webpackJsonp([1],{

/***/ "+0cg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLabelingEdit_vue__ = __webpack_require__("bsLA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7910942b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserLabelingEdit_vue__ = __webpack_require__("+Brv");
function injectStyle (ssrContext) {
  __webpack_require__("MXb/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLabelingEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7910942b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserLabelingEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+1Kz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    imageSrc: function imageSrc() {
      if (this.$route.path.includes('/dispatch')) {
        return '../../../../static/img/icons/dispatch.png';
      }
      if (this.title === 'Dashboard') {
        return '../../../../static/img/icons/icon-topBar-dashboard.png';
      } else if (this.title === 'Categories' || this.title === 'Top Category' || this.title === 'Product Options' || this.title === 'Group Options' || this.title === 'Product Filters' || this.title === 'Product Filters' || this.title === 'Custom Pages' || this.title === 'Menu Links' || this.title === 'Info Pages') {
        return '../../../../static/img/icons/icon-topBar-paper.png';
      } else if (this.title === 'Customers') {
        return '../../../../static/img/icons/icon-topBar-customers.png';
      } else if (this.title === 'Catalog') {
        return '../../../../static/img/icons/icon-topBar-paper.png';
      } else if (this.$route.path.includes('/marketing')) {
        return '../../../../static/img/icons/icon-topBar-marketing.png';
      } else if (this.$route.path.includes('/reports')) {
        return '../../../../static/img/icons/icon-topBar-reports.png';
      } else if (this.$route.path.includes('/feedback')) {
        return '../../../../static/img/icons/icon-topBar-feedback.png';
      } else {
        return '../../../../static/img/icons/icon-topBar-settings.png';
      }
    }
  }
});

/***/ }),

/***/ "+1fW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      categories: [],
      posts: [],
      selectedCategory: null,
      selectedPost: null,
      searchQuery: ''
    };
  },


  computed: {
    rootCategories: function rootCategories() {
      return this.categories.filter(function (c) {
        return c.parent === 0 && c.id !== 1;
      });
    },
    currentYear: function currentYear() {
      return new Date().getFullYear();
    },
    filteredPosts: function filteredPosts() {
      var _this = this;

      var result = this.posts;

      if (this.selectedCategory) {
        result = result.filter(function (post) {
          if (post.categories.includes(_this.selectedCategory)) {
            return true;
          }

          var childIds = _this.getAllChildrenIds(_this.selectedCategory);
          return childIds.some(function (childId) {
            return post.categories.includes(childId);
          });
        });
      }

      if (this.searchQuery.trim()) {
        var q = this.searchQuery.toLowerCase();
        result = result.filter(function (post) {
          var title = (post.title.rendered || post.title || '').toLowerCase();
          var excerpt = (post.excerpt.rendered || post.excerpt || '').replace(/<[^>]+>/g, '').toLowerCase();
          return title.includes(q) || excerpt.includes(q);
        });
      }

      return result;
    },
    currentCategoryName: function currentCategoryName() {
      var _this2 = this;

      if (this.selectedCategory === null) {
        return this.$t('newsletterCard.allArticles');
      }

      var cat = this.categories.find(function (c) {
        return c.id === _this2.selectedCategory;
      });
      return cat ? cat.name : this.$t('newsletterCard.allArticles');
    }
  },

  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.fetchData();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },


  methods: {
    fetchData: function fetchData() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return fetch('https://newsletter.taptasty.com/wp-json/secure/v1/blog-data', {
                  headers: {
                    Authorization: 'Bearer 2dc5f2d429a3d971b7403d918b2177f65a14b8b87a4741856206c8099627ea65'
                  }
                });

              case 3:
                res = _context2.sent;
                _context2.next = 6;
                return res.json();

              case 6:
                data = _context2.sent;

                _this4.categories = data.categories;
                _this4.posts = data.posts;
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](0);

                console.error('Failed to fetch data:', _context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 11]]);
      }))();
    },
    getAllChildrenIds: function getAllChildrenIds(parentId) {
      var _this5 = this;

      var directChildren = this.categories.filter(function (c) {
        return c.parent === parentId;
      });
      var allIds = directChildren.map(function (c) {
        return c.id;
      });

      directChildren.forEach(function (child) {
        allIds = allIds.concat(_this5.getAllChildrenIds(child.id));
      });

      return allIds;
    },
    getTitle: function getTitle(post) {
      return post.title.rendered || post.title || '';
    },
    getExcerpt: function getExcerpt(post) {
      return (post.excerpt.rendered || post.excerpt || '').replace(/<[^>]+>/g, '');
    },
    getContent: function getContent(post) {
      return post.content.rendered || post.content || '';
    },
    selectCategory: function selectCategory(id) {
      this.selectedCategory = id;
      this.selectedPost = null;
      this.searchQuery = '';
    },
    openPost: function openPost(post) {
      this.selectedPost = post;
    },
    getChildren: function getChildren(parentId) {
      return this.categories.filter(function (c) {
        return c.parent === parentId;
      });
    },
    getCategoryCount: function getCategoryCount(catId) {
      var allCatIds = [catId].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getAllChildrenIds(catId)));
      return this.posts.filter(function (p) {
        return p.categories.some(function (cat) {
          return allCatIds.includes(cat);
        });
      }).length;
    },
    formatDate: function formatDate(date) {
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  }
});

/***/ }),

/***/ "+3k5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);













var _components;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductImportList',
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      batches: [],
      locationId: null,
      companyId: null
    };
  },
  created: function created() {
    var params = this.route && this.route.params || this.$route.params;
    this.locationId = params.locationId;
    this.companyId = this.$session.get('selectedCompany');
    this.loadBatches();
  },

  methods: {
    statusLabel: function statusLabel(status) {
      var map = {
        PENDING: this.$t('productImport.statusPending'),
        CONFIRMED: this.$t('productImport.statusSuccessful'),
        PARTIALLY_CONFIRMED: this.$t('productImport.statusPartiallySuccessful'),
        CANCELED: this.$t('productImport.statusCanceled')
      };
      return map[status] || status;
    },
    loadBatches: function loadBatches() {
      var _this = this;

      this.loading = true;
      this.apiRequest('/product-imports', 'GET', {
        token: this.$session.get('token'),
        company_id: this.companyId,
        location_id: this.locationId
      }, function (response) {
        _this.loading = false;
        if (response && response.status) {
          var payload = response.data;
          _this.batches = payload && payload.data ? payload.data : Array.isArray(payload) ? payload : [];
        }
      });
    },
    openBatch: function openBatch(row) {
      this.$router.push({
        path: '/locations/' + this.locationId + '/product-imports/' + row.id
      });
    },
    goBack: function goBack() {
      this.$router.push('/locations/edit/' + this.locationId);
    }
  }
});

/***/ }),

/***/ "+65S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayQr_vue__ = __webpack_require__("L0G8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eba28d1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayQr_vue__ = __webpack_require__("umDV");
function injectStyle (ssrContext) {
  __webpack_require__("R/CC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayQr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eba28d1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayQr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+82s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleOverlayClick($event)}}},[_c('div',{ref:"modal",staticClass:"global-modal-box",on:{"mousedown":function($event){_vm.startedInside = true},"touchstart":function($event){_vm.startedInside = true}}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+8ZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InvoiceForm_vue__ = __webpack_require__("vYda");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'InvoiceForm', __WEBPACK_IMPORTED_MODULE_7__InvoiceForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "+8mR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"10","prop":"name","label":"ID"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.id || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"name","label":"Name"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.name ? props.row.name : "-"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":320,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.send')},on:{"click":function($event){_vm.handleDelete(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")])]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+B1S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kiosk_vue__ = __webpack_require__("rIb9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34712b72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kiosk_vue__ = __webpack_require__("PyC8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kiosk_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34712b72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kiosk_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Brv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('user-labeling-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+DUu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 449.4 209"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 449.4 209","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_1_","y":"62.9","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_3_","d":"M0,137.1V71.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v65.2c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H9c-2.4,0-4.7-0.9-6.4-2.6C0.9,141.8,0,139.5,0,137.1\n            z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,146.1V62.9h83.2v83.2H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_5_","x":"366.2","y":"62.9","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_7_","d":"M366.2,137.1V71.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v65.2c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-0.9-6.4-2.6\n            C367.2,141.8,366.2,139.5,366.2,137.1z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M366.2,146.1V62.9h83.2v83.2H366.2z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_9_","x":"302.4","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_11_","d":"M302.4,74.2V9c0-2.4,1-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2\n            c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-1-6.4-2.6S302.4,76.6,302.4,74.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M302.4,83.2V0h83.2v83.2H302.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_13_","x":"180.4","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_15_","d":"M180.4,74.2V9c0-2.4,0.9-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2\n            c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-1-6.4-2.6S180.4,76.6,180.4,74.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M180.4,83.2V0h83.2v83.2H180.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_17_","x":"66","y":"62.9","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_19_","d":"M66,137.1V71.9c0-2.4,0.9-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2\n            c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6H75c-2.4,0-4.7-0.9-6.4-2.6S66,139.5,66,137.1z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M66,146.1V62.9h83.2v83.2H66z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_21_","x":"62.9","y":"0","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_23_","d":"M71.9,0h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6H71.9\n            c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4V9c0-2.4,0.9-4.7,2.6-6.4S69.5,0,71.9,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st2",attrs:{"d":"M62.9,0h83.2v83.2H62.9V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_25_","x":"62.9","y":"125.8","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st13"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_27_","d":"M71.9,125.8h65.2c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4V200c0,2.4-0.9,4.7-2.6,6.4\n            s-4,2.6-6.4,2.6H71.9c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-65.2c0-2.4,0.9-4.7,2.6-6.4C67.2,126.8,69.5,125.8,71.9,125.8z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('path',{staticClass:"st2",attrs:{"d":"M62.9,125.8h83.2V209H62.9V125.8z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_29_","x":"180.4","y":"125.8","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_30_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_29_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_31_","d":"M189.4,125.8h65.2c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4V200c0,2.4-0.9,4.7-2.6,6.4\n            s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-65.2c0-2.4,0.9-4.7,2.6-6.4C184.8,126.8,187,125.8,189.4,125.8z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_32_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_31_"}})]),_vm._v(" "),_c('g',{staticClass:"st16"},[_c('path',{staticClass:"st2",attrs:{"d":"M180.4,125.8h83.2V209h-83.2V125.8z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_33_","x":"302.4","y":"125.8","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_34_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_33_"}})]),_vm._v(" "),_c('g',{staticClass:"st17"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_35_","d":"M302.4,200v-65.2c0-2.4,1-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4V200\n            c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-0.9-6.4-2.6S302.4,202.4,302.4,200z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_36_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_35_"}})]),_vm._v(" "),_c('g',{staticClass:"st18"},[_c('path',{staticClass:"st2",attrs:{"d":"M302.4,209v-83.2h83.2V209H302.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_37_","x":"14.7","y":"14.7","width":"418.9","height":"179.6"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_38_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_37_"}})]),_vm._v(" "),_c('g',{staticClass:"st19"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_39_","d":"M37.7,14.7h372.8c12.7,0,23,10.3,23,23v133.6c0,12.7-10.3,23-23,23H37.7c-12.7,0-23-10.3-23-23V37.7\n            C14.7,25,25,14.7,37.7,14.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_40_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_39_"}})]),_vm._v(" "),_c('g',{staticClass:"st20"},[_c('path',{staticClass:"st21",attrs:{"d":"M14.7,14.7h418.9v179.6H14.7V14.7z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_41_","x":"155.7","y":"36.2","width":"136.7","height":"136.7"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_42_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_41_"}})]),_vm._v(" "),_c('g',{staticClass:"st22"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"t8_43_","cx":"224.1","cy":"104.5","r":"68.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_44_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_43_"}})]),_vm._v(" "),_c('g',{staticClass:"st23"},[_c('path',{staticClass:"st2",attrs:{"d":"M155.7,36.2h136.7v136.7H155.7V36.2z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Fja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons "},[_c('div',{staticClass:"left-buttons mar-rt-10"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat) + " — Locații: " + (group.locations.map(function (l) { return l.name; }).join(', ')))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group",staticStyle:{"display":"grid","margin-top":"15px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.series')))]),_vm._v(" "),_c('el-input',{ref:"seriesInput",attrs:{"disabled":_vm.loading,"placeholder":"Introdu seria facturii"},on:{"input":_vm.onSeriesInput},model:{value:(_vm.filter.series),callback:function ($$v) {_vm.$set(_vm.filter, "series", $$v)},expression:"filter.series"}})],1)]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.addInvoice($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('invoice.addInvoice'))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn spv-fetch mar-rt-10",attrs:{"title":_vm.$t('gestiune.fetchSpvMessages')},on:{"click":function($event){$event.preventDefault();return _vm.fetchSpvInboxMessages($event)}}},[_vm._v("\n          "+_vm._s(_vm.$t('gestiune.fetchSpvMessages'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"prop":"invoiceNumber","label":_vm.$t('invoice.invoice'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"series","label":_vm.$t('invoice.series'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"client","label":_vm.$t('invoice.client'),"width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"issueDate","label":_vm.$t('invoice.issueDate'),"formatter":_vm.formatDate}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valueNoVAT","label":_vm.$t('invoice.valueNoVAT')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vatValue","label":_vm.$t('invoice.vatValue')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalValue","label":_vm.$t('invoice.totalValue')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('invoice.spvStatus'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"spv-status-cell"},[_c('span',{staticClass:"spv-status-badge",class:scope.row.spvStatusClass,attrs:{"title":scope.row.spvStatusTitle}},[_vm._v("\n                        "+_vm._s(scope.row.spvStatusLabel)+"\n                      ")]),_vm._v(" "),(scope.row.spvIdIncarcare)?_c('span',{staticClass:"spv-status-index-badge",attrs:{"title":_vm.$t('invoice.spvUploadIndex')}},[_vm._v("\n                        Index: "+_vm._s(scope.row.spvIdIncarcare)+"\n                      ")]):_vm._e()])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Nr. comandă / bon","min-width":"150","align":"left","class-name":"order-info-column"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"order-info-cell"},[_c('button',{staticClass:"order-info-trigger",class:{
                          'order-info-trigger--active': scope.row.hasOrderInfo,
                          'order-info-trigger--loading': scope.row._orderInfoLoading
                        },attrs:{"type":"button","title":"Vezi date comandă"},on:{"click":function($event){$event.stopPropagation();_vm.openOrderInfo(scope.row)}}},[_c('i',{staticClass:"ti-info-alt"})]),_vm._v(" "),(scope.row.orderInfoDisplay)?_c('span',{staticClass:"order-info-number",attrs:{"title":scope.row.orderInfoDisplay}},[_vm._v("\n                        "+_vm._s(scope.row.orderInfoDisplay)+"\n                      ")]):_c('span',{staticClass:"order-info-number order-info-number--empty"},[_vm._v("—")])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"80","align":"center","fixed":"right","class-name":"invoice-actions-column"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"invoice-actions-cell"},[_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                        ▾ ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editInvoice(scope.row.invoiceNumber, scope.row.series)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('general.edit'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.openOrderInfo(scope.row)}}},[_vm._v("\n                          Vezi date comandă\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"disabled":scope.row.hasParent},nativeOn:{"click":function($event){_vm.addStorno(scope.row.invoiceNumber, scope.row.series)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('invoice.storno'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{class:{ disabled: !_vm.canSendToSpv(scope.row) },attrs:{"disabled":!_vm.canSendToSpv(scope.row)},nativeOn:{"click":function($event){_vm.sendToSPV(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('gestiune.sendToSPV'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadEfacturaXml(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('gestiune.downloadEfacturaXml'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.viewSpvPdf(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('gestiune.viewSpvPdf'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.verifySpvStatus(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('gestiune.checkSpvStatus'))+"\n                        ")]),_vm._v(" "),(_vm.hasNexusLocation)?_c('el-dropdown-item',{attrs:{"disabled":!scope.row.orderNumber},nativeOn:{"click":function($event){_vm.fetchNexusInvoiceStatus(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('nexus.invoiceStatus'))+"\n                        ")]):_vm._e(),_vm._v(" "),(_vm.hasNexusLocation)?_c('el-dropdown-item',{attrs:{"disabled":!scope.row.orderNumber},nativeOn:{"click":function($event){_vm.fetchNexusInvoiceLogs(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('nexus.invoiceLog'))+"\n                        ")]):_vm._e(),_vm._v(" "),(_vm.hasNexusLocation)?_c('el-dropdown-item',{attrs:{"disabled":!scope.row.orderNumber},nativeOn:{"click":function($event){_vm.markNexusInvoice(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('nexus.invoiceSend'))+"\n                        ")]):_vm._e(),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadInvoice(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('invoice.download'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadExcel(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('gestiune.downloadExcel'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{class:{ disabled: !_vm.canDeleteInvoice(scope.row, scope.$index) },staticStyle:{"color":"red","font-weight":"bold"},attrs:{"disabled":!_vm.canDeleteInvoice(scope.row, scope.$index)},nativeOn:{"click":function($event){_vm.handleDeleteInvoice(scope.row.id)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('general.delete'))+"\n                        ")])],1)],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+GID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__ = __webpack_require__("5fo9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5993c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__ = __webpack_require__("AYSv");
function injectStyle (ssrContext) {
  __webpack_require__("32EI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5993c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Gp3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_c('div',{ref:"navbarHeader",staticClass:"navbar-header"},[_c('div',{staticClass:"text-center logo-normal pull-left pad-to-25"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})])]),_vm._v(" "),_c('button',{staticClass:"navbar-toggle",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar bar1"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar2"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar3"})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+HOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopCategoryEdit_vue__ = __webpack_require__("WugT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6a04b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopCategoryEdit_vue__ = __webpack_require__("LIBP");
function injectStyle (ssrContext) {
  __webpack_require__("Fbzq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopCategoryEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6a04b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopCategoryEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);



var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+ND1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);















var _components;




/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a), _components),
  props: {
    isPosOrderActionsReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isPosOrderActionsReport: function isPosOrderActionsReport() {
      if (this.isPosOrderActionsReport) {
        this.bootstrap();
      }
    },
    '$route.query.posOrderActionsFilters': function $routeQueryPosOrderActionsFilters() {
      this.applyFiltersFromUrl();
    }
  },
  created: function created() {
    this.applyFiltersFromUrl();
    this.bootstrap();
    this.$bus.$on('refreshPosOrderActions', this.handleRefreshPosOrderActions);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refreshPosOrderActions', this.handleRefreshPosOrderActions);
  },
  data: function data() {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      timezone: null,
      loading: true,
      loadingTables: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      period: [__WEBPACK_IMPORTED_MODULE_14_moment___default()().subtract(1, 'days').format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('YYYY-MM-DD')],
      locations: [],
      selectedLocationIds: [],
      posUsers: [],
      selectedPosUser: '',
      tableMaps: [],
      selectedTableMapIds: [],
      selectedZoneIds: [],
      zones: [],
      selectedTable: null,
      availableTables: [],
      rows: [],
      total: 0,
      sortBy: [],
      sortOrder: [],
      posNameById: {},
      selectedActionType: null,
      selectedStatus: null,
      selectedOrderId: null,

      isFiltersModalOpen: false,
      modalSelectedLocationIds: [],
      modalSelectedTableMapIds: [],
      modalSelectedZoneIds: [],
      modalSelectedPosUser: '',
      modalSelectedStatus: null,
      modalSelectedActionType: null,
      modalSelectedTable: null,
      modalSelectedOrderId: null
    };
  },

  computed: {
    orderStatusOptions: function orderStatusOptions() {
      return ['NEW', 'PROCESSING', 'ON_HOLD', 'POSTPONED', 'AWAITING_TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'TRANSPORT', 'DELIVERED', 'NOT_DELIVERED', 'CANCELED'];
    },
    appliedFilters: function appliedFilters() {
      var _this = this;

      var out = [];

      if (Array.isArray(this.selectedLocationIds) && this.selectedLocationIds.length) {
        var names = this.selectedLocationIds.map(function (id) {
          var found = _this.locations.find(function (l) {
            return l.true_id === id || l.id === id;
          });
          return found && found.name ? found.name : String(id);
        }).filter(Boolean);
        if (names.length) out.push(this.$t('orders.location') + ': ' + names.join(', '));
      }

      if (Array.isArray(this.selectedTableMapIds) && this.selectedTableMapIds.length) {
        var _names = this.selectedTableMapIds.map(function (id) {
          var found = _this.tableMaps.find(function (m) {
            return m.id === id;
          });
          return found && found.name ? found.name : String(id);
        }).filter(Boolean);
        if (_names.length) out.push(this.$t('settingTable.maps') + ': ' + _names.join(', '));
      }

      if (Array.isArray(this.selectedZoneIds) && this.selectedZoneIds.length) {
        var _names2 = this.selectedZoneIds.map(function (id) {
          var z = _this.zones.find(function (x) {
            return String(x.id) === String(id);
          });
          return z && z.name ? z.name : String(id);
        }).filter(Boolean);
        if (_names2.length) out.push(this.$t('settingTable.zone') + ': ' + _names2.join(', '));
      }

      if (this.selectedPosUser) {
        var u = this.posUsers.find(function (x) {
          return x.id === _this.selectedPosUser;
        });
        var label = u ? ((u.firstname || '') + ' ' + (u.lastname || '')).trim() : String(this.selectedPosUser);
        out.push(this.$t('reports.operator') + ': ' + (label || String(this.selectedPosUser)));
      }

      if (this.selectedStatus) out.push(this.$t('orders.status') + ': ' + this.$t('ordersStatus.' + this.selectedStatus));

      if (typeof this.selectedActionType === 'number') out.push(this.$t('general.action') + ': ' + this.$t('reports.posOrderActionTypes.' + this.actionTypeKey(this.selectedActionType)));

      if (this.selectedTable && this.selectedTable.id != null) out.push(this.$t('reports.tables') + ': ' + (this.selectedTable.label || 'ID ' + this.selectedTable.id));

      if (this.selectedOrderId != null && String(this.selectedOrderId).trim() !== '') out.push(this.$t('general.orderId') + ': ' + String(this.selectedOrderId));

      return out;
    },
    mergedTables: function mergedTables() {
      var map = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a(this.availableTables.map(function (t) {
        return [t.id, t];
      }));
      if (this.selectedTable && this.selectedTable.id && !map.has(this.selectedTable.id)) {
        map.set(this.selectedTable.id, this.selectedTable);
      }
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()(map.values());
    }
  },
  methods: {
    handleRefreshPosOrderActions: function handleRefreshPosOrderActions() {
      var page = this.paginationProps.currentPage || 1;
      var pageSize = this.paginationProps.pageSize || 20;
      this.getOrders({ page: page, pageSize: pageSize });
    },
    actionTypeKey: function actionTypeKey(type) {
      var numericToKey = {
        1: 'openOrder',
        2: 'markProduct',
        3: 'preNote',
        4: 'closeOrder',
        5: 'storno',
        6: 'transferOut',
        7: 'transferIn'
      };
      return numericToKey[Number(type)] || String(type);
    },
    syncModalFromFilters: function syncModalFromFilters() {
      this.modalSelectedLocationIds = Array.isArray(this.selectedLocationIds) ? [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.selectedLocationIds)) : [];
      this.modalSelectedTableMapIds = Array.isArray(this.selectedTableMapIds) ? [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.selectedTableMapIds)) : [];
      this.modalSelectedZoneIds = Array.isArray(this.selectedZoneIds) ? [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.selectedZoneIds)) : [];
      this.modalSelectedPosUser = this.selectedPosUser || '';
      this.modalSelectedStatus = this.selectedStatus || null;
      this.modalSelectedActionType = this.selectedActionType !== undefined ? this.selectedActionType : null;
      this.modalSelectedTable = this.selectedTable && this.selectedTable.id != null ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.selectedTable) : null;
      this.modalSelectedOrderId = this.selectedOrderId;
    },
    openFiltersModal: function openFiltersModal() {
      this.syncModalFromFilters();
      this.isFiltersModalOpen = true;
      this.$modal.show('posOrderActionsFiltersModal');
    },
    applyFilters: function applyFilters() {
      var _this2 = this;

      var prevLocationIds = Array.isArray(this.selectedLocationIds) ? this.selectedLocationIds.map(String).sort().join(',') : '';
      this.selectedLocationIds = Array.isArray(this.modalSelectedLocationIds) ? [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.modalSelectedLocationIds)) : [];
      this.selectedTableMapIds = Array.isArray(this.modalSelectedTableMapIds) ? [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.modalSelectedTableMapIds)) : [];
      this.selectedZoneIds = Array.isArray(this.modalSelectedZoneIds) ? [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.modalSelectedZoneIds)) : [];
      this.selectedPosUser = this.modalSelectedPosUser || '';
      this.selectedStatus = this.modalSelectedStatus || null;
      this.selectedActionType = this.modalSelectedActionType !== undefined ? this.modalSelectedActionType : null;
      this.selectedTable = this.modalSelectedTable && this.modalSelectedTable.id != null ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.modalSelectedTable) : null;
      this.selectedOrderId = this.modalSelectedOrderId !== '' && this.modalSelectedOrderId !== null && this.modalSelectedOrderId !== undefined ? Number(this.modalSelectedOrderId) : null;

      var nextLocationIds = Array.isArray(this.selectedLocationIds) ? this.selectedLocationIds.map(String).sort().join(',') : '';
      if (prevLocationIds !== nextLocationIds) this.getTableMaps();

      this.$modal.hide('posOrderActionsFiltersModal');
      this.isFiltersModalOpen = false;
      this.$nextTick(function () {
        return _this2.updateData();
      });
    },
    resetModalFilters: function resetModalFilters() {
      this.resetFilters();
      this.syncModalFromFilters();
    },
    resetFilters: function resetFilters() {
      this.selectedLocationIds = [];
      this.selectedTableMapIds = [];
      this.selectedZoneIds = [];
      this.selectedPosUser = '';
      this.selectedStatus = null;
      this.selectedActionType = null;
      this.selectedTable = null;
      this.selectedOrderId = null;
      this.availableTables = [];
      this.updateData();
    },
    rowStatusKey: function rowStatusKey(row) {
      if (!row) return null;
      if (row.status && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(row.status) === 'object' && row.status.id) return row.status.id;
      return row.status || null;
    },
    changeDeliveryStatus: function changeDeliveryStatus(statusUsed, deliveryType) {
      if (!statusUsed) return '-';
      if (statusUsed === 'DELIVERED' && deliveryType === 'EAT_LOCATION') {
        statusUsed = 'reservedReady';
        return this.$t('ordersStatus.' + statusUsed);
      }
      if (statusUsed === 'DELIVERED' && deliveryType === 'PICK_UP') {
        statusUsed = 'completedReady';
        return this.$t('ordersStatus.' + statusUsed);
      }
      if (statusUsed === 'DELIVERED' && (deliveryType === 'MEET_HALF' || deliveryType === 'DELIVERY')) {
        statusUsed = 'deliveredReady';
        return this.$t('ordersStatus.' + statusUsed);
      }
      return this.$t('ordersStatus.' + statusUsed);
    },
    orderStatusClass: function orderStatusClass(type) {
      switch (type) {
        case 'DELIVERED':
          return 'success';
        case 'CANCELED':
          return 'danger';
        case 'NOT_DELIVERED':
          return 'danger';
        case 'NEW':
          return 'info';
        case 'ON_HOLD':
          return 'hold';
        case 'POSTPONED':
          return 'postponed';
        case 'PROCESSING':
          return 'warning';
        case 'AWAITING_TRANSPORT':
          return 'yellow';
        case 'PICKED_UP_BY_DELIVERY':
          return 'grey';
        case 'TRANSPORT':
          return 'blue';
        default:
          return 'primary';
      }
    },
    bootstrap: function bootstrap() {
      this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest';
      this.locations = this.$session.get('selectedCompanyData').locations_details || [];
      this.getPosUsers();
      this.getPosDevices();
      this.getTableMaps();
      this.getZones();
      this.getOrders();
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
          order = _ref.order;

      if (!order) {
        this.sortBy = [];
        this.sortOrder = [];
      } else {
        var direction = order === 'ascending' ? 'asc' : 'desc';
        this.sortOrder = [direction];
        this.sortBy = [prop];
      }
      var pageSize = this.paginationProps.pageSize || 20;
      this.getOrders({ page: 1, pageSize: pageSize });
    },
    formatOrderSeriesNumber: function formatOrderSeriesNumber(row) {
      if (!row) return '-';
      var s = row.series ? String(row.series) : '';
      var n = row.number !== undefined && row.number !== null ? String(row.number) : '';
      if (!s && !n) return '-';
      return [s, n].filter(Boolean).join(' ');
    },
    orderLocationName: function orderLocationName(row) {
      if (!row) return '-';
      var loc = row.production_details && row.production_details.location && row.production_details.location.name;
      if (loc) return loc;
      var lid = row.location_id;
      if (lid == null) return '-';
      var found = this.locations.find(function (l) {
        return l.true_id === lid || l.id === lid;
      });
      return found && found.name ? found.name : String(lid);
    },
    posDeviceName: function posDeviceName(posId) {
      if (posId === undefined || posId === null) return '-';
      var name = this.posNameById[posId];
      return name || String(posId);
    },
    waiterDisplayName: function waiterDisplayName(waiterId) {
      if (waiterId === undefined || waiterId === null) return '-';
      var u = this.posUsers.find(function (x) {
        return x.id === waiterId;
      });
      if (!u) return String(waiterId);
      var full = ((u.firstname || '') + ' ' + (u.lastname || '')).trim();
      return full || String(waiterId);
    },
    serializeFiltersForUrl: function serializeFiltersForUrl() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        selectedLocationIds: this.selectedLocationIds,
        selectedTableMapIds: this.selectedTableMapIds,
        selectedZoneIds: this.selectedZoneIds,
        selectedPosUser: this.selectedPosUser,
        selectedStatus: this.selectedStatus,
        selectedActionType: this.selectedActionType,
        selectedTable: this.selectedTable,
        selectedOrderId: this.selectedOrderId,
        period: this.period,
        valid_from: this.valid_from,
        valid_to: this.valid_to,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      });
    },
    applyFiltersFromUrl: function applyFiltersFromUrl() {
      var raw = this.$route.query && this.$route.query.posOrderActionsFilters;
      if (!raw) return;
      try {
        var parsed = JSON.parse(raw);
        if (!parsed || (typeof parsed === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(parsed)) !== 'object') return;
        if (Array.isArray(parsed.selectedLocationIds)) this.selectedLocationIds = parsed.selectedLocationIds;
        if (Array.isArray(parsed.selectedTableMapIds)) this.selectedTableMapIds = parsed.selectedTableMapIds;

        if (Array.isArray(parsed.selectedZoneIds)) this.selectedZoneIds = parsed.selectedZoneIds;else if (parsed.selectedZone !== undefined && parsed.selectedZone !== null && String(parsed.selectedZone).trim() !== '') this.selectedZoneIds = [parsed.selectedZone];
        if (parsed.selectedPosUser !== undefined) this.selectedPosUser = parsed.selectedPosUser;
        if (parsed.selectedStatus !== undefined) this.selectedStatus = parsed.selectedStatus;
        if (parsed.selectedActionType !== undefined) this.selectedActionType = parsed.selectedActionType;
        if (parsed.selectedTable !== undefined) this.selectedTable = parsed.selectedTable;
        if (parsed.selectedOrderId !== undefined) this.selectedOrderId = parsed.selectedOrderId;
        if (Array.isArray(parsed.period)) this.period = parsed.period;
        if (typeof parsed.valid_from === 'string') this.valid_from = parsed.valid_from;
        if (typeof parsed.valid_to === 'string') this.valid_to = parsed.valid_to;
        if (Array.isArray(parsed.sortBy)) this.sortBy = parsed.sortBy;
        if (Array.isArray(parsed.sortOrder)) this.sortOrder = parsed.sortOrder;
      } catch (e) {}
    },
    goToOrder: function goToOrder(row) {
      if (!row || row.id == null) return;
      var route = {
        path: '/reports/pos-order-actions/' + row.id,
        query: {
          tab: 'pos-order-actions',
          posOrderActionsFilters: this.serializeFiltersForUrl(),
          app_id: row.app_id
        }
      };
      this.$router.push(route);
    },
    openLogs: function openLogs(row) {
      this.goToOrder(row);
    },
    openOrderInNewTab: function openOrderInNewTab(row) {
      if (!row || row.id == null) return;

      this.$router.push('/orders/view/' + row.id);
    },
    formatToCompanyTimezone: function formatToCompanyTimezone(utcString) {
      var date = new Date(utcString + 'Z');
      var formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: this.timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
      var parts = formatter.formatToParts(date);
      return parts.find(function (p) {
        return p.type === 'year';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'month';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'day';
      }).value + ' ' + parts.find(function (p) {
        return p.type === 'hour';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'minute';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'second';
      }).value;
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    updateData: function updateData() {
      var pageSize = this.paginationProps.pageSize || 20;
      this.getOrders({ page: 1, pageSize: pageSize });
    },
    clearSearch: function clearSearch() {
      var select = this.$refs.tableSelect;
      if (select) {
        select.query = '';
        select.handleQueryChange('');
      }
    },
    searchTables: function searchTables(query) {
      var _this3 = this;

      if (!query) {
        this.availableTables = [];
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      };
      this.loadingTables = true;

      var locationIds = this.isFiltersModalOpen ? this.modalSelectedLocationIds : this.selectedLocationIds;
      var mapIds = this.isFiltersModalOpen ? this.modalSelectedTableMapIds : this.selectedTableMapIds;
      var zoneIds = this.isFiltersModalOpen ? this.modalSelectedZoneIds : this.selectedZoneIds;

      if (Array.isArray(locationIds) && locationIds.length) {
        data.location_ids = locationIds;
      }
      if (Array.isArray(mapIds) && mapIds.length) {
        data.map_ids = mapIds;
      }
      if (Array.isArray(zoneIds) && zoneIds.length) {
        data.table_zone_id = zoneIds.length === 1 ? zoneIds[0] : zoneIds;
      }

      this.apiRequest('/table-management', 'GET', data, function (response) {
        if (response && response.status === true) {
          var arr = Array.isArray(response.data) ? response.data : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.data || {});
          _this3.availableTables = (arr || []).map(function (t) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, t, {
              label: _this3.formatTableName(t)
            });
          });
        } else {
          _this3.availableTables = [];
        }
        _this3.$nextTick(function () {
          _this3.loadingTables = false;
        });
      });
    },
    formatTableName: function formatTableName(t) {
      if (!t) return '-';
      var type = t.type ? String(t.type) : '';
      var number = t.number !== undefined && t.number !== null && String(t.number).length ? String(t.number) : '';
      var external = t.external_id ? String(t.external_id) : '';
      var label = [type, number].filter(Boolean).join(' ');
      return label || external || 'ID ' + t.id;
    },
    getPosUsers: function getPosUsers() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this4.posUsers = response.data.pos_user || [];
        }
      });
    },
    getPosDevices: function getPosDevices() {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos', 'GET', data, function (response) {
        var map = {};
        if (response.status === true && response.data && response.data.pos) {
          response.data.pos.forEach(function (p) {
            if (p && p.id != null) {
              map[p.id] = p.name || 'ID ' + p.id;
            }
          });
        }
        _this5.posNameById = map;
      });
    },
    getTableMaps: function getTableMaps() {
      var _this6 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (Array.isArray(this.selectedLocationIds) && this.selectedLocationIds.length) {
        data.location_ids = this.selectedLocationIds;
      }
      this.apiRequest('/pos/all/map', 'GET', data, function (response) {
        if (response && response.status === true) {
          _this6.tableMaps = response.data.table_maps || [];
        } else {
          _this6.tableMaps = [];
        }

        var allowed = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a((_this6.tableMaps || []).map(function (m) {
          return String(m.id);
        }));
        if (Array.isArray(_this6.selectedTableMapIds) && _this6.selectedTableMapIds.length) {
          _this6.selectedTableMapIds = _this6.selectedTableMapIds.filter(function (id) {
            return allowed.has(String(id));
          });
        }
        if (Array.isArray(_this6.modalSelectedTableMapIds) && _this6.modalSelectedTableMapIds.length) {
          _this6.modalSelectedTableMapIds = _this6.modalSelectedTableMapIds.filter(function (id) {
            return allowed.has(String(id));
          });
        }
      });
    },
    getZones: function getZones() {
      var _this7 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/table-zone', 'GET', data, function (response) {
        if (response && response.status === true && Array.isArray(response.data) && response.data.length) {
          _this7.zones = response.data.map(function (z) {
            return {
              id: z.id,
              name: z.name
            };
          });
        } else {
          _this7.zones = [];
        }
      });
    },
    getOrders: function getOrders(query) {
      var _this8 = this;

      if (!this.isPosOrderActionsReport) {
        return;
      }
      var pageSize = query && query.pageSize != null ? query.pageSize : this.paginationProps.pageSize || 20;
      var page = query && query.page != null ? query.page : this.paginationProps.currentPage || 1;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.period && this.period[0] ? this.period[0] + ' ' + (this.valid_from || '00:00') : null;
      var toDate = this.period && this.period[1] ? this.period[1] + ' ' + (this.valid_to || '23:59') : null;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        sort_by: this.sortBy,
        sort_order: this.sortOrder
      };

      if (Array.isArray(this.selectedLocationIds) && this.selectedLocationIds.length) {
        data.location_ids = this.selectedLocationIds;
      }
      if (this.selectedPosUser) {
        data.operator = this.selectedPosUser;
      }
      if (Array.isArray(this.selectedTableMapIds) && this.selectedTableMapIds.length) {
        data.map_ids = this.selectedTableMapIds;
      }
      if (Array.isArray(this.selectedZoneIds) && this.selectedZoneIds.length) {
        data.table_zone_id = this.selectedZoneIds;
      }
      if (this.selectedTable && this.selectedTable.id) {
        data.table_id = this.selectedTable.id;
      }
      if (this.selectedStatus) {
        data.status = this.selectedStatus;
      }
      if (typeof this.selectedActionType === 'number') {
        data.action = this.selectedActionType;
      }
      if (this.selectedOrderId != null && String(this.selectedOrderId).trim() !== '') {
        data.id = this.selectedOrderId;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/order-actions?page=' + page + '&perPage=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          var ordersPaginator = response.data && response.data.orders;
          var paginatorData = ordersPaginator && Array.isArray(ordersPaginator.data) ? ordersPaginator.data : [];

          _this8.rows = paginatorData;

          var pageFromTop = response.pagination && response.pagination.page;
          var perPageFromTop = response.pagination && response.pagination.perPage;
          var totalFromTop = response.pagination && response.pagination.total;

          var pageFromOrders = ordersPaginator && ordersPaginator.current_page;
          var perPageFromOrders = ordersPaginator && ordersPaginator.per_page;
          var totalFromOrders = ordersPaginator && ordersPaginator.total;

          _this8.total = totalFromTop || totalFromOrders || 0;
          _this8.paginationProps.currentPage = pageFromTop || pageFromOrders || 1;
          _this8.paginationProps.pageSize = perPageFromTop || perPageFromOrders || pageSize;
        } else {
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this8.$t('validations.wentWrong'), 'error');
        }
        _this8.$nextTick(function () {
          _this8.loading = false;
        });
      });
    }
  }
});

/***/ }),

/***/ "+RZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_google_maps__ = __webpack_require__("lMsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_google_maps__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      loading: false,
      isWalletReportActive: false,
      isActiveProgramActive: false,
      isActiveActivityActive: false,
      isMapReportActive: true,
      drivers: [],
      selectedDriversWallet: [],
      selectedDriversProgram: [],
      selectedDriversActivity: [],
      selectedDriversMap: null,
      walletData: [],
      programData: [],
      activityData: [],
      fromDateTimeWallet: this.formatDate2(new Date(), 'start'),
      toDateTimeWallet: this.formatDate2(new Date(), 'end'),
      fromDateTimeProgram: this.formatDate2(new Date(), 'start'),
      fromDateTimeActivity: this.formatDate2(new Date(), 'start'),
      fromDateTimeMap: this.formatDate2(new Date(), 'start'),
      toDateTimeProgram: this.formatDate2(new Date(), 'end'),
      toDateTimeActivity: this.formatDate2(new Date(), 'end'),
      toDateTimeMap: this.formatDate2(new Date(), 'end'),
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return false;
        }
      },
      orderColors: ['#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#FF00FF', '#00FFFF', '#800000', '#008000', '#000080', '#808000'],
      map: null,
      points: [],
      markers: [],
      polylines: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    var locationsDetails = this.$session.get('selectedCompanyData').locations_details;
    var apiKey = null;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(locationsDetails), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var location = _step.value;

        if (location.google_maps_api_key) {
          apiKey = location.google_maps_api_key;
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (apiKey) {
      __WEBPACK_IMPORTED_MODULE_3_google_maps___default.a.KEY = apiKey;
      __WEBPACK_IMPORTED_MODULE_3_google_maps___default.a.load(function (google) {
        _this.initMap(google);
      });
    } else {
      console.error('No Google Maps API key found in locations details.');
    }
  },
  created: function created() {
    this.loadDriversFromSession();
  },

  methods: {
    openWalletReport: function openWalletReport() {
      this.isWalletReportActive = true;
      this.isActiveProgramActive = false;
      this.isActiveActivityActive = false;
      this.isMapReportActive = false;
    },
    openActiveProgram: function openActiveProgram() {
      this.isActiveProgramActive = true;
      this.isWalletReportActive = false;
      this.isActiveActivityActive = false;
      this.isMapReportActive = false;
    },
    openActivityProgram: function openActivityProgram() {
      this.isActiveProgramActive = false;
      this.isWalletReportActive = false;
      this.isActiveActivityActive = true;
      this.isMapReportActive = false;
    },
    openMapReport: function openMapReport() {
      var _this2 = this;

      this.isActiveProgramActive = false;
      this.isWalletReportActive = false;
      this.isActiveActivityActive = false;
      this.isMapReportActive = true;
      this.$nextTick(function () {
        if (document.getElementById('map')) {
          _this2.initMap(window.google);
        } else {
          console.error('Containerul pentru hartă nu a fost găsit');
        }
      });
    },
    formatDate: function formatDate(dateString) {
      return new Date(dateString).toLocaleString();
    },
    formatDate2: function formatDate2(date, type) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      if (type === 'start') {
        return year + '-' + month + '-' + day + ' 00:00:00';
      } else if (type === 'end') {
        return year + '-' + month + '-' + day + ' 23:59:59';
      }
      return year + '-' + month + '-' + day;
    },
    convertMinutesToHours: function convertMinutesToHours(minutes) {
      return (minutes / 60).toFixed(2);
    },
    convertMinutesToDays: function convertMinutesToDays(minutes) {
      return (minutes / (60 * 24)).toFixed(2);
    },
    loadDriversFromSession: function loadDriversFromSession() {
      var driversFromSession = this.$session.get('drivers');
      if (driversFromSession) {
        this.drivers = driversFromSession;
      } else {
        console.error('No drivers found in session');
      }
    },
    sendEncashmentReport: function sendEncashmentReport() {
      var _this3 = this;

      if (!this.fromDateTimeWallet || !this.toDateTimeWallet) {
        alert('Please select from date and to date.');
        return;
      }

      var driverIds = this.selectedDriversWallet.map(function (driver) {
        return driver.id;
      });
      var fromDateFormatted = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.fromDateTimeWallet).format('YYYY-MM-DD HH:mm:ss');
      var toDateFormatted = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.toDateTimeWallet).format('YYYY-MM-DD HH:mm:ss');

      var dataToSend = {
        token: this.$session.get('token'),
        drivers_id: driverIds,
        from_date: fromDateFormatted,
        to_date: toDateFormatted
      };

      this.loading = true;
      this.apiRequest('/encashment-raport', 'GET', dataToSend, function (response) {
        _this3.loading = false;
        if (response.status === true) {
          _this3.walletData = response.data.driver_wallet.map(function (item) {
            return {
              driverId: item.driver_id,
              driverName: item.driver.firstname ? item.driver.firstname + ' ' + item.driver.lastname : 'N/A',
              adminName: item.admin ? item.admin.firstname + ' ' + item.admin.lastname : 'N/A',
              orderId: item.order_id,
              value: item.value,
              createdAt: item.created_at
            };
          });
        } else {
          console.error('Failed to send encashment report:', response.message);
        }
      });
    },
    sendProgramReport: function sendProgramReport() {
      var _this4 = this;

      if (!this.selectedDriversProgram.length || !this.fromDateTimeProgram || !this.toDateTimeProgram) {
        alert('Please select drivers, from date, and to date.');
        return;
      }

      var driverIds = this.selectedDriversProgram.map(function (driver) {
        return driver.id;
      });
      var fromDateFormatted = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.fromDateTimeProgram).format('YYYY-MM-DD HH:mm:ss');
      var toDateFormatted = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.toDateTimeProgram).format('YYYY-MM-DD HH:mm:ss');

      var dataToSend = {
        token: this.$session.get('token'),
        drivers_id: driverIds,
        from_date: fromDateFormatted,
        to_date: toDateFormatted
      };

      this.loading = true;
      this.apiRequest('/program-raport', 'GET', dataToSend, function (response) {
        _this4.loading = false;
        if (response.status === true) {
          _this4.programData = response.data.driver_wallet;
        } else {
          console.error('Failed to send encashment report:', response.message);
        }
      });
    },
    sendActivityReport: function sendActivityReport() {
      var _this5 = this;

      if (!this.selectedDriversActivity.length || !this.fromDateTimeActivity || !this.toDateTimeActivity) {
        alert('Please select drivers, from date, and to date.');
        return;
      }

      var driverIds = this.selectedDriversActivity.map(function (driver) {
        return driver.id;
      });
      var fromDateFormatted = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.fromDateTimeActivity).format('YYYY-MM-DD HH:mm:ss');
      var toDateFormatted = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.toDateTimeActivity).format('YYYY-MM-DD HH:mm:ss');

      var dataToSend = {
        token: this.$session.get('token'),
        drivers_id: driverIds,
        from_date: fromDateFormatted,
        to_date: toDateFormatted
      };

      this.loading = true;
      this.apiRequest('/activity-raport', 'GET', dataToSend, function (response) {
        _this5.loading = false;
        if (response.status === true) {
          _this5.activityData = response.data.drivers_activity;
        } else {
          console.error('Failed to send encashment report:', response.message);
        }
      });
    },
    sendMapReport: function sendMapReport() {
      var _this6 = this;

      if (!this.selectedDriversMap || !this.fromDateTimeMap || !this.toDateTimeMap) {
        alert('Please select drivers, from date, and to date.');
        return;
      }

      var driverId = this.selectedDriversMap ? this.selectedDriversMap.id : null;
      var fromDateFormatted = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.fromDateTimeMap).format('YYYY-MM-DD HH:mm:ss');
      var toDateFormatted = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.toDateTimeMap).format('YYYY-MM-DD HH:mm:ss');

      var dataToSend = {
        token: this.$session.get('token'),
        driver_id: driverId,
        from_date: fromDateFormatted,
        to_date: toDateFormatted
      };

      this.loading = true;
      this.apiRequest('/dispatch-map-raport', 'GET', dataToSend, function (response) {
        _this6.loading = false;
        console.log('API response:', response);
        if (response.status === true) {
          _this6.addPointsToMap(response.data.points);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
            type: 'error',
            title: 'Error',
            text: response.errors.time || 'Unknown error.',
            timer: 1500,
            showConfirmButton: false
          });
        }
      });
    },
    initMap: function initMap(google) {
      var defaultLatlng = new window.google.maps.LatLng(44.4268, 26.1025);

      var mapStyles = [{
        featureType: 'all',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ visibility: 'off' }]
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#d3d3d3' }]
      }, {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ visibility: 'on' }]
      }, {
        featureType: 'poi.business',
        stylers: [{ visibility: 'off' }]
      }, {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#c8e6c9' }]
      }];

      var mapOptions = {
        zoom: 10,
        center: defaultLatlng,
        scrollwheel: false,
        styles: mapStyles
      };

      this.map = new window.google.maps.Map(document.getElementById('map'), mapOptions);
    },
    addPointsToMap: function addPointsToMap(points) {
      var _this7 = this;

      if (!this.map) {
        console.error('Harta nu a fost inițializată.');
        return;
      }

      if (!Array.isArray(points) || points.length === 0) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
          type: 'error',
          title: 'Error',
          text: 'Points are not available or are not in a valid format.',
          timer: 1500,
          showConfirmButton: false
        });
        return;
      }

      this.markers.forEach(function (marker) {
        return marker.setMap(null);
      });
      this.markers = [];

      if (this.polylines) {
        this.polylines.forEach(function (polyline) {
          return polyline.setMap(null);
        });
      }
      this.polylines = [];

      var bounds = new window.google.maps.LatLngBounds();

      var infoWindow = new window.google.maps.InfoWindow();

      var path = [];

      points.forEach(function (point, index) {

        var color = '#FF0000';

        if (point.order_id) {
          color = '#17B086';
        } else {
          color = '#800080';
        }

        var marker = new window.google.maps.Marker({
          position: new window.google.maps.LatLng(point.gps_latitude, point.gps_longitude),
          map: _this7.map,
          icon: {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 7,
            fillColor: color,
            fillOpacity: 0.8,
            strokeWeight: 0
          }
        });

        bounds.extend(marker.getPosition());

        path.push(marker.getPosition());

        marker.addListener('click', function () {
          var content = '\n            <div>\n              <strong>Order ID:</strong> ' + (point.order_id ? point.order_id : 'N/A') + '<br>\n              <strong>Created At:</strong> ' + (point.created_at ? point.created_at : 'N/A') + '\n            </div>\n          ';
          infoWindow.setContent(content);
          infoWindow.open(_this7.map, marker);
        });

        _this7.markers.push(marker);
      });

      var segmentPath = [];
      points.forEach(function (point, index) {
        var color = '#FF0000';
        if (point.order_id) {
          color = '#00FF00';
        } else {
          color = '#800080';
        }

        segmentPath.push(new window.google.maps.LatLng(point.gps_latitude, point.gps_longitude));

        if (index < points.length - 1) {
          var nextPoint = points[index + 1];
          var nextColor = nextPoint.order_id ? '#00FF00' : '#800080';

          if (color !== nextColor) {
            if (segmentPath.length > 1) {
              var polyline = new window.google.maps.Polyline({
                path: segmentPath,
                geodesic: true,
                strokeColor: color,
                strokeOpacity: 1.0,
                strokeWeight: 2,
                icons: [{
                  icon: {
                    path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    scale: 1.5,
                    strokeColor: color,
                    strokeWeight: 1
                  },
                  repeat: '20px' }]
              });

              polyline.setMap(_this7.map);
              _this7.polylines.push(polyline);
            }

            segmentPath = [new window.google.maps.LatLng(point.gps_latitude, point.gps_longitude)];
          }
        }
      });

      if (segmentPath.length > 1) {
        var lastColor = points[points.length - 1].order_id ? '#00FF00' : '#800080';
        var polyline = new window.google.maps.Polyline({
          path: segmentPath,
          geodesic: true,
          strokeColor: lastColor,
          strokeOpacity: 1.0,
          strokeWeight: 2,
          icons: [{
            icon: {
              path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
              scale: 1.5,
              strokeColor: lastColor,
              strokeWeight: 1
            },
            repeat: '20px'
          }]
        });

        polyline.setMap(this.map);
        this.polylines.push(polyline);
      }

      this.map.fitBounds(bounds);
    },
    showLegend: function showLegend() {
      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
        title: this.$t('dispath.legend'),
        html: '\n          <div style="text-align: left; padding: 0 20px;">\n            <!-- Legend for Stop with Delivery -->\n            <div style="display: flex; align-items: center; margin-top: 30px; margin-bottom: 10px;">\n              <p style="margin: 0; font-weight: 500; margin-right: 20px; width: 166px;">\n                ' + this.$t('dispath.stopWithDelivery') + ':\n              </p>\n              <span style="display: inline-block; width: 20px; height: 20px; border-radius: 50%; background-color: #3DBE9C;"></span>\n            </div>\n\n            <!-- Legend for Driver with Delivery -->\n            <div style="display: flex; align-items: center; margin-bottom: 10px;">\n              <p style="margin: 0; font-weight: 500; margin-right: 20px; width: 162px;">\n                ' + this.$t('dispath.driverWithOrder') + ':\n              </p>\n              <svg width="220" height="40" style="display: block;">\n                <!-- Line -->\n                <line x1="20" y1="20" x2="200" y2="20" stroke="#00FF00" stroke-width="4" />\n                <!-- Right Arrow -->\n                <polygon points="200,15 200,25 210,20" fill="#00FF00" />\n                <!-- Left Arrow -->\n                <polygon points="20,15 20,25 10,20" fill="#00FF00" />\n                <!-- Label -->\n                <text x="110" y="38" fill="#000000" font-size="12" text-anchor="middle">' + this.$t('dispath.movementDirection') + '</text>\n              </svg>\n            </div>\n\n            <!-- Legend for Stop without Delivery -->\n            <div style="display: flex; align-items: center; margin-bottom: 10px;">\n              <p style="margin: 0; font-weight: 500; margin-right: 20px; width: 166px;">\n                ' + this.$t('dispath.stopWithoutDelivery') + ':\n              </p>\n              <span style="display: inline-block; width: 20px; height: 20px; border-radius: 50%; background-color: #800080;"></span>\n            </div>\n\n            <!-- Legend for Driver without Delivery -->\n            <div style="display: flex; align-items: center;">\n              <p style="margin: 0; font-weight: 500; margin-right: 20px;">\n                ' + this.$t('dispath.driverWithoutOrder') + ':\n              </p>\n              <svg width="220" height="40" style="display: block;">\n                <!-- Line -->\n                <line x1="20" y1="20" x2="200" y2="20" stroke="#800080" stroke-width="4" />\n                <!-- Right Arrow -->\n                <polygon points="200,15 200,25 210,20" fill="#800080" />\n                <!-- Left Arrow -->\n                <polygon points="20,15 20,25 10,20" fill="#800080" />\n                <!-- Label -->\n                <text x="110" y="38" fill="#000000" font-size="12" text-anchor="middle">' + this.$t('dispath.movementDirection') + '</text>\n              </svg>\n            </div>\n          </div>\n        ',
        confirmButtonText: this.$t('general.close')
      });
    }
  }
});

/***/ }),

/***/ "+VS9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrinterForm_vue__ = __webpack_require__("QfPH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_497b61ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrinterForm_vue__ = __webpack_require__("yOgY");
function injectStyle (ssrContext) {
  __webpack_require__("beEL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-497b61ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrinterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_497b61ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrinterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+WkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't2'
});

/***/ }),

/***/ "+Y1x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInvoiceSupplier_vue__ = __webpack_require__("+Zzd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe95dad6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInvoiceSupplier_vue__ = __webpack_require__("OPjp");
function injectStyle (ssrContext) {
  __webpack_require__("gb1l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe95dad6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInvoiceSupplier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe95dad6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInvoiceSupplier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Zzd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      selectedLocation: null
    };
  },

  props: {
    groupedLocations: { type: Array, required: true }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.$bus.$on('refresh', this.refreshPurchases);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.refreshPurchases);
  },

  methods: {
    formatMoney: function formatMoney(amount) {
      if (!amount || (typeof amount === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(amount)) !== 'object') return '0.00 RON';

      var value = Number(amount.value || 0);
      var currency = amount.currency || 'RON';

      return value.toFixed(2) + ' ' + currency;
    },
    goToInvoiceSupplier: function goToInvoiceSupplier(row) {
      this.$router.push({ name: 'ManagementInvoiceSupplierView', params: { id: row.id } });
    },
    refreshPurchases: function refreshPurchases() {
      this.fetchPurchases(this.selectedLocation, this.currentPage, this.pageSize);
    },
    onSearchPurchases: function onSearchPurchases() {
      if (!this.selectedLocation) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        });
        this.tableData = [];
        this.totalItems = 0;
        return;
      }

      this.fetchPurchases(this.selectedLocation);
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.fetchPurchases(this.selectedLocation, this.currentPage, this.pageSize);
    },
    fetchInvoices: function fetchInvoices() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, baseHost, baseUrl, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this.companyID || !_this.selectedLocation || !_this.selectedLocation.inv_fiscal_code)) {
                  _context.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  type: 'warning',
                  title: _this.$t('general.required'),
                  text: 'Selectați cel puțin o locație',
                  confirmButtonText: 'OK'
                });

                return _context.abrupt('return');

              case 3:
                params = new URLSearchParams({
                  externalCompanyId: _this.companyID,
                  zile: 30,
                  cif: _this.selectedLocation.inv_fiscal_code.replace(/^ro/i, ''),
                  filtru: 'P'
                });
                baseHost = "https://fiscal-dev.cdntaptasty.com".replace(/\/$/, '');
                baseUrl = baseHost + ':4443';
                url = baseUrl + '/efactura/inbox/import?' + params.toString();
                _context.prev = 7;

                _this.loading = true;

                _context.next = 11;
                return fetch(url);

              case 11:
                response = _context.sent;
                _context.next = 14;
                return response.json();

              case 14:
                data = _context.sent;

                if (response.ok) {
                  _context.next = 17;
                  break;
                }

                throw new Error(data.message || 'Import failed');

              case 17:

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  icon: data.imported && data.imported.length > 0 ? 'success' : 'info',
                  title: _this.$t('general.success'),
                  html: '<div>' + '<p><b>Message:</b> ' + (data.message ? data.message : '-') + '</p>' + '<p><b>Imported:</b> ' + (data.imported ? data.imported.length : 0) + '</p>' + '<p><b>Skipped:</b> ' + (data.skipped ? data.skipped.length : 0) + '</p>' + '</div>',
                  confirmButtonText: 'OK'
                });
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](7);

                console.error(_context.t0);

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  icon: 'error',
                  title: _this.$t('general.error'),
                  text: _context.t0.message || 'Error importing invoices',
                  confirmButtonText: 'OK'
                });

              case 24:
                _context.prev = 24;

                _this.loading = false;
                return _context.finish(24);

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[7, 20, 24, 27]]);
      }))();
    },
    fetchPurchases: function fetchPurchases() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this2 = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, response, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.companyID) {
                  _context2.next = 3;
                  break;
                }

                console.error('Missing company ID for fetching purchases.');
                return _context2.abrupt('return');

              case 3:
                if (!(!location || !location.inv_fiscal_code)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:

                _this2.loading = true;
                params = new URLSearchParams();

                params.append('externalCompanyId', _this2.companyID);
                params.append('vatNumber', location.inv_fiscal_code);
                params.append('page', page);
                params.append('limit', pageSize);

                _context2.prev = 11;
                _context2.next = 14;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/purchases?' + params.toString());

              case 14:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 17;
                  break;
                }

                throw new Error('Failed to fetch purchases');

              case 17:
                _context2.next = 19;
                return response.json();

              case 19:
                data = _context2.sent;

                if (Array.isArray(data.purchases)) {
                  clearTimeout(_this2.loadingTimeout);
                  _this2.loading = false;

                  _this2.totalItems = data.total || 0;
                  _this2.currentPage = data.currentPage || page;
                  _this2.pageSize = data.pageSize || pageSize;

                  _this2.tableData = data.purchases.map(function (p) {
                    var totals = p.totals || {};

                    return {
                      number: p.invoiceNumber || p._id,
                      id: p._id,
                      anafMessageId: p.anafMessageId,
                      supplierName: p.supplier.name || 'N/A',
                      taxableValue: _this2.formatMoney(totals.taxable),
                      taxValue: _this2.formatMoney(totals.tax),
                      totalValue: _this2.formatMoney(totals.total),
                      payableValue: _this2.formatMoney(totals.payable),
                      issueDate: p.issueDate || p.createdAt
                    };
                  });
                } else {
                  console.error('Purchases data not in expected format', data);
                }
                _context2.next = 28;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2['catch'](11);

                clearTimeout(_this2.loadingTimeout);
                _this2.loading = false;
                console.error('Error fetching purchases:', _context2.t0);

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[11, 23]]);
      }))();
    },
    handleDownload: function handleDownload(url, errorTitle) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, dataText, parsed, msg, anafObj;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return fetch(url, { method: 'GET' });

              case 2:
                response = _context3.sent;
                _context3.next = 5;
                return response.text();

              case 5:
                dataText = _context3.sent;
                parsed = null;

                try {
                  parsed = JSON.parse(dataText);
                } catch (e) {
                  parsed = null;
                }

                if (!(!response.ok || parsed && parsed.error)) {
                  _context3.next = 13;
                  break;
                }

                msg = 'A apărut o eroare.';


                if (parsed && parsed.anaf_error) {
                  try {
                    anafObj = JSON.parse(parsed.anaf_error);

                    if (anafObj && anafObj.eroare) {
                      msg = anafObj.eroare;
                    }
                  } catch (e) {}
                } else if (parsed && parsed.error) {
                  msg = parsed.error;
                }

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: errorTitle || 'Eroare',
                  text: msg,
                  type: 'error',
                  timer: 4000,
                  showConfirmButton: false
                });

                return _context3.abrupt('return', null);

              case 13:
                return _context3.abrupt('return', parsed);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    viewPdf: function viewPdf(row) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var base, url, result, downloadUrl;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                base = "https://fiscal-dev.cdntaptasty.com" + ':4443/efactura/purchase/pdf/' + row.id;
                url = row.status === true ? base + '?externalCompanyId=' + _this4.companyID : base + '?externalCompanyId=' + _this4.companyID + '&check=1';
                _context4.next = 5;
                return _this4.handleDownload(url, 'Eroare PDF');

              case 5:
                result = _context4.sent;

                if (result) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt('return');

              case 8:
                if (result.status === true) {
                  downloadUrl = base + '?externalCompanyId=' + _this4.companyID + '&download=1';


                  window.open(downloadUrl, '_blank');
                }
                _context4.next = 15;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Eroare neașteptată la încărcarea PDF-ului.',
                  type: 'error',
                  timer: 4000,
                  showConfirmButton: false
                });

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 11]]);
      }))();
    },
    exportDocument: function exportDocument(row) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var base, url, result, downloadUrl;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                base = "https://fiscal-dev.cdntaptasty.com" + ':4443/efactura/inbox/messages/' + row.anafMessageId + '/download';
                url = row.status === true ? base + '?externalCompanyId=' + _this5.companyID : base + '?externalCompanyId=' + _this5.companyID + '&check=1';
                _context5.next = 5;
                return _this5.handleDownload(url, 'Eroare descărcare');

              case 5:
                result = _context5.sent;

                if (result) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt('return');

              case 8:

                if (result.status === true) {
                  downloadUrl = base + '?externalCompanyId=' + _this5.companyID + '&download=1';


                  window.open(downloadUrl, '_blank');
                }
                _context5.next = 15;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](0);

                console.error(_context5.t0);

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Eroare neașteptată la descărcare.',
                  type: 'error',
                  timer: 4000,
                  showConfirmButton: false
                });

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 11]]);
      }))();
    }
  }
});

/***/ }),

/***/ "+aCA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosMapEdit_vue__ = __webpack_require__("SzMd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c277c67c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosMapEdit_vue__ = __webpack_require__("KFmv");
function injectStyle (ssrContext) {
  __webpack_require__("Tfw8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosMapEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c277c67c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosMapEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+cGz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+gUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Promos_vue__ = __webpack_require__("oQNv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e91fee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Promos_vue__ = __webpack_require__("boZy");
function injectStyle (ssrContext) {
  __webpack_require__("K2Qx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Promos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e91fee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Promos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+igg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-lg-12"},[_c('div',{staticClass:"search-bar"},[_c('div',{staticClass:"col-sm-12 no-padding"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('reports.search')},on:{"input":function($event){_vm.onInput()}},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('marketingSubscriptions.single'),"to":{ path: '/marketing/subscriptions/add' }}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.add'))+"\n          ")])],1)])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"sub-families"},[(!_vm.loading && !_vm.families.length)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center text-muted sub-empty"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.noSubscriptions')))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.families),function(family){return _c('div',{key:'family' + family.id,staticClass:"card sub-family"},[_c('div',{staticClass:"sub-family__head"},[_c('div',{staticClass:"sub-family__title"},[_c('i',{staticClass:"fa fa-clone",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(family.name))]),_vm._v(" "),_c('span',{staticClass:"sub-family__meta"},[_vm._v("\n              · "+_vm._s(family.levels.length === 1 ? _vm.$t('marketingSubscriptions.oneLevel') : _vm.$t('marketingSubscriptions.levelsCount', { count: family.levels.length }))+"\n              · "+_vm._s(_vm.$t('marketingSubscriptions.activeSubscribersCount', { count: family.active_subscribers }))+"\n              · "+_vm._s(_vm.$t('marketingSubscriptions.paymentProcessor'))+": "+_vm._s(family.payment_group_name ? _vm.paymentGroupLabel({ group_name: family.payment_group_name, gateway: family.payment_gateway }) : '-')+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"sub-family__actions"},[_c('a',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){_vm.openSubscribers(family)}}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "+_vm._s(_vm.$t('marketingSubscriptions.allSubscribers'))+"\n            ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){_vm.openFamilyModal(family)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" "+_vm._s(_vm.$t('marketingSubscriptions.editFamily'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"sub-grid sub-grid--head"},[_c('span'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.name')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.price')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.benefits')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.subscribers')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.status')))]),_vm._v(" "),_c('span')]),_vm._v(" "),_vm._l((family.levels),function(level){return _c('div',{key:'level' + level.id,staticClass:"sub-grid sub-row",class:{ 'is-inactive': !level.active }},[_c('div',{staticClass:"sub-level"},[_vm._v(_vm._s(level.level))]),_vm._v(" "),_c('div',{staticClass:"sub-name"},[(level.image_url)?_c('img',{staticClass:"sub-thumb",attrs:{"src":level.image_url}}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"sub-name__link",on:{"click":function($event){_vm.editLevel(level)}}},[_vm._v(_vm._s(level.name))]),_vm._v(" "),(!level.active)?_c('span',{staticClass:"sub-badge sub-badge--muted",attrs:{"title":_vm.$t('marketingSubscriptions.inactiveHint')}},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.inactive')))]):_vm._e()]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(level.price)+" "+_vm._s(_vm.currency)+"\n            "),(level.price_diff !== null)?_c('small',{staticClass:"text-muted"},[_vm._v("(+"+_vm._s(level.price_diff)+")")]):_vm._e()]),_vm._v(" "),_c('div',[(level.inherited_coupons.length)?_c('el-tooltip',{attrs:{"placement":"top"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"sub-tooltip-title"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.inheritedTitle')))]),_vm._v(" "),_vm._l((level.inherited_coupons),function(coupon){return _c('div',{key:'inh' + level.id + '-' + coupon.id},[_vm._v("\n                  "+_vm._s(coupon.name)+" "),_c('span',{staticClass:"sub-tooltip-from"},[_vm._v("("+_vm._s(coupon.from_name)+")")])])})],2),_vm._v(" "),_c('span',{staticClass:"sub-badge sub-badge--inherited"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.inheritedCount', { count: level.inherited_coupons.length })))])]):_vm._e(),_vm._v(" "),_vm._l((level.coupons),function(coupon){return _c('span',{key:'own' + level.id + '-' + coupon.id,staticClass:"sub-badge sub-badge--own"},[_vm._v(_vm._s(coupon.name))])}),_vm._v(" "),(!level.coupons.length && !level.inherited_coupons.length)?_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.noneAssigned')))]):_vm._e()],2),_vm._v(" "),_c('div',[_c('a',{staticClass:"sub-count",on:{"click":function($event){_vm.openSubscribers(family, level)}}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "+_vm._s(level.active_subscribers)+"\n            ")])]),_vm._v(" "),_c('div',[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(level)}},model:{value:(level.active),callback:function ($$v) {_vm.$set(level, "active", $$v)},expression:"level.active"}})],1),_vm._v(" "),_c('div',{staticClass:"sub-row__actions"},[_c('a',{staticClass:"sub-icon",attrs:{"title":_vm.$t('general.edit')},on:{"click":function($event){_vm.editLevel(level)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),(level.can_delete)?_c('a',{staticClass:"sub-icon sub-icon--danger",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.handleDelete(family, level)}}},[_c('i',{staticClass:"fa fa-trash-o"})]):_c('a',{staticClass:"sub-icon sub-icon--locked",attrs:{"title":_vm.deleteBlockedReason(family, level)},on:{"click":function($event){_vm.showDeleteBlocked(family, level)}}},[_c('i',{staticClass:"fa fa-lock"})])])])}),_vm._v(" "),_c('a',{staticClass:"sub-family__add",on:{"click":function($event){_vm.addLevel(family)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('marketingSubscriptions.addLevelOnTop', { name: _vm.topLevel(family).name }))+"\n        ")])],2)})],2)]),_vm._v(" "),_c('vmodal',{staticClass:"subscriptionFamilyModal",attrs:{"name":"subscriptionFamilyModal","width":"95%","maxWidth":520,"minWidth":300,"height":"auto","adaptive":true,"clickToClose":false},on:{"opened":_vm.onModalOpened}},[_c('div',{staticClass:"sub-modal__header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.editFamily')))])]),_vm._v(" "),_c('div',{staticClass:"sub-modal__body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.familyName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.familyForm.name),expression:"familyForm.name"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"255"},domProps:{"value":(_vm.familyForm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.familyForm, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.paymentProcessor'))+"*")]),_vm._v(" "),_c('el-select',{staticClass:"w-100",attrs:{"disabled":_vm.familyForm.locked,"no-data-text":_vm.$t('marketingSubscriptions.noPaymentAccounts')},model:{value:(_vm.familyForm.payment_group_key),callback:function ($$v) {_vm.$set(_vm.familyForm, "payment_group_key", $$v)},expression:"familyForm.payment_group_key"}},_vm._l((_vm.paymentGroups),function(group){return _c('el-option',{key:group.group_key,attrs:{"label":_vm.paymentGroupLabel(group),"value":group.group_key}})})),_vm._v(" "),(_vm.familyForm.locked)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.paymentLockedHint')))]):(!_vm.paymentGroups.length)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.noPaymentAccounts')))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"sub-modal__footer"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.$modal.hide('subscriptionFamilyModal')}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-purple-light btn-fill",attrs:{"disabled":_vm.savingFamily},on:{"click":_vm.saveFamily}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+j9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SpinningWheelCampaignForm_vue__ = __webpack_require__("qgrA");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SpinningWheelCampaignForm: __WEBPACK_IMPORTED_MODULE_0__SpinningWheelCampaignForm_vue__["a" /* default */] },
  props: {
    route: { type: Object, default: function _default() {
        return {};
      } }
  }
});

/***/ }),

/***/ "+lQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control border-input",domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+nbN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+p52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Settings_Locations_LocationForm_vue__ = __webpack_require__("Oz8n");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'LocationForm', __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Settings_Locations_LocationForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.tableManagementModel = model;
    }
  }
});

/***/ }),

/***/ "+pAP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductForm_vue__ = __webpack_require__("jkt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__productFormDependencies_js__ = __webpack_require__("F7xP");







var _components;





__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ProductForm', __WEBPACK_IMPORTED_MODULE_7__ProductForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      productData: this.route.params.productData || {},
      mainCategories: this.route.params.mainCategories || [],
      taxes: this.route.params.taxes || [],
      kdsSections: this.route.params.kdsSections || [],
      productOptions: this.route.params.productOptions || [],
      companyProductFilters: this.route.params.companyProductFilters || [],
      measurementsUnits: this.route.params.measurementsUnits || [],
      language: this.route.params.language || '',
      languages: this.route.params.languages || [],
      categoryModel: {},
      category: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__productFormDependencies_js__["a" /* loadProductFormDependencies */])(this);
  },

  methods: {
    onProductSubmit: function onProductSubmit(model, isValid) {
      this.productModel = model;
    }
  }
});

/***/ }),

/***/ "+suy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableManagement_vue__ = __webpack_require__("PPUE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e9c9fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableManagement_vue__ = __webpack_require__("uQMD");
function injectStyle (ssrContext) {
  __webpack_require__("PcAN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e9c9fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+tRN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wolt-menu-layout",class:{ 'wolt-menu-layout--product': !!_vm.selectedProduct }},[(_vm.selectedProduct)?_c('product-options-panel',{attrs:{"product":_vm.selectedProduct,"currency":_vm.currency,"variant":"wolt"},on:{"close":function($event){_vm.selectedProduct = null}}}):[_c('div',{staticClass:"wolt-menu-layout__tabs"},_vm._l((_vm.categories),function(category){return _c('button',{key:category.id,staticClass:"wolt-menu-layout__tab",class:{ 'is-active': category.id === _vm.activeCategoryId },attrs:{"type":"button"},on:{"click":function($event){_vm.selectCategory(category.id)}}},[_vm._v("\n        "+_vm._s(category.name)+"\n      ")])})),_vm._v(" "),_c('div',{ref:"content",staticClass:"wolt-menu-layout__content"},_vm._l((_vm.categories),function(category){return _c('section',{key:'sec-' + category.id,staticClass:"wolt-menu-layout__section",attrs:{"id":'wolt-cat-' + category.id}},[_c('h2',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_c('div',{staticClass:"wolt-menu-layout__grid"},_vm._l((category.products),function(product){return _c('article',{key:product.id,staticClass:"wolt-menu-layout__card",on:{"click":function($event){_vm.$emit('select-product', product); _vm.selectedProduct = product}}},[_c('div',{staticClass:"wolt-menu-layout__card-text"},[_c('h3',[_vm._v(_vm._s(product.name))]),_vm._v(" "),(product.description)?_c('p',[_vm._v(_vm._s(_vm.truncate(product.description)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wolt-menu-layout__card-price"},[_vm._v(_vm._s(_vm.formatPrice(product.price)))])]),_vm._v(" "),_c('div',{staticClass:"wolt-menu-layout__card-media"},[(product.image_url)?_c('img',{attrs:{"src":product.image_url,"alt":product.name}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"wolt-menu-layout__add",attrs:{"type":"button","aria-label":"+"}},[_vm._v("+")])])])}))])}))]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+wRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsCustomerDetails_vue__ = __webpack_require__("e0Nk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2425e27d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsCustomerDetails_vue__ = __webpack_require__("Bw5W");
function injectStyle (ssrContext) {
  __webpack_require__("YyoL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2425e27d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsCustomerDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2425e27d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsCustomerDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+woV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+xaX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row it-tour-page"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12 mb-10 it-topbar"},[_c('div',{staticClass:"it-tour-settings"},[_c('label',{staticClass:"it-setting"},[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.saveSettings('use_interactive_tour_first_login')}},model:{value:(_vm.settings.use_interactive_tour_first_login),callback:function ($$v) {_vm.$set(_vm.settings, "use_interactive_tour_first_login", $$v)},expression:"settings.use_interactive_tour_first_login"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('settingsPages.interactiveTourFirstLogin')))])],1),_vm._v(" "),_c('label',{staticClass:"it-setting"},[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.saveSettings('use_interactive_tour_always')}},model:{value:(_vm.settings.use_interactive_tour_always),callback:function ($$v) {_vm.$set(_vm.settings, "use_interactive_tour_always", $$v)},expression:"settings.use_interactive_tour_always"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('settingsPages.interactiveTourAlways')))])],1)]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn add mar-bt-20",on:{"click":_vm.openCreate}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"it-table-wrap"},[_c('table',{ref:"sortableTable",staticClass:"table width-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"5%"}}),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.image')))]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.title')))]),_vm._v(" "),_c('th',{attrs:{"width":"25%"}},[_vm._v("Descriere")]),_vm._v(" "),_c('th',{attrs:{"width":"13%"}},[_vm._v(_vm._s(_vm.$t('settingsPages.interactiveTourDisplayMode')))]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.status')))]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.actions')))]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}})])]),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody'},on:{"end":_vm.onReorder},model:{value:(_vm.slides),callback:function ($$v) {_vm.slides=$$v},expression:"slides"}},[_vm._l((_vm.slides),function(item,index){return [_c('tr',{key:item.id,staticClass:"sortableRow"},[_c('td',[_c('i',{staticClass:"fa fa-arrows sortHandle",staticStyle:{"cursor":"move","color":"#7C8DB5"}})]),_vm._v(" "),_c('td',[(item.image_url)?_c('img',{staticClass:"it-thumb",attrs:{"src":item.image_url}}):_c('span',{staticClass:"text-muted"},[_vm._v("—")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"it-clamp",attrs:{"title":item.title}},[_vm._v(_vm._s(item.title || '—'))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"it-clamp",attrs:{"title":item.description}},[_vm._v(_vm._s(item.description || '—'))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"it-mode-badge"},[_vm._v(_vm._s(_vm.displayModeLabel(item.display_mode)))])]),_vm._v(" "),_c('td',[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(item)}},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}})],1),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.handleDelete(index, item, $event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])]),_vm._v(" "),_c('td',{staticClass:"edit-icon-pointer",on:{"click":function($event){_vm.openEdit(item)}}},[_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                    ")])])])]})],2)],1)]),_vm._v(" "),(!_vm.loading && _vm.slides.length === 0)?_c('p',{staticClass:"text-center mar-tp-20"},[_vm._v("\n            Nicio secțiune adăugată încă.\n          ")]):_vm._e()]),_vm._v(" "),_c('vmodal',{staticClass:"tourModal",attrs:{"name":"tourModal","width":"95%","maxWidth":900,"minWidth":300,"height":"auto","scrollable":true,"adaptive":true},on:{"opened":_vm.onModalOpened}},[_c('div',{staticClass:"header border-bottom"},[_c('h4',[_vm._v(_vm._s(_vm.form.id ? _vm.$t('general.edit') : _vm.$t('general.add'))+" — Tur Interactiv")])]),_vm._v(" "),_c('div',{staticClass:"content-group"},[_c('div',{staticClass:"content_scrool"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.image'))+" "),_c('small',{staticClass:"text-muted"},[_vm._v("(max "+_vm._s(_vm.MAX_IMAGE_PX)+"x"+_vm._s(_vm.MAX_IMAGE_PX)+"px, max "+_vm._s(_vm.MAX_IMAGE_MB)+"MB)")])]),_vm._v(" "),_c('el-upload',{attrs:{"action":"","list-type":"picture-card","accept":".jpg,.jpeg,.png","file-list":_vm.form.imagelist,"limit":1,"auto-upload":false,"on-change":_vm.handleImageChange,"on-remove":_vm.handleImageRemove,"on-exceed":_vm.handleExceed}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.title')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.title),expression:"form.title"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.TITLE_MAX},domProps:{"value":(_vm.form.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "title", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted pull-right"},[_vm._v(_vm._s((_vm.form.title || '').length)+" / "+_vm._s(_vm.TITLE_MAX))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descriere")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"rows":"4","maxlength":_vm.DESCRIPTION_MAX},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted pull-right"},[_vm._v(_vm._s((_vm.form.description || '').length)+" / "+_vm._s(_vm.DESCRIPTION_MAX))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsPages.interactiveTourDisplayMode')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.display_mode),expression:"form.display_mode"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "display_mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.DISPLAY_MODES),function(mode){return _c('option',{key:mode,domProps:{"value":mode}},[_vm._v("\n                    "+_vm._s(_vm.displayModeLabel(mode))+"\n                  ")])}))]),_vm._v(" "),_c('p',{staticClass:"text-muted mar-tp-10"},[_vm._v("\n                Nimic nu e obligatoriu, dar o secțiune trebuie să aibă cel puțin o poză, un titlu sau o descriere.\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"tourModal__footer border-top",staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('button',{staticClass:"btn btn-default mar-rt-10",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_vm._v("\n              "+_vm._s(_vm.$t('general.cancel'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon save",attrs:{"type":"button","disabled":_vm.saving,"title":_vm.$t('general.save')},on:{"click":_vm.save}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n            ")])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/1mS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceEdit_vue__ = __webpack_require__("iVuY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c255ab9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceEdit_vue__ = __webpack_require__("/AZz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c255ab9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/3Kn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.cancelOption($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px","margin-bottom":"0"},on:{"click":function($event){$event.preventDefault();return _vm.handleDeleteOption($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),(_vm.model)?_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('h5',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.generalInformation')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('catalogProdOpt.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.label')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.label),expression:"model.label"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('catalogProdOpt.label')},domProps:{"value":(_vm.model.label)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "label", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.type')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.type),expression:"model.type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.optionTypes),function(opt,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(opt))])}))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.show_type')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.show_type),expression:"model.show_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "show_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.showTypes),function(opt,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(opt))])}))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.show_type_kiosk')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.show_type_kiosk),expression:"model.show_type_kiosk"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "show_type_kiosk", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.showTypesKiosk),function(opt,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(opt))])}))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.variants_id')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.variants_id),expression:"model.variants_id"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('catalogProdOpt.variants_id')},domProps:{"value":(_vm.model.variants_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "variants_id", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h5',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.settings')))]),_vm._v(" "),(_vm.showLocations)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProd.availableInLocation')))]),_vm._v(" "),_c('v-select',{key:'model' + _vm.model.id,ref:'model' + _vm.model.id,attrs:{"multiple":"","options":_vm.locations,"value":"id","label":"name","placeholder":_vm.$t('general.all')},model:{value:(_vm.optionLocationDetails),callback:function ($$v) {_vm.optionLocationDetails=$$v},expression:"optionLocationDetails"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProd.availableFor')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.deliveryMethods,"placeholder":_vm.$t('general.all')},model:{value:(_vm.optionDeliveryMethods),callback:function ($$v) {_vm.optionDeliveryMethods=$$v},expression:"optionDeliveryMethods"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProd.availableForSource')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.sourceOptions,"placeholder":_vm.$t('general.all')},model:{value:(_vm.optionSources),callback:function ($$v) {_vm.optionSources=$$v},expression:"optionSources"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"35px","background":"#fff","padding":"10px","border":"1px solid #e8e8e8"}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.optionType')))]),_vm._v(" "),_c('div',{staticClass:"radio-group"},[_c('p-radio',{staticStyle:{"margin":"0"},attrs:{"name":"is_product","value":1,"label":1,"inline":true},model:{value:(_vm.model.is_product),callback:function ($$v) {_vm.$set(_vm.model, "is_product", $$v)},expression:"model.is_product"}},[_vm._v("\n                    "+_vm._s(_vm.$t('catalogProdOpt.isProduct'))+"\n                  ")]),_vm._v(" "),_c('small',{staticClass:"help-text"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.isProductDesc')))]),_vm._v(" "),_c('p-radio',{staticStyle:{"margin":"0"},attrs:{"name":"is_product","value":0,"label":0,"inline":true},model:{value:(_vm.model.is_product),callback:function ($$v) {_vm.$set(_vm.model, "is_product", $$v)},expression:"model.is_product"}},[_vm._v("\n                    "+_vm._s(_vm.$t('catalogProdOpt.isModifier2'))+"\n                  ")]),_vm._v(" "),_c('small',{staticClass:"help-text"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.isModifierDesc')))])],1)]),_vm._v(" "),_c('div',{staticClass:"checkbox-group row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group checkbox-item"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.isModifier')))]),_vm._v(" "),_c('p-checkbox',{staticClass:"text-purple",attrs:{"value":_vm.model.is_modifier},model:{value:(_vm.model.is_modifier),callback:function ($$v) {_vm.$set(_vm.model, "is_modifier", $$v)},expression:"model.is_modifier"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group checkbox-item"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.menuQr')))]),_vm._v(" "),_c('p-checkbox',{staticClass:"text-purple",attrs:{"value":_vm.model.display_in_dynamic_menu,"label":_vm.$t('displayInMenu')},model:{value:(_vm.model.display_in_dynamic_menu),callback:function ($$v) {_vm.$set(_vm.model, "display_in_dynamic_menu", $$v)},expression:"model.display_in_dynamic_menu"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group checkbox-item"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('settingLocationGroups.active')))]),_vm._v(" "),_c('p-checkbox',{staticClass:"text-purple",attrs:{"value":_vm.model.active,"label":_vm.$t('settingLocationGroups.active')},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h5',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('catalogProd.image')))]),_vm._v(" "),_c('div',{staticClass:"form-group image-upload-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('catalogProd.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.image,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage1,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove1,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-12 col-md-12"},[(_vm.optionValuesData)?_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-header"},[_c('h5',{staticClass:"section-title",staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.values')))])]),_vm._v(" "),_c('div',{staticClass:"card-content values-section"},[_vm._l((_vm.optionValuesData),function(item,index){return (!item.hasOwnProperty('delete') || (item.hasOwnProperty('delete') && item.delete != 1))?_c('div',{key:'value-' + index,staticClass:"value-row"},[_c('div',{staticClass:"value-col value-col-data"},[(item.id)?_c('div',{staticClass:"item-id-badge"},[_c('span',{staticClass:"id-label"},[_vm._v("ID: "+_vm._s(item.id))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.option_name'))+" #"+_vm._s(index+1))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.name),expression:"item.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(item.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.sgrName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.name_sgr),expression:"item.name_sgr"}],staticClass:"form-control sml",attrs:{"type":"text"},domProps:{"value":(item.name_sgr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "name_sgr", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.sgrPrice')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.price_sgr),expression:"item.price_sgr"}],staticClass:"form-control sml",attrs:{"type":"text"},domProps:{"value":(item.price_sgr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "price_sgr", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.sgrPos')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.pos_id_sgr),expression:"item.pos_id_sgr"}],staticClass:"form-control sml",attrs:{"type":"text"},domProps:{"value":(item.pos_id_sgr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "pos_id_sgr", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.posid')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.pos_id),expression:"item.pos_id"}],staticClass:"form-control sml",attrs:{"type":"text"},domProps:{"value":(item.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "pos_id", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.posid2')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.external_id),expression:"item.external_id"}],staticClass:"form-control sml",attrs:{"type":"text"},domProps:{"value":(item.external_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "external_id", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.vat')))]),_vm._v(" "),(_vm.taxesVersion === 2)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.vat_rate_id),expression:"item.vat_rate_id"}],staticClass:"form-control sml",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "vat_rate_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{key:vat.id,attrs:{"disabled":_vm.isVatOptionDisabled(vat, item.vat_rate_id)},domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.rate)+"%"+_vm._s(!vat.is_active ? ' (inactiv)' : ''))])})],2):_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.vat_id),expression:"item.vat_id"}],staticClass:"form-control sml",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "vat_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{key:vat.id,domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.amount))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.vatSGR')))]),_vm._v(" "),(_vm.taxesVersion === 2)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.vat_rate_id_sgr),expression:"item.vat_rate_id_sgr"}],staticClass:"form-control sml",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "vat_rate_id_sgr", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{key:vat.id,attrs:{"disabled":_vm.isVatOptionDisabled(vat, item.vat_rate_id_sgr)},domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.rate)+"%"+_vm._s(!vat.is_active ? ' (inactiv)' : ''))])})],2):_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.vat_id_sgr),expression:"item.vat_id_sgr"}],staticClass:"form-control sml",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "vat_id_sgr", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{key:vat.id,domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.amount))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.section')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.section_id),expression:"item.section_id"}],staticClass:"form-control sml",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select'))+" "+_vm._s(_vm.$t('catalogProdOpt.section')))]),_vm._v(" "),_vm._l((_vm.kdsSectionsParent),function(section){return _c('option',{key:section.id,attrs:{"label":section.name},domProps:{"value":section.id}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('printer.section'))+" SGR")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.sgr_section_id),expression:"item.sgr_section_id"}],staticClass:"form-control sml",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "sgr_section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('printer.section'))+" SGR")]),_vm._v(" "),_vm._l((_vm.kdsSectionsParent),function(section){return _c('option',{key:section.id,attrs:{"label":section.name},domProps:{"value":section.id}})})],2)])])]),_vm._v(" "),_c('div',{staticClass:"quantity-block"},[_c('div',{staticClass:"form-group checkbox-item-inline"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('companyOptions.allowQuantity')))]),_vm._v(" "),_c('p-checkbox',{staticClass:"text-purple",attrs:{"value":1},model:{value:(item.allow_quantity),callback:function ($$v) {_vm.$set(item, "allow_quantity", $$v)},expression:"item.allow_quantity"}})],1),_vm._v(" "),(item.allow_quantity == 1)?_c('div',{staticClass:"quantity-inputs-row"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('companyOptions.minQuantity')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.min_quantity),expression:"item.min_quantity",modifiers:{"number":true}}],staticClass:"form-control sml",attrs:{"type":"number","min":"1","max":"9999","oninput":"\n                                 if(this.value.length > 4) this.value = this.value.slice(0,4);\n                                 if(this.value !== '' && this.value < 1) this.value = 1;\n                               "},domProps:{"value":(item.min_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "min_quantity", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('companyOptions.maxQuantity')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.max_quantity),expression:"item.max_quantity",modifiers:{"number":true}}],staticClass:"form-control sml",attrs:{"type":"number","min":"1","max":"9999","oninput":"\n                                 if(this.value.length > 4) this.value = this.value.slice(0,4);\n                                 if(this.value !== '' && this.value < 1) this.value = 1;\n                               "},domProps:{"value":(item.max_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "max_quantity", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"value-col value-col-desc"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.info')))]),_vm._v(" "),_c('div',{staticClass:"wysiwyg-wrapper"},[_c('wysiwyg',{attrs:{"placeholder":_vm.$t('catalogProdOpt.infoPlaceholder')},model:{value:(item.cov_info),callback:function ($$v) {_vm.$set(item, "cov_info", $$v)},expression:"item.cov_info"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group inline-field"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('companyOptions.print_with_product_label')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(item.print_with_product_label),callback:function ($$v) {_vm.$set(item, "print_with_product_label", $$v)},expression:"item.print_with_product_label"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('companyOptions.product_id')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","reserve-keyword":"","clearable":"","remote-method":_vm.searchProducts,"loading":_vm.searchProductsLoading,"loading-text":_vm.$t('general.generalLoader'),"placeholder":_vm.$t('general.add'),"no-data-text":_vm.$t('general.no_data')},model:{value:(item.product_id),callback:function ($$v) {_vm.$set(item, "product_id", $$v)},expression:"item.product_id"}},[_vm._l((_vm.allProducts),function(prod){return _c('el-option',{key:prod.id,attrs:{"value":prod.id,"label":prod.name}})}),_vm._v(" "),_vm._l((_vm.allProductsHidden),function(hiddenItem){return _c('el-option',{key:'hidden-' + hiddenItem.id,staticClass:"hidden-option",attrs:{"value":hiddenItem.id,"label":hiddenItem.name}})}),_vm._v(" "),[(!_vm.searchProductsLoading && _vm.allProducts.length === 0)?_c('span',{staticStyle:{"padding":"0","margin":"0","text-align":"center","color":"#999","font-size":"14px","width":"100%","display":"inline-block"}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.no_data'))+"\n                    ")]):_vm._e()]],2)],1)]),_vm._v(" "),_c('div',{staticClass:"value-col value-col-images"},[_c('div',{staticClass:"images-row"},[_c('div',{staticClass:"image-upload-wrapper"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",refInFor:true,attrs:{"action":"","limit":2,"file-list":item.image ? item.image : [],"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":function (file,fileList) { return _vm.handleImgChnage(file,fileList,index) },"on-exceed":_vm.handleExceed,"on-remove":function (file,fileList) { return _vm.handleRemove(file,fileList,index) },"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"image-upload-wrapper"},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('companyOptions.prod_image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",refInFor:true,attrs:{"action":"","limit":2,"file-list":item.prod_image ? item.prod_image : [],"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":function (file,fileList) { return _vm.handleImgProdChnage(file,fileList,index) },"on-exceed":_vm.handleExceed,"on-remove":function (file,fileList) { return _vm.handleRemoveProd(file,fileList,index) },"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})])],1)])]),_vm._v(" "),_c('div',{staticClass:"value-actions-bar"},[_c('div',{staticClass:"actions-left"},[_c('div',{staticClass:"form-group checkbox-item-inline",staticStyle:{"margin":"0"}},[_c('label',{staticClass:"small-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.active')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}})],1)]),_vm._v(" "),_c('div',{staticClass:"actions-right"},[_c('button',{staticClass:"btn btn-simple btn-icon delete-btn",on:{"click":function($event){$event.preventDefault();_vm.deleteValue(index)}}},[_c('i',{staticClass:"ti-close text-orange",attrs:{"title":_vm.$t('general.delete')}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.delete')))])])])])]):_vm._e()}),_vm._v(" "),_c('button',{staticClass:"btn add mar-to-15 mar-lt-20",on:{"click":function($event){$event.preventDefault();_vm.addNewValue()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('catalogProdOpt.addNewOptionValue'))+" #"+_vm._s(_vm.optionValuesData.length + 1)+"\n          ")])],2)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"space_for_alert_box",staticStyle:{"height":"100px","width":"100%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/51X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_col_css__ = __webpack_require__("jZDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_col_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_col_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_col__ = __webpack_require__("91Nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css__);




























__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_col___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_18_vuedraggable___default.a
  },
  data: function data() {
    return {
      links: [],
      loading: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_vee_validate__["b" /* mapFields */])(['title', 'alias'])),
  created: function created() {
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      this.loading = true;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        sort_order: 'asc'
      };

      this.apiRequest('/menulink', 'GET', data, function (response) {
        if (response.status === true) {
          _this.links = response.data;
        }
        _this.loading = false;
      });
    },
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/menu-links/edit/');
    },
    adjustSort: function adjustSort(evt) {
      var _this2 = this;

      if (this.links.length > 1) {
        var idx = evt.newIndex;
        var after, before, sortOrder;

        if (idx === 0) {
          before = 0;
          after = this.links[idx + 1].sort_order;
        } else if (idx + 1 === this.links.length) {
          before = this.links[idx - 1].sort_order;
          after = parseFloat(before) + 1;
        } else {
          before = this.links[idx - 1].sort_order;
          after = this.links[idx + 1].sort_order;
        }

        sortOrder = (parseFloat(before) + parseFloat(after)) / 2;
        var id = this.links[idx].id;

        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: sortOrder
        };
        this.apiRequest('/menulink/' + id, 'PUT', data, function (response) {
          if (response.status !== true) {
            __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
              title: '',
              text: _this2.$t('validations.dataCouldNotBeSaved'),
              type: 'danger',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "/6y3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreen_vue__ = __webpack_require__("Mm9z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5cd088_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreen_vue__ = __webpack_require__("i1gK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5cd088_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/AZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('invoice-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/CcY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/DdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.fiscalZReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-12",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"fiscal-z-filters"},[(_vm.showLocations)?_c('div',{staticClass:"fiscal-z-filter"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fiscal-z-filter"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.zNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.z_number),expression:"orders.z_number"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"z_number","placeholder":_vm.$t('reports.zNumber')},domProps:{"value":(_vm.orders.z_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.orders, "z_number", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])]),_vm._v(" "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(" "+_vm._s(_vm.$t('reports.interval'))+": "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":00")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row",staticStyle:{"display":"flex","align-items":"stretch","margin-bottom":"15px"}},[_c('div',{staticClass:"col-md-6",staticStyle:{"display":"flex"}},[_c('div',{staticClass:"card center-sales-report-stats",staticStyle:{"width":"100%","min-height":"430px","display":"flex","flex-direction":"column"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content",staticStyle:{"flex":"1","display":"flex","flex-direction":"column"}},[_c('div',{staticClass:"report-container",staticStyle:{"flex":"1","overflow-y":"auto"}},[_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalSales')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_sales || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.cash')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.cash || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.cardPayment')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.card || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.credit')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.credit || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.mealTickets')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.meal_tickets || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.valueTickets')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.value_tickets || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.voucher')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.voucher || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.modernPayment')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.modern_payment || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.advanceInCash')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.advance_in_cash || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.otherMethods')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.other_methods || 0)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6",staticStyle:{"display":"flex"}},[_c('div',{staticClass:"card center-sales-report-stats",staticStyle:{"width":"100%","min-height":"430px","display":"flex","flex-direction":"column"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content",staticStyle:{"flex":"1","display":"flex","flex-direction":"column"}},[_c('div',{staticClass:"report-container",staticStyle:{"flex":"1","overflow-y":"auto"}},[_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalVat')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_vat || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalVatA'))+" (21%)")]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_vat_a || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalVatB'))+" (11%)")]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_vat_b || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalVatC'))+" (0%)")]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_vat_c || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalVatD'))+" (0%)")]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_vat_d || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalVatE'))+" (0%)")]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_vat_e || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalSalesA')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_sales_a || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalSalesB')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_sales_b || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalSalesC')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_sales_c || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalSalesD')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_sales_d || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalSalesE')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_sales_e || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.nrFiscalReceipts')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.productsTableDataTotals.nr_fiscal_receipts || 0))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.nrNonFiscalReceipts')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.productsTableDataTotals.nr_non_fiscal_receipts || 0))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns",staticStyle:{"width":"100%"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"reportsTable",attrs:{"data":_vm.productsTableData,"total":_vm.totalOrders,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":"60","label":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('i',{staticClass:"ti-eye",staticStyle:{"cursor":"pointer","font-size":"18px","color":"#3B4BFF"},on:{"click":function($event){_vm.openRawDataModal(props.row)}}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"z_number","label":_vm.$t('reports.zNumber'),"min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"device_name","label":_vm.$t('reports.deviceName'),"min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"z_timestamp","label":_vm.$t('reports.zTimestamp'),"min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.z_timestamp ? _vm.formatToCompanyTimezone(props.row.z_timestamp) : '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"cash_in_drawer","label":_vm.$t('reports.cashInDrawer'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.cash_in_drawer || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cash","min-width":"120","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.cash'), _vm.productsTableDataTotals.cash); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.cash || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"card","min-width":"120","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.cardPayment'), _vm.productsTableDataTotals.card); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.card || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"credit","min-width":"120","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.credit'), _vm.productsTableDataTotals.credit); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.credit || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"meal_tickets","min-width":"140","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.mealTickets'), _vm.productsTableDataTotals.meal_tickets); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.meal_tickets || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value_tickets","min-width":"140","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.valueTickets'), _vm.productsTableDataTotals.value_tickets); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.value_tickets || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"voucher","min-width":"120","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.voucher'), _vm.productsTableDataTotals.voucher); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.voucher || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"modern_payment","min-width":"150","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.modernPayment'), _vm.productsTableDataTotals.modern_payment); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.modern_payment || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"advance_in_cash","min-width":"150","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.advanceInCash'), _vm.productsTableDataTotals.advance_in_cash); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.advance_in_cash || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"other_methods","min-width":"140","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.otherMethods'), _vm.productsTableDataTotals.other_methods); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.other_methods || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales_a","min-width":"140","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalSalesA'), _vm.productsTableDataTotals.total_sales_a); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_sales_a || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales_b","min-width":"140","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalSalesB'), _vm.productsTableDataTotals.total_sales_b); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_sales_b || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales_c","min-width":"140","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalSalesC'), _vm.productsTableDataTotals.total_sales_c); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_sales_c || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales_d","min-width":"140","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalSalesD'), _vm.productsTableDataTotals.total_sales_d); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_sales_d || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales_e","min-width":"140","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalSalesE'), _vm.productsTableDataTotals.total_sales_e); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_sales_e || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_other_taxes","min-width":"150","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalOtherTaxes'), _vm.productsTableDataTotals.total_other_taxes); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_other_taxes || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_exempt","min-width":"150","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalVatExempt'), _vm.productsTableDataTotals.total_vat_exempt); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_vat_exempt || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales","min-width":"140","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalSales'), _vm.productsTableDataTotals.total_sales); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_sales || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_a","min-width":"130","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalVatA'), _vm.productsTableDataTotals.total_vat_a); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_vat_a || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_b","min-width":"130","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalVatB'), _vm.productsTableDataTotals.total_vat_b); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_vat_b || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_c","min-width":"130","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalVatC'), _vm.productsTableDataTotals.total_vat_c); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_vat_c || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_d","min-width":"130","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalVatD'), _vm.productsTableDataTotals.total_vat_d); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_vat_d || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_e","min-width":"130","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalVatE'), _vm.productsTableDataTotals.total_vat_e); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_vat_e || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat","min-width":"120","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.totalVat'), _vm.productsTableDataTotals.total_vat); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_vat || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fiscal_code_clients_total_vat","min-width":"200","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.fiscalCodeClientsTotalVat'), _vm.productsTableDataTotals.fiscal_code_clients_total_vat); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.fiscal_code_clients_total_vat || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fiscal_code_clients_total_sum","min-width":"200","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.fiscalCodeClientsTotalSum'), _vm.productsTableDataTotals.fiscal_code_clients_total_sum); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.fiscal_code_clients_total_sum || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nr_fiscal_code_client_receipts","min-width":"200","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.nrFiscalCodeClientReceipts'), _vm.productsTableDataTotals.nr_fiscal_code_client_receipts); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.nr_fiscal_code_client_receipts || 0)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nr_fiscal_receipts","min-width":"150","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.nrFiscalReceipts'), _vm.productsTableDataTotals.nr_fiscal_receipts); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.nr_fiscal_receipts || 0)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nr_non_fiscal_receipts","min-width":"180","class-name":"centered-cell","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.nrNonFiscalReceipts'), _vm.productsTableDataTotals.nr_non_fiscal_receipts); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.nr_non_fiscal_receipts || 0)+"\n            ")]}}])})],1)],1)])]),_vm._v(" "),_c('vmodal',{attrs:{"name":"rawDataModal","height":"auto","width":"620","adaptive":true,"scrollable":true}},[_c('div',{staticClass:"z-receipt-doc"},[_c('div',{staticClass:"z-receipt-doc__header"},[_c('div',{staticClass:"z-receipt-doc__heading"},[_c('h4',{staticClass:"z-receipt-doc__title"},[_vm._v("\n            "+_vm._s(_vm.$t('reports.fiscalZReport'))+" · Z "+_vm._s(_vm.selectedRawDataRow.z_number || '-')+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"z-receipt-doc__subtitle"},[(_vm.selectedRawDataRow.device_name)?_c('span',[_vm._v(_vm._s(_vm.selectedRawDataRow.device_name))]):_vm._e(),_vm._v(" "),(_vm.selectedRawDataRow.device_name && _vm.selectedRawDataRow.z_timestamp)?_c('span',{staticClass:"z-receipt-doc__dot"},[_vm._v("•")]):_vm._e(),_vm._v(" "),(_vm.selectedRawDataRow.z_timestamp)?_c('span',[_vm._v("\n              "+_vm._s(_vm.formatToCompanyTimezone(_vm.selectedRawDataRow.z_timestamp))+"\n            ")]):_vm._e()])]),_vm._v(" "),_c('el-button',{staticClass:"z-receipt-doc__close",attrs:{"type":"text","title":_vm.$t('general.close')},on:{"click":_vm.closeRawDataModal}},[_c('i',{staticClass:"el-icon-close"})])],1),_vm._v(" "),_c('div',{staticClass:"z-receipt-doc__body"},[(_vm.rawSummarySections.length && _vm.selectedRawDataRow.total_sales !== undefined)?_c('div',{staticClass:"z-receipt-hero"},[_c('span',{staticClass:"z-receipt-hero__label"},[_vm._v(_vm._s(_vm.$t('reports.totalSales')))]),_vm._v(" "),_c('span',{staticClass:"z-receipt-hero__value"},[_vm._v("\n            "+_vm._s(_vm.formatMoneyAmount(Number(_vm.selectedRawDataRow.total_sales || 0)))+"\n          ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.rawSummarySections),function(section){return _c('div',{key:section.id,staticClass:"z-receipt-card"},[_c('div',{staticClass:"z-receipt-card__title"},[_vm._v(_vm._s(section.title))]),_vm._v(" "),_c('div',{staticClass:"z-receipt-card__rows"},_vm._l((section.rows),function(item){return _c('div',{key:item.key,staticClass:"z-receipt-line"},[_c('span',{staticClass:"z-receipt-line__label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticClass:"z-receipt-line__value"},[_vm._v(_vm._s(item.value))])])}))])}),_vm._v(" "),(_vm.rawOutputText)?_c('div',{staticClass:"z-receipt-raw"},[_c('button',{staticClass:"z-receipt-raw__toggle",attrs:{"type":"button"},on:{"click":function($event){_vm.rawExpanded = !_vm.rawExpanded}}},[_c('span',[_vm._v("Raport fiscal brut")]),_vm._v(" "),_c('i',{class:_vm.rawExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('pre',{directives:[{name:"show",rawName:"v-show",value:(_vm.rawExpanded),expression:"rawExpanded"}],staticClass:"z-receipt-raw__panel"},[_vm._v(_vm._s(_vm.rawOutputText))])]):_vm._e(),_vm._v(" "),(!_vm.rawSummarySections.length && !_vm.rawOutputText)?_c('div',{staticClass:"z-receipt-empty"},[_vm._v("\n          "+_vm._s(_vm.$t('reports.noRawData'))+"\n        ")]):_vm._e()],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/J3T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NomenclatorProductsEdit_vue__ = __webpack_require__("HrqZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d03c74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NomenclatorProductsEdit_vue__ = __webpack_require__("loWU");
function injectStyle (ssrContext) {
  __webpack_require__("GDtL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42d03c74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NomenclatorProductsEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d03c74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NomenclatorProductsEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/SUY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs",attrs:{"direction":"vertical"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.tableZones')}},[_c('keep-alive',[(_vm.isTableZones)?_c('div',[(_vm.selectedZone !== false)?[_c('table-zone-form',{attrs:{"callback":_vm.tableZoneUpdate,"zoneId":_vm.selectedZone},on:{"on-submit":_vm.onUserSubmit}})]:[_c('table-zone-list',{ref:"tableZone",attrs:{"isTable":_vm.isTableZones,"callback":_vm.getZone}})]],2):_vm._e()])],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.qrModule')}},[_c('keep-alive',[(_vm.isTableManager)?_c('div',[(_vm.selectedTable !== false)?[_c('table-management-form',{attrs:{"callback":_vm.tableManagementUpdate,"tableId":_vm.selectedTable,"posUsers":_vm.formattedUsers,"showOnlineQr":true},on:{"on-submit":_vm.onUserSubmit}})]:[_c('table-management-list',{ref:"tableManagement",attrs:{"isTable":_vm.isTableManager,"callback":_vm.getTable,"posUsers":_vm.formattedUsers}})]],2):_vm._e()])],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.settings')}},[_c('keep-alive',[_c('div',[_c('kiosk-colors-card',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)])],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Sdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_GlobalModal_vue__ = __webpack_require__("sEIX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Settings_TableManagement_TableManagementForm_vue__ = __webpack_require__("kQ0V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__svg_t1__ = __webpack_require__("H3Cb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__svg_t2__ = __webpack_require__("agUK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__svg_t3__ = __webpack_require__("xVQE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__svg_t4__ = __webpack_require__("QTC9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__svg_t5__ = __webpack_require__("Tqm7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__svg_t6__ = __webpack_require__("ph0e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__svg_t7__ = __webpack_require__("S6Gb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__svg_t8__ = __webpack_require__("/srY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__svg_t9__ = __webpack_require__("uONr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__svg_t10__ = __webpack_require__("l+xS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__svg_t11__ = __webpack_require__("IqgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__svg_t12__ = __webpack_require__("TOu6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__svg_r1__ = __webpack_require__("MY36");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__svg_r2__ = __webpack_require__("aBwl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__svg_r3__ = __webpack_require__("ZRcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__svg_r4__ = __webpack_require__("6c7q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__svg_r5__ = __webpack_require__("I0te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__svg_r6__ = __webpack_require__("cXXj");












var _components;



























__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    t1: __WEBPACK_IMPORTED_MODULE_16__svg_t1__["a" /* default */],
    t2: __WEBPACK_IMPORTED_MODULE_17__svg_t2__["a" /* default */],
    t3: __WEBPACK_IMPORTED_MODULE_18__svg_t3__["a" /* default */],
    t4: __WEBPACK_IMPORTED_MODULE_19__svg_t4__["a" /* default */],
    t5: __WEBPACK_IMPORTED_MODULE_20__svg_t5__["a" /* default */],
    t6: __WEBPACK_IMPORTED_MODULE_21__svg_t6__["a" /* default */],
    t7: __WEBPACK_IMPORTED_MODULE_22__svg_t7__["a" /* default */],
    t8: __WEBPACK_IMPORTED_MODULE_23__svg_t8__["a" /* default */],
    t9: __WEBPACK_IMPORTED_MODULE_24__svg_t9__["a" /* default */],
    t10: __WEBPACK_IMPORTED_MODULE_25__svg_t10__["a" /* default */],
    t11: __WEBPACK_IMPORTED_MODULE_26__svg_t11__["a" /* default */],
    t12: __WEBPACK_IMPORTED_MODULE_27__svg_t12__["a" /* default */],
    r1: __WEBPACK_IMPORTED_MODULE_28__svg_r1__["a" /* default */],
    r2: __WEBPACK_IMPORTED_MODULE_29__svg_r2__["a" /* default */],
    r3: __WEBPACK_IMPORTED_MODULE_30__svg_r3__["a" /* default */],
    r4: __WEBPACK_IMPORTED_MODULE_31__svg_r4__["a" /* default */],
    r5: __WEBPACK_IMPORTED_MODULE_32__svg_r5__["a" /* default */],
    r6: __WEBPACK_IMPORTED_MODULE_33__svg_r6__["a" /* default */],
    TableManagementForm: __WEBPACK_IMPORTED_MODULE_15__Settings_TableManagement_TableManagementForm_vue__["a" /* default */],
    GlobalModal: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_GlobalModal_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.company_id = this.$session.get('selectedCompany');
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getData();
  },
  data: function data() {
    return {
      id: this.route.params.id || null,
      company_id: null,
      locations: [],
      tables: [],
      model: {
        'id': 0,
        'name': null,
        'location_id': null,
        'table_manager_maps': []
      },
      posUsers: [],
      scaleFactor: 1,
      offset: { x: 0, y: 0 },
      draggingTable: null,
      selectedTableIndex: null,
      selectedTable: null,
      showTableModal: false,
      resizing: false,
      modelValidate: {
        name: { required: true },
        location_id: { required: true }
      },
      topCategories: null,
      loadingTable: true,
      loading: true
    };
  },

  computed: {
    formattedUsers: function formattedUsers() {
      return this.posUsers.map(function (user) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user, {
          fullname: user.firstname + ' ' + user.lastname });
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('mousemove', this.updateTablePosition);
    window.addEventListener('mouseup', function () {
      return _this.selectedTableIndex = null;
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('mousemove', this.updateTablePosition);
  },

  methods: {
    tableMapTableNumber: function tableMapTableNumber(tableManagerId) {
      if (this.tables && this.tables.length) {
        var table = this.tables.find(function (tableFromTables) {
          return tableFromTables.id === tableManagerId;
        });
        if (table) {
          return table.number;
        }
      }
      return '';
    },
    getTableComponent: function getTableComponent(tableManagerId) {
      if (this.tables && this.tables.length) {
        var table = this.tables.find(function (tableFromTables) {
          return tableFromTables.id === tableManagerId;
        });
        if (table) {
          if (table.table_shape === 'round') {
            if (!table.max_pers) {
              return 'r4';
            }
            if (table.max_pers >= 6) {
              return 'r6';
            } else {
              return 'r' + table.max_pers;
            }
          } else {
            if (!table.max_pers) {
              return 't4';
            }
            if (table.max_pers >= 12) {
              return 't12';
            } else {
              return 't' + table.max_pers;
            }
          }
        }
      }
      return 't4';
    },
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy);
    },
    getData: function getData() {
      var _this2 = this;

      this.getPosUsers();
      var id = this.id || this.route.params.id;

      if (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.company_id
        };
        this.apiRequest('/pos/map/' + id, 'GET', data, function (response) {
          if (response.status) {
            _this2.model = response.data.table_map;
          }
          _this2.loading = false;
          _this2.getTables();
        });
      } else {
        this.getTables();
      }

      this.locations = [];
      var requestData = {
        token: this.$session.get('token'),
        company_id: this.company_id
      };

      this.apiRequest('/get-locations', 'GET', requestData, function (response) {
        if (response.status) {
          _this2.locations = response.data;
        }
        if (!id) {
          _this2.loading = false;
        }
      });

      var data2 = {
        token: this.$session.get('token'),
        company_id: this.company_id
      };
      this.apiRequest('/topcategory', 'GET', data2, function (topCatResp) {
        if (topCatResp.status === true) {
          _this2.topCategories = topCatResp.data;
        }
      });
    },
    getPosUsers: function getPosUsers() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this3.posUsers = response.data.pos_user;
        }
      });
    },
    getTables: function getTables() {
      var _this4 = this;

      this.loadingTable = true;
      this.tables = [];
      if (!this.id) {
        this.model.table_manager_maps = [];
      }
      if (this.model.location_id) {
        var requestData = {
          token: this.$session.get('token'),
          company_id: this.company_id,
          location_id: this.model.location_id
        };

        this.apiRequest('/pos/map/get-tables', 'GET', requestData, function (response) {
          if (response.status) {
            __WEBPACK_IMPORTED_MODULE_11_vue___default.a.set(_this4, 'tables', response.data);
          }
          _this4.loadingTable = false;

          if (_this4.id && _this4.model.table_manager_maps.length > 0) {
            _this4.inferScaleFactorFromData();
          }
        });
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this5 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this5.saveTable();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    saveTable: function saveTable() {
      var _this6 = this;

      this.loadingTable = true;
      this.loading = true;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        'token': this.$session.get('token'),
        'company_id': this.company_id
      }, this.model);

      var id = this.id || this.route.params.id;
      var url = '';
      var request = '';
      if (id) {
        url = '/pos/map/' + id;
        request = 'PUT';
      } else {
        url = '/pos/map/add';
        request = 'POST';
      }
      this.apiRequest(url, request, data, function (response) {
        if (response.status === true) {
          _this6.errors.clear();
          if (request === 'POST') {
            _this6.$bus.$emit('refresh');
            _this6.$bus.$emit('close-modal');
          } else {
            _this6.$bus.$emit('refresh');
            _this6.$bus.$emit('close-modal');
          }
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
            title: '',
            text: _this6.$t('settingTable.tableSave'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          _this6.handleErrors(response.errors);
        }
        _this6.loading = false;
        _this6.loadingTable = false;
      });
    },
    deleteOrderScreen: function deleteOrderScreen() {
      var _this7 = this;

      this.loadingReset = true;
      var id = this.id || this.route.params.id;
      var data = {
        company_id: this.company_id,
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/pos/map/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this7.backButton();
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({ 'text': _this7.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
        _this7.loadingReset = false;
      });
    },
    editTable: function editTable(tableMap, table) {
      if (tableMap) {
        this.selectedTable = tableMap.table_manager_id;
      } else {
        this.selectedTable = table.id;
      }
      this.showTableModal = true;
    },
    closeTableModal: function closeTableModal() {
      this.showTableModal = false;
    },
    tableManagementUpdate: function tableManagementUpdate(respTable, isNew, deletedTableId) {
      this.closeTableModal();
      if (respTable) {
        if (isNew) {
          this.draggingTable = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.draggingTable, respTable);
          respTable.table_maps_id = this.model.id || true;
          this.tables.push(respTable);
          this.onDrop();
        } else {
          var tableIndex = this.tables.findIndex(function (tableFromTables) {
            return tableFromTables.id === respTable.id;
          });

          var isDeletedOnMap = this.model.table_manager_maps.some(function (tm) {
            return tm.table_manager_id === respTable.id && tm.deleted;
          });
          if (isDeletedOnMap) {
            respTable.table_maps_id = 0;
          } else {
            var existingTable = this.tables[tableIndex];
            if (existingTable && existingTable.table_maps_id) {
              respTable.table_maps_id = existingTable.table_maps_id;
            }
          }

          __WEBPACK_IMPORTED_MODULE_11_vue___default.a.set(this.tables, tableIndex, respTable);

          this.updateTableManagerMapsDimensions();
        }
      } else {
        var _tableIndex = this.tables.findIndex(function (tableFromTables) {
          return tableFromTables.id === deletedTableId;
        });
        if (this.tables[_tableIndex].table_maps_id) {
          var tableMapIndex = this.model.table_manager_maps.findIndex(function (tableFromTablesMap) {
            return tableFromTablesMap.table_manager_id === deletedTableId;
          });
          if (tableMapIndex !== -1) {
            this.model.table_manager_maps[tableMapIndex].deleted = true;
            this.validate();
          }
        }
        if (_tableIndex !== -1) {
          this.tables.splice(_tableIndex, 1);
        }
      }
    },
    onUserSubmit: function onUserSubmit() {
      console.log('onUserSubmit');
    },
    onDragObject: function onDragObject(event) {
      this.selectedTable = null;
      var table = {
        id: -1,
        table_maps_id: this.model.id || true,
        isObject: true
      };
      this.draggingTable = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, table, { width: 60, height: 60 });
    },
    onDragStartNew: function onDragStartNew(event) {
      this.selectedTable = null;
      var table = {
        id: 0,
        table_maps_id: this.model.id || true
      };
      this.draggingTable = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, table, { width: 60, height: 60 });
    },
    onDragStart: function onDragStart(event, table) {
      this.draggingTable = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, table, { width: 60, height: 60 });
    },
    onDrop: function onDrop(event) {
      var _this8 = this;

      if (event) {
        this.draggingTable.onDropEvent = event;
      }

      if (!this.draggingTable) {
        return;
      }

      if (this.draggingTable.id !== -1) {
        var existingIndex = this.model.table_manager_maps.findIndex(function (t) {
          return t.table_manager_id === _this8.draggingTable.id;
        });

        if (existingIndex !== -1) {
          var existing = this.model.table_manager_maps[existingIndex];

          existing.deleted = false;

          var _tableToUpdate = this.tables.find(function (t) {
            return t.id === _this8.draggingTable.id;
          });
          if (_tableToUpdate) {
            _tableToUpdate.table_maps_id = this.model.id || true;
          }

          if (this.draggingTable.onDropEvent) {
            var _svgRect = this.$refs.svgMap.getBoundingClientRect();
            var _x = this.draggingTable.onDropEvent.clientX - _svgRect.left;
            var _y = this.draggingTable.onDropEvent.clientY - _svgRect.top;

            existing.draw_data.x = Math.max(0, Math.min(_x, _svgRect.width - existing.draw_data.width));
            existing.draw_data.y = Math.max(0, Math.min(_y, _svgRect.height - existing.draw_data.height));
          }

          this.draggingTable = null;
          this.updateTableManagerMapsDimensions();
          return;
        }
      }

      if (this.draggingTable.isObject) {
        var _svgRect2 = this.$refs.svgMap.getBoundingClientRect();
        var _x2 = this.draggingTable.onDropEvent.clientX - _svgRect2.left;
        var _y2 = this.draggingTable.onDropEvent.clientY - _svgRect2.top;

        var _drawData = {
          x: Math.max(0, Math.min(_x2, _svgRect2.width - this.draggingTable.width)),
          y: Math.max(0, Math.min(_y2, _svgRect2.height - this.draggingTable.height)),
          width: this.draggingTable.width,
          height: this.draggingTable.height,
          rotation: 0
        };

        this.model.table_manager_maps.push({
          id: 0,
          company_id: this.company_id,
          table_manager_id: this.draggingTable.id,
          table_maps_id: this.model.id,
          draw_data: _drawData
        });

        this.draggingTable = null;
        this.updateTableManagerMapsDimensions();
        return;
      }

      if (this.draggingTable.id === 0) {
        this.showTableModal = true;
        return;
      }

      this.draggingTable.table_maps_id = this.model.id || true;
      var tableToUpdate = this.tables.find(function (t) {
        return t.id === _this8.draggingTable.id;
      });
      if (tableToUpdate) {
        tableToUpdate.table_maps_id = this.model.id || true;
      }

      var svgRect = this.$refs.svgMap.getBoundingClientRect();
      var x = this.draggingTable.onDropEvent.clientX - svgRect.left;
      var y = this.draggingTable.onDropEvent.clientY - svgRect.top;

      var drawData = {
        x: Math.max(0, Math.min(x, svgRect.width - this.draggingTable.width)),
        y: Math.max(0, Math.min(y, svgRect.height - this.draggingTable.height)),
        width: this.draggingTable.width,
        height: this.draggingTable.height,
        rotation: 0
      };

      this.model.table_manager_maps.push({
        id: 0,
        company_id: this.company_id,
        table_manager_id: this.draggingTable.id,
        table_maps_id: this.model.id,
        draw_data: drawData
      });

      this.draggingTable = null;
      this.updateTableManagerMapsDimensions();
    },
    updateTableManagerMapsDimensions: function updateTableManagerMapsDimensions() {
      var _this9 = this;

      this.model.table_manager_maps.forEach(function (tableMap) {
        if (tableMap.table_manager_id !== -1) {
          var table = _this9.tables.find(function (t) {
            return t.id === tableMap.table_manager_id;
          });
          if (table) {
            if (table.table_shape === 'round') {
              if (table.max_pers <= 4) {
                tableMap.draw_data.width = 50 * _this9.scaleFactor;
                tableMap.draw_data.height = 50 * _this9.scaleFactor;
              } else {
                tableMap.draw_data.width = 70 * _this9.scaleFactor;
                tableMap.draw_data.height = 70 * _this9.scaleFactor;
              }
            } else {
              if (table.max_pers <= 1) {
                tableMap.draw_data.width = 40 * _this9.scaleFactor;
                tableMap.draw_data.height = 40 * _this9.scaleFactor;
              } else if (table.max_pers <= 2) {
                tableMap.draw_data.width = 50 * _this9.scaleFactor;
                tableMap.draw_data.height = 50 * _this9.scaleFactor;
              } else if (table.max_pers <= 3) {
                tableMap.draw_data.width = 60 * _this9.scaleFactor;
                tableMap.draw_data.height = 60 * _this9.scaleFactor;
              } else if (table.max_pers <= 4) {
                tableMap.draw_data.width = 60 * _this9.scaleFactor;
                tableMap.draw_data.height = 60 * _this9.scaleFactor;
              } else if (table.max_pers <= 5) {
                tableMap.draw_data.width = 90 * _this9.scaleFactor;
                tableMap.draw_data.height = 60 * _this9.scaleFactor;
              } else if (table.max_pers <= 6) {
                tableMap.draw_data.width = 90 * _this9.scaleFactor;
                tableMap.draw_data.height = 60 * _this9.scaleFactor;
              } else if (table.max_pers <= 7) {
                tableMap.draw_data.width = 100 * _this9.scaleFactor;
                tableMap.draw_data.height = 60 * _this9.scaleFactor;
              } else if (table.max_pers <= 8) {
                tableMap.draw_data.width = 100 * _this9.scaleFactor;
                tableMap.draw_data.height = 60 * _this9.scaleFactor;
              } else if (table.max_pers <= 9) {
                tableMap.draw_data.width = 120 * _this9.scaleFactor;
                tableMap.draw_data.height = 60 * _this9.scaleFactor;
              } else if (table.max_pers <= 10) {
                tableMap.draw_data.width = 140 * _this9.scaleFactor;
                tableMap.draw_data.height = 60 * _this9.scaleFactor;
              } else if (table.max_pers <= 11) {
                tableMap.draw_data.width = 180 * _this9.scaleFactor;
                tableMap.draw_data.height = 60 * _this9.scaleFactor;
              } else if (table.max_pers >= 12) {
                tableMap.draw_data.width = 180 * _this9.scaleFactor;
                tableMap.draw_data.height = 60 * _this9.scaleFactor;
              }
            }
          } else {
            tableMap.draw_data.width = 60 * _this9.scaleFactor;
            tableMap.draw_data.height = 60 * _this9.scaleFactor;
          }
        } else {}
      });
    },
    inferScaleFactorFromData: function inferScaleFactorFromData() {
      var firstTableMap = this.model.table_manager_maps.find(function (t) {
        return t.table_manager_id !== -1 && !t.deleted && t.draw_data && t.draw_data.width > 0;
      });

      if (!firstTableMap) {
        this.scaleFactor = 1;
        return;
      }

      var width = firstTableMap.draw_data.width;
      var table = this.tables.find(function (t) {
        return t.id === firstTableMap.table_manager_id;
      });

      if (!table) {
        this.scaleFactor = 1;
        return;
      }

      if (table.table_shape === 'round') {
        if (table.max_pers <= 4) {
          this.scaleFactor = width / 50;
        } else {
          this.scaleFactor = width / 70;
        }
      } else {
        if (table.max_pers <= 1) {
          this.scaleFactor = width / 40;
        } else if (table.max_pers <= 2) {
          this.scaleFactor = width / 50;
        } else if (table.max_pers <= 4) {
          this.scaleFactor = width / 60;
        } else if (table.max_pers <= 6) {
          this.scaleFactor = width / 90;
        } else if (table.max_pers <= 8) {
          this.scaleFactor = width / 100;
        } else if (table.max_pers <= 10) {
          this.scaleFactor = width / 140;
        } else {
          this.scaleFactor = width / 180;
        }
      }

      this.scaleFactor = Math.max(0.5, Math.min(1.5, this.scaleFactor));
    },
    selectTable: function selectTable(index, event) {
      this.selectedTableIndex = index;
      var table = this.model.table_manager_maps[index];
      var svgRect = this.$refs.svgMap.getBoundingClientRect();

      this.offset.x = event.clientX - svgRect.left - (table.draw_data.x + table.draw_data.width / 2);
      this.offset.y = event.clientY - svgRect.top - (table.draw_data.y + table.draw_data.height / 2);
    },
    updateTablePosition: function updateTablePosition(event) {
      var _this10 = this;

      if (this.selectedTableIndex !== null && !this.resizing) {
        var table = this.model.table_manager_maps[this.selectedTableIndex];
        var svgRect = this.$refs.svgMap.getBoundingClientRect();

        var newX = event.clientX - svgRect.left - this.offset.x - table.draw_data.width / 2;
        var newY = event.clientY - svgRect.top - this.offset.y - table.draw_data.height / 2;

        newX = Math.max(0, Math.min(newX, svgRect.width - table.draw_data.width));
        newY = Math.max(0, Math.min(newY, svgRect.height - table.draw_data.height));

        var isOverlapping = this.model.table_manager_maps.some(function (otherTable, index) {
          if (index === _this10.selectedTableIndex) return false;
          if (otherTable.deleted) return false;

          var otherDrawData = otherTable.draw_data;
          return !(newX + table.draw_data.width <= otherDrawData.x || newX >= otherDrawData.x + otherDrawData.width || newY + table.draw_data.height <= otherDrawData.y || newY >= otherDrawData.y + otherDrawData.height);
        });

        if (!isOverlapping) {
          table.draw_data.x = newX;
          table.draw_data.y = newY;
        }
      }
    },
    startResize: function startResize(index) {
      this.selectedTableIndex = index;
      this.resizing = true;
    },
    resizeTable: function resizeTable(event) {
      if (this.selectedTableIndex !== null && this.resizing) {
        var table = this.model.table_manager_maps[this.selectedTableIndex];
        var svgRect = this.$refs.svgMap.getBoundingClientRect();
        var mouseX = event.clientX - svgRect.left;
        var mouseY = event.clientY - svgRect.top;

        var newWidth = Math.max(20, mouseX - table.draw_data.x);
        var newHeight = Math.max(20, mouseY - table.draw_data.y);

        if (table.draw_data.x + newWidth > svgRect.width) {
          newWidth = svgRect.width - table.draw_data.x;
        }
        if (table.draw_data.y + newHeight > svgRect.height) {
          newHeight = svgRect.height - table.draw_data.y;
        }

        newWidth = Math.min(newWidth, 300);
        newHeight = Math.min(newHeight, 300);

        table.draw_data.width = newWidth;
        table.draw_data.height = newHeight;
      }
    },
    endResize: function endResize() {
      this.resizing = false;
    },
    rotateTable: function rotateTable(index, angle) {
      var table = this.model.table_manager_maps[index];
      table.draw_data.rotation += angle;
    },
    deleteTable: function deleteTable(index, tableId) {
      if (this.model.table_manager_maps[index].table_manager_id !== -1) {
        this.model.table_manager_maps[index].deleted = true;
        var tableToDelete = this.tables.find(function (t) {
          return t.id === tableId;
        });
        if (tableToDelete) {
          tableToDelete.table_maps_id = 0;
        }
      } else {
        if (this.model.id) {
          var tab = this.model.table_manager_maps[index];
          tab.deleted = true;

          __WEBPACK_IMPORTED_MODULE_11_vue___default.a.set(this.model.table_manager_maps, index, tab);
        } else {
          this.model.table_manager_maps.splice(index, 1);
        }
      }
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "/VMh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_GLOVO_LAAS_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_GLOVO_LAAS_POS_IMPLEMENTATION_NAME; });
/* unused harmony export GLOVO_LAAS_AUTO_SEND_STATUS_VALUES */
/* unused harmony export GLOVO_LAAS_AUTO_SEND_TIME_VALUES */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Integrations_WoltDriveIntegrationForm_vue__ = __webpack_require__("VamX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__ = __webpack_require__("3z7E");





var DEFAULT_GLOVO_LAAS_API_URL = 'https://api.glovoapp.com';
var DEFAULT_GLOVO_LAAS_POS_IMPLEMENTATION_NAME = 'taptasty';

var GLOVO_LAAS_AUTO_SEND_STATUS_VALUES = __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Integrations_WoltDriveIntegrationForm_vue__["b" /* WOLT_DRIVE_AUTO_SEND_STATUS_VALUES */];
var GLOVO_LAAS_AUTO_SEND_TIME_VALUES = __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Integrations_WoltDriveIntegrationForm_vue__["c" /* WOLT_DRIVE_AUTO_SEND_TIME_VALUES */];

/* harmony default export */ __webpack_exports__["c"] = ({
  name: 'GlovoLaasIntegrationForm',
  props: {
    formData: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    requiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    validationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showFieldValidation: {
      type: Boolean,
      default: false
    },
    occupiedLocationIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isCreateMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    autoSendStatusOptions: function autoSendStatusOptions() {
      var _this = this;

      return GLOVO_LAAS_AUTO_SEND_STATUS_VALUES.map(function (value) {
        return {
          value: value,
          label: _this.autoSendStatusLabel(value)
        };
      });
    },
    autoSendTimeOptions: function autoSendTimeOptions() {
      return GLOVO_LAAS_AUTO_SEND_TIME_VALUES.slice();
    },
    isAutoSendManual: function isAutoSendManual() {
      return String(this.formData.auto_send_at_status || '').toUpperCase() === 'MANUAL';
    }
  },
  created: function created() {
    this.ensureDefaults();
  },

  methods: {
    fieldLabel: function fieldLabel(field) {
      if (typeof this.fieldLabelFn === 'function') return this.fieldLabelFn(field);
      return field;
    },
    isRequired: function isRequired(field) {
      return (this.requiredFields || []).includes(field);
    },
    hasFieldError: function hasFieldError(field) {
      return Boolean(this.validationErrors && this.validationErrors[field]);
    },
    showFieldError: function showFieldError(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["a" /* hasIntegrationFieldError */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData
      });
    },
    fieldErrorMessage: function fieldErrorMessage(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["b" /* getIntegrationFieldErrorMessage */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData,
        requiredMessage: this.$t('validations.requiredField')
      });
    },
    isLocationOccupied: function isLocationOccupied(locationId) {
      if (locationId == null || locationId === '') return false;
      return (this.occupiedLocationIds || []).map(String).includes(String(locationId));
    },
    locationOptionLabel: function locationOptionLabel(loc) {
      var name = loc && loc.name ? loc.name : '';
      if (this.isLocationOccupied(loc._integrationLocationId)) {
        return name + ' (' + this.$t('gestiune.integrationsLocationOccupied') + ')';
      }
      return name;
    },
    autoSendStatusLabel: function autoSendStatusLabel(value) {
      var key = 'gestiune.woltDriveAutoSendStatus_' + String(value || '').toLowerCase();
      var translated = this.$t(key);
      return translated !== key ? translated : String(value || '');
    },
    ensureDefaults: function ensureDefaults() {
      var url = this.formData.api_url;
      if (url === undefined || url === null || String(url).trim() === '') {
        this.$set(this.formData, 'api_url', DEFAULT_GLOVO_LAAS_API_URL);
      }

      var posName = this.formData.pos_implementation_name;
      if (posName === undefined || posName === null || String(posName).trim() === '') {
        this.$set(this.formData, 'pos_implementation_name', DEFAULT_GLOVO_LAAS_POS_IMPLEMENTATION_NAME);
      }

      var status = this.formData.auto_send_at_status;
      status = status === undefined || status === null || String(status).trim() === '' ? '' : String(status).trim().toUpperCase();
      if (!status || !GLOVO_LAAS_AUTO_SEND_STATUS_VALUES.includes(status)) {
        status = 'MANUAL';
      }
      this.$set(this.formData, 'auto_send_at_status', status);

      var time = this.formData.auto_send_time;
      time = time === null || time === undefined || String(time).trim() === '' ? '' : String(parseInt(String(time).trim(), 10));
      if (!time || !GLOVO_LAAS_AUTO_SEND_TIME_VALUES.includes(time)) {
        time = '30';
      }
      this.$set(this.formData, 'auto_send_time', time);
    }
  }
});

/***/ }),

/***/ "/ZwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css__);







/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.initPage();

    this.fidelitiesLabelsPrimaryOption = this.$session.get('selectedCompanyData').fidelities_labels_primary_option;

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      tableData: [],
      isNew: false,
      showLocations: false,
      fidelitiesLabelsPrimaryOption: null,
      model: {
        name: '',
        orderValue: null,
        orderNumbers: null,
        color: '',
        notification: '',
        coupon: '',
        productId: null,
        recurrence: 0,
        user_notification: '',
        showError: false
      },
      colors: {
        red: '#f7786b',
        green: '#d9ecd0',
        blue: '#92a8d1',
        yellow: '#ffef96',
        orange: 'orange',
        pink: '#eca1a6',
        aqua: '#80ced6',
        navy: 'navy',
        maroon: 'maroon',
        olive: 'olive',
        white: 'white',
        grey: '#888888',
        black: 'black'
      },
      locations: [],
      products: [],
      modelValidations: {
        name: {
          required: true,
          min: 3
        },
        color: {
          required: true
        }
      },
      orderValNumOnCreate: false,
      labelsPrimaryOption: null,
      labelsInterval: null,
      fidelitiesOptions: [],
      fidelitiesIntervalOptions: [],
      fidelitiesReccurenceOptions: [],
      showLabel: null,
      enableLabelNotification: null,
      currency: null
    };
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.initPage();
    },
    initPage: function initPage() {
      var _this = this;

      this.getUserLabeling();

      var companyData = this.$session.get('selectedCompanyData');
      this.locations = companyData.locations_details;

      var data = {
        token: this.$session.get('token')
      };

      var companyID = this.$session.get('selectedCompany');
      var currency = companyData.price_details;
      if (currency !== undefined) {
        this.currency = this.decodeHtml(currency.symbol);
      }

      this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response) {
        if (response.status === true) {
          _this.$nextTick(function () {
            _this.loading = false;
            _this.showLabel = !!response.data[0].show_userlabel;
            _this.enableLabelNotification = !!response.data[0].enable_label_notification;
          });
        }
      });
    },
    goToRecord: function goToRecord(row, event, column) {
      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/user-label/edit/');
      }
    },
    goToAdd: function goToAdd() {
      this.$router.push('/user-label/add');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getUserLabeling: function getUserLabeling() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/userlabeling', 'GET', data, function (response) {
        if (response.status === true) {
          var dataWithError = response.data.items.map(function (value) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, value, {
              showError: false
            });
          });
          _this2.tableData = dataWithError;
          _this2.fidelitiesOptions = response.data.fidelities_options;
          _this2.fidelitiesIntervalOptions = response.data.fidelities_intervals;
          _this2.labelsInterval = response.data.fidelities_labels_interval;
          _this2.labelsPrimaryOption = response.data.fidelities_labels_primary_option;
          _this2.fidelitiesReccurenceOptions = response.data.fidelities_recurrences;
        }
        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'fidelities_labels_primary_option': this.labelsPrimaryOption,
        'enable_label_notification': this.enableLabelNotification,
        'fidelities_labels_interval': this.labelsInterval,
        'show_userlabel': this.showLabel
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({ 'text': self.$t('marketingFidelities.labelingSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          self.$session.set('selectedCompanyData', self.buildCompanySessionData(response.data[0]));
          if (response.data[0]) {
            self.fidelitiesLabelsPrimaryOption = response.data[0].fidelities_labels_primary_option;
          }
        } else {
          self.handleErrors(response.errors);
        }
      });
    },
    handleDelete: function handleDelete(item) {
      var _this3 = this;

      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        text: this.$t('marketingFidelities.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            id: item,
            token: _this3.$session.get('token'),
            company_id: _this3.$session.get('selectedCompany')
          };
          _this3.apiRequest('/userlabeling/' + item, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()('', _this3.$t('marketingFidelities.labelDeleted'), 'success');
              _this3.getUserLabeling();
            } else {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : _this3.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function (err) {
        if (err) {}
      });
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.disableConfirmButton();
      var yes = this.$t('general.yes');
      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          if (__WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.getConfirmButton().textContent = yes + ' (' + btnCounter + ')';
          }
        } else {
          if (__WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.getConfirmButton().textContent = yes;
          }
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    validate: function validate() {
      var _this4 = this;

      this.errors['items'] = this.removeErrorByName('error', this.errors['items']);
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this4.handleCreate();
        } else {}
      });
    },
    checkValueOrNumber: function checkValueOrNumber(item) {
      if (item) {
        item.showError = false;
      } else {
        this.model.showError = false;
      }
    }
  }
});

/***/ }),

/***/ "/bpg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/goY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_select__);











var _components;








__WEBPACK_IMPORTED_MODULE_10_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_15_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    defaultData: {},
    modeldata: {},
    taxesData: {}
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },
    modeldata: function modeldata(value) {
      this.model = value;
    },
    taxesData: function taxesData(value) {
      this.taxes = value;
    }
  },
  data: function data() {
    return {
      model: this.value || this.modeldata,
      defaults: this.value || this.defaultData,
      taxes: this.value || this.taxesData
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vee_validate__["b" /* mapFields */])(['title', 'description'])),
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop][0]);
        }
      }
    },
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'tips_taxes': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model.tips_taxes)
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({ 'text': self.$t('settingsTips.tipsSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          self.$session.set('selectedCompanyData', self.buildCompanySessionData(response.data[0]));
        } else {
          self.handleErrors(response.errors);
        }
      });
    },
    handleActive: function handleActive(e) {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'tips_in_use': this.model.tips_in_use ? 1 : 0
      };
      if (data['tips_in_use'] === 1) {
        this.$session.set('tips_use', true);
      } else {
        this.$session.set('tips_use', false);
      }

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({ 'text': self.$t('settingsTips.tipsSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          self.handleErrors(response.errors);
          self.model.tips_in_use = !self.model.tips_in_use;
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validationa.wentWrong'), 'error');
        }
      });
    }
  }
});

/***/ }),

/***/ "/hhg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('product-form',{attrs:{"productData":_vm.productData,"mainCategoriesParent":_vm.mainCategories,"taxesParent":_vm.taxes,"kdsSectionsParent":_vm.kdsSections,"productOptionsParent":_vm.productOptions,"companyProductFilters":_vm.companyProductFilters,"measurementsUnits":_vm.measurementsUnits,"language":_vm.language,"languages":_vm.languages,"route":_vm.route},on:{"on-submit":_vm.onProductSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/kOV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card mar-to-15",staticStyle:{"display":"none"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.selfOrderDomain')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.self_order_domain),expression:"model.self_order_domain"}],staticClass:"form-control",attrs:{"type":"text","name":"appLink","placeholder":_vm.$t('settingCompany.selfOrderDomain')},domProps:{"value":(_vm.model.self_order_domain)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "self_order_domain", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Kiosk/Table Colors")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.table_colors),expression:"model.table_colors"}],staticClass:"form-control",attrs:{"type":"text","name":"appLink","placeholder":_vm.$t('settingCompany.selfOrderDomain')},domProps:{"value":(_vm.model.table_colors)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "table_colors", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("{\"sideBarBg\": \"#fff\", \"mainPageBg\": \"#F1F1F1\", \"addBtnColor\": \"#ffca40\", \"addBtnColorInv\": \"#000\", \"iconsColor1\": \"#942007\", \"iconsColor2\": \"#fff\", \"secundarColor\": \"#ffca40\", \"principalColor\": \"#4D966D\"}")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Imagine bg transparent Kiosk")]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.kiosk_transparent_bg ? _vm.model.kiosk_transparent_bg : [],"list-type":"picture-card","accept":".jpg, .jpeg, .png","on-change":function (file,fileList) {return _vm.handleImgChnage(file,fileList,_vm.index)},"on-exceed":_vm.handleExceed,"on-remove":function (file,fileList) {return _vm.handleRemove(file,fileList,_vm.index)},"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info mar-rt-10",on:{"click":function($event){_vm.deleteCacheFromKiosk()}}},[_vm._v("Delete Cache For Kiosks")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info mar-rt-10",on:{"click":function($event){_vm.restartAllKiosk()}}},[_vm._v("Restart all Kiosks")])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.appLink')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.app_link),expression:"model.app_link"}],staticClass:"form-control",attrs:{"type":"text","name":"appLink","placeholder":_vm.$t('settingCompany.appLink')},domProps:{"value":(_vm.model.app_link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "app_link", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.appLinkAndroid')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.app_android),expression:"model.app_android"}],staticClass:"form-control",attrs:{"type":"text","name":"appLinkAndroid","placeholder":_vm.$t('settingCompany.appLinkAndroid')},domProps:{"value":(_vm.model.app_android)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "app_android", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.appLinkIos')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.app_ios),expression:"model.app_ios"}],staticClass:"form-control",attrs:{"type":"text","name":"appLinkIos","placeholder":_vm.$t('settingCompany.appLinkIos')},domProps:{"value":(_vm.model.app_ios)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "app_ios", $event.target.value)}}})])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/l4D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractiveTour_vue__ = __webpack_require__("xUte");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9ebf816_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InteractiveTour_vue__ = __webpack_require__("+xaX");
function injectStyle (ssrContext) {
  __webpack_require__("bEDA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a9ebf816"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InteractiveTour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9ebf816_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InteractiveTour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/lhP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isCompanyLocations },on:{"click":function($event){_vm.openTab('companyLocations')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.companyLocations')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isLocationGroups },on:{"click":function($event){_vm.openTab('locationGroups')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.locationGroups')))])])])])]),_vm._v(" "),(_vm.isCompanyLocations)?_c('div',[_c('locations',{on:{"setSelectedTab":_vm.setSelectedTab}})],1):_vm._e(),_vm._v(" "),(_vm.isLocationGroups)?_c('div',[(_vm.selectedLocationGroups !== false)?[_c('location-groups-form',{attrs:{"callback":_vm.updateLocationGroups,"locId":_vm.selectedLocationGroups}})]:[_c('location-groups',{ref:"LocationGroups",attrs:{"isLocationGroups":_vm.isLocationGroups,"callback":_vm.getLocationGroups}})]],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/mYi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/mvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CategoryForm_vue__ = __webpack_require__("vCTZ");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CategoryForm', __WEBPACK_IMPORTED_MODULE_7__CategoryForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      categoryModel: {},
      category: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onCategorySubmit: function onCategorySubmit(model, isValid) {
      this.categoryModel = model;
    }
  }
});

/***/ }),

/***/ "/nKj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PricelistFieldsForm',
  props: {
    fieldNames: {
      type: Array,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    formText: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    booleanFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    jsonFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    jsonHint: {
      type: String,
      default: ''
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    readOnlyFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    booleanSet: function booleanSet() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.booleanFields || []);
    },
    jsonSet: function jsonSet() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.jsonFields || []);
    },
    readOnlySet: function readOnlySet() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.readOnlyFields || []);
    }
  },
  methods: {
    fieldLabel: function fieldLabel(field) {
      if (typeof this.fieldLabelFn === 'function') return this.fieldLabelFn(field);
      return field;
    },
    fieldDisabled: function fieldDisabled(field) {
      return this.disabled || this.readOnlySet.has(field);
    },
    isBooleanField: function isBooleanField(field) {
      return this.booleanSet.has(field);
    },
    isJsonField: function isJsonField(field) {
      return this.jsonSet.has(field);
    },
    onBoolChange: function onBoolChange(field, checked) {
      this.$set(this.formData, field, checked);
    },
    onTextInput: function onTextInput(field, value) {
      this.$set(this.formData, field, value);
    },
    onJsonInput: function onJsonInput(field, value) {
      this.$set(this.formText, field, value);
    }
  }
});

/***/ }),

/***/ "/oG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LocationGroupsForm_vue__ = __webpack_require__("s1f/");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LocationGroupsForm: __WEBPACK_IMPORTED_MODULE_0__LocationGroupsForm_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  props: {
    editData: {
      required: false,
      type: Object
    },
    openModal: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    openModal: function openModal() {
      this.openAddLocationGroupModal();
    }
  },
  methods: {
    handleNewLocationGroup: function handleNewLocationGroup(newGroup) {
      if (!this.editData) {
        this.$emit('new-group', newGroup);
      } else if (this.editData && newGroup && this.editData.parent_id !== newGroup.parent_id) {
        if (this.editData.location_ids !== newGroup.location_ids) {
          newGroup.location_ids = null;
        }
        this.$emit('new-group', newGroup);
        this.$emit('delete-group', this.editData);
      }
      if (this.editData && this.editData.image !== newGroup.image) {
        this.$emit('edit-group', newGroup);
      }
      this.hideAddLocationGroupModal();
    },
    openAddLocationGroupModal: function openAddLocationGroupModal() {
      this.$modal.show('addEditLocationGroupModal');
    },
    hideAddLocationGroupModal: function hideAddLocationGroupModal() {
      var deletedGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (deletedGroup) {
        this.$emit('delete-group', deletedGroup);
      }
      this.$modal.hide('addEditLocationGroupModal');
    }
  }
});

/***/ }),

/***/ "/of0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__);











var _components;










__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */],

    PSwitch: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'draggable', __WEBPACK_IMPORTED_MODULE_12_vuedraggable___default.a), _components),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    },
    isTable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.token = this.$session.get('token');
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      loading2: true,
      token: null,
      apiUrl: null,
      optionData: []
    };
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/product-option/edit/');
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/get-company-options', 'GET', data, function (response) {
        if (response.status === true) {
          _this.optionData = response.data.options;

          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    },
    handleActive: function handleActive(item) {
      var _this2 = this;

      this.loading = true;
      var id = item.id;
      var data = {};
      var companyID = this.$session.get('selectedCompany');
      data.token = this.$session.get('token');
      data.company_id = companyID;
      data.option = {
        id: item.id,
        active: item.active
      };
      this.apiRequest('/save-option/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          _this2.loading = false;
          _this2.errors.clear();
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ 'text': _this2.$t('menuLink.updated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          _this2.loading = false;
        }
      });
    },
    adjustSort: function adjustSort() {}
  }
});

/***/ }),

/***/ "/pMg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"report-filters"},[_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left date-range"},[_c('el-date-picker',{staticClass:"mid",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.clients.valid),callback:function ($$v) {_vm.$set(_vm.clients, "valid", $$v)},expression:"clients.valid"}})],1),_vm._v(" "),(_vm.showLocations)?_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left "},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selecteLocationId),expression:"selecteLocationId"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selecteLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.true_id}},[_vm._v(_vm._s(loc.name))])]})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-info btn-print",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData(null)}}},[_c('i',{staticClass:"ti-file"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/s2G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/srY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t8_vue__ = __webpack_require__("9r3a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c51eb1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t8_vue__ = __webpack_require__("+DUu");
function injectStyle (ssrContext) {
  __webpack_require__("MtLy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c51eb1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t8_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c51eb1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t8_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/yjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);











var _components;






__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a), _components),
  props: {
    defaultData: {},
    modeldata: {},
    locations: {}
  },
  watch: {
    modeldata: {
      immediate: true,
      handler: function handler(value) {
        if (!value || !value.length) {
          return;
        }
        this.model = value;
        this.savedLocations = this.copyVar(this.locations);
        this.checkIfHasMutipleLocationAvailable();
        this.setUpBits(value);
        this.setUpCustomBits();
      }
    },
    defaultData: {
      immediate: true,
      handler: function handler(value) {
        if (!value || !value.length) {
          return;
        }
        this.defaults = value;
        this.setUpLoyaltyPointsBits(value);
        this.setUpCustomBits();
      }
    },
    locations: {
      immediate: true,
      handler: function handler(value) {
        if (!value) {
          return;
        }
        this.savedLocations = this.copyVar(value);
        this.checkIfHasMutipleLocationAvailable();
      }
    }
  },
  data: function data() {
    return {
      savedLocations: [],
      showIfHasMultipleLocation: {
        'DELIVERY': false,
        'PICK_UP': false,
        'MEET_HALF': false,
        'EAT_LOCATION': false,
        'LOYALTY_POINTS': true
      },
      labels: {
        'order_new': this.$t('settingsPushNotif.order_new'),
        'order_completed_pickup': this.$t('settingsPushNotif.order_completed_pickup'),
        'order_completed_meet': this.$t('settingsPushNotif.order_completed_meet'),
        'order_completed_delivery': this.$t('settingsPushNotif.order_completed_delivery'),
        'order_completed_eat': this.$t('settingsPushNotif.order_completed_eat'),
        'order_canceled': this.$t('settingsPushNotif.order_canceled')
      },
      model: this.value || this.modeldata,
      defaults: this.value || this.defaultData,
      modelValidations: {
        text: { required: true }
      },
      customModelValidations: {
        text: { required: true },
        select: { required: true }
      },
      parameters: ['{time}', '{date_time}', '{persons_number}'],
      notifBits: {
        'DELIVERY': {
          'PROCESSING': ['', '']
        },
        'PICK_UP': {
          'PROCESSING': ['', '']
        },
        'MEET_HALF': {
          'PROCESSING': ['', '']
        },
        'EAT_LOCATION': {
          'DELIVERED': ['', '', '']
        }
      },
      notifLoyaltyPoints: {
        'LOYALTY_POINTS': {
          'DELIVERED': ['', '', '']
        }
      },
      customNotifications: [],
      customLoyaltyPointsNotifications: [],
      currency: this.$session.get('selectedCompanyData')['currency_iso'],
      loyalty_value_one_point: '',
      loyalty_value_one_point_amount: ''
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  created: function created() {
    this.getAndSaveNotif();
    this.loyalty_value_one_point_amount = Math.round(this.$session.get('selectedCompanyData').loyalty_value_one_point_amount * 10) / 10;
    this.loyalty_value_one_point = this.$session.get('selectedCompanyData').loyalty_value_one_point;
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validate('validateDefault').then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    validateSingleSection: function validateSingleSection(sectionName, id, type) {
      var _this2 = this;

      this.$validator.validate(sectionName).then(function (isValid) {
        if (isValid) {
          _this2.saveBox(id, type);
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop][0]);
        }
      }
    },
    setUpBits: function setUpBits(model) {
      for (var idx in model) {
        var notif = model[idx];
        for (var notifIdx in notif.messages) {
          var message = notif.messages[notifIdx];
          if (message.status === 'PROCESSING' || message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION') {
            var bits = this.getBits(message.message || '', notif.delivery_type);
            if (!this.notifBits[notif.delivery_type]) {
              __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.notifBits, notif.delivery_type, {});
            }
            __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.notifBits[notif.delivery_type], message.status, bits);
          }
        }
      }
    },
    setUpLoyaltyPointsBits: function setUpLoyaltyPointsBits() {
      var bits = this.getLoyaltyPointsBits();
      this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED'] = bits;
    },
    setUpCustomBits: function setUpCustomBits() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.customNotifications), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var notif = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(notif.message), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var message = _step2.value;

              if (message.status.toUpperCase() === 'PROCESSING' || message.status.toUpperCase() === 'DELIVERED' && notif.delivery_type.toUpperCase() === 'EAT_LOCATION' || message.status.toUpperCase() === 'DELIVERED' && notif.delivery_type.toUpperCase() === 'LOYALTY_POINTS') {
                var bits = this.getBits(message.message, notif.delivery_type.toUpperCase());
                __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(notif, 'bits', bits);
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    setCustomLoyaltyPointsNotifications: function setCustomLoyaltyPointsNotifications() {
      if (this.customNotifications) {
        var result = null;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.customNotifications), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var element = _step3.value;

            if (element.delivery_type === 'loyalty_points') {
              result = element;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        this.customLoyaltyPointsNotifications[0] = result;
      }
    },
    setUpCustomLoyaltyPointsBits: function setUpCustomLoyaltyPointsBits() {
      var bits = this.getLoyaltyPointsBits();
      __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.customLoyaltyPointsNotifications[0], 'bits', bits);
    },
    getBits: function getBits(message, type) {
      var bits = '';
      switch (type) {
        case 'LOYALTY_POINTS':
          bits = message.split('{gainedPoints}');
          if (bits.length < 2) {
            bits.push(' ');
            bits.push(' ');
            return bits;
          } else {
            var bits2 = bits[1].split('{worth}');
            if (bits2.length < 2) {
              bits2.push(' ');
            }
            bits[1] = bits2[0];
            bits[2] = bits2[1];
          }
          return bits;
        case 'EAT_LOCATION':
          bits = message.split('{persons_number}');
          if (bits.length < 2) {
            bits.push(' ');
            bits.push(' ');
            return bits;
          } else {
            var _bits = bits[1].split('{date_time}');
            if (_bits.length < 2) {
              _bits.push(' ');
            }
            bits[1] = _bits[0];
            bits[2] = _bits[1];
          }
          return bits;
        default:
          var bitsDef = String(message || '').split('{time}');
          if (bitsDef.length < 2) {
            bitsDef.push(' ');
          }
          return bitsDef;
      }
    },
    getLoyaltyPointsBits: function getLoyaltyPointsBits() {
      if (this.customLoyaltyPointsNotifications && this.customLoyaltyPointsNotifications.bits) {
        return this.customLoyaltyPointsNotifications.bits;
      } else {
        var message = this.defaults[0]['messages'][0]['message'];
        var bits = '';
        bits = message.split('{gainedPoints}');
        if (bits.length < 2) {
          bits.push(' ');
          bits.push(' ');
          return bits;
        } else {
          var bits2 = bits[1].split('{worth}');
          if (bits2.length < 2) {
            bits2.push(' ');
          }
          bits[1] = bits2[0];
          bits[2] = bits2[1];
        }
        return bits;
      }
    },
    getMsgFromBits: function getMsgFromBits(type, status) {
      var bits = this.notifBits[type][status];
      switch (type) {
        case 'EAT_LOCATION':
          return bits[0] + '{persons_number}' + bits[1] + '{date_time}' + bits[2];
        case 'LOYALTY_POINTS':
          return bits[0] + '{gainedPoints}' + bits[1] + '{worth}' + bits[2];
        default:
          if (bits[1] === '' || bits[1] === ' ') {
            return bits[0];
          }
          return bits[0] + '{time}' + bits[1];
      }
    },
    saveBox: function saveBox(id, type) {
      var forSave = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.customNotifications), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var notiff = _step4.value;

          if (notiff.delivery_type === type && notiff.id === id) {
            forSave.push(notiff);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(forSave), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var notif = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(notif.message), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var message = _step6.value;

              if (message.status.toUpperCase() === 'PROCESSING' || message.status.toUpperCase() === 'DELIVERED' && notif.delivery_type.toUpperCase() === 'EAT_LOCATION' || notif.delivery_type.toUpperCase() === 'LOYALTY_POINTS') {
                switch (notif.delivery_type.toUpperCase()) {
                  case 'EAT_LOCATION':
                    message.message = notif.bits[0] + '{persons_number}' + notif.bits[1] + '{date_time}' + notif.bits[2];
                    break;
                  case 'LOYALTY_POINTS':
                    message.message = notif.bits[0] + '{gainedPoints}' + notif.bits[1] + '{worth}' + notif.bits[2];
                    break;
                  default:
                    if (notif.bits[1] === '' || notif.bits[1] === ' ') {
                      message.message = notif.bits[0];
                    } else {
                      message.message = notif.bits[0] + '{time}' + notif.bits[1];
                    }
                    break;
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.getAndSaveNotif(forSave);
    },
    getAndSaveNotif: function getAndSaveNotif() {
      var _this3 = this;

      var saveNotif = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany'),
        'push_notifications': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(saveNotif)
      };
      this.apiRequest('/settings/notif', 'POST', data, function (response) {
        if (response.success === true) {
          _this3.customNotifications = response.data;
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this3.customNotifications), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var not = _step7.value;

              not.location_ids = JSON.parse(not.location_ids);
              not.message = JSON.parse(not.message);
              var _iteratorNormalCompletion8 = true;
              var _didIteratorError8 = false;
              var _iteratorError8 = undefined;

              try {
                for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(not.location_ids), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                  var locid = _step8.value;
                  var _iteratorNormalCompletion9 = true;
                  var _didIteratorError9 = false;
                  var _iteratorError9 = undefined;

                  try {
                    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this3.savedLocations), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                      var loc = _step9.value;

                      if (locid === loc.id) {
                        var _iteratorNormalCompletion10 = true;
                        var _didIteratorError10 = false;
                        var _iteratorError10 = undefined;

                        try {
                          for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(loc.ordering_management), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                            var ord = _step10.value;

                            if (not.delivery_type === ord.type) {
                              ord.notifSelected = true;
                            }
                          }
                        } catch (err) {
                          _didIteratorError10 = true;
                          _iteratorError10 = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion10 && _iterator10.return) {
                              _iterator10.return();
                            }
                          } finally {
                            if (_didIteratorError10) {
                              throw _iteratorError10;
                            }
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError9 = true;
                    _iteratorError9 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                      }
                    } finally {
                      if (_didIteratorError9) {
                        throw _iteratorError9;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                  }
                } finally {
                  if (_didIteratorError8) {
                    throw _iteratorError8;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          _this3.setCustomLoyaltyPointsNotifications();
          _this3.$nextTick(function () {
            _this3.checkIfHasMutipleLocationAvailable();
            _this3.setUpCustomBits();
          });
        }
      });
    },
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');

      for (var idx in this.model) {
        var notif = this.model[idx];
        for (var notifIdx in notif.messages) {
          var message = notif.messages[notifIdx];
          if (message.status === 'PROCESSING' || message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION') {
            this.model[idx].messages[notifIdx].message = this.getMsgFromBits(notif.delivery_type, message.status);
          }
        }
      }

      var data = {
        'token': this.$session.get('token'),
        'push_notifications': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model)
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          self.errors.clear();
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': self.$t('settingsPushNotif.notifUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch({});
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': self.$t('validationa.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch({});
        }
      });
    },
    setUpMessageLoyaltyPoints: function setUpMessageLoyaltyPoints() {
      var message = '';
      if (this.customLoyaltyPointsNotifications[0]) {
        message = this.customLoyaltyPointsNotifications[0]['bits'][0] + ' {gainedPoints} ' + this.customLoyaltyPointsNotifications[0]['bits'][1];
        if (this.customLoyaltyPointsNotifications[0]['bits'][2].trim().length > 0) {
          message = message + ' {worth} ' + this.customLoyaltyPointsNotifications[0]['bits'][2];
        }
        return message;
      }

      if (this.notifLoyaltyPoints && this.notifLoyaltyPoints['LOYALTY_POINTS'] && this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED']) {
        message = this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED'][0] + ' {gainedPoints} ' + this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED'][1];
        if (this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED'][2].trim().length > 0) {
          message = message + ' {worth} ' + this.notifLoyaltyPoints['LOYALTY_POINTS']['DELIVERED'][2];
        }
        return message;
      }
    },
    saveLoyaltyPointsNotification: function saveLoyaltyPointsNotification() {
      var _this4 = this;

      var message = this.setUpMessageLoyaltyPoints();
      var notification = [{
        'company_id': this.$session.get('selectedCompany'),
        'delivery_type': 'loyalty_points',
        'location_ids': [],
        'message': [{
          'status': 'DELIVERED',
          'message': message
        }]
      }];

      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany'),
        'push_notifications': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notification)
      };

      this.apiRequest('/settings/loyalty-points-notification', 'POST', data, function (response) {
        if (response.success === true) {
          _this4.customLoyaltyPointsNotifications[0] = response.data;
          _this4.setUpCustomLoyaltyPointsBits();
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this4.$t('settingsPushNotif.notifUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch({});
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 2000 });
        }
      });
    },
    changeDeliveryStatusOnEatLocation: function changeDeliveryStatusOnEatLocation(deliveryType, status) {
      if (deliveryType === 'EAT_LOCATION' && status === 'DELIVERED') {
        status = 'RESERVED';
      }
      return this.$t('ordersStatus.' + status);
    },
    checkIfHasMutipleLocationAvailable: function checkIfHasMutipleLocationAvailable() {
      if (!this.model) return;
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.model), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var notif = _step11.value;

          var flag = 0;
          var type = notif.delivery_type.toLowerCase();
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.savedLocations), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var element = _step12.value;
              var _iteratorNormalCompletion14 = true;
              var _didIteratorError14 = false;
              var _iteratorError14 = undefined;

              try {
                for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(element.ordering_management), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                  var element2 = _step14.value;

                  if (element2.type.toLowerCase() === type) {
                    if (element2.enabled && !element2.notifSelected) {
                      flag++;
                    }
                  }
                }
              } catch (err) {
                _didIteratorError14 = true;
                _iteratorError14 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion14 && _iterator14.return) {
                    _iterator14.return();
                  }
                } finally {
                  if (_didIteratorError14) {
                    throw _iteratorError14;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          if (flag === 1) {
            flag = 0;
          }
          if (this.customNotifications.length) {
            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
              for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.customNotifications), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                var not = _step13.value;

                if (not.delivery_type.toLowerCase() === type && not.id === 0) {
                  flag = 0;
                }
              }
            } catch (err) {
              _didIteratorError13 = true;
              _iteratorError13 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion13 && _iterator13.return) {
                  _iterator13.return();
                }
              } finally {
                if (_didIteratorError13) {
                  throw _iteratorError13;
                }
              }
            }
          }
          this.showIfHasMultipleLocation[notif.delivery_type] = !!flag;
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }
    },
    addBoxForLocation: function addBoxForLocation(type) {
      var message = this.model.filter(function (m) {
        return m.delivery_type.toLowerCase() === type.toLowerCase();
      });
      var msg = this.copyVar(message[0].messages);
      this.customNotifications.push({
        'id': 0,
        'delivery_type': type.toLowerCase(),
        'location_ids': [],
        'message': msg
      });
      this.checkIfHasMutipleLocationAvailable();
      this.setUpCustomBits();
    },
    getLocationById: function getLocationById(id) {
      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.locations), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var element = _step15.value;

          if (element.id === id) {
            return element.name;
          }
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }
    },
    deleteBox: function deleteBox(id, type) {
      var _this5 = this;

      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany'),
        'id': id
      };
      this.apiRequest('/settings/delete-notif', 'POST', data, function (response) {
        if (response.success === true) {
          _this5.customNotifications = response.data;
          var _iteratorNormalCompletion16 = true;
          var _didIteratorError16 = false;
          var _iteratorError16 = undefined;

          try {
            for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this5.customNotifications), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
              var not = _step16.value;

              not.location_ids = JSON.parse(not.location_ids);
              not.message = JSON.parse(not.message);
            }
          } catch (err) {
            _didIteratorError16 = true;
            _iteratorError16 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion16 && _iterator16.return) {
                _iterator16.return();
              }
            } finally {
              if (_didIteratorError16) {
                throw _iteratorError16;
              }
            }
          }

          _this5.checkIfHasMutipleLocationAvailable();
          _this5.setUpCustomBits();
          _this5.showIfHasMultipleLocation[type.toUpperCase()] = true;
        }
      });
    },
    locationsAvailable: function locationsAvailable(message) {
      var filteredLocations = [];
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.savedLocations), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var item = _step17.value;
          var _iteratorNormalCompletion18 = true;
          var _didIteratorError18 = false;
          var _iteratorError18 = undefined;

          try {
            for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(item.ordering_management), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
              var ord = _step18.value;

              if (ord.type === message.delivery_type.toLowerCase() && ord.enabled) {
                if (this.checkInCustomNot(item.id, message.delivery_type.toLowerCase())) {
                  ord.notifSelected = false;
                } else {
                  ord.notifSelected = true;
                }
                filteredLocations.push(item);
              }
            }
          } catch (err) {
            _didIteratorError18 = true;
            _iteratorError18 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion18 && _iterator18.return) {
                _iterator18.return();
              }
            } finally {
              if (_didIteratorError18) {
                throw _iteratorError18;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }

      return filteredLocations;
    },
    locationsAvailable2: function locationsAvailable2(message) {
      var filteredLocations = [];
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.savedLocations), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var item = _step19.value;
          var _iteratorNormalCompletion20 = true;
          var _didIteratorError20 = false;
          var _iteratorError20 = undefined;

          try {
            for (var _iterator20 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(item.ordering_management), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
              var ord = _step20.value;

              if (ord.type === message.delivery_type.toLowerCase() && ord.enabled) {
                if (this.checkInCustomNot(item.id, message.delivery_type.toLowerCase())) {
                  ord.notifSelected = false;
                } else {
                  ord.notifSelected = true;
                }
                filteredLocations.push(ord);
              }
            }
          } catch (err) {
            _didIteratorError20 = true;
            _iteratorError20 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion20 && _iterator20.return) {
                _iterator20.return();
              }
            } finally {
              if (_didIteratorError20) {
                throw _iteratorError20;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }

      return filteredLocations;
    },
    checkInCustomNot: function checkInCustomNot(id, type) {
      var flag = 0;
      var _iteratorNormalCompletion21 = true;
      var _didIteratorError21 = false;
      var _iteratorError21 = undefined;

      try {
        for (var _iterator21 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.customNotifications), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
          var notiff = _step21.value;

          if (type === notiff.delivery_type) {
            if (notiff.location_ids.length) {
              var _iteratorNormalCompletion22 = true;
              var _didIteratorError22 = false;
              var _iteratorError22 = undefined;

              try {
                for (var _iterator22 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(notiff.location_ids), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                  var loc = _step22.value;

                  if (loc === id) {
                    flag++;
                  }
                }
              } catch (err) {
                _didIteratorError22 = true;
                _iteratorError22 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion22 && _iterator22.return) {
                    _iterator22.return();
                  }
                } finally {
                  if (_didIteratorError22) {
                    throw _iteratorError22;
                  }
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion21 && _iterator21.return) {
            _iterator21.return();
          }
        } finally {
          if (_didIteratorError21) {
            throw _iteratorError21;
          }
        }
      }

      return !flag;
    }
  }
});

/***/ }),

/***/ "/zre":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0+8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__("MWby");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c6db092_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__("Mzj5");
function injectStyle (ssrContext) {
  __webpack_require__("YuZj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c6db092_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "01lY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_json_excel__ = __webpack_require__("fXhN");










var _components;









__WEBPACK_IMPORTED_MODULE_9_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_14_vue_json_excel__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isClients: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.verifyUserLocations();
  },

  watch: {
    isClients: function isClients() {
      if (this.isClients) {
        var firstQuery = {
          sort: {
            prop: 'name',
            order: 'asc'
          },
          page: 1,
          pageSize: 20
        };
        this.getClients(firstQuery);
      }
    }
  },
  data: function data() {
    var _jsonFields;

    return {
      loading: false,
      donation_points_enabled: false,
      jsonFields: (_jsonFields = {}, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.name'), 'firstname'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.email'), 'email'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.phone'), 'phone'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.gender'), 'gender'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.age'), 'age'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.donation_points'), 'donation_points'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.totalAmount'), 'sales'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.ordersNumber'), 'orders_count'), _jsonFields),
      export_name: 'Export Clienti - ',
      clients: {
        'valid': [__WEBPACK_IMPORTED_MODULE_10_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_10_moment___default()().endOf('month').format('YYYY-MM-DD')],
        minOrder: null,
        maxOrder: null,
        minAmount: null,
        search: null,
        location: ''
      },
      locations: [],
      showLocations: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        defaultSort: {
          prop: 'name',
          order: 'ascending'
        }
      },
      labels: null,
      labelingPrimaryOption: null,
      totalClients: null,
      sortBy: 'name',
      sortOrder: 'asc',
      clientsTableData: [],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_10_moment___default()().subtract(24, 'months');
        }
      },
      pickerNames: ['date_from', 'date_to']
    };
  },

  methods: {
    clientsExportData: function clientsExportData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp, data, $dd, sortOptions, ced, clientsData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resp = [];

                if (!_this.clients) {
                  _context.next = 12;
                  break;
                }

                data = {
                  token: _this.$session.get('token'),
                  company_id: _this.$session.get('selectedCompany'),
                  start_date: _this.clients.valid[0],
                  end_date: _this.clients.valid[1],
                  min_orders: _this.clients.minOrder,
                  max_orders: _this.clients.maxOrder,
                  min_ammount: _this.clients.minAmount,
                  filter: _this.clients.search,
                  location_id: _this.clients.location
                };
                $dd = {};
                sortOptions = {
                  field: _this.sortBy,
                  order: _this.sortOrder
                };

                data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, sortOptions);

                ced = [];
                clientsData = [];
                _context.next = 10;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var ver = _this.$route.query && _this.$route.query.ver === 'V2' ? 'V2' : '';
                  _this.apiRequest('/reports/clients' + ver + '?page=' + 1 + '&pageSize=' + 50000, 'GET', data, function (response) {
                    clientsData = response.data.clients.data;
                    if (clientsData) {
                      var _iteratorNormalCompletion = true;
                      var _didIteratorError = false;
                      var _iteratorError = undefined;

                      try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(clientsData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                          var customer = _step.value;

                          $dd = {
                            'firstname': customer.firstname,
                            'email': customer.email,
                            'phone': customer.phone,
                            'gender': customer.gender,
                            'birthdate': customer.birthdate,
                            'age': customer.age,
                            'orders_count': customer.orders_count,
                            'sales': _this.formatMoneyAmount(customer.sales, '')
                          };
                          if (customer.donation_points) {
                            $dd['donation_points'] = customer.donation_points;
                          }
                          ced.push($dd);
                        }
                      } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }
                        } finally {
                          if (_didIteratorError) {
                            throw _iteratorError;
                          }
                        }
                      }
                    }
                    resolve(ced);
                  });
                });

              case 10:
                resp = _context.sent;
                return _context.abrupt('return', resp);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    startDownload: function startDownload() {
      this.loading = true;
    },
    finishDownload: function finishDownload() {
      this.loading = false;
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getClients(query);
      if (query.type === 'size') this.getClients(query);
      if (query.type === 'sort') {
        if (query.sort.order) {
          this.sortBy = query.sort.prop;
          this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc';
        } else {
          this.sortBy = 'name';
          this.sortOrder = 'asc';
        }
        this.getClients(query);
      }
    },
    getClients: function getClients(query) {
      var _this2 = this;

      if (!this.isClients) {
        return;
      }
      this.export_name = this.export_name + this.clients.valid[0] + ' - ' + this.clients.valid[1];
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.clients.valid[0],
        end_date: this.clients.valid[1],
        min_orders: this.clients.minOrder,
        max_orders: this.clients.maxOrder,
        min_ammount: this.clients.minAmount,
        filter: this.clients.search,
        location_id: this.clients.location
      };

      var sortColumn = '';
      var sortType = '';

      if (query) {
        sortColumn = query.sort.prop;
        sortType = query.sort.order === 'descending' ? 'desc' : 'asc';
      } else {
        sortColumn = this.sortBy;
        sortType = this.sortOrder;
      }

      var sortOptions = {
        field: sortColumn,
        order: sortType
      };
      data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, sortOptions);

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      var ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : '';
      this.apiRequest('/reports/clients' + ver + '?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status === true) {
          _this2.donation_points_enabled = response.data.use_donation_points;
          _this2.clientsTableData = response.data.clients.data;
          _this2.totalClients = response.data.clients.total;
          _this2.labels = response.data.labels;
          _this2.labelingPrimaryOption = response.data.fidelities_labels_primary_option;

          if (_this2.clientsTableData) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this2.clientsTableData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var customer = _step2.value;

                if (customer.lastname) {
                  customer['firstname'] = customer.firstname + ' ' + customer.lastname;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        }
        _this2.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    goToRecordCustomer: function goToRecordCustomer(row, event, column) {
      window.open('/#/reports/customer/' + row.id);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details;
      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }
      if (this.locations.length > 1) {
        this.showLocations = true;
      }
      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.clients.location = filterCookie[0];
      }
    }
  }
});

/***/ }),

/***/ "0230":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_KioskColorsCard_vue__ = __webpack_require__("4Ds/");












var _components;












__WEBPACK_IMPORTED_MODULE_11_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_16_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'KioskColorsCard', __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_KioskColorsCard_vue__["a" /* default */]), _components),
  props: {
    defaultData: {},
    modeldata: {}
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },

    modeldata: {
      immediate: true,
      handler: function handler(newVal) {
        this.model = newVal || {};
      }
    }
  },
  data: function data() {
    return {
      model: this.value || this.modeldata,
      defaults: this.value || this.defaultData
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vee_validate__["b" /* mapFields */])(['title', 'description'])),
  methods: {
    deleteCacheFromKiosk: function deleteCacheFromKiosk() {
      console.log('deleteCacheFromKiosk');
    },
    restartAllKiosk: function restartAllKiosk() {
      console.log('restartAllKiosk');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop][0]);
        }
      }
    },
    handleImgChnage: function handleImgChnage(file, fileList, index) {
      var _this2 = this;

      var self = this;
      var pp = this.model;
      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        self.$refs.upload.clearFiles();
        pp.kiosk_transparent_bg = [];
      } else {
        if (fileList.length > 1) {
          pp.kiosk_transparent_bg = fileList.slice(1);
        } else {
          pp.kiosk_transparent_bg = fileList;
        }
      }
      this.model = null;
      this.model = pp;
      this.getBase64(this.model.kiosk_transparent_bg[0].raw).then(function (base64enc) {
        _this2.model.kiosk_transparent_bg[0].base64enc = base64enc;
      });
    },
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        text: this.$t('general.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    handleRemove: function handleRemove(file, fileList, index) {
      if (fileList.length === 0) {
        this.model.kiosk_transparent_bg = [];
      }
    },
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'self_order_domain': this.model.self_order_domain,
        'table_colors': this.model.table_colors,
        'kiosk_pass': this.model.kiosk_pass,
        'text_fiscal_print': this.model.text_fiscal_print,
        'app_link': this.model.app_link,
        'app_android': this.model.app_android,
        'app_ios': this.model.app_ios
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({ 'text': self.$t('settingsTips.tipsSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          self.$session.set('selectedCompanyData', self.buildCompanySessionData(response.data[0]));
        } else {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({ 'text': self.$t('settingsTips.tipsSuccess'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    }
  }
});

/***/ }),

/***/ "04fd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('order-screen-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Dhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();return _vm.handleDelete($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":_vm.validate}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',{staticClass:"row pad-to-15",on:{"submit":function($event){$event.preventDefault();return _vm.validate($event)}}},[(_vm.errors.items.length)?_c('div',{staticClass:"col-md-12"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.name'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:3'),expression:"'required|min:3'"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('kds.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.errors.first('name'))+"\n            ")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Selectează locații *")]),_vm._v(" "),_c('small',{staticClass:"help-block text-muted"},[_vm._v("\n              Pe aceeași locație poate exista un singur profil fără alte filtre.\n              Al doilea profil pe aceeași locație trebuie să aibă în plus o categorie de top,\n              o zonă de livrare sau un grup de clienți.\n            ")]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"options":_vm.availableLocations,"multiple":"","label":"name","reduce":function (loc) { return loc.true_id; },"placeholder":_vm.$t('general.select'),"name":"location_ids","data-vv-as":"locații"},on:{"input":_vm.onLocationsChanged},model:{value:(_vm.model.location_ids),callback:function ($$v) {_vm.$set(_vm.model, "location_ids", $$v)},expression:"model.location_ids"}}),_vm._v(" "),(_vm.errors.has('location_ids'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.errors.first('location_ids'))+"\n            ")]):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.plainProfileTaken && !_vm.hasAnyScope)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n            Există deja un profil doar pe locație pentru locațiile selectate:\n            "),_c('strong',[_vm._v(_vm._s(_vm.plainProfileTaken))]),_vm._v(". Alege cel puțin un filtru mai jos.\n          ")]):_vm._e(),_vm._v(" "),(!_vm.selectedLocationIds.length)?_c('div',{staticClass:"text-muted"},[_vm._v("\n            Selectează întâi locațiile pentru a putea alege filtrele.\n          ")]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Grupuri de clienți")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.scopeOptions.customers_group,"multiple":"","label":"name","placeholder":_vm.$t('general.select'),"disabled":_vm.loadingScopeOptions},model:{value:(_vm.model.customers_group_ids),callback:function ($$v) {_vm.$set(_vm.model, "customers_group_ids", $$v)},expression:"model.customers_group_ids"}}),_vm._v(" "),(_vm.takenLabel('customers_group_ids'))?_c('small',{staticClass:"help-block text-muted"},[_vm._v("\n                  Ascunse (deja folosite în alt profil): "+_vm._s(_vm.takenLabel('customers_group_ids'))+"\n                ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Zone de livrare")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.scopeOptions.delivery_ranges,"multiple":"","label":"name","placeholder":_vm.$t('general.select'),"disabled":_vm.loadingScopeOptions},model:{value:(_vm.model.delivery_range_ids),callback:function ($$v) {_vm.$set(_vm.model, "delivery_range_ids", $$v)},expression:"model.delivery_range_ids"}}),_vm._v(" "),(_vm.takenLabel('delivery_range_ids'))?_c('small',{staticClass:"help-block text-muted"},[_vm._v("\n                  Ascunse (deja folosite în alt profil): "+_vm._s(_vm.takenLabel('delivery_range_ids'))+"\n                ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Categorii de top")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.scopeOptions.top_categories,"multiple":"","label":"name","placeholder":_vm.$t('general.select'),"disabled":_vm.loadingScopeOptions},model:{value:(_vm.model.top_category_ids),callback:function ($$v) {_vm.$set(_vm.model, "top_category_ids", $$v)},expression:"model.top_category_ids"}}),_vm._v(" "),(_vm.takenLabel('top_category_ids'))?_c('small',{staticClass:"help-block text-muted"},[_vm._v("\n                  Ascunse (deja folosite în alt profil): "+_vm._s(_vm.takenLabel('top_category_ids'))+"\n                ")]):_vm._e()],1)])])])])]),_vm._v(" "),(!_vm.isNew())?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card pricing-table-card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"filters-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Caută după nume")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.name),expression:"filters.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nume produs..."},domProps:{"value":(_vm.filters.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "name", $event.target.value)},_vm.debouncedLoadProducts]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Caută după ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.product_id),expression:"filters.product_id"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"ID produs..."},domProps:{"value":(_vm.filters.product_id)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "product_id", $event.target.value)},_vm.debouncedLoadProducts]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.category')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.category_id),expression:"filters.category_id"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.loadProducts]}},[_c('option',{attrs:{"value":""}},[_vm._v("Toate categoriile")]),_vm._v(" "),_vm._l((_vm.mainCategories),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v("\n                      "+_vm._s(option.name)+"\n                    ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-block",attrs:{"type":"button"},on:{"click":_vm.resetFilters}},[_c('i',{staticClass:"ti-close"}),_vm._v(" Reset\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-block",class:_vm.discountSelectionCount ? 'btn-info' : 'btn-default',attrs:{"type":"button"},on:{"click":_vm.openDiscountCampaignModal}},[_c('i',{staticClass:"ti-tag"}),_vm._v("\n                    "+_vm._s(_vm.$t('discountCampaigns.campaignButton'))+"\n                    "),(_vm.discountSelectionCount)?_c('span',[_vm._v("("+_vm._s(_vm.discountSelectionCount)+")")]):_vm._e()])])])])]),_vm._v(" "),(_vm.discountSelectionCount)?_c('div',{staticClass:"discount-selection-bar"},[_c('div',{staticClass:"discount-selection-bar__info"},[_vm._v("\n              "+_vm._s(_vm.$t('discountCampaigns.selectionSummary', {
                cells: _vm.discountSelectionCount,
                products: _vm.discountSelectionProductCount
              }))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"discount-selection-bar__actions"},[_c('button',{staticClass:"btn btn-sm btn-info",attrs:{"type":"button"},on:{"click":_vm.openDiscountCampaignModal}},[_vm._v("\n                "+_vm._s(_vm.$t('discountCampaigns.applyDiscount'))+"\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-default",attrs:{"type":"button"},on:{"click":_vm.clearDiscountSelection}},[_vm._v("\n                "+_vm._s(_vm.$t('discountCampaigns.clearSelection'))+"\n              ")])])]):_vm._e(),_vm._v(" "),(_vm.loadingProducts)?_c('div',{staticClass:"text-center py-3"},[_c('i',{staticClass:"ti-reload rotate"}),_vm._v(" Se încarcă produsele...\n          ")]):_c('div',{staticClass:"table-responsive-wrapper"},[_c('div',{staticClass:"table-horizontal-scroll"},[_c('table',{staticClass:"table pricing-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"product-col sticky-col"},[_vm._v("Produs (Preț Standard)")]),_vm._v(" "),_vm._l((_vm.sources),function(source){return _vm._l((source.methods),function(method){return _c('th',{key:((source.id) + "-" + (method.id)),staticClass:"source-method-col"},[_c('div',{staticClass:"source-header"},[_vm._v(_vm._s(source.name))]),_vm._v(" "),_c('div',{staticClass:"method-header"},[_vm._v(_vm._s(method.name))])])})})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.products),function(product){return _c('tr',{key:product.id},[_c('td',{staticClass:"product-col sticky-col"},[_c('div',{staticClass:"product-info"},[_c('strong',{on:{"click":function($event){_vm.goToProduct(product)}}},[_vm._v(_vm._s(product.name))]),_vm._v(" "),_c('div',{staticClass:"product-id text-muted"},[_vm._v("ID: "+_vm._s(product.id))]),_vm._v(" "),_c('div',{staticClass:"standard-price text-muted"},[_vm._v("\n                          Preț: "+_vm._s(product.price)+" RON\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-info btn-block quick-apply-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.openQuickApplyModal(product)}}},[_c('i',{staticClass:"ti-light-bulb"}),_vm._v(" Aplicare rapidă\n                        ")])])]),_vm._v(" "),_vm._l((_vm.sources),function(source){return _vm._l((source.methods),function(method){return _c('td',{key:((product.id) + "-" + (source.id) + "-" + (method.id)),staticClass:"pricing-cell"},[_c('div',{staticClass:"field-row checkbox-row"},[_c('label',{staticClass:"checkbox-label"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.getEditMode(product.id, source.id, method.id)},on:{"change":function($event){_vm.toggleEditMode(product.id, source.id, method.id, $event.target.checked)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.edit')))])])]),_vm._v(" "),(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))])?_c('div',{staticClass:"pricing-fields",class:{ 'disabled': !_vm.getEditMode(product.id, source.id, method.id) }},[_c('div',{staticClass:"field-row"},[_c('label',[_vm._v("Preț")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].price),expression:"pricingData[`${product.id}_${source.id}_${method.id}`].price"}],staticClass:"form-control input-sm",attrs:{"type":"number","step":"0.01","placeholder":"0.00"},domProps:{"value":(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))], "price", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('label',[_vm._v("TVA")]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",on:{"change":function($event){_vm.updateVatFromSelect(product.id, source.id, method.id, $event)}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează TVA")]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{key:vat.id,attrs:{"data-amount":vat.amount},domProps:{"value":vat.id,"selected":_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].vat_id == vat.id}},[_vm._v("\n                                "+_vm._s(vat.amount)+"% "),(vat.tax && vat.tax.name)?[_vm._v("- "+_vm._s(vat.tax.name))]:_vm._e()],2)}),_vm._v(" "),(!_vm.vatOptions.find(function (v) { return v.id == _vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].vat_id; }) && _vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].vat_id)?_c('option',{staticStyle:{"display":"none"},domProps:{"value":_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].vat_id}},[_vm._v("\n                                "+_vm._s(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].vat_amount)+"%\n                              ")]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"field-row"},[_c('label',[_vm._v("POS ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].pos_id),expression:"pricingData[`${product.id}_${source.id}_${method.id}`].pos_id"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"ID POS"},domProps:{"value":(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))], "pos_id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"field-row checkbox-row"},[_c('label',{staticClass:"checkbox-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].active),expression:"pricingData[`${product.id}_${source.id}_${method.id}`].active"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].active)?_vm._i(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].active,null)>-1:(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].active)},on:{"change":function($event){var $$a=_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))].active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))], "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))], "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))], "active", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Activ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"discount-row-compact",class:{
                            'is-selected': _vm.isDiscountCellSelected(product.id, source.id, method.id),
                            'has-discount': _vm.hasDiscounts(product.id, source.id, method.id)
                          }},[_c('input',{staticClass:"discount-select-check",attrs:{"type":"checkbox","disabled":!_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))],"title":_vm.pricingData[((product.id) + "_" + (source.id) + "_" + (method.id))]
                              ? _vm.$t('discountCampaigns.selectForCampaign')
                              : _vm.$t('discountCampaigns.noPriceConfigured')},domProps:{"checked":_vm.isDiscountCellSelected(product.id, source.id, method.id)},on:{"change":function($event){_vm.toggleDiscountCellSelection(product, source, method, $event.target.checked)}}}),_vm._v(" "),(_vm.hasDiscounts(product.id, source.id, method.id))?_c('span',{staticClass:"discount-dot",class:{ 'is-inactive': !_vm.isDiscountCampaignActive(product.id, source.id, method.id) }}):_vm._e(),_vm._v(" "),(_vm.hasDiscounts(product.id, source.id, method.id))?[_c('input',{staticClass:"form-control input-sm discount-input-compact",class:{ 'is-saved-flash': _vm.discountFlashKey === _vm.getPricingKey(product.id, source.id, method.id) },attrs:{"type":"number","step":"0.01","min":"0","readonly":_vm.getDiscounts(product.id, source.id, method.id).length > 1,"title":_vm.getDiscountTooltip(product.id, source.id, method.id)},domProps:{"value":_vm.getDiscountSum(product.id, source.id, method.id)},on:{"change":function($event){_vm.onDiscountSumChange(product.id, source.id, method.id, $event)},"click":function($event){_vm.onDiscountInputClick(product, source, method)}}}),_vm._v(" "),(_vm.getDiscounts(product.id, source.id, method.id).length > 1)?_c('sup',{staticClass:"discount-count"},[_vm._v(_vm._s(_vm.getDiscounts(product.id, source.id, method.id).length))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-default discount-edit-btn",attrs:{"type":"button","title":_vm.$t('discountCampaigns.viewEditDiscount')},on:{"click":function($event){_vm.openDiscountLineModal(product, source, method)}}},[_c('i',{staticClass:"ti-pencil"})])]:_c('span',{staticClass:"discount-empty text-muted"},[_vm._v("\n                            "+_vm._s(_vm.$t('discountCampaigns.discShort'))+" —\n                          ")])],2)])})})],2)}))])])]),_vm._v(" "),(_vm.productsPagination.totalPages > 1)?_c('div',{staticClass:"pagination-wrapper"},[_c('div',{staticClass:"pagination-info"},[_vm._v("\n              Pagina "+_vm._s(_vm.productsPagination.page)+" din "+_vm._s(_vm.productsPagination.totalPages)+"\n              ("+_vm._s(_vm.productsPagination.totalRecords)+" produse)\n            ")]),_vm._v(" "),_c('div',{staticClass:"pagination-controls"},[_c('button',{staticClass:"btn btn-sm btn-default",attrs:{"disabled":_vm.productsPagination.page === 1},on:{"click":function($event){$event.preventDefault();_vm.changePage(_vm.productsPagination.page - 1)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" Anterior\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-default",attrs:{"disabled":_vm.productsPagination.page === _vm.productsPagination.totalPages},on:{"click":function($event){$event.preventDefault();_vm.changePage(_vm.productsPagination.page + 1)}}},[_vm._v("\n                Următor "),_c('i',{staticClass:"ti-arrow-right"})])])]):_vm._e(),_vm._v(" "),(!_vm.loadingProducts && _vm.products.length === 0)?_c('div',{staticClass:"text-center py-4 text-muted"},[_c('i',{staticClass:"ti-package",staticStyle:{"font-size":"48px"}}),_vm._v(" "),_c('p',[_vm._v("Nu există produse disponibile pentru configurare")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),(_vm.showQuickApplyModal)?_c('div',{staticClass:"modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeQuickApplyModal($event)}}},[_c('div',{staticClass:"modal-dialog quick-apply-modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),(_vm.quickApplyProduct)?_c('p',{staticClass:"modal-subtitle"},[_c('strong',[_vm._v(_vm._s(_vm.quickApplyProduct.name))]),_vm._v(" (ID: "+_vm._s(_vm.quickApplyProduct.id)+")\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.closeQuickApplyModal}},[_c('i',{staticClass:"ti-close"})])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"quick-apply-form"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-danger btn-block quick-clear-btn",attrs:{"type":"button"},on:{"click":_vm.clearProductPricing}},[_c('i',{staticClass:"ti-trash"}),_vm._v(" Șterge din lista de prețuri\n              ")]),_vm._v(" "),_c('small',{staticClass:"help-block text-muted"},[_vm._v("\n                Dezactivează toate sursele și metodele acestui produs. Recordurile existente vor fi șterse la salvare.\n              ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Preț")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quickApplyData.price),expression:"quickApplyData.price"}],staticClass:"form-control",attrs:{"type":"number","step":"0.01","placeholder":"0.00"},domProps:{"value":(_vm.quickApplyData.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.quickApplyData, "price", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("TVA")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.quickApplyData.vat_id),expression:"quickApplyData.vat_id"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.quickApplyData, "vat_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.updateQuickApplyVat]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează TVA")]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{key:vat.id,domProps:{"value":vat.id}},[_vm._v("\n                  "+_vm._s(vat.amount)+"% "),(vat.tax && vat.tax.name)?[_vm._v("- "+_vm._s(vat.tax.name))]:_vm._e()],2)})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("POS ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quickApplyData.pos_id),expression:"quickApplyData.pos_id"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ID POS"},domProps:{"value":(_vm.quickApplyData.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.quickApplyData, "pos_id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group checkbox-group"},[_c('label',{staticClass:"checkbox-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quickApplyData.active),expression:"quickApplyData.active"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.quickApplyData.active)?_vm._i(_vm.quickApplyData.active,null)>-1:(_vm.quickApplyData.active)},on:{"change":function($event){var $$a=_vm.quickApplyData.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.quickApplyData, "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.quickApplyData, "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.quickApplyData, "active", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Activ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer pp-modal-footer"},[_c('p',{staticClass:"d-inline-flex pp-modal-footer__actions"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.closeQuickApplyModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n              Anulează\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon save",attrs:{"type":"button"},on:{"click":_vm.applyQuickApply}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              Aplică la toate\n            ")])])])])])]):_vm._e(),_vm._v(" "),(_vm.showDiscountCampaignModal)?_c('div',{staticClass:"modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeDiscountCampaignModal($event)}}},[_c('div',{staticClass:"modal-dialog discount-campaign-modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_c('i',{staticClass:"ti-tag"}),_vm._v(" "+_vm._s(_vm.$t('discountCampaigns.newCampaignModal'))+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"modal-subtitle"},[_vm._v("\n            "+_vm._s(_vm.$t('discountCampaigns.newCampaignSubtitle', {
              name: _vm.model.name || '',
              cells: _vm.discountSelectionCount
            }))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.closeDiscountCampaignModal}},[_c('i',{staticClass:"ti-close"})])]),_vm._v(" "),_c('div',{staticClass:"modal-body discount-campaign-modal__body"},[(_vm.showDiscountCampaignModal)?_c('discount-campaign-form',{ref:"discountCampaignForm",attrs:{"embedded":true,"hide-preview":true,"lock-price-profile":true,"prefill":_vm.discountCampaignPrefill,"route":{ params: {} }},on:{"saved":_vm.onDiscountCampaignSaved,"cancel":_vm.closeDiscountCampaignModal}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"modal-footer pp-modal-footer"},[_c('p',{staticClass:"d-inline-flex pp-modal-footer__actions"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.closeDiscountCampaignModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.cancel'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon save",attrs:{"type":"button"},on:{"click":_vm.submitDiscountCampaignModal}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('discountCampaigns.createCampaign'))+"\n            ")])])])])])]):_vm._e(),_vm._v(" "),(_vm.showDiscountLineModal)?_c('div',{staticClass:"modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeDiscountLineModal($event)}}},[_c('div',{staticClass:"modal-dialog discount-line-modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_c('i',{staticClass:"ti-tag"}),_vm._v(" "+_vm._s(_vm.$t('discountCampaigns.discount'))+"\n          ")]),_vm._v(" "),(_vm.discountLineContext)?_c('p',{staticClass:"modal-subtitle"},[_c('strong',[_vm._v(_vm._s(_vm.discountLineContext.productName))]),_vm._v("\n            #"+_vm._s(_vm.discountLineContext.productId)+"\n            · "+_vm._s(_vm.discountLineContext.sourceName)+" "+_vm._s(_vm.discountLineContext.methodName)+"\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.closeDiscountLineModal}},[_c('i',{staticClass:"ti-close"})])]),_vm._v(" "),(_vm.discountLineContext)?_c('div',{staticClass:"modal-body"},_vm._l((_vm.discountLineEdits),function(lineEdit,idx){return _c('div',{key:lineEdit.id,staticClass:"discount-line-editor"},[_c('div',{staticClass:"discount-line-editor__meta"},[_c('div',{staticClass:"meta-row"},[_c('span',{staticClass:"meta-label"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.single')))]),_vm._v(" "),_c('span',{staticClass:"meta-value"},[_vm._v("\n                  "+_vm._s(lineEdit.campaignName || ('#' + lineEdit.campaignId))+"\n                ")])]),_vm._v(" "),(lineEdit.period)?_c('div',{staticClass:"meta-row"},[_c('span',{staticClass:"meta-label"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.period')))]),_vm._v(" "),_c('span',{staticClass:"meta-value"},[_vm._v(_vm._s(lineEdit.period))])]):_vm._e(),_vm._v(" "),(lineEdit.number_of_units != null)?_c('div',{staticClass:"meta-row"},[_c('span',{staticClass:"meta-label"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.cap')))]),_vm._v(" "),_c('span',{staticClass:"meta-value"},[_vm._v("\n                  "+_vm._s(lineEdit.number_of_units)+" · "+_vm._s(_vm.$t('discountCampaigns.unitsSold'))+" "+_vm._s(lineEdit.units_sold || 0)+"\n                ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.listPrice')))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":lineEdit.basePrice}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.discount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(lineEdit.discount),expression:"lineEdit.discount",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","step":"0.01","min":"0"},domProps:{"value":(lineEdit.discount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(lineEdit, "discount", _vm._n($event.target.value))},function($event){_vm.recalcLineEdit(idx)}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(lineEdit.error)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(lineEdit.error))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.discountedPrice')))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":lineEdit.discounted_price}})]),_vm._v(" "),(idx < _vm.discountLineEdits.length - 1)?_c('hr'):_vm._e()])})):_vm._e(),_vm._v(" "),(_vm.discountLineEdits.length)?_c('div',{staticClass:"modal-footer pp-modal-footer pp-modal-footer--split"},[_c('p',{staticClass:"d-inline-flex"},[_c('a',{staticClass:"btn btn-danger btn-icon delete",class:{ disabled: _vm.discountLineSaving },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();!_vm.discountLineSaving && _vm.deleteDiscountLinesFromModal()}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.delete'))+"\n            ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex pp-modal-footer__actions"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.closeDiscountLineModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.cancel'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon save",attrs:{"type":"button","disabled":_vm.discountLineSaving || _vm.hasDiscountLineErrors},on:{"click":_vm.saveAllDiscountLinesFromModal}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n            ")])])]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Filtre profil")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("\n            Opțional. La aplicare prioritatea este: grup de clienți > zonă de livrare > categorie de top.\n            Dacă profilul are mai multe filtre setate, trebuie să se potrivească toate simultan.\n            Aceeași categorie/zonă/grup nu poate exista în două profile pe aceeași locație.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Configurare Prețuri Produse")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Setează prețurile pentru fiecare produs în funcție de sursă și metodă")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"modal-title"},[_c('i',{staticClass:"ti-light-bulb"}),_vm._v(" Aplicare rapidă\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"modal-description"},[_vm._v("\n            Completează valorile de mai jos pentru a le aplica la "),_c('strong',[_vm._v("toate sursele și metodele")]),_vm._v(" acestui produs.\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Emz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0Gi9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0JRC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cross-sell-picker"},[_c('div',{staticClass:"cross-sell-selected"},[_c('label',{staticClass:"form-label"},[_vm._v("\n      "+_vm._s(_vm.$t('crossSell.selectedTitle'))+"\n      "),_c('span',{staticClass:"cross-sell-count"},[_vm._v(_vm._s(_vm.selectedItems.length)+"/"+_vm._s(_vm.maxItems))])]),_vm._v(" "),(_vm.selectedItems.length)?_c('div',{staticClass:"cross-sell-chips"},_vm._l((_vm.selectedItems),function(item){return _c('span',{key:item.id,staticClass:"cross-sell-chip"},[_vm._v("\n        "+_vm._s(item.name)+"\n        "),_c('a',{staticClass:"cross-sell-chip-remove",on:{"click":function($event){$event.preventDefault();_vm.removeItem(item.id)}}},[_vm._v("×")])])})):_c('p',{staticClass:"cross-sell-empty"},[_vm._v(_vm._s(_vm.$t('crossSell.noneSelected')))])]),_vm._v(" "),_c('div',{staticClass:"cross-sell-filters row"},[_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('crossSell.searchPlaceholder')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryId),expression:"categoryId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('crossSell.allCategories')))]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v(_vm._s(cat.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"cross-sell-results"},[(_vm.loading)?_c('div',{staticClass:"cross-sell-hint"},[_vm._v(_vm._s(_vm.$t('crossSell.loading')))]):(!_vm.results.length)?_c('div',{staticClass:"cross-sell-hint"},[_vm._v(_vm._s(_vm.$t('crossSell.noResults')))]):_vm._l((_vm.results),function(product){return _c('div',{key:product.id,staticClass:"cross-sell-row",class:{ 'is-checked': _vm.isChecked(product.id) },on:{"click":function($event){_vm.toggle(product)}}},[_c('input',{staticClass:"cross-sell-row-check",staticStyle:{"pointer-events":"none"},attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked(product.id)}}),_vm._v(" "),_c('span',{staticClass:"cross-sell-row-name"},[_vm._v(_vm._s(product.name))])])})],2),_vm._v(" "),(!_vm.loading && _vm.total > 0)?_c('div',{staticClass:"cross-sell-pagination"},[_c('button',{staticClass:"btn btn-default btn-sm cross-sell-page-btn",attrs:{"type":"button","disabled":_vm.page <= 1},on:{"click":function($event){_vm.goToPage(_vm.page - 1)}}},[_vm._v("\n      «\n    ")]),_vm._v(" "),_c('span',{staticClass:"cross-sell-page-info"},[_vm._v("\n      "+_vm._s(_vm.$t('crossSell.pageInfo', { page: _vm.page, pages: _vm.lastPage, total: _vm.total }))+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-sm cross-sell-page-btn",attrs:{"type":"button","disabled":_vm.page >= _vm.lastPage},on:{"click":function($event){_vm.goToPage(_vm.page + 1)}}},[_vm._v("\n      »\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0NWe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Ou5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canRequestBackgroundReport; });
/* harmony export (immutable) */ __webpack_exports__["a"] = isLongReportPeriod;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);





var canRequestBackgroundReport = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(error) {
    var response, body;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', true);

          case 2:
            response = error.response;

            if (!(!response || response.status === 0)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return', error.code === 'ERR_NETWORK' || error.message === 'Network Error');

          case 5:
            if (![408, 504, 524].includes(response.status)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt('return', true);

          case 7:
            if (!(response.status !== 500 && response.status !== 502 && response.status !== 200)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return', false);

          case 9:
            body = response.data;

            if (!(typeof Blob !== 'undefined' && body instanceof Blob)) {
              _context.next = 22;
              break;
            }

            if (!(body.size > 65536)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt('return', false);

          case 13:
            _context.prev = 13;
            _context.next = 16;
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var reader = new FileReader();
              reader.onload = function () {
                return resolve(reader.result);
              };
              reader.onerror = reject;
              reader.readAsText(body);
            });

          case 16:
            body = _context.sent;
            _context.next = 22;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context['catch'](13);
            return _context.abrupt('return', false);

          case 22:
            if (typeof body !== 'string') body = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(body || {});
            return _context.abrupt('return', /maximum execution time.{0,40}exceeded|gateway.{0,20}time.?out|timed?\s*out|execution.{0,20}timeout/i.test(body));

          case 24:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[13, 19]]);
  }));

  return function canRequestBackgroundReport(_x) {
    return _ref.apply(this, arguments);
  };
}();

function isLongReportPeriod(fromDate, toDate) {
  if (!fromDate || !toDate || toDate < fromDate) return false;
  var start = new Date(fromDate + 'T00:00:00Z');
  var end = new Date(toDate + 'T00:00:00Z');
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return false;
  var nextMonth = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + 1, 1));
  var lastDay = new Date(Date.UTC(nextMonth.getUTCFullYear(), nextMonth.getUTCMonth() + 1, 0)).getUTCDate();
  nextMonth.setUTCDate(Math.min(start.getUTCDate(), lastDay));
  return end >= nextMonth;
}

/***/ }),

/***/ "0Svp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-end","gap":"10px","flex-wrap":"nowrap","margin-bottom":"20px"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"nowrap","gap":"8px","align-items":"flex-end","flex":"0 1 auto"}},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.id')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('catalogProd.id'),"size":"small","clearable":""},model:{value:(_vm.searchId),callback:function ($$v) {_vm.searchId=$$v},expression:"searchId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 180px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('catalogProd.name'),"size":"small","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(_vm.locations.length)?_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 200px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select'),"size":"small","multiple":"","collapse-tags":"","clearable":""},model:{value:(_vm.selectedLocations),callback:function ($$v) {_vm.selectedLocations=$$v},expression:"selectedLocations"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:loc.id || loc.true_id,attrs:{"label":loc.name,"value":loc.true_id || loc.id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.searchPos}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"right-group",staticStyle:{"flex":"0 0 auto"}},[_c('button',{staticClass:"btn add",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"10","prop":"name","label":"ID"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.id || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"name","label":_vm.$t('reports.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.name ? props.row.name : "-"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"name","label":_vm.$t('reports.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.location.name ? props.row.location.name : "-"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":320,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.send')},on:{"click":function($event){_vm.handleDelete(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")])]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0WcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyLocations_vue__ = __webpack_require__("wF+N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_706f26ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyLocations_vue__ = __webpack_require__("GMql");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyLocations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_706f26ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyLocations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0XE4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card'
});

/***/ }),

/***/ "0Yz/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0ZfM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('category-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onCategorySubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0afy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaignEdit_vue__ = __webpack_require__("DU2L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8391249a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaignEdit_vue__ = __webpack_require__("Hioa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaignEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8391249a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaignEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0cXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Campaigns_Steps_ForthStep_vue__ = __webpack_require__("c3/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Campaigns_spinningWheelCoupon__ = __webpack_require__("HDqy");











var _components;









__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, 'ForthStep', __WEBPACK_IMPORTED_MODULE_14__Campaigns_Steps_ForthStep_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    embedded: {
      type: Boolean,
      default: false
    },

    forceSubscription: {
      type: Boolean,
      default: false
    },

    forceAutomation: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      loaded: false,
      saving: false,
      header: {
        name: '',
        fromto: null,
        active: true
      },
      headerErrors: {},
      pushCampaigns: [],

      subscriptionLevels: [],

      automationCampaigns: [],

      couponModel: { type: 'COUPON', order_source_ids: [] },
      coupons: {},
      userLabelLevels: [],
      customerGroups: [],
      selectedCustomerGroups: [],
      checkedKeys: [],
      couponError: null
    };
  },

  computed: {
    couponId: function couponId() {
      return this.route.params && this.route.params.id;
    },
    subscriptionLockReason: function subscriptionLockReason() {
      if (this.forceSubscription) {
        return '';
      }

      if (!this.coupons.is_subscription && this.coupons.is_automation) {
        return this.$t('marketingCoupons.subscriptionAutomationExclusive');
      }
      if (this.coupons.is_subscription && this.subscriptionLevels.length) {
        return this.$t('marketingCoupons.subscriptionLockedUsed');
      }
      if (!this.coupons.is_subscription && this.pushCampaigns.length) {
        return this.$t('marketingCoupons.subscriptionLockedCampaign');
      }
      return '';
    },
    subscriptionLocked: function subscriptionLocked() {
      return this.forceSubscription || this.forceAutomation || !!this.subscriptionLockReason;
    },
    automationLockReason: function automationLockReason() {
      if (this.forceAutomation) {
        return '';
      }
      if (!this.coupons.is_automation && this.coupons.is_subscription) {
        return this.$t('marketingCoupons.subscriptionAutomationExclusive');
      }
      if (this.coupons.is_automation && this.automationCampaigns.length) {
        return this.$t('marketingCoupons.automationLockedUsed');
      }
      if (!this.coupons.is_automation && this.pushCampaigns.length) {
        return this.$t('marketingCoupons.automationLockedCampaign');
      }
      return '';
    },
    automationLocked: function automationLocked() {
      return this.forceAutomation || this.forceSubscription || !!this.automationLockReason;
    }
  },
  created: function created() {
    this.coupons = this.emptyCoupon();
    this.getUserLabeling();
    this.getGroups();
    if (this.couponId) {
      this.getCoupon();
    } else {
      this.loaded = true;
    }
  },

  methods: {
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    emptyCoupon: function emptyCoupon() {
      return {
        type: 'PERCENTAGE',
        usage_type: null,
        discount: null,
        from_value: 0,
        coupon_code: null,
        delivery_methods: [],
        interval_settings: [],
        user_label_selected: null,
        coupons_codes: [],
        usage_for_categories: [],
        usage_for_products: [],
        free_product_id: null,
        min_order_value: null,
        is_subscription: this.forceSubscription,

        is_cumulative: this.forceSubscription,
        is_automation: this.forceAutomation
      };
    },
    onSubscriptionToggle: function onSubscriptionToggle(value) {
      if (value) {
        this.$set(this.coupons, 'is_cumulative', true);
      }
    },
    handleGroupCustomers: function handleGroupCustomers(e) {
      this.selectedCustomerGroups = e;
    },
    getCoupon: function getCoupon() {
      var _this = this;

      this.loading = true;
      this.apiRequest('/coupon/' + this.couponId, 'GET', this.requestData(), function (response) {
        _this.loading = false;
        if (!(response.status === true && response.data && response.data[0])) {
          return;
        }
        var coupon = response.data[0];

        _this.header.name = coupon.name;
        _this.header.active = !!coupon.active;
        _this.header.fromto = coupon.datetime_validfrom && coupon.datetime_validto ? [coupon.datetime_validfrom.substr(0, 10), coupon.datetime_validto.substr(0, 10)] : null;
        _this.pushCampaigns = coupon.push_campaigns || [];
        _this.subscriptionLevels = coupon.subscription_levels || [];
        coupon.is_subscription = !!coupon.is_subscription;
        _this.automationCampaigns = coupon.automation_campaigns || [];
        coupon.is_automation = !!coupon.is_automation;
        _this.couponModel = { type: 'COUPON', order_source_ids: coupon.order_source_ids || [] };

        if (coupon.waterfall_discounts && coupon.waterfall_discounts.length) {
          coupon.from_value = coupon.waterfall_discounts[0].from_value;
          coupon.discount = coupon.waterfall_discounts[0].discount_value;
          coupon.waterfall_discounts.shift();
        }
        if (!coupon.from_value) {
          coupon.from_value = 0;
        }
        if (coupon.group_customers) {
          var groups = coupon.group_customers;
          if (typeof groups === 'string') {
            try {
              groups = JSON.parse(groups);
            } catch (e) {
              groups = [];
            }
          }
          if (groups && groups.length) {
            _this.selectedCustomerGroups = groups;
          }
        }
        if (coupon.free_product_id != null) {
          var freeProductId = coupon.free_product_id;
          coupon.free_product_id = (typeof freeProductId === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(freeProductId)) === 'object' ? parseInt(freeProductId.id || freeProductId.product_id, 10) || null : parseInt(freeProductId, 10) || null;
        }
        if (!Array.isArray(coupon.coupons_codes)) {
          coupon.coupons_codes = [];
        }
        coupon.user_label_selected = _this.userLabelLevels.find(function (el) {
          return el.key === coupon.user_label_id;
        }) || null;

        _this.checkedKeys = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(coupon.usage_for_products || []).concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(coupon.usage_for_categories || []));
        _this.coupons = coupon;
        _this.loaded = true;
      });
    },
    getUserLabeling: function getUserLabeling() {
      var _this2 = this;

      this.apiRequest('/userlabeling', 'GET', this.requestData(), function (response) {
        if (response.status === true) {
          _this2.userLabelLevels = response.data.items.map(function (el) {
            return {
              key: el.id,
              label: el.name
            };
          });
          if (_this2.coupons && _this2.coupons.user_label_id) {
            _this2.$set(_this2.coupons, 'user_label_selected', _this2.userLabelLevels.find(function (el) {
              return el.key === _this2.coupons.user_label_id;
            }) || null);
          }
        }
      });
    },
    getGroups: function getGroups() {
      var _this3 = this;

      this.apiRequest('/customersgroup/get-groups', 'POST', this.requestData(), function (response) {
        if (response.status === true) {
          _this3.customerGroups = response.data;
        }
      });
    },
    validateHeader: function validateHeader() {
      this.headerErrors = {};
      if (!this.header.name || !String(this.header.name).trim()) {
        this.$set(this.headerErrors, 'name', true);
      }
      if (!this.header.fromto || !this.header.fromto[0] || !this.header.fromto[1]) {
        this.$set(this.headerErrors, 'fromto', true);
      }
      return !__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.headerErrors).length;
    },
    save: function save() {
      var _this4 = this;

      var headerValid = this.validateHeader();
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(this.$refs.forthStep.validate()).then(function (couponValid) {
        if (headerValid && couponValid) {
          _this4.submit();
        }
      });
    },
    buildPayload: function buildPayload() {
      var forthStep = this.$refs.forthStep;

      var coupon = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(forthStep.coupons));

      if (coupon.user_label_selected) {
        coupon.user_label_id = coupon.user_label_selected.key;
      } else {
        coupon.user_label_id = '';
      }
      delete coupon.user_label_selected;

      if (coupon.type !== 'FREE_PRODUCT') {
        coupon.min_order_value = null;
        if (coupon.is_waterfall || parseInt(coupon.from_value)) {
          if (parseInt(coupon.from_value) || parseInt(coupon.from_value) === 0) {
            if (!Array.isArray(coupon.waterfall_discounts)) {
              coupon.waterfall_discounts = [];
            }
            coupon.waterfall_discounts.unshift({
              from_value: coupon.from_value,
              discount_value: coupon.discount
            });
            coupon.is_waterfall = true;
            delete coupon.from_value;
          }
          if (!parseInt(coupon.from_value) && !coupon.waterfall_discounts.length) {
            coupon.is_waterfall = false;
          }
        }
      } else {
        delete coupon.discount;
        delete coupon.is_waterfall;
        delete coupon.waterfall_discounts;
        delete coupon.waterfall_restriction;
        delete coupon.from_value;
        if (coupon.min_order_value === '' || coupon.min_order_value === undefined) {
          coupon.min_order_value = null;
        }
      }
      if (!coupon.waterfall_restriction) {
        coupon.waterfall_restriction = false;
      }
      if (!coupon.coupon_has_multiple_codes) {
        coupon.coupon_has_multiple_codes = false;
      }

      var data = this.copyObject(coupon);
      if (data.type === 'FREE_PRODUCT' && coupon.free_product_id != null) {
        var freeProductId = coupon.free_product_id;
        data.free_product_id = (typeof freeProductId === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(freeProductId)) === 'object' ? parseInt(freeProductId.id || freeProductId.product_id, 10) || null : parseInt(freeProductId, 10) || null;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__Campaigns_spinningWheelCoupon__["a" /* isSpinningWheelFreeProductCoupon */])(coupon, forthStep.model)) {
        data.usage_for_categories = '[]';
        data.usage_for_products = '[]';
      } else if (data.usage_type === 'PRODUCTS') {
        var tree = forthStep.$refs.tree;
        var checkedNodes = tree.getCheckedNodes();
        var level1Nodes = checkedNodes.filter(function (node) {
          return node.level === 1;
        }).map(function (node) {
          return node.id;
        });
        var level2Nodes = checkedNodes.filter(function (node) {
          return node.level === 2;
        }).filter(function (node) {
          return !level1Nodes.includes(tree.getNode(node).parent.data.id);
        }).map(function (node) {
          return node.id;
        });
        data.usage_for_categories = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(level1Nodes);
        data.usage_for_products = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(level2Nodes);
      } else {
        data.usage_for_categories = null;
        data.usage_for_products = null;
      }

      data.delivery_methods = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(data.delivery_methods || {}).map(function (method) {
        return method.key;
      }));
      data.location_ids = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(data.location_ids || {}).map(function (location) {
        return location.id;
      }));
      data.group_customers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.selectedCustomerGroups);

      if (typeof data.use_time_interval !== 'undefined' && (data.use_time_interval === '' || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(data.use_time_interval) === 'object')) {
        data.use_time_interval = 0;
      }

      var orderSourceIds = forthStep.model && Array.isArray(forthStep.model.order_source_ids) ? forthStep.model.order_source_ids : [];
      data.order_source_ids = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(orderSourceIds);

      data.name = this.header.name;
      data.active = this.header.active ? 1 : 0;
      data.is_subscription = coupon.is_subscription ? 1 : 0;
      if (data.is_subscription) {
        delete data.coupon_code;
        delete data.coupons_codes;
      }
      data.is_automation = coupon.is_automation ? 1 : 0;
      if (data.is_automation) {
        delete data.coupons_codes;
      }
      data.datetime_validfrom = this.header.fromto[0];
      data.datetime_validto = this.header.fromto[1];

      delete data.push_campaigns;
      delete data.subscription_levels;
      delete data.automation_campaigns;
      delete data.qr_url;
      delete data.coupons_codes_count;
      delete data.order_sources_mask;
      delete data.campaign_id;
      delete data.company_id;
      delete data.created_at;
      delete data.updated_at;
      delete data.deleted_at;
      delete data.created_by;
      delete data.updated_by;
      delete data.deleted_by;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, this.requestData());
    },
    submit: function submit() {
      var _this5 = this;

      var data = this.buildPayload();
      var url = this.couponId ? '/coupon/' + this.couponId : '/coupon';
      var method = this.couponId ? 'PUT' : 'POST';

      this.saving = true;
      this.couponError = null;
      this.apiRequest(url, method, data, function (response) {
        _this5.saving = false;
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            title: '',
            text: _this5.$t('marketingCoupons.couponSaved'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
          if (_this5.embedded) {
            _this5.$emit('saved', response.data && response.data[0] || null);
            return;
          }
          _this5.goBack();
          return;
        }

        var errors = response.errors || {};
        if (errors.coupon_code) {
          _this5.couponError = Array.isArray(errors.coupon_code) ? errors.coupon_code[0] : errors.coupon_code;
        }
        if (_this5.$refs.forthStep) {
          _this5.$refs.forthStep.handleIntervalErrors(errors);
        }
        var messages = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(errors).map(function (key) {
          return Array.isArray(errors[key]) ? errors[key][0] : errors[key];
        });
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', messages.join(' ') || _this5.$t('validations.wentWrong'), 'error').catch(function () {});
      });
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "0dTk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0i5z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"report-filters"},[_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clients.search),expression:"clients.search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('reports.searchFilter')},domProps:{"value":(_vm.clients.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.clients, "search", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clients.minOrder),expression:"clients.minOrder"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('reports.minOrders')},domProps:{"value":(_vm.clients.minOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.clients, "minOrder", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clients.maxOrder),expression:"clients.maxOrder"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('reports.maxOrders')},domProps:{"value":(_vm.clients.maxOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.clients, "maxOrder", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clients.minAmount),expression:"clients.minAmount"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('reports.minAmount')},domProps:{"value":(_vm.clients.minAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.clients, "minAmount", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left date-range"},[_c('el-date-picker',{staticClass:"mid",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.clients.valid),callback:function ($$v) {_vm.$set(_vm.clients, "valid", $$v)},expression:"clients.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('reports.search')},on:{"click":function($event){_vm.getClients(null)}}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('download-excel',{directives:[{name:"show",rawName:"v-show",value:(_vm.clientsTableData.length),expression:"clientsTableData.length"}],staticClass:"btn btn-icon mar-rt-40 btn-success",attrs:{"fetch":_vm.clientsExportData,"fields":_vm.jsonFields,"name":_vm.export_name,"before-generate":_vm.startDownload,"before-finish":_vm.finishDownload}},[_c('i',{staticClass:"ti-file"})])],1),_vm._v(" "),_c('div',{staticClass:"card-content total-pagination"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.clientsTableData,"search-def":{ show: false },"total":_vm.totalClients,"pagination-props":_vm.paginationProps,"table-props":_vm.tableOptions},on:{"query-change":_vm.paginationChanged,"row-click":_vm.goToRecordCustomer},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.created_at))])]}}])},[_c('el-table-column',{attrs:{"min-width":80,"sortable":"custom","prop":"name","label":_vm.$t('reports.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n          "+_vm._s(props.row.firstname)+" "+_vm._s(props.row.lastname)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"sortable":"custom","prop":"email","label":_vm.$t('reports.email')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"sortable":"custom","prop":"created_at","label":"Client from"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"sortable":"custom","prop":"orders_count","label":_vm.$t('reports.ordersNumber')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.orders_count))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"label","label":"Total valoare consumata"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.totals_discount_loyalty_points))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"label","label":"Total puncte acumulate"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.gained_loyalty_points))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"label","label":"Total puncte folosite"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.used_loyalty_points))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"label","label":"Total puncte disponibile"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.loyalty_points))])]}}])})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0jgF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('location-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0juF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreenAdd_vue__ = __webpack_require__("C8MM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62745b6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreenAdd_vue__ = __webpack_require__("d2AR");
function injectStyle (ssrContext) {
  __webpack_require__("FRrx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreenAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62745b6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreenAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0lpa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't1'
});

/***/ }),

/***/ "0mka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),(_vm.settings && _vm.settings[0])?_c('form',{staticClass:"services"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),(_vm.settings[0].firebase_api_key != '')?[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("firebase_api_key")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].firebase_api_key),expression:"settings[0].firebase_api_key"}],staticClass:"form-control",attrs:{"type":"text","name":"firebase_api_key","placeholder":"firebase_api_key"},domProps:{"value":(_vm.settings[0].firebase_api_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0], "firebase_api_key", $event.target.value)}}})])])]:[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Firebase Project Id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].firebase.project_id),expression:"settings[0].firebase.project_id"}],staticClass:"form-control",attrs:{"type":"text","name":"project_id","placeholder":"Project ID"},domProps:{"value":(_vm.settings[0].firebase.project_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].firebase, "project_id", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Firebase Json Key")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].firebase.json_key),expression:"settings[0].firebase.json_key"}],staticClass:"form-control",staticStyle:{"height":"150px"},attrs:{"type":"text","name":"json_key","placeholder":"Json Key"},domProps:{"value":(_vm.settings[0].firebase.json_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].firebase, "json_key", $event.target.value)}}})])])]],2)])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[(_vm.settings[0].apple)?_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("client_id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].apple.client_id),expression:"settings[0].apple.client_id"}],staticClass:"form-control",attrs:{"type":"text","name":"client_id","placeholder":"client_id"},domProps:{"value":(_vm.settings[0].apple.client_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].apple, "client_id", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("redirect")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].apple.redirect),expression:"settings[0].apple.redirect"}],staticClass:"form-control",attrs:{"type":"text","name":"client_id","placeholder":"redirect"},domProps:{"value":(_vm.settings[0].apple.redirect)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].apple, "redirect", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("key_id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].apple.key_id),expression:"settings[0].apple.key_id"}],staticClass:"form-control",attrs:{"type":"text","name":"client_id","placeholder":"key_id"},domProps:{"value":(_vm.settings[0].apple.key_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].apple, "key_id", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("team_id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].apple.team_id),expression:"settings[0].apple.team_id"}],staticClass:"form-control",attrs:{"type":"text","name":"client_id","placeholder":"team_id"},domProps:{"value":(_vm.settings[0].apple.team_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].apple, "team_id", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("key")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].apple.key),expression:"settings[0].apple.key"}],staticClass:"form-control",staticStyle:{"height":"150px"},attrs:{"type":"text","name":"client_id","placeholder":"team_id"},domProps:{"value":(_vm.settings[0].apple.key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].apple, "key", $event.target.value)}}})])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[(_vm.settings[0].facebook)?_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("client_id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].facebook.client_id),expression:"settings[0].facebook.client_id"}],staticClass:"form-control",attrs:{"type":"text","name":"client_id","placeholder":"client_id"},domProps:{"value":(_vm.settings[0].facebook.client_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].facebook, "client_id", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("1048664826452257")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("client_secret")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].facebook.client_secret),expression:"settings[0].facebook.client_secret"}],staticClass:"form-control",attrs:{"type":"text","name":"client_secret","placeholder":"client_secret"},domProps:{"value":(_vm.settings[0].facebook.client_secret)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].facebook, "client_secret", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("f375ea240e987043e0464fc5677cb830")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("redirect")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].facebook.redirect),expression:"settings[0].facebook.redirect"}],staticClass:"form-control",attrs:{"type":"text","name":"redirect","placeholder":"redirect"},domProps:{"value":(_vm.settings[0].facebook.redirect)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].facebook, "redirect", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("https://gateway.taptasty.com/handler/facebook/")])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[(_vm.settings[0].google)?_c('div',{staticClass:"row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("client_id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].google.client_id),expression:"settings[0].google.client_id"}],staticClass:"form-control",attrs:{"type":"text","name":"client_id","placeholder":"client_id"},domProps:{"value":(_vm.settings[0].google.client_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].google, "client_id", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("679589114914-stdcelgg7vr4it1qf0vnv9e17vep151u.apps.googleusercontent.com")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("client_secret")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].google.client_secret),expression:"settings[0].google.client_secret"}],staticClass:"form-control",attrs:{"type":"text","name":"client_secret","placeholder":"client_secret"},domProps:{"value":(_vm.settings[0].google.client_secret)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].google, "client_secret", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("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")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("redirect")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settings[0].google.redirect),expression:"settings[0].google.redirect"}],staticClass:"form-control",attrs:{"type":"text","name":"redirect","placeholder":"redirect"},domProps:{"value":(_vm.settings[0].google.redirect)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.settings[0].google, "redirect", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("https://gateway.taptasty.com/handler/google")])])])]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Firebase")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Apple")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Facebook")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Google")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0rET":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0w7I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTicketBubble_vue__ = __webpack_require__("6yfL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c35941_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTicketBubble_vue__ = __webpack_require__("voac");
function injectStyle (ssrContext) {
  __webpack_require__("BryT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58c35941"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTicketBubble_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c35941_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTicketBubble_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0wHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('select',{staticClass:"form-control color-option-default",style:({ backgroundColor: _vm.color, color: _vm.getTextColor(_vm.color) }),attrs:{"name":"color"},domProps:{"value":_vm.color},on:{"change":function($event){_vm.updateColor($event.target.value)}}},_vm._l((_vm.currentPalette),function(item){return _c('option',{key:item,style:(_vm.getOptionStyle(item)),attrs:{"selected":""},domProps:{"value":item}},[_vm._v(_vm._s(item))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0ydz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0yfM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TablePage"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{ref:"optionsTopBar",staticClass:"tables-top-bar tables-top-bar"},[_c('div',{staticClass:"filter__bar"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocaion),expression:"selectedLocaion"}],staticClass:"form-control inline-auto white ",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocaion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{key:loc.true_id,attrs:{"label":loc.name},domProps:{"value":loc.true_id}},[_vm._v(" "+_vm._s(loc.name)+"\n            ")])]})],2)]),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dashboard.selectZone')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedZone),expression:"selectedZone"}],staticClass:"form-control inline-auto white ",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedZone=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.zones),function(loc){return [_c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(" "+_vm._s(loc.name)+"\n            ")])]})],2)]),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('h3',[_c('a',{staticClass:"btn btn-info btn-icon",on:{"click":function($event){$event.preventDefault();_vm.getData()}}},[_c('i',{staticClass:"ti-reload",staticStyle:{"margin-right":"5px"}}),_vm._v(" Cauta")])])])]),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-right":"10px"}},[_c('div',{staticClass:"zoom",on:{"click":function($event){_vm.goFullScreen()}}},[_c('svg',{attrs:{"id":"Component_2_1","data-name":"Component 2 – 1","xmlns":"http://www.w3.org/2000/svg","width":"58","height":"60","viewBox":"0 0 58 60"}},[_c('rect',{attrs:{"id":"Rectangle_6606","data-name":"Rectangle 6606","width":"58","height":"60","rx":"10","fill":"#f3f3f3"}}),_vm._v(" "),_c('g',{attrs:{"id":"Icon_feather-maximize-2","data-name":"Icon feather-maximize-2","transform":"translate(20 21)"}},[_c('path',{attrs:{"id":"Path_24778","data-name":"Path 24778","d":"M22.5,4.5h6.141v6.141","transform":"translate(-10.218 -4.5)","fill":"none","stroke":"#8f8f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_24779","data-name":"Path 24779","d":"M10.641,28.641H4.5V22.5","transform":"translate(-4.5 -10.218)","fill":"none","stroke":"#8f8f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_24780","data-name":"Path 24780","d":"M28.164,4.5,21,11.664","transform":"translate(-9.742 -4.5)","fill":"none","stroke":"#8f8f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_24781","data-name":"Path 24781","d":"M4.5,28.164,11.664,21","transform":"translate(-4.5 -9.742)","fill":"none","stroke":"#8f8f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"tableWrapper"},[_vm._l((_vm.tableData),function(table){return [_c('div',{staticClass:"card table_card mar-to-15",on:{"click":function($event){_vm.openOrdersModal(table.id)}}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"title"},[_c('span',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(table.id))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(table.type)+" "+_vm._s(table.number))]),_vm._v(" "),_c('span',{staticClass:"min_max_pers"},[_vm._v("min_pers: "+_vm._s(table.min_pers || 0)+" - max_pers: "+_vm._s(table.max_pers))]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"0"}}),_vm._v(" "),_c('span',[_vm._v("Comenzi: "+_vm._s(table.nr_orders))]),_c('br'),_vm._v(" "),_c('span',[_vm._v("Rezervari: "+_vm._s(table.nr_reservations))]),_c('br'),_vm._v(" "),(table.first_date_reservations)?[_c('span',[_vm._v("Prima rezervare: ")]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatDateToShowJustDate(table.first_date_reservations)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatDateToShowJustTime(table.first_date_reservations)))])]:_vm._e()],2)])])]})],2)]),_vm._v(" "),_c('vmodal',{staticClass:"ordersModal",attrs:{"name":"ordersModal","width":"90%","height":"90%","maxWidth":900,"minWidth":200,"adaptive":true}},[_c('div',{class:(_vm.loadingOrders ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),(_vm.tableDataInPopup)?[_c('div',{staticClass:"ordersModal__header"},[_c('div',{staticClass:"tableHeader"},[_c('h4',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.tableDataInPopup.type)+" "+_vm._s(_vm.tableDataInPopup.number))]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Zone:")]),_vm._v(" "+_vm._s(_vm.tableDataInPopup.zone))]),_c('br'),_vm._v(" "),(_vm.tableDataInPopup.min_pers && _vm.tableDataInPopup.max_pers)?_c('span',[_vm._v("Intre "+_vm._s(_vm.tableDataInPopup.min_pers)+" si "+_vm._s(_vm.tableDataInPopup.max_pers)+" persoane")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"ordersModal__wrapper"},[_c('div',{staticClass:"cols"},[_c('div',{staticClass:"col reservation_col"},[_c('h4',[_vm._v("Reservation")]),_vm._v(" "),_c('div',{staticClass:"reservations"},[_vm._l((_vm.tableDataInPopup.reservations),function(reservation){return [(reservation)?_c('div',{staticClass:"reservation"},[_c('span',{staticClass:"reservation_id"},[_vm._v("ID: "+_vm._s(reservation.id))]),_vm._v(" "),_c('div',{staticClass:"reservation_data"},[_c('table',{staticStyle:{"text-align":"center","margin":"0"}},[_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.formatDateToShowJustDate(reservation.date_from)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.formatDateToShowJustTime(reservation.date_from)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDateToShowJustTime(reservation.date_to)))])])])]),_vm._v(" "),_c('div',{staticClass:"reservation_data statuses"},[(reservation.status != 'RESERVED')?[_c('button',{class:['statusBtn RESERVED'],on:{"click":function($event){_vm.changeStatusReservation('RESERVED', reservation)}}},[_vm._v("RESERVED")]),_vm._v(" "),_c('button',{class:['statusBtn CANCELED'],on:{"click":function($event){_vm.changeStatusReservation('CANCELED', reservation)}}},[_vm._v("CANCELED")])]:[_vm._l((_vm.reservationStatuses),function(sts){return [(reservation.status == 'RESERVED' && sts != reservation.status)?[_c('button',{class:['statusBtn', 
                                            sts,
                                            reservation.status == sts ? 'active' : ''
                                          ],on:{"click":function($event){_vm.changeStatusReservation(sts, reservation)}}},[_vm._v(_vm._s(sts))])]:_vm._e()]})]],2),_vm._v(" "),_c('div',{staticClass:"reservation_user"},[_c('span',[_vm._v("Name: "+_vm._s(reservation.name))]),_vm._v(" "),_c('span',[_vm._v("Phone: "+_vm._s(reservation.phone))]),_vm._v(" "),_c('span',[_vm._v("Total Persoane: "+_vm._s(reservation.total_pers))])]),_vm._v(" "),_c('div',{staticClass:"reservation_data"},[_c('table',{staticClass:"reservation_prices"},[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Price")])]),_vm._v(" "),_vm._l((reservation.reservations_items),function(resItems){return [_c('tr',[_c('td',[_vm._v(_vm._s(resItems.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(resItems.price))])])]}),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Total Masa:")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(reservation.reservations_table[0].table_total_price))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Total Rezervare:")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(reservation.reservations_table[0].total_price))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Payment Type:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reservation.payment_type))])])],2)])]):_vm._e()]})],2)]),_vm._v(" "),_c('div',{staticClass:"col_bar"}),_vm._v(" "),_c('div',{staticClass:"col order_col"},[_c('h4',[_vm._v("Orders")]),_vm._v(" "),_c('div',{staticClass:"tables"},[_vm._l((_vm.tableDataInPopup.order),function(order){return [_c('div',{staticClass:"order"},[_c('span',[_vm._v("ID:"+_vm._s(order.id))]),_vm._v(" "),_c('span',[_vm._v("TOKEN:"+_vm._s(order.token))]),_vm._v(" "),_c('div',{staticClass:"order_data statuses"},[_vm._l((_vm.statuses),function(sts){return [_c('button',{class:['statusBtn', 
                                        sts,
                                        order.status == sts ? 'active' : ''
                                      ],on:{"click":function($event){_vm.changeStatus(sts, order)}}},[_vm._v(_vm._s(sts))])]})],2),_vm._v(" "),_c('div',{staticClass:"order_data"},[_c('table',{staticClass:"order_prices"},[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Qty")]),_vm._v(" "),_c('th',[_vm._v("Price")])]),_vm._v(" "),_vm._l((order.parts),function(group){return [_vm._l((group.items),function(prod){return [_c('tr',[_c('td',[_vm._v("\n                              "+_vm._s(prod.name)+"\n                              "),_vm._l((prod.options),function(option){return [_c('span',[_vm._v("+ "+_vm._s(option.name)+"("+_vm._s(option.price)+")")])]})],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(prod.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(prod.price))])])]})]}),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Subtotal:")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(order.totals_subtotals))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Taxe:")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(order.totals_shipping + order.totals_extras))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Total Discount:")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(order.totals_discount))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Tips:")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(order.totals_tip))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Total:")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(order.totals_grandtotal))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Payment Type:")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.payment_type))])])],2)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.goToOrder(order.id)}}},[_vm._v("View Order")])])]})],2)])])])]:_vm._e()],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter"},[_c('h3',[_vm._v("Tables")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "111K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select__);









var _components;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntegrationScheduleEditor',
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), _components),
  props: {
    formData: { type: Object, required: true },
    platform: { type: String, required: true },
    disabled: { type: Boolean, default: false }
  },
  data: function data() {
    return { pickerOptions: { start: '00:00', step: '00:15', end: '23:59' } };
  },

  computed: {
    openingKey: function openingKey() {
      return this.platform === 'bolt' ? 'start_at_minutes_from_midnight' : 'opening_time';
    },
    closingKey: function closingKey() {
      return this.platform === 'bolt' ? 'stop_at_minutes_from_midnight' : 'closing_time';
    },
    scheduleDays: function scheduleDays() {
      return this.formData.schedule || [];
    },
    endTimeOptions: function endTimeOptions() {
      var times = [];
      for (var minute = 0; minute < 1440; minute += 15) {
        times.push(String(Math.floor(minute / 60)).padStart(2, '0') + ':' + String(minute % 60).padStart(2, '0'));
      }
      times.push('23:59');
      return times;
    }
  },
  methods: {
    addInterval: function addInterval(dayIdx) {
      var _day$intervals$push;

      if (this.disabled) return;
      var day = this.scheduleDays[dayIdx];
      day.intervals.push((_day$intervals$push = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_day$intervals$push, this.openingKey, '10:00'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_day$intervals$push, this.closingKey, '22:00'), _day$intervals$push));
    },
    removeInterval: function removeInterval(dayIdx, intervalIdx) {
      if (this.disabled || intervalIdx === 0) return;
      this.scheduleDays[dayIdx].intervals.splice(intervalIdx, 1);
    }
  }
});

/***/ }),

/***/ "161f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CantarEdit_vue__ = __webpack_require__("Rq+r");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07244524_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CantarEdit_vue__ = __webpack_require__("8rbq");
function injectStyle (ssrContext) {
  __webpack_require__("9/pE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CantarEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07244524_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CantarEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1CET":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Dja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      onSeriesInputTimeout: null,
      tableData: [],
      allLocations: [],
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      filter: {
        series: ''
      },
      vatNumber: null,
      selectedLocation: null
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.$bus.$on('refresh', this.handleRefresh);
  },
  mounted: function mounted() {
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getInvoices(this.filter.series || '', 'proforma', { locations: this.allLocations });
    },
    onSearch: function onSearch() {
      if (!this.selectedLocation || Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        });

        this.tableData = [];
        this.totalItems = 0;

        return;
      }

      var locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation];
      this.getInvoices(this.filter.series || '', 'proforma', { locations: locations });
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getInvoices(this.filter.series || '', 'proforma', this.selectedLocation, this.currentPage, this.pageSize);
    },
    onSeriesInput: function onSeriesInput(value) {
      this.filter.series = value;
    },
    addInvoice: function addInvoice() {
      this.$router.push('/invoice-tabs/proforma/add');
    },
    editInvoice: function editInvoice(invoiceNumber, series) {
      if (!invoiceNumber || !series) {
        console.error('Missing invoice number or series');
        return;
      }

      var invoiceId = series + '-' + invoiceNumber;
      this.$router.push({
        path: '/invoice-tabs/proforma/' + invoiceId,
        query: { edit: 'true' }
      });
    },
    invoice: function invoice(invoiceNumber, series) {
      if (!invoiceNumber || !series) {
        console.error('Missing invoice number or series');
        return;
      }

      var invoiceId = series + '-' + invoiceNumber;
      this.$router.push('/invoice-tabs/proforma/' + invoiceId);
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (!cellValue) return '';
      return new Date(cellValue).toLocaleDateString();
    },
    getInvoices: function getInvoices() {
      var series = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var tip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proforma';
      var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var _this = this;

      var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var pageSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 25;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var externalCompanyId, url, ids, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, id, allLocations, _ids, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _id, response, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                externalCompanyId = _this.companyID;

                if (externalCompanyId) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/documents?externalCompanyId=' + externalCompanyId + '&tip=' + tip;

                if (series) {
                  url += '&series=' + series;
                }

                url += '&page=' + page + '&limit=' + pageSize;

                if (!location) {
                  _context.next = 33;
                  break;
                }

                if (!Array.isArray(location.locations)) {
                  _context.next = 30;
                  break;
                }

                ids = location.locations.map(function (l) {
                  return l.true_id;
                }).filter(Boolean);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 12;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(ids); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  id = _step.value;

                  url += '&externalLocationId=' + encodeURIComponent(id);
                }
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](12);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 20:
                _context.prev = 20;
                _context.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context.prev = 23;

                if (!_didIteratorError) {
                  _context.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context.finish(23);

              case 27:
                return _context.finish(20);

              case 28:
                _context.next = 31;
                break;

              case 30:
                if (location.id) {
                  if (location.true_id) {
                    url += '&externalLocationId=' + encodeURIComponent(location.true_id);
                  }
                }

              case 31:
                _context.next = 54;
                break;

              case 33:
                allLocations = _this.groupedLocations.flatMap(function (group) {
                  return group.locations;
                });
                _ids = allLocations.map(function (l) {
                  return l.true_id;
                }).filter(Boolean);
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 38;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_ids); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _id = _step2.value;

                  url += '&externalLocationId=' + encodeURIComponent(_id);
                }
                _context.next = 46;
                break;

              case 42:
                _context.prev = 42;
                _context.t1 = _context['catch'](38);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 46:
                _context.prev = 46;
                _context.prev = 47;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 49:
                _context.prev = 49;

                if (!_didIteratorError2) {
                  _context.next = 52;
                  break;
                }

                throw _iteratorError2;

              case 52:
                return _context.finish(49);

              case 53:
                return _context.finish(46);

              case 54:

                clearTimeout(_this.loadingTimeout);
                _this.loadingTimeout = setTimeout(function () {
                  _this.loading = true;
                }, 100);
                _context.prev = 56;
                _context.next = 59;
                return fetch(url);

              case 59:
                response = _context.sent;
                _context.next = 62;
                return response.json();

              case 62:
                data = _context.sent;

                if (Array.isArray(data.documents)) {
                  clearTimeout(_this.loadingTimeout);
                  _this.loading = false;
                  _this.totalItems = data.total || 0;
                  _this.currentPage = data.currentPage || page;
                  _this.pageSize = data.pageSize || pageSize;
                  _this.tableData = data.documents.map(function (invoice) {
                    var vatValue = 0;
                    if (invoice.vatTotals && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(invoice.vatTotals) === 'object') {
                      vatValue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(invoice.vatTotals).reduce(function (sum, val) {
                        return sum + val;
                      }, 0);
                    }

                    return {
                      id: invoice._id || invoice.id,
                      invoiceNumber: invoice.invoiceNumber,
                      client: invoice.customer ? invoice.customer.name : 'N/A',
                      issueDate: invoice.date,
                      valueNoVAT: invoice.subtotal.toFixed(2) + ' ' + invoice.currency,
                      vatValue: vatValue.toFixed(2) + ' ' + invoice.currency,
                      totalValue: invoice.total.toFixed(2) + ' ' + invoice.currency,
                      status: 'Paid',
                      series: invoice.series || 'N/A',
                      hasParent: !!invoice.parentDocument
                    };
                  });
                } else {
                  console.error('Invalid data format:', data);
                }
                _context.next = 69;
                break;

              case 66:
                _context.prev = 66;
                _context.t2 = _context['catch'](56);

                console.error('Error fetching invoices:', _context.t2);

              case 69:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 16, 20, 28], [21,, 23, 27], [38, 42, 46, 54], [47,, 49, 53], [56, 66]]);
      }))();
    },
    downloadExcel: function downloadExcel(row) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                series = row.series;
                invoiceNumber = row.invoiceNumber;
                externalCompanyId = _this2.companyID;

                if (!(!series || !invoiceNumber || !externalCompanyId)) {
                  _context2.next = 6;
                  break;
                }

                alert('Missing series, invoice number or company ID.');
                return _context2.abrupt('return');

              case 6:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/proforma/' + series + '-' + invoiceNumber + '/xls?externalCompanyId=' + externalCompanyId;
                _context2.prev = 7;
                _context2.next = 10;
                return fetch(url);

              case 10:
                response = _context2.sent;

                if (!response.ok) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 14;
                return response.blob();

              case 14:
                blob = _context2.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + invoiceNumber + '.xls';
                link.click();
                URL.revokeObjectURL(link.href);
                _context2.next = 23;
                break;

              case 22:
                console.error('Error downloading invoice:', response.statusText);

              case 23:
                _context2.next = 28;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2['catch'](7);

                console.error('Error fetching invoice:', _context2.t0);

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 25]]);
      }))();
    },
    downloadInvoice: function downloadInvoice(row) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                series = row.series;
                invoiceNumber = row.invoiceNumber;
                externalCompanyId = _this3.companyID;

                if (!(!series || !invoiceNumber)) {
                  _context3.next = 6;
                  break;
                }

                alert('Missing series or invoice number.');
                return _context3.abrupt('return');

              case 6:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/proforma/' + series + '-' + invoiceNumber + '/pdf?externalCompanyId=' + externalCompanyId;
                _context3.prev = 7;
                _context3.next = 10;
                return fetch(url);

              case 10:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 14;
                return response.blob();

              case 14:
                blob = _context3.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + invoiceNumber + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                _context3.next = 23;
                break;

              case 22:
                console.error('Error downloading invoice:', response.statusText);

              case 23:
                _context3.next = 28;
                break;

              case 25:
                _context3.prev = 25;
                _context3.t0 = _context3['catch'](7);

                console.error('Error fetching invoice:', _context3.t0);

              case 28:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[7, 25]]);
      }))();
    },
    handleDeleteProforma: function handleDeleteProforma(id) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log(id);

                if (id) {
                  _context5.next = 4;
                  break;
                }

                console.error('Missing Proforma ID for deletion.');
                return _context5.abrupt('return');

              case 4:

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  title: 'Ești sigur?',
                  text: 'Această acțiune va șterge definitiv proforma!',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Da, șterge!',
                  cancelButtonText: 'Anulează'
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(result) {
                    var response, data;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!result) {
                              _context4.next = 19;
                              break;
                            }

                            _context4.prev = 1;
                            _context4.next = 4;
                            return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                              method: 'DELETE',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                type: 'proforma',
                                id: id,
                                externalCompanyId: _this4.companyID
                              })
                            });

                          case 4:
                            response = _context4.sent;

                            if (response.ok) {
                              _context4.next = 7;
                              break;
                            }

                            throw new Error('HTTP error! Status: ' + response.status);

                          case 7:
                            _context4.next = 9;
                            return response.json();

                          case 9:
                            data = _context4.sent;

                            console.log('Proforma deleted successfully:', data);

                            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                              title: 'Succes!',
                              text: 'Proforma a fost ștearsă cu succes.',
                              type: 'success',
                              timer: 2000,
                              showConfirmButton: false
                            });

                            _this4.getInvoices();
                            _context4.next = 19;
                            break;

                          case 15:
                            _context4.prev = 15;
                            _context4.t0 = _context4['catch'](1);

                            console.error('Error deleting Proforma:', _context4.t0);

                            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                              title: 'Eroare!',
                              text: 'A apărut o problemă la ștergerea proformei.',
                              type: 'error',
                              timer: 2000,
                              showConfirmButton: false
                            });

                          case 19:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this4, [[1, 15]]);
                  }));

                  return function (_x6) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    }
  }
});

/***/ }),

/***/ "1Drb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1FF6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiscalPrinterEdit_vue__ = __webpack_require__("QRcy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_105005c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiscalPrinterEdit_vue__ = __webpack_require__("zj2D");
function injectStyle (ssrContext) {
  __webpack_require__("YCRe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiscalPrinterEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_105005c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiscalPrinterEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1HF3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceProfileAdd_vue__ = __webpack_require__("lUWt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c45598c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceProfileAdd_vue__ = __webpack_require__("tDDt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceProfileAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c45598c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceProfileAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Kqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-radio',
  model: {
    prop: 'value'
  },
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: {
      type: [String, Boolean, Number],
      required: false
    },
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "1MDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementIntegrations_vue__ = __webpack_require__("oM1m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cead6122_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementIntegrations_vue__ = __webpack_require__("rhnu");
function injectStyle (ssrContext) {
  __webpack_require__("DtKv")
  __webpack_require__("IrVx")
  __webpack_require__("usQc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cead6122"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementIntegrations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cead6122_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementIntegrations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1P1l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementAvizForm_vue__ = __webpack_require__("2Sc4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27c4c727_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementAvizForm_vue__ = __webpack_require__("Bmk/");
function injectStyle (ssrContext) {
  __webpack_require__("Eid7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27c4c727"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementAvizForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27c4c727_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementAvizForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1V4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");

















__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    ChartPieCard: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */],
    ChartBarsCard: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]
  },
  created: function created() {
    this.userRole = this.$session.get('userDataRole');

    var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
    this.locations = this.$session.get('selectedCompanyData').locations_details;
    if (!this.isOwner() && allowedLocations.length) {
      this.locations = this.locations.filter(function (el) {
        return allowedLocations.includes(el.id);
      });
    }
    if (this.locations.length > 1) {
      this.showLocations = true;
      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.selectedLocation = filterCookie[0];
      }
    }
    this.getData(this.selectedLocation);
  },
  data: function data() {
    return {
      userRole: null,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      locations: [],
      showLocations: false,
      selectedLocation: '',
      cardsClass: 'col-lg-3 col-sm-12',
      statsCards: {
        'new_orders': {
          type: 'warning',
          icon: 'dash1.png',
          title: this.$t('dashboard.tile1Title'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'total_orders': {
          type: 'success',
          icon: 'dash2.png',
          title: this.$t('dashboard.tile2Title'),
          value: '',
          canceled: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'revenue': {
          type: 'danger',
          icon: 'dash3.png',
          title: this.$t('dashboard.tile3Title'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'installed_apps': {
          type: 'info',
          icon: 'dash2.png',
          title: this.$t('dashboard.tile4Title'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        }
      },
      ordersChart: {
        data: {
          labels: [],
          series: [],
          canceled: [],
          delivered: []
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          },
          height: '200px'
        }
      },
      salesChart: {
        data: {
          labels: ['9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'],
          series: []
        },
        options: {
          showArea: true,
          height: '200px',
          axisX: {
            showGrid: false
          },
          showLine: true
        }
      },
      topProdsChart: {
        title: 'Today',
        data: {
          labels: ['Cappucinno', 'Ristretto', 'Expresso', 'Ice coffe', 'Cookie'],
          series: [[411, 345, 201, 189, 157]]
        },
        options: {
          seriesBarDistance: 10,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      deliveryChart: {
        title: 'Today',
        data: {
          labels: ['Pick-up', 'Meet me half-way', 'On Location', 'Delivery'],
          series: [[411, 345, 201, 189]]
        },
        options: {
          seriesBarDistance: 10,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      paymentsChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      }
    };
  },

  methods: {
    filterLocations: function filterLocations() {
      this.getData(this.selectedLocation);
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.selectedLocation]), 30);
    },
    getData: function getData(location) {
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (location && location !== '') {
        data.location = location;
        this.cardsClass = 'col-lg-4 col-sm-12';
      } else {
        this.cardsClass = 'col-lg-3 col-sm-12';
      }
      this.apiRequest('/reports/dashboard', 'GET', data, function (response) {
        if (response.status === true) {
          self.ordersChart.data.labels = response.data.orders.labels;
          self.ordersChart.data.series = [response.data.orders.delivered];
          self.$refs.refOrdersChart.initChart();

          self.salesChart.data.labels = response.data.sales.labels;
          self.salesChart.data.series = [response.data.sales.values];
          self.$refs.salesChart.initChart();

          self.topProdsChart.data.labels = response.data.top_products.labels;
          self.topProdsChart.data.series = [response.data.top_products.values];
          self.$refs.topProdsChart.initChart();

          self.deliveryChart.data.labels = response.data.delivery_types.labels;
          self.deliveryChart.data.series = [response.data.delivery_types.values];
          self.$refs.deliveryChart.initChart();

          self.statsCards.new_orders.value = response.data.counters.new_orders;
          self.statsCards.total_orders.value = response.data.counters.total_orders;
          self.statsCards.total_orders.canceled = response.data.counters.total_canceled;
          self.statsCards.revenue.value = response.data.counters.revenue;
          self.statsCards.installed_apps.value = response.data.order_average;
        }
      });
    }
  }
});

/***/ }),

/***/ "1ge/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementEntriesForm_vue__ = __webpack_require__("JKdJ");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneIntrariForm', __WEBPACK_IMPORTED_MODULE_7__ManagementEntriesForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "1hFq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyDetails_vue__ = __webpack_require__("YeLk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58010557_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyDetails_vue__ = __webpack_require__("VO75");
function injectStyle (ssrContext) {
  __webpack_require__("FPRT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58010557_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1iZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('management-my-orders-suppliers-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1jC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'r2'
});

/***/ }),

/***/ "1jbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't5'
});

/***/ }),

/***/ "1kFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaignForm_vue__ = __webpack_require__("imS3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417973c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaignForm_vue__ = __webpack_require__("BkAF");
function injectStyle (ssrContext) {
  __webpack_require__("Y2xW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-417973c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaignForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417973c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaignForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1rQM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_barcode_reader__ = __webpack_require__("9iU5");






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('StreamBarcodeReader', __WEBPACK_IMPORTED_MODULE_3_vue_barcode_reader__["a" /* StreamBarcodeReader */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      client: null,
      company: null,
      timestamp: null,
      client_id: null,
      showScanner: true,
      points: 1
    };
  },
  created: function created() {
    if (!document.body.classList.contains('sidebar-mini')) {
      document.body.classList.toggle('sidebar-mini');
    }
  },
  mounted: function mounted() {
    var style = document.createElement('style');
    style.id = 'scanner-swal-dynamic-style';
    style.textContent = '\n      .swal2-popup, .swal2-title, .swal2-html-container, .swal2-content, .swal2-modal, swal2-buttonswrapper, button {\n        font-size: 35px !important;\n      }\n\n      swal2-buttonswrapper, button {\n        font-size: 30px !important;\n      }\n    ';
    document.head.appendChild(style);
  },
  beforeDestroy: function beforeDestroy() {
    var existing = document.getElementById('scanner-swal-dynamic-style');
    if (existing) {
      existing.remove();
    }
  },

  methods: {
    increment: function increment() {
      if (parseInt(this.points) + 5 <= this.client.points) {
        this.points += 5;
      } else {
        this.points = this.client.points;
      }
    },
    subtract: function subtract() {
      this.points = Math.max(0, this.points - 5);
    },
    onLoaded: function onLoaded() {},
    onDecodeQr: function onDecodeQr(text) {
      this.getUser(text);
    },
    getUser: function getUser(hash) {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        hash: hash
      };
      this.apiRequest('/client-by-scanner', 'GET', data, function (response) {
        if (response.status === true) {
          _this.showScanner = false;
          _this.client = response.data.client;
          _this.company = response.data.company;
          _this.points = _this.client.points;
        } else {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            toast: true,
            type: 'warning',
            text: _this.$t('scanner.' + response.error_code),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          });
        }
      });
    },
    subtractPoints: function subtractPoints() {
      var self = this;
      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        text: self.$t('validations.subtractPoints') + ' ' + this.points + ' ' + self.$t('customers.points') + ' (' + parseInt(this.points) / parseInt(this.company.loyalty_value_one_point_amount) + ' ' + this.company.currency + ') ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')',
        cancelButtonText: self.$t('general.no'),
        customClass: 'scanner-swal-popup-lg scanner-swal-content-lg'
      }).then(function (result) {
        if (result) {
          var data = {
            token: self.$session.get('token'),
            company_id: self.$session.get('selectedCompany'),
            hash: self.client.hash,
            points_spent: self.points
          };
          self.apiRequest('/subtract-loyalty-points', 'POST', data, function (response) {
            if (response.status) {
              self.reset();
              __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
                toast: true,
                type: 'success',
                text: self.$t('general.success'),
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                customClass: 'scanner-swal-popup-lg scanner-swal-content-lg'
              });
            } else {
              if (response.error_code === 'expired') self.reset();
              __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
                toast: true,
                type: 'warning',
                text: self.$t('scanner.' + response.error_code),
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                customClass: 'scanner-swal-popup-lg scanner-swal-content-lg'
              });
            }
          });
        }
      });
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.disableConfirmButton();
      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    reset: function reset() {
      this.showScanner = true;
      this.client = null;
      this.company = null;
    }
  }
});

/***/ }),

/***/ "1s1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__("EdqV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bea51e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__("jxm0");
function injectStyle (ssrContext) {
  __webpack_require__("c6a9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bea51e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1wii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Management_ManagementSeriesAdd_vue__ = __webpack_require__("kgt7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);














function getLocalDateTimeString() {
  var now = new Date();
  var year = now.getFullYear();
  var month = String(now.getMonth() + 1).padStart(2, '0');
  var day = String(now.getDate()).padStart(2, '0');
  var hours = String(now.getHours()).padStart(2, '0');
  var minutes = String(now.getMinutes()).padStart(2, '0');
  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__["a" /* default */],
    ManagementSeriesAdd: __WEBPACK_IMPORTED_MODULE_9__Management_ManagementSeriesAdd_vue__["a" /* default */]
  },
  data: function data() {
    return {
      selectedLocationId: '',
      selectedLocation: null,
      locations: [],
      gestiuneOptions: [],
      seriesOptions: [],
      searchResults: [],
      fetchTimer: null,
      currencyOptions: [{ code: 'RON', name: 'Leu Românesc (RON)' }, { code: 'EUR', name: 'Euro (EUR)' }, { code: 'USD', name: 'Dolar American (USD)' }],
      stockInfo: {
        quantity: 0,
        value: 0
      },
      bonConsum: {
        date: getLocalDateTimeString(),
        gestiune: null,
        serie: null,
        currency: 'RON',
        manager: '',
        receiver: '',
        internalNote: '',
        commandProject: '',
        consumptionType: '',
        lot: ''
      },
      loading: false,
      isEdit: !!this.route.params.series && !!this.route.params.number,
      editIndex: null,
      tableData: [],
      item: {
        productObject: null,
        um: '',
        cantitate: null,
        cantitateNecesara: null,
        cantitateConsumata: null
      }
    };
  },

  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    today: function today() {
      var now = new Date();
      now.setSeconds(0, 0);
      return now.toISOString().slice(0, 16);
    },
    seriesOptionsWithAdd: function seriesOptionsWithAdd() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(this.seriesOptions), [{ id: 'add', name: '➕ Adaugă serie' }]);
    },
    groupedLocations: function groupedLocations() {
      var groups = {};

      if (!this.locations || !this.locations.length) return [];

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocationId) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocationId;
      });
      return result;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.fetchGestiuni();
    this.fetchLocation();
  },

  watch: {
    selectedLocationId: function selectedLocationId(id) {
      if (!this.isEdit) {
        this.bonConsum.gestiune = null;
        this.bonConsum.serie = null;
        this.series = null;
        this.documentNumber = null;
        this.selectedLocation = null;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;
            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code);
            }
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    locations: function locations(newLocations) {
      if (newLocations && newLocations.length) {
        var s = this.route && this.route.params && this.route.params.series;
        var inv = this.route && this.route.params && this.route.params.number;
        if (s && inv) {
          this.fetchBonConsum(s, inv);
        }
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveBonConsum();
        }
      });
    },
    getEmptyItem: function getEmptyItem() {
      return {
        editIndex: null,
        productObject: null,
        um: 'buc',
        cantitate: null,
        cantitateNecesara: null,
        cantitateConsumata: null
      };
    },
    formatNumber: function formatNumber(value) {
      if (value === null || value === undefined || value === '') return '0';

      return Number(value).toLocaleString('ro-RO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 20
      });
    },
    handleSerieChange: function handleSerieChange(event) {
      var val = event.target.value;
      if (val === 'add') {
        this.openSeriesModal();
        this.bonConsum.serie = null;
      }
    },
    openSeriesModal: function openSeriesModal() {
      this.$modal.show('addSeriesModal');
    },
    fetchLocation: function fetchLocation() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataToSend = {
                  company_id: _this3.companyID,
                  token: _this3.$session.get('token')
                };


                _this3.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this3.locations = response.data.locations;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetchBonConsum: function fetchBonConsum(seriesParam, invoiceNumberParam) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var transformDate;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                transformDate = function transformDate(isoString) {
                  var d = new Date(isoString);
                  var year = d.getFullYear();
                  var month = String(d.getMonth() + 1).padStart(2, '0');
                  var day = String(d.getDate()).padStart(2, '0');
                  var hours = String(d.getHours()).padStart(2, '0');
                  var minutes = String(d.getMinutes()).padStart(2, '0');
                  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
                };

                _context3.prev = 1;
                return _context3.delegateYield(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                  var response, data, bon, extra, getField, matchedGestiune, gestiuneId, foundLocation, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, group;

                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getDocument?tip=bon_consum&series=' + seriesParam + '&number=' + invoiceNumberParam + '&externalCompanyId=' + _this4.companyID);

                        case 2:
                          response = _context2.sent;

                          if (response.ok) {
                            _context2.next = 5;
                            break;
                          }

                          throw new Error('Failed to fetch bon de consum');

                        case 5:
                          _context2.next = 7;
                          return response.json();

                        case 7:
                          data = _context2.sent;

                          if (!(!data || !Array.isArray(data.documents) || !data.documents.length)) {
                            _context2.next = 10;
                            break;
                          }

                          throw new Error('Bon de consum inexistent');

                        case 10:
                          bon = data.documents[0];
                          extra = bon.extraFields || [];

                          getField = function getField(key) {
                            var field = extra.find(function (f) {
                              return f.key === key;
                            });
                            return field ? field.value : '';
                          };

                          matchedGestiune = _this4.gestiuneOptions.find(function (g) {
                            return g.name === bon.gestiune_from;
                          });
                          gestiuneId = matchedGestiune ? matchedGestiune.id : bon.gestiune_from;


                          _this4.bonConsum = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.bonConsum, {
                            gestiune: gestiuneId,
                            serie: bon.series,
                            lot: bon.lot || '',
                            date: transformDate(bon.date),
                            documentNumber: bon.documentNumber,
                            manager: getField('manager'),
                            receiver: getField('receiver'),
                            internalNote: getField('internalNote'),
                            commandProject: getField('commandProject'),
                            consumptionType: getField('consumptionType')
                          });

                          _this4.tableData = (bon.items || []).map(function (item) {
                            return {
                              productName: item.name,
                              cantitateNecesara: item.quantity_needed,
                              cantitateConsumata: item.quantity_consumed,
                              um: item.um,
                              posId: item.posId
                            };
                          });

                          if (!(bon.externalLocationId && _this4.locations && _this4.locations.length)) {
                            _context2.next = 47;
                            break;
                          }

                          foundLocation = null;
                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _iteratorError2 = undefined;
                          _context2.prev = 22;
                          _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this4.groupedLocations);

                        case 24:
                          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                            _context2.next = 32;
                            break;
                          }

                          group = _step2.value;

                          foundLocation = group.locations.find(function (loc) {
                            return bon.externalLocationId && loc.true_id === bon.externalLocationId || bon.vatNumber && loc.inv_fiscal_code === bon.vatNumber;
                          });

                          if (!foundLocation) {
                            _context2.next = 29;
                            break;
                          }

                          return _context2.abrupt('break', 32);

                        case 29:
                          _iteratorNormalCompletion2 = true;
                          _context2.next = 24;
                          break;

                        case 32:
                          _context2.next = 38;
                          break;

                        case 34:
                          _context2.prev = 34;
                          _context2.t0 = _context2['catch'](22);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context2.t0;

                        case 38:
                          _context2.prev = 38;
                          _context2.prev = 39;

                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }

                        case 41:
                          _context2.prev = 41;

                          if (!_didIteratorError2) {
                            _context2.next = 44;
                            break;
                          }

                          throw _iteratorError2;

                        case 44:
                          return _context2.finish(41);

                        case 45:
                          return _context2.finish(38);

                        case 46:
                          if (foundLocation) {
                            _this4.selectedLocationId = foundLocation.true_id;
                          }

                        case 47:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this4, [[22, 34, 38, 46], [39,, 41, 45]]);
                })(), 't0', 3);

              case 3:
                _context3.next = 8;
                break;

              case 5:
                _context3.prev = 5;
                _context3.t1 = _context3['catch'](1);

                console.error('Error fetching bon de consum:', _context3.t1);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[1, 5]]);
      }))();
    },
    checkValidatedAfter: function checkValidatedAfter(date) {
      var _this5 = this;

      var products = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var queryParams, body, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (date) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt('return', false);

              case 3:

                if (!products) {
                  if (!_this5.tableData || _this5.tableData.length === 0) {
                    products = [];
                  } else {
                    products = _this5.tableData.map(function (item) {
                      return item.posId;
                    });
                  }
                }

                queryParams = new URLSearchParams({
                  date: new Date(date).toISOString(),
                  externalCompanyId: _this5.companyID,
                  externalLocationId: _this5.selectedLocationId
                });
                body = products.length > 0 ? { products: products } : null;
                _context4.next = 8;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/inventar/validated-after-products?' + queryParams.toString(), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: body ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body) : null
                });

              case 8:
                response = _context4.sent;

                if (response.ok) {
                  _context4.next = 11;
                  break;
                }

                throw new Error('Request failed: ' + response.status);

              case 11:
                _context4.next = 13;
                return response.json();

              case 13:
                data = _context4.sent;

                console.log('Response from validated-after:', data);

                if (!data.exists) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 18;
                return __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  icon: 'warning',
                  title: 'Atenție!',
                  text: 'Există deja un inventar validat după această dată pentru unul sau mai multe produse selectate.'
                });

              case 18:
                return _context4.abrupt('return', false);

              case 19:
                return _context4.abrupt('return', true);

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  icon: 'error',
                  title: 'Eroare!',
                  text: 'Nu s-a putut verifica inventarul.'
                });
                return _context4.abrupt('return', false);

              case 27:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 22]]);
      }))();
    },
    saveProduct: function saveProduct() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var productId, isValid, product, newItem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!_this6.item.productObject || !_this6.item.cantitateNecesara || !_this6.item.cantitateConsumata)) {
                  _context5.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Te rugăm să completezi toate câmpurile necesare!',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context5.abrupt('return');

              case 3:
                productId = _this6.item.productObject.product_id || _this6.item.productObject.posId;
                _context5.next = 6;
                return _this6.checkValidatedAfter(_this6.bonConsum.date, [productId]);

              case 6:
                isValid = _context5.sent;

                if (isValid) {
                  _context5.next = 9;
                  break;
                }

                return _context5.abrupt('return');

              case 9:
                product = _this6.item.productObject;
                newItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this6.item, {
                  productName: product && product.productDetails && product.productDetails.name ? product.productDetails.name : product.label || product.name,
                  posId: product && (product.product_id || product.posId)
                });


                console.log('New item added:', newItem);

                if (_this6.editIndex !== null && _this6.editIndex !== undefined) {
                  _this6.$set(_this6.tableData, _this6.editIndex, newItem);
                } else {
                  _this6.tableData.push(newItem);
                }

                _this6.resetModal();
                _this6.$modal.hide('addProductModal');

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    editRow: function editRow(row) {
      var index = this.tableData.indexOf(row);
      if (index === -1) return;

      this.editIndex = index;

      var productObject = {
        posId: row.posId,
        productDetails: {
          name: row.productName,
          posId: row.posId,
          um: row.um
        },
        label: row.productName
      };

      var productOption = {
        label: row.productName,
        value: productObject
      };

      this.searchResults = [productOption];

      this.item = {
        productObject: productObject,
        um: row.um,
        cantitateNecesara: row.cantitateNecesara,
        cantitateConsumata: row.cantitateConsumata,
        posId: row.posId || null
      };

      this.$modal.show('addProductModal');
    },
    deleteRow: function deleteRow(row) {
      var index = this.tableData.indexOf(row);

      if (index !== -1) {
        this.tableData.splice(index, 1);
      }
    },
    _fetchProducts: function _fetchProducts(searchTerm) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var url, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.searchResults = [];

                if (!(!_this7.selectedLocation || !_this7.companyID || !_this7.bonConsum.gestiune || !searchTerm || searchTerm.length < 2)) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt('return');

              case 3:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/products?externalCompanyId=' + _this7.companyID;

                url += '&gestiune=' + _this7.bonConsum.gestiune;
                url += '&externalLocationId=' + _this7.selectedLocation.true_id;
                url += '&name=' + encodeURIComponent(searchTerm);

                _this7.loading = true;
                _context6.prev = 8;
                _context6.next = 11;
                return fetch(url);

              case 11:
                response = _context6.sent;
                _context6.next = 14;
                return response.json();

              case 14:
                data = _context6.sent;


                if (Array.isArray(data.products)) {
                  _this7.searchResults = data.products.map(function (item) {
                    return {
                      label: item.name,
                      posId: item._id,
                      value: item
                    };
                  });
                  console.log(_this7.searchResults);
                } else {
                  _this7.searchResults = [];
                  console.error('Invalid data format:', data);
                }
                _context6.next = 21;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6['catch'](8);

                console.error('Error fetching stock:', _context6.t0);

              case 21:
                _context6.prev = 21;

                _this7.loading = false;
                return _context6.finish(21);

              case 24:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[8, 18, 21, 24]]);
      }))();
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this8 = this;

      if (this.fetchTimer) {
        clearTimeout(this.fetchTimer);
      }

      this.fetchTimer = setTimeout(function () {
        _this8._fetchProducts(searchTerm);
      }, 300);
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this9.companyID);

              case 3:
                response = _context7.sent;

                if (response.ok) {
                  _context7.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context7.next = 8;
                return response.json();

              case 8:
                data = _context7.sent;

                console.log('Date primite de la server:', data.gestiuni);
                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this9.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      externalLocationId: gest.externalLocationId || ''
                    };
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                    title: 'Error!',
                    text: 'Nu s-a primit un array valid de la server.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context7.next = 17;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7['catch'](0);

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Error!',
                  text: 'Request failed: ' + _context7.t0.message,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching management data:', _context7.t0);

              case 17:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[0, 13]]);
      }))();
    },
    getSeries: function getSeries(vatNumber) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this10.companyID,
                    vatNumber: vatNumber,
                    tip: 'bon_consum'
                  })
                });

              case 3:
                response = _context8.sent;

                if (response.ok) {
                  _context8.next = 6;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 6:
                _context8.next = 8;
                return response.json();

              case 8:
                data = _context8.sent;

                console.log('Serii primite:', data.series);

                if (Array.isArray(data.series)) {
                  _this10.seriesOptions = data.series.map(function (serie) {
                    return {
                      id: serie._id,
                      name: serie.series,
                      currentNumber: serie.currentNumber
                    };
                  });
                } else {
                  console.error('Format invalid pentru series:', data);
                }
                _context8.next = 16;
                break;

              case 13:
                _context8.prev = 13;
                _context8.t0 = _context8['catch'](0);

                console.error('Error fetching series:', _context8.t0);

              case 16:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10, [[0, 13]]);
      }))();
    },
    saveBonConsum: function saveBonConsum() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var selectedSerie, serieName, gestiuneId, bonConsumData, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(!_this11.tableData || _this11.tableData.length === 0)) {
                  _context9.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Este necesar un produs minim de adăugat.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context9.abrupt('return');

              case 3:
                selectedSerie = _this11.seriesOptions.find(function (serie) {
                  return serie.id === _this11.bonConsum.serie || serie.name === _this11.bonConsum.serie;
                });
                serieName = selectedSerie ? selectedSerie.name : _this11.bonConsum.serie || null;
                gestiuneId = _this11.bonConsum.gestiune || null;
                bonConsumData = {
                  externalCompanyId: _this11.companyID,
                  externalLocationId: _this11.selectedLocation.true_id,
                  vatNumber: _this11.selectedLocation.inv_fiscal_code,
                  series: serieName,
                  lot: _this11.bonConsum.lot || '',
                  tip: 'bon_consum',
                  gestiune_from: gestiuneId,
                  items: _this11.tableData.map(function (item) {
                    return {
                      posId: item.posId,
                      name: item.productName,
                      quantity: item.cantitateNecesara,
                      quantity_needed: item.cantitateNecesara,
                      quantity_consumed: item.cantitateConsumata,
                      price: item.unitPrice,
                      um: item.um
                    };
                  }),
                  currency: _this11.bonConsum.currency,
                  extraFields: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()({
                    manager: _this11.bonConsum.manager,
                    receiver: _this11.bonConsum.receiver,
                    commandProject: _this11.bonConsum.commandProject,
                    internalNote: _this11.bonConsum.internalNote,
                    consumptionType: _this11.bonConsum.consumptionType
                  }).map(function (_ref3) {
                    var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                        key = _ref4[0],
                        value = _ref4[1];

                    return { key: key, value: value };
                  })
                };


                if (_this11.bonConsum.date) {
                  bonConsumData.date = _this11.bonConsum.date;
                }
                if (_this11.bonConsum.documentNumber) {
                  bonConsumData.documentNumber = _this11.bonConsum.documentNumber;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Salvare în curs...',
                  text: 'Se salvează Bonul de Consum. Așteaptă te rog.',
                  buttons: false,
                  closeOnClickOutside: false,
                  closeOnEsc: false,
                  type: 'info'
                });

                _context9.prev = 10;
                _context9.next = 13;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/bon', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bonConsumData)
                });

              case 13:
                response = _context9.sent;
                _context9.next = 16;
                return response.json();

              case 16:
                data = _context9.sent;


                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.close();

                if (response.ok) {
                  console.log('Bon consum salvat cu succes!', data);

                  __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                    title: 'Succes',
                    text: 'Bonul consum a fost salvat cu succes!',
                    type: 'success',
                    timer: 1500,
                    showConfirmButton: false
                  });

                  _this11.$bus.$emit('refresh');
                  _this11.$bus.$emit('close-modal');
                } else {
                  console.error('Eroare la salvarea bonului consum', data);

                  __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                    title: 'Eroare',
                    text: data.details || data.error || 'A apărut o eroare la salvarea bonului consum.',
                    type: 'error',
                    timer: 1500,
                    showConfirmButton: false
                  });
                }
                _context9.next = 26;
                break;

              case 21:
                _context9.prev = 21;
                _context9.t0 = _context9['catch'](10);

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.close();
                console.error('Eroare la trimiterea cererii', _context9.t0);

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o problemă la trimiterea cererii.',
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                });

              case 26:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11, [[10, 21]]);
      }))();
    },
    fetchStockForProducts: function fetchStockForProducts(productIDs, companyID, gestiune, locationID) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var params, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(!productIDs || productIDs.length === 0)) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt('return', []);

              case 2:
                params = new URLSearchParams();

                productIDs.forEach(function (id) {
                  return params.append('product_ids', id);
                });

                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/stock?externalCompanyId=' + companyID + ('&gestiune=' + gestiune) + ('&externalLocationId=' + locationID + '&' + params.toString());


                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  type: 'info',
                  title: 'Loading Stock...',
                  text: 'Please wait while we fetch stock data...',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  showConfirmButton: false
                });

                _context10.prev = 6;
                _context10.next = 9;
                return fetch(url);

              case 9:
                response = _context10.sent;
                _context10.next = 12;
                return response.json();

              case 12:
                data = _context10.sent;

                if (!Array.isArray(data.stock)) {
                  _context10.next = 17;
                  break;
                }

                return _context10.abrupt('return', data.stock);

              case 17:
                console.error('Invalid data format:', data);
                return _context10.abrupt('return', []);

              case 19:
                _context10.next = 25;
                break;

              case 21:
                _context10.prev = 21;
                _context10.t0 = _context10['catch'](6);

                console.error('Error fetching stock:', _context10.t0);
                return _context10.abrupt('return', []);

              case 25:
                _context10.prev = 25;

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.close();
                return _context10.finish(25);

              case 28:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this12, [[6, 21, 25, 28]]);
      }))();
    },
    handleProductSelect: function handleProductSelect(selectedProduct) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var productId, stockData, stock;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                productId = selectedProduct && selectedProduct.posId || selectedProduct && selectedProduct.value && selectedProduct.value._id;

                if (productId) {
                  _context11.next = 3;
                  break;
                }

                return _context11.abrupt('return');

              case 3:
                _context11.next = 5;
                return _this13.fetchStockForProducts([productId], _this13.companyID, _this13.bonConsum.gestiune, _this13.selectedLocation.true_id);

              case 5:
                stockData = _context11.sent;

                if (!(!stockData || stockData.length === 0)) {
                  _context11.next = 8;
                  break;
                }

                return _context11.abrupt('return');

              case 8:
                stock = stockData[0];


                if (stock && stock.productDetails && stock.productDetails.um) {
                  _this13.item.um = stock.productDetails.um;
                }

                _this13.stockInfo = {
                  quantity: stock && stock.quantity ? stock.quantity : 0,
                  value: stock && stock.value ? stock.value : 0
                };

              case 11:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this13);
      }))();
    },
    openAddProductModal: function openAddProductModal() {
      this.$modal.show('addProductModal');
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    closeModal: function closeModal() {
      this.resetModal();
      this.$modal.hide('addProductModal');
    },
    resetModal: function resetModal() {
      this.item = this.getEmptyItem();
      this.editIndex = null;
      this.stockInfo = {
        quantity: 0,
        value: 0
      };
    }
  }
});

/***/ }),

/***/ "1yuR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1z+n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "21Qg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportProductsLegacyInput_vue__ = __webpack_require__("B/Oa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bc6b682_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportProductsLegacyInput_vue__ = __webpack_require__("btA/");
function injectStyle (ssrContext) {
  __webpack_require__("yT4d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportProductsLegacyInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bc6b682_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportProductsLegacyInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "21i8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartBarsCard_vue__ = __webpack_require__("hvya");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dacf092c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartBarsCard_vue__ = __webpack_require__("Qqv+");
function injectStyle (ssrContext) {
  __webpack_require__("rpXM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartBarsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dacf092c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartBarsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "22Vx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('donation-campaign-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onCampaignSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "23P3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonFiscal_vue__ = __webpack_require__("qRa1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c02def0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonFiscal_vue__ = __webpack_require__("g74j");
function injectStyle (ssrContext) {
  __webpack_require__("efeo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c02def0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonFiscal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c02def0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonFiscal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "23bL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptionsAdd_vue__ = __webpack_require__("RZnj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8fb7012_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptionsAdd_vue__ = __webpack_require__("djXS");
function injectStyle (ssrContext) {
  __webpack_require__("tIqS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptionsAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8fb7012_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptionsAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "24+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('offers-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onOfferSubmit}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2481":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "24WM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "276U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"integration-schedule-editor"},_vm._l((_vm.scheduleDays),function(day,dayIdx){return _c('div',{key:dayIdx,staticClass:"integration-schedule-editor__day",class:{ 'integration-schedule-editor__day--closed': !day.open }},[_c('div',{staticClass:"integration-schedule-editor__weekday checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"id":_vm.platform + '-schedule-day-' + dayIdx,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(day.open)?_vm._i(day.open,null)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.platform + '-schedule-day-' + dayIdx}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + dayIdx))))])]),_vm._v(" "),_c('div',{staticClass:"integration-schedule-editor__periods"},[(!day.open)?_c('span',{staticClass:"integration-schedule-editor__closed"},[_vm._v(_vm._s(_vm.$t('marketplace.closedDay')))]):[_vm._l((day.intervals),function(interval,intervalIdx){return _c('div',{key:intervalIdx,staticClass:"integration-schedule-editor__interval"},[_c('el-time-select',{attrs:{"disabled":_vm.disabled,"placeholder":_vm.$t('menuLink.from'),"picker-options":_vm.pickerOptions,"aria-label":_vm.$t('days.' + dayIdx) + ' ' + _vm.$t('menuLink.from')},model:{value:(interval[_vm.openingKey]),callback:function ($$v) {_vm.$set(interval, _vm.openingKey, $$v)},expression:"interval[openingKey]"}}),_vm._v(" "),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("—")]),_vm._v(" "),_c('el-select',{attrs:{"disabled":_vm.disabled,"placeholder":_vm.$t('menuLink.to'),"aria-label":_vm.$t('days.' + dayIdx) + ' ' + _vm.$t('menuLink.to'),"filterable":""},model:{value:(interval[_vm.closingKey]),callback:function ($$v) {_vm.$set(interval, _vm.closingKey, $$v)},expression:"interval[closingKey]"}},_vm._l((_vm.endTimeOptions),function(time){return _c('el-option',{key:time,attrs:{"label":time,"value":time}})})),_vm._v(" "),(intervalIdx > 0)?_c('button',{staticClass:"integration-schedule-editor__remove",attrs:{"type":"button","disabled":_vm.disabled,"aria-label":_vm.$t('general.delete')},on:{"click":function($event){_vm.removeInterval(dayIdx, intervalIdx)}}},[_c('i',{staticClass:"ti-close",attrs:{"aria-hidden":"true"}})]):_vm._e()],1)}),_vm._v(" "),_c('button',{staticClass:"integration-schedule-editor__add",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){_vm.addInterval(dayIdx)}}},[_c('i',{staticClass:"ti-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('marketplace.addInterval')))])]],2)])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2BWB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2CXN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      drivers: [],
      sortedDrivers: [],
      loading: false
    };
  },
  mounted: function mounted() {
    this.getDriversStatus();
  },

  methods: {
    getDriversStatus: function getDriversStatus() {
      var _this = this;

      this.loading = true;
      var dataToSend = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/get-drivers-status', 'GET', dataToSend, function (response) {
        _this.loading = false;
        if (response.status === true) {
          _this.currencyIso = response.data.currency_iso;
          _this.drivers = response.data.locations.map(function (driver) {
            return {
              id: driver.id,
              name: driver.firstname + ' ' + driver.lastname,
              email: driver.email,
              status: driver.is_online ? 'Online' : 'Offline',
              driver_schedule_active: driver.driver_schedule_active,
              driver_wallet: driver.driver_wallet || 0
            };
          });

          _this.$session.set('drivers', _this.drivers);
        } else {
          console.error('Failed to fetch offline drivers:', response.message);
        }
      });
    },
    getStatusClass: function getStatusClass(status) {
      return status === 'Online' ? 'online' : 'offline';
    },
    handleSortChange: function handleSortChange(_ref) {
      var column = _ref.column,
          prop = _ref.prop,
          order = _ref.order;

      if (prop === 'status') {
        this.sortedDrivers.sort(function (a, b) {
          if (order === 'ascending') {
            return a.status === 'Online' ? -1 : 1;
          } else {
            return a.status === 'Online' ? 1 : -1;
          }
        });
      }
    },
    openAddToWalletModal: function openAddToWalletModal(driver) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: this.$t('general.walletAdd'),
        text: this.$t('general.walletAddFor') + ' ' + driver.name + ':',
        input: 'text',
        inputPlaceholder: this.$t('general.walletPlaceholder'),
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: this.$t('general.add'),
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        if (result) {
          var amount = parseFloat(result.replace(/[^\d.-]/g, ''));
          if (isNaN(amount) || amount < 0) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
              title: 'Error',
              text: _this2.$t('general.invalidAmount'),
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            });
            return;
          }
          var dataToSend = {
            user_id: driver.id,
            amount: amount,
            token: _this2.$session.get('token')
          };
          _this2.apiRequest('/add-to-wallet', 'POST', dataToSend, function (response) {
            if (response.status === true) {
              var driverWallet = response.data.user.driver_wallet;

              var updatedDrivers = _this2.drivers.map(function (d) {
                if (d.id === driver.id) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, d, { driver_wallet: driverWallet });
                }
                return d;
              });

              _this2.drivers = updatedDrivers;

              __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
                title: 'Succes',
                text: _this2.$t('general.walletSuccess'),
                type: 'success',
                timer: 1500,
                showConfirmButton: false
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
                title: 'Error',
                text: _this2.$t('general.walletError'),
                type: 'error',
                timer: 1500,
                showConfirmButton: false
              });
            }
          });
        }
      });
    },
    openRemoveToWalletModal: function openRemoveToWalletModal(driver) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: this.$t('general.walletRemove'),
        text: this.$t('general.walletRemoveFor') + ' ' + driver.name + ':',
        input: 'text',
        inputPlaceholder: this.$t('general.walletPlaceholder'),
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: this.$t('general.remove'),
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        if (result) {
          var amount = parseFloat(result.replace(/[^\d.-]/g, ''));
          if (isNaN(amount) || amount < 0) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
              title: 'Error',
              text: _this3.$t('general.invalidAmount'),
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            });
            return;
          }

          if (amount > driver.driver_wallet) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
              title: 'Error',
              text: _this3.$t('general.amountExceedsBalance'),
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            });
            return;
          }

          var dataToSend = {
            user_id: driver.id,
            amount: amount,
            token: _this3.$session.get('token')
          };

          _this3.apiRequest('/reset-wallet', 'POST', dataToSend, function (response) {
            if (response.status === true) {
              var driverWallet = response.data.user.driver_wallet;

              var updatedDrivers = _this3.drivers.map(function (d) {
                if (d.id === driver.id) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, d, { driver_wallet: driverWallet });
                }
                return d;
              });

              _this3.drivers = updatedDrivers;

              __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
                title: 'Success',
                text: _this3.$t('general.walletRemoved'),
                type: 'success',
                timer: 1500,
                showConfirmButton: false
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
                title: 'Error',
                text: _this3.$t('general.walletRemovalError'),
                type: 'error',
                timer: 1500,
                showConfirmButton: false
              });
            }
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "2DaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-product"},[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n        "+_vm._s(_vm.$t('general.back'))+"\n      ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){_vm.saveBonProduct()}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.isBonProductie')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v("Categorie produs*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategory),expression:"selectedCategory"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.categories),function(category){return _c('option',{key:category.value,domProps:{"value":category.value}},[_vm._v("\n                  "+_vm._s(category.label)+"\n                ")])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productName'))+"*")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.searchResults,"label":"name","placeholder":"Caută un produs...","filterable":false,"disabled":_vm.isEdit},on:{"search":function (term) { return _vm.fetchProducts(term); },"input":_vm.onProductSelect},model:{value:(_vm.productNameRecipe),callback:function ($$v) {_vm.productNameRecipe=$$v},expression:"productNameRecipe"}},[[(!_vm.loading)?_c('span',[_vm._v("Niciun produs găsit")]):_vm._e()]],2),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"cantitateProdusa"}},[_vm._v("Cantitate produsa*")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":"0","placeholder":"Introdu cantitatea"},model:{value:(_vm.bonProduct.cantitateProdusa),callback:function ($$v) {_vm.$set(_vm.bonProduct, "cantitateProdusa", $$v)},expression:"bonProduct.cantitateProdusa"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.location')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                    "+_vm._s(loc.name)+"\n                  ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gestiune"}},[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonProduct.fromGestiune),expression:"bonProduct.fromGestiune"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.bonProduct, "fromGestiune", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selectează gestiunea")]),_vm._v(" "),_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('option',{key:gestiune.id,domProps:{"value":gestiune.id}},[_vm._v("\n                  "+_vm._s(gestiune.name)+"\n                ")])}),_vm._v(" "),(_vm.bonProduct.fromGestiune && !_vm.filteredGestiuni.some(function (g) { return g.id === _vm.bonProduct.fromGestiune; }))?_c('option',{domProps:{"value":_vm.bonProduct.fromGestiune}},[_vm._v("\n                  "+_vm._s(_vm.getGestiuneName(_vm.bonProduct.fromGestiune))+"\n                ")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"serie"}},[_vm._v(_vm._s(_vm.$t('invoice.series'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonProduct.serie),expression:"bonProduct.serie"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.bonProduct, "serie", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.handleSerieChange]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează seria")]),_vm._v(" "),_vm._l((_vm.seriesOptionsWithAdd),function(serie){return _c('option',{key:serie.id,domProps:{"value":serie.id}},[_vm._v("\n                "+_vm._s(serie.id === 'add'
                    ? serie.name
                    : ((serie.name) + " - " + (serie.currentNumber || _vm.bonProduct.documentNumber)))+"\n                ")])}),_vm._v(" "),(_vm.bonProduct.serie && !_vm.seriesOptionsWithAdd.some(function (s) { return s.id === _vm.bonProduct.serie; }))?_c('option',{domProps:{"value":_vm.bonProduct.serie}},[_vm._v("\n                  "+_vm._s(_vm.bonProduct.serie)+"\n                ")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"data"}},[_vm._v(_vm._s(_vm.$t('gestiune.data')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonProduct.date),expression:"bonProduct.date"}],staticClass:"form-control",attrs:{"type":"datetime-local","disabled":!_vm.selectedLocationId,"placeholder":_vm.$t('Selectează data și ora'),"max":_vm.today},domProps:{"value":(_vm.bonProduct.date)},on:{"change":function($event){_vm.checkValidatedAfter(_vm.bonProduct.date, 'bonProduct.date')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bonProduct, "date", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"lot"}},[_vm._v(_vm._s(_vm.$t('gestiune.lot')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introdu lotul","disabled":_vm.isEdit},model:{value:(_vm.bonProduct.lot),callback:function ($$v) {_vm.$set(_vm.bonProduct, "lot", $$v)},expression:"bonProduct.lot"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dataProductie"}},[_vm._v(_vm._s(_vm.$t('gestiune.dataProductie')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonProduct.dataProductie),expression:"bonProduct.dataProductie"}],staticClass:"form-control",attrs:{"type":"datetime-local","placeholder":_vm.$t('Selectează data și ora producției'),"max":_vm.today},domProps:{"value":(_vm.bonProduct.dataProductie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bonProduct, "dataProductie", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dataExpirare"}},[_vm._v(_vm._s(_vm.$t('gestiune.dataExpirare')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonProduct.dataExpirare),expression:"bonProduct.dataExpirare"}],staticClass:"form-control",attrs:{"type":"datetime-local","placeholder":_vm.$t('Selectează data și ora expirării')},domProps:{"value":(_vm.bonProduct.dataExpirare)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bonProduct, "dataExpirare", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProductInBonProductie')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingTable),expression:"loadingTable"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"element-loading-text":"Se încarcă datele..."}},[_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.productName'),"prop":"productName"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('span',[_vm._v(_vm._s(scope.row.productName))]),_vm._v(" "),(scope.row.stoc && scope.row.stoc)?_c('span',{style:({
                  fontSize: '12px',
                  color:
                    scope.row.stoc < 0
                      ? 'red'
                      : scope.row.stoc > 0
                      ? 'green'
                      : 'gray'
                })},[_vm._v("\n                Stoc: "+_vm._s(Number(scope.row.stoc).toFixed(2))+"\n              ")]):_vm._e(),_vm._v(" "),_c('span',{class:_vm.getCategoryClass(scope.row.categorie)},[_vm._v("\n                "+_vm._s(scope.row.categorie)+"\n              ")])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.gestiune_descarcare'),"prop":"gestiune"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.getGestiuneName(_vm.bonProduct.fromGestiune))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.cantitateConsumata'),"prop":"cantitate"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"mini","type":"number","disabled":""},model:{value:(scope.row.cantitate),callback:function ($$v) {_vm.$set(scope.row, "cantitate", $$v)},expression:"scope.row.cantitate"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.scazamant'),"prop":"scazamantValue"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.scazamantType === 'procent')?_c('span',[_vm._v("\n              "+_vm._s(scope.row.scazamantValue)+"%\n            ")]):_c('span',[_vm._v("\n              "+_vm._s(scope.row.scazamantValue)+"\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.um'),"prop":"um"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.um)+"\n          ")]}}])})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"card col-md-6 no-padding"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gestionar"}},[_vm._v(_vm._s(_vm.$t('gestiune.manager')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introdu numele gestionarului"},model:{value:(_vm.bonProduct.manager),callback:function ($$v) {_vm.$set(_vm.bonProduct, "manager", $$v)},expression:"bonProduct.manager"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"primitor"}},[_vm._v(_vm._s(_vm.$t('gestiune.receiver')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introdu numele primitorului"},model:{value:(_vm.bonProduct.receiver),callback:function ($$v) {_vm.$set(_vm.bonProduct, "receiver", $$v)},expression:"bonProduct.receiver"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"notaInterna"}},[_vm._v(_vm._s(_vm.$t('gestiune.internalNote')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Adaugă o notă internă","type":"textarea"},model:{value:(_vm.bonProduct.internalNote),callback:function ($$v) {_vm.$set(_vm.bonProduct, "internalNote", $$v)},expression:"bonProduct.internalNote"}})],1)])])])])]),_vm._v(" "),_c('vmodal',{staticClass:"openEditPriceModal",attrs:{"name":"openEditPriceModal","height":"auto","width":"600"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.editPrice')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.pretVanzare')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.pretVanzare),expression:"item.pretVanzare"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.pretVanzare')},domProps:{"value":(_vm.item.pretVanzare)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "pretVanzare", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currency')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.currency),expression:"item.currency"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"RON"}},[_vm._v("RON")]),_vm._v(" "),_c('option',{attrs:{"value":"EURO"}},[_vm._v("EURO")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.pretPerUnitate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.pretPerUnitate),expression:"item.pretPerUnitate"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.pretPerUnitate')},domProps:{"value":(_vm.item.pretPerUnitate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "pretPerUnitate", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save"},[_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n            ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":function($event){_vm.$modal.hide('openEditPriceModal')}}},[_vm._v("\n              "+_vm._s(_vm.$t('general.cancel2'))+"\n            ")])])])])])]),_vm._v(" "),_c('ManagementSeriesAdd',{attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations,"vat-number":_vm.selectedLocation ? _vm.selectedLocation.inv_fiscal_code : ''},on:{"getSeries":_vm.getSeries}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2FHI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformMenuImports_vue__ = __webpack_require__("75Kl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e21944_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformMenuImports_vue__ = __webpack_require__("T343");
function injectStyle (ssrContext) {
  __webpack_require__("aGLL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60e21944"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformMenuImports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e21944_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformMenuImports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2Igw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushNotifications_vue__ = __webpack_require__("/yjk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b132e1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushNotifications_vue__ = __webpack_require__("s9LM");
function injectStyle (ssrContext) {
  __webpack_require__("YEwK")
  __webpack_require__("Bf4E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b132e1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushNotifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b132e1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushNotifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2Iil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"box-container row tabs-dispatch"},_vm._l((_vm.managementRoutes),function(route,index){return _c('div',{key:route.key,staticClass:"col-md-4"},[(!route.right || route.right && _vm.userHasRight(route.right))?[_c('router-link',{staticClass:"box",style:({ backgroundColor: _vm.getBoxColor(index) }),attrs:{"to":route.path}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('gestiune.' + route.key)))]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.getImageForRoute(route.key),"alt":'Image for ' + route.key}})])])]:_vm._e()],2)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2KDK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      startedInside: false
    };
  },

  methods: {
    handleOverlayClick: function handleOverlayClick(e) {
      if (this.startedInside) {
        this.startedInside = false;
        return;
      }

      this.$emit('close', e);
    }
  }
});

/***/ }),

/***/ "2Nww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceAdd_vue__ = __webpack_require__("J0t7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c4d8e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceAdd_vue__ = __webpack_require__("m5DB");
function injectStyle (ssrContext) {
  __webpack_require__("Jh78")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79c4d8e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c4d8e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2OAG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('pos-user-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2OT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_radio_group_css__ = __webpack_require__("BNJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_radio_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_radio_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group__ = __webpack_require__("fDPO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_radio_css__ = __webpack_require__("8jhb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_radio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_radio_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_radio__ = __webpack_require__("RDoK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("Zki6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input_number__ = __webpack_require__("0kY3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__OrderView_vue__ = __webpack_require__("q0FD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_vue_js_modal__);













































__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_35_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_32_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_30_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_37_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_dropdown_item___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input_number___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_radio___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group___default.a);
__WEBPACK_IMPORTED_MODULE_36_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_41_vue_js_modal___default.a, { componentName: 'vmodal' });
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_39_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_38_src_components_UIComponents_Switch_vue__["a" /* default */],
    OrderForm: __WEBPACK_IMPORTED_MODULE_40__OrderView_vue__["a" /* default */]
  },
  computed: {
    hasActiveFilters: function hasActiveFilters() {
      var hasStatusFilters = this.requestFilters[0].value.length > 0;
      var hasLocationFilters = this.showLocations && this.locationFilter.length > 0;
      var hasPickupDatetime = this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2;
      var hasPlacedDatetime = this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2;
      var hasOrderId = this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== '';
      var hasOrderNumber = this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== '';
      var hasOrderTotal = this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null || this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null;
      var hasOperator = this.orderFilters.operator && this.orderFilters.operator.length > 0;
      var hasPaymentType = this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0;
      var hasDeliveryType = this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0;
      var hasSource = this.orderFilters.source && this.orderFilters.source.length > 0;

      var hasPreorders = this.orderFilters.preorders !== 'all';

      return hasPreorders || hasStatusFilters || hasLocationFilters || hasPickupDatetime || hasPlacedDatetime || hasOrderId || hasOrderNumber || hasOrderTotal || hasOperator || hasPaymentType || hasDeliveryType || hasSource;
    },
    filteredStatuses: function filteredStatuses() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.statuses).filter(function (key) {
        return key !== 'DRAFT';
      });
    }
  },
  created: function created() {
    this.buildWaitingTimeByMethodId();
    this.initializePage();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      timeoutGetData: null,
      isModalFilterChange: false,
      modalOrderFilters: {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: [],
        source: [],
        preorders: 'all'
      },
      route: {},
      modalLocationFilter: [],
      modalSortOrder: 1,
      modalRequestFilters: [{ value: ['OPEN_DRAFT', 'NEW', 'ON_HOLD', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT'] }],
      paginationDef: {
        page: null,
        perPage: 20,
        totalRecords: 0
      },
      pagerCount: 7,
      searchQuery: '',
      timeout: null,
      propsToSearch: ['status', 'price'],
      tableColumns: [{
        prop: 'number',
        label: 'Number',
        minWidth: 100
      }, {
        prop: 'type',
        label: 'Type',
        minWidth: 100
      }],
      orders: [],
      ordersReversed: [],
      useReversed: false,
      tableData: [],
      windowHeight: 0,
      tableTopHeight: 136,
      tableTopHeightFixed: 136,
      tableBottomHeight: 45,
      pageTopHeight: 0,

      requestLimit: 15,
      requestPage: 1,
      customFilter: false,
      showLoadMore: false,
      requestFilters: [{
        value: ['OPEN_DRAFT', 'NEW', 'ON_HOLD', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT'] }, {
        value: [] }, {
        value: '' }],
      locationFilter: [],
      sortOrder: 1,
      showFiltersCollapsed: false,
      operatorOptions: [],
      sourceOptions: [1, 2, 3, 4, 5, 6, 7, 8],
      paymentTypeOptions: ['CASH', 'CARD', 'POS', 'CARD_POS', 'CASH_MACHINE', 'POS_KIOSK', 'ONLINE', 'SPLIT', 'ROOM', 'FOLIO', 'EVENT', 'MANCARE_PERSONAL', 'PROTOCOL', 'VIRAMENT', 'GLOVO_CARD', 'GLOVO_CASH', 'BOLT_CASH', 'BOLT_CARD', 'WOLT_CASH', 'WOLT_CARD', 'null'],
      deliveryTypeOptions: ['PICK_UP', 'DELIVERY', 'EAT_LOCATION', 'MEET_HALF', 'SELF_ORDERING'],
      orderFilters: {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: [],
        source: [],
        preorders: 'all'
      },
      sortOptions: [{
        id: 1,
        name: 'CreatedDescending'
      }, {
        id: 2,
        name: 'CreatedAscending'
      }, {
        id: 3,
        name: 'PickupDescending'
      }, {
        id: 4,
        name: 'PickupAscending'
      }],
      resetFiltersObj: [{ value: ['OPEN_DRAFT', 'NEW', 'ON_HOLD', 'POSTPONED', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT'] }, { value: [] }, { value: '' }],
      filters: [],
      statuses: this.$session.get('defaultData')['order_statuses']['ALL_DELIVERY_TYPES'],
      locations: [],
      showLocations: true,
      editedRowId: null,
      heartbeatSet: false,
      sessionNewOrders: 0,
      sessionProcessingOrders: 0,
      waitingTimeByMethodId: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var companyLocations = _this.$session.get('selectedCompanyData');
      for (var type in _this.statuses) {
        if (type === 'ON_HOLD') {
          if (!companyLocations.is_allowed_on_hold) {
            delete _this.statuses[type];
          }
        }
        if (type === 'POSTPONED') {
          if (!companyLocations.is_allowed_postponed) {
            delete _this.statuses[type];
          }
        }
      }

      _this.windowHeight = window.innerHeight;
      _this.tableTopHeight = _this.$refs.tableTop && _this.$refs.tableTop.clientHeight ? _this.$refs.tableTop.clientHeight : 0;
      _this.tableTopHeightFixed = _this.tableTopHeight;

      if (window.innerWidth < 1200) {
        _this.pageTopHeight = 0;
      } else {
        _this.pageTopHeight = 0;
      }

      window.addEventListener('resize', function () {
        _this.windowHeight = window.innerHeight;
        _this.tableTopHeight = _this.$refs.tableTop && _this.$refs.tableTop.clientHeight ? _this.$refs.tableTop.clientHeight : 0;

        if (!_this.showFiltersCollapsed) {
          _this.tableTopHeightFixed = _this.tableTopHeight;
        }

        if (window.innerWidth < 1200) {
          _this.pageTopHeight = 0;
        } else {
          _this.pageTopHeight = 0;
        }
      });

      if (!_this.heartbeatSet) {
        _this.heartbeat();
        _this.heartbeatSet = true;
      }
    });
  },

  methods: {
    buildWaitingTimeByMethodId: function buildWaitingTimeByMethodId() {
      var map = {};
      var companyData = this.$session.get('selectedCompanyData') || {};
      var locations = companyData.locations_details || [];
      for (var i = 0; i < locations.length; i++) {
        var methods = locations[i].ordering_management || [];
        for (var j = 0; j < methods.length; j++) {
          var method = methods[j];
          if (method && method.id != null) {
            map[String(method.id)] = Number(method.default_waiting_time) || 0;
          }
        }
      }
      this.waitingTimeByMethodId = map;
    },
    isPreorder: function isPreorder(order) {
      if (!order || order.method_id == null || !order.pickup_datetime) {
        return false;
      }
      var waitingMinutes = this.waitingTimeByMethodId[String(order.method_id)];
      if (waitingMinutes == null) {
        return false;
      }
      var pickup = new Date(String(order.pickup_datetime).replace(' ', 'T'));
      if (isNaN(pickup.getTime())) {
        return false;
      }
      var readyAt = Date.now() + waitingMinutes * 60 * 1000;
      return pickup.getTime() > readyAt;
    },
    handleRefresh: function handleRefresh(editedId) {
      this.initializePage();

      if (editedId) {
        this.editedRowId = editedId;
      }
    },
    getCurrentPage: function getCurrentPage() {
      if (this.paginationDef && this.paginationDef.page) {
        return this.paginationDef.page;
      }
      return 1;
    },
    handlePageChange: function handlePageChange(newPage) {
      this.paginationDef.page = newPage;
      this.requestPage = newPage;
      this.getData(false, false);
    },
    initializePage: function initializePage() {
      this.sessionNewOrders = parseInt(this.$session.get('newOrdersCount'));
      this.sessionProcessingOrders = parseInt(this.$session.get('processingOrdersCount'));
      if (this.$session.get('temp-status')) {
        if (this.$session.get('temp-status') === 'refreshSaveStatuses') {
          this.$session.remove('temp-status');
        } else {
          this.requestFilters[0].value = [this.$session.get('temp-status')];
          this.$session.remove('temp-status');
        }
      } else if (this.$session.get('saved-statuses')) {
        this.requestFilters[0].value = this.$session.get('saved-statuses');
        this.$session.remove('saved-statuses');
      } else {
        this.getData(false, false);
      }

      this.locations = this.$session.get('selectedCompanyData').locations_details;
      var allowedLocations = JSON.parse(this.$session.get('userDataLocations') || '[]');
      if (!this.isOwner() && allowedLocations.length) {
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      var filterCookie = this.$cookie.get('filter-orders-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);

        this.locationFilter = this.normalizeLocationFilter(filterCookie);
      }

      this.getPosUsers();

      var sorOrderCookie = this.$cookie.get('sort-order');
      if (sorOrderCookie) {
        this.sortOrder = parseInt(sorOrderCookie) || 1;
      } else {
        this.sortOrder = 1;
      }
      window.removeEventListener('hashchange', this.dataEvent);
      window.addEventListener('hashchange', this.dataEvent);
    },
    dataEvent: function dataEvent() {
      if (this.$refs.orderForm) {
        this.$refs.orderForm.getData();
      }
    },
    updateOrderStatusToProcessed: function updateOrderStatusToProcessed(order) {
      var id = order.id;
      var data = {
        id: id,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        status: 'PROCESSING'
      };
      this.apiRequest('/order/' + id, 'PUT', data, function (response) {});
      this.getData(false, false);
      if (this.$refs.orderForm) {
        this.$refs.orderForm.getData();
      }
    },
    goToRecord: function goToRecord(row, event, column) {
      var automatedProcessedStatus = this.$session.get('selectedCompanyData').automated_processed_status;
      if (row.status.id === 'NEW' && automatedProcessedStatus) {
        this.updateOrderStatusToProcessed(row);
      }

      this.$router.push('/orders/view/' + row.id);
    },

    heartbeat: function heartbeat() {
      var _this2 = this;

      var self = this;
      setInterval(function () {
        var sNO = parseInt(_this2.$session.get('newOrdersCount'));
        var sPO = parseInt(_this2.$session.get('processingOrdersCount'));

        if (!self.customFilter && (_this2.sessionNewOrders !== sNO || _this2.sessionProcessingOrders !== sPO)) {
          self.getData(true, false);
        }

        _this2.sessionNewOrders = sNO;
        _this2.sessionProcessingOrders = sPO;
      }, 8000);
      setInterval(function () {
        if (self.$session.get('temp-status')) {
          if (_this2.$session.get('temp-status') === 'refreshSaveStatuses') {
            self.$session.remove('temp-status');
            self.getData(true, false);
          } else {
            self.requestFilters[0].value = [_this2.$session.get('temp-status')];
            self.$session.remove('temp-status');
            self.getData(true, false);
          }
        }
      }, 1000);
    },

    getData: function getData(isHeartBeat, isLoadMore) {
      var _this3 = this;

      this.$session.set('saved-statuses', this.requestFilters[0].value);

      if (!isHeartBeat) {
        this.$nextTick(function () {
          _this3.loading = true;
        });
      }
      var self = this;
      clearTimeout(self.timeoutGetData);
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        inactive: 1,
        limit: this.requestLimit,
        page: this.getCurrentPage(),
        sort_order: self.useReversed ? 'desc' : 'asc'
      };
      if (this.requestFilters[0].value.length) {
        data.statuses = this.requestFilters[0].value.join(',');
      }
      var filterCookie = this.$cookie.get('filter-orders-locations');
      if (this.locationFilter.length) {
        var normalizedIds = this.locationFilter.map(function (id) {
          return parseInt(id, 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        data.location_ids = normalizedIds.join(',');
      } else if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        if (filterCookie.length) {
          var normalizedCookie = this.normalizeLocationFilter(filterCookie);
          var _normalizedIds = normalizedCookie.map(function (id) {
            return parseInt(id, 10);
          }).filter(function (id) {
            return !isNaN(id);
          });
          data.location_ids = _normalizedIds.join(',');
        }
      }

      var sortOrderId = this.sortOrder || 1;
      var sortOption = this.sortOptions.find(function (sort) {
        return sort.id === parseInt(sortOrderId);
      });
      if (sortOption) {
        data.sort_order = sortOption.name;
      } else {
        data.sort_order = self.useReversed ? 'desc' : 'asc';
      }

      if (this.requestFilters[2].value !== '') {
        data.search = this.requestFilters[2].value;
      }

      if (this.orderFilters.preorders !== 'all') {
        data.preorders = Number(this.orderFilters.preorders);
      }

      if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
        data.pickup_datetime_from = this.orderFilters.pickupDatetime[0];

        data.pickup_datetime_to = this.adjustEndTime(this.orderFilters.pickupDatetime[1]);
      }
      if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
        data.created_at_from = this.orderFilters.placedDatetime[0];

        data.created_at_to = this.adjustEndTime(this.orderFilters.placedDatetime[1]);
      }
      if (this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== '') {
        data.id = String(this.orderFilters.orderId).trim();
      }
      if (this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== '') {
        data.order_number = this.orderFilters.orderNumber.trim();
      }
      if (this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null) {
        data.order_total_min = this.normalizeOrderTotal(this.orderFilters.orderTotalMin);
      }
      if (this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null) {
        data.order_total_max = this.normalizeOrderTotal(this.orderFilters.orderTotalMax);
      }
      if (this.orderFilters.operator && this.orderFilters.operator.length > 0) {
        data.operator = this.orderFilters.operator.join(',');
      }
      if (this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0) {
        data.payment_type = this.orderFilters.paymentType.join(',');
      }
      if (this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0) {
        data.delivery_type = this.orderFilters.deliveryType.join(',');
      }
      if (this.orderFilters.source && this.orderFilters.source.length > 0) {
        data.source = this.orderFilters.source.join(',');
      }

      var currentOrderId = null;
      if (this.showForm()) {
        currentOrderId = parseInt(this.$route.params.id);
      }
      this.apiRequest('/orders-admin', 'GET', data, function (response) {
        if (response.status === true) {
          var goodOrders = [];
          for (var idx in response.data) {
            if (response.data[idx]['status'].id === 'DRAFT') {} else {
              response.data[idx]['status_type'] = response.data[idx]['status'].id;
              response.data[idx]['production_location'] = response.data[idx].production_details !== null ? response.data[idx].production_details.location.id : '';

              goodOrders.push(response.data[idx]);

              if (isHeartBeat && currentOrderId === response.data[idx].id) {
                if (self.$refs.orderForm) {
                  self.$refs.orderForm.heartbeat(response.data[idx]);
                }
              }
            }
            if (response.data[idx]['customer']) {
              var comment = void 0;
              if (response.data[idx]['customer']['comment'] !== null) {
                comment = '<i class="ti-info-alt text-color-red pad-lf-10" title="' + response.data[idx]['customer']['comment'] + '"></i>';
              } else {
                comment = '';
              }
              if (response.data[idx]['customer']['firstname'] === null) {
                if (response.data[idx]['delivery_details_firstname']) {
                  var name = response.data[idx]['delivery_details_firstname'];
                  if (response.data[idx]['customer']['lastname']) {
                    name += ' ' + response.data[idx]['customer']['lastname'];
                  }
                  response.data[idx]['customer_display'] = '<b>' + name + '</b>' + comment;
                  response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['delivery_details_phone'] + '</small>';
                } else if (response.data[idx]['delivery_details_phone']) {
                  response.data[idx]['customer_display'] = '<b>' + response.data[idx]['delivery_details_phone'] + '</b>';
                } else if (response.data[idx]['customer']['phone']) {
                  response.data[idx]['customer_display'] = '<b>' + response.data[idx]['customer']['phone'] + '</b>';
                }
              } else if (response.data[idx]['customer']['firstname'] !== null && response.data[idx]['customer']['lastname'] !== null || response.data[idx]['customer']['firstname'] !== null) {
                if (response.data[idx]['delivery_details_firstname']) {
                  var _name = response.data[idx]['delivery_details_firstname'];
                  if (response.data[idx]['customer']['lastname']) {
                    _name += ' ' + response.data[idx]['customer']['lastname'];
                  }
                  response.data[idx]['customer_display'] = '<b>' + _name + '</b>' + comment;
                } else {
                  var _name2 = response.data[idx]['customer']['firstname'];
                  if (response.data[idx]['customer']['lastname']) {
                    _name2 += ' ' + response.data[idx]['customer']['lastname'];
                  }
                  response.data[idx]['customer_display'] = '<b>' + _name2 + '</b>' + comment;
                }
                if (response.data[idx].delivery_type !== 'SELF_ORDERING') {
                  if (response.data[idx]['delivery_details_phone']) {
                    response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['delivery_details_phone'] + '</small>';
                  } else if (response.data[idx]['customer']['phone']) {
                    response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['customer']['phone'] + '</small>';
                  }
                }
                if (response.data[idx].delivery_type === 'SELF_ORDERING' && response.data[idx]['table_id']) {
                  response.data[idx]['customer_display'] = response.data[idx]['customer_display'] + '<br><small>' + response.data[idx]['table_data']['zone'] + '</small>';
                }
              } else {
                response.data[idx]['customer_display'] = 'CCC';
              }
            } else {
              response.data[idx]['customer_display'] = '';
            }
          }

          if (goodOrders.length < self.requestLimit) {
            self.showLoadMore = false;
          } else {
            self.showLoadMore = true;
          }

          if (isLoadMore) {
            self.orders = self.orders.concat(goodOrders);
          } else {
            self.orders = goodOrders;
          }

          self.tableData = self.orders;

          if (response.pagination) {
            self.paginationDef.totalRecords = response.pagination.totalRecords;
            self.paginationDef.perPage = response.pagination.perPage;
            self.paginationDef.currentPage = response.pagination.page;
            self.paginationDef.totalPages = response.pagination.totalPages;
          }

          self.scrollToCurrent();

          self.$nextTick(function () {
            self.loading = false;
          });

          if (self.$session.get('selectedCompany') === 39 || self.$session.get('selectedCompany') === 50 || self.$session.get('selectedCompany') === 83 || self.$session.get('selectedCompany') === 90 || self.$session.get('selectedCompany') === 106 || self.$session.get('selectedCompany') === 107 || self.$session.get('selectedCompany') === 100 || self.$session.get('selectedCompany') === 125 || self.$session.get('selectedCompany') === 126 || self.$session.get('selectedCompany') === 132 || self.$session.get('selectedCompany') === 142 || self.$session.get('selectedCompany') === 143 || self.$session.get('selectedCompany') === 146 || self.$session.get('selectedCompany') === 164 || self.$session.get('selectedCompany') === 166 || self.$session.get('selectedCompany') === 201 || self.$session.get('selectedCompany') === 30) {
            self.timeoutGetData = setTimeout(function () {
              self.getData(false, false);
            }, 60000);
          }
        }
      });
    },
    scrollToCurrent: function scrollToCurrent() {
      this.$nextTick(function () {
        var el = this.$el.getElementsByClassName('current')[0];
        if (el) {
          var container = this.$refs.tableContainerRef;
          var table = this.$refs.detailsScrollTable.$el.querySelector('.el-table__body tbody');
          var position = 1;

          for (var i = 0; i < table.children.length; i++) {
            if (table.children[i].classList.length > 1 && table.children[i].classList[1] === 'current') {
              if (i > 1) {
                position = i;
              }
            }
          }
          container.scrollTo({
            left: 0,
            top: el.clientHeight * position,
            behavior: 'smooth'
          });
        }
      });
    },
    rowClass: function rowClass(rowData, index) {
      var row = rowData.row || rowData;

      if (parseInt(row.id) === parseInt(this.editedRowId)) {
        return 'highlight-row';
      }

      if (this.$route.params.id && parseInt(row.id) === parseInt(this.$route.params.id)) {
        return 'current row-' + this.orderStatusClass(row.status.id);
      }

      return 'row-' + this.orderStatusClass(row.status.id);
    },
    showForm: function showForm() {
      if (this.$route.path.indexOf('view') !== -1) {
        return true;
      } else {
        return false;
      }
    },
    removeFilter: function removeFilter(filterKey, key) {
      if (filterKey === 0) {
        __WEBPACK_IMPORTED_MODULE_36_vue___default.a.delete(this.requestFilters[filterKey].value, key);
      } else {
        __WEBPACK_IMPORTED_MODULE_36_vue___default.a.delete(this.filters[filterKey].value, key);
      }
      this.tableTopHeight = this.$refs.tableTop.clientHeight;
      this.updateCookie();
    },
    resetFilters: function resetFilters() {
      this.customFilter = false;
      this.requestPage = 1;
      var filter = this.resetFiltersObj;
      this.requestFilters = filter;
      this.locationFilter = [];
      this.orderFilters = {
        pickupDatetime: null,
        placedDatetime: null,
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: [],
        source: [],
        preorders: 'all'
      };

      this.$cookie.set('filter-locations', '', -1);
      this.$router.push('/orders');
      this.getData(false, false);
    },
    loadMore: function loadMore() {
      this.customFilter = true;
      this.requestPage = this.requestPage + 1;
      this.getData(false, true);
    },
    updateCookie: function updateCookie() {
      this.$router.push('/orders');
      this.$cookie.set('filter-orders-locations', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.locationFilter), 30);
      this.requestPage = 1;
      this.getData(false, false);
    },
    updateSortOrderCookie: function updateSortOrderCookie() {
      this.$router.push('/orders');
      this.$cookie.set('sort-order', this.sortOrder, 30);
      this.requestPage = 1;
      this.getData(false, false);
    },
    updateList: function updateList(id, status) {
      var pickupHour = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var idx = this.getObjectByElemKeyValue('id', parseInt(id), this.tableData);
      if (idx) {
        if (status) {
          this.tableData[idx]['status'] = status;
          this.tableData[idx]['status_type'] = status['type'];
        } else if (pickupHour) {
          this.tableData[idx]['pickup_datetime'] = pickupHour;
        }
      }
    },
    openFiltersModal: function openFiltersModal() {
      this.modalRequestFilters = [{
        value: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.requestFilters[0].value))
      }];

      this.modalLocationFilter = this.normalizeLocationFilter(this.locationFilter);

      this.modalSortOrder = parseInt(this.sortOrder) || 1;

      var pickupDatetime = null;
      if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
        pickupDatetime = [this.orderFilters.pickupDatetime[0], this.adjustEndTime(this.orderFilters.pickupDatetime[1])];
      }

      var placedDatetime = null;
      if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
        placedDatetime = [this.orderFilters.placedDatetime[0], this.adjustEndTime(this.orderFilters.placedDatetime[1])];
      }

      this.modalOrderFilters = {
        pickupDatetime: pickupDatetime,
        placedDatetime: placedDatetime,
        orderId: this.orderFilters.orderId,
        orderNumber: this.orderFilters.orderNumber,
        orderTotalMin: this.orderFilters.orderTotalMin,
        orderTotalMax: this.orderFilters.orderTotalMax,
        operator: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.orderFilters.operator || [])),
        paymentType: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.orderFilters.paymentType || [])),
        deliveryType: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.orderFilters.deliveryType || [])),
        preorders: this.orderFilters.preorders,
        source: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.orderFilters.source || []))
      };
      this.$modal.show('filtersAndSortModal');
    },
    applyFilters: function applyFilters() {
      var _this4 = this;

      this.isModalFilterChange = true;

      this.requestFilters[0].value = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalRequestFilters[0].value));

      this.locationFilter = this.normalizeLocationFilter(this.modalLocationFilter);
      this.sortOrder = this.modalSortOrder;

      var pickupDatetime = null;
      if (this.modalOrderFilters.pickupDatetime && this.modalOrderFilters.pickupDatetime.length === 2) {
        pickupDatetime = [this.modalOrderFilters.pickupDatetime[0], this.adjustEndTime(this.modalOrderFilters.pickupDatetime[1])];
      }

      var placedDatetime = null;
      if (this.modalOrderFilters.placedDatetime && this.modalOrderFilters.placedDatetime.length === 2) {
        placedDatetime = [this.modalOrderFilters.placedDatetime[0], this.adjustEndTime(this.modalOrderFilters.placedDatetime[1])];
      }

      this.orderFilters = {
        pickupDatetime: pickupDatetime,
        placedDatetime: placedDatetime,
        orderId: this.modalOrderFilters.orderId,
        orderNumber: this.modalOrderFilters.orderNumber,
        orderTotalMin: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMin),
        orderTotalMax: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMax),
        operator: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.operator || [])),
        paymentType: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.paymentType || [])),
        deliveryType: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.deliveryType || [])),
        preorders: this.modalOrderFilters.preorders,
        source: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.source || []))
      };

      this.$cookie.set('sort-order', this.sortOrder, 30);
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.locationFilter), 30);
      this.$modal.hide('filtersAndSortModal');

      this.$nextTick(function () {
        _this4.isModalFilterChange = false;
        _this4.requestPage = 1;
        _this4.getData(false, false);
      });
    },
    resetModalFilters: function resetModalFilters() {
      this.modalRequestFilters[0].value = ['OPEN_DRAFT', 'NEW', 'ON_HOLD', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'PICKED_UP_BY_DELIVERY', 'AWAITING_TRANSPORT'];
      this.modalLocationFilter = [];
      this.modalSortOrder = 1;
      this.modalOrderFilters = {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: [],
        source: [],
        preorders: 'all'
      };

      this.requestFilters[0].value = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalRequestFilters[0].value));
      this.locationFilter = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalLocationFilter));
      this.sortOrder = this.modalSortOrder;
      this.orderFilters = {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: [],
        source: [],
        preorders: 'all'
      };

      this.$cookie.set('sort-order', this.sortOrder, 30);

      this.updateCookie();
    },
    removeStatusFilter: function removeStatusFilter(index) {
      this.requestFilters[0].value.splice(index, 1);
      this.updateCookie();
    },
    removeLocationFilter: function removeLocationFilter(index) {
      this.locationFilter.splice(index, 1);
      this.updateCookie();
    },
    removePreordersFilter: function removePreordersFilter() {
      this.orderFilters.preorders = 'all';
      this.updateCookie();
    },
    removePickupDatetimeFilter: function removePickupDatetimeFilter() {
      this.orderFilters.pickupDatetime = null;
      this.updateCookie();
    },
    removePlacedDatetimeFilter: function removePlacedDatetimeFilter() {
      this.orderFilters.placedDatetime = null;
      this.updateCookie();
    },
    removeOrderIdFilter: function removeOrderIdFilter() {
      this.orderFilters.orderId = '';
      this.updateCookie();
    },
    removeOrderNumberFilter: function removeOrderNumberFilter() {
      this.orderFilters.orderNumber = '';
      this.updateCookie();
    },
    removeOrderTotalFilter: function removeOrderTotalFilter() {
      this.orderFilters.orderTotalMin = null;
      this.orderFilters.orderTotalMax = null;
      this.updateCookie();
    },
    removeOperatorFilter: function removeOperatorFilter(index) {
      if (index !== undefined) {
        this.orderFilters.operator.splice(index, 1);
      } else {
        this.orderFilters.operator = [];
      }
      this.updateCookie();
    },
    togglePaymentTypeFilter: function togglePaymentTypeFilter(paymentType) {
      this.isModalFilterChange = true;
      if (!this.orderFilters.paymentType) {
        this.orderFilters.paymentType = [];
      }
      var idx = this.orderFilters.paymentType.indexOf(paymentType);
      if (idx === -1) {
        this.orderFilters.paymentType.push(paymentType);
      } else {
        this.orderFilters.paymentType.splice(idx, 1);
      }
    },
    toggleModalPaymentTypeFilter: function toggleModalPaymentTypeFilter(paymentType) {
      if (!this.modalOrderFilters.paymentType) {
        this.modalOrderFilters.paymentType = [];
      }
      var idx = this.modalOrderFilters.paymentType.indexOf(paymentType);
      if (idx === -1) {
        this.modalOrderFilters.paymentType.push(paymentType);
      } else {
        this.modalOrderFilters.paymentType.splice(idx, 1);
      }
    },
    toggleModalDeliveryTypeFilter: function toggleModalDeliveryTypeFilter(deliveryType) {
      if (!this.modalOrderFilters.deliveryType) {
        this.modalOrderFilters.deliveryType = [];
      }
      var idx = this.modalOrderFilters.deliveryType.indexOf(deliveryType);
      if (idx === -1) {
        this.modalOrderFilters.deliveryType.push(deliveryType);
      } else {
        this.modalOrderFilters.deliveryType.splice(idx, 1);
      }
    },
    removePaymentTypeFilter: function removePaymentTypeFilter(index) {
      if (index !== undefined) {
        this.orderFilters.paymentType.splice(index, 1);
      } else {
        this.orderFilters.paymentType = [];
      }
      this.updateCookie();
    },
    removeDeliveryTypeFilter: function removeDeliveryTypeFilter(index) {
      if (index !== undefined) {
        this.orderFilters.deliveryType.splice(index, 1);
      } else {
        this.orderFilters.deliveryType = [];
      }
      this.updateCookie();
    },
    formatLabelFirstLetter: function formatLabelFirstLetter(translationKey) {
      try {
        var label = this.$t(translationKey);
        if (!label || typeof label !== 'string') {
          var fallback = translationKey.split('.').pop();
          return fallback ? fallback.toLowerCase().split(' ').map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
          }).join(' ') : translationKey;
        }

        return label.toLowerCase().split(' ').map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ');
      } catch (e) {
        var key = translationKey.split('.').pop();
        return key ? key.toLowerCase().split(' ').map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ') : translationKey;
      }
    },
    getPosUsers: function getPosUsers() {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status && response.data && response.data.pos_user) {
          _this5.operatorOptions = response.data.pos_user.map(function (user) {
            return {
              id: user.id,
              label: ((user.firstname || '') + ' ' + (user.lastname || '')).trim() || 'User ' + user.id
            };
          });
        }
      });
    },
    removeSourceFilter: function removeSourceFilter(index) {
      if (index !== undefined) {
        this.orderFilters.source.splice(index, 1);
      } else {
        this.orderFilters.source = [];
      }
      this.updateCookie();
    },
    toggleStatusFilter: function toggleStatusFilter(key) {
      this.isModalFilterChange = true;
      var idx = this.requestFilters[0].value.indexOf(key);
      if (idx === -1) {
        this.requestFilters[0].value.push(key);
      } else {
        this.requestFilters[0].value.splice(idx, 1);
      }
    },
    toggleModalStatusFilter: function toggleModalStatusFilter(key) {
      var idx = this.modalRequestFilters[0].value.indexOf(key);
      if (idx === -1) {
        this.modalRequestFilters[0].value.push(key);
      } else {
        this.modalRequestFilters[0].value.splice(idx, 1);
      }
    },
    toggleSourceFilter: function toggleSourceFilter(src) {
      this.isModalFilterChange = true;
      if (!this.orderFilters.source) {
        this.orderFilters.source = [];
      }
      var idx = this.orderFilters.source.indexOf(src);
      if (idx === -1) {
        this.orderFilters.source.push(src);
      } else {
        this.orderFilters.source.splice(idx, 1);
      }
    },
    toggleModalSourceFilter: function toggleModalSourceFilter(src) {
      if (!this.modalOrderFilters.source) {
        this.modalOrderFilters.source = [];
      }
      var idx = this.modalOrderFilters.source.indexOf(src);
      if (idx === -1) {
        this.modalOrderFilters.source.push(src);
      } else {
        this.modalOrderFilters.source.splice(idx, 1);
      }
    },
    toggleFiltersCollapse: function toggleFiltersCollapse() {
      var _this6 = this;

      this.showFiltersCollapsed = !this.showFiltersCollapsed;
      this.$nextTick(function () {
        if (!_this6.showFiltersCollapsed && _this6.$refs.tableTop) {
          _this6.tableTopHeight = _this6.$refs.tableTop.clientHeight;
          _this6.tableTopHeightFixed = _this6.tableTopHeight;
        }
      });
    },
    getLocationName: function getLocationName(locationId) {
      var location = this.locations.find(function (loc) {
        return loc.true_id === locationId || loc.id === locationId;
      });
      return location ? location.name : locationId;
    },
    normalizeLocationFilter: function normalizeLocationFilter(locationFilter) {
      var _this7 = this;

      if (!locationFilter || !Array.isArray(locationFilter) || locationFilter.length === 0) {
        return [];
      }
      var normalized = [];

      var _loop = function _loop(value) {
        var numValue = typeof value === 'string' ? parseInt(value, 10) : value;

        var location = _this7.locations.find(function (loc) {
          if (loc.true_id === numValue || loc.true_id === value) return true;
          if (loc.id === numValue || loc.id === value) return true;

          if (typeof value === 'string') {
            return String(loc.true_id) === value || String(loc.id) === value;
          }
          return false;
        });
        if (location && location.true_id) {
          var trueId = parseInt(location.true_id, 10);
          if (!isNaN(trueId) && !normalized.includes(trueId)) {
            normalized.push(trueId);
          }
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(locationFilter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var value = _step.value;

          _loop(value);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return normalized;
    },
    getOperatorName: function getOperatorName(operatorId) {
      var operator = this.operatorOptions.find(function (op) {
        return op.id === operatorId;
      });
      return operator ? operator.label : operatorId;
    },
    formatDateRange: function formatDateRange(dateRange) {
      if (!dateRange || dateRange.length !== 2) return '';
      return dateRange[0] + ' - ' + dateRange[1];
    },
    normalizeOrderTotal: function normalizeOrderTotal(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      var num = Number(value);

      if (isNaN(num) || num === 0) {
        return null;
      }
      return num;
    },
    adjustEndTime: function adjustEndTime(datetime) {
      if (datetime && datetime.endsWith('00:00:00')) {
        return datetime.replace('00:00:00', '23:59:59');
      }
      return datetime;
    },
    adjustDatetimeRange: function adjustDatetimeRange(filterType) {
      if (this.modalOrderFilters[filterType] && this.modalOrderFilters[filterType].length === 2) {
        this.modalOrderFilters[filterType] = [this.modalOrderFilters[filterType][0], this.adjustEndTime(this.modalOrderFilters[filterType][1])];
      }
    },
    search: function search() {
      clearTimeout(this.timeout);

      var self = this;
      this.timeout = setTimeout(function () {
        self.requestFilters[2].value = self.searchQuery;
      }, 500);
    },
    convertLabelingJsonToHtml: function convertLabelingJsonToHtml(labeling) {
      var label = JSON.parse(labeling);
      var labelLevel = '<p style="color:' + label.color + ';">' + label.name + '</p>';
      return labelLevel;
    },
    changeDeliveryStatus: function changeDeliveryStatus(statusUsed, deliveryType) {
      if (statusUsed === 'DELIVERED' && deliveryType === 'EAT_LOCATION') {
        statusUsed = 'reservedReady';
        return this.$t('ordersStatus.' + statusUsed);
      }
      if (statusUsed === 'DELIVERED' && deliveryType === 'PICK_UP') {
        statusUsed = 'completedReady';
        return this.$t('ordersStatus.' + statusUsed);
      }
      if (statusUsed === 'DELIVERED' && (deliveryType === 'MEET_HALF' || deliveryType === 'DELIVERY')) {
        statusUsed = 'deliveredReady';
        return this.$t('ordersStatus.' + statusUsed);
      }
      return this.$t('ordersStatus.' + statusUsed);
    },
    getCourierIntegrationStatus: function getCourierIntegrationStatus(order) {
      if (!order || order.delivery_type !== 'DELIVERY') return null;

      var woltStatus = order.wolt_drive_status != null ? Number(order.wolt_drive_status) : order.integration && order.integration.wolt_drive_status != null ? Number(order.integration.wolt_drive_status) : null;
      var deliveryHeroStatus = order.delivery_hero_status != null ? Number(order.delivery_hero_status) : order.integration && order.integration.delivery_hero_status != null ? Number(order.integration.delivery_hero_status) : null;
      var glovoStatus = order.glovo_status != null ? Number(order.glovo_status) : null;

      if (woltStatus != null && woltStatus > 0) {
        return { type: 'wolt_drive', status: woltStatus };
      }
      if (deliveryHeroStatus != null && deliveryHeroStatus > 0) {
        return { type: 'delivery_hero', status: deliveryHeroStatus };
      }
      if (glovoStatus != null && glovoStatus > 0) {
        return { type: 'glovo_laas', status: glovoStatus };
      }
      return null;
    },
    isCourierDeliveryError: function isCourierDeliveryError(status) {
      return status === 3 || status === 6;
    },
    getCourierDeliveryLabel: function getCourierDeliveryLabel(order) {
      var courier = this.getCourierIntegrationStatus(order);
      if (!courier) return '';
      if (this.isCourierDeliveryError(courier.status)) {
        return this.$t('orders.courierDeliveryError');
      }
      if (courier.status === 2) {
        return this.$t('orders.courierDeliverySuccess');
      }
      return '';
    },
    getCourierDeliveryLabelClass: function getCourierDeliveryLabelClass(order) {
      var courier = this.getCourierIntegrationStatus(order);
      if (!courier) return 'primary';
      if (this.isCourierDeliveryError(courier.status)) return 'danger';
      if (courier.status === 2) return 'success';
      return 'primary';
    }
  },
  watch: {
    requestFilters: {
      handler: function handler(newval, oldval) {
        if (this.isModalFilterChange) {
          return;
        }

        var self = this;
        var onlyDefaults = newval[0]['value'].filter(function (elm) {
          return self.resetFiltersObj[0]['value'].indexOf(elm) === -1;
        });

        var rev = false;

        if (!onlyDefaults.length) {
          this.customFilter = false;
          rev = false;
        } else {
          this.customFilter = true;
          rev = true;
        }
        this.useReversed = rev;

        this.requestPage = 1;

        this.getData(false, false);

        this.paginationDef.pageSize = this.tableData.length + 1;
      },
      deep: true
    }
  }
});

/***/ }),

/***/ "2OUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle navbar-toggle-black",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/login"}},[_vm._v("\n              Looking to login?\n            ")])],1)])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/admin"}},[_vm._v("\n          Dashboard\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("Paper Dashboard PRO")]),_vm._v(" "),_c('h4',[_vm._v("Register for free and experience the dashboard today.")]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-danger"},[_c('i',{staticClass:"ti ti-user"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Free Account")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-warning"},[_c('i',{staticClass:"ti-bar-chart-alt"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Awesome Performances")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-info"},[_c('i',{staticClass:"ti-headphone"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Global Support")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Your First Name"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Your Last Name"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Company"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Enter email"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password Confirmation"}})])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"}},[_vm._v("Create Free Account")])])])])])])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Coded with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            "),_c('a',{attrs:{"href":"http://11digits.com","target":"_blank"}},[_vm._v("11Digits")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2RAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('location-groups-form',{on:{"on-submit":_vm.onSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2RDU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Sc4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Management_Nomenclator_ManagementClientsAdd_vue__ = __webpack_require__("QxJS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Management_ManagementSeriesAdd_vue__ = __webpack_require__("kgt7");















function getLocalDateTimeString() {
  var now = new Date();
  var year = now.getFullYear();
  var month = String(now.getMonth() + 1).padStart(2, '0');
  var day = String(now.getDate()).padStart(2, '0');
  var hours = String(now.getHours()).padStart(2, '0');
  var minutes = String(now.getMinutes()).padStart(2, '0');
  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementClientsAdd: __WEBPACK_IMPORTED_MODULE_10__Management_Nomenclator_ManagementClientsAdd_vue__["a" /* default */],
    ManagementSeriesAdd: __WEBPACK_IMPORTED_MODULE_11__Management_ManagementSeriesAdd_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      loadingProducts: false,
      selectedLocationId: '',
      isEdit: false,
      isInvoice: false,
      searchTerm: '',
      currentNumber: '',
      clientName: '',
      clientCUI: '',
      clientEmail: '',
      clientPhone: '',
      clientAddress: '',
      clientVATPayer: 'yes',
      clientLegalStatus: 'juridica_ro',
      issueDate: getLocalDateTimeString(),
      dueDate: getLocalDateTimeString(),
      seriesNumber: '',
      currency: 'RON',
      language: 'ro',
      productName: '',
      quantity: 0,
      priceRON: 0,
      vatRate: 0,
      includeVAT: 'no',
      vatNumber: null,
      isDisabled: false,
      searchResults: [],
      items: [],
      vats: [],
      selectedLocation: null,
      clientResults: [],
      clientSelected: null,
      gestiuneOptions: [],
      descarcaGestiunea: false,
      newItem: {
        gestiuneId: null,
        productName: '',
        unitMeasure: 'buc',
        quantity: 1,
        priceRON: null,
        vatRate: '',
        includeVAT: 'no',
        type: '',
        code: ''
      },
      fetchClientsCalled: false,
      modelValidate: {
        clientCUI: { required: true },
        clientName: { required: true },
        clientAddress: { required: true },
        productName: { required: true },
        clientPhone: { required: true },
        unitMeasure: { required: true },
        quantity: { required: true },
        priceRON: { required: true },
        vatRate: { required: true },
        includeVAT: { required: true }
      },
      myOrder: {},
      extraFields: {
        intocmitDe: '',
        cnp: '',
        delegat: '',
        carteIdentitate: '',
        auto: '',
        agentVanzari: '',
        punctDeLucruClient: '',
        numarComandaBT13: '',
        numarContractBT12: '',
        referintaProiectBT11: '',
        identificatorCumparatorBT46: '',
        numarAvizReceptieBT15: '',
        referintaContabilaCumparatorBT19: '',
        dataLivrarii: '',
        dataIncasarii: '',
        notaInterna: ''
      },
      isAviz: false,
      locations: [],
      seriesOptions: [],
      gestiuniList: []
    };
  },

  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    today: function today() {
      var now = new Date();
      now.setSeconds(0, 0);
      return now.toISOString().slice(0, 16);
    },
    seriesOptionsWithAdd: function seriesOptionsWithAdd() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(this.seriesOptions), [{ id: 'add', nume: '➕ Adaugă serie' }]);
    },
    groupedLocations: function groupedLocations() {
      var groups = {};

      if (!this.locations || !this.locations.length) return [];

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocationId) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocationId;
      });
      return result;
    },
    totalFaraTva: function totalFaraTva() {
      return this.items.reduce(function (acc, item) {
        var qty = Number(item.quantity) || 0;
        var priceNoVAT = Number(item.priceRON) || 0;
        return acc + priceNoVAT * qty;
      }, 0);
    },
    totalTva: function totalTva() {
      return this.items.reduce(function (acc, item) {
        var qty = Number(item.quantity) || 0;
        var priceNoVAT = Number(item.priceRON) || 0;
        var vat = Number(item.vatRate) || 0;

        return acc + priceNoVAT * vat / 100 * qty;
      }, 0);
    },
    totalCorectie: function totalCorectie() {
      return 0;
    },
    totalFinal: function totalFinal() {
      return this.totalFaraTva + this.totalTva + this.totalCorectie;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    var invoiceId = this.route && this.route.params && this.route.params.id;
    var path = this.route && this.route.path;

    if (invoiceId !== 'add') {
      var _invoiceId$split = invoiceId.split('-'),
          _invoiceId$split2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_invoiceId$split, 2),
          series = _invoiceId$split2[0],
          invoiceNumber = _invoiceId$split2[1];

      if (!series || !invoiceNumber) {
        console.error('Invalid invoice ID format');
        return;
      }

      this.series = series;
      this.invoiceNumber = invoiceNumber;

      if (this.route.query.edit === 'true') {
        this.isEdit = true;
      } else {
        this.isInvoice = path.includes('outputs');
      }
    }
    this.fetchGestiuni();
    this.fetchLocation();
  },

  watch: {
    selectedLocationId: function selectedLocationId(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;
            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code);

              this.loadVats(loc.true_id);
            }
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    locations: function locations(newLocations) {
      if (newLocations && newLocations.length) {
        var _route$query = this.route.query,
            series = _route$query.series,
            number = _route$query.number,
            isAviz = _route$query.isAviz;

        this.isAviz = isAviz === 'true' || isAviz === true;

        if (this.isAviz) {
          this.fetchOrder(series, number);
        }

        var invoiceId = this.route.params.id;
        console.log(invoiceId, this.isAviz);
        if (invoiceId && (this.isInvoice || this.isEdit)) {
          if (this.selectedLocation && this.selectedLocation.inv_fiscal_code) {
            this.getSeries(this.selectedLocation.inv_fiscal_code);
          }
          this.getInvoiceDetails(invoiceId);
        }
      }
    },
    clientCUI: function clientCUI(newCUI) {
      if (this.isInvoice || this.isEdit || this.isAviz) {
        return;
      }

      if (this.fetchClientsCalled) return;

      if (newCUI.length >= 8) {
        this.fetchCompanyDetails(newCUI);
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveAviz();
        }
      });
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    parseDateTimeLocal: function parseDateTimeLocal(dateString) {
      if (!dateString) return '';
      var d = new Date(dateString);
      var yyyy = d.getFullYear();
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var dd = String(d.getDate()).padStart(2, '0');
      var hh = String(d.getHours()).padStart(2, '0');
      var min = String(d.getMinutes()).padStart(2, '0');
      return yyyy + '-' + mm + '-' + dd + 'T' + hh + ':' + min;
    },
    loadVats: function loadVats(locationId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.fetchVats(locationId);

              case 2:
                _this3.vats = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    onClientSelect: function onClientSelect(client) {
      if (client && client.id === 'add') {
        this.openAddClientModal();
        this.clientSelected = null;
        this.clientName = '';
        this.clientCUI = '';
        this.clientEmail = '';
        this.clientPhone = '';
        this.clientAddress = '';
      } else if (client) {
        this.clientSelected = client;

        this.clientName = client.fullData.name || '';
        this.clientCUI = client.fullData.vatNumber || client.vatNumber || '';
        this.clientEmail = client.fullData.email || '';
        this.clientPhone = client.fullData.phone || '';
        this.clientAddress = client.fullData.address || '';
      } else {
        this.clientSelected = null;
        this.clientName = '';
        this.clientCUI = '';
        this.clientEmail = '';
        this.clientPhone = '';
        this.clientAddress = '';
      }
    },
    openAddClientModal: function openAddClientModal() {
      this.client = {
        companyName: '',
        abbreviation: '',
        CUI: '',
        email: '',
        registrationNumber: '',
        address: '',
        bank: '',
        IBAN: '',
        dueDays: null,
        id: null,
        _rev: null
      };
      this.$modal.show('addClientModal');
    },
    fetchClients: function fetchClients(query) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var vatNumber, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.fetchClientsCalled = true;

                vatNumber = _this4.selectedLocation && _this4.selectedLocation.inv_fiscal_code;


                _this4.loading = true;
                _context2.prev = 3;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/customers' + ('?name=' + encodeURIComponent(query)) + ('&externalCompanyId=' + _this4.companyID) + (vatNumber ? '&vatNumber=' + encodeURIComponent(vatNumber) : '');
                _context2.next = 7;
                return fetch(url);

              case 7:
                response = _context2.sent;
                _context2.next = 10;
                return response.json();

              case 10:
                data = _context2.sent;


                if (Array.isArray(data.customers)) {
                  _this4.clientResults = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(data.customers.map(function (client) {
                    return {
                      id: client._id,
                      nume: client.name,
                      vatNumber: client.vatNumber,
                      fullData: client
                    };
                  })), [{ id: 'add', nume: '➕ Adaugă client' }]);
                } else {
                  _this4.clientResults = [{ id: 'add', nume: '➕ Adaugă client' }];
                }
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](3);

                console.error('Error fetching clients:', _context2.t0);
                _this4.clientResults = [{ id: 'add', nume: '➕ Adaugă client' }];

              case 18:
                _context2.prev = 18;

                _this4.loading = false;
                return _context2.finish(18);

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[3, 14, 18, 21]]);
      }))();
    },
    fetchLocation: function fetchLocation() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dataToSend = {
                  company_id: _this5.companyID,
                  token: _this5.$session.get('token')
                };


                _this5.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this5.locations = response.data.locations;
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    fetchOrder: function fetchOrder(series, number) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/order?series=' + series + '&number=' + number + '&externalCompanyId=' + _this6.companyID);

              case 3:
                response = _context4.sent;

                if (response.ok) {
                  _context4.next = 6;
                  break;
                }

                throw new Error('Eroare la fetch order: ' + response.status);

              case 6:
                _context4.next = 8;
                return response.json();

              case 8:
                data = _context4.sent;


                if (data) {
                  _this6.myOrder = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data);

                  if (data.externalLocationId) {
                    _this6.selectedLocationId = data.externalLocationId;
                  }

                  _this6.items = data.products.map(function (item) {
                    var quantity = item.quantity_faptic || item.quantity_scriptic || 0;
                    var priceRON = item.pret_fara_tva || 0;
                    var vatRate = item.tva_percent != null ? item.tva_percent : '';
                    var includeVAT = vatRate > 0 ? 'yes' : 'no';

                    var priceFaraTVA = priceRON;
                    var tvaUnit = priceFaraTVA * vatRate / 100;

                    var totalFaraTVA = priceFaraTVA * quantity;
                    var totalTVA = tvaUnit * quantity;

                    return {
                      posId: item.posId,
                      productName: item.productName || '',
                      type: item.type || 'N/A',
                      code: item.code || 'N/A',
                      unitMeasure: item.unitMeasure || 'BUC',
                      quantity: quantity,
                      priceRON: (priceFaraTVA + tvaUnit).toFixed(2),
                      vatRate: String(vatRate),
                      includeVAT: includeVAT,
                      gestiuneFrom: item.gestiune,
                      priceFaraTVA: priceFaraTVA.toFixed(2),
                      valoare: (totalFaraTVA + totalTVA).toFixed(2),
                      tva: totalTVA.toFixed(2)
                    };
                  });

                  if (_this6.locations && _this6.locations.length) {
                    _this6.populateClientFromLocation();
                  }
                } else {
                  console.error('Comandă invalidă primită:', data);
                  __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                    title: 'Eroare',
                    text: 'Comanda nu a fost găsită.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context4.next = 16;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](0);

                console.error('Eroare la fetch order:', _context4.t0);
                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o problemă la încărcarea comenzii.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 12]]);
      }))();
    },
    getInvoiceDetails: function getInvoiceDetails(invoiceId) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (invoiceId) {
                  _context6.next = 3;
                  break;
                }

                console.error('Missing invoice ID');
                return _context6.abrupt('return');

              case 3:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/getDocument/?tip=aviz&series=' + _this7.series + '&number=' + _this7.invoiceNumber + '&externalCompanyId=' + _this7.companyID;
                _context6.prev = 4;
                return _context6.delegateYield(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
                  var response, result, data, foundLocation, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, group, customer, clientObj;

                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return fetch(url, {
                            method: 'GET',
                            headers: {
                              'Content-Type': 'application/json'
                            }
                          });

                        case 2:
                          response = _context5.sent;

                          if (response.ok) {
                            _context5.next = 5;
                            break;
                          }

                          throw new Error('HTTP error! Status: ' + response.status);

                        case 5:
                          _context5.next = 7;
                          return response.json();

                        case 7:
                          result = _context5.sent;
                          data = result.documents && result.documents.length ? result.documents[0] : null;


                          _this7.parentSeries = data.series;
                          _this7.parentInvoiceNumber = data.invoiceNumber;

                          _this7.invoiceData = data;
                          _this7.items = data.items.map(function (item) {
                            var quantity = _this7.isStorno ? -1 * item.quantity : item.quantity;
                            var priceRON = item.price || 0;
                            var vatRate = item.tva != null ? item.tva : 19;
                            var includeVAT = vatRate > 0 ? 'yes' : 'no';

                            var priceFaraTVA = priceRON;
                            var totalFaraTVA = +(priceFaraTVA * quantity).toFixed(2);
                            var totalTVA = +(priceFaraTVA * quantity * vatRate / 100).toFixed(2);
                            var totalValoare = +(totalFaraTVA + totalTVA).toFixed(2);

                            return {
                              posId: item.posId,
                              productName: item.name || '',
                              type: item.type || 'N/A',
                              code: item.code || 'N/A',
                              unitMeasure: item.unitMeasure || 'BUC',
                              quantity: quantity,
                              priceRON: priceRON.toFixed(2),
                              vatRate: String(vatRate),
                              includeVAT: includeVAT,
                              gestiuneFrom: item.gestiune_from,
                              priceFaraTVA: priceFaraTVA.toFixed(2),
                              valoare: totalValoare.toFixed(2),
                              tva: totalTVA.toFixed(2)
                            };
                          });
                          _this7.currency = data.currency;
                          _this7.seriesNumber = data.series;
                          _this7.clientName = data.customer.name;
                          _this7.clientCUI = data.customer.cnp;
                          _this7.clientEmail = data.customer.email;
                          _this7.clientPhone = data.customer.phone;
                          _this7.clientAddress = data.customer.address;

                          _this7.seriesOptions = [{
                            series: data.series,
                            currentNumber: data.invoiceNumber
                          }];
                          _this7.seriesNumber = data.series;
                          _this7.currentNumber = data.invoiceNumber;

                          if (data.extraFields) {
                            _this7.extraFields = data.extraFields.reduce(function (acc, field) {
                              acc[field.key] = field.value;
                              return acc;
                            }, {});
                          }

                          _this7.issueDate = _this7.parseDateTimeLocal(data.issueDate || data.date);
                          _this7.dueDate = _this7.parseDateTimeLocal(data.dueDate || data.date);

                          if (!(data.externalLocationId && _this7.locations && _this7.locations.length)) {
                            _context5.next = 56;
                            break;
                          }

                          foundLocation = null;
                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _iteratorError2 = undefined;
                          _context5.prev = 31;
                          _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(_this7.groupedLocations);

                        case 33:
                          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                            _context5.next = 41;
                            break;
                          }

                          group = _step2.value;

                          foundLocation = group.locations.find(function (loc) {
                            return data.externalLocationId && loc.true_id === data.externalLocationId || data.vatNumber && loc.inv_fiscal_code === data.vatNumber;
                          });

                          if (!foundLocation) {
                            _context5.next = 38;
                            break;
                          }

                          return _context5.abrupt('break', 41);

                        case 38:
                          _iteratorNormalCompletion2 = true;
                          _context5.next = 33;
                          break;

                        case 41:
                          _context5.next = 47;
                          break;

                        case 43:
                          _context5.prev = 43;
                          _context5.t0 = _context5['catch'](31);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context5.t0;

                        case 47:
                          _context5.prev = 47;
                          _context5.prev = 48;

                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }

                        case 50:
                          _context5.prev = 50;

                          if (!_didIteratorError2) {
                            _context5.next = 53;
                            break;
                          }

                          throw _iteratorError2;

                        case 53:
                          return _context5.finish(50);

                        case 54:
                          return _context5.finish(47);

                        case 55:
                          if (foundLocation) {
                            _this7.selectedLocationId = foundLocation.true_id;
                          }

                        case 56:

                          if (data.customer) {
                            console.log('Customer data found:', data.customer);
                            customer = data.customer;
                            clientObj = {
                              id: 'temp-' + customer.cnp,
                              nume: customer.name,
                              vatNumber: customer.cnp,
                              fullData: customer
                            };


                            _this7.clientSelected = clientObj;
                            console.log('Selected client from invoice:', clientObj);
                            _this7.onClientSelect(clientObj);
                          }

                        case 57:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this7, [[31, 43, 47, 55], [48,, 50, 54]]);
                })(), 't0', 6);

              case 6:
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t1 = _context6['catch'](4);

                console.error('Error fetching invoice details:', _context6.t1);

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[4, 8]]);
      }))();
    },
    fetchCompanyDetails: function fetchCompanyDetails(cui) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var company;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return _this8.fetchAnafCompanyByCui(cui);

              case 3:
                company = _context7.sent;

                _this8.applyAnafCompanyToFields(company, 'simpleClient');
                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7['catch'](0);

                console.error('Error fetching company details:', _context7.t0);

              case 10:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[0, 7]]);
      }))();
    },
    populateClientFromLocation: function populateClientFromLocation() {
      var _this9 = this;

      if (this.myOrder && this.myOrder.supplierExternalLocationId) {
        var matchedLocation = this.locations.find(function (loc) {
          return loc.true_id === _this9.myOrder.supplierExternalLocationId;
        });

        if (matchedLocation) {
          this.clientName = matchedLocation.inv_company_name || '';
          this.clientCUI = matchedLocation.inv_fiscal_code || '';
          this.clientAddress = matchedLocation.inv_address || '';
          this.clientEmail = matchedLocation.inv_email || '';
          this.clientPhone = matchedLocation.inv_phone || '';
          this.clientLegalStatus = 'juridica_ro';
          this.clientVATPayer = 'yes';
        }
      }
    },
    searchOrder: function searchOrder() {
      var _this10 = this;

      var id = this.searchTerm ? parseInt(this.searchTerm.trim(), 10) : null;
      var data = {
        token: this.$session.get('token'),
        company_id: this.companyID,
        id: id
      };

      if (!id) {
        __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
          type: 'warning',
          title: 'Atenție',
          text: 'Te rog introdu un ID de comandă.'
        });
        return;
      }

      __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
        title: 'Se caută comanda...',
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        content: {
          element: 'div',
          attributes: {
            innerHTML: '<div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>'
          }
        }
      });

      this.apiRequest('/get-products-from-order/', 'GET', data, function (response) {
        __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.close();

        if (response.status === true && response.data && Array.isArray(response.data.items) && response.data.items.length > 0) {
          _this10.isDisabled = true;

          var firstGestiune = _this10.gestiuniList.length ? _this10.gestiuniList[0].name : '';
          _this10.receipt_number = response.data.receipt_number || null;

          _this10.items = response.data.items.map(function (item) {
            var rawQuantity = parseFloat(item.quantity);
            var rawPrice = parseFloat(item.price);
            var quantity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(rawQuantity) ? rawQuantity : 1;
            var price = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(rawPrice) ? rawPrice : 0;

            if (price < 0) {
              if (quantity > 0) quantity = -quantity;else if (quantity === 0) quantity = -1;
              price = Math.abs(price);
            }
            var vatRate = item.vat != null ? item.vat : '';
            var includeVAT = item.includeVAT === 'no' ? 'no' : 'yes';

            var priceFaraTVA = 0;
            var tvaUnit = 0;
            var priceCuTVA = 0;

            if (includeVAT === 'yes') {
              priceCuTVA = price;
              priceFaraTVA = price / (1 + vatRate / 100);
              tvaUnit = price - priceFaraTVA;
            } else {
              priceFaraTVA = price;
              tvaUnit = price * (vatRate / 100);
              priceCuTVA = price + tvaUnit;
            }

            var totalFaraTVA = priceFaraTVA * quantity;
            var totalTVA = tvaUnit * quantity;

            return {
              productName: item.name || '',
              type: item.type || 'N/A',
              code: item.product_code || 'N/A',
              unitMeasure: item.unit || 'BUC',
              quantity: quantity,
              priceRON: priceFaraTVA.toFixed(2),
              priceCuTVA: priceCuTVA.toFixed(2),
              vatRate: String(vatRate),
              includeVAT: includeVAT,
              gestiune: firstGestiune,
              priceFaraTVA: priceFaraTVA.toFixed(2),
              valoare: (totalFaraTVA + totalTVA).toFixed(2),
              tva: totalTVA.toFixed(2)
            };
          });

          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
            icon: 'success',
            title: 'Comandă găsită',
            text: 'Am preluat ' + _this10.items.length + ' articole din comand\u0103.'
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
            icon: 'error',
            title: 'Eroare',
            text: 'Comanda nu a fost găsită.'
          });
        }
      });
    },
    calculateItemTotals: function calculateItemTotals(item) {
      var quantity = Number(item.quantity);
      var priceRON = Number(item.priceRON);
      var vatRate = Number(item.vatRate);
      var includeVAT = item.includeVAT === 'yes';

      console.log('Calculating totals for item:', vatRate);
      console.log('Include VAT:', includeVAT);

      var priceFaraTVA = void 0,
          tvaUnit = void 0,
          totalFaraTVA = void 0,
          totalTVA = void 0;

      if (includeVAT) {
        priceFaraTVA = priceRON / (1 + vatRate / 100);
        tvaUnit = priceRON - priceFaraTVA;
      } else {
        priceFaraTVA = priceRON;
        tvaUnit = priceFaraTVA * vatRate / 100;
      }

      totalFaraTVA = priceFaraTVA * quantity;
      totalTVA = tvaUnit * quantity;
      return {
        priceFaraTVA: priceFaraTVA,
        total: totalFaraTVA + totalTVA,
        tva: totalTVA };
    },
    addItem: function addItem() {
      if (this.newItem.gestiuneId && this.newItem.productName && this.newItem.unitMeasure && this.newItem.quantity > 0 && this.newItem.priceRON > 0 && this.newItem.type && this.newItem.code && this.newItem.vatRate !== null && this.newItem.includeVAT !== '') {
        var totals = this.calculateItemTotals(this.newItem);

        console.log(totals);
        var newItemWithTotals = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.newItem, {
          priceRON: totals.priceFaraTVA.toFixed(2),
          valoare: totals.total.toFixed(2),
          tva: totals.tva.toFixed(2),
          gestiuneFrom: this.newItem.gestiuneId
        });
        console.log(this.newItem.posId);
        this.items.push(newItemWithTotals);
        this.resetNewItem();
      } else {}
    },
    getGestiuneName: function getGestiuneName(gestiuneId) {
      var gestiune = this.gestiuneOptions.find(function (g) {
        return g.id === gestiuneId;
      });
      return gestiune ? gestiune.name : 'N/A';
    },
    removeItem: function removeItem(index) {
      this.items.splice(index, 1);
    },
    resetNewItem: function resetNewItem() {
      this.newItem = {
        gestiuneId: null,
        productName: '',
        unitMeasure: '',
        quantity: null,
        priceRON: null,
        type: '',
        code: '',
        vatRate: '',
        includeVAT: 'no'
      };
    },
    getSeries: function getSeries(vatNumber) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var tipSerie, response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                tipSerie = _this11.route.query.edit === 'true' ? 'aviz' : _this11.route.params.id !== 'add' ? 'invoice' : 'aviz';
                _context8.prev = 1;
                _context8.next = 4;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this11.companyID,
                    vatNumber: vatNumber,
                    tip: tipSerie
                  })
                });

              case 4:
                response = _context8.sent;

                if (response.ok) {
                  _context8.next = 7;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 7:
                _context8.next = 9;
                return response.json();

              case 9:
                data = _context8.sent;

                console.log('Serii primite:', data.series);

                if (Array.isArray(data.series) && data.series.length > 0) {
                  _this11.seriesOptions = data.series.map(function (serie) {
                    return {
                      series: serie.series,
                      currentNumber: serie.currentNumber
                    };
                  });

                  _this11.seriesNumber = _this11.seriesOptions[0].series;
                  _this11.currentNumber = _this11.seriesOptions[0].currentNumber;
                } else {
                  console.warn('Nu există serii disponibile pentru acest cod fiscal.');

                  _this11.seriesOptions = [];
                  _this11.seriesNumber = '';
                  _this11.currentNumber = '';
                }
                _context8.next = 20;
                break;

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8['catch'](1);

                console.error('Error fetching series:', _context8.t0);

                _this11.seriesOptions = [];
                _this11.seriesNumber = '';
                _this11.currentNumber = '';

              case 20:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[1, 14]]);
      }))();
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this12.companyID);

              case 3:
                response = _context9.sent;

                if (response.ok) {
                  _context9.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context9.next = 8;
                return response.json();

              case 8:
                data = _context9.sent;

                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this12.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      externalLocationId: gest.externalLocationId || ''
                    };
                  });
                } else {
                  _this12.$message.error('Nu s-a primit un array valid de la server.');
                }
                _context9.next = 16;
                break;

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9['catch'](0);

                _this12.$message.error('Request failed: ' + _context9.t0.message);
                console.error('Error fetching management data:', _context9.t0);

              case 16:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12, [[0, 12]]);
      }))();
    },
    updateNumber: function updateNumber() {
      var _this13 = this;

      if (this.seriesNumber === 'add') {
        this.openSeriesModal();
        return;
      }

      var selectedSeries = this.seriesOptions.find(function (series) {
        return series.series === _this13.seriesNumber;
      });

      if (selectedSeries) {
        this.currentNumber = selectedSeries.currentNumber;
      } else {
        this.currentNumber = '';
      }
    },
    openSeriesModal: function openSeriesModal() {
      this.$modal.show('addSeriesModal');
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(!_this14.selectedLocation || !searchTerm || searchTerm.length < 2)) {
                  _context10.next = 3;
                  break;
                }

                _this14.searchResults = [];
                return _context10.abrupt('return');

              case 3:

                _this14.loadingProducts = true;
                _context10.prev = 4;
                _context10.next = 7;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/products?vatNumber=' + _this14.selectedLocation.inv_fiscal_code + '&name=' + encodeURIComponent(searchTerm) + '&externalCompanyId=' + _this14.companyID);

              case 7:
                response = _context10.sent;
                _context10.next = 10;
                return response.json();

              case 10:
                data = _context10.sent;


                if (Array.isArray(data.products)) {
                  _this14.searchResults = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(data.products));
                }
                _context10.next = 17;
                break;

              case 14:
                _context10.prev = 14;
                _context10.t0 = _context10['catch'](4);

                console.error('Error fetching products:', _context10.t0);

              case 17:
                _context10.prev = 17;

                _this14.loadingProducts = false;
                return _context10.finish(17);

              case 20:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this14, [[4, 14, 17, 20]]);
      }))();
    },
    onProductSelected: function onProductSelected(selectedProduct) {
      if (typeof selectedProduct === 'string' || !selectedProduct) {
        this.resetNewItem();
        return;
      }

      this.newItem.posId = selectedProduct.posId || selectedProduct._id;
      this.newItem.code = selectedProduct.product_code || '';
      this.newItem.type = selectedProduct.categorie || '';
      this.newItem.unitMeasure = selectedProduct.um;
      this.newItem.quantity = selectedProduct.quantity || 1;
      this.newItem.priceRON = selectedProduct.pret_vanzare && selectedProduct.pret_vanzare.length > 0 && selectedProduct.pret_vanzare[0].price || '';
      this.newItem.vatRate = selectedProduct.vat_percent != null ? String(selectedProduct.vat_percent) : '';
      this.newItem.includeVAT = selectedProduct.is_with_vat ? 'yes' : 'no';
    },
    updateOrderWithAviz: function updateOrderWithAviz(series, number) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var currentExternalDocs, updateOrderPayload, response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                currentExternalDocs = _this15.myOrder.externalDocIds || {};
                updateOrderPayload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this15.myOrder, {
                  externalDocIds: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, currentExternalDocs, {
                    aviz: {
                      series: series,
                      number: number
                    }
                  }),
                  status: 'avizat'
                });
                _context11.prev = 2;
                _context11.next = 5;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/order', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(updateOrderPayload)
                });

              case 5:
                response = _context11.sent;


                if (!response.ok) {
                  console.warn('Order update with aviz_id failed');
                } else {
                  console.log('Order updated with aviz:', series, number);
                }
                _context11.next = 12;
                break;

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11['catch'](2);

                console.error('Error updating order with aviz_id:', _context11.t0);

              case 12:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this15, [[2, 9]]);
      }))();
    },
    saveAviz: function saveAviz() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var invoiceData, response, errorData, errorMessage, data, isAviz;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(!_this16.seriesNumber || !_this16.currency || !_this16.clientName || !_this16.clientCUI || !_this16.clientAddress)) {
                  _context12.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: 'Please complete all mandatory fields before saving the aviz.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context12.abrupt('return');

              case 3:
                if (!_this16.items.some(function (item) {
                  return !item.productName || !item.unitMeasure || !item.quantity || !item.priceRON || !item.vatRate;
                })) {
                  _context12.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: 'Please complete all product details (name, unit measure, quantity, price, VAT rate).',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context12.abrupt('return');

              case 6:
                invoiceData = {
                  tip: 'aviz',
                  externalCompanyId: _this16.companyID,
                  dueDate: _this16.dueDate,
                  issueDate: _this16.issueDate,
                  externalLocationId: _this16.selectedLocation.true_id,
                  vatNumber: _this16.selectedLocation.inv_fiscal_code,
                  items: _this16.items.map(function (item) {
                    return {
                      name: item.productName.name || item.productName,
                      type: item.type,
                      code: item.code,
                      posId: item.posId,
                      unitMeasure: item.unitMeasure,
                      quantity: item.quantity,
                      price: parseFloat(item.priceRON),
                      tva: item.vatRate,
                      gestiune_from: item.gestiuneId || item.gestiuneFrom
                    };
                  }),
                  currency: _this16.currency,
                  series: _this16.seriesNumber,
                  customer: {
                    name: _this16.clientName,
                    cnp: _this16.clientCUI,
                    email: _this16.clientEmail,
                    phone: _this16.clientPhone,
                    address: _this16.clientAddress
                  },
                  extraFields: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(_this16.extraFields).map(function (_ref3) {
                    var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                        key = _ref4[0],
                        value = _ref4[1];

                    return { key: key, value: value };
                  })
                };


                if (_this16.isEdit && _this16.invoiceData && _this16.invoiceData.invoiceNumber) {
                  invoiceData.number = _this16.invoiceData.invoiceNumber;
                }

                _context12.prev = 8;
                _context12.next = 11;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/document', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(invoiceData) });

              case 11:
                response = _context12.sent;

                if (response.ok) {
                  _context12.next = 19;
                  break;
                }

                _context12.next = 15;
                return response.json();

              case 15:
                errorData = _context12.sent;
                errorMessage = errorData.error || 'Error saving aviz';


                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: errorMessage,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

                throw new Error('Error saving aviz');

              case 19:
                _context12.next = 21;
                return response.json();

              case 21:
                data = _context12.sent;

                console.log('Aviz saved successfully:', data);

                isAviz = _this16.route.query.isAviz;

                if (!(isAviz && data.series && data.invoiceNumber)) {
                  _context12.next = 27;
                  break;
                }

                _context12.next = 27;
                return _this16.updateOrderWithAviz(data.series, data.invoiceNumber);

              case 27:

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Success',
                  text: 'Aviz saved successfully.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this16.$bus.$emit('refresh');
                _this16.$bus.$emit('close-modal');
                _context12.next = 36;
                break;

              case 32:
                _context12.prev = 32;
                _context12.t0 = _context12['catch'](8);

                console.error('Error saving aviz:', _context12.t0);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: _context12.t0.message || 'An unexpected error occurred.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 36:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this16, [[8, 32]]);
      }))();
    },
    getClientTypeCode: function getClientTypeCode(status) {
      switch (status) {
        case 'juridica_ro':
          return 1;
        case 'fizica':
          return 2;
        case 'juridica_vies':
          return 3;
        default:
          return 1;}
    },
    saveInvoice: function saveInvoice() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var invoiceData, response, errorData, errorMessage, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(!_this17.seriesNumber || !_this17.currency || !_this17.clientName || !_this17.clientCUI || !_this17.clientAddress)) {
                  _context13.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: 'Please complete all mandatory fields before saving the invoice.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context13.abrupt('return');

              case 3:
                invoiceData = {
                  tip: 'invoice',
                  externalCompanyId: _this17.companyID,
                  dueDate: _this17.dueDate,
                  issueDate: _this17.issueDate,
                  externalLocationId: _this17.selectedLocationId,
                  vatNumber: _this17.selectedLocation.inv_fiscal_code,
                  items: _this17.items.map(function (item) {
                    return {
                      posId: item.posId,
                      name: item.productName.name || item.productName,
                      type: item.type,
                      code: item.code,
                      unitMeasure: item.unitMeasure,
                      quantity: item.quantity,
                      price: parseFloat(item.priceRON),
                      tva: item.vatRate,
                      gestiune_from: item.gestiuneId || item.gestiuneFrom
                    };
                  }),
                  currency: _this17.currency,
                  series: _this17.seriesNumber,
                  customer: {
                    name: _this17.clientName,
                    cnp: _this17.clientCUI,
                    email: _this17.clientEmail,
                    phone: _this17.clientPhone,
                    address: _this17.clientAddress
                  },
                  extraFields: [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(_this17.extraFields).map(function (_ref5) {
                    var _ref6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                        key = _ref6[0],
                        value = _ref6[1];

                    return { key: key, value: value };
                  })), [{ key: 'avizNumber', value: _this17.series + '-' + _this17.invoiceNumber }])
                };


                if ((_this17.isInvoice || _this17.isEdit) && _this17.invoiceData && _this17.invoiceData.invoiceNumber) {
                  invoiceData.invoiceNumber = _this17.invoiceData.invoiceNumber;
                }

                _context13.prev = 5;
                _context13.next = 8;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/document', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(invoiceData)
                });

              case 8:
                response = _context13.sent;

                if (response.ok) {
                  _context13.next = 16;
                  break;
                }

                _context13.next = 12;
                return response.json();

              case 12:
                errorData = _context13.sent;
                errorMessage = errorData.error || 'Error saving invoice';


                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: errorMessage,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

                throw new Error('Error saving invoice');

              case 16:
                _context13.next = 18;
                return response.json();

              case 18:
                data = _context13.sent;

                console.log('Invoice saved successfully:', data);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Success',
                  text: 'Invoice saved successfully.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this17.$bus.$emit('refresh');
                _this17.$bus.$emit('close-modal');
                _context13.next = 29;
                break;

              case 25:
                _context13.prev = 25;
                _context13.t0 = _context13['catch'](5);

                console.error('Error saving invoice:', _context13.t0);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: _context13.t0.message || 'An unexpected error occurred.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 29:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this17, [[5, 25]]);
      }))();
    }
  }
});

/***/ }),

/***/ "2Sfy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Tqu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Suppliers_ManagementMyOrdersSuppliers_vue__ = __webpack_require__("KNch");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Suppliers_ManagementForOrdersSuppliers_vue__ = __webpack_require__("Tbq/");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementMyOrdersSuppliers: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Suppliers_ManagementMyOrdersSuppliers_vue__["a" /* default */],
    ManagementForOrdersSuppliers: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Suppliers_ManagementForOrdersSuppliers_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isMyOrders: true,
      isForOrders: false
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  created: function created() {},

  methods: {
    openMyOrders: function openMyOrders() {
      this.isMyOrders = true;
      this.isForOrders = false;
    },
    openForOrders: function openForOrders() {
      this.isMyOrders = false;
      this.isForOrders = true;
    }
  }
});

/***/ }),

/***/ "2VZ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"report-filters"},[_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left date-range"},[_c('el-date-picker',{staticClass:"mid",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.clients.valid),callback:function ($$v) {_vm.$set(_vm.clients, "valid", $$v)},expression:"clients.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":function($event){_vm.getData(null)}}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-info btn-print",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData(null)}}},[_c('i',{staticClass:"ti-file"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('reports.requestReport')},on:{"click":function($event){_vm.requestReport()}}},[_c('i',{staticClass:"ti-calendar"})])])]),_vm._v(" "),_c('div',{staticClass:"card-content total-pagination pad-15"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.clientsTableData,"search-def":{ show: false },"total":_vm.totalClients,"pagination-props":_vm.paginationProps,"table-props":_vm.tableOptions},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"prop":"user.id","label":"Id user"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"name","label":"Nume"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(props.row.user.firstname)+" "+_vm._s(props.row.user.lastname)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"prop":"bon_cif","label":"CIF bon"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"prop":"bon_user","label":"Utilizator bon"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"prop":"bon_data","label":"Data bon"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"prop":"bon_nr","label":"Nr bon"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"prop":"bon_total","label":"Total bon"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"name","label":"Puncte Primite"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"pad-lf-30"},[_vm._v(_vm._s(props.row.gained_loyalty_points))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Data scanare"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(_vm.formatDateTime(props.row.created_at)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":120,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.photo_url)?_c('a',{staticClass:"btn btn-info btn-icon duplicate-prod",attrs:{"href":props.row.photo_url,"target":"_blank"}},[_c('i',{staticClass:"ti-image"})]):_vm._e()]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86550852_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("+Gp3");
function injectStyle (ssrContext) {
  __webpack_require__("SGWg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86550852_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2aqO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2cDa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2eUK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: { locationId: [Number, String] }
});

/***/ }),

/***/ "2fTx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard pad-to-15"},[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.dashboardReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.posUsers.length)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.operator')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPosUser),expression:"selectedPosUser"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedPosUser=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.alls')}},[_vm._v(_vm._s(_vm.$t('general.alls')))]),_vm._v(" "),_vm._l((_vm.posUsers),function(operator){return _c('option',{key:operator.id,attrs:{"label":operator.firstname + ' ' + operator.lastname},domProps:{"value":operator.id}},[_vm._v("\n              "+_vm._s(operator.firstname)+" "+_vm._s(operator.lastname)+"\n            ")])})],2)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(" "+_vm._s(_vm.$t('reports.interval'))+": "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to))])])]),_vm._v(" "),_c('div',{staticClass:"row pad-to-15 pad-bt-5 all-cards dashboard-resize-statistics-card stats-cards-row"},_vm._l((_vm.firstRowCards),function(stats,key){return _c('div',{key:key,class:[_vm.cardsClass, 'card-' + key, 'stats-card-wrapper']},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",attrs:{"slot":"header"},slot:"header"},[_c('img',{attrs:{"src":("/static/img/icons/" + (stats.icon))}})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(stats.title))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(stats.value !== undefined && stats.value !== null ? stats.value : ''))]),_vm._v(" "),(stats.canceled)?_c('small',[_vm._v("( "+_vm._s(stats.canceled)+" "+_vm._s(_vm.$t('ordersStatus.CANCELED'))+")")]):_vm._e(),_vm._v(" "),(stats.average)?_c('p',[_vm._v(_vm._s(stats.average))]):_vm._e()])])],1)})),_vm._v(" "),_c('div',{staticClass:"row pad-to-5 pad-bt-15 all-cards dashboard-resize-statistics-card stats-cards-row"},_vm._l((_vm.secondRowCards),function(stats,key){return _c('div',{key:key,class:[_vm.cardsClass, 'card-' + key, 'stats-card-wrapper']},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",attrs:{"slot":"header"},slot:"header"},[_c('img',{attrs:{"src":("/static/img/icons/" + (stats.icon))}})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(stats.title))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(stats.value !== undefined && stats.value !== null ? stats.value : ''))]),_vm._v(" "),(stats.canceled)?_c('small',[_vm._v("( "+_vm._s(stats.canceled)+" "+_vm._s(_vm.$t('ordersStatus.CANCELED'))+")")]):_vm._e(),_vm._v(" "),(stats.average)?_c('p',[_vm._v(_vm._s(stats.average))]):_vm._e()])])],1)})),_vm._v(" "),_c('div',{staticClass:"row text-left"},[_c('div',{staticClass:"col-md-12"},[_c('chart-card',{ref:"refOrdersChart",attrs:{"chart-data":_vm.ordersChart.data,"chart-options":_vm.ordersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.orderChart')))]),_vm._v(" "),(_vm.orders.valid && _vm.orders.valid.length === 2)?_c('p',{staticClass:"category"},[_c('img',{attrs:{"src":"/static/img/icons/icon-calendar.png"}}),_vm._v(" "+_vm._s(_vm.orders.valid[0])+" - "+_vm._s(_vm.orders.valid[1])+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('dashboard.completed'))+"\n            ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('chart-card',{ref:"salesChart",attrs:{"chart-data":_vm.salesChart.data,"chart-options":_vm.salesChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.salesChart')))]),_vm._v(" "),(_vm.orders.valid && _vm.orders.valid.length === 2)?_c('p',{staticClass:"category"},[_c('img',{attrs:{"src":"/static/img/icons/icon-calendar.png"}}),_vm._v(" "+_vm._s(_vm.orders.valid[0])+" - "+_vm._s(_vm.orders.valid[1])+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('dashboard.salesIn'))+" "+_vm._s(_vm.currency)+"\n            ")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row text-left"},[_c('div',{staticClass:"col-md-12"},[_c('chart-bars-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"paymentMethodSales",attrs:{"chart-data":_vm.paymentMethodSales.data,"chart-options":_vm.paymentMethodSales.options}},[(!_vm.hasPaymentMethodData && !_vm.loading)?[_c('div',{staticClass:"no-data-message",staticStyle:{"text-align":"center","margin":"20px"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('reports.noDataAvailable')))])])]:_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.paymentTypes')))]),_vm._v(" "),(_vm.orders.valid && _vm.orders.valid.length === 2)?_c('p',{staticClass:"category"},[_c('img',{attrs:{"src":"/static/img/icons/icon-calendar.png"}}),_vm._v(" "+_vm._s(_vm.orders.valid[0])+" - "+_vm._s(_vm.orders.valid[1])+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend",staticStyle:{"display":"flex","flex-wrap":"wrap"}},_vm._l((_vm.paymentMethodSales.data.labels),function(label,index){return _c('div',{key:index,staticStyle:{"display":"flex","align-items":"center","margin-right":"12px"}},[_c('i',{staticClass:"fa fa-circle",style:({ color: _vm.colors[index % _vm.colors.length], marginRight: '5px' })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(label)+" - "+_vm._s(_vm.formatMoneyAmount(_vm.paymentMethodSales.data.series[0][index] || 0)))])])}))])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row text-left charts-row-equal-height"},[_c('div',{staticClass:"col-md-6 chart-bar-label"},[_c('chart-bars-card',{ref:"topProdsChart",attrs:{"chart-data":_vm.topProdsChart.data,"chart-options":_vm.topProdsChart.options}},[(!_vm.hasTopProdsData && !_vm.loading)?[_c('div',{staticClass:"no-data-message",staticStyle:{"text-align":"center","margin":"20px"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('reports.noDataAvailable')))])])]:_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.top5Chart')))]),_vm._v(" "),(_vm.orders.valid && _vm.orders.valid.length === 2)?_c('p',{staticClass:"category"},[_c('img',{attrs:{"src":"/static/img/icons/icon-calendar.png"}}),_vm._v(" "+_vm._s(_vm.orders.valid[0])+" - "+_vm._s(_vm.orders.valid[1])+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('reports.salesProductNr'))+"\n            ")])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 delivery-chart-container"},[_c('chart-bars-card',{ref:"deliveryChart",attrs:{"chart-data":_vm.deliveryChart.data,"chart-options":_vm.deliveryChart.options}},[(!_vm.hasDeliveryData && !_vm.loading)?[_c('div',{staticClass:"no-data-message",staticStyle:{"text-align":"center","margin":"20px"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('reports.noDataAvailable')))])])]:_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.orderingChart')))]),_vm._v(" "),(_vm.orders.valid && _vm.orders.valid.length === 2)?_c('p',{staticClass:"category"},[_c('img',{attrs:{"src":"/static/img/icons/icon-calendar.png"}}),_vm._v(" "+_vm._s(_vm.orders.valid[0])+" - "+_vm._s(_vm.orders.valid[1])+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('dashboard.nrOfOrders'))+"\n            ")])])],2)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2hkR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2iTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceProfileForm_vue__ = __webpack_require__("szIs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fcb9e5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceProfileForm_vue__ = __webpack_require__("0Dhw");
function injectStyle (ssrContext) {
  __webpack_require__("Zco+")
  __webpack_require__("o2vL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fcb9e5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceProfileForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fcb9e5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceProfileForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2kML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { GeneralTopBar: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */] },
  props: {
    isReferralProgramReport: { type: Boolean, default: false }
  },
  watch: {
    isReferralProgramReport: function isReferralProgramReport(v) {
      if (v) {
        this.loadCampaigns();
        this.loadAmbassadorOptions();
        this.bootstrapAmbassadors();
      }
    }
  },
  computed: {
    ambassadorOptions: function ambassadorOptions() {
      var cacheKey = this.ambassadorOptionsCacheKey();
      return this.ambassadorOptionsCache[cacheKey] || [];
    },
    campaignsById: function campaignsById() {
      var map = {};(this.campaigns || []).forEach(function (c) {
        if (c && c.id != null) map[String(c.id)] = c;
      });
      return map;
    }
  },
  data: function data() {
    return {
      loading: false,
      loadingAmbassadorOptions: false,
      paginationProps: { layout: 'prev, pager, next, sizes, total' },
      ambassadorsRows: [],
      ambassadorsTotal: 0,
      campaigns: [],
      selectedCampaignId: '',
      selectedAmbassadorId: '',
      ambassadorOptionsCache: {},
      ambassadorsReportCache: {},
      pageSize: 10
    };
  },

  methods: {
    formatMoney: function formatMoney(v) {
      if (v === null || v === undefined || v === '') return this.$t('general.emDash');
      var n = Number(v);
      return isNaN(n) ? String(v) : n.toFixed(2);
    },
    ambassadorRefereesCount: function ambassadorRefereesCount(row) {
      if (row.registered_referees_count != null) return row.registered_referees_count;
      if (row.referees_count != null) return row.referees_count;
      if (row.referee_count != null) return row.referee_count;
      return this.$t('general.emDash');
    },
    ambassadorEarningsTotal: function ambassadorEarningsTotal(row) {
      if (row.earnings && row.earnings.total != null) return row.earnings.total;
      return row.total_cashback_and_order_rewards;
    },
    ambassadorEarningsCashback: function ambassadorEarningsCashback(row) {
      if (row.earnings && row.earnings.from_cashback != null) return row.earnings.from_cashback;
      return row.total_cashback_from_percent;
    },
    pickField: function pickField(row, key) {
      if (!row || key == null) return null;
      var parts = String(key).split('.');
      var cur = row;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(parts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var part = _step.value;

          if (cur == null || (typeof cur === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(cur)) !== 'object') return null;
          cur = cur[part];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (cur == null || cur === '') return null;
      return cur;
    },
    pickStringField: function pickStringField(row, keys) {
      if (!row || !keys) return null;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(keys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          var v = this.pickField(row, key);
          if (v != null && String(v).trim() !== '') return String(v).trim();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    },
    campaignNameById: function campaignNameById(id) {
      if (id == null || id === '') return null;
      var match = this.campaignsById[String(id)];
      if (!match) return null;
      var name = match.name != null ? String(match.name).trim() : '';
      return name || null;
    },
    campaignObjectFromRow: function campaignObjectFromRow(row) {
      if (!row) return null;
      var c = row.campaign || row.referral_campaign || row.referralCampaign;
      if (c && (typeof c === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(c)) === 'object') return c;
      if (typeof c === 'string' && c.trim().startsWith('{')) {
        try {
          var parsed = JSON.parse(c.trim());
          if (parsed && (typeof parsed === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(parsed)) === 'object') return parsed;
        } catch (_) {}
      }
      return null;
    },
    campaignNameForRow: function campaignNameForRow(row) {
      if (!row) return this.$t('general.emDash');

      var campaign = this.campaignObjectFromRow(row);
      if (campaign && campaign.name != null && String(campaign.name).trim() !== '') {
        return String(campaign.name).trim();
      }

      var campaignId = campaign && campaign.id != null ? campaign.id : row.referral_campaign_id || row.campaign_id || null;
      var fromList = this.campaignNameById(campaignId);
      if (fromList) return fromList;

      var flatName = this.pickStringField(row, ['referral_campaign_name', 'campaign_name']);
      if (flatName) return flatName;

      if (campaignId != null && campaignId !== '') {
        return this.$t('general.idHash', { id: campaignId });
      }
      return this.$t('general.emDash');
    },
    displayPersonEmail: function displayPersonEmail(row) {
      return this.pickStringField(row, ['email', 'user_email', 'user.email', 'ambassador.email', 'ambassador_user.email', 'ambassador_user_email']);
    },
    displayPersonName: function displayPersonName(row, role) {
      if (!row) return this.$t('general.emDash');
      var nestedName = this.pickStringField(row, ['full_name', 'name', 'user.full_name', 'user.name', 'ambassador.full_name', 'ambassador.name', 'ambassador_user.full_name', 'ambassador_user.name']);
      if (nestedName) return nestedName;
      var fn = String(row.firstname || row.first_name || this.pickField(row, 'user.firstname') || this.pickField(row, 'user.first_name') || this.pickField(row, 'ambassador.firstname') || this.pickField(row, 'ambassador.first_name') || '').trim();
      var ln = String(row.lastname || row.last_name || this.pickField(row, 'user.lastname') || this.pickField(row, 'user.last_name') || this.pickField(row, 'ambassador.lastname') || this.pickField(row, 'ambassador.last_name') || '').trim();
      var s = [fn, ln].filter(Boolean).join(' ');
      if (s) return s;
      if (role === 'ambassador') {
        var _id = row.ambassador_user_id || row.user_id || row.id;
        return this.$t('general.idHash', { id: _id });
      }
      var id = row.referee_user_id || row.user_id || row.id;
      return this.$t('general.idHash', { id: id });
    },
    ambassadorIdFromRow: function ambassadorIdFromRow(row) {
      return row.ambassador_user_id || row.user_id || row.id;
    },
    onAmbassadorRow: function onAmbassadorRow(row) {
      var ambassadorId = this.ambassadorIdFromRow(row);
      var title = this.displayPersonName(row, 'ambassador');
      this.$router.push({
        name: 'Referral Program Ambassador Drilldown',
        params: { ambassadorId: String(ambassadorId) },
        query: { title: title }
      });
    },
    normalizeRows: function normalizeRows(response) {
      if (!response || !response.data) return [];
      var d = response.data;
      return Array.isArray(d) ? d : Array.isArray(d.data) ? d.data : [];
    },
    normalizeTotal: function normalizeTotal(response) {
      if (response.pagination && response.pagination.total != null) return response.pagination.total;
      if (response.meta && response.meta.total != null) return response.meta.total;
      return this.normalizeRows(response).length;
    },
    baseParams: function baseParams() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    ambassadorOptionsCacheKey: function ambassadorOptionsCacheKey() {
      return String(this.selectedCampaignId || '');
    },
    ambassadorsReportCacheKey: function ambassadorsReportCacheKey(page, perPage) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
        campaign: this.selectedCampaignId || '',
        page: page,
        perPage: perPage
      });
    },
    hasAmbassadorFilter: function hasAmbassadorFilter() {
      return this.selectedAmbassadorId != null && this.selectedAmbassadorId !== '';
    },
    campaignFilterParams: function campaignFilterParams() {
      var params = {};
      if (this.selectedCampaignId != null && this.selectedCampaignId !== '') {
        params.referral_campaign_id = this.selectedCampaignId;
        params.campaign_id = this.selectedCampaignId;
      }
      return params;
    },
    filterParams: function filterParams() {
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.campaignFilterParams());
      if (this.hasAmbassadorFilter()) {
        params.ambassador_id = this.selectedAmbassadorId;
      }
      return params;
    },
    ambassadorOptionId: function ambassadorOptionId(item) {
      if (!item) return '';
      return item.ambassador_user_id || item.user_id || item.id || '';
    },
    ambassadorOptionLabel: function ambassadorOptionLabel(item) {
      var name = this.displayPersonName(item, 'ambassador');
      var id = this.ambassadorOptionId(item);
      if (name && !String(name).startsWith('#')) return name;
      return id ? this.$t('general.idHash', { id: id }) : this.$t('general.emDash');
    },
    loadCampaigns: function loadCampaigns() {
      var _this = this;

      if (!this.isReferralProgramReport) {
        return;
      }
      this.apiRequest('/referral-campaign', 'GET', this.baseParams(), function (response) {
        if (response.status) {
          _this.campaigns = _this.normalizeRows(response);
          if (_this.ambassadorsRows.length) {
            _this.ambassadorsRows = _this.ambassadorsRows.slice();
          }
        }
      });
    },
    loadAmbassadorOptions: function loadAmbassadorOptions() {
      var _this2 = this;

      if (!this.isReferralProgramReport) {
        return;
      }
      var cacheKey = this.ambassadorOptionsCacheKey();
      if (this.ambassadorOptionsCache[cacheKey]) {
        return;
      }
      this.loadingAmbassadorOptions = true;
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.baseParams(), this.campaignFilterParams());
      this.apiRequest('/reports/v2/referral-ambassadors-options', 'GET', data, function (response) {
        _this2.loadingAmbassadorOptions = false;
        var rows = response.status ? _this2.normalizeRows(response) : [];
        _this2.$set(_this2.ambassadorOptionsCache, cacheKey, rows);
      });
    },
    onCampaignFilterChange: function onCampaignFilterChange() {
      this.selectedAmbassadorId = '';
      this.loadAmbassadorOptions();
    },
    applyFilters: function applyFilters() {
      this.fetchAmbassadors(1, this.pageSize);
    },
    bootstrapAmbassadors: function bootstrapAmbassadors() {
      this.fetchAmbassadors(1, this.pageSize);
    },
    onAmbassadorsPage: function onAmbassadorsPage(q) {
      this.pageSize = q.pageSize;
      this.fetchAmbassadors(q.page, q.pageSize);
    },
    fetchAmbassadors: function fetchAmbassadors(page, perPage) {
      var _this3 = this;

      if (!this.isReferralProgramReport) {
        return;
      }
      this.pageSize = perPage;
      var cacheKey = this.ambassadorsReportCacheKey(page, perPage);
      if (!this.hasAmbassadorFilter() && this.ambassadorsReportCache[cacheKey]) {
        var cached = this.ambassadorsReportCache[cacheKey];
        this.ambassadorsRows = cached.rows;
        this.ambassadorsTotal = cached.total;
        return;
      }

      this.loading = true;
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.baseParams(), { page: page, perPage: perPage }, this.filterParams());
      this.apiRequest('/reports/v2/referral-ambassadors?page=' + page + '&perPage=' + perPage, 'GET', data, function (response) {
        if (response.status) {
          var rows = _this3.normalizeRows(response);
          var total = _this3.normalizeTotal(response);
          _this3.ambassadorsRows = rows;
          _this3.ambassadorsTotal = total;
          if (!_this3.hasAmbassadorFilter()) {
            _this3.$set(_this3.ambassadorsReportCache, cacheKey, { rows: rows, total: total });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error');
        }
        _this3.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "2mRZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_tree_halower_dist_halower_tree_min_css__ = __webpack_require__("ug9+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_tree_halower_dist_halower_tree_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vue_tree_halower_dist_halower_tree_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_tree_halower__ = __webpack_require__("lTSm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_tree_halower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_tree_halower__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__("O5me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vue_wysiwyg_dist_vueWysiwyg_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_components_UIComponents_Inputs_VatDropdown_vue__ = __webpack_require__("QcfT");



























var _components;












__WEBPACK_IMPORTED_MODULE_26_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_30_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_26_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_26_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_26_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_26_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_26_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_26_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_26_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_32_vue_tree_halower___default.a);
__WEBPACK_IMPORTED_MODULE_26_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_35_src_components_UIComponents_Inputs_VatDropdown_vue__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_33_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_defineProperty___default()(_components, 'VueDropdown', __WEBPACK_IMPORTED_MODULE_35_src_components_UIComponents_Inputs_VatDropdown_vue__["a" /* default */]), _components),
  props: {
    mainCategoriesParent: {
      type: Array,
      required: true
    },

    productOptionsParent: {
      required: true
    },
    companyProductFilters: {
      required: true
    },
    taxesParent: {
      type: Array,
      required: true
    },
    kdsSectionsParent: {
      type: Array,
      required: true
    },

    measurementsUnits: {
      required: true
    },
    language: {
      required: true
    },
    languages: {
      required: true
    },
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    mainCategoriesParent: function mainCategoriesParent(value, oldVal) {
      this.mainCategories = value;
    },
    productOptionsParent: function productOptionsParent(value, oldVal) {
      this.productOptions = value;
      this.$nextTick(function () {
        this.filterOptionsByLocations();
        this.availableFiltersByLocations();
      });
    },
    taxesParent: function taxesParent(value, oldVal) {
      this.taxes = value;
    },
    kdsSectionsParent: function kdsSectionsParent(value) {
      __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(this, 'kdsSections', value);
    },

    'model.override_delivery': {
      handler: function handler(newval, oldval) {},
      deep: true
    },
    'model.location_ids': {
      handler: function handler(newval, oldval) {
        this.$nextTick(function () {
          this.clampCoursesType();
        });
      },
      deep: true
    },
    coursesTypeMax: function coursesTypeMax() {
      this.clampCoursesType();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_vee_validate__["b" /* mapFields */])(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity']), {
    selectedProductTaxRules: function selectedProductTaxRules() {
      var selectedIds = this.model && Array.isArray(this.model.tax_rule_ids_v2) ? this.model.tax_rule_ids_v2.map(function (id) {
        return Number(id);
      }) : [];
      var availableRules = [].concat(this.productTaxRuleOptions || []).concat(this.model && this.model.tax_rules_v2 || []);
      var rulesById = {};
      availableRules.forEach(function (rule) {
        rulesById[Number(rule.id)] = rule;
      });
      return selectedIds.map(function (id) {
        return rulesById[id];
      }).filter(function (rule) {
        return !!rule;
      });
    },
    hasProductOptionsWithoutCompanyOptions: function hasProductOptionsWithoutCompanyOptions() {
      var hasProductOptions = this.model && Array.isArray(this.model.product_options) && this.model.product_options.length > 0;
      var hasCompanyOptions = Array.isArray(this.productOptions) && this.productOptions.length > 0;
      return hasProductOptions && !hasCompanyOptions;
    },

    preparationTimeInMinutes: {
      get: function get() {
        if (this.model.preparation_time_in_seconds === null || this.model.preparation_time_in_seconds === undefined || this.model.preparation_time_in_seconds === '') {
          return null;
        }
        return Number(this.model.preparation_time_in_seconds) / 60;
      },
      set: function set(minutes) {
        if (minutes === null || minutes === undefined || minutes === '') {
          this.$set(this.model, 'preparation_time_in_seconds', null);
          return;
        }
        this.$set(this.model, 'preparation_time_in_seconds', Math.round(Number(minutes) * 60));
      }
    },
    selectedCategory: function selectedCategory() {
      if (!this.model.category_id) {
        return null;
      }
      var categoryId = parseInt(this.model.category_id, 10);
      var fromList = this.mainCategories.find(function (cat) {
        return parseInt(cat.id, 10) === categoryId;
      });
      if (fromList) {
        return fromList;
      }
      if (this.model.category && parseInt(this.model.category.id, 10) === categoryId) {
        return this.model.category;
      }
      return null;
    },
    categoryPreparationTimeInMinutes: function categoryPreparationTimeInMinutes() {
      var category = this.selectedCategory;
      if (!category) {
        return null;
      }
      var seconds = category.preparation_time_in_seconds;
      if (seconds === null || seconds === undefined || seconds === '') {
        return null;
      }
      return Number(seconds) / 60;
    },
    mainCategoriesForSecondaryCategories: function mainCategoriesForSecondaryCategories() {
      return this.mainCategories.map(function (cat) {
        return {
          id: cat.id,
          name: cat.name
        };
      });
    },
    timeSelectOptions: function timeSelectOptions() {
      var options = [];
      var h = 0;
      var m = 0;
      while (h < 24) {
        options.push(String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0'));
        m += 15;
        if (m >= 60) {
          m -= 60;
          h += 1;
        }
      }
      options.push('23:59');
      return options;
    },
    coursesTypeMax: function coursesTypeMax() {
      var _this = this;

      var defaultMax = 5;
      var selectedLocations = this.model && this.model.location_ids && this.model.location_ids.length ? this.model.location_ids : this.locations;

      if (!selectedLocations || !selectedLocations.length) {
        return defaultMax;
      }

      var counts = selectedLocations.map(function (loc) {
        var locationId = loc.id || loc;
        var locationData = _this.locations[_this.getObjectByElemKeyValue('id', locationId, _this.locations)];
        var rawValue = locationData ? locationData.pos_default_course_count : null;

        if (rawValue === null || rawValue === undefined || rawValue === '') {
          return defaultMax;
        }

        var count = parseInt(rawValue, 10);
        return isNaN(count) ? defaultMax : count;
      });

      return Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()(counts));
    },
    coursesTypeHasError: function coursesTypeHasError() {
      if (this.errors.has('courses_type', 'general')) {
        return true;
      }
      if (this.model.courses_type === null || this.model.courses_type === '') {
        return false;
      }
      var value = Number(this.model.courses_type);
      return !isNaN(value) && (value < 0 || value > this.coursesTypeMax);
    },
    coursesTypeErrorMessage: function coursesTypeErrorMessage() {
      if (this.coursesTypeMax === 0) {
        return this.$t('catalogProd.coursesTypeLocationNotPermitted');
      }
      return this.$t('catalogProd.coursesTypeMaxAllowed', { max: this.coursesTypeMax });
    },
    modelValidations: function modelValidations() {
      var validations = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, this.baseValidations);

      if (this.kdsSectionsParent && this.kdsSectionsParent.length > 0) {
        validations.kds_section_id = {
          required: true
        };
      }

      if (this.vatOptions && this.vatOptions.length > 0) {
        validations[this.taxesVersion === 2 ? 'vat_rate_id' : 'vat_id'] = {
          required: true
        };
      }
      validations.courses_type = {
        required: false,
        min_value: 0,
        max_value: this.coursesTypeMax
      };
      return validations;
    }
  }),
  data: function data() {
    return {
      loadingSearchProd: false,
      linkedProducts: {},
      loadingVat: null,
      activeVat: null,
      optionValueQuery: '',
      searchTerm: '',
      searchResults: [],
      selectedProductForVat: null,
      searchTimeout: null,


      companyID: null,
      taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
      productTaxRuleOptions: [],
      initialProductTaxRuleIds: [],
      loadingProductTaxRules: false,
      use_gestiune: false,
      has_charisma_location: false,
      administrations: [],
      administrationsToDelete: [],
      charismaLocations: [],
      pricesFor: [{
        id: 1,
        name: 'Website'
      }, {
        id: 2,
        name: 'QR'
      }, {
        id: 3,
        name: 'Kiosk'
      }, {
        id: 4,
        name: 'POS'
      }, {
        id: 5,
        name: 'GLOVO'
      }, {
        id: 6,
        name: 'BOLT'
      }, {
        id: 7,
        name: 'Wolt'
      }],
      invalidTabs: [],
      overrideDeliveryErrors: [],
      currentSection: 'description',
      currentSubSection: 'l1',
      validateOptionCheck: true,
      type: '',
      isCheckedDeliveryMethod: false,
      isCheckedDay: false,
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      imagesToBeDeleted: [],
      groupOptions: [],
      tabIndex: null,
      tabFilterIndex: null,
      tabOtherInfoIndex: null,
      currentTab: '',
      pickerNames: ['date_from', 'date_to'],
      mainCategories: this.mainCategoriesParent,
      model: [],
      soldWithProducts: [],
      products: [],
      productsGrouped: [],
      halfChecks: [],
      productOptions: this.productOptionsParent,
      productAvailableFilters: [],
      productOptionsFiltered: [],
      taxes: [],
      labelTypes: [{
        id: 1,
        name: 'Eticheta 6x4cm'
      }],
      hasImages: false,
      showLocations: false,
      locations: [],
      prevLocationIds: [],
      orderingManagement: [],
      is_not_available_from: '',
      is_not_available_to: '',
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      selectedVideo: null,
      baseValidations: {
        name: {
          required: true,
          min: 3
        },
        sku: {
          required: true
        },
        measurements_units_id: {
          required: true
        },
        quantitative_unit: {
          required: false,
          min_value: 0,
          max_value: 9999999.99
        },
        price: {
          required: true,
          min_value: 0,
          max_value: 999999.99
        },
        price_to_show: {
          required: false,
          min_value: 0,
          max_value: 999999.99
        },
        old_price: {
          min_value: 0,
          required: true
        },
        category_id: {
          required: true
        }
      },
      optionTypes: ['checkbox', 'radio'],
      searchword: '',
      kdsSections: [],
      searchwordExtra: '',
      treeData: [],
      treeDataExtra: [],
      currency: this.$session.get('selectedCompanyData')['currency_iso'],
      use_pos_id_per_product_option: this.$session.get('selectedCompanyData')['use_pos_id_per_product_option'] || 0,
      use_quantity_per_product_option: this.$session.get('selectedCompanyData')['use_quantity_per_product_option'] || 0,
      loading: true,
      userRole: null,
      filtersData: [],
      isNewFilter: false,
      filter: {
        value: null,
        filter_id: null,
        showError: false
      },
      initialStatus: null,

      errorProductUnavailable: null,
      nullProductOptionValues: false,
      vatOptions: null,
      deleteOptionValues: [],
      deleteOptions: [],
      deleteOverrides: []
    };
  },

  created: function created() {
    var _this2 = this;

    this.companyID = this.$session.get('selectedCompany');
    this.$bus.$on('doReloadProd', this.doReloadProd);
    var companyData = this.$session.get('selectedCompanyData');
    this.use_gestiune = companyData.use_gestiune;
    this.ensureCompanyLocationFlags(function (sessionData) {
      _this2.has_charisma_location = !!sessionData.has_charisma_location;
    });
    this.initCharismaAdministrations();
    this.loadProductTaxRules();
    this.getData();
    this.model.allowed_location = true;
    if (this.$session.get('userDataRole') !== 'LOCATION_STORE_ADMIN') {
      this.locations = companyData.locations_details;
      if (this.locations.length > 1) {
        this.showLocations = true;
      }
    }
    this.userRole = this.$session.get('userDataRole');

    if (this.locations.length > 1) {
      this.showLocations = true;
    }
    if (!this.productsGrouped.length) {
      this.getCategories();
    }
    this.getProductFiltersCount();
    this.getTrees();
    this.getGroupOptions();
  },
  mounted: function mounted() {
    this.mapItems();
  },

  methods: {
    loadProductTaxRules: function loadProductTaxRules() {
      var _this3 = this;

      this.loadingProductTaxRules = true;
      this.apiRequest('/taxes-v2/rules', 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, function (response) {
        _this3.loadingProductTaxRules = false;
        if (response.status === true && Array.isArray(response.data)) {
          _this3.productTaxRuleOptions = response.data.filter(function (rule) {
            return rule.applies_to === 'item';
          }).sort(function (a, b) {
            return String(a.name).localeCompare(String(b.name));
          });
        }
      });
    },
    formatProductTaxRuleLabel: function formatProductTaxRuleLabel(rule) {
      var value = rule.calculation_type === 'percentage' ? rule.value + '%' : rule.value + ' ' + this.currency;
      return rule.name + ' (' + value + ')' + (rule.is_active ? '' : ' - inactivă');
    },
    isProductTaxRuleDisabled: function isProductTaxRuleDisabled(rule) {
      if (rule.is_active) {
        return false;
      }
      return this.initialProductTaxRuleIds.indexOf(Number(rule.id)) === -1;
    },
    productTaxRuleStatusLabel: function productTaxRuleStatusLabel(rule) {
      if (this.taxesVersion !== 2) return 'Nu se aplică — motor V2 oprit';
      return rule.is_active ? 'Se aplică' : 'Nu se aplică — taxă inactivă';
    },
    productTaxRuleStatusClass: function productTaxRuleStatusClass(rule) {
      return this.taxesVersion === 2 && rule.is_active ? 'label-success' : 'label-default';
    },
    showGestiuneCategory: function showGestiuneCategory(category) {
      var colors = {
        'Produs finit (Reteta)': '#674BD2',
        'Marfa': 'orange',
        'Fara Categorie': 'gray'
      };

      if (!category || category.trim() === '') {
        category = 'Fara Categorie';
      }

      var color = colors[category] || 'gray';

      return '<span class="searchBadge" style="background: ' + color + '">' + category + '</span>';
    },
    loadLinkedProducts: function loadLinkedProducts() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vat, entries, posId, response, data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.keys(_this4.model.pos_id_gruped_by_vat);

              case 1:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 25;
                  break;
                }

                vat = _context.t1.value;
                entries = _this4.model.pos_id_gruped_by_vat[vat];

                if (entries.length) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('continue', 1);

              case 6:
                posId = entries[0].pos_id;


                _this4.loadingVat = vat;

                if (!posId) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 9;
                _context.next = 12;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/nomenclator', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()({
                    posId: posId,
                    externalCompanyId: _this4.companyID,
                    vatNumber: vat
                  })
                });

              case 12:
                response = _context.sent;
                _context.next = 15;
                return response.json();

              case 15:
                data = _context.sent;


                if (response.ok && data) {
                  _this4.$set(_this4.linkedProducts, vat, data);
                }
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t2 = _context['catch'](9);

                console.error(_context.t2);

              case 22:

                _this4.loadingVat = null;
                _context.next = 1;
                break;

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[9, 19]]);
      }))();
    },
    openChangeModal: function openChangeModal(vat) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.activeVat = vat;
                _this5.searchTerm = '';
                _this5.searchResults = [];
                _this5.selectedProductForVat = null;

                _this5.$modal.show('changeProductModal');

                if (_this5.searchResults.length) {
                  _context2.next = 9;
                  break;
                }

                _this5.loadingSearchProd = true;
                _context2.next = 9;
                return _this5.searchProducts();

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    debouncedSearch: function debouncedSearch() {
      var _this6 = this;

      this.loadingSearchProd = true;
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(function () {
        _this6.searchProducts();
      }, 400);
    },
    searchProducts: function searchProducts() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var params, queryString, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  externalCompanyId: _this7.companyID,
                  vatNumber: _this7.activeVat,
                  name: _this7.searchTerm,
                  page: 1,
                  limit: 50,
                  category: 'Produs finit (Reteta), Marfa, fara_categorie'
                };
                queryString = new URLSearchParams(params).toString();
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/products?' + queryString;
                _context3.next = 5;
                return fetch(url);

              case 5:
                response = _context3.sent;
                _context3.next = 8;
                return response.json();

              case 8:
                data = _context3.sent;

                _this7.loadingSearchProd = false;
                if (data.products) {
                  _this7.searchResults = data.products.map(function (p) {
                    return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, p);
                  });
                }

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    selectProduct: function selectProduct(prod) {
      this.selectedProductForVat = prod;
    },
    removeGestionLink: function removeGestionLink(vat) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this8.selectedProductForVat = null;
                _this8.activeVat = vat;
                _this8.saveNewLink();

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this8);
      }))();
    },
    saveNewLink: function saveNewLink() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var vat, posId;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                vat = _this9.activeVat;
                posId = null;


                if (_this9.selectedProductForVat) {
                  posId = _this9.selectedProductForVat._id;
                }

                if (!_this9.isNew()) {
                  _context5.next = 8;
                  break;
                }

                _this9.model.pos_id_gruped_by_vat[vat].forEach(function (item) {
                  item.pos_id = posId;
                  item.is_manual = 1;
                });
                if (_this9.selectedProductForVat) {
                  _this9.$set(_this9.linkedProducts, vat, __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, _this9.selectedProductForVat));
                } else {
                  _this9.$set(_this9.linkedProducts, vat, null);
                }
                _this9.$modal.hide('changeProductModal');
                return _context5.abrupt('return', true);

              case 8:

                if (_this9.selectedProductForVat) {
                  _this9.model.pos_id_gruped_by_vat[vat].forEach(function (item) {
                    item.pos_id = _this9.selectedProductForVat._id;
                    item.is_manual = 1;
                  });
                  _this9.$set(_this9.linkedProducts, vat, __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, _this9.selectedProductForVat));
                }

                _this9.$modal.hide('changeProductModal');

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },
    getPosIdGrupedByVat: function getPosIdGrupedByVat() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = {
                  token: _this10.$session.get('token'),
                  company_id: _this10.$session.get('selectedCompany')
                };

                _this10.apiRequest('/gestiune/get-pos-id-gruped-by-vat', 'POST', data, function (response) {
                  if (response.status === true) {
                    _this10.model.pos_id_gruped_by_vat = response.data.pos_id_gruped_by_vat;
                  }
                });

                _this10.$modal.hide('changeProductModal');

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10);
      }))();
    },
    addNewOverrideInterval: function addNewOverrideInterval(locId, deliveryMethod, deliveryMethodLabel) {
      if (!this.model.override_settings[locId]['delivery'][deliveryMethod]) {
        __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(this.model.override_settings[locId]['delivery'], deliveryMethod, []);
      }
      this.model.override_settings[locId]['delivery'][deliveryMethod].push(this.createEmptyOverrideInterval(deliveryMethodLabel));
    },
    removeOverrideInterval: function removeOverrideInterval(locId, deliveryMethod, intervalIndex) {
      if (this.model.override_settings[locId]['delivery'][deliveryMethod][intervalIndex].id) {
        this.deleteOverrides.push(this.model.override_settings[locId]['delivery'][deliveryMethod][intervalIndex].id);
      }
      this.model.override_settings[locId]['delivery'][deliveryMethod].splice(intervalIndex, 1);
    },
    validateOption: function validateOption(option, keyId) {
      this.validateOptionCheck = true;
      if (option.values.length && option.max_no > parseInt(option.values.length)) {
        this.errors.add('max' + keyId, this.$t('catalogProd.maxNoTooHigh'));
        this.validateOptionCheck = false;
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (item) {
            return item.field !== 'max' + keyId;
          });
        }
      }

      if (parseInt(option.min_no) > parseInt(option.max_no) && parseInt(option.max_no)) {
        this.errors.add('min' + keyId, this.$t('catalogProd.minNoTooHigh'));
        this.validateOptionCheck = false;
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (item) {
            return item.field !== 'min' + keyId;
          });
        }
      }

      if (parseInt(option.min_no) < 0) {
        this.errors.add('min_negative' + keyId, this.$t('catalogProd.minNoNegative'));
        this.validateOptionCheck = false;
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (item) {
            return item.field !== 'min_negative' + keyId;
          });
        }
      }

      if (parseInt(option.max_no) < 0) {
        this.errors.add('max_negative' + keyId, this.$t('catalogProd.maxNoNegative'));
        this.validateOptionCheck = false;
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (item) {
            return item.field !== 'max_negative' + keyId;
          });
        }
      }
    },
    removeDiacritics: function removeDiacritics(str) {
      return String(str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
    filterOptionValues: function filterOptionValues(query) {
      this.optionValueQuery = query;
    },
    resetOptionValueQuery: function resetOptionValueQuery(visible) {
      if (visible) {
        this.optionValueQuery = '';
      }
    },
    matchesOptionValueQuery: function matchesOptionValueQuery(name, selectedId, optionId) {
      if (optionId === selectedId) {
        return true;
      }
      var query = this.removeDiacritics(this.optionValueQuery).toLowerCase().trim();
      if (!query) {
        return true;
      }
      return this.removeDiacritics(name).toLowerCase().indexOf(query) > -1;
    },
    selectOptionValue: function selectOptionValue(selectedId, optionIndex, optionValueIndex) {
      var option = this.model.product_options[optionIndex];
      var companyOptionIndex = this.getObjectByElemKeyValue('id', option.company_option_id, this.productOptionsFiltered);
      var selectedName = '';
      if (companyOptionIndex !== false && this.productOptionsFiltered[companyOptionIndex] && this.productOptionsFiltered[companyOptionIndex]['values']) {
        var values = this.productOptionsFiltered[companyOptionIndex]['values'];
        var valueIndex = this.getObjectByElemKeyValue('id', selectedId, values);
        if (valueIndex !== false && values[valueIndex]) {
          selectedName = values[valueIndex].name;
        }
      }
      __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(this.model.product_options[optionIndex].values[optionValueIndex], 'name', selectedName);
      __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(this.model.product_options[optionIndex].values[optionValueIndex], 'company_option_value_id', selectedId);

      if (this.model.product_options && this.model.product_options[optionIndex] && this.model.product_options[optionIndex].values && this.model.product_options[optionIndex].values[optionValueIndex]) {
        __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(this.model.product_options[optionIndex].values[optionValueIndex], 'pos_id', '');

        if (this.use_pos_id_per_product_option || this.model.product_options[optionIndex].values[optionValueIndex].hasOwnProperty('pos_id_per_product')) {
          __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(this.model.product_options[optionIndex].values[optionValueIndex], 'pos_id_per_product', '');
        }
      }
    },
    updateProductVatPrinterId: function updateProductVatPrinterId(obj) {
      var selectElement = obj.target;
      selectElement = selectElement.options[selectElement.selectedIndex];
      if (selectElement) {
        var selectedAmount = selectElement.dataset.amount;
        this.model.vat = selectedAmount;
      }
    },
    getVatOptions: function getVatOptions() {
      var _this11 = this;

      var locaitonIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_ids: locaitonIds
      };
      var endpoint = this.taxesVersion === 2 ? '/taxes-v2/vat-rates' : '/location/vat';
      this.apiRequest(endpoint, 'GET', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(_this11, 'vatOptions', response.data);
        }
      });
    },
    isVatOptionDisabled: function isVatOptionDisabled(vat, selectedId) {
      return !!(this.taxesVersion === 2 && vat && !vat.is_active && String(vat.id) !== String(selectedId));
    },
    getTaxOption: function getTaxOption(locaitonIds) {
      var _this12 = this;

      var locationIds = locaitonIds;
      if (Array.isArray(locationIds) && locationIds.length && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(locationIds[0]) === 'object') {
        locationIds = locationIds.map(function (loc) {
          return loc && (loc.id != null ? loc.id : loc.location_id);
        }).filter(function (id) {
          return id != null && id !== '';
        });
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_ids: locationIds
      };
      this.apiRequest('/location/taxes', 'GET', data, function (response) {
        if (response.status === true && Array.isArray(response.data) && response.data.length) {
          __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(_this12, 'taxes', response.data);
        }
      });
    },
    getGroupOptions: function getGroupOptions() {
      var _this13 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/group-options', 'GET', data, function (response) {
        if (response.status === true) {
          _this13.groupOptions = response.data;
        }
      });
    },
    handleCheckDay: function handleCheckDay(locId, intervalId, orderId) {
      var check = this.model.override_settings[locId]['delivery'][intervalId][orderId]['active'] && !this.model.override_settings[locId]['delivery'][intervalId][orderId].monday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].tuesday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].wednesday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].thursday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].friday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].saturday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].sunday;

      this.isCheckedDay = !check;

      if (!this.isCheckedDay && this.model.override_delivery) {
        this.errors.add('isCheckedDay', 'Day is required.');
        return false;
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (element) {
            return element.field !== 'isCheckedDay';
          });
        }
      }
    },
    handleChangeIsCheckedDeliveryMethod: function handleChangeIsCheckedDeliveryMethod(locId, orderIntervalId, orderId) {
      var hasActive = false;
      var delivery = this.model.override_settings[locId]['delivery'];
      var groups = Array.isArray(delivery) ? delivery : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(delivery || {});
      groups.forEach(function (group) {
        if (Array.isArray(group)) {
          group.forEach(function (interval) {
            if (interval && (interval.active === true || interval.active === 1)) {
              hasActive = true;
            }
          });
        } else if (group && (group.active === true || group.active === 1)) {
          hasActive = true;
        }
      });

      this.isCheckedDeliveryMethod = !hasActive;
      this.handleChangeOverrideDelivery();
      if (orderIntervalId !== undefined && orderId !== undefined) {
        this.handleCheckDay(locId, orderIntervalId, orderId);
      }
    },
    handleChangeOverrideDelivery: function handleChangeOverrideDelivery() {
      if (this.isCheckedDeliveryMethod && this.model.override_delivery) {
        this.errors.add('isCheckedDeliveryMethod', 'Location is required.');
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (element) {
            return element.field !== 'isCheckedDeliveryMethod';
          });
        }
      }
    },
    createEmptyOverrideInterval: function createEmptyOverrideInterval(deliveryMethod) {
      return {
        active: true,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
        delivery_method: deliveryMethod,
        available_from: '',
        available_to: ''
      };
    },
    deliveryMethodLabel: function deliveryMethodLabel(orderInterval, orderIntervalId) {
      if (orderInterval && orderInterval[0] && orderInterval[0].delivery_method) {
        return orderInterval[0].delivery_method;
      }
      return orderIntervalId;
    },
    getLocationOrderingManagement: function getLocationOrderingManagement(loc) {
      if (loc && Array.isArray(loc.ordering_management) && loc.ordering_management.length) {
        return loc.ordering_management;
      }

      var allTypes = (this.$session.get('defaultData') || {}).delivery_types || {};
      var methods = [];

      if (Array.isArray(allTypes)) {
        allTypes.forEach(function (type) {
          var method = typeof type === 'string' ? type : type && (type.key || type.type);
          if (method) {
            methods.push({ type: String(method).toLowerCase() });
          }
        });
      } else if (allTypes && (typeof allTypes === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(allTypes)) === 'object') {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(allTypes).forEach(function (key) {
          methods.push({ type: String(key).toLowerCase() });
        });
      }

      if (!methods.length) {
        return [{ type: 'pick_up' }, { type: 'delivery' }, { type: 'eat_in' }];
      }

      return methods;
    },
    buildLocationDeliveryMap: function buildLocationDeliveryMap(loc, existingDelivery) {
      var delivery = {};

      if (Array.isArray(existingDelivery)) {
        existingDelivery.forEach(function (group) {
          if (!Array.isArray(group) || !group.length || !group[0] || !group[0].delivery_method) {
            return;
          }
          var method = group[0].delivery_method;
          delivery[method] = group.slice();
        });
      } else if (existingDelivery && (typeof existingDelivery === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(existingDelivery)) === 'object') {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(existingDelivery).forEach(function (method) {
          var group = existingDelivery[method];
          delivery[method] = Array.isArray(group) ? group.slice() : [];
        });
      }

      var orderingManagement = this.getLocationOrderingManagement(loc);
      orderingManagement.forEach(function (ordering) {
        var deliveryMethod = ordering.type;
        if (!deliveryMethod) {
          return;
        }
        if (!Object.prototype.hasOwnProperty.call(delivery, deliveryMethod)) {
          delivery[deliveryMethod] = [];
        }
      });

      return delivery;
    },
    overrideLocationTitle: function overrideLocationTitle(locId) {
      var idx = this.getObjectByElemKeyValue('id', locId, this.locations);
      if (idx === false || !this.locations[idx]) {
        return locId;
      }
      return this.locations[idx].name;
    },
    getCategories: function getCategories() {
      var _this14 = this;

      if (this.productsGrouped.length) {
        this.productsGrouped = [];
      } else {
        var groupData = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sold_with_products: this.model.sold_with_products
        };
        if (this.model.location_ids && this.model.location_ids.length) {
          var ids = [];
          for (var index = 0; index < this.model.location_ids.length; index++) {
            ids.push(this.model.location_ids[index].id);
          }
          groupData.location_ids = ids;
        }
        this.apiRequest('/product-tree-categories', 'GET', groupData, function (response) {
          if (response.status === true) {
            _this14.productsGrouped = response.data.data;
            _this14.halfChecks = (response.data.half_checks || []).map(function (id) {
              return parseInt(id);
            });
            _this14.getTrees();
          }
        });
      }
    },
    updateSoldWith: function updateSoldWith(node, checked, position) {
      var _this15 = this;

      if (position.level === 1) {
        var categoryId = parseInt(node.id);
        var wasPartial = this.halfChecks.includes(categoryId) || node.children.some(function (child) {
          return child.checked;
        });
        var categoryIndex = this.model.sold_with_categories.indexOf(categoryId);
        if (!checked && categoryIndex !== -1) {
          this.model.sold_with_categories.splice(categoryIndex, 1);
        }
        if (checked && categoryIndex === -1) {
          this.model.sold_with_categories.push(categoryId);
        }
        this.halfChecks = this.halfChecks.filter(function (id) {
          return id !== categoryId;
        });
        if (node.children.length) {
          this.removeChildrenFromSoldWithProducts(node);
        } else if (wasPartial) {
          var data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            category_id: categoryId,
            category_name: node.title
          };
          this.apiRequest('/product-tree-category-products', 'GET', data, function (response) {
            if (response.status) {
              _this15.removeChildrenFromSoldWithProducts({ children: response.data.products });
              _this15.getTrees();
            }
          });
        }
      }

      if (position.level === 2) {
        var parent = node.parent();
        var parentId = parseInt(parent.id);
        var _categoryIndex = this.model.sold_with_categories.indexOf(parentId);
        var checkedChildren = parent.children.filter(function (child) {
          return child === node ? checked : child.checked;
        });
        var productId = parseInt(node.id);
        var productIndex = this.model.sold_with_products.findIndex(function (id) {
          return parseInt(id) === productId;
        });
        if (!checked && productIndex !== -1) {
          this.model.sold_with_products.splice(productIndex, 1);
        }
        if (checked && productIndex === -1) {
          this.model.sold_with_products.push(productId);
        }

        if (checkedChildren.length === parent.children.length && this.searchword.length < 3) {
          if (_categoryIndex === -1) {
            this.model.sold_with_categories.push(parentId);
          }
          this.removeChildrenFromSoldWithProducts(parent);
        } else if (!checked && _categoryIndex !== -1) {
          this.model.sold_with_categories.splice(_categoryIndex, 1);
          checkedChildren.forEach(function (child) {
            var childId = parseInt(child.id);
            if (!_this15.model.sold_with_products.some(function (id) {
              return parseInt(id) === childId;
            })) {
              _this15.model.sold_with_products.push(childId);
            }
          });
        }
        this.halfChecks = this.halfChecks.filter(function (id) {
          return id !== parentId;
        });
        if (checkedChildren.length && !this.model.sold_with_categories.includes(parentId)) {
          this.halfChecks.push(parentId);
        }
      }
    },
    getProductsForCategory: function getProductsForCategory(node, expand, position) {
      var _this16 = this;

      if (!node.children.length) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          category_id: parseInt(node.id),
          category_name: node.title
        };

        if (this.searchword.length >= 3) {
          data.search = this.searchword;
        }

        if (this.model.location_ids.length) {
          var ids = [];
          for (var _index = 0; _index < this.model.location_ids.length; _index++) {
            ids.push(this.model.location_ids[_index].id);
          }
          data.location_ids = ids;
        }

        this.apiRequest('/product-tree-category-products', 'GET', data, function (response) {
          if (response.status) {
            var categoryId = response.data.category_id;
            _this16.productsGrouped[categoryId].items = response.data.products;
            _this16.getTrees(categoryId, expand);
          }
        });
      } else {
        for (var index = 0; index < this.treeData.length; index++) {
          this.treeData[index].expanded = false;
          this.treeData[index].hasExpanded = false;
        }
        this.treeData[position.index].expanded = expand;
        this.treeData[position.index].hasExpanded = expand;
      }
    },
    removeChildrenFromSoldWithProducts: function removeChildrenFromSoldWithProducts(node) {
      var _this17 = this;

      var _loop = function _loop(child) {
        var index = _this17.model.sold_with_products.findIndex(function (id) {
          return parseInt(id) === parseInt(child.id);
        });
        if (index !== -1) {
          _this17.model.sold_with_products.splice(index, 1);
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(node.children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          _loop(child);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    search: function search() {
      var _this18 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.searchword.length >= 3) {
        if (this.model.location_ids.length) {
          var ids = [];
          for (var _index2 = 0; _index2 < this.model.location_ids.length; _index2++) {
            ids.push(this.model.location_ids[_index2].id);
          }
          data.location_ids = ids;
        }

        data.search = this.searchword;
        this.apiRequest('/product-tree-search', 'GET', data, function (response) {
          if (response.status === true) {
            _this18.productsGrouped = response.data;
            _this18.getTrees();
          }
        });
      }

      if (this.searchword.length === 0) {
        data.sold_with_products = this.model.sold_with_products;
        this.apiRequest('/product-tree-categories', 'GET', data, function (response) {
          if (response.status === true) {
            _this18.productsGrouped = response.data.data;
            _this18.halfChecks = (response.data.half_checks || []).map(function (id) {
              return parseInt(id);
            });
            _this18.getTrees();
          }
        });
      }
    },
    filterSecondaryCategories: function filterSecondaryCategories() {
      var _this19 = this;

      this.mainCategories.filter(function (cat) {
        return _this19.model.secondary_categories.includes(cat.id);
      });
    },
    clampCoursesType: function clampCoursesType() {
      if (!this.model || this.model.courses_type == null || this.model.courses_type === '') {
        return;
      }
      if (this.model.courses_type > this.coursesTypeMax) {
        this.model.courses_type = this.coursesTypeMax;
      }
    },
    validateCoursesType: function validateCoursesType() {
      this.$validator.validate('courses_type', 'general');
    },
    productFilterValues: function productFilterValues(filter) {
      var filterById = this.getObjectByElemKeyValue('id', filter.id, this.productAvailableFilters);
      return this.productAvailableFilters[filterById];
    },
    isNew: function isNew() {
      if (this.route.params.id && this.route.params.id !== 'add') {
        this.type = this.$t('general.edit');
        return false;
      } else {
        this.type = this.$t('general.add');
        this.model.allowed_location = true;
        return true;
      }
    },
    getData: function getData() {
      var _this20 = this;

      this.imagesToBeDeleted = [];
      this.$nextTick(function () {
        this.loading = true;
      });
      this.errors['items'] = this.removeErrorByName('error', this.errors['items']);
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      var objProps = ['taxes', 'tax_rules_v2', 'sold_with_products', 'sold_with_categories', 'extra_products', 'extra_categories', 'product_options', 'location_ids'];

      if (this.route.params.id && this.route.params.id !== 'add') {
        var prodId = this.route.params.id;

        this.apiRequest('/product/' + prodId, 'GET', data, function (response) {
          if (response.status === true) {
            if (response.data[0].image_url) {
              response.data[0].imagelist = response.data[0].image_url;
              _this20.hasImages = response.data[0].images.length > 0;
            } else {
              response.data[0].imagelist = [];
            }
            if (response.data[0].more_image_url) {
              response.data[0].moreimagelist = response.data[0].more_image_url;
            } else {
              response.data[0].moreimagelist = [];
            }
            for (var prop in objProps) {
              if (response.data[0][objProps[prop]] === undefined || response.data[0][objProps[prop]] === null) {
                response.data[0][objProps[prop]] = [];
              }
            }
            var assignedTaxRuleIds = response.data[0].tax_rules_v2.map(function (rule) {
              return Number(rule.id);
            });
            _this20.$set(response.data[0], 'tax_rule_ids_v2', assignedTaxRuleIds);
            _this20.initialProductTaxRuleIds = assignedTaxRuleIds.slice();
            if (response.data[0].category.id !== undefined) {
              response.data[0].category_id = response.data[0].category.id;
            }
            if (response.data[0].delivery_details !== undefined || response.data[0].delivery_details !== null) {
              for (var existingLocation in response.data[0].delivery_details) {
                if (response.data[0].delivery_details[existingLocation].delivery !== undefined || response.data[0].delivery_details[0].delivery !== null) {
                  for (var existingDay in response.data[0].delivery_details[0].delivery) {
                    if (response.data[0].delivery_details[0].delivery[existingDay].days === undefined || response.data[0].delivery_details[0].delivery[existingDay].days === null) {
                      response.data[0].delivery_details[0].delivery[existingDay].days = {
                        'Monday': false,
                        'Tuesday': false,
                        'Wednesday': false,
                        'Thursday': false,
                        'Friday': false,
                        'Saturday': false,
                        'Sunday': false
                      };
                    }
                  }
                }
              }
            }
            _this20.model = response.data[0];
            _this20.$set(_this20.model, 'print_on_order_label', !!_this20.model.print_on_order_label);
            _this20.model.override_delivery = !!(_this20.model.override_delivery === true || _this20.model.override_delivery === 1 || _this20.model.override_delivery === '1');
            if (!Array.isArray(_this20.model.override_settings)) {
              _this20.model.override_settings = [];
            }
            _this20.deleteOverrides = [];
            if (!_this20.model.administrations) {
              _this20.model.administrations = [];
            }
            _this20.mapLocationIdsToObjects();
            if (!_this20.model.labels || !_this20.model.labels.length) {
              _this20.model.labels = [{
                id: 0,
                type: '',
                name: '',
                ingredients: '',
                allergens: '',
                exp_txt: ''
              }];
            }
            if (Array.isArray(_this20.model.localized_fields) && _this20.model.localized_fields.length === 0) {
              _this20.model.localized_fields = {};
            }
            _this20.languages.forEach(function (element, index) {
              if (!_this20.model.localized_fields[element.short]) {
                _this20.model.localized_fields[element.short] = {
                  language_id: element.id,
                  name: '',
                  description: '',
                  language_short: element.short,
                  language_name: element.name
                };
              }
            });
            _this20.pricesFor.forEach(function (element, index) {
              if (!_this20.model.price_list[element.id]) {
                _this20.model.price_list[element.id] = {
                  id: 0,
                  price: null,
                  price_for: element.id
                };
              }
            });
            if (!_this20.model.image_size) {
              _this20.model.image_size = 'cover';
            }
            _this20.initialStatus = _this20.model.active;
            _this20.prevLocationIds = response.data[0]['location_ids'] ? [].concat(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()(response.data[0]['location_ids'])) : [];
            if (!_this20.model.secondary_categories) {
              _this20.model.secondary_categories = [];
            }
            _this20.getCategories();
            _this20.getTrees();
            _this20.filterOptionsByLocations();
            _this20.availableFiltersByLocations();
            _this20.getVatOptions(_this20.model.locations);
            _this20.getTaxOption(_this20.model.locations);
            _this20.loadLinkedProducts();

            if (_this20.$session.get('userDataRole') === 'LOCATION_STORE_ADMIN') {
              _this20.locations = _this20.model.store_admin_locations;
              if (_this20.locations.length > 1) {
                _this20.showLocations = true;
              }
            }
            _this20.updateDeliverySettings();
            _this20.$nextTick(function () {
              this.clampCoursesType();
              this.loading = false;
            });
          }
        });
      } else {
        this.model = [];
        var object = {
          'taxes': [],
          'vat_rate_id': null,
          'tax_rules_v2': [],
          'tax_rule_ids_v2': [],
          'secondary_categories': [],
          'courses_type': null,
          'sold_with_products': [],
          'sold_with_categories': [],
          'sold_with_menu_suggestion_pos': null,
          'extra_products': [],
          'extra_categories': [],
          'product_options': [],
          'product_filters': [],
          'location_ids': [],
          'discountPeriod': [],
          'price_list': {},
          'localized_fields': {},
          'image_size': 'cover',
          'is_discounted': false,
          'old_price': null,
          'new_price': null,
          'valid_from': null,
          'valid_to': null,
          'active': true,
          'print_on_order_label': false,
          'is_age_restrict': false,
          'type': 'single',
          'administrations': [],
          'override_delivery': false,
          'override_settings': []
        };
        object.labels = [{
          id: 0,
          type: '',
          name: '',
          ingredients: '',
          allergens: '',
          exp_txt: ''
        }];
        this.languages.forEach(function (element, index) {
          if (!object.localized_fields[element.short]) {
            object.localized_fields[element.short] = {
              language_id: element.id,
              name: '',
              description: '',
              language_short: element.short,
              language_name: element.name
            };
          }
        });
        this.pricesFor.forEach(function (element, index) {
          if (!object.price_list[element.id]) {
            object.price_list[element.id] = {
              id: 0,
              price: null,
              price_for: element.id
            };
          }
        });
        this.model = object;
        this.getVatOptions(this.model.locations);
        this.getTaxOption(this.model.locations);
        this.getPosIdGrupedByVat();

        this.$nextTick(function () {
          this.loading = false;
        });
      }
      this.currency = this.getCurrencySymbol(this.currency);
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateLocalizedNames: function validateLocalizedNames() {
      var _this21 = this;

      var firstInvalidSub = null;

      if (!this.model.name || !String(this.model.name).trim()) {
        if (!this.invalidTabs.includes('l1')) {
          this.invalidTabs.push('l1');
        }
        firstInvalidSub = 'l1';
      }

      if (Array.isArray(this.languages)) {
        this.languages.forEach(function (lang) {
          var lf = _this21.model.localized_fields ? _this21.model.localized_fields[lang.short] : null;
          var tabKey = lang.id + '-' + lang.short;
          if (!lf || !lf.name || !String(lf.name).trim()) {
            if (!_this21.invalidTabs.includes(tabKey)) {
              _this21.invalidTabs.push(tabKey);
            }
            if (!firstInvalidSub) {
              firstInvalidSub = tabKey;
            }
          }
        });
      }

      return firstInvalidSub;
    },
    validate: function validate() {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var initStatus, actualStatus, scopes, overallValid, firstInvalidScope, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, scope, isScopeValid, days, hasAnyInterval, hasMissingHours, hasMissingDay, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, locSetting, deliveryMethod, intervals, _loop2, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, interval, firstInvalidLocalizedTab;

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this22.errors['items'] = _this22.removeErrorByName('error', _this22.errors['items']);

                initStatus = !!parseInt(_this22.initialStatus);
                actualStatus = !!parseInt(_this22.model.active);

                if (!((!_this22.model.is_not_available_from || !_this22.model.is_not_available_to) && _this22.model.is_not_available)) {
                  _context7.next = 8;
                  break;
                }

                _this22.errorProductUnavailable = _this22.$t('catalogProd.productNotAvailableError');
                return _context7.abrupt('return', false);

              case 8:
                _this22.errorProductUnavailable = null;

              case 9:
                scopes = ['description', 'general', 'price', 'location', 'options', 'marketing', 'settings'];

                _this22.invalidTabs = [];
                overallValid = true;
                firstInvalidScope = null;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context7.prev = 16;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(scopes);

              case 18:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context7.next = 27;
                  break;
                }

                scope = _step2.value;
                _context7.next = 22;
                return _this22.$validator.validateAll(scope);

              case 22:
                isScopeValid = _context7.sent;

                if (!isScopeValid) {
                  _this22.invalidTabs.push(scope);
                  if (!firstInvalidScope) {
                    firstInvalidScope = scope;
                  }
                  overallValid = false;
                }

              case 24:
                _iteratorNormalCompletion2 = true;
                _context7.next = 18;
                break;

              case 27:
                _context7.next = 33;
                break;

              case 29:
                _context7.prev = 29;
                _context7.t0 = _context7['catch'](16);
                _didIteratorError2 = true;
                _iteratorError2 = _context7.t0;

              case 33:
                _context7.prev = 33;
                _context7.prev = 34;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 36:
                _context7.prev = 36;

                if (!_didIteratorError2) {
                  _context7.next = 39;
                  break;
                }

                throw _iteratorError2;

              case 39:
                return _context7.finish(36);

              case 40:
                return _context7.finish(33);

              case 41:

                _this22.nullProductOptionValues = false;
                if (_this22.model.product_options) {
                  _this22.model.product_options.forEach(function (element, index) {
                    if (!element.values.length) {
                      _this22.nullProductOptionValues = true;
                      overallValid = false;
                      if (!firstInvalidScope) {
                        firstInvalidScope = 'options';
                      }
                      if (!_this22.invalidTabs.includes('options')) {
                        _this22.invalidTabs.push('options');
                      }
                    }
                  });
                }

                _this22.overrideDeliveryErrors = [];

                if (!(_this22.model.override_delivery && _this22.model.override_settings && _this22.model.override_settings.length)) {
                  _context7.next = 105;
                  break;
                }

                days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
                hasAnyInterval = false;
                hasMissingHours = false;
                hasMissingDay = false;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context7.prev = 52;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this22.model.override_settings);

              case 54:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context7.next = 89;
                  break;
                }

                locSetting = _step3.value;

                if (locSetting.delivery) {
                  _context7.next = 58;
                  break;
                }

                return _context7.abrupt('continue', 86);

              case 58:
                _context7.t1 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.keys(locSetting.delivery);

              case 59:
                if ((_context7.t2 = _context7.t1()).done) {
                  _context7.next = 86;
                  break;
                }

                deliveryMethod = _context7.t2.value;
                intervals = locSetting.delivery[deliveryMethod];

                if (!(intervals.length > 0)) {
                  _context7.next = 84;
                  break;
                }

                hasAnyInterval = true;

                _loop2 = function _loop2(interval) {
                  if (!interval.available_from || !interval.available_to) {
                    hasMissingHours = true;
                  }
                  if (!days.some(function (d) {
                    return interval[d];
                  })) {
                    hasMissingDay = true;
                  }
                };

                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context7.prev = 68;
                for (_iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(intervals); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  interval = _step4.value;

                  _loop2(interval);
                }
                _context7.next = 76;
                break;

              case 72:
                _context7.prev = 72;
                _context7.t3 = _context7['catch'](68);
                _didIteratorError4 = true;
                _iteratorError4 = _context7.t3;

              case 76:
                _context7.prev = 76;
                _context7.prev = 77;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 79:
                _context7.prev = 79;

                if (!_didIteratorError4) {
                  _context7.next = 82;
                  break;
                }

                throw _iteratorError4;

              case 82:
                return _context7.finish(79);

              case 83:
                return _context7.finish(76);

              case 84:
                _context7.next = 59;
                break;

              case 86:
                _iteratorNormalCompletion3 = true;
                _context7.next = 54;
                break;

              case 89:
                _context7.next = 95;
                break;

              case 91:
                _context7.prev = 91;
                _context7.t4 = _context7['catch'](52);
                _didIteratorError3 = true;
                _iteratorError3 = _context7.t4;

              case 95:
                _context7.prev = 95;
                _context7.prev = 96;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 98:
                _context7.prev = 98;

                if (!_didIteratorError3) {
                  _context7.next = 101;
                  break;
                }

                throw _iteratorError3;

              case 101:
                return _context7.finish(98);

              case 102:
                return _context7.finish(95);

              case 103:

                if (!hasAnyInterval) {
                  _this22.overrideDeliveryErrors.push(_this22.$t('validations.noOverrideIntervals'));
                } else {
                  if (hasMissingHours) {
                    _this22.overrideDeliveryErrors.push(_this22.$t('validations.overrideIntervalMissingHours'));
                  }
                  if (hasMissingDay) {
                    _this22.overrideDeliveryErrors.push(_this22.$t('validations.overrideIntervalMissingDay'));
                  }
                }

                if (_this22.overrideDeliveryErrors.length) {
                  overallValid = false;
                  if (!_this22.invalidTabs.includes('location')) {
                    _this22.invalidTabs.push('location');
                  }
                  if (!firstInvalidScope) {
                    firstInvalidScope = 'location';
                  }
                }

              case 105:

                if (_this22.has_charisma_location && _this22.model.administrations && _this22.model.administrations.length) {
                  _this22.model.administrations.forEach(function (row, index) {
                    var fieldName = 'administration_id_' + index;
                    _this22.errors.remove(fieldName);
                    if (!row.administration_id) {
                      _this22.errors.add({
                        field: fieldName,
                        msg: _this22.$t('validations.requiredField')
                      });
                      overallValid = false;
                      if (!firstInvalidScope) {
                        firstInvalidScope = 'description';
                      }
                      if (!_this22.invalidTabs.includes('description')) {
                        _this22.invalidTabs.push('description');
                      }
                    }
                  });
                }

                firstInvalidLocalizedTab = _this22.validateLocalizedNames();

                if (firstInvalidLocalizedTab) {
                  overallValid = false;
                  if (!_this22.invalidTabs.includes('description')) {
                    _this22.invalidTabs.push('description');
                  }
                  if (!firstInvalidScope) {
                    firstInvalidScope = 'description';
                  }
                  _this22.currentSubSection = firstInvalidLocalizedTab;
                }

                if (overallValid) {
                  if (initStatus && !actualStatus) {
                    _this22.checkBanner(_this22.model.id);
                  } else {
                    _this22.initialStatus = _this22.model.active;
                    _this22.saveProduct();
                  }
                } else {
                  _this22.currentSection = firstInvalidScope || 'general';
                }

              case 109:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this22, [[16, 29, 33, 41], [34,, 36, 40], [52, 91, 95, 103], [68, 72, 76, 84], [77,, 79, 83], [96,, 98, 102]]);
      }))();
    },
    handleVatInputChange: function handleVatInputChange() {
      if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(this.model.vat)) {
        this.model.vat = Math.floor(this.model.vat);
      }
      if (this.model.vat < 0 || this.model.vat > 100) {
        this.model.vat = 0;
      }
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors[prop].length === 1) {
          this.errors.add(prop, errors[prop][0]);
        } else {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    handleVideoThumbChnage: function handleVideoThumbChnage(file, fileList) {
      var _this23 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload_video_thumbnail.clearFiles();
        this.model.video_thumbnail = [];
      } else {
        if (fileList.length > 1) {
          this.model.video_thumbnail = fileList.slice(1);
        } else {
          this.model.video_thumbnail = fileList;
        }
      }
      this.getBase64(this.model.video_thumbnail[0].raw).then(function (base64enc) {
        _this23.model.video_thumbnail[0].base64enc = base64enc;
      });
    },
    handleVideoThumbRemove: function handleVideoThumbRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.video_thumbnail = [];
      }
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
      }
    },
    handleVideoChange: function handleVideoChange(event) {
      if (event.target.files[0].size > 5097152) {
        alert('File is too big!');
        this.selectedVideo = null;
      } else {
        this.selectedVideo = event.target.files[0];
      }
    },
    handleMoreImgChnage: function handleMoreImgChnage(file, moreFileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.moreimagelist = [];
      } else {
        this.model.moreimagelist = moreFileList;
      }
    },
    handleMoreRemove: function handleMoreRemove(file, moreFileList) {
      this.imagesToBeDeleted.push(file);
      if (moreFileList.length === 0) {
        this.model.moreimagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
        text: this.$t('general.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    backButton: function backButton() {
      if (this.route.path && this.route.path.includes('/integrations/menu-fix')) {
        window.close();
        return;
      }
      this.$bus.$emit('refresh', this.route.params.id);
      this.$bus.$emit('close-modal', null, this.route.params.id);
    },
    beforeUpload: function beforeUpload(file) {
      var self = this;
      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    },
    mapItems: function mapItems() {
      for (var i in this.products) {
        var idx = this.getObjectByElemKeyValue('id', parseInt(this.products[i].id), this.model.sold_with_products);
        if (idx) {
          this.soldWithProducts.push(this.products[i]);
        }
      }
    },
    getTrees: function getTrees() {
      var expendNodeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var expandParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.treeData = [];

      var currentProdID = null;
      if (!this.isNew()) {
        currentProdID = parseInt(this.route.params.id);
      }

      this.$nextTick(function () {
        var catProdTree = [];
        this.treeData = [];
        var expand = false;

        for (var id in this.productsGrouped) {
          if (expendNodeId && parseInt(expendNodeId) === parseInt(id)) {
            if (expandParam) {
              expand = expandParam;
            }
          } else {
            expand = false;
          }
          var idCateg = this.isInObject(parseInt(id), this.model.sold_with_categories);
          if (idCateg) {
            var data = { 'id': id, 'title': this.productsGrouped[id].details.name, 'checked': true };
            var children = [];
            for (var idx in this.productsGrouped[id].items) {
              var title = this.productsGrouped[id].items[idx].name;
              title += this.productsGrouped[id].items[idx].locations.length !== 0 ? ' (' + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(this.productsGrouped[id].items[idx].locations) + ')' : ' (' + this.$t('general.all') + ')';
              if (currentProdID !== this.productsGrouped[id].items[idx].id) {
                children.push({ 'id': this.productsGrouped[id].items[idx].id, 'title': title, 'checked': true });
              }
            }
            data['children'] = children;
            data['expanded'] = expand;
            catProdTree.push(data);
          } else {
            var _children = [];
            for (var _idx in this.productsGrouped[id].items) {
              var chk = false;
              var idProd = this.isInObject(parseInt(this.productsGrouped[id].items[_idx].id), this.model.sold_with_products);
              if (idProd) {
                chk = true;
              }
              var _title = this.productsGrouped[id].items[_idx].name;
              _title += this.productsGrouped[id].items[_idx].locations.length !== 0 ? ' (' + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(this.productsGrouped[id].items[_idx].locations) + ')' : ' (' + this.$t('general.all') + ')';
              if (currentProdID !== this.productsGrouped[id].items[_idx].id) {
                _children.push({
                  'id': this.productsGrouped[id].items[_idx].id,
                  'title': _title,
                  'checked': chk
                });
              }
            }
            var isHalfcheck = _children.length ? _children.some(function (child) {
              return child.checked;
            }) : this.halfChecks.includes(parseInt(id));
            catProdTree.push({ 'id': id, 'title': this.productsGrouped[id].details.name, 'expanded': expand, 'children': _children, 'halfcheck': isHalfcheck, 'checked': false });
          }
        }
        this.treeData = catProdTree;
      });
    },
    addNewOption: function addNewOption() {
      var newRow = {
        'id': null,
        'min_no': null,
        'max_no': null,
        'required': true,
        'hide_prices': false,
        'has_default_value': false,
        'active': true,
        'values': []
      };

      this.model.product_options.push(newRow);

      this.tabIndex = this.model.product_options ? this.model.product_options.length - 1 : 0;
    },
    addNewOptionValue: function addNewOptionValue(optIdx) {
      var newRow = {
        'id': null,
        'active': true,
        'price': null
      };
      if (this.use_pos_id_per_product_option) {
        newRow['pos_id_per_product'] = 0;
      }
      if (this.use_quantity_per_product_option) {
        newRow['quantity_per_option'] = 0;
      }
      this.model.product_options[optIdx].values.push(newRow);
    },
    showAddButton: function showAddButton(optIdx, option) {
      if (option === undefined) {
        return false;
      }
      if (option['id'] === undefined) {
        return false;
      }
      var existingOptions = option['values'].length;
      var allOptions = this.productOptions[this.getObjectByElemKeyValue('id', option['company_option_id'], this.productOptions)];
      if (allOptions === undefined) {
        return false;
      }
      allOptions = allOptions['values'].length;
      return existingOptions < allOptions;
    },
    disableOption: function disableOption(optIdx, id, main) {
      var thisOptIdx = false;
      if (main) {
        if (this.model.product_options !== undefined) {
          thisOptIdx = this.getObjectByElemKeyValue('company_option_id', id, this.model.product_options);
        }
      } else {
        if (this.model.product_options[optIdx] !== undefined) {
          thisOptIdx = this.getObjectByElemKeyValue('company_option_value_id', id, this.model.product_options[optIdx]['values']);
        }
      }

      if (thisOptIdx !== false) {
        return true;
      } else {
        return false;
      }
    },
    deleteOption: function deleteOption(thisOptIdx) {
      var _this24 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
        text: self.$t('catalogProdOpt.areyouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result) {
          self.deleteOptions.push(_this24.model.product_options[thisOptIdx].id);
          self.model.product_options.splice(thisOptIdx, 1);
        }
      });
    },
    deleteOptionValue: function deleteOptionValue(thisOptIdx, thisValIdx) {
      this.deleteOptionValues.push(this.model.product_options[thisOptIdx].values[thisValIdx].id);
      this.model.product_options[thisOptIdx].values.splice(thisValIdx, 1);
    },
    updateName: function updateName(thisOptIdx, optId, optName) {
      var prOptIdx = this.getObjectByElemKeyValue('id', optId, this.productOptions);
      if (this.productOptions[prOptIdx]['name'] === optName) {
        this.model.product_options[thisOptIdx]['modified'] = false;
      } else {
        this.model.product_options[thisOptIdx]['modified'] = true;
      }
    },
    getOptData: function getOptData(option, what) {
      if (option.company_option_id) {
        var prOptIdx = this.getObjectByElemKeyValue('id', option.company_option_id, this.productOptions);
        if (prOptIdx) {
          return this.productOptions[prOptIdx].label ? this.productOptions[prOptIdx][what] + ' (' + this.productOptions[prOptIdx].label + ')' : this.productOptions[prOptIdx][what];
        }
      }
      switch (what) {
        case 'name':
          return this.$t('catalogProdOpt.new');
        default:
          return null;
      }
    },
    changeOption: function changeOption(thisOptIdx, companyOptionId) {
      if (companyOptionId) {
        var companyOptionIndex = this.getObjectByElemKeyValue('id', companyOptionId, this.productOptions);
        var companyOption = this.productOptions[companyOptionIndex];
        this.model.product_options[thisOptIdx]['values'] = [];
        this.model.product_options[thisOptIdx]['type'] = companyOption['type'];
        this.model.product_options[thisOptIdx]['name'] = companyOption['name'];
        this.model.product_options[thisOptIdx]['company_option_id'] = companyOption['id'];
        this.model.product_options[thisOptIdx]['required'] = true;
        this.model.product_options[thisOptIdx]['hide_prices'] = false;
        this.model.product_options[thisOptIdx]['has_default_value'] = false;
        this.tabIndex = thisOptIdx;
      }
    },
    searchExtra: function searchExtra() {
      this.$refs.treeExtra.searchNodes(this.searchwordExtra);
    },
    handleDelete: function handleDelete(label) {
      var self = this;

      var productData = {
        token: self.$session.get('token'),
        company_id: self.$session.get('selectedCompany'),
        product_id: self.route.params.id
      };
      self.apiRequest('/check-banner-has-product', 'GET', productData, function (response) {
        if (response && response.data && response.data.product_banner) {
          productData.active = 0;
          productData.id = response.data.banner_id;

          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
            text: self.$t('catalogProd.deleteProductUsedByBanner'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: self.$t('general.yes'),
            cancelButtonText: self.$t('general.no'),
            onOpen: function onOpen() {
              __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default.a.enableConfirmButton();
            }
          }).then(function (result) {
            if (result) {
              self.apiRequest('/banner/' + productData.id, 'PUT', productData, function (response2) {
                if (response2.status) {
                  self.deleteProduct(label);
                } else {
                  __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
                }
              });
            }
          });
        } else {
          self.deleteProduct(label);
        }
      });
    },
    deleteProduct: function deleteProduct(label) {
      var self = this;
      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
        text: self.$t('validations.areYouSureYouWantTo') + ' ' + label + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          if (self.isNew()) {
            self.$bus.$emit('refresh');
            self.$bus.$emit('close-modal');
          } else {
            var id = self.route.params.id;
            var data = {
              id: id,
              token: self.$session.get('token'),
              company_id: self.$session.get('selectedCompany')
            };
            self.apiRequest('/product/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                self.trackAdminEvent('ADMIN_PRODUCT_DELETED', 'product', id, {
                  product_id: id,
                  name: self.model && self.model.name || null,
                  location_ids: self.model && self.model.location_ids || null
                });
                __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', self.$t('catalogProd.prodDeleted'), 'success');

                self.$bus.$emit('refresh');
                self.$bus.$emit('close-modal');
              } else {
                __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    checkBanner: function checkBanner(productId) {
      var productData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        product_id: productId
      };
      var self = this;

      self.apiRequest('/check-banner-has-product', 'GET', productData, function (response) {
        if (response && response.data && response.data.product_banner) {
          productData.active = 0;
          productData.id = response.data.banner_id;

          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
            text: self.$t('catalogProd.disableProductUsedByBanner'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: self.$t('general.yes'),
            cancelButtonText: self.$t('general.no')
          }).then(function (result) {
            if (result) {
              self.initialStatus = self.model.active;
              self.apiRequest('/banner/' + productData.id, 'PUT', productData, function (response2) {
                if (response2.status) {
                  __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()(self.$t('general.success') + '!', '', 'success').catch(function () {});
                } else {
                  __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
                }
                self.saveProduct();
              });
            }
          }, function (dismiss) {
            if (dismiss === 'cancel') {
              return false;
            }
          });
        } else {
          self.saveProduct();
        }
      });
    },
    removeVideo: function removeVideo(id) {
      var _this25 = this;

      this.loading = true;
      var formData = new FormData();
      formData.append('token', this.$session.get('token'));
      formData.append('product_id', id);
      formData.append('company_id', this.$session.get('selectedCompany'));
      this.apiRequest('/product-remove-video', 'POST', formData, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
            title: '',
            text: 'Video remove successfully',
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
          if (_this25.$refs.video && _this25.$refs.video.value) {
            _this25.$refs.video.value = null;
          }
          _this25.selectedVideo = null;
          _this25.getData();
        } else {
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
            title: '',
            text: 'Video error',
            type: 'error',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
        }
        _this25.loading = false;
      });
    },
    uploadVideo: function uploadVideo(id) {
      var _this26 = this;

      if (this.selectedVideo) {
        this.loading = true;
        var formData = new FormData();
        formData.append('token', this.$session.get('token'));
        formData.append('product_id', id);
        formData.append('company_id', this.$session.get('selectedCompany'));
        formData.append('video', this.selectedVideo);
        formData.append('video_name', this.selectedVideo.name);
        this.apiRequest('/product-upload-video', 'POST', formData, function (response) {
          if (response.status) {
            __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
              title: '',
              text: 'Video saved successfully',
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
            _this26.$refs.video.value = null;
            _this26.getData();
          } else {
            __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
              title: '',
              text: 'Video error',
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
          }
          _this26.loading = false;
        });
      }
    },
    saveProduct: function saveProduct() {
      var _this27 = this;

      var videoData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var bypassPreCheckSaveProduct = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.$nextTick(function () {
        _this27.loading = true;
      });
      var self = this;
      this.apiRequest('/product/pre-check-save-product', 'POST', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: this.model.id,
        new_name: this.model.name
      }, function (pcspResp) {
        if (!bypassPreCheckSaveProduct && pcspResp && pcspResp.status && pcspResp.data.sameNameAreYouShoure) {
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
            text: self.$t('catalogProd.same_name_are_you_shore'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: self.$t('general.continue'),
            cancelButtonText: self.$t('general.cancel')
          }).then(function (result) {
            if (result) {
              self.saveProduct(videoData, 1);
            } else {
              self.loading = false;
              return 0;
            }
          }, function (dismiss) {
            if (dismiss === 'cancel') {
              self.loading = false;
              return 0;
            }
          });
          self.loading = false;
          return 0;
        }

        _this27.model.sold_with_menu_suggestion = !!_this27.model.sold_with_menu_suggestion;
        _this27.model.limit_quantity_kiosk_qr = !!_this27.model.limit_quantity_kiosk_qr;
        _this27.model.is_age_restrict = !!_this27.model.is_age_restrict;

        if (_this27.model.product_options && _this27.model.product_options.length) {
          for (var optIdx in _this27.model.product_options) {
            if (_this27.model.product_options[optIdx]['values'].length) {
              for (var optValIdx in _this27.model.product_options[optIdx]['values']) {
                var valPrc = _this27.model.product_options[optIdx]['values'][optValIdx]['price'];
                if (valPrc === null || valPrc === '') {
                  _this27.model.product_options[optIdx]['values'][optValIdx]['price'] = null;
                }
              }
            }
          }
        }

        if (_this27.model.override_settings && _this27.model.override_settings.length) {
          _this27.model.override_settings.forEach(function (item) {
            item.version = 2;
          });
        }

        _this27.model.override_delivery = !!(_this27.model.override_delivery === true || _this27.model.override_delivery === 1 || _this27.model.override_delivery === '1');

        var data = _this27.copyObject(_this27.model);

        var taxRuleIdsV2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(_this27.model.tax_rule_ids_v2 || {});
        data.tax_rule_ids_v2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(taxRuleIdsV2.map(function (id) {
          return Number(id);
        }));
        if (_this27.taxesVersion === 2) {
          delete data.vat_id;
          delete data.vat;
          delete data.taxes;
        } else {
          delete data.vat_rate_id;
        }
        delete data.tax_rules_v2;
        delete data.delivery_details;

        data.token = _this27.$session.get('token');
        data.company_id = _this27.$session.get('selectedCompany');

        data.date_validfrom = null;
        data.date_validto = null;
        data.valid_to = data.valid_to === {} ? null : data.valid_to;
        data.valid_from = data.valid_from === {} ? null : data.valid_from;

        if (data.type === 'single') {
          delete data.child_products;
        } else {
          data.child_products = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(data.child_products);
        }

        delete data.other_images;

        if (data.product_filters) {
          for (var filIdx in data.product_filters) {
            if (data.product_filters[filIdx]['filter_id'] === 0) {
              __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
                title: '',
                text: self.$t('filter.filterType') + ' ' + self.$t('general.required'),
                type: 'error',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
              self.$nextTick(function () {
                self.loading = false;
              });
              return false;
            }
            if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(data.product_filters[filIdx]['filter_value']).length === 0) {
              __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
                title: '',
                text: 'Filter values is required',
                type: 'error',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
              self.$nextTick(function () {
                self.loading = false;
              });
              return false;
            }
          }
        }

        data.product_options = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(data.product_options);
        data.product_filters = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(data.product_filters);

        data.delete_option_values = _this27.deleteOptionValues;
        data.delete_options = _this27.deleteOptions;
        data.delete_overrides = _this27.deleteOverrides;

        var objProps = ['taxes'];
        for (var prop in objProps) {
          if (data[objProps[prop]] === undefined || data[objProps[prop]] === null) {} else {
            if (data[objProps[prop]] === []) {
              data[objProps[prop]] = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(data[objProps[prop]]);
            } else {
              var vals = [];
              var objs = data[objProps[prop]];
              for (var ii in objs) {
                vals.push(objs[ii].id);
              }
              data[objProps[prop]] = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(vals);
            }
          }
        }

        data['sold_with_products'] = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(_this27.model.sold_with_products);
        data['sold_with_categories'] = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(_this27.model.sold_with_categories);

        var locIds = [];
        for (var idxL in data.location_ids) {
          locIds.push(data.location_ids[idxL]['id']);
        }
        data['location_ids'] = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(locIds);

        for (var existingLocation in data.delivery_details) {
          for (var method in data.delivery_details[existingLocation].delivery) {
            if (typeof data.delivery_details[existingLocation].delivery[method].from !== 'undefined' && (data.delivery_details[existingLocation].delivery[method].from === '' || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(data.delivery_details[existingLocation].delivery[method].from) === 'object')) {
              data.delivery_details[existingLocation].delivery[method].from = null;
            }
            if (typeof data.delivery_details[existingLocation].delivery[method].to !== 'undefined' && (data.delivery_details[existingLocation].delivery[method].to === '' || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(data.delivery_details[existingLocation].delivery[method].to) === 'object')) {
              data.delivery_details[existingLocation].delivery[method].to = null;
            }
          }
        }
        data['delivery_details'] = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(data.delivery_details);

        if (_this27.has_charisma_location) {
          if (_this27.model.administrations && _this27.model.administrations.length) {
            data.administrations = _this27.model.administrations.map(function (admin) {
              return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, admin, {
                location_ids: admin.location_ids.map(function (loc) {
                  return (typeof loc === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(loc)) === 'object' ? loc.id : loc;
                })
              });
            });
          }
          if (!_this27.isNew()) {
            data.administrationsToDelete = _this27.administrationsToDelete;
          }
        }

        var makeNull = ['monetary_conversion', 'description', 'sku', 'pos_id'];
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(makeNull), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var field = _step5.value;

            if (typeof data[field] !== 'undefined' && (data[field] === '' || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(data[field]) === 'object')) {
              data[field] = null;
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        if (_this27.isNew()) {
          delete data.image;

          _this27.apiRequest('/product', 'POST', data, function (response) {
            if (response.status === true) {
              self.model.product_options = response.data[0].product_options;
              self.model.other_info = response.data[0].other_info;
              var id = response.data[0].id;
              self.prepareMorePicturesForSave(data).then(function (saveData) {
                var hasImages = saveData.image || saveData.use === 'forMorePictures';

                var showCreateSuccess = function showCreateSuccess() {
                  self.$nextTick(function () {
                    self.loading = false;
                  });
                  __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
                    title: '',
                    text: self.$t('catalogProd.prodAdded'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }).catch(function () {});
                  self.$bus.$emit('refresh');
                  self.$bus.$emit('close-modal');
                };

                var showCreatePhotoError = function showCreatePhotoError() {
                  self.$nextTick(function () {
                    self.loading = false;
                  });
                  __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
                    title: '',
                    text: self.$t('catalogProd.prodPhotoError'),
                    type: 'danger',
                    showConfirmButton: false,
                    timer: 1500
                  }).catch(function () {});
                };

                if (hasImages) {
                  var pictureData = {
                    id: id,
                    token: data.token,
                    company_id: data.company_id
                  };
                  if (saveData.image) {
                    pictureData.image = saveData.image;
                  }
                  if (saveData.use === 'forMorePictures') {
                    pictureData.use = saveData.use;
                    pictureData.imagesToBeDeleted = saveData.imagesToBeDeleted;
                    pictureData.allPictures = saveData.allPictures;
                  }
                  self.apiRequest('/product/' + id, 'PUT', pictureData, function (response2) {
                    if (response2.status === true) {
                      showCreateSuccess();
                    } else {
                      showCreatePhotoError();
                    }
                  });
                } else {
                  showCreateSuccess();
                }
              });
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              self.handleErrors(response.errors);
            }
          });
        } else {
          var id = _this27.route.params.id;
          delete data.parent_category;
          delete data.images;
          delete data.image_url;
          delete data.created_at;
          delete data.created_by;
          delete data.updated_at;
          delete data.updated_by;
          delete data.deleted_at;
          delete data.deleted_by;
          delete data.company;
          delete data.parent_product;
          delete data.top_category;
          delete data.category;
          delete data.price_details;
          delete data.extra_categories;
          delete data.extra_products;

          if (!data.imagelist) {
            data.imagelist = [];
          }
          if (!self.model.imagelist) {
            self.model.imagelist = [];
          }
          if (!data.imagelist[0]) {
            data.images = '';
          }
          var nowHasImages = data.imagelist && !!data.imagelist[0];
          data.image_was_removed = self.hasImages && !nowHasImages;
          delete data.imagelist;
          if (_this27.selectedVideo) {
            _this27.uploadVideo(id);
          }
          self.prepareMorePicturesForSave(data).then(function (saveData) {
            self.apiRequest('/product/' + id, 'PUT', saveData, function (response) {
              if (response.status === true) {
                self.trackAdminEvent('ADMIN_PRODUCT_UPDATE', 'product', id, {
                  product_id: id,
                  name: self.model && self.model.name || null,
                  active: !!(self.model && self.model.active),
                  location_ids: self.model && self.model.location_ids || null,
                  request: saveData,
                  response: response
                });
                var deletedOptionIds = saveData.delete_options || self.deleteOptions || [];
                if (deletedOptionIds.length) {
                  deletedOptionIds.forEach(function (optId) {
                    self.trackAdminEvent('ADMIN_PRODUCT_OPTION_DELETED', 'product_option', optId, {
                      product_option_id: optId,
                      product_id: id
                    });
                  });
                }
                if (saveData.allPictures && saveData.allPictures.length) {
                  self.getData();
                }

                self.model.product_options = response.data[0].product_options;
                self.model.other_info = response.data[0].other_info;
                self.model.tax_rules_v2 = response.data[0].tax_rules_v2 || [];
                var savedTaxRuleIds = self.model.tax_rules_v2.map(function (rule) {
                  return Number(rule.id);
                });
                self.$set(self.model, 'tax_rule_ids_v2', savedTaxRuleIds);
                self.initialProductTaxRuleIds = savedTaxRuleIds.slice();
                self.model.price_list = response.data[0].price_list;
                self.pricesFor.forEach(function (element, index) {
                  if (!self.model.price_list[element.id]) {
                    self.model.price_list[element.id] = {
                      id: 0,
                      price: null,
                      price_for: element.id
                    };
                  }
                });
                self.$bus.$emit('updateProductInList', id, {
                  name: self.model.name,
                  price: self.model.price,
                  is_discounted: self.model.is_discounted,
                  active: self.model.active,
                  locations: response.data[0].locations,
                  delivery: response.data[0].delivery
                });
                if (!self.selectedVideo) {
                  self.$nextTick(function () {
                    self.loading = false;
                  });
                }
                __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
                  title: '',
                  text: self.$t('catalogProd.prodUpdated'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }).catch(function () {});
              } else {
                if (!self.selectedVideo) {
                  self.$nextTick(function () {
                    self.loading = false;
                  });
                }
                self.handleErrors(response.errors);
              }
            });
          });
        }
      });
    },
    prepareMorePicturesForSave: function prepareMorePicturesForSave(data) {
      var _this28 = this;

      var allPromises = [];
      for (var imgKey in this.model.moreimagelist) {
        var img = this.model.moreimagelist[imgKey];
        if (img && img.status === 'ready') {
          allPromises.push(this.getBase64(img.raw));
        }
      }

      var mainImagePromise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(null);
      if (this.model.imagelist && this.model.imagelist[0] && this.model.imagelist[0].status === 'ready') {
        mainImagePromise = this.getBase64(this.model.imagelist[0].raw);
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(allPromises), mainImagePromise]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            allPictures = _ref2[0],
            mainImageBase64 = _ref2[1];

        if (allPictures.length || _this28.imagesToBeDeleted.length) {
          data.use = 'forMorePictures';
          data.imagesToBeDeleted = _this28.imagesToBeDeleted;
          data.allPictures = allPictures;
        }
        if (mainImageBase64) {
          data.image = mainImageBase64;
        }
        return data;
      });
    },
    changeGroupOptions: function changeGroupOptions() {},
    checkLocations: function checkLocations(model) {
      this.$nextTick(function () {
        var self = this;
        var location = self.model.location_ids;
        var ok = true;
        var badIds = [];
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(location), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var loc = _step6.value;

            if (self.model.product_options.length) {
              var _iteratorNormalCompletion9 = true;
              var _didIteratorError9 = false;
              var _iteratorError9 = undefined;

              try {
                for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(self.model.product_options), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                  var prOpt = _step9.value;

                  var optIdx = this.getObjectByElemKeyValue('id', prOpt.id, self.model.product_options);
                  var optionLocations = self.model.product_options[optIdx]['location_ids'];
                  if (optionLocations === undefined || !optionLocations || !optionLocations.length) {} else {
                    if (optionLocations.indexOf(loc.id) === -1) {
                      ok = false;
                      badIds.push(loc.id);
                    }
                  }
                }
              } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion9 && _iterator9.return) {
                    _iterator9.return();
                  }
                } finally {
                  if (_didIteratorError9) {
                    throw _iteratorError9;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        if (!ok) {
          var btnCounter = 3;

          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
            text: self.$t('catalogProd.addLocationValidation'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: self.$t('general.continue') + ' (' + btnCounter + ')',
            cancelButtonText: self.$t('general.cancel')
          }).then(function (result) {
            if (result) {
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(badIds), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var id = _step7.value;

                  for (var k in self.model.product_options) {
                    var o = self.model.product_options[k];
                    var oIdx = self.getObjectByElemKeyValue('id', o.id, self.model.product_options);
                    if (oIdx !== false) {
                      var oLocations = self.model.product_options[oIdx]['location_ids'];
                      if (oLocations && oLocations.length !== undefined && oLocations.length && oLocations.indexOf(id) === -1) {
                        self.deleteOptions.push(o.id);
                        __WEBPACK_IMPORTED_MODULE_26_vue___default.a.delete(self.model.product_options, k);
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }

              self.prevLocationIds = self.copyObject(self.model.location_ids);
            }
          }, function (dismiss) {
            if (dismiss === 'cancel') {
              var _iteratorNormalCompletion8 = true;
              var _didIteratorError8 = false;
              var _iteratorError8 = undefined;

              try {
                for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(badIds), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                  var id = _step8.value;

                  var k = self.getObjectByElemKeyValue('id', id, self.model.location_ids);
                  if (k !== false) {
                    __WEBPACK_IMPORTED_MODULE_26_vue___default.a.delete(self.model.location_ids, k);
                  }
                }
              } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                  }
                } finally {
                  if (_didIteratorError8) {
                    throw _iteratorError8;
                  }
                }
              }

              self.prevLocationIds = self.copyObject(self.model.location_ids);
            }
          });
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default.a.disableConfirmButton();

          var btnInterval = setInterval(function () {
            btnCounter--;

            if (btnCounter >= 1) {
              __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.continue') + ' (' + btnCounter + ')';
            } else {
              __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.continue');
              clearInterval(btnInterval);
              __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default.a.enableConfirmButton();
            }
          }, 1000);
        }
        self.updateDeliverySettings();
        self.getVatOptions(self.model.locations);
        self.getTaxOption(self.model.locations);
      });
    },
    updateDeliverySettings: function updateDeliverySettings() {
      this.$nextTick(function () {
        var _this29 = this;

        var model = this.model;

        if (!Array.isArray(model.override_settings)) {
          __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(this.model, 'override_settings', []);
        }

        var deliveryDetails = [];
        var locationSource = this.locations || [];

        if (model.location_ids && model.location_ids.length) {
          locationSource = this.locations.filter(function (loc) {
            return _this29.getObjectByElemKeyValueBool('id', loc.id, model.location_ids);
          });
        }

        if (!locationSource.length) {
          locationSource = this.locations || [];
        }

        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(locationSource), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var loc = _step10.value;

            if (!loc) continue;

            var idx = this.getObjectByElemKeyValue('loc_id', loc.id, model.override_settings);
            var existing = idx !== false && idx !== null && idx !== undefined ? model.override_settings[idx] : null;

            deliveryDetails.push({
              loc_id: loc.id,
              delivery: this.buildLocationDeliveryMap(loc, existing ? existing.delivery : null)
            });
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(this.model, 'override_settings', deliveryDetails);

        this.filterOptionsByLocations();
        this.availableFiltersByLocations();
      });
    },
    showThisLocation: function showThisLocation(locId) {
      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.model.location_ids).length && this.getObjectByElemKeyValueBool('id', locId, this.model.location_ids) || !__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.model.location_ids).length && this.getObjectByElemKeyValueBool('id', locId, this.locations)) {
        return 1;
      } else {
        return 0;
      }
    },
    filterOptionsByLocations: function filterOptionsByLocations() {
      var _this30 = this;

      if (this.model && this.model.location_ids) {
        var filtered = this.copyObject(this.productOptions);
        var location = this.model.location_ids ? this.model.location_ids : this.locations;

        var _loop3 = function _loop3(loc) {
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this30.productOptions), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var prOpt = _step12.value;

              var optionLocations = prOpt['location_ids'];
              if (optionLocations === undefined || !optionLocations || !optionLocations.length) {} else {
                if (!optionLocations.find(function (obj) {
                  return obj.token === loc.id;
                })) {
                  var optIdx = _this30.getObjectByElemKeyValue('id', prOpt.id, filtered);
                  if (optIdx !== false) {
                    __WEBPACK_IMPORTED_MODULE_26_vue___default.a.delete(filtered, optIdx);
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }
        };

        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(location), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var loc = _step11.value;

            _loop3(loc);
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        this.productOptionsFiltered = filtered;
      }
    },
    availableFiltersByLocations: function availableFiltersByLocations() {
      var filtered = this.copyObject(this.companyProductFilters);
      var location = this.model && this.model.location_ids && this.model.location_ids.length ? this.model.location_ids : this.locations;
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(location), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var loc = _step13.value;
          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.companyProductFilters), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var prFilter = _step14.value;

              var filterLocations = prFilter['location_ids'];
              if (filterLocations === undefined || !filterLocations || filterLocations && !filterLocations.length) {} else {
                if (filterLocations.indexOf(loc.id) === -1) {
                  var filIdx = this.getObjectByElemKeyValue('id', prFilter.id, filtered);
                  if (filIdx !== false) {
                    __WEBPACK_IMPORTED_MODULE_26_vue___default.a.delete(filtered, filIdx);
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      this.productAvailableFilters = filtered;
    },
    getProductFilters: function getProductFilters() {
      var _this31 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        product_id: this.route.params.id
      };
      this.apiRequest('/filtercatalogproduct', 'GET', data, function (response) {
        if (response.status === true) {
          var dataWithError = response.data.map(function (value) {
            return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_extends___default()({}, value, {
              showError: false
            });
          });
          _this31.filtersData = dataWithError;
          _this31.$nextTick(function () {
            _this31.loading = false;
          });
        }
      });
    },
    getFilData: function getFilData(filterId, what) {
      if (filterId) {
        var prFilIdx = this.getObjectByElemKeyValue('id', filterId, this.companyProductFilters);
        if (prFilIdx) {
          return this.companyProductFilters[prFilIdx][what];
        }
      }
      switch (what) {
        case 'type':
          return this.$t('filter.filterName');
        default:
          return null;
      }
    },
    changeFilter: function changeFilter(thisFilIdx, filId, filter) {
      this.model.product_filters[thisFilIdx]['filter_value'] = [];
      this.tabFilterIndex = thisFilIdx;
    },
    disableFilter: function disableFilter(filIdx, filId, main) {
      var thisFilIdx = false;
      if (main) {
        if (this.model.product_filters !== undefined) {
          thisFilIdx = this.getObjectByElemKeyValue('filter_id', filId, this.model.product_filters);
        }
      } else {
        if (this.model.product_filters[filIdx] !== undefined) {
          thisFilIdx = this.getObjectByElemKeyValue('id', filId, this.model.product_filters[filIdx]['filter_value']);
        }
      }

      if (thisFilIdx !== false) {
        return true;
      } else {
        return false;
      }
    },
    disableFilterValue: function disableFilterValue(filIdx, filId, main) {
      var thisFilIdx = false;
      if (main) {
        if (this.model.product_filters !== undefined) {
          thisFilIdx = this.getObjectByElemKeyValue('id', filId, this.model.product_filters);
        }
      } else {
        if (this.model.product_filters[filIdx] !== undefined) {
          thisFilIdx = this.getObjectByElemKeyValue('id', filId, this.model.product_filters[filIdx]['filter_value']);
        }
      }

      if (thisFilIdx !== false) {
        return true;
      } else {
        return false;
      }
    },
    showAddButtonFilter: function showAddButtonFilter(filIdx, filter) {
      if (filter === undefined) {
        return false;
      }
      if (filter['filter_id'] === undefined) {
        return false;
      }
      var existingFilterValues = 0;
      existingFilterValues = filter.filter_value.length;
      var allFilters = this.companyProductFilters;
      if (allFilters === undefined) {
        return false;
      }
      var usedFilterKey = this.getObjectByElemKeyValue('id', filter.filter_id, this.companyProductFilters);
      if (usedFilterKey === false) {
        return false;
      }
      var count = this.companyProductFilters[usedFilterKey]['filter_value'].length;
      return existingFilterValues < count;
    },
    addNewFilter: function addNewFilter() {
      var newRow = {
        'filter_id': 0,
        'type': 0,
        'filter_value': []
      };
      this.model.product_filters.push(newRow);
      this.tabFilterIndex = this.model.product_filters ? this.model.product_filters.length - 1 : 0;
    },
    addNeFilterValue: function addNeFilterValue(filIdx) {
      var newRow = {
        'id': null,
        'value': 0
      };
      this.model.product_filters[filIdx].filter_value.push(newRow);
    },
    getProductFiltersCount: function getProductFiltersCount() {
      if (this.model.product_filters) {
        var filterCount = 0;
        filterCount = this.model.product_filters.length;
        return filterCount;
      }
    },
    deleteFilter: function deleteFilter(thisFilIdx) {
      var _this32 = this;

      __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
        text: this.$t('filter.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this32.model.product_filters.splice(thisFilIdx, 1);
        }
      });
    },
    deleteFilterValue: function deleteFilterValue(thisFilIdx, thisValIdx) {
      if (thisValIdx === 0) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
          title: '',
          text: this.$t('filter.minOneFilterValueRequired'),
          type: 'error',
          showConfirmButton: false,
          timer: 1500
        }).catch(function () {});
        return false;
      }
      this.model.product_filters[thisFilIdx].filter_value.splice(thisValIdx, 1);
    },
    addNewOtherInfo: function addNewOtherInfo() {
      var newRow = {
        'id': 0,
        'del': 0,
        'title': '',
        'description': ''
      };
      if (!this.model.hasOwnProperty('other_info')) {
        __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(this.model, 'other_info', []);
      }
      this.model.other_info.push(newRow);
      this.tabOtherInfoIndex = this.model.other_info ? this.model.other_info.length - 1 : 0;
    },
    deleteOtherInfo: function deleteOtherInfo(id) {
      var _this33 = this;

      __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
        text: this.$t('filter.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(_this33.model.other_info[id], 'del', 1);
        }
      });
    },
    doReloadProd: function doReloadProd(obj) {
      this.getData();
    },
    handleDateChange: function handleDateChange(event) {
      var date = new Date();
      var today = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).toISOString().split('T')[0];
      if (!event) {
        this.model.price = this.model.new_price ? this.model.new_price : this.model.price;
        this.model.valid_from = this.model.valid_to = this.model.discountPeriod = null;
      } else if (event && today >= event[0] && today <= event[1] && this.model.new_price <= this.model.price) {
        this.model.price = this.model.new_price ? this.model.new_price : this.model.price;
        this.model.valid_from = event[0];
        this.model.valid_to = event[1];
      } else {
        this.model.price = this.model.old_price ? this.model.old_price : this.model.price;
        this.model.valid_from = event[0];
        this.model.valid_to = event[1];
      }
    },
    handleDiscountedPrice: function handleDiscountedPrice(event) {
      if (this.model.is_discounted) {
        this.model.old_price = this.model.price;
        this.model.valid_from = null;
        this.model.valid_to = null;
        this.model.discountPeriod = [];
      } else {
        this.model.price = this.model.old_price && this.model.old_price > this.model.price ? this.model.old_price : this.model.price;
        this.model.new_price = null;
        this.model.old_price = null;
        this.model.valid_from = null;
        this.model.valid_to = null;
        this.model.discountPeriod = [];
      }
    },
    handleNewPriceChange: function handleNewPriceChange() {
      var date = new Date();
      var today = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).toISOString().split('T')[0];
      if (this.model.new_price <= this.model.old_price) {
        if (!this.model.valid_from || today >= this.model.valid_from && today <= this.model.valid_to) {
          this.model.price = this.model.new_price ? this.model.new_price : this.model.price;
        } else {
          this.model.price = this.model.old_price ? this.model.old_price : this.model.price;
        }
      }
    },
    handlePriceChange: function handlePriceChange() {
      var date = new Date();
      var today = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).toISOString().split('T')[0];
      if (today < this.model.valid_from) {
        this.model.old_price = this.model.price;
      }
    },
    goToLink: function goToLink(link, newTab) {
      window.open(link, newTab);
    },
    handleProductUnavailable: function handleProductUnavailable(newValue) {
      if (newValue === true && this.model.active !== true) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
          type: 'warning',
          title: this.$t('catalogProd.swalTitleChangeStatus'),
          width: 600
        });
        this.model.is_not_available = false;
      }
    },
    openSection: function openSection(section) {
      this.currentSection = section;
    },
    openSubSection: function openSubSection(section) {
      this.currentSubSection = section;
    },
    initCharismaAdministrations: function initCharismaAdministrations() {
      var _this34 = this;

      var sessionData = this.$session.get('selectedCompanyData') || {};
      var locationsDetails = sessionData.locations_details || [];

      if (!sessionData.locations_list) {
        var locationsList = locationsDetails.map(function (location) {
          return {
            id: location.true_id,
            name: location.name
          };
        });
        sessionData.locations_list = locationsList;
        this.$session.set('selectedCompanyData', sessionData);
      }
      this.charismaLocations = sessionData.locations_list;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (!sessionData.administrations) {
        this.apiRequest('/administration', 'GET', data, function (response) {
          if (response.status) {
            sessionData.administrations = response.data;
            _this34.administrations = response.data;
            _this34.$session.set('selectedCompanyData', sessionData);
          }
        });
      } else {
        this.administrations = sessionData.administrations;
      }
    },
    addAdministrationRow: function addAdministrationRow() {
      if (!this.model.administrations) {
        __WEBPACK_IMPORTED_MODULE_26_vue___default.a.set(this.model, 'administrations', []);
      }

      this.model.administrations.push({
        id: null,
        company_id: this.$session.get('selectedCompany'),
        administration_id: null,
        location_ids: []
      });
    },
    removeAdministrationRow: function removeAdministrationRow(index) {
      var removed = this.model.administrations[index];

      if (removed.id) {
        this.administrationsToDelete.push(removed.id);
      }

      this.model.administrations.splice(index, 1);
    },
    availableAdministrations: function availableAdministrations(currentId) {
      var used = this.model.administrations.map(function (r) {
        return r.administration_id;
      }).filter(function (id) {
        return id !== currentId;
      });
      return this.administrations.filter(function (a) {
        return !used.includes(a.id);
      });
    },
    mapLocationIdsToObjects: function mapLocationIdsToObjects() {
      var administrations = this.model.administrations || [];

      administrations.forEach(function (admin) {
        if (Array.isArray(admin.location_ids)) {
          admin.location_ids = admin.location_ids.map(function (loc) {
            return (typeof loc === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(loc)) === 'object' && loc ? loc.id : loc;
          }).filter(function (id) {
            return id != null;
          });
        }
      });
      this.model.administrations = administrations;
    }
  }
});

/***/ }),

/***/ "2qO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page login-wrapper"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":"","data-image":"static/img/background/background-2.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-box"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.login({ email: _vm.email, password: _vm.password })}}},[_c('div',{attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.recoverMsg !== ''),expression:"recoverMsg !== ''"}],staticClass:"text-success"},[_vm._v("\n                      "+_vm._s(_vm.recoverMsg)+"\n                    ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('error'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email","placeholder":"Email*"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('email'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-orange-purple btn-fill btn-wd ",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Let's go")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"full-page-background"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Register")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/admin/overview","tag":"li"}},[_c('a',[_vm._v("Dashboard")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header text-center"},[_c('a',{attrs:{"href":"//taptasty.com"}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo-taptasty.png"}})]),_vm._v(" "),_c('h4',{staticClass:"purple mar-to-0 mar-bt-25"},[_vm._v("Recover Password")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2rGO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2v2B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row product-import-list"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n            "+_vm._s(_vm.$t('general.back'))+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('productImport.importHistory')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{class:_vm.loading ? 'show-loader' : 'hide-loader'},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"product-import-table data-table mar-bt-20"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.batches},on:{"row-click":_vm.openBatch}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('productImport.batch'),"width":"90","align":"left","header-align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("#"+_vm._s(scope.row.id))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":_vm.$t('productImport.date'),"width":"180","align":"left","header-align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"original_filename","label":_vm.$t('productImport.file'),"min-width":"220","align":"left","header-align":"left","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('productImport.selectPriceProfile'),"width":"160","align":"left","header-align":"left","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s((scope.row.price_profile && scope.row.price_profile.name) || (scope.row.price_profiles_id ? ('#' + scope.row.price_profiles_id) : '-'))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_rows","label":_vm.$t('productImport.products'),"width":"100","align":"left","header-align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('productImport.status'),"width":"160","align":"left","header-align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.statusLabel(scope.row.status)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"120","align":"left","header-align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.openBatch(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('productImport.review'))+"\n                    ")])],1)],1)]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2vPa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-button"},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"1"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"type":"success"},on:{"click":function($event){_vm.addBonTransfer()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('gestiune.addNoteTransfer'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"label":"Nr.","prop":"documentNumber","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.documentNumber)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Serie","prop":"series","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.series)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Din Gestiunea","prop":"gestiune_from"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm.getGestiuneNameById(scope.row.gestiune_from))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"La Gestiunea","prop":"gestiune_to"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm.getGestiuneNameById(scope.row.gestiune_to))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                    ▾ ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editBonTransfer(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.edit'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.download(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('invoice.download'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadExcel(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('gestiune.downloadExcel'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},nativeOn:{"click":function($event){_vm.handleDeleteBonTransfer(scope.row._id)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2vyi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2x2C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2zJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductOptionsPanel_vue__ = __webpack_require__("BzuL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BoltMenuLayout',
  components: { ProductOptionsPanel: __WEBPACK_IMPORTED_MODULE_1__ProductOptionsPanel_vue__["a" /* default */] },
  props: {
    categories: { type: Array, default: function _default() {
        return [];
      } },
    currency: { type: String, default: 'RON' }
  },
  data: function data() {
    return {
      activeCategoryId: null,
      selectedProduct: null
    };
  },

  computed: {
    activeCategory: function activeCategory() {
      var _this = this;

      return (this.categories || []).find(function (c) {
        return c.id === _this.activeCategoryId;
      }) || null;
    },
    activeCategoryName: function activeCategoryName() {
      return this.activeCategory ? this.activeCategory.name : '';
    },
    activeProducts: function activeProducts() {
      return this.activeCategory ? this.activeCategory.products || [] : [];
    }
  },
  watch: {
    categories: {
      immediate: true,
      handler: function handler(cats) {
        if (cats && cats.length) this.activeCategoryId = cats[0].id;
        this.selectedProduct = null;
      }
    }
  },
  methods: {
    selectCategory: function selectCategory(id) {
      this.activeCategoryId = id;
    },
    truncate: function truncate(text) {
      var s = String(text || '');
      return s.length > 110 ? s.slice(0, 107) + '...' : s;
    },
    formatPrice: function formatPrice(price) {
      var n = Number(price);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(n)) return '';
      return n.toFixed(2).replace('.', ',') + ' ' + this.currency;
    }
  }
});

/***/ }),

/***/ "30fc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "32EI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "32Vb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.customerLifetimeValueReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(" "+_vm._s(_vm.$t('reports.interval'))+": "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0]))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1]))])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(" "+_vm._s(_vm.$t('reports.churnRate'))+": "),_c('b',[_vm._v(_vm._s(isNaN(_vm.churnRate) ? 0 : _vm.churnRate.toFixed(2))+" %")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-summary-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.productsTableData,"total":_vm.totalOrders,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged,"row-click":_vm.goToRecord,"sort-change":_vm.handleSortChange}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"sortable":"custom","prop":"id","label":_vm.$t('reports.clientId')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"year","label":_vm.$t('general.year')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"month","label":_vm.$t('general.month')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.$t('months.' + props.row.month))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"prop":"client_name","label":_vm.$t('reports.clientName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":200,"prop":"email","label":_vm.$t('reports.email')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"phone","label":_vm.$t('reports.phone')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"segment","label":_vm.$t('general.segment')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"sortable":"custom","prop":"registration_date","label":_vm.$t('reports.registrationDate')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"sortable":"custom","prop":"first_order_date","label":_vm.$t('reports.firstOrderDate')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"sortable":"custom","prop":"last_order_date","label":_vm.$t('reports.lastOrderDate')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":140,"prop":"monthly_order_count","sortable":"custom","render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.monthlyOrderCount'), _vm.productsTableDataTotals.total_order_count); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.monthly_order_count)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"monthly_order_value_total","sortable":"custom","min-width":180,"render-header":function (h) { return _vm.renderHeaderWithTotal(h, _vm.$t('reports.monthlyOrderValueTotal'), _vm.productsTableDataTotals.total_orders_value); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(Math.round(Number(props.row.monthly_order_value_total)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"sortable":"custom","prop":"average_order_value","label":_vm.$t('reports.averageOrderValue')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(Number(props.row.average_order_value).toFixed(2))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"sortable":"custom","prop":"monthly_order_average","label":_vm.$t('reports.monthlyOrderAverage')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(Number(props.row.monthly_order_average).toFixed(2))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"is_new_client","label":_vm.$t('reports.isNewClient')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.is_new_client ? _vm.$t('general.yes') : _vm.$t('general.no'))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":140,"prop":"is_inactive_client","label":_vm.$t('reports.isInactiveClient')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.is_inactive_client ? _vm.$t('general.yes') : _vm.$t('general.no'))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"sortable":"custom","prop":"days_since_last_order","label":_vm.$t('reports.daysSinceLastOrder')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"prop":"acquisition_channel","label":_vm.$t('reports.acquisitionChannel')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"sortable":"custom","prop":"estimated_clv","label":_vm.$t('reports.estimatedCLV')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(Number(props.row.estimated_clv).toFixed(2))+"\n            ")]}}])})],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "32rl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"canvas"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "34V7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "37fh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReorderPopupResponses_vue__ = __webpack_require__("JMxZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca8cfbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReorderPopupResponses_vue__ = __webpack_require__("M+2A");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReorderPopupResponses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca8cfbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReorderPopupResponses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "39kX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3AXy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.handleBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();return _vm.handleDelete($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":_vm.ID},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","data-vv-as":"name","placeholder":_vm.$t('settingTable.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('name'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Departament ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.department_id),expression:"model.department_id"}],staticClass:"form-control",attrs:{"type":"number","name":"department_id","data-vv-as":"department_id","placeholder":"Departament ID"},domProps:{"value":(_vm.model.department_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "department_id", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('department_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('department_id'))+"\n                ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("POS ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos_id),expression:"model.pos_id"}],staticClass:"form-control",attrs:{"type":"text","name":"pos_id","data-vv-as":"pos_id","placeholder":"beverage/food/12312"},domProps:{"value":(_vm.model.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "pos_id", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('pos_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('pos_id'))+"\n                ")]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"card",staticStyle:{"height":"auto","width":"100%","margin-top":"10px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v("Statusuri de lucru")]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('table',{staticClass:"table mar-bt-0"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"1%"}}),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v("ID")]),_vm._v(" "),_c('th',{attrs:{"width":"45%"}},[_vm._v(_vm._s(_vm.$t('kds.name')))]),_vm._v(" "),_c('th',{attrs:{"width":"45%"}},[_vm._v(_vm._s(_vm.$t('kds.deliveryMethods')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('draggable',{attrs:{"list":_vm.model.statuses,"options":{group:_vm.model.statuses},"element":'tbody'},model:{value:(_vm.model.statuses),callback:function ($$v) {_vm.$set(_vm.model, "statuses", $$v)},expression:"model.statuses"}},[_vm._l((_vm.model.statuses),function(status,index){return _c('tr',{staticClass:"sortableRow draggable-highlight"},[_c('td',[_c('i',{staticClass:"fa fa-arrows sortHandle",staticStyle:{"cursor":"move","color":"#674BD2"}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(status.id),expression:"status.id"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ID","disabled":"","name":'amount'+status.id},domProps:{"value":(status.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(status, "id", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(status.name),expression:"status.name"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",attrs:{"type":"text","placeholder":'PROCESSING ' + (index + 1),"name":'amount'+status.id},domProps:{"value":(status.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(status, "name", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('v-select',{attrs:{"multiple":"","options":_vm.deliveryMethods,"placeholder":_vm.$t('general.all')},model:{value:(_vm.model.statuses[index].delivery_methods),callback:function ($$v) {_vm.$set(_vm.model.statuses[index], "delivery_methods", $$v)},expression:"model.statuses[index].delivery_methods"}})],1),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-icon pull-right",on:{"click":function($event){$event.preventDefault();_vm.deleteStatus(status, index)}}},[_c('i',{staticClass:"ti-trash ",attrs:{"title":"Remove"}})])])])}),_vm._v(" "),(!_vm.model.statuses.length)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h6',{staticClass:"no-data"},[_vm._v(_vm._s(_vm.$t('kds.noData')))])]),_vm._v(" "),_c('td')]):_vm._e()],2)],1),_vm._v(" "),_c('button',{staticClass:"btn add mar-to-15",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingTaxes.single')},on:{"click":function($event){$event.preventDefault();_vm.addNewStatus()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.add'))+"\n                ")])]),_vm._v(" "),_vm._m(0)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"help-block warning mb-0"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v("Aceste statusuri sunt situate strict intre PROCESARE si PREPARAT")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3CPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AddEditModal_vue__ = __webpack_require__("YQHF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__);














var _components;










__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'AddEditModal', __WEBPACK_IMPORTED_MODULE_17__AddEditModal_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PPagination', __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'draggable', __WEBPACK_IMPORTED_MODULE_18_vuedraggable___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'swal', __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default.a), _components),
  beforeCreate: function beforeCreate() {
    this.$options.components.LocationGroupSection = __webpack_require__("Ozs5").default;
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this, 'groupsData', this.groupsDataProp);
    this.getData();
  },
  props: {
    groupsDataProp: {},
    groupToBeDeletedProp: {
      required: false,
      type: Object
    },
    groupToBeAddedProp: {
      required: false,
      type: Object
    },
    groupToBeEditedProp: {
      required: false,
      type: Object
    }
  },
  data: function data() {
    return {
      loading: true,
      groupsData: {},
      activeName: '',
      groupValidations: {
        group_name: {
          required: true
        },
        group_display: {
          required: true
        }
      },
      groupToBeDeleted: null,
      groupToBeEdited: null,
      groupToBeAdded: null
    };
  },

  watch: {
    groupToBeDeletedProp: function groupToBeDeletedProp(value) {
      this.deleteLocationsGroup(value);
    },
    groupToBeEditedProp: function groupToBeEditedProp(value) {
      this.editLocationsGroupImageAttribute(value);
    },
    groupToBeAddedProp: function groupToBeAddedProp(value) {
      this.addLocationsGroup(value);
    }
  },
  methods: {
    addLocationsGroup: function addLocationsGroup(newGroup) {
      if (newGroup.parent_id === this.groupsData.id && this.groupsData.children && !this.groupsData.children.includes(newGroup)) {
        var newData = [];
        newData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.groupsData.children), [newGroup]);
        __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this.groupsData, 'children', newData);
      } else {
        __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this, 'groupToBeAdded', newGroup);
      }
    },
    editLocationsGroupImageAttribute: function editLocationsGroupImageAttribute(group) {
      if (this.groupsData.id === group.parent_id) {
        var beforeEditGroup = this.findGroupById(this.groupsData.children, group.id);
        var index = this.groupsData.children.indexOf(beforeEditGroup);
        if (index !== -1) {
          __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this.groupsData.children[index], 'image', group.image);
        }
      }
    },
    findGroupById: function findGroupById(haystack, groupId) {
      var beforeEditGroup = haystack.filter(function (element) {
        return element.id === groupId;
      });
      beforeEditGroup = beforeEditGroup.pop();
      return beforeEditGroup;
    },
    deleteLocationsGroup: function deleteLocationsGroup(deletedGroup) {
      if (deletedGroup.parent_id === this.groupsData.id) {
        var filteredData = [];
        filteredData = this.groupsData.children.filter(function (element) {
          return element.id !== deletedGroup.id;
        });
        __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this.groupsData, 'children', filteredData);
      } else {
        __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this, 'groupToBeDeleted', deletedGroup);
      }
    },
    openEditLocationGroupModal: function openEditLocationGroupModal(group) {
      this.$emit('open-modal', group);
    },
    handleActiveGroup: function handleActiveGroup(group) {
      var _this = this;

      var actionText = group.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + group.name + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this.$session.get('token'),
            company_id: _this.$session.get('selectedCompany'),
            active: group.active ? 1 : 0,
            name: group.name,
            id: group.id
          };
          _this.apiRequest('/location-groups/' + group.id, 'PUT', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
                title: '',
                text: _this.$t('general.success'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
                title: '',
                text: _this.$t('validations.dataCouldNotBeSaved'),
                type: 'danger',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
            }
          });
        }
      }).catch(function () {
        group.active = !group.active;
      });
    },
    getData: function getData() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        group_id: this.groupsData.id
      };

      this.apiRequest('/locations-groups-show-admin', 'GET', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(_this2.groupsData, 'children', response.data);
          _this2.$nextTick(function () {
            this.loading = false;
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "3Cl/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3DXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      screenRoutes: [{ path: '/screens/tabs?tabIndex=0', key: 'ods' }, { path: '/screens/tabs?tabIndex=1', key: 'posScreen' }, { path: '/screens/tabs?tabIndex=2', key: 'digitalSignage' }]
    };
  },

  methods: {
    getImageForRoute: function getImageForRoute(routeKey) {
      var images = {
        ods: 'static/img/ods.png',
        posScreen: 'static/img/posScreen.png',
        digitalSignage: 'static/img/digitalSignage.png'
      };
      return images[routeKey] || 'static/img/default.jpg';
    },
    getBoxColor: function getBoxColor(index) {
      var colors = ['#3AB7CD', '#674bd2', '#20bfab'];
      return colors[index] || '#FFFFFF';
    }
  }
});

/***/ }),

/***/ "3E23":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3FaB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationEditWolt_vue__ = __webpack_require__("a5L6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c7a7e77_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationEditWolt_vue__ = __webpack_require__("FpHq");
function injectStyle (ssrContext) {
  __webpack_require__("cGpe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c7a7e77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationEditWolt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c7a7e77_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationEditWolt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3I9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreenView_vue__ = __webpack_require__("3DXX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3951b898_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreenView_vue__ = __webpack_require__("gobJ");
function injectStyle (ssrContext) {
  __webpack_require__("MnBL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3951b898"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreenView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3951b898_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreenView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3IFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PosList_vue__ = __webpack_require__("R35P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PosMapList_vue__ = __webpack_require__("U6jD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PosSettingsUsers_vue__ = __webpack_require__("mzhu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CantarList_vue__ = __webpack_require__("upf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Screens_OrderScreen_PosScreen_vue__ = __webpack_require__("jUCR");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PosList: __WEBPACK_IMPORTED_MODULE_0__PosList_vue__["a" /* default */],
    PosMapList: __WEBPACK_IMPORTED_MODULE_1__PosMapList_vue__["a" /* default */],
    PosSettingsUsers: __WEBPACK_IMPORTED_MODULE_2__PosSettingsUsers_vue__["a" /* default */],
    CantarList: __WEBPACK_IMPORTED_MODULE_3__CantarList_vue__["a" /* default */],
    PosScreen: __WEBPACK_IMPORTED_MODULE_4__Screens_OrderScreen_PosScreen_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isTableMaps: false,
      isFirst: false,
      isUser: false,
      isCantar: false,
      isReport: false,
      isSettings: false,
      isPosScreen: false
    };
  },
  mounted: function mounted() {
    this.switchTab();
  },

  methods: {
    resetStates: function resetStates() {
      this.isTableMaps = false;
      this.isFirst = false;
      this.isUser = false;
      this.isCantar = false;
      this.isReport = false;
      this.isSettings = false;
      this.isPosScreen = false;
    },
    switchTab: function switchTab() {
      var _this = this;

      var index = this.$route.query.tabIndex;
      this.$nextTick(function () {
        if (index && _this.$refs.tabs) {
          _this.$refs.tabs.navigateToTab(parseInt(index));
        }
      });
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      this.resetStates();
      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);
      switch (newTab.title) {
        case this.$t('pages.tableMaps'):
          this.isTableMaps = true;
          break;
        case this.$t('dispath.users'):
          this.isUser = true;
          break;

        case 'Cantar':
          this.isCantar = true;
          break;

        case this.$t('pages.posScreen'):
          this.isPosScreen = true;
          break;
        default:
          this.isFirst = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ "3RFX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Sx/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementWastedAdd_vue__ = __webpack_require__("Vmvn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d321f3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementWastedAdd_vue__ = __webpack_require__("BdGd");
function injectStyle (ssrContext) {
  __webpack_require__("Gm2z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d321f3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementWastedAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d321f3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementWastedAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3V/3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Via":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var end = new Date();
    var start = new Date();
    start.setDate(end.getDate() - 29);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    return {
      stocLaZi: false,
      loading: false,
      loadingTimeout: null,
      selectedProduct: null,
      selectedDocumentType: '',
      loadingProducts: false,
      selectedCategory: '',
      documentNumber: '',
      tableData: [],
      searchDate: [start, end],
      filter: {
        series: ''
      },
      totalGeneral: {
        valoareIntrare: 0,
        valoareIesire: 0,
        valoareStoc: 0
      },
      categories: [{ value: '', label: 'Selectează categoria' }, { value: 'Marfa', label: 'Marfa' }, { value: 'Materii prime', label: 'Materii prime' }, { value: 'Materiale consumabile', label: 'Materiale consumabile' }, { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' }, { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' }, { value: 'Produs rezidual', label: 'Produs rezidual' }, { value: 'Ambalaje', label: 'Ambalaje' }, { value: 'Obiecte de inventar', label: 'Obiecte de inventar' }, { value: 'fara_categorie', label: 'Fara categorie' }],
      documentTypes: [{ value: '', label: 'Selectează tipul de document' }, { value: 'NIR', label: 'NIR' }, { value: 'BON_TRANSFER', label: 'Bon de transfer' }, { value: 'BON_PRODUCTIE', label: 'Bon de producție' }, { value: 'BON_CONSUM', label: 'Bon de consum' }, { value: 'BON_FISCAL', label: 'Bon fiscal' }, { value: 'AVIZ', label: 'Aviz' }],
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      searchProdResults: [],
      groupedTableData: [],
      flattenedHistory: [],
      searchTerm: null,
      searchTimeout: null,
      selectedGestiune: null,
      selectedLocation: null,
      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            var end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      }
    };
  },

  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    },
    extraProp: { type: Boolean, required: false }
  },
  computed: {
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id;
      });
      return result;
    },
    selectedGestiuneObject: function selectedGestiuneObject() {
      var _this2 = this;

      return this.gestiuneOptions.find(function (g) {
        return g.id === _this2.selectedGestiune;
      });
    }
  },
  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.resetTable();

      this.selectedGestiune = null;
      this.selectedProduct = null;
      this.tableData = [];
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code;
    },
    selectedGestiune: function selectedGestiune() {
      this.resetTable();
    },
    selectedCategory: function selectedCategory() {
      this.resetTable();

      this.searchProdResults = [];
      this.selectedProduct = null;
    },
    selectedDocumentType: function selectedDocumentType() {
      this.resetTable();
    },
    documentNumber: function documentNumber() {
      this.resetTable();
    },
    groupedLocations: function groupedLocations(newVal) {
      this.firstLoad();
    },
    gestiuneOptions: function gestiuneOptions(newVal) {
      this.firstLoad();
    },
    stocLaZi: function stocLaZi(val) {
      this.resetTable();

      this.pageSize = val ? 50 : 3;
    },
    searchDate: function searchDate() {
      this.resetTable();
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    this.firstLoad();

    console.log('ss', this.extraProp);
    if (this.extraProp) {
      this.stocLaZi = true;
      this.handleStocLaZi();
    }
  },

  methods: {
    resetTable: function resetTable() {
      this.groupedTableData = [];
      this.totalItems = 0;
      this.currentPage = 1;
      this.pageSize = 20;
      this.totalGeneral = { valoareIntrare: 0, valoareIesire: 0, valoareStoc: 0 };
    },
    getCategoryClass: function getCategoryClass(categorie) {
      if (!categorie) return '';

      switch (categorie.toLowerCase().replace(/\s+/g, '-')) {
        case 'marfa':
          return 'marfa';
        case 'semifabricate-(reteta)':
          return 'semifabricate';
        case 'materii-prime':
          return 'materii-prime';
        case 'produs-finit-(reteta)':
          return 'produs-finit';
        default:
          return '';
      }
    },
    firstLoad: function firstLoad() {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0];
      }
    },
    handleStocLaZi: function handleStocLaZi() {
      this.resetTable();

      if (this.stocLaZi) {
        var today = new Date();
        var start = new Date(today.setHours(0, 0, 0, 0));
        var end = new Date(today.setHours(23, 59, 59, 999));

        this.searchDate = [start, end];
      }
    },
    downloadDocument: function downloadDocument(format) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                externalCompanyId = _this3.companyID;

                if (externalCompanyId) {
                  _context.next = 4;
                  break;
                }

                alert('Missing company ID.');
                return _context.abrupt('return');

              case 4:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/export?export=' + format + '&externalCompanyId=' + externalCompanyId;
                _context.prev = 5;
                _context.next = 8;
                return fetch(url);

              case 8:
                response = _context.sent;

                if (!response.ok) {
                  _context.next = 20;
                  break;
                }

                _context.next = 12;
                return response.blob();

              case 12:
                blob = _context.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = 'document.' + format.toLowerCase();
                link.click();
                URL.revokeObjectURL(link.href);
                _context.next = 21;
                break;

              case 20:
                console.error('Error downloading document:', response.statusText);

              case 21:
                _context.next = 26;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context['catch'](5);

                console.error('Error fetching document:', _context.t0);

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[5, 23]]);
      }))();
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      var size = this.stocLaZi ? 50 : this.pageSize;
      this.getData(null, this.currentPage, size);
    },
    toCssClass: function toCssClass(str) {
      if (!str) return '';
      return str.toLowerCase().trim().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
    },
    randomColor: function randomColor(seed) {
      var hash = 0;
      for (var i = 0; i < seed.length; i++) {
        hash = seed.charCodeAt(i) + ((hash << 5) - hash);
      }
      var c = (hash & 0x00FFFFFF).toString(16).toUpperCase();
      return '#' + '00000'.substring(0, 6 - c.length) + c;
    },
    formatDocumentTypeLabel: function formatDocumentTypeLabel(str) {
      if (!str) return '-';
      return str.replace(/_/g, ' ').toLowerCase().split(' ').map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join(' ');
    },
    formatNumberWithZecimale: function formatNumberWithZecimale(value) {
      var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      if (value === undefined || value === null || isNaN(value)) return '-';
      return parseFloat(value).toFixed(decimals);
    },
    formatNumber: function formatNumber(value) {
      if (value === null || value === undefined) return '';

      return Math.round(value).toString();
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (!cellValue) return '';
      var d = new Date(cellValue);
      return d.toLocaleString('ro-RO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    triggerFilter: function triggerFilter() {
      this.resetTable();

      this.tableData = [];
      this.getData();
    },
    handleProductSelect: function handleProductSelect(product) {
      this.resetTable();

      this.selectedProduct = product;
    },
    handleClearProduct: function handleClearProduct() {
      this.resetTable();

      this.selectedProduct = null;
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!searchTerm || searchTerm.length < 2)) {
                  _context2.next = 3;
                  break;
                }

                _this4.searchProdResults = [];
                return _context2.abrupt('return');

              case 3:

                _this4.loadingProducts = true;

                _context2.prev = 4;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/products?vatNumber=' + _this4.selectedVatNumber + '&name=' + encodeURIComponent(searchTerm) + '&externalCompanyId=' + _this4.companyID;


                if (_this4.selectedCategory) {
                  url += '&categorie=' + encodeURIComponent(_this4.selectedCategory);
                }

                _context2.next = 9;
                return fetch(url);

              case 9:
                response = _context2.sent;
                _context2.next = 12;
                return response.json();

              case 12:
                data = _context2.sent;


                if (Array.isArray(data.products)) {
                  _this4.searchProdResults = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data.products));
                } else {
                  _this4.searchProdResults = [];
                }
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](4);

                console.error('Error fetching products:', _context2.t0);
                _this4.searchProdResults = [];

              case 20:
                _context2.prev = 20;

                _this4.loadingProducts = false;
                return _context2.finish(20);

              case 23:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[4, 16, 20, 23]]);
      }))();
    },
    getData: function getData() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var _this5 = this;

      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
      var exportFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var externalCompanyId, url, startISO, endISO, response, _response, blob, link, data, products, processed;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                externalCompanyId = _this5.companyID;

                if (!(!externalCompanyId || !_this5.selectedGestiune || !_this5.selectedLocation)) {
                  _context3.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  type: 'warning',
                  title: _this5.selectedGestiune ? 'Select Location' : 'Select Gestiune',
                  text: !_this5.selectedGestiune ? 'Trebuie să selectați o gestiune pentru a continua.' : 'Trebuie să selectați o locație pentru a continua.',
                  confirmButtonText: 'OK'
                });
                return _context3.abrupt('return');

              case 4:

                if (_this5.stocLaZi) {
                  pageSize = _this5.pageSize = 50;
                }

                clearTimeout(_this5.loadingTimeout);
                _this5.loading = true;

                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/stock_history_advanced_v2?externalCompanyId=' + externalCompanyId;

                if (date) url += '&date=' + date;
                if (_this5.selectedGestiune) url += '&gestiune=' + _this5.selectedGestiune;
                if (_this5.selectedLocation) url += '&externalLocationId=' + _this5.selectedLocation.true_id;

                if (_this5.selectedCategory) {
                  url += '&categorie=' + encodeURIComponent(_this5.selectedCategory);
                }

                if (_this5.selectedDocumentType) {
                  url += '&document_type=' + encodeURIComponent(_this5.selectedDocumentType);
                }

                url += '&page=' + page + '&limit=' + pageSize;

                if (exportFormat) {
                  url += '&export=' + exportFormat;
                }

                if (_this5.searchDate && _this5.searchDate.length >= 2 && _this5.searchDate[0] && _this5.searchDate[1]) {
                  startISO = new Date(_this5.searchDate[0]);
                  endISO = new Date(_this5.searchDate[1]);

                  url += '&startDate=' + encodeURIComponent(startISO) + '&endDate=' + encodeURIComponent(endISO);
                }

                if (_this5.selectedProduct) {
                  url += '&product_id=' + _this5.selectedProduct;
                }

                _context3.prev = 17;
                _context3.next = 20;
                return fetch(url);

              case 20:
                response = _context3.sent;

                if (!exportFormat) {
                  _context3.next = 53;
                  break;
                }

                if (!(!_this5.groupedTableData || _this5.groupedTableData.length === 0)) {
                  _context3.next = 25;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  type: 'warning',
                  title: 'Nu există date',
                  text: 'Nu există date pentru export în perioada și filtrele selectate.',
                  icon: 'warning',
                  confirmButtonText: 'OK'
                });
                return _context3.abrupt('return');

              case 25:

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  type: 'warning',
                  title: 'Se procesează exportul...',
                  text: 'În funcție de perioadă și filtrele aplicate, exportul poate dura. Vă rugăm să așteptați...',
                  allowOutsideClick: false,
                  showConfirmButton: false,
                  didOpen: function didOpen() {
                    __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.showLoading();
                  }
                });
                _context3.prev = 26;
                _context3.next = 29;
                return fetch(url);

              case 29:
                _response = _context3.sent;

                if (!_response.ok) {
                  _context3.next = 41;
                  break;
                }

                _context3.next = 33;
                return _response.blob();

              case 33:
                blob = _context3.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = 'stock_history.' + exportFormat.toLowerCase();
                link.click();
                URL.revokeObjectURL(link.href);
                _context3.next = 43;
                break;

              case 41:
                console.error('Error downloading export:', _response.statusText);
                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Eroare la desc\u0103rcarea fi\u0219ierului: ' + _response.statusText,
                  type: 'error',
                  timer: 3000,
                  showConfirmButton: false
                });

              case 43:
                _context3.next = 49;
                break;

              case 45:
                _context3.prev = 45;
                _context3.t0 = _context3['catch'](26);

                console.error('Eroare fetch export:', _context3.t0);
                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o eroare la descărcarea fișierului.',
                  type: 'error',
                  timer: 3000,
                  showConfirmButton: false
                });

              case 49:
                _context3.prev = 49;

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.close();
                return _context3.finish(49);

              case 52:
                return _context3.abrupt('return');

              case 53:
                _context3.next = 55;
                return response.json();

              case 55:
                data = _context3.sent;

                _this5.totalItems = data.total || 0;
                _this5.currentPage = data.currentPage || page;
                _this5.pageSize = data.pageSize || pageSize;

                if (!(data.status === true && Array.isArray(data.products) && data.products.length === 0)) {
                  _context3.next = 62;
                  break;
                }

                _this5.groupedTableData = [];
                return _context3.abrupt('return');

              case 62:
                products = [];

                if (data.products && Array.isArray(data.products)) {
                  products = data.products;
                } else if (data.history && data.product_id) {
                  products = [data];
                }

                processed = products.map(function (prod) {
                  var firstHistory = prod.history && prod.history.length > 0 ? prod.history[0] : null;
                  var firstItem = firstHistory && firstHistory.item ? firstHistory.item : {};

                  var history = Array.isArray(prod.history) ? prod.history : [];

                  var totalIntrare = history.filter(function (e) {
                    return e.document_type !== 'STOCK_INITIAL';
                  }).reduce(function (sum, e) {
                    return sum + (parseFloat(e.intrare) || 0);
                  }, 0);

                  var totalIesire = history.filter(function (e) {
                    return e.document_type !== 'STOCK_INITIAL';
                  }).reduce(function (sum, e) {
                    return sum + (parseFloat(e.iesire) || 0);
                  }, 0);

                  var totalValoareIntrare = history.filter(function (e) {
                    return e.document_type !== 'STOCK_INITIAL';
                  }).reduce(function (sum, e) {
                    var cant = parseFloat(e.intrare) || 0;
                    var pret = parseFloat(e.pret) || 0;
                    return sum + cant * pret;
                  }, 0);

                  var totalValoareIesire = history.filter(function (e) {
                    return e.document_type !== 'STOCK_INITIAL';
                  }).reduce(function (sum, e) {
                    var cant = parseFloat(e.iesire) || 0;
                    var pret = parseFloat(e.pret) || 0;
                    return sum + cant * pret;
                  }, 0);

                  var lastEntry = history.length > 0 ? history[history.length - 1] : {};

                  var hasStockInitial = history.some(function (e) {
                    return e.document_type === 'STOCK_INITIAL';
                  });

                  return {
                    productId: prod.product_id,
                    productName: prod.denumire_produs_sau_serviciu || firstItem.product_naame || 'N/A',
                    um: (firstItem.um || firstItem.product_um || 'N/A').toUpperCase(),
                    stocMinim: prod.productDetails && prod.productDetails.stocMinim ? prod.productDetails.stocMinim : 0,
                    totalQuantity: totalIntrare - totalIesire,
                    totalIntrare: totalIntrare,
                    totalIesire: totalIesire,
                    valoareIntrare: totalValoareIntrare > 0 ? totalValoareIntrare : null,
                    valoareIesire: totalValoareIesire > 0 ? totalValoareIesire : null,
                    stocFinal: lastEntry && lastEntry.stoc_final != null ? lastEntry.stoc_final : null,
                    running: lastEntry && lastEntry.running != null ? lastEntry.running : 0,
                    runningValue: lastEntry && lastEntry.runningValue != null ? lastEntry.runningValue : 0,
                    valoareStoc: lastEntry && lastEntry.valoare_stoc != null ? lastEntry.valoare_stoc : null,
                    hasStockInitial: hasStockInitial,
                    history: prod.history && Array.isArray(prod.history) ? prod.history.map(function (h) {
                      var item = h.item || {};
                      var document = h.document || {};
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, h, {
                        item: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
                          id: item.product_id || item.posId || null
                        }),
                        document: document
                      });
                    }) : []
                  };
                });


                _this5.groupedTableData = processed;

                _this5.totalGeneral = {
                  valoareIntrare: processed.filter(function (e) {
                    return e.document_type !== 'STOCK_INITIAL';
                  }).reduce(function (sum, p) {
                    return sum + (p.valoareIntrare || 0);
                  }, 0),
                  valoareIesire: processed.filter(function (e) {
                    return e.document_type !== 'STOCK_INITIAL';
                  }).reduce(function (sum, p) {
                    return sum + (p.valoareIesire || 0);
                  }, 0),
                  valoareStoc: processed.reduce(function (sum, p) {
                    return sum + (p.runningValue || 0);
                  }, 0)
                };
                _context3.next = 72;
                break;

              case 69:
                _context3.prev = 69;
                _context3.t1 = _context3['catch'](17);

                console.error('Eroare fetch:', _context3.t1);

              case 72:
                _context3.prev = 72;

                _this5.loading = false;
                return _context3.finish(72);

              case 75:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[17, 69, 72, 75], [26, 45, 49, 52]]);
      }))();
    },
    goToProduced: function goToProduced(entry) {
      if (!entry || !entry.document || !entry.document.produced_posId) return;

      var producedId = entry.document.produced_posId;
      var vatNumber = entry.document.company.vatNumber || '';

      this.$router.push({
        path: '/management/nomenclator-products/edit/' + producedId + '/' + vatNumber,
        query: {
          highlight: entry.item.product_id || entry.document.produced_posId
        }
      });
    },
    goToDocument: function goToDocument(entry) {
      try {
        if (!entry || !entry.document_type) {
          return false;
        }

        var type = entry.document_type;
        var doc = entry.document || {};

        var id = entry.document_id || doc._id;

        if (!id) {
          return false;
        }

        if (type === 'NIR') {
          if (!doc.nirNumber) return false;

          return this.$router.push({
            path: '/management/entries/edit/' + id,
            query: {
              nirNumber: doc.nirNumber,
              data_document: doc.data_document,
              vatNumberFurnizor: doc.vatNumberFurnizor,
              series: doc.series
            }
          });
        }

        if (type === 'BON_TRANSFER') {
          if (!doc.series || !doc.documentNumber) return false;

          return this.$router.push({
            path: '/management/transfer/edit/' + doc.series + '/' + doc.documentNumber
          });
        }

        if (type === 'BON_PRODUCTIE') {
          if (!doc.series || !doc.documentNumber) return false;

          return this.$router.push({
            path: '/management/bon-product/edit/' + doc.series + '/' + doc.documentNumber
          });
        }

        if (type === 'BON_FISCAL') {
          if (!doc._id) return false;

          return this.$router.push({
            name: 'ManagementBonFiscalView',
            params: { id: doc._id }
          });
        }

        if (type === 'AVIZ') {
          if (!doc.series || !doc.invoiceNumber) return false;

          var invoiceId = doc.series + '-' + doc.invoiceNumber;

          return this.$router.push({
            path: '/management/outputs/' + invoiceId,
            query: { edit: 'true' }
          });
        }

        if (type === 'BON_CASARE') {
          if (!doc.series || !doc.documentNumber) return false;

          return this.$router.push({
            path: '/management/wasted/edit/' + doc.series + '/' + doc.documentNumber
          });
        }

        if (type === 'BON_CONSUM') {
          if (!doc.series || !doc.documentNumber) return false;

          return this.$router.push({
            path: '/management/stocks/edit/' + doc.series + '/' + doc.documentNumber
          });
        }

        return false;
      } catch (error) {
        return false;
      }
    },
    getDocumentNumberLabel: function getDocumentNumberLabel(entry) {
      var doc = entry.document || {};
      var type = entry.document_type;

      if (type === 'NIR') {
        if (doc.series && doc.nirNumber) {
          return doc.series + '-' + doc.nirNumber;
        }
        return doc.nirNumber || '';
      }

      if (['BON_TRANSFER', 'BON_PRODUCTIE', 'BON_CONSUM'].includes(type)) {
        if (doc.documentNumber) {
          return doc.series + '-' + doc.documentNumber;
        }
        return '';
      }

      if (type === 'BON_FISCAL') {
        if (doc.nr) {
          return 'NR: ' + doc.nr;
        }
        return '';
      }

      if (type === 'AVIZ') {
        if (doc.series && doc.invoiceNumber) {
          return doc.series + '-' + doc.invoiceNumber;
        }
        return doc.invoiceNumber || '';
      }

      if (type === 'INVENTAR') {
        if (doc.series && doc.number) {
          return doc.series + '-' + doc.number;
        }
        return doc.number || '';
      }

      return '';
    },
    downloadInvoice: function downloadInvoice(row) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var series, invoiceNumber, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                series = row.series;
                invoiceNumber = row.invoiceNumber;

                if (!(!series || !invoiceNumber)) {
                  _context4.next = 5;
                  break;
                }

                alert('Missing series or invoice number.');
                return _context4.abrupt('return');

              case 5:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/invoice/' + series + '-' + invoiceNumber + '/pdf';
                _context4.prev = 6;
                _context4.next = 9;
                return fetch(url);

              case 9:
                response = _context4.sent;

                if (!response.ok) {
                  _context4.next = 21;
                  break;
                }

                _context4.next = 13;
                return response.blob();

              case 13:
                blob = _context4.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + invoiceNumber + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                _context4.next = 22;
                break;

              case 21:
                console.error('Error downloading invoice:', response.statusText);

              case 22:
                _context4.next = 27;
                break;

              case 24:
                _context4.prev = 24;
                _context4.t0 = _context4['catch'](6);

                console.error('Error fetching invoice:', _context4.t0);

              case 27:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[6, 24]]);
      }))();
    }
  }
});

/***/ }),

/***/ "3W1s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Wqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrinterAdd_vue__ = __webpack_require__("tFKc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a7aea7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrinterAdd_vue__ = __webpack_require__("HG/N");
function injectStyle (ssrContext) {
  __webpack_require__("JmI1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrinterAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a7aea7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrinterAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3XMI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventarView"},[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons mar-rt-10"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group mar-rt-10",staticStyle:{"flex":"1"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                  "+_vm._s(loc.name)+"\n                ")])}))}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group mar-rt-10",staticStyle:{"flex":"1"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.status')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedStatus),expression:"selectedStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Toate")]),_vm._v(" "),_c('option',{attrs:{"value":"DRAFT"}},[_vm._v("Nefinalizat")]),_vm._v(" "),_c('option',{attrs:{"value":"VALIDATED"}},[_vm._v("Validat")])])])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.addInventory($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('gestiune.addInventory'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData'),"element-loading-text":"Se încarcă..."}},[_c('el-table-column',{attrs:{"prop":"number","label":_vm.$t('gestiune.nr'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"series","label":_vm.$t('invoice.series'),"width":"70"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"state","label":_vm.$t('gestiune.status'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{style:({
                  backgroundColor: scope.row.state === 'VALIDATED' ? '#67C23A' : '#909399',
                  color: 'white',
                  padding: '2px 8px',
                  borderRadius: '50px',
                  fontSize: '12px',
                  display: 'inline-block'
                })},[_vm._v("\n                "+_vm._s(scope.row.state)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.gestiune'),"width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.getGestiuneNameById(scope.row.gestiune))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.date')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.formatDate(scope.row.date))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                  ▾ ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[(scope.row.state != 'VALIDATED')?_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editInventory(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.edit'))+"\n                  ")]):_vm._e(),_vm._v(" "),(scope.row.state == 'VALIDATED')?_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editInventory(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.see'))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadPdf(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('invoice.download'))+"\n                  ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadExcel(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('gestiune.downloadExcel'))+"\n                  ")]),_vm._v(" "),(scope.row.state != 'VALIDATED')?_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},nativeOn:{"click":function($event){_vm.deleteInventory(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.delete'))+"\n                  ")]):_vm._e()],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}}),_vm._v(" "),(!_vm.tableData.length && !_vm.loading)?_c('div',{staticStyle:{"text-align":"center","margin-top":"20px"}},[_vm._v("\n          Nu există inventare pentru criteriile selectate.\n        ")]):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3bPQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3czh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isAccountingInboundInvoices },on:{"click":_vm.openAccountingInboundInvoices}},[_vm._v("\n            "+_vm._s(_vm.$t('gestiune.inboundInvoices'))+"\n          ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isAccountingSales },on:{"click":_vm.openAccountingSales}},[_vm._v("\n            "+_vm._s(_vm.$t('gestiune.accountingSales'))+"\n          ")])])])])]),_vm._v(" "),(_vm.isAccountingInboundInvoices)?_c('div',[_c('AccountingInboundInvoices',{attrs:{"grouped-locations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isAccountingSales)?_c('div',[_c('AccountingSales',{attrs:{"grouped-locations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3f2I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isZones },on:{"click":function($event){_vm.openTab('zones')}}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.zonesTitle')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isSlots },on:{"click":function($event){_vm.openTab('slots')}}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.slotsTitle')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isPreferences },on:{"click":function($event){_vm.openTab('preferences')}}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.preferencesTitle')))])])])])]),_vm._v(" "),(_vm.isZones)?_c('div',[_c('settings-delivery-zones')],1):_vm._e(),_vm._v(" "),(_vm.isSlots)?_c('div',[_c('settings-delivery-slots')],1):_vm._e(),_vm._v(" "),(_vm.isPreferences)?_c('div',[_c('settings-delivery-preferences')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3h9K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3o1n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3oa1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RSystemSetup_vue__ = __webpack_require__("6yfg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1bef34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RSystemSetup_vue__ = __webpack_require__("khGH");
function injectStyle (ssrContext) {
  __webpack_require__("0ydz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a1bef34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RSystemSetup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1bef34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RSystemSetup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3qTf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3v1P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3vOG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3w8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_tooltip_css__ = __webpack_require__("RWjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_tooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_tooltip__ = __webpack_require__("aMwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_css__);










__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_tooltip___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  created: function created() {
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      tableData: [],
      isNew: false,
      model: {},
      maxVisibleSections: 3
    };
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {

      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/screens/kds/edit/');
      }
    },
    goToAdd: function goToAdd() {
      this.$router.push('/screens/kds/add');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getRowSectionNames: function getRowSectionNames(row) {
      if (row.sections && row.sections.length) {
        return row.sections.map(function (section) {
          return section.name;
        });
      }
      if (row.section && row.section.name) {
        return [row.section.name];
      }
      return [];
    },
    getVisibleSectionNames: function getVisibleSectionNames(row) {
      var names = this.getRowSectionNames(row);
      if (!names.length) {
        return this.$t('general.all');
      }
      return names.slice(0, this.maxVisibleSections).join(', ');
    },
    getHiddenSectionCount: function getHiddenSectionCount(row) {
      var names = this.getRowSectionNames(row);
      if (names.length <= this.maxVisibleSections) {
        return 0;
      }
      return names.length - this.maxVisibleSections;
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/kds', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    handleDelete: function handleDelete(item) {
      var _this2 = this;

      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        text: this.$t('kds.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            id: item,
            token: _this2.$session.get('token'),
            company_id: _this2.$session.get('selectedCompany')
          };
          _this2.apiRequest('/kds/' + item, 'DELETE', data, function (response) {
            if (response.status === true) {
              _this2.trackAdminEvent('ADMIN_KDS_DELETED', 'kds', item, {
                kds_id: item
              });
              __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('', _this2.$t('general.success'), 'success');
              _this2.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : _this2.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function (err) {
        if (err) {}
      });
      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.disableConfirmButton();
      var yes = this.$t('general.yes');
      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          if (__WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.getConfirmButton().textContent = yes + ' (' + btnCounter + ')';
          }
        } else {
          if (__WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.getConfirmButton().textContent = yes;
          }
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    }
  }
});

/***/ }),

/***/ "3wCJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      saving: false,
      tableData: [],

      pagination: {
        page: 1,
        perPage: 20,
        totalPages: 0,
        totalRecords: 0
      },

      form: {
        type: null,
        value: null,
        expiration_time: null,
        total_number: null
      }
    };
  },
  created: function created() {
    this.fetchData();
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },


  methods: {
    handleRefresh: function handleRefresh() {
      this.fetchData();
    },
    fetchData: function fetchData() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.loading = true;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: page
      };

      this.apiRequest('/gift-cards', 'GET', data, function (response) {
        if (response.status) {
          _this.tableData = response.data.data;

          _this.pagination.page = response.data.current_page;
          _this.pagination.perPage = response.data.per_page;
          _this.pagination.totalPages = response.data.last_page;
          _this.pagination.totalRecords = response.data.total;
        }

        _this.loading = false;
      });
    },
    handlePageChange: function handlePageChange(page) {
      this.fetchData(page);
    },
    openAddModal: function openAddModal() {
      this.form = {
        type: null,
        value: null,
        expiration_time: null,
        total_number: null
      };

      this.$modal.show('addModal');
    },
    submitForm: function submitForm() {
      var _this2 = this;

      if (this.form.expiration_time && Number(this.form.expiration_time) > 700) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: this.$t('giftCard.errorTitle'),
          text: this.$t('giftCard.errorExpirationTimeMax'),
          icon: 'error',
          confirmButtonText: this.$t('giftCard.ok')
        });
        return;
      }

      if (this.form.total_number && Number(this.form.total_number) > 10000) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: this.$t('giftCard.errorTitle'),
          text: this.$t('giftCard.errorTotalNumberMax'),
          icon: 'error',
          confirmButtonText: this.$t('giftCard.ok')
        });
        return;
      }

      if (!this.form.type || !this.form.value) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: this.$t('giftCard.errorTitle'),
          text: this.$t('giftCard.errorRequired'),
          icon: 'error',
          confirmButtonText: this.$t('giftCard.ok')
        });
        return;
      }

      if (this.form.type === 2 && !this.form.total_number) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: this.$t('giftCard.errorTitle'),
          text: this.$t('giftCard.errorOffline'),
          icon: 'error',
          confirmButtonText: this.$t('giftCard.ok')
        });
        return;
      }

      this.saving = true;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        type: this.form.type,
        value: this.form.value,
        expiration_time: this.form.expiration_time,
        total_number: this.form.total_number
      };

      this.apiRequest('/gift-cards', 'POST', data, function (response) {
        _this2.saving = false;

        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            title: _this2.$t('giftCard.successTitle'),
            text: _this2.$t('giftCard.successMessage'),
            icon: 'success',
            confirmButtonText: _this2.$t('giftCard.ok')
          }).then(function () {
            _this2.$modal.hide('addModal');
            _this2.fetchData();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            title: _this2.$t('giftCard.errorTitle'),
            text: _this2.$t('giftCard.errorCreate'),
            icon: 'error',
            confirmButtonText: _this2.$t('giftCard.ok')
          });
        }
      });
    },
    goToDetails: function goToDetails(row) {
      this.$router.push({
        path: '/gift-cards/' + row.id
      });
    }
  }
});

/***/ }),

/***/ "3xT/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row orders-view"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-xs-12 noprint"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"fixed"},[_c('div',{ref:"tableTop",staticClass:"table-top",staticStyle:{"flex-shrink":"0"}},[_c('el-row',[_c('el-col',[_c('div',{staticClass:"search-filter-row"},[_c('el-input',{staticClass:"sm-search icon-search",staticStyle:{"flex":"1","min-width":"0"},attrs:{"placeholder":_vm.$t('general.search')},on:{"input":_vm.search},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('el-button',{staticClass:"filter-btn",staticStyle:{"width":"15%","margin-bottom":"12px","flex-shrink":"0"},attrs:{"type":"default"},on:{"click":_vm.openFiltersModal}},[_c('img',{attrs:{"src":"/static/img/icons/filter.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"pad-to-10 text-bold-500 filters-content",staticStyle:{"font-size":"13px","margin-top":"0","padding-top":"0"}},[(_vm.hasActiveFilters)?[_c('div',{staticClass:"filters-header",on:{"click":_vm.toggleFiltersCollapse}},[_c('button',{staticClass:"collapse-toggle-btn",attrs:{"type":"button"}},[_c('i',{class:_vm.showFiltersCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('orders.filtersApplied'))+":")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showFiltersCollapsed),expression:"!showFiltersCollapsed"}],staticClass:"filters-list"},[_vm._l((_vm.requestFilters[0].value),function(sts,key){return _c('span',{key:'status-filter-' + sts + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                      "+_vm._s(_vm.formatLabelFirstLetter('ordersStatus.' + sts))),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeStatusFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}),_vm._v(" "),(_vm.showLocations)?_vm._l((_vm.locationFilter),function(locId,key){return _c('span',{key:'location-filter-' + locId + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                        "+_vm._s(_vm.getLocationName(locId))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeLocationFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e(),_vm._v(" "),(_vm.orderFilters.preorders !== 'all')?_c('span',{staticClass:"filter-selection"},[_vm._v("\n                      "+_vm._s(_vm.$t(_vm.orderFilters.preorders === '1' ? 'orders.pendingPreorders' : 'orders.withoutPendingPreorders'))+"\n                      "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removePreordersFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])]):_vm._e(),_vm._v(" "),(_vm.orderFilters.pickupDatetime && _vm.orderFilters.pickupDatetime.length === 2)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Pickup: "+_vm._s(_vm.formatDateRange(_vm.orderFilters.pickupDatetime))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removePickupDatetimeFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.placedDatetime && _vm.orderFilters.placedDatetime.length === 2)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Placed: "+_vm._s(_vm.formatDateRange(_vm.orderFilters.placedDatetime))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removePlacedDatetimeFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.orderId)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Order ID: "+_vm._s(_vm.orderFilters.orderId)+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOrderIdFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.orderNumber)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Order #: "+_vm._s(_vm.orderFilters.orderNumber)+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOrderNumberFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.orderTotalMin || _vm.orderFilters.orderTotalMax)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Total: "+_vm._s(_vm.orderFilters.orderTotalMin || '0')+" - "+_vm._s(_vm.orderFilters.orderTotalMax || '∞')+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOrderTotalFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.operator && _vm.orderFilters.operator.length > 0)?_vm._l((_vm.orderFilters.operator),function(opId,key){return _c('span',{key:'operator-filter-' + opId + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                        Operator: "+_vm._s(_vm.getOperatorName(opId))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOperatorFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e(),_vm._v(" "),(_vm.orderFilters.paymentType && _vm.orderFilters.paymentType.length > 0)?_vm._l((_vm.orderFilters.paymentType),function(pt,key){return _c('span',{key:'payment-type-filter-' + pt + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                        Payment: "+_vm._s(_vm.formatLabelFirstLetter('paymentTypes.' + pt))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removePaymentTypeFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e(),_vm._v(" "),(_vm.orderFilters.deliveryType && _vm.orderFilters.deliveryType.length > 0)?_vm._l((_vm.orderFilters.deliveryType),function(dt,key){return _c('span',{key:'delivery-type-filter-' + dt + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                        "+_vm._s(_vm.$t('settingCompany.deliveryType'))+": "+_vm._s(_vm.formatLabelFirstLetter('deliveryTypes.' + dt))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeDeliveryTypeFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e(),_vm._v(" "),(_vm.orderFilters.source && _vm.orderFilters.source.length > 0)?_vm._l((_vm.orderFilters.source),function(src,key){return _c('span',{key:'source-filter-' + src + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                        Source: "+_vm._s(_vm.formatLabelFirstLetter('ordersSource.' + src))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeSourceFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e()],2),_vm._v(" "),_c('a',{staticClass:"reset-filters-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.resetFilters()}}},[_vm._v(_vm._s(_vm.$t('orders.resetFilters')))])]:[_vm._v("\n                  "+_vm._s(_vm.$t('orders.noFiltersApplied'))+"\n                ")]],2)])],1)],1),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('div',{ref:"tableContainerRef",staticClass:"table-container",staticStyle:{"flex":"1","overflow-y":"auto","min-height":"0"}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"row-class-name":_vm.rowClass},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"label":"ID / Nr.","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticStyle:{"line-height":"1.2"}},[_c('div',[_c('b',[_vm._v("#"+_vm._s(props.row.id))])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px","margin-top":"10px","color":"#7C8DB5"}},[(props.row.series)?[_vm._v("\n                            "+_vm._s(props.row.series)+" -\n                          ")]:_vm._e(),_vm._v("\n                          "+_vm._s((parseInt(props.row.number) === 0) ? '@' : parseInt(props.row.number))+"\n                        ")],2)])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.data'),"width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                      "+_vm._s(_vm.formatDateTime(props.row.created_at))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Labels","min-width":"70","width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.user_labeling)?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.convertLabelingJsonToHtml(props.row.user_labeling))}})]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.customer'),"min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{domProps:{"innerHTML":_vm._s(props.row.customer_display)}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.location'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                      "+_vm._s(props.row.production_details && props.row.production_details.location ? props.row.production_details.location.name : '')+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('orders.type'),"min-width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.company_id === 31 && props.row.delivery_type === 'MEET_HALF')?[_vm._v("\n                        Due Drive\n                      ")]:(props.row.company_id === 46 && props.row.delivery_type === 'MEET_HALF')?[_vm._v("\n                        Yumm Drive\n                      ")]:[_vm._v("\n                        "+_vm._s(props.row.delivery_type ? _vm.$t('deliveryTypes.' + props.row.delivery_type) : '')+"\n                      ")]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('orders.pickupTime'),"min-width":"170","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"box",staticStyle:{"display":"flex","flex-direction":"column"}},[(props.row.delivery_type !== 'EAT_LOCATION' && props.row.just_date !== 1)?_c('span',[_vm._v("\n                          "+_vm._s(_vm.$t('orders.at'))+" "+_vm._s(_vm._f("formatTime")(props.row.pickup_datetime))+"\n                        ")]):(props.row.delivery_type !== 'EAT_LOCATION' && props.row.just_date === 1)?_c('span',[_vm._v("\n                          "+_vm._s(_vm.$t('orders.at'))+" "+_vm._s(_vm.formatDate(props.row.pickup_datetime))+"\n                        ")]):_vm._e(),_vm._v(" "),(props.row.delivery_moment)?_c('div',[_c('span',{staticClass:"text-color-red",staticStyle:{"display":"inline-block"}},[_vm._v("\n                            "+_vm._s(props.row.delivery_moment)+"\n                          ")])]):_vm._e(),_vm._v(" "),(_vm.isPreorder(props.row))?_c('div',[_c('span',{staticClass:"text-color-red",staticStyle:{"display":"inline-block"}},[_vm._v("\n                            "+_vm._s(_vm.$t('orders.preorder'))+"\n                          ")])]):_vm._e()])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Status","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"label",class:'label-' + _vm.orderStatusClass(props.row.status.id)},[_vm._v("\n                        "+_vm._s(_vm.changeDeliveryStatus(props.row.status.id, props.row.delivery_type))+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('orders.courier'),"min-width":"180","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.getCourierDeliveryLabel(props.row))?_c('span',{staticClass:"label",class:'label-' + _vm.getCourierDeliveryLabelClass(props.row)},[_vm._v("\n                        "+_vm._s(_vm.getCourierDeliveryLabel(props.row))+"\n                      ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Total","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.totals_grandtotal)+" "+_vm._s(_vm.getCurrencySymbol(props.row.currency)))])]}}])})],1)],1),_vm._v(" "),_c('el-pagination',{staticClass:"active-pagination",attrs:{"total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"pager-count":_vm.pagerCount,"current-page":_vm.paginationDef.page,"layout":"prev, pager, next, total"},on:{"current-change":_vm.handlePageChange}})],1)])])])])]),_vm._v(" "),(_vm.showForm())?_c('order-form',{ref:"orderForm",attrs:{"showLocations":_vm.showLocations,"callback":_vm.updateList,"route":_vm.route}}):_vm._e(),_vm._v(" "),_c('vmodal',{staticClass:"filtersAndSortModal",attrs:{"name":"filtersAndSortModal","height":"auto","width":"1200"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header slim-header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('orders.filtersAndSort')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body slim-body"},[_c('div',{staticClass:"filters-grid"},[_c('div',{staticClass:"modal-column-left"},[_c('h6',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('orders.filters')))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.status')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons"},_vm._l((_vm.filteredStatuses),function(key){return _c('button',{key:key,class:'btn btn-status-filter ' + (_vm.modalRequestFilters[0].value.includes(key) ? 'btn-' + _vm.orderStatusClass(key) + ' current ' + key : 'btn-default'),on:{"click":function($event){_vm.toggleModalStatusFilter(key)}}},[_vm._v("\n                    "+_vm._s(_vm.formatLabelFirstLetter('ordersStatus.' + key))+"\n                  ")])}))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.preorderFilter')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.modalOrderFilters.preorders),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "preorders", $$v)},expression:"modalOrderFilters.preorders"}},[_c('el-option',{attrs:{"label":_vm.$t('orders.allOrders'),"value":"all"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('orders.pendingPreorders'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('orders.withoutPendingPreorders'),"value":"0"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingCompany.deliveryType')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons delivery-type-buttons"},_vm._l((_vm.deliveryTypeOptions),function(dt){return _c('button',{key:dt,class:'btn btn-status-filter ' + (_vm.modalOrderFilters.deliveryType && _vm.modalOrderFilters.deliveryType.includes(dt) ? 'btn-primary current ' + dt : 'btn-default'),on:{"click":function($event){_vm.toggleModalDeliveryTypeFilter(dt)}}},[_vm._v("\n                    "+_vm._s(_vm.formatLabelFirstLetter('deliveryTypes.' + dt))+"\n                  ")])}))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.source')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons source-filter-buttons"},_vm._l((_vm.sourceOptions),function(src){return _c('button',{key:src,class:'btn btn-status-filter ' + (_vm.modalOrderFilters.source && _vm.modalOrderFilters.source.includes(src) ? 'btn-primary current ' + src : 'btn-default'),on:{"click":function($event){_vm.toggleModalSourceFilter(src)}}},[_vm._v("\n                    "+_vm._s(_vm.formatLabelFirstLetter('ordersSource.' + src))+"\n                  ")])}))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.payment')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons payment-type-buttons"},_vm._l((_vm.paymentTypeOptions),function(pt){return _c('button',{key:pt,class:'btn btn-status-filter ' + (_vm.modalOrderFilters.paymentType && _vm.modalOrderFilters.paymentType.includes(pt) ? 'btn-primary current ' + pt : 'btn-default'),on:{"click":function($event){_vm.toggleModalPaymentTypeFilter(pt)}}},[_vm._v("\n                    "+_vm._s(_vm.formatLabelFirstLetter('paymentTypes.' + pt))+"\n                  ")])}))])]),_vm._v(" "),_c('div',{staticClass:"modal-column-right"},[_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.pickupDatetime')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","placeholder":_vm.$t('orders.selectDateRange')},on:{"change":function($event){_vm.adjustDatetimeRange('pickupDatetime')}},model:{value:(_vm.modalOrderFilters.pickupDatetime),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "pickupDatetime", $$v)},expression:"modalOrderFilters.pickupDatetime"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.placedDatetime')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","placeholder":_vm.$t('orders.selectDateRange')},on:{"change":function($event){_vm.adjustDatetimeRange('placedDatetime')}},model:{value:(_vm.modalOrderFilters.placedDatetime),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "placedDatetime", $$v)},expression:"modalOrderFilters.placedDatetime"}})],1),_vm._v(" "),(_vm.showLocations)?[_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"multiple":"","clearable":"","filterable":"","collapse-tags":"","placeholder":_vm.$t('orders.location')},model:{value:(_vm.modalLocationFilter),callback:function ($$v) {_vm.modalLocationFilter=$$v},expression:"modalLocationFilter"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:'modal-location-' + loc.id,attrs:{"label":loc.name,"value":loc.true_id}})}))],1)]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.orderId')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('orders.enterOrderId')},model:{value:(_vm.modalOrderFilters.orderId),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderId", $$v)},expression:"modalOrderFilters.orderId"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.orderNumber')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('orders.enterOrderNumber')},model:{value:(_vm.modalOrderFilters.orderNumber),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderNumber", $$v)},expression:"modalOrderFilters.orderNumber"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.operator')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"multiple":"","clearable":"","filterable":"","collapse-tags":"","placeholder":_vm.$t('reports.operator')},model:{value:(_vm.modalOrderFilters.operator),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "operator", $$v)},expression:"modalOrderFilters.operator"}},_vm._l((_vm.operatorOptions),function(op){return _c('el-option',{key:'op-' + op.id,attrs:{"label":op.label,"value":op.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.orderTotal')))]),_vm._v(" "),_c('div',{staticClass:"range-row"},[_c('el-input-number',{staticStyle:{"flex":"1","line-height":"44px"},attrs:{"placeholder":_vm.$t('orders.min'),"precision":2,"controls":false},model:{value:(_vm.modalOrderFilters.orderTotalMin),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderTotalMin", $$v)},expression:"modalOrderFilters.orderTotalMin"}}),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"flex":"1","line-height":"44px"},attrs:{"placeholder":_vm.$t('orders.max'),"precision":2,"controls":false},model:{value:(_vm.modalOrderFilters.orderTotalMax),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderTotalMax", $$v)},expression:"modalOrderFilters.orderTotalMax"}})],1)]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('general.sortOrder')))]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.modalSortOrder),callback:function ($$v) {_vm.modalSortOrder=$$v},expression:"modalSortOrder"}},_vm._l((_vm.sortOptions),function(sort){return _c('el-radio',{key:'sort-' + sort.id,staticStyle:{"display":"block","margin-bottom":"10px"},attrs:{"label":sort.id}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.sort' + sort.name))+"\n                  ")])}))],1)],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer slim-footer"},[_c('el-button',{attrs:{"type":"default","size":"small"},on:{"click":_vm.resetModalFilters}},[_vm._v(_vm._s(_vm.$t('general.reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.applyFilters}},[_vm._v(_vm._s(_vm.$t('general.apply')))])],1)])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3z7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isIntegrationFieldEmpty */
/* harmony export (immutable) */ __webpack_exports__["a"] = hasIntegrationFieldError;
/* harmony export (immutable) */ __webpack_exports__["b"] = getIntegrationFieldErrorMessage;
function isIntegrationFieldEmpty(field, value) {
  if (field === 'location_id' || field === 'orders_location_id') {
    return value === null || value === undefined || value === '';
  }
  return value === null || value === undefined || String(value).trim() === '';
}

function hasIntegrationFieldError(_ref) {
  var field = _ref.field,
      validationErrors = _ref.validationErrors,
      showFieldValidation = _ref.showFieldValidation,
      requiredFields = _ref.requiredFields,
      formData = _ref.formData;

  if (validationErrors && validationErrors[field]) return true;
  if (!showFieldValidation) return false;
  if (!(requiredFields || []).includes(field)) return false;
  return isIntegrationFieldEmpty(field, formData ? formData[field] : undefined);
}

function getIntegrationFieldErrorMessage(_ref2) {
  var field = _ref2.field,
      validationErrors = _ref2.validationErrors,
      showFieldValidation = _ref2.showFieldValidation,
      requiredFields = _ref2.requiredFields,
      formData = _ref2.formData,
      requiredMessage = _ref2.requiredMessage;

  if (validationErrors && validationErrors[field]) {
    return validationErrors[field];
  }
  if (hasIntegrationFieldError({
    field: field,
    validationErrors: validationErrors,
    showFieldValidation: showFieldValidation,
    requiredFields: requiredFields,
    formData: formData
  })) {
    return requiredMessage;
  }
  return '';
}

/***/ }),

/***/ "4+xT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "41va":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersForm_vue__ = __webpack_require__("9S8B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ebda288_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersForm_vue__ = __webpack_require__("TC4q");
function injectStyle (ssrContext) {
  __webpack_require__("Pcd2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ebda288_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "428f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderPosClientScreen_vue__ = __webpack_require__("chgN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d5674c5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderPosClientScreen_vue__ = __webpack_require__("uK/2");
function injectStyle (ssrContext) {
  __webpack_require__("1CET")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d5674c5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderPosClientScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d5674c5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderPosClientScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "48Il":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");










/* harmony default export */ __webpack_exports__["a"] = ({
  components: { GeneralTopBar: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */] },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    activeRoute: function activeRoute() {
      return this.route && this.route.params ? this.route : this.$route;
    }
  },
  data: function data() {
    var _this = this;

    return {
      loading: false,
      items: [],
      expandedRowKeys: [],
      modifiedProductsById: {},
      modifiedOptionsByKey: {},
      validationTriggered: false,
      rowsReady: false,
      tableKey: 0,
      categoryAdministrationByKey: {},
      logs: [],
      timezone: null,
      administrations: [],
      integration: null,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        defaultSort: {
          prop: 'name',
          order: 'ascending'
        },
        rowKey: 'id',
        expandRowKeys: [],
        rowClassName: function rowClassName(_ref) {
          var row = _ref.row;

          if (!_this.rowsReady) return '';
          var hasOptions = row && Array.isArray(row.options) && row.options.length > 0;
          return hasOptions ? '' : 'no-expand';
        }
      }
    };
  },
  created: function created() {
    this.timezone = (this.$session.get('selectedCompanyData') || {}).timezone || 'Europe/Bucharest';
    this.fetchItems();
    this.initAdministrations();
  },

  methods: {
    goBackToReport: function goBackToReport() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    isCategoryAdminInvalid: function isCategoryAdminInvalid(row) {
      if (!this.validationTriggered) return false;
      var key = this.getCategoryKey(row);
      var val = this.categoryAdministrationByKey[key];
      return val === undefined || val === null || val === '';
    },
    isPosIdMissing: function isPosIdMissing(value) {
      if (value === undefined || value === null) return true;
      if (typeof value === 'string') return value.trim() === '';
      return false;
    },
    isProductPosIdMissing: function isProductPosIdMissing(row) {
      return !row || this.isPosIdMissing(row.c_pos_id);
    },
    isOptionPosIdMissing: function isOptionPosIdMissing(option) {
      return !option || this.isPosIdMissing(option.cov_pos_id);
    },
    initAdministrations: function initAdministrations() {
      var _this2 = this;

      var sessionData = this.$session.get('selectedCompanyData') || {};
      if (sessionData['administrations']) {
        this.administrations = sessionData['administrations'];
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/administration', 'GET', data, function (response) {
        if (response && response.status && Array.isArray(response.data)) {
          _this2.administrations = response.data;
          sessionData['administrations'] = response.data;
          _this2.$session.set('selectedCompanyData', sessionData);
        } else {
          _this2.administrations = [];
        }
      });
    },
    fetchItems: function fetchItems() {
      var _this3 = this;

      var orderId = this.activeRoute.params.orderId;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.loading = true;
      this.apiRequest('/reports/v2/charisma/items/' + orderId, 'GET', data, function (response) {
        if (response && response.status) {
          if (response.data && Array.isArray(response.data.products)) {
            _this3.items = response.data.products;
          } else if (Array.isArray(response.data)) {
            _this3.items = response.data;
          } else {
            _this3.items = response.data.products || [];
          }

          _this3.logs = _this3.extractLogsFromResponse(response.data);

          if (response.data && response.data.integration) {
            _this3.integration = response.data.integration;
          } else {
            _this3.integration = null;
          }

          _this3.expandedRowKeys = (_this3.items || []).filter(function (p) {
            return p && Array.isArray(p.options) && p.options.length > 0;
          }).map(function (p) {
            return p.id;
          });
          _this3.tableOptions.expandRowKeys = _this3.expandedRowKeys;(_this3.items || []).forEach(function (p) {
            var key = _this3.getCategoryKey(p);
            if (key === undefined || key === null) return;
            var inferred = p.administration_id || null;
            if (inferred !== undefined && inferred !== null) {
              _this3.$set(_this3.categoryAdministrationByKey, key, inferred);
            }
          });
        } else {
          _this3.items = [];
          _this3.logs = [];
          _this3.integration = null;
        }
        _this3.$nextTick(function () {
          _this3.rowsReady = true;
          _this3.loading = false;
          _this3.tableKey = Date.now();
        });
      });
    },
    getCategoryKey: function getCategoryKey(row) {
      if (!row) return undefined;

      return row.category_id || row.categoryId || row.category || row.category_name || row.categoryName;
    },
    onCategoryAdminChange: function onCategoryAdminChange(row, value) {
      var _this4 = this;

      var key = this.getCategoryKey(row);
      if (key === undefined || key === null) return;
      this.$set(this.categoryAdministrationByKey, key, value);(this.items || []).forEach(function (p) {
        if (_this4.getCategoryKey(p) === key) {
          _this4.$set(p, '_category_admin', value);

          var categoryId = p.category_id || p.categoryId || row.category_id || row.categoryId || null;
          var updated = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this4.modifiedProductsById[p.id] || {}, {
            id: p.id,
            category_id: categoryId,
            administration_id: value
          });
          _this4.$set(_this4.modifiedProductsById, p.id, updated);
        }
      });
    },
    extractLogsFromResponse: function extractLogsFromResponse(data) {
      if (!data) return [];
      if (Array.isArray(data.all_logs)) return data.all_logs;
      return [];
    },
    getLogActionLabel: function getLogActionLabel(action) {
      if (action === undefined || action === null || action === '') return '-';
      var i18nKey = 'charisma.logAction.' + action;
      var translated = this.$t(i18nKey);
      if (translated !== i18nKey) return translated;
      var known = {
        bill: 'charisma.bill',
        invoice: 'charisma.invoice',
        proform: 'charisma.bill',
        proforma: 'charisma.bill'
      };
      var normalized = String(action).toLowerCase();
      if (known[normalized]) return this.$t(known[normalized]);
      return String(action);
    },
    getLogAdministrationName: function getLogAdministrationName(log) {
      if (!log) return '-';
      if (log.administration && log.administration.name) return log.administration.name;
      if (log.administration_name) return log.administration_name;
      var adminId = log.administration_id != null ? log.administration_id : log.administration && log.administration.id;
      if (adminId != null) {
        var found = (this.administrations || []).find(function (a) {
          return a && Number(a.id) === Number(adminId);
        });
        if (found && found.name) return found.name;
      }
      return '-';
    },
    getLogPropertyValue: function getLogPropertyValue(properties, propertyCode) {
      if (!Array.isArray(properties)) return null;
      var prop = properties.find(function (p) {
        if (!p) return false;
        var code = p.propertyCode || p.PropertyCode;
        return code === propertyCode;
      });
      if (!prop) return null;
      var value = prop.propertyValue != null ? prop.propertyValue : prop.PropertyValue;
      return value != null && value !== '' ? value : null;
    },
    getLogRvcFromDataTo: function getLogRvcFromDataTo(dataTo) {
      var parsed = this.parseLogPayload(dataTo);
      if (!parsed || parsed._raw) return '-';
      var document = parsed.document || parsed.Document;
      if (!document) return '-';
      var details = document.documentDetail || document.DocumentDetail;
      if (!Array.isArray(details) || !details.length) return '-';
      var firstDetail = details[0];
      var properties = firstDetail.documentDetailProperty || firstDetail.DocumentDetailProperty;
      var rvc = this.getLogPropertyValue(properties, 'RVC');
      return rvc != null ? String(rvc) : '-';
    },
    escapeHtml: function escapeHtml(value) {
      return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    openLogModal: function openLogModal(row, field) {
      if (!row || !this.hasLogPayload(row[field])) return;
      var title = field === 'data_from' ? this.$t('charisma.resultCharisma') : this.$t('charisma.document');
      var content = this.prettyJson(row[field]);
      var html = '<div class="charisma-log-swal__scroll">' + '<pre class="charisma-log-swal__pre">' + this.escapeHtml(content) + '</pre>' + '</div>';
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: title,
        html: html,
        width: '1200px',
        confirmButtonText: 'OK',
        customClass: 'wolt-drive-events-swal'
      });
    },
    isCharismaAlreadySent: function isCharismaAlreadySent(type) {
      if (!this.integration) return false;
      var proformaStatus = Number(this.integration.charisma_status);
      var invoiceStatus = Number(this.integration.charisma_invoice_status);
      if (type === 1) return proformaStatus === 3;
      if (type === 2) return invoiceStatus === 3;
      return proformaStatus === 3 || invoiceStatus === 3;
    },
    confirmResendIfNeeded: function confirmResendIfNeeded(type, onConfirm) {
      if (!this.isCharismaAlreadySent(type)) {
        onConfirm();
        return;
      }
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
        title: '',
        text: this.$t('charisma.resendConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        if (result) onConfirm();
      });
    },
    prettyJson: function prettyJson(val) {
      if (val === undefined || val === null || val === '') return '';
      try {
        var parsed = typeof val === 'string' ? JSON.parse(val) : val;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(parsed, null, 2);
      } catch (e) {
        return typeof val === 'string' ? val : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(val);
      }
    },
    parseLogPayload: function parseLogPayload(val) {
      if (val === undefined || val === null || val === '') return null;
      if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === 'object') return val;
      try {
        return JSON.parse(val);
      } catch (e) {
        return { _raw: String(val) };
      }
    },
    hasLogPayload: function hasLogPayload(val) {
      if (val === undefined || val === null) return false;
      if (Array.isArray(val)) return val.length > 0;
      if (typeof val === 'string') {
        var trimmed = val.trim();
        if (!trimmed || trimmed === '[]' || trimmed === '{}') return false;
        try {
          var parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) return parsed.length > 0;
          if (parsed && (typeof parsed === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(parsed)) === 'object') return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(parsed).length > 0;
          return !!parsed;
        } catch (e) {
          return true;
        }
      }
      if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === 'object') return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(val).length > 0;
      return true;
    },
    getCharismaErrorId: function getCharismaErrorId(parsed) {
      if (!parsed || parsed._raw) return null;
      if (parsed.errorId != null) return parsed.errorId;
      if (parsed.ErrorId != null) return parsed.ErrorId;
      return null;
    },
    hasCharismaBusinessError: function hasCharismaBusinessError(parsed) {
      var errorId = this.getCharismaErrorId(parsed);
      if (errorId === undefined || errorId === null || errorId === '') return false;
      return Number(errorId) !== 0;
    },
    getLogErrorsArray: function getLogErrorsArray(parsed) {
      if (!parsed || parsed._raw) return [];
      var errors = parsed.errors || parsed.Errors;
      return Array.isArray(errors) ? errors : [];
    },
    getLogErrorText: function getLogErrorText(err) {
      if (err == null) return '';
      if (typeof err === 'string') return err;
      return String(err.error || err.Error || err.message || err.Message || '');
    },
    hasDataToMissingPosIdValidationError: function hasDataToMissingPosIdValidationError(dataTo) {
      var _this5 = this;

      var parsed = this.parseLogPayload(dataTo);
      if (!parsed || parsed._raw) return false;
      return this.getLogErrorsArray(parsed).some(function (err) {
        if (!err || (typeof err === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(err)) !== 'object') return false;
        var msg = _this5.getLogErrorText(err);
        if (/do not have pos_id/i.test(msg)) return true;
        if (Array.isArray(err.product_ids) && err.product_ids.length > 0) return true;
        if (Array.isArray(err.company_option_value_ids) && err.company_option_value_ids.length > 0) return true;
        return false;
      });
    },
    hasDataToMissingCategoryAdministrationError: function hasDataToMissingCategoryAdministrationError(dataTo) {
      var _this6 = this;

      var parsed = this.parseLogPayload(dataTo);
      if (!parsed || parsed._raw) return false;
      return this.getLogErrorsArray(parsed).some(function (err) {
        var text = _this6.getLogErrorText(err).toLowerCase();
        return text.includes('categoryadministration') || /getorderjson returned empty for receipt/i.test(text);
      });
    },
    getDataFromAsText: function getDataFromAsText(dataFrom) {
      if (dataFrom === undefined || dataFrom === null) return '';
      if (typeof dataFrom === 'string') return dataFrom;
      var parsed = this.parseLogPayload(dataFrom);
      if (!parsed) return '';
      if (parsed._raw) return parsed._raw;
      if (parsed.message || parsed.Message) return String(parsed.message || parsed.Message);
      return '';
    },
    hasDataFromCurlConnectionError: function hasDataFromCurlConnectionError(dataFrom) {
      var text = this.getDataFromAsText(dataFrom).toLowerCase();
      return text.includes('curl error') || text.includes('libcurl');
    },
    getLogErrorsText: function getLogErrorsText(val) {
      var _this7 = this;

      var parsed = this.parseLogPayload(val);
      if (!parsed || parsed._raw) return '';
      var errors = parsed.errors || parsed.Errors;
      if (typeof errors === 'string') return errors;
      if (Array.isArray(errors)) {
        return errors.map(function (err) {
          return _this7.getLogErrorText(err);
        }).filter(Boolean).join(' ');
      }
      if (errors && (typeof errors === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(errors)) === 'object') {
        return this.getLogErrorText(errors);
      }
      return '';
    },
    hasOrderNotDeliveredError: function hasOrderNotDeliveredError(val) {
      if (val === undefined || val === null || val === '') return false;
      var parts = [];
      if (typeof val === 'string') {
        parts.push(val);
      } else {
        var errorsText = this.getLogErrorsText(val);
        if (errorsText) parts.push(errorsText);
        var parsed = this.parseLogPayload(val);
        if (parsed && parsed._raw) parts.push(parsed._raw);else parts.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(val));
      }
      var text = parts.join(' ').toLowerCase();
      return text.includes('order is not delivered yet') || text.includes('comanda nu a fost livrat');
    },
    normalizeCharismaBusinessDetailMessage: function normalizeCharismaBusinessDetailMessage(detail) {
      if (detail == null) return '';
      var msg = '';
      if (typeof detail === 'string') {
        msg = detail.trim();
      } else {
        msg = String(detail.message || detail.Message || detail.errorMessage || detail.ErrorMessage || detail.detail || detail.Detail || detail.description || detail.Description || '').trim();
      }
      return msg.replace(/^Eroare validare\s*:?\s*/i, '').trim();
    },
    getCharismaBusinessErrorMessages: function getCharismaBusinessErrorMessages(dataFrom) {
      var _this8 = this;

      var parsed = this.parseLogPayload(dataFrom);
      if (!parsed || !this.hasCharismaBusinessError(parsed)) return null;
      var charismaErrorLabel = this.$t('charisma.logVerdictCharismaError');
      var businessErrorLog = parsed.businessErrorLog || parsed.BusinessErrorLog;
      var parts = [];
      if (businessErrorLog) {
        var header = businessErrorLog.errorHeader || businessErrorLog.ErrorHeader;
        if (header) parts.push(String(header).trim());
        var errorDetails = businessErrorLog.errorDetails || businessErrorLog.ErrorDetails;
        if (Array.isArray(errorDetails) && errorDetails.length) {
          errorDetails.forEach(function (detail) {
            var msg = _this8.normalizeCharismaBusinessDetailMessage(detail);
            if (msg) parts.push(msg);
          });
        }
      }
      if (!parts.length) return charismaErrorLabel;
      return charismaErrorLabel + ': ' + parts.join(' ');
    },
    isLogResponseError: function isLogResponseError(dataFrom) {
      var parsed = this.parseLogPayload(dataFrom);
      if (!parsed) return false;
      if (this.hasCharismaBusinessError(parsed)) return true;
      if (parsed._raw) {
        var raw = parsed._raw.toLowerCase();
        return raw.includes('error') || raw.includes('exception') || raw.includes('failed') || raw.includes('fail');
      }
      if (parsed.success === false || parsed.Success === false || parsed.isSuccess === false) return true;
      if (parsed.error || parsed.Error || parsed.errors || parsed.Errors) return true;
      if (parsed.status === 'error' || parsed.Status === 'Error' || parsed.status === 'failed') return true;
      if (parsed.HasError === true || parsed.hasError === true) return true;
      var msg = parsed.Message || parsed.message || '';
      if (typeof msg === 'string' && /error|eroare|failed|fail/i.test(msg)) return true;
      return false;
    },
    isLogResponseSuccess: function isLogResponseSuccess(dataFrom) {
      var parsed = this.parseLogPayload(dataFrom);
      if (!parsed) return false;
      if (this.hasCharismaBusinessError(parsed)) return false;
      if (parsed._raw) return !this.isLogResponseError(dataFrom);
      if (parsed.success === true || parsed.Success === true || parsed.isSuccess === true) return true;
      if (parsed.status === 'ok' || parsed.status === 'success' || parsed.Status === 'Success' || parsed.Status === 'OK') return true;
      if (parsed.HasError === false && this.hasLogPayload(dataFrom)) return true;
      if (!this.isLogResponseError(dataFrom) && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(parsed).length > 0) return true;
      return false;
    },
    getLogVerdict: function getLogVerdict(log) {
      if (!log) return this.$t('charisma.logVerdictNoPayload');
      var hasTo = this.hasLogPayload(log.data_to);
      var hasFrom = this.hasLogPayload(log.data_from);
      if (!hasTo && !hasFrom) return this.$t('charisma.logVerdictNoPayload');
      var charismaErrorMessage = this.getCharismaBusinessErrorMessages(log.data_from);
      if (charismaErrorMessage) return charismaErrorMessage;
      if (this.hasDataToMissingPosIdValidationError(log.data_to)) {
        return this.$t('charisma.logVerdictMissingPosIds');
      }
      if (this.hasDataToMissingCategoryAdministrationError(log.data_to)) {
        return this.$t('charisma.logVerdictMissingCategoryAdministration');
      }
      if (this.hasOrderNotDeliveredError(log.data_from) || this.hasOrderNotDeliveredError(log.data_to)) {
        return this.$t('charisma.logVerdictOrderNotDelivered');
      }
      if (hasTo && !hasFrom) return this.$t('charisma.logVerdictAwaitingResponse');
      if (this.hasDataFromCurlConnectionError(log.data_from)) {
        return this.$t('charisma.logVerdictConnectionError');
      }
      if (this.isLogResponseError(log.data_from)) return this.$t('charisma.logVerdictError');
      if (this.isLogResponseSuccess(log.data_from)) return this.$t('charisma.logVerdictSuccess');
      return this.$t('charisma.logVerdictUnknown');
    },
    mergeLogsFromSaveResponse: function mergeLogsFromSaveResponse(data) {
      var extracted = this.extractLogsFromResponse(data);
      if (extracted.length) {
        this.logs = extracted;
      }
    },
    markProductModified: function markProductModified(product) {
      if (!product || !product.id) return;
      this.$set(this.modifiedProductsById, product.id, {
        id: product.c_id,
        c_pos_id: product.c_pos_id,
        c_external_id: product.c_external_id
      });
    },
    markOptionModified: function markOptionModified(product, option) {
      if (!product || !product.id || !option || !option.id) return;
      var key = product.id + ':' + option.id;
      this.$set(this.modifiedOptionsByKey, key, {
        product_id: product.id,
        id: option.cov_id,
        pos_id: option.cov_pos_id
      });
    },
    saveDetailsAndSendOrder: function saveDetailsAndSendOrder(type) {
      var _this9 = this;

      if (this.loading) {
        return;
      }

      this.validationTriggered = true;

      var hasInvalidCategory = (this.items || []).some(function (p) {
        return _this9.isCategoryAdminInvalid(p);
      });
      var hasInvalidProductId = (this.items || []).some(function (p) {
        return _this9.isProductPosIdMissing(p);
      });
      var hasInvalidOption = (this.items || []).some(function (p) {
        return (p.options || []).some(function (o) {
          return _this9.isOptionPosIdMissing(o);
        });
      });
      if (hasInvalidCategory || hasInvalidProductId || hasInvalidOption) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('', this.$t('general.fillRequiredFields'), 'error');
        return;
      }
      this.confirmResendIfNeeded(type, function () {
        _this9.executeSaveDetailsAndSendOrder(type);
      });
    },
    executeSaveDetailsAndSendOrder: function executeSaveDetailsAndSendOrder(type) {
      var _this10 = this;

      var orderId = this.activeRoute.params.orderId;

      var allProducts = (this.items || []).map(function (p) {
        var categoryId = p.category_id || p.categoryId || null;
        var adminId = _this10.categoryAdministrationByKey[_this10.getCategoryKey(p)] || p._category_admin || p.administration_id || null;
        return {
          id: p.id,
          c_pos_id: p.c_pos_id,
          c_external_id: p.c_external_id,
          category_id: categoryId,
          administration_id: adminId
        };
      });
      var allOptions = (this.items || []).reduce(function (acc, p) {
        var opts = (p.options || []).map(function (o) {
          return {
            product_id: p.id,
            id: o.cov_id,
            pos_id: o.cov_pos_id
          };
        });
        acc.push.apply(acc, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(opts));
        return acc;
      }, []);

      var payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: orderId,
        products: allProducts,
        options: allOptions,
        type: type
      };
      this.loading = true;
      this.apiRequest('/reports/v2/charisma/items', 'PUT', payload, function (response) {
        _this10.loading = false;
        if (response && response.status) {
          if (response.data && Array.isArray(response.data.products)) {
            _this10.items = response.data.products;
          } else if (Array.isArray(response.data)) {
            _this10.items = response.data;
          } else {
            _this10.items = response.data.products || [];
          }

          _this10.mergeLogsFromSaveResponse(response.data);

          if (response.data && response.data.integration) {
            _this10.integration = response.data.integration;
          }

          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('', _this10.$t('general.success'), 'success');
          _this10.modifiedProductsById = {};
          _this10.modifiedOptionsByKey = {};
        } else {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this10.$t('general.error'), 'error');
        }
      });
    }
  }
});

/***/ }),

/***/ "4AJd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceTabs_vue__ = __webpack_require__("Mt5O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_175d4f00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceTabs_vue__ = __webpack_require__("8bCh");
function injectStyle (ssrContext) {
  __webpack_require__("IcKo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-175d4f00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_175d4f00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Brd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row products"},[(!_vm.showForm())?_c('div',{staticClass:"col-xl-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{ref:"tableTop",staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-start","gap":"10px","flex-wrap":"wrap","flex-direction":"column"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px","align-items":"flex-end","flex":"1 1 auto"}},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"1 1 200px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.search')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('catalogProd.search'),"size":"small","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 120px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.id')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('catalogProd.id'),"size":"small","clearable":""},model:{value:(_vm.searchId),callback:function ($$v) {_vm.searchId=$$v},expression:"searchId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 120px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.status')))]),_vm._v(" "),_c('v-select',{attrs:{"options":[
                  { id: 'active', type: _vm.$t('general.active') },
                  { id: 'inactive', type: _vm.$t('general.inactive') }
                ],"multiple":"","label":"type","reduce":function (option) { return option.id; },"placeholder":_vm.$t('general.select'),"clearable":""},model:{value:(_vm.filters[3].value),callback:function ($$v) {_vm.$set(_vm.filters[3], "value", $$v)},expression:"filters[3].value"}})],1),_vm._v(" "),(_vm.topCategories.length)?_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 140px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.topCategory')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.topCategories,"multiple":"","label":"name","reduce":function (cat) { return cat.id; },"placeholder":_vm.$t('general.select'),"clearable":""},model:{value:(_vm.filters[5].value),callback:function ($$v) {_vm.$set(_vm.filters[5], "value", $$v)},expression:"filters[5].value"}})],1):_vm._e(),_vm._v(" "),(_vm.mainCategories.length)?_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 140px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.category')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.mainCategories,"multiple":"","label":"name","reduce":function (cat) { return cat.id; },"placeholder":_vm.$t('general.select'),"clearable":""},model:{value:(_vm.filters[1].value),callback:function ($$v) {_vm.$set(_vm.filters[1], "value", $$v)},expression:"filters[1].value"}})],1):_vm._e(),_vm._v(" "),(_vm.locations.length)?_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 140px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.locations,"multiple":"","label":"name","reduce":function (loc) { return loc.id; },"placeholder":_vm.$t('general.select'),"clearable":""},model:{value:(_vm.filters[2].value),callback:function ($$v) {_vm.$set(_vm.filters[2], "value", $$v)},expression:"filters[2].value"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 120px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('general.specialPrice')))]),_vm._v(" "),_c('v-select',{attrs:{"options":[
                  { id: 'discounted', type: _vm.$t('general.active') },
                  { id: 'notDiscounted', type: _vm.$t('general.inactive') }
                ],"multiple":"","label":"type","reduce":function (option) { return option.id; },"placeholder":_vm.$t('general.select'),"clearable":""},model:{value:(_vm.filters[4].value),callback:function ($$v) {_vm.$set(_vm.filters[4], "value", $$v)},expression:"filters[4].value"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 210px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.deliveryMethod')))]),_vm._v(" "),_c('v-select',{attrs:{"options":[
                  { id: 'delivery', type: _vm.$t('settingCompany.delivery') },
                  { id: 'eat_location', type: _vm.$t('settingCompany.eat_location') },
                  { id: 'meet_half', type: _vm.$t('settingCompany.meet_half') },
                  { id: 'pick_up', type: _vm.$t('settingCompany.pick_up') },
                  { id: 'self_ordering', type: _vm.$t('settingCompany.self_ordering') }
                ],"multiple":"","label":"type","reduce":function (option) { return option.id; },"placeholder":_vm.$t('general.select'),"clearable":"","close-on-select":false},model:{value:(_vm.filters[6].value),callback:function ($$v) {_vm.$set(_vm.filters[6], "value", $$v)},expression:"filters[6].value"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.applyFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right-group",staticStyle:{"flex":"0 0 auto","margin-bottom":"20px","margin-top":"10px","display":"flex","gap":"8px","flex-wrap":"wrap"}},[_c('button',{staticClass:"btn add",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"disabled":_vm.affectedProductCount <= 0,"title":_vm.$t('catalogProd.massUpdate')},on:{"click":function($event){$event.preventDefault();return _vm.openMassUpdateModal($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('catalogProd.massUpdate'))+"\n              "),(_vm.affectedProductCount > 0)?_c('span',[_vm._v("("+_vm._s(_vm.affectedProductCount)+")")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn add",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('catalogProd.single')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-sm.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProd.single'))+"\n            ")])])]),_vm._v(" "),(!_vm.showForm())?_c('div',{staticClass:"data-table",staticStyle:{"margin-top":"20px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"row-class-name":_vm.rowClass,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.onRowClick}},[_c('el-table-column',{attrs:{"width":"50","class-name":"selection-column","align":"center"},scopedSlots:_vm._u([{key:"header",fn:function(scope){return [_c('input',{staticClass:"product-select-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.headerCheckboxChecked,"indeterminate":_vm.headerCheckboxIndeterminate},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleSelectAll($event)}}})]}},{key:"default",fn:function(scope){return [_c('input',{staticClass:"product-select-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isProductSelected(scope.row.id)},on:{"click":function($event){$event.stopPropagation();_vm.toggleProductSelection(scope.row.id)}}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('catalogProd.id'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('catalogProd.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"active","label":_vm.$t('general.active')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[(scope.row.allowed_location)?_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.checkBanner(scope.$index, scope.row, $event)}},model:{value:(scope.row.active),callback:function ($$v) {_vm.$set(scope.row, "active", $$v)},expression:"scope.row.active"}}):_vm._e()],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"category","label":_vm.$t('catalogProd.category')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price","label":_vm.$t('catalogProd.price')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.showLocations)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(scope.row.price),expression:"scope.row.price"}],staticClass:"form-control",attrs:{"type":"number","disabled":(!scope.row.allowed_location && !scope.row.is_discounted),"readonly":scope.row.is_discounted},domProps:{"value":(scope.row.price)},on:{"click":function($event){$event.stopPropagation();},"focus":function($event){$event.stopPropagation();},"input":function($event){if($event.target.composing){ return; }_vm.$set(scope.row, "price", $event.target.value)}}}):_c('b',[_vm._v("\n                  "+_vm._s(scope.row.price_details ? _vm.decodeHtml(scope.row.price_details.formatted_price) : '')+"\n                ")]),_vm._v(" "),(scope.row.allowed_location && !scope.row.is_discounted)?_c('button',{staticClass:"btn btn-success btn-icon mar-to-5",staticStyle:{"margin-left":"5px","margin-bottom":"2px"},on:{"click":function($event){$event.stopPropagation();_vm.updateName(scope.$index, scope.row, $event)}}},[_c('i',{staticClass:"ti-save"})]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"locations","label":_vm.$t('orders.location')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"locations-scroll-horizontal"},[(scope.row.locations && Object.keys(scope.row.locations).length)?_vm._l((scope.row.locations),function(locName,locKey){return _c('span',{key:locKey,staticClass:"location-item"},[_vm._v("\n                      "+_vm._s(locName)+"\n                    ")])}):_c('span',{staticClass:"location-item"},[_vm._v("\n                    "+_vm._s(_vm.$t('general.all'))+"\n                  ")])],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.goToRecord(scope.row, null, $event)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.edit'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.duplicateProduct(scope.$index, scope.row, $event)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.duplicate'))+"\n                    ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"current-page":_vm.paginationDef.page},on:{"update:currentPage":function($event){_vm.$set(_vm.paginationDef, "page", $event)},"current-change":_vm.handlePageChange}})],1):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.showMassUpdateModal)?_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-dialog mass-update-modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("\n            "+_vm._s(_vm.$t('catalogProd.massUpdate'))+"\n            "),_c('span',{staticClass:"mass-count-badge"},[_vm._v("("+_vm._s(_vm.affectedProductCount)+")")])]),_vm._v(" "),_c('p',{staticClass:"mass-subtitle"},[_vm._v(_vm._s(_vm.$t('catalogProd.massUpdateSubtitle', { count: _vm.affectedProductCount })))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.closeMassUpdateModal}},[_c('i',{staticClass:"ti-close"})])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"mass-action-pills"},_vm._l((_vm.massActionOptions),function(opt){return _c('button',{key:opt.id,staticClass:"mass-action-pill",class:{
                active: _vm.massAction === opt.id,
                danger: opt.id === 'delete',
                queued: _vm.isMassActionQueued(opt.id)
              },attrs:{"type":"button"},on:{"click":function($event){_vm.massAction = opt.id}}},[(_vm.isMassActionQueued(opt.id))?_c('i',{staticClass:"ti-check mass-pill-check"}):_vm._e(),_vm._v("\n              "+_vm._s(opt.label)+"\n            ")])})),_vm._v(" "),(_vm.massAction === 'locations')?_c('div',{key:'panel-locations',staticClass:"mass-action-panel"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{key:'select-locations',staticStyle:{"width":"100%"},attrs:{"multiple":"","collapse-tags":"","filterable":"","clearable":"","placeholder":_vm.$t('general.select')},model:{value:(_vm.bulkLocationTokens),callback:function ($$v) {_vm.bulkLocationTokens=$$v},expression:"bulkLocationTokens"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:'loc-' + (loc.token || loc.id),attrs:{"label":loc.name,"value":loc.token}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.bulkLocationsMode')))]),_vm._v(" "),_c('el-select',{key:'select-locations-mode',staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select')},model:{value:(_vm.bulkLocationMode),callback:function ($$v) {_vm.bulkLocationMode=$$v},expression:"bulkLocationMode"}},_vm._l((_vm.bulkModeOptions),function(opt){return _c('el-option',{key:'loc-mode-' + opt.id,attrs:{"label":opt.label,"value":opt.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-switch',{attrs:{"type":"primary"},model:{value:(_vm.bulkIncludeAllLocations),callback:function ($$v) {_vm.bulkIncludeAllLocations=$$v},expression:"bulkIncludeAllLocations"}}),_vm._v(" "),_c('label',{staticClass:"switch-label"},[_vm._v(_vm._s(_vm.$t('catalogProd.includeAllLocationsProducts')))])],1)]):(_vm.massAction === 'set_active')?_c('div',{key:'panel-set_active',staticClass:"mass-action-panel"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('general.active')))]),_vm._v(" "),_c('el-select',{key:'select-active',staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":_vm.$t('general.select')},on:{"change":_vm.onBulkActiveChange},model:{value:(_vm.bulkActiveValue),callback:function ($$v) {_vm.bulkActiveValue=$$v},expression:"bulkActiveValue"}},[_c('el-option',{attrs:{"label":_vm.$t('general.active'),"value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('general.inactive'),"value":0}})],1)],1)]):(_vm.massAction === 'set_override_delivery')?_c('div',{key:'panel-set_override_delivery',staticClass:"mass-action-panel mass-override-panel"},[_c('div',{staticClass:"form-group product-override-group"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('catalogProd.deliveryMethodsandHours')))])]),_vm._v(" "),_c('div',[_c('p-checkbox',{attrs:{"value":true},on:{"input":_vm.onBulkOverrideDeliveryToggle},model:{value:(_vm.bulkOverrideDeliveryValue),callback:function ($$v) {_vm.bulkOverrideDeliveryValue=$$v},expression:"bulkOverrideDeliveryValue"}},[_vm._v(_vm._s(_vm.$t('catalogProd.overrideSettings')))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('catalogProd.bulkOverrideDeliveryHint')))])],1),_vm._v(" "),(_vm.bulkOverrideDeliveryValue === 1)?_c('div',{staticClass:"bulk-override-schedule"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{key:'select-override-locations',staticStyle:{"width":"100%"},attrs:{"multiple":"","filterable":"","clearable":"","collapse-tags":"","placeholder":_vm.$t('general.all')},model:{value:(_vm.bulkOverrideLocationTokens),callback:function ($$v) {_vm.bulkOverrideLocationTokens=$$v},expression:"bulkOverrideLocationTokens"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:'ov-loc-' + (loc.token || loc.id),attrs:{"label":loc.name,"value":loc.token || loc.id}})})),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('catalogProd.bulkOverrideLocationsHint')))])],1),_vm._v(" "),_vm._l((_vm.bulkOverrideMethodKeys),function(methodKey){return _c('div',{key:'ov-method-' + methodKey,staticClass:"col-md-12 bulk-ov-method"},[_c('h4',[_vm._v("\n                    "+_vm._s(_vm.$t('settingCompany.' + methodKey))+"\n                    "),_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addBulkOverrideInterval(methodKey)}}},[_vm._v("+")])]),_vm._v(" "),_vm._l(((_vm.bulkOverrideDeliveryMap[methodKey] || [])),function(interval,intervalIdx){return [_c('div',{key:'ov-interval-' + methodKey + '-' + intervalIdx,staticClass:"col-md-12"},[_c('p-checkbox',{attrs:{"value":interval.active},model:{value:(interval.active),callback:function ($$v) {_vm.$set(interval, "active", $$v)},expression:"interval.active"}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.active'))+"\n                      ")]),_vm._v("\n\n                      "+_vm._s(_vm.$t('general.from'))+"\n                      "),_c('el-time-select',{staticClass:"in-inline-160",attrs:{"disabled":!interval.active,"placeholder":"Select time","picker-options":_vm.bulkOverridePickerOptions,"popper-class":"bulk-ov-time-popper"},model:{value:(interval.available_from),callback:function ($$v) {_vm.$set(interval, "available_from", $$v)},expression:"interval.available_from"}}),_vm._v("\n\n                      "+_vm._s(_vm.$t('general.to'))+"\n                      "),_c('el-time-select',{staticClass:"in-inline-160",attrs:{"disabled":!interval.active,"placeholder":"Select time","picker-options":_vm.bulkOverridePickerOptions,"popper-class":"bulk-ov-time-popper"},model:{value:(interval.available_to),callback:function ($$v) {_vm.$set(interval, "available_to", $$v)},expression:"interval.available_to"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.removeBulkOverrideInterval(methodKey, intervalIdx)}}},[_vm._v("-")])],1),_vm._v(" "),_c('div',{key:'ov-days-' + methodKey + '-' + intervalIdx,staticClass:"col-md-12 pull-left-first-child",staticStyle:{"flex-wrap":"wrap"}},[_vm._l((_vm.weekDays()),function(d,dayKey){return [_c('p-checkbox',{key:'ov-day-' + methodKey + '-' + intervalIdx + '-' + dayKey,staticClass:"inline-auto mar-rt-5",attrs:{"disabled":!interval.active,"value":d},model:{value:(interval[d.toLowerCase()]),callback:function ($$v) {_vm.$set(interval, d.toLowerCase(), $$v)},expression:"interval[d.toLowerCase()]"}},[_vm._v("\n                          "+_vm._s(_vm.$t('catalogProd.' + d))+"\n                        ")])]})],2),_vm._v(" "),_c('div',{key:'ov-day-err-' + methodKey + '-' + intervalIdx,staticClass:"col-md-12 pull-left-first-child",staticStyle:{"flex-wrap":"wrap"}},[(interval.active &&
                              !interval.monday &&
                              !interval.tuesday &&
                              !interval.wednesday &&
                              !interval.thursday &&
                              !interval.friday &&
                              !interval.saturday &&
                              !interval.sunday)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('validations.chooseDay')))]):_vm._e()])]})],2)})],2):_vm._e()])]):(_vm.massAction === 'adjust_price')?_c('div',{key:'panel-adjust_price',staticClass:"mass-action-panel"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.bulkPriceDirection')))]),_vm._v(" "),_c('el-select',{key:'select-price-direction',staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select')},model:{value:(_vm.bulkPriceDirection),callback:function ($$v) {_vm.bulkPriceDirection=$$v},expression:"bulkPriceDirection"}},_vm._l((_vm.priceDirectionOptions),function(opt){return _c('el-option',{key:'price-dir-' + opt.id,attrs:{"label":opt.label,"value":opt.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.bulkPriceMode')))]),_vm._v(" "),_c('el-select',{key:'select-price-mode',staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select')},model:{value:(_vm.bulkPriceMode),callback:function ($$v) {_vm.bulkPriceMode=$$v},expression:"bulkPriceMode"}},_vm._l((_vm.priceModeOptions),function(opt){return _c('el-option',{key:'price-mode-' + opt.id,attrs:{"label":opt.label,"value":opt.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.bulkPriceAmount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.bulkPriceAmount),expression:"bulkPriceAmount",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01","placeholder":_vm.$t('catalogProd.bulkPriceAmount')},domProps:{"value":(_vm.bulkPriceAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bulkPriceAmount=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('catalogProd.bulkPriceBaseOnlyHint')))])])]):(_vm.massAction === 'option_groups')?_c('div',{key:'panel-option_groups',staticClass:"mass-action-panel"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.groupOption')))]),_vm._v(" "),_c('el-select',{key:'select-option-groups',staticStyle:{"width":"100%"},attrs:{"multiple":"","collapse-tags":"","filterable":"","clearable":"","placeholder":_vm.$t('general.select')},model:{value:(_vm.bulkGroupOptionIds),callback:function ($$v) {_vm.bulkGroupOptionIds=$$v},expression:"bulkGroupOptionIds"}},_vm._l((_vm.groupOptionsList),function(grp){return _c('el-option',{key:'grp-' + grp.id,attrs:{"label":grp.name,"value":grp.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.bulkOptionGroupsMode')))]),_vm._v(" "),_c('el-select',{key:'select-option-groups-mode',staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select')},model:{value:(_vm.bulkOptionGroupsMode),callback:function ($$v) {_vm.bulkOptionGroupsMode=$$v},expression:"bulkOptionGroupsMode"}},_vm._l((_vm.optionGroupsModeOptions),function(opt){return _c('el-option',{key:'grp-mode-' + opt.id,attrs:{"label":opt.label,"value":opt.id}})})),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('catalogProd.bulkOptionGroupsModeHint')))])],1)]):(_vm.massAction === 'set_vat')?_c('div',{key:'panel-set_vat',staticClass:"mass-action-panel"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.vat')))]),_vm._v(" "),_c('el-select',{key:'select-vat',staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":_vm.$t('vat.selectVat')},model:{value:(_vm.bulkVatId),callback:function ($$v) {_vm.bulkVatId=$$v},expression:"bulkVatId"}},_vm._l((_vm.vatSelectOptions),function(vat){return _c('el-option',{key:'vat-' + vat.id,attrs:{"label":vat.label,"value":vat.id}})}))],1)]):(_vm.massAction === 'set_section')?_c('div',{key:'panel-set_section',staticClass:"mass-action-panel"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.section')))]),_vm._v(" "),_c('el-select',{key:'select-section',staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":_vm.$t('general.select')},model:{value:(_vm.bulkSectionId),callback:function ($$v) {_vm.bulkSectionId=$$v},expression:"bulkSectionId"}},_vm._l((_vm.kdsSections),function(section){return _c('el-option',{key:'section-' + section.id,attrs:{"label":section.name,"value":section.id}})}))],1)]):(_vm.massAction === 'delete')?_c('div',{key:'panel-delete',staticClass:"mass-action-panel"},[_c('div',{staticClass:"mass-delete-warning"},[_vm._v("\n              "+_vm._s(_vm.$t('catalogProd.bulkDeleteWarning', { count: _vm.affectedProductCount }))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"14px"}},[_c('label',{staticClass:"checkbox-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bulkDeleteEnabled),expression:"bulkDeleteEnabled"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.bulkDeleteEnabled)?_vm._i(_vm.bulkDeleteEnabled,null)>-1:(_vm.bulkDeleteEnabled)},on:{"change":function($event){var $$a=_vm.bulkDeleteEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.bulkDeleteEnabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.bulkDeleteEnabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.bulkDeleteEnabled=$$c}}}}),_vm._v("\n                "+_vm._s(_vm.$t('catalogProd.bulkDeleteEnableLabel'))+"\n              ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.closeMassUpdateModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.cancel'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"button","disabled":!_vm.massConfirmEnabled || _vm.bulkUpdating},on:{"click":_vm.confirmMassUpdate}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.confirm'))+"\n            ")])])])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Ds/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KioskColorsCard_vue__ = __webpack_require__("XEoW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa7585c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KioskColorsCard_vue__ = __webpack_require__("PBad");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KioskColorsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa7585c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KioskColorsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Ilb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n        "+_vm._s(_vm.$t('general.back'))+"\n      ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){_vm.saveBonConsum()}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.stoc.action.bonConsum')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                    "+_vm._s(loc.name)+"\n                  ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gestiune"}},[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonConsum.gestiune),expression:"bonConsum.gestiune"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.bonConsum, "gestiune", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selectează gestiunea")]),_vm._v(" "),_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('option',{key:gestiune.id,domProps:{"value":gestiune.id}},[_vm._v("\n                  "+_vm._s(gestiune.name)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"serie"}},[_vm._v(_vm._s(_vm.$t('invoice.series'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonConsum.serie),expression:"bonConsum.serie"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.bonConsum, "serie", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.handleSerieChange]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează seria")]),_vm._v(" "),_vm._l((_vm.seriesOptionsWithAdd),function(serie){return _c('option',{key:serie.id,domProps:{"value":serie.id}},[_vm._v("\n                  "+_vm._s(serie.id === 'add' ? serie.name : ((serie.name) + " - " + (serie.currentNumber)))+"\n                ")])}),_vm._v(" "),(_vm.bonConsum.serie && !_vm.seriesOptionsWithAdd.some(function (s) { return s.id === _vm.bonConsum.serie; }))?_c('option',{domProps:{"value":_vm.bonConsum.serie}},[_vm._v("\n                  "+_vm._s(_vm.bonConsum.serie)+"\n                ")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"lot"}},[_vm._v(_vm._s(_vm.$t('gestiune.lot')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introdu lotul","disabled":_vm.isEdit},model:{value:(_vm.bonConsum.lot),callback:function ($$v) {_vm.$set(_vm.bonConsum, "lot", $$v)},expression:"bonConsum.lot"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.data'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonConsum.date),expression:"bonConsum.date"}],staticClass:"form-control",attrs:{"type":"datetime-local","name":"date","max":_vm.today,"disabled":!_vm.selectedLocationId},domProps:{"value":(_vm.bonConsum.date)},on:{"change":function($event){_vm.checkValidatedAfter(_vm.bonConsum.date)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bonConsum, "date", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProductInBonConsum')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.productName'),"prop":"productName"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.productName)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.um'),"prop":"um"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.um)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.cantitateNecesara'),"prop":"cantitateNecesara"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.cantitateNecesara)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.cantitateConsumata'),"prop":"cantitateConsumata"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.cantitateConsumata)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editRow(scope.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.edit'))+"\n                ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.deleteRow(scope.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")])],1)],1)]}}])})],1),_vm._v(" "),_c('button',{staticClass:"btn add mar-rt-10 mar-bt-5 mar-to-15",attrs:{"disabled":!_vm.selectedLocationId,"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.openAddProductModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n        "+_vm._s(_vm.$t('gestiune.addProduct'))+"\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 no-padding"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.stoc.action.bonConsum')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gestionar"}},[_vm._v(_vm._s(_vm.$t('gestiune.manager')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introdu numele gestionarului"},model:{value:(_vm.bonConsum.manager),callback:function ($$v) {_vm.$set(_vm.bonConsum, "manager", $$v)},expression:"bonConsum.manager"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"primitor"}},[_vm._v(_vm._s(_vm.$t('gestiune.receiver')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introdu numele primitorului"},model:{value:(_vm.bonConsum.receiver),callback:function ($$v) {_vm.$set(_vm.bonConsum, "receiver", $$v)},expression:"bonConsum.receiver"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"comandaProiect"}},[_vm._v(_vm._s(_vm.$t('gestiune.commandProject')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Adaugă o comandă/proiect"},model:{value:(_vm.bonConsum.commandProject),callback:function ($$v) {_vm.$set(_vm.bonConsum, "commandProject", $$v)},expression:"bonConsum.commandProject"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"type"}},[_vm._v(_vm._s(_vm.$t('gestiune.type'))+"*")]),_vm._v(" "),_c('el-select',{staticClass:"w-full",attrs:{"placeholder":"Selectează motivul consumului"},model:{value:(_vm.bonConsum.consumptionType),callback:function ($$v) {_vm.$set(_vm.bonConsum, "consumptionType", $$v)},expression:"bonConsum.consumptionType"}},[_c('el-option',{attrs:{"label":"Bon de consum pentru producție","value":"producție"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Bon de consum pentru casare","value":"casare"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Bon de consum pentru testare / training / evenimente","value":"testare"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Bon de consum pentru consum propriu","value":"consum_propriu"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"notaInterna"}},[_vm._v(_vm._s(_vm.$t('gestiune.internalNote')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Adaugă o notă internă","type":"textarea"},model:{value:(_vm.bonConsum.internalNote),callback:function ($$v) {_vm.$set(_vm.bonConsum, "internalNote", $$v)},expression:"bonConsum.internalNote"}})],1)])])])])])]),_vm._v(" "),_c('vmodal',{staticClass:"addProductModal",attrs:{"name":"addProductModal","height":"auto","width":"600"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProduct')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"stock-info mt-2",staticStyle:{"margin-bottom":"10px","padding":"0px 14px"}},[_c('span',{staticClass:"d-block"},[_vm._v("\n                Stoc: "),_c('strong',[_vm._v(_vm._s(_vm.formatNumber(_vm.stockInfo.quantity)))])]),_vm._v(" "),_c('span',{staticClass:"d-block"},[_vm._v("\n                Valoare: "),_c('strong',[_vm._v(_vm._s(_vm.formatNumber(_vm.stockInfo.value)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productName'))+"*")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.searchResults,"label":"label","reduce":function (option) { return option.value; },"placeholder":"Caută un produs...","filterable":false},on:{"search":_vm.fetchProducts,"input":_vm.handleProductSelect},model:{value:(_vm.item.productObject),callback:function ($$v) {_vm.$set(_vm.item, "productObject", $$v)},expression:"item.productObject"}},[[(!_vm.loading)?_c('span',[_vm._v("Niciun produs găsit")]):_vm._e()]],2),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.um'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.um),expression:"item.um"}],staticClass:"form-control",attrs:{"disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "um", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":_vm.item.um}},[_vm._v(_vm._s(_vm.item.um))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.cantitateConsumata'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.cantitateConsumata),expression:"item.cantitateConsumata"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.cantitateConsumata')},domProps:{"value":(_vm.item.cantitateConsumata)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "cantitateConsumata", $event.target.value)},function($event){_vm.item.cantitateNecesara = _vm.item.cantitateConsumata}]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.cantitateNecesara'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.cantitateNecesara),expression:"item.cantitateNecesara"}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":_vm.$t('gestiune.cantitateNecesara')},domProps:{"value":(_vm.item.cantitateNecesara)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "cantitateNecesara", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeModal}},[_vm._v("\n              "+_vm._s(_vm.$t('general.cancel2'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":_vm.saveProduct}},[_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n            ")])])])])])]),_vm._v(" "),_c('ManagementSeriesAdd',{attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations,"vat-number":_vm.selectedLocation ? _vm.selectedLocation.inv_fiscal_code : ''},on:{"getSeries":_vm.getSeries}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4U7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'id': 1,
  'number': '000001',
  'created_date': '2018-05-01 10:09',
  'pickup_time': '2018-05-01 12:00',
  'status': 'completed',
  'type': 'group',
  'reward_points': 1,
  'currency': 'lei',
  'delivery': {
    'id': 'pickup',
    'type': 'Pick up'
  },
  'payment': {
    'id': 'cash',
    'type': 'Cash on Delivery'
  },
  'totals': {
    'subtotal': '32.5',
    'discount': '-10',
    'shipping': '5',
    'total': '27.5'
  },
  'comments': '',
  'customer': {
    'id': 1,
    'name': 'Iopescu Viorel',
    'phone': '+44 777 111 222',
    'email': 'iovio@gmail.com'
  },
  'address': {
    'billing': {
      'id': 10,
      'type': 'billing',
      'street': 'Zorelelor 12',
      'city': 'Oradea',
      'state': 'Bihor',
      'country': 'RO'
    },
    'shipping': {
      'id': 11,
      'type': 'shipping',
      'street': 'Zorelelor 12',
      'city': 'Oradea',
      'state': 'Bihor',
      'country': 'RO'
    }
  },
  'products': [{
    'customer': {
      'name': 'Viorel'
    },
    'items': [{
      'id': 1,
      'name': 'Cappucinno',
      'quantity': 3,
      'price': 7.00,
      'instructions': 'Please use coconut milk.',
      'category': {
        'category_id': 7,
        'name': 'Beverages'
      },
      'options': [{
        'id': 3,
        'name': 'Extra extresso shot',
        'price': 3
      }]
    }, {
      'id': 1,
      'name': 'Chocolate Chip Cookie',
      'quantity': 1,
      'price': 4.50,
      'instructions': '',
      'category': {
        'category_id': 8,
        'name': 'Cookies'
      },
      'options': []
    }]
  }, {
    'customer': {
      'name': 'Rozi-'
    },
    'items': [{
      'id': 1,
      'name': 'Cappucinno',
      'quantity': 1,
      'price': 7.00,
      'instructions': '',
      'category': {
        'category_id': 7,
        'name': 'Beverages'
      },
      'options': []
    }]
  }],
  'history': [{
    'date': '2018-07-15',
    'status': 'pending',
    'comment': '',
    'customer_notified': 'yes'
  }, {
    'date': '2018-07-15',
    'status': 'processing',
    'comment': '',
    'customer_notified': 'no'
  }]
});

/***/ }),

/***/ "4UmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row glovo-integration-form marketplace-settings"},[_c('div',{staticClass:"col-md-12"},[_c('section',{staticClass:"marketplace-action-panel marketplace-setup-panel"},[_c('div',{staticClass:"marketplace-action-heading"},[_c('i',{staticClass:"ti-location-pin",attrs:{"aria-hidden":"true"}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('marketplace.locations')))]),_c('p',[_vm._v(_vm._s(_vm.$t('marketplace.locationsSectionHint')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('location_id') }},[_c('label',{attrs:{"for":"glovo-location_id"}},[_vm._v(_vm._s(_vm.$t('marketplace.menuLocation'))),(_vm.isRequired('location_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.location_id),expression:"formData.location_id"}],staticClass:"form-control",attrs:{"id":"glovo-location_id","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'glovo-loc-' + String(loc._integrationLocationId),domProps:{"value":loc._integrationLocationId}},[_vm._v("\n          "+_vm._s(loc.name)+"\n        ")])})],2),_vm._v(" "),_c('p',{staticClass:"marketplace-field-hint"},[_vm._v(_vm._s(_vm.$t('marketplace.menuHint')))]),_vm._v(" "),(_vm.showFieldError('location_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('location_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('orders_location_id') }},[_c('label',{attrs:{"for":"glovo-orders_location_id"}},[_vm._v(_vm._s(_vm.$t('marketplace.ordersLocation'))),(_vm.isRequired('orders_location_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.orders_location_id),expression:"formData.orders_location_id"}],staticClass:"form-control",attrs:{"id":"glovo-orders_location_id","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "orders_location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'glovo-orders-loc-' + String(loc._integrationLocationId),domProps:{"value":_vm.locationOptionValue(loc)}},[_vm._v("\n          "+_vm._s(loc.name)+"\n        ")])})],2),_vm._v(" "),_c('p',{staticClass:"marketplace-field-hint"},[_vm._v(_vm._s(_vm.$t('marketplace.ordersHint')))]),_vm._v(" "),(_vm.showFieldError('orders_location_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('orders_location_id')))]):_vm._e()])])])]),_vm._v(" "),_c('section',{staticClass:"marketplace-action-panel marketplace-setup-panel"},[_c('div',{staticClass:"marketplace-action-heading"},[_c('i',{staticClass:"ti-key",attrs:{"aria-hidden":"true"}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('marketplace.credentials')))]),_c('p',[_vm._v(_vm._s(_vm.$t('marketplace.credentialsSectionHint')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('api_url') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('api_url'))),(_vm.isRequired('api_url'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.api_url),expression:"formData.api_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.api_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "api_url", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('api_url'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('api_url')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('pos_implementation_name') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('pos_implementation_name'))),(_vm.isRequired('pos_implementation_name'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.pos_implementation_name),expression:"formData.pos_implementation_name"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.pos_implementation_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "pos_implementation_name", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('pos_implementation_name'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('pos_implementation_name')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('store_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('store_id'))),(_vm.isRequired('store_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.store_id),expression:"formData.store_id"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.store_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "store_id", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('store_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('store_id')))]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4VJU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"integration-menu-entity-edit-page"},[_c('div',{staticClass:"integration-menu-entity-edit-page__banner",attrs:{"role":"status"}},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsMenuValidationEditPageHint')))])]),_vm._v(" "),(_vm.entityComponent)?_c(_vm.entityComponent,{key:_vm.entityRouteKey,tag:"component",attrs:{"route":_vm.entityRoute}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4WvA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4ZgZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4f/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('a',{staticClass:"btn btn-success btn-icon mar-rt-10",attrs:{"title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('i',{staticClass:"ti-save"})])])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsTips.state')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive($event)}},model:{value:(_vm.model.tips_in_use),callback:function ($$v) {_vm.$set(_vm.model, "tips_in_use", $$v)},expression:"model.tips_in_use"}})],1),_vm._v(" "),(_vm.model.tips_in_use)?_c('div',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsTips.tipsTaxes')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.taxes,"value":"id","label":"name"},model:{value:(_vm.model.tips_taxes),callback:function ($$v) {_vm.$set(_vm.model, "tips_taxes", $$v)},expression:"model.tips_taxes"}}),_vm._v(" "),(_vm.errors.has(_vm.model.tips_taxes))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError(_vm.model.tips_taxes))+"\n                ")]):_vm._e()],1)]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4gP/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tables_vue__ = __webpack_require__("UZ+M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bd0d9fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tables_vue__ = __webpack_require__("0yfM");
function injectStyle (ssrContext) {
  __webpack_require__("3qTf")
  __webpack_require__("yU+I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bd0d9fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bd0d9fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4kd5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4nx0":
/***/ (function(module, exports) {

module.exports = {"counters":{"u_row":13,"u_column":19,"u_content_menu":3,"u_content_text":11,"u_content_image":3,"u_content_button":4,"u_content_social":1,"u_content_divider":6},"body":{"id":"a5HhZ_qlZy","rows":[{"id":"Ep9XVhvzIy","cells":[1],"columns":[{"id":"h24aZoZpqk","contents":[{"id":"omalCky6vC","type":"divider","values":{"width":"100%","border":{"borderTopWidth":"0px","borderTopStyle":"solid","borderTopColor":"#BBBBBB"},"textAlign":"center","containerPadding":"5px","anchor":"","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_divider_6","htmlClassNames":"u_content_divider"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false}}],"values":{"_meta":{"htmlID":"u_column_16","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_13","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}},{"id":"T6ZAlfZ5RO","cells":[1,1,1],"columns":[{"id":"SJ2Y3DE5l2","contents":[{"id":"L4GWAMUoeZ","type":"menu","values":{"containerPadding":"25px 10px 10px","anchor":"","menu":{"items":[{"key":"1606923979328","link":{"name":"web","values":{"href":"","target":"_self"}},"text":"Noutăți"}]},"fontFamily":{"label":"Montserrat","value":"'Montserrat',sans-serif","url":"https://fonts.googleapis.com/css?family=Montserrat:400,700","defaultFont":true},"fontSize":"14px","textColor":"#444444","linkColor":"#0068A5","align":"center","layout":"horizontal","separator":"","padding":"5px 15px","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_menu_3","htmlClassNames":"u_content_menu"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false}}],"values":{"_meta":{"htmlID":"u_column_1","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}},{"id":"rC_ELsbdr3","contents":[{"id":"lx_PjCBSFX","type":"image","values":{"containerPadding":"20px 10px","anchor":"","src":{"url":"https://cdn.templates.unlayer.com/assets/1606906849237-logo.png","width":248,"height":56,"maxWidth":"77%","autoWidth":false},"textAlign":"center","altText":"Image","action":{"name":"web","values":{"href":"","target":"_blank"}},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_image_1","htmlClassNames":"u_content_image"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"_override":{"mobile":{"src":{"maxWidth":"58%","autoWidth":false}}}}}],"values":{"_meta":{"htmlID":"u_column_2","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}},{"id":"-_FKX5eb5h","contents":[{"id":"X91eqWl5FM","type":"menu","values":{"containerPadding":"25px 10px 30px","anchor":"","menu":{"items":[{"key":"1606923979328","link":{"name":"web","values":{"href":"","target":"_self"}},"text":"Servicii"}]},"fontFamily":{"label":"Montserrat","value":"'Montserrat',sans-serif","url":"https://fonts.googleapis.com/css?family=Montserrat:400,700","defaultFont":true},"fontSize":"14px","textColor":"#444444","linkColor":"#0068A5","align":"center","layout":"horizontal","separator":"","padding":"5px 15px","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_menu_2","htmlClassNames":"u_content_menu"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false}}],"values":{"_meta":{"htmlID":"u_column_3","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_1","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}},{"id":"GWKtYhef21","cells":[1],"columns":[{"id":"ycZvvbQOIH","contents":[{"id":"Sa5XPcAG3m","type":"divider","values":{"width":"100%","border":{"borderTopWidth":"0px","borderTopStyle":"solid","borderTopColor":"#BBBBBB"},"textAlign":"center","containerPadding":"150px 10px 10px","anchor":"","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_divider_2","htmlClassNames":"u_content_divider"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false}},{"id":"KjpjVp8tSU","type":"text_deprecated","values":{"containerPadding":"10px","anchor":"","color":"#ffffff","textAlign":"center","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_1","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"font-size: 14px; line-height: 140%;\"><strong><span style=\"font-size: 44px; line-height: 61.6px;\">Promoție</span></strong></p>"}},{"id":"nGfUcnU-O_","type":"button","values":{"containerPadding":"10px 10px 50px","anchor":"","href":{"name":"web","values":{"href":"","target":"_blank"}},"buttonColors":{"color":"#463a41","backgroundColor":"#ffffff","hoverColor":"#FFFFFF","hoverBackgroundColor":"#3AAEE0"},"size":{"autoWidth":true,"width":"100%"},"fontSize":"14px","textAlign":"center","lineHeight":"120%","padding":"12px 22px","border":[],"borderRadius":"0px","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_button_1","htmlClassNames":"u_content_button"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<strong>VEZI DETALII</strong>","calculatedWidth":139,"calculatedHeight":41}}],"values":{"_meta":{"htmlID":"u_column_5","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"https://ichef.bbci.co.uk/food/ic/food_16x9_832/recipes/black_and_blue_burger_95881_16x9.jpg","fullWidth":false,"repeat":"no-repeat","size":"custom","position":"top-center","width":832,"height":468,"customPosition":["50%","0%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_3","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}},{"id":"ZFPlyxI0B8","cells":[1],"columns":[{"id":"TzdqOA_mi7","contents":[{"id":"Nguez2ovzK","type":"text_deprecated","values":{"containerPadding":"40px 10px 10px","anchor":"","textAlign":"center","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_2","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"line-height: 140%; font-size: 14px;\"><strong><span style=\"font-size: 24px; line-height: 33.6px;\">Comandă prin aplicație</span></strong></p>"}},{"id":"SKfhjoEghx","type":"text_deprecated","values":{"containerPadding":"0px 10px 40px","anchor":"","textAlign":"center","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_11","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\">Lorem ipsum dolor sit amet, </span></p>"}}],"values":{"_meta":{"htmlID":"u_column_7","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_5","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}},{"id":"CwnWHwl5w8","cells":[1,1],"columns":[{"id":"k0UCrCt7v-","contents":[{"id":"9Xr4jZdRPe","type":"image","values":{"containerPadding":"10px","anchor":"","src":{"url":"https://www.foodandwine.com/thmb/pwFie7NRkq4SXMDJU6QKnUKlaoI=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Ultimate-Veggie-Burgers-FT-Recipe-0821-5d7532c53a924a7298d2175cf1d4219f.jpg","width":1500,"height":1001},"textAlign":"center","altText":"Image","action":{"name":"web","values":{"href":"","target":"_blank"}},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_image_3","htmlClassNames":"u_content_image"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false}},{"id":"gLl-djO3VL","type":"text_deprecated","values":{"containerPadding":"10px 10px 0px","anchor":"","textAlign":"center","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_3","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 16px; line-height: 22.4px;\"><strong><span style=\"line-height: 22.4px; font-size: 16px;\">Burger</span></strong></span></p>"}},{"id":"ewkeLXalox","type":"text_deprecated","values":{"containerPadding":"10px","anchor":"","textAlign":"center","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_4","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 16px; line-height: 22.4px;\"><strong><span style=\"line-height: 22.4px; font-size: 16px;\">40 Lei</span></strong></span></p>"}},{"id":"E6CVOvtZmP","type":"button","values":{"containerPadding":"10px","anchor":"","href":{"name":"web","values":{"href":"","target":"_blank"}},"buttonColors":{"color":"#FFFFFF","backgroundColor":"#262425","hoverColor":"#FFFFFF","hoverBackgroundColor":"#3AAEE0"},"size":{"autoWidth":true,"width":"100%"},"fontSize":"14px","textAlign":"center","lineHeight":"120%","padding":"10px 20px","border":[],"borderRadius":"0px","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_button_2","htmlClassNames":"u_content_button"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<span style=\"line-height: 16.8px;\">Comandă acum</span>","calculatedWidth":139,"calculatedHeight":37}}],"values":{"_meta":{"htmlID":"u_column_6","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}},{"id":"3l_UsMpMbV","contents":[{"id":"QLuTRXtU6_","type":"image","values":{"containerPadding":"10px","anchor":"","src":{"url":"https://www.foodandwine.com/thmb/pwFie7NRkq4SXMDJU6QKnUKlaoI=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Ultimate-Veggie-Burgers-FT-Recipe-0821-5d7532c53a924a7298d2175cf1d4219f.jpg","width":1500,"height":1001},"textAlign":"center","altText":"Image","action":{"name":"web","values":{"href":"","target":"_blank"}},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_image_2","htmlClassNames":"u_content_image"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false}},{"id":"JVTs6igXDt","type":"text_deprecated","values":{"containerPadding":"10px 10px 0px","anchor":"","textAlign":"center","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_5","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 16px; line-height: 22.4px;\"><strong><span style=\"line-height: 22.4px; font-size: 16px;\">Burger</span></strong></span></p>"}},{"id":"a3Uivi-NiJ","type":"text_deprecated","values":{"containerPadding":"10px","anchor":"","textAlign":"center","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_6","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 16px; line-height: 22.4px;\"><strong><span style=\"line-height: 22.4px; font-size: 16px;\">40 Lei</span></strong></span></p>"}},{"id":"-Ux7-YtC5t","type":"button","values":{"containerPadding":"10px","anchor":"","href":{"name":"web","values":{"href":"","target":"_blank"}},"buttonColors":{"color":"#FFFFFF","backgroundColor":"#262425","hoverColor":"#FFFFFF","hoverBackgroundColor":"#3AAEE0"},"size":{"autoWidth":true,"width":"100%"},"fontSize":"14px","textAlign":"center","lineHeight":"120%","padding":"10px 20px","border":[],"borderRadius":"0px","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_button_3","htmlClassNames":"u_content_button"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"Comandă acum","calculatedWidth":139,"calculatedHeight":37}}],"values":{"_meta":{"htmlID":"u_column_10","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_4","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}},{"id":"lTz0cI3bwo","cells":[1],"columns":[{"id":"9BAp-A_kWg","contents":[{"id":"HPB1aIy39I","type":"text_deprecated","values":{"containerPadding":"30px 30px 40px","anchor":"","textAlign":"center","lineHeight":"160%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_7","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"font-size: 14px; line-height: 160%;\"><span style=\"font-size: 14px; line-height: 22.4px;\">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span></p>"}}],"values":{"_meta":{"htmlID":"u_column_11","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_8","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}},{"id":"ZHHNJ43MLx","cells":[1],"columns":[{"id":"E-ibsbJDnd","contents":[{"id":"PgENPm_ZFH","type":"text_deprecated","values":{"containerPadding":"60px 30px 0px","anchor":"","color":"#ffffff","textAlign":"left","lineHeight":"120%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_8","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"line-height: 120%;\"><span style=\"font-size: 32px; line-height: 38.4px;\"><strong>Despre noi</strong></span></p>","_override":{"mobile":{"textAlign":"center"}}}},{"id":"Aw3eD-ICsc","type":"text_deprecated","values":{"containerPadding":"22px 30px 10px","anchor":"","color":"#ffffff","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_9","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\">Lorem ipsum dolor sit amet, consectetur </span></p>\n<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\">adipiscing elit, sed do eiusmod tempor </span></p>\n<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\">incididunt ut labore et dolore magna </span></p>\n<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\"><span style=\"line-height: 19.6px; font-size: 14px;\">aliqua.</span><span style=\"line-height: 19.6px; font-size: 14px;\">enim ad minim veniam, quis nostrud </span></span></p>\n<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\"><span style=\"line-height: 19.6px; font-size: 14px;\">exercitation ullamco</span><span style=\"line-height: 19.6px; font-size: 14px;\"> </span></span></p>","_override":{"mobile":{"textAlign":"center"}}}},{"id":"l5rYaMPf23","type":"button","values":{"containerPadding":"10px 30px 40px","anchor":"","href":{"name":"web","values":{"href":"","target":"_blank"}},"buttonColors":{"color":"#252324","backgroundColor":"#ffffff","hoverColor":"#FFFFFF","hoverBackgroundColor":"#3AAEE0"},"size":{"autoWidth":true,"width":"100%"},"fontSize":"14px","textAlign":"left","lineHeight":"120%","padding":"12px 25px","border":[],"borderRadius":"0px","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_button_4","htmlClassNames":"u_content_button"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<strong>VEZI DETALII</strong>","_override":{"mobile":{"textAlign":"center"}},"calculatedWidth":145,"calculatedHeight":41}}],"values":{"_meta":{"htmlID":"u_column_9","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"https://www.foodandwine.com/thmb/pwFie7NRkq4SXMDJU6QKnUKlaoI=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Ultimate-Veggie-Burgers-FT-Recipe-0821-5d7532c53a924a7298d2175cf1d4219f.jpg","fullWidth":false,"repeat":"no-repeat","size":"custom","position":"center-left","width":1500,"height":1001,"customPosition":["0%","50%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_7","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}},{"id":"nnXXJM1RZn","cells":[1],"columns":[{"id":"OitQyc6GcD","contents":[{"id":"tTvivre32W","type":"divider","values":{"width":"100%","border":{"borderTopWidth":"0px","borderTopStyle":"solid","borderTopColor":"#BBBBBB"},"textAlign":"center","containerPadding":"15px","anchor":"","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_divider_4","htmlClassNames":"u_content_divider"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false}}],"values":{"_meta":{"htmlID":"u_column_12","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_9","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}},{"id":"p5a1xH4CKB","cells":[1],"columns":[{"id":"0j-i5LnFbS","contents":[{"id":"hiBSZwld5n","type":"text_deprecated","values":{"containerPadding":"20px 10px 10px","anchor":"","color":"#ffffff","textAlign":"center","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_10","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px; font-family: Montserrat, sans-serif;\"><strong><span style=\"line-height: 19.6px; font-size: 14px;\">SOCIAL MEDIA</span></strong></span></p>"}},{"id":"OiSvfqRLeO","type":"social","values":{"containerPadding":"0px 10px 20px","anchor":"","icons":{"iconType":"circle-white","icons":[{"url":"https://facebook.com/","name":"Facebook"},{"url":"https://instagram.com/","name":"Instagram"},{"url":"https://twitter.com/","name":"Twitter"}],"editor":{"data":{"showDefaultIcons":true,"showDefaultOptions":true,"customIcons":[],"customOptions":[]}}},"align":"center","spacing":10,"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_social_1","htmlClassNames":"u_content_social"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false}}],"values":{"_meta":{"htmlID":"u_column_14","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"#cd4126","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_11","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}},{"id":"vwsUakjTfv","cells":[1],"columns":[{"id":"mtrz-M6Ss_","contents":[{"id":"EnKFCdHFKx","type":"divider","values":{"width":"100%","border":{"borderTopWidth":"0px","borderTopStyle":"solid","borderTopColor":"#BBBBBB"},"textAlign":"center","containerPadding":"10px","anchor":"","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_divider_5","htmlClassNames":"u_content_divider"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false}}],"values":{"_meta":{"htmlID":"u_column_15","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_12","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}}],"values":{"popupPosition":"center","popupWidth":"600px","popupHeight":"auto","borderRadius":"10px","contentAlign":"center","contentVerticalAlign":"center","contentWidth":"600px","fontFamily":{"label":"Montserrat","value":"'Montserrat',sans-serif","url":"https://fonts.googleapis.com/css?family=Montserrat:400,700","defaultFont":true},"textColor":"#000000","popupBackgroundColor":"#FFFFFF","popupBackgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"cover","position":"center"},"popupOverlay_backgroundColor":"rgba(0, 0, 0, 0.1)","popupCloseButton_position":"top-right","popupCloseButton_backgroundColor":"#DDDDDD","popupCloseButton_iconColor":"#000000","popupCloseButton_borderRadius":"0px","popupCloseButton_margin":"0px","popupCloseButton_action":{"name":"close_popup","attrs":{"onClick":"document.querySelector('.u-popup-container').style.display = 'none';"}},"backgroundColor":"#f3e1af","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"preheaderText":"","linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}},"schemaVersion":12}

/***/ }),

/***/ "4uSL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosScreenForm_vue__ = __webpack_require__("OcVr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ce70ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosScreenForm_vue__ = __webpack_require__("AahH");
function injectStyle (ssrContext) {
  __webpack_require__("2aqO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosScreenForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ce70ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosScreenForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4xpk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSuppliers_vue__ = __webpack_require__("ve+k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4272009c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSuppliers_vue__ = __webpack_require__("P+7y");
function injectStyle (ssrContext) {
  __webpack_require__("aAvn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4272009c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSuppliers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4272009c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSuppliers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "52Pd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n        "+_vm._s(_vm.$t('general.back'))+"\n      ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){_vm.saveMyOrder()}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.isProcess ? _vm.$t('gestiune.processingOrder') : _vm.$t('gestiune.addOrder')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Comanda pentru locatia")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isProcess},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                    "+_vm._s(loc.name)+"\n                  ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Din locatiile cu gestiune tip depozit")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDepositLocationId),expression:"selectedDepositLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isProcess},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedDepositLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează locația depozit")]),_vm._v(" "),_vm._l((_vm.locationsWithDepositGestiune),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                  "+_vm._s(loc.name)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"serie"}},[_vm._v(_vm._s(_vm.$t('invoice.series'))+"*")]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Selectează seria"},model:{value:(_vm.myOrder.serie),callback:function ($$v) {_vm.$set(_vm.myOrder, "serie", $$v)},expression:"myOrder.serie"}},_vm._l((_vm.seriesOptions),function(serie){return _c('el-option',{key:serie.id,attrs:{"label":((serie.name) + " - " + (serie.currentNumber)),"value":serie.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"data"}},[_vm._v(_vm._s(_vm.$t('gestiune.data')))]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"Selectează data"},model:{value:(_vm.myOrder.date),callback:function ($$v) {_vm.$set(_vm.myOrder, "date", $$v)},expression:"myOrder.date"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.productName'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.codeProduct'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.unitMeasure'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.quantityScriptic'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.quantityFaptic'))+"*")]),_vm._v(" "),_c('th',[_vm._v("Preț fără TVA")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.vatPercent')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.vatValue')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('general.actions')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[(_vm.isProcess)?[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Selectează gestiunea"},model:{value:(item.gestiune),callback:function ($$v) {_vm.$set(item, "gestiune", $$v)},expression:"item.gestiune"}},_vm._l((_vm.gestiuniForSelectedDepositLocation),function(option){return _c('el-option',{key:option.id,attrs:{"label":option.name,"value":option.id}})}))]:[_vm._v("\n                "+_vm._s(_vm.gestiuneOptions.find(function (g) { return g.id === item.gestiune; }).name || '—')+"\n              ")]],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(typeof item.productName === 'object' ? item.productName.name : item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.unitMeasure))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.quantity_scriptic))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.quantity_faptic),expression:"item.quantity_faptic",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Cantitate faptic"},domProps:{"value":(item.quantity_faptic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity_faptic", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.pret_fara_tva),expression:"item.pret_fara_tva",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","step":"0.01","placeholder":"Preț fără TVA"},domProps:{"value":(item.pret_fara_tva)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "pret_fara_tva", _vm._n($event.target.value))},function($event){_vm.updateVatValue(item)}],"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tva_percent))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.vatValue))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",on:{"click":function($event){_vm.removeItem(index)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.delete'))+"\n              ")])])])}),_vm._v(" "),_c('tr',[_c('td',[_c('el-select',{attrs:{"placeholder":"Selectează gestiunea"},model:{value:(_vm.newItem.gestiune),callback:function ($$v) {_vm.$set(_vm.newItem, "gestiune", $$v)},expression:"newItem.gestiune"}},_vm._l((_vm.filteredGestiuni),function(option){return _c('el-option',{key:option.id,attrs:{"label":option.name,"value":option.id}})}))],1),_vm._v(" "),_c('td',{staticStyle:{"width":"250px !important"}},[_c('v-select',{attrs:{"options":_vm.searchResults,"label":"name","placeholder":"Caută un produs...","filterable":false},on:{"search":_vm.fetchProducts,"input":_vm.onProductSelected},model:{value:(_vm.newItem.productName),callback:function ($$v) {_vm.$set(_vm.newItem, "productName", $$v)},expression:"newItem.productName"}},[[_c('span',[_vm._v("Niciun produs găsit")])]],2)],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.code),expression:"newItem.code"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Cod","disabled":""},domProps:{"value":(_vm.newItem.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "code", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.unitMeasure),expression:"newItem.unitMeasure"}],staticClass:"form-control",attrs:{"disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newItem, "unitMeasure", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":_vm.newItem.unitMeasure}},[_vm._v(_vm._s(_vm.newItem.unitMeasure))])])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.quantity_scriptic),expression:"newItem.quantity_scriptic",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.quantityScriptic')},domProps:{"value":(_vm.newItem.quantity_scriptic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "quantity_scriptic", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.quantity_faptic),expression:"newItem.quantity_faptic",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.quantityFaptic')},domProps:{"value":(_vm.newItem.quantity_faptic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "quantity_faptic", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.pret_fara_tva),expression:"newItem.pret_fara_tva",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Preț fără TVA"},domProps:{"value":(_vm.newItem.pret_fara_tva)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "pret_fara_tva", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.tva_percent),expression:"newItem.tva_percent",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.newItem.tva_percent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "tva_percent", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{staticClass:"form-control",attrs:{"type":"number","disabled":""},domProps:{"value":_vm.calculateVatValue(_vm.newItem)}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.addItem}},[_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])])])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "52vF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row bolt-integration-form marketplace-settings"},[_c('div',{staticClass:"col-md-12"},[_c('section',{staticClass:"marketplace-action-panel marketplace-setup-panel"},[_c('div',{staticClass:"marketplace-action-heading"},[_c('i',{staticClass:"ti-location-pin",attrs:{"aria-hidden":"true"}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('marketplace.locations')))]),_c('p',[_vm._v(_vm._s(_vm.$t('marketplace.locationsSectionHint')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('location_id') }},[_c('label',{attrs:{"for":"bolt-location_id"}},[_vm._v(_vm._s(_vm.$t('marketplace.menuLocation'))),(_vm.isRequired('location_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.location_id),expression:"formData.location_id"}],staticClass:"form-control",attrs:{"id":"bolt-location_id","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'bolt-loc-' + String(loc._integrationLocationId),domProps:{"value":loc._integrationLocationId}},[_vm._v("\n          "+_vm._s(loc.name)+"\n        ")])})],2),_vm._v(" "),_c('p',{staticClass:"marketplace-field-hint"},[_vm._v(_vm._s(_vm.$t('marketplace.menuHint')))]),_vm._v(" "),(_vm.showFieldError('location_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('location_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('orders_location_id') }},[_c('label',{attrs:{"for":"bolt-orders_location_id"}},[_vm._v(_vm._s(_vm.$t('marketplace.ordersLocation'))),(_vm.isRequired('orders_location_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.orders_location_id),expression:"formData.orders_location_id"}],staticClass:"form-control",attrs:{"id":"bolt-orders_location_id","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "orders_location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'bolt-orders-loc-' + String(loc._integrationLocationId),domProps:{"value":_vm.locationOptionValue(loc)}},[_vm._v("\n          "+_vm._s(loc.name)+"\n        ")])})],2),_vm._v(" "),_c('p',{staticClass:"marketplace-field-hint"},[_vm._v(_vm._s(_vm.$t('marketplace.ordersHint')))]),_vm._v(" "),(_vm.showFieldError('orders_location_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('orders_location_id')))]):_vm._e()])])])]),_vm._v(" "),_c('section',{staticClass:"marketplace-action-panel marketplace-setup-panel"},[_c('div',{staticClass:"marketplace-action-heading"},[_c('i',{staticClass:"ti-key",attrs:{"aria-hidden":"true"}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('marketplace.credentials')))]),_c('p',[_vm._v(_vm._s(_vm.$t('marketplace.credentialsSectionHint')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('api_url') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('api_url'))),(_vm.isRequired('api_url'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.api_url),expression:"formData.api_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.api_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "api_url", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('api_url'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('api_url')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('integrator_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('integrator_id'))),(_vm.isRequired('integrator_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.integrator_id),expression:"formData.integrator_id"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.integrator_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "integrator_id", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('integrator_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('integrator_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('provider_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('provider_id'))),(_vm.isRequired('provider_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.provider_id),expression:"formData.provider_id"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.provider_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "provider_id", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('provider_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('provider_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('secret_key') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('secret_key'))),(_vm.isRequired('secret_key'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.secret_key),expression:"formData.secret_key"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.secret_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "secret_key", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('secret_key'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('secret_key')))]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "53nb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"})])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.$t('gestiune.bonFiscal'))+"\n        "),(_vm.tableData.length && _vm.tableData[0].nr)?_c('span',[_vm._v("\n          - Nr: "+_vm._s(_vm.tableData[0].nr)+"\n        ")]):_vm._e()]),_vm._v(" "),(_vm.tableData.length)?_c('div',{staticClass:"bon-details"},[_c('div',{staticClass:"detail-item"},[_c('span',{staticClass:"label"},[_vm._v("ID:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.tableData[0]._id))])]),_vm._v(" "),_c('div',{staticClass:"detail-item"},[_c('span',{staticClass:"label"},[_vm._v("Data:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.formatDate(_vm.tableData[0].date)))])]),_vm._v(" "),_c('div',{staticClass:"detail-item"},[_c('span',{staticClass:"label"},[_vm._v("Created at:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.formatDate(_vm.tableData[0].created_at)))])]),_vm._v(" "),_c('div',{staticClass:"detail-item"},[_c('span',{staticClass:"label"},[_vm._v("Companie:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.tableData[0].externalCompanyId))])]),_vm._v(" "),_c('div',{staticClass:"detail-item"},[_c('span',{staticClass:"label"},[_vm._v("Locație:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.tableData[0].externalLocationId))])]),_vm._v(" "),_c('div',{staticClass:"detail-item order"},[_c('span',{staticClass:"label"},[_vm._v("Order ID:")]),_vm._v(" "),_c('span',{staticClass:"value",on:{"click":function($event){$event.stopPropagation();_vm.goToOrder(_vm.tableData[0])}}},[_vm._v(_vm._s(_vm.tableData[0].externalOrderId || 'N/A'))])]),_vm._v(" "),_c('div',{staticClass:"detail-item"},[_c('span',{staticClass:"label"},[_vm._v("Fiscal:")]),_vm._v(" "),_c('span',{staticClass:"value",class:_vm.tableData[0].is_fiscal ? 'yes' : 'no'},[_vm._v("\n            "+_vm._s(_vm.tableData[0].is_fiscal ? 'DA' : 'NU')+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"detail-item"},[_c('span',{staticClass:"label"},[_vm._v("Tip vânzare:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.formatTipVanzare(_vm.tableData[0].tip_vanzare)))])]),_vm._v(" "),_c('div',{staticClass:"detail-item"},[_c('span',{staticClass:"label"},[_vm._v("Sursă:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.tableData[0].source))])]),_vm._v(" "),_c('div',{staticClass:"detail-item"},[_c('span',{staticClass:"label"},[_vm._v("Tip:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.formatTipVanzare(_vm.tableData[0].type)))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"summary-wrapper"},[_c('div',{staticClass:"summary-card"},[_c('div',{staticClass:"label"},[_vm._v("Total fără discount")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.summary.totalWithoutDiscount.toFixed(2))+" lei")])]),_vm._v(" "),_c('div',{staticClass:"summary-card highlight"},[_c('div',{staticClass:"label"},[_vm._v("Total cu discount")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.summary.totalWithDiscount.toFixed(2))+" lei")])]),_vm._v(" "),_c('div',{staticClass:"summary-card"},[_c('div',{staticClass:"label"},[_vm._v("Total net (fără TVA)")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.summary.totalNet.toFixed(2))+" lei")])]),_vm._v(" "),_c('div',{staticClass:"summary-card"},[_c('div',{staticClass:"label"},[_vm._v("Total TVA")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.summary.totalVat.toFixed(2))+" lei")])]),_vm._v(" "),_c('div',{staticClass:"summary-card danger"},[_c('div',{staticClass:"label"},[_vm._v("Total discount")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("-"+_vm._s(_vm.summary.totalDiscount.toFixed(2))+" lei")])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"border":""}},[_c('el-table-column',{attrs:{"label":"ID Produs","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.productId)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Produs","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.productName)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Cantitate","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.productQty)+" "+_vm._s(scope.row.productUm || '')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Preț produs","width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.productOriginalPrice)+" lei\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"TVA produs","width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.vat)+" %\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Discount","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.productDiscount || 0)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Discount fara tva","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.productDiscountNet)+" lei\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"TVA Discount","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.productDiscountVat)+" lei\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Preț (final)","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.productPrice)+" lei\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Preț (final) fara TVA","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.productNetPrice)+" lei\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"TVA pret (final)","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.productVatValue)+" lei\n              ("+_vm._s(scope.row.productVatRate)+"%)\n            ")]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "540F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reservations_vue__ = __webpack_require__("rNmr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ba1dba4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reservations_vue__ = __webpack_require__("NcRz");
function injectStyle (ssrContext) {
  __webpack_require__("fRZ+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ba1dba4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reservations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ba1dba4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reservations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "568L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    modelFromParent: {
      type: [Object, Array]
    }
  },
  data: function data() {
    return {
      model: this.modelFromParent,
      coupons: [],
      couponsLoaded: false,
      selectedCoupon: null,
      currency: ''
    };
  },

  watch: {
    modelFromParent: function modelFromParent(value) {
      if (!value || Array.isArray(value) || (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) !== 'object') {
        return;
      }
      this.model = value;
      if (value.coupon_id === undefined && this.selectedCoupon) {
        this.$set(this.model, 'coupon_id', this.selectedCoupon.id);
        return;
      }
      this.syncSelectedCoupon();
    },
    selectedCoupon: function selectedCoupon(value) {
      if (this.couponsLoaded && this.model && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.model) === 'object' && !Array.isArray(this.model)) {
        this.$set(this.model, 'coupon_id', value ? value.id : null);
      }
    }
  },
  computed: {
    isOutsideCampaign: function isOutsideCampaign() {
      var fromto = this.model && this.model.fromto;
      if (!this.selectedCoupon || !fromto || !fromto[0] || !fromto[1]) {
        return false;
      }
      var day = function day(value) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YYYY-MM-DD');
      };
      return day(fromto[0]) < String(this.selectedCoupon.datetime_validfrom).substr(0, 10) || day(fromto[1]) > String(this.selectedCoupon.datetime_validto).substr(0, 10);
    }
  },
  created: function created() {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso);
    this.getCoupons();
  },

  methods: {
    getCoupons: function getCoupons() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      data.exclude_subscription = 1;

      data.exclude_automation = 1;
      this.apiRequest('/coupon', 'GET', data, function (response) {
        if (response.status === true) {
          _this.coupons = response.data.map(function (coupon) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, coupon, {
              selectLabel: coupon.name + (coupon.coupon_code ? ' (' + coupon.coupon_code + ')' : '')
            });
          });
          _this.couponsLoaded = true;
          _this.syncSelectedCoupon();
        }
      });
    },
    syncSelectedCoupon: function syncSelectedCoupon() {
      if (!this.couponsLoaded) {
        return;
      }
      var couponId = this.model && this.model.coupon_id;
      this.selectedCoupon = couponId ? this.coupons.find(function (coupon) {
        return coupon.id === parseInt(couponId, 10);
      }) || null : null;
    },
    validate: function validate() {
      return true;
    }
  }
});

/***/ }),

/***/ "575J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageInput_vue__ = __webpack_require__("x2FS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7cc8268_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageInput_vue__ = __webpack_require__("Yr/u");
function injectStyle (ssrContext) {
  __webpack_require__("Iu1Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7cc8268_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "57yd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductCrossSellPicker_vue__ = __webpack_require__("Ulu/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8aa487be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductCrossSellPicker_vue__ = __webpack_require__("0JRC");
function injectStyle (ssrContext) {
  __webpack_require__("zmRt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8aa487be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductCrossSellPicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8aa487be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductCrossSellPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5AKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons "},[_c('div',{staticClass:"left-buttons mar-rt-10"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[(_vm.groupedLocations)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1)])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"})]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"tableInvoice",staticStyle:{"overflow-x":"auto"}},[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"codProdus","label":"PROD CODE","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numeProdus","label":"PROD NAME","min-width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalVanzari","label":"TOT SALES","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vanzariLocatie","label":"LOC SALES","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vanzariPachet","label":"PKG SALES","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"alteMetode","label":"OTH SALES","min-width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"pierderiProduse","label":"FIN WASTE","min-width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"pauzaMasa","label":"MEAL","min-width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produseAnulate","label":"CNL RCPT","min-width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalVanzari","label":"TOT SALES","min-width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"pretProdus","label":"PRICE/PROD","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bani","label":"MONEY","min-width":"150"}})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Anz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAdd_vue__ = __webpack_require__("cQcw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63219b8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAdd_vue__ = __webpack_require__("g7AI");
function injectStyle (ssrContext) {
  __webpack_require__("loY+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63219b8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Blt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      tableData: [],
      allLocations: [],
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      onSeriesInputTimeout: null,
      filter: {
        series: ''
      },
      selectedLocation: null,
      vatNumber: null
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getInvoices(this.filter.series || '', 'aviz', { locations: this.allLocations });
    },
    onSearch: function onSearch() {
      if (!this.selectedLocation || Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        });

        this.tableData = [];
        this.totalItems = 0;

        return;
      }

      var locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation];
      this.getInvoices(this.filter.series || '', 'aviz', { locations: locations });
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getInvoices(this.filter.series || '', 'aviz', this.selectedLocation, this.currentPage, this.pageSize);
    },
    onSeriesInput: function onSeriesInput(value) {
      this.filter.series = value;
    },
    addInvoice: function addInvoice() {
      this.$router.push('/management/outputs/add');
    },
    editInvoice: function editInvoice(invoiceNumber, series) {
      if (!invoiceNumber || !series) {
        console.error('Missing invoice number or series');
        return;
      }

      var invoiceId = series + '-' + invoiceNumber;
      this.$router.push({
        path: '/management/outputs/' + invoiceId,
        query: { edit: 'true' }
      });
    },
    invoice: function invoice(invoiceNumber, series) {
      if (!invoiceNumber || !series) {
        console.error('Missing invoice number or series');
        return;
      }

      var invoiceId = series + '-' + invoiceNumber;
      this.$router.push('/management/outputs/' + invoiceId);
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (!cellValue) return '';
      return new Date(cellValue).toLocaleDateString();
    },
    getInvoices: function getInvoices() {
      var series = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var tip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'aviz';
      var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var _this = this;

      var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var pageSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 25;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var externalCompanyId, url, ids, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, id, allLocations, _ids, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _id, response, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                externalCompanyId = _this.companyID;

                if (externalCompanyId) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/documents?externalCompanyId=' + externalCompanyId + '&tip=' + tip;

                if (series) {
                  url += '&series=' + series;
                }

                url += '&page=' + page + '&limit=' + pageSize;

                if (!location) {
                  _context.next = 33;
                  break;
                }

                if (!Array.isArray(location.locations)) {
                  _context.next = 30;
                  break;
                }

                ids = location.locations.map(function (l) {
                  return l.true_id;
                }).filter(Boolean);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 12;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(ids); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  id = _step.value;

                  url += '&externalLocationId=' + encodeURIComponent(id);
                }
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](12);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 20:
                _context.prev = 20;
                _context.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context.prev = 23;

                if (!_didIteratorError) {
                  _context.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context.finish(23);

              case 27:
                return _context.finish(20);

              case 28:
                _context.next = 31;
                break;

              case 30:
                if (location.id) {
                  if (location.true_id) {
                    url += '&externalLocationId=' + encodeURIComponent(location.true_id);
                  }
                }

              case 31:
                _context.next = 54;
                break;

              case 33:
                allLocations = _this.groupedLocations.flatMap(function (group) {
                  return group.locations;
                });
                _ids = allLocations.map(function (l) {
                  return l.true_id;
                }).filter(Boolean);
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 38;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_ids); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _id = _step2.value;

                  url += '&externalLocationId=' + encodeURIComponent(_id);
                }
                _context.next = 46;
                break;

              case 42:
                _context.prev = 42;
                _context.t1 = _context['catch'](38);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 46:
                _context.prev = 46;
                _context.prev = 47;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 49:
                _context.prev = 49;

                if (!_didIteratorError2) {
                  _context.next = 52;
                  break;
                }

                throw _iteratorError2;

              case 52:
                return _context.finish(49);

              case 53:
                return _context.finish(46);

              case 54:

                clearTimeout(_this.loadingTimeout);
                _this.loadingTimeout = setTimeout(function () {
                  _this.loading = true;
                }, 100);
                _context.prev = 56;
                _context.next = 59;
                return fetch(url);

              case 59:
                response = _context.sent;
                _context.next = 62;
                return response.json();

              case 62:
                data = _context.sent;

                if (Array.isArray(data.documents)) {
                  clearTimeout(_this.loadingTimeout);
                  _this.loading = false;
                  _this.totalItems = data.total || 0;
                  _this.currentPage = data.currentPage || page;
                  _this.pageSize = data.pageSize || pageSize;
                  _this.tableData = data.documents.map(function (invoice) {
                    var vatValue = 0;
                    if (invoice.vatTotals && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(invoice.vatTotals) === 'object') {
                      vatValue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(invoice.vatTotals).reduce(function (sum, val) {
                        return sum + val;
                      }, 0);
                    }

                    return {
                      id: invoice._id || invoice.id,
                      invoiceNumber: invoice.invoiceNumber,
                      client: invoice.customer ? invoice.customer.name : 'N/A',
                      issueDate: invoice.date,
                      valueNoVAT: invoice.subtotal.toFixed(2) + ' ' + invoice.currency,
                      vatValue: vatValue.toFixed(2) + ' ' + invoice.currency,
                      totalValue: invoice.total.toFixed(2) + ' ' + invoice.currency,
                      status: 'Paid',
                      series: invoice.series || 'N/A',
                      hasParent: !!invoice.parentDocument
                    };
                  });
                } else {
                  console.error('Invalid data format:', data);
                  _this.loading = false;
                }
                _context.next = 70;
                break;

              case 66:
                _context.prev = 66;
                _context.t2 = _context['catch'](56);

                console.error('Error fetching invoices:', _context.t2);
                _this.loading = false;

              case 70:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 16, 20, 28], [21,, 23, 27], [38, 42, 46, 54], [47,, 49, 53], [56, 66]]);
      }))();
    },
    applyFilter: function applyFilter() {
      this.getInvoices(this.filter.series);
      this.$modal.hide('filterModal');
    },
    clearFilter: function clearFilter() {
      this.filter.series = '';
      this.getInvoices();
      this.$modal.hide('filterModal');
    },
    downloadExcel: function downloadExcel(row) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                series = row.series;
                invoiceNumber = row.invoiceNumber;
                externalCompanyId = _this2.companyID;

                if (!(!series || !invoiceNumber || !externalCompanyId)) {
                  _context2.next = 6;
                  break;
                }

                alert('Missing series, invoice number or company ID.');
                return _context2.abrupt('return');

              case 6:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/aviz/' + series + '-' + invoiceNumber + '/xls?externalCompanyId=' + externalCompanyId;
                _context2.prev = 7;
                _context2.next = 10;
                return fetch(url);

              case 10:
                response = _context2.sent;

                if (!response.ok) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 14;
                return response.blob();

              case 14:
                blob = _context2.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + invoiceNumber + '.xls';
                link.click();
                URL.revokeObjectURL(link.href);
                _context2.next = 23;
                break;

              case 22:
                console.error('Error downloading invoice:', response.statusText);

              case 23:
                _context2.next = 28;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2['catch'](7);

                console.error('Error fetching invoice:', _context2.t0);

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 25]]);
      }))();
    },
    downloadInvoice: function downloadInvoice(row) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                series = row.series;
                invoiceNumber = row.invoiceNumber;
                externalCompanyId = _this3.companyID;

                if (!(!series || !invoiceNumber)) {
                  _context3.next = 6;
                  break;
                }

                alert('Missing series or invoice number.');
                return _context3.abrupt('return');

              case 6:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/aviz/' + series + '-' + invoiceNumber + '/pdf?externalCompanyId=' + externalCompanyId;
                _context3.prev = 7;
                _context3.next = 10;
                return fetch(url);

              case 10:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 14;
                return response.blob();

              case 14:
                blob = _context3.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + invoiceNumber + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                _context3.next = 23;
                break;

              case 22:
                console.error('Error downloading invoice:', response.statusText);

              case 23:
                _context3.next = 28;
                break;

              case 25:
                _context3.prev = 25;
                _context3.t0 = _context3['catch'](7);

                console.error('Error fetching invoice:', _context3.t0);

              case 28:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[7, 25]]);
      }))();
    },
    handleDeleteInvoice: function handleDeleteInvoice(id) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log(id);

                if (id) {
                  _context5.next = 4;
                  break;
                }

                console.error('Missing Invoice ID for deletion.');
                return _context5.abrupt('return');

              case 4:

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  title: 'Ești sigur?',
                  text: 'Această acțiune va șterge definitiv factura!',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Da, șterge!',
                  cancelButtonText: 'Anulează'
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(result) {
                    var response, data;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!result) {
                              _context4.next = 19;
                              break;
                            }

                            _context4.prev = 1;
                            _context4.next = 4;
                            return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                              method: 'DELETE',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                type: 'aviz',
                                id: id,
                                externalCompanyId: _this4.companyID
                              })
                            });

                          case 4:
                            response = _context4.sent;

                            if (response.ok) {
                              _context4.next = 7;
                              break;
                            }

                            throw new Error('HTTP error! Status: ' + response.status);

                          case 7:
                            _context4.next = 9;
                            return response.json();

                          case 9:
                            data = _context4.sent;

                            console.log('Invoice deleted successfully:', data);

                            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                              title: 'Succes!',
                              text: 'Avizul a fost șters cu succes.',
                              type: 'success',
                              timer: 2000,
                              showConfirmButton: false
                            });

                            _this4.getInvoices();
                            _context4.next = 19;
                            break;

                          case 15:
                            _context4.prev = 15;
                            _context4.t0 = _context4['catch'](1);

                            console.error('Error deleting Invoice:', _context4.t0);

                            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                              title: 'Eroare!',
                              text: 'A apărut o problemă la ștergerea avizului.',
                              type: 'error',
                              timer: 2000,
                              showConfirmButton: false
                            });

                          case 19:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this4, [[1, 15]]);
                  }));

                  return function (_x6) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    }
  }
});

/***/ }),

/***/ "5EKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__ = __webpack_require__("bfzT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d229811e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__ = __webpack_require__("seR9");
function injectStyle (ssrContext) {
  __webpack_require__("iDPB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d229811e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d229811e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Eos":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementInitialStockForm_vue__ = __webpack_require__("nrcP");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneInventarForm', __WEBPACK_IMPORTED_MODULE_7__ManagementInitialStockForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("gKTg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5NHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    badgeType: {
      type: String,
      default: 'success'
    },
    badgeIcon: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "5Nb5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationMenuValidationCollapse_vue__ = __webpack_require__("qPfg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ceebe3f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationMenuValidationCollapse_vue__ = __webpack_require__("oViy");
function injectStyle (ssrContext) {
  __webpack_require__("7b9o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ceebe3f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationMenuValidationCollapse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ceebe3f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationMenuValidationCollapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5ObC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Set":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuLinkAdd_vue__ = __webpack_require__("YBPa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf36c09e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuLinkAdd_vue__ = __webpack_require__("Ul8b");
function injectStyle (ssrContext) {
  __webpack_require__("7t5x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuLinkAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf36c09e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuLinkAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5WAl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockHistoryReport_vue__ = __webpack_require__("tw0q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1ae1dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockHistoryReport_vue__ = __webpack_require__("l8fr");
function injectStyle (ssrContext) {
  __webpack_require__("fqZq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d1ae1dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockHistoryReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1ae1dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockHistoryReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5ZZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementClients_vue__ = __webpack_require__("rKzl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d34b368_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementClients_vue__ = __webpack_require__("BADL");
function injectStyle (ssrContext) {
  __webpack_require__("EnYg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9d34b368"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementClients_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d34b368_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementClients_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5fo9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__ = __webpack_require__("pa/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TimeLine: __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__["a" /* default */],
    TimeLineItem: __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    TaskList: __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__["a" /* default */]
  },
  data: function data() {
    return {
      salesChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[542, 543, 520, 680, 653, 753, 326, 434, 568, 610, 756, 895], [230, 293, 380, 480, 503, 553, 600, 664, 698, 710, 736, 795]]
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: '245px'
        }
      },
      usersChart: {
        data: {
          labels: ['9AM', '12AM', '3PM', '6PM', '9PM', '12PM', '3AM', '6AM'],
          series: [[287, 385, 490, 562, 594, 626, 698, 895, 952], [67, 152, 193, 240, 387, 435, 535, 642, 744], [23, 113, 67, 108, 190, 239, 307, 410, 410]]
        },
        options: {
          low: 0,
          high: 1000,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          },
          showLine: true,
          showPoint: false
        }
      },
      subscriptionsChart: {
        data: {
          labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
          series: [[60, 50, 30, 50, 70, 60, 90, 100]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-red'
          }
        }
      },
      downloadsChart: {
        data: {
          labels: ['2009', '2010', '2011', '2012', '2013', '2014'],
          series: [[1200, 1000, 3490, 8345, 3256, 2566]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-orange'
          }
        }
      }
    };
  }
});

/***/ }),

/***/ "5h+L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementWastedForm_vue__ = __webpack_require__("Zyt1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a2d072c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementWastedForm_vue__ = __webpack_require__("pCH6");
function injectStyle (ssrContext) {
  __webpack_require__("so2V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a2d072c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementWastedForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a2d072c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementWastedForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5stz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaignAdd_vue__ = __webpack_require__("ZR/e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5559f4f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaignAdd_vue__ = __webpack_require__("22Vx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaignAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5559f4f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaignAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5thJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5y5J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5yP9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Settings_Printer_PrinterForm_vue__ = __webpack_require__("+VS9");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PrinterForm: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Settings_Printer_PrinterForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      tableManagementModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  }
});

/***/ }),

/***/ "6+yi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('menu-link-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onLinkSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "64vS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"offers-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();return _vm.handleDelete($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.delete'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"gift-card-detail"},[_c('div',{staticClass:"header-section"},[_c('div',{staticClass:"base-info"},[_c('h2',[_vm._v(_vm._s(_vm.$t('giftCard.baseTitle'))+" "+_vm._s(_vm.baseId))]),_vm._v(" "),_c('div',{staticClass:"badges"},[_c('span',{class:['badge', 'type-badge', _vm.typeClass]},[_vm._v("\n            "+_vm._s(_vm.baseData.type === 1 ? _vm.$t('giftCard.online') : _vm.$t('giftCard.offline'))+"\n          ")]),_vm._v(" "),_c('span',{class:['badge', 'status-badge', _vm.baseData.active ? 'active' : 'inactive']},[_vm._v("\n            "+_vm._s(_vm.baseData.active ? _vm.$t('giftCard.active') : _vm.$t('giftCard.inactive'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"value-display"},[_c('div',{staticClass:"value-box"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('giftCard.valueLabel')))]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.baseData.value)))])]),_vm._v(" "),(_vm.baseData.type === 2)?_c('div',{staticClass:"value-box"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('giftCard.totalCards')))]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v(_vm._s(_vm.pagination.total))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"cards-section"},[_c('div',{staticClass:"section-header d-flex align-items-center gap-3"},[_c('div',{staticClass:"form-group mb-0"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.status')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.baseData.active),callback:function ($$v) {_vm.$set(_vm.baseData, "active", $$v)},expression:"baseData.active"}})],1),_vm._v(" "),(_vm.baseData.type == 1)?_c('div',{staticClass:"form-group mb-0"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.validFromTo'))+"*")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","start-placeholder":_vm.$t('giftCard.fromDate'),"end-placeholder":_vm.$t('giftCard.toDate'),"range-separator":" - ","format":"dd.MM.yyyy","value-format":"yyyy-MM-dd"},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}}),_vm._v(" "),(_vm.errors.has('dateRange'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.$t('validations.requiredField'))+"\n          ")]):_vm._e()],1):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"cards-section"},[(_vm.baseData.type === 2)?_c('div',{staticClass:"section-header"},[_c('h3',[_vm._v(_vm._s(_vm.$t('giftCard.cardsListTitle')))]),_vm._v(" "),_c('div',{staticClass:"filters"},[_c('button',{staticClass:"btn-export",on:{"click":_vm.exportCards}},[_c('i',{staticClass:"ti-export"}),_vm._v(" "+_vm._s(_vm.$t('giftCard.export'))+"\n          ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"cards-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),(_vm.baseData.type === 2)?_c('th',[_vm._v(_vm._s(_vm.$t('giftCard.qr')))]):_vm._e(),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('giftCard.status')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('giftCard.payment')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('giftCard.active')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('giftCard.assignedTo')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('giftCard.value')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('giftCard.created')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.cards),function(card){return _c('tr',{key:card.id,class:{ 'used-row': card.used, 'inactive-row': !card.active }},[_c('td',[_vm._v(_vm._s(card.id))]),_vm._v(" "),(_vm.baseData.type === 2)?_c('td',[_c('img',{attrs:{"src":card.qr_code,"width":"50","height":"50","alt":"QR"}}),_vm._v(" "),_c('button',{staticClass:"btn-copy",attrs:{"title":_vm.$t('giftCard.copyLink')},on:{"click":function($event){_vm.copyLink(card.qr_code)}}},[_c('i',{staticClass:"ti-clipboard"})])]):_vm._e(),_vm._v(" "),_c('td',[_c('span',{class:['status-tag', card.used ? 'used' : 'unused']},[_vm._v("\n                  "+_vm._s(card.used ? _vm.$t('giftCard.used') : _vm.$t('giftCard.unused'))+"\n                ")])]),_vm._v(" "),_c('td',[_c('span',{class:['payment-tag', card.payed ? 'payed' : 'unpayed']},[_vm._v("\n                  "+_vm._s(card.payed ? _vm.$t('giftCard.payed') : _vm.$t('giftCard.unpayed'))+"\n                ")])]),_vm._v(" "),_c('td',[_c('span',{class:['active-tag', card.active ? 'active' : 'inactive']},[_vm._v("\n                  "+_vm._s(card.active ? _vm.$t('giftCard.yes') : _vm.$t('giftCard.no'))+"\n                ")])]),_vm._v(" "),_c('td',[(card.user_id)?_c('div',{staticClass:"user-info"},[_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.$t('giftCard.user'))+" "+_vm._s(card.user_id))])]):_c('span',{staticClass:"unassigned"},[_vm._v(_vm._s(_vm.$t('giftCard.notAssigned')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatCurrency(card.current_value)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(card.created_at)))])])}))])]),_vm._v(" "),(_vm.pagination.last_page > 1)?_c('div',{staticClass:"pagination-wrapper"},[_c('div',{staticClass:"pagination-info"},[_vm._v("\n          "+_vm._s(_vm.$t('giftCard.showingRecords', { from: _vm.pagination.from, to: _vm.pagination.to, total: _vm.pagination.total }))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('button',{staticClass:"page-btn",attrs:{"disabled":_vm.pagination.current_page === 1},on:{"click":function($event){_vm.changePage(_vm.pagination.current_page - 1)}}},[_c('i',{staticClass:"ti-angle-left"})]),_vm._v(" "),_vm._l((_vm.paginationRange),function(page){return _c('button',{key:page,class:['page-btn', { active: page === _vm.pagination.current_page }],on:{"click":function($event){_vm.changePage(page)}}},[_vm._v("\n            "+_vm._s(page)+"\n          ")])}),_vm._v(" "),_c('button',{staticClass:"page-btn",attrs:{"disabled":_vm.pagination.current_page === _vm.pagination.last_page},on:{"click":function($event){_vm.changePage(_vm.pagination.current_page + 1)}}},[_c('i',{staticClass:"ti-angle-right"})])],2)]):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"spinner"})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "67b5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs",attrs:{"direction":"vertical","value":"Description"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('dispath.dispatch')}},[(_vm.isDispatch)?_c('dispatch',{attrs:{"isDispatch":_vm.isDispatch}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left addNewOrder",attrs:{"title":_vm.$t('dispath.addNewOrder')}},[(_vm.isAddNewOrder)?_c('order-pos',{attrs:{"isAddNewOrder":_vm.isAddNewOrder}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('dispath.drivers')}},[(_vm.isDriver)?_c('dispatch-drivers',{attrs:{"isDriver":_vm.isDriver}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('dispath.orders')}},[(_vm.isOrder)?_c('dispatch-orders',{attrs:{"isOrder":_vm.isOrder}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('dispath.reports')}},[(_vm.isReport)?_c('dispatch-reports',{attrs:{"isReport":_vm.isReport}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('dispath.settings')}},[(_vm.isSettings)?_c('dispatch-settings',{attrs:{"isSettings":_vm.isSettings}}):_vm._e()],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "69bs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KdsForm_vue__ = __webpack_require__("rA/S");







var _components;





__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'KdsForm', __WEBPACK_IMPORTED_MODULE_7__KdsForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "6Ae6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationStatusPollingField_vue__ = __webpack_require__("7iHq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d383cedc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationStatusPollingField_vue__ = __webpack_require__("KDLz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationStatusPollingField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d383cedc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationStatusPollingField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6BXR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6CoB":
/***/ (function(module, exports) {

module.exports = {"counters":{"u_row":15,"u_column":21,"u_content_menu":3,"u_content_text":11,"u_content_image":3,"u_content_button":9,"u_content_social":1,"u_content_divider":6,"u_content_text_deprecated":1},"body":{"id":"a5HhZ_qlZy","rows":[{"id":"Ep9XVhvzIy","cells":[1],"columns":[{"id":"h24aZoZpqk","contents":[{"id":"omalCky6vC","type":"divider","values":{"width":"100%","border":{"borderTopWidth":"0px","borderTopStyle":"solid","borderTopColor":"#BBBBBB"},"textAlign":"center","containerPadding":"5px","anchor":"","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_divider_6","htmlClassNames":"u_content_divider"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false}}],"values":{"_meta":{"htmlID":"u_column_16","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_13","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}},{"id":"ZHHNJ43MLx","cells":[1],"columns":[{"id":"E-ibsbJDnd","contents":[{"id":"PgENPm_ZFH","type":"text_deprecated","values":{"containerPadding":"60px 30px 0px","anchor":"","color":"#ffffff","textAlign":"left","lineHeight":"120%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_8","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"line-height: 120%;\"><span style=\"font-size: 32px; line-height: 38.4px;\"><strong>20% REDUCERE</strong></span><span style=\"font-size: 32px; line-height: 38.4px;\"></span></p>","_override":{"mobile":{"textAlign":"center"}}}},{"id":"Aw3eD-ICsc","type":"text_deprecated","values":{"containerPadding":"22px 30px 10px","anchor":"","color":"#ffffff","textAlign":"left","lineHeight":"140%","linkStyle":{"inherit":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true},"hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_text_9","htmlClassNames":"u_content_text"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\">Lorem ipsum dolor sit amet, consectetur </span></p>\n<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\">adipiscing elit, sed do eiusmod tempor </span></p>\n<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\">incididunt ut labore et dolore magna </span></p>\n<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\"><span style=\"line-height: 19.6px; font-size: 14px;\">aliqua.</span><span style=\"line-height: 19.6px; font-size: 14px;\">enim ad minim veniam, quis nostrud </span></span></p>\n<p style=\"font-size: 14px; line-height: 140%;\"><span style=\"font-size: 14px; line-height: 19.6px;\"><span style=\"line-height: 19.6px; font-size: 14px;\">exercitation ullamco</span><span style=\"line-height: 19.6px; font-size: 14px;\"> </span></span></p>","_override":{"mobile":{"textAlign":"center"}}}},{"id":"o9yIKwqnS4","type":"button","values":{"containerPadding":"10px 30px 40px","anchor":"","href":{"name":"web","values":{"href":"","target":"_blank"}},"buttonColors":{"color":"#252324","backgroundColor":"#ffffff","hoverColor":"#FFFFFF","hoverBackgroundColor":"#3AAEE0"},"size":{"autoWidth":true,"width":"100%"},"fontSize":"14px","textAlign":"left","lineHeight":"120%","padding":"12px 25px","border":[],"borderRadius":"0px","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_button_5","htmlClassNames":"u_content_button"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"text":"<strong>COMANDĂ ACUM</strong>","_override":{"mobile":{"textAlign":"center"}},"calculatedWidth":168,"calculatedHeight":41}}],"values":{"_meta":{"htmlID":"u_column_9","htmlClassNames":"u_column"},"border":{"borderTopWidth":"0px","borderTopStyle":"solid","borderLeftWidth":"0px","borderLeftStyle":"solid","borderRightWidth":"0px","borderRightStyle":"solid","borderBottomWidth":"0px","borderBottomStyle":"solid"},"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"https://www.foodandwine.com/thmb/pwFie7NRkq4SXMDJU6QKnUKlaoI=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Ultimate-Veggie-Burgers-FT-Recipe-0821-5d7532c53a924a7298d2175cf1d4219f.jpg","fullWidth":false,"repeat":"no-repeat","size":"custom","position":"center-left","width":1500,"height":1001,"customPosition":["0%","50%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_7","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false,"_override":{"desktop":{"hideDesktop":false}}}},{"id":"vwsUakjTfv","cells":[1],"columns":[{"id":"mtrz-M6Ss_","contents":[{"id":"EnKFCdHFKx","type":"divider","values":{"width":"100%","border":{"borderTopWidth":"0px","borderTopStyle":"solid","borderTopColor":"#BBBBBB"},"textAlign":"center","containerPadding":"10px","anchor":"","hideDesktop":false,"displayCondition":[],"_meta":{"htmlID":"u_content_divider_5","htmlClassNames":"u_content_divider"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false}}],"values":{"_meta":{"htmlID":"u_column_15","htmlClassNames":"u_column"},"border":[],"padding":"0px","backgroundColor":""}}],"values":{"displayCondition":[],"columns":false,"backgroundColor":"","columnsBackgroundColor":"","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"padding":"0px","anchor":"","hideDesktop":false,"_meta":{"htmlID":"u_row_12","htmlClassNames":"u_row"},"selectable":true,"draggable":true,"duplicatable":true,"deletable":true,"hideable":true,"hideMobile":false,"noStackMobile":false}}],"values":{"popupPosition":"center","popupWidth":"600px","popupHeight":"auto","borderRadius":"10px","contentAlign":"center","contentVerticalAlign":"center","contentWidth":"600px","fontFamily":{"label":"Montserrat","value":"'Montserrat',sans-serif","url":"https://fonts.googleapis.com/css?family=Montserrat:400,700","defaultFont":true},"textColor":"#000000","popupBackgroundColor":"#FFFFFF","popupBackgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"cover","position":"center"},"popupOverlay_backgroundColor":"rgba(0, 0, 0, 0.1)","popupCloseButton_position":"top-right","popupCloseButton_backgroundColor":"#DDDDDD","popupCloseButton_iconColor":"#000000","popupCloseButton_borderRadius":"0px","popupCloseButton_margin":"0px","popupCloseButton_action":{"name":"close_popup","attrs":{"onClick":"document.querySelector('.u-popup-container').style.display = 'none';"}},"backgroundColor":"#ffffff","backgroundImage":{"url":"","fullWidth":true,"repeat":"no-repeat","size":"custom","position":"top-center","customPosition":["50%","0%"]},"preheaderText":"","linkStyle":{"body":true,"linkColor":"#0000ee","linkHoverColor":"#0000ee","linkUnderline":true,"linkHoverUnderline":true,"inherit":false},"_meta":{"htmlID":"u_body","htmlClassNames":"u_body"}}},"schemaVersion":12}

/***/ }),

/***/ "6ESu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IntegrationStatusPollingField_vue__ = __webpack_require__("6Ae6");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PSwitch: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Switch_vue__["a" /* default */], IntegrationStatusPollingField: __WEBPACK_IMPORTED_MODULE_1__IntegrationStatusPollingField_vue__["a" /* default */] },
  props: {
    formData: { type: Object, required: true },
    platform: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    fieldLabelFn: { type: Function, default: null }
  },
  methods: {
    fieldLabel: function fieldLabel(key) {
      return this.fieldLabelFn ? this.fieldLabelFn(key) : key;
    }
  }
});

/***/ }),

/***/ "6Eo9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  },
  data: function data() {
    var end = new Date();
    var start = new Date();
    start.setDate(end.getDate() - 29);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    return {
      loading: false,
      tableData: [],
      totalItems: 0,
      totalValue: 0,
      selectedGestiune: null,
      selectedLocation: null,
      searchDate: [start, end],
      selectedProduct: {},
      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            var end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      }
    };
  },

  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];

      return this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id && (g.categorie === 'Produs finit (Reteta)' || g.categorie === 'Semifabricate (Reteta)');
      });
    }
  },
  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.resetTable();

      this.selectedGestiune = null;
      this.tableData = [];
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    this.firstLoad();
  },

  methods: {
    firstLoad: function firstLoad() {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0];
      }
    },
    openViewProduction: function openViewProduction(product) {
      this.selectedProduct = product;
      this.$modal.show('productionModal');
    },
    closeProductionModal: function closeProductionModal() {
      this.$modal.hide('productionModal');
    },
    triggerFilter: function triggerFilter() {
      if (!this.selectedLocation) {
        return;
      }
      if (!this.searchDate || this.searchDate.length !== 2) {
        return;
      }

      this.resetTable();
      this.fetchProductionReport();
    },
    getProductionSummary: function getProductionSummary(_ref2) {
      var _this2 = this;

      var columns = _ref2.columns;

      var summary = [];

      columns.forEach(function (column, index) {
        if (index === 0) {
          summary[index] = 'TOTAL (' + _this2.totalItems + ' produse)';
          return;
        }

        if (column.property === 'value') {
          summary[index] = Number(_this2.totalValue).toFixed(2) + ' lei';
          return;
        }

        summary[index] = '';
      });

      return summary;
    },
    fetchProductionReport: function fetchProductionReport() {
      var _this3 = this;

      var exportFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _searchDate, startDate, endDate, externalCompanyId, params, url, response, data, grouped;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this3.selectedLocation || !_this3.searchDate)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (_this3.selectedGestiune) {
                  _context.next = 5;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  type: 'warning',
                  title: 'Nu aveți categorii setate pe gestiune',
                  text: 'Trebuie să setați cel puțin o gestiune care are categorie: "Produs finit (Reteta)" sau "Semifabricate (Reteta)" pentru a genera raportul.',
                  showConfirmButton: true
                });
                return _context.abrupt('return');

              case 5:

                _this3.loading = true;

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  type: 'info',
                  title: 'Se generează raportul de productie',
                  text: 'Vă rugăm așteptați...',
                  allowOutsideClick: false,
                  didOpen: function didOpen() {
                    return __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.showLoading();
                  }
                });

                _context.prev = 7;
                _searchDate = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_this3.searchDate, 2), startDate = _searchDate[0], endDate = _searchDate[1];
                externalCompanyId = _this3.$session.get('selectedCompany');
                params = new URLSearchParams({
                  externalCompanyId: externalCompanyId,
                  gestiune: _this3.selectedGestiune,
                  startDate: new Date(startDate),
                  endDate: new Date(endDate),
                  vatNumber: _this3.selectedLocation.inv_fiscal_code,
                  externalLocationId: _this3.selectedLocation.true_id
                });


                if (exportFormat) {
                  params.append('export', exportFormat.toUpperCase());
                }

                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/reports/production?' + params.toString();
                _context.next = 15;
                return fetch(url);

              case 15:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 18;
                  break;
                }

                throw new Error('HTTP ' + response.status);

              case 18:
                if (!exportFormat) {
                  _context.next = 22;
                  break;
                }

                window.location.href = url;

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.close();
                }, 800);

                return _context.abrupt('return');

              case 22:
                _context.next = 24;
                return response.json();

              case 24:
                data = _context.sent;


                if (Array.isArray(data.items)) {
                  grouped = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(data.items.reduce(function (acc, item) {
                    var key = item.productId;

                    if (!acc[key]) {
                      acc[key] = {
                        productId: item.productId,
                        name: item.name,
                        unit: item.unit,
                        quantity: 0,
                        value: 0,
                        productionDocuments: [],
                        lineCount: 0 };
                    }

                    acc[key].quantity += Number(item.quantity) || 0;
                    acc[key].value += Number(item.value) || 0;
                    acc[key].productionDocuments.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item));
                    acc[key].lineCount++;

                    return acc;
                  }, {}));


                  grouped.forEach(function (item) {
                    item.price = item.lineCount === 1 ? item.productionDocuments[0].price : null;
                    delete item.lineCount;
                  });

                  _this3.tableData = grouped;
                }

                _this3.totalItems = data.totalItems || 0;
                _this3.totalValue = data.totalValue || 0;
                _context.next = 35;
                break;

              case 30:
                _context.prev = 30;
                _context.t0 = _context['catch'](7);

                console.error('Eroare raport productie:', _context.t0);
                _this3.tableData = [];

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Nu s-a putut genera raportul de productie.',
                  icon: 'error'
                });

              case 35:
                _context.prev = 35;

                _this3.loading = false;
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.close();
                return _context.finish(35);

              case 39:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[7, 30, 35, 39]]);
      }))();
    },
    resetTable: function resetTable() {
      this.tableData = [];
    }
  }
});

/***/ }),

/***/ "6FLT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountCampaignPricingGrid_vue__ = __webpack_require__("8/OZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1bebfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountCampaignPricingGrid_vue__ = __webpack_require__("CTLp");
function injectStyle (ssrContext) {
  __webpack_require__("pLD+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f1bebfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountCampaignPricingGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1bebfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountCampaignPricingGrid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6G0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"report-filters"},[_c('div',{staticClass:"col-md-4 col-sm-6 col-xs-12 form-group pull-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clients.searchEmployee),expression:"clients.searchEmployee"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('reports.searchEmployee')},domProps:{"value":(_vm.clients.searchEmployee)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.clients, "searchEmployee", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6 col-xs-12 form-group pull-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clients.searchClient),expression:"clients.searchClient"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('reports.searchClient')},domProps:{"value":(_vm.clients.searchClient)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.clients, "searchClient", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left date-range"},[_c('el-date-picker',{staticClass:"mid",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.clients.valid),callback:function ($$v) {_vm.$set(_vm.clients, "valid", $$v)},expression:"clients.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":function($event){_vm.getClients(null)}}},[_c('i',{staticClass:"ti-search"})])])]),_vm._v(" "),_c('div',{staticClass:"card-content total-pagination pad-15"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.clientsTableData,"search-def":{ show: false },"total":_vm.totalClients,"pagination-props":_vm.paginationProps,"table-props":_vm.tableOptions},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"min-width":80,"prop":"name","label":"Operator"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(props.row.creater.firstname)+" "+_vm._s(props.row.creater.lastname)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"name","label":"Client"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(props.row.user.firstname)+" "+_vm._s(props.row.user.lastname)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"prop":"user.email","label":_vm.$t('reports.email')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"prop":"user.phone","label":_vm.$t('reports.phone')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"name","label":"Puncte Folosite"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"pad-lf-30"},[_vm._v(_vm._s(props.row.points_spent))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"prop":"orders_count","label":"Echivalent"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(parseFloat(props.row.points_to_money).toFixed(2))+" "+_vm._s(_vm.currency))])]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6GZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutomationCampaigns_vue__ = __webpack_require__("LiuW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e512c2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutomationCampaigns_vue__ = __webpack_require__("uIho");
function injectStyle (ssrContext) {
  __webpack_require__("34V7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutomationCampaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e512c2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutomationCampaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6H3B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProformaAdd_vue__ = __webpack_require__("eqLV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73692890_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProformaAdd_vue__ = __webpack_require__("Bktc");
function injectStyle (ssrContext) {
  __webpack_require__("0XE4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73692890"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProformaAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73692890_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProformaAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6HWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CategoryForm_vue__ = __webpack_require__("vCTZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);







var _components;






__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CategoryForm', __WEBPACK_IMPORTED_MODULE_7__CategoryForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      categoryModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onCategorySubmit: function onCategorySubmit(model, isValid) {
      this.categoryModel = model;
    }
  }
});

/***/ }),

/***/ "6HlB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Management_Nomenclator_ManagementClientsAdd_vue__ = __webpack_require__("QxJS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Management_ManagementSeriesAdd_vue__ = __webpack_require__("kgt7");















function getLocalDateTimeString() {
  var now = new Date();
  var year = now.getFullYear();
  var month = String(now.getMonth() + 1).padStart(2, '0');
  var day = String(now.getDate()).padStart(2, '0');
  var hours = String(now.getHours()).padStart(2, '0');
  var minutes = String(now.getMinutes()).padStart(2, '0');
  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementClientsAdd: __WEBPACK_IMPORTED_MODULE_10__Management_Nomenclator_ManagementClientsAdd_vue__["a" /* default */],
    ManagementSeriesAdd: __WEBPACK_IMPORTED_MODULE_11__Management_ManagementSeriesAdd_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      loadingProducts: false,
      selectedLocationId: '',
      isEdit: false,
      isInvoice: false,
      searchTerm: '',
      currentNumber: '',
      clientName: '',
      clientCUI: '',
      clientEmail: '',
      clientPhone: '',
      clientAddress: '',
      clientVATPayer: 'yes',
      clientLegalStatus: 'juridica_ro',
      issueDate: getLocalDateTimeString(),
      dueDate: getLocalDateTimeString(),
      seriesNumber: '',
      currency: 'RON',
      language: 'ro',
      productName: '',

      quantity: 0,
      priceRON: 0,
      vatRate: 0,
      includeVAT: 'no',
      vatNumber: null,
      isDisabled: false,
      clientSelected: null,
      selectedLocation: null,
      clientResults: [],
      searchResults: [],
      items: [],
      vats: [],
      gestiuneOptions: [],
      descarcaGestiunea: false,
      newItem: {
        gestiuneId: null,
        productName: '',
        unitMeasure: 'buc',
        quantity: 1,
        priceRON: null,
        vatRate: '19',
        includeVAT: 'no',
        type: '',
        code: ''
      },
      fetchClientsCalled: false,
      modelValidate: {
        clientCUI: { required: true },
        clientName: { required: true },
        clientPhone: { required: true },
        clientAddress: { required: true },
        productName: { required: true },
        unitMeasure: { required: true },
        quantity: { required: true },
        priceRON: { required: true },
        vatRate: { required: true },
        includeVAT: { required: true }
      },
      locations: [],
      extraFields: {
        intocmitDe: '',
        cnp: '',
        delegat: '',
        carteIdentitate: '',
        auto: '',
        agentVanzari: '',
        punctDeLucruClient: '',
        numarComandaBT13: '',
        numarContractBT12: '',
        referintaProiectBT11: '',
        identificatorCumparatorBT46: '',
        numarAvizReceptieBT15: '',
        referintaContabilaCumparatorBT19: '',
        dataLivrarii: '',
        dataIncasarii: '',
        notaInterna: ''
      },
      seriesOptions: [],
      gestiuniList: []
    };
  },

  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    today: function today() {
      var now = new Date();
      now.setSeconds(0, 0);
      return now.toISOString().slice(0, 16);
    },
    seriesOptionsWithAdd: function seriesOptionsWithAdd() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(this.seriesOptions), [{ id: 'add', nume: '➕ Adaugă serie' }]);
    },
    groupedLocations: function groupedLocations() {
      var groups = {};

      if (!this.locations || !this.locations.length) return [];

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocationId) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocationId;
      });
      return result;
    },
    totalFaraTva: function totalFaraTva() {
      return this.items.reduce(function (acc, item) {
        var qty = Number(item.quantity) || 0;
        var priceNoVAT = Number(item.priceRON) || 0;
        return acc + priceNoVAT * qty;
      }, 0);
    },
    totalTva: function totalTva() {
      return this.items.reduce(function (acc, item) {
        var qty = Number(item.quantity) || 0;
        var priceNoVAT = Number(item.priceRON) || 0;
        var vat = Number(item.vatRate) || 0;

        return acc + priceNoVAT * vat / 100 * qty;
      }, 0);
    },
    totalCorectie: function totalCorectie() {
      return 0;
    },
    totalFinal: function totalFinal() {
      return this.totalFaraTva + this.totalTva + this.totalCorectie;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    var invoiceId = this.route && this.route.params && this.route.params.id;
    var path = this.route && this.route.path;

    console.log('Route params:', this.route);

    if (invoiceId) {
      var _invoiceId$split = invoiceId.split('-'),
          _invoiceId$split2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_invoiceId$split, 2),
          series = _invoiceId$split2[0],
          invoiceNumber = _invoiceId$split2[1];

      if (!series || !invoiceNumber) {
        console.error('Invalid invoice ID format');
        return;
      }

      this.series = series;
      this.invoiceNumber = invoiceNumber;

      if (this.route.query.edit === 'true') {
        this.isEdit = true;
      } else {
        this.isInvoice = path.includes('proforma');
      }
    }
    this.fetchGestiuni();
    this.fetchLocation();
  },

  watch: {
    selectedLocationId: function selectedLocationId(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;
            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code);

              this.fetchVats(loc.true_id);
            }

            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    locations: function locations(newLocations) {
      if (newLocations && newLocations.length) {
        var invoiceId = this.route.params.id;
        if (invoiceId) {
          this.getInvoiceDetails(invoiceId);
        }
      }
    },
    clientCUI: function clientCUI(newCUI) {
      if (this.isInvoice || this.isEdit) {
        return;
      }

      if (this.fetchClientsCalled) return;

      if (newCUI.length >= 8) {
        this.fetchCompanyDetails(newCUI);
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveProforma();
        }
      });
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    parseDateTimeLocal: function parseDateTimeLocal(dateString) {
      if (!dateString) return '';
      var d = new Date(dateString);
      var yyyy = d.getFullYear();
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var dd = String(d.getDate()).padStart(2, '0');
      var hh = String(d.getHours()).padStart(2, '0');
      var min = String(d.getMinutes()).padStart(2, '0');
      return yyyy + '-' + mm + '-' + dd + 'T' + hh + ':' + min;
    },
    onClientSelect: function onClientSelect(client) {
      if (client && client.id === 'add') {
        this.openAddClientModal();
        this.clientSelected = null;
        this.clientName = '';
        this.clientCUI = '';
        this.clientEmail = '';
        this.clientPhone = '';
        this.clientAddress = '';
      } else if (client) {
        this.clientSelected = client;

        this.clientName = client.fullData.name || '';
        this.clientCUI = client.fullData.vatNumber || client.vatNumber || '';
        this.clientEmail = client.fullData.email || '';
        this.clientPhone = client.fullData.phone || '';
        this.clientAddress = client.fullData.address || '';
      } else {
        this.clientSelected = null;
        this.clientName = '';
        this.clientCUI = '';
        this.clientEmail = '';
        this.clientPhone = '';
        this.clientAddress = '';
      }
    },
    openAddClientModal: function openAddClientModal() {
      this.client = {
        companyName: '',
        abbreviation: '',
        CUI: '',
        email: '',
        registrationNumber: '',
        address: '',
        bank: '',
        IBAN: '',
        dueDays: null,
        id: null,
        _rev: null
      };
      this.$modal.show('addClientModal');
    },
    fetchClients: function fetchClients(query) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vatNumber, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.fetchClientsCalled = true;

                vatNumber = _this3.selectedLocation && _this3.selectedLocation.inv_fiscal_code;


                _this3.loading = true;
                _context.prev = 3;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/customers' + ('?name=' + encodeURIComponent(query)) + ('&externalCompanyId=' + _this3.companyID) + (vatNumber ? '&vatNumber=' + encodeURIComponent(vatNumber) : '');
                _context.next = 7;
                return fetch(url);

              case 7:
                response = _context.sent;
                _context.next = 10;
                return response.json();

              case 10:
                data = _context.sent;


                if (Array.isArray(data.customers)) {
                  _this3.clientResults = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(data.customers.map(function (client) {
                    return {
                      id: client._id,
                      nume: client.name,
                      vatNumber: client.vatNumber,
                      fullData: client
                    };
                  })), [{ id: 'add', nume: '➕ Adaugă client' }]);
                } else {
                  _this3.clientResults = [{ id: 'add', nume: '➕ Adaugă client' }];
                }
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](3);

                console.error('Error fetching clients:', _context.t0);
                _this3.clientResults = [{ id: 'add', nume: '➕ Adaugă client' }];

              case 18:
                _context.prev = 18;

                _this3.loading = false;
                return _context.finish(18);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[3, 14, 18, 21]]);
      }))();
    },
    fetchLocation: function fetchLocation() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dataToSend = {
                  company_id: _this4.companyID,
                  token: _this4.$session.get('token')
                };


                _this4.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this4.locations = response.data.locations;
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    getInvoiceDetails: function getInvoiceDetails(invoiceId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (invoiceId) {
                  _context4.next = 3;
                  break;
                }

                console.error('Missing invoice ID');
                return _context4.abrupt('return');

              case 3:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/getDocument/?tip=proforma&series=' + _this5.series + '&number=' + _this5.invoiceNumber + '&externalCompanyId=' + _this5.companyID;
                _context4.prev = 4;
                return _context4.delegateYield(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
                  var response, result, data, foundLocation, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, group, customer, clientObj;

                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return fetch(url, {
                            method: 'GET',
                            headers: {
                              'Content-Type': 'application/json'
                            }
                          });

                        case 2:
                          response = _context3.sent;

                          if (response.ok) {
                            _context3.next = 5;
                            break;
                          }

                          throw new Error('HTTP error! Status: ' + response.status);

                        case 5:
                          _context3.next = 7;
                          return response.json();

                        case 7:
                          result = _context3.sent;
                          data = result.documents && result.documents.length ? result.documents[0] : null;


                          _this5.parentSeries = data.series;
                          _this5.parentInvoiceNumber = data.invoiceNumber;

                          _this5.invoiceData = data;
                          _this5.items = data.items.map(function (item) {
                            var quantity = _this5.isStorno ? -1 * item.quantity : item.quantity;
                            var priceRON = item.price || 0;
                            var vatRate = item.tva != null ? item.tva : 19;
                            var includeVAT = vatRate > 0 ? 'yes' : 'no';

                            var priceFaraTVA = priceRON;
                            var totalFaraTVA = +(priceFaraTVA * quantity).toFixed(2);
                            var totalTVA = +(priceFaraTVA * quantity * vatRate / 100).toFixed(2);
                            var totalValoare = +(totalFaraTVA + totalTVA).toFixed(2);

                            return {
                              posId: item.posId,
                              productName: item.name || '',
                              type: item.type || 'N/A',
                              code: item.code || 'N/A',
                              unitMeasure: item.unitMeasure || 'BUC',
                              quantity: quantity,
                              priceRON: priceRON.toFixed(2),
                              vatRate: String(vatRate),
                              includeVAT: includeVAT,
                              gestiuneFrom: item.gestiune_from,
                              priceFaraTVA: priceFaraTVA.toFixed(2),
                              valoare: totalValoare.toFixed(2),
                              tva: totalTVA.toFixed(2)
                            };
                          });
                          _this5.currency = data.currency;
                          _this5.seriesNumber = data.series;
                          _this5.clientName = data.customer.name;
                          _this5.clientCUI = data.customer.cnp;
                          _this5.clientEmail = data.customer.email;
                          _this5.clientPhone = data.customer.phone;
                          _this5.clientAddress = data.customer.address;

                          _this5.seriesOptions = [{
                            series: data.series,
                            currentNumber: data.invoiceNumber
                          }];
                          _this5.seriesNumber = data.series;
                          _this5.currentNumber = data.invoiceNumber;

                          if (data.extraFields) {
                            _this5.extraFields = data.extraFields.reduce(function (acc, field) {
                              acc[field.key] = field.value;
                              return acc;
                            }, {});
                          }

                          _this5.issueDate = _this5.parseDateTimeLocal(data.issueDate || data.date);
                          _this5.dueDate = _this5.parseDateTimeLocal(data.dueDate || data.date);

                          if (!(data.externalLocationId && _this5.locations && _this5.locations.length)) {
                            _context3.next = 56;
                            break;
                          }

                          foundLocation = null;
                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _iteratorError2 = undefined;
                          _context3.prev = 31;
                          _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(_this5.groupedLocations);

                        case 33:
                          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                            _context3.next = 41;
                            break;
                          }

                          group = _step2.value;

                          foundLocation = group.locations.find(function (loc) {
                            return data.externalLocationId && loc.true_id === data.externalLocationId || data.vatNumber && loc.inv_fiscal_code === data.vatNumber;
                          });

                          if (!foundLocation) {
                            _context3.next = 38;
                            break;
                          }

                          return _context3.abrupt('break', 41);

                        case 38:
                          _iteratorNormalCompletion2 = true;
                          _context3.next = 33;
                          break;

                        case 41:
                          _context3.next = 47;
                          break;

                        case 43:
                          _context3.prev = 43;
                          _context3.t0 = _context3['catch'](31);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context3.t0;

                        case 47:
                          _context3.prev = 47;
                          _context3.prev = 48;

                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }

                        case 50:
                          _context3.prev = 50;

                          if (!_didIteratorError2) {
                            _context3.next = 53;
                            break;
                          }

                          throw _iteratorError2;

                        case 53:
                          return _context3.finish(50);

                        case 54:
                          return _context3.finish(47);

                        case 55:
                          if (foundLocation) {
                            _this5.selectedLocationId = foundLocation.true_id;
                          }

                        case 56:

                          if (data.customer) {
                            console.log('Customer data found:', data.customer);
                            customer = data.customer;
                            clientObj = {
                              id: 'temp-' + customer.cnp,
                              nume: customer.name,
                              vatNumber: customer.cnp,
                              fullData: customer
                            };


                            _this5.clientSelected = clientObj;
                            console.log('Selected client from invoice:', clientObj);
                            _this5.onClientSelect(clientObj);
                          }

                        case 57:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this5, [[31, 43, 47, 55], [48,, 50, 54]]);
                })(), 't0', 6);

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t1 = _context4['catch'](4);

                console.error('Error fetching invoice details:', _context4.t1);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[4, 8]]);
      }))();
    },
    fetchCompanyDetails: function fetchCompanyDetails(cui) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var company;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return _this6.fetchAnafCompanyByCui(cui);

              case 3:
                company = _context5.sent;

                _this6.applyAnafCompanyToFields(company, 'simpleClient');
                _context5.next = 10;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](0);

                console.error('Error fetching company details:', _context5.t0);

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 7]]);
      }))();
    },
    searchOrder: function searchOrder() {
      var _this7 = this;

      var id = this.searchTerm ? parseInt(this.searchTerm.trim(), 10) : null;
      var data = {
        token: this.$session.get('token'),
        company_id: this.companyID,
        id: id
      };

      if (!id) {
        __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
          type: 'warning',
          title: 'Atenție',
          text: 'Te rog introdu un ID de comandă.'
        });
        return;
      }

      __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
        title: 'Se caută comanda...',
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        content: {
          element: 'div',
          attributes: {
            innerHTML: '<div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>'
          }
        }
      });

      this.apiRequest('/get-products-from-order/', 'GET', data, function (response) {
        __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.close();

        console.log(response);

        if (response.status === true && response.data && Array.isArray(response.data.items) && response.data.items.length > 0) {
          _this7.isDisabled = true;

          var firstGestiune = _this7.gestiuniList.length ? _this7.gestiuniList[0].name : '';
          _this7.receipt_number = response.data.receipt_number || null;

          _this7.items = response.data.items.map(function (item) {
            var rawQuantity = parseFloat(item.quantity);
            var rawPrice = parseFloat(item.price);
            var quantity = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(rawQuantity) ? rawQuantity : 1;
            var price = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_finite___default()(rawPrice) ? rawPrice : 0;

            if (price < 0) {
              if (quantity > 0) quantity = -quantity;else if (quantity === 0) quantity = -1;
              price = Math.abs(price);
            }
            var vatRate = item.vat != null ? item.vat : '';
            var includeVAT = item.includeVAT === 'no' ? 'no' : 'yes';

            var priceFaraTVA = 0;
            var tvaUnit = 0;
            var priceCuTVA = 0;

            if (includeVAT === 'yes') {
              priceCuTVA = price;
              priceFaraTVA = price / (1 + vatRate / 100);
              tvaUnit = price - priceFaraTVA;
            } else {
              priceFaraTVA = price;
              tvaUnit = price * (vatRate / 100);
              priceCuTVA = price + tvaUnit;
            }

            var totalFaraTVA = priceFaraTVA * quantity;
            var totalTVA = tvaUnit * quantity;

            return {
              productName: item.name || '',
              type: item.type || 'N/A',
              code: item.product_code || 'N/A',
              unitMeasure: item.unit || 'BUC',
              quantity: quantity,
              priceRON: priceFaraTVA.toFixed(2),
              priceCuTVA: priceCuTVA.toFixed(2),
              vatRate: String(vatRate),
              includeVAT: includeVAT,
              gestiune: firstGestiune,
              priceFaraTVA: priceFaraTVA.toFixed(2),
              valoare: (totalFaraTVA + totalTVA).toFixed(2),
              tva: totalTVA.toFixed(2)
            };
          });

          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
            icon: 'success',
            title: 'Comandă găsită',
            text: 'Am preluat ' + _this7.items.length + ' articole din comand\u0103.'
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
            icon: 'error',
            title: 'Eroare',
            text: 'Comanda nu a fost găsită.'
          });
        }
      });
    },
    calculateItemTotals: function calculateItemTotals(item) {
      var quantity = Number(item.quantity);
      var priceRON = Number(item.priceRON);
      var vatRate = Number(item.vatRate);
      var includeVAT = item.includeVAT === 'yes';

      console.log('Calculating totals for item:', vatRate);
      console.log('Include VAT:', includeVAT);

      var priceFaraTVA = void 0,
          tvaUnit = void 0,
          totalFaraTVA = void 0,
          totalTVA = void 0;

      if (includeVAT) {
        priceFaraTVA = priceRON / (1 + vatRate / 100);
        tvaUnit = priceRON - priceFaraTVA;
      } else {
        priceFaraTVA = priceRON;
        tvaUnit = priceFaraTVA * vatRate / 100;
      }

      totalFaraTVA = priceFaraTVA * quantity;
      totalTVA = tvaUnit * quantity;
      return {
        priceFaraTVA: priceFaraTVA,
        total: totalFaraTVA + totalTVA,
        tva: totalTVA };
    },
    addItem: function addItem() {
      if (this.newItem.gestiuneId && this.newItem.productName && this.newItem.unitMeasure && this.newItem.quantity > 0 && this.newItem.priceRON > 0 && this.newItem.type && this.newItem.code && this.newItem.vatRate !== null && this.newItem.includeVAT !== '') {
        var totals = this.calculateItemTotals(this.newItem);

        console.log(totals);
        var newItemWithTotals = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.newItem, {
          priceRON: totals.priceFaraTVA.toFixed(2),
          valoare: totals.total.toFixed(2),
          tva: totals.tva.toFixed(2),
          gestiuneFrom: this.newItem.gestiuneId
        });
        this.items.push(newItemWithTotals);
        this.resetNewItem();
      } else {}
    },
    getGestiuneName: function getGestiuneName(gestiuneId) {
      var gestiune = this.gestiuneOptions.find(function (g) {
        return g.id === gestiuneId;
      });
      return gestiune ? gestiune.name : 'N/A';
    },
    removeItem: function removeItem(index) {
      this.items.splice(index, 1);
    },
    resetNewItem: function resetNewItem() {
      this.newItem = {
        gestiuneId: null,
        productName: '',
        unitMeasure: '',
        quantity: null,
        priceRON: null,
        type: '',
        code: '',
        vatRate: '',
        includeVAT: 'no'
      };
    },
    getSeries: function getSeries(vatNumber) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var tipSerie, response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                tipSerie = _this8.route.query.edit === 'true' ? 'proforma' : _this8.route.params.id ? 'invoice' : 'proforma';
                _context6.prev = 1;
                _context6.next = 4;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this8.companyID,
                    vatNumber: vatNumber,
                    tip: tipSerie
                  })
                });

              case 4:
                response = _context6.sent;

                if (response.ok) {
                  _context6.next = 7;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 7:
                _context6.next = 9;
                return response.json();

              case 9:
                data = _context6.sent;

                console.log('Serii primite:', data.series);

                if (Array.isArray(data.series) && data.series.length > 0) {
                  _this8.seriesOptions = data.series.map(function (serie) {
                    return {
                      series: serie.series,
                      currentNumber: serie.currentNumber
                    };
                  });

                  _this8.seriesNumber = _this8.seriesOptions[0].series;
                  _this8.currentNumber = _this8.seriesOptions[0].currentNumber;
                } else {
                  console.warn('Nu există serii disponibile pentru acest cod fiscal.');

                  _this8.seriesOptions = [];
                  _this8.seriesNumber = '';
                  _this8.currentNumber = '';
                }
                _context6.next = 20;
                break;

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6['catch'](1);

                console.error('Error fetching series:', _context6.t0);

                _this8.seriesOptions = [];
                _this8.seriesNumber = '';
                _this8.currentNumber = '';

              case 20:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[1, 14]]);
      }))();
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this9.companyID);

              case 3:
                response = _context7.sent;

                if (response.ok) {
                  _context7.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context7.next = 8;
                return response.json();

              case 8:
                data = _context7.sent;

                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this9.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      externalLocationId: gest.externalLocationId || ''
                    };
                  });
                } else {
                  _this9.$message.error('Nu s-a primit un array valid de la server.');
                }
                _context7.next = 16;
                break;

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7['catch'](0);

                _this9.$message.error('Request failed: ' + _context7.t0.message);
                console.error('Error fetching management data:', _context7.t0);

              case 16:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[0, 12]]);
      }))();
    },
    updateNumber: function updateNumber() {
      var _this10 = this;

      if (this.seriesNumber === 'add') {
        this.openSeriesModal();
        return;
      }

      var selectedSeries = this.seriesOptions.find(function (series) {
        return series.series === _this10.seriesNumber;
      });

      if (selectedSeries) {
        this.currentNumber = selectedSeries.currentNumber;
      } else {
        this.currentNumber = '';
      }
    },
    openSeriesModal: function openSeriesModal() {
      this.$modal.show('addSeriesModal');
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(!searchTerm || searchTerm.length < 2)) {
                  _context8.next = 3;
                  break;
                }

                _this11.searchResults = [];
                return _context8.abrupt('return');

              case 3:

                _this11.loadingProducts = true;
                _context8.prev = 4;
                _context8.next = 7;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/products?externalCompanyId=' + _this11.companyID + '&name=' + searchTerm);

              case 7:
                response = _context8.sent;
                _context8.next = 10;
                return response.json();

              case 10:
                data = _context8.sent;


                if (Array.isArray(data.products)) {
                  _this11.searchResults = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(data.products));
                }
                _context8.next = 17;
                break;

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8['catch'](4);

                console.error('Error fetching products:', _context8.t0);

              case 17:
                _context8.prev = 17;

                _this11.loadingProducts = false;
                return _context8.finish(17);

              case 20:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[4, 14, 17, 20]]);
      }))();
    },
    onProductSelected: function onProductSelected(selectedProduct) {
      if (typeof selectedProduct === 'string' || !selectedProduct) {
        this.resetNewItem();
        return;
      }

      this.newItem.posId = selectedProduct.posId || selectedProduct._id;
      this.newItem.code = selectedProduct.product_code || '';
      this.newItem.type = selectedProduct.categorie || '';
      this.newItem.unitMeasure = selectedProduct.um;
      this.newItem.quantity = selectedProduct.quantity || 1;
      this.newItem.priceRON = selectedProduct.pret_vanzare && selectedProduct.pret_vanzare.length > 0 && selectedProduct.pret_vanzare[0].price || '';
      this.newItem.vatRate = selectedProduct.vat_percent != null ? String(selectedProduct.vat_percent) : '';
      this.newItem.includeVAT = selectedProduct.is_with_vat ? 'yes' : 'no';
    },
    saveProforma: function saveProforma() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var invoiceData, response, errorData, errorMessage, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                console.log(_this12.clientName, _this12.clientCUI, _this12.clientAddress);

                if (!(!_this12.seriesNumber || !_this12.currency || !_this12.clientName || !_this12.clientCUI || !_this12.clientAddress)) {
                  _context9.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: 'Please complete all mandatory fields before saving the invoice.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context9.abrupt('return');

              case 4:
                if (!_this12.items.some(function (item) {
                  return !item.productName || !item.unitMeasure || !item.quantity || !item.priceRON || !item.vatRate;
                })) {
                  _context9.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: 'Please complete all product details (name, unit measure, quantity, price, VAT rate).',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context9.abrupt('return');

              case 7:
                invoiceData = {
                  tip: 'proforma',
                  dueDate: _this12.dueDate,
                  issueDate: _this12.issueDate,
                  externalCompanyId: _this12.companyID,
                  externalLocationId: _this12.selectedLocation.true_id,
                  vatNumber: _this12.selectedLocation.inv_fiscal_code,
                  items: _this12.items.map(function (item) {
                    return {
                      posId: item.posId,
                      name: item.productName.name || item.productName,
                      type: item.type,
                      code: item.code,
                      unitMeasure: item.unitMeasure,
                      quantity: item.quantity,
                      price: parseFloat(item.priceRON),
                      tva: item.vatRate,
                      gestiune_from: item.gestiuneId || item.gestiuneFrom
                    };
                  }),
                  currency: _this12.currency,
                  series: _this12.seriesNumber,
                  customer: {
                    name: _this12.clientName,
                    cnp: _this12.clientCUI,
                    email: _this12.clientEmail,
                    phone: _this12.clientPhone,
                    address: _this12.clientAddress
                  },
                  extraFields: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(_this12.extraFields).map(function (_ref3) {
                    var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                        key = _ref4[0],
                        value = _ref4[1];

                    return { key: key, value: value };
                  })
                };


                if (_this12.isEdit && _this12.invoiceData && _this12.invoiceData.invoiceNumber) {
                  invoiceData.number = _this12.invoiceData.invoiceNumber;
                }

                _context9.prev = 9;
                _context9.next = 12;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/document', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(invoiceData) });

              case 12:
                response = _context9.sent;

                if (response.ok) {
                  _context9.next = 20;
                  break;
                }

                _context9.next = 16;
                return response.json();

              case 16:
                errorData = _context9.sent;
                errorMessage = errorData.error || 'Error saving proforma';


                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: errorMessage,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

                throw new Error('Error saving proforma');

              case 20:
                _context9.next = 22;
                return response.json();

              case 22:
                data = _context9.sent;

                console.log('Proforma saved successfully:', data);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Success',
                  text: 'Proforma saved successfully.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this12.$bus.$emit('refresh');
                _this12.$bus.$emit('close-modal');
                _context9.next = 33;
                break;

              case 29:
                _context9.prev = 29;
                _context9.t0 = _context9['catch'](9);

                console.error('Error saving proforma:', _context9.t0);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: _context9.t0.message || 'An unexpected error occurred.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 33:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12, [[9, 29]]);
      }))();
    },
    getClientTypeCode: function getClientTypeCode(status) {
      switch (status) {
        case 'juridica_ro':
          return 1;
        case 'fizica':
          return 2;
        case 'juridica_vies':
          return 3;
        default:
          return 1;}
    },
    saveInvoice: function saveInvoice() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var invoiceData, response, errorData, errorMessage, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(!_this13.seriesNumber || !_this13.currency || !_this13.clientName || !_this13.clientCUI || !_this13.clientAddress)) {
                  _context10.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: 'Please complete all mandatory fields before saving the invoice.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context10.abrupt('return');

              case 3:
                invoiceData = {
                  tip: 'invoice',
                  externalCompanyId: _this13.companyID,
                  externalLocationId: _this13.selectedLocationId,
                  vatNumber: _this13.selectedLocation.inv_fiscal_code,
                  dueDate: _this13.dueDate,
                  issueDate: _this13.issueDate,
                  items: _this13.items.map(function (item) {
                    return {
                      posId: item.posId,
                      name: item.productName.name || item.productName,
                      type: item.type,
                      code: item.code,
                      unitMeasure: item.unitMeasure,
                      quantity: item.quantity,
                      price: parseFloat(item.priceRON),
                      tva: item.vatRate,
                      gestiune_from: item.gestiuneId || item.gestiuneFrom
                    };
                  }),
                  currency: _this13.currency,
                  series: _this13.seriesNumber,
                  customer: {
                    name: _this13.clientName,
                    cnp: _this13.clientCUI,
                    email: _this13.clientEmail,
                    phone: _this13.clientPhone,
                    address: _this13.clientAddress
                  },
                  extraFields: [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(_this13.extraFields).map(function (_ref5) {
                    var _ref6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                        key = _ref6[0],
                        value = _ref6[1];

                    return { key: key, value: value };
                  })), [{ key: 'proformaNumber', value: _this13.series + '-' + _this13.invoiceNumber }])
                };


                if ((_this13.isInvoice || _this13.isEdit) && _this13.invoiceData && _this13.invoiceData.invoiceNumber) {
                  invoiceData.invoiceNumber = _this13.invoiceData.invoiceNumber;
                }

                _context10.prev = 5;
                _context10.next = 8;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/document', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(invoiceData)
                });

              case 8:
                response = _context10.sent;

                if (response.ok) {
                  _context10.next = 16;
                  break;
                }

                _context10.next = 12;
                return response.json();

              case 12:
                errorData = _context10.sent;
                errorMessage = errorData.error || 'Error saving invoice';


                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: errorMessage,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

                throw new Error('Error saving invoice');

              case 16:
                _context10.next = 18;
                return response.json();

              case 18:
                data = _context10.sent;

                console.log('Invoice saved successfully:', data);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Success',
                  text: 'Invoice saved successfully.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this13.$bus.$emit('refresh');
                _this13.$bus.$emit('close-modal');
                _context10.next = 29;
                break;

              case 25:
                _context10.prev = 25;
                _context10.t0 = _context10['catch'](5);

                console.error('Error saving invoice:', _context10.t0);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: _context10.t0.message || 'An unexpected error occurred.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 29:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this13, [[5, 25]]);
      }))();
    }
  }
});

/***/ }),

/***/ "6Ib2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6IqH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6KiT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientPoints_vue__ = __webpack_require__("fVLV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f901d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientPoints_vue__ = __webpack_require__("0i5z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientPoints_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f901d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientPoints_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Odg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementInventoryForm_vue__ = __webpack_require__("hphe");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneInventarForm', __WEBPACK_IMPORTED_MODULE_7__ManagementInventoryForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "6OhQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6R02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsletterSidebar_vue__ = __webpack_require__("pLVm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd435c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsletterSidebar_vue__ = __webpack_require__("HthW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsletterSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd435c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsletterSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6R4L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_json_excel__ = __webpack_require__("fXhN");






var _components;










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_12_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isSalesProducts: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isSalesProducts: function isSalesProducts() {
      if (this.isSalesProducts) {
        this.getPaymentMethods();
        this.getOrders();
        this.verifyUserLocations();
        this.verifyUserMethods();
      }
    }
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      productsTableData: [],
      productsTableDataTotals: {},
      paymentMethods: [],
      receiptOptions: [{ label: this.$t('reports.withoutReceipt'), value: 1 }, { label: this.$t('reports.withReceipt'), value: 2 }],
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_method: '',
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_9_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_9_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      ordersTableData: {},
      totals: {
        total: 0,
        totalCash: 0,
        totalVirament: 0,
        totalOnline: 0,
        totalProtocol: 0,
        totalCard: 0,
        totalPOS: 0,
        totalCARDPOS: 0,
        totalTips: 0,
        totalDiscount: 0,
        totalTax: 0,
        totalShipping: 0,
        avarageOrderValue: 0
      },
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      hasRceipt: null,
      noData: false
    };
  },

  methods: {
    getPaymentMethods: function getPaymentMethods() {
      var _this = this;

      var sessionData = this.$session.get('selectedCompanyData');

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };

        this.apiRequest('/orders/get-payment-methods', 'GET', data, function (response) {
          if (response.status && response.data.length) {
            var result = response.data.map(function (item) {
              return { id: item || 'unpaid', name: _this.$t('paymentTypes.' + item) };
            });
            sessionData['payment_methods'] = response.data;
            _this.$session.set('selectedCompanyData', sessionData);

            __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(_this, 'paymentMethods', result);
          }
        });
      } else {
        var result = sessionData['payment_methods'].map(function (item) {
          return { id: item || 'unpaid', name: _this.$t('paymentTypes.' + item) };
        });
        __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(this, 'paymentMethods', result);
      }
    },
    summaryTotal: function summaryTotal() {
      var result = {
        revenue: 0,
        quantity: 0,
        discount: 0,
        vat: 0
      };

      this.productsTableData.forEach(function (item) {
        result.revenue += Number(item.total_revenue || 0);
        result.quantity += Number(item.quantity_sold || 0);
        result.discount += Number(item.discount || 0);
        result.vat += Number(item.vat || 0);
      });

      return result;
    },
    startDownload: function startDownload() {
      this.loading = true;
    },
    finishDownload: function finishDownload() {
      this.loading = false;
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this2 = this;

      if (!this.isSalesProducts) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };
      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }
      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      var hasReceiptValue = this.hasRceipt && this.hasRceipt.value || null;

      this.apiRequest('/reports/v2/sales-products' + '?page=' + page + '&perPage=' + pageSize + '&has_receipt=' + hasReceiptValue, 'GET', data, function (response) {
        if (response.status) {
          _this2.productsTableData = response.data.order_part_items;
          _this2.productsTableDataTotals = response.data.totals;
          _this2.totalOrders = response.pagination.total;
          _this2.paginationProps.currentPage = response.pagination.page;
          _this2.paginationProps.pageSize = response.pagination.perPage;
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
        }

        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    exportData: function exportData() {
      var _this3 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        top_category_id: this.topCategoryId,
        order_id: this.orderId,
        payment_method: this.selected_payment_method,
        perPage: this.paginationProps.pageSize,
        page: this.paginationProps.currentPage,
        has_receipt: this.hasRceipt && this.hasRceipt.value || null
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/sales-products-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error');
        }
        _this3.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "6UZX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6VuL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GiftCardForm',
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      baseId: this.route.params.id,
      baseData: {},
      cards: [],
      dateRange: [],
      loading: true,
      filters: {
        status: 'all',
        payment: 'all'
      },
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 50,
        total: 0,
        from: 0,
        to: 0
      }
    };
  },


  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  watch: {
    dateRange: function dateRange(val) {
      if (val) {
        this.baseData.date_from = val[0] || null;
        this.baseData.date_to = val[1] || null;
      }
    }
  },

  computed: {
    typeClass: function typeClass() {
      return this.baseData.type === 1 ? 'online' : 'offline';
    },
    paginationRange: function paginationRange() {
      var current = this.pagination.current_page;
      var last = this.pagination.last_page;
      var delta = 2;
      var range = [];

      for (var i = Math.max(1, current - delta); i <= Math.min(last, current + delta); i++) {
        range.push(i);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.fetchBaseData(1);
  },


  methods: {
    fetchBaseData: function fetchBaseData() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.loading = true;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: page,
        per_page: this.pagination.per_page,
        status_filter: this.filters.status,
        payment_filter: this.filters.payment
      };

      this.apiRequest('/gift-cards/' + this.baseId, 'GET', data, function (response) {
        if (response.status) {
          _this.baseData = response.data.base;

          var giftCardsData = response.data.gift_cards;
          _this.cards = giftCardsData.data || [];

          if (_this.baseData.date_from && _this.baseData.date_to) {
            _this.dateRange = [_this.baseData.date_from, _this.baseData.date_to];
          }

          _this.pagination = {
            current_page: giftCardsData.current_page || 1,
            last_page: giftCardsData.last_page || 1,
            per_page: giftCardsData.per_page || 50,
            total: giftCardsData.total || 0,
            from: giftCardsData.from || 0,
            to: giftCardsData.to || 0
          };
        } else {
          _this.$message.error(_this.$t('giftCard.updateError'));
        }
        _this.loading = false;
      });
    },
    changePage: function changePage(page) {
      if (page < 1 || page > this.pagination.last_page) return;
      this.fetchBaseData(page);
    },
    handleDelete: function handleDelete() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
                  title: _this2.$t('giftCard.confirmDeleteTitle'),
                  text: _this2.$t('giftCard.confirmDeleteText'),
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonText: _this2.$t('giftCard.yesButton'),
                  cancelButtonText: _this2.$t('giftCard.noButton'),
                  closeOnConfirm: false,
                  closeOnCancel: true
                }, function (isConfirm) {
                  if (!isConfirm) {
                    return;
                  }
                });

              case 2:

                _this2.loading = true;

                data = {
                  token: _this2.$session.get('token'),
                  company_id: _this2.$session.get('selectedCompany')
                };


                _this2.apiRequest('/gift-cards/' + _this2.baseId, 'DELETE', data, function (response) {
                  if (response.status) {
                    __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
                      type: 'success',
                      title: _this2.$t('giftCard.deleteSuccess'),
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {});
                    _this2.goBack();
                  } else {
                    __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
                      type: 'error',
                      title: _this2.$t('giftCard.errorTitle'),
                      text: response.message || _this2.$t('giftCard.deleteError')
                    });
                  }
                  _this2.loading = false;
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    formatCurrency: function formatCurrency(value) {
      return new Intl.NumberFormat('ro-RO', {
        style: 'currency',
        currency: 'RON'
      }).format(value);
    },
    formatDate: function formatDate(date) {
      if (!date) return this.$t('giftCard.notAvailable');
      return new Date(date).toLocaleDateString('ro-RO');
    },
    copyLink: function copyLink(link) {
      navigator.clipboard.writeText(link);
      this.$message.success(this.$t('giftCard.linkCopied'));
    },
    exportCards: function exportCards() {
      var _this3 = this;

      var headers = ['ID', 'Qr', 'Qr Img Link', 'Transfer Link', 'Status', 'Payment', 'Active', 'Assigned To', 'Value', 'Created'];
      var rows = this.cards.map(function (c) {
        return [c.id, c.qr_code_hash, c.qr_code, c.transfer_link, c.used ? _this3.$t('giftCard.used') : _this3.$t('giftCard.unused'), c.payed ? _this3.$t('giftCard.payed') : _this3.$t('giftCard.unpayed'), c.active ? _this3.$t('giftCard.yes') : _this3.$t('giftCard.no'), c.user_id ? _this3.$t('giftCard.user') + ' ' + c.user_id : _this3.$t('giftCard.notAssigned'), c.current_value, c.created_at];
      });

      var csv = headers.join(',') + '\n';
      rows.forEach(function (row) {
        csv += row.join(',') + '\n';
      });

      var blob = new Blob([csv], { type: 'text/csv' });
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = 'gift-cards-base-' + this.baseId + '-page-' + this.pagination.current_page + '.csv';
      a.click();
    },
    viewCard: function viewCard(card) {
      this.$modal.show('cardDetailModal', { card: card });
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    validate: function validate() {
      this.handleSave();
    },
    handleSave: function handleSave() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.loading = true;

                data = {
                  token: _this4.$session.get('token'),
                  company_id: _this4.$session.get('selectedCompany'),
                  active: _this4.baseData.active ? 1 : 0,
                  date_from: _this4.baseData.date_from,
                  date_to: _this4.baseData.date_to
                };


                _this4.apiRequest('/gift-cards/' + _this4.baseId, 'PUT', data, function (response) {
                  if (response.status) {
                    __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
                      type: 'success',
                      title: _this4.$t('giftCard.updateSuccess'),
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {
                      _this4.$bus.$emit('refresh');
                      _this4.$bus.$emit('close-modal');
                    });
                  } else {
                    __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
                      type: 'error',
                      title: _this4.$t('giftCard.errorTitle'),
                      text: response.message || _this4.$t('giftCard.updateError')
                    });
                  }

                  _this4.loading = false;
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }
});

/***/ }),

/***/ "6X+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__ = __webpack_require__("SkgD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b546340_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__ = __webpack_require__("wvZt");
function injectStyle (ssrContext) {
  __webpack_require__("oVxW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b546340_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Yrw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6c7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r4_vue__ = __webpack_require__("L1Dm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_334959b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r4_vue__ = __webpack_require__("7qxb");
function injectStyle (ssrContext) {
  __webpack_require__("5thJ")
  __webpack_require__("qm2r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-334959b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_334959b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6cn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"challenge-users-report"},[(_vm.loading)?_c('div',{staticClass:"challenge-report-fullscreen-loader"},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('h4',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.challengeTitle))])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('el-radio-group',{staticStyle:{"margin-bottom":"15px"},attrs:{"size":"small"},on:{"change":_vm.loadUsers},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}},[_c('el-radio-button',{attrs:{"label":""}},[_vm._v(_vm._s(_vm.$t('challengeCampaigns.allUsers')))]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"IN_PROGRESS"}},[_vm._v(_vm._s(_vm.$t('challengeCampaigns.inProgressUsers')))]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"COMPLETED"}},[_vm._v(_vm._s(_vm.$t('challengeCampaigns.completedUsers')))])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.onRowClick}},[_c('el-table-column',{attrs:{"label":_vm.$t('challengeCampaigns.user'),"min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n            "+_vm._s([p.row.firstname, p.row.lastname].filter(Boolean).join(' ') || p.row.email || ('#' + p.row.user_id))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('challengeCampaigns.progress'),"width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v(_vm._s(p.row.progress)+" / "+_vm._s(p.row.target)+" ("+_vm._s(p.row.progress_percentage)+"%)")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('orders.status'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v(_vm._s(_vm.formatChallengeStatus(p.row.status)))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('challengeCampaigns.startedAt'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v(_vm._s(_vm.formatDateTime(p.row.started_at) || '—'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('challengeCampaigns.lastProgressAt'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v(_vm._s(_vm.formatDateTime(p.row.last_progress_at) || '—'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('challengeCampaigns.completedAt'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v(_vm._s(_vm.formatDateTime(p.row.completed_at) || '—'))]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6dpF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"20","prop":"id","label":"ID"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.id || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"40","prop":"name","label":_vm.$t('kds.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.name || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"20","prop":"is_offline","label":"Offline"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.is_offline)?[_c('div',{staticClass:"cell-center",staticStyle:{"color":"green"}},[_vm._v(_vm._s(_vm.$t('general.yes')))])]:[_c('div',{staticClass:"cell-center",staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.$t('general.no')))])]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"50","prop":"location_name","label":_vm.$t('orders.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.locations.length)?[_c('span',[_vm._l((props.row.locations),function(location){return [_vm._v("\n                      "+_vm._s(location.name)+"\n                    ")]})],2)]:[_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(_vm.$t('general.all')))])]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"170","prop":"sections","label":_vm.$t('kds.section')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.getRowSectionNames(props.row).length)?_c('el-tooltip',{attrs:{"placement":"top","effect":"dark","open-delay":200}},[_c('div',{staticClass:"sections-tooltip",attrs:{"slot":"content"},slot:"content"},_vm._l((_vm.getRowSectionNames(props.row)),function(name,index){return _c('div',{key:index},[_vm._v("\n                      "+_vm._s(name)+"\n                    ")])})),_vm._v(" "),_c('div',{staticClass:"sections-cell"},[_c('span',{staticClass:"sections-name"},[_vm._v(_vm._s(_vm.getVisibleSectionNames(props.row)))]),_vm._v(" "),(_vm.getHiddenSectionCount(props.row))?_c('span',{staticClass:"sections-more"},[_vm._v("\n                      +"+_vm._s(_vm.getHiddenSectionCount(props.row))+"\n                    ")]):_vm._e()])]):_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(_vm.$t('general.all')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":320,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.send')},on:{"click":function($event){_vm.handleDelete(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")])]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6f3K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6f9o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs",attrs:{"direction":"vertical","value":"Description"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.app')}},[_c('keep-alive',[(_vm.isApp && !_vm.company.use_app)?_c('module-locked',{attrs:{"module":"app","icon":"📱","title":"Modul APP","message":"Acest modul nu este activat pentru compania ta.","hint":"Contactează administratorul pentru activare.","action-text":"Contact"},on:{"action":_vm.openSupport}}):_vm._e(),_vm._v(" "),(_vm.isApp && _vm.company.use_app)?_c('app-form',{attrs:{"isApp":_vm.isApp,"modeldata":_vm.model,"defaultData":_vm.defaultData}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left addNewOrder",attrs:{"title":_vm.$t('settingsPages.companyWeb')}},[_c('keep-alive',[(_vm.isCompanyWeb && !_vm.company.use_website)?_c('module-locked',{attrs:{"module":"website","icon":"🌐","title":_vm.$t('general.modules_website_title'),"message":_vm.$t('general.modules_website_message'),"hint":_vm.$t('general.modules_website_hint')}}):_vm._e(),_vm._v(" "),(_vm.isCompanyWeb && _vm.company.use_website)?_c('company-web-form',{attrs:{"isCompanyWeb":_vm.isCompanyWeb,"modeldata":_vm.websiteData}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.infoPagesCustom')}},[_c('keep-alive',[(_vm.isInfoPagesCustom)?_c('custom-info-pages',{attrs:{"isInfoPagesCustom":_vm.isInfoPagesCustom}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.infoPages')}},[_c('keep-alive',[(_vm.isInfoPages)?_c('info-pages',{attrs:{"isInfoPages":_vm.isInfoPages}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.homepageSections')}},[_c('keep-alive',[(_vm.isHomepageSections)?_c('homepage-sections'):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.interactiveTour')}},[_c('keep-alive',[(_vm.isInteractiveTour)?_c('interactive-tour'):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.blog')}},[_c('keep-alive',[(_vm.isBlog)?_c('blog'):_vm._e()],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6gb4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosEdit_vue__ = __webpack_require__("fluv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793cbeb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosEdit_vue__ = __webpack_require__("W5NV");
function injectStyle (ssrContext) {
  __webpack_require__("yJS/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793cbeb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6i1p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6jsq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GiftCardForm_vue__ = __webpack_require__("6VuL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_862c1168_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GiftCardForm_vue__ = __webpack_require__("64vS");
function injectStyle (ssrContext) {
  __webpack_require__("XCia")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-862c1168"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GiftCardForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_862c1168_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GiftCardForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6knb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchTabs_vue__ = __webpack_require__("OPEv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c8bea7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchTabs_vue__ = __webpack_require__("P5VO");
function injectStyle (ssrContext) {
  __webpack_require__("iuHn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c8bea7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c8bea7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6nV6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6nWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 264.8 284.8"},attrs:{"version":"1.1","id":"t3","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 264.8 284.8","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t3_1_","y":"85.7","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t3_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t3_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t3_3_","d":"M0,190.1V94.7c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H9c-2.4,0-4.7-0.9-6.4-2.6S0,192.5,0,190.1z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t3_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t3_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,199.1V85.7h113.4v113.4H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t3_5_","x":"85.7","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t3_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t3_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t3_7_","d":"M94.7,0h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H94.7\n            c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4S92.3,0,94.7,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t3_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t3_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M85.7,0h113.4v113.4H85.7V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t3_9_","x":"85.7","y":"171.4","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t3_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t3_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t3_11_","d":"M94.7,171.4h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6\n            H94.7c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4C90,172.4,92.3,171.4,94.7,171.4z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t3_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t3_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M85.7,171.4h113.4v113.4H85.7V171.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t3_13_","x":"20","y":"20","width":"244.8","height":"244.8"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t3_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t3_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t3_15_","d":"M43,20h198.8c12.7,0,23,10.3,23,23v198.8c0,12.7-10.3,23-23,23H43c-12.7,0-23-10.3-23-23V43\n            C20,30.3,30.3,20,43,20z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t3_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t3_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st9",attrs:{"d":"M20,20h244.8v244.8H20V20z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t3_17_","x":"49.3","y":"49.3","width":"186.3","height":"186.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t3_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t3_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"t3_19_","cx":"142.4","cy":"142.4","r":"93.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t3_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t3_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('path',{staticClass:"st2",attrs:{"d":"M49.3,49.3h186.3v186.3H49.3V49.3z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6ncc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6sHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row donation-campaigns"},[_c('div',{staticClass:"col-xl-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{ref:"tableTop",staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-start","gap":"10px","flex-wrap":"wrap","flex-direction":"column"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px","align-items":"flex-end","flex":"1 1 auto"}},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"1 1 200px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.search')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('donationCampaigns.search'),"size":"small","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 140px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.status')))]),_vm._v(" "),_c('v-select',{attrs:{"options":[
                  { id: 1, type: _vm.$t('general.active') },
                  { id: 0, type: _vm.$t('general.inactive') }
                ],"label":"type","reduce":function (option) { return option.id; },"placeholder":_vm.$t('general.select'),"clearable":""},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}})],1),_vm._v(" "),(_vm.locations.length)?_c('div',{staticClass:"form-group donation-campaigns__location-filter",staticStyle:{"margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","collapse-tags":"","clearable":"","filterable":"","size":"small","placeholder":_vm.$t('general.select')},model:{value:(_vm.locationFilter),callback:function ($$v) {_vm.locationFilter=$$v},expression:"locationFilter"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:_vm.getLocationOptionValue(loc),attrs:{"label":loc.name,"value":_vm.getLocationOptionValue(loc)}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 220px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.startEnd')))]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","size":"small","placeholder":_vm.$t('donationCampaigns.startEnd')},model:{value:(_vm.dateRangeFilter),callback:function ($$v) {_vm.dateRangeFilter=$$v},expression:"dateRangeFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.applyFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right-group",staticStyle:{"flex":"0 0 auto","margin-bottom":"20px","margin-top":"10px"}},[_c('button',{staticClass:"btn add",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('donationCampaigns.single')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-sm.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('donationCampaigns.single'))+"\n            ")])])]),_vm._v(" "),_c('p',{staticClass:"donation-campaigns__info"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('donationCampaigns.onlyOneActivePerLocation'))+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"donation-campaigns__info"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v("\n          "+_vm._s(_vm.$t('donationCampaigns.fiscalizationInfoPrefix'))),_c('router-link',{staticClass:"donation-campaigns__info-link",attrs:{"to":{ path: '/settings', query: { tabIndex: '1' } }}},[_vm._v(_vm._s(_vm.$t('donationCampaigns.fiscalizationInfoLink')))]),_vm._v(_vm._s(_vm.$t('donationCampaigns.fiscalizationInfoSuffix', { field: _vm.$t('settingCompany.donation_vat_printer_id') }))+"\n        ")],1),_vm._v(" "),_c('div',{staticClass:"data-table",staticStyle:{"margin-top":"20px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"row-class-name":_vm.rowClass,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.onRowClick}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('donationCampaigns.id'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('donationCampaigns.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('donationCampaigns.location'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"locations-cell",attrs:{"title":_vm.getLocationNames(props.row)}},[_c('span',{staticClass:"locations-name"},[_vm._v(_vm._s(_vm.getVisibleLocationName(props.row)))]),_vm._v(" "),(_vm.getHiddenLocationCount(props.row))?_c('span',{staticClass:"locations-more"},[_vm._v("\n                    +"+_vm._s(_vm.getHiddenLocationCount(props.row))+"\n                  ")]):_vm._e()])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('donationCampaigns.startEnd'),"min-width":"180","class-name":"date-range-cell"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatDate(props.row.starts_at || props.row.date_start))+" - "+_vm._s(_vm.formatDate(props.row.ends_at || props.row.date_end))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('donationCampaigns.daysLeft'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.getDaysLeft(props.row.ends_at || props.row.date_end))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('donationCampaigns.targetAmount'),"width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(parseFloat(props.row.target_amount || 0).toFixed(2))+" "+_vm._s(_vm.currency)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('donationCampaigns.collectedAmount'),"width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(parseFloat(props.row.raised_total || 0).toFixed(2))+" "+_vm._s(_vm.currency)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.active'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(scope.$index, scope.row, $event)}},model:{value:(scope.row.active),callback:function ($$v) {_vm.$set(scope.row, "active", $$v)},expression:"scope.row.active"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.goToRecord(scope.row, null, $event)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.edit'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.handleDelete(scope.$index, scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"current-page":_vm.paginationDef.page},on:{"update:currentPage":function($event){_vm.$set(_vm.paginationDef, "page", $event)},"current-change":_vm.handlePageChange}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6ulu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pricelist-fields-form"},_vm._l((_vm.fieldNames),function(field){return _c('div',{key:field,staticClass:"col-md-6"},[(_vm.isBooleanField(field))?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"pricelist-fields-form__bool-label"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.fieldDisabled(field)},domProps:{"checked":Boolean(_vm.formData[field])},on:{"change":function($event){_vm.onBoolChange(field, $event.target.checked)}}}),_vm._v("\n        "+_vm._s(_vm.fieldLabel(field))+"\n      ")])]):(_vm.isJsonField(field))?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel(field)))]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"rows":"3","placeholder":_vm.fieldLabel(field),"disabled":_vm.fieldDisabled(field)},domProps:{"value":_vm.formText[field]},on:{"input":function($event){_vm.onJsonInput(field, $event.target.value)}}}),_vm._v(" "),(_vm.jsonHint)?_c('small',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.jsonHint))]):_vm._e()]):_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel(field)))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.fieldLabel(field),"disabled":_vm.fieldDisabled(field)},domProps:{"value":_vm.formData[field]},on:{"input":function($event){_vm.onTextInput(field, $event.target.value)}}})])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6xUT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6y2k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.view === 'list')?_c('div',[_c('div',{staticClass:"card mar-to-15",staticStyle:{"width":"calc(100% - 20px)","margin-left":"10px","margin-right":"10px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',[_c('button',{staticClass:"btn add",on:{"click":function($event){$event.preventDefault();_vm.openForm(null)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('deliveryPreferences.zoneAdd'))+"\n            ")])])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"70px"}},[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.name')))]),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('th',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.shippingCost')))]):_c('th',[_vm._v("Taxe de livrare")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.type')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"110px"}},[_vm._v(_vm._s(_vm.$t('zoneAvailability.activeColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"200px"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.zones),function(zone){return _c('tr',{key:zone.id},[_c('td',[_vm._v(_vm._s(zone.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(zone.name))]),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('td',[_vm._v(_vm._s(zone.shipping_cost))]):_c('td',[_vm._l((_vm.zoneDeliveryTaxes(zone.id)),function(tax){return _c('span',{key:tax.id,staticClass:"zone-tax-badge"},[_vm._v(_vm._s(tax.name))])}),_vm._v(" "),(!_vm.zoneDeliveryTaxes(zone.id).length)?_c('span',{staticClass:"text-muted"},[_vm._v("Nicio taxă")]):_vm._e()],2),_vm._v(" "),_c('td',[(zone.editable)?_c('span',{staticClass:"badge",staticStyle:{"background":"#4caf50","color":"#fff","padding":"3px 8px","border-radius":"4px"}},[_vm._v("\n                    "+_vm._s(_vm.$t('deliveryPreferences.companyZone'))+"\n                  ")]):_c('span',{staticClass:"badge",staticStyle:{"background":"#9e9e9e","color":"#fff","padding":"3px 8px","border-radius":"4px"}},[_vm._v("\n                    "+_vm._s(_vm.$t('deliveryPreferences.locationZone'))+"\n                  ")]),_vm._v(" "),(zone.schedule_enabled)?_c('span',{staticClass:"badge",staticStyle:{"background":"#2196f3","color":"#fff","padding":"3px 8px","border-radius":"4px"}},[_vm._v("\n                    "+_vm._s(_vm.$t('zoneAvailability.withSchedule'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('td',[(zone.editable)?_c('p-switch',{attrs:{"name":'zoneActive_' + zone.id,"value":zone.active !== false,"type":"success"},on:{"input":function (val) { return _vm.toggleActive(zone, val); }}}):_c('span',{staticClass:"text-muted"},[_vm._v("-")])],1),_vm._v(" "),_c('td',[(zone.editable)?_c('button',{staticClass:"btn btn-sm btn-info",staticStyle:{"margin-right":"6px"},on:{"click":function($event){$event.preventDefault();_vm.openForm(zone.id)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" "+_vm._s(_vm.$t('general.edit'))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-icon btn-info",attrs:{"title":_vm.$t('deliveryPreferences.clone')},on:{"click":function($event){$event.preventDefault();_vm.cloneZone(zone)}}},[_c('i',{staticClass:"ti-files"})])])])}),_vm._v(" "),(!_vm.loading && !_vm.zones.length)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"6"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.noData')))])]):_vm._e()],2)]),_vm._v(" "),_c('p',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.legacyReadonly')))])])])])])]):_c('div',[_c('div',{staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":function($event){$event.preventDefault();return _vm.backToList($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('deliveryPreferences.back'))+"\n          ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.model.id)?_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.remove($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.delete'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success save mar-rt-10",on:{"click":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[(_vm.formError)?_c('p',{staticClass:"text-danger",staticStyle:{"margin":"0 15px"}},[_vm._v(_vm._s(_vm.formError))]):_vm._e(),_vm._v(" "),(_vm.overlayOptions.length)?_c('div',{staticClass:"form-group",staticStyle:{"margin":"0 15px 15px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.showOtherZones')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%","display":"block"},attrs:{"multiple":"","filterable":"","collapse-tags":"","placeholder":_vm.$t('deliveryPreferences.showOtherZonesPlaceholder')},model:{value:(_vm.overlayZoneIds),callback:function ($$v) {_vm.overlayZoneIds=$$v},expression:"overlayZoneIds"}},_vm._l((_vm.overlayOptions),function(z){return _c('el-option',{key:z.id,attrs:{"label":z.name || ('#' + z.id),"value":z.id}})}))],1):_vm._e(),_vm._v(" "),(_vm.mapReady)?_c('delivery-google-maps',{key:_vm.mapKey,attrs:{"googleMapsapiKey":_vm.mapContext.google_maps_api_key,"cityFromParent":_vm.mapContext.city,"locationMarker":{ lat: _vm.mapContext.lat, lng: _vm.mapContext.lng, name: _vm.mapContext.name },"showTheRestOfTheZones":_vm.overlayZones.length > 0,"zoneInComp":_vm.model,"nameInvalid":_vm.attemptedSave && !_vm.model.name,"deliveryRanges":_vm.mapZones,"indexZone":0,"bussLocationId":_vm.mapContext.token,"location_id":null,"hideDeleteZone":true,"orderType":'delivery',"currency":_vm.currency,"vatOptions":_vm.vatOptions,"taxes-version":_vm.taxesVersion},on:{"update-zone":_vm.handleUpdateZone}}):_vm._e(),_vm._v(" "),(_vm.mapReady)?_c('zone-availability-editor',{attrs:{"zone":_vm.model,"showErrors":_vm.attemptedSave}}):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6yfL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    openNewPage: function openNewPage() {
      window.open('https://taptasty-support.freshdesk.com/support/tickets/new', '_blank');
    }
  }
});

/***/ }),

/***/ "6yfg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);













var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default.a), _components),
  props: { location: { type: Object, required: true } },
  data: function data() {
    return {
      draft: {},
      organizations: [],
      options: null,
      paymentIds: {},
      busy: false,
      error: '',
      notice: '',
      requestVersion: 0,
      savedSnapshot: '',
      menuRefreshRequired: false,
      paymentTypes: ['CASH', 'CARD', 'POS', 'CARD_POS', 'ONLINE'],
      entityFields: [{ key: 'terminal_group_id', list: 'terminal_groups', label: 'terminalGroupId' }, { key: 'tips_pos_id', list: 'tips_types', label: 'tipsId' }, { key: 'discount_pos_id', list: 'discounts', label: 'discountId' }]
    };
  },

  computed: {
    config: function config() {
      return this.location.r_system_company || {};
    },
    paymentChoices: function paymentChoices() {
      var _this = this;

      return this.options ? this.options.payment_methods.filter(function (item) {
        return item.id && item.paymentTypeKind && (!_this.draft.terminal_group_id || !item.terminalGroups || !item.terminalGroups.length || item.terminalGroups.some(function (group) {
          return group.id === _this.draft.terminal_group_id;
        }));
      }) : [];
    },
    canSave: function canSave() {
      var _this2 = this;

      return this.draft.organization_id && this.draft.terminal_group_id && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.paymentIds).some(function (type) {
        return _this2.paymentIds[type];
      });
    },
    dirty: function dirty() {
      return this.snapshot() !== this.savedSnapshot;
    },
    selectedOrganizationLabel: function selectedOrganizationLabel() {
      var _this3 = this;

      var item = this.organizations.find(function (item) {
        return item.id === _this3.draft.organization_id;
      });return item ? item.name || item.id : '';
    },
    selectedTerminalLabel: function selectedTerminalLabel() {
      var _this4 = this;

      var item = this.options && this.options.terminal_groups.find(function (item) {
        return item.id === _this4.draft.terminal_group_id;
      });return item ? item.name || item.id : '';
    }
  },
  watch: {
    busy: function busy(value) {
      this.$emit('busy', value);
    },

    'location.true_id': { immediate: true, handler: function handler() {
        this.initialize();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.requestVersion++;this.$emit('busy', false);
  },

  methods: {
    selectedEntity: function selectedEntity(field) {
      var _this5 = this;

      return this.options && this.options[field.list].find(function (item) {
        return item.id === _this5.draft[field.key];
      });
    },
    discountLabel: function discountLabel(item) {
      var mode = { Percent: 'proc', FixedSum: 'fix', FlexibleSum: 'adjustable' }[item.mode] || item.mode;
      var value = item.mode === 'Percent' ? ' (' + item.percent + '%)' : item.mode === 'FixedSum' ? ' (' + item.sum + ')' : '';
      return this.$t('rsystem.' + mode) + value + (item.recommended ? ' · ' + this.$t('rsystem.recommended') : '');
    },
    normalizePayments: function normalizePayments(value) {
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (e) {
          return {};
        }
      }
      if (Array.isArray(value)) return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default.a.apply(Object, [{}].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(value)));
      return value || {};
    },
    initialize: function initialize() {
      var _this6 = this;

      this.requestVersion++;
      this.draft = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ api_key: '', organization_id: null, terminal_group_id: null, discount_pos_id: null, tips_pos_id: null }, this.config);
      this.paymentIds = {};
      var mappings = this.normalizePayments(this.config.payment_types);
      this.paymentTypes.forEach(function (type) {
        _this6.$set(_this6.paymentIds, type, mappings[type] && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(mappings[type])[0] || null);
      });
      this.organizations = [];
      this.options = null;
      this.error = '';
      this.notice = '';
      this.menuRefreshRequired = false;
      this.busy = false;
      this.savedSnapshot = this.snapshot();
      if (this.location.true_id && this.draft.api_key) this.loadOrganizations();
    },
    snapshot: function snapshot() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([this.draft.api_key, this.draft.organization_id, this.draft.terminal_group_id, this.draft.discount_pos_id, this.draft.tips_pos_id, this.paymentTypes.map(function (type) {
        return _this7.paymentIds[type] || null;
      })]);
    },
    credentialsChanged: function credentialsChanged() {
      this.requestVersion++;
      this.busy = false;
      this.organizations = [];
      this.clearDependent();
      this.draft.organization_id = null;
      this.error = '';
      this.notice = '';
    },
    clearDependent: function clearDependent() {
      this.options = null;
      this.draft.terminal_group_id = null;
      this.draft.discount_pos_id = null;
      this.draft.tips_pos_id = null;
      this.paymentIds = {};
    },
    request: function request(action, extra, callback) {
      var _this8 = this;

      var version = ++this.requestVersion;
      var locationId = this.location.true_id;
      this.busy = true;
      this.error = '';
      var body = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ token: this.$session.get('token'),
        company_id: this.location.company_id,
        location_id: locationId,
        location_token: this.location.id,
        api_key: this.draft.api_key,
        organization_id: this.draft.organization_id }, extra);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this8.apiRequest('/rsystems/' + (_this8.config.id || 0) + '/' + action, 'POST', body, function (response) {
          if (version !== _this8.requestVersion || locationId !== _this8.location.true_id) {
            resolve({ status: false, canceled: true });
            return;
          }
          _this8.busy = false;
          if (!response.status) {
            _this8.error = response.errors && response.errors.message || _this8.$t('rsystem.requestFailed');
          } else if (callback) {
            callback(response);
          }
          resolve(response);
        });
      });
    },
    loadOrganizations: function loadOrganizations() {
      var _this9 = this;

      this.request('organizations', {}, function (response) {
        _this9.organizations = response.data.organizations;
        if (!_this9.organizations.some(function (item) {
          return item.id === _this9.draft.organization_id;
        })) {
          _this9.draft.organization_id = null;
          _this9.clearDependent();
        }

        if (_this9.draft.organization_id) _this9.loadOptions();
      });
    },
    entityChanged: function entityChanged(key) {
      var _this10 = this;

      if (key !== 'terminal_group_id') return;
      this.paymentTypes.forEach(function (type) {
        if (!_this10.paymentChoices.some(function (item) {
          return item.id === _this10.paymentIds[type];
        })) _this10.$set(_this10.paymentIds, type, null);
      });
    },
    organizationChanged: function organizationChanged() {
      this.clearDependent();
      this.notice = '';
      this.menuRefreshRequired = this.draft.organization_id !== this.config.organization_id;
      this.loadOptions();
    },
    loadOptions: function loadOptions() {
      var _this11 = this;

      this.request('setup-options', {}, function (response) {
        _this11.options = response.data;
        _this11.entityFields.forEach(function (field) {
          var choices = _this11.options[field.list];
          if (!choices.some(function (item) {
            return item.id === _this11.draft[field.key];
          })) {
            _this11.draft[field.key] = choices.length === 1 ? choices[0].id : null;
          }
        });
        _this11.paymentTypes.forEach(function (type) {
          var oldId = _this11.paymentIds[type];
          var suggestion = _this11.options.suggested_payment_types[type];
          _this11.$set(_this11.paymentIds, type, _this11.paymentChoices.some(function (item) {
            return item.id === oldId;
          }) ? oldId : suggestion ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(suggestion)[0] : null);
        });
      });
    },
    saveIfDirty: function saveIfDirty() {
      if (!this.dirty) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(true);
      if (this.busy || !this.options || !this.canSave || !this.location.true_id) {
        this.error = this.$t('rsystem.completeSetup');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
      }
      return this.save().then(function (response) {
        return !!response.status;
      });
    },
    save: function save() {
      var _this12 = this;

      var mappings = {};
      this.paymentTypes.forEach(function (type) {
        var payment = _this12.paymentChoices.find(function (item) {
          return item.id === _this12.paymentIds[type];
        });
        if (payment) mappings[type] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, payment.paymentTypeKind, payment.id);
      });
      return this.request('setup', { terminal_group_id: this.draft.terminal_group_id,
        discount_pos_id: this.draft.discount_pos_id,
        tips_pos_id: this.draft.tips_pos_id,
        payment_types: mappings,
        updated_at: this.config.updated_at }, function (response) {
        _this12.$emit('saved', response.data);
        _this12.savedSnapshot = _this12.snapshot();
        _this12.menuRefreshRequired = _this12.menuRefreshRequired || response.menu_refresh_required;
        _this12.notice = _this12.$t('rsystem.saved');
      });
    },
    importMenu: function importMenu() {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({ text: this.$t('rsystem.importConfirm'), type: 'warning', showCancelButton: true }).then(function (confirmed) {
        if (!confirmed || _this13.dirty) return;
        _this13.request('import-products', {}, function () {
          _this13.menuRefreshRequired = false;
          _this13.notice = _this13.$t('rsystem.importQueued');
        });
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "70Hq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "72u/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't4'
});

/***/ }),

/***/ "73l2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isValidEmailAddress */
/* harmony export (immutable) */ __webpack_exports__["c"] = parseEmailListInput;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatEmailListForInput;
/* harmony export (immutable) */ __webpack_exports__["a"] = validateEmailListInput;
var EMAIL_SPLIT_PATTERN = /[,;\n\r]+/;

function isValidEmailAddress(email) {
  return (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(String(email).trim())
  );
}

function parseEmailListInput(value) {
  if (value == null || value === '') return [];
  if (Array.isArray(value)) {
    return value.map(function (entry) {
      return String(entry).trim();
    }).filter(Boolean);
  }

  var str = String(value).trim();
  if (!str) return [];

  if (str.startsWith('[')) {
    try {
      var parsed = JSON.parse(str);
      if (Array.isArray(parsed)) {
        return parsed.map(function (entry) {
          return String(entry).trim();
        }).filter(Boolean);
      }
    } catch (e) {}
  }

  return str.split(EMAIL_SPLIT_PATTERN).map(function (entry) {
    return entry.trim();
  }).filter(Boolean);
}

function formatEmailListForInput(value) {
  return parseEmailListInput(value).join(', ');
}

function validateEmailListInput(value) {
  var entries = parseEmailListInput(value);
  if (!entries.length) return true;
  return entries.every(function (entry) {
    return isValidEmailAddress(entry);
  });
}

/***/ }),

/***/ "75Cv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px","margin-bottom":"0"},on:{"click":function($event){$event.preventDefault();_vm.handleDelete('delete')}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px","margin-bottom":"0"},on:{"click":function($event){$event.preventDefault();_vm.handleDelete('cancel')}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.cancel'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('infoPages.title')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.title),expression:"modelValidations.title"}],staticClass:"form-control",attrs:{"type":"text","name":"title","placeholder":_vm.$t('infoPages.title')},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}})]),_vm._v(" "),(_vm.errors.has('title'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('title'))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',[_c('label',{staticClass:"pad-to-10"},[_vm._v(_vm._s(_vm.$t('settingsInfoPages.content')))]),_vm._v(" "),_c('wysiwyg',{staticClass:"form-control",staticStyle:{"height":"calc(100% - 32px)"},attrs:{"rows":"15","name":"description","placeholder":_vm.$t('infoPages.shortDescription'),"aria-invalid":_vm.errors.has('description')},on:{"change":_vm.validateEditor},model:{value:(_vm.model.description),callback:function ($$v) {_vm.$set(_vm.model, "description", $$v)},expression:"model.description"}}),_vm._v(" "),_c('small',{staticClass:"help-block"},[_vm._v("\n                "+_vm._s(_vm.$t('infoPages.changeLinkTab'))+"\n              ")]),_vm._v(" "),(_vm.errors.has('description'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('description'))+"\n              ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":[{'url': this.model.image}],"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsInfoPages.imageSize')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","name":"image_size","placeholder":_vm.$t('general.select')},model:{value:(_vm.model.image_size),callback:function ($$v) {_vm.$set(_vm.model, "image_size", $$v)},expression:"model.image_size"}},_vm._l((_vm.imageSizes),function(size){return _c('el-option',{key:size.value,attrs:{"label":size.label,"value":size.value}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('p-checkbox',{model:{value:(_vm.model.show_in_header),callback:function ($$v) {_vm.$set(_vm.model, "show_in_header", $$v)},expression:"model.show_in_header"}},[_vm._v("\n              "+_vm._s(_vm.$t('settingsInfoPages.showInHeader'))+"\n            ")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.model.show_in_footer),callback:function ($$v) {_vm.$set(_vm.model, "show_in_footer", $$v)},expression:"model.show_in_footer"}},[_vm._v("\n              "+_vm._s(_vm.$t('settingsInfoPages.showInFooter'))+"\n            ")])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "75Kl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__MenuPreview_WoltMenuLayout_vue__ = __webpack_require__("mYhK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MenuPreview_GlovoMenuLayout_vue__ = __webpack_require__("vLc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__MenuPreview_BoltMenuLayout_vue__ = __webpack_require__("otpQ");



















var _components;





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PlatformMenuImports',
  components: (_components = { WoltMenuLayout: __WEBPACK_IMPORTED_MODULE_19__MenuPreview_WoltMenuLayout_vue__["a" /* default */], GlovoMenuLayout: __WEBPACK_IMPORTED_MODULE_20__MenuPreview_GlovoMenuLayout_vue__["a" /* default */], BoltMenuLayout: __WEBPACK_IMPORTED_MODULE_21__MenuPreview_BoltMenuLayout_vue__["a" /* default */] }, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_dropdown___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_dropdown___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dropdown_menu___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_dropdown_menu___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown_item___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown_item___default.a), _components),
  props: { route: { type: Object, default: function _default() {
        return {};
      } } },
  data: function data() {
    return { reviewMode: 'preview', activeAction: '', storeUrl: '', batch: null, draft: null, history: [], taxes: [], busy: false, error: '', search: '', timer: null, openSequence: 0 };
  },

  computed: {
    locationId: function locationId() {
      return (this.route && this.route.params || this.$route.params).locationId;
    },
    editable: function editable() {
      return this.batch && this.batch.status === 'READY';
    },
    processing: function processing() {
      return this.batch && ['PROCESSING', 'CONFIRMING'].indexOf(this.batch.status) !== -1;
    },
    diagnostics: function diagnostics() {
      return this.batch ? (this.batch.diagnostics || []).filter(function (issue) {
        return issue.code !== 'CATEGORY_IMAGE_ABSENT';
      }) : [];
    },
    selectedCount: function selectedCount() {
      return this.draft ? this.draft.products.filter(function (p) {
        return p.included;
      }).length : 0;
    },
    resultCount: function resultCount() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.batch && this.batch.result && this.batch.result.products || {}).length;
    },
    previewLayout: function previewLayout() {
      return { wolt: 'WoltMenuLayout', glovo: 'GlovoMenuLayout', bolt: 'BoltMenuLayout' }[this.batch && this.batch.platform || 'wolt'] || 'WoltMenuLayout';
    },
    previewCategories: function previewCategories() {
      if (!this.draft) return [];
      var products = {};
      this.filteredProducts.filter(function (product) {
        return product.included;
      }).forEach(function (product) {
        products[String(product.id)] = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, product, {
          image_url: (product.image_urls || [])[0] || '',
          options: product.options.filter(function (option) {
            return option.included !== false;
          }).map(function (option) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, option, {
              multiple: option.mode === 'multiple', counter: option.mode === 'counter'
            });
          })
        });
      });
      return this.draft.categories.filter(function (category) {
        return category.included;
      }).map(function (category) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, category, {
          products: category.product_ids.map(function (id) {
            return products[String(id)];
          }).filter(Boolean)
        });
      }).filter(function (category) {
        return category.products.length;
      });
    },
    filteredProducts: function filteredProducts() {
      var _this = this;

      return this.draft.products.filter(function (p) {
        return !_this.search || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(p).toLowerCase().indexOf(_this.search.toLowerCase()) !== -1;
      });
    }
  },
  created: function created() {
    this.loadHistory();
    var params = this.route && this.route.params || this.$route.params;
    if (params.importId) this.open(params.importId);
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timer);
  },

  methods: {
    isImportRunning: function isImportRunning(item) {
      return ['PROCESSING', 'CONFIRMING'].indexOf(item.status) !== -1;
    },
    historyAction: function historyAction(item, action) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var suffix;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.busy || _this2.isImportRunning(item))) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (!(action !== 'reimport')) {
                  _context.next = 11;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
                  title: _this2.t(action === 'deleteProducts' && item.status === 'PRODUCTS_DELETED' ? 'cleanupImport' : action),
                  text: _this2.t(action === 'deleteProducts' ? item.status === 'PRODUCTS_DELETED' ? 'cleanupImportConfirm' : 'deleteProductsConfirm' : 'deleteImportConfirm'),
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: _this2.$t('general.delete'),
                  cancelButtonText: _this2.$t('general.cancel')
                });

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](3);
                return _context.abrupt('return');

              case 11:
                if (!_this2.busy) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt('return');

              case 13:
                _this2.busy = true;
                _this2.error = '';
                suffix = action === 'reimport' ? '/reimport' : action === 'deleteProducts' ? '/products' : '';

                _this2.request('/' + item.id + suffix, action === 'reimport' ? 'POST' : 'DELETE', {}, function (response) {
                  _this2.busy = false;
                  if (action === 'reimport') {
                    _this2.storeUrl = response.data.store_url;
                    _this2.open(response.data.id);
                  } else if (_this2.batch && _this2.batch.id === item.id) {
                    if (action === 'deleteImport') {
                      _this2.batch = null;_this2.draft = null;clearTimeout(_this2.timer);
                    } else {
                      _this2.open(item.id);
                    }
                  }
                  _this2.loadHistory();
                });

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[3, 8]]);
      }))();
    },
    warningMessage: function warningMessage(issue) {
      var codes = ['DEFAULT_MODIFIER_PRICE_SEPARATED', 'INDIVIDUAL_LIMITS_ABSENT', 'MISSING_TAX_AND_POS_MAPPING', 'ADDITIONAL_SOURCE_DETAILS', 'PRODUCT_DEPOSIT_AS_REQUIRED_GROUP', 'IMAGE_DOWNLOAD_FAILED', 'DEPOSIT_FROM_FEE_LABEL', 'FEE_REQUIRES_REVIEW', 'UNSUPPORTED_OPTION_PRICING_OR_DEPENDENCY'];
      if (codes.indexOf(issue.code) === -1) return issue.message;
      var parameters = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, issue.parameters || {});

      if (issue.code === 'DEFAULT_MODIFIER_PRICE_SEPARATED') {
        var match = String(issue.message || '').match(/total \(([^)]+)\)/);
        var amount = parameters.amount != null ? parameters.amount : match && match[1];
        parameters.amount = amount == null ? '—' : Number(amount).toLocaleString(this.$i18n.locale);
      }
      if (issue.code === 'DEPOSIT_FROM_FEE_LABEL' || issue.code === 'FEE_REQUIRES_REVIEW') {
        var _match = String(issue.message || '').match(/: (.*)$/);
        parameters.label = parameters.label || _match && _match[1] || '';
      }
      return this.$t('platformMenuImport.warnings.' + issue.code, parameters);
    },
    goBack: function goBack() {
      if (!this.busy) this.$emit('close');
    },
    validateStoreUrl: function validateStoreUrl(input) {
      input.setCustomValidity('');
      if (input.validity.valueMissing) input.setCustomValidity(this.t('storeUrlRequired'));else if (input.validity.typeMismatch) input.setCustomValidity(this.t('storeUrlInvalid'));
    },
    historyStatus: function historyStatus(status) {
      var key = { PROCESSING: 'statusProcessing', READY: 'statusReady', CONFIRMING: 'statusConfirming', CONFIRMED: 'statusConfirmed', PRODUCTS_DELETED: 'statusProductsDeleted', FAILED: 'statusFailed', CANCELED: 'statusCanceled' }[status];
      return key ? this.t(key) : status;
    },
    historyRowClass: function historyRowClass(_ref) {
      var row = _ref.row;
      return this.batch && row.id === this.batch.id ? 'history-current' : '';
    },
    t: function t(key) {
      return this.$t('platformMenuImport.' + key);
    },
    request: function request(path, method, data, done) {
      var _this3 = this;

      this.apiRequest('/platform-menu-imports' + path, method, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({ token: this.$session.get('token'), company_id: this.$session.get('selectedCompany') }, data), function (response) {
        if (!response || !response.status) {
          var failure = response && response.error;
          var http = failure && failure.response;
          var payload = http && http.data || response || {};
          var validation = payload.errors && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(payload.errors).map(function (key) {
            return [].concat(payload.errors[key]).join(' ');
          }).join(' ');
          _this3.error = http && http.status === 404 ? _this3.t('apiUnavailable') : payload.message || validation || typeof payload.data === 'string' && payload.data || (http && http.status === 403 ? _this3.t('accessDenied') : failure && failure.code === 'ECONNABORTED' ? _this3.t('timedOut') : _this3.t('requestFailed'));
          _this3.busy = false;
          return;
        }
        done(response);
      }, { timeout: 600000 });
    },
    loadHistory: function loadHistory() {
      var _this4 = this;

      this.request('', 'GET', { location_id: this.locationId }, function (r) {
        _this4.history = r.data.data || [];
      });
    },
    createImport: function createImport() {
      var _this5 = this;

      if (this.busy || !this.storeUrl.trim()) return;
      this.activeAction = 'preview';
      this.busy = true;
      this.error = '';
      this.request('', 'POST', { store_url: this.storeUrl, location_id: this.locationId }, function (r) {
        _this5.busy = false;_this5.open(r.data.id);_this5.loadHistory();
      });
    },
    open: function open(id) {
      var _this6 = this;

      clearTimeout(this.timer);
      var sequence = ++this.openSequence;
      this.error = '';
      this.request('/' + id, 'GET', {}, function (r) {
        if (sequence !== _this6.openSequence) return;
        _this6.batch = r.data;
        _this6.reviewMode = 'preview';
        _this6.taxes = r.tax_options || [];
        _this6.draft = r.data.draft ? JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(r.data.draft)) : null;
        if (_this6.draft) _this6.draft.products.forEach(function (p) {
          return p.options.forEach(function (o) {
            if (o.included === undefined) _this6.$set(o, 'included', true);
          });
        });
        if (_this6.processing) _this6.timer = setTimeout(function () {
          return _this6.open(id);
        }, 2500);
      });
    },
    setImage: function setImage(entity, value) {
      entity.image_urls = value.trim() ? [value.trim()] : [];
    },
    setImages: function setImages(entity, value) {
      entity.image_urls = value.split('\n').map(function (x) {
        return x.trim();
      }).filter(Boolean);
    },
    setQuantity: function setQuantity(value, key, input) {
      value[key] = input === '' ? null : Number(input);
    },
    categoryChanged: function categoryChanged(changed) {
      var _this7 = this;

      var byId = {};
      this.draft.categories.forEach(function (c) {
        byId[c.id] = c;
      });
      if (changed.included) {
        var parent = byId[changed.parent_id];
        var visited = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
        while (parent && !visited.has(parent.id)) {
          visited.add(parent.id);
          parent.included = true;
          parent = byId[parent.parent_id];
        }
      } else {
        var excluded = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a([changed.id]);
        this.draft.categories.forEach(function () {
          return _this7.draft.categories.forEach(function (c) {
            if (excluded.has(c.parent_id)) {
              c.included = false;excluded.add(c.id);
            }
          });
        });
      }
      var ids = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      this.draft.categories.filter(function (c) {
        return c.included;
      }).forEach(function (c) {
        return c.product_ids.forEach(function (id) {
          return ids.add(String(id));
        });
      });
      this.draft.products.forEach(function (p) {
        p.included = ids.has(String(p.id));
      });
    },
    productChanged: function productChanged(product) {
      if (product.included && !this.draft.categories.some(function (c) {
        return c.included && c.product_ids.indexOf(product.id) !== -1;
      })) {
        var category = this.draft.categories.find(function (c) {
          return c.product_ids.indexOf(product.id) !== -1;
        });
        if (category) category.included = true;
      }
    },
    save: function save(confirm) {
      var _this8 = this;

      if (this.busy || !this.editable || confirm && (!this.draft.acknowledged_gaps || !this.selectedCount)) return;
      this.activeAction = confirm ? 'confirm' : 'save';
      this.busy = true;
      this.error = '';
      this.request('/' + this.batch.id, 'PUT', { revision: this.batch.revision, draft: this.draft }, function (r) {
        _this8.batch = r.data;
        if (!confirm) {
          _this8.busy = false;return;
        }
        _this8.request('/' + _this8.batch.id + '/confirm', 'POST', { revision: _this8.batch.revision }, function (response) {
          _this8.busy = false;
          _this8.batch = response.data;
          _this8.open(_this8.batch.id);
          _this8.loadHistory();
        });
      });
    },
    cancel: function cancel() {
      var _this9 = this;

      if (this.busy || !this.editable) return;
      this.activeAction = 'cancel';
      this.busy = true;
      this.error = '';
      this.request('/' + this.batch.id + '/cancel', 'POST', {}, function () {
        _this9.busy = false;
        _this9.open(_this9.batch.id);
        _this9.loadHistory();
      });
    }
  }
});

/***/ }),

/***/ "78++":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DiW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])]),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('automation-campaign-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7F4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementInitialStockForm_vue__ = __webpack_require__("nrcP");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneInventarForm', __WEBPACK_IMPORTED_MODULE_7__ManagementInitialStockForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "7FDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsUserForm_vue__ = __webpack_require__("YlEC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd83880_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsUserForm_vue__ = __webpack_require__("pBDY");
function injectStyle (ssrContext) {
  __webpack_require__("XRNR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsUserForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd83880_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsUserForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Gbx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7H1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);










/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a),
  created: function created() {
    this.getData();
  },
  data: function data() {
    return {
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      clients: {
        'valid': [__WEBPACK_IMPORTED_MODULE_5_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf('month').format('YYYY-MM-DD')],
        searchClient: null,
        searchEmployee: null
      },
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        defaultSort: {
          prop: 'name',
          order: 'ascending'
        }
      },
      labels: null,
      labelingPrimaryOption: null,
      totalClients: null,
      sortBy: 'name',
      sortOrder: 'asc',
      clientsTableData: [],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      pickerNames: ['date_from', 'date_to']
    };
  },

  methods: {
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getData(query);
      if (query.type === 'size') this.getData(query);
      if (query.type === 'sort') {
        if (query.sort.order) {
          this.sortBy = query.sort.prop;
          this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc';
        } else {
          this.sortBy = 'name';
          this.sortOrder = 'asc';
        }
        this.getData(query);
      }
    },
    getData: function getData(query) {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.clients.valid[0],
        end_date: this.clients.valid[1],
        search_client: this.clients.searchClient,
        search_employee: this.clients.searchEmployee
      };

      var sortColumn = '';
      var sortType = '';

      if (query) {
        sortColumn = query.sort.prop;
        sortType = query.sort.order === 'descending' ? 'desc' : 'asc';
      } else {
        sortColumn = this.sortBy;
        sortType = this.sortOrder;
      }

      var sortOptions = {
        field: sortColumn,
        order: sortType
      };
      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, sortOptions);

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      this.apiRequest('/reports/ocr?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status === true) {
          _this.clientsTableData = response.data.data;
          _this.totalClients = response.data.total;
        }
        _this.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    exportData: function exportData() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.clients.valid[0],
        end_date: this.clients.valid[1]
      };

      this.loading = true;
      this.apiRequest('/reports/ocr-export', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        }
        _this2.loading = false;
      });
    },
    requestReport: function requestReport() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.clients.valid[0],
        end_date: this.clients.valid[1],
        type: 'exportRaportPuncte'
      };

      this.loading = true;
      this.apiRequest('/reports/pending-report', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
            title: _this3.$t('reports.requestSuccess'),
            text: _this3.$t('reports.requestInfo'),
            type: 'success',
            showConfirmButton: true,
            confirmButtonText: _this3.$t('reports.requestConfirm')
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error');
        }
        _this3.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "7O3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomInfoPageForm_vue__ = __webpack_require__("r37d");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CustomInfoPageForm', __WEBPACK_IMPORTED_MODULE_7__CustomInfoPageForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "7QYl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('kds-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7VBo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7WtQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('raffle-campaign-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Xe3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-lg-12"},[_c('div',{staticClass:"search-bar"},[_c('div',{staticClass:"col-sm-12 no-padding"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('reports.search')},on:{"input":function($event){_vm.onInput()}},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('menuSubscriptions.single'),"to":{ path: '/marketing/menu-subscriptions/add' }}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.add'))+"\n          ")])],1)])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"msub-list"},[(!_vm.loading && !_vm.items.length)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center text-muted msub-empty"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.noSubscriptions')))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{key:'msub' + item.id,staticClass:"card msub-card",class:{ 'is-inactive': !item.active }},[_c('div',{staticClass:"msub-card__main"},[(item.image_url)?_c('img',{staticClass:"msub-card__thumb",attrs:{"src":item.image_url}}):_c('div',{staticClass:"msub-card__thumb msub-card__thumb--empty"},[_c('i',{staticClass:"fa fa-cutlery"})]),_vm._v(" "),_c('div',{staticClass:"msub-card__info"},[_c('a',{staticClass:"msub-card__name",on:{"click":function($event){_vm.edit(item)}}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"msub-card__meta"},[_c('span',[_c('i',{staticClass:"fa fa-map-marker"}),_vm._v(" "+_vm._s(item.location_name || '-'))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"fa fa-money"}),_vm._v(" "+_vm._s(item.price_per_day)+" "+_vm._s(_vm.currency)+" / "+_vm._s(_vm.$t('menuSubscriptions.perDayShort')))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.durationDays', { days: item.duration_days })))]),_vm._v(" "),(item.delivery_days.length)?_c('span',[_c('i',{staticClass:"fa fa-truck"}),_vm._v(" "+_vm._s(_vm.dayList(item.delivery_days)))]):_vm._e(),_vm._v(" "),(item.delivery_hours.length)?_c('span',[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" "+_vm._s(_vm.hourList(item.delivery_hours)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"msub-card__meta"},[_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.menusCount', { count: item.menus_count }))),(item.default_menu_name)?[_vm._v(" · "+_vm._s(_vm.$t('menuSubscriptions.defaultMenuShort'))+": "+_vm._s(item.default_menu_name))]:_vm._e()],2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.zonesCount', { count: item.zones_count })))])]),_vm._v(" "),(item.issues.length)?_c('div',{staticClass:"msub-card__issues"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v("\n              "+_vm._s(_vm.$t('menuSubscriptions.notReady'))+": "+_vm._s(_vm.issuesText(item.issues))+"\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"msub-card__side"},[_c('div',{staticClass:"msub-card__switch",attrs:{"title":item.issues.length ? _vm.$t('menuSubscriptions.notReadyHint') : ''}},[_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.active')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(item)}},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}})],1),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){_vm.openSubscribers(item)}}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscribers.title'))+": "+_vm._s(item.active_subscribers || 0)+"\n            "),(item.pending_purchases)?_c('small',{staticClass:"text-muted"},[_vm._v("(+"+_vm._s(item.pending_purchases)+" "+_vm._s(_vm.$t('menuSubscribers.status.pending').toLowerCase())+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"msub-card__actions"},[_c('a',{staticClass:"msub-icon",attrs:{"title":_vm.$t('menuSubscriptions.tabMenus')},on:{"click":function($event){_vm.edit(item, 'menus')}}},[_c('i',{staticClass:"fa fa-list"})]),_vm._v(" "),_c('a',{staticClass:"msub-icon",attrs:{"title":_vm.$t('menuSubscriptions.tabCalendar')},on:{"click":function($event){_vm.edit(item, 'calendar')}}},[_c('i',{staticClass:"fa fa-calendar"})]),_vm._v(" "),_c('a',{staticClass:"msub-icon",attrs:{"title":_vm.$t('general.edit')},on:{"click":function($event){_vm.edit(item)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),_c('a',{staticClass:"msub-icon msub-icon--danger",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.handleDelete(item)}}},[_c('i',{staticClass:"fa fa-trash-o"})])])])])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Y9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.salesTrendsReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('line-chart',{attrs:{"chartData":_vm.chartData,"options":_vm.chartOptions}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"search-def":{show: false},"total":_vm.ordersTableData.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"sale_week","label":_vm.$t('reports.saleWeek')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.getSalePeriod(props.row.sale_week))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"counter","label":_vm.$t('reports.orderCounter')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(Number(props.row.counter))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"sold","label":_vm.$t('reports.revenue')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.sold)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"item_level_discount","label":_vm.$t('reports.orderItemDiscount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.item_level_discount)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"order_level_discount","label":_vm.$t('reports.orderDiscount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.order_level_discount)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"discount","label":_vm.$t('reports.discount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.item_level_discount) + Number(props.row.order_level_discount)))+"\n            ")]}}])})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7YTo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row loyalty-store-campaigns-page"},[_c('div',{staticClass:"col-md-12 col-lg-12"},[_c('div',{staticClass:"search-bar"},[_c('div',{staticClass:"col-sm-12 no-padding"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('reports.search')},model:{value:(_vm.filters[0].value),callback:function ($$v) {_vm.$set(_vm.filters[0], "value", $$v)},expression:"filters[0].value"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('pages.loyaltyStoreCampaigns'),"to":{ path: '/marketing/loyalty-store-campaigns/add' }}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.add'))+"\n          ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"loyaltyStoreDataTables",staticClass:"campaign-table width-table loyalty-store-campaigns-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDef,"table-props":{ border: false },"filters":_vm.filters},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":70,"prop":"id","label":_vm.$t('customers.id')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":160,"prop":"name","label":_vm.$t('loyaltyStore.campaignName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":180,"label":_vm.$t('loyaltyStore.availability')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatAvailabilityRange(props.row))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":100,"label":_vm.$t('loyaltyStore.rewardsCount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.rewards_count != null ? props.row.rewards_count : (props.row.rewards ? props.row.rewards.length : 0))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":90,"label":_vm.$t('loyaltyStore.active')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{attrs:{"value":!!props.row.active,"type":"success"},on:{"input":function (val) { return _vm.handleActive(props.row, val); }}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","width":120,"prop":"actions","label":_vm.$t('marketingCampaigns.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.editRecord(props.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.edit'))+"\n                  ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.handleDelete(props.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.delete'))+"\n                  ")])],1)],1)]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Zo3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeUserProgressLogsReport_vue__ = __webpack_require__("Ducs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4974c7bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeUserProgressLogsReport_vue__ = __webpack_require__("gfa0");
function injectStyle (ssrContext) {
  __webpack_require__("BIDe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4974c7bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeUserProgressLogsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4974c7bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeUserProgressLogsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7b9o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7bzV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7dba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaignsReport_vue__ = __webpack_require__("UleD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d8c606b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaignsReport_vue__ = __webpack_require__("cT4/");
function injectStyle (ssrContext) {
  __webpack_require__("BGrY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaignsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d8c606b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaignsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7hXV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7iHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntegrationStatusPollingField',
  components: { PSwitch: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Switch_vue__["a" /* default */] },
  props: {
    formData: { type: Object, required: true },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    setEnabled: function setEnabled(value) {
      if (!this.disabled) {
        this.$set(this.formData, 'platform_status_polling_enabled', Boolean(value));
      }
    }
  }
});

/***/ }),

/***/ "7iQP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7qxb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 274.3 275.2"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 274.3 275.2","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r4_1_","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r4_3_","d":"M0,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6H9c-2.4,0-4.7-0.9-6.4-2.6C0.9,190,0,187.7,0,185.3z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,194.3V80.9h113.4v113.4H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r4_5_","x":"160.9","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r4_7_","d":"M160.9,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6h-95.4c-2.4,0-4.7-0.9-6.4-2.6\n            S160.9,187.7,160.9,185.3z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M160.9,194.3V80.9h113.4v113.4H160.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r4_9_","x":"85.2","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r4_11_","d":"M85.2,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H94.2c-2.4,0-4.7-0.9-6.4-2.6S85.2,187.7,85.2,185.3z\n            "}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M85.2,194.3V80.9h113.4v113.4H85.2z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r4_13_","x":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r4_15_","d":"M89.9,0h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6\n            H89.9c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4C85.2,0.9,87.5,0,89.9,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M80.9,0h113.4v113.4H80.9V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r4_17_","x":"80.9","y":"161.8","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r4_19_","d":"M89.9,161.8h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6\n            H89.9c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4S87.5,161.8,89.9,161.8z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M80.9,161.8h113.4v113.4H80.9V161.8z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r4_21_","x":"10.9","y":"10.9","width":"253.4","height":"253.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"r4_23_","cx":"137.6","cy":"137.6","r":"126.7"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st13",attrs:{"d":"M10.9,10.9h253.4v253.4H10.9V10.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r4_25_","x":"62.7","y":"62.7","width":"149.8","height":"149.8"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"r4_27_","cx":"137.6","cy":"137.6","r":"74.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r4_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r4_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('path',{staticClass:"st2",attrs:{"d":"M62.7,62.7h149.8v149.8H62.7V62.7z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7sZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 264.3 275.3"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 264.3 275.3","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r3_1_","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r3_3_","d":"M0,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6H9c-2.4,0-4.7-0.9-6.4-2.6C0.9,190,0,187.7,0,185.3z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,194.3V80.9h113.4v113.4H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r3_5_","x":"137.6","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r3_7_","d":"M137.6,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6H242c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-95.4c-2.4,0-4.7-0.9-6.4-2.6S137.6,187.7,137.6,185.3z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M137.6,194.3V80.9H251v113.4H137.6z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r3_9_","x":"85.2","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r3_11_","d":"M85.2,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H94.2c-2.4,0-4.7-0.9-6.4-2.6S85.2,187.7,85.2,185.3z\n            "}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M85.2,194.3V80.9h113.4v113.4H85.2z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r3_13_","x":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r3_15_","d":"M89.9,0h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6\n            H89.9c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4C85.2,0.9,87.5,0,89.9,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M80.9,0h113.4v113.4H80.9V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r3_17_","x":"80.9","y":"161.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r3_19_","d":"M89.9,161.9h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6\n            H89.9c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4S87.5,161.9,89.9,161.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M80.9,161.9h113.4v113.4H80.9V161.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r3_21_","x":"10.9","y":"10.9","width":"253.4","height":"253.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"r3_23_","cx":"137.6","cy":"137.6","r":"126.7"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st13",attrs:{"d":"M10.9,10.9h253.4v253.4H10.9V10.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r3_25_","x":"62.7","y":"62.7","width":"149.8","height":"149.8"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"r3_27_","cx":"137.6","cy":"137.6","r":"74.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r3_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r3_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('path',{staticClass:"st2",attrs:{"d":"M62.7,62.7h149.8v149.8H62.7V62.7z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7ssq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 50,
      selectedLocation: null,
      selectedGestiune: null,
      tableData: [],
      gestiuniList: [],
      selectedStatus: '',
      selectedManagement: ''
    };
  },

  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.selectedGestiune = null;
      this.tableData = [];

      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
    },
    selectedGestiune: function selectedGestiune(newGestiune) {
      this.searchTerm = null;
      this.tableData = [];
    }
  },
  computed: {
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id;
      });
      return result;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
    if (this.groupedLocations && this.groupedLocations.length) {
      this.selectedLocation = this.groupedLocations[0].locations[0];
    }

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.fetchInventare();
    },
    onSearch: function onSearch() {
      if (!this.selectedLocation) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați o locație',
          confirmButtonText: 'OK'
        });
        return;
      }

      if (!this.selectedGestiune) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați o gestiune',
          confirmButtonText: 'OK'
        });
        return;
      }

      this.fetchInventare();
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.fetchInventare(this.currentPage, this.pageSize);
    },
    getGestiuneNameById: function getGestiuneNameById(id) {
      var gest = this.gestiuneOptions.find(function (g) {
        return g._id === id || g.id === id;
      });
      return gest ? gest.name : id;
    },
    addInventory: function addInventory() {
      this.$router.push('/management/inventory/add');
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this2.companyID);

              case 3:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context.next = 8;
                return response.json();

              case 8:
                data = _context.sent;


                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this2.gestiuniList = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      value: gest._id,
                      label: gest.name + ' (' + gest.cod_gestiune + ')'
                    };
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    icon: 'error',
                    title: 'Eroare!',
                    text: 'Nu s-a primit un array valid de la server.',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                  icon: 'error',
                  title: 'Eroare!',
                  text: 'Request failed: ' + _context.t0.message,
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching management data:', _context.t0);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    },
    fetchInventare: function fetchInventare() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.companyID) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                clearTimeout(_this3.loadingTimeout);
                _this3.loadingTimeout = setTimeout(function () {
                  _this3.loading = true;
                }, 100);
                _context2.prev = 4;
                params = new URLSearchParams();

                params.append('externalCompanyId', _this3.companyID);
                if (_this3.selectedManagement) params.append('externalLocationId', _this3.selectedManagement);
                if (_this3.selectedStatus) params.append('state', _this3.selectedStatus);

                if (_this3.selectedLocation) params.append('externalLocationId', _this3.selectedLocation.true_id);
                if (_this3.selectedGestiune) params.append('gestiune', _this3.selectedGestiune);
                params.append('page', page);
                params.append('limit', pageSize);

                _context2.next = 15;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/inventare?' + params.toString());

              case 15:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 18;
                  break;
                }

                throw new Error('Failed to fetch inventare');

              case 18:
                _context2.next = 20;
                return response.json();

              case 20:
                data = _context2.sent;


                _this3.totalItems = data.total || 0;
                _this3.currentPage = data.currentPage || page;
                _this3.pageSize = data.pageSize || pageSize;

                _this3.tableData = data.inventare.map(function (inv) {
                  return {
                    series: inv.series || '',
                    number: inv.number || '',
                    state: inv.state || '',
                    gestiune: inv.gestiune ? inv.gestiune.name || inv.gestiune : '',
                    differences: inv.differences || '',
                    note: inv.note || '',
                    date: inv.date || '',
                    scriptDate: inv.scriptDate || '',
                    vatNumber: inv.vatNumber,
                    _id: inv._id
                  };
                });
                _context2.next = 31;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2['catch'](4);

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                  icon: 'error',
                  title: 'Eroare!',
                  text: 'Request failed: ' + _context2.t0.message,
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching inventare:', _context2.t0);

              case 31:
                _context2.prev = 31;

                clearTimeout(_this3.loadingTimeout);
                _this3.loading = false;
                return _context2.finish(31);

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[4, 27, 31, 35]]);
      }))();
    },
    editInventory: function editInventory(row) {
      var externalLocationId = this.selectedLocation && this.selectedLocation.true_id;
      this.$router.push('/management/inventory/edit/' + row.vatNumber + '/' + row.series + '/' + row.number + '/' + externalLocationId);
    },
    downloadExcel: function downloadExcel(row) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var series, number, externalCompanyId, externalLocationId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                series = row.series;
                number = row.number;
                externalCompanyId = _this4.companyID;
                externalLocationId = _this4.selectedLocation && _this4.selectedLocation.true_id;

                if (!(!series || !number)) {
                  _context3.next = 7;
                  break;
                }

                alert('Missing series or number.');
                return _context3.abrupt('return');

              case 7:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/inventar/' + series + '-' + number + '/xls?vatNumber=' + row.vatNumber + '&externalCompanyId=' + externalCompanyId + '&externalLocationId=' + externalLocationId;
                _context3.prev = 8;
                _context3.next = 11;
                return fetch(url);

              case 11:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 15;
                return response.blob();

              case 15:
                blob = _context3.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + number + '.xls';
                link.click();
                URL.revokeObjectURL(link.href);
                _context3.next = 24;
                break;

              case 23:
                console.error('Error downloading:', response.statusText);

              case 24:
                _context3.next = 29;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t0 = _context3['catch'](8);

                console.error('Error fetching:', _context3.t0);

              case 29:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[8, 26]]);
      }))();
    },
    downloadPdf: function downloadPdf(row) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var series, number, externalCompanyId, externalLocationId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                series = row.series;
                number = row.number;
                externalCompanyId = _this5.companyID;
                externalLocationId = _this5.selectedLocation && _this5.selectedLocation.true_id;

                if (!(!series || !number)) {
                  _context4.next = 7;
                  break;
                }

                alert('Missing series or number.');
                return _context4.abrupt('return');

              case 7:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/inventar/' + series + '-' + number + '/pdf?vatNumber=' + row.vatNumber + '&externalCompanyId=' + externalCompanyId + '&externalLocationId=' + externalLocationId;
                _context4.prev = 8;
                _context4.next = 11;
                return fetch(url);

              case 11:
                response = _context4.sent;

                if (!response.ok) {
                  _context4.next = 23;
                  break;
                }

                _context4.next = 15;
                return response.blob();

              case 15:
                blob = _context4.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + number + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                _context4.next = 24;
                break;

              case 23:
                console.error('Error downloading:', response.statusText);

              case 24:
                _context4.next = 29;
                break;

              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4['catch'](8);

                console.error('Error fetching:', _context4.t0);

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[8, 26]]);
      }))();
    },
    deleteInventory: function deleteInventory(row) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Confirmare ștergere',
        text: 'Sigur dore\u0219ti s\u0103 \u0219tergi inventarul ' + row.series + ' ' + row.number + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Da, șterge',
        cancelButtonText: 'Anulează',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false
      }).then(function (result) {
        if (result) {
          fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/inventar', {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json'
            },
            body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
              externalCompanyId: _this6.companyID,
              id: row._id
            })
          }).then(function (response) {
            if (!response.ok) {
              throw new Error('Failed to delete inventar');
            }
            return response.json();
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
              title: 'Șters!',
              text: 'Inventarul a fost șters.',
              icon: 'success',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success'
            });
            _this6.fetchInventare();
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
              title: 'Eroare',
              text: '\u0218tergerea a e\u0219uat: ' + error.message,
              icon: 'error',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger'
            });
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "7t5x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7z/J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8/OZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DiscountCampaignPricingGrid',
  props: {
    products: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pricingData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    combos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    showUnitsSold: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: null
    }
  },
  methods: {
    getCell: function getCell(productId, combo) {
      var key = productId + '_' + combo.source + '_' + combo.method;
      return this.pricingData[key] || null;
    }
  }
});

/***/ }),

/***/ "80MR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "80s4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_time_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);

var DAY_NAMES = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

function buildAvailableDays(existing) {
  var source = Array.isArray(existing) ? existing : [];
  return DAY_NAMES.map(function (name) {
    var found = source.find(function (d) {
      return d && d.day === name;
    });
    if (found) {
      return {
        day: name,
        open: !!found.open,
        open_from: found.open_from || '',
        open_to: found.open_to || '',
        intervals: Array.isArray(found.intervals) ? found.intervals.map(function (iv) {
          return { open_from: iv.open_from || '', open_to: iv.open_to || '' };
        }) : []
      };
    }
    return { day: name, open: false, open_from: '', open_to: '', intervals: [] };
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      view: 'list',
      loading: true,
      attemptedSave: false,
      formError: '',
      preferences: [],
      slots: [],
      zones: [],
      rowKey: 0,
      pickerOptions: { start: '00:00', step: '00:15', end: '24:00' },
      days: [{ key: 1, slug: 'mon' }, { key: 2, slug: 'tue' }, { key: 3, slug: 'wed' }, { key: 4, slug: 'thu' }, { key: 5, slug: 'fri' }, { key: 6, slug: 'sat' }, { key: 0, slug: 'sun' }],
      model: this.emptyModel()
    };
  },
  created: function created() {
    this.getSlots();
    this.getZones();
    this.getData();
  },

  methods: {
    sessionData: function sessionData() {
      var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, extra);
    },
    emptyModel: function emptyModel() {
      return {
        id: null,
        nume_admin: '',
        name: '',
        type: null,
        enabled: true,
        sort_order: 0,
        hour_mode: 1,
        available_days: buildAvailableDays([]),
        offset: 0,
        period: 1,
        no_preorders: false,
        is_always_open: false,
        is_always_open_preorder_hours: 23,
        minimum_order_value: 0,
        default_waiting_time: 0,
        delay_hours: 0,
        auto_assign_first_slot: false,
        schedules: [],
        closed_dates: [],
        zones: [{ delivery_range_id: null }]
      };
    },
    getData: function getData() {
      var _this = this;

      this.loading = true;
      this.apiRequest('/delivery-preference', 'GET', this.sessionData(), function (response) {
        if (response.status === true) {
          _this.preferences = response.data;
        }
        _this.loading = false;
      });
    },
    getSlots: function getSlots() {
      var _this2 = this;

      this.apiRequest('/delivery-slot', 'GET', this.sessionData(), function (response) {
        if (response.status === true) _this2.slots = response.data;
      });
    },
    getZones: function getZones() {
      var _this3 = this;

      this.apiRequest('/delivery-zone', 'GET', this.sessionData(), function (response) {
        if (response.status === true) {
          _this3.zones = (response.data || []).filter(function (z) {
            return z.editable;
          });
        }
      });
    },
    openForm: function openForm(id) {
      var _this4 = this;

      this.formError = '';
      this.attemptedSave = false;
      if (id) {
        var pref = this.preferences.find(function (p) {
          return p.id === id;
        });
        var m = this.emptyModel();
        m.id = pref.id;
        m.nume_admin = pref.nume_admin;
        m.name = pref.name;
        m.type = Number(pref.type);
        m.enabled = !!pref.enabled;
        m.sort_order = Number(pref.sort_order || 0);
        m.hour_mode = pref.hour_mode !== null ? Number(pref.hour_mode) : 1;
        m.available_days = buildAvailableDays(pref.available_days);
        m.offset = Number(pref.offset || 0);
        m.period = Number(pref.period || 1);
        m.no_preorders = !!pref.no_preorders;
        m.is_always_open = !!pref.is_always_open;
        m.is_always_open_preorder_hours = 23;
        m.minimum_order_value = Number(pref.minimum_order_value || 0);
        m.default_waiting_time = Number(pref.default_waiting_time || 0);
        m.delay_hours = Number(pref.delay_hours || 0);
        m.auto_assign_first_slot = !!pref.auto_assign_first_slot;
        m.schedules = (pref.schedules || []).map(function (s) {
          return {
            _k: _this4.rowKey++,
            id: s.id,
            day_of_week: Number(s.day_of_week),
            delivery_slot_id: s.delivery_slot_id ? Number(s.delivery_slot_id) : null,
            start_time: _this4.trimTime(s.start_time),
            end_time: _this4.trimTime(s.end_time),
            active: !!s.active
          };
        });
        m.closed_dates = (pref.closed_dates || []).map(function (c) {
          return {
            _k: _this4.rowKey++,
            date: (c.date || '').substr(0, 10),

            all_day: c.all_day === undefined || c.all_day === null || !!c.all_day ? 1 : 0,

            schedules: (c.schedules || []).map(function (s) {
              return {
                _k: _this4.rowKey++,
                id: s.id,
                delivery_slot_id: s.delivery_slot_id ? Number(s.delivery_slot_id) : null,
                start_time: _this4.trimTime(s.start_time),
                end_time: _this4.trimTime(s.end_time),
                active: !!s.active
              };
            })
          };
        });
        m.zones = (pref.preference_zones || pref.preferenceZones || []).map(function (z) {
          return {
            delivery_range_id: z.delivery_range_id !== null ? Number(z.delivery_range_id) : null
          };
        });
        if (!m.zones.length) m.zones.push({ delivery_range_id: null });
        this.model = m;
      } else {
        this.model = this.emptyModel();
      }
      this.view = 'form';
    },
    trimTime: function trimTime(t) {
      if (!t) return null;
      return String(t).substr(0, 5);
    },
    backToList: function backToList() {
      this.view = 'list';
      this.getData();
    },
    addZone: function addZone() {
      this.model.zones.push({ delivery_range_id: null });
    },
    removeZone: function removeZone(index) {
      if (this.model.zones.length > 1) this.model.zones.splice(index, 1);
    },
    isZoneUsed: function isZoneUsed(rangeId, currentIndex) {
      return this.model.zones.some(function (z, i) {
        return i !== currentIndex && z.delivery_range_id === rangeId;
      });
    },
    isZoneDuplicate: function isZoneDuplicate(index) {
      var id = this.model.zones[index].delivery_range_id;
      if (id === null || typeof id === 'undefined') return false;
      return this.model.zones.findIndex(function (z) {
        return z.delivery_range_id === id;
      }) !== index;
    },
    hasDuplicateZones: function hasDuplicateZones() {
      var ids = this.model.zones.map(function (z) {
        return z.delivery_range_id;
      }).filter(function (v) {
        return v !== null && typeof v !== 'undefined';
      });
      return ids.some(function (v, i) {
        return ids.indexOf(v) !== i;
      });
    },
    timePairInvalid: function timePairInvalid(from, to) {
      if (!from || !to) return true;
      return from >= to;
    },
    scheduleError: function scheduleError() {
      if (this.model.type === 1) {
        if (this.model.is_always_open) return '';
        for (var i = 0; i < this.model.available_days.length; i++) {
          var day = this.model.available_days[i];
          if (!day.open) continue;
          if (!day.open_from || !day.open_to) return this.$t('deliveryPreferences.hoursRequired');
          if (day.open_from >= day.open_to) return this.$t('deliveryPreferences.hoursOrder');
          var intervals = day.intervals || [];
          for (var j = 0; j < intervals.length; j++) {
            var iv = intervals[j];
            if (!iv.open_from || !iv.open_to) return this.$t('deliveryPreferences.hoursRequired');
            if (iv.open_from >= iv.open_to) return this.$t('deliveryPreferences.hoursOrder');
          }
        }
      } else if (this.model.type === 2) {
        for (var _i = 0; _i < this.model.schedules.length; _i++) {
          var row = this.model.schedules[_i];
          if (!row.active) continue;
          if (row.delivery_slot_id === null || typeof row.delivery_slot_id === 'undefined') return this.$t('deliveryPreferences.slotRequired');
          if (!row.start_time || !row.end_time) return this.$t('deliveryPreferences.hoursRequired');
          if (row.start_time >= row.end_time) return this.$t('deliveryPreferences.hoursOrder');
        }

        for (var _i2 = 0; _i2 < this.model.closed_dates.length; _i2++) {
          var cd = this.model.closed_dates[_i2];
          if (!cd.date) continue;
          if (this.closedDateDuplicate(_i2)) return this.$t('deliveryPreferences.closedDateDuplicate');
          if (cd.all_day) continue;
          if (!cd.schedules.length) return this.$t('deliveryPreferences.closedScheduleRequired');
          for (var _j = 0; _j < cd.schedules.length; _j++) {
            var _row = cd.schedules[_j];
            if (!_row.active) continue;
            if (_row.delivery_slot_id === null || typeof _row.delivery_slot_id === 'undefined') return this.$t('deliveryPreferences.slotRequired');
            if (!_row.start_time || !_row.end_time) return this.$t('deliveryPreferences.hoursRequired');
            if (_row.start_time >= _row.end_time) return this.$t('deliveryPreferences.hoursOrder');
          }
        }
      }
      return '';
    },
    moveZone: function moveZone(index, dir) {
      var to = index + dir;
      if (to < 0 || to >= this.model.zones.length) return;
      var arr = this.model.zones;
      var tmp = arr[index];
      this.$set(arr, index, arr[to]);
      this.$set(arr, to, tmp);
    },
    rowsForDay: function rowsForDay(dayKey) {
      return this.model.schedules.filter(function (s) {
        return s.day_of_week === dayKey;
      });
    },
    addScheduleRow: function addScheduleRow(dayKey) {
      this.model.schedules.push({
        _k: this.rowKey++,
        day_of_week: dayKey,
        delivery_slot_id: null,
        start_time: '08:00',
        end_time: '10:00',
        active: true
      });
    },
    removeScheduleRow: function removeScheduleRow(row) {
      var i = this.model.schedules.indexOf(row);
      if (i > -1) this.model.schedules.splice(i, 1);
    },
    addClosedDate: function addClosedDate() {
      this.model.closed_dates.push({ _k: this.rowKey++, date: '', all_day: 1, schedules: [] });
    },
    closedDateDuplicate: function closedDateDuplicate(index) {
      var date = this.model.closed_dates[index].date;
      return !!date && this.model.closed_dates.some(function (c, i) {
        return i !== index && c.date === date;
      });
    },
    removeClosedDate: function removeClosedDate(index) {
      this.model.closed_dates.splice(index, 1);
    },
    dayOfWeek: function dayOfWeek(date) {
      var p = String(date || '').split('-').map(Number);
      if (p.length !== 3 || !p[0] || !p[1] || !p[2]) return null;
      return new Date(p[0], p[1] - 1, p[2]).getDay();
    },
    weekdayLabel: function weekdayLabel(date) {
      var dow = this.dayOfWeek(date);
      var d = this.days.find(function (x) {
        return x.key === dow;
      });
      return d ? this.$t('deliveryPreferences.' + d.slug) : '';
    },
    setOverrideSchedule: function setOverrideSchedule(cd) {
      cd.all_day = 0;
      if (!cd.schedules.length) this.copyWeeklyInto(cd, false);
    },
    copyWeeklyInto: function copyWeeklyInto(cd, confirmReplace) {
      var _this5 = this;

      var dow = this.dayOfWeek(cd.date);
      if (dow === null) return;
      var apply = function apply() {
        cd.schedules = _this5.rowsForDay(dow).map(function (s) {
          return {
            _k: _this5.rowKey++,
            delivery_slot_id: s.delivery_slot_id,
            start_time: s.start_time,
            end_time: s.end_time,
            active: s.active
          };
        });
      };
      if (!confirmReplace || !cd.schedules.length) return apply();
      __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
        title: this.$t('deliveryPreferences.closedCopyConfirm', { day: this.weekdayLabel(cd.date) }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result && (result.value || result === true)) apply();
      }).catch(function () {});
    },
    addOverrideRow: function addOverrideRow(cd) {
      cd.schedules.push({ _k: this.rowKey++, delivery_slot_id: null, start_time: '08:00', end_time: '10:00', active: true });
    },
    removeOverrideRow: function removeOverrideRow(cd, row) {
      var i = cd.schedules.indexOf(row);
      if (i > -1) cd.schedules.splice(i, 1);
    },
    addClassicInterval: function addClassicInterval(dayIdx) {
      var day = this.model.available_days[dayIdx];
      if (!day.intervals) this.$set(day, 'intervals', []);
      day.intervals.push({ open_from: '', open_to: '' });
    },
    deleteClassicInterval: function deleteClassicInterval(intervalKey, dayIdx) {
      this.model.available_days[dayIdx].intervals.splice(intervalKey, 1);
    },
    save: function save() {
      var _this6 = this;

      this.attemptedSave = true;
      if (this.model.type !== 1 && this.model.type !== 2) {
        this.formError = this.$t('general.fillRequiredFields');
        return;
      }
      if (!this.model.name) {
        this.formError = this.$t('general.fillRequiredFields');
        return;
      }
      if (!this.model.zones.length || this.model.zones.some(function (z) {
        return z.delivery_range_id === null || typeof z.delivery_range_id === 'undefined';
      })) {
        this.formError = this.$t('deliveryPreferences.zoneRequired');
        return;
      }
      if (this.hasDuplicateZones()) {
        this.formError = this.$t('deliveryPreferences.duplicateZone');
        return;
      }
      var schedErr = this.scheduleError();
      if (schedErr) {
        this.formError = schedErr;
        return;
      }
      this.formError = '';
      this.loading = true;

      var payload = this.sessionData({
        name: this.model.name,
        nume_admin: this.model.nume_admin,
        type: this.model.type,
        enabled: this.model.enabled,
        sort_order: this.model.sort_order,
        hour_mode: this.model.hour_mode,
        available_days: this.model.available_days,
        offset: this.model.offset,
        period: this.model.period,
        no_preorders: this.model.no_preorders,
        is_always_open: this.model.is_always_open,
        is_always_open_preorder_hours: 23,
        minimum_order_value: this.model.minimum_order_value,
        default_waiting_time: this.model.default_waiting_time,
        delay_hours: this.model.delay_hours,
        auto_assign_first_slot: this.model.auto_assign_first_slot,
        schedules: this.model.schedules.map(function (s) {
          return {
            id: s.id,
            day_of_week: s.day_of_week,
            delivery_slot_id: s.delivery_slot_id,
            start_time: s.start_time,
            end_time: s.end_time,
            active: s.active
          };
        }),
        closed_dates: this.model.closed_dates.filter(function (c) {
          return !!c.date;
        }).map(function (c) {
          return {
            date: c.date,
            all_day: !!c.all_day,
            schedules: c.all_day ? [] : c.schedules.map(function (s) {
              return {
                id: s.id,
                delivery_slot_id: s.delivery_slot_id,
                start_time: s.start_time,
                end_time: s.end_time,
                active: s.active
              };
            })
          };
        }),
        zones: this.model.zones.map(function (z, i) {
          return { delivery_range_id: z.delivery_range_id, sort_order: i + 1 };
        })
      });

      var url = this.model.id ? '/delivery-preference/' + this.model.id : '/delivery-preference';
      var method = this.model.id ? 'PUT' : 'POST';

      this.apiRequest(url, method, payload, function (response) {
        _this6.loading = false;
        if (response.success === true) {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ text: _this6.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(function () {}).catch(function () {});
          _this6.backToList();
        } else {
          _this6.formError = _this6.firstError(response.errors);
        }
      });
    },
    remove: function remove() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
        title: self.$t('deliveryPreferences.deleteConfirm'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result && (result.value || result === true)) {
          self.loading = true;
          self.apiRequest('/delivery-preference/' + self.model.id, 'PUT', self.sessionData({ delete: true }), function (response) {
            self.loading = false;
            if (response.success === true) {
              __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ text: self.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(function () {}).catch(function () {});
              self.backToList();
            } else {
              __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ text: self.firstError(response.errors) || self.$t('validations.wentWrong'), type: 'error', showConfirmButton: false, timer: 2500 }).then(function () {}).catch(function () {});
            }
          });
        }
      }).catch(function () {});
    },
    firstError: function firstError(errors) {
      if (!errors) return '';
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors);
      if (!keys.length) return '';
      var v = errors[keys[0]];
      return Array.isArray(v) ? v[0] : v;
    }
  }
});

/***/ }),

/***/ "82KJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons "},[_c('div',{staticClass:"left-buttons mar-rt-10"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[(_vm.groupedLocations)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date și oră")]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"disabled":_vm.loading,"placeholder":"Selectează intervalul"},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"right-buttons",staticStyle:{"display":"flex","align-items":"center","justify-content":"flex-end"}},[_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.triggerFilter}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.fetchBalanceReport('xls')}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table-wrapper"},[(_vm.tableData && _vm.tableData.length)?_c('div',{staticClass:"consumption-total-header"},[_c('strong',[_vm._v("TOTAL:")]),_vm._v("\n          "+_vm._s(_vm.totalItems)+" produse\n        ")]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"main-table"},[_vm._m(0),_vm._v(" "),(_vm.tableData && _vm.tableData.length)?_c('tbody',_vm._l((_vm.tableData),function(row){return _c('tr',{key:row.nr},[_c('td',[_vm._v(_vm._s(row.nr))]),_vm._v(" "),_c('td',{staticClass:"product-column"},[_vm._v(_vm._s(row.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.unit))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatNumber(row.stock_initial_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatNumber(row.stock_initial_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.entries_nir_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.entries_nir_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.entries_transfer_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.entries_transfer_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.entries_productie_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.entries_productie_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_nir_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_nir_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_vanzare_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_vanzare_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_bon_consum_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_bon_consum_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_transfer_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_transfer_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_productie_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_productie_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_casare_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_casare_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_aviz_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_aviz_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_inventar_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatIfNotZero(row.exits_inventar_val)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatNumber(row.stock_final_qty)))]),_vm._v(" "),_c('td',{staticClass:"numeric"},[_vm._v(_vm._s(_vm.formatNumber(row.stock_final_val)))])])})):_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":29}},[_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","width":"100%","padding":"20px","color":"#909399"}},[_vm._v("\n                  "+_vm._s(_vm.$t('gestiune.noData'))+"\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-left",attrs:{"rowspan":"3"}},[_vm._v("Nr.")]),_vm._v(" "),_c('th',{staticClass:"align-left product-column",attrs:{"rowspan":"3"}},[_vm._v("Produs")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"rowspan":"3"}},[_vm._v("UM")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("STOC INITIAL")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"6"}},[_vm._v("INTRARI")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"16"}},[_vm._v("IESIRI")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("STOC FINAL")])]),_vm._v(" "),_c('tr',{staticClass:"subheaders"},[_c('th',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("NIR")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("Transfer")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("Producție")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("NIR")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("Vânzare")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("Bon consum")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("Transfer")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("Producție")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("Pierdere")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("Aviz")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"2"}},[_vm._v("Diff. Inventar")]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}})]),_vm._v(" "),_c('tr',{staticClass:"subheaders"},[_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Cant")]),_vm._v(" "),_c('th',{staticClass:"align-center numeric"},[_vm._v("Val")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "82iU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.view === 'list')?_c('div',[_c('div',{staticClass:"card mar-to-15",staticStyle:{"width":"calc(100% - 20px)","margin-left":"10px","margin-right":"10px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',[_c('button',{staticClass:"btn add",on:{"click":function($event){$event.preventDefault();_vm.openForm(null)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('deliveryPreferences.slotAdd'))+"\n            ")])])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"70px"}},[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.numeAdmin')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.costPerParte')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.seats')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"130px"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.slots),function(slot){return _c('tr',{key:slot.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.openForm(slot.id)}}},[_c('td',[_vm._v(_vm._s(slot.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(slot.nume_admin))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(slot.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(slot.cost_per_parte !== null ? slot.cost_per_parte : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(slot.seats ? slot.seats.length : 0))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"edit",staticStyle:{"white-space":"nowrap"}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" "+_vm._s(_vm.$t('general.edit')))])])])}),_vm._v(" "),(!_vm.loading && !_vm.slots.length)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"6"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.noData')))])]):_vm._e()],2)])])])])]):_c('div',[_c('div',{staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":function($event){$event.preventDefault();return _vm.backToList($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('deliveryPreferences.back'))+"\n          ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.model.id)?_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.remove($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.delete'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success save mar-rt-10",on:{"click":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"margin":"0 10px"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content"},[(_vm.formError)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.numeAdmin'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nume_admin),expression:"model.nume_admin"}],staticClass:"form-control",class:{'is-invalid': _vm.attemptedSave && !_vm.model.nume_admin},attrs:{"type":"text","placeholder":_vm.$t('deliveryPreferences.numeAdminPlaceholder')},domProps:{"value":(_vm.model.nume_admin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nume_admin", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.name'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",class:{'is-invalid': _vm.attemptedSave && !_vm.model.name},attrs:{"type":"text","placeholder":_vm.$t('deliveryPreferences.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.costPerParte')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.cost_per_parte),expression:"model.cost_per_parte",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","step":"0.01","min":"0","placeholder":"—"},domProps:{"value":(_vm.model.cost_per_parte)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "cost_per_parte", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.costPerParteHelp')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"margin":"0 10px"}},[_c('div',{staticClass:"card-content"},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.seats')))]),_vm._v(" "),_c('p',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.seatsHelp')))])]),_vm._v(" "),(_vm.model.seats.length)?_c('div',{staticClass:"d-flex",staticStyle:{"display":"flex","gap":"10px","margin-bottom":"5px"}},[_c('label',{staticStyle:{"width":"270px","margin-right":"10px","margin-bottom":"0"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.seatsCount')))]),_vm._v(" "),_c('label',{staticStyle:{"width":"270px","margin-right":"10px","margin-bottom":"0"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.seatCost')))]),_vm._v(" "),_c('span',{staticStyle:{"width":"35px"}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.model.seats),function(seat,index){return _c('div',{key:index,staticClass:"d-flex align-items-center",staticStyle:{"display":"flex","gap":"10px","margin-bottom":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(seat.numar),expression:"seat.numar",modifiers:{"number":true}}],staticClass:"form-control",class:{'is-invalid': _vm.attemptedSave && !_vm.isFilled(seat.numar)},staticStyle:{"width":"270px","margin-right":"10px"},attrs:{"type":"number","min":"0","step":"1","placeholder":_vm.$t('deliveryPreferences.seatsCount')},domProps:{"value":(seat.numar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(seat, "numar", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(seat.cost),expression:"seat.cost",modifiers:{"number":true}}],staticClass:"form-control",class:{'is-invalid': _vm.attemptedSave && !_vm.isFilled(seat.cost)},staticStyle:{"width":"270px","margin-right":"10px"},attrs:{"type":"number","min":"0","step":"0.01","placeholder":_vm.$t('deliveryPreferences.seatCost')},domProps:{"value":(seat.cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(seat, "cost", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",staticStyle:{"width":"35px","height":"35px","padding":"0"},on:{"click":function($event){$event.preventDefault();_vm.removeSeat(index)}}},[_c('i',{staticClass:"ti-close"})])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-primary",on:{"click":function($event){$event.preventDefault();return _vm.addSeat($event)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('deliveryPreferences.addSeatTier'))+"\n            ")])],2)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "82ze":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "846y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "86lR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LocationGroupsForm_vue__ = __webpack_require__("s1f/");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'LocationGroupsForm', __WEBPACK_IMPORTED_MODULE_7__LocationGroupsForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      LocationGroupsModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onSubmit: function onSubmit(model, isValid) {
      this.LocationGroupsModel = model;
    }
  }
});

/***/ }),

/***/ "8A7+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8DTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Hhm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't11'
});

/***/ }),

/***/ "8HuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_BackgroundColorPicker_vue__ = __webpack_require__("8zHz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__);














var _components;








__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PSwitch: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__["a" /* default */],
    BackgroundColorPicker: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_BackgroundColorPicker_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getVatRates();
    this.getData();
  },
  data: function data() {
    return {
      id: this.value || this.tableId,
      locations: [],
      table_maps: [],
      model: {
        'id': 0,
        'type': 1,
        'ip_port_printer': null,
        'cash_register_auto_dp_before_z': null,
        'serie_dispozitie_plata': null,
        'numar_dispozitie_plata': null,
        'vat_rates': []
      },
      modelValidate: {
        ip_port_printer: { required: true },
        series: { required: false },
        serie_dispozitie_plata: { required: true },
        numar_dispozitie_plata: { required: true }
      },
      loading: true,
      vatOptions: [],
      vatOptionsLoaded: false,
      printerLoaded: false,
      printerVatMappings: [],
      colors: {
        defult: '#c850c0',
        black: '#000'
      }
    };
  },

  methods: {
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy);
    },
    getData: function getData() {
      var _this = this;

      var id = this.id || this.route.params.id;
      if (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };
        this.apiRequest('/fiscal-printer/' + id, 'GET', data, function (response) {
          if (response.status) {
            _this.model = response.data.fiscalPrinter;
            _this.printerVatMappings = (_this.model.vat_rates || []).slice();
            if (_this.model.location_id) {
              _this.changeLocation(true);
            }
          }
          _this.printerLoaded = true;
          _this.mergeVatMappings();
          _this.loading = false;
        });
      } else {
        this.printerLoaded = true;
        this.mergeVatMappings();
        this.loading = false;
      }
    },
    getVatRates: function getVatRates() {
      var _this2 = this;

      this.apiRequest('/taxes-v2/vat-rates', 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, function (response) {
        if (response.status) {
          _this2.vatOptions = response.data || [];
          _this2.vatOptionsLoaded = true;
          _this2.mergeVatMappings();
        }
      });
    },
    mergeVatMappings: function mergeVatMappings() {
      if (!this.model || !this.vatOptionsLoaded || !this.printerLoaded) return;
      var existing = {};(this.printerVatMappings || []).forEach(function (mapping) {
        existing[String(mapping.vat_rate_id)] = mapping;
      });
      var rows = (this.vatOptions || []).map(function (vat) {
        return {
          vat_rate_id: vat.id,
          rate: vat.rate,
          is_active: vat.is_active,
          vat_printer_id: existing[String(vat.id)] ? existing[String(vat.id)].vat_printer_id : ''
        };
      });
      this.$set(this.model, 'vat_rates', rows);
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (isValid) {
        var companyData = _this3.$session.get('selectedCompanyData') || {};
        var missingVatMapping = (_this3.model.vat_rates || []).some(function (mapping) {
          return !mapping.vat_printer_id || Number(mapping.vat_printer_id) <= 0;
        });
        if (Number(companyData.taxes_version) === 2 && missingVatMapping) {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ text: 'Toate cotele TVA trebuie mapate pe imprimanta fiscală.', type: 'error' });
          return;
        }
        if (isValid) {
          _this3.saveTable();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    saveTable: function saveTable() {
      var _this4 = this;

      this.loading = true;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model, {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany')
      });

      var id = this.id || this.route.params.id;
      var url = '';
      var request = '';
      if (id) {
        url = '/fiscal-printer/' + id;
        request = 'PUT';
      } else {
        url = '/fiscal-printer/add';
        request = 'POST';
      }
      this.apiRequest(url, request, data, function (response) {
        if (response.status === true) {
          _this4.errors.clear();
          if (request === 'POST') {
            _this4.$bus.$emit('refresh');
            _this4.$bus.$emit('close-modal');
          } else {
            _this4.backButton();
          }
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
            title: '',
            text: _this4.$t('settingTable.tableSave'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          _this4.handleErrors(response.errors);
        }
        _this4.loading = false;
      });
    },
    deleteOrderScreen: function deleteOrderScreen() {
      var _this5 = this;

      this.loadingReset = true;
      var id = this.id || this.route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/fiscal-printer/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this5.backButton();
        } else {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': _this5.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
        _this5.loadingReset = false;
      });
    },
    changeLocation: function changeLocation() {
      var _this6 = this;

      var doNotEmptyModel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!doNotEmptyModel) {
        this.model.table_maps_ids = [];
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_id: this.model.location_id
      };
      this.loading = true;
      this.apiRequest('/pos/all/map', 'GET', data, function (response) {
        if (response.status) {
          _this6.table_maps = response.data.fiscalPrinter;
        }
        _this6.loading = false;
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    updateColor: function updateColor(value) {
      this.model.background_color = value;
    }
  }
});

/***/ }),

/***/ "8NBa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zoneAvailability__ = __webpack_require__("ohf7");










__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'zone-availability-editor',
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  props: {
    zone: { type: Object, required: true },

    showErrors: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      uid: this._uid,
      pickerOptions: { start: '00:00', step: '00:15', end: '24:00' }
    };
  },

  computed: {
    error: function error() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__zoneAvailability__["a" /* zoneAvailabilityError */])(this.zone, this.$t.bind(this));
    }
  },
  watch: {
    zone: {
      immediate: true,
      handler: function handler(zone) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__zoneAvailability__["b" /* ensureZoneAvailability */])(this, zone);
      }
    }
  },
  methods: {
    hasOverlap: function hasOverlap(day) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__zoneAvailability__["c" /* overlappingIntervalKeys */])(day)).length > 0;
    },
    isInvalid: function isInvalid(day, key, from, to) {
      if (!day.open) return false;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__zoneAvailability__["c" /* overlappingIntervalKeys */])(day)[key]) return true;
      return this.showErrors && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__zoneAvailability__["d" /* intervalPairInvalid */])(from, to);
    },
    addInterval: function addInterval(dayIdx) {
      var day = this.zone.available_days[dayIdx];
      if (!day.intervals) this.$set(day, 'intervals', []);
      day.intervals.push({ open_from: '', open_to: '' });
    },
    deleteInterval: function deleteInterval(dayIdx, intervalKey) {
      this.zone.available_days[dayIdx].intervals.splice(intervalKey, 1);
    }
  }
});

/***/ }),

/***/ "8NwC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ODs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"referral-role-reward",class:[_vm.columnClass, { 'has-error': _vm.error }]},[_c('h6',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.fieldId + '-type'}},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.rewardKind')))]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":_vm.fieldId + '-type'},domProps:{"value":_vm.value.type},on:{"change":function($event){_vm.changeType($event.target.value)}}},[_c('option',{attrs:{"value":"NONE"}},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.none')))]),_vm._v(" "),_c('option',{attrs:{"value":"FLAT"}},[_vm._v(_vm._s(_vm.$t('referralProgram.cashbackTypeFlat')))]),_vm._v(" "),_c('option',{attrs:{"value":"PERCENT"}},[_vm._v(_vm._s(_vm.$t('referralProgram.cashbackTypePercent')))]),_vm._v(" "),(_vm.allowCoupons)?_c('option',{attrs:{"value":"COUPON"}},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.coupon')))]):_vm._e(),_vm._v(" "),(_vm.value.type === 'LEGACY')?_c('option',{attrs:{"value":"LEGACY"}},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.legacyCombined')))]):_vm._e()])]),_vm._v(" "),(_vm.value.type === 'FLAT' || _vm.value.type === 'PERCENT')?_c('div',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.fieldId + '-value'}},[_vm._v(_vm._s(_vm.$t(_vm.value.type === 'PERCENT' ? 'referralProgram.cashbackPercentValue' : 'referralProgram.cashbackFlatValue')))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":_vm.fieldId + '-value',"type":"number","min":"0","max":_vm.value.type === 'PERCENT' ? 100 : null,"step":"0.0001","aria-invalid":!!_vm.error},domProps:{"value":_vm.value.value},on:{"input":function($event){_vm.update('value', $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.fieldId + '-destination'}},[_vm._v(_vm._s(_vm.$t('referralProgram.rewardType')))]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":_vm.fieldId + '-destination'},domProps:{"value":_vm.value.reward_type == null ? '' : _vm.value.reward_type},on:{"change":function($event){_vm.update('reward_type', $event.target.value || null)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.campaignDefault')))]),_vm._v(" "),_c('option',{attrs:{"value":"1","disabled":!_vm.loyaltyEnabled}},[_vm._v(_vm._s(_vm.$t('referralProgram.rewardTypeLoyaltyPoints')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v(_vm._s(_vm.$t('referralProgram.rewardTypeWallet')))])])])]):_vm._e(),_vm._v(" "),(_vm.value.type === 'COUPON')?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.fieldId + '-coupon'}},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.selectCoupon')))]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":_vm.fieldId + '-coupon',"disabled":_vm.couponsLoading,"aria-invalid":!!_vm.error},domProps:{"value":_vm.value.coupon_id || ''},on:{"change":function($event){_vm.update('coupon_id', $event.target.value)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.selectCoupon')))]),_vm._v(" "),(_vm.missingCoupon)?_c('option',{domProps:{"value":_vm.value.coupon_id}},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.unavailableCoupon', { id: _vm.value.coupon_id })))]):_vm._e(),_vm._v(" "),_vm._l((_vm.coupons),function(coupon){return _c('option',{key:coupon.id,domProps:{"value":coupon.id}},[_vm._v(_vm._s(coupon.name)+" (#"+_vm._s(coupon.id)+")")])})],2),_vm._v(" "),(_vm.couponsLoading)?_c('small',[_vm._v(_vm._s(_vm.$t('referralProgram.v2.loadingCoupons')))]):(!_vm.coupons.length && !_vm.missingCoupon)?_c('small',[_vm._v(_vm._s(_vm.$t('referralProgram.v2.noCoupons')))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.error)?_c('small',{staticClass:"text-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.' + _vm.error)))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text-muted referral-rule-summary"},[_vm._v(_vm._s(_vm.summary))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8VFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_col_css__ = __webpack_require__("jZDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_col_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_col_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_col__ = __webpack_require__("91Nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css__);




























__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_col___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_21_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Switch_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default.a
  },
  computed: {},
  data: function data() {
    return {
      loading: true,
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      searchQuery: '',
      propsToSearch: ['name'],
      tableColumns: [],
      tableData: null,
      filters: [{
        value: '',
        prop: ['name', 'parent_category']
      }],
      sortOrderChanges: {},
      debounceTimeout: null,
      swalLoading: null
    };
  },

  watch: {
    loading: function loading(value) {
      if (value) {
        if (this.swalLoading) {
          return;
        }

        this.swalLoading = __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
          title: '<div style="font-size: 1.2em; margin-bottom: 10px;">' + this.$t('general.loading') + '</div>',
          html: '\n            <div class="custom-loader"></div>\n            <div style="margin-top: 10px;">' + this.$t('general.justMoment') + '</div>\n          ',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: function didOpen() {
            __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default.a.showLoading();
          }
        });
      } else {
        if (this.swalLoading) {
          __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default.a.close();
          this.swalLoading = null;
        }
      }
    }
  },
  created: function created() {
    this.$nextTick(function () {
      this.loading = true;
    });
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        use_sort_order: 'asc'
      };
      this.apiRequest('/sorted-category', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    handleActive: function handleActive(row) {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        active: row.active ? 1 : 0,
        id: row.id,
        version: 3
      };

      this.apiRequest('/category/' + row.id, 'PUT', data, function (response) {
        if (!response.status) {
          __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()('', response.errors.error, 'error').catch(function () {});
          row.active = !row.active;
        } else {
          _this2.trackAdminEvent('ADMIN_CATEGORY_UPDATE', 'category', row.id, {
            category_id: row.id,
            name: row.name || null,
            active: !!row.active
          });
        }
      });
    },
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/categories/edit/');
    },
    adjustSort: function adjustSort(evt) {
      var _this3 = this;

      var categoryId = evt.item.dataset.id;
      var topCategoryIndex = evt.item.dataset.index;
      if (this.tableData[topCategoryIndex].items.length > 1) {
        var idx = evt.newIndex;
        var after, before, sortOrder;
        if (idx === 0) {
          before = 0;
          after = this.tableData[topCategoryIndex].items[idx + 1].sort_order;
        } else if (idx + 1 === this.tableData[topCategoryIndex].items.length) {
          before = this.tableData[topCategoryIndex].items[idx - 1].sort_order;
          after = parseFloat(before) + 1;
        } else {
          before = this.tableData[topCategoryIndex].items[idx - 1].sort_order;
          after = this.tableData[topCategoryIndex].items[idx + 1].sort_order;
        }

        sortOrder = (parseFloat(before) + parseFloat(after)) / 2;
        var data = {
          id: categoryId,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: sortOrder,
          version: 3
        };

        this.apiRequest('/category/' + categoryId, 'PUT', data, function (response) {
          if (response.status !== true) {
            _this3.getData();
            __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
              title: '',
              text: response.errors.error,
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
          }
        });
      }
    },
    onSortOrderInput: function onSortOrderInput(item) {
      var _this4 = this;

      if (item.sort_order < 0) {
        item.sort_order = 0;
      } else if (item.sort_order > 1000) {
        item.sort_order = 1000;
      }

      this.sortOrderChanges[item.id] = {
        sort_order: item.sort_order,
        top_category_id: item.top_category_id
      };

      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(function () {
        _this4.sendSortOrderUpdates();
      }, 1000 * 5);
    },
    sendSortOrderUpdates: function sendSortOrderUpdates() {
      var _this5 = this;

      var updates = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.sortOrderChanges).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            id = _ref2[0],
            value = _ref2[1];

        return {
          id: parseInt(id),
          sortOrder: value.sort_order,
          parentId: value.top_category_id
        };
      });

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        updates: updates
      };

      this.loading = true;

      this.apiRequest('/sort-category-mass-update', 'PUT', data, function (response) {
        if (response.status) {
          _this5.getData();
        } else {
          _this5.loading = false;
          __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
            title: '',
            text: response.errors.message || _this5.$t('validations.wentWrong'),
            type: 'error',
            showConfirmButton: false,
            timer: 5000
          }).catch(function () {});
        }
      });

      this.sortOrderChanges = {};
      this.debounceTimeout = null;
    },
    onlyDigits: function onlyDigits(event) {
      var char = String.fromCharCode(event.which);
      if (!/^\d$/.test(char)) {
        event.preventDefault();
      }
    },
    selectInputText: function selectInputText(event) {
      event.target.select();
    }
  }
});

/***/ }),

/***/ "8aRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__ = __webpack_require__("wpqV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425d00cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__ = __webpack_require__("Kkks");
function injectStyle (ssrContext) {
  __webpack_require__("z58I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425d00cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8bCh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"box-container row tabs-dispatch"},_vm._l((_vm.invoiceRoutes),function(route,index){return _c('div',{key:route.key,staticClass:"col-md-4"},[_c('router-link',{staticClass:"box",style:({ backgroundColor: _vm.getBoxColor(index) }),attrs:{"to":route.path}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('invoice.' + route.key)))]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.getImageForRoute(route.key),"alt":'Image for ' + route.key}})])])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8eBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutomationBeneficiariesPage_vue__ = __webpack_require__("jKkb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d2d518_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutomationBeneficiariesPage_vue__ = __webpack_require__("HE83");
function injectStyle (ssrContext) {
  __webpack_require__("U9DA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutomationBeneficiariesPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d2d518_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutomationBeneficiariesPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8fAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalSignage_vue__ = __webpack_require__("pipV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d39e3fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalSignage_vue__ = __webpack_require__("PTf0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalSignage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d39e3fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalSignage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8fWk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8iMY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row challenge-campaigns-page"},[_c('div',{staticClass:"col-xl-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content",staticStyle:{"position":"relative"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"challenge-campaigns-page__toolbar"},[_c('div',{staticClass:"challenge-campaigns-page__filters"},[_c('div',{staticClass:"form-group challenge-campaigns-page__search"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.search')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('challengeCampaigns.search'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applyFilters($event)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group challenge-campaigns-page__status"},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.status')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","size":"small","placeholder":_vm.$t('general.select')},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}},[_c('el-option',{attrs:{"label":_vm.$t('general.active'),"value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('general.inactive'),"value":0}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group challenge-campaigns-page__search-btn"},[_c('button',{staticClass:"btn add",attrs:{"type":"button","title":_vm.$t('reports.search')},on:{"click":_vm.applyFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"challenge-campaigns-page__add"},[_c('router-link',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('challengeCampaigns.single'),"to":{ path: '/marketing/challenge-campaigns/add' }}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-sm.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.filteredTableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('challengeCampaigns.id'),"width":"70"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('challengeCampaigns.image'),"width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.image)?_c('div',{staticClass:"image-table"},[_c('img',{attrs:{"src":scope.row.image,"alt":""}})]):_c('span',[_vm._v("—")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":_vm.$t('challengeCampaigns.title'),"min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('challengeCampaigns.description'),"min-width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.description || '—')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('challengeCampaigns.target'),"width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.target)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.active'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(scope.row)}},model:{value:(scope.row.active),callback:function ($$v) {_vm.$set(scope.row, "active", $$v)},expression:"scope.row.active"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.goToRecord(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.edit'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.handleDelete(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"center"},attrs:{"layout":"prev, pager, next, sizes, total","total":_vm.filteredAll.length,"page-size":_vm.paginationDef.pageSize,"page-sizes":_vm.paginationDef.pageSizes,"current-page":_vm.paginationDef.currentPage},on:{"update:currentPage":function($event){_vm.$set(_vm.paginationDef, "currentPage", $event)},"size-change":_vm.onPageSizeChange}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8jhb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8mNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8mVm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8n+4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-inventar-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8rJ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8rbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('cantar-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8tZ+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8tlD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-button"},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"1"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"type":"success"},on:{"click":function($event){_vm.addBonProduct()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('gestiune.addBonProduction'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.tableDataBonProduct,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"label":"Nr.","prop":"documentNumber","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.documentNumber)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Serie","prop":"series","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.series)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"La Gestiunea","prop":"gestiune_to","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(_vm.getGestiuneNameById(scope.row.gestiune_to))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Produs"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.items),function(item,idx){return _c('div',{key:idx},[_vm._v("\n                    "+_vm._s(item.name)+" - "+_vm._s(item.quantity)+" "+_vm._s(item.um)+"\n                  ")])})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Lot","prop":"lot"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.lot)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                      ▾\n                    ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editBonProduct(scope.row)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.edit'))+"\n                      ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.download(scope.row)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('invoice.download'))+"\n                      ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadExcel(scope.row)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('gestiune.downloadExcel'))+"\n                      ")]),_vm._v(" "),_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},nativeOn:{"click":function($event){_vm.handleDeleteBonProductie(scope.row._id)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.delete'))+"\n                      ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8vED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loyality_vue__ = __webpack_require__("jgtC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserLabel_UserLabeling_vue__ = __webpack_require__("a5PJ");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loyality: __WEBPACK_IMPORTED_MODULE_0__Loyality_vue__["a" /* default */],
    UserLabeling: __WEBPACK_IMPORTED_MODULE_1__UserLabel_UserLabeling_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isLoyality: true,
      isUserLabeling: false
    };
  },

  methods: {
    openLoyality: function openLoyality() {
      this.isLoyality = true;
      this.isUserLabeling = false;
    },
    openUserLabeling: function openUserLabeling() {
      this.isLoyality = false;
      this.isUserLabeling = true;
    }
  }
});

/***/ }),

/***/ "8yVT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.model = {
      email: '',
      code: '',
      password: '',
      password_confirmation: ''
    };
  },
  data: function data() {
    return {
      model: {},
      modelValidations: {
        email: {
          required: true,
          email: true,
          min: 4
        },
        password: {
          required: true,
          min: 6
        },
        password_confirmation: {
          required: true,
          min: 6
        },
        code: {
          required: true
        }
      },
      recoverMsg: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email', 'code', 'password', 'password_confirmation'])),
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.reset();
        }
      });
    },
    reset: function reset() {
      var creds = {
        email: this.model.email,
        company_id: -1,
        code: this.model.code,
        password_confirmation: this.model.password_confirmation,
        password: this.model.password
      };

      var self = this;
      this.apiRequest('/reset', 'POST', creds, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('', response.data['message'] ? response.data['message'] : 'Please check your email adreess to get the reset code.', 'success').catch({});
          self.$router.push('/login');
        } else {
          for (var prop in response.errors) {
            if (response.errors.hasOwnProperty(prop)) {
              if (response.errors[prop].length === 1) {
                self.errors.add(prop, response.errors[prop][0]);
              } else {
                self.errors.add(prop, response.errors[prop]);
              }
            }
          }
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "8zHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackgroundColorPicker_vue__ = __webpack_require__("N589");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d2b9c37_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackgroundColorPicker_vue__ = __webpack_require__("0wHK");
function injectStyle (ssrContext) {
  __webpack_require__("30fc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d2b9c37"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackgroundColorPicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d2b9c37_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackgroundColorPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9/pE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "903Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ImageBarcodeReader_vue__ = __webpack_require__("NqnY");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a9bff776_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ImageBarcodeReader_vue__ = __webpack_require__("FcRW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ImageBarcodeReader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a9bff776_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ImageBarcodeReader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "930j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('invoice-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "93oy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-10 col-sm-12 "},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-right",staticStyle:{"position":"relative","z-index":"2"}},[_c('router-link',{staticClass:"btn btn-info btn-icon add mar-bt-20",attrs:{"title":"","to":{ path: 'product-option/add'}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])],1)]),_vm._v(" "),_c('table',{ref:"sortableTable",staticClass:"table align-center width-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('companyOptions.id')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('companyOptions.image')))]),_vm._v(" "),_c('th',{attrs:{"width":"30%"}},[_vm._v(_vm._s(_vm.$t('companyOptions.name')))]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.$t('companyOptions.type')))]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.$t('companyOptions.active')))]),_vm._v(" "),_c('th',{attrs:{"width":"40%"}})])]),_vm._v(" "),_c('draggable',{attrs:{"sort":false,"element":'tbody'},on:{"end":_vm.adjustSort},model:{value:(_vm.optionData),callback:function ($$v) {_vm.optionData=$$v},expression:"optionData"}},[_vm._l((_vm.optionData),function(item,index){return [_c('tr',{key:item.id,staticClass:"sortableRow"},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"image-table"},[_c('img',{attrs:{"src":(item.image[0].url)?item.image[0].url : ''}})])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('td',[[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(item)}},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}})]],2),_vm._v(" "),_c('td',[_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(item,[],[], $event)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                  ")])])])]})],2)],1)])])]),_vm._v(" "),_c('div',{staticClass:"space_for_alert_box",staticStyle:{"height":"100px","width":"100%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "94sP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceSettings_vue__ = __webpack_require__("Gddo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60dc6810_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceSettings_vue__ = __webpack_require__("iE/4");
function injectStyle (ssrContext) {
  __webpack_require__("ZqJc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60dc6810"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60dc6810_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9720":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "9G8F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Gda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PromosForm_vue__ = __webpack_require__("SB3G");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PromosForm', __WEBPACK_IMPORTED_MODULE_7__PromosForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      offerModel: {},
      offer: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onOfferSubmit: function onOfferSubmit(model, isValid) {
      this.offerModel = model;
    }
  }
});

/***/ }),

/***/ "9KLf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_utils_btPayments__ = __webpack_require__("pAUm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__);












var _components;







__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a), _components),
  props: {
    paymentGroupId: null,
    callback: {
      required: false
    },
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    paymentGroupId: function paymentGroupId(value) {
      this.id = value;
    }
  },
  created: function created() {
    console.log('route', this.route);
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getData();
  },
  data: function data() {
    return {
      apiUrl: '',
      btFormError: '',
      id: this.value || this.paymentGroupId,
      isNew: true,
      model: {
        'id': 0,
        'name': '',
        'bt_ipay_data': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_src_utils_btPayments__["a" /* btSettings */])(),
        'libra_pay_data': {
          'merch_name': '',
          'merch_url': '',
          'email': '',
          'key': '',
          'merchant': '',
          'terminal': '',
          'postAction': ''
        }
      },
      modelValidate: {
        name: { required: true },

        merch_name: { required: true },
        merch_url: { required: true },
        email: { required: true },
        key: { required: true },
        merchant: { required: true },
        postAction: { required: true }
      },
      locations: ['btIpay', 'euplatesc', 'paylike', 'stripe', 'vivaWallet', 'libraPay'],
      languages: this.$session.get('defaultData')['available_languages'],
      loading: true
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (this.$route.params.id !== undefined && this.$route.params.id || this.id !== undefined && this.id !== null) {
        this.isNew = false;
      } else {
        this.isNew = true;
      }
      if (!this.isNew) {
        var id = this.$route.params.id || this.id;
        this.apiRequest('/payment-group/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            _this.model = response.data;
            if (_this.model.gateway === 'btIpay') {
              _this.$set(_this.model, 'bt_ipay_data', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_src_utils_btPayments__["a" /* btSettings */])(_this.model.bt_ipay_data || {}));
            }
            _this.loading = false;
          }
        });
      } else {
        this.loading = false;
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveZone();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    changeGateway: function changeGateway() {
      this.btFormError = '';
      if (this.model.gateway === 'btIpay' && !this.model.bt_ipay_data) {
        this.$set(this.model, 'bt_ipay_data', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_src_utils_btPayments__["a" /* btSettings */])());
      }
      if (this.model.gateway === 'paylike') {
        this.model.gateway_id = '';
        this.model.public_key = '';
        this.model.private_key = '';
        this.model.UKEY = '';
        this.model.UAPI = '';
      }
      if (this.model.gateway === 'euplatesc') {
        this.model.gateway_id = '';
        this.model.public_key = '';
        this.model.private_key = '';
        this.model.UKEY = '';
        this.model.UAPI = '';
      }
      if (this.model.gateway === 'stripe') {
        this.model.gateway_id = 'stripe';
        this.model.public_key = '';
        this.model.private_key = '';
        this.model.UKEY = '';
        this.model.UAPI = '';
      }
      if (this.model.gateway === 'vivaWallet') {
        this.model.gateway_id = 'vivaWallet';
        this.model.public_key = '';
        this.model.private_key = '';
        this.model.UKEY = '';
        this.model.UAPI = '';
      }
      if (this.model.gateway === 'libraPay') {
        this.model.gateway_id = 'libraPay';
        this.model.libra_pay_data = {
          merch_name: '',
          merch_url: '',
          email: '',
          key: '',
          merchant: '',
          terminal: '',
          postAction: 'https://secure.librapay.ro/pay_auth.php'
        };
      }
    },
    saveZone: function saveZone() {
      var _this3 = this;

      this.loading = true;
      this.btFormError = '';
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.model);
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      data.group_name = this.model.group_name;
      data.group_key = this.model.gateway === 'btIpay' && this.model.group_key ? this.model.group_key : this.model.group_name.toLowerCase().replace(/\s+/g, '') + '_' + data.company_id + '_' + new Date().getTime();
      data.gateway = this.model.gateway;
      data.gateway_id = this.model.gateway_id;
      data.public_key = this.model.public_key;
      data.private_key = this.model.private_key;
      data.UKEY = this.model.UKEY;
      data.UAPI = this.model.UAPI;
      data.libra_pay_data = this.model.libra_pay_data;
      if (this.model.gateway === 'btIpay') {
        data.bt_ipay_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.model.bt_ipay_data);
        delete data.bt_ipay_data.has_api_password;
        if (!data.bt_ipay_data.api_password) delete data.bt_ipay_data.api_password;
      } else {
        delete data.bt_ipay_data;
      }
      this.apiRequest('/payment-group/' + data.id, 'PUT', data, function (response) {
        if (response.success === true) {
          _this3.loading = false;
          _this3.errors.clear();
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
            title: '',
            text: _this3.$t('settingTable.tableSave'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).then(function () {}).catch(function () {});
          if (_this3.model.gateway === 'btIpay') _this3.model.bt_ipay_data.api_password = '';
          _this3.cancelZone();
        } else {
          _this3.loading = false;
          if (_this3.model.gateway === 'btIpay') {
            _this3.btFormError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_src_utils_btPayments__["b" /* btApiError */])(response, _this3.$t('btPayments.saveError'));
          } else {
            _this3.handleErrors(response.errors);
          }
        }
      });
    },
    deleteZone: function deleteZone() {
      var _this4 = this;

      var btnCounter = 3;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
        title: 'Are you sure?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          _this4.deleteZone2();
        }
      });
      __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    deleteZone2: function deleteZone2() {
      var _this5 = this;

      this.loadingReset = true;
      var id = this.id || this.$route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/payment-group/' + id, 'PUT', data, function (response) {
        if (response.success === true) {
          _this5.loadingReset = false;
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this5.cancelZone();
        } else {
          _this5.loadingReset = false;
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({ 'text': _this5.model.gateway === 'btIpay' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_src_utils_btPayments__["b" /* btApiError */])(response, _this5.$t('btPayments.saveError')) : _this5.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    cancelZone: function cancelZone() {
      if (typeof this.callback === 'function') {
        this.callback();
      }
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "9M6q":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAABHNCSVQICAgIfAhkiAAAAqJJREFUSEu9VkFuU0EMtflBaldJT0C5QTgByQYpbIAlKlWSExBOQHsCygnSqq1YNt00Ehs+J2hygxyBHUVNMzxPZj6e3z+TBCq8iuZ7/PzsZ0+Y1rTxuemRoa4x1GSmBq7lxJR39vhwzRBwX2HjL2bX3NEFHJsR1xmS6Hf2OV8VKwl2dWpeI8DQMUnHYjpYxbIS7NvQNG4e0ydE763KtvQ9pwws3/Ks6t49sK/npjk3YBMvWxIfPf0Bh/7LfR6VHQOwqzMzwIEwipuhKTo9gUM37UZH27d02O6zgFuzYImyXSLTGXr2vghsqL01pwnKLKWqu/McftPADx8M0QSAbQ9owSCEHI7PdaZw/MAZjcycrpVALjvvWERD41NzgFQ/6iRwpwHfY5VEAMhufobq0jR7RL0XezxBEkdBthk91c1H2WfI9olnh0TaUqWfNRrp5MH6M3o44PGZkUa+shdQCpSo5WmXgp0gWE+zLye6dUs7/q6OK6IB2I6AgX3RwT5mRcpgLfiGXlUNbsxHVH1n6LqIjaoImKjFN1on/rC/HZgwScr4n1HRHlSlyU72Arjs20MbgLzgiqG2oLXosl2mwHZ9Lasgw000SOZWo5lWL9v1tLDzclK1YnQwPVuQ1Xf4t1JgsshldJz0R4FAMqZnMl+xAJuCBeJzAvkj/Yi8PfhfgAWxwzn7n2BsaLDI7Ean7V801RtbztZhBp+WyWQlQk8L/HXwBiIhM9WsqncpBeY2xgVC7Fb2PAXmL2jRxMDcrMpqqgZajkqcWcHebexUGZ3EhVXc7oE5geinRc9TjFn0XC/5GNjGQdVDGiRXAXYM7l39lomisJrknavj8hu/WfQ5vhfPkROHKK+uz4s3zS9iKbI4lzeHbfoWNcp/yzY917F/Az3V1WrEXmoLAAAAAElFTkSuQmCC"

/***/ }),

/***/ "9NOQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__);
















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);

var emptyForm = function emptyForm() {
  return {
    id: null,
    name: '',
    applies_to: 'delivery',
    calculation_type: 'fixed',
    value: 0,
    pos_id: '',
    vat_rate_id: '',
    is_active: true,
    location_ids: [],
    source_ids: [],
    method_ids: [3],
    delivery_range_ids: [],
    product_ids: [],
    company_option_value_ids: [],
    delivery_cost_ranges: []
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeliveryTaxPanel',
  props: {
    locationId: { default: null },
    deliveryRangeId: { default: null },
    currency: { type: String, default: 'lei' }
  },
  data: function data() {
    return {
      loading: false,
      saving: false,
      editorLoading: false,
      editorOpen: false,
      assignmentOpen: false,
      assigning: false,
      selectedExistingTaxIds: [],
      rules: [],
      vatRates: [],
      form: emptyForm(),
      sources: [{ id: 1, name: 'Website' }, { id: 2, name: 'QR' }, { id: 3, name: 'Kiosk' }, { id: 4, name: 'POS' }, { id: 5, name: 'App' }, { id: 6, name: 'Glovo' }, { id: 7, name: 'Bolt' }, { id: 8, name: 'Wolt' }]
    };
  },

  computed: {
    appliedTaxes: function appliedTaxes() {
      var _this = this;

      return this.rules.filter(function (rule) {
        if (!rule || rule.applies_to !== 'delivery') return false;
        var locations = rule.location_ids || [];
        var ranges = rule.delivery_range_ids || [];
        var matchesLocation = !_this.locationId || !locations.length || locations.some(function (id) {
          return String(id) === String(_this.locationId);
        });
        var matchesRange = _this.deliveryRangeId ? !ranges.length || ranges.some(function (id) {
          return String(id) === String(_this.deliveryRangeId);
        }) : !ranges.length;
        return matchesLocation && matchesRange;
      });
    },
    selectableVatRates: function selectableVatRates() {
      var _this2 = this;

      return this.vatRates.filter(function (vat) {
        return vat.is_active || String(vat.id) === String(_this2.form.vat_rate_id);
      });
    },
    assignableTaxes: function assignableTaxes() {
      var _this3 = this;

      if (!this.deliveryRangeId) return [];
      return this.rules.filter(function (rule) {
        if (!rule || rule.applies_to !== 'delivery') return false;
        var ranges = rule.delivery_range_ids || [];
        if (!ranges.length) return false;
        return !ranges.some(function (id) {
          return String(id) === String(_this3.deliveryRangeId);
        });
      });
    }
  },
  watch: {
    locationId: function locationId() {
      this.loadRules();
    },
    deliveryRangeId: function deliveryRangeId() {
      this.loadRules();
    }
  },
  created: function created() {
    this.loadRules();
    this.loadVatRates();
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('delivery-tax-editor-open');
  },

  methods: {
    requestData: function requestData(extra) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ token: this.$session.get('token'), company_id: this.$session.get('selectedCompany') }, extra || {});
    },
    loadRules: function loadRules() {
      var _this4 = this;

      this.loading = true;
      this.apiRequest('/taxes-v2/rules', 'GET', this.requestData(), function (response) {
        _this4.loading = false;
        _this4.rules = response.status ? response.data || [] : [];
      });
    },
    loadVatRates: function loadVatRates() {
      var _this5 = this;

      this.apiRequest('/taxes-v2/vat-rates', 'GET', this.requestData(), function (response) {
        _this5.vatRates = response.status ? response.data || [] : [];
      });
    },
    scopeIds: function scopeIds(value) {
      if (value === null || value === undefined || value === '') return [];
      var numberValue = Number(value);
      return [__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(numberValue) ? value : numberValue];
    },
    openCreate: function openCreate() {
      this.form = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(emptyForm(), {
        location_ids: this.scopeIds(this.locationId),
        delivery_range_ids: this.scopeIds(this.deliveryRangeId)
      });
      this.editorLoading = false;
      this.openEditor();
    },
    openAssignment: function openAssignment() {
      var _this6 = this;

      this.selectedExistingTaxIds = [];
      this.assignmentOpen = true;
      document.body.classList.add('delivery-tax-editor-open');
      this.$nextTick(function () {
        if (_this6.$refs.assignmentEditor && _this6.$refs.assignmentEditor.parentNode !== document.body) {
          document.body.appendChild(_this6.$refs.assignmentEditor);
        }
        if (_this6.$refs.assignmentEditor) _this6.$refs.assignmentEditor.scrollTop = 0;
      });
    },
    closeAssignment: function closeAssignment() {
      if (this.assigning) return;
      this.assignmentOpen = false;
      this.selectedExistingTaxIds = [];
      document.body.classList.remove('delivery-tax-editor-open');
    },
    assignExistingTaxes: function assignExistingTaxes() {
      var _this7 = this;

      if (!this.deliveryRangeId || !this.selectedExistingTaxIds.length) return;
      this.assigning = true;
      this.apiRequest('/taxes-v2/delivery-ranges/' + this.deliveryRangeId + '/rules', 'POST', this.requestData({ tax_rule_ids: this.selectedExistingTaxIds }), function (response) {
        _this7.assigning = false;
        if (!response.status) return _this7.notify(_this7.responseMessage(response, 'Taxele nu au putut fi atribuite zonei.'), 'error');
        var assignedCount = (response.data && response.data.attached_tax_rule_ids || []).length;
        _this7.notify(assignedCount === 1 ? 'Taxa a fost atribuită zonei.' : 'Taxele au fost atribuite zonei.');
        _this7.closeAssignment();
        _this7.loadRules();
        _this7.$emit('saved');
      });
    },
    openEdit: function openEdit(tax) {
      var _this8 = this;

      this.editorLoading = true;
      this.openEditor();
      this.apiRequest('/taxes-v2/rules/' + tax.id, 'GET', this.requestData(), function (response) {
        _this8.editorLoading = false;
        if (!response.status) {
          _this8.notify(_this8.responseMessage(response, 'Taxa nu a putut fi încărcată.'), 'error');
          _this8.closeEditor();
          return;
        }
        _this8.form = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(emptyForm(), JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.data || {})));
        if (!Array.isArray(_this8.form.delivery_cost_ranges)) _this8.$set(_this8.form, 'delivery_cost_ranges', []);
      });
    },
    openEditor: function openEditor() {
      var _this9 = this;

      this.editorOpen = true;
      document.body.classList.add('delivery-tax-editor-open');
      this.$nextTick(function () {
        if (_this9.$refs.editor && _this9.$refs.editor.parentNode !== document.body) {
          document.body.appendChild(_this9.$refs.editor);
        }
        if (_this9.$refs.editor) _this9.$refs.editor.scrollTop = 0;
      });
    },
    closeEditor: function closeEditor() {
      if (this.saving) return;
      this.editorOpen = false;
      this.editorLoading = false;
      this.form = emptyForm();
      document.body.classList.remove('delivery-tax-editor-open');
    },
    save: function save() {
      var _this10 = this;

      if (!this.form.name) return this.notify('Completează numele taxei.', 'error');
      if (this.form.vat_rate_id === '' || this.form.vat_rate_id === null) return this.notify('Selectează TVA-ul taxei.', 'error');
      if (Number(this.form.value) < 0) return this.notify('Costul taxei nu poate fi negativ.', 'error');
      var payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.form)), { applies_to: 'delivery', calculation_type: 'fixed', method_ids: [3] });
      var isEdit = !!payload.id;
      this.saving = true;
      this.apiRequest('/taxes-v2/rules' + (isEdit ? '/' + payload.id : ''), isEdit ? 'PUT' : 'POST', this.requestData(payload), function (response) {
        _this10.saving = false;
        if (!response.status) return _this10.notify(_this10.responseMessage(response, 'Taxa nu a putut fi salvată.'), 'error');
        _this10.notify(isEdit ? 'Taxa a fost actualizată.' : 'Taxa a fost creată.');
        _this10.closeEditor();
        _this10.loadRules();
        _this10.$emit('saved', response.data || payload);
      });
    },
    addCostRange: function addCostRange() {
      this.form.delivery_cost_ranges.push({ distance_in_km: '', shipping_cost: '', pos_id: '', min_order_value: 0, extra_delivery_time: 0 });
    },
    removeCostRange: function removeCostRange(index) {
      this.form.delivery_cost_ranges.splice(index, 1);
    },
    existingTaxLabel: function existingTaxLabel(tax) {
      return tax.name + ' \u2014 ' + this.money(tax.value) + ' ' + this.currency + (tax.is_active ? '' : ' (inactivă)');
    },
    money: function money(value) {
      return Number(value || 0).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    rate: function rate(value) {
      return Number(value || 0).toLocaleString('ro-RO', { maximumFractionDigits: 2 });
    },
    responseMessage: function responseMessage(response, fallback) {
      var errorData = response && response.error && response.error.response && response.error.response.data;
      if (response && response.message) return response.message;
      if (errorData && errorData.message) return errorData.message;
      if (errorData && errorData.errors) {
        var firstKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errorData.errors)[0];
        var value = firstKey ? errorData.errors[firstKey] : null;
        if (Array.isArray(value)) return value[0];
        if (value) return value;
      }
      return fallback;
    },
    notify: function notify(text, type) {
      __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ text: text, type: type || 'success', showConfirmButton: false, timer: 2200 });
    }
  }
});

/***/ }),

/***/ "9OgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__);

















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default.a
  },
  watch: {
    homepage: function homepage(newValue, oldValue) {
      this.homepageText = newValue === true ? this.$t('marketingOffers.offers') : this.$t('marketingOffers.banners');
      this.updateHomepage(newValue);
    },
    triggerModal: function triggerModal(newValue, oldValue) {
      this.addGroup();
    }
  },
  computed: {},
  props: {
    triggerModal: {
      type: Boolean
    }
  },
  data: function data() {
    var _this = this;

    return {
      loading: true,
      homepage: this.$session.get('selectedCompanyData')['homepage'],
      homepageText: '',
      selected_group_idx: null,
      group: {
        id: '',
        name: '',
        display: '',
        status: ''
      },
      current_group: 0,
      actionCol: {
        label: 'Delete',
        props: {
          align: 'center'
        },
        buttons: [{
          props: {
            type: 'danger',
            icon: 'el-icon-delete',
            class: 'btn btn-orange btn-fill'
          },
          handler: function handler(index, row) {
            _this.handleDelete(index, row);
          },
          label: 'delete'
        }]
      },
      paginationDef: {
        pageSize: 999,
        currentPage: 1,
        pageSizes: [999],
        show: false,
        disabled: true
      },
      searchQuery: '',
      propsToSearch: ['name', 'status', 'type', 'discount'],
      tableColumns: [],
      groupsData: [],
      filters: [{
        value: '',
        prop: ['title', 'link_type', 'date_start', 'date_end']
      }],
      groupValidations: {
        group_name: {
          required: true
        },
        group_display: {
          required: true
        }
      }
    };
  },
  created: function created() {
    this.initPage();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.initPage();
    },
    initPage: function initPage() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.loading = true;
      });

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        use_sort_order: 'asc'
      };

      this.getOffers(data);
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.errors.clear();
          _this3.saveGroup();
        }
      });
    },
    onEnd: function onEnd(evt) {
      var _this4 = this;

      if (this.groupsData.length > 1) {
        var idx = evt.newIndex;
        var after, before, sortOrder;

        if (idx === 0) {
          before = 0;
          after = this.groupsData[idx + 1].sort_order;
        } else if (idx + 1 === this.groupsData.length) {
          before = this.groupsData[idx - 1].sort_order;
          after = parseFloat(before) + 1;
        } else {
          before = this.groupsData[idx - 1].sort_order;
          after = this.groupsData[idx + 1].sort_order;
        }

        sortOrder = (parseFloat(before) + parseFloat(after)) / 2;
        var id = this.groupsData[idx].id;

        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: sortOrder
        };

        this.apiRequest('/homepage-offer/update-group/' + id, 'PUT', data, function (response) {
          if (response.status !== true) {
            __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
              title: '',
              text: _this4.$t('validations.dataCouldNotBeSaved'),
              type: 'danger',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
          }
        });
      }
    },
    toggleVisibility: function toggleVisibility(idx, event) {
      if (!this.ignoreToggle(event)) return false;

      this.groupsData[idx].visibility = !this.groupsData[idx].visibility;
      this.current_group = idx;
    },
    ignoreToggle: function ignoreToggle(event) {
      var check = event.srcElement.className === 'fa fa-angle-right' || event.srcElement.className === 'fa fa-angle-down' || event.srcElement.className === 'group_name';
      return check;
    },
    getOffers: function getOffers(data) {
      var _this5 = this;

      this.apiRequest('/homepage-offer', 'GET', data, function (response) {
        if (response.status === true) {
          _this5.groupsData = response.data;
          var active = parseInt(_this5.$route.query.active);
          if (active) {
            _this5.groupsData.forEach(function (el, idx) {
              if (el.id === active) {
                el.visibility = 1;
                _this5.current_group = idx;
              }
            });
          }
        }
        _this5.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    addGroup: function addGroup() {
      this.emptyModal();
      this.$modal.show('groupModal');
    },
    saveGroup: function saveGroup() {
      var _this6 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: this.group.id,
        name: this.group.name,
        display: this.group.display
      };
      this.apiRequest('/homepage-offer/add', 'POST', data, function (response) {
        if (response.status) {
          _this6.getOffers(data);
          _this6.emptyModal();
          _this6.$modal.hide('groupModal');
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()(_this6.$t('general.success') + '!', _this6.$t('marketingOffers.offerSuccess'), 'success').catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this6.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    editGroup: function editGroup(data, idx) {
      this.$modal.show('groupModal');

      this.group.id = data.id;
      this.group.name = data.name;
      this.group.display = data.display;
    },
    emptyModal: function emptyModal() {
      this.group.id = '';
      this.group.name = '';
      this.group.display = '';
    },
    deleteGroup: function deleteGroup(id, name, idx) {
      var _this7 = this;

      var self = this;

      event.stopPropagation();
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        text: self.$t('marketingCampaigns.areYouSureDelete') + (' \'' + name + '\'?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this7.$session.get('token'),
            company_id: _this7.$session.get('selectedCompany')
          };
          _this7.apiRequest('/homepage-offer/delete-group/' + id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('marketingOffers.offerDeleted'), 'success');
              self.groupsData.splice(idx, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function () {});
    },
    handleActiveGroup: function handleActiveGroup(group) {
      var _this8 = this;

      var actionText = group.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + group.name + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this8.$session.get('token'),
            company_id: _this8.$session.get('selectedCompany'),
            active: group.active ? 1 : 0,
            name: group.name,
            display: group.display,
            id: group.id
          };
          _this8.apiRequest('/homepage-offer/add', 'POST', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()(_this8.$t('general.success') + '!', '', 'success').catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this8.$t('validations.wentWrong'), 'error').catch(function () {});
              group.active = !group.active;
            }
          });
        }
      }).catch(function () {
        group.active = !group.active;
      });
    },
    updateHomepage: function updateHomepage(option) {
      var _this9 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        option: option ? 1 : 0
      };
      this.apiRequest('/homepage-offer/update-company', 'POST', data, function (response) {
        if (response.status) {
          var selected = _this9.$session.get('selectedCompanyData');
          selected.homepage = option;
          _this9.$session.set('selectedCompanyData', selected);
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()(_this9.$t('general.success') + '!', 'Optiune homepage updatata', 'success').catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this9.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    handleActive: function handleActive(row) {
      var _this10 = this;

      var actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + row.title + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this10.$session.get('token'),
            company_id: _this10.$session.get('selectedCompany'),
            active: row.active ? 1 : 0,
            id: row.id
          };

          var self = _this10;
          _this10.apiRequest('/homepage-offer/update-banner/' + row.id, 'PUT', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()(self.$t('general.success') + '!', '', 'success').catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        row.active = !row.active;
      });
    },
    goToRecord: function goToRecord(group, banner) {
      this.$router.push('/marketing/offers/' + group + '/edit-group-banner/' + banner);
    },
    adjustSort: function adjustSort(evt) {
      if (this.groupsData.length > 1) {
        var idx = evt.newIndex;
        var after, before, sortOrder;
        var group = this.current_group;
        if (idx === 0) {
          before = 0;
          after = this.groupsData[group].banners[idx + 1].sort_order;
        } else if (idx + 1 === this.groupsData[group].length) {
          before = this.groupsData[group].banners[idx - 1].sort_order;
          after = parseFloat(before) + 1;
        } else {
          before = this.groupsData[group].banners[idx - 1].sort_order;
          after = this.groupsData[group].banners[idx + 1].sort_order;
        }
        sortOrder = (parseFloat(before) + parseFloat(after)) / 2;
        var id = this.groupsData[group].banners[idx].id;

        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: sortOrder
        };
        var self = this;
        this.apiRequest('/homepage-offer/update-banner/' + id, 'PUT', data, function (response) {
          if (response.status !== true) {
            __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
              title: '',
              text: self.$t('validations.dataCouldNotBeSaved'),
              type: 'danger',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
          }
        });
      }
    },
    handleDelete: function handleDelete(index, row, idx, event) {
      var _this11 = this;

      var self = this;

      event.stopPropagation();
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        text: self.$t('marketingCampaigns.areYouSureDelete') + (' \'' + row.title + '\'?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this11.$session.get('token'),
            company_id: _this11.$session.get('selectedCompany')
          };
          _this11.apiRequest('/homepage-offer/delete-banner/' + row.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('marketingOffers.offerDeleted'), 'success');
              self.groupsData[idx].banners.splice(index, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "9PmA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9S8B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("Yq4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog__ = __webpack_require__("qubY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__);



















var _components;







__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default.a), _components),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_vee_validate__["b" /* mapFields */])(['name', 'description', 'sort_order', 'parent_id', 'date_validfrom', 'date_validto', 'display_type'])),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pickerOptions1: {},
      pickerNames: ['date_validfrom', 'date_validto'],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      model: {},
      filelist: [],
      filelistToUpload: [],
      generalSuccess: '',
      modelValidations: {
        title: {
          required: true,
          min: 4
        }
      },
      categories: [],
      products: [],
      loading: true,
      locations: [],
      groups: [],
      imageWeb: [],
      removeImage: false,
      removeWeb: false,
      removeBanner: false,
      removeLanding: false
    };
  },

  created: function created() {
    var _this = this;

    this.locations = this.getCompanyDetail('locations_details');
    this.$nextTick(function () {
      this.loading = true;
    });

    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    var self = this;

    this.apiRequest('/category', 'GET', data, function (response) {
      if (response.status === true) {
        self.categories = response.data;
      }
    });
    this.apiRequest('/product', 'GET', data, function (response) {
      if (response.status === true) {
        self.products = response.data;
      }
    });
    this.apiRequest('/customersgroup', 'GET', data, function (response) {
      if (response.status === true) {
        _this.groups = response.data;
      }
    });

    if (this.route.params.id) {
      var id = this.route.params.id;

      this.apiRequest('/banner/' + id, 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data[0].date_start && response.data[0].date_end) {
            response.data[0].fromto = [response.data[0].date_start, response.data[0].date_end];
          }
          if (response.data[0].image) {
            response.data[0].imagelist = [{ url: response.data[0].image }];
          } else {
            response.data[0].imagelist = [];
          }
          if (response.data[0].image_web) {
            response.data[0].imageWeb = [{ url: response.data[0].image_web }];
          } else {
            response.data[0].imageWeb = [];
          }
          if (response.data[0].image_landing) {
            response.data[0].imageLanding = [{ url: response.data[0].image_landing }];
          } else {
            response.data[0].imageLanding = [];
          }
          if (response.data[0].image_banner) {
            response.data[0].imageBanner = [{ url: response.data[0].image_banner }];
          } else {
            response.data[0].imageBanner = [];
          }
          self.model = response.data[0];

          self.$nextTick(function () {
            self.loading = false;
          });
        }
      });
    } else {
      self.$nextTick(function () {
        self.loading = false;
      });
    }
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.errors.clear();
          _this2.saveOffer();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors[prop].length === 1) {
          this.errors.add(prop, errors[prop][0]);
        } else {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    isNew: function isNew() {
      if (this.route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    handleImgChangeLanding: function handleImgChangeLanding(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imageLanding = [];
      } else {
        if (fileList.length > 1) {
          this.model.imageLanding = fileList.slice(1);
        } else {
          this.model.imageLanding = fileList;
        }
      }
    },
    handleImgChangeBanner: function handleImgChangeBanner(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imageBanner = [];
      } else {
        if (fileList.length > 1) {
          this.model.imageBanner = fileList.slice(1);
        } else {
          this.model.imageBanner = fileList;
        }
      }
    },
    handleImgChangeWeb: function handleImgChangeWeb(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imageWeb = [];
      } else {
        if (fileList.length > 1) {
          this.model.imageWeb = fileList.slice(1);
        } else {
          this.model.imageWeb = fileList;
        }
      }
    },
    handleImgChange: function handleImgChange(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
    },
    handleRemoveLanding: function handleRemoveLanding(file, fileList) {
      if (fileList.length === 0) {
        this.removeLanding = true;
        this.model.imageLanding = [];
      }
    },
    handleRemoveBanner: function handleRemoveBanner(file, fileList) {
      if (fileList.length === 0) {
        this.removeBanner = true;
        this.model.imageBanner = [];
      }
    },
    handleRemoveWeb: function handleRemoveWeb(file, fileList) {
      if (fileList.length === 0) {
        this.removeWeb = true;
        this.model.imageWeb = [];
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.removeImage = true;
        this.model.imagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    },
    handleDelete: function handleDelete(label) {
      var _this3 = this;

      var btnCounter = 3;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        text: self.$t('marketingOffers.areYouSure', { label: label }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          if (_this3.isNew()) {
            self.goBack();
          } else {
            var id = _this3.route.params.id;
            var data = {
              id: id,
              token: _this3.$session.get('token'),
              company_id: _this3.$session.get('selectedCompany')
            };
            _this3.apiRequest('/banner/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', self.$t('validations.offerDeleted'), 'success');

                self.goBack();
              } else {
                __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    clearLinkSelection: function clearLinkSelection() {
      this.model.link_id = null;
      this.model.description = null;
    },
    saveOffer: function saveOffer() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var locIds = [];
      for (var idxL in this.model.location_ids) {
        locIds.push(this.model.location_ids[idxL]['id']);
      }
      locIds = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(locIds);

      var data = {
        title: this.model.title,
        link_type: this.model.link_type,
        link_id: this.model.link_id,
        description: this.model.description,
        selected_groups: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model.selected_groups),
        location_ids: locIds,
        delete_image: this.removeImage,
        delete_web: this.removeWeb,
        delete_banner: this.removeBanner,
        delete_landing: this.removeLanding
      };
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
        data.date_start = this.model.fromto[0];
        data.date_end = this.model.fromto[1];
      } else {
        data.date_start = null;
        data.date_end = null;
      }

      var self = this;

      if (this.isNew()) {
        data.sort_order = 0;
        if (self.model.imagelist && self.model.imagelist[0].status === 'ready') {
          self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
            data.image = base64enc;
          });
        }

        if (self.model.imageWeb && self.model.imageWeb[0].status === 'ready') {
          self.getBase64(self.model.imageWeb[0].raw).then(function (base64enc) {
            data.imageWeb = base64enc;
          });
        }
        if (self.model.imageLanding && self.model.imageLanding[0].status === 'ready') {
          self.getBase64(self.model.imageLanding[0].raw).then(function (base64enc) {
            data.imageLanding = base64enc;
          });
        }
        if (self.model.imageBanner && self.model.imageBanner[0].status === 'ready') {
          self.getBase64(self.model.imageBanner[0].raw).then(function (base64enc) {
            data.imageBanner = base64enc;
          });
        }
        self.apiRequest('/banner', 'POST', data, function (response) {
          if (response.status === true) {
            self.$nextTick(function () {
              self.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
              title: '',
              text: self.$t('marketingOffers.offerAdded'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
            var id = response.data[0].id;
            data.id = id;
            data.sort_order = id;
            self.apiRequest('/banner/' + id, 'PUT', data, function (response2) {});

            self.goBack();
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
          }
        });
      } else {
        var id = this.route.params.id;

        if (this.model.imagelist === 0) {
          data.image = '';
        }
        if (this.model.imageWeb) {
          data.imageWeb = '';
        }
        if (this.model.imageBanner) {
          data.imageBanner = '';
        }
        if (this.model.imageLanding) {
          data.imageLanding = '';
        }
        this.apiRequest('/banner/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            if (self.model.imagelist[0] !== undefined && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.image = base64enc;

                self.apiRequest('/banner/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.offerUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.weCouldNot'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  }
                });
              });
            }
            if (self.model.imageWeb[0] !== undefined && self.model.imageWeb[0].status && self.model.imageWeb[0].status === 'ready') {
              self.getBase64(self.model.imageWeb[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.imageWeb = base64enc;
                self.apiRequest('/banner/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.offerUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.weCouldNot'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  }
                });
              });
            }

            if (self.model.imageBanner[0] !== undefined && self.model.imageBanner[0].status && self.model.imageBanner[0].status === 'ready') {
              self.getBase64(self.model.imageBanner[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.imageBanner = base64enc;
                self.apiRequest('/banner/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.offerUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.weCouldNot'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  }
                });
              });
            }
            if (self.model.imageLanding[0] !== undefined && self.model.imageLanding[0].status && self.model.imageLanding[0].status === 'ready') {
              self.getBase64(self.model.imageLanding[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.imageLanding = base64enc;
                self.apiRequest('/banner/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.offerUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.weCouldNot'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  }
                });
              });
            }
            self.$nextTick(function () {
              self.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
              title: '',
              text: self.$t('marketingOffers.offerUpdated'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
            self.goBack();
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
          }
        });
      }
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "9SsU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      allLocations: [],
      vatNumber: null,
      selectedLocation: null,
      isStoc: true
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getWasted(this.selectedLocation, this.currentPage, this.pageSize);
    },
    onSearch: function onSearch() {
      if (!this.selectedLocation || Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        });

        this.tableData = [];
        this.totalItems = 0;

        return;
      }

      var locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation];

      this.getWasted(locations);
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getWasted(this.selectedLocation, this.currentPage, this.pageSize);
    },
    getGestiuneNameById: function getGestiuneNameById(id) {
      var gest = this.gestiuneOptions.find(function (g) {
        return g._id === id || g.id === id;
      });
      return gest ? gest.name : id;
    },
    openStoc: function openStoc() {
      this.isStoc = true;
      this.isBonTransfer = false;
    },
    addCasare: function addCasare() {
      this.$router.push('/management/wasted/add');
    },
    editWasted: function editWasted(row) {
      this.$router.push('/management/wasted/edit/' + row.series + '/' + row.documentNumber);
    },
    getWasted: function getWasted() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, ids, allLocations, _ids, response, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;

                params = new URLSearchParams({
                  externalCompanyId: _this.companyID,
                  tip: 'bon_casare'
                });


                params.append('page', page);
                params.append('limit', pageSize);

                if (location) {
                  if (Array.isArray(location)) {
                    ids = location.map(function (l) {
                      return l.true_id;
                    }).filter(Boolean);

                    ids.forEach(function (id) {
                      return params.append('externalLocationId', id);
                    });
                  } else if (location.id && location.true_id) {
                    params.append('externalLocationId', location.true_id);
                  }
                } else {
                  allLocations = _this.groupedLocations.flatMap(function (group) {
                    return group.locations;
                  });
                  _ids = allLocations.map(function (l) {
                    return l.true_id;
                  }).filter(Boolean);

                  _ids.forEach(function (id) {
                    return params.append('externalLocationId', id);
                  });
                }

                clearTimeout(_this.loadingTimeout);
                _this.loadingTimeout = setTimeout(function () {
                  _this.loading = true;
                }, 100);

                _context.next = 10;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/bons?' + params.toString(), {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 10:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 13;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 13:
                _context.next = 15;
                return response.json();

              case 15:
                data = _context.sent;


                if (Array.isArray(data.bons)) {
                  clearTimeout(_this.loadingTimeout);
                  _this.loading = false;

                  _this.totalItems = data.total || 0;
                  _this.currentPage = data.currentPage || page;
                  _this.pageSize = data.pageSize || pageSize;

                  _this.tableData = data.bons.map(function (bon) {
                    return {
                      _id: bon._id,
                      documentNumber: bon.documentNumber,
                      gestiune_from: bon.gestiune_from,
                      lot: bon.lot,
                      series: bon.series
                    };
                  });
                } else {
                  console.error('Nu s-au găsit bonuri valide.');
                  _this.tableData = [];
                }
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](0);

                clearTimeout(_this.loadingTimeout);
                _this.loading = false;

                console.error('Error fetching bons:', _context.t0);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 19]]);
      }))();
    },
    handleDeleteBonCasare: function handleDeleteBonCasare(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (id) {
                  _context3.next = 3;
                  break;
                }

                console.error('Missing Bon Casare ID for deletion.');
                return _context3.abrupt('return');

              case 3:

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: 'Ești sigur?',
                  text: 'Această acțiune va șterge definitiv bonul de casare!',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Da, șterge!',
                  cancelButtonText: 'Anulează'
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
                    var response, data;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!result) {
                              _context2.next = 19;
                              break;
                            }

                            _context2.prev = 1;
                            _context2.next = 4;
                            return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                              method: 'DELETE',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                type: 'bon_casare',
                                id: id,
                                externalCompanyId: _this2.companyID
                              })
                            });

                          case 4:
                            response = _context2.sent;

                            if (response.ok) {
                              _context2.next = 7;
                              break;
                            }

                            throw new Error('HTTP error! Status: ' + response.status);

                          case 7:
                            _context2.next = 9;
                            return response.json();

                          case 9:
                            data = _context2.sent;

                            console.log('Bon casare deleted successfully:', data);

                            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                              title: 'Succes!',
                              text: 'Bon casare șters cu succes.',
                              type: 'success',
                              timer: 2000,
                              showConfirmButton: false
                            });

                            _this2.getWasted();
                            _context2.next = 19;
                            break;

                          case 15:
                            _context2.prev = 15;
                            _context2.t0 = _context2['catch'](1);

                            console.error('Error deleting Bon Casare:', _context2.t0);

                            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                              title: 'Eroare!',
                              text: 'A apărut o problemă la ștergerea bonului de casare.',
                              type: 'error',
                              timer: 2000,
                              showConfirmButton: false
                            });

                          case 19:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2, [[1, 15]]);
                  }));

                  return function (_x4) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    downloadExcel: function downloadExcel(row) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var type, series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                type = 'bon_casare';
                series = row.series;
                invoiceNumber = row.documentNumber;
                externalCompanyId = _this3.companyID;

                if (!(!type || !series || !invoiceNumber || !externalCompanyId)) {
                  _context4.next = 7;
                  break;
                }

                alert('Missing type, series, invoice number or company ID.');
                return _context4.abrupt('return');

              case 7:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/' + type + '/' + series + '-' + invoiceNumber + '/xls?externalCompanyId=' + externalCompanyId;
                _context4.prev = 8;
                _context4.next = 11;
                return fetch(url);

              case 11:
                response = _context4.sent;

                if (!response.ok) {
                  _context4.next = 23;
                  break;
                }

                _context4.next = 15;
                return response.blob();

              case 15:
                blob = _context4.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = type + '-' + series + '-' + invoiceNumber + '.xls';
                link.click();
                URL.revokeObjectURL(link.href);
                _context4.next = 24;
                break;

              case 23:
                console.error('Error downloading document:', response.statusText);

              case 24:
                _context4.next = 29;
                break;

              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4['catch'](8);

                console.error('Error fetching document:', _context4.t0);

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[8, 26]]);
      }))();
    },
    download: function download(row) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var type, series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                type = 'bon_casare';
                series = row.series;
                invoiceNumber = row.documentNumber;
                externalCompanyId = _this4.companyID;

                if (!(!type || !series || !invoiceNumber || !externalCompanyId)) {
                  _context5.next = 7;
                  break;
                }

                alert('Missing type, series, invoice number or company ID.');
                return _context5.abrupt('return');

              case 7:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/' + type + '/' + series + '-' + invoiceNumber + '/pdf?externalCompanyId=' + externalCompanyId;
                _context5.prev = 8;
                _context5.next = 11;
                return fetch(url);

              case 11:
                response = _context5.sent;

                if (!response.ok) {
                  _context5.next = 23;
                  break;
                }

                _context5.next = 15;
                return response.blob();

              case 15:
                blob = _context5.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = type + '-' + series + '-' + invoiceNumber + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                _context5.next = 24;
                break;

              case 23:
                console.error('Error downloading document:', response.statusText);

              case 24:
                _context5.next = 29;
                break;

              case 26:
                _context5.prev = 26;
                _context5.t0 = _context5['catch'](8);

                console.error('Error fetching document:', _context5.t0);

              case 29:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4, [[8, 26]]);
      }))();
    }
  }
});

/***/ }),

/***/ "9Yis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('kds-user-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9iTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"referral-campaign-form"},[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[(_vm.campaignId)?_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",on:{"click":function($event){$event.preventDefault();return _vm.handleDelete($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.delete'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit","disabled":_vm.loading || _vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader') + ' referral-campaign-form__loader'},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('h5',{staticClass:"referral-card-title"},[_vm._v(_vm._s(_vm.$t('referralProgram.generalSettings')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.fieldErrors.name }},[_c('label',{class:{ 'text-danger': _vm.fieldErrors.name }},[_vm._v(_vm._s(_vm.$t('referralProgram.campaignName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",class:{ error: _vm.fieldErrors.name },attrs:{"type":"text","name":"referral_campaign_name"},domProps:{"value":(_vm.model.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)},function($event){_vm.clearFieldError('name')}]}}),_vm._v(" "),(_vm.fieldErrors.name)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('referralProgram.nameRequired')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group referral-form-switches-row"},[_c('div',{staticClass:"referral-form-switch-item"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('referralProgram.active')))])],1),_vm._v(" "),_c('div',{staticClass:"referral-form-switch-item"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_visible_for_users),callback:function ($$v) {_vm.$set(_vm.model, "is_visible_for_users", $$v)},expression:"model.is_visible_for_users"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('referralProgram.v2.visibleInApp')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('referralProgram.rewardType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.rewardType),expression:"rewardType"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.rewardType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"LOYALTY_POINTS","disabled":!_vm.loyaltyPointsEnabled}},[_vm._v(_vm._s(_vm.$t('referralProgram.rewardTypeLoyaltyPoints')))]),_vm._v(" "),_c('option',{attrs:{"value":"WALLET"}},[_vm._v(_vm._s(_vm.$t('referralProgram.rewardTypeWallet')))])]),_vm._v(" "),(!_vm.loyaltyPointsEnabled)?_c('small',[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v("\n              "+_vm._s(_vm.$t('referralProgram.loyaltyPointsModuleRequired'))+"\n              "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goToLoyaltySettings($event)}}},[_vm._v(_vm._s(_vm.$t('referralProgram.loyaltyPointsModuleLink')))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('referralProgram.availableBetween')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy"},model:{value:(_vm.availabilityRange),callback:function ($$v) {_vm.availabilityRange=$$v},expression:"availabilityRange"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('referralProgram.optionalAvailability')))])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('h5',{staticClass:"referral-card-title"},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.hierarchyTitle')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('referralProgram.v2.hierarchy')))]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.purchaseFlow')))])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"referral-section-heading referral-form-inline-toggle"},[_c('h5',{staticClass:"referral-section-heading__title"},[_vm._v(_vm._s(_vm.$t('referralProgram.orderRewardsSection')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.order_rewards_active),callback:function ($$v) {_vm.$set(_vm.model, "order_rewards_active", $$v)},expression:"model.order_rewards_active"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.order_rewards_active),expression:"model.order_rewards_active"}]},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.fieldErrors.maxOrders }},[_c('label',{attrs:{"for":"referral-max-orders"}},[_vm._v(_vm._s(_vm.$t('referralProgram.maxOrdersForOrderRewards')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxOrdersInput),expression:"maxOrdersInput"}],staticClass:"form-control",attrs:{"id":"referral-max-orders","type":"number","min":"1","step":"1","placeholder":_vm.$t('referralProgram.unlimitedPlaceholder')},domProps:{"value":(_vm.maxOrdersInput)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.maxOrdersInput=$event.target.value},function($event){_vm.clearFieldError('maxOrders')}]}}),_vm._v(" "),(_vm.fieldErrors.maxOrders)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.maxOrdersInvalid')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.roles),function(role){return _c('referral-reward-rule',{key:role,attrs:{"column-class":"col-md-6","field-id":role + '-order',"title":_vm.$t('referralProgram.v2.' + role),"coupons":_vm.coupons,"coupons-loading":_vm.couponsLoading,"loyalty-enabled":_vm.loyaltyPointsEnabled,"default-reward-type":_vm.defaultRewardType,"error":_vm.fieldErrors[role + '.order_reward'] || ''},on:{"input":function($event){_vm.clearFieldError(role + '.order_reward')}},model:{value:(_vm.rewardSettings[role].order_reward),callback:function ($$v) {_vm.$set(_vm.rewardSettings[role], "order_reward", $$v)},expression:"rewardSettings[role].order_reward"}})}))]),_vm._v(" "),_c('p',{staticClass:"referral-reward-summary"},[_vm._v(_vm._s(_vm.orderRewardsSummaryText))])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"referral-section-heading referral-form-inline-toggle"},[_c('div',{staticClass:"referral-section-heading__text"},[_c('h5',{staticClass:"referral-section-heading__title"},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.cashbackTitle')))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.cashbackHelp')))])]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.cashbackEnabled),callback:function ($$v) {_vm.cashbackEnabled=$$v},expression:"cashbackEnabled"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cashbackEnabled),expression:"cashbackEnabled"}],staticClass:"row"},_vm._l((_vm.cashbackRoles),function(role){return _c('referral-reward-rule',{key:role,attrs:{"column-class":"col-md-12","allow-coupons":false,"field-id":role + '-cashback',"title":_vm.$t('referralProgram.v2.' + role),"coupons":_vm.coupons,"coupons-loading":_vm.couponsLoading,"loyalty-enabled":_vm.loyaltyPointsEnabled,"default-reward-type":_vm.defaultRewardType,"error":_vm.fieldErrors[role + '.cashback'] || ''},on:{"input":function($event){_vm.clearFieldError(role + '.cashback')}},model:{value:(_vm.rewardSettings[role].cashback),callback:function ($$v) {_vm.$set(_vm.rewardSettings[role], "cashback", $$v)},expression:"rewardSettings[role].cashback"}})})),_vm._v(" "),_c('p',{staticClass:"referral-reward-summary"},[_vm._v(_vm._s(_vm.cashbackSummaryText))])])]),_vm._v(" "),(_vm.couponsLoadFailed)?_c('p',{staticClass:"text-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.$t('referralProgram.v2.couponsLoadFailed'))+"\n    "),_c('button',{staticClass:"btn btn-sm btn-default",attrs:{"type":"button"},on:{"click":_vm.loadCoupons}},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.retry')))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9ke0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isStoc)?_c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-button"},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"1"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"type":"success"},on:{"click":function($event){_vm.addBonConsum()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('gestiune.addBonConsum'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"label":"Nr.","prop":"documentNumber","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.documentNumber)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Serie","prop":"series","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.series)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Lot","prop":"lot"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.lot)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Gestiune","prop":"gestiune_from"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(_vm.getGestiuneNameById(scope.row.gestiune_from))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                      ▾ ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editBonConsum(scope.row)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.edit'))+"\n                      ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.download(scope.row)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('invoice.download'))+"\n                      ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadExcel(scope.row)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('gestiune.downloadExcel'))+"\n                      ")]),_vm._v(" "),_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},nativeOn:{"click":function($event){_vm.handleDeleteBonConsum(scope.row._id)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.delete'))+"\n                      ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9mGn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9njO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Qr_vue__ = __webpack_require__("y0eN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_437d4014_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Qr_vue__ = __webpack_require__("/SUY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Qr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_437d4014_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Qr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9nxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9oL+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9pV9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a),
  props: {
    isPdfRaport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isPdfRaport: function isPdfRaport() {
      if (this.isPdfRaport) {
        this.getData();
      }
    }
  },
  created: function created() {
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear();
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '_' + this.$t('reports.pdfRaportDeliveryOrders') + '_' + formattedDate + '.xlsx';
  },
  mounted: function mounted() {
    if (document.getElementsByClassName('left-vertical-tabs')[0]) {
      document.getElementsByClassName('left-vertical-tabs')[0].classList.add('noprint');
    }
  },
  data: function data() {
    return {
      loading: true,
      orders: null,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      date: [__WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(1, 'days').format('YYYY-MM-DD')],
      pickerNames: ['date_from', 'date_to'],
      pickerOptions1: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(5, 'days');
        }
      },
      test1: '',
      products: [],
      export_file: '',
      export_name: ''
    };
  },

  methods: {
    printToIframe: function printToIframe() {
      var iframe = document.getElementById('print-frame');
      var doc = iframe.contentWindow.document;

      var ordersHtml = '';
      this.orders.forEach(function (order) {
        var partsHtml = order.parts.map(function (part) {
          var itemsHtml = part.items.map(function (prod) {
            var optionsHtml = prod.options && prod.options.length ? '<div class="options">' + prod.options.map(function (opt) {
              return '+ ' + opt.name;
            }).join('<br>') + '</div>' : '';
            var infoHtml = prod.additional_info ? '<div class="options">- ' + prod.additional_info + '</div>' : '';

            return '\n              <tr>\n                <td>\n                  ' + prod.name + '\n                  ' + optionsHtml + '\n                  ' + infoHtml + '\n                </td>\n                <td class="center">' + prod.quantity + '</td>\n              </tr>\n            ';
          }).join('');

          return '\n            ' + (order.order_type === 'GROUP' ? '<div class="section"><b>Sub-client:</b> ' + part.customer_name + '</div>' : '') + '\n            <table>\n              <thead>\n                <tr>\n                  <th>Nume</th>\n                  <th>Cantitate</th>\n                </tr>\n              </thead>\n              <tbody>\n                ' + itemsHtml + '\n              </tbody>\n            </table>\n          ';
        }).join('');

        ordersHtml += '\n          <div class="card">\n            <div class="section"><b>Comanda:</b> ' + order.number + ' - ' + order.id + '</div>\n            <div class="section"><b>Client:</b> ' + order.delivery_details_firstname + ' | ' + order.delivery_details_phone + '</div>\n            ' + (order.address_shipping ? '\n              <div class="section">\n                <b>Adresa:</b>\n                ' + (order.address_shipping.state || '') + ',\n                ' + (order.address_shipping.city || '') + ',\n                ' + (order.address_shipping.street || '') + ' ' + (order.address_shipping.number || '') + ',\n                ' + (order.address_shipping.apartment || '') + '\n                ' + (order.address_shipping.other_info || '') + '\n              </div>' : '') + '\n            ' + (order.pickup_datetime ? '<div class="section"><b>Data livrare:</b> ' + order.pickup_datetime.split(' ')[0] + '</div>' : '') + '\n            ' + (order.comments && order.comments !== '</br>' ? '<div class="section"><b>Comentarii:</b> ' + order.comments + '</div>' : '') + '\n            ' + partsHtml + '\n          </div>\n        ';
      });

      var content = '\n        <html>\n          <head>\n            <title>Raport Comenzi Livrare</title>\n            <style>\n              * {\n                box-sizing: border-box;\n              }\n              body {\n                font-family: sans-serif;\n                padding: 10px;\n                margin: 0;\n                font-size: 16px;\n              }\n              .card {\n                border: 1px solid #aaa;\n                border-radius: 6px;\n                padding: 8px;\n                margin-bottom: 12px;\n                width: 100%;\n                page-break-inside: avoid;\n              }\n              .section {\n                margin-bottom: 6px;\n              }\n             .section b {\n                display: inline;\n                font-weight: bold;\n                margin-right: 4px;\n              }\n              table {\n                width: 100%;\n                border-collapse: collapse;\n                margin-top: 5px;\n              }\n              th, td {\n                border: 1px solid #ccc;\n                padding: 2px 4px;\n                font-size: 16px;\n                word-break: break-word;\n              }\n              td.center {\n                text-align: center;\n              }\n              .options {\n                font-size: 14px;\n                color: #555;\n              }\n            </style>\n          </head>\n          <body>\n            ' + ordersHtml + '\n          </body>\n        </html>\n      ';

      doc.open();
      doc.write(content);
      doc.close();
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    },
    downloadReport: function downloadReport() {
      var _this = this;

      this.loading = true;
      var link = document.createElement('a');
      link.href = this.export_file;
      link.setAttribute('download', this.export_name);
      document.body.appendChild(link);
      link.click();
      this.$nextTick(function () {
        _this.loading = false;
      });
    },
    print: function print() {
      if (document.getElementsByClassName('left-vertical-tabs')[0]) {
        document.getElementsByClassName('left-vertical-tabs')[0].classList.add('noprint');
      }
      window.print();
    },
    getData: function getData() {
      var _this2 = this;

      if (!this.isPdfRaport) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.date[0],
        end_date: this.date[1]
      };
      this.loading = true;
      this.apiRequest('/reports/get-pdf', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.orders = response.data.orders;
          _this2.products = response.data.products;
          _this2.export_file = response.data.excel.file;
        }
        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    test: function test() {
      console.log('test');
    }
  }
});

/***/ }),

/***/ "9r3a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't8'
});

/***/ }),

/***/ "9sk9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductEdit_vue__ = __webpack_require__("+pAP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_050997f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductEdit_vue__ = __webpack_require__("/hhg");
function injectStyle (ssrContext) {
  __webpack_require__("iOcN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_050997f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9uTf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"challenge-campaign-form"},[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();return _vm.deleteCampaign($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"show-loader challenge-campaign-form__loader"},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mar-to-15 mar-bt-15"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"header challenge-campaign-form__section-title"},[_c('h5',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.details')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.title')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"},{name:"validate",rawName:"v-validate",value:('required|min:2'),expression:"'required|min:2'"}],staticClass:"form-control",attrs:{"type":"text","name":"title","placeholder":_vm.$t('challengeCampaigns.titlePlaceholder')},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('title'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('title')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"3","placeholder":_vm.$t('challengeCampaigns.descriptionPlaceholder')},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group challenge-campaign-form__active"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('general.active')))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","list-type":"picture-card","auto-upload":false,"limit":1,"file-list":_vm.model.imagelist,"on-change":_vm.handleImgChange,"on-remove":_vm.handleRemove,"on-exceed":_vm.handleExceed}},[_c('i',{staticClass:"el-icon-plus"})])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"header challenge-campaign-form__section-title"},[_c('h5',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.conditions')))])]),_vm._v(" "),_c('ul',{staticClass:"challenge-campaign-form__info-list"},[_c('li',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.conditionsAndInfo')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.deliveredOnlyInfo')))])]),_vm._v(" "),_c('h6',{staticClass:"challenge-campaign-form__group-title"},[_vm._v(_vm._s(_vm.$t('challengeCampaigns.goalGroup')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.target')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.target),expression:"model.target",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.model.target)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "target", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.periodOfTimeDays')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.period_of_time_days),expression:"model.period_of_time_days",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","placeholder":_vm.$t('challengeCampaigns.periodOfTimeDaysHint')},domProps:{"value":(_vm.model.period_of_time_days)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "period_of_time_days", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group challenge-campaign-form__switch-field"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.distinctOrder')))]),_vm._v(" "),_c('div',{staticClass:"challenge-campaign-form__active"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.distinct_order),callback:function ($$v) {_vm.$set(_vm.model, "distinct_order", $$v)},expression:"model.distinct_order"}})],1),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('challengeCampaigns.distinctOrderHint')))])])])]),_vm._v(" "),_c('h6',{staticClass:"challenge-campaign-form__group-title"},[_vm._v(_vm._s(_vm.$t('challengeCampaigns.orderFiltersGroup')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.minOrderValue')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.min_order_value),expression:"model.min_order_value"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(_vm.model.min_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "min_order_value", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.locations')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","collapse-tags":"","clearable":"","filterable":"","placeholder":_vm.$t('challengeCampaigns.leaveEmptyAll')},model:{value:(_vm.locationIds),callback:function ($$v) {_vm.locationIds=$$v},expression:"locationIds"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:loc.id,attrs:{"label":loc.name,"value":loc.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.deliveryMethods')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","collapse-tags":"","clearable":"","filterable":"","placeholder":_vm.$t('challengeCampaigns.leaveEmptyAll')},model:{value:(_vm.model.delivery_methods),callback:function ($$v) {_vm.$set(_vm.model, "delivery_methods", $$v)},expression:"model.delivery_methods"}},_vm._l((_vm.deliveryMethodOptions),function(m){return _c('el-option',{key:m,attrs:{"label":_vm.$t('deliveryTypes.' + m),"value":m}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.sources')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","collapse-tags":"","clearable":"","filterable":"","placeholder":_vm.$t('challengeCampaigns.leaveEmptyAll')},model:{value:(_vm.model.order_source_ids),callback:function ($$v) {_vm.$set(_vm.model, "order_source_ids", $$v)},expression:"model.order_source_ids"}},_vm._l((_vm.sourceOptions),function(s){return _c('el-option',{key:s.id,attrs:{"label":s.label,"value":s.id}})}))],1)])]),_vm._v(" "),_c('h6',{staticClass:"challenge-campaign-form__group-title"},[_vm._v(_vm._s(_vm.$t('challengeCampaigns.scheduleGroup')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.timePeriod')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.days')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","collapse-tags":"","clearable":"","placeholder":_vm.$t('challengeCampaigns.leaveEmptyAll')},model:{value:(_vm.model.days),callback:function ($$v) {_vm.$set(_vm.model, "days", $$v)},expression:"model.days"}},_vm._l((_vm.dayOptions),function(d){return _c('el-option',{key:d.id,attrs:{"label":d.label,"value":d.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.orderTimeFrom')))]),_vm._v(" "),_c('el-time-picker',{staticStyle:{"width":"100%"},attrs:{"format":"HH:mm","value-format":"HH:mm:ss"},model:{value:(_vm.model.order_time_from),callback:function ($$v) {_vm.$set(_vm.model, "order_time_from", $$v)},expression:"model.order_time_from"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('challengeCampaigns.orderTimeTo')))]),_vm._v(" "),_c('el-time-picker',{staticStyle:{"width":"100%"},attrs:{"format":"HH:mm","value-format":"HH:mm:ss"},model:{value:(_vm.model.order_time_to),callback:function ($$v) {_vm.$set(_vm.model, "order_time_to", $$v)},expression:"model.order_time_to"}})],1)])]),_vm._v(" "),_c('h6',{staticClass:"challenge-campaign-form__group-title"},[_vm._v(_vm._s(_vm.$t('challengeCampaigns.catalogGroup')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('searchable-multi-select',{attrs:{"label":"challengeCampaigns.products","url":"/search-order-products","initial-limit":20},model:{value:(_vm.productsSelected),callback:function ($$v) {_vm.productsSelected=$$v},expression:"productsSelected"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('searchable-multi-select',{attrs:{"label":"challengeCampaigns.categories","url":"/search-categories","initial-limit":20},model:{value:(_vm.categoriesSelected),callback:function ($$v) {_vm.categoriesSelected=$$v},expression:"categoriesSelected"}})],1)]),_vm._v(" "),_c('p',{staticClass:"challenge-campaign-form__summary"},[_vm._v("\n            "+_vm._s(_vm.conditionsSummaryText)+"\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9xcS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  created: function created() {
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      tableData: []
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {

      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/cantar/edit/');
      }
    },
    goToAdd: function goToAdd() {
      this.$router.push('/cantar/add');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/cantar', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data.cantar;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    handleDelete: function handleDelete(item) {
      var _this2 = this;

      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        text: this.$t('addOrder.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            id: item,
            token: _this2.$session.get('token'),
            company_id: _this2.$session.get('selectedCompany')
          };
          _this2.apiRequest('/cantar/' + item, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this2.$t('general.success'), 'success');
              _this2.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : _this2.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function (err) {
        if (err) {}
      });
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.disableConfirmButton();
      var yes = this.$t('general.yes');
      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          if (__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton().textContent = yes + ' (' + btnCounter + ')';
          }
        } else {
          if (__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton().textContent = yes;
          }
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    }
  }
});

/***/ }),

/***/ "A+TP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-timeline card-plain"},[_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"timeline",class:{'timeline-simple': _vm.type === 'simple'}},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A//q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A4GO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A4Ki":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A5Ie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiscalZReport_vue__ = __webpack_require__("cK/Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d5b7f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiscalZReport_vue__ = __webpack_require__("/DdY");
function injectStyle (ssrContext) {
  __webpack_require__("VjcE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiscalZReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d5b7f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiscalZReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A8IB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A8RD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card driver mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"data":_vm.drivers},on:{"sort-change":_vm.handleSortChange}},[_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('reports.name')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.name)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email","label":"ID"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.email)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"Status","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{class:_vm.getStatusClass(scope.row.status)},[_vm._v("\n                "+_vm._s(scope.row.status)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"driver_schedule_active","label":_vm.$t('reports.timerApp'),"sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{class:scope.row.driver_schedule_active ? 'online' : 'offline'},[_vm._v("\n                "+_vm._s(scope.row.driver_schedule_active ? 'Active' : 'Inactive')+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.wallet'),"prop":"driver_wallet","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.driver_wallet)+" "+_vm._s(_vm.currencyIso)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":200},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.wallet')},on:{"click":function($event){_vm.openAddToWalletModal(props.row)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.wallet'))+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":200},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"delete",on:{"click":function($event){_vm.openRemoveToWalletModal(props.row)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.walletRemove'))+"\n              ")])]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AC8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'import-products-input',
  inheritAttrs: false,
  props: {
    location: Object
  },
  data: function data() {
    return {
      apiUrl: '',
      file: null,
      originalFilename: null,
      uploading: false
    };
  },

  computed: {
    canUpload: function canUpload() {
      return !!this.file && !this.uploading;
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
  },

  methods: {
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pdfSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
      }
      return isOkSize;
    },
    handleChange: function handleChange(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 25;
      var isPdf = file.raw.type === 'text/csv' || file.name && file.name.toLowerCase().endsWith('.csv');
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pdfSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
      } else if (!isPdf) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.wrongFormat'),
          position: 'top-end',
          showConfirmButton: true,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
      } else {
        self.originalFilename = file.name;
        self.getBase64(file.raw).then(function (base64enc) {
          self.file = base64enc;
        });
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.$refs.upload.files = [];
        this.file = null;
        this.originalFilename = null;
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        toast: true,
        text: self.$t('validations.removePhoto'),
        type: 'warning',
        position: 'top-end',
        showConfirmButton: true
      });
    },
    getBase64: function getBase64(file) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    upload: function upload() {
      var _this = this;

      if (!this.canUpload) {
        return;
      }
      this.uploading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.$session.get('selectedCompany'),
        csv: this.file,
        original_filename: this.originalFilename
      };

      this.apiRequest('/import-location/products/', 'POST', data, function (response) {
        _this.uploading = false;
        if (response && response.status && response.data && response.data.id) {
          var importId = response.data.id;
          _this.trackAdminEvent('ADMIN_PRODUCT_IMPORT_CREATED', 'product_import', importId, {
            product_import_id: importId,
            location_id: _this.location.true_id,
            original_filename: _this.originalFilename,
            total_rows: response.data.total_rows != null ? response.data.total_rows : null,
            pending_rows: response.data.pending_rows != null ? response.data.pending_rows : null,
            error_rows: response.data.error_rows != null ? response.data.error_rows : null,
            price_profiles_id: response.data.price_profiles_id != null ? response.data.price_profiles_id : null,
            response: response
          });
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            toast: true,
            text: _this.$t('productImport.uploadSuccess'),
            type: 'success',
            position: 'top-end',
            showConfirmButton: false,
            timer: 2500
          });
          _this.file = null;
          _this.originalFilename = null;
          if (_this.$refs.upload) {
            _this.$refs.upload.clearFiles();
          }
          _this.$router.push('/locations/' + _this.location.true_id + '/product-imports/' + importId);
        } else {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            toast: true,
            text: response && response.data || _this.$t('general.error'),
            type: 'error',
            position: 'top-end',
            showConfirmButton: false,
            timer: 4000
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "ACsk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesProducts_vue__ = __webpack_require__("6R4L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_246c5ea2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesProducts_vue__ = __webpack_require__("PlUG");
function injectStyle (ssrContext) {
  __webpack_require__("9oL+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_246c5ea2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesProducts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AF16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolveLocationId */
/* unused harmony export getAuditActor */
/* unused harmony export loadAuditScript */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initAuditClient; });
/* harmony export (immutable) */ __webpack_exports__["b"] = trackAdminEvent;
/* harmony export (immutable) */ __webpack_exports__["c"] = tableEntityKind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__);








var AUDIT_SCRIPT_URL = 'https://analytics.cdntaptasty.com/analytics.js';
var AUDIT_ENDPOINT = 'https://analytics.cdntaptasty.com/api/audit.php';
var SYNC_INTERVAL_MS = 30000;

var scriptLoadPromise = null;
var initPromise = null;
var pendingEvents = [];

function getSessionUser(vm) {
  try {
    var raw = vm.$session && vm.$session.get('userData');
    if (!raw) return {};
    return typeof raw === 'string' ? JSON.parse(raw) : raw;
  } catch (e) {
    return {};
  }
}

function getCompanyLocations(vm) {
  try {
    var companyData = vm.$session && vm.$session.get('selectedCompanyData');
    var details = companyData && companyData.locations_details;
    if (Array.isArray(details) && details.length) {
      return details;
    }
  } catch (e) {}

  try {
    var raw = vm.$session && vm.$session.get('userDataLocations');
    var list = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (Array.isArray(list) && list.length) {
      return list;
    }
  } catch (e) {}

  return [];
}

function locationTrueId(loc) {
  if (!loc || (typeof loc === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(loc)) !== 'object') return null;
  if (loc.true_id != null && loc.true_id !== '') return loc.true_id;

  if (loc.id != null && typeof loc.id === 'number') return loc.id;
  return null;
}

function mapTokenOrIdToTrueId(locations, value) {
  if (value == null || value === '') return null;
  var str = String(value);

  for (var i = 0; i < locations.length; i++) {
    var loc = locations[i];
    if (!loc) continue;
    if (loc.true_id != null && String(loc.true_id) === str) {
      return loc.true_id;
    }
    if (loc.token != null && String(loc.token) === str) {
      return locationTrueId(loc);
    }

    if (loc.id != null && String(loc.id) === str) {
      return locationTrueId(loc);
    }
  }

  var asNum = Number(value);
  if (!isNaN(asNum) && String(asNum) === str && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_finite___default()(asNum)) {
    return asNum;
  }
  return null;
}

function firstPreferredValue(preferred) {
  if (preferred == null || preferred === '') return null;
  if (Array.isArray(preferred)) {
    for (var i = 0; i < preferred.length; i++) {
      var item = preferred[i];
      if (item == null || item === '') continue;
      if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(item)) === 'object') {
        if (item.true_id != null) return item.true_id;
        if (item.token != null) return item.token;
        if (item.id != null) return item.id;
        continue;
      }
      return item;
    }
    return null;
  }
  if ((typeof preferred === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(preferred)) === 'object') {
    if (preferred.true_id != null) return preferred.true_id;
    if (preferred.token != null) return preferred.token;
    if (preferred.id != null) return preferred.id;
    return null;
  }
  return preferred;
}

function resolveLocationId(vm, preferred) {
  var locations = getCompanyLocations(vm);
  var candidate = firstPreferredValue(preferred);

  if (candidate != null && candidate !== '') {
    var mapped = mapTokenOrIdToTrueId(locations, candidate);
    if (mapped != null) return mapped;
  }

  if (locations.length) {
    return locationTrueId(locations[0]);
  }

  return null;
}

function getAuditActor(vm) {
  var user = getSessionUser(vm);
  var first = user.firstname || user.first_name || '';
  var last = user.lastname || user.last_name || '';
  var userName = (first + ' ' + last).trim() || user.email || null;
  return {
    user_id: user.id || null,
    user_name: userName,
    company_id: vm.$session && vm.$session.get('selectedCompany') || null
  };
}

function loadAuditScript() {
  if (typeof window === 'undefined') {
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve();
  }
  if (window.AuditClient) {
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve();
  }
  if (scriptLoadPromise) {
    return scriptLoadPromise;
  }
  scriptLoadPromise = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
    var existing = document.querySelector('script[data-taptasty-audit]');
    if (existing) {
      if (window.AuditClient) {
        resolve();
        return;
      }
      existing.addEventListener('load', function () {
        return resolve();
      });
      existing.addEventListener('error', function () {
        return resolve();
      });
      setTimeout(function () {
        return resolve();
      }, 0);
      return;
    }
    var script = document.createElement('script');
    script.src = AUDIT_SCRIPT_URL + '?t=' + Date.now();
    script.async = true;
    script.dataset.taptastyAudit = '1';
    script.onload = function () {
      return resolve();
    };
    script.onerror = function () {
      console.error('Eroare analytics: nu s-a putut încărca analytics.js');
      resolve();
    };
    document.head.appendChild(script);
  });
  return scriptLoadPromise;
}

function flushPendingEvents() {
  if (!window.audit || typeof window.audit.event !== 'function') {
    return;
  }
  while (pendingEvents.length) {
    var item = pendingEvents.shift();
    try {
      emitAuditEvent(item);
    } catch (err) {
      console.error('Eroare analytics ' + item.eventName, err);
    }
  }
}

function emitAuditEvent(item) {
  if (item.companyId && window.audit.companyId !== item.companyId) {
    window.audit.companyId = item.companyId;
  }
  if (item.locationId != null) {
    window.audit.locationId = item.locationId;
  }
  window.audit.event(item.eventName, item.entityType, item.entityId, item.payload, item.context);
}

var initAuditClient = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(vm) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!initPromise) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt('return', initPromise);

          case 2:
            initPromise = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
              var hasSession, actor, locationId, version;
              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;

                      if (!(!vm || !vm.$session)) {
                        _context.next = 3;
                        break;
                      }

                      return _context.abrupt('return', null);

                    case 3:
                      hasSession = typeof vm.$session.exists === 'function' ? vm.$session.exists() : !!vm.$session.get('token');

                      if (hasSession) {
                        _context.next = 6;
                        break;
                      }

                      return _context.abrupt('return', null);

                    case 6:
                      _context.next = 8;
                      return loadAuditScript();

                    case 8:
                      if (!(typeof window.AuditClient !== 'function')) {
                        _context.next = 11;
                        break;
                      }

                      console.error('Eroare analytics: AuditClient lipsește după încărcarea scriptului');
                      return _context.abrupt('return', null);

                    case 11:
                      actor = getAuditActor(vm);
                      locationId = resolveLocationId(vm, options.locationId);

                      if (!actor.company_id) {
                        console.warn('Analytics init: selectedCompany lipsește');
                      }
                      if (locationId == null) {
                        console.warn('Analytics init: nu s-a găsit location_id (API respinge location_id=null)');
                      }

                      version = options.version != null ? options.version : __webpack_require__.i({"NODE_ENV":"production","API_BASE_URL":"https://gatewaydev.taptasty.com/","API_BASE_URL_GESTIUNE":"https://fiscal-dev.cdntaptasty.com","EFACTURA_MODE":"TEST"}).APP_VERSION || '1.1.0';


                      window.audit = new window.AuditClient({
                        endpoint: AUDIT_ENDPOINT,
                        companyId: actor.company_id,
                        locationId: locationId,
                        posId: options.posId != null ? options.posId : null,
                        userId: actor.user_id,
                        appId: null,
                        version: version,
                        syncInterval: SYNC_INTERVAL_MS
                      });

                      flushPendingEvents();
                      return _context.abrupt('return', window.audit);

                    case 21:
                      _context.prev = 21;
                      _context.t0 = _context['catch'](0);

                      console.error('Eroare analytics init', _context.t0);
                      return _context.abrupt('return', null);

                    case 25:
                      _context.prev = 25;

                      initPromise = null;
                      return _context.finish(25);

                    case 28:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this, [[0, 21, 25, 28]]);
            }))();
            return _context2.abrupt('return', initPromise);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function initAuditClient(_x) {
    return _ref.apply(this, arguments);
  };
}();

function sanitizeForAudit(value, depth, seen) {
  var maxDepth = 6;
  var maxString = 2000;
  var maxArray = 50;
  var maxKeys = 80;
  if (depth == null) depth = 0;
  if (!seen) seen = [];

  if (value == null) return value;
  var t = typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(value);
  if (t === 'string') {
    return value.length > maxString ? value.slice(0, maxString) + '…[truncated]' : value;
  }
  if (t === 'number' || t === 'boolean') return value;
  if (t === 'function' || t === 'symbol' || t === 'undefined') return undefined;
  if (t !== 'object') return String(value);

  if (typeof File !== 'undefined' && value instanceof File) {
    return { __file: value.name, size: value.size, type: value.type };
  }
  if (typeof Blob !== 'undefined' && value instanceof Blob) {
    return { __blob: true, size: value.size, type: value.type };
  }

  for (var i = 0; i < seen.length; i++) {
    if (seen[i] === value) return '[Circular]';
  }
  if (depth >= maxDepth) return '[MaxDepth]';

  seen.push(value);

  if (Array.isArray(value)) {
    var out = [];
    var len = Math.min(value.length, maxArray);
    for (var _i = 0; _i < len; _i++) {
      var item = sanitizeForAudit(value[_i], depth + 1, seen);
      if (item !== undefined) out.push(item);
    }
    if (value.length > maxArray) out.push('…[+' + (value.length - maxArray) + ' items]');
    seen.pop();
    return out;
  }

  var outObj = {};
  var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(value);
  var keyLen = Math.min(keys.length, maxKeys);
  for (var _i2 = 0; _i2 < keyLen; _i2++) {
    var key = keys[_i2];
    if (key === '__ob__' || key.charAt(0) === '$') continue;
    try {
      var _item = sanitizeForAudit(value[key], depth + 1, seen);
      if (_item !== undefined) outObj[key] = _item;
    } catch (e) {
      outObj[key] = '[Unreadable]';
    }
  }
  if (keys.length > maxKeys) outObj.__truncated_keys = keys.length - maxKeys;
  seen.pop();
  return outObj;
}

function buildEventArgs(vm, eventName, entityType, entityId, payload) {
  var actor = getAuditActor(vm);
  var rawPayload = payload || {};
  var preferred = rawPayload.location_id != null ? rawPayload.location_id : rawPayload.locationId != null ? rawPayload.locationId : rawPayload.location_tokens != null ? rawPayload.location_tokens : rawPayload.location_ids != null ? rawPayload.location_ids : null;
  var locationId = resolveLocationId(vm, preferred);
  var safePayload = sanitizeForAudit(rawPayload) || {};
  var mergedPayload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, safePayload, {
    user_id: actor.user_id,
    user_name: actor.user_name,
    company_id: actor.company_id,
    location_id: locationId
  });
  var context = {
    user_id: actor.user_id,
    user_name: actor.user_name,
    company_id: actor.company_id,
    location_id: locationId
  };
  return {
    eventName: eventName,
    entityType: entityType,
    entityId: entityId,
    payload: mergedPayload,
    context: context,
    companyId: actor.company_id,
    locationId: locationId
  };
}

function trackAdminEvent(vm, eventName, entityType, entityId) {
  var payload = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  try {
    var args = buildEventArgs(vm, eventName, entityType, entityId, payload);

    if (args.locationId == null) {
      console.warn('Analytics: event skipped — location_id lipsă (API respinge null)', eventName);
      return;
    }

    try {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(args.payload);
    } catch (serializeErr) {
      console.error('Analytics: payload neserializabil, se trimite varianta redusă', eventName, serializeErr);
      args.payload = {
        user_id: args.payload.user_id,
        user_name: args.payload.user_name,
        company_id: args.payload.company_id,
        location_id: args.payload.location_id,
        entity_id: entityId,
        note: 'payload_stripped_unserializable'
      };
    }

    if (window.audit && typeof window.audit.event === 'function') {
      emitAuditEvent(args);
      return;
    }

    pendingEvents.push(args);
    initAuditClient(vm, { locationId: args.locationId }).then(function (client) {
      if (!client) {
        console.warn('Analytics: eventul a fost pus în coadă dar clientul nu s-a inițializat', eventName);
      }
    });
  } catch (err) {
    console.error('Eroare analytics ' + eventName, err);
  }
}

function tableEntityKind(vm, modelType) {
  if (modelType === 'Kiosk') return 'kiosk';
  var path = vm.$route && vm.$route.path ? vm.$route.path : typeof window !== 'undefined' ? window.location.pathname : '';
  if (String(path).toLowerCase().includes('qr')) return 'qr';
  return 'table';
}

/***/ }),

/***/ "AGp5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementMyOrdersSuppliersForm_vue__ = __webpack_require__("zUd+");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ManagementMyOrdersSuppliersForm', __WEBPACK_IMPORTED_MODULE_7__ManagementMyOrdersSuppliersForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "AIwG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_time_picker_css__ = __webpack_require__("5ObC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_time_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_picker__ = __webpack_require__("4ZDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_mixins_BtOrderPayment__ = __webpack_require__("i3di");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Customers_countries__ = __webpack_require__("KLaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__);
















var _components;









__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_picker___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_16_src_mixins_BtOrderPayment__["a" /* default */]],
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select___default.a), _components),
  props: {
    showLocations: {
      type: Boolean,
      required: true
    },
    callback: {
      required: true
    }
  },
  data: function data() {
    return {
      order: [],
      coupon: '',
      countries: __WEBPACK_IMPORTED_MODULE_19__Customers_countries__["a" /* default */],
      modelValidations: {
        required: {
          required: true
        }
      },
      orderStatuses: [],
      currentOrdersStatus: 'NEW',
      usesExtraCosts: false,
      currecy: '',
      timeFormat: this.getTimeFormat(),
      loading: true,
      refundLoading: false,
      showPrintBtn: false,
      totals: ['totals_subtotals', 'totals_shipping', 'totals_extras', 'totals_tip', 'totals_discount', 'totals_discount_loyalty_points', 'totals_grandtotal'],
      cancelOrder: null
    };
  },

  created: function created() {
    this.getData();
  },
  computed: {
    canShowRefundButton: function canShowRefundButton() {
      var order = this.order;
      if (!order || !order.status) {
        return false;
      }
      return order.payment_type === 'CARD' && !!order.transaction_id && (order.payment_id === 'btIpay' || order.payment_id === 'euplatesc' && !!order.pay_link);
    },
    refundAlreadyDone: function refundAlreadyDone() {
      var order = this.order;
      if (!order) {
        return false;
      }
      var status = order.capture_transaction_status;
      return order.is_refunded === 1 || order.is_refunded === true || status === 'reversal OK' || status === 'refund OK';
    }
  },
  methods: {
    getRowClass: function getRowClass(label) {
      switch (label) {
        case 'totals_discount_loyalty_points':
        case 'totals_discount':
          return 'text-danger';
        case 'totals_grandtotal':
          return 'text-bold total-row';
        default:
          return '';
      }
    },
    isNew: function isNew() {
      if (this.$route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    disabledCls: function disabledCls(isBefore) {
      if (isBefore) {
        return 'disabled';
      } else {
        return '';
      }
    },
    getPaymetnStatus: function getPaymetnStatus(status) {
      if (this.order.payment_id === 'btIpay' && status === 'AUTHORIZED') {
        return ' - <span class="text-info">' + this.$t('btPayments.authorized') + '</span>';
      }
      switch (status) {
        case 'OK':
          return ' - <span class="text-success">' + this.$t('paymentStatus.paid') + '</span>';
        case 'NOT OK':
          return ' - <span class="text-danger">' + this.$t('paymentStatus.notOk') + '</span>';
        default:
          return ' - <span class="text-warning">' + this.$t('paymentStatus.notPaid') + '</small></span> <br><span class="text-muted"><small>' + this.$t('paymentStatus.notPaidDetails') + '</small></span>';
      }
    },
    refundErrorMessage: function refundErrorMessage(response) {
      if (response) {
        if (response.error && response.error.response && response.error.response.data) {
          var data = response.error.response.data;
          if (data.message) {
            return data.message;
          }
          if (data.error) {
            return data.error;
          }
        }
        if (response.message) {
          return response.message;
        }
      }
      return this.$t('orders.refundError');
    },
    doRefundOrder: function doRefundOrder() {
      var self = this;
      if (this.refundAlreadyDone || this.refundLoading || this.btReturnPending) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        title: self.$t('orders.refundConfirmTitle'),
        text: self.$t(self.order.payment_id === 'btIpay' ? 'btPayments.refundConfirm' : 'orders.refundConfirmText'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: self.$t('general.cancel'),
        confirmButtonText: self.$t('orders.refundOrder')
      }).then(function (result) {
        if (!result) {
          return;
        }
        var id = self.$route.params.id;
        var data = {
          token: self.$session.get('token'),
          company_id: self.$session.get('selectedCompany'),
          order_id: parseInt(id)
        };
        self.refundLoading = true;
        self.$nextTick(function () {
          self.loading = true;
        });
        self.apiRequest('/refound-order', 'POST', data, function (response) {
          self.refundLoading = false;
          self.$nextTick(function () {
            self.loading = false;
          });
          if (response && response.success === true) {
            if (self.order.payment_id === 'btIpay' && response.pending === true) {
              self.handleBtReturnQueued();
              return;
            }
            __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
              title: '',
              text: response.message || self.$t('orders.refundSuccess'),
              type: 'success'
            }).then(function () {
              self.afterRefundSuccess(id);
            }).catch(function () {
              self.afterRefundSuccess(id);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
              title: '',
              text: self.refundErrorMessage(response),
              type: 'error'
            });
          }
        });
      }).catch(function () {});
    },
    afterRefundSuccess: function afterRefundSuccess(id) {
      var self = this;

      self.$session.set('refreshOrdersCount', 'refresh');
      self.getData();
      if (typeof self.callback === 'function') {
        self.callback(id);
      }

      if (!self.order || !self.order.status || self.order.status.id === 'CANCELED') {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        title: '',
        text: self.$t('orders.refundAskCancel'),
        type: 'question',
        showCancelButton: true,
        cancelButtonText: self.$t('general.cancel')
      }).then(function (result) {
        if (result) {
          self.cancelAfterRefund(id);
        }
      }).catch(function () {});
    },
    cancelAfterRefund: function cancelAfterRefund(id) {
      var self = this;
      var data = {
        id: id,
        token: self.$session.get('token'),
        company_id: self.$session.get('selectedCompany'),
        status: 'CANCELED'
      };
      self.apiRequest('/order/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          self.$session.set('refreshOrdersCount', 'refresh');
          self.$bus.$emit('stopSound');
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
            text: self.$t('orders.orderStatusSuccess'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          self.getData();
          if (typeof self.callback === 'function') {
            self.callback(id, { 'id': 'CANCELED', 'type': self.$t('ordersStatus.CANCELED') });
          }
        } else if (response.errors && response.errors.boogit) {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
            text: response.errors.boogit,
            type: 'error',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
        }
      });
    },
    showPrint: function showPrint() {
      var companyLocations = this.$session.get('selectedCompanyData');
      var locationId = this.order.production_details.location.id;
      var show = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(companyLocations.locations_details), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var location = _step.value;

          if (location.id === locationId && location.use_printer !== undefined && location.use_printer) {
            show = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return show;
    },
    getData: function getData() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      var self = this;

      if (self.$route.params.id) {
        var id = self.$route.params.id;

        self.apiRequest('/order/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            response.data[0].formatted_pickup_datetime = self.formatTime(response.data[0].pickup_datetime);
            self.order = response.data[0];
            self.coupon = self.order.coupon;
            if (self.order.applyCoupons) {
              self.coupon = '';
              for (var cupons in self.order.applyCoupons) {
                self.coupon += self.order.applyCoupons[cupons].coupon_code;
                self.coupon += ', ';
              }
              self.coupon = self.coupon.slice(0, -2);
            }
            for (var iParts in self.order.parts) {
              for (var iItem in self.order.parts[iParts].items) {
                var item = self.order.parts[iParts].items[iItem];
                var sumOptions = 0;
                if (item.options && item.options.length) {
                  sumOptions = item.options.map(function (item) {
                    return item.price;
                  }).reduce(function (prev, next) {
                    return parseFloat(prev) + parseFloat(next);
                  });
                }
                self.order.parts[iParts].items[iItem].price_total_product = (parseFloat(item.price) + parseFloat(sumOptions)).toFixed(2);
              }
            }
            var statusesRaw = self.$session.get('defaultData')['order_statuses'];
            var isBefore = true;
            var isAllowed = true;
            self.cancelOrder = !!self.order.packagez_order_id;
            self.orderStatuses = [];
            self.currentOrdersStatus = self.order.status.id;
            for (var ordType in statusesRaw) {
              for (var type in statusesRaw[ordType]) {
                if (ordType === self.order.delivery_type && type !== 'DRAFT') {
                  if (type === 'CANCELED' && self.order.payment_type === 'CARD' && self.order.capture_transaction_status === 'OK') {
                    isAllowed = false;
                  } else if (self.order.delivery_type === 'EAT_LOCATION') {
                    isAllowed = true;
                  } else {
                    isAllowed = self.orderStatusAllowed(self.order.status.id, type);
                  }
                  self.orderStatuses.push({
                    'type': type,
                    'text': statusesRaw[ordType][type],
                    'isBefore': isBefore,
                    'isAllowed': isAllowed
                  });
                  if (self.order.status.id === type) {
                    isBefore = false;
                  }
                }
              }
            }

            self.currency = response.data[0]['currency'];

            self.showPrintBtn = self.showPrint();

            self.$nextTick(function () {
              self.loading = false;
            });
          }
        });
      }
    },
    heartbeat: function heartbeat(orderData) {
      var self = this;
      self.order.status = orderData.status;

      var statusesRaw = self.$session.get('defaultData')['order_statuses'];
      var isBefore = true;
      var isAllowed = true;

      self.orderStatuses = [];
      self.currentOrdersStatus = self.order.status.id;

      for (var ordType in statusesRaw) {
        for (var type in statusesRaw[ordType]) {
          if (ordType === self.order.delivery_type && type !== 'DRAFT') {
            isAllowed = self.orderStatusAllowed(self.order.status.id, type);
            self.orderStatuses.push({
              'type': type,
              'text': statusesRaw[ordType][type],
              'isBefore': isBefore,
              'isAllowed': isAllowed
            });
            if (self.order.status.id === type) {
              isBefore = false;
            }
          }
        }
      }
      this.$nextTick(function () {});
    },
    updateHour: function updateHour() {
      var id = this.$route.params.id;
      var self = this;
      if (this.order.formatted_pickup_datetime === '' || this.order.formatted_pickup_datetime === null) {
        __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({ 'text': self.$t('orders.orderHourError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch({});
      } else {
        var newTime = __WEBPACK_IMPORTED_MODULE_18_moment___default()(String(this.order.pickup_datetime)).format('YYYY-MM-DD');
        newTime = __WEBPACK_IMPORTED_MODULE_18_moment___default()(String(newTime + ' ' + this.order.formatted_pickup_datetime)).format('YYYY-MM-DD HH:mm:ss');
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          pickup_datetime: newTime
        };

        this.apiRequest('/order/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', self.$t('orders.orderHourSuccess'), 'success');
          } else {
            __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
          }
        });
      }
    },
    automatUpdateHour: function automatUpdateHour(time, flag) {
      var id = this.$route.params.id;
      var self = this;
      if (this.order.formatted_pickup_datetime === '' || this.order.formatted_pickup_datetime === null) {
        __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({ 'text': self.$t('orders.orderHourError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch({});
      } else {
        var newTime = __WEBPACK_IMPORTED_MODULE_18_moment___default()(String(this.order.pickup_datetime)).format('YYYY-MM-DD');
        if (flag === 'add') {
          newTime = __WEBPACK_IMPORTED_MODULE_18_moment___default()(String(newTime + ' ' + this.order.formatted_pickup_datetime)).add(time, 'minutes').format('YYYY-MM-DD HH:mm:ss');
        } else {
          newTime = __WEBPACK_IMPORTED_MODULE_18_moment___default()(String(newTime + ' ' + this.order.formatted_pickup_datetime)).subtract(time, 'minutes').format('YYYY-MM-DD HH:mm:ss');
        }
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          pickup_datetime: newTime
        };
        if (__WEBPACK_IMPORTED_MODULE_18_moment___default()(this.order.created_at).format('YYYY-MM-DD HH:mm:ss') > __WEBPACK_IMPORTED_MODULE_18_moment___default()(newTime).format('YYYY-MM-DD HH:mm:ss')) {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', this.$t('validations.hourIsSmallerThanCreated'), 'error');
        } else {
          this.apiRequest('/order/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              self.order.formatted_pickup_datetime = self.formatTime(response.data[0].pickup_datetime);
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', self.$t('orders.orderHourSuccess'), 'success');
              self.callback(id, null, response.data[0].pickup_datetime);
            } else {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }
    },
    saveComment: function saveComment() {
      var id = this.$route.params.id;
      var data = {
        id: id,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        backoffice_comments: this.order.backoffice_comments
      };
      var self = this;
      this.apiRequest('/order/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', self.$t('orders.orderCommnetSuccess'), 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
        }
      });
    },
    updateStatus: function updateStatus(status, label, disabled) {
      var _this = this;

      var revertOnCancel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (disabled) {
        return false;
      }
      var self = this;
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        text: self.$t('validations.areYouSure') + this.changeDeliveryStatus(status),
        type: 'question',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        if (result) {
          var id = _this.$route.params.id;
          var data = {
            id: id,
            token: _this.$session.get('token'),
            company_id: _this.$session.get('selectedCompany'),
            status: status
          };
          _this.apiRequest('/order/' + id, 'PUT', data, function (response) {
            var _this2 = this;

            if (response.status === true) {
              self.$session.set('refreshOrdersCount', 'refresh');
              var msg = self.$t('orders.orderStatusSuccess');
              if (response.data_specials !== undefined && response.data_specials.printer_error !== undefined) {
                msg = msg + self.$t('orders.orderPrinterError');
              }

              if (response.data[0].status.id !== 'NEW') {
                self.$bus.$emit('stopSound');
              }
              if (response.data[0].status.id === 'CANCELED') {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(self.orderStatuses), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var ordstat = _step2.value;

                    ordstat.isAllowed = false;
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              }
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                text: msg,
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).then(function () {
                var companyLocations = self.$session.get('selectedCompanyData');
                var locationId = self.order.production_details.location.id;
                companyLocations.locations_details.forEach(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(location) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (location.id === locationId && status === 'PROCESSING' && location.auto_print) {
                              setTimeout(function () {
                                self.printPage();
                              }, 3000);
                            }

                          case 1:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
              });
              if (status !== 'CANCELED') {
                self.$session.set('refreshOrdersCount', 'refresh');
                var _msg = self.$t('orders.orderStatusSuccess');
                if (response.data_specials !== undefined && response.data_specials.printer_error !== undefined) {
                  _msg = _msg + self.$t('orders.orderPrinterError');
                }
                __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                  text: _msg,
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function () {
                  var companyLocations = self.$session.get('selectedCompanyData');
                  var locationId = self.order.production_details.location.id;
                  companyLocations.locations_details.forEach(function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(location) {
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              if (location.id === locationId && status === 'PROCESSING' && location.auto_print) {
                                setTimeout(function () {
                                  self.printPage();
                                }, 3000);
                              }

                            case 1:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this2);
                    }));

                    return function (_x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                });
                self.getData();
                self.callback(id, { 'id': status, 'type': label });
              } else if (status === 'CANCELED' && response.data[0].payment_id === 'btIpay') {
                if (self.order.transaction_id && !self.refundAlreadyDone) self.handleBtReturnQueued();else self.getData();
              } else if (status === 'CANCELED' && response.data[0].payment_type === 'CARD') {
                if (response.data[0].was_delivery_before) {
                  __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                    text: self.$t('orders.refundManual'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  });
                  self.getData();
                  self.callback(id, { 'id': status, 'type': label });
                } else {
                  setTimeout(function () {
                    var que = self.$t('orders.refundAutomat');
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      text: que,
                      type: 'question',
                      showCancelButton: true,
                      cancelButtonText: self.$t('general.cancel')
                    }).then(function (res) {
                      var data2 = {
                        id: id,
                        token: self.$session.get('token'),
                        company_id: self.$session.get('selectedCompany'),
                        status: status
                      };
                      self.apiRequest('/automat-refund', 'POST', data2, function (response) {
                        if (response.status === true) {
                          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                            text: self.$t('orders.' + response.data),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          });
                        } else {
                          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                            text: self.$t('orders.' + response.errors.error),
                            type: 'error',
                            showConfirmButton: false,
                            timer: 1500
                          });
                        }
                        self.getData();
                        self.callback(id, { 'id': status, 'type': label });
                      });
                    });
                  }, 2000);
                }
              }
            } else if (response.errors.boogit) {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                text: response.errors.boogit,
                type: 'error',
                showConfirmButton: false,
                timer: 1500
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
              if (revertOnCancel) {
                self.currentOrdersStatus = self.order.status.id;
              }
            }
          });
        }
      }).catch(function () {
        if (revertOnCancel) {
          self.currentOrdersStatus = self.order.status.id;
        }
      });
    },
    changeStatus: function changeStatus() {
      var status = this.currentOrdersStatus;
      var label = this.$t('ordersStatus.' + this.currentOrdersStatus);
      this.updateStatus(status, label, false, true);
    },
    changeStatusFromButtons: function changeStatusFromButtons(type) {
      this.currentOrdersStatus = type;
      var status = this.currentOrdersStatus;
      var label = this.$t('ordersStatus.' + this.currentOrdersStatus);
      this.updateStatus(status, label, false, true);
    },
    printPage: function printPage() {
      window.print();
    },
    sendToPrinter: function sendToPrinter() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var id = this.$route.params.id;
      var data = {
        token: this.$session.get('token')
      };
      var self = this;
      this.apiRequest('/print/' + id, 'GET', data, function (response) {
        self.$nextTick(function () {
          self.loading = false;
        });
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', self.$t('orders.printerSuccess'), 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', self.$t('orders.printerErrror'), 'error');
        }
      });
    },
    changeDeliveryStatusForLabel: function changeDeliveryStatusForLabel(status) {
      var self = this;
      if (status === 'DELIVERED' && self.order.delivery_type === 'EAT_LOCATION') {
        status = 'RESERVED';
      }
      if (status === 'DELIVERED' && self.order.delivery_type === 'PICK_UP') {
        status = 'COMPLETED';
      }
      return this.$t('ordersStatus.' + status);
    },
    changeDeliveryStatus: function changeDeliveryStatus(status) {
      var self = this;
      if (status === 'DELIVERED' && self.order.delivery_type === 'EAT_LOCATION') {
        status = 'RESERVED';
      }
      if (status === 'DELIVERED' && self.order.delivery_type === 'PICK_UP') {
        status = 'COMPLETED';
      }
      if (status === 'CANCELED') {
        status = this.$t('canceledForever');
      }
      return this.$t('ordersStatus.' + status);
    },
    convetLabelingJson: function convetLabelingJson(labeling) {
      var label = JSON.parse(labeling);
      return label.notification;
    },
    courierCall: function courierCall(id, locationId) {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        title: this.$t('orders.packageDetails'),
        html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"><label style="margin-top: inherit;">' + this.$t('orders.packageSize') + '</label><select id="package-size-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="30x30x10">30x30x10</option><option value="30x30x20">30x30x20</option><option value="30x30x30">30x30x30</option><option value="60x60x30">60x60x30</option></select></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        data.size = document.getElementById('package-size-' + id).value;
        data.time = document.getElementById('package-time-' + id).value;
        if (result) {
          _this3.apiRequest('/packagez-send-order', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                text: _this3.$t('orders.orderSentSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false
              });
              _this3.cancelOrder = true;
            } else {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                text: response.errors.package,
                type: 'error',
                timer: 2000,
                showConfirmButton: false
              });
            }
          });
        }
      });
    },
    cancelCourierOrder: function cancelCourierOrder(id, locationId) {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        text: this.$t('orders.callCourierCancel'),
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (result) {
          _this4.apiRequest('/packagez-cancel-order', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                text: _this4.$t('orders.orderCancelSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false,
                cancelButtonText: _this4.$t('general.cancel')
              });
              _this4.cancelOrder = false;
            } else {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                text: response.errors.order,
                type: 'error',
                timer: 2000,
                showConfirmButton: false
              });
            }
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "AJDH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ALiV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{},[_c('div',{staticClass:"card-content "},[_c('reward-form',{attrs:{"modeldata":_vm.model,"defaultData":_vm.defaultData}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AM1d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      apiUrl: "https://gatewaydev.taptasty.com/"
    };
  },
  created: function created() {
    this.saveWoltCode();
  },

  methods: {
    saveWoltCode: function saveWoltCode() {
      var _this = this;

      var params = this.$route.query;

      var data = {
        payload: params
      };

      this.apiRequest('/client-api/wolt/dashboard-callback', 'POST', data, function (response) {
        _this.$router.push('/login');
      });
    }
  }
});

/***/ }),

/***/ "AQ90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosScreenEdit_vue__ = __webpack_require__("WvLp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb209d26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosScreenEdit_vue__ = __webpack_require__("KAgW");
function injectStyle (ssrContext) {
  __webpack_require__("7iQP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosScreenEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb209d26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosScreenEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AS2v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_js_popover__);












__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a),
  props: {
    isOrderStatus: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isOrderStatus: function isOrderStatus() {
      if (this.isOrderStatus) {
        this.getOrders();
      }
    }
  },
  created: function created() {
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear();
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '_' + this.$t('reports.statusReport') + '_' + formattedDate + '.xlsx';
    this.verifyUserMethods();
  },
  data: function data() {
    return {
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD')],
        method: 'delivery'
      },
      showMethods: false,
      methods: [],
      paginationProps: {
        layout: 'total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions1: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      ordersTableData: [],
      average: [],
      statuses: [],
      totalRecords: null,
      editMode: false,
      useStatuses: {
        'ON_HOLD': true,
        'POSTPONED': true,
        'PROCESSING': true,
        'PREPARED': true,
        'AWAITING_TRANSPORT': true,
        'PICKED_UP_BY_DELIVERY': true,
        'TRANSPORT': true,
        'DELIVERED': true,
        'NOT_DELIVERED': true
      },
      excludeOrders: []
    };
  },

  methods: {
    separateDate: function separateDate(date) {
      if (date === '--') {
        return date;
      }
      var txt = date.split(' ');
      return txt[1];
    },
    separateDateJustDate: function separateDateJustDate(date) {
      if (date === '--') {
        return date;
      }
      var txt = date.split(' ');
      return txt[0];
    },
    calcSubst: function calcSubst(column) {
      return column.substring(0, 3) === 'AVG';
    },
    calcSubst2: function calcSubst2(column) {
      var a = column.substring(3);
      a = this.average[a];
      if (a) {
        return this.calcTime(a.avg);
      } else {
        return '--';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    downloadReport: function downloadReport(query) {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.orders.valid[0],
        end_date: this.orders.valid[1]
      };
      var onlyUse = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.useStatuses).filter(function (status) {
        return _this.useStatuses[status] === true;
      });
      data.use_statuses = onlyUse;
      if (this.orders.method && this.orders.method !== '') {
        data.method = this.orders.method.toUpperCase();
      }
      if (this.excludeOrders.length) {
        data.exclude_orders = this.excludeOrders;
      } else {
        delete data.exclude_orders;
      }
      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      this.apiRequest('/reports/status/export?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        var link = document.createElement('a');
        link.href = response.file;
        link.setAttribute('download', _this.export_name);
        document.body.appendChild(link);
        link.click();
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    getOrders: function getOrders(query) {
      var _this2 = this;

      if (!this.isOrderStatus) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.orders.valid[0],
        end_date: this.orders.valid[1]
      };
      var onlyUse = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.useStatuses).filter(function (status) {
        return _this2.useStatuses[status] === true;
      });
      data.use_statuses = onlyUse;
      if (this.orders.method && this.orders.method !== '') {
        data.method = this.orders.method.toUpperCase();
      }
      if (this.excludeOrders.length) {
        data.exclude_orders = this.excludeOrders;
      } else {
        delete data.exclude_orders;
      }
      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      this.apiRequest('/reports/status?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status === true) {
          _this2.ordersTableData = response.data.orders;
          _this2.average = response.data.averages;
          _this2.totalRecords = response.data.total;
          _this2.statuses = response.data.statuses;
        }
        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
    },
    goToRecordOrder: function goToRecordOrder(row, event, column) {
      window.open('/#/orders/view/' + row.id);
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    calcTime: function calcTime(seconds) {
      var originalSeconds = seconds;
      if (seconds <= 0) {
        seconds = seconds * -1;
      }
      if (seconds === '' || seconds === 0) return '--';

      var numdays = Math.floor(seconds % 31536000 / 86400);
      var numhours = Math.floor(seconds % 31536000 % 86400 / 3600);
      var numminutes = Math.floor(seconds % 31536000 % 86400 % 3600 / 60);
      var numseconds = seconds % 31536000 % 86400 % 3600 % 60;
      var total = '';
      if (originalSeconds <= 0) {
        total = '-';
      }
      if (numdays) total += parseInt(numdays) + 'd ';
      if (numhours) total += parseInt(numhours) + 'h ';
      if (numminutes) total += parseInt(numminutes) + 'm ';
      if (numseconds) total += parseInt(numseconds) + 's ';
      return total;
    },
    editRows: function editRows() {
      this.editMode = !this.editMode;
    },
    handleCheck: function handleCheck(id) {
      if (this.excludeOrders.includes(id)) {
        var index = this.excludeOrders.indexOf(id);
        this.excludeOrders.splice(index, 1);
      } else {
        this.excludeOrders.push(id);
      }
    }
  }
});

/***/ }),

/***/ "ATVL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-offset-1 col-md-10"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"purple text-center"},[_vm._v(_vm._s(_vm.$t('marketingCoupons.couponDetails')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.name'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.header.name),expression:"header.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('marketingCoupons.name')},domProps:{"value":(_vm.header.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.header, "name", $event.target.value)}}}),_vm._v(" "),(_vm.headerErrors.name)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('validations.requiredField')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.validFromTo'))+"*")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","value-format":"yyyy-MM-dd"},model:{value:(_vm.header.fromto),callback:function ($$v) {_vm.$set(_vm.header, "fromto", $$v)},expression:"header.fromto"}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.headerErrors.fromto)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('validations.requiredField')))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.active')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.header.active),callback:function ($$v) {_vm.$set(_vm.header, "active", $$v)},expression:"header.active"}})],1)])]),_vm._v(" "),(_vm.pushCampaigns.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.pushCampaigns'))+":")]),_vm._v(" "),_vm._l((_vm.pushCampaigns),function(campaign){return _c('span',{key:campaign.id,staticClass:"coupon-badge coupon-badge--campaign"},[_vm._v(_vm._s(campaign.name))])})],2)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.loaded)?_c('forth-step',{ref:"forthStep",attrs:{"standalone":"","userLabelLevels":_vm.userLabelLevels,"modelFromParent":_vm.couponModel,"couponsParent":_vm.coupons,"customerGroups":_vm.customerGroups,"selectedCustomerGroups":_vm.selectedCustomerGroups,"checkedKeys":_vm.checkedKeys,"couponError":_vm.couponError,"route":_vm.route},on:{"groupCustomers":_vm.handleGroupCustomers}},[_c('div',{staticClass:"form-group coupon-subscription",class:{ 'is-on': _vm.coupons.is_subscription },attrs:{"slot":"before-auto-apply"},slot:"before-auto-apply"},[_c('p-checkbox',{staticClass:"text-purple",attrs:{"disabled":_vm.subscriptionLocked},on:{"input":_vm.onSubscriptionToggle},model:{value:(_vm.coupons.is_subscription),callback:function ($$v) {_vm.$set(_vm.coupons, "is_subscription", $$v)},expression:"coupons.is_subscription"}},[_c('h6',{staticClass:"coupon-selection pad-to-7"},[_vm._v(_vm._s(_vm.$t('marketingCoupons.isSubscription')))])]),_vm._v(" "),_c('small',{staticClass:"text-muted coupon-subscription__hint"},[_vm._v(_vm._s(_vm.$t('marketingCoupons.isSubscriptionHint')))]),_vm._v(" "),(_vm.subscriptionLockReason)?_c('small',{staticClass:"coupon-subscription__lock"},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" "+_vm._s(_vm.subscriptionLockReason))]):_vm._e(),_vm._v(" "),(_vm.subscriptionLevels.length)?_c('div',{staticClass:"coupon-subscription__levels"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.subscriptionLevels'))+":")]),_vm._v(" "),_vm._l((_vm.subscriptionLevels),function(level){return _c('span',{key:level.id,staticClass:"coupon-badge coupon-badge--subscription"},[_vm._v(_vm._s(level.name))])})],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group coupon-automation",class:{ 'is-on': _vm.coupons.is_automation },attrs:{"slot":"before-auto-apply"},slot:"before-auto-apply"},[_c('p-checkbox',{attrs:{"disabled":_vm.automationLocked},model:{value:(_vm.coupons.is_automation),callback:function ($$v) {_vm.$set(_vm.coupons, "is_automation", $$v)},expression:"coupons.is_automation"}},[_c('h6',{staticClass:"coupon-selection pad-to-7"},[_vm._v(_vm._s(_vm.$t('marketingCoupons.isAutomation')))])]),_vm._v(" "),_c('small',{staticClass:"text-muted coupon-automation__hint"},[_vm._v(_vm._s(_vm.$t('marketingCoupons.isAutomationHint')))]),_vm._v(" "),(_vm.automationLockReason)?_c('small',{staticClass:"coupon-automation__lock"},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" "+_vm._s(_vm.automationLockReason))]):_vm._e(),_vm._v(" "),(_vm.automationCampaigns.length)?_c('div',{staticClass:"coupon-automation__campaigns"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.automationCampaigns'))+":")]),_vm._v(" "),_vm._l((_vm.automationCampaigns),function(campaign){return _c('span',{key:campaign.id,staticClass:"coupon-badge coupon-badge--automation"},[_vm._v(_vm._s(campaign.name))])})],2):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center mar-to-10"},[_c('button',{staticClass:"btn btn-purple-light btn-fill btn-wd",attrs:{"disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AX3L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PriceProfileForm_vue__ = __webpack_require__("2iTw");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PriceProfileForm: __WEBPACK_IMPORTED_MODULE_0__PriceProfileForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      priceProfileData: this.route.params.priceProfileData || {}
    };
  },

  methods: {
    onProfileSubmit: function onProfileSubmit(model, isValid) {
      this.priceProfileModel = model;
    }
  }
});

/***/ }),

/***/ "AYSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.salesChart.data,"chart-options":_vm.salesChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("2015 Sales")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("All products including Taxes")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Tesla Model S\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" BMW 5 Series\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.usersChart.data,"chart-options":_vm.usersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Users Behavior")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("24 hours performance")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Open\n          "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" Click\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" Click Second Time\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.subscriptionsChart.data,"chart-options":_vm.subscriptionsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("169")]),_vm._v(" "),_c('span',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        -14%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total customers "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 7 days\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View all members\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-angle-right"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.downloadsChart.data,"chart-options":_vm.downloadsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("8,960")]),_vm._v(" "),_c('span',{staticClass:"label label-warning",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        ~51%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total app downloads "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 6 years\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View more details\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-info"})])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Aa8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderEdit_vue__ = __webpack_require__("JtLQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32e22bf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderEdit_vue__ = __webpack_require__("h2V8");
function injectStyle (ssrContext) {
  __webpack_require__("2Sfy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32e22bf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AahH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.$route.params.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteOrderScreen($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-3 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.model.id)?_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-lg-4 col-md-6"},[_c('p',{staticStyle:{"margin":"0","min-width":"110px"}},[_vm._v(_vm._s(_vm.$t('settingTable.loginCode')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('input',{staticClass:"copy_link",staticStyle:{"margin":"0"},attrs:{"type":"text","disabled":"true"},domProps:{"value":_vm.model.id + '.' + _vm.company_id},on:{"click":function($event){_vm.copyToClipboard(_vm.model.id + '.' + _vm.company_id)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('a',{staticClass:"btn btn-icon btn-info mar-rt-10",staticStyle:{"padding":"6px 5px"},attrs:{"title":_vm.$t('general.copyToClipboard')},on:{"click":function($event){_vm.copyToClipboard(_vm.model.id + '.' + _vm.company_id)}}},[_c('i',{staticClass:"fa fa-copy"})])])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"id":"name","type":"text"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.location')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.location.id),expression:"model.location.id"}],staticClass:"form-control",attrs:{"name":"location"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.location, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateLocationId($event)}]}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}})})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.invalid),expression:"type.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('type'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Server Local Ip")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.server_ip),expression:"modelValidate.server_ip"},{name:"model",rawName:"v-model",value:(_vm.model.server_ip),expression:"model.server_ip"}],staticClass:"form-control",attrs:{"id":"name","type":"text","placeholder":"192.168.1.10"},domProps:{"value":(_vm.model.server_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "server_ip", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Pos")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos_id),expression:"model.pos_id"}],staticClass:"form-control",attrs:{"name":"type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "pos_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"label":_vm.$t('general.select')},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.allPoses),function(pos){return _c('option',{key:pos.id,attrs:{"label":pos.name},domProps:{"value":pos.id}})})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.pos_image,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnagePosImage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemovePosImage,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-9 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{staticClass:"card-content",staticStyle:{"padding":"5px"}},[_c('table',{ref:"sortableTable",staticClass:"table width-table",staticStyle:{"margin":"0px","width":"100% !important"}},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('companyOptions.image')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"70px"}},[_vm._v("Time in seconds between slides")]),_vm._v(" "),_c('th',{staticStyle:{"width":"70px"}},[_vm._v("From")]),_vm._v(" "),_c('th',{staticStyle:{"width":"70px"}},[_vm._v("To")]),_vm._v(" "),_c('th',{staticStyle:{"width":"70px"}},[_vm._v("Active")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('draggable',{attrs:{"sort":false,"element":'tbody'},model:{value:(_vm.model.images),callback:function ($$v) {_vm.$set(_vm.model, "images", $$v)},expression:"model.images"}},[_vm._l((_vm.model.images),function(item,index){return [_c('tr',{key:'slide-' + index,staticClass:"sortableRow"}),_c('tr',[_c('td',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",refInFor:true,attrs:{"multiple":"","action":"","limit":50,"file-list":item.images ? item.images : [],"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":function (file,fileList) {return _vm.handleImgChnage(file,fileList,index)},"on-exceed":_vm.handleExceed,"on-remove":function (file,fileList) {return _vm.handleRemove(file,fileList,index)},"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)]),_vm._v(" "),_c('td',[_c('tr',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.time),expression:"item.time"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml mar-bt-5",attrs:{"type":"text","placeholder":""},domProps:{"value":(item.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "time", $event.target.value)}}})])]),_vm._v(" "),_c('td',[_c('tr',[_c('el-time-select',{staticStyle:{"width":"100px"},attrs:{"disabled":false,"placeholder":"Select time","value":item.from,"picker-options":_vm.pickerOptions},model:{value:(item.from),callback:function ($$v) {_vm.$set(item, "from", $$v)},expression:"item.from"}})],1)]),_vm._v(" "),_c('td',[_c('tr',[_c('el-time-select',{staticStyle:{"width":"100px"},attrs:{"disabled":false,"placeholder":"Select time","value":item.to,"picker-options":_vm.pickerOptions},model:{value:(item.to),callback:function ($$v) {_vm.$set(item, "to", $$v)},expression:"item.to"}})],1)]),_vm._v(" "),_c('td',[_c('tr',{staticStyle:{"height":"45px"}},[[_c('p-switch',{staticClass:"mar-bt-5 mar-to-5",attrs:{"type":"success"},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}})]],2)]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.deleteValue(index)}}},[_c('i',{staticClass:"ti-close text-orange",attrs:{"title":_vm.$t('general.delete')}})])])])]})],2)],1),_vm._v(" "),_c('button',{staticClass:"btn add mar-to-15 mar-lt-20",on:{"click":function($event){$event.preventDefault();_vm.addNewImageGroup()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.value'))+"\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ah4W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableDaysSchedule_vue__ = __webpack_require__("haYA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5973d210_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableDaysSchedule_vue__ = __webpack_require__("ac9j");
function injectStyle (ssrContext) {
  __webpack_require__("wJGW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5973d210"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableDaysSchedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5973d210_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableDaysSchedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AhS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_select__);









var _components;








__WEBPACK_IMPORTED_MODULE_8_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_12_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      settings: null
    };
  },
  created: function created() {
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/services', 'GET', data, function (response) {
        if (response.status === true) {
          _this.settings = response.data.settings;

          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveDetails();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop][0]);
        }
      }
    },
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');
      this.settings[0].apple.key = this.settings[0].apple.key.replace(/(\r\n|\n|\r)/gm, '');
      var data = {
        'token': this.$session.get('token'),
        'settings': this.settings
      };
      this.apiRequest('/services/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ 'text': 'Saved', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ 'text': 'Error', 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    }
  }
});

/***/ }),

/***/ "An/G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSettings_vue__ = __webpack_require__("IdNy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d6f2e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSettings_vue__ = __webpack_require__("PLDt");
function injectStyle (ssrContext) {
  __webpack_require__("W5NO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d6f2e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AnFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("0230");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b053ca9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("/kOV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b053ca9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ApCQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-details order-mng"},[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('p',[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('settingCompany.deliveryMethodsReflect'))),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goToCompany()}}},[_vm._v(" "+_vm._s(_vm.$t('settingCompany.locationGroups'))+".")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-right"},[_c('p',{},[_c('a',{staticClass:"btn btn-success btn-icon mar-rt-10",attrs:{"title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('i',{staticClass:"ti-save"})])])])])]),_vm._v(" "),_c('div',{ref:"compDetailsContainer",staticClass:"company-wrap",style:('height:' + (_vm.windowHeight - _vm.pageTopHeight - _vm.navbarHeaderHeight - 1) + 'px')},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-5"},[_c('div',{staticClass:"card-content"},[_c('h5',{staticClass:"pad-bt-15"},[_c('i',{staticClass:"ti-align-left"}),_vm._v("  "+_vm._s(_vm.$t('settingCompany.deliveryLabels'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.model.delivery_options_labels),function(labelObj){return _c('div',{staticClass:"pad-bt-15 col-md-6"},[_c('label',[_vm._v(" "+_vm._s(_vm.$t('settingCompany.' + labelObj['key']))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(labelObj['label']),expression:"labelObj['label']"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(labelObj['label'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(labelObj, 'label', $event.target.value)}}})])}))])]),_vm._v(" "),_vm._l((_vm.model.locations_details),function(bussLocation,indexBussLocation){return _c('div',{staticClass:"card pad-bt-15"},[_c('div',{staticClass:"card-content"},[_c('h5',{staticClass:"pad-bt-15"},[_c('i',{staticClass:"ti-home"}),_vm._v(" "+_vm._s(_vm.$t('settingCompany.bussLoc'))+": "+_vm._s(bussLocation.name)+"\n        ")]),_vm._v(" "),_c('form',[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('el-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_vm._l((bussLocation.ordering_management),function(order,orderIdx){return [(_vm.model.delivery_options_labels[_vm.getObjectByElemKeyValue('key', order.type, _vm.model.delivery_options_labels)])?[_c('div',{staticClass:"pull-right disable-chck",on:{"click":function($event){_vm.updateTabs(bussLocation.id + order.type, order.enabled)}}},[_c('p-checkbox',{key:"order.type",attrs:{"value":"true","label":order.label},on:{"click":function($event){_vm.updateTabs(bussLocation.id + order.type)}},model:{value:(order.enabled),callback:function ($$v) {_vm.$set(order, "enabled", $$v)},expression:"order.enabled"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.enabled')))])],1),_vm._v(" "),_c('el-collapse-item',{staticClass:"text-left",class:order.enabled ? '' : 'disabled',attrs:{"title":_vm.model.delivery_options_labels[_vm.getObjectByElemKeyValue('key', order.type, _vm.model.delivery_options_labels)]['label'],"name":bussLocation.id + order.type}},[_c('form',[(order.type == 'eat_location')?[_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"order.reservation_available_in_app",attrs:{"value":"true","label":order.reservation_available_in_app},model:{value:(order.reservation_available_in_app),callback:function ($$v) {_vm.$set(order, "reservation_available_in_app", $$v)},expression:"order.reservation_available_in_app"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservation_available_in_app')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('hr')]),_vm._v(" "),(order.reservation_available_in_app)?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Numărul minim de persoane pentru o rezervare")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.min_reservation),expression:"order.min_reservation"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'min_reservation',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.min_reservation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "min_reservation", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Numărul maxim de persoane pentru o rezervare")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.max_reservation),expression:"order.max_reservation"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'max_reservation',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.max_reservation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "max_reservation", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.min_between_reservations')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.min_between_reservations),expression:"order.min_between_reservations"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'min_between_reservations',"placeholder":"","disabled":!order.enabled},domProps:{"value":(order.min_between_reservations)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "min_between_reservations", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.min_standard_reservations')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.min_standard_reservations),expression:"order.min_standard_reservations"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'min_standard_reservations',"placeholder":"","disabled":!order.enabled},domProps:{"value":(order.min_standard_reservations)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "min_standard_reservations", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.available_days')))]),_vm._v(" "),_vm._l((order.available_days),function(day,dayIdx){return _c('div',{staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[(dayIdx == 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'days',"id":bussLocation.id + order.type + day.day,"disabled":!order.enabled},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'days',"id":bussLocation.id + order.type + day.day,"disabled":!order.enabled},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":bussLocation.id + order.type + day.day}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + day.day))))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                  from\n                                  "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled,"placeholder":"Select time","value":day.open_from,"picker-options":_vm.pickerOptions},model:{value:(day.open_from),callback:function ($$v) {_vm.$set(day, "open_from", $$v)},expression:"day.open_from"}}),_vm._v("\n                                  to\n                                  "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled,"placeholder":"Select time","value":day.open_to,"picker-options":_vm.pickerOptions},model:{value:(day.open_to),callback:function ($$v) {_vm.$set(day, "open_to", $$v)},expression:"day.open_to"}})],1)]),_vm._v(" "),(day.intervals)?_c('div',{staticClass:"row intervals"},[_vm._l((day.intervals),function(interval,intervalKey){return [_c('div',{staticClass:"col-md-3 padd in-inline-160"}),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                  from\n                                  "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled,"placeholder":"Select time","value":interval.open_from,"picker-options":_vm.pickerOptions},model:{value:(interval.open_from),callback:function ($$v) {_vm.$set(interval, "open_from", $$v)},expression:"interval.open_from"}}),_vm._v("\n                                  to\n                                  "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled,"placeholder":"Select time","value":interval.open_to,"picker-options":_vm.pickerOptions},model:{value:(interval.open_to),callback:function ($$v) {_vm.$set(interval, "open_to", $$v)},expression:"interval.open_to"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.deleteIntervals(intervalKey, dayIdx, orderIdx, indexBussLocation)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])],1)]})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-icon ",attrs:{"title":_vm.$t('general.add')  + ' moreIntervals'},on:{"click":function($event){$event.preventDefault();_vm.addMoreIntervals(dayIdx, orderIdx, indexBussLocation)}}},[_c('i',{staticClass:"ti-plus"})])])])})],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"card",staticStyle:{"box-shadow":"none","border":"1px solid #dcdfe6"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('div',{staticClass:"col-md-12 display-flex align-items-center justify-content-space-between"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationTaxesTitle')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-icon ",attrs:{"title":_vm.$t('general.add')  + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.addReservationTaxesInfo(indexBussLocation, orderIdx)}}},[_c('i',{staticClass:"ti-plus"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-lf-0 pad-rg-0"},[_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":_vm.$t('catalogProdOpt.plural')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(order.reservation_taxes && order.reservation_taxes.length == 0)?_c('p',{},[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationTaxesTitleEmpty')))]):_vm._e(),_vm._v(" "),_c('el-collapse',{ref:"elColl",refInFor:true,attrs:{"accordion":""},model:{value:(_vm.reservationTaxesIndex),callback:function ($$v) {_vm.reservationTaxesIndex=$$v},expression:"reservationTaxesIndex"}},[_vm._l((order.reservation_taxes),function(tax,idTax){return [(!tax.deleted_at)?_c('div',{staticClass:"align"},[_c('el-collapse-item',{staticClass:"customItem",attrs:{"title":tax.name === '' ? 'Name' : tax.name,"name":idTax}},[_c('div',{staticClass:"clearfix"},[_c('hr',{staticClass:"no-margin mar-bt-15"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',[_vm._v("ID: "+_vm._s(tax.id))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(tax.name),expression:"tax.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogProd.name')},domProps:{"value":(tax.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                                            "+_vm._s(_vm.getError('name'))+"\n                                                          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.chooseZone')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(tax.table_zone_id),expression:"tax.table_zone_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(tax, "table_zone_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.model.table_zones),function(zone){return [_c('option',{domProps:{"value":zone.id}},[_vm._v(_vm._s(zone.name))])]})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.startEndDate')))]),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":{
                                                                            disabledDate: function disabledDate (time) {
                                                                              if ((time.getTime() + 86401 * 1000) < Date.now()) {
                                                                                return true
                                                                              } else {
                                                                                return false
                                                                              }
                                                                            }
                                                                          }},model:{value:(tax.date_from),callback:function ($$v) {_vm.$set(tax, "date_from", $$v)},expression:"tax.date_from"}}),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":_vm.pickerOptionsTaxTo},model:{value:(tax.date_to),callback:function ($$v) {_vm.$set(tax, "date_to", $$v)},expression:"tax.date_to"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.price')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(tax.price),expression:"tax.price"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"name","placeholder":_vm.$t('catalogProd.price')},domProps:{"value":(tax.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax, "price", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"closeBtn"},[_c('button',{staticClass:"btn btn-danger pull-left btn-icon mar-15",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteReservationTaxesInfo(indexBussLocation, orderIdx, idTax)}}},[_c('i',{staticClass:"ti-close"})])])],1):_vm._e()]})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15 pad-bt-10"})])])])])])])])]:[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.paymentOptions')))]),_vm._v(" "),_vm._l((_vm.paymentOptions),function(opt,idx){return _c('div',{staticClass:"checkbox mar-bt-20"},[(idx == 0)?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(order.payment_options[opt.payment_id]),expression:"order.payment_options[opt.payment_id]"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'payment',"id":bussLocation.id + order.type + opt.payment_id,"disabled":!order.enabled},domProps:{"value":opt.payment_id,"checked":Array.isArray(order.payment_options[opt.payment_id])?_vm._i(order.payment_options[opt.payment_id],opt.payment_id)>-1:(order.payment_options[opt.payment_id])},on:{"change":function($event){var $$a=order.payment_options[opt.payment_id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=opt.payment_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(order.payment_options, opt.payment_id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(order.payment_options, opt.payment_id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(order.payment_options, opt.payment_id, $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.payment_options[opt.payment_id]),expression:"order.payment_options[opt.payment_id]"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'payment',"id":bussLocation.id + order.type + opt.payment_id,"disabled":!order.enabled},domProps:{"value":opt.payment_id,"checked":Array.isArray(order.payment_options[opt.payment_id])?_vm._i(order.payment_options[opt.payment_id],opt.payment_id)>-1:(order.payment_options[opt.payment_id])},on:{"change":function($event){var $$a=order.payment_options[opt.payment_id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=opt.payment_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(order.payment_options, opt.payment_id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(order.payment_options, opt.payment_id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(order.payment_options, opt.payment_id, $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":bussLocation.id + order.type + opt.payment_id}},[_vm._v(_vm._s(opt.name))])])}),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(bussLocation.id + order.type + 'payment')),expression:"errors.has(bussLocation.id + order.type + 'payment')"}],staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.$t('settingsOrdering.paymentOptionsErr'))+"\n                          ")])],2),_vm._v(" "),(order.type != 'delivery')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minimumOrderValue')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min_value: 0}),expression:"{required: true, min_value: 0}"},{name:"model",rawName:"v-model",value:(order.minimum_order_value),expression:"order.minimum_order_value"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'minimum_order_value',"placeholder":"","disabled":!order.enabled},domProps:{"value":(order.minimum_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "minimum_order_value", $event.target.value)}}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.currency))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.waitingTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.default_waiting_time),expression:"order.default_waiting_time"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'default_waiting_time',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.default_waiting_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "default_waiting_time", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minutes')))])]),_vm._v(" "),(order.type == 'eat_location')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Minim rezervari")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.min_reservation),expression:"order.min_reservation"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'min_reservation',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.min_reservation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "min_reservation", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(order.type == 'eat_location')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Maxim rezervari")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.max_reservation),expression:"order.max_reservation"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'max_reservation',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.max_reservation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "max_reservation", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[(order.type != 'self_ordering')?[_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"},attrs:{"for":'swPreorders_'+order.id}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.noPreorders')))]),_vm._v(" "),_c('p-switch',{attrs:{"name":'swPreorders_'+order.id,"type":"success"},model:{value:(order.no_preorders),callback:function ($$v) {_vm.$set(order, "no_preorders", $$v)},expression:"order.no_preorders"}}),_vm._v(" "),(order.offset > 0 || order.period > 1)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsOrdering.offnoPreorders')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"},attrs:{"for":'swAlwaysOpen_'+bussLocation.id+'_'+order.type}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.isAlwaysOpen')))]),_vm._v(" "),_c('p-switch',{attrs:{"name":'swAlwaysOpen_'+bussLocation.id+'_'+order.type,"type":"success"},model:{value:(order.is_always_open),callback:function ($$v) {_vm.$set(order, "is_always_open", $$v)},expression:"order.is_always_open"}})],1),_vm._v(" "),(order.is_always_open)?_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                                "+_vm._s(_vm.$t('settingsOrdering.isAlwaysOpenPreorderHours'))+"\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.is_always_open_preorder_hours),expression:"order.is_always_open_preorder_hours"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type +'is_always_open_preorder_hours',"disabled":!order.enabled},domProps:{"value":(order.is_always_open_preorder_hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "is_always_open_preorder_hours", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.availableDays')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(bussLocation.id + order.type + 'days')),expression:"errors.has(bussLocation.id + order.type + 'days')"}],staticClass:"text-danger"},[_vm._v("\n                              "+_vm._s(_vm.$t('settingsOrdering.availableDaysErr'))+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"changeDeliveryDisponibility"},[_c('div',{},_vm._l((_vm.delivery_hour_usage),function(dusg,dusgId){return (order.type != 'eat_location' || (dusg.id != 2 && order.type === 'eat_location'))?_c('p-radio',{key:dusgId,attrs:{"label":dusgId,"inline":true},on:{"input":function($event){_vm.changeDeliveryHourUsage(order)}},model:{value:(order.delivery_hour_usage),callback:function ($$v) {_vm.$set(order, "delivery_hour_usage", $$v)},expression:"order.delivery_hour_usage"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering')[dusg.name])+"\n                                ")]):_vm._e()})),_vm._v(" "),_c('hr')])]:_vm._e(),_vm._v(" "),(!order.deactivate_delivery_hour_usage)?[(order.type != 'self_ordering')?[_c('label',{staticStyle:{"margin-bottom":"12px","margin-right":"10px"},attrs:{"for":""}},[_vm._v("\n                                "+_vm._s(_vm.$t('settingsOrdering.offset'))+"\n                                "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.offset),expression:"modelValidate.offset"},{name:"model",rawName:"v-model",value:(order.offset),expression:"order.offset"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type +'offset',"disabled":order.is_always_open},domProps:{"value":(order.offset)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "offset", $event.target.value)}}})]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                                "+_vm._s(_vm.$t('settingsOrdering.period'))+"\n                                "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.period),expression:"modelValidate.period"},{name:"model",rawName:"v-model",value:(order.period),expression:"order.period"}],staticClass:"form-control",attrs:{"type":"number","min":"1","name":bussLocation.id + order.type +'period',"disabled":order.is_always_open},domProps:{"value":(order.period)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "period", $event.target.value)}}})])]:_vm._e(),_vm._v(" "),_vm._l((order.available_days),function(day,dayIdx){return _c('div',{staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[(dayIdx == 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'days',"id":bussLocation.id + order.type + day.day,"disabled":!order.enabled || order.is_always_open},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'days',"id":bussLocation.id + order.type + day.day,"disabled":!order.enabled || order.is_always_open},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":bussLocation.id + order.type + day.day}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + day.day))))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                    from\n                                    "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":day.open_from,"picker-options":_vm.pickerOptions},model:{value:(day.open_from),callback:function ($$v) {_vm.$set(day, "open_from", $$v)},expression:"day.open_from"}}),_vm._v("\n                                    to\n                                    "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":day.open_to,"picker-options":_vm.pickerOptions},model:{value:(day.open_to),callback:function ($$v) {_vm.$set(day, "open_to", $$v)},expression:"day.open_to"}})],1)]),_vm._v(" "),(day.intervals)?_c('div',{staticClass:"row intervals"},[_vm._l((day.intervals),function(interval,intervalKey){return [_c('div',{staticClass:"col-md-3 padd in-inline-160"}),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                    from\n                                    "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":interval.open_from,"picker-options":_vm.pickerOptions},model:{value:(interval.open_from),callback:function ($$v) {_vm.$set(interval, "open_from", $$v)},expression:"interval.open_from"}}),_vm._v("\n                                    to\n                                    "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":interval.open_to,"picker-options":_vm.pickerOptions},model:{value:(interval.open_to),callback:function ($$v) {_vm.$set(interval, "open_to", $$v)},expression:"interval.open_to"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon ",attrs:{"disabled":order.is_always_open},on:{"click":function($event){$event.preventDefault();_vm.deleteIntervals(intervalKey, dayIdx, orderIdx, indexBussLocation)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])],1)]})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-icon ",attrs:{"disabled":order.is_always_open,"title":_vm.$t('general.add')  + ' moreIntervals'},on:{"click":function($event){$event.preventDefault();_vm.addMoreIntervals(dayIdx, orderIdx, indexBussLocation)}}},[_c('i',{staticClass:"ti-plus"})])])])})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('hr')])],_vm._v(" "),(order.type != 'self_ordering')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"card",staticStyle:{"box-shadow":"none","border":"1px solid #dcdfe6"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('div',{staticClass:"col-md-12 display-flex align-items-center justify-content-space-between"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxTitle')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-icon ",attrs:{"title":_vm.$t('general.add')  + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.addMethodInfo(orderIdx, indexBussLocation)}}},[_c('i',{staticClass:"ti-plus"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-lf-0 pad-rg-0"},[_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":_vm.$t('catalogProdOpt.plural')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(!order.method_info || (order.method_info && order.method_info.length == 0))?_c('p',{},[_vm._v("No options added yet.")]):_vm._e(),_vm._v(" "),_c('el-collapse',{ref:"elColl",refInFor:true,attrs:{"accordion":""},model:{value:(_vm.methodInfoIndex),callback:function ($$v) {_vm.methodInfoIndex=$$v},expression:"methodInfoIndex"}},[_vm._l((order.method_info),function(option,idxO){return [_c('div',{staticClass:"align"},[_c('el-collapse-item',{staticClass:"customItem",attrs:{"title":option.title === '' ? 'Name' : option.title,"name":idxO}},[_c('div',{staticClass:"clearfix"},[_c('hr',{staticClass:"no-margin mar-bt-15"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(option.title),expression:"option.title"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogProd.name')},domProps:{"value":(option.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "title", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                                        "+_vm._s(_vm.getError('name'))+"\n                                                      ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxRadioCheck')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.type),expression:"option.type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"check"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxCheck')))]),_vm._v(" "),_c('option',{attrs:{"value":"radio"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxRadio')))])])])])]),_vm._v(" "),_c('table',{staticClass:"table no-margin"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"200px"}},[_vm._v(_vm._s(_vm.$t('catalogProd.optVal')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('general.delete')))])])]),_vm._v(" "),_c('tbody',_vm._l((option.options),function(value,idx){return _c('tr',[_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.title),expression:"value.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(value.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "title", $event.target.value)}}})])])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.deleteMethodInfoOptionValue(orderIdx, indexBussLocation, idxO, idx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])])])}))]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-simple btn-icon mar-bt-5",on:{"click":function($event){$event.preventDefault();_vm.addMethodInfoOptionValue(orderIdx, indexBussLocation, idxO)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" add\n                                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"closeBtn"},[_c('button',{staticClass:"btn btn-danger pull-left btn-icon mar-15",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteMethodInfo(orderIdx, indexBussLocation, idxO)}}},[_c('i',{staticClass:"ti-close"})])])],1)]})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15 pad-bt-10"})])])])])])])])]):_vm._e()]:[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.paymentOptions')))]),_vm._v(" "),_vm._l((_vm.paymentOptions),function(opt,idx){return _c('div',{staticClass:"checkbox mar-bt-20"},[(idx == 0)?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(order.payment_options[opt.payment_id]),expression:"order.payment_options[opt.payment_id]"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'payment',"id":bussLocation.id + order.type + opt.payment_id,"disabled":!order.enabled},domProps:{"value":opt.payment_id,"checked":Array.isArray(order.payment_options[opt.payment_id])?_vm._i(order.payment_options[opt.payment_id],opt.payment_id)>-1:(order.payment_options[opt.payment_id])},on:{"change":function($event){var $$a=order.payment_options[opt.payment_id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=opt.payment_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(order.payment_options, opt.payment_id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(order.payment_options, opt.payment_id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(order.payment_options, opt.payment_id, $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.payment_options[opt.payment_id]),expression:"order.payment_options[opt.payment_id]"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'payment',"id":bussLocation.id + order.type + opt.payment_id,"disabled":!order.enabled},domProps:{"value":opt.payment_id,"checked":Array.isArray(order.payment_options[opt.payment_id])?_vm._i(order.payment_options[opt.payment_id],opt.payment_id)>-1:(order.payment_options[opt.payment_id])},on:{"change":function($event){var $$a=order.payment_options[opt.payment_id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=opt.payment_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(order.payment_options, opt.payment_id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(order.payment_options, opt.payment_id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(order.payment_options, opt.payment_id, $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":bussLocation.id + order.type + opt.payment_id}},[_vm._v(_vm._s(opt.name))])])}),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(bussLocation.id + order.type + 'payment')),expression:"errors.has(bussLocation.id + order.type + 'payment')"}],staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.$t('settingsOrdering.paymentOptionsErr'))+"\n                        ")])],2),_vm._v(" "),(order.type != 'delivery')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minimumOrderValue')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min_value: 0}),expression:"{required: true, min_value: 0}"},{name:"model",rawName:"v-model",value:(order.minimum_order_value),expression:"order.minimum_order_value"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'minimum_order_value',"placeholder":"","disabled":!order.enabled},domProps:{"value":(order.minimum_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "minimum_order_value", $event.target.value)}}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.currency))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.waitingTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.default_waiting_time),expression:"order.default_waiting_time"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'default_waiting_time',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.default_waiting_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "default_waiting_time", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minutes')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.count_orders_starts_from_hour')))]),_vm._v(" "),_c('el-time-select',{attrs:{"disabled":!order.enabled,"placeholder":"Select Hour","value":order.count_orders_starts_from_hour,"picker-options":_vm.picker_options_orders_starts_from},model:{value:(order.count_orders_starts_from_hour),callback:function ($$v) {_vm.$set(order, "count_orders_starts_from_hour", $$v)},expression:"order.count_orders_starts_from_hour"}})],1),_vm._v(" "),(order.type === 'delivery')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.deliveryRules')))])])]),_vm._v(" "),_vm._l((_vm.zoneLimitations),function(zoneL,zoneId){return _c('el-radio',{key:bussLocation.id + order.type + zoneId,attrs:{"change":_vm.handleChangeArea(order.area, bussLocation.id),"label":zoneId,"inline":true},model:{value:(order.area),callback:function ($$v) {_vm.$set(order, "area", $$v)},expression:"order.area"}},[_vm._v(_vm._s(_vm.$t('settingCompany.'+ zoneL)))])}),_vm._v(" "),(order.area == 'radius')?[(_vm.taxesVersion === 2)?_c('delivery-tax-panel',{staticClass:"mar-bt-20",attrs:{"location-id":bussLocation.true_id || bussLocation.location_id || bussLocation.id,"currency":_vm.currency}}):_vm._e(),_vm._v(" "),_vm._l((order.delivery_rules),function(rule,idx){return _c('table',{key:bussLocation.id+ idx + 'rule',staticClass:"table table-rules"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"15px"}},[_c('b',[_vm._v(_vm._s((idx + 1)))])]),_vm._v(" "),_c('th',{staticStyle:{"line-height":"2"},attrs:{"width":""}},[_vm._v("\n                                  "+_vm._s(_vm.$t('settingsOrdering.deliveryRange'))+" ("+_vm._s(_vm.$t('settingsOrdering.deliveryRangeUnit'))+")\n\n                                  "),(order.delivery_rules.length > 1)?_c('button',{staticClass:"btn btn-danger btn-icon pull-right",on:{"click":function($event){$event.preventDefault();_vm.removeRule(bussLocation.id, idx, order.type)}}},[_c('i',{staticClass:"ti-trash",attrs:{"title":_vm.$t('general.remove')}}),_vm._v(" "+_vm._s(_vm.$t('general.remove'))+"\n                                  ")]):_vm._e()])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({min_value: 0}),expression:"{min_value: 0}"},{name:"model",rawName:"v-model",value:(rule.delivery_range),expression:"rule.delivery_range"}],ref:bussLocation.id + order.type +'delivery_range'+idx,refInFor:true,staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type +'delivery_range'+idx,"placeholder":"","disabled":!order.enabled,"aria-invalid":_vm.errors.has(bussLocation.id + order.type +'delivery_range'+idx)},domProps:{"value":(rule.delivery_range)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(rule, "delivery_range", $event.target.value)}}}),_vm._v(" "),_c('table',{staticClass:"table table-subrules"},[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$t('settingsOrdering.shippingNeighborhoods')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('settingsOrdering.shippingCities')))]),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('th',{attrs:{"width":"10%"}},[_vm._v("\n                                          "+_vm._s(_vm.$t('settingsOrdering.shippingCost'))+" ("+_vm._s(_vm.currency)+")\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('th',{attrs:{"width":"10%"}},[_vm._v("\n                                          "+_vm._s(_vm.$t('catalogCateg.vat'))+" "),_c('small',[_vm._v("("+_vm._s(_vm.$t('catalogCateg.included'))+")")])]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('th',{attrs:{"width":"10%"}},[_vm._v("\n                                          "+_vm._s(_vm.$t('settingsOrdering.posId'))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('th',{attrs:{"width":"10%"}},[_vm._v("\n                                          \n                                          "+_vm._s(_vm.$t('settingsOrdering.minimumOrderValue'))+" ("+_vm._s(_vm.currency)+")\n                                        ")]):_vm._e(),_vm._v(" "),_c('th')]),_vm._v(" "),_vm._l((rule.subrules),function(subrule,idxSubrule){return _c('tr',{key:bussLocation.id+ idx + idxSubrule + 'subrule'},[_c('td',{staticClass:"display-text-white"},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(subrule.neighborhoods),callback:function ($$v) {_vm.$set(subrule, "neighborhoods", $$v)},expression:"subrule.neighborhoods"}},_vm._l((subrule.neighborhoods),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('td',{staticClass:"display-text-white"},[[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(subrule.cities),callback:function ($$v) {_vm.$set(subrule, "cities", $$v)},expression:"subrule.cities"}},_vm._l((subrule.cities),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))]],2),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min_value: 0}),expression:"{required: true, min_value: 0}"},{name:"model",rawName:"v-model",value:(subrule.shipping_cost),expression:"subrule.shipping_cost"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type +'shipping_cost'+order.type+idx+idxSubrule,"placeholder":"","disabled":!order.enabled},domProps:{"value":(subrule.shipping_cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(subrule, "shipping_cost", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(subrule.tax_id),expression:"subrule.tax_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(subrule, "tax_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(tax){return (bussLocation.id == tax.location_token)?_c('option',{domProps:{"value":tax.id}},[_vm._v(_vm._s(tax.amount)+"\n                                            ")]):_vm._e()})],2)]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(subrule.shipping_pos_id),expression:"subrule.shipping_pos_id"}],staticClass:"form-control sml",attrs:{"type":"text","name":bussLocation.id + order.type +'shipping_pos_id'+order.type+idx+idxSubrule,"placeholder":_vm.$t('settingsOrdering.posId'),"disabled":!order.enabled},domProps:{"value":(subrule.shipping_pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(subrule, "shipping_pos_id", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min_value: 0}),expression:"{required: true, min_value: 0}"},{name:"model",rawName:"v-model",value:(subrule.min_order_value),expression:"subrule.min_order_value"}],staticClass:"form-control sml",attrs:{"type":"text","name":bussLocation.id + order.type +'shipping_pos_id'+order.type+idx+idxSubrule,"placeholder":_vm.$t('settingsOrdering.minimumOrderValue'),"disabled":!order.enabled},domProps:{"value":(subrule.min_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(subrule, "min_order_value", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('td',[(rule.subrules.length > 1)?_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.removeSubRule(bussLocation.id, idx, idxSubrule,order.type)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.remove')}})]):_vm._e()])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":_vm.taxesVersion === 2 ? 2 : 4}}),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addNewSubRule(bussLocation.id, order.type, idx)}}},[_c('i',{staticClass:"ti-plus"})])])])],2)])])])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-info mar-bt-15 ",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addNewRule(bussLocation.id, order.type)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('settingsOrdering.addRange'))+" ")]),_c('br')]:_vm._e(),_vm._v(" "),(order.area == 'draw')?[_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.model.locations_details[indexBussLocation].mapactive),callback:function ($$v) {_vm.$set(_vm.model.locations_details[indexBussLocation], "mapactive", $$v)},expression:"model.locations_details[indexBussLocation].mapactive"}},[_c('draggable',{attrs:{"element":'div'},model:{value:(_vm.deliveryRanges[bussLocation.id]),callback:function ($$v) {_vm.$set(_vm.deliveryRanges, bussLocation.id, $$v)},expression:"deliveryRanges[bussLocation.id]"}},_vm._l((_vm.deliveryRanges[bussLocation.id]),function(zone,indexZone){return _c('div',[_c('div',{key:indexZone,staticClass:"sortableRow"},[_c('el-collapse-item',{attrs:{"title":zone.name == '' ? _vm.$t('settingsOrdering.newZone'):zone.name,"name":indexZone}},[(_vm.model.locations_details[indexBussLocation].mapactive == indexZone)?[_c('delivery-google-maps',{attrs:{"googleMapsapiKey":bussLocation.google_maps_api_key,"cityFromParent":_vm.model.locations_details[indexBussLocation].city,"locationMarker":{lat: bussLocation.lat, lng: bussLocation.lng, name: bussLocation.name},"zoneInComp":zone,"deliveryRanges":_vm.deliveryRanges[bussLocation.id],"indexZone":indexZone,"bussLocationId":bussLocation.id,"location_id":bussLocation.true_id || bussLocation.location_id || bussLocation.id,"orderType":order.type,"currency":_vm.currency,"vatOptions":_vm.vatOptions,"taxes-version":_vm.taxesVersion}})]:_vm._e()],2)],1)])}))],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-info",on:{"click":function($event){$event.preventDefault();_vm.addNewZone(bussLocation.id, order.type, indexBussLocation)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(_vm._s(_vm.$t('settingsOrdering.addZone')))]),_vm._v(" "),_c('br')]:_vm._e(),_vm._v(" "),_c('br')]:_vm._e(),_vm._v(" "),(order.type === 'meet_half')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.locations')))]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.street')))]),_vm._v(" "),_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.city')))]),_vm._v(" "),_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.country')))]),_vm._v(" "),_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.state')))]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}})])]),_vm._v(" "),_c('tbody',[_vm._l((order.locations),function(location,idx){return _c('tr',[_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"},{name:"model",rawName:"v-model",value:(location.street),expression:"location.street"}],staticClass:"form-control",attrs:{"type":"text","name":bussLocation.id + order.type +'locationstr'+order.type+idx,"disabled":!order.enabled},domProps:{"value":(location.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "street", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.city),expression:"location.city"}],staticClass:"form-control",attrs:{"type":"text","name":bussLocation.id + order.type +'locationcity'+order.type+idx,"disabled":!order.enabled,"vv-validate":"modelValidate.required"},domProps:{"value":(location.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "city", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.country),expression:"location.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"select-primary form-control",attrs:{"name":bussLocation.id + order.type +'locationcountry'+order.type+idx,"disabled":!order.enabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateCountry(location)}]}},_vm._l((_vm.defaults.countries),function(country){return _c('option',{staticClass:"select-primary",domProps:{"value":country.alpha2}},[_vm._v(_vm._s(country.name)+"\n                                  ")])}))]),_vm._v(" "),_c('td',[(_vm.showStateDrop(location))?[_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.state_id),expression:"location.state_id"}],staticClass:"select-primary form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.getStatesOptions(location)),function(state){return _c('option',{staticClass:"select-primary",domProps:{"value":state.id}},[_vm._v(_vm._s(state.name)+"\n                                      ")])}))]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.state),expression:"location.state"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control",attrs:{"type":"text","name":"state","placeholder":_vm.$t('settingsOrdering.state')},domProps:{"value":(location.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "state", $event.target.value)}}})]],2),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.removeLocation(bussLocation.id, idx, order.type)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.remove')}})])])])}),_vm._v(" "),[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addNewLocation(bussLocation.id, order.type)}}},[_c('i',{staticClass:"ti-plus"})])])])]],2),_vm._v(" "),_c('tfoot')])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[(order.type == 'self_ordering')?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.maxDistanceInMeter')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.max_distance_in_meter),expression:"order.max_distance_in_meter"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type + 'max_distance_in_meter',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.max_distance_in_meter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "max_distance_in_meter", $event.target.value)}}})])]:_vm._e(),_vm._v(" "),(order.type != 'self_ordering')?[_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"},attrs:{"for":'swPreorders_'+order.id}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.noPreorders')))]),_vm._v(" "),_c('p-switch',{attrs:{"name":'swPreorders_'+order.id,"type":"success"},model:{value:(order.no_preorders),callback:function ($$v) {_vm.$set(order, "no_preorders", $$v)},expression:"order.no_preorders"}}),_vm._v(" "),(order.offset > 0 || order.period > 1)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsOrdering.offnoPreorders')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"},attrs:{"for":'swAlwaysOpen_'+bussLocation.id+'_'+order.type}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.isAlwaysOpen')))]),_vm._v(" "),_c('p-switch',{attrs:{"name":'swAlwaysOpen_'+bussLocation.id+'_'+order.type,"type":"success"},model:{value:(order.is_always_open),callback:function ($$v) {_vm.$set(order, "is_always_open", $$v)},expression:"order.is_always_open"}})],1),_vm._v(" "),(order.is_always_open)?_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                              "+_vm._s(_vm.$t('settingsOrdering.isAlwaysOpenPreorderHours'))+"\n                              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.is_always_open_preorder_hours),expression:"order.is_always_open_preorder_hours"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type +'is_always_open_preorder_hours',"disabled":!order.enabled},domProps:{"value":(order.is_always_open_preorder_hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "is_always_open_preorder_hours", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.availableDays')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(bussLocation.id + order.type + 'days')),expression:"errors.has(bussLocation.id + order.type + 'days')"}],staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.$t('settingsOrdering.availableDaysErr'))+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"changeDeliveryDisponibility"},[_c('div',{},_vm._l((_vm.delivery_hour_usage),function(dusg,dusgId){return (order.type != 'eat_location' || (dusg.id != 2 && order.type === 'eat_location'))?_c('p-radio',{key:dusgId,attrs:{"label":dusgId,"inline":true},on:{"input":function($event){_vm.changeDeliveryHourUsage(order)}},model:{value:(order.delivery_hour_usage),callback:function ($$v) {_vm.$set(order, "delivery_hour_usage", $$v)},expression:"order.delivery_hour_usage"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering')[dusg.name])+"\n                              ")]):_vm._e()})),_vm._v(" "),_c('hr')])]:_vm._e(),_vm._v(" "),(!order.deactivate_delivery_hour_usage)?[(order.type != 'self_ordering')?[_c('label',{staticStyle:{"margin-bottom":"12px","margin-right":"10px"},attrs:{"for":""}},[_vm._v("\n                              "+_vm._s(_vm.$t('settingsOrdering.offset'))+"\n                              "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.offset),expression:"modelValidate.offset"},{name:"model",rawName:"v-model",value:(order.offset),expression:"order.offset"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":bussLocation.id + order.type +'offset',"disabled":order.is_always_open},domProps:{"value":(order.offset)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "offset", $event.target.value)}}})]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                              "+_vm._s(_vm.$t('settingsOrdering.period'))+"\n                              "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.period),expression:"modelValidate.period"},{name:"model",rawName:"v-model",value:(order.period),expression:"order.period"}],staticClass:"form-control",attrs:{"type":"number","min":"1","name":bussLocation.id + order.type +'period',"disabled":order.is_always_open},domProps:{"value":(order.period)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "period", $event.target.value)}}})])]:_vm._e(),_vm._v(" "),_vm._l((order.available_days),function(day,dayIdx){return _c('div',{staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[(dayIdx == 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'days',"id":bussLocation.id + order.type + day.day,"disabled":!order.enabled || order.is_always_open},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","name":bussLocation.id + order.type + 'days',"id":bussLocation.id + order.type + day.day,"disabled":!order.enabled || order.is_always_open},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":bussLocation.id + order.type + day.day}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + day.day))))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                  from\n                                  "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":day.open_from,"picker-options":_vm.pickerOptions},model:{value:(day.open_from),callback:function ($$v) {_vm.$set(day, "open_from", $$v)},expression:"day.open_from"}}),_vm._v("\n                                  to\n                                  "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":day.open_to,"picker-options":_vm.pickerOptions},model:{value:(day.open_to),callback:function ($$v) {_vm.$set(day, "open_to", $$v)},expression:"day.open_to"}})],1)]),_vm._v(" "),(day.intervals)?_c('div',{staticClass:"row intervals"},[_vm._l((day.intervals),function(interval,intervalKey){return [_c('div',{staticClass:"col-md-3 padd in-inline-160"}),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                  from\n                                  "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":interval.open_from,"picker-options":_vm.pickerOptions},model:{value:(interval.open_from),callback:function ($$v) {_vm.$set(interval, "open_from", $$v)},expression:"interval.open_from"}}),_vm._v("\n                                  to\n                                  "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":interval.open_to,"picker-options":_vm.pickerOptions},model:{value:(interval.open_to),callback:function ($$v) {_vm.$set(interval, "open_to", $$v)},expression:"interval.open_to"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon ",attrs:{"disabled":order.is_always_open},on:{"click":function($event){$event.preventDefault();_vm.deleteIntervals(intervalKey, dayIdx, orderIdx, indexBussLocation)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])],1)]})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-icon ",attrs:{"disabled":order.is_always_open,"title":_vm.$t('general.add')  + ' moreIntervals'},on:{"click":function($event){$event.preventDefault();_vm.addMoreIntervals(dayIdx, orderIdx, indexBussLocation)}}},[_c('i',{staticClass:"ti-plus"})])])])})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('hr')]),_vm._v(" "),(order.type != 'self_ordering')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"card",staticStyle:{"box-shadow":"none","border":"1px solid #dcdfe6"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('div',{staticClass:"col-md-12 display-flex align-items-center justify-content-space-between"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxTitle')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-icon ",attrs:{"title":_vm.$t('general.add')  + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.addMethodInfo(orderIdx, indexBussLocation)}}},[_c('i',{staticClass:"ti-plus"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-lf-0 pad-rg-0"},[_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":_vm.$t('catalogProdOpt.plural')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(!order.method_info || (order.method_info && order.method_info.length == 0))?_c('p',{},[_vm._v("No options added yet.")]):_vm._e(),_vm._v(" "),_c('el-collapse',{ref:"elColl",refInFor:true,attrs:{"accordion":""},model:{value:(_vm.methodInfoIndex),callback:function ($$v) {_vm.methodInfoIndex=$$v},expression:"methodInfoIndex"}},[_vm._l((order.method_info),function(option,idxO){return [_c('div',{staticClass:"align"},[_c('el-collapse-item',{staticClass:"customItem",attrs:{"title":option.title === '' ? 'Name' : option.title,"name":idxO}},[_c('div',{staticClass:"clearfix"},[_c('hr',{staticClass:"no-margin mar-bt-15"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(option.title),expression:"option.title"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogProd.name')},domProps:{"value":(option.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "title", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                                        "+_vm._s(_vm.getError('name'))+"\n                                                      ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxRadioCheck')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.type),expression:"option.type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"check"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxCheck')))]),_vm._v(" "),_c('option',{attrs:{"value":"radio"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxRadio')))])])])])]),_vm._v(" "),_c('table',{staticClass:"table no-margin"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"200px"}},[_vm._v(_vm._s(_vm.$t('catalogProd.optVal')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('general.delete')))])])]),_vm._v(" "),_c('tbody',_vm._l((option.options),function(value,idx){return _c('tr',[_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.title),expression:"value.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(value.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "title", $event.target.value)}}})])])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.deleteMethodInfoOptionValue(orderIdx, indexBussLocation, idxO, idx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])])])}))]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-simple btn-icon mar-bt-5",on:{"click":function($event){$event.preventDefault();_vm.addMethodInfoOptionValue(orderIdx, indexBussLocation, idxO)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" add\n                                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"closeBtn"},[_c('button',{staticClass:"btn btn-danger pull-left btn-icon mar-15",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteMethodInfo(orderIdx, indexBussLocation, idxO)}}},[_c('i',{staticClass:"ti-close"})])])],1)]})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15 pad-bt-10"})])])])])])])])]):_vm._e()]],2)])]:_vm._e()]})],2)],1)])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ApSM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ark/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchableMultiSelect_vue__ = __webpack_require__("fklu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a8b6b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchableMultiSelect_vue__ = __webpack_require__("qAw5");
function injectStyle (ssrContext) {
  __webpack_require__("4ZgZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41a8b6b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchableMultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a8b6b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchableMultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B/Oa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'import-products-legacy-input',
  inheritAttrs: false,
  props: {
    location: Object
  },
  data: function data() {
    return {
      apiUrl: '',
      file: null,
      uploading: false
    };
  },

  computed: {
    canUpload: function canUpload() {
      return !!this.file && !this.uploading && this.location && this.location.id;
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
  },

  methods: {
    handleChange: function handleChange(file, fileList) {
      var _this = this;

      var isOkSize = file.size / 1024 / 1024 < 25;
      var isCsv = file.raw.type === 'text/csv' || file.name && file.name.toLowerCase().endsWith('.csv');
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: this.$t('validations.pdfSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        return;
      }
      if (!isCsv) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: this.$t('validations.wrongFormat'),
          position: 'top-end',
          showConfirmButton: true,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        return;
      }
      this.getBase64(file.raw).then(function (base64enc) {
        _this.file = base64enc;
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.$refs.upload.files = [];
        this.file = null;
      }
    },
    handleExceed: function handleExceed() {
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        toast: true,
        text: this.$t('validations.removePhoto'),
        type: 'warning',
        position: 'top-end',
        showConfirmButton: true
      });
    },
    getBase64: function getBase64(file) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    upload: function upload() {
      var _this2 = this;

      if (!this.canUpload) {
        return;
      }
      this.uploading = true;
      var data = {
        token: this.$session.get('token'),

        location_id: this.location.id,
        company_id: this.$session.get('selectedCompany'),
        csv: this.file
      };

      this.apiRequest('/import-location/products/legacy', 'POST', data, function (response) {
        _this2.uploading = false;
        if (response && response.status === true) {
          var locationTrueId = _this2.location && _this2.location.true_id || null;
          _this2.trackAdminEvent('ADMIN_PRODUCT_IMPORT_LEGACY', 'product_import', locationTrueId, {
            location_id: locationTrueId,
            location_token: _this2.location.id || null,
            import_type: 'legacy',
            response: response
          });
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            toast: true,
            text: _this2.$t('productImport.legacyUploadSuccess'),
            type: 'success',
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          });
          _this2.file = null;
          if (_this2.$refs.upload) {
            _this2.$refs.upload.clearFiles();
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            toast: true,
            text: response && response.data || _this2.$t('general.error'),
            type: 'error',
            position: 'top-end',
            showConfirmButton: false,
            timer: 4000
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "B2tR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryAdd_vue__ = __webpack_require__("/mvQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec61e0f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryAdd_vue__ = __webpack_require__("0ZfM");
function injectStyle (ssrContext) {
  __webpack_require__("ghJJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec61e0f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B560":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinning-wheel-users-report"},[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":function($event){$event.preventDefault();return _vm.back($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('h5',{staticClass:"mar-bt-0"},[_vm._v(_vm._s(_vm.pageTitle))])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.toggleExpand}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.spins || [],"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"spin_id","label":_vm.$t('spinningWheel.spinId'),"width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('spinningWheel.dateWon'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(s){return [_vm._v(_vm._s(_vm.formatDateTime(s.row.date_won)))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('spinningWheel.status'),"width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('spinningWheel.dateRedeemed'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(s){return [_vm._v(_vm._s(s.row.date_redeemed ? _vm.formatDateTime(s.row.date_redeemed) : '—'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qualifying_order_id","label":_vm.$t('spinningWheel.qualifyingOrder'),"width":"130"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user_id","label":_vm.$t('customers.id'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('spinningWheel.user'),"min-width":"160","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s([props.row.firstname, props.row.lastname].filter(Boolean).join(' ') || props.row.email || ('#' + props.row.user_id))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"wins","label":_vm.$t('spinningWheel.wins'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"used","label":_vm.$t('spinningWheel.used'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"available","label":_vm.$t('spinningWheel.available'),"width":"100"}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B5QA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreenForm_vue__ = __webpack_require__("wvB3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5fe9e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreenForm_vue__ = __webpack_require__("qkXe");
function injectStyle (ssrContext) {
  __webpack_require__("fGFU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreenForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5fe9e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreenForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B631":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('printer-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B7bJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);










var _components;





/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), _components),
  props: {
    isTableOpenOrderReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isTableOpenOrderReport: function isTableOpenOrderReport() {
      if (this.isTableOpenOrderReport) {
        this.getOrders();
      }
    }
  },
  created: function created() {
    this.getOrders();
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear();
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '-' + formattedDate + '.xls';
    this.verifyUserLocations();
    this.verifyUserMethods();
    this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest';
    this.getPosUsers();
  },
  data: function data() {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      currentTime: this.formatToCompanyTimezone(),
      selectedTables: [],
      availableTables: [],
      allTablesMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
      posUsers: [],
      productsTableData: [],
      selectedPosUser: null,
      timezone: null,
      orderId: null,
      loading: true,
      loadingTables: false,
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_9_moment___default()().subtract(1, 'days').format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      totalOrders: null,
      noData: false,
      pagination: {
        page: 1,
        pageSize: 20
      }
    };
  },

  computed: {
    mergedTables: function mergedTables() {
      var map = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(this.availableTables.map(function (t) {
        return [t.id, t];
      }));
      this.selectedTables.forEach(function (t) {
        if (!map.has(t.id)) {
          map.set(t.id, t);
        }
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(map.values());
    }
  },
  methods: {
    searchTables: function searchTables(query) {
      var _this = this;

      if (!query) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      };

      this.loadingTables = true;

      this.apiRequest('/search-tables', 'GET', data, function (response) {
        if (response.status) {
          response.data.forEach(function (item) {
            _this.allTablesMap.set(item.id, item);
          });

          _this.availableTables = response.data;
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loadingTables = false;
        });
      });
    },
    clearSearch: function clearSearch() {
      this.$refs.tableSelect.focus();
      var select = this.$refs.tableSelect;

      if (select) {
        select.query = '';
        select.handleQueryChange('');
      }
    },
    formatToCompanyTimezone: function formatToCompanyTimezone(utcString) {
      var date = '';
      if (!utcString) {
        date = new Date();
      } else {
        date = new Date(utcString + 'Z');
      }

      var formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: this.timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      var parts = formatter.formatToParts(date);

      return parts.find(function (p) {
        return p.type === 'year';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'month';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'day';
      }).value + ' ' + parts.find(function (p) {
        return p.type === 'hour';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'minute';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'second';
      }).value;
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '05:00';
      }
      if (!this.valid_to) {
        this.valid_to = '05:00';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page' || query.type === 'size' || query.type === 'sort') {
        this.pagination.page = query.page;
        this.pagination.pageSize = query.pageSize;
        this.getOrders(query);
      }
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this2 = this;

      if (!this.isTableOpenOrderReport) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: this.orderId,
        operator: this.selectedPosUser
      };

      if (this.selectedTables && this.selectedTables.length) {
        data.table_ids = this.selectedTables.map(function (table) {
          return table.id;
        });
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      var pageSize = query ? query.pageSize : this.pagination.pageSize;
      var page = query ? query.page : this.pagination.page;

      this.apiRequest('/reports/v2/table-open-orders?page=' + page + '&perPage=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          _this2.productsTableData = response.data;
          _this2.totalOrders = response.pagination.total;
          _this2.paginationProps.currentPage = response.pagination.page;
          _this2.paginationProps.pageSize = response.pagination.perPage;
          _this2.pagination.page = response.pagination.page;
          _this2.pagination.pageSize = response.pagination.perPage;
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this2.$t('validations.wentWrong'), 'error');
        }

        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.currentTime = this.formatToCompanyTimezone();
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    getPosUsers: function getPosUsers() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this3.posUsers = response.data.pos_user;
        }
      });
    }
  }
});

/***/ }),

/***/ "B9/F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('pos-map-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BADL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"},[_c('div',{staticClass:"form-group mar-rt-10",staticStyle:{"max-width":"230px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedVatNumber),expression:"selectedVatNumber"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedVatNumber=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('option',{key:group.vat,domProps:{"value":group.vat}},[_vm._v("\n            VAT: "+_vm._s(group.vat)+" — "+_vm._s(group.locations.map(function (l) { return l.name; }).join(', '))+"\n          ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group mar-rt-10",staticStyle:{"max-width":"230px"}},[_c('label',{attrs:{"for":"searchInput"}},[_vm._v(_vm._s(_vm.$t('gestiune.searchClients')))]),_vm._v(" "),_c('el-input',{attrs:{"id":"searchInput","placeholder":"Caută după nume de client","clearable":""},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.openAddClientModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('gestiune.addClient'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.filteredClients,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"prop":"clientName","label":_vm.$t('gestiune.clientName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","label":_vm.$t('gestiune.address')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"city","label":_vm.$t('gestiune.city')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"countries","label":_vm.$t('gestiune.countries')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cui","label":_vm.$t('gestiune.cui')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('marketingOffers.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                    ▾\n                  ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editRow(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.edit'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},nativeOn:{"click":function($event){_vm.handleDelete(scope.row.id)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])]),_vm._v(" "),_c('ManagementClientsAdd',{attrs:{"groupedLocations":_vm.groupedLocations,"getClients":_vm.getClients,"clientData":_vm.client,"editMode":_vm.editMode},on:{"getClients":_vm.getClients}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BCKP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BCg7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupOptionsAdd_vue__ = __webpack_require__("lFKZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d34cca7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupOptionsAdd_vue__ = __webpack_require__("Cw38");
function injectStyle (ssrContext) {
  __webpack_require__("hlOD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupOptionsAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d34cca7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupOptionsAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BFcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KdsSectionForm__ = __webpack_require__("R2Bc");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'KdsSectionForm', __WEBPACK_IMPORTED_MODULE_7__KdsSectionForm__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      kdsSectionModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onSubmit: function onSubmit(model, isValid) {
      this.kdsSectionModel = model;
    }
  }
});

/***/ }),

/***/ "BGrY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BIDe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BK0Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BKA/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BKm5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BNE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("aCDv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78f52fe8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("hINz");
function injectStyle (ssrContext) {
  __webpack_require__("vU3l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78f52fe8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BNJR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BRie":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BX3Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsDeliveryZones_vue__ = __webpack_require__("sdfu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c11f1b3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsDeliveryZones_vue__ = __webpack_require__("6y2k");
function injectStyle (ssrContext) {
  __webpack_require__("lWAn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c11f1b3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsDeliveryZones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c11f1b3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsDeliveryZones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BaAX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_color__ = __webpack_require__("Zzkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_color__);











var _components;







__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    ChromePicker: __WEBPACK_IMPORTED_MODULE_13_vue_color__["Chrome"]
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.loading = true;
    this.getProducts();
    if (this.route.params.id) {
      this.getUserLabeling();
    }
    this.fidelitiesLabelsPrimaryOption = this.$session.get('selectedCompanyData').fidelities_labels_primary_option;

    if (this.fidelitiesLabelsPrimaryOption === 'ordersValue') {
      __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.modelValidations, 'order_value', { required: true });
    }
    if (this.fidelitiesLabelsPrimaryOption === 'ordersNumber') {
      __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.modelValidations, 'order_numbers', { required: true });
    }
    if (this.fidelitiesLabelsPrimaryOption === 'MOR') {
      __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.modelValidations, 'mor_value', { required: true });
    }
  },
  data: function data() {
    return {
      id: this.route.params.id || null,
      currency: this.getCompanyDetail('currency'),
      fidelitiesLabelsPrimaryOption: null,
      model: {
        name: '',
        orderValue: null,
        orderNumbers: null,
        color: '#000',
        notification: '',
        coupon: '',
        product_id: null,
        recurrence: 0,
        user_notification: '',
        showError: false,
        loyalty_points: {
          delivery: null,
          eat_location: null,
          pick_up: null,
          self_ordering: null,
          meet_half: null
        }
      },
      modelValidations: {
        name: {
          required: true,
          min: 3
        },
        color: {
          required: true
        }
      },
      colors: {
        red: '#f7786b',
        green: '#d9ecd0',
        blue: '#92a8d1',
        yellow: '#ffef96',
        orange: 'orange',
        pink: '#eca1a6',
        aqua: '#80ced6',
        navy: 'navy',
        maroon: 'maroon',
        olive: 'olive',
        white: 'white',
        grey: '#888888',
        black: 'black'
      },
      isNew: true,
      loading: true,
      products: [],
      fidelitiesReccurenceOptions: {
        0: 'noReccurence',
        1: 'oneDay',
        3: 'threeDays',
        5: 'fiveDays',
        7: 'sevenDays',
        10: 'tenDays',
        15: 'fifteenDays',
        20: 'twentyDays',
        25: 'twentyFiveDays'
      }
    };
  },

  computed: {
    morValCalc: {
      get: function get() {
        return this.model.mor_value ? Math.round(this.model.mor_value * 12) : null;
      },
      set: function set(value) {
        this.model.mor_value = value ? Number((value / 12).toFixed(2)) : null;
      }
    }
  },
  methods: {
    updateColor: function updateColor(newColor) {
      this.model.color = newColor.hex;
    },
    getProducts: function getProducts() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/user-labeling-products', 'GET', data, function (response) {
        if (response.status === true) {
          _this.products = response.data;
          _this.loading = false;
        }
      });
    },
    checkValueOrNumber: function checkValueOrNumber(item) {
      if (item) {
        item.showError = false;
      } else {
        this.model.showError = false;
      }
    },
    getUserLabeling: function getUserLabeling() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/userlabeling/' + this.id, 'GET', data, function (response) {
        if (response.status === true) {
          _this2.model = response.data;
        }
        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.updateOrCreateUserLabel();
        }
      });
    },
    updateOrCreateUserLabel: function updateOrCreateUserLabel() {
      var _this4 = this;

      var data = {
        'company_id': this.$session.get('selectedCompany'),
        'token': this.$session.get('token'),
        'id': this.id,
        'name': this.model.name,
        'order_value': this.model.order_value,
        'order_numbers': this.model.order_numbers,
        'mor_value': this.model.mor_value,
        'color': this.model.color,
        'notification': this.model.notification,
        'user_notification': this.model.user_notification,
        'coupon': this.model.coupon,
        'product_id': this.model.product_id,
        'recurrence': this.model.recurrence,
        'loyalty_points': this.model.loyalty_points
      };

      var url = '/userlabeling/';
      var httpMethod = '';

      if (this.id) {
        url += this.id;
        httpMethod = 'PUT';
      } else {
        httpMethod = 'POST';
      }

      this.apiRequest(url, httpMethod, data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', 'Success', 'success');
          _this4.backButton();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    deleteUserLabel: function deleteUserLabel() {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.loading = true;
      });
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/userlabeling/' + this.id, 'DELETE', data, function (response) {
        if (response.status) {
          _this5.$nextTick(function () {
            _this5.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': 'Success', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this5.backButton();
        } else {
          _this5.$nextTick(function () {
            _this5.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this5.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "BaIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BbTf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BdGd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-stocuri-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BdU3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 390 231.5"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 390 231.5","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t6_1_","y":"69.7","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t6_3_","d":"M0,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H9C4,161.8,0,157.8,0,152.8z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,161.8V69.7h92.2v92.2H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t6_5_","x":"297.9","y":"69.7","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t6_7_","d":"M297.9,152.8V78.7c0-5,4-9,9-9H381c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2\n            C301.9,161.8,297.9,157.8,297.9,152.8z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M297.9,161.8V69.7H390v92.2H297.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t6_9_","x":"229.9","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t6_11_","d":"M229.9,83.2V9c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2C233.9,92.2,229.9,88.1,229.9,83.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M229.9,92.2V0h92.2v92.2H229.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t6_13_","x":"73.2","y":"69.7","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t6_15_","d":"M73.2,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H82.2C77.2,161.8,73.2,157.8,73.2,152.8\n            z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M73.2,161.8V69.7h92.2v92.2H73.2z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t6_17_","x":"69.7","y":"0","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t6_19_","d":"M78.7,0h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9V9C69.7,4,73.7,0,78.7,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M69.7,0h92.2v92.2H69.7V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t6_21_","x":"69.7","y":"139.4","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t6_23_","d":"M78.7,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9v-74.2\n            C69.7,143.4,73.7,139.4,78.7,139.4z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st2",attrs:{"d":"M69.7,139.4h92.2v92.2H69.7V139.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t6_25_","x":"229.9","y":"139.4","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st13"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t6_27_","d":"M238.9,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2c-5,0-9-4-9-9v-74.2\n            C229.9,143.4,233.9,139.4,238.9,139.4z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('path',{staticClass:"st2",attrs:{"d":"M229.9,139.4h92.2v92.2h-92.2V139.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t6_29_","x":"16.3","y":"16.3","width":"355.3","height":"199"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_30_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_29_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t6_31_","d":"M39.3,16.3H348c6.1,0,12,2.4,16.3,6.7s6.7,10.2,6.7,16.3v153c0,6.1-2.4,11.9-6.7,16.3\n            s-10.2,6.7-16.3,6.7H39.3c-6.1,0-11.9-2.4-16.3-6.7c-4.3-4.3-6.7-10.2-6.7-16.3v-153c0-6.1,2.4-11.9,6.7-16.3\n            C27.3,18.7,33.2,16.3,39.3,16.3z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_32_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_31_"}})]),_vm._v(" "),_c('g',{staticClass:"st16"},[_c('path',{staticClass:"st17",attrs:{"d":"M16.3,16.3h354.5v199H16.3V16.3z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t6_33_","x":"117.9","y":"40.1","width":"151.4","height":"151.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_34_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_33_"}})]),_vm._v(" "),_c('g',{staticClass:"st18"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t6_35_","d":"M193.6,40.1c-41.8,0-75.7,33.9-75.7,75.7s33.9,75.7,75.7,75.7s75.7-33.9,75.7-75.7\n            S235.5,40.1,193.6,40.1z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t6_36_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t6_35_"}})]),_vm._v(" "),_c('g',{staticClass:"st19"},[_c('path',{staticClass:"st2",attrs:{"d":"M117.9,40.1h151.4v151.4H117.9V40.1z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BdcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsSalesBeta_vue__ = __webpack_require__("Td+/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05fcbc1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsSalesBeta_vue__ = __webpack_require__("RuEO");
function injectStyle (ssrContext) {
  __webpack_require__("yJ5Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsSalesBeta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05fcbc1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsSalesBeta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bef2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export translateMenuValidationErrorCode */
/* unused harmony export formatMenuValidationItem */
/* unused harmony export resolveMenuValidationEditTarget */
/* harmony export (immutable) */ __webpack_exports__["j"] = getMenuValidationGroupEntries;
/* unused harmony export getAxiosErrorResponseData */
/* unused harmony export unwrapMenuApiResponse */
/* harmony export (immutable) */ __webpack_exports__["b"] = isMenuNotFoundResponse;
/* harmony export (immutable) */ __webpack_exports__["e"] = extractMenuValidationGroups;
/* unused harmony export extractMenuValidationWarnings */
/* harmony export (immutable) */ __webpack_exports__["f"] = isMenuValidationSuccessful;
/* harmony export (immutable) */ __webpack_exports__["h"] = canProceedWithMenuValidation;
/* harmony export (immutable) */ __webpack_exports__["i"] = getMenuValidationSummary;
/* harmony export (immutable) */ __webpack_exports__["g"] = getMenuValidationEntityEditPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = getMenuValidationShortMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = extractApiResponseMessage;
/* unused harmony export formatIntegrationPlatformError */
/* harmony export (immutable) */ __webpack_exports__["c"] = getIntegrationActionErrorMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_freeze__);






var ISSUE_KEY_BY_CODE = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_freeze___default()({
  CATEGORY_EMPTY: 'categories_empty',
  PRODUCT_INVALID_PRICE: 'products_invalid_price',
  OPTION_MISSING_VALUES: 'options_missing_values',
  OPTION_INVALID_MIN: 'options_invalid_min'
});

var ISSUE_GROUP_LABELS = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_freeze___default()({
  categories_empty: 'gestiune.integrationsMenuValidationCategoriesEmpty',
  products_invalid_price: 'gestiune.integrationsMenuValidationProductsInvalidPrice',
  options_missing_values: 'gestiune.integrationsMenuValidationOptionsMissingValues',
  options_invalid_min: 'gestiune.integrationsMenuValidationOptionsInvalidMin'
});

function getItemTypeLabel(code, t) {
  var c = String(code || '').toUpperCase();
  if (c.startsWith('CATEGORY')) return t('gestiune.integrationsMenuValidationItemCategory');
  if (c.startsWith('PRODUCT')) return t('gestiune.integrationsMenuValidationItemProduct');
  if (c.startsWith('OPTION')) return t('gestiune.integrationsMenuValidationItemOption');
  return '';
}

function translateMenuValidationErrorCode(code, t) {
  var normalized = code == null ? '' : String(code).trim();
  if (!normalized) return '';

  var codeKey = 'gestiune.integrationsMenuValidationErrorCodes.' + normalized;
  var codeLabel = t(codeKey);
  if (codeLabel !== codeKey) return codeLabel;

  var issueKey = ISSUE_KEY_BY_CODE[normalized];
  if (issueKey) {
    return t(ISSUE_GROUP_LABELS[issueKey]);
  }

  return '';
}

function getErrorGroupLabel(entry, t) {
  if (!entry || (typeof entry === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(entry)) !== 'object') {
    return t('gestiune.integrationsGlovoValidationErrors');
  }

  var fromCode = translateMenuValidationErrorCode(entry.code, t);
  if (fromCode) return fromCode;

  if (entry.code) return String(entry.code).trim();

  return t('gestiune.integrationsGlovoValidationErrors');
}

function formatMenuValidationItem(item, t) {
  if (item == null) return '';
  if (typeof item === 'string') return item.trim();
  if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(item)) !== 'object') return String(item).trim();

  var typeLabel = getItemTypeLabel(item.code, t);
  var prefix = typeLabel ? '[' + typeLabel + '] ' : '';
  var id = item.id != null && item.id !== '' ? item.id : null;
  var name = item.name != null ? String(item.name).trim() : '';

  if (id != null && name) return prefix + '#' + id + ' \u2014 ' + name;
  if (id != null) return prefix + '#' + id;
  if (name) return '' + prefix + name;
  if (item.message) return String(item.message).trim();
  return '';
}

function parseEditTargetFromLegacyMessage(text) {
  var raw = String(text || '').trim();
  if (!raw) return null;

  var idMatch = raw.match(/\bid:\s*'?(\d+)'?/i) || raw.match(/#(\d+)/);
  var id = idMatch ? String(idMatch[1]) : null;
  if (!id) return null;

  var entityMatch = raw.match(/entity\s+'([^']+)'/i);
  var entity = entityMatch ? String(entityMatch[1]).toLowerCase() : '';

  if (entity.includes('group')) {
    return { type: 'group-option', id: id };
  }
  if (entity.includes('product') && !entity.includes('option')) {
    return { type: 'product', id: id };
  }
  if (entity.includes('option')) {
    return { type: 'product-option', id: id };
  }

  return null;
}

function resolveMenuValidationEditTarget(item) {
  if (item == null) return null;
  if (typeof item === 'string') return parseEditTargetFromLegacyMessage(item);
  if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(item)) !== 'object') return null;

  var optionId = item.company_option_id != null && item.company_option_id !== '' ? String(item.company_option_id) : null;
  if (optionId) {
    return { type: 'product-option', id: optionId };
  }

  var id = item.id != null && item.id !== '' ? String(item.id) : null;
  var code = String(item.code || '').toUpperCase();
  var entity = String(item.entity || item.entity_type || '').toLowerCase();

  if (id) {
    if (code.startsWith('PRODUCT') || entity === 'products' || entity === 'product') {
      return { type: 'product', id: id };
    }
    if (entity.includes('group') || code.includes('GROUP')) {
      return { type: 'group-option', id: id };
    }
    if (code.startsWith('OPTION') || entity.includes('option')) {
      return { type: 'product-option', id: id };
    }
  }

  if (item.message) return parseEditTargetFromLegacyMessage(item.message);
  return null;
}

function normalizeMenuValidationEntry(item, t) {
  var text = formatMenuValidationItem(item, t);
  if (!text) return null;
  return {
    text: text,
    editTarget: resolveMenuValidationEditTarget(item)
  };
}

function getMenuValidationGroupEntries(group, t) {
  if (!group || (typeof group === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(group)) !== 'object') return [];
  if (Array.isArray(group.entries) && group.entries.length) {
    return group.entries;
  }
  var source = Array.isArray(group.items) ? group.items : [];
  return source.map(function (item) {
    if (item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(item)) === 'object' && item.text) {
      return {
        text: String(item.text).trim(),
        editTarget: item.editTarget || resolveMenuValidationEditTarget(item)
      };
    }
    return normalizeMenuValidationEntry(item, t);
  }).filter(Boolean);
}

function normalizeLegacyValidationList(value) {
  var items = [];
  var collect = function collect(entry) {
    if (entry == null) return;
    if (Array.isArray(entry)) {
      entry.forEach(collect);
      return;
    }
    if ((typeof entry === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(entry)) === 'object') {
      if (Array.isArray(entry.items) && entry.items.length) {
        entry.items.forEach(collect);
        return;
      }
      if (entry.message) collect(entry.message);else if (entry.error) collect(entry.error);
      return;
    }
    var text = String(entry).trim();
    if (text) items.push(text);
  };
  collect(value);
  return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(items)));
}

function getAxiosErrorResponseData(response) {
  if (!response || (typeof response === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(response)) !== 'object') return null;
  var data = response.error && response.error.response && response.error.response.data;
  if (data && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(data)) === 'object') return data;
  return null;
}

function unwrapMenuApiResponse(response) {
  if (!response || (typeof response === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(response)) !== 'object') return response;
  var nested = getAxiosErrorResponseData(response);
  if (!nested) return response;
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nested, {
    status: nested.status !== undefined ? nested.status : false,
    error: response.error
  });
}

function isMenuEmptyErrorCode(code) {
  return String(code || '').trim().toUpperCase() === 'MENU_EMPTY';
}

function textIndicatesMenuNotFound(text) {
  var message = String(text || '').trim().toLowerCase();
  if (!message) return false;
  return message.includes('menu not found') || message.includes('no exportable products') || message.includes('menu is empty') || message.includes('menu has no exportable') || message.includes('no products to export') || /\bno products\b/.test(message);
}

function collectErrorEntries(errors) {
  if (errors == null) return [];
  if (Array.isArray(errors)) return errors;
  if ((typeof errors === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(errors)) === 'object') return [errors];
  return [errors];
}

function responseHasMenuEmptyCode(payload) {
  if (!payload || (typeof payload === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(payload)) !== 'object') return false;
  var lists = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(collectErrorEntries(payload.errors)), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(collectErrorEntries(payload.data && payload.data.errors)));
  return lists.some(function (entry) {
    if (!entry || (typeof entry === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(entry)) !== 'object') return false;
    return isMenuEmptyErrorCode(entry.code);
  });
}

function isMenuNotFoundResponse(response) {
  if (!response) return false;

  var unwrapped = unwrapMenuApiResponse(response);
  if (responseHasMenuEmptyCode(unwrapped) || responseHasMenuEmptyCode(response)) {
    return true;
  }

  var message = extractApiResponseMessage(response);
  if (textIndicatesMenuNotFound(message)) return true;

  var errors = unwrapped && unwrapped.errors;
  if (errors && (typeof errors === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(errors)) === 'object' && !Array.isArray(errors)) {
    if (textIndicatesMenuNotFound(errors.message) || textIndicatesMenuNotFound(errors.error)) {
      return true;
    }
  }

  return false;
}

function getStructuredErrorsSource(response) {
  if (!response || (typeof response === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(response)) !== 'object') return [];
  if (Array.isArray(response.errors) && response.errors.length) {
    return response.errors;
  }

  if (response.errors && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(response.errors) === 'object' && !Array.isArray(response.errors)) {
    if (response.errors.code || response.errors.message || response.errors.error) {
      return [response.errors];
    }
  }
  var data = response.data;
  if (data && Array.isArray(data.errors) && data.errors.length) {
    return data.errors;
  }
  if (data && data.errors && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(data.errors) === 'object' && !Array.isArray(data.errors)) {
    if (data.errors.code || data.errors.message || data.errors.error) {
      return [data.errors];
    }
  }
  return [];
}

function buildMenuEmptyValidationGroup(t) {
  var label = translateMenuValidationErrorCode('MENU_EMPTY', t) || t('gestiune.integrationsGlovoMenuEmpty');
  return {
    code: 'MENU_EMPTY',
    label: label,
    entries: [{ text: label, editTarget: null }]
  };
}

function buildGroupsFromStructuredErrors(errors, t) {
  var groups = [];
  errors.forEach(function (entry) {
    if (entry == null) return;

    if (typeof entry === 'string' || typeof entry === 'number') {
      var text = String(entry).trim();
      if (!text) return;
      if (textIndicatesMenuNotFound(text) || isMenuEmptyErrorCode(text)) {
        groups.push(buildMenuEmptyValidationGroup(t));
        return;
      }
      groups.push({
        code: '',
        label: t('gestiune.integrationsGlovoValidationErrors'),
        entries: [{ text: text, editTarget: null }]
      });
      return;
    }

    if ((typeof entry === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(entry)) !== 'object') return;

    if (isMenuEmptyErrorCode(entry.code) || textIndicatesMenuNotFound(entry.message)) {
      groups.push(buildMenuEmptyValidationGroup(t));
      return;
    }

    var label = getErrorGroupLabel(entry, t);
    var entries = (Array.isArray(entry.items) ? entry.items : []).map(function (item) {
      return normalizeMenuValidationEntry(item, t);
    }).filter(Boolean);
    if (entries.length) {
      groups.push({
        code: entry.code || '',
        label: label,
        entries: entries
      });
    } else if (entry.message) {
      groups.push({
        code: entry.code || '',
        label: label,
        entries: [{ text: String(entry.message).trim(), editTarget: null }]
      });
    } else if (label) {
      groups.push({
        code: entry.code || '',
        label: label,
        entries: [{ text: label, editTarget: null }]
      });
    }
  });
  return groups;
}

function buildGroupsFromIssues(response, t) {
  var issues = response && response.data && response.data.issues;
  if (!issues || (typeof issues === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(issues)) !== 'object') return [];

  var groups = [];
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ISSUE_GROUP_LABELS).forEach(function (key) {
    var list = issues[key];
    if (!Array.isArray(list) || !list.length) return;
    var entries = list.map(function (item) {
      return normalizeMenuValidationEntry(item, t);
    }).filter(Boolean);
    if (!entries.length) return;
    groups.push({
      code: key,
      label: t(ISSUE_GROUP_LABELS[key]),
      entries: entries
    });
  });
  return groups;
}

function extractMenuValidationGroups(response, t) {
  var source = unwrapMenuApiResponse(response);
  if (isMenuNotFoundResponse(response)) {
    return [buildMenuEmptyValidationGroup(t)];
  }

  var structured = getStructuredErrorsSource(source);
  var fromErrors = buildGroupsFromStructuredErrors(structured, t);
  if (fromErrors.length) return fromErrors;

  var fromIssues = buildGroupsFromIssues(source, t);
  if (fromIssues.length) return fromIssues;

  var legacyItems = [];
  if (source && source.errors != null) {
    legacyItems.push.apply(legacyItems, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(normalizeLegacyValidationList(source.errors)));
  }
  var payload = source && source.data;
  if (payload) {
    legacyItems.push.apply(legacyItems, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(normalizeLegacyValidationList(payload.errors)));
    legacyItems.push.apply(legacyItems, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(normalizeLegacyValidationList(payload.details)));
    if (payload.provider_response) {
      legacyItems.push.apply(legacyItems, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(normalizeLegacyValidationList(payload.provider_response.errors)));
      legacyItems.push.apply(legacyItems, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(normalizeLegacyValidationList(payload.provider_response.details)));
    }
  }
  var uniqueLegacy = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(legacyItems)));
  if (uniqueLegacy.length) {
    if (uniqueLegacy.some(textIndicatesMenuNotFound)) {
      return [buildMenuEmptyValidationGroup(t)];
    }
    return [{
      code: '',
      label: t('gestiune.integrationsGlovoValidationErrors'),
      entries: uniqueLegacy.map(function (item) {
        return normalizeMenuValidationEntry(item, t);
      }).filter(Boolean)
    }];
  }
  return [];
}

function extractMenuValidationWarnings(response, t) {
  var items = [];
  var payload = response && response.data;
  if (payload) {
    items.push.apply(items, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(normalizeLegacyValidationList(payload.warnings)));
    if (payload.provider_response) {
      items.push.apply(items, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(normalizeLegacyValidationList(payload.provider_response.warnings)));
    }
  }
  return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(items)));
}

function isMenuValidationSuccessful(response, t, isMenuNotFound) {
  if (isMenuNotFound) return false;
  if (!response || !response.status || response.status === false || response.error) {
    return false;
  }

  var rootData = response.data;
  var payload = rootData && (rootData.data || rootData);

  if (rootData && rootData.valid === false) return false;
  if (payload && payload.valid === false) return false;
  if (payload && payload.is_valid === false) return false;

  return extractMenuValidationGroups(response, t).length === 0;
}

function canProceedWithMenuValidation(response, t) {
  if (!response || isMenuNotFoundResponse(response)) return false;
  if (response.error) {
    var httpResponse = response.error.response;
    if (!httpResponse || httpResponse.status >= 500) return false;
  }
  return extractMenuValidationGroups(response, t).length > 0;
}

function getMenuValidationSummary(response, success, t, isMenuNotFound) {
  if (isMenuNotFound) {
    return t('gestiune.integrationsGlovoMenuEmpty');
  }
  if (success) return '';
  if (extractMenuValidationGroups(response, t).length) {
    return t('gestiune.integrationsGlovoValidationFailedTitle');
  }
  if (response && response.message) return String(response.message).trim();
  return t('gestiune.integrationsActionError');
}

function getMenuValidationEntityEditPath(target) {
  if (!target || !target.type || target.id == null || target.id === '') return null;

  var paths = {
    product: '/integrations/menu-fix/product/' + target.id,
    'product-option': '/integrations/menu-fix/product-option/' + target.id,
    'group-option': '/integrations/menu-fix/group-option/' + target.id
  };

  return paths[target.type] || null;
}

function getMenuValidationShortMessage(response, t, isMenuNotFound) {
  if (extractMenuValidationGroups(response, t).length) {
    return '';
  }
  return getMenuValidationSummary(response, false, t, isMenuNotFound);
}

function extractMessageFromUnknownErrorValue(value) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (value == null || value === '' || depth > 5) return '';

  if (typeof value === 'string') {
    var trimmed = value.trim();
    if (!trimmed) return '';
    if (trimmed.startsWith('{') && trimmed.endsWith('}') || trimmed.startsWith('[') && trimmed.endsWith(']')) {
      try {
        var parsed = JSON.parse(trimmed);
        var nested = extractMessageFromUnknownErrorValue(parsed, depth + 1);
        if (nested) return nested;
      } catch (e) {}
    }
    return trimmed;
  }

  if (Array.isArray(value)) {
    return value.map(function (item) {
      return extractMessageFromUnknownErrorValue(item, depth + 1);
    }).filter(Boolean).join('\n');
  }

  if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(value)) === 'object') {
    if (value.message != null && String(value.message).trim()) {
      return String(value.message).trim();
    }

    var nestedKeys = ['error', 'errors', 'provider_response', 'data', 'details'];
    for (var i = 0; i < nestedKeys.length; i += 1) {
      var _nested = extractMessageFromUnknownErrorValue(value[nestedKeys[i]], depth + 1);
      if (_nested) return _nested;
    }
  }

  return '';
}

function extractApiResponseMessage(response) {
  if (!response) return '';

  if (typeof response === 'string') {
    return extractMessageFromUnknownErrorValue(response);
  }

  if ((typeof response === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(response)) !== 'object') {
    return String(response).trim();
  }

  var nestedData = getAxiosErrorResponseData(response);
  if (nestedData) {
    var nestedMessage = extractApiResponseMessage(nestedData);
    if (nestedMessage) return nestedMessage;
  }

  var directMessage = extractMessageFromUnknownErrorValue(response.message);
  if (directMessage) return directMessage;

  var errorsMessage = extractMessageFromUnknownErrorValue(response.errors);
  if (errorsMessage) return errorsMessage;

  if (response.data != null) {
    var dataMessage = extractMessageFromUnknownErrorValue(response.data);
    if (dataMessage) return dataMessage;
  }

  var axiosMessage = extractMessageFromUnknownErrorValue(response.error);
  if (axiosMessage) return axiosMessage;

  return '';
}

var PLATFORM_HTTP_ERROR_PATTERN = /Client error:|Server error:|resulted in a `\d{3}/i;
var PLATFORM_CODE_PATTERN = /NOT_AUTHORIZED|UNAUTHORIZED|INVALID_TOKEN|FORBIDDEN|NOT_FOUND/i;
var PLATFORM_NETWORK_PATTERN = /cURL error|Connection refused|timed out|Could not resolve host|Failed to connect/i;

function parseHttpStatusFromPlatformMessage(message) {
  var match = String(message || '').match(/resulted in a `(\d{3})/i);
  return match ? parseInt(match[1], 10) : null;
}

function parsePlatformCodeFromMessage(message) {
  var text = String(message || '');
  var jsonMatch = text.match(/\{[\s\S]*\}/);
  if (jsonMatch) {
    try {
      var parsed = JSON.parse(jsonMatch[0]);
      if (parsed && parsed.message != null && String(parsed.message).trim()) {
        return String(parsed.message).trim().toUpperCase();
      }
    } catch (e) {}
  }
  var codeMatch = text.match(PLATFORM_CODE_PATTERN);
  return codeMatch ? codeMatch[0].toUpperCase() : '';
}

function looksLikePlatformHttpError(message) {
  var text = String(message || '').trim();
  if (!text) return false;
  return PLATFORM_HTTP_ERROR_PATTERN.test(text) || PLATFORM_CODE_PATTERN.test(text) || PLATFORM_NETWORK_PATTERN.test(text);
}

function integrationPlatformErrorKey(integration, suffix) {
  var integrationKey = String(integration || '').toLowerCase();
  if (integrationKey === 'bolt' || integrationKey === 'glovo' || integrationKey === 'wolt') {
    return 'gestiune.integrationsPlatformErrors.' + suffix + '_' + integrationKey;
  }
  return 'gestiune.integrationsPlatformErrors.' + suffix;
}

function integrationFieldLabel(field, translate) {
  return translate('gestiune.integrationsFields.' + field);
}

function getPlatformErrorInterpolation(integration, suffix, translate) {
  var integrationKey = String(integration || '').toLowerCase();

  if (integrationKey === 'bolt') {
    if (suffix === 'unauthorized') {
      return {
        secretKey: integrationFieldLabel('secret_key', translate),
        integratorId: integrationFieldLabel('integrator_id', translate),
        providerId: integrationFieldLabel('provider_id', translate)
      };
    }
    if (suffix === 'forbidden' || suffix === 'not_found') {
      return {
        providerId: integrationFieldLabel('provider_id', translate),
        apiUrl: integrationFieldLabel('api_url', translate)
      };
    }
  }

  if (integrationKey === 'glovo') {
    if (suffix === 'unauthorized' || suffix === 'forbidden' || suffix === 'not_found') {
      return {
        apiKey: integrationFieldLabel('api_key', translate),
        storeId: integrationFieldLabel('store_id', translate),
        apiUrl: integrationFieldLabel('api_url', translate)
      };
    }
  }

  if (integrationKey === 'wolt') {
    if (suffix === 'unauthorized' || suffix === 'forbidden' || suffix === 'not_found') {
      return {
        apiKey: integrationFieldLabel('api_key', translate),
        clientId: integrationFieldLabel('client_id', translate),
        venueId: integrationFieldLabel('venue_id', translate),
        apiUrl: integrationFieldLabel('api_url', translate)
      };
    }
  }

  return {};
}

function translatePlatformError(integration, suffix, translate) {
  var interpolation = getPlatformErrorInterpolation(integration, suffix, translate);
  var specificKey = integrationPlatformErrorKey(integration, suffix);
  var specificMessage = translate(specificKey, interpolation);
  if (specificMessage && specificMessage !== specificKey) {
    return specificMessage;
  }
  var genericKey = 'gestiune.integrationsPlatformErrors.' + suffix;
  var genericMessage = translate(genericKey, interpolation);
  if (genericMessage && genericMessage !== genericKey) {
    return genericMessage;
  }
  return '';
}

function formatIntegrationPlatformError(rawMessage, integration, action, t) {
  var message = String(rawMessage || '').trim();
  var translate = typeof t === 'function' ? t : function (key) {
    return key;
  };
  var actionKey = ['toggleLocation', 'pushMenu', 'syncSchedule'].includes(action) ? action : 'generic';

  if (!message) {
    return translate('gestiune.integrationsPlatformErrors.' + actionKey + '_failed') || translate('gestiune.integrationsActionError');
  }

  if (!looksLikePlatformHttpError(message)) {
    return message;
  }

  var httpStatus = parseHttpStatusFromPlatformMessage(message);
  var platformCode = parsePlatformCodeFromMessage(message);
  var isUnauthorized = httpStatus === 401 || platformCode === 'NOT_AUTHORIZED' || platformCode === 'UNAUTHORIZED' || platformCode === 'INVALID_TOKEN' || /\b401\b/.test(message) || /unauthorized/i.test(message);

  if (isUnauthorized) {
    return translatePlatformError(integration, 'unauthorized', translate) || translate('gestiune.integrationsPlatformErrors.unauthorized');
  }

  if (httpStatus === 403 || platformCode === 'FORBIDDEN' || /\b403\b/.test(message)) {
    return translatePlatformError(integration, 'forbidden', translate) || translate('gestiune.integrationsPlatformErrors.forbidden');
  }

  if (httpStatus === 404 || platformCode === 'NOT_FOUND' || /\b404\b/.test(message)) {
    return translatePlatformError(integration, 'not_found', translate) || translate('gestiune.integrationsPlatformErrors.not_found');
  }

  if (httpStatus === 429 || /\b429\b/.test(message) || /rate limit/i.test(message)) {
    return translate('gestiune.integrationsPlatformErrors.rate_limited');
  }

  if (PLATFORM_NETWORK_PATTERN.test(message)) {
    return translate('gestiune.integrationsPlatformErrors.network');
  }

  if (httpStatus != null && httpStatus >= 500 || /\b5\d{2}\b/.test(message)) {
    return translate('gestiune.integrationsPlatformErrors.unavailable');
  }

  return translate('gestiune.integrationsPlatformErrors.' + actionKey + '_failed') || translate('gestiune.integrationsActionError');
}

function getIntegrationActionErrorMessage(response, integration, action, t) {
  var translate = typeof t === 'function' ? t : function (key) {
    return key;
  };
  if (isMenuNotFoundResponse(response)) {
    return translate('gestiune.integrationsGlovoMenuEmpty');
  }
  var rawMessage = extractApiResponseMessage(response);
  if (!rawMessage) {
    return translate('gestiune.integrationsActionError');
  }
  return formatIntegrationPlatformError(rawMessage, integration, action, t);
}

/***/ }),

/***/ "Bf4E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BgVy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupOptionsForm_vue__ = __webpack_require__("LImY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_459dbb58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupOptionsForm_vue__ = __webpack_require__("Nyg0");
function injectStyle (ssrContext) {
  __webpack_require__("A4GO")
  __webpack_require__("joYi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-459dbb58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupOptionsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_459dbb58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupOptionsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BiTS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-intrari-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BkAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();return _vm.deleteCampaign($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15 mar-bt-15 donation-campaign-form"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card donation-campaign-form__card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"header donation-campaign-form__header"},[_c('h5',[_vm._v(_vm._s(_vm.$t('donationCampaigns.details')))])]),_vm._v(" "),(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('error')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('donationCampaigns.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('name')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"4","name":"description","placeholder":_vm.$t('donationCampaigns.description')},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.targetAmount'))+" ("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.target_amount),expression:"model.target_amount"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.target_amount),expression:"modelValidations.target_amount"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01","name":"target_amount","placeholder":_vm.$t('donationCampaigns.targetAmount')},domProps:{"value":(_vm.model.target_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "target_amount", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('target_amount'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('target_amount')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.fundingMode')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('donationCampaigns.fundingMode')},model:{value:(_vm.model.funding_mode),callback:function ($$v) {_vm.$set(_vm.model, "funding_mode", $$v)},expression:"model.funding_mode"}},_vm._l((_vm.fundingModeOptions),function(option){return _c('el-option',{key:option.value,attrs:{"label":option.label,"value":option.value}})}))],1),_vm._v(" "),(_vm.model.funding_mode === 'restaurant_flat')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.restaurantFlatAmount'))+" ("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.restaurant_flat_amount),expression:"model.restaurant_flat_amount"},{name:"validate",rawName:"v-validate",value:('required|min_value:0.01'),expression:"'required|min_value:0.01'"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01","name":"restaurant_flat_amount","placeholder":_vm.$t('donationCampaigns.restaurantFlatAmount')},domProps:{"value":(_vm.model.restaurant_flat_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "restaurant_flat_amount", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('restaurant_flat_amount'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('restaurant_flat_amount')))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.funding_mode === 'restaurant_percent')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.restaurantPercent')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.restaurant_percent),expression:"model.restaurant_percent"},{name:"validate",rawName:"v-validate",value:('required|decimal|min_value:0|max_value:100'),expression:"'required|decimal|min_value:0|max_value:100'"}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"100","step":"0.01","name":"restaurant_percent","placeholder":_vm.$t('donationCampaigns.restaurantPercent')},domProps:{"value":(_vm.model.restaurant_percent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "restaurant_percent", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('restaurant_percent'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('restaurant_percent')))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.image')))]),_vm._v(" "),(!_vm.loading)?_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":".jpg, .jpeg, .png","on-change":_vm.handleImgChange,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize'))+_vm._s(_vm.$t('validations.imageResolution')))])]):_vm._e(),_vm._v(" "),(_vm.errors.has('image'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('image')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.startEnd')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","picker-options":_vm.pickerOptions},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.location')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.locations,"label":"name"},model:{value:(_vm.locations_formatted),callback:function ($$v) {_vm.locations_formatted=$$v},expression:"locations_formatted"}}),_vm._v(" "),_c('small',[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('donationCampaigns.locationInfo')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.active')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}})],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bktc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('proforma-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BlQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StornoReport_vue__ = __webpack_require__("Y5Cc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04803445_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StornoReport_vue__ = __webpack_require__("lsfa");
function injectStyle (ssrContext) {
  __webpack_require__("kRhx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StornoReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04803445_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StornoReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bm93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      showStockSection: true,
      showProductsSection: false,
      gestiune: '',
      inventoryNumber: '',
      inventoryDate: this.getLocalDateTimeString(),
      selectedLocation: null,
      selectedGestiune: null,
      gestiuneId: null,
      searchProdName: null,
      extraFields: {
        'presedinte': '',
        'comisia': '',
        'gestionar': '',
        'contabilitate': '',
        'nota': '',
        'nota_completare': ''
      },
      newItem: {
        name: '',
        quantity: '',
        unitMeasure: '',
        price: null
      },
      modelValidate: {
        location: 'required',
        gestiune: 'required',
        date: 'required'
      },
      categories: ['Marfa', 'Materii prime', 'Materiale consumabile', 'Semifabricate (Reteta)', 'Produs finit (Reteta)', 'Produs rezidual', 'Ambalaje', 'Obiecte de inventar'],
      selectedCategory: null,
      isInEdit: false,
      isBlocked: false,
      locations: [],
      gestiuneOptions: [],
      productsList: [],
      productsListStocks: [],
      gestiuniList: [],
      inventoryNumberOptions: [],
      searchProducts: []
    };
  },
  created: function created() {
    var _this = this;

    this.companyID = this.$session.get('selectedCompany');

    var id = this.route && this.route.params && this.route.params.id;__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchLocation();

            case 2:
              _context.next = 4;
              return _this.fetchGestiuni();

            case 4:
              if (id) {
                _this.isInEdit = true;
                _this.getInitialStock(id);
              } else {
                _this.showStockSection = false;
                _this.showProductsSection = true;
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    selectedLocation: function selectedLocation() {
      if (!this.isInEdit) {
        this.selectedGestiune = null;

        if (this.filteredGestiuni && this.filteredGestiuni.length) {
          this.selectedGestiune = this.filteredGestiuni[0].id;

          console.log('this.selectedGestiune', this.selectedGestiune);
        }
      }

      if (!this.isInEdit) {
        this.productsList = [];
      }
    },
    selectedGestiune: function selectedGestiune() {
      if (!this.isInEdit) {
        this.fetchProducts();
      }
    }
  },
  computed: {
    today: function today() {
      var now = new Date();
      now.setSeconds(0, 0);
      return now.toISOString().slice(0, 16);
    },
    groupedLocations: function groupedLocations() {
      var groups = {};

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            vat = _ref3[0],
            locations = _ref3[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      console.log('result', result);

      return result;
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this2 = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this2.selectedLocation.true_id;
      });
      return result;
    }
  },
  methods: {
    filterProducts: function filterProducts() {
      var _this3 = this;

      this.productsList.forEach(function (p) {
        if (!_this3.selectedCategory || p.categorie === _this3.selectedCategory) {
          p.is_hiden = 0;
        } else {
          p.is_hiden = 1;
        }
      });
    },
    clamp: function clamp(value, min, max) {
      if (value === '' || value === null || value === undefined) return '';

      var v = Number(value);
      if (isNaN(v)) return '';

      return Math.min(Math.max(v, min), max);
    },
    toggleSection: function toggleSection(section) {
      if (section === 'stock') {
        this.showStockSection = true;
        this.showProductsSection = false;
      }

      if (section === 'products') {
        this.showProductsSection = true;
        this.showStockSection = false;
      }
    },
    waitForGroupedLocations: function waitForGroupedLocations() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                  if (_this4.groupedLocations.length) {
                    return resolve();
                  }

                  var unwatch = _this4.$watch('groupedLocations', function (val) {
                    if (val.length) {
                      unwatch();
                      resolve();
                    }
                  }, { immediate: true });
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    onProductSelect: function onProductSelect(selected) {
      if (selected) {
        this.newItem = {
          id: selected._id,
          name: selected.name,
          quantity: null,
          unitMeasure: selected.um || '',
          price: null
        };
      }
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    addItem: function addItem() {
      var _this5 = this;

      if (this.newItem && this.newItem.name && this.newItem.quantity != null) {
        var index = this.productsList.findIndex(function (p) {
          return p._id === _this5.newItem.id;
        });
        if (index !== -1) {
          this.productsList[index].quantity = this.newItem.quantity;
          this.productsList[index].price = this.newItem.price;
        } else {}
        this.resetNewItem();
      } else {}
      return false;
    },
    removeItem: function removeItem(index) {},
    isProductInStock: function isProductInStock(productId) {
      return this.productsListStocks.some(function (stock) {
        return stock._id === productId;
      });
    },
    resetNewItem: function resetNewItem() {
      this.searchProdName = null;
      this.newItem = {
        productName: '',
        code: '',
        unitMeasure: '',
        quantity: null,
        price: null
      };
    },
    fetchLocation: function fetchLocation() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dataToSend = {
                  company_id: _this6.companyID,
                  token: _this6.$session.get('token')
                };


                _this6.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this6.locations = response.data.locations;
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this7.companyID);

              case 3:
                response = _context4.sent;

                if (response.ok) {
                  _context4.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context4.next = 8;
                return response.json();

              case 8:
                data = _context4.sent;

                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this7.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      externalLocationId: gest.externalLocationId || ''
                    };
                  });
                } else {
                  _this7.$message.error('Nu s-a primit un array valid de la server.');
                }
                _context4.next = 16;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](0);

                _this7.$message.error('Request failed: ' + _context4.t0.message);
                console.error('Error fetching management data:', _context4.t0);

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[0, 12]]);
      }))();
    },
    fetchProducts: function fetchProducts() {
      var _this8 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var url, response, data;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this8.productsList = [];

                if (_this8.selectedLocation) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt('return');

              case 3:

                clearTimeout(_this8.loadingTimeout);
                _this8.loadingTimeout = setTimeout(function () {
                  _this8.loading = true;
                }, 10);

                _context5.prev = 5;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/products?externalCompanyId=' + _this8.companyID;


                if (_this8.selectedLocation.inv_fiscal_code) {
                  url += '&vatNumber=' + _this8.selectedLocation.inv_fiscal_code;
                }

                if (_this8.inventoryDate) {
                  url += '&inventoryDate=' + _this8.inventoryDate;
                }

                console.log('this.selectedGestiune', _this8.selectedGestiune);

                if (_this8.gestiuneId) {
                  url += '&gestiune=' + _this8.gestiuneId;
                }

                url += '&isStockInitial=true';
                url += '&page=' + page + '&limit=' + pageSize;

                _context5.next = 15;
                return fetch(url);

              case 15:
                response = _context5.sent;
                _context5.next = 18;
                return response.json();

              case 18:
                data = _context5.sent;


                if (Array.isArray(data.products)) {
                  _this8.productsList = data.products.map(function (prod) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, prod, {
                      quantity: null,
                      price: null
                    });
                  });

                  _this8.searchProducts = (data.products || []).filter(function (p) {
                    return p && p.name;
                  }).map(function (prod) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, prod, {
                      label: prod.name || ''
                    });
                  });

                  console.log('this.productsList', _this8.productsList);
                } else {
                  _this8.$message.error('Eroare la încărcarea produselor.');
                }

                clearTimeout(_this8.loadingTimeout);
                _this8.loading = false;
                _context5.next = 29;
                break;

              case 24:
                _context5.prev = 24;
                _context5.t0 = _context5['catch'](5);

                _this8.$message.error('Eroare: ' + _context5.t0.message);
                clearTimeout(_this8.loadingTimeout);
                _this8.loading = false;

              case 29:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[5, 24]]);
      }))();
    },
    formatLocalDateTime: function formatLocalDateTime(dateStr) {
      if (!dateStr) return '';

      var d = new Date(dateStr);

      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };

      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    },
    getInitialStock: function getInitialStock(id) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var url, response, result;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (id) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return');

              case 2:
                _context6.prev = 2;

                _this9.loading = true;

                _context6.next = 6;
                return _this9.waitForGroupedLocations();

              case 6:
                url = new URL("https://fiscal-dev.cdntaptasty.com" + ':4443/stoc-initial/get');

                url.searchParams.append('id', id);
                url.searchParams.append('externalCompanyId', _this9.companyID);

                _context6.next = 11;
                return fetch(url);

              case 11:
                response = _context6.sent;
                _context6.next = 14;
                return response.json();

              case 14:
                result = _context6.sent;

                if (response.ok) {
                  _context6.next = 18;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ icon: 'error', title: 'Eroare!', text: result.error || 'Nu s-a putut încărca stocul inițial' });
                return _context6.abrupt('return');

              case 18:

                console.log('result.externalLocationId', result.externalLocationId);
                console.log('this.groupedLocations', _this9.groupedLocations);

                if (result.externalLocationId) {
                  _this9.selectedLocation = _this9.groupedLocations.flatMap(function (g) {
                    return g.locations;
                  }).find(function (l) {
                    return l.true_id === result.externalLocationId;
                  }) || null;
                }

                console.log('this.selectedLocation', _this9.selectedLocation);

                _this9.selectedGestiune = result.gestiune_id || null;
                _this9.gestiuneId = result.gestiune_id || null;

                if (Array.isArray(result.extraFields)) {
                  _this9.extraFields = result.extraFields.reduce(function (acc, _ref4) {
                    var key = _ref4.key,
                        value = _ref4.value;

                    acc[key] = value;
                    return acc;
                  }, {});
                } else {
                  _this9.extraFields = {};
                }

                _this9.inventoryDate = result.date ? _this9.formatLocalDateTime(result.date) : null;

                _this9.productsListStocks = result.lines.map(function (line) {
                  return {
                    _id: line.product_id,
                    name: line.product.name || '',
                    categorie: line.product.categorie || '',
                    quantity: line.quantity,
                    price: line.price || 0,
                    um: line.product.um || '',
                    is_hiden: 0
                  };
                });

                _this9.fetchProducts();
                _context6.next = 33;
                break;

              case 30:
                _context6.prev = 30;
                _context6.t0 = _context6['catch'](2);

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ icon: 'error', title: 'Eroare!', text: _context6.t0.message });

              case 33:
                _context6.prev = 33;

                _this9.loading = false;
                return _context6.finish(33);

              case 36:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[2, 30, 33, 36]]);
      }))();
    },
    updateStock: function updateStock() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var productsToSend, missingPrices, confirmed, extraFieldsArray, body, response, result;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(!_this10.selectedGestiune || !_this10.inventoryDate)) {
                  _context7.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ icon: 'warning', title: 'Alege gestiunea și data documentului!' });
                return _context7.abrupt('return');

              case 3:
                productsToSend = _this10.productsList.filter(function (p) {
                  return p.quantity > 0;
                });

                if (productsToSend.length) {
                  _context7.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ icon: 'warning', title: 'Adaugă cel puțin un produs cu cantitate mai mare ca 0!' });
                return _context7.abrupt('return');

              case 7:
                missingPrices = productsToSend.filter(function (p) {
                  return p.price === null || p.price === undefined || p.price === 0;
                }).map(function (p) {
                  return p.name;
                });

                if (!(missingPrices.length > 0)) {
                  _context7.next = 11;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  icon: 'error',
                  title: 'Eroare! Produse fără preț',
                  html: '\n            <p style="margin-bottom:10px;">Urm\u0103toarele produse nu au pre\u021B setat:</p>\n            <ul style="text-align:left; padding-left:20px; color:#d32f2f; font-weight:600;">\n              ' + missingPrices.map(function (name) {
                    return '<li>' + name + '</li>';
                  }).join('') + '\n            </ul>\n            <p style="margin-top:10px; font-size:14px; color:#555;">\n              Te rug\u0103m s\u0103 completezi pre\u021Bul \xEEnainte de a salva modific\u0103rile.\n            </p>\n          ',
                  showCloseButton: true,
                  confirmButtonText: 'OK'
                });
                return _context7.abrupt('return');

              case 11:
                _context7.next = 13;
                return _this10.confirmUmAndPriceWarning();

              case 13:
                confirmed = _context7.sent;

                if (confirmed) {
                  _context7.next = 16;
                  break;
                }

                return _context7.abrupt('return');

              case 16:
                extraFieldsArray = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(_this10.extraFields).map(function (_ref5) {
                  var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
                      key = _ref6[0],
                      value = _ref6[1];

                  return {
                    key: key,
                    value: value
                  };
                });
                _context7.prev = 17;
                body = {
                  externalCompanyId: _this10.companyID,
                  gestiune: _this10.selectedGestiune,
                  date: _this10.inventoryDate,
                  lines: productsToSend.map(function (p) {
                    return {
                      product_id: p._id,
                      quantity: p.quantity,
                      price: p.price
                    };
                  }),
                  extraFields: extraFieldsArray
                };
                _context7.next = 21;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/stoc-initial-update', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body)
                });

              case 21:
                response = _context7.sent;
                _context7.next = 24;
                return response.json();

              case 24:
                result = _context7.sent;

                if (response.ok) {
                  _context7.next = 28;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ icon: 'error', title: 'Eroare!', text: result.error || 'Eroare la actualizarea stocului inițial' });
                return _context7.abrupt('return');

              case 28:

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: 'Success',
                  text: 'Stoc inițial actualizat cu succes.',
                  icon: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this10.$bus.$emit('refresh');
                _this10.$bus.$emit('close-modal');

                _this10.productsList = [];
                _context7.next = 37;
                break;

              case 34:
                _context7.prev = 34;
                _context7.t0 = _context7['catch'](17);

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ icon: 'error', title: 'Eroare!', text: _context7.t0.message });

              case 37:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[17, 34]]);
      }))();
    },
    confirmUmAndPriceWarning: function confirmUmAndPriceWarning() {
      return __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        icon: 'warning',
        title: 'Atenție!',
        text: 'Vă rog să vă asigurați că unitățile de măsură selectate sunt corecte și că prețul este corespunzător unității de măsură selectate. În cazul în care sunt corecte, continuați apăsând butonul „Salvează”.',
        showCancelButton: true,
        confirmButtonText: 'Salvează',
        cancelButtonText: 'Anulează'
      }).then(function (result) {
        return !!result;
      }).catch(function () {
        return false;
      });
    },
    saveInitialStock: function saveInitialStock() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var productsToSend, missingPrices, confirmed, extraFieldsArray, body, response, result;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(!_this11.selectedGestiune || !_this11.inventoryDate)) {
                  _context8.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ icon: 'warning', title: 'Alege gestiunea și data documentului!' });
                return _context8.abrupt('return');

              case 3:
                productsToSend = _this11.productsList.filter(function (p) {
                  return p.quantity > 0;
                });

                if (productsToSend.length) {
                  _context8.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ icon: 'warning', title: 'Adaugă cel puțin un produs cu cantitate mai mare ca 0!' });
                return _context8.abrupt('return');

              case 7:
                missingPrices = productsToSend.filter(function (p) {
                  return p.price === null || p.price === undefined || p.price === 0;
                }).map(function (p) {
                  return p.name;
                });

                if (!(missingPrices.length > 0)) {
                  _context8.next = 11;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  icon: 'error',
                  title: 'Eroare! Produse fără preț',
                  html: '\n            <p style="margin-bottom:10px;">Urm\u0103toarele produse nu au pre\u021B setat:</p>\n            <ul style="text-align:left; padding-left:20px; color:#d32f2f; font-weight:600;">\n              ' + missingPrices.map(function (name) {
                    return '<li>' + name + '</li>';
                  }).join('') + '\n            </ul>\n            <p style="margin-top:10px; font-size:14px; color:#555;">\n              Te rug\u0103m s\u0103 completezi pre\u021Bul \xEEnainte de a salva stocul ini\u021Bial.\n            </p>\n          ',
                  showCloseButton: true,
                  confirmButtonText: 'OK'
                });
                return _context8.abrupt('return');

              case 11:
                _context8.next = 13;
                return _this11.confirmUmAndPriceWarning();

              case 13:
                confirmed = _context8.sent;

                if (confirmed) {
                  _context8.next = 16;
                  break;
                }

                return _context8.abrupt('return');

              case 16:
                extraFieldsArray = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(_this11.extraFields).map(function (_ref7) {
                  var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
                      key = _ref8[0],
                      value = _ref8[1];

                  return {
                    key: key,
                    value: value
                  };
                });
                _context8.prev = 17;
                body = {
                  externalCompanyId: _this11.companyID,
                  externalLocationId: _this11.selectedLocation.true_id,
                  gestiune: _this11.selectedGestiune,
                  date: _this11.inventoryDate,
                  lines: productsToSend.map(function (p) {
                    return {
                      product_id: p._id,
                      quantity: p.quantity,
                      price: p.price
                    };
                  }),
                  extraFields: extraFieldsArray
                };
                _context8.next = 21;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/stoc-initial', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body)
                });

              case 21:
                response = _context8.sent;
                _context8.next = 24;
                return response.json();

              case 24:
                result = _context8.sent;

                if (response.ok) {
                  _context8.next = 28;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ icon: 'error', title: 'Eroare!', text: result.error || 'Eroare la salvarea stocului inițial' });
                return _context8.abrupt('return');

              case 28:

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: 'Success',
                  text: 'Initial stock saved successfully.',
                  icon: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this11.$bus.$emit('refresh');
                _this11.$bus.$emit('close-modal');

                _this11.productsList = [];
                _this11.productsListStocks = [];
                _context8.next = 38;
                break;

              case 35:
                _context8.prev = 35;
                _context8.t0 = _context8['catch'](17);

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ icon: 'error', title: 'Eroare!', text: _context8.t0.message });

              case 38:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[17, 35]]);
      }))();
    }
  }
});

/***/ }),

/***/ "Bmk/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.isInvoice)?_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"button","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.saveInvoice($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('invoice.invoiced'))+"\n        ")]):_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('invoice.invoiceDetails')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit || _vm.isAviz},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                  "+_vm._s(loc.name)+"\n                ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.issueDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.issueDate),expression:"issueDate"}],staticClass:"form-control",attrs:{"type":"datetime-local","max":_vm.today},domProps:{"value":(_vm.issueDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.issueDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.dueDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dueDate),expression:"dueDate"}],staticClass:"form-control",attrs:{"type":"datetime-local","max":_vm.today},domProps:{"value":(_vm.dueDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dueDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.series'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seriesNumber),expression:"seriesNumber"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seriesNumber=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.updateNumber]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('invoice.selectSeries')))]),_vm._v(" "),_vm._l((_vm.seriesOptionsWithAdd),function(series){return _c('option',{key:series.id || series.series,domProps:{"value":series.id || series.series}},[_vm._v("\n                  "+_vm._s(series.nume || series.series)+"\n                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currentNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentNumber),expression:"currentNumber"}],staticClass:"form-control",attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.currentNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentNumber=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('invoice.client')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.vatPayer'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientVATPayer),expression:"clientVATPayer"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.clientVATPayer=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"yes"}},[_vm._v(_vm._s(_vm.$t('invoice.yes')))]),_vm._v(" "),_c('option',{attrs:{"value":"no"}},[_vm._v(_vm._s(_vm.$t('invoice.no')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.legalStatus'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientLegalStatus),expression:"clientLegalStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.clientLegalStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"fizica"}},[_vm._v(_vm._s(_vm.$t('invoice.statusLegal.fizica')))]),_vm._v(" "),_c('option',{attrs:{"value":"juridica_ro"}},[_vm._v(_vm._s(_vm.$t('invoice.statusLegal.juridicaRo')))]),_vm._v(" "),_c('option',{attrs:{"value":"juridica_eu"}},[_vm._v(_vm._s(_vm.$t('invoice.statusLegal.juridicaEu')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientName'))+"*")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.clientResults,"label":"nume","placeholder":"Caută un client...","filterable":false,"disabled":!_vm.selectedLocation},on:{"search":_vm.fetchClients,"input":_vm.onClientSelect},model:{value:(_vm.clientSelected),callback:function ($$v) {_vm.clientSelected=$$v},expression:"clientSelected"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientCUI'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.clientCUI),expression:"modelValidate.clientCUI"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientCUI')},domProps:{"value":_vm.clientCUI},on:{"input":function($event){_vm.clientCUI = $event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientEmail),expression:"clientEmail"}],staticClass:"form-control",attrs:{"type":"email","placeholder":_vm.$t('invoice.clientEmail')},domProps:{"value":(_vm.clientEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientPhone'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientPhone),expression:"clientPhone"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.clientPhone),expression:"modelValidate.clientPhone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientPhone')},domProps:{"value":(_vm.clientPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientPhone=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientAddress'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientAddress),expression:"clientAddress"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.clientAddress),expression:"modelValidate.clientAddress"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientAddress')},domProps:{"value":(_vm.clientAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientAddress=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('invoice.otherDetails')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.currency'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency),expression:"currency"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currency=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"RON"}},[_vm._v("RON")]),_vm._v(" "),_c('option',{attrs:{"value":"EUR"}},[_vm._v("EUR")]),_vm._v(" "),_c('option',{attrs:{"value":"USD"}},[_vm._v("USD")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.language')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.language),expression:"language"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.language=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"ro"}},[_vm._v("Română")]),_vm._v(" "),_c('option',{attrs:{"value":"en"}},[_vm._v("English")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"title"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProductInAviz')))])]),_vm._v(" "),(!_vm.isAviz)?_c('div',{staticClass:"search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search Order Id..."},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"btn btn-icon btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.searchOrder}},[_c('i',{staticClass:"ti-search"})])]):_vm._e()]),_vm._v(" "),_c('hr',{staticClass:"sm"})])]),_vm._v(" "),[_c('div',[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.productName'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.type'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.codeProduct'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.unitMeasure'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.quantity'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.vatRate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.pretFaraTva'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.valoare')))]),_vm._v(" "),_c('th',[_vm._v("TVA")]),_vm._v(" "),(!_vm.isDisabled && !_vm.isEdit)?_c('th',[_vm._v(_vm._s(_vm.$t('general.actions')))]):_vm._e()])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(_vm.getGestiuneName(item.gestiuneFrom)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(typeof item.productName === 'object' ? item.productName.name : item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.unitMeasure))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.vatRate)+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.priceRON))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.valoare))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tva))]),_vm._v(" "),(!_vm.isDisabled && !_vm.isEdit)?_c('td',[_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",attrs:{"disabled":_vm.isAviz},on:{"click":function($event){_vm.removeItem(index)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                        "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])]):_vm._e()])}),_vm._v(" "),(!_vm.isInvoice && !_vm.isEdit && !_vm.isAviz && !_vm.isDisabled)?_c('tr',[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.gestiuneId),expression:"newItem.gestiuneId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newItem, "gestiuneId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selectează gestiunea")]),_vm._v(" "),_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('option',{key:gestiune.id,domProps:{"value":gestiune.id}},[_vm._v("\n                        "+_vm._s(gestiune.name)+"\n                      ")])})],2)]),_vm._v(" "),_c('td',{staticStyle:{"width":"250px !important"}},[_c('v-select',{attrs:{"options":_vm.searchResults,"label":"name","placeholder":"Caută un produs...","filterable":false},on:{"search":_vm.fetchProducts,"input":_vm.onProductSelected},model:{value:(_vm.newItem.productName),callback:function ($$v) {_vm.$set(_vm.newItem, "productName", $$v)},expression:"newItem.productName"}},[[(!_vm.loadingProducts)?_c('span',[_vm._v("Niciun produs găsit")]):_vm._e()]],2),_vm._v(" "),(_vm.loadingProducts)?_c('div',{staticClass:"v-select-loader-product"}):_vm._e()],1),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.type),expression:"newItem.type"}],staticClass:"form-control",attrs:{"disabled":true},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newItem, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Tip")]),_vm._v(" "),_c('option',{attrs:{"value":"Marfa"}},[_vm._v("Marfa")]),_vm._v(" "),_c('option',{attrs:{"value":"Materii prime"}},[_vm._v("Materii prime")]),_vm._v(" "),_c('option',{attrs:{"value":"Materiale consumabile"}},[_vm._v("Materiale consumabile")]),_vm._v(" "),_c('option',{attrs:{"value":"Semifabricate (Reteta)"}},[_vm._v("Semifabricate (Reteta)")]),_vm._v(" "),_c('option',{attrs:{"value":"Produs finit (Reteta)"}},[_vm._v("Produs finit (Reteta)")]),_vm._v(" "),_c('option',{attrs:{"value":"Produs rezidual"}},[_vm._v("Produs rezidual")]),_vm._v(" "),_c('option',{attrs:{"value":"Ambalaje"}},[_vm._v("Ambalaje")]),_vm._v(" "),_c('option',{attrs:{"value":"Obiecte de inventar"}},[_vm._v("Obiecte de inventar")])])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.code),expression:"newItem.code"}],staticClass:"form-control",attrs:{"type":"text","disabled":true,"placeholder":"Cod"},domProps:{"value":(_vm.newItem.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "code", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('el-select',{attrs:{"disabled":true,"placeholder":"Selectează unitatea de măsură"},model:{value:(_vm.newItem.unitMeasure),callback:function ($$v) {_vm.$set(_vm.newItem, "unitMeasure", $$v)},expression:"newItem.unitMeasure"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.quantity),expression:"newItem.quantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('invoice.quantity')},domProps:{"value":(_vm.newItem.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "quantity", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('el-select',{attrs:{"placeholder":"Cota TVA"},model:{value:(_vm.newItem.vatRate),callback:function ($$v) {_vm.$set(_vm.newItem, "vatRate", $$v)},expression:"newItem.vatRate"}},_vm._l((_vm.vats),function(vat){return _c('el-option',{key:vat.tax_id,attrs:{"label":((vat.amount) + " %"),"value":vat.amount}})}))],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.priceRON),expression:"newItem.priceRON",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.pretFaraTva')},domProps:{"value":(_vm.newItem.priceRON)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "priceRON", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('el-select',{attrs:{"placeholder":"Prețul include TVA?"},model:{value:(_vm.newItem.includeVAT),callback:function ($$v) {_vm.$set(_vm.newItem, "includeVAT", $$v)},expression:"newItem.includeVAT"}},[_c('el-option',{attrs:{"label":"Cu TVA","value":"yes"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Fără TVA","value":"no"}})],1)],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.tva),expression:"newItem.tva",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":_vm.$t('gestiune.tva')},domProps:{"value":(_vm.newItem.tva)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "tva", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.addItem}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.add'))+"\n                    ")])])]):_vm._e()],2)])])],_vm._v(" "),_c('div',{staticClass:"totals-container"},[_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Total fara TVA:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalFaraTva.toFixed(2))+" RON")])]),_vm._v(" "),_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Total TVA:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalTva.toFixed(2))+" RON")])]),_vm._v(" "),(_vm.totalCorectie !== 0)?_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Corectie Document:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalCorectie.toFixed(2))+" RON")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"total-row total-final"},[_c('span',{staticClass:"label"},[_vm._v("Total:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalFinal.toFixed(2))+" RON")])])])],2)]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v("Detalii Client")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"intocmitDe"}},[_vm._v("Întocmit de")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.intocmitDe),expression:"extraFields.intocmitDe"}],staticClass:"form-control",attrs:{"type":"text","id":"intocmitDe","placeholder":"Numele persoanei"},domProps:{"value":(_vm.extraFields.intocmitDe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "intocmitDe", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"cnp"}},[_vm._v("CNP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.cnp),expression:"extraFields.cnp"}],staticClass:"form-control",attrs:{"type":"text","id":"cnp","placeholder":"Cod Numeric Personal"},domProps:{"value":(_vm.extraFields.cnp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "cnp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"delegat"}},[_vm._v("Delegat")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.delegat),expression:"extraFields.delegat"}],staticClass:"form-control",attrs:{"type":"text","id":"delegat","placeholder":"Numele delegatului"},domProps:{"value":(_vm.extraFields.delegat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "delegat", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"carteIdentitate"}},[_vm._v("Carte Identitate")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.carteIdentitate),expression:"extraFields.carteIdentitate"}],staticClass:"form-control",attrs:{"type":"text","id":"carteIdentitate","placeholder":"Seria și numărul cărții de identitate"},domProps:{"value":(_vm.extraFields.carteIdentitate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "carteIdentitate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"auto"}},[_vm._v("Auto")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.auto),expression:"extraFields.auto"}],staticClass:"form-control",attrs:{"type":"text","id":"auto","placeholder":"Marca și modelul auto"},domProps:{"value":(_vm.extraFields.auto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "auto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"agentVanzari"}},[_vm._v("Agent vânzări")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.agentVanzari),expression:"extraFields.agentVanzari"}],staticClass:"form-control",attrs:{"type":"text","id":"agentVanzari","placeholder":"Numele agentului de vânzări"},domProps:{"value":(_vm.extraFields.agentVanzari)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "agentVanzari", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"punctDeLucruClient"}},[_vm._v("Punct de Lucru Client")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.punctDeLucruClient),expression:"extraFields.punctDeLucruClient"}],staticClass:"form-control",attrs:{"type":"text","id":"punctDeLucruClient","placeholder":"Locația punctului de lucru"},domProps:{"value":(_vm.extraFields.punctDeLucruClient)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "punctDeLucruClient", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"numarComandaBT13"}},[_vm._v("Număr comandă BT-13")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.numarComandaBT13),expression:"extraFields.numarComandaBT13"}],staticClass:"form-control",attrs:{"type":"text","id":"numarComandaBT13","placeholder":"Numărul comenzii"},domProps:{"value":(_vm.extraFields.numarComandaBT13)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "numarComandaBT13", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"numarContractBT12"}},[_vm._v("Număr contract BT-12")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.numarContractBT12),expression:"extraFields.numarContractBT12"}],staticClass:"form-control",attrs:{"type":"text","id":"numarContractBT12","placeholder":"Numărul contractului"},domProps:{"value":(_vm.extraFields.numarContractBT12)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "numarContractBT12", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"referintaProiectBT11"}},[_vm._v("Referință proiect BT-11")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.referintaProiectBT11),expression:"extraFields.referintaProiectBT11"}],staticClass:"form-control",attrs:{"type":"text","id":"referintaProiectBT11","placeholder":"Codul proiectului"},domProps:{"value":(_vm.extraFields.referintaProiectBT11)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "referintaProiectBT11", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"identificatorCumparatorBT46"}},[_vm._v("Identificator cumpărător BT-46")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.identificatorCumparatorBT46),expression:"extraFields.identificatorCumparatorBT46"}],staticClass:"form-control",attrs:{"type":"text","id":"identificatorCumparatorBT46","placeholder":"ID-ul cumpărătorului"},domProps:{"value":(_vm.extraFields.identificatorCumparatorBT46)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "identificatorCumparatorBT46", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"numarAvizReceptieBT15"}},[_vm._v("Număr aviz recepție BT-15")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.numarAvizReceptieBT15),expression:"extraFields.numarAvizReceptieBT15"}],staticClass:"form-control",attrs:{"type":"text","id":"numarAvizReceptieBT15","placeholder":"Numărul avizului"},domProps:{"value":(_vm.extraFields.numarAvizReceptieBT15)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "numarAvizReceptieBT15", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"referintaContabilaCumparatorBT19"}},[_vm._v("Referință contabilă cumpărător BT-19")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.referintaContabilaCumparatorBT19),expression:"extraFields.referintaContabilaCumparatorBT19"}],staticClass:"form-control",attrs:{"type":"text","id":"referintaContabilaCumparatorBT19","placeholder":"Referința contabilă"},domProps:{"value":(_vm.extraFields.referintaContabilaCumparatorBT19)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "referintaContabilaCumparatorBT19", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dataLivrarii"}},[_vm._v("Data livrării")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.dataLivrarii),expression:"extraFields.dataLivrarii"}],staticClass:"form-control",attrs:{"type":"date","id":"dataLivrarii"},domProps:{"value":(_vm.extraFields.dataLivrarii)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "dataLivrarii", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dataIncasarii"}},[_vm._v("Data încasării")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.dataIncasarii),expression:"extraFields.dataIncasarii"}],staticClass:"form-control",attrs:{"type":"date","id":"dataIncasarii"},domProps:{"value":(_vm.extraFields.dataIncasarii)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "dataIncasarii", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"notaInterna"}},[_vm._v("Notă internă")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.notaInterna),expression:"extraFields.notaInterna"}],staticClass:"form-control",attrs:{"id":"notaInterna","placeholder":"Informații suplimentare"},domProps:{"value":(_vm.extraFields.notaInterna)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "notaInterna", $event.target.value)}}})])])])])]),_vm._v(" "),_c('ManagementClientsAdd',{attrs:{"groupedLocations":_vm.groupedLocations}}),_vm._v(" "),_c('ManagementSeriesAdd',{attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations,"vat-number":_vm.selectedLocation ? _vm.selectedLocation.inv_fiscal_code : ''},on:{"getSeries":_vm.getSeries}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bq/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductOptionsPanel',
  props: {
    product: { type: Object, required: true },
    currency: { type: String, default: 'RON' },
    variant: { type: String, default: 'wolt' }
  },
  data: function data() {
    return {
      selections: {}
    };
  },

  watch: {
    product: {
      immediate: true,
      handler: function handler(product) {
        var next = {};(product.options || []).forEach(function (option) {
          if (option.counter) {
            next[option.id] = {};(option.values || []).filter(function (v) {
              return v.selected_by_default;
            }).forEach(function (v) {
              next[option.id][v.id] = 1;
            });
          } else if (option.multiple) {
            next[option.id] = (option.values || []).filter(function (v) {
              return v.selected_by_default;
            }).map(function (v) {
              return v.id;
            });
          } else {
            var values = option.values || [];
            var first = values.find(function (v) {
              return v.selected_by_default && v.available !== false;
            }) || (values.some(function (v) {
              return v.selected_by_default != null;
            }) ? null : values.find(function (v) {
              return v.available !== false;
            }));
            next[option.id] = first ? first.id : null;
          }
        });
        this.selections = next;
      }
    }
  },
  methods: {
    setCounter: function setCounter(option, value, input) {
      var limit = Math.max(0, Number(option.max) - this.counterTotal(option) + this.counterQty(option, value.id));
      var count = Math.max(0, Math.min(Number(input) || 0, Number(value.max_quantity) || limit, limit));
      var selected = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.selections[option.id] || {});
      selected[value.id] = Math.floor(count);
      this.$set(this.selections, option.id, selected);
    },
    formatPrice: function formatPrice(price) {
      var n = Number(price);
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(n)) return '';
      return n.toFixed(2).replace('.', ',') + ' ' + this.currency;
    },
    optionHint: function optionHint(option) {
      var min = Number(option.min || 0);
      var max = Number(option.max || 0);
      if (option.multiple) {
        return this.$t('gestiune.integrationsMenuPreviewOptionRange', { min: min, max: max });
      }
      if (min >= 1) {
        return this.$t('gestiune.integrationsMenuPreviewChooseOne');
      }
      return this.$t('gestiune.integrationsMenuPreviewOptionOptional');
    },
    isSelected: function isSelected(option, valueId) {
      var selected = this.selections[option.id];
      if (option.multiple && Array.isArray(selected)) {
        return selected.map(String).includes(String(valueId));
      }
      return String(selected) === String(valueId);
    },
    counterQty: function counterQty(option, valueId) {
      var selected = this.selections[option.id];
      if (!selected || (typeof selected === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(selected)) !== 'object') return 0;
      return Number(selected[valueId]) || 0;
    },
    counterTotal: function counterTotal(option) {
      var selected = this.selections[option.id];
      if (!selected || (typeof selected === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(selected)) !== 'object') return 0;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(selected).reduce(function (sum, id) {
        return sum + (Number(selected[id]) || 0);
      }, 0);
    },
    canIncreaseCounter: function canIncreaseCounter(option, valueId) {
      var value = (option.values || []).find(function (v) {
        return String(v.id) === String(valueId);
      });
      var eachMax = Math.max(1, Number(value && value.max_quantity) || Number(option.each_max) || 1);
      var groupMax = Math.max(1, Number(option.max) || eachMax);
      var current = this.counterQty(option, valueId);
      if (current >= eachMax) return false;
      return this.counterTotal(option) < groupMax;
    },
    adjustCounter: function adjustCounter(option, valueId, delta) {
      var current = this.counterQty(option, valueId);
      var nextQty = current + delta;
      if (nextQty < 0) return;
      if (delta > 0 && !this.canIncreaseCounter(option, valueId)) return;

      var prev = this.selections[option.id] && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.selections[option.id]) === 'object' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.selections[option.id]) : {};
      if (nextQty <= 0) {
        delete prev[valueId];
      } else {
        prev[valueId] = nextQty;
      }
      this.$set(this.selections, option.id, prev);
    }
  }
});

/***/ }),

/***/ "BryT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BtN9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bw5W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content user-report"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{ref:"dateRangePicker",staticClass:"mid",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions1},model:{value:(_vm.filters.valid),callback:function ($$v) {_vm.$set(_vm.filters, "valid", $$v)},expression:"filters.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('reports.filter')},on:{"click":_vm.getData}},[_c('i',{staticClass:"ti-search"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5 col-sm-12 col-xs-12 details-height"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            "+_vm._s(_vm.$t('reports.userDetails'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:" card-content"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.id')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.customer.id))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.name')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.customer.firstname)+" "+_vm._s(_vm.customer.lastname))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.email')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.customer.email))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.phone')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.customer.phone))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.gender')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.customer.gender))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.birth')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.formatDate(_vm.customer.birthdate)))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.address')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-7 col-xs-12"},[(_vm.customer.addresses && _vm.customer.addresses.length)?[_vm._v("\n                "+_vm._s(_vm.getUserAddress(_vm.customer.addresses[0]))+"\n              ")]:[_c('b',[_vm._v("-")])]],2)]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-5 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.pointsTitle')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.customer.loyalty_points))])])]),_vm._v(" "),_c('div',{staticClass:"row card-footer"})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-7 col-sm-12 col-xs-12 details-height"},[_c('chart-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"refOrdersChart",attrs:{"chart-data":_vm.ordersChart.data,"chart-options":_vm.ordersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.orderChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.ordersChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v("\n          "+_vm._s(_vm.$t('dashboard.completed'))+"\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-12 charts-height"},[_c('chart-pie-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"paymentsChart",attrs:{"chart-data":_vm.paymentsChart.data,"chart-options":_vm.paymentsChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.cash'))+" VS "+_vm._s(_vm.$t('reports.card')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.paymentsChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-sm-12 charts-height"},[_c('chart-bars-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"topProdsChart",attrs:{"chart-data":_vm.topProdsChart.data,"chart-options":_vm.topProdsChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.top5Chart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.topProdsChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v("\n          "+_vm._s(_vm.$t('reports.salesProductNr'))+"\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('form',{},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            "+_vm._s(_vm.$t('reports.salesDetails'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"row card-content"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.customer.orders,"search-def":{show: false},"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDef,"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"min-width":100,"sortable":"","prop":"number","label":_vm.$t('customers.number')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v("#"+_vm._s(props.row.token))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":150,"sortable":"","prop":"date","label":_vm.$t('customers.dateCreated')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatDateTime(props.row.created_at))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":150,"sortable":"","prop":"delivery_type","label":_vm.$t('customers.delivery')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.delivery_type ? _vm.$t('deliveryTypes.' + props.row.delivery_type) : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"sortable":"","prop":"order_type","label":_vm.$t('customers.type')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{class:'text-lowercase'},[_vm._v("\n                "+_vm._s(_vm.$t('ordersTypes.' + props.row.order_type))+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"sortable":"","prop":"status","label":_vm.$t('customers.status')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{class:'label label-' + _vm.orderStatusClass(props.row.status.id)},[_vm._v(_vm._s(_vm.$t('ordersStatus.' + props.row.status.id)))])]}}])}),_vm._v(" "),_c('el-table-column',{class:'text-right',attrs:{"min-width":100,"sortable":"","prop":"total","label":_vm.$t('customers.total')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(props.row.totals_grandtotal, props.row.currency)))])]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"row card-footer"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bx1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStoreCampaignEdit_vue__ = __webpack_require__("JiEC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e23522_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStoreCampaignEdit_vue__ = __webpack_require__("f9Y/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStoreCampaignEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e23522_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStoreCampaignEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BzuL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptionsPanel_vue__ = __webpack_require__("Bq/p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c678bed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptionsPanel_vue__ = __webpack_require__("uJR6");
function injectStyle (ssrContext) {
  __webpack_require__("abJY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c678bed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptionsPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c678bed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptionsPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C+sr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C3Gn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_tooltip_css__ = __webpack_require__("RWjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_tooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tooltip__ = __webpack_require__("aMwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__discountCampaignConstants__ = __webpack_require__("WW1J");













__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tooltip___default.a);

var VISIBLE_LIST_ITEMS = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  props: {
    isDiscountCampaigns: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: true,
      onInputTimeout: null,
      search: '',
      tableData: [],
      paginationDef: {
        page: 1,
        perPage: 20,
        totalPages: null,
        totalRecords: null
      }
    };
  },
  created: function created() {
    this.getCampaigns();
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    priceProfileName: function priceProfileName(row) {
      if (row.price_profile && row.price_profile.name) {
        return row.price_profile.name;
      }
      return row.price_profile_name || row.price_profile_id || '-';
    },
    productsCountFallback: function productsCountFallback(row) {
      if (row.lines_count != null) return row.lines_count;
      if (row.products_count != null) return row.products_count;
      return '-';
    },
    handleRefresh: function handleRefresh() {
      this.getCampaigns();
    },
    onRowClick: function onRowClick(row, column, event) {
      if (event.target.closest('.el-switch') || event.target.closest('.el-dropdown')) {
        return;
      }
      this.goToRecord(row);
    },
    goToAdd: function goToAdd() {
      this.$router.push({ path: '/marketing/discount-campaigns/add' });
    },
    goToRecord: function goToRecord(row) {
      this.$router.push({ path: '/marketing/discount-campaigns/edit/' + row.id });
    },
    applyFilters: function applyFilters() {
      this.paginationDef.page = 1;
      this.getCampaigns();
    },
    onInput: function onInput() {
      var _this = this;

      clearTimeout(this.onInputTimeout);
      this.onInputTimeout = setTimeout(function () {
        _this.paginationDef.page = 1;
        _this.getCampaigns();
      }, 500);
    },
    handlePageChange: function handlePageChange(page) {
      this.paginationDef.page = page;
      this.getCampaigns();
    },
    buildParams: function buildParams() {
      var params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.paginationDef.page,
        perPage: this.paginationDef.perPage
      };
      if (this.search) {
        params.name = this.search;
      }
      return params;
    },
    getCampaigns: function getCampaigns() {
      var _this2 = this;

      this.loading = true;
      this.apiRequest('/discount-campaigns', 'GET', this.buildParams(), function (response) {
        if (response.status === true) {
          var rows = Array.isArray(response.data) ? response.data : response.data && response.data.data || [];
          _this2.tableData = rows.map(function (row) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, row, {
              active: !!(parseInt(row.active, 10) === 1 || row.active === true),
              productsList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__discountCampaignConstants__["i" /* formatTruncatedList */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__discountCampaignConstants__["j" /* getProductLabels */])(row), null, VISIBLE_LIST_ITEMS),
              combosList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__discountCampaignConstants__["i" /* formatTruncatedList */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__discountCampaignConstants__["k" /* getComboLabels */])(row), null, VISIBLE_LIST_ITEMS)
            });
          });
          if (response.pagination) {
            _this2.paginationDef.page = response.pagination.page;
            _this2.paginationDef.perPage = response.pagination.perPage;
            _this2.paginationDef.totalPages = response.pagination.totalPages;
            _this2.paginationDef.totalRecords = response.pagination.totalRecords;
          } else if (response.data && response.data.pagination) {
            _this2.paginationDef.page = response.data.pagination.page;
            _this2.paginationDef.perPage = response.data.pagination.perPage;
            _this2.paginationDef.totalPages = response.data.pagination.totalPages;
            _this2.paginationDef.totalRecords = response.data.pagination.totalRecords;
          } else {
            _this2.paginationDef.totalRecords = _this2.tableData.length;
          }
        }
        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    formatDiscount: function formatDiscount(row) {
      var discount = parseFloat(row.discount || 0);
      if (parseInt(row.discount_type, 10) === 2) {
        return discount + '%';
      }
      return this.formatMoneyAmount(discount);
    },
    rowClass: function rowClass(_ref) {
      var row = _ref.row;

      return row.active ? 'highlight-row' : '';
    },
    handleActive: function handleActive(index, row, e) {
      var _this3 = this;

      var actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + row.name + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this3.$session.get('token'),
            company_id: _this3.$session.get('selectedCompany'),
            active: row.active ? 1 : 0
          };
          _this3.apiRequest('/discount-campaigns/' + row.id, 'PUT', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()(_this3.$t('general.success') + '!', '', 'success').catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error').catch(function () {});
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        row.active = !row.active;
      });
    },
    handleDelete: function handleDelete(index, row) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        text: this.$t('discountCampaigns.areYouSureDelete') + ' ' + row.name + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this4.$session.get('token'),
            company_id: _this4.$session.get('selectedCompany')
          };
          _this4.apiRequest('/discount-campaigns/' + row.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', _this4.$t('discountCampaigns.campaignDeleted'), 'success').catch(function () {});
              _this4.tableData.splice(index, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "C47s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableZones_vue__ = __webpack_require__("Yqnz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c027eb3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableZones_vue__ = __webpack_require__("cWSf");
function injectStyle (ssrContext) {
  __webpack_require__("D1gf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableZones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c027eb3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableZones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C59m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C8MM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OrderScreenForm_vue__ = __webpack_require__("B5QA");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'OrderScreenForm', __WEBPACK_IMPORTED_MODULE_7__OrderScreenForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderScreenModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderScreenModel = model;
    }
  }
});

/***/ }),

/***/ "C8Oy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_json_excel__ = __webpack_require__("fXhN");






var _components;










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_12_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isCustomerLifetimeValueReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isCustomerLifetimeValueReport: function isCustomerLifetimeValueReport() {
      if (this.isCustomerLifetimeValueReport) {
        this.getOrders();
      }
    }
  },
  created: function created() {
    this.getOrders();
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear();
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '-' + formattedDate + '.xls';
    this.verifyUserLocations();
    this.verifyUserMethods();
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      productsTableData: [],
      productsTableDataTotals: {},
      sortBy: [],
      sortOrder: [],
      paymentMethods: [],
      receiptOptions: [{ label: this.$t('reports.withoutReceipt'), value: 1 }, { label: this.$t('reports.withReceipt'), value: 2 }],
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_method: '',
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_9_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_9_moment___default()().endOf('month').format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_9_moment___default()().subtract(24, 'months');
        }
      },
      ordersTableData: {},
      totals: {
        total: 0,
        totalCash: 0,
        totalVirament: 0,
        totalOnline: 0,
        totalProtocol: 0,
        totalCard: 0,
        totalPOS: 0,
        totalCARDPOS: 0,
        totalTips: 0,
        totalDiscount: 0,
        totalTax: 0,
        totalShipping: 0,
        avarageOrderValue: 0
      },
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      noData: false,
      churnRate: 0,
      pagination: {
        page: 1,
        pageSize: 20
      }
    };
  },

  methods: {
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
          order = _ref.order;

      if (!order) {
        this.sortBy = [];
        this.sortOrder = [];
      } else {
        var direction = order === 'ascending' ? 'asc' : 'desc';
        this.sortOrder = [direction];
        this.sortBy = [prop];
      }

      this.getOrders();
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    renderHeaderWithTotal: function renderHeaderWithTotal(h, label, total) {
      total = Math.round(Number(total));

      return h('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: '100%',
          textAlign: 'center',
          padding: '4px',
          boxSizing: 'border-box',
          justifyContent: 'space-between',
          overflow: 'visible'
        }
      }, [h('div', {
        style: {
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          hyphens: 'auto',
          whiteSpace: 'normal',
          lineHeight: '1.2',
          minWidth: '0'
        }
      }, label), h('div', {
        style: {
          display: 'flex',
          justifyContent: 'center',
          marginTop: '4px'
        }
      }, [h('span', {
        style: {
          background: '#674BD2 !important',
          color: '#fff',
          borderRadius: '5px',
          padding: '2px 6px',
          fontWeight: 'bold',
          fontSize: '12px',
          lineHeight: '1',
          whiteSpace: 'nowrap',
          display: 'inline-block'
        }
      }, total)])]);
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page' || query.type === 'size' || query.type === 'sort') {
        this.pagination.page = query.page;
        this.pagination.pageSize = query.pageSize;
        this.getOrders(query);
      }
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    goToRecord: function goToRecord(row) {
      var route = this.$router.resolve({ path: '/customers/view/' + row.id });
      window.open(route.href, '_blank');
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this = this;

      if (!this.isCustomerLifetimeValueReport) {
        return;
      }
      if (this.loading) {
        return;
      }

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: this.orders.valid[0],
        to_date: this.orders.valid[1],
        sort_by: this.sortBy,
        sort_order: this.sortOrder
      };
      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }
      this.loading = true;
      var pageSize = query ? query.pageSize : this.pagination.pageSize;
      var page = query ? query.page : this.pagination.page;

      this.apiRequest('/reports/v2/customer-lifetime-value' + '?page=' + page + '&perPage=' + pageSize + '&has_receipt=', 'GET', data, function (response) {
        if (response.status) {
          _this.productsTableData = response.data;
          _this.productsTableDataTotals = response.totals;
          _this.totalOrders = response.pagination.total;
          _this.paginationProps.currentPage = response.pagination.page;
          _this.paginationProps.pageSize = response.pagination.perPage;
          _this.pagination.page = response.pagination.page;
          _this.pagination.pageSize = response.pagination.perPage;
          _this.churnRate = parseFloat(response.churn_rate_percentage) || 0;
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    exportData: function exportData() {
      var _this2 = this;

      var fromDate = this.orders.valid[0];
      var toDate = this.orders.valid[1];

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        perPage: this.paginationProps.pageSize,
        page: this.paginationProps.currentPage
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/master-report-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
        }
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "CFH9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CLOz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Integrations_ManagementIntegrations_vue__ = __webpack_require__("1MDv");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SettingsIntegrations',
  components: {
    ManagementIntegrations: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Integrations_ManagementIntegrations_vue__["a" /* default */]
  },
  computed: {
    groupedLocations: function groupedLocations() {
      var company = this.$session && this.$session.get('selectedCompanyData') || {};
      var locs = Array.isArray(company.locations_details) ? company.locations_details : [];
      var groups = {};

      locs.forEach(function (loc) {
        var vat = loc.inv_fiscal_code || loc.vatNumber || 'Fără cod fiscal';
        if (!groups[vat]) groups[vat] = [];
        groups[vat].push(loc);
      });

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return { vat: vat, locations: locations };
      });
    }
  }
});

/***/ }),

/***/ "CRWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._m(0),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.task.title))]),_vm._v(" "),_c('td',{staticClass:"td-actions text-right"},[_c('div',{staticClass:"table-icons"},[_c('button',{staticClass:"btn btn-info btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Edit Task"},on:{"click":_vm.handleEditClick}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Remove"},on:{"click":_vm.handleDeleteClick}},[_c('i',{staticClass:"ti-close"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","value":"","data-toggle":"checkbox"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CTLp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discount-pricing-grid"},[(_vm.loading)?_c('div',{staticClass:"text-center py-3"},[_c('i',{staticClass:"ti-reload rotate"}),_vm._v(" "+_vm._s(_vm.$t('general.loading'))+"\n  ")]):[(_vm.products.length)?_c('div',{staticClass:"table-responsive-wrapper"},[_c('div',{staticClass:"table-horizontal-scroll"},[_c('table',{staticClass:"table pricing-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"product-col sticky-col"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.productStandardPrice')))]),_vm._v(" "),_vm._l((_vm.combos),function(combo){return _c('th',{key:combo.key,staticClass:"source-method-col"},[_c('div',{staticClass:"combo-label"},[_vm._v(_vm._s(combo.label))])])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.products),function(product){return _c('tr',{key:product.id},[_c('td',{staticClass:"product-col sticky-col"},[_c('div',{staticClass:"product-info"},[_c('strong',[_vm._v(_vm._s(product.name))]),_vm._v(" "),_c('div',{staticClass:"product-id text-muted"},[_vm._v("ID: "+_vm._s(product.id))]),_vm._v(" "),_c('div',{staticClass:"standard-price text-muted"},[_vm._v("\n                    "+_vm._s(_vm.formatMoneyAmount(product.price))+"\n                  ")])])]),_vm._v(" "),_vm._l((_vm.combos),function(combo){return _c('td',{key:((product.id) + "-" + (combo.key)),staticClass:"pricing-cell"},[(_vm.getCell(product.id, combo))?_c('div',{staticClass:"discount-cell"},[_c('div',{staticClass:"discount-row"},[_c('span',{staticClass:"discount-label"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.originalPrice')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.getCell(product.id, combo).price)))])]),_vm._v(" "),_c('div',{staticClass:"discount-row"},[_c('span',{staticClass:"discount-label"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.discountAmount')))]),_vm._v(" "),_c('span',{staticClass:"text-success"},[_vm._v("-"+_vm._s(_vm.formatMoneyAmount(_vm.getCell(product.id, combo).discount)))])]),_vm._v(" "),_c('div',{staticClass:"discount-row discount-row--bold"},[_c('span',{staticClass:"discount-label"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.discountedPrice')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.getCell(product.id, combo).discounted_price)))])]),_vm._v(" "),(_vm.getCell(product.id, combo).pricing_type)?_c('div',{staticClass:"discount-row text-muted"},[_c('small',[_vm._v(_vm._s(_vm.getCell(product.id, combo).pricing_type === 'catalog' ? _vm.$t('discountCampaigns.pricingCatalog') : _vm.$t('discountCampaigns.pricingProfile')))])]):_vm._e(),_vm._v(" "),(_vm.getCell(product.id, combo).number_of_units != null)?_c('div',{staticClass:"discount-row"},[_c('span',{staticClass:"discount-label"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.cap')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getCell(product.id, combo).number_of_units))])]):_vm._e(),_vm._v(" "),(_vm.showUnitsSold)?_c('div',{staticClass:"discount-row"},[_c('span',{staticClass:"discount-label"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.unitsSold')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getCell(product.id, combo).units_sold || 0))])]):_vm._e()]):_c('div',{staticClass:"text-muted text-center"},[_vm._v("—")])])})],2)}))])])]):_c('div',{staticClass:"text-center py-4 text-muted"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.noData')))])]),_vm._v(" "),(_vm.pagination && _vm.pagination.totalRecords > 0)?_c('div',{staticClass:"pagination-wrapper"},[_c('el-pagination',{staticStyle:{"margin-top":"0","text-align":"right","width":"100%"},attrs:{"layout":"prev, pager, next","total":_vm.pagination.totalRecords,"page-size":_vm.pagination.perPage,"current-page":_vm.pagination.page},on:{"current-change":function($event){_vm.$emit('page-change', $event)}}})],1):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ceu5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row reports"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{staticClass:"row settings-tabs full-height-tabs",attrs:{"type":"tabs","value":_vm.selectedTab,"direction":"vertical"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{attrs:{"title":_vm.$t('reports.salesReport')}},[_c('reports-sales',{attrs:{"isReports":_vm.isReports}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.salesReportBeta')}},[_c('reports-sales-beta',{attrs:{"isSalesReportBeta":_vm.isSalesReportBeta}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.paymentTypes')}},[_c('sales-payment-method',{attrs:{"isSalesPaymentMethod":_vm.isSalesPaymentMethod}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.productsSalesReport2')}},[_c('sales-products',{attrs:{"isSalesProducts":_vm.isSalesProducts}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.productSaleTrendsReport')}},[_c('sales-products-trend',{attrs:{"isSalesProductsTrend":_vm.isSalesProductsTrend}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.salesTrendsReport')}},[_c('sales-trend',{attrs:{"isSalesTrend":_vm.isSalesTrend}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.topProductsReport')}},[_c('top-products',{attrs:{"isTopProducts":_vm.isTopProducts}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.topCategoriesReport')}},[_c('top-categories',{attrs:{"isTopCategories":_vm.isTopCategories}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.orderFromReport')}},[_c('order-from',{attrs:{"isOrderFrom":_vm.isOrderFrom}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.operatorSalesReport')}},[_c('operator-sales',{attrs:{"isOperatorSales":_vm.isOperatorSales}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.waiterTipsReport')}},[_c('waiter-tips-report',{attrs:{"isWaiterTips":_vm.isWaiterTips}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.stornoReport')}},[_c('storno',{attrs:{"isStorno":_vm.isStorno}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.dashboardReport')}},[_c('dashboard-report',{attrs:{"isDashboardReport":_vm.isDashboardReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.productsAndOptionsReport')}},[_c('products-and-options-report',{attrs:{"isProductsAndOptions":_vm.isProductsAndOptions}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.preordersItems')}},[_c('preorders-items',{attrs:{"isPreordersItems":_vm.isPreordersItems}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.fiscalZReport')}},[_c('fiscal-z-report',{attrs:{"isMasterReport":_vm.isFiscalZReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.mixReport')}},[_c('mixed-report',{attrs:{"isMixedReport":_vm.isMixedReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.posOrderActionsReport')}},[_c('pos-order-actions-report',{attrs:{"isPosOrderActionsReport":_vm.isPosOrderActionsReport}})],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left title",attrs:{"title":_vm.$t('reports.custom'),"disabled":""}}),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.masterReport')}},[_c('master-report',{attrs:{"isMasterReport":_vm.isMasterReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.masterReportBeta')}},[_c('master-report',{attrs:{"isMasterReport":_vm.isMasterReportBeta,"useFromColumns":true}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.tableOpenOrders')}},[_c('table-open-order-report',{attrs:{"isTableOpenOrderReport":_vm.isTableOpenOrderReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.customerLifetimeValueReport')}},[_c('customer-lifetime-value',{attrs:{"isCustomerLifetimeValueReport":_vm.isCustomerLifetimeValueReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.labelEvolution')}},[_c('label-evolution',{attrs:{"isLabelEvolution":_vm.isLabelEvolution}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.donationCampaignsReport'),"id":"donationCampaignsReport"}},[_c('donation-campaigns-report',{attrs:{"isDonationCampaignsReport":_vm.isDonationCampaignsReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.loyaltyStoreReport'),"id":"loyaltyStoreReport"}},[_c('loyalty-store-report',{attrs:{"isLoyaltyStoreReport":_vm.isLoyaltyStoreReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.challengeCampaignsReport'),"id":"challengeCampaignsReport"}},[_c('challenge-campaigns-report',{attrs:{"isChallengeCampaignsReport":_vm.isChallengeCampaignsReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.spinningWheelReport'),"id":"spinningWheelReport"}},[_c('spinning-wheel-report',{attrs:{"isSpinningWheelReport":_vm.isSpinningWheelReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.referralProgramReport')}},[_c('referral-program-report',{attrs:{"isReferralProgramReport":_vm.isReferralProgramReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.raffleCampaignsReport')}},[_c('raffle-campaigns-report',{attrs:{"isRaffleCampaignsReport":_vm.isRaffleCampaignsReport}})],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left title",attrs:{"title":_vm.$t('reports.old'),"disabled":""}}),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.trends')}},[_c('trends',{attrs:{"isTrends":_vm.isTrends}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.accountingReport')}},[_c('accounting-report',{attrs:{"isReports":_vm.isReports}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.clientsWOrders')}},[_c('clients',{attrs:{"isClients":_vm.isClients}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.productsSalesReport')}},[_c('products-sales',{attrs:{"isProductSales":_vm.isProductSales}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.orderStatus'),"id":"orderStatus"}},[_c('order-status',{attrs:{"isOrderStatus":_vm.isOrderStatus}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.pdfRaport'),"id":"pdfRaport"}},[_c('pdf-raport',{attrs:{"isPdfRaport":_vm.isPdfRaport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.loyaltyPoints'),"id":"loyaltyPoints"}},[_c('loyalty-points',{attrs:{"isLoyaltyPoints":_vm.isLoyaltyPoints}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.donationReport'),"id":"donationReport"}},[_c('donation-report',{attrs:{"isDonationReport":_vm.isDonationReport}})],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.ocr'),"id":"ocr"}},[(_vm.isOCR)?_c('ocr'):_vm._e()],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.stockMovements'),"id":"stockMovements"}},[(_vm.isStockMovements)?_c('stock-movements'):_vm._e()],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.reorderPopupResponses'),"id":"reorderPopupResponses"}},[(_vm.isReorderPopupResponses)?_c('reorder-popup-responses'):_vm._e()],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.wallet'),"id":"wallet"}},[(_vm.isWallet)?_c('wallet'):_vm._e()],1),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.reportRequestTab'),"id":"reportRequest"}},[(_vm.isReportRequest)?_c('report-request',{ref:"reportRequest"}):_vm._e()],1),_vm._v(" "),(_vm.hasCharismaLocation)?_c('v-tab',{staticClass:"text-left title",attrs:{"title":"Charisma","disabled":""}}):_vm._e(),_vm._v(" "),(_vm.hasCharismaLocation)?_c('v-tab',{attrs:{"title":_vm.$t('reports.charismaReport'),"id":"charismaReport"}},[(_vm.isCharismaReport)?_c('charisma-report',{attrs:{"isCharismaReport":_vm.isCharismaReport}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasCharismaLocation)?_c('v-tab',{attrs:{"title":_vm.$t('reports.charismaLocationReceipt'),"id":"charismaLocationReceipt"}},[(_vm.isCharismaLocationReceiptReport)?_c('charisma-location-receipt',{attrs:{"isCharismaLocationReceiptReport":_vm.isCharismaLocationReceiptReport}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasNexusLocation)?_c('v-tab',{staticClass:"text-left title",attrs:{"title":"Nexus","disabled":""}}):_vm._e(),_vm._v(" "),(_vm.hasNexusLocation)?_c('v-tab',{attrs:{"title":_vm.$t('reports.nexusReport'),"id":"nexusReport"}},[(_vm.isNexusReport)?_c('nexus-report',{attrs:{"isNexusReport":_vm.isNexusReport}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-tab',{attrs:{"title":_vm.$t('reports.clientLoyalty'),"id":"clientLoyalty","icon":"icon-report icon-report-clients"}},[_c('client-points',{attrs:{"isClientPoints":_vm.isClientPoints}})],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left title",attrs:{"title":"Rapoarte exportabile","disabled":""}}),_vm._v(" "),_c('v-tab',{attrs:{"title":"Export CSV","id":"exportableReports"}},[(_vm.isExportableReports)?_c('exportable-reports',{on:{"show-requests":_vm.showReportRequests}}):_vm._e()],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CgSl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CmBs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      vatNumber: null,
      selectedLocation: null
    };
  },

  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.tableData = [];
      this.totalItems = 0;
      this.currentPage = 1;
    }
  },
  computed: {
    showAvizColumn: function showAvizColumn() {
      return this.tableData.some(function (row) {
        return row.externalDocIds && row.externalDocIds.aviz;
      });
    },
    showNirColumn: function showNirColumn() {
      return this.tableData.some(function (row) {
        return row.externalDocIds && row.externalDocIds.nir;
      });
    },
    showInvoiceColumn: function showInvoiceColumn() {
      return this.tableData.some(function (row) {
        return row.externalDocIds && row.externalDocIds.invoice;
      });
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    var _this = this;

    this.$bus.$on('refresh', function () {
      _this.onSearch();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh');
  },

  methods: {
    onSearch: function onSearch() {
      if (!this.selectedLocation || Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        });
        return;
      }

      var locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation];

      this.getMyOrder(locations);
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getMyOrder(this.selectedLocation, this.currentPage, this.pageSize);
    },
    hasBonTransfer: function hasBonTransfer(order) {
      if (!order.externalDocIds) return false;

      if (Array.isArray(order.externalDocIds)) {
        return order.externalDocIds.some(function (doc) {
          return 'bonTransfer' in doc;
        });
      } else if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(order.externalDocIds) === 'object') {
        return 'bonTransfer' in order.externalDocIds;
      }

      return false;
    },
    getBonTransferNumber: function getBonTransferNumber(order) {
      if (!order.externalDocIds) return null;

      if (Array.isArray(order.externalDocIds)) {
        var doc = order.externalDocIds.find(function (doc) {
          return 'bonTransfer' in doc;
        });
        return doc ? doc.bonTransfer : null;
      } else if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(order.externalDocIds) === 'object') {
        return order.externalDocIds.bonTransfer || null;
      }

      return null;
    },
    getStatusStyle: function getStatusStyle(status) {
      switch (status.toLowerCase()) {
        case 'sent':
          return {
            backgroundColor: '#007bff',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
        case 'processed':
          return {
            backgroundColor: '#fd7e14',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
        case 'validat':
          return {
            backgroundColor: '#28a745',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
        case 'facturat':
          return {
            backgroundColor: '#6f42c1',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
        case 'new':
          return {
            backgroundColor: '#6c757d',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
        default:
          return {
            backgroundColor: '#343a40',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
      }
    },
    addMyOrder: function addMyOrder() {
      this.$router.push('/management/my-orders-suppliers/add');
    },
    editMyOrder: function editMyOrder(row) {
      this.$router.push('/management/my-orders-suppliers/edit/' + row.series + '/' + row.documentNumber);
    },
    sendOrder: function sendOrder(row) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var orderToSend, response, data, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                orderToSend = {
                  status: 'sent',
                  products: row.products || [],
                  vatNumber: row.vatNumber,
                  externalCompanyId: row.externalCompanyId,
                  supplierVatNumber: row.supplierVatNumber,
                  supplierExternalLocationId: row.supplierExternalLocationId,
                  externalLocationId: row.externalLocationId,
                  gestiune: row.gestiune,
                  series: row.series,
                  number: row.documentNumber,
                  date: row.date
                };
                _context.next = 4;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/order', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(orderToSend)
                });

              case 4:
                response = _context.sent;
                _context.next = 7;
                return response.json();

              case 7:
                data = _context.sent;

                if (!response.ok) {
                  _context.next = 14;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Comanda a fost trimisă cu succes!',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                });

                index = _this2.tableData.findIndex(function (o) {
                  return o._id === row._id;
                });

                if (index !== -1) {
                  _this2.$set(_this2.tableData, index, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.tableData[index], { status: 'sent' }));
                }
                _context.next = 15;
                break;

              case 14:
                throw new Error(data.message || 'Eroare la trimiterea comenzii');

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](0);

                console.error('Eroare sendOrder:', _context.t0);
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o problemă la trimiterea comenzii.',
                  icon: 'error',
                  timer: 1500,
                  buttons: false
                });

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 17]]);
      }))();
    },
    reception: function reception(row) {
      this.$router.push({
        path: '/management/my-orders-suppliers/edit/' + row._id,
        query: {
          series: row.series,
          number: row.documentNumber,
          isReception: true
        }
      });
    },
    validateOrder: function validateOrder(row) {
      this.$router.push({
        path: '/management/my-orders-suppliers/edit/' + row._id,
        query: {
          series: row.series,
          number: row.documentNumber,
          isValidate: true
        }
      });
    },
    generateNir: function generateNir(row) {
      console.log('Generating NIR for order:', row);
      this.$router.push({
        path: '/management/entries/add',
        query: {
          series: row.series,
          number: row.documentNumber,
          isNir: true
        }
      });
    },
    getMyOrder: function getMyOrder() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this3 = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, ids, allLocations, _ids, response, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = true;

                params = new URLSearchParams();

                params.append('externalCompanyId', _this3.companyID);

                params.append('page', page);
                params.append('limit', pageSize);

                if (location) {
                  if (Array.isArray(location)) {
                    ids = location.map(function (l) {
                      return l.true_id;
                    }).filter(Boolean);

                    ids.forEach(function (id) {
                      return params.append('externalLocationId', id);
                    });
                  } else if (location.id && location.true_id) {
                    params.append('externalLocationId', location.true_id);
                  }
                } else {
                  allLocations = _this3.groupedLocations.flatMap(function (group) {
                    return group.locations;
                  });
                  _ids = allLocations.map(function (l) {
                    return l.true_id;
                  }).filter(Boolean);

                  _ids.forEach(function (id) {
                    return params.append('externalLocationId', id);
                  });
                }

                clearTimeout(_this3.loadingTimeout);
                _this3.loadingTimeout = setTimeout(function () {
                  _this3.loading = true;
                }, 100);

                _context2.prev = 8;
                _context2.next = 11;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/orders?' + params.toString(), {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 11:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 14;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 14:
                _context2.next = 16;
                return response.json();

              case 16:
                data = _context2.sent;


                if (Array.isArray(data.comenzi)) {
                  clearTimeout(_this3.loadingTimeout);
                  _this3.loading = false;

                  _this3.totalItems = data.total || 0;
                  _this3.currentPage = data.currentPage || page;
                  _this3.pageSize = data.pageSize || pageSize;

                  _this3.tableData = data.comenzi.map(function (order) {
                    return {
                      _id: order._id,
                      series: order.series,
                      documentNumber: order.number,
                      status: order.status,
                      date: order.date,
                      externalLocationId: order.externalLocationId,
                      supplierVatNumber: order.supplierVatNumber,
                      supplierExternalLocationId: order.supplierExternalLocationId,
                      gestiune: order.gestiune,
                      products: order.products || [],
                      externalDocIds: order.externalDocIds || {},
                      vatNumber: order.vatNumber,
                      externalCompanyId: order.externalCompanyId
                    };
                  });
                } else {
                  console.error('No valid orders found.');
                  _this3.tableData = [];
                }
                _context2.next = 25;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](8);

                clearTimeout(_this3.loadingTimeout);
                _this3.loading = false;

                console.error('Error fetching orders:', _context2.t0);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[8, 20]]);
      }))();
    }
  }
});

/***/ }),

/***/ "CnGb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"report-filters"},[_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clients.search),expression:"clients.search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('reports.searchFilter')},domProps:{"value":(_vm.clients.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.clients, "search", $event.target.value)}}})]),_vm._v(" "),(_vm.showLocations)?_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.clients.location),expression:"clients.location"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.clients, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.true_id}},[_vm._v(_vm._s(loc.name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clients.minOrder),expression:"clients.minOrder"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('reports.minOrders')},domProps:{"value":(_vm.clients.minOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.clients, "minOrder", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clients.maxOrder),expression:"clients.maxOrder"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('reports.maxOrders')},domProps:{"value":(_vm.clients.maxOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.clients, "maxOrder", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clients.minAmount),expression:"clients.minAmount"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('reports.minAmount')},domProps:{"value":(_vm.clients.minAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.clients, "minAmount", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{staticClass:"mid",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.clients.valid),callback:function ($$v) {_vm.$set(_vm.clients, "valid", $$v)},expression:"clients.valid"}})],1),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":function($event){_vm.getClients(null)}}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('download-excel',{staticClass:"btn btn-icon mar-rt-40 btn-xls",attrs:{"disabled":_vm.clientsTableData.length == 0,"fetch":_vm.clientsExportData,"fields":_vm.jsonFields,"name":_vm.export_name,"before-generate":_vm.startDownload,"before-finish":_vm.finishDownload}},[_vm._v("\n              "+_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])],1),_vm._v(" "),_c('p')])]),_vm._v(" "),_c('div',{staticClass:"card-content total-pagination pad-15"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.clientsTableData,"search-def":{ show: false },"total":_vm.totalClients,"pagination-props":_vm.paginationProps,"table-props":_vm.tableOptions},on:{"query-change":_vm.paginationChanged,"row-click":_vm.goToRecordCustomer}},[_c('el-table-column',{attrs:{"min-width":80,"sortable":"custom","prop":"location_name","label":_vm.$t('reports.location')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"custom","prop":"name","label":_vm.$t('reports.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(props.row.firstname)+" "+_vm._s(props.row.lastname)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"sortable":"custom","prop":"email","label":_vm.$t('reports.email')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"sortable":"custom","prop":"phone","label":_vm.$t('reports.phone')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"sortable":"custom","prop":"gender","label":_vm.$t('reports.gender')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"sortable":"custom","prop":"age","label":_vm.$t('reports.age')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"custom","prop":"sales","label":_vm.$t('reports.totalAmount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.formatMoneyAmount(props.row.sales))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"sortable":"custom","prop":"orders_count","label":_vm.$t('reports.ordersNumber')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(props.row.orders_count)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"prop":"label","label":_vm.$t('reports.label')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',{domProps:{"innerHTML":_vm._s(_vm.getUserLabel(_vm.labels, props.row.last_sales, props.row.last_orders, _vm.labelingPrimaryOption))}})]}}])}),_vm._v(" "),(_vm.donation_points_enabled)?_c('el-table-column',{attrs:{"min-width":80,"prop":"donation_points","label":_vm.$t('reports.donation_points')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.hasOwnProperty('donation_points'))?_c('b',[_vm._v(_vm._s(props.row.donation_points))]):_vm._e()]}}])}):_vm._e()],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CpwN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tips_vue__ = __webpack_require__("/goY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b3024a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tips_vue__ = __webpack_require__("4f/N");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tips_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b3024a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tips_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__("HRUz");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');

    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
    this.isMinimized = !this.isMinimized;
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "CtxG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cw38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('element-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CwYU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row hs-sections-page"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12 mb-10"},[_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-info mar-bt-20 mar-rt-10",attrs:{"disabled":_vm.exporting},on:{"click":_vm.exportNewsletter}},[_c('i',{staticClass:"fa fa-download"}),_vm._v("\n              Exportă newsletter\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn add mar-bt-20",on:{"click":_vm.openCreate}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"hs-table-wrap"},[_c('table',{ref:"sortableTable",staticClass:"table width-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"5%"}}),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.title')))]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.typeColumnLabel))]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.contentColumnLabel))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.status')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.actions')))]),_vm._v(" "),_c('th',{attrs:{"width":"15%"}})])]),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody'},on:{"end":_vm.onReorder},model:{value:(_vm.sections),callback:function ($$v) {_vm.sections=$$v},expression:"sections"}},[_vm._l((_vm.sections),function(item,index){return [_c('tr',{key:item.id,staticClass:"sortableRow"},[_c('td',[_c('i',{staticClass:"fa fa-arrows sortHandle",staticStyle:{"cursor":"move","color":"#7C8DB5"}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"hs-title-cell",attrs:{"title":item.title}},[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.typeLabel(item.section_type)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.contentSummary(item)))]),_vm._v(" "),_c('td',[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(item)}},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}})],1),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.handleDelete(index, item, $event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])]),_vm._v(" "),_c('td',{staticClass:"edit-icon-pointer",on:{"click":function($event){_vm.openEdit(item)}}},[_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                    ")])])])]})],2)],1)]),_vm._v(" "),(!_vm.loading && _vm.sections.length === 0)?_c('p',{staticClass:"text-center mar-tp-20"},[_vm._v("\n            Nicio secțiune adăugată încă.\n          ")]):_vm._e()]),_vm._v(" "),_c('vmodal',{staticClass:"sectionModal",attrs:{"name":"sectionModal","width":"95%","maxWidth":1300,"minWidth":300,"height":"auto","scrollable":true,"adaptive":true},on:{"opened":_vm.onModalOpened}},[_c('div',{staticClass:"header border-bottom"},[_c('h4',[_vm._v(_vm._s(_vm.form.id ? _vm.$t('general.edit') : _vm.$t('general.add'))+" — "+_vm._s(_vm.typeLabel(_vm.form.section_type)))])]),_vm._v(" "),_c('div',{staticClass:"content-group"},[_c('div',{staticClass:"content_scrool"},[(!_vm.form.id)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.typeColumnLabel))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.section_type),expression:"form.section_type",modifiers:{"number":true}}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.form, "section_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.availableTypes),function(t){return _c('option',{key:t.value,domProps:{"value":t.value}},[_vm._v(_vm._s(t.label))])}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.title'))+" "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.title),expression:"form.title"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.TITLE_MAX},domProps:{"value":(_vm.form.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "title", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted pull-right"},[_vm._v(_vm._s((_vm.form.title || '').length)+" / "+_vm._s(_vm.TITLE_MAX))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descriere "),_c('small',{staticClass:"text-muted"},[_vm._v("(opțional)")])]),_vm._v(" "),_c('wysiwyg',{model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1),_vm._v(" "),(_vm.form.section_type === 1)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.typeLabel(1))+" (minim "+_vm._s(_vm.MIN_IMAGES)+", maxim "+_vm._s(_vm.MAX_ITEMS)+") "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('el-upload',{attrs:{"action":"","multiple":"","list-type":"picture-card","accept":".jpg,.jpeg,.png","file-list":_vm.form.imagelist,"limit":_vm.MAX_ITEMS,"auto-upload":false,"on-change":_vm.handleImagesChange,"on-remove":_vm.handleImagesRemove,"on-exceed":_vm.handleExceed}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})])],1):_vm._e(),_vm._v(" "),(_vm.form.section_type === 2)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Poze (maxim "+_vm._s(_vm.MAX_ITEMS)+")")]),_vm._v(" "),_c('el-upload',{attrs:{"action":"","multiple":"","list-type":"picture-card","accept":".jpg,.jpeg,.png","file-list":_vm.form.imagelist,"limit":_vm.MAX_ITEMS,"auto-upload":false,"on-change":_vm.handleImagesChange,"on-remove":_vm.handleImagesRemove,"on-exceed":_vm.handleExceed}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})])],1):_vm._e(),_vm._v(" "),(_vm.form.section_type === 2)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cum arată pozele")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.image_fit),expression:"form.image_fit"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "image_fit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"cover"}},[_vm._v("Cover — umple tot spațiul (poate tăia din poză)")]),_vm._v(" "),_c('option',{attrs:{"value":"contain"}},[_vm._v("Contain — încape toată poza")])])]):_vm._e(),_vm._v(" "),(_vm.form.section_type === 3)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.typeLabel(3))+" (max "+_vm._s(_vm.MAX_ITEMS)+")")]),_vm._v(" "),_c('el-select',{staticClass:"hs-product-select",staticStyle:{"width":"100%"},attrs:{"multiple":"","filterable":"","remote":"","reserve-keyword":"","popper-class":"hs-product-dropdown","remote-method":_vm.searchProducts,"loading":_vm.productLoading,"multiple-limit":_vm.MAX_ITEMS,"placeholder":_vm.$t('marketingOffers.pickProd')},on:{"visible-change":_vm.onProductDropdownVisible},model:{value:(_vm.form.selectedProducts),callback:function ($$v) {_vm.$set(_vm.form, "selectedProducts", $$v)},expression:"form.selectedProducts"}},_vm._l((_vm.products),function(p){return _c('el-option',{key:p.id,attrs:{"label":p.name,"value":p.id}})})),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Se afișează primele "+_vm._s(_vm.PRODUCTS_PER_PAGE)+" produse; scrie pentru a căuta altele.")])],1):_vm._e(),_vm._v(" "),(_vm.form.section_type === 4)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.typeLabel(4))+" (max "+_vm._s(_vm.MAX_ITEMS)+")")]),_vm._v(" "),_vm._l((_vm.form.testimonials),function(t,tIndex){return _c('div',{key:'t' + tIndex,staticClass:"item-box"},[_c('div',{staticClass:"item-box__header"},[_c('span',[_vm._v("#"+_vm._s(tIndex + 1))]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-icon",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.removeTestimonial(tIndex)}}},[_c('i',{staticClass:"ti-close"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.image')))]),_vm._v(" "),_c('el-upload',{attrs:{"action":"","list-type":"picture-card","accept":".jpg,.jpeg,.png","file-list":t.imagelist,"limit":1,"auto-upload":false,"on-change":function (file, fileList) { return _vm.handleTestimonialImg(tIndex, file, fileList); },"on-remove":function (file, fileList) { return _vm.handleTestimonialRemove(tIndex, file, fileList); },"on-exceed":_vm.handleExceed}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Locația")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(t.title),expression:"t.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(t.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(t, "title", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Autor")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(t.author),expression:"t.author"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(t.author)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(t, "author", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Notă "),_c('small',{staticClass:"text-muted"},[_vm._v("(0 - 5, ex: 4.8)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(t.rating),expression:"t.rating"}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"5","step":"0.1","placeholder":"ex: 4.8"},domProps:{"value":(t.rating)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(t, "rating", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Review")]),_vm._v(" "),_c('wysiwyg',{model:{value:(t.description),callback:function ($$v) {_vm.$set(t, "description", $$v)},expression:"t.description"}})],1)])])])}),_vm._v(" "),(_vm.form.testimonials.length < _vm.MAX_ITEMS)?_c('button',{staticClass:"btn btn-info btn-icon add mar-tp-10",attrs:{"type":"button"},on:{"click":_vm.addTestimonial}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.add'))+"\n                ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.form.section_type === 5)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.typeLabel(5))+" (max "+_vm._s(_vm.MAX_ITEMS)+")")]),_vm._v(" "),_vm._l((_vm.form.qas),function(q,qIndex){return _c('div',{key:'q' + qIndex,staticClass:"item-box"},[_c('div',{staticClass:"item-box__header"},[_c('span',[_vm._v("#"+_vm._s(qIndex + 1))]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-icon",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.removeQa(qIndex)}}},[_c('i',{staticClass:"ti-close"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.questionLabel)+" "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(q.question),expression:"q.question"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(q.question)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(q, "question", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.answerLabel)+" "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('wysiwyg',{model:{value:(q.answer),callback:function ($$v) {_vm.$set(q, "answer", $$v)},expression:"q.answer"}})],1)])}),_vm._v(" "),(_vm.form.qas.length < _vm.MAX_ITEMS)?_c('button',{staticClass:"btn btn-info btn-icon add mar-tp-10",attrs:{"type":"button"},on:{"click":_vm.addQa}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.add'))+"\n                ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.form.section_type === 6)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.image')))]),_vm._v(" "),_c('el-upload',{attrs:{"action":"","list-type":"picture-card","accept":".jpg,.jpeg,.png","file-list":_vm.form.imagelist,"limit":1,"auto-upload":false,"on-change":_vm.handleImagesChange,"on-remove":_vm.handleImagesRemove,"on-exceed":_vm.handleExceed}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})]),_vm._v(" "),_c('p',{staticClass:"text-muted mar-tp-10"},[_vm._v("\n                  Emailurile completate de clienți vor apărea la export.\n                ")])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"sectionModal__footer border-top",staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('button',{staticClass:"btn btn-default mar-rt-10",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_vm._v("\n              "+_vm._s(_vm.$t('general.cancel'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon save",attrs:{"type":"button","disabled":_vm.saving,"title":_vm.$t('general.save')},on:{"click":_vm.save}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n            ")])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cx4m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cyb2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+CL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryGoogleMaps_vue__ = __webpack_require__("G8fY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25fb4ae6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryGoogleMaps_vue__ = __webpack_require__("sT6j");
function injectStyle (ssrContext) {
  __webpack_require__("VAZx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25fb4ae6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryGoogleMaps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25fb4ae6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryGoogleMaps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D+R4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+p6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('kds-section-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D/d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonProductAdd_vue__ = __webpack_require__("Ia+4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_901edcb4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonProductAdd_vue__ = __webpack_require__("pg+z");
function injectStyle (ssrContext) {
  __webpack_require__("o8/5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-901edcb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonProductAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_901edcb4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonProductAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D0LU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('location-groups-form',{on:{"on-submit":_vm.onSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D117":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");










/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a),
  props: {
    isWaiterTips: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isWaiterTips: {
      immediate: true,
      handler: function handler(isActive) {
        if (isActive) {
          this.verifyUserLocations();
          this.getPosUsers();
          this.getDrivers();
          this.getOrders();
        }
      }
    },
    selectedWaiters: function selectedWaiters() {
      this.currentPage = 1;
    },
    reportMode: function reportMode() {
      this.selectedWaiters = [];
      this.currentPage = 1;
      if (this.isWaiterTips) {
        this.getOrders();
      }
    }
  },
  computed: {
    isDeliveryMode: function isDeliveryMode() {
      return this.reportMode === 'delivery';
    },
    personFilterLabel: function personFilterLabel() {
      return this.isDeliveryMode ? this.$t('reports.waiterTipsSelectDrivers') : this.$t('reports.waiterTipsSelectWaiters');
    },
    waiterOptions: function waiterOptions() {
      if (this.isDeliveryMode) {
        if (this.waiters.length) {
          return this.waiters.map(function (waiter) {
            return {
              value: waiter.waiter_id,
              label: waiter.waiter_name
            };
          });
        }
        return this.rawDrivers.map(function (user) {
          return {
            value: user.id,
            label: user.firstname + ' ' + user.lastname
          };
        });
      }

      if (this.waiters.length) {
        return this.waiters.map(function (waiter) {
          return {
            value: waiter.waiter_id,
            label: waiter.waiter_name
          };
        });
      }
      return this.rawPosUsers.map(function (user) {
        return {
          value: user.id,
          label: user.firstname + ' ' + user.lastname
        };
      });
    },
    selectedWaiterIds: function selectedWaiterIds() {
      if (!this.selectedWaiters || !this.selectedWaiters.length) {
        return [];
      }
      return this.selectedWaiters.map(function (waiter) {
        return String(waiter.value);
      });
    },
    filteredWaiters: function filteredWaiters() {
      var _this = this;

      if (!this.selectedWaiterIds.length) {
        return this.waiters;
      }
      return this.waiters.filter(function (waiter) {
        return _this.selectedWaiterIds.indexOf(String(waiter.waiter_id)) !== -1;
      });
    },
    pagedWaiters: function pagedWaiters() {
      var start = (this.currentPage - 1) * this.pageSize;
      return this.filteredWaiters.slice(start, start + this.pageSize);
    },
    displayedTotals: function displayedTotals() {
      if (!this.selectedWaiterIds.length) {
        return this.totals;
      }
      return this.filteredWaiters.reduce(function (acc, waiter) {
        acc.order_count += Number(waiter.total && waiter.total.order_count || 0);
        acc.total_tips += Number(waiter.total && waiter.total.total_tips || 0);
        return acc;
      }, { order_count: 0, total_tips: 0 });
    },
    zRangeLabel: function zRangeLabel() {
      if (this.zRange.min == null && this.zRange.max == null) {
        return '—';
      }
      if (this.zRange.min === this.zRange.max) {
        return String(this.zRange.min);
      }
      return (this.zRange.min || '—') + ' – ' + (this.zRange.max || '—');
    }
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      loading: false,
      reportMode: 'waiter',
      waiters: [],
      selectedWaiters: [],
      rawPosUsers: [],
      rawDrivers: [],
      currentPage: 1,
      pageSize: 20,
      totals: {
        order_count: 0,
        total_tips: 0
      },
      zRange: {
        min: null,
        max: null
      },
      period: {
        from: '',
        to: ''
      },
      orders: {
        valid: [__WEBPACK_IMPORTED_MODULE_5_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')],
        location: ''
      },
      locations: [],
      showLocations: false,
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(12, 'months').startOf('day') || date > __WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf('day');
        }
      }
    };
  },

  methods: {
    paymentLabel: function paymentLabel(type) {
      if (!type) return '';
      var key = 'paymentTypes.' + type;
      return this.$te(key) ? this.$t(key) : type;
    },
    formatTips: function formatTips(amount) {
      var value = Number(amount || 0).toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    normalizePeople: function normalizePeople(responseData) {
      if (this.isDeliveryMode) {
        return (responseData.drivers || []).map(function (driver) {
          return {
            waiter_id: driver.driver_id,
            waiter_name: driver.driver_name,
            payment_methods: driver.payment_methods || [],
            total: driver.total || { order_count: 0, total_tips: 0 }
          };
        });
      }
      return responseData.waiters || [];
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    verifyUserLocations: function verifyUserLocations() {
      var companyData = this.$session.get('selectedCompanyData') || {};
      var details = companyData.locations_details || [];
      this.locations = details.map(function (location) {
        return {
          id: location.true_id != null ? location.true_id : location.id,
          name: location.name
        };
      }).filter(function (location) {
        return location.id != null;
      });

      if (!this.isOwner()) {
        var allowedLocations = [];
        try {
          allowedLocations = JSON.parse(this.$session.get('userDataLocations') || '[]') || [];
        } catch (e) {
          allowedLocations = [];
        }
        if (allowedLocations.length === 0) {
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.some(function (id) {
            return String(id) === String(el.id);
          });
        });
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    getRequestData: function getRequestData() {
      this.changeValidFrom();
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: this.orders.valid[0],
        to_date: this.orders.valid[1],
        start_date: this.orders.valid[0] + ' ' + this.valid_from + ':00',
        end_date: this.orders.valid[1] + ' ' + this.valid_to + ':59'
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.isDeliveryMode) {
        data.mode = 'delivery';
        if (this.selectedWaiterIds.length) {
          data.driver_ids = this.selectedWaiterIds;
        }
      } else if (this.selectedWaiterIds.length) {
        data.waiter_ids = this.selectedWaiterIds;
      }

      return data;
    },
    getOrders: function getOrders() {
      var _this2 = this;

      if (!this.isWaiterTips) {
        return;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/waiter-tips', 'GET', this.getRequestData(), function (response) {
        if (response.status && response.data) {
          _this2.waiters = _this2.normalizePeople(response.data);
          _this2.totals = response.data.total || { order_count: 0, total_tips: 0 };
          _this2.zRange = response.data.z_range || { min: null, max: null };
          _this2.period = response.data.period || { from: '', to: '' };
          _this2.currentPage = 1;
        } else {
          _this2.waiters = [];
          _this2.totals = { order_count: 0, total_tips: 0 };
          _this2.zRange = { min: null, max: null };
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this2.$t('validations.wentWrong'), 'error');
        }
        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    exportData: function exportData() {
      var _this3 = this;

      this.loading = true;
      this.apiRequest('/reports/v2/waiter-tips-download', 'GET', this.getRequestData(), function (response) {
        if (response.status === true && response.data) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this3.$t('validations.wentWrong'), 'error');
        }
        _this3.loading = false;
      });
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
    },
    getPosUsers: function getPosUsers() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this4.rawPosUsers = response.data.pos_user || [];
        }
      });
    },
    getDrivers: function getDrivers() {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/reports/drivers-list', 'GET', data, function (response) {
        if (response.status) {
          _this5.rawDrivers = response.data.drivers || response.data || [];
        }
      });
    }
  }
});

/***/ }),

/***/ "D1gf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D2O9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row loyalty-store-report"},[_c('div',{staticClass:"col-xl-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-start","gap":"10px","flex-wrap":"wrap"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px","align-items":"flex-end","flex":"1 1 auto"}},[_c('div',{staticClass:"form-group",staticStyle:{"margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('reports.dateInterval')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"260px"},attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","size":"small"},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1),_vm._v(" "),(_vm.locations.length)?_c('div',{staticClass:"form-group",staticStyle:{"margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"200px"},attrs:{"clearable":"","filterable":"","size":"small","placeholder":_vm.$t('general.select')},model:{value:(_vm.locationId),callback:function ($$v) {_vm.locationId=$$v},expression:"locationId"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:loc.id,attrs:{"label":loc.name,"value":loc.id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin":"0","flex":"0 0 180px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('loyaltyStore.user')))]),_vm._v(" "),_c('el-input',{attrs:{"size":"small","clearable":"","placeholder":_vm.$t('customers.id')},model:{value:(_vm.userId),callback:function ($$v) {_vm.userId=$$v},expression:"userId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.applyFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"data-table",staticStyle:{"margin-top":"20px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.onRowClick}},[_c('el-table-column',{attrs:{"prop":"reward_id","label":_vm.$t('customers.id'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.reward'),"min-width":"160","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.reward || props.row.reward_name || '—')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.rewardType'),"width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.reward_type === 'gift_card' ? _vm.$t('loyaltyStore.typeGiftCard') : _vm.$t('loyaltyStore.typeProduct'))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.campaign'),"min-width":"140","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.campaign || props.row.campaign_name || '—')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.pointsCost'),"width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.loyalty_points_cost)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.timesSold'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.times_sold)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.totalPointsSpent'),"width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.total_loyalty_points_spent)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.totalGiftValue'),"width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.reward_type === 'gift_card')?_c('span',[_vm._v("\n                  "+_vm._s(parseFloat(props.row.total_gift_card_value_issued || 0).toFixed(2))+" "+_vm._s(_vm.currency)+"\n                ")]):_c('span',[_vm._v("—")])]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D4Y4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D81y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"donation-campaign-orders-report"},[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back banner-back-button",attrs:{"title":_vm.$t('general.back'),"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),(_vm.campaignTitle)?_c('p',{staticClass:"donation-campaign-orders-report__title"},[_vm._v("\n        "+_vm._s(_vm.campaignTitle)+"\n      ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"sales-report mar-to-15"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content total-pagination pad-15"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{ show: false },"total":_vm.total,"pagination-props":_vm.paginationProps,"table-props":_vm.tableOptions},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"min-width":90,"prop":"order_id","label":_vm.$t('reports.orderId'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.order_id || props.row.app_id || '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"label":_vm.$t('donationReport.client')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.getClientName(props.row))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"label":_vm.$t('reports.email')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.email || (props.row.user && props.row.user.email) || props.row.client_email || '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":90,"prop":"amount","label":_vm.$t('donationReport.amount'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(parseFloat(props.row.amount || props.row.donation_amount || 0).toFixed(2))+" "+_vm._s(_vm.currency))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"label":_vm.$t('reports.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.getLocationName(props.row.location_id) || (props.row.location && props.row.location.name) || props.row.location_name || '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"prop":"credited_at","label":_vm.$t('donationReport.date'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatOrderDate(props.row))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":90,"label":_vm.$t('orders.status')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.status || props.row.order_status || '-')+"\n              ")]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DAkQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PurchaseReport_vue__ = __webpack_require__("hr6u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_689c0c95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PurchaseReport_vue__ = __webpack_require__("IlTL");
function injectStyle (ssrContext) {
  __webpack_require__("xhcJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-689c0c95"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PurchaseReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_689c0c95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PurchaseReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DBPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementWasted_vue__ = __webpack_require__("9SsU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65fb2bb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementWasted_vue__ = __webpack_require__("QcHk");
function injectStyle (ssrContext) {
  __webpack_require__("zDrT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65fb2bb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementWasted_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65fb2bb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementWasted_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DCTk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 244.8 284.8"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 244.8 284.8","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t2_SVGID_1_","x":"65.7","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t2_SVGID_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t2_SVGID_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t2_SVGID_3_","d":"M74.7,0h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H74.7\n            c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4S72.3,0,74.7,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t2_SVGID_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t2_SVGID_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M65.7,0h113.4v113.4H65.7V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t2_SVGID_5_","x":"65.7","y":"171.4","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t2_SVGID_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t2_SVGID_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t2_SVGID_7_","d":"M74.7,171.4h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6\n            H74.7c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4C70,172.4,72.3,171.4,74.7,171.4z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t2_SVGID_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t2_SVGID_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M65.7,171.4h113.4v113.4H65.7V171.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t2_SVGID_9_","y":"20","width":"244.8","height":"244.8"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t2_SVGID_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t2_SVGID_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t2_SVGID_11_","d":"M23,20h198.8c12.7,0,23,10.3,23,23v198.8c0,12.7-10.3,23-23,23H23c-12.7,0-23-10.3-23-23V43\n            C0,30.3,10.3,20,23,20z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t2_SVGID_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t2_SVGID_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st7",attrs:{"d":"M0,20h244.8v244.8H0V20z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t2_SVGID_13_","x":"29.3","y":"49.3","width":"186.3","height":"186.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t2_SVGID_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t2_SVGID_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"t2_SVGID_15_","cx":"122.4","cy":"142.4","r":"93.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t2_SVGID_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t2_SVGID_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('path',{staticClass:"st2",attrs:{"d":"M29.3,49.3h186.3v186.3H29.3V49.3z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DCiy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DD47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromosAdd_vue__ = __webpack_require__("9Gda");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d2211da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromosAdd_vue__ = __webpack_require__("oKKX");
function injectStyle (ssrContext) {
  __webpack_require__("ZgTq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromosAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d2211da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromosAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DEpc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"col-md-12 mar-bt-15"},[_c('div',{staticClass:"pull-left mar-rt-10"},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dashboard.selectMethod')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.method),expression:"orders.method"}],staticClass:"form-control inline-auto white",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getOrders()}]}},[_vm._l((_vm.methods),function(method){return [_c('option',{key:method.key,attrs:{"label":_vm.$t('settingCompany.'+ method.key.toLowerCase())},domProps:{"value":method.key}},[_vm._v("\n              "+_vm._s(method.label))])]})],2)]),_vm._v(" "),_c('p',{class:{'pull-left': true, 'sales-rectify-date-picker-padding' : _vm.showMethods}},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions1},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})]),_vm._v(" "),_c('div',{staticClass:"btn btn-icon btn-xls mar-lt-20",attrs:{"title":_vm.$t('reports.export')},on:{"click":_vm.downloadReport}},[_vm._v("\n          "+_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn edit mar-rt-40",attrs:{"type":"submit","title":_vm.$t('general.edit')},on:{"click":_vm.editRows}},[_c('i',{staticClass:"fa fa-pencil",on:{"click":function($event){_vm.editGroup(_vm.group, _vm.idx)}}}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n        ")])])]),_vm._v(" "),(_vm.ordersTableData && _vm.editMode)?_c('div',{staticClass:"col-md-12 custom-border"},[_c('form',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"report-sales custom-border",attrs:{"data":[_vm.useStatuses]}},[_c('el-table-column',{attrs:{"width":120},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(_vm.$t('general.included'))+"\n                ")]}}])}),_vm._v(" "),_vm._l((_vm.useStatuses),function(key,column){return _c('el-table-column',{key:column,attrs:{"label":_vm.$t('ordersStatus.' + column),"min-width":120},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p-checkbox',{key:column,attrs:{"checked":_vm.useStatuses[column]},on:{"input":function($event){{ _vm.useStatuses[column] = !_vm.useStatuses[column] }}}})]}}])})})],2)],1)])])]):_vm._e(),_vm._v(" "),(_vm.average.NEW)?_c('div',{staticClass:"col-md-12 custom-border"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"report-sales custom-border",attrs:{"data":[_vm.average]}},[_c('el-table-column',{attrs:{"width":120},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm.$t('reports.average'))+"\n              ")]}}])}),_vm._v(" "),_vm._l((_vm.statuses),function(column,key){return _c('el-table-column',{key:key,attrs:{"label":_vm.$t('ordersStatus.' + column),"min-width":80},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm.average[column]?[_vm._v("\n                "+_vm._s(_vm.calcTime(_vm.average[column]['avg']))+"\n              ")]:undefined}}])})})],2)],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"ordersTableData",staticClass:"report-sales custom-border",attrs:{"data":_vm.ordersTableData,"search-def":{show: false},"total":_vm.totalRecords,"pagination-props":_vm.paginationProps}},[_c('el-table-column',{attrs:{"width":160,"prop":"token","label":'ID '+_vm.$t('reports.order')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.id)+" / "+_vm._s(scope.row.token)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":200,"prop":"token","label":_vm.$t('reports.checkOrder')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p-checkbox',{key:scope.row.id,staticClass:"checkbox-color",attrs:{"v-model":_vm.excludeOrders,"id":scope.row.id,"checked":""},on:{"input":function($event){_vm.handleCheck(scope.row.id)}}})]}}])}),_vm._v(" "),_vm._l((_vm.statuses),function(column,key){return _c('el-table-column',{key:key,attrs:{"prop":String(key),"label":_vm.$t('ordersStatus.' + column),"min-width":80},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statuses_time && scope.row.statuses_time[column])?_c('p',[_c('span',[_vm._v(_vm._s(_vm.calcTime(scope.row.statuses_time[column])))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popoverWrapper"},[(scope.row.statuses)?_c('p',{directives:[{name:"popover",rawName:"v-popover",value:({ name: (' ' + scope.row.id + column) }),expression:"{ name: (' ' + scope.row.id + column) }"}]},[_vm._v(_vm._s(_vm.separateDate(scope.row.statuses[column])))]):_vm._e(),_vm._v(" "),(_vm.separateDate(scope.row.statuses[column]) != '--')?_c('popover',{staticClass:"bottom",attrs:{"name":(' ' + scope.row.id + column),"event":"hover"}},[_vm._v("\n                    "+_vm._s(_vm.separateDateJustDate(scope.row.statuses[column]))+"\n                  ")]):_vm._e()],1)]}}])})}),_vm._v(" "),_c('el-table-column',{attrs:{"width":120,"prop":"statuses_time","label":_vm.$t('settingCompany.custom')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statuses_time && scope.row.statuses_time['NEW_HOLD_PROCESSING'])?_c('div',{staticClass:"popoverWrapper"},[_c('p',{directives:[{name:"popover",rawName:"v-popover",value:({ name: (' ' + scope.row.id + '_NEW_HOLD_PROCESSING') }),expression:"{ name: (' ' + scope.row.id + '_NEW_HOLD_PROCESSING') }"}]},[_c('span',[_vm._v(_vm._s(_vm.calcTime(scope.row.statuses_time['NEW_HOLD_PROCESSING'])))])]),_vm._v(" "),_c('popover',{staticClass:"bottom",attrs:{"name":(' ' + scope.row.id + '_NEW_HOLD_PROCESSING'),"event":"hover"}},[_vm._v("\n                    "+_vm._s(_vm.$t('ordersStatus.NEW'))+" + "+_vm._s(_vm.$t('ordersStatus.ON_HOLD'))+" + "+_vm._s(_vm.$t('ordersStatus.PROCESSING'))+"\n                  ")])],1):_vm._e(),_vm._v(" "),(scope.row.statuses_time && scope.row.statuses_time['PREPARED_TRANSPORT'])?_c('div',{staticClass:"popoverWrapper"},[_c('p',{directives:[{name:"popover",rawName:"v-popover",value:({ name: (' ' + scope.row.id + '_PREPARED_TRANSPORT') }),expression:"{ name: (' ' + scope.row.id + '_PREPARED_TRANSPORT') }"}]},[_c('span',[_vm._v(_vm._s(_vm.calcTime(scope.row.statuses_time['PREPARED_TRANSPORT'])))])]),_vm._v(" "),_c('popover',{staticClass:"bottom",attrs:{"name":(' ' + scope.row.id + '_PREPARED_TRANSPORT'),"event":"hover"}},[_vm._v("\n                    "+_vm._s(_vm.$t('ordersStatus.PREPARED'))+" + "+_vm._s(_vm.$t('ordersStatus.TRANSPORT'))+"\n                  ")])],1):_vm._e(),_vm._v(" "),(scope.row.statuses_time && scope.row.statuses_time['TOTAL'])?_c('div',{staticClass:"popoverWrapper"},[_c('p',{directives:[{name:"popover",rawName:"v-popover",value:({ name: (' ' + scope.row.id + '_TOTAL') }),expression:"{ name: (' ' + scope.row.id + '_TOTAL') }"}]},[_c('span',[_vm._v(_vm._s(_vm.calcTime(scope.row.statuses_time['TOTAL'])))])]),_vm._v(" "),_c('popover',{staticClass:"bottom",attrs:{"name":(' ' + scope.row.id + '_TOTAL'),"event":"hover"}},[_vm._v("\n                    "+_vm._s(_vm.$t('customers.total'))+"\n                  ")])],1):_vm._e()]}}])})],2)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DI0V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page login-wrapper"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":"","data-image":"static/img/background/background-2.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-box"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.login({ email: _vm.email, password: _vm.password })}}},[_c('div',{attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('error'))+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control ",attrs:{"type":"email","name":"email","placeholder":"Email*"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('email'))+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":"Password*"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('password'))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-orange-purple btn-fill btn-wd ",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("LOG IN")]),_vm._v(" "),_c('div',{staticClass:"forgot"},[_c('router-link',{attrs:{"to":"/recover"}},[_vm._v("\n                          Forgot your password?\n                        ")])],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"full-page-background"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Register")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/admin/overview","tag":"li"}},[_c('a',[_vm._v("Dashboard")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header text-center"},[_c('a',{attrs:{"href":"//taptasty.com"}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo-taptasty.png"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DI3i":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "DKN6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DOX6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",attrs:{"title":_vm.$t('general.delete') + ' ' + _vm.$t('catalogCateg.single')},on:{"click":function($event){$event.preventDefault();_vm.handleDelete('delete')}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card translations-card"},[_c('div',{staticClass:"card-content"},[_c('h5',{staticClass:"translations-title"},[_vm._v(_vm._s(_vm.$t('catalogCateg.name'))+" / "+_vm._s(_vm.$t('catalogCateg.shortDescription')))]),_vm._v(" "),_c('div',{staticClass:"lang-tabs"},[_c('a',{staticClass:"lang-tab",class:[{ active: _vm.currentSubSection === 'l1', errorT: _vm.invalidTabs.includes('l1') }],on:{"click":function($event){$event.preventDefault();_vm.openSubSection('l1')}}},[_vm._v(_vm._s(_vm.language))]),_vm._v(" "),_vm._l((_vm.languages),function(lang){return _c('a',{key:'tab-' + lang.id,staticClass:"lang-tab",class:[{ active: _vm.currentSubSection === lang.id + '-' + lang.short, errorT: _vm.invalidTabs.includes(lang.id + '-' + lang.short) }],on:{"click":function($event){$event.preventDefault();_vm.openSubSection(lang.id + '-' + lang.short)}}},[_vm._v(_vm._s(lang.short))])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSubSection === 'l1'),expression:"currentSubSection === 'l1'"}]},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogCateg.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('name'))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.shortDescription')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"5","name":"description","placeholder":_vm.$t('catalogCateg.shortDescription')},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}})])]),_vm._v(" "),_vm._l((_vm.languages),function(lang){return [(_vm.model.localized_fields && _vm.model.localized_fields[lang.short])?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSubSection === lang.id + '-' + lang.short),expression:"currentSubSection === lang.id + '-' + lang.short"}],key:'box-' + lang.id},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.name'))+" ("+_vm._s(lang.short)+")")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.localized_fields[lang.short].name),expression:"model.localized_fields[lang.short].name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('catalogCateg.name')},domProps:{"value":(_vm.model.localized_fields[lang.short].name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.localized_fields[lang.short], "name", $event.target.value)}}}),_vm._v(" "),(_vm.invalidTabs.includes(lang.id + '-' + lang.short) && (!_vm.model.localized_fields[lang.short].name || !_vm.model.localized_fields[lang.short].name.trim()))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.$t('validations.requiredField'))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.shortDescription'))+" ("+_vm._s(lang.short)+")")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.localized_fields[lang.short].description),expression:"model.localized_fields[lang.short].description"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":_vm.$t('catalogCateg.shortDescription')},domProps:{"value":(_vm.model.localized_fields[lang.short].description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.localized_fields[lang.short], "description", $event.target.value)}}})])]):_vm._e()]})],2)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"section-header"},[_c('h5',{staticClass:"section-header__title"},[_vm._v(_vm._s(_vm.$t('catalogCateg.topCategory')))])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"forceMethod",attrs:{"label":"forceMethod"},on:{"input":function($event){_vm.showMethods()}},model:{value:(_vm.forceMethod),callback:function ($$v) {_vm.forceMethod=$$v},expression:"forceMethod"}},[_c('span',{ref:"interval",staticClass:"pad-to-7",staticStyle:{"margin":"4px"},attrs:{"name":"forceMethod"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.forceMethod')))])]),_vm._v(" "),(_vm.forceMethod)?[_c('label',{staticClass:"selectMethod",attrs:{"for":"methods"}},[_vm._v("\n                    "+_vm._s(_vm.$t('catalogCateg.selectMethod'))+"\n                  "),(_vm.delivery_options_labels.length)?_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:((_vm.forceMethod) ? 'required' : ''),expression:"(forceMethod) ? 'required' : ''"}],key:"methods",attrs:{"name":"methods","multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.selected_delivery_options_labels),callback:function ($$v) {_vm.selected_delivery_options_labels=$$v},expression:"selected_delivery_options_labels"}},[_vm._l((_vm.delivery_options_labels),function(item){return [_c('el-option',{key:item.key,attrs:{"label":item.label,"value":item.key}})]})],2):_vm._e()],1)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.hideFromPlatforms')))]),_vm._v(" "),_c('v-select',{staticClass:"line-heigth-44",attrs:{"multiple":"","options":_vm.platforms,"label":"name","placeholder":_vm.$t('catalogProd.timeOptionsValues.none')},model:{value:(_vm.selectedPlatforms),callback:function ($$v) {_vm.selectedPlatforms=$$v},expression:"selectedPlatforms"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChange,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingLocationGroups.active')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.visibleInLocations')))]),_vm._v(" "),_c('v-select',{staticClass:"line-heigth-44",attrs:{"multiple":"","options":_vm.locations,"label":"name","placeholder":_vm.$t('general.all')},model:{value:(_vm.selectedLocations),callback:function ($$v) {_vm.selectedLocations=$$v},expression:"selectedLocations"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.visibleInLocationsInfo')))])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"section-header"},[_c('h5',{staticClass:"section-header__title"},[_vm._v(_vm._s(_vm.$t('catalogCateg.schedule')))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"overrideSchedule",attrs:{"label":"overrideSchedule"},model:{value:(_vm.overrideSchedule),callback:function ($$v) {_vm.overrideSchedule=$$v},expression:"overrideSchedule"}},[_c('span',{staticClass:"pad-to-7",staticStyle:{"margin":"4px"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.useSchedule')))])]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('catalogCateg.scheduleHelp')))])],1),_vm._v(" "),(_vm.overrideSchedule)?[_c('available-days-schedule',{attrs:{"available-days":_vm.availableDays,"name-prefix":"top-category-schedule-"}})]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"card reward-card"},[_c('div',{staticClass:"section-header"},[_c('img',{staticClass:"section-header__icon",attrs:{"src":"/static/img/icons/points-sm.png"}}),_vm._v(" "),_c('h5',{staticClass:"section-header__title"},[_vm._v(_vm._s(_vm.$t('catalogProd.rewardPoints')))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',{staticClass:"reward-card__help"},[_vm._v("\n        "+_vm._s(_vm.$t('catalogProd.numberOfYouNeedToSpend', { currency: _vm.currency }))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"reward-card__control"},[_c('span',[_vm._v("1 "+_vm._s(_vm.currency)+" =")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.monetary_conversion),expression:"model.monetary_conversion"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.1","name":"monetary_conversion"},domProps:{"value":(_vm.model.monetary_conversion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "monetary_conversion", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('catalogProd.points')))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DOXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsUserAdd_vue__ = __webpack_require__("yCh9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd52664a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsUserAdd_vue__ = __webpack_require__("9Yis");
function injectStyle (ssrContext) {
  __webpack_require__("DuAr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsUserAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd52664a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsUserAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DU2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChallengeCampaignForm_vue__ = __webpack_require__("DvBx");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ChallengeCampaignForm: __WEBPACK_IMPORTED_MODULE_0__ChallengeCampaignForm_vue__["a" /* default */] },
  props: {
    route: { type: Object, default: function _default() {
        return {};
      } }
  }
});

/***/ }),

/***/ "DUIu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DUbD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"mar-lt-15"},[_vm._v(_vm._s(_vm.$t('settingCompany.appQRCode')))]),_vm._v(" "),[_c('div',{staticClass:"col-md-12 px-0"},[_c('img',{staticStyle:{"height":"170px","width":"170px"},attrs:{"src":_vm.location.app_qr}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-5 ml-4 px-0 mar-to-15"},[_c('a',{staticClass:"btn btn-info btn-icon duplicate-prod",attrs:{"href":this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + _vm.location.app_qr + '&name=' + 'App ' + _vm.location.name + '.png',"target":"_blank"}},[_c('i',{staticClass:"fa fa-download"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-icon duplicate-prod",on:{"click":function($event){$event.preventDefault();_vm.copy(_vm.location.app_link)}}},[_c('i',{staticClass:"fa fa-copy"})])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DYIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");


















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PSwitch: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__["a" /* default */] },
  props: {
    isSpinningWheelCampaigns: { type: Boolean, default: false }
  },
  watch: {
    isSpinningWheelCampaigns: function isSpinningWheelCampaigns(v) {
      if (v) this.initPage();
    },
    tableData: function tableData() {
      var _this = this;

      this.$nextTick(function () {
        return _this.layoutTable();
      });
    }
  },
  data: function data() {
    return {
      loading: false,
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      filters: [{ value: '', prop: ['title', 'id'] }],
      tableData: []
    };
  },
  created: function created() {
    this.$bus.$on('refresh', this.handleRefresh);
  },
  mounted: function mounted() {
    var _this2 = this;

    this.initPage();
    this._onResizeTable = function () {
      return _this2.layoutTable();
    };
    window.addEventListener('resize', this._onResizeTable);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
    if (this._onResizeTable) {
      window.removeEventListener('resize', this._onResizeTable);
    }
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.initPage();
    },
    layoutTable: function layoutTable() {
      var dt = this.$refs.spinningWheelDataTables;
      var elTable = dt && dt.$refs && dt.$refs.elTable;
      if (elTable && typeof elTable.doLayout === 'function') {
        elTable.doLayout();
      }
    },
    goToRecord: function goToRecord(row, column) {
      if (column && column.property === 'actions') return;
      this.editRecord(row);
    },
    editRecord: function editRecord(row) {
      if (!row || !row.id) return;
      this.$router.push('/marketing/spinning-wheel-campaigns/edit/' + row.id);
    },
    formatAvailabilityRange: function formatAvailabilityRange(row) {
      var _this3 = this;

      var dash = this.$t('general.emDash') || '—';
      var from = row.starts_at || null;
      var to = row.ends_at || null;
      if (!from && !to) return dash;
      var formatSafe = function formatSafe(value) {
        if (!value) return null;
        var formatted = _this3.formatDate(value);
        if (!formatted || formatted === 'Invalid date') return null;
        return formatted;
      };
      var a = formatSafe(from);
      var b = formatSafe(to);
      if (!a && !b) return dash;
      return (a || dash) + ' - ' + (b || dash);
    },
    formatPercentage: function formatPercentage(value) {
      if (value == null || value === '') return '0';
      var n = Number(value);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(n)) {
        var s = String(value);
        return s.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '') || '0';
      }
      var fixed = n.toFixed(4);
      return fixed.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
    },
    normalizeList: function normalizeList(response) {
      if (!response || !response.data) return [];
      var d = response.data;
      if (Array.isArray(d)) return d;
      if (Array.isArray(d.data)) return d.data;
      return [];
    },
    initPage: function initPage() {
      var _this4 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/spinning-wheel-campaigns', 'GET', data, function (response) {
        if (response.status) {
          _this4.tableData = _this4.normalizeList(response);
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error');
        }
        _this4.loading = false;
        _this4.$nextTick(function () {
          return _this4.layoutTable();
        });
      });
    },
    handleActive: function handleActive(row, val) {
      var _this5 = this;

      var previous = !!row.active;
      row.active = val;
      var body = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        active: val ? 1 : 0
      };
      this.apiRequest('/spinning-wheel-campaigns/' + row.id, 'PUT', body, function (response) {
        if (!response.status) {
          row.active = previous;
          var msg = response.errors && (response.errors.active || response.errors.message) || _this5.$t('validations.wentWrong');
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', Array.isArray(msg) ? msg[0] : msg, 'error');
          return;
        }
        if (response.data) {
          row.percentages_valid = response.data.percentages_valid;
          row.percentage_sum = response.data.percentage_sum;
          row.active = !!response.data.active;
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        title: this.$t('spinningWheel.confirmDelete'),
        useRejections: false,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then(function (result) {
        if (!result || !result.value) return;
        var data = {
          token: _this6.$session.get('token'),
          company_id: _this6.$session.get('selectedCompany')
        };
        _this6.apiRequest('/spinning-wheel-campaigns/' + row.id, 'DELETE', data, function (response) {
          if (response.status) {
            _this6.initPage();
            __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this6.$t('general.success'), 'success').catch(function () {});
          } else {
            __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this6.$t('validations.wentWrong'), 'error');
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "DYlH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  created: function created() {
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      tableData: []
    };
  },
  mounted: function mounted() {
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {

      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/fiscal-printer/edit/');
      }
    },
    goToAdd: function goToAdd() {
      this.$router.push('/fiscal-printer/add');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/fiscal-printer', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data.fiscalPrinter;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    handleDelete: function handleDelete(item) {
      var _this2 = this;

      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        text: this.$t('addOrder.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            id: item,
            token: _this2.$session.get('token'),
            company_id: _this2.$session.get('selectedCompany')
          };
          _this2.apiRequest('/fiscal-printer/' + item, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this2.$t('general.success'), 'success');
              _this2.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : _this2.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function (err) {
        if (err) {}
      });
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.disableConfirmButton();
      var yes = this.$t('general.yes');
      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          if (__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton().textContent = yes + ' (' + btnCounter + ')';
          }
        } else {
          if (__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton().textContent = yes;
          }
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    }
  }
});

/***/ }),

/***/ "DZrI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Nomenclator_NomenclatorProducts_vue__ = __webpack_require__("hFMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Nomenclator_ManagementClients_vue__ = __webpack_require__("5ZZT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Management_Suppliers_ManagementSuppliers_vue__ = __webpack_require__("4xpk");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NomenclatorProducts: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Nomenclator_NomenclatorProducts_vue__["a" /* default */],
    ManagementClients: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Nomenclator_ManagementClients_vue__["a" /* default */],
    ManagementSuppliers: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Management_Suppliers_ManagementSuppliers_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isProducts: true,
      isClients: false,
      isSuppliers: false
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  created: function created() {},

  methods: {
    openProducts: function openProducts() {
      this.isProducts = true;
      this.isClients = false;
      this.isSuppliers = false;
    },
    openClients: function openClients() {
      this.isProducts = false;
      this.isClients = true;
      this.isSuppliers = false;
    },
    openSuppliers: function openSuppliers() {
      this.isProducts = false;
      this.isClients = false;
      this.isSuppliers = true;
    }
  }
});

/***/ }),

/***/ "Da5+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallet_vue__ = __webpack_require__("b1Qe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2175386e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallet_vue__ = __webpack_require__("OGAj");
function injectStyle (ssrContext) {
  __webpack_require__("8fWk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2175386e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2175386e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DbxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"row order-view"},[_c('div',{staticClass:" col-lg-12 col-md-12 pad-to-15"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 posunset"},[_c('div',{staticClass:"card hightfixed posunset"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-sm-12"},[_c('h6',{staticClass:"noprint"},[_c('i',{staticClass:"ti-panel"}),_vm._v(" "+_vm._s(_vm.$t('orders.updateStatus')))]),_vm._v(" "),_c('hr',{staticClass:"noprint",staticStyle:{"clear":"both"}})])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-15 sticky-order-view-header"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left status-line pad-to-10 order-buttons resize-method"},[_vm._l((_vm.orderStatuses),function(sts,i){return [_c('button',{staticClass:"btn",class:((_vm.currentOrdersStatus === sts.type ) ? sts.type : '') + ' ' +'mr-1-rem current btn-' + _vm.orderStatusClass(sts.type),attrs:{"disabled":!sts.isAllowed || _vm.order.is_refunded === 1 || _vm.btStatusBlocked(sts.type)},on:{"click":function($event){$event.preventDefault();_vm.changeStatusFromButtons(sts.type)}},model:{value:(_vm.currentOrdersStatus),callback:function ($$v) {_vm.currentOrdersStatus=$$v},expression:"currentOrdersStatus"}},[_vm._v("\n                        "+_vm._s(_vm.changeDeliveryStatusForLabel(sts.type))+"\n                        ")])]})],2),_vm._v(" "),_c('div',{staticClass:"pull-right",staticStyle:{"display":"inline-flex"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentOrdersStatus),expression:"currentOrdersStatus"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentOrdersStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){$event.preventDefault();return _vm.changeStatus($event)}]}},_vm._l((_vm.orderStatuses),function(sts,i){return _c('option',{attrs:{"disabled":!sts.isAllowed || _vm.order.is_refunded === 1 || _vm.btStatusBlocked(sts.type)},domProps:{"value":sts.type}},[_vm._v("\n                              "+_vm._s(_vm.changeDeliveryStatusForLabel(sts.type))+"\n                            ")])}))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row pad-to-15"},[_c('div',{staticClass:"col-sm-12"},[_c('h6',{staticClass:"pull-left print-lg-font"},[_vm._v(_vm._s(_vm.$t('orders.single'))+" "),_c('span',{staticStyle:{"text-transform":"none"}},[_vm._v("#"+_vm._s(_vm.order.token))])]),_vm._v(" "),_c('h6',{staticClass:"pull-right"},[_c('i',{staticClass:"ti-shopping-cart"}),_vm._v(" "+_vm._s(_vm.$t('orders.ordDetails')))]),_vm._v(" "),_c('hr',{staticStyle:{"clear":"both"}})])]),_vm._v(" "),(_vm.order.status)?_c('div',{staticClass:"row display-flex resized-min-width-1600"},[_c('div',{staticClass:"col-md-6 col-print-6"},[(_vm.showLocations)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.ordLocation')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.order.production_details ? _vm.order.production_details.location.name : '-'))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6"},[_vm._v(_vm._s(_vm.$t('orders.date')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"},[_c('b',[_vm._v(_vm._s(_vm.formatDate(_vm.order.created_at)))])])]),_vm._v(" "),(_vm.order.delivery_type == 'MEET_HALF')?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6"},[_vm._v(_vm._s(_vm.$t('orders.meetupLocation')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"},[_c('b',[_vm._v(_vm._s(_vm.order.delivery_details ? _vm.order.delivery_details.location.name : ''))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6"},[_vm._v(_vm._s(_vm.$t('orders.madeAt')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"},[_c('b',[_vm._v(_vm._s(_vm.formatTime(_vm.order.created_at)))])])]),_vm._v(" "),(_vm.order.delivery_type !== 'EAT_LOCATION')?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6 text-color-red"},[_c('b',{staticStyle:{"font-size":"larger"}},[_vm._v(_vm._s(_vm.$t('orders.pickupTime')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"},[_c('el-time-picker',{staticClass:"in-inline-120",attrs:{"disabled":"true","arrow-control":"","value-format":_vm.timeFormat,"format":_vm.timeFormat,"placeholder":"Select time"},model:{value:(_vm.order.formatted_pickup_datetime),callback:function ($$v) {_vm.$set(_vm.order, "formatted_pickup_datetime", $$v)},expression:"order.formatted_pickup_datetime"}})],1)]):_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6 text-color-red"},[_c('b',{staticStyle:{"font-size":"larger"}},[_vm._v(_vm._s(_vm.$t('orders.reservationTime')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 "},[_c('b',[_vm._v(_vm._s(_vm.formatDate(_vm.order.pickup_datetime))+" "+_vm._s(_vm.formatTime(_vm.order.pickup_datetime)))])])]),_vm._v(" "),(_vm.order.delivery_type !== 'EAT_LOCATION')?[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6"}),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 order-delivery-time-buttons justify-space-evenly pad-lf-0"},[_vm._l((_vm.orderTimeDelivery()),function(min){return [_c('button',{staticClass:"btn btn-info btn-icon noprint mr-1-rem hour-button",attrs:{"disabled":_vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(min, 'add')}}},[_vm._v("+"+_vm._s(min)+"m")])]})],2)]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6"}),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 order-delivery-time-buttons justify-space-evenly pad-lf-0"},[_c('button',{staticClass:"btn btn-danger btn-icon noprint mr-1-rem hour-button",staticStyle:{"width":"47px"},attrs:{"disabled":_vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(5, 'sub')}}},[_vm._v("-5m")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon noprint mr-1-rem hour-button",staticStyle:{"width":"51px"},attrs:{"disabled":_vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(15, 'sub')}}},[_vm._v("-15m")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon noprint mr-1-rem hour-button",staticStyle:{"width":"54px"},attrs:{"disabled":_vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(30, 'sub')}}},[_vm._v("-30m")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon noprint mr-1-rem hour-button",staticStyle:{"width":"54px"},attrs:{"disabled":_vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(45, 'sub')}}},[_vm._v("-45m")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon noprint mr-1-rem hour-button",staticStyle:{"width":"55px"},attrs:{"disabled":_vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(55, 'sub')}}},[_vm._v("-60m")])])])]:_vm._e(),_vm._v(" "),(_vm.order.user_labeling)?[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6"},[_vm._v(_vm._s(_vm.$t('orders.note')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"},[(_vm.order.user_labeling)?[_c('b',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.convetLabelingJson(_vm.order.user_labeling)))])]:_vm._e()],2)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-print-6",attrs:{"_style":"padding-right: 0px !important;"}},[_c('div',{staticClass:"height-70-percent"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.payment')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6"},[_c('b',[_vm._v(_vm._s(_vm.$t('paymentTypes.' + _vm.order.payment_type)))]),_vm._v(" "),(_vm.order.payment_type === 'CARD' && _vm.order.is_refunded === 0)?_c('b',{domProps:{"innerHTML":_vm._s(_vm.getPaymetnStatus(_vm.order.capture_transaction_status))}}):_vm._e(),_vm._v(" "),(_vm.order.payment_id === 'btIpay')?_c('div',{staticClass:"help-block noprint"},[_c('strong',[_vm._v("BT iPay")]),_vm._v(" — "+_vm._s(_vm.$t('btPayments.captureHelp'))+"\n                          "),_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.getData($event)}}},[_vm._v(_vm._s(_vm.$t('btPayments.refresh')))])]):_vm._e(),_vm._v(" "),(_vm.order.payment_type === 'CARD' && _vm.order.is_refunded === 1)?_c('b',[_vm._v("\n                          - "),_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('orders.amountRefunded')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_c('small',[_vm._v(_vm._s(_vm.$t('orders.amountIntegralRefunded')))])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('general.deliveryMethod')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6"},[_c('b',[(_vm.order.company_id === 31 && _vm.order.delivery_type === 'MEET_HALF')?[_vm._v("Due Drive")]:_vm._e(),_vm._v(" "),(_vm.order.company_id === 46 && _vm.order.delivery_type === 'MEET_HALF')?[_vm._v("Yumm Drive")]:[_vm._v(_vm._s(_vm.$t('deliveryTypes.' + _vm.order.delivery_type)))]],2)])]),_vm._v(" "),(_vm.order.delivery_type === 'EAT_LOCATION')?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.reservationSeats')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6"},[_c('b',[_vm._v(_vm._s(_vm.order.delivery_details ? _vm.order.delivery_details.how_many : '-'))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[(_vm.order.comments)?[_vm._v(_vm._s(_vm.$t('orders.custComments')))]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6 ",class:_vm.order.comments ? 'text-danger' : ''},[(_vm.order.comments)?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.order.comments || '<small>'+_vm.$t('orders.none')+'</small>')}})]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10 height-30-percent display-flex align-items-flex-end"},[_c('div',{staticClass:"col-lg-12 col-sm-12 col-xs-12 col-print-12 details-label",staticStyle:{"padding-right":"0px !important"}},[_c('div',{staticClass:"col-lg-1 col-sm-1 col-xs-12 col-print-6 details-label"}),_vm._v(" "),_c('div',{staticClass:"col-lg-11 col-sm-11 col-xs-12 col-print-6 justify-content-flex-end display-inline-flex"},[(_vm.order.delivery_type === 'DELIVERY' && _vm.order.packageez_flag)?[(!_vm.cancelOrder && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-info mar-rt-10",attrs:{"id":'call-courier-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.courierCall(_vm.order.id, _vm.order.store_id)}}},[_vm._v(_vm._s(_vm.$t("orders.callCourier")))]):_vm._e(),_vm._v(" "),(_vm.cancelOrder && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.cancelCourierOrder(_vm.order.id, _vm.order.store_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancelCourier")))]):_vm._e(),_vm._v(" "),(_vm.order.status.id === 'TRANSPORT' || _vm.order.status.id === 'CANCELED' || _vm.order.status.id === 'NOT_DELIVERED')?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-disabled-' + _vm.order.id,"disabled":"disabled"},on:{"click":function($event){$event.preventDefault();_vm.cancelCourierOrder(_vm.order.id, _vm.order.store_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancel")))]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.canShowRefundButton)?_c('button',{staticClass:"btn btn-warning mar-rt-10 noprint",attrs:{"disabled":_vm.refundLoading || _vm.refundAlreadyDone || _vm.btReturnPending},on:{"click":function($event){$event.preventDefault();return _vm.doRefundOrder($event)}}},[_c('i',{staticClass:"fa fa-undo print-icon"}),_vm._v(" "),(_vm.refundAlreadyDone)?[_vm._v(_vm._s(_vm.$t('orders.refundAlreadyDone')))]:(_vm.btReturnPending)?[_vm._v(_vm._s(_vm.$t('btPayments.returnPending')))]:[_vm._v(_vm._s(_vm.$t('orders.refundOrder')))]],2):_vm._e(),_vm._v(" "),(_vm.btReturnPending)?_c('div',{staticClass:"text-warning noprint",attrs:{"role":"status"}},[_vm._v("\n                  "+_vm._s(_vm.$t('btPayments.returnHelp'))+"\n                  "),_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.getData($event)}}},[_vm._v(_vm._s(_vm.$t('btPayments.refresh')))])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-info mar-rt-10 noprint",on:{"click":function($event){$event.preventDefault();return _vm.printPage($event)}}},[_c('i',{staticClass:"fa fa-print print-icon"}),_vm._v(" "+_vm._s(_vm.$t('orders.print')))]),_vm._v(" "),(_vm.showPrintBtn)?_c('button',{staticClass:"btn btn-info noprint",on:{"click":function($event){$event.preventDefault();return _vm.sendToPrinter($event)}}},[_c('i',{staticClass:"fa fa-print print-icon"}),_vm._v(" "+_vm._s(_vm.$t('orders.printerPrint'))+"\n                          ")]):_vm._e()],2)])])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-print-12",staticStyle:{"display":"flex","justify-content":"space-between","margin-bottom":"20px","padding":"0"}},[_c('div',{class:(_vm.order.address.shipping ? 'col-md-6 col-print-6' : 'col-md-12 col-print-12')},[_c('div',{staticClass:"card",staticStyle:{"margin":"auto","height":"100%"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',{staticClass:"mar-to-0"},[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/user-sm.png"}}),_vm._v("  "+_vm._s(_vm.$t('orders.custDetails')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-2 col-sm-3 col-xs-12 details-label"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.name')))])]),_vm._v(" "),(_vm.order.delivery_details_firstname)?_c('div',{staticClass:"col-lg-10 col-sm-8 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.order.delivery_details_firstname)+" ")])]):_c('div',{staticClass:"col-lg-10 col-sm-8 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.order.customer ? _vm.order.customer.firstname : '')+" "+_vm._s(_vm.order.customer ? _vm.order.customer.lastname : ''))])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-2 col-sm-3 col-xs-12 details-label"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.email')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-sm-8 col-xs-12"},[_vm._v(_vm._s(_vm.order.customer ? _vm.order.customer.email : ''))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-2 col-sm-3 col-xs-12 details-label"},[_c('b',[_vm._v(_vm._s(_vm.$t('customers.phone')))])]),_vm._v(" "),(_vm.order.delivery_details_phone)?_c('div',{staticClass:"col-lg-10 col-sm-8 col-xs-12"},[_vm._v(_vm._s(_vm.order.delivery_details_phone))]):_c('div',{staticClass:"col-lg-10 col-sm-8 col-xs-12"},[_vm._v(_vm._s((_vm.order.customer && _vm.order.customer.phone) ? _vm.order.customer.phone : '-'))])])])])]),_vm._v(" "),(_vm.order.address.shipping)?[_c('div',{staticClass:"col-md-6 col-print-6"},[_c('div',{staticClass:"card address-box",staticStyle:{"margin":"auto","height":"100%"}},[_c('div',{staticClass:"card-content"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.shipping')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"address-content"},[_c('b',[_vm._v(_vm._s(_vm.order.address.shipping.address_name ? _vm.order.address.shipping.address_name : ''))]),_c('br'),_vm._v(_vm._s(_vm.order.address.shipping.street ? _vm.order.address.shipping.street : '')+" "+_vm._s(_vm.order.address.shipping.number ? _vm.order.address.shipping.number : '')+", "+_vm._s(_vm.order.address.shipping.apartment ? _vm.order.address.shipping.apartment : '')),_c('br'),_vm._v("\n                      "+_vm._s(_vm.order.address.shipping.city ? _vm.order.address.shipping.city : '')+",\n                      "+_vm._s(_vm.order.address.shipping.state ? _vm.order.address.shipping.state : '')),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.address.shipping.country),expression:"order.address.shipping.country"}]},[_vm._v(_vm._s(_vm.order.address.shipping.country ? _vm.order.address.shipping.country : '')),_c('br')]),_vm._v("\n                      "+_vm._s(_vm.order.address.shipping.other_info ? _vm.order.address.shipping.other_info : '')+"\n                    \n                  ")])])])])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{},[_c('table',{staticClass:"table orders-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('orders.name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.qty')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.unit')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.total')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.order.parts),function(customer){return [(_vm.order.order_type=='GROUP')?_c('tr',{staticClass:"active"},[_c('td',{attrs:{"colspan":"4"}},[_vm._v(_vm._s(_vm.$t('customers.single'))+": "+_vm._s(customer.customer_name))])]):_vm._e(),_vm._v(" "),_vm._l((customer.items),function(prod){return _c('tr',[_c('td',[_vm._v("\n                        "+_vm._s(prod.name)+"\n                        "),_vm._v(" "),_vm._l((prod.options),function(opt){return _c('div',[_vm._v("+ "+_vm._s(opt.name)),(opt.price>0)?_c('span',[_vm._v(" ("+_vm._s(_vm.formatMoneyAmount(opt.price, _vm.currency))+")")]):_vm._e()])}),_vm._v(" "),(prod.additional_info != '')?_c('div',{staticClass:"pad-to-10"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.custComments'))+": "),_c('i',{staticClass:"text-danger"},[_vm._v(_vm._s(prod.additional_info))])])]):_vm._e()],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(prod.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatMoneyAmount(prod.price, _vm.currency)))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(parseFloat(prod.quantity) * parseFloat(prod.price_total_product), _vm.currency)))])])])})]})],2)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-md-5 order-comment"}),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('table',{staticClass:"table no-border totals-table"},[_c('tbody',[_vm._l((_vm.totals),function(label){return [(label == 'totals_grandtotal' || _vm.order[label] > 0)?_c('tr',{class:_vm.getRowClass(label)},[_c('td',[(label != 'totals_extras')?_c('span',[_vm._v(_vm._s(_vm.$t('orders.' + label)))]):(_vm.$t('orders.' + label + '_' + _vm.order.company_id) != 'orders.' + label + '_' + _vm.order.company_id)?_c('span',[_vm._v("\n                            "+_vm._s(_vm.$t('orders.' + label + '_' + _vm.order.company_id))+"\n                          ")]):_c('span',[_vm._v(_vm._s(_vm.$t('orders.' + label)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(label == 'totals_discount'),expression:"label == 'totals_discount'"}]},[_vm._v("(Coupon: "+_vm._s(_vm.coupon)+")")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.order[label], _vm.currency, true)))])]):_vm._e()]})],2)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h6',[_c('img',{staticClass:"pad-rg-5",attrs:{"src":"/static/img/icons/comment.png"}}),_vm._v("  "+_vm._s(_vm.$t('orders.adminComments')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.backoffice_comments),expression:"order.backoffice_comments"}],staticClass:"form-control",attrs:{"placeholder":_vm.$t('orders.none'),"rows":"5"},domProps:{"value":(_vm.order.backoffice_comments)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.order, "backoffice_comments", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-icon btn-success noprint",attrs:{"title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.saveComment($event)}}},[_c('i',{staticClass:"ti-save"})])])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "De7v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStoreCampaignAdd_vue__ = __webpack_require__("rfzv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40f89a96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStoreCampaignAdd_vue__ = __webpack_require__("mYY+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStoreCampaignAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40f89a96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStoreCampaignAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dgnx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('digital-signage-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dhz4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DkQd":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAkCAYAAAB15jFqAAAABHNCSVQICAgIfAhkiAAAAYZJREFUWEftlr8vQ3EUxe951dgMfqwiBiEsEotFhCb6HulOWx1ZxGYwCDEIk4j/QCP2hopExGDE2jRdRAyGigQT3td50kY1Fcv73qkvedNL7ifnvnPuvTjJmm2IrIjdpyCQDTeJowCDfNYYu7yf6hSXjKdwqAqlvBcvjTZV6LdmI/3q0OindKpC2d4c25vQhL7CyHA8jZIa1PiS8OaRU4sM27rPti5Vw6Oh9LrrTUZHFvCuAqXC51ZfhiYzeKgdQFaVctRNeSmc1U88m9A9N4XlRiPWGpTxmGE8jlWhhJ1TaUwbKlS7RrWbmv9U6F7fcSQWT+JCzb2VrVKORmQwNodHlZxWIYzOlVuSMazDVxuDFfgWjbWqDQ2M5dJYp9Zy+sfddU+13dpQiUD61KGOL72qULr4jgugRw0arDlpkQlvFre/oPxwGfbhDcgH6xZ5ruxOZ1Csj8wTndURNvS/gd+Eht7xWiM122ulvWVWbedbYGQGQic0KIj8gRk3kEXHyA7Xzo0G9AtHwd0SWrxOeQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "DosS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DqLO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__ = __webpack_require__("VNNG");















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);

function pad(number) {
  return String(number).padStart(2, '0');
}

function ymd(date) {
  return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
}

function dayName(date) {
  return __WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__["a" /* DAY_NAMES */][(date.getDay() + 6) % 7];
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    subscription: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var now = new Date();
    return {
      loading: false,
      saving: false,
      year: now.getFullYear(),
      month: now.getMonth(),

      today: ymd(now),
      menus: [],

      assigned: {},
      selected: [],
      assignMenuId: null
    };
  },

  computed: {
    weekLabels: function weekLabels() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__["a" /* DAY_NAMES */].map(function (day) {
        return _this.$t('menuSubscriptions.dayShort.' + day);
      });
    },
    monthLabel: function monthLabel() {
      var label = this.$t('menuSubscriptions.months.' + this.month);
      return label + ' ' + this.year;
    },
    defaultMenu: function defaultMenu() {
      return this.menus.find(function (menu) {
        return menu.is_default;
      }) || null;
    },
    cells: function cells() {
      var first = new Date(this.year, this.month, 1);
      var start = new Date(this.year, this.month, 1 - (first.getDay() + 6) % 7);
      var deliveryDays = this.subscription.delivery_days || [];
      var cells = [];
      for (var i = 0; i < 42; i++) {
        var date = new Date(start.getFullYear(), start.getMonth(), start.getDate() + i);
        var key = ymd(date);
        var delivery = deliveryDays.indexOf(dayName(date)) !== -1;
        var past = key < this.today;
        cells.push({
          date: key,
          day: date.getDate(),
          inMonth: date.getMonth() === this.month,
          delivery: delivery,
          past: past,
          selectable: delivery && !past,
          menuId: this.assigned[key] || null
        });
      }
      return cells;
    },
    menusById: function menusById() {
      var map = {};
      this.menus.forEach(function (menu) {
        map[menu.id] = menu;
      });
      return map;
    }
  },
  created: function created() {
    this.getMenus();
    this.getCalendar();
  },

  methods: {
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    url: function url(path) {
      return '/menu-subscription/' + this.subscription.id + path;
    },
    getMenus: function getMenus() {
      var _this2 = this;

      this.apiRequest(this.url('/menus'), 'GET', this.requestData(), function (response) {
        if (response.status === true && response.data) {
          _this2.menus = response.data.menus || [];
        }
      });
    },
    getCalendar: function getCalendar() {
      var _this3 = this;

      var cells = this.cells;
      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestData(), {
        from: cells[0].date,
        to: cells[cells.length - 1].date
      });
      this.loading = true;
      this.apiRequest(this.url('/calendar'), 'GET', data, function (response) {
        _this3.loading = false;
        if (response.status !== true || !response.data) {
          return;
        }
        var assigned = {};(response.data.days || []).forEach(function (day) {
          assigned[day.date] = day.menu_id;
        });
        _this3.assigned = assigned;
        if (response.data.today) {
          _this3.today = response.data.today;
        }
      });
    },
    changeMonth: function changeMonth(step) {
      var date = new Date(this.year, this.month + step, 1);
      this.year = date.getFullYear();
      this.month = date.getMonth();
      this.selected = [];
      this.getCalendar();
    },
    menuName: function menuName(id) {
      return this.menusById[id] ? this.menusById[id].name : null;
    },
    isSelected: function isSelected(date) {
      return this.selected.indexOf(date) !== -1;
    },
    toggle: function toggle(cell) {
      if (!cell.selectable) {
        return;
      }
      var index = this.selected.indexOf(cell.date);
      if (index === -1) {
        this.selected.push(cell.date);
      } else {
        this.selected.splice(index, 1);
      }
    },
    selectMonth: function selectMonth() {
      this.selected = this.cells.filter(function (cell) {
        return cell.inMonth && cell.selectable;
      }).map(function (cell) {
        return cell.date;
      });
    },
    assign: function assign(menuId) {
      var _this4 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestData(), {
        dates: this.selected.slice().sort(),
        menu_id: menuId
      });
      this.saving = true;
      this.apiRequest(this.url('/calendar'), 'PUT', data, function (response) {
        _this4.saving = false;
        if (response.status === true) {
          _this4.selected = [];
          _this4.assignMenuId = null;
          _this4.getCalendar();
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ title: '', text: _this4.$t('menuSubscriptions.calendarSaved'), type: 'success', showConfirmButton: false, timer: 1200 }).catch(function () {});
        } else {
          var errors = response.errors || {};
          var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors)[0];
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', key ? errors[key] : _this4.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    }
  }
});

/***/ }),

/***/ "DsSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BtPaymentHistory_vue__ = __webpack_require__("QDmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__);






















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    BtPaymentHistory: __WEBPACK_IMPORTED_MODULE_13__BtPaymentHistory_vue__["a" /* default */],
    PPagination: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    },
    isTable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.token = this.$session.get('token');
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      token: null,
      apiUrl: null,
      tableColumns: [{
        prop: 'id',
        label: 'ID',
        minWidth: 100
      }, {
        prop: 'group_name',
        label: this.$t('settingTable.name'),
        minWidth: 300
      }, {
        prop: 'gateway',
        label: 'Gateway',
        minWidth: 300
      }],
      showBtPayments: false,
      paymentGroups: []
    };
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/payment-group', 'GET', data, function (response) {
        if (response.status === true) {
          _this.paymentGroups = response.data;

          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    },
    goToAdd: function goToAdd() {
      this.$router.push('/payment-groups/add');
    },
    goToRecord: function goToRecord(record, event, column) {
      if (!record || !record.id) return;

      if (typeof this.callback === 'function') {
        this.callback(record.id);
      } else {
        this.$router.push('/payment-groups/edit/' + record.id);
      }
    }
  }
});

/***/ }),

/***/ "Dsif":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DtKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dte2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DuAr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ducs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      loading: true,
      tableData: [],
      progressSummary: null,
      ordersGrandTotal: 0,
      challengeTitle: ''
    };
  },

  computed: {
    challengeId: function challengeId() {
      var fromProp = this.route && this.route.params && this.route.params.challengeId;
      var fromRouter = this.$route && this.$route.params && this.$route.params.challengeId;
      return fromProp || fromRouter;
    },
    userId: function userId() {
      var fromProp = this.route && this.route.params && this.route.params.userId;
      var fromRouter = this.$route && this.$route.params && this.$route.params.userId;
      return fromProp || fromRouter;
    },
    headerTitle: function headerTitle() {
      return this.challengeTitle || this.$t('challengeCampaigns.userProgress') + ' #' + this.userId;
    },
    locations: function locations() {
      var company = this.$session.get('selectedCompanyData') || {};
      return company.locations_details || company.locations || [];
    },
    summaryCurrency: function summaryCurrency() {
      var withCurrency = this.tableData.find(function (row) {
        return row.currency;
      });
      return withCurrency ? withCurrency.currency : '';
    }
  },
  created: function created() {
    this.challengeTitle = this.route && this.route.query && this.route.query.title || this.$route.query && this.$route.query.title || '';
    this.loadLogs();
  },

  methods: {
    formatChallengeStatus: function formatChallengeStatus(status) {
      if (!status) return '—';
      var key = 'challengeCampaigns.status_' + status;
      var translated = this.$t(key);
      return translated === key ? status : translated;
    },
    formatOrderStatus: function formatOrderStatus(status) {
      if (!status) return '—';
      var key = 'ordersStatus.' + status;
      var translated = this.$t(key);
      return translated === key ? status : translated;
    },
    formatLocation: function formatLocation(row) {
      if (row.location_name) return row.location_name;
      if (!row.location_id) return '—';
      var location = this.locations.find(function (loc) {
        return loc.true_id === row.location_id || loc.id === row.location_id || String(loc.true_id) === String(row.location_id) || String(loc.id) === String(row.location_id);
      });
      return location && location.name ? location.name : row.location_id;
    },
    getSummaries: function getSummaries(_ref) {
      var _this = this;

      var columns = _ref.columns;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = _this.$t('orders.totals_grandtotal');
          return;
        }
        if (column.property === 'totals_grandtotal') {
          var total = _this.ordersGrandTotal != null ? _this.ordersGrandTotal : _this.tableData.reduce(function (acc, row) {
            return acc + (Number(row.totals_grandtotal) || 0);
          }, 0);
          sums[index] = _this.formatMoneyAmount(total, _this.summaryCurrency);
          return;
        }
        if (column.property === 'progress') {
          sums[index] = _this.tableData.reduce(function (acc, row) {
            return acc + (Number(row.progress) || 0);
          }, 0);
          return;
        }
        sums[index] = '';
      });
      return sums;
    },
    relayoutTable: function relayoutTable() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.$refs.logsTable && _this2.$refs.logsTable.doLayout) {
          _this2.$refs.logsTable.doLayout();
        }
      });
    },
    loadLogs: function loadLogs() {
      var _this3 = this;

      if (!this.challengeId || !this.userId) return;
      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/reports/challenges/' + this.challengeId + '/users/' + this.userId + '/logs', 'GET', data, function (response) {
        _this3.loading = false;
        if (response.status) {
          _this3.tableData = response.data || [];
          var specials = response.data_specials || {};
          _this3.progressSummary = specials.progress || response.progress || null;
          _this3.ordersGrandTotal = specials.orders_grandtotal != null ? Number(specials.orders_grandtotal) : _this3.tableData.reduce(function (acc, row) {
            return acc + (Number(row.totals_grandtotal) || 0);
          }, 0);
          var challenge = specials.challenge || response.challenge;
          if (challenge && challenge.title) {
            _this3.challengeTitle = challenge.title;
          }
          _this3.relayoutTable();
        }
      });
    },
    openOrder: function openOrder(orderId) {
      if (!orderId) return;
      this.$router.push('/orders/view/' + orderId);
    },
    close: function close() {
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "DvBx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaignForm_vue__ = __webpack_require__("jCme");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b830a40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaignForm_vue__ = __webpack_require__("9uTf");
function injectStyle (ssrContext) {
  __webpack_require__("ODBQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b830a40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaignForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b830a40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaignForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dvak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);







var CHUNK_SIZE = 20 * 1024 * 1024;
var CHUNK_RETRIES = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'archive-input',
  inheritAttrs: false,
  props: {
    location: Object
  },
  data: function data() {
    return {
      apiUrl: '',
      file: null,
      uploading: false,
      progress: 0
    };
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
  },

  methods: {
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 500;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.archiveSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
      }
      return isOkSize;
    },
    handleChange: function handleChange(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 500;
      var isZip = file.raw.type.includes('zip');
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.archiveSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
      } else if (!isZip) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.wrongFormat'),
          position: 'top-end',
          showConfirmButton: true,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
      } else {
        self.file = file.raw;
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.file = null;
        this.$refs.upload.files = [];
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        toast: true,
        text: self.$t('validations.removePhoto'),
        type: 'warning',
        position: 'top-end',
        showConfirmButton: true
      });
    },
    postChunk: function postChunk(data) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this.apiRequest('/import-location/products/images/', 'POST', data, resolve);
      });
    },
    sendChunk: function sendChunk(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, attempt;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                response = null;
                attempt = 0;

              case 2:
                if (!(attempt < CHUNK_RETRIES)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 5;
                return _this2.postChunk(data);

              case 5:
                response = _context.sent;

                if (!(response && response.status)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', response);

              case 8:
                attempt++;
                _context.next = 2;
                break;

              case 11:
                return _context.abrupt('return', response);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    upload: function upload() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var file, uploadId, response, offset, end, chunk;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                file = _this3.file;

                if (!(!file || _this3.uploading)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                _this3.uploading = true;
                _this3.progress = 0;

                uploadId = Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
                response = null;
                _context2.prev = 7;
                offset = 0;

              case 9:
                if (!(offset < file.size)) {
                  _context2.next = 23;
                  break;
                }

                end = Math.min(offset + CHUNK_SIZE, file.size);
                _context2.next = 13;
                return _this3.getBase64(file.slice(offset, end));

              case 13:
                chunk = _context2.sent;
                _context2.next = 16;
                return _this3.sendChunk({
                  token: _this3.$session.get('token'),
                  location_id: _this3.location.id,
                  company_id: _this3.$session.get('selectedCompany'),
                  upload_id: uploadId,
                  offset: offset,
                  total_size: file.size,
                  is_last: end >= file.size ? 1 : 0,
                  chunk: chunk
                });

              case 16:
                response = _context2.sent;

                if (!(!response || !response.status)) {
                  _context2.next = 19;
                  break;
                }

                return _context2.abrupt('break', 23);

              case 19:
                _this3.progress = Math.round(end / file.size * 100);

              case 20:
                offset += CHUNK_SIZE;
                _context2.next = 9;
                break;

              case 23:
                _context2.next = 28;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2['catch'](7);

                response = null;

              case 28:
                _this3.uploading = false;

                if (response && response.status) {
                  __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                    toast: true,
                    text: _this3.$t('general.success'),
                    type: 'success',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                  });
                  _this3.file = null;
                  _this3.$refs.upload.clearFiles();
                } else {
                  __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                    toast: true,
                    text: _this3.$t('general.error'),
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                  });
                }

              case 30:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[7, 25]]);
      }))();
    }
  }
});

/***/ }),

/***/ "Dw7J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15 report-toolbar"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"filters-applied-row"},[_c('el-button',{staticStyle:{"margin-right":"10px"},attrs:{"type":"primary","size":"small"},on:{"click":_vm.openFiltersModal}},[_vm._v("\n            "+_vm._s(_vm.$t('orders.filters'))+"\n          ")]),_vm._v(" "),(_vm.appliedFilters.length)?[_c('span',{staticClass:"filters-applied-label"},[_vm._v(_vm._s(_vm.$t('orders.filtersList'))+":")]),_vm._v(" "),_vm._l((_vm.appliedFilters),function(flt,idx){return _c('span',{key:'sales-filter-' + idx,staticClass:"filter-selection"},[_vm._v("\n              "+_vm._s(flt)+"\n            ")])}),_vm._v(" "),_c('a',{staticClass:"reset-filters-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.resetFilters()}}},[_vm._v(_vm._s(_vm.$t('orders.resetFilters')))])]:[_c('span',{staticClass:"filters-applied-label"},[_vm._v(_vm._s(_vm.$t('orders.noFiltersApplied')))])]],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"sales-date-row"},[_c('el-date-picker',{staticClass:"sales-date-picker",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}}),_vm._v(" "),_c('span',{staticClass:"sales-date-text"},[_vm._v(_vm._s(_vm.$t('general.from')))]),_vm._v(" "),_c('div',{staticClass:"sales-time-range"},[_c('el-time-select',{staticClass:"mar-rt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v(" "),_c('span',{staticClass:"sales-date-text"},[_vm._v(_vm._s(_vm.$t('general.to')))]),_vm._v(" "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_column),expression:"date_column"}],staticClass:"form-control sales-date-column",staticStyle:{"width":"auto","min-width":"140px","margin-left":"10px","margin-right":"10px","height":"40px"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.date_column=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"created_at"}},[_vm._v(_vm._s(_vm.$t('reports.dateColumnCreate')))]),_vm._v(" "),_c('option',{attrs:{"value":"closed_at"}},[_vm._v(_vm._s(_vm.$t('reports.dateColumnClose')))]),_vm._v(" "),_c('option',{attrs:{"value":"fiscalized_at"}},[_vm._v(_vm._s(_vm.$t('reports.dateColumnFiscalize')))])]),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports pull-left",staticStyle:{"margin-bottom":"0 !important"},attrs:{"title":_vm.$t('reports.export')}},[(this.$route.query && this.$route.query.ver !== 'V2')?_c('download-excel',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"fetch":_vm.clientsExportData,"export-fields":_vm.json_fields,"name":_vm.export_name,"before-generate":_vm.startDownload,"before-finish":_vm.finishDownload}},[_vm._v("\n            "+_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})]):_vm._e(),_vm._v(" "),(this.$route.query && this.$route.query.ver === 'V2')?_c('download-excel',{staticClass:"btn btn-icon btn-xls-slim btn-success",attrs:{"fetch":_vm.clientsExportData,"fields":_vm.jsonFields,"name":_vm.export_name,"before-generate":_vm.startDownload,"before-finish":_vm.finishDownload}},[_c('i',{staticClass:"ti-download"})]):_vm._e()],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mar-bt-15 summary-cards-row"},[_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card primary"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalSum')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.total || 0).toFixed(2))))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.ordersNumber')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.totalOrders || 0))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.giftCardsSoldTotal')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.totals.giftCardsSoldCount || 0))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.totals_discount')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalDiscountItems || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.totals_discount_loyalty_points')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalDiscountLoyaltyPoints || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.totalTax')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalTax || 0).toFixed(2))))])]),_vm._v(" "),(_vm.totals.totalSlotTax)?_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v("  "+_vm._s(_vm.$t('reports.slotTax')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalSlotTax || 0).toFixed(2))))])]):_vm._e(),_vm._v(" "),(_vm.totals.totalSlotPartTax)?_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v("  "+_vm._s(_vm.$t('reports.slotPartTax')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalSlotPartTax || 0).toFixed(2))))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.shipping')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalShipping || 0).toFixed(2))))])]),_vm._v(" "),(_vm.use_tips)?[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.tips')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalTips || 0).toFixed(2))))])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.splitVoucher')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalSplitVoucher || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.woltOtherMethods')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalWoltOtherMethods || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.giftCardsSoldAmount')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.giftCardsSoldAmount || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.totalPayFromWallet')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalPayFromWallet || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unpaid')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalUnpaid || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unfiscalTotal')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.unfiscalTotal || 0).toFixed(2))))])])],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalCash')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v("\n            "+_vm._s(_vm.formatMoneyAmount((_vm.cashSummaryTotal || 0).toFixed(2)))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.cash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalCash || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.glovoCash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalGlovoCash || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.boltCash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalBoltCash || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.woltCash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalWoltCash || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.splitCash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalSplitCash || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unfiscalCash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.unfiscalTotalCash || 0).toFixed(2))))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalOnline')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v("\n            "+_vm._s(_vm.formatMoneyAmount((_vm.totalOnlineSummaryTotal || 0).toFixed(2)))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.card')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalCard || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.online')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalOnline || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unfiscalOnline')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.unfiscalTotalOnline || 0).toFixed(2))))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-bt-15 summary-cards-row"},[_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalCard')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totalCardSummaryTotal || 0).toFixed(2))))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.pos')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalPOS || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.cardPos')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalCARDPOS || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.splitCardPos')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalSplitCard || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unfiscalCard')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.unfiscalTotalCard || 0).toFixed(2))))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalCredit')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totalCreditSummaryTotal || 0).toFixed(2))))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.boltCard')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalBoltCard || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.glovoCard')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalGlovoCard || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.woltCard')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalWoltCard || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unfiscalCredit')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.unfiscalTotalCredit || 0).toFixed(2))))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalNonFiscal')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.nonFiscalSummaryTotal || 0).toFixed(2))))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.protocol')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalProtocol || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.staffFood')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalStaffFood || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.virament')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalVirament || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.room')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalRoom || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.event')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalEvent || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.folio')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalFolio || 0).toFixed(2))))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:((_vm.loading && !_vm.isFiltersModalOpen) || _vm.exportLoading),expression:"(loading && !isFiltersModalOpen) || exportLoading"}],staticClass:"card-content total-pagination reports-center-columns"},[_c('data-tables-server',{key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"search-def":{show: false},"total":_vm.totalOrders,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged,"row-click":_vm.goToRecordOrder}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":140,"prop":"id","label":_vm.$t('reports.orderId')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":200,"prop":"location","label":_vm.$t('reports.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.getLocationName(props.row.store_id))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":140,"prop":"created_at","label":_vm.$t('reports.date')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":140,"prop":"updated_at","label":_vm.$t('reports.closingOrder')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"token","label":'# '+_vm.$t('reports.order')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"number","label":_vm.$t('reports.number')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"table_number","label":_vm.$t('reports.tableNumber')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.table_number ? props.row.table_number : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":150,"label":_vm.$t('reports.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.customer.firstname)+" "+_vm._s(props.row.customer.lastname)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"class-name":"centered-cell","prop":"totals_grandtotal","label":_vm.$t('reports.totalSum')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(props.row.totals_grandtotal))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"class-name":"centered-cell","label":_vm.$t('reports.discount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(props.row.totals_discount + props.row.totals_discount_loyalty_points))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"class-name":"centered-cell","label":_vm.$t('reports.couponCode')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.coupon)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"class-name":"centered-cell","label":_vm.$t('reports.tax')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(props.row.totals_extras))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"class-name":"centered-cell","label":_vm.$t('reports.shipping')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(props.row.totals_shipping || 0))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":130,"class-name":"centered-cell","label":_vm.$t('reports.delivery_type')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.$t('settingCompany.'+ props.row.delivery_type.toLowerCase()))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":130,"class-name":"centered-cell","label":_vm.$t('reports.zone')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.shipping_details && props.row.shipping_details.hasOwnProperty('name'))?_c('span',[_vm._v(_vm._s(props.row.shipping_details.name))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":130,"prop":"payment_type","label":_vm.$t('reports.paymentType')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.$t('paymentTypes.' + props.row.payment_type))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":140,"class-name":"centered-cell","label":_vm.$t('reports.receiptNumber')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatReceiptNumber(props.row.receipt_number))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"class-name":"centered-cell","label":_vm.$t('reports.zet')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.parseZet(props.row.receipt_number))+"\n              ")]}}])})],1)],1)])])]),_vm._v(" "),_c('vmodal',{staticClass:"filtersAndSortModal sales-report-filters",attrs:{"name":"salesReportFiltersModal","height":"auto","width":"1200","adaptive":true,"scrollable":true}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header slim-header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('orders.filters')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body slim-body"},[_c('div',{staticClass:"filters-grid sales-report-filters-grid"},[_c('div',{staticClass:"modal-column-left"},[(_vm.showLocations)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalOrders.location),expression:"modalOrders.location"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modalOrders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'loc-' + loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.taxation')))]),_vm._v(" "),_c('v-select',{key:'has-receipt-select-modal',staticClass:"w-100 white line-heigth-44",attrs:{"options":_vm.receiptOptions,"label":"label","placeholder":_vm.$t('general.all')},model:{value:(_vm.modalHasReceipt),callback:function ($$v) {_vm.modalHasReceipt=$$v},expression:"modalHasReceipt"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.zet')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalZet),expression:"modalZet"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":_vm.$t('reports.zet')},domProps:{"value":(_vm.modalZet)},on:{"input":function($event){if($event.target.composing){ return; }_vm.modalZet=$event.target.value}}})]),_vm._v(" "),(_vm.showMethods)?_c('div',{staticClass:"filter-section wide-filter"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectMethod')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"multiple":"","collapse-tags":"","clearable":"","filterable":""},model:{value:(_vm.modalOrders.methods),callback:function ($$v) {_vm.$set(_vm.modalOrders, "methods", $$v)},expression:"modalOrders.methods"}},_vm._l((_vm.methods),function(m){return _c('el-option',{key:m.key || m,attrs:{"label":m.label || m,"value":m.key || m}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectClient')))]),_vm._v(" "),_c('el-select',{ref:"userSelect",staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","reserve-keyword":"","clearable":"","placeholder":_vm.$t('general.search'),"remote-method":_vm.searchUsers,"loading":_vm.loadingUsers},on:{"change":_vm.handleUserChange},model:{value:(_vm.modalSelectedUser),callback:function ($$v) {_vm.modalSelectedUser=$$v},expression:"modalSelectedUser"}},[_c('el-option',{attrs:{"value":'',"label":_vm.$t('general.alls')}}),_vm._v(" "),_vm._l((_vm.mergedUsers),function(usr){return _c('el-option',{key:'usr-' + usr.id,attrs:{"label":(usr.firstname && usr.lastname) ? (usr.firstname + ' ' + usr.lastname) : (usr.email || ''),"value":usr.id}})})],2)],1),_vm._v(" "),(_vm.posUsers.length)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.operator')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalSelectedPosUser),expression:"modalSelectedPosUser"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.modalSelectedPosUser=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.alls')}},[_vm._v(_vm._s(_vm.$t('general.alls')))]),_vm._v(" "),_vm._l((_vm.posUsers),function(operator){return _c('option',{key:'op-' + operator.id,attrs:{"label":operator.firstname + ' ' + operator.lastname},domProps:{"value":operator.id}},[_vm._v("\n                      "+_vm._s(operator.firstname)+" "+_vm._s(operator.lastname)+"\n                    ")])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',{staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.$t('pages.topCategory')))]),_vm._v(" "),_c('el-select',{ref:"categorySelect",staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"value-key":"id","multiple":"","filterable":"","remote":"","collapse-tags":"","reserve-keyword":"","clearable":"","placeholder":_vm.$t('general.search'),"remote-method":_vm.searchTopCategories,"loading":_vm.loadingCategories},on:{"change":_vm.clearCategorySearch},model:{value:(_vm.modalSelectedCategories),callback:function ($$v) {_vm.modalSelectedCategories=$$v},expression:"modalSelectedCategories"}},_vm._l((_vm.mergedCategories),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"modal-column-right"},[(_vm.orderFormFlags.length)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectedOrderFormFlags')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalSelectedOrderFrom),expression:"modalSelectedOrderFrom"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.modalSelectedOrderFrom=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.orderFormFlags),function(sts){return _c('option',{key:'of-' + sts,attrs:{"label":sts.toUpperCase()},domProps:{"value":sts}},[_vm._v(_vm._s(sts))])})],2)]):_vm._e(),_vm._v(" "),(_vm.paymentMethods.length)?_c('div',{staticClass:"filter-section wide-filter"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectedPaymentMethods')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",attrs:{"multiple":"","collapse-tags":"","clearable":""},model:{value:(_vm.modalSelectedPaymentMethods),callback:function ($$v) {_vm.modalSelectedPaymentMethods=$$v},expression:"modalSelectedPaymentMethods"}},_vm._l((_vm.paymentMethods),function(pm){return _c('el-option',{key:pm.id,attrs:{"label":pm.name,"value":pm.id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.orderPaidStatus')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalUnpaidOrdersFilter),expression:"modalUnpaidOrdersFilter"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.modalUnpaidOrdersFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.unpaidOrdersFilterOptions),function(opt){return _c('option',{key:'unpaid-filter-' + opt.value,domProps:{"value":opt.value}},[_vm._v("\n                  "+_vm._s(opt.label)+"\n                ")])}))]),_vm._v(" "),_c('div',{staticClass:"filter-section wide-filter"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.tables')))]),_vm._v(" "),_c('el-select',{ref:"salesReportTableSelect",staticClass:"w-100",attrs:{"value-key":"id","filterable":"","remote":"","clearable":"","reserve-keyword":"","placeholder":_vm.$t('settingTable.searchTable'),"remote-method":_vm.searchTables,"loading":_vm.loadingTables},on:{"change":_vm.clearTableSearch},model:{value:(_vm.modalSelectedTable),callback:function ($$v) {_vm.modalSelectedTable=$$v},expression:"modalSelectedTable"}},_vm._l((_vm.mergedSalesReportTables),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item}})}))],1),_vm._v(" "),(_vm.drivers.length)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectDriver')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalSelectedDriver),expression:"modalSelectedDriver"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.modalSelectedDriver=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.alls')}},[_vm._v(_vm._s(_vm.$t('general.alls')))]),_vm._v(" "),_vm._l((_vm.drivers),function(drive){return _c('option',{key:'drv-' + drive.id,attrs:{"label":drive.firstname + ' ' + drive.lastname},domProps:{"value":drive.id}},[_vm._v("\n                  "+_vm._s(drive.firstname)+" "+_vm._s(drive.lastname)+"\n                ")])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.serchCoupon')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalOrders.search),expression:"modalOrders.search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('dashboard.serchCoupon')},domProps:{"value":(_vm.modalOrders.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modalOrders, "search", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('general.orderId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalOrderId),expression:"modalOrderId"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"price","placeholder":"3823231"},domProps:{"value":(_vm.modalOrderId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.modalOrderId=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer slim-footer"},[_c('el-button',{attrs:{"type":"default","size":"small"},on:{"click":_vm.resetModalFilters}},[_vm._v(_vm._s(_vm.$t('general.reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.applyFilters}},[_vm._v(_vm._s(_vm.$t('general.apply')))])],1)])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DwHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductOptionsForm_vue__ = __webpack_require__("sDlK");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ProductOptionsForm', __WEBPACK_IMPORTED_MODULE_7__ProductOptionsForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      productOptionsForm: {},
      modelValidations: {
        required: {
          required: true
        }
      },
      kdsSections: []
    };
  },
  created: function created() {
    var _this = this;

    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };

    this.apiRequest('/sections', 'GET', data, function (response) {
      if (response.status) {
        _this.kdsSections = response.data;
      }
    });
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.productOptionsForm = model;
    }
  }
});

/***/ }),

/***/ "DxqD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{ref:"optionsTopBar",staticClass:"sticky-header",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.saveDetails($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"company-wrap mar-to-25"},[_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"labeling-options"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingFidelities.labelingPrimaryOption')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.labelsPrimaryOption),expression:"labelsPrimaryOption"}],staticClass:"form-control",attrs:{"name":"fidelities_labels_primary_option"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.labelsPrimaryOption=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.fidelitiesOptions),function(opt,key){return _c('option',{domProps:{"value":key,"selected":key === _vm.labelsPrimaryOption}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.'+key))+"\n                    ")])}))])]),_vm._v(" "),(_vm.labelsPrimaryOption != 'MOR')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingFidelities.labelingInterval')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.labelsInterval),expression:"labelsInterval"}],staticClass:"form-control",attrs:{"name":"fidelities_labels_interval"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.labelsInterval=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.fidelitiesIntervalOptions),function(opt,key){return _c('option',{domProps:{"value":key,"selected":key === _vm.labelsInterval}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.'+key))+"\n                    ")])}))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('p-checkbox',{model:{value:(_vm.showLabel),callback:function ($$v) {_vm.showLabel=$$v},expression:"showLabel"}},[_c('span',{staticClass:"pad-lf-5"},[_vm._v(_vm._s((_vm.$t('marketingFidelities.showLabelOnUser'))))])])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('p-checkbox',{model:{value:(_vm.enableLabelNotification),callback:function ($$v) {_vm.enableLabelNotification=$$v},expression:"enableLabelNotification"}},[_c('div',{staticClass:"pad-lf-5"},[_vm._v(_vm._s((_vm.$t('marketingFidelities.sentUserLabelNotification'))))])])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('a',{staticClass:"text-italic fidelities-customize-a",attrs:{"href":'/#/info-pages',"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.checkTermsAndConditionFidelities')))])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"50","prop":"name","label":_vm.$t('marketingFidelities.badgeName')}}),_vm._v(" "),(_vm.fidelitiesLabelsPrimaryOption == 'ordersValue')?_c('el-table-column',{attrs:{"min-width":"50","prop":"order_value","label":_vm.$t('marketingFidelities.ordersValue')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.order_value || '-'))])]}}])}):_vm._e(),_vm._v(" "),(_vm.fidelitiesLabelsPrimaryOption == 'ordersNumber')?_c('el-table-column',{attrs:{"min-width":"50","prop":"order_numbers","label":_vm.$t('marketingFidelities.ordersNumber')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.order_numbers || '-'))])]}}])}):_vm._e(),_vm._v(" "),(_vm.fidelitiesLabelsPrimaryOption == 'MOR')?_c('el-table-column',{attrs:{"min-width":"50","prop":"order_numbers","label":_vm.$t('marketingFidelities.MOR')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.mor_value || '-'))])]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"50","prop":"label_color","label":_vm.$t('marketingFidelities.color')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center",style:({ backgroundColor: props.row.color, width: '75%', color: props.row.color })},[_vm._v("\n                  "+_vm._s(props.row.color)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"50","prop":"product","label":_vm.$t('marketingFidelities.product')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.product ? props.row.product.name : '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"50","prop":"coupon","label":_vm.$t('marketingFidelities.coupon')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.coupon || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":320,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.send')},on:{"click":function($event){_vm.handleDelete(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")])]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dzb6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E0xI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DynamicMenu_vue__ = __webpack_require__("JWNY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ded45ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DynamicMenu_vue__ = __webpack_require__("UkeB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DynamicMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ded45ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DynamicMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E1FO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"raffle-campaign-participants-report"},[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back'),"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"sales-report mar-to-15"},[_c('div',{staticClass:"col-md-12 mar-bt-15"},[_c('p',{staticClass:"text-muted"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.raffleCampaignsReport')))]),_vm._v("\n        "+_vm._s(_vm.$t('general.breadcrumbSeparator'))+"\n        "),_c('span',[_vm._v(_vm._s(_vm.campaignTitle))]),_vm._v(" "),(_vm.level === 'orders')?[_vm._v("\n          "+_vm._s(_vm.$t('general.breadcrumbSeparator'))+_vm._s(_vm.participantTitle)+"\n        ")]:_vm._e()],2)]),_vm._v(" "),(_vm.level === 'participants')?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"raffle-campaign-participants-report__filters"},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 110px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.userId')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('raffleCampaigns.userId'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applyParticipantFilters($event)}},model:{value:(_vm.participantFilters.user_id),callback:function ($$v) {_vm.$set(_vm.participantFilters, "user_id", $$v)},expression:"participantFilters.user_id"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"1 1 200px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.search')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('raffleCampaigns.searchParticipants'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applyParticipantFilters($event)}},model:{value:(_vm.participantFilters.search),callback:function ($$v) {_vm.$set(_vm.participantFilters, "search", $$v)},expression:"participantFilters.search"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 240px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.joinedAt')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","size":"small","placeholder":_vm.$t('raffleCampaigns.joinedAt')},model:{value:(_vm.participantJoinedRange),callback:function ($$v) {_vm.participantJoinedRange=$$v},expression:"participantJoinedRange"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},on:{"click":_vm.applyParticipantFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])]),_vm._v(" "),_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"campaign-table width-table raffle-campaign-participants-report__table",staticStyle:{"width":"100%"},attrs:{"data":_vm.participantsRows,"total":_vm.participantsTotal,"pagination-props":_vm.paginationProps,"table-props":{ border: false }},on:{"query-change":_vm.onParticipantsPage,"row-click":_vm.onParticipantRow}},[_c('el-table-column',{attrs:{"min-width":90,"label":_vm.$t('raffleCampaigns.userId')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(p.row.user_id || p.row.id || '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":160,"label":_vm.$t('reports.email')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('span',{staticClass:"raffle-report-table__ellipsis"},[_vm._v(_vm._s(p.row.email || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":150,"label":_vm.$t('reports.name')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('span',{staticClass:"raffle-report-table__ellipsis"},[_vm._v(_vm._s(_vm.displayPersonName(p.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":140,"label":_vm.$t('raffleCampaigns.joinedAt')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatDate(p.row.joined_at))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":110,"label":_vm.$t('raffleCampaigns.score')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('b',[_vm._v(_vm._s(_vm.formatScore(p.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":110,"label":_vm.$t('raffleCampaigns.ordersCount')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(p.row.orders_count != null ? p.row.orders_count : 0)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"label":_vm.$t('raffleCampaigns.ordersTotal')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatMoney(p.row.orders_total))+" "+_vm._s(_vm.currency)+"\n              ")]}}])})],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.level === 'orders')?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"raffle-campaign-participants-report__filters"},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 120px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('general.orderId')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('general.orderId'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applyOrderFilters($event)}},model:{value:(_vm.orderFilters.order_id),callback:function ($$v) {_vm.$set(_vm.orderFilters, "order_id", $$v)},expression:"orderFilters.order_id"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"1 1 160px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.orderNumber')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('raffleCampaigns.orderNumber'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applyOrderFilters($event)}},model:{value:(_vm.orderFilters.order_number),callback:function ($$v) {_vm.$set(_vm.orderFilters, "order_number", $$v)},expression:"orderFilters.order_number"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 160px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.status')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","size":"small","placeholder":_vm.$t('general.select')},model:{value:(_vm.orderFilters.status),callback:function ($$v) {_vm.$set(_vm.orderFilters, "status", $$v)},expression:"orderFilters.status"}},_vm._l((_vm.orderStatusOptions),function(status){return _c('el-option',{key:status,attrs:{"label":_vm.$t('ordersStatus.' + status),"value":status}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 240px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.registeredAt')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","size":"small","placeholder":_vm.$t('raffleCampaigns.registeredAt')},model:{value:(_vm.orderDateRange),callback:function ($$v) {_vm.orderDateRange=$$v},expression:"orderDateRange"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},on:{"click":_vm.applyOrderFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])]),_vm._v(" "),_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"campaign-table width-table raffle-campaign-participants-report__table",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersRows,"total":_vm.ordersTotal,"pagination-props":_vm.paginationProps,"table-props":{ border: false }},on:{"query-change":_vm.onOrdersPage}},[_c('el-table-column',{attrs:{"min-width":100,"label":_vm.$t('general.orderId')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(p.row.order_id || p.row.id || '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":130,"label":_vm.$t('raffleCampaigns.orderNumber')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(p.row.order_number || '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"label":_vm.$t('orders.status')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.orderStatusLabel(p.row.order_status))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"label":_vm.$t('orders.totals_grandtotal')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatMoney(p.row.order_total))+" "+_vm._s(_vm.currency)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":140,"label":_vm.$t('raffleCampaigns.orderCreatedAt')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatDate(p.row.order_created_at))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":140,"label":_vm.$t('raffleCampaigns.registeredAt')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatDate(p.row.registered_at))+"\n              ")]}}])})],1)],1)])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E6Hi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs",attrs:{"direction":"vertical","value":"Description"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.generalSettings')}},[(_vm.isGeneralSettings)?_c('settings-general',{attrs:{"isGeneralSettings":_vm.isGeneralSettings}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('deliveryPreferences.deliveryTypeTitle')}},[(_vm.isDeliveryType)?_c('settings-delivery-type'):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.locationSettings')}},[(_vm.isLocationSettings)?_c('settings-locations',{attrs:{"isLocationSettings":_vm.isLocationSettings}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.payment')}},[(_vm.isPayment)?_c('payment',{attrs:{"isPayment":_vm.isPayment}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.integrations')}},[(_vm.isIntegrations)?_c('settings-integrations',{attrs:{"isIntegrations":_vm.isIntegrations}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":"Taxe"}},[(_vm.isTaxes)?_c('taxes-v2'):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.fiscalPrinter')}},[(_vm.isFiscalPrinter)?_c('fiscal-printer-list',{attrs:{"isFiscalPrinter":_vm.isFiscalPrinter}}):_vm._e()],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EB1b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EBxe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DeliveryPreferences_ZoneAvailabilityEditor_vue__ = __webpack_require__("P77k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DeliveryPreferences_zoneAvailability__ = __webpack_require__("ohf7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Maps_DeliveryGoogleMaps_vue__ = __webpack_require__("D+CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Taxes_DeliveryTaxPanel_vue__ = __webpack_require__("OZUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuedraggable__);




















var _components;













__WEBPACK_IMPORTED_MODULE_19_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_26_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    ZoneAvailabilityEditor: __WEBPACK_IMPORTED_MODULE_22__DeliveryPreferences_ZoneAvailabilityEditor_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'DeliveryGoogleMaps', __WEBPACK_IMPORTED_MODULE_27__Maps_DeliveryGoogleMaps_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'DeliveryTaxPanel', __WEBPACK_IMPORTED_MODULE_28__Taxes_DeliveryTaxPanel_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_21_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'draggable', __WEBPACK_IMPORTED_MODULE_29_vuedraggable___default.a), _components),
  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vee_validate__["b" /* mapFields */])(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity']), {
    copyDeliveryRangesLocations: function copyDeliveryRangesLocations() {
      var sessionCompany = this.$session && this.$session.get ? this.$session.get('selectedCompanyData') : null;
      var all = this.model && Array.isArray(this.model.locations_details) ? this.model.locations_details : sessionCompany && Array.isArray(sessionCompany.locations_details) ? sessionCompany.locations_details : [];
      var currentToken = this.model && this.model.token ? this.model.token : null;
      return all.filter(function (l) {
        return l && l.token && l.token !== currentToken;
      });
    },
    reservationWidgetCompanyId: function reservationWidgetCompanyId() {
      return this.$session.get('selectedCompany');
    },
    reservationWidgetButtonLabel: function reservationWidgetButtonLabel() {
      var labels = {
        ro: 'Rezerva o masa',
        en: 'Reserve a table'
      };
      return labels[this.reservationWidget.language] || labels.ro;
    },
    reservationWidgetPositions: function reservationWidgetPositions() {
      return [{ id: 'top-left', label: this.$t('settingsOrdering.reservationWidgetPosTopLeft') }, { id: 'top-right', label: this.$t('settingsOrdering.reservationWidgetPosTopRight') }, { id: 'bottom-left', label: this.$t('settingsOrdering.reservationWidgetPosBottomLeft') }, { id: 'bottom-right', label: this.$t('settingsOrdering.reservationWidgetPosBottomRight') }];
    }
  }),
  props: {
    defaultData: {},
    modeldata: {},
    drawDetails: {}
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },
    'model.name': function modelName(value) {
      if (value && !this.reservationWidget.restaurantNameCustomized) {
        this.reservationWidget.restaurantName = value;
      }
    },
    modeldata: function modeldata(value) {
      var _this = this;

      for (var iLocation in value.locations_details) {
        var _loop = function _loop() {
          if (value.locations_details[iLocation].ordering_management[iOrder].locations === undefined) {
            value.locations_details[iLocation].ordering_management[iOrder].locations = [];
          }

          if (value.locations_details[iLocation].ordering_management[iOrder].period === undefined) {
            __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'period', 1);
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].offset === undefined) {
            __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'offset', 0);
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].no_preorders === undefined) {
            __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'no_preorders', false);
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].is_always_open === undefined) {
            __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'is_always_open', false);
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].is_always_open_preorder_hours === undefined) {
            __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'is_always_open_preorder_hours', 0);
          }
          if ((value.locations_details[iLocation].ordering_management[iOrder].hour_and_date_delivery_hour_usage === undefined || !value.locations_details[iLocation].ordering_management[iOrder].hour_and_date_delivery_hour_usage) && (value.locations_details[iLocation].ordering_management[iOrder].just_date_delivery_hour_usage === undefined || !value.locations_details[iLocation].ordering_management[iOrder].just_date_delivery_hour_usage) && (value.locations_details[iLocation].ordering_management[iOrder].deactivate_delivery_hour_usage === undefined || !value.locations_details[iLocation].ordering_management[iOrder].deactivate_delivery_hour_usage)) {
            __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'delivery_hour_usage', 0);
            _this.changeDeliveryHourUsage(value.locations_details[iLocation].ordering_management[iOrder]);
          }

          if (value.locations_details[iLocation].ordering_management[iOrder].shipping_cost === undefined) {
            value.locations_details[iLocation].ordering_management[iOrder].shipping_cost = [];
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].delivery_rules === undefined) {
            var newRow = _this.copyObject(_this.newRule);
            var newSubRule = _this.copyObject(_this.newSubRule);
            newRow.subrules = [];
            newRow.subrules.push(newSubRule);
            value.locations_details[iLocation].ordering_management[iOrder].delivery_rules = [];
            value.locations_details[iLocation].ordering_management[iOrder].delivery_rules.push(newRow);
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].area === undefined && value.locations_details[iLocation].ordering_management[iOrder].type === 'delivery') {
            value.locations_details[iLocation].ordering_management[iOrder].area = 'radius';
          }

          for (iDay in _this.days) {
            day = _this.days[iDay];

            if (value.locations_details[iLocation].ordering_management[iOrder].available_days === undefined) {
              value.locations_details[iLocation].ordering_management[iOrder].available_days = [];
            }
            index = _this.getObjectByElemKeyValue('day', day, value.locations_details[iLocation].ordering_management[iOrder].available_days);

            if (index === false) {
              value.locations_details[iLocation].ordering_management[iOrder].available_days.push({ day: day, open_to: '', open_from: '', open: false });
            } else if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open === undefined) {
              if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_to !== '' && value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_from !== '') {
                value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = true;
              } else {
                value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = false;
              }
            }
          }

          var self = _this;
          value.locations_details[iLocation].ordering_management[iOrder].available_days = value.locations_details[iLocation].ordering_management[iOrder].available_days.filter(function (value, index, arr) {
            return self.days.indexOf(value.day) !== -1;
          });
        };

        for (var iOrder in value.locations_details[iLocation].ordering_management) {
          var iDay;
          var day;
          var index;

          _loop();
        }
      }
      this.model = value;
    }
  },
  data: function data() {
    return {
      showTheRestOfTheZones: true,
      copyDeliveryRangesLocationToken: '',
      copyDeliveryRangesFetched: [],
      copyDeliveryRangesLoading: false,
      deliveryRangesDataReady: false,
      isAutoChangeEnabled: [],
      deliveryMethodLabels: [],
      reservationTaxesIndex: 0,
      methodInfoIndex: 0,
      closeOrderOptions: [{ 'id': 0, 'label': this.$t('settingCompany.closeOrdersAfter') }, { 'id': 1, 'label': this.$t('settingCompany.closeOrdersAt') }],
      delivery_hour_usage: [{
        'id': 0,
        'name': 'hourAndDate'
      }, {
        'id': 1,
        'name': 'justDate'
      }, {
        'id': 2,
        'name': 'deactivateDeliveryHours'
      }],
      arrowsSimbolHtml: '<i style="cursor: move" class="fa fa-arrows sortHandle"></i>',
      colapsedItem: null,
      model: this.modeldata,
      deliveryRanges: [],
      defaults: this.value || this.defaultData,
      pickerOptions1: {},
      pickerOptionsTaxFrom: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      pickerOptionsTaxTo: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      tabIndex: 0,
      taxes: [],
      taxesPerLocation: [],
      activeNames: [],
      currency: this.$session.get('selectedCompanyData')['currency_iso'],
      modelValidate: {
        'available_days': { required: true },
        'required': { required: true },
        'offset': { required: true, min_value: 0, max_value: 365, decimal: 0 },
        'period': { required: true, min_value: 1, max_value: 1095, decimal: 0 },
        'auto_close_orders_after_hour': { min_value: 0, max_value: 12, decimal: 0 },
        'auto_change_status_after_min': { min_value: 0, max_value: 360, decimal: 0 }
      },
      statusesAutoChange: [{
        name: 'NEW',
        values: ['PROCESSING', 'PREPARED']
      }, {
        name: 'PROCESSING',
        values: ['PREPARED']
      }, {
        name: 'PREPARED',
        values: ['DELIVERED']
      }],
      paymentOptions: [{
        'payment_id': 'credit_card',
        'name': this.$t('paymentTypes.CARD')
      }, {
        'payment_id': 'cash',
        'name': this.$t('paymentTypes.CASH')
      }, {
        'payment_id': 'pos',
        'name': this.$t('paymentTypes.POS')
      }, {
        'payment_id': 'kiosk_pos',
        'name': this.$t('paymentTypes.POS_KIOSK')
      }],
      pickerNames: ['date_from', 'date_to'],
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '24:00'
      },
      picker_options_orders_starts_from: {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      },
      newLocation: {
        street: '',
        city: '',
        state: '',
        country: ''
      },
      newRule: {
        delivery_range: '',
        subrules: []
      },
      newSubRule: {
        shipping_cost: 0,
        shipping_pos_id: '',
        vat_rate_id: null,
        cities: [],
        neighborhoods: [],
        min_order_value: 0
      },
      zoneLimitations: {
        'radius': 'setRadiusArea',
        'draw': 'setDrawArea'
      },
      windowHeight: 0,
      navbarHeaderHeight: 0,
      pageTopHeight: 76,
      loading: true,
      vatOptions: [],
      deliveryPreferencesList: [],
      preferenceSearch: '',
      taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
      defaultDeliveryMethods: [],
      tableZones: [],
      reservationWidgetLanguages: [{ id: 'ro', label: 'Română' }, { id: 'en', label: 'English' }],
      reservationWidget: {
        position: 'bottom-right',
        language: 'ro',
        hoursToStay: 2,
        defaultPersons: 2,
        tableZoneId: 0,
        countryCodePrefix: '40',
        restaurantName: '',
        restaurantNameCustomized: false,
        copied: false
      }
    };
  },
  created: function created() {
    var _this2 = this;

    var requestsToComplete = {
      vat: false,
      tableZones: false,
      deliveryRanges: false
    };

    var checkAllComplete = function checkAllComplete() {
      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(requestsToComplete).every(function (v) {
        return v === true;
      })) {
        _this2.$bus.$emit('delivery-methods-loaded');
      }
    };

    this.getVatOptions(function () {
      requestsToComplete.vat = true;
      checkAllComplete();
    });
    this.getTableZones(function () {
      requestsToComplete.tableZones = true;
      checkAllComplete();
    });
    this.$nextTick(function () {
      _this2.loading = false;
    });
    this.getData(function () {
      requestsToComplete.deliveryRanges = true;
      checkAllComplete();
    });
    if (this.model) {
      console.log(this.model);
      for (var iOrder in this.model.ordering_management) {
        if (this.model.ordering_management[iOrder].auto_close_orders_at_hour) {
          __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model.ordering_management[iOrder], 'closeOrder', 1);
        } else {
          __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model.ordering_management[iOrder], 'closeOrder', 0);
        }
        if (this.model.ordering_management[iOrder].is_always_open === undefined || this.model.ordering_management[iOrder].is_always_open === null) {
          __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model.ordering_management[iOrder], 'is_always_open', false);
        } else {
          __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model.ordering_management[iOrder], 'is_always_open', Boolean(this.model.ordering_management[iOrder].is_always_open));
        }
        if (this.model.ordering_management[iOrder].is_always_open_preorder_hours === undefined || this.model.ordering_management[iOrder].is_always_open_preorder_hours === null) {
          __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model.ordering_management[iOrder], 'is_always_open_preorder_hours', 0);
        }

        if (this.model.ordering_management[iOrder].use_multiple_delivery_preferences === undefined || this.model.ordering_management[iOrder].use_multiple_delivery_preferences === null) {
          __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model.ordering_management[iOrder], 'use_multiple_delivery_preferences', this.model.ordering_management[iOrder].type === 'delivery');
        } else {
          __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model.ordering_management[iOrder], 'use_multiple_delivery_preferences', Boolean(this.model.ordering_management[iOrder].use_multiple_delivery_preferences));
        }
        if (!Array.isArray(this.model.ordering_management[iOrder].delivery_preference_ids)) {
          __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model.ordering_management[iOrder], 'delivery_preference_ids', []);
        }
      }
    }
    this.deliveryMethodLabels = this.getCompanyDetail('delivery_options_labels');
    this.getDeliveryPreferences();
    this.model.ordering_management.forEach(function (order, orderIdx) {
      if (order.status_from_auto_change != null || order.status_to_auto_change != null || order.auto_change_status_after_min != null) {
        _this2.isAutoChangeEnabled[orderIdx] = true;
      }
    });
    this.initReservationWidgetDefaults();
  },

  methods: {
    initReservationWidgetDefaults: function initReservationWidgetDefaults() {
      if (this.model && this.model.name && !this.reservationWidget.restaurantName) {
        this.reservationWidget.restaurantName = this.model.name;
      }
      var eatOrder = this.model && this.model.ordering_management ? this.model.ordering_management.find(function (o) {
        return o.type === 'eat_location';
      }) : null;
      if (eatOrder && eatOrder.min_standard_reservations) {
        this.reservationWidget.hoursToStay = Number(eatOrder.min_standard_reservations) || 2;
      }
      if (eatOrder && eatOrder.min_reservation) {
        this.reservationWidget.defaultPersons = Number(eatOrder.min_reservation) || 2;
      }
    },
    escapeWidgetAttr: function escapeWidgetAttr(value) {
      return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    },
    getReservationWidgetScript: function getReservationWidgetScript(order) {
      var widget = this.reservationWidget;
      var restaurantName = widget.restaurantName || this.model && this.model.name || '';
      var methodId = order && order.id ? order.id : '';
      var locationToken = this.model && this.model.token ? this.model.token : '';
      var scriptClose = '</' + 'script>';
      return ['<script src="https://reservationswidget.taptasty.ro/reservations-widget.env.production.js">' + scriptClose, '<script', '  src="https://reservationswidget.taptasty.ro/reservations-widget.js"', '  data-company-id="' + this.escapeWidgetAttr(this.reservationWidgetCompanyId) + '"', '  data-method-id="' + this.escapeWidgetAttr(methodId) + '"', '  data-location-token="' + this.escapeWidgetAttr(locationToken) + '"', '  data-position="' + this.escapeWidgetAttr(widget.position) + '"', '  data-language="' + this.escapeWidgetAttr(widget.language) + '"', '  data-hours-to-stay="' + this.escapeWidgetAttr(widget.hoursToStay) + '"', '  data-default-persons="' + this.escapeWidgetAttr(widget.defaultPersons) + '"', '  data-table-zone-id="' + this.escapeWidgetAttr(widget.tableZoneId) + '"', '  data-country-code-prefix="' + this.escapeWidgetAttr(widget.countryCodePrefix) + '"', '  data-restaurant-name="' + this.escapeWidgetAttr(restaurantName) + '"', '>' + scriptClose].join('\n');
    },
    fallbackCopyReservationWidgetScript: function fallbackCopyReservationWidgetScript(script, done) {
      var textarea = document.createElement('textarea');
      textarea.value = script;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        if (done) done();
      } catch (err) {
        console.error('Copy failed', err);
      }
      document.body.removeChild(textarea);
    },
    copyReservationWidgetScript: function copyReservationWidgetScript(order) {
      var _this3 = this;

      var script = this.getReservationWidgetScript(order);
      var done = function done() {
        _this3.reservationWidget.copied = true;
        setTimeout(function () {
          _this3.reservationWidget.copied = false;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(script).then(done).catch(function () {
          _this3.fallbackCopyReservationWidgetScript(script, done);
        });
      } else {
        this.fallbackCopyReservationWidgetScript(script, done);
      }
    },
    handleUpdateZone: function handleUpdateZone(zone, indexZone) {
      this.deliveryRanges[indexZone] = zone;
    },
    handleClosingHour: function handleClosingHour(orderIdx, e) {
      if (parseInt(e.target.value)) {
        this.model.ordering_management[orderIdx].auto_close_orders_after_hour = null;
      } else {
        this.model.ordering_management[orderIdx].auto_close_orders_at_hour = null;
      }
    },
    getTableZones: function getTableZones(callback) {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/table-zone', 'GET', data, function (response) {
        if (response.status === true) {
          _this4.tableZones = response.data;
        }
        if (callback) callback();
      });
    },
    getVatOptions: function getVatOptions(callback) {
      var _this5 = this;

      var locaitonIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_ids: locaitonIds
      };
      var endpoint = this.taxesVersion === 2 ? '/taxes-v2/vat-rates' : '/location/vat';
      this.apiRequest(endpoint, 'GET', data, function (response) {
        if (response.status === true) {
          _this5.vatOptions = response.data;
        }
        if (callback) callback();
      });
    },
    getDeliveryPreferences: function getDeliveryPreferences() {
      var _this6 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/delivery-preference', 'GET', data, function (response) {
        if (response.status === true) {
          _this6.deliveryPreferencesList = response.data;
        }
      });
    },
    filteredPreferences: function filteredPreferences() {
      var q = (this.preferenceSearch || '').toLowerCase().trim();
      if (!q) return this.deliveryPreferencesList;
      return this.deliveryPreferencesList.filter(function (p) {
        var admin = (p.nume_admin || '').toLowerCase();
        var name = (p.name || '').toLowerCase();
        return admin.indexOf(q) !== -1 || name.indexOf(q) !== -1;
      });
    },
    isPreferenceChecked: function isPreferenceChecked(order, id) {
      return Array.isArray(order.delivery_preference_ids) && order.delivery_preference_ids.indexOf(id) !== -1;
    },
    togglePreference: function togglePreference(order, id) {
      if (!Array.isArray(order.delivery_preference_ids)) {
        this.$set(order, 'delivery_preference_ids', []);
      }
      var i = order.delivery_preference_ids.indexOf(id);
      if (i === -1) {
        order.delivery_preference_ids.push(id);
      } else {
        order.delivery_preference_ids.splice(i, 1);
      }
    },
    getData: function getData(callback) {
      this.getDeliveryRanges(callback);
      this.$bus.$on('drawingDetails', this.drawing);
      this.$bus.$on('changeDeliveryZone', this.changeDeliveryZone);
      this.currency = this.getCurrencySymbol(this.currency);
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getDeliveryRanges: function getDeliveryRanges(callback) {
      var _this7 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_token: this.model.token
      };
      this.apiRequest('/admin/delivery-ranges', 'GET', data, function (response) {
        if (response.status === true) {
          _this7.deliveryRanges = Array.isArray(response.data) ? response.data : [];
          _this7.$nextTick().then(function () {
            _this7.deliveryRangesDataReady = true;
            if (callback) callback();
          });
        } else {
          if (callback) callback();
        }
      });
    },
    openCopyDeliveryRangesModal: function openCopyDeliveryRangesModal() {
      this.copyDeliveryRangesLocationToken = '';
      this.copyDeliveryRangesFetched = [];
      this.copyDeliveryRangesLoading = false;
      this.$modal.show('copyDeliveryRangesModal');
    },
    closeCopyDeliveryRangesModal: function closeCopyDeliveryRangesModal() {
      this.$modal.hide('copyDeliveryRangesModal');
    },
    handleCopyDeliveryRangesLocationChange: function handleCopyDeliveryRangesLocationChange() {
      var _this8 = this;

      var token = this.copyDeliveryRangesLocationToken;
      if (!token) {
        this.copyDeliveryRangesFetched = [];
        return;
      }
      this.copyDeliveryRangesLoading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_token: token
      };
      this.apiRequest('/admin/delivery-ranges', 'GET', data, function (response) {
        if (response && response.status === true && Array.isArray(response.data)) {
          _this8.copyDeliveryRangesFetched = response.data;
        } else {
          _this8.copyDeliveryRangesFetched = [];
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({ 'text': _this8.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
        _this8.$nextTick(function () {
          _this8.copyDeliveryRangesLoading = false;
        });
      });
    },
    confirmCopyDeliveryRanges: function confirmCopyDeliveryRanges() {
      var _this9 = this;

      if (!Array.isArray(this.copyDeliveryRangesFetched) || !this.copyDeliveryRangesFetched.length) {
        return;
      }
      if (!Array.isArray(this.deliveryRanges)) {
        this.deliveryRanges = [];
      }
      var isBlankZone = function isBlankZone(z) {
        if (!z) return true;
        var name = (z.name || '').toString().trim();
        var shape = z.shape;
        var shapeEmpty = !shape || Array.isArray(shape) && shape.length === 0 || (typeof shape === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(shape)) === 'object' && !Array.isArray(shape) && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(shape).length === 0;
        return name === '' && shapeEmpty;
      };

      var sessionCompany = this.$session && this.$session.get ? this.$session.get('selectedCompanyData') : null;
      var allLocations = this.model && Array.isArray(this.model.locations_details) ? this.model.locations_details : sessionCompany && Array.isArray(sessionCompany.locations_details) ? sessionCompany.locations_details : [];
      var sourceLocation = allLocations.find(function (l) {
        return l && l.token === _this9.copyDeliveryRangesLocationToken;
      });
      if (sourceLocation && sourceLocation.google_maps_api_key) {
        __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model, 'google_maps_api_key', sourceLocation.google_maps_api_key);
      }

      var currentLocationId = this.model && this.model.true_id ? this.model.true_id : this.model && this.model.id ? this.model.id : null;

      this.deliveryRanges = this.deliveryRanges.filter(function (z) {
        return !isBlankZone(z);
      });

      var cloned = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.copyDeliveryRangesFetched));
      cloned.filter(function (z) {
        return !isBlankZone(z);
      }).forEach(function (z) {
        if (!z) return;
        if (z && z.hasOwnProperty('id')) delete z.id;
        z.location_id = currentLocationId;
        if (!z.hasOwnProperty('name')) z.name = '';
        if (!z.hasOwnProperty('shape')) z.shape = {};
        if (Array.isArray(z.delivery_range_cost_rules)) {
          z.delivery_range_cost_rules.forEach(function (rule) {
            if (!rule) return;
            if (rule.hasOwnProperty('id')) delete rule.id;
            if (rule.hasOwnProperty('delivery_ranges_id')) delete rule.delivery_ranges_id;
            rule.location_id = currentLocationId;
          });
        }
        _this9.deliveryRanges.push(z);
      });
      this.deliveryRangesDataReady = true;
      this.model.mapactive = this.deliveryRanges.length ? this.deliveryRanges.length - 1 : null;
      this.closeCopyDeliveryRangesModal();
    },
    validate: function validate() {
      var _this10 = this;

      var self = this;
      this.errors.clear();
      var normalizeTimeValue = function normalizeTimeValue(val) {
        if (val === null) return '';
        if (val === undefined) return '';
        if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(val)) === 'object' && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(val).length === 0) return '';
        if (Array.isArray(val) && val.length === 0) return '';
        return val;
      };
      this.model.ordering_management.forEach(function (order) {
        if (!order.available_days) return;
        order.available_days.forEach(function (day) {
          day.open_from = normalizeTimeValue(day.open_from);
          day.open_to = normalizeTimeValue(day.open_to);
          if (day.intervals) {
            day.intervals.forEach(function (interval) {
              interval.open_from = normalizeTimeValue(interval.open_from);
              interval.open_to = normalizeTimeValue(interval.open_to);
            });
          }
        });
      });

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this10.$validator.validateAll().then(function (isValid) {
          if (isValid) {
            for (var oIdx in _this10.model.ordering_management) {
              var o = _this10.model.ordering_management[oIdx];
              if (o.type === 'delivery') {
                if (o.delivery_rules && o.delivery_rules.length > 1) {
                  for (var rIdx in o.delivery_rules) {
                    var rule = o.delivery_rules[rIdx];
                    if (rule.delivery_range.trim() === '') {
                      self.errors.add(_this10.model.id + o.type + 'delivery_range' + rIdx, 'invalid');
                      isValid = false;
                    } else {
                      for (var r2Idx in o.delivery_rules) {
                        var rule2 = o.delivery_rules[r2Idx];
                        if (rule.delivery_range === rule2.delivery_range && rIdx !== r2Idx) {
                          self.errors.add(_this10.model.id + o.type + 'delivery_range' + rIdx, 'invalid');
                          self.errors.add(_this10.model.id + o.type + 'delivery_range' + r2Idx, 'invalid');
                          isValid = false;
                        }
                      }
                    }
                  }
                }

                if (o.delivery_rules && o.delivery_rules.length && o.enabled) {
                  var uniqueCities = [];
                  for (var rIdx3 in o.delivery_rules) {
                    if (o.delivery_rules[rIdx3].subrules !== undefined && o.delivery_rules[rIdx3].subrules.length > 1) {
                      uniqueCities = [];
                      var subrules = o.delivery_rules[rIdx3].subrules;
                      var _iteratorNormalCompletion = true;
                      var _didIteratorError = false;
                      var _iteratorError = undefined;

                      try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(subrules), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                          var subrule = _step.value;

                          if (subrule.cities.length) {
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(subrule.cities), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var city = _step2.value;

                                if (uniqueCities.indexOf(city) > -1 && (subrule.neighborhoods === undefined || !subrule.neighborhoods.length)) {
                                  __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({ 'text': self.$t('settingsOrdering.citiesValidationError'), 'type': 'error', 'showConfirmButton': true }).catch(function () {});
                                  isValid = false;
                                  resolve(false);
                                  return;
                                } else {
                                  uniqueCities.push(city);
                                }
                              }
                            } catch (err) {
                              _didIteratorError2 = true;
                              _iteratorError2 = err;
                            } finally {
                              try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                  _iterator2.return();
                                }
                              } finally {
                                if (_didIteratorError2) {
                                  throw _iteratorError2;
                                }
                              }
                            }
                          }
                        }
                      } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }
                        } finally {
                          if (_didIteratorError) {
                            throw _iteratorError;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          var isEmpty = function isEmpty(v) {
            return v === '' || v === null || typeof v === 'undefined';
          };
          var preserveActiveNames = false;
          if (Array.isArray(_this10.deliveryRanges)) {
            for (var zIdx = 0; zIdx < _this10.deliveryRanges.length; zIdx++) {
              var zone = _this10.deliveryRanges[zIdx];
              var rules = zone && Array.isArray(zone.delivery_range_cost_rules) ? zone.delivery_range_cost_rules : [];
              for (var _rIdx = 0; _rIdx < rules.length; _rIdx++) {
                var _rule = rules[_rIdx];
                if (_rule && !_rule.deleted && isEmpty(_rule.distance_in_km)) {
                  __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(_rule, '__distance_required_error', Date.now());
                  isValid = false;
                  preserveActiveNames = true;

                  _this10.model.mapactive = zIdx;

                  var deliveryTab = _this10.model.id + 'delivery';
                  if (_this10.activeNames.indexOf(deliveryTab) === -1) {
                    _this10.activeNames = [deliveryTab];
                  }
                  __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
                    text: _this10.$t('settingsOrdering.distanceInKm') + ' is required.',
                    type: 'error',
                    showConfirmButton: true
                  }).catch(function () {});
                  break;
                }
              }
              if (!isValid && preserveActiveNames) break;
            }
          }

          if (isValid && Array.isArray(_this10.deliveryRanges)) {
            for (var _zIdx = 0; _zIdx < _this10.deliveryRanges.length; _zIdx++) {
              var _zone = _this10.deliveryRanges[_zIdx];
              var availabilityError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__DeliveryPreferences_zoneAvailability__["a" /* zoneAvailabilityError */])(_zone, _this10.$t.bind(_this10));
              if (availabilityError) {
                __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(_zone, '__availability_error', Date.now());
                isValid = false;
                preserveActiveNames = true;
                _this10.model.mapactive = _zIdx;
                var _deliveryTab = _this10.model.id + 'delivery';
                if (_this10.activeNames.indexOf(_deliveryTab) === -1) {
                  _this10.activeNames = [_deliveryTab];
                }
                break;
              }
            }
          }

          _this10.$nextTick().then(function () {
            if (isValid) {
              resolve(true);
            } else {
              if (!preserveActiveNames) _this10.activeNames = [];
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this10.model.ordering_management), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var order = _step3.value;

                  var tabTtl = _this10.model.id + order.type;
                  if (order.enabled && _this10.errors.items.length) {
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                      for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this10.errors.items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var err = _step4.value;

                        if (err.field.includes(tabTtl)) {
                          _this10.activeNames.push(tabTtl);
                        }
                      }
                    } catch (err) {
                      _didIteratorError4 = true;
                      _iteratorError4 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                          _iterator4.return();
                        }
                      } finally {
                        if (_didIteratorError4) {
                          throw _iteratorError4;
                        }
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }

              __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({ 'text': _this10.$t('settingsOrdering.notice'), 'type': 'error' });
              resolve(false);
            }
          });
        });
      });
    },
    showStateDrop: function showStateDrop(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);
      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return true;
      } else {
        return false;
      }
    },
    getStatesOptions: function getStatesOptions(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);
      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return countries[countryIdx].states;
      } else {
        return [];
      }
    },
    updateCountry: function updateCountry(location) {
      location.state = null;
      location.state_id = null;
    },
    addNewLocation: function addNewLocation(locId, type) {
      var _this11 = this;

      var data = {
        'token': this.$session.get('token'),
        'type': 'hashes'
      };

      this.apiRequest('/helpers', 'GET', data, function (response) {
        if (response.status) {
          var newRow = [];
          newRow = _this11.copyObject(_this11.newLocation);
          newRow.id = response.data[0].id;
          var typeIdx = _this11.getObjectByElemKeyValue('type', type, _this11.model.ordering_management);
          _this11.model.ordering_management[typeIdx].locations.push(newRow);
        } else {
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({ 'text': _this11.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    addNewRule: function addNewRule(locId, type) {
      this.$nextTick(function () {
        var self = this;
        var newRow = [];
        newRow = this.copyObject(self.newRule);
        var newSubRule = this.copyObject(self.newSubRule);
        var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.ordering_management);
        this.$nextTick().then(function () {
          newRow.subrules = [];
          newRow.subrules.push(newSubRule);
          if (self.model.ordering_management[typeIdx].delivery_rules) {
            self.model.ordering_management[typeIdx].delivery_rules.push(newRow);
          } else {
            self.model.ordering_management[typeIdx].delivery_rules = [];
            self.model.ordering_management[typeIdx].delivery_rules.push(newRow);
          }
        });
      });
    },
    addNewSubRule: function addNewSubRule(locId, type, idx) {
      this.$nextTick(function () {
        var self = this;
        var newRow = [];
        newRow = this.copyObject(self.newSubRule);
        var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.ordering_management);
        var subrules = this.model.ordering_management[typeIdx].delivery_rules[idx]['subrules'];
        this.$nextTick().then(function () {
          if (subrules) {
            self.model.ordering_management[typeIdx].delivery_rules[idx]['subrules'].push(newRow);
          } else {
            self.model.ordering_management[typeIdx].delivery_rules[idx]['subrules'] = [];
            self.model.ordering_management[typeIdx].delivery_rules[idx]['subrules'].push(newRow);
          }
        });
      });
    },
    updateTabs: function updateTabs(name, enabled) {
      this.$nextTick(function () {
        if (!enabled) {
          this.activeNames = [name];
        } else {
          this.activeNames = [];
        }
      });
    },
    removeLocation: function removeLocation(locId, idx, type) {
      var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.ordering_management);
      this.model.ordering_management[typeIdx].locations.splice(idx, 1);
    },
    removeRule: function removeRule(locId, idx, type) {
      this.$nextTick(function () {
        var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.ordering_management);
        this.$nextTick(function () {
          this.model.ordering_management[typeIdx].delivery_rules.splice(idx, 1);
        });
      });
    },
    removeSubRule: function removeSubRule(locId, idx, idxSubrule, type) {
      this.$nextTick(function () {
        var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.ordering_management);
        this.$nextTick(function () {
          this.model.ordering_management[typeIdx].delivery_rules[idx].subrules.splice(idxSubrule, 1);
        });
      });
    },
    getDeliveryMethodsDataToSave: function getDeliveryMethodsDataToSave() {
      var _this12 = this;

      this.$nextTick(function () {
        this.loading = true;
      });
      this.$emit('mapactive', this.model.mapactive);
      var countries = this.$session.get('defaultData').countries;

      var locData = this.copyObject(this.model);
      for (var orMngIdx in this.model.ordering_management) {
        if (locData.ordering_management[orMngIdx].type === 'meet_half') {
          for (var idx in locData.ordering_management[orMngIdx].locations) {
            var countryIso = locData.ordering_management[orMngIdx].locations[idx].country;
            var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);
            var states = [];
            if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
              states = countries[countryIdx].states;
            }
            if (states.length && locData.ordering_management[orMngIdx].locations[idx].state_id) {
              var state = this.getObjectByElemKeyValue('id', locData.ordering_management[orMngIdx].locations[idx].state_id, states);
              if (state !== undefined) {
                locData.ordering_management[orMngIdx].locations[idx].state = states[state].name;
              } else {
                locData.ordering_management[orMngIdx].locations[idx].state = null;
              }
            }
            delete locData.ordering_management[orMngIdx].locations[idx].states;
          }
        }
      }

      var sourceRanges = Array.isArray(this.deliveryRanges) ? this.deliveryRanges : [];
      var deliveryRanges = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(sourceRanges));
      deliveryRanges.forEach(function (range) {
        if (!range) return;
        if (_this12.taxesVersion === 2) {
          delete range.shipping_cost_vat_id;
          delete range.shipping_cost_vat_rate_id;
          delete range.shipping_cost;
          delete range.shipping_pos_id;
          delete range.min_order_value;
          delete range.extra_delivery_time;
          delete range.delivery_range_cost_rules;
        } else {
          delete range.shipping_cost_vat_rate_id;
        }
      });

      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany'),
        'delivery_methods': locData.ordering_management,
        'delivery_ranges': deliveryRanges
      };

      return data;
    },
    drawing: function drawing(obj) {},
    changeDeliveryZone: function changeDeliveryZone(obj) {
      if (obj.action === 'delete') {
        this.deliveryRanges.splice(obj.indexZone, 1);
      }
    },
    duplicateZone: function duplicateZone(indexZone) {
      var source = this.deliveryRanges[indexZone];
      if (!source) return;

      var clone = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(source));
      delete clone.id;
      clone.name = (clone.name || '') + ' (copy)';
      if (Array.isArray(clone.delivery_range_cost_rules)) {
        clone.delivery_range_cost_rules.forEach(function (rule) {
          if (!rule) return;
          delete rule.id;
          delete rule.delivery_ranges_id;
        });
      }

      this.deliveryRanges.push(clone);
      this.model.mapactive = this.deliveryRanges.length - 1;
    },
    addNewZone: function addNewZone(locId, type) {
      this.pushEmptyDeliveryZones(locId);
    },
    pushEmptyDeliveryZones: function pushEmptyDeliveryZones(locId) {
      if (!this.deliveryRanges) {
        this.deliveryRanges = [];
      }
      var length = this.deliveryRanges.push({
        'name': '',
        'shape': {},
        'shipping_cost_vat_rate_id': null
      });
      this.model.mapactive = length - 1;
    },
    handleChangeArea: function handleChangeArea(area, locId) {
      var _this13 = this;

      this.$nextTick(function () {
        if (area === 'draw') {
          if (!_this13.deliveryRanges) {
            _this13.deliveryRanges = [];
          }
          if (!_this13.deliveryRanges.length) {
            _this13.pushEmptyDeliveryZones(locId);
          }
        }
      });
    },
    addMethodInfo: function addMethodInfo(orderIdx) {
      var newRow = {
        'title': '',
        'type': 'check',
        'options': []
      };

      if (!this.model.ordering_management[orderIdx].hasOwnProperty('method_info') || !this.model.ordering_management[orderIdx].method_info) {
        __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model.ordering_management[orderIdx], 'method_info', []);
      }

      this.model.ordering_management[orderIdx].method_info.push(newRow);

      this.methodInfoIndex = this.model.ordering_management[orderIdx].method_info ? this.model.ordering_management[orderIdx].method_info.length - 1 : 0;
    },
    deleteMethodInfo: function deleteMethodInfo(orderIdx, id) {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
        text: this.$t('catalogProdOpt.areyouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this14.methodInfoIndex = _this14.model.ordering_management[orderIdx].method_info.splice(id, 1);
        }
      });
    },
    addMethodInfoOptionValue: function addMethodInfoOptionValue(orderIdx, optIdx) {
      var newRow = {
        'title': ''
      };
      this.model.ordering_management[orderIdx].method_info[optIdx].options.push(newRow);
    },
    deleteMethodInfoOptionValue: function deleteMethodInfoOptionValue(orderIdx, optIdx, idx) {
      this.model.ordering_management[orderIdx].method_info[optIdx].options.splice(idx, 1);
    },
    deleteReservationsIntervalsValue: function deleteReservationsIntervalsValue(orderIdx, resIntIdx) {
      this.model.ordering_management[orderIdx].reservations_intervals.splice(resIntIdx, 1);
    },
    addMoreReservationsIntervals: function addMoreReservationsIntervals(orderIdx) {
      if (!Array.isArray(this.model.ordering_management[orderIdx].reservations_intervals)) {
        this.model.ordering_management[orderIdx].reservations_intervals = [];
      }


      this.model.ordering_management[orderIdx].reservations_intervals.push('');
    },
    changeDeliveryHourUsage: function changeDeliveryHourUsage(order) {
      order.hour_and_date_delivery_hour_usage = false;
      order.just_date_delivery_hour_usage = false;
      order.deactivate_delivery_hour_usage = false;

      switch (order.delivery_hour_usage) {
        case 0:
          order.hour_and_date_delivery_hour_usage = true;
          break;
        case 1:
          order.just_date_delivery_hour_usage = true;
          break;
        default:
          order.deactivate_delivery_hour_usage = true;
      }
    },
    addMoreIntervals: function addMoreIntervals(dayIdx, orderIdx) {
      var index = 0;
      if (!this.model.ordering_management[orderIdx].available_days[dayIdx].hasOwnProperty('intervals')) {
        __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model.ordering_management[orderIdx].available_days[dayIdx], 'intervals', []);
      } else {
        index = this.model.ordering_management[orderIdx].available_days[dayIdx].intervals.length;
      }
      var newObj = {
        'open_from': '',
        'open_to': ''
      };
      __WEBPACK_IMPORTED_MODULE_19_vue___default.a.set(this.model.ordering_management[orderIdx].available_days[dayIdx].intervals, index, newObj);
    },
    deleteIntervals: function deleteIntervals(intervalKey, dayIdx, orderIdx) {
      this.model.ordering_management[orderIdx].available_days[dayIdx].intervals.splice(intervalKey, 1);
    },
    addReservationTaxesInfo: function addReservationTaxesInfo(orderIdx) {
      this.model.ordering_management[orderIdx].reservation_taxes.push({
        'id': 0,
        'name': 'Rezervare',
        'price': 0,
        'is_advance_consumption': false,
        'table_zone_id': 0,
        'date_from': '',
        'date_to': '',
        'deleted_at': null
      });
    },
    deleteReservationTaxesInfo: function deleteReservationTaxesInfo(orderIdx, idTax) {
      var _this15 = this;

      __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
        text: this.$t('catalogProdOpt.areyouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          if (_this15.model.ordering_management[orderIdx].reservation_taxes[idTax].id) {
            _this15.model.ordering_management[orderIdx].reservation_taxes[idTax].deleted_at = 1;
          } else {
            _this15.reservationTaxesIndex = _this15.model.ordering_management[orderIdx].reservation_taxes.splice(idTax, 1);
          }
        }
      });
    },
    isAutoChangeEnabledChange: function isAutoChangeEnabledChange(orderIdx) {
      if (!this.isAutoChangeEnabled[orderIdx]) {
        this.model.ordering_management[orderIdx].status_from_auto_change = null;
        this.model.ordering_management[orderIdx].status_to_auto_change = null;
        this.model.ordering_management[orderIdx].auto_change_status_after_min = null;
      }
    },
    goToCompany: function goToCompany() {
      this.$session.set('selectedTab', this.$t('settingsPages.locationGroups'));
      window.location.reload(true);
    }
  }
});

/***/ }),

/***/ "EGZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticStyle:{"overflow":"hidden"}},[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_vm._t("back-button",[(!_vm.fromExternal)?_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.cancelTable($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")]):_vm._e()])],2),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteTable($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch","flex-wrap":"wrap"}},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{class:_vm.model.type === 'Kiosk' ? 'card' : '',staticStyle:{"width":"100%","position":"relative"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{class:_vm.model.type === 'Kiosk' ? 'card-content' : ''},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row qr-settings-grid"},[_c('div',{class:_vm.model.type !== 'Kiosk' ? 'col-md-6 qr-card-column' : 'col-md-12'},[_c('div',{staticClass:"qr-card-slot"},[_c('div',{class:_vm.model.type !== 'Kiosk' ? 'card' : '',attrs:{"data-qr-section":"general"}},[(_vm.model.type !== 'Kiosk')?_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('settingTable.qrGeneralSettings')))])]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.model.type !== 'Kiosk' ? 'card-content' : ''},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("ID: "+_vm._s(_vm.model.id))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.table_colors_string),expression:"model.table_colors_string"}],staticClass:"form-group"},[_c('label',[_vm._v("Colors")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.table_colors_string),expression:"modelValidate.table_colors_string"},{name:"model",rawName:"v-model",value:(_vm.model.table_colors_string),expression:"model.table_colors_string"}],staticClass:"form-control",attrs:{"type":"text","name":"table_colors_string","data-vv-as":"table_colors_string","placeholder":"Colors"},domProps:{"value":(_vm.model.table_colors_string)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "table_colors_string", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('table_colors_string'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError('table_colors_string'))+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.location')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.location_id),expression:"modelValidate.location_id"},{name:"model",rawName:"v-model",value:(_vm.model.location_id),expression:"model.location_id"}],staticClass:"form-control",attrs:{"name":"location","disabled":_vm.autoselectLocation ? true : false},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.true_id,attrs:{"label":loc.name},domProps:{"value":loc.true_id}})})),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.invalid),expression:"type.invalid"}],staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError('type'))+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.type')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.type),expression:"modelValidate.type"},{name:"model",rawName:"v-model",value:(_vm.model.type),expression:"model.type"}],staticClass:"form-control",attrs:{"name":"type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.type),function(t){return _c('option',{key:t,attrs:{"label":t},domProps:{"value":t}})})),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.invalid),expression:"type.invalid"}],staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError('type'))+"\n                          ")])]),_vm._v(" "),(_vm.model.type != 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.table_shape')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.table_shape),expression:"modelValidate.table_shape"},{name:"model",rawName:"v-model",value:(_vm.model.table_shape),expression:"model.table_shape"}],staticClass:"form-control",attrs:{"name":"type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "table_shape", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:"squere",attrs:{"selected":"","value":"squere","label":_vm.$t('settingTable.squere')}}),_vm._v(" "),_c('option',{key:"round",attrs:{"value":"round","label":_vm.$t('settingTable.round')}})]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.invalid),expression:"type.invalid"}],staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError('type'))+"\n                          ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.zone')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.zone),expression:"modelValidate.zone"},{name:"model",rawName:"v-model",value:(_vm.model.table_zones_id),expression:"model.table_zones_id"}],staticClass:"form-control",attrs:{"name":"zone"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "table_zones_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.zone),function(z){return _c('option',{key:z.id,attrs:{"label":z.name},domProps:{"value":z.id}})})),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.zone.invalid),expression:"zone.invalid"}],staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError('zone'))+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.model.type == 'Kiosk' ? _vm.$t('settingTable.kioskName') : _vm.$t('settingTable.number', {type: _vm.model.type})))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.number),expression:"modelValidate.number"},{name:"model",rawName:"v-model",value:(_vm.model.number),expression:"model.number"}],staticClass:"form-control",attrs:{"type":"text","name":"number","data-vv-as":_vm.model.type == 'Kiosk' ? 'name' : 'number',"placeholder":_vm.model.type == 'Kiosk' ? _vm.$t('settingTable.kioskName') : _vm.$t('settingTable.number')},domProps:{"value":(_vm.model.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "number", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('number'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError('number'))+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.externalId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.external_id),expression:"model.external_id"}],staticClass:"form-control",attrs:{"type":"text","name":"external_id","data-vv-as":"external_id","placeholder":_vm.$t('settingTable.externalIdPlaceholder')},domProps:{"value":(_vm.model.external_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "external_id", $event.target.value)}}})])])])]),_vm._v(" "),(_vm.model.type !== 'Kiosk')?_c('div',{staticClass:"qr-card-slot"},[_c('div',{staticClass:"card",attrs:{"data-qr-section":"capacity"}},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('settingTable.qrCapacitySettings')))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.model.type != 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"use_fiscal_net",attrs:{"label":_vm.$t('settingTable.app_available'),"inline":true},model:{value:(_vm.model.app_available),callback:function ($$v) {_vm.$set(_vm.model, "app_available", $$v)},expression:"model.app_available"}},[_vm._v(_vm._s(_vm.$t('settingTable.app_available'))+"\n                          ")])],1):_vm._e(),_vm._v(" "),(_vm.model.type != 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.min_pers')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.min_pers),expression:"modelValidate.min_pers"},{name:"model",rawName:"v-model",value:(_vm.model.min_pers),expression:"model.min_pers"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"30","name":"min_pers","data-vv-as":"min_pers"},domProps:{"value":(_vm.model.min_pers)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "min_pers", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('min_pers'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError('min_pers'))+"\n                          ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.type != 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.max_pers')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.max_pers),expression:"modelValidate.max_pers"},{name:"model",rawName:"v-model",value:(_vm.model.max_pers),expression:"model.max_pers"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"30","name":"max_pers","data-vv-as":"max_pers"},domProps:{"value":(_vm.model.max_pers)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "max_pers", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('max_pers'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError('max_pers'))+"\n                          ")]):_vm._e()]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.model.type !== 'Kiosk' && _vm.model.qr_offline)?_c('div',{staticClass:"qr-card-slot"},[_c('div',{staticClass:"card",attrs:{"data-qr-section":"numbering"}},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('settingTable.qrNumberingSettings')))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.model.qr_offline)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.series')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.series),expression:"modelValidate.series"},{name:"model",rawName:"v-model",value:(_vm.model.series),expression:"model.series"}],staticClass:"form-control",attrs:{"type":"text","name":"series","placeholder":_vm.$t('settingTable.series')},domProps:{"value":(_vm.model.series)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "series", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.start_number')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.start_number),expression:"modelValidate.start_number"},{name:"model",rawName:"v-model",value:(_vm.model.start_number),expression:"model.start_number"}],staticClass:"form-control",attrs:{"type":"number","name":"start_number","placeholder":_vm.$t('settingTable.start_number')},domProps:{"value":(_vm.model.start_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "start_number", $event.target.value)}}})])])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),(_vm.model.type !== 'Kiosk')?_c('div',{staticClass:"col-md-6 qr-card-column"},[(_vm.model.type !== 'Kiosk')?_c('div',{staticClass:"qr-card-slot"},[_c('div',{staticClass:"card",attrs:{"data-qr-section":"connection"}},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('settingTable.qrConnectionSettings')))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.model.type !== 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"qr_offline",attrs:{"label":_vm.$t('settingTable.qr_offline'),"inline":true},model:{value:(_vm.model.qr_offline),callback:function ($$v) {_vm.$set(_vm.model, "qr_offline", $$v)},expression:"model.qr_offline"}},[_vm._v(_vm._s(_vm.$t('settingTable.qr_offline')))]),_vm._v(" "),(_vm.model.qr_offline && _vm.model.id)?_c('p',{staticStyle:{"margin":"8px 0 0"}},[_vm._v("\n                            "+_vm._s(_vm.$t('settingTable.offlineLoginCode'))+" "+_vm._s(_vm.model.company_id || _vm.company_id)+"."+_vm._s(_vm.model.id)+"\n                          ")]):_vm._e(),_vm._v(" "),(_vm.offlineUrl && _vm.model.type !== 'Kiosk')?_c('div',{staticClass:"offline-url"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":"","aria-label":"Offline URL"},domProps:{"value":_vm.offlineUrl},on:{"click":function($event){$event.target.select()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-purple btn-fill",attrs:{"type":"button"},on:{"click":function($event){_vm.copyToClipboard(_vm.offlineUrl)}}},[_c('i',{staticClass:"fa fa-copy",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('general.copyUrlToClipboard'))+"\n                            ")])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.model.qr_offline)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.server_ip')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.server_pos_ip),expression:"model.server_pos_ip"},{name:"validate",rawName:"v-validate",value:(_vm.model.type !== 'Kiosk' && _vm.model.qr_offline ? 'required' : ''),expression:"model.type !== 'Kiosk' && model.qr_offline ? 'required' : ''"}],staticClass:"form-control",attrs:{"type":"text","name":"server_pos_ip","placeholder":_vm.$t('settingTable.server_ip'),"data-vv-as":_vm.$t('settingTable.server_ip')},domProps:{"value":(_vm.model.server_pos_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "server_pos_ip", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('server_pos_ip'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('server_pos_ip')))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.qr_offline)?_c('div',{staticClass:"form-group mar-to-15"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.yumm_integration_external_ip')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.yumm_integration_external_ip),expression:"model.yumm_integration_external_ip"}],staticClass:"form-control",staticStyle:{"max-width":"280px"},attrs:{"type":"text","name":"yumm_integration_external_ip","placeholder":"Ip"},domProps:{"value":(_vm.model.yumm_integration_external_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "yumm_integration_external_ip", $event.target.value)}}})]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.model.type !== 'Kiosk')?_c('div',{staticClass:"qr-card-slot"},[_c('div',{staticClass:"card",attrs:{"data-qr-section":"service"}},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('settingTable.qrServiceSettings')))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.model.qr_offline)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.qrServiceCode')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.login_code),expression:"model.login_code"}],staticClass:"form-control",attrs:{"type":"text","name":"login_code","maxlength":"191"},domProps:{"value":(_vm.model.login_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "login_code", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('login_code'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('login_code')))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.type != 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.waiters')))]),_vm._v(" "),_c('el-select',{staticClass:"qr-waiter-select",class:{'has-overflow': _vm.selectedWaiterIds.length > 3},style:(_vm.waiterSelectStyle),attrs:{"multiple":"","filterable":"","placeholder":_vm.$t('settingTable.assignWaiter')},model:{value:(_vm.selectedWaiterIds),callback:function ($$v) {_vm.selectedWaiterIds=$$v},expression:"selectedWaiterIds"}},_vm._l((_vm.waiterOptions),function(user){return _c('el-option',{key:user.id,attrs:{"label":user.fullname,"value":user.id}})})),_vm._v(" "),(_vm.errors.has('users'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError('users'))+"\n                          ")]):_vm._e()],1):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.model.id)?_c('div',{staticClass:"qr-preview"},[_c('div',{staticClass:"card",staticStyle:{"width":"100%","margin":"0"}},[_c('div',{staticClass:"card-content",staticStyle:{"width":"100%","margin":"0"}},[_c('div',{staticClass:"middle",staticStyle:{"width":"100%"}},[_c('img',{attrs:{"src":_vm.model.qr_code,"alt":"qrCode","data-link":_vm.model.qr_link},on:{"click":function($event){_vm.copyToClipboard(_vm.model.qr_link)}}}),_vm._v(" "),_c('a',{staticClass:"btn btn-info btn-icon duplicate-prod mar-to-15",attrs:{"href":this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + _vm.model.qr_code + '&name=' + _vm.model.type + ' ' + _vm.model.number + '.png',"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('upload.download')))]),_vm._v(" "),_c('input',{staticClass:"copy_link",attrs:{"type":"text","disabled":"true"},domProps:{"value":_vm.model.qr_link},on:{"click":function($event){_vm.copyToClipboard(_vm.model.qr_link)}}}),_vm._v(" "),(_vm.model.type == 'Kiosk')?[_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('p',{staticStyle:{"margin":"0","min-width":"110px"}},[_vm._v(_vm._s(_vm.$t('settingTable.loginCode')))]),_vm._v(" "),_c('input',{staticClass:"copy_link",staticStyle:{"margin":"0"},attrs:{"type":"text","disabled":"true"},domProps:{"value":_vm.model.login_code},on:{"click":function($event){_vm.copyToClipboard(_vm.model.login_code)}}})])]:_vm._e()],2)])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.type !== 'Kiosk')?_c('div',{staticClass:"col-md-12"},[(_vm.model.type !== 'Kiosk')?_c('qr-payment-settings',{attrs:{"pos-options":_vm.qrPosOptions,"legacy-bank-provider":_vm.model.bank_terminal_provider || (_vm.model.with_viva_wallet ? 'viva_wallet' : null),"error-bag":_vm.errors},model:{value:(_vm.model.qr_payment_methods),callback:function ($$v) {_vm.$set(_vm.model, "qr_payment_methods", $$v)},expression:"model.qr_payment_methods"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.model.type === 'Kiosk')?_c('div',{staticClass:"col-md-12"},[(_vm.model.type == 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"kiosk_offline",attrs:{"label":_vm.$t('settingTable.kiosk_offline'),"inline":true},model:{value:(_vm.model.kiosk_offline),callback:function ($$v) {_vm.$set(_vm.model, "kiosk_offline", $$v)},expression:"model.kiosk_offline"}},[_vm._v(_vm._s(_vm.$t('settingTable.kiosk_offline'))+"\n                    ")]),_vm._v(" "),(_vm.model.kiosk_offline && _vm.model.id)?_c('p',{staticStyle:{"margin":"8px 0 0"}},[_vm._v("\n                      "+_vm._s(_vm.$t('settingTable.offlineLoginCode'))+" "+_vm._s(_vm.model.company_id || _vm.company_id)+"."+_vm._s(_vm.model.id)+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.offlineUrl && _vm.model.type === 'Kiosk')?_c('div',{staticClass:"offline-url"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":"","aria-label":"Offline URL"},domProps:{"value":_vm.offlineUrl}}),_vm._v(" "),_c('button',{staticClass:"btn btn-purple btn-fill",attrs:{"type":"button"},on:{"click":function($event){_vm.copyToClipboard(_vm.offlineUrl)}}},[_c('i',{staticClass:"fa fa-copy",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('general.copyUrlToClipboard'))+"\n                      ")])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.model.type === 'Kiosk')?_c('kiosk-video-input',{attrs:{"company-id":_vm.model.company_id || _vm.company_id,"location-id":_vm.model.location_id,"table-id":_vm.model.id || null},model:{value:(_vm.model.videos),callback:function ($$v) {_vm.$set(_vm.model, "videos", $$v)},expression:"model.videos"}}):_vm._e(),_vm._v(" "),(_vm.model.type === 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"kiosk-ga4-code"}},[_vm._v(_vm._s(_vm.$t('settingsWeb.g4a')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ga4Code),expression:"model.ga4Code"}],staticClass:"form-control",attrs:{"id":"kiosk-ga4-code","type":"text","name":"ga4Code","placeholder":"G-XXXXXXXXXX","maxlength":"255"},domProps:{"value":(_vm.model.ga4Code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ga4Code", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('ga4Code'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('ga4Code'))+"\n                    ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.type === 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.server_ip')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.server_pos_ip),expression:"model.server_pos_ip"},{name:"validate",rawName:"v-validate",value:(_vm.model.type !== 'Kiosk' && _vm.model.qr_offline ? 'required' : ''),expression:"model.type !== 'Kiosk' && model.qr_offline ? 'required' : ''"}],staticClass:"form-control",attrs:{"type":"text","name":"server_pos_ip","placeholder":_vm.$t('settingTable.server_ip'),"data-vv-as":_vm.$t('settingTable.server_ip')},domProps:{"value":(_vm.model.server_pos_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "server_pos_ip", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('server_pos_ip'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('server_pos_ip')))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.type === 'Kiosk')?_c('div',{staticClass:"form-group mar-to-15"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.yumm_integration_external_ip')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.yumm_integration_external_ip),expression:"model.yumm_integration_external_ip"}],staticClass:"form-control",staticStyle:{"max-width":"280px"},attrs:{"type":"text","name":"yumm_integration_external_ip","placeholder":"Ip"},domProps:{"value":(_vm.model.yumm_integration_external_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "yumm_integration_external_ip", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.model.type == 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Scaner Position")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.scaner_position),expression:"model.scaner_position"}],staticClass:"form-control",attrs:{"name":"scaner_position"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "scaner_position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:"left",attrs:{"value":"left","label":"Left"}}),_vm._v(" "),_c('option',{key:"center",attrs:{"value":"center","label":"Center"}}),_vm._v(" "),_c('option',{key:"right",attrs:{"value":"right","label":"Right"}})])]):_vm._e(),_vm._v(" "),(_vm.model.type === 'Kiosk' || _vm.model.qr_offline)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.series')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.series),expression:"modelValidate.series"},{name:"model",rawName:"v-model",value:(_vm.model.series),expression:"model.series"}],staticClass:"form-control",attrs:{"type":"text","name":"series","placeholder":_vm.$t('settingTable.series')},domProps:{"value":(_vm.model.series)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "series", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.start_number')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.start_number),expression:"modelValidate.start_number"},{name:"model",rawName:"v-model",value:(_vm.model.start_number),expression:"model.start_number"}],staticClass:"form-control",attrs:{"type":"number","name":"start_number","placeholder":_vm.$t('settingTable.start_number')},domProps:{"value":(_vm.model.start_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "start_number", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(_vm.model.type == 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.kioskUrl')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.kioskUrl),expression:"kioskUrl"}],staticClass:"form-control",attrs:{"type":"text","name":"kioskUrl","disabled":"true"},domProps:{"value":(_vm.kioskUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.kioskUrl=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.model.type == 'Kiosk')?_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"use_fiscal_net",staticClass:"margin-left-10",attrs:{"label":_vm.$t('settingTable.use_fiscal_net'),"inline":true},model:{value:(_vm.model.use_fiscal_net),callback:function ($$v) {_vm.$set(_vm.model, "use_fiscal_net", $$v)},expression:"model.use_fiscal_net"}},[_vm._v(_vm._s(_vm.$t('settingTable.use_fiscal_net'))+"\n                    ")]),_vm._v(" "),_c('p-checkbox',{key:"use_fiscal_net_with_pos",staticClass:"margin-left-10",attrs:{"label":_vm.$t('settingTable.use_fiscal_net_with_pos'),"inline":true},model:{value:(_vm.model.use_fiscal_net_with_pos),callback:function ($$v) {_vm.$set(_vm.model, "use_fiscal_net_with_pos", $$v)},expression:"model.use_fiscal_net_with_pos"}},[_vm._v(_vm._s(_vm.$t('settingTable.use_fiscal_net_with_pos'))+"\n                    ")]),_vm._v(" "),_c('p-checkbox',{key:"use_pager",staticClass:"margin-left-10",attrs:{"label":_vm.$t('settingTable.use_pager'),"inline":true},model:{value:(_vm.model.use_pager),callback:function ($$v) {_vm.$set(_vm.model, "use_pager", $$v)},expression:"model.use_pager"}},[_vm._v(_vm._s(_vm.$t('settingTable.use_pager'))+"\n                    ")]),_vm._v(" "),_c('p-checkbox',{key:"use_cash_machine",staticClass:"margin-left-10",attrs:{"label":_vm.$t('settingTable.use_cash_machine'),"inline":true},model:{value:(_vm.model.use_cash_machine),callback:function ($$v) {_vm.$set(_vm.model, "use_cash_machine", $$v)},expression:"model.use_cash_machine"}},[_vm._v(_vm._s(_vm.$t('settingTable.use_cash_machine'))+"\n                    ")]),_vm._v(" "),_c('p-checkbox',{key:"disable_cash_payment",staticClass:"margin-left-10",attrs:{"label":_vm.$t('settingTable.disable_cash_payment'),"inline":true},model:{value:(_vm.model.disable_cash_payment),callback:function ($$v) {_vm.$set(_vm.model, "disable_cash_payment", $$v)},expression:"model.disable_cash_payment"}},[_vm._v(_vm._s(_vm.$t('settingTable.disable_cash_payment'))+"\n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-checkbox',{key:"kiosk_is_using_fiscal_receipt_for_sections",staticClass:"margin-left-10",attrs:{"label":_vm.$t('settingTable.kiosk_is_using_fiscal_receipt_for_sections'),"inline":true},model:{value:(_vm.model.kiosk_is_using_fiscal_receipt_for_sections),callback:function ($$v) {_vm.$set(_vm.model, "kiosk_is_using_fiscal_receipt_for_sections", $$v)},expression:"model.kiosk_is_using_fiscal_receipt_for_sections"}},[_vm._v(_vm._s(_vm.$t('settingTable.kiosk_is_using_fiscal_receipt_for_sections'))+"\n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-checkbox',{key:"use_tips",staticClass:"margin-left-10",attrs:{"label":_vm.$t('settingTable.use_tips'),"inline":true},model:{value:(_vm.model.use_tips),callback:function ($$v) {_vm.$set(_vm.model, "use_tips", $$v)},expression:"model.use_tips"}},[_vm._v(_vm._s(_vm.$t('settingTable.use_tips'))+"\n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-checkbox',{key:"use_methods",staticClass:"margin-left-10",attrs:{"label":_vm.$t('settingTable.use_methods'),"inline":true},model:{value:(_vm.model.use_methods),callback:function ($$v) {_vm.$set(_vm.model, "use_methods", $$v)},expression:"model.use_methods"}},[_vm._v(_vm._s(_vm.$t('settingTable.use_methods'))+"\n                    ")])],1):_vm._e(),_vm._v(" "),(_vm.model.type == 'Kiosk' && _vm.model.use_fiscal_net)?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fiscal Printer")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.fiscal_printer_id),expression:"model.fiscal_printer_id"}],staticClass:"form-control",attrs:{"name":"location"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "fiscal_printer_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.none')))]),_vm._v(" "),_vm._l((_vm.fiscalPrinter),function(el){return _c('option',{key:el.id,attrs:{"label":el.series},domProps:{"value":el.id}})})],2)])]):_vm._e()],1):_vm._e()])])])])])]),_vm._v(" "),(_vm.model.id && _vm.model.type === 'Kiosk' && !_vm.model.kiosk_offline)?_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{staticClass:"card-content",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{staticClass:"middle",staticStyle:{"height":"100%","width":"100%"}},[_c('img',{attrs:{"src":_vm.model.qr_code,"alt":"qrCode","data-link":_vm.model.qr_link},on:{"click":function($event){_vm.copyToClipboard(_vm.model.qr_link)}}}),_vm._v(" "),_c('a',{staticClass:"btn btn-info btn-icon duplicate-prod mar-to-15",attrs:{"href":this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + _vm.model.qr_code + '&name=' + _vm.model.type + ' ' + _vm.model.number + '.png',"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('upload.download')))]),_vm._v(" "),_c('input',{staticClass:"copy_link",attrs:{"type":"text","disabled":"true"},domProps:{"value":_vm.model.qr_link},on:{"click":function($event){_vm.copyToClipboard(_vm.model.qr_link)}}}),_vm._v(" "),(_vm.model.type == 'Kiosk')?[_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('p',{staticStyle:{"margin":"0","min-width":"110px"}},[_vm._v(_vm._s(_vm.$t('settingTable.loginCode')))]),_vm._v(" "),_c('input',{staticClass:"copy_link",staticStyle:{"margin":"0"},attrs:{"type":"text","disabled":"true"},domProps:{"value":_vm.model.login_code},on:{"click":function($event){_vm.copyToClipboard(_vm.model.login_code)}}})])]:_vm._e()],2)])])]):_vm._e()]),_vm._v(" "),(_vm.model.id && _vm.showOnlineQr)?_c('div',{staticClass:"row mar-to-15",staticStyle:{"margin-top":"30px"}},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"margin":"0"}},[_c('div',{staticClass:"card-content",staticStyle:{"position":"relative"}},[_c('div',{class:(_vm.onlineQrLoading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('h4',{staticStyle:{"margin":"0 0 4px","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('settingTable.onlineQrTitle')))]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0 0 20px","color":"#9a9a9a","font-size":"13px"}},[_vm._v(_vm._s(_vm.$t('settingTable.onlineQrDesc')))]),_vm._v(" "),(_vm.model.online_qr_token)?_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"width":"200px","height":"200px","max-width":"100%","cursor":"pointer","border":"1px solid #eee","border-radius":"8px","padding":"6px"},attrs:{"src":_vm.onlineQrImage,"alt":"onlineQrCode"},on:{"click":function($event){_vm.copyToClipboard(_vm.onlineQrLink)}}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"8px","margin":"16px auto 0","max-width":"380px"}},[_c('input',{staticClass:"form-control",staticStyle:{"flex":"1","font-size":"12px","cursor":"pointer"},attrs:{"type":"text","readonly":""},domProps:{"value":_vm.onlineQrLink},on:{"click":function($event){_vm.copyToClipboard(_vm.onlineQrLink)}}}),_vm._v(" "),_c('a',{staticClass:"btn btn-info btn-icon",staticStyle:{"margin":"0","white-space":"nowrap"},on:{"click":function($event){$event.preventDefault();_vm.copyToClipboard(_vm.onlineQrLink)}}},[_vm._v("\n                "+_vm._s(_vm.$t('settingTable.onlineQrCopy'))+"\n              ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"16px","display":"flex","gap":"8px","justify-content":"center","flex-wrap":"wrap"}},[_c('a',{staticClass:"btn btn-orange btn-icon",staticStyle:{"margin":"0"},on:{"click":function($event){$event.preventDefault();return _vm.generateOnlineQr($event)}}},[_vm._v("\n                "+_vm._s(_vm.$t('settingTable.onlineQrRegenerate'))+"\n              ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-info btn-icon",staticStyle:{"margin":"0"},attrs:{"href":_vm.apiUrl + '/settings/download?token=' + _vm.$session.get('token') + '&url=' + _vm.onlineQrImage + '&name=online ' + _vm.model.type + ' ' + _vm.model.number + '.png',"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('upload.download')))])])]):_c('div',{staticStyle:{"text-align":"center","padding":"24px 0"}},[_c('p',{staticStyle:{"color":"#9a9a9a","margin-bottom":"20px"}},[_vm._v(_vm._s(_vm.$t('settingTable.onlineQrEmpty')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-orange btn-icon",staticStyle:{"margin":"0"},on:{"click":function($event){$event.preventDefault();return _vm.generateOnlineQr($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('settingTable.onlineQrGenerate'))+"\n            ")])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch","margin-top":"30px"}},[(_vm.model.type == 'Kiosk')?_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{staticClass:"card-content",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('h3',{staticStyle:{"margin-top":"0"}},[_vm._v(_vm._s(_vm.$t('settingTable.posSet')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.type')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos),expression:"model.pos"}],staticClass:"form-control",attrs:{"name":"pos"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "pos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:0,attrs:{"label":''},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.pos),function(z){return _c('option',{key:z.id,attrs:{"label":z.name},domProps:{"value":(_vm.model.pos && z.id == _vm.model.pos.id) ? _vm.model.pos : z}})})],2)]),_vm._v(" "),(_vm.model.pos)?[(_vm.isVivaWalletPos)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.host')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos.host),expression:"model.pos.host"}],staticClass:"form-control",attrs:{"type":"text","name":"model.pos.host","data-vv-as":"model.pos.host","placeholder":_vm.$t('settingTable.host')},domProps:{"value":(_vm.model.pos.host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.pos, "host", $event.target.value)}}})]):(typeof _vm.model.pos.ip !== 'undefined' && _vm.model.pos.ip != null)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.ip')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos.ip),expression:"model.pos.ip"}],staticClass:"form-control",attrs:{"type":"text","name":"model.pos.ip","data-vv-as":"model.pos.ip","placeholder":_vm.$t('settingTable.ip')},domProps:{"value":(_vm.model.pos.ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.pos, "ip", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(typeof _vm.model.pos.port !== 'undefined' && _vm.model.pos.port != null)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.terminal_port')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos.port),expression:"model.pos.port"}],staticClass:"form-control",attrs:{"type":"text","name":"model.pos.port","data-vv-as":"model.pos.port","placeholder":_vm.$t('settingTable.terminal_port')},domProps:{"value":(_vm.model.pos.port)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.pos, "port", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.hasPosServerFields)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.server_ip')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos.server_ip),expression:"model.pos.server_ip"}],staticClass:"form-control",attrs:{"type":"text","name":"model.pos.server_ip","data-vv-as":"model.pos.server_ip","placeholder":_vm.$t('settingTable.server_ip')},domProps:{"value":(_vm.model.pos.server_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.pos, "server_ip", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.hasPosServerFields)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.server_port')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos.server_port),expression:"model.pos.server_port"}],staticClass:"form-control",attrs:{"type":"text","name":"model.pos.server_port","data-vv-as":"model.pos.server_port","placeholder":_vm.$t('settingTable.server_port')},domProps:{"value":(_vm.model.pos.server_port)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.pos, "server_port", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(typeof _vm.model.pos.tid_mid !== 'undefined' && _vm.model.pos.tid_mid != null)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("TID/MID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos.tid_mid),expression:"model.pos.tid_mid"}],staticClass:"form-control",attrs:{"type":"text","name":"TID/MID","data-vv-as":"model.pos.tid_mid","placeholder":"TID/MID"},domProps:{"value":(_vm.model.pos.tid_mid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.pos, "tid_mid", $event.target.value)}}})]):_vm._e()]:_vm._e()],2)])]):_vm._e(),_vm._v(" "),(_vm.model.type == 'Kiosk')?_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{staticClass:"card-content",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('h3',{staticStyle:{"margin-top":"0"}},[_vm._v(_vm._s(_vm.$t('settingTable.printerSet')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.type')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.printer),expression:"modelValidate.printer"},{name:"model",rawName:"v-model",value:(_vm.model.printer),expression:"model.printer"}],staticClass:"form-control",attrs:{"name":"printer"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "printer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:0,attrs:{"label":''},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.printer),function(z){return _c('option',{key:z.id,attrs:{"label":z.name},domProps:{"value":(_vm.model.printer && z.id == _vm.model.printer.id) ? _vm.model.printer : z}})})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.printer.invalid),expression:"printer.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('printer'))+"\n            ")])]),_vm._v(" "),(_vm.model.printer)?[(typeof _vm.model.printer.p1 !== 'undefined')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.p1')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.printer.p1),expression:"model.printer.p1"}],staticClass:"form-control",attrs:{"type":"text","name":"model.printer.p1","data-vv-as":"model.printer.p1","placeholder":_vm.$t('settingTable.p1')},domProps:{"value":(_vm.model.printer.p1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.printer, "p1", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(typeof _vm.model.printer.p2 !== 'undefined')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.p2')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.printer.p2),expression:"model.printer.p2"}],staticClass:"form-control",attrs:{"type":"text","name":"model.printer.p2","data-vv-as":"model.printer.p2","placeholder":_vm.$t('settingTable.p2')},domProps:{"value":(_vm.model.printer.p2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.printer, "p2", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(typeof _vm.model.printer.ip !== 'undefined')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.ip')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.printer.ip),expression:"model.printer.ip"}],staticClass:"form-control",attrs:{"type":"text","name":"model.printer.ip","data-vv-as":"model.printer.ip","placeholder":_vm.$t('settingTable.ip')},domProps:{"value":(_vm.model.printer.ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.printer, "ip", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(typeof _vm.model.printer.port !== 'undefined')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.port')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.printer.port),expression:"model.printer.port"}],staticClass:"form-control",attrs:{"type":"text","name":"model.printer.port","data-vv-as":"model.printer.port","placeholder":_vm.$t('settingTable.port')},domProps:{"value":(_vm.model.printer.port)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.printer, "port", $event.target.value)}}})]):_vm._e()]:_vm._e()],2)])]):_vm._e(),_vm._v(" "),(_vm.model.type == 'Kiosk')?_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{staticClass:"card-content",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('h3',{staticStyle:{"margin-top":"0"}},[_vm._v(_vm._s(_vm.$t('settingTable.fiscalSet')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.type')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.fiscal),expression:"model.fiscal"}],staticClass:"form-control",attrs:{"name":"fiscal"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "fiscal", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:0,attrs:{"label":''},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.fiscal),function(z){return _c('option',{key:z.id,attrs:{"label":z.name},domProps:{"value":(_vm.model.fiscal && z.id == _vm.model.fiscal.id) ? _vm.model.fiscal : z}})})],2)]),_vm._v(" "),(_vm.model.fiscal)?[(typeof _vm.model.fiscal.port !== 'undefined' && _vm.model.fiscal.port != null)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.port')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.fiscal.port),expression:"model.fiscal.port"}],staticClass:"form-control",attrs:{"type":"text","name":"model.fiscal.port","data-vv-as":"model.fiscal.port","placeholder":_vm.$t('settingTable.port')},domProps:{"value":(_vm.model.fiscal.port)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.fiscal, "port", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.model.fiscal.id == 1)?[_c('p',[_vm._v("DataBits: 8")]),_vm._v(" "),_c('p',[_vm._v("Parity: 'none'")]),_vm._v(" "),_c('p',[_vm._v("StopBits: 1")]),_vm._v(" "),_c('p',[_vm._v("BaudRate: 115200")])]:_vm._e()]:_vm._e()],2)])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EGhD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left"},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n        "+_vm._s(_vm.$t('general.back'))+"\n      ")])]),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('group-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onOfferSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EHmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSuppliersTabs_vue__ = __webpack_require__("2Tqu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3c27620_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSuppliersTabs_vue__ = __webpack_require__("eQuH");
function injectStyle (ssrContext) {
  __webpack_require__("PozW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3c27620"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSuppliersTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3c27620_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSuppliersTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EKzd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInitialStock_vue__ = __webpack_require__("vyeN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff6b85e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInitialStock_vue__ = __webpack_require__("sjK5");
function injectStyle (ssrContext) {
  __webpack_require__("UmdO")
  __webpack_require__("6UZX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ff6b85e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInitialStock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff6b85e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInitialStock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EMWT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ERsw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('discount-campaign-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ETu8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementAvizEdit_vue__ = __webpack_require__("azRF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48d71f0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementAvizEdit_vue__ = __webpack_require__("Oxr/");
function injectStyle (ssrContext) {
  __webpack_require__("kEEq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48d71f0f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementAvizEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48d71f0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementAvizEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EYdS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__);












var _components;









__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'vSelect', __WEBPACK_IMPORTED_MODULE_15_vue_select___default.a), _components),
  props: {
    callback: {
      required: false
    },
    editData: {
      required: false,
      type: Object
    }
  },
  watch: {
    locId: function locId(value) {
      this.id = value;
    },
    editData: function editData(value) {
      if (value) {
        this.isNew = false;
      } else {
        this.isNew = true;
      }
      if (!this.isNew) {
        this.model = value;
      }
      this.getGroupParents();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vee_validate__["b" /* mapFields */])(['name', 'description'])),
  created: function created() {
    this.locations = this.$session.get('selectedCompanyData').locations_details;
    this.getGroupLocations();
    this.getGroupParents();
    this.$nextTick(function () {
      this.loading = true;
      this.loadingReset = true;
    });
    this.$validator.localize('en', {
      en: {
        attributes: {
          name: this.$t('settingsPages.locationGroupsName'),
          description: this.$t('settingsPages.locationGroupsDescription')
        }
      }
    });
    if (this.editData) {
      if (this.editData.image) {
        this.imagelist = [{ 'url': this.editData.image }];
      }
      this.isNew = false;
    } else {
      this.isNew = true;
    }
    if (!this.isNew) {
      this.model = this.editData;
    }
    this.$nextTick(function () {
      this.loading = false;
      this.loadingReset = false;
    });
  },
  data: function data() {
    return {
      id: this.value || this.locId,
      isNew: true,
      model: {
        'name': '',
        'description': '',
        'active': true,
        'display_in_slider_app': false,
        'parent_id': null,
        'parent': null,
        'location_ids': []
      },
      imagelist: [],
      modelValidate: {
        name: { required: true, min: 3 },
        description: { max: 255 }
      },
      loading: true,
      loadingReset: true,
      parentOptions: [],
      categoryLocations: []
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveGroupLocation();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;

      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: this.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
        this.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.imagelist = fileList.slice(1);
        } else {
          this.imagelist = fileList;
        }
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.imagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
      }
      return isOkSize;
    },
    saveGroupLocation: function saveGroupLocation() {
      var _this2 = this;

      this.$nextTick(function () {
        this.loading = true;
      });
      var data = {
        id: this.model.id,
        name: this.model.name,
        description: this.model.description,
        active: this.model.active,
        display_in_slider_app: this.model.display_in_slider_app
      };
      data.location_ids = this.parseLocationIds();
      data.parent_id = this.parseParentId();

      if (this.imagelist.length === 0) {
        data.image = '';
      }
      var companyID = this.$session.get('selectedCompany');
      data.token = this.$session.get('token');
      data.company_id = companyID;
      if (this.imagelist && this.imagelist.length && this.imagelist[0].status && this.imagelist[0].status === 'ready') {
        this.getBase64(this.imagelist[0].raw).then(function (base64enc) {
          data.image = base64enc;
          _this2.handleImageUpload(data);
        });
      } else {
        this.handleImageUpload(data);
      }
    },
    handleBack: function handleBack() {
      this.$session.set('selectedTab', this.$t('settingsPages.locationGroups'));
      this.$router.push('/settings');
    },
    handleDelete: function handleDelete(label) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
        text: this.$t('settingsPages.locationGroupsAreYouSure', { label: label }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          if (_this3.isNew) {
            _this3.$router.push('/location-groups');
          } else {
            var data = {
              id: _this3.model.id,
              token: _this3.$session.get('token'),
              company_id: _this3.$session.get('selectedCompany')
            };
            _this3.apiRequest('/location-groups/' + _this3.model.id, 'DELETE', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
                  title: '',
                  text: _this3.$t('settingsPages.locationGroupsDelete'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                });
                _this3.closeModal(_this3.model);
              } else {
                __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : _this3.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
    },
    getGroupLocations: function getGroupLocations() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        columns: ['id', 'token', 'company_id', 'name', 'email', 'street', 'phone', 'active']
      };
      this.apiRequest('/locations', 'GET', data, function (response) {
        if (response.status === true) {
          _this4.categoryLocations = response.data;
          _this4.$nextTick(function () {
            _this4.loading = false;
          });
        }
      });
    },
    getGroupParents: function getGroupParents() {
      var _this5 = this;

      var data = {
        id: this.model.id,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/location-parents', 'GET', data, function (response) {
        if (response.status === true) {
          _this5.parentOptions = response.data;
          _this5.$nextTick(function () {
            _this5.loading = false;
          });
        }
      });
    },
    parseLocationIds: function parseLocationIds() {
      if (this.model.location_ids && this.model.location_ids.length) {
        var locIds = [];
        for (var idxL in this.model.location_ids) {
          locIds.push(this.model.location_ids[idxL]['token']);
        }
        return locIds;
      } else {
        return null;
      }
    },
    parseParentId: function parseParentId() {
      if (this.model.parent && this.model.parent.id) {
        var parentId = null;
        parentId = this.model.parent.id;
        return parentId;
      } else {
        return null;
      }
    },
    handleImageUpload: function handleImageUpload(data) {
      var _this6 = this;

      if (this.isNew) {
        this.apiRequest('/location-groups', 'POST', data, function (response) {
          if (response.status === true) {
            _this6.errors.clear();
            _this6.$nextTick(function () {
              this.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
              title: '',
              text: _this6.$t('settingsPages.locationGroupsAdded'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then(function () {}).catch(function () {});
            _this6.$emit('on-submit', response.data);
          } else {
            _this6.$nextTick(function () {
              this.loading = false;
            });
            _this6.handleErrors(response.errors);
          }
        });
      } else {
        if (data.role === 'OWNER') {
          delete data.role;
        }
        this.apiRequest('/location-groups/' + this.model.id, 'PUT', data, function (response) {
          if (response.status === true) {
            _this6.$nextTick(function () {
              this.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
              title: '',
              text: _this6.$t('settingsPages.locationGroupsUpdated'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then(function () {}).catch(function () {});
            _this6.$emit('on-submit', response.data);
          } else {
            _this6.$nextTick(function () {
              this.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
              title: '',
              text: _this6.$t('settingsPages.locationGroupsUpdated'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then(function () {}).catch(function () {});
            if (typeof _this6.callback === 'function') {
              _this6.callback();
            }
          }
        });
      }
    },
    closeModal: function closeModal() {
      var deletedGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.$emit('close-modal', deletedGroup);
    }
  }
});

/***/ }),

/***/ "Ear1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"card mar-to-15",staticStyle:{"width":"calc(100% - 20px)","margin-left":"10px","margin-right":"10px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"userList",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"width":150},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n              ")])]}}])})],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EcL7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EdqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);

















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__["a" /* default */],

    PSwitch: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      loading: true,
      pagerCount: 5,
      paginationDef: {
        page: null,
        totalPages: null,
        totalRecords: null,
        show: true
      },
      propsToSearch: ['name', 'status', 'type', 'discount'],
      tableColumns: [],
      tableData: [],
      search: ''
    };
  },

  created: function created() {
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    this.getFeedback(data);
  },
  methods: {
    onInput: function onInput() {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.search.length >= 3) {
        data.search = this.search;
        this.getFeedback(data);
      }

      if (this.search.length === 0) {
        this.getFeedback(data);
      }
    },
    handlePageChange: function handlePageChange(page) {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: page,
        perPage: this.paginationDef.perPage
      };
      if (this.search.length >= 3) {
        data.search = this.search;
      }
      this.getFeedback(data);
    },
    getFeedback: function getFeedback(data) {
      var self = this;
      this.loading = true;
      this.apiRequest('/feedback', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data.data;
          self.paginationDef.page = response.data.pagination.page;
          self.paginationDef.perPage = response.data.pagination.perPage;
          self.paginationDef.totalPages = response.data.pagination.totalPages;
          self.paginationDef.totalRecords = response.data.pagination.totalRecords;
        }
        self.$nextTick(function () {
          self.loading = false;
        });
      });
    },
    handleDelete: function handleDelete(index, row) {
      var _this = this;

      var self = this;
      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: 'Are you sure you want to delete \'' + row.name + '\'?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          _this.apiRequest('/hello', 'GET', [], function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', 'Push Notification deleted successfully', 'success');
              self.tableData.splice(index, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', 'Something went wrong, please try again later...', 'error');
            }
          });
        }
      });
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = 'Yes (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = 'Yes';
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/feedback/view/');
    },
    rowClass: function rowClass(row, index) {
      if (row.row.seen) {
        return '';
      } else {
        return 'new-feedback';
      }
    }
  }
});

/***/ }),

/***/ "EfBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])]),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('campaign-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onCampaignSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Eid7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EnYg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eo5+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isBonProduct },on:{"click":_vm.openBonProduct}},[_vm._v(_vm._s(_vm.$t('gestiune.isBonProductie')))])])])])]),_vm._v(" "),(_vm.isBonProduct)?_c('div',[_c('ManagementBonProduct',{attrs:{"grouped-locations":_vm.groupedLocations,"gestiune-options":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isLot)?_c('div',[_c('ManagementLot',{attrs:{"grouped-locations":_vm.groupedLocations,"gestiune-options":_vm.gestiuneOptions}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EoWJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_json_excel__ = __webpack_require__("fXhN");







var _components;









__WEBPACK_IMPORTED_MODULE_6_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_12_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), _components),
  props: {
    isPreordersItems: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isPreordersItems: function isPreordersItems() {
      if (this.isPreordersItems) {
        this.getOrders();
      }
    }
  },
  created: function created() {
    this.getOrders();
    this.verifyUserLocations();
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      loading: true,
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_9_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYY-MM-DD')],
        location: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total',
        pageSize: 20,
        currentPage: 1,
        pageSizes: [20, 50, 100]
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_9_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      ordersTableData: {
        data: []
      },
      totalRecords: 0,
      totalAmount: 0,
      totalCounter: 0,
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      hasRceipt: null,
      colors: ['#f44336', '#2196f3', '#ff9800', '#9c27b0', '#00bcd4', '#8bc34a', '#ffc107', '#3f51b5', '#ff5722', '#795548', '#607d8b', '#009688', '#cddc39', '#673ab7', '#03a9f4', '#aed581', '#ffb74d', '#ba68c8'],
      noData: false
    };
  },

  methods: {
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    getOrders: function getOrders(query) {
      var _this = this;

      if (!this.isPreordersItems) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;

      this.apiRequest('/reports/v2/preorders-items' + '?page=' + page + '&per_page=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          var items = Array.isArray(response.data) ? response.data : response.data.items || response.data.table_data || [];

          var expandedItems = [];
          items.forEach(function (item, index) {
            var baseName = item.product || item.item_name || item.name || 'item';
            var options = Array.isArray(item.options) ? item.options : [];

            expandedItems.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
              option: options.length > 0 ? options[0] : null,
              _rowKey: baseName + '-' + index + '-product',
              _isProductRow: true
            }));

            if (options.length > 1) {
              options.slice(1).forEach(function (option, optIndex) {
                expandedItems.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
                  option: option,
                  _rowKey: baseName + '-' + index + '-' + (optIndex + 1),
                  _isProductRow: false
                }));
              });
            }
          });

          if (expandedItems && expandedItems.length) {
            _this.noData = false;
            _this.ordersTableData.data = expandedItems;
            _this.ordersTableData.total = expandedItems.length;

            _this.totalRecords = response.pagination ? response.pagination.total : expandedItems.length;
            _this.paginationProps.currentPage = response.pagination ? response.pagination.page : page;
            _this.paginationProps.pageSize = response.pagination ? response.pagination.perPage : pageSize;

            _this.totalCounter = items.reduce(function (sum, item) {
              return sum + (parseInt(item.quantity) || 0);
            }, 0);

            _this.totalAmount = response.data.total || 0;
          } else {
            _this.noData = true;
            _this.ordersTableData.data = [];
            _this.ordersTableData.total = 0;
            _this.totalRecords = 0;
            _this.paginationProps.currentPage = page;
            _this.paginationProps.pageSize = pageSize;
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    exportData: function exportData() {
      var _this2 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;

      this.apiRequest('/reports/v2/preorders-items?page=1&per_page=1', 'GET', data, function (response) {
        if (response && response.status) {
          var pagination = response.pagination || {};
          var total = pagination.total != null ? pagination.total : 0;

          if (!total) {
            __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', _this2.$t('reports.noData') || 'Nu există date', 'info');
            _this2.loading = false;
            return;
          }

          _this2.apiRequest('/reports/v2/preorders-items-download', 'GET', data, function (downloadResponse) {
            if (downloadResponse && downloadResponse.status === true) {
              var link = document.createElement('a');
              link.href = downloadResponse.data.file;
              link.setAttribute('download', downloadResponse.data.file_name);
              document.body.appendChild(link);
              link.click();
            } else {
              __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
            }
            _this2.loading = false;
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
          _this2.loading = false;
        }
      });
    },
    paginationChanged: function paginationChanged(query) {
      this.getOrders(query);
    }
  }
});

/***/ }),

/***/ "ErY3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__("JjPW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d5ffa8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__("XE0K");
function injectStyle (ssrContext) {
  __webpack_require__("RqIF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9d5ffa8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d5ffa8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EtOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChallengeCampaignForm_vue__ = __webpack_require__("DvBx");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ChallengeCampaignForm: __WEBPACK_IMPORTED_MODULE_0__ChallengeCampaignForm_vue__["a" /* default */] },
  props: {
    route: { type: Object, default: function _default() {
        return {};
      } }
  }
});

/***/ }),

/***/ "Evvf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentGroupsAdd_vue__ = __webpack_require__("c23J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054c8cd3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentGroupsAdd_vue__ = __webpack_require__("Xipi");
function injectStyle (ssrContext) {
  __webpack_require__("yTmD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentGroupsAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054c8cd3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentGroupsAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ewy/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__);























__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_item___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_pagination___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PSwitch: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__["a" /* default */] },
  props: {
    isChallengeCampaigns: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      loading: true,
      search: '',
      appliedSearch: '',
      statusFilter: null,
      appliedStatus: null,
      tableData: [],
      paginationDef: {
        pageSize: 20,
        pageSizes: [10, 20, 50],
        currentPage: 1
      }
    };
  },

  computed: {
    filteredAll: function filteredAll() {
      var _this = this;

      var rows = this.tableData || [];
      var q = (this.appliedSearch || '').toString().trim().toLowerCase();
      if (q) {
        rows = rows.filter(function (r) {
          var title = (r.title || '').toString().toLowerCase();
          var desc = (r.description || '').toString().toLowerCase();
          return title.indexOf(q) !== -1 || desc.indexOf(q) !== -1;
        });
      }
      if (this.appliedStatus === 0 || this.appliedStatus === 1) {
        rows = rows.filter(function (r) {
          return !!r.active === !!_this.appliedStatus;
        });
      }
      return rows;
    },
    filteredTableData: function filteredTableData() {
      var start = (this.paginationDef.currentPage - 1) * this.paginationDef.pageSize;
      return this.filteredAll.slice(start, start + this.paginationDef.pageSize);
    }
  },
  watch: {
    isChallengeCampaigns: function isChallengeCampaigns(v) {
      if (v) this.getCampaigns();
    }
  },
  created: function created() {
    this.getCampaigns();
    this.$bus.$on('refresh', this.getCampaigns);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.getCampaigns);
  },

  methods: {
    applyFilters: function applyFilters() {
      this.appliedSearch = this.search;
      this.appliedStatus = this.statusFilter;
      this.paginationDef.currentPage = 1;
    },
    onPageSizeChange: function onPageSizeChange(size) {
      this.paginationDef.pageSize = size;
      this.paginationDef.currentPage = 1;
    },
    getCampaigns: function getCampaigns() {
      var _this2 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/challenge-campaigns', 'GET', data, function (response) {
        _this2.loading = false;
        if (response.status) {
          _this2.tableData = (response.data || []).map(function (row) {
            row.active = !!(row.active === true || parseInt(row.active) === 1);
            return row;
          });
        }
      });
    },
    goToRecord: function goToRecord(row) {
      if (!row || !row.id) return;
      this.$router.push('/marketing/challenge-campaigns/edit/' + row.id);
    },
    handleActive: function handleActive(row) {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        active: row.active ? 1 : 0
      };
      this.apiRequest('/challenge-campaigns/' + row.id, 'PUT', data, function (response) {
        if (!response.status) {
          row.active = !row.active;
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: this.$t('challengeCampaigns.areYouSureDelete') + ' ' + (row.title || '') + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (!result) return;
        var data = {
          token: _this4.$session.get('token'),
          company_id: _this4.$session.get('selectedCompany')
        };
        _this4.apiRequest('/challenge-campaigns/' + row.id, 'DELETE', data, function (response) {
          if (response.status) _this4.getCampaigns();else __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error').catch(function () {});
        });
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "EySa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__("O5me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_wysiwyg_dist_vueWysiwyg_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DiscountCoupons_CouponForm_vue__ = __webpack_require__("zKgQ");






















__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_vue_js_modal___default.a, { componentName: 'vmodal' });

var NAME_MAX = 255;
var MAX_IMAGE_MB = 5;
var GATEWAY_LABELS = {
  euplatesc: 'euPlatesc'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__["a" /* default */],
    CouponForm: __WEBPACK_IMPORTED_MODULE_17__DiscountCoupons_CouponForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      NAME_MAX: NAME_MAX,

      editorOptions: {
        hideModules: { code: true, table: true, image: true }
      },
      loading: false,
      loaded: false,
      saving: false,
      currency: '',
      form: {
        family_mode: 'new',
        family_name: '',
        payment_group_key: '',
        subscription_family_id: null,
        name: '',
        price: '',
        active: true,
        description: '',
        imagelist: [],
        coupon_ids: []
      },
      formErrors: {},

      level: null,
      family: null,
      editLevelBelow: null,
      editLevelAbove: null,
      lowerLevels: [],

      families: [],
      paymentGroups: [],
      coupons: [],
      couponSearch: '',
      couponModalOpen: false
    };
  },

  computed: {
    subscriptionId: function subscriptionId() {
      return this.route.params && this.route.params.id;
    },
    isEdit: function isEdit() {
      return !!this.subscriptionId;
    },
    selectedPaymentGroup: function selectedPaymentGroup() {
      var _this = this;

      return this.paymentGroups.find(function (group) {
        return group.group_key === _this.form.payment_group_key;
      }) || null;
    },
    selectedFamily: function selectedFamily() {
      var _this2 = this;

      return this.families.find(function (item) {
        return item.id === _this2.form.subscription_family_id;
      }) || null;
    },
    levelBelow: function levelBelow() {
      if (this.isEdit) {
        return this.editLevelBelow;
      }
      return this.form.family_mode === 'existing' && this.selectedFamily ? this.selectedFamily.top_level : null;
    },
    levelAbove: function levelAbove() {
      return this.isEdit ? this.editLevelAbove : null;
    },
    priceOrderError: function priceOrderError() {
      var price = parseFloat(this.form.price);
      if (this.form.price === '' || this.form.price === null || isNaN(price)) {
        return '';
      }
      if (this.levelBelow && price <= parseFloat(this.levelBelow.price)) {
        return this.$t('marketingSubscriptions.priceTooLow', { price: this.levelBelow.price + ' ' + this.currency });
      }
      if (this.levelAbove && price >= parseFloat(this.levelAbove.price)) {
        return this.$t('marketingSubscriptions.priceTooHigh', { price: this.levelAbove.price + ' ' + this.currency });
      }
      return '';
    },
    minPrice: function minPrice() {
      return this.levelBelow ? (parseFloat(this.levelBelow.price) + 0.01).toFixed(2) : 0;
    },
    upgradeDiffText: function upgradeDiffText() {
      var price = parseFloat(this.form.price);
      if (!this.levelBelow || isNaN(price)) {
        return '-';
      }
      return (price - parseFloat(this.levelBelow.price)).toFixed(2) + ' ' + this.currency;
    },
    inheritedGroups: function inheritedGroups() {
      var levels = this.isEdit ? this.lowerLevels : this.form.family_mode === 'existing' && this.selectedFamily ? this.selectedFamily.levels || [] : [];
      return levels.map(function (level) {
        return {
          level: level.level,
          name: level.name,
          coupons: level.coupons || []
        };
      });
    },
    inheritedById: function inheritedById() {
      var map = {};
      this.inheritedGroups.forEach(function (group) {
        group.coupons.forEach(function (coupon) {
          if (!map[coupon.id]) {
            map[coupon.id] = { level: group.level, name: group.name };
          }
        });
      });
      return map;
    },
    filteredCoupons: function filteredCoupons() {
      var q = (this.couponSearch || '').trim().toLowerCase();
      if (!q) {
        return this.coupons;
      }
      return this.coupons.filter(function (coupon) {
        return (coupon.name || '').toLowerCase().indexOf(q) !== -1 || (coupon.coupon_code || '').toLowerCase().indexOf(q) !== -1;
      });
    }
  },
  watch: {
    paymentGroups: function paymentGroups(groups) {
      if (!this.form.payment_group_key && groups.length === 1) {
        this.form.payment_group_key = groups[0].group_key;
      }
    }
  },
  created: function created() {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso);
    this.getCoupons();
    if (this.isEdit) {
      this.getSubscription();
    } else {
      this.getFamilies();
      this.getPaymentGroups();
      this.loaded = true;
    }
  },

  methods: {
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    getCoupons: function getCoupons(callback) {
      var _this3 = this;

      this.apiRequest('/subscription/coupons', 'GET', this.requestData(), function (response) {
        if (response.status === true) {
          _this3.coupons = response.data || [];
        }
        if (callback) {
          callback();
        }
      });
    },
    openCouponModal: function openCouponModal() {
      this.couponModalOpen = true;
      this.$modal.show('subscriptionCouponModal');
    },
    onCouponModalOpened: function onCouponModalOpened() {
      var el = document.querySelector('.subscriptionCouponModal.vm--container');
      if (el && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    },
    onCouponCreated: function onCouponCreated(coupon) {
      var _this4 = this;

      this.$modal.hide('subscriptionCouponModal');
      this.couponModalOpen = false;
      this.getCoupons(function () {
        if (coupon && coupon.id && _this4.form.coupon_ids.indexOf(coupon.id) === -1) {
          _this4.form.coupon_ids.push(coupon.id);
        }
      });
    },
    getFamilies: function getFamilies() {
      var _this5 = this;

      this.apiRequest('/subscription/families', 'GET', this.requestData(), function (response) {
        if (response.status !== true) {
          return;
        }
        _this5.families = response.data || [];

        var familyId = parseInt(_this5.route.query && _this5.route.query.family_id, 10);
        if (familyId && _this5.families.find(function (item) {
          return item.id === familyId;
        })) {
          _this5.form.family_mode = 'existing';
          _this5.form.subscription_family_id = familyId;
        }
      });
    },
    getPaymentGroups: function getPaymentGroups() {
      var _this6 = this;

      this.apiRequest('/subscription/payment-groups', 'GET', this.requestData(), function (response) {
        if (response.status === true) {
          _this6.paymentGroups = response.data || [];
        }
      });
    },
    getSubscription: function getSubscription() {
      var _this7 = this;

      this.loading = true;
      this.apiRequest('/subscription/' + this.subscriptionId, 'GET', this.requestData(), function (response) {
        _this7.loading = false;
        if (!(response.status === true && response.data)) {
          return;
        }
        var data = response.data;
        _this7.level = data.level;
        _this7.family = data.family;
        _this7.editLevelBelow = data.level_below;
        _this7.editLevelAbove = data.level_above;
        _this7.lowerLevels = data.lower_levels || [];
        _this7.form = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this7.form, {
          name: data.name || '',
          price: data.price,
          active: !!data.active,
          description: data.description || '',
          imagelist: data.image_filename ? [{ url: data.image_url, name: data.image_filename, filename: data.image_filename }] : [],
          coupon_ids: Array.isArray(data.coupon_ids) ? data.coupon_ids.slice() : []
        });
        _this7.loaded = true;
      });
    },
    paymentGroupLabel: function paymentGroupLabel(group) {
      return (group.group_name || group.group_key) + ' · ' + (GATEWAY_LABELS[group.gateway] || group.gateway);
    },
    isCouponChecked: function isCouponChecked(id) {
      return this.form.coupon_ids.indexOf(id) !== -1;
    },
    toggleCoupon: function toggleCoupon(id) {
      if (this.inheritedById[id] && this.form.coupon_ids.indexOf(id) === -1) {
        return;
      }
      var i = this.form.coupon_ids.indexOf(id);
      if (i === -1) {
        this.form.coupon_ids.push(id);
      } else {
        this.form.coupon_ids.splice(i, 1);
      }
    },
    couponDiscountText: function couponDiscountText(coupon) {
      if (coupon.type === 'FREE_PRODUCT') {
        return this.$t('marketingSubscriptions.freeProduct');
      }
      return (coupon.discount || 0) + ' ' + (coupon.type === 'FIXED' ? this.currency : '%');
    },
    handleImageChange: function handleImageChange(file, fileList) {
      if (file.size && file.size / 1024 / 1024 > MAX_IMAGE_MB) {
        __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: this.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).catch(function () {});
        this.form.imagelist = fileList.filter(function (f) {
          return f.uid !== file.uid;
        }).slice(-1);
        return;
      }
      this.form.imagelist = fileList.slice(-1);
    },
    handleImageRemove: function handleImageRemove() {
      this.form.imagelist = [];
    },
    handleExceed: function handleExceed() {
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', this.$t('validations.pictureSizeExceed'), 'warning').catch(function () {});
    },
    collectImage: function collectImage() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var f;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                f = _this8.form.imagelist && _this8.form.imagelist[0];

                if (f) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', '');

              case 3:
                if (!f.raw) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', _this8.getBase64(f.raw));

              case 5:
                return _context.abrupt('return', f.filename || '');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this8);
      }))();
    },
    validate: function validate() {
      this.formErrors = {};
      if (!(this.form.name || '').trim()) {
        this.$set(this.formErrors, 'name', true);
      }
      var price = parseFloat(this.form.price);
      if (this.form.price === '' || this.form.price === null || isNaN(price) || price < 0) {
        this.$set(this.formErrors, 'price', this.$t('marketingSubscriptions.priceRequired'));
      } else if (this.priceOrderError) {
        this.$set(this.formErrors, 'price', this.priceOrderError);
      }
      if (!this.isEdit) {
        if (this.form.family_mode === 'new' && !this.selectedPaymentGroup) {
          this.$set(this.formErrors, 'payment', true);
        }
        if (this.form.family_mode === 'existing' && !this.form.subscription_family_id) {
          this.$set(this.formErrors, 'family', true);
        }
      }
      return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.formErrors).length;
    },
    save: function save() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var image, data, url, method;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this9.validate()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:

                _this9.saving = true;

                image = void 0;
                _context2.prev = 4;
                _context2.next = 7;
                return _this9.collectImage();

              case 7:
                image = _context2.sent;
                _context2.next = 15;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                _this9.saving = false;
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this9.$t('validations.wentWrong'), 'error').catch(function () {});
                return _context2.abrupt('return');

              case 15:
                data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this9.requestData(), {
                  name: _this9.form.name,
                  price: _this9.form.price,
                  active: _this9.form.active ? 1 : 0,
                  description: _this9.form.description,
                  image: image,
                  coupon_ids: _this9.form.coupon_ids
                });

                if (!_this9.isEdit) {
                  data.family_mode = _this9.form.family_mode;
                  if (_this9.form.family_mode === 'new') {
                    data.family_name = _this9.form.family_name;
                    data.payment_gateway = _this9.selectedPaymentGroup.gateway;
                    data.payment_group_key = _this9.selectedPaymentGroup.group_key;
                  } else {
                    data.subscription_family_id = _this9.form.subscription_family_id;
                  }
                }
                url = _this9.isEdit ? '/subscription/' + _this9.subscriptionId : '/subscription';
                method = _this9.isEdit ? 'PUT' : 'POST';


                _this9.apiRequest(url, method, data, function (response) {
                  _this9.saving = false;
                  if (response.status === true) {
                    __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                      title: '',
                      text: _this9.$t('marketingSubscriptions.saved'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                    _this9.goBack();
                    return;
                  }

                  var errors = response.errors || {};
                  var messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors).map(function (key) {
                    return Array.isArray(errors[key]) ? errors[key][0] : errors[key];
                  });
                  __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', messages.join(' ') || _this9.$t('validations.wentWrong'), 'error').catch(function () {});
                });

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this9, [[4, 10]]);
      }))();
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "F+V8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountingInboundInvoices_vue__ = __webpack_require__("Z3DB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_661ef3b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountingInboundInvoices_vue__ = __webpack_require__("O7GA");
function injectStyle (ssrContext) {
  __webpack_require__("kGmb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-661ef3b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountingInboundInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_661ef3b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountingInboundInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F3Gu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscribersPage_vue__ = __webpack_require__("wcsK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1217ccca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscribersPage_vue__ = __webpack_require__("fDUP");
function injectStyle (ssrContext) {
  __webpack_require__("Iic6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscribersPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1217ccca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscribersPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F5yH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",[_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F7xP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadProductFormDependencies;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function loadProductFormDependencies(vm) {
  if (!vm || typeof vm.apiRequest !== 'function') return;

  var data = {
    token: vm.$session.get('token'),
    company_id: vm.$session.get('selectedCompany'),
    inactive: 1
  };

  if (!Array.isArray(vm.mainCategories) || !vm.mainCategories.length) {
    vm.apiRequest('/category', 'GET', data, function (response) {
      if (response.status === true) {
        vm.mainCategories = response.data;
      }
    });
  }

  if (!Array.isArray(vm.taxes) || !vm.taxes.length) {
    vm.apiRequest('/location/taxes', 'GET', data, function (response) {
      if (response.status === true) {
        vm.taxes = response.data;
      }
    });
  }

  if (!Array.isArray(vm.productOptions) || !vm.productOptions.length) {
    vm.apiRequest('/settings/general/' + data.company_id, 'GET', data, function (response) {
      if (response.status === true && response.data && response.data[0]) {
        vm.productOptions = response.data[0].products_options;
      }
    });
  }

  if (!Array.isArray(vm.kdsSections) || !vm.kdsSections.length) {
    vm.apiRequest('/sections', 'GET', data, function (response) {
      if (response.status === true) {
        vm.kdsSections = response.data;
      }
    });
  }

  if (!Array.isArray(vm.measurementsUnits) || !vm.measurementsUnits.length) {
    vm.apiRequest('/measurements-units', 'GET', data, function (response) {
      if (response.status === true) {
        vm.measurementsUnits = response.data;
      }
    });
  }

  if (!Array.isArray(vm.languages) || !vm.languages.length) {
    vm.apiRequest('/company-data', 'GET', data, function (response) {
      if (response.status === true && response.data && response.data.company) {
        vm.languages = response.data.company.languages;
        vm.language = response.data.company.language;
      }
    });
  }

  if (!Array.isArray(vm.companyProductFilters) || !vm.companyProductFilters.length) {
    vm.apiRequest('/filter', 'GET', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { from_product: 1 }), function (response) {
      if (response.status === true) {
        vm.companyProductFilters = response.data;
      }
    });
  }
}

/***/ }),

/***/ "F87u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);


















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isLoyaltyStoreReport: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      dateRange: [],
      locationId: null,
      userId: '',
      locations: [],
      tableData: [],
      currency: this.getCurrencySymbol((this.$session.get('selectedCompanyData') || {})['currency_iso'])
    };
  },

  watch: {
    isLoyaltyStoreReport: function isLoyaltyStoreReport(active) {
      if (active) this.loadReport();
    }
  },
  mounted: function mounted() {
    this.initLocations();
    if (this.isLoyaltyStoreReport) this.loadReport();
    this.$bus.$on('refresh-loyalty-store-report', this.loadReport);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh-loyalty-store-report', this.loadReport);
  },

  methods: {
    initLocations: function initLocations() {
      var company = this.$session.get('selectedCompanyData') || {};
      var locs = company.locations_details || [];
      this.locations = locs.map(function (l) {
        return {
          id: l.true_id || l.id,
          name: l.name
        };
      });
    },
    applyFilters: function applyFilters() {
      this.loadReport();
    },
    buildParams: function buildParams() {
      var params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (this.dateRange && this.dateRange[0]) params.start_date = this.dateRange[0];
      if (this.dateRange && this.dateRange[1]) params.end_date = this.dateRange[1];
      if (this.locationId) params.location_id = this.locationId;
      if (this.userId) params.user_id = this.userId;
      return params;
    },
    loadReport: function loadReport() {
      var _this = this;

      this.loading = true;
      this.apiRequest('/reports/loyalty-store', 'GET', this.buildParams(), function (response) {
        _this.loading = false;
        if (response.status && response.data) {
          _this.tableData = response.data.rewards || [];
        } else {
          _this.tableData = [];
        }
      });
    },
    onRowClick: function onRowClick(row) {
      if (!row || !row.reward_id) return;
      var title = row.reward || row.reward_name || '#' + row.reward_id;
      this.$router.push({
        path: '/reports/loyalty-store/rewards/' + row.reward_id + '/purchases',
        query: {
          title: title,
          type: row.reward_type || 'product',
          start_date: this.dateRange && this.dateRange[0] || '',
          end_date: this.dateRange && this.dateRange[1] || '',
          location_id: this.locationId || '',
          user_id: this.userId || ''
        }
      });
    }
  }
});

/***/ }),

/***/ "F9X5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscribersPage_vue__ = __webpack_require__("d41/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c1a84f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscribersPage_vue__ = __webpack_require__("nvsd");
function injectStyle (ssrContext) {
  __webpack_require__("aK6o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscribersPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c1a84f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscribersPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F9Yb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group kiosk-video-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.kioskVideo')))]),_vm._v(" "),_vm._l((_vm.value),function(video,index){return _c('div',{key:video.id,staticClass:"kiosk-video-item"},[_c('video',{staticClass:"kiosk-video-preview",attrs:{"src":video.url,"controls":"","muted":"","preload":"metadata"},domProps:{"muted":true}}),_vm._v(" "),_c('div',{staticClass:"kiosk-video-info"},[_c('span',[_vm._v("#"+_vm._s(video.id)+" "+_vm._s(video.original_name || video.name))]),_vm._v(" "),(video.size)?_c('small',[_vm._v("("+_vm._s(_vm.formatSize(video.size))+")")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button","disabled":_vm.uploading || _vm.removing},on:{"click":function($event){_vm.remove(index)}}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('settingTable.kioskVideoRemove'))+"\n      ")])])])}),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","on-change":_vm.handleChange,"on-remove":_vm.handleRemove,"limit":1,"auto-upload":false,"accept":".mp4,.webm,video/mp4,video/webm"}},[_c('el-button',{staticClass:"btn add mar",attrs:{"slot":"trigger","size":"small","type":"primary","disabled":_vm.uploading},slot:"trigger"},[_vm._v(_vm._s(_vm.$t('upload.browse')))]),_vm._v(" "),_c('el-button',{staticClass:"btn add mar",staticStyle:{"margin-left":"10px"},attrs:{"disabled":!_vm.file || _vm.uploading,"loading":_vm.uploading,"size":"small","type":"primary"},on:{"click":_vm.upload}},[_vm._v(_vm._s(_vm.$t('upload.upload')))]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t(_vm.tableId ? 'settingTable.kioskVideoHintAuto' : 'settingTable.kioskVideoHint')))])],1),_vm._v(" "),(_vm.uploading)?_c('el-progress',{staticClass:"pad-bt-5",attrs:{"percentage":_vm.progress}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FFcL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsEdit_vue__ = __webpack_require__("TaTp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab3c8c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsEdit_vue__ = __webpack_require__("h4VG");
function injectStyle (ssrContext) {
  __webpack_require__("4WvA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab3c8c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FP5N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FPRT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FRrx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FSfG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSections_vue__ = __webpack_require__("NPgD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a14ab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSections_vue__ = __webpack_require__("WhE9");
function injectStyle (ssrContext) {
  __webpack_require__("NoQD")
  __webpack_require__("Y/xN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSections_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a14ab8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSections_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FTLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaignAdd_vue__ = __webpack_require__("IuL4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47dcb00b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaignAdd_vue__ = __webpack_require__("r+e0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaignAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47dcb00b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaignAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FV8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',{staticClass:"row pad-to-15",on:{"submit":function($event){$event.preventDefault();return _vm.saveStocks($event)}}},[(_vm.products.length > 0)?_c('div',{staticClass:"save-wrapper"},[_c('button',{staticClass:"btn btn-primary btn-fill",attrs:{"type":"submit","disabled":_vm.saving}},[_c('i',{staticClass:"ti-save"}),_vm._v(" \n           "+_vm._s(_vm.saving ? _vm.$t('stock.saving') : _vm.$t('stock.saveStocks'))+"\n         ")])]):_vm._e(),_vm._v(" "),(_vm.errors.items.length)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"alert alert-danger alert-custom-danger"},[_vm._v(_vm._s(_vm.$t('validations.checkErrors')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card pricing-table-card"},[_c('div',{staticClass:"card-header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('stock.title')))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('stock.subtitle')))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"filters-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('stock.searchByName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.name),expression:"filters.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('stock.productNamePlaceholder')},domProps:{"value":(_vm.filters.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "name", $event.target.value)},_vm.debouncedLoadProducts]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('stock.searchById')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.product_id),expression:"filters.product_id"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('stock.productIdPlaceholder')},domProps:{"value":(_vm.filters.product_id)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "product_id", $event.target.value)},_vm.debouncedLoadProducts]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.category')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.category_id),expression:"filters.category_id"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.loadProducts]}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('stock.allCategories')))]),_vm._v(" "),_vm._l((_vm.mainCategories),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v("\n                       "+_vm._s(option.name)+"\n                     ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-block",attrs:{"type":"button"},on:{"click":_vm.resetFilters}},[_c('i',{staticClass:"ti-close"}),_vm._v(" "+_vm._s(_vm.$t('stock.resetFilters'))+"\n                   ")])])])])]),_vm._v(" "),(_vm.loadingProducts)?_c('div',{staticClass:"text-center py-3"},[_c('i',{staticClass:"ti-reload rotate"}),_vm._v(" "+_vm._s(_vm.$t('stock.loadingProducts'))+"\n           ")]):_c('div',{staticClass:"table-responsive-wrapper"},[_c('div',{staticClass:"table-horizontal-scroll"},[_c('table',{staticClass:"table pricing-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"product-col sticky-col"},[_vm._v(_vm._s(_vm.$t('stock.product')))]),_vm._v(" "),_vm._l((_vm.locations),function(location){return _c('th',{key:location.id,staticClass:"location-col"},[_vm._v("\n                       "+_vm._s(location.name)+"\n                     ")])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.products),function(product){return _c('tr',{key:product.id},[_c('td',{staticClass:"product-col sticky-col"},[_c('div',{staticClass:"product-info"},[_c('strong',{on:{"click":function($event){_vm.goToProduct(product)}}},[_vm._v(_vm._s(product.name))]),_vm._v(" "),_c('div',{staticClass:"product-id text-muted"},[_vm._v(_vm._s(_vm.$t('stock.idLabel', { id: product.id })))]),_vm._v(" "),_c('div',{staticClass:"standard-price text-muted"},[_vm._v("\n                           "+_vm._s(product.price)+" "+_vm._s(_vm.$t('stock.currency'))+"\n                         ")])])]),_vm._v(" "),_vm._l((_vm.locations),function(location){return _c('td',{key:((product.id) + "-" + (location.true_id)),staticClass:"location-cell",class:{ 
                         'not-available': !_vm.isProductInLocation(product, location.true_id),
                         'inactive': !_vm.getStockData(product.id, location.true_id).active && _vm.isProductInLocation(product, location.true_id)
                       }},[(!_vm.isProductInLocation(product, location.true_id))?[_c('div',{staticClass:"not-available-text"},[_c('i',{staticClass:"ti-close"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('stock.notAvailable')))])])]:[_c('div',{staticClass:"field-row active-row"},[_c('label',{staticClass:"checkbox-label active-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getStockData(product.id, location.true_id).active),expression:"getStockData(product.id, location.true_id).active"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.getStockData(product.id, location.true_id).active)?_vm._i(_vm.getStockData(product.id, location.true_id).active,null)>-1:(_vm.getStockData(product.id, location.true_id).active)},on:{"change":[function($event){var $$a=_vm.getStockData(product.id, location.true_id).active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.getStockData(product.id, location.true_id), "active", $$c)}},function($event){_vm.toggleActive(product.id, location.true_id)}]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('stock.active')))])])]),_vm._v(" "),_c('div',{class:{ 'disabled-fields': !_vm.getStockData(product.id, location.true_id).active }},[_c('div',{staticClass:"field-row"},[_c('label',[_vm._v(_vm._s(_vm.$t('stock.stock')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getStockData(product.id, location.true_id).stock),expression:"getStockData(product.id, location.true_id).stock"}],staticClass:"form-control input-sm",class:{ 'disabled-input': _vm.getStockData(product.id, location.true_id).sync_gestiune },attrs:{"type":"number","step":"0.01","min":"0","placeholder":_vm.$t('stock.stockPlaceholder'),"disabled":!_vm.getStockData(product.id, location.true_id).active || _vm.getStockData(product.id, location.true_id).sync_gestiune},domProps:{"value":(_vm.getStockData(product.id, location.true_id).stock)},on:{"change":function($event){_vm.markDirty(product.id, location.true_id)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getStockData(product.id, location.true_id), "stock", $event.target.value)}}})]),_vm._v(" "),(!_vm.getStockData(product.id, location.true_id).allow_negative_stock)?_c('div',{staticClass:"field-row"},[_c('label',[_vm._v(_vm._s(_vm.$t('stock.reservation')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getStockData(product.id, location.true_id).rezervare_stock),expression:"getStockData(product.id, location.true_id).rezervare_stock"}],staticClass:"form-control input-sm",class:{ 'input-error': _vm.isReservationInvalid(product.id, location.true_id) },attrs:{"type":"number","step":"1","min":"0","placeholder":_vm.$t('stock.reservationPlaceholder'),"disabled":!_vm.getStockData(product.id, location.true_id).active},domProps:{"value":(_vm.getStockData(product.id, location.true_id).rezervare_stock)},on:{"change":function($event){_vm.onReservationChange(product.id, location.true_id)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.getStockData(product.id, location.true_id), "rezervare_stock", $event.target.value)}}}),_vm._v(" "),(_vm.isReservationInvalid(product.id, location.true_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                               "+_vm._s(_vm.$t('stock.reservationError'))+"\n                             ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field-row checkbox-row"},[_c('label',{staticClass:"checkbox-label",class:{ 'disabled-label': _vm.getStockData(product.id, location.true_id).sync_gestiune }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getStockData(product.id, location.true_id).allow_negative_stock),expression:"getStockData(product.id, location.true_id).allow_negative_stock"}],attrs:{"type":"checkbox","disabled":!_vm.getStockData(product.id, location.true_id).active || _vm.getStockData(product.id, location.true_id).sync_gestiune},domProps:{"checked":Array.isArray(_vm.getStockData(product.id, location.true_id).allow_negative_stock)?_vm._i(_vm.getStockData(product.id, location.true_id).allow_negative_stock,null)>-1:(_vm.getStockData(product.id, location.true_id).allow_negative_stock)},on:{"change":[function($event){var $$a=_vm.getStockData(product.id, location.true_id).allow_negative_stock,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "allow_negative_stock", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "allow_negative_stock", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.getStockData(product.id, location.true_id), "allow_negative_stock", $$c)}},function($event){_vm.onAllowNegativeChange(product.id, location.true_id)}]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('stock.allowNegative')))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticStyle:{"font-size":"0.7em"}},[_vm._v(_vm._s(_vm.$t('stock.activateForSources')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"field-row checkbox-row"},[_c('label',{staticClass:"checkbox-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getStockData(product.id, location.true_id).active_pos),expression:"getStockData(product.id, location.true_id).active_pos"}],attrs:{"type":"checkbox","disabled":!_vm.getStockData(product.id, location.true_id).active},domProps:{"checked":Array.isArray(_vm.getStockData(product.id, location.true_id).active_pos)?_vm._i(_vm.getStockData(product.id, location.true_id).active_pos,null)>-1:(_vm.getStockData(product.id, location.true_id).active_pos)},on:{"change":[function($event){var $$a=_vm.getStockData(product.id, location.true_id).active_pos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active_pos", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active_pos", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.getStockData(product.id, location.true_id), "active_pos", $$c)}},function($event){_vm.markDirty(product.id, location.true_id)}]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('stock.pos')))])])]),_vm._v(" "),_c('div',{staticClass:"field-row checkbox-row"},[_c('label',{staticClass:"checkbox-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getStockData(product.id, location.true_id).active_app),expression:"getStockData(product.id, location.true_id).active_app"}],attrs:{"type":"checkbox","disabled":!_vm.getStockData(product.id, location.true_id).active},domProps:{"checked":Array.isArray(_vm.getStockData(product.id, location.true_id).active_app)?_vm._i(_vm.getStockData(product.id, location.true_id).active_app,null)>-1:(_vm.getStockData(product.id, location.true_id).active_app)},on:{"change":[function($event){var $$a=_vm.getStockData(product.id, location.true_id).active_app,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active_app", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active_app", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.getStockData(product.id, location.true_id), "active_app", $$c)}},function($event){_vm.markDirty(product.id, location.true_id)}]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('stock.app')))])])]),_vm._v(" "),_c('div',{staticClass:"field-row checkbox-row"},[_c('label',{staticClass:"checkbox-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getStockData(product.id, location.true_id).active_website),expression:"getStockData(product.id, location.true_id).active_website"}],attrs:{"type":"checkbox","disabled":!_vm.getStockData(product.id, location.true_id).active},domProps:{"checked":Array.isArray(_vm.getStockData(product.id, location.true_id).active_website)?_vm._i(_vm.getStockData(product.id, location.true_id).active_website,null)>-1:(_vm.getStockData(product.id, location.true_id).active_website)},on:{"change":[function($event){var $$a=_vm.getStockData(product.id, location.true_id).active_website,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active_website", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active_website", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.getStockData(product.id, location.true_id), "active_website", $$c)}},function($event){_vm.markDirty(product.id, location.true_id)}]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('stock.website')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"field-row checkbox-row"},[_c('label',{staticClass:"checkbox-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getStockData(product.id, location.true_id).active_qr),expression:"getStockData(product.id, location.true_id).active_qr"}],attrs:{"type":"checkbox","disabled":!_vm.getStockData(product.id, location.true_id).active},domProps:{"checked":Array.isArray(_vm.getStockData(product.id, location.true_id).active_qr)?_vm._i(_vm.getStockData(product.id, location.true_id).active_qr,null)>-1:(_vm.getStockData(product.id, location.true_id).active_qr)},on:{"change":[function($event){var $$a=_vm.getStockData(product.id, location.true_id).active_qr,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active_qr", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active_qr", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.getStockData(product.id, location.true_id), "active_qr", $$c)}},function($event){_vm.markDirty(product.id, location.true_id)}]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('stock.qr')))])])]),_vm._v(" "),_c('div',{staticClass:"field-row checkbox-row"},[_c('label',{staticClass:"checkbox-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getStockData(product.id, location.true_id).active_kiosk),expression:"getStockData(product.id, location.true_id).active_kiosk"}],attrs:{"type":"checkbox","disabled":!_vm.getStockData(product.id, location.true_id).active},domProps:{"checked":Array.isArray(_vm.getStockData(product.id, location.true_id).active_kiosk)?_vm._i(_vm.getStockData(product.id, location.true_id).active_kiosk,null)>-1:(_vm.getStockData(product.id, location.true_id).active_kiosk)},on:{"change":[function($event){var $$a=_vm.getStockData(product.id, location.true_id).active_kiosk,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active_kiosk", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.getStockData(product.id, location.true_id), "active_kiosk", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.getStockData(product.id, location.true_id), "active_kiosk", $$c)}},function($event){_vm.markDirty(product.id, location.true_id)}]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('stock.kiosk')))])])])])])])]],2)})],2)}))])])]),_vm._v(" "),(_vm.productsPagination.totalPages > 1)?_c('div',{staticClass:"pagination-wrapper"},[_c('div',{staticClass:"pagination-info"},[_vm._v("\n               "+_vm._s(_vm.$t('stock.page', { page: _vm.productsPagination.page, totalPages: _vm.productsPagination.totalPages }))+"\n               "+_vm._s(_vm.$t('stock.productsCount', { totalRecords: _vm.productsPagination.totalRecords }))+"\n             ")]),_vm._v(" "),_c('div',{staticClass:"pagination-controls"},[_c('button',{staticClass:"btn btn-sm btn-default",attrs:{"disabled":_vm.productsPagination.page === 1 || _vm.saving},on:{"click":function($event){$event.preventDefault();_vm.changePage(_vm.productsPagination.page - 1)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('stock.previous'))+"\n               ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-default",attrs:{"disabled":_vm.productsPagination.page === _vm.productsPagination.totalPages || _vm.saving},on:{"click":function($event){$event.preventDefault();_vm.changePage(_vm.productsPagination.page + 1)}}},[_vm._v("\n                 "+_vm._s(_vm.$t('stock.next'))+" "),_c('i',{staticClass:"ti-arrow-right"})])])]):_vm._e(),_vm._v(" "),(!_vm.loadingProducts && _vm.products.length === 0)?_c('div',{staticClass:"text-center py-4 text-muted"},[_c('i',{staticClass:"ti-package",staticStyle:{"font-size":"48px"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('stock.noProductsAvailable')))])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fbzq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FcRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file","name":"image","accept":"image/*","capture":"environment"},on:{"change":_vm.onChangeInput}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FeL0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card mar-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-right",staticStyle:{"position":"relative","z-index":"2"}},[_c('router-link',{staticClass:"btn btn-info btn-icon add mar-bt-20",attrs:{"title":"","to":{ path: 'group-option/add'}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])],1)]),_vm._v(" "),_c('table',{ref:"sortableTable",staticClass:"table width-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.$t('companyOptions.id')))]),_vm._v(" "),_c('th',{attrs:{"width":"50%"}},[_vm._v(_vm._s(_vm.$t('companyOptions.name')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}})])]),_vm._v(" "),_c('draggable',{attrs:{"sort":false,"element":'tbody'},on:{"end":_vm.adjustSort},model:{value:(_vm.optionData),callback:function ($$v) {_vm.optionData=$$v},expression:"optionData"}},[_vm._l((_vm.optionData),function(item,index){return [_c('tr',{key:item.id,staticClass:"sortableRow"},[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(item,[],[], $event)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                    ")])])])]})],2)],1)])])])]),_vm._v(" "),_c('div',{staticClass:"space_for_alert_box",staticStyle:{"height":"100px","width":"100%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FeRf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Reports_StockReport_vue__ = __webpack_require__("LYFt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Management_Reports_StockHistoryReport_vue__ = __webpack_require__("5WAl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Management_Reports_NirsReport_vue__ = __webpack_require__("SQ1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Management_Reports_InventoryReport_vue__ = __webpack_require__("z49E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Management_Reports_ProductMixReport_vue__ = __webpack_require__("elzn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Management_Reports_PurchaseReport_vue__ = __webpack_require__("DAkQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Management_Reports_ConsumptionReport_vue__ = __webpack_require__("P9yM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Management_Reports_ProductionReport_vue__ = __webpack_require__("jxwq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Management_Reports_BalanceReport_vue__ = __webpack_require__("QTMt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Reports_Versions_2_MixedReport_vue__ = __webpack_require__("PYU9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Management_Reports_SalesMarkupReport_vue__ = __webpack_require__("v16S");













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StockReport: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Reports_StockReport_vue__["a" /* default */],
    StockHistoryReport: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Management_Reports_StockHistoryReport_vue__["a" /* default */],
    NirsReport: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Management_Reports_NirsReport_vue__["a" /* default */],
    InventoryReport: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Management_Reports_InventoryReport_vue__["a" /* default */],
    ProductMixReport: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Management_Reports_ProductMixReport_vue__["a" /* default */],
    PurchaseReport: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Management_Reports_PurchaseReport_vue__["a" /* default */],
    ConsumptionReport: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Management_Reports_ConsumptionReport_vue__["a" /* default */],
    ProductionReport: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Management_Reports_ProductionReport_vue__["a" /* default */],
    BalanceReport: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Management_Reports_BalanceReport_vue__["a" /* default */],
    MixReport: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Reports_Versions_2_MixedReport_vue__["a" /* default */],
    SalesMarkupReport: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Management_Reports_SalesMarkupReport_vue__["a" /* default */]
  },
  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isInViewElement: {
        isStock: false,
        isStockHistory: false,
        nirs: true,
        inventory: false,
        productMix: false,
        purchase: false,
        consumption: false,
        production: false,
        balance: false,
        salesMarkup: false
      }
    };
  },
  created: function created() {},

  methods: {
    allVarsFalse: function allVarsFalse() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.isInViewElement).forEach(function (key) {
        _this.isInViewElement[key] = false;
      });
    },
    changeView: function changeView(varName) {
      this.allVarsFalse();
      this.isInViewElement[varName] = true;
    }
  }
});

/***/ }),

/***/ "FfsB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__);














__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a),
  props: {},
  watch: {},
  data: function data() {
    return {
      model: [],
      modelValidate: {
        name: { required: true },
        required: { required: true }
      },
      optionTypes: {
        'checkbox': this.$t('checkbox'),
        'radio': this.$t('radio'),
        'upload': this.$t('productOptions.upload')
      },
      windowHeight: 0,
      navbarHeaderHeight: 0,
      pageTopHeight: 76,
      loading: true,
      showLocations: false,
      locations: [],
      vatOptions: [],
      taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
      deleteOptionValues: [],
      deleteOptions: [],
      extraFields: false
    };
  },
  created: function created() {
    this.$nextTick(function () {
      this.loading = true;
    });
    var data = {
      token: this.$session.get('token'),
      detailed_options: 1
    };
    var self = this;

    var companyData = this.$session.get('selectedCompanyData');

    this.extraFields = companyData.glovo_active;

    this.locations = companyData.locations_details;
    if (this.locations.length > 1) {
      this.showLocations = true;
    }

    this.apiRequest('/listdefaults', 'GET', data, function (response) {
      if (response.status === true) {
        self.defaultData = response.data[0];
      }
    });

    this.getData();
  },
  mounted: function mounted() {
    var _this = this;

    this.getVatOptions();
    this.$nextTick(function () {
      _this.doHeightCalculation();

      window.addEventListener('resize', function () {
        _this.doHeightCalculation();
      });
    });
  },

  methods: {
    getData: function getData() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        detailed_options: 1
      };
      var companyID = this.$session.get('selectedCompany');

      this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response2) {
        if (response2.status === true) {
          _this2.model = response2.data[0];
          _this2.$nextTick(function () {
            this.loading = false;
          });
        }
      });
    },
    isLastActiveOptionValue: function isLastActiveOptionValue(optionValues) {
      var counter = optionValues.filter(function (item) {
        return item.active === true;
      });

      return counter.length === 1;
    },
    updateVatPrinterId: function updateVatPrinterId(obj) {
      var selectElement = obj.target;
      var selectedOptionId = selectElement.options[selectElement.selectedIndex].id;
      this.model.vat_id = selectedOptionId;
    },
    getVatOptions: function getVatOptions(locaitonIds) {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_ids: locaitonIds
      };
      var endpoint = this.taxesVersion === 2 ? '/taxes-v2/vat-rates' : '/location/vat';
      this.apiRequest(endpoint, 'GET', data, function (response) {
        if (response.status === true) {
          _this3.vatOptions = response.data;
        }
      });
    },
    isVatOptionDisabled: function isVatOptionDisabled(vat, selectedId) {
      return !!(this.taxesVersion === 2 && vat && !vat.is_active && String(vat.id) !== String(selectedId));
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate(pageId) {
      var _this4 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this4.saveDetails();
        }
      });
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
    },
    addNewValue: function addNewValue(optId) {
      var newRow = {
        'id': null,
        'name': '',
        'vat_rate_id': null,
        'vat_rate_id_sgr': null,
        'active': true
      };

      var zElement = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.model.products_options).filter(function (element) {
        return element.id === optId;
      });

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(zElement[0].values).length === 0) {
        zElement[0].values = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(zElement[0].values));
      }

      zElement[0].values.push(newRow);
    },
    addNewOption: function addNewOption() {
      var newRow = {
        'id': null,
        'name': '',
        'active': true,
        'type': '',
        'location_ids': [],
        'values': []
      };

      var newOption = {
        'id': null,
        'name': '',
        'active': true
      };

      newRow.values.push(newOption);

      if (!this.model.products_options) {
        this.model.products_options = [];
      }

      this.model.products_options.push(newRow);
    },
    duplicateOption: function duplicateOption(optId) {

      var optIdx = this.getObjectByElemKeyValue('id', optId, this.model.products_options);


      var newOpt = {
        'name': this.model.products_options[optIdx].name,
        'active': this.model.products_options[optIdx].active,
        'type': this.model.products_options[optIdx].type,
        'location_ids': this.model.products_options[optIdx].location_ids,
        'display_in_dynamic_menu': this.model.products_options[optIdx].display_in_dynamic_menu,
        'values': this.copyCompanyOptionValueWithoutIds(this.model.products_options[optIdx].values)
      };

      this.model.products_options.push(newOpt);
      this.locations = this.locations;
      this.$nextTick(function () {});
    },
    deleteValue: function deleteValue(optId, valId) {
      this.deleteOptionValues.push(this.model.products_options[optId].values[valId].id);
      this.model.products_options[optId].values.splice(valId, 1);
    },
    expandRow: function expandRow(optId, valId, val) {
      var _this5 = this;

      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_7_vue___default.a.set(_this5.model.products_options[optId].values[valId], 'show', val);
      });
    },
    deleteOption: function deleteOption(optId) {
      var _this6 = this;

      var optionKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!optId) {
        this.model.products_options.splice(optionKey, 1);
        return;
      }
      var self = this;
      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
        text: self.$t('catalogProdOpt.areyouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this6.$session.get('token'),
            company_id: _this6.$session.get('selectedCompany'),
            product_option_id: optId
          };
          _this6.apiRequest('/settings/usage', 'POST', data, function (response) {
            if (response.status) {
              var optIdx = self.getObjectByElemKeyValue('id', optId, self.model.products_options);
              self.deleteOptions.push(optId);
              self.model.products_options.splice(optIdx, 1);
            } else {
              var msg = response.errors['product_option_id'] ? self.$t('catalogProd.optionInUse') : self.$t('validations.wentWrong');
              __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', msg, 'error');
            }
          });
        }
      }).catch(function () {});
    },
    saveDetails: function saveDetails() {
      var _this7 = this;

      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');

      var options = this.copyObject(this.model.products_options);

      for (var idxO in options) {
        var locIds = [];
        if (options[idxO].location_ids) {
          for (var idxL in options[idxO].location_ids) {
            locIds.push(options[idxO].location_ids[idxL]['token']);
          }
        }
        options[idxO].location_ids = locIds;

        for (var idxV in options[idxO].values) {
          if (this.taxesVersion === 2) {
            delete options[idxO].values[idxV].vat_id;
            delete options[idxO].values[idxV].vat_id_sgr;
          } else {
            delete options[idxO].values[idxV].vat_rate_id;
            delete options[idxO].values[idxV].vat_rate_id_sgr;
          }
        }
      }

      var data = {
        'token': this.$session.get('token'),
        'products_options': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options),
        'validate_products_options': 1,
        'delete_options': this.deleteOptions,
        'delete_option_values': this.deleteOptionValues
      };

      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          _this7.getData();
          _this7.errors.clear();
          _this7.$nextTick(function () {
            this.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': _this7.$t('catalogProdOpt.optionSaved'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          _this7.$nextTick(function () {
            this.loading = false;
          });

          if (response.errors && response.errors.option_location) {
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': _this7.$t('catalogProdOpt.optLocationError', response.errors.option_location), 'type': 'error', 'showConfirmButton': true }).catch(function () {});
          } else {
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': _this7.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "Fg1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsDeliveryPreferences_vue__ = __webpack_require__("80s4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c544d52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsDeliveryPreferences_vue__ = __webpack_require__("Q1XM");
function injectStyle (ssrContext) {
  __webpack_require__("mAKn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c544d52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsDeliveryPreferences_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c544d52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsDeliveryPreferences_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FiZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'dashboard',
  icon: 'dash',
  path: '/admin/overview',
  custom_permission: '',
  hide_for_users: false,
  hide_for_admin_location: false,
  hide_for_marketer: true,
  hide_for_operator: true
}, {
  name: 'customers',
  icon: 'cust',
  path: '/customers',
  custom_permission: 'general_can_access_clients',
  hide_for_users: false,
  hide_for_admin_location: false,
  hide_for_marketer: false,
  hide_for_operator: true
}, {
  name: 'orders',
  icon: 'order',
  path: '/orders',
  custom_permission: 'general_can_access_orders',
  session: 'newOrders',
  hide_for_users: false,
  hide_for_marketer: true,
  hide_for_operator: true
}, {
  name: 'catalog',
  icon: 'catalog',
  path: '/catalog?tabIndex=0',
  custom_permission: 'general_can_access_catalog',
  activePaths: ['/catalog', '/products', '/categories', '/top-categories', '/product-options', '/group-options', '/product-filters', '/custom-info-pages', '/menu-links', '/info-pages'],
  hide_for_users: true,
  hide_for_admin_location: false,
  hide_for_marketer: false,
  hide_for_operator: true
}, {
  name: 'tables',
  icon: 'tables',
  path: '/tables',
  custom_permission: 'general_can_access_tables',
  session: 'newTables',
  hide_for_users: true,
  hide_for_marketer: true,
  hide_for_operator: true,
  disabled_globally: true
}, {
  name: 'reservations',
  icon: 'reservations',
  path: '/reservations',
  custom_permission: 'general_can_access_reservations',
  session: 'newReservations',
  hide_for_users: true,
  hide_for_marketer: true,
  hide_for_operator: true
}, {
  name: 'orderspos',
  icon: 'ordernew',
  path: '/add-order',
  custom_permission: 'general_can_access_add_order',
  hide_for_users: true,
  hide_for_marketer: true,
  hide_for_operator: true
}, {
  name: 'dispatch',
  icon: 'dispatch',
  path: '/dispatch?tabIndex=0',
  custom_permission: 'general_can_access_dispatch',
  hide_for_users: true,
  hide_for_admin_location: false,
  hide_for_marketer: true,
  hide_for_operator: true,
  disabled_globally: true
}, {
  name: 'online',
  icon: 'online',
  path: '/online?tabIndex=0',
  hide_for_users: false,
  hide_for_admin_location: false,
  hide_for_marketer: true,
  hide_for_operator: true,
  disabled_globally: true
}, {
  name: 'kiosk',
  icon: 'kiosk',
  path: '/kiosk?tabIndex=0',
  hide_for_users: false,
  hide_for_admin_location: false,
  hide_for_marketer: true,
  hide_for_operator: true,
  disabled_globally: true
}, {
  name: 'qr',
  icon: 'qr',
  path: '/qr?tabIndex=0',
  hide_for_users: false,
  hide_for_admin_location: false,
  hide_for_marketer: true,
  hide_for_operator: true,
  disabled_globally: true
}, {
  name: 'kds',
  icon: 'kds',
  path: '/screens/kds?tabIndex=0',
  custom_permission: 'general_can_access_kds',
  hide_for_users: true,
  hide_for_admin_location: false,
  hide_for_marketer: true,
  hide_for_operator: true,
  disabled_globally: true
}, {
  name: 'screens',
  icon: 'screens',
  path: '/screens/tabs?tabIndex=0',
  custom_permission: 'general_can_access_screens',
  activePaths: [{ path: '/screens', exact: true }, '/screens/tabs'],
  exact: true,
  includeChildrenInActive: false,
  hide_for_users: true,
  hide_for_admin_location: false,
  hide_for_marketer: true,
  hide_for_operator: true,
  disabled_globally: true
}, {
  name: 'gestiune',
  icon: 'gestiune',
  path: '/management/sidebar?tab=reports',
  custom_permission: 'general_can_access_inventory',
  hide_for_users: true,
  hide_for_admin_location: false,
  hide_for_marketer: true,
  hide_for_operator: true,
  disabled_globally: true
}, {
  name: 'pos',
  icon: 'pos',
  path: '/pos/tabs?tabIndex=1',
  custom_permission: 'general_can_access_pos',
  hide_for_users: true,
  hide_for_admin_location: false,
  hide_for_marketer: true,
  hide_for_operator: true,
  disabled_globally: true
}, {
  name: 'marketing',
  icon: 'marketing',
  path: '/marketing',
  custom_permission: 'general_can_access_marketing',
  hide_for_users: true,
  hide_for_admin_location: false,
  hide_for_marketer: false,
  hide_for_operator: true,
  disabled_globally: true
}, {
  name: 'reports',
  icon: 'report',
  path: '/reports',
  custom_permission: 'general_can_access_reports',
  hide_for_users: false,
  hide_for_admin_location: false,
  hide_for_marketer: true,
  hide_for_operator: true
}, {
  icon: 'feedback',
  name: 'feedback',
  path: '/feedback',
  custom_permission: 'general_can_access_feedback',
  session: 'newFeedback',
  hide_for_users: false,
  hide_for_admin_location: false,
  hide_for_marketer: true,
  hide_for_operator: true
}, {
  name: 'settings',
  icon: 'settings',
  path: '/settings',
  custom_permission: 'general_can_access_setings',
  hide_for_users: true,
  hide_for_admin_location: true,
  hide_for_marketer: true,
  hide_for_operator: true
}, {
  name: 'newsletter',
  icon: 'newsletter',
  path: '/newsletter/news',
  session: 'newNews',
  hide_for_users: true,
  hide_for_admin_location: true,
  hide_for_marketer: true,
  hide_for_operator: true
}]);

/***/ }),

/***/ "FpHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"wolt-location-wrapper"},[(_vm.route)?_c('location-form',{attrs:{"route":_vm.route}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fxae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementStocksForm_vue__ = __webpack_require__("1wii");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46053feb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementStocksForm_vue__ = __webpack_require__("4Ilb");
function injectStyle (ssrContext) {
  __webpack_require__("ry9P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46053feb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementStocksForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46053feb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementStocksForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FzEz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PosForm_vue__ = __webpack_require__("iVJX");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PosForm', __WEBPACK_IMPORTED_MODULE_7__PosForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "FzzJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Marketing_Campaigns_Campaigns_vue__ = __webpack_require__("f9hE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Marketing_DiscountCoupons_Coupons_vue__ = __webpack_require__("nI7P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Marketing_Subscriptions_Subscriptions_vue__ = __webpack_require__("YCPL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Marketing_MenuSubscriptions_MenuSubscriptions_vue__ = __webpack_require__("sSO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Marketing_AutomationCampaigns_AutomationCampaigns_vue__ = __webpack_require__("6GZj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Marketing_DonationCampaigns_DonationCampaigns_vue__ = __webpack_require__("sqsr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Marketing_DiscountCampaigns_DiscountCampaigns_vue__ = __webpack_require__("wGs9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Marketing_ChallengeCampaigns_ChallengeCampaigns_vue__ = __webpack_require__("sSZn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Marketing_SpinningWheel_SpinningWheelCampaigns_vue__ = __webpack_require__("gz/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Marketing_Referral_ReferralCampaigns_vue__ = __webpack_require__("t613");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Marketing_RaffleCampaigns_RaffleCampaigns_vue__ = __webpack_require__("eLXi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Marketing_LoyaltyStore_LoyaltyStoreCampaigns_vue__ = __webpack_require__("OTDR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Marketing_Referral_ReferralAmbassadorRequests_vue__ = __webpack_require__("ROT0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Marketing_Offers_Offers_vue__ = __webpack_require__("duJW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Marketing_DynamicMenus_DynamicMenu_vue__ = __webpack_require__("E0xI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Marketing_Promos_Promos_vue__ = __webpack_require__("+gUM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Customers_Groups_Groups_vue__ = __webpack_require__("xWAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Customers_Approvals_Approvals_vue__ = __webpack_require__("PUl8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Marketing_GiftCard_GiftCard_vue__ = __webpack_require__("sQwZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Marketing_Fidelities_Loyality_vue__ = __webpack_require__("jgtC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Marketing_Fidelities_UserLabel_UserLabeling_vue__ = __webpack_require__("a5PJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_LoyaltyPointsScanner_LoyaltyPointsScanner_vue__ = __webpack_require__("fKeh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__UIComponents_ModuleLocked_vue__ = __webpack_require__("hszr");


























/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Campaigns: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Marketing_Campaigns_Campaigns_vue__["a" /* default */],
    DiscountCoupons: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Marketing_DiscountCoupons_Coupons_vue__["a" /* default */],
    Subscriptions: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Marketing_Subscriptions_Subscriptions_vue__["a" /* default */],
    MenuSubscriptions: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Marketing_MenuSubscriptions_MenuSubscriptions_vue__["a" /* default */],
    AutomationCampaigns: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Marketing_AutomationCampaigns_AutomationCampaigns_vue__["a" /* default */],
    DonationCampaigns: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Marketing_DonationCampaigns_DonationCampaigns_vue__["a" /* default */],
    DiscountCampaigns: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Marketing_DiscountCampaigns_DiscountCampaigns_vue__["a" /* default */],
    ChallengeCampaigns: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Marketing_ChallengeCampaigns_ChallengeCampaigns_vue__["a" /* default */],
    SpinningWheelCampaigns: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Marketing_SpinningWheel_SpinningWheelCampaigns_vue__["a" /* default */],
    ReferralCampaigns: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Marketing_Referral_ReferralCampaigns_vue__["a" /* default */],
    RaffleCampaigns: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Marketing_RaffleCampaigns_RaffleCampaigns_vue__["a" /* default */],
    LoyaltyStoreCampaigns: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Marketing_LoyaltyStore_LoyaltyStoreCampaigns_vue__["a" /* default */],
    ReferralAmbassadorRequests: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Marketing_Referral_ReferralAmbassadorRequests_vue__["a" /* default */],
    Offers: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Marketing_Offers_Offers_vue__["a" /* default */],
    DynamicMenu: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Marketing_DynamicMenus_DynamicMenu_vue__["a" /* default */],
    Loyality: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Marketing_Fidelities_Loyality_vue__["a" /* default */],
    UserLabeling: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Marketing_Fidelities_UserLabel_UserLabeling_vue__["a" /* default */],
    Promos: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Marketing_Promos_Promos_vue__["a" /* default */],
    GroupsCustomer: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Customers_Groups_Groups_vue__["a" /* default */],
    Approvals: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Customers_Approvals_Approvals_vue__["a" /* default */],
    ModuleLocked: __WEBPACK_IMPORTED_MODULE_22__UIComponents_ModuleLocked_vue__["a" /* default */],
    GiftCard: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Marketing_GiftCard_GiftCard_vue__["a" /* default */],
    Scanner: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_LoyaltyPointsScanner_LoyaltyPointsScanner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isCampaigns: false,
      isCoupons: false,
      isSubscriptions: false,
      isMenuSubscriptions: false,
      isAutomation: false,
      isDonationCampaigns: false,
      isDiscountCampaigns: false,
      isChallengeCampaigns: false,
      isSpinningWheelCampaigns: false,
      isReferralCampaigns: false,
      isRaffleCampaigns: false,
      isLoyaltyStoreCampaigns: false,
      isAmbassadorRequests: false,
      isOffersSlider: false,
      isMenus: false,
      isLoyality: false,
      isUserLabeling: false,
      isPromos: false,
      isCustomersGroups: false,
      isGiftCard: false,
      isApprovals: false,
      isScanner: false
    };
  },

  computed: {
    company: function company() {
      return this.userData && this.userData.companies && this.userData.companies[0] || {};
    }
  },
  mounted: function mounted() {
    this.userData = JSON.parse(this.$session.get('userData') || '{}');

    var index = this.$route.query.tabIndex;
    if (index != null && index !== '') {
      this.switchTab();
    } else {
      this.isCampaigns = true;
    }
  },

  watch: {
    '$route.query.tabIndex': function $routeQueryTabIndex() {
      this.switchTab();
    }
  },
  methods: {
    resetStates: function resetStates() {
      this.isCampaigns = false;
      this.isCoupons = false;
      this.isSubscriptions = false;
      this.isMenuSubscriptions = false;
      this.isAutomation = false;
      this.isDonationCampaigns = false;
      this.isDiscountCampaigns = false;
      this.isChallengeCampaigns = false;
      this.isSpinningWheelCampaigns = false;
      this.isReferralCampaigns = false;
      this.isRaffleCampaigns = false;
      this.isLoyaltyStoreCampaigns = false;
      this.isAmbassadorRequests = false;
      this.isOffersSlider = false;
      this.isMenus = false;
      this.isLoyality = false;
      this.isUserLabeling = false;
      this.isPromos = false;
      this.isCustomersGroups = false;
      this.isApprovals = false;
      this.isGiftCard = false;
      this.isScanner = false;
    },
    switchTab: function switchTab() {
      var _this = this;

      var index = this.$route.query.tabIndex;
      this.$nextTick(function () {
        if (index != null && index !== '' && _this.$refs.tabs) {
          var tabIndex = parseInt(index, 10);
          _this.$refs.tabs.navigateToTab(tabIndex);
          _this.activateTabByIndex(tabIndex);
        }
      });
    },
    activateTabByIndex: function activateTabByIndex(tabIndex) {
      this.resetStates();
      var tabFlags = ['isCampaigns', 'isCoupons', 'isSubscriptions', 'isMenuSubscriptions', 'isAutomation', 'isDonationCampaigns', 'isDiscountCampaigns', 'isChallengeCampaigns', 'isSpinningWheelCampaigns', 'isReferralCampaigns', 'isRaffleCampaigns', 'isLoyaltyStoreCampaigns', 'isAmbassadorRequests', 'isOffersSlider', 'isMenus', 'isLoyality', 'isUserLabeling', 'isPromos', 'isCustomersGroups', 'isApprovals', 'isGiftCard', 'isScanner'];
      var flag = tabFlags[tabIndex];
      if (flag) {
        this[flag] = true;
      } else {
        this.isCampaigns = true;
      }
    },
    handleTabChange: function handleTabChange(tabIndex) {
      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);
      this.activateTabByIndex(tabIndex);
    }
  }
});

/***/ }),

/***/ "G1Mb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G6CG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasurementsUnits_vue__ = __webpack_require__("TndE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0912ccfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasurementsUnits_vue__ = __webpack_require__("Ear1");
function injectStyle (ssrContext) {
  __webpack_require__("7z/J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasurementsUnits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0912ccfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasurementsUnits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G8fY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_google_maps__ = __webpack_require__("lMsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__API_KEY__ = __webpack_require__("JElF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Settings_Taxes_DeliveryTaxPanel_vue__ = __webpack_require__("OZUI");












__WEBPACK_IMPORTED_MODULE_7_google_maps___default.a.KEY = __WEBPACK_IMPORTED_MODULE_8__API_KEY__["a" /* API_KEY */];
__WEBPACK_IMPORTED_MODULE_7_google_maps___default.a.VERSION = '3.64';
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DeliveryTaxPanel: __WEBPACK_IMPORTED_MODULE_9__Settings_Taxes_DeliveryTaxPanel_vue__["a" /* default */]
  },
  computed: {
    vatOptionsForLocation: function vatOptionsForLocation() {
      var _this = this;

      if (this.taxesVersion === 2) {
        return this.vatOptions || [];
      }
      return (this.vatOptions || []).filter(function (vat) {
        return _this.bussLocationId === vat.location_token;
      });
    },
    visibleCostRanges: function visibleCostRanges() {
      var rules = this.zone && this.zone.delivery_range_cost_rules ? this.zone.delivery_range_cost_rules : [];
      return rules.map(function (costRange, idxO) {
        return { costRange: costRange, idxO: idxO };
      }).filter(function (x) {
        return !x.costRange.deleted;
      });
    }
  },
  data: function data() {
    return {
      zoneCostRulesIndex: 0,
      flagEventIsAdded: 0,
      draw: {},
      selectedShape: null,
      drawingManager: null,
      shape: [],
      zone: null,
      costRangeDistanceTouched: {},
      costRangeDistanceErrors: {}
    };
  },

  props: {
    location_id: null,
    nameInvalid: {
      type: Boolean,
      default: false
    },
    showTheRestOfTheZones: true,
    currency: null,
    cityFromParent: '',
    googleMapsapiKey: '',
    locationMarker: {},
    zoneInComp: {},
    deliveryRanges: {},
    indexZone: {},
    bussLocationId: {},
    orderType: {},
    taxesVersion: {
      type: Number,
      default: 1
    },
    vatOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    hideDeleteZone: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.zone = this.zoneInComp;
    this.resolveVatForContext();
    this.restOfZones = [];
    for (var i = this.deliveryRanges.length - 1; i >= 0; i--) {
      if (!this.zone.hasOwnProperty('id') || this.zone.hasOwnProperty('id') && this.zone.id !== this.deliveryRanges[i].id) {
        this.restOfZones.push(this.deliveryRanges[i]);
      }
    }
    this.openCostRangeWithDistanceError();
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_7_google_maps___default.a.load(function (google) {
      _this2.initMap(google);
    });
  },

  watch: {
    showTheRestOfTheZones: function showTheRestOfTheZones() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_7_google_maps___default.a.load(function (google) {
        _this3.initMap(google);
      });
    },
    vatOptions: function vatOptions() {
      this.resolveVatForContext();
    },

    zoneInComp: {
      deep: true,
      handler: function handler(zone) {
        this.zone = zone;
        this.resolveVatForContext();
        this.openCostRangeWithDistanceError();
      }
    }
  },
  methods: {
    openCostRangeWithDistanceError: function openCostRangeWithDistanceError() {
      var _this4 = this;

      this.$nextTick(function () {
        var invalidCostRange = _this4.visibleCostRanges.find(function (item) {
          return item.costRange && item.costRange.__distance_required_error;
        });
        if (invalidCostRange) {
          _this4.zoneCostRulesIndex = invalidCostRange.idxO;
        }
      });
    },
    touchCostRangeDistance: function touchCostRangeDistance(idx, costRange) {
      __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(this.costRangeDistanceTouched, idx, true);
      this.validateCostRangeDistance(idx, costRange);
    },
    validateCostRangeDistance: function validateCostRangeDistance(idx, costRange) {
      var v = costRange ? costRange.distance_in_km : '';
      var hasError = v === '' || v === null || typeof v === 'undefined';
      if (costRange && costRange.__distance_required_error && !hasError) {
        __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(costRange, '__distance_required_error', false);
      }
      __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(this.costRangeDistanceErrors, idx, hasError);
      return !hasError;
    },
    costRangeDistanceHasError: function costRangeDistanceHasError(idx, costRange) {
      if (costRange && costRange.__distance_required_error) return true;
      if (!this.costRangeDistanceTouched[idx]) return false;
      if (typeof this.costRangeDistanceErrors[idx] === 'undefined') {
        return !this.validateCostRangeDistance(idx, costRange);
      }
      return !!this.costRangeDistanceErrors[idx];
    },
    emitZoneUpdate: function emitZoneUpdate() {
      this.$emit('update-zone', this.zone, this.indexZone);
    },
    addCostRules: function addCostRules() {
      var newRow = {
        'company_id': this.zone.company_id,
        'location_id': this.location_id,
        'delivery_ranges_id': this.zone.id,
        'distance_in_km': '',
        'extra_delivery_time': '',
        'min_order_value': '',
        'shipping_cost': '',
        'shipping_pos_id': ''
      };

      if (!this.zone.hasOwnProperty('delivery_range_cost_rules')) {
        __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(this.zone, 'delivery_range_cost_rules', []);
      }

      this.zone.delivery_range_cost_rules.push(newRow);
      this.$emit('update-zone', this.zone, this.indexZone);

      this.zoneCostRulesIndex = this.zone.delivery_range_cost_rules ? this.zone.delivery_range_cost_rules.length - 1 : 0;
    },
    deleteCostRules: function deleteCostRules(id) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        text: this.$t('catalogProdOpt.areyouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(_this5.zone.delivery_range_cost_rules[id], 'deleted', 1);
          _this5.$emit('update-zone', _this5.zone, _this5.indexZone);
        }
      });
    },
    resolveVatForContext: function resolveVatForContext() {
      var current = this.zone ? this.zone.shipping_cost_vat_id : null;
      if (current === null || current === undefined || current === '' || Number(current) === 0) return;
      var localList = this.vatOptionsForLocation || [];
      if (localList.some(function (v) {
        return String(v.id) === String(current);
      })) return;
      var original = (this.vatOptions || []).find(function (v) {
        return String(v.id) === String(current);
      });
      if (!original) return;
      var match = localList.find(function (v) {
        return String(v.amount) === String(original.amount);
      });
      if (match) this.$set(this.zone, 'shipping_cost_vat_id', match.id);
    },
    geolocation: function geolocation(address, callbackFunction) {
      var Lat = null;
      var Lng = null;
      var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({
        'address': address
      }, function (results, status) {
        if (status === window.google.maps.GeocoderStatus.OK) {
          Lat = results[0].geometry.location.lat();
          Lng = results[0].geometry.location.lng();
        } else {
          Lat = 47.0667;
          Lng = 21.9333;
        }
        if (callbackFunction) callbackFunction(Lat, Lng);
        return true;
      });
    },
    getVatOptions: function getVatOptions() {
      var _this6 = this;

      var locaitonIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_ids: locaitonIds
      };
      this.apiRequest('/location/vat', 'GET', data, function (response) {
        if (response.status === true) {
          _this6.vatOptions = response.data;
        }
      });
    },
    initMap: function initMap(google) {
      var _this7 = this;

      var myLatlng = {};
      if (this.zone.shape && this.zone.shape.type === 'circle') {
        myLatlng = new google.maps.LatLng(this.zone.shape.centerLat, this.zone.shape.centerLng);
        this.initMap2(myLatlng);
      } else if (this.zone.shape && this.zone.shape.type === 'rectangle') {
        myLatlng = new google.maps.LatLng(this.zone.shape.center.lat, this.zone.shape.center.lng);
        this.initMap2(myLatlng);
      } else if (this.zone.shape && this.zone.shape.type === 'polygon' && Array.isArray(this.zone.shape.array) && this.zone.shape.array.length) {
        var bounds = new google.maps.LatLngBounds();
        this.zone.shape.array.forEach(function (p) {
          return bounds.extend(new google.maps.LatLng(p.lat, p.lng));
        });
        myLatlng = bounds.getCenter();
        this.initMap2(myLatlng);
      } else {
        this.geolocation(this.cityFromParent, function (Lat, Lng) {
          myLatlng = new google.maps.LatLng(Lat, Lng);
          _this7.initMap2(myLatlng);
        });
      }
    },
    initMap2: function initMap2(myLatlng) {
      var _this8 = this;

      this.drawingManager = new window.google.maps.drawing.DrawingManager({
        drawingControl: true,
        drawingControlOptions: {
          position: window.google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [window.google.maps.drawing.OverlayType.CIRCLE, window.google.maps.drawing.OverlayType.POLYGON, window.google.maps.drawing.OverlayType.RECTANGLE]
        },
        circleOptions: {
          fillColor: 'white',
          fillOpacity: 0.2,
          strokeWeight: 1,
          clickable: true,
          editable: true,
          zIndex: 1
        },
        rectangleOptions: {
          fillColor: 'white',
          fillOpacity: 0.2,
          strokeWeight: 1,
          clickable: true,
          editable: true,
          zIndex: 1
        },
        polygonOptions: {
          fillColor: 'white',
          fillOpacity: 0.2,
          strokeWeight: 1,
          clickable: true,
          editable: true,
          zIndex: 1
        }
      });
      var mapOptions = {
        zoom: 12,
        center: myLatlng,
        streetViewControl: false,
        scrollwheel: false };
      var map = new window.google.maps.Map(document.getElementById('map_' + this.indexZone + '_' + this.bussLocationId), mapOptions);
      this.drawingManager.setMap(map);

      if (this.locationMarker) {}

      window.google.maps.event.addListener(this.drawingManager, 'overlaycomplete', function (e) {
        if (e.type !== window.google.maps.drawing.OverlayType.MARKER) {
          _this8.drawingManager.setDrawingMode(null);

          _this8.drawingManager.setOptions({
            drawingControl: false
          });

          var newShape = e.overlay;
          newShape.type = e.type;
          window.google.maps.event.addListener(newShape, 'click', function () {
            _this8.setSelection(newShape);
          });
          _this8.setSelection(newShape);
        }
      });

      this.drawTheShape(map);
      if (this.showTheRestOfTheZones) {
        var colors = ['#FF5733', '#3357FF', '#FF33A1', '#33FFF3', '#F3FF33', '#8D33FF', '#FF8D33', '#33FF8D', '#5733FF', '#FF5733', '#33A1FF', '#A1FF33', '#FF33F3', '#33FFA1'];
        for (var i = this.restOfZones.length - 1; i >= 0; i--) {
          this.drawTheShape2(map, this.restOfZones[i], colors[i % colors.length]);
        }
      }
    },
    drawTheShape: function drawTheShape(map) {
      if (this.zone.shape) {
        if (this.zone.shape.type === 'polygon') {
          this.drawingManager.setDrawingMode(null);
          this.drawingManager.setOptions({
            drawingControl: false
          });
          this.selectedShape = new window.google.maps.Polygon({
            paths: this.zone.shape.array,
            fillColor: 'white',
            fillOpacity: 0.2,
            strokeWeight: 1,
            clickable: true,
            editable: true,
            zIndex: 1
          });
          this.selectedShape.setMap(map);
          this.selectedShape.type = this.zone.shape.type;
          this.sendCoords();
        }
        if (this.zone.shape.type === 'circle') {
          this.drawingManager.setDrawingMode(null);
          this.drawingManager.setOptions({
            drawingControl: false
          });
          this.selectedShape = new window.google.maps.Circle({
            center: { 'lat': this.zone.shape.centerLat, 'lng': this.zone.shape.centerLng },
            radius: this.zone.shape.centerRadius,
            fillColor: 'white',
            fillOpacity: 0.2,
            strokeWeight: 1,
            clickable: true,
            editable: true,
            zIndex: 1
          });
          this.selectedShape.setMap(map);
          this.selectedShape.type = this.zone.shape.type;
          this.sendCoords();
        }
        if (this.zone.shape.type === 'rectangle') {
          this.selectedShape = new window.google.maps.Rectangle({
            fillColor: 'white',
            fillOpacity: 0.2,
            strokeWeight: 1,
            clickable: true,
            editable: true,
            zIndex: 1,
            bounds: new window.google.maps.LatLngBounds(new window.google.maps.LatLng(this.zone.shape.southWestLat, this.zone.shape.southWestLng), new window.google.maps.LatLng(this.zone.shape.northEastLat, this.zone.shape.northEastLng))
          });
          this.drawingManager.setDrawingMode(null);
          this.drawingManager.setOptions({
            drawingControl: false
          });
          this.selectedShape.setMap(map);
          this.selectedShape.type = this.zone.shape.type;
          this.sendCoords();
        }
      }
    },
    drawTheShape2: function drawTheShape2(map, zone, color) {
      var labelPosition = null;
      if (zone.shape) {
        if (zone.shape.type === 'polygon') {
          this.shape[zone.id] = new window.google.maps.Polygon({
            paths: zone.shape.array,
            fillColor: color,
            fillOpacity: 0.3,
            strokeWeight: 0,
            clickable: false,
            editable: false,
            zIndex: 1
          });
          this.shape[zone.id].setMap(map);
          this.shape[zone.id].type = zone.shape.type;

          var bounds = new window.google.maps.LatLngBounds();
          zone.shape.array.forEach(function (path) {
            bounds.extend(new window.google.maps.LatLng(path.lat, path.lng));
          });
          labelPosition = bounds.getCenter();
        }
        if (zone.shape.type === 'circle') {
          this.shape[zone.id] = new window.google.maps.Circle({
            center: { 'lat': zone.shape.centerLat, 'lng': zone.shape.centerLng },
            radius: zone.shape.centerRadius,
            fillColor: color,
            fillOpacity: 0.3,
            strokeWeight: 0,
            clickable: false,
            editable: false,
            zIndex: 1
          });
          this.shape[zone.id].setMap(map);
          this.shape[zone.id].type = zone.shape.type;
          labelPosition = new window.google.maps.LatLng(zone.shape.centerLat, zone.shape.centerLng);
        }
        if (zone.shape.type === 'rectangle') {
          this.shape[zone.id] = new window.google.maps.Rectangle({
            fillColor: color,
            fillOpacity: 0.3,
            strokeWeight: 0,
            clickable: false,
            editable: false,
            zIndex: 1,
            bounds: new window.google.maps.LatLngBounds(new window.google.maps.LatLng(zone.shape.southWestLat, zone.shape.southWestLng), new window.google.maps.LatLng(zone.shape.northEastLat, zone.shape.northEastLng))
          });
          this.shape[zone.id].setMap(map);
          this.shape[zone.id].type = zone.shape.type;

          labelPosition = this.shape[zone.id].bounds.getCenter();
        }

        var LabelOverlay = function (_window$google$maps$O) {
          __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LabelOverlay, _window$google$maps$O);

          function LabelOverlay(map, position, text) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LabelOverlay);

            var _this9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LabelOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LabelOverlay)).call(this));

            _this9.position = position;
            _this9.text = text;
            _this9.setMap(map);
            return _this9;
          }

          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LabelOverlay, [{
            key: 'onAdd',
            value: function onAdd() {
              this.div = document.createElement('div');
              this.div.style.position = 'absolute';
              this.div.style.background = color;
              this.div.style.color = 'white';
              this.div.style.padding = '2px';
              this.div.style.border = '0px solid black';
              this.div.style.fontSize = '12px';
              this.div.innerHTML = this.text;
              var panes = this.getPanes();
              panes.overlayLayer.appendChild(this.div);
            }
          }, {
            key: 'draw',
            value: function draw() {
              var projection = this.getProjection();
              var position = projection.fromLatLngToDivPixel(this.position);
              if (this.div) {
                this.div.style.left = position.x + 'px';
                this.div.style.top = position.y + 'px';
              }
            }
          }, {
            key: 'onRemove',
            value: function onRemove() {
              if (this.div) {
                this.div.parentNode.removeChild(this.div);
                this.div = null;
              }
            }
          }]);

          return LabelOverlay;
        }(window.google.maps.OverlayView);

        if (labelPosition) {
          var label = new LabelOverlay(map, labelPosition, zone.name);
          this.shape[zone.id].label = label;
        }
      }
    },
    setSelection: function setSelection(shape) {
      this.clearSelection();
      this.selectedShape = shape;
      shape.setEditable(true);
      this.flagEventIsAdded = 0;
      this.sendCoords();
    },
    sendCoords: function sendCoords() {
      if (this.selectedShape.type === 'polygon') {
        if (!this.flagEventIsAdded) {
          window.google.maps.event.addListener(this.selectedShape.getPath(), 'insert_at', this.sendCoords);
          window.google.maps.event.addListener(this.selectedShape.getPath(), 'remove_at', this.sendCoords);
          window.google.maps.event.addListener(this.selectedShape.getPath(), 'set_at', this.sendCoords);
          this.flagEventIsAdded = 1;
        }
        var cord = [];
        var coords = this.selectedShape.getPath().getArray();
        for (var i = 0; i < coords.length; i++) {
          var coordsLat = coords[i].lat();
          var coordsLng = coords[i].lng();
          cord[i] = {
            lat: coordsLat,
            lng: coordsLng
          };
        }
        this.zone['shape'] = {
          'type': this.selectedShape.type,
          'array': cord
        };
      }
      if (this.selectedShape.type === 'circle') {
        if (!this.flagEventIsAdded) {
          window.google.maps.event.addListener(this.selectedShape, 'radius_changed', this.sendCoords);
          window.google.maps.event.addListener(this.selectedShape, 'center_changed', this.sendCoords);
          this.flagEventIsAdded = 1;
        }
        var center = this.selectedShape.getCenter();
        this.zone['shape'] = {
          'type': this.selectedShape.type,
          'centerLat': center.lat(),
          'centerLng': center.lng(),
          'centerRadius': this.selectedShape.getRadius()
        };
      }
      if (this.selectedShape.type === 'rectangle') {
        if (!this.flagEventIsAdded) {
          window.google.maps.event.addListener(this.selectedShape, 'bounds_changed', this.sendCoords);
          this.flagEventIsAdded = 1;
        }
        var bounds = this.selectedShape.getBounds();
        this.zone['shape'] = {
          'type': this.selectedShape.type,
          'center': { 'lat': bounds.getCenter().lat(), 'lng': bounds.getCenter().lng() },
          'northEastLat': bounds.getNorthEast().lat(),
          'northEastLng': bounds.getNorthEast().lng(),
          'southWestLat': bounds.getSouthWest().lat(),
          'southWestLng': bounds.getSouthWest().lng()
        };
      }
    },
    deleteZone: function deleteZone(indexZone) {
      var obj = {
        'action': 'delete',
        'indexZone': indexZone,
        'bussLocationId': this.bussLocationId,
        'orderType': this.orderType
      };
      this.$bus.$emit('changeDeliveryZone', obj);
    },
    deleteSelectedShape: function deleteSelectedShape() {
      if (this.selectedShape) {
        this.selectedShape.setMap(null);

        this.drawingManager.setOptions({
          drawingControl: true
        });
        this.selectedShape = null;
        this.zone['shape'] = null;
        this.flagEventIsAdded = 0;
      }
    },
    clearSelection: function clearSelection() {
      if (this.selectedShape) {
        this.selectedShape.setEditable(false);
        this.selectedShape = null;
        this.zone['shape'] = null;
        this.flagEventIsAdded = 0;
      }
    }
  }
});

/***/ }),

/***/ "G9By":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_tooltip_css__ = __webpack_require__("RWjY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_tooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tooltip__ = __webpack_require__("aMwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);



















__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_tooltip___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_vue_js_modal___default.a, { componentName: 'vmodal' });

var GATEWAY_LABELS = {
  euplatesc: 'euPlatesc'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      searchQuery: '',
      families: [],
      currency: '',
      paymentGroups: [],
      savingFamily: false,
      familyForm: {
        id: null,
        name: '',
        payment_group_key: '',
        locked: false
      }
    };
  },
  created: function created() {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso);
    this.getFamilies();
    this.getPaymentGroups();
    this.$bus.$on('refresh', this.getFamilies);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.getFamilies);
  },

  methods: {
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    getFamilies: function getFamilies() {
      var _this = this;

      var data = this.requestData();
      if (this.searchQuery.length >= 3) {
        data.search = this.searchQuery;
      }
      this.loading = true;
      this.apiRequest('/subscription', 'GET', data, function (response) {
        if (response.status === true) {
          _this.families = response.data || [];
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    getPaymentGroups: function getPaymentGroups() {
      var _this2 = this;

      this.apiRequest('/subscription/payment-groups', 'GET', this.requestData(), function (response) {
        if (response.status === true) {
          _this2.paymentGroups = response.data || [];
        }
      });
    },
    paymentGroupLabel: function paymentGroupLabel(group) {
      return (group.group_name || group.group_key) + ' · ' + (GATEWAY_LABELS[group.gateway] || group.gateway);
    },
    onInput: function onInput() {
      if (this.searchQuery.length >= 3 || this.searchQuery.length === 0) {
        this.getFamilies();
      }
    },
    topLevel: function topLevel(family) {
      return family.levels[family.levels.length - 1] || {};
    },
    editLevel: function editLevel(level) {
      this.$router.push({ path: '/marketing/subscriptions/edit/' + level.id }).catch(function () {});
    },
    addLevel: function addLevel(family) {
      this.$router.push({ path: '/marketing/subscriptions/add', query: { family_id: family.id } }).catch(function () {});
    },
    openSubscribers: function openSubscribers(family, level) {
      var query = { family_id: family.id };
      if (level) {
        query.subscription_id = level.id;
      }
      this.$router.push({ path: '/marketing/subscriptions/subscribers', query: query }).catch(function () {});
    },
    handleActive: function handleActive(level) {
      var _this3 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestData(), {
        active: level.active ? 1 : 0
      });
      this.apiRequest('/subscription/' + level.id + '/status', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()(_this3.$t('general.success') + '!', '', 'success').catch(function () {});
        } else {
          level.active = !level.active;
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    deleteBlockedReason: function deleteBlockedReason(family, level) {
      return level.id !== this.topLevel(family).id ? this.$t('marketingSubscriptions.notTopDelete') : this.$t('marketingSubscriptions.lockedDelete');
    },
    showDeleteBlocked: function showDeleteBlocked(family, level) {
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', this.deleteBlockedReason(family, level), 'info').catch(function () {});
    },
    handleDelete: function handleDelete(family, level) {
      var _this4 = this;

      var text = this.$t('marketingSubscriptions.areYouSureDelete') + ' ' + level.name + '?';
      if (family.levels.length === 1) {
        text += ' ' + this.$t('marketingSubscriptions.deleteLastLevelWarning');
      }
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        text: text,
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (!result) {
          return;
        }
        _this4.apiRequest('/subscription/' + level.id, 'DELETE', _this4.requestData(), function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this4.$t('marketingSubscriptions.deleted'), 'success').catch(function () {});
            _this4.getFamilies();
          } else {
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this4.firstError(response), 'error').catch(function () {});
          }
        });
      }).catch(function () {});
    },
    openFamilyModal: function openFamilyModal(family) {
      this.familyForm = {
        id: family.id,
        name: family.name,
        payment_group_key: family.payment_group_key,
        locked: family.active_subscribers > 0
      };
      this.$modal.show('subscriptionFamilyModal');
    },
    onModalOpened: function onModalOpened() {
      var el = document.querySelector('.subscriptionFamilyModal.vm--container');
      if (el && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    },
    saveFamily: function saveFamily() {
      var _this5 = this;

      if (!(this.familyForm.name || '').trim()) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', this.$t('marketingSubscriptions.familyNameRequired'), 'warning').catch(function () {});
        return;
      }
      var group = this.paymentGroups.find(function (item) {
        return item.group_key === _this5.familyForm.payment_group_key;
      });
      if (!group) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', this.$t('marketingSubscriptions.paymentRequired'), 'warning').catch(function () {});
        return;
      }
      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestData(), {
        name: this.familyForm.name,
        payment_gateway: group.gateway,
        payment_group_key: group.group_key
      });
      this.savingFamily = true;
      this.apiRequest('/subscription/families/' + this.familyForm.id, 'PUT', data, function (response) {
        _this5.savingFamily = false;
        if (response.status === true) {
          _this5.$modal.hide('subscriptionFamilyModal');
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this5.$t('marketingSubscriptions.familySaved'), 'success').catch(function () {});
          _this5.getFamilies();
        } else {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this5.firstError(response), 'error').catch(function () {});
        }
      });
    },
    firstError: function firstError(response) {
      var errors = response && response.errors || {};
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors)[0];
      if (!key) {
        return this.$t('validations.wentWrong');
      }
      return Array.isArray(errors[key]) ? errors[key][0] : errors[key];
    }
  }
});

/***/ }),

/***/ "GDtL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GKg+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralProgramReport_vue__ = __webpack_require__("2kML");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122f931c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralProgramReport_vue__ = __webpack_require__("Tcqv");
function injectStyle (ssrContext) {
  __webpack_require__("hLvh")
  __webpack_require__("BbTf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-122f931c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralProgramReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122f931c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralProgramReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GMql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-details"},[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn btn-info btn-icon mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingCompany.location')},on:{"click":function($event){$event.preventDefault();return _vm.addLocation($event)}}},[_c('i',{staticClass:"ti-plus"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-success btn-icon mar-rt-10",attrs:{"title":_vm.$t('general.save') + ' ' + _vm.$t('settingCompany.location')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('i',{staticClass:"ti-save"})])])])]),_vm._v(" "),_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{ref:"compDetailsContainer",staticClass:"company-wrap",style:({height: _vm.windowHeight - _vm.pageTopHeight - _vm.navbarHeaderHeight - 1 + 'px'})},[_vm._l((_vm.model.locations_details),function(location,index){return [_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',{staticClass:"company-location"},[_c('i',{staticClass:"ti-home"}),_vm._v(" "+_vm._s(_vm.$t('settingCompany.bussLoc'))+": "+_vm._s(location.name)+"\n                "),(_vm.showDelete || _vm.model.isNew)?_c('button',{staticClass:"btn btn-danger pull-right btn-icon mar-to--5",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteLocation(location.id)}}},[_c('i',{staticClass:"ti-trash"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('upload.uploadLabel')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"pad-bt-5",attrs:{"for":"download"}},[_vm._v(_vm._s(_vm.$t('upload.downloadImportProductsTemplate')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"name":"download","href":_vm.apiUrl + 'download-import-form?token=' + _vm.$session.get('token'),"target":"_blank"}},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.downloadForm()}}},[_vm._v(_vm._s(_vm.$t('upload.downloadButton')))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('archive-input',{attrs:{"location":location}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('import-products-input',{attrs:{"location":location}})],1)])])])])]),_vm._v(" "),(location.is_magister_location)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('magister.syncLabel')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"pad-bt-5",attrs:{"for":"download"}},[_vm._v(_vm._s(_vm.$t('magister.syncPrices')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.updateProductPricesMagister(location)}}},[_vm._v(_vm._s(_vm.$t('general.start')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"pad-bt-5",attrs:{"for":"download"}},[_vm._v(_vm._s(_vm.$t('magister.syncStocks')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.updateProductStocksMagister(location)}}},[_vm._v(_vm._s(_vm.$t('general.start')))])],1)])])])])]):_vm._e(),_vm._v(" "),(location.is_tazz_location)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('tazz.syncLabel')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.updateTazzMenu(location)}}},[_vm._v(_vm._s(_vm.$t('general.start')))])],1)])])])])]):_vm._e(),_vm._v(" "),(location.is_rkeeper_location)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('rkeeper.sync')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.importCategories(location)}}},[_vm._v(_vm._s(_vm.$t('rkeeper.categories')))]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.importProducts(location)}}},[_vm._v(_vm._s(_vm.$t('rkeeper.products')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.syncProductPrices(location)}}},[_vm._v(_vm._s(_vm.$t('rkeeper.productPrices')))]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.syncOptionPrices(location)}}},[_vm._v(_vm._s(_vm.$t('rkeeper.optionPrices')))])],1)])])])])]):_vm._e(),_vm._v(" "),(location.glovo_company_id)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('glovo.syncLabel')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.syncGlovoMenu(location)}}},[_vm._v(_vm._s(_vm.$t('general.start')))])],1)])])])])]):_vm._e(),_vm._v(" "),(location.freya_cloud_id)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('epRestaurant.importLabel')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.syncFreyaCloudMenu(location)}}},[_vm._v(_vm._s(_vm.$t('general.start')))])],1)])])])])]):_vm._e(),_vm._v(" "),(location.ep_restaurant_id)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('epRestaurant.importLabel')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.syncEpRestaurantMenu(location)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('epRestaurant.importButton'))+"\n                        ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.syncEpRestaurantMenu(location, true)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('epRestaurant.syncButton'))+"\n                        ")])],1)])])])])]):_vm._e(),_vm._v(" "),_vm._m(0,true),_vm._v(" "),(_vm.showDelete)?_c('div',{staticClass:"col-md-12"},[_vm._v("\n              "+_vm._s(_vm.$t('settingCompany.copyProductsFrom'))+"\n              "),_c('select',{ref:'copyFrom' + location.id,refInFor:true,staticClass:"select-primary form-control inline-auto mar-lt-5"},[_vm._l((_vm.model.locations_details),function(l){return [(l.id !== location.id)?_c('option',{staticClass:"select-primary",domProps:{"value":l.id}},[_vm._v(_vm._s(l.name)+"\n                  ")]):_vm._e()]})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-icon duplicate-prod mar-to--5 mar-lt-5",on:{"click":function($event){$event.preventDefault();_vm.copyProducts(location.id)}}},[_c('i',{staticClass:"fa fa-copy"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon delete-prod mar-to--5 mar-lt-5",on:{"click":function($event){$event.preventDefault();_vm.deleteProducts(location.id)}}},[_vm._v("\n                Sterge toate produsele din aceasta locatie\n              ")]),_vm._v(" "),_c('hr')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.name),expression:"location.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"}],staticClass:"form-control",attrs:{"type":"text","name":"phome","placeholder":_vm.$t('settingCompany.name')},domProps:{"value":(location.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "name", $event.target.value)}}})])]),_vm._v(" "),_c('br',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.phone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.phone),expression:"location.phone"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.phone),expression:"modelValidate.phone"}],staticClass:"form-control",attrs:{"type":"text","name":"phome","placeholder":_vm.$t('settingCompany.phone')},domProps:{"value":(location.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "phone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.email),expression:"location.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.email),expression:"modelValidate.email"}],staticClass:"form-control",attrs:{"type":"text","name":"email","placeholder":_vm.$t('settingCompany.email')},domProps:{"value":(location.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.street')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.street),expression:"location.street"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.street),expression:"modelValidate.street"}],staticClass:"form-control",attrs:{"type":"text","name":"street","placeholder":_vm.$t('settingCompany.street')},domProps:{"value":(location.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "street", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.number')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.number),expression:"location.number"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.number),expression:"modelValidate.number"}],staticClass:"form-control",attrs:{"type":"text","name":"street","placeholder":_vm.$t('settingCompany.number')},domProps:{"value":(location.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "number", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.city')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.city),expression:"location.city"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.city),expression:"modelValidate.city"}],staticClass:"form-control",attrs:{"type":"text","name":"city","placeholder":_vm.$t('settingCompany.city')},domProps:{"value":(location.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "city", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.country')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.country),expression:"location.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.country),expression:"modelValidate.country"}],ref:"country",refInFor:true,staticClass:"select-primary form-control",attrs:{"name":"country"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateCountry(location)}]}},_vm._l((_vm.countriesList),function(country){return _c('option',{staticClass:"select-primary",domProps:{"value":country.alpha2}},[_vm._v(_vm._s(country.name)+"\n                  ")])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.state')))]),_vm._v(" "),(_vm.showStateDrop(location))?[_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.state_id),expression:"location.state_id"}],staticClass:"select-primary form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.getStatesOptions(location)),function(state){return _c('option',{staticClass:"select-primary",domProps:{"value":state.id}},[_vm._v(_vm._s(state.name)+"\n                    ")])}))]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.state),expression:"location.state"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.state),expression:"modelValidate.state"}],staticClass:"form-control",attrs:{"type":"text","name":"state"},domProps:{"value":(location.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "state", $event.target.value)}}})]],2)]),_vm._v(" "),(_vm.paymentGroups)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingCompany.cardPaymentDetails')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.paylikeKeys')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.payment_group),expression:"location.payment_group"},{name:"validate",rawName:"v-validate",value:({required:true}),expression:"{required:true}"}],staticClass:"select-primary form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "payment_group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.paymentGroups),function(pId,pVal){return _c('option',{staticClass:"select-primary",domProps:{"value":pVal}},[_vm._v(_vm._s(pId)+"\n                      ")])}))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.posDiscount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.id_discount_pos),expression:"location.id_discount_pos"}],staticClass:"form-control",attrs:{"type":"text","name":"posDiscount"},domProps:{"value":(location.id_discount_pos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "id_discount_pos", $event.target.value)}}})])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingCompany.printSettings')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(location.auto_print),callback:function ($$v) {_vm.$set(location, "auto_print", $$v)},expression:"location.auto_print"}},[_vm._v(_vm._s(_vm.$t('settingCompany.automatPrintOrder')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row mar-bt-10"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(location.auto_print_local_server),callback:function ($$v) {_vm.$set(location, "auto_print_local_server", $$v)},expression:"location.auto_print_local_server"}},[_vm._v(_vm._s(_vm.$t('settingCompany.autoPrintLocalServer')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row mar-bt-10"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(location.use_printer),callback:function ($$v) {_vm.$set(location, "use_printer", $$v)},expression:"location.use_printer"}},[_vm._v(_vm._s(_vm.$t('settingCompany.autoSendOrderToPrinter')))])],1)]),_vm._v(" "),(location.use_printer)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.printerIp')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.printer_ip),expression:"location.printer_ip"}],staticClass:"form-control",attrs:{"type":"text","name":"printer_ip","placeholder":_vm.$t('settingCompany.printerIp')},domProps:{"value":(location.printer_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "printer_ip", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.printerPort')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.printer_port),expression:"location.printer_port"}],staticClass:"form-control",attrs:{"type":"text","name":"printer_port","placeholder":_vm.$t('settingCompany.printerPort')},domProps:{"value":(location.printer_port)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "printer_port", $event.target.value)}}})])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.transport_setings')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(location.email_transport),callback:function ($$v) {_vm.$set(location, "email_transport", $$v)},expression:"location.email_transport"}},[_vm._v(_vm._s(_vm.$t('settingCompany.email_transport')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(location.use_twilio),callback:function ($$v) {_vm.$set(location, "use_twilio", $$v)},expression:"location.use_twilio"}},[_vm._v(_vm._s(_vm.$t('settingCompany.twilio_call')))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingCompany.invoicePerOrder')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(location.smartbill_status),callback:function ($$v) {_vm.$set(location, "smartbill_status", $$v)},expression:"location.smartbill_status"}},[_vm._v(_vm._s(_vm.$t('settingLocationGroups.active')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.apiKey')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: location.smartbill_status}),expression:"{required: location.smartbill_status}"},{name:"model",rawName:"v-model",value:(location.smartbill_api_key),expression:"location.smartbill_api_key"}],staticClass:"form-control",attrs:{"disabled":!location.smartbill_status,"type":"text","name":"street","placeholder":_vm.$t('settingCompany.apiKey')},domProps:{"value":(location.smartbill_api_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "smartbill_api_key", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.cif')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.smartbill_cif),expression:"location.smartbill_cif"},{name:"validate",rawName:"v-validate",value:({required: location.smartbill_status}),expression:"{required: location.smartbill_status}"}],staticClass:"form-control",attrs:{"disabled":!location.smartbill_status,"type":"text","name":"street","placeholder":_vm.$t('settingCompany.cif')},domProps:{"value":(location.smartbill_cif)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "smartbill_cif", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.email')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: location.smartbill_status}),expression:"{required: location.smartbill_status}"},{name:"model",rawName:"v-model",value:(location.smartbill_email),expression:"location.smartbill_email"}],staticClass:"form-control",attrs:{"disabled":!location.smartbill_status,"type":"text","name":"street","placeholder":_vm.$t('marketingPromos.email')},domProps:{"value":(location.smartbill_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "smartbill_email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.series')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.smartbill_series),expression:"location.smartbill_series"},{name:"validate",rawName:"v-validate",value:({required: location.smartbill_status}),expression:"{required: location.smartbill_status}"}],staticClass:"form-control",attrs:{"disabled":!location.smartbill_status,"type":"text","name":"street","placeholder":_vm.$t('settingCompany.series')},domProps:{"value":(location.smartbill_series)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "smartbill_series", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p-checkbox',{attrs:{"disabled":!location.smartbill_status},model:{value:(location.smartbill_send_auto),callback:function ($$v) {_vm.$set(location, "smartbill_send_auto", $$v)},expression:"location.smartbill_send_auto"}},[_vm._v(_vm._s(_vm.$t('settingCompany.automatedInvoice')))]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":!location.smartbill_status},model:{value:(location.smartbill_add_to_cc),callback:function ($$v) {_vm.$set(location, "smartbill_add_to_cc", $$v)},expression:"location.smartbill_add_to_cc"}},[_vm._v(_vm._s(_vm.$t('settingCompany.addToCC')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('vat.generalTaxes')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('table',{staticClass:"table mar-bt-0"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.single')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.amount')))]),_vm._v(" "),_c('th',{staticStyle:{"padding-left":"55px"}},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.posid')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((location.taxes),function(tax_rate,taxIndex){return _c('tr',[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.id),expression:"tax_rate.id"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",on:{"input":function($event){_vm.updateVatPrinterId($event, index, taxIndex)},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(tax_rate, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.taxes),function(tax){return _c('option',{attrs:{"data-name":tax.name,"disabled":_vm.disableTaxOption(location.id, tax.id) && tax.id != tax_rate.id},domProps:{"value":tax.id}},[_vm._v(_vm._s(tax.name))])})),_vm._v(" "),(_vm.errors.has(tax_rate.hash_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError(tax_rate.hash_id))+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.type),expression:"tax_rate.type"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",attrs:{"name":'type'+tax_rate.id},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(tax_rate, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"FIXED_EXCLUDED"}},[_vm._v(_vm._s(_vm.$t('taxTypes.FIXED_EXCLUDED')))]),_vm._v(" "),_c('option',{attrs:{"value":"PERCENTAGE_EXCLUDED"}},[_vm._v(_vm._s(_vm.$t('taxTypes.PERCENTAGE_EXCLUDED')))])])]),_vm._v(" "),_c('td',[_c('label',{staticClass:"label-currency"},[_vm._v(_vm._s(tax_rate.type == 'FIXED_EXCLUDED' ? _vm.currency : '%'))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.amount),expression:"tax_rate.amount"},{name:"validate",rawName:"v-validate",value:({required: true, min_value:0}),expression:"{required: true, min_value:0}"}],staticClass:"form-control field-currency",attrs:{"type":"number","min":"0","name":'amount'+tax_rate.id},domProps:{"value":(tax_rate.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax_rate, "amount", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.pos_id),expression:"tax_rate.pos_id"}],staticClass:"form-control field-currency",attrs:{"type":"number","min":"0","name":'pos_id'+tax_rate.pos_id},domProps:{"value":(tax_rate.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax_rate, "pos_id", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-icon pull-right",on:{"click":function($event){$event.preventDefault();_vm.deleteTax(location.id, tax_rate.id)}}},[_c('i',{staticClass:"ti-trash ",attrs:{"title":"Remove"}})])])])}),_vm._v(" "),(location.taxes.length < _vm.taxes.length)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]):_vm._e()],2)]),_vm._v(" "),(location.taxes.length < _vm.taxes.length)?_c('button',{staticClass:"btn btn-icon btn-info ",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingTaxes.single')},on:{"click":function($event){$event.preventDefault();_vm.addNewTax(location.id)}}},[_c('i',{staticClass:"ti-plus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v(_vm._s(_vm.$t('catalogCateg.vat'))+" "),_c('small',[_vm._v("("+_vm._s(_vm.$t('catalogCateg.included'))+")")])]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('table',{staticClass:"table mar-bt-0"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"25%"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.vat')))]),_vm._v(" "),_c('th',{attrs:{"width":"25%"}},[_vm._v(_vm._s(_vm.$t('settingTaxes.type')))]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.$t('settingTaxes.amount')))]),_vm._v(" "),_c('th',{staticStyle:{"padding-left":"55px"},attrs:{"width":"20%"}},[_vm._v("Printer ID")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.model.locations_details[index].vat),function(tax_rate,vatIndex){return _c('tr',[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.tax_id),expression:"tax_rate.tax_id"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(tax_rate, "tax_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.vat),function(tax){return _c('option',{attrs:{"disabled":_vm.disableVatOption(index, tax.id) && tax.id != tax_rate.tax_id},domProps:{"value":tax.id}},[_vm._v(_vm._s(tax.name))])})),_vm._v(" "),(_vm.errors.has(tax_rate.hash_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError(tax_rate.hash_id))+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",attrs:{"disabled":"","name":'type'+tax_rate.id}},[_c('option',{attrs:{"selected":"true","value":"PERCENTAGE_EXCLUDED"}},[_vm._v(_vm._s(_vm.$t('taxTypes.PERCENTAGE_EXCLUDED')))])])]),_vm._v(" "),_c('td',[_c('label',{staticClass:"label-currency"},[_vm._v(_vm._s(tax_rate.type == 'FIXED_EXCLUDED' ? _vm.currency : '%'))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.amount),expression:"tax_rate.amount"},{name:"validate",rawName:"v-validate",value:({required: true, min_value:0}),expression:"{required: true, min_value:0}"}],staticClass:"form-control field-currency",attrs:{"type":"number","min":"0","name":'amount'+tax_rate.id},domProps:{"value":(tax_rate.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax_rate, "amount", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.printer_id),expression:"tax_rate.printer_id"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control field-currency",attrs:{"type":"text","placeholder":"A","name":'amount'+tax_rate.id},domProps:{"value":(tax_rate.printer_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax_rate, "printer_id", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-icon pull-right",on:{"click":function($event){$event.preventDefault();_vm.deleteVat(index, tax_rate.id, vatIndex)}}},[_c('i',{staticClass:"ti-trash ",attrs:{"title":"Remove"}})])])])}),_vm._v(" "),(!location.vat || location.vat.length < _vm.vat.length)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]):_vm._e()],2)]),_vm._v(" "),(!location.vat || location.vat.length < _vm.vat.length)?_c('button',{staticClass:"btn btn-icon btn-info ",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingTaxes.single')},on:{"click":function($event){$event.preventDefault();_vm.addNewVat(index, location.token)}}},[_c('i',{staticClass:"ti-plus"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"help-block warning mb-0"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('settingTaxes.notice3'))+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goToCompany()}}},[_vm._v(_vm._s(_vm.$t('settingTaxes.notice4')))]),_vm._v(".")])])]),_vm._v(" "),[_c('div',{staticClass:"col-md-12"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingCompany.locationImage')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('image-input',{attrs:{"location":location,"label":_vm.$t('settingCompany.locationImage'),"image":location.image,"imageField":"image"}})],1)])],_vm._v(" "),[_c('div',{staticClass:"col-md-12"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('h5',{staticClass:"col-md-1 pad-rg-0"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.menuQr')))]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.use_dynamic_menu),expression:"location.use_dynamic_menu"}],staticClass:"form-control",on:{"input":function($event){_vm.handleMenu(index, $event)},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "use_dynamic_menu", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.menuType),function(menu){return _c('option',{domProps:{"value":menu.id}},[_vm._v(_vm._s(menu.label))])}))])])]),_vm._v(" "),_vm._m(1,true),_vm._v(" "),(!location.use_dynamic_menu)?_c('div',{staticClass:"col-md-6"},[_c('file-input',{attrs:{"location":location}})],1):_vm._e(),_vm._v(" "),(location.use_dynamic_menu)?_c('div',{staticClass:"col-md-6"},[_c('display-qr',{attrs:{"location":location}})],1):_vm._e(),_vm._v(" "),(location.use_dynamic_menu)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-6"},[_c('image-input',{attrs:{"location":location,"label":_vm.$t('general.logo'),"image":location.dynamic_menu_logo,"imageField":"dynamic_menu_logo"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('image-input',{attrs:{"location":location,"label":_vm.$t('marketingOffers.banners'),"image":location.dynamic_menu_banner,"imageField":"dynamic_menu_banner"}})],1)]):_vm._e()],_vm._v(" "),(location.app_link && location.app_qr)?[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('display-qr-app',{attrs:{"location":location}})],1)]:_vm._e()],2)])])]})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('hr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GXEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GXVQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementWastedEdit_vue__ = __webpack_require__("QZLz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ffaf7d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementWastedEdit_vue__ = __webpack_require__("busv");
function injectStyle (ssrContext) {
  __webpack_require__("qyL6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ffaf7d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementWastedEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ffaf7d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementWastedEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ga6V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{staticClass:"logo"},[_c('div',{staticClass:"text-center logo-normal"},[_c('a',{staticClass:"show-hide-menu",on:{"click":function($event){$event.preventDefault();_vm.minimizeSidebar(1)}}},[_c('i',{class:_vm.$sidebar.isMinimized ? 'ti-menu' : 'ti-menu'})])]),_vm._v(" "),_c('div',{staticClass:"logo-mini"})]),_vm._v(" "),_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[_vm._t("default"),_vm._v(" "),_c('ul',{class:_vm.navClasses},[_vm._t("links",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-item',{key:link.name + index,ref:link.session !== undefined ? link.session : '',refInFor:true,attrs:{"loc":link.name == 'orderspos' ? _vm.default_location_for_admin_order : null,"link":link}},_vm._l((link.children),function(subLink,index){return _c('sidebar-item',{key:subLink.name + index,attrs:{"link":subLink}})}))})),_vm._v(" "),(_vm.userRole != 'USER_CUSTOM' || (_vm.userRole === 'USER_CUSTOM' && this.userHasRight('general_can_access_suport')))?_c('li',{ref:"supportTicketItem",staticClass:"support-ticket-item"},[_c('a',{staticClass:"buton-suport-custom",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onSupportTicketClick($event)}}},[_c('i',{staticClass:"icon-menu icon-menu-chat"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('pages.supportTicket')))])])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"logout-link"},[_c('a',{attrs:{"_href":"/logout"},on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_c('i',{staticClass:"icon-menu icon-menu-logout"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('general.logout')))])]),_vm._v(" "),_c('div',{staticClass:"logo-footer"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.logo,"alt":"TapTasty"}})])])])],2)],2),_vm._v(" "),(_vm.showSupportLocationModal)?_c('div',{staticClass:"modal-overlay support-location-modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeSupportLocationModal($event)}}},[_c('div',{staticClass:"modal-dialog support-location-modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.closeSupportLocationModal}},[_c('i',{staticClass:"ti-close"})])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticClass:"support-location-select",staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","popper-class":"support-location-select-dropdown","placeholder":_vm.$t('general.select')},model:{value:(_vm.selectedSupportLocationToken),callback:function ($$v) {_vm.selectedSupportLocationToken=$$v},expression:"selectedSupportLocationToken"}},_vm._l((_vm.supportLocations),function(loc){return _c('el-option',{key:loc.token,attrs:{"label":loc.name,"value":loc.token}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.closeSupportLocationModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.cancel'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",attrs:{"type":"button","disabled":!_vm.selectedSupportLocationToken || _vm.supportWidgetLoading},on:{"click":_vm.confirmSupportLocation}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.confirm'))+"\n            ")])])])])])]):_vm._e(),_vm._v(" "),(_vm.orderFiscalError)?_c('div',{staticClass:"alert-box-wrap-fiscal"},[_c('div',{staticClass:"alert-box-fiscal"},[_c('span',{staticClass:"number"},[_vm._v("Nu s-a putut printa bonul pentru comanda: "+_vm._s(_vm.orderFiscalError))])])]):_vm._e(),_vm._v(" "),(this.$route.name !== 'Dispatch')?_c('div',{staticClass:"alert-box-wrap"},[_vm._l((_vm.all_waiter_calls),function(call,callIndex){return [_c('div',{staticClass:"alert-box waiter",on:{"click":function($event){_vm.markWaiterCallView(callIndex, call.id)}}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(call.zone)+" "+_vm._s(call.type)+" "+_vm._s(call.number)+" ")]),_vm._v(" "),(call.reason)?_c('span',{staticClass:"reason"},[_c('b',[_vm._v(_vm._s(call.reason))])]):_vm._e()])]}),_vm._v(" "),(_vm.newOrdersCount > 0)?_c('div',{staticClass:"alert-box",on:{"click":function($event){_vm.goToOrders('NEW')}}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.newOrdersCount)+" "+_vm._s(_vm.$t('ordersStatus.NEW')))])]):_vm._e(),_vm._v(" "),(_vm.processingOrdersCount > 0)?_c('div',{staticClass:"alert-box processing",on:{"click":function($event){_vm.goToOrders('PROCESSING')}}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.processingOrdersCount)+" "+_vm._s(_vm.$t('ordersStatus.PROCESSING')))])]):_vm._e(),_vm._v(" "),(_vm.ordersCheckIn > 0)?_c('div',{staticClass:"alert-box checkIn",on:{"click":function($event){_vm.goToOrders('ordersCheckIn')}}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.ordersCheckIn)+" "+_vm._s(_vm.$t('ordersStatus.checkIn')))])]):_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GaZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.paymentTypes')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[(_vm.showLocations)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.paymentMethods && _vm.paymentMethods.length)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('addOrder.choosePay')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected_payment_method),expression:"selected_payment_method"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected_payment_method=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.paymentMethods),function(val){return [_c('option',{attrs:{"label":val.name},domProps:{"value":val.id}},[_vm._v(_vm._s(val.name))])]})],2)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('chart-bars-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"paymentMethodSales",attrs:{"chart-data":_vm.paymentMethodSales.data,"chart-options":_vm.paymentMethodSales.options}},[(_vm.noData)?[_c('div',{staticClass:"no-data-message",staticStyle:{"text-align":"center","margin":"20px"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('reports.noDataAvailable')))])])]:_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend",staticStyle:{"display":"flex","flex-wrap":"wrap"}},_vm._l((_vm.paymentMethodSales.data.labels),function(label,index){return _c('div',{key:index,staticStyle:{"display":"flex","align-items":"center","margin-right":"12px"}},[_c('i',{staticClass:"fa fa-circle",style:({ color: _vm.colors[index % _vm.colors.length], marginRight: '5px' })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(label)+" - "+_vm._s(_vm.paymentMethodSales.data.series[0][index]))])])}))])],2),_vm._v(" "),(_vm.ordersTableData.data && _vm.ordersTableData.data.length > 0)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card center-sales-report-stats",staticStyle:{"height":"100% !important"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content"},[_c('div',{staticClass:"report-container"},[_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.total')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.totalAmount)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.orderCounter')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.totalCounter))])])])])])])])]):_vm._e(),_vm._v(" "),_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"total":_vm.ordersTableData.total,"search-def":{show: false}}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"payment_type","label":_vm.$t('reports.paymentMethod')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.$t('paymentTypes.' + props.row.payment_type))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"counter","label":_vm.$t('reports.orderCounter')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"total_amount","label":_vm.$t('reports.totalAmount')}})],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GahT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_radio_group_css__ = __webpack_require__("BNJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_radio_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_radio_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio_group__ = __webpack_require__("fDPO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_radio_css__ = __webpack_require__("8jhb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_radio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_radio_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio__ = __webpack_require__("RDoK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("Zki6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input_number__ = __webpack_require__("0kY3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__DispatchOrders_vue__ = __webpack_require__("rVZm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__DispatchDrivers_vue__ = __webpack_require__("w4Yf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__OrdersPos_OrdersPos_vue__ = __webpack_require__("jTQK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_google_maps__ = __webpack_require__("lMsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Orders_OrderView_vue__ = __webpack_require__("q0FD");








































var _components;
















__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_38_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_35_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_33_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_31_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_41_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_dropdown_item___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input_number___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio_group___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_47_vue_js_modal___default.a, { componentName: 'vmodal' });

var DEFAULT_DISPATCH_STATUSES = ['PREPARED', 'TRANSPORT'];
var DEFAULT_DISPATCH_DELIVERY_TYPES = ['DELIVERY'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DispatchView',
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'draggable', __WEBPACK_IMPORTED_MODULE_40_vuedraggable___default.a), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'PPagination', __WEBPACK_IMPORTED_MODULE_43_src_components_UIComponents_Pagination_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'DispatchOrders', __WEBPACK_IMPORTED_MODULE_44__DispatchOrders_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'DispatchDrivers', __WEBPACK_IMPORTED_MODULE_45__DispatchDrivers_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'OrdersPos', __WEBPACK_IMPORTED_MODULE_46__OrdersPos_OrdersPos_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'OrderView', __WEBPACK_IMPORTED_MODULE_50__Orders_OrderView_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_42_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  computed: {
    hasActiveFilters: function hasActiveFilters() {
      var hasStatusFilters = this.requestFilters[0].value.length > 0;
      var hasLocationFilters = this.locationFilter.length > 0;
      var hasPickupDatetime = this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2;
      var hasPlacedDatetime = this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2;
      var hasOrderId = this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== '';
      var hasOrderNumber = this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== '';
      var hasOrderTotal = this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null || this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null;
      var hasOperator = this.orderFilters.operator && this.orderFilters.operator.length > 0;
      var hasPaymentType = this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0;
      var hasDeliveryType = this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0;
      var hasSource = this.orderFilters.source && this.orderFilters.source.length > 0;

      return hasStatusFilters || hasLocationFilters || hasPickupDatetime || hasPlacedDatetime || hasOrderId || hasOrderNumber || hasOrderTotal || hasOperator || hasPaymentType || hasDeliveryType || hasSource;
    },
    filteredStatuses: function filteredStatuses() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.statuses).filter(function (key) {
        return key !== 'DRAFT';
      });
    }
  },
  props: {
    order: {}
  },
  created: function created() {
    var _this = this;

    this.loadDispatchFilters();
    this.getPosUsers();
    this.getLocationAndZones().then(function () {
      _this.getData();
    });
  },
  beforeDestroy: function beforeDestroy() {},
  data: function data() {
    return {
      use_auto_dispatch2: null,
      use_auto_dispatch: null,
      userInteractedMap: false,
      selectedOrderId: null,
      orderId: null,
      selectedOrderAssigned: false,
      working_drivers: [],
      driverTableData: [],
      orders: [],
      groupingOrders: [],
      groupingOrdersByZone: [],
      groups: [],
      groupsDispatch: [],
      getDataTimeout: null,
      loading: false,
      orderUrl: '',
      isModalFilterChange: false,
      modalOrderFilters: {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: DEFAULT_DISPATCH_DELIVERY_TYPES.slice(),
        source: []
      },
      modalLocationFilter: [],
      modalSortOrder: 1,
      modalRequestFilters: [{ value: DEFAULT_DISPATCH_STATUSES.slice() }],
      requestFilters: [{ value: DEFAULT_DISPATCH_STATUSES.slice() }],
      locationFilter: [],
      sortOrder: 1,
      showFiltersCollapsed: false,
      operatorOptions: [],
      sourceOptions: [1, 2, 3, 4, 5, 6, 7, 8],
      paymentTypeOptions: ['CASH', 'CARD', 'POS', 'CARD_POS', 'CASH_MACHINE', 'POS_KIOSK', 'ONLINE', 'SPLIT', 'ROOM', 'FOLIO', 'EVENT', 'MANCARE_PERSONAL', 'PROTOCOL', 'VIRAMENT', 'GLOVO_CARD', 'GLOVO_CASH', 'BOLT_CASH', 'BOLT_CARD', 'WOLT_CASH', 'WOLT_CARD', 'null'],
      deliveryTypeOptions: ['PICK_UP', 'DELIVERY', 'EAT_LOCATION', 'MEET_HALF'],
      orderFilters: {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: DEFAULT_DISPATCH_DELIVERY_TYPES.slice(),
        source: []
      },
      sortOptions: [{ id: 1, name: 'CreatedDescending' }, { id: 2, name: 'CreatedAscending' }, { id: 3, name: 'PickupDescending' }, { id: 4, name: 'PickupAscending' }],
      resetFiltersObj: [{ value: DEFAULT_DISPATCH_STATUSES.slice() }],
      statuses: this.$session.get('defaultData')['order_statuses']['ALL_DELIVERY_TYPES'],
      map: null,
      markers: [],
      shapes: [],
      locations: [],
      selectedButtons: []
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var locationsDetails = this.$session.get('selectedCompanyData').locations_details;
    var apiKey = null;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(locationsDetails), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var location = _step.value;

        if (location.google_maps_api_key) {
          apiKey = location.google_maps_api_key;
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (apiKey) {
      __WEBPACK_IMPORTED_MODULE_49_google_maps___default.a.KEY = apiKey;
      __WEBPACK_IMPORTED_MODULE_49_google_maps___default.a.load(function (google) {
        _this2.initMap(google);
      });
    } else {
      console.error('No Google Maps API key found in locations details.');
    }
  },

  watch: {
    map: function map(newMap) {
      var _this3 = this;

      if (newMap) {
        newMap.addListener('dragstart', function () {
          _this3.userInteractedMap = true;
        });
        newMap.addListener('zoom_changed', function () {
          _this3.userInteractedMap = true;
        });
        newMap.addListener('center_changed', function () {
          _this3.userInteractedMap = true;
        });
      }
    }
  },
  methods: {
    buildDispatchFilterParams: function buildDispatchFilterParams() {
      var data = {};

      data.statuses = this.requestFilters[0].value && this.requestFilters[0].value.length ? this.requestFilters[0].value.join(',') : DEFAULT_DISPATCH_STATUSES.join(',');

      if (this.locationFilter.length) {
        var normalizedIds = this.locationFilter.map(function (id) {
          return parseInt(id, 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        data.locations = normalizedIds.join(',');
      }

      var sortOrderId = this.sortOrder || 1;
      var sortOption = this.sortOptions.find(function (sort) {
        return sort.id === parseInt(sortOrderId);
      });

      data.sort_order = sortOption ? sortOption.name : 'CreatedDescending';

      if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
        data.pickup_datetime_from = this.orderFilters.pickupDatetime[0];
        data.pickup_datetime_to = this.adjustEndTime(this.orderFilters.pickupDatetime[1]);
      }
      if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
        data.created_at_from = this.orderFilters.placedDatetime[0];
        data.created_at_to = this.adjustEndTime(this.orderFilters.placedDatetime[1]);
      }
      if (this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== '') {
        data.id = String(this.orderFilters.orderId).trim();
      }
      if (this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== '') {
        data.order_number = this.orderFilters.orderNumber.trim();
      }
      if (this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null) {
        data.order_total_min = this.normalizeOrderTotal(this.orderFilters.orderTotalMin);
      }
      if (this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null) {
        data.order_total_max = this.normalizeOrderTotal(this.orderFilters.orderTotalMax);
      }
      if (this.orderFilters.operator && this.orderFilters.operator.length > 0) {
        data.operator = this.orderFilters.operator.join(',');
      }
      if (this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0) {
        data.payment_type = this.orderFilters.paymentType.join(',');
      }

      data.delivery_type = this.orderFilters.deliveryType && this.orderFilters.deliveryType.length ? this.orderFilters.deliveryType.join(',') : DEFAULT_DISPATCH_DELIVERY_TYPES.join(',');
      if (this.orderFilters.source && this.orderFilters.source.length > 0) {
        data.source = this.orderFilters.source.join(',');
      }

      return data;
    },
    loadDispatchFilters: function loadDispatchFilters() {
      try {
        var savedFilters = JSON.parse(localStorage.getItem('dispatchOrderFilters'));
        if (!savedFilters) {
          return;
        }
        if (savedFilters.requestFilters && savedFilters.requestFilters[0]) {
          this.requestFilters[0].value = savedFilters.requestFilters[0].value || this.requestFilters[0].value;
        }
        if (Array.isArray(savedFilters.locationFilter)) {
          this.locationFilter = savedFilters.locationFilter;
        }
        if (savedFilters.orderFilters) {
          this.orderFilters = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.orderFilters, savedFilters.orderFilters);
        }
        if (savedFilters.sortOrder) {
          this.sortOrder = parseInt(savedFilters.sortOrder) || 1;
        }
      } catch (e) {}
    },
    persistDispatchFilters: function persistDispatchFilters() {
      localStorage.setItem('dispatchOrderFilters', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
        requestFilters: this.requestFilters,
        locationFilter: this.locationFilter,
        orderFilters: this.orderFilters,
        sortOrder: this.sortOrder
      }));
      localStorage.setItem('locationFilter', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.locationFilter));
    },
    refreshDispatchData: function refreshDispatchData() {
      this.persistDispatchFilters();
      this.updateMapMarkers(this.map);
      this.getData();
    },
    getData: function getData() {
      var _this4 = this;

      this.loading = true;

      var dataToSend = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, this.buildDispatchFilterParams());
      this.apiRequest('/dispatch', 'GET', dataToSend, function (response) {
        if (response.status === true) {
          _this4.working_drivers = response.data.working_drivers;
          _this4.orders = response.data.orders;
          _this4.groupsDispatch = response.data.groups;
          _this4.loading = false;
          clearTimeout(_this4.getDataTimeout);
          if (_this4.$route.name === 'Dispatch') {
            _this4.getDataTimeout = setTimeout(function () {
              _this4.getLocationAndZones();
              _this4.getData();
              _this4.updateMapMarkers(_this4.map);
              console.log('Auto-refreshing data...');
            }, 10000);
          }
        }
      });
    },
    getDriversForOrder: function getDriversForOrder(orderId) {
      var _this5 = this;

      var dataToSend = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: orderId
      };
      this.apiRequest('/get-drivers-for-order', 'GET', dataToSend, function (response) {
        if (response.status === true) {
          _this5.working_drivers = response.data.drivers;
          _this5.selectedOrderAssigned = _this5.working_drivers.some(function (driver) {
            return driver.orders && driver.orders.some(function (order) {
              return order.id === _this5.selectedOrderId;
            });
          });
          _this5.api_drivers = _this5.working_drivers;
          _this5.loadDriverData();
          _this5.$modal.show('driverModal');
        } else {
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Error',
            text: 'Failed to retrieve drivers for the order.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          });
        }
      }, function (error) {
        console.error('Error:', error);
        __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
          title: 'Error',
          text: 'An error occurred while retrieving drivers.',
          type: 'error',
          timer: 1500,
          showConfirmButton: false
        });
      });
    },
    changeAutoDispatch: function changeAutoDispatch(useAutoDispatch) {
      var _this6 = this;

      if (useAutoDispatch !== this.use_auto_dispatch) {
        this.loading = true;
        var dataToSend = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          use_auto_dispatch: useAutoDispatch
        };
        this.apiRequest('/change-auto-dispatch', 'GET', dataToSend, function (response) {
          if (response.status === true) {
            _this6.use_auto_dispatch = !!response.data.use_auto_dispatch;
            _this6.loading = false;
          }
        });
      }
    },
    formatOrderNr: function formatOrderNr(nr) {
      return nr.toString().padStart(3, 0);
    },
    goToOrder: function goToOrder(orderId) {
      this.$router.push('/orders/view/' + orderId);
    },
    getCoords: function getCoords(orderId) {
      var link = 'https://www.google.com/maps/dir/';
      var dataToSend = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: orderId
      };
      this.apiRequest('/get-order-lat-long', 'GET', dataToSend, function (response) {
        if (response.status === true) {
          link += response.data.coords;
          window.open(link, '_blank');
        }
      });
    },
    toggleStatus: function toggleStatus(status) {
      var index = this.requestFilters[0].value.indexOf(status);
      if (index > -1) {
        this.requestFilters[0].value.splice(index, 1);
      } else {
        this.requestFilters[0].value.push(status);
      }
      this.refreshDispatchData();
    },
    getLocationAndZones: function getLocationAndZones() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var dataToSend = {
          token: _this7.$session.get('token'),
          company_id: _this7.$session.get('selectedCompany')
        };
        _this7.apiRequest('/get-locations-and-zones', 'GET', dataToSend, function (response) {
          if (response.status === true) {
            _this7.locations = response.data.locations || [];
            if (_this7.locationFilter.length) {
              _this7.locationFilter = _this7.normalizeLocationFilter(_this7.locationFilter);
            } else {
              var savedLocations = JSON.parse(localStorage.getItem('locationFilter')) || [];
              _this7.locationFilter = _this7.normalizeLocationFilter(savedLocations);
            }
            _this7.updateMapMarkers(_this7.map);
            resolve();
          } else {
            reject(response.message);
          }
        });
      });
    },
    updateSelection: function updateSelection(type) {
      if (Array.isArray(this.selectedButtons)) {
        if (type === 'delivery' || type === 'orders' || type === 'zones') {
          this.userInteractedMap = false;

          this.updateMapMarkers(this.map);
        }
      } else {
        console.error('selectedButtons is not an array');
      }
    },
    initMap: function initMap(google) {
      var _this8 = this;

      var mapEl = document.getElementById('map');
      if (!mapEl || !window.google || !window.google.maps) {
        return;
      }

      var defaultLatlng = new window.google.maps.LatLng(44.4268, 26.1025);

      var mapStyles = [{
        featureType: 'all',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ visibility: 'off' }]
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#d3d3d3' }]
      }, {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ visibility: 'on' }]
      }, {
        featureType: 'poi.business',
        stylers: [{ visibility: 'off' }]
      }, {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#c8e6c9' }]
      }];

      var mapOptions = {
        zoom: 10,
        center: defaultLatlng,
        scrollwheel: false,
        styles: mapStyles
      };

      this.map = new window.google.maps.Map(mapEl, mapOptions);

      this.updateMapMarkers(this.map);

      this.map.addListener('dragstart', function () {
        _this8.userInteractedMap = true;
      });
      this.map.addListener('zoom_changed', function () {
        _this8.userInteractedMap = true;
      });
      this.map.addListener('center_changed', function () {
        _this8.userInteractedMap = true;
      });
    },
    updateMapMarkers: function updateMapMarkers(map) {
      var _this9 = this;

      if (!map || !window.google || !window.google.maps) {
        return;
      }

      if (this.markers && this.markers.length) {
        this.markers.forEach(function (marker) {
          return marker.setMap(null);
        });
      }
      if (this.shapes && this.shapes.length) {
        this.shapes.forEach(function (shape) {
          return shape.setMap(null);
        });
      }

      this.markers = [];
      this.shapes = [];

      var getRandomColor = function getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
      };

      this.locations.forEach(function (loc) {
        if (_this9.isLocationInFilter(loc)) {
          if (loc.lat && loc.lng) {
            var position = new window.google.maps.LatLng(loc.lat, loc.lng);
            var marker = new window.google.maps.Marker({
              position: position,
              title: loc.name,
              icon: {
                url: '/static/img/location.png',
                scaledSize: new window.google.maps.Size(32, 32) }
            });
            marker.setMap(map);
            _this9.markers.push(marker);

            var infoWindowContent = '\n              <div>\n                  <strong>' + loc.name + '</strong><br>\n                  Street: ' + loc.street + '<br>\n                  Latitude: ' + loc.lat + '<br>\n                  Longitude: ' + loc.lng + '\n              </div>\n            ';
            var infoWindow = new window.google.maps.InfoWindow({
              content: infoWindowContent
            });

            marker.addListener('click', function () {
              infoWindow.open(map, marker);
            });

            if (_this9.selectedButtons.includes('zones')) {
              if (loc.ranges) {
                loc.ranges.forEach(function (range) {
                  if (range.shape) {
                    var randomColor = getRandomColor();
                    var shapeOptions = {
                      map: map,
                      strokeColor: randomColor,
                      strokeOpacity: 0.5,
                      strokeWeight: 2,
                      fillColor: randomColor,
                      fillOpacity: 0.2
                    };

                    var shape = void 0;

                    switch (range.shape.type) {
                      case 'rectangle':
                        if (range.shape.northEastLat && range.shape.northEastLng && range.shape.southWestLat && range.shape.southWestLng) {
                          shapeOptions.bounds = new window.google.maps.LatLngBounds(new window.google.maps.LatLng(range.shape.southWestLat, range.shape.southWestLng), new window.google.maps.LatLng(range.shape.northEastLat, range.shape.northEastLng));
                          shape = new window.google.maps.Rectangle(shapeOptions);
                          _this9.shapes.push(shape);
                        } else {
                          console.warn('Incomplete rectangle shape data for range ID: ' + range.id);
                        }
                        break;
                      case 'circle':
                        if (range.shape.centerLat && range.shape.centerLng && range.shape.centerRadius) {
                          shapeOptions.center = new window.google.maps.LatLng(range.shape.centerLat, range.shape.centerLng);
                          shapeOptions.radius = range.shape.centerRadius;
                          shape = new window.google.maps.Circle(shapeOptions);
                          _this9.shapes.push(shape);
                        } else {
                          console.warn('Incomplete circle shape data for range ID: ' + range.id);
                        }
                        break;
                      case 'polygon':
                        if (range.shape.array && range.shape.array.length) {
                          shapeOptions.paths = range.shape.array.map(function (point) {
                            if (point.lat && point.lng) {
                              return new window.google.maps.LatLng(point.lat, point.lng);
                            } else {
                              console.warn('Incomplete polygon path data for range ID: ' + range.id);
                              return null;
                            }
                          }).filter(function (latLng) {
                            return latLng !== null;
                          });
                          if (shapeOptions.paths.length > 0) {
                            shape = new window.google.maps.Polygon(shapeOptions);
                            _this9.shapes.push(shape);
                          }
                        } else {
                          console.warn('Incomplete polygon shape data for range ID: ' + range.id);
                        }
                        break;
                      default:
                        console.warn('Unknown shape type: ' + range.shape.type);
                        break;
                    }

                    if (shape) {
                      var _infoWindow = new window.google.maps.InfoWindow({
                        content: '<div><strong>' + range.name + '</strong></div>'
                      });

                      shape.addListener('click', function () {
                        var position = void 0;
                        if (shape instanceof window.google.maps.Circle) {
                          position = shape.getCenter();
                        } else if (shape instanceof window.google.maps.Rectangle) {
                          position = shape.getBounds().getCenter();
                        } else if (shape instanceof window.google.maps.Polygon) {
                          var bounds = new window.google.maps.LatLngBounds();
                          shape.getPath().forEach(function (latlng) {
                            return bounds.extend(latlng);
                          });
                          position = bounds.getCenter();
                        }
                        _infoWindow.setPosition(position);
                        _infoWindow.open(map);
                      });
                    }
                  } else {
                    console.warn('Missing shape data for range ID: ' + range.id);
                  }
                });
              } else {
                console.warn('No ranges data available for location ID: ' + loc.id);
              }
            }
          } else {
            console.warn('Missing lat/lng data for location ID: ' + loc.id);
          }
        }
      });

      if (this.selectedButtons.includes('delivery') && this.working_drivers) {
        this.working_drivers.forEach(function (driver) {
          if (driver.last_gps_location && driver.last_gps_location.lat && driver.last_gps_location.lng) {
            var position = new window.google.maps.LatLng(driver.last_gps_location.lat, driver.last_gps_location.lng);

            var orderCount = driver.orders ? driver.orders.length : 0;

            var iconUrl = void 0;
            if (driver.avatar) {
              iconUrl = driver.avatar;
            } else {
              var backgroundColor = orderCount > 0 ? '#ff4d4d' : '#17B086';

              var initials = ('' + driver.firstname[0] + driver.lastname[0]).toUpperCase();

              var canvas = document.createElement('canvas');
              var ctx = canvas.getContext('2d');
              var size = 32;
              var radius = size / 2;
              canvas.width = size;
              canvas.height = size;

              ctx.beginPath();
              ctx.arc(radius, radius, radius, 0, 2 * Math.PI);
              ctx.fillStyle = backgroundColor;
              ctx.fill();

              ctx.fillStyle = '#fff';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.font = 'bold 14px Arial';
              ctx.fillText(initials, radius, radius);

              ctx.beginPath();
              var tailSize = 8;
              var tailOffset = 8;
              ctx.moveTo(radius - tailSize, size - tailOffset);
              ctx.lineTo(radius + tailSize, size - tailOffset);
              ctx.lineTo(radius, size - tailOffset + tailSize);
              ctx.closePath();
              ctx.fillStyle = backgroundColor;
              ctx.fill();

              iconUrl = canvas.toDataURL();
            }
            var iconSize = new window.google.maps.Size(32, 32);

            var marker = new window.google.maps.Marker({
              position: position,
              title: driver.firstname + ' ' + driver.lastname,
              icon: {
                url: iconUrl,
                scaledSize: iconSize
              }
            });
            marker.setMap(map);

            var infoWindow = new window.google.maps.InfoWindow({
              content: '\n                <div>\n                  <strong>' + driver.firstname + ' ' + driver.lastname + '</strong><br>\n                  ID: ' + driver.email + '<br>\n                  Orders: ' + orderCount + '<br>\n                  ' + (driver.phone ? 'Phone: ' + driver.phone + '<br>' : '') + '\n                </div>\n              '
            });

            marker.addListener('click', function () {
              infoWindow.open(map, marker);
            });

            _this9.markers.push(marker);
          }
        });
      }

      if (this.selectedButtons.includes('orders') && this.orders) {
        this.orders.forEach(function (order) {
          if (order.address_billing && order.address_billing.lat && order.address_billing.lng) {
            var position = new window.google.maps.LatLng(order.address_billing.lat, order.address_billing.lng);
            var marker = new window.google.maps.Marker({
              position: position,
              title: order.address_billing.address_name,
              icon: {
                url: '/static/img/food.png',
                scaledSize: new window.google.maps.Size(32, 32) }
            });
            marker.setMap(map);

            var infoWindow = new window.google.maps.InfoWindow({
              content: '<div><strong>' + order.address_billing.address_name + '</strong><br>' + order.address_billing.formatted_address + '</div>'
            });

            marker.addListener('click', function () {
              infoWindow.open(map, marker);
            });

            _this9.markers.push(marker);
          }
        });
      }

      console.log('User interacted with map:', this.userInteractedMap);
      if (!this.userInteractedMap) {
        this.centerMap(map);
      }
    },
    centerMap: function centerMap(map) {
      if (!map || !window.google || !window.google.maps) {
        return;
      }

      if (this.markers.length > 0) {
        var bounds = new window.google.maps.LatLngBounds();

        this.markers.forEach(function (marker) {
          bounds.extend(marker.getPosition());
        });

        map.fitBounds(bounds);
        window.google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
          var currentZoom = map.getZoom();
          var targetZoom = 22;

          if (currentZoom > targetZoom) {
            map.setZoom(targetZoom);
          }
        });
      } else {
        map.setCenter(new window.google.maps.LatLng(44.4268, 26.1025));
        map.setZoom(11);
      }
    },
    resetMap: function resetMap() {
      this.userInteractedMap = false;
      this.updateMapMarkers(this.map);
    },
    highlightOrderOnMap: function highlightOrderOnMap(orderId) {
      var _this10 = this;

      if (!window.google || !window.google.maps) {
        console.error('Google Maps API is not loaded or not available.');
        return;
      }

      var order = this.orders.find(function (o) {
        return o.id === orderId;
      });

      if (order && order.address_shipping && order.address_shipping.lat && order.address_shipping.lng) {
        var position = new window.google.maps.LatLng(order.address_shipping.lat, order.address_shipping.lng);

        var marker = new window.google.maps.Marker({
          position: position,
          title: 'Comanda #' + orderId,
          icon: {
            url: '/static/img/food.png',
            scaledSize: new window.google.maps.Size(32, 32)
          }
        });

        marker.setMap(this.map);

        this.map.setCenter(position);

        this.map.setZoom(15);

        if (this.currentInfoWindow) {
          this.currentInfoWindow.close();
        }

        var infoWindow = new window.google.maps.InfoWindow({
          content: '<div><strong>Comanda #' + orderId + '</strong><br>' + order.address_shipping.formatted_address + '</div>'
        });

        infoWindow.open(this.map, marker);

        this.currentInfoWindow = infoWindow;

        marker.addListener('click', function () {
          if (_this10.currentInfoWindow) {
            _this10.currentInfoWindow.close();
          }

          infoWindow.open(_this10.map, marker);
          _this10.currentInfoWindow = infoWindow;
        });

        this.markers.push(marker);
        this.selectedOrderId = orderId;
      } else {
        console.error('Locația pentru această comandă nu este disponibilă.');
      }
    },
    showDriverOnMap: function showDriverOnMap(driver) {
      var _this11 = this;

      if (!driver || !driver.last_gps_location || !driver.last_gps_location.lat || !driver.last_gps_location.lng) {
        __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
          title: 'Error',
          text: 'Driver location is not available.',
          type: 'error',
          timer: 1500,
          showConfirmButton: false
        });
        return;
      }

      var position = new window.google.maps.LatLng(driver.last_gps_location.lat, driver.last_gps_location.lng);
      var iconUrl = void 0;
      if (driver.avatar && !driver.avatar.includes('noface.png')) {
        iconUrl = driver.avatar;
      } else {
        var backgroundColor = '#ff4d4d';

        var initials = ('' + driver.firstname[0] + driver.lastname[0]).toUpperCase();

        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var size = 32;
        var radius = size / 2;
        canvas.width = size;
        canvas.height = size;

        ctx.beginPath();
        ctx.arc(radius, radius, radius, 0, 2 * Math.PI);
        ctx.fillStyle = backgroundColor;
        ctx.fill();

        ctx.fillStyle = '#fff';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = 'bold 14px Arial';
        ctx.fillText(initials, radius, radius);

        ctx.beginPath();
        var tailSize = 8;
        var tailOffset = 8;
        ctx.moveTo(radius - tailSize, size - tailOffset);
        ctx.lineTo(radius + tailSize, size - tailOffset);
        ctx.lineTo(radius, size - tailOffset + tailSize);
        ctx.closePath();
        ctx.fillStyle = backgroundColor;
        ctx.fill();

        iconUrl = canvas.toDataURL();
      }

      var iconSize = new window.google.maps.Size(32, 32);

      var marker = new window.google.maps.Marker({
        position: position,
        title: driver.firstname + ' ' + driver.lastname,
        icon: {
          url: iconUrl,
          scaledSize: iconSize
        }
      });

      marker.setMap(this.map);

      this.map.setCenter(position);
      this.map.setZoom(11);

      var infoWindowContent = '\n        <div>\n          <strong>' + driver.firstname + ' ' + driver.lastname + '</strong><br>\n          Phone: ' + (driver.phone ? driver.phone : 'N/A') + '<br>\n          Driver\'s current location\n        </div>\n      ';

      var infoWindow = new window.google.maps.InfoWindow({
        content: infoWindowContent
      });

      infoWindow.open(this.map, marker);

      if (this.currentInfoWindow) {
        this.currentInfoWindow.close();
      }

      this.currentInfoWindow = infoWindow;

      marker.addListener('click', function () {
        infoWindow.open(_this11.map, marker);
      });

      this.markers.push(marker);
    },
    showDriverModal: function showDriverModal(orderId) {
      this.selectedOrderId = orderId;
      this.getDriversForOrder(this.selectedOrderId);
    },
    hideDriverModal: function hideDriverModal() {
      this.$modal.hide('driverModal');
    },
    loadDriverData: function loadDriverData() {
      var _this12 = this;

      this.driverTableData = this.api_drivers.map(function (driver) {
        var name = driver.firstname + ' ' + driver.lastname;
        var orderCount = driver.orders ? driver.orders.length : 0;
        var distance = driver.air_distance !== null && driver.air_distance !== undefined ? driver.air_distance + ' km' : 'N/A';
        var hasAssignedOrder = driver.orders && driver.orders.some(function (order) {
          return order.id === _this12.selectedOrderId;
        });

        return {
          id: driver.id,
          name: name,
          orders: orderCount > 0 ? orderCount : 'Free',
          distance: distance,
          hasAssignedOrder: hasAssignedOrder,
          canAssign: !_this12.selectedOrderAssigned || hasAssignedOrder
        };
      });
    },
    assignDriver: function assignDriver(driver) {
      var _this13 = this;

      if (this.groupId) {
        var dataToSend = {
          driver_id: driver.id,
          group_id: this.groupId,
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token')
        };

        this.apiRequest('/dispatch-assign-group-to-driver', 'POST', dataToSend, function (response) {
          if (response.status === true) {
            _this13.loading = false;
            __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
              title: 'Success',
              text: 'Driver assigned successfully to the group.',
              type: 'success',
              timer: 1500,
              showConfirmButton: false
            });
            _this13.loadDriverData();
            _this13.getData();
            _this13.hideDriverModal();
          } else {
            var errorMessage = response.errors.order || 'Failed to assign driver to the group.';
            __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
              title: 'Error',
              text: errorMessage,
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            });
          }
        }, function (error) {
          console.error('Error:', error);
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Error',
            text: 'An error occurred while assigning the driver to the group.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          });
        });
      } else {
        var _dataToSend = {
          to: driver.id,
          from: 0,
          orderId: this.selectedOrderId,
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token')
        };

        this.apiRequest('/dispatch', 'POST', _dataToSend, function (response) {
          if (response.status === true) {
            _this13.loading = false;
            __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
              title: 'Success',
              text: 'Driver assigned successfully.',
              type: 'success',
              timer: 1500,
              showConfirmButton: false
            });
            _this13.selectedOrderAssigned = true;
            _this13.loadDriverData();
            _this13.getData();
            _this13.hideDriverModal();
          } else {
            __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
              title: 'Error',
              text: 'Failed to assign driver.',
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            });
          }
        }, function (error) {
          console.error('Error:', error);
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Error',
            text: 'An error occurred while assigning the driver.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          });
        });
      }
    },
    unassignDriver: function unassignDriver(driver) {
      var _this14 = this;

      var dataToSend = {
        to: 0,
        from: driver.id,
        orderId: this.selectedOrderId,
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token')
      };

      this.apiRequest('/dispatch', 'POST', dataToSend, function (response) {
        if (response.status === true) {
          _this14.loading = false;
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Success',
            text: 'Driver unassigned successfully.',
            type: 'success',
            timer: 1500,
            showConfirmButton: false
          });
          _this14.selectedOrderAssigned = false;
          _this14.loadDriverData();
          _this14.getData();
          _this14.hideDriverModal();
        } else {
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Error',
            text: 'Failed to unassign driver.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          });
        }
      }, function (error) {
        console.error('Error:', error);
        __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
          title: 'Error',
          text: 'An error occurred while unassigning the driver.',
          type: 'error',
          timer: 1500,
          showConfirmButton: false
        });
      });
    },
    sendOrderToPrintSections: function sendOrderToPrintSections(orderId, printToIp) {
      var _this15 = this;

      __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
        title: 'Printing Sections',
        html: 'Please wait...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: function onOpen() {
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default.a.showLoading();
        }
      });

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: orderId
      };

      this.apiRequest('/get-order-for-local-printer', 'POST', data, function (response) {
        if (response.status) {
          var sectionDataToSendToLocal = {
            order: response.data.order,
            printers: response.data.printers
          };

          var receiptDataToSendToLocal = {
            order: response.data.order,
            printers: response.data.printersForReceipt
          };

          var $msg = '';
          var oneErrorMsg = 'success';

          if (response.data.printers.length) {
            _this15.localRequest(printToIp, '/print-sections', 'POST', sectionDataToSendToLocal, function (sectionRsp) {
              if (sectionRsp.status === 200) {
                sectionRsp.data.data.forEach(function (printerResponse) {
                  if (printerResponse.status) {
                    if (printerResponse.message && printerResponse.message === 'No items to print') {
                      return;
                    }
                    $msg += 'Sectia: ' + printerResponse.printerSectionName + ' s-a printat cu succes!\n';
                  } else {
                    $msg += 'Eroare sectia: ' + printerResponse.printerSectionName + '\n';
                    oneErrorMsg = 'error';
                  }
                });
              } else {
                $msg += 'Eroare: sectiuni - ' + printToIp + ' inaccesibil sau proxy nu functioneaza.\n';
                oneErrorMsg = 'error';
              }

              if (response.data.printersForReceipt.length) {
                _this15.localRequest(printToIp, '/print', 'POST', receiptDataToSendToLocal, function (receiptRsp) {
                  if (receiptRsp.status === 200) {
                    receiptRsp.data.data.forEach(function (printerResponse) {
                      if (printerResponse.status) {
                        $msg += 'Nota de plata s-a printat cu succes!\n';
                      } else {
                        $msg += 'Eroare nota de plata' + '\n';
                        oneErrorMsg = 'error';
                      }
                    });
                  } else {
                    $msg += 'Eroare: bonuri - ' + printToIp + ' inaccesibil sau proxy nu functioneaza.\n';
                    oneErrorMsg = 'error';
                  }
                });
              }
              __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
                title: oneErrorMsg === 'success' ? 'Succes!' : 'Rezultat printare',
                html: $msg.replace(/\n/g, '<br>'),
                type: oneErrorMsg,
                confirmButtonText: 'OK',
                allowOutsideClick: false
              });
            });
          } else if (response.data.printersForReceipt.length) {
            _this15.localRequest(printToIp, '/print', 'POST', receiptDataToSendToLocal, function (receiptRsp) {
              if (receiptRsp.status === 200) {
                receiptRsp.data.data.forEach(function (printerResponse) {
                  if (printerResponse.status) {
                    $msg += 'Nota de plata s-a printat cu succes!\n';
                  } else {
                    $msg += 'Eroare nota de plata' + '\n';
                    oneErrorMsg = 'error';
                  }
                });
              } else {
                $msg += 'Eroare: bonuri - ' + printToIp + ' inaccesibil sau proxy nu functioneaza.\n';
                oneErrorMsg = 'error';
              }

              __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
                title: oneErrorMsg === 'success' ? 'Succes!' : 'Rezultat printare',
                html: $msg.replace(/\n/g, '<br>'),
                type: oneErrorMsg,
                confirmButtonText: 'OK',
                allowOutsideClick: false
              });
            });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Error',
            text: 'Failed to load order for printing',
            type: 'error',
            confirmButtonText: 'OK'
          });
        }
      });
    },
    updateStatus: function updateStatus(orderId, newStatus) {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
        text: 'Are you sure you want to update the order status to ' + newStatus + '?',
        type: 'question',
        position: 'top-end',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Confirm',
        allowOutsideClick: false,
        reverseButtons: true
      }).then(function (result) {
        if (result) {
          var data = {
            id: orderId,
            token: self.$session.get('token'),
            company_id: self.$session.get('selectedCompany'),
            status: newStatus
          };

          self.apiRequest('/order/' + orderId, 'PUT', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
                title: 'Success',
                text: 'Order status updated successfully.',
                type: 'success',
                timer: 1500,
                showConfirmButton: false
              });

              if (newStatus === 'PROCESSING') {
                var printToIp = JSON.parse(self.$session.get('userData')).server_ip_port;
                if (printToIp && printToIp !== '') {
                  self.sendOrderToPrintSections(orderId, printToIp);
                }
              }

              self.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
                title: 'Error',
                text: 'Failed to update order status.',
                type: 'error',
                timer: 1500,
                showConfirmButton: false
              });
            }
          }, function (error) {
            console.error('Error:', error);
            __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
              title: 'Error',
              text: 'An error occurred while updating the status.',
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            });
          });
        }
      }).catch(function (error) {
        console.error('Swal Error:', error);
      });
    },
    getStatusClass: function getStatusClass(status, driver) {
      if (status === 'NEW') {
        return 'status-new';
      } else if (status === 'PROCESSING') {
        return 'status-processing';
      } else if (status === 'PREPARED') {
        return driver ? 'status-prepared-driver' : 'status-prepared-no-driver';
      } else if (status === 'TRANSPORT') {
        return 'status-transport';
      } else if (status === 'NOT_DELIVERED') {
        return 'status-not-delivered';
      } else {
        return '';
      }
    },
    getStatusText: function getStatusText(status, driver) {
      if (status === 'PREPARED') {
        return driver ? this.$t('dispath.assign') : 'prepared';
      }
      return status.toLowerCase();
    },
    showOrdersPosModal: function showOrdersPosModal() {
      this.$modal.show('ordersPosModal');
    },
    hideOrdersPosModal: function hideOrdersPosModal() {
      this.$modal.hide('ordersPosModal');
    },
    showOrdersViewModal: function showOrdersViewModal(orderId) {
      this.iframeSrc = '/orders/view/' + orderId;
      this.$modal.show('ordersViewModal');
    },
    hideOrdersViewModal: function hideOrdersViewModal() {
      this.$modal.hide('ordersViewModal');
      this.orderId = null;
    },
    showLocationModal: function showLocationModal(orderId) {
      this.currentOrderId = orderId;
      this.$modal.show('changeLocation');
    },
    hideLocationModal: function hideLocationModal() {
      this.$modal.hide('changeLocation');
    },
    showAddOrdersGroupModal: function showAddOrdersGroupModal() {
      this.getDispatchCheckIfGroupingIsPossible();
      this.$modal.show('ordersGroupModal');
    },
    hideAddOrdersGroupModal: function hideAddOrdersGroupModal() {
      this.$modal.hide('ordersGroupModal');
      this.getData();
    },
    changeOrderLocation: function changeOrderLocation(locationId) {
      var _this16 = this;

      var dataToSend = {
        order_id: this.currentOrderId,
        new_location_id: locationId,
        token: this.$session.get('token')
      };

      this.apiRequest('/dispatch-change-order-location', 'POST', dataToSend, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Success',
            text: _this16.$t('general.changeOrderLocationSuccess'),
            type: 'success',
            timer: 1500,
            showConfirmButton: false
          });
          _this16.getData();
          _this16.hideLocationModal();
        } else {
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Error',
            text: _this16.$t('general.changeOrderLocationFailed'),
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          });
        }
      });
    },
    getDispatchCheckIfGroupingIsPossible: function getDispatchCheckIfGroupingIsPossible() {
      var _this17 = this;

      var dataToSend = {
        token: this.$session.get('token')
      };

      this.apiRequest('/dispatch-check-if-grouping-is-possible', 'GET', dataToSend, function (response) {
        if (response.status === true) {
          _this17.groupingOrders = response.data.orders;
          _this17.groupingOrdersByZone = response.data.grouped_orders_by_zone;
          _this17.groups = response.data.groups.map(function (group) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, group, {
              orders_suggestions: group.orders_suggestions || []
            });
          });
        } else {
          console.error('Grouping check failed:', response.message);
        }
      });
    },
    removeOrderGroup: function removeOrderGroup(group, orderId) {
      var _this18 = this;

      var groupId = group.id;
      var dataToSend = {
        token: this.$session.get('token'),
        order_id: orderId,
        group_id: groupId
      };

      this.apiRequest('/dispatch-remove-order-from-group', 'POST', dataToSend, function (response) {
        if (response.status === true) {
          var index = group.orders.findIndex(function (order) {
            return order.id === orderId;
          });
          if (index !== -1) {
            group.orders.splice(index, 1);
          }
          _this18.getDispatchCheckIfGroupingIsPossible();
        } else {
          console.error('Failed to remove order:', response.message);
        }
      });
    },
    removeOrderGroupPosibile: function removeOrderGroupPosibile(group, orderId) {
      var orderIndex = group.orders.findIndex(function (order) {
        return order.id === orderId;
      });
      if (orderIndex !== -1) {
        group.orders.splice(orderIndex, 1);
      }
    },
    addOrderGroupPosibile: function addOrderGroupPosibile(group, orderId) {
      var _this19 = this;

      var dataToSend = {
        token: this.$session.get('token'),
        orders_ids: [orderId],
        group_id: group.id
      };

      this.apiRequest('/dispatch-add-order-in-group', 'POST', dataToSend, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Success',
            text: _this19.$t('dispath.addOrderGroupPosibileSuccess'),
            type: 'success',
            timer: 1500,
            showConfirmButton: false
          });
          _this19.getDispatchCheckIfGroupingIsPossible();
        } else {
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Error',
            text: _this19.$t('dispath.addOrderGroupPosibileError'),
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          });
        }
      });
    },
    createOrderGroup: function createOrderGroup(group) {
      var _this20 = this;

      var ordersIds = group.orders.map(function (order) {
        return order.id;
      });
      var dataToSend = {
        token: this.$session.get('token'),
        orders_ids: ordersIds
      };
      this.apiRequest('/dispatch-create-order-group', 'POST', dataToSend, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Success',
            text: _this20.$t('dispath.createOrderGroupSuccess'),
            type: 'success',
            timer: 1500,
            showConfirmButton: false
          });
          _this20.getDispatchCheckIfGroupingIsPossible();
        } else {
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Error',
            text: _this20.$t('dispath.createOrderGroupError'),
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          });
        }
      });
    },
    onDropOrder: function onDropOrder(event) {
      var fromGroup = parseInt(event.from.getAttribute('data-group_id'));
      var toGroupId = parseInt(event.to.getAttribute('data-group_id'));
      var movedOrderId = event.item.dataset.orderId;

      if (!fromGroup && toGroupId) {
        this.addOrderToGroup(toGroupId, movedOrderId);
      } else {
        console.log('Comanda nu se poate muta decât din coloana de comenzi nealocate în grupuri.');
      }
    },
    addOrderToGroup: function addOrderToGroup(groupId, orderId) {
      var dataToSend = {
        token: this.$session.get('token'),
        orders_ids: [orderId],
        group_id: groupId
      };

      this.apiRequest('/dispatch-add-order-in-group', 'POST', dataToSend, function (response) {
        if (response.status === true) {
          console.log('Order successfully added to group:', response.data);
        } else {
          console.error('Failed to add order to group:', response.message);
        }
      });
    },
    addGroupOrderDriverModal: function addGroupOrderDriverModal(groupId) {
      var group = this.groupsDispatch.find(function (g) {
        return g.id === groupId;
      });
      if (group) {
        if (group.orders && group.orders.length) {
          this.groupId = groupId;
          this.selectedOrderId = group.orders[0].id;
          this.getDriversForOrder(this.selectedOrderId);
        } else {
          __WEBPACK_IMPORTED_MODULE_48_sweetalert2___default()({
            title: 'Error',
            text: 'No orders available for this group.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          });
        }
      }
    },
    openFiltersModal: function openFiltersModal() {
      this.modalRequestFilters = [{
        value: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.requestFilters[0].value))
      }];
      this.modalLocationFilter = this.normalizeLocationFilter(this.locationFilter);
      this.modalSortOrder = parseInt(this.sortOrder) || 1;

      var pickupDatetime = null;
      if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
        pickupDatetime = [this.orderFilters.pickupDatetime[0], this.adjustEndTime(this.orderFilters.pickupDatetime[1])];
      }

      var placedDatetime = null;
      if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
        placedDatetime = [this.orderFilters.placedDatetime[0], this.adjustEndTime(this.orderFilters.placedDatetime[1])];
      }

      this.modalOrderFilters = {
        pickupDatetime: pickupDatetime,
        placedDatetime: placedDatetime,
        orderId: this.orderFilters.orderId,
        orderNumber: this.orderFilters.orderNumber,
        orderTotalMin: this.orderFilters.orderTotalMin,
        orderTotalMax: this.orderFilters.orderTotalMax,
        operator: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.orderFilters.operator)),
        paymentType: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.orderFilters.paymentType)),
        deliveryType: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.orderFilters.deliveryType)),
        source: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.orderFilters.source))
      };
      this.$modal.show('dispatchFiltersModal');
    },
    applyFilters: function applyFilters() {
      var _this21 = this;

      this.isModalFilterChange = true;

      this.requestFilters[0].value = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalRequestFilters[0].value));
      this.locationFilter = this.normalizeLocationFilter(this.modalLocationFilter);
      this.sortOrder = this.modalSortOrder;

      var pickupDatetime = null;
      if (this.modalOrderFilters.pickupDatetime && this.modalOrderFilters.pickupDatetime.length === 2) {
        pickupDatetime = [this.modalOrderFilters.pickupDatetime[0], this.adjustEndTime(this.modalOrderFilters.pickupDatetime[1])];
      }

      var placedDatetime = null;
      if (this.modalOrderFilters.placedDatetime && this.modalOrderFilters.placedDatetime.length === 2) {
        placedDatetime = [this.modalOrderFilters.placedDatetime[0], this.adjustEndTime(this.modalOrderFilters.placedDatetime[1])];
      }

      this.orderFilters = {
        pickupDatetime: pickupDatetime,
        placedDatetime: placedDatetime,
        orderId: this.modalOrderFilters.orderId,
        orderNumber: this.modalOrderFilters.orderNumber,
        orderTotalMin: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMin),
        orderTotalMax: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMax),
        operator: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.operator)),
        paymentType: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.paymentType)),
        deliveryType: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.deliveryType)),
        source: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.source))
      };

      this.$modal.hide('dispatchFiltersModal');

      this.$nextTick(function () {
        _this21.isModalFilterChange = false;
        _this21.refreshDispatchData();
      });
    },
    resetModalFilters: function resetModalFilters() {
      this.modalRequestFilters[0].value = DEFAULT_DISPATCH_STATUSES.slice();
      this.modalLocationFilter = [];
      this.modalSortOrder = 1;
      this.modalOrderFilters = {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: DEFAULT_DISPATCH_DELIVERY_TYPES.slice(),
        source: []
      };

      this.requestFilters[0].value = DEFAULT_DISPATCH_STATUSES.slice();
      this.locationFilter = [];
      this.sortOrder = this.modalSortOrder;
      this.orderFilters = {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: DEFAULT_DISPATCH_DELIVERY_TYPES.slice(),
        source: []
      };
      this.refreshDispatchData();
    },
    resetFilters: function resetFilters() {
      this.requestFilters[0].value = DEFAULT_DISPATCH_STATUSES.slice();
      this.locationFilter = [];
      this.orderFilters = {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: DEFAULT_DISPATCH_DELIVERY_TYPES.slice(),
        source: []
      };
      this.sortOrder = 1;
      this.refreshDispatchData();
    },
    removeStatusFilter: function removeStatusFilter(index) {
      this.requestFilters[0].value.splice(index, 1);
      this.refreshDispatchData();
    },
    removeLocationFilter: function removeLocationFilter(index) {
      this.locationFilter.splice(index, 1);
      this.refreshDispatchData();
    },
    removePickupDatetimeFilter: function removePickupDatetimeFilter() {
      this.orderFilters.pickupDatetime = null;
      this.refreshDispatchData();
    },
    removePlacedDatetimeFilter: function removePlacedDatetimeFilter() {
      this.orderFilters.placedDatetime = null;
      this.refreshDispatchData();
    },
    removeOrderIdFilter: function removeOrderIdFilter() {
      this.orderFilters.orderId = '';
      this.refreshDispatchData();
    },
    removeOrderNumberFilter: function removeOrderNumberFilter() {
      this.orderFilters.orderNumber = '';
      this.refreshDispatchData();
    },
    removeOrderTotalFilter: function removeOrderTotalFilter() {
      this.orderFilters.orderTotalMin = null;
      this.orderFilters.orderTotalMax = null;
      this.refreshDispatchData();
    },
    removeOperatorFilter: function removeOperatorFilter(index) {
      if (index !== undefined) {
        this.orderFilters.operator.splice(index, 1);
      } else {
        this.orderFilters.operator = [];
      }
      this.refreshDispatchData();
    },
    removePaymentTypeFilter: function removePaymentTypeFilter(index) {
      if (index !== undefined) {
        this.orderFilters.paymentType.splice(index, 1);
      } else {
        this.orderFilters.paymentType = [];
      }
      this.refreshDispatchData();
    },
    removeDeliveryTypeFilter: function removeDeliveryTypeFilter(index) {
      if (index !== undefined) {
        this.orderFilters.deliveryType.splice(index, 1);
      } else {
        this.orderFilters.deliveryType = [];
      }
      this.refreshDispatchData();
    },
    removeSourceFilter: function removeSourceFilter(index) {
      if (index !== undefined) {
        this.orderFilters.source.splice(index, 1);
      } else {
        this.orderFilters.source = [];
      }
      this.refreshDispatchData();
    },
    toggleModalStatusFilter: function toggleModalStatusFilter(key) {
      var idx = this.modalRequestFilters[0].value.indexOf(key);
      if (idx === -1) {
        this.modalRequestFilters[0].value.push(key);
      } else {
        this.modalRequestFilters[0].value.splice(idx, 1);
      }
    },
    toggleModalPaymentTypeFilter: function toggleModalPaymentTypeFilter(paymentType) {
      if (!this.modalOrderFilters.paymentType) {
        this.modalOrderFilters.paymentType = [];
      }
      var idx = this.modalOrderFilters.paymentType.indexOf(paymentType);
      if (idx === -1) {
        this.modalOrderFilters.paymentType.push(paymentType);
      } else {
        this.modalOrderFilters.paymentType.splice(idx, 1);
      }
    },
    toggleModalDeliveryTypeFilter: function toggleModalDeliveryTypeFilter(deliveryType) {
      if (!this.modalOrderFilters.deliveryType) {
        this.modalOrderFilters.deliveryType = [];
      }
      var idx = this.modalOrderFilters.deliveryType.indexOf(deliveryType);
      if (idx === -1) {
        this.modalOrderFilters.deliveryType.push(deliveryType);
      } else {
        this.modalOrderFilters.deliveryType.splice(idx, 1);
      }
    },
    toggleModalSourceFilter: function toggleModalSourceFilter(src) {
      if (!this.modalOrderFilters.source) {
        this.modalOrderFilters.source = [];
      }
      var idx = this.modalOrderFilters.source.indexOf(src);
      if (idx === -1) {
        this.modalOrderFilters.source.push(src);
      } else {
        this.modalOrderFilters.source.splice(idx, 1);
      }
    },
    toggleFiltersCollapse: function toggleFiltersCollapse() {
      this.showFiltersCollapsed = !this.showFiltersCollapsed;
    },
    getLocationFilterValue: function getLocationFilterValue(loc) {
      if (loc.true_id != null && loc.true_id !== '') {
        return parseInt(loc.true_id, 10);
      }
      return loc.id;
    },
    isLocationInFilter: function isLocationInFilter(loc) {
      return this.locationFilter.some(function (filterId) {
        var filterValue = parseInt(filterId, 10);
        var locId = parseInt(loc.id, 10);
        var locTrueId = loc.true_id != null ? parseInt(loc.true_id, 10) : null;
        return filterValue === locId || locTrueId != null && filterValue === locTrueId || filterId === loc.id || filterId === loc.true_id;
      });
    },
    getLocationName: function getLocationName(locationId) {
      var location = this.locations.find(function (loc) {
        return loc.true_id === locationId || loc.id === locationId;
      });
      return location ? location.name : locationId;
    },
    normalizeLocationFilter: function normalizeLocationFilter(locationFilter) {
      var _this22 = this;

      if (!locationFilter || !Array.isArray(locationFilter) || locationFilter.length === 0) {
        return [];
      }
      var normalized = [];

      var _loop = function _loop(value) {
        var numValue = typeof value === 'string' ? parseInt(value, 10) : value;
        var location = _this22.locations.find(function (loc) {
          if (loc.true_id === numValue || loc.true_id === value) return true;
          if (loc.id === numValue || loc.id === value) return true;
          if (typeof value === 'string') {
            return String(loc.true_id) === value || String(loc.id) === value;
          }
          return false;
        });
        if (location) {
          var filterValue = _this22.getLocationFilterValue(location);
          if (!normalized.includes(filterValue)) {
            normalized.push(filterValue);
          }
        }
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(locationFilter), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var value = _step2.value;

          _loop(value);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return normalized;
    },
    getOperatorName: function getOperatorName(operatorId) {
      var operator = this.operatorOptions.find(function (op) {
        return op.id === operatorId;
      });
      return operator ? operator.label : operatorId;
    },
    formatDateRange: function formatDateRange(dateRange) {
      if (!dateRange || dateRange.length !== 2) return '';
      return dateRange[0] + ' - ' + dateRange[1];
    },
    normalizeOrderTotal: function normalizeOrderTotal(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      var num = Number(value);

      if (isNaN(num) || num === 0) {
        return null;
      }
      return num;
    },
    adjustEndTime: function adjustEndTime(datetime) {
      if (datetime && datetime.endsWith('00:00:00')) {
        return datetime.replace('00:00:00', '23:59:59');
      }
      return datetime;
    },
    adjustDatetimeRange: function adjustDatetimeRange(filterType) {
      if (this.modalOrderFilters[filterType] && this.modalOrderFilters[filterType].length === 2) {
        this.modalOrderFilters[filterType] = [this.modalOrderFilters[filterType][0], this.adjustEndTime(this.modalOrderFilters[filterType][1])];
      }
    },
    formatLabelFirstLetter: function formatLabelFirstLetter(translationKey) {
      try {
        var label = this.$t(translationKey);
        if (!label || typeof label !== 'string') {
          var fallback = translationKey.split('.').pop();
          return fallback ? fallback.toLowerCase().split(' ').map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
          }).join(' ') : translationKey;
        }
        return label.toLowerCase().split(' ').map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ');
      } catch (e) {
        var key = translationKey.split('.').pop();
        return key ? key.toLowerCase().split(' ').map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ') : translationKey;
      }
    },
    getPosUsers: function getPosUsers() {
      var _this23 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status && response.data && response.data.pos_user) {
          _this23.operatorOptions = response.data.pos_user.map(function (user) {
            return {
              id: user.id,
              label: ((user.firstname || '') + ' ' + (user.lastname || '')).trim() || 'User ' + user.id
            };
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "Gddo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);











/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    }
  },
  data: function data() {
    return {
      loading: false,
      isSeries: true,
      series: '',
      startNumber: null,
      endNumber: null,
      vatNumber: null
    };
  },
  mounted: function mounted() {},
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
    this.vatNumber = this.$session.get('getVatNumber');
  },

  methods: {
    openSeries: function openSeries() {
      this.isSeries = true;
    },
    saveSeries: function saveSeries() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var seriesData, companyResponse, companyData, seriesResponse, seriesDataResponse;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this.series || !_this.startNumber || !_this.endNumber)) {
                  _context.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: 'Error',
                  text: 'All fields are required for the series.',
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                });
                return _context.abrupt('return');

              case 3:
                seriesData = {
                  externalCompanyId: _this.companyID,
                  vatNumber: _this.vatNumber,
                  series: _this.series,
                  startNumber: _this.startNumber,
                  endNumber: _this.endNumber
                };
                _context.prev = 4;
                _context.next = 7;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/company', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    vatNumber: seriesData.vatNumber,
                    name: _this.$session.get('companyName') })
                });

              case 7:
                companyResponse = _context.sent;

                if (companyResponse.ok) {
                  _context.next = 10;
                  break;
                }

                throw new Error('Error saving company');

              case 10:
                _context.next = 12;
                return companyResponse.json();

              case 12:
                companyData = _context.sent;

                console.log('Company saved successfully:', companyData);

                _context.next = 16;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/series', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(seriesData)
                });

              case 16:
                seriesResponse = _context.sent;

                if (seriesResponse.ok) {
                  _context.next = 19;
                  break;
                }

                throw new Error('Error saving series');

              case 19:
                _context.next = 21;
                return seriesResponse.json();

              case 21:
                seriesDataResponse = _context.sent;

                console.log('Series saved successfully:', seriesDataResponse);

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: 'Success',
                  text: 'Series saved successfully.',
                  type: 'success',
                  timer: 1500,
                  showConfirmButton: false
                });
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context['catch'](4);

                console.error('Error saving series:', _context.t0);

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: 'Error',
                  text: _context.t0.message,
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                });

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 26]]);
      }))();
    }
  }
});

/***/ }),

/***/ "GfWv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GgGM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceSidebar_vue__ = __webpack_require__("cJTk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d5ffe78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceSidebar_vue__ = __webpack_require__("apxn");
function injectStyle (ssrContext) {
  __webpack_require__("celo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d5ffe78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d5ffe78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GlGL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Nomenclator_ManagementBonProduct_vue__ = __webpack_require__("deWJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_ManagementLot_vue__ = __webpack_require__("lLZK");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementBonProduct: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Nomenclator_ManagementBonProduct_vue__["a" /* default */],
    ManagementLot: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_ManagementLot_vue__["a" /* default */]
  },
  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isBonProduct: true,
      isLot: false
    };
  },
  created: function created() {},

  methods: {
    openBonProduct: function openBonProduct() {
      this.isBonProduct = true;
      this.isLot = false;
    },
    openLot: function openLot() {
      this.isBonProduct = false;
      this.isLot = true;
    }
  }
});

/***/ }),

/***/ "Gm2z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GnSb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GoHO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gonw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LocationGroupsForm_vue__ = __webpack_require__("s1f/");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'LocationGroupsForm', __WEBPACK_IMPORTED_MODULE_7__LocationGroupsForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      LocationGroupsModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onSubmit: function onSubmit(model, isValid) {
      this.LocationGroupsModel = model;
    }
  }
});

/***/ }),

/***/ "Gpc3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Grt+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GrvI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomInfoPageAdd_vue__ = __webpack_require__("7O3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028f64cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomInfoPageAdd_vue__ = __webpack_require__("QaDr");
function injectStyle (ssrContext) {
  __webpack_require__("KAZc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomInfoPageAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028f64cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomInfoPageAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gtju":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GuXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  1: {
    'id': 1,
    'name': 'Cappucinno',
    'image_url': 'http://placeholder.pics/svg/60/DEDEDE/8F8F8F-DEDEDE/image',
    'active': true,
    'type': 'simple',
    'price': 8,
    'currency': 'lei'
  },
  2: {
    'id': 2,
    'name': 'Latte Machiato',
    'image_url': 'http://placeholder.pics/svg/60/DEDEDE/8F8F8F-DEDEDE/image',
    'active': true,
    'type': 'simple',
    'price': 7.50,
    'currency': 'lei'
  },
  3: {
    'id': 3,
    'name': 'Chocolate Cookie ',
    'image_url': 'http://placeholder.pics/svg/60/DEDEDE/8F8F8F-DEDEDE/image',
    'active': false,
    'type': 'combo',
    'price': 10.20,
    'currency': 'lei'
  }
});

/***/ }),

/***/ "GyU5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralCampaignForm_vue__ = __webpack_require__("bfPJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430e0f8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralCampaignForm_vue__ = __webpack_require__("9iTM");
function injectStyle (ssrContext) {
  __webpack_require__("H+ND")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-430e0f8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralCampaignForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430e0f8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralCampaignForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H+Bc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H+ND":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H/7z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H0h3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuLinks_vue__ = __webpack_require__("/51X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665fa7df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuLinks_vue__ = __webpack_require__("ppKS");
function injectStyle (ssrContext) {
  __webpack_require__("hHSX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665fa7df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H2Im":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);










/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    appId: function appId(newVal, oldVal) {
      if (String(newVal || '') === String(oldVal || '')) return;
      this.paginationProps.currentPage = 1;
      var pageSize = this.paginationProps.pageSize || 20;
      this.fetchActions({ page: 1, pageSize: pageSize });
    }
  },
  created: function created() {
    this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest';
    this.getPosUsers();
    this.getPosDevices();
    this.fetchActions();
  },
  data: function data() {
    return {
      timezone: null,
      loading: true,
      actions: [],
      total: 0,
      diffModalRow: null,
      posUsers: [],
      posNameById: {},
      transferTableNameById: {},
      paginationProps: {
        layout: 'prev, pager, next, sizes, total',
        currentPage: 1,
        pageSize: 20
      }
    };
  },

  computed: {
    beforeProducts: function beforeProducts() {
      if (!this.diffModalRow) return [];
      var type = Number(this.diffModalRow.action_type);
      if (type !== 2 && type !== 3) return [];
      return this.extractProductsFromBefore(this.diffModalRow);
    },
    printerStatusObj: function printerStatusObj() {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 3) return null;
      var obj = this.parseJsonMaybe(this.diffModalRow.data_after);
      return obj && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(obj)) === 'object' ? obj : null;
    },
    orderStatusAfter: function orderStatusAfter() {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 4) return null;
      var obj = this.parseJsonMaybe(this.diffModalRow.data_after);
      var st = obj && obj.status ? String(obj.status) : null;
      return st && st.trim() ? st.trim() : null;
    },
    transferOutProducts: function transferOutProducts() {
      var _this = this;

      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 6) return [];
      return this.extractTransferOutProducts(this.diffModalRow).filter(function (it) {
        return !_this.isHiddenStornoDisplayLine(it);
      });
    },
    transferRemainingProducts: function transferRemainingProducts() {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 6) return [];
      return this.extractTransferRemainingProducts(this.diffModalRow);
    },
    transferRemainingDisplayProducts: function transferRemainingDisplayProducts() {
      var products = this.transferRemainingProducts || [];
      return products.filter(function (p) {
        if (!p) return false;

        var name = p.name != null ? String(p.name).trim() : '';
        var hasName = !!name && name !== '-';

        var hasOptions = Array.isArray(p.options) && p.options.length > 0;
        var hasAdditional = p.additional_info != null && String(p.additional_info).trim() !== '';

        var qty = p.quantity != null && p.quantity !== '-' ? Number(p.quantity) : null;
        var hasNonZeroQty = qty != null && !isNaN(qty) && qty !== 0;

        return hasName || hasOptions || hasAdditional || hasNonZeroQty;
      });
    },
    transferRemainingKeySet: function transferRemainingKeySet() {
      var _this2 = this;

      var set = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a();
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 6) return set;
      var after = this.parseJsonMaybe(this.diffModalRow.data_after);
      var items = after && Array.isArray(after.remaining_items) ? after.remaining_items : [];
      items.forEach(function (it) {
        if (!it) return;
        var key = _this2.productCompareKey({
          app_id: it.app_id != null ? it.app_id : null,
          name: it.name != null ? String(it.name) : null
        });
        if (key) set.add(key);
      });
      return set;
    },
    transferRemainingStatus: function transferRemainingStatus() {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 6) return null;
      var after = this.parseJsonMaybe(this.diffModalRow.data_after);
      var st = after && after.status ? String(after.status) : null;
      return st && st.trim() ? st.trim() : null;
    },
    transferInProducts: function transferInProducts() {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 7) return [];
      return this.extractTransferInProducts(this.diffModalRow);
    },
    stornoAfterProducts: function stornoAfterProducts() {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 5) return [];
      return this.extractStornoAfterProducts(this.diffModalRow);
    },
    orderId: function orderId() {
      return this.route && this.route.params && this.route.params.orderId != null ? this.route.params.orderId : this.$route.params.orderId;
    },
    appId: function appId() {
      if (this.route && this.route.query && this.route.query.app_id != null) return this.route.query.app_id;
      if (this.route && this.route.params && this.route.params.orderId != null) return this.route.params.orderId;
      return this.$route.query && this.$route.query.app_id;
    }
  },
  methods: {
    productCreatedAtDisplay: function productCreatedAtDisplay(prod) {
      if (!prod) return '-';
      var createdAt = prod.created_at || prod.createdAt;
      var ts = prod.timestamp || prod.time || prod.created;
      var val = createdAt || ts;
      return val ? this.formatToCompanyTimezone(val) : '-';
    },
    productCompareKey: function productCompareKey(p) {
      if (!p) return null;

      var appId = p.app_id != null ? String(p.app_id) : '';
      if (appId) return 'app_id:' + appId;
      var name = p.name != null ? String(p.name).trim().toLowerCase() : '';
      if (name && name !== '-') return 'name:' + name;
      return null;
    },
    isHiddenStornoDisplayLine: function isHiddenStornoDisplayLine(it) {
      if (!it || Number(it.is_storno) !== 1) return false;
      var priceNum = it.price != null ? Number(it.price) : null;
      var priceNegative = priceNum != null && !isNaN(priceNum) && priceNum < 0;
      var qtyNum = it.quantity != null && it.quantity !== '-' ? Number(it.quantity) : null;
      var qtyNegative = qtyNum != null && !isNaN(qtyNum) && qtyNum < 0;
      return priceNegative || qtyNegative;
    },
    isTransferredOutItem: function isTransferredOutItem(prod) {
      if (prod && Number(prod.is_storno) === 1) return false;

      var key = this.productCompareKey(prod);
      if (!key) return false;
      return !this.transferRemainingKeySet.has(key);
    },
    getPosUsers: function getPosUsers() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response && response.status === true) {
          _this3.posUsers = response.data && response.data.pos_user ? response.data.pos_user : [];
        } else {
          _this3.posUsers = [];
        }
      });
    },
    getPosDevices: function getPosDevices() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos', 'GET', data, function (response) {
        var map = {};
        if (response && response.status === true && response.data && Array.isArray(response.data.pos)) {
          response.data.pos.forEach(function (p) {
            if (p && p.id != null) map[p.id] = p.name || 'ID ' + p.id;
          });
        }
        _this4.posNameById = map;
      });
    },
    posDeviceName: function posDeviceName(posId) {
      if (posId === undefined || posId === null || posId === '') return '-';
      return this.posNameById[posId] || String(posId);
    },
    operatorDisplayName: function operatorDisplayName(operatorId) {
      if (operatorId === undefined || operatorId === null || operatorId === '') return '-';
      var u = this.posUsers.find(function (x) {
        return x && (x.id === operatorId || String(x.id) === String(operatorId));
      });
      if (!u) return String(operatorId);
      var full = ((u.firstname || '') + ' ' + (u.lastname || '')).trim();
      return full || String(operatorId);
    },
    paymentMethodLabel: function paymentMethodLabel(method) {
      if (method === undefined || method === null || method === '') return '-';
      var key = String(method);
      var translated = this.$t('paymentTypes.' + key);

      if (translated && translated !== 'paymentTypes.' + key) return translated;
      return key;
    },
    actionTypeDisplay: function actionTypeDisplay(row) {
      if (!row) return '-';
      var type = Number(row.action_type);
      if (type === 2) {
        var name = this.extractMarkedProductName(row);
        if (name) return this.$t('reports.posOrderActionMarkProduct', { name: name });
        return this.$t('reports.posOrderActionMarkProductGeneric');
      }
      return this.actionTypeLabel(row.action_type);
    },
    extractMarkedProductName: function extractMarkedProductName(row) {
      var productId = row && row.product_id != null ? String(row.product_id) : null;

      var findNameByProductId = function findNameByProductId(payload) {
        if (!productId) return null;

        if (Array.isArray(payload)) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(payload), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var part = _step.value;

              var items = part && Array.isArray(part.order_part_items) ? part.order_part_items : [];
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var it = _step2.value;

                  if (!it) continue;
                  if (it.product_id != null && String(it.product_id) === productId) {
                    var n = it.name ? String(it.name) : null;
                    return n && n.trim() ? n.trim() : null;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        if (payload && (typeof payload === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(payload)) === 'object' && Array.isArray(payload.products)) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(payload.products), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _it = _step3.value;

              if (!_it) continue;
              if (_it.product_id != null && String(_it.product_id) === productId) {
                var _n = _it.name ? String(_it.name) : null;
                return _n && _n.trim() ? _n.trim() : null;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }

        return null;
      };

      var before = this.parseJsonMaybe(row.data_before);

      return findNameByProductId(before) || null;
    },
    extractProductsFromBefore: function extractProductsFromBefore(row) {
      var payload = this.parseJsonMaybe(row && row.data_before);
      var products = [];

      if (Array.isArray(payload)) {
        payload.forEach(function (part) {
          var items = part && Array.isArray(part.order_part_items) ? part.order_part_items : [];
          items.forEach(function (it) {
            if (!it) return;
            products.push({
              name: it.name ? String(it.name) : '-',
              quantity: it.quantity != null ? it.quantity : '-',
              price: it.price != null ? it.price : null,
              created_at: it.created_at || it.timestamp || null,
              options: Array.isArray(it.options) ? it.options : [],
              additional_info: it.comment ? String(it.comment) : ''
            });
          });
        });
        return products;
      }

      if (payload && (typeof payload === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(payload)) === 'object' && Array.isArray(payload.products)) {
        payload.products.forEach(function (it) {
          if (!it) return;
          products.push({
            name: it.name ? String(it.name) : '-',
            quantity: it.quantity != null ? it.quantity : '-',
            price: it.price != null ? it.price : null,
            created_at: it.created_at || it.timestamp || null,
            options: Array.isArray(it.options) ? it.options : [],
            additional_info: it.comment ? String(it.comment) : ''
          });
        });
      }

      return products;
    },
    extractTransferOutProducts: function extractTransferOutProducts(row) {
      var before = this.parseJsonMaybe(row && row.data_before);
      var items = before && Array.isArray(before.order_part_items) ? before.order_part_items : [];
      return items.map(function (it) {
        return {
          app_id: it && it.app_id != null ? it.app_id : null,
          name: it && it.name ? String(it.name) : '-',
          quantity: it && it.quantity != null ? it.quantity : '-',
          price: it && it.price != null ? it.price : null,
          created_at: it && (it.created_at || it.timestamp) ? it.created_at || it.timestamp : null,
          options: it && Array.isArray(it.options) ? it.options : [],
          additional_info: it && it.comment ? String(it.comment) : '',
          is_storno: it && it.is_storno != null ? Number(it.is_storno) : 0
        };
      });
    },
    extractTransferRemainingProducts: function extractTransferRemainingProducts(row) {
      var after = this.parseJsonMaybe(row && row.data_after);
      var items = after && Array.isArray(after.remaining_items) ? after.remaining_items : [];

      return items.filter(function (it) {
        return it && it.name != null && String(it.name).trim() !== '';
      }).map(function (it) {
        return {
          app_id: it && it.app_id != null ? it.app_id : null,
          name: String(it.name),
          quantity: it && it.quantity != null ? it.quantity : '-',
          price: it && it.price != null ? it.price : null,
          created_at: it && (it.created_at || it.timestamp) ? it.created_at || it.timestamp : null,
          options: it && Array.isArray(it.options) ? it.options : [],
          additional_info: it && it.comment ? String(it.comment) : ''
        };
      });
    },
    extractTransferInProducts: function extractTransferInProducts(row) {
      var after = this.parseJsonMaybe(row && row.data_after);
      var items = after && Array.isArray(after.items_received) ? after.items_received : [];
      return items.map(function (it) {
        return {
          name: it && it.name ? String(it.name) : '-',
          quantity: it && it.quantity != null ? it.quantity : '-',
          created_at: it && (it.created_at || it.timestamp) ? it.created_at || it.timestamp : null,
          product_id: it && it.product_id != null ? it.product_id : null
        };
      });
    },
    extractStornoAfterProducts: function extractStornoAfterProducts(row) {
      var _this5 = this;

      var after = this.parseJsonMaybe(row && row.data_after);
      var items = [];

      if (Array.isArray(after)) {
        items = after;
      } else if (after && (typeof after === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(after)) === 'object') {
        if (Array.isArray(after.items)) items = after.items;else if (Array.isArray(after.order_part_items)) items = after.order_part_items;else if (Array.isArray(after.products)) items = after.products;
      }

      var mapped = items.map(function (it) {
        return {
          name: it && it.name ? String(it.name) : '-',
          quantity: it && it.quantity != null ? it.quantity : '-',
          price: it && it.price != null ? it.price : null,
          created_at: it && (it.created_at || it.timestamp) ? it.created_at || it.timestamp : null,
          options: it && Array.isArray(it.options) ? it.options : [],
          additional_info: it && it.comment ? String(it.comment) : '',
          is_storno: it && it.is_storno != null ? Number(it.is_storno) : 0
        };
      });

      return mapped.filter(function (it) {
        return !_this5.isHiddenStornoDisplayLine(it);
      });
    },
    statusPillClass: function statusPillClass(status) {
      if (!status) return '';
      return String(status);
    },
    parseJsonMaybe: function parseJsonMaybe(val) {
      if (val === undefined || val === null) return null;
      if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(val)) === 'object') return val;
      var s = String(val);
      if (!s.trim()) return null;
      try {
        return JSON.parse(s);
      } catch (e) {
        return null;
      }
    },
    actionTypeLabel: function actionTypeLabel(type) {
      if (type == null || type === '') return '-';

      var numericToKey = {
        1: 'openOrder',
        2: 'markProduct',
        3: 'preNote',
        4: 'closeOrder',
        5: 'storno',
        6: 'transferOut',
        7: 'transferIn'
      };

      var key = numericToKey[Number(type)] || String(type);
      return this.$t('reports.posOrderActionTypes.' + key);
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.fetchActions(query);
      if (query.type === 'size') this.fetchActions(query);
      if (query.type === 'sort') this.fetchActions(query);
    },
    refreshNow: function refreshNow() {
      var page = this.paginationProps.currentPage || 1;
      var pageSize = this.paginationProps.pageSize || 20;
      this.fetchActions({ page: page, pageSize: pageSize });
    },
    goBack: function goBack() {
      this.$bus.$emit('refreshPosOrderActions');
      this.$bus.$emit('close-modal');
    },
    hasBeforeAfter: function hasBeforeAfter(row) {
      if (!row) return false;
      var before = row.data_before;
      var after = row.data_after;
      var hasBefore = before !== undefined && before !== null && String(before).trim() !== '';
      var hasAfter = after !== undefined && after !== null && String(after).trim() !== '';
      return hasBefore || hasAfter;
    },
    openBeforeAfterModal: function openBeforeAfterModal(row) {
      this.diffModalRow = row || null;
      this.$modal.show('posOrderActionsBeforeAfterModal');
    },
    closeBeforeAfterModal: function closeBeforeAfterModal() {
      this.$modal.hide('posOrderActionsBeforeAfterModal');
      this.diffModalRow = null;
    },
    formatDiffValue: function formatDiffValue(val) {
      if (val === undefined || val === null) return '-';
      if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(val)) === 'object') {
        try {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(val, null, 2);
        } catch (e) {
          return String(val);
        }
      }
      var s = String(val);
      if (!s.trim()) return '-';
      try {
        var parsed = JSON.parse(s);
        return (typeof parsed === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(parsed)) === 'object' && parsed !== null ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(parsed, null, 2) : String(parsed);
      } catch (e) {
        return s;
      }
    },
    formatToCompanyTimezone: function formatToCompanyTimezone(utcString) {
      var date = new Date(utcString + 'Z');
      var formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: this.timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
      var parts = formatter.formatToParts(date);
      return parts.find(function (p) {
        return p.type === 'year';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'month';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'day';
      }).value + ' ' + parts.find(function (p) {
        return p.type === 'hour';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'minute';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'second';
      }).value;
    },
    fetchActions: function fetchActions(query) {
      var _this6 = this;

      var pageSize = query && query.pageSize != null ? query.pageSize : this.paginationProps.pageSize || 20;
      var page = query && query.page != null ? query.page : this.paginationProps.currentPage || 1;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        app_id: this.appId
      };

      this.loading = true;
      this.apiRequest('/reports/v2/order-actions/order/' + this.appId + '?page=' + page + '&perPage=' + pageSize, 'GET', data, function (response) {
        if (response && response.status === true) {
          var paginator = response.data && response.data.actions;
          var rows = paginator && Array.isArray(paginator.data) ? paginator.data : [];
          _this6.actions = rows;
          _this6.prefetchTransferTables(rows);

          var pageFromTop = response.pagination && response.pagination.page;
          var perPageFromTop = response.pagination && response.pagination.perPage;
          var totalFromTop = response.pagination && response.pagination.total;

          var pageFromActions = paginator && paginator.current_page;
          var perPageFromActions = paginator && paginator.per_page;
          var totalFromActions = paginator && paginator.total;

          _this6.total = totalFromTop || totalFromActions || 0;
          _this6.paginationProps.currentPage = pageFromTop || pageFromActions || page;
          _this6.paginationProps.pageSize = perPageFromTop || perPageFromActions || pageSize;
        } else {
          var code = response && (response.statusCode || response.http_code || response.code) || response && response.errors && (response.errors.statusCode || response.errors.http_code || response.errors.code) || response && response.error && response.error.response && response.error.response.status;

          if (Number(code) === 404) {
            _this6.actions = [];
            _this6.total = 0;
            _this6.paginationProps.currentPage = 1;
            _this6.paginationProps.pageSize = pageSize;
          } else {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', _this6.$t('validations.wentWrong'), 'error');
          }
        }
        _this6.$nextTick(function () {
          _this6.loading = false;
        });
      });
    },
    prefetchTransferTables: function prefetchTransferTables(rows) {
      var _this7 = this;

      var list = Array.isArray(rows) ? rows : [];
      var ids = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(list.map(function (r) {
        return r && r.transfer_table_id;
      }).filter(function (v) {
        return v !== undefined && v !== null && v !== '';
      })));
      ids.forEach(function (id) {
        var key = String(id);
        if (_this7.transferTableNameById[key]) return;
        _this7.fetchTransferTableById(id);
      });
    },
    fetchTransferTableById: function fetchTransferTableById(id) {
      var _this8 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/table-management/' + id, 'GET', data, function (response) {
        if (response && response.status === true && response.data) {
          var t = response.data;
          var label = t.name && String(t.name).trim() || [t.type, t.number].filter(Boolean).join(' ') || null || (t.external_id ? String(t.external_id) : null) || 'ID ' + id;
          _this8.$set(_this8.transferTableNameById, String(id), label);
        } else {
          _this8.$set(_this8.transferTableNameById, String(id), 'ID ' + id);
        }
      });
    },
    transferTableName: function transferTableName(id) {
      if (id === undefined || id === null || id === '') return '-';
      return this.transferTableNameById[String(id)] || 'ID ' + id;
    },
    openTransferOrder: function openTransferOrder(row) {
      var _this9 = this;

      if (!row) return;
      var filters = this.route && this.route.query && this.route.query.posOrderActionsFilters ? this.route.query.posOrderActionsFilters : undefined;
      var navigateTo = function navigateTo(pathOrderId, appId) {
        _this9.$bus.$emit('close-modal');
        setTimeout(function () {
          _this9.$router.push({
            path: '/reports/pos-order-actions/' + pathOrderId,
            query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              tab: 'pos-order-actions',
              app_id: appId
            }, filters ? { posOrderActionsFilters: filters } : {})
          });
        }, 50);
      };

      var transferAppId = row.transfer_app_id || row.transfer_order_app_id;
      if (!transferAppId) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
        return;
      }
      navigateTo(transferAppId, transferAppId);
    }
  }
});

/***/ }),

/***/ "H3Cb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t1_vue__ = __webpack_require__("0lpa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18800d7d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t1_vue__ = __webpack_require__("QUHT");
function injectStyle (ssrContext) {
  __webpack_require__("3Cl/")
  __webpack_require__("YMMF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18800d7d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18800d7d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H62W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row referral-campaigns-page"},[_c('div',{staticClass:"col-md-12 col-lg-12"},[_c('div',{staticClass:"card mar-bt-15"},[_c('div',{staticClass:"card-header"},[_c('strong',[_vm._v(_vm._s(_vm.$t('referralProgram.notificationEmailsTitle')))])]),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('referralProgram.notificationEmailsHelp')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notificationEmailsRaw),expression:"notificationEmailsRaw"}],staticClass:"form-control",attrs:{"rows":"2","placeholder":_vm.$t('referralProgram.notificationEmailsPlaceholder')},domProps:{"value":(_vm.notificationEmailsRaw)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notificationEmailsRaw=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info mar-to-10",attrs:{"type":"button","disabled":_vm.notificationLoading},on:{"click":_vm.saveNotificationEmails}},[_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"search-bar"},[_c('div',{staticClass:"col-sm-12 no-padding"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('reports.search')},model:{value:(_vm.filters[0].value),callback:function ($$v) {_vm.$set(_vm.filters[0], "value", $$v)},expression:"filters[0].value"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn add ",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('pages.referralCampaigns'),"to":{ path: '/marketing/referral-campaigns/add' }}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.add'))+"\n          ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"referralDataTables",staticClass:"campaign-table width-table referral-campaigns-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDef,"table-props":{ border: false },"filters":_vm.filters},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","width":64,"prop":"id","label":_vm.$t('customers.id')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":170,"prop":"name","label":_vm.$t('referralProgram.campaignName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","width":190,"label":_vm.$t('referralProgram.tableAvailability')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatAvailabilityRange(props.row))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","width":80,"label":_vm.$t('referralProgram.active')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatActiveColumn(props.row))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"referral-campaigns-table__reward-cell","align":"left","header-align":"left","min-width":260,"label":_vm.$t('referralProgram.orderRewards')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.rewardEntries(props.row, 'order_reward').length)?_c('div',{staticClass:"referral-campaigns-table__rewards"},_vm._l((_vm.rewardEntries(props.row, 'order_reward')),function(reward){return _c('div',{key:reward.role,staticClass:"referral-campaigns-table__reward"},[_c('strong',[_vm._v(_vm._s(reward.label))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(reward.description))])])})):_c('span',[_vm._v(_vm._s(_vm.$t('referralProgram.rewardSummaryDisabled')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"referral-campaigns-table__reward-cell","align":"left","header-align":"left","min-width":260,"label":_vm.$t('referralProgram.cashback')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.rewardEntries(props.row, 'cashback').length)?_c('div',{staticClass:"referral-campaigns-table__rewards"},_vm._l((_vm.rewardEntries(props.row, 'cashback')),function(reward){return _c('div',{key:reward.role,staticClass:"referral-campaigns-table__reward"},[_c('strong',[_vm._v(_vm._s(reward.label))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(reward.description))])])})):_c('span',[_vm._v(_vm._s(_vm.$t('referralProgram.rewardSummaryDisabled')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","width":120,"prop":"actions","label":_vm.$t('marketingCampaigns.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('button',{staticClass:"arrow-box",attrs:{"type":"button","aria-label":_vm.$t('marketingCampaigns.actions'),"data-row-id":props.row.id}},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu referral-campaign-actions-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.goToRecord(props.row, null, $event)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.edit'))+"\n                  ")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"divided":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.handleDelete(props.$index, props.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.delete'))+"\n                  ")])],1)],1)]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H6VS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceProfileEdit_vue__ = __webpack_require__("AX3L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31802e3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceProfileEdit_vue__ = __webpack_require__("Wve1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceProfileEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31802e3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceProfileEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H9EB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H9OI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchReports_vue__ = __webpack_require__("+RZf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4224c8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchReports_vue__ = __webpack_require__("nlx2");
function injectStyle (ssrContext) {
  __webpack_require__("ijTy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4224c8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HBXc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosMapAdd_vue__ = __webpack_require__("TLBU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0082cd1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosMapAdd_vue__ = __webpack_require__("B9/F");
function injectStyle (ssrContext) {
  __webpack_require__("hMIh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosMapAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0082cd1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosMapAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HDo4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HDqy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSpinningWheelFreeProductCoupon;
function isSpinningWheelFreeProductCoupon(coupon) {
  var campaign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return !!coupon && coupon.type === 'FREE_PRODUCT' && (Number(coupon.spinning_wheel_reward_id) > 0 || Number(campaign && campaign.spinning_wheel_reward_id) > 0);
}

/***/ }),

/***/ "HE83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])]),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"card automation-beneficiaries"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ab-head"},[_c('span',{staticClass:"ab-head__icon"},[_c('i',{class:_vm.isCart ? 'fa fa-shopping-cart' : 'fa fa-birthday-cake'})]),_vm._v(" "),_c('div',[_c('h4',{staticClass:"ab-head__title"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.beneficiariesTitle')))]),_vm._v(" "),(_vm.campaign)?_c('div',{staticClass:"ab-head__sub"},[_vm._v(_vm._s(_vm.campaign.name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"ab-chips"},_vm._l((_vm.chips),function(chip){return _c('a',{key:chip.key,staticClass:"ab-chip",class:['ab-chip--' + chip.key, { 'is-active': _vm.filters.status === chip.value }],on:{"click":function($event){$event.preventDefault();_vm.setStatus(chip.value)}}},[_c('span',{staticClass:"ab-chip__count"},[_vm._v(_vm._s(_vm.counts[chip.key] || 0))]),_vm._v(" "),_c('span',{staticClass:"ab-chip__label"},[_c('i',{class:chip.icon}),_vm._v(" "+_vm._s(_vm.$t(chip.label)))])])})),_vm._v(" "),_c('div',{staticClass:"ab-filters"},[_c('el-input',{staticClass:"ab-search",attrs:{"prefix-icon":"el-icon-search","clearable":"","placeholder":_vm.$t('marketingAutomation.searchCustomer')},on:{"input":_vm.onSearch},model:{value:(_vm.filters.search),callback:function ($$v) {_vm.$set(_vm.filters, "search", $$v)},expression:"filters.search"}}),_vm._v(" "),_c('el-select',{staticClass:"ab-year",on:{"change":_vm.reload},model:{value:(_vm.filters.year),callback:function ($$v) {_vm.$set(_vm.filters, "year", $$v)},expression:"filters.year"}},[_c('el-option',{attrs:{"label":_vm.$t('marketingAutomation.allYears'),"value":""}}),_vm._v(" "),_vm._l((_vm.years),function(year){return _c('el-option',{key:year,attrs:{"label":String(year),"value":year}})})],2)],1),_vm._v(" "),(_vm.campaign)?_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"ab-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.items,"empty-text":_vm.$t('marketingAutomation.noBeneficiaries')}},[_c('el-table-column',{attrs:{"min-width":220,"label":_vm.$t('marketingAutomation.customer')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"ab-customer"},[_c('span',{staticClass:"ab-avatar"},[_vm._v(_vm._s(_vm.initials(props.row.customer)))]),_vm._v(" "),_c('div',{staticClass:"ab-customer__text"},[_c('div',{staticClass:"ab-strong"},[_vm._v(_vm._s((props.row.customer && props.row.customer.name) || '—'))]),_vm._v(" "),_c('div',{staticClass:"ab-muted"},[_vm._v(_vm._s(_vm.contact(props.row.customer)))])])])]}}])}),_vm._v(" "),(!_vm.isCart)?_c('el-table-column',{attrs:{"min-width":140,"label":_vm.$t('marketingAutomation.birthday')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"ab-strong"},[_vm._v(_vm._s(_vm.formatDay(props.row.occasion_date)))]),_vm._v(" "),_c('div',{staticClass:"ab-muted"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.yearLabel', { year: props.row.year })))])]}}])}):_c('el-table-column',{attrs:{"min-width":150,"label":_vm.$t('marketingAutomation.cart')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.cart)?[_c('div',{staticClass:"ab-strong"},[_vm._v("\n                  #"+_vm._s(props.row.cart.id)+"\n                  "),(props.row.cart.total !== null)?_c('span',{staticClass:"ab-order-total"},[_vm._v("· "+_vm._s(props.row.cart.total)+" "+_vm._s(_vm.currency))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ab-muted"},[_vm._v(_vm._s(_vm.formatDateTime(props.row.cart.created_at)))])]:_c('span',{staticClass:"ab-muted"},[_vm._v("—")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":210,"label":_vm.$t('marketingAutomation.notifications')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"ab-push",class:'ab-push--' + _vm.pushState(props.row.announce)},[_c('i',{class:_vm.pushIcon(props.row.announce)}),_vm._v(" "),_c('span',{staticClass:"ab-push__kind"},[_vm._v(_vm._s(_vm.isCart ? _vm.$t('marketingAutomation.cartPush1Short') : _vm.$t('marketingAutomation.announcePushShort'))+":")]),_vm._v("\n                "+_vm._s(_vm.pushText(props.row.announce))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"ab-push",class:'ab-push--' + _vm.pushState(props.row.day)},[_c('i',{class:_vm.pushIcon(props.row.day)}),_vm._v(" "),_c('span',{staticClass:"ab-push__kind"},[_vm._v(_vm._s(_vm.isCart ? _vm.$t('marketingAutomation.cartPush2Short') : _vm.$t('marketingAutomation.dayPushShort'))+":")]),_vm._v("\n                "+_vm._s(_vm.pushText(props.row.day))+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":130,"label":_vm.$t('marketingAutomation.status')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"ab-status",class:'ab-status--' + props.row.status},[_c('span',{staticClass:"ab-status__dot"}),_vm._v(_vm._s(_vm.statusLabel(props.row.status))+"\n              ")]),_vm._v(" "),(_vm.isCart && props.row.status === 'granted' && props.row.valid_until)?_c('div',{staticClass:"ab-muted"},[_vm._v("\n                "+_vm._s(_vm.$t('marketingAutomation.validUntil', { time: _vm.formatDateTime(props.row.valid_until) }))+"\n              ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":170,"label":_vm.$t('marketingAutomation.order')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.status === 'used')?[(props.row.order)?_c('div',{staticClass:"ab-strong"},[_vm._v("\n                  #"+_vm._s(props.row.order.number || props.row.order.id)+"\n                  "),(props.row.order.total !== null)?_c('span',{staticClass:"ab-order-total"},[_vm._v("· "+_vm._s(props.row.order.total)+" "+_vm._s(_vm.currency))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ab-muted"},[_vm._v(_vm._s(_vm.formatDateTime(props.row.used_at)))])]:(props.row.converted)?[_c('div',{staticClass:"ab-strong"},[_vm._v("#"+_vm._s(props.row.converted.number || props.row.converted.order_id))]),_vm._v(" "),_c('div',{staticClass:"ab-muted"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.cartPlaced'))+" · "+_vm._s(_vm.formatDateTime(props.row.converted.at)))])]:_c('span',{staticClass:"ab-muted"},[_vm._v("—")]),_vm._v(" "),(props.row.status === 'used' && props.row.converted)?_c('span',{staticClass:"ab-recovered"},[_c('i',{staticClass:"fa fa-shopping-bag"}),_vm._v(" "+_vm._s(_vm.$t('marketingAutomation.status_converted')))]):_vm._e()]}}])})],1):_vm._e(),_vm._v(" "),(_vm.pagination.total > 0)?_c('div',{staticClass:"ab-pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"total, sizes, prev, pager, next","total":_vm.pagination.total,"page-size":_vm.pagination.per_page,"page-sizes":[20, 50, 100],"current-page":_vm.pagination.current_page},on:{"size-change":_vm.onSizeChange,"current-change":_vm.onPageChange}})],1):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HG/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('printer-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HHnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "HJlf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CantarForm_vue__ = __webpack_require__("HR1T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec49c28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CantarForm_vue__ = __webpack_require__("Z/c3");
function injectStyle (ssrContext) {
  __webpack_require__("z5H4")
  __webpack_require__("D4Y4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ec49c28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CantarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec49c28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CantarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HOa3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserForm_vue__ = __webpack_require__("cxx/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e966a1d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserForm_vue__ = __webpack_require__("OBGo");
function injectStyle (ssrContext) {
  __webpack_require__("RJy+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e966a1d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HQw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ocr_vue__ = __webpack_require__("7H1W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c96b9b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ocr_vue__ = __webpack_require__("2VZ6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ocr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c96b9b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ocr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HR1T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_BackgroundColorPicker_vue__ = __webpack_require__("8zHz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__);














var _components;








__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PSwitch: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__["a" /* default */],
    BackgroundColorPicker: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_BackgroundColorPicker_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getData();
  },
  data: function data() {
    return {
      id: this.value,
      locations: [],
      table_maps: [],
      model: {
        'id': 0,
        'type': 1,
        'name': null,
        'type_name': 'CAS',
        'port': null,
        'baudRate': null,
        'timeoutMs': null
      },
      modelValidate: {
        name: { required: true },
        port: { required: true },
        baudRate: { required: true },
        timeoutMs: { required: true },
        type_name: { required: true }
      },
      loading: true,
      colors: {
        defult: '#c850c0',
        black: '#000'
      }
    };
  },

  methods: {
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy);
    },
    getData: function getData() {
      var _this = this;

      var id = this.id || this.route.params.id;
      if (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };
        this.apiRequest('/cantar/' + id, 'GET', data, function (response) {
          if (response.status) {
            _this.model = response.data.cantar;
            if (_this.model.location_id) {
              _this.changeLocation(true);
            }
          }
          _this.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveTable();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    saveTable: function saveTable() {
      var _this3 = this;

      this.loading = true;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model, {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany')
      });

      var id = this.id || this.route.params.id;
      var url = '';
      var request = '';
      if (id) {
        url = '/cantar/' + id;
        request = 'PUT';
      } else {
        url = '/cantar/add';
        request = 'POST';
      }
      this.apiRequest(url, request, data, function (response) {
        if (response.status === true) {
          _this3.errors.clear();
          if (request === 'POST') {
            _this3.$bus.$emit('refresh');
            _this3.$bus.$emit('close-modal');
          } else {
            _this3.backButton();
          }
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
            title: '',
            text: _this3.$t('settingTable.tableSave'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          _this3.handleErrors(response.errors);
        }
        _this3.loading = false;
      });
    },
    deleteOrderScreen: function deleteOrderScreen() {
      var _this4 = this;

      this.loadingReset = true;
      var id = this.id || this.route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/cantar/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this4.backButton();
        } else {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': _this4.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
        _this4.loadingReset = false;
      });
    },
    changeLocation: function changeLocation() {
      var _this5 = this;

      var doNotEmptyModel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!doNotEmptyModel) {
        this.model.table_maps_ids = [];
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_id: this.model.location_id
      };
      this.loading = true;
      this.apiRequest('/pos/all/map', 'GET', data, function (response) {
        if (response.status) {
          _this5.table_maps = response.data.cantar;
        }
        _this5.loading = false;
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    updateColor: function updateColor(value) {
      this.model.background_color = value;
    }
  }
});

/***/ }),

/***/ "HRUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("zwtn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a71d5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("Qeci");
function injectStyle (ssrContext) {
  __webpack_require__("DKN6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a71d5f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HTxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLabelingForm_vue__ = __webpack_require__("BaAX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9566611a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserLabelingForm_vue__ = __webpack_require__("Z+1f");
function injectStyle (ssrContext) {
  __webpack_require__("SyU1")
  __webpack_require__("BKm5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9566611a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLabelingForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9566611a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserLabelingForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HZcq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 283.4 284.8"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 283.4 284.8","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t4_1_","y":"85.7","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t4_3_","d":"M0,190.1V94.7c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H9c-2.4,0-4.7-0.9-6.4-2.6S0,192.5,0,190.1z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,199.1V85.7h113.4v113.4H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t4_5_","x":"170","y":"85.7","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t4_7_","d":"M170,190.1V94.7c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H179c-2.4,0-4.7-0.9-6.4-2.6S170,192.5,170,190.1z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M170,199.1V85.7h113.4v113.4H170z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t4_9_","x":"90","y":"85.7","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t4_11_","d":"M90,190.1V94.7c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H99c-2.4,0-4.7-0.9-6.4-2.6S90,192.5,90,190.1z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M90,199.1V85.7h113.4v113.4H90z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t4_13_","x":"85.7","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t4_15_","d":"M94.7,0h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6\n            H94.7c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4S92.3,0,94.7,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M85.7,0h113.4v113.4H85.7V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t4_17_","x":"85.7","y":"171.4","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t4_19_","d":"M94.7,171.4h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6\n            H94.7c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4C90,172.4,92.3,171.4,94.7,171.4z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M85.7,171.4h113.4v113.4H85.7V171.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t4_21_","x":"20","y":"20","width":"244.8","height":"244.8"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t4_23_","d":"M43,20h198.8c12.7,0,23,10.3,23,23v198.8c0,12.7-10.3,23-23,23H43c-12.7,0-23-10.3-23-23V43\n            C20,30.3,30.3,20,43,20z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st13",attrs:{"d":"M20,20h244.8v244.8H20V20z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t4_25_","x":"49.3","y":"49.3","width":"186.3","height":"186.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"t4_27_","cx":"142.4","cy":"142.4","r":"93.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t4_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t4_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('path',{staticClass:"st2",attrs:{"d":"M49.3,49.3h186.3v186.3H49.3V49.3z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HdYx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HeUh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_col_css__ = __webpack_require__("jZDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_col_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_col_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_col__ = __webpack_require__("91Nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css__);




























__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_col___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_21_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Switch_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default.a
  },
  computed: {},
  data: function data() {
    return {
      loading: true,
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      searchQuery: '',
      propsToSearch: ['name'],
      tableColumns: [],
      tableData: [],
      filters: [{
        value: '',
        prop: ['name', 'parent_category']
      }],
      sortOrderChanges: {},
      debounceTimeout: null,
      swalLoading: null
    };
  },

  watch: {
    loading: function loading(value) {
      if (value) {
        if (this.swalLoading) {
          return;
        }

        this.swalLoading = __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
          title: '<div style="font-size: 1.2em; margin-bottom: 10px;">' + this.$t('general.loading') + '</div>',
          html: '\n            <div class="custom-loader"></div>\n            <div style="margin-top: 10px;">' + this.$t('general.justMoment') + '</div>\n          ',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: function didOpen() {
            __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default.a.showLoading();
          }
        });
      } else {
        if (this.swalLoading) {
          __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default.a.close();
          this.swalLoading = null;
        }
      }
    }
  },
  created: function created() {
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      this.$nextTick(function () {
        this.loading = true;
      });
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        use_sort_order: 'asc'
      };
      this.apiRequest('/topcategory', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    handleActive: function handleActive(row) {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        active: row.active ? 1 : 0,
        id: row.id,
        version: 3
      };

      this.apiRequest('/topcategory/' + row.id, 'PUT', data, function (response) {
        if (!response.status) {
          __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()('', response.errors.error, 'error').catch(function () {});
          row.active = !row.active;
        } else {
          _this2.trackAdminEvent('ADMIN_TOP_CATEGORY_UPDATE', 'top_category', row.id, {
            top_category_id: row.id,
            name: row.name || null,
            active: !!row.active
          });
        }
      });
    },
    formatCategName: function formatCategName(row) {
      if (row['parent_id']) {
        return row['parent_category']['name'];
      } else {
          return '';
        }
    },
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/top-categories/edit/');
    },
    adjustSort: function adjustSort(evt) {
      var _this3 = this;

      if (this.tableData.length > 1) {
        var idx = evt.newIndex;
        var after, before, sortOrder;

        if (idx === 0) {
          before = 0;
          after = this.tableData[idx + 1].sort_order;
        } else if (idx + 1 === this.tableData.length) {
          before = this.tableData[idx - 1].sort_order;
          after = parseFloat(before) + 1;
        } else {
          before = this.tableData[idx - 1].sort_order;
          after = this.tableData[idx + 1].sort_order;
        }
        sortOrder = (parseFloat(before) + parseFloat(after)) / 2;
        var id = this.tableData[idx].id;
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: sortOrder,
          version: 3
        };

        this.apiRequest('/topcategory/' + id, 'PUT', data, function (response) {
          if (response.status !== true) {
            _this3.getData();
            __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
              title: '',
              text: response.errors.error,
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
          }
        });
      }
    },
    onSortOrderInput: function onSortOrderInput(item) {
      var _this4 = this;

      if (item.sort_order < 0) {
        item.sort_order = 0;
      } else if (item.sort_order > 100) {
        item.sort_order = 100;
      }

      this.sortOrderChanges[item.id] = item.sort_order;

      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(function () {
        _this4.sendSortOrderUpdates();
      }, 1000 * 5);
    },
    sendSortOrderUpdates: function sendSortOrderUpdates() {
      var _this5 = this;

      var updates = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.sortOrderChanges).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            id = _ref2[0],
            sortOrder = _ref2[1];

        return {
          id: id,
          sortOrder: sortOrder
        };
      });

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        updates: updates
      };

      this.loading = true;

      this.apiRequest('/sort-top-category-mass-update', 'PUT', data, function (response) {
        if (response.status) {
          _this5.getData();
        } else {
          _this5.loading = false;
          __WEBPACK_IMPORTED_MODULE_22_sweetalert2___default()({
            title: '',
            text: response.errors.message || _this5.$t('validations.wentWrong'),
            type: 'error',
            showConfirmButton: false,
            timer: 5000
          }).catch(function () {});
        }
      });

      this.sortOrderChanges = {};
      this.debounceTimeout = null;
    },
    onlyDigits: function onlyDigits(event) {
      var char = String.fromCharCode(event.which);
      if (!/^\d$/.test(char)) {
        event.preventDefault();
      }
    },
    selectInputText: function selectInputText(event) {
      event.target.select();
    }
  }
});

/***/ }),

/***/ "HfNC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HgLu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsUserEdit_vue__ = __webpack_require__("r6BL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fd54918_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsUserEdit_vue__ = __webpack_require__("TMxC");
function injectStyle (ssrContext) {
  __webpack_require__("g2Ay")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsUserEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fd54918_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsUserEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HhpG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationReport_vue__ = __webpack_require__("rjjY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e8b7a04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationReport_vue__ = __webpack_require__("IS4p");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e8b7a04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hioa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('challenge-campaign-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hji5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hoxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[(_vm.id)?_c('a',{staticClass:"btn btn-icon btn-xls mar-rt-10",attrs:{"title":_vm.$t('reports.export')}},[_vm._v("\n            "+_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"},on:{"click":_vm.downloadPoints}})]):_vm._e(),_vm._v(" "),(_vm.id)?_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",on:{"click":function($event){$event.preventDefault();return _vm.handleDelete($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.delete'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])])]),_vm._v(" "),(['ADMIN', 'OWNER', 'MARKETER'].includes(_vm.userRole))?_c('div',{staticClass:"card mar-to-15"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.title')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.title),expression:"modelValidations.title"},{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],staticClass:"form-control",attrs:{"type":"text","name":"title","placeholder":_vm.$t('marketingPromos.title')},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('title'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('title'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.treshold')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.treshold),expression:"modelValidations.treshold"},{name:"model",rawName:"v-model",value:(_vm.model.treshold),expression:"model.treshold"}],staticClass:"form-control",attrs:{"type":"number","name":"threshold","placeholder":_vm.$t('marketingPromos.treshold')},domProps:{"value":(_vm.model.treshold)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "treshold", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('treshold'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('treshold'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.startEndDate')))]),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":_vm.pickerOptions},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}}),_vm._v(" "),(_vm.errors.has('date_start'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('date_start'))+"\n                ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.expiry')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.expiry),expression:"modelValidations.expiry"},{name:"model",rawName:"v-model",value:(_vm.model.expiry),expression:"model.expiry"}],staticClass:"form-control",attrs:{"type":"number","name":"expiry","placeholder":_vm.$t('marketingPromos.expiry')},domProps:{"value":(_vm.model.expiry)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "expiry", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('marketingPromos.expiryInfo')))]),_vm._v(" "),(_vm.errors.has('expiry'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('expiry'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.multiple')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.multiple),callback:function ($$v) {_vm.$set(_vm.model, "multiple", $$v)},expression:"model.multiple"}}),_vm._v(" "),(_vm.errors.has('multiple'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('multiple'))+"\n                ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.redeemFromNextOrder')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.redeem_from_next_order),callback:function ($$v) {_vm.$set(_vm.model, "redeem_from_next_order", $$v)},expression:"model.redeem_from_next_order"}}),_vm._v(" "),(_vm.errors.has('redeem_from_next_order'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('redeem_from_next_order'))+"\n                ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.addFreeProductAutomatically')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.add_free_product_auto),callback:function ($$v) {_vm.$set(_vm.model, "add_free_product_auto", $$v)},expression:"model.add_free_product_auto"}}),_vm._v(" "),(_vm.errors.has('add_free_product_auto'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('add_free_product_auto'))+"\n                ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.allowOnePointPerOrder')))]),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_one_point_per_order),callback:function ($$v) {_vm.$set(_vm.model, "allow_one_point_per_order", $$v)},expression:"model.allow_one_point_per_order"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":".jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize'))+_vm._s(_vm.$t('validations.imageResolution')))])]),_vm._v(" "),(_vm.errors.has('image'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('image'))+"\n                ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.description),expression:"modelValidations.description"},{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"5","name":"description","placeholder":_vm.$t('marketingPromos.descriptionPlaceholder')},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('description'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('description'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.notificationText')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.notification_text),expression:"model.notification_text"}],staticClass:"form-control",attrs:{"rows":"5","name":"notification_text","placeholder":_vm.$t('marketingPromos.notificationTextPlaceholder')},domProps:{"value":(_vm.model.notification_text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "notification_text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.location')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.locations,"value":"token","label":"name"},on:{"input":_vm.onLocationsInput},model:{value:(_vm.locations_formatted),callback:function ($$v) {_vm.locations_formatted=$$v},expression:"locations_formatted"}}),_vm._v(" "),(_vm.errors.has('location'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('location'))+"\n              ")]):_vm._e()],1),_vm._v(" "),(this.route.name != 'Edit Promo')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.code')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.qr_code),expression:"modelValidations.qr_code"},{name:"model",rawName:"v-model",value:(_vm.model.qr_code),expression:"model.qr_code"}],ref:"qrCode",staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.model.qr_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "qr_code", $event.target.value)}}}),_vm._v(" "),(_vm.errors.qr_code)?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('qr_code'))+"\n              ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-purple mar-to-10 mar-bt-10 generate-code",on:{"click":function($event){$event.preventDefault();_vm.generateCode()}}},[_vm._v(_vm._s(_vm.$t('marketingPromos.generateQrCode')))])]):_c('div',{staticClass:"col-md-12 pl-0 ml-15n"},[_c('div',[_c('img',{attrs:{"src":_vm.model.qr_code}})]),_vm._v(" "),_c('a',{staticClass:"btn btn-info btn-icon duplicate-prod ml-15 mar-to-10 mar-bt-10",attrs:{"download":"","href":this.model.qr_code,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('upload.download')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.to_order')))]),_vm._v(" "),_c('el-tree',{ref:"order",staticClass:"el-product-border filter-tree",attrs:{"data":_vm.toOrder,"props":_vm.treeConfig,"check-strictly":false,"filter-node-method":_vm.filterNode,"default-checked-keys":_vm.orderItems,"node-key":"id","show-checkbox":"","accordion":""},on:{"node-expand":_vm.loadProducts,"check-change":_vm.validateOrder}}),_vm._v(" "),_c('div',{staticClass:"buttons mar-to-5"},[_c('el-button',{on:{"click":function($event){_vm.checkAll()}}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.checkAll')))]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetProductTree()}}},[_vm._v(_vm._s(_vm.$t('general.reset')))])],1)],1),_vm._v(" "),(_vm.errorTree)?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.errorTree)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.to_receive')))]),_vm._v(" "),_c('el-tree',{ref:"receive",staticClass:"el-product-border filter-tree",attrs:{"data":_vm.toReceive,"props":_vm.treeConfig,"check-strictly":false,"filter-node-method":_vm.filterNodeReceive,"default-checked-keys":_vm.receiveItems,"node-key":"id","show-checkbox":"","accordion":""},on:{"node-expand":_vm.loadProductsReceive,"check-change":_vm.validateReceive}}),_vm._v(" "),_c('div',{staticClass:"buttons mar-to-5"},[_c('el-button',{on:{"click":function($event){_vm.checkAllReceive()}}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.checkAll')))]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetProductTreeReceive()}}},[_vm._v(_vm._s(_vm.$t('general.reset')))])],1)],1),_vm._v(" "),(_vm.errorTreeReceive)?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.errorTreeReceive)+"\n            ")]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.users.length || ['LOCATION_ADMIN', 'OWNER', 'MARKETER'].includes(_vm.userRole))?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search mar-bt-15",attrs:{"placeholder":_vm.$t('reports.search')},model:{value:(_vm.filters[0].value),callback:function ($$v) {_vm.$set(_vm.filters[0], "value", $$v)},expression:"filters[0].value"}})],1)]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.users,"search-def":_vm.defaultSearchDef(),"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDef,"table-props":{'border': false},"filters":_vm.filters}},[_c('el-table-column',{attrs:{"min-width":55,"sortable":"","prop":"firstname","label":_vm.$t('marketingPromos.firstname')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":55,"sortable":"","prop":"lastname","label":_vm.$t('marketingPromos.lastname')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":55,"sortable":"","prop":"email","label":_vm.$t('marketingPromos.email')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":25,"sortable":"","prop":"points","label":_vm.$t('marketingPromos.points')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.waiting_approval)?_c('input',{ref:props.row.id,staticClass:"form-control",attrs:{"type":"text","name":"title","placeholder":_vm.$t('marketingPromos.title'),"model":_vm.model.points},domProps:{"value":props.row.points}}):_vm._e(),_vm._v(" "),(!props.row.waiting_approval)?_c('div',[_vm._v(_vm._s(props.row.points))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":110},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.waiting_approval)?_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"btn btn-success btn-icon",attrs:{"type":"button","title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.handleApprove(0, props.row)}}},[_c('i',{staticClass:"ti-check"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon",attrs:{"type":"button","title":_vm.$t('general.cancel')},on:{"click":function($event){$event.preventDefault();_vm.handleApprove(1, props.row)}}},[_c('i',{staticClass:"ti-close"})])]):_vm._e()]}}])})],1)],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hqz5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HrqZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);











/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loadingProducts: false,
      selectedCategory: '',
      recipes: [],
      loadingRecipes: false,
      isGestionProduct: true,
      gestiuniStock: [],
      gestiuniStockHistoryDetails: [],
      stockByGestiune: {},
      name: '',
      validityValue: null,
      description: '',
      type: '',
      umProduct: 'BUC',
      currencyProduct: 'RON',
      code: '',
      productName: '',
      productDescription: '',
      productType: '',
      um: 'buc',
      price: '',
      currency: '',
      codeProduct: '',
      companyID: '',
      product: {},
      gestiunePrices: {},
      vats: [],
      cotaTva: '',
      id: '',
      validityUnit: 'ore',
      isEditing: false,
      editingProduct: null,
      modelValidate: {
        productName: { required: true },
        productType: { required: true },
        productDescription: { required: true },
        productNameRecipe: { required: true },
        name: { required: true },
        description: { required: true },
        um: { required: true }
      },
      validityTerm: 0,
      scazamantValue: 0,
      scazamantType: 'valoare',
      productNameRecipe: '',
      downloadMethod: 'bon_productie',
      productTypeRecipe: '',
      codeProductRecipe: '',
      umRecipe: '',
      quantityRecipe: 0,

      tableData: [],
      locations: [],
      gestiuniList: [],
      searchResults: [],
      groupedLocationsData: [],
      cantitateRezultata: '',
      gestionData: [{ gestionType: 'Magazin', quantity: 10, price: 50, currency: 'RON', minStock: 5 }, { gestionType: 'Depozit', quantity: 15, price: 100, currency: 'EUR', minStock: 3 }],
      editForm: {
        price: '',
        currency: 'RON',
        minStock: ''
      },
      is_external: false,
      isProductSelected: false,
      mesurementsUnits: [],
      productId: null,
      highlightRowId: null,
      loadingStockDetails: false
    };
  },

  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    var _this = this;

    var posId = this.route.params.id;
    var vatNumberProduct = this.route.params.vatNumber;
    if (!posId || !vatNumberProduct) {
      console.error('Missing product ID');
      return;
    }

    this.productId = posId;
    this.companyID = this.$session.get('selectedCompany');

    this.loadMesurementsUnits();
    this.fetchLocation();
    this.fetchGestiuni();

    this.getProductDetails(posId, vatNumberProduct).then(function () {
      if (_this.is_external === 1) {
        __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
          title: 'Atenție',
          text: 'Acest produs este gestionat din Taptasty. Modificările făcute acolo vor fi reflectate automat și în acest nomenclator.',
          type: 'warning'
        });
      }

      _this.fetchProductRecipes();
      _this.fetchStockDetails();
      _this.fetchStockHistoryDetails();

      _this.$nextTick(function () {
        var highlightId = _this.route.query.highlight;
        console.log('Highlight ID from query:', highlightId);

        if (highlightId) {
          _this.highlightRowId = highlightId;

          _this.$nextTick(function () {
            _this.scrollToRecipeTable();
          });
        }
      });
    });
  },

  watch: {
    vats: function vats(newVats) {
      var _this2 = this;

      if (newVats && newVats.length > 0 && this.product && this.product.vat_percent != null) {
        var vat = newVats.find(function (v) {
          return parseFloat(v.amount) === parseFloat(_this2.product.vat_percent);
        });
        this.cotaTva = vat ? vat.amount.toString() : '';
      }
    },
    type: function type(newVal) {
      if (newVal === 'Semifabricate (Reteta)') {
        this.umProduct = 'BUC';
      }
    }
  },
  computed: {
    hasRecipe: function hasRecipe() {
      return this.product && this.product.reteta && this.product.reteta.items && this.product.reteta.items.length > 0;
    },
    isRecipeProduct: function isRecipeProduct() {
      return this.product && this.productType && this.productType.includes('Reteta');
    },
    filteredProductTypes: function filteredProductTypes() {
      var types = [{ value: 'Marfa', label: 'Marfa', externalOnly: false }, { value: 'Materii prime', label: 'Materii prime', externalOnly: true }, { value: 'Materiale consumabile', label: 'Materiale consumabile', externalOnly: true }, { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)', externalOnly: true }, { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)', externalOnly: false }, { value: 'Produs rezidual', label: 'Produs rezidual', externalOnly: true }, { value: 'Ambalaje', label: 'Ambalaje', externalOnly: true }, { value: 'Obiecte de inventar', label: 'Obiecte de inventar', externalOnly: true }];

      if (this.is_external === 1) {
        return types.filter(function (type) {
          return !type.externalOnly;
        });
      } else {
        return types;
      }
    },
    limitedCategories: function limitedCategories() {
      return [{ value: 'Materii prime', label: 'Materii prime' }, { value: 'Marfa', label: 'Marfa' }, { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' }, { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' }, { value: 'Ambalaje', label: 'Ambalaje' }, { value: 'Materiale consumabile', label: 'Materiale consumabile' }];
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this3 = this;

      if (!this.route || !this.route.params || !this.route.params.vatNumber) return [];

      return this.gestiuniList.filter(function (g) {
        return g.vatNumber === _this3.route.params.vatNumber && (g.categorie === 'Produs finit (Reteta)' || g.categorie === 'Marfa');
      });
    },
    gestiuniStockFiltered: function gestiuniStockFiltered() {
      return this.gestiuniStock.filter(function (g) {
        return g.loading || g.stock && g.stock.length;
      });
    }
  },
  methods: {
    blockCommaKey: function blockCommaKey(event) {
      if (event.key === ',' || event.key === 'Comma') {
        event.preventDefault();
      }
    },
    sanitizeQuantityRecipe: function sanitizeQuantityRecipe(event) {
      var value = event.target.value.replace(/,/g, '.');
      if (value !== event.target.value) {
        this.quantityRecipe = value;
      }
    },
    scrollToRecipeTable: function scrollToRecipeTable() {
      var _this4 = this;

      this.$nextTick(function () {
        var comp = _this4.$refs.recipeTable;
        if (!comp) return;

        var el = comp.$el || comp;
        var rect = el.getBoundingClientRect();

        var scrollContainer = el.parentElement;
        while (scrollContainer && scrollContainer !== document.body) {
          var style = window.getComputedStyle(scrollContainer);
          if (style.overflow === 'auto' || style.overflow === 'scroll' || style.overflowY === 'auto' || style.overflowY === 'scroll') {
            break;
          }
          scrollContainer = scrollContainer.parentElement;
        }

        if (scrollContainer && scrollContainer !== document.body) {
          var containerRect = scrollContainer.getBoundingClientRect();
          var relativeTop = rect.top - containerRect.top + scrollContainer.scrollTop - 200;

          scrollContainer.scrollTo({
            top: relativeTop,
            behavior: 'smooth'
          });
        } else {
          window.scrollTo({
            top: window.scrollY + rect.top - 200,
            behavior: 'smooth'
          });
        }
      });
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row;

      if (this.highlightRowId && (row.posId === this.highlightRowId || row.posId === this.highlightRowId)) {
        return 'highlight-row';
      }
      return '';
    },
    resetSelectedProduct: function resetSelectedProduct() {
      this.isProductSelected = false;
      this.posId = null;
      this.productNameRecipe = '';
      this.codeProductRecipe = '';
      this.umRecipe = '';
      this.searchResults = [];
    },
    getLocationName: function getLocationName(externalLocationId) {
      if (!this.locations || !externalLocationId) return '';

      var location = this.locations.find(function (loc) {
        return loc.true_id === externalLocationId;
      });

      return location ? location.name : '';
    },
    onCategoryChange: function onCategoryChange() {
      this.resetSelectedProduct();
    },
    loadMesurementsUnits: function loadMesurementsUnits() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this5.getMesurementsUnits();

              case 2:
                _this5.mesurementsUnits = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    fetchLocation: function fetchLocation() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dataToSend = {
                  company_id: _this6.companyID,
                  token: _this6.$session.get('token')
                };


                _this6.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this6.locations = response.data.locations;

                  var groups = {};
                  _this6.locations.forEach(function (location) {
                    var vat = location.inv_fiscal_code || 'Fără cod fiscal';
                    if (!groups[vat]) groups[vat] = [];
                    groups[vat].push(location);
                  });

                  _this6.groupedLocationsData = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref2) {
                    var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
                        vat = _ref3[0],
                        locations = _ref3[1];

                    return { vat: vat, locations: locations };
                  });

                  console.log('Fetched locations:', _this6.locations);
                  console.log('Grouped locations:', _this6.groupedLocationsData);
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    fetchProductRecipes: function fetchProductRecipes() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url, response, data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this7.loadingRecipes = true;

                _context3.prev = 1;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/retete/by-product/' + _this7.productId + ('?externalCompanyId=' + encodeURIComponent(_this7.companyID));
                _context3.next = 5;
                return fetch(url);

              case 5:
                response = _context3.sent;
                _context3.next = 8;
                return response.json();

              case 8:
                data = _context3.sent;

                if (data) {
                  _context3.next = 12;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare!',
                  text: 'Eroare la preluarea rețetelor.',
                  type: 'error',
                  timer: 3000,
                  showConfirmButton: false
                });
                return _context3.abrupt('return');

              case 12:

                _this7.recipes = data.retete || [];

                console.log('Recipes found:', _this7.recipes);
                _context3.next = 20;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](1);

                console.error('Error fetching recipes:', _context3.t0);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare!',
                  text: 'Eroare la server.',
                  type: 'error',
                  timer: 3000,
                  showConfirmButton: false
                });

              case 20:
                _context3.prev = 20;

                _this7.loadingRecipes = false;
                return _context3.finish(20);

              case 23:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[1, 16, 20, 23]]);
      }))();
    },
    fetchStockDetails: function fetchStockDetails() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var requests;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this8.loadingStockDetails = true;

                _context5.prev = 1;

                if (_this8.gestiuniList.length) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt('return');

              case 4:

                _this8.gestiuniStock = _this8.gestiuniList.map(function (g) {
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, g, {
                    loading: true,
                    stock: [],
                    product: null,
                    date: null
                  });
                });

                requests = _this8.gestiuniList.map(function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee4(g, index) {
                    var url, res, data, stockItem;
                    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.prev = 0;
                            url = "https://fiscal-dev.cdntaptasty.com" + ':4443/stock' + ('?gestiune=' + encodeURIComponent(g._id)) + ('&product_ids=' + encodeURIComponent(_this8.productId)) + ('&vatNumber=' + encodeURIComponent(_this8.route.params.vatNumber)) + ('&externalCompanyId=' + encodeURIComponent(_this8.companyID));
                            _context4.next = 4;
                            return fetch(url);

                          case 4:
                            res = _context4.sent;
                            _context4.next = 7;
                            return res.json();

                          case 7:
                            data = _context4.sent;
                            stockItem = data.stock && data.stock.length ? data.stock[0] : null;


                            _this8.$set(_this8.gestiuniStock, index, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, g, {
                              loading: false,
                              stock: data.stock || [],
                              product: stockItem.productDetails || null,
                              quantity: stockItem.quantity || 0,
                              value: stockItem.value || 0,
                              average_price: stockItem.average_price || 0,
                              date: data.date || null
                            }));
                            _context4.next = 15;
                            break;

                          case 12:
                            _context4.prev = 12;
                            _context4.t0 = _context4['catch'](0);

                            _this8.$set(_this8.gestiuniStock, index, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, g, {
                              loading: false,
                              stock: [],
                              product: null,
                              quantity: 0,
                              value: 0,
                              average_price: 0,
                              date: null
                            }));

                          case 15:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this8, [[0, 12]]);
                  }));

                  return function (_x, _x2) {
                    return _ref4.apply(this, arguments);
                  };
                }());
                _context5.next = 8;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(requests);

              case 8:
                _context5.next = 14;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](1);

                console.error(_context5.t0);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare!',
                  text: 'Eroare server',
                  type: 'error',
                  timer: 3000,
                  showConfirmButton: false
                });

              case 14:
                _context5.prev = 14;

                _this8.loadingStockDetails = false;
                return _context5.finish(14);

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[1, 10, 14, 17]]);
      }))();
    },
    getFirstProductHistory: function getFirstProductHistory(gestiune) {
      if (!gestiune.products || !gestiune.products.length) return [];
      var firstProduct = gestiune.products[0];
      return (firstProduct.history || []).slice(0, 5);
    },
    getDocumentLabel: function getDocumentLabel(h) {
      if (typeof h.document === 'string') return h.document;
      if (h.document && h.document.type) return h.document.type.toUpperCase();
      return h.document_type || '-';
    },
    getDocumentBadgeClass: function getDocumentBadgeClass(docType) {
      var map = {
        'STOCK_INITIAL': 'badge-info',
        'BON_CONSUM': 'badge-danger',
        'NIR': 'badge-success',
        'TRANSFER': 'badge-warning',
        'INVENTAR': 'badge-primary',
        'AJUSTARE': 'badge-default'
      };
      return map[docType] || 'badge-default';
    },
    getProductStockInfo: function getProductStockInfo(g) {
      if (!g.products || !g.products.length) return '-';
      var prod = g.products[0];
      var qty = prod.quantity !== undefined ? this.formatNumber(prod.quantity) : '-';
      var um = this.um || 'buc';
      return 'Stoc: ' + qty + ' ' + um;
    },
    formatDocumentType: function formatDocumentType(docType) {
      if (!docType) return '-';

      return docType.replace(/_/g, ' ');
    },
    getDocumentNumber: function getDocumentNumber(h) {
      if (!h.document) return null;
      if (typeof h.document === 'string') return null;

      var numar = h.document.numar_document || h.document.nirNumber || h.document.number || '';
      var serie = h.document.series || '';

      if (numar && serie) return serie + ' / ' + numar;
      if (numar) return numar;
      if (serie) return serie;
      return null;
    },
    fetchStockHistoryDetails: function fetchStockHistoryDetails() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var end, start, startISO, endISO, requests;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this9.loadingStockDetails = true;

                _context7.prev = 1;

                if (_this9.gestiuniList.length) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt('return');

              case 4:
                end = new Date();
                start = new Date();

                start.setDate(start.getDate() - 7);

                startISO = start.toISOString();
                endISO = end.toISOString();

                _this9.gestiuniStockHistoryDetails = _this9.gestiuniList.map(function (g) {
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, g, {
                    loading: true,
                    products: [],
                    total: 0,
                    currentPage: 1,
                    pageSize: 20
                  });
                });

                requests = _this9.gestiuniList.map(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee6(g, index) {
                    var url, res, data;
                    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.prev = 0;
                            url = "https://fiscal-dev.cdntaptasty.com" + ':4443/stock_history_advanced_v2' + ('?externalCompanyId=' + encodeURIComponent(_this9.companyID)) + ('&product_id=' + encodeURIComponent(_this9.productId)) + ('&startDate=' + encodeURIComponent(startISO)) + ('&endDate=' + encodeURIComponent(endISO));


                            if (g._id) {
                              url += '&gestiune=' + encodeURIComponent(g._id);
                            }

                            if (g.externalLocationId) {
                              url += '&externalLocationId=' + encodeURIComponent(g.externalLocationId);
                            }

                            _context6.next = 6;
                            return fetch(url);

                          case 6:
                            res = _context6.sent;
                            _context6.next = 9;
                            return res.json();

                          case 9:
                            data = _context6.sent;


                            console.log('Stock history for gestiune ' + g.name + ':', data);

                            _this9.$set(_this9.gestiuniStockHistoryDetails, index, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, g, {
                              loading: false,

                              products: data.products || [],
                              total: data.total || 0,
                              currentPage: data.currentPage || 1,
                              pageSize: data.pageSize || 20,
                              gestiune: data.gestiune || g._id
                            }));
                            _context6.next = 18;
                            break;

                          case 14:
                            _context6.prev = 14;
                            _context6.t0 = _context6['catch'](0);

                            console.error('Eroare gestiune ' + g.name + ':', _context6.t0);
                            _this9.$set(_this9.gestiuniStockHistoryDetails, index, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, g, {
                              loading: false,
                              products: [],
                              total: 0,
                              currentPage: 1,
                              pageSize: 20
                            }));

                          case 18:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this9, [[0, 14]]);
                  }));

                  return function (_x3, _x4) {
                    return _ref5.apply(this, arguments);
                  };
                }());
                _context7.next = 13;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(requests);

              case 13:
                _context7.next = 19;
                break;

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7['catch'](1);

                console.error(_context7.t0);
                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare!',
                  text: 'Eroare server',
                  type: 'error',
                  timer: 3000,
                  showConfirmButton: false
                });

              case 19:
                _context7.prev = 19;

                _this9.loadingStockDetails = false;
                return _context7.finish(19);

              case 22:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[1, 15, 19, 22]]);
      }))();
    },
    goToDocument: function goToDocument(entry) {
      try {
        if (!entry || !entry.document_type) {
          return false;
        }

        var type = entry.document_type;
        var doc = entry.document || {};

        var id = entry.document_id || doc._id;

        if (!id) {
          return false;
        }

        if (type === 'NIR') {
          if (!doc.nirNumber) return false;

          return this.$router.push({
            path: '/management/entries/edit/' + id,
            query: {
              nirNumber: doc.nirNumber,
              data_document: doc.data_document,
              vatNumberFurnizor: doc.vatNumberFurnizor,
              series: doc.series
            }
          });
        }

        if (type === 'BON_TRANSFER') {
          if (!doc.series || !doc.documentNumber) return false;

          return this.$router.push({
            path: '/management/transfer/edit/' + doc.series + '/' + doc.documentNumber
          });
        }

        if (type === 'BON_PRODUCTIE') {
          if (!doc.series || !doc.documentNumber) return false;

          return this.$router.push({
            path: '/management/bon-product/edit/' + doc.series + '/' + doc.documentNumber
          });
        }

        if (type === 'BON_FISCAL') {
          if (!doc._id) return false;

          return this.$router.push({
            name: 'ManagementBonFiscalView',
            params: { id: doc._id }
          });
        }

        if (type === 'AVIZ') {
          if (!doc.series || !doc.invoiceNumber) return false;

          var invoiceId = doc.series + '-' + doc.invoiceNumber;

          return this.$router.push({
            path: '/management/outputs/' + invoiceId,
            query: { edit: 'true' }
          });
        }

        if (type === 'BON_CASARE') {
          if (!doc.series || !doc.documentNumber) return false;

          return this.$router.push({
            path: '/management/wasted/edit/' + doc.series + '/' + doc.documentNumber
          });
        }

        if (type === 'BON_CONSUM') {
          if (!doc.series || !doc.documentNumber) return false;

          return this.$router.push({
            path: '/management/stocks/edit/' + doc.series + '/' + doc.documentNumber
          });
        }

        return false;
      } catch (error) {
        return false;
      }
    },
    goToProduced: function goToProduced(entry) {
      if (!entry || !entry.document || !entry.document.produced_posId) return;

      var producedId = entry.document.produced_posId;
      var vatNumber = entry.document.company && entry.document.company.vatNumber ? entry.document.company.vatNumber : '';

      this.$router.push({
        path: '/management/nomenclator-products/edit/' + producedId + '/' + vatNumber,
        query: {
          highlight: entry.item && entry.item.product_id ? entry.item.product_id : entry.document.produced_posId
        }
      });
    },
    goToProduct: function goToProduct(row) {
      console.log('row', row);
      var id = row.recipe.parentPosId;
      var vatNumber = this.route.params.vatNumber;

      this.$router.push('/management/nomenclator-products/edit/' + id + '/' + vatNumber);
    },
    validate: function validate() {
      var _this10 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this10.saveProduct();
        }
      });
    },
    openEditModal: function openEditModal() {
      this.$modal.show('editGestionModal');
    },
    closeEditModal: function closeEditModal() {
      this.$modal.hide('editGestionModal');
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var categorieParam, allCategories, vatNumberParam, response, data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(!searchTerm || searchTerm.length < 2)) {
                  _context8.next = 3;
                  break;
                }

                _this11.searchResults = [];
                return _context8.abrupt('return');

              case 3:

                _this11.loadingProducts = true;
                _context8.prev = 4;
                categorieParam = '';


                if (_this11.selectedCategory) {
                  categorieParam = '&categorie=' + encodeURIComponent(_this11.selectedCategory);
                } else {
                  allCategories = _this11.limitedCategories.map(function (c) {
                    return c.value;
                  }).join(',');

                  categorieParam = '&categorie=' + encodeURIComponent(allCategories);
                }

                vatNumberParam = _this11.route.params.vatNumber ? '&vatNumber=' + encodeURIComponent(_this11.route.params.vatNumber) : '';
                _context8.next = 10;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/products?externalCompanyId=' + _this11.companyID + '&name=' + encodeURIComponent(searchTerm) + categorieParam + vatNumberParam);

              case 10:
                response = _context8.sent;
                _context8.next = 13;
                return response.json();

              case 13:
                data = _context8.sent;


                if (Array.isArray(data.products)) {
                  _this11.searchResults = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(data.products), [{ id: 'add', name: '➕ Adaugă produs' }]);
                } else {
                  _this11.searchResults = [{ id: 'add', name: '➕ Adaugă produs' }];
                }
                _context8.next = 21;
                break;

              case 17:
                _context8.prev = 17;
                _context8.t0 = _context8['catch'](4);

                console.error('Error fetching products:', _context8.t0);
                _this11.searchResults = [{ id: 'add', name: '➕ Adaugă produs' }];

              case 21:
                _context8.prev = 21;

                _this11.loadingProducts = false;
                return _context8.finish(21);

              case 24:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[4, 17, 21, 24]]);
      }))();
    },
    loadVats: function loadVats(locationId) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this12.fetchVats(locationId);

              case 2:
                _this12.vats = _context9.sent;

                console.log(_this12.vats);

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },
    formatNumber: function formatNumber(value) {
      if (value === null || value === undefined || value === '') {
        return 0;
      }

      return parseFloat(Number(value).toFixed(4));
    },
    copyProduct: function copyProduct() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var vatOptionsHtml, selectedVat, confirm, selectEl, targetGroup, response, errJson, confirmOverwrite, errText, data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                console.log('Initiating product copy...', _this13.product);

                if (_this13.codeProduct) {
                  _context10.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('Eroare', 'Nu există cod de produs pentru copiere!', 'error');
                return _context10.abrupt('return');

              case 4:
                vatOptionsHtml = '\n        <select id="swal-vat-select" class="form-control">\n          <option value="">Selecteaz\u0103 loca\u021Bia dup\u0103 VAT</option>\n          ' + _this13.groupedLocationsData.map(function (group) {
                  var disabled = group.vat === _this13.product.vatNumber ? 'disabled' : '';
                  return '<option value="' + group.vat + '" ' + disabled + '>\n                VAT: ' + group.vat + ' \u2014 ' + group.locations.map(function (l) {
                    return l.name;
                  }).join(', ') + '\n              </option>';
                }).join('') + '\n        </select>\n      ';
                _context10.prev = 5;
                selectedVat = null;
                _context10.prev = 7;
                _context10.next = 10;
                return __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Alege locația pentru copiere',
                  html: vatOptionsHtml,
                  type: 'info',
                  showCancelButton: true,
                  confirmButtonText: 'Copiază',
                  cancelButtonText: 'Renunță'
                });

              case 10:
                confirm = _context10.sent;

                if (confirm) {
                  _context10.next = 13;
                  break;
                }

                return _context10.abrupt('return');

              case 13:
                selectEl = document.getElementById('swal-vat-select');

                selectedVat = selectEl ? selectEl.value : null;
                _context10.next = 22;
                break;

              case 17:
                _context10.prev = 17;
                _context10.t0 = _context10['catch'](7);

                if (!(_context10.t0 === 'cancel')) {
                  _context10.next = 21;
                  break;
                }

                return _context10.abrupt('return');

              case 21:
                throw _context10.t0;

              case 22:
                if (selectedVat) {
                  _context10.next = 25;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('Atenție', 'Trebuie să selectezi o locație!', 'warning');
                return _context10.abrupt('return');

              case 25:
                targetGroup = _this13.groupedLocationsData.find(function (g) {
                  return g.vat === selectedVat;
                });

                if (!(!targetGroup || !targetGroup.locations.length)) {
                  _context10.next = 29;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('Eroare', 'Locația selectată nu este validă!', 'error');
                return _context10.abrupt('return');

              case 29:
                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  type: 'info',
                  title: 'Se copiază produsul...',
                  text: 'Așteptați câteva momente',
                  showConfirmButton: false,
                  allowOutsideClick: false
                });

                _context10.next = 32;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/products/copy', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    sourceExternalCompanyId: _this13.companyID,
                    targetExternalCompanyId: _this13.companyID,
                    product_code: _this13.product.product_code,
                    product_id: _this13.product._id,
                    sourceVatNumber: _this13.product.vatNumber,
                    targetVatNumber: selectedVat
                  })
                });

              case 32:
                response = _context10.sent;

                if (!(response.status === 409)) {
                  _context10.next = 62;
                  break;
                }

                errJson = {};
                _context10.prev = 35;
                _context10.next = 38;
                return response.json();

              case 38:
                errJson = _context10.sent;
                _context10.next = 43;
                break;

              case 41:
                _context10.prev = 41;
                _context10.t1 = _context10['catch'](35);

              case 43:
                confirmOverwrite = false;
                _context10.prev = 44;
                _context10.next = 47;
                return __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Produs deja existent',
                  text: errJson.error || 'Produsul există deja în locația selectată. Vrei să îl suprascrii?',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Da, suprascrie',
                  cancelButtonText: 'Nu'
                });

              case 47:
                confirmOverwrite = _context10.sent;
                _context10.next = 55;
                break;

              case 50:
                _context10.prev = 50;
                _context10.t2 = _context10['catch'](44);

                if (!(_context10.t2 === 'cancel')) {
                  _context10.next = 54;
                  break;
                }

                return _context10.abrupt('return');

              case 54:
                throw _context10.t2;

              case 55:
                if (confirmOverwrite) {
                  _context10.next = 58;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.close();
                return _context10.abrupt('return');

              case 58:

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Se suprascrie produsul...',
                  text: 'Așteptați câteva momente',
                  showConfirmButton: false,
                  allowOutsideClick: false
                });

                _context10.next = 61;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/products/copy', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    sourceExternalCompanyId: _this13.companyID,
                    targetExternalCompanyId: _this13.companyID,
                    product_code: _this13.product.product_code,
                    product_id: _this13.product._id,
                    sourceVatNumber: _this13.product.vatNumber,
                    targetVatNumber: selectedVat,
                    overwrite: 1
                  })
                });

              case 61:
                response = _context10.sent;

              case 62:
                if (response.ok) {
                  _context10.next = 67;
                  break;
                }

                _context10.next = 65;
                return response.text();

              case 65:
                errText = _context10.sent;
                throw new Error(errText);

              case 67:
                _context10.next = 69;
                return response.json();

              case 69:
                data = _context10.sent;

                console.log('Copy result:', data);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Produsul a fost copiat cu succes!',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });
                _context10.next = 80;
                break;

              case 74:
                _context10.prev = 74;
                _context10.t3 = _context10['catch'](5);

                if (!(_context10.t3 === 'cancel')) {
                  _context10.next = 78;
                  break;
                }

                return _context10.abrupt('return');

              case 78:
                console.error('Error copying product:', _context10.t3);
                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Nu s-a putut copia produsul: ' + _context10.t3.message,
                  type: 'error',
                  timer: 9000,
                  showConfirmButton: false
                });

              case 80:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this13, [[5, 74], [7, 17], [35, 41], [44, 50]]);
      }))();
    },
    getProductDetails: function getProductDetails(posId, vatNumberProduct) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  type: 'warning',
                  title: 'Se încarcă produsul...',
                  showConfirmButton: false,
                  allowOutsideClick: false
                });

                _context11.next = 4;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/nomenclator', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    posId: posId,
                    externalCompanyId: _this14.companyID,
                    vatNumber: vatNumberProduct
                  })
                });

              case 4:
                response = _context11.sent;

                if (response.ok) {
                  _context11.next = 7;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 7:
                _context11.next = 9;
                return response.json();

              case 9:
                data = _context11.sent;


                _this14.product = data;

                _this14.id = data._id || '';
                _this14.productName = data.name || '';
                _this14.productType = data.categorie || '';
                _this14.um = data.um || '';
                _this14.price = data.price ? data.price.toString() : '';
                _this14.currency = data.currency || '';
                _this14.codeProduct = data.product_code || '';
                _this14.is_external = data.is_external;
                _this14.externalId = data.externalId || '';
                _this14.validityValue = data.validity && data.validity.value ? data.validity.value : '';
                _this14.validityUnit = data.validity && data.validity.unit ? data.validity.unit : 'ore';
                _this14.posId = data.posId;

                if (data.prices && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data.prices) === 'object') {
                  _this14.gestiunePrices = {};
                  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(data.prices).forEach(function (_ref6) {
                    var _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
                        gestiuneId = _ref7[0],
                        price = _ref7[1];

                    _this14.$set(_this14.gestiunePrices, gestiuneId, price);
                  });
                }

                if (data.reteta && data.reteta.substract_using) {
                  _this14.downloadMethod = data.reteta.substract_using;
                } else {
                  _this14.downloadMethod = '';
                }

                if (_this14.hasRecipe && data.reteta && Array.isArray(data.reteta.items)) {
                  _this14.tableData = data.reteta.items.map(function (item) {
                    return {
                      posId: item.productDetails ? item.productDetails._id : item.posId,
                      productNameRecipe: item.productDetails ? item.productDetails.name : '',
                      productTypeRecipe: item.productDetails ? item.productDetails.categorie : '',
                      codeProductRecipe: item.productDetails ? item.productDetails.product_code : '',
                      umRecipe: item.um || '',
                      quantityRecipe: item.qty || 0,
                      scazamantValue: item.scazamantValue,
                      scazamantType: item.scazamantType
                    };
                  });

                  _this14.cantitateRezultata = data.reteta.cantitate_rezultata || '';
                } else {
                  _this14.tableData = [];
                }

                console.log(_this14.is_external);

                if (!(_this14.is_external !== 1)) {
                  _context11.next = 32;
                  break;
                }

                _context11.next = 30;
                return _this14.loadVats(data.externalLocationId);

              case 30:
                _context11.next = 33;
                break;

              case 32:
                _this14.cotaTva = data.vat_percent != null ? data.vat_percent.toString() : '';

              case 33:
                _context11.next = 38;
                break;

              case 35:
                _context11.prev = 35;
                _context11.t0 = _context11['catch'](0);

                console.error('Error fetching product details:', _context11.t0);

              case 38:
                _context11.prev = 38;

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.close();
                return _context11.finish(38);

              case 41:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this14, [[0, 35, 38, 41]]);
      }))();
    },
    saveRecipe: function saveRecipe() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var hasScazamantValue, newProduct, index;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(!_this15.productNameRecipe || !_this15.quantityRecipe)) {
                  _context12.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Completează câmpurile obligatorii: Denumire produs și Cantitate.',
                  type: 'error',
                  timer: 3000,
                  showConfirmButton: true
                });
                return _context12.abrupt('return');

              case 3:
                hasScazamantValue = _this15.scazamantValue !== '' && _this15.scazamantValue !== null && _this15.scazamantValue !== undefined && !isNaN(parseFloat(_this15.scazamantValue)) && parseFloat(_this15.scazamantValue) !== 0;

                if (!(hasScazamantValue && !_this15.scazamantType)) {
                  _context12.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Dacă completezi Scăzământ, trebuie să selectezi și tipul (valoare sau procent).',
                  type: 'error',
                  timer: 3000,
                  showConfirmButton: true
                });
                return _context12.abrupt('return');

              case 7:
                newProduct = {
                  posId: _this15.posId,
                  productNameRecipe: _this15.productNameRecipe,
                  productTypeRecipe: _this15.productTypeRecipe,
                  codeProductRecipe: _this15.codeProductRecipe,
                  umRecipe: _this15.umRecipe,
                  quantityRecipe: _this15.quantityRecipe,
                  scazamantValue: _this15.scazamantValue,
                  scazamantType: _this15.scazamantType
                };


                if (_this15.isEditing && _this15.editingProduct) {
                  index = _this15.tableData.findIndex(function (p) {
                    return p === _this15.editingProduct;
                  });

                  if (index !== -1) {
                    _this15.tableData.splice(index, 1, newProduct);
                  }
                } else {
                  _this15.tableData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this15.tableData), [newProduct]);
                }

                _context12.prev = 9;
                _context12.next = 12;
                return _this15.saveOrFetchRecipe();

              case 12:
                _context12.next = 17;
                break;

              case 14:
                _context12.prev = 14;
                _context12.t0 = _context12['catch'](9);

                console.error('Error while saving recipe:', _context12.t0);

              case 17:

                _this15.$modal.hide('addProductModal');
                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Rețeta a fost salvată cu succes.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 19:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this15, [[9, 14]]);
      }))();
    },
    saveOrFetchRecipe: function saveOrFetchRecipe() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var bodyData, response, data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  type: 'warning',
                  title: 'Se salveaza reteta...',
                  showConfirmButton: false,
                  allowOutsideClick: false
                });

                bodyData = {
                  parentPosId: _this16.id,
                  items: _this16.tableData.map(function (item) {
                    return {
                      name: item.productNameRecipe,
                      posId: item.posId,
                      qty: item.quantityRecipe,
                      um: item.umRecipe,
                      scazamantValue: item.scazamantValue,
                      scazamantType: item.scazamantType
                    };
                  }),
                  externalCompanyId: _this16.companyID
                };


                if (_this16.cantitateRezultata) {
                  bodyData.cantitate_rezultata = parseFloat(_this16.cantitateRezultata);
                }

                _context13.next = 6;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/reteta', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(bodyData)
                });

              case 6:
                response = _context13.sent;

                if (response.ok) {
                  _context13.next = 9;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 9:
                _context13.next = 11;
                return response.json();

              case 11:
                data = _context13.sent;

                console.log('Recipe updated:', data);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  icon: 'success',
                  title: 'Rețetă salvată!',
                  timer: 1500,
                  showConfirmButton: false
                });
                _context13.next = 20;
                break;

              case 16:
                _context13.prev = 16;
                _context13.t0 = _context13['catch'](0);

                console.error('Error updating recipe:', _context13.t0);
                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  icon: 'error',
                  title: 'Eroare la salvare!',
                  text: 'A apărut o problemă la salvarea rețetei.'
                });

              case 20:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this16, [[0, 16]]);
      }))();
    },
    formatDate: function formatDate(date) {
      if (!date) return '-';

      return new Date(date).toLocaleString('ro-RO');
    },
    saveProduct: function saveProduct() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var productData, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (_this17.um) {
                  _context14.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Te rugăm să selectezi unitatea de măsură (UM)!',
                  type: 'error',
                  showConfirmButton: true,
                  allowOutsideClick: false,
                  allowEscapeKey: false
                });
                return _context14.abrupt('return');

              case 3:
                _context14.prev = 3;

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  type: 'warning',
                  title: 'Se salveaza produsul...',
                  showConfirmButton: false,
                  allowOutsideClick: false
                });

                productData = {
                  name: _this17.productName,
                  product_code: _this17.codeProduct,

                  is_with_vat: true,
                  vat_percent: parseInt(_this17.cotaTva),
                  currency: _this17.currency,
                  um: _this17.um,
                  externalId: _this17.externalId || '',
                  externalCompanyId: _this17.companyID,
                  vatNumber: _this17.route.params.vatNumber,
                  is_external: _this17.is_external,
                  categorie: _this17.productType,
                  validity: _this17.validityValue ? {
                    value: _this17.validityValue,
                    unit: _this17.validityUnit
                  } : null,
                  prices: _this17.gestiunePrices
                };


                if (_this17.productId) {
                  productData.posId = _this17.productId;
                }

                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/nomenclator';
                _context14.next = 10;
                return fetch(url, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(productData)
                });

              case 10:
                response = _context14.sent;

                if (response.ok) {
                  _context14.next = 13;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 13:
                _context14.next = 15;
                return response.json();

              case 15:
                data = _context14.sent;

                console.log('Product saved successfully:', data);

                if (!_this17.cantitateRezultata) {
                  _context14.next = 20;
                  break;
                }

                _context14.next = 20;
                return _this17.saveOrFetchRecipe();

              case 20:

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Produsul a fost salvat cu succes.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this17.$bus.$emit('refresh');
                _this17.$bus.$emit('close-modal');
                _context14.next = 29;
                break;

              case 25:
                _context14.prev = 25;
                _context14.t0 = _context14['catch'](3);

                console.error('Error saving product:', _context14.t0);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error',
                  text: 'There was an error saving the product.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 29:
                _context14.prev = 29;

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.close();
                return _context14.finish(29);

              case 32:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this17, [[3, 25, 29, 32]]);
      }))();
    },
    addProduct: function addProduct() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var vatNumberProduct, productData, response, data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(!_this18.name || !_this18.code || !_this18.type)) {
                  _context15.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Toate câmpurile obligatorii trebuie completate!',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context15.abrupt('return');

              case 3:
                vatNumberProduct = _this18.route.params.vatNumber;
                productData = {
                  name: _this18.name,
                  product_code: _this18.code,
                  price: parseFloat(_this18.priceProduct),
                  is_with_vat: true,
                  vat_percent: parseInt(_this18.cotaTva),
                  currency: _this18.currencyProduct,
                  um: _this18.umProduct,
                  externalId: '',
                  externalCompanyId: _this18.companyID,
                  is_external: 0,
                  vatNumber: vatNumberProduct,
                  categorie: _this18.type,
                  pret_vanzare: []
                };
                _context15.prev = 5;
                _context15.next = 8;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/nomenclator', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(productData)
                });

              case 8:
                response = _context15.sent;
                _context15.next = 11;
                return response.json();

              case 11:
                data = _context15.sent;

                if (response.ok) {
                  _context15.next = 15;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare',
                  text: data.details || 'A apărut o eroare la salvarea produsului.',
                  type: 'error',
                  timer: 4000,
                  showConfirmButton: false
                });
                return _context15.abrupt('return');

              case 15:
                _context15.next = 17;
                return _this18.fetchProducts();

              case 17:
                _this18.searchResults.push(data);

                _this18.productNameRecipe = data;
                _this18.codeProductRecipe = data.product_code;
                _this18.umRecipe = data.um;
                _this18.posId = data._id;

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Produsul a fost salvat cu succes.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this18.$modal.hide('addProduct');
                _this18.resetFields();
                _context15.next = 31;
                break;

              case 27:
                _context15.prev = 27;
                _context15.t0 = _context15['catch'](5);

                console.error('Error saving product:', _context15.t0);
                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o eroare la salvarea produsului.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 31:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this18, [[5, 27]]);
      }))();
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this19.companyID);

              case 3:
                response = _context16.sent;
                _context16.next = 6;
                return response.json();

              case 6:
                data = _context16.sent;


                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this19.gestiuniList = data.gestiuni;
                } else {
                  __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                    title: 'Error!',
                    text: 'Nu s-a primit un array valid de la server.',
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context16.next = 14;
                break;

              case 10:
                _context16.prev = 10;
                _context16.t0 = _context16['catch'](0);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error!',
                  text: 'Request failed: ' + _context16.t0.message,
                  icon: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching management data:', _context16.t0);

              case 14:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this19, [[0, 10]]);
      }))();
    },
    resetFields: function resetFields() {
      this.name = '';
      this.description = '';
      this.code = '';
    },
    onProductSelect: function onProductSelect(selectedProduct) {
      if (selectedProduct && selectedProduct.id === 'add') {
        this.addProductModal();
        return;
      }

      if (selectedProduct && selectedProduct._id) {
        this.posId = selectedProduct._id;
        this.productNameRecipe = selectedProduct.name || '';
        this.productTypeRecipe = selectedProduct.categorie || '';
        this.codeProductRecipe = selectedProduct.product_code || '';
        this.umRecipe = selectedProduct.um || '';
        this.isProductSelected = true;
      } else {
        this.isProductSelected = false;
      }
    },
    handleDelete: function handleDelete() {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee18() {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (_this20.id) {
                  _context18.next = 3;
                  break;
                }

                console.error('Missing product ID for deletion.');
                return _context18.abrupt('return');

              case 3:

                try {
                  __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                    title: 'Ești sigur că vrei să ștergi acest produs?',
                    text: 'Această acțiune nu poate fi anulată!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Da, șterge-l!',
                    cancelButtonText: 'Anulează'
                  }).then(function () {
                    var _ref8 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee17(result) {
                      var response, data;
                      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
                        while (1) {
                          switch (_context17.prev = _context17.next) {
                            case 0:
                              if (result) {
                                _context17.next = 2;
                                break;
                              }

                              return _context17.abrupt('return');

                            case 2:

                              __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                                type: 'warning',
                                title: 'Ștergere...',
                                text: 'Se șterge produsul. Așteaptă...',
                                allowOutsideClick: false,
                                showConfirmButton: false
                              });

                              _context17.next = 5;
                              return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                                method: 'DELETE',
                                headers: { 'Content-Type': 'application/json' },
                                body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                  type: 'product',
                                  id: _this20.id,
                                  posId: _this20.id,
                                  externalCompanyId: _this20.companyID
                                })
                              });

                            case 5:
                              response = _context17.sent;
                              _context17.next = 8;
                              return response.json();

                            case 8:
                              data = _context17.sent;

                              if (response.ok) {
                                _context17.next = 16;
                                break;
                              }

                              if (!(response.status === 409 && data.error)) {
                                _context17.next = 15;
                                break;
                              }

                              __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                                title: 'Eroare',
                                text: data.error + '\nID: ' + (data.taptasty_ray_id || ''),
                                type: 'error',
                                showConfirmButton: true });
                              return _context17.abrupt('return');

                            case 15:
                              throw new Error('HTTP error! Status: ' + response.status);

                            case 16:

                              __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.close();

                              __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                                title: 'Succes',
                                text: 'Produsul a fost șters cu succes.',
                                type: 'success',
                                timer: 2000,
                                showConfirmButton: false
                              });

                              _this20.$bus.$emit('refresh');
                              _this20.$bus.$emit('close-modal');

                            case 20:
                            case 'end':
                              return _context17.stop();
                          }
                        }
                      }, _callee17, _this20);
                    }));

                    return function (_x5) {
                      return _ref8.apply(this, arguments);
                    };
                  }());
                } catch (error) {
                  __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.close();
                  console.error('Error deleting product:', error);

                  __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                    title: 'Eroare',
                    text: error.message || 'A apărut o eroare la ștergerea produsului.',
                    type: 'error',
                    showConfirmButton: true });
                }

              case 4:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this20);
      }))();
    },
    backButton: function backButton() {

      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    deleteRow: function deleteRow(row) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var index, removed;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                index = _this21.tableData.findIndex(function (item) {
                  return item === row;
                });

                if (!(index === -1)) {
                  _context19.next = 4;
                  break;
                }

                console.error('Item not found in tableData');
                return _context19.abrupt('return');

              case 4:
                removed = _this21.tableData.splice(index, 1)[0];
                _context19.prev = 5;
                _context19.next = 8;
                return _this21.saveOrFetchRecipe();

              case 8:

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Rețeta a fost ștearsă cu succes!',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });
                _context19.next = 16;
                break;

              case 11:
                _context19.prev = 11;
                _context19.t0 = _context19['catch'](5);

                _this21.tableData.splice(index, 0, removed);

                console.error('Error updating recipe:', _context19.t0);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o eroare la ștergerea rețetei.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 16:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this21, [[5, 11]]);
      }))();
    },
    addProductModal: function addProductModal() {
      this.$modal.show('addProduct');
    },
    closeProduct: function closeProduct() {
      this.$modal.hide('addProduct');
    },
    openAddProductModal: function openAddProductModal() {
      var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (product && product.posId) {
        this.isEditing = true;
        this.editingProduct = product;

        this.posId = product.posId || '';
        this.productNameRecipe = product.productNameRecipe || '';
        this.selectedCategory = product.productTypeRecipe || '';
        this.codeProductRecipe = product.codeProductRecipe || '';
        this.umRecipe = product.umRecipe || '';
        this.quantityRecipe = product.quantityRecipe || '';
        this.scazamantValue = product.scazamantValue || '';
        this.scazamantType = product.scazamantType || '';
        this.searchResults = [product];
      } else {
        this.isEditing = false;
        this.editingProduct = null;

        this.productNameRecipe = null;
        this.searchResults = [];
        this.codeProductRecipe = '';
        this.umRecipe = '';
        this.quantityRecipe = '';
        this.scazamantValue = 0;
        this.posId = null;
        this.selectedCategory = '';
        this.scazamantValue = '';
        this.scazamantType = '';
      }

      this.$modal.show('addProductModal');
    },
    closeModal: function closeModal() {
      this.productNameRecipe = null;
      this.codeProductRecipe = '';
      this.umRecipe = '';
      this.quantityRecipe = '';

      this.$modal.hide('addProductModal');
    }
  }
});

/***/ }),

/***/ "Hrxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  created: function created() {
    this.locations = this.$session.get('selectedCompanyData').locations_details || [];
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      tableData: [],
      search: '',
      searchId: '',
      selectedLocations: [],
      locations: []
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {

      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/pos/map/');
      }
    },
    goToAdd: function goToAdd() {
      this.$router.push('/pos/map/add');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.searchId) {
        data.id = this.searchId;
      }
      if (this.search) {
        data.search = this.search;
      }
      if (Array.isArray(this.selectedLocations) && this.selectedLocations.length) {
        data.location_ids = this.selectedLocations;
      }

      this.apiRequest('/pos/all/map', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data.table_maps;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    searchMaps: function searchMaps() {
      this.getData();
    },
    handleDelete: function handleDelete(item) {
      var _this2 = this;

      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        text: this.$t('addOrder.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            id: item,
            token: _this2.$session.get('token'),
            company_id: _this2.$session.get('selectedCompany')
          };
          _this2.apiRequest('/pos/map/' + item, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this2.$t('general.success'), 'success');
              _this2.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : _this2.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function (err) {
        if (err) {}
      });
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.disableConfirmButton();
      var yes = this.$t('general.yes');
      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          if (__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton().textContent = yes + ' (' + btnCounter + ')';
          }
        } else {
          if (__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton().textContent = yes;
          }
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    }
  }
});

/***/ }),

/***/ "HthW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs",attrs:{"direction":"vertical","value":"Description"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('newsletterCard.titleNews')}},[(_vm.isTitleNews)?_c('News',{attrs:{"isTitleNews":_vm.isTitleNews,"hasAlert":_vm.hasNewFiles}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('newsletterCard.titleMonthlyInfo')}},[(_vm.isTitleMonthlyInfo)?_c('MonthlyInfo',{attrs:{"isTitleMonthlyInfo":_vm.isTitleMonthlyInfo}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('newsletterCard.titleVideoSupport')}},[(_vm.isTitleVideoSupport)?_c('VideoSupport',{attrs:{"isTitleVideoSupport":_vm.isTitleVideoSupport}}):_vm._e()],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HuGI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      customersRoutes: [{ path: '/customers', key: 'customers' }, { path: '/groups', key: 'customersGroups' }, { path: '/approvals', key: 'approvals' }]
    };
  },

  methods: {
    getImageForRoute: function getImageForRoute(routeKey) {
      var images = {
        'customers': 'static/img/customers.png',
        'customersGroups': 'static/img/groups.png',
        'approvals': 'static/img/groups.png'
      };
      return images[routeKey] || 'static/img/default.jpg';
    },
    getBoxColor: function getBoxColor(index) {
      var colors = ['#3AB7CD', '#674BD2', '#674BD2'];
      return colors[index] || '#FFFFFF';
    }
  }
});

/***/ }),

/***/ "Hwfw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])]),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('subscription-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HxCe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CouponPage_vue__ = __webpack_require__("SS9M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0810a73f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CouponPage_vue__ = __webpack_require__("f/HY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CouponPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0810a73f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CouponPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HySc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsDeliveryType_vue__ = __webpack_require__("OTo0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9d64838_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsDeliveryType_vue__ = __webpack_require__("3f2I");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsDeliveryType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9d64838_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsDeliveryType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hz/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_BOLT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEFAULT_BOLT_SECRET_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEFAULT_BOLT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DEFAULT_BOLT_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_BOLT_MENU_LANGUAGE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultBoltSchedule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Integrations_integrationLocationHelpers_js__ = __webpack_require__("fX4L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__ = __webpack_require__("3z7E");









var DEFAULT_BOLT_API_URL = 'https://node.bolt.eu/delivery-provider-pos/genericClient';
var DEFAULT_BOLT_SECRET_KEY = 'DRyMxJVUjn9HCHeY5UeHU3Ly';
var DEFAULT_BOLT_USER = 'BoltProd';
var DEFAULT_BOLT_PASSWORD = '}N31Y4-Q^wu0Q:$J';
var DEFAULT_BOLT_MENU_LANGUAGE = 'ro-RO';

function defaultBoltSchedule() {
  var day = {
    open: true,
    intervals: [{
      start_at_minutes_from_midnight: '10:00',
      stop_at_minutes_from_midnight: '22:00'
    }]
  };
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()({ length: 7 }, function () {
    return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(day));
  });
}

/* harmony default export */ __webpack_exports__["g"] = ({
  name: 'BoltIntegrationForm',
  props: {
    formData: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    requiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    validationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showFieldValidation: {
      type: Boolean,
      default: false
    },
    topCategories: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {
    this.ensureSchedule();
    this.ensureBooleanDefaults();
    this.ensureDefaults();
  },

  methods: {
    fieldLabel: function fieldLabel(field) {
      if (typeof this.fieldLabelFn === 'function') return this.fieldLabelFn(field);
      return field;
    },
    isRequired: function isRequired(field) {
      return (this.requiredFields || []).includes(field);
    },
    hasFieldError: function hasFieldError(field) {
      return Boolean(this.validationErrors && this.validationErrors[field]);
    },
    showFieldError: function showFieldError(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["a" /* hasIntegrationFieldError */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData
      });
    },
    fieldErrorMessage: function fieldErrorMessage(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["b" /* getIntegrationFieldErrorMessage */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData,
        requiredMessage: this.$t('validations.requiredField')
      });
    },
    locationOptionValue: function locationOptionValue(loc) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Integrations_integrationLocationHelpers_js__["b" /* integrationLocationOptionValue */])(loc);
    },
    ensureSchedule: function ensureSchedule() {
      if (!Array.isArray(this.formData.schedule) || !this.formData.schedule.length) {
        this.$set(this.formData, 'schedule', defaultBoltSchedule());
      }
    },
    ensureBooleanDefaults: function ensureBooleanDefaults() {
      var _this = this;

      var boolFields = ['active', 'has_own_delivery', 'is_auto_accept'];
      boolFields.forEach(function (f) {
        if (_this.formData[f] === undefined || _this.formData[f] === null || _this.formData[f] === '') {
          _this.$set(_this.formData, f, false);
        } else {
          _this.$set(_this.formData, f, Boolean(_this.formData[f]));
        }
      });
    },
    ensureDefaults: function ensureDefaults() {
      var _this2 = this;

      var defaults = {
        api_url: DEFAULT_BOLT_API_URL,
        secret_key: DEFAULT_BOLT_SECRET_KEY,
        user: DEFAULT_BOLT_USER,
        password: DEFAULT_BOLT_PASSWORD,
        menu_language: DEFAULT_BOLT_MENU_LANGUAGE
      };
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(defaults).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        var current = _this2.formData[key];
        if (current === undefined || current === null || String(current).trim() === '') {
          _this2.$set(_this2.formData, key, value);
        }
      });
      if (this.formData.emails === undefined || this.formData.emails === null) {
        this.$set(this.formData, 'emails', '');
      }
    }
  }
});

/***/ }),

/***/ "I0/X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.topProductsReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[(_vm.showLocations)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.products')))]),_vm._v(" "),_c('el-select',{ref:"productSelect",staticStyle:{"width":"100%"},attrs:{"value-key":"id","multiple":"","filterable":"","remote":"","collapse-tags":"","reserve-keyword":"","label":"label","placeholder":_vm.$t('reports.searchProducts'),"remote-method":_vm.searchProducts,"loading":_vm.loadingProducts},on:{"change":_vm.clearSearch},model:{value:(_vm.selectedProducts),callback:function ($$v) {_vm.selectedProducts=$$v},expression:"selectedProducts"}},_vm._l((_vm.mergedProducts),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item}})}))],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('chart-bars-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"topProductSales",attrs:{"chart-data":_vm.topProductSales.data,"chart-options":_vm.topProductSales.options}},[(_vm.noData)?[_c('div',{staticClass:"no-data-message",staticStyle:{"text-align":"center","margin":"20px"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('reports.noDataAvailable')))])])]:_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend",staticStyle:{"display":"flex","flex-wrap":"wrap"}},_vm._l((_vm.legendItems),function(item){return _c('div',{key:item.product,staticClass:"legend-item"},[_c('div',{staticClass:"legend-color-box",style:({ backgroundColor: item.sales.color })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.sales.label))]),_vm._v(" "),_c('div',{staticClass:"legend-color-box",style:({ backgroundColor: item.discount.color })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.discount.label))])])}))])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"search-def":{show: false},"total":_vm.ordersTableData.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"product_name","label":_vm.$t('reports.product')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"total_quantity","label":_vm.$t('reports.quantity')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(Number(props.row.total_quantity))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"total_sales","label":_vm.$t('reports.revenue')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_sales)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"total_discount","label":_vm.$t('reports.discount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_discount)))+"\n            ")]}}])})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I0te":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r5_vue__ = __webpack_require__("JQdg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d6c1d2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r5_vue__ = __webpack_require__("xKX6");
function injectStyle (ssrContext) {
  __webpack_require__("1Drb")
  __webpack_require__("uMna")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d6c1d2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r5_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d6c1d2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r5_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I2DY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs",attrs:{"direction":"vertical","value":"Description"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.tableMaps')}},[(_vm.isTableMaps)?_c('pos-map-list',{attrs:{"isTableMaps":_vm.isTableMaps}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.pos')}},[(_vm.isFirst)?_c('pos-list',{attrs:{"isFirst":_vm.isFirst}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.posScreen')}},[(_vm.isPosScreen)?_c('pos-screen'):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('dispath.users')}},[(_vm.isUser)?_c('pos-settings-users',{attrs:{"isUser":_vm.isUser}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":"Cantar"}},[(_vm.isCantar)?_c('cantar-list',{attrs:{"isCantar":_vm.isCantar}}):_vm._e()],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I3/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"})])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.$route.params.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteOrderScreen($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":"ID"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.firstname')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.firstname),expression:"modelValidate.firstname"},{name:"model",rawName:"v-model",value:(_vm.model.firstname),expression:"model.firstname"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Firstname"},domProps:{"value":(_vm.model.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.lastname')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.lastname),expression:"modelValidate.lastname"},{name:"model",rawName:"v-model",value:(_vm.model.lastname),expression:"model.lastname"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Lastname"},domProps:{"value":(_vm.model.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.email')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.email),expression:"modelValidate.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group pos-user-location-group",class:{'has-error': _vm.errors.has('location_details')}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.location')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%","color":"#fff"},attrs:{"multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},on:{"change":_vm.onLocationDetailsChange},model:{value:(_vm.model.location_details),callback:function ($$v) {_vm.$set(_vm.model, "location_details", $$v)},expression:"model.location_details"}},_vm._l((_vm.locations),function(item){return _c('el-option',{key:item.id,attrs:{"value":item.id,"label":item.name}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.login_code')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.login_code),expression:"modelValidate.login_code"},{name:"model",rawName:"v-model",value:(_vm.model.login_code),expression:"model.login_code"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Login Code"},domProps:{"value":(_vm.model.login_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "login_code", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('login_code'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.$t('settingTable.login_code_already_used'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_maps')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-select',{key:"methods",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"methods","multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.model.allow_maps),callback:function ($$v) {_vm.$set(_vm.model, "allow_maps", $$v)},expression:"model.allow_maps"}},[_c('el-option',{key:0,attrs:{"value":null,"label":_vm.$t('general.all'),"disabled":""}}),_vm._v(" "),_vm._l((_vm.tableMaps),function(item){return [_c('el-option',{attrs:{"value":item.id,"label":item.name}})]})],2)],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"height":"100%","width":"100%","margin":"0","display":"flex","flex-direction":"column","flex-wrap":"nowrap","justify-content":"center"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingLocationGroups.active')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}})],1),_vm._v(" "),_c('div',[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.is_manager')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.is_manager),callback:function ($$v) {_vm.is_manager=$$v},expression:"is_manager"}})],1),_vm._v(" "),_c('div',{staticClass:"isManagerBox"},[(_vm.is_manager)?_c('div',{staticClass:"managerBox"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_advanced_settings')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_advanced_settings),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_advanced_settings", $$v)},expression:"model.pos_allow_advanced_settings"}}),_vm._v(" "),_c('small',{staticClass:"text-muted",staticStyle:{"display":"block"}},[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_advanced_settings_info')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_access_reports')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_access_reports),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_access_reports", $$v)},expression:"model.pos_allow_access_reports"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_reports')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_reports),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_reports", $$v)},expression:"model.pos_allow_reports"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_approvals')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_approvals),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_approvals", $$v)},expression:"model.pos_allow_approvals"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_discount')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_discount),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_discount", $$v)},expression:"model.pos_allow_discount"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_storno')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_storno),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_storno", $$v)},expression:"model.pos_allow_storno"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_refund')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_refund),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_refund", $$v)},expression:"model.pos_allow_refund"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_access_all_tables')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_access_all_tables),callback:function ($$v) {_vm.$set(_vm.model, "allow_access_all_tables", $$v)},expression:"model.allow_access_all_tables"}})],1),_vm._v(" "),_c('div',[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_transfer')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.allow_transfer),callback:function ($$v) {_vm.allow_transfer=$$v},expression:"allow_transfer"}})],1),_vm._v(" "),_c('div',{staticClass:"isManagerBox"},[(_vm.allow_transfer)?_c('div',{staticClass:"managerBox"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_waiter_transfer')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_waiter_transfer),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_waiter_transfer", $$v)},expression:"model.pos_allow_waiter_transfer"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_table_transfer')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_table_transfer),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_table_transfer", $$v)},expression:"model.pos_allow_table_transfer"}})],1)]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_order_change_status')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_order_change_status),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_order_change_status", $$v)},expression:"model.pos_allow_order_change_status"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.table_for_one_user')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.table_for_one_user),callback:function ($$v) {_vm.$set(_vm.model, "table_for_one_user", $$v)},expression:"model.table_for_one_user"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_mobile_pos')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_mobile_pos),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_mobile_pos", $$v)},expression:"model.pos_allow_mobile_pos"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_plata_moderna')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_plata_moderna),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_plata_moderna", $$v)},expression:"model.pos_allow_plata_moderna"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_protocol')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_protocol),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_protocol", $$v)},expression:"model.pos_allow_protocol"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_glovo')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_glovo),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_glovo", $$v)},expression:"model.pos_allow_glovo"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_bolt')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_bolt),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_bolt", $$v)},expression:"model.pos_allow_bolt"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_wolt')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_wolt),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_wolt", $$v)},expression:"model.pos_allow_wolt"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_tips')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_tips),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_tips", $$v)},expression:"model.pos_allow_tips"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_disable_cancel_order')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_disable_cancel_order),callback:function ($$v) {_vm.$set(_vm.model, "pos_disable_cancel_order", $$v)},expression:"model.pos_disable_cancel_order"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_close_order_without_receipt')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_close_order_without_receipt),callback:function ($$v) {_vm.$set(_vm.model, "allow_close_order_without_receipt", $$v)},expression:"model.allow_close_order_without_receipt"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_bank_transfer')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_bank_transfer),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_bank_transfer", $$v)},expression:"model.pos_allow_bank_transfer"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_staff_food')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_staff_food),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_staff_food", $$v)},expression:"model.pos_allow_staff_food"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_some_top_categories')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_some_top_categories),callback:function ($$v) {_vm.$set(_vm.model, "allow_some_top_categories", $$v)},expression:"model.allow_some_top_categories"}}),_vm._v(" "),(_vm.model.allow_some_top_categories)?_c('div',{staticClass:"form-group"},[_c('el-select',{key:"methods",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"methods","multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.model.allowed_top_categories),callback:function ($$v) {_vm.$set(_vm.model, "allowed_top_categories", $$v)},expression:"model.allowed_top_categories"}},[_c('el-option',{key:0,attrs:{"value":null,"label":_vm.$t('general.none'),"disabled":""}}),_vm._v(" "),_vm._l((_vm.topCategories),function(item){return [_c('el-option',{attrs:{"value":item.id,"label":item.name}})]})],2)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_filter_status_orders ')))]),_vm._v(" "),_c('el-select',{key:"methods",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"methods","multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.model.pos_filter_status_orders ),callback:function ($$v) {_vm.$set(_vm.model, "pos_filter_status_orders", $$v)},expression:"model.pos_filter_status_orders "}},[_c('el-option',{key:0,attrs:{"value":null,"label":_vm.$t('general.none'),"disabled":""}}),_vm._v(" "),_vm._l((_vm.allStatusesForFilterOrders),function(item){return [_c('el-option',{attrs:{"value":item.name,"label":item.name}})]})],2)],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4nB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I6xf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isMeasurementsUnits },on:{"click":function($event){_vm.openTab('measurementsUnits')}}},[_vm._v("\n            "+_vm._s(_vm.$t('settingsPages.measurementsUnits'))+"\n          ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isTableZones },on:{"click":function($event){_vm.openTab('tableZones')}}},[_vm._v("\n            "+_vm._s(_vm.$t('settingsPages.tableZones'))+"\n          ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isTableManager },on:{"click":function($event){_vm.openTab('tableManager')}}},[_vm._v("\n            "+_vm._s(_vm.$t('settingsPages.tableManager'))+"\n          ")])])])])]),_vm._v(" "),(_vm.isApp)?_c('div',[_c('app-form',{attrs:{"modeldata":_vm.model,"defaultData":_vm.defaultData}})],1):_vm._e(),_vm._v(" "),(_vm.isCompanyWeb)?_c('div',[_c('company-web-form',{attrs:{"modeldata":_vm.websiteData}})],1):_vm._e(),_vm._v(" "),(_vm.isMeasurementsUnits)?_c('div',[(_vm.selectedMeasurementsUnits !== false)?[_c('measurements-units-form',{attrs:{"callback":_vm.measurementsUnitsUpdate,"zoneId":_vm.selectedMeasurementsUnits},on:{"on-submit":_vm.onUserSubmit}})]:[_c('measurements-units-list',{ref:"tableMeasurementsUnits",attrs:{"isTable":_vm.isMeasurementsUnits,"callback":_vm.getMeasurementsUnits}})]],2):_vm._e(),_vm._v(" "),(_vm.isTableZones)?_c('div',[(_vm.selectedZone !== false)?[_c('table-zone-form',{attrs:{"callback":_vm.tableZoneUpdate,"zoneId":_vm.selectedZone},on:{"on-submit":_vm.onUserSubmit}})]:[_c('table-zone-list',{ref:"tableZone",attrs:{"isTable":_vm.isTableZones,"callback":_vm.getZone}})]],2):_vm._e(),_vm._v(" "),(_vm.isTableManager)?_c('div',[(_vm.selectedTable !== false)?[_c('table-management-form',{attrs:{"callback":_vm.tableManagementUpdate,"tableId":_vm.selectedTable,"posUsers":_vm.formattedUsers},on:{"on-submit":_vm.onUserSubmit}})]:[_c('table-management-list',{ref:"tableManagement",attrs:{"isTable":_vm.isTableManager,"callback":_vm.getTable,"posUsers":_vm.formattedUsers}})]],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I7+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();_vm.handleDelete('delete this product')}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":_vm.validate}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),(_vm.model && _vm.model.allowed_location)?_c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',{staticClass:"row pad-to-15"},[(_vm.errors.has('error'))?_c('div',{staticClass:"col-md-12 "},[_c('div',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.getError('error'))+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.errors.items.length)?_c('div',{staticClass:"col-md-12 "},[_c('div',{staticClass:"alert alert-danger alert-custom-danger"},[_vm._v(_vm._s(_vm.$t('catalogProd.errorOptions')))])]):_vm._e(),_vm._v(" "),(_vm.nullProductOptionValues)?_c('div',{staticClass:"col-md-12 "},[_c('div',{staticClass:"alert alert-danger alert-custom-danger"},[_vm._v(_vm._s(_vm.$t('catalogProd.productOptionError')))])]):_vm._e(),_vm._v(" "),(_vm.hasProductOptionsWithoutCompanyOptions)?_c('div',{staticClass:"col-md-12 "},[_c('div',{staticClass:"alert alert-danger alert-custom-danger"},[_vm._v(_vm._s(_vm.$t('catalogProd.couldNotFetchProductOptions')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"company-details",attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10 space-between",staticStyle:{"padding":"0px 20px"}},[_c('a',{staticClass:"btn btn-fill btn-primary",class:[{ active: _vm.currentSection === 'description', errorT: _vm.invalidTabs.includes('description') }],on:{"click":function($event){$event.preventDefault();_vm.openSection('description')}}},[_vm._v(_vm._s(_vm.$t('catalogProd.prod_desc')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:[{ active: _vm.currentSection === 'general', errorT: _vm.invalidTabs.includes('general') }],on:{"click":function($event){$event.preventDefault();_vm.openSection('general')}}},[_vm._v(_vm._s(_vm.$t('catalogProd.prod_general')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:[{ active: _vm.currentSection === 'price', errorT: _vm.invalidTabs.includes('price') }],on:{"click":function($event){$event.preventDefault();_vm.openSection('price')}}},[_vm._v(_vm._s(_vm.$t('catalogProd.prod_price')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:[{ active: _vm.currentSection === 'location', errorT: _vm.invalidTabs.includes('location') }],on:{"click":function($event){$event.preventDefault();_vm.openSection('location')}}},[_vm._v(_vm._s(_vm.$t('catalogProd.prod_loc')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:[{ active: _vm.currentSection === 'options', errorT: _vm.invalidTabs.includes('options') }],on:{"click":function($event){$event.preventDefault();_vm.openSection('options')}}},[_vm._v(_vm._s(_vm.$t('catalogProd.prod_opt')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:[{ active: _vm.currentSection === 'marketing', errorT: _vm.invalidTabs.includes('marketing') }],on:{"click":function($event){$event.preventDefault();_vm.openSection('marketing')}}},[_vm._v(_vm._s(_vm.$t('catalogProd.prod_mark')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:[{ active: _vm.currentSection === 'label', errorT: _vm.invalidTabs.includes('label') }],on:{"click":function($event){$event.preventDefault();_vm.openSection('label')}}},[_vm._v(_vm._s(_vm.$t('catalogProd.prod_lab')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:[{ active: _vm.currentSection === 'settings', errorT: _vm.invalidTabs.includes('settings') }],on:{"click":function($event){$event.preventDefault();_vm.openSection('settings')}}},[_vm._v(_vm._s(_vm.$t('catalogProd.prod_set')))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'description'),expression:"currentSection === 'description'"}],attrs:{"id":"description"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10 space-between",staticStyle:{"padding":"0px 20px"}},[_c('a',{staticClass:"btn btn-fill btn-primary",class:[{ active: _vm.currentSubSection === 'l1', errorT: _vm.invalidTabs.includes('l1') }],on:{"click":function($event){$event.preventDefault();_vm.openSubSection('l1')}}},[_vm._v(_vm._s(_vm.language))]),_vm._v(" "),_vm._l((_vm.languages),function(lang){return [_c('a',{staticClass:"btn btn-fill btn-primary",class:[{ active: _vm.currentSubSection === lang.id + '-' +lang.short, errorT: _vm.invalidTabs.includes(lang.id + '-' +lang.short) }],on:{"click":function($event){$event.preventDefault();_vm.openSubSection(lang.id + '-' +lang.short)}}},[_vm._v(_vm._s(lang.short))])]})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSubSection === 'l1'),expression:"currentSubSection === 'l1'"}],staticClass:"card-container",attrs:{"id":"l1"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogProd.name'),"data-vv-scope":"description"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('name'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.desc')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"name":"description","rows":"8"},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.description.invalid),expression:"description.invalid"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('description'))+"\n                    ")])])])])])]),_vm._v(" "),_vm._l((_vm.model.localized_fields),function(lang){return [_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSubSection === lang.language_id + '-' +lang.language_short ),expression:"currentSubSection === lang.language_id + '-' +lang.language_short "}],staticClass:"card-container",attrs:{"id":lang.language_id + '-' +lang.language_short}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(lang.name),expression:"lang.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogProd.name'),"data-vv-scope":"description"},domProps:{"value":(lang.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(lang, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('name'))+"\n                      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.desc')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(lang.description),expression:"lang.description"}],staticClass:"form-control",attrs:{"name":"description","rows":"8"},domProps:{"value":(lang.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(lang, "description", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.description.invalid),expression:"description.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('description'))+"\n                      ")])])])])])])]}),_vm._v(" "),_c('div',{staticClass:"card-container"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"pad-to-10"},[_vm._v("Info")]),_vm._v(" "),_c('div',{staticStyle:{"background":"#fff"}},[_c('wysiwyg',{model:{value:(_vm.model.prod_info),callback:function ($$v) {_vm.$set(_vm.model, "prod_info", $$v)},expression:"model.prod_info"}})],1)])])])])])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'general'),expression:"currentSection === 'general'"}],staticClass:"card-container",attrs:{"id":"general"}},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.image_size')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.image_size),expression:"model.image_size"}],ref:"image_size",staticClass:"form-control",attrs:{"name":"image_size","data-vv-as":"image_size"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "image_size", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:"cover",attrs:{"value":"cover","label":"Cover"}}),_vm._v(" "),_c('option',{key:"contain",attrs:{"value":"contain","label":"Contain"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.imageMore')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":5,"multiple":"","file-list":_vm.model.moreimagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleMoreImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleMoreRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1),_vm._v(" "),(!_vm.isNew())?[_c('div',{staticClass:"form-group"},[(_vm.model.video)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-info btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.goToLink(_vm.model.video, '_blank')}}},[_vm._v(_vm._s(_vm.$t('catalogProd.video')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-danger btn-icon",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.removeVideo(_vm.model.id)}}},[_vm._v("Remove video")])])]):[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.video')))]),_vm._v(" "),(!_vm.model.video)?_c('input',{ref:"video",attrs:{"type":"file"},on:{"change":_vm.handleVideoChange}}):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.video_thumbnail')))]),_vm._v(" "),_c('el-upload',{ref:"upload_video_thumbnail",attrs:{"action":"","limit":2,"file-list":_vm.model.video_thumbnail,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleVideoThumbChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleVideoThumbRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.status')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.active),expression:"model.active"}],staticClass:"form-control",attrs:{"name":"active"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":true}},[_vm._v(_vm._s(_vm.$t('general.active')))]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v(_vm._s(_vm.$t('general.inactive')))])]),_vm._v(" "),(_vm.errors.has('status'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('status'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.category')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.category_id),expression:"model.category_id"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.category_id),expression:"modelValidations.category_id"}],ref:"category_id",staticClass:"form-control",attrs:{"name":"category_id","data-vv-as":"category","data-vv-scope":"general"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.mainCategories),function(option){return _c('option',{key:option.id,attrs:{"label":option.name},domProps:{"value":option.id}})})),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.category_id.invalid),expression:"category_id.invalid"}],staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('category_id'))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-12"},[_vm._v(_vm._s(_vm.$t('catalogProd.secondaryCategory')))]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","options":_vm.mainCategoriesForSecondaryCategories,"label":"name"},on:{"change":_vm.filterSecondaryCategories},model:{value:(_vm.model.secondary_categories),callback:function ($$v) {_vm.$set(_vm.model, "secondary_categories", $$v)},expression:"model.secondary_categories"}})],1)]),_vm._v(" "),(_vm.kdsSectionsParent.length)?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.section')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.kds_section_id || {}),expression:"modelValidations.kds_section_id || {}"},{name:"model",rawName:"v-model",value:(_vm.model.kds_section_id),expression:"model.kds_section_id"}],staticClass:"form-control",attrs:{"name":"type","data-vv-scope":"general"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "kds_section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"label":_vm.$t('general.select')},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.kdsSectionsParent),function(section){return _c('option',{key:section.id,attrs:{"label":section.name},domProps:{"value":section.id}})})],2),_vm._v(" "),(_vm.errors.has('kds_section_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('kds_section_id'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{'has-error': _vm.coursesTypeHasError}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.coursesType')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.courses_type),expression:"modelValidations.courses_type"},{name:"model",rawName:"v-model.number",value:(_vm.model.courses_type),expression:"model.courses_type",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":_vm.coursesTypeMax,"name":"courses_type","data-vv-scope":"general"},domProps:{"value":(_vm.model.courses_type)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "courses_type", _vm._n($event.target.value))},_vm.validateCoursesType],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.coursesTypeHasError)?_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.coursesTypeErrorMessage)+"\n                    ")]):_vm._e()])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.preparation_time_in_minutes')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preparationTimeInMinutes),expression:"preparationTimeInMinutes"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"1","name":"preparation_time_in_minutes","placeholder":_vm.$t('catalogProd.preparation_time_in_minutes')},domProps:{"value":(_vm.preparationTimeInMinutes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.preparationTimeInMinutes=$event.target.value}}}),_vm._v(" "),(_vm.categoryPreparationTimeInMinutes !== null)?_c('small',{staticClass:"text-muted"},[_vm._v("\n                    "+_vm._s(_vm.$t('catalogProd.category_preparation_time_hint', { minutes: _vm.categoryPreparationTimeInMinutes }))+"\n                  ")]):_vm._e()])],2)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'price'),expression:"currentSection === 'price'"}],staticClass:"card-container",attrs:{"id":"price","data-vv-scope":"price"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.price'))+" ("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.price),expression:"modelValidations.price"},{name:"model",rawName:"v-model",value:(_vm.model.price),expression:"model.price"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"price","placeholder":_vm.$t('catalogProd.price'),"data-vv-scope":"price"},domProps:{"value":(_vm.model.price)},on:{"change":_vm.handlePriceChange,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "price", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.price.invalid),expression:"price.invalid"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('price'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.measurements_units_id')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.measurements_units_id),expression:"model.measurements_units_id"}],ref:"measurements_units_id",staticClass:"select-primary form-control",attrs:{"name":"measurements_units_id","data-vv-scope":"price"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "measurements_units_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.measurementsUnits),function(mu){return _c('option',{staticClass:"select-primary",domProps:{"value":mu.id}},[_vm._v(_vm._s(mu.name)+"\n                        ")])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.quantitative_unit')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.quantitative_unit),expression:"modelValidations.quantitative_unit"},{name:"model",rawName:"v-model",value:(_vm.model.quantitative_unit),expression:"model.quantitative_unit"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"quantitative_unit","placeholder":_vm.$t('settingCompany.quantitative_unit'),"data-vv-scope":"price"},domProps:{"value":(_vm.model.quantitative_unit)},on:{"change":_vm.handlePriceChange,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "quantitative_unit", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.minQuantity')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.min_quantity),expression:"model.min_quantity"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"min_quantity","placeholder":"3"},domProps:{"value":(_vm.model.min_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "min_quantity", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"help-block"},[_vm._v(" "+_vm._s(_vm.$t('general.contactSuportFeature'))+" ")])])])])])])]),_vm._v(" "),(0)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_vm._l((_vm.pricesFor),function(pf){return [_c('div',{staticClass:"col-md-12",style:(( (pf.id != 1 && pf.id <= 3) || (_vm.model.price_list && _vm.model.price_list[pf.id].price)) ? '' : '')},[(_vm.model.price_list && _vm.model.price_list[pf.id])?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('pricesFor.' + pf.id))+" ("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.price_list[pf.id].price),expression:"model.price_list[pf.id].price"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"price","placeholder":_vm.$t('catalogProd.price')},domProps:{"value":(_vm.model.price_list[pf.id].price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.price_list[pf.id], "price", $event.target.value)}}})]):_vm._e()])]})],2)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.usePriceToShow')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.use_price_to_show),callback:function ($$v) {_vm.$set(_vm.model, "use_price_to_show", $$v)},expression:"model.use_price_to_show"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.model.use_price_to_show)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.priceToShow'))+" ("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.price_to_show),expression:"modelValidations.price_to_show"},{name:"model",rawName:"v-model",value:(_vm.model.price_to_show),expression:"model.price_to_show"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"price","placeholder":_vm.$t('catalogProd.price'),"data-vv-scope":"price"},domProps:{"value":(_vm.model.price_to_show)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "price_to_show", $event.target.value)}}})]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.useDiscountPrice')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleDiscountedPrice($event)}},model:{value:(_vm.model.is_discounted),callback:function ($$v) {_vm.$set(_vm.model, "is_discounted", $$v)},expression:"model.is_discounted"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.validFromTo')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","disabled":!_vm.model.is_discounted,"format":"yyyy-MM-dd","value-format":"yyyy-MM-dd"},on:{"change":function($event){_vm.handleDateChange($event)}},model:{value:(_vm.model.discountPeriod),callback:function ($$v) {_vm.$set(_vm.model, "discountPeriod", $$v)},expression:"model.discountPeriod"}}),_vm._v(" "),(_vm.errors.has('date_from'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('date_from'))+"\n                  ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.newPrice'))+"("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.new_price),expression:"model.new_price"},{name:"validate",rawName:"v-validate",value:(_vm.model.is_discounted ? {required: true,  min_value: 0, max_value: _vm.model.old_price - 0.1} : ''),expression:"model.is_discounted ? {required: true,  min_value: 0, max_value: model.old_price - 0.1} : ''"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"new_price","placeholder":_vm.$t('catalogProd.newPrice'),"disabled":!_vm.model.is_discounted,"data-vv-scope":"price"},domProps:{"value":(_vm.model.new_price)},on:{"change":_vm.handleNewPriceChange,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "new_price", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('new_price'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('new_price'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.oldPrice'))+"("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.old_price),expression:"model.old_price"},{name:"validate",rawName:"v-validate",value:(_vm.model.is_discounted ? _vm.modelValidations.old_price : ''),expression:"model.is_discounted ? modelValidations.old_price : ''"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"old_price","placeholder":_vm.$t('catalogProd.oldPrice'),"disabled":"","data-vv-scope":"price"},domProps:{"value":(_vm.model.old_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "old_price", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('old_price'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('old_price'))+"\n                  ")]):_vm._e()])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'location'),expression:"currentSection === 'location'"}],staticClass:"card-container",attrs:{"id":"location"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[(_vm.userRole !== 'LOCATION_ADMIN' || _vm.userRole !== 'LOCATION_STORE_ADMIN')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{attrs:{"direction":"horizontal","type":"tabs"}},[_c('h6',[_vm._v(_vm._s(_vm.$t('catalogProd.locationSettings')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})])]),_vm._v(" "),(_vm.showLocations)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-12"},[_vm._v(_vm._s(_vm.$t('catalogProd.availableIn')))]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","options":_vm.locations,"label":"name","placeholder":_vm.$t('general.all')},on:{"input":function($event){_vm.checkLocations(_vm.model)}},model:{value:(_vm.model.location_ids),callback:function ($$v) {_vm.$set(_vm.model, "location_ids", $$v)},expression:"model.location_ids"}})],1),_vm._v(" "),(_vm.errors.has('location_ids'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                              "+_vm._s(_vm.getError('location_ids'))+"\n                            ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group product-override-group"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('catalogProd.deliveryMethodsandHours')))])]),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.updateDeliverySettings()}}},[_c('p-checkbox',{attrs:{"value":true},on:{"input":function($event){_vm.handleChangeOverrideDelivery()}},model:{value:(_vm.model.override_delivery),callback:function ($$v) {_vm.$set(_vm.model, "override_delivery", $$v)},expression:"model.override_delivery"}},[_vm._v(_vm._s(_vm.$t('catalogProd.overrideSettings')))]),_vm._v(" "),(_vm.model.override_delivery && (_vm.errors.has('isCheckedDay') || _vm.errors.has('isCheckedDeliveryMethod')))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                              "+_vm._s(_vm.$t('validations.chooseLocationAndDeliveryMethod'))+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.model.override_delivery && _vm.errors.has('intervalError'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                              "+_vm._s(_vm.$t('validations.timeInterval'))+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.overrideDeliveryErrors.length)?_c('div',_vm._l((_vm.overrideDeliveryErrors),function(err,idx){return _c('small',{key:idx,staticClass:"text-danger d-block"},[_vm._v(_vm._s(err))])})):_vm._e()],1),_vm._v(" "),(_vm.model.override_delivery)?_c('el-collapse',{staticClass:"product-override-collapse",attrs:{"accordion":""}},_vm._l((_vm.model.override_settings),function(loc,locId){return _c('el-collapse-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showThisLocation(loc.loc_id)),expression:"showThisLocation(loc.loc_id)"}],key:'override-' + loc.loc_id + '-' + locId,attrs:{"title":_vm.overrideLocationTitle(loc.loc_id),"name":String(loc.loc_id)}},[_c('hr',{staticClass:"sm"}),_vm._v(" "),_vm._l((loc.delivery),function(orderInterval,orderIntervalId){return [_c('div',{key:'dm-' + locId + '-' + orderIntervalId,staticClass:"col-md-12"},[_c('h4',[_vm._v("\n                                    "+_vm._s(_vm.$t('settingCompany.' + _vm.deliveryMethodLabel(orderInterval, orderIntervalId)))+"\n                                    "),_c('button',{staticClass:"btn btn-success btn-sm",on:{"click":function($event){$event.preventDefault();_vm.addNewOverrideInterval(locId, orderIntervalId, _vm.deliveryMethodLabel(orderInterval, orderIntervalId))}}},[_vm._v("+")])]),_vm._v(" "),_vm._l((orderInterval),function(order,orderId){return [_c('div',{key:'interval-' + locId + '-' + orderIntervalId + '-' + orderId,staticClass:"col-md-12"},[_c('p-checkbox',{attrs:{"value":_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']},on:{"input":function($event){_vm.handleChangeIsCheckedDeliveryMethod(locId, orderIntervalId, orderId)}},model:{value:(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']),callback:function ($$v) {_vm.$set(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId], 'active', $$v)},expression:"model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('general.active'))+"\n                                      ")]),_vm._v("\n\n                                      "+_vm._s(_vm.$t('general.from'))+"\n                                      "),_c('el-time-select',{staticClass:"in-inline-160",attrs:{"disabled":!_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active'],"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_from']),callback:function ($$v) {_vm.$set(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId], 'available_from', $$v)},expression:"model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_from']"}}),_vm._v("\n\n                                      "+_vm._s(_vm.$t('general.to'))+"\n                                      "),_c('el-time-select',{staticClass:"in-inline-160",attrs:{"disabled":!_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active'],"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_to']),callback:function ($$v) {_vm.$set(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId], 'available_to', $$v)},expression:"model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_to']"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.preventDefault();_vm.removeOverrideInterval(locId, orderIntervalId, orderId)}}},[_vm._v("-")])],1),_vm._v(" "),_c('div',{key:'days-' + locId + '-' + orderIntervalId + '-' + orderId,staticClass:"col-md-12 pull-left-first-child",staticStyle:{"flex-wrap":"wrap"}},[_vm._l((_vm.weekDays()),function(d,key){return [_c('p-checkbox',{key:'day-' + locId + '-' + orderIntervalId + '-' + orderId + '-' + key,staticClass:"inline-auto mar-rt-5",attrs:{"disabled":!_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active'],"value":d},on:{"input":function($event){_vm.handleCheckDay(locId, orderIntervalId, orderId)}},model:{value:(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId][d.toLowerCase()]),callback:function ($$v) {_vm.$set(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId], d.toLowerCase(), $$v)},expression:"model.override_settings[locId]['delivery'][orderIntervalId][orderId][d.toLowerCase()]"}},[_vm._v("\n                                          "+_vm._s(_vm.$t('catalogProd.' + d))+"\n                                        ")])]})],2),_vm._v(" "),_c('div',{key:'day-err-' + locId + '-' + orderIntervalId + '-' + orderId,staticClass:"col-md-12 pull-left-first-child",staticStyle:{"flex-wrap":"wrap"}},[(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active'] &&
                                              !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].monday &&
                                              !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].tuesday &&
                                              !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].wednesday &&
                                              !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].thursday &&
                                              !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].friday &&
                                              !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].saturday &&
                                              !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].sunday)?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                        "+_vm._s(_vm.$t('validations.chooseDay'))+"\n                                      ")]):_vm._e()])]})],2)]})],2)})):_vm._e()],1)])])]:_vm._e()],2)]),_vm._v(" "),(_vm.has_charisma_location)?_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',[_vm._v(_vm._s(_vm.$t('charisma.charismaInventory')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})])]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('general.administration')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.locations')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('general.actions')))])])]),_vm._v(" "),_c('tbody',[(!_vm.administrations || !_vm.administrations.length)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"3"}},[_vm._v("\n                          "+_vm._s(_vm.$t('general.noAdministrationsAvailable'))+"\n                        ")])]):_vm._e(),_vm._v(" "),(_vm.administrations && _vm.administrations.length && (!_vm.model.administrations || !_vm.model.administrations.length))?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"3"}},[_vm._v("\n                          "+_vm._s(_vm.$t('general.setAdministration'))+"\n                        ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.model.administrations),function(row,index){return _c('tr',{key:index},[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(row.administration_id),expression:"row.administration_id"}],staticClass:"form-control",attrs:{"placeholder":_vm.$t('general.select')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(row, "administration_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.availableAdministrations(row.administration_id)),function(admin){return _c('option',{key:admin.id,domProps:{"value":admin.id}},[_vm._v("\n                              "+_vm._s(admin.name)+"\n                            ")])})],2),_vm._v(" "),(_vm.errors.has(("administration_id_" + index)))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError(("administration_id_" + index)))+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('el-select',{staticClass:"charisma-location-select",attrs:{"multiple":"","collapse-tags":"","clearable":"","filterable":"","placeholder":_vm.$t('settingsOrdering.selectLocations')},model:{value:(row.location_ids),callback:function ($$v) {_vm.$set(row, "location_ids", $$v)},expression:"row.location_ids"}},_vm._l((_vm.charismaLocations),function(loc){return _c('el-option',{key:loc.id,attrs:{"label":loc.name,"value":loc.id}})}))],1),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-icon delete-prod mar-to--5 mar-lt-5",on:{"click":function($event){$event.preventDefault();_vm.removeAdministrationRow(index)}}},[_c('i',{staticClass:"ti-trash"})])])])})],2)]),_vm._v(" "),(_vm.administrations && _vm.administrations.length && (!_vm.model.administrations || (_vm.model.administrations && _vm.model.administrations.length < _vm.administrations.length)))?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addAdministrationRow($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('general.add'))+"\n                  ")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('el-collapse',{attrs:{"accordion":""}},[_c('el-collapse-item',{staticClass:"product-availability",attrs:{"title":_vm.$t('catalogProd.availabilityTitle')}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.productNotAvailable')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},on:{"input":_vm.handleProductUnavailable},model:{value:(_vm.model.is_not_available),callback:function ($$v) {_vm.$set(_vm.model, "is_not_available", $$v)},expression:"model.is_not_available"}})],1),_vm._v("\n                      "+_vm._s(_vm.$t('catalogProd.fromTime'))+"\n                      "),_c('el-time-select',{staticClass:"in-inline-165",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"picker-options":_vm.pickerOptions},model:{value:(_vm.model.is_not_available_from),callback:function ($$v) {_vm.$set(_vm.model, "is_not_available_from", $$v)},expression:"model.is_not_available_from"}}),_vm._v("\n                      "+_vm._s(_vm.$t('catalogProd.toTime'))+"\n                      "),_c('el-time-select',{staticClass:"in-inline-165",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"picker-options":_vm.pickerOptions},model:{value:(_vm.model.is_not_available_to),callback:function ($$v) {_vm.$set(_vm.model, "is_not_available_to", $$v)},expression:"model.is_not_available_to"}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.errorProductUnavailable)?_c('small',{staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.errorProductUnavailable)+"\n                      ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.use_gestiune)?[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{attrs:{"direction":"horizontal","type":"tabs"}},[_c('h6',[_vm._v(_vm._s(_vm.$t('gestiune.productManagement')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})])])]),_vm._v(" "),_c('div',{staticClass:"vat-boxes"},_vm._l((_vm.model.pos_id_gruped_by_vat),function(entries,vat){return (vat != 'NO_VAT')?_c('div',{key:vat,staticClass:"vat-box"},[_c('div',{staticClass:"vat-header"},[_c('strong',[_vm._v("VAT: "+_vm._s(vat))])]),_vm._v(" "),_c('div',{staticClass:"vat-body"},[(_vm.loadingVat === vat)?_c('div',{staticClass:"mini-loader"},[_vm._v("\n                            "+_vm._s(_vm.$t('gestiune.prodLoading'))+"\n                          ")]):_c('div',[(_vm.linkedProducts[vat])?_c('div',[_c('div',{staticClass:"linked-product-id"},[_vm._v("\n                                Id: "+_vm._s(_vm.linkedProducts[vat]._id)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"linked-product-name"},[_vm._v("\n                                "+_vm._s(_vm.linkedProducts[vat].name)+" - "),_c('div',{staticStyle:{"display":"inline"},domProps:{"innerHTML":_vm._s(_vm.showGestiuneCategory(_vm.linkedProducts[vat].categorie))}}),_vm._v(" "),(_vm.linkedProducts && _vm.linkedProducts[vat] && _vm.linkedProducts[vat].reteta && _vm.linkedProducts[vat].reteta.items && _vm.linkedProducts[vat].reteta.items.length)?_c('span',{staticClass:"reteta"},[_vm._v("\n                                  Reteta\n                                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"linked-product-extra"})]):_c('div',{staticClass:"no-link"},[_vm._v("\n                              "+_vm._s(_vm.$t('gestiune.noGestion'))+"\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm change mar-to-10",on:{"click":function($event){$event.preventDefault();_vm.openChangeModal(vat)}}},[(_vm.linkedProducts[vat])?[_vm._v("\n                              "+_vm._s(_vm.$t('gestiune.change'))+"\n                            ")]:[_vm._v("\n                              "+_vm._s(_vm.$t('general.add'))+"\n                            ")]],2)])])]):_vm._e()}))])])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'options'),expression:"currentSection === 'options'"}],staticClass:"card-container",attrs:{"id":"options"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-12"},[_vm._v(_vm._s(_vm.$t('catalogProd.groupOption')))]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","options":_vm.groupOptions,"label":"name","placeholder":_vm.$t('general.all')},on:{"input":function($event){_vm.changeGroupOptions()}},model:{value:(_vm.model.group_options),callback:function ($$v) {_vm.$set(_vm.model, "group_options", $$v)},expression:"model.group_options"}})],1),_vm._v(" "),(_vm.errors.has('group_options'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.getError('group_options'))+"\n                          ")]):_vm._e()]),_vm._v(" "),(!_vm.model.group_options || (_vm.model.group_options && !_vm.model.group_options.length))?_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('div',{staticClass:"col-md-12 display-flex align-items-center justify-content-space-between no-padding"},[_c('h6',[_vm._v(_vm._s(_vm.$t('catalogProdOpt.plural')))]),_vm._v(" "),(this.model.product_options && Object.keys(_vm.productOptionsFiltered).length > _vm.model.product_options.length)?_c('button',{staticClass:"btn btn-plus btn-icon no-padding",attrs:{"title":_vm.$t('general.add')  + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.addNewOption()}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})]):_vm._e()]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":_vm.$t('catalogProdOpt.plural')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-10 "},[_c('el-collapse',{ref:"elColl",attrs:{"accordion":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_vm._l((_vm.model.product_options),function(option,idxO){return [_c('button',{staticClass:"btn btn-danger pull-left btn-icon btn-icon-delete mar-15",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteOption(idxO)}}},[_c('i',{staticClass:"ti-close"})]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":_vm.getOptData(option, 'name'),"name":idxO}},[_c('div',{staticClass:"clearfix"},[_c('hr',{staticClass:"no-margin mar-bt-15"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProdOpt.single')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.product_options[idxO].company_option_id),expression:"model.product_options[idxO].company_option_id"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",attrs:{"placeholder":"Pick an option","data-vv-scope":"options"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.product_options[idxO], "company_option_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.changeOption(idxO, _vm.model.product_options[idxO].company_option_id)}]}},[_c('option',{attrs:{"disabled":"","value":"null"}},[_vm._v(_vm._s(_vm.$t('catalogProd.pickAnOption')))]),_vm._v(" "),_vm._l((_vm.productOptionsFiltered),function(prOption){return [_c('option',{attrs:{"disabled":_vm.disableOption(idxO, prOption.id, true) && _vm.model.product_options[idxO].company_option_id != prOption.id},domProps:{"value":prOption.id}},[_vm._v(_vm._s(prOption.name)+" "+_vm._s(prOption.label.length ? '(' + prOption.label + ')' : '')+" ")])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('general.required')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.required),expression:"option.required"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "required", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":true}},[_vm._v(_vm._s(_vm.$t('general.yes')))]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v(_vm._s(_vm.$t('general.no')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(option.type == 'checkbox' || option.type == 'upload')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.minNoSelected')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.min_no),expression:"option.min_no"}],staticClass:"form-control",attrs:{"type":"number","name":"min"},domProps:{"value":(option.min_no)},on:{"change":function($event){_vm.validateOption(option, _vm.model.product_options[idxO].company_option_id)},"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "min_no", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('min' + _vm.model.product_options[idxO].company_option_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                          "+_vm._s(_vm.getError('min' + _vm.model.product_options[idxO].company_option_id))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.errors.has('min_negative' + _vm.model.product_options[idxO].company_option_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                          "+_vm._s(_vm.getError('min_negative' + _vm.model.product_options[idxO].company_option_id))+"\n                                        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(option.type == 'checkbox' || option.type == 'upload')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.maxNoSelected')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.max_no),expression:"option.max_no"}],staticClass:"form-control",attrs:{"type":"number","name":"max"},domProps:{"value":(option.max_no)},on:{"change":function($event){_vm.validateOption(option, _vm.model.product_options[idxO].company_option_id)},"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "max_no", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('max' + _vm.model.product_options[idxO].company_option_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                          "+_vm._s(_vm.getError('max' + _vm.model.product_options[idxO].company_option_id))+"\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.errors.has('max_negative' + _vm.model.product_options[idxO].company_option_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                          "+_vm._s(_vm.getError('max_negative' + _vm.model.product_options[idxO].company_option_id))+"\n                                        ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productOptions.hidePrices')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.hide_prices),expression:"option.hide_prices"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "hide_prices", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":true}},[_vm._v(_vm._s(_vm.$t('general.yes')))]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v(_vm._s(_vm.$t('general.no')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productOptions.hasDefaultValue')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.has_default_value),expression:"option.has_default_value"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "has_default_value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":true}},[_vm._v(_vm._s(_vm.$t('general.yes')))]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v(_vm._s(_vm.$t('general.no')))])])])])]),_vm._v(" "),(option.id != '')?_c('table',{staticClass:"table no-margin"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"200px"}},[_vm._v(_vm._s(_vm.$t('catalogProd.optVal')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('catalogProd.price'))+" ("+_vm._s(_vm.currency)+")\n                                          ")]),_vm._v(" "),_c('th',[_vm._v("Pos Id 1")]),_vm._v(" "),(_vm.use_pos_id_per_product_option)?_c('th',[_vm._v("Pos Id 2")]):_vm._e(),_vm._v(" "),(_vm.use_quantity_per_product_option)?_c('th',[_vm._v("Qty.")]):_vm._e(),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((option.values),function(value,idx){return _c('tr',[_c('td',[(_vm.productOptionsFiltered[_vm.getObjectByElemKeyValue('id', option.company_option_id, _vm.productOptionsFiltered)])?[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"product-option-value-select",attrs:{"filterable":"","filter-method":_vm.filterOptionValues,"placeholder":_vm.$t('catalogProd.pickAnOption'),"data-vv-scope":"options"},on:{"visible-change":_vm.resetOptionValueQuery,"change":function($event){_vm.selectOptionValue($event, idxO, idx)}},model:{value:(value.company_option_value_id),callback:function ($$v) {_vm.$set(value, "company_option_value_id", $$v)},expression:"value.company_option_value_id"}},_vm._l((_vm.productOptionsFiltered[_vm.getObjectByElemKeyValue('id', option.company_option_id, _vm.productOptionsFiltered)]['values']),function(prOption){return (_vm.matchesOptionValueQuery(prOption.name, value.company_option_value_id, prOption.id))?_c('el-option',{key:prOption.id,attrs:{"label":prOption.name,"value":prOption.id,"disabled":_vm.disableOption(idxO, prOption.id, false) && value.company_option_value_id != prOption.id}}):_vm._e()}))]:_vm._e()],2),_vm._v(" "),_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({min_value: 0}),expression:"{min_value: 0}"},{name:"model",rawName:"v-model",value:(value.price),expression:"value.price"}],staticClass:"form-control",attrs:{"type":"number","data-vv-scope":"options"},domProps:{"value":(value.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "price", $event.target.value)}}})])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.pos_id),expression:"value.pos_id"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(value.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "pos_id", $event.target.value)}}})])])]),_vm._v(" "),(_vm.use_pos_id_per_product_option || (value.hasOwnProperty('pos_id_per_product') && value.pos_id_per_product))?_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.pos_id_per_product),expression:"value.pos_id_per_product"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(value.pos_id_per_product)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "pos_id_per_product", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(_vm.use_quantity_per_product_option || (value.hasOwnProperty('quantity_per_option') && value.quantity_per_option) )?_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.quantity_per_option),expression:"value.quantity_per_option"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(value.quantity_per_option)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "quantity_per_option", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.deleteOptionValue(idxO, idx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])])])}))]):_vm._e(),_vm._v(" "),(_vm.showAddButton(idxO, option))?_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-simple btn-icon mar-bt-5",attrs:{"title":""},on:{"click":[function($event){_vm.validateOption(option, _vm.model.product_options[idxO].company_option_id)},function($event){$event.preventDefault();_vm.addNewOptionValue(idxO)}]}},[_c('i',{staticClass:"ti-plus"}),_vm._v("\n                                        "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.single'))+" "+_vm._s(_vm.$t('catalogProdOpt.value'))+"\n                                    ")])]):_vm._e()])]})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15 pad-bt-10"})])])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('div',{staticClass:"col-md-12 display-flex align-items-center justify-content-space-between no-padding"},[_c('h6',[_vm._v(_vm._s(_vm.$t('filter.filters')))]),_vm._v(" "),(this.model.product_filters && Object.keys(_vm.productAvailableFilters).length > this.model.product_filters.length)?_c('button',{staticClass:"btn btn-icon btn-plus no-padding",attrs:{"title":_vm.$t('general.add')  + ' ' + _vm.$t('filter.filter')},on:{"click":function($event){$event.preventDefault();_vm.addNewFilter()}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})]):_vm._e()]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":_vm.$t('catalogProdOpt.plural')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-10 "},[_c('el-collapse',{ref:"elColl",attrs:{"accordion":""},model:{value:(_vm.tabFilterIndex),callback:function ($$v) {_vm.tabFilterIndex=$$v},expression:"tabFilterIndex"}},[_vm._l((_vm.model.product_filters),function(filter,idxF){return [_c('button',{staticClass:"btn btn-danger pull-left btn-icon mar-15",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteFilter(idxF)}}},[_c('i',{staticClass:"ti-close"})]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":_vm.getFilData(filter.filter_id, 'type'),"name":idxF}},[_c('div',{staticClass:"clearfix"},[_c('hr',{staticClass:"no-margin mar-bt-15"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('filter.filterType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(filter.filter_id),expression:"filter.filter_id"}],staticClass:"form-control",attrs:{"placeholder":"Pick an filter","name":'filter'+filter.filter_id},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(filter, "filter_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.$t('catalogProd.pickAnOption')))]),_vm._v(" "),_vm._l((_vm.productAvailableFilters),function(prFilter){return [_c('option',{key:prFilter.id,attrs:{"disabled":_vm.disableFilter(idxF, prFilter.id, true) && filter.filter_id != prFilter.id,"label":prFilter.type},domProps:{"value":prFilter.id}})]})],2)])])]),_vm._v(" "),(filter.id != '')?_c('table',{staticClass:"table no-margin"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"200px"}},[_vm._v(_vm._s(_vm.$t('catalogProd.optVal')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.productAvailableFilters),function(paf,idxpaf){return [(filter.filter_id == paf.id)?[_vm._l((filter.filter_value),function(filVal,idnx){return [_c('tr',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.id),expression:"filter.id"}],attrs:{"type":"hidden"},domProps:{"value":(filter.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter, "id", $event.target.value)}}}),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" "+_vm._s(_vm.$t('catalogProdOpt.value'))+" "+_vm._s(_vm.$t('filter.filter')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(filVal.id),expression:"filVal.id"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",attrs:{"placeholder":"Pick an value","data-vv-scope":"options"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(filVal, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('catalogProd.pickAnOption')))]),_vm._v(" "),_vm._l((paf.filter_value),function(prFilterValue){return [_c('option',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"disabled":_vm.disableFilterValue(idxF, prFilterValue.id, false),"data-vv-scope":"options"},domProps:{"value":prFilterValue.id}},[_vm._v(_vm._s(prFilterValue.value))])]})],2)])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.deleteFilterValue(idxF, idnx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])])])]})]:_vm._e()]})],2)]):_vm._e(),_vm._v(" "),(_vm.showAddButtonFilter(idxF, filter))?_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-simple btn-icon mar-bt-5",attrs:{"title":""},on:{"click":function($event){$event.preventDefault();_vm.addNeFilterValue(idxF)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v("\n                                        "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.value'))+" "+_vm._s(_vm.$t('filter.filter'))+"\n                                    ")])]):_vm._e()])]})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15 pad-bt-10"})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('div',{staticClass:"col-md-12 display-flex align-items-center justify-content-space-between no-padding"},[_c('h6',[_vm._v(_vm._s(_vm.$t('catalogProd.aditionalInfo')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-plus no-padding",attrs:{"title":_vm.$t('general.add')  + ' OtherInfo'},on:{"click":function($event){$event.preventDefault();_vm.addNewOtherInfo()}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":"title"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-10 "},[_c('el-collapse',{ref:"elColl",attrs:{"accordion":""},model:{value:(_vm.tabOtherInfoIndex),callback:function ($$v) {_vm.tabOtherInfoIndex=$$v},expression:"tabOtherInfoIndex"}},[_vm._l((_vm.model.other_info),function(info,id_info){return [(info.del != 1)?[_c('button',{staticClass:"btn btn-danger pull-left btn-icon mar-15",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteOtherInfo(id_info)}}},[_c('i',{staticClass:"ti-close"})]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":info.title === '' ? 'Name' : info.title,"name":_vm.idxF}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(info.title),expression:"info.title"}],staticClass:"form-control",attrs:{"type":"text","name":"info_name","placeholder":_vm.$t('catalogProd.name'),"data-vv-scope":"options"},domProps:{"value":(info.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(info, "title", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('info_name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                        "+_vm._s(_vm.getError('info_name'))+"\n                                      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"pad-to-10"},[_vm._v("Description")]),_vm._v(" "),_c('wysiwyg',{model:{value:(info.description),callback:function ($$v) {_vm.$set(info, "description", $$v)},expression:"info.description"}})],1)])]:_vm._e()]})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15 pad-bt-10"})])])])])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'marketing'),expression:"currentSection === 'marketing'"}],staticClass:"card-container",attrs:{"id":"marketing"}},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.type),expression:"model.type"}],attrs:{"type":"hidden","name":"","value":"single"},domProps:{"value":(_vm.model.type)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "type", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12 "},[(_vm.model.type == 'group')?_c('div',[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Pick products that should be in the group")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","options":_vm.products,"label":"name"},model:{value:(_vm.model.child_products),callback:function ($$v) {_vm.$set(_vm.model, "child_products", $$v)},expression:"model.child_products"}})],1),_vm._v(" "),(_vm.errors.has('child_products'))?_c('small',{staticClass:"text-danger col-md-12"},[_vm._v("\n                            "+_vm._s(_vm.getError('child_products'))+"\n                          ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15"},[_c('h6',[_c('img',{attrs:{"src":"/static/img/icons/points-sm.png"}}),_vm._v("\n                      "+_vm._s(_vm.$t('catalogProd.rewardPoints'))+"\n                    ")]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.moneySpent')))]),_vm._v(" "),_c('small',{staticClass:"help-block"},[_vm._v("\n                        "+_vm._s(_vm.$t('catalogProd.numberOfYouNeedToSpend', { currency: _vm.currency }))+"\n                        "),_c('div',{staticClass:"pad-to-5"},[_vm._v(_vm._s(_vm.$t('catalogProd.rewardPossibelValue'))+":\n                          "),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t('catalogProdRewardsHints.hint1')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('catalogProdRewardsHints.hint2')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('catalogProdRewardsHints.hint3')))])])])]),_vm._v("\n                      1 "+_vm._s(_vm.currency)+" = "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.monetary_conversion),expression:"model.monetary_conversion"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"0","step":"0.1","name":"monetary_conversion"},domProps:{"value":(_vm.model.monetary_conversion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "monetary_conversion", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.$t('catalogProd.points'))+"\n                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('h6',[_vm._v(_vm._s(_vm.$t('catalogProd.soldWith')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('p-checkbox',{attrs:{"value":!!_vm.model.sold_with_menu_suggestion},model:{value:(_vm.model.sold_with_menu_suggestion),callback:function ($$v) {_vm.$set(_vm.model, "sold_with_menu_suggestion", $$v)},expression:"model.sold_with_menu_suggestion"}},[_vm._v("\n                        "+_vm._s(_vm.$t('catalogProd.sold_with_menu_suggestion'))+"\n                      ")]),_vm._v(" "),_c('p-checkbox',{attrs:{"value":!!_vm.model.sold_with_menu_suggestion_pos},model:{value:(_vm.model.sold_with_menu_suggestion_pos),callback:function ($$v) {_vm.$set(_vm.model, "sold_with_menu_suggestion_pos", $$v)},expression:"model.sold_with_menu_suggestion_pos"}},[_vm._v("\n                        "+_vm._s(_vm.$t('catalogProd.sold_with_menu_suggestion_pos'))+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"text-left icon-search sold-with-tree",attrs:{"title":"","tabId":"first"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchword),expression:"searchword"}],staticClass:"form-control ",attrs:{"type":"text","placeholder":_vm.$t('general.search')},domProps:{"value":(_vm.searchword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchword=$event.target.value},_vm.search]}}),_vm._v(" "),_c('v-tree',{ref:"tree",attrs:{"data":_vm.treeData,"multiple":true,"allowGetParentNode":true,"halfcheck":true},on:{"node-click":_vm.updateSoldWith,"node-check":_vm.updateSoldWith,"node-expand":_vm.getProductsForCategory}})],1)],1)])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'label'),expression:"currentSection === 'label'"}],staticClass:"card-container",attrs:{"id":"label"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('catalogProd.orderLabelSettings')))]),_vm._v(" "),_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.printOnOrderLabel')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.print_on_order_label),callback:function ($$v) {_vm.$set(_vm.model, "print_on_order_label", $$v)},expression:"model.print_on_order_label"}})],1),_vm._v(" "),_c('small',{staticClass:"help-block order-label-hint"},[_vm._v(_vm._s(_vm.$t('catalogProd.printOnOrderLabelHint')))])])])]),_vm._v(" "),(_vm.model.labels)?_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.label_type')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.labels[0].type),expression:"model.labels[0].type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.labels[0], "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":""},domProps:{"value":0}},[_vm._v("None")]),_vm._v(" "),_vm._l((_vm.labelTypes),function(lt){return [_c('option',{domProps:{"value":lt.id}},[_vm._v(_vm._s(lt.name))])]})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.label_name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.labels[0].name),expression:"model.labels[0].name"}],staticClass:"form-control",attrs:{"type":"text","name":"label_name","placeholder":_vm.$t('catalogProd.label_name')},domProps:{"value":(_vm.model.labels[0].name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.labels[0], "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.label_ingredients')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.labels[0].ingredients),expression:"model.labels[0].ingredients"}],staticClass:"form-control",attrs:{"type":"text","name":"label_ingredients","placeholder":_vm.$t('catalogProd.label_ingredients')},domProps:{"value":(_vm.model.labels[0].ingredients)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.labels[0], "ingredients", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.label_allergens')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.labels[0].allergens),expression:"model.labels[0].allergens"}],staticClass:"form-control",attrs:{"type":"text","name":"label_allergens","placeholder":_vm.$t('catalogProd.label_allergens')},domProps:{"value":(_vm.model.labels[0].allergens)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.labels[0], "allergens", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.label_exp_txt')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.labels[0].exp_txt),expression:"model.labels[0].exp_txt"}],staticClass:"form-control",attrs:{"type":"text","name":"label_exp_txt","placeholder":_vm.$t('catalogProd.label_exp_txt')},domProps:{"value":(_vm.model.labels[0].exp_txt)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.labels[0], "exp_txt", $event.target.value)}}})])])])]):_vm._e(),_vm._v(" "),(_vm.model.labels)?_c('div',{staticClass:"col-md-4"},[(_vm.model.labels[0].type === 1)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"prevewLabel"},[(_vm.model.labels[0].name)?_c('p',{staticClass:"prevewLabel_title"},[_vm._v(_vm._s(_vm.model.labels[0].name))]):_vm._e(),_vm._v(" "),(_vm.model.labels[0].ingredients)?_c('p',{staticClass:"prevewLabel_txt"},[_vm._v(_vm._s(_vm.model.labels[0].ingredients))]):_vm._e(),_vm._v(" "),(_vm.model.labels[0].allergens)?_c('p',{staticClass:"prevewLabel_txt"},[_vm._v(_vm._s(_vm.model.labels[0].allergens))]):_vm._e(),_vm._v(" "),(_vm.model.labels[0].exp_txt)?_c('p',{staticClass:"prevewLabel_txt"},[_vm._v(_vm._s(_vm.model.labels[0].exp_txt))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"prevewLabel_title"},[_vm._v("ORDER: NUMAR")])])])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'settings'),expression:"currentSection === 'settings'"}],staticClass:"card-container",attrs:{"id":"settings"}},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.isDeposit')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_deposit),callback:function ($$v) {_vm.$set(_vm.model, "is_deposit", $$v)},expression:"model.is_deposit"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.isAgeRestrict')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_age_restrict),callback:function ($$v) {_vm.$set(_vm.model, "is_age_restrict", $$v)},expression:"model.is_age_restrict"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.partialPay')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.partial_pay),callback:function ($$v) {_vm.$set(_vm.model, "partial_pay", $$v)},expression:"model.partial_pay"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.limitQuantityKioskQr')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.limit_quantity_kiosk_qr),callback:function ($$v) {_vm.$set(_vm.model, "limit_quantity_kiosk_qr", $$v)},expression:"model.limit_quantity_kiosk_qr"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.highlightsProduct')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_highlight),callback:function ($$v) {_vm.$set(_vm.model, "is_highlight", $$v)},expression:"model.is_highlight"}}),_vm._v(" "),(_vm.errors.has('is_highlight'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('is_highlight'))+"\n                        ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.isHiddenFromListing')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_hidden_from_listing),callback:function ($$v) {_vm.$set(_vm.model, "is_hidden_from_listing", $$v)},expression:"model.is_hidden_from_listing"}}),_vm._v(" "),(_vm.errors.has('is_hidden_from_listing'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('is_hidden_from_listing'))+"\n                        ")]):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.allowUserComments')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_user_comments),callback:function ($$v) {_vm.$set(_vm.model, "allow_user_comments", $$v)},expression:"model.allow_user_comments"}}),_vm._v(" "),(_vm.errors.has('allow_user_comments'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('allow_user_comments'))+"\n                        ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.isHiddenFromSearch')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_hidden_from_search),callback:function ($$v) {_vm.$set(_vm.model, "is_hidden_from_search", $$v)},expression:"model.is_hidden_from_search"}}),_vm._v(" "),(_vm.errors.has('is_hidden_from_search'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('is_hidden_from_search'))+"\n                        ")]):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.availableInStore')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_available_only_in_store),callback:function ($$v) {_vm.$set(_vm.model, "is_available_only_in_store", $$v)},expression:"model.is_available_only_in_store"}}),_vm._v(" "),(_vm.errors.has('is_available_only_in_store'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('is_available_only_in_store'))+"\n                        ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.isHiddenFromQrMenu')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_hidden_from_qrmenu),callback:function ($$v) {_vm.$set(_vm.model, "is_hidden_from_qrmenu", $$v)},expression:"model.is_hidden_from_qrmenu"}}),_vm._v(" "),(_vm.errors.has('is_hidden_from_qrmenu'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('is_hidden_from_qrmenu'))+"\n                        ")]):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.isHiddenFromKiosk')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_hidden_from_kiosk),callback:function ($$v) {_vm.$set(_vm.model, "is_hidden_from_kiosk", $$v)},expression:"model.is_hidden_from_kiosk"}}),_vm._v(" "),(_vm.errors.has('is_hidden_from_kiosk'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('is_hidden_from_kiosk'))+"\n                        ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.isHiddenFromPOS')))]),_vm._v(" "),_c('div',{staticClass:"pad-to-10"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_hidden_from_pos),callback:function ($$v) {_vm.$set(_vm.model, "is_hidden_from_pos", $$v)},expression:"model.is_hidden_from_pos"}}),_vm._v(" "),(_vm.errors.has('is_hidden_from_pos'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('is_hidden_from_pos'))+"\n                        ")]):_vm._e()],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-md-12"},[_vm._v(_vm._s(_vm.$t('catalogProd.taxes')))]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","options":_vm.taxes,"label":"name"},model:{value:(_vm.model.taxes),callback:function ($$v) {_vm.$set(_vm.model, "taxes", $$v)},expression:"model.taxes"}})],1),_vm._v(" "),(_vm.errors.has('taxes'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('taxes'))+"\n                    ")]):_vm._e()]),_vm._v(" "),(_vm.model && _vm.vatOptions && _vm.taxesVersion === 2)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.vat')))]),_vm._v(" "),_c('small',[_vm._v("("+_vm._s(_vm.$t('catalogCateg.included'))+")")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.vat_rate_id),expression:"model.vat_rate_id"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.vat_rate_id || {}),expression:"modelValidations.vat_rate_id || {}"}],staticClass:"form-control",attrs:{"data-vv-scope":"settings"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "vat_rate_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{key:vat.id,attrs:{"disabled":_vm.isVatOptionDisabled(vat, _vm.model.vat_rate_id)},domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.rate)+"%"),(!vat.is_active)?[_vm._v(" (inactiv)")]:_vm._e()],2)})],2)]):(_vm.model && _vm.vatOptions)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.vat')))]),_vm._v(" "),_c('small',[_vm._v("("+_vm._s(_vm.$t('catalogCateg.included'))+")")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.vat_id),expression:"model.vat_id"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.vat_id || {}),expression:"modelValidations.vat_id || {}"}],staticClass:"form-control",attrs:{"data-vv-scope":"settings"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "vat_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateProductVatPrinterId($event)}]}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{key:vat.id,attrs:{"id":vat.id,"data-amount":vat.amount},domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.amount)+" "),(vat.tax && vat.tax.name)?[_vm._v(" - "+_vm._s(vat.tax.name))]:_vm._e()],2)}),_vm._v(" "),(_vm.model.vat !== null)?_c('option',{staticStyle:{"display":"none"},domProps:{"value":_vm.model.vat}},[_vm._v(_vm._s(_vm.model.vat))]):_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Taxe V2 aplicate")]),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('div',{staticClass:"alert alert-warning"},[_c('strong',[_vm._v("Motorul Taxe V2 este oprit.")]),_vm._v("\n                    Atribuirile se salvează pentru migrare, dar aceste taxe nu se aplică până când activezi Taxe V2 pentru companie.\n                  ")]):_vm._e(),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","filterable":"","clearable":"","loading":_vm.loadingProductTaxRules,"placeholder":"Selectează una sau mai multe taxe"},model:{value:(_vm.model.tax_rule_ids_v2),callback:function ($$v) {_vm.$set(_vm.model, "tax_rule_ids_v2", $$v)},expression:"model.tax_rule_ids_v2"}},_vm._l((_vm.productTaxRuleOptions),function(rule){return _c('el-option',{key:rule.id,attrs:{"label":_vm.formatProductTaxRuleLabel(rule),"value":Number(rule.id),"disabled":_vm.isProductTaxRuleDisabled(rule)}})})),_vm._v(" "),_c('small',{staticClass:"help-block"},[_vm._v("Poți adăuga sau scoate taxe, apoi salvezi produsul. Taxele inactive deja atribuite pot fi doar păstrate sau scoase.")]),_vm._v(" "),(_vm.selectedProductTaxRules.length)?_c('div',{staticClass:"table-responsive mar-to-10"},[_c('table',{staticClass:"table table-striped table-bordered"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.selectedProductTaxRules),function(rule){return _c('tr',{key:rule.id},[_c('td',[_vm._v(_vm._s(rule.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(rule.value)+_vm._s(rule.calculation_type === 'percentage' ? '%' : ' ' + _vm.currency))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(rule.vat_rate ? rule.vat_rate.rate + '%' : '-'))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label",class:_vm.productTaxRuleStatusClass(rule)},[_vm._v("\n                              "+_vm._s(_vm.productTaxRuleStatusLabel(rule))+"\n                            ")])])])}))])]):_c('p',{staticClass:"help-block mar-to-10"},[_vm._v("Produsul nu are taxe V2 aplicate.")])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.posid')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos_id),expression:"model.pos_id"}],staticClass:"form-control",attrs:{"type":"text","name":"pos_id","placeholder":_vm.$t('catalogProd.posid')},domProps:{"value":(_vm.model.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "pos_id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.externalProductId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.external_product_id),expression:"model.external_product_id"}],staticClass:"form-control",attrs:{"type":"text","name":"external_product_id","placeholder":"1234, abcd-efgh"},domProps:{"value":(_vm.model.external_product_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "external_product_id", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.max_purchases_per_customer')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.max_purchases_per_customer),expression:"model.max_purchases_per_customer"}],staticClass:"form-control",attrs:{"type":"number","name":"max_purchases_per_customer","placeholder":_vm.$t('catalogProd.max_purchases_per_customer')},domProps:{"value":(_vm.model.max_purchases_per_customer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "max_purchases_per_customer", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.purchase_limit_interval_hours')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.purchase_limit_interval_hours),expression:"model.purchase_limit_interval_hours"}],staticClass:"form-control",attrs:{"type":"number","name":"purchase_limit_interval_hours","placeholder":_vm.$t('settingCompany.purchase_limit_interval_hours')},domProps:{"value":(_vm.model.purchase_limit_interval_hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "purchase_limit_interval_hours", $event.target.value)}}})])])])])])])])]):_c('div',{staticClass:"no-product-allowed"},[_c('h2',[_vm._v(" "+_vm._s(_vm.$t('catalogProd.accesRestricted'))+" ")])]),_vm._v(" "),_c('vmodal',{attrs:{"name":"changeProductModal","height":"600","width":"900"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',[_vm._v(_vm._s(_vm.$t('gestiune.changeProduct'))+" - VAT "+_vm._s(_vm.activeVat))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.searchProduct')},domProps:{"value":(_vm.searchTerm)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value},_vm.debouncedSearch]}}),_vm._v(" "),_c('div',{staticClass:"search-results"},[_c('div',{class:(_vm.loadingSearchProd ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),(_vm.searchResults && _vm.searchResults.length)?_vm._l((_vm.searchResults),function(prod){return _c('div',{key:prod.id,staticClass:"search-item",class:{ active: _vm.selectedProductForVat && _vm.selectedProductForVat._id === prod._id },on:{"click":function($event){_vm.selectProduct(prod)}}},[_c('div',{staticClass:"searchId"},[_vm._v("ID: "+_vm._s(prod._id))]),_vm._v("\n              "+_vm._s(prod.name)+" - "),_c('div',{staticStyle:{"display":"inline"},domProps:{"innerHTML":_vm._s(_vm.showGestiuneCategory(prod.categorie))}}),_vm._v(" "),(prod.reteta && prod.reteta.items && prod.reteta.items.length)?_c('span',{staticClass:"reteta"},[_vm._v("Reteta")]):_vm._e()])}):[_c('p',{staticClass:"centerSearch"},[_vm._v(_vm._s(_vm.$t('general.no_data')))])]],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btnSearch btn-danger",on:{"click":function($event){_vm.$modal.hide('changeProductModal')}}},[_vm._v(_vm._s(_vm.$t('general.close')))]),_vm._v(" "),_c('button',{staticClass:"btn btnSearch btn-success",on:{"click":_vm.saveNewLink}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 pad-lf-0 pad-rg-0"},[_c('hr',{staticClass:"sm"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 pad-lf-0 pad-rg-0"},[_c('hr',{staticClass:"sm"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 pad-lf-0 pad-rg-0"},[_c('hr',{staticClass:"sm"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Nume")]),_vm._v(" "),_c('th',[_vm._v("Calcul")]),_vm._v(" "),_c('th',[_vm._v("TVA taxă")]),_vm._v(" "),_c('th',[_vm._v("Stare")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I8zs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IAoy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MenuLinkForm_vue__ = __webpack_require__("RyIs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);







var _components;





__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'MenuLinkForm', __WEBPACK_IMPORTED_MODULE_7__MenuLinkForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      linkModel: {},
      link: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onLinkSubmit: function onLinkSubmit(model, isValid) {
      this.linkModel = model;
    }
  }
});

/***/ }),

/***/ "IB+M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ICL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bt-payment-history",attrs:{"aria-live":"polite"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('btPayments.title')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();_vm.load(_vm.page)}}},[_vm._v(_vm._s(_vm.$t('btPayments.refresh')))]),_vm._v(" "),(_vm.loading)?_c('p',[_vm._v(_vm._s(_vm.$t('btPayments.processing')))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"text-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(!_vm.error)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v(_vm._s(_vm.$t('btPayments.reference')))]),_c('th',[_vm._v(_vm._s(_vm.$t('btPayments.mode')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('btPayments.state')))]),_c('th',[_vm._v(_vm._s(_vm.$t('btPayments.amount')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('btPayments.capturedAmount')))]),_c('th',[_vm._v(_vm._s(_vm.$t('btPayments.returnedAmount')))]),_c('th',[_vm._v(_vm._s(_vm.$t('btPayments.details')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.payments),function(payment){return _c('tr',{key:payment.id},[_c('td',[_vm._v(_vm._s(payment.id))]),_vm._v(" "),_c('td',[_c('div',[_vm._v(_vm._s(payment.reference))]),_c('small',[_vm._v(_vm._s(payment.payable_type)+" #"+_vm._s(payment.payable_id))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(payment.payment_type)),_c('br'),_c('small',[_vm._v(_vm._s(payment.environment))])]),_vm._v(" "),_c('td',[_c('strong',{class:payment.attention_required ? 'text-danger' : ''},[_vm._v(_vm._s(_vm.$t('btPayments.' + _vm.statusKey(payment.status))))]),_vm._v(" "),(payment.attention_required)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('btPayments.review')))]):_vm._e(),_vm._v(" "),(payment.cancel_requested_at && ![5, 6].includes(Number(payment.status)))?_c('div',{staticClass:"text-warning"},[_vm._v(_vm._s(_vm.$t('btPayments.returnPending')))]):_vm._e(),_vm._v(" "),_c('small',[_vm._v(_vm._s(payment.applied_at ? _vm.$t('btPayments.applied') : _vm.$t('btPayments.notApplied')))]),_vm._v(" "),(payment.error_message)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(payment.error_message))]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.amount(payment.amount_minor, payment.currency)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.amount(payment.captured_minor, payment.currency)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.amount(payment.refunded_minor, payment.currency)))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){$event.preventDefault();_vm.selected = _vm.selected && _vm.selected.id === payment.id ? null : payment}}},[_vm._v(_vm._s(_vm.$t('btPayments.details')))])])])}),_vm._v(" "),(!_vm.loading && !_vm.payments.length)?_c('tr',[_c('td',{attrs:{"colspan":"8"}},[_vm._v(_vm._s(_vm.$t('btPayments.empty')))])]):_vm._e()],2)])]):_vm._e(),_vm._v(" "),(_vm.selected)?_c('div',{staticClass:"well"},[_c('button',{staticClass:"btn btn-sm pull-right",on:{"click":function($event){$event.preventDefault();_vm.selected = null}}},[_vm._v(_vm._s(_vm.$t('btPayments.close')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('btPayments.payment'))+" #"+_vm._s(_vm.selected.id)+" — "+_vm._s(_vm.selected.reference))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('btPayments.transaction'))+": "+_vm._s(_vm.selected.gateway_transaction_id || '—'))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('btPayments.approved'))+": "+_vm._s(_vm.amount(_vm.selected.approved_minor, _vm.selected.currency)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('btPayments.cancelRequested'))+": "+_vm._s(_vm.selected.cancel_requested_at || '—'))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('btPayments.fulfilled')))])]):_vm._e(),_vm._v(" "),(!_vm.error)?_c('div',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm",attrs:{"disabled":_vm.loading || _vm.page <= 1},on:{"click":function($event){$event.preventDefault();_vm.load(_vm.page - 1)}}},[_vm._v(_vm._s(_vm.$t('btPayments.previous')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('btPayments.page'))+" "+_vm._s(_vm.page)+" / "+_vm._s(_vm.lastPage))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",attrs:{"disabled":_vm.loading || _vm.page >= _vm.lastPage},on:{"click":function($event){$event.preventDefault();_vm.load(_vm.page + 1)}}},[_vm._v(_vm._s(_vm.$t('btPayments.next')))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IDcL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IDoR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NomenclatorTabs_vue__ = __webpack_require__("DZrI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25abaf23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NomenclatorTabs_vue__ = __webpack_require__("xz3T");
function injectStyle (ssrContext) {
  __webpack_require__("Cyb2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25abaf23"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NomenclatorTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25abaf23_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NomenclatorTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IFWP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSidebar_vue__ = __webpack_require__("jKDF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ddffcc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSidebar_vue__ = __webpack_require__("Jhho");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ddffcc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IIzT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__menuSubscriptionHelpers__ = __webpack_require__("VNNG");













__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      searchQuery: '',
      items: [],
      currency: ''
    };
  },
  created: function created() {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso);
    this.getItems();
    this.$bus.$on('refresh', this.getItems);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.getItems);
  },

  methods: {
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    getItems: function getItems() {
      var _this = this;

      var data = this.requestData();
      if (this.searchQuery.length >= 3) {
        data.search = this.searchQuery;
      }
      this.loading = true;
      this.apiRequest('/menu-subscription', 'GET', data, function (response) {
        if (response.status === true) {
          _this.items = response.data || [];
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    onInput: function onInput() {
      if (this.searchQuery.length >= 3 || this.searchQuery.length === 0) {
        this.getItems();
      }
    },
    dayList: function dayList(days) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_9__menuSubscriptionHelpers__["a" /* DAY_NAMES */].filter(function (day) {
        return days.indexOf(day) !== -1;
      }).map(function (day) {
        return _this2.$t('menuSubscriptions.dayShort.' + day);
      }).join(', ');
    },
    hourList: function hourList(hours) {
      return hours.map(function (hour) {
        return hour.from + '-' + hour.to;
      }).join(', ');
    },
    issuesText: function issuesText(issues) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__menuSubscriptionHelpers__["b" /* issuesText */])(this, issues);
    },
    openSubscribers: function openSubscribers(item) {
      this.$router.push({ path: '/marketing/menu-subscriptions/subscribers', query: { menu_subscription_id: item.id } }).catch(function () {});
    },
    edit: function edit(item, tab) {
      var query = tab ? { tab: tab } : {};
      this.$router.push({ path: '/marketing/menu-subscriptions/edit/' + item.id, query: query }).catch(function () {});
    },
    handleActive: function handleActive(item) {
      var _this3 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestData(), {
        active: item.active ? 1 : 0
      });
      this.apiRequest('/menu-subscription/' + item.id + '/status', 'POST', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ title: '', text: _this3.$t('menuSubscriptions.saved'), type: 'success', showConfirmButton: false, timer: 1200 }).catch(function () {});
        } else {
          item.active = !item.active;
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', _this3.firstError(response), 'warning').catch(function () {});
        }
      });
    },
    handleDelete: function handleDelete(item) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        text: this.$t('menuSubscriptions.areYouSureDelete', { name: item.name }),
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (!result) {
          return;
        }
        _this4.apiRequest('/menu-subscription/' + item.id, 'DELETE', _this4.requestData(), function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', _this4.$t('menuSubscriptions.deleted'), 'success').catch(function () {});
            _this4.getItems();
          } else {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', _this4.firstError(response), 'error').catch(function () {});
          }
        });
      }).catch(function () {});
    },
    firstError: function firstError(response) {
      var errors = response && response.errors || {};
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors)[0];
      if (!key) {
        return this.$t('validations.wentWrong');
      }
      return Array.isArray(errors[key]) ? errors[key][0] : errors[key];
    }
  }
});

/***/ }),

/***/ "IJPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);











var _components;






__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a), _components),
  props: {
    zoneId: null,
    callback: {
      required: false
    }
  },
  watch: {
    zoneId: function zoneId(value) {
      this.id = value;
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getData();
  },
  data: function data() {
    return {
      apiUrl: '',
      id: this.value || this.zoneId,
      isNew: true,
      model: {
        'id': 0,
        'name': ''
      },
      modelValidate: {
        name: { required: true }
      },
      languages: this.$session.get('defaultData')['available_languages'],
      loading: true
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (this.$route.params.id !== undefined && this.$route.params.id || this.id !== undefined && this.id !== null) {
        this.isNew = false;
      } else {
        this.isNew = true;
      }
      if (!this.isNew) {
        var id = this.$route.params.id || this.id;
        this.apiRequest('/table-zone/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            _this.model = response.data;
            _this.loading = false;
          }
        });
      } else {
        this.loading = false;
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveZone();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    saveZone: function saveZone() {
      var _this3 = this;

      this.loading = true;
      var data = this.model;
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      this.apiRequest('/table-zone/' + data.id, 'PUT', data, function (response) {
        if (response.success === true) {
          _this3.loading = false;
          _this3.errors.clear();
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            title: '',
            text: _this3.$t('settingTable.tableSave'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).then(function () {}).catch(function () {});
          _this3.cancelZone();
        } else {
          _this3.loading = false;
          _this3.handleErrors(response.errors);
        }
      });
    },
    deleteZone: function deleteZone() {
      var _this4 = this;

      var btnCounter = 10;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        title: self.$t('settingTable.deleteZoneTitle'),
        text: self.$t('settingTable.deleteZoneTxt'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          _this4.deleteZone2();
        }
      });
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    deleteZone2: function deleteZone2() {
      var _this5 = this;

      this.loadingReset = true;
      var id = this.id || this.$route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/table-zone/' + id, 'PUT', data, function (response) {
        if (response.success === true) {
          _this5.loadingReset = false;
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this5.cancelZone();
        } else {
          _this5.loadingReset = false;
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this5.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    cancelZone: function cancelZone() {
      if (typeof this.callback === 'function') {
        this.callback();
      }
    }
  }
});

/***/ }),

/***/ "INfR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomepageSections_vue__ = __webpack_require__("zks6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8525ffa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageSections_vue__ = __webpack_require__("CwYU");
function injectStyle (ssrContext) {
  __webpack_require__("pzYo")
  __webpack_require__("2hkR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8525ffa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomepageSections_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8525ffa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomepageSections_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IOOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardReport_vue__ = __webpack_require__("Ra/8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04cbfd9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardReport_vue__ = __webpack_require__("2fTx");
function injectStyle (ssrContext) {
  __webpack_require__("BCKP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04cbfd9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IQeM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);

















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      level: 'participants',
      paginationProps: { layout: 'prev, pager, next, sizes, total' },
      participantsRows: [],
      participantsTotal: 0,
      ordersRows: [],
      ordersTotal: 0,
      selectedCampaignId: null,
      selectedUserId: null,
      participantTitle: '',
      skipParticipantsQueryChange: true,
      skipOrdersQueryChange: false,
      participantFilters: {
        user_id: '',
        search: ''
      },
      participantJoinedRange: [],
      orderFilters: {
        order_id: '',
        order_number: '',
        status: null
      },
      orderDateRange: [],
      orderStatusOptions: ['NEW', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'DELIVERED', 'CANCELED', 'ON_HOLD', 'POSTPONED', 'COMPLETED'],
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso'])
    };
  },

  computed: {
    campaignTitle: function campaignTitle() {
      var q = this.route.query || {};
      if (q.title) return q.title;
      var id = this.selectedCampaignId;
      return id != null ? this.$t('general.idHash', { id: id }) : '';
    }
  },
  created: function created() {
    var raw = this.route.params && this.route.params.campaignId;
    this.selectedCampaignId = raw != null && raw !== '' ? raw : null;
    if (this.selectedCampaignId == null) {
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error').catch(function () {});
      return;
    }
    this.fetchParticipants(1, 25);
  },

  methods: {
    backButton: function backButton() {
      if (this.level === 'orders') {
        this.level = 'participants';
        this.selectedUserId = null;
        this.orderFilters = { order_id: '', order_number: '', status: null };
        this.orderDateRange = [];
        this.skipParticipantsQueryChange = true;
        this.fetchParticipants(1, 25);
        return;
      }
      this.$bus.$emit('close-modal');
    },
    formatMoney: function formatMoney(value) {
      var n = parseFloat(value || 0);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    formatScore: function formatScore(row) {
      if (row.score == null) return 0;
      if (row.type === 'order_total') {
        return this.formatMoney(row.score);
      }
      return row.score;
    },
    orderStatusLabel: function orderStatusLabel(status) {
      if (!status) return '-';
      var key = 'ordersStatus.' + status;
      var translated = this.$t(key);
      return translated === key ? status : translated;
    },
    displayPersonName: function displayPersonName(row) {
      if (!row) return this.$t('general.emDash');
      var fn = String(row.firstname || row.first_name || '').trim();
      var ln = String(row.lastname || row.last_name || '').trim();
      var s = [fn, ln].filter(Boolean).join(' ');
      if (s) return s;
      if (row.email) return row.email;
      return this.$t('general.idHash', { id: row.user_id || row.id });
    },
    userIdFromRow: function userIdFromRow(row) {
      return row.user_id || row.id;
    },
    onParticipantRow: function onParticipantRow(row) {
      this.selectedUserId = this.userIdFromRow(row);
      this.participantTitle = this.displayPersonName(row);
      this.level = 'orders';
      this.orderFilters = { order_id: '', order_number: '', status: null };
      this.orderDateRange = [];
      this.skipOrdersQueryChange = true;
      this.fetchOrders(1, 25);
    },
    normalizeRows: function normalizeRows(response) {
      if (!response || !response.data) return [];
      var d = response.data;
      if (Array.isArray(d)) return d;
      if (Array.isArray(d.data)) return d.data;
      if (Array.isArray(d.participants)) return d.participants;
      if (Array.isArray(d.orders)) return d.orders;
      return [];
    },
    normalizeTotal: function normalizeTotal(response) {
      if (response.pagination && response.pagination.total != null) return response.pagination.total;
      if (response.meta && response.meta.total != null) return response.meta.total;
      var d = response.data;
      if (d && d.pagination && d.pagination.total != null) return d.pagination.total;
      if (d && d.total != null) return d.total;
      return this.normalizeRows(response).length;
    },
    baseParams: function baseParams() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    applyParticipantFilters: function applyParticipantFilters() {
      this.skipParticipantsQueryChange = true;
      this.fetchParticipants(1, 25);
    },
    applyOrderFilters: function applyOrderFilters() {
      this.skipOrdersQueryChange = true;
      this.fetchOrders(1, 25);
    },
    buildParticipantParams: function buildParticipantParams(page, perPage) {
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.baseParams(), { page: page, per_page: perPage, perPage: perPage });
      var userId = String(this.participantFilters.user_id || '').trim();
      if (userId !== '') {
        data.user_id = userId;
      }
      var search = String(this.participantFilters.search || '').trim();
      if (search !== '') {
        data.search = search;
      }
      if (this.participantJoinedRange && this.participantJoinedRange.length === 2 && this.participantJoinedRange[0] && this.participantJoinedRange[1]) {
        data.joined_from = this.participantJoinedRange[0];
        data.joined_to = this.participantJoinedRange[1];
      }
      return data;
    },
    buildOrderParams: function buildOrderParams(page, perPage) {
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.baseParams(), { page: page, per_page: perPage, perPage: perPage });
      var orderId = String(this.orderFilters.order_id || '').trim();
      if (orderId !== '') {
        data.order_id = orderId;
      }
      var orderNumber = String(this.orderFilters.order_number || '').trim();
      if (orderNumber !== '') {
        data.order_number = orderNumber;
      }
      if (this.orderFilters.status) {
        data.status = this.orderFilters.status;
      }
      if (this.orderDateRange && this.orderDateRange.length === 2 && this.orderDateRange[0] && this.orderDateRange[1]) {
        data.date_from = this.orderDateRange[0];
        data.date_to = this.orderDateRange[1];
      }
      return data;
    },
    onParticipantsPage: function onParticipantsPage(q) {
      if (this.skipParticipantsQueryChange) {
        this.skipParticipantsQueryChange = false;
        return;
      }
      this.fetchParticipants(q.page, q.pageSize);
    },
    fetchParticipants: function fetchParticipants(page, perPage) {
      var _this = this;

      if (!this.selectedCampaignId) return;
      this.loading = true;
      var data = this.buildParticipantParams(page, perPage);
      var path = '/reports/raffle-campaigns/' + this.selectedCampaignId + '/participants';
      this.apiRequest(path, 'GET', data, function (response) {
        if (response.status) {
          _this.participantsRows = _this.normalizeRows(response);
          _this.participantsTotal = _this.normalizeTotal(response);
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this.$t('validations.wentWrong'), 'error').catch(function () {});
        }
        _this.loading = false;
      });
    },
    onOrdersPage: function onOrdersPage(q) {
      if (this.skipOrdersQueryChange) {
        this.skipOrdersQueryChange = false;
        return;
      }
      this.fetchOrders(q.page, q.pageSize);
    },
    fetchOrders: function fetchOrders(page, perPage) {
      var _this2 = this;

      if (!this.selectedCampaignId || !this.selectedUserId) return;
      this.loading = true;
      var data = this.buildOrderParams(page, perPage);
      var path = '/reports/raffle-campaigns/' + this.selectedCampaignId + '/participants/' + this.selectedUserId + '/orders';
      this.apiRequest(path, 'GET', data, function (response) {
        if (response.status) {
          _this2.ordersRows = _this2.normalizeRows(response);
          _this2.ordersTotal = _this2.normalizeTotal(response);
        } else if (response.errors && response.errors.user_id) {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', response.errors.user_id, 'error').catch(function () {});
          _this2.level = 'participants';
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error').catch(function () {});
        }
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "IQj2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IRf1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IS4p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"report-filters"},[_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 form-group pull-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.searchClient),expression:"filters.searchClient"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('reports.searchClient')},domProps:{"value":(_vm.filters.searchClient)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "searchClient", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 form-group pull-left"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.campaignId),expression:"filters.campaignId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "campaignId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('donationCampaigns.allCampaigns')))]),_vm._v(" "),_vm._l((_vm.campaigns),function(c){return _c('option',{key:c.id,domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 form-group pull-left date-range"},[_c('el-date-picker',{staticClass:"mid",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.filters.valid),callback:function ($$v) {_vm.$set(_vm.filters, "valid", $$v)},expression:"filters.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports col-md-1 col-sm-6 col-xs-12 form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":function($event){_vm.getData(null)}}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports col-md-1 col-sm-6 col-xs-12 form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-info btn-print",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_c('i',{staticClass:"ti-file"})])])]),_vm._v(" "),(_vm.totals)?_c('div',{staticClass:"row mar-to-15 mar-bt-15",staticStyle:{"padding":"0 15px"}},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card",staticStyle:{"padding":"15px","text-align":"center"}},[_c('h5',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.$t('donationReport.totalAmount')))]),_vm._v(" "),_c('h3',{staticStyle:{"margin":"5px 0 0 0"}},[_vm._v(_vm._s(parseFloat(_vm.totals.amount || 0).toFixed(2))+" "+_vm._s(_vm.currency))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card",staticStyle:{"padding":"15px","text-align":"center"}},[_c('h5',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.$t('donationReport.totalDonations')))]),_vm._v(" "),_c('h3',{staticStyle:{"margin":"5px 0 0 0"}},[_vm._v(_vm._s(_vm.totals.donations || 0))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card",staticStyle:{"padding":"15px","text-align":"center"}},[_c('h5',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.$t('donationReport.totalDonors')))]),_vm._v(" "),_c('h3',{staticStyle:{"margin":"5px 0 0 0"}},[_vm._v(_vm._s(_vm.totals.donors || 0))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content total-pagination pad-15"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{ show: false },"total":_vm.total,"pagination-props":_vm.paginationProps,"table-props":_vm.tableOptions},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"min-width":60,"prop":"id","label":_vm.$t('reports.id'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"prop":"campaign_name","label":_vm.$t('donationReport.campaign'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s((props.row.campaign && props.row.campaign.name) || props.row.campaign_name || '-')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"label":_vm.$t('donationReport.client')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.user)?[_vm._v("\n              "+_vm._s(props.row.user.firstname)+" "+_vm._s(props.row.user.lastname)+"\n            ")]:[_vm._v("\n              "+_vm._s(props.row.client_name || '-')+"\n            ")]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"label":_vm.$t('reports.email')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s((props.row.user && props.row.user.email) || props.row.client_email || '-')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"label":_vm.$t('reports.phone')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s((props.row.user && props.row.user.phone) || props.row.client_phone || '-')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":90,"prop":"amount","label":_vm.$t('donationReport.amount'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(parseFloat(props.row.amount || 0).toFixed(2))+" "+_vm._s(_vm.currency))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"order_id","label":_vm.$t('reports.orderId'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(props.row.order_id || '-')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"prop":"location_name","label":_vm.$t('reports.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s((props.row.location && props.row.location.name) || props.row.location_name || '-')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"prop":"created_at","label":_vm.$t('donationReport.date'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.formatDateTime(props.row.created_at))+"\n          ")]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ITsO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dashboard_Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dashboard_Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");







var _components;





__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'TimeLine', __WEBPACK_IMPORTED_MODULE_7__Dashboard_Stats_TimeLine_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'TimeLineItem', __WEBPACK_IMPORTED_MODULE_8__Dashboard_Stats_TimeLineItem_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      message: {},
      loading: true
    };
  },

  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      this.loading = true;
    });

    if (this.$route.params.id) {
      var id = this.$route.params.id;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/feedback/' + id, 'GET', data, function (response) {
        if (response.status === true) {
          _this.message = response.data[0];
          _this.$nextTick(function () {
            this.loading = false;
          });
          if (response.data[0].seen === 0) {
            _this.apiRequest('/feedback/' + id, 'DELETE', data, function (response) {});
          }
        }
      });
    }
  },
  methods: {
    saveComment: function saveComment() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.errors.clear();
          _this2.$nextTick(function () {
            _this2.loading = true;
          });
          var id = _this2.$route.params.id;
          var data = {
            token: _this2.$session.get('token'),
            company_id: _this2.$session.get('selectedCompany'),
            admin_response: _this2.message.admin_response
          };
          _this2.apiRequest('/feedback/admin-comment/' + id, 'PUT', data, function (response) {
            _this2.$nextTick(function () {
              _this2.loading = false;
            });
          });
        }
      });
    },
    deleteComment: function deleteComment() {
      var self = this;
      self.message.admin_response = ' ';
      self.$nextTick(function () {
        self.loading = true;
      });
      var id = this.$route.params.id;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        admin_response: ''
      };
      this.apiRequest('/feedback/admin-comment/' + id, 'PUT', data, function (response) {
        self.$nextTick(function () {
          self.loading = false;
        });
      });
    }
  }
});

/***/ }),

/***/ "IWKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isGestiuni },on:{"click":_vm.openGestiuni}},[_vm._v(_vm._s(_vm.$t('gestiune.gestiuni')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isSeries },on:{"click":_vm.openSeries}},[_vm._v(_vm._s(_vm.$t('invoice.seriesDocument')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isCategories },on:{"click":_vm.openCategories}},[_vm._v(_vm._s(_vm.$t('gestiune.categoriesSettings')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isOperation },on:{"click":_vm.openOperation}},[_vm._v(_vm._s(_vm.$t('gestiune.operations')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isOrderErrors },on:{"click":_vm.openOrderErrors}},[_vm._v(_vm._s(_vm.$t('gestiune.orderErrors')))])])])])]),_vm._v(" "),(_vm.isGestiuni)?_c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"}),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.openGestiuneModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('gestiune.addManagment'))+"\n          ")])])]),_vm._v(" "),(_vm.locations.length)?_vm._l((_vm.gestiuniGroupedByVatNumber),function(group){return _c('div',{key:group.vat,staticClass:"location-group"},[(group.gestiuni.length)?[_c('p',{staticClass:"location-label"},[_vm._v("\n              "+_vm._s(group.label)+" — VAT: "+_vm._s(group.vat)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":group.gestiuni}},[_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.numeGestiune'),"prop":"name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(scope.row.name)+"\n                        "),(_vm.isDefaultForLocation(scope.row._id, scope.row.externalLocationId))?_c('span',{staticClass:"default-label"},[_vm._v("\n                          Default\n                        ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.category'),"prop":"categorie"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.categorie))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.tipGestiune'),"prop":"gestiune_type"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.gestiune_type))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.workPoint'),"prop":"nume_punct_de_lucru"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.nume_punct_de_lucru))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.adresaPunctLucru'),"prop":"adresa_punct_de_lucru"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.adresa_punct_de_lucru))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.numeGestionar'),"prop":"gestionar"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.gestionar))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.codContabil'),"prop":"cod_contabil"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.cod_contabil))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('marketingOffers.actions'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                            ▾ ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editRowGestiune(row)}}},[_vm._v("\n                              "+_vm._s(_vm.$t('general.edit'))+"\n                            ")]),_vm._v(" "),_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},nativeOn:{"click":function($event){_vm.handleDeleteGestiune(row)}}},[_vm._v("\n                              "+_vm._s(_vm.$t('general.delete'))+"\n                            ")])],1)],1)]}}])})],1)],1)])])]:_vm._e()],2)}):_vm._e(),_vm._v(" "),(!_vm.gestiuniGroupedByVatNumber.some(function (g) { return g.gestiuni.length; }))?[_c('p',{staticClass:"mar-to-20 text-center"},[_vm._v("\n          "+_vm._s(_vm.$t('gestiune.noGestiuni'))+"\n        ")])]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.isSeries)?_c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"}),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.openSeriesModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('invoice.addSeries'))+"\n          ")])])]),_vm._v(" "),_vm._l((_vm.groupedSeriesByVat),function(group){return _c('div',{key:group.vat,staticClass:"vat-group"},[_c('p',{staticClass:"location-label"},[_vm._v("\n          "+_vm._s(group.locationsNames)+" — VAT: "+_vm._s(group.vat)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":group.series}},[_c('el-table-column',{attrs:{"label":_vm.$t('invoice.type'),"prop":"tip"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.tip))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('invoice.series'),"prop":"series"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.series))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('invoice.startNumber'),"prop":"startNumber"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.startNumber))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.currentNumber'),"prop":"currentNumber"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.currentNumber))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('marketingOffers.actions'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                        ▾\n                      ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},nativeOn:{"click":function($event){_vm.handleDeleteSeries(row._id)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('general.delete'))+"\n                        ")])],1)],1)]}}])})],1)],1)])])])}),_vm._v(" "),(!_vm.groupedSeriesByVat.length)?_c('div',{staticClass:"no-series-message text-center mar-to-20"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.noSeries')))])]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.isCategories)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.tableDataCategories}},[_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.categorii'),"prop":"category"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.category)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.contContabil'),"prop":"account"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.account)+"\n                ")]}}])})],1)],1)])])]):_vm._e(),_vm._v(" "),(_vm.isOperation)?_c('div',{staticStyle:{"display":"flex","gap":"5px"}},[_c('div',{staticClass:"card mar-to-15 col-md-6"},[_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația (Punct de lucru)")]),_vm._v(" "),_vm._l((_vm.locations),function(location){return _c('option',{key:location.id,domProps:{"value":location}},[_vm._v("\n                "+_vm._s(location.name)+_vm._s(location.gestiune_start_sync_order ? ' (Start: ' + location.gestiune_start_sync_order + ')' : '')+"\n              ")])})],2),_vm._v(" "),(_vm.selectedLocation && _vm.selectedLocation.gestiune_start_sync_order)?_c('div',{staticStyle:{"margin-top":"8px"}},[_c('span',{staticStyle:{"font-weight":"500","background-color":"#28a745","color":"white","padding":"3px 7px","border-radius":"4px"}},[_vm._v("\n                Start: "+_vm._s(_vm.selectedLocation.gestiune_start_sync_order)+"\n              ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-10"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.dataStart')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDate),expression:"selectedDate"}],staticClass:"form-control",attrs:{"type":"datetime-local","max":_vm.maxDate,"min":_vm.minDate},domProps:{"value":(_vm.selectedDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mar-to-15 d-flex"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",attrs:{"disabled":!_vm.selectedLocation || !_vm.selectedDate},on:{"click":function($event){_vm.toggleSales(true, _vm.selectedLocation.inv_fiscal_code)}}},[_vm._v("\n              "+_vm._s(_vm.selectedLocation && _vm.selectedLocation.gestiune_start_sync_order ? 'Modifică vânzările' : 'Pornește vânzările')+"\n            ")]),_vm._v(" "),_c('a',{staticClass:"btn delete mar-rt-10",class:{ disabled: !_vm.selectedLocation || !_vm.selectedLocation.gestiune_start_sync_order },attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.toggleSales(false)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n               Oprește vânzările\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 col-md-6"},[_c('div',{staticClass:"card-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("CIF")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedVatExport),expression:"selectedVatExport"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedVatExport=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Selectează CIF-ul")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('option',{key:group.vat,domProps:{"value":group.vat}},[_vm._v("\n                "+_vm._s(_vm.getVatOptionLabel(group))+"\n              ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"mar-to-15"},[_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"disabled":!_vm.selectedVatExport},on:{"click":_vm.exportNomenclator}},[_vm._v("\n              Exportă Nomenclator\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 col-md-6"},[_c('div',{staticClass:"card-content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("CIF")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedVatSpv),expression:"selectedVatSpv"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedVatSpv=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.fetchSpvStatus]}},[_c('option',{attrs:{"value":""}},[_vm._v("Selectează CIF-ul")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('option',{key:group.vat,domProps:{"value":group.vat}},[_vm._v("\n                "+_vm._s(_vm.getVatOptionLabel(group))+"\n              ")])})],2)]),_vm._v(" "),(_vm.selectedVatSpv && _vm.spvStatusLoaded)?_c('div',{staticClass:"mar-b-10"},[(_vm.spvStatus.hasToken)?_c('div',{staticClass:"badge badge-success"},[_vm._v("\n              Token existent\n            ")]):_c('div',{staticClass:"badge badge-warning"},[_vm._v("\n              Fără token SPV\n            ")]),_vm._v(" "),(_vm.spvStatus.hasToken)?_c('div',{staticClass:"spv-expire-box"},[_c('small',[_vm._v("\n                Expiră la:\n                "+_vm._s(_vm.formatDate(_vm.spvStatus.expiresAt))+"\n              ")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mar-to-15"},[_c('button',{staticClass:"btn btn-icon btn-primary spv-enroll-btn",attrs:{"type":"button","disabled":!_vm.selectedVatSpv},on:{"click":_vm.openSpvEnroll}},[_vm._v("\n              "+_vm._s(_vm.spvStatus.hasToken ? 'Administrează token' : 'Activează token')+"\n            ")]),_vm._v(" "),(!_vm.selectedVatSpv)?_c('p',{staticClass:"spv-enroll-hint"},[_vm._v("\n              Selectează un CIF pentru a continua.\n            ")]):_vm._e()])])])]):_vm._e(),_vm._v(" "),(_vm.isOrderErrors)?_c('div',[_c('ManagementOrderErrors',{attrs:{"locations":_vm.locations}})],1):_vm._e(),_vm._v(" "),(_vm.isBankAccounts)?_c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"}),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.openBankModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              Adaugă Cont Bancar\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.bankAccounts}},[_c('el-table-column',{attrs:{"prop":"iban","label":"IBAN"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bank","label":"Banca"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"currency","label":"Moneda"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"swift","label":"SWIFT"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Acțiuni"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.deleteBankAccount(row)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('general.delete'))+"\n                  ")])]}}])})],1)],1)])])]):_vm._e(),_vm._v(" "),_c('vmodal',{attrs:{"name":"bankAccountModal","height":"auto","width":"800"},model:{value:(_vm.showBankModal),callback:function ($$v) {_vm.showBankModal=$$v},expression:"showBankModal"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v("Adaugă Cont Bancar")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("IBAN")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAccount.iban),expression:"newAccount.iban"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Introduceți IBAN"},domProps:{"value":(_vm.newAccount.iban)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAccount, "iban", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Banca")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAccount.bank),expression:"newAccount.bank"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Introduceți banca"},domProps:{"value":(_vm.newAccount.bank)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAccount, "bank", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Moneda")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAccount.currency),expression:"newAccount.currency"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newAccount, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"RON"}},[_vm._v("RON")]),_vm._v(" "),_c('option',{attrs:{"value":"EUR"}},[_vm._v("EUR")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("SWIFT")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newAccount.swift),expression:"newAccount.swift"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Introduceți SWIFT"},domProps:{"value":(_vm.newAccount.swift)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newAccount, "swift", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":function($event){$event.preventDefault();return _vm.addBankAccount($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeBankModal}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))])])])])])]),_vm._v(" "),_c('vmodal',{attrs:{"name":"addGestiuneModal","height":"auto","width":"800"},model:{value:(_vm.showGestiuneModal),callback:function ($$v) {_vm.showGestiuneModal=$$v},expression:"showGestiuneModal"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addManagment')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.numeGestiune'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gestiune),expression:"gestiune"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.gestiune),expression:"modelValidate.gestiune"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.numeGestiune')},domProps:{"value":(_vm.gestiune)},on:{"input":function($event){if($event.target.composing){ return; }_vm.gestiune=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Categoria *")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeGestion),expression:"typeGestion"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.typeGestion),expression:"modelValidate.typeGestion"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.typeGestion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează Categoria")]),_vm._v(" "),_vm._l((_vm.tableDataCategories),function(item,index){return _c('option',{key:index,domProps:{"value":item.category}},[_vm._v("\n                              "+_vm._s(item.category)+"\n                            ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.numeGestionar')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.administrator),expression:"administrator"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.numeGestionar')},domProps:{"value":(_vm.administrator)},on:{"input":function($event){if($event.target.composing){ return; }_vm.administrator=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.codGestiune')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.codGestiune),expression:"codGestiune"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.codGestiune')},domProps:{"value":(_vm.codGestiune)},on:{"input":function($event){if($event.target.composing){ return; }_vm.codGestiune=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locatia (Punct de lucru)")]),_vm._v(" "),_vm._l((_vm.locations),function(location){return _c('option',{key:location.id,domProps:{"value":location}},[_vm._v("\n                              "+_vm._s(location.name)+"\n                            ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.adresaPunctLucru')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation.street),expression:"selectedLocation.street"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.adresaPunctLucru'),"disabled":""},domProps:{"value":(_vm.selectedLocation.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedLocation, "street", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.codContabil')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.codContabil),expression:"codContabil"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.codContabil')},domProps:{"value":(_vm.codContabil)},on:{"input":function($event){if($event.target.composing){ return; }_vm.codContabil=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.analitic')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.analitic),expression:"analitic"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.analitic'),"disabled":!_vm.codContabil},domProps:{"value":(_vm.analitic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.analitic=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Depozit")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipDepozit),expression:"tipDepozit"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipDepozit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează tipul")]),_vm._v(" "),_c('option',{attrs:{"value":"Depozit"}},[_vm._v("Da")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6",staticStyle:{"position":"relative","top":"40px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isDefaultGestiune),expression:"isDefaultGestiune"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isDefaultGestiune)?_vm._i(_vm.isDefaultGestiune,null)>-1:(_vm.isDefaultGestiune)},on:{"change":function($event){var $$a=_vm.isDefaultGestiune,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isDefaultGestiune=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isDefaultGestiune=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isDefaultGestiune=$$c}}}}),_vm._v("\n                            "+_vm._s(_vm.$t('gestiune.default'))+"\n                          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeGestiuneModal}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])]),_vm._v(" "),_c('ManagementSeriesAdd',{attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations},on:{"getSeries":_vm.getSeries}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mar-b-15"},[_c('h5',[_vm._v("Pornește vânzările")]),_vm._v(" "),_c('div',{staticClass:"info-text"},[_vm._v("\n              Prin selectarea locației și a datei, se pornesc bonurile fiscale din Taptasty în gestiune,\n              iar mișcările de stoc vor apărea în raport.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mar-b-15"},[_c('h5',[_vm._v("Export Nomenclator")]),_vm._v(" "),_c('div',{staticClass:"info-text"},[_vm._v("\n              Alege CIF-ul pentru care dorești să exporti catalogul\n              de produse în format CSV.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mar-b-15"},[_c('h5',[_vm._v("Activare SPV (ANAF)")]),_vm._v(" "),_c('div',{staticClass:"info-text"},[_vm._v("\n              Alege CIF-ul și activează conexiunea SPV pentru transmiterea documentelor fiscale către ANAF.\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IZUt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryEdit_vue__ = __webpack_require__("6HWz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ef6e448_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryEdit_vue__ = __webpack_require__("ZhiD");
function injectStyle (ssrContext) {
  __webpack_require__("EcL7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ef6e448_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ia+4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementBonProductForm_vue__ = __webpack_require__("P0Ic");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneBonProductForm', __WEBPACK_IMPORTED_MODULE_7__ManagementBonProductForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "Ib+y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabelEvolution_vue__ = __webpack_require__("f1TT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec1d09ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabelEvolution_vue__ = __webpack_require__("e2cc");
function injectStyle (ssrContext) {
  __webpack_require__("NVJu")
  __webpack_require__("i/Hx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabelEvolution_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec1d09ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabelEvolution_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcKo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


var _mutations;




__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var LOGIN = 'LOGIN';
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGOUT = 'LOGOUT';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    isLoggedIn: !!localStorage.getItem('token')
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LOGIN, function (state) {
    state.pending = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LOGIN_SUCCESS, function (state) {
    state.isLoggedIn = true;
    state.pending = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LOGOUT, function (state) {
    state.isLoggedIn = false;
  }), _mutations),
  actions: {
    login: function login(_ref, creds) {
      var commit = _ref.commit;

      commit(LOGIN);
      localStorage.setItem('token', creds.token);
      commit(LOGIN_SUCCESS);
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;

      localStorage.removeItem('token');
      commit(LOGOUT);
    }
  },
  getters: {
    isLoggedIn: function isLoggedIn(state) {
      return state.isLoggedIn;
    }
  }
}));

/***/ }),

/***/ "IdNy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_picker_css__ = __webpack_require__("5ObC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_time_picker__ = __webpack_require__("4ZDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Sections_KdsSections_vue__ = __webpack_require__("FSfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__KdsSettingsUsers_vue__ = __webpack_require__("mOD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_UIComponents_BackgroundColorPicker_vue__ = __webpack_require__("8zHz");




























__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    PSwitch: __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__["a" /* default */],
    KdsSections: __WEBPACK_IMPORTED_MODULE_17__Sections_KdsSections_vue__["a" /* default */],
    KdsSettingsUsers: __WEBPACK_IMPORTED_MODULE_18__KdsSettingsUsers_vue__["a" /* default */],
    BackgroundColorPicker: __WEBPACK_IMPORTED_MODULE_22_src_components_UIComponents_BackgroundColorPicker_vue__["a" /* default */],
    'el-time-picker': __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_time_picker___default.a,
    PPagination: __WEBPACK_IMPORTED_MODULE_21_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input___default.a),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    },
    openUsersProp: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      isGeneral: true,
      isUsers: false,
      isSections: false,
      useStartTimerForAllItems: false,
      startTimer: false,
      useOrderLanes: false,
      allowOptionTimer: false,
      allowCourseTimer: false,
      timeProcessingStatus: false,
      displayStartedOrdersFirst: false,
      groupProductsByCategory: false,
      hidePreparedItems: false,
      displayWaiterName: false,
      displayDeliveryTime: false,
      useAutoCloseOrders: false,
      autoPrint: false,
      notificationSound: 1,
      displayOrdersGrid: false,
      displayOrdersMode: 1,
      ordersSortColumn: 'pickup_datetime',
      productSorting: 1,
      orderAveragePrepTime: '00:00:00',
      lane1background: null,
      lane2background: null,
      tableColumns: [{
        prop: 'firstname',
        label: this.$t('settingUsers.fn'),
        minWidth: 100
      }, {
        prop: 'lastname',
        label: this.$t('settingUsers.ln'),
        minWidth: 100
      }],
      tableData: [],
      colors: {
        black: '#000'
      }
    };
  },

  computed: {
    filteredTableData: function filteredTableData() {
      return this.tableData.filter(function (user) {
        return user.role === 'KDS_OPERATOR';
      });
    },
    displayOrdersModeOptions: function displayOrdersModeOptions() {
      return [{ value: 1, label: this.$t('kds.displayOrdersModeVertical') }, { value: 2, label: this.$t('kds.displayOrdersModeOscilloscopic') }, { value: 3, label: this.$t('kds.displayOrdersModeHorizontal') }];
    },
    notificationSoundOptions: function notificationSoundOptions() {
      return [{ value: 1, label: this.$t('kds.sound1') }, { value: 2, label: this.$t('kds.sound2') }, { value: 3, label: this.$t('kds.sound3') }];
    },
    ordersSortColumnOptions: function ordersSortColumnOptions() {
      return [{ value: 'pickup_datetime', label: this.$t('kds.ordersSortColumnPickup') }, { value: 'created_at', label: this.$t('kds.ordersSortColumnCreated') }];
    },
    productSortingOptions: function productSortingOptions() {
      return [{ value: 1, label: this.$t('kds.productSortingChronologic') }, { value: 2, label: this.$t('kds.productSortingPrepTime') }];
    }
  },
  mounted: function mounted() {
    if (this.openUsersProp) {
      this.openUsers();
    }
  },
  created: function created() {
    if (this.openUsersProp) {
      this.openUsers();
    }
    this.getUsers();
    this.getSettings();
  },

  watch: {
    useStartTimerForAllItems: function useStartTimerForAllItems() {
      this.updateSettings();
    },
    startTimer: function startTimer() {
      this.updateSettings();
    },
    useOrderLanes: function useOrderLanes() {
      this.updateSettings();
    },
    allowOptionTimer: function allowOptionTimer() {
      this.updateSettings();
    },
    allowCourseTimer: function allowCourseTimer() {
      this.updateSettings();
    },
    timeProcessingStatus: function timeProcessingStatus() {
      this.updateSettings();
    },
    displayStartedOrdersFirst: function displayStartedOrdersFirst() {
      this.updateSettings();
    },
    groupProductsByCategory: function groupProductsByCategory() {
      this.updateSettings();
    },
    hidePreparedItems: function hidePreparedItems() {
      this.updateSettings();
    },
    displayWaiterName: function displayWaiterName() {
      this.updateSettings();
    },
    displayDeliveryTime: function displayDeliveryTime() {
      this.updateSettings();
    },
    useAutoCloseOrders: function useAutoCloseOrders() {
      this.updateSettings();
    },
    autoPrint: function autoPrint() {
      this.updateSettings();
    },
    notificationSound: function notificationSound() {
      this.updateSettings();
    },
    displayOrdersGrid: function displayOrdersGrid() {
      this.updateSettings();
    },
    displayOrdersMode: function displayOrdersMode() {
      this.updateSettings();
    },
    ordersSortColumn: function ordersSortColumn() {
      this.updateSettings();
    },
    productSorting: function productSorting() {
      this.updateSettings();
    },
    lane1background: function lane1background() {
      this.updateSettings();
    },
    lane2background: function lane2background() {
      this.updateSettings();
    }
  },
  methods: {
    openGeneral: function openGeneral() {
      this.isGeneral = true;
      this.isUsers = false;
      this.isSections = false;
    },
    openUsers: function openUsers() {
      this.isUsers = true;
      this.isGeneral = false;
      this.isSections = false;
    },
    openSections: function openSections() {
      this.isSections = true;
      this.isGeneral = false;
      this.isUsers = false;
    },
    globalGoToRecord: function globalGoToRecord(row, event, path) {
      var userId = row.id;
      this.$router.push('' + path + userId);
    },
    goToRecord: function goToRecord(row, event) {
      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, '/user/edit/');
      }
    },
    goToAdd: function goToAdd() {
      this.$router.push({ path: '/user/add', query: { from: 'kdsSettings' } });
    },
    getUsers: function getUsers() {
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/profile', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data;

          self.$nextTick(function () {
            self.loading = false;
          });
        }
      });
    },
    getSettings: function getSettings() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/kds/settings/', 'GET', data, function (response) {
        if (response.status === true) {
          _this.useStartTimerForAllItems = response.data.use_start_timer_for_all_items === true;
          _this.startTimer = response.data.start_timer === true || response.data.start_timer === 1 || response.data.start_timer === '1';
          _this.useOrderLanes = response.data.use_order_lanes === true;
          _this.allowOptionTimer = response.data.allow_start_timer_per_option === true;
          _this.allowCourseTimer = response.data.allow_start_timer_course === true;
          _this.timeProcessingStatus = response.data.time_processing_status === true;
          _this.displayStartedOrdersFirst = response.data.display_started_orders_first === true;
          _this.groupProductsByCategory = response.data.group_products_by_category === true;
          _this.hidePreparedItems = response.data.hide_prepared_items === true;
          _this.displayWaiterName = response.data.display_waiter_name === true;
          _this.displayDeliveryTime = response.data.display_delivery_time === true;
          _this.useAutoCloseOrders = response.data.use_auto_close_orders === true;
          _this.autoPrint = response.data.auto_print === true;
          var notificationSound = parseInt(response.data.notification_sound_type, 10);
          _this.notificationSound = [1, 2, 3].includes(notificationSound) ? notificationSound : 1;
          _this.displayOrdersGrid = response.data.display_orders_grid === true;
          var mode = parseInt(response.data.display_orders_mode, 10);
          _this.displayOrdersMode = [1, 2, 3].includes(mode) ? mode : 1;
          var sortColumn = response.data.orders_sort_column;
          _this.ordersSortColumn = ['pickup_datetime', 'created_at'].includes(sortColumn) ? sortColumn : 'pickup_datetime';
          var productSorting = parseInt(response.data.product_sorting, 10);
          _this.productSorting = [1, 2].includes(productSorting) ? productSorting : 1;
          _this.orderAveragePrepTime = _this.formatTime(response.data.order_average_prep_time) || '00:00:00';
          _this.lane1background = response.data.lane_1_background;
          _this.lane2background = response.data.lane_2_background;
          _this.loading = false;
        }
      });
    },
    formatTime: function formatTime(timeString) {
      var parts = timeString.split(':');
      if (parts.length === 3) {
        var date = new Date();
        date.setHours(parts[0]);
        date.setMinutes(parts[1]);
        date.setSeconds(parts[2]);
        return date;
      }
      return null;
    },
    getNotificationSoundSrc: function getNotificationSoundSrc(sound) {
      var soundMap = {
        1: '/static/audio/beep.mp3',
        2: '/static/audio/beep2.mp4',
        3: '/static/audio/order-alert-1.wav'
      };
      return soundMap[sound] || soundMap[1];
    },
    playNotificationSound: function playNotificationSound() {
      var audio = new Audio(this.getNotificationSoundSrc(this.notificationSound));
      audio.play();
    },
    updateSettings: function updateSettings() {
      var date = new Date(this.orderAveragePrepTime);
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');

      var formattedPrepTime = hours + ':' + minutes + ':' + seconds;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        use_start_timer_for_all_items: this.useStartTimerForAllItems ? 1 : 0,
        start_timer: this.startTimer ? 1 : 0,
        use_order_lanes: this.useOrderLanes ? 1 : 0,
        allow_start_timer_per_option: this.allowOptionTimer ? 1 : 0,
        allow_start_timer_course: this.allowCourseTimer ? 1 : 0,
        time_processing_status: this.timeProcessingStatus ? 1 : 0,
        display_started_orders_first: this.displayStartedOrdersFirst ? 1 : 0,
        group_products_by_category: this.groupProductsByCategory ? 1 : 0,
        hide_prepared_items: this.hidePreparedItems ? 1 : 0,
        display_waiter_name: this.displayWaiterName ? 1 : 0,
        display_delivery_time: this.displayDeliveryTime ? 1 : 0,
        use_auto_close_orders: this.useAutoCloseOrders ? 1 : 0,
        auto_print: this.autoPrint ? 1 : 0,
        notification_sound_type: this.notificationSound,
        order_average_prep_time: formattedPrepTime,
        display_orders_grid: this.displayOrdersGrid,
        display_orders_mode: this.displayOrdersMode,
        orders_sort_column: this.ordersSortColumn,
        product_sorting: this.productSorting,
        lane_1_background: this.lane1background,
        lane_2_background: this.lane2background
      };
      this.apiRequest('/kds/settings', 'PUT', data, function (response) {
        if (response.status === true) {}
      });
    },
    updatePrepTime: function updatePrepTime() {
      this.updateSettings();
    },
    updateColor: function updateColor(value, attribute) {
      this[attribute] = value;
    }
  }
});

/***/ }),

/***/ "Iddv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__("O5me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_wysiwyg_dist_vueWysiwyg_css__);












var _components;








__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a), _components),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vee_validate__["b" /* mapFields */])(['title', 'description', 'sort_order', 'image']), {
    imageSizes: function imageSizes() {
      return [{ value: 'contain', label: this.$t('settingsInfoPages.imageSizeContain') }, { value: 'cover', label: this.$t('settingsInfoPages.imageSizeCover') }, { value: 'full_page', label: this.$t('settingsInfoPages.imageSizeFullPage') }];
    }
  }),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      model: {
        show_in_header: false,
        show_in_footer: false,
        image_size: null
      },
      modelValidations: {
        title: {
          required: true,
          min: 5
        }
      },
      loading: true,
      imagelist: []
    };
  },

  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      this.loading = true;
    });
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    if (this.route.params.id) {
      var id = this.route.params.id;
      this.apiRequest('/settings/infopages/' + id, 'GET', data, function (response) {
        if (response.status === true) {
          _this.model = response.data[0];
          _this.$nextTick(function () {
            _this.loading = false;
          });
        } else {
          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    }
    this.$nextTick(function () {
      _this.loading = false;
    });
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      var isEditorValid = this.validateEditor();

      if (!isEditorValid) {
        return false;
      }

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.errors.clear();
          _this2.savePage();
        }
      });
    },
    validateEditor: function validateEditor() {
      if (this.errors.items.length) {
        this.errors.items = this.errors.items.filter(function (item) {
          return item.field !== 'description';
        });
      }

      if (!this.model.description || this.model.description.length <= 5) {
        this.errors.add('description', 'Field is required. Min length: 5');

        return false;
      }

      return true;
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    isNew: function isNew() {
      if (this.route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    handleDelete: function handleDelete(label) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
        text: this.$t('infoPages.areYouSure', { label: this.$t('infoPages.' + label) }),
        type: 'question',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel'),
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          if (_this3.isNew()) {
            _this3.$bus.$emit('refresh');
            _this3.$bus.$emit('close-modal');
          } else {
            var id = _this3.route.params.id;
            var data = {
              id: id,
              token: _this3.$session.get('token'),
              company_id: _this3.$session.get('selectedCompany')
            };
            _this3.apiRequest('/settings/infopages/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
                  text: _this3.$t('infoPages.deleted'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                });

                _this3.$bus.$emit('refresh');
                _this3.$bus.$emit('close-modal');
              } else {
                __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : _this3.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var _this4 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
        this.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.imagelist = fileList.slice(1);
        } else {
          this.imagelist = fileList;
        }
      }
      if (this.imagelist && this.imagelist[0].status === 'ready') {
        this.getBase64(this.imagelist[0].raw).then(function (base64enc) {
          _this4.model.image = base64enc;
        });
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.imagelist = [];
        this.model.image = null;
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
      }
      return isOkSize;
    },
    savePage: function savePage() {
      var _this5 = this;

      this.loading = true;
      var data = this.model;
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      data.type = 'CUSTOM';
      if (this.isNew()) {
        this.apiRequest('/settings/infopages', 'POST', data, function (response) {
          if (response.status === true) {
            _this5.$nextTick(function () {
              _this5.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
              title: '',
              text: _this5.$t('infoPages.added'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});

            _this5.$bus.$emit('refresh');
            _this5.$bus.$emit('close-modal');
          } else {
            _this5.$nextTick(function () {
              _this5.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
              title: '',
              text: _this5.$t('catalogCateg.couldNotSave'),
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
            _this5.$nextTick(function () {
              _this5.loading = false;
            });

            _this5.$bus.$emit('refresh');
            _this5.$bus.$emit('close-modal');
          }
        });
      } else {
        var self = this;
        var id = this.route.params.id;
        this.apiRequest('/settings/infopages/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            self.$nextTick(function () {
              self.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
              title: '',
              text: self.$t('infoPages.updated'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then(function () {}).catch(function () {});
            _this5.$bus.$emit('refresh');
            _this5.$bus.$emit('close-modal');
            if (typeof self.callback === 'function') {
              self.callback();
            }
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
              title: '',
              text: self.$t('catalogCateg.couldNotUpdate'),
              type: 'danger',
              showConfirmButton: false,
              timer: 1500
            }).then(function () {}).catch(function () {});
            _this5.$nextTick(function () {
              _this5.loading = false;
            });

            _this5.$bus.$emit('refresh');
            _this5.$bus.$emit('close-modal');
          }
        });
      }
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "Iic6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ij4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopCategories_vue__ = __webpack_require__("HeUh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de1e291c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopCategories_vue__ = __webpack_require__("l9QA");
function injectStyle (ssrContext) {
  __webpack_require__("GoHO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de1e291c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IjU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ijvv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationAdd_vue__ = __webpack_require__("+p52");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91a731f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationAdd_vue__ = __webpack_require__("WPuu");
function injectStyle (ssrContext) {
  __webpack_require__("IjU4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91a731f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IkKL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IlTL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons "},[_c('div',{staticClass:"left-buttons mar-rt-10"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[(_vm.groupedLocations)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date și oră")]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"disabled":_vm.loading || !_vm.selectedGestiune,"placeholder":"Selectează intervalul"},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"right-buttons",staticStyle:{"display":"flex","align-items":"center","justify-content":"flex-end"}},[_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.triggerFilter}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.fetchPurchaseReport('xls')}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"tableInvoice",staticStyle:{"overflow-x":"auto"}},[(_vm.tableData && _vm.tableData.length)?_c('div',{staticClass:"consumption-total-header"},[_c('strong',[_vm._v("TOTAL:")]),_vm._v("\n            "+_vm._s(_vm.totalItems)+" produse —\n            "),_c('strong',[_vm._v(_vm._s(_vm.totalValue.toFixed(2))+" lei")])]):_vm._e(),_vm._v(" "),_c('el-table',{staticStyle:{"min-width":"max-content"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.openViewPurchase}},[_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('gestiune.product'),"min-width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.price'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.price !== null)?_c('span',[_vm._v("\n                  "+_vm._s(Number(scope.row.price).toFixed(2))+" lei\n                ")]):_c('span',{staticStyle:{"cursor":"pointer","text-decoration":"underline","color":"#409EFF"},on:{"click":function($event){$event.stopPropagation();_vm.openViewPurchase(scope.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.see'))+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.cantitate'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.quantity).toFixed(2))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"UM","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.unit)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.stoc.valoareTotala'),"min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.value).toFixed(2))+" lei\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},on:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box",on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("\n                    ▾ ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.openNirModal(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.see'))+"\n                    ")])],1)],1)]}}])})],1)],1)])]),_vm._v(" "),_c('vmodal',{staticClass:"nirModal",attrs:{"name":"nirModal","height":"auto","width":"800"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.nirsProduct'))+" "+_vm._s(_vm.selectedProduct.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('el-table',{staticStyle:{"width":"100%","background":"transparent"},attrs:{"data":_vm.selectedProduct.nirDocuments}},[_c('el-table-column',{attrs:{"prop":"series","label":_vm.$t('invoice.series'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"number","label":_vm.$t('gestiune.number'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qty","label":_vm.$t('gestiune.cantitate'),"width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unit","label":"UM","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.unit)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"data_document","label":_vm.$t('gestiune.date'),"width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.data_document ? new Date(scope.row.data_document).toLocaleString() : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price","label":_vm.$t('gestiune.price'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.price).toFixed(2))+" lei\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":_vm.$t('gestiune.total'),"width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.total).toFixed(2))+" lei\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticStyle:{"margin-top":"0px !important"},attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.goToNir(scope.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.see'))+" NIR\n                ")])]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeNirModal}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))])])])])])]),_vm._v(" "),_c('vmodal',{ref:"purchaseModal",staticClass:"purchaseModal",attrs:{"name":"purchaseModal","height":"auto","width":"800"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v("Detalii produs: "+_vm._s(_vm.selectedProduct.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('el-table',{staticStyle:{"width":"100%","background":"transparent"},attrs:{"data":_vm.selectedProduct.purchaseDocuments}},[_c('el-table-column',{attrs:{"prop":"quantity","label":"Cantitate"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.quantity).toFixed(2))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unit","label":"UM"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price","label":"Preț"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.price).toFixed(2))+" lei\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"Valoare"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.value).toFixed(2))+" lei\n              ")]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closePurchaseModal}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IqUa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IqgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t11_vue__ = __webpack_require__("8Hhm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cddb61f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t11_vue__ = __webpack_require__("XECX");
function injectStyle (ssrContext) {
  __webpack_require__("9PmA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cddb61f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t11_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cddb61f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t11_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IrVx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ItDH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iu1Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IuKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementStocksForm_vue__ = __webpack_require__("Fxae");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneStocuriForm', __WEBPACK_IMPORTED_MODULE_7__ManagementStocksForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "IuL4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RaffleCampaignForm_vue__ = __webpack_require__("m4/V");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RaffleCampaignForm: __WEBPACK_IMPORTED_MODULE_0__RaffleCampaignForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),

/***/ "J0t7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InvoiceForm_vue__ = __webpack_require__("vYda");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'InvoiceForm', __WEBPACK_IMPORTED_MODULE_7__InvoiceForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "J2tZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){_vm.saveBonTransfer()}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.notaTransfer')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.fromLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                    "+_vm._s(loc.name)+"\n                  ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gestiune"}},[_vm._v(_vm._s(_vm.$t('gestiune.fromGestiune'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonTransfer.fromGestiune),expression:"bonTransfer.fromGestiune"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.bonTransfer, "fromGestiune", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează gestiunea")]),_vm._v(" "),_vm._l((_vm.filteredGestiuni),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v("\n                  "+_vm._s(option.name)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.toLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedToLocationId),expression:"selectedToLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedToLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,attrs:{"disabled":_vm.isDisabledToLocation(loc)},domProps:{"value":loc.true_id}},[_vm._v("\n                    "+_vm._s(loc.name)+"\n                  ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gestiune"}},[_vm._v(_vm._s(_vm.$t('gestiune.toGestiune'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonTransfer.toGestiune),expression:"bonTransfer.toGestiune"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.bonTransfer, "toGestiune", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează gestiunea")]),_vm._v(" "),_vm._l((_vm.filteredToGestiuni),function(option){return _c('option',{key:option.id,attrs:{"disabled":option.disabled},domProps:{"value":option.id}},[_vm._v("\n                  "+_vm._s(option.name)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"serie"}},[_vm._v(_vm._s(_vm.$t('invoice.series'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonTransfer.serie),expression:"bonTransfer.serie"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.bonTransfer, "serie", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.handleSerieChange]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează seria")]),_vm._v(" "),(_vm.isEdit)?_c('option',{domProps:{"value":_vm.bonTransfer.serie}},[_vm._v("\n                  "+_vm._s(_vm.bonTransfer.serie)+"\n                ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.seriesOptionsWithAdd),function(serie){return _c('option',{key:serie.value,domProps:{"value":serie.value}},[_vm._v("\n                  "+_vm._s(serie.label)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.data'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonTransfer.date),expression:"bonTransfer.date"}],staticClass:"form-control",attrs:{"type":"datetime-local","name":"date","max":_vm.today,"disabled":!_vm.selectedLocationId},domProps:{"value":(_vm.bonTransfer.date)},on:{"change":function($event){_vm.checkValidatedAfter(_vm.bonTransfer.date)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bonTransfer, "date", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProductInBonTransfer')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.productName'),"prop":"productName"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.productName)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.um'),"prop":"um"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.um)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.cantitate'),"prop":"cantitate"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.cantitate)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editRow(scope.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.edit'))+"\n                ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.deleteRow(scope.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")])],1)],1)]}}])})],1),_vm._v(" "),_c('button',{staticClass:"btn add mar-rt-10 mar-bt-5 mar-to-15",attrs:{"disabled":!_vm.selectedLocationId,"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.openAddProductModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n        "+_vm._s(_vm.$t('gestiune.addProduct'))+"\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"gap":"15px","display":"flex"}},[_c('div',{staticClass:"card col-md-6 no-padding"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"}),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gestionar"}},[_vm._v(_vm._s(_vm.$t('gestiune.manager')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introdu numele gestionarului"},model:{value:(_vm.bonTransfer.manager),callback:function ($$v) {_vm.$set(_vm.bonTransfer, "manager", $$v)},expression:"bonTransfer.manager"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"primitor"}},[_vm._v(_vm._s(_vm.$t('gestiune.receiver')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introdu numele primitorului"},model:{value:(_vm.bonTransfer.receiver),callback:function ($$v) {_vm.$set(_vm.bonTransfer, "receiver", $$v)},expression:"bonTransfer.receiver"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"comandaProiect"}},[_vm._v(_vm._s(_vm.$t('gestiune.commandProject')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Adaugă o comandă/proiect"},model:{value:(_vm.bonTransfer.commandProject),callback:function ($$v) {_vm.$set(_vm.bonTransfer, "commandProject", $$v)},expression:"bonTransfer.commandProject"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"notaInterna"}},[_vm._v(_vm._s(_vm.$t('gestiune.internalNote')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Adaugă o notă internă","type":"textarea"},model:{value:(_vm.bonTransfer.internalNote),callback:function ($$v) {_vm.$set(_vm.bonTransfer, "internalNote", $$v)},expression:"bonTransfer.internalNote"}})],1)])])])])])]),_vm._v(" "),_c('vmodal',{staticClass:"addProductModal",attrs:{"name":"addProductModal","height":"auto","width":"600"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProduct')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productName'))+"*")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.searchResults,"label":"label","reduce":function (option) { return option.value; },"placeholder":"Caută un produs...","filterable":false},on:{"search":_vm.fetchProducts,"input":_vm.handleProductSelect},model:{value:(_vm.item.productObject),callback:function ($$v) {_vm.$set(_vm.item, "productObject", $$v)},expression:"item.productObject"}},[[(!_vm.loading)?_c('span',[_vm._v("Niciun produs găsit")]):_vm._e()]],2),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.um'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.um),expression:"item.um"}],staticClass:"form-control",attrs:{"disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "um", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":_vm.item.um}},[_vm._v(_vm._s(_vm.item.um))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.cantitate'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.item.cantitate),expression:"item.cantitate",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.cantitate')},domProps:{"value":(_vm.item.cantitate)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "cantitate", _vm._n($event.target.value))},_vm.validateQty],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.item.stockQuantity !== undefined)?_c('small',[_vm._v("\n                  Stoc disponibil: "),_c('b',[_vm._v(_vm._s(_vm.item.stockQuantity))])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeModal}},[_vm._v("\n              "+_vm._s(_vm.$t('general.cancel2'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":_vm.saveProduct}},[_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n            ")])])])])])]),_vm._v(" "),_c('ManagementSeriesAdd',{attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations,"vat-number":_vm.selectedLocation ? _vm.selectedLocation.inv_fiscal_code : ''},on:{"getSeries":_vm.getSeries}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J7qd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JB2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"box-container row"},_vm._l((_vm.customersRoutes),function(route,index){return _c('div',{key:route.name,staticClass:"col-md-4"},[_c('router-link',{staticClass:"box",style:({ backgroundColor: _vm.getBoxColor(index) }),attrs:{"to":route.path}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('pages.' + route.key)))]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.getImageForRoute(route.key),"alt":'Image for ' + route.key}})])])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JB9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2_dist_sweetalert2_css__);













__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a),
  props: {
    currencylist: {},
    currencyformatlist: {},
    modeldata: {}
  },
  watch: {
    currencylist: function currencylist(value) {
      this.currencies = value;
    },
    currencyformatlist: function currencyformatlist(value) {
      this.currenciesformat = value;
    },
    modeldata: function modeldata(value) {
      this.model = value;
    }
  },
  data: function data() {
    return {
      model: [],
      currencies: [],
      currenciesformat: [],
      modelValidate: {
        name: { required: true },
        email: { required: true, email: true },
        phone: { required: true },
        street: { required: true },
        city: { required: true },
        state: { required: true },
        country: { required: true }
      },
      loading: false
    };
  },
  created: function created() {
    if (this.currencylist && this.currencylist.length) {
      this.currencies = this.currencylist;
    }

    if (this.currencyformatlist && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.currencyformatlist).length) {
      this.currenciesformat = this.currencyformatlist;
    }

    if (this.modeldata && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.modeldata).length) {
      this.model = this.modeldata;
    }
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate(pageId) {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    displayCurrecy: function displayCurrecy(cr) {
      var name = this.getCurrencySymbol(cr.iso);
      return name + ' - ' + cr.name;
    },
    saveDetails: function saveDetails() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'currency_display_format': 1,
        'currency_iso': this.model.currency_iso
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          self.errors.clear();
          self.$session.set('selectedCompanyData', self.buildCompanySessionData(response.data[0]));
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({ 'text': self.$t('settingCurrency.saveMsg'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    }
  }
});

/***/ }),

/***/ "JE2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JElF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_KEY; });
var API_KEY = 'AIzaSyCH3VjJoX4lToMOIgi7adyXkv0HWEG6BJg&libraries=drawing';

/***/ }),

/***/ "JFQz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAApCAYAAABUdSs8AAAABHNCSVQICAgIfAhkiAAAA5xJREFUWEfVmF1IVEEUx8+stolFhX1AVqL0JCVEJERRUAmpBWEPRbSbmWW9FEQfEJEURVSULwVhkqG7q+BLhukqJhJSYBBB5ENUhGUfYoEUy9a27uk/N1fb9u7euevdhebFu3fOnPM7HzNzroJMjE4Pb2OmjcS0CsvySNBCJhrE7zdC0GNbiO5v3iP6TaiECoXhdfMmGL4OI/lG4gDy2piOFDvFayNZOR8XgM+yzbuUzsPwKSPZCGNMPijeCYh2I4i4APD8ChScMFISYx5Bo3WlDvEo3vqYAB1uLsFkR4LGtWUg+GwP0fKicvE1lh5dgIEWtg/+pFcIfc5UAMbX1pY4xCFTAF4PH0Vl11hgXFMREpS7ZbcY1NOnGwHk/gmEC60CQC0cRy1cUwLobOEsDlDMnCUI1YM0FCkBtLu5wEb0PEFDussQgSFEYIkSQJeH14eYHloJIHUhArrpjnrZ6eKVLOipxQBBAExTikBPAy8KpNGQxQDvAaC7pXXDgkNoBBPzLIS4C4DtShGQQl4X1+GW2G8VAE7E8lKnaFQG6G7k/KCNBrBA6bY0AP2YY6e8ZTtEQBlgPAq1MF811SjAewe895g6iqVw7x3O8KdTHzaPbD4SG0y3SpziYLzFcUP8oIHnYkfcg9BaswTw/AY8P2y0TinH2BWXIXjSSJmcx6n3RaAjgufNKvJKAFpNNHMuBek0HnehNmZEKWf6BGU3YbwGfaFPxbiUUQYIK2xr48y071QoxibXogf0m21Gw/pMA6h6pir3fwF0uXjNmCB5rS7A9syi0J804PIaRe6H8WMInXCfqvdKNaAV3xhVobqdMLDYSDnkhgHTBLla7ISXRvIxU9DdwDk4js/Ax71Qkm6k6N95nAMhRKkJX0vVKNC3sdbH6gnLoKAZCqabNRwFQhRAh1VR7BAyKlEjuiFx8wWEUe53awfOB6Tk2L9KIwBw4lXjxTlrLUdou4S+QH7mTYwJALTiDrx1JdG4phrRrUSDWh+2owHA81l4eIfH2ckGAIEP2zYbEN+kLQ0A3l/En4jQJBWE6SrqQfvoFdrZPkojqPjMpBr9SznS4E8L0Xx5aYnx/3q0psp42A62eRn6hVaB/N9GHvalHICoHnVQKQGeAWBFygGYXiACBQIF+AHGs1MOgDpABDIFvgH82AsZqQaQ9tLtNEemoA0p2JpqABRhP1KwWvS28Mwfv+gA7vbkH0KTXvoyglS3oUKM/gY87imsuElYxQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "JGRj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JHHj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons "},[_c('div',{staticClass:"left-buttons mar-rt-10"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[(_vm.groupedLocations)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":['date_from', 'date_to']},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Caută produs")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],ref:"searchTerm",staticClass:"form-control",attrs:{"type":"text","placeholder":"Caută după nume produs...","disabled":_vm.loading},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"})]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"prop":"productDetails.name","label":_vm.$t('gestiune.stockNameTable'),"width":"400"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"productDetails.um","label":_vm.$t('gestiune.stockUm'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"productDetails.stocMinim","label":_vm.$t('gestiune.stockStocMinim')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":_vm.$t('gestiune.stockQuantity')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.stockPrice')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.productDetails)?[_vm._v("\n                      "+_vm._s(scope.row.productDetails.price)+" "+_vm._s(scope.row.productDetails.currency)+"\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.stockValue')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.value)?[_vm._v("\n                      "+_vm._s(scope.row.value)+"\n                    ")]:_vm._e(),_vm._v(" "),(scope.row.productDetails && scope.row.productDetails.currency)?[_vm._v("\n                      "+_vm._s(scope.row.productDetails.currency)+"\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.stockStatus'),"width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.productDetails && scope.row.productDetails.stocMinim !== null)?[(scope.row.quantity < scope.row.productDetails.stocMinim)?_c('span',[_vm._v(_vm._s(_vm.$t('gestiune.stockStatus3')))]):(scope.row.quantity < scope.row.productDetails.stocMinim + 5)?_c('span',[_vm._v(_vm._s(_vm.$t('gestiune.stockStatus1')))]):_c('span',[_vm._v(_vm._s(_vm.$t('gestiune.stockStatus2')))])]:[_vm._v("-")]]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JHMb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_vm._t("default",[_vm._v("\n\t\tDownload "+_vm._s(_vm.name)+"\n\t")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JKdJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementEntriesForm_vue__ = __webpack_require__("gGlf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6e165ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementEntriesForm_vue__ = __webpack_require__("PC3X");
function injectStyle (ssrContext) {
  __webpack_require__("DUIu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6e165ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementEntriesForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6e165ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementEntriesForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JMkg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-inventar-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JMxZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a),
  created: function created() {
    this.verifyUserLocations();
    this.getData(null);
  },
  data: function data() {
    return {
      loading: false,
      filters: {
        location: '',
        orderId: '',

        dateRange: [__WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(10, 'days').format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD')]
      },
      locations: [],
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {},
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          var minDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(10, 'days').startOf('day');
          var maxDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('day');
          return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).isBefore(minDate) || __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).isAfter(maxDate);
        }
      },
      totalResponses: null,
      responsesTableData: []
    };
  },

  methods: {
    responseLabel: function responseLabel(response) {
      if (response === 'YES') return this.$t('reports.reorderResponseYes');
      if (response === 'NO') return this.$t('reports.reorderResponseNo');
      return response;
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        if (allowedLocations.length > 0) {
          this.locations = this.locations.filter(function (el) {
            return allowedLocations.includes(el.id);
          });
        }
      }
    },
    onFilterChange: function onFilterChange() {
      this.getData(null);
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getData(query);
      if (query.type === 'size') this.getData(query);
    },
    buildParams: function buildParams() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_id: this.filters.location || null,
        order_id: this.filters.orderId || null,
        from_date: this.filters.dateRange ? this.filters.dateRange[0] : null,
        to_date: this.filters.dateRange ? this.filters.dateRange[1] : null
      };
    },
    getData: function getData(query) {
      var _this = this;

      var data = this.buildParams();

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      this.apiRequest('/reports/reorder-popup-responses?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status === true) {
          _this.responsesTableData = response.data.data;
          _this.totalResponses = response.data.total;
        }
        _this.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    exportData: function exportData() {
      var _this2 = this;

      var data = this.buildParams();

      this.loading = true;
      this.apiRequest('/reports/reorder-popup-responses-export', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        }
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "JOpd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JQdg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'r4'
});

/***/ }),

/***/ "JQr7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JQzo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-offset-1 col-md-10"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"purple text-center"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.details')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.name'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"255","placeholder":_vm.$t('marketingAutomation.name')},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),(_vm.formErrors.name)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.period'))+"*")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","format":"dd.MM.yyyy","value-format":"yyyy-MM-dd"},model:{value:(_vm.form.period),callback:function ($$v) {_vm.$set(_vm.form, "period", $$v)},expression:"form.period"}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.formErrors.period)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.period))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.active')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.form.active),callback:function ($$v) {_vm.$set(_vm.form, "active", $$v)},expression:"form.active"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.type'))+"*")]),_vm._v(" "),_c('div',{staticClass:"automation-types"},_vm._l((_vm.types),function(item){return _c('div',{key:item.value,staticClass:"automation-type-card",class:{ 'is-selected': _vm.form.type === item.value, 'is-disabled': !_vm.canPickType(item) },on:{"click":function($event){_vm.pickType(item)}}},[_c('i',{class:item.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(item.label)))]),_vm._v(" "),(!item.available)?_c('small',{staticClass:"automation-type-card__soon"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.comingSoon')))]):_vm._e()])})),_vm._v(" "),(_vm.isEdit)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.typeLocked')))]):_vm._e(),_vm._v(" "),(_vm.formErrors.type)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.type))]):_vm._e()])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.form.type === _vm.TYPE_BIRTHDAY || _vm.form.type === _vm.TYPE_CART)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"automation-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.form.type === _vm.TYPE_CART ? _vm.$t('marketingAutomation.cartRule') : _vm.$t('marketingAutomation.birthdayRule'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[(_vm.form.type === _vm.TYPE_BIRTHDAY)?[_c('div',{staticClass:"automation-box",class:{ 'is-off': !_vm.form.settings.announce_enabled }},[_c('div',{staticClass:"automation-box__head"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.form.settings.announce_enabled),callback:function ($$v) {_vm.$set(_vm.form.settings, "announce_enabled", $$v)},expression:"form.settings.announce_enabled"}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('marketingAutomation.announceTitleBox')))]),_vm._v(" "),(_vm.form.settings.announce_enabled)?_c('a',{staticClass:"automation-example-link",on:{"click":function($event){$event.preventDefault();_vm.useExample('announce')}}},[_c('i',{staticClass:"fa fa-magic"}),_vm._v(" "+_vm._s(_vm.$t('marketingAutomation.useExample'))+"\n                    ")]):_vm._e()],1),_vm._v(" "),(_vm.form.settings.announce_enabled)?[_c('div',{staticClass:"form-group automation-days"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.announceDaysBefore'))+"*")]),_vm._v(" "),_c('div',{staticClass:"automation-days__row"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.settings.announce_days_before),expression:"form.settings.announce_days_before",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":_vm.ANNOUNCE_DAYS_MAX,"step":"1"},domProps:{"value":(_vm.form.settings.announce_days_before)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "announce_days_before", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('marketingAutomation.daysBeforeBirthday')))])]),_vm._v(" "),(_vm.formErrors.announce_days_before)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.announce_days_before))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.pushTitle'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.settings.announce_title),expression:"form.settings.announce_title"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.TITLE_MAX,"placeholder":_vm.example('exampleAnnounceTitle')},domProps:{"value":(_vm.form.settings.announce_title)},on:{"focus":function($event){_vm.focused = 'announce'},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "announce_title", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"automation-count"},[_vm._v(_vm._s((_vm.form.settings.announce_title || '').length)+"/"+_vm._s(_vm.TITLE_MAX))]),_vm._v(" "),(_vm.formErrors.announce_title)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.announce_title))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.pushMessage'))+"*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.settings.announce_message),expression:"form.settings.announce_message"}],staticClass:"form-control",attrs:{"rows":"4","maxlength":_vm.MESSAGE_MAX,"placeholder":_vm.example('exampleAnnounceMessage')},domProps:{"value":(_vm.form.settings.announce_message)},on:{"focus":function($event){_vm.focused = 'announce'},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "announce_message", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"automation-count"},[_vm._v(_vm._s((_vm.form.settings.announce_message || '').length)+"/"+_vm._s(_vm.MESSAGE_MAX))]),_vm._v(" "),(_vm.formErrors.announce_message)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.announce_message))]):_vm._e()])]:_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.announceOffHint')))])],2),_vm._v(" "),_c('div',{staticClass:"automation-box"},[_c('div',{staticClass:"automation-box__head"},[_c('i',{staticClass:"fa fa-birthday-cake"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('marketingAutomation.dayTitleBox')))]),_vm._v(" "),_c('a',{staticClass:"automation-example-link",on:{"click":function($event){$event.preventDefault();_vm.useExample('day')}}},[_c('i',{staticClass:"fa fa-magic"}),_vm._v(" "+_vm._s(_vm.$t('marketingAutomation.useExample'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.pushTitle'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.settings.day_title),expression:"form.settings.day_title"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.TITLE_MAX,"placeholder":_vm.example('exampleDayTitle')},domProps:{"value":(_vm.form.settings.day_title)},on:{"focus":function($event){_vm.focused = 'day'},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "day_title", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"automation-count"},[_vm._v(_vm._s((_vm.form.settings.day_title || '').length)+"/"+_vm._s(_vm.TITLE_MAX))]),_vm._v(" "),(_vm.formErrors.day_title)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.day_title))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.pushMessage'))+"*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.settings.day_message),expression:"form.settings.day_message"}],staticClass:"form-control",attrs:{"rows":"4","maxlength":_vm.MESSAGE_MAX,"placeholder":_vm.example('exampleDayMessage')},domProps:{"value":(_vm.form.settings.day_message)},on:{"focus":function($event){_vm.focused = 'day'},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "day_message", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"automation-count"},[_vm._v(_vm._s((_vm.form.settings.day_message || '').length)+"/"+_vm._s(_vm.MESSAGE_MAX))]),_vm._v(" "),(_vm.formErrors.day_message)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.day_message))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.sendTime')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-time-select',{attrs:{"clearable":false,"picker-options":{ start: '06:00', step: '00:30', end: '22:00' }},model:{value:(_vm.form.settings.send_time),callback:function ($$v) {_vm.$set(_vm.form.settings, "send_time", $$v)},expression:"form.settings.send_time"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.sendTimeHint')))]),_vm._v(" "),(_vm.formErrors.send_time)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.send_time))]):_vm._e()],1)]:_vm._e(),_vm._v(" "),(_vm.form.type === _vm.TYPE_CART)?[_c('div',{staticClass:"automation-box"},[_c('div',{staticClass:"automation-box__head"},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('marketingAutomation.cartFirstBox')))]),_vm._v(" "),_c('span',{staticClass:"automation-variant",class:{ 'is-coupon': _vm.form.coupon_ids.length }},[_vm._v(_vm._s(_vm.form.coupon_ids.length ? _vm.$t('marketingAutomation.variantWithCoupon') : _vm.$t('marketingAutomation.variantNoCampaignCoupon')))]),_vm._v(" "),_c('a',{staticClass:"automation-example-link",on:{"click":function($event){$event.preventDefault();_vm.useExample('first')}}},[_c('i',{staticClass:"fa fa-magic"}),_vm._v(" "+_vm._s(_vm.$t('marketingAutomation.useExample'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"form-group automation-days"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.cartFirstDelay'))+"*")]),_vm._v(" "),_c('div',{staticClass:"automation-days__row"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.settings.first_delay_minutes),expression:"form.settings.first_delay_minutes",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":_vm.DELAY_MIN,"max":_vm.FIRST_DELAY_MAX,"step":"1"},domProps:{"value":(_vm.form.settings.first_delay_minutes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "first_delay_minutes", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('marketingAutomation.minutesAfterChange'))+" "),_c('span',{staticClass:"automation-duration"},[_vm._v(_vm._s(_vm.durationText(_vm.form.settings.first_delay_minutes)))])])]),_vm._v(" "),(_vm.formErrors.first_delay_minutes)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.first_delay_minutes))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.pushTitle'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.settings.first_title),expression:"form.settings.first_title"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.TITLE_MAX,"placeholder":_vm.example('exampleCartFirstTitle')},domProps:{"value":(_vm.form.settings.first_title)},on:{"focus":function($event){_vm.focused = 'first'},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "first_title", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"automation-count"},[_vm._v(_vm._s((_vm.form.settings.first_title || '').length)+"/"+_vm._s(_vm.TITLE_MAX))]),_vm._v(" "),(_vm.formErrors.first_title)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.first_title))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.pushMessage'))+"*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.settings.first_message),expression:"form.settings.first_message"}],staticClass:"form-control",attrs:{"rows":"4","maxlength":_vm.MESSAGE_MAX,"placeholder":_vm.example('exampleCartFirstMessage')},domProps:{"value":(_vm.form.settings.first_message)},on:{"focus":function($event){_vm.focused = 'first'},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "first_message", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"automation-count"},[_vm._v(_vm._s((_vm.form.settings.first_message || '').length)+"/"+_vm._s(_vm.MESSAGE_MAX))]),_vm._v(" "),(_vm.formErrors.first_message)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.first_message))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"automation-box",class:{ 'is-off': !_vm.form.coupon_ids.length }},[_c('div',{staticClass:"automation-box__head"},[_c('i',{staticClass:"fa fa-bell-o"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('marketingAutomation.cartFirstBox')))]),_vm._v(" "),_c('span',{staticClass:"automation-variant"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.variantNoCoupon')))]),_vm._v(" "),(_vm.form.coupon_ids.length)?_c('a',{staticClass:"automation-example-link",on:{"click":function($event){$event.preventDefault();_vm.useExample('nocoupon')}}},[_c('i',{staticClass:"fa fa-magic"}),_vm._v(" "+_vm._s(_vm.$t('marketingAutomation.useExample'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('small',{staticClass:"text-muted automation-box__hint"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.cartNoCouponHint')))]),_vm._v(" "),(!_vm.form.coupon_ids.length)?_c('small',{staticClass:"automation-placeholder__off automation-box__hint"},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" "+_vm._s(_vm.$t('marketingAutomation.noCouponNeedsCoupon')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.pushTitle'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.settings.nocoupon_title),expression:"form.settings.nocoupon_title"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.TITLE_MAX,"disabled":!_vm.form.coupon_ids.length,"placeholder":_vm.example('exampleCartNoCouponTitle')},domProps:{"value":(_vm.form.settings.nocoupon_title)},on:{"focus":function($event){_vm.focused = 'nocoupon'},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "nocoupon_title", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"automation-count"},[_vm._v(_vm._s((_vm.form.settings.nocoupon_title || '').length)+"/"+_vm._s(_vm.TITLE_MAX))]),_vm._v(" "),(_vm.formErrors.nocoupon_title)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.nocoupon_title))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.pushMessage'))+"*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.settings.nocoupon_message),expression:"form.settings.nocoupon_message"}],staticClass:"form-control",attrs:{"rows":"4","maxlength":_vm.MESSAGE_MAX,"disabled":!_vm.form.coupon_ids.length,"placeholder":_vm.example('exampleCartNoCouponMessage')},domProps:{"value":(_vm.form.settings.nocoupon_message)},on:{"focus":function($event){_vm.focused = 'nocoupon'},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "nocoupon_message", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"automation-count"},[_vm._v(_vm._s((_vm.form.settings.nocoupon_message || '').length)+"/"+_vm._s(_vm.MESSAGE_MAX))]),_vm._v(" "),(_vm.formErrors.nocoupon_message)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.nocoupon_message))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"automation-box",class:{ 'is-off': !_vm.form.settings.second_enabled }},[_c('div',{staticClass:"automation-box__head"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.form.settings.second_enabled),callback:function ($$v) {_vm.$set(_vm.form.settings, "second_enabled", $$v)},expression:"form.settings.second_enabled"}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('marketingAutomation.cartSecondBox')))]),_vm._v(" "),(_vm.form.settings.second_enabled)?_c('a',{staticClass:"automation-example-link",on:{"click":function($event){$event.preventDefault();_vm.useExample('second')}}},[_c('i',{staticClass:"fa fa-magic"}),_vm._v(" "+_vm._s(_vm.$t('marketingAutomation.useExample'))+"\n                    ")]):_vm._e()],1),_vm._v(" "),(_vm.form.settings.second_enabled)?[_c('small',{staticClass:"text-muted automation-box__hint"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.cartSecondHint', { cod: '{cod}' })))]),_vm._v(" "),_c('div',{staticClass:"form-group automation-days"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.cartSecondDelay'))+"*")]),_vm._v(" "),_c('div',{staticClass:"automation-days__row"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.settings.second_delay_minutes),expression:"form.settings.second_delay_minutes",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":_vm.DELAY_MIN,"max":_vm.SECOND_DELAY_MAX,"step":"1"},domProps:{"value":(_vm.form.settings.second_delay_minutes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "second_delay_minutes", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('marketingAutomation.minutesAfterFirst'))+" "),_c('span',{staticClass:"automation-duration"},[_vm._v(_vm._s(_vm.durationText(_vm.form.settings.second_delay_minutes)))])])]),_vm._v(" "),(_vm.formErrors.second_delay_minutes)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.second_delay_minutes))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.pushTitle'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.settings.second_title),expression:"form.settings.second_title"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.TITLE_MAX,"placeholder":_vm.example('exampleCartSecondTitle')},domProps:{"value":(_vm.form.settings.second_title)},on:{"focus":function($event){_vm.focused = 'second'},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "second_title", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"automation-count"},[_vm._v(_vm._s((_vm.form.settings.second_title || '').length)+"/"+_vm._s(_vm.TITLE_MAX))]),_vm._v(" "),(_vm.formErrors.second_title)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.second_title))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.pushMessage'))+"*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.settings.second_message),expression:"form.settings.second_message"}],staticClass:"form-control",attrs:{"rows":"4","maxlength":_vm.MESSAGE_MAX,"placeholder":_vm.example('exampleCartSecondMessage')},domProps:{"value":(_vm.form.settings.second_message)},on:{"focus":function($event){_vm.focused = 'second'},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "second_message", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"automation-count"},[_vm._v(_vm._s((_vm.form.settings.second_message || '').length)+"/"+_vm._s(_vm.MESSAGE_MAX))]),_vm._v(" "),(_vm.formErrors.second_message)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.second_message))]):_vm._e()])]:_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.cartSecondOffHint')))])],2),_vm._v(" "),_c('div',{staticClass:"automation-box",class:{ 'is-off': !_vm.form.settings.quiet_enabled }},[_c('div',{staticClass:"automation-box__head"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.form.settings.quiet_enabled),callback:function ($$v) {_vm.$set(_vm.form.settings, "quiet_enabled", $$v)},expression:"form.settings.quiet_enabled"}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('marketingAutomation.quietBox')))])],1),_vm._v(" "),(_vm.form.settings.quiet_enabled)?[_c('div',{staticClass:"automation-quiet"},[_c('span',[_vm._v(_vm._s(_vm.$t('marketingAutomation.quietFrom')))]),_vm._v(" "),_c('el-time-select',{staticClass:"automation-quiet__time",attrs:{"clearable":false,"picker-options":{ start: '00:00', step: '00:30', end: '23:30' }},model:{value:(_vm.form.settings.quiet_from),callback:function ($$v) {_vm.$set(_vm.form.settings, "quiet_from", $$v)},expression:"form.settings.quiet_from"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('marketingAutomation.quietTo')))]),_vm._v(" "),_c('el-time-select',{staticClass:"automation-quiet__time",attrs:{"clearable":false,"picker-options":{ start: '00:00', step: '00:30', end: '23:30' }},model:{value:(_vm.form.settings.quiet_to),callback:function ($$v) {_vm.$set(_vm.form.settings, "quiet_to", $$v)},expression:"form.settings.quiet_to"}})],1),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.quietHint')))]),_vm._v(" "),(_vm.formErrors.quiet_from || _vm.formErrors.quiet_to)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.quiet_from || _vm.formErrors.quiet_to))]):_vm._e()]:_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.quietOffHint')))])],2)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingAutomation.preview')))]),_vm._v(" "),_c('div',{staticClass:"automation-preview"},[_c('div',{staticClass:"automation-preview__app"},[_c('i',{staticClass:"fa fa-bell"}),_vm._v(" "+_vm._s(_vm.companyName)+" · "+_vm._s(_vm.previewWhen)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"automation-preview__title",class:{ 'is-example': !_vm.previewPush.title }},[_vm._v(_vm._s(_vm.previewText(_vm.previewPush.title || _vm.previewExample.title)))]),_vm._v(" "),_c('div',{staticClass:"automation-preview__body",class:{ 'is-example': !_vm.previewPush.message }},[_vm._v(_vm._s(_vm.previewText(_vm.previewPush.message || _vm.previewExample.message)))])]),_vm._v(" "),(!_vm.previewPush.title || !_vm.previewPush.message)?_c('small',{staticClass:"text-muted automation-preview__note"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.previewExampleNote')))]):_vm._e(),_vm._v(" "),(_vm.codeMissing)?_c('small',{staticClass:"automation-preview__warn"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" "+_vm._s(_vm.$t('marketingAutomation.codeMissing', { cod: '{cod}' }))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.codeWithoutCoupon)?_c('small',{staticClass:"automation-preview__warn"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$t('marketingAutomation.codeWithoutCoupon', { cod: '{cod}' }))+"\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"automation-placeholders"},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.placeholdersHint')))]),_vm._v(" "),_vm._l((_vm.placeholders),function(item){return _c('div',{key:item.key,staticClass:"automation-placeholder",class:{ 'is-disabled': item.disabled }},[_c('code',{attrs:{"title":item.disabled ? _vm.$t(item.disabledHint) : _vm.$t('marketingAutomation.clickToInsert')},on:{"click":function($event){!item.disabled && _vm.insertPlaceholder(item.key)}}},[_vm._v(_vm._s(item.key))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t(item.label)))]),_vm._v(" "),(item.disabled)?_c('small',{staticClass:"automation-placeholder__off"},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" "+_vm._s(_vm.$t(item.disabledHint)))]):_vm._e()])})],2)])])])]):_vm._e(),_vm._v(" "),(_vm.form.type)?_c('hr'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"automation-coupons-head"},[_c('label',{staticStyle:{"margin":"0"}},[_vm._v("\n                  "+_vm._s(_vm.$t('marketingAutomation.coupons'))+" "),_c('small',{staticClass:"text-muted"},[_vm._v("("+_vm._s(_vm.$t('marketingAutomation.optional'))+")")]),_vm._v(" "),(_vm.form.coupon_ids.length)?_c('span',{staticClass:"automation-selected-count"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.selectedCount', { count: _vm.form.coupon_ids.length })))]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-purple",on:{"click":function($event){$event.preventDefault();return _vm.openCouponModal($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('marketingAutomation.newCoupon'))+"\n                ")])]),_vm._v(" "),_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-bottom":"8px"}},[_vm._v(_vm._s(_vm.$t('marketingAutomation.couponsHint')))]),_vm._v(" "),(!_vm.coupons.length)?_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.noCoupons')))]):[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couponSearch),expression:"couponSearch"}],staticClass:"form-control automation-coupon-search",attrs:{"type":"text","placeholder":_vm.$t('marketingAutomation.searchCoupons')},domProps:{"value":(_vm.couponSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.couponSearch=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"automation-coupon-list"},[_vm._l((_vm.filteredCoupons),function(coupon){return _c('div',{key:'coupon' + coupon.id,staticClass:"automation-coupon-row",class:{ 'is-checked': _vm.isCouponChecked(coupon.id) },on:{"click":function($event){_vm.toggleCoupon(coupon.id)}}},[_c('input',{staticStyle:{"margin":"0","pointer-events":"none"},attrs:{"type":"checkbox"},domProps:{"checked":_vm.isCouponChecked(coupon.id)}}),_vm._v(" "),_c('span',[_c('strong',[_vm._v(_vm._s(coupon.name))]),_vm._v(" "),(coupon.coupon_code)?_c('code',{staticClass:"automation-coupon-code"},[_vm._v(_vm._s(coupon.coupon_code))]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(" — "+_vm._s(_vm.couponDiscountText(coupon))+" · "+_vm._s(_vm.couponValidityText(coupon)))]),_vm._v(" "),(!coupon.active)?_c('span',{staticClass:"automation-coupon-flag"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.inactive')))]):(_vm.couponExpired(coupon))?_c('span',{staticClass:"automation-coupon-flag automation-coupon-flag--warn"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.expired')))]):_vm._e()])])}),_vm._v(" "),(!_vm.filteredCoupons.length)?_c('p',{staticClass:"text-muted",staticStyle:{"padding":"10px","margin":"0"}},[_vm._v(_vm._s(_vm.$t('marketingAutomation.noCouponsFound')))]):_vm._e()],2)],_vm._v(" "),(_vm.formErrors.coupon_ids)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.coupon_ids))]):_vm._e()],2),_vm._v(" "),(_vm.form.type === _vm.TYPE_CART)?_c('div',{staticClass:"automation-box automation-cooldown",class:{ 'is-off': !_vm.form.coupon_ids.length }},[_c('div',{staticClass:"automation-box__head"},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('marketingAutomation.cooldownBox')))])]),_vm._v(" "),_c('div',{staticClass:"automation-days__row"},[_c('span',[_vm._v(_vm._s(_vm.$t('marketingAutomation.cooldownLabel')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.settings.coupon_cooldown_days),expression:"form.settings.coupon_cooldown_days",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":_vm.COOLDOWN_MAX,"step":"1","disabled":!_vm.form.coupon_ids.length},domProps:{"value":(_vm.form.settings.coupon_cooldown_days)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.settings, "coupon_cooldown_days", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('marketingAutomation.cooldownDays')))])]),_vm._v(" "),_c('small',{staticClass:"text-muted automation-cooldown__hint"},[_vm._v(_vm._s(_vm.$t('marketingAutomation.cooldownHint')))]),_vm._v(" "),(!_vm.form.coupon_ids.length)?_c('small',{staticClass:"automation-placeholder__off"},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" "+_vm._s(_vm.$t('marketingAutomation.cooldownNeedsCoupon')))]):_vm._e(),_vm._v(" "),(_vm.formErrors.coupon_cooldown_days)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.coupon_cooldown_days))]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"text-center mar-to-10"},[_c('button',{staticClass:"btn btn-purple-light btn-fill btn-wd",attrs:{"disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])]),_vm._v(" "),_c('vmodal',{staticClass:"automationCouponModal",attrs:{"name":"automationCouponModal","width":"95%","maxWidth":1100,"minWidth":300,"height":"auto","scrollable":true,"adaptive":true,"clickToClose":false},on:{"opened":_vm.onCouponModalOpened}},[_c('div',{staticClass:"automation-coupon-modal__header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('marketingAutomation.newCouponTitle')))]),_vm._v(" "),_c('a',{staticClass:"automation-coupon-modal__close",on:{"click":_vm.closeCouponModal}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"automation-coupon-modal__body"},[(_vm.couponModalOpen)?_c('coupon-form',{attrs:{"embedded":"","force-automation":""},on:{"saved":_vm.onCouponCreated}}):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JTCb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.$route.params.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteOrderScreen($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-3 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.model.id)?_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-lg-4 col-md-6"},[_c('p',{staticStyle:{"margin":"0","min-width":"110px"}},[_vm._v(_vm._s(_vm.$t('settingTable.loginCode')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('input',{staticClass:"copy_link",staticStyle:{"margin":"0"},attrs:{"type":"text","disabled":"true"},domProps:{"value":_vm.model.id + '.' + _vm.company_id},on:{"click":function($event){_vm.copyToClipboard(_vm.model.id + '.' + _vm.company_id)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('a',{staticClass:"btn btn-icon btn-info mar-rt-10",staticStyle:{"padding":"6px 5px"},attrs:{"title":_vm.$t('general.copyToClipboard')},on:{"click":function($event){_vm.copyToClipboard(_vm.model.id + '.' + _vm.company_id)}}},[_c('i',{staticClass:"fa fa-copy"})])])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"id":"name","type":"text"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.location')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.location.id),expression:"model.location.id"}],staticClass:"form-control",attrs:{"name":"location"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.location, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateLocationId($event)}]}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}})})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.invalid),expression:"type.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('type'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Server Local Ip")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.server_ip),expression:"modelValidate.server_ip"},{name:"model",rawName:"v-model",value:(_vm.model.server_ip),expression:"model.server_ip"}],staticClass:"form-control",attrs:{"id":"name","type":"text","placeholder":"192.168.1.10"},domProps:{"value":(_vm.model.server_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "server_ip", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-9 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{staticClass:"card-content",staticStyle:{"padding":"5px"}},[_c('table',{ref:"sortableTable",staticClass:"table width-table",staticStyle:{"margin":"0px","width":"100% !important"}},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('companyOptions.image')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"70px"}},[_vm._v("Time in seconds between slides")]),_vm._v(" "),_c('th',{staticStyle:{"width":"70px"}},[_vm._v("From")]),_vm._v(" "),_c('th',{staticStyle:{"width":"70px"}},[_vm._v("To")]),_vm._v(" "),_c('th',{staticStyle:{"width":"70px"}},[_vm._v("Active")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('draggable',{attrs:{"sort":false,"element":'tbody'},model:{value:(_vm.model.images),callback:function ($$v) {_vm.$set(_vm.model, "images", $$v)},expression:"model.images"}},[_vm._l((_vm.model.images),function(item,index){return [_c('tr',{key:'slide-' + index,staticClass:"sortableRow"}),_c('tr',[_c('td',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",refInFor:true,attrs:{"multiple":"","action":"","limit":50,"file-list":item.images ? item.images : [],"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":function (file,fileList) {return _vm.handleImgChnage(file,fileList,index)},"on-exceed":_vm.handleExceed,"on-remove":function (file,fileList) {return _vm.handleRemove(file,fileList,index)},"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)]),_vm._v(" "),_c('td',[_c('tr',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.time),expression:"item.time"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml mar-bt-5",attrs:{"type":"text","placeholder":""},domProps:{"value":(item.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "time", $event.target.value)}}})])]),_vm._v(" "),_c('td',[_c('tr',[_c('el-time-select',{staticStyle:{"width":"100px"},attrs:{"disabled":false,"placeholder":"Select time","value":item.from,"picker-options":_vm.pickerOptions},model:{value:(item.from),callback:function ($$v) {_vm.$set(item, "from", $$v)},expression:"item.from"}})],1)]),_vm._v(" "),_c('td',[_c('tr',[_c('el-time-select',{staticStyle:{"width":"100px"},attrs:{"disabled":false,"placeholder":"Select time","value":item.to,"picker-options":_vm.pickerOptions},model:{value:(item.to),callback:function ($$v) {_vm.$set(item, "to", $$v)},expression:"item.to"}})],1)]),_vm._v(" "),_c('td',[_c('tr',{staticStyle:{"height":"45px"}},[[_c('p-switch',{staticClass:"mar-bt-5 mar-to-5",attrs:{"type":"success"},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}})]],2)]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.deleteValue(index)}}},[_c('i',{staticClass:"ti-close text-orange",attrs:{"title":_vm.$t('general.delete')}})])])])]})],2)],1),_vm._v(" "),_c('button',{staticClass:"btn add mar-to-15 mar-lt-20",on:{"click":function($event){$event.preventDefault();_vm.addNewImageGroup()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.value'))+"\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JUmJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementTransferForm_vue__ = __webpack_require__("TZJI");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneTransferForm', __WEBPACK_IMPORTED_MODULE_7__ManagementTransferForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "JWNY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_DisplayQr_vue__ = __webpack_require__("+65S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Switch_vue__["a" /* default */],
    DisplayQr: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Inputs_DisplayQr_vue__["a" /* default */]
  },
  watch: {},
  data: function data() {
    return {
      locations: [],
      windowHeight: 0,
      pageTopHeight: 76,
      navbarHeaderHeight: 0,
      loading: true
    };
  },

  updated: function updated() {},
  computed: {},
  created: function created() {
    this.locations = this.getCompanyDetail('locations_details');
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.doHeightCalculation();
      _this.loading = false;

      window.addEventListener('resize', function () {
        _this.doHeightCalculation();
      });
    });
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
    },
    scrollToPx: function scrollToPx(px) {
      var elem = this.$el;

      elem.scrollTop = elem.clientHeight;
      window.scrollTo({
        left: 0,
        top: elem.clientHeight - px,
        behavior: 'smooth'
      });
    },
    goToCompany: function goToCompany() {
      this.$session.set('selectedTab', this.$t('settingsPages.companyLocations'));
      this.$router.push('/settings');
    }
  }
});

/***/ }),

/***/ "JboP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Products_ProductsList_vue__ = __webpack_require__("VWkf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Products_PriceProfile_vue__ = __webpack_require__("vPYJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Products_Stock_vue__ = __webpack_require__("oJuI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Categories_Categories_vue__ = __webpack_require__("pUJd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_TopCategories_TopCategories_vue__ = __webpack_require__("Ij4o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_ProductOptions_ProductOptions_vue__ = __webpack_require__("lZGK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_GroupOptions_GroupOptions_vue__ = __webpack_require__("b1nj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Settings_Tabs_ProductFilters_vue__ = __webpack_require__("u5js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_MenuLinks_MenuLinks_vue__ = __webpack_require__("H0h3");












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProductsList: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Products_ProductsList_vue__["a" /* default */],
    PriceProfile: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Products_PriceProfile_vue__["a" /* default */],
    Stock: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Products_Stock_vue__["a" /* default */],
    Categories: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Categories_Categories_vue__["a" /* default */],
    TopCategories: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_TopCategories_TopCategories_vue__["a" /* default */],
    ProductOptions: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_ProductOptions_ProductOptions_vue__["a" /* default */],
    GroupOptions: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_GroupOptions_GroupOptions_vue__["a" /* default */],
    ProductFilters: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Settings_Tabs_ProductFilters_vue__["a" /* default */],
    MenuLinks: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_MenuLinks_MenuLinks_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isProducts: false,
      isPriceList: false,
      isStock: false,
      isCategories: false,
      isTopCategories: false,
      isProductOptions: false,
      isGroupOptions: false,
      isProductFilters: false,
      isMenuLinks: false
    };
  },
  mounted: function mounted() {
    this.switchTab();
  },

  methods: {
    resetStates: function resetStates() {
      this.isProducts = false;
      this.isPriceList = false;
      this.isStock = false;
      this.isCategories = false;
      this.isTopCategories = false;
      this.isProductOptions = false;
      this.isGroupOptions = false;
      this.isProductFilters = false;
      this.isMenuLinks = false;
    },
    switchTab: function switchTab() {
      var _this = this;

      var index = this.$route.query.tabIndex;
      this.$nextTick(function () {
        if (index && _this.$refs.tabs) {
          _this.$refs.tabs.navigateToTab(parseInt(index));
        }
      });
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      this.resetStates();
      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);
      switch (newTab.title) {
        case this.$t('pages.products'):
          this.isProducts = true;
          break;
        case this.$t('pages.isPriceList'):
          this.isPriceList = true;
          break;
        case this.$t('pages.stock'):
          this.isStock = true;
          break;
        case this.$t('pages.categories'):
          this.isCategories = true;
          break;
        case this.$t('pages.topCategory'):
          this.isTopCategories = true;
          break;
        case this.$t('pages.productOptions'):
          this.isProductOptions = true;
          break;
        case this.$t('pages.groupOptions'):
          this.isGroupOptions = true;
          break;
        case this.$t('pages.productFilters'):
          this.isProductFilters = true;
          break;
        case this.$t('pages.menuLinks'):
          this.isMenuLinks = true;
          break;
        default:
          this.isFirst = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ "JcV3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jcwn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loyalty-store-purchases-report"},[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back banner-back-button",attrs:{"title":_vm.$t('general.back'),"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),(_vm.rewardTitle)?_c('p',{staticClass:"mar-lt-10"},[_c('strong',[_vm._v(_vm._s(_vm.$t('loyaltyStore.purchases'))+":")]),_vm._v(" "+_vm._s(_vm.rewardTitle)+"\n      ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"sales-report mar-to-15"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content total-pagination pad-15"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.datetime'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatDateTime(props.row.created_at || props.row.datetime))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.user'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.getUserName(props.row))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('reports.location'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.locationName(props.row.location_id) || props.row.location_name || '—')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.pointsCost'),"width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.loyalty_points_spent)+"\n              ")]}}])}),_vm._v(" "),(_vm.isProductType)?_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.orderId'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.order_id)?_c('a',{staticClass:"text-info",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.openOrder(props.row.order_id)}}},[_vm._v("\n                  "+_vm._s(props.row.order_id)+"\n                  "),(props.row.order && props.row.order.status)?_c('span',[_vm._v("("+_vm._s(props.row.order.status)+")")]):_vm._e()]):_c('span',[_vm._v("—")])]}}])}):_vm._e(),_vm._v(" "),(_vm.isGiftType)?_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.giftCardId'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.gift_card_id || '—')+"\n              ")]}}])}):_vm._e(),_vm._v(" "),(_vm.isGiftType)?_c('el-table-column',{attrs:{"label":_vm.$t('loyaltyStore.giftCardValue'),"width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.gift_card_value != null ? parseFloat(props.row.gift_card_value).toFixed(2) : '—')+" "+_vm._s(_vm.currency)+"\n              ")]}}])}):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"15px","text-align":"right"}},[_c('el-pagination',{attrs:{"layout":"prev, pager, next","total":_vm.total,"page-size":_vm.perPage,"current-page":_vm.page},on:{"update:currentPage":function($event){_vm.page=$event},"current-change":_vm.loadPurchases}})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JgGs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jh78":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jhho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs",attrs:{"direction":"vertical","value":"Description"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('kds.kds')}},[(_vm.isKds)?_c('kds',{attrs:{"isKds":_vm.isKds}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('kds.settings')}},[(_vm.isSettings)?_c('kds-settings',{attrs:{"isSettings":_vm.isSettings,"openUsersProp":_vm.openUsers}}):_vm._e()],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JiEC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoyaltyStoreCampaignForm_vue__ = __webpack_require__("SJ2J");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { LoyaltyStoreCampaignForm: __WEBPACK_IMPORTED_MODULE_0__LoyaltyStoreCampaignForm_vue__["a" /* default */] },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),

/***/ "JjPW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__("O5me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_wysiwyg_dist_vueWysiwyg_css__);


























__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_vue_js_modal___default.a, { componentName: 'vmodal' });

var TITLE_MAX = 255;
var SLUG_MAX = 255;
var SHORT_DESCRIPTION_MAX = 500;
var AUTHOR_MAX = 150;
var IMAGE_ALT_MAX = 255;
var META_TITLE_MAX = 255;
var META_DESCRIPTION_MAX = 300;
var META_KEYWORDS_MAX = 500;
var CATEGORY_NAME_MAX = 100;
var MAX_IMAGE_MB = 5;
var PER_PAGE = 20;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      TITLE_MAX: TITLE_MAX,
      SLUG_MAX: SLUG_MAX,
      SHORT_DESCRIPTION_MAX: SHORT_DESCRIPTION_MAX,
      AUTHOR_MAX: AUTHOR_MAX,
      IMAGE_ALT_MAX: IMAGE_ALT_MAX,
      META_TITLE_MAX: META_TITLE_MAX,
      META_DESCRIPTION_MAX: META_DESCRIPTION_MAX,
      META_KEYWORDS_MAX: META_KEYWORDS_MAX,
      CATEGORY_NAME_MAX: CATEGORY_NAME_MAX,

      editorOptions: {
        hideModules: { code: true, table: true, image: true }
      },
      loading: true,
      saving: false,
      savingCategory: false,
      editorReady: false,
      seoOpen: false,
      articles: [],
      categories: [],
      filters: {
        search: '',
        category_id: '',
        status: ''
      },
      pagination: {
        total: 0,
        page: 1,
        per_page: PER_PAGE
      },
      searchTimer: null,
      newCategoryName: '',
      editingCategoryId: null,
      editingCategoryName: '',
      form: this.emptyForm()
    };
  },

  computed: {
    companyID: function companyID() {
      return this.$session.get('selectedCompany');
    },
    token: function token() {
      return this.$session.get('token');
    },
    slugPreview: function slugPreview() {
      return this.slugify(this.form.title);
    }
  },
  created: function created() {
    this.getCategories();
    this.getArticles();
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.searchTimer);
  },

  methods: {
    emptyForm: function emptyForm() {
      return {
        id: null,
        title: '',
        slug: '',
        short_description: '',
        content: '',
        blog_category_id: null,
        author_name: '',
        published_at: null,
        is_active: false,
        image_alt: '',
        meta_title: '',
        meta_description: '',
        meta_keywords: '',
        imagelist: []
      };
    },
    baseData: function baseData(extra) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({
        token: this.token,
        company_id: this.companyID
      }, extra || {});
    },
    firstError: function firstError(response) {
      if (!response.errors) {
        return this.$t('validations.wentWrong');
      }
      var first = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(response.errors)[0];
      return Array.isArray(first) ? first[0] : first;
    },
    slugify: function slugify(text) {
      return (text || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/[\s-]+/g, '-');
    },
    formatDay: function formatDay(value) {
      var _value$substring$spli = value.substring(0, 10).split('-'),
          _value$substring$spli2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_value$substring$spli, 3),
          y = _value$substring$spli2[0],
          m = _value$substring$spli2[1],
          d = _value$substring$spli2[2];

      return d + '.' + m + '.' + y;
    },
    formatTime: function formatTime(value) {
      return value.substring(11, 16);
    },
    articleStatus: function articleStatus(item) {
      if (!item.is_active) {
        return 'draft';
      }
      if (item.published_at && new Date(item.published_at.replace(' ', 'T')) > new Date()) {
        return 'scheduled';
      }
      return 'published';
    },
    getCategories: function getCategories() {
      var _this = this;

      this.apiRequest('/blog/categories', 'GET', this.baseData(), function (response) {
        if (response.status === true) {
          _this.categories = response.data;
        }
      });
    },
    addCategory: function addCategory() {
      var _this2 = this;

      var name = (this.newCategoryName || '').trim();
      if (!name || this.savingCategory) {
        return;
      }
      this.savingCategory = true;
      this.apiRequest('/blog/categories', 'POST', this.baseData({ name: name }), function (response) {
        _this2.savingCategory = false;
        if (response.status === true) {
          _this2.newCategoryName = '';
          _this2.getCategories();
        } else {
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this2.firstError(response), 'error').catch(function () {});
        }
      });
    },
    startEditCategory: function startEditCategory(cat) {
      this.editingCategoryId = cat.id;
      this.editingCategoryName = cat.name;
    },
    cancelEditCategory: function cancelEditCategory() {
      this.editingCategoryId = null;
      this.editingCategoryName = '';
    },
    saveCategory: function saveCategory(cat) {
      var _this3 = this;

      var name = (this.editingCategoryName || '').trim();
      if (!name) {
        return;
      }
      this.apiRequest('/blog/categories/' + cat.id, 'PUT', this.baseData({ name: name }), function (response) {
        if (response.status === true) {
          _this3.cancelEditCategory();
          _this3.getCategories();

          _this3.getArticles();
        } else {
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this3.firstError(response), 'error').catch(function () {});
        }
      });
    },
    deleteCategory: function deleteCategory(cat) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
        text: this.$t('blogPage.deleteCategoryConfirm', { name: cat.name, count: cat.articles_count || 0 }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this4.apiRequest('/blog/categories/' + cat.id, 'DELETE', _this4.baseData(), function (response) {
            if (response.status === true) {
              if (_this4.filters.category_id === String(cat.id)) {
                _this4.filters.category_id = '';
              }
              _this4.getCategories();
              _this4.getArticles();
            } else {
              __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this4.firstError(response), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
    },
    getArticles: function getArticles() {
      var _this5 = this;

      this.loading = true;
      var data = this.baseData({
        page: this.pagination.page,
        per_page: this.pagination.per_page,
        search: this.filters.search,
        category_id: this.filters.category_id,
        status: this.filters.status
      });
      this.apiRequest('/blog/articles', 'GET', data, function (response) {
        if (response.status === true && response.data) {
          _this5.articles = response.data.items || [];
          var p = response.data.pagination || {};
          _this5.pagination.total = p.total || 0;
          _this5.pagination.page = p.page || 1;
        }
        _this5.$nextTick(function () {
          _this5.loading = false;
        });
      });
    },
    reloadArticles: function reloadArticles() {
      this.pagination.page = 1;
      this.getArticles();
    },
    onSearchInput: function onSearchInput() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(this.reloadArticles, 400);
    },
    handlePageChange: function handlePageChange(page) {
      this.pagination.page = page;
      this.getArticles();
    },
    deleteArticle: function deleteArticle(item, event) {
      var _this6 = this;

      if (event) event.stopPropagation();
      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
        text: this.$t('blogPage.deleteArticleConfirm', { name: item.title }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this6.apiRequest('/blog/articles/' + item.id, 'DELETE', _this6.baseData(), function (response) {
            if (response.status === true) {
              if (_this6.articles.length === 1 && _this6.pagination.page > 1) {
                _this6.pagination.page--;
              }
              _this6.getArticles();
              _this6.getCategories();
              __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this6.$t('general.success') + '!', 'success').catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this6.firstError(response), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
    },
    openCreate: function openCreate() {
      this.form = this.emptyForm();
      this.seoOpen = false;
      this.showModal();
    },
    openEdit: function openEdit(item) {
      var _this7 = this;

      this.apiRequest('/blog/articles/' + item.id, 'GET', this.baseData(), function (response) {
        if (response.status === true) {
          _this7.form = _this7.mapToForm(response.data);
          _this7.seoOpen = !!(_this7.form.meta_title || _this7.form.meta_description || _this7.form.meta_keywords);
          _this7.showModal();
        } else {
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this7.firstError(response), 'error').catch(function () {});
        }
      });
    },
    showModal: function showModal() {
      var _this8 = this;

      this.editorReady = false;
      this.$modal.show('blogArticleModal');
      this.$nextTick(function () {
        _this8.editorReady = true;
      });
    },
    closeModal: function closeModal() {
      this.$modal.hide('blogArticleModal');
    },
    onModalOpened: function onModalOpened() {
      var el = document.querySelector('.blogArticleModal.vm--container');
      if (el && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    },
    mapToForm: function mapToForm(data) {
      var form = this.emptyForm();
      form.id = data.id;
      form.title = data.title || '';
      form.slug = data.slug || '';
      form.short_description = data.short_description || '';
      form.content = data.content || '';
      form.blog_category_id = data.blog_category_id || null;
      form.author_name = data.author_name || '';
      form.published_at = data.published_at || null;
      form.is_active = !!data.is_active;
      form.image_alt = data.image_alt || '';
      form.meta_title = data.meta_title || '';
      form.meta_description = data.meta_description || '';
      form.meta_keywords = data.meta_keywords || '';
      form.imagelist = data.image_filename ? [{ url: data.image_url, name: data.image_filename, filename: data.image_filename }] : [];
      return form;
    },
    handleImageChange: function handleImageChange(file, fileList) {
      if (file.size && file.size / 1024 / 1024 > MAX_IMAGE_MB) {
        __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: this.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).catch(function () {});
        this.form.imagelist = fileList.filter(function (f) {
          return f.uid !== file.uid;
        }).slice(-1);
        return;
      }
      this.form.imagelist = fileList.slice(-1);
    },
    handleImageRemove: function handleImageRemove() {
      this.form.imagelist = [];
    },
    handleExceed: function handleExceed() {
      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', this.$t('validations.pictureSizeExceed'), 'warning').catch(function () {});
    },
    collectImage: function collectImage() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var f;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                f = _this9.form.imagelist && _this9.form.imagelist[0];

                if (f) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', '');

              case 3:
                if (!f.raw) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', _this9.getBase64(f.raw));

              case 5:
                return _context.abrupt('return', f.filename || '');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9);
      }))();
    },
    saveArticle: function saveArticle() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var image, data, isUpdate, url, method;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if ((_this10.form.title || '').trim()) {
                  _context2.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this10.$t('blogPage.titleRequired'), 'warning').catch(function () {});
                return _context2.abrupt('return');

              case 3:

                _this10.saving = true;

                image = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return _this10.collectImage();

              case 8:
                image = _context2.sent;
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                _this10.saving = false;
                __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this10.$t('validations.wentWrong'), 'error').catch(function () {});
                return _context2.abrupt('return');

              case 16:
                data = _this10.baseData({
                  title: _this10.form.title,
                  slug: _this10.form.slug,
                  short_description: _this10.form.short_description,
                  content: _this10.form.content,
                  blog_category_id: _this10.form.blog_category_id || '',
                  author_name: _this10.form.author_name,
                  published_at: _this10.form.published_at || '',
                  is_active: _this10.form.is_active ? 1 : 0,
                  image: image,
                  image_alt: _this10.form.image_alt,
                  meta_title: _this10.form.meta_title,
                  meta_description: _this10.form.meta_description,
                  meta_keywords: _this10.form.meta_keywords
                });
                isUpdate = !!_this10.form.id;
                url = isUpdate ? '/blog/articles/' + _this10.form.id : '/blog/articles';
                method = isUpdate ? 'PUT' : 'POST';


                _this10.apiRequest(url, method, data, function (response) {
                  _this10.saving = false;
                  if (response.status === true) {
                    _this10.closeModal();
                    _this10.getArticles();
                    _this10.getCategories();
                    __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()(_this10.$t('general.success') + '!', '', 'success').catch(function () {});
                  } else {
                    __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this10.firstError(response), 'error').catch(function () {});
                  }
                });

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this10, [[5, 11]]);
      }))();
    }
  }
});

/***/ }),

/***/ "Jlsm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JmI1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JovD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PosUserForm_vue__ = __webpack_require__("y5df");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PosUserForm: __WEBPACK_IMPORTED_MODULE_0__PosUserForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "JpJd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left"},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n        "+_vm._s(_vm.$t('general.back'))+"\n      ")])]),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('group-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onOfferSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JrLq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JtLQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__order__ = __webpack_require__("4U7a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Customers_countries__ = __webpack_require__("KLaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Customers_customers__ = __webpack_require__("qBXS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DeliveryService_services__ = __webpack_require__("rat0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Products_products__ = __webpack_require__("GuXC");









var _components;









__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_time_select___default.a), _components),
  data: function data() {
    return {
      order: __WEBPACK_IMPORTED_MODULE_10__order__["a" /* default */],
      countries: __WEBPACK_IMPORTED_MODULE_11__Customers_countries__["a" /* default */],
      customers: __WEBPACK_IMPORTED_MODULE_12__Customers_customers__["a" /* default */],
      deliveryMethods: __WEBPACK_IMPORTED_MODULE_13__DeliveryService_services__["a" /* default */],
      productsAll: __WEBPACK_IMPORTED_MODULE_14__Products_products__["a" /* default */],
      states: { billing: [], shipping: [] },
      modelValidations: {
        required: {
          required: true
        },
        product: {
          required: true
        },
        person: {
          required: true,
          min: 3
        },
        quantity: {
          required: true,
          min: 1
        }
      },
      newOrderHist: {
        'status': '',
        'comment': '',
        'customer_notified': false
      },
      modelProduct: {
        product: '',
        person: '',
        quantity: '1',
        price: 0
      },
      historyTableColumns: [{
        prop: 'date',
        label: 'Date',
        minWidth: 100
      }, {
        prop: 'comment',
        label: 'Comment',
        minWidth: 200
      }, {
        prop: 'status',
        label: 'Status',
        minWidth: 100
      }, {
        prop: 'customer_notified',
        label: 'Customer Notified',
        minWidth: 50
      }]
    };
  },
  created: function created() {},

  methods: {
    getRowClass: function getRowClass(label) {
      switch (label) {
        case 'discount':
          return 'text-danger';
        case 'total':
          return 'text-info';
        default:
          return '';
      }
    },
    addOrderHistory: function addOrderHistory() {
      var history = {
        'date': new Date().toJSON().slice(0, 10),
        'status': this.newOrderHist.status,
        'customer_notified': this.newOrderHist.customer_notified ? 'yes' : 'no',
        'comment': this.newOrderHist.comment
      };

      this.historyTableData.push(history);
      this.newOrderHist = {
        'status': '',
        'comment': '',
        'customer_notified': false
      };
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    addProduct: function addProduct() {
      var valid = this.validate();

      if (!valid) {
        return false;
      }

      var items = this.productsAll;
      var price = items[this.modelProduct.product].price;

      var newRow = {
        'customer': {
          'name': this.modelProduct.person
        },
        'items': [{
          'product_id': this.modelProduct.product,
          'name': items[this.modelProduct.product].name,
          'quantity': this.modelProduct.quantity,
          'price': price,
          'additional_info': '',
          'options': []
        }]
      };
      this.order.products.push(newRow);

      this.modelProduct = {
        product: '',
        person: '',
        quantity: '1',
        price: 0
      };
    },
    updateCounty: function updateCounty(type) {
      var name = this.order.address[type].country.name;

      this.states[type] = this.getCoutryStates(name);
    }
  }
});

/***/ }),

/***/ "Jz9u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LocationGroupSection_vue__ = __webpack_require__("Ozs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AddEditModal_vue__ = __webpack_require__("YQHF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__);














var _components;













__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    LocationGroupSection: __WEBPACK_IMPORTED_MODULE_17__LocationGroupSection_vue__["default"]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'AddEditModal', __WEBPACK_IMPORTED_MODULE_18__AddEditModal_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PPagination', __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'draggable', __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'swal', __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a), _components),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    },
    isLocationGroups: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isLocationGroups: function isLocationGroups() {
      if (this.isLocationGroups) {
        this.getData();
      }
    }
  },
  data: function data() {
    return {
      loading: true,
      tableColumns: [{
        prop: 'name',
        label: 'Name',

        minWidth: 100
      }, {
        prop: 'description',
        label: 'Description',

        minWidth: 100
      }],
      model: [{
        id: null,
        company_id: null,
        active: true,
        name: '',
        description: '',
        image: '',
        sort_order: null
      }],
      groupsData: {},
      activeName: '',
      groupValidations: {
        group_name: {
          required: true
        },
        group_display: {
          required: true
        }
      },
      editGroup: null,
      openModal: false,
      groupToBeDeleted: null,
      groupToBeAdded: null,
      groupToBeEdited: null
    };
  },

  methods: {
    handleNewLocationGroup: function handleNewLocationGroup(newGroup) {
      var newData = [];
      if (!newGroup.parent_id) {
        newGroup.children = [];
        newData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.groupsData), [newGroup]);
        __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this, 'groupsData', newData);
        return;
      }
      if (newGroup.parent_id) {
        var parent = this.findGroupById(this.groupsData, newGroup.parent_id);
        if (parent) {
          var index = this.groupsData.indexOf(parent);
          if (index !== -1 && this.groupsData[index].children && !this.groupsData[index].children.includes(newGroup)) {
            newData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.groupsData[index].children), [newGroup]);
            __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this.groupsData[index], 'children', newData);
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this, 'groupToBeAdded', newGroup);
        }
      }
    },
    editLocationsGroup: function editLocationsGroup(group) {
      if (group.parent_id) {
        this.updateData(group);
      } else {
        this.updateDataChild(group);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this, 'groupToBeEdited', group);
    },
    deleteLocationsGroup: function deleteLocationsGroup(deletedGroup) {
      var filteredData = [];
      if (deletedGroup.hasOwnProperty('children')) {
        this.handleChildrenOfDeletedGroup(deletedGroup.children);
      }
      if (deletedGroup.parent_id) {
        var parent = {};
        parent = this.groupsData.filter(function (element) {
          return element.id === deletedGroup.parent_id;
        });
        if (parent && parent.length === 1) {
          filteredData = parent[0].children.filter(function (child) {
            return child.id !== deletedGroup.id;
          });
          var index = this.groupsData.indexOf(parent[0]);
          __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this.groupsData[index], 'children', []);
          this.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this.groupsData[index], 'children', filteredData);
          });
          return;
        }
      }
      if (this.groupsData.includes(deletedGroup)) {
        filteredData = this.groupsData.filter(function (element) {
          return element.id !== deletedGroup.id;
        });
        __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this, 'groupsData', filteredData);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this, 'groupToBeDeleted', deletedGroup);
    },
    updateData: function updateData(group) {
      var parent = this.findGroupById(this.groupsData, group.parent_id);
      if (parent) {
        var parentIndex = this.groupsData.indexOf(parent);
        if (parentIndex !== -1) {
          var beforeEditGroup = this.findGroupById(this.groupsData[parentIndex].children, group.id);
          var childIndex = this.groupsData[parentIndex].children.indexOf(beforeEditGroup);
          if (childIndex !== -1) {
            __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this.groupsData[parentIndex].children[childIndex], 'image', group.image);
          }
        }
      }
    },
    updateDataChild: function updateDataChild(group) {
      var beforeEditGroup = this.findGroupById(this.groupsData, group.id);
      var index = this.groupsData.indexOf(beforeEditGroup);
      if (index !== -1) {
        __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this.groupsData[index], 'image', group.image);
      }
    },
    findGroupById: function findGroupById(haystack, groupId) {
      var beforeEditGroup = haystack.filter(function (element) {
        return element.id === groupId;
      });
      beforeEditGroup = beforeEditGroup.pop();
      return beforeEditGroup;
    },
    openEditLocationGroupModal: function openEditLocationGroupModal() {
      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this, 'editGroup', group);
      __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this, 'openModal', !this.openModal);
    },
    handleActiveGroup: function handleActiveGroup(group) {
      var _this = this;

      var actionText = group.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + group.name + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this.$session.get('token'),
            company_id: _this.$session.get('selectedCompany'),
            active: group.active ? 1 : 0,
            name: group.name,
            id: group.id
          };
          _this.apiRequest('/location-groups/' + group.id, 'PUT', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                title: '',
                text: _this.$t('general.success'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                title: '',
                text: _this.$t('validations.dataCouldNotBeSaved'),
                type: 'danger',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
            }
          });
        }
      }).catch(function () {
        group.active = !group.active;
      });
    },
    handleChildrenOfDeletedGroup: function handleChildrenOfDeletedGroup(children) {
      var _this2 = this;

      children.forEach(function (element) {
        var data = {
          token: _this2.$session.get('token'),
          company_id: _this2.$session.get('selectedCompany'),
          id: element.id,
          name: element.name,
          parent_id: null,
          active: false
        };
        _this2.apiRequest('/location-groups/' + element.id, 'PUT', data, function (response) {
          if (response.data) {
            _this2.groupsData.push(response.data);
          }
        });
      });
    },
    onEndParent: function onEndParent(evt, haystack) {
      if (haystack && haystack.length > 1) {
        var idx = evt.newIndex;
        var sortOrder = this.calculateNewSortOrder(evt, haystack);
        var id = haystack[idx].id;
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: sortOrder
        };
        this.updateGroup(data, function () {});
      }
    },
    onEndChild: function onEndChild(evt, haystack) {
      var _this3 = this;

      if (haystack && haystack.length > 1) {
        var idx = evt.newIndex;
        var sortOrder = this.calculateNewSortOrder(evt, haystack);
        var id = haystack[idx].id;
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: sortOrder
        };
        this.updateGroup(data, function () {
          var parent = _this3.findGroupById(_this3.groupsData, haystack[idx].parent_id);
          var index = _this3.groupsData.indexOf(parent);
          var copy = _this3.groupsData[index].children;
          __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(_this3.groupsData[index], 'children', []);
          _this3.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this.groupsData[index], 'children', copy);
          });
        });
      }
    },
    updateGroup: function updateGroup(requestData, callback) {
      this.apiRequest('/location-groups/' + requestData.id, 'PUT', requestData, function (response) {
        if (response.status) {
          callback();
        }
      });
    },
    calculateNewSortOrder: function calculateNewSortOrder(evt, haystack) {
      var idx = evt.newIndex;
      var after, before, sortOrder;
      if (idx === 0) {
        before = 0;
        after = haystack[idx + 1].sort_order ? haystack[idx + 1].sort_order : 1;
      } else if (idx + 1 === haystack.length) {
        before = haystack[idx - 1].sort_order;
        after = parseFloat(before) + 1;
      } else {
        before = haystack[idx - 1].sort_order - haystack[idx - 1].sort_order * 0.1;
        after = haystack[idx + 1].sort_order - haystack[idx + 1].sort_order * 0.1;
      }
      sortOrder = (parseFloat(before) + parseFloat(after)) / 2;
      return sortOrder;
    },
    getData: function getData() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/locations-groups-index-admin', 'GET', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(_this4, 'groupsData', response.data);
          _this4.$nextTick(function () {
            this.loading = false;
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "K/+R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K2Qx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K4Pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NexusReport_vue__ = __webpack_require__("RM7a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2e8b63e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NexusReport_vue__ = __webpack_require__("bFwK");
function injectStyle (ssrContext) {
  __webpack_require__("npOj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NexusReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2e8b63e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NexusReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KAZc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KAgW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('pos-screen-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KDLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsFields.platform_status_polling_enabled')))]),_vm._v(" "),_c('div',[_c('p-switch',{staticClass:"mar-bt-0",attrs:{"value":Boolean(_vm.formData.platform_status_polling_enabled),"disabled":_vm.disabled,"type":"success"},on:{"input":_vm.setEnabled}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KEOC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      loading: false,
      tableData: [],
      rewardId: null,
      pageTitle: ''
    };
  },
  created: function created() {
    this.rewardId = this.route.params && this.route.params.rewardId || this.$route.params && this.$route.params.rewardId;
    this.pageTitle = this.$route.query && this.$route.query.title || this.$t('spinningWheel.users');
    this.loadReport();
  },

  methods: {
    back: function back() {
      var q = this.$route.query || {};
      if (q.campaign_id) {
        this.$router.replace({
          path: '/reports/spinning-wheel/' + q.campaign_id + '/rewards',
          query: {
            title: '',
            date_from: q.date_from || '',
            date_to: q.date_to || ''
          }
        });
        return;
      }
      this.$bus.$emit('close-modal');
    },
    toggleExpand: function toggleExpand() {},
    loadReport: function loadReport() {
      var _this = this;

      if (!this.rewardId) return;
      this.loading = true;
      var params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      var q = this.$route.query || {};
      if (q.date_from) params.date_from = q.date_from;
      if (q.date_to) params.date_to = q.date_to;
      this.apiRequest('/reports/spinning-wheel/rewards/' + this.rewardId + '/users', 'GET', params, function (response) {
        _this.loading = false;
        if (response.status && response.data) {
          _this.tableData = response.data.users || [];
          if (response.data.reward && response.data.reward.name) {
            _this.pageTitle = response.data.reward.name;
          }
        } else {
          _this.tableData = [];
        }
      });
    }
  }
});

/***/ }),

/***/ "KFmv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('pos-map-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KLaF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ 'name': 'Afghanistan', 'code': 'AF' }, { 'name': 'land Islands', 'code': 'AX' }, { 'name': 'Albania', 'code': 'AL' }, { 'name': 'Algeria', 'code': 'DZ' }, { 'name': 'American Samoa', 'code': 'AS' }, { 'name': 'AndorrA', 'code': 'AD' }, { 'name': 'Angola', 'code': 'AO' }, { 'name': 'Anguilla', 'code': 'AI' }, { 'name': 'Antarctica', 'code': 'AQ' }, { 'name': 'Antigua and Barbuda', 'code': 'AG' }, { 'name': 'Argentina', 'code': 'AR' }, { 'name': 'Armenia', 'code': 'AM' }, { 'name': 'Aruba', 'code': 'AW' }, { 'name': 'Australia', 'code': 'AU' }, { 'name': 'Austria', 'code': 'AT' }, { 'name': 'Azerbaijan', 'code': 'AZ' }, { 'name': 'Bahamas', 'code': 'BS' }, { 'name': 'Bahrain', 'code': 'BH' }, { 'name': 'Bangladesh', 'code': 'BD' }, { 'name': 'Barbados', 'code': 'BB' }, { 'name': 'Belarus', 'code': 'BY' }, { 'name': 'Belgium', 'code': 'BE' }, { 'name': 'Belize', 'code': 'BZ' }, { 'name': 'Benin', 'code': 'BJ' }, { 'name': 'Bermuda', 'code': 'BM' }, { 'name': 'Bhutan', 'code': 'BT' }, { 'name': 'Bolivia', 'code': 'BO' }, { 'name': 'Bosnia and Herzegovina', 'code': 'BA' }, { 'name': 'Botswana', 'code': 'BW' }, { 'name': 'Bouvet Island', 'code': 'BV' }, { 'name': 'Brazil', 'code': 'BR' }, { 'name': 'British Indian Ocean Territory', 'code': 'IO' }, { 'name': 'Brunei Darussalam', 'code': 'BN' }, { 'name': 'Bulgaria', 'code': 'BG' }, { 'name': 'Burkina Faso', 'code': 'BF' }, { 'name': 'Burundi', 'code': 'BI' }, { 'name': 'Cambodia', 'code': 'KH' }, { 'name': 'Cameroon', 'code': 'CM' }, { 'name': 'Canada', 'code': 'CA' }, { 'name': 'Cape Verde', 'code': 'CV' }, { 'name': 'Cayman Islands', 'code': 'KY' }, { 'name': 'Central African Republic', 'code': 'CF' }, { 'name': 'Chad', 'code': 'TD' }, { 'name': 'Chile', 'code': 'CL' }, { 'name': 'China', 'code': 'CN' }, { 'name': 'Christmas Island', 'code': 'CX' }, { 'name': 'Cocos (Keeling) Islands', 'code': 'CC' }, { 'name': 'Colombia', 'code': 'CO' }, { 'name': 'Comoros', 'code': 'KM' }, { 'name': 'Congo', 'code': 'CG' }, { 'name': 'Congo, The Democratic Republic of the', 'code': 'CD' }, { 'name': 'Cook Islands', 'code': 'CK' }, { 'name': 'Costa Rica', 'code': 'CR' }, { 'name': 'Cote D\'Ivoire', 'code': 'CI' }, { 'name': 'Croatia', 'code': 'HR' }, { 'name': 'Cuba', 'code': 'CU' }, { 'name': 'Cyprus', 'code': 'CY' }, { 'name': 'Czech Republic', 'code': 'CZ' }, { 'name': 'Denmark', 'code': 'DK' }, { 'name': 'Djibouti', 'code': 'DJ' }, { 'name': 'Dominica', 'code': 'DM' }, { 'name': 'Dominican Republic', 'code': 'DO' }, { 'name': 'Ecuador', 'code': 'EC' }, { 'name': 'Egypt', 'code': 'EG' }, { 'name': 'El Salvador', 'code': 'SV' }, { 'name': 'Equatorial Guinea', 'code': 'GQ' }, { 'name': 'Eritrea', 'code': 'ER' }, { 'name': 'Estonia', 'code': 'EE' }, { 'name': 'Ethiopia', 'code': 'ET' }, { 'name': 'Falkland Islands (Malvinas)', 'code': 'FK' }, { 'name': 'Faroe Islands', 'code': 'FO' }, { 'name': 'Fiji', 'code': 'FJ' }, { 'name': 'Finland', 'code': 'FI' }, { 'name': 'France', 'code': 'FR' }, { 'name': 'French Guiana', 'code': 'GF' }, { 'name': 'French Polynesia', 'code': 'PF' }, { 'name': 'French Southern Territories', 'code': 'TF' }, { 'name': 'Gabon', 'code': 'GA' }, { 'name': 'Gambia', 'code': 'GM' }, { 'name': 'Georgia', 'code': 'GE' }, { 'name': 'Germany', 'code': 'DE' }, { 'name': 'Ghana', 'code': 'GH' }, { 'name': 'Gibraltar', 'code': 'GI' }, { 'name': 'Greece', 'code': 'GR' }, { 'name': 'Greenland', 'code': 'GL' }, { 'name': 'Grenada', 'code': 'GD' }, { 'name': 'Guadeloupe', 'code': 'GP' }, { 'name': 'Guam', 'code': 'GU' }, { 'name': 'Guatemala', 'code': 'GT' }, { 'name': 'Guernsey', 'code': 'GG' }, { 'name': 'Guinea', 'code': 'GN' }, { 'name': 'Guinea-Bissau', 'code': 'GW' }, { 'name': 'Guyana', 'code': 'GY' }, { 'name': 'Haiti', 'code': 'HT' }, { 'name': 'Heard Island and Mcdonald Islands', 'code': 'HM' }, { 'name': 'Holy See (Vatican City State)', 'code': 'VA' }, { 'name': 'Honduras', 'code': 'HN' }, { 'name': 'Hong Kong', 'code': 'HK' }, { 'name': 'Hungary', 'code': 'HU' }, { 'name': 'Iceland', 'code': 'IS' }, { 'name': 'India', 'code': 'IN' }, { 'name': 'Indonesia', 'code': 'ID' }, { 'name': 'Iran, Islamic Republic Of', 'code': 'IR' }, { 'name': 'Iraq', 'code': 'IQ' }, { 'name': 'Ireland', 'code': 'IE' }, { 'name': 'Isle of Man', 'code': 'IM' }, { 'name': 'Israel', 'code': 'IL' }, { 'name': 'Italy', 'code': 'IT' }, { 'name': 'Jamaica', 'code': 'JM' }, { 'name': 'Japan', 'code': 'JP' }, { 'name': 'Jersey', 'code': 'JE' }, { 'name': 'Jordan', 'code': 'JO' }, { 'name': 'Kazakhstan', 'code': 'KZ' }, { 'name': 'Kenya', 'code': 'KE' }, { 'name': 'Kiribati', 'code': 'KI' }, { 'name': 'Korea, Democratic People\'S Republic of', 'code': 'KP' }, { 'name': 'Korea, Republic of', 'code': 'KR' }, { 'name': 'Kuwait', 'code': 'KW' }, { 'name': 'Kyrgyzstan', 'code': 'KG' }, { 'name': 'Lao People\'S Democratic Republic', 'code': 'LA' }, { 'name': 'Latvia', 'code': 'LV' }, { 'name': 'Lebanon', 'code': 'LB' }, { 'name': 'Lesotho', 'code': 'LS' }, { 'name': 'Liberia', 'code': 'LR' }, { 'name': 'Libyan Arab Jamahiriya', 'code': 'LY' }, { 'name': 'Liechtenstein', 'code': 'LI' }, { 'name': 'Lithuania', 'code': 'LT' }, { 'name': 'Luxembourg', 'code': 'LU' }, { 'name': 'Macao', 'code': 'MO' }, { 'name': 'Macedonia, The Former Yugoslav Republic of', 'code': 'MK' }, { 'name': 'Madagascar', 'code': 'MG' }, { 'name': 'Malawi', 'code': 'MW' }, { 'name': 'Malaysia', 'code': 'MY' }, { 'name': 'Maldives', 'code': 'MV' }, { 'name': 'Mali', 'code': 'ML' }, { 'name': 'Malta', 'code': 'MT' }, { 'name': 'Marshall Islands', 'code': 'MH' }, { 'name': 'Martinique', 'code': 'MQ' }, { 'name': 'Mauritania', 'code': 'MR' }, { 'name': 'Mauritius', 'code': 'MU' }, { 'name': 'Mayotte', 'code': 'YT' }, { 'name': 'Mexico', 'code': 'MX' }, { 'name': 'Micronesia, Federated States of', 'code': 'FM' }, { 'name': 'Moldova, Republic of', 'code': 'MD' }, { 'name': 'Monaco', 'code': 'MC' }, { 'name': 'Mongolia', 'code': 'MN' }, { 'name': 'Montenegro', 'code': 'ME' }, { 'name': 'Montserrat', 'code': 'MS' }, { 'name': 'Morocco', 'code': 'MA' }, { 'name': 'Mozambique', 'code': 'MZ' }, { 'name': 'Myanmar', 'code': 'MM' }, { 'name': 'Namibia', 'code': 'NA' }, { 'name': 'Nauru', 'code': 'NR' }, { 'name': 'Nepal', 'code': 'NP' }, { 'name': 'Netherlands', 'code': 'NL' }, { 'name': 'Netherlands Antilles', 'code': 'AN' }, { 'name': 'New Caledonia', 'code': 'NC' }, { 'name': 'New Zealand', 'code': 'NZ' }, { 'name': 'Nicaragua', 'code': 'NI' }, { 'name': 'Niger', 'code': 'NE' }, { 'name': 'Nigeria', 'code': 'NG' }, { 'name': 'Niue', 'code': 'NU' }, { 'name': 'Norfolk Island', 'code': 'NF' }, { 'name': 'Northern Mariana Islands', 'code': 'MP' }, { 'name': 'Norway', 'code': 'NO' }, { 'name': 'Oman', 'code': 'OM' }, { 'name': 'Pakistan', 'code': 'PK' }, { 'name': 'Palau', 'code': 'PW' }, { 'name': 'Palestinian Territory, Occupied', 'code': 'PS' }, { 'name': 'Panama', 'code': 'PA' }, { 'name': 'Papua New Guinea', 'code': 'PG' }, { 'name': 'Paraguay', 'code': 'PY' }, { 'name': 'Peru', 'code': 'PE' }, { 'name': 'Philippines', 'code': 'PH' }, { 'name': 'Pitcairn', 'code': 'PN' }, { 'name': 'Poland', 'code': 'PL' }, { 'name': 'Portugal', 'code': 'PT' }, { 'name': 'Puerto Rico', 'code': 'PR' }, { 'name': 'Qatar', 'code': 'QA' }, { 'name': 'Reunion', 'code': 'RE' }, { 'name': 'Romania', 'code': 'RO' }, { 'name': 'Russian Federation', 'code': 'RU' }, { 'name': 'RWANDA', 'code': 'RW' }, { 'name': 'Saint Helena', 'code': 'SH' }, { 'name': 'Saint Kitts and Nevis', 'code': 'KN' }, { 'name': 'Saint Lucia', 'code': 'LC' }, { 'name': 'Saint Pierre and Miquelon', 'code': 'PM' }, { 'name': 'Saint Vincent and the Grenadines', 'code': 'VC' }, { 'name': 'Samoa', 'code': 'WS' }, { 'name': 'San Marino', 'code': 'SM' }, { 'name': 'Sao Tome and Principe', 'code': 'ST' }, { 'name': 'Saudi Arabia', 'code': 'SA' }, { 'name': 'Senegal', 'code': 'SN' }, { 'name': 'Serbia', 'code': 'RS' }, { 'name': 'Seychelles', 'code': 'SC' }, { 'name': 'Sierra Leone', 'code': 'SL' }, { 'name': 'Singapore', 'code': 'SG' }, { 'name': 'Slovakia', 'code': 'SK' }, { 'name': 'Slovenia', 'code': 'SI' }, { 'name': 'Solomon Islands', 'code': 'SB' }, { 'name': 'Somalia', 'code': 'SO' }, { 'name': 'South Africa', 'code': 'ZA' }, { 'name': 'South Georgia and the South Sandwich Islands', 'code': 'GS' }, { 'name': 'Spain', 'code': 'ES' }, { 'name': 'Sri Lanka', 'code': 'LK' }, { 'name': 'Sudan', 'code': 'SD' }, { 'name': 'Suriname', 'code': 'SR' }, { 'name': 'Svalbard and Jan Mayen', 'code': 'SJ' }, { 'name': 'Swaziland', 'code': 'SZ' }, { 'name': 'Sweden', 'code': 'SE' }, { 'name': 'Switzerland', 'code': 'CH' }, { 'name': 'Syrian Arab Republic', 'code': 'SY' }, { 'name': 'Taiwan, Province of China', 'code': 'TW' }, { 'name': 'Tajikistan', 'code': 'TJ' }, { 'name': 'Tanzania, United Republic of', 'code': 'TZ' }, { 'name': 'Thailand', 'code': 'TH' }, { 'name': 'Timor-Leste', 'code': 'TL' }, { 'name': 'Togo', 'code': 'TG' }, { 'name': 'Tokelau', 'code': 'TK' }, { 'name': 'Tonga', 'code': 'TO' }, { 'name': 'Trinidad and Tobago', 'code': 'TT' }, { 'name': 'Tunisia', 'code': 'TN' }, { 'name': 'Turkey', 'code': 'TR' }, { 'name': 'Turkmenistan', 'code': 'TM' }, { 'name': 'Turks and Caicos Islands', 'code': 'TC' }, { 'name': 'Tuvalu', 'code': 'TV' }, { 'name': 'Uganda', 'code': 'UG' }, { 'name': 'Ukraine', 'code': 'UA' }, { 'name': 'United Arab Emirates', 'code': 'AE' }, { 'name': 'United Kingdom', 'code': 'GB' }, { 'name': 'United States', 'code': 'US' }, { 'name': 'United States Minor Outlying Islands', 'code': 'UM' }, { 'name': 'Uruguay', 'code': 'UY' }, { 'name': 'Uzbekistan', 'code': 'UZ' }, { 'name': 'Vanuatu', 'code': 'VU' }, { 'name': 'Venezuela', 'code': 'VE' }, { 'name': 'Viet Nam', 'code': 'VN' }, { 'name': 'Virgin Islands, British', 'code': 'VG' }, { 'name': 'Virgin Islands, U.S.', 'code': 'VI' }, { 'name': 'Wallis and Futuna', 'code': 'WF' }, { 'name': 'Western Sahara', 'code': 'EH' }, { 'name': 'Yemen', 'code': 'YE' }, { 'name': 'Zambia', 'code': 'ZM' }, { 'name': 'Zimbabwe', 'code': 'ZW' }]);

/***/ }),

/***/ "KMI6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInitialStock },on:{"click":_vm.openInitialStock}},[_vm._v(_vm._s(_vm.$t('gestiune.initialStock')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInventar },on:{"click":_vm.openInventar}},[_vm._v(_vm._s(_vm.$t('gestiune.inventar')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isBonConsum },on:{"click":_vm.openBonConsum}},[_vm._v(_vm._s(_vm.$t('gestiune.stoc.action.bonConsum')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isBonProduct },on:{"click":_vm.openBonProduct}},[_vm._v(_vm._s(_vm.$t('gestiune.isBonProductie')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isBonTransfer },on:{"click":_vm.openBonTrasnfer}},[_vm._v(_vm._s(_vm.$t('gestiune.notaTransfer')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isCasare },on:{"click":_vm.openCasare}},[_vm._v(_vm._s(_vm.$t('gestiune.casare')))])])])])]),_vm._v(" "),(_vm.isInitialStock)?_c('div',[_c('ManagementInitialStock',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isInventar)?_c('div',[_c('ManagementInventory',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isBonProduct)?_c('div',[_c('ManagementBonProduct',{attrs:{"grouped-locations":_vm.groupedLocations,"gestiune-options":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isLot)?_c('div',[_c('ManagementLot',{attrs:{"grouped-locations":_vm.groupedLocations,"gestiune-options":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isBonConsum)?_c('div',[_c('ManagementStocks',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isBonTransfer)?_c('div',[_c('ManagementTransfer',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isCasare)?_c('div',[_c('ManagementWasted',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KNB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Printers_vue__ = __webpack_require__("msZ6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a528c8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Printers_vue__ = __webpack_require__("nXWo");
function injectStyle (ssrContext) {
  __webpack_require__("N+ua")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a528c8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Printers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a528c8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Printers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KNch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementMyOrdersSuppliers_vue__ = __webpack_require__("CmBs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2495cb43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementMyOrdersSuppliers_vue__ = __webpack_require__("UgX3");
function injectStyle (ssrContext) {
  __webpack_require__("U4CI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2495cb43"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementMyOrdersSuppliers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2495cb43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementMyOrdersSuppliers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KTmZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.isInvoice)?_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"button","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.saveInvoice($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('invoice.invoiced'))+"\n        ")]):_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('invoice.invoiceDetails')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat) + " — Locații: " + (group.locations.map(function (l) { return l.name; }).join(', ')))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                  "+_vm._s(loc.name)+"\n                ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.issueDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.issueDate),expression:"issueDate"}],staticClass:"form-control",attrs:{"type":"datetime-local","max":_vm.today},domProps:{"value":(_vm.issueDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.issueDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.dueDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dueDate),expression:"dueDate"}],staticClass:"form-control",attrs:{"type":"datetime-local","max":_vm.today},domProps:{"value":(_vm.dueDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dueDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.series'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seriesNumber),expression:"seriesNumber"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seriesNumber=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.updateNumber]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('invoice.selectSeries')))]),_vm._v(" "),_vm._l((_vm.seriesOptionsWithAdd),function(series){return _c('option',{key:series.id || series.series,domProps:{"value":series.id || series.series}},[_vm._v("\n                  "+_vm._s(series.nume || series.series)+"\n                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currentNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentNumber),expression:"currentNumber"}],staticClass:"form-control",attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.currentNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentNumber=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('invoice.client')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.vatPayer'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientVATPayer),expression:"clientVATPayer"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.clientVATPayer=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"yes"}},[_vm._v(_vm._s(_vm.$t('invoice.yes')))]),_vm._v(" "),_c('option',{attrs:{"value":"no"}},[_vm._v(_vm._s(_vm.$t('invoice.no')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.legalStatus'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientLegalStatus),expression:"clientLegalStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.clientLegalStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"fizica"}},[_vm._v(_vm._s(_vm.$t('invoice.statusLegal.fizica')))]),_vm._v(" "),_c('option',{attrs:{"value":"juridica_ro"}},[_vm._v(_vm._s(_vm.$t('invoice.statusLegal.juridicaRo')))]),_vm._v(" "),_c('option',{attrs:{"value":"juridica_eu"}},[_vm._v(_vm._s(_vm.$t('invoice.statusLegal.juridicaEu')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientName'))+"*")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.clientResults,"label":"nume","placeholder":"Caută un client...","filterable":false,"disabled":!_vm.selectedLocation},on:{"search":_vm.fetchClients,"input":_vm.onClientSelect},model:{value:(_vm.clientSelected),callback:function ($$v) {_vm.clientSelected=$$v},expression:"clientSelected"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientCUI'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.clientCUI),expression:"modelValidate.clientCUI"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientCUI')},domProps:{"value":_vm.clientCUI},on:{"input":function($event){_vm.clientCUI = $event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientEmail),expression:"clientEmail"}],staticClass:"form-control",attrs:{"type":"email","placeholder":_vm.$t('invoice.clientEmail')},domProps:{"value":(_vm.clientEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientPhone'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientPhone),expression:"clientPhone"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.clientPhone),expression:"modelValidate.clientPhone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientPhone')},domProps:{"value":(_vm.clientPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientPhone=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientAddress'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientAddress),expression:"clientAddress"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.clientAddress),expression:"modelValidate.clientAddress"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientAddress')},domProps:{"value":(_vm.clientAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientAddress=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('invoice.otherDetails')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.currency'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency),expression:"currency"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currency=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"RON"}},[_vm._v("RON")]),_vm._v(" "),_c('option',{attrs:{"value":"EUR"}},[_vm._v("EUR")]),_vm._v(" "),_c('option',{attrs:{"value":"USD"}},[_vm._v("USD")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.language')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.language),expression:"language"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.language=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"ro"}},[_vm._v("Română")]),_vm._v(" "),_c('option',{attrs:{"value":"en"}},[_vm._v("English")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"title"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProductInProforma')))])]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search Order Id..."},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"btn btn-icon btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.searchOrder}},[_c('i',{staticClass:"ti-search"})])])]),_vm._v(" "),_c('hr',{staticClass:"sm"})])]),_vm._v(" "),[_c('div',[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.productName'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.type'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.codeProduct'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.unitMeasure'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.quantity'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.vatRate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.pretFaraTva'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.valoare')))]),_vm._v(" "),_c('th',[_vm._v("TVA")]),_vm._v(" "),(!_vm.isDisabled && !_vm.isEdit)?_c('th',[_vm._v(_vm._s(_vm.$t('general.actions')))]):_vm._e()])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(_vm.getGestiuneName(item.gestiuneFrom)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(typeof item.productName === 'object' ? item.productName.name : item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.unitMeasure))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.vatRate)+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.priceRON))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.valoare))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tva))]),_vm._v(" "),(!_vm.isDisabled && !_vm.isEdit)?_c('td',[_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",on:{"click":function($event){_vm.removeItem(index)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                        "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])]):_vm._e()])}),_vm._v(" "),(!_vm.isInvoice && !_vm.isEdit && !_vm.isDisabled)?_c('tr',[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.gestiuneId),expression:"newItem.gestiuneId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newItem, "gestiuneId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selectează gestiunea")]),_vm._v(" "),_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('option',{key:gestiune.id,domProps:{"value":gestiune.id}},[_vm._v("\n                        "+_vm._s(gestiune.name)+"\n                      ")])})],2)]),_vm._v(" "),_c('td',{staticStyle:{"width":"250px !important"}},[_c('v-select',{attrs:{"options":_vm.searchResults,"label":"name","placeholder":"Caută un produs...","filterable":false},on:{"search":_vm.fetchProducts,"input":_vm.onProductSelected},model:{value:(_vm.newItem.productName),callback:function ($$v) {_vm.$set(_vm.newItem, "productName", $$v)},expression:"newItem.productName"}},[[(!_vm.loadingProducts)?_c('span',[_vm._v("Niciun produs găsit")]):_vm._e()]],2),_vm._v(" "),(_vm.loadingProducts)?_c('div',{staticClass:"v-select-loader-product"}):_vm._e()],1),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.type),expression:"newItem.type"}],staticClass:"form-control",attrs:{"disabled":true},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newItem, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Tip")]),_vm._v(" "),_c('option',{attrs:{"value":"Marfa"}},[_vm._v("Marfa")]),_vm._v(" "),_c('option',{attrs:{"value":"Materii prime"}},[_vm._v("Materii prime")]),_vm._v(" "),_c('option',{attrs:{"value":"Materiale consumabile"}},[_vm._v("Materiale consumabile")]),_vm._v(" "),_c('option',{attrs:{"value":"Semifabricate (Reteta)"}},[_vm._v("Semifabricate (Reteta)")]),_vm._v(" "),_c('option',{attrs:{"value":"Produs finit (Reteta)"}},[_vm._v("Produs finit (Reteta)")]),_vm._v(" "),_c('option',{attrs:{"value":"Produs rezidual"}},[_vm._v("Produs rezidual")]),_vm._v(" "),_c('option',{attrs:{"value":"Ambalaje"}},[_vm._v("Ambalaje")]),_vm._v(" "),_c('option',{attrs:{"value":"Obiecte de inventar"}},[_vm._v("Obiecte de inventar")])])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.code),expression:"newItem.code"}],staticClass:"form-control",attrs:{"type":"text","disabled":true,"placeholder":"Cod"},domProps:{"value":(_vm.newItem.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "code", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('el-select',{attrs:{"disabled":true,"placeholder":"Selectează unitatea de măsură"},model:{value:(_vm.newItem.unitMeasure),callback:function ($$v) {_vm.$set(_vm.newItem, "unitMeasure", $$v)},expression:"newItem.unitMeasure"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.quantity),expression:"newItem.quantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('invoice.quantity')},domProps:{"value":(_vm.newItem.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "quantity", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('el-select',{attrs:{"placeholder":"Cota TVA"},model:{value:(_vm.newItem.vatRate),callback:function ($$v) {_vm.$set(_vm.newItem, "vatRate", $$v)},expression:"newItem.vatRate"}},_vm._l((_vm.vats),function(vat){return _c('el-option',{key:vat.tax_id,attrs:{"label":((vat.amount) + " %"),"value":vat.amount}})}))],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.priceRON),expression:"newItem.priceRON",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.pretFaraTva')},domProps:{"value":(_vm.newItem.priceRON)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "priceRON", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('el-select',{attrs:{"placeholder":"Prețul include TVA?"},model:{value:(_vm.newItem.includeVAT),callback:function ($$v) {_vm.$set(_vm.newItem, "includeVAT", $$v)},expression:"newItem.includeVAT"}},[_c('el-option',{attrs:{"label":"Cu TVA","value":"yes"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Fără TVA","value":"no"}})],1)],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.tva),expression:"newItem.tva",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":_vm.$t('gestiune.tva')},domProps:{"value":(_vm.newItem.tva)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "tva", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.addItem}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.add'))+"\n                    ")])])]):_vm._e()],2)])])],_vm._v(" "),_c('div',{staticClass:"totals-container"},[_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Total fara TVA:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalFaraTva.toFixed(2))+" RON")])]),_vm._v(" "),_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Total TVA:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalTva.toFixed(2))+" RON")])]),_vm._v(" "),(_vm.totalCorectie !== 0)?_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Corectie Document:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalCorectie.toFixed(2))+" RON")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"total-row total-final"},[_c('span',{staticClass:"label"},[_vm._v("Total:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalFinal.toFixed(2))+" RON")])])])],2)]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v("Detalii Client")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"intocmitDe"}},[_vm._v("Întocmit de")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.intocmitDe),expression:"extraFields.intocmitDe"}],staticClass:"form-control",attrs:{"type":"text","id":"intocmitDe","placeholder":"Numele persoanei"},domProps:{"value":(_vm.extraFields.intocmitDe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "intocmitDe", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"cnp"}},[_vm._v("CNP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.cnp),expression:"extraFields.cnp"}],staticClass:"form-control",attrs:{"type":"text","id":"cnp","placeholder":"Cod Numeric Personal"},domProps:{"value":(_vm.extraFields.cnp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "cnp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"delegat"}},[_vm._v("Delegat")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.delegat),expression:"extraFields.delegat"}],staticClass:"form-control",attrs:{"type":"text","id":"delegat","placeholder":"Numele delegatului"},domProps:{"value":(_vm.extraFields.delegat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "delegat", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"carteIdentitate"}},[_vm._v("Carte Identitate")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.carteIdentitate),expression:"extraFields.carteIdentitate"}],staticClass:"form-control",attrs:{"type":"text","id":"carteIdentitate","placeholder":"Seria și numărul cărții de identitate"},domProps:{"value":(_vm.extraFields.carteIdentitate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "carteIdentitate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"auto"}},[_vm._v("Auto")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.auto),expression:"extraFields.auto"}],staticClass:"form-control",attrs:{"type":"text","id":"auto","placeholder":"Marca și modelul auto"},domProps:{"value":(_vm.extraFields.auto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "auto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"agentVanzari"}},[_vm._v("Agent vânzări")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.agentVanzari),expression:"extraFields.agentVanzari"}],staticClass:"form-control",attrs:{"type":"text","id":"agentVanzari","placeholder":"Numele agentului de vânzări"},domProps:{"value":(_vm.extraFields.agentVanzari)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "agentVanzari", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"punctDeLucruClient"}},[_vm._v("Punct de Lucru Client")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.punctDeLucruClient),expression:"extraFields.punctDeLucruClient"}],staticClass:"form-control",attrs:{"type":"text","id":"punctDeLucruClient","placeholder":"Locația punctului de lucru"},domProps:{"value":(_vm.extraFields.punctDeLucruClient)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "punctDeLucruClient", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"numarComandaBT13"}},[_vm._v("Număr comandă BT-13")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.numarComandaBT13),expression:"extraFields.numarComandaBT13"}],staticClass:"form-control",attrs:{"type":"text","id":"numarComandaBT13","placeholder":"Numărul comenzii"},domProps:{"value":(_vm.extraFields.numarComandaBT13)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "numarComandaBT13", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"numarContractBT12"}},[_vm._v("Număr contract BT-12")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.numarContractBT12),expression:"extraFields.numarContractBT12"}],staticClass:"form-control",attrs:{"type":"text","id":"numarContractBT12","placeholder":"Numărul contractului"},domProps:{"value":(_vm.extraFields.numarContractBT12)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "numarContractBT12", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"referintaProiectBT11"}},[_vm._v("Referință proiect BT-11")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.referintaProiectBT11),expression:"extraFields.referintaProiectBT11"}],staticClass:"form-control",attrs:{"type":"text","id":"referintaProiectBT11","placeholder":"Codul proiectului"},domProps:{"value":(_vm.extraFields.referintaProiectBT11)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "referintaProiectBT11", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"identificatorCumparatorBT46"}},[_vm._v("Identificator cumpărător BT-46")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.identificatorCumparatorBT46),expression:"extraFields.identificatorCumparatorBT46"}],staticClass:"form-control",attrs:{"type":"text","id":"identificatorCumparatorBT46","placeholder":"ID-ul cumpărătorului"},domProps:{"value":(_vm.extraFields.identificatorCumparatorBT46)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "identificatorCumparatorBT46", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"numarAvizReceptieBT15"}},[_vm._v("Număr aviz recepție BT-15")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.numarAvizReceptieBT15),expression:"extraFields.numarAvizReceptieBT15"}],staticClass:"form-control",attrs:{"type":"text","id":"numarAvizReceptieBT15","placeholder":"Numărul avizului"},domProps:{"value":(_vm.extraFields.numarAvizReceptieBT15)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "numarAvizReceptieBT15", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"referintaContabilaCumparatorBT19"}},[_vm._v("Referință contabilă cumpărător BT-19")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.referintaContabilaCumparatorBT19),expression:"extraFields.referintaContabilaCumparatorBT19"}],staticClass:"form-control",attrs:{"type":"text","id":"referintaContabilaCumparatorBT19","placeholder":"Referința contabilă"},domProps:{"value":(_vm.extraFields.referintaContabilaCumparatorBT19)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "referintaContabilaCumparatorBT19", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dataLivrarii"}},[_vm._v("Data livrării")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.dataLivrarii),expression:"extraFields.dataLivrarii"}],staticClass:"form-control",attrs:{"type":"date","id":"dataLivrarii"},domProps:{"value":(_vm.extraFields.dataLivrarii)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "dataLivrarii", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dataIncasarii"}},[_vm._v("Data încasării")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.dataIncasarii),expression:"extraFields.dataIncasarii"}],staticClass:"form-control",attrs:{"type":"date","id":"dataIncasarii"},domProps:{"value":(_vm.extraFields.dataIncasarii)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "dataIncasarii", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"notaInterna"}},[_vm._v("Notă internă")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.notaInterna),expression:"extraFields.notaInterna"}],staticClass:"form-control",attrs:{"id":"notaInterna","placeholder":"Informații suplimentare"},domProps:{"value":(_vm.extraFields.notaInterna)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "notaInterna", $event.target.value)}}})])])])])]),_vm._v(" "),_c('ManagementClientsAdd',{attrs:{"groupedLocations":_vm.groupedLocations}}),_vm._v(" "),_c('ManagementSeriesAdd',{attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations,"vat-number":_vm.selectedLocation ? _vm.selectedLocation.inv_fiscal_code : ''},on:{"getSeries":_vm.getSeries}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KWii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformMenuImportLink_vue__ = __webpack_require__("2eUK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc99d9fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformMenuImportLink_vue__ = __webpack_require__("V8Nv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformMenuImportLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc99d9fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformMenuImportLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KWlb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);


















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isRaffleCampaignsReport: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: true,
      exportingId: null,
      idFilter: '',
      nameFilter: '',
      statusFilter: null,
      typeFilter: null,
      dateRangeFilter: [],
      tableData: [],
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      paginationDef: {
        page: 1,
        perPage: 25,
        totalRecords: 0
      }
    };
  },

  computed: {
    typeOptions: function typeOptions() {
      return [{ value: 'order_count', label: this.$t('raffleCampaigns.typeOrderCount') }, { value: 'order_total', label: this.$t('raffleCampaigns.typeOrderTotal') }];
    }
  },
  watch: {
    isRaffleCampaignsReport: function isRaffleCampaignsReport(active) {
      if (active) {
        this.getCampaigns();
      }
    }
  },
  created: function created() {
    this.getCampaigns();
    this.$bus.$on('refreshRaffleCampaignsReport', this.getCampaigns);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refreshRaffleCampaignsReport', this.getCampaigns);
  },

  methods: {
    typeLabel: function typeLabel(type) {
      if (type === 'order_total') {
        return this.$t('raffleCampaigns.typeOrderTotal');
      }
      return this.$t('raffleCampaigns.typeOrderCount');
    },
    formatMoney: function formatMoney(value) {
      var n = parseFloat(value || 0);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    applyFilters: function applyFilters() {
      this.paginationDef.page = 1;
      this.getCampaigns();
    },
    handlePageChange: function handlePageChange(page) {
      this.paginationDef.page = page;
      this.getCampaigns();
    },
    normalizeActiveFilterValue: function normalizeActiveFilterValue(value) {
      if (value === true || value === 1 || value === '1') return true;
      if (value === false || value === 0 || value === '0') return false;
      return null;
    },
    buildParams: function buildParams() {
      var params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.paginationDef.page,
        per_page: this.paginationDef.perPage
      };
      var id = String(this.idFilter || '').trim();
      if (id !== '') {
        params.id = id;
      }
      var name = String(this.nameFilter || '').trim();
      if (name !== '') {
        params.name = name;
      }
      var active = this.normalizeActiveFilterValue(this.statusFilter);
      if (active !== null) {
        params.active = active;
      }
      if (this.typeFilter) {
        params.type = this.typeFilter;
      }
      if (this.dateRangeFilter && this.dateRangeFilter.length === 2 && this.dateRangeFilter[0] && this.dateRangeFilter[1]) {
        params.start_date = this.dateRangeFilter[0];
        params.end_date = this.dateRangeFilter[1];
      }
      return params;
    },
    normalizeListResponse: function normalizeListResponse(response) {
      var payload = response.data || {};
      if (payload.pagination) {
        return {
          rows: payload.data || [],
          page: payload.pagination.page || this.paginationDef.page,
          perPage: payload.pagination.per_page || payload.pagination.perPage || this.paginationDef.perPage,
          total: payload.pagination.total || payload.pagination.totalRecords || 0
        };
      }
      if (response.pagination) {
        return {
          rows: Array.isArray(payload) ? payload : payload.data || [],
          page: response.pagination.page || this.paginationDef.page,
          perPage: response.pagination.per_page || response.pagination.perPage || this.paginationDef.perPage,
          total: response.pagination.total || response.pagination.totalRecords || 0
        };
      }
      if (Array.isArray(payload)) {
        return { rows: payload, page: 1, perPage: this.paginationDef.perPage, total: payload.length };
      }
      if (Array.isArray(payload.data)) {
        return { rows: payload.data, page: 1, perPage: this.paginationDef.perPage, total: payload.data.length };
      }
      return { rows: [], page: 1, perPage: this.paginationDef.perPage, total: 0 };
    },
    getCampaigns: function getCampaigns() {
      var _this = this;

      this.loading = true;
      this.apiRequest('/reports/raffle-campaigns', 'GET', this.buildParams(), function (response) {
        if (response.status === true) {
          var normalized = _this.normalizeListResponse(response);
          _this.tableData = (normalized.rows || []).map(function (row) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, row, {
              active: !!(parseInt(row.active) === 1 || row.active === true)
            });
          });
          _this.paginationDef.page = normalized.page;
          _this.paginationDef.perPage = normalized.perPage;
          _this.paginationDef.totalRecords = normalized.total;
        } else {
          _this.tableData = [];
          _this.paginationDef.totalRecords = 0;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    goToParticipants: function goToParticipants(row) {
      if (!row || row.id == null) return;
      this.$router.push({
        name: 'Raffle Campaign Participants Report',
        params: { campaignId: String(row.id) },
        query: {
          tab: 'raffle-campaigns-report',
          title: row.name || String(row.id)
        }
      });
    },
    exportEntries: function exportEntries(row) {
      var _this2 = this;

      if (!row || row.id == null || this.exportingId != null) return;
      this.exportingId = row.id;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/raffle-campaigns/' + row.id + '/export-entries', 'GET', data, function (response) {
        _this2.exportingId = null;
        if (response.status === true && response.data && response.data.file) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name || 'raffle-campaign-' + row.id + '-entries.txt');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    }
  }
});

/***/ }),

/***/ "KaL1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderScreen_OrderScreen_vue__ = __webpack_require__("/6y3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrderScreen_DigitalSignage_vue__ = __webpack_require__("8fAq");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Ods: __WEBPACK_IMPORTED_MODULE_0__OrderScreen_OrderScreen_vue__["a" /* default */],
    DigitalSignage: __WEBPACK_IMPORTED_MODULE_1__OrderScreen_DigitalSignage_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isOds: false,
      isDigitalSignage: false
    };
  },
  mounted: function mounted() {
    this.switchTab();
  },

  methods: {
    resetStates: function resetStates() {
      this.isOds = false;
      this.isDigitalSignage = false;
    },
    switchTab: function switchTab() {
      var _this = this;

      var index = this.$route.query.tabIndex;
      this.$nextTick(function () {
        if (index && _this.$refs.tabs) {
          _this.$refs.tabs.navigateToTab(parseInt(index));
        }
      });
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      this.resetStates();
      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);
      switch (newTab.title) {
        case this.$t('pages.digitalSignage'):
          this.isDigitalSignage = true;
          break;
        default:
          this.isOds = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ "KbtO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreenTabs_vue__ = __webpack_require__("KaL1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d5449c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreenTabs_vue__ = __webpack_require__("VqcG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreenTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d5449c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreenTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KdvI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_btPayments__ = __webpack_require__("pAUm");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: { companyId: { required: true } },
  data: function data() {
    return { payments: [], selected: null, page: 1, lastPage: 1, loading: false, error: '', requestId: 0 };
  },

  watch: { companyId: { immediate: true, handler: function handler() {
        this.payments = [];this.selected = null;this.load(1);
      }
    } },
  beforeDestroy: function beforeDestroy() {
    this.requestId++;
  },

  methods: {
    statusKey: __WEBPACK_IMPORTED_MODULE_0_src_utils_btPayments__["c" /* btStatusKey */],
    amount: __WEBPACK_IMPORTED_MODULE_0_src_utils_btPayments__["d" /* btAmount */],
    load: function load(page) {
      var _this = this;

      if (!this.companyId) return;
      var requestId = ++this.requestId;
      this.loading = true;
      this.error = '';
      this.selected = null;
      this.apiRequest('/bt-ipay/payments', 'GET', {
        token: this.$session.get('token'), company_id: this.companyId, page: page
      }, function (response) {
        if (requestId !== _this.requestId) return;
        _this.loading = false;
        var result = response && response.data;
        if (!result || !Array.isArray(result.data)) {
          _this.payments = [];
          _this.error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_src_utils_btPayments__["b" /* btApiError */])(response, _this.$t('btPayments.loadError'));
          return;
        }
        _this.payments = result.data;
        _this.page = Number(result.current_page) || page;
        _this.lastPage = Number(result.last_page) || 1;
      });
    }
  }
});

/***/ }),

/***/ "KepL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");






var _components;







/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isLoyaltyPoints: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isLoyaltyPoints: function isLoyaltyPoints() {
      if (this.isLoyaltyPoints) {
        var firstQuery = {
          sort: {
            prop: 'name',
            order: 'asc'
          },
          page: 1,
          pageSize: 20
        };
        this.getData(firstQuery);
      }
    }
  },
  created: function created() {
    this.getClients();
  },
  data: function data() {
    return {
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      clients: {
        'valid': [__WEBPACK_IMPORTED_MODULE_5_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf('month').format('YYYY-MM-DD')],
        searchClient: null,
        searchEmployee: null
      },
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        defaultSort: {
          prop: 'name',
          order: 'ascending'
        }
      },
      labels: null,
      labelingPrimaryOption: null,
      totalClients: null,
      sortBy: 'name',
      sortOrder: 'asc',
      clientsTableData: [],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      pickerNames: ['date_from', 'date_to']
    };
  },

  methods: {
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getClients(query);
      if (query.type === 'size') this.getClients(query);
      if (query.type === 'sort') {
        if (query.sort.order) {
          this.sortBy = query.sort.prop;
          this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc';
        } else {
          this.sortBy = 'name';
          this.sortOrder = 'asc';
        }
        this.getClients(query);
      }
    },
    getClients: function getClients(query) {
      var _this = this;

      if (!this.isLoyaltyPoints) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.clients.valid[0],
        end_date: this.clients.valid[1],
        search_client: this.clients.searchClient,
        search_employee: this.clients.searchEmployee
      };

      var sortColumn = '';
      var sortType = '';

      if (query) {
        sortColumn = query.sort.prop;
        sortType = query.sort.order === 'descending' ? 'desc' : 'asc';
      } else {
        sortColumn = this.sortBy;
        sortType = this.sortOrder;
      }

      var sortOptions = {
        field: sortColumn,
        order: sortType
      };
      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, sortOptions);

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      this.apiRequest('/reports/loyalty-points?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status === true) {
          _this.clientsTableData = response.data.data;
          _this.totalClients = response.data.total;
        }
        _this.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    goToRecordCustomer: function goToRecordCustomer(row, event, column) {
      window.open('/#/reports/customer/' + row.id);
    }
  }
});

/***/ }),

/***/ "KfMv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasMissingSyncStart)?_c('div',{staticClass:"global-ribbon-warning",on:{"click":_vm.openMissingSyncInfo}},[_vm._v("\n    ⚠️ Vânzarea NU este pornită pentru locațiile:\n    "),_c('strong',[_vm._v(_vm._s(_vm.missingSyncLocations.join(', ')))]),_vm._v("\n    – Click pentru detalii.\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row management-tabs full-height-tabs items-align-management-tabs text-align-management-tabs",attrs:{"direction":"vertical","value":_vm.selectedTabIndex},on:{"tab-change":_vm.handleTabChange}},[(_vm.userHasRight('can_access_gestiune'))?_c('v-tab',{ref:"reteta",staticClass:"text-left",attrs:{"name":"reteta","title":_vm.$t('gestiune.reteta')}},[_c('keep-alive',[(_vm.shouldLoadTab('reteta'))?_c('nomenclator-tabs',{key:'reteta-' + _vm.groupedLocationsKey,attrs:{"grouped-locations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.userHasRight('can_generate_nir'))?_c('v-tab',{ref:"entries",staticClass:"text-left",attrs:{"name":"entries","title":_vm.$t('gestiune.entries')}},[_c('keep-alive',[(_vm.shouldLoadTab('entries'))?_c('management-entries-tabs',{key:'entries-' + _vm.groupedLocationsKey,attrs:{"grouped-locations":_vm.groupedLocations}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.userHasRight('can_access_gestiune'))?_c('v-tab',{ref:"outputs",staticClass:"text-left",attrs:{"name":"outputs","title":_vm.$t('gestiune.outputs')}},[_c('keep-alive',[(_vm.shouldLoadTab('outputs'))?_c('management-outputs-tabs',{key:'outputs-' + _vm.groupedLocationsKey,attrs:{"grouped-locations":_vm.groupedLocations}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.userHasRight('can_access_gestiune'))?_c('v-tab',{ref:"stocks",staticClass:"text-left",attrs:{"name":"stocks","title":_vm.$t('gestiune.stocks')}},[_c('keep-alive',[(_vm.shouldLoadTab('stocks'))?_c('management-stocks-tabs',{key:'stocks-' + _vm.groupedLocationsKey,attrs:{"grouped-locations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.userHasRight('can_access_supplier_orders'))?_c('v-tab',{ref:"ordersSuppliers",staticClass:"text-left",attrs:{"name":"ordersSuppliers","title":_vm.$t('gestiune.ordersSuppliers')}},[_c('keep-alive',[(_vm.shouldLoadTab('ordersSuppliers'))?_c('management-suppliers-tabs',{key:'ordersSuppliers-' + _vm.groupedLocationsKey,attrs:{"grouped-locations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.userHasRight('can_access_reports'))?_c('v-tab',{ref:"reports",staticClass:"text-left",attrs:{"name":"reports","title":_vm.$t('gestiune.reports')}},[_c('keep-alive',[(_vm.shouldLoadTab('reports'))?_c('management-reports',{key:'reports-' + _vm.groupedLocationsKey,attrs:{"grouped-locations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-tab',{ref:"exports",staticClass:"text-left",attrs:{"name":"exports","title":_vm.$t('gestiune.exports')}},[_c('keep-alive',[(_vm.shouldLoadTab('exports'))?_c('management-exports',{key:'exports-' + _vm.groupedLocationsKey,attrs:{"locations":_vm.locations,"gestiuneOptions":_vm.gestiuneOptions,"grouped-locations":_vm.groupedLocations},on:{"fetchLocation":_vm.fetchLocation}}):_vm._e()],1)],1),_vm._v(" "),(_vm.userHasRight('can_access_settings'))?_c('v-tab',{ref:"settings",staticClass:"text-left",attrs:{"name":"settings","title":_vm.$t('gestiune.settings')}},[_c('keep-alive',[(_vm.shouldLoadTab('settings'))?_c('management-settings',{key:'settings-' + _vm.groupedLocationsKey,attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations},on:{"fetchLocation":_vm.fetchLocation}}):_vm._e()],1)],1):_vm._e()],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KheQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_time_picker_css__ = __webpack_require__("5ObC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_time_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_time_picker__ = __webpack_require__("4ZDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_mixins_BtOrderPayment__ = __webpack_require__("i3di");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Customers_countries__ = __webpack_require__("KLaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_clipboard2__);






















var _components;










__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_23_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_time_picker___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_time_select___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_28_vue_clipboard2___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_22_src_mixins_BtOrderPayment__["a" /* default */]],
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_time_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_time_picker___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_time_select___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      capture_transaction_response_string: null,
      receipt_number_string: null,
      cui: null,
      classForBtn: '',
      order: [],
      coupon: '',
      countries: __WEBPACK_IMPORTED_MODULE_25__Customers_countries__["a" /* default */],
      modelValidations: {
        required: {
          required: true
        }
      },
      orderStatuses: [],
      currentOrdersStatus: 'NEW',
      usesExtraCosts: false,
      currency: '',
      timeFormat: this.getTimeFormat(),
      loading: true,
      refundLoading: false,
      locationId: null,
      showPrintBtn: false,
      totals: ['totals_subtotals', 'totals_shipping', 'totals_extras', 'totals_tip', 'totals_discount', 'totals_discount_loyalty_points', 'totals_donation'],
      cancelOrder: null,
      grandchefDelay: 0,
      callPackageezConfig: null,
      editOrder: {
        price: 0,
        reason: ''
      },
      editOrderFlag: this.$session.get('selectedCompanyData')['edit_price'],
      groupValidations: {
        order_price: {
          required: true
        },
        reason: {
          required: true
        }
      },
      apiUrl: '',
      courierTime: null,
      jsonFields: {
        'Comandă ID': 'id',
        'Numar Comandă': 'number',
        'Client': 'client',
        'Telefon': 'phone',
        'Adresă': 'address',
        'Data livrare': 'delivery_date',
        'Comentariu': 'comment',
        'Nume produs': 'productName',
        'Cantitate': 'quantity',
        'Preț': 'price'
      },
      timezone: null
    };
  },

  created: function created() {
    this.getData();
    this.onResize();
    this.getDefaults();
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    window.addEventListener('resize', this.onResize);
    this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest';
  },
  computed: {
    slotTaxes: function slotTaxes() {
      return (this.order.order_taxes || []).filter(function (tax) {
        var type = Number(tax.type);
        return (type === 10 || type === 11) && !tax.deleted_at;
      });
    },
    canShowRefundButton: function canShowRefundButton() {
      var order = this.order;
      if (!order || !order.status) {
        return false;
      }
      return order.payment_type === 'CARD' && !!order.transaction_id && (order.payment_id === 'btIpay' || order.payment_id === 'euplatesc' && !!order.pay_link);
    },
    refundAlreadyDone: function refundAlreadyDone() {
      var order = this.order;
      if (!order) {
        return false;
      }
      var status = order.capture_transaction_status;
      return order.is_refunded === 1 || order.is_refunded === true || status === 'reversal OK' || status === 'refund OK';
    },
    deliveryHeroStatus: function deliveryHeroStatus() {
      var order = this.order;
      if (!order) return 0;
      if (order.integration && order.integration.delivery_hero_status != null) {
        return Number(order.integration.delivery_hero_status);
      }
      if (order.delivery_hero_status != null) {
        return Number(order.delivery_hero_status);
      }
      return 0;
    }
  },
  methods: {
    getPartItems: function getPartItems(part) {
      if (part && part.order_part_items && part.order_part_items.length) {
        return part.order_part_items;
      }
      return part && part.items || [];
    },
    getItemCategoryName: function getItemCategoryName(item) {
      if (!item) return null;
      if (item.category && item.category.name) return item.category.name;
      return item.category_name || null;
    },
    getItemOptions: function getItemOptions(item) {
      if (!item) return [];
      if (item.options && item.options.length) return item.options;
      if (item.item_options && item.item_options.length) return item.item_options;
      return [];
    },
    getItemAdditionalInfo: function getItemAdditionalInfo(item) {
      if (!item) return '';
      return item.additional_info || item.comment || '';
    },
    getItemUnitPrice: function getItemUnitPrice(item) {
      if (!item) return 0;
      if (item.original_price_after_discount != null && item.original_price_after_discount !== '') {
        return parseFloat(item.original_price_after_discount) || 0;
      }
      var price = parseFloat(item.price) || 0;
      var discount = parseFloat(item.discount) || 0;
      return price + discount;
    },
    getItemFinalPrice: function getItemFinalPrice(item) {
      if (!item) return 0;
      return parseFloat(item.price) || 0;
    },
    getItemOptionsTotal: function getItemOptionsTotal(item) {
      var _this = this;

      if (!item) return 0;
      var options = this.getItemOptions(item);
      if (options.length) {
        return options.reduce(function (sum, opt) {
          return sum + _this.getOptionQuantity(opt) * (parseFloat(opt.price) || 0);
        }, 0);
      }
      return parseFloat(item.options_total_price) || 0;
    },
    getItemLineTotal: function getItemLineTotal(item) {
      if (!item) return 0;
      var qty = parseFloat(item.quantity) || 0;
      var unitTotal = parseFloat(item.price_total_product);
      if (!isNaN(unitTotal)) {
        return qty * unitTotal;
      }
      return qty * (this.getItemFinalPrice(item) + this.getItemOptionsTotal(item));
    },
    getProductOnlyLineTotal: function getProductOnlyLineTotal(item) {
      if (!item) return 0;
      var qty = parseFloat(item.quantity) || 0;
      return qty * this.getItemFinalPrice(item);
    },
    getOptionUnitPrice: function getOptionUnitPrice(opt) {
      if (!opt) return 0;
      if (opt.original_price_after_discount != null && opt.original_price_after_discount !== '') {
        return parseFloat(opt.original_price_after_discount) || 0;
      }
      return (parseFloat(opt.price) || 0) + (parseFloat(opt.discount) || 0);
    },
    getOptionFinalPrice: function getOptionFinalPrice(opt) {
      return parseFloat(opt && opt.price) || 0;
    },
    getOptionDiscount: function getOptionDiscount(opt) {
      return parseFloat(opt && opt.discount) || 0;
    },
    getOptionQuantity: function getOptionQuantity(opt) {
      var qty = parseInt(opt && opt.quantity, 10);
      if (!isNaN(qty) && qty > 0) return qty;
      return 1;
    },
    formatOptionName: function formatOptionName(opt) {
      if (!opt) return '';
      var qty = this.getOptionQuantity(opt);
      var name = opt.name || '';
      if (qty > 1) {
        return qty + ' x ' + name;
      }
      return name;
    },
    getOptionLineTotal: function getOptionLineTotal(item, opt) {
      return this.getOptionQuantity(opt) * this.getOptionFinalPrice(opt);
    },
    formatToCompanyTimezone: function formatToCompanyTimezone(value) {
      if (!value) return '';
      if (typeof value !== 'string') return String(value);

      var hasTimezone = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value);
      var date = new Date(hasTimezone ? value : value + 'Z');
      if (__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_nan___default()(date.getTime())) {
        return value;
      }
      var formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: this.timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      var parts = formatter.formatToParts(date);

      return parts.find(function (p) {
        return p.type === 'year';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'month';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'day';
      }).value + ' ' + parts.find(function (p) {
        return p.type === 'hour';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'minute';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'second';
      }).value;
    },
    getWoltDriveWebhookLogs: function getWoltDriveWebhookLogs(orderId) {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        text: this.$t('general.generalLoader'),
        type: 'info',
        showConfirmButton: false,
        allowOutsideClick: false
      });

      this.apiRequest('/wolt-drive/order/' + orderId + '/webhook-logs', 'GET', data, function (response) {
        if (!response || response.status !== true) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: response && (response.errors || response.message) || _this2.$t('validations.wentWrong'),
            type: 'error',
            showConfirmButton: true
          });
          return;
        }

        var trackingUrl = response.tracking_url || null;
        var logs = Array.isArray(response.logs) ? response.logs : response.logs ? [response.logs] : [];

        var escapeHtml = function escapeHtml(value) {
          return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        };

        var getEventTypeKey = function getEventTypeKey(eventType) {
          if (!eventType || typeof eventType !== 'string') return null;
          return 'orders.woltDriveEventType_' + eventType.replace(/\./g, '_');
        };

        var getEventTypeLabel = function getEventTypeLabel(eventType, statusValue) {
          var key = getEventTypeKey(eventType);
          if (!key) return eventType || '';
          var label = _this2.$t(key);
          var base = label === key ? eventType : label;
          if (eventType === 'order.status_updated' && statusValue) {
            return base + ': ' + statusValue;
          }
          return base;
        };

        var getActionLabel = function getActionLabel(log) {
          var action = log && log.action ? String(log.action) : '';
          var actionLower = action.toLowerCase();

          if (actionLower === 'get shipment promise (error)' || actionLower === 'get shipment promise failed') {
            return _this2.$t('orders.woltDriveLogAction_Get_shipment_promise_failed');
          }

          if (actionLower === 'get shipment promise' || actionLower === 'get shipment promise (manual mode)') {
            return _this2.$t('orders.woltDriveLogAction_Get_shipment_promise');
          }

          if (actionLower.indexOf('cron callcourier company') === 0) {
            return _this2.$t('orders.woltDriveLogAction_Cron_callCourier');
          }

          if (actionLower === 'create delivery') {
            return _this2.$t('orders.woltDriveLogAction_Create_delivery');
          }

          if (actionLower === 'create delivery failed') {
            return _this2.$t('orders.woltDriveLogAction_Create_delivery_failed');
          }

          if (log && log.is_webhook_call) {
            return _this2.$t('orders.woltDriveLogAction_Webhook_event_received');
          }

          var meaningKey = 'orders.woltDriveLogAction_' + action.replace(/[()]/g, '').replace(/\s*-\s*/g, '_').replace(/\s+/g, '_').replace(/_+/g, '_');
          var meaning = _this2.$t(meaningKey);
          if (meaning && meaning !== meaningKey) return meaning;

          return action || '—';
        };

        var getResponseLabel = function getResponseLabel(log) {
          var action = log && log.action ? String(log.action).toLowerCase() : '';
          var isShipmentPromise = action.indexOf('shipment promise') !== -1;

          if (isShipmentPromise) {
            var isFailed = !!(log && log.is_error) || action.indexOf('(error)') !== -1 || action.indexOf('failed') !== -1;

            if (isFailed) {
              var resp = log && log.response && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(log.response) === 'object' ? log.response : {};
              var parts = [];
              if (resp.error_code) parts.push(String(resp.error_code));
              if (resp.reason) parts.push(String(resp.reason));
              if (parts.length) return parts.join(' — ');
              var _message = log && log.message != null ? String(log.message) : '';
              return _message && _message !== 'Success' ? _message : '';
            }

            return _this2.$t('orders.woltDriveLogResponse_success');
          }

          if (log && log.is_webhook_call) {
            var eventType = log.request && log.request.event_type || log.response && log.response.type || '';
            var statusValue = log.response && log.response.details && log.response.details.status ? log.response.details.status : '';
            if (eventType) return getEventTypeLabel(eventType, statusValue);
          }

          var message = log && log.message != null ? String(log.message) : '';
          if (message && message !== 'Success') return message;

          if (log && log.tracking_id) return String(log.tracking_id);

          if (log && log.response != null) {
            if (typeof log.response === 'string') return log.response;
            try {
              return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(log.response);
            } catch (e) {
              return String(log.response);
            }
          }

          return message || '';
        };

        var rows = logs.map(function (log) {
          return {
            action: getActionLabel(log),
            response: getResponseLabel(log),
            createdAt: log && log.created_at ? _this2.formatToCompanyTimezone(log.created_at) : ''
          };
        });

        var html = rows.length ? '<div style="max-height: 420px; overflow-y: auto; padding-top: 6px;">' + '<table style="width: 100%; border-collapse: collapse; font-size: 14px;">' + '<thead>' + '<tr>' + '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + _this2.$t('orders.woltDriveEventsEvent') + '</th>' + '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + _this2.$t('orders.woltDriveLogResponse') + '</th>' + '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6; white-space: nowrap;">' + _this2.$t('orders.woltDriveEventsTime') + '</th>' + '</tr>' + '</thead>' + '<tbody>' + rows.map(function (r) {
          return '<tr>' + '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left;">' + escapeHtml(r.action) + '</td>' + '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left; word-break: break-word;">' + escapeHtml(r.response) + '</td>' + '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; white-space: nowrap;">' + escapeHtml(r.createdAt) + '</td>' + '</tr>';
        }).join('') + '</tbody>' + '</table>' + '</div>' : '<div style="padding: 24px; text-align: center;">' + _this2.$t('general.no_data') + '</div>';

        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
          title: _this2.$t('orders.woltDriveEvents'),
          html: html,
          width: '900px',
          showCancelButton: !!trackingUrl,
          cancelButtonText: '🔗 ' + _this2.$t('orders.woltDriveTrackCourier'),
          cancelButtonColor: '#007bff',
          confirmButtonText: 'OK',
          customClass: 'wolt-drive-events-swal'
        }).then(function () {}, function (dismiss) {
          if (dismiss === 'cancel' && trackingUrl) {
            window.open(trackingUrl, '_blank');
          }
        });
      });
    },
    getGlovoLaasWebhookLogs: function getGlovoLaasWebhookLogs(orderId) {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        text: this.$t('general.generalLoader'),
        type: 'info',
        showConfirmButton: false,
        allowOutsideClick: false
      });

      this.apiRequest('/glovo-laas/order/' + orderId + '/webhook-logs', 'GET', data, function (response) {
        if (!response || response.status !== true) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: response && (response.errors || response.message) || _this3.$t('validations.wentWrong'),
            type: 'error',
            showConfirmButton: true
          });
          return;
        }

        var trackingUrl = response.tracking_url || null;
        var logs = Array.isArray(response.logs) ? response.logs : response.logs ? [response.logs] : [];

        var escapeHtml = function escapeHtml(value) {
          return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        };

        var getEventTypeKey = function getEventTypeKey(eventType) {
          if (!eventType || typeof eventType !== 'string') return null;
          return 'orders.glovoLaasEventType_' + eventType.replace(/\./g, '_');
        };

        var getEventTypeLabel = function getEventTypeLabel(eventType, statusValue) {
          var key = getEventTypeKey(eventType);
          if (!key) return eventType || '';
          var label = _this3.$t(key);
          var base = label === key ? eventType : label;
          if (statusValue) {
            return base + ': ' + statusValue;
          }
          return base;
        };

        var getActionLabel = function getActionLabel(log) {
          var action = log && log.action ? String(log.action) : '';
          var actionLower = action.toLowerCase();

          if (actionLower === 'create delivery' || actionLower === 'create order') {
            return _this3.$t('orders.glovoLaasLogAction_Create_delivery');
          }

          if (actionLower === 'create delivery failed' || actionLower === 'create order failed') {
            return _this3.$t('orders.glovoLaasLogAction_Create_delivery_failed');
          }

          if (actionLower === 'cancel delivery' || actionLower === 'cancel order') {
            return _this3.$t('orders.glovoLaasLogAction_Cancel_delivery');
          }

          if (actionLower.indexOf('cron callcourier company') === 0) {
            return _this3.$t('orders.glovoLaasLogAction_Cron_callCourier');
          }

          if (log && log.is_webhook_call) {
            return _this3.$t('orders.glovoLaasLogAction_Webhook_event_received');
          }

          var meaningKey = 'orders.glovoLaasLogAction_' + action.replace(/[()]/g, '').replace(/\s*-\s*/g, '_').replace(/\s+/g, '_').replace(/_+/g, '_');
          var meaning = _this3.$t(meaningKey);
          if (meaning && meaning !== meaningKey) return meaning;

          return action || '—';
        };

        var getResponseLabel = function getResponseLabel(log) {
          if (log && log.is_webhook_call) {
            var eventType = log.request && log.request.event_type || log.request && log.request.type || log.response && log.response.type || log.response && log.response.event_type || '';
            var statusValue = log.response && log.response.details && log.response.details.status ? log.response.details.status : log.response && log.response.status ? log.response.status : '';
            if (eventType) return getEventTypeLabel(eventType, statusValue);
          }

          var message = log && log.message != null ? String(log.message) : '';
          if (message && message !== 'Success') return message;

          if (log && log.tracking_id) return String(log.tracking_id);

          if (log && log.response != null) {
            if (typeof log.response === 'string') return log.response;
            try {
              return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(log.response);
            } catch (e) {
              return String(log.response);
            }
          }

          return message || '';
        };

        var rows = logs.map(function (log) {
          return {
            action: getActionLabel(log),
            response: getResponseLabel(log),
            createdAt: log && log.created_at ? _this3.formatToCompanyTimezone(log.created_at) : ''
          };
        });

        var html = rows.length ? '<div style="max-height: 420px; overflow-y: auto; padding-top: 6px;">' + '<table style="width: 100%; border-collapse: collapse; font-size: 14px;">' + '<thead>' + '<tr>' + '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + _this3.$t('orders.glovoLaasEventsEvent') + '</th>' + '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + _this3.$t('orders.glovoLaasLogResponse') + '</th>' + '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6; white-space: nowrap;">' + _this3.$t('orders.glovoLaasEventsTime') + '</th>' + '</tr>' + '</thead>' + '<tbody>' + rows.map(function (r) {
          return '<tr>' + '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left;">' + escapeHtml(r.action) + '</td>' + '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left; word-break: break-word;">' + escapeHtml(r.response) + '</td>' + '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; white-space: nowrap;">' + escapeHtml(r.createdAt) + '</td>' + '</tr>';
        }).join('') + '</tbody>' + '</table>' + '</div>' : '<div style="padding: 24px; text-align: center;">' + _this3.$t('general.no_data') + '</div>';

        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
          title: _this3.$t('orders.glovoLaasEvents'),
          html: html,
          width: '900px',
          showCancelButton: !!trackingUrl,
          cancelButtonText: '🔗 ' + _this3.$t('orders.glovoLaasTrackCourier'),
          cancelButtonColor: '#007bff',
          confirmButtonText: 'OK',
          customClass: 'wolt-drive-events-swal'
        }).then(function () {}, function (dismiss) {
          if (dismiss === 'cancel' && trackingUrl) {
            window.open(trackingUrl, '_blank');
          }
        });
      });
    },
    getDeliveryHeroWebhookLogs: function getDeliveryHeroWebhookLogs(orderId) {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        text: this.$t('general.generalLoader'),
        type: 'info',
        showConfirmButton: false,
        allowOutsideClick: false
      });

      this.apiRequest('/delivery-hero/order/' + orderId + '/webhook-logs', 'GET', data, function (response) {
        if (!response || response.status !== true) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: response && (response.errors || response.message) || _this4.$t('validations.wentWrong'),
            type: 'error',
            showConfirmButton: true
          });
          return;
        }

        var logs = Array.isArray(response.logs) ? response.logs : response.logs ? [response.logs] : [];

        var escapeHtml = function escapeHtml(value) {
          return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        };

        var getActionLabel = function getActionLabel(log) {
          var action = log && log.action ? String(log.action) : '';
          var actionLower = action.toLowerCase();

          if (actionLower === 'create order' || actionLower === 'create delivery') {
            return _this4.$t('orders.deliveryHeroLogAction_Create_order');
          }
          if (actionLower.indexOf('create order failed') === 0 || actionLower.indexOf('create delivery failed') === 0) {
            return _this4.$t('orders.deliveryHeroLogAction_Create_order_failed');
          }
          if (actionLower === 'cancel order' || actionLower === 'cancel delivery') {
            return _this4.$t('orders.deliveryHeroLogAction_Cancel_order');
          }
          if (actionLower.indexOf('cancel order failed') === 0) {
            return _this4.$t('orders.deliveryHeroLogAction_Cancel_order_failed');
          }
          if (actionLower === 'oauth token' || actionLower.indexOf('oauth') === 0) {
            return _this4.$t('orders.deliveryHeroLogAction_OAuth_token');
          }
          if (actionLower === 'status webhook' || log && log.is_webhook_call && actionLower.indexOf('refund') < 0) {
            return _this4.$t('orders.deliveryHeroLogAction_Status_webhook');
          }
          if (actionLower === 'refund webhook' || actionLower.indexOf('refund') >= 0) {
            return _this4.$t('orders.deliveryHeroLogAction_Refund_webhook');
          }
          if (actionLower === 'autopilot skip') {
            return _this4.$t('orders.deliveryHeroLogAction_Autopilot_skip');
          }

          var meaningKey = 'orders.deliveryHeroLogAction_' + action.replace(/[()]/g, '').replace(/\s*-\s*/g, '_').replace(/\s+/g, '_').replace(/_+/g, '_');
          var meaning = _this4.$t(meaningKey);
          if (meaning && meaning !== meaningKey) return meaning;

          return action || '—';
        };

        var getResponseLabel = function getResponseLabel(log) {
          if (log && log.odr_order_id) {
            var from = log.data_from;
            if (from != null) {
              if (typeof from === 'string') return from;
              try {
                return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(from);
              } catch (e) {
                return String(from);
              }
            }
            return String(log.odr_order_id);
          }

          if (log && log.data_from != null) {
            if (typeof log.data_from === 'string') return log.data_from;
            try {
              return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(log.data_from);
            } catch (e) {
              return String(log.data_from);
            }
          }

          return '';
        };

        var rows = logs.map(function (log) {
          return {
            action: getActionLabel(log),
            response: getResponseLabel(log),
            createdAt: log && log.created_at ? _this4.formatToCompanyTimezone(log.created_at) : ''
          };
        });

        var html = rows.length ? '<div style="max-height: 420px; overflow-y: auto; padding-top: 6px;">' + '<table style="width: 100%; border-collapse: collapse; font-size: 14px;">' + '<thead>' + '<tr>' + '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + _this4.$t('orders.deliveryHeroEventsEvent') + '</th>' + '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6;">' + _this4.$t('orders.deliveryHeroLogResponse') + '</th>' + '<th style="text-align: center; padding: 10px; border-bottom: 1px solid #e6e6e6; white-space: nowrap;">' + _this4.$t('orders.deliveryHeroEventsTime') + '</th>' + '</tr>' + '</thead>' + '<tbody>' + rows.map(function (r) {
          return '<tr>' + '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left;">' + escapeHtml(r.action) + '</td>' + '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; text-align: left; word-break: break-word;">' + escapeHtml(r.response) + '</td>' + '<td style="padding: 10px; border-bottom: 1px solid #f0f0f0; white-space: nowrap;">' + escapeHtml(r.createdAt) + '</td>' + '</tr>';
        }).join('') + '</tbody>' + '</table>' + '</div>' : '<div style="padding: 24px; text-align: center;">' + _this4.$t('general.no_data') + '</div>';

        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
          title: _this4.$t('orders.deliveryHeroEvents'),
          html: html,
          width: '900px',
          showCancelButton: false,
          confirmButtonText: 'OK',
          customClass: 'wolt-drive-events-swal'
        });
      });
    },
    printToIframe: function printToIframe() {
      var _this5 = this;

      var iframe = document.getElementById('print-frame');
      var doc = iframe.contentWindow.document;

      var ordersHtml = '';
      var partsHtml = this.order.parts.map(function (part) {
        var productMap = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a();

        _this5.getPartItems(part).forEach(function (prod) {
          var optionsKey = _this5.getItemOptions(prod).map(function (opt) {
            return opt.name;
          }).join('|');
          var infoKey = _this5.getItemAdditionalInfo(prod) || '';
          var key = prod.name + '||' + optionsKey + '||' + infoKey;

          if (productMap.has(key)) {
            productMap.get(key).quantity += prod.quantity;
          } else {
            productMap.set(key, {
              name: prod.name,
              quantity: prod.quantity,
              options: _this5.getItemOptions(prod),
              additional_info: _this5.getItemAdditionalInfo(prod)
            });
          }
        });

        var itemsHtml = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(productMap.values()).map(function (prod) {
          var itemOptions = _this5.getItemOptions(prod);
          var optionsHtml = itemOptions.length ? '<div class="options">' + itemOptions.map(function (opt) {
            return '+ ' + _this5.formatOptionName(opt);
          }).join('<br>') + '</div>' : '';
          var infoHtml = _this5.getItemAdditionalInfo(prod) ? '<div class="options">- ' + _this5.getItemAdditionalInfo(prod) + '</div>' : '';

          return '\n            <tr>\n              <td>\n                ' + prod.name + '\n                ' + optionsHtml + '\n                ' + infoHtml + '\n              </td>\n              <td class="center">' + prod.quantity + '</td>\n            </tr>\n          ';
        }).join('');

        return '\n          ' + (_this5.order.order_type === 'GROUP' ? '<div class="section"><b>Sub-client:</b> ' + part.customer_name + '</div>' : '') + '\n          <table>\n            <thead>\n              <tr>\n                <th>Nume</th>\n                <th>Cantitate</th>\n              </tr>\n            </thead>\n            <tbody>\n              ' + itemsHtml + '\n            </tbody>\n          </table>\n        ';
      }).join('');

      ordersHtml += '\n        <div class="card">\n          <div class="section"><b>Comanda:</b> ' + parseInt(this.order.number) + ' - ' + this.order.id + '</div>\n          <div class="section"><b>Client:</b> ' + this.order.delivery_details_firstname + ' | ' + this.order.delivery_details_phone + '</div>\n          ' + (this.order.address_shipping ? '\n            <div class="section">\n              <b>Adresa:</b>\n              ' + (this.order.address_shipping.state || '') + ',\n              ' + (this.order.address_shipping.city || '') + ',\n              ' + (this.order.address_shipping.street || '') + ' ' + (this.order.address_shipping.number || '') + ',\n              ' + (this.order.address_shipping.apartment || '') + '\n              ' + (this.order.address_shipping.other_info || '') + '\n            </div>' : '') + '\n          ' + (this.order.pickup_datetime ? '<div class="section"><b>Data livrare:</b> ' + this.order.pickup_datetime.split(' ')[0] + '</div>' : '') + '\n          ' + (this.order.customer.comment ? '<div class="section"><b>Comentariu:</b> ' + this.order.customer.comment + '</div>' : '') + '\n          ' + partsHtml + '\n        </div>\n      ';

      var content = '\n        <html>\n          <head>\n            <title>Comanda #' + parseInt(this.order.number) + ' - ' + parseInt(this.order.id) + '</title>\n            <style>\n              * {\n                box-sizing: border-box;\n              }\n              body {\n                font-family: sans-serif;\n                padding: 10px;\n                margin: 0;\n                font-size: 16px;\n              }\n              .card {\n                border: 1px solid #aaa;\n                border-radius: 6px;\n                padding: 8px;\n                margin-bottom: 12px;\n                width: 100%;\n                page-break-inside: avoid;\n              }\n              .section {\n                margin-bottom: 6px;\n              }\n              .section b {\n                display: inline;\n                font-weight: bold;\n                margin-right: 4px;\n              }\n              table {\n                width: 100%;\n                border-collapse: collapse;\n                margin-top: 5px;\n              }\n              th, td {\n                border: 1px solid #ccc;\n                padding: 2px 4px;\n                font-size: 16px;\n                word-break: break-word;\n              }\n              td.center {\n                text-align: center;\n              }\n              .options {\n                font-size: 14px;\n                color: #555;\n              }\n            </style>\n          </head>\n          <body>\n            ' + ordersHtml + '\n          </body>\n        </html>\n      ';

      doc.open();
      doc.write(content);
      doc.close();
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    },
    orderExportData: function orderExportData() {
      var _this6 = this;

      var order = this.order;
      if (!order || !order.parts) return [];

      var base = {
        id: '' + (order.id || ''),
        number: '' + (parseInt(order.number) || ''),
        client: '' + (order.delivery_details_firstname || ''),
        phone: '' + (order.delivery_details_phone || ''),
        address: order.address_shipping ? ((order.address_shipping.state || '') + ', ' + (order.address_shipping.city || '') + ', ' + (order.address_shipping.street || '') + ' ' + (order.address_shipping.number || '') + ', ' + (order.address_shipping.apartment || '') + ' ' + (order.address_shipping.details || '')).trim() : '',
        delivery_date: order.pickup_datetime.split(' ')[0] || '',
        comment: order.customer.comment || ''
      };

      var productMap = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a();

      order.parts.forEach(function (part) {
        _this6.getPartItems(part).forEach(function (prod) {
          var productName = function () {
            var name = prod.name || '';
            var options = _this6.getItemOptions(prod).map(function (opt) {
              return '+ ' + _this6.formatOptionName(opt) + (opt.price ? ' (' + opt.price + ')' : '');
            }).join(', ') || '';
            var info = _this6.getItemAdditionalInfo(prod) ? ' - ' + _this6.getItemAdditionalInfo(prod) : '';
            return '' + name + (options ? ' - ' + options : '') + info;
          }();

          var key = productName;

          if (productMap.has(key)) {
            var existing = productMap.get(key);
            existing.quantity += prod.quantity;
          } else {
            productMap.set(key, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, base, {
              productName: productName,
              quantity: prod.quantity,
              price: prod.price
            }));
          }
        });
      });

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(productMap.values());
    },
    generateProductsData: function generateProductsData(parts) {
      var _this7 = this;

      var products = '';
      parts.forEach(function (part) {
        _this7.getPartItems(part).forEach(function (prod) {
          var options = _this7.getItemOptions(prod).map(function (opt) {
            return '+ ' + _this7.formatOptionName(opt) + (opt.price ? ' (' + opt.price + ')' : '');
          }).join(', ') || '';
          var info = _this7.getItemAdditionalInfo(prod) ? ' - ' + _this7.getItemAdditionalInfo(prod) : '';
          products += '' + prod.name + (options ? ' - ' + options : '') + info + ' | Cantitate: ' + prod.quantity + ' | Pre\u021B: ' + prod.price + '\n';
        });
      });

      return products.trim();
    },
    startDownload: function startDownload() {
      this.loading = true;
    },
    finishDownload: function finishDownload() {
      this.loading = false;
    },
    printReceipt: function printReceipt() {
      var printWindow = window.open('', '_blank');

      var htmlContent = '\n        <html>\n          <head>\n            <title>Print Receipt</title>\n            <style>\n              body { font-family: sans-serif; padding: 20px; }\n              .no-print { display: none !important; }\n            </style>\n          </head>\n          <body>\n            <div id="printable">\n              <h1>Receipt</h1>\n              <p>Total: $123.45</p>\n            </div>\n            <script>\n              window.onload = function() {\n                window.print();\n                window.close();\n              };\n            </script>\n          </body>\n        </html>\n      ';


      printWindow.document.open();
      printWindow.document.write(htmlContent);
      printWindow.document.close();
    },
    showExpressoftError: function showExpressoftError() {
      var data = {
        id: this.route.params.id,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/show-expressoft-log', 'GET', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            title: 'Expressoft Log',
            icon: 'error',
            html: response.data.log,
            showCloseButton: true
          });
        }
      });
    },
    sendOrderToEpRestaurant: function sendOrderToEpRestaurant() {
      var _this8 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token')
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        type: 'question',
        text: this.$t('epRestaurant.resendQuestion'),
        position: 'top-end',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        allowOutsideClick: false
      }).then(function (result) {
        _this8.apiRequest('/ep-restaurant/send-order/' + _this8.route.params.id, 'POST', data, function (response) {
          if (response) {
            _this8.loading = false;
            __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
              text: _this8.$t('orders.orderSentSuccess'),
              type: 'success',
              showConfirmButton: false
            });
            _this8.getData();
          }
        });
      }, function (dismiss) {
        _this8.loading = false;
      });
    },
    editOrderNow: function editOrderNow() {
      this.$router.push('/add-order/?order_id=' + this.order.id);
      this.backButton();
    },
    downloadImage: function downloadImage(imageSrc, name) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var image, imageBlog, imageURL, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(imageSrc);

              case 2:
                image = _context.sent;
                _context.next = 5;
                return image.blob();

              case 5:
                imageBlog = _context.sent;
                imageURL = URL.createObjectURL(imageBlog);
                link = document.createElement('a');

                link.href = imageURL;
                link.download = name;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9);
      }))();
    },
    emitInvoice: function emitInvoice() {
      var _this10 = this;

      var data = {
        id: this.route.params.id,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/send-order-invoice', 'POST', data, function (response) {
        if (response) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: response.message,
            type: 'info',

            showConfirmButton: true
          });
          _this10.getData();
        }
      });
    },
    deliveredStatusValidation: function deliveredStatusValidation(sts) {
      var isDisabled = (this.order.status.id === 'DELIVERED' || this.order.status.id === 'NOT_DELIVERED') && sts.type !== 'CANCELED' && sts.type !== 'DELIVERED' && sts.type !== 'NOT_DELIVERED' || this.order.status.id === 'PREPARED' && (sts.type === 'PROCESSING' || sts.type === 'NEW' || sts.type === 'ON_HOLD' || sts.type === 'POSTPONE') || this.order.status.id === 'TRANSPORT' && (sts.type === 'PREPARED' || sts.type === 'PROCESSING' || sts.type === 'NEW' || sts.type === 'ON_HOLD' || sts.type === 'POSTPONE');
      return isDisabled;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this11 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this11.errors.clear();
          _this11.updateOrderPrice();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    checkEmailTrnsport: function checkEmailTrnsport(order) {
      if (this.$session.get('userDataRole') === 'USER' || this.$session.get('userDataRole') === 'LOCATION_STORE_ADMIN') {
        if (order.email_transport) {
          return false;
        }
      }
      return true;
    },
    onResize: function onResize() {
      if (window.innerWidth <= 1200) {
        this.classForBtn = 'mb40';
      } else {
        this.classForBtn = '';
      }
    },
    getRowClass: function getRowClass(label) {
      switch (label) {
        case 'totals_discount_loyalty_points':
        case 'totals_discount':
          return 'text-danger';
        case 'totals_grandtotal':
          return 'text-bold total-row';
        default:
          return '';
      }
    },
    isNew: function isNew() {
      if (this.route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    disabledCls: function disabledCls(isBefore) {
      if (isBefore) {
        return 'disabled';
      } else {
        return '';
      }
    },
    getPaymetnStatus: function getPaymetnStatus(status) {
      if (this.order.payment_id === 'btIpay' && status === 'AUTHORIZED') {
        return ' - <span class="text-info">' + this.$t('btPayments.authorized') + '</span>';
      }
      switch (status) {
        case 'OK':
          return ' - <span class="text-success">' + this.$t('paymentStatus.paid') + '</span>';
        case 'NOT OK':
          return ' - <span class="text-danger">' + this.$t('paymentStatus.notOk') + '</span>';
        default:
          return ' - <span class="text-warning">' + this.$t('paymentStatus.notPaid') + '</small></span> <br><span class="text-muted"><small>' + this.$t('paymentStatus.notPaidDetails') + '</small></span>';
      }
    },
    refundErrorMessage: function refundErrorMessage(response) {
      if (response) {
        if (response.error && response.error.response && response.error.response.data) {
          var data = response.error.response.data;
          if (data.message) {
            return data.message;
          }
          if (data.error) {
            return data.error;
          }
        }
        if (response.message) {
          return response.message;
        }
      }
      return this.$t('orders.refundError');
    },
    doRefundOrder: function doRefundOrder() {
      var self = this;
      if (this.refundAlreadyDone || this.refundLoading || this.btReturnPending) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: self.$t('orders.refundConfirmTitle'),
        text: self.$t(self.order.payment_id === 'btIpay' ? 'btPayments.refundConfirm' : 'orders.refundConfirmText'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: self.$t('general.cancel'),
        confirmButtonText: self.$t('orders.refundOrder')
      }).then(function (result) {
        if (!result) {
          return;
        }
        var id = self.route.params.id;
        var data = {
          token: self.$session.get('token'),
          company_id: self.$session.get('selectedCompany'),
          order_id: parseInt(id)
        };
        self.refundLoading = true;
        self.loading = true;
        self.apiRequest('/refound-order', 'POST', data, function (response) {
          self.refundLoading = false;
          self.loading = false;
          if (response && response.success === true) {
            if (self.order.payment_id === 'btIpay' && response.pending === true) {
              self.handleBtReturnQueued();
              return;
            }
            __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
              title: '',
              text: response.message || self.$t('orders.refundSuccess'),
              type: 'success'
            }).then(function () {
              self.afterRefundSuccess(id);
            }).catch(function () {
              self.afterRefundSuccess(id);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
              title: '',
              text: self.refundErrorMessage(response),
              type: 'error'
            });
          }
        });
      }).catch(function () {});
    },
    afterRefundSuccess: function afterRefundSuccess(id) {
      var self = this;

      self.$session.set('refreshOrdersCount', 'refresh');
      self.getData();
      self.$bus.$emit('refresh', id);

      if (!self.order || !self.order.status || self.order.status.id === 'CANCELED') {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: '',
        text: self.$t('orders.refundAskCancel'),
        type: 'question',
        showCancelButton: true,
        cancelButtonText: self.$t('general.cancel')
      }).then(function (result) {
        if (result) {
          self.cancelAfterRefund(id);
        }
      }).catch(function () {});
    },
    cancelAfterRefund: function cancelAfterRefund(id) {
      var self = this;
      var data = {
        id: id,
        token: self.$session.get('token'),
        company_id: self.$session.get('selectedCompany'),
        status: 'CANCELED'
      };
      self.apiRequest('/order/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          self.$session.set('refreshOrdersCount', 'refresh');
          if (self.$bus) {
            self.$bus.$emit('stopSound');
            self.$bus.$emit('refresh', id);
          }
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: self.$t('orders.orderStatusSuccess'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          self.getData();
        } else if (response.errors && response.errors.boogit) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: response.errors.boogit,
            type: 'error',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
        }
      });
    },
    showPrint: function showPrint() {
      var show = false;
      var companyLocations = this.$session.get('selectedCompanyData');
      if (this.order.production_details) {
        var locationId = this.order.production_details.location.id;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(companyLocations.locations_details), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var location = _step.value;

            if (location.id === locationId && location.use_printer !== undefined && location.use_printer) {
              show = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return show;
    },
    showDrCarmen: function showDrCarmen() {
      var companyLocations = this.$session.get('selectedCompanyData');
      var locationId = this.order.production_details.location.id;
      var show = false;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(companyLocations.locations_details), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var location = _step2.value;

          if (location.id === locationId && location.drcarmen_active !== undefined && location.drcarmen_active) {
            show = true;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return show;
    },
    getData: function getData() {
      var _this12 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.route.params.id) {
        var id = this.route.params.id;

        this.apiRequest('/order/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            if (_this12.route.query.print_fiscal) {
              _this12.printFiscal();
            }
            response.data[0].formatted_pickup_datetime = _this12.formatTime(response.data[0].pickup_datetime);
            response.data[0].formatted_date_pickup_datetime = _this12.formatDate(response.data[0].pickup_datetime);
            _this12.order = response.data[0];
            if (_this12.order.capture_transaction_response && _this12.order.payment_type === 'CARD_POS') {
              _this12.order.capture_transaction_response = JSON.parse(_this12.order.capture_transaction_response);
              _this12.capture_transaction_response_string = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(_this12.order.capture_transaction_response, null, 1);
            }
            if (_this12.isJSONString(_this12.order.receipt_number)) {
              _this12.order.receipt_number = JSON.parse(_this12.order.receipt_number);
              _this12.receipt_number_string = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(_this12.order.receipt_number, null, 1);
            } else {
              _this12.order.receipt_number = null;
              _this12.receipt_number_string = null;
            }
            _this12.coupon = _this12.order.coupon;
            if (_this12.order.applyCoupons) {
              _this12.coupon = '';
              for (var cupons in _this12.order.applyCoupons) {
                if (_this12.order.applyCoupons[cupons].coupon_has_multiple_codes) {
                  _this12.coupon += _this12.order.applyCoupons[cupons].selected_coupon_code;
                } else {
                  _this12.coupon += _this12.order.applyCoupons[cupons].coupon_code;
                }
                _this12.coupon += ', ';
              }
              _this12.coupon = _this12.coupon.slice(0, -2);
            }
            for (var iParts in _this12.order.parts) {
              var part = _this12.order.parts[iParts];
              var partItems = _this12.getPartItems(part);
              for (var iItem in partItems) {
                var item = partItems[iItem];
                var sumOptions = _this12.getItemOptionsTotal(item);
                item.price_total_product = (_this12.getItemFinalPrice(item) + sumOptions).toFixed(2);
              }
            }
            var companyLocations = _this12.$session.get('selectedCompanyData');
            var statusesRaw = _this12.$session.get('defaultData')['order_statuses'];
            var isBefore = true;
            var isAllowed = true;
            if (_this12.order.hio_flag) {
              _this12.cancelOrder = _this12.order.hio_status;
            }
            if (_this12.order.packageez_flag) {
              _this12.cancelOrder = !!_this12.order.packagez_order_id;
            }
            if (_this12.order.rapid_donkey_status === 2) {
              _this12.cancelOrder = true;
            }
            if (_this12.order.glovo_status === 2) {
              _this12.cancelOrder = true;
            }

            _this12.orderStatuses = [];
            _this12.currentOrdersStatus = _this12.order.status.id;

            for (var type in statusesRaw[_this12.order.delivery_type]) {
              if (type !== 'DRAFT') {
                if (type === 'CANCELED' && _this12.order.payment_type === 'CARD' && _this12.order.capture_transaction_status === 'OK') {
                  isAllowed = false;
                } else if (_this12.order.delivery_type === 'EAT_LOCATION') {
                  isAllowed = true;
                } else {
                  isAllowed = _this12.orderStatusAllowed(_this12.order.status.id, type);
                }
                if (_this12.order.status.id === type) {
                  isBefore = false;
                }
                if (type !== 'ON_HOLD' || type === 'ON_HOLD' && companyLocations.is_allowed_on_hold) {
                  if (type !== 'POSTPONED' || type === 'POSTPONED' && companyLocations.is_allowed_postponed) {
                    _this12.orderStatuses.push({
                      'type': type,
                      'text': statusesRaw[_this12.order.delivery_type][type],
                      'isBefore': isBefore,
                      'isAllowed': isAllowed
                    });
                  }
                }
              }
            }

            __WEBPACK_IMPORTED_MODULE_21_vue___default.a.set(_this12, 'currency', response.data[0]['currency']);

            _this12.showPrintBtn = _this12.showPrint();
          }
          _this12.loading = false;
        });
      }
    },
    getDefaults: function getDefaults() {
      var _this13 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/listdefaults', 'GET', data, function (response) {
        if (response.status === true) {
          _this13.callPackageezConfig = response.data[0].call_packageez_courier_on_processing;
        }
      });
    },
    callPackageezOnProcessing: function callPackageezOnProcessing() {
      var _this14 = this;

      var compnayId = this.$session.get('selectedCompany');
      if (this.callPackageezConfig && this.callPackageezConfig[compnayId]) {
        var id = this.route.params.id;
        var data = {
          token: this.$session.get('token'),
          company_id: compnayId,
          id: id,
          location_id: this.order.store_id,
          time: this.callPackageezConfig[compnayId]['time'],
          size: this.callPackageezConfig[compnayId]['size']
        };
        this.apiRequest('/packagez-send-order', 'POST', data, function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
              text: _this14.$t('orders.orderSentSuccess'),
              type: 'success',
              timer: 1000,
              showConfirmButton: false
            });
            _this14.cancelOrder = true;
          } else {
            __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
              text: _this14.$t('orders.contactPakageez'),
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            });
          }
        });
      }
    },
    heartbeat: function heartbeat(orderData) {
      var self = this;
      self.order.status = orderData.status;

      self.currentOrdersStatus = self.order.status.id;

      this.$nextTick(function () {});
    },
    updateHour: function updateHour() {
      var _this15 = this;

      var id = this.route.params.id;
      if (this.order.formatted_pickup_datetime === '' || this.order.formatted_pickup_datetime === null) {
        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({ 'text': self.$t('orders.orderHourError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch({});
      } else {
        var newTime = __WEBPACK_IMPORTED_MODULE_24_moment___default()(String(this.order.pickup_datetime)).format('YYYY-MM-DD');
        newTime = __WEBPACK_IMPORTED_MODULE_24_moment___default()(String(newTime + ' ' + this.order.formatted_pickup_datetime)).format('YYYY-MM-DD HH:mm:ss');
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          pickup_datetime: newTime
        };

        this.apiRequest('/order/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', _this15.$t('orders.orderHourSuccess'), 'success');
          } else {
            __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', _this15.$t('validations.wentWrong'), 'error');
          }
        });
      }
    },
    automatUpdateHour: function automatUpdateHour(time, flag) {
      var id = this.route.params.id;
      var self = this;
      if (this.order.formatted_pickup_datetime === '' || this.order.formatted_pickup_datetime === null) {
        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({ 'text': self.$t('orders.orderHourError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch({});
      } else {
        var newTime = __WEBPACK_IMPORTED_MODULE_24_moment___default()(String(this.order.pickup_datetime)).format('YYYY-MM-DD');
        if (flag === 'add') {
          newTime = __WEBPACK_IMPORTED_MODULE_24_moment___default()(String(newTime + ' ' + this.order.formatted_pickup_datetime)).add(time, 'minutes').format('YYYY-MM-DD HH:mm:ss');
        } else {
          newTime = __WEBPACK_IMPORTED_MODULE_24_moment___default()(String(newTime + ' ' + this.order.formatted_pickup_datetime)).subtract(time, 'minutes').format('YYYY-MM-DD HH:mm:ss');
        }
        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          pickup_datetime: newTime
        };
        if (__WEBPACK_IMPORTED_MODULE_24_moment___default()(this.order.created_at).format('YYYY-MM-DD HH:mm:ss') > __WEBPACK_IMPORTED_MODULE_24_moment___default()(newTime).format('YYYY-MM-DD HH:mm:ss')) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', this.$t('validations.hourIsSmallerThanCreated'), 'error');
        } else {
          var pickupFrom = this.order.pickup_datetime || null;
          var loc = this.order && this.order.production_details && this.order.production_details.location || null;
          var locationId = loc && (loc.true_id != null ? loc.true_id : loc.id) || this.order && this.order.location_id || null;
          this.apiRequest('/order/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              self.trackAdminEvent('ADMIN_ORDER_PICKUP_DATETIME_CHANGED', 'order', id, {
                order_id: id,
                location_id: locationId,
                pickup_datetime_from: pickupFrom,
                pickup_datetime_to: response.data && response.data[0] && response.data[0].pickup_datetime || newTime,
                direction: flag === 'add' ? 'add' : 'subtract',
                minutes: time
              });
              self.order.formatted_pickup_datetime = self.formatTime(response.data[0].pickup_datetime);
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', self.$t('orders.orderHourSuccess'), 'success');
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }
    },
    saveComment: function saveComment() {
      var id = this.route.params.id;
      var data = {
        id: id,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        backoffice_comments: this.order.backoffice_comments
      };
      var self = this;
      this.apiRequest('/order/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', self.$t('orders.orderCommnetSuccess'), 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
        }
      });
    },
    sendOrderToPrintSections: function sendOrderToPrintSections(orderId, printToIp) {
      var _this16 = this;

      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: 'Printing Sections',
        html: 'Please wait...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: function onOpen() {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default.a.showLoading();
        }
      });

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: orderId
      };

      this.apiRequest('/get-order-for-local-printer', 'POST', data, function (response) {
        if (response.status) {
          var sectionDataToSendToLocal = {
            order: response.data.order,
            printers: response.data.printers
          };

          var receiptDataToSendToLocal = {
            order: response.data.order,
            printers: response.data.printersForReceipt
          };

          var $msg = '';
          var oneErrorMsg = 'success';

          if (response.data.printers.length) {
            _this16.localRequest(printToIp, '/print-sections', 'POST', sectionDataToSendToLocal, function (sectionRsp) {
              if (sectionRsp.status === 200) {
                sectionRsp.data.data.forEach(function (printerResponse) {
                  if (printerResponse.status) {
                    if (printerResponse.message && printerResponse.message === 'No items to print') {
                      return;
                    }
                    $msg += 'Sectia: ' + printerResponse.printerSectionName + ' s-a printat cu succes!\n';
                  } else {
                    $msg += 'Eroare sectia: ' + printerResponse.printerSectionName + '\n';
                    oneErrorMsg = 'error';
                  }
                });
              } else {
                $msg += 'Eroare: sectiuni - ' + printToIp + ' inaccesibil sau proxy nu functioneaza.\n';
                oneErrorMsg = 'error';
              }
              if (response.data.printersForReceipt.length) {
                _this16.localRequest(printToIp, '/print', 'POST', receiptDataToSendToLocal, function (receiptRsp) {
                  if (receiptRsp.status === 200) {
                    receiptRsp.data.data.forEach(function (printerResponse) {
                      if (printerResponse.status) {
                        $msg += 'Nota de plata s-a printat cu succes!\n';
                      } else {
                        $msg += 'Eroare nota de plata' + '\n';
                        oneErrorMsg = 'error';
                      }
                    });
                  } else {
                    $msg += 'Eroare: bonuri - ' + printToIp + ' inaccesibil sau proxy nu functioneaza.\n';
                    oneErrorMsg = 'error';
                  }
                });
              }

              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                title: oneErrorMsg === 'success' ? 'Succes!' : 'Rezultat printare',
                html: $msg.replace(/\n/g, '<br>'),
                type: oneErrorMsg,
                confirmButtonText: 'OK',
                allowOutsideClick: false
              });
            });
          } else if (response.data.printersForReceipt.length) {
            _this16.localRequest(printToIp, '/print', 'POST', receiptDataToSendToLocal, function (receiptRsp) {
              if (receiptRsp.status === 200) {
                receiptRsp.data.data.forEach(function (printerResponse) {
                  if (printerResponse.status) {
                    $msg += 'Nota de plata s-a printat cu succes!\n';
                  } else {
                    $msg += 'Eroare nota de plata' + '\n';
                    oneErrorMsg = 'error';
                  }
                });
              } else {
                $msg += 'Eroare: bonuri - ' + printToIp + ' inaccesibil sau proxy nu functioneaza.\n';
                oneErrorMsg = 'error';
              }

              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                title: oneErrorMsg === 'success' ? 'Succes!' : 'Rezultat printare',
                html: $msg.replace(/\n/g, '<br>'),
                type: oneErrorMsg,
                confirmButtonText: 'OK',
                allowOutsideClick: false
              });
            });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            title: 'Error',
            text: 'Failed to load order for printing',
            type: 'error',
            confirmButtonText: 'OK'
          });
        }
      });
    },
    beforeUpdateStatus: function beforeUpdateStatus(requestStatus, orderStatus) {
      if (requestStatus === true) {
        var orderId = this.order && this.order.id || this.route.params.id;
        var loc = this.order && this.order.production_details && this.order.production_details.location || null;
        var locationId = loc && (loc.true_id != null ? loc.true_id : loc.id) || this.order && this.order.location_true_id || this.order && this.order.location_id || null;
        this.trackAdminEvent('ADMIN_ORDER_STATUS_CHANGED', 'order', orderId, {
          order_id: orderId,
          location_id: locationId,
          status_from: this.order && this.order.status && this.order.status.id || null,
          status_to: orderStatus
        });
        if (orderStatus === 'PROCESSING') {
          var printToIp = JSON.parse(this.$session.get('userData')).server_ip_port;
          if (printToIp && printToIp !== '') {
            this.sendOrderToPrintSections(this.order.id, printToIp);
          }
        }
      }
    },
    updateStatus: function updateStatus(status, label, disabled) {
      var _this17 = this;

      var revertOnCancel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (disabled) {
        return false;
      }
      var self = this;
      if (status === 'CANCELED') {
        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
          input: 'textarea',
          inputAttributes: {
            maxlength: 255
          },
          showCancelButton: true,
          inputPlaceholder: this.$t('orders.cancelReason'),
          confirmButtonText: this.$t('addOrder.btnPopup'),
          showLoaderOnConfirm: true,
          text: self.$t('validations.areYouSure') + this.changeDeliveryStatus(status),
          type: 'question',
          cancelButtonText: this.$t('general.cancel2'),
          allowOutsideClick: false,
          preConfirm: function preConfirm(val) {
            if (!val) {
              document.getElementById('swal2-validationerror').innerText = _this17.$t('validations.cancelReason');
              document.getElementById('swal2-validationerror').setAttribute('style', 'display: block');
              document.getElementsByClassName('swal2-buttonswrapper')[0].setAttribute('class', 'swal2-buttonswrapper');
              document.getElementsByClassName('swal2-confirm swal2-styled')[0].removeAttribute('disabled');
              document.getElementsByClassName('swal2-cancel swal2-styled')[0].removeAttribute('disabled');
              return;
            }
            var id = _this17.route.params.id;
            var data2 = {
              token: _this17.$session.get('token'),
              company_id: _this17.$session.get('selectedCompany'),
              id: id,
              status: status,
              cancel_order_reason: val
            };
            __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
              type: 'question',
              text: self.$t('customers.clientNotification'),
              position: 'top-end',
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: self.$t('general.yes'),
              cancelButtonText: self.$t('general.no'),
              allowOutsideClick: false
            }).then(function (result) {
              if (result) {
                data2.send_notifications = 1;
                self.cancelRKeeperOrder(id);
                self.cancelFreyaOrder(id);
                self.apiRequest('/order/' + id, 'PUT', data2, function (response) {
                  if (response.status === true) {
                    __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', 'Sucess', 'success').then(function () {
                      if (self.order.payment_type === 'CARD' || self.order.payment_type === 'SPLIT') {
                        self.refundOnCancel(response.data[0].was_delivery_before, id, status, label);
                      } else {
                        self.getData();
                      }
                    });
                  } else {
                    __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                      text: self.$t('general.error'),
                      type: 'error',
                      showConfirmButton: false,
                      timer: 1500
                    });
                  }
                  self.beforeUpdateStatus(response.status, status);
                });
              }
            }, function (dismiss) {
              data2.send_notifications = 0;
              self.cancelRKeeperOrder(id);
              self.cancelFreyaOrder(id);
              if (dismiss === 'cancel') {
                self.apiRequest('/order/' + id, 'PUT', data2, function (response) {
                  if (response.status === true) {
                    __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', 'Sucess', 'success').then(function () {
                      if (self.order.payment_type === 'CARD' || self.order.payment_type === 'SPLIT') {
                        self.refundOnCancel(response.data[0].was_delivery_before, id, status, label);
                      } else {
                        self.getData();
                      }
                    });
                  } else {
                    __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                      title: '',
                      text: self.$t('general.error'),
                      type: 'error',
                      showConfirmButton: false,
                      timer: 1500
                    });
                    self.currentOrdersStatus = self.order.status.id;
                  }
                  self.beforeUpdateStatus(response.status, status);
                });
                self.loading = false;
              }
            });
          }
        }).then(function (val) {}, function (dismiss) {
          if (dismiss === 'cancel') {
            self.currentOrdersStatus = self.order.status.id;
            self.loading = false;
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
          text: self.$t('validations.areYouSure') + this.changeDeliveryStatus(status),
          type: 'question',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel2')
        }).then(function (result) {
          if (result) {
            var id = _this17.route.params.id;
            var data = {
              id: id,
              token: _this17.$session.get('token'),
              company_id: _this17.$session.get('selectedCompany'),
              status: status
            };
            if (status === 'PROCESSING' && self.order.delivery_type === 'DELIVERY') {
              _this17.callPackageezOnProcessing();
            }
            _this17.apiRequest('/order/' + id, 'PUT', data, function (response) {
              var _this18 = this;

              if (response.status === true) {
                self.$session.set('refreshOrdersCount', 'refresh');
                var msg = self.$t('orders.orderStatusSuccess');
                if (response.data_specials !== undefined && response.data_specials.printer_error !== undefined) {
                  msg = msg + self.$t('orders.orderPrinterError');
                }

                if (response.data[0].status.id !== 'NEW') {
                  self.$bus.$emit('stopSound');
                }
                if (response.data[0].status.id === 'CANCELED') {
                  var _iteratorNormalCompletion3 = true;
                  var _didIteratorError3 = false;
                  var _iteratorError3 = undefined;

                  try {
                    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(self.orderStatuses), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                      var ordstat = _step3.value;

                      ordstat.isAllowed = false;
                    }
                  } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                      }
                    } finally {
                      if (_didIteratorError3) {
                        throw _iteratorError3;
                      }
                    }
                  }
                }
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: msg,
                  type: 'success',
                  showConfirmButton: false
                }).then(function () {
                  var companyLocations = self.$session.get('selectedCompanyData');
                  var locationId = self.order.production_details.location.id;
                  companyLocations.locations_details.forEach(function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(location) {
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              if (location.id === locationId && status === 'PROCESSING' && location.auto_print) {
                                setTimeout(function () {
                                  self.printPage();
                                }, 3000);
                              }

                            case 1:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this18);
                    }));

                    return function (_x2) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                });
                if (status !== 'CANCELED') {
                  self.$session.set('refreshOrdersCount', 'refresh');
                  var _msg = self.$t('orders.orderStatusSuccess');
                  if (response.data_specials !== undefined && response.data_specials.printer_error !== undefined) {
                    _msg = _msg + self.$t('orders.orderPrinterError');
                  }
                  __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                    text: _msg,
                    type: 'success',
                    showConfirmButton: false
                  }).then(function () {
                    var companyLocations = self.$session.get('selectedCompanyData');
                    var locationId = self.order.production_details.location.id;
                    companyLocations.locations_details.forEach(function () {
                      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(location) {
                        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                          while (1) {
                            switch (_context3.prev = _context3.next) {
                              case 0:
                                if (location.id === locationId && status === 'PROCESSING' && location.auto_print) {
                                  setTimeout(function () {
                                    self.printPage();
                                  }, 3000);
                                }

                              case 1:
                              case 'end':
                                return _context3.stop();
                            }
                          }
                        }, _callee3, _this18);
                      }));

                      return function (_x3) {
                        return _ref2.apply(this, arguments);
                      };
                    }());
                  });
                  self.getData();
                }
              } else if (response.errors.boogit) {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: response.errors.boogit,
                  type: 'error',
                  showConfirmButton: false
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
                if (revertOnCancel) {
                  self.currentOrdersStatus = self.order.status.id;
                }
              }
              self.beforeUpdateStatus(response.status, status);
            });
          }
        }).catch(function () {
          if (revertOnCancel) {
            self.currentOrdersStatus = self.order.status.id;
            self.loading = false;
          }
        });
      }
    },
    changeStatus: function changeStatus() {
      var _this19 = this;

      var status = this.currentOrdersStatus;
      var label = this.$t('ordersStatus.' + this.currentOrdersStatus);
      this.loading = true;
      this.updateStatus(status, label, false, true).then(function () {
        _this19.loading = false;
      });
    },
    changeStatusFromButtons: function changeStatusFromButtons(type) {
      if (type === this.currentOrdersStatus) {
        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
          text: this.$t('orders.sameStatus') + this.$t('ordersStatus.' + this.currentOrdersStatus),
          type: 'error',
          timer: 1000,
          showConfirmButton: false
        });
      } else {
        this.currentOrdersStatus = type;
        var status = this.currentOrdersStatus;
        var label = this.$t('ordersStatus.' + this.currentOrdersStatus);
        this.loading = true;
        this.updateStatus(status, label, false, true);
        this.loading = false;
      }
    },
    printPage: function printPage() {
      window.print();
    },
    sendToPrinter: function sendToPrinter() {
      var _this20 = this;

      this.$nextTick(function () {
        _this20.loading = true;
      });
      var id = this.route.params.id;
      var data = {
        token: this.$session.get('token')
      };
      var self = this;
      this.apiRequest('/print/' + id, 'GET', data, function (response) {
        self.$nextTick(function () {
          self.loading = false;
        });
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', self.$t('orders.printerSuccess'), 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', self.$t('orders.printerErrror'), 'error');
        }
      });
    },
    closePaymentModal: function closePaymentModal() {
      this.$modal.hide('paymentModal');
    },
    printFiscal: function printFiscal() {
      this.$modal.show('paymentModal');
    },
    processPrinter: function processPrinter(payMethod) {
      this.closePaymentModal();
      var data = {
        token: this.$session.get('token'),
        pay_method: payMethod,
        with_pos: true,
        company_id: this.$session.get('selectedCompany'),
        capture_transaction_response: '',
        receipt_number: '',
        cui: this.cui,
        orderid: this.route.params.id,
        total: this.order['totals_grandtotal']
      };
      this.$bus.$emit('fiscalEvent', data);
    },
    changeDeliveryStatusForLabel: function changeDeliveryStatusForLabel(status) {
      var self = this;
      if (status === 'DELIVERED' && self.order.delivery_type === 'EAT_LOCATION') {
        status = 'RESERVED';
      }
      if (status === 'DELIVERED' && self.order.delivery_type === 'PICK_UP') {
        status = 'COMPLETED';
      }
      return this.$t('ordersStatus.' + status);
    },
    changeDeliveryStatus: function changeDeliveryStatus(status) {
      var self = this;
      if (status === 'DELIVERED' && self.order.delivery_type === 'EAT_LOCATION') {
        status = 'RESERVED';
      }
      if (status === 'DELIVERED' && self.order.delivery_type === 'PICK_UP') {
        status = 'COMPLETED';
      }
      if (status === 'CANCELED') {
        status = this.$t('canceledForever');
      }
      return this.$t('ordersStatus.' + status);
    },
    convetLabelingJson: function convetLabelingJson(labeling) {
      var label = JSON.parse(labeling);
      return label.notification;
    },
    glovoCourierCall: function glovoCourierCall(id, locationId) {
      var _this21 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: this.$t('glovo.areYouSure'),
        html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;">' + '<div style="margin-top: 14px;"></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="glovo-package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option><option value="45">45 min</option><option value="60">60 min</option></select>' + '<label>' + this.$t('customers.commentsLabel') + '</label>' + '<textarea type="text" id="glovo-comment-' + id + '" maxlength="255" rows="3" columns="4" class="form-control" style="max-width: 75%; margin: auto" placeholder="50 burgers"></textarea></div>',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        data.time = document.getElementById('glovo-package-time-' + id).value;
        data.glovo_comment = document.getElementById('glovo-comment-' + id).value;
        if (result) {
          _this21.apiRequest('/glovo-laas/create/' + id, 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this21.$t('orders.orderSentSuccess'),
                type: 'success',

                showConfirmButton: true
              });

              _this21.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: response.errors,
                type: 'error',

                showConfirmButton: true
              });
              _this21.getData();
            }
          });
        }
      });
    },
    cancelGlovoCourier: function cancelGlovoCourier(id, locationId) {
      var _this22 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };

      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        text: this.$t('orders.callCourierCancel'),
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (result) {
          _this22.apiRequest('/glovo-laas/cancel/' + id, 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this22.$t('orders.orderCancelSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false,
                cancelButtonText: _this22.$t('general.cancel')
              });
              _this22.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: response.errors,
                type: 'error',
                timer: 5000,
                showConfirmButton: false
              });
              _this22.getData();
            }
          });
        }
      });
    },
    deliveryHeroCourierCall: function deliveryHeroCourierCall(id, locationId) {
      var _this23 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: this.$t('orders.deliveryHeroAreYouSure'),
        html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;">' + '<div style="margin-top: 14px;"></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="delivery-hero-package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option><option value="45">45 min</option><option value="60">60 min</option></select>' + '<label>' + this.$t('customers.commentsLabel') + '</label>' + '<textarea type="text" id="delivery-hero-comment-' + id + '" maxlength="255" rows="3" columns="4" class="form-control" style="max-width: 75%; margin: auto"></textarea></div>',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        data.time = document.getElementById('delivery-hero-package-time-' + id).value;
        data.delivery_hero_comment = document.getElementById('delivery-hero-comment-' + id).value;
        if (result) {
          _this23.apiRequest('/delivery-hero/create/' + id, 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this23.$t('orders.orderSentSuccess'),
                type: 'success',
                showConfirmButton: true
              });
              _this23.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: response.errors,
                type: 'error',
                showConfirmButton: true
              });
              _this23.getData();
            }
          });
        }
      });
    },
    cancelDeliveryHeroCourier: function cancelDeliveryHeroCourier(id, locationId) {
      var _this24 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };

      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        text: this.$t('orders.callCourierCancel'),
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (result) {
          _this24.apiRequest('/delivery-hero/cancel/' + id, 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this24.$t('orders.orderCancelSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false,
                cancelButtonText: _this24.$t('general.cancel')
              });
              _this24.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: response.errors,
                type: 'error',
                timer: 5000,
                showConfirmButton: false
              });
              _this24.getData();
            }
          });
        }
      });
    },
    woltDriveCourierCall: function woltDriveCourierCall(id, locationId) {
      var _this25 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: this.$t('orders.callCourier') + ' WOLT DRIVE',
        html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;">' + '<div style="margin-top: 14px;"></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="wolt-drive-package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option><option value="45">45 min</option><option value="60">60 min</option></select>' + '<label>' + this.$t('customers.commentsLabel') + '</label>' + '<textarea type="text" id="wolt-drive-comment-' + id + '" maxlength="255" rows="3" columns="4" class="form-control" style="max-width: 75%; margin: auto" placeholder="Optional comment for courier"></textarea></div>',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        if (result) {
          var time = document.getElementById('wolt-drive-package-time-' + id).value;
          var comment = document.getElementById('wolt-drive-comment-' + id).value;

          _this25.apiRequest('/wolt-drive/order/' + id + '/shipment-promises?time=' + time, 'GET', data, function (response) {
            var unwrappedResponse = response && response.status === false && response.error && response.error.response && response.error.response.data ? response.error.response.data : response;

            var errorPayload = function () {
              var candidates = [unwrappedResponse, unwrappedResponse && unwrappedResponse.data, unwrappedResponse && unwrappedResponse.data && unwrappedResponse.data.data];
              for (var i = 0; i < candidates.length; i++) {
                var c = candidates[i];
                if (c && c.status === false && c.errors && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(c.errors) === 'object') return c;
              }
              return null;
            }();

            if (errorPayload && errorPayload.errors && errorPayload.errors.error_code) {
              var codeKey = 'orders.woltDriveShipmentPromisesErrorCode_' + errorPayload.errors.error_code;
              var translated = _this25.$t(codeKey);
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: translated !== codeKey ? translated : errorPayload.errors.details || errorPayload.errors.reason || _this25.$t('validations.wentWrong'),
                type: 'error',
                showConfirmButton: true
              });
              return;
            }

            var promises = [];

            var looksLikePromise = function looksLikePromise(obj) {
              return !!(obj && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(obj)) === 'object' && obj.id && obj.pickup && obj.price);
            };

            var pushPromiseOrArray = function pushPromiseOrArray(value) {
              if (!value) return;
              if (Array.isArray(value)) {
                promises = value;
                return;
              }
              if (looksLikePromise(value)) {
                promises = [value];
              }
            };

            pushPromiseOrArray(unwrappedResponse);

            if (promises.length === 0 && unwrappedResponse && unwrappedResponse.data) {
              pushPromiseOrArray(unwrappedResponse.data);
            }

            if (promises.length === 0 && unwrappedResponse && unwrappedResponse.data && unwrappedResponse.data.data) {
              pushPromiseOrArray(unwrappedResponse.data.data);
            }

            if (promises.length === 0 && unwrappedResponse && unwrappedResponse.data && unwrappedResponse.data.data && unwrappedResponse.data.data.data) {
              pushPromiseOrArray(unwrappedResponse.data.data.data);
            }

            if (promises.length === 0) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this25.$t('orders.noShipmentPromises'),
                type: 'error',
                showConfirmButton: true
              });

              console.log('Wolt Drive shipment-promises raw response:', unwrappedResponse);
              return;
            }

            var promise = promises[0];

            var pickupEtaMinutes = promise.pickup && (promise.pickup.eta_minutes || promise.pickup.eta) || promise.pickup_eta_minutes || null;
            var pickupEtaText = pickupEtaMinutes !== null && pickupEtaMinutes !== undefined ? pickupEtaMinutes + ' min' : 'N/A';

            var priceAmount = promise.price && promise.price.amount !== undefined && promise.price.amount !== null ? promise.price.amount : 'N/A';
            var priceCurrency = promise.price && promise.price.currency ? promise.price.currency : '';
            var formattedPriceAmount = typeof priceAmount === 'number' ? (priceAmount / 100).toFixed(2) : priceAmount;
            var priceText = priceCurrency ? formattedPriceAmount + ' ' + priceCurrency : '' + formattedPriceAmount;

            var validUntilText = promise.valid_until ? _this25.formatToCompanyTimezone(promise.valid_until) : 'N/A';

            var promisesHtml = '<div style="margin-top: 14px;">' + '<div style="padding: 12px; border: 1px solid #ddd; border-radius: 6px;">' + ('<div><strong>Pickup ETA:</strong> ' + pickupEtaText + '</div>') + ('<div><strong>Price:</strong> ' + priceText + '</div>') + ('<div><strong>Valid until:</strong> ' + validUntilText + '</div>') + '</div>' + '</div>';

            __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
              title: _this25.$t('orders.confirmDeliveryDetails'),
              html: promisesHtml,
              showCancelButton: true,
              cancelButtonText: _this25.$t('general.cancel'),
              confirmButtonText: _this25.$t('scanner.confirm'),
              width: '600px'
            }).then(function (promiseResult) {
              if (promiseResult) {
                var selectedPromise = promises[0];

                var deliveryData = {
                  token: _this25.$session.get('token'),
                  company_id: _this25.$session.get('selectedCompany'),
                  promise_data: selectedPromise,
                  comment: comment || ''
                };

                _this25.apiRequest('/wolt-drive/order/' + id + '/create-delivery', 'POST', deliveryData, function (deliveryResponse) {
                  var unwrapped = deliveryResponse && deliveryResponse.status === false && deliveryResponse.error && deliveryResponse.error.response && deliveryResponse.error.response.data ? deliveryResponse.error.response.data : deliveryResponse;

                  if (unwrapped && unwrapped.status === true) {
                    __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                      text: _this25.$t('orders.orderSentSuccess'),
                      type: 'success',
                      showConfirmButton: true
                    });
                    _this25.getData();
                  } else {
                    var errorText = function () {
                      var resp = unwrapped;
                      if (!resp) return _this25.$t('validations.wentWrong');
                      if (resp.errors && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(resp.errors) === 'object' && resp.errors.error_code) {
                        var _codeKey = 'orders.woltDriveCreateDeliveryErrorCode_' + resp.errors.error_code;
                        var _translated = _this25.$t(_codeKey);
                        if (_translated !== _codeKey) return _translated;
                        if (typeof resp.errors.details === 'string') return resp.errors.details;
                        if (typeof resp.errors.reason === 'string') return resp.errors.reason;
                      }
                      if (typeof resp.errors === 'string') return resp.errors;
                      if (typeof resp.message === 'string') return resp.message;
                      return _this25.$t('validations.wentWrong');
                    }();
                    __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                      text: errorText,
                      type: 'error',
                      showConfirmButton: true
                    });
                    _this25.getData();
                  }
                });
              }
            });
          });
        }
      });
    },
    cancelWoltDriveCourier: function cancelWoltDriveCourier(id, locationId) {
      var _this26 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        input: 'textarea',
        inputAttributes: {
          maxlength: 255
        },
        showCancelButton: true,
        inputPlaceholder: this.$t('orders.cancelReason'),
        confirmButtonText: this.$t('scanner.confirm'),
        showLoaderOnConfirm: true,
        text: this.$t('orders.callCourierCancel'),
        type: 'question',
        cancelButtonText: this.$t('general.cancel2'),
        allowOutsideClick: false,
        preConfirm: function preConfirm(val) {
          if (!val) {
            __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default.a.showValidationMessage(_this26.$t('validations.cancelReason'));
            return false;
          }

          var data = {
            token: _this26.$session.get('token'),
            company_id: _this26.$session.get('selectedCompany'),
            reason: val
          };

          var authToken = data.token ? 'Bearer ' + data.token : '';
          var instance = self.axios.create({
            baseURL: "https://gatewaydev.taptasty.com/",
            timeout: 90000,
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Authorization': authToken
            }
          });

          return instance.post('/wolt-drive/order/' + id + '/status/cancel', data).then(function (res) {
            return res.data;
          }).catch(function (err) {
            var errorPayload = err && err.response && err.response.data ? err.response.data : null;
            return errorPayload || { status: false, errors: err && err.message ? err.message : 'Request failed' };
          });
        }
      }).then(function (result) {
        if (result === undefined || result === null) return;

        var hasSwalShape = (typeof result === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(result)) === 'object' && (Object.prototype.hasOwnProperty.call(result, 'value') || Object.prototype.hasOwnProperty.call(result, 'dismiss') || Object.prototype.hasOwnProperty.call(result, 'isConfirmed'));
        var isCancelled = hasSwalShape ? !!result.dismiss : false;
        var isConfirmed = hasSwalShape ? result.isConfirmed === true || !isCancelled && result.value !== undefined : true;
        if (!isConfirmed) return;

        var response = hasSwalShape ? result.value : result;
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: self.$t('orders.orderCancelSuccess'),
            type: 'success',
            showConfirmButton: true
          });
        } else {
          var errorText = function () {
            if (!response) return self.$t('validations.wentWrong');
            if (typeof response.errors === 'string') return response.errors;
            if (response.errors && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(response.errors) === 'object' && response.errors.error_code) {
              var codeKey = 'orders.woltDriveCancelErrorCode_' + response.errors.error_code;
              var translated = self.$t(codeKey);
              if (translated !== codeKey) return translated;
              if (typeof response.errors.details === 'string') return response.errors.details;
              if (typeof response.errors.reason === 'string') return response.errors.reason;
            }
            if (typeof response.message === 'string') return response.message;
            if (response.error && typeof response.error === 'string') return response.error;
            try {
              if (response.errors) return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(response.errors);
            } catch (e) {}
            return self.$t('validations.wentWrong');
          }();
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: errorText,
            type: 'error',
            showConfirmButton: true
          });
        }
        self.getData();
      });
    },
    tazzCourierCall: function tazzCourierCall(id, locationId) {
      var _this27 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: this.$t('tazz.areYouSure'),
        html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="tazz-package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        data.time = document.getElementById('tazz-package-time-' + id).value;
        if (result) {
          _this27.apiRequest('/tazz/create', 'POST', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this27.$t('orders.orderSentSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false
              });

              _this27.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: response.errors.error,
                type: 'error',
                timer: 5000,
                showConfirmButton: false
              });
              _this27.getData();
            }
          });
        }
      });
    },
    tazzLaasCourierCall: function tazzLaasCourierCall(id, locationId) {
      var _this28 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: this.$t('tazz.areYouSure'),
        html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="laas-tazz-package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        var time = document.getElementById('laas-tazz-package-time-' + id).value;
        if (result) {
          _this28.apiRequest('/tazz-laas/create/' + id + '/' + time, 'POST', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this28.$t('orders.orderSentSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false
              });

              _this28.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: response.errors,
                title: 'Error',
                type: 'error',
                timer: 5000,
                showConfirmButton: false
              });
              _this28.getData();
            }
          });
        }
      });
    },
    tazzLaasCancelCourierCall: function tazzLaasCancelCourierCall(id, locationId) {
      var _this29 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: this.$t('tazz.areYouSureCancel'),

        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: this.$t('general.no'),
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this29.apiRequest('/tazz-laas/cancel/' + id, 'POST', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this29.$t('orders.orderSentSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false
              });

              _this29.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: response.errors,
                title: 'Error',
                type: 'error',
                timer: 5000,
                showConfirmButton: false
              });
              _this29.getData();
            }
          });
        }
      });
    },
    boogitSendOrder: function boogitSendOrder(id) {
      var _this30 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id
      };
      this.apiRequest('/boogit/send-order/' + id, 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: _this30.$t('orders.orderSentSuccess'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          });
          _this30.getData();
        } else {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: response.errors,
            title: 'Error',
            type: 'error',
            timer: 5000,
            showConfirmButton: false
          });
          _this30.getData();
        }
      });
    },
    tazzSetOrderPrepared: function tazzSetOrderPrepared(orderId) {
      var _this31 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: orderId
      };

      this.apiRequest('/tazz/manual-set-prep-ready', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: _this31.$t('orders.orderSentSuccess'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          });

          _this31.getData();
        } else {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: response.errors.error,
            type: 'error',
            timer: 5000,
            showConfirmButton: false
          });
          _this31.getData();
        }
      });
    },
    cancelTazzCourier: function cancelTazzCourier(id, locationId) {
      var _this32 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };

      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        text: this.$t('orders.callCourierCancel'),
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (result) {
          _this32.apiRequest('/tazz/cancel/' + id, 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this32.$t('orders.orderCancelSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false,
                cancelButtonText: _this32.$t('general.cancel')
              });
              _this32.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this32.$t('tazz.' + response.errors.error),
                type: 'error',
                timer: 5000,
                showConfirmButton: false
              });
              _this32.getData();
            }
          });
        }
      });
    },
    courierHioCall: function courierHioCall(id, locationId) {
      var _this33 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: 'Sigur vrei sa chemi curier HIO?',
        html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        if (result) {
          _this33.apiRequest('/hio-send-order', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this33.$t('orders.orderSentSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false
              });
              _this33.cancelOrder = true;
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: response.errors,
                type: 'error',
                timer: 2000,
                showConfirmButton: false
              });
            }
          });
        }
      });
    },
    cancelHioCourierOrder: function cancelHioCourierOrder(id, locationId) {
      var _this34 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };

      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        text: this.$t('orders.callCourierCancel'),
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (result) {
          _this34.apiRequest('/hio-cancel-order', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this34.$t('orders.orderCancelSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false,
                cancelButtonText: _this34.$t('general.cancel')
              });
              _this34.cancelOrder = false;
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: response.errors,
                type: 'error',
                timer: 2000,
                showConfirmButton: false
              });
            }
          });
        }
      });
    },
    courierCall: function courierCall(id, locationId) {
      var _this35 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: this.$t('orders.packageDetails'),
        html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"><label style="margin-top: inherit;">' + this.$t('orders.packageSize') + '</label><select id="package-size-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="30x30x10">30x30x10</option><option value="30x30x20">30x30x20</option><option value="30x30x30">30x30x30</option><option value="60x60x30">60x60x30</option></select></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel2')
      }).then(function (result) {
        data.size = document.getElementById('package-size-' + id).value;
        data.time = document.getElementById('package-time-' + id).value;
        if (result) {
          _this35.apiRequest('/packagez-send-order', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this35.$t('orders.orderSentSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false
              });
              _this35.cancelOrder = true;
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this35.$t('orders.contactPakageez'),
                type: 'error',
                timer: 2000,
                showConfirmButton: false
              });
            }
          });
        }
      });
    },
    callRapidDonkey: function callRapidDonkey(id) {
      var _this36 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: this.$t('orders.packageDetails'),
        html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;"><div style="margin-top: 14px;"><label style="margin-top: inherit;">' + this.$t('orders.packageSize') + '</label><select id="package-size-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="30x30x10">30x30x10</option><option value="30x30x20">30x30x20</option><option value="30x30x30">30x30x30</option><option value="60x60x30">60x60x30</option></select></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="1">' + this.$t('orders.now') + '</option><option value="15">15 min</option><option value="30">30 min</option></select></div>',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel2')
      }).then(function (result) {
        data.size = document.getElementById('package-size-' + id).value;
        data.time = document.getElementById('package-time-' + id).value;
        if (result) {
          _this36.apiRequest('/rapid-donkey-send-order', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_21_vue___default.a.set(_this36.order, 'rapid_donkey_status', response.data.rapid_donkey_status);
              if (response.data.rapid_donkey_status === 2) {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this36.$t('orders.orderSentSuccess'),
                  type: 'success',

                  showConfirmButton: true
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this36.$t('orders.contactRapidDonkey'),
                  type: 'error',

                  showConfirmButton: true
                });
              }
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this36.$t('orders.contactRapidDonkey'),
                type: 'error',

                showConfirmButton: true
              });
            }
          });
        }
      });
    },
    cancelRapidDonkey: function cancelRapidDonkey() {
      var _this37 = this;

      var id = this.route.params.id;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        input: 'textarea',
        inputAttributes: {
          maxlength: 255
        },
        showCancelButton: true,
        inputPlaceholder: this.$t('orders.cancelReason'),
        confirmButtonText: this.$t('addOrder.btnPopup'),
        showLoaderOnConfirm: true,
        text: this.$t('orders.callCourierCancel'),
        type: 'question',
        cancelButtonText: this.$t('general.cancel2'),
        allowOutsideClick: false,
        preConfirm: function preConfirm(val) {
          if (!val) {
            document.getElementById('swal2-validationerror').innerText = _this37.$t('validations.cancelReason');
            document.getElementById('swal2-validationerror').setAttribute('style', 'display: block');
            document.getElementsByClassName('swal2-buttonswrapper')[0].setAttribute('class', 'swal2-buttonswrapper');
            document.getElementsByClassName('swal2-confirm swal2-styled')[0].removeAttribute('disabled');
            document.getElementsByClassName('swal2-cancel swal2-styled')[0].removeAttribute('disabled');
            return;
          }
          data.cancel_order_reason = val;
          _this37.apiRequest('/rapid-donkey-cancel-order', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_21_vue___default.a.set(_this37.order, 'rapid_donkey_status', response.data.rapid_donkey_status);
              if (response.data.rapid_donkey_status === 1) {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this37.$t('orders.orderCancelSuccess'),
                  type: 'success',

                  showConfirmButton: true
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this37.$t('orders.contactRapidDonkey'),
                  type: 'error',

                  showConfirmButton: true
                });
              }
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this37.$t('orders.contactRapidDonkey'),
                type: 'error',

                showConfirmButton: true
              });
            }
          });
        }
      });
    },
    cancelCourierOrder: function cancelCourierOrder(id, locationId) {
      var _this38 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id,
        location_id: locationId
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        text: this.$t('orders.callCourierCancel'),
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (result) {
          _this38.apiRequest('/packagez-cancel-order', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this38.$t('orders.orderCancelSuccess'),
                type: 'success',
                timer: 1000,
                showConfirmButton: false,
                cancelButtonText: _this38.$t('general.cancel2')
              });
              _this38.cancelOrder = false;
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: response.errors.order,
                type: 'error',
                timer: 2000,
                showConfirmButton: false
              });
            }
          });
        }
      });
    },
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy).then(function (e) {}, function (e) {});
    },
    showOrderInIntegrationLink: function showOrderInIntegrationLink(orderId) {
      var _this39 = this;

      var dataToBeSent = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: orderId
      };
      this.apiRequest('/show_order_in_integration_link', 'GET', dataToBeSent, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: _this39.$t('general.success'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          });
          _this39.getData();
        } else {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: _this39.$t('general.error'),
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          });
        }
      });
    },
    sendToGrandchef: function sendToGrandchef(orderId) {
      var _this40 = this;

      var data = {
        order_id: orderId,
        token: this.$session.get('token')
      };

      if (!this.grandchefDelay || parseInt(Math.abs(this.grandchefDelay.getTime() - new Date().getTime()) / (1000 * 60) % 60) >= 30) {
        this.grandchefDelay = new Date();
        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
          text: this.$t('orders.sendToGrandchef'),
          type: 'question',
          showCancelButton: true
        }).then(function (result) {
          if (result) {
            _this40.apiRequest('/grand-chef/send-failed-order', 'GET', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this40.$t('general.success'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false,
                  cancelButtonText: _this40.$t('general.cancel2')
                });
                _this40.cancelOrder = false;
              } else {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this40.$t('orders.grandchefError'),
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
              }
            });
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: this.$t('orders.grandchefWait'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
    },
    refundOnCancel: function refundOnCancel(boolean, id, status, label) {
      var _this41 = this;

      if (this.order.payment_id === 'btIpay') {
        if (this.order.transaction_id && !this.refundAlreadyDone) this.handleBtReturnQueued();else this.getData();
        return;
      }
      if (boolean) {
        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
          text: this.$t('orders.refundManual'),
          type: 'success',
          showConfirmButton: false,
          timer: 1500
        });
        this.getData();
      } else {
        setTimeout(function () {
          var que = _this41.$t('orders.refundAutomat');
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: que,
            type: 'question',
            showCancelButton: true,
            cancelButtonText: _this41.$t('general.cancel2')
          }).then(function (res) {
            var data2 = {
              id: id,
              token: _this41.$session.get('token'),
              company_id: _this41.$session.get('selectedCompany'),
              status: status
            };
            _this41.apiRequest('/automat-refund', 'POST', data2, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this41.$t('orders.' + response.data),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this41.$t('orders.' + response.errors.error),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                });
              }
              _this41.getData();
            });
          });
        }, 2000);
      }
    },
    editOrderPrice: function editOrderPrice() {
      this.$modal.show('editPriceModal');
      this.editOrder.price = this.order.totals_grandtotal;
    },
    updateOrderPrice: function updateOrderPrice() {
      var _this42 = this;

      var data = {
        order_id: this.order.id,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        totals_grandtotal: this.editOrder.price,
        reason: this.editOrder.reason
      };
      this.apiRequest('/order/' + this.order.id, 'PUT', data, function (response) {
        if (response.status === true) {
          _this42.$modal.hide('editPriceModal');
          _this42.editOrder.price = 0;
          _this42.editOrder.reason = '';
          _this42.getData();
        } else {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: response.errors.order,
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          });
        }
      });
    },
    cancelFreyaOrder: function cancelFreyaOrder(id) {
      if (this.order.freya_status !== 0) {
        var data = {
          token: this.$session.get('token')
        };
        this.apiRequest("https://gatewaydev.taptasty.com/" + 'freya/cancel-order/' + id, 'POST', data, function (response) {});
      }
    },
    resendOrderToFreya: function resendOrderToFreya(orderId) {
      var _this43 = this;

      this.order.freya_status = 1;
      var data = {
        token: this.$session.get('token'),
        order_id: orderId
      };
      this.apiRequest("https://gatewaydev.taptasty.com/" + 'freya/send-order/' + orderId, 'POST', data, function (response) {
        _this43.order.freya_status = response.status ? 2 : 3;
      });
    },
    resendOrderToRKeeper: function resendOrderToRKeeper(orderId) {
      var _this44 = this;

      this.order.rkeeper_status = 1;
      var data = {
        token: this.$session.get('token'),
        order_id: orderId
      };
      this.apiRequest("https://gatewaydev.taptasty.com/" + 'send-order-rkeeper/' + orderId, 'POST', data, function (response) {
        if (response && response.data && response.data.order_status) {
          _this44.order.rkeeper_status = response.data.order_status;
        }
      });
    },
    cancelRKeeperOrder: function cancelRKeeperOrder(orderId) {
      var data = {
        token: this.$session.get('token'),
        order_id: orderId
      };
      if (this.order.rkeeper_status !== 0) {
        this.apiRequest("https://gatewaydev.taptasty.com/" + 'cancel-order-rkeeper/' + orderId, 'POST', data, function (response) {});
      }
    },
    callChopChopDriver: function callChopChopDriver(id) {
      var _this45 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: id
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: this.$t('orders.callDriver'),
        html: '',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel2')
      }).then(function (result) {
        if (result) {
          _this45.apiRequest('/chopchop-add-order', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_21_vue___default.a.set(_this45.order, 'call_chopchop', response.data.call_chopchop);
              if (response.data.call_chopchop === 2) {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this45.$t('orders.orderSentSuccess'),
                  type: 'success',

                  showConfirmButton: true
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this45.$t('orders.contactChopChop'),
                  type: 'error',

                  showConfirmButton: true
                });
              }
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this45.$t('orders.contactChopChop'),
                type: 'error',

                showConfirmButton: true
              });
            }
          });
        }
      });
    },
    cancelChopChopDriver: function cancelChopChopDriver() {
      var _this46 = this;

      var id = this.route.params.id;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: id
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        input: 'textarea',
        inputAttributes: {
          maxlength: 255
        },
        showCancelButton: true,
        inputPlaceholder: this.$t('orders.cancelReason'),
        confirmButtonText: this.$t('addOrder.btnPopup'),
        showLoaderOnConfirm: true,
        text: this.$t('orders.callCourierCancel'),
        type: 'question',
        cancelButtonText: this.$t('general.cancel2'),
        allowOutsideClick: false,
        preConfirm: function preConfirm(val) {
          if (!val) {
            document.getElementById('swal2-validationerror').innerText = _this46.$t('validations.cancelReason');
            document.getElementById('swal2-validationerror').setAttribute('style', 'display: block');
            document.getElementsByClassName('swal2-buttonswrapper')[0].setAttribute('class', 'swal2-buttonswrapper');
            document.getElementsByClassName('swal2-confirm swal2-styled')[0].removeAttribute('disabled');
            document.getElementsByClassName('swal2-cancel swal2-styled')[0].removeAttribute('disabled');
            return;
          }
          data.cancel_order_reason = val;
          _this46.apiRequest('/chopchop-cancel-order', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_21_vue___default.a.set(_this46.order, 'call_chophop', response.data.call_chophop);
              if (response.data.chopchop_response === 1) {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this46.$t('orders.orderCancelSuccess'),
                  type: 'success',

                  showConfirmButton: true
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  text: _this46.$t('orders.contactRapidDonkey'),
                  type: 'error',

                  showConfirmButton: true
                });
              }
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this46.$t('orders.contactRapidDonkey'),
                type: 'error',

                showConfirmButton: true
              });
            }
          });
        }
      });
    },
    callDrCarmen: function callDrCarmen(id) {
      var _this47 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id
      };
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: this.$t('orders.packageDetails'),

        html: '<div style:"display: inline-grid; justify-items: stretch; flex-direction: column;">' + '<div style="margin-top: 14px;"></div>' + '<div><label>' + this.$t('orders.courierTime') + '</label><select id="drcarmen-package-time-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"><option value="60">' + this.$t('orders.now') + '</option><option value="900">15 min</option><option value="1800">30 min</option><option value="2700">45 min</option><option value="3600">60 min</option></select>' + '<label style="margin-top: inherit;">' + this.$t('orders.packageNumber') + '</label><input type="number" id="package-number-' + id + '" class="swal2-select" style="display: block; margin-top: auto;"></div>',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel2')
      }).then(function (result) {
        data.time = document.getElementById('drcarmen-package-time-' + id).value;
        data.packages = document.getElementById('package-number-' + id).value;
        if (result) {
          _this47.apiRequest('/drcarmen-add-order', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_21_vue___default.a.set(_this47.order, 'dr_carmen_status', response.data.drcarmen_status);
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: _this47.$t('orders.orderSentSuccess'),
                type: 'success',

                showConfirmButton: true
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                text: response.errors.error,
                type: 'error',

                showConfirmButton: true
              });
            }
          });
        }
      });
    },
    cancelDrCarmen: function cancelDrCarmen(id) {
      var _this48 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id
      };
      this.apiRequest('/drcarmen-cancel-order', 'POST', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_21_vue___default.a.set(_this48.order, 'dr_carmen_status', 0);
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: response.data.drcarmen_status,
            type: 'success',

            showConfirmButton: true
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            text: _this48.$t('orders.contactDrCarmen'),
            type: 'error',

            showConfirmButton: true
          });
        }
      });
    },
    isFiscalized: function isFiscalized() {
      return this.order && this.order.company && this.order.company.print_fiscal_from_dashboard && this.order.receipt_number && this.order.receipt_number.ReceiptNumber;
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh', this.route.params.id);
      this.$bus.$emit('close-modal', null, this.route.params.id);
    }
  }
});

/***/ }),

/***/ "KiKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaignsReport_vue__ = __webpack_require__("OFjz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fa25cec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaignsReport_vue__ = __webpack_require__("smDL");
function injectStyle (ssrContext) {
  __webpack_require__("82ze")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fa25cec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaignsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fa25cec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaignsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KihW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kj5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");












var _components;






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CharismaLocationReceiptDetails',
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_time_select___default.a), _components),
  data: function data() {
    return {
      loading: false,
      receipts: [],
      zReports: [],
      totalZReports: 0,
      dataToTextarea: '',
      dataFromTextarea: '',
      locations: [],
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      administrations: [],
      posList: [],
      filters: {
        locationId: null,
        posIds: [],
        partnerCode: this.$route.query.partnerCode || '',
        administrationId: this.$route.query.administrationId ? Number(this.$route.query.administrationId) : null,
        itemId: this.$route.query.itemId || '',
        tipsItemId: this.$route.query.tipsItemId || ''
      },
      timezone: (this.$session.get('selectedCompanyData') || {}).timezone || 'Europe/Bucharest',
      dateRange: [__WEBPACK_IMPORTED_MODULE_12_moment___default()().subtract(1, 'days').format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_12_moment___default()().format('YYYY-MM-DD')],
      data_from_time: '05:00',
      data_to_time: '05:00',
      pickerNames: ['data_from', 'data_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_12_moment___default()().subtract(12, 'months').startOf('day');
        }
      }
    };
  },

  computed: {
    posOptions: function posOptions() {
      return (this.posList || []).map(function (pos) {
        return {
          value: pos.id,
          label: pos.name || pos.id
        };
      });
    }
  },
  created: function created() {
    this.initLocations();
    this.initAdministrations();
    this.initPosList();
    this.fetchLocationReceiptDetails();
  },

  methods: {
    goBackToReport: function goBackToReport() {
      var query = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.$route.query, { tab: 'charisma-location-receipt' });
      this.$router.push({ path: '/reports', query: query });
    },
    fetchLocationReceiptDetails: function fetchLocationReceiptDetails(query) {
      var _this = this;

      var locationId = this.$route.params.locationId;
      if (!locationId) {
        return;
      }

      var dataFrom = null;
      var dataTo = null;
      if (this.dateRange && this.dateRange.length === 2 && this.data_from_time && this.data_to_time) {
        var fromTime = this.data_from_time === '24:00' ? '23:59' : this.data_from_time;
        var toTime = this.data_to_time === '24:00' ? '23:59' : this.data_to_time;
        dataFrom = this.dateRange[0] + ' ' + fromTime;
        dataTo = this.dateRange[1] + ' ' + toTime;
      }

      var payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (dataFrom) {
        payload.date_from = dataFrom;
      }
      if (dataTo) {
        payload.date_to = dataTo;
      }

      var pageSize = query ? query.pageSize : this.paginationProps.pageSize || 20;
      var page = query ? query.page : this.paginationProps.currentPage || 1;
      var queryParams = '?page=' + page + '&perPage=' + pageSize;

      this.loading = true;
      this.apiRequest('/reports/v2/charisma/location-receipts/' + locationId + queryParams, 'GET', payload, function (response) {
        if (response && response.status) {
          var data = response.data || {};
          _this.receipts = _this.normalizeReceipts(data);
          _this.populateFiltersFromResponse(data);

          var zReportsData = data.today_fiscal_z_reports || response.today_fiscal_z_reports;
          if (zReportsData && zReportsData.data && Array.isArray(zReportsData.data)) {
            _this.zReports = zReportsData.data;
            _this.totalZReports = zReportsData.total || 0;
            _this.paginationProps.currentPage = zReportsData.current_page || page;
            _this.paginationProps.pageSize = zReportsData.per_page || pageSize;
          } else if (zReportsData && Array.isArray(zReportsData)) {
            _this.zReports = zReportsData;
            _this.totalZReports = zReportsData.length;
          } else {
            _this.zReports = [];
            _this.totalZReports = 0;
          }

          var logs = data.today_charisma_location_receipt_logs || response.today_charisma_location_receipt_logs || [];
          if (Array.isArray(logs) && logs.length > 0) {
            var dataToValues = logs.map(function (log) {
              return log.data_to;
            }).filter(function (val) {
              return val !== undefined && val !== null && val !== '';
            }).map(function (val) {
              if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(val)) === 'object') {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(val, null, 2);
              }
              return String(val);
            });
            var dataFromValues = logs.map(function (log) {
              return log.data_from;
            }).filter(function (val) {
              return val !== undefined && val !== null && val !== '';
            }).map(function (val) {
              if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(val)) === 'object') {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(val, null, 2);
              }
              return String(val);
            });
            _this.dataToTextarea = dataToValues.join('\n-------------\n');
            _this.dataFromTextarea = dataFromValues.join('\n-------------\n');
          } else {
            _this.dataToTextarea = '';
            _this.dataFromTextarea = '';
          }
        } else {
          _this.receipts = [];
          _this.zReports = [];
          _this.totalZReports = 0;
          _this.dataToTextarea = '';
          _this.dataFromTextarea = '';
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', response && response.errors && response.errors.id ? response.errors.id : _this.$t('validations.wentWrong'), 'error');
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    initLocations: function initLocations() {
      var _this2 = this;

      var sessionData = this.$session.get('selectedCompanyData') || {};
      var setLocations = function setLocations() {
        var locationSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var normalized = Array.isArray(locationSource) ? locationSource.map(function (location) {
          return {
            id: _this2.normalizeSelectableValue(location.true_id || location.location_id || location.id),
            name: location.name
          };
        }) : [];

        var role = _this2.$session.get('userDataRole');
        if (['USER', 'LOCATION_ADMIN', 'LOCATION_STORE_ADMIN'].includes(role)) {
          var allowedLocations = [];
          try {
            allowedLocations = JSON.parse(_this2.$session.get('userDataLocations') || '[]');
          } catch (err) {
            allowedLocations = [];
          }
          if (!allowedLocations.length) {
            allowedLocations = normalized.map(function (loc) {
              return loc.id;
            });
          }
          normalized = normalized.filter(function (loc) {
            return allowedLocations.includes(loc.id);
          });
        }

        _this2.locations = normalized;
      };

      if (Array.isArray(sessionData.locations_details) && sessionData.locations_details.length) {
        setLocations(sessionData.locations_details);
        return;
      }

      var payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        columns: ['id', 'true_id', 'name', 'location_id']
      };

      this.apiRequest('/locations', 'GET', payload, function (response) {
        if (response && response.status && Array.isArray(response.data)) {
          sessionData.locations_details = response.data;
          _this2.$session.set('selectedCompanyData', sessionData);
          setLocations(response.data);
        } else {
          _this2.locations = [];
        }
      });
    },
    initAdministrations: function initAdministrations() {
      var _this3 = this;

      var sessionData = this.$session.get('selectedCompanyData') || {};
      var parseStoredList = function parseStoredList(value) {
        if (Array.isArray(value)) {
          return value;
        }
        if (!value) {
          return [];
        }
        try {
          return JSON.parse(value);
        } catch (err) {
          return [];
        }
      };
      var cachedAdministrations = Array.isArray(sessionData.administrations) && sessionData.administrations.length ? sessionData.administrations : parseStoredList(this.$session.get('administrations'));
      if (Array.isArray(cachedAdministrations) && cachedAdministrations.length) {
        this.administrations = cachedAdministrations;
        return;
      }
      var payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/administration', 'GET', payload, function (response) {
        if (response && response.status && Array.isArray(response.data)) {
          _this3.administrations = response.data;
          sessionData.administrations = response.data;
          _this3.$session.set('selectedCompanyData', sessionData);
          _this3.$session.set('administrations', response.data);
        } else {
          _this3.administrations = [];
        }
      });
    },
    initPosList: function initPosList() {
      var _this4 = this;

      var sessionData = this.$session.get('selectedCompanyData') || {};
      var parseStoredList = function parseStoredList(value) {
        if (Array.isArray(value)) {
          return value;
        }
        if (!value) {
          return [];
        }
        try {
          return JSON.parse(value);
        } catch (err) {
          return [];
        }
      };
      var cachedPos = Array.isArray(sessionData.compact_pos_list) && sessionData.compact_pos_list.length ? sessionData.compact_pos_list : parseStoredList(this.$session.get('compact_pos_list'));
      var payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (Array.isArray(cachedPos) && cachedPos.length) {
        this.posList = cachedPos;
        return;
      }
      this.apiRequest('/pos-admin/compact-list', 'GET', payload, function (response) {
        if (response && response.status && Array.isArray(response.data)) {
          _this4.posList = response.data;
          sessionData.compact_pos_list = response.data;
          _this4.$session.set('selectedCompanyData', sessionData);
          _this4.$session.set('compact_pos_list', response.data);
        } else {
          _this4.posList = [];
        }
      });
    },
    populateFiltersFromResponse: function populateFiltersFromResponse(data) {
      var _this5 = this;

      if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(data)) !== 'object') {
        return;
      }
      var location = data.location || {};
      var meta = data.meta || data.configuration || {};
      var fallback = data.data || data || {};

      var pickValue = function pickValue() {
        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
          values[_key] = arguments[_key];
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(values), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var val = _step.value;

            if (val !== undefined && val !== null && val !== '') {
              return val;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return undefined;
      };

      var locationId = pickValue(this.filters.locationId, location.true_id, location.location_id, location.id);
      if (locationId === undefined) {
        var fallbackLocationId = pickValue(fallback.true_id, fallback.location_id, fallback.id);
        if (fallbackLocationId !== undefined) {
          this.filters.locationId = this.normalizeSelectableValue(fallbackLocationId);
        }
      } else {
        this.filters.locationId = this.normalizeSelectableValue(locationId);
      }

      var partnerCode = pickValue(this.filters.partnerCode, location.partner_code, meta.partner_code, fallback.partner_code);
      if (partnerCode !== undefined) {
        this.filters.partnerCode = partnerCode;
      }

      var administrationId = pickValue(this.filters.administrationId, location.administration_id, location.administration && location.administration.id, location.administrationId, fallback.administration_id, fallback.administration && fallback.administration.id, fallback.administrationId);
      if (administrationId !== undefined) {
        this.filters.administrationId = Number(administrationId) || administrationId;
      }

      var itemId = pickValue(this.filters.itemId, location.item_id, location.itemId, meta.item_id, meta.itemId, fallback.item_id, fallback.itemId);
      if (itemId !== undefined) {
        this.filters.itemId = itemId;
      }

      var tipsItemId = pickValue(this.filters.tipsItemId, location.tips_item_id, location.tipsItemId, meta.tips_item_id, meta.tipsItemId, fallback.tips_item_id, fallback.tipsItemId);
      if (tipsItemId !== undefined) {
        this.filters.tipsItemId = tipsItemId;
      }

      var posIds = pickValue(location.pos_ids, location.posIds, meta.pos_ids, meta.posIds, fallback.pos_ids, fallback.posIds);
      if (Array.isArray(posIds)) {
        this.filters.posIds = posIds.filter(function (id) {
          return id !== undefined && id !== null && id !== '';
        }).map(function (id) {
          return _this5.normalizeSelectableValue(id);
        });
      }
    },
    normalizeReceipts: function normalizeReceipts(payload) {
      if (Array.isArray(payload)) {
        return payload;
      }
      if (Array.isArray(payload.receipts)) {
        return payload.receipts;
      }
      if (Array.isArray(payload.table_data)) {
        return payload.table_data;
      }
      if (payload.data && Array.isArray(payload.data)) {
        return payload.data;
      }
      return [];
    },
    formatMoney: function formatMoney(amount) {
      var numeric = Number(amount || 0);
      if (this.formatMoneyAmount) {
        return this.formatMoneyAmount(numeric);
      }
      return numeric.toFixed(2);
    },
    formatStatus: function formatStatus(status) {
      if (status === null || status === undefined || status === '') {
        return '-';
      }
      return this.$t('charisma.charisma' + status) || status;
    },
    formatDate: function formatDate(value) {
      if (!value) {
        return '-';
      }
      if (this.formatToCompanyTimezone) {
        return this.formatToCompanyTimezone(value, this.timezone);
      }
      return value;
    },
    normalizeSelectableValue: function normalizeSelectableValue(value) {
      if (value === undefined || value === null || value === '') {
        return value;
      }
      var numeric = Number(value);
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(numeric)) {
        return numeric;
      }
      return value;
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.data_from_time) {
        this.data_from_time = '05:00';
      }
      if (!this.data_to_time) {
        this.data_to_time = '05:00';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.fetchLocationReceiptDetails(query);
      if (query.type === 'size') this.fetchLocationReceiptDetails(query);
      if (query.type === 'sort') this.fetchLocationReceiptDetails(query);
    },
    updateData: function updateData() {
      this.fetchLocationReceiptDetails();
    },
    sendFiscalZReports: function sendFiscalZReports() {
      var _this6 = this;

      if (!this.zReports || this.zReports.length === 0) {
        return;
      }

      var locationId = this.$route.params.locationId;
      if (!locationId) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
        return;
      }

      var userData = JSON.parse(this.$session.get('userData') || '{}');
      var userId = userData.id;

      if (!userId) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
        return;
      }

      var fiscalZReportIds = this.zReports.map(function (report) {
        return report.id;
      }).filter(function (id) {
        return id !== undefined && id !== null;
      });

      if (fiscalZReportIds.length === 0) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
        return;
      }

      var dateFrom = null;
      var dateTo = null;
      if (this.dateRange && this.dateRange.length === 2 && this.data_from_time && this.data_to_time) {
        var fromTime = this.data_from_time === '24:00' ? '23:59' : this.data_from_time;
        var toTime = this.data_to_time === '24:00' ? '23:59' : this.data_to_time;
        dateFrom = this.dateRange[0] + ' ' + fromTime;
        dateTo = this.dateRange[1] + ' ' + toTime;
      }

      var payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: locationId,
        location_id: this.filters.locationId,
        user_id: userId,
        fiscal_z_report_ids: fiscalZReportIds
      };

      if (dateFrom) {
        payload.date_from = dateFrom;
      }
      if (dateTo) {
        payload.date_to = dateTo;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/charisma/send-fiscal-z-report', 'POST', payload, function (response) {
        if (response && response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', _this6.$t('general.success') || 'Success', 'success');

          _this6.fetchLocationReceiptDetails();
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', response && response.errors && response.errors.id ? response.errors.id : _this6.$t('validations.wentWrong'), 'error');
        }
        _this6.$nextTick(function () {
          _this6.loading = false;
        });
      });
    }
  }
});

/***/ }),

/***/ "KkB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);











/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {
      loading: true,
      loadingProducts: false,
      saving: false,
      companyId: this.$session.get('selectedCompany'),
      token: this.$session.get('token'),

      filters: {
        name: '',
        product_id: '',
        category_id: ''
      },
      debounceTimer: null,
      mainCategories: [],
      products: [],
      locations: [],
      productsPagination: {
        page: 1,
        perPage: 20,
        totalPages: 0,
        totalRecords: 0
      },
      stockData: {}
    };
  },
  created: function created() {
    this.getCategories();
    this.loadLocations();
    this.loadProducts();
  },
  beforeDestroy: function beforeDestroy() {
    this.autoSave();
  },

  methods: {
    loadLocations: function loadLocations() {
      var companyData = this.$session.get('selectedCompanyData');
      this.locations = companyData.locations_details.map(function (l) {
        return {
          id: l.id,
          true_id: l.true_id,
          name: l.name
        };
      });
    },
    isProductInLocation: function isProductInLocation(product, locationTrueId) {
      if (!product.location_ids || product.location_ids.length === 0) {
        return true;
      }
      return product.location_ids.includes(locationTrueId);
    },
    getStockData: function getStockData(productId, locationTrueId) {
      var key = productId + '_' + locationTrueId;
      if (!this.stockData[key]) {
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(this.stockData, key, {
          product_id: productId,
          location_id: locationTrueId,
          active: false,
          stock_id: null,
          _original_stock_id: null,
          stock: 0,
          rezervare_stock: 0,
          sync_gestiune: false,
          decrease_stock: true,
          allow_negative_stock: true,
          active_app: true,
          active_website: true,
          active_qr: true,
          active_kiosk: true,
          active_pos: true,
          _deleted: false,
          _dirty: false
        });
      }
      return this.stockData[key];
    },
    markDirty: function markDirty(productId, locationTrueId) {
      var key = productId + '_' + locationTrueId;
      var stock = this.stockData[key];
      if (stock) {
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, '_dirty', true);
      }
    },
    toggleActive: function toggleActive(productId, locationTrueId) {
      var key = productId + '_' + locationTrueId;
      var stock = this.stockData[key];
      if (!stock) return;

      var isActive = stock.active;
      __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, '_dirty', true);

      if (!isActive) {
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, '_deleted', true);
      } else {
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, '_deleted', false);
        if (!stock.stock_id) {
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'stock', 0);
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'rezervare_stock', 0);
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'sync_gestiune', false);
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'decrease_stock', true);
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'allow_negative_stock', true);
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'active_app', true);
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'active_website', true);
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'active_qr', true);
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'active_kiosk', true);
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'active_pos', true);
        }
      }
    },
    onSyncGestiuneChange: function onSyncGestiuneChange(productId, locationTrueId) {
      var key = productId + '_' + locationTrueId;
      var stock = this.stockData[key];
      if (!stock || !stock.active) return;

      __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, '_dirty', true);

      if (stock.sync_gestiune) {
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'decrease_stock', false);
      }
    },
    onAllowNegativeChange: function onAllowNegativeChange(productId, locationTrueId) {
      var key = productId + '_' + locationTrueId;
      var stock = this.stockData[key];
      if (!stock || !stock.active) return;

      __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, '_dirty', true);

      if (stock.allow_negative_stock) {
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'rezervare_stock', 0);
      }
    },
    isReservationInvalid: function isReservationInvalid(productId, locationTrueId) {
      var key = productId + '_' + locationTrueId;
      var stock = this.stockData[key];
      if (!stock) return false;
      if (stock.allow_negative_stock) return false;

      var rezervare = parseFloat(stock.rezervare_stock) || 0;
      var stoc = parseFloat(stock.stock) || 0;
      return rezervare > stoc;
    },
    onReservationChange: function onReservationChange(productId, locationTrueId) {
      var key = productId + '_' + locationTrueId;
      var stock = this.stockData[key];
      if (!stock) return;

      if (!stock.allow_negative_stock) {
        var rezervare = parseFloat(stock.rezervare_stock) || 0;
        var stoc = parseFloat(stock.stock) || 0;
        if (rezervare > stoc) {
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, 'rezervare_stock', stoc);
        }
      }

      __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(stock, '_dirty', true);
    },
    getCategories: function getCategories() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/category', 'GET', data, function (response) {
        if (response.status === true) {
          _this.mainCategories = response.data;
        }
      });
    },
    debouncedLoadProducts: function debouncedLoadProducts() {
      var _this2 = this;

      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(function () {
        _this2.productsPagination.page = 1;
        _this2.loadProducts();
      }, 500);
    },
    resetFilters: function resetFilters() {
      this.filters = {
        name: '',
        product_id: '',
        category_id: ''
      };
      this.productsPagination.page = 1;
      this.loadProducts();
    },
    loadProducts: function loadProducts() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.autoSave();

              case 2:

                _this3.loadingProducts = true;

                data = {
                  token: _this3.token,
                  company_id: _this3.companyId,
                  page: _this3.productsPagination.page,
                  perPage: _this3.productsPagination.perPage
                };


                if (_this3.filters.name) data.name = _this3.filters.name;
                if (_this3.filters.product_id) data.product_id = _this3.filters.product_id;
                if (_this3.filters.category_id) data.category_id = _this3.filters.category_id;

                _this3.apiRequest('/product-stocks/products', 'GET', data, function (response) {
                  if (response.status) {
                    _this3.products = response.data;
                    _this3.productsPagination = response.pagination || _this3.productsPagination;
                    _this3.initializeStockData(response.data);
                  }
                  _this3.loadingProducts = false;
                  _this3.loading = false;
                });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    initializeStockData: function initializeStockData(products) {
      var _this4 = this;

      products.forEach(function (product) {
        _this4.locations.forEach(function (location) {
          var key = product.id + '_' + location.true_id;

          var existingStock = product.stocks && product.stocks[location.true_id] ? product.stocks[location.true_id] : null;

          var isActive = !!existingStock;

          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this4.stockData, key, {
            product_id: product.id,
            location_id: location.true_id,
            active: isActive,
            stock_id: existingStock ? existingStock.id : null,
            _original_stock_id: existingStock ? existingStock.id : null,
            stock: existingStock ? existingStock.stock : 0,
            rezervare_stock: existingStock ? existingStock.rezervare_stock : 0,
            sync_gestiune: existingStock ? existingStock.sync_inventory ? true : false : false,
            decrease_stock: existingStock ? existingStock.decrease_stock ? true : false : true,
            allow_negative_stock: existingStock ? existingStock.allow_negative_stock ? true : false : true,
            active_app: existingStock ? existingStock.active_app || existingStock.active_app === 1 ? true : false : true,
            active_website: existingStock ? existingStock.active_website || existingStock.active_website === 1 ? true : false : true,
            active_qr: existingStock ? existingStock.active_qr || existingStock.active_qr === 1 ? true : false : true,
            active_kiosk: existingStock ? existingStock.active_kiosk || existingStock.active_kiosk === 1 ? true : false : true,
            active_pos: existingStock ? existingStock.active_pos || existingStock.active_pos === 1 ? true : false : true,
            _deleted: false,
            _dirty: false
          });
        });
      });
    },
    changePage: function changePage(newPage) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(newPage < 1 || newPage > _this5.productsPagination.totalPages)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return _this5.autoSave();

              case 4:

                _this5.productsPagination.page = newPage;
                _this5.loadProducts();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    autoSave: function autoSave() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                payload = _this6.buildPayload();

                if (!(!payload.products.length && !payload.products_to_delete.length)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return');

              case 3:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
                  var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
                    token: _this6.token,
                    company_id: _this6.companyId
                  }, payload);

                  _this6.apiRequest('/product-stocks/products/stocks', 'POST', data, function (response) {
                    if (response.status) {
                      payload.products.forEach(function (p) {
                        var key = p.product_id + '_' + p.location_id;
                        if (_this6.stockData[key]) {
                          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this6.stockData[key], '_dirty', false);
                        }
                      });

                      if (response.saved) {
                        response.saved.forEach(function (savedItem) {
                          if (savedItem.action === 'created') {
                            var key = savedItem.product_id + '_' + savedItem.location_id;
                            if (_this6.stockData[key]) {
                              __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this6.stockData[key], 'stock_id', savedItem.stock_id);
                              __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this6.stockData[key], '_original_stock_id', savedItem.stock_id);
                            }
                          }
                        });
                      }

                      payload.products_to_delete.forEach(function (p) {
                        var key = p.product_id + '_' + p.location_id;
                        if (_this6.stockData[key]) {
                          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this6.stockData[key], 'stock_id', null);
                          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this6.stockData[key], '_original_stock_id', null);
                        }
                      });
                    }
                    resolve(response);
                  });
                }));

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    saveStocks: function saveStocks() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var validationErrors, isValid, payload, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                validationErrors = [];

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(_this7.stockData).forEach(function (stock) {
                  if (stock.active && !stock.allow_negative_stock) {
                    var rezervare = parseFloat(stock.rezervare_stock) || 0;
                    var stoc = parseFloat(stock.stock) || 0;
                    if (rezervare > stoc) {
                      validationErrors.push('Produs ' + stock.product_id + ' - Loca\u021Bie ' + stock.location_id + ': Rezervarea dep\u0103\u0219e\u0219te stockul');
                    }
                  }
                });

                if (!(validationErrors.length > 0)) {
                  _context4.next = 5;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: '',
                  text: validationErrors.join('\n'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 3000
                });
                return _context4.abrupt('return');

              case 5:
                _context4.next = 7;
                return _this7.$validator.validateAll();

              case 7:
                isValid = _context4.sent;

                if (isValid) {
                  _context4.next = 11;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: '',
                  text: _this7.$t('validations.checkErrors'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 2000
                });
                return _context4.abrupt('return');

              case 11:

                _this7.saving = true;

                payload = _this7.buildPayload();
                data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
                  token: _this7.token,
                  company_id: _this7.companyId
                }, payload);


                _this7.apiRequest('/product-stocks/products/stocks', 'POST', data, function (response) {
                  _this7.saving = false;

                  if (response.status) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this7.stockData).forEach(function (key) {
                      __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this7.stockData[key], '_dirty', false);
                    });

                    if (response.saved) {
                      response.saved.forEach(function (savedItem) {
                        if (savedItem.action === 'created') {
                          var key = savedItem.product_id + '_' + savedItem.location_id;
                          if (_this7.stockData[key]) {
                            __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this7.stockData[key], 'stock_id', savedItem.stock_id);
                            __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this7.stockData[key], '_original_stock_id', savedItem.stock_id);
                          }
                        }
                      });
                    }

                    payload.products_to_delete.forEach(function (p) {
                      var key = p.product_id + '_' + p.location_id;
                      if (_this7.stockData[key]) {
                        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this7.stockData[key], 'stock_id', null);
                        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this7.stockData[key], '_original_stock_id', null);
                      }
                    });

                    __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                      title: '',
                      text: _this7.$t('stock.stocksSavedSuccess'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    });
                  } else {
                    console.log(response.errors);
                    if (response.errors) {
                      for (var field in response.errors) {
                        _this7.errors.add(field, response.errors[field]);
                      }
                    }

                    __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                      title: '',
                      text: response.message || _this7.$t('validations.wentWrong'),
                      type: 'error',
                      showConfirmButton: false,
                      timer: 2000
                    });
                  }
                });

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    buildPayload: function buildPayload() {
      var productsToSave = [];
      var productsToDelete = [];

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.stockData).forEach(function (stock) {
        if (stock._deleted && stock._original_stock_id) {
          productsToDelete.push({
            product_id: stock.product_id,
            location_id: stock.location_id,
            stock_id: stock._original_stock_id
          });
          return;
        }

        if (stock.active && stock._dirty) {
          productsToSave.push({
            product_id: stock.product_id,
            location_id: stock.location_id,
            stock_id: stock.stock_id,
            stock: parseFloat(stock.stock) || 0,
            rezervare_stock: parseInt(stock.rezervare_stock) || 0,
            sync_gestiune: !!stock.sync_gestiune,
            decrease_stock: !!stock.decrease_stock,
            allow_negative_stock: !!stock.allow_negative_stock,
            active_app: !!stock.active_app,
            active_website: !!stock.active_website,
            active_qr: !!stock.active_qr,
            active_kiosk: !!stock.active_kiosk,
            active_pos: !!stock.active_pos
          });
        }
      });

      return {
        products: productsToSave,
        products_to_delete: productsToDelete
      };
    },
    goToProduct: function goToProduct(prod) {
      return 0;
      this.$router.push({
        name: 'Edit Product',
        params: {
          id: prod.id,
          productData: prod,
          mainCategories: this.mainCategories
        }
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "KkTj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kkks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('user-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KsE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_sweetalert2__);






























var _components;









__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_30_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_item___default.a);
__WEBPACK_IMPORTED_MODULE_29_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_33_vue_js_modal___default.a, { componentName: 'vmodal' });

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'PPagination', __WEBPACK_IMPORTED_MODULE_32_src_components_UIComponents_Pagination_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_31_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  computed: {},
  created: function created() {
    var _this = this;

    var time = 60000;
    var databaseName = 'tapTasty_' + this.$session.get('selectedCompany');
    var versionDB = 2;
    this.openDatabaseAndReadOrCreate(databaseName, versionDB, 'menuForAdminOrder', 0);
    clearInterval(window.intervalForDatabaseCache);
    window.intervalForDatabaseCache = setInterval(function () {
      _this.openDatabaseAndReadOrCreate(databaseName, versionDB, 'menuForAdminOrder', 1);
    }, time);

    localStorage.removeItem('order_for_' + this.$session.get('selectedCompany'));
    localStorage.setItem('order_for_' + this.$session.get('selectedCompany') + '_add_tip', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(null));
    this.userData = JSON.parse(this.$session.get('userData'));
    if (this.$route.query.order_id) {
      this.isInEditMode = true;
      this.selectedOrderForEdit = parseInt(this.$route.query.order_id);
      this.getOrderForEdit();
      return 0;
    }
    if (this.$route.query.location) {
      this.supraSelectedLocation = true;
      this.selectedLocation = this.$route.query.location;
    }
    if (!document.body.classList.contains('sidebar-mini')) {
      document.body.classList.toggle('sidebar-mini');
    }
    if (!document.body.classList.contains('onPos')) {
      document.body.classList.add('onPos');
    }
    this.getUserData();
    this.filterForstatusEntered();
    this.$bus.$off('orders_pos_complete_order');
    this.$bus.$on('orders_pos_complete_order', this.ordersPosCompleteOrder);
    this.$bus.$off('completePaymentPos');
    this.$bus.$on('completePaymentPos', this.completePaymentPos);
  },
  destroyed: function destroyed() {
    clearInterval(window.intervalForDatabaseCache);
    if (document.body.classList.contains('onPos')) {
      document.body.classList.remove('onPos');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.CalendarInline && this.$refs.CalendarInline.destroyCalendar();
    localStorage.removeItem('order_for_' + this.$session.get('selectedCompany'));
    localStorage.setItem('order_for_' + this.$session.get('selectedCompany') + '_add_tip', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(null));
  },
  data: function data() {
    return {
      toGo: false,
      showCommentSection: false,
      canScrollProductList: false,
      userData: null,
      availableStatuses: [],
      timeoutTipFromClientView: null,
      tipFromClientView: null,
      selectedStatus: 'NEW',
      showStatusDropdown: 0,
      dropdownLocationActive: false,
      noDate: 0,
      selectedDate: null,
      selectedHour: null,
      curentLocation: null,
      choosenHours: null,
      how_many: 1,
      newTextTimeout: null,
      selectedCategory: null,
      loadingCompleteOrder: false,
      loadingAddRemoveRequest: 0,
      preventInfiniteLoopGetCart: 1,
      orderComent: '',
      orderClientNotification: '',
      payMethod: '',
      payment_options: [],
      posIsAvailable: false,
      cashIsAvailable: true,
      cartToken: null,
      newAdress: false,
      new_clientErrors: {
        'count': 0,
        'email': '',
        'phone': '',
        'gender': '',
        'birthdate': '',
        'firstname': '',
        'address_street': '',
        'address_number': '',
        'address_city': '',
        'address_apartment': ''
      },
      addToCartDisabled: false,
      currentProductInPopup: null,
      cart: null,
      currency: this.$session.get('selectedCompanyData')['currency_iso'],
      canAddNoClient: this.$session.get('selectedCompanyData')['print_fiscal_from_dashboard'],
      searchFilterShow: true,
      products: [],
      category: [],
      searchClient: '',
      not2timeSsearchForClient: 1,
      not2timeByPhone: 1,
      not2timeByEmail: 1,
      not2timeByName: 1,
      not2timeByName2: 1,
      not2timeById: 1,
      searchByIdPressEnter: 0,
      pickerOptions: {},
      company: [],
      availableLocations: null,
      activeMethod: null,
      selectedLocation: null,
      supraSelectedLocation: false,
      selectedOrderForEdit: null,
      isInEditMode: false,
      selectedTag: 'phone',
      availableTags: this.getOrderFormFlags(),
      client_phone_is_empty: true,
      client: null,
      new_client: {},
      existingClients: [],
      existingPhones: [],
      existingEmails: [],
      existingNames: [],
      existingNames2: [],
      existingId: [],
      showRemoveTextFromSearch: 0,
      searchText: '',
      isFullScreen: false,
      loading: false,
      defaultUser: [],
      orderCui: ''
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.$route.query.fullscreen) {
      document.body.addEventListener('click', function () {
        if (_this2.$route.query.fullscreen && !_this2.isFullScreen) {
          _this2.goFullScreen();
        }
      }, true);
    }
    this.getTipFromClientView();
  },

  methods: {
    scrollUpProductList: function scrollUpProductList() {
      var scrollAmount = this.$refs.productList.offsetHeight / 1.5;
      this.$refs.productList.scrollTop -= scrollAmount;
    },
    scrollDownProductList: function scrollDownProductList() {
      var scrollAmount = this.$refs.productList.offsetHeight / 1.5;
      this.$refs.productList.scrollTop += scrollAmount;
    },
    checkScrollProductList: function checkScrollProductList() {
      var productList = this.$refs.productList;
      if (productList) {
        this.canScrollProductList = productList.scrollHeight > productList.clientHeight;
      }
    },
    getTipFromClientView: function getTipFromClientView() {
      var _this3 = this;

      clearInterval(this.timeoutTipFromClientView);
      this.timeoutTipFromClientView = setInterval(function () {
        _this3.tipFromClientView = parseFloat(JSON.parse(localStorage.getItem('order_for_' + _this3.$session.get('selectedCompany') + '_add_tip')));
        if (_this3.cart && _this3.cart.shopping_cart_id && (_this3.tipFromClientView > 0 || _this3.tipFromClientView === 0)) {
          clearInterval(_this3.timeoutTipFromClientView);
          _this3.setTip(_this3.tipFromClientView, function (response) {
            if (response.status === true) {
              localStorage.setItem('order_for_' + _this3.$session.get('selectedCompany') + '_add_tip', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(null));
            }
            _this3.getTipFromClientView();
          });
        }
      }, 500);
    },
    getOrderForEdit: function getOrderForEdit() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        order_id: this.selectedOrderForEdit,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/get-order-for-edit', 'GET', data, function (response) {
        if (response.status === true) {
          _this4.cart = response.data;
          _this4.cartToken = response.data.shopping_cart_id;

          _this4.activeMethod = response.data.delivery_type.toLowerCase();
          _this4.selectedLocation = response.data.location.id;

          _this4.getProducts();
        }
      });
    },
    formatDate: function formatDate(date) {
      var d = new Date();
      if (date) {
        d = new Date(date);
      }
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [day, month, year].join('-');
    },
    selectedDateChange: function selectedDateChange() {
      if (!this.curentLocation.just_date_delivery_hour_usage) {
        var dayIndex = new Date(this.selectedDate).getDay();
        this.choosenHours = this.curentLocation.available_hours[dayIndex];
        this.selectedHour = this.curentLocation.available_hours[dayIndex][0];
      }
      if (this.curentLocation.offset === '0' && this.isToday(this.selectedDate)) {
        this.choosenHours = this.curentLocation.available_hours_today;
        this.selectedHour = this.curentLocation.available_hours_today[0];
      }
    },
    disabledEndDate: function disabledEndDate(date) {
      var dat = new Date(Date.now() + this.curentLocation.period_range.start * 24 * 60 * 60 * 1000);
      var year = dat.getFullYear();
      var month = dat.getMonth() + 1;
      var day = dat.getDate();

      var end = this.curentLocation.period_range.end + this.curentLocation.period_range.start - 1;

      var dat2 = new Date(Date.now() + end * 24 * 60 * 60 * 1000);
      var year2 = dat2.getFullYear();
      var month2 = dat2.getMonth() + 1;
      var day2 = dat2.getDate();

      return date.getTime() < new Date(year + '-' + month + '-' + day + ' 00:00:00').getTime() || date.getTime() > new Date(year2 + '-' + month2 + '-' + day2 + ' 00:00:00').getTime() || this.curentLocation.disabled_days.includes(date.getDay());
    },
    editOrderNow: function editOrderNow() {
      var _this5 = this;

      this.loadingCompleteOrder = true;
      var dataToBeSent = {
        token: this.$session.get('token'),
        action: 'edit_order',
        company_id: this.$session.get('selectedCompany'),
        shopping_cart_id: this.cart.shopping_cart_id,
        comments: this.orderComent,
        client_notification: this.orderClientNotification,
        add_order: true,
        edit_order: true
      };
      this.apiRequest('/update-cart', 'PUT', dataToBeSent, function (response) {
        if (response.status === true) {
          _this5.$router.push('/orders/view/' + _this5.cart.order_id);
        }
        _this5.loadingCompleteOrder = false;
      });
    },
    orderNow: function orderNow() {
      var _this6 = this;

      var payMethod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.loadingCompleteOrder = true;
      this.loading = true;
      if (payMethod > 0) {
        this.payMethod = 'pos';
        if (payMethod === 1) {
          this.payMethod = 'cash';
        }
        if (payMethod === 9) {
          this.payMethod = 'virament';
        }
      }

      this.$modal.hide('payModal');

      var errors = 0;
      if (!this.client) {
        __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
          title: '',
          text: this.$t('addOrder.errorProduct5'),
          type: 'error',
          showConfirmButton: true,
          target: document.getElementById('mySwal2'),
          toast: true
        });
        errors++;
      }
      if (this.activeMethod === 'delivery' && !this.client.address) {
        __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
          title: '',
          text: this.$t('addOrder.errorProduct7'),
          type: 'error',
          showConfirmButton: true,
          target: document.getElementById('mySwal2'),
          toast: true
        });
        errors++;
      }
      if (this.payMethod === '') {
        __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
          title: '',
          text: this.$t('addOrder.errorProduct6'),
          type: 'error',
          showConfirmButton: true,
          target: document.getElementById('mySwal2'),
          toast: true
        });
        errors++;
      }
      if (!this.selectedLocation || !this.activeMethod) {
        __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
          title: '',
          text: this.$t('addOrder.errorProduct4'),
          type: 'error',
          showConfirmButton: true,
          target: document.getElementById('mySwal2'),
          toast: true
        });
        errors++;
      }
      if (this.activeMethod !== 'eat_location' && (!this.cart || !this.cart.myCart || !this.cart.myCart.products.length)) {
        __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
          title: '',
          text: this.$t('addOrder.errorProduct3'),
          type: 'error',
          showConfirmButton: true,
          target: document.getElementById('mySwal2'),
          toast: true
        });
        errors++;
      }
      if (!errors) {
        var data2 = {
          token: this.$session.get('token'),
          action: 'product_validation',
          products_need_deleted: true,
          add_order: true,
          company_id: this.$session.get('selectedCompany'),
          shopping_cart_id: this.cart.shopping_cart_id
        };
        this.apiRequest('/update-cart', 'PUT', data2, function (response) {
          if (response.status === true) {
            if (!_this6.applyUpdateCartResponse(response)) {
              _this6.loadingCompleteOrder = false;
              _this6.loading = false;
              return;
            }
            if (_this6.activeMethod !== 'eat_location' && !_this6.cart.myCart.products.length) {
              __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
                title: '',
                text: _this6.$t('addOrder.errorProduct1'),
                type: 'error',
                showConfirmButton: true,
                target: document.getElementById('mySwal2'),
                toast: true
              });
            }
            if (response.data.some_products_deleted) {
              __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
                title: '',
                text: _this6.$t('addOrder.errorProduct1'),
                type: 'error',
                showConfirmButton: true,
                target: document.getElementById('mySwal2'),
                toast: true
              });
            }

            if (_this6.company.print_fiscal_from_dashboard && !_this6.company.is_not_waiting_for_pos_admin && payMethod) {
              var data = {
                token: _this6.$session.get('token'),
                pay_method: payMethod,
                with_pos: false,
                company_id: _this6.$session.get('selectedCompany'),
                capture_transaction_response: '',
                receipt_number: '',
                cui: _this6.orderCui,
                orderid: _this6.cart.order_id,
                total: _this6.cart.myCart.total_cart_price
              };
              if (payMethod === 2) {
                _this6.$bus.$emit('fiscalPosPayment', data);
              } else {
                _this6.completeOrder(payMethod);
              }
            } else {
              _this6.completeOrder(payMethod);
            }
            setTimeout(function () {
              _this6.printOrders();
            }, 2000);
          } else {
            _this6.loadingCompleteOrder = false;
            _this6.loading = false;
          }
        });
      } else {
        this.loadingCompleteOrder = false;
        this.loading = false;
      }
    },
    generateRaport: function generateRaport(raport) {
      var _this7 = this;

      this.loadingCompleteOrder = true;
      this.$bus.$emit('getRaport', raport);
      setTimeout(function () {
        _this7.loadingCompleteOrder = false;
      }, 2000);
    },
    ordersPosCompleteOrder: function ordersPosCompleteOrder(data) {
      if (!this.company.is_not_waiting_for_pos_admin && data.with_pos) {
        if (data) {
          this.completeOrder(data.pay_method);
        } else {
          this.loadingCompleteOrder = false;
          this.loading = false;
          __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
            title: '',
            text: this.$t('addOrder.errorProduct8'),
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          });
        }
      }
    },
    completePaymentPos: function completePaymentPos(data) {
      if (!this.company.is_not_waiting_for_pos_admin) {
        if (data) {
          this.completeOrder(data.pay_method);
        } else {
          this.loadingCompleteOrder = false;
          this.loading = false;
          __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
            title: '',
            text: this.$t('addOrder.errorProduct8'),
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          });
        }
      }
    },
    completeOrder: function completeOrder(payMethod) {
      var _this8 = this;

      if (!this.cart || !this.cart.myCart) {
        this.loadingCompleteOrder = false;
        this.loading = false;
        return;
      }
      this.loadingCompleteOrder = true;
      var oldOrderId = this.cart.order_id;
      var totalValue = this.cart.myCart.total_cart_price;
      var cid = parseInt(this.$session.get('selectedCompany'));
      if (this.toGo) {
        this.orderComent += ' ' + this.$t('addOrder.toGo');
      }
      var data2 = {
        token: this.$session.get('token'),
        action: 'complete_order',
        products_need_deleted: true,
        add_order: true,
        chosen_hour: this.selectedHour,
        chosen_date: this.formatDate(this.selectedDate),
        company_id: cid,
        shopping_cart_id: this.cart.shopping_cart_id,
        payment_type: this.payMethod,
        order_from: this.selectedTag,
        selected_status: this.selectedStatus,
        comments: this.orderComent
      };
      this.orderComent = '';
      this.toGo = false;
      this.apiRequest('/update-cart', 'PUT', data2, function (response) {
        _this8.loadingCompleteOrder = false;
        _this8.loading = false;
        if (response.status === true) {
          _this8.applyUpdateCartResponse(response);
          if (response.data && response.data.shopping_cart_id) {
            _this8.cartToken = response.data.shopping_cart_id;
          }
          localStorage.removeItem('order_for_' + data2.company_id);
          var orderId = oldOrderId || response.data && response.data.order_id;
          if (orderId) {
            if (cid === 109) {
              _this8.client = null;
              location.reload();
            } else {
              if (_this8.company.print_fiscal_from_dashboard && payMethod !== 9) {
                var data = {
                  token: _this8.$session.get('token'),
                  pay_method: payMethod,
                  with_pos: true,
                  company_id: _this8.$session.get('selectedCompany'),
                  capture_transaction_response: '',
                  receipt_number: '',
                  cui: _this8.orderCui,
                  orderid: orderId,
                  total: totalValue
                };
                if (_this8.company.is_not_waiting_for_pos_admin) {
                  data.with_pos = true;
                  if (payMethod) {
                    _this8.$bus.$emit('fiscalEvent', data);
                  }
                } else {
                  data.with_pos = false;
                  if (payMethod) {
                    _this8.$bus.$emit('fiscalEvent', data);
                  }
                }

                if (!_this8.company.flag_fast_order_from_admin) {
                  _this8.client = null;
                  _this8.$router.push('/orders/view/' + orderId);
                } else {
                  _this8.cart = null;
                  _this8.getTheCart(null, 1);
                }
              } else {
                if (_this8.company.flag_fast_order_from_admin) {
                  _this8.$router.push('/orders/view/' + orderId);
                } else {
                  _this8.client = null;
                  _this8.$router.push('/orders/view/' + orderId);
                }
              }
            }
          }
        }
      });
    },
    goToClient: function goToClient(clientId) {
      window.open('/#/customers/view/' + clientId, '_blank');
    },
    getUserData: function getUserData() {
      var _this9 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_admin: true
      };
      var url = '';
      var user = JSON.parse(this.$session.get('userData'));
      if (user.id) {
        url = '/profile/' + user.id;
      } else {
        url = '/profile/me';
      }

      this.apiRequest(url, 'GET', data, function (response) {
        if (response.status === true) {
          _this9.apiRequest('/delivery-type', 'GET', data, function (response2) {
            if (response2.status === true) {
              _this9.company = response.data[0].company;
              _this9.defaultUser = response.data[0];
              var executedChangeMethod = 0;
              if (_this9.company.flag_fast_order_from_admin) {
                _this9.selectClient(_this9.defaultUser);
                _this9.selectedTag = 'inlocation';
              } else {
                if (!_this9.client) {
                  setTimeout(function () {
                    _this9.openClientModal();
                  }, 10);
                }
              }
              if (!_this9.defaultUser.phone) {
                _this9.defaultUser.phone = _this9.company.default_order_phone;
              }
              for (var i = 0; i < _this9.company.delivery_options_labels.length; i++) {
                if (_this9.company.delivery_options_labels[i].key === 'pick_up') {
                  _this9.company.delivery_options_labels[i].active = response2.data.pickup;
                  _this9.company.delivery_options_labels[i].enabled = response2.data.pickup_enabled;

                  if (_this9.company.delivery_options_labels[i].active && _this9.company.delivery_options_labels[i].enabled && _this9.company.flag_fast_order_from_admin && !_this9.activeMethod && !executedChangeMethod) {
                    _this9.changeMethod(_this9.company.delivery_options_labels[i]);
                    executedChangeMethod = 1;
                  }
                }
                if (_this9.company.delivery_options_labels[i].key === 'delivery') {
                  _this9.company.delivery_options_labels[i].active = response2.data.delivery;
                  _this9.company.delivery_options_labels[i].enabled = response2.data.delivery_enabled;

                  if (_this9.company.delivery_options_labels[i].active && _this9.company.delivery_options_labels[i].enabled && _this9.company.flag_fast_order_from_admin && !_this9.activeMethod && !executedChangeMethod) {
                    _this9.changeMethod(_this9.company.delivery_options_labels[i]);
                    executedChangeMethod = 1;
                  }
                }
                if (_this9.company.delivery_options_labels[i].key === 'meet_half') {
                  _this9.company.delivery_options_labels[i].active = false;
                  _this9.company.delivery_options_labels[i].enabled = false;
                }
                if (_this9.company.delivery_options_labels[i].key === 'eat_location') {
                  _this9.company.delivery_options_labels[i].active = false;
                  _this9.company.delivery_options_labels[i].enabled = false;
                }
              }
            }
          });

          if (response.data[0].lastDraftOrder) {
            _this9.cartToken = response.data[0].lastDraftOrder;
          }
        }
      });
    },
    scrollToCurrent: function scrollToCurrent() {
      this.$nextTick(function () {
        var el = this.$el.getElementsByClassName('current')[0];
        if (el) {
          var container = this.$refs.tableContainerRef;
          var table = this.$refs.detailsScrollTable.$el.querySelector('.el-table__body tbody');
          var position = 1;

          for (var i = 0; i < table.children.length; i++) {
            if (table.children[i].classList.length > 1 && table.children[i].classList[1] === 'current') {
              if (i > 1) {
                position = i;
              }
            }
          }
          container.scrollTo({
            left: 0,
            top: el.clientHeight * position,
            behavior: 'smooth'
          });
        }
      });
    },
    getTheCart: function getTheCart() {
      var _this10 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var refreshOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this.loading = false;
      this.orderCui = '';
      var shoppingCartId = null;
      if (this.cart && this.cart.shopping_cart_id) {
        shoppingCartId = this.cart.shopping_cart_id;
      } else if (id) {
        shoppingCartId = id;
      }
      var data = {
        token: this.$session.get('token'),
        shopping_cart_id: shoppingCartId,
        location: this.selectedLocation,
        method: this.activeMethod,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/get-cart', 'GET', data, function (response2) {
        if (response2.status === true) {
          _this10.preventInfiniteLoopGetCart = 1;
          _this10.cart = response2.data;
          _this10.cartToken = response2.data.shopping_cart_id;
          _this10.getPaymentProfile();

          _this10.getProducts();
          if (_this10.client && _this10.activeMethod === 'pick_up') {
            _this10.selectClient(_this10.client, null, true, false);
          }
        } else {
          if (_this10.preventInfiniteLoopGetCart) {
            _this10.preventInfiniteLoopGetCart = 0;
            _this10.cart = null;
            _this10.getTheCart(null);
          }
        }
      });
    },
    getPaymentProfile: function getPaymentProfile() {
      var _this11 = this;

      var data = {
        token: this.$session.get('token'),
        add_order: true,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/paymentprofile', 'GET', data, function (response) {
        if (response.status === true) {
          _this11.payment_options = response.data.payment_options;

          _this11.posIsAvailable = !!_this11.payment_options.filter(function (opt) {
            return opt.id === 'pos';
          }).length;
          if (_this11.cashIsAvailable) {
            _this11.payMethod = 'cash';
          } else {
            _this11.payMethod = '';
          }
        }
      });
    },
    newText: function newText() {
      var _this12 = this;

      if (this.searchText.length >= 1) {
        this.showRemoveTextFromSearch = 1;
      } else {
        this.showRemoveTextFromSearch = 0;
      }
      if (!this.loading) {
        if (this.newTextTimeout) clearTimeout(this.newTextTimeout);
        this.newTextTimeout = setTimeout(function () {
          _this12.getProducts(null, _this12.searchText);
        }, 1000);
      }
    },
    deleteTextFromSearch: function deleteTextFromSearch() {
      this.searchText = '';
      this.showRemoveTextFromSearch = 0;
      this.getProducts();
    },
    deleteTextFromClientSearch: function deleteTextFromClientSearch() {
      this.searchClient = '';
      this.existingClients = [];
    },
    changeDeliveryStatus: function changeDeliveryStatus(statusUsed, deliveryType) {
      if (statusUsed === 'DELIVERED' && deliveryType === 'EAT_LOCATION') {
        statusUsed = 'reservedReady';
        return this.$t('ordersStatus.' + statusUsed);
      }
      if (statusUsed === 'DELIVERED' && deliveryType === 'PICK_UP') {
        statusUsed = 'completedReady';
        return this.$t('ordersStatus.' + statusUsed);
      }
      if (statusUsed === 'DELIVERED' && (deliveryType === 'MEET_HALF' || deliveryType === 'DELIVERY')) {
        statusUsed = 'deliveredReady';
        return this.$t('ordersStatus.' + statusUsed);
      }
      return this.$t('ordersStatus.' + statusUsed);
    },
    goFullScreen: function goFullScreen() {
      var element = document.querySelector('.ordersposContainer');
      if (this.isFullScreen) {
        document.exitFullscreen();
        this.isFullScreen = false;
      } else {
        this.isFullScreen = true;
        this.requestFullScreen(element);
      }
    },
    requestFullScreen: function requestFullScreen(element) {
      var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
      if (requestMethod) {
        requestMethod.call(element);
      } else if (window.ActiveXObject && typeof window.ActiveXObject !== 'undefined') {
        var wscript = new ActiveXObject('WScript.Shell');
        if (wscript !== null) {
          wscript.SendKeys('{F11}');
        }
      }
    },
    searchBtn: function searchBtn() {
      var _this13 = this;

      this.searchFilterShow = !this.searchFilterShow;
      if (!this.searchFilterShow) {
        this.deleteTextFromSearch();
      } else {
        this.$nextTick(function () {
          _this13.$refs.searchText.focus();
        });
      }
    },
    getProducts: function getProducts() {
      var _this14 = this;

      var categoryID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.selectedCategory = categoryID;
      this.loading = true;
      var data2 = {
        with_cache: true,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_id: this.selectedLocation,
        delivery_method: this.activeMethod
      };
      if (categoryID) {
        data2.category_id = categoryID;
        this.searchText = '';

        this.showRemoveTextFromSearch = 0;
      }
      if (search) {
        data2.search = search;
      }
      this.apiRequest('/admin-order-products', 'GET', data2, function (response) {
        if (response.status === true) {
          _this14.category = response.data.categories;
          _this14.products = response.data.products;
          _this14.openAllProducts(response.data.products);
          if (!categoryID && !search) {
            _this14.selectedCategory = _this14.category[0].id;
          }
          setTimeout(function () {
            _this14.checkScrollProductList();
          }, 1);
          _this14.loading = false;
        }
      });
    },
    openAllProducts: function openAllProducts(productsFromRequest) {
      if (productsFromRequest.length) {
        var timeTimeout = 0;
        for (var i = 0; i < productsFromRequest.length; i++) {
          if (i > 30) {
            return 0;
          }
          if (productsFromRequest[i]) {
            timeTimeout += 500;
            this.getProductsForCache(productsFromRequest[i], timeTimeout);
          }
        }
      }
    },
    getProductsForCache: function getProductsForCache(product, timeTimeout) {
      var _this15 = this;

      setTimeout(function () {
        _this15.openProduct(product, null, null, null, true);
      }, timeTimeout);
    },
    addProductDirectlyToCart: function addProductDirectlyToCart(prod) {
      var _this16 = this;

      if (prod.has_product_options) {
        this.openProduct(prod, 0, 0, function () {});
      } else {
        this.openProduct(prod, 0, 1, function () {
          _this16.addToCart();
        });
      }
    },
    openProduct: function openProduct(prod) {
      var edit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var noModal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var _this17 = this;

      var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var forCacheOnly = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var i = 0;
      var data2 = {
        with_cache: true,
        token: this.$session.get('token'),
        from_admin: true
      };
      if (edit) {
        data2.with_cache = false;
        data2.add_order = true;
        data2.index = prod.index;
        data2.shopping_cart_id = this.cart.shopping_cart_id;
        if (this.isInEditMode) {
          data2.edit_order = true;
        }
      }
      var extraParam = '?deliveryMethod=' + this.activeMethod + '&location=' + this.selectedLocation;

      this.apiRequest('product/' + prod.id + extraParam, 'GET', data2, function (resp) {
        if (!forCacheOnly) {
          _this17.currentProductInPopup = resp.data[0];
          if (edit) {
            _this17.currentProductInPopup.index = prod.index;
            _this17.currentProductInPopup.product_options = _this17.currentProductInPopup.categories;
            _this17.currentProductInPopup.in_edit = true;
            _this17.currentProductInPopup.order_part_item_id = _this17.currentProductInPopup.order_part_item_id;
            _this17.currentProductInPopup.kds_section_id = _this17.currentProductInPopup.kds_section_id;
            _this17.currentProductInPopup.image_url = [];
            _this17.currentProductInPopup.image_url[0] = { 'url': _this17.currentProductInPopup.image };
            if (_this17.currentProductInPopup.product_options.length) {
              for (i = _this17.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
                _this17.currentProductInPopup.product_options[i].values = _this17.currentProductInPopup.product_options[i].options;
                _this17.currentProductInPopup.product_options[i].name = _this17.currentProductInPopup.product_options[i].title;
                _this17.currentProductInPopup.product_options[i].min_no = _this17.currentProductInPopup.product_options[i].min;
                _this17.currentProductInPopup.product_options[i].max_no = _this17.currentProductInPopup.product_options[i].max;
                if (_this17.currentProductInPopup.product_options[i].values.length) {
                  for (var j = _this17.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
                    _this17.currentProductInPopup.product_options[i].values[j].label = _this17.currentProductInPopup.product_options[i].values[j].name;
                    if (_this17.currentProductInPopup.product_options[i].type === 'radio') {
                      if (_this17.currentProductInPopup.product_options[i].values[j].checked) {
                        _this17.currentProductInPopup.product_options[i].checked = _this17.currentProductInPopup.product_options[i].values[j].id;
                      }
                    }
                  }
                }
              }
            }
          }

          _this17.updateCategories();

          if (!noModal) {
            _this17.$modal.show('productModal');
          }
        }
        if (callback) {
          callback();
        }
      });
    },
    updateQuantity: function updateQuantity(prod, add) {
      if (prod.quantity >= 1) {
        if (add) {
          prod.quantity++;
        } else {
          if (prod.quantity > 1) {
            prod.quantity--;
          }
        }
      }
      this.updateCategories();
    },
    updateCategories: function updateCategories() {
      var sumToBeAdded = 0;
      if (this.currentProductInPopup.product_options.length) {
        for (var i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
          this.currentProductInPopup.product_options[i].optionsSelected = [];
          if (this.currentProductInPopup.product_options[i].values.length) {
            for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
              if (this.currentProductInPopup.product_options[i].type === 'radio') {
                if (this.currentProductInPopup.product_options[i].checked === this.currentProductInPopup.product_options[i].values[j].id) {
                  sumToBeAdded += parseFloat(this.currentProductInPopup.product_options[i].values[j].price);
                  this.currentProductInPopup.product_options[i].optionsSelected[0] = this.currentProductInPopup.product_options[i].values[j].id;
                  this.currentProductInPopup.product_options[i].values[j].checked = true;
                } else {
                  this.currentProductInPopup.product_options[i].values[j].checked = false;
                }
              }
              if (this.currentProductInPopup.product_options[i].type === 'checkbox' && this.currentProductInPopup.product_options[i].values[j].checked) {
                sumToBeAdded += parseFloat(this.currentProductInPopup.product_options[i].values[j].price);
              }
              if (this.currentProductInPopup.product_options[i].type === 'checkbox') {
                if (this.currentProductInPopup.product_options[i].values[j].checked) {
                  this.currentProductInPopup.product_options[i].optionsSelected.push(this.currentProductInPopup.product_options[i].values[j].id);
                }
              }
              if (this.currentProductInPopup.product_options[i].type === 'upload') {
                var asd = this.currentProductInPopup.product_options[i].values[j].id;
                if (this.$refs[asd] && this.$refs[asd][0] && this.$refs[asd][0].files && this.$refs[asd][0].files[0]) {
                  this.setImage(this.$refs[asd][0].files[0], i, j);
                  sumToBeAdded += parseFloat(this.currentProductInPopup.product_options[i].values[j].price);
                  this.currentProductInPopup.product_options[i].optionsSelected.push(this.currentProductInPopup.product_options[i].values[j].id);
                } else {}
                if (!(this.$refs[asd] && this.$refs[asd][0] && this.$refs[asd][0].files && this.$refs[asd][0].files[0]) && this.currentProductInPopup.product_options[i].values[j].checked) {
                  this.currentProductInPopup.product_options[i].optionsSelected.push(this.currentProductInPopup.product_options[i].values[j].id);
                }
              }
              if (this.currentProductInPopup.product_options[i].values[j].checked) {
                this.currentProductInPopup.product_options[i].values[j].checked = true;
              } else {
                this.currentProductInPopup.product_options[i].values[j].checked = false;
              }
            }
          }
        }
      }
      this.currentProductInPopup.price_details.price = parseFloat(this.currentProductInPopup.price) * parseFloat(this.currentProductInPopup.quantity);
      this.currentProductInPopup.price_details.price = this.currentProductInPopup.price_details.price + parseFloat(sumToBeAdded) * parseFloat(this.currentProductInPopup.quantity);
      this.currentProductInPopup.price_details.price = parseFloat(this.currentProductInPopup.price_details.price).toFixed(2);

      if (this.company.is_required_options_for_admin_order) {
        var verifyCart = 1;
        if (this.currentProductInPopup.product_options.length) {
          for (i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
            if (this.currentProductInPopup.product_options[i].min_no) {
              if (!(parseInt(this.currentProductInPopup.product_options[i].min_no) <= this.currentProductInPopup.product_options[i].optionsSelected.length)) {
                verifyCart = 0;
              }
            }
            if (this.currentProductInPopup.product_options[i].max_no) {
              if (!(parseInt(this.currentProductInPopup.product_options[i].max_no) >= this.currentProductInPopup.product_options[i].optionsSelected.length)) {
                verifyCart = 0;
              }
            }
          }
        }
        if (verifyCart) {
          this.addToCartDisabled = false;
        } else {
          this.addToCartDisabled = true;
        }
      }
    },
    setImage: function setImage(img, i, j) {
      var self = this;
      this.getBase64(img).then(function (base64enc) {
        self.currentProductInPopup.product_options[i].values[j].checked = true;
        self.currentProductInPopup.product_options[i].values[j].file = base64enc;
        var cv = self.currentProductInPopup;
        self.currentProductInPopup = null;
        self.currentProductInPopup = cv;
      });
    },
    removeImage: function removeImage(optionIdx, valuesIdx) {
      var asd = this.currentProductInPopup.product_options[optionIdx].values[valuesIdx].id;
      this.$refs[asd][0].value = '';

      this.currentProductInPopup.product_options[optionIdx].values[valuesIdx].checked = false;
      this.currentProductInPopup.product_options[optionIdx].values[valuesIdx].file = null;

      this.updateCategories();
    },
    modificationsInCart: function modificationsInCart() {
      if (!this.cart || !this.cart.myCart) {
        return;
      }
      localStorage.setItem('order_for_' + this.$session.get('selectedCompany'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.cart));
      if (this.cart.myCart.total_cart_price <= 0) {
        this.payMethod = 'free';
      } else if (this.payMethod === 'free') {
        if (this.cashIsAvailable) {
          this.payMethod = 'cash';
        } else {
          this.payMethod = '';
        }
      }
    },
    applyUpdateCartResponse: function applyUpdateCartResponse(response) {
      var refreshIfIncomplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (response && response.data && response.data.myCart) {
        this.cart = response.data;
        this.modificationsInCart();
        return true;
      }
      if (refreshIfIncomplete && this.cart && this.cart.shopping_cart_id) {
        this.getTheCart(this.cart.shopping_cart_id);
      }
      return false;
    },
    addToCart: function addToCart() {
      var _this18 = this;

      this.currentProductInPopup.categories = this.currentProductInPopup.product_options;

      for (var i = this.currentProductInPopup.categories.length - 1; i >= 0; i--) {
        this.currentProductInPopup.categories[i].options = this.currentProductInPopup.product_options[i].values;
        for (var j = this.currentProductInPopup.categories[i].options.length - 1; j >= 0; j--) {
          this.currentProductInPopup.categories[i].options[j].name = this.currentProductInPopup.categories[i].options[j].name;
        }
      }
      this.loadingAddRemoveRequest++;
      var data2 = {
        token: this.$session.get('token'),
        action: 'add',
        add_order: true,
        edit_order: this.isInEditMode,
        company_id: this.$session.get('selectedCompany'),
        shopping_cart_id: this.cart.shopping_cart_id,
        product: this.currentProductInPopup
      };
      this.apiRequest('/update-cart', 'PUT', data2, function (response) {
        if (response.status === true) {
          _this18.cart = response.data;
          _this18.modificationsInCart();
        }
        _this18.loadingAddRemoveRequest--;
      });
      this.$modal.hide('productModal');
    },
    editToCart: function editToCart() {
      var _this19 = this;

      this.currentProductInPopup.categories = this.currentProductInPopup.product_options;

      for (var i = this.currentProductInPopup.categories.length - 1; i >= 0; i--) {
        this.currentProductInPopup.categories[i].options = this.currentProductInPopup.product_options[i].values;
        for (var j = this.currentProductInPopup.categories[i].options.length - 1; j >= 0; j--) {
          this.currentProductInPopup.categories[i].options[j].name = this.currentProductInPopup.categories[i].options[j].label;
        }
      }

      var data2 = {
        token: this.$session.get('token'),
        action: 'edit',
        add_order: true,
        edit_order: this.isInEditMode,
        company_id: this.$session.get('selectedCompany'),
        shopping_cart_id: this.cart.shopping_cart_id,
        product_cart_index: this.currentProductInPopup.index,
        products_need_deleted: true,
        product: this.currentProductInPopup
      };
      this.loadingAddRemoveRequest++;
      this.apiRequest('/update-cart', 'PUT', data2, function (response) {
        if (response.status === true) {
          _this19.cart = response.data;
          _this19.modificationsInCart();
        }
        _this19.loadingAddRemoveRequest--;
      });
      this.$modal.hide('productModal');
    },
    editToCartUpdateQuantity: function editToCartUpdateQuantity(quantity, productId, productIndex) {
      var _this20 = this;

      var data2 = {
        token: this.$session.get('token'),
        action: 'update_quantity',
        add_order: true,
        edit_order: this.isInEditMode,
        company_id: this.$session.get('selectedCompany'),
        shopping_cart_id: this.cart.shopping_cart_id,
        quantity: quantity,
        product_id: productId,
        product_index: productIndex,
        products_need_deleted: true
      };
      if (quantity >= 1) {
        this.loadingAddRemoveRequest++;
        this.apiRequest('/update-cart', 'PUT', data2, function (response) {
          if (response.status === true) {
            _this20.cart = response.data;
            _this20.modificationsInCart();
          }
          _this20.loadingAddRemoveRequest--;
        });
      }
    },
    modifyProduct: function modifyProduct(prod) {
      this.openProduct(prod, true);
    },
    changePrice: function changePrice() {
      var _this21 = this;

      __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
        title: this.$t('addOrder.titlePopupPriceModify'),
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: this.$t('addOrder.btnPopup'),
        showLoaderOnConfirm: true,
        target: document.getElementById('mySwal2')
      }).then(function (val) {
        _this21.currentProductInPopup.price_details.price = parseFloat(val) * _this21.currentProductInPopup.quantity;
        _this21.currentProductInPopup.price = parseFloat(val);
        _this21.currentProductInPopup.edit_price = true;

        __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default.a.close();
      });
    },
    deleteProductPopup: function deleteProductPopup(prodId, index) {
      var _this22 = this;

      if (this.isInEditMode) {
        __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
          text: this.$t('addOrder.areYouSureDelete'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        }).then(function (result) {
          if (result) {
            _this22.deleteProduct(prodId, index);
          }
        });
      } else {
        this.deleteProduct(prodId, index);
      }
    },
    deleteProduct: function deleteProduct(prodId, index) {
      var _this23 = this;

      var data2 = {
        token: this.$session.get('token'),
        action: 'remove_product',
        add_order: true,
        edit_order: this.isInEditMode,
        product_id: prodId,
        product_index: index,
        company_id: this.$session.get('selectedCompany'),
        products_need_deleted: true,
        shopping_cart_id: this.cart.shopping_cart_id
      };
      this.loadingAddRemoveRequest++;
      this.apiRequest('/update-cart', 'PUT', data2, function (response) {
        if (response.status === true) {
          _this23.cart = response.data;
          _this23.modificationsInCart();
        }
        _this23.loadingAddRemoveRequest--;
      });
    },
    emptyCart: function emptyCart() {
      var _this24 = this;

      var data2 = {
        token: this.$session.get('token'),
        action: 'empty_order',
        add_order: true,
        company_id: this.$session.get('selectedCompany'),
        products_need_deleted: true,
        shopping_cart_id: this.cart.shopping_cart_id
      };
      this.loadingAddRemoveRequest++;
      this.apiRequest('/update-cart', 'PUT', data2, function (response) {
        if (response.status === true) {
          _this24.cart = response.data;
          _this24.modificationsInCart();
        }
        _this24.loadingAddRemoveRequest--;
      });
    },
    openClientModal: function openClientModal() {
      var _this25 = this;

      this.$modal.show('userModal');
      setTimeout(function () {
        _this25.$refs.clientIdRef.focus();
      }, 10);
    },
    openAdressModal: function openAdressModal() {
      var _this26 = this;

      setTimeout(function () {
        if (_this26.$session.get('selectedCompany') === 39 || _this26.$session.get('selectedCompany') === 30) {
          _this26.new_client = {};
          _this26.new_client.address_city = 'Oradea';
          _this26.new_client.address_county = 'Bihor';
        }
        if (_this26.$session.get('selectedCompany') === 109) {
          _this26.new_client = {};
          _this26.new_client.address_city = 'Drobeta-Turnu Severin';
          _this26.new_client.address_county = 'Mehedinti';
        }
        if (_this26.$session.get('selectedCompany') === 38) {
          _this26.new_client = {};
          _this26.new_client.address_city = 'Ștefăneștii de Jos';
          _this26.new_client.address_county = 'Bucuresti';
        }
      }, 10);
      this.$modal.show('adressModal');
    },
    selectClient: function selectClient(client) {
      var adress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var _this27 = this;

      var $addPerOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var $getCartAfter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      this.client = client;
      if (this.client && this.client.phone !== '') {
        this.client_phone_is_empty = false;
      } else {
        this.client_phone_is_empty = true;
      }
      this.client.newAdress = null;
      this.newAdress = false;
      this.searchClient = '';
      this.existingClients = [];
      this.existingPhones = [];
      this.existingEmails = [];
      this.existingNames = [];
      this.existingNames2 = [];
      this.existingId = [];

      this.new_client = {};

      if ($addPerOrder) {
        if (adress) {
          this.client.address = adress;
        } else {
          this.client.address = this.client.addresses[0];
        }
        var data2 = {
          token: this.$session.get('token'),
          order_from_admin: 1,
          for_user: this.client.id,
          chosen_restaurant_id: this.selectedLocation,
          shopping_cart_id: this.cart.shopping_cart_id,
          add_order: true,
          chosen_address: this.client.address,
          company_id: this.$session.get('selectedCompany'),
          save_address: false,
          phone: this.client.phone || null,
          type: this.activeMethod.toUpperCase()
        };
        if (this.activeMethod.toUpperCase() === 'EAT_LOCATION') {
          data2.how_many = this.how_many;
        }
        this.apiRequest('/delivery-type', 'POST', data2, function (response) {
          if (response.status === true) {
            if ($getCartAfter) {
              _this27.getTheCart();
            }
          } else {
            _this27.client = null;
            if (response.errors) {
              __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
                title: '',
                text: response.errors[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.errors)[0]],
                type: 'error',
                showConfirmButton: true,
                target: document.getElementById('mySwal2'),
                toast: true
              });
            }
          }
        });
      }
    },
    addNewClient: function addNewClient() {
      this.client = null;
      this.newAdress = false;
      this.new_client = {};
      this.new_clientErrors = {
        'count': 0,
        'email': '',
        'phone': '',
        'firstname': '',
        'address_street': '',
        'address_number': '',
        'address_apartment': '',
        'address_city': '',
        'address_county': ''
      };
    },
    addClient: function addClient() {
      var _this28 = this;

      this.new_clientErrors = {
        'count': 0,
        'email': '',
        'phone': '',
        'firstname': ''
      };
      var email = /\S+@\S+\.\S+/;
      if (this.new_client.email && this.new_client.email !== '' && !email.test(this.new_client.email)) {
        this.new_clientErrors.email = 'red';
        this.new_clientErrors.count++;
      }
      if (typeof this.new_client.firstname === 'undefined' || this.new_client.firstname === '') {
        this.new_client.firstname = '';
      }
      if (typeof this.new_client.phone === 'undefined' || this.new_client.phone === '') {
        this.new_clientErrors.phone = 'red';
        this.new_clientErrors.count++;
      }
      if (this.new_clientErrors.count) {
        return;
      }
      this.loading = true;
      var data2 = {
        token: this.$session.get('token'),
        cartId: this.cartToken,
        email: this.new_client.email,
        firstname: this.new_client.firstname,
        lastname: this.new_client.lastname,
        phone: this.new_client.phone,
        birthdate: this.new_client.birthdate,
        gender: this.new_client.gender,
        add_account: this.new_client.add_account,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/add-new-client', 'POST', data2, function (response) {
        if (response.status === true) {
          _this28.client = response.data.client;

          _this28.$modal.hide('userModal');
        } else {
          var err = '';
          if (response.errors.code) {
            err = response.errors.code;
          }

          __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
            title: 'Error',
            text: err,
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          });
        }
        _this28.loading = false;
      });
    },
    saveClient: function saveClient() {
      var _this29 = this;

      this.loading = true;
      var data2 = {
        token: this.$session.get('token'),
        cartId: this.cartToken,
        client: this.client,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/add-client', 'POST', data2, function (response) {
        if (response.status === true) {
          _this29.client = response.data.client;

          _this29.$modal.hide('userModal');
        } else {
          var err = 'error';

          __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
            title: '',
            text: err,
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          });
        }
        _this29.loading = false;
      });
    },
    deleteAdress: function deleteAdress(adressId) {
      var _this30 = this;

      __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
        text: this.$t('addOrder.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        _this30.loading = true;
        var data = {
          token: _this30.$session.get('token'),
          add_order: true,
          client_id: _this30.client.id,
          company_id: _this30.$session.get('selectedCompany')
        };
        _this30.apiRequest('/address/' + adressId, 'DELETE', data, function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
              title: '',
              text: _this30.$t('addOrder.adressDeleted'),
              type: 'success',
              showConfirmButton: true,
              target: document.getElementById('mySwal2'),
              toast: true
            });
            _this30.saveClient();
          } else {
            var err = 'error';
            __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
              title: '',
              text: err,
              type: 'error',
              showConfirmButton: true,
              target: document.getElementById('mySwal2'),
              toast: true
            });
          }
          _this30.loading = false;
        });
      });
    },
    selectAdress: function selectAdress(adress) {
      var _this31 = this;

      this.loading = true;
      this.new_clientErrors = {
        'count': 0,
        'address_street': '',
        'address_number': '',
        'address_apartment': '',
        'address_city': '',
        'address_county': ''
      };
      var data2 = {
        token: this.$session.get('token'),
        cart_id: this.cartToken,
        client_id: this.client.id,
        adress_id: adress.id,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/select-address', 'POST', data2, function (response) {
        if (response.status === true) {
          _this31.selectClient(response.data.client, response.data.client.address, true);
        } else {
          var err = '';
          if (response.errors.notInRange) {
            err = _this31.$t('addOrder.adressNotInRange');
          } else {
            err = _this31.$t('addOrder.adressNotCorect');
          }
          __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
            title: '',
            text: err,
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          });
        }
        _this31.loading = false;
      });
    },
    addNewAdress: function addNewAdress() {
      this.newAdress = false;
      this.client.address = null;
      this.new_clientErrors = {
        'count': 0,
        'address_street': '',
        'address_number': '',
        'address_apartment': '',
        'address_city': '',
        'address_county': ''
      };
    },
    addAddress: function addAddress() {
      var _this32 = this;

      this.new_clientErrors = {
        'count': 0,
        'address_street': '',
        'address_number': '',
        'address_apartment': '',
        'address_city': '',
        'address_county': ''
      };
      if (this.activeMethod === 'delivery') {
        if (typeof this.new_client.address_street === 'undefined' || this.new_client.address_street === '') {
          this.new_clientErrors.address_street = 'red';
          this.new_clientErrors.count++;
        }
        if (typeof this.new_client.address_number === 'undefined' || this.new_client.address_number === '') {
          this.new_clientErrors.address_number = 'red';
          this.new_clientErrors.count++;
        }
        if (typeof this.new_client.address_apartment === 'undefined' || this.new_client.address_apartment === '') {
          this.new_clientErrors.address_apartment = 'red';
          this.new_clientErrors.count++;
        }
        if (typeof this.new_client.address_city === 'undefined' || this.new_client.address_city === '') {
          this.new_clientErrors.address_city = 'red';
          this.new_clientErrors.count++;
        }
        if (typeof this.new_client.address_county === 'undefined' || this.new_client.address_county === '') {
          this.new_clientErrors.address_county = 'red';
          this.new_clientErrors.count++;
        }
      }
      if (this.new_clientErrors.count) {
        return;
      }
      this.loading = true;
      var data2 = {
        token: this.$session.get('token'),
        cart_id: this.cartToken,
        client_id: this.client.id,
        address_street: this.new_client.address_street,
        address_number: this.new_client.address_number,
        address_county: this.new_client.address_county,
        address_city: this.new_client.address_city,
        address_apartment: this.new_client.address_apartment,
        address_name: this.new_client.address_name,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/add-new-adress', 'POST', data2, function (response) {
        if (response.status === true) {
          _this32.client = response.data.client;
          _this32.selectClient(response.data.client, response.data.client.address, true);
          _this32.$modal.hide('adressModal');
        } else {
          var err = '';
          if (response.errors.notInRange) {
            err = _this32.$t('addOrder.adressNotInRange');
          } else {
            err = _this32.$t('addOrder.adressNotCorect');
          }
          __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
            title: '',
            text: err,
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          });
        }
        _this32.loading = false;
      });
    },
    editAddress: function editAddress() {
      var _this33 = this;

      this.loading = true;
      var data2 = {
        token: this.$session.get('token'),
        cart_id: this.cartToken,
        client: this.client,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/edit-adress', 'POST', data2, function (response) {
        if (response.status === true) {
          _this33.client = response.data.client;
          _this33.selectClient(response.data.client, response.data.client.address, true);
          _this33.$modal.hide('adressModal');
        } else {
          var err = '';
          if (response.errors.notInRange) {
            err = _this33.$t('addOrder.adressNotInRange');
          } else {
            err = _this33.$t('addOrder.adressNotCorect');
          }
          __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
            title: '',
            text: err,
            type: 'error',
            showConfirmButton: true,
            target: document.getElementById('mySwal2'),
            toast: true
          });
        }
        _this33.loading = false;
      });
    },
    searchForClient: function searchForClient() {
      var _this34 = this;

      if (this.not2timeSsearchForClient) {
        if (this.searchClient === '') {
          this.existingClients = [];
        } else {
          this.existingPhones = [];
          this.existingEmails = [];
          this.existingNames = [];
          this.existingNames2 = [];
          this.existingId = [];
          this.not2timeSsearchForClient = 0;
          setTimeout(function () {
            var data2 = {
              search: _this34.searchClient,
              token: _this34.$session.get('token'),
              company_id: _this34.$session.get('selectedCompany')
            };
            _this34.apiRequest('/search-for-client', 'GET', data2, function (response) {
              if (response.status === true) {
                _this34.existingClients = response.data.clients;
              }
              _this34.not2timeSsearchForClient = 1;
            });
          }, 500);
        }
      }
    },
    autocompletePhone: function autocompletePhone() {
      var _this35 = this;

      var dataToBeSent = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (this.supraSelectedLocation && this.selectedLocation) {
        dataToBeSent.location_token = this.selectedLocation;
      }
      this.apiRequest('/autocomplete-phone', 'GET', dataToBeSent, function (response) {
        if (response.status === true) {
          if (response.data.clients.length === 1) {
            _this35.selectClient(response.data.clients[0]);
          } else {
            _this35.existingPhones = response.data.clients;
            _this35.new_client.phone = response.data.phone;
          }
        }
        _this35.not2timeByPhone = 1;
      });
    },
    searchByPhone: function searchByPhone() {
      var _this36 = this;

      if (this.not2timeByPhone) {
        if (this.new_client.phone === '') {
          this.existingPhones = [];
        } else {
          this.not2timeByPhone = 0;
          this.existingClients = [];
          this.existingEmails = [];
          this.existingNames = [];
          this.existingNames2 = [];
          this.existingId = [];
          setTimeout(function () {
            var data2 = {
              search: _this36.new_client.phone,
              token: _this36.$session.get('token'),
              company_id: _this36.$session.get('selectedCompany')
            };
            _this36.apiRequest('/search-by-phone', 'GET', data2, function (response) {
              if (response.status === true) {
                _this36.existingPhones = response.data.clients;
              }
              _this36.not2timeByPhone = 1;
            });
          }, 500);
        }
      }
    },
    searchByEmail: function searchByEmail() {
      var _this37 = this;

      if (this.not2timeByEmail) {
        if (this.new_client.email === '') {
          this.existingEmails = [];
        } else {
          this.not2timeByEmail = 0;
          this.existingClients = [];
          this.existingPhones = [];
          this.existingNames = [];
          this.existingNames2 = [];
          this.existingId = [];
          setTimeout(function () {
            var data2 = {
              search: _this37.new_client.email,
              token: _this37.$session.get('token'),
              company_id: _this37.$session.get('selectedCompany')
            };
            _this37.apiRequest('/search-by-email', 'GET', data2, function (response) {
              if (response.status === true) {
                _this37.existingEmails = response.data.clients;
              }
              _this37.not2timeByEmail = 1;
            });
          }, 500);
        }
      }
    },
    searchByName: function searchByName() {
      var _this38 = this;

      if (this.not2timeByName) {
        if (this.new_client.firstname === '') {
          this.existingNames = [];
        } else {
          this.not2timeByName = 0;
          this.existingClients = [];
          this.existingPhones = [];
          this.existingEmails = [];
          this.existingNames2 = [];
          this.existingId = [];
          setTimeout(function () {
            var data2 = {
              search: _this38.new_client.firstname,
              token: _this38.$session.get('token'),
              company_id: _this38.$session.get('selectedCompany')
            };
            _this38.apiRequest('/search-by-firstname', 'GET', data2, function (response) {
              if (response.status === true) {
                _this38.existingNames = response.data.clients;
              }
              _this38.not2timeByName = 1;
            });
          }, 500);
        }
      }
    },
    searchByName2: function searchByName2() {
      var _this39 = this;

      if (this.not2timeByName2) {
        if (this.new_client.lastname === '') {
          this.existingNames2 = [];
        } else {
          this.not2timeByName2 = 0;
          this.existingClients = [];
          this.existingPhones = [];
          this.existingEmails = [];
          this.existingNames = [];
          this.existingId = [];
          setTimeout(function () {
            var data2 = {
              search: _this39.new_client.lastname,
              token: _this39.$session.get('token'),
              company_id: _this39.$session.get('selectedCompany')
            };
            _this39.apiRequest('/search-by-lastname', 'GET', data2, function (response) {
              if (response.status === true) {
                _this39.existingNames2 = response.data.clients;
              }
              _this39.not2timeByName2 = 1;
            });
          }, 500);
        }
      }
    },
    searchById: function searchById(event) {
      var _this40 = this;

      if (event.keyCode === 13) {
        this.searchByIdPressEnter = 1;
      }
      if (this.not2timeById) {
        if (this.new_client.lastname === '') {
          this.existingId = [];
        } else {
          this.not2timeById = 0;
          this.existingClients = [];
          this.existingPhones = [];
          this.existingEmails = [];
          this.existingNames = [];
          this.existingNames2 = [];
          setTimeout(function () {
            var data2 = {
              search: _this40.new_client.id,
              token: _this40.$session.get('token'),
              company_id: _this40.$session.get('selectedCompany')
            };
            _this40.apiRequest('/search-by-id', 'GET', data2, function (response) {
              if (response.status === true) {
                _this40.existingId = response.data.clients;


                if (_this40.searchByIdPressEnter && _this40.existingId.length) {
                  _this40.selectClient(_this40.existingId[0]);
                }
                _this40.searchByIdPressEnter = 0;
              }
              _this40.not2timeById = 1;
            });
          }, 500);
        }
      }
    },
    changeMethod: function changeMethod(method) {
      var _this41 = this;

      this.category = {};
      this.products = {};
      if (!this.supraSelectedLocation) {
        this.selectedLocation = null;
      }
      this.availableLocations = [];
      this.client.address = null;

      var newMethod = method.key;
      if (newMethod === 'pick_up') {
        newMethod = 'pickup';
      }
      if (newMethod === 'meet_half') {
        newMethod = 'half_way';
      }
      if (newMethod === 'eat_location') {
        newMethod = 'reserve';
      }
      var data2 = {
        token: this.$session.get('token'),
        add_order: true,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('delivery-type-details/' + newMethod, 'GET', data2, function (response) {
        if (response.status === true) {
          _this41.activeMethod = method.key;
          _this41.availableLocations = response.data.restaurants;

          setTimeout(function () {
            _this41.selectedLocationChanged(response.data.restaurants[0]);
          }, 10);
        }
      });
    },
    selectedLocationChanged: function selectedLocationChanged(loc) {
      this.dropdownLocationActive = false;
      if (!this.supraSelectedLocation) {
        this.selectedLocation = loc.id;
      }
      this.category = {};
      this.products = {};
      this.client.address = null;
      if (this.selectedLocation) {
        this.getTheCart(null);
      }
      if (this.availableLocations.length) {
        this.curentLocation = loc;

        if (this.curentLocation && this.curentLocation.length) {
          this.curentLocation = this.curentLocation[0];
        }
        if (this.curentLocation.offset === '0' && this.curentLocation.period === '1' || this.curentLocation.offset === 0 && this.curentLocation.period === 1) {
          this.noDate = 1;
          this.choosenHours = this.curentLocation.available_hours_today;
          this.selectedHour = this.curentLocation.available_hours_today[0];
        } else {
          this.noDate = 0;
        }
        if (this.curentLocation.hour_and_date_delivery_hour_usage && !this.noDate || this.curentLocation.just_date_delivery_hour_usage) {
          var startSplit = this.curentLocation.period_range.start_day.split('-');
          var startSplitDay = startSplit[0].substring(0, 1) === '0' ? startSplit[0].substring(1, 2) : startSplit[0];
          var startSplitMounth = startSplit[1].substring(0, 1) === '0' ? startSplit[1].substring(1, 2) : startSplit[1];
          var startSplitYear = startSplit[2];
          var getStart = startSplitYear + '/' + startSplitMounth + '/' + startSplitDay;
          var startParsedData = new Date(getStart);
          var dayIndex = new Date(startParsedData).getDay();
          this.selectedDate = startParsedData;
          this.choosenHours = this.curentLocation.available_hours[dayIndex];
          this.selectedHour = this.curentLocation.available_hours[dayIndex][0];
        }
        if (this.curentLocation.offset === '0' && this.isToday(this.selectedDate)) {
          this.choosenHours = this.curentLocation.available_hours_today;
          this.selectedHour = this.curentLocation.available_hours_today[0];
        }
        if (this.curentLocation.just_date_delivery_hour_usage) {
          this.selectedHour = null;
        }
        if (this.curentLocation.deactivate_delivery_hour_usage) {
          this.selectedHour = null;
          this.selectedDate = null;
        }
      }
    },
    filterForstatusEntered: function filterForstatusEntered() {
      var _this42 = this;

      var data2 = {
        token: this.$session.get('token'),
        add_order: true,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('pos-statuses', 'GET', data2, function (response) {
        if (response.status === true) {
          _this42.availableStatuses = response.data.statuses;
        }
        if (_this42.$session.get('selectedCompany') === 136 || _this42.$session.get('selectedCompany') === 125 || _this42.$session.get('selectedCompany') === 201 || _this42.$session.get('selectedCompany') === 210 || _this42.$session.get('selectedCompany') === 233 || _this42.$session.get('selectedCompany') === 234 || _this42.$session.get('selectedCompany') === 238) {
          _this42.availableStatuses.PROCESSING = true;
          _this42.selectedStatus = 'PROCESSING';
        }
        if (_this42.availableStatuses.DELIVERED) {
          _this42.selectedStatus = 'DELIVERED';
        }
      });
    },
    isToday: function isToday(someDate) {
      if (someDate) {
        var today = new Date();
        return someDate.getDate() === today.getDate() && someDate.getMonth() === today.getMonth() && someDate.getFullYear() === today.getFullYear();
      } else {
        return false;
      }
    },
    openHourDate: function openHourDate() {
      this.$modal.show('hourDateModal');
    },
    addOrRemoveTip: function addOrRemoveTip(flag) {
      var _this43 = this;

      if (flag) {
        __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
          title: this.$t('addOrder.titlePopupTip'),
          input: 'number',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: this.$t('addOrder.btnPopup'),
          showLoaderOnConfirm: true,
          target: document.getElementById('mySwal2'),
          preConfirm: function preConfirm(val) {
            _this43.setTip(val, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default.a.close();
              }
              __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default.a.hideLoading();
            });
          }
        });
      } else {
        this.setTip(0);
      }
    },
    setTip: function setTip(tipValue) {
      var _this44 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var data2 = {
        token: this.$session.get('token'),
        action: 'set_tip',
        add_order: true,
        tip_value: tipValue || 0,
        company_id: this.$session.get('selectedCompany'),
        products_need_deleted: true,
        shopping_cart_id: this.cart.shopping_cart_id
      };
      this.apiRequest('/update-cart', 'PUT', data2, function (response) {
        if (response.status === true) {
          _this44.cart = response.data;
          _this44.modificationsInCart();
        }
        if (callback) {
          callback(response);
        }
      });
    },
    useOrRemoveLoyaltyPoints: function useOrRemoveLoyaltyPoints(flag) {
      var _this45 = this;

      var data = {
        token: this.$session.get('token'),
        action: 'use_loyalty_points',
        status: !this.cart.loyalty_discount_value,
        add_order: true,
        company_id: this.$session.get('selectedCompany'),
        products_need_deleted: true,
        shopping_cart_id: this.cart.shopping_cart_id
      };
      this.apiRequest('/update-cart', 'PUT', data, function (response) {
        if (response.status === true) {
          _this45.cart = response.data;
          _this45.modificationsInCart();
        }
      });
    },
    toggleCommentSection: function toggleCommentSection() {
      this.showCommentSection = !this.showCommentSection;
    },
    showFreeCouponProductsAdded: function showFreeCouponProductsAdded(response) {
      var added = response.data_specials && response.data_specials.free_coupon_products_added;
      if (!added || !added.length) {
        return;
      }
      var productNames = added.map(function (item) {
        return item.name || item.product_id;
      }).join(', ');
      __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
        toast: true,
        position: 'bottom-start',
        showConfirmButton: false,
        timer: 4000,
        type: 'success',
        target: document.getElementById('mySwal2'),
        title: this.$t('addOrder.freeCouponProductAdded', { products: productNames })
      });
    },
    addOrRemoveCupon: function addOrRemoveCupon(flag) {
      var _this46 = this;

      if (flag) {
        __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
          title: this.$t('addOrder.titlePopupCoupon'),
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: this.$t('addOrder.btnPopup'),
          showLoaderOnConfirm: true,
          target: document.getElementById('mySwal2'),
          preConfirm: function preConfirm(val) {
            if (!val) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(_this46.$t('validations.requiredField')));
            }
            var data2 = {
              token: _this46.$session.get('token'),
              action: 'use_coupon',
              add_order: true,
              apply_coupon: false,
              status: true,
              check_coupon: 'check_coupon',
              coupon: val,
              company_id: _this46.$session.get('selectedCompany'),
              products_need_deleted: true,
              shopping_cart_id: _this46.cart.shopping_cart_id
            };
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              _this46.apiRequest('/update-cart', 'PUT', data2, function (response) {
                if (response.status === true) {
                  _this46.showFreeCouponProductsAdded(response);
                  _this46.applyUpdateCartResponse(response);
                  resolve();
                } else if (response.errors && response.errors.wrong_coupon) {
                  reject(new Error(_this46.$t('addOrder.errorPopupCoupon')));
                } else {
                  reject(new Error(_this46.$t('validations.wentWrong')));
                }
              });
            });
          }
        });
      } else {
        var data2 = {
          token: this.$session.get('token'),
          action: 'use_coupon',
          add_order: true,
          apply_coupon: true,
          status: false,
          coupon: '',
          company_id: this.$session.get('selectedCompany'),
          products_need_deleted: true,
          shopping_cart_id: this.cart.shopping_cart_id
        };
        this.apiRequest('/update-cart', 'PUT', data2, function (response) {
          if (response.status === true) {
            _this46.applyUpdateCartResponse(response);
          }
        });
      }
    },
    openPayModal: function openPayModal() {
      this.$modal.show('payModal');
    },
    openCommentModal: function openCommentModal() {
      this.$modal.show('commentModal');
    },
    submitComment: function submitComment() {
      this.$modal.hide('commentModal');
    },
    printOrders: function printOrders() {
      console.log('print');
      var data = {
        token: this.$session.get('token')
      };
      this.apiRequest('/noauth/print/orders', 'GET', data, function (response) {
        if (response.status === true) {
          console.log('Răspunsul de la server:', response);
        } else {
          console.error('Eroare la procesarea comenzii', response);
        }
      });
    },
    others: function others() {
      var _this47 = this;

      __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default()({
        title: this.$t('addOrder.other'),
        html: '\n          <button id="reportX" class="orderWithPaymentButton orange">Raport X</button>\n          <button id="reportZ" class="orderWithPaymentButton orange">Raport Z</button>\n        ',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: this.$t('cancel'),
        cancelButtonClass: 'swal-button--danger'
      });

      document.getElementById('reportX').addEventListener('click', function () {
        _this47.generateRaport('X');
        __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default.a.close();
      });
      document.getElementById('reportZ').addEventListener('click', function () {
        _this47.generateRaport('Z');
        __WEBPACK_IMPORTED_MODULE_34_sweetalert2___default.a.close();
      });
    }
  }
});

/***/ }),

/***/ "KtK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementOrderErrors_vue__ = __webpack_require__("zQKl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5030ac46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementOrderErrors_vue__ = __webpack_require__("o4UX");
function injectStyle (ssrContext) {
  __webpack_require__("2481")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5030ac46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementOrderErrors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5030ac46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementOrderErrors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L0G8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'display-qr',
  inheritAttrs: false,
  props: {
    location: Object
  },
  data: function data() {
    return {
      apiUrl: ''
    };
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
  },

  methods: {
    copy: function copy() {
      this.$refs.clone.focus();
      document.execCommand('copy');
    }
  }
});

/***/ }),

/***/ "L1Dm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'r4'
});

/***/ }),

/***/ "L5Y3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"},[_c('div',{staticClass:"form-group mar-rt-10",staticStyle:{"max-width":"230px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedVatNumber),expression:"selectedVatNumber"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedVatNumber=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('option',{key:group.vat,domProps:{"value":group.vat}},[_vm._v("\n            VAT: "+_vm._s(group.vat)+" — "+_vm._s(group.locations.map(function (l) { return l.name; }).join(', '))+"\n          ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group mar-rt-10"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.type')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategory),expression:"selectedCategory"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.categories),function(cat,index){return _c('option',{key:index,domProps:{"value":cat.value}},[_vm._v("\n              "+_vm._s(cat.label)+"\n            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.productNameFilter),expression:"productNameFilter"}],ref:"searchTerm",staticClass:"form-control",attrs:{"type":"text","placeholder":"Caută produs..."},domProps:{"value":(_vm.productNameFilter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.productNameFilter=$event.target.value}}}),_vm._v(" "),(_vm.loadingProducts)?_c('div',{staticClass:"v-select-loader"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":function($event){_vm.getProducts(1, _vm.pageSize)}}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.openAddProductModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('gestiune.addProduct'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.filteredProducts,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"prop":"product","label":_vm.$t('gestiune.product')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeProduct","label":_vm.$t('gestiune.codeProduct')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"categorie","label":_vm.$t('gestiune.type')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[(scope.row.categorie && scope.row.categorie.includes('Reteta'))?[_c('span',{staticClass:"categorie-label",class:_vm.getCategoryClass(scope.row.categorie)},[_vm._v("\n                        "+_vm._s(scope.row.categorie.replace(' (Reteta)', ''))+"\n                      ")]),_vm._v(" "),_c('span',{staticClass:"reteta-label",style:(scope.row.hasReteta ? 'background-color: green; color: white;' : 'background-color: red; color: white;'),attrs:{"title":"Rețetă"}},[_vm._v("\n                        "+_vm._s(scope.row.hasReteta ? 'R' : '!')+"\n                      ")])]:(scope.row.categorie)?[_c('span',{staticClass:"categorie-label",class:_vm.getCategoryClass(scope.row.categorie)},[_vm._v("\n                        "+_vm._s(scope.row.categorie)+"\n                      ")])]:[_c('span',{staticClass:"categorie-label unallocated"},[_vm._v("Tip nealocat")])]],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"um","label":_vm.$t('gestiune.um')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"stocMinim","label":_vm.$t('gestiune.stocMinim')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.stocMinim || 0)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validity","label":_vm.$t('gestiune.validity')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.validity && scope.row.validity.value != null && scope.row.validity.unit
                    ? scope.row.validity.value + ' ' + scope.row.validity.unit
                    : '')+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price","label":_vm.$t('gestiune.price')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.price || '')+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"currency","label":_vm.$t('gestiune.currency')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                      ▾\n                    ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editProduct(scope.row.id, scope.row.vatNumber)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.edit'))+"\n                      ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{key:_vm.paginationKey,staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])]),_vm._v(" "),_c('vmodal',{staticClass:"addProductModal",attrs:{"name":"addProductModal","height":"auto","width":"1200"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProduct')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.selectedLocationId),expression:"modelValidate.selectedLocationId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația*")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                      "+_vm._s(loc.name)+"\n                    ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.productName),expression:"productName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.productName),expression:"modelValidate.productName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.productName')},domProps:{"value":(_vm.productName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.productName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.codeProduct'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.codeProduct),expression:"codeProduct"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.codeProduct),expression:"modelValidate.codeProduct"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.codeProduct')},domProps:{"value":(_vm.codeProduct)},on:{"input":function($event){if($event.target.composing){ return; }_vm.codeProduct=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productDescription')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.productDescription),expression:"productDescription"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.productDescription')},domProps:{"value":(_vm.productDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.productDescription=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.type'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.productType),expression:"productType"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.productType),expression:"modelValidate.productType"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.productType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează opțiunea")]),_vm._v(" "),_vm._l((_vm.productTypes),function(type,index){return _c('option',{key:index,domProps:{"value":type.value}},[_vm._v("\n                        "+_vm._s(type.label)+"\n                      ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.um'))+" *")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.um),expression:"um"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.um),expression:"modelValidate.um"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.um=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează unitatea de măsură")]),_vm._v(" "),_vm._l((_vm.mesurementsUnits),function(unit){return [_c('option',{domProps:{"value":unit.short}},[_vm._v(_vm._s(unit.short))])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currency'))+" *")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency),expression:"currency"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currency=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"RON"}},[_vm._v("RON")]),_vm._v(" "),_c('option',{attrs:{"value":"EUR"}},[_vm._v("EURO")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.tva'))+" *")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cotaTva),expression:"cotaTva"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.cotaTva),expression:"modelValidate.cotaTva"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cotaTva=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează TVA")]),_vm._v(" "),_vm._l((_vm.vats),function(vat){return _c('option',{key:vat.tax_id,attrs:{"label":((vat.amount) + " %")},domProps:{"value":vat.amount}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.stocMinim')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.stocMinim),expression:"stocMinim"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.stocMinim')},domProps:{"value":(_vm.stocMinim)},on:{"input":function($event){if($event.target.composing){ return; }_vm.stocMinim=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeModal}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L7GT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L8oI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupForm_vue__ = __webpack_require__("rE7J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae908e9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupForm_vue__ = __webpack_require__("pMOA");
function injectStyle (ssrContext) {
  __webpack_require__("QeLv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae908e9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LFMz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);

















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a);

var emptyVat = function emptyVat() {
  return { id: null, rate: null, is_active: true, is_used: false, usage: {} };
};
var emptyRule = function emptyRule() {
  return { id: null, name: '', applies_to: 'order', calculation_type: 'fixed', value: 0, pos_id: '', vat_rate_id: '', is_active: true, location_ids: [], source_ids: [], method_ids: [], delivery_range_ids: [], product_ids: [], company_option_value_ids: [], delivery_cost_ranges: [] };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeTab: 'vat',
      saving: false,
      loadingRule: false,
      applyingCategoryTaxes: false,
      categoryTaxResult: '',
      showVatEditor: false,
      showRuleEditor: false,
      taxesVersion: 1,
      vatRates: [],
      taxRules: [],
      categories: [],
      priceProfiles: [],
      locations: [],
      deliveryRanges: [],
      sources: [{ id: 1, name: 'Website' }, { id: 2, name: 'QR' }, { id: 3, name: 'Kiosk' }, { id: 4, name: 'POS' }, { id: 5, name: 'App' }, { id: 6, name: 'Glovo' }, { id: 7, name: 'Bolt' }, { id: 8, name: 'Wolt' }],
      methods: [{ id: 1, name: 'EatIn' }, { id: 2, name: 'ToGo' }, { id: 3, name: 'Delivery' }],
      productVatTool: { category_ids: [], vat_rate_id: '' },
      profileVatTool: { price_profile_id: '', category_ids: [], vat_rate_id: '', source_ids: [], method_ids: [] },
      taxCategoryTool: { category_ids: [], tax_rule_ids: [], include_option_values: false },
      vatForm: emptyVat(),
      ruleForm: emptyRule()
    };
  },

  computed: {
    companyId: function companyId() {
      return this.$session.get('selectedCompany');
    },
    token: function token() {
      return this.$session.get('token');
    }
  },
  created: function created() {
    var companyData = this.$session.get('selectedCompanyData') || {};
    this.taxesVersion = Number(companyData.taxes_version) === 2 ? 2 : 1;
    this.locations = (companyData.locations_details || []).map(function (l) {
      return { id: l.true_id || l.id, token: l.token, name: l.name };
    });
    this.loadAll();
    this.openRuleFromRoute();
  },

  methods: {
    requestData: function requestData(extra) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({ token: this.token, company_id: this.companyId }, extra || {});
    },
    openTaxTab: function openTaxTab(tab) {
      if (this.applyingCategoryTaxes) return;
      this.activeTab = tab;
      this.showVatEditor = false;
      this.showRuleEditor = false;
      this.vatForm = emptyVat();
      this.ruleForm = emptyRule();
    },
    loadAll: function loadAll() {
      this.loadVat();this.loadRules();this.loadCategories();this.loadProfiles();this.loadDeliveryRanges();
    },
    loadVat: function loadVat() {
      var _this = this;

      this.apiRequest('/taxes-v2/vat-rates', 'GET', this.requestData(), function (r) {
        if (r.status) _this.vatRates = r.data || [];
      });
    },
    loadRules: function loadRules() {
      var _this2 = this;

      this.apiRequest('/taxes-v2/rules', 'GET', this.requestData(), function (r) {
        if (r.status) {
          _this2.taxRules = r.data || [];_this2.mergeDeliveryRanges();
        }
      });
    },
    loadCategories: function loadCategories() {
      var _this3 = this;

      this.apiRequest('/category', 'GET', this.requestData(), function (r) {
        if (r.status) _this3.categories = r.data || [];
      });
    },
    loadProfiles: function loadProfiles() {
      var _this4 = this;

      this.apiRequest('/price-profiles', 'GET', this.requestData({ perPage: 500 }), function (r) {
        if (r.status) _this4.priceProfiles = r.data || [];
      });
    },
    loadDeliveryRanges: function loadDeliveryRanges() {
      var _this5 = this;

      this.apiRequest('/price-profiles/scope-options', 'GET', this.requestData({ location_ids: this.locations.map(function (l) {
          return l.id;
        }) }), function (r) {
        if (r.status) _this5.mergeDeliveryRanges(r.data && r.data.delivery_ranges || []);
      });
    },
    formatRate: function formatRate(v) {
      return Number(v).toLocaleString('ro-RO', { maximumFractionDigits: 2 });
    },
    usageLabel: function usageLabel(usage) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(usage || {}).map(function (k) {
        return k + ': ' + usage[k];
      }).join(', ');
    },
    relationNames: function relationNames(ids, options, emptyLabel) {
      if (!ids || !ids.length) return emptyLabel;return ids.map(function (id) {
        return (options.find(function (o) {
          return String(o.id) === String(id);
        }) || { name: '#' + id }).name;
      }).join(', ');
    },
    scopeSummary: function scopeSummary(rule) {
      return ['Locații: ' + this.relationNames(rule.location_ids, this.locations, 'toate'), 'Surse: ' + this.relationNames(rule.source_ids, this.sources, 'toate'), 'Metode: ' + this.relationNames(rule.method_ids, this.methods, 'toate'), 'Zone: ' + this.relationNames(rule.delivery_range_ids, this.deliveryRanges, 'toate')].join('; ');
    },
    responseMessage: function responseMessage(response, fallback) {
      var errorData = response && response.error && response.error.response && response.error.response.data;
      if (response && response.message) return response.message;
      if (errorData && errorData.message) return errorData.message;
      if (errorData && errorData.errors) {
        var first = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(errorData.errors)[0];
        var value = first ? errorData.errors[first] : null;
        if (Array.isArray(value)) return value[0];
        if (value) return value;
      }
      return fallback;
    },
    profileLabel: function profileLabel(profile) {
      var names = (profile.location_details || []).map(function (l) {
        return l.name;
      }).join(', ');return names ? profile.name + ' \u2014 ' + names : profile.name;
    },
    deliveryRangeLabel: function deliveryRangeLabel(range) {
      var location = this.locations.find(function (l) {
        return String(l.token) === String(range.location_id);
      });return location ? range.name + ' \u2014 ' + location.name : range.name;
    },
    mergeDeliveryRanges: function mergeDeliveryRanges(ranges) {
      var merged = {};(this.deliveryRanges || []).concat(ranges || []).forEach(function (range) {
        merged[String(range.id)] = range;
      });(this.taxRules || []).forEach(function (rule) {
        ;(rule.delivery_ranges || []).forEach(function (range) {
          merged[String(range.id)] = range;
        });
      });(this.ruleForm && this.ruleForm.delivery_ranges || []).forEach(function (range) {
        merged[String(range.id)] = range;
      });
      this.deliveryRanges = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(merged).map(function (id) {
        return merged[id];
      }).sort(function (a, b) {
        return String(a.name || '').localeCompare(String(b.name || ''), 'ro');
      });
    },
    taxTypeLabel: function taxTypeLabel(type) {
      return type === 'order' ? 'Comandă' : type === 'delivery' ? 'Livrare' : 'Produs/opțiune';
    },
    selectableVatRates: function selectableVatRates(selected) {
      return this.vatRates.filter(function (v) {
        return v.is_active || String(v.id) === String(selected);
      });
    },
    notify: function notify(text, type) {
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ text: text, type: type || 'success', showConfirmButton: false, timer: 2200 });
    },
    setTaxesVersion: function setTaxesVersion(version) {
      var _this6 = this;

      this.apiRequest('/taxes-v2/version', 'PUT', this.requestData({ taxes_version: version }), function (r) {
        if (!r.status) {
          _this6.notify(_this6.responseMessage(r, 'Versiunea taxelor nu a putut fi actualizată.'), 'error');return;
        }
        _this6.taxesVersion = version;
        var companyData = _this6.$session.get('selectedCompanyData') || {};
        companyData.taxes_version = version;
        _this6.$session.set('selectedCompanyData', companyData);
        _this6.notify(version === 2 ? 'Motorul de taxe V2 este activ.' : 'Motorul vechi de taxe este activ.');
      });
    },
    resetVatTools: function resetVatTools(vatRateId) {
      this.productVatTool = { category_ids: [], vat_rate_id: vatRateId || '' };
      this.profileVatTool = { price_profile_id: '', category_ids: [], vat_rate_id: vatRateId || '', source_ids: [], method_ids: [] };
    },
    openCreateVat: function openCreateVat() {
      this.vatForm = emptyVat();
      this.resetVatTools(null);
      this.showVatEditor = true;
    },
    openEditVat: function openEditVat(vat) {
      this.vatForm = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(emptyVat(), JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(vat)));
      this.resetVatTools(vat.id);
      this.showVatEditor = true;
    },
    closeVatEditor: function closeVatEditor() {
      this.showVatEditor = false;
      this.vatForm = emptyVat();
      this.resetVatTools(null);
    },
    saveVat: function saveVat() {
      var _this7 = this;

      if (this.vatForm.rate === null || this.vatForm.rate === '') {
        this.notify('Completează cota TVA.', 'error');return;
      }
      this.saving = true;
      var isEdit = !!this.vatForm.id;
      var url = '/taxes-v2/vat-rates' + (isEdit ? '/' + this.vatForm.id : '');
      var payload = isEdit ? { is_active: this.vatForm.is_active ? 1 : 0 } : { rate: this.vatForm.rate, is_active: this.vatForm.is_active ? 1 : 0 };
      this.apiRequest(url, isEdit ? 'PUT' : 'POST', this.requestData(payload), function (r) {
        _this7.saving = false;
        if (!r.status) {
          _this7.notify(_this7.responseMessage(r, 'Cota TVA nu a putut fi salvată.'), 'error');return;
        }
        _this7.vatForm = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(emptyVat(), _this7.vatForm, r.data || {});
        _this7.resetVatTools(_this7.vatForm.id);
        _this7.loadVat();
        _this7.notify(isEdit ? 'Cota TVA a fost actualizată.' : 'Cota TVA a fost adăugată.');
      });
    },
    toggleVat: function toggleVat(vat, active) {
      var _this8 = this;

      this.apiRequest('/taxes-v2/vat-rates/' + vat.id, 'PUT', this.requestData({ is_active: active ? 1 : 0 }), function (r) {
        if (r.status) _this8.loadVat();else _this8.notify(_this8.responseMessage(r, 'TVA-ul nu a putut fi actualizat.'), 'error');
      });
    },
    deleteVat: function deleteVat(vat) {
      var _this9 = this;

      if (vat.is_used) return;this.apiRequest('/taxes-v2/vat-rates/' + vat.id, 'DELETE', this.requestData(), function (r) {
        if (r.status) {
          _this9.loadVat();_this9.notify('Cota TVA a fost ștearsă.');
        } else _this9.notify(_this9.responseMessage(r, 'TVA-ul nu poate fi șters.'), 'error');
      });
    },
    applyProductVat: function applyProductVat() {
      this.postTool('/taxes-v2/tools/products/vat', this.productVatTool, 'TVA-ul a fost aplicat produselor.');
    },
    applyProfileVat: function applyProfileVat() {
      this.postTool('/taxes-v2/tools/price-profiles/vat', this.profileVatTool, 'TVA-ul a fost aplicat listei de preț.');
    },
    applyCategoryTaxes: function applyCategoryTaxes() {
      var _this10 = this;

      if (!this.ruleForm.id || !this.taxCategoryTool.category_ids.length || this.saving || this.applyingCategoryTaxes) return;
      var ruleId = this.ruleForm.id;
      var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.taxCategoryTool, { tax_rule_ids: [ruleId], category_ids: this.taxCategoryTool.category_ids.slice() });
      this.applyingCategoryTaxes = true;
      this.categoryTaxResult = '';
      this.apiRequest('/taxes-v2/tools/categories/taxes', 'POST', this.requestData(payload), function (r) {
        _this10.applyingCategoryTaxes = false;
        if (!r.status) {
          _this10.notify(_this10.responseMessage(r, 'Atribuirile nu au putut fi salvate. Încearcă din nou.'), 'error');return;
        }
        var data = r.data || {};
        if (_this10.ruleForm.id === ruleId) {
          ;['product_ids', 'company_option_value_ids'].forEach(function (field) {
            _this10.ruleForm[field] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a((_this10.ruleForm[field] || []).concat(data[field] || []).map(Number)));
          });
          _this10.taxCategoryTool.category_ids = [];
          _this10.categoryTaxResult = 'Atribuiri salvate: ' + (data.products || 0) + ' produse \u0219i ' + (data.option_values || 0) + ' valori de op\u021Biuni. Nu mai trebuie s\u0103 ape\u0219i \u201ESalveaz\u0103 taxa\u201D pentru aceste atribuiri.';
        }
        _this10.loadRules();
      });
    },
    postTool: function postTool(url, payload, message) {
      var _this11 = this;

      this.apiRequest(url, 'POST', this.requestData(payload), function (r) {
        if (r.status) _this11.notify(message);else _this11.notify(_this11.responseMessage(r, 'Operația nu a putut fi finalizată.'), 'error');
      });
    },
    saveRule: function saveRule() {
      var _this12 = this;

      if (this.saving || this.loadingRule || this.applyingCategoryTaxes) return;
      var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.ruleForm);
      if (payload.applies_to === 'delivery') {
        payload.calculation_type = 'fixed';
        payload.method_ids = [3];
      }
      var url = '/taxes-v2/rules' + (payload.id ? '/' + payload.id : '');
      this.saving = true;
      this.apiRequest(url, payload.id ? 'PUT' : 'POST', this.requestData(payload), function (r) {
        _this12.saving = false;
        if (!r.status) {
          _this12.notify(_this12.responseMessage(r, 'Taxa nu a putut fi salvată.'), 'error');return;
        }
        _this12.ruleForm = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(emptyRule(), JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(r.data || payload)));
        _this12.mergeDeliveryRanges(_this12.ruleForm.delivery_ranges || []);
        _this12.taxCategoryTool.tax_rule_ids = _this12.ruleForm.id ? [_this12.ruleForm.id] : [];
        _this12.loadRules();
        _this12.loadVat();
        _this12.notify(_this12.ruleForm.applies_to === 'item' && _this12.taxCategoryTool.category_ids.length ? 'Taxa a fost salvată. Categoriile selectate încă nu au fost aplicate: apasă „Aplică taxa” în instrumentul de mai jos.' : 'Taxa a fost salvată.', _this12.ruleForm.applies_to === 'item' && _this12.taxCategoryTool.category_ids.length ? 'info' : 'success');
      });
    },
    openCreateRule: function openCreateRule(preset) {
      this.categoryTaxResult = '';
      this.ruleForm = emptyRule();
      if (preset) this.ruleForm = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.ruleForm, preset);
      this.handleRuleTypeChange();
      this.taxCategoryTool = { category_ids: [], tax_rule_ids: [], include_option_values: false };
      this.loadingRule = false;
      this.showRuleEditor = true;
    },
    openEditRule: function openEditRule(rule) {
      var _this13 = this;

      this.categoryTaxResult = '';
      this.ruleForm = emptyRule();
      this.taxCategoryTool = { category_ids: [], tax_rule_ids: [rule.id], include_option_values: false };
      this.loadingRule = true;
      this.showRuleEditor = true;
      this.apiRequest('/taxes-v2/rules/' + rule.id, 'GET', this.requestData(), function (r) {
        _this13.loadingRule = false;
        if (!r.status) {
          _this13.notify(_this13.responseMessage(r, 'Taxa nu a putut fi încărcată.'), 'error');_this13.closeRuleEditor();return;
        }
        _this13.ruleForm = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(emptyRule(), JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(r.data || {})));
        _this13.mergeDeliveryRanges(_this13.ruleForm.delivery_ranges || []);
        _this13.handleRuleTypeChange();
      });
    },
    closeRuleEditor: function closeRuleEditor() {
      if (this.applyingCategoryTaxes) return;
      this.categoryTaxResult = '';
      this.showRuleEditor = false;
      this.loadingRule = false;
      this.ruleForm = emptyRule();
      this.taxCategoryTool = { category_ids: [], tax_rule_ids: [], include_option_values: false };
      this.clearRuleRouteQuery();
    },
    handleRuleTypeChange: function handleRuleTypeChange() {
      if (this.ruleForm.applies_to === 'delivery') {
        this.ruleForm.calculation_type = 'fixed';
        this.ruleForm.method_ids = [3];
      }
      if (!Array.isArray(this.ruleForm.delivery_cost_ranges)) this.$set(this.ruleForm, 'delivery_cost_ranges', []);
    },
    addDeliveryCostRange: function addDeliveryCostRange() {
      this.ruleForm.delivery_cost_ranges.push({ distance_in_km: '', shipping_cost: '', pos_id: '', min_order_value: 0, extra_delivery_time: 0 });
    },
    removeDeliveryCostRange: function removeDeliveryCostRange(index) {
      this.ruleForm.delivery_cost_ranges.splice(index, 1);
    },
    openRuleFromRoute: function openRuleFromRoute() {
      var query = this.$route.query || {};
      if (query.taxRuleId) {
        this.activeTab = 'rules';
        this.openEditRule({ id: query.taxRuleId });
        return;
      }
      if (query.newTax === 'delivery') {
        this.activeTab = 'rules';
        var deliveryRangeId = query.deliveryRangeId ? Number(query.deliveryRangeId) : null;
        var locationId = query.locationId ? Number(query.locationId) : null;
        this.openCreateRule({
          applies_to: 'delivery',
          calculation_type: 'fixed',
          method_ids: [3],
          delivery_range_ids: deliveryRangeId ? [deliveryRangeId] : [],
          location_ids: locationId ? [locationId] : []
        });
      }
    },
    clearRuleRouteQuery: function clearRuleRouteQuery() {
      var query = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.$route.query || {});
      if (!query.taxRuleId && !query.newTax && !query.deliveryRangeId && !query.locationId) return;
      delete query.taxRuleId;
      delete query.newTax;
      delete query.deliveryRangeId;
      delete query.locationId;
      this.$router.replace({ path: this.$route.path, query: query });
    },
    toggleRule: function toggleRule(rule, active) {
      var _this14 = this;

      var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(rule)), { is_active: active });
      this.apiRequest('/taxes-v2/rules/' + rule.id, 'PUT', this.requestData(payload), function (r) {
        if (r.status) {
          _this14.loadRules();_this14.notify(active ? 'Taxa a fost activată.' : 'Taxa a fost dezactivată.');
        } else _this14.notify(_this14.responseMessage(r, 'Taxa nu a putut fi actualizată.'), 'error');
      });
    },
    deleteRule: function deleteRule(rule) {
      var _this15 = this;

      this.apiRequest('/taxes-v2/rules/' + rule.id, 'DELETE', this.requestData(), function (r) {
        if (r.status) {
          _this15.loadRules();_this15.notify('Taxa a fost dezactivată și arhivată.');
        } else _this15.notify(_this15.responseMessage(r, 'Taxa nu a putut fi ștearsă.'), 'error');
      });
    }
  }
});

/***/ }),

/***/ "LHZe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LIBP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('top-category-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onCategorySubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LImY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__);















var _components;








__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PSwitch: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_17_vuedraggable___default.a
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    groupId: null,
    callback: {
      required: false
    }
  },
  watch: {
    groupId: function groupId(value) {
      this.id = value;
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";

    this.getData();
    this.getCategorys();
    this.getLocations();
  },
  data: function data() {
    return {
      apiUrl: '',
      id: this.value || this.groupId,
      model: false,
      option_name: '',
      tabIndex: null,
      modelValidate: {
        name: { required: true },
        type: { required: true },
        status: { required: true }
      },
      companyOptions: [],
      mainCategories: [],
      locations: [],
      selectedCategoryForImport: null,
      selectedLocationForImport: null,
      validateOptionCheck: true,
      languages: this.$session.get('defaultData')['available_languages'],
      currency: this.$session.get('selectedCompanyData')['currency_iso'],
      use_pos_id_per_product_option: this.$session.get('selectedCompanyData')['use_pos_id_per_product_option'] || 0,
      use_quantity_per_product_option: this.$session.get('selectedCompanyData')['use_quantity_per_product_option'] || 0,
      deleteOptionValues: [],
      deleteOptions: [],
      optionValueQuery: '',
      loading: true
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (!this.isNew()) {
        var id = this.route.params.id || this.id;
        this.apiRequest('/group-options/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            _this.option_name = response.data.group_option.name;
            _this.model = response.data.group_option.options;
            _this.companyOptions = response.data.company_options;

            _this.loading = false;
          }
        });
      } else {
        this.model = [];
        this.apiRequest('/get-company-options/', 'GET', data, function (response) {
          if (response.status === true) {
            _this.companyOptions = response.data.options;
            _this.loading = false;
          }
        });
      }
    },
    getCategorys: function getCategorys() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        inactive: 1
      };
      this.apiRequest('/category', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.mainCategories = response.data;
        }
      });
    },
    getLocations: function getLocations() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/get-locations', 'GET', data, function (response) {
        if (response.status === true) {
          _this3.locations = response.data;
        }
      });
    },
    importGroupOptionToCategory: function importGroupOptionToCategory() {
      var _this4 = this;

      if (this.selectedCategoryForImport) {
        __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
          text: this.$t('groupOption.areYouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then(function (result) {
          if (result) {
            var data = {
              token: _this4.$session.get('token'),
              company_id: _this4.$session.get('selectedCompany'),
              group_id: _this4.route.params.id,
              category_id: _this4.selectedCategoryForImport
            };
            if (_this4.selectedLocationForImport) {
              data.location_token = _this4.selectedLocationForImport;
            }
            _this4.apiRequest('/import-group-options', 'POST', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': 'success', 'type': 'success', 'showConfirmButton': false, 'timer': 1000 }).catch(function () {});
              } else {
                __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': _this4.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 1000 }).catch(function () {});
              }
            });
          }
        });
      }
      return false;
    },
    isNew: function isNew() {
      if (this.route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    validate: function validate() {
      var _this5 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this5.saveOption();
        }
      });
    },
    validateOption: function validateOption(option, keyId) {
      this.validateOptionCheck = true;
      if (option.group_company_option_values.length && option.max_no > parseInt(option.group_company_option_values.length)) {
        this.errors.add('max' + keyId, this.$t('catalogProd.maxNoTooHigh'));
        this.validateOptionCheck = false;
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (item) {
            return item.field !== 'max' + keyId;
          });
        }
      }

      if (parseInt(option.min_no) > parseInt(option.max_no) && parseInt(option.max_no)) {
        this.errors.add('min' + keyId, this.$t('catalogProd.minNoTooHigh'));
        this.validateOptionCheck = false;
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (item) {
            return item.field !== 'min' + keyId;
          });
        }
      }

      if (parseInt(option.min_no) < 0) {
        this.errors.add('min_negative' + keyId, this.$t('catalogProd.minNoNegative'));
        this.validateOptionCheck = false;
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (item) {
            return item.field !== 'min_negative' + keyId;
          });
        }
      }

      if (parseInt(option.max_no) < 0) {
        this.errors.add('max_negative' + keyId, this.$t('catalogProd.maxNoNegative'));
        this.validateOptionCheck = false;
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (item) {
            return item.field !== 'max_negative' + keyId;
          });
        }
      }
    },
    selectOptionValue: function selectOptionValue(selectedId, optionIndex, optionValueIndex) {
      var option = this.model[optionIndex];
      var companyOptionIndex = this.getObjectByElemKeyValue('id', option.company_option_id, this.companyOptions);
      var selectedName = '';
      if (companyOptionIndex !== false && this.companyOptions[companyOptionIndex] && this.companyOptions[companyOptionIndex]['values']) {
        var values = this.companyOptions[companyOptionIndex]['values'];
        var valueIndex = this.getObjectByElemKeyValue('id', selectedId, values);
        if (valueIndex !== false && values[valueIndex]) {
          selectedName = values[valueIndex].name;
        }
      }
      __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(this.model[optionIndex].group_company_option_values[optionValueIndex], 'company_option_value_id', selectedId);
      __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(this.model[optionIndex].group_company_option_values[optionValueIndex], 'name', selectedName);
    },
    removeDiacritics: function removeDiacritics(str) {
      return String(str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
    filterOptionValues: function filterOptionValues(query) {
      this.optionValueQuery = query;
    },
    resetOptionValueQuery: function resetOptionValueQuery(visible) {
      if (visible) {
        this.optionValueQuery = '';
      }
    },
    matchesOptionValueQuery: function matchesOptionValueQuery(name, selectedId, optionId) {
      if (optionId === selectedId) {
        return true;
      }
      var query = this.removeDiacritics(this.optionValueQuery).toLowerCase().trim();
      if (!query) {
        return true;
      }
      return this.removeDiacritics(name).toLowerCase().indexOf(query) > -1;
    },
    handleErrors: function handleErrors(errors) {
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
    },
    handleDeleteOption: function handleDeleteOption() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        text: self.$t('catalogProdOpt.areyouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result) {
          self.trueDeleteOption();
        }
      });
    },
    trueDeleteOption: function trueDeleteOption() {
      var _this6 = this;

      var data = {};
      var id = this.route.params.id;
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      data.delete = 1;
      this.apiRequest('/group-options/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          _this6.trackAdminEvent('ADMIN_OPTION_GROUP_DELETED', 'option_group', id, {
            option_group_id: id,
            name: _this6.option_name || null
          });
          _this6.cancelOption();
        }
      });
    },
    saveOption: function saveOption() {
      var _this7 = this;

      this.loading = true;
      var id = this.route.params.id || 0;
      var data = {};
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      data.option_name = this.option_name;
      data.option = this.model;
      data.deleteOptions = this.deleteOptions;
      data.deleteOptionValues = this.deleteOptionValues;

      if (Array.isArray(data.option)) {
        data.option.forEach(function (opt) {
          if (opt && Array.isArray(opt.group_company_option_values)) {
            opt.group_company_option_values.forEach(function (val) {
              if (val && (val.pos_id === undefined || val.pos_id === null)) {
                val.pos_id = '';
              }
            });
          }

          if (opt && Array.isArray(opt.values) && Array.isArray(opt.group_company_option_values)) {
            opt.values.forEach(function (v) {
              var match = opt.group_company_option_values.find(function (gv) {
                return gv.id && v.id && gv.id === v.id || gv.company_option_value_id && v.company_option_value_id && gv.company_option_value_id === v.company_option_value_id;
              });
              if (match && (v.pos_id === undefined || v.pos_id === null)) {
                v.pos_id = match.pos_id;
              }
            });
          } else if (opt && !opt.values && Array.isArray(opt.group_company_option_values)) {
            opt.values = opt.group_company_option_values;
          }
        });
      }

      this.apiRequest('/group-options/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          _this7.loading = false;
          _this7.errors.clear();
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': _this7.$t('menuLink.updated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          _this7.cancelOption();
        } else {
          _this7.loading = false;
          _this7.handleErrors(response.errors);
        }
      });
    },
    deleteOption: function deleteOption(thisOptIdx) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        text: this.$t('catalogProdOpt.areyouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          if (_this8.model[thisOptIdx].id) {
            _this8.deleteOptions.push(_this8.model[thisOptIdx].id);
          }
          _this8.model.splice(thisOptIdx, 1);
        }
      });
    },
    deleteOptionValue: function deleteOptionValue(thisOptIdx, thisValIdx) {
      if (this.model[thisOptIdx].group_company_option_values[thisValIdx].id) {
        this.deleteOptionValues.push(this.model[thisOptIdx].group_company_option_values[thisValIdx].id);
      }
      this.model[thisOptIdx].group_company_option_values.splice(thisValIdx, 1);
    },
    addNewOption: function addNewOption() {
      var newRow = {
        'id': null,
        'min_no': 0,
        'max_no': 1,
        'required': true,
        'hide_prices': false,
        'has_default_value': false,
        'active': true,
        'group_company_option_values': []
      };
      this.model.push(newRow);
      this.tabIndex = this.model ? this.model.length - 1 : 0;
    },
    addNewOptionValue: function addNewOptionValue(optIdx) {
      var newRow = {
        'id': null,
        'active': true,
        'price': 0,
        'pos_id': null
      };
      if (this.use_pos_id_per_product_option) {
        newRow['pos_id_per_product'] = 0;
      }
      if (this.use_quantity_per_product_option) {
        newRow['quantity_per_option'] = 0;
      }
      this.model[optIdx].group_company_option_values.push(newRow);
    },
    disableOption: function disableOption(optIdx, id, main) {
      var thisOptIdx = false;
      if (main) {
        if (this.model !== undefined) {
          thisOptIdx = this.getObjectByElemKeyValue('company_option_id', id, this.model);
        }
      } else {
        if (this.model[optIdx] !== undefined) {
          thisOptIdx = this.getObjectByElemKeyValue('company_option_value_id', id, this.model[optIdx]['group_company_option_values']);
        }
      }

      if (thisOptIdx !== false) {
        return true;
      } else {
        return false;
      }
    },
    changeOption: function changeOption(thisOptIdx, companyOptionId) {
      if (companyOptionId) {
        var companyOptionIndex = this.getObjectByElemKeyValue('id', companyOptionId, this.companyOptions);
        var companyOption = this.companyOptions[companyOptionIndex];
        this.model[thisOptIdx]['group_company_option_values'] = [];
        this.model[thisOptIdx]['type'] = companyOption['type'];
        this.model[thisOptIdx]['name'] = companyOption['name'];
        this.model[thisOptIdx]['company_option_id'] = companyOption['id'];
        this.model[thisOptIdx]['required'] = true;
        this.model[thisOptIdx]['hide_prices'] = false;
        this.model[thisOptIdx]['has_default_value'] = false;
        this.tabIndex = thisOptIdx;
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    cancelOption: function cancelOption() {
      if (this.route.path && this.route.path.includes('/integrations/menu-fix')) {
        window.close();
        return;
      }

      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "LKKj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementExports_vue__ = __webpack_require__("xlfv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_483030de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementExports_vue__ = __webpack_require__("3czh");
function injectStyle (ssrContext) {
  __webpack_require__("uk0M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-483030de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementExports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_483030de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementExports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LL4n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LM/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_vm._t("content")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_vm._t("header")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LPdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Currency_vue__ = __webpack_require__("JB9I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb6f9c40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Currency_vue__ = __webpack_require__("f1GC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Currency_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb6f9c40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Currency_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LYFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockReport_vue__ = __webpack_require__("P3i8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_492ef752_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockReport_vue__ = __webpack_require__("JHHj");
function injectStyle (ssrContext) {
  __webpack_require__("RExQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-492ef752"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_492ef752_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LiuW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__automationTypes__ = __webpack_require__("OEwP");














__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      searchQuery: '',
      tableData: [],
      paginationDef: {
        pageSize: 20,
        currentPage: 1,
        pageSizes: [20, 50, 100]
      }
    };
  },
  created: function created() {
    this.getCampaigns();
    this.$bus.$on('refresh', this.getCampaigns);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.getCampaigns);
  },

  methods: {
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    typeLabel: function typeLabel(type) {
      var item = __WEBPACK_IMPORTED_MODULE_10__automationTypes__["a" /* AUTOMATION_TYPES */].find(function (t) {
        return t.value === type;
      });
      return item ? this.$t(item.label) : type;
    },
    typeIcon: function typeIcon(type) {
      var item = __WEBPACK_IMPORTED_MODULE_10__automationTypes__["a" /* AUTOMATION_TYPES */].find(function (t) {
        return t.value === type;
      });
      return item ? item.icon : 'fa fa-cog';
    },
    formatDay: function formatDay(value) {
      if (!value) {
        return '-';
      }
      var parts = String(value).substr(0, 10).split('-');
      return parts.length === 3 ? parts[2] + '.' + parts[1] + '.' + parts[0] : value;
    },
    periodHint: function periodHint(row) {
      var today = new Date();
      var day = function day(value) {
        var parts = String(value || '').substr(0, 10).split('-').map(Number);
        return parts.length === 3 ? new Date(parts[0], parts[1] - 1, parts[2]) : null;
      };
      var start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      var diff = function diff(target) {
        return Math.round((target - start) / 86400000);
      };

      var NEAR_DAYS = 30;
      if (row.state === 'running' && day(row.date_to)) {
        var days = diff(day(row.date_to));
        if (days === 0) {
          return this.$t('marketingAutomation.endsToday');
        }
        return days <= NEAR_DAYS ? this.$t('marketingAutomation.endsIn', { days: days }) : '';
      }
      if (row.state === 'scheduled' && day(row.date_from)) {
        var _days = diff(day(row.date_from));
        return _days <= NEAR_DAYS ? this.$t('marketingAutomation.startsIn', { days: _days }) : '';
      }
      return '';
    },
    getCampaigns: function getCampaigns() {
      var _this = this;

      var data = this.requestData();
      if (this.searchQuery.length >= 3) {
        data.search = this.searchQuery;
      }
      this.loading = true;
      this.apiRequest('/automation-campaign', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data || [];
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    onInput: function onInput() {
      if (this.searchQuery.length >= 3 || this.searchQuery.length === 0) {
        this.getCampaigns();
      }
    },
    openBeneficiaries: function openBeneficiaries(row) {
      this.$router.push({ path: '/marketing/automation/beneficiaries', query: { campaign_id: row.id } }).catch(function () {});
    },
    goToRecord: function goToRecord(row, column, event) {
      this.globalGoToRecord(row, event, column, '/marketing/automation/edit/');
    },
    errorText: function errorText(response) {
      var errors = response && response.errors || {};
      var messages = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors).map(function (key) {
        return Array.isArray(errors[key]) ? errors[key][0] : errors[key];
      });
      return messages.join(' ') || this.$t('validations.wentWrong');
    },
    handleActive: function handleActive(row) {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.requestData(), {
        active: row.active ? 1 : 0
      });
      this.apiRequest('/automation-campaign/' + row.id + '/status', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()(_this2.$t('general.success') + '!', '', 'success').catch(function () {});
        } else {
          row.active = !row.active;
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', _this2.errorText(response), 'error').catch(function () {});
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
        text: this.$t('marketingAutomation.areYouSureDelete', { name: row.name }),
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (!result) {
          return;
        }
        _this3.apiRequest('/automation-campaign/' + row.id, 'DELETE', _this3.requestData(), function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', _this3.$t('marketingAutomation.deleted'), 'success').catch(function () {});
            _this3.tableData = _this3.tableData.filter(function (item) {
              return item.id !== row.id;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', _this3.errorText(response), 'error').catch(function () {});
          }
        });
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "Lqom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('referral-campaign-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lw9u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M+2A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"report-filters",staticStyle:{"align-items":"end"}},[_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 form-group pull-left"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.location),expression:"filters.location"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onFilterChange]}},[_c('option',{domProps:{"value":''}},[_vm._v(_vm._s(_vm.$t('reports.allLocations')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc,index){return _c('option',{key:index,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 form-group pull-left date-range"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('reports.dateInterval')))]),_vm._v(" "),_c('el-date-picker',{staticClass:"mid w-100",staticStyle:{"width":"100%"},attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions,"clearable":false},model:{value:(_vm.filters.dateRange),callback:function ($$v) {_vm.$set(_vm.filters, "dateRange", $$v)},expression:"filters.dateRange"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group pull-left"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('reports.orderId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.orderId),expression:"filters.orderId"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('reports.orderId')},domProps:{"value":(_vm.filters.orderId)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.getData(null)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "orderId", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left",staticStyle:{"margin-bottom":"34px"}},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":function($event){_vm.getData(null)}}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left",staticStyle:{"margin-bottom":"34px"}},[_c('div',{staticClass:"btn btn-icon btn-info btn-print",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_c('i',{staticClass:"ti-file"})])])]),_vm._v(" "),_c('div',{staticClass:"card-content total-pagination pad-15"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.responsesTableData,"search-def":{ show: false },"total":_vm.totalResponses,"pagination-props":_vm.paginationProps,"table-props":_vm.tableOptions},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"min-width":60,"prop":"id","label":"Id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":150,"label":_vm.$t('reports.dateTime')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.answered_at))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"label":_vm.$t('reports.reorderResponse')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(_vm.responseLabel(props.row.response)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"label":_vm.$t('reports.orderId')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.order_id || props.row.order_token || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":140,"label":_vm.$t('dashboard.selectLocation')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.location_name || '-'))])]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M3Di":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"user"},[_c('div',{staticClass:"user-box"},[(_vm.companyAvatar)?_c('div',{staticClass:"photo",style:('background-image: url(' + _vm.companyAvatar + ')'),on:{"click":function($event){$event.preventDefault();_vm.minimizeSidebar(1)}}}):_c('div',{staticClass:"photo"}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('a',{attrs:{"data-toggle":"collapse","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goToSettings($event)}}},[_c('span',[_vm._v(_vm._s(_vm.companyName))])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div')])]),_vm._v(" "),_c('div',{staticClass:"modules-preview"},[_c('div',{staticClass:"progress-header"},[_c('div',{staticClass:"progress-percentage"},[_c('span',{staticClass:"percent-value"},[_vm._v(_vm._s(_vm.activeModulesPercent)+"%")]),_vm._v(" "),_c('span',{staticClass:"percent-label"},[_vm._v(_vm._s(_vm.$t('general.modulesActivate')))])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"progress-slider-container"},[_c('div',{staticClass:"progress-track"},[_c('div',{staticClass:"progress-fill",style:({ width: _vm.activeModulesPercent + '%' })}),_vm._v(" "),_c('div',{staticClass:"progress-thumb",style:({ left: _vm.activeModulesPercent + '%' })})])]),_vm._v(" "),_c('div',{staticClass:"allModules"},[_c('a',{staticClass:"goToALLmodules",on:{"click":_vm.openModulesModal}},[_vm._v(_vm._s(_vm.$t('pages.allModules')))])])])]),_vm._v(" "),_c('AllModulesModal',{ref:"allModulesModalRef",attrs:{"active-modules-percent":_vm.activeModulesPercent,"active-modules":_vm.activeModules,"inactive-modules":_vm.inactiveModules}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-icons"},[_c('div',{staticClass:"icon-item active"},[_c('img',{attrs:{"src":__webpack_require__("nZuH")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M6xv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dispatch_vue__ = __webpack_require__("oVBA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f70306_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dispatch_vue__ = __webpack_require__("67b5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dispatch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f70306_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dispatch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M8kF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268d686c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("T1L0");
function injectStyle (ssrContext) {
  __webpack_require__("4+xT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268d686c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9c6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MAOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MCNz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProformaEdit_vue__ = __webpack_require__("zre5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8ccdea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProformaEdit_vue__ = __webpack_require__("lkiV");
function injectStyle (ssrContext) {
  __webpack_require__("YZnw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a8ccdea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProformaEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8ccdea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProformaEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MDZD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 454.7 145.5"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 454.7 145.5","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_1_","y":"43.8","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_3_","d":"M0,92.7V52.8c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H9C4,101.7,0,97.7,0,92.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,101.7V43.8h57.9v57.9H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_5_","x":"270.9","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_7_","d":"M270.9,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C275,57.9,270.9,53.9,270.9,48.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M270.9,57.9V0h57.9v57.9H270.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_9_","x":"270.9","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_11_","d":"M270.9,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9\n            C275,145.5,270.9,141.5,270.9,136.5z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M270.9,145.5V87.6h57.9v57.9H270.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_13_","x":"347.8","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_15_","d":"M347.8,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C351.9,57.9,347.8,53.9,347.8,48.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M347.8,57.9V0h57.9v57.9H347.8z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_17_","x":"347.8","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_19_","d":"M347.8,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9\n            C351.9,145.5,347.8,141.5,347.8,136.5z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M347.8,145.5V87.6h57.9v57.9H347.8z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_21_","x":"368.4","y":"43.8","width":"86.3","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_23_","d":"M368.4,92.7V52.8c0-5,4-9,9-9h68.2c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-68.2\n            C372.4,101.7,368.4,97.7,368.4,92.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st2",attrs:{"d":"M368.4,101.7V43.8h86.2v57.9H368.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_25_","x":"194","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st13"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_27_","d":"M194,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H203C198,57.9,194,53.9,194,48.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('path',{staticClass:"st2",attrs:{"d":"M194,57.9V0h57.9v57.9H194z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_29_","x":"116.9","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_30_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_29_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_31_","d":"M116.9,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C121,57.9,116.9,53.9,116.9,48.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_32_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_31_"}})]),_vm._v(" "),_c('g',{staticClass:"st16"},[_c('path',{staticClass:"st2",attrs:{"d":"M116.9,57.9V0h57.9v57.9H116.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_33_","x":"46","y":"43.8","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_34_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_33_"}})]),_vm._v(" "),_c('g',{staticClass:"st17"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_35_","d":"M46,92.7V52.8c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H55C50,101.7,46,97.7,46,92.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_36_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_35_"}})]),_vm._v(" "),_c('g',{staticClass:"st18"},[_c('path',{staticClass:"st2",attrs:{"d":"M46,101.7V43.8h57.9v57.9H46z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_37_","x":"43.8","y":"0","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_38_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_37_"}})]),_vm._v(" "),_c('g',{staticClass:"st19"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_39_","d":"M52.8,0h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H52.8c-5,0-9-4-9-9V9C43.8,4,47.8,0,52.8,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_40_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_39_"}})]),_vm._v(" "),_c('g',{staticClass:"st20"},[_c('path',{staticClass:"st2",attrs:{"d":"M43.8,0h57.9v57.9H43.8V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_41_","x":"43.8","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_42_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_41_"}})]),_vm._v(" "),_c('g',{staticClass:"st21"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_43_","d":"M52.8,87.6h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H52.8c-5,0-9-4-9-9V96.6C43.8,91.6,47.8,87.6,52.8,87.6z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_44_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_43_"}})]),_vm._v(" "),_c('g',{staticClass:"st22"},[_c('path',{staticClass:"st2",attrs:{"d":"M43.8,87.6h57.9v57.9H43.8V87.6z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_45_","x":"116.9","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_46_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_45_"}})]),_vm._v(" "),_c('g',{staticClass:"st23"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_47_","d":"M125.9,87.6h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9c-5,0-9-4-9-9V96.6C116.9,91.6,121,87.6,125.9,87.6\n            z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_48_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_47_"}})]),_vm._v(" "),_c('g',{staticClass:"st24"},[_c('path',{staticClass:"st2",attrs:{"d":"M116.9,87.6h57.9v57.9h-57.9V87.6z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_49_","x":"194","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_50_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_49_"}})]),_vm._v(" "),_c('g',{staticClass:"st25"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_51_","d":"M194,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H203C198,145.5,194,141.5,194,136.5z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_52_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_51_"}})]),_vm._v(" "),_c('g',{staticClass:"st26"},[_c('path',{staticClass:"st2",attrs:{"d":"M194,145.5V87.6h57.9v57.9H194z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_53_","x":"10.2","y":"10.2","width":"433.8","height":"125.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_54_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_53_"}})]),_vm._v(" "),_c('g',{staticClass:"st27"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_55_","d":"M24.2,10.2h405.9c7.7,0,14,6.3,14,14v97.1c0,7.7-6.3,14-14,14H24.2c-7.7,0-14-6.3-14-14V24.2\n            C10.2,16.5,16.5,10.2,24.2,10.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_56_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_55_"}})]),_vm._v(" "),_c('g',{staticClass:"st28"},[_c('path',{staticClass:"st29",attrs:{"d":"M10.2,10.2H444v125.1H10.2V10.2z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_57_","x":"177.2","y":"25.2","width":"95.1","height":"95.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_58_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_57_"}})]),_vm._v(" "),_c('g',{staticClass:"st30"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"t12_59_","cx":"224.7","cy":"72.8","r":"47.6"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_60_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_59_"}})]),_vm._v(" "),_c('g',{staticClass:"st31"},[_c('path',{staticClass:"st2",attrs:{"d":"M177.2,25.2h95.1v95.1h-95.1V25.2z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MME9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){_vm.saveMyOrder()}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.modalOrderTitle))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Comanda pentru locatia")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit || _vm.isReception || _vm.isValidate},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                    "+_vm._s(loc.name)+"\n                  ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Din locatiile cu gestiune tip depozit")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDepositLocationId),expression:"selectedDepositLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit || _vm.isReception || _vm.isValidate},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedDepositLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează locația depozit")]),_vm._v(" "),_vm._l((_vm.locationsWithDepositGestiune),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                  "+_vm._s(loc.name)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"serie"}},[_vm._v(_vm._s(_vm.$t('invoice.series'))+"*")]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Selectează seria","disabled":_vm.isReception || _vm.isValidate},on:{"change":_vm.handleSerieChange},model:{value:(_vm.myOrder.serie),callback:function ($$v) {_vm.$set(_vm.myOrder, "serie", $$v)},expression:"myOrder.serie"}},_vm._l((_vm.seriesOptionsWithAdd),function(serie){return _c('el-option',{key:serie.id,attrs:{"label":serie.id === 'add' ? serie.name : ((serie.name) + " - " + (serie.currentNumber)),"value":serie.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"data"}},[_vm._v(_vm._s(_vm.$t('gestiune.data')))]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"Selectează data"},model:{value:(_vm.myOrder.date),callback:function ($$v) {_vm.$set(_vm.myOrder, "date", $$v)},expression:"myOrder.date"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProductInOrder')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[(_vm.isReception || _vm.isValidate)?_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.productName'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.codeProduct'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.unitMeasure'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.quantityScriptic'))+"*")]),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.quantityFaptic'))+"*")]):_vm._e(),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('th',[_vm._v("Preț fără TVA")]):_vm._e(),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('th',[_vm._v(_vm._s(_vm.$t('invoice.vatPercent')))]):_vm._e(),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('th',[_vm._v(_vm._s(_vm.$t('invoice.vatValue')))]):_vm._e(),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('general.actions')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[(_vm.isReception || _vm.isValidate)?_c('td',[_vm._v("\n              "+_vm._s(_vm.gestiuneOptions.find(function (g) { return g.id === item.gestiune; }).name || '—')+"\n            ")]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(typeof item.productName === 'object' ? item.productName.name : item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.unitMeasure))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.quantity_scriptic))]),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.quantity_faptic),expression:"item.quantity_faptic",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(item.quantity_faptic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity_faptic", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]):_vm._e(),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('td',[_vm._v(_vm._s(item.pret_fara_tva))]):_vm._e(),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('td',[_vm._v(_vm._s(item.tva_percent))]):_vm._e(),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('td',[_vm._v(_vm._s(item.vatValue))]):_vm._e(),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",class:{ disabled: _vm.isReception || _vm.isValidate },attrs:{"disabled":_vm.isReception || _vm.isValidate},on:{"click":function($event){_vm.removeItem(index)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.delete'))+"\n              ")])])])}),_vm._v(" "),(!_vm.isReception && !_vm.isValidate)?_c('tr',[_c('td',{staticStyle:{"width":"250px !important"}},[_c('v-select',{attrs:{"options":_vm.searchResults,"label":"name","placeholder":"Caută un produs...","filterable":false},on:{"search":function($event){_vm.onInputSearch($event)},"input":_vm.onProductSelected},model:{value:(_vm.newItem.productName),callback:function ($$v) {_vm.$set(_vm.newItem, "productName", $$v)},expression:"newItem.productName"}},[[(!_vm.loading)?_c('span',[_vm._v("Niciun produs găsit")]):_vm._e()]],2),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.code),expression:"newItem.code"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Cod","disabled":""},domProps:{"value":(_vm.newItem.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "code", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.unitMeasure),expression:"newItem.unitMeasure"}],staticClass:"form-control",attrs:{"disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newItem, "unitMeasure", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":_vm.newItem.unitMeasure}},[_vm._v(_vm._s(_vm.newItem.unitMeasure))])])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.quantity_scriptic),expression:"newItem.quantity_scriptic",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.quantityScriptic')},domProps:{"value":(_vm.newItem.quantity_scriptic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "quantity_scriptic", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.quantity_faptic),expression:"newItem.quantity_faptic",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.quantityFaptic')},domProps:{"value":(_vm.newItem.quantity_faptic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "quantity_faptic", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]):_vm._e(),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.pret_fara_tva),expression:"newItem.pret_fara_tva",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Preț fără TVA"},domProps:{"value":(_vm.newItem.pret_fara_tva)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "pret_fara_tva", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]):_vm._e(),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.tva_percent),expression:"newItem.tva_percent",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.newItem.tva_percent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "tva_percent", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]):_vm._e(),_vm._v(" "),(_vm.isReception || _vm.isValidate)?_c('td',[_c('input',{staticClass:"form-control",attrs:{"type":"number","disabled":""},domProps:{"value":_vm.calculateVatValue(_vm.newItem)}})]):_vm._e(),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.addItem}},[_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])])]):_vm._e()],2)])])]),_vm._v(" "),_c('ManagementSeriesAdd',{attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations,"vat-number":_vm.selectedLocation ? _vm.selectedLocation.inv_fiscal_code : ''},on:{"getSeries":_vm.getSeries}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MNRc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationGroups_vue__ = __webpack_require__("Jz9u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32a83414_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationGroups_vue__ = __webpack_require__("xE4N");
function injectStyle (ssrContext) {
  __webpack_require__("YyuL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32a83414"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationGroups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32a83414_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationGroups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MNoZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"msub-cal__head"},[_c('div',{staticClass:"msub-cal__nav"},[_c('a',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){_vm.changeMonth(-1)}}},[_c('i',{staticClass:"fa fa-chevron-left"})]),_vm._v(" "),_c('strong',{staticClass:"msub-cal__month"},[_vm._v(_vm._s(_vm.monthLabel))]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){_vm.changeMonth(1)}}},[_c('i',{staticClass:"fa fa-chevron-right"})])]),_vm._v(" "),_c('div',{staticClass:"msub-cal__legend"},[_c('span',[_c('i',{staticClass:"msub-cal__dot msub-cal__dot--custom"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.calendarCustom')))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"msub-cal__dot msub-cal__dot--default"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.calendarDefault')))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"msub-cal__dot msub-cal__dot--off"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.calendarNoDelivery')))])])]),_vm._v(" "),_c('small',{staticClass:"text-muted msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.calendarHint')))]),_vm._v(" "),(!_vm.menus.length && !_vm.loading)?_c('p',{staticClass:"msub-cal__warn"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.calendarNoMenus'))+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"msub-cal"},[_vm._l((_vm.weekLabels),function(label){return _c('div',{key:'wl' + label,staticClass:"msub-cal__weekday"},[_vm._v(_vm._s(label))])}),_vm._v(" "),_vm._l((_vm.cells),function(cell){return _c('div',{key:cell.date,staticClass:"msub-cal__cell",class:{
             'is-other-month': !cell.inMonth,
             'is-past': cell.past,
             'is-off': !cell.delivery,
             'is-selected': _vm.isSelected(cell.date),
             'is-today': cell.date === _vm.today,
             'is-selectable': cell.selectable
           },on:{"click":function($event){_vm.toggle(cell)}}},[_c('div',{staticClass:"msub-cal__day"},[_vm._v(_vm._s(cell.day))]),_vm._v(" "),(cell.delivery)?[(cell.menuId && _vm.menuName(cell.menuId))?_c('div',{staticClass:"msub-cal__menu msub-cal__menu--custom"},[_vm._v(_vm._s(_vm.menuName(cell.menuId)))]):(_vm.defaultMenu)?_c('div',{staticClass:"msub-cal__menu msub-cal__menu--default"},[_vm._v(_vm._s(_vm.defaultMenu.name))]):_c('div',{staticClass:"msub-cal__menu msub-cal__menu--none"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.calendarNoMenu')))])]:_c('div',{staticClass:"msub-cal__menu msub-cal__menu--off"},[_vm._v("\n          "+_vm._s(cell.menuId && _vm.menuName(cell.menuId) ? _vm.menuName(cell.menuId) + ' · ' : '')+_vm._s(_vm.$t('menuSubscriptions.calendarNoDeliveryShort'))+"\n        ")])],2)})],2),_vm._v(" "),_c('div',{staticClass:"msub-cal__select-tools"},[_c('a',{staticClass:"btn btn-sm btn-default",on:{"click":_vm.selectMonth}},[_c('i',{staticClass:"fa fa-check-square-o"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.selectMonth')))]),_vm._v(" "),(_vm.selected.length)?_c('a',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){_vm.selected = []}}},[_c('i',{staticClass:"fa fa-square-o"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.clearSelection')))]):_vm._e()]),_vm._v(" "),(_vm.selected.length)?_c('div',{staticClass:"msub-cal__actions"},[_c('div',{staticClass:"msub-cal__actions-title"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.selectedDays', { count: _vm.selected.length })))]),_vm._v(" "),_c('div',{staticClass:"msub-cal__actions-row"},[_c('el-select',{attrs:{"filterable":"","placeholder":_vm.$t('menuSubscriptions.chooseMenu')},model:{value:(_vm.assignMenuId),callback:function ($$v) {_vm.assignMenuId=$$v},expression:"assignMenuId"}},_vm._l((_vm.menus),function(menu){return _c('el-option',{key:'am' + menu.id,attrs:{"label":menu.name + (menu.is_default ? ' (' + _vm.$t('menuSubscriptions.defaultMenu') + ')' : ''),"value":menu.id}})})),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-purple-light btn-fill",attrs:{"disabled":!_vm.assignMenuId || _vm.saving},on:{"click":function($event){_vm.assign(_vm.assignMenuId)}}},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.applyMenu')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-default",attrs:{"disabled":_vm.saving},on:{"click":function($event){_vm.assign(null)}}},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.resetToDefault')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-purple",attrs:{"disabled":_vm.saving},on:{"click":function($event){_vm.$emit('new-menu-for-dates', _vm.selected)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.newMenuForDays')))])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MR49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_menu_item_group_css__ = __webpack_require__("V5v9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_menu_item_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_menu_item_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group__ = __webpack_require__("D8db");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_menu_item_css__ = __webpack_require__("/bpg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_menu_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_menu_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item__ = __webpack_require__("ACGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_menu_css__ = __webpack_require__("bwiK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu__ = __webpack_require__("SExR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SettingsMenu__ = __webpack_require__("bukA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Users_Users_vue__ = __webpack_require__("SvXL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Users_UserForm_vue__ = __webpack_require__("HOa3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__OrderingManagement_OrderingManagement__ = __webpack_require__("pznp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__TableManagement_TableManagement__ = __webpack_require__("+suy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__TableManagement_TableManagementForm__ = __webpack_require__("kQ0V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__TableZones_TableZones__ = __webpack_require__("C47s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__TableZones_TableZonesForm__ = __webpack_require__("YngB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__MeasurementsUnits_MeasurementsUnitsForm__ = __webpack_require__("QHzq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__MeasurementsUnits_MeasurementsUnits__ = __webpack_require__("G6CG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__PaymentGroups_PaymentGroups__ = __webpack_require__("cOLK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__PaymentGroups_PaymentGroupsForm__ = __webpack_require__("vizI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreen_vue__ = __webpack_require__("/6y3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__RewardProgram_RewardProgramForm_vue__ = __webpack_require__("RYO5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__InfoPages_InfoPages_vue__ = __webpack_require__("TUUy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Tabs_Taxes_vue__ = __webpack_require__("sAdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Tabs_Tips_vue__ = __webpack_require__("CpwN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Tabs_App_vue__ = __webpack_require__("AnFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Tabs_Services_vue__ = __webpack_require__("oqzg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Tabs_CompanyWeb_vue__ = __webpack_require__("XKKy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__LocationGroups_LocationGroups_vue__ = __webpack_require__("MNRc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Tabs_CompanyDetails_vue__ = __webpack_require__("1hFq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Printer_Printers_vue__ = __webpack_require__("KNB5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Tabs_CompanyLocations_vue__ = __webpack_require__("0WcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Locations_Location_vue__ = __webpack_require__("W4Mh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Tabs_Currency_vue__ = __webpack_require__("LPdL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Tabs_DateTime_vue__ = __webpack_require__("kzgQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Tabs_PushNotifications_vue__ = __webpack_require__("2Igw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__LocationGroups_LocationGroupsForm_vue__ = __webpack_require__("s1f/");




















var _components;



































__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group___default.a);
__WEBPACK_IMPORTED_MODULE_19_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_menu___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu_item_group___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'SettingsMenu', __WEBPACK_IMPORTED_MODULE_22__SettingsMenu__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'UserForm', __WEBPACK_IMPORTED_MODULE_24__Users_UserForm_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'OrderingManagement', __WEBPACK_IMPORTED_MODULE_25__OrderingManagement_OrderingManagement__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'TableManagementList', __WEBPACK_IMPORTED_MODULE_26__TableManagement_TableManagement__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'TableManagementForm', __WEBPACK_IMPORTED_MODULE_27__TableManagement_TableManagementForm__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'TableZoneList', __WEBPACK_IMPORTED_MODULE_28__TableZones_TableZones__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'TableZoneForm', __WEBPACK_IMPORTED_MODULE_29__TableZones_TableZonesForm__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'MeasurementsUnitsForm', __WEBPACK_IMPORTED_MODULE_30__MeasurementsUnits_MeasurementsUnitsForm__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'MeasurementsUnitsList', __WEBPACK_IMPORTED_MODULE_31__MeasurementsUnits_MeasurementsUnits__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PaymentGroupsList', __WEBPACK_IMPORTED_MODULE_32__PaymentGroups_PaymentGroups__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PaymentGroupsForm', __WEBPACK_IMPORTED_MODULE_33__PaymentGroups_PaymentGroupsForm__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'RewardForm', __WEBPACK_IMPORTED_MODULE_35__RewardProgram_RewardProgramForm_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'InfoPages', __WEBPACK_IMPORTED_MODULE_36__InfoPages_InfoPages_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'TaxForm', __WEBPACK_IMPORTED_MODULE_37__Tabs_Taxes_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'TipsForm', __WEBPACK_IMPORTED_MODULE_38__Tabs_Tips_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'AppForm', __WEBPACK_IMPORTED_MODULE_39__Tabs_App_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'AppServices', __WEBPACK_IMPORTED_MODULE_40__Tabs_Services_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CompanyWebForm', __WEBPACK_IMPORTED_MODULE_41__Tabs_CompanyWeb_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'locationGroups', __WEBPACK_IMPORTED_MODULE_42__LocationGroups_LocationGroups_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CompanyDetails', __WEBPACK_IMPORTED_MODULE_43__Tabs_CompanyDetails_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CompanyLocations', __WEBPACK_IMPORTED_MODULE_45__Tabs_CompanyLocations_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'Printers', __WEBPACK_IMPORTED_MODULE_44__Printer_Printers_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'Locations', __WEBPACK_IMPORTED_MODULE_46__Locations_Location_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'CurrencyForm', __WEBPACK_IMPORTED_MODULE_47__Tabs_Currency_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'DatetimeForm', __WEBPACK_IMPORTED_MODULE_48__Tabs_DateTime_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PushNotifications', __WEBPACK_IMPORTED_MODULE_49__Tabs_PushNotifications_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'UsersList', __WEBPACK_IMPORTED_MODULE_23__Users_Users_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'LocationGroupsForm', __WEBPACK_IMPORTED_MODULE_50__LocationGroups_LocationGroupsForm_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'OrderScreen', __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreen_vue__["a" /* default */]), _components),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vee_validate__["b" /* mapFields */])(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity']), {
    formattedUsers: function formattedUsers() {
      return this.posUsers.map(function (user) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user, {
          fullname: user.firstname + ' ' + user.lastname });
      });
    }
  }),
  data: function data() {
    return {
      posUsers: [],
      pickerOptions1: {},
      tabName: 'My Profile',
      currentTab: '',
      isMyProfile: true,
      isUsers: false,
      isCompanyDetails: false,
      isPrinters: false,
      isDateTime: false,
      isCurrency: false,
      isServices: false,
      isPaymentGroups: false,
      isPush: false,
      isTable: false,
      isTaxLabeling: false,
      isTableManager: false,
      isTableZones: false,
      isMeasurementsUnits: false,
      isCompanyWeb: false,
      selectedUser: false,
      selectedTable: false,
      selectedZone: false,
      selectedMeasurementsUnits: false,
      selectedPaymentGroups: false,
      selectedLocationGroups: false,
      pickerNames: ['date_from', 'date_to'],
      days: [this.$t('days.monday'), this.$t('days.tuesday'), this.$t('days.wednesday'), this.$t('days.thursday'), this.$t('days.friday'), this.$t('days.saturday'), this.$t('days.sunday')],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      mainCategories: [],
      optionTypes: ['checkbox', 'radiobox', 'dropdown'],
      locations: [],
      model: {},
      user: JSON.parse(this.$session.get('userData')),
      defaultData: {
        'available_languages': {},
        'countries': {},
        'currencies': {},
        'currency_display_format': [],
        'date_formats': [],
        'time_formats': [],
        'timezones': {},
        'push_notifications': []
      },
      timeformats: [{ format: 'H:mm', example: '15:40' }, { format: 'h:mm a', example: '3:40 pm' }],
      dateformats: [{ format: 'DD/MM/YYYY', example: '15/03/2018' }, { format: 'MM/DD/YYYY', example: '03/15/2018' }, { format: 'MMMM D, YYYY', example: 'March 15, 2018' }],
      newLocation: {
        'street': '',
        'city': '',
        'state': '',
        'country': ''
      },
      modelValidations: {},
      modelValidate: {},
      taxes: [],
      websiteData: []
    };
  },
  created: function created() {
    var _this = this;

    var data = {
      token: this.$session.get('token')
    };

    console.log('Created SettingsGeneral.vue', this.user);
    var self = this;
    if (self.$session.get('userDataRole') === 'MARKETER') {
      self.$router.push('/products');
    }
    var companyID = this.$session.get('selectedCompany');

    this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response2) {
      if (response2.status === true) {
        self.model = response2.data[0];
        self.model.selected_languages = response2.data[0].languages.map(function (lang) {
          return {
            value: lang.id,
            label: lang.name
          };
        });
      }
    });

    var taxesData = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };

    this.apiRequest('/listdefaults', 'GET', data, function (response) {
      if (response.status === true) {
        self.defaultData = response.data[0];
        self.defaultData['push_notifications'] = response.data[0]['push_notifications'];
      }
    });

    this.apiRequest('/settings/taxes', 'GET', taxesData, function (response) {
      if (response.status === true) {
        self.taxes = response.data;
      }
    });

    this.apiRequest('/settings/website', 'GET', taxesData, function (response) {
      if (response.status === true) {
        self.websiteData = response.data;
      }
    });

    var tab = this.$session.get('selectedTab');

    if (tab !== undefined && tab !== '') {
      this.tabName = tab;
      this.$session.set('selectedTab', '');
    }
    this.$bus.$on('upload', function (payload) {
      self.model.locations_details.forEach(function (value, index) {
        if (value.id === payload.id) {
          value.upload = payload.file;
        }
      });
    });
    this.$bus.$on('remove-upload', function (payload) {
      self.model.locations_details.forEach(function (value, index) {
        if (value.id === payload.id) {
          value.upload = null;
          value.qr_code = null;
          value.qr_code_url = null;
        }
      });
    });
    this.$bus.$on('upload-location-image', function (payload) {
      _this.model.locations_details.forEach(function (value, index) {
        if (value.id === payload.id) {
          _this.model.locations_details[index][payload.field] = payload.file;
        }
      });
    });
    this.$bus.$on('remove-upload-location-image', function (payload) {
      _this.model.locations_details.forEach(function (value, index) {
        if (value.id === payload.id) {
          _this.model.locations_details[index][payload.field] = null;
        }
      });
    });
    this.getPosUsers();
  },

  methods: {
    openTab: function openTab(tab) {
      this.isMyProfile = false;
      this.isUsers = false;
      this.isCompanyDetails = false;
      this.isPrinters = false;
      this.isDateTime = false;
      this.isCurrency = false;
      this.isServices = false;
      this.isPaymentGroups = false;
      this.isPush = false;
      this.isTaxLabeling = false;
      this.isTableManager = false;
      this.isTableZones = false;
      this.isMeasurementsUnits = false;
      this.isCompanyWeb = false;

      switch (tab) {
        case 'myProfile':
          this.isMyProfile = true;break;
        case 'users':
          this.isUsers = true;break;
        case 'companyDetails':
          this.isCompanyDetails = true;break;
        case 'printers':
          this.isPrinters = true;break;
        case 'dateTime':
          this.isDateTime = true;break;
        case 'currency':
          this.isCurrency = true;break;
        case 'services':
          this.isServices = true;break;
        case 'paymentGroups':
          this.isPaymentGroups = true;break;
        case 'push':
          this.isPush = true;break;
        case 'taxLabeling':
          this.isTaxLabeling = true;break;
        case 'tableManager':
          this.isTableManager = true;break;
        case 'tableZones':
          this.isTableZones = true;break;
        case 'measurementsUnits':
          this.isMeasurementsUnits = true;break;
        case 'companyWeb':
          this.isCompanyWeb = true;break;
      }
    },
    getPosUsers: function getPosUsers() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this2.posUsers = response.data.pos_user;
        }
      });
    },
    getData: function getData() {
      return [];
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (isValid) {
        _this3.$emit('on-submit', _this3.registerForm, isValid);
      });
    },
    addNewLocation: function addNewLocation() {
      var locationCopy = this.newLocation;
      var newRow = [];
      newRow = this.newLocation;
      newRow.location_id = '';
      newRow.location_id = 'new_' + Math.round(Math.random() * 10000);

      if (this.locations === undefined) {
        this.locations = [];
      }

      this.locations.push(newRow);
      this.newLocation = locationCopy;
    },
    goToRecordUser: function goToRecordUser(row, event, column) {
      this.globalGoToRecord(row, event, column, '/user/edit/');
    },
    onUserSubmit: function onUserSubmit(model, isValid) {},
    updateList: function updateList() {
      this.selectedUser = false;
      if (this.$refs.userList) {
        this.$refs.userList.getData();
      }
    },
    tableManagementUpdate: function tableManagementUpdate() {
      this.selectedTable = false;
      if (this.$refs.tableManagement) {
        this.$refs.tableManagement.getData();
      }
    },
    measurementsUnitsUpdate: function measurementsUnitsUpdate() {
      this.selectedMeasurementsUnits = false;
      if (this.$refs.tableMeasurementsUnits) {
        this.$refs.tableMeasurementsUnits.getData();
      }
    },
    tableZoneUpdate: function tableZoneUpdate() {
      this.selectedZone = false;
      if (this.$refs.tableZone) {
        this.$refs.tableZone.getData();
      }
    },
    paymentGroupsUpdate: function paymentGroupsUpdate() {
      this.selectedPaymentGroups = false;
      if (this.$refs.paymentGroups) {
        this.$refs.paymentGroups.getData();
      }
    },
    getTable: function getTable(id) {
      this.selectedTable = id;
    },
    getMeasurementsUnits: function getMeasurementsUnits(id) {
      this.selectedMeasurementsUnits = id;
    },
    getZone: function getZone(id) {
      this.selectedZone = id;
    },
    getPaymentGroups: function getPaymentGroups(id) {
      this.selectedPaymentGroups = id;
    },
    getUser: function getUser(id) {
      this.selectedUser = id;
    },
    updateLocationGroups: function updateLocationGroups() {
      this.selectedLocationGroups = false;
      if (this.$refs.LocationGroups) {
        this.$refs.LocationGroups.getData();
      }
    },
    getLocationGroups: function getLocationGroups(id) {
      this.selectedLocationGroups = id;
    },
    setSelectedTab: function setSelectedTab(value) {
      this.tabName = value;
    },
    setTaxes: function setTaxes() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/settings/taxes', 'GET', data, function (response) {
        if (response.status === true) {
          _this4.taxes = response.data;
        }
      });
    },
    updateModelData: function updateModelData(data) {
      this.model = data;
      if (data.languages) {
        this.model.selected_languages = data.languages.map(function (lang) {
          return {
            value: lang.id,
            label: lang.name
          };
        });
      }
    }
  }
});

/***/ }),

/***/ "MWby":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_data_tables__);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      loading: true,
      tableData: [],
      pagesize: 10,
      company_id: null
    };
  },
  created: function created() {
    this.company_id = this.$session.get('selectedCompany');
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.company_id
      };
      this.apiRequest('/show-invoice-from-company', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data.invoices;
          _this.loading = false;

          setTimeout(function () {
            _this.pagesize = 999;
          }, 100);
        }
      });
    },
    convertToMounth: function convertToMounth(date) {
      var dateObj = new Date(date);
      var month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      return month + '-' + dateObj.getFullYear();
    },
    showInvoice: function showInvoice(series, number) {
      var link = '?number=' + btoa(number);
      link += '&series=' + btoa(series);
      link += '&pass=zGCoxq92n24P';
      return "https://gatewaydev.taptasty.com/" + '/show-invoice' + link;
    }
  }
});

/***/ }),

/***/ "MWvD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SpinningWheelCampaignForm_vue__ = __webpack_require__("qgrA");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SpinningWheelCampaignForm: __WEBPACK_IMPORTED_MODULE_0__SpinningWheelCampaignForm_vue__["a" /* default */] },
  props: {
    route: { type: Object, default: function _default() {
        return {};
      } }
  }
});

/***/ }),

/***/ "MXb/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MY36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r1_vue__ = __webpack_require__("arw6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de64e79_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r1_vue__ = __webpack_require__("y1da");
function injectStyle (ssrContext) {
  __webpack_require__("hPfU")
  __webpack_require__("x5cH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5de64e79"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de64e79_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MYzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketplaceOrderSettings_vue__ = __webpack_require__("6ESu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1342de47_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketplaceOrderSettings_vue__ = __webpack_require__("ouLj");
function injectStyle (ssrContext) {
  __webpack_require__("dZc2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1342de47"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketplaceOrderSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1342de47_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketplaceOrderSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee728cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("t5bk");
function injectStyle (ssrContext) {
  __webpack_require__("j9Hv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ee728cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ma48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",[_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "McWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-md-12 "},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12 mb-10"},[_c('div',{staticClass:"pull-left"},[_c('label',{attrs:{"for":"","id":"homepage_text"}},[_vm._v(_vm._s(_vm.homepageText))]),_vm._v(" "),[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.homepage),callback:function ($$v) {_vm.homepage=$$v},expression:"homepage"}})]],2),_vm._v(" "),_c('div',{staticClass:"pull-right "},[(!_vm.homepage)?_c('router-link',{staticClass:"btn btn-icon btn-info add mar-bt-20",attrs:{"to":{ path: '/marketing/offers/add'},"title":_vm.$t('general.add') + ' ' + _vm.$t('marketingOffers.single')}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")]):_c('button',{staticClass:"btn add mar-bt-20",on:{"click":function($event){_vm.triggerModal = !_vm.triggerModal}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('marketingOffers.addGroup'))+"\n            ")])],1)]),_vm._v(" "),(!_vm.homepage)?_c('table',{ref:"sortableTable",staticClass:"table width-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"5%"}}),_vm._v(" "),_c('th',{attrs:{"width":"15%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.image')))]),_vm._v(" "),_c('th',{attrs:{"width":"15%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.title')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.status')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.linkType')))]),_vm._v(" "),_c('th',{attrs:{"width":"25%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.startEndDate')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.actions')))]),_vm._v(" "),_c('th',{attrs:{"width":"25%"}})])]),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody'},on:{"end":_vm.adjustSort},model:{value:(_vm.tableData),callback:function ($$v) {_vm.tableData=$$v},expression:"tableData"}},[_vm._l((_vm.tableData),function(item,index){return [_c('tr',{key:item.id,staticClass:"sortableRow"},[_c('td',[_c('i',{staticClass:"fa fa-arrows sortHandle",staticStyle:{"cursor":"move","color":"#7C8DB5"}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"image-table"},[_c('img',{attrs:{"src":(item.image)?item.image : ''}})])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(item)}},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}})]],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.link_type))]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.formatDate(item.date_start))+" - "+_vm._s(_vm.formatDate(item.date_end)))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.handleDelete(index, item, $event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('general.delete'))+"\n                  ")])]),_vm._v(" "),_c('td',{staticClass:"edit-icon-pointer",on:{"click":function($event){_vm.goToRecord(item,[],[], $event)}}},[_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                  ")])])])]})],2)],1):_c('group',{attrs:{"triggerModal":_vm.triggerModal}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_perfect_scrollbar__ = __webpack_require__("Fiov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_perfect_scrollbar_dist_css_perfect_scrollbar_css__ = __webpack_require__("ieps");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_perfect_scrollbar_dist_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_perfect_scrollbar_dist_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);

















__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'tapTasty'
    },
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['white', 'brown', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'static/img/logo-taptasty.png'
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {
    var _this = this;

    if (localStorage['tapTastyMenu_cache_date_' + this.$session.get('selectedCompany')]) {
      window.cache_date = new Date(localStorage['tapTastyMenu_cache_date_' + this.$session.get('selectedCompany')]);
    }
    if (this.$session.get('selectedCompanyData').default_location_for_admin_order) {
      this.default_location_for_admin_order = this.$session.get('selectedCompanyData').default_location_for_admin_order;
    }
    this.$bus.$off('fiscalEvent');
    this.$bus.$on('fiscalEvent', this.printFiscal);
    this.$bus.$off('fiscalPosPayment');
    this.$bus.$on('fiscalPosPayment', this.fiscalPosPayment);
    this.$bus.$off('getRaport');
    this.$bus.$on('getRaport', this.getRaport);
    this.minimizeSidebar();
    this.$nextTick(function () {
      _this.startPlaySound();
    });
    this.userRole = this.$session.get('userDataRole');
    this.$bus.$on('stopSound', this.handleStopSound);
    this.getCounter();
    setInterval(function () {
      if (!_this.timeoutCounters) {
        _this.getCounter();
      }
    }, 1000 * 60);
  },
  data: function data() {
    return {
      all_waiter_calls: [],
      printFiscalDisabled: false,
      fiscalPosPaymentDisabled: false,
      default_location_for_admin_order: null,
      children: [],
      timeoutCounters: null,
      collapsed: true,
      heartbeatSet: false,
      newOrdersCount: 0,
      processingOrdersCount: 0,
      ordersCheckIn: 0,
      ordersWithSound: 0,
      oldOrdersCheckIn: 0,
      audioFile: null,
      audioPlayed: true,
      userRole: null,
      hideOwnerOnlyLinks: false,
      orderFiscalError: false,
      showSupportLocationModal: false,
      selectedSupportLocationToken: '',
      supportLocations: [],
      supportWidgetLocationToken: '',
      supportScriptHost: null,
      supportLinkObserver: null,
      supportWidgetLoading: false
    };
  },

  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    }
  },
  methods: {
    toggleAlertMenu: function toggleAlertMenu(ref, shouldAlert) {
      var component = Array.isArray(ref) ? ref[0] : ref;
      var el = component && component.$el;
      if (!el || !el.classList) {
        return;
      }
      if (shouldAlert) {
        el.classList.add('alert-menu');
      } else {
        el.classList.remove('alert-menu');
      }
    },
    getSupportLocations: function getSupportLocations() {
      var company = this.$session.get('selectedCompanyData') || {};
      return (company.locations_details || []).filter(function (location) {
        return location && location.token;
      });
    },
    getSupportUserId: function getSupportUserId() {
      try {
        return JSON.parse(this.$session.get('userData')).id || null;
      } catch (e) {
        return null;
      }
    },
    onSupportTicketClick: function onSupportTicketClick() {
      var _this2 = this;

      var locations = this.getSupportLocations();
      if (!locations.length || !this.$session.get('selectedCompany')) {
        return;
      }
      if (locations.length === 1) {
        var locationToken = locations[0].token;
        this.openSupportLocationSelect(locationToken);
        this.$nextTick(function () {
          _this2.loadAndOpenSupportWidget(locationToken);
        });
        return;
      }
      this.openSupportLocationSelect();
    },
    openSupportLocationSelect: function openSupportLocationSelect(preselectToken) {
      var locations = this.getSupportLocations();
      if (!locations.length) {
        return;
      }
      this.supportLocations = locations;
      this.selectedSupportLocationToken = preselectToken || this.supportWidgetLocationToken || (locations.length === 1 ? locations[0].token : '');
      this.showSupportLocationModal = true;
    },
    closeSupportLocationModal: function closeSupportLocationModal() {
      this.showSupportLocationModal = false;
    },
    confirmSupportLocation: function confirmSupportLocation() {
      if (!this.selectedSupportLocationToken || this.supportWidgetLoading) {
        return;
      }
      var locationToken = this.selectedSupportLocationToken;
      this.closeSupportLocationModal();
      this.loadAndOpenSupportWidget(locationToken);
    },
    handleSupportWidgetError: function handleSupportWidgetError(errorMessage, locationToken) {
      var _this3 = this;

      var knownError = 'Support widget token is not available for this location';
      var message = errorMessage === knownError ? this.$t('pages.supportWidgetTokenUnavailable') : errorMessage || this.$t('validations.wentWrong');

      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', message, 'error').then(function () {
        _this3.openSupportLocationSelect(locationToken);
      });
    },
    cleanupSupportWidget: function cleanupSupportWidget() {
      if (this.supportLinkObserver) {
        this.supportLinkObserver.disconnect();
        this.supportLinkObserver = null;
      }
      document.querySelectorAll('[data-taptasty-support-widget="true"]').forEach(function (node) {
        return node.remove();
      });
      if (this.supportScriptHost && this.supportScriptHost.parentNode) {
        this.supportScriptHost.parentNode.removeChild(this.supportScriptHost);
      }
      this.supportScriptHost = null;
      this.supportWidgetLocationToken = '';
    },
    loadAndOpenSupportWidget: function loadAndOpenSupportWidget(locationToken) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var companyId, existingLink, widgetHost, bootstrapUrl, response, payload, errorMessage, host, script;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                companyId = _this4.$session.get('selectedCompany');

                if (!(!companyId || !locationToken || _this4.supportWidgetLoading)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                if (!(_this4.supportWidgetLocationToken === locationToken && _this4.supportScriptHost)) {
                  _context.next = 10;
                  break;
                }

                existingLink = _this4.supportScriptHost.querySelector('a[data-taptasty-support-link="true"]');
                widgetHost = document.querySelector('[data-taptasty-support-widget="true"]');

                if (!(existingLink && widgetHost)) {
                  _context.next = 10;
                  break;
                }

                _this4.closeSupportLocationModal();

                setTimeout(function () {
                  existingLink.click();
                }, 0);
                return _context.abrupt('return');

              case 10:

                _this4.supportWidgetLoading = true;
                _this4.cleanupSupportWidget();

                _context.prev = 12;
                bootstrapUrl = 'https://superadmin.taptasty.com/api/public/support/widget/bootstrap' + '?company_id=' + encodeURIComponent(companyId) + '&location_id=' + encodeURIComponent(locationToken);
                _context.next = 16;
                return fetch(bootstrapUrl, {
                  method: 'GET',
                  credentials: 'omit',
                  headers: { Accept: 'application/json' }
                });

              case 16:
                response = _context.sent;
                _context.next = 19;
                return response.json().catch(function () {
                  return null;
                });

              case 19:
                payload = _context.sent;

                if (!(!response.ok || !payload || payload.success !== true || !payload.data)) {
                  _context.next = 24;
                  break;
                }

                errorMessage = payload && typeof payload.error === 'string' ? payload.error : _this4.$t('validations.wentWrong');

                _this4.handleSupportWidgetError(errorMessage, locationToken);
                return _context.abrupt('return');

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context['catch'](12);

                _this4.handleSupportWidgetError(_this4.$t('validations.wentWrong'), locationToken);
                return _context.abrupt('return');

              case 30:
                _context.prev = 30;

                _this4.supportWidgetLoading = false;
                return _context.finish(30);

              case 33:

                _this4.closeSupportLocationModal();

                window.TapTastySupportPayload = function () {
                  return {
                    userid: _this4.getSupportUserId(),
                    posid: null
                  };
                };

                host = document.createElement('div');

                host.style.display = 'none';
                host.setAttribute('data-taptasty-support-script-host', '1');
                document.body.appendChild(host);
                _this4.supportScriptHost = host;
                _this4.supportWidgetLocationToken = locationToken;

                _this4.supportLinkObserver = new MutationObserver(function () {
                  var link = host.querySelector('a[data-taptasty-support-link="true"]');
                  if (link) {
                    _this4.supportLinkObserver.disconnect();
                    _this4.supportLinkObserver = null;
                    link.click();
                  }
                });
                _this4.supportLinkObserver.observe(host, { childList: true });

                script = document.createElement('script');

                script.src = 'https://superadmin.taptasty.com/management/support-widget.js?t=' + Date.now();
                script.async = true;
                script.dataset.taptastySupportWidgetScript = '1';
                script.dataset.companyId = String(companyId);
                script.dataset.locationId = String(locationToken);
                script.dataset.mode = 'inline';
                script.dataset.class = 'buton-suport-custom';
                script.dataset.label = _this4.$t('pages.supportTicket');
                script.dataset.payloadSource = 'TapTastySupportPayload';
                host.appendChild(script);

              case 54:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[12, 26, 30, 33]]);
      }))();
    },
    markWaiterCallView: function markWaiterCallView(index, id) {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        call_id: id
      };
      this.apiRequest('/mark-call-resolved', 'GET', data, function (response) {
        if (response.status === true) {
          _this5.all_waiter_calls.splice(index, 1);
        }
      });
    },
    showRedNotice: function showRedNotice(show) {
      if (show) {
        this.$bus.$emit('RedNotice', 1);
      } else {
        this.$bus.$emit('RedNotice', 0);
      }
    },
    printFiscal: function printFiscal(data) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var totalToSend, printToIp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this6.printFiscalDisabled) {
                  _context2.next = 15;
                  break;
                }

                _this6.printFiscalDisabled = true;

                if (!(data.pay_method === 2 && data.with_pos)) {
                  _context2.next = 13;
                  break;
                }

                totalToSend = data.total;

                totalToSend = totalToSend.toFixed(2);
                totalToSend = totalToSend.replace(',', '');
                totalToSend = parseInt(totalToSend.replace('.', ''));

                _context2.next = 9;
                return _this6.getPrinterIp();

              case 9:
                printToIp = _context2.sent;

                _this6.localRequest(printToIp, '/api/Receipt', 'POST', '[\n' + '"POS^' + totalToSend + '"' + '\n]', function (response) {
                  data.capture_transaction_response = response.data;

                  if (response.data && response.data.ReceiptStatus) {
                    _this6.printFiscalNet(data.orderid, data);
                  } else {
                    _this6.fiscalPrintError(data.orderid);
                  }
                });
                _context2.next = 15;
                break;

              case 13:
                if (data.pay_method === 8) {
                  data.pay_method = 2;
                }
                _this6.printFiscalNet(data.orderid, data);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    fiscalPosPayment: function fiscalPosPayment(data) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var totalToSend, printToIp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this7.fiscalPosPaymentDisabled) {
                  _context3.next = 10;
                  break;
                }

                _this7.fiscalPosPaymentDisabled = true;
                totalToSend = data.total;

                totalToSend = totalToSend.toFixed(2);
                totalToSend = totalToSend.replace(',', '');
                totalToSend = parseInt(totalToSend.replace('.', ''));

                _context3.next = 8;
                return _this7.getPrinterIp();

              case 8:
                printToIp = _context3.sent;

                _this7.localRequest(printToIp, '/api/Receipt', 'POST', '[\n' + '"POS^' + totalToSend + '"' + '\n]', function (response) {
                  data.capture_transaction_response = response.data;

                  if (response.data && response.data.ReceiptStatus) {
                    _this7.fiscalPosPaymentDisabled = false;
                    _this7.$bus.$emit('completePaymentPos', data);
                  } else {
                    _this7.fiscalPosPaymentError(data.orderid);
                  }
                });

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    getRaport: function getRaport(raportType) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var printToIp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this8.getPrinterIp();

              case 2:
                printToIp = _context4.sent;

                if (raportType === 'X') {
                  _this8.localRequest(printToIp, '/api/Receipt', 'POST', '[\n' + '"X^",' + '\n]', function (response) {});
                }
                if (raportType === 'Z') {
                  _this8.localRequest(printToIp, '/api/Receipt', 'POST', '[\n' + '"Z^",' + '\n]', function (response) {});
                }

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this8);
      }))();
    },
    printFiscalNet: function printFiscalNet(orderid, data) {
      var _this9 = this;

      this.apiRequest('/noauth/print-fiscal-net/' + orderid + '/0', 'GET', data, function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(printerText) {
          var printToIp;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!printerText.status) {
                    _context5.next = 7;
                    break;
                  }

                  _context5.next = 3;
                  return _this9.getPrinterIp();

                case 3:
                  printToIp = _context5.sent;

                  _this9.localRequest(printToIp, '/api/Receipt', 'POST', '[\n' + printerText.data + '\n]', function (response) {
                    data.receipt_number = response.data;
                    data.receipt = printerText.data;
                    _this9.apiRequest('/noauth/print-fiscal-net-answer/' + orderid, 'POST', data, function (answer) {
                      if (response.data && response.data.ErrorCode === '') {
                        if (_this9.$route.query.print_fiscal) {
                          _this9.$router.push('/add-order');
                        }
                        _this9.printFiscalDisabled = false;
                        _this9.$bus.$emit('orders_pos_complete_order', data);
                      }
                    });
                    if (response.data && response.data.ErrorCode === '') {
                      _this9.orderFiscalError = '';
                    } else {
                      _this9.fiscalPrintError(data.orderid);
                    }
                  });
                  _context5.next = 8;
                  break;

                case 7:
                  _this9.fiscalPrintError(data.orderid);

                case 8:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, _this9);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getPrinterIp: function getPrinterIp() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var printToIp, d1, fpResp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                printToIp = null;

                if (!JSON.parse(_this10.$session.get('userData')).fiscal_printer_id) {
                  _context6.next = 11;
                  break;
                }

                if (!JSON.parse(_this10.$session.get('userData')).fiscal_printer) {
                  _context6.next = 6;
                  break;
                }

                printToIp = JSON.parse(_this10.$session.get('userData')).fiscal_printer.ip_port_printer;
                _context6.next = 11;
                break;

              case 6:
                d1 = {
                  'token': _this10.$session.get('token'),
                  'company_id': _this10.$session.get('selectedCompany')
                };
                _context6.next = 9;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this10.apiRequest('/fiscal-printer/' + JSON.parse(_this10.$session.get('userData')).fiscal_printer_id, 'GET', d1, function (response) {
                    if (response) {
                      resolve(response.data);
                    } else {
                      reject(new Error('Eroare la obținerea datelor'));
                    }
                  });
                });

              case 9:
                fpResp = _context6.sent;

                if (fpResp) {
                  printToIp = fpResp.fiscalPrinter.ip_port_printer;
                }

              case 11:
                return _context6.abrupt('return', printToIp);

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10);
      }))();
    },
    initScrollBar: function initScrollBar() {
      __WEBPACK_IMPORTED_MODULE_9_perfect_scrollbar___default.a.initialize(this.$refs.sidebarScrollArea);
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar(isMinimizeFromButton) {
      if (isMinimizeFromButton) {
        this.$sidebar.toggleMinimize();
        this.$session.set('isMinimized', this.$sidebar.isMinimized);
      } else {
        var minMenu = this.$session.get('isMinimized');
        if (minMenu === undefined && this.$sidebar.isMinimized) {
          this.$sidebar.toggleMinimize();
        }
        if (minMenu === false && this.$sidebar.isMinimized) {
          this.$sidebar.toggleMinimize();
        } else if (minMenu && !this.$sidebar.isMinimized) {
          this.$sidebar.toggleMinimize();
        }
      }
    },

    heartbeat: function heartbeat() {
      var _this11 = this;

      var self = this;

      this.loadSound();
      var allowSoundAtNew = this.$session.get('selectedCompanyData')['is_allowed_sound_at_new'];
      var allowSoundAtProcessing = this.$session.get('selectedCompanyData')['is_allowed_sound_at_processing'];
      if ((self.newOrdersCount > 0 && allowSoundAtNew && self.ordersWithSound > 0 || self.processingOrdersCount > 0 && allowSoundAtProcessing && self.ordersWithSound > 0 || self.all_waiter_calls.length) && this.$session.exists()) {
        self.playSound();
      }

      setInterval(function () {
        _this11.loadSound();
        if ((self.newOrdersCount > 0 && allowSoundAtNew && self.ordersWithSound > 0 || self.processingOrdersCount > 0 && allowSoundAtProcessing && self.ordersWithSound > 0 || self.all_waiter_calls.length) && _this11.$session.exists()) {
          self.playSound();
        }
      }, 1000 * 3);
    },
    openPopup: function openPopup() {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: this.$t('general.agreePopupMessage'),
        type: 'info',
        confirmButtonText: this.$t('general.agree'),
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      }).then(function (result) {
        _this12.playQuietSound();
      });
    },
    loadSound: function loadSound() {},
    playSound: function playSound() {
      if (window.soundEffect) {
        window.soundEffect.src = '/static/audio/alarm.mp3';
        window.soundEffect.play();
      }
    },
    playQuietSound: function playQuietSound() {
      if (window.soundEffect) {
        window.soundEffect.src = '/static/audio/quiet.mp3';
        window.soundEffect.play();
      }
    },
    startPlaySound: function startPlaySound() {},
    getCounter: function getCounter() {
      var data = {
        user_id: JSON.parse(this.$session.get('userData')).id,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        status: 'NEW',
        seen: 0
      };
      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        data.location_ids = filterCookie.join(',');
      }

      if ((data.location_ids === undefined || data.location_ids === '') && this.$session.get('userDataRole') === 'USER') {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        if (allowedLocations) {
          data.location_ids = allowedLocations.join(',');
        }
      }
      var self = this;
      this.apiRequest('/counters', 'GET', data, function (response) {
        var newFeedback = false;
        var newOrders = false;
        var processingOrders = false;
        var newNews = false;
        if (response.status === true) {
          if (response.data['all_waiter_calls'].length) {
            self.all_waiter_calls = response.data['all_waiter_calls'];
          }

          if (response.data.last_menu_modification_for_cache) {
            self.createCacheForMenu(response.data.last_menu_modification_for_cache);
          }

          if (response.data['red_notice'] === 0) {
            self.showRedNotice(0);
          }
          if (response.data['red_notice'] === 1) {
            self.showRedNotice(1);
          }
          if (response.data['red_notice'] === 2 || response.data['force_logout']) {
            self.forceLogout();
            window.location.reload(true);
          }

          if (response.data['orders'] > 0) {
            newOrders = true;
            self.newOrdersCount = response.data['orders'];
          } else {
            self.newOrdersCount = 0;
          }
          self.$session.set('newOrders', newOrders);
          self.$session.set('newOrdersCount', self.newOrdersCount);

          if (response.data['orders_processing'] > 0) {
            processingOrders = true;
            self.processingOrdersCount = response.data['orders_processing'];
          } else {
            self.processingOrdersCount = 0;
          }
          self.$session.set('processingOrders', processingOrders);
          self.$session.set('processingOrdersCount', self.processingOrdersCount);

          if (response.data['feedbacks'] > 0) {
            newFeedback = true;
          }
          self.$session.set('newFeedback', true);

          if (response.data['newsletter_news'] > 0) {
            newNews = true;
          }
          self.$session.set('newNews', true);

          if (response.data['orders_check_in'] > 0) {
            self.ordersCheckIn = response.data['orders_check_in'];
          } else {
            self.ordersCheckIn = 0;
          }
          if (response.data['orders_methods_sound'] > 0) {
            self.ordersWithSound = response.data['orders_methods_sound'];
          } else {
            self.ordersWithSound = 0;
          }
          if (self.oldOrdersCheckIn !== self.ordersCheckIn) {
            self.$session.set('temp-status', 'refreshSaveStatuses');
          }
          self.oldOrdersCheckIn = self.ordersCheckIn;
        }
        self.toggleAlertMenu(self.$refs.newFeedback, newFeedback);
        self.toggleAlertMenu(self.$refs.newOrders, newOrders || processingOrders);
        self.toggleAlertMenu(self.$refs.newNews, newNews);

        clearTimeout(self.timeoutCounters);
        if (self.$session.get('refreshOrdersCount') === 'refresh') {
          self.$session.set('refreshOrdersCount', '');
          self.timeoutCounters = setTimeout(function () {
            self.getCounter();
          }, 1000 * 2);
        } else {
          self.timeoutCounters = setTimeout(function () {
            self.getCounter();
          }, 1000 * 60);
        }
      });
    },
    createCacheForMenu: function createCacheForMenu(refreshProductsDate) {
      var givenDate = new Date(refreshProductsDate + ' GMT');
      if (window.cache_date <= givenDate) {
        console.log('ClearCache');
        window.appInstanceCache = {};

        var databaseName = 'tapTasty_' + this.$session.get('selectedCompany');

        var deleteRequest = indexedDB.deleteDatabase(databaseName);
        deleteRequest.onsuccess = function (event) {
          console.log('Database deleted successfully');
        };
        deleteRequest.onerror = function (event) {
          console.error('Error deleting database:', event.target.error);
        };
        deleteRequest.onblocked = function (event) {
          console.warn('Database deletion blocked:', event.target.error);
        };

        window.cache_date = new Date();
        localStorage['tapTastyMenu_cache_date_' + this.$session.get('selectedCompany')] = window.cache_date.toISOString();
      }
    },
    goToOrders: function goToOrders(status) {
      this.$session.set('temp-status', status);
      this.$nextTick(function () {
        this.$router.replace('/orders');
      });
    },
    handleStopSound: function handleStopSound() {
      this.newOrdersCount = 0;
      this.processingOrdersCount = 0;
      this.ordersCheckIn = 0;
    },
    fiscalPosPaymentError: function fiscalPosPaymentError(orderId) {
      var _this13 = this;

      this.$bus.$emit('completePaymentPos', 0);
      this.fiscalPosPaymentDisabled = false;
      this.orderFiscalError = orderId;
      setInterval(function () {
        _this13.orderFiscalError = false;
      }, 1000 * 3);
    },
    fiscalPrintError: function fiscalPrintError(orderId) {
      var _this14 = this;

      this.$bus.$emit('orders_pos_complete_order', 0);
      this.printFiscalDisabled = false;
      this.orderFiscalError = orderId;
      setInterval(function () {
        _this14.orderFiscalError = false;
      }, 1000 * 3);
    }
  },
  mounted: function mounted() {
    window.soundEffect = new Audio();
    var allowSoundAtNew = true;
    var allowSoundAtProcessing = true;
    if (this.$session.get('selectedCompanyData')) {
      allowSoundAtNew = this.$session.get('selectedCompanyData')['is_allowed_sound_at_new'];
      allowSoundAtProcessing = this.$session.get('selectedCompanyData')['is_allowed_sound_at_processing'];
    }
    if (this.$session.exists() && (allowSoundAtNew || allowSoundAtProcessing)) {
      this.openPopup(true);
    }


    if (!this.heartbeatSet) {
      this.heartbeat();
      this.heartbeatSet = true;
    }

    this.initScrollBar();
    this.toggleAlertMenu(this.$refs.newFeedback, this.$session.get('newFeedback'));
    this.toggleAlertMenu(this.$refs.newOrders, this.$session.get('newOrders'));
    this.toggleAlertMenu(this.$refs.newNews, this.$session.get('newNews'));
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_9_perfect_scrollbar___default.a.destroy(this.$refs.sidebarScrollArea);
    clearTimeout(this.timeoutCounters);
    this.cleanupSupportWidget();
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
});

/***/ }),

/***/ "MeMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutomationCampaignForm_vue__ = __webpack_require__("f+Xs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b261b6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutomationCampaignForm_vue__ = __webpack_require__("JQzo");
function injectStyle (ssrContext) {
  __webpack_require__("u5IJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutomationCampaignForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b261b6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutomationCampaignForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MjZx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__exportableReportHelpers__ = __webpack_require__("0Ou5");










var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a), _components),
  created: function created() {
    this.loadCoupons();
  },
  data: function data() {
    return {
      productLocationId: '',
      couponLocationId: '',
      activeOnly: false,
      fromDate: '',
      toDate: '',
      couponId: '',
      coupons: [],
      loadingCoupons: false,
      couponError: '',
      exporting: '',
      requesting: '',
      timedOut: { 'products': null, 'coupon-orders': null },
      errorReport: '',
      error: ''
    };
  },

  watch: {
    productFilterKey: function productFilterKey() {
      this.timedOut.products = null;
    },
    couponFilterKey: function couponFilterKey() {
      this.timedOut['coupon-orders'] = null;
    }
  },
  computed: {
    couponRequiresRequest: function couponRequiresRequest() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__exportableReportHelpers__["a" /* isLongReportPeriod */])(this.fromDate, this.toDate);
    },
    productFilterKey: function productFilterKey() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.buildParams('products'));
    },
    couponFilterKey: function couponFilterKey() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.buildParams('coupon-orders'));
    },
    validDates: function validDates() {
      return !this.fromDate || !this.toDate || this.fromDate <= this.toDate;
    },
    locations: function locations() {
      var company = this.$session.get('selectedCompanyData') || {};
      var locations = company.locations_details || [];
      if (!this.isOwner()) {
        var allowed = JSON.parse(this.$session.get('userDataLocations') || '[]').map(String);
        if (allowed.length) locations = locations.filter(function (location) {
          return allowed.includes(String(location.true_id));
        });
      }
      return locations;
    }
  },
  methods: {
    buildParams: function buildParams(report) {
      return {
        company_id: this.$session.get('selectedCompany'),
        location_id: (report === 'products' ? this.productLocationId : this.couponLocationId) || null,
        coupon_id: report === 'coupon-orders' ? this.couponId : undefined,
        active_only: report === 'products' && this.activeOnly ? 1 : 0,
        from_date: report === 'products' ? undefined : this.fromDate || undefined,
        to_date: report === 'products' ? undefined : this.toDate || undefined
      };
    },
    requestReport: function requestReport(report) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(report === 'coupon-orders' && (!_this.validDates || !_this.couponId))) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                params = report === 'coupon-orders' && _this.couponRequiresRequest ? _this.buildParams(report) : _this.timedOut[report];

                if (!(!params || _this.requesting || _this.exporting)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _this.requesting = report;
                _this.errorReport = report;
                _this.error = '';
                _context.prev = 8;
                _context.next = 11;
                return _this.axios.post('/reports/exportable/' + report + '/request', params, {
                  baseURL: "https://gatewaydev.taptasty.com/",
                  headers: { Authorization: 'Bearer ' + _this.$session.get('token') },
                  timeout: 30000
                });

              case 11:
                response = _context.sent;

                if (!(!response.data || response.data.status !== true)) {
                  _context.next = 14;
                  break;
                }

                throw new Error('Request failed');

              case 14:
                _this.timedOut[report] = null;
                _this.$emit('show-requests');
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](8);

                _this.error = 'Solicitarea nu a putut fi confirmată. Încearcă din nou sau verifică tabul Solicitări Rapoarte.';

              case 21:
                _context.prev = 21;

                _this.requesting = '';
                return _context.finish(21);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[8, 18, 21, 24]]);
      }))();
    },
    couponLabel: function couponLabel(coupon) {
      var code = coupon.coupon_has_multiple_codes ? 'coduri multiple' : coupon.coupon_code;
      return (coupon.name || 'Cupon') + ' (#' + coupon.id + ')' + (code ? ' — ' + code : '') + (!coupon.active ? ' — inactiv' : '');
    },
    loadCoupons: function loadCoupons() {
      var _this2 = this;

      this.loadingCoupons = true;
      this.couponError = '';
      this.apiRequest('/reports/exportable-coupons', 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, function (response) {
        _this2.loadingCoupons = false;
        if (response.status === true) {
          _this2.coupons = response.data;
        } else {
          _this2.couponError = 'Lista cupoanelor nu a putut fi încărcată.';
        }
      });
    },
    download: function download(report) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, response, failure, url, link;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this3.requesting || _this3.exporting || report !== 'products' && (!_this3.validDates || !_this3.couponId))) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                if (!(report === 'coupon-orders' && _this3.couponRequiresRequest)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                params = _this3.buildParams(report);

                _this3.timedOut[report] = null;
                _this3.exporting = report;
                _this3.errorReport = report;
                _this3.error = '';
                _context2.prev = 9;
                _context2.next = 12;
                return _this3.axios.get('/reports/exportable/' + report, {
                  baseURL: "https://gatewaydev.taptasty.com/",
                  headers: { Authorization: 'Bearer ' + _this3.$session.get('token') },
                  responseType: 'blob',
                  timeout: 180000,
                  params: params
                });

              case 12:
                response = _context2.sent;

                if ((response.headers['content-type'] || '').includes('text/csv')) {
                  _context2.next = 17;
                  break;
                }

                failure = new Error('Exportul nu a returnat un fișier CSV.');

                failure.response = response;
                throw failure;

              case 17:
                url = window.URL.createObjectURL(response.data);
                link = document.createElement('a');

                link.href = url;
                link.download = report + (report === 'coupon-orders' ? '-' + _this3.couponId : '') + '.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.setTimeout(function () {
                  return window.URL.revokeObjectURL(url);
                }, 1000);
                _context2.next = 37;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2['catch'](9);
                _context2.next = 31;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__exportableReportHelpers__["b" /* canRequestBackgroundReport */])(_context2.t0);

              case 31:
                if (!_context2.sent) {
                  _context2.next = 35;
                  break;
                }

                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(params) === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this3.buildParams(report))) {
                  _this3.timedOut[report] = params;
                }
                _this3.error = 'Exportul direct a expirat sau conexiunea cu serverul a fost întreruptă.';
                return _context2.abrupt('return');

              case 35:
                _this3.error = 'Exportul nu a putut fi generat. Verifică filtrele și încearcă din nou.';
                if (_context2.t0.response && _context2.t0.response.status === 403) {
                  _this3.error = 'Nu ai acces la compania sau locația selectată.';
                }

              case 37:
                _context2.prev = 37;

                _this3.exporting = '';
                return _context2.finish(37);

              case 40:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[9, 27, 37, 40]]);
      }))();
    }
  }
});

/***/ }),

/***/ "Ml/r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mm9z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__);





















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a),
  props: {},
  created: function created() {
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      tableColumns: [{
        prop: 'id',
        label: 'ID',
        minWidth: 30
      }, {
        prop: 'type',
        label: this.$t('settingTable.type'),
        minWidth: 50
      }, {
        prop: 'location_name',
        label: this.$t('settingTable.location'),
        minWidth: 50
      }, {
        prop: 'section.name',
        label: this.$t('kds.name'),
        minWidth: 50
      }],
      tableData: []
    };
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {
      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/ods/order-screen/edit/');
      }
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/order-screen', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data;
          _this.$nextTick(function () {
            this.loading = false;
          });
        }
      });
    },
    goToAdd: function goToAdd() {
      this.$router.push('/ods/order-screen/add');
    },
    copyToClipboard: function copyToClipboard(url) {
      url = url.replace(/\s/g, '');
      this.$copyText(url);
    },
    deleteOrderScreen: function deleteOrderScreen(id) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.loadingReset = true;
      });
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/order-screen/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          _this2.$nextTick(function () {
            _this2.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        } else {
          _this2.$nextTick(function () {
            _this2.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ 'text': _this2.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
        _this2.getData();
      });
    }
  }
});

/***/ }),

/***/ "MnBL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mna9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementEntriesForm_vue__ = __webpack_require__("JKdJ");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneIntrariForm', __WEBPACK_IMPORTED_MODULE_7__ManagementEntriesForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "Mt5O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      invoiceRoutes: [{ path: '/invoice-tabs/sidebar?tabIndex=0', key: 'invoices' }, { path: '/invoice-tabs/sidebar?tabIndex=1', key: 'proforma' }, { path: '/invoice-tabs/sidebar?tabIndex=2', key: 'reports' }, { path: '/invoice-tabs/sidebar?tabIndex=3', key: 'settings' }]
    };
  },

  methods: {
    getImageForRoute: function getImageForRoute(routeKey) {
      var images = {
        'invoices': 'static/img/dispatch-settings.png',
        'proforma': 'static/img/dispatch-settings.png',
        'reports': 'static/img/dispatch-settings.png',
        'settings': 'static/img/dispatch-settings.png'
      };
      return images[routeKey] || 'static/img/default.jpg';
    },
    getBoxColor: function getBoxColor(index) {
      var colors = ['#3AB7CD', '#FF6B6B', '#674BD2', '#FF6B6B'];
      return colors[index] || '#FFFFFF';
    }
  }
});

/***/ }),

/***/ "MtLy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MtbO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row referral-ambassador-requests"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"search-bar referral-ambassador-requests__filters"},[_c('div',{staticClass:"col-sm-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('referralProgram.requestStatus')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusFilter),expression:"statusFilter"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.statusFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.reload]}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_c('option',{attrs:{"value":"PENDING"}},[_vm._v(_vm._s(_vm.$t('general.pending')))]),_vm._v(" "),_c('option',{attrs:{"value":"APPROVED"}},[_vm._v(_vm._s(_vm.$t('general.accepted')))]),_vm._v(" "),_c('option',{attrs:{"value":"DENIED"}},[_vm._v(_vm._s(_vm.$t('general.denied')))])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"total":_vm.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('customers.id'),"min-width":"70"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"160","label":_vm.$t('reports.email')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.email || props.row.user_email || (props.row.user && props.row.user.email) || _vm.$t('general.emDash'))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"120","label":_vm.$t('referralProgram.desiredCode')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.desired_code || _vm.$t('general.emDash'))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"100","label":_vm.$t('referralProgram.requestStatus')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatRequestStatus(props.row))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"160","label":_vm.$t('referralProgram.createdAt')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatRequestCreatedAt(props.row))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"220","label":_vm.$t('marketingCampaigns.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.isPending(props.row))?_c('div',{staticClass:"referral-request-actions"},[_c('a',{staticClass:"btn add",attrs:{"href":"#","title":_vm.$t('general.accept')},on:{"click":function($event){$event.preventDefault();_vm.openApprove(props.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.accept'))+"\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn delete",attrs:{"href":"#","title":_vm.$t('general.deny')},on:{"click":function($event){$event.preventDefault();_vm.openDeny(props.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.deny'))+"\n                ")])]):_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('general.emDash')))])]}}])})],1)],1)]),_vm._v(" "),_c('vmodal',{attrs:{"name":"referralApproveRequestModal","height":"auto","width":"500","adaptive":true},on:{"closed":_vm.resetApprove}},[_c('div',{staticClass:"card referral-approve-request-modal",staticStyle:{"margin":"0"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('referralProgram.approveRequest')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.campaignSelectInvalid }},[_c('label',{class:{ 'text-danger': _vm.campaignSelectInvalid }},[_vm._v(_vm._s(_vm.$t('referralProgram.selectCampaign')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.approveForm.campaignId),expression:"approveForm.campaignId"}],staticClass:"form-control",class:{ error: _vm.campaignSelectInvalid },on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.approveForm, "campaignId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.clearApproveCampaignError]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.campaigns),function(c){return _c('option',{key:c.id,domProps:{"value":c.id}},[_vm._v(_vm._s(c.name || _vm.$t('general.idHash', { id: c.id })))])})],2),_vm._v(" "),(_vm.campaignSelectInvalid)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('referralProgram.selectCampaignRequired')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('referralProgram.approvedCodeOptional')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.approveForm.code),expression:"approveForm.code"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.approveForm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.approveForm, "code", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer referral-approve-request-modal__footer referral-request-actions"},[_c('a',{staticClass:"btn add",class:{ disabled: !_vm.canSubmitApprove },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.submitApprove($event)}}},[_vm._v(_vm._s(_vm.$t('general.accept')))]),_vm._v(" "),_c('a',{staticClass:"btn delete",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.closeApproveModal($event)}}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))])])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MyDR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mzj5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-top":"40px","margin-left":"5px","margin-right":"5px"}},[(JSON.parse(this.$session.get('userData')).is_allowed_to_see_bills)?_c('div',{staticClass:"payment_page"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-container"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%","background":"#fff"},attrs:{"data":_vm.tableData,"current-page":1,"page-size":_vm.pagesize}},[_c('el-table-column',{attrs:{"label":_vm.$t('paymentPage.invoice'),"min-width":80},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',{class:props.row.payed ? '' : 'unpaid'},[_vm._v(_vm._s(props.row.series)+_vm._s(props.row.number))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('paymentPage.total'),"min-width":80},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',{class:props.row.payed ? '' : 'unpaid'},[_c('span',[_vm._v(_vm._s(props.row.total))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.row.currency))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('paymentPage.forDate')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',{class:props.row.payed ? '' : 'unpaid'},[_c('span',[_vm._v(_vm._s(_vm.convertToMounth(props.row.for_month_date)))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('paymentPage.payed')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.payed)?_c('p',{staticStyle:{"color":"green"}},[_vm._v(_vm._s(_vm.$t('general.yes')))]):_c('p',{class:props.row.payed ? '' : 'unpaid'},[_vm._v(_vm._s(_vm.$t('general.no')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('paymentPage.transaction')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',{class:props.row.payed ? '' : 'unpaid'},[_c('span',[_vm._v(_vm._s(props.row.transaction_id))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('paymentPage.payLink')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.link && props.row.link != '' && !props.row.payed)?_c('p',[_c('a',{attrs:{"href":props.row.link,"target":"_blank"}},[_c('button',[_vm._v(_vm._s(_vm.$t('paymentPage.pay')))])])]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('paymentPage.viewInvoice')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(1)?_c('p',[_c('a',{attrs:{"href":_vm.showInvoice(props.row.series, props.row.number),"target":"_blank"}},[_c('button',{class:props.row.payed ? 'dwnBtn' : 'dwnBtn unpaid'},[_vm._v(_vm._s(_vm.$t('paymentPage.download')))])])]):_vm._e()]}}])})],1)],1)])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N+ua":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N471":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseHasEnrolledUsers */
/* harmony export (immutable) */ __webpack_exports__["a"] = attemptReferralCampaignDelete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);




function parseHasEnrolledUsers(response) {
  if (!response || !response.status) return null;
  var d = response.data;
  if (d != null && (typeof d === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(d)) === 'object' && d.data != null && typeof d.data !== 'string') {
    d = d.data;
  }
  if (typeof d === 'boolean') return d;
  if (d == null) return false;
  if ((typeof d === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(d)) === 'object') {
    if (typeof d.has_enrolled_users === 'boolean') return d.has_enrolled_users;
    if (typeof d.hasEnrolledUsers === 'boolean') return d.hasEnrolledUsers;
    if (typeof d.enrolled === 'boolean') return d.enrolled;
    if (typeof d.count === 'number') return d.count > 0;
  }
  return false;
}

function sessionPayload(vm) {
  return {
    token: vm.$session.get('token'),
    company_id: vm.$session.get('selectedCompany')
  };
}

function requestHasEnrolledUsers(vm, campaignId, callback) {
  vm.apiRequest('/referral-campaign/' + campaignId + '/has-enrolled-users', 'GET', sessionPayload(vm), callback);
}

function performDelete(vm, campaignId, onDeleted) {
  vm.apiRequest('/referral-campaign/' + campaignId, 'DELETE', sessionPayload(vm), function (response) {
    if (response.status) {
      if (typeof onDeleted === 'function') onDeleted(response);
    } else {
      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('', vm.$t('validations.wentWrong'), 'error');
    }
  });
}

function performDeactivate(vm, campaignId, buildBody, onDeactivated) {
  var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, typeof buildBody === 'function' ? buildBody() : {}, sessionPayload(vm), { active: false, is_visible_for_users: false });
  vm.apiRequest('/referral-campaign/' + campaignId, 'PUT', body, function (response) {
    if (response.status) {
      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()(vm.$t('general.success') + '!', '', 'success').catch(function () {});
      if (typeof onDeactivated === 'function') onDeactivated(response);
    } else {
      var msg = response.errors && (response.errors.message || response.errors[0]) || vm.$t('validations.wentWrong');
      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('', msg, 'error');
    }
  });
}

function showCannotDeleteSwal(vm, campaignId, options) {
  __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
    text: vm.$t('referralProgram.cannotDeleteHasEnrolledUsers'),
    type: 'error',
    showCancelButton: true,
    confirmButtonText: vm.$t('referralProgram.deactivateCampaign'),
    cancelButtonText: vm.$t('general.cancel')
  }).then(function (result) {
    if (!result) return;
    performDeactivate(vm, campaignId, options.buildDeactivateBody, options.onDeactivated);
  }).catch(function () {});
}

function attemptReferralCampaignDelete(vm, campaignId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (campaignId == null || campaignId === '') return;

  requestHasEnrolledUsers(vm, campaignId, function (checkResponse) {
    if (!checkResponse.status) {
      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('', vm.$t('validations.wentWrong'), 'error');
      return;
    }

    var hasEnrolled = parseHasEnrolledUsers(checkResponse);
    if (hasEnrolled === null) {
      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('', vm.$t('validations.wentWrong'), 'error');
      return;
    }

    if (hasEnrolled) {
      showCannotDeleteSwal(vm, campaignId, options);
      return;
    }

    __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
      text: vm.$t('general.generalAreYouSure'),
      type: 'question',
      showCancelButton: true,
      confirmButtonText: vm.$t('general.yes')
    }).then(function (result) {
      if (!result) return;
      performDelete(vm, campaignId, options.onDeleted);
    }).catch(function () {});
  });
}

/***/ }),

/***/ "N589":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: {
      type: String,
      default: '#c850c0'
    },
    palette: {
      type: String,
      default: 'colors'
    },
    title: {
      type: String,
      default: 'Color'
    }
  },
  methods: {
    updateColor: function updateColor(newColor) {
      this.$emit('color-change', newColor);
    },
    getOptionStyle: function getOptionStyle(color) {
      return {
        backgroundColor: color,
        color: this.getTextColor(color)
      };
    },
    getTextColor: function getTextColor(color) {
      var rgb = this.hexToRgb(color);
      if (!rgb) {
        return '#111';
      }
      var luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
      return luminance > 0.6 ? '#111' : '#fff';
    },
    hexToRgb: function hexToRgb(hex) {
      if (!hex) {
        return '#000000';
      }
      var match = hex.replace('#', '');
      if (match.length === 3) {
        var _match$split = match.split(''),
            _match$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_match$split, 3),
            r = _match$split2[0],
            g = _match$split2[1],
            b = _match$split2[2];

        return {
          r: parseInt(r + r, 16),
          g: parseInt(g + g, 16),
          b: parseInt(b + b, 16)
        };
      }
      if (match.length === 6) {
        return {
          r: parseInt(match.slice(0, 2), 16),
          g: parseInt(match.slice(2, 4), 16),
          b: parseInt(match.slice(4, 6), 16)
        };
      }
      return null;
    }
  },
  computed: {
    currentPalette: function currentPalette() {
      return this.palettes[this.palette] || this.palettes.colors;
    }
  },
  data: function data() {
    return {
      palettes: {
        colors: {
          default: '#c850c0',
          black: '#000',
          yumGrey: '#626262',
          yumOrange: '#FF5500',
          kioskGrey: '#F1F1F1'
        },
        odsColors: {
          default: '#c850c0',
          white: '#FFF',
          black: '#000',
          yumGrey: '#8c8c8c',
          yumOrange: '#FF5500',
          tyranosaurusRed: '#D22538',
          carrotOrange: '#ED7117',
          tapTastyOrange: '#f3bb45',
          tapTastyGreen: '#7ac29a',
          yumBlue: '#0055ff'
        }
      }
    };
  }
});

/***/ }),

/***/ "N64B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperatorSalesReport_vue__ = __webpack_require__("sxb2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d08234_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperatorSalesReport_vue__ = __webpack_require__("swtX");
function injectStyle (ssrContext) {
  __webpack_require__("ZFeI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperatorSalesReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28d08234_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperatorSalesReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N7/s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-report",staticStyle:{"padding-top":"12px !important"}},[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back banner-back-button",attrs:{"title":_vm.$t('general.back'),"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goBackToReport($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n            "+_vm._s(_vm.$t('general.back'))+"\n          ")])]),_vm._v(" "),_c('p',{staticClass:"nexus-items-order-id"},[_vm._v("\n          "+_vm._s(_vm.$t('general.orderId'))+": "),_c('strong',[_vm._v(_vm._s(_vm.orderId))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-content total-pagination pad-1"},[_c('div',{staticClass:"nexus-items-table-wrap"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.items,"empty-text":_vm.$t('reports.noDataAvailable')}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","min-width":70}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"order_id","label":_vm.$t('reports.orderId'),"min-width":100},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.order_id || _vm.orderId)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"data_to","label":_vm.$t('charisma.dataTo'),"min-width":220},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"display":"block","max-width":"300px","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","font-size":"12px","color":"#303133"}},[_vm._v(_vm._s(_vm.truncate(scope.row.data_to)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"data_from","label":_vm.$t('charisma.dataFrom'),"min-width":220},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"display":"block","max-width":"300px","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","font-size":"12px","color":"#303133"}},[_vm._v(_vm._s(_vm.truncate(scope.row.data_from)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":_vm.$t('charisma.createDate'),"min-width":160},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm.formatToCompanyTimezone(scope.row.created_at, _vm.timezone))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"actions","label":_vm.$t('marketingCampaigns.actions'),"min-width":120},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('general.visualize')},on:{"click":function($event){$event.preventDefault();_vm.openLogModal(scope.row)}}},[_c('i',{staticClass:"ti-eye"})])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"nexus-items-pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":[10, 20, 50],"page-size":_vm.pageSize,"layout":"prev, pager, next, sizes, total","total":_vm.total},on:{"current-change":_vm.onPageChange,"size-change":_vm.onPageSizeChange}})],1)],1)])])]),_vm._v(" "),_c('vmodal',{staticClass:"nexus-log-modal",attrs:{"name":"nexusLogModal","height":"auto","width":"1200","adaptive":true,"scrollable":true}},[_c('div',{staticClass:"card",staticStyle:{"margin":"0","position":"relative"}},[_c('a',{staticClass:"btn btn-icon btn-default nexus-modal-close",on:{"click":function($event){$event.preventDefault();_vm.$modal.hide('nexusLogModal')}}},[_c('i',{staticClass:"ti-close"})]),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"padding-top":"40px"}},[_c('div',{staticClass:"modal-header slim-header",staticStyle:{"text-align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('reports.nexusItems'))+" #"+_vm._s(_vm.selectedLog && _vm.selectedLog.id)+" — "+_vm._s(_vm.$t('general.orderId'))+": "+_vm._s(_vm.orderId))])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"padding":"15px 0"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('charisma.dataTo')))]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":24,"disabled":"","value":_vm.selectedLog && _vm.prettyJson(_vm.selectedLog.data_to),"placeholder":_vm.$t('charisma.dataTo')}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('charisma.dataFrom')))]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":24,"disabled":"","value":_vm.selectedLog && _vm.prettyJson(_vm.selectedLog.data_from),"placeholder":_vm.$t('charisma.dataFrom')}})],1)])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N91b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesPaymentMethod_vue__ = __webpack_require__("tTO3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6308794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesPaymentMethod_vue__ = __webpack_require__("GaZz");
function injectStyle (ssrContext) {
  __webpack_require__("e9Q6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesPaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6308794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesPaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NE6U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Steps_FirstStep_vue__ = __webpack_require__("6X+/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Steps_ThirdStep_vue__ = __webpack_require__("vTqF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Steps_CouponSelectStep_vue__ = __webpack_require__("qj8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Customers_countries__ = __webpack_require__("KLaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_moment__);






















var _components;















__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'FormWizard', __WEBPACK_IMPORTED_MODULE_23_vue_form_wizard__["FormWizard"]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'TabContent', __WEBPACK_IMPORTED_MODULE_23_vue_form_wizard__["TabContent"]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'FirstStep', __WEBPACK_IMPORTED_MODULE_27__Steps_FirstStep_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'ThirdStep', __WEBPACK_IMPORTED_MODULE_28__Steps_ThirdStep_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'CouponSelectStep', __WEBPACK_IMPORTED_MODULE_29__Steps_CouponSelectStep_vue__["a" /* default */]), _components),
  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_vee_validate__["b" /* mapFields */])(['name', 'price', 'active', 'date_from'])),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      days: [this.$t('days.monday'), this.$t('days.tuesday'), this.$t('days.wednesday'), this.$t('days.thursday'), this.$t('days.friday'), this.$t('days.saturday'), this.$t('days.sunday')],
      campaignsNotificationTypes: this.$session.get('defaultData')['campaigns_notification_types'],
      countries: __WEBPACK_IMPORTED_MODULE_30__Customers_countries__["a" /* default */],
      userLabels: [],
      userLabelLevels: [],
      model: [],
      customerList: 0,
      modelValidations: {
        name: {
          required: true,
          min: 4
        },
        active: {
          required: true
        },
        price: {
          required: true
        },
        status: {
          required: true
        },
        date_from: {},
        coupon_code: {
          required: true,
          min: 4
        },
        coupon_option: {}
      },
      wizardModel: {},
      customerGroups: [],
      selectedCustomerGroups: []
    };
  },
  created: function created() {
    this.getData();
    this.getGroups();
  },

  methods: {
    handleGroupCustomers: function handleGroupCustomers(e) {
      this.selectedCustomerGroups = e;
    },
    getData: function getData() {
      this.defineDataModels();
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.getDataOnEdit(data);

      this.getUserLabeling(data);
    },
    getDataOnEdit: function getDataOnEdit(data) {
      var _this = this;

      var editId = this.route.params && this.route.params.id;
      var duplicateFrom = this.route.query && this.route.query.duplicateFrom || this.$route.query && this.$route.query.duplicateFrom;
      var sourceId = editId || duplicateFrom;
      if (sourceId) {
        var id = sourceId;
        this.apiRequest('/campaign/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            if (response.data[0].datetime_validfrom && response.data[0].datetime_validto) {
              response.data[0].fromto = [response.data[0].datetime_validfrom, response.data[0].datetime_validto];
            }

            if (response.data[0]['image_url']) {
              response.data[0]['imagelist'] = response.data[0]['image_url'];
            } else {
              response.data[0]['imagelist'] = [];
            }

            var notifTimes = response.data[0]['notification_times'];
            var dayData = [];
            for (var day in _this.days) {
              var checked = false;
              var hourTo = '';
              var hourFrom = '';
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(notifTimes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var nTime = _step.value;

                  if (nTime.day === _this.days[day]) {
                    checked = true;
                    hourTo = nTime.hour_to;
                    hourFrom = nTime.hour_from;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              dayData.push({ day: _this.days[day], hour_to: hourTo, hour_from: hourFrom, checked: checked });
            }
            response.data[0]['notification_times_array'] = dayData;
            var notifTypesArray = [];
            var notifTypes = response.data[0]['notification_type'];
            for (var type in _this.campaignsNotificationTypes) {
              notifTypesArray.push({ type: false });
              if (notifTypes !== null) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(notifTypes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var nType = _step2.value;

                    if (nType.type === type) {
                      notifTypesArray[type] = true;
                    }
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              }
            }
            response.data[0]['notification_types_array'] = notifTypesArray;

            _this.model = response.data[0];
            if (duplicateFrom && !editId) {
              _this.prepareDuplicatedCampaign();
            }
          }
        });
      }
    },
    prepareDuplicatedCampaign: function prepareDuplicatedCampaign() {
      if (!this.model || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(this.model) !== 'object') {
        return;
      }
      var originalName = this.model.name || '';
      delete this.model.id;
      delete this.model.sent;
      delete this.model.notif_sent;
      delete this.model.email_sent;
      delete this.model.counter;
      delete this.model.last_sent;
      delete this.model.in_queue;
      delete this.model.total_notificatios_to_be_sent;
      delete this.model.created_at;
      delete this.model.updated_at;
      delete this.model.deleted_at;
      delete this.model.created_by;
      delete this.model.updated_by;
      delete this.model.deleted_by;
      this.model.is_sending = false;
      this.model.active = false;
      this.model.name = originalName ? originalName + ' <Copie>' : '<Copie>';
    },
    defineDataModels: function defineDataModels() {
      var notifTimes = [];
      var dayData = [];
      for (var day in this.days) {
        var dayDataIdx = this.getObjectByElemKeyValue('day', this.days[day], notifTimes);
        if (dayDataIdx !== undefined && notifTimes[dayDataIdx] !== undefined) {
          notifTimes[dayDataIdx]['checked'] = true;
          dayData.push(notifTimes[dayDataIdx]);
        } else {
          dayData.push({ day: this.days[day], hour_to: '', hour_from: '', checked: false });
        }
      }
      var notifTypesArray = [];
      for (var type in this.campaignsNotificationTypes) {
        notifTypesArray[type] = false;
      }
      this.model = {
        notification_times_array: dayData,
        notification_types_array: notifTypesArray,
        user_filters: {
          age: '',
          gender: '',
          orders_above: '',
          location_id: '',
          user_label_id: '',
          counter_matching_users: 0
        },
        type_push: 1,
        link_type: 1,
        url: null,
        email_json: null,
        user_label_id: null,
        imagelist: [],
        type: 'TEXT',
        coupon_id: null
      };
    },
    getUserLabeling: function getUserLabeling(data) {
      var _this2 = this;

      this.apiRequest('/userlabeling', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.userLabels = response.data.items;
          _this2.userLabelLevels = response.data.items.map(function (el) {
            return {
              key: el.id,
              label: el.name
            };
          });
        }
      });
    },
    isEdit: function isEdit() {
      if (this.route.params.id) {
        return true;
      } else {
        return false;
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      this.$validator.validateAll().then(function (isValid) {});
    },
    validateFirstStep: function validateFirstStep() {
      this.model = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, this.$refs.firstStep.model);
      return this.$refs.firstStep.validate();
    },
    validateThirdStep: function validateThirdStep() {
      var ret = this.$refs.thirdStep.validate();
      this.model = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, this.$refs.thirdStep.model);
      return ret;
    },
    validateCouponStep: function validateCouponStep() {
      this.model = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, this.$refs.couponStep.model);
      return this.$refs.couponStep.validate();
    },
    handleRemoveImage: function handleRemoveImage(file, fileList) {},
    filterCustomers: function filterCustomers() {
      this.customerList = 30;
    },
    resetTable: function resetTable() {
      this.customerList = 0;
    },
    sanitizeGroups: function sanitizeGroups(groups) {
      if (!groups.length) return null;
      var res = [];
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(groups).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        res.push(groups[key].id);
      });
      return res;
    },
    wizardComplete: function wizardComplete() {

      var self = this;
      var data = this.copyObject(this.model);
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');

      data.coupon_id = this.model.coupon_id || null;
      data.type = data.coupon_id ? 'COUPON' : 'TEXT';
      delete data.coupon;
      delete data.order_source_ids;
      delete data.order_sources_mask;

      if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
        data.datetime_validfrom = __WEBPACK_IMPORTED_MODULE_31_moment___default()(this.model.fromto[0], __WEBPACK_IMPORTED_MODULE_31_moment___default.a.ISO_8601).format();
        data.datetime_validfrom = data.datetime_validfrom.slice(0, data.datetime_validfrom.indexOf('+'));
        data.datetime_validfrom = data.datetime_validfrom.replace('T', ' ');
        data.datetime_validto = __WEBPACK_IMPORTED_MODULE_31_moment___default()(this.model.fromto[1], __WEBPACK_IMPORTED_MODULE_31_moment___default.a.ISO_8601).format();
        data.datetime_validto = data.datetime_validto.slice(0, data.datetime_validto.indexOf('+'));
        data.datetime_validto = data.datetime_validto.replace('T', ' ');
      } else {
        data.datetime_validfrom = null;
        data.datetime_validto = null;
      }

      var notificationTimes = [];
      for (var timeKey in data.notification_times_array) {
        if (data.notification_times_array[timeKey].checked === true) {
          notificationTimes.push({ day: data.notification_times_array[timeKey].day, hour_to: '', hour_from: data.notification_times_array[timeKey].hour_from });
        }
      }

      var notificationTypes = [];
      for (var type in data.notification_types_array) {
        if (data.notification_types_array[type] === true) {
          notificationTypes.push({ 'type': type });
        }
      }

      data.user_filters.counter_matching_users = data.counter_matching_users;

      if (data.description === {}) {
        data.description = '';
      }

      data.email_html = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.email_html);
      data.email_json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.email_json);

      delete data.notification_times_array;
      delete data.notification_types_array;
      delete data.notification_times;
      delete data.notification_type;
      delete data.fromto;
      var existingImageUrl = data.image_url;
      delete data.image_url;
      delete data.deleted_at;
      delete data.created_at;
      delete data.updated_at;
      delete data.created_by;
      delete data.deleted_at;
      delete data.deleted_by;
      delete data.updated_by;
      delete data.counter_matching_users;
      data.notification_times = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(notificationTimes);
      data.user_filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.user_filters);
      data.notification_type = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(notificationTypes);

      if (!this.route.params.id) {
        var hasNewImage = data.imagelist && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.imagelist).length && data.imagelist[0].status === 'ready';
        if (!hasNewImage && existingImageUrl) {
          data.image_url = existingImageUrl;
        }
        this.apiRequest('/campaign', 'POST', data, function (response) {
          if (response.status === true) {
            var id = response.data[0].id;
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.imagelist).length && data.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.name = data.name;
                data2.type = data.type;
                data2.mode = data.mode;
                data2.notification_type = data.notification_type;
                data2.image = base64enc;
                self.apiRequest('/campaign/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.goBack();
                  } else {
                    __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingCampaigns.campaignPhotoError'),
                      type: 'error',
                      showConfirmButton: false,
                      timer: 1500
                    });
                  }
                });
              });
            } else {
              self.goBack();
            }
          }
        });
      } else {
        var id = this.route.params.id;

        if (data.imagelist === 0) {
          data.image_url = '';
        }
        this.apiRequest('/campaign/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.imagelist).length && data.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.image = base64enc;
                data2.name = data.name;
                data2.type = data.type;
                data2.mode = data.mode;
                data2.notification_type = data.notification_type;
                self.apiRequest('/campaign/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.goBack();
                  } else {
                    __WEBPACK_IMPORTED_MODULE_25_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingCampaigns.campaignPhotoError'),
                      type: 'error',
                      showConfirmButton: false,
                      timer: 1500
                    });
                  }
                });
              });
            } else {
              self.goBack();
            }
          } else {}
        });
      }
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    getGroups: function getGroups() {
      var self = this;
      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/customersgroup/get-groups', 'POST', data, function (response) {
        if (response.status === true) {
          self.customerGroups = response.data;
        }
        self.$nextTick(function () {
          self.loading = false;
        });
      });
    }
  }
});

/***/ }),

/***/ "NETA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NEY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DonationCampaignForm_vue__ = __webpack_require__("1kFH");







var _components;





__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'DonationCampaignForm', __WEBPACK_IMPORTED_MODULE_7__DonationCampaignForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      campaignModel: {}
    };
  },

  methods: {
    onCampaignSubmit: function onCampaignSubmit(model) {
      this.campaignModel = model;
    }
  }
});

/***/ }),

/***/ "NGTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  en: {
    reimport: 'Import again',
    deleteImport: 'Delete import record',
    deleteProducts: 'Delete imported products',
    cleanupImport: 'Clean up remaining categories and images',
    cleanupImportConfirm: 'Remove empty categories created by this import and try deleting its unused image files? Shared categories and images will remain.',
    deleteImportConfirm: 'Remove this import from history? Products already created in the catalog will remain.',
    deleteProductsConfirm: 'Delete the products created by this import and their options? Empty categories created by this import and unused import images will also be removed. Shared categories and images will remain.',
    productsDeleted: 'The imported products have been deleted. You can import the store again to create a fresh preview.',
    statusProductsDeleted: 'Products deleted',
    warnings: {
      DEFAULT_MODIFIER_PRICE_SEPARATED: 'The displayed price includes selected modifiers. Their total ({amount}) was separated from the base price; review this calculation.',
      INDIVIDUAL_LIMITS_ABSENT: 'Glovo provides selection limits for groups, but no individual quantity limits. Review these before importing.',
      MISSING_TAX_AND_POS_MAPPING: 'Review the VAT and POS mappings. Platform identifiers are not local POS IDs.',
      ADDITIONAL_SOURCE_DETAILS: 'Promotions, schedules, nutrition, restrictions and other platform-specific fields remain in the source details when no catalog mapping exists. Base prices are imported.',
      PRODUCT_DEPOSIT_AS_REQUIRED_GROUP: 'This product deposit is imported as a required SGR option group. Its amount is preserved.',
      IMAGE_DOWNLOAD_FAILED: 'Some images could not be downloaded.',
      DEPOSIT_FROM_FEE_LABEL: 'Review the attached deposit identified from the SGR fee label: {label}',
      FEE_REQUIRES_REVIEW: 'Set the attached deposit based on the source fee label: {label}',
      UNSUPPORTED_OPTION_PRICING_OR_DEPENDENCY: 'Conditional prices or free-choice pricing require manual adjustment.'
    },
    storeUrlRequired: 'Enter the store URL.',
    storeUrlInvalid: 'Enter a valid store URL, for example https://glovoapp.com/ro/ro/sibiu/stores/mos-burger.',
    platform: 'Platform',
    date: 'Created',
    status: 'Status',
    open: 'Open',
    noHistory: 'No menu imports yet.',
    statusProcessing: 'Processing',
    statusReady: 'Ready to review',
    statusConfirming: 'Importing',
    statusConfirmed: 'Completed',
    statusFailed: 'Failed',
    statusCanceled: 'Canceled',
    menuPreview: 'Menu preview',
    editDetails: 'Edit details',
    view: 'Preview view',
    storeUrl: 'Store URL',
    loading: 'Loading preview…',
    noResults: 'No selected products match your search.',
    acknowledgeHint: 'Review the data gaps above, then check the acknowledgement to enable import.',
    apiUnavailable: 'The menu import API is not available on this server. Deploy the API update and run its migration.',
    accessDenied: 'Your account does not have permission to import menus for this company.',
    timedOut: 'The import request timed out. Check import history before retrying.',
    title: 'Import menu from platform',
    back: 'Back',
    intro: 'Paste a Glovo, Wolt or Bolt store URL. Review the menu before adding it to this location. Existing catalog items are unchanged.',
    preview: 'Load preview',
    processing: 'Processing menu… Please keep this page open.',
    done: 'Import completed',
    products: 'products',
    categories: 'Categories',
    gaps: 'Source data gaps and warnings',
    search: 'Search products and options',
    image: 'Image URL (one per line)',
    name: 'Name',
    price: 'Base price',
    description: 'Description',
    available: 'Available',
    tax: 'Location VAT mapping',
    unknown: 'Unknown / not provided',
    mode: 'Selection mode',
    single: 'Single selection',
    multiple: 'Multiple selection',
    counter: 'Repeated quantities',
    groupMin: 'Group minimum',
    groupMax: 'Group maximum',
    eachMin: 'Per-choice minimum',
    eachMax: 'Per-choice maximum',
    default: 'Selected by default',
    source: 'Original source details',
    reviewFee: 'Review and enter this separate fee as a deposit before confirming.',
    addDeposit: 'Add attached SGR deposit',
    acknowledge: 'I reviewed the source gaps, missing tax/POS mappings and export limitations.',
    skipImages: 'Allow importing without images that fail to download.',
    save: 'Save preview',
    confirm: 'Confirm and add new items',
    cancel: 'Cancel import',
    history: 'Platform import history',
    requestFailed: 'Request failed. Check your access or reload the preview if another user edited it.'
  },
  ro: {
    reimport: 'Importă din nou',
    deleteImport: 'Șterge înregistrarea importului',
    deleteProducts: 'Șterge produsele importate',
    cleanupImport: 'Curăță categoriile și imaginile rămase',
    cleanupImportConfirm: 'Ștergi categoriile goale create de acest import și încerci eliminarea imaginilor neutilizate? Categoriile și imaginile partajate vor rămâne.',
    deleteImportConfirm: 'Elimini acest import din istoric? Produsele deja create în catalog vor rămâne.',
    deleteProductsConfirm: 'Ștergi produsele create de acest import și opțiunile lor? Se vor elimina și categoriile goale create de import și imaginile neutilizate ale importului. Categoriile și imaginile partajate vor rămâne.',
    productsDeleted: 'Produsele importate au fost șterse. Poți importa din nou magazinul pentru a crea o previzualizare nouă.',
    statusProductsDeleted: 'Produse șterse',
    warnings: {
      DEFAULT_MODIFIER_PRICE_SEPARATED: 'Prețul afișat include opțiunile selectate implicit. Totalul acestora ({amount}) a fost separat de prețul de bază. Verifică acest calcul.',
      INDIVIDUAL_LIMITS_ABSENT: 'Glovo oferă limite de selecție pentru grupuri, dar nu și limite individuale de cantitate. Verifică-le înainte de import.',
      MISSING_TAX_AND_POS_MAPPING: 'Verifică asocierile TVA și POS. Identificatorii platformei nu sunt ID-uri POS locale.',
      ADDITIONAL_SOURCE_DETAILS: 'Promoțiile, programul, informațiile nutriționale, restricțiile și alte câmpuri specifice platformei rămân în detaliile sursei dacă nu au un câmp echivalent în catalog. Se importă prețurile de bază.',
      PRODUCT_DEPOSIT_AS_REQUIRED_GROUP: 'Garanția acestui produs se importă ca grup obligatoriu de opțiuni SGR. Valoarea acesteia este păstrată.',
      IMAGE_DOWNLOAD_FAILED: 'Unele imagini nu au putut fi descărcate.',
      DEPOSIT_FROM_FEE_LABEL: 'Verifică garanția atașată, identificată din eticheta taxei SGR: {label}',
      FEE_REQUIRES_REVIEW: 'Completează garanția atașată pe baza etichetei taxei din sursă: {label}',
      UNSUPPORTED_OPTION_PRICING_OR_DEPENDENCY: 'Prețurile condiționate sau opțiunile gratuite necesită ajustare manuală.'
    },
    storeUrlRequired: 'Introdu URL-ul magazinului.',
    storeUrlInvalid: 'Introdu un URL valid al magazinului, de exemplu https://glovoapp.com/ro/ro/sibiu/stores/mos-burger.',
    platform: 'Platformă',
    date: 'Data creării',
    status: 'Stare',
    open: 'Deschide',
    noHistory: 'Nu există încă importuri de meniu.',
    statusProcessing: 'Se procesează',
    statusReady: 'Pregătit de verificare',
    statusConfirming: 'Se importă',
    statusConfirmed: 'Finalizat',
    statusFailed: 'Eșuat',
    statusCanceled: 'Anulat',
    menuPreview: 'Previzualizare meniu',
    editDetails: 'Editează detaliile',
    view: 'Vizualizare meniu',
    storeUrl: 'URL magazin',
    loading: 'Se încarcă previzualizarea…',
    noResults: 'Niciun produs selectat nu corespunde căutării.',
    acknowledgeHint: 'Verifică datele lipsă de mai sus și bifează confirmarea pentru a activa importul.',
    apiUnavailable: 'API-ul de import meniu nu este disponibil pe acest server. Actualizează API-ul și rulează migrarea.',
    accessDenied: 'Contul tău nu are permisiunea de a importa meniuri pentru această companie.',
    timedOut: 'Cererea de import a expirat. Verifică istoricul importurilor înainte de a reîncerca.',
    title: 'Importă meniul de pe platformă',
    back: 'Înapoi',
    intro: 'Introdu URL-ul unui magazin Glovo, Wolt sau Bolt. Verifică meniul înainte de a-l adăuga în locație. Produsele existente rămân neschimbate.',
    preview: 'Încarcă previzualizarea',
    processing: 'Se procesează meniul… Te rugăm să păstrezi pagina deschisă.',
    done: 'Import finalizat',
    products: 'produse',
    categories: 'Categorii',
    gaps: 'Date lipsă și avertismente',
    search: 'Caută produse și opțiuni',
    image: 'URL imagine (câte unul pe rând)',
    name: 'Denumire',
    price: 'Preț de bază',
    description: 'Descriere',
    available: 'Disponibil',
    tax: 'TVA din locație',
    unknown: 'Necunoscut / nefurnizat',
    mode: 'Mod de selecție',
    single: 'Selecție unică',
    multiple: 'Selecție multiplă',
    counter: 'Cantități repetate',
    groupMin: 'Minim în grup',
    groupMax: 'Maxim în grup',
    eachMin: 'Minim per valoare',
    eachMax: 'Maxim per valoare',
    default: 'Selectat implicit',
    source: 'Detalii originale din sursă',
    reviewFee: 'Verifică și introdu această taxă separată ca garanție înainte de confirmare.',
    addDeposit: 'Adaugă garanție SGR atașată',
    acknowledge: 'Am verificat datele lipsă, asocierile TVA/POS și limitările de export.',
    skipImages: 'Permite importul fără imaginile care nu pot fi descărcate.',
    save: 'Salvează previzualizarea',
    confirm: 'Confirmă și adaugă elemente noi',
    cancel: 'Anulează importul',
    history: 'Istoric importuri de pe platforme',
    requestFailed: 'Cererea a eșuat. Verifică accesul sau reîncarcă previzualizarea dacă a fost editată de alt utilizator.'
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__("HSQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pollyfills__ = __webpack_require__("im4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_axios_extensions__ = __webpack_require__("fnFf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_session__ = __webpack_require__("18Sv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__stayawake__ = __webpack_require__("O6k+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__gloablComponents__ = __webpack_require__("iXuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_mixins_Inmobito__ = __webpack_require__("m0L1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_sass_paper_dashboard_scss__ = __webpack_require__("MAOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_sass_paper_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_sass_paper_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_sass_element_variables_scss__ = __webpack_require__("yv97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_sass_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__assets_sass_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_sass_demo_scss__ = __webpack_require__("9G8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_sass_demo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__assets_sass_demo_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__sidebarLinks__ = __webpack_require__("FiZY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__lang_lang__ = __webpack_require__("pe4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_wysiwyg__ = __webpack_require__("V2hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vue_wysiwyg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vue_data_tables__);



















































__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_38_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_23_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_collapse_item___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_26__globalDirectives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_25__gloablComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_notifyjs___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_27__components_UIComponents_SidebarPlugin__["a" /* default */], { sidebarLinks: __WEBPACK_IMPORTED_MODULE_34__sidebarLinks__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_18_axios___default.a, __WEBPACK_IMPORTED_MODULE_19_axios_extensions__["a" /* cacheAdapterEnhancer */]);
__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_locale_lang_en___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_37_vue_wysiwyg___default.a, {
  hideModules: { 'code': true, 'table': true },
  maxHeight: '500px'
});
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21_vue_session___default.a, { persist: 1 });
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_22_vue_cookie___default.a);

__WEBPACK_IMPORTED_MODULE_9_vue___default.a.mixin(__WEBPACK_IMPORTED_MODULE_29_src_mixins_Inmobito__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_10_vue_i18n__["a" /* default */]({
  locale: 'en',
  fallbackLocale: 'en',
  messages: __WEBPACK_IMPORTED_MODULE_36__lang_lang__["a" /* default */] });

__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_locale___default.a.i18n(function (key, value) {
  return i18n.t(key, value);
});

var router = new __WEBPACK_IMPORTED_MODULE_12_vue_router__["a" /* default */]({
  i18n: i18n,
  routes: __WEBPACK_IMPORTED_MODULE_28__routes_routes__["a" /* default */],
  linkActiveClass: 'active'
});

var noSleep = new __WEBPACK_IMPORTED_MODULE_24__stayawake__["a" /* default */]();
noSleep.enable();

__WEBPACK_IMPORTED_MODULE_9_vue___default.a.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_35_moment___default()(String(value)).format('DD/MM/YYYY');
  }
});
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.filter('formatDateTime', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_35_moment___default()(String(value)).format('DD/MM/YYYY H:mm');
  }
});
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.filter('formatTime', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_35_moment___default()(String(value)).format('H:mm');
  }
});

var EventBus = new __WEBPACK_IMPORTED_MODULE_9_vue___default.a();

router.beforeEach(function (to, from, next) {
  if (to.meta && to.meta.modal) {
    var matched = to.matched[to.matched.length - 1];
    var component = matched.components.default;

    var routeProps = {
      params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, to.params),
      query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, to.query),
      fullPath: to.fullPath,
      path: to.path,
      name: to.name
    };

    console.log('🟣 MODAL ROUTE DETECTED');
    console.log('📦 Modal component:', component);
    console.log('📨 Modal props (full route):', routeProps);

    EventBus.$emit('open-modal', {
      component: component,
      props: { route: routeProps }
    });

    return next(false);
  }

  next();
});

router.beforeEach(function (to, from, next) {
  var marketerRoutes = ['/customers', '/products', '/logout', '/customers', '/groups', '/marketing/campaigns', '/marketing/offers', '/marketing/dynamic-menus', '/marketing/fidelities', '/marketing/client-order-view', '/marketing/campaigns/edit/', '/marketing/coupons', '/categories', '/top-categories', '/product-option', '/product-filters', '/custom-info-pages', '/menu-links', '/info-pages', '/integrations/menu-fix'];
  var matches = marketerRoutes.filter(function (s) {
    return to.path.includes(s);
  });

  var operatorRoutes = ['/dashboard', '/logout', '/scanner'];
  var operatorRoutesMatches = operatorRoutes.filter(function (s) {
    return to.path.includes(s);
  });

  if (router.app.$session.get('userDataRole') === 'MARKETER') {
    if (!matches.length) {
      next('/products');
    } else {
      next();
    }
  } else {
    next();
  }

  if (router.app.$session.get('userDataRole') === 'OPERATOR') {
    if (!operatorRoutesMatches.length) {
      next('/scanner');
    } else {
      next();
    }
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_9_vue___default.a.prototype, {
  $bus: {
    get: function get() {
      return EventBus;
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_9_vue___default.a({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_17__App_vue__["a" /* default */]);
  },
  i18n: i18n,
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_30__store_index__["a" /* default */],
  created: function created() {
    if (this.$session && this.$session.exists && this.$session.exists()) {
      this.initAuditClient();
    }
  }
});

/***/ }),

/***/ "NKVS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NNhe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NOIG":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAcCAYAAACK7SRjAAAABHNCSVQICAgIfAhkiAAAAchJREFUSEu9ll9OwkAQxmf4k+AbNxBPIJ7A9sWkvMirghFuICcQT6A3sAYSH8EXeARuUE5gj8CbJqLrNw0lFLa0C4FNmpLuzm9mv52ZhQlj9KqK33l6xk8LT0m+xQ1F1KrU+UXmBx0l7/tchuyrGnvrNizgrxx9MlNxG3Q5p+jJueP2Aj6G3aVSNNM54GFXueI9FVgWaeDBZ40DHnSVz0Sn+8J1DiRyyGgwYiIPCas7MIcTvTl1biw0r0Lz3npo4uBkTmfG8NDQbvIscNBVD6yoQUznK4c+xaGXjeELgIvom0li7goXrlv4oVa4A52jfeDC85EN/QzT+I8pkCkclVue7AuPVSbLdHEwOIrNPjJc0RR77ev2C30t6SVJWRLMayL/QIpVtxkPO6qNnH5MdLABXyntOGPALcBH5nCkFmXJdm7Y1xkH7TlPIzS68i7wRJvUC46eLWhME2x7nDpCWciBTNcRG03ky3ZqBMfijSzaJVvinOKyjvZ2TeQ+kr+JXmwky/BdldQv9SJZdMgDRTEyQysvcouYih2zPoSnK2czp0FiQCactOl/l22O0PgKc7LkhgrgMuS08bLwJJe2Hu5xhjynxm44/Q88xvtEnyBFpgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "NPgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__);























__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
    PPagination: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    },
    isTable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.token = this.$session.get('token');
    this.getData();
    this.getCategories();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  computed: {
    formattedCategories: function formattedCategories() {
      return this.mainCategories.map(function (cat) {
        return {
          label: cat.name,
          value: cat.id
        };
      });
    },
    allCategoryValues: function allCategoryValues() {
      return this.formattedCategories.map(function (c) {
        return c.value;
      });
    },
    toggleOption: function toggleOption() {
      var _this = this;

      var isAllSelected = this.allCategoryValues.every(function (val) {
        return _this.categoryForImport.includes(val);
      });

      return {
        label: isAllSelected ? this.$t('general.deselectAll') : this.$t('general.selectAll'),
        value: '__toggle_all__'
      };
    }
  },
  data: function data() {
    return {
      loading: true,
      token: null,
      sectionForImport: null,
      categoryForImport: null,
      mainCategories: [],
      apiUrl: null,
      tableColumns: [{
        prop: 'id',
        label: 'ID',
        minWidth: '80'
      }, {
        prop: 'name',
        label: this.$t('settingTable.name'),
        minWidth: '120'
      }],
      tableData: []
    };
  },

  methods: {
    handleChange: function handleChange(val) {
      var _this2 = this;

      var toggleIndex = val.indexOf('__toggle_all__');

      if (toggleIndex > -1) {
        var isAllSelected = this.allCategoryValues.every(function (v) {
          return _this2.categoryForImport.includes(v);
        });

        this.categoryForImport = isAllSelected ? [] : [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.allCategoryValues));

        this.$nextTick(function () {
          _this2.categoryForImport = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.categoryForImport));
        });
      }
    },
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row) {
      this.$router.push('/screens/sections/edit/' + row.id);
    },
    setSectionOnProductsFromCategory: function setSectionOnProductsFromCategory() {
      var _this3 = this;

      if (!this.categoryForImport || !this.sectionForImport) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        text: this.$t('general.generalAreYouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this3.$session.get('token'),
            company_id: _this3.$session.get('selectedCompany'),
            id: _this3.sectionForImport,
            category_id: _this3.categoryForImport
          };
          _this3.apiRequest('/sections/set-section-on-products/' + _this3.sectionForImport, 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': _this3.$t('general.success'), 'type': 'success', 'timer': 1000 }).catch(function () {});
              __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(_this3, 'categoryForImport', null);
              __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(_this3, 'sectionForImport', null);
            } else {
              __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': _this3.$t('validations.wentWrong'), 'type': 'error', 'timer': 1000 }).catch(function () {});
            }
          });
        }
      });
    },
    getCategories: function getCategories() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        inactive: 1
      };
      this.apiRequest('/category', 'GET', data, function (response) {
        if (response.status === true) {
          _this4.mainCategories = response.data;
        }
      });
    },
    getData: function getData() {
      var _this5 = this;

      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/sections', 'GET', data, function (response) {
        if (response.status === true) {
          _this5.tableData = response.data;

          _this5.$nextTick(function () {
            _this5.loading = false;
          });
        }
      });
    },
    goToAdd: function goToAdd() {
      this.$router.push('/screens/sections/add');
    },
    handleDelete: function handleDelete(id) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        title: this.$t('general.generalAreYouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this6.deleteKdsSection(id);
        }
      });
    },
    deleteKdsSection: function deleteKdsSection(id) {
      var _this7 = this;

      this.loading = true;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/sections/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          _this7.getData();
        } else {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': _this7.$t('validations.wentWrong'), 'type': 'error', 'timer': 1000 }).catch(function () {});
          _this7.loading = false;
        }
      });
    }
  }
});

/***/ }),

/***/ "NTnw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductAdd_vue__ = __webpack_require__("OWQI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfdf97d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductAdd_vue__ = __webpack_require__("XRoD");
function injectStyle (ssrContext) {
  __webpack_require__("O3tG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dfdf97d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NVJu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NVSL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-transfer-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NWZS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NWn5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSidebar_vue__ = __webpack_require__("TkD5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2a82dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSidebar_vue__ = __webpack_require__("KfMv");
function injectStyle (ssrContext) {
  __webpack_require__("ow6R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b2a82dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2a82dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NcRz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{ref:"optionsTopBar",staticClass:"reservations-top-bar category-top-bar"},[_c('div',{staticClass:"text-left"},[_c('h3',[_vm._v(_vm._s(_vm.$t('menuLink.reservations'))+" "),_c('a',{staticClass:"btn btn-info btn-icon",on:{"click":function($event){$event.preventDefault();_vm.getData()}}},[_c('i',{staticClass:"ti-reload",staticStyle:{"margin-right":"5px"}}),_vm._v(" Reload")])])]),_vm._v(" "),_c('div',{staticClass:"text-right"})]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"tableWrapper"},[_vm._l((_vm.tableData),function(table){return [_c('div',{staticClass:"card table_card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(table.id)+" "+_vm._s(table.zone)+" "+_vm._s(table.type)+" "+_vm._s(table.number)+" (max:"+_vm._s(table.max_pers)+")")]),_vm._v(" "),_c('span',{staticClass:"min_max_pers"},[_vm._v("min_pers: "+_vm._s(table.min_pers || 0)+" - max_pers: "+_vm._s(table.max_pers))]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"0"}})]),_vm._v(" "),_c('div',{staticClass:"reservations"},[_vm._l((table.reservations_table),function(resTable){return [(resTable.reservations)?_c('div',{staticClass:"reservation"},[_c('span',{staticClass:"reservation_id"},[_vm._v("ID: "+_vm._s(resTable.reservations.id))]),_vm._v(" "),_c('div',{staticClass:"reservation_data"},[_c('table',{staticStyle:{"text-align":"center","margin":"0"}},[_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.formatDateToShowJustDate(resTable.reservations.date_from)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.formatDateToShowJustTime(resTable.reservations.date_from)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDateToShowJustTime(resTable.reservations.date_to)))])])])]),_vm._v(" "),_c('div',{staticClass:"reservation_data statuses"},[(resTable.reservations.status != 'RESERVED')?[_c('button',{class:['statusBtn RESERVED'],on:{"click":function($event){_vm.changeStatus('RESERVED', resTable)}}},[_vm._v("RESERVED")]),_vm._v(" "),_c('button',{class:['statusBtn CANCELED'],on:{"click":function($event){_vm.changeStatus('CANCELED', resTable)}}},[_vm._v("CANCELED")])]:[_vm._l((_vm.statuses),function(sts){return [(resTable.reservations.status == 'RESERVED' && sts != resTable.reservations.status)?[_c('button',{class:['statusBtn',
                                            sts,
                                            resTable.reservations.status == sts ? 'active' : ''
                                          ],on:{"click":function($event){_vm.changeStatus(sts, resTable)}}},[_vm._v(_vm._s(sts))])]:_vm._e()]})]],2),_vm._v(" "),_c('div',{staticClass:"reservation_user"},[_c('span',[_vm._v("Name: "+_vm._s(resTable.reservations.name))]),_vm._v(" "),_c('span',[_vm._v("Email: "+_vm._s(resTable.reservations.email))]),_vm._v(" "),_c('span',[_vm._v("Phone: "+_vm._s(resTable.reservations.phone))]),_vm._v(" "),_c('span',[_vm._v("Total Persoane: "+_vm._s(resTable.reservations.total_pers))])]),_vm._v(" "),_c('div',{staticClass:"reservation_data"},[_c('table',{staticClass:"reservation_prices"},[_vm._m(0,true),_vm._v(" "),_vm._l((resTable.reservations_items),function(resItems){return [_c('tr',[_c('td',[_vm._v(_vm._s(resItems.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(resItems.price))])])]}),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Total Masa:")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(resTable.table_total_price))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Total Rezervare:")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(resTable.reservations.total_price))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Payment Type:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(resTable.reservations.payment_type))])])],2)])]):_vm._e()]})],2)])])]})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Price")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NdNc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInventory_vue__ = __webpack_require__("7ssq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63942c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInventory_vue__ = __webpack_require__("3XMI");
function injectStyle (ssrContext) {
  __webpack_require__("Y+4g")
  __webpack_require__("zyut")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d63942c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInventory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63942c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInventory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NfmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomError", function() { return CustomError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customErrorFactory", function() { return customErrorFactory; });
function fixProto(target, prototype) {
  var setPrototypeOf = Object.setPrototypeOf;
  setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
}
function fixStack(target, fn) {
  if (fn === void 0) {
    fn = target.constructor;
  }

  var captureStackTrace = Error.captureStackTrace;
  captureStackTrace && captureStackTrace(target, fn);
}

var __extends = undefined && undefined.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var CustomError = function (_super) {
  __extends(CustomError, _super);

  function CustomError(message, options) {
    var _newTarget = this.constructor;

    var _this = _super.call(this, message, options) || this;

    Object.defineProperty(_this, 'name', {
      value: _newTarget.name,
      enumerable: false,
      configurable: true
    });
    fixProto(_this, _newTarget.prototype);
    fixStack(_this);
    return _this;
  }

  return CustomError;
}(Error);

var __spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
function customErrorFactory(fn, parent) {
  if (parent === void 0) {
    parent = Error;
  }

  function CustomError() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (!(this instanceof CustomError)) return new (CustomError.bind.apply(CustomError, __spreadArray([void 0], args, false)))();
    parent.apply(this, args);
    Object.defineProperty(this, 'name', {
      value: fn.name || parent.name,
      enumerable: false,
      configurable: true
    });
    fn.apply(this, args);
    fixStack(this, CustomError);
  }

  return Object.defineProperties(CustomError, {
    prototype: {
      value: Object.create(parent.prototype, {
        constructor: {
          value: CustomError,
          writable: true,
          configurable: true
        }
      })
    }
  });
}


//# sourceMappingURL=custom-error.mjs.map


/***/ }),

/***/ "Nijh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"col-md-12 "},[_c('draggable',{attrs:{"handle":".handle"},on:{"end":_vm.onEnd},model:{value:(_vm.groupsData),callback:function ($$v) {_vm.groupsData=$$v},expression:"groupsData"}},[_c('transition-group',_vm._l((_vm.groupsData),function(group,idx){return _c('div',{key:group.id,staticClass:"homepage-div"},[_c('div',{staticClass:"homepage-banner",class:group.visibility ? 'selected-group' : '',on:{"click":function($event){_vm.toggleVisibility(idx, $event)}}},[_c('div',{staticClass:"group-header"},[_c('span',{staticClass:"handle",staticStyle:{"max-width":"10px"}},[_c('i',{staticClass:"fa fa-align-justify "})]),_vm._v(" "),_c('span',{staticClass:"group_name"},[_vm._v(_vm._s(group.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(group.display ? group.display : 0))]),_vm._v(" "),_c('span',[[_c('p-switch',{staticClass:"switch",attrs:{"type":"success"},on:{"input":function($event){_vm.handleActiveGroup(group)}},model:{value:(group.active),callback:function ($$v) {_vm.$set(group, "active", $$v)},expression:"group.active"}})]],2),_vm._v(" "),_c('span',[_c('div',{staticClass:"edit",on:{"click":function($event){_vm.editGroup(group, idx)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                  ")]),_vm._v(" "),_c('a',{staticClass:"btn delete",on:{"click":function($event){_vm.deleteGroup(group.id, group.name, idx)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"banner-action"},[_c('i',{class:group.visibility ? 'fa fa-angle-down' : 'fa fa-angle-right'})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(group.visibility),expression:"group.visibility"}],ref:'banners_table_'+group.id,refInFor:true,staticClass:"banners-table"},[_c('div',{staticClass:"banner-div"},[_c('div',{staticClass:"pull-right "},[_c('router-link',{staticClass:"btn btn-icon btn-info add mar-bt-20",attrs:{"to":{ path: '/marketing/offers/'+group.id+'/add-group-banner'},"title":_vm.$t('general.add') + ' ' + _vm.$t('marketingOffers.single')}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])],1),_vm._v(" "),_c('table',{ref:"sortableTable",refInFor:true,staticClass:"table width-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"5%"}}),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.image')))]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.title')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.status')))]),_vm._v(" "),_c('th',{attrs:{"width":"15%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.linkType')))]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.startEndDate')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.actions')))]),_vm._v(" "),_c('th',{attrs:{"width":"30%"}})])]),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody'},on:{"end":_vm.adjustSort},model:{value:(group.banners),callback:function ($$v) {_vm.$set(group, "banners", $$v)},expression:"group.banners"}},[_vm._l((group.banners),function(item,index){return [_c('tr',{key:item.id,staticClass:"sortableRow"},[_c('td',[_c('i',{staticClass:"fa fa-arrows sortHandle",staticStyle:{"cursor":"move"}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"image-table"},[_c('img',{attrs:{"src":(item.image)?item.image : ''}})])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(item)}},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}})]],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.link_type))]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.formatDate(item.date_start))+" - "+_vm._s(_vm.formatDate(item.date_end)))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-icon btn-danger",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.handleDelete(index, item, idx, $event)}}},[_c('i',{staticClass:"ti-close"})])]),_vm._v(" "),_c('td',{staticClass:"edit-icon-pointer",on:{"click":function($event){_vm.goToRecord(group.id, item.id)}}},[_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                      ")])])])]})],2)],1)])])])}))],1),_vm._v(" "),_c('vmodal',{staticClass:"groupModal",attrs:{"name":"groupModal","title":"groupModal","width":"70%","maxWidth":800,"minWidth":200,"height":"40%","adaptive":true}},[_c('form',[_c('div',{staticClass:"header border-bottom"},[_c('h4',[_vm._v(_vm._s(_vm.$t('marketingOffers.addGroup')))])]),_vm._v(" "),_c('div',{staticClass:"content-group"},[_c('div',{staticClass:"content_scrool"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"group_name"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.title')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.groupValidations.group_name),expression:"groupValidations.group_name"},{name:"model",rawName:"v-model",value:(_vm.group.name),expression:"group.name"}],staticClass:"form-control",attrs:{"type":"text","name":"title","id":"group_name"},domProps:{"value":(_vm.group.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.group, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('title'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('title'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"group_display"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.display')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.group.display),expression:"group.display"},{name:"validate",rawName:"v-validate",value:(_vm.groupValidations.group_display),expression:"groupValidations.group_display"}],staticClass:"form-control",attrs:{"id":"group_display","name":"display"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.group, "display", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1X"}},[_vm._v("1X")]),_vm._v(" "),_c('option',{attrs:{"value":"2X"}},[_vm._v("2X")]),_vm._v(" "),_c('option',{attrs:{"value":"3X"}},[_vm._v("3X")])]),_vm._v(" "),(_vm.errors.has('display'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('display'))+"\n              ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"groupModal__footer"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NkqJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementDashboard_vue__ = __webpack_require__("SF1l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a748682_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementDashboard_vue__ = __webpack_require__("fNaR");
function injectStyle (ssrContext) {
  __webpack_require__("SaRj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a748682"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a748682_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NlLU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NoQD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NqnY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library__ = __webpack_require__("YE/A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zxing_library__);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "image-barcode-reader",

    data: function data() {
        return {
            codeReader: new __WEBPACK_IMPORTED_MODULE_0__zxing_library__["BrowserMultiFormatReader"]()
        };
    },


    methods: {
        onChangeInput: function onChangeInput(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            var reader = new FileReader();
            reader.onload = this.processFile;
            reader.readAsDataURL(files[0]);
        },
        processFile: function processFile(e) {
            var _this = this;

            this.$el.innerHTML += "<img id=\"image\" src=\"" + e.target.result + "\"/>";

            this.codeReader.decodeFromImage("image").then(function (result) {
                return _this.$emit("decode", result.text);
            }).catch(function (error) {
                return _this.$emit("error", error);
            });
        }
    }
});

/***/ }),

/***/ "Nt52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementForOrdersSuppliersAdd_vue__ = __webpack_require__("ce0i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f07210f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementForOrdersSuppliersAdd_vue__ = __webpack_require__("plct");
function injectStyle (ssrContext) {
  __webpack_require__("0Emz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f07210f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementForOrdersSuppliersAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f07210f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementForOrdersSuppliersAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nubt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_radio_button_css__ = __webpack_require__("bRYy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_radio_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_radio_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_radio_button__ = __webpack_require__("eBGF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_radio_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_radio_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_radio_group_css__ = __webpack_require__("BNJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_radio_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_radio_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group__ = __webpack_require__("fDPO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);









__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_radio_group___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_radio_button___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      loading: true,
      tableData: [],
      statusFilter: '',
      challengeTitle: ''
    };
  },

  computed: {
    challengeId: function challengeId() {
      var fromProp = this.route && this.route.params && this.route.params.challengeId;
      var fromRouter = this.$route && this.$route.params && this.$route.params.challengeId;
      return fromProp || fromRouter;
    }
  },
  created: function created() {
    this.challengeTitle = this.route && this.route.query && this.route.query.title || this.$route.query && this.$route.query.title || '';
    this.loadUsers();
  },

  methods: {
    formatChallengeStatus: function formatChallengeStatus(status) {
      if (!status) return '—';
      var key = 'challengeCampaigns.status_' + status;
      var translated = this.$t(key);
      return translated === key ? status : translated;
    },
    loadUsers: function loadUsers() {
      var _this = this;

      if (!this.challengeId) return;
      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        status: this.statusFilter || null,
        page: 1,
        pageSize: 100
      };
      this.apiRequest('/reports/challenges/' + this.challengeId + '/users', 'GET', data, function (response) {
        _this.loading = false;
        if (response.status) {
          _this.tableData = response.data || [];
          var challenge = response.data_specials && response.data_specials.challenge || response.challenge;
          if (challenge && challenge.title) {
            _this.challengeTitle = challenge.title;
          }
        }
      });
    },
    onRowClick: function onRowClick(row) {
      this.$router.push({
        path: '/reports/challenge-campaigns/' + this.challengeId + '/users/' + row.user_id + '/logs',
        query: { title: this.challengeTitle }
      });
    },
    close: function close() {
      this.$bus.$emit('refresh-challenge-report');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "Nxv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_radio_group_css__ = __webpack_require__("BNJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_radio_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_radio_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_radio_group__ = __webpack_require__("fDPO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_radio_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_radio_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_radio_css__ = __webpack_require__("8jhb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_radio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_radio_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio__ = __webpack_require__("RDoK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("Zki6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input_number__ = __webpack_require__("0kY3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_js_modal__);





























__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input_number___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_radio___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_radio_group___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_24_vue_js_modal___default.a, { componentName: 'vmodal' });

var DEFAULT_STATUSES = ['NEW', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'DELIVERED', 'CANCELED'];

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    hasActiveFilters: function hasActiveFilters() {
      var hasStatusFilters = this.requestFilters[0].value && this.requestFilters[0].value.length > 0;
      var hasLocationFilters = this.locationFilter.length > 0;
      var hasPickupDatetime = this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2;
      var hasPlacedDatetime = this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2;
      var hasOrderId = this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== '';
      var hasOrderNumber = this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== '';
      var hasOrderTotal = this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null || this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null;
      var hasOperator = this.orderFilters.operator && this.orderFilters.operator.length > 0;
      var hasPaymentType = this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0;
      var hasDeliveryType = this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0;
      var hasSource = this.orderFilters.source && this.orderFilters.source.length > 0;

      return hasStatusFilters || hasLocationFilters || hasPickupDatetime || hasPlacedDatetime || hasOrderId || hasOrderNumber || hasOrderTotal || hasOperator || hasPaymentType || hasDeliveryType || hasSource;
    },
    filteredStatuses: function filteredStatuses() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.statuses).filter(function (key) {
        return key !== 'DRAFT';
      });
    }
  },
  data: function data() {
    return {
      drivers: [],
      orders: {
        new: [],
        processing: [],
        prepared: [],
        transport: [],
        delivered: [],
        canceled: []
      },
      ordersCount: {
        new: 0,
        processing: 0,
        prepared: 0,
        transport: 0,
        delivered: 0,
        canceled: 0
      },
      loading: false,
      showFiltersCollapsed: false,
      modalOrderFilters: {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: [],
        source: []
      },
      modalLocationFilter: [],
      modalSortOrder: 1,
      modalRequestFilters: [{ value: DEFAULT_STATUSES.slice() }],
      requestFilters: [{ value: DEFAULT_STATUSES.slice() }],
      locationFilter: [],
      sortOrder: 1,
      operatorOptions: [],
      sourceOptions: [1, 2, 3, 4, 5, 6, 7, 8],
      paymentTypeOptions: ['CASH', 'CARD', 'POS', 'CARD_POS', 'CASH_MACHINE', 'POS_KIOSK', 'ONLINE', 'SPLIT', 'ROOM', 'FOLIO', 'EVENT', 'MANCARE_PERSONAL', 'PROTOCOL', 'VIRAMENT', 'GLOVO_CARD', 'GLOVO_CASH', 'BOLT_CASH', 'BOLT_CARD', 'WOLT_CASH', 'WOLT_CARD', 'null'],
      deliveryTypeOptions: ['PICK_UP', 'DELIVERY', 'EAT_LOCATION', 'MEET_HALF', 'SELF_ORDERING'],
      orderFilters: {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: [],
        source: []
      },
      sortOptions: [{ id: 1, name: 'CreatedDescending' }, { id: 2, name: 'CreatedAscending' }, { id: 3, name: 'PickupDescending' }, { id: 4, name: 'PickupAscending' }],
      resetFiltersObj: [{ value: DEFAULT_STATUSES.slice() }],
      statuses: this.$session.get('defaultData')['order_statuses']['ALL_DELIVERY_TYPES'],
      locations: []
    };
  },
  created: function created() {
    var _this = this;

    this.loadSavedFilters();
    this.getPosUsers();
    this.getLocations().then(function () {
      _this.getDispatchOrders();
    }).catch(function () {
      _this.getDispatchOrders();
    });
  },

  methods: {
    emptyOrdersBuckets: function emptyOrdersBuckets() {
      return {
        new: [],
        processing: [],
        prepared: [],
        transport: [],
        delivered: [],
        canceled: []
      };
    },
    emptyOrdersCount: function emptyOrdersCount() {
      return {
        new: 0,
        processing: 0,
        prepared: 0,
        transport: 0,
        delivered: 0,
        canceled: 0
      };
    },
    buildFilterParams: function buildFilterParams() {
      var data = {};

      data.statuses = this.requestFilters[0].value && this.requestFilters[0].value.length ? this.requestFilters[0].value.join(',') : DEFAULT_STATUSES.join(',');

      if (this.locationFilter.length) {
        var normalizedIds = this.locationFilter.map(function (id) {
          return parseInt(id, 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        data.locations = normalizedIds.join(',');
      }

      var sortOrderId = this.sortOrder || 1;
      var sortOption = this.sortOptions.find(function (sort) {
        return sort.id === parseInt(sortOrderId);
      });

      data.sort_order = sortOption ? sortOption.name : 'CreatedDescending';

      if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
        data.pickup_datetime_from = this.orderFilters.pickupDatetime[0];
        data.pickup_datetime_to = this.adjustEndTime(this.orderFilters.pickupDatetime[1]);
      }
      if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
        data.created_at_from = this.orderFilters.placedDatetime[0];
        data.created_at_to = this.adjustEndTime(this.orderFilters.placedDatetime[1]);
      }
      if (this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== '') {
        data.id = String(this.orderFilters.orderId).trim();
      }
      if (this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== '') {
        data.order_number = this.orderFilters.orderNumber.trim();
      }
      if (this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null) {
        data.order_total_min = this.normalizeOrderTotal(this.orderFilters.orderTotalMin);
      }
      if (this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null) {
        data.order_total_max = this.normalizeOrderTotal(this.orderFilters.orderTotalMax);
      }
      if (this.orderFilters.operator && this.orderFilters.operator.length > 0) {
        data.operator = this.orderFilters.operator.join(',');
      }
      if (this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0) {
        data.payment_type = this.orderFilters.paymentType.join(',');
      }
      if (this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0) {
        data.delivery_type = this.orderFilters.deliveryType.join(',');
      }
      if (this.orderFilters.source && this.orderFilters.source.length > 0) {
        data.source = this.orderFilters.source.join(',');
      }

      return data;
    },
    orderMatchesClientFilters: function orderMatchesClientFilters(order) {
      var status = this.getOrderStatus(order);
      if (this.requestFilters[0].value.length && status && this.requestFilters[0].value.indexOf(status) === -1) {
        return false;
      }
      if (this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0) {
        if (this.orderFilters.deliveryType.indexOf(order.delivery_type) === -1) {
          return false;
        }
      }
      if (this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0) {
        var payment = order.payment_type == null ? 'null' : String(order.payment_type);
        if (this.orderFilters.paymentType.indexOf(payment) === -1) {
          return false;
        }
      }
      if (this.orderFilters.source && this.orderFilters.source.length > 0) {
        var sourceId = order.order_source_id != null ? order.order_source_id : order.source;
        var matchesSource = this.orderFilters.source.some(function (src) {
          return src === sourceId || Number(src) === Number(sourceId) || String(src) === String(sourceId);
        });
        if (!matchesSource) {
          return false;
        }
      }
      if (this.locationFilter.length) {
        var locationId = order.location_id != null ? order.location_id : order.production_details && order.production_details.location ? order.production_details.location.true_id || order.production_details.location.id : order.store_id;
        var normalizedLocation = parseInt(locationId, 10);
        var matchesLocation = this.locationFilter.some(function (id) {
          return parseInt(id, 10) === normalizedLocation || String(id) === String(locationId);
        });
        if (!matchesLocation) {
          return false;
        }
      }
      if (this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== '') {
        if (String(order.id) !== String(this.orderFilters.orderId).trim()) {
          return false;
        }
      }
      if (this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== '') {
        if (String(order.number) !== String(this.orderFilters.orderNumber).trim()) {
          return false;
        }
      }
      if (this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null && Number(order.totals_grandtotal) < Number(this.orderFilters.orderTotalMin)) {
        return false;
      }
      if (this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null && Number(order.totals_grandtotal) > Number(this.orderFilters.orderTotalMax)) {
        return false;
      }
      return true;
    },
    getOrderStatus: function getOrderStatus(order) {
      if (!order || order.status == null) {
        return null;
      }
      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(order.status) === 'object') {
        return order.status.id || order.status.type || null;
      }
      return order.status;
    },
    getDispatchOrders: function getDispatchOrders() {
      var _this2 = this;

      this.loading = true;
      var dataToSend = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, this.buildFilterParams());
      this.apiRequest('/get-dispatch-orders-for-today', 'GET', dataToSend, function (response) {
        _this2.loading = false;
        if (response.status === true) {
          var orders = response.data.orders || [];
          _this2.orders = _this2.emptyOrdersBuckets();
          _this2.ordersCount = _this2.emptyOrdersCount();

          orders.forEach(function (order) {
            if (!_this2.orderMatchesClientFilters(order)) {
              return;
            }
            var status = _this2.getOrderStatus(order);
            if (status === 'NEW') {
              _this2.orders.new.push(order);
              _this2.ordersCount.new++;
            } else if (status === 'PROCESSING') {
              _this2.orders.processing.push(order);
              _this2.ordersCount.processing++;
            } else if (status === 'PREPARED') {
              _this2.orders.prepared.push(order);
              _this2.ordersCount.prepared++;
            } else if (status === 'TRANSPORT') {
              _this2.orders.transport.push(order);
              _this2.ordersCount.transport++;
            } else if (status === 'DELIVERED') {
              _this2.orders.delivered.push(order);
              _this2.ordersCount.delivered++;
            } else if (status === 'CANCELED') {
              _this2.orders.canceled.push(order);
              _this2.ordersCount.canceled++;
            }
          });
        } else {
          console.error('Failed to fetch dispatch orders:', response.message);
        }
      });
    },
    goToOrder: function goToOrder(orderId) {
      this.$router.push('/orders/view/' + orderId);
    },
    formatDeliveryType: function formatDeliveryType(type) {
      if (!type) return '';
      var key = 'deliveryTypes.' + type;
      var translated = this.$t(key);
      return translated !== key ? translated : type;
    },
    loadSavedFilters: function loadSavedFilters() {
      try {
        var savedFilters = JSON.parse(localStorage.getItem('dispatchOrdersKanbanFilters'));
        if (!savedFilters) {
          return;
        }
        if (savedFilters.requestFilters && savedFilters.requestFilters[0]) {
          this.requestFilters[0].value = savedFilters.requestFilters[0].value || this.requestFilters[0].value;
        }
        if (Array.isArray(savedFilters.locationFilter)) {
          this.locationFilter = savedFilters.locationFilter;
        }
        if (savedFilters.orderFilters) {
          this.orderFilters = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.orderFilters, savedFilters.orderFilters);
        }
        if (savedFilters.sortOrder) {
          this.sortOrder = parseInt(savedFilters.sortOrder) || 1;
        }
      } catch (e) {}
    },
    persistFilters: function persistFilters() {
      localStorage.setItem('dispatchOrdersKanbanFilters', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        requestFilters: this.requestFilters,
        locationFilter: this.locationFilter,
        orderFilters: this.orderFilters,
        sortOrder: this.sortOrder
      }));
    },
    refreshOrders: function refreshOrders() {
      this.persistFilters();
      this.getDispatchOrders();
    },
    getLocations: function getLocations() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var dataToSend = {
          token: _this3.$session.get('token'),
          company_id: _this3.$session.get('selectedCompany')
        };
        _this3.apiRequest('/get-locations-and-zones', 'GET', dataToSend, function (response) {
          if (response.status === true) {
            _this3.locations = response.data.locations || [];
            if (_this3.locationFilter.length) {
              _this3.locationFilter = _this3.normalizeLocationFilter(_this3.locationFilter);
            }
            resolve();
          } else {
            reject(response.message);
          }
        });
      });
    },
    openFiltersModal: function openFiltersModal() {
      this.modalRequestFilters = [{
        value: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.requestFilters[0].value))
      }];
      this.modalLocationFilter = this.normalizeLocationFilter(this.locationFilter);
      this.modalSortOrder = parseInt(this.sortOrder) || 1;

      var pickupDatetime = null;
      if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
        pickupDatetime = [this.orderFilters.pickupDatetime[0], this.adjustEndTime(this.orderFilters.pickupDatetime[1])];
      }

      var placedDatetime = null;
      if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
        placedDatetime = [this.orderFilters.placedDatetime[0], this.adjustEndTime(this.orderFilters.placedDatetime[1])];
      }

      this.modalOrderFilters = {
        pickupDatetime: pickupDatetime,
        placedDatetime: placedDatetime,
        orderId: this.orderFilters.orderId,
        orderNumber: this.orderFilters.orderNumber,
        orderTotalMin: this.orderFilters.orderTotalMin,
        orderTotalMax: this.orderFilters.orderTotalMax,
        operator: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.orderFilters.operator || [])),
        paymentType: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.orderFilters.paymentType || [])),
        deliveryType: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.orderFilters.deliveryType || [])),
        source: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.orderFilters.source || []))
      };
      this.$modal.show('dispatchOrdersFiltersModal');
    },
    applyFilters: function applyFilters() {
      this.requestFilters[0].value = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.modalRequestFilters[0].value));
      this.locationFilter = this.normalizeLocationFilter(this.modalLocationFilter);
      this.sortOrder = this.modalSortOrder;

      var pickupDatetime = null;
      if (this.modalOrderFilters.pickupDatetime && this.modalOrderFilters.pickupDatetime.length === 2) {
        pickupDatetime = [this.modalOrderFilters.pickupDatetime[0], this.adjustEndTime(this.modalOrderFilters.pickupDatetime[1])];
      }

      var placedDatetime = null;
      if (this.modalOrderFilters.placedDatetime && this.modalOrderFilters.placedDatetime.length === 2) {
        placedDatetime = [this.modalOrderFilters.placedDatetime[0], this.adjustEndTime(this.modalOrderFilters.placedDatetime[1])];
      }

      this.orderFilters = {
        pickupDatetime: pickupDatetime,
        placedDatetime: placedDatetime,
        orderId: this.modalOrderFilters.orderId,
        orderNumber: this.modalOrderFilters.orderNumber,
        orderTotalMin: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMin),
        orderTotalMax: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMax),
        operator: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.operator || [])),
        paymentType: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.paymentType || [])),
        deliveryType: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.deliveryType || [])),
        source: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.modalOrderFilters.source || []))
      };

      this.$modal.hide('dispatchOrdersFiltersModal');
      this.refreshOrders();
    },
    resetModalFilters: function resetModalFilters() {
      this.modalRequestFilters[0].value = DEFAULT_STATUSES.slice();
      this.modalLocationFilter = [];
      this.modalSortOrder = 1;
      this.modalOrderFilters = {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: [],
        source: []
      };

      this.requestFilters[0].value = DEFAULT_STATUSES.slice();
      this.locationFilter = [];
      this.sortOrder = 1;
      this.orderFilters = {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: [],
        source: []
      };
      this.refreshOrders();
    },
    resetFilters: function resetFilters() {
      this.requestFilters[0].value = DEFAULT_STATUSES.slice();
      this.locationFilter = [];
      this.orderFilters = {
        pickupDatetime: null,
        placedDatetime: null,
        orderId: '',
        orderNumber: '',
        orderTotalMin: null,
        orderTotalMax: null,
        operator: [],
        paymentType: [],
        deliveryType: [],
        source: []
      };
      this.sortOrder = 1;
      this.refreshOrders();
    },
    removeStatusFilter: function removeStatusFilter(index) {
      this.requestFilters[0].value.splice(index, 1);
      this.refreshOrders();
    },
    removeLocationFilter: function removeLocationFilter(index) {
      this.locationFilter.splice(index, 1);
      this.refreshOrders();
    },
    removePickupDatetimeFilter: function removePickupDatetimeFilter() {
      this.orderFilters.pickupDatetime = null;
      this.refreshOrders();
    },
    removePlacedDatetimeFilter: function removePlacedDatetimeFilter() {
      this.orderFilters.placedDatetime = null;
      this.refreshOrders();
    },
    removeOrderIdFilter: function removeOrderIdFilter() {
      this.orderFilters.orderId = '';
      this.refreshOrders();
    },
    removeOrderNumberFilter: function removeOrderNumberFilter() {
      this.orderFilters.orderNumber = '';
      this.refreshOrders();
    },
    removeOrderTotalFilter: function removeOrderTotalFilter() {
      this.orderFilters.orderTotalMin = null;
      this.orderFilters.orderTotalMax = null;
      this.refreshOrders();
    },
    removeOperatorFilter: function removeOperatorFilter(index) {
      if (index !== undefined) {
        this.orderFilters.operator.splice(index, 1);
      } else {
        this.orderFilters.operator = [];
      }
      this.refreshOrders();
    },
    removePaymentTypeFilter: function removePaymentTypeFilter(index) {
      if (index !== undefined) {
        this.orderFilters.paymentType.splice(index, 1);
      } else {
        this.orderFilters.paymentType = [];
      }
      this.refreshOrders();
    },
    removeDeliveryTypeFilter: function removeDeliveryTypeFilter(index) {
      if (index !== undefined) {
        this.orderFilters.deliveryType.splice(index, 1);
      } else {
        this.orderFilters.deliveryType = [];
      }
      this.refreshOrders();
    },
    removeSourceFilter: function removeSourceFilter(index) {
      if (index !== undefined) {
        this.orderFilters.source.splice(index, 1);
      } else {
        this.orderFilters.source = [];
      }
      this.refreshOrders();
    },
    toggleModalStatusFilter: function toggleModalStatusFilter(key) {
      var idx = this.modalRequestFilters[0].value.indexOf(key);
      if (idx === -1) {
        this.modalRequestFilters[0].value.push(key);
      } else {
        this.modalRequestFilters[0].value.splice(idx, 1);
      }
    },
    toggleModalPaymentTypeFilter: function toggleModalPaymentTypeFilter(paymentType) {
      if (!this.modalOrderFilters.paymentType) {
        this.modalOrderFilters.paymentType = [];
      }
      var idx = this.modalOrderFilters.paymentType.indexOf(paymentType);
      if (idx === -1) {
        this.modalOrderFilters.paymentType.push(paymentType);
      } else {
        this.modalOrderFilters.paymentType.splice(idx, 1);
      }
    },
    toggleModalDeliveryTypeFilter: function toggleModalDeliveryTypeFilter(deliveryType) {
      if (!this.modalOrderFilters.deliveryType) {
        this.modalOrderFilters.deliveryType = [];
      }
      var idx = this.modalOrderFilters.deliveryType.indexOf(deliveryType);
      if (idx === -1) {
        this.modalOrderFilters.deliveryType.push(deliveryType);
      } else {
        this.modalOrderFilters.deliveryType.splice(idx, 1);
      }
    },
    toggleModalSourceFilter: function toggleModalSourceFilter(src) {
      if (!this.modalOrderFilters.source) {
        this.modalOrderFilters.source = [];
      }
      var idx = this.modalOrderFilters.source.indexOf(src);
      if (idx === -1) {
        this.modalOrderFilters.source.push(src);
      } else {
        this.modalOrderFilters.source.splice(idx, 1);
      }
    },
    toggleFiltersCollapse: function toggleFiltersCollapse() {
      this.showFiltersCollapsed = !this.showFiltersCollapsed;
    },
    getLocationFilterValue: function getLocationFilterValue(loc) {
      if (loc.true_id != null && loc.true_id !== '') {
        return parseInt(loc.true_id, 10);
      }
      return loc.id;
    },
    getLocationName: function getLocationName(locationId) {
      var location = this.locations.find(function (loc) {
        return loc.true_id === locationId || loc.id === locationId;
      });
      return location ? location.name : locationId;
    },
    normalizeLocationFilter: function normalizeLocationFilter(locationFilter) {
      var _this4 = this;

      if (!locationFilter || !Array.isArray(locationFilter) || locationFilter.length === 0) {
        return [];
      }
      var normalized = [];

      var _loop = function _loop(value) {
        var numValue = typeof value === 'string' ? parseInt(value, 10) : value;
        var location = _this4.locations.find(function (loc) {
          if (loc.true_id === numValue || loc.true_id === value) return true;
          if (loc.id === numValue || loc.id === value) return true;
          if (typeof value === 'string') {
            return String(loc.true_id) === value || String(loc.id) === value;
          }
          return false;
        });
        if (location) {
          var filterValue = _this4.getLocationFilterValue(location);
          if (!normalized.includes(filterValue)) {
            normalized.push(filterValue);
          }
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(locationFilter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var value = _step.value;

          _loop(value);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return normalized;
    },
    getOperatorName: function getOperatorName(operatorId) {
      var operator = this.operatorOptions.find(function (op) {
        return op.id === operatorId;
      });
      return operator ? operator.label : operatorId;
    },
    formatDateRange: function formatDateRange(dateRange) {
      if (!dateRange || dateRange.length !== 2) return '';
      return dateRange[0] + ' - ' + dateRange[1];
    },
    normalizeOrderTotal: function normalizeOrderTotal(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      var num = Number(value);

      if (isNaN(num) || num === 0) {
        return null;
      }
      return num;
    },
    adjustEndTime: function adjustEndTime(datetime) {
      if (datetime && datetime.endsWith('00:00:00')) {
        return datetime.replace('00:00:00', '23:59:59');
      }
      return datetime;
    },
    adjustDatetimeRange: function adjustDatetimeRange(filterType) {
      if (this.modalOrderFilters[filterType] && this.modalOrderFilters[filterType].length === 2) {
        this.modalOrderFilters[filterType] = [this.modalOrderFilters[filterType][0], this.adjustEndTime(this.modalOrderFilters[filterType][1])];
      }
    },
    formatLabelFirstLetter: function formatLabelFirstLetter(translationKey) {
      try {
        var label = this.$t(translationKey);
        if (!label || typeof label !== 'string') {
          var fallback = translationKey.split('.').pop();
          return fallback ? fallback.toLowerCase().split(' ').map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
          }).join(' ') : translationKey;
        }
        return label.toLowerCase().split(' ').map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ');
      } catch (e) {
        var key = translationKey.split('.').pop();
        return key ? key.toLowerCase().split(' ').map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ') : translationKey;
      }
    },
    getPosUsers: function getPosUsers() {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status && response.data && response.data.pos_user) {
          _this5.operatorOptions = response.data.pos_user.map(function (user) {
            return {
              id: user.id,
              label: ((user.firstname || '') + ' ' + (user.lastname || '')).trim() || 'User ' + user.id
            };
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "Nyg0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.cancelOption($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px","margin-bottom":"0"},on:{"click":function($event){$event.preventDefault();return _vm.handleDeleteOption($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-12 col-md-8 col-sm-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"option_name"}},[_vm._v("\n                    Name:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.option_name),expression:"option_name"}],staticClass:"form-control",attrs:{"type":"text","id":"option_name"},domProps:{"value":(_vm.option_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.option_name=$event.target.value}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('div',{staticClass:"col-md-12 display-flex align-items-center justify-content-space-between"},[_c('h6',[_vm._v(_vm._s(_vm.$t('catalogProdOpt.plural')))]),_vm._v(" "),(_vm.model && Object.keys(_vm.companyOptions).length > _vm.model.length)?_c('button',{staticClass:"btn add mar-to-15 mar-lt-20 ",attrs:{"title":_vm.$t('general.add')  + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.addNewOption()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                          "+_vm._s(_vm.$t('general.add'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":_vm.$t('catalogProdOpt.plural')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-10",staticStyle:{"padding-top":"0px"}},[_c('el-collapse',{ref:"elColl",attrs:{"accordion":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_vm._l((_vm.model),function(option,idxO){return [_c('button',{staticClass:"btn btn-danger pull-left btn-icon mar-15",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteOption(idxO)}}},[_c('i',{staticClass:"ti-close"})]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":option.company_option && option.company_option.label ? option.name + ' (' + option.company_option.label + ')' : option.name,"name":idxO}},[_c('div',{staticClass:"clearfix"},[_c('hr',{staticClass:"no-margin mar-bt-15"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group pad-to-10"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProdOpt.single')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model[idxO].company_option_id),expression:"model[idxO].company_option_id"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",attrs:{"placeholder":"Pick an option"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model[idxO], "company_option_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.changeOption(idxO, _vm.model[idxO].company_option_id)}]}},[_c('option',{attrs:{"disabled":"","value":"null"}},[_vm._v(_vm._s(_vm.$t('catalogProd.pickAnOption')))]),_vm._v(" "),_vm._l((_vm.companyOptions),function(prOption){return [_c('option',{attrs:{"disabled":_vm.disableOption(idxO, prOption.id, true) && _vm.model[idxO].company_option_id != prOption.id},domProps:{"value":prOption.id}},[_vm._v(_vm._s(prOption.name)+" "+_vm._s(prOption.label && prOption.label.length ? '(' + prOption.label + ')' : ''))])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group pad-to-10"},[_c('label',[_vm._v(_vm._s(_vm.$t('general.required')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.required),expression:"option.required"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "required", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":true}},[_vm._v(_vm._s(_vm.$t('general.yes')))]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v(_vm._s(_vm.$t('general.no')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productOptions.hidePrices')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.hide_prices),expression:"option.hide_prices"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "hide_prices", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":true}},[_vm._v(_vm._s(_vm.$t('general.yes')))]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v(_vm._s(_vm.$t('general.no')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productOptions.hasDefaultValue')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.has_default_value),expression:"option.has_default_value"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "has_default_value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":true}},[_vm._v(_vm._s(_vm.$t('general.yes')))]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v(_vm._s(_vm.$t('general.no')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(option.type == 'checkbox' || option.type == 'upload')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.minNoSelected')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.min_no),expression:"option.min_no"}],staticClass:"form-control",attrs:{"type":"number","name":"min"},domProps:{"value":(option.min_no)},on:{"change":function($event){_vm.validateOption(option, _vm.model[idxO].company_option_id)},"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "min_no", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('min' + _vm.model[idxO].company_option_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                    "+_vm._s(_vm.getError('min' + _vm.model[idxO].company_option_id))+"\n                                  ")]):_vm._e(),_vm._v(" "),(_vm.errors.has('min_negative' + _vm.model[idxO].company_option_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                    "+_vm._s(_vm.getError('min_negative' + _vm.model[idxO].company_option_id))+"\n                                  ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(option.type == 'checkbox' || option.type == 'upload')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.maxNoSelected')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.max_no),expression:"option.max_no"}],staticClass:"form-control",attrs:{"type":"number","name":"max"},domProps:{"value":(option.max_no)},on:{"change":function($event){_vm.validateOption(option, _vm.model[idxO].company_option_id)},"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "max_no", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('max' + _vm.model[idxO].company_option_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                    "+_vm._s(_vm.getError('max' + _vm.model[idxO].company_option_id))+"\n                                  ")]):_vm._e(),_vm._v(" "),(_vm.errors.has('max_negative' + _vm.model[idxO].company_option_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                    "+_vm._s(_vm.getError('max_negative' + _vm.model[idxO].company_option_id))+"\n                                  ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),(option.id != '')?_c('table',{staticClass:"table no-margin"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"200px"}},[_vm._v(_vm._s(_vm.$t('catalogProd.optVal')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('catalogProd.price'))+" ("+_vm._s(_vm.currency)+")\n                                  ")]),_vm._v(" "),_c('th',[_vm._v("Pos Id")]),_vm._v(" "),(_vm.use_pos_id_per_product_option)?_c('th',[_vm._v("Pos Id 2")]):_vm._e(),_vm._v(" "),(_vm.use_quantity_per_product_option)?_c('th',[_vm._v("Qty.")]):_vm._e(),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((option.group_company_option_values),function(value,idx){return _c('tr',[_c('td',[(_vm.companyOptions[_vm.getObjectByElemKeyValue('id', option.company_option_id, _vm.companyOptions)])?[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"group-option-value-select",attrs:{"filterable":"","filter-method":_vm.filterOptionValues,"placeholder":_vm.$t('catalogProd.pickAnOption')},on:{"visible-change":_vm.resetOptionValueQuery,"change":function($event){_vm.selectOptionValue($event, idxO, idx)}},model:{value:(value.company_option_value_id),callback:function ($$v) {_vm.$set(value, "company_option_value_id", $$v)},expression:"value.company_option_value_id"}},_vm._l((_vm.companyOptions[_vm.getObjectByElemKeyValue('id', option.company_option_id, _vm.companyOptions)]['values']),function(prOption){return (_vm.matchesOptionValueQuery(prOption.name, value.company_option_value_id, prOption.id))?_c('el-option',{key:prOption.id,attrs:{"label":prOption.name,"value":prOption.id,"disabled":_vm.disableOption(idxO, prOption.id, false) && value.company_option_value_id != prOption.id}}):_vm._e()}))]:_vm._e()],2),_vm._v(" "),_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({min_value: 0}),expression:"{min_value: 0}"},{name:"model",rawName:"v-model",value:(value.price),expression:"value.price"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(value.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "price", $event.target.value)}}})])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.pos_id),expression:"value.pos_id"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(value.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "pos_id", $event.target.value)}}})])])]),_vm._v(" "),(_vm.use_pos_id_per_product_option || (value.hasOwnProperty('pos_id_per_product') && value.pos_id_per_product) )?_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.pos_id_per_product),expression:"value.pos_id_per_product"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(value.pos_id_per_product)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "pos_id_per_product", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(_vm.use_quantity_per_product_option || (value.hasOwnProperty('quantity_per_option') && value.quantity_per_option) )?_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.quantity_per_option),expression:"value.quantity_per_option"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(value.quantity_per_option)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "quantity_per_option", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.deleteOptionValue(idxO, idx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])])])}))]):_vm._e(),_vm._v(" "),(1)?_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn add mar-to-15 mar-lt-20",attrs:{"title":""},on:{"click":[function($event){_vm.validateOption(option, _vm.model[idxO].company_option_id)},function($event){$event.preventDefault();_vm.addNewOptionValue(idxO)}]}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                  "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.single'))+" "+_vm._s(_vm.$t('catalogProdOpt.value'))+"\n                              ")])]):_vm._e()])]})],2)],1)])])])])])])])]),_vm._v(" "),(!_vm.isNew())?_c('div',{staticClass:"col-lg-6 col-md-4 col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"option_name"}},[_c('p',[_vm._v(_vm._s(this.$t('groupOption.importTitle')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"location_token"}},[_vm._v(_vm._s(this.$t('pages.categories')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategoryForImport),expression:"selectedCategoryForImport"}],ref:"category_id",staticClass:"form-control",attrs:{"name":"category_id","data-vv-as":"category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategoryForImport=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"label":"Select"},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.mainCategories),function(option){return _c('option',{key:option.id,attrs:{"label":option.name},domProps:{"value":option.id}})})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"location_token"}},[_vm._v(_vm._s(this.$t('settingsOrdering.locations')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationForImport),expression:"selectedLocationForImport"}],ref:"location_token",staticClass:"form-control",attrs:{"name":"location_token","id":"location_token","data-vv-as":"location"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationForImport=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"label":this.$t('general.all')},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.locations),function(el){return _c('option',{key:el.id,attrs:{"label":el.name},domProps:{"value":el.token}})})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn add mar-to-15",on:{"click":function($event){$event.preventDefault();_vm.importGroupOptionToCategory()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.add'))+"\n                ")])])])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"space_for_alert_box",staticStyle:{"height":"100px","width":"100%"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 pad-lf-0 pad-rg-0"},[_c('hr',{staticClass:"sm",staticStyle:{"margin-bottom":"5px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O1IU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoSupportCard_vue__ = __webpack_require__("eSji");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3afe320b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoSupportCard_vue__ = __webpack_require__("OoTu");
function injectStyle (ssrContext) {
  __webpack_require__("nrBd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3afe320b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoSupportCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3afe320b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoSupportCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O3tG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O5PS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O5me":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O6k+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);





var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var _require = {
  webm: "data:video/webm;base64,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",
  mp4: "data:video/mp4;base64,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"
};

var webm = _require.webm;
var mp4 = _require.mp4;

var oldIOS = function oldIOS() {
  return typeof navigator !== "undefined" && parseFloat(("" + (/CPU.*OS ([0-9_]{3,4})[0-9_]{0,1}|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ""])[1]).replace("undefined", "3_2").replace("_", ".").replace("_", "")) < 10 && !window.MSStream;
};

var nativeWakeLock = function nativeWakeLock() {
  return "wakeLock" in navigator;
};

var NoSleep = function () {
  function NoSleep() {
    var _this = this;

    _classCallCheck(this, NoSleep);

    this.enabled = false;
    if (nativeWakeLock()) {
      this._wakeLock = null;
      var handleVisibilityChange = function handleVisibilityChange() {
        if (_this.enabled && document.visibilityState === "visible") {
          _this.enable();
        }
      };
      document.addEventListener("visibilitychange", handleVisibilityChange);
      document.addEventListener("fullscreenchange", handleVisibilityChange);
    } else if (oldIOS()) {
      this.noSleepTimer = null;
    } else {
      this.noSleepVideo = document.createElement("video");

      this.noSleepVideo.setAttribute("title", "No Sleep");
      this.noSleepVideo.setAttribute("playsinline", "");

      this._addSourceToVideo(this.noSleepVideo, "webm", webm);
      this._addSourceToVideo(this.noSleepVideo, "mp4", mp4);

      this.noSleepVideo.addEventListener("loadedmetadata", function () {
        if (_this.noSleepVideo.duration <= 1) {
          _this.noSleepVideo.setAttribute("loop", "");
        } else {
          _this.noSleepVideo.addEventListener("timeupdate", function () {
            if (_this.noSleepVideo.currentTime > 0.5) {
              _this.noSleepVideo.currentTime = Math.random();
            }
          });
        }
      });
    }
  }

  _createClass(NoSleep, [{
    key: "_addSourceToVideo",
    value: function _addSourceToVideo(element, type, dataURI) {
      var source = document.createElement("source");
      source.src = dataURI;
      source.type = "video/" + type;
      element.appendChild(source);
    }
  }, {
    key: "enable",
    value: function enable() {
      var _this2 = this;

      if (nativeWakeLock()) {
        if (document.visibilityState !== "visible") {
          _this2.enabled = true;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        }
        return navigator.wakeLock.request("screen").then(function (wakeLock) {
          _this2._wakeLock = wakeLock;
          _this2.enabled = true;

          _this2._wakeLock.addEventListener("release", function () {});
        }).catch(function (err) {
          _this2.enabled = false;
          console.error(err.name + ", " + err.message);
        });
      } else if (oldIOS()) {
        this.disable();
        console.warn("\n        NoSleep enabled for older iOS devices. This can interrupt\n        active or long-running network requests from completing successfully.\n        See https://github.com/richtr/NoSleep.js/issues/15 for more details.\n      ");
        this.noSleepTimer = window.setInterval(function () {
          if (!document.hidden) {
            window.location.href = window.location.href.split("#")[0];
            window.setTimeout(window.stop, 0);
          }
        }, 15000);
        this.enabled = true;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      } else {
        var playPromise = this.noSleepVideo.play();
        return playPromise.then(function (res) {
          _this2.enabled = true;
          return res;
        }).catch(function (err) {
          _this2.enabled = false;
          throw err;
        });
      }
    }
  }, {
    key: "disable",
    value: function disable() {
      if (nativeWakeLock()) {
        if (this._wakeLock) {
          this._wakeLock.release();
        }
        this._wakeLock = null;
      } else if (oldIOS()) {
        if (this.noSleepTimer) {
          console.warn("\n          NoSleep now disabled for older iOS devices.\n        ");
          window.clearInterval(this.noSleepTimer);
          this.noSleepTimer = null;
        }
      } else {
        this.noSleepVideo.pause();
      }
      this.enabled = false;
    }
  }, {
    key: "isEnabled",
    get: function get() {
      return this.enabled;
    }
  }]);

  return NoSleep;
}();

/* harmony default export */ __webpack_exports__["a"] = (NoSleep);

/***/ }),

/***/ "O7GA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons",staticStyle:{"display":"flex","align-items":"center","gap":"20px","margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n              "+_vm._s(loc.name)+"\n            ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"1","display":"flex","flex-direction":"column"}},[_c('label',[_vm._v("Date și oră")]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"disabled":_vm.loading},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"right-buttons",staticStyle:{"display":"flex","gap":"10px"}},[_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":'Export XML'},on:{"click":function($event){_vm.exportFacturiIntrare('XML')}}},[_vm._v("\n          "+_vm._s(_vm.$t('gestiune.download_xml'))+"\n          "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":'Export XLS'},on:{"click":function($event){_vm.exportFacturiIntrare('XLS')}}},[_vm._v("\n          "+_vm._s(_vm.$t('general.download_xls'))+"\n          "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])])]),_vm._v(" "),_c('div',{staticClass:"export-info-text"},[_vm._v("\n    "+_vm._s(_vm.$t('gestiune.exportAccounting.infoText'))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OBGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[(_vm.userId !== _vm.loggedUserId)?_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.cancelUser($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")]):_vm._e()]),_vm._v(" "),_c('p',[_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15"},[_c('div',{class:_vm.isNew ? 'col-md-6 ' : 'col-lg-6 col-md-12'},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(!_vm.isNew)?_c('div',{staticStyle:{"display":"none"}},[_vm._v("\n                id: "+_vm._s(_vm.model.id)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.isNew && !_vm.fromDispatchSettings && !_vm.fromKdsSettings && !_vm.fromDispatcherSettings)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.role')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.role),expression:"modelValidate.role"},{name:"model",rawName:"v-model",value:(_vm.model.role),expression:"model.role"}],staticClass:"form-control",attrs:{"name":"role","disabled":!_vm.isNew},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getDriverCode(_vm.model.role)}]}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.roles),function(role,key){return _c('option',{key:key,attrs:{"label":role},domProps:{"value":key}})})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.role.invalid),expression:"role.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('role'))+"\n                ")])]):_vm._e(),_vm._v(" "),(_vm.isNew && _vm.fromDispatchSettings)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.role')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.role),expression:"modelValidate.role"},{name:"model",rawName:"v-model",value:(_vm.model.role),expression:"model.role"}],staticClass:"form-control",attrs:{"name":"role","disabled":!_vm.isNew},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.onDispatchRoleChange(_vm.model.role)}]}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_c('option',{attrs:{"value":"DRIVER"}},[_vm._v("\n                    "+_vm._s(_vm.roles.DRIVER || _vm.$t('settingUsers.DRIVER'))+"\n                  ")]),_vm._v(" "),_c('option',{attrs:{"value":"DISPATCHER"}},[_vm._v("\n                    "+_vm._s(_vm.roles.DISPATCHER || _vm.$t('settingUsers.DISPATCHER'))+"\n                  ")])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.role.invalid),expression:"role.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('role'))+"\n                ")])]):_vm._e(),_vm._v(" "),(_vm.isNew && _vm.fromDispatcherSettings)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.role')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.role),expression:"modelValidate.role"},{name:"model",rawName:"v-model",value:(_vm.model.role),expression:"model.role"}],staticClass:"form-control",attrs:{"name":"role","disabled":!_vm.isNew},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_c('option',{attrs:{"value":"DISPATCHER","selected":""}},[_vm._v("\n                    "+_vm._s(_vm.roles.DISPATCHER || _vm.$t('settingUsers.DISPATCHER'))+"\n                  ")])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.role.invalid),expression:"role.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('role'))+"\n                ")])]):_vm._e(),_vm._v(" "),(_vm.isNew && _vm.fromKdsSettings)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.role')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.role),expression:"modelValidate.role"},{name:"model",rawName:"v-model",value:(_vm.model.role),expression:"model.role"}],staticClass:"form-control",attrs:{"name":"role","disabled":!_vm.isNew},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getDriverCode(_vm.model.role)}]}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_c('option',{attrs:{"value":"KDS_OPERATOR","selected":""}},[_vm._v("\n                    "+_vm._s(_vm.roles.KDS_OPERATOR)+"\n                  ")])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.role.invalid),expression:"role.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('role'))+"\n                ")])]):_vm._e(),_vm._v(" "),(_vm.model.role && (_vm.model.role == 'USER' || _vm.model.role == 'DRIVER' || _vm.model.role == 'DISPATCHER' || _vm.model.role == 'LOCATION_ADMIN' || _vm.model.role == 'LOCATION_STORE_ADMIN' || _vm.model.role == 'OPERATOR'|| _vm.model.role == 'USER_CUSTOM'))?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.locations')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.locations,"value":"id","label":"name"},model:{value:(_vm.model.locations),callback:function ($$v) {_vm.$set(_vm.model, "locations", $$v)},expression:"model.locations"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("\n                  "+_vm._s(_vm.$t('settingUsers.locations_helptext'))+"\n                ")])],1):_vm._e(),_vm._v(" "),(_vm.model.role && (_vm.model.role == 'DRIVER'))?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.zones')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.filteredData,"value":"id","label":"name"},model:{value:(_vm.model.delivery_ranges),callback:function ($$v) {_vm.$set(_vm.model, "delivery_ranges", $$v)},expression:"model.delivery_ranges"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",class:{'has-error': _vm.hasFieldError('firstname')}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.fn')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.dispatcherMode ? '' : _vm.modelValidate.firstname),expression:"dispatcherMode ? '' : modelValidate.firstname"},{name:"model",rawName:"v-model",value:(_vm.model.firstname),expression:"model.firstname"}],staticClass:"form-control",class:{ error: _vm.hasFieldError('firstname') },attrs:{"type":"text","name":"firstname","placeholder":_vm.$t('settingUsers.fn'),"aria-invalid":_vm.hasFieldError('firstname') ? 'true' : 'false'},domProps:{"value":(_vm.model.firstname)},on:{"blur":function($event){_vm.onDispatcherFieldChange('firstname')},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstname", $event.target.value)},function($event){_vm.onDispatcherFieldChange('firstname')}]}}),_vm._v(" "),(_vm.hasFieldError('firstname'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.$t('validations.requiredField'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{'has-error': _vm.hasFieldError('lastname')}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.ln')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.dispatcherMode ? '' : _vm.modelValidate.lastname),expression:"dispatcherMode ? '' : modelValidate.lastname"},{name:"model",rawName:"v-model",value:(_vm.model.lastname),expression:"model.lastname"}],staticClass:"form-control",class:{ error: _vm.hasFieldError('lastname') },attrs:{"type":"text","name":"lastname","placeholder":_vm.$t('settingUsers.ln'),"aria-invalid":_vm.hasFieldError('lastname') ? 'true' : 'false'},domProps:{"value":(_vm.model.lastname)},on:{"blur":function($event){_vm.onDispatcherFieldChange('lastname')},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastname", $event.target.value)},function($event){_vm.onDispatcherFieldChange('lastname')}]}}),_vm._v(" "),(_vm.hasFieldError('lastname'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.$t('validations.requiredField'))+"\n                ")]):_vm._e()]),_vm._v(" "),(_vm.model.role != 'DISPATCHER')?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fiscal Printer")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.fiscal_printer_id),expression:"model.fiscal_printer_id"}],staticClass:"form-control",attrs:{"name":"location"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "fiscal_printer_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.none')))]),_vm._v(" "),_vm._l((_vm.fiscalPrinter),function(el){return _c('option',{key:el.id,attrs:{"label":el.series},domProps:{"value":el.id}})})],2)])]):_vm._e(),_vm._v(" "),(_vm.model.role != 'DISPATCHER')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Server Ip:port")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.server_ip_port),expression:"model.server_ip_port"}],staticClass:"form-control",attrs:{"type":"text","name":"server_ip_port","data-vv-as":"server_ip_port","placeholder":"192.168.100.100:6999"},domProps:{"value":(_vm.model.server_ip_port)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "server_ip_port", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text"},[_vm._v("\n                  You need a proxy server\n                ")])]):_vm._e(),_vm._v(" "),(_vm.model.role == 'DRIVER')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.phone')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.phone),expression:"modelValidate.phone"},{name:"model",rawName:"v-model",value:(_vm.model.phone),expression:"model.phone"}],staticClass:"form-control",attrs:{"type":"text","name":"phone","placeholder":_vm.$t('settingUsers.phone')},domProps:{"value":(_vm.model.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "phone", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('phone'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('phone'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.role != 'DRIVER' && _vm.model.role != 'DISPATCHER')?_c('div',{staticClass:"form-group",class:{'has-error': _vm.hasFieldError('email')}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.email')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.email),expression:"modelValidate.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",class:{ error: _vm.hasFieldError('email') },attrs:{"type":"text","name":"email","placeholder":_vm.$t('settingUsers.email'),"aria-invalid":_vm.hasFieldError('email') ? 'true' : 'false'},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),(_vm.hasFieldError('email'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.$t('validations.requiredField'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.role == 'DISPATCHER')?_c('div',{staticClass:"form-group",class:{'has-error': _vm.hasFieldError('login_code')}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.login_code')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.login_code),expression:"model.login_code"}],staticClass:"form-control",class:{ error: _vm.hasFieldError('login_code') },attrs:{"type":"text","name":"login_code","maxlength":"4","inputmode":"numeric","placeholder":_vm.$t('settingTable.login_code'),"aria-invalid":_vm.hasFieldError('login_code') ? 'true' : 'false'},domProps:{"value":(_vm.model.login_code)},on:{"blur":function($event){_vm.onDispatcherFieldChange('login_code')},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "login_code", $event.target.value)},function($event){_vm.onDispatcherFieldChange('login_code')}]}}),_vm._v(" "),(_vm.hasFieldError('login_code'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.$t('validations.requiredField'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.role == 'DISPATCHER')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingLocationGroups.active')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}})],1):_vm._e(),_vm._v(" "),(_vm.model.role == 'DISPATCHER')?[_c('div',[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.is_manager')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.is_manager),callback:function ($$v) {_vm.is_manager=$$v},expression:"is_manager"}})],1),_vm._v(" "),_c('div',{staticClass:"isManagerBox"},[(_vm.is_manager)?_c('div',{staticClass:"managerBox"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_access_reports')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_access_reports),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_access_reports", $$v)},expression:"model.pos_allow_access_reports"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_reports')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_reports),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_reports", $$v)},expression:"model.pos_allow_reports"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_approvals')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_approvals),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_approvals", $$v)},expression:"model.pos_allow_approvals"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_discount')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_discount),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_discount", $$v)},expression:"model.pos_allow_discount"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.pos_allow_refund')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.pos_allow_refund),callback:function ($$v) {_vm.$set(_vm.model, "pos_allow_refund", $$v)},expression:"model.pos_allow_refund"}})],1)]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.model.role == 'DRIVER')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.username')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.email),expression:"modelValidate.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"text","name":"email","placeholder":_vm.$t('settingUsers.username'),"disabled":""},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('email'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('email'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isNew && _vm.model.role != 'DISPATCHER')?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingUsers.password')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.password),expression:"modelValidate.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":_vm.$t('settingUsers.password')},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('password'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isNew && _vm.model.role != 'DISPATCHER')?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingUsers.confPass')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.password_confirmation),expression:"modelValidate.password_confirmation"},{name:"model",rawName:"v-model",value:(_vm.model.password_confirmation),expression:"model.password_confirmation"}],staticClass:"form-control",attrs:{"type":"password","name":"password_confirmation","placeholder":_vm.$t('settingUsers.confPass')},domProps:{"value":(_vm.model.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password_confirmation", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password_confirmation'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('password_confirmation'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.role != 'OWNER' && !_vm.isNew)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.role')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.role),expression:"modelValidate.role"},{name:"model",rawName:"v-model",value:(_vm.model.role),expression:"model.role"}],staticClass:"form-control",attrs:{"name":"role","disabled":!_vm.isNew},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.roles),function(role,key){return _c('option',{key:key,attrs:{"label":role},domProps:{"value":key}})})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.role.invalid),expression:"role.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('role'))+"\n                ")])]):_vm._e(),_vm._v(" "),(_vm.model.role != 'DISPATCHER')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.lang')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.language),expression:"model.language"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.language),expression:"modelValidate.language"}],staticClass:" form-control",attrs:{"placeholder":" - Select Language - "},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.languages),function(label,key){return _c('option',{key:key,attrs:{"label":label},domProps:{"value":key}},[_vm._v(_vm._s(label))])})),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t('settingUsers.langMsg')))]),_vm._v(" "),(_vm.errors.has('language'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('language'))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.role != 'DISPATCHER')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.avatar')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1):_vm._e()],2)])])])]),_vm._v(" "),(!_vm.isNew)?_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loadingReset ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',{},[_c('div',{staticClass:"row card-content"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v("\n                "+_vm._s(_vm.$t('settingUsers.resetPass'))+"\n              ")]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingUsers.pass')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":_vm.$t('settingUsers.pass'),"aria-invalid":_vm.errors.has('password_2') ? true : false},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password_2'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('password_2'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingUsers.confPass')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password_confirmation),expression:"model.password_confirmation"}],staticClass:"form-control",attrs:{"type":"password","placeholder":_vm.$t('settingUsers.confPass'),"aria-invalid":_vm.errors.has('password_confirm_2') ? true : false},domProps:{"value":(_vm.model.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password_confirmation", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password_confirm_2'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('password_confirm_2'))+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row card-footer"},[_c('div',{staticClass:"col-md-12 form-group"},[_c('label'),_vm._v(" "),_c('button',{staticClass:"btn reset",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validateReset($event)}}},[_vm._v("\n                "+_vm._s(_vm.$t('general.reset'))+"\n              ")])])])])])]):_vm._e(),_vm._v(" "),(_vm.model.role == 'DRIVER' && !_vm.isNew)?_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loadingReset ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"none","margin":"30px 20px","margin-bottom":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.active')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.driver_schedule_active),callback:function ($$v) {_vm.$set(_vm.model, "driver_schedule_active", $$v)},expression:"model.driver_schedule_active"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin":"30px 20px","margin-bottom":"10px"}},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('settingUsers.scheduleStatus'))+"\n            "),_c('strong',{class:_vm.model.driver_schedule_active ? 'text-success' : 'text-danger'},[_vm._v("\n              "+_vm._s(_vm.model.driver_schedule_active ? _vm.$t('settingUsers.scheduleActive') : _vm.$t('settingUsers.scheduleInactive'))+"\n            ")])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row card-content"},[_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"card-title"},[_vm._v("\n                "+_vm._s(_vm.$t('settingUsers.program'))+"\n              ")]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_vm._l((_vm.model.driver_schedule),function(day,dayIdx){return _c('div',{staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","padding":"20px"}},[_c('div',{staticClass:"col-md-12"},[_c('span',[_vm._v(_vm._s(_vm.available_days[dayIdx]))]),_vm._v(" "),_c('div',[_vm._l((day),function(interval,intervalKey){return [_c('div',{staticClass:"interval"},[_c('div',{staticClass:"int"},[_vm._v("\n                        From\n                        "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"placeholder":"Select time","value":interval.from,"picker-options":_vm.pickerOptions},model:{value:(interval.from),callback:function ($$v) {_vm.$set(interval, "from", $$v)},expression:"interval.from"}}),_vm._v("\n                        To\n                        "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"placeholder":"Select time","value":interval.to,"picker-options":_vm.pickerOptions},model:{value:(interval.to),callback:function ($$v) {_vm.$set(interval, "to", $$v)},expression:"interval.to"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.deleteIntervals(dayIdx, intervalKey)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])],1)])]})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-icon ",attrs:{"title":_vm.$t('general.add')  + ' moreIntervals'},on:{"click":function($event){$event.preventDefault();_vm.addMoreIntervals(dayIdx)}}},[_c('i',{staticClass:"ti-plus"})])])])})],2)])])]):_vm._e(),_vm._v(" "),(_vm.userRole != 'USER_CUSTOM' && (_vm.model.role == 'LOCATION_ADMIN' || _vm.model.role == 'LOCATION_STORE_ADMIN' || _vm.model.role == 'USER_CUSTOM') && !_vm.isNew)?_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row card-content"},[_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"card-title"},[_vm._v("\n                "+_vm._s(_vm.$t('settingUsers.permissions'))+"\n              ")]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","padding":"20px"}},[(_vm.model.permissions_map)?_c('div',{staticClass:"col-md-12"},[(_vm.model.role == 'USER_CUSTOM')?[_c('p',[_vm._v(_vm._s(_vm.$t('settingUsers.permissionsGeneral')))]),_vm._v(" "),_vm._l((_vm.model.permissions_map),function(value,key){return _c('div',{key:key,staticClass:"row"},[(key.startsWith('general_') && key !== 'general_can_access_price_lists')?_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{on:{"input":function($event){_vm.onGeneralPermissionChange(key, $event)}},model:{value:(_vm.model.permissions_map[key]),callback:function ($$v) {_vm.$set(_vm.model.permissions_map, key, $$v)},expression:"model.permissions_map[key]"}},[_vm._v("\n                        "+_vm._s(_vm.$t('permission.' + key))+"\n                      ")]),_vm._v(" "),(key === 'general_can_access_catalog')?_c('div',{staticClass:"col-md-12",staticStyle:{"padding-left":"28px","margin-top":"4px"}},[_c('p-checkbox',{attrs:{"disabled":!_vm.model.permissions_map.general_can_access_catalog},model:{value:(_vm.model.permissions_map.general_can_access_price_lists),callback:function ($$v) {_vm.$set(_vm.model.permissions_map, "general_can_access_price_lists", $$v)},expression:"model.permissions_map.general_can_access_price_lists"}},[_vm._v("\n                          "+_vm._s(_vm.$t('permission.general_can_access_price_lists'))+"\n                        ")])],1):_vm._e()],1):_vm._e()])}),_vm._v(" "),_c('br')]:_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('settingUsers.permissionsGestiune')))]),_vm._v(" "),_vm._l((_vm.model.permissions_map),function(value,key){return _c('div',{key:key,staticClass:"row"},[(_vm.allowedPermissions.includes(key))?_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.model.permissions_map[key]),callback:function ($$v) {_vm.$set(_vm.model.permissions_map, key, $$v)},expression:"model.permissions_map[key]"}},[_vm._v("\n                      "+_vm._s(_vm.$t('permission.' + key))+"\n                    ")])],1):_vm._e()])})],2):_vm._e()])])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ODBQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ODHw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementProduction_vue__ = __webpack_require__("GlGL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_096da32a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementProduction_vue__ = __webpack_require__("Eo5+");
function injectStyle (ssrContext) {
  __webpack_require__("TNB8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-096da32a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementProduction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_096da32a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementProduction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OEwP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTOMATION_TYPE_BIRTHDAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTOMATION_TYPE_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTOMATION_TYPES; });

var AUTOMATION_TYPE_BIRTHDAY = 1;
var AUTOMATION_TYPE_CART = 3;

var AUTOMATION_TYPES = [{ value: 1, label: 'marketingAutomation.typeBirthday', icon: 'fa fa-birthday-cake', available: true }, { value: 2, label: 'marketingAutomation.typeGeofencing', icon: 'fa fa-map-marker', available: false }, { value: 3, label: 'marketingAutomation.typeAbandonedCart', icon: 'fa fa-shopping-cart', available: true }, { value: 4, label: 'marketingAutomation.typeProductViews', icon: 'fa fa-eye', available: false }];

/***/ }),

/***/ "OFjz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);












__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isDonationCampaignsReport: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: true,
      searchName: '',
      locationFilter: [],
      locations: [],
      tableData: [],
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      paginationDef: {
        page: 1,
        perPage: 25,
        totalRecords: 0
      }
    };
  },

  watch: {
    isDonationCampaignsReport: function isDonationCampaignsReport(active) {
      if (active) {
        this.getCampaigns();
      }
    }
  },
  created: function created() {
    this.initializePage();
    this.$bus.$on('refreshDonationCampaignsReport', this.getCampaigns);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refreshDonationCampaignsReport', this.getCampaigns);
  },

  methods: {
    initializePage: function initializePage() {
      this.locations = this.$session.get('selectedCompanyData').locations_details || [];
      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        if (allowedLocations && allowedLocations.length > 0) {
          this.locations = this.locations.filter(function (el) {
            return allowedLocations.includes(el.true_id) || allowedLocations.includes(el.id);
          });
        }
      }
      this.getCampaigns();
    },
    applyFilters: function applyFilters() {
      this.paginationDef.page = 1;
      this.getCampaigns();
    },
    handlePageChange: function handlePageChange(page) {
      this.paginationDef.page = page;
      this.getCampaigns();
    },
    buildParams: function buildParams() {
      var params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.paginationDef.page,
        per_page: this.paginationDef.perPage
      };
      if (this.searchName && String(this.searchName).trim()) {
        params.name = String(this.searchName).trim();
      }
      if (this.locationFilter && this.locationFilter.length) {
        params.location_ids = this.locationFilter;
      }
      return params;
    },
    getCampaigns: function getCampaigns() {
      var _this = this;

      if (!this.isDonationCampaignsReport) {
        return;
      }
      this.loading = true;
      this.apiRequest('/reports/donation-campaigns', 'GET', this.buildParams(), function (response) {
        if (response.status === true) {
          var payload = response.data || {};
          if (payload.pagination) {
            _this.tableData = payload.data || [];
            _this.paginationDef.page = payload.pagination.page || _this.paginationDef.page;
            _this.paginationDef.perPage = payload.pagination.per_page || payload.pagination.perPage || _this.paginationDef.perPage;
            _this.paginationDef.totalRecords = payload.pagination.totalRecords || payload.pagination.total || 0;
          } else if (Array.isArray(payload.data)) {
            _this.tableData = payload.data;
            _this.paginationDef.totalRecords = payload.total || payload.data.length;
          } else if (Array.isArray(payload)) {
            _this.tableData = payload;
            _this.paginationDef.totalRecords = payload.length;
          } else {
            _this.tableData = [];
            _this.paginationDef.totalRecords = 0;
          }
        } else {
          _this.tableData = [];
          _this.paginationDef.totalRecords = 0;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    locationIdMatches: function locationIdMatches(a, b) {
      if (a === b) return true;
      if (a == null || b == null || a === '' || b === '') return false;
      return String(a) === String(b);
    },
    locationMatchesId: function locationMatchesId(loc, locationId) {
      return this.locationIdMatches(loc.id, locationId) || this.locationIdMatches(loc.true_id, locationId);
    },
    getRowLocationNames: function getRowLocationNames(row) {
      var _this2 = this;

      if (row.locations_formatted && row.locations_formatted.length) {
        return row.locations_formatted.map(function (loc) {
          return loc.name;
        });
      }
      var locationIds = row.location_ids;
      if (!locationIds || !locationIds.length || !this.locations.length) {
        return [];
      }
      return this.locations.filter(function (loc) {
        return locationIds.some(function (locationId) {
          return _this2.locationMatchesId(loc, locationId);
        });
      }).map(function (loc) {
        return loc.name;
      });
    },
    getVisibleLocationName: function getVisibleLocationName(row) {
      var names = this.getRowLocationNames(row);
      if (names.length) {
        return names[0];
      }
      if (!row.location_ids || !row.location_ids.length) {
        return this.$t('donationCampaigns.allLocations');
      }
      return '-';
    },
    getHiddenLocationCount: function getHiddenLocationCount(row) {
      var names = this.getRowLocationNames(row);
      if (names.length <= 1) {
        return 0;
      }
      return names.length - 1;
    },
    getLocationNames: function getLocationNames(row) {
      var names = this.getRowLocationNames(row);
      if (names.length) {
        return names.join(', ');
      }
      if (!row.location_ids || !row.location_ids.length) {
        return this.$t('donationCampaigns.allLocations');
      }
      return '-';
    },
    formatProgress: function formatProgress(row) {
      if (row.progress != null && !isNaN(parseFloat(row.progress))) {
        return parseFloat(row.progress).toFixed(1) + '%';
      }
      var target = parseFloat(row.target_amount || 0);
      var raised = parseFloat(row.raised_total || 0);
      if (target <= 0) return '0%';
      return Math.min(100, raised / target * 100).toFixed(1) + '%';
    },
    onRowClick: function onRowClick(row) {
      if (!row || row.id == null) return;
      this.$router.push({
        path: '/reports/donation-campaigns/' + row.id + '/orders',
        query: {
          tab: 'donation-campaigns-report',
          title: row.name || String(row.id)
        }
      });
    }
  }
});

/***/ }),

/***/ "OGAj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"report-filters"},[_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 form-group pull-left"},[_c('el-input',{attrs:{"placeholder":"Cauta...","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.getData(null)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},[_c('i',{staticClass:"el-input__icon el-icon-search",attrs:{"slot":"prefix"},slot:"prefix"})])],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":function($event){_vm.getData(null)}}},[_c('i',{staticClass:"ti-search"})])])]),_vm._v(" "),_c('div',{staticClass:"card-content total-pagination pad-15 wallet-report-table-wrap"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{ show: false },"total":_vm.total,"table-props":_vm.tableOptions},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('reports.wallet_id'),"width":"70","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"firstname","label":_vm.$t('reports.wallet_firstname'),"min-width":"110","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"lastname","label":_vm.$t('reports.wallet_lastname'),"min-width":"95","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email","class-name":"wallet-ellipsis-cell","label":_vm.$t('reports.wallet_email'),"min-width":"220","show-overflow-tooltip":"","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"phone","label":_vm.$t('reports.wallet_phone'),"min-width":"130","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"loyalty_points","label":_vm.$t('reports.wallet_loyalty_points'),"min-width":"180","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"donation_points","label":_vm.$t('reports.wallet_donation_points'),"min-width":"180","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"wallet_value","label":_vm.$t('reports.wallet_value'),"min-width":"120","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(parseFloat(props.row.wallet_value || 0).toFixed(2))+" "+_vm._s(_vm.currency)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"driver_wallet","label":_vm.$t('reports.wallet_driver_wallet'),"min-width":"180","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(parseFloat(props.row.driver_wallet || 0).toFixed(2))+" "+_vm._s(_vm.currency)+"\n          ")]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OKCc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OM/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscriptionCalendar_vue__ = __webpack_require__("DqLO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71fbfb0b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscriptionCalendar_vue__ = __webpack_require__("MNoZ");
function injectStyle (ssrContext) {
  __webpack_require__("Q+Ap")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscriptionCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71fbfb0b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscriptionCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OPEv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      dispatchRoutes: [{ path: '/dispatch?tabIndex=0', key: 'dispatch' }, { path: '/dispatch?tabIndex=1', key: 'addNewOrder' }, { path: '/dispatch?tabIndex=2', key: 'drivers' }, { path: '/dispatch?tabIndex=3', key: 'orders' }, { path: '/dispatch?tabIndex=4', key: 'reports' }, { path: '/dispatch?tabIndex=5', key: 'settings' }]
    };
  },

  methods: {
    getImageForRoute: function getImageForRoute(routeKey) {
      var images = {
        'dispatch': 'static/img/dispatch.png',
        'addNewOrder': 'static/img/dispatch-orders.png',
        'orders': 'static/img/dispatch-orders.png',
        'drivers': 'static/img/dispatch-drivers.png',
        'reports': 'static/img/dispatch-reports.png',
        'settings': 'static/img/dispatch-settings.png'
      };
      return images[routeKey] || 'static/img/default.jpg';
    },
    getBoxColor: function getBoxColor(index) {
      var colors = ['#3AB7CD', '#17B086', '#674BD2', '#FF6B6B', '#FFD93D', '#17B086'];
      return colors[index] || '#FFFFFF';
    }
  }
});

/***/ }),

/***/ "OPjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"1"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n              "+_vm._s(loc.name)+"\n            ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearchPurchases}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.fetchInvoice') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();_vm.fetchInvoices()}}},[_vm._v("\n          "+_vm._s(_vm.$t('gestiune.fetchInvoice'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.nr'),"prop":"number","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.number)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.furnizor'),"prop":"supplierName"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.supplierName)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.valoareTaxable'),"prop":"taxableValue","align":"left","header-align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.taxableValue)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.valoareTva'),"prop":"taxValue","align":"left","header-align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.taxValue)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.valoareTotal'),"prop":"totalValue","align":"left","header-align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.totalValue)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.valoarePayable'),"prop":"payableValue","align":"left","header-align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('strong',[_vm._v(_vm._s(scope.row.payableValue))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.dataEmitere'),"prop":"issueDate"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.issueDate)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('marketingOffers.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.goToInvoiceSupplier(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.see'))+"\n                  ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.viewPdf(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('gestiune.seePDF'))+"\n                  ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.exportDocument(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('gestiune.exportDocument'))+"\n                  ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OQGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var en = {
  title: 'BT iPay payments',
  apiUser: 'API username',
  apiPassword: 'API password',
  environment: 'Environment',
  sandbox: 'Sandbox',
  production: 'Production',
  mode: 'Order payment mode',
  onePhase: '1 phase — capture at checkout',
  twoPhase: '2 phases — authorize, then capture on delivery',
  passwordConfigured: 'Password configured. Leave blank to keep it.',
  modeHelp: 'This setting applies to new orders and QR preorders. Bills, selected items, reservations and gift cards use 1 phase.',
  captureHelp: 'Delivering a 2-phase order queues capture. Cancelling queues a reversal or refund after bank verification.',
  refresh: 'Refresh',
  previous: 'Previous',
  next: 'Next',
  page: 'Page',
  empty: 'No BT payments on this page.',
  loadError: 'BT payments could not be loaded. Company-owner or site-admin access is required.',
  saveError: 'BT settings could not be saved.',
  reference: 'Reference / payable',
  amount: 'Card amount',
  approved: 'Authorized',
  capturedAmount: 'Captured',
  returnedAmount: 'Returned',
  state: 'Financial status',
  applied: 'Purchase applied',
  notApplied: 'Purchase not yet applied',
  review: 'Operator review required',
  created: 'Registration unresolved',
  pending: 'Awaiting payment',
  captured: 'Captured',
  failed: 'Failed',
  expired: 'Expired',
  reversed: 'Cancelled / reversed',
  refunded: 'Refunded',
  authorized: 'Authorized — funds reserved',
  partial: 'Partially refunded',
  unknown: 'Unknown',
  refundConfirm: 'Request a BT return? The backend will verify the bank status and reverse the authorization or refund captured funds.',
  returnPending: 'Return requested — awaiting bank confirmation',
  returnHelp: 'This is not a completed refund. Refresh the order or check BT payment history for the verified outcome.',
  details: 'Details',
  close: 'Close',
  transaction: 'Bank transaction',
  environmentLabel: 'Environment',
  cancelRequested: 'Return requested',
  order: 'Order',
  payment: 'Payment',
  processing: 'Processing…',
  fulfilled: 'Fulfillment and financial confirmation are separate.'
};
var ro = {
  title: 'Plăți BT iPay',
  apiUser: 'Utilizator API',
  apiPassword: 'Parolă API',
  environment: 'Mediu',
  sandbox: 'Test',
  production: 'Producție',
  mode: 'Modul de plată al comenzilor',
  onePhase: '1 fază — încasare la plată',
  twoPhase: '2 faze — autorizare, apoi încasare la livrare',
  passwordConfigured: 'Parolă configurată. Lasă câmpul gol pentru a o păstra.',
  modeHelp: 'Setarea se aplică comenzilor și precomenzilor QR noi. Notele, produsele selectate, rezervările și cardurile cadou folosesc 1 fază.',
  captureHelp: 'Livrarea unei comenzi în 2 faze programează încasarea. Anularea programează reversarea sau rambursarea după verificarea băncii.',
  refresh: 'Actualizează',
  previous: 'Înapoi',
  next: 'Înainte',
  page: 'Pagina',
  empty: 'Nu există plăți BT pe această pagină.',
  loadError: 'Plățile BT nu au putut fi încărcate. Este necesar acces de proprietar al companiei sau administrator de site.',
  saveError: 'Setările BT nu au putut fi salvate.',
  reference: 'Referință / achiziție',
  amount: 'Sumă pe card',
  approved: 'Autorizat',
  capturedAmount: 'Încasat',
  returnedAmount: 'Returnat',
  state: 'Stare financiară',
  applied: 'Achiziție confirmată',
  notApplied: 'Achiziție încă neconfirmată',
  review: 'Necesită verificarea unui operator',
  created: 'Înregistrare neconfirmată',
  pending: 'În așteptarea plății',
  captured: 'Încasat',
  failed: 'Eșuat',
  expired: 'Expirat',
  reversed: 'Anulat / reversat',
  refunded: 'Rambursat',
  authorized: 'Autorizat — fonduri rezervate',
  partial: 'Rambursat parțial',
  unknown: 'Necunoscut',
  refundConfirm: 'Soliciți returnarea prin BT? Serverul va verifica starea la bancă și va reversa autorizarea sau rambursa fondurile încasate.',
  returnPending: 'Returnare solicitată — se așteaptă confirmarea băncii',
  returnHelp: 'Rambursarea nu este încă finalizată. Actualizează comanda sau verifică istoricul plăților BT pentru rezultatul confirmat.',
  details: 'Detalii',
  close: 'Închide',
  transaction: 'Tranzacție bancară',
  environmentLabel: 'Mediu',
  cancelRequested: 'Returnare solicitată',
  order: 'Comandă',
  payment: 'Plată',
  processing: 'Se procesează…',
  fulfilled: 'Finalizarea comenzii și confirmarea financiară sunt separate.'
};
/* harmony default export */ __webpack_exports__["a"] = ({ en: en, ro: ro });

/***/ }),

/***/ "OTDR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStoreCampaigns_vue__ = __webpack_require__("YWVT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a2aa3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStoreCampaigns_vue__ = __webpack_require__("7YTo");
function injectStyle (ssrContext) {
  __webpack_require__("NKVS")
  __webpack_require__("Ml/r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09a2aa3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStoreCampaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a2aa3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStoreCampaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OTo0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SettingsDeliveryZones_vue__ = __webpack_require__("BX3Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SettingsDeliverySlots_vue__ = __webpack_require__("RESi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SettingsDeliveryPreferences_vue__ = __webpack_require__("Fg1h");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SettingsDeliveryZones: __WEBPACK_IMPORTED_MODULE_0__SettingsDeliveryZones_vue__["a" /* default */],
    SettingsDeliverySlots: __WEBPACK_IMPORTED_MODULE_1__SettingsDeliverySlots_vue__["a" /* default */],
    SettingsDeliveryPreferences: __WEBPACK_IMPORTED_MODULE_2__SettingsDeliveryPreferences_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isZones: true,
      isSlots: false,
      isPreferences: false
    };
  },

  methods: {
    openTab: function openTab(tab) {
      this.isZones = false;
      this.isSlots = false;
      this.isPreferences = false;

      switch (tab) {
        case 'zones':
          this.isZones = true;
          break;
        case 'slots':
          this.isSlots = true;
          break;
        case 'preferences':
          this.isPreferences = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ "OUAZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OV1C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OWQI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductForm_vue__ = __webpack_require__("jkt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__productFormDependencies_js__ = __webpack_require__("F7xP");







var _components;





__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ProductForm', __WEBPACK_IMPORTED_MODULE_7__ProductForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      categoryModel: {},
      category: {},
      modelValidations: {
        required: {
          required: true
        }
      },
      productData: this.route.params.productData || {},
      mainCategories: this.route.params.mainCategories || [],
      taxes: this.route.params.taxes || [],
      kdsSections: this.route.params.kdsSections || [],
      productOptions: this.route.params.productOptions || [],
      companyProductFilters: this.route.params.companyProductFilters || [],
      measurementsUnits: this.route.params.measurementsUnits || [],
      language: this.route.params.language || '',
      languages: this.route.params.languages || []
    };
  },
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__productFormDependencies_js__["a" /* loadProductFormDependencies */])(this);
  },

  methods: {
    onProductSubmit: function onProductSubmit(model, isValid) {
      this.productModel = model;
    }
  }
});

/***/ }),

/***/ "OXAs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OZHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementTransferAdd_vue__ = __webpack_require__("JUmJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028fd997_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementTransferAdd_vue__ = __webpack_require__("u29E");
function injectStyle (ssrContext) {
  __webpack_require__("h6uT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-028fd997"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementTransferAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028fd997_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementTransferAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OZUI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTaxPanel_vue__ = __webpack_require__("9NOQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e64f417_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTaxPanel_vue__ = __webpack_require__("hbtu");
function injectStyle (ssrContext) {
  __webpack_require__("9mGn")
  __webpack_require__("XH+H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e64f417"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryTaxPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e64f417_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryTaxPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OaMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips__ = __webpack_require__("iWxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__ = __webpack_require__("L7GT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Line' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.chartOptions['plugins'] = [this.$Chartist.plugins.tooltip()];
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "OboX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedVatNumber: null,
      selectedLocationId: '',
      selectedLocation: null,
      vatNumber: null,
      tableData: [],
      client: {
        companyName: '',
        abbreviation: '',
        CUI: '',
        registrationNumber: '',
        address: '',
        city: '',
        countries: '',
        bank: '',
        IBAN: '',
        dueDays: null
      },
      searchCUI: ''
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    getClients: {
      type: Function,
      required: false
    },
    clientData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedLocationId: function selectedLocationId(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    selectedVatNumber: function selectedVatNumber(newVat) {
      this.selectedVatNumber = newVat;
      this.getClients();
    },

    clientData: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        if (!val || !__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(val).length) return;

        this.client = this.mapCustomerRowToForm(val);

        if (val.externalLocationId) {
          this.selectedLocationId = val.externalLocationId;
        }

        this.$modal.show('addClientModal');
      }
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },

  computed: {
    filteredClients: function filteredClients() {
      var _this = this;

      if (!this.searchQuery) {
        return this.tableData;
      }

      return this.tableData.filter(function (client) {
        return client.clientName.toLowerCase().includes(_this.searchQuery.toLowerCase());
      });
    }
  },
  methods: {
    mapCustomerRowToForm: function mapCustomerRowToForm() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return {
        companyName: row.companyName || row.clientName || row.name || '',
        abbreviation: row.abbreviation || '',
        CUI: row.CUI || row.vatNumber || row.cui || row.customerVatNumber || '',
        email: row.email || '',
        registrationNumber: row.registrationNumber || '',
        address: row.address || '',
        city: row.city || '',
        countries: row.countries || '',
        bank: row.bank || '',
        IBAN: row.IBAN || row.iban || '',
        dueDays: row.dueDays != null ? row.dueDays : null,
        id: row.id || row._id || null,
        _rev: row._rev || null,
        externalLocationId: row.externalLocationId || null
      };
    },
    openAddClientModal: function openAddClientModal() {
      this.editMode = false;
      this.selectedLocationId = '';
      this.searchCUI = '';
      this.client = {
        companyName: '',
        abbreviation: '',
        CUI: '',
        email: '',
        registrationNumber: '',
        address: '',
        city: '',
        countries: '',
        bank: '',
        IBAN: '',
        dueDays: null,
        id: null,
        _rev: null
      };
      this.$modal.show('addClientModal');
    },
    closeAddClientModal: function closeAddClientModal() {
      this.editMode = false;
      this.$modal.hide('addClientModal');
    },
    editRow: function editRow(row) {
      this.editMode = true;
      this.client = this.mapCustomerRowToForm(row);

      if (row.externalLocationId) {
        this.selectedLocationId = row.externalLocationId;
      }

      this.$modal.show('addClientModal');
    },
    searchClient: function searchClient() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var company;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (_this2.searchCUI) {
                  _context.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  title: 'Error',
                  text: 'Please enter a CUI to search.',
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                });
                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return _this2.fetchAnafCompanyByCui(_this2.searchCUI);

              case 6:
                company = _context.sent;

                _this2.client = _this2.mapCustomerRowToForm(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.client, {
                  companyName: company.name,
                  CUI: company.cui || _this2.client.CUI,
                  registrationNumber: company.registrationNumber,
                  address: company.address,
                  city: company.city,
                  countries: company.countryCode,
                  IBAN: company.iban
                }));
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.error('Error fetching client details:', _context.t0);
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  title: 'Error',
                  text: _context.t0.message || 'Failed to retrieve client details.',
                  type: 'error',
                  timer: 2500,
                  showConfirmButton: false
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10]]);
      }))();
    },
    saveClient: function saveClient() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var selectedLocation, clientData, response, responseData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(!_this3.selectedLocationId || !_this3.client.CUI || !_this3.client.companyName || !_this3.client.address)) {
                  _context2.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  title: 'Error',
                  text: 'Toate câmpurile marcate cu * sunt obligatorii.',
                  icon: 'error',
                  timer: 1500,
                  buttons: false
                });
                return _context2.abrupt('return');

              case 4:
                selectedLocation = _this3.groupedLocations.flatMap(function (g) {
                  return g.locations;
                }).find(function (loc) {
                  return loc.true_id === _this3.selectedLocationId;
                });

                if (selectedLocation) {
                  _context2.next = 8;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  title: 'Error',
                  text: 'Locația selectată este invalidă.',
                  icon: 'error',
                  timer: 1500,
                  buttons: false
                });
                return _context2.abrupt('return');

              case 8:
                clientData = {
                  externalCompanyId: _this3.companyID,
                  externalLocationId: selectedLocation.true_id,
                  vatNumber: selectedLocation.inv_fiscal_code,
                  customerVatNumber: _this3.client.CUI,
                  name: _this3.client.companyName,
                  abbreviation: _this3.client.abbreviation || '',
                  registrationNumber: _this3.client.registrationNumber || '',
                  address: _this3.client.address,
                  city: _this3.client.city || '',
                  countries: _this3.client.countries || '',
                  bank: _this3.client.bank || '',
                  iban: _this3.client.IBAN || '',
                  IBAN: _this3.client.IBAN || '',
                  dueDays: _this3.client.dueDays != null ? Number(_this3.client.dueDays) : 0
                };


                if (_this3.editMode && _this3.client.id) {
                  clientData.id = _this3.client.id;
                  if (_this3.client._rev) {
                    clientData._rev = _this3.client._rev;
                  }
                }

                _context2.next = 12;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/customer', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(clientData)
                });

              case 12:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 15;
                  break;
                }

                throw new Error('Eroare la salvarea clientului');

              case 15:
                _context2.next = 17;
                return response.json();

              case 17:
                responseData = _context2.sent;

                console.log('Client salvat cu succes:', responseData);

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Clientul a fost salvat cu succes.',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                });

                _this3.$emit('getClients');

                _this3.$modal.hide('addClientModal');
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2['catch'](0);

                console.error('Eroare la salvarea clientului:', _context2.t0);
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  title: 'Error',
                  text: _context2.t0.message,
                  icon: 'error',
                  timer: 1500,
                  buttons: false
                });

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 24]]);
      }))();
    }
  }
});

/***/ }),

/***/ "OcNi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),(!_vm.isBlocked)?_c('p',{staticClass:"d-inline-flex"},[(!_vm.isInEdit)?_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","disabled":_vm.loading,"title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.saveInitialStock($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")]):_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","disabled":_vm.loading,"title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.updateStock($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          Salvează modificările\n        ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addInitialStock')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[(_vm.groupedLocations)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.location),expression:"modelValidate.location"}],staticClass:"form-control",attrs:{"disabled":_vm.loading || _vm.isInEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                    "+_vm._s(loc.name)+"\n                  ")])}))})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.gestiune),expression:"modelValidate.gestiune"}],attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading || _vm.isInEdit},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.date')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.date),expression:"modelValidate.date"},{name:"model",rawName:"v-model",value:(_vm.inventoryDate),expression:"inventoryDate"}],staticClass:"form-control",attrs:{"type":"datetime-local","disabled":_vm.isBlocked || _vm.loading || _vm.isInEdit,"max":_vm.today},domProps:{"value":(_vm.inventoryDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inventoryDate=$event.target.value}}})])])])])])]),_vm._v(" "),(_vm.productsListStocks.length > 0 || _vm.productsList.length > 0)?_c('div',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-md-12"},[(_vm.productsListStocks.length > 0)?_c('button',{staticClass:"btn-toggle",class:{ 'active': _vm.showStockSection },on:{"click":function($event){_vm.toggleSection('stock')}}},[_c('span',{staticClass:"toggle-text"},[_vm._v("\n          Produse cu stoc inițial\n        ")]),_vm._v(" "),_c('span',{staticClass:"badge-count"},[_vm._v(_vm._s(_vm.productsListStocks.length))])]):_vm._e(),_vm._v(" "),(_vm.productsList.length > 0)?_c('button',{staticClass:"btn-toggle",class:{ 'active': _vm.showProductsSection },on:{"click":function($event){_vm.toggleSection('products')}}},[_c('span',{staticClass:"toggle-text"},[_vm._v("\n          Produse fără stoc inițial\n        ")]),_vm._v(" "),_c('span',{staticClass:"badge-count"},[_vm._v(_vm._s(_vm.productsList.length))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.productsListStocks.length > 0 && _vm.showStockSection)?_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('invoice.productName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.unitMeasure')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.quantity')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.pretPerUnitate')))])])]),_vm._v(" "),_c('tbody',[(_vm.productsListStocks.length > 0)?_c('tr',{staticClass:"section-header-stoc"},[_c('td',{attrs:{"colspan":"5"}},[_vm._v("\n              Produse cu stoc inițial — doar vizualizare\n            ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.productsListStocks),function(item,index){return [(item.is_hiden !== 1)?[_c('tr',{key:'stock-' + index,staticClass:"row-stoc"},[_c('td',[_c('span',{staticClass:"badge-stoc"},[_vm._v("Stoc")]),_vm._v("\n                  "+_vm._s(item.name)+"\n\n                  "),_c('div',{staticStyle:{"font-size":"11px","opacity":"0.7","margin-top":"10px"}},[_vm._v("\n                    ID: "+_vm._s(item._id)+"\n                  ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.categorie))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.um))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.quantity),expression:"item.quantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":"Cantitate","disabled":"","title":"Stoc inițial deja setat"},domProps:{"value":(item.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.price),expression:"item.price",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":"Preț per unitate","disabled":"","title":"Preț inițial deja setat"},domProps:{"value":(item.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "price", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])])]:_vm._e()]}),_vm._v(" "),(_vm.loading)?_c('tr',[_c('td',[_c('div',{staticClass:"loadingTableCenter"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])])])])]):_vm._e()],2)])])]):_vm._e(),_vm._v(" "),(_vm.showProductsSection)?_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Filtreaza produsele dupa categorie:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategory),expression:"selectedCategory"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.filterProducts]}},[_c('option',{domProps:{"value":null}},[_vm._v("-- Toate categoriile --")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat,domProps:{"value":cat}},[_vm._v("\n              "+_vm._s(cat)+"\n            ")])})],2)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('invoice.productName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.unitMeasure')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.quantity')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.pretPerUnitate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('general.actions')))])])]),_vm._v(" "),_c('tbody',[(!_vm.isBlocked)?_c('tr',[_c('td',[_c('v-select',{attrs:{"options":_vm.searchProducts,"label":"label","placeholder":"Caută un produs...","filterable":true},on:{"input":_vm.onProductSelect},model:{value:(_vm.searchProdName),callback:function ($$v) {_vm.searchProdName=$$v},expression:"searchProdName"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.categorie),expression:"newItem.categorie",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","disabled":true,"placeholder":"UM"},domProps:{"value":(_vm.newItem.categorie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "categorie", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.unitMeasure),expression:"newItem.unitMeasure",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","disabled":true,"placeholder":"UM"},domProps:{"value":(_vm.newItem.unitMeasure)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "unitMeasure", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.quantity),expression:"newItem.quantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Cantitate"},domProps:{"value":(_vm.newItem.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "quantity", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.price),expression:"newItem.price",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Preț per unitate"},domProps:{"value":(_vm.newItem.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "price", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.addItem}},[_vm._v(_vm._s(_vm.$t('general.add')))])])]):_vm._e(),_vm._v(" "),(_vm.productsList.length > 0)?_c('tr',{staticClass:"section-header-produs"},[_c('td',{attrs:{"colspan":"5"}},[_vm._v("\n              Produse fără stoc inițial — completează cantitatea și prețul\n            ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.productsList),function(item,index){return [(item.is_hiden !== 1)?[_c('tr',{key:'prod-' + index,class:['row-produs', { 'row-exista-stoc': _vm.isProductInStock(item._id) }]},[_c('td',[(_vm.isProductInStock(item._id))?_c('span',{staticClass:"badge-exista-stoc"},[_vm._v("Deja în stoc")]):_vm._e(),_vm._v("\n                  "+_vm._s(item.name)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.categorie))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.um))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.quantity),expression:"item.quantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":"Cantitate","disabled":_vm.isProductInStock(item._id),"title":_vm.isProductInStock(item._id) ? 'Produsul există deja în stocul inițial' : ''},domProps:{"value":(item.quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", _vm._n($event.target.value))},function($event){item.quantity = _vm.clamp($event.target.value, 0, 999999)}],"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.price),expression:"item.price",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":"Preț per unitate","disabled":_vm.isProductInStock(item._id),"title":_vm.isProductInStock(item._id) ? 'Produsul există deja în stocul inițial' : ''},domProps:{"value":(item.price)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "price", _vm._n($event.target.value))},function($event){item.price = _vm.clamp($event.target.value, 0, 999999)}],"blur":function($event){_vm.$forceUpdate()}}})])])]:_vm._e()]}),_vm._v(" "),(_vm.loading)?_c('tr',[_c('td',[_c('div',{staticClass:"loadingTableCenter"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])])])])]):_vm._e()],2)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v("Comisia de Inventariere")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"presedinteleComisiei"}},[_vm._v("Președintele Comisiei")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.presedinte),expression:"extraFields.presedinte"}],staticClass:"form-control",attrs:{"type":"text","id":"presedinteleComisiei","disabled":_vm.isBlocked,"placeholder":"Numele președintelui comisiei"},domProps:{"value":(_vm.extraFields.presedinte)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "presedinte", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gestionar"}},[_vm._v("Gestionar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.gestionar),expression:"extraFields.gestionar"}],staticClass:"form-control",attrs:{"type":"text","id":"gestionar","disabled":_vm.isBlocked,"placeholder":"Numele gestionarului"},domProps:{"value":(_vm.extraFields.gestionar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "gestionar", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"notaInternaComisie"}},[_vm._v("Notă internă")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.nota),expression:"extraFields.nota"}],staticClass:"form-control",attrs:{"id":"notaInternaComisie","disabled":_vm.isBlocked,"placeholder":"Informații suplimentare"},domProps:{"value":(_vm.extraFields.nota)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "nota", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"comisiaDeInventariere"}},[_vm._v("Comisia de Inventariere")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.comisia),expression:"extraFields.comisia"}],staticClass:"form-control",attrs:{"type":"text","id":"comisiaDeInventariere","disabled":_vm.isBlocked,"placeholder":"Denumirea comisiei"},domProps:{"value":(_vm.extraFields.comisia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "comisia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"contabilitate"}},[_vm._v("Contabilitate")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.contabilitate),expression:"extraFields.contabilitate"}],staticClass:"form-control",attrs:{"type":"text","id":"contabilitate","disabled":_vm.isBlocked,"placeholder":"Detalii contabilitate"},domProps:{"value":(_vm.extraFields.contabilitate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "contabilitate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"notaInternaCompletare"}},[_vm._v("Notă internă (completare)")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.nota_completare),expression:"extraFields.nota_completare"}],staticClass:"form-control",attrs:{"id":"notaInternaCompletare","disabled":_vm.isBlocked,"placeholder":"Detalii suplimentare notă internă"},domProps:{"value":(_vm.extraFields.nota_completare)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "nota_completare", $event.target.value)}}})])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OcVr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuedraggable__);

















var _components;








__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    draggable: __WEBPACK_IMPORTED_MODULE_20_vuedraggable___default.a
  }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.company_id = this.$session.get('selectedCompany');

    this.getPoses();
    this.getData();
  },
  data: function data() {
    return {
      company_id: 0,
      apiUrl: '',
      roles: [],
      kdsSections: [],
      allPoses: [],
      id: this.value || this.tableId,
      isNew: true,
      filelist: [],
      model: {
        'id': 0,
        'name': '',
        'location_id': '',
        'images': [],
        'location': {
          'id': null
        },
        'type': 2
      },
      type: ['ODS', 'POS', 'DSS'],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '24:00'
      },
      locations: [],
      modelValidate: {
        type: { required: true },
        server_ip: { required: true }
      },
      languages: [{ 'id': 'ro', 'label': 'Romana' }, { 'id': 'en', 'label': 'English' }, { 'id': 'es', 'label': 'Espagnol' }, { 'id': 'gr', 'label': 'Greek' }, { 'id': 'cz', 'label': 'Czech' }],
      loading: true
    };
  },

  methods: {
    getKdsSections: function getKdsSections() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.company_id
      };
      this.apiRequest('/kds-sections', 'GET', data, function (response) {
        if (response.status === true) {
          _this.kdsSections = response.data;

          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    },
    getPoses: function getPoses() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.company_id
      };
      this.apiRequest('/pos', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.allPoses = response.data.pos;

          _this2.$nextTick(function () {
            _this2.loading = false;
          });
        }
      });
    },
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy);
    },
    getData: function getData() {
      var _this3 = this;

      this.locations = [];
      var requestData = {
        token: this.$session.get('token'),
        company_id: this.company_id
      };
      var id = this.route.params.id;
      if (id) {
        this.apiRequest('/pos/screens/' + id, 'GET', requestData, function (response) {
          if (response.status) {
            _this3.model = response.data.screens;
            _this3.model.pos_image = [{ 'url': _this3.model.pos_image }];
            _this3.model.images = _this3.model.images.map(function (item) {
              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
                images: item.images.map(function (img) {
                  return { url: img };
                })
              });
            });
          }
        });
      }

      this.apiRequest('/get-locations', 'GET', requestData, function (response) {
        if (response.status) {
          _this3.locations = response.data;
        }
      });
      this.$nextTick(function () {
        _this3.loading = false;
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this4 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this4.saveTable();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    saveTable: function saveTable() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, companyID, id, url, request;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this5.$nextTick(function () {
                  _this5.loading = true;
                });
                if (_this5.model.location && _this5.model.location.id != null && _this5.model.location.id !== 'null') {
                  _this5.model.location_id = _this5.model.location.id;
                }
                _context.prev = 2;
                _context.next = 5;
                return _this5.ensureSlideImagesBase64();

              case 5:
                _context.next = 12;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](2);

                _this5.$nextTick(function () {
                  _this5.loading = false;
                });
                __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
                  toast: true,
                  type: 'warning',
                  text: _this5.$t('validations.wentWrong'),
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000
                });
                return _context.abrupt('return');

              case 12:
                data = _this5.model;
                companyID = _this5.company_id;

                data.token = _this5.$session.get('token');
                data.company_id = companyID;

                id = _this5.id || _this5.route.params.id;
                url = '';
                request = '';

                if (id) {
                  url = '/pos/screens/' + id;
                  request = 'PUT';
                } else {
                  url = '/pos/screens/add';
                  request = 'POST';
                }
                _this5.apiRequest(url, request, data, function (response) {
                  if (response.status === true) {
                    _this5.$nextTick(function () {
                      _this5.loading = false;
                    });
                    _this5.errors.clear();
                    if (request === 'POST') {
                      _this5.$bus.$emit('refresh');
                      _this5.$bus.$emit('close-modal');
                    } else {
                      _this5.backButton();
                    }
                    __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
                      title: '',
                      text: _this5.$t('settingTable.tableSave'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    });
                  } else {
                    _this5.$nextTick(function () {
                      _this5.loading = false;
                    });
                    _this5.handleErrors(response.errors);
                  }
                });

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5, [[2, 7]]);
      }))();
    },
    deleteOrderScreen: function deleteOrderScreen() {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.loadingReset = true;
      });
      var id = this.id || this.route.params.id;
      var data = {
        company_id: this.company_id,
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/pos/screens/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          _this6.$nextTick(function () {
            _this6.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this6.backButton();
        } else {
          _this6.$nextTick(function () {
            _this6.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({ 'text': _this6.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    deleteToken: function deleteToken() {
      var _this7 = this;

      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany'),
        'screen_id': this.model.id
      };
      __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
        type: 'question',
        title: this.$t('settingTable.deleteZoneTitle'),
        text: this.$t('settingTable.disableAuthScreenInfo'),
        position: 'top-end',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        allowOutsideClick: false
      }).then(function (result) {
        _this7.apiRequest('/pos/screens/delete-token', 'POST', data, function (response) {
          _this7.model.login_token = null;
        });
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    updateLocationId: function updateLocationId(event) {
      if (event.target.value !== 'null') {
        var selectedLocation = this.locations.find(function (item) {
          return parseInt(item.id) === parseInt(event.target.value);
        });
        this.model.location_id = selectedLocation.id;
      }
    },
    addNewImageGroup: function addNewImageGroup() {
      var newRow = {
        'images': [],
        'from': '00:00',
        'to': '24:00',
        'time': 10,
        'active': true
      };
      if (!this.model.images) {
        this.model.images = [];
      }
      this.model.images.push(newRow);
    },
    deleteValue: function deleteValue(index) {
      this.model.images.splice(index, 1);
    },
    handleRemove: function handleRemove(file, fileList, index) {
      if (this.model.images[index]) {
        this.$set(this.model.images[index], 'images', fileList || []);
      }
    },
    ensureSlideImagesBase64: function ensureSlideImagesBase64() {
      var _this8 = this;

      var groups = this.model.images || [];
      var tasks = [];
      groups.forEach(function (group) {
        (group.images || []).forEach(function (img) {
          if (img && img.raw && !img.base64enc) {
            tasks.push(_this8.getBase64(img.raw).then(function (base64enc) {
              _this8.$set(img, 'base64enc', base64enc);
            }));
          }
        });
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(tasks);
    },
    handleImgChnage: function handleImgChnage(file, fileList, index) {
      var self = this;
      var pp = this.model.images;
      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        self.$refs.upload.clearFiles();
        pp[index].images = [];
      } else {
        pp[index].images = fileList;
      }
      this.model.images = null;
      this.model.images = pp;
      this.ensureSlideImagesBase64().catch(function () {});
    },
    handleImgChnagePosImage: function handleImgChnagePosImage(file, fileList) {
      var _this9 = this;

      var pp = this.model;

      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        pp.pos_image = [];
      } else {
        if (fileList.length > 1) {
          pp.pos_image = fileList.slice(1);
        } else {
          pp.pos_image = fileList;
        }
      }
      this.model = null;
      this.model = pp;
      this.getBase64(this.model.pos_image[0].raw).then(function (base64enc) {
        _this9.model.pos_image[0].base64enc = base64enc;
      });
    },
    handleRemovePosImage: function handleRemovePosImage(file, fileList) {
      if (fileList.length === 0) {
        this.model.pos_image = [];
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
        text: this.$t('general.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    }
  }
});

/***/ }),

/***/ "Odsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryHeroIntegrationForm_vue__ = __webpack_require__("cFks");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryHeroIntegrationForm_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03095954_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryHeroIntegrationForm_vue__ = __webpack_require__("hdtC");
function injectStyle (ssrContext) {
  __webpack_require__("YOHX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03095954"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryHeroIntegrationForm_vue__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03095954_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryHeroIntegrationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["b"] = (Component.exports);


/***/ }),

/***/ "Om5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__);











var _components;







__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PSwitch: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getData();
  },

  watch: {
    is_manager: function is_manager(newVal) {
      this.onChangeManager(newVal);
    },
    allow_transfer: function allow_transfer(newVal) {
      this.onChangeAllowTransfer(newVal);
    }
  },
  data: function data() {
    return {
      id: this.value || this.tableId,
      locations: [],
      tableMaps: [],
      is_manager: false,
      is_manager_first: true,
      allow_transfer: false,
      allow_transfer_first: true,
      model: {
        'id': 0,
        'role': 'POS',
        'language': 'en',
        'loyalty_points': 0,
        'has_push_notifications': 0,
        'has_email_notifications': 0,
        'is_verified': 0,
        'is_created_from_admin': 0,
        'is_siteadmin': 0,
        'firstname': null,
        'lastname': null,
        'login_code': null,
        'active': true,
        'pos_allow_discount': false,
        'pos_allow_storno': false,
        'pos_allow_refund': false,
        'table_for_one_user': false,
        'pos_allow_order_change_status': true,
        'pos_allow_reports': false,
        'pos_allow_approvals': false,
        'pos_allow_access_reports': false,
        'pos_allow_waiter_transfer': false,
        'pos_allow_table_transfer': false,
        'allow_close_order_without_receipt': false,
        'allow_access_all_tables': false,
        'pos_allow_advanced_settings': false
      },
      allStatusesForFilterOrders: [{ id: 'NEW', name: 'NEW' }, { id: 'ON_HOLD', name: 'ON_HOLD' }, { id: 'POSTPONED', name: 'POSTPONED' }, { id: 'PROCESSING', name: 'PROCESSING' }, { id: 'PREPARED', name: 'PREPARED' }, { id: 'TRANSPORT', name: 'TRANSPORT' }, { id: 'DELIVERED', name: 'DELIVERED' }, { id: 'CANCELED', name: 'CANCELED' }],
      modelValidate: {
        firstname: { required: true },
        lastname: { required: true },
        email: { required: true, email: true },
        login_code: {
          required: true,
          regex: /^[0-9]{4}$/
        }
      },
      topCategories: null,
      loading: true
    };
  },

  methods: {
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy);
    },
    getData: function getData() {
      var _this = this;

      var id = this.id || this.route.params.id;
      if (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };
        this.apiRequest('/pos/user/' + id, 'GET', data, function (response) {
          if (response.status) {
            _this.model = response.data.pos_user;
            _this.model.active = _this.model.active === undefined || _this.model.active === null ? true : !!(+_this.model.active || _this.model.active === true);

            var hasManagerFlags = _this.model.pos_allow_access_reports || _this.model.pos_allow_reports || _this.model.pos_allow_approvals || _this.model.pos_allow_discount || _this.model.pos_allow_refund || _this.model.pos_allow_storno || _this.model.allow_access_all_tables || _this.model.pos_allow_waiter_transfer || _this.model.pos_allow_table_transfer || _this.model.pos_allow_advanced_settings;

            if (hasManagerFlags) {
              _this.is_manager_first = false;
              _this.is_manager = true;
            }

            if (_this.model.pos_allow_waiter_transfer || _this.model.pos_allow_table_transfer) {
              _this.allow_transfer_first = false;
              _this.allow_transfer = true;
            }
          }
          _this.loading = false;
        });
      } else {
        this.loading = false;
      }

      this.locations = [];
      var requestData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/get-locations', 'GET', requestData, function (response) {
        if (response.status) {
          _this.locations = response.data;
        }
      });

      var data2 = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/topcategory', 'GET', data2, function (topCatResp) {
        if (topCatResp.status === true) {
          _this.topCategories = topCatResp.data;
        }
      });

      this.getTableMaps();
    },
    getTableMaps: function getTableMaps() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos/all/map', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.tableMaps = response.data.table_maps;
        }
      });
    },
    onChangeManager: function onChangeManager(newVal) {
      if (this.is_manager_first) {
        if (this.is_manager) {
          this.model.pos_allow_discount = true;
          this.model.pos_allow_refund = true;
          this.model.pos_allow_reports = true;
          this.model.pos_allow_access_reports = true;
          this.model.pos_allow_approvals = true;
          this.model.pos_allow_storno = true;
          this.model.allow_access_all_tables = true;
          this.allow_transfer = true;
          this.model.pos_allow_waiter_transfer = true;
          this.model.pos_allow_table_transfer = true;
        } else {
          this.model.pos_allow_discount = false;
          this.model.pos_allow_storno = false;
          this.model.pos_allow_refund = false;
          this.model.pos_allow_reports = false;
          this.model.pos_allow_access_reports = false;
          this.model.pos_allow_approvals = false;
          this.model.allow_access_all_tables = false;
          this.allow_transfer = false;
          this.model.pos_allow_transfer = false;
          this.model.pos_allow_waiter_transfer = false;
          this.model.pos_allow_table_transfer = false;
          this.model.pos_allow_advanced_settings = false;
        }
      }
      this.is_manager_first = true;
    },
    onChangeAllowTransfer: function onChangeAllowTransfer(newVal) {
      if (this.allow_transfer_first) {
        if (this.allow_transfer) {
          this.model.pos_allow_waiter_transfer = true;
          this.model.pos_allow_table_transfer = true;
        } else {
          this.model.pos_allow_waiter_transfer = false;
          this.model.pos_allow_table_transfer = false;
        }
      }
      this.allow_transfer_first = true;
    },
    onLocationDetailsChange: function onLocationDetailsChange() {
      var loc = this.model.location_details;
      var ok = Array.isArray(loc) && loc.length > 0;
      if (ok) {
        this.errors.remove('location_details');
      } else {
        this.errors.remove('location_details');
        this.errors.add('location_details', this.$t('validations.requiredField'));
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (isValid) {
        var loc = _this3.model.location_details;
        var hasLocs = Array.isArray(loc) && loc.length > 0;
        if (!hasLocs) {
          _this3.errors.remove('location_details');
          _this3.errors.add('location_details', _this3.$t('validations.requiredField'));
        } else {
          _this3.errors.remove('location_details');
        }
        if (isValid && hasLocs) {
          _this3.saveTable();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    saveTable: function saveTable() {
      var _this4 = this;

      this.loading = true;
      this.model.login_code = this.model.login_code;
      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany'),
        'pos_user': this.model
      };

      var id = this.id || this.route.params.id;
      var url = '';
      var request = '';
      if (id) {
        url = '/pos/user/' + id;
        request = 'PUT';
      } else {
        url = '/pos/user/add';
        request = 'POST';
      }
      this.apiRequest(url, request, data, function (response) {
        if (response.status === true) {
          _this4.errors.clear();
          if (request === 'POST') {
            _this4.$bus.$emit('refresh');
            _this4.$bus.$emit('close-modal');
          } else {
            _this4.backButton();
          }
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
            title: '',
            text: _this4.$t('settingTable.tableSave'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          _this4.handleErrors(response.errors);
        }
        _this4.loading = false;
      });
    },
    deleteOrderScreen: function deleteOrderScreen() {
      var _this5 = this;

      this.loadingReset = true;
      var id = this.id || this.route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/pos/user/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this5.backButton();
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({ 'text': _this5.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
        _this5.loadingReset = false;
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("+lQa");
function injectStyle (ssrContext) {
  __webpack_require__("p9mx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Onhx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementEntriesAdd_vue__ = __webpack_require__("Mna9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19074eec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementEntriesAdd_vue__ = __webpack_require__("gedM");
function injectStyle (ssrContext) {
  __webpack_require__("ZmjM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19074eec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementEntriesAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19074eec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementEntriesAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OoTu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-wraper"},[_c('div',{staticClass:"video-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"video-container"},[_c('iframe',{staticClass:"video",attrs:{"src":_vm.src,"title":_vm.title,"frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share","allowfullscreen":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OsC+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ouxb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserLabelingForm_vue__ = __webpack_require__("HTxq");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'UserLabelingForm', __WEBPACK_IMPORTED_MODULE_7__UserLabelingForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      userLabel: {},
      modelValidations: {
        name: {
          required: true,
          min: 15
        },
        color: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.userLabel = model;
    }
  }
});

/***/ }),

/***/ "Oxr/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('management-aviz-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OyUV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Oz8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationForm_vue__ = __webpack_require__("vrDl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e29aabc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationForm_vue__ = __webpack_require__("rKkS");
function injectStyle (ssrContext) {
  __webpack_require__("b8hO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e29aabc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ozs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationGroupSection_vue__ = __webpack_require__("3CPt");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92ab8774_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationGroupSection_vue__ = __webpack_require__("UZpQ");
function injectStyle (ssrContext) {
  __webpack_require__("0NWe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-92ab8774"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationGroupSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92ab8774_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationGroupSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "P+7y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"},[_c('div',{staticClass:"form-group mar-rt-10",staticStyle:{"max-width":"230px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedVatNumber),expression:"selectedVatNumber"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedVatNumber=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('option',{key:group.vat,domProps:{"value":group.vat}},[_vm._v("\n            VAT: "+_vm._s(group.vat)+" — "+_vm._s(group.locations.map(function (l) { return l.name; }).join(', '))+"\n          ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group mar-rt-10",staticStyle:{"max-width":"230px"}},[_c('label',{attrs:{"for":"searchInput"}},[_vm._v(_vm._s(_vm.$t('gestiune.searchSuppliers')))]),_vm._v(" "),_c('el-input',{attrs:{"id":"searchInput","placeholder":"Caută după nume distribuitor","clearable":""},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.openAddSupplierModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('gestiune.addSupplier'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.filteredSuppliers,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"prop":"distributorName","label":_vm.$t('gestiune.distributorName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","label":_vm.$t('gestiune.address')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cui","label":_vm.$t('gestiune.cui')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('marketingOffers.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                      ▾\n                    ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editRow(scope.row)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.edit'))+"\n                      ")]),_vm._v(" "),_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},nativeOn:{"click":function($event){_vm.handleDelete(scope.row.id)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.delete'))+"\n                      ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])]),_vm._v(" "),_c('ManagementSuppliersAdd',{attrs:{"groupedLocations":_vm.groupedLocations,"getSuppliers":_vm.getSuppliers,"supplierData":_vm.supplier,"editMode":_vm.editMode,"filterVatNumber":_vm.selectedVatNumber},on:{"getSuppliers":_vm.getSuppliers}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P0Ic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonProductForm_vue__ = __webpack_require__("jh6f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d59e76e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonProductForm_vue__ = __webpack_require__("2DaQ");
function injectStyle (ssrContext) {
  __webpack_require__("c2vN")
  __webpack_require__("ykYJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d59e76e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonProductForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d59e76e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonProductForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P3i8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      tableData: [],
      searchDate: null,
      filter: {
        series: ''
      },
      searchTerm: null,
      searchTimeout: null,
      selectedGestiune: null,
      selectedLocation: null
    };
  },

  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id;
      });
      return result;
    }
  },
  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.selectedGestiune = null;
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
    },
    searchDate: function searchDate(newGestiune) {
      this.searchTerm = null;
      this.tableData = [];
      if (this.selectedLocation && this.selectedGestiune) {
        this.getData();
      }
    },
    selectedGestiune: function selectedGestiune(newGestiune) {
      this.searchTerm = null;
      this.tableData = [];
      if (this.selectedLocation && this.selectedGestiune) {
        this.getData();
      }
    },
    groupedLocations: function groupedLocations(newVal) {
      this.searchTerm = null;
      this.firstLoad();
    },
    gestiuneOptions: function gestiuneOptions(newVal) {
      this.searchTerm = null;
      this.firstLoad();
    },
    searchTerm: function searchTerm() {
      var _this2 = this;

      this.tableData = [];
      if (this.selectedLocation && this.selectedGestiune) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this2.getData();

                case 2:
                  _this2.$refs.searchTerm.focus();

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        })), 300);
      }
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    this.firstLoad();
  },

  methods: {
    firstLoad: function firstLoad() {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0];
      }
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (!cellValue) return '';
      return new Date(cellValue).toLocaleDateString();
    },
    getData: function getData() {
      var _this3 = this;

      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var externalCompanyId, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                externalCompanyId = _this3.companyID;


                clearTimeout(_this3.loadingTimeout);
                _this3.loadingTimeout = setTimeout(function () {
                  _this3.loading = true;
                }, 200);
                _this3.tableData = [];

                if (externalCompanyId) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:
                if (_this3.selectedGestiune) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return');

              case 8:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/stock?externalCompanyId=' + externalCompanyId;

                if (date) {
                  url += '&date=' + date;
                }
                if (_this3.selectedGestiune) {
                  url += '&gestiune=' + _this3.selectedGestiune;
                }
                if (_this3.selectedLocation) {
                  url += '&externalLocationId=' + _this3.selectedLocation.true_id;
                }
                if (_this3.searchTerm) {
                  url += '&name=' + encodeURIComponent(_this3.searchTerm);
                }
                if (_this3.searchDate && _this3.searchDate[0] && _this3.searchDate[0]) {
                  url += '&startDate=' + _this3.searchDate[0];
                  url += '&endDate=' + _this3.searchDate[1];
                }

                _context2.prev = 14;
                _context2.next = 17;
                return fetch(url);

              case 17:
                response = _context2.sent;
                _context2.next = 20;
                return response.json();

              case 20:
                data = _context2.sent;

                clearTimeout(_this3.loadingTimeout);
                _this3.loading = false;
                if (Array.isArray(data.stock)) {
                  _this3.tableData = data.stock;
                } else {
                  console.error('Invalid data format:', data);
                }
                _context2.next = 29;
                break;

              case 26:
                _context2.prev = 26;
                _context2.t0 = _context2['catch'](14);

                console.error('Error fetching invoices:', _context2.t0);

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[14, 26]]);
      }))();
    },
    downloadInvoice: function downloadInvoice(row) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var series, invoiceNumber, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                series = row.series;
                invoiceNumber = row.invoiceNumber;

                if (!(!series || !invoiceNumber)) {
                  _context3.next = 5;
                  break;
                }

                alert('Missing series or invoice number.');
                return _context3.abrupt('return');

              case 5:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/invoice/' + series + '-' + invoiceNumber + '/pdf';
                _context3.prev = 6;
                _context3.next = 9;
                return fetch(url);

              case 9:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 13;
                return response.blob();

              case 13:
                blob = _context3.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + invoiceNumber + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                _context3.next = 22;
                break;

              case 21:
                console.error('Error downloading invoice:', response.statusText);

              case 22:
                _context3.next = 27;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3['catch'](6);

                console.error('Error fetching invoice:', _context3.t0);

              case 27:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[6, 24]]);
      }))();
    }
  }
});

/***/ }),

/***/ "P3jN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__("O5me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_wysiwyg_dist_vueWysiwyg_css__);










var _components;







__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a), _components),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vee_validate__["b" /* mapFields */])(['title', 'alias', 'sort_order', 'image'])),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      model: {},
      modelValidations: {
        title: {
          required: true,
          min: 5
        },
        alias: {
          required: true
        }
      },
      loading: true,
      aliases: null,
      imagelist: []
    };
  },

  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      this.loading = true;
    });
    this.aliases = this.$session.get('defaultData')['menu_link_aliases'];
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    if (this.route.params.id) {
      var id = this.route.params.id;
      this.apiRequest('/menulink/' + id, 'GET', data, function (response) {
        if (response.status === true) {
          _this.model = response.data;
          if (response.data.image) {
            response.data.image = [{ url: response.data.image }];
          } else {
            response.data.image = [];
          }
          _this.$nextTick(function () {
            _this.loading = false;
          });
        } else {
          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    }
    this.$nextTick(function () {
      _this.loading = false;
    });
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.errors.clear();
          _this2.savePage();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    isNew: function isNew() {
      if (this.route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    handleDelete: function handleDelete(label) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: this.$t('menuLink.areYouSure', { label: this.$t('menuLink.' + label) }),
        type: 'question',
        showCancelButton: true,
        cancelButtonText: this.$t('general.cancel'),
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          if (_this3.isNew()) {
            _this3.$bus.$emit('refresh');
            _this3.$bus.$emit('close-modal');
          } else {
            var id = _this3.route.params.id;
            var data = {
              id: id,
              token: _this3.$session.get('token'),
              company_id: _this3.$session.get('selectedCompany')
            };
            _this3.apiRequest('/menulink/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  text: _this3.$t('menuLink.deleted'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                });

                _this3.$bus.$emit('refresh');
                _this3.$bus.$emit('close-modal');
              } else {
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : _this3.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
      }
      return isOkSize;
    },
    savePage: function savePage() {
      var _this4 = this;

      this.loading = true;
      var data = this.model;
      delete data.image;
      var self = this;
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      if (this.isNew()) {
        this.apiRequest('/menulink', 'POST', data, function (response) {
          if (response.status === true) {
            var id = response.data.id;
            var data2 = {
              token: _this4.$session.get('token'),
              company_id: _this4.$session.get('selectedCompany'),
              sort_order: id
            };
            if (self.model.imagelist && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data3 = {};
                data3.id = response.data.id;
                data3.token = data2.token;
                data3.company_id = data2.company_id;
                data3.image = base64enc;
                data3.sort_order = data2.sort_order;

                _this4.apiRequest('/menulink/' + id, 'PUT', data3, function (response2) {
                  if (response2.status === true) {
                    _this4.$nextTick(function () {
                      _this4.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                      title: '',
                      text: _this4.$t('menuLink.added'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});

                    _this4.$bus.$emit('refresh');
                    _this4.$bus.$emit('close-modal');
                  } else {
                    _this4.$nextTick(function () {
                      _this4.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                      title: '',
                      text: _this4.$t('menuLink.couldNotSave'),
                      type: 'error',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                    _this4.$nextTick(function () {
                      _this4.loading = false;
                    });
                  }
                });
              });
            } else {
              _this4.$nextTick(function () {
                _this4.loading = false;
              });
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                title: '',
                text: _this4.$t('menuLink.added'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});

              _this4.$bus.$emit('refresh');
              _this4.$bus.$emit('close-modal');
            }
          } else {
            _this4.$nextTick(function () {
              _this4.loading = false;
            });
            _this4.handleErrors(response.errors);
          }
        });
      } else {
        var id = this.route.params.id;
        this.apiRequest('/menulink/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            if (self.model.imagelist && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.image = base64enc;

                self.apiRequest('/menulink/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                      title: '',
                      text: self.$t('menuLink.updated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {}).catch(function () {});
                    if (typeof self.callback === 'function') {
                      self.callback();
                    }
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                      title: '',
                      text: self.$t('menuLink.couldNotUpdate'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {}).catch(function () {});
                  }
                });
              });
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                title: '',
                text: self.$t('menuLink.updated'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).then(function () {}).catch(function () {});
              if (typeof self.callback === 'function') {
                self.callback();
              }
            }
            _this4.$nextTick(function () {
              _this4.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this4.$t('menuLink.updated'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
            _this4.$nextTick(function () {
              _this4.loading = false;
            });

            _this4.$bus.$emit('refresh');
            _this4.$bus.$emit('close-modal');
          } else {
            _this4.$nextTick(function () {
              _this4.loading = false;
            });
            _this4.handleErrors(response.errors);
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this4.$t('menuLink.couldNotUpdate'),
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
          }
        });
      }
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "P5VO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"box-container row tabs-dispatch"},_vm._l((_vm.dispatchRoutes),function(route,index){return _c('div',{key:route.name,staticClass:"col-md-4"},[_c('router-link',{staticClass:"box",style:({ backgroundColor: _vm.getBoxColor(index) }),attrs:{"to":route.path}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('dispath.' + route.key)))]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.getImageForRoute(route.key),"alt":'Image for ' + route.key}})])])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P6UO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAmCAYAAACyAQkgAAAABHNCSVQICAgIfAhkiAAAArxJREFUWEfFmEFu01AQhuelQWpXpCcgnID2BDQbpHRDu0RtRTkB6QkwJ6A9QYOSiiVh00hsGk5AOEHDCUhWINpq+CeKI9vYfvOeE9tSpKqe9/x5Zv55MzbDKz4lpkvKuZhpamp01j4y3Ty7dd4zwz4wdNekfWye6kxXb+UCSpt3tN16Y6arx7DvaK77PDFET+ymsGBqtU/MSGW7YiMz/MRNvqcO9t2J7g34Bhl6lnhel2tUap7WmWYvjswYPNmXQ/6u2H/x7aCiw3zQHo9TvLpWqLTNAXph86iE+XXpZIkHoiyd5YJCaB0YfKgaVERsC/0eQn9TNSjqt8kFFcCqBYX8/LZ/YvbsoBULSoQEUEnB/AserVRQUpoAOrCDKpoW28sWuR8e21bQr1e888D0vcjDfNeiLP3cPzZNWW8FrVhQH6H4UzXodY9HqA/PfT3ju04KPTx67gJ6DtC3vg/0XbdhaFcaEjWoZgrwhclZN0PYG+F9VY5WIaiw0DuBViIopvdo0gNn0NIFlZgmVKGXtwJoeYJi+gFvJicOnQzSBLVoaAe6HXRWGzWahkqPrlB7VGYreqDb6OKwYdAhFLNSgy4EJaPy48gjJzjbusUQ4qs3/9JF2kjuBFqSoEaon63kyzuBDnscwIPvVunBlL1ihd65PC2Uf4Cj9POaQb/AowfFPFpObzpCD3qYzFN16BH21EFv/qWvTrvtV2bi6umsKRdd03jrjlpRWD1on6U0NTNgln2jFvbmkhu/63SLVFo2HrHSF2nx5P8qUNn0zyP6lQUhXsVcs62FnJe6jAiFe3g1JTZQfCD478izQdtAsT4mKpVH54rP/zzpHPqMA2T5ftHuXh16S6hmUGnT5wNvZkNepCkR2EUDHeDPl/jN8BsAsuMDGbpOUgDeC2Qmk6kTaTTYuqfAuzzZcm7d9/8BPBQpKB3Kow4AAAAASUVORK5CYII="

/***/ }),

/***/ "P77k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoneAvailabilityEditor_vue__ = __webpack_require__("8NBa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a99dddc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoneAvailabilityEditor_vue__ = __webpack_require__("V7K+");
function injectStyle (ssrContext) {
  __webpack_require__("psqB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a99dddc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoneAvailabilityEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a99dddc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoneAvailabilityEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P9FU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSectionEdit_vue__ = __webpack_require__("ncV7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e621bb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSectionEdit_vue__ = __webpack_require__("Ray4");
function injectStyle (ssrContext) {
  __webpack_require__("JE2O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSectionEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e621bb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSectionEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P9yM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsumptionReport_vue__ = __webpack_require__("lFUR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3e417b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsumptionReport_vue__ = __webpack_require__("xI2Z");
function injectStyle (ssrContext) {
  __webpack_require__("v6C4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3e417b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConsumptionReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3e417b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConsumptionReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PAqi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementReports_vue__ = __webpack_require__("FeRf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57f1193c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementReports_vue__ = __webpack_require__("olp1");
function injectStyle (ssrContext) {
  __webpack_require__("s8oF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57f1193c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57f1193c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PAwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-stocuri-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PBad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.color),function(hex,key){return _c('div',{key:key,staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",staticStyle:{"max-width":"225px","margin-bottom":"50px"}},[_c('div',{staticStyle:{"min-height":"100px"}},[_c('label',[_vm._v(_vm._s(_vm.$t(("txtForColors." + key + ".title"))))]),_vm._v(" "),_c('span',{staticStyle:{"display":"block","font-size":"12px","font-weight":"200","margin-bottom":"20px"}},[_vm._v(_vm._s(_vm.$t(("txtForColors." + key + ".msg"))))])]),_vm._v(" "),_c('ChromePicker',{attrs:{"value":{ hex: hex }},on:{"input":function($event){_vm.updateColor(key, $event)}}})],1)])}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Kiosk Pass")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.kiosk_pass),expression:"model.kiosk_pass"}],staticClass:"form-control",attrs:{"type":"text","name":"appLink","placeholder":_vm.$t('settingCompany.selfOrderDomain')},domProps:{"value":(_vm.model.kiosk_pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "kiosk_pass", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Text Fiscal Print")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.text_fiscal_print),expression:"model.text_fiscal_print"}],staticClass:"form-control",attrs:{"type":"text","name":"appLink","placeholder":_vm.$t('settingCompany.selfOrderDomain')},domProps:{"value":(_vm.model.text_fiscal_print)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "text_fiscal_print", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.table_scroll_menu_horizontal')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.table_scroll_menu_horizontal),callback:function ($$v) {_vm.$set(_vm.model, "table_scroll_menu_horizontal", $$v)},expression:"model.table_scroll_menu_horizontal"}})],1)])],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v("Qr/Kiosk Colors")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PC3X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n            "+_vm._s(_vm.$t('general.back'))+"\n          ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"nir-info-note mar-to-15",domProps:{"innerHTML":_vm._s(_vm.$t('gestiune.nirInfoNote'))}}),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.noteEntries')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit || _vm.isNir},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                        "+_vm._s(loc.name)+"\n                      ")])}))})],2)])]),_vm._v(" "),(!_vm.isNir && (!_vm.isEdit || (_vm.isEdit && _vm.selectedGestiuneId)))?_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedGestiuneId),expression:"selectedGestiuneId"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.selectedGestiuneId),expression:"modelValidate.selectedGestiuneId"}],staticClass:"form-control",attrs:{"disabled":!_vm.selectedLocationId || (_vm.isEdit && _vm.selectedGestiuneId)},on:{"click":function($event){$event.preventDefault();return _vm.checkGestiuneChange($event)},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedGestiuneId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selectează gestiunea")]),_vm._v(" "),(_vm.isEdit && _vm.selectedGestiuneId)?_c('option',{domProps:{"value":_vm.selectedGestiuneId}},[_vm._v("\n                      "+_vm._s(_vm.getGestiuneNameById(_vm.selectedGestiuneId))+"\n                    ")]):_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('option',{key:gestiune._id,domProps:{"value":gestiune._id}},[_vm._v("\n                      "+_vm._s(gestiune.name)+"\n                    ")])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.supplier'))+"*")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.supplierResults,"label":"nume","placeholder":"Caută un furnizor...","filterable":false,"disabled":!_vm.selectedLocation},on:{"search":_vm.fetchSuppliers,"input":_vm.onSupplierSelect},model:{value:(_vm.supplierSelected),callback:function ($$v) {_vm.supplierSelected=$$v},expression:"supplierSelected"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.codeFiscalFurnizor'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.codeFiscalFurnizor),expression:"codeFiscalFurnizor"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.codeFiscalFurnizor),expression:"modelValidate.codeFiscalFurnizor"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.codeFiscalFurnizor'),"name":"codeFiscalFurnizor"},domProps:{"value":(_vm.codeFiscalFurnizor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.codeFiscalFurnizor=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.dataDocument'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataDocument),expression:"dataDocument"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.dataDocument),expression:"modelValidate.dataDocument"}],staticClass:"form-control",attrs:{"type":"datetime-local","name":"dataDocument","max":_vm.today},domProps:{"value":(_vm.dataDocument)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dataDocument=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.dataInStoc'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataInStoc),expression:"dataInStoc"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.dataInStoc),expression:"modelValidate.dataInStoc"}],staticClass:"form-control",attrs:{"type":"datetime-local","name":"dataInStoc","max":_vm.today},domProps:{"value":(_vm.dataInStoc)},on:{"change":function($event){_vm.checkValidatedAfter('dataInStoc')},"input":function($event){if($event.target.composing){ return; }_vm.dataInStoc=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.dataScadenta')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataScadenta),expression:"dataScadenta"}],staticClass:"form-control",attrs:{"type":"datetime-local","name":"dataScadenta","max":_vm.today},domProps:{"value":(_vm.dataScadenta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dataScadenta=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.tipDocument'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipDocument),expression:"tipDocument"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.tipDocument),expression:"modelValidate.tipDocument"}],staticClass:"form-control",attrs:{"disabled":_vm.isNir || _vm.isInvoiceSupplier},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipDocument=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează tip document")]),_vm._v(" "),_c('option',{attrs:{"value":"factura"}},[_vm._v("Factura")]),_vm._v(" "),_c('option',{attrs:{"value":"aviz"}},[_vm._v("Aviz")]),_vm._v(" "),_c('option',{attrs:{"value":"bon_fiscal"}},[_vm._v("Bon Fiscal")]),_vm._v(" "),_c('option',{attrs:{"value":"altul"}},[_vm._v("Altul")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.nrDocument'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nrDocument),expression:"nrDocument"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.nrDocument),expression:"modelValidate.nrDocument"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.nrDocument'),"name":"nrDocument","disabled":_vm.isNir || _vm.isInvoiceSupplier},domProps:{"value":(_vm.nrDocument)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nrDocument=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.series'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seriesNumber),expression:"seriesNumber"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seriesNumber=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.updateNumber]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('invoice.selectSeries')))]),_vm._v(" "),_vm._l((_vm.seriesOptionsWithAdd),function(series){return _c('option',{key:series.id || series.series,domProps:{"value":series.id || series.series}},[_vm._v("\n                    "+_vm._s(series.nume || series.series)+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currentNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentNumber),expression:"currentNumber"}],staticClass:"form-control",attrs:{"type":"number","disabled":!_vm.seriesNumber || _vm.isEdit},domProps:{"value":(_vm.currentNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentNumber=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.valoare')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valoare),expression:"valoare"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.valoare'),"name":"valoare","disabled":_vm.isNir || _vm.isInvoiceSupplier},domProps:{"value":(_vm.valoare)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valoare=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currency')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency),expression:"currency"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currency=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"RON"}},[_vm._v("RON")]),_vm._v(" "),_c('option',{attrs:{"value":"EUR"}},[_vm._v("EURO")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.precizie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.precizie),expression:"precizie"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.precizie=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"2 zecimale"}},[_vm._v("2 zecimale")]),_vm._v(" "),_c('option',{attrs:{"value":"3 zecimale"}},[_vm._v("3 zecimale")]),_vm._v(" "),_c('option',{attrs:{"value":"4 zecimale"}},[_vm._v("4 zecimale")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProductInNir')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"tableInvoice",class:{ 'invoice-supplier-mode': _vm.isInvoiceSupplier },staticStyle:{"overflow-x":"auto","width":"100%"}},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.code')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.categoria')))]),_vm._v(" "),((_vm.isEdit && !_vm.selectedGestiuneId) || _vm.isNir)?_c('th',[_vm._v("\n                    "+_vm._s(_vm.$t('gestiune.gestiune'))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.um')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.cantitate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.tva')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.pretFaraTva')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.currency')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.valoare')))]),_vm._v(" "),_c('th',[_vm._v("Val. TVA")]),_vm._v(" "),(_vm.hasMarfaProducts && !_vm.isInvoiceSupplier)?_c('th',[_vm._v("Preț vânzare (TVA incl.)")]):_vm._e(),_vm._v(" "),(_vm.hasMarfaProducts && !_vm.isInvoiceSupplier)?_c('th',[_vm._v("TVA %")]):_vm._e(),_vm._v(" "),(_vm.hasMarfaProducts && !_vm.isInvoiceSupplier)?_c('th',[_vm._v("Adaos total (RON)")]):_vm._e(),_vm._v(" "),(!_vm.isNir && !_vm.isInvoiceSupplier && !_vm.invoiceSupplierId)?_c('th',[_vm._v(_vm._s(_vm.$t('general.actions')))]):_vm._e()])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.tableData),function(row,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(row.nr))]),_vm._v(" "),_c('td',[(_vm.isInvoiceSupplier)?_c('div',{staticClass:"invoice-product-wrapper"},[_c('span',{staticClass:"supplier-product-name"},[_vm._v(_vm._s(_vm.$t('gestiune.name'))+": "+_vm._s(row.productInvoiceSupplier))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.searchResults,"label":"name","placeholder":"Mapeaza produsul...","filterable":false},on:{"search":_vm.fetchProducts,"input":function (val) { return _vm.onProductSelect(val, row); }},model:{value:(row.productName),callback:function ($$v) {_vm.$set(row, "productName", $$v)},expression:"row.productName"}},[[(!_vm.loading)?_c('span',[_vm._v("Niciun produs găsit")]):_vm._e()]],2)],1):_c('span',[_vm._v(_vm._s(row.productName))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.categoria))]),_vm._v(" "),((_vm.isEdit && !_vm.selectedGestiuneId) || _vm.isNir)?_c('td',[_vm._v("\n                    "+_vm._s(_vm.getGestiuneNameById(row.gestiune))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('td',[(_vm.isInvoiceSupplier)?[_c('span',{staticClass:"supplier-product-name"},[_vm._v("Factură: "+_vm._s(_vm.getUnitText(row.umInvoiceSupplier)))]),_vm._v(" "),_c('div',{staticClass:"invoice-supplier-um-edit"},[(row.um)?_c('span',{staticClass:"supplier-product-name"},[_vm._v("Stoc: "+_vm._s(row.um))]):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(row.umDocument),expression:"row.umDocument"}],staticClass:"form-control invoice-supplier-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(row, "umDocument", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.onInvoiceSupplierUnitChange(row)}]}},_vm._l((_vm.getRowDocumentUmOptions(row)),function(unitShort){return _c('option',{key:unitShort,domProps:{"value":unitShort}},[_vm._v("\n                            "+_vm._s(unitShort)+"\n                          ")])})),_vm._v(" "),_c('small',{staticClass:"supplier-product-hint"},[_vm._v("UM recepție")])])]:[_vm._v(_vm._s(row.um))]],2),_vm._v(" "),_c('td',[(_vm.isInvoiceSupplier)?[_c('span',{staticClass:"supplier-product-name"},[_vm._v("Factură: "+_vm._s(row.quantityInvoiceSupplier)+" "+_vm._s(_vm.getUnitText(row.umInvoiceSupplier)))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(row.cantitateDocument),expression:"row.cantitateDocument",modifiers:{"number":true}}],staticClass:"form-control invoice-supplier-qty",attrs:{"type":"number","min":"0.0001","step":"any","required":"","disabled":!row.um},domProps:{"value":(row.cantitateDocument)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(row, "cantitateDocument", _vm._n($event.target.value))},function($event){_vm.onInvoiceSupplierQuantityInput(row)}],"blur":function($event){_vm.$forceUpdate()}}})]:[_vm._v(_vm._s(row.cantitate))]],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.tva))]),_vm._v(" "),_c('td',[(_vm.isInvoiceSupplier)?[_c('span',{staticClass:"supplier-product-name"},[_vm._v("Factură: "+_vm._s(row.priceInvoiceSupplier != null ? Number(row.priceInvoiceSupplier).toFixed(2) : '')+" / "+_vm._s(_vm.getUnitText(row.umInvoiceSupplier)))]),_vm._v(" "),_c('input',{staticClass:"form-control invoice-supplier-price",attrs:{"type":"number","disabled":""},domProps:{"value":row.pretInvoiceSupplier != null ? Number(row.pretInvoiceSupplier).toFixed(3) : ''}})]:[_vm._v(_vm._s(Number(row.pretFaraTva).toFixed(4)))]],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.currency))]),_vm._v(" "),_c('td',[(_vm.isInvoiceSupplier)?[_c('span',{staticClass:"supplier-product-name"},[_vm._v("Factură: "+_vm._s(row.valoareInvoiceSupplier != null ? Number(row.valoareInvoiceSupplier).toFixed(2) : '')+" "+_vm._s(row.currency))]),_vm._v(" "),_c('input',{staticClass:"form-control invoice-supplier-value",attrs:{"type":"number","disabled":""},domProps:{"value":row.valoareCalculata != null ? Number(row.valoareCalculata).toFixed(2) : ''}})]:[_vm._v("\n                      "+_vm._s(!isNaN(row.valoareCalculata) && row.valoareCalculata !== null ? row.valoareCalculata.toFixed(2) : row.valoareCalculata)+" "+_vm._s(row.currency)+"\n                    ")]],2),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(!isNaN(row.valoareTva) && row.valoareTva !== null ? row.valoareTva.toFixed(2) : row.valoareTva)+" "+_vm._s(row.currency)+"\n                  ")]),_vm._v(" "),(_vm.hasMarfaProducts && !_vm.isInvoiceSupplier)?_c('td',[(row.categoria === 'Marfa')?_c('span',[_vm._v("\n                      "+_vm._s((!isNaN(Number(row.price)) && row.price !== null) ? Number(row.price).toFixed(2) : row.price)+" "+_vm._s(row.currency)+"\n                    ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasMarfaProducts && !_vm.isInvoiceSupplier)?_c('td',[(row.categoria === 'Marfa')?_c('span',[_vm._v(_vm._s(row.tvaProdusVanzare)+" %")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasMarfaProducts && !_vm.isInvoiceSupplier)?_c('td',[(row.categoria === 'Marfa')?_c('span',[_vm._v(_vm._s(!isNaN(row.adaosTotal) && row.adaosTotal !== null ? row.adaosTotal.toFixed(2) : row.adaosTotal)+" "+_vm._s(row.currency))]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isNir && !_vm.isInvoiceSupplier && !_vm.invoiceSupplierId)?_c('td',[_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editRow(row)}}},[_vm._v(_vm._s(_vm.$t('general.edit')))]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.deleteRow(row)}}},[_vm._v(_vm._s(_vm.$t('general.delete')))])],1)],1)],1):_vm._e()])}),_vm._v(" "),(_vm.tableData.length === 0)?_c('tr',[_c('td',{staticStyle:{"text-align":"center","color":"#909399","padding":"20px"},attrs:{"colspan":15}},[_vm._v("\n                    "+_vm._s(_vm.$t('gestiune.emptyData'))+"\n                  ")])]):_vm._e()],2)])]),_vm._v(" "),(!_vm.isNir || !_vm.isInvoiceSupplier)?_c('button',{staticClass:"btn add mar-rt-10 mar-bt-5 mar-to-15",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single'),"disabled":!_vm.selectedLocationId || _vm.isInvoiceSupplier || _vm.invoiceSupplierId},on:{"click":function($event){$event.preventDefault();return _vm.openAddProductModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('gestiune.addProduct'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"totals-container"},[(_vm.totalPretVanzare > 0)?_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Valoare totală preț vânzare:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalPretVanzare.toFixed(2))+" RON")])]):_vm._e(),_vm._v(" "),(_vm.valoareNir > 0)?_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Valoare NIR:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.valoareNir.toFixed(2))+" RON")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Total fara TVA:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalFaraTva.toFixed(2))+" RON")])]),_vm._v(" "),_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Total TVA pret achizitie:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalTva.toFixed(2))+" RON")])]),_vm._v(" "),(_vm.totalCorectie !== 0)?_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Corectie Document:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalCorectie.toFixed(2))+" RON")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"total-row total-final"},[_c('span',{staticClass:"label"},[_vm._v("Total:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalFinal.toFixed(2))+" RON")])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 col-md-6"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v("Detalii Client")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"delegat"}},[_vm._v("Delegat")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.delegat),expression:"extraFields.delegat"}],staticClass:"form-control",attrs:{"type":"text","id":"delegat","placeholder":"Numele delegatului"},domProps:{"value":(_vm.extraFields.delegat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "delegat", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"carteIdentitate"}},[_vm._v("Carte Identitate")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.carteIdentitate),expression:"extraFields.carteIdentitate"}],staticClass:"form-control",attrs:{"type":"text","id":"carteIdentitate","placeholder":"Seria și numărul cărții de identitate"},domProps:{"value":(_vm.extraFields.carteIdentitate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "carteIdentitate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"auto"}},[_vm._v("Auto")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.auto),expression:"extraFields.auto"}],staticClass:"form-control",attrs:{"type":"text","id":"auto","placeholder":"Marca și modelul auto"},domProps:{"value":(_vm.extraFields.auto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "auto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"notaInterna"}},[_vm._v("Notă internă (nu va fi vizibilă pentru furnizor)")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.notaInterna),expression:"extraFields.notaInterna"}],staticClass:"form-control",attrs:{"id":"notaInterna","placeholder":"Informații suplimentare"},domProps:{"value":(_vm.extraFields.notaInterna)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "notaInterna", $event.target.value)}}})])])])])]),_vm._v(" "),_c('vmodal',{staticClass:"addProductModal",attrs:{"name":"addProductModal","height":"auto","width":"1200"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProduct')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v("Cauta dupa categoria")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategory),expression:"selectedCategory"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.productCategories),function(category){return _c('option',{key:category.value,domProps:{"value":category.value}},[_vm._v("\n                          "+_vm._s(category.label)+"\n                        ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productName'))+"*")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.searchResults,"label":"name","placeholder":"Caută un produs...","filterable":false},on:{"search":_vm.fetchProducts,"input":function (val) { return _vm.onProductSelect(val, null); }},model:{value:(_vm.item.productName),callback:function ($$v) {_vm.$set(_vm.item, "productName", $$v)},expression:"item.productName"}},[[(!_vm.loading)?_c('span',[_vm._v("Niciun produs găsit")]):_vm._e()]],2),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.codeProduct'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.nr),expression:"item.nr"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.codeProduct'),"disabled":""},domProps:{"value":(_vm.item.nr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "nr", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.um'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.um),expression:"item.um"}],staticClass:"form-control",attrs:{"disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "um", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":_vm.item.um}},[_vm._v(_vm._s(_vm.item.um))])])])]),_vm._v(" "),(_vm.isEdit && !_vm.selectedGestiuneId)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.gestiune),expression:"item.gestiune"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "gestiune", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selectează gestiunea")]),_vm._v(" "),_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('option',{key:gestiune._id,domProps:{"value":gestiune._id}},[_vm._v("\n                          "+_vm._s(gestiune.name)+"\n                        ")])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currency'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.currency),expression:"item.currency"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"RON"}},[_vm._v("RON")]),_vm._v(" "),_c('option',{attrs:{"value":"EUR"}},[_vm._v("EURO")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.tva'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.tva),expression:"item.tva"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "tva", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează TVA")]),_vm._v(" "),_vm._l((_vm.vats),function(vat){return _c('option',{key:vat.tax_id,attrs:{"label":((vat.amount) + " %")},domProps:{"value":Number(vat.amount)}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Valoare total in LEI pentru "+_vm._s(_vm.selectedQuantity)+" "+_vm._s(_vm.getDocumentUmShort()))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.totalValue),expression:"totalValue",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":'Valoare totală'},domProps:{"value":(_vm.totalValue)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.totalValue=_vm._n($event.target.value)},_vm.calculateUnitPrice],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{staticClass:"form-text",staticStyle:{"color":"#000"}},[_vm._v("\n                        Calculator consultativ: completează valoarea totală și cantitatea pentru a afla prețul de achiziție pe unitate. Dacă nu completezi, nu se modifică nimic.\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.priceAchizitie'))+" in "+_vm._s(_vm.selectedUnit.short || _vm.item.um)+"*")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.item.pretFaraTva),expression:"item.pretFaraTva",modifiers:{"number":true}}],staticClass:"form-control",staticStyle:{"margin-right":"8px"},attrs:{"type":"number","placeholder":_vm.$t('gestiune.priceAchizitie'),"min":"0"},domProps:{"value":(_vm.item.pretFaraTva)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "pretFaraTva", _vm._n($event.target.value))},_vm.onInputNumber],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.valoare),expression:"item.valoare"}],staticClass:"form-control",staticStyle:{"max-width":"130px"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "valoare", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"cu_tva"}},[_vm._v("cu TVA")]),_vm._v(" "),_c('option',{attrs:{"value":"fara_tva"}},[_vm._v("fără TVA")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.cantitate'))+" in "+_vm._s(_vm.selectedUnit.short || _vm.item.um)+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.selectedQuantity),expression:"selectedQuantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.cantitate')},domProps:{"value":(_vm.selectedQuantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.selectedQuantity=_vm._n($event.target.value)},_vm.onInputQuantity],"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),(1)?[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("UM document intrare")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUnit),expression:"selectedUnit"}],staticClass:"form-control",attrs:{"disabled":!(_vm.unit_calc && _vm.unit_calc.length)},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedUnit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onDocumentUnitChange]}},[_c('option',{domProps:{"value":_vm.item.um}},[_vm._v(_vm._s(_vm.item.um))]),_vm._v(" "),_vm._l((_vm.unit_calc),function(unit){return [_c('option',{domProps:{"value":unit}},[_vm._v(_vm._s(unit.short))])]})],2)])]:_vm._e(),_vm._v(" "),(_vm.unit_calc && _vm.unit_calc.length)?[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v(" Gestiunea incarca "+_vm._s(_vm.item.cantitate)+" "+_vm._s(_vm.item.um))])])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.pretVanzare')))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.item.price != null ? _vm.item.price + ' ' + _vm.item.currency : ''}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("TVA vânzare")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.item.tvaProdusVanzare != null ? _vm.item.tvaProdusVanzare + ' %' : ''}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Adaos pe item (RON)")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.item.adaosLinie != null ? _vm.item.adaosLinie.toFixed(2) : '0.00'}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Adaos total (RON)")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.item.adaosTotal != null ? _vm.item.adaosTotal.toFixed(2) : '0.00'}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Adaos procentual (%)")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.item.adaosProc != null ? _vm.item.adaosProc.toFixed(2) + ' %' : '0 %'}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":function($event){_vm.$modal.hide('addProductModal')}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.cancel2'))+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":_vm.saveProduct}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.save'))+"\n                ")])])])])])]),_vm._v(" "),_c('vmodal',{staticClass:"addProductModal",attrs:{"name":"addProduct","height":"auto","width":"970"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProduct')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.productName')},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productDescription'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.productDescription')},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.type'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează opțiunea")]),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('option',{key:category.value,domProps:{"value":category.value}},[_vm._v("\n                            "+_vm._s(category.label)+"\n                          ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.um'))+" *")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.umProduct),expression:"umProduct"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.umProduct=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selectează optiunea")]),_vm._v(" "),_vm._l((_vm.mesurementsUnits),function(unit){return [_c('option',{domProps:{"value":unit.short}},[_vm._v(_vm._s(unit.short))])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currency'))+" *")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currencyProduct),expression:"currencyProduct"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currencyProduct=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"RON"}},[_vm._v("RON")]),_vm._v(" "),_c('option',{attrs:{"value":"EUR"}},[_vm._v("EURO")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.codeProduct'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.codeProduct')},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeProduct}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":function($event){$event.preventDefault();return _vm.addProductApi($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])]),_vm._v(" "),_c('ManagementSuppliersAdd',{attrs:{"groupedLocations":_vm.groupedLocations}}),_vm._v(" "),_c('ManagementSeriesAdd',{attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations,"vat-number":_vm.selectedLocation ? _vm.selectedLocation.inv_fiscal_code : ''},on:{"getSeries":_vm.getSeries}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PIUN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("Yq4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_dialog__ = __webpack_require__("qubY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__ = __webpack_require__("Ark/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__rewards__ = __webpack_require__("XMpP");




























var _components;








__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_item___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_dialog___default.a.name, __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_dialog___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dropdown___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dropdown___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown_menu___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown_menu___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_item___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_item___default.a), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_29_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_components, 'SearchableMultiSelect', __WEBPACK_IMPORTED_MODULE_30_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__["a" /* default */]), _components),
  props: {
    route: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      loading: false,
      campaignId: null,
      availabilityRange: null,
      percentageSum: '0',
      percentagesValid: false,
      rewards: [],
      locations: [],
      locationsFormatted: [],
      sortOrderDebounce: null,
      percentageDebounce: null,
      pendingSortUpdates: {},
      pendingPercentageUpdates: {},
      model: {
        title: '',
        description: '',
        active: false,
        minimum_order_value: 0,
        location_ids: []
      },
      rewardDialogVisible: false,
      editingReward: null,
      rewardForm: this.emptyRewardForm(),
      productOptions: [],
      productsLoading: false,
      productSearchVersion: 0,
      nextDraftId: -1,
      rewardSaving: false,
      rewardActiveSaving: false
    };
  },
  created: function created() {
    var _this = this;

    var fromProp = this.route && this.route.params && this.route.params.id;
    var fromRouter = this.$route && this.$route.params && this.$route.params.id;
    this.campaignId = fromProp || fromRouter || null;
    this.getLocations().then(function () {
      if (_this.campaignId) _this.loadCampaign();
    }).catch(function () {
      if (_this.campaignId) _this.loadCampaign();
    });
  },

  computed: {
    visibleRewards: function visibleRewards() {
      return this.rewards.filter(function (row) {
        return Number(row.type) !== 1 || Number(row.winning_percentage) > 0;
      }).sort(function (a, b) {
        return (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0) || (Number(a.id) || 0) - (Number(b.id) || 0);
      });
    },
    hasOtherNothing: function hasOtherNothing() {
      var _this2 = this;

      return this.rewards.some(function (row) {
        return Number(row.type) === 1 && (!_this2.editingReward || row.id !== _this2.editingReward.id);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.sortOrderDebounce);
    clearTimeout(this.percentageDebounce);
    this.productSearchVersion++;
  },

  methods: {
    displayRewardTitle: function displayRewardTitle(row) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__rewards__["a" /* rewardTitle */])(row, this.$t('spinningWheel.typeNothing')) || this.rewardTypeLabel(row);
    },
    setDraftRewards: function setDraftRewards(rows) {
      var createIfMissing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      try {
        this.rewards = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__rewards__["b" /* rebalanceRewards */])(rows, createIfMissing);
        this.percentageSum = this.rewards.filter(function (row) {
          return row.active;
        }).reduce(function (sum, row) {
          return sum + Math.round(Number(row.winning_percentage) * 10000);
        }, 0) / 10000;
        this.percentagesValid = this.percentageSum === 100;
        return true;
      } catch (error) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', this.$t(error.message), 'error').catch(function () {});
        return false;
      }
    },
    handleRewardActive: function handleRewardActive(row, value) {
      var _this3 = this;

      if (Number(row.type) === 1 || this.rewardActiveSaving) return;
      var active = !!value;
      var previous = !!row.active;
      if (active === previous) return;
      if (!this.campaignId) {
        this.setDraftRewards(this.rewards.map(function (item) {
          return item.id === row.id ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, item, { active: active }) : item;
        }));
        return;
      }
      this.rewardActiveSaving = true;
      row.active = active;
      var body = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        active: active ? 1 : 0
      };
      this.apiRequest('/spinning-wheel-rewards/' + row.id, 'PUT', body, function (response) {
        _this3.rewardActiveSaving = false;
        if (!response.status) {
          row.active = previous;
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', _this3.flattenErrors(response.errors) || _this3.$t('validations.wentWrong'), 'error').catch(function () {});
          return;
        }
        if (response.campaign) _this3.applyCampaignMeta(response.campaign);else _this3.loadCampaign();
      });
    },
    getLocations: function getLocations() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var data = {
          token: _this4.$session.get('token'),
          company_id: _this4.$session.get('selectedCompany')
        };
        _this4.apiRequest('/get-locations', 'GET', data, function (response) {
          if (response.status) {
            _this4.locations = response.data || [];
            resolve();
          } else {
            reject(new Error('Failed to fetch locations'));
          }
        });
      });
    },
    syncLocationsFormatted: function syncLocationsFormatted(locationIds) {
      var ids = (locationIds || []).map(function (id) {
        return Number(id);
      });
      this.locationsFormatted = (this.locations || []).filter(function (loc) {
        return ids.includes(Number(loc.id));
      });
    },
    emptyRewardForm: function emptyRewardForm() {
      return {
        type: 2,
        winning_percentage: 0,
        display_title: '',
        display_description: '',
        loyalty_points: null,
        coupon_type: 'PERCENTAGE',
        usage_type: 'PRODUCTS',
        discount: null,
        catalogproduct_id: null,
        sort_order: 0,
        active: true
      };
    },
    rewardTypeLabel: function rewardTypeLabel(row) {
      var map = {
        1: this.$t('spinningWheel.typeNothing'),
        2: this.$t('spinningWheel.typeLoyaltyPoints'),
        3: this.$t('spinningWheel.typeDiscountCoupon'),
        4: this.$t('spinningWheel.typeFreeProduct')
      };
      return map[Number(row.type)] || row.type_label || '—';
    },
    toDateOnly: function toDateOnly(value) {
      if (value == null || value === '') return null;
      var s = String(value).trim();
      return s.length >= 10 ? s.slice(0, 10) : s;
    },
    formatPercentage: function formatPercentage(value) {
      if (value == null || value === '') return '0';
      var n = Number(value);
      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan___default()(n)) {
        var s = String(value);
        return s.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '') || '0';
      }
      var fixed = n.toFixed(4);
      return fixed.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
    },
    flattenErrors: function flattenErrors(errors) {
      if (!errors) return null;
      if (typeof errors === 'string') return errors;
      var parts = [];
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(errors).forEach(function (key) {
        var val = errors[key];
        if (Array.isArray(val)) {
          val.forEach(function (m) {
            if (m) parts.push(String(m));
          });
        } else if (val && (typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === 'object') {
          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(val).forEach(function (k) {
            var inner = val[k];
            if (Array.isArray(inner)) inner.forEach(function (m) {
              if (m) parts.push(String(m));
            });else if (inner) parts.push(String(inner));
          });
        } else if (val) {
          parts.push(String(val));
        }
      });
      return parts.length ? parts.join('\n') : null;
    },
    applyCampaignMeta: function applyCampaignMeta(item) {
      var _this5 = this;

      if (!item) return;
      if (item.percentage_sum != null) this.percentageSum = item.percentage_sum;
      if (item.percentages_valid != null) this.percentagesValid = !!item.percentages_valid;
      if (item.active != null) this.model.active = !!item.active;
      if (item.rewards) {
        this.rewards = item.rewards;
        this.$nextTick(function () {
          return _this5.layoutRewardsTable();
        });
      }
    },
    backButton: function backButton() {
      this.$bus.$emit('close-modal');
    },
    loadCampaign: function loadCampaign() {
      var _this6 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/spinning-wheel-campaigns/' + this.campaignId, 'GET', data, function (response) {
        _this6.loading = false;
        if (!response.status || !response.data) {
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', _this6.$t('validations.wentWrong'), 'error');
          return;
        }
        var item = response.data;
        _this6.model.title = item.title || '';
        _this6.model.description = item.description || '';
        _this6.model.active = !!item.active;
        _this6.model.minimum_order_value = item.minimum_order_value != null ? Number(item.minimum_order_value) : 0;
        _this6.model.location_ids = item.location_ids || [];
        _this6.syncLocationsFormatted(_this6.model.location_ids);
        _this6.percentageSum = item.percentage_sum || '0';
        _this6.percentagesValid = !!item.percentages_valid;
        var from = _this6.toDateOnly(item.starts_at);
        var to = _this6.toDateOnly(item.ends_at);
        _this6.availabilityRange = from && to ? [from, to] : null;
        _this6.rewards = item.rewards || [];
        _this6.$nextTick(function () {
          return _this6.layoutRewardsTable();
        });
      });
    },
    layoutRewardsTable: function layoutRewardsTable() {
      var table = this.$refs.rewardsTable;
      if (table && typeof table.doLayout === 'function') table.doLayout();
    },
    scrollToRewards: function scrollToRewards() {
      var el = this.$el && this.$el.querySelector ? this.$el.querySelector('.spinning-wheel-rewards-table') : null;
      if (el && typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    payload: function payload() {
      var range = this.availabilityRange || [];
      var locationIds = (this.locationsFormatted || []).map(function (loc) {
        return Number(loc.id);
      });
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        title: this.model.title,
        description: this.model.description,
        active: this.model.active ? 1 : 0,
        starts_at: range[0] || null,
        ends_at: range[1] || null,
        minimum_order_value: this.model.minimum_order_value != null ? this.model.minimum_order_value : 0,
        location_ids: locationIds
      }, !this.campaignId ? { rewards: this.rewards.map(function (row) {
          return {
            type: row.type,
            winning_percentage: row.winning_percentage,
            display_title: row.display_title,
            display_description: row.display_description,
            loyalty_points: row.loyalty_points,
            coupon_type: row.coupon_type,
            discount: row.discount,
            usage_type: Number(row.type) === 3 ? row.usage_type || 'PRODUCTS' : 'PRODUCTS',
            catalogproduct_id: row.catalogproduct_id,
            sort_order: row.sort_order,
            active: row.active ? 1 : 0
          };
        }) } : {});
    },
    save: function save() {
      var _this7 = this;

      if (!this.model.title || !String(this.model.title).trim()) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', this.$t('spinningWheel.titleRequired'), 'error');
        return;
      }
      var range = this.availabilityRange || [];
      if (!range[0] || !range[1]) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', this.$t('spinningWheel.datesRequired'), 'error');
        return;
      }
      if (this.loading) return;
      this.loading = true;
      var body = this.payload();
      var done = function done(response) {
        _this7.loading = false;
        if (!response.status) {
          var msg = _this7.flattenErrors(response.errors) || _this7.$t('validations.wentWrong');
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', msg, 'error');
          if (response.data && response.data.id && !_this7.campaignId) {
            _this7.campaignId = response.data.id;
            _this7.rewards = response.data.rewards || [];
          }
          return;
        }
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()(_this7.$t('general.success') + '!', '', 'success').catch(function () {});
        _this7.$bus.$emit('refresh');
        if (!_this7.campaignId && response.data && response.data.id) {
          _this7.campaignId = response.data.id;
          _this7.applyCampaignMeta(response.data);
          _this7.$nextTick(function () {
            _this7.layoutRewardsTable();
            _this7.scrollToRewards();
          });
        } else if (_this7.campaignId) {
          _this7.loadCampaign();
        }
      };
      if (this.campaignId) {
        this.apiRequest('/spinning-wheel-campaigns/' + this.campaignId, 'PUT', body, done);
      } else {
        this.apiRequest('/spinning-wheel-campaigns', 'POST', body, done);
      }
    },
    handleDelete: function handleDelete() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
        title: this.$t('spinningWheel.confirmDelete'),
        useRejections: false,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then(function (result) {
        if (!result || !result.value) return;
        var data = {
          token: _this8.$session.get('token'),
          company_id: _this8.$session.get('selectedCompany')
        };
        _this8.apiRequest('/spinning-wheel-campaigns/' + _this8.campaignId, 'DELETE', data, function (response) {
          if (response.status) {
            _this8.$bus.$emit('refresh');
            _this8.$bus.$emit('close-modal');
          } else {
            __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', _this8.$t('validations.wentWrong'), 'error');
          }
        });
      });
    },
    openRewardForm: function openRewardForm(row) {
      this.productSearchVersion++;
      this.editingReward = row || null;
      if (row) {
        this.rewardForm = {
          type: Number(row.type) || 1,
          winning_percentage: Number(row.winning_percentage) || 0,
          display_title: this.displayRewardTitle(row) || '',
          display_description: row.display_description || '',
          loyalty_points: row.loyalty_points,
          coupon_type: row.coupon_type || 'PERCENTAGE',
          usage_type: row.usage_type || 'PRODUCTS',
          discount: row.discount,
          catalogproduct_id: row.catalogproduct_id || null,
          sort_order: row.sort_order || 0,
          active: !!row.active
        };
        this.productOptions = row.product ? [row.product] : [];
      } else {
        this.rewardForm = this.emptyRewardForm();
        this.productOptions = [];
      }
      this.rewardDialogVisible = true;
      if (this.rewardForm.type === 4) this.searchProducts('');
    },
    onProductDropdown: function onProductDropdown(visible) {
      if (visible && !this.productOptions.length) this.searchProducts('');
    },
    searchProducts: function searchProducts(query) {
      var _this9 = this;

      var version = ++this.productSearchVersion;
      this.productsLoading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query || ''
      };
      this.apiRequest('/spinning-wheel-campaigns/products', 'GET', data, function (response) {
        if (version !== _this9.productSearchVersion) return;
        _this9.productsLoading = false;
        if (!response.status) return;
        var options = Array.isArray(response.data) ? response.data : [];
        if (query) {
          var q = String(query).toLowerCase();
          options = options.filter(function (p) {
            return String(p.name || '').toLowerCase().includes(q);
          });
        }
        var selectedId = _this9.rewardForm.catalogproduct_id;
        if (selectedId && !options.some(function (p) {
          return Number(p.id) === Number(selectedId);
        })) {
          var existing = _this9.productOptions.find(function (p) {
            return Number(p.id) === Number(selectedId);
          });
          if (existing) options = [existing].concat(options);
        }
        _this9.productOptions = options.slice(0, 50);
      });
    },
    saveReward: function saveReward() {
      var _this10 = this;

      if (this.rewardSaving) return;
      if (this.rewardForm.type !== 1 && (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(Number(this.rewardForm.winning_percentage)) || this.rewardForm.winning_percentage < 0.0001)) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', this.$t('spinningWheel.percentageRequired'), 'error');
        return;
      }
      if (this.rewardForm.type === 2 && (!this.rewardForm.loyalty_points || this.rewardForm.loyalty_points < 1)) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', this.$t('spinningWheel.loyaltyPointsRequired'), 'error');
        return;
      }
      if (this.rewardForm.type === 3 && (!this.rewardForm.discount || this.rewardForm.discount <= 0)) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', this.$t('spinningWheel.discountRequired'), 'error');
        return;
      }
      if (this.rewardForm.type === 4 && !this.rewardForm.catalogproduct_id) {
        __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', this.$t('spinningWheel.productRequired'), 'error');
        return;
      }
      var body = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        type: this.rewardForm.type,
        winning_percentage: this.rewardForm.winning_percentage,
        display_title: this.rewardForm.display_title,
        display_description: this.rewardForm.display_description,
        loyalty_points: this.rewardForm.type === 2 ? this.rewardForm.loyalty_points : null,
        coupon_type: this.rewardForm.type === 3 ? this.rewardForm.coupon_type : null,
        discount: this.rewardForm.type === 3 ? this.rewardForm.discount : null,
        usage_type: this.rewardForm.type === 3 ? this.rewardForm.usage_type : 'PRODUCTS',
        catalogproduct_id: this.rewardForm.type === 4 ? this.rewardForm.catalogproduct_id : null,
        sort_order: this.rewardForm.sort_order || 0,
        active: this.rewardForm.active ? 1 : 0
      };
      if (!this.campaignId) {
        var row = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, body, { id: this.editingReward ? this.editingReward.id : this.nextDraftId-- });
        if (this.rewardForm.type === 4) {
          row.product = this.productOptions.find(function (product) {
            return Number(product.id) === Number(row.catalogproduct_id);
          });
        }
        var rows = this.editingReward ? this.rewards.map(function (item) {
          return item.id === row.id ? row : item;
        }) : this.rewards.concat(row);
        if (this.setDraftRewards(rows)) this.rewardDialogVisible = false;
        return;
      }
      this.rewardSaving = true;
      var done = function done(response) {
        _this10.rewardSaving = false;
        if (!response.status) {
          var msg = _this10.flattenErrors(response.errors) || _this10.$t('validations.wentWrong');
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', msg, 'error');
          return;
        }
        _this10.rewardDialogVisible = false;
        if (response.campaign) _this10.applyCampaignMeta(response.campaign);else _this10.loadCampaign();
      };
      if (this.editingReward && this.editingReward.id) {
        this.apiRequest('/spinning-wheel-rewards/' + this.editingReward.id, 'PUT', body, done);
      } else {
        this.apiRequest('/spinning-wheel-campaigns/' + this.campaignId + '/rewards', 'POST', body, done);
      }
    },
    onSortOrderInput: function onSortOrderInput(row) {
      var _this11 = this;

      if (!this.campaignId) return;
      var val = Number(row.sort_order);
      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan___default()(val) || val < 0) val = 0;
      if (val > 1000) val = 1000;
      row.sort_order = val;
      this.pendingSortUpdates[row.id] = val;
      if (this.sortOrderDebounce) clearTimeout(this.sortOrderDebounce);
      this.sortOrderDebounce = setTimeout(function () {
        return _this11.flushSortOrderUpdates();
      }, 800);
    },
    flushSortOrderUpdates: function flushSortOrderUpdates() {
      var updates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.pendingSortUpdates);
      this.pendingSortUpdates = {};
      this.sendRewardUpdates(updates, 'sort_order');
    },
    sendRewardUpdates: function sendRewardUpdates(updates, field) {
      var _this12 = this;

      var ids = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(updates);
      var next = function next() {
        var id = ids.shift();
        if (!id) {
          _this12.loadCampaign();
          return;
        }
        var body = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()({
          token: _this12.$session.get('token'),
          company_id: _this12.$session.get('selectedCompany')
        }, field, updates[id]);
        _this12.apiRequest('/spinning-wheel-rewards/' + id, 'PUT', body, function (response) {
          if (!response.status) {
            __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', _this12.flattenErrors(response.errors) || _this12.$t('validations.wentWrong'), 'error').catch(function () {});
          }
          next();
        });
      };
      if (ids.length) next();
    },
    onPercentageInput: function onPercentageInput(row) {
      var _this13 = this;

      if (!this.campaignId) {
        if (!this.setDraftRewards(this.rewards)) row.winning_percentage = row._savedWinningPercentage;
        return;
      }
      var val = Number(row.winning_percentage);
      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan___default()(val) || val <= 0) return;
      this.pendingPercentageUpdates[row.id] = val;
      if (this.percentageDebounce) clearTimeout(this.percentageDebounce);
      this.percentageDebounce = setTimeout(function () {
        return _this13.flushPercentageUpdates();
      }, 800);
    },
    flushPercentageUpdates: function flushPercentageUpdates() {
      var updates = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.pendingPercentageUpdates);
      this.pendingPercentageUpdates = {};
      this.sendRewardUpdates(updates, 'winning_percentage');
    },
    duplicateReward: function duplicateReward(row) {
      var _this14 = this;

      if (!row || !row.id || Number(row.type) === 1) return;
      if (!this.campaignId) {
        this.setDraftRewards(this.rewards.concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, row, { id: this.nextDraftId--, sort_order: Number(row.sort_order) + 1 })));
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/spinning-wheel-rewards/' + row.id + '/duplicate', 'POST', data, function (response) {
        if (!response.status) {
          __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', _this14.flattenErrors(response.errors) || _this14.$t('validations.wentWrong'), 'error');
          return;
        }
        if (response.campaign) _this14.applyCampaignMeta(response.campaign);else _this14.loadCampaign();
      });
    },
    deleteReward: function deleteReward(row) {
      var _this15 = this;

      __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()({
        title: this.$t('spinningWheel.confirmDelete'),
        useRejections: false,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then(function (result) {
        if (!result || !result.value) return;
        if (!_this15.campaignId) {
          _this15.setDraftRewards(_this15.rewards.filter(function (item) {
            return item.id !== row.id;
          }), Number(row.type) !== 1);
          return;
        }
        var data = {
          token: _this15.$session.get('token'),
          company_id: _this15.$session.get('selectedCompany')
        };
        _this15.apiRequest('/spinning-wheel-rewards/' + row.id, 'DELETE', data, function (response) {
          if (response.status) {
            if (response.campaign) _this15.applyCampaignMeta(response.campaign);else _this15.loadCampaign();
          } else __WEBPACK_IMPORTED_MODULE_28_sweetalert2___default()('', _this15.flattenErrors(response.errors) || _this15.$t('validations.wentWrong'), 'error');
        });
      });
    },
    openGeneratedCampaign: function openGeneratedCampaign(row) {
      var id = row.open_campaign_id || row.generated_campaign_id;
      if (!id) return;
      this.$router.push('/marketing/campaigns/edit/' + id);
    }
  }
});

/***/ }),

/***/ "PLDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isGeneral },on:{"click":_vm.openGeneral}},[_vm._v(_vm._s(_vm.$t('kds.general')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isUsers },on:{"click":_vm.openUsers}},[_vm._v(_vm._s(_vm.$t('kds.users')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isSections },on:{"click":_vm.openSections}},[_vm._v(_vm._s(_vm.$t('kds.sections')))])])])])]),_vm._v(" "),(_vm.isGeneral)?_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.startTimer')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.startTimer),callback:function ($$v) {_vm.startTimer=$$v},expression:"startTimer"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.useStartTimerForAllItems')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.useStartTimerForAllItems),callback:function ($$v) {_vm.useStartTimerForAllItems=$$v},expression:"useStartTimerForAllItems"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.useOrderLanes')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.useOrderLanes),callback:function ($$v) {_vm.useOrderLanes=$$v},expression:"useOrderLanes"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.allowOptionTimer')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.allowOptionTimer),callback:function ($$v) {_vm.allowOptionTimer=$$v},expression:"allowOptionTimer"}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t('kds.allowOptionTimerInfo')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.allowCourseTimer')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.allowCourseTimer),callback:function ($$v) {_vm.allowCourseTimer=$$v},expression:"allowCourseTimer"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.timeProcessingStatus')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.timeProcessingStatus),callback:function ($$v) {_vm.timeProcessingStatus=$$v},expression:"timeProcessingStatus"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.displayOrdersGrid')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.displayOrdersGrid),callback:function ($$v) {_vm.displayOrdersGrid=$$v},expression:"displayOrdersGrid"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.displayOrdersMode')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%","max-width":"280px"},model:{value:(_vm.displayOrdersMode),callback:function ($$v) {_vm.displayOrdersMode=$$v},expression:"displayOrdersMode"}},_vm._l((_vm.displayOrdersModeOptions),function(option){return _c('el-option',{key:option.value,attrs:{"label":option.label,"value":option.value}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.ordersSortColumn')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%","max-width":"280px"},model:{value:(_vm.ordersSortColumn),callback:function ($$v) {_vm.ordersSortColumn=$$v},expression:"ordersSortColumn"}},_vm._l((_vm.ordersSortColumnOptions),function(option){return _c('el-option',{key:option.value,attrs:{"label":option.label,"value":option.value}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.productSorting')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%","max-width":"280px"},model:{value:(_vm.productSorting),callback:function ($$v) {_vm.productSorting=$$v},expression:"productSorting"}},_vm._l((_vm.productSortingOptions),function(option){return _c('el-option',{key:option.value,attrs:{"label":option.label,"value":option.value}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.displayStartedOrdersFirst')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.displayStartedOrdersFirst),callback:function ($$v) {_vm.displayStartedOrdersFirst=$$v},expression:"displayStartedOrdersFirst"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.groupProductsByCategory')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.groupProductsByCategory),callback:function ($$v) {_vm.groupProductsByCategory=$$v},expression:"groupProductsByCategory"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.hidePreparedItems')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.hidePreparedItems),callback:function ($$v) {_vm.hidePreparedItems=$$v},expression:"hidePreparedItems"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.displayWaiterName')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.displayWaiterName),callback:function ($$v) {_vm.displayWaiterName=$$v},expression:"displayWaiterName"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.displayDeliveryTime')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.displayDeliveryTime),callback:function ($$v) {_vm.displayDeliveryTime=$$v},expression:"displayDeliveryTime"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.useAutoCloseOrders')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.useAutoCloseOrders),callback:function ($$v) {_vm.useAutoCloseOrders=$$v},expression:"useAutoCloseOrders"}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t('kds.useAutoCloseOrdersInfo')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.autoPrint')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.autoPrint),callback:function ($$v) {_vm.autoPrint=$$v},expression:"autoPrint"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.notificationSound')))]),_vm._v(" "),_c('div',{staticClass:"notification-sound-row"},[_c('el-select',{staticStyle:{"width":"100%","max-width":"280px"},model:{value:(_vm.notificationSound),callback:function ($$v) {_vm.notificationSound=$$v},expression:"notificationSound"}},_vm._l((_vm.notificationSoundOptions),function(option){return _c('el-option',{key:option.value,attrs:{"label":option.label,"value":option.value}})})),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-primary",attrs:{"type":"button"},on:{"click":_vm.playNotificationSound}},[_vm._v("\n              "+_vm._s(_vm.$t('kds.playSound'))+"\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('BackgroundColorPicker',{attrs:{"title":_vm.$t('kds.lane_1_color'),"color":_vm.lane1background},on:{"color-change":function($event){_vm.updateColor($event, 'lane1background')}}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('BackgroundColorPicker',{attrs:{"title":_vm.$t('kds.lane_2_color'),"color":_vm.lane2background},on:{"color-change":function($event){_vm.updateColor($event, 'lane2background')}}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.orderAveragePrepTime')))]),_vm._v(" "),_c('el-time-picker',{attrs:{"format":"HH:mm:ss","placeholder":"Select time"},on:{"change":_vm.updatePrepTime},model:{value:(_vm.orderAveragePrepTime),callback:function ($$v) {_vm.orderAveragePrepTime=$$v},expression:"orderAveragePrepTime"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.isUsers)?_c('div',[_c('KdsSettingsUsers')],1):_vm._e(),_vm._v(" "),(_vm.isSections)?_c('div',[_c('KdsSections')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PO7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bolt-menu-layout",class:{ 'bolt-menu-layout--product': !!_vm.selectedProduct }},[(_vm.selectedProduct)?_c('product-options-panel',{attrs:{"product":_vm.selectedProduct,"currency":_vm.currency,"variant":"bolt"},on:{"close":function($event){_vm.selectedProduct = null}}}):[_c('aside',{staticClass:"bolt-menu-layout__sidebar"},_vm._l((_vm.categories),function(category){return _c('button',{key:category.id,staticClass:"bolt-menu-layout__nav",class:{ 'is-active': category.id === _vm.activeCategoryId },attrs:{"type":"button"},on:{"click":function($event){_vm.selectCategory(category.id)}}},[_vm._v("\n        "+_vm._s(category.name)+"\n      ")])})),_vm._v(" "),_c('div',{staticClass:"bolt-menu-layout__main"},[_c('h2',[_vm._v(_vm._s(_vm.activeCategoryName))]),_vm._v(" "),_vm._l((_vm.activeProducts),function(product){return _c('div',{key:product.id,staticClass:"bolt-menu-layout__row",class:{ 'is-oos': !product.available },on:{"click":function($event){product.available !== false && (_vm.selectedProduct = product)}}},[_c('div',{staticClass:"bolt-menu-layout__text"},[(!product.available)?_c('div',{staticClass:"bolt-menu-layout__oos"},[_vm._v("\n            "+_vm._s(_vm.$t('gestiune.integrationsMenuPreviewOutOfStock'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v(_vm._s(product.name))]),_vm._v(" "),(product.description)?_c('p',[_vm._v(_vm._s(_vm.truncate(product.description)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bolt-menu-layout__price"},[_vm._v(_vm._s(_vm.formatPrice(product.price)))])]),_vm._v(" "),_c('div',{staticClass:"bolt-menu-layout__media"},[(product.image_url)?_c('img',{class:{ 'is-muted': !product.available },attrs:{"src":product.image_url,"alt":product.name}}):_vm._e(),_vm._v(" "),(product.available !== false)?_c('button',{staticClass:"bolt-menu-layout__add",attrs:{"type":"button"}},[_vm._v("+")]):_vm._e()])])})],2)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PPUE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__);

























__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({
    PPagination: __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_input___default.a),
  computed: {
    mergedUsers: function mergedUsers() {
      var map = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(this.users.map(function (item) {
        return [item.id, item];
      }));
      this.selectedUsers.forEach(function (item) {
        if (!map.has(item.id)) {
          map.set(item.id, item);
        }
      });
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(map.values());
    },
    isKioskView: function isKioskView() {
      return window.location.href.toLowerCase().includes('kiosk');
    },
    allKiosksReloading: function allKiosksReloading() {
      return this.tableData.length > 0 && this.tableData.every(function (k) {
        return Number(k.reload) === 1;
      });
    }
  },
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    },
    isTable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.initData();

    this.setTableTypes();
    this.$bus.$on('refresh', this.handleRefresh);
  },

  watch: {
    filterLocation: function filterLocation() {
      this.getMaps();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      loading2: true,
      reloadingAll: false,
      token: null,
      apiUrl: null,
      filterId: '',
      filterLocation: [],
      filterTableName: '',
      filterType: '',
      filterZone: '',
      filterMaps: [],
      filterUser: [],
      users: [],
      selectedUsers: [],
      loadingUsers: false,
      tableTypes: ['Masa', 'Umbrela', 'Camera', 'Kiosk'],
      zones: [],
      maps: [],
      tableColumns: [{
        prop: 'number',
        label: this.$t('settingTable.number'),
        minWidth: 140
      }, {
        prop: 'type',
        label: this.$t('settingTable.type'),
        minWidth: 150
      }, {
        prop: 'zone',
        label: this.$t('settingTable.zone'),
        minWidth: 150
      }],
      locationDataForTableManagement: [],
      tableData: [],
      locations: []
    };
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.initData();
    },
    initData: function initData() {
      this.apiUrl = "https://gatewaydev.taptasty.com/";
      this.token = this.$session.get('token');

      this.locations = this.$session.get('selectedCompanyData').locations_details || [];
      this.getData();
      if (this.isKioskView) {
        this.loading2 = false;
      } else {
        this.getQrForLocations();
      }
      this.getZones();
      this.getMaps();
    },
    setTableTypes: function setTableTypes() {
      var url = window.location.href.toLowerCase();

      if (url.includes('kiosk')) {
        this.tableTypes = ['Kiosk'];
        this.filterType = 'Kiosk';
        return;
      }

      if (url.includes('qr')) {
        this.tableTypes = ['Masa', 'Umbrela', 'Camera'];

        if (!this.tableTypes.includes(this.filterType)) {
          this.filterType = '';
        }

        return;
      }

      this.tableTypes = ['Masa', 'Umbrela', 'Camera', 'Kiosk'];
    },
    getLocationName: function getLocationName(locationId) {
      if (!locationId) return '';

      var location = this.locationDataForTableManagement.find(function (loc) {
        return loc.id === locationId || loc.true_id === locationId;
      });
      if (location) {
        return location.name;
      }

      if (this.locations && this.locations.length) {
        var sessionLocation = this.locations.find(function (loc) {
          return loc.id === locationId || loc.true_id === locationId;
        });
        if (sessionLocation) {
          return sessionLocation.name;
        }
      }
      return locationId;
    },
    goToRecord: function goToRecord(row, event, column) {
      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/user/edit/');
      }
    },
    getData: function getData() {
      var _this = this;

      var url = window.location.href.toLowerCase();

      if (url.includes('kiosk')) {
        this.filterType = 'Kiosk';
      }

      if (url.includes('qr')) {
        this.filterType = 'Masa';
      }

      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany')
      };

      if (this.filterId) data.id = this.filterId;
      if (Array.isArray(this.filterLocation) && this.filterLocation.length) {
        data.location_ids = this.filterLocation;
      }
      if (this.filterTableName) data.search = this.filterTableName;
      if (this.filterType) data.type = this.filterType;
      if (this.filterZone) data.zone = this.filterZone;
      if (Array.isArray(this.filterMaps) && this.filterMaps.length) {
        data.map_ids = this.filterMaps;
      }
      if (Array.isArray(this.filterUser) && this.filterUser.length) {
        data.user = this.filterUser.map(function (u) {
          return u.id;
        });
      }

      this.apiRequest('/table-management', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = Array.isArray(response.data) ? response.data : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.data || {});

          _this.$nextTick(function () {
            _this.loading = false;
          });
        } else {
          _this.tableData = [];
          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    },
    getQrForLocations: function getQrForLocations() {
      var _this2 = this;

      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/table/get-qr-for-locations', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.locationDataForTableManagement = response.data.locations;

          _this2.$nextTick(function () {
            _this2.loading2 = false;
          });
        }
      });
    },
    reloadAllKiosks: function reloadAllKiosks() {
      var _this3 = this;

      this.reloadingAll = true;
      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/table/reload-kiosks', 'POST', data, function (response) {
        if (response.status === true) {
          _this3.getData();
        }
        _this3.$nextTick(function () {
          _this3.reloadingAll = false;
        });
      });
    },
    reloadKiosk: function reloadKiosk(kiosk) {
      var _this4 = this;

      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany'),
        table_id: kiosk.id
      };
      this.apiRequest('/table/reload-kiosks', 'POST', data, function (response) {
        if (response.status === true) {
          _this4.$set(kiosk, 'reload', 1);
        }
      });
    },
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy).then(function (e) {}, function (e) {});
    },
    goToAdd: function goToAdd() {
      if (typeof this.callback === 'function') {
        this.callback(null);
      }
    },
    applyFilters: function applyFilters() {
      this.selectedUsers = Array.isArray(this.filterUser) ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.filterUser)) : [];
      this.loading = true;
      this.getData();
    },
    searchUsers: function searchUsers(query) {
      var _this5 = this;

      if (!query) {
        this.users = [];
        return;
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      };

      this.loadingUsers = true;
      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this5.users = response.data.pos_user || [];
        }
        _this5.$nextTick(function () {
          _this5.loadingUsers = false;
        });
      });
    },
    clearUserSearch: function clearUserSearch() {
      if (this.$refs.userSelect) {
        this.$refs.userSelect.focus();
        this.$refs.userSelect.query = '';
        this.$refs.userSelect.handleQueryChange('');
      }
    },
    getZones: function getZones() {
      var _this6 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/table-zone', 'GET', data, function (response) {
        if (response.status === true && response.data.length) {
          _this6.zones = response.data.map(function (zone) {
            return {
              id: zone.id,
              name: zone.name
            };
          });
        }
      });
    },
    getMaps: function getMaps() {
      var _this7 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (Array.isArray(this.filterLocation) && this.filterLocation.length) {
        data.location_ids = this.filterLocation;
      }
      this.apiRequest('/pos/all/map', 'GET', data, function (response) {
        if (response && response.status === true) {
          _this7.maps = response.data.table_maps || [];
        } else {
          _this7.maps = [];
        }
      });
    }
  }
});

/***/ }),

/***/ "PT7/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutomationCampaignPage_vue__ = __webpack_require__("Q1uJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1437a7af_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutomationCampaignPage_vue__ = __webpack_require__("7DiW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutomationCampaignPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1437a7af_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutomationCampaignPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PTf0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.add'))+"\n          ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.modelData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"50","prop":"name","label":_vm.$t('customers.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"50","prop":"location_name","label":_vm.$t('customers.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.location && props.row.location.name)?_c('span',[_vm._v(_vm._s(props.row.location.name))]):_c('span',[_vm._v(_vm._s(_vm.$t('general.all')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":200,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.deleteOrderScreen(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.delete'))+"\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":150,"label":_vm.$t('general.edit')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n            ")])]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PUl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Approvals_vue__ = __webpack_require__("phjV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d8da26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Approvals_vue__ = __webpack_require__("bK1W");
function injectStyle (ssrContext) {
  __webpack_require__("PlW5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Approvals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d8da26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Approvals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PWXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelCampaignEdit_vue__ = __webpack_require__("+j9/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05aa0d4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelCampaignEdit_vue__ = __webpack_require__("jfB8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelCampaignEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05aa0d4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelCampaignEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PYU9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MixedReport_vue__ = __webpack_require__("kRrD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4798e208_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MixedReport_vue__ = __webpack_require__("X2tq");
function injectStyle (ssrContext) {
  __webpack_require__("IB+M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MixedReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4798e208_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MixedReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PcAN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pcd2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PdiO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAABHNCSVQICAgIfAhkiAAAA+xJREFUWEftWUtOG0EQrcImglXICWJOEHOCmE0kswlZRoAwJ4hzgjgniDkBRgZlSdhgKRucE0BOAJwAvEokbDqvez7pmel2ZrrHRkhpaSQ+3dVvqqqrX71hyjEGfdEgpl1BVGc8OZbYpowqTI03W3zpYQNQpozvx6I+EfQFUxo+m6i1gn4ujamxvsd3vrasoM/6YhPGD5hpxXcTG+AogqFTato+1/h5iKjsm6JiBC09PH6g81IAE42W7qmme/j8QKz8XlQRbOVwSA/rP+rrjaAHR+IKxvQ3z2HbMoVpr7nFvei/g6+iJiZ0UuRs4CxdLt/TegQ8A3pwLFoI54E7Sm0l8ri5w/HBlR7+tYgIOhxmHXgG9NmRuHAxanpJIejdxg5/i73cFx0c/U/ODhH0GU7oZD19hK1KGsjFF1FIZVrQhGTaOQ8gu1se02oCdHiaz52t6gtTqVFa2uGMJECrU131ujz+wq7SdfM9y9KlBg63TJO3JTjkdOrlUsIGsQnU/SFK6Gtfm0iRH/ME3QXoD08KdJgisl7v+gBPeFrl8zN4QiieIR+fMZR1lSu0r+e1NOibJjHokq/t+GVlicIve4la7Vn6FGh1S1XpqiSekYmOBM5VWtM97uNtBRq12e+WypdEp81tlqwxKH8eVCEAXSY5mvICAB1XKp9LLAJtu7ZHmFCsw2CqAdlLI/YKrUYpEjYXF/mClJxlBY23uAEVrBftMsIbdQhS9Cqb3LQOsjOMU8SR40zz9CHC2XLxhPWMiFmDDing0wJN9PQ8HfFWl5y2diYzTw/khboUuGD1CPpK+WTHPEC75PPUNf9BO9bLwpGYi6fTeoWZoxyieW3HzWug+cm26vljXC4JghMBgLxwrV/TOp+I5/SFuUOZtaclgd/Y5rW0t0Apb3UKq0sEjw5aAgDwLi2oUAdjQm0AjullOOdyganzwIrsE8uuR1AnZ8mTa7JpBO0P5balbDB10wTsXyyv8FkrUvLCbkmmUtyhK0BVakVsMCRgbYBvay94KPl0aYpSEdDRXMWtZU+6AJ1EEyp1W0qdGgfeh8bdfXTQLuG0g4asBYNxTgumloHgj5DD3XhjVuqUWUVKVQ8XsNEaI2jZBKB61HTDoRB+q/8NSv1aWqm3yl+zBg1gtjqdkIFNdTpvE1C+p81t/yZO+klis9StGUZD9n6JKKk1c/B0hG0Y7EcrNqFdKUkU1GnUobpVP9EaWx8vy7Wcvpp9DVrWj5BK/l/JQuPzEmuc2zeTE5QsBiHd3PaX4/YRVaieFiJ9TCvVR4knD9Qz6hU+1sEjyvisnIaQ/OYSaGybOFD++QdeDcGnV7Q5zuOjPzeEevWtUIegAAAAAElFTkSuQmCC"

/***/ }),

/***/ "PgRl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);












__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_data_tables___default.a);

var ORDER_SOURCE_LABELS = {
  1: 'kiosk',
  2: 'qr',
  3: 'pos',
  4: 'app',
  5: 'website'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      searchQuery: '',
      tableData: [],
      currency: '',
      paginationDef: {
        pageSize: 20,
        currentPage: 1,
        pageSizes: [20, 50, 100]
      }
    };
  },
  created: function created() {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso);
    this.getCoupons();
    this.$bus.$on('refresh', this.getCoupons);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.getCoupons);
  },

  methods: {
    automationTitle: function automationTitle(row) {
      var campaigns = row.automation_campaigns || [];
      var hint = this.$t('marketingCoupons.isAutomationHint');
      if (!campaigns.length) {
        return hint;
      }
      return this.$t('marketingCoupons.automationCampaigns') + ': ' + campaigns.map(function (campaign) {
        return campaign.name;
      }).join(', ') + '\n\n' + hint;
    },
    subscriptionTitle: function subscriptionTitle(row) {
      var levels = row.subscription_levels || [];
      var hint = this.$t('marketingCoupons.isSubscriptionHint');
      if (!levels.length) {
        return hint;
      }
      return this.$t('marketingCoupons.subscriptionLevels') + ': ' + levels.map(function (level) {
        return level.name;
      }).join(', ') + '\n\n' + hint;
    },
    orderSourcesText: function orderSourcesText(ids) {
      var _this = this;

      if (!Array.isArray(ids) || !ids.length) {
        return this.$t('marketingCoupons.allSources');
      }
      return ids.map(function (id) {
        var label = ORDER_SOURCE_LABELS[id] || String(id);
        var key = 'orderFrom.' + label;
        var translated = _this.$t(key);
        if (translated !== key) {
          return translated;
        }
        var upperKey = 'orderFrom.' + label.toUpperCase();
        var upperTranslated = _this.$t(upperKey);
        return upperTranslated !== upperKey ? upperTranslated : label;
      }).join(', ');
    },
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    getCoupons: function getCoupons() {
      var _this2 = this;

      var data = this.requestData();
      if (this.searchQuery.length >= 3) {
        data.search = this.searchQuery;
      }
      this.loading = true;
      this.apiRequest('/coupon', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.tableData = response.data;
        }
        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    onInput: function onInput() {
      if (this.searchQuery.length >= 3 || this.searchQuery.length === 0) {
        this.getCoupons();
      }
    },
    goToRecord: function goToRecord(row, column, event) {
      this.globalGoToRecord(row, event, column, '/marketing/coupons/edit/');
    },
    handleActive: function handleActive(row) {
      var _this3 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.requestData(), {
        active: row.active ? 1 : 0
      });
      this.apiRequest('/coupon/' + row.id + '/status', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()(_this3.$t('general.success') + '!', '', 'success').catch(function () {});
        } else {
          row.active = !row.active;
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;

      var text = this.$t('marketingCoupons.areYouSureDelete') + ' ' + row.name + '?';
      if (row.push_campaigns && row.push_campaigns.length) {
        text += ' ' + this.$t('marketingCoupons.deleteAssignedWarning', {
          campaigns: row.push_campaigns.map(function (campaign) {
            return campaign.name;
          }).join(', ')
        });
      }
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        text: text,
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (!result) {
          return;
        }
        _this4.apiRequest('/coupon/' + row.id, 'DELETE', _this4.requestData(), function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', _this4.$t('marketingCoupons.couponDeleted'), 'success').catch(function () {});
            _this4.tableData = _this4.tableData.filter(function (item) {
              return item.id !== row.id;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error').catch(function () {});
          }
        });
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "PiTK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"menu-preview-modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onClose($event)}}},[_c('div',{staticClass:"menu-preview-modal__dialog"},[_c('header',{staticClass:"menu-preview-modal__header"},[_c('div',{staticClass:"menu-preview-modal__heading"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subtitle)?_c('p',{staticClass:"menu-preview-modal__subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"menu-preview-modal__actions"},[_c('button',{staticClass:"btn add",attrs:{"type":"button","disabled":_vm.busy || _vm.importing || !_vm.hasCategories},on:{"click":function($event){_vm.$emit('import')}}},[_vm._v("\n          "+_vm._s(_vm.importing
            ? _vm.$t('gestiune.integrationsMenuPreviewImporting')
            : _vm.$t('gestiune.integrationsMenuPreviewImport'))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn delete menu-preview-modal__close-btn",attrs:{"type":"button","disabled":_vm.busy || _vm.importing},on:{"click":_vm.onClose}},[_vm._v("\n          "+_vm._s(_vm.$t('general.close'))+"\n        ")])])]),_vm._v(" "),(!_vm.busy && !_vm.errorMessage && _vm.hasCategories)?_c('div',{staticClass:"menu-preview-modal__toolbar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"menu-preview-modal__search",attrs:{"type":"search","placeholder":_vm.$t('gestiune.integrationsMenuPreviewSearchPlaceholder'),"disabled":_vm.importing,"autocomplete":"off"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_vm._v(" "),(_vm.searchQuery)?_c('button',{staticClass:"menu-preview-modal__search-clear",attrs:{"type":"button","disabled":_vm.importing},on:{"click":function($event){_vm.searchQuery = ''}}},[_vm._v("\n        "+_vm._s(_vm.$t('gestiune.integrationsMenuPreviewSearchClear'))+"\n      ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.warnings.length)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"status"}},_vm._l((_vm.warnings),function(warning,index){return _c('p',{key:index},[_vm._v(_vm._s(_vm.warningMessage(warning)))])})):_vm._e(),_vm._v(" "),_c('div',{staticClass:"menu-preview-modal__content"},[(_vm.busy)?_c('div',{staticClass:"menu-preview-modal__loading"},[_c('div',{staticClass:"menu-preview-modal__spinner",attrs:{"aria-hidden":"true"}},[_c('svg',{staticClass:"menu-preview-modal__spinner-svg",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"menu-preview-modal__spinner-path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsMenuPreviewLoading')))])]):(_vm.errorMessage)?_c('div',{staticClass:"menu-preview-modal__error"},[_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n      ")]):(!_vm.filteredCategories.length)?_c('div',{staticClass:"menu-preview-modal__error"},[_vm._v("\n        "+_vm._s(_vm.searchQuery
          ? _vm.$t('gestiune.integrationsMenuPreviewSearchEmpty')
          : _vm.$t('gestiune.integrationsGlovoMenuEmpty'))+"\n      ")]):_c('div',{staticClass:"menu-preview-modal__body"},[(_vm.layout === 'wolt')?_c('wolt-menu-layout',{attrs:{"categories":_vm.filteredCategories,"currency":_vm.currency}}):(_vm.layout === 'glovo')?_c('glovo-menu-layout',{attrs:{"categories":_vm.filteredCategories,"currency":_vm.currency}}):_c('bolt-menu-layout',{attrs:{"categories":_vm.filteredCategories,"currency":_vm.currency}})],1),_vm._v(" "),(_vm.importing)?_c('div',{staticClass:"menu-preview-modal__importing"},[_c('div',{staticClass:"menu-preview-modal__spinner",attrs:{"aria-hidden":"true"}},[_c('svg',{staticClass:"menu-preview-modal__spinner-svg",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"menu-preview-modal__spinner-path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsMenuPreviewImporting')))])]):_vm._e()])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PlUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.productsSalesReport2') + ' (' + _vm.$t('reports.withoutOptions') + ')'}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n            "+_vm._s(_vm.$t('general.from'))+"\n            "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.to'))+"\n            "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"center-sales-report-stats",staticStyle:{"height":"225px !important"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content"},[_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.revenue')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.productsTableDataTotals.total_revenue || 0))))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.quantity')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(Number(_vm.productsTableDataTotals.quantity_sold || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.discount')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.productsTableDataTotals.discount || 0))))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('catalogCateg.vatTitle')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.productsTableDataTotals.vat || 0))))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-summary-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.productsTableData,"total":_vm.totalOrders,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":50,"prop":"product_id","label":"ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":150,"prop":"name","label":_vm.$t('reports.productName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"total_revenue","label":_vm.$t('reports.revenue')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_revenue)))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"quantity_sold","label":_vm.$t('reports.quantity')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_vm._v("\n                  "+_vm._s(Number(props.row.quantity_sold))+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"discount","label":_vm.$t('reports.discount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_vm._v("\n                  "+_vm._s(_vm.formatMoneyAmount(Number(props.row.discount)))+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"vat","label":_vm.$t('catalogCateg.vatTitle')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(Number(props.row.vat)))+"\n              ")]}}])})],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PlW5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PozW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PrLq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Settings_Locations_LocationForm_vue__ = __webpack_require__("Oz8n");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'LocationForm', __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Settings_Locations_LocationForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      tableManagementModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {}
});

/***/ }),

/***/ "PyC8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs",attrs:{"direction":"vertical"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.tableZones')}},[_c('keep-alive',[(_vm.isTableZones)?_c('div',[(_vm.selectedZone !== false)?[_c('table-zone-form',{attrs:{"callback":_vm.tableZoneUpdate,"zoneId":_vm.selectedZone},on:{"on-submit":_vm.onUserSubmit}})]:[_c('table-zone-list',{ref:"tableZone",attrs:{"isTable":_vm.isTableZones,"callback":_vm.getZone}})]],2):_vm._e()])],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.kioskModule')}},[_c('keep-alive',[(_vm.isTableManager)?_c('div',[(_vm.selectedTable !== false)?[_c('table-management-form',{attrs:{"callback":_vm.tableManagementUpdate,"tableId":_vm.selectedTable,"posUsers":_vm.formattedUsers},on:{"on-submit":_vm.onUserSubmit}})]:[_c('table-management-list',{ref:"tableManagement",attrs:{"isTable":_vm.isTableManager,"callback":_vm.getTable,"posUsers":_vm.formattedUsers}})]],2):_vm._e()])],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('settingsPages.settings')}},[_c('keep-alive',[_c('div',[_c('kiosk-colors-card',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)])],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q+Ap":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q1XM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.view === 'list')?_c('div',[_c('div',{staticClass:"card mar-to-15",staticStyle:{"width":"calc(100% - 20px)","margin-left":"10px","margin-right":"10px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',[_c('button',{staticClass:"btn add",on:{"click":function($event){$event.preventDefault();_vm.openForm(null)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('deliveryPreferences.preferenceAdd'))+"\n            ")])])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"70px"}},[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.numeAdmin')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.enabled')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"130px"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.preferences),function(pref){return _c('tr',{key:pref.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.openForm(pref.id)}}},[_c('td',[_vm._v(_vm._s(pref.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(pref.nume_admin))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(pref.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(pref.type === 2 ? _vm.$t('deliveryPreferences.typeSlot') : _vm.$t('deliveryPreferences.typeClassic')))]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa",class:pref.enabled ? 'fa-check text-success' : 'fa-times text-danger'})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"edit",staticStyle:{"white-space":"nowrap"}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" "+_vm._s(_vm.$t('general.edit')))])])])}),_vm._v(" "),(!_vm.loading && !_vm.preferences.length)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"6"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.noData')))])]):_vm._e()],2)])])])])]):_c('div',[_c('div',{staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":function($event){$event.preventDefault();return _vm.backToList($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('deliveryPreferences.back'))+"\n          ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.model.id)?_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.remove($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.delete'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success save mar-rt-10",on:{"click":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"margin":"0 10px"}},[_c('div',{staticClass:"card-content"},[(_vm.formError)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.numeAdmin')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nume_admin),expression:"model.nume_admin"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('deliveryPreferences.numeAdminPlaceholder')},domProps:{"value":(_vm.model.nume_admin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nume_admin", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.name'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",class:{'is-invalid': _vm.attemptedSave && !_vm.model.name},attrs:{"type":"text"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{class:{'text-danger': _vm.attemptedSave && _vm.model.type !== 1 && _vm.model.type !== 2},staticStyle:{"display":"block"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.type')))]),_vm._v(" "),_c('p-radio',{attrs:{"label":1,"inline":true},model:{value:(_vm.model.type),callback:function ($$v) {_vm.$set(_vm.model, "type", $$v)},expression:"model.type"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.typeClassic')))]),_vm._v(" "),_c('p-radio',{attrs:{"label":2,"inline":true},model:{value:(_vm.model.type),callback:function ($$v) {_vm.$set(_vm.model, "type", $$v)},expression:"model.type"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.typeSlot')))]),_vm._v(" "),(_vm.model.type === 1)?_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-top":"6px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.typeClassicHelp')))]):_vm._e(),_vm._v(" "),(_vm.model.type === 2)?_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-top":"6px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.typeSlotHelp')))]):_vm._e(),_vm._v(" "),(_vm.attemptedSave && _vm.model.type !== 1 && _vm.model.type !== 2)?_c('small',{staticClass:"text-danger",staticStyle:{"display":"block","margin-top":"6px"}},[_vm._v(_vm._s(_vm.$t('general.required')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.enabled')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.enabled),callback:function ($$v) {_vm.$set(_vm.model, "enabled", $$v)},expression:"model.enabled"}})],1)])])]),_vm._v(" "),(_vm.model.type === 1 || _vm.model.type === 2)?_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"margin":"0 10px"}},[_c('div',{staticClass:"card-content"},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.zones')))]),_vm._v(" "),_vm._l((_vm.model.zones),function(z,index){return _c('div',{key:index,staticClass:"d-flex align-items-center",staticStyle:{"display":"flex","align-items":"center","gap":"8px","margin-bottom":"8px"}},[_c('el-select',{class:{'is-invalid': _vm.isZoneDuplicate(index) || (_vm.attemptedSave && z.delivery_range_id === null)},staticStyle:{"flex":"1","min-width":"0"},attrs:{"filterable":"","placeholder":_vm.$t('deliveryPreferences.selectZone')},model:{value:(z.delivery_range_id),callback:function ($$v) {_vm.$set(z, "delivery_range_id", $$v)},expression:"z.delivery_range_id"}},_vm._l((_vm.zones),function(zone){return _c('el-option',{key:zone.id,attrs:{"label":zone.name,"value":zone.id,"disabled":_vm.isZoneUsed(zone.id, index)}})})),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-default",staticStyle:{"width":"35px","height":"35px","padding":"0","flex-shrink":"0"},attrs:{"disabled":index === 0},on:{"click":function($event){$event.preventDefault();_vm.moveZone(index, -1)}}},[_c('i',{staticClass:"ti-arrow-up"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-default",staticStyle:{"width":"35px","height":"35px","padding":"0","flex-shrink":"0"},attrs:{"disabled":index === _vm.model.zones.length - 1},on:{"click":function($event){$event.preventDefault();_vm.moveZone(index, 1)}}},[_c('i',{staticClass:"ti-arrow-down"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",staticStyle:{"width":"35px","height":"35px","padding":"0","flex-shrink":"0"},attrs:{"disabled":_vm.model.zones.length <= 1},on:{"click":function($event){$event.preventDefault();_vm.removeZone(index)}}},[_c('i',{staticClass:"ti-close"})])],1)}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-primary",on:{"click":function($event){$event.preventDefault();return _vm.addZone($event)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('deliveryPreferences.selectZone')))])],2)])]):_vm._e(),_vm._v(" "),(_vm.model.type === 1)?_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"margin":"15px 10px 0"}},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.typeClassic')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.isAlwaysOpen')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_always_open),callback:function ($$v) {_vm.$set(_vm.model, "is_always_open", $$v)},expression:"model.is_always_open"}})],1),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.availableDays')))]),_vm._v(" "),_c('div',{staticClass:"changeDeliveryDisponibility"},[_c('div',[_c('p-radio',{attrs:{"label":1,"inline":true},model:{value:(_vm.model.hour_mode),callback:function ($$v) {_vm.$set(_vm.model, "hour_mode", $$v)},expression:"model.hour_mode"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.hourModeHourDate')))]),_vm._v(" "),_c('p-radio',{attrs:{"label":2,"inline":true},model:{value:(_vm.model.hour_mode),callback:function ($$v) {_vm.$set(_vm.model, "hour_mode", $$v)},expression:"model.hour_mode"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.hourModeDateOnly')))]),_vm._v(" "),_c('p-radio',{attrs:{"label":3,"inline":true},model:{value:(_vm.model.hour_mode),callback:function ($$v) {_vm.$set(_vm.model, "hour_mode", $$v)},expression:"model.hour_mode"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.hourModeDisabled')))])],1),_vm._v(" "),(_vm.model.hour_mode === 1)?_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-top":"6px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.hourModeHourDateHelp')))]):_vm._e(),_vm._v(" "),(_vm.model.hour_mode === 2)?_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-top":"6px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.hourModeDateOnlyHelp')))]):_vm._e(),_vm._v(" "),(_vm.model.hour_mode === 3)?_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-top":"6px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.hourModeDisabledHelp')))]):_vm._e(),_vm._v(" "),_c('hr')]),_vm._v(" "),(_vm.model.hour_mode !== 3)?[_c('label',{staticStyle:{"margin-bottom":"12px","margin-right":"10px"},attrs:{"for":""}},[_vm._v("\n                "+_vm._s(_vm.$t('settingsOrdering.offset'))+"\n                "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.offset),expression:"model.offset",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","disabled":_vm.model.is_always_open},domProps:{"value":(_vm.model.offset)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "offset", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                "+_vm._s(_vm.$t('settingsOrdering.period'))+"\n                "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.period),expression:"model.period",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","disabled":_vm.model.is_always_open},domProps:{"value":(_vm.model.period)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "period", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-bottom":"12px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.offsetPeriodHelp')))])]:_vm._e(),_vm._v(" "),(_vm.model.hour_mode !== 3)?_vm._l((_vm.model.available_days),function(day,dayIdx){return _c('div',{key:day.day,staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-3 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","id":'cd_' + day.day,"disabled":_vm.model.is_always_open},domProps:{"checked":Array.isArray(day.open)?_vm._i(day.open,null)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":'cd_' + day.day}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + day.day))))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                    from\n                    "),_c('el-time-select',{class:{'is-invalid': _vm.attemptedSave && day.open && !_vm.model.is_always_open && _vm.timePairInvalid(day.open_from, day.open_to)},attrs:{"disabled":!day.open || _vm.model.is_always_open,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(day.open_from),callback:function ($$v) {_vm.$set(day, "open_from", $$v)},expression:"day.open_from"}}),_vm._v("\n                    to\n                    "),_c('el-time-select',{class:{'is-invalid': _vm.attemptedSave && day.open && !_vm.model.is_always_open && _vm.timePairInvalid(day.open_from, day.open_to)},attrs:{"disabled":!day.open || _vm.model.is_always_open,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(day.open_to),callback:function ($$v) {_vm.$set(day, "open_to", $$v)},expression:"day.open_to"}})],1)]),_vm._v(" "),(day.intervals)?_c('div',{staticClass:"row intervals"},[_vm._l((day.intervals),function(interval,intervalKey){return [_c('div',{staticClass:"col-md-3 padd in-inline-160"}),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd",staticStyle:{"margin-bottom":"12px"}},[_vm._v("\n                      from\n                      "),_c('el-time-select',{class:{'is-invalid': _vm.attemptedSave && day.open && !_vm.model.is_always_open && _vm.timePairInvalid(interval.open_from, interval.open_to)},attrs:{"disabled":!day.open || _vm.model.is_always_open,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(interval.open_from),callback:function ($$v) {_vm.$set(interval, "open_from", $$v)},expression:"interval.open_from"}}),_vm._v("\n                      to\n                      "),_c('el-time-select',{class:{'is-invalid': _vm.attemptedSave && day.open && !_vm.model.is_always_open && _vm.timePairInvalid(interval.open_from, interval.open_to)},attrs:{"disabled":!day.open || _vm.model.is_always_open,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(interval.open_to),callback:function ($$v) {_vm.$set(interval, "open_to", $$v)},expression:"interval.open_to"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",staticStyle:{"width":"35px","height":"35px","padding":"0","margin-left":"8px"},attrs:{"disabled":_vm.model.is_always_open},on:{"click":function($event){$event.preventDefault();_vm.deleteClassicInterval(intervalKey, dayIdx)}}},[_c('i',{staticClass:"ti-close"})])],1)]})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn add",attrs:{"disabled":_vm.model.is_always_open,"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addClassicInterval(dayIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+"\n                ")])])])}):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.minimumOrderValue')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.minimum_order_value),expression:"model.minimum_order_value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","step":"0.01","min":"0"},domProps:{"value":(_vm.model.minimum_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "minimum_order_value", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.defaultWaitingTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.default_waiting_time),expression:"model.default_waiting_time",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","step":"1","min":"0"},domProps:{"value":(_vm.model.default_waiting_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "default_waiting_time", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.noPreorders')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.no_preorders),callback:function ($$v) {_vm.$set(_vm.model, "no_preorders", $$v)},expression:"model.no_preorders"}})],1)],2)])]):_vm._e(),_vm._v(" "),(_vm.model.type === 2)?_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"margin":"15px 10px 0"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group",staticStyle:{"max-width":"320px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.delayHours')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.delay_hours),expression:"model.delay_hours",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","step":"1","min":"0"},domProps:{"value":(_vm.model.delay_hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "delay_hours", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.delayHoursHelp')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.autoAssignFirstSlot')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.auto_assign_first_slot),callback:function ($$v) {_vm.$set(_vm.model, "auto_assign_first_slot", $$v)},expression:"model.auto_assign_first_slot"}})],1),_vm._v(" "),(!_vm.model.auto_assign_first_slot)?[_c('label',{staticStyle:{"margin-bottom":"12px","margin-right":"10px"},attrs:{"for":""}},[_vm._v("\n                "+_vm._s(_vm.$t('settingsOrdering.offset'))+"\n                "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.offset),expression:"model.offset",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.model.offset)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "offset", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                "+_vm._s(_vm.$t('settingsOrdering.period'))+"\n                "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.period),expression:"model.period",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.model.period)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "period", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-bottom":"12px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.offsetPeriodHelp')))])]:_vm._e(),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.schedule')))]),_vm._v(" "),_vm._l((_vm.days),function(d){return _c('div',{key:d.key,staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-2 padd in-inline-160"},[_c('strong',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.' + d.slug)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 padd"},[_vm._l((_vm.rowsForDay(d.key)),function(row){return _c('div',{key:row._k,staticClass:"row intervals",staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('p-switch',{staticStyle:{"margin-right":"10px"},attrs:{"type":"success","title":_vm.$t('deliveryPreferences.active')},model:{value:(row.active),callback:function ($$v) {_vm.$set(row, "active", $$v)},expression:"row.active"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(row.delivery_slot_id),expression:"row.delivery_slot_id",modifiers:{"number":true}}],staticClass:"form-control",class:{'is-invalid': _vm.attemptedSave && row.active && row.delivery_slot_id === null},staticStyle:{"max-width":"200px","margin-right":"10px","padding-right":"28px","text-overflow":"ellipsis"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(row, "delivery_slot_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.selectSlot')))]),_vm._v(" "),_vm._l((_vm.slots),function(slot){return _c('option',{key:slot.id,domProps:{"value":slot.id}},[_vm._v(_vm._s(slot.nume_admin || slot.name))])})],2),_vm._v("\n                  from\n                  "),_c('el-time-select',{class:{'is-invalid': _vm.attemptedSave && row.active && _vm.timePairInvalid(row.start_time, row.end_time)},staticStyle:{"margin":"0 8px"},attrs:{"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(row.start_time),callback:function ($$v) {_vm.$set(row, "start_time", $$v)},expression:"row.start_time"}}),_vm._v("\n                  to\n                  "),_c('el-time-select',{class:{'is-invalid': _vm.attemptedSave && row.active && _vm.timePairInvalid(row.start_time, row.end_time)},staticStyle:{"margin":"0 8px"},attrs:{"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(row.end_time),callback:function ($$v) {_vm.$set(row, "end_time", $$v)},expression:"row.end_time"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",staticStyle:{"width":"35px","height":"35px","padding":"0","margin-left":"8px"},on:{"click":function($event){$event.preventDefault();_vm.removeScheduleRow(row)}}},[_c('i',{staticClass:"ti-close"})])],1)}),_vm._v(" "),(!_vm.rowsForDay(d.key).length)?_c('p',{staticClass:"text-muted",staticStyle:{"margin":"0"}},[_vm._v("—")]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-2 padd"},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addScheduleRow(d.key)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+"\n                ")])])])}),_vm._v(" "),_c('div',{staticClass:"override-block"},[_c('h5',{staticStyle:{"margin":"0 0 4px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.closedDates')))]),_vm._v(" "),_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-bottom":"14px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.closedDatesHelp')))]),_vm._v(" "),_vm._l((_vm.model.closed_dates),function(cd,index){return _c('div',{key:cd._k,staticClass:"override-card"},[_c('div',{staticClass:"override-card-head"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(cd.date),expression:"cd.date"}],staticClass:"form-control override-date",class:{'is-invalid': _vm.attemptedSave && (!cd.date || _vm.closedDateDuplicate(index))},attrs:{"type":"date"},domProps:{"value":(cd.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(cd, "date", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"override-weekday"},[_vm._v(_vm._s(_vm.weekdayLabel(cd.date)))]),_vm._v(" "),_c('div',{staticClass:"override-toggle"},[_c('button',{staticClass:"closed",class:{active: cd.all_day},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();cd.all_day = 1}}},[_c('i',{staticClass:"ti-na"}),_vm._v(" "+_vm._s(_vm.$t('deliveryPreferences.closedAllDay'))+"\n                    ")]),_vm._v(" "),_c('button',{staticClass:"partial",class:{active: !cd.all_day},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.setOverrideSchedule(cd)}}},[_c('i',{staticClass:"ti-calendar"}),_vm._v(" "+_vm._s(_vm.$t('deliveryPreferences.closedOverrideSchedule'))+"\n                    ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger override-remove",on:{"click":function($event){$event.preventDefault();_vm.removeClosedDate(index)}}},[_c('i',{staticClass:"ti-close"})])]),_vm._v(" "),_c('div',{staticClass:"override-card-body"},[(cd.all_day)?_c('span',{staticClass:"text-muted override-none"},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.closedNoDelivery')))]):[_vm._l((cd.schedules),function(row){return _c('div',{key:row._k,staticClass:"row intervals",staticStyle:{"display":"flex","align-items":"center","margin":"0 0 10px"}},[_c('p-switch',{staticStyle:{"margin-right":"10px"},attrs:{"type":"success","title":_vm.$t('deliveryPreferences.active')},model:{value:(row.active),callback:function ($$v) {_vm.$set(row, "active", $$v)},expression:"row.active"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(row.delivery_slot_id),expression:"row.delivery_slot_id",modifiers:{"number":true}}],staticClass:"form-control",class:{'is-invalid': _vm.attemptedSave && row.active && row.delivery_slot_id === null},staticStyle:{"max-width":"200px","margin-right":"10px","padding-right":"28px","text-overflow":"ellipsis"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(row, "delivery_slot_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.selectSlot')))]),_vm._v(" "),_vm._l((_vm.slots),function(slot){return _c('option',{key:slot.id,domProps:{"value":slot.id}},[_vm._v(_vm._s(slot.nume_admin || slot.name))])})],2),_vm._v("\n                      from\n                      "),_c('el-time-select',{class:{'is-invalid': _vm.attemptedSave && row.active && _vm.timePairInvalid(row.start_time, row.end_time)},staticStyle:{"margin":"0 8px"},attrs:{"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(row.start_time),callback:function ($$v) {_vm.$set(row, "start_time", $$v)},expression:"row.start_time"}}),_vm._v("\n                      to\n                      "),_c('el-time-select',{class:{'is-invalid': _vm.attemptedSave && row.active && _vm.timePairInvalid(row.start_time, row.end_time)},staticStyle:{"margin":"0 8px"},attrs:{"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(row.end_time),callback:function ($$v) {_vm.$set(row, "end_time", $$v)},expression:"row.end_time"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",staticStyle:{"width":"35px","height":"35px","padding":"0","margin-left":"8px"},on:{"click":function($event){$event.preventDefault();_vm.removeOverrideRow(cd, row)}}},[_c('i',{staticClass:"ti-close"})])],1)}),_vm._v(" "),(!cd.schedules.length)?_c('p',{staticClass:"text-muted",class:{'text-danger': _vm.attemptedSave},staticStyle:{"margin":"0 0 10px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.closedScheduleEmpty')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"override-actions"},[_c('button',{staticClass:"btn add",on:{"click":function($event){$event.preventDefault();_vm.addOverrideRow(cd)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+"\n                      ")]),_vm._v(" "),(cd.date)?_c('button',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){$event.preventDefault();_vm.copyWeeklyInto(cd, true)}}},[_c('i',{staticClass:"ti-files"}),_vm._v(" "+_vm._s(_vm.$t('deliveryPreferences.closedCopyWeekly', { day: _vm.weekdayLabel(cd.date) }))+"\n                      ")]):_vm._e()])]],2)])}),_vm._v(" "),(!_vm.model.closed_dates.length)?_c('p',{staticClass:"text-muted",staticStyle:{"margin":"0 0 12px"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.closedEmpty')))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn add",staticStyle:{"margin-top":"12px"},on:{"click":function($event){$event.preventDefault();return _vm.addClosedDate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v(" "+_vm._s(_vm.$t('deliveryPreferences.addClosedDate'))+"\n              ")])],2)],2)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q1uJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutomationCampaignForm_vue__ = __webpack_require__("MeMx");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AutomationCampaignForm: __WEBPACK_IMPORTED_MODULE_0__AutomationCampaignForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "Q7tW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscriptionForm_vue__ = __webpack_require__("pvLU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5663178_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscriptionForm_vue__ = __webpack_require__("oMhr");
function injectStyle (ssrContext) {
  __webpack_require__("drZW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscriptionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5663178_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscriptionForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q9x8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CampaignForm_vue__ = __webpack_require__("tLlR");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CampaignForm', __WEBPACK_IMPORTED_MODULE_7__CampaignForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      campaignModel: {},
      campaign: {},
      modelValidations: {
        required: true
      }
    };
  },

  methods: {
    onCampaignSubmit: function onCampaignSubmit(model, isValid) {
      this.campaignModel = model;
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "QAyF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charisma-location-receipt-details"},[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.charismaLocationReceipt')}}),_vm._v(" "),_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('div',[_c('p',{staticClass:"d-inline-flex"},[_c('a',{staticClass:"btn btn-orange back",on:{"click":function($event){$event.preventDefault();return _vm.goBackToReport($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('general.back'))+"\n          ")])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","disabled":!_vm.zReports || _vm.zReports.length === 0,"title":_vm.$t('reports.sendReceipts')},on:{"click":function($event){$event.preventDefault();return _vm.sendFiscalZReports($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('reports.sendReceipts'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-content filters-card"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('charisma.location')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","disabled":"","placeholder":_vm.$t('general.select')},model:{value:(_vm.filters.locationId),callback:function ($$v) {_vm.$set(_vm.filters, "locationId", $$v)},expression:"filters.locationId"}},_vm._l((_vm.locations),function(location){return _c('el-option',{key:location.id,attrs:{"label":location.name,"value":location.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('charisma.posIds')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","filterable":"","clearable":"","disabled":"","placeholder":_vm.$t('general.select')},model:{value:(_vm.filters.posIds),callback:function ($$v) {_vm.$set(_vm.filters, "posIds", $$v)},expression:"filters.posIds"}},_vm._l((_vm.posOptions),function(pos){return _c('el-option',{key:pos.value,attrs:{"label":pos.label,"value":pos.value}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('charisma.partnerCode')))]),_vm._v(" "),_c('el-input',{attrs:{"disabled":"","placeholder":_vm.$t('charisma.partnerCode')},model:{value:(_vm.filters.partnerCode),callback:function ($$v) {_vm.$set(_vm.filters, "partnerCode", $$v)},expression:"filters.partnerCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('charisma.categoryAdministration')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","disabled":"","placeholder":_vm.$t('general.select')},model:{value:(_vm.filters.administrationId),callback:function ($$v) {_vm.$set(_vm.filters, "administrationId", $$v)},expression:"filters.administrationId"}},_vm._l((_vm.administrations),function(admin){return _c('el-option',{key:admin.id,attrs:{"label":admin.name,"value":admin.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('charisma.itemId')))]),_vm._v(" "),_c('el-input',{attrs:{"disabled":"","placeholder":_vm.$t('charisma.itemId')},model:{value:(_vm.filters.itemId),callback:function ($$v) {_vm.$set(_vm.filters, "itemId", $$v)},expression:"filters.itemId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('charisma.tipsItemId')))]),_vm._v(" "),_c('el-input',{attrs:{"disabled":"","placeholder":_vm.$t('charisma.tipsItemId')},model:{value:(_vm.filters.tipsItemId),callback:function ($$v) {_vm.$set(_vm.filters, "tipsItemId", $$v)},expression:"filters.tipsItemId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1),_c('p',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n              "+_vm._s(_vm.$t('general.from'))+"\n              "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"change":_vm.changeValidFrom(),"picker-options":{
                  start: '00:00',
                  step: '00:10',
                  end: '24:00'
                }},model:{value:(_vm.data_from_time),callback:function ($$v) {_vm.data_from_time=$$v},expression:"data_from_time"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.to'))+"\n              "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"change":_vm.changeValidFrom(),"picker-options":{
                  start: '00:00',
                  step: '00:10',
                  end: '24:00'
                }},model:{value:(_vm.data_to_time),callback:function ($$v) {_vm.data_to_time=$$v},expression:"data_to_time"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('p')])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.zReports,"total":_vm.totalZReports,"pagination-props":_vm.paginationProps,"empty-text":_vm.$t('reports.noDataAvailable')},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('fiscalZ.id'),"min-width":"60"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"z_number","label":_vm.$t('fiscalZ.zNumber'),"min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.z_number || '-')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"z_timestamp","label":_vm.$t('fiscalZ.zTimestamp'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatDate(scope.row.z_timestamp))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales_a","label":_vm.$t('fiscalZ.totalSalesA'),"min-width":"135"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_sales_a))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales_b","label":_vm.$t('fiscalZ.totalSalesB'),"min-width":"135"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_sales_b))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales_c","label":_vm.$t('fiscalZ.totalSalesC'),"min-width":"135"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_sales_c))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales_d","label":_vm.$t('fiscalZ.totalSalesD'),"min-width":"135"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_sales_d))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales_e","label":_vm.$t('fiscalZ.totalSalesE'),"min-width":"135"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_sales_e))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_other_taxes","label":_vm.$t('fiscalZ.totalOtherTaxes'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_other_taxes))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_exempt","label":_vm.$t('fiscalZ.totalVatExempt'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_vat_exempt))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_sales","label":_vm.$t('fiscalZ.totalSales'),"min-width":"125"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_sales))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_a","label":_vm.$t('fiscalZ.totalVatA'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_vat_a))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_b","label":_vm.$t('fiscalZ.totalVatB'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_vat_b))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_c","label":_vm.$t('fiscalZ.totalVatC'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_vat_c))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_d","label":_vm.$t('fiscalZ.totalVatD'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_vat_d))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat_e","label":_vm.$t('fiscalZ.totalVatE'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_vat_e))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_vat","label":_vm.$t('fiscalZ.totalVat'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(_vm.formatMoney(scope.row.total_vat))+"\n          ")]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v(_vm._s(_vm.$t('charisma.dataTo')))]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":10,"readonly":"","placeholder":_vm.$t('charisma.dataTo')},model:{value:(_vm.dataToTextarea),callback:function ($$v) {_vm.dataToTextarea=$$v},expression:"dataToTextarea"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v(_vm._s(_vm.$t('charisma.dataFrom')))]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":10,"readonly":"","placeholder":_vm.$t('charisma.dataFrom')},model:{value:(_vm.dataFromTextarea),callback:function ($$v) {_vm.dataFromTextarea=$$v},expression:"dataFromTextarea"}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QDmZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtPaymentHistory_vue__ = __webpack_require__("KdvI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90780b66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtPaymentHistory_vue__ = __webpack_require__("ICL7");
function injectStyle (ssrContext) {
  __webpack_require__("+nbN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90780b66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BtPaymentHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90780b66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BtPaymentHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QGSD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons "},[_c('div',{staticClass:"left-buttons mar-rt-10"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[(_vm.groupedLocations)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.categoria')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategory),expression:"selectedCategory"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.categories),function(category){return _c('option',{key:category.value,domProps:{"value":category.value}},[_vm._v("\n              "+_vm._s(category.label)+"\n            ")])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Produs")]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Caută produsul...","filterable":"","remote":"","clearable":"","remote-method":_vm.fetchProducts,"loading":_vm.loadingProducts,"disabled":_vm.loading},on:{"change":_vm.handleProductSelect,"clear":_vm.handleClearProduct},model:{value:(_vm.selectedProduct),callback:function ($$v) {_vm.selectedProduct=$$v},expression:"selectedProduct"}},_vm._l((_vm.searchProdResults),function(product){return _c('el-option',{key:product._id,attrs:{"label":product.name,"value":product._id}},[[_vm._v("\n              "+_vm._s(product.name)+"\n              "),(product.categorie)?_c('span',{class:_vm.getCategoryClass(product.categorie),staticStyle:{"margin-left":"6px","padding":"2px 6px","border-radius":"50px","color":"white","font-size":"11px"}},[_vm._v("\n                "+_vm._s(product.categorie)+"\n              ")]):_vm._e()]],2)}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date și oră")]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"disabled":_vm.loading || !_vm.selectedGestiune,"placeholder":"Selectează intervalul"},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.triggerFilter}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])])]),_vm._v(" "),_c('div',{staticClass:"card",staticStyle:{"background":"#fff","border":"none"}},[_c('div',{staticClass:"card-content",staticStyle:{"display":"flex","align-items":"center","padding":"0px 5px"}},[_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.fetchInventoryReport('xls')}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"tableInvoice",staticStyle:{"overflow-x":"auto"}},[_c('el-table',{staticStyle:{"min-width":"max-content"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"prop":"denumire","label":"Denumire","min-width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"categorie","label":"Categorie","min-width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"um","label":"UM","min-width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"deschidere","label":"Stoc Inițial","min-width":"120","formatter":function (row) { return Number(row.deschidere).toFixed(2); }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"intrare","label":"Intrări/Livrări","min-width":"120","formatter":function (row) { return Number(row.intrare).toFixed(2); }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"transfer","label":"Transfer","min-width":"100","formatter":function (row) { return Number(row.transfer).toFixed(2); }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"pierderiMaterii","label":"Pierderi Materii Prime","min-width":"200","formatter":function (row) { return Number(row.pierderiMaterii).toFixed(2); }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"pierderiProduse","label":"Pierderi Produse Finite","min-width":"200","formatter":function (row) { return Number(row.pierderiProduse).toFixed(2); }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"pauzaMasa","label":"Consum Angajați","min-width":"170","formatter":function (row) { return Number(row.pauzaMasa).toFixed(2); }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vandute","label":"Cant. Produse Vandute","min-width":"200","formatter":function (row) { return Number(row.vandute).toFixed(2); }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"trebuie","label":"Stoc Estimat","min-width":"120","formatter":function (row) { return Number(row.trebuie).toFixed(2); }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"inventar","label":"Inventar","min-width":"120","formatter":function (row) { return row.inventar !== null ? Number(row.inventar).toFixed(2) : ''; }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"inchidere","label":"Stoc Final","min-width":"120","formatter":function (row) { return Number(row.inchidere).toFixed(2); }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"diferenteCant","label":"Diferență Cantitate","min-width":"170","formatter":function (row) { return row.diferenteCant !== null ? Number(row.diferenteCant).toFixed(2) : ''; }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"diferenteVal","label":"Diferență Valoare","min-width":"170","formatter":function (row) { return row.diferenteVal !== null ? Number(row.diferenteVal).toFixed(2) : ''; }}})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QHzq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasurementsUnitsForm_vue__ = __webpack_require__("n7pR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a751f7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasurementsUnitsForm_vue__ = __webpack_require__("xt4N");
function injectStyle (ssrContext) {
  __webpack_require__("BtN9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasurementsUnitsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a751f7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasurementsUnitsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QJH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      tableData: [{
        type: 'Materie Prima',
        name: 'Exemplu 1',
        unitPrice: 100,
        inStock: '100 / 50 Buc'
      }],
      searchQuery: '',
      filterForm: {
        provider: '',
        tag: '',
        quantity: ''
      }
    };
  },

  methods: {}
});

/***/ }),

/***/ "QJOo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__countries__ = __webpack_require__("KLaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2__);















var _components;







__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.loyalty_usage = this.$session.get('selectedCompanyData').loyalty_in_use;
    this.loyalty_value_one_currency = this.$session.get('selectedCompanyData').loyalty_value_one_currency;
    this.loyalty_value_one_point = this.$session.get('selectedCompanyData').loyalty_value_one_point;
    this.loyalty_value_one_point_amount = parseFloat(this.$session.get('selectedCompanyData').loyalty_value_one_point_amount).toFixed(2);
    if (this.$session.get('userDataRole') === 'MARKETER') {
      this.is_marketer = true;
    }
    this.getData();
    this.getPaymentMethods();
    this.getActiveSubscriptions();
  },
  data: function data() {
    return {
      loading: true,
      loyalty_value_one_currency: null,
      loyalty_value_one_point: null,
      loyalty_value_one_point_amount: null,
      is_marketer: false,
      customer: [],

      activeSubscriptions: [],
      newPoints: {
        points_earned: null,
        money_spent: null,
        comments: null
      },
      countries: __WEBPACK_IMPORTED_MODULE_16__countries__["a" /* default */],
      currency: '',
      modelValidations: {
        required: {
          required: true
        }
      },
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      loyalty_usage: null,
      searchDate: null,
      paymentMethods: null,
      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            var start = new Date();
            start.setDate(end.getDate() - 6);
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            var start = new Date();
            start.setDate(end.getDate() - 29);
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      },
      selectedPaymentMethod: null,
      walletTransactions: [],
      paginationDef2: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      }
    };
  },

  methods: {
    getActiveSubscriptions: function getActiveSubscriptions() {
      var _this = this;

      if (!this.route.params || !this.route.params.id) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        user_id: this.route.params.id,
        per_page: 100
      };
      this.apiRequest('/subscription/subscribers', 'GET', data, function (response) {
        if (response.status === true && response.data) {
          var current = ['active', 'expiring', 'unpaid', 'pending'];
          _this.activeSubscriptions = (response.data.items || []).filter(function (item) {
            return current.indexOf(item.state) !== -1;
          });
        }
      });
    },
    getData: function getData() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var currency = this.getCompanyDetail('currency');
      this.currency = this.getCurrencySymbol(currency);
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.searchDate && this.searchDate.length === 2) {
        data.date_from = this.searchDate[0];
        data.date_to = this.searchDate[1];
      }

      if (this.selectedPaymentMethod && this.selectedPaymentMethod.length > 0) {
        data.payment_type = this.selectedPaymentMethod;
      }

      var self = this;

      if (self.route.params.id) {
        var id = self.route.params.id;
        self.apiRequest('/customer/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            var goodOrders = [];
            for (var idx in response.data[0].orders) {
              if (response.data[0].orders[idx]['status'].id !== 'DRAFT') {
                goodOrders.push(response.data[0].orders[idx]);
              }
            }
            response.data[0].orders = goodOrders;
            self.customer = response.data[0];
            self.customer.allow_virament = !!self.customer.allow_virament;

            self.getWaletData();

            self.$nextTick(function () {
              self.loading = false;
            });
          }
        });
      }
    },
    getWaletData: function getWaletData() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        user_id: this.route.params.id,
        page: page,
        per_page: this.paginationDef2.pageSize
      };

      this.apiRequest('/reports/get-user-wallet-transactions', 'GET', data, function (response) {
        _this2.walletTransactions = response.data.wallet_transactions.data;
        _this2.paginationDef2.currentPage = response.data.wallet_transactions.current_page;
        _this2.paginationDef2.total = response.data.wallet_transactions.total;
      });
    },
    walletTypeLabel: function walletTypeLabel(row) {
      if (row.type === 1) {
        return 'Minus (Order ' + row.order_id + ')';
      }

      if (row.type === 2) {
        return 'Gift Card (' + row.gift_card_id + ')';
      }

      return '-';
    },
    addPoints: function addPoints() {
      var self = this;
      if (!this.newPoints.money_spent || !this.newPoints.comments) {
        __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.validPoinsNo'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      } else {
        var id = this.route.params.id;
        var data = {
          user_id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          money_spent: this.newPoints.money_spent,
          comments: this.newPoints.comments,
          money_spent_confirm: 1,
          send_notifications: 0
        };

        __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
          type: 'question',
          text: self.$t('customers.clientNotification'),
          position: 'top-end',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes'),
          cancelButtonText: self.$t('general.no')
        }).then(function (result) {
          if (result) {
            data.send_notifications = 1;
            self.apiRequest('/loyalty-points', 'POST', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', response.data.message, 'success');
                self.customer.loyalty_points = parseInt(response.data.loyalty_points);
                self.newPoints.money_spent = null;
                self.newPoints.points_earned = null;
                self.newPoints.comments = null;
              } else {
                __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', response.errors.company_id !== undefined ? response.errors.company_id : self.$t('customers.points'), 'error');
              }
            });
          }
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            self.apiRequest('/loyalty-points', 'POST', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', response.data.message, 'success');
                self.customer.loyalty_points = parseInt(response.data.loyalty_points);
                self.newPoints.money_spent = null;
                self.newPoints.points_earned = null;
                self.newPoints.comments = null;
              } else {
                __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', response.errors.company_id !== undefined ? response.errors.company_id : self.$t('customers.points'), 'error');
              }
            });
          }
        });
      }
    },
    goToRecord: function goToRecord(row, event, column) {
      this.backButton();
      this.globalGoToRecord(row, event, column, '/orders/view/');
    },
    getPaymentMethods: function getPaymentMethods() {
      var _this3 = this;

      var sessionData = this.$session.get('selectedCompanyData');

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };

        this.apiRequest('/orders/get-payment-methods', 'GET', data, function (response) {
          if (response.status && response.data.length) {
            var result = response.data.map(function (item) {
              return { id: item || 'unpaid', name: _this3.$t('paymentTypes.' + item) };
            });
            sessionData['payment_methods'] = response.data;
            _this3.$session.set('selectedCompanyData', sessionData);

            __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(_this3, 'paymentMethods', result);
          }
        });
      } else {
        var result = sessionData['payment_methods'].map(function (item) {
          return { id: item || 'unpaid', name: _this3.$t('paymentTypes.' + item) };
        });
        __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(this, 'paymentMethods', result);
      }
    },
    addComment: function addComment() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        comment: this.customer.comment
      };
      var self = this;
      if (self.route.params.id) {
        var id = self.route.params.id;
        self.apiRequest('/add-customer-comment/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
              toast: true,
              type: 'success',
              text: self.$t('customers.newCommentAdded'),
              showConfirmButton: false,
              timer: 2000
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', response.errors.id !== undefined ? response.errors.id : 'error', 'error');
          }
          self.$nextTick(function () {
            self.loading = false;
          });
        });
      }
    },
    saveSettings: function saveSettings() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        allow_virament: this.customer.allow_virament
      };
      var self = this;
      if (self.route.params.id) {
        var id = self.route.params.id;
        self.apiRequest('/customer-update/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
              toast: true,
              type: 'success',
              text: self.$t('customers.newCommentAdded'),
              showConfirmButton: false,
              timer: 2000
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', response.errors.id !== undefined ? response.errors.id : 'error', 'error');
          }
          self.$nextTick(function () {
            self.loading = false;
          });
        });
      }
    },
    calcPoints: function calcPoints($part) {
      if (this.loyalty_value_one_currency) {
        if ($part === 1) {
          this.newPoints.points_earned = (this.newPoints.money_spent * this.loyalty_value_one_currency).toFixed(2);
        } else {
          this.newPoints.money_spent = (this.newPoints.points_earned / this.loyalty_value_one_currency).toFixed(2);
        }
      }
    },
    removeLocation: function removeLocation(locationId) {
      var _this4 = this;

      var id = this.route.params.id;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_id: locationId,
        user_id: id
      };
      this.apiRequest('/remove-auth-location/', 'POST', data, function (response) {
        if (response.status === true) {
          _this4.getData();
        }
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "QObC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('offers-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onOfferSubmit}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QOjv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QRcy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiscalPrinterForm_vue__ = __webpack_require__("Umb1");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'FiscalPrinterForm', __WEBPACK_IMPORTED_MODULE_7__FiscalPrinterForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "QSgq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fidelities_vue__ = __webpack_require__("8vED");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c17676bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fidelities_vue__ = __webpack_require__("ZoNs");
function injectStyle (ssrContext) {
  __webpack_require__("H+Bc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c17676bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fidelities_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c17676bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fidelities_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QTC9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t4_vue__ = __webpack_require__("72u/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e70926_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t4_vue__ = __webpack_require__("HZcq");
function injectStyle (ssrContext) {
  __webpack_require__("kDXO")
  __webpack_require__("8tZ+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35e70926"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e70926_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QTMt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BalanceReport_vue__ = __webpack_require__("fPtS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa2795c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BalanceReport_vue__ = __webpack_require__("82KJ");
function injectStyle (ssrContext) {
  __webpack_require__("n4qE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fa2795c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BalanceReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa2795c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BalanceReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QUE/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentGroupsEdit_vue__ = __webpack_require__("r9jT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12202d76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentGroupsEdit_vue__ = __webpack_require__("c8N3");
function injectStyle (ssrContext) {
  __webpack_require__("YJQT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentGroupsEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12202d76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentGroupsEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QUHT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 244.8 264.8"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 244.8 264.8","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t1_SVGID_1_","x":"65.7","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t1_SVGID_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t1_SVGID_1_"}})]),_vm._v(" "),_c('g',{staticClass:"s1t0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t1_SVGID_3_","d":"M74.7,0h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H74.7\n            c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4S72.3,0,74.7,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t1_SVGID_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t1_SVGID_3_"}})]),_vm._v(" "),_c('g',{staticClass:"s1t1"},[_c('path',{staticClass:"s1t2",attrs:{"d":"M65.7,0h113.4v113.4H65.7V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t1_SVGID_5_","x":"65.7","y":"151.4","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t1_SVGID_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t1_SVGID_5_"}})]),_vm._v(" "),_c('g',{staticClass:"s1t3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t1_SVGID_7_","d":"M74.7,151.4h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6\n            H74.7c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4C70,152.4,72.3,151.4,74.7,151.4z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t1_SVGID_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t1_SVGID_7_"}})]),_vm._v(" "),_c('g',{staticClass:"s1t4"},[_c('path',{staticClass:"s1t2",attrs:{"d":"M65.7,151.4h113.4v113.4H65.7V151.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t1_SVGID_9_","y":"20","width":"244.8","height":"244.8"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t1_SVGID_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t1_SVGID_9_"}})]),_vm._v(" "),_c('g',{staticClass:"s1t5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t1_SVGID_11_","d":"M23,20h198.8c12.7,0,23,10.3,23,23v198.8c0,12.7-10.3,23-23,23H23c-12.7,0-23-10.3-23-23V43\n            C0,30.3,10.3,20,23,20z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t1_SVGID_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t1_SVGID_11_"}})]),_vm._v(" "),_c('g',{staticClass:"s1t6"},[_c('path',{staticClass:"s1t7",attrs:{"d":"M0,20h244.8v244.8H0V20z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t1_SVGID_13_","x":"29.3","y":"49.3","width":"186.3","height":"186.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t1_SVGID_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t1_SVGID_13_"}})]),_vm._v(" "),_c('g',{staticClass:"s1t8"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"t1_SVGID_15_","cx":"122.4","cy":"142.4","r":"93.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t1_SVGID_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t1_SVGID_15_"}})]),_vm._v(" "),_c('g',{staticClass:"s1t9"},[_c('path',{staticClass:"s1t2",attrs:{"d":"M29.3,49.3h186.3v186.3H29.3V49.3z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QZLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementWastedForm_vue__ = __webpack_require__("5h+L");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneStocuriForm', __WEBPACK_IMPORTED_MODULE_7__ManagementWastedForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "QaDr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('custom-info-page-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qafa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementBonProductForm_vue__ = __webpack_require__("P0Ic");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneBonProductForm', __WEBPACK_IMPORTED_MODULE_7__ManagementBonProductForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "Qbyg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs",attrs:{"direction":"vertical","value":"Description"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.pushCampaigns')}},[_c('keep-alive',[(_vm.isCampaigns && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"📢","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isCampaigns && _vm.company.use_marketing_standard)?_c('campaigns',{attrs:{"isCampaigns":_vm.isCampaigns}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.coupons')}},[_c('keep-alive',[(_vm.isCoupons && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"🎟️","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isCoupons && _vm.company.use_marketing_standard)?_c('discount-coupons'):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.subscriptions')}},[_c('keep-alive',[(_vm.isSubscriptions && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"🎫","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isSubscriptions && _vm.company.use_marketing_standard)?_c('subscriptions'):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.menuSubscriptions')}},[_c('keep-alive',[(_vm.isMenuSubscriptions && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"🍱","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isMenuSubscriptions && _vm.company.use_marketing_standard)?_c('menu-subscriptions'):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.automationMarketing')}},[_c('keep-alive',[(_vm.isAutomation && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"🤖","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isAutomation && _vm.company.use_marketing_standard)?_c('automation-campaigns'):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.donationCampaigns')}},[(_vm.isDonationCampaigns)?_c('donation-campaigns',{attrs:{"isDonationCampaigns":_vm.isDonationCampaigns}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.discountCampaigns')}},[_c('keep-alive',[(_vm.isDiscountCampaigns && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"🏷️","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isDiscountCampaigns && _vm.company.use_marketing_standard)?_c('discount-campaigns',{attrs:{"isDiscountCampaigns":_vm.isDiscountCampaigns}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.challengeCampaigns')}},[(_vm.isChallengeCampaigns)?_c('challenge-campaigns',{attrs:{"isChallengeCampaigns":_vm.isChallengeCampaigns}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.spinningWheelCampaigns')}},[(_vm.isSpinningWheelCampaigns)?_c('spinning-wheel-campaigns',{attrs:{"isSpinningWheelCampaigns":_vm.isSpinningWheelCampaigns}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.referralCampaigns')}},[(_vm.isReferralCampaigns)?_c('referral-campaigns',{attrs:{"isReferralCampaigns":_vm.isReferralCampaigns}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.raffleCampaigns')}},[(_vm.isRaffleCampaigns)?_c('raffle-campaigns',{attrs:{"isRaffleCampaigns":_vm.isRaffleCampaigns}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.loyaltyStoreCampaigns')}},[(_vm.isLoyaltyStoreCampaigns)?_c('loyalty-store-campaigns',{attrs:{"isLoyaltyStoreCampaigns":_vm.isLoyaltyStoreCampaigns}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.ambassadorRequests')}},[(_vm.isAmbassadorRequests)?_c('referral-ambassador-requests',{attrs:{"isAmbassadorRequests":_vm.isAmbassadorRequests}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.offersSlider')}},[_c('keep-alive',[(_vm.isOffersSlider && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"📢","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isOffersSlider && _vm.company.use_marketing_standard)?_c('offers',{attrs:{"isOffersSlider":_vm.isOffersSlider}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.menus')}},[_c('keep-alive',[(_vm.isMenus && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"📢","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isMenus && _vm.company.use_marketing_standard)?_c('dynamic-menu',{attrs:{"isMenus":_vm.isMenus}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('marketingFidelities.loyalityPoint')}},[_c('keep-alive',[(_vm.isLoyality && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"🎯","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isLoyality && _vm.company.use_marketing_standard)?_c('loyality',{attrs:{"isLoyality":_vm.isLoyality}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('marketingFidelities.userLabeling')}},[_c('keep-alive',[(_vm.isUserLabeling && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"🏷️","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isUserLabeling && _vm.company.use_marketing_standard)?_c('UserLabeling',{attrs:{"isUserLabeling":_vm.isUserLabeling}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.promos')}},[_c('keep-alive',[(_vm.isPromos && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"📢","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isPromos && _vm.company.use_marketing_standard)?_c('promos',{attrs:{"isPromos":_vm.isPromos}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.customersGroups')}},[_c('keep-alive',[(_vm.isCustomersGroups && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"📢","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isCustomersGroups && _vm.company.use_marketing_standard)?_c('groups-customer',{attrs:{"isCustomersGroups":_vm.isCustomersGroups}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.approvals')}},[_c('keep-alive',[(_vm.isApprovals && !_vm.company.use_marketing_standard)?_c('module-locked',{attrs:{"module":"marketing","icon":"📢","title":_vm.$t('general.modules_marketing_title'),"message":_vm.$t('general.modules_marketing_message'),"hint":_vm.$t('general.modules_marketing_hint')}}):_vm._e(),_vm._v(" "),(_vm.isApprovals && _vm.company.use_marketing_standard)?_c('approvals',{attrs:{"isApprovals":_vm.isApprovals}}):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.giftCard')}},[_c('keep-alive',[(_vm.isGiftCard && !_vm.company.use_marketing_gift_card)?_c('module-locked',{attrs:{"module":"gift_card","icon":"🎁","title":_vm.$t('general.modules_gift_card_title'),"message":_vm.$t('general.modules_gift_card_message'),"hint":_vm.$t('general.modules_gift_card_hint')}}):_vm._e(),_vm._v(" "),(_vm.isGiftCard && _vm.company.use_marketing_gift_card)?_c('gift-card'):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.scanner')}},[_c('keep-alive',[(_vm.isScanner)?_c('scanner'):_vm._e()],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QcHk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isStoc)?_c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-button"},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"1"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"type":"success"},on:{"click":function($event){_vm.addCasare()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('gestiune.addCasare'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"label":"Nr.","prop":"documentNumber","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.documentNumber)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Serie","prop":"series","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.series)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Lot","prop":"lot"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.lot)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Gestiune","prop":"gestiune_from"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(_vm.getGestiuneNameById(scope.row.gestiune_from))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                      ▾ ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editWasted(scope.row)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('gestiune.preview'))+"\n                      ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.download(scope.row)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('invoice.download'))+"\n                      ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadExcel(scope.row)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('gestiune.downloadExcel'))+"\n                      ")]),_vm._v(" "),_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},nativeOn:{"click":function($event){_vm.handleDeleteBonCasare(scope.row._id)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.delete'))+"\n                      ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QcfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VatDropdown_vue__ = __webpack_require__("zGLH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779d674d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VatDropdown_vue__ = __webpack_require__("nLoA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VatDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779d674d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VatDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QeLv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qeci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",class:{active: _vm.isActive, hidden: !_vm.isVisible},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"exact":_vm.linkExact,"tag":"li"}},[(_vm.isMenu)?_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.collapseMenu}},[_c('i',{class:'icon-menu icon-menu-' + _vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('pages.' + _vm.link.name))+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav sub-nav"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path && _vm.link.name)?_vm._t("title",[_c(_vm.elementType(_vm.link, false),{tag:"component",class:{active: _vm.link.active, hidden: _vm.childIsHidden},attrs:{"to":_vm.loc ? _vm.link.path + '?location=' + _vm.loc : _vm.link.path,"exact":_vm.linkExact,"target":_vm.link.target,"href":_vm.loc ? '/#' + _vm.link.path + '?location=' + _vm.loc : '/#' + _vm.link.path}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-mini"},[_vm._v(_vm._s(_vm.link.nameshort ? _vm.link.nameshort : _vm.link.name.substring(0, 1)))]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.$t('pages.' + _vm.link.name)))])]:[_c('i',{class:'icon-menu icon-menu-' + _vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('pages.' + _vm.link.name)))])]],2)]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qf2k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.items},on:{"row-click":_vm.handleRowClick}},[_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('newsletterCard.tableName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":_vm.$t('newsletterCard.tableDate'),"width":200}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('newsletterCard.tableDownload'),"width":200},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"dld-btn",attrs:{"size":"mini","type":"success"},on:{"click":function($event){$event.stopPropagation();_vm.handleDownload(scope.row)}}},[_vm._v(_vm._s(_vm.$t('newsletterCard.buttonDownload')))])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"active-pagination",attrs:{"current-page":_vm.pagination.currentPage,"page-size":_vm.pagination.pageSize,"total":_vm.pagination.total,"layout":"prev, pager, next, total"},on:{"update:currentPage":function($event){_vm.$set(_vm.pagination, "currentPage", $event)},"current-change":_vm.handlePageChange}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QfPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");














var _components;







__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    var _this = this;

    var sessionData = this.$session.get('selectedCompanyData');

    this.locations = sessionData.locations_details;
    this.getSections();
    this.getMaps();

    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };

    if (!sessionData['compact_pos_list'] || !sessionData['compact_pos_list'].length) {
      this.apiRequest('/pos-admin/compact-list', 'GET', data, function (response) {
        if (response.status) {
          _this.posList = response.data;
          sessionData['compact_pos_list'] = response.data;
          _this.$session.set('compact_pos_list', response.data);
        }
      });
    } else {
      this.posList = sessionData['compact_pos_list'];
    }

    var fetchPosList = function fetchPosList() {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!sessionData['compact_pos_list'] || !sessionData['compact_pos_list'].length) {
          _this.apiRequest('/pos-admin/compact-list', 'GET', data, function (response) {
            if (response.status) {
              _this.posList = response.data;
              sessionData['compact_pos_list'] = response.data;
              _this.$session.set('compact_pos_list', response.data);
              resolve();
            } else {
              resolve();
            }
          });
        } else {
          _this.posList = sessionData['compact_pos_list'];
          resolve();
        }
      });
    };

    fetchPosList().then(function () {
      if (_this.route.params.id) {
        _this.loading = true;
        _this.getData();
      }
    });
  },
  mounted: function mounted() {
    this.getSections();
  },

  watch: {
    'model.type': function modelType(val) {
      this.$validator.validate('type');
    },
    'model.location': function modelLocation(newVal, oldVal) {
      if (oldVal && newVal && oldVal.true_id !== newVal.true_id) {
        this.getMaps(true);
      } else if (newVal && (!oldVal || !oldVal.true_id)) {
        this.getMaps();
      }
    }
  },
  computed: {
    selectedType: {
      get: function get() {
        var _this2 = this;

        return this.types.find(function (t) {
          return t.id === _this2.model.type;
        }) || null;
      },
      set: function set(value) {
        var previousType = this.model.type;
        this.model.type = value ? value.id : null;
        if (previousType !== this.model.type && ![2, 3].includes(this.model.type)) {
          this.model.printer_is_usb = false;
        }
        if (previousType !== this.model.type && this.model.type === 5) {
          this.model.order_label_is_lan = false;
        }
        this.$validator.validate('type');
      }
    },
    orderLabelIsLan: {
      get: function get() {
        return !!this.model.order_label_is_lan;
      },
      set: function set(value) {
        this.model.order_label_is_lan = !!value;
      }
    },
    selectedFontSize: {
      get: function get() {
        var _this3 = this;

        return this.fontSizes.find(function (t) {
          return t.id === _this3.model.font_size;
        }) || this.fontSizes.find(function (t) {
          return t.id === '1';
        });
      },
      set: function set(value) {
        this.model.font_size = value ? value.id : '1';
      }
    }
  },
  data: function data() {
    return {
      id: this.route.params.id || null,
      model: {
        id: null,
        type: null,
        location: null,
        section: null,
        table_maps: [],
        printer_is_usb: false,
        order_label_is_lan: false,
        print_receipts: false,
        order_label_print_mode: 'grouped',
        ip: null,
        port: null,
        hide_single_option_qty: false,
        display_prices_and_totals: false
      },
      modelValidations: {
        location: {
          required: true
        },
        ip: {
          required: true
        },
        port: {
          required: true
        }
      },
      isNew: true,
      loading: true,
      locations: [],
      posList: [],
      sections: [],
      maps: [],
      printerTypes: [{ id: 1, name: 'Standard' }, { id: 2, name: 'V2' }],
      types: [{ id: 1, name: 'Port Forwarding' }, { id: 2, name: 'Local' }, { id: 3, name: 'Label Local' }, { id: 4, name: 'USB' }, { id: 5, name: 'Order Label' }],
      paymentMethods: [{ id: 'CASH', name: this.$t('paymentTypes.CASH') }, { id: 'CARD', name: this.$t('paymentTypes.CARD') }, { id: 'POS', name: this.$t('paymentTypes.POS') }, { id: 'CARD_POS', name: this.$t('paymentTypes.CARD_POS') }, { id: 'CASH_MACHINE', name: this.$t('paymentTypes.CASH_MACHINE') }, { id: 'POS_KIOSK', name: this.$t('paymentTypes.POS_KIOSK') }, { id: 'VIVA_INTENT', name: this.$t('paymentTypes.VIVA_INTENT') }, { id: 'VIRAMENT', name: this.$t('paymentTypes.VIRAMENT') }, { id: 'SPLIT', name: this.$t('paymentTypes.SPLIT') }, { id: 'ROOM', name: this.$t('paymentTypes.ROOM') }, { id: 'EVENT', name: this.$t('paymentTypes.EVENT') }, { id: 'PROTOCOL', name: this.$t('paymentTypes.PROTOCOL') }, { id: 'MANCARE_PERSONAL', name: this.$t('paymentTypes.MANCARE_PERSONAL') }, { id: 'GLOVO', name: this.$t('paymentTypes.GLOVO') }, { id: 'BOLT', name: this.$t('paymentTypes.BOLT') }, { id: 'WOLT', name: this.$t('paymentTypes.WOLT') }],
      fontSizes: [{ id: 1, name: this.$t('general.normal') }, { id: 2, name: this.$t('general.big') }]
    };
  },

  methods: {
    getData: function getData() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/printer/' + this.id, 'GET', data, function (response) {
        if (response.status) {
          _this4.model = response.data;
          __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(_this4.model, 'order_label_print_mode', _this4.model.order_label_print_mode || 'grouped');
          __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(_this4.model, 'order_label_is_lan', !!_this4.model.order_label_is_lan);

          _this4.model.printer_type = _this4.printerTypes.find(function (p) {
            return p.id === _this4.model.printer_type;
          }) || null;

          if (_this4.model.print_receipt_twice_payment_methods && _this4.model.print_receipt_twice_payment_methods.length) {
            var mappedBack = _this4.model.print_receipt_twice_payment_methods.map(function (id) {
              return {
                id: id,
                name: _this4.$t('paymentTypes.' + id)
              };
            });
            __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(_this4.model, 'print_receipt_twice_payment_methods', mappedBack);
          }

          if (_this4.posList && _this4.posList.length && _this4.model.pos_ids && _this4.model.pos_ids.length) {
            var mappedBack1 = _this4.model.pos_ids.map(function (id) {
              var pos = _this4.posList.find(function (p) {
                return p.id === id;
              });
              return {
                id: id,
                name: pos ? pos.name : ''
              };
            });
            __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(_this4.model, 'pos_ids', mappedBack1);
          }

          _this4.getMaps();
        }
        _this4.$nextTick(function () {
          _this4.loading = false;
        });
      });
    },
    getSections: function getSections() {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/sections', 'GET', data, function (response) {
        if (response.status) {
          _this5.sections = response.data;
        }
        _this5.$nextTick(function () {
          _this5.loading = false;
        });
      });
    },
    getMaps: function getMaps() {
      var _this6 = this;

      var resetSelection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (this.model.location && this.model.location.true_id) {
        data.location_id = this.model.location.true_id;
      }
      this.apiRequest('/pos/all/map', 'GET', data, function (response) {
        if (response.status) {
          _this6.maps = response.data.table_maps || [];
          if (resetSelection) {
            __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(_this6.model, 'table_maps', []);
          } else {
            _this6.mapTableMapsFromApi();
          }
        }
      });
    },
    mapTableMapsFromApi: function mapTableMapsFromApi() {
      var _this7 = this;

      if (Array.isArray(this.model.table_maps) && this.model.table_maps.length && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.model.table_maps[0]) === 'object') {
        return;
      }

      var mapIds = [];
      if (Array.isArray(this.model.table_map_ids) && this.model.table_map_ids.length) {
        mapIds = this.model.table_map_ids;
      } else if (this.model.table_map_id) {
        mapIds = Array.isArray(this.model.table_map_id) ? this.model.table_map_id : [this.model.table_map_id];
      }

      if (!mapIds.length || !this.maps.length) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_13_vue___default.a.set(this.model, 'table_maps', mapIds.map(function (id) {
        var map = _this7.maps.find(function (m) {
          return m.id === id;
        });
        return {
          id: id,
          name: map ? map.name : ''
        };
      }));
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this8 = this;

      this.$validator.validateAll().then(function (isValid) {
        console.log(_this8.model.print_receipts);
        if (isValid) {
          _this8.updateOrCreatePrinter();
        }
      });
    },
    updateOrCreatePrinter: function updateOrCreatePrinter() {
      var _this9 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model);
      data.company_id = this.$session.get('selectedCompany');
      data.token = this.$session.get('token');

      if (this.model.section) {
        data.section_id = this.model.section.id;
      } else {
        data.section_id = null;
      }

      if (this.model.table_maps && this.model.table_maps.length) {
        data.table_map_ids = this.model.table_maps.map(function (item) {
          return item.id;
        });
      } else {
        data.table_map_ids = [];
      }

      data.location_id = this.model.location.true_id;
      if (this.model.printer_type) {
        data.printer_type = this.model.printer_type.id;
      } else {
        data.printer_type = null;
      }

      if (this.model.print_receipt_twice_payment_methods && this.model.print_receipt_twice_payment_methods.length) {
        var result = this.model.print_receipt_twice_payment_methods.map(function (item) {
          return item.id;
        });
        data.print_receipt_twice_payment_methods = result;
      }

      if (this.model.pos_ids && this.model.pos_ids.length) {
        var _result = this.model.pos_ids.map(function (item) {
          return item.id;
        });
        data.pos_ids = _result;
      }

      data.print_receipts = !!this.model.print_receipts;
      data.order_label_print_mode = this.model.type === 5 ? this.model.order_label_print_mode || 'grouped' : 'grouped';
      data.order_label_is_lan = this.model.type === 5 && !!this.model.order_label_is_lan;

      var url = '/printer/';
      var httpMethod = '';

      if (this.id) {
        url += this.id;
        httpMethod = 'PUT';
      } else {
        httpMethod = 'POST';
      }

      this.apiRequest(url, httpMethod, data, function (response) {
        if (response.status === true) {
          var entityId = _this9.id || response.data && response.data.id || null;
          _this9.trackAdminEvent('ADMIN_PRINTER_UPDATE', 'printer', entityId, {
            printer_id: entityId,
            name: data.name || _this9.model && _this9.model.name || null,
            request: data,
            response: response
          });
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', 'Success', 'success');
          _this9.backButton();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    handleDelete: function handleDelete() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        text: this.$t('printer.deleteConfirm'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then(function () {
        _this10.$nextTick(function () {
          _this10.loading = true;
        });
        var data = {
          company_id: _this10.$session.get('selectedCompany'),
          token: _this10.$session.get('token'),
          delete: true
        };
        _this10.apiRequest('/printer/' + _this10.id, 'DELETE', data, function (response) {
          if (response.status) {
            _this10.trackAdminEvent('ADMIN_PRINTER_DELETED', 'printer', _this10.id, {
              printer_id: _this10.id,
              name: _this10.model && _this10.model.name || null
            });
            _this10.$nextTick(function () {
              _this10.loadingReset = false;
            });
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({ 'text': 'Success', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
            _this10.backButton();
          } else {
            _this10.$nextTick(function () {
              _this10.loadingReset = false;
            });
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({ 'text': _this10.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          }
        });
      }).catch(function () {});
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "Qimq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementMyOrdersSuppliersForm_vue__ = __webpack_require__("zUd+");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ManagementMyOrdersSuppliersForm', __WEBPACK_IMPORTED_MODULE_7__ManagementMyOrdersSuppliersForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "QkjM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-lg-12 "},[_c('div',{staticClass:" row"},[_c('div',{staticClass:"col-sm-12"},[_c('chart-bars-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading2),expression:"loading2"}],ref:"refEmailsChart",attrs:{"chart-data":_vm.emailsChart.data,"chart-options":_vm.emailsChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('p',[_vm._v(_vm._s(_vm.emailsChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v("\n              "+_vm._s(_vm.$t('dashboard.nrOfEmails'))+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"totalEmails"},[_vm._v(_vm._s(_vm.$t('reports.emailTotal'))+" "),_c('span',[_vm._v(_vm._s(_vm.totalEmails))])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"search-bar"},[_c('div',{staticClass:"col-sm-12 no-padding"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('reports.search')},on:{"input":function($event){_vm.onInput()}},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn add ",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('marketingCampaigns.single'),"to":{ path: '/marketing/campaigns/add'}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"campaign-table campaign-table--with-images width-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDef,"table-props":{'border': false},"filters":_vm.filters},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"min-width":30,"label":_vm.$t('marketingCampaigns.image')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"image-table"},[_c('img',{attrs:{"src":(props.row.image_url)?props.row.image_url[0].url : ''}})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":45,"prop":"name","label":_vm.$t('marketingCampaigns.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":30,"prop":"mode","label":_vm.$t('marketingCampaigns.mode')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n             "+_vm._s(_vm.$t('campaignsModes.' + props.row.mode))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":45,"prop":"valid","label":_vm.$t('marketingCampaigns.startEnd')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatDate(props.row.datetime_validfrom))+" - "+_vm._s(_vm.formatDate(props.row.datetime_validto))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":25,"prop":"name","label":_vm.$t('marketingCampaigns.daysLeft')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.getDaysLeft(props.row.datetime_validto))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":30,"prop":"name","label":_vm.$t('marketingCampaigns.timesUsed')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.counter)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":25,"label":_vm.$t('marketingCampaigns.status'),"prop":"active"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(props.$index, props.row, $event)}},model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":200,"prop":"actions","class-name":"centered-cell","align":"center","header-align":"center","label":_vm.$t('marketingCampaigns.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"campaign-table__actions"},[_c('a',{staticClass:"btn btn-icon-small btn-danger mar-rt-10",attrs:{"title":_vm.$t('general.delete'),"disabled":props.row.is_sending},on:{"click":function($event){$event.stopPropagation();_vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"fa fa-trash-o"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-icon-small btn-info mar-rt-10",attrs:{"title":_vm.$t('general.duplicate')},on:{"click":function($event){$event.stopPropagation();_vm.duplicateCampaign(props.row)}}},[_c('i',{staticClass:"fa fa-copy"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-icon-small btn-purple mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.send'),"disabled":props.row.isDisabledByLastSent || !props.row.active || props.row.mode == 'AUTO'},on:{"click":function($event){$event.stopPropagation();_vm.sendNotif(props.$index, props.row)}}},[_c('i',{staticClass:"ti-email"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-icon-small btn-orange mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.stopSending'),"disabled":!props.row.is_sending},on:{"click":function($event){$event.stopPropagation();_vm.stopSending(props.row)}}},[_c('i',{staticClass:"fa fa-ban",attrs:{"aria-hidden":"true"}})])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":160,"class-name":"centered-cell","align":"center","header-align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"active-pagination width-table",attrs:{"total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"pager-count":_vm.pagerCount,"layout":"prev, pager, next, total"},on:{"current-change":function($event){_vm.handlePageChange($event)},"prev-click":function($event){_vm.handlePageChange($event)},"next-click":function($event){_vm.handlePageChange($event)}}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qkmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalSignageEdit_vue__ = __webpack_require__("Tbs+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295eb70f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalSignageEdit_vue__ = __webpack_require__("ThP8");
function injectStyle (ssrContext) {
  __webpack_require__("Hji5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalSignageEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295eb70f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalSignageEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qn0H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var en = {
  previewWarnings: { 'GLOVO_EXPORT_LIMITATIONS': 'Individual quantity limits are not sent to Glovo; the attached SGR deposit is included in option prices.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Category images are not sent to Wolt. Catalog images are retained.' },
  credentialsSavedTitle: 'Integration saved',
  credentialsSavedSyncMenu: 'Your credentials and settings have been saved. Sync the menu from Menu management to complete setup.',
  credentialsSavedSyncMenuSchedule: 'Your credentials and settings have been saved. Sync the menu from Menu management, then sync the opening hours from Opening hours to complete setup.',
  locationsSectionHint: 'Choose where your menu comes from and where platform orders arrive.',
  credentialsSectionHint: 'Connection details used to identify your store on the platform.',
  'operations': 'Platform settings and actions',
  'orderSettings': 'Orders and availability',
  'orderSettingsHint': 'Configure incoming orders and monitor platform availability.',
  'integrationActive': 'Integration enabled',
  'scheduleTitle': 'Opening hours',
  'scheduleHint': 'Edit the weekly hours here, then sync this schedule to the platform.',
  'closedDay': 'Closed',
  'addInterval': 'Add interval',
  'saveBeforeActions': 'Save the integration to enable platform actions.',
  'notifications': 'Email notifications',
  'locations': 'Locations',
  'menuLocation': 'Menu location',
  'ordersLocation': 'Orders location',
  'menuHint': 'The catalog and prices used to publish your platform menu.',
  'ordersHint': 'Incoming platform orders will be created at this location.',
  'credentials': 'Platform credentials',
  'settings': 'Other settings',
  'role': 'Used for',
  'menu': 'Menu',
  'orders': 'Orders',
  'menu_orders': 'Menu + orders',
  'menuActions': 'Menu management',
  'menuActionsHint': 'Review your menu before publishing, or bring an existing platform menu into your catalog.',
  'connection': 'Platform connection',
  'connectionHint': 'Connect this location to Wolt or refresh its credentials.',
  'availability': 'Orders and opening hours',
  'availabilityHint': 'Control whether the platform accepts orders and update its opening hours.'
};
var ro = {
  previewWarnings: { 'GLOVO_EXPORT_LIMITATIONS': 'Limitele individuale de cantitate nu sunt trimise către Glovo; garanția SGR atașată este inclusă în prețurile opțiunilor.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Imaginile categoriilor nu sunt trimise către Wolt. Imaginile din catalog sunt păstrate.' },
  credentialsSavedTitle: 'Integrare salvată',
  credentialsSavedSyncMenu: 'Datele de conectare și setările au fost salvate. Sincronizează meniul din secțiunea Gestionare meniu pentru a finaliza configurarea.',
  credentialsSavedSyncMenuSchedule: 'Datele de conectare și setările au fost salvate. Sincronizează meniul din secțiunea Gestionare meniu, apoi programul din secțiunea Program de funcționare pentru a finaliza configurarea.',
  locationsSectionHint: 'Alege sursa meniului și locația în care ajung comenzile de pe platformă.',
  credentialsSectionHint: 'Datele de conectare care identifică magazinul tău pe platformă.',
  'operations': 'Setări și acțiuni pe platformă',
  'orderSettings': 'Comenzi și disponibilitate',
  'orderSettingsHint': 'Configurează comenzile primite și monitorizează disponibilitatea pe platformă.',
  'integrationActive': 'Integrare activă',
  'scheduleTitle': 'Program de funcționare',
  'scheduleHint': 'Editează programul săptămânal, apoi sincronizează-l cu platforma.',
  'closedDay': 'Închis',
  'addInterval': 'Adaugă interval',
  'saveBeforeActions': 'Salvează integrarea pentru a activa acțiunile pe platformă.',
  'notifications': 'Notificări prin email',
  'locations': 'Locații',
  'menuLocation': 'Locație meniu',
  'ordersLocation': 'Locație comenzi',
  'menuHint': 'Catalogul și prețurile folosite pentru publicarea meniului pe platformă.',
  'ordersHint': 'Comenzile primite de pe platformă vor fi create în această locație.',
  'credentials': 'Date de conectare la platformă',
  'settings': 'Alte setări',
  'role': 'Utilizare',
  'menu': 'Meniu',
  'orders': 'Comenzi',
  'menu_orders': 'Meniu + comenzi',
  'menuActions': 'Gestionare meniu',
  'menuActionsHint': 'Verifică meniul înainte de publicare sau importă meniul platformei în catalog.',
  'connection': 'Conectare la platformă',
  'connectionHint': 'Conectează locația la Wolt sau actualizează datele de conectare.',
  'availability': 'Comenzi și program',
  'availabilityHint': 'Controlează acceptarea comenzilor pe platformă și actualizează programul.'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  en: en,
  ro: ro,
  el: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, en, { previewWarnings: { 'GLOVO_EXPORT_LIMITATIONS': 'Τα μεμονωμένα όρια ποσότητας δεν αποστέλλονται στο Glovo· η συνδεδεμένη εγγύηση SGR περιλαμβάνεται στις τιμές των επιλογών.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Οι εικόνες κατηγοριών δεν αποστέλλονται στο Wolt. Οι εικόνες του καταλόγου διατηρούνται.' } }),
  nl: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, en, { previewWarnings: { 'GLOVO_EXPORT_LIMITATIONS': 'Individuele hoeveelheidslimieten worden niet naar Glovo verzonden; het gekoppelde SGR-statiegeld is inbegrepen in de optieprijzen.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Categorieafbeeldingen worden niet naar Wolt verzonden. De afbeeldingen in de catalogus blijven behouden.' } }),
  it: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, en, { previewWarnings: { 'GLOVO_EXPORT_LIMITATIONS': 'I limiti di quantità individuali non vengono inviati a Glovo; il deposito SGR associato è incluso nei prezzi delle opzioni.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Le immagini delle categorie non vengono inviate a Wolt. Le immagini del catalogo vengono conservate.' } }),
  de: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, en, { previewWarnings: { 'GLOVO_EXPORT_LIMITATIONS': 'Individuelle Mengenlimits werden nicht an Glovo gesendet; das zugehörige SGR-Pfand ist in den Optionspreisen enthalten.', 'CATEGORY_IMAGES_NOT_EXPORTED': 'Kategoriebilder werden nicht an Wolt gesendet. Die Bilder im Katalog bleiben erhalten.' } })
});

/***/ }),

/***/ "QnKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QoUj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qq2o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_json_excel__ = __webpack_require__("fXhN");








var _components;










__WEBPACK_IMPORTED_MODULE_7_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_14_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isTopProducts: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isTopProducts: function isTopProducts() {
      if (this.isTopProducts) {
        this.getOrders();
        this.verifyUserLocations();
        this.verifyUserMethods();
      }
    }
  },

  computed: {
    mergedProducts: function mergedProducts() {
      var map = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(this.availableProducts.map(function (t) {
        return [t.id, t];
      }));
      this.selectedProducts.forEach(function (t) {
        if (!map.has(t.id)) {
          map.set(t.id, t);
        }
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(map.values());
    }
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      selectedProducts: [],
      availableProducts: [],
      allProductsMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
      topProductSales: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '500px',
          axisX: {
            scaleMinSpace: 50,
            showGrid: false
          },
          axisY: {
            onlyInteger: true,
            offset: 20
          }
        }
      },
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_method: '',
      loading: true,
      loadingProducts: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_11_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      legendItems: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_11_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      ordersTableData: {},
      totalOrders: null,
      colors: ['#f44336', '#2196f3', '#ff9800', '#9c27b0', '#00bcd4', '#8bc34a', '#ffc107', '#3f51b5', '#ff5722', '#795548', '#607d8b', '#009688', '#cddc39', '#673ab7', '#03a9f4', '#aed581', '#ffb74d', '#ba68c8'],
      noData: false
    };
  },

  methods: {
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this = this;

      if (!this.isTopProducts) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        payment_method: this.selected_payment_method
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.selectedProducts && this.selectedProducts.length) {
        data.product_ids = this.selectedProducts.map(function (table) {
          return table.id;
        });
      }

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;

      var hasReceiptValue = this.hasRceipt && this.hasRceipt.value || null;

      this.apiRequest('/reports/v2/top-products' + '?page=' + page + '&perPage=' + pageSize + '&has_receipt=' + hasReceiptValue, 'GET', data, function (response) {
        if (response.status) {
          if (response.data.table_data.length) {
            _this.ordersTableData.data = response.data.table_data;
            _this.ordersTableData.total = response.pagination.total;
            _this.paginationProps.currentPage = response.pagination.page;
            _this.paginationProps.pageSize = response.pagination.perPage;
          } else {
            _this.ordersTableData.data = [];
            _this.ordersTableData.total = 0;
          }

          _this.topProductSales.options.chartPadding = {
            top: 30,
            right: 10,
            bottom: 20,
            left: 40
          };

          if (!response.data.products.length) {
            _this.$nextTick(function () {
              _this.topProductSales.data.labels = [];
              _this.topProductSales.data.series = [[]];
              _this.discounts = [];
              _this.noData = true;

              if (_this.$refs.topProductSales.chart) {
                _this.$refs.topProductSales.initChartAndReturn();
              }

              return false;
            });
          }

          _this.noData = false;

          var baseLabels = [];
          var salesSeries = [];
          var discountsSeries = [];

          response.data.products.forEach(function (product, index) {
            baseLabels.push(product);
            salesSeries.push(response.data.sales[index] || 0);
            discountsSeries.push(response.data.discounts[index] || 0);
          });

          _this.topProductSales.data.labels = baseLabels;
          _this.topProductSales.data.series = [salesSeries, discountsSeries];

          _this.discounts = response.data.discounts;

          _this.legendItems = _this.topProductSales.data.labels.map(function (product, index) {
            var baseColor = _this.colors[index % _this.colors.length];
            return {
              product: product,
              sales: {
                label: product + ' - ' + _this.topProductSales.data.series[0][index],
                color: baseColor
              },
              discount: {
                label: 'Discount ' + product + ' - ' + (_this.topProductSales.data.series[1][index] || 0),
                color: _this.lightenHexColor(baseColor, 40)
              }
            };
          });

          _this.$nextTick(function () {
            _this.$refs.topProductSales.initChartAndReturn();

            if (_this.$refs.topProductSales.chart) {
              _this.$refs.topProductSales.chart.on('draw', function (data) {
                if (data.type === 'bar') {
                  var productIndex = data.index;
                  var isDiscount = data.seriesIndex === 1;
                  var baseColor = _this.colors[productIndex % _this.colors.length];
                  var color = isDiscount ? _this.lightenHexColor(baseColor, 40) : baseColor;

                  data.element.attr({
                    style: 'stroke: ' + color + '; stroke-width: 30px;'
                  });
                }
              });
            }
          });
        } else {
          _this.topProductSales.data.labels = [];
          _this.topProductSales.data.series = [[]];
          _this.discounts = [];
          _this.noData = true;

          if (_this.$refs.topProductSales.chart) {
            _this.$refs.topProductSales.initChartAndReturn();
          }

          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    lightenHexColor: function lightenHexColor(hex, percent) {
      var num = parseInt(hex.replace('#', ''), 16);
      var amt = Math.round(2.55 * percent);
      var R = (num >> 16) + amt;
      var G = (num >> 8 & 0x00FF) + amt;
      var B = (num & 0x0000FF) + amt;

      return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    exportData: function exportData() {
      var _this2 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        payment_method: this.selected_payment_method,
        has_receipt: this.hasRceipt && this.hasRceipt.value || null
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.selectedProducts && this.selectedProducts.length) {
        data.product_ids = this.selectedProducts.map(function (table) {
          return table.id;
        });
      }

      this.loading = true;
      this.apiRequest('/reports/v2/top-products-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
        }
        _this2.loading = false;
      });
    },
    clearSearch: function clearSearch() {
      this.$refs.productSelect.focus();
      var select = this.$refs.productSelect;

      if (select) {
        select.query = '';
        select.handleQueryChange('');
      }
    },
    searchProducts: function searchProducts(query) {
      var _this3 = this;

      if (!query) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loadingProducts = true;

      this.apiRequest('/search-order-products', 'GET', data, function (response) {
        if (response.status) {
          response.data.forEach(function (item) {
            _this3.allProductsMap.set(item.id, item);
          });

          _this3.availableProducts = response.data;
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this3.$t('validations.wentWrong'), 'error');
        }

        _this3.$nextTick(function () {
          _this3.loadingProducts = false;
        });
      });
    }
  }
});

/***/ }),

/***/ "Qqv+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",[_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)])],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qsxu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qv2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QwF0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosMapForm_vue__ = __webpack_require__("/Sdt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b316530_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosMapForm_vue__ = __webpack_require__("eZ11");
function injectStyle (ssrContext) {
  __webpack_require__("XOix")
  __webpack_require__("kLQI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b316530"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosMapForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b316530_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosMapForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QxJS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementClientsAdd_vue__ = __webpack_require__("OboX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc2c7f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementClientsAdd_vue__ = __webpack_require__("WOuw");
function injectStyle (ssrContext) {
  __webpack_require__("Qsxu")
  __webpack_require__("EMWT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fc2c7f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementClientsAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc2c7f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementClientsAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QyTD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 449.4 209"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 449.4 209","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_1_","y":"62.9","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_3_","d":"M0,137.1V71.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v65.2c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H9c-2.4,0-4.7-0.9-6.4-2.6C0.9,141.8,0,139.5,0,137.1\n            z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,146.1V62.9h83.2v83.2H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_5_","x":"366.2","y":"62.9","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_7_","d":"M366.2,137.1V71.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v65.2c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-0.9-6.4-2.6\n            C367.2,141.8,366.2,139.5,366.2,137.1z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M366.2,146.1V62.9h83.2v83.2H366.2z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_9_","x":"302.4","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_11_","d":"M302.4,74.2V9c0-2.4,1-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2\n            c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-1-6.4-2.6S302.4,76.6,302.4,74.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M302.4,83.2V0h83.2v83.2H302.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_13_","x":"180.4","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_15_","d":"M180.4,74.2V9c0-2.4,0.9-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2\n            c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-1-6.4-2.6S180.4,76.6,180.4,74.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M180.4,83.2V0h83.2v83.2H180.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_17_","x":"66","y":"62.9","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_19_","d":"M66,137.1V71.9c0-2.4,0.9-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2\n            c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6H75c-2.4,0-4.7-0.9-6.4-2.6S66,139.5,66,137.1z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M66,146.1V62.9h83.2v83.2H66z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_21_","x":"62.9","y":"0","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_23_","d":"M71.9,0h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v65.2c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6H71.9\n            c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4V9c0-2.4,0.9-4.7,2.6-6.4S69.5,0,71.9,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st2",attrs:{"d":"M62.9,0h83.2v83.2H62.9V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_25_","x":"62.9","y":"125.8","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st13"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_27_","d":"M71.9,125.8h65.2c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4V200c0,2.4-0.9,4.7-2.6,6.4\n            s-4,2.6-6.4,2.6H71.9c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-65.2c0-2.4,0.9-4.7,2.6-6.4C67.2,126.8,69.5,125.8,71.9,125.8z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('path',{staticClass:"st2",attrs:{"d":"M62.9,125.8h83.2V209H62.9V125.8z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_29_","x":"180.4","y":"125.8","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_30_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_29_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_31_","d":"M189.4,125.8h65.2c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4V200c0,2.4-0.9,4.7-2.6,6.4\n            s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-65.2c0-2.4,0.9-4.7,2.6-6.4C184.8,126.8,187,125.8,189.4,125.8z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_32_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_31_"}})]),_vm._v(" "),_c('g',{staticClass:"st16"},[_c('path',{staticClass:"st2",attrs:{"d":"M180.4,125.8h83.2V209h-83.2V125.8z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_33_","x":"302.4","y":"125.8","width":"83.2","height":"83.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_34_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_33_"}})]),_vm._v(" "),_c('g',{staticClass:"st17"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_35_","d":"M302.4,200v-65.2c0-2.4,1-4.7,2.6-6.4s4-2.6,6.4-2.6h65.2c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4V200\n            c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-65.2c-2.4,0-4.7-0.9-6.4-2.6S302.4,202.4,302.4,200z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_36_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_35_"}})]),_vm._v(" "),_c('g',{staticClass:"st18"},[_c('path',{staticClass:"st2",attrs:{"d":"M302.4,209v-83.2h83.2V209H302.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_37_","x":"14.7","y":"14.7","width":"418.9","height":"179.6"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_38_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_37_"}})]),_vm._v(" "),_c('g',{staticClass:"st19"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t8_39_","d":"M37.7,14.7h372.8c12.7,0,23,10.3,23,23v133.6c0,12.7-10.3,23-23,23H37.7c-12.7,0-23-10.3-23-23V37.7\n            C14.7,25,25,14.7,37.7,14.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_40_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_39_"}})]),_vm._v(" "),_c('g',{staticClass:"st20"},[_c('path',{staticClass:"st21",attrs:{"d":"M14.7,14.7h418.9v179.6H14.7V14.7z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t8_41_","x":"155.7","y":"36.2","width":"136.7","height":"136.7"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_42_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_41_"}})]),_vm._v(" "),_c('g',{staticClass:"st22"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"t8_43_","cx":"224.1","cy":"104.5","r":"68.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t8_44_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t8_43_"}})]),_vm._v(" "),_c('g',{staticClass:"st23"},[_c('path',{staticClass:"st2",attrs:{"d":"M155.7,36.2h136.7v136.7H155.7V36.2z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R+jw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersAdd_vue__ = __webpack_require__("kbwa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d68386_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersAdd_vue__ = __webpack_require__("24+u");
function injectStyle (ssrContext) {
  __webpack_require__("iQHX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d68386_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R/CC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R/cZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.inRedNotice)?_c('div',{staticClass:"redNotice"},[_c('span',[_vm._v("Vă rugăm să achitați facturile restante in cel mai scurt timp pentru a nu vi se suspenda accesul la panoul de control!")])]):_vm._e(),_vm._v(" "),_c('side-bar',{staticClass:"noprint",attrs:{"type":"sidebar","sidebar-links":_vm.$sidebar.sidebarLinks}},[_c('user-menu'),_vm._v(" "),_c('mobile-menu')],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading.body.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"body":true,"lock":true}}],staticClass:"main-panel",attrs:{"id":"mainContainer"}},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R0fG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Online_vue__ = __webpack_require__("mi3b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcee19c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Online_vue__ = __webpack_require__("6f9o");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Online_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcee19c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Online_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R2Bc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSectionForm_vue__ = __webpack_require__("bLKJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f83e7d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSectionForm_vue__ = __webpack_require__("3AXy");
function injectStyle (ssrContext) {
  __webpack_require__("ul0L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSectionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f83e7d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSectionForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R2fV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row categories"},[_c('div',{class:{'loading-bar': _vm.loading}},[_c('div',{staticClass:"bar"})]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-10 col-sm-12 "},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-right",staticStyle:{"position":"relative","z-index":"2"}},[_c('router-link',{staticClass:"btn btn-info btn-icon add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('catalogCateg.single'),"to":{ path: 'categories/add'}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])],1)]),_vm._v(" "),(_vm.tableData !== null)?_c('div',[_vm._l((_vm.tableData),function(tc,ind){return [_c('label',{staticClass:"details-label pad-lf-20 mar-bt-25 top-category-font"},[_vm._v(" "+_vm._s((tc.categ.name == 'no-parent' ? _vm.$t('catalogCateg.categoriesWithoutParent') : tc.categ.name )))]),_vm._v(" "),_c('table',{ref:"sortableTable",refInFor:true,staticClass:"table width-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('general.sortOrder')))]),_vm._v(" "),_c('th',{attrs:{"width":"30%"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.image')))]),_vm._v(" "),_c('th',{attrs:{"width":"40%"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.name')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}}),_vm._v(" "),_c('th',{attrs:{"width":"10%"}})])]),_vm._v(" "),_vm._l((tc.items),function(c,index){return [_c('tr',{staticClass:"sortableRow draggable-highlight",attrs:{"data-index":ind,"data-id":c.id}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(c.sort_order),expression:"c.sort_order"}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"500","placeholder":_vm.$t('general.sortOrder'),"step":"1"},domProps:{"value":(c.sort_order)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(c, "sort_order", $event.target.value)},function($event){_vm.onSortOrderInput(c)}],"keypress":function($event){_vm.onlyDigits($event)},"click":function($event){_vm.selectInputText($event)}}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"image-table"},[_c('img',{attrs:{"src":(c.image)?c.image : ''}})])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(c.name))]),_vm._v(" "),_c('td',[[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(c)}},model:{value:(c.active),callback:function ($$v) {_vm.$set(c, "active", $$v)},expression:"c.active"}})]],2),_vm._v(" "),_c('td',[_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(c,[],[], $event)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                        ")])])])]})],2),_vm._v(" "),_c('hr')]})],2):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 rkeeper-card-width"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R35P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosList_vue__ = __webpack_require__("dkaT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3470ea39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosList_vue__ = __webpack_require__("0Svp");
function injectStyle (ssrContext) {
  __webpack_require__("nddP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3470ea39_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R3pE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R4s4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6df68817_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("Ga6V");
function injectStyle (ssrContext) {
  __webpack_require__("6BXR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6df68817_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R5eq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])]),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('campaign-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onCampaignSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RESi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsDeliverySlots_vue__ = __webpack_require__("ZREN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31246ad9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsDeliverySlots_vue__ = __webpack_require__("82iU");
function injectStyle (ssrContext) {
  __webpack_require__("xRQ2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31246ad9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsDeliverySlots_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31246ad9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsDeliverySlots_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RExQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RG8w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RJy+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RM7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__ = __webpack_require__("Ark/");












/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */],
    SearchableMultiSelect: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a),
  props: {
    isNexusReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isNexusReport: {
      immediate: true,
      handler: function handler(val) {
        this.applyRouteFilters();
        this.getOrders({ page: this.paginationProps.currentPage || 1, pageSize: this.paginationProps.pageSize || 20 });
        this.verifyUserLocations();
        this.verifyUserMethods();
        this.initAdministrations();
      }
    }
  },
  created: function created() {
    this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest';
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      types: [{ id: null, name: this.$t('general.all') }, { id: 0, name: this.$t('nexus.sentStatus0') }, { id: 1, name: this.$t('nexus.sentStatus1') }, { id: 2, name: this.$t('nexus.sentStatus2') }, { id: 3, name: this.$t('nexus.sentStatus3') }, { id: 4, name: this.$t('nexus.sentStatus4') }, { id: 5, name: this.$t('nexus.sentStatus5') }],
      selectedType: null,
      documents: [{ id: null, name: this.$t('general.all') }, { id: 'bill', name: this.$t('charisma.bill') }, { id: 'invoice', name: this.$t('charisma.invoice') }],
      selectedDocument: null,
      selectedSeries: null,
      selectedNumber: null,
      administrations: [],
      selectedAdministration: null,
      selectedAdministrationIdFromRoute: null,
      selectedCategories: [],
      selectedTopCategories: [],
      rawPosUsers: [],
      ordersTableData: {},
      productsTableDataTotals: {},
      selectedPosUser: null,
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'day').format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total',
        currentPage: 1,
        pageSize: 20
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      noData: false,
      selectedOrderId: null,
      selectedNexusOrderId: null,
      timezone: null,
      editedRowId: null
    };
  },

  methods: {
    handleRefresh: function handleRefresh(editedId) {
      if (editedId) {
        this.editedRowId = editedId;
      }
      this.getOrders({
        page: this.paginationProps.currentPage || 1,
        pageSize: this.paginationProps.pageSize || 20
      });
    },
    rowClass: function rowClass(rowData) {
      var row = rowData.row || rowData;
      var orderId = row.order_id || row.id;
      return String(orderId) === String(this.editedRowId) ? 'highlight-row' : '';
    },
    getLocationName: function getLocationName(locationId) {
      if (!locationId) return '-';
      var loc = this.locations.find(function (l) {
        return l.id === locationId || l.id === Number(locationId);
      });
      return loc ? loc.name : locationId;
    },
    translatePaymentType: function translatePaymentType(type) {
      if (!type) return '-';
      var key = 'paymentTypes.' + type;
      return this.$te(key) ? this.$t(key) : type;
    },
    translateOrderStatus: function translateOrderStatus(status) {
      if (!status) return '-';
      var key = 'ordersStatus.' + status;
      return this.$te(key) ? this.$t(key) : status;
    },
    applyRouteFilters: function applyRouteFilters() {
      var q = this.$route && this.$route.query ? this.$route.query : {};
      if (q.from && q.to) {
        this.orders.valid = [q.from, q.to];
      }
      if (q.timeFrom) this.valid_from = q.timeFrom;
      if (q.timeTo) this.valid_to = q.timeTo;
      if (q.location) this.orders.location = q.location;
      if (q.orderIdFilter) this.selectedOrderId = q.orderIdFilter;
      if (q.nexusOrderIdFilter) this.selectedNexusOrderId = q.nexusOrderIdFilter;
      if (q.type !== undefined) {
        var typeId = Number(q.type);
        this.selectedType = this.types.find(function (t) {
          return t && t.id === typeId;
        }) || null;
      }
      if (q.document !== undefined) {
        this.selectedDocument = this.documents.find(function (d) {
          return d && d.id === q.document;
        }) || null;
      }
      if (q.series !== undefined) {
        this.selectedSeries = q.series;
      }
      if (q.number !== undefined) {
        this.selectedNumber = q.number ? Number(q.number) : null;
      }
      if (q.admin !== undefined) {
        var adminId = Number(q.admin);
        this.selectedAdministrationIdFromRoute = adminId;
        if (this.administrations && this.administrations.length > 0) {
          this.selectedAdministration = this.administrations.find(function (a) {
            return a && a.id === adminId;
          }) || null;
          this.selectedAdministrationIdFromRoute = null;
        }
      }
      if (q.page) this.paginationProps.currentPage = isNaN(q.page) ? q.page : Number(q.page);
      if (q.perPage) this.paginationProps.pageSize = isNaN(q.perPage) ? q.perPage : Number(q.perPage);
    },
    initAdministrations: function initAdministrations() {
      var _this = this;

      var sessionData = this.$session.get('selectedCompanyData') || {};
      if (sessionData['administrations']) {
        this.administrations = sessionData['administrations'];
        if (this.selectedAdministrationIdFromRoute && !this.selectedAdministration) {
          this.selectedAdministration = this.administrations.find(function (a) {
            return a && a.id === Number(_this.selectedAdministrationIdFromRoute);
          }) || null;
          this.selectedAdministrationIdFromRoute = null;
        }
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/administration', 'GET', data, function (response) {
        if (response && response.status && Array.isArray(response.data)) {
          _this.administrations = response.data;
          sessionData['administrations'] = response.data;
          _this.$session.set('selectedCompanyData', sessionData);
          if (_this.selectedAdministrationIdFromRoute && !_this.selectedAdministration) {
            _this.selectedAdministration = _this.administrations.find(function (a) {
              return a && a.id === Number(_this.selectedAdministrationIdFromRoute);
            }) || null;
            _this.selectedAdministrationIdFromRoute = null;
          }
        } else {
          _this.administrations = [];
        }
      });
    },
    goToItems: function goToItems(row) {
      var orderId = row.order_id || row.id;
      if (!orderId) {
        return;
      }
      var page = this.paginationProps.currentPage || 1;
      var perPage = this.paginationProps.pageSize || 20;
      var query = {
        tab: 'nexus',
        page: page,
        perPage: perPage,
        from: this.orders.valid[0],
        to: this.orders.valid[1],
        timeFrom: this.valid_from,
        timeTo: this.valid_to
      };
      if (this.orders.location) query.location = this.orders.location;
      if (this.selectedOrderId) query.orderIdFilter = this.selectedOrderId;
      if (this.selectedNexusOrderId) query.nexusOrderIdFilter = this.selectedNexusOrderId;
      if (this.selectedType) query.type = this.selectedType.id ? this.selectedType.id : this.selectedType;
      if (this.selectedDocument) query.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument;
      if (this.selectedSeries) query.series = this.selectedSeries;
      if (this.selectedNumber) query.number = this.selectedNumber;
      if (this.selectedAdministration) query.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration;
      this.$router.push({
        name: 'Nexus Items',
        params: { orderId: String(orderId) },
        query: query
      });
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page' || query.type === 'size' || query.type === 'sort') {
        var pageSize = query.pageSize || this.paginationProps.pageSize || 20;
        var page = query.page || this.paginationProps.currentPage || 1;
        var syncQuery = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query, {
          tab: 'nexus',
          page: page,
          perPage: pageSize,
          from: this.orders.valid[0],
          to: this.orders.valid[1],
          timeFrom: this.valid_from,
          timeTo: this.valid_to
        });
        if (this.orders.location) syncQuery.location = this.orders.location;
        if (this.selectedOrderId) syncQuery.orderIdFilter = this.selectedOrderId;
        if (this.selectedNexusOrderId) syncQuery.nexusOrderIdFilter = this.selectedNexusOrderId;
        if (this.selectedType) syncQuery.type = this.selectedType.id ? this.selectedType.id : this.selectedType;
        if (this.selectedDocument) syncQuery.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument;
        if (this.selectedSeries) syncQuery.series = this.selectedSeries;
        if (this.selectedNumber) syncQuery.number = this.selectedNumber;
        if (this.selectedAdministration) syncQuery.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration;
        this.$router.replace({ path: '/reports', query: syncQuery });
        this.getOrders(query);
      }
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this2 = this;

      if (!this.isNexusReport) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from + ':00';
      var toDate = this.orders.valid[1] + ' ' + this.valid_to + ':00';

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.selectedOrderId) {
        data.order_id = this.selectedOrderId;
      }

      if (this.selectedNexusOrderId) {
        data.nexus_order_id = this.selectedNexusOrderId;
      }

      if (this.selectedType) {
        data.status = this.selectedType.id;
      }

      if (this.selectedDocument) {
        data.document = this.selectedDocument.id;
      }

      if (this.selectedSeries) {
        data.series = this.selectedSeries;
      }

      if (this.selectedNumber) {
        data.number = this.selectedNumber;
      }

      if (this.selectedAdministration) {
        data.administration_id = this.selectedAdministration.id;
      }

      this.loading = true;
      var pageSize = query && query.pageSize ? query.pageSize : this.paginationProps.pageSize || 20;
      var page = query && query.page ? query.page : this.paginationProps.currentPage || 1;

      this.apiRequest('/nexus/report' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          if (response.data.table_data.length) {
            _this2.ordersTableData = {
              data: response.data.table_data,
              total: response.pagination.total
            };
            _this2.paginationProps.currentPage = response.pagination.page;
            _this2.paginationProps.pageSize = response.pagination.perPage;
          } else {
            _this2.ordersTableData = { data: [], total: 0 };
            _this2.paginationProps.currentPage = 1;
            _this2.paginationProps.pageSize = 20;
          }

          _this2.noData = false;
        } else {
          _this2.discounts = [];
          _this2.noData = true;

          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this2.$t('validations.wentWrong'), 'error');
        }

        _this2.$nextTick(function () {
          _this2.loading = false;
          if (_this2.editedRowId) {
            var highlighted = _this2.$el.querySelector('.el-table__body tr.highlight-row');
            if (highlighted) {
              highlighted.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          }
        });
      });
    },
    rowUpdateStatus: function rowUpdateStatus(nexusOrderId, newStatus) {
      var _this3 = this;

      var titleKey = newStatus === 0 ? 'nexus.markResend' : 'nexus.markCancellation';
      var confirmText = newStatus === 0 ? this.$t('nexus.markResendConfirm') + ' (#' + nexusOrderId + ')' : this.$t('nexus.markCancellationConfirm') + ' (#' + nexusOrderId + ')';
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        title: this.$t(titleKey),
        text: confirmText,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('general.cancel') || 'Cancel'
      }).then(function (result) {
        if (!result) return;
        var data = {
          token: _this3.$session.get('token'),
          company_id: _this3.$session.get('selectedCompany'),
          nexus_order_id: nexusOrderId,
          new_status: newStatus
        };
        _this3.loading = true;
        _this3.apiRequest('/nexus/bulk-update-status', 'POST', data, function (response) {
          if (response && response.status) {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', _this3.$t('nexus.markSuccessMessage'), 'success');
            _this3.getOrders({ page: _this3.paginationProps.currentPage || 1, pageSize: _this3.paginationProps.pageSize || 20 });
          } else {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', response && response.errors && response.errors['id'] ? response.errors['id'] : _this3.$t('validations.wentWrong'), 'error');
          }
          _this3.$nextTick(function () {
            _this3.loading = false;
          });
        });
      });
    },
    bulkUpdateStatus: function bulkUpdateStatus(newStatus) {
      var _this4 = this;

      var confirmKey = newStatus === 0 ? 'nexus.markResendConfirm' : 'nexus.markCancellationConfirm';
      var titleKey = newStatus === 0 ? 'nexus.markResend' : 'nexus.markCancellation';
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        title: this.$t(titleKey),
        text: this.$t(confirmKey),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('general.cancel') || 'Cancel'
      }).then(function (result) {
        if (!result) return;
        _this4._doBulkUpdateStatus(newStatus);
      });
    },
    _doBulkUpdateStatus: function _doBulkUpdateStatus(newStatus) {
      var _this5 = this;

      if (this.valid_to === '24:00') this.valid_to = '23:59';
      if (this.valid_from === '24:00') this.valid_from = '23:59';

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from + ':00';
      var toDate = this.orders.valid[1] + ' ' + this.valid_to + ':00';

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        new_status: newStatus
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }
      if (this.selectedOrderId) {
        data.order_id = this.selectedOrderId;
      }
      if (this.selectedNexusOrderId) {
        data.nexus_order_id = this.selectedNexusOrderId;
      }
      if (this.selectedType) {
        data.status = this.selectedType.id;
      }
      if (this.selectedDocument) {
        data.document = this.selectedDocument.id;
      }
      if (this.selectedSeries) {
        data.series = this.selectedSeries;
      }
      if (this.selectedNumber) {
        data.number = this.selectedNumber;
      }
      if (this.selectedAdministration) {
        data.administration_id = this.selectedAdministration.id;
      }

      this.loading = true;
      this.apiRequest('/nexus/bulk-update-status', 'POST', data, function (response) {
        if (response && response.status) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', _this5.$t('nexus.markSuccessMessage'), 'success');
          _this5.getOrders({ page: _this5.paginationProps.currentPage || 1, pageSize: _this5.paginationProps.pageSize || 20 });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', response && response.errors && response.errors['id'] ? response.errors['id'] : _this5.$t('validations.wentWrong'), 'error');
        }
        _this5.$nextTick(function () {
          _this5.loading = false;
        });
      });
    },
    sentStatusClass: function sentStatusClass(status) {
      var map = {
        0: 'text-muted',
        1: 'text-success',
        2: 'text-danger',
        3: 'text-info',
        4: 'text-warning',
        5: 'text-warning' };
      return map[status] !== undefined ? map[status] : 'text-muted';
    },
    parseReceiptNumber: function parseReceiptNumber(raw) {
      if (!raw) return '-';
      try {
        var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        var num = parsed.ReceiptNumber;
        var status = parsed.ReceiptStatus;
        if (num !== undefined && num !== null) {
          return status === false ? num + ' (error)' : num;
        }
        return raw;
      } catch (e) {
        return raw;
      }
    },
    updateData: function updateData() {
      var syncQuery = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query, {
        tab: 'nexus',
        page: this.paginationProps.currentPage || 1,
        perPage: this.paginationProps.pageSize || 20,
        from: this.orders.valid[0],
        to: this.orders.valid[1],
        timeFrom: this.valid_from,
        timeTo: this.valid_to
      });
      if (this.orders.location) syncQuery.location = this.orders.location;
      if (this.selectedOrderId) syncQuery.orderIdFilter = this.selectedOrderId;
      if (this.selectedNexusOrderId) syncQuery.nexusOrderIdFilter = this.selectedNexusOrderId;
      if (this.selectedType) syncQuery.type = this.selectedType.id ? this.selectedType.id : this.selectedType;
      if (this.selectedDocument) syncQuery.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument;
      if (this.selectedSeries) syncQuery.series = this.selectedSeries;
      if (this.selectedNumber) syncQuery.number = this.selectedNumber;
      if (this.selectedAdministration) syncQuery.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration;
      this.$router.replace({ path: '/reports', query: syncQuery });
      this.getOrders({ page: syncQuery.page, pageSize: syncQuery.perPage });
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    }
  }
});

/***/ }),

/***/ "RMTn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kds_vue__ = __webpack_require__("3w8t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42994c3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kds_vue__ = __webpack_require__("6dpF");
function injectStyle (ssrContext) {
  __webpack_require__("fm9h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kds_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42994c3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kds_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ROT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralAmbassadorRequests_vue__ = __webpack_require__("ldJr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca92de78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralAmbassadorRequests_vue__ = __webpack_require__("MtbO");
function injectStyle (ssrContext) {
  __webpack_require__("Gpc3")
  __webpack_require__("nzlA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca92de78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralAmbassadorRequests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca92de78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralAmbassadorRequests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RPJ8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RPVL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LineChart',
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Line */],
  components: {
    Line: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Line */]
  },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    chartData: function chartData(newData) {
      this.renderChart(newData, this.options);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.renderChart(_this.chartData, _this.options);
    });
  }
});

/***/ }),

/***/ "RQ8p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isMyProfile },on:{"click":function($event){_vm.openTab ('myProfile')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.myProfile')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isUsers },on:{"click":function($event){_vm.openTab ('users')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.users')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isCompanyDetails },on:{"click":function($event){_vm.openTab ('companyDetails')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.companyDetails')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isPrinters },on:{"click":function($event){_vm.openTab ('printers')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.printers')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isDateTime },on:{"click":function($event){_vm.openTab ('dateTime')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.dateTime')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isCurrency },on:{"click":function($event){_vm.openTab ('currency')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.currency')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isServices },on:{"click":function($event){_vm.openTab ('services')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.services')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isPaymentGroups },on:{"click":function($event){_vm.openTab ('paymentGroups')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.paymentGroups')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isPush },on:{"click":function($event){_vm.openTab ('push')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.push')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isTaxLabeling },on:{"click":function($event){_vm.openTab ('taxLabeling')}}},[_vm._v(_vm._s(_vm.$t('settingsPages.taxLabeling')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isMeasurementsUnits },on:{"click":function($event){_vm.openTab('measurementsUnits')}}},[_vm._v("\n            "+_vm._s(_vm.$t('settingsPages.measurementsUnits'))+"\n          ")])])])])]),_vm._v(" "),(_vm.isMyProfile)?_c('div',[_c('user-form',{attrs:{"callback":_vm.updateList,"userId":_vm.user && _vm.user.id ? _vm.user.id : null},on:{"on-submit":_vm.onUserSubmit}})],1):_vm._e(),_vm._v(" "),(_vm.isUsers)?_c('div',[(_vm.selectedUser != false)?[_c('user-form',{attrs:{"callback":_vm.updateList,"userId":_vm.selectedUser},on:{"on-submit":_vm.onUserSubmit}})]:[_c('users-list',{ref:"userList",attrs:{"isUsers":_vm.isUsers,"callback":_vm.getUser}})]],2):_vm._e(),_vm._v(" "),(_vm.isCompanyDetails)?_c('div',[_c('company-details',{attrs:{"modeldata":_vm.model,"countries":_vm.defaultData.countries,"taxesData":_vm.taxes,"tabRefresh":_vm.currentTab,"isCompanyDetails":_vm.isCompanyDetails},on:{"updateModelData":_vm.updateModelData,"setSelectedTab":_vm.setSelectedTab}})],1):_vm._e(),_vm._v(" "),(_vm.isPrinters)?_c('div',[_c('printers',{attrs:{"tabRefresh":_vm.currentTab,"isPrinters":_vm.isPrinters}})],1):_vm._e(),_vm._v(" "),(_vm.isDateTime)?_c('div',[_c('datetime-form',{attrs:{"modeldata":_vm.model,"defaultData":_vm.defaultData}})],1):_vm._e(),_vm._v(" "),(_vm.isCurrency)?_c('div',[_c('currency-form',{attrs:{"modeldata":_vm.model,"currencylist":_vm.defaultData.currencies,"currencyformatlist":_vm.defaultData.currency_display_format}})],1):_vm._e(),_vm._v(" "),(_vm.isServices)?_c('div',[_c('app-services',{ref:"tableManagement",attrs:{"modeldata":_vm.model,"isServices":_vm.isServices,"defaultData":_vm.defaultData}})],1):_vm._e(),_vm._v(" "),(_vm.isPaymentGroups)?_c('div',[(_vm.selectedPaymentGroups != false)?[_c('payment-groups-form',{attrs:{"callback":_vm.paymentGroupsUpdate,"paymentGroupId":_vm.selectedPaymentGroups},on:{"on-submit":_vm.onUserSubmit}})]:[_c('payment-groups-list',{ref:"paymentGroups",attrs:{"isTable":_vm.isPaymentGroups,"callback":_vm.getPaymentGroups}})]],2):_vm._e(),_vm._v(" "),(_vm.isPush)?_c('div',[_c('push-notifications',{attrs:{"modeldata":_vm.model.push_notifications,"locations":_vm.model.locations_details,"defaultData":_vm.defaultData['push_notifications']}})],1):_vm._e(),_vm._v(" "),(_vm.isTaxLabeling)?_c('div',[_c('tax-form',{attrs:{"modeldata":_vm.model,"defaultData":_vm.defaultData,"taxesData":_vm.taxes},on:{"setSelectedTab":_vm.setSelectedTab,"setTaxes":_vm.setTaxes}})],1):_vm._e(),_vm._v(" "),(_vm.isMeasurementsUnits)?_c('div',[(_vm.selectedMeasurementsUnits !== false)?[_c('measurements-units-form',{attrs:{"callback":_vm.measurementsUnitsUpdate,"zoneId":_vm.selectedMeasurementsUnits},on:{"on-submit":_vm.onUserSubmit}})]:[_c('measurements-units-list',{ref:"tableMeasurementsUnits",attrs:{"isTable":_vm.isMeasurementsUnits,"callback":_vm.getMeasurementsUnits}})]],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RR5O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RU0y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CantarForm_vue__ = __webpack_require__("HJlf");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CantarForm', __WEBPACK_IMPORTED_MODULE_7__CantarForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "RUDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group integration-menu-top-categories"},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","filterable":"","clearable":"","collapse-tags":"","size":"small","disabled":_vm.disabled,"placeholder":_vm.$t('gestiune.integrationsMenuTopCategoriesPlaceholder')},on:{"change":_vm.onSelectionChange},model:{value:(_vm.selectedIds),callback:function ($$v) {_vm.selectedIds=$$v},expression:"selectedIds"}},_vm._l((_vm.activeTopCategories),function(item){return _c('el-option',{key:'menu-top-cat-' + item.id,attrs:{"value":item.id,"label":item.name}})})),_vm._v(" "),_c('small',{staticClass:"integration-menu-top-categories__hint mar-to-10"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('gestiune.integrationsMenuTopCategoriesHint'))+"\n    ")]),_vm._v(" "),(_vm.showFilterNote)?_c('small',{staticClass:"integration-menu-top-categories__hint"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('gestiune.integrationsMenuTopCategoriesExportNote'))+"\n    ")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RVZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_WOLT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_WOLT_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEFAULT_WOLT_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEFAULT_WOLT_CLIENT_SECRET; });
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultWoltSchedule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Integrations_integrationLocationHelpers_js__ = __webpack_require__("fX4L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__ = __webpack_require__("3z7E");









var DEFAULT_WOLT_API_URL = 'https://pos-integration-service.wolt.com';
var DEFAULT_WOLT_API_KEY = '8XQROyovhJN3-zbg4xjfvKshrvSfbAglVi6jODoSbvE=';
var DEFAULT_WOLT_CLIENT_ID = 'b1eff6b5-1bf7-4ba2-b899-1e8c3b9c356e';
var DEFAULT_WOLT_CLIENT_SECRET = 'IAsSkcQ0djcT9RqfemhhZTsTfQ';

function defaultWoltSchedule() {
  var day = {
    open: true,
    intervals: [{ opening_time: '10:00', closing_time: '22:00' }]
  };
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()({ length: 7 }, function () {
    return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(day));
  });
}

/* harmony default export */ __webpack_exports__["f"] = ({
  name: 'WoltIntegrationForm',
  props: {
    formData: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    requiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    validationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showFieldValidation: {
      type: Boolean,
      default: false
    },
    topCategories: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {
    this.ensureSchedule();
    this.ensureBooleanDefaults();
    this.ensureDefaults();
  },

  methods: {
    fieldLabel: function fieldLabel(field) {
      if (typeof this.fieldLabelFn === 'function') return this.fieldLabelFn(field);
      return field;
    },
    isRequired: function isRequired(field) {
      return (this.requiredFields || []).includes(field);
    },
    hasFieldError: function hasFieldError(field) {
      return Boolean(this.validationErrors && this.validationErrors[field]);
    },
    showFieldError: function showFieldError(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["a" /* hasIntegrationFieldError */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData
      });
    },
    fieldErrorMessage: function fieldErrorMessage(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["b" /* getIntegrationFieldErrorMessage */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData,
        requiredMessage: this.$t('validations.requiredField')
      });
    },
    locationOptionValue: function locationOptionValue(loc) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Integrations_integrationLocationHelpers_js__["b" /* integrationLocationOptionValue */])(loc);
    },
    ensureSchedule: function ensureSchedule() {
      if (!Array.isArray(this.formData.schedule) || !this.formData.schedule.length) {
        this.$set(this.formData, 'schedule', defaultWoltSchedule());
      }
    },
    ensureBooleanDefaults: function ensureBooleanDefaults() {
      var _this = this;

      var boolFields = ['active', 'is_auto_accept'];
      boolFields.forEach(function (f) {
        if (_this.formData[f] === undefined || _this.formData[f] === null || _this.formData[f] === '') {
          _this.$set(_this.formData, f, false);
        } else {
          _this.$set(_this.formData, f, Boolean(_this.formData[f]));
        }
      });
    },
    ensureDefaults: function ensureDefaults() {
      var _this2 = this;

      var defaults = {
        api_url: DEFAULT_WOLT_API_URL,
        api_key: DEFAULT_WOLT_API_KEY,
        client_id: DEFAULT_WOLT_CLIENT_ID,
        client_secret: DEFAULT_WOLT_CLIENT_SECRET
      };
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(defaults).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        var current = _this2.formData[key];
        if (current === undefined || current === null || String(current).trim() === '') {
          _this2.$set(_this2.formData, key, value);
        }
      });
    }
  }
});

/***/ }),

/***/ "RVli":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RWjY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RX1z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CampaignForm_vue__ = __webpack_require__("tLlR");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CampaignForm', __WEBPACK_IMPORTED_MODULE_7__CampaignForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      campaignModel: {},
      campaign: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onCampaignSubmit: function onCampaignSubmit(model, isValid) {
      this.campaignModel = model;
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "RYJx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"box-container row"},_vm._l((_vm.routess),function(route,index){return _c('div',{key:route.name,staticClass:"col-md-4"},[_c('router-link',{staticClass:"box",style:({ backgroundColor: _vm.getBoxColor(index) }),attrs:{"to":route.path}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(route.name))]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.getImageForRoute(route.name),"alt":'Image for ' + route.name}})])])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RYO5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardProgramForm_vue__ = __webpack_require__("gK/d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d5076f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardProgramForm_vue__ = __webpack_require__("U5bR");
function injectStyle (ssrContext) {
  __webpack_require__("yi0V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardProgramForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d5076f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardProgramForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RZnj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductOptionsForm_vue__ = __webpack_require__("sDlK");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ProductOptionsForm', __WEBPACK_IMPORTED_MODULE_7__ProductOptionsForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      productOptionsModel: {},
      kdsSections: [],
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };

    this.apiRequest('/sections', 'GET', data, function (response) {
      if (response.status) {
        _this.kdsSections = response.data;
      }
    });
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.productOptionsModel = model;
    }
  }
});

/***/ }),

/***/ "Ra/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");























__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_time_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    ChartPieCard: __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */],
    ChartBarsCard: __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]
  },
  props: {
    isDashboardReport: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    firstRowCards: function firstRowCards() {
      return {
        'new_orders': this.statsCards.new_orders,
        'total_orders': this.statsCards.total_orders,
        'revenue': this.statsCards.revenue,
        'installed_apps': this.statsCards.installed_apps
      };
    },
    secondRowCards: function secondRowCards() {
      return {
        'orders_with_discount': this.statsCards.orders_with_discount,
        'total_discount': this.statsCards.total_discount,
        'orders_with_fidelity': this.statsCards.orders_with_fidelity,
        'total_fidelity_discount': this.statsCards.total_fidelity_discount
      };
    },
    hasPaymentMethodData: function hasPaymentMethodData() {
      return this.paymentMethodSales.data.labels.length > 0 && this.paymentMethodSales.data.series.length > 0 && this.paymentMethodSales.data.series[0] && this.paymentMethodSales.data.series[0].some(function (val) {
        return val > 0;
      });
    },
    hasTopProdsData: function hasTopProdsData() {
      return this.topProdsChart.data.labels.length > 0 && this.topProdsChart.data.series.length > 0 && this.topProdsChart.data.series[0] && this.topProdsChart.data.series[0].some(function (val) {
        return val > 0;
      });
    },
    hasDeliveryData: function hasDeliveryData() {
      return this.deliveryChart.data.labels.length > 0 && this.deliveryChart.data.series.length > 0 && this.deliveryChart.data.series[0] && this.deliveryChart.data.series[0].some(function (val) {
        return val > 0;
      });
    }
  },
  watch: {
    isDashboardReport: function isDashboardReport() {
      this.initializeData();
      this.verifyUserLocations();
      this.getPosUsers();
      this.getData();
    },
    hasPaymentMethodData: function hasPaymentMethodData() {
      return this.paymentMethodSales.data.labels.length > 0 && this.paymentMethodSales.data.series.length > 0 && this.paymentMethodSales.data.series[0] && this.paymentMethodSales.data.series[0].some(function (val) {
        return val > 0;
      });
    },
    hasTopProdsData: function hasTopProdsData() {
      return this.topProdsChart.data.labels.length > 0 && this.topProdsChart.data.series.length > 0 && this.topProdsChart.data.series[0] && this.topProdsChart.data.series[0].some(function (val) {
        return val > 0;
      });
    },
    hasDeliveryData: function hasDeliveryData() {
      return this.deliveryChart.data.labels.length > 0 && this.deliveryChart.data.series.length > 0 && this.deliveryChart.data.series[0] && this.deliveryChart.data.series[0].some(function (val) {
        return val > 0;
      });
    }
  },
  data: function data() {
    return {
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      locations: [],
      showLocations: false,
      posUsers: [],
      selectedPosUser: '',
      cardsClass: 'col-lg-3 col-sm-12',
      valid_from: '00:00',
      valid_to: '23:59',
      loading: false,
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_11_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_11_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      statsCards: {
        'new_orders': {
          type: 'warning',
          icon: 'dash1.png',
          title: this.$t('dashboard.tile1Title'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'total_orders': {
          type: 'success',
          icon: 'dash2.png',
          title: this.$t('dashboard.tile2Title'),
          value: '',
          canceled: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'revenue': {
          type: 'danger',
          icon: 'dash3.png',
          title: this.$t('dashboard.tile3Title'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'installed_apps': {
          type: 'info',
          icon: 'dash2.png',
          title: this.$t('dashboard.tile4Title'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'orders_with_discount': {
          type: 'warning',
          icon: 'dash1.png',
          title: this.$t('reports.ordersWithDiscount'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'total_discount': {
          type: 'success',
          icon: 'dash2.png',
          title: this.$t('reports.totalDiscount'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'orders_with_fidelity': {
          type: 'danger',
          icon: 'dash3.png',
          title: this.$t('reports.ordersWithFidelity'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        },
        'total_fidelity_discount': {
          type: 'info',
          icon: 'dash2.png',
          title: this.$t('reports.totalFidelityDiscount'),
          value: '',
          footerText: this.$t('dashboard.today'),
          footerIcon: 'ti-calendar'
        }
      },
      ordersChart: {
        data: {
          labels: [],
          series: [],
          canceled: [],
          delivered: []
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          },
          height: '200px'
        }
      },
      salesChart: {
        data: {
          labels: ['9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'],
          series: []
        },
        options: {
          showArea: true,
          height: '200px',
          axisX: {
            showGrid: false
          },
          showLine: true
        }
      },
      topProdsChart: {
        title: 'Today',
        data: {
          labels: ['Cappucinno', 'Ristretto', 'Expresso', 'Ice coffe', 'Cookie'],
          series: [[411, 345, 201, 189, 157]]
        },
        options: {
          seriesBarDistance: 10,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      deliveryChart: {
        title: 'Today',
        data: {
          labels: ['Pick-up', 'Meet me half-way', 'On Location', 'Delivery'],
          series: [[411, 345, 201, 189]]
        },
        options: {
          seriesBarDistance: 10,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      paymentMethodSales: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '500px',
          axisX: {
            scaleMinSpace: 50,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      colors: ['#f44336', '#2196f3', '#ff9800', '#9c27b0', '#00bcd4', '#8bc34a', '#ffc107', '#3f51b5', '#ff5722', '#795548', '#607d8b', '#009688', '#cddc39', '#673ab7', '#03a9f4', '#aed581', '#ffb74d', '#ba68c8']
    };
  },

  methods: {
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      } else {
        this.orders.location = '';
      }
    },
    getPosUsers: function getPosUsers() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this.posUsers = response.data.pos_user;
        }
      });
    },
    initializeData: function initializeData() {},
    changeValidFrom: function changeValidFrom() {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    updateData: function updateData() {
      this.getData();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    getData: function getData() {
      if (!this.isDashboardReport) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
        this.cardsClass = 'col-lg-3 col-sm-12';
      } else {
        this.cardsClass = 'col-lg-3 col-sm-12';
      }

      if (this.selectedPosUser && this.selectedPosUser !== '') {
        data.operator_id = this.selectedPosUser;
      }

      this.loading = true;

      this.apiRequest('/reports/v2/dashboard-report', 'GET', data, function (response) {
        if (response.status === true) {
          self.ordersChart.data.labels = response.data.orders.labels;
          self.ordersChart.data.series = [response.data.orders.delivered];
          self.$refs.refOrdersChart.initChart();

          self.salesChart.data.labels = response.data.sales.labels;
          self.salesChart.data.series = [response.data.sales.values];
          self.$refs.salesChart.initChart();

          self.topProdsChart.data.labels = response.data.top_products.labels;
          self.topProdsChart.data.series = [response.data.top_products.values];
          self.$nextTick(function () {
            if (self.$refs.topProdsChart) {
              self.$refs.topProdsChart.initChart();
            }
          });

          self.deliveryChart.data.labels = response.data.delivery_types.labels;
          self.deliveryChart.data.series = [response.data.delivery_types.values];
          self.$nextTick(function () {
            if (self.$refs.deliveryChart) {
              self.$refs.deliveryChart.initChart();
            }
          });

          self.apiRequest('/reports/v2/sales-payment-type', 'GET', data, function (pmResponse) {
            if (pmResponse.status === true && pmResponse.data) {
              if (pmResponse.data.payment_types && pmResponse.data.payment_types.length) {
                self.$nextTick(function () {
                  self.paymentMethodSales.options.chartPadding = {
                    top: 30,
                    right: 10,
                    bottom: 20,
                    left: 20
                  };

                  if (pmResponse.data.payment_types && pmResponse.data.payment_types.length) {
                    self.paymentMethodSales.data.labels = pmResponse.data.payment_types.map(function (item) {
                      return self.$t('paymentTypes.' + item);
                    });
                  }

                  self.paymentMethodSales.data.series = [pmResponse.data.total_amounts];

                  self.$nextTick(function () {
                    if (self.$refs.paymentMethodSales) {
                      self.$refs.paymentMethodSales.initChartAndReturn();

                      if (self.$refs.paymentMethodSales.chart) {
                        self.$refs.paymentMethodSales.chart.on('draw', function (data) {
                          if (data.type === 'bar') {
                            data.element.attr({
                              style: 'stroke: ' + self.colors[data.index % self.colors.length] + '; stroke-width: 60px;'
                            });
                          }
                        });
                      }
                    }
                  });
                });
              } else {
                self.paymentMethodSales.data.labels = [];
                self.paymentMethodSales.data.series = [[]];
                self.$nextTick(function () {
                  if (self.$refs.paymentMethodSales && self.$refs.paymentMethodSales.chart) {
                    self.$refs.paymentMethodSales.initChartAndReturn();
                  }
                });
              }
            } else {
              self.paymentMethodSales.data.labels = [];
              self.paymentMethodSales.data.series = [[]];
              self.$nextTick(function () {
                if (self.$refs.paymentMethodSales && self.$refs.paymentMethodSales.chart) {
                  self.$refs.paymentMethodSales.initChartAndReturn();
                }
              });
            }
          });

          self.statsCards.new_orders.value = response.data.counters.new_orders;
          self.statsCards.total_orders.value = response.data.counters.total_orders;
          self.statsCards.total_orders.canceled = response.data.counters.total_canceled;
          self.statsCards.revenue.value = response.data.counters.revenue;
          self.statsCards.installed_apps.value = response.data.order_average;
          self.statsCards.orders_with_discount.value = response.data.orders_with_discount || 0;
          var totalDiscountValue = response.data.total_discount !== undefined && response.data.total_discount !== null ? response.data.total_discount : 0;
          var currencyIso = self.$session.get('selectedCompanyData')['currency_iso'];
          var currencyPosition = self.getCurrencyPosition(currencyIso);
          var formattedDiscount = totalDiscountValue === 0 ? '0' : parseFloat(totalDiscountValue).toFixed(2);
          self.statsCards.total_discount.value = currencyPosition === 'left' ? currencyIso + ' ' + formattedDiscount : formattedDiscount + ' ' + currencyIso;
          self.statsCards.orders_with_fidelity.value = response.data.orders_with_fidelity || 0;
          var totalFidelityDiscountValue = response.data.total_fidelity_discount !== undefined && response.data.total_fidelity_discount !== null ? response.data.total_fidelity_discount : 0;
          var formattedFidelityDiscount = totalFidelityDiscountValue === 0 ? '0' : parseFloat(totalFidelityDiscountValue).toFixed(2);
          self.statsCards.total_fidelity_discount.value = currencyPosition === 'left' ? currencyIso + ' ' + formattedFidelityDiscount : formattedFidelityDiscount + ' ' + currencyIso;
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
        }

        self.$nextTick(function () {
          self.loading = false;
        });
      });
    },
    exportData: function exportData() {
      var _this2 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.selectedPosUser && this.selectedPosUser !== '') {
        data.operator = this.selectedPosUser;
      }

      this.loading = true;
      this.apiRequest('/reports/dashboard-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
        }
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "RaHM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ray4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('kds-section-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RcJs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RdNT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopCategoryAdd_vue__ = __webpack_require__("YGYh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1af2aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopCategoryAdd_vue__ = __webpack_require__("jKpd");
function injectStyle (ssrContext) {
  __webpack_require__("k5Wm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopCategoryAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1af2aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopCategoryAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rk5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      allLocations: [],
      vatNumber: null,
      selectedLocation: null
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getBons(this.selectedLocation, this.currentPage, this.pageSize);
    },
    onSearch: function onSearch() {
      if (!this.selectedLocation || Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        });

        this.tableData = [];
        this.totalItems = 0;

        return;
      }

      var locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation];

      this.getBons(locations);
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getBons(this.selectedLocation, this.currentPage, this.pageSize);
    },
    getGestiuneNameById: function getGestiuneNameById(id) {
      var gest = this.gestiuneOptions.find(function (g) {
        return g._id === id || g.id === id;
      });
      return gest ? gest.name : id;
    },
    addBonTransfer: function addBonTransfer() {
      this.$router.push('/management/transfer/add');
    },
    editBonTransfer: function editBonTransfer(row) {
      this.$router.push('/management/transfer/edit/' + row.series + '/' + row.documentNumber);
    },
    getBons: function getBons() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, ids, allLocations, _ids, response, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;

                params = new URLSearchParams({
                  externalCompanyId: _this.companyID,
                  tip: 'bon_transfer'
                });


                params.append('page', page);
                params.append('limit', pageSize);

                if (location) {
                  if (Array.isArray(location)) {
                    ids = location.map(function (l) {
                      return l.true_id;
                    }).filter(Boolean);

                    ids.forEach(function (id) {
                      return params.append('externalLocationId', id);
                    });
                  } else if (location.id && location.true_id) {
                    params.append('externalLocationId', location.true_id);
                  }
                } else {
                  allLocations = _this.groupedLocations.flatMap(function (group) {
                    return group.locations;
                  });
                  _ids = allLocations.map(function (l) {
                    return l.true_id;
                  }).filter(Boolean);

                  _ids.forEach(function (id) {
                    return params.append('externalLocationId', id);
                  });
                }

                clearTimeout(_this.loadingTimeout);
                _this.loadingTimeout = setTimeout(function () {
                  _this.loading = true;
                }, 100);

                _context.next = 10;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/bons?' + params.toString(), {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 10:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 13;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 13:
                _context.next = 15;
                return response.json();

              case 15:
                data = _context.sent;


                if (Array.isArray(data.bons)) {
                  clearTimeout(_this.loadingTimeout);
                  _this.loading = false;

                  _this.totalItems = data.total || 0;
                  _this.currentPage = data.currentPage || page;
                  _this.pageSize = data.pageSize || pageSize;

                  _this.tableData = data.bons.map(function (bon) {
                    return {
                      _id: bon._id,
                      documentNumber: bon.documentNumber,
                      gestiune_from: bon.gestiune_from,
                      gestiune_to: bon.gestiune_to,
                      series: bon.series
                    };
                  });
                } else {
                  console.error('Nu s-au găsit bonuri valide.');
                  _this.tableData = [];
                }
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](0);

                clearTimeout(_this.loadingTimeout);
                _this.loading = false;

                console.error('Error fetching bons:', _context.t0);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 19]]);
      }))();
    },
    handleDeleteBonTransfer: function handleDeleteBonTransfer(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (id) {
                  _context3.next = 3;
                  break;
                }

                console.error('Missing Bon Transfer ID for deletion.');
                return _context3.abrupt('return');

              case 3:

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: 'Ești sigur?',
                  text: 'Această acțiune va șterge definitiv bonul de transfer!',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Da, șterge!',
                  cancelButtonText: 'Anulează'
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
                    var response, data;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!result) {
                              _context2.next = 19;
                              break;
                            }

                            _context2.prev = 1;
                            _context2.next = 4;
                            return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                              method: 'DELETE',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                type: 'bon_transfer',
                                id: id,
                                externalCompanyId: _this2.companyID
                              })
                            });

                          case 4:
                            response = _context2.sent;

                            if (response.ok) {
                              _context2.next = 7;
                              break;
                            }

                            throw new Error('HTTP error! Status: ' + response.status);

                          case 7:
                            _context2.next = 9;
                            return response.json();

                          case 9:
                            data = _context2.sent;

                            console.log('Bon transfer deleted successfully:', data);

                            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                              title: 'Succes!',
                              text: 'Bonul de transfer a fost șters cu succes.',
                              type: 'success',
                              timer: 2000,
                              showConfirmButton: false
                            });

                            _this2.getBons();
                            _context2.next = 19;
                            break;

                          case 15:
                            _context2.prev = 15;
                            _context2.t0 = _context2['catch'](1);

                            console.error('Error deleting Bon Transfer:', _context2.t0);

                            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                              title: 'Eroare!',
                              text: 'A apărut o problemă la ștergerea bonului de transfer.',
                              type: 'error',
                              timer: 2000,
                              showConfirmButton: false
                            });

                          case 19:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2, [[1, 15]]);
                  }));

                  return function (_x4) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    downloadExcel: function downloadExcel(row) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var type, series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                type = 'bon_transfer';
                series = row.series;
                invoiceNumber = row.documentNumber;
                externalCompanyId = _this3.companyID;

                if (!(!type || !series || !invoiceNumber || !externalCompanyId)) {
                  _context4.next = 7;
                  break;
                }

                alert('Missing type, series, invoice number or company ID.');
                return _context4.abrupt('return');

              case 7:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/' + type + '/' + series + '-' + invoiceNumber + '/xls?externalCompanyId=' + externalCompanyId;
                _context4.prev = 8;
                _context4.next = 11;
                return fetch(url);

              case 11:
                response = _context4.sent;

                if (!response.ok) {
                  _context4.next = 23;
                  break;
                }

                _context4.next = 15;
                return response.blob();

              case 15:
                blob = _context4.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = type + '-' + series + '-' + invoiceNumber + '.xls';
                link.click();
                URL.revokeObjectURL(link.href);
                _context4.next = 24;
                break;

              case 23:
                console.error('Error downloading document:', response.statusText);

              case 24:
                _context4.next = 29;
                break;

              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4['catch'](8);

                console.error('Error fetching document:', _context4.t0);

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[8, 26]]);
      }))();
    },
    download: function download(row) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var type, series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                type = 'bon_transfer';
                series = row.series;
                invoiceNumber = row.documentNumber;
                externalCompanyId = _this4.companyID;

                if (!(!type || !series || !invoiceNumber || !externalCompanyId)) {
                  _context5.next = 7;
                  break;
                }

                alert('Missing type, series, invoice number or company ID.');
                return _context5.abrupt('return');

              case 7:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/' + type + '/' + series + '-' + invoiceNumber + '/pdf?externalCompanyId=' + externalCompanyId;
                _context5.prev = 8;
                _context5.next = 11;
                return fetch(url);

              case 11:
                response = _context5.sent;

                if (!response.ok) {
                  _context5.next = 23;
                  break;
                }

                _context5.next = 15;
                return response.blob();

              case 15:
                blob = _context5.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = type + '-' + series + '-' + invoiceNumber + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                _context5.next = 24;
                break;

              case 23:
                console.error('Error downloading document:', response.statusText);

              case 24:
                _context5.next = 29;
                break;

              case 26:
                _context5.prev = 26;
                _context5.t0 = _context5['catch'](8);

                console.error('Error fetching document:', _context5.t0);

              case 29:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4, [[8, 26]]);
      }))();
    }
  }
});

/***/ }),

/***/ "RnFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db917ef4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementUsers_vue__ = __webpack_require__("H9EB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db917ef4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rq+r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CantarForm_vue__ = __webpack_require__("HJlf");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CantarForm', __WEBPACK_IMPORTED_MODULE_7__CantarForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "RqIF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rt3n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-end","gap":"10px","flex-wrap":"nowrap","margin-bottom":"20px"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"nowrap","gap":"8px","align-items":"flex-end","flex":"0 1 auto"}},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.id')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('catalogProd.id'),"size":"small","clearable":""},model:{value:(_vm.searchId),callback:function ($$v) {_vm.searchId=$$v},expression:"searchId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 180px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('catalogProd.name'),"size":"small","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(_vm.locations.length)?_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 200px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select'),"size":"small","multiple":"","collapse-tags":"","clearable":""},model:{value:(_vm.selectedLocations),callback:function ($$v) {_vm.selectedLocations=$$v},expression:"selectedLocations"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:loc.id || loc.true_id,attrs:{"label":loc.name,"value":loc.true_id || loc.id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.searchMaps}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"right-group",staticStyle:{"flex":"0 0 auto"}},[_c('button',{staticClass:"btn add",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"10","prop":"name","label":"ID"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.id || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"name","label":"Name"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.name ? props.row.name : "-"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"name","label":"Location"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.location.name ? props.row.location.name : "-"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":320,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.send')},on:{"click":function($event){_vm.handleDelete(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")])]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RuEO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15 report-toolbar"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"filters-applied-row"},[_c('el-button',{staticStyle:{"margin-right":"10px"},attrs:{"type":"primary","size":"small"},on:{"click":_vm.openFiltersModal}},[_vm._v("\n            "+_vm._s(_vm.$t('orders.filters'))+"\n          ")]),_vm._v(" "),(_vm.appliedFilters.length)?[_c('span',{staticClass:"filters-applied-label"},[_vm._v(_vm._s(_vm.$t('orders.filtersList'))+":")]),_vm._v(" "),_vm._l((_vm.appliedFilters),function(flt,idx){return _c('span',{key:'sales-filter-' + idx,staticClass:"filter-selection"},[_vm._v("\n              "+_vm._s(flt)+"\n            ")])}),_vm._v(" "),_c('a',{staticClass:"reset-filters-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.resetFilters()}}},[_vm._v(_vm._s(_vm.$t('orders.resetFilters')))])]:[_c('span',{staticClass:"filters-applied-label"},[_vm._v(_vm._s(_vm.$t('orders.noFiltersApplied')))])]],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"sales-date-row"},[_c('el-date-picker',{staticClass:"sales-date-picker",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}}),_vm._v(" "),_c('span',{staticClass:"sales-date-text"},[_vm._v(_vm._s(_vm.$t('general.from')))]),_vm._v(" "),_c('div',{staticClass:"sales-time-range"},[_c('el-time-select',{staticClass:"mar-rt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v(" "),_c('span',{staticClass:"sales-date-text"},[_vm._v(_vm._s(_vm.$t('general.to')))]),_vm._v(" "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_column),expression:"date_column"}],staticClass:"form-control sales-date-column",staticStyle:{"width":"auto","min-width":"140px","margin-left":"10px","margin-right":"10px","height":"40px"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.date_column=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"created_at"}},[_vm._v(_vm._s(_vm.$t('reports.dateColumnCreate')))]),_vm._v(" "),_c('option',{attrs:{"value":"closed_at"}},[_vm._v(_vm._s(_vm.$t('reports.dateColumnClose')))]),_vm._v(" "),_c('option',{attrs:{"value":"fiscalized_at"}},[_vm._v(_vm._s(_vm.$t('reports.dateColumnFiscalize')))])]),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports pull-left",staticStyle:{"margin-bottom":"0 !important"},attrs:{"title":_vm.$t('reports.export')}},[(this.$route.query && this.$route.query.ver !== 'V2')?_c('download-excel',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"fetch":_vm.clientsExportData,"export-fields":_vm.json_fields,"name":_vm.export_name,"before-generate":_vm.startDownload,"before-finish":_vm.finishDownload}},[_vm._v("\n            "+_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})]):_vm._e(),_vm._v(" "),(this.$route.query && this.$route.query.ver === 'V2')?_c('download-excel',{staticClass:"btn btn-icon btn-xls-slim btn-success",attrs:{"fetch":_vm.clientsExportData,"fields":_vm.jsonFields,"name":_vm.export_name,"before-generate":_vm.startDownload,"before-finish":_vm.finishDownload}},[_c('i',{staticClass:"ti-download"})]):_vm._e()],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row mar-bt-15 summary-cards-row"},[_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card primary"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalSum')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.total || 0).toFixed(2))))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.ordersNumber')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.totalOrders || 0))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.totals_discount')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalDiscountItems || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.totals_discount_loyalty_points')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalDiscountLoyaltyPoints || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.totalTax')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalTax || 0).toFixed(2))))])]),_vm._v(" "),(_vm.totals.totalSlotTax)?_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v("  "+_vm._s(_vm.$t('reports.slotTax')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalSlotTax || 0).toFixed(2))))])]):_vm._e(),_vm._v(" "),(_vm.totals.totalSlotPartTax)?_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v("  "+_vm._s(_vm.$t('reports.slotPartTax')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalSlotPartTax || 0).toFixed(2))))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.shipping')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalShipping || 0).toFixed(2))))])]),_vm._v(" "),(_vm.use_tips)?[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.tips')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalTips || 0).toFixed(2))))])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.splitVoucher')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalSplitVoucher || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.woltOtherMethods')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalWoltOtherMethods || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unpaid')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalUnpaid || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unfiscalTotal')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.unfiscalTotal || 0).toFixed(2))))])])],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalCash')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v("\n            "+_vm._s(_vm.formatMoneyAmount((_vm.cashSummaryTotal || 0).toFixed(2)))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.cash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalCash || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.glovoCash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalGlovoCash || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.boltCash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalBoltCash || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.woltCash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalWoltCash || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.splitCash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalSplitCash || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unfiscalCash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.unfiscalTotalCash || 0).toFixed(2))))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalOnline')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v("\n            "+_vm._s(_vm.formatMoneyAmount((_vm.totalOnlineSummaryTotal || 0).toFixed(2)))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.card')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalCard || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.online')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalOnline || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unfiscalOnline')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.unfiscalTotalOnline || 0).toFixed(2))))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-bt-15 summary-cards-row"},[_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalCard')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totalCardSummaryTotal || 0).toFixed(2))))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.pos')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalPOS || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.cardPos')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalCARDPOS || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.splitCardPos')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalSplitCard || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unfiscalCard')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.unfiscalTotalCard || 0).toFixed(2))))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalCredit')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totalCreditSummaryTotal || 0).toFixed(2))))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.boltCard')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalBoltCard || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.glovoCard')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalGlovoCard || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.woltCard')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalWoltCard || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.unfiscalCredit')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.unfiscalTotalCredit || 0).toFixed(2))))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"sales-summary-card"},[_c('div',{staticClass:"sales-summary-title"},[_vm._v(_vm._s(_vm.$t('reports.totalNonFiscal')))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-total"},[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.nonFiscalSummaryTotal || 0).toFixed(2))))]),_vm._v(" "),_c('div',{staticClass:"sales-summary-list"},[_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.protocol')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalProtocol || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.staffFood')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalStaffFood || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.virament')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalVirament || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.room')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalRoom || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.event')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalEvent || 0).toFixed(2))))])]),_vm._v(" "),_c('div',{staticClass:"sales-summary-item"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.folio')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatMoneyAmount((_vm.totals.totalFolio || 0).toFixed(2))))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:((_vm.loading && !_vm.isFiltersModalOpen) || _vm.exportLoading),expression:"(loading && !isFiltersModalOpen) || exportLoading"}],staticClass:"card-content total-pagination reports-center-columns"},[_c('data-tables-server',{key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"search-def":{show: false},"total":_vm.totalOrders,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged,"row-click":_vm.goToRecordOrder}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":140,"prop":"id","label":_vm.$t('reports.orderId')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":200,"prop":"location","label":_vm.$t('reports.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.getLocationName(props.row.store_id))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":140,"prop":"created_at","label":_vm.$t('reports.date')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":140,"prop":"updated_at","label":_vm.$t('reports.closingOrder')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"token","label":'# '+_vm.$t('reports.order')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"number","label":_vm.$t('reports.number')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"table_number","label":_vm.$t('reports.tableNumber')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.table_number ? props.row.table_number : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":150,"label":_vm.$t('reports.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.customer.firstname)+" "+_vm._s(props.row.customer.lastname)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"class-name":"centered-cell","prop":"totals_grandtotal","label":_vm.$t('reports.totalSum')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(props.row.totals_grandtotal))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"class-name":"centered-cell","label":_vm.$t('reports.discount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(props.row.totals_discount + props.row.totals_discount_loyalty_points))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"class-name":"centered-cell","label":_vm.$t('reports.couponCode')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.coupon)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"class-name":"centered-cell","label":_vm.$t('reports.tax')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(props.row.totals_extras))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"class-name":"centered-cell","label":_vm.$t('reports.shipping')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(props.row.totals_shipping || 0))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":130,"class-name":"centered-cell","label":_vm.$t('reports.delivery_type')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.$t('settingCompany.'+ props.row.delivery_type.toLowerCase()))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":130,"class-name":"centered-cell","label":_vm.$t('reports.zone')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.shipping_details && props.row.shipping_details.hasOwnProperty('name'))?_c('span',[_vm._v(_vm._s(props.row.shipping_details.name))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":130,"prop":"payment_type","label":_vm.$t('reports.paymentType')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.$t('paymentTypes.' + props.row.payment_type))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":140,"class-name":"centered-cell","label":_vm.$t('reports.receiptNumber')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatReceiptNumber(props.row.receipt_number))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"class-name":"centered-cell","label":_vm.$t('reports.zet')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.parseZet(props.row.receipt_number))+"\n              ")]}}])})],1)],1)])])]),_vm._v(" "),_c('vmodal',{staticClass:"filtersAndSortModal sales-report-filters",attrs:{"name":"salesReportBetaFiltersModal","height":"auto","width":"1200","adaptive":true,"scrollable":true}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header slim-header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('orders.filters')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body slim-body"},[_c('div',{staticClass:"filters-grid sales-report-filters-grid"},[_c('div',{staticClass:"modal-column-left"},[(_vm.showLocations)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalOrders.location),expression:"modalOrders.location"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modalOrders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'loc-' + loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.taxation')))]),_vm._v(" "),_c('v-select',{key:'has-receipt-select-modal',staticClass:"w-100 white line-heigth-44",attrs:{"options":_vm.receiptOptions,"label":"label","placeholder":_vm.$t('general.all')},model:{value:(_vm.modalHasReceipt),callback:function ($$v) {_vm.modalHasReceipt=$$v},expression:"modalHasReceipt"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.zet')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalZet),expression:"modalZet"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":_vm.$t('reports.zet')},domProps:{"value":(_vm.modalZet)},on:{"input":function($event){if($event.target.composing){ return; }_vm.modalZet=$event.target.value}}})]),_vm._v(" "),(_vm.showMethods)?_c('div',{staticClass:"filter-section wide-filter"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectMethod')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"multiple":"","collapse-tags":"","clearable":"","filterable":""},model:{value:(_vm.modalOrders.methods),callback:function ($$v) {_vm.$set(_vm.modalOrders, "methods", $$v)},expression:"modalOrders.methods"}},_vm._l((_vm.methods),function(m){return _c('el-option',{key:m.key || m,attrs:{"label":m.label || m,"value":m.key || m}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectClient')))]),_vm._v(" "),_c('el-select',{ref:"userSelect",staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","reserve-keyword":"","clearable":"","placeholder":_vm.$t('general.search'),"remote-method":_vm.searchUsers,"loading":_vm.loadingUsers},on:{"change":_vm.clearUserSearch},model:{value:(_vm.modalSelectedUser),callback:function ($$v) {_vm.modalSelectedUser=$$v},expression:"modalSelectedUser"}},[_c('el-option',{attrs:{"value":'',"label":_vm.$t('general.alls')}}),_vm._v(" "),_vm._l((_vm.mergedUsers),function(usr){return _c('el-option',{key:'usr-' + usr.id,attrs:{"label":(usr.firstname && usr.lastname) ? (usr.firstname + ' ' + usr.lastname) : (usr.email || ''),"value":usr.id}})})],2)],1),_vm._v(" "),(_vm.posUsers.length)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.operator')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalSelectedPosUser),expression:"modalSelectedPosUser"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.modalSelectedPosUser=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.alls')}},[_vm._v(_vm._s(_vm.$t('general.alls')))]),_vm._v(" "),_vm._l((_vm.posUsers),function(operator){return _c('option',{key:'op-' + operator.id,attrs:{"label":operator.firstname + ' ' + operator.lastname},domProps:{"value":operator.id}},[_vm._v("\n                      "+_vm._s(operator.firstname)+" "+_vm._s(operator.lastname)+"\n                    ")])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',{staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(_vm.$t('pages.topCategory')))]),_vm._v(" "),_c('el-select',{ref:"categorySelect",staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"value-key":"id","multiple":"","filterable":"","remote":"","collapse-tags":"","reserve-keyword":"","clearable":"","placeholder":_vm.$t('general.search'),"remote-method":_vm.searchTopCategories,"loading":_vm.loadingCategories},on:{"change":_vm.clearCategorySearch},model:{value:(_vm.modalSelectedCategories),callback:function ($$v) {_vm.modalSelectedCategories=$$v},expression:"modalSelectedCategories"}},_vm._l((_vm.mergedCategories),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"modal-column-right"},[(_vm.orderFormFlags.length)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectedOrderFormFlags')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalSelectedOrderFrom),expression:"modalSelectedOrderFrom"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.modalSelectedOrderFrom=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.orderFormFlags),function(sts){return _c('option',{key:'of-' + sts,attrs:{"label":sts.toUpperCase()},domProps:{"value":sts}},[_vm._v(_vm._s(sts))])})],2)]):_vm._e(),_vm._v(" "),(_vm.paymentMethods.length)?_c('div',{staticClass:"filter-section wide-filter"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectedPaymentMethods')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",attrs:{"multiple":"","collapse-tags":"","clearable":""},model:{value:(_vm.modalSelectedPaymentMethods),callback:function ($$v) {_vm.modalSelectedPaymentMethods=$$v},expression:"modalSelectedPaymentMethods"}},_vm._l((_vm.paymentMethods),function(pm){return _c('el-option',{key:pm.id,attrs:{"label":pm.name,"value":pm.id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.orderPaidStatus')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalUnpaidOrdersFilter),expression:"modalUnpaidOrdersFilter"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.modalUnpaidOrdersFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.unpaidOrdersFilterOptions),function(opt){return _c('option',{key:'unpaid-filter-' + opt.value,domProps:{"value":opt.value}},[_vm._v("\n                  "+_vm._s(opt.label)+"\n                ")])}))]),_vm._v(" "),_c('div',{staticClass:"filter-section wide-filter"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.tables')))]),_vm._v(" "),_c('el-select',{ref:"salesReportTableSelect",staticClass:"w-100",attrs:{"value-key":"id","filterable":"","remote":"","clearable":"","reserve-keyword":"","placeholder":_vm.$t('settingTable.searchTable'),"remote-method":_vm.searchTables,"loading":_vm.loadingTables},on:{"change":_vm.clearTableSearch},model:{value:(_vm.modalSelectedTable),callback:function ($$v) {_vm.modalSelectedTable=$$v},expression:"modalSelectedTable"}},_vm._l((_vm.mergedSalesReportTables),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item}})}))],1),_vm._v(" "),(_vm.drivers.length)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.selectDriver')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalSelectedDriver),expression:"modalSelectedDriver"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.modalSelectedDriver=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.alls')}},[_vm._v(_vm._s(_vm.$t('general.alls')))]),_vm._v(" "),_vm._l((_vm.drivers),function(drive){return _c('option',{key:'drv-' + drive.id,attrs:{"label":drive.firstname + ' ' + drive.lastname},domProps:{"value":drive.id}},[_vm._v("\n                  "+_vm._s(drive.firstname)+" "+_vm._s(drive.lastname)+"\n                ")])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('dashboard.serchCoupon')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalOrders.search),expression:"modalOrders.search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('dashboard.serchCoupon')},domProps:{"value":(_vm.modalOrders.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modalOrders, "search", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('general.orderId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modalOrderId),expression:"modalOrderId"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"price","placeholder":"3823231"},domProps:{"value":(_vm.modalOrderId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.modalOrderId=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer slim-footer"},[_c('el-button',{attrs:{"type":"default","size":"small"},on:{"click":_vm.resetModalFilters}},[_vm._v(_vm._s(_vm.$t('general.reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.applyFilters}},[_vm._v(_vm._s(_vm.$t('general.apply')))])],1)])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RucB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rwfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosOrderActionsDetails_vue__ = __webpack_require__("H2Im");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ede38260_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosOrderActionsDetails_vue__ = __webpack_require__("ggir");
function injectStyle (ssrContext) {
  __webpack_require__("R3pE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosOrderActionsDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ede38260_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosOrderActionsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RyIs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuLinkForm_vue__ = __webpack_require__("P3jN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c8b4198_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuLinkForm_vue__ = __webpack_require__("pJrd");
function injectStyle (ssrContext) {
  __webpack_require__("Yp5G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuLinkForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c8b4198_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuLinkForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S/Xs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Integrations_GlovoLaasIntegrationForm_vue__ = __webpack_require__("jAxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Integrations_integrationLocationHelpers_js__ = __webpack_require__("fX4L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__ = __webpack_require__("3z7E");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GlovoIntegrationForm',
  props: {
    formData: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    requiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    validationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showFieldValidation: {
      type: Boolean,
      default: false
    },
    topCategories: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {
    this.ensureDefaults();
  },

  methods: {
    fieldLabel: function fieldLabel(field) {
      if (typeof this.fieldLabelFn === 'function') return this.fieldLabelFn(field);
      return field;
    },
    isRequired: function isRequired(field) {
      return (this.requiredFields || []).includes(field);
    },
    hasFieldError: function hasFieldError(field) {
      return Boolean(this.validationErrors && this.validationErrors[field]);
    },
    showFieldError: function showFieldError(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["a" /* hasIntegrationFieldError */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData
      });
    },
    fieldErrorMessage: function fieldErrorMessage(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["b" /* getIntegrationFieldErrorMessage */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData,
        requiredMessage: this.$t('validations.requiredField')
      });
    },
    locationOptionValue: function locationOptionValue(loc) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Integrations_integrationLocationHelpers_js__["b" /* integrationLocationOptionValue */])(loc);
    },
    ensureDefaults: function ensureDefaults() {
      var url = this.formData.api_url;
      if (url === undefined || url === null || String(url).trim() === '') {
        this.$set(this.formData, 'api_url', __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Integrations_GlovoLaasIntegrationForm_vue__["a" /* DEFAULT_GLOVO_LAAS_API_URL */]);
      }

      var posName = this.formData.pos_implementation_name;
      if (posName === undefined || posName === null || String(posName).trim() === '') {
        this.$set(this.formData, 'pos_implementation_name', __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Integrations_GlovoLaasIntegrationForm_vue__["b" /* DEFAULT_GLOVO_LAAS_POS_IMPLEMENTATION_NAME */]);
      }
    }
  }
});

/***/ }),

/***/ "S6Gb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t7_vue__ = __webpack_require__("vDkz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5347b215_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t7_vue__ = __webpack_require__("u2GW");
function injectStyle (ssrContext) {
  __webpack_require__("HDo4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5347b215"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t7_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5347b215_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t7_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S6Lm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S8Ll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"box-container row"},_vm._l((_vm.screenRoutes),function(route,index){return _c('div',{key:route.name,staticClass:"col-md-4"},[_c('router-link',{staticClass:"box",style:({ backgroundColor: _vm.getBoxColor(index) }),attrs:{"to":route.path}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('kds.' + route.key)))]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.getImageForRoute(route.key),"alt":'Image for ' + route.key}})])])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SB3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromosForm_vue__ = __webpack_require__("i//v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75fb7586_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromosForm_vue__ = __webpack_require__("Hoxq");
function injectStyle (ssrContext) {
  __webpack_require__("x3WR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75fb7586"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromosForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75fb7586_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromosForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SF1l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "SFlb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SGWg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SHkX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('spinning-wheel-campaign-form',{attrs:{"route":_vm.route}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SJ2J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStoreCampaignForm_vue__ = __webpack_require__("bFWQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_749592d5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStoreCampaignForm_vue__ = __webpack_require__("qE+m");
function injectStyle (ssrContext) {
  __webpack_require__("3W1s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStoreCampaignForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_749592d5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStoreCampaignForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SKRm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SQ1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NirsReport_vue__ = __webpack_require__("3Via");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b82f846_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NirsReport_vue__ = __webpack_require__("iY8r");
function injectStyle (ssrContext) {
  __webpack_require__("O5PS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b82f846"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NirsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b82f846_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NirsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SS9M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CouponForm_vue__ = __webpack_require__("zKgQ");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CouponForm: __WEBPACK_IMPORTED_MODULE_0__CouponForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "ST7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SZpq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('pos-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SaRj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SfqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStoreReport_vue__ = __webpack_require__("F87u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348dc57c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStoreReport_vue__ = __webpack_require__("D2O9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStoreReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348dc57c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStoreReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SkgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_email_editor__ = __webpack_require__("zLys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_email_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_email_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__template_json__ = __webpack_require__("4nx0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__template_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__template_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__template2_json__ = __webpack_require__("6CoB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__template2_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__template2_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UploadImageModal_vue__ = __webpack_require__("vrT8");
















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_vue_email_editor__["EmailEditor"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EmailEditor: __WEBPACK_IMPORTED_MODULE_9_vue_email_editor__["EmailEditor"],
    UploadImageModal: __WEBPACK_IMPORTED_MODULE_13__UploadImageModal_vue__["a" /* default */]
  },
  props: {
    modelFromParent: {
      type: [Object, Array],
      required: true
    },
    daysParent: {
      type: Array,
      required: true
    }
  },
  watch: {
    modelFromParent: function modelFromParent(value, oldVal) {
      this.model = value;

      if (this.model.email_json && this.$refs.emailEditor.editor) {
        this.$refs.emailEditor.editor.loadDesign(this.model.email_json);
      } else if (this.$refs.emailEditor.editor) {
        this.$refs.emailEditor.editor.loadDesign(__WEBPACK_IMPORTED_MODULE_11__template_json___default.a);
      }
      this.editorLoaded();
    },
    daysParent: function daysParent(value, oldVal) {
      this.days = value;
    },
    'model.monday': function modelMonday(val) {
      if (val && !this.model.monday_active) this.model.monday_active = 1;
    },
    'model.tuesday': function modelTuesday(val) {
      if (val && !this.model.tuesday_active) this.model.tuesday_active = 1;
    },
    'model.wednesday': function modelWednesday(val) {
      if (val && !this.model.wednesday_active) this.model.wednesday_active = 1;
    },
    'model.thursday': function modelThursday(val) {
      if (val && !this.model.thursday_active) this.model.thursday_active = 1;
    },
    'model.friday': function modelFriday(val) {
      if (val && !this.model.friday_active) this.model.friday_active = 1;
    },
    'model.saturday': function modelSaturday(val) {
      if (val && !this.model.saturday_active) this.model.saturday_active = 1;
    },
    'model.sunday': function modelSunday(val) {
      if (val && !this.model.sunday_active) this.model.sunday_active = 1;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* mapFields */])(['name']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* mapFields */])(['notification_types', 'notification_mode', 'email'])),
  data: function data() {
    return {
      date: {
        trends: {
          'valid': ['2018-01-01', '2018-12-31']
        }
      },
      model: this.value || this.modelFromParent,
      days: this.value || this.daysParent,
      modalState: false,
      locations: [],
      categories: [],
      products: [],
      daysOfWeek: [{ key: 'monday' }, { key: 'tuesday' }, { key: 'wednesday' }, { key: 'thursday' }, { key: 'friday' }, { key: 'saturday' }, { key: 'sunday' }],
      modelValidations: {
        name: {
          required: true
        },
        description: {
          max: 400,
          required: true
        },
        notification_type: {
          required: true
        },
        notification_mode: {
          required: true
        },
        mode: {
          required: true
        },
        time: {
          required: true
        },
        image: {
          required: true
        },
        dateRange: {
          required: true
        }
      },
      couponType: this.$session.get('defaultData')['coupons_types'],
      couponUsageTypes: this.$session.get('defaultData')['coupons_usage_types'],
      pickerOptions1: {},
      pickerNames: ['date_from', 'date_to'],
      desclength: 0,
      pickerOptions: {
        start: '08:00',
        step: '01:00',
        end: '24:00'
      },
      campaignsNotificationTypes: [],
      campaignsModes: [] };
  },
  created: function created() {
    var _this = this;

    this.campaignsNotificationTypes = this.$session.get('defaultData')['campaigns_notification_types'];
    this.campaignsModes = this.$session.get('defaultData')['campaigns_modes'];
    this.getLocations();
    this.getCategories();
    this.$nextTick(function () {
      if (!_this.$route.params.id) {
        _this.$refs.emailEditor.editor.loadDesign(__WEBPACK_IMPORTED_MODULE_11__template_json___default.a);
      }
      _this.model.mode = 'MANUAL';
    });
  },

  methods: {
    getLocations: function getLocations() {
      var _this2 = this;

      if (!this.model.location_token) {
        var requestData = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };
        this.apiRequest('/get-locations', 'GET', requestData, function (response) {
          if (response.status) {
            _this2.locations = response.data;
          }
        });
      }
    },
    getCategories: function getCategories() {
      var _this3 = this;

      if (this.model.link_type === 1 && !this.model.location_token) {
        this.model.category_id = null;
      }
      var requestData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/get-categories', 'GET', requestData, function (response) {
        if (response.status) {
          _this3.categories = response.data;
          _this3.getProducts();
        }
      });
    },
    getProducts: function getProducts() {
      var _this4 = this;

      if (this.model.link_type === 1 && !this.model.category_id) {
        this.model.product_id = null;
      }
      var requestData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        category_id: this.model.category_id,
        location_token: this.model.location_token
      };
      this.apiRequest('/get-products', 'GET', requestData, function (response) {
        if (response.status) {
          _this4.products = response.data;
        }
      });
    },
    setDefaultHour: function setDefaultHour($event, day) {
      if ($event) {
        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.model, day + '_active', 1);
        if (!this.model[day]) {
          __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.model, day, this.pickerOptions.start);
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.model, day + '_active', 0);
        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.model, day, null);
      }
    },
    editorLoaded: function editorLoaded() {
      var _this5 = this;

      this.$refs.emailEditor.editor.addEventListener('design:updated', function (updates) {
        _this5.$refs.emailEditor.editor.exportHtml(function (data) {
          if (data) {
            _this5.model.email_html = data.html;
            _this5.model.email_json = data.design;
          }
        });
      });
      this.$refs.emailEditor.editor.registerCallback('selectImage', function (data, done) {
        _this5.handleUpload().then(function (result) {
          if (result) {
            done({ url: result });
          }
        });
      });
    },
    saveDesign: function saveDesign() {
      var _this6 = this;

      this.$refs.emailEditor.editor.exportHtml(function (data) {
        _this6.model.email_html = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(data.html);
        _this6.model.email_json = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(data.design);
        var requestData = {};
        var id = _this6.$route.params.id || _this6.couponErrorCampaignId;
        if (_this6.model.imagelist === 0) {
          _this6.model.image_url = '';
        }
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this6.model.imagelist).length && _this6.model.imagelist[0].status === 'ready' && _this6.$route.params.id) {
          _this6.getBase64(_this6.model.imagelist[0].raw).then(function (base64enc) {
            requestData.id = id;
            requestData.token = _this6.$session.get('token');
            requestData.company_id = _this6.model.company_id;
            requestData.image = base64enc;
            requestData.name = _this6.model.name;
            requestData.type = _this6.model.type;
            requestData.mode = _this6.model.mode;
            requestData.email_html = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(data.html);
            requestData.email_json = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(data.design);
            _this6.apiRequest('/campaign/' + id, 'PUT', requestData, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: '',
                  text: 'Campaign Updated',
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
                  title: '',
                  text: 'Failed to update the campaign',
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                });
              }
            });
          });
        }
      });
    },
    exportHtml: function exportHtml() {
      this.$refs.emailEditor.editor.exportHtml(function (data) {});
    },
    loadTemplate: function loadTemplate(templateName) {
      var templateData = null;
      if (templateName === 'template1') {
        templateData = __WEBPACK_IMPORTED_MODULE_11__template_json___default.a;
      }
      if (templateName === 'template2') {
        templateData = __WEBPACK_IMPORTED_MODULE_12__template2_json___default.a;
      }
      if (templateData) {
        this.$refs.emailEditor.editor.loadDesign(templateData);
      }
    },
    showModal: function showModal() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.$refs.modal.open();
        _this7.$refs.modal.$once('selected-image', function (url) {
          resolve(url);
        });
        _this7.$refs.modal.$once('close', function () {
          reject(new Error('Modal closed without submitting.'));
        });
      });
    },
    handleUpload: function handleUpload() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this8.showModal();

              case 3:
                result = _context.sent;
                return _context.abrupt('return', result);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this8, [[0, 7]]);
      }))();
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      if (this.model.link_type === 1 && this.model.location_token === null) {
        this.errors.add('location_token', 'Location is required.');
      } else {
        if (this.errors.items.length) {
          this.errors.items.splice(this.errors.items.indexOf({ 'field': 'location_token', 'msg': 'Location is required.' }), 1);
        }
      }
      return this.$validator.validateAll();
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        text: this.$t('validations.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    },
    calcWidthProc: function calcWidthProc(toBeSent, total) {
      var sent = total - toBeSent;
      if (!sent) {
        sent = 0;
      }
      var pr = sent / total;
      if (!pr) {
        pr = 0;
      }
      var rez = (pr * 100).toFixed(0);
      if (rez < 0) {
        rez = 0;
      }
      if (rez > 100) {
        rez = 100;
      }
      return rez;
    }
  }
});

/***/ }),

/***/ "Somv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomInfoPageForm_vue__ = __webpack_require__("r37d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);







var _components;






__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'CustomInfoPageForm', __WEBPACK_IMPORTED_MODULE_7__CustomInfoPageForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "SuKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"})])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.$route.params.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteOrderScreen($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":"ID"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Ip:Port")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.ip_port_printer),expression:"modelValidate.ip_port_printer"},{name:"model",rawName:"v-model",value:(_vm.model.ip_port_printer),expression:"model.ip_port_printer"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"192.168.100.100:65400"},domProps:{"value":(_vm.model.ip_port_printer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ip_port_printer", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Series")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.series),expression:"modelValidate.series"},{name:"model",rawName:"v-model",value:(_vm.model.series),expression:"model.series"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"series"},domProps:{"value":(_vm.model.series)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "series", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.cash_register_auto_dp_before_z),callback:function ($$v) {_vm.$set(_vm.model, "cash_register_auto_dp_before_z", $$v)},expression:"model.cash_register_auto_dp_before_z"}}),_vm._v(" "),_c('label',[_vm._v(" Emite automat dispozitie de plata la generarea raportului Z")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Serie Dispozitie De Plata*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.serie_dispozitie_plata),expression:"modelValidate.serie_dispozitie_plata"},{name:"model",rawName:"v-model",value:(_vm.model.serie_dispozitie_plata),expression:"model.serie_dispozitie_plata"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Serie Dispozitie De Plata"},domProps:{"value":(_vm.model.serie_dispozitie_plata)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "serie_dispozitie_plata", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Urmatorul Numar Dispozitie De Plata*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.numar_dispozitie_plata),expression:"modelValidate.numar_dispozitie_plata"},{name:"model",rawName:"v-model",value:(_vm.model.numar_dispozitie_plata),expression:"model.numar_dispozitie_plata"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Urmatorul Numar Dispozitie De Plata"},domProps:{"value":(_vm.model.numar_dispozitie_plata)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "numar_dispozitie_plata", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-20"},[_c('h4',[_vm._v("Mapare TVA pentru imprimanta fiscală")]),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v("Codul TVA este specific acestei imprimante și este rezolvat doar în momentul fiscalizării.")]),_vm._v(" "),_c('table',{staticClass:"table table-striped"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.model.vat_rates),function(mapping){return _c('tr',{key:mapping.vat_rate_id},[_c('td',[_vm._v(_vm._s(mapping.rate)+"% "),(!mapping.is_active)?_c('span',{staticClass:"text-muted"},[_vm._v("(inactiv, păstrat)")]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(mapping.vat_printer_id),expression:"mapping.vat_printer_id"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Cod TVA pe imprimantă"},domProps:{"value":(mapping.vat_printer_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(mapping, "vat_printer_id", $event.target.value)}}})])])}))])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("TVA")]),_c('th',[_vm._v("vat_printer_id")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SvRh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/modules-girl.9f883c2.png";

/***/ }),

/***/ "SvXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("Y09D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071ff64e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("oNp7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071ff64e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SyU1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Syew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{class:{ 'discount-campaign-form--embedded': _vm.embedded }},[(!_vm.embedded)?_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();return _vm.deleteCampaign($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mar-to-15 mar-bt-15 discount-campaign-form",class:{ 'mar-to-0': _vm.embedded }},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card discount-campaign-form__card",class:{ 'discount-campaign-form__card--embedded': _vm.embedded }},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(!_vm.embedded)?_c('div',{staticClass:"header discount-campaign-form__header"},[_c('h5',[_vm._v(_vm._s(_vm.$t('discountCampaigns.details')))])]):_vm._e(),_vm._v(" "),(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('error')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.name'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('name')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.image')))]),_vm._v(" "),(!_vm.loading)?_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":".jpg, .jpeg, .png","on-change":_vm.handleImgChange,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.discount'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.discount),expression:"model.discount"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.discount),expression:"modelValidations.discount"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01","name":"discount"},domProps:{"value":(_vm.model.discount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "discount", $event.target.value)},_vm.schedulePreview]}}),_vm._v(" "),(_vm.errors.has('discount'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('discount')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.discountType'))+" *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},on:{"change":_vm.schedulePreview},model:{value:(_vm.model.discount_type),callback:function ($$v) {_vm.$set(_vm.model, "discount_type", $$v)},expression:"model.discount_type"}},_vm._l((_vm.discountTypes),function(type){return _c('el-option',{key:type.id,attrs:{"label":_vm.$t('discountCampaigns.discountType_' + type.key),"value":type.id}})}))],1)])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.numberOfUnits')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.number_of_units),expression:"model.number_of_units"}],staticClass:"form-control",attrs:{"type":"number","min":"1","name":"number_of_units","placeholder":_vm.$t('discountCampaigns.numberOfUnitsPlaceholder')},domProps:{"value":(_vm.model.number_of_units)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "number_of_units", $event.target.value)},_vm.schedulePreview]}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.numberOfUnitsHint')))])]),_vm._v(" "),(_vm.model.number_of_units)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.unitsSoldScope')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},on:{"change":_vm.schedulePreview},model:{value:(_vm.model.units_sold_scope),callback:function ($$v) {_vm.$set(_vm.model, "units_sold_scope", $$v)},expression:"model.units_sold_scope"}},_vm._l((_vm.unitsSoldScopes),function(scope){return _c('el-option',{key:scope.id,attrs:{"label":_vm.$t('discountCampaigns.unitsSoldScope_' + scope.key),"value":scope.id}})})),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.unitsSoldScopeHint')))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.unitsSoldPool')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},on:{"change":_vm.schedulePreview},model:{value:(_vm.model.units_sold_pool),callback:function ($$v) {_vm.$set(_vm.model, "units_sold_pool", $$v)},expression:"model.units_sold_pool"}},_vm._l((_vm.unitsSoldPools),function(pool){return _c('el-option',{key:pool.id,attrs:{"label":_vm.$t('discountCampaigns.unitsSoldPool_' + pool.key),"value":pool.id}})})),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.unitsSoldPoolHint')))])],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                  "+_vm._s(_vm.$t('discountCampaigns.priceProfile'))+" *\n                  "),(_vm.lockPriceProfile)?_c('i',{staticClass:"ti-lock text-muted",attrs:{"title":_vm.$t('discountCampaigns.priceProfileLocked')}}):_vm._e()]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":_vm.$t('general.select'),"disabled":_vm.lockPriceProfile},on:{"change":_vm.schedulePreview},model:{value:(_vm.model.price_profile_id),callback:function ($$v) {_vm.$set(_vm.model, "price_profile_id", $$v)},expression:"model.price_profile_id"}},_vm._l((_vm.priceProfiles),function(profile){return _c('el-option',{key:profile.id,attrs:{"label":profile.name,"value":profile.id}})})),_vm._v(" "),(_vm.errors.has('price_profile_id'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('price_profile_id')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.sourceMethodCombos'))+" *")]),_vm._v(" "),_c('el-select',{staticClass:"combo-select",staticStyle:{"width":"100%"},attrs:{"multiple":"","filterable":"","collapse-tags":"","placeholder":_vm.$t('general.select')},on:{"change":_vm.onSourceMethodCombosChange},model:{value:(_vm.selectedComboKeys),callback:function ($$v) {_vm.selectedComboKeys=$$v},expression:"selectedComboKeys"}},_vm._l((_vm.sourceMethodOptions),function(option){return _c('el-option',{key:option.key,attrs:{"label":option.label,"value":option.key}})})),_vm._v(" "),(_vm.errors.has('source_method_combos'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('source_method_combos')))]):_vm._e()],1),_vm._v(" "),_c('searchable-multi-select',{attrs:{"value":_vm.selectedProducts,"label":'discountCampaigns.products',"url":"/search-order-products","initial-limit":0},on:{"input":_vm.onProductsChange}}),_vm._v(" "),_c('searchable-multi-select',{attrs:{"value":_vm.selectedTopCategories,"label":'discountCampaigns.topCategories',"url":"/search-top-categories","initial-limit":10},on:{"input":_vm.onTopCategoriesChange}}),_vm._v(" "),_c('searchable-multi-select',{key:'categories-' + _vm.topCategoriesFilterKey,attrs:{"value":_vm.selectedCategories,"label":'pages.categories',"url":"/search-categories","initial-limit":10,"extra-params":_vm.categorySearchParams},on:{"input":_vm.onCategoriesChange}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.startEnd'))+" *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}}),_vm._v(" "),(_vm.errors.has('start_date'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('start_date')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.active')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group use-intervals-toggle"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.useIntervals')))]),_vm._v(" "),_c('div',{staticClass:"use-intervals-toggle__switch"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.useIntervals),callback:function ($$v) {_vm.useIntervals=$$v},expression:"useIntervals"}})],1),_vm._v(" "),_c('small',{staticClass:"text-muted use-intervals-toggle__hint"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.useIntervalsHint')))])]),_vm._v(" "),(_vm.useIntervals)?[_c('div',{staticClass:"intervals-block"},[_c('div',{staticClass:"intervals-row intervals-row--header"},[_c('div',{staticClass:"intervals-row__day"},[_vm._v(_vm._s(_vm.$t('discountCampaigns.intervalDay')))]),_vm._v(" "),_c('div',{staticClass:"intervals-row__from"},[_vm._v(_vm._s(_vm.$t('general.from')))]),_vm._v(" "),_c('div',{staticClass:"intervals-row__to"},[_vm._v(_vm._s(_vm.$t('general.to')))]),_vm._v(" "),_c('div',{staticClass:"intervals-row__actions",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_vm._l((_vm.model.intervals),function(interval,index){return _c('div',{key:'interval-' + index,staticClass:"intervals-row"},[_c('div',{staticClass:"intervals-row__day"},[_c('el-select',{staticClass:"interval-day-select",attrs:{"value":_vm.intervalDaySelectValue(interval.day),"placeholder":_vm.$t('general.all')},on:{"input":function($event){_vm.setIntervalDay(interval, $event)}}},_vm._l((_vm.intervalDayOptions),function(opt){return _c('el-option',{key:'day-' + String(opt.value),attrs:{"label":opt.label,"value":opt.value}},[_c('span',[_vm._v(_vm._s(opt.label))])])}))],1),_vm._v(" "),_c('div',{staticClass:"intervals-row__from"},[_c('el-time-select',{staticClass:"interval-time-select",attrs:{"placeholder":_vm.$t('general.from'),"picker-options":_vm.timePickerOptions},model:{value:(interval.time_from),callback:function ($$v) {_vm.$set(interval, "time_from", $$v)},expression:"interval.time_from"}})],1),_vm._v(" "),_c('div',{staticClass:"intervals-row__to"},[_c('el-time-select',{staticClass:"interval-time-select",attrs:{"placeholder":_vm.$t('general.to'),"picker-options":_vm.timePickerOptions},model:{value:(interval.time_to),callback:function ($$v) {_vm.$set(interval, "time_to", $$v)},expression:"interval.time_to"}})],1),_vm._v(" "),_c('div',{staticClass:"intervals-row__actions"},[_c('button',{staticClass:"interval-remove",attrs:{"type":"button","title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.removeInterval(index)}}},[_c('i',{staticClass:"ti-close"})])])])})],2),_vm._v(" "),(_vm.errors.has('intervals'))?_c('small',{staticClass:"text-danger intervals-error"},[_vm._v(_vm._s(_vm.errors.first('intervals')))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-sm interval-add",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addInterval($event)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('discountCampaigns.addInterval'))+"\n                ")])]:_vm._e()],2)])])])]),_vm._v(" "),(_vm.canPreview && !_vm.hidePreview)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"header",staticStyle:{"margin-bottom":"15px"}},[_c('h5',[_vm._v(_vm._s(_vm.$t('discountCampaigns.previewTitle')))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("\n              "+_vm._s(_vm.$t('discountCampaigns.previewCount', { count: _vm.gridProductsCount }))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"row filters-wrapper",staticStyle:{"margin-bottom":"15px"}},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.searchProduct')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.previewFilters.name),expression:"previewFilters.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.previewFilters.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.previewFilters, "name", $event.target.value)},_vm.schedulePreview]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.searchProductId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.previewFilters.product_id),expression:"previewFilters.product_id"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.previewFilters.product_id)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.previewFilters, "product_id", $event.target.value)},_vm.schedulePreview]}})])])]),_vm._v(" "),_c('discount-campaign-pricing-grid',{attrs:{"products":_vm.gridProducts,"pricing-data":_vm.gridPricingData,"combos":_vm.gridCombos,"loading":_vm.previewLoading,"show-units-sold":!!_vm.id,"pagination":_vm.gridPagination},on:{"page-change":_vm.onPreviewPageChange}})],1)])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SzMd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PosMapForm_vue__ = __webpack_require__("QwF0");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PosMapForm', __WEBPACK_IMPORTED_MODULE_7__PosMapForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "T1L0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[(!_vm.excludedRoutes.includes(_vm.$route.name))?_c('CreateTicketBubble'):_vm._e(),_vm._v(" "),_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"out-in"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-right"}},[(_vm.modalComponent)?_c('GlobalModal',{on:{"close":_vm.closeModal}},[(_vm.modalProps.route)?_c('div',{staticClass:"modal-breadcrumb-info"},[_c('span',{staticClass:"breadcrumb-item"},[_vm._v(_vm._s(_vm.$t('general.home')))]),_vm._v(" "),_vm._l((_vm.breadcrumbs),function(crumb,index){return _c('span',{key:index,staticClass:"breadcrumb-separator"},[_vm._v("\n          › "),_c('span',{staticClass:"breadcrumb-item"},[_vm._v(_vm._s(crumb.name))])])})],2):_vm._e(),_vm._v(" "),_c(_vm.modalComponent,_vm._b({tag:"component",on:{"close":_vm.closeModal}},'component',_vm.modalProps,false))],1):_vm._e()],1),_vm._v(" "),(_vm.loadingView)?_c('div',{staticClass:"global-loader"},[_c('div',{staticClass:"spinner"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('general.generalLoader')))])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Dashboard_Overview_vue__ = __webpack_require__("uFAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Dashboard_Stats_vue__ = __webpack_require__("+GID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_OrderingManagement_OrderingManagement_vue__ = __webpack_require__("pznp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Customers_CustomersView_vue__ = __webpack_require__("qJAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Customers_Customers_vue__ = __webpack_require__("5EKb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Customers_CustomerView_vue__ = __webpack_require__("viQu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Customers_Groups_Groups_vue__ = __webpack_require__("xWAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Customers_Groups_GroupView_vue__ = __webpack_require__("zaxN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Customers_Approvals_Approvals_vue__ = __webpack_require__("PUl8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Screens_ScreenView_vue__ = __webpack_require__("rcIA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreenView_vue__ = __webpack_require__("3I9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreenTabs_vue__ = __webpack_require__("KbtO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Screens_Kds_KdsSidebar_vue__ = __webpack_require__("IFWP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Screens_Kds_Kds_vue__ = __webpack_require__("RMTn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Screens_Kds_KdsAdd_vue__ = __webpack_require__("la1r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Screens_Kds_KdsEdit_vue__ = __webpack_require__("FFcL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Screens_Kds_KdsReport_vue__ = __webpack_require__("p7YO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Screens_Kds_KdsSettingsUsers_vue__ = __webpack_require__("mOD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Screens_Kds_Users_KdsUserAdd_vue__ = __webpack_require__("DOXX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Screens_Kds_Users_KdsUserEdit_vue__ = __webpack_require__("HgLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Screens_Kds_Sections_KdsSections_vue__ = __webpack_require__("FSfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Screens_Kds_Sections_KdsSectionAdd_vue__ = __webpack_require__("zSEb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Screens_Kds_Sections_KdsSectionEdit_vue__ = __webpack_require__("P9FU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Screens_Kds_KdsSettings_vue__ = __webpack_require__("An/G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreen_vue__ = __webpack_require__("/6y3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreenAdd_vue__ = __webpack_require__("0juF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreenEdit_vue__ = __webpack_require__("bWcp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Screens_PosScreen_PosScreenAdd_vue__ = __webpack_require__("gyD3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Screens_PosScreen_PosScreenEdit_vue__ = __webpack_require__("AQ90");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Screens_DigitalSignage_DigitalSignageAdd_vue__ = __webpack_require__("krfC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Screens_DigitalSignage_DigitalSignageEdit_vue__ = __webpack_require__("Qkmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Marketing_GiftCard_GiftCardForm_vue__ = __webpack_require__("6jsq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Management_ManagementTabs_vue__ = __webpack_require__("o694");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_Management_ManagementOutputsTabs_vue__ = __webpack_require__("u9Do");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Management_ManagementEntriesTabs_vue__ = __webpack_require__("TGY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_Management_ManagementStocksTabs_vue__ = __webpack_require__("V4Gz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_Management_ManagementSidebar_vue__ = __webpack_require__("NWn5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_Management_Dashboard_ManagementDashboard_vue__ = __webpack_require__("NkqJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_Management_Nomenclator_NomenclatorTabs_vue__ = __webpack_require__("IDoR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_Management_Nomenclator_NomenclatorProducts_vue__ = __webpack_require__("hFMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_Management_Nomenclator_NomenclatorProductsEdit_vue__ = __webpack_require__("/J3T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_Management_Nomenclator_ManagementClients_vue__ = __webpack_require__("5ZZT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_Management_Stocks_ManagementStocks_vue__ = __webpack_require__("bTak");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_Management_Stocks_ManagementStocksAdd_vue__ = __webpack_require__("royS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_Management_Stocks_ManagementStocksEdit_vue__ = __webpack_require__("ddPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_src_components_Dashboard_Views_Management_ManagementProduction_vue__ = __webpack_require__("ODHw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_src_components_Dashboard_Views_Management_ManagementLot_vue__ = __webpack_require__("lLZK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_src_components_Dashboard_Views_Management_Nomenclator_ManagementBonProduct_vue__ = __webpack_require__("deWJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_src_components_Dashboard_Views_Management_Nomenclator_ManagementBonProductAdd_vue__ = __webpack_require__("D/d3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_src_components_Dashboard_Views_Management_Nomenclator_ManagementBonProductEdit_vue__ = __webpack_require__("kbGJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_src_components_Dashboard_Views_Management_Transfer_ManagementTransfer_vue__ = __webpack_require__("WO6t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_src_components_Dashboard_Views_Management_Transfer_ManagementTransferAdd_vue__ = __webpack_require__("OZHF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_src_components_Dashboard_Views_Management_Transfer_ManagementTransferEdit_vue__ = __webpack_require__("lSJF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_src_components_Dashboard_Views_Management_Outputs_ManagementAviz_vue__ = __webpack_require__("t5XZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_src_components_Dashboard_Views_Management_Outputs_ManagementAvizAdd_vue__ = __webpack_require__("UCPQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_src_components_Dashboard_Views_Management_Outputs_ManagementAvizEdit_vue__ = __webpack_require__("ETu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_src_components_Dashboard_Views_Management_Outputs_ManagementBonFiscal_vue__ = __webpack_require__("23P3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_src_components_Dashboard_Views_Management_Outputs_ManagementBonFiscalView_vue__ = __webpack_require__("zWhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_src_components_Dashboard_Views_Management_Entries_ManagementEntries_vue__ = __webpack_require__("q98Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_src_components_Dashboard_Views_Management_Entries_ManagementEntriesAdd_vue__ = __webpack_require__("Onhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_src_components_Dashboard_Views_Management_Entries_ManagementEntriesEdit_vue__ = __webpack_require__("rsl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_src_components_Dashboard_Views_Management_Entries_ManagementInvoiceSupplier_vue__ = __webpack_require__("+Y1x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_src_components_Dashboard_Views_Management_Entries_ManagementInvoiceSupplierView_vue__ = __webpack_require__("kbjP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_src_components_Dashboard_Views_Management_Inventory_ManagementInventory_vue__ = __webpack_require__("NdNc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_src_components_Dashboard_Views_Management_Inventory_ManagementInventoryAdd_vue__ = __webpack_require__("UB3S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_src_components_Dashboard_Views_Management_Inventory_ManagementInventoryEdit_vue__ = __webpack_require__("hcPu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_src_components_Dashboard_Views_Management_InitialStock_ManagementInitialStock_vue__ = __webpack_require__("EKzd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_src_components_Dashboard_Views_Management_InitialStock_ManagementInitialStockAdd_vue__ = __webpack_require__("gM1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_src_components_Dashboard_Views_Management_InitialStock_ManagementInitialStockEdit_vue__ = __webpack_require__("TJSw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_src_components_Dashboard_Views_Management_Wasted_ManagementWasted_vue__ = __webpack_require__("DBPj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_src_components_Dashboard_Views_Management_Wasted_ManagementWastedAdd_vue__ = __webpack_require__("3Sx/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_src_components_Dashboard_Views_Management_Wasted_ManagementWastedEdit_vue__ = __webpack_require__("GXVQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_src_components_Dashboard_Views_Management_Suppliers_ManagementSuppliersTabs_vue__ = __webpack_require__("EHmy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_src_components_Dashboard_Views_Management_Suppliers_ManagementSuppliers_vue__ = __webpack_require__("4xpk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_src_components_Dashboard_Views_Management_Suppliers_ManagementOrdersSuppliers_vue__ = __webpack_require__("mzTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_src_components_Dashboard_Views_Management_Suppliers_ManagementMyOrdersSuppliers_vue__ = __webpack_require__("KNch");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_src_components_Dashboard_Views_Management_Suppliers_ManagementMyOrdersSuppliersAdd_vue__ = __webpack_require__("pfxT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_src_components_Dashboard_Views_Management_Suppliers_ManagementMyOrdersSuppliersEdit_vue__ = __webpack_require__("qd75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_src_components_Dashboard_Views_Management_Suppliers_ManagementForOrdersSuppliers_vue__ = __webpack_require__("Tbq/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_src_components_Dashboard_Views_Management_Suppliers_ManagementForOrdersSuppliersAdd_vue__ = __webpack_require__("Nt52");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_src_components_Dashboard_Views_Management_Suppliers_ManagementForOrdersSuppliersEdit_vue__ = __webpack_require__("Vsht");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_src_components_Dashboard_Views_Management_Accounting_AccountingInboundInvoices_vue__ = __webpack_require__("F+V8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_src_components_Dashboard_Views_Management_Accounting_AccountingSales_vue__ = __webpack_require__("dmW6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_src_components_Dashboard_Views_Management_Casa_ManagementCasaRegister_vue__ = __webpack_require__("vnQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_src_components_Dashboard_Views_Management_ManagementReports_vue__ = __webpack_require__("PAqi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_src_components_Dashboard_Views_Management_ManagementSettings_vue__ = __webpack_require__("T2pQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_src_components_Dashboard_Views_Management_ManagementUsers_vue__ = __webpack_require__("RnFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_src_components_Dashboard_Views_Invoice_InvoiceTabs_vue__ = __webpack_require__("4AJd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_src_components_Dashboard_Views_Invoice_InvoiceSidebar_vue__ = __webpack_require__("GgGM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_src_components_Dashboard_Views_Invoice_InvoiceDashboard_vue__ = __webpack_require__("fakT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_src_components_Dashboard_Views_Invoice_InvoiceAdd_vue__ = __webpack_require__("2Nww");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_src_components_Dashboard_Views_Invoice_InvoiceStorno_vue__ = __webpack_require__("ZkTW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_src_components_Dashboard_Views_Invoice_InvoiceEdit_vue__ = __webpack_require__("/1mS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_src_components_Dashboard_Views_Invoice_InvoiceSettings_vue__ = __webpack_require__("94sP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_src_components_Dashboard_Views_Invoice_InvoiceReports_vue__ = __webpack_require__("VGc9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_src_components_Dashboard_Views_Invoice_Proforma_Proforma_vue__ = __webpack_require__("mX3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_src_components_Dashboard_Views_Invoice_Proforma_ProformaAdd_vue__ = __webpack_require__("6H3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_src_components_Dashboard_Views_Invoice_Proforma_ProformaEdit_vue__ = __webpack_require__("MCNz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_src_components_Dashboard_Views_InfoPages_InfoPages_vue__ = __webpack_require__("TUUy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_src_components_Dashboard_Views_InfoPagesCustom_CustomInfoPages_vue__ = __webpack_require__("hQuq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_src_components_Dashboard_Views_InfoPagesCustom_CustomInfoPageAdd_vue__ = __webpack_require__("GrvI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_src_components_Dashboard_Views_InfoPagesCustom_CustomInfoPageEdit_vue__ = __webpack_require__("nFSe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_src_components_Dashboard_Views_Reservations_Reservations_vue__ = __webpack_require__("540F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_src_components_Dashboard_Views_Tables_Tables_vue__ = __webpack_require__("4gP/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_src_components_Dashboard_Views_Orders_Orders_vue__ = __webpack_require__("ec2Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107_src_components_Dashboard_Views_Orders_OrderView_vue__ = __webpack_require__("q0FD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_src_components_Dashboard_Views_Orders_OrderEdit_vue__ = __webpack_require__("Aa8n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109_src_components_Dashboard_Views_LoyaltyPointsScanner_LoyaltyPointsScanner_vue__ = __webpack_require__("fKeh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110_src_components_Dashboard_Views_OrdersPos_OrdersPos_vue__ = __webpack_require__("jTQK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111_src_components_Dashboard_Views_OrdersPos_OrdersPosView_vue__ = __webpack_require__("cQrm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112_src_components_Dashboard_Views_OrdersPos_OrderPosClientScreen_vue__ = __webpack_require__("428f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113_src_components_Dashboard_Views_PosSettings_PosView_vue__ = __webpack_require__("nKgJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114_src_components_Dashboard_Views_PosSettings_PosTabs_vue__ = __webpack_require__("bSoM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115_src_components_Dashboard_Views_PosSettings_PosList_vue__ = __webpack_require__("R35P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116_src_components_Dashboard_Views_PosSettings_PosSettingsUsers_vue__ = __webpack_require__("mzhu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117_src_components_Dashboard_Views_PosSettings_PosSettingsSettings_vue__ = __webpack_require__("TQZs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118_src_components_Dashboard_Views_PosSettings_PosSettingsReports_vue__ = __webpack_require__("qprm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119_src_components_Dashboard_Views_PosSettings_pos_PosAdd_vue__ = __webpack_require__("zrv2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120_src_components_Dashboard_Views_PosSettings_pos_PosEdit_vue__ = __webpack_require__("6gb4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121_src_components_Dashboard_Views_PosSettings_users_PosUserAdd_vue__ = __webpack_require__("lJ5Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122_src_components_Dashboard_Views_PosSettings_users_PosUserEdit_vue__ = __webpack_require__("ryuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123_src_components_Dashboard_Views_PosSettings_maps_PosMapAdd_vue__ = __webpack_require__("HBXc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124_src_components_Dashboard_Views_PosSettings_maps_PosMapEdit_vue__ = __webpack_require__("+aCA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125_src_components_Dashboard_Views_PosSettings_fiscalPrinter_FiscalPrinterAdd_vue__ = __webpack_require__("rVyl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126_src_components_Dashboard_Views_PosSettings_fiscalPrinter_FiscalPrinterEdit_vue__ = __webpack_require__("1FF6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127_src_components_Dashboard_Views_PosSettings_cantar_CantarAdd_vue__ = __webpack_require__("W7NN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128_src_components_Dashboard_Views_PosSettings_cantar_CantarEdit_vue__ = __webpack_require__("161f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129_src_components_Dashboard_Views_Dispatch_Dispatch_vue__ = __webpack_require__("M6xv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130_src_components_Dashboard_Views_Dispatch_DispatchTabs_vue__ = __webpack_require__("6knb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131_src_components_Dashboard_Views_Dispatch_DispatchView_vue__ = __webpack_require__("esvh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132_src_components_Dashboard_Views_Dispatch_DispatchDrivers_vue__ = __webpack_require__("w4Yf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133_src_components_Dashboard_Views_Dispatch_DispatchReports_vue__ = __webpack_require__("H9OI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134_src_components_Dashboard_Views_Dispatch_DispatchSettings_vue__ = __webpack_require__("g01Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135_src_components_Dashboard_Views_Online_Online_vue__ = __webpack_require__("R0fG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136_src_components_Dashboard_Views_Kiosk_Kiosk_vue__ = __webpack_require__("+B1S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137_src_components_Dashboard_Views_Qr_Qr_vue__ = __webpack_require__("9njO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138_src_components_Dashboard_Views_Catalog_CatalogSidebar_vue__ = __webpack_require__("yI4Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139_src_components_Dashboard_Views_Products_ProductsList_vue__ = __webpack_require__("VWkf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140_src_components_Dashboard_Views_Products_ProductAdd_vue__ = __webpack_require__("NTnw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141_src_components_Dashboard_Views_Products_ProductEdit_vue__ = __webpack_require__("9sk9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142_src_components_Dashboard_Views_Products_PriceProfile_vue__ = __webpack_require__("vPYJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143_src_components_Dashboard_Views_Products_PriceProfileAdd_vue__ = __webpack_require__("1HF3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144_src_components_Dashboard_Views_Products_PriceProfileEdit_vue__ = __webpack_require__("H6VS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145_src_components_Dashboard_Views_Settings_Tabs_ProductOptions_vue__ = __webpack_require__("soYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146_src_components_Dashboard_Views_ProductOptions_ProductOptions_vue__ = __webpack_require__("lZGK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147_src_components_Dashboard_Views_ProductOptions_ProductOptionsAdd_vue__ = __webpack_require__("23bL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148_src_components_Dashboard_Views_ProductOptions_ProductOptionsEdit_vue__ = __webpack_require__("tNYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149_src_components_Dashboard_Views_GroupOptions_GroupOptions_vue__ = __webpack_require__("b1nj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150_src_components_Dashboard_Views_GroupOptions_GroupOptionsAdd_vue__ = __webpack_require__("BCg7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151_src_components_Dashboard_Views_GroupOptions_GroupOptionsEdit_vue__ = __webpack_require__("raNR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152_src_components_Dashboard_Views_Integrations_IntegrationMenuEntityEditPage_vue__ = __webpack_require__("mhAJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153_src_components_Dashboard_Views_Settings_Tabs_ProductFilters_vue__ = __webpack_require__("u5js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154_src_components_Dashboard_Views_Categories_Categories_vue__ = __webpack_require__("pUJd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155_src_components_Dashboard_Views_Categories_CategoryAdd_vue__ = __webpack_require__("B2tR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156_src_components_Dashboard_Views_Categories_CategoryEdit_vue__ = __webpack_require__("IZUt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157_src_components_Dashboard_Views_TopCategories_TopCategories_vue__ = __webpack_require__("Ij4o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158_src_components_Dashboard_Views_TopCategories_TopCategoryAdd_vue__ = __webpack_require__("RdNT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159_src_components_Dashboard_Views_TopCategories_TopCategoryEdit_vue__ = __webpack_require__("+HOK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160_src_components_Dashboard_Views_MenuLinks_MenuLinks_vue__ = __webpack_require__("H0h3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161_src_components_Dashboard_Views_MenuLinks_MenuLinkAdd_vue__ = __webpack_require__("5Set");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162_src_components_Dashboard_Views_MenuLinks_MenuLinkEdit_vue__ = __webpack_require__("XqGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163_src_components_Dashboard_Views_Marketing_MarketingSidebar_vue__ = __webpack_require__("iSHC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164_src_components_Dashboard_Views_Marketing_Campaigns_Campaigns_vue__ = __webpack_require__("f9hE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165_src_components_Dashboard_Views_Marketing_Campaigns_CampaignAdd_vue__ = __webpack_require__("bQaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166_src_components_Dashboard_Views_Marketing_Campaigns_CampaignEdit_vue__ = __webpack_require__("Yvs9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167_src_components_Dashboard_Views_Marketing_DiscountCoupons_CouponPage_vue__ = __webpack_require__("HxCe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168_src_components_Dashboard_Views_Marketing_Subscriptions_SubscriptionPage_vue__ = __webpack_require__("WKBS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169_src_components_Dashboard_Views_Marketing_Subscriptions_SubscribersPage_vue__ = __webpack_require__("F3Gu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170_src_components_Dashboard_Views_Marketing_AutomationCampaigns_AutomationCampaignPage_vue__ = __webpack_require__("PT7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171_src_components_Dashboard_Views_Marketing_AutomationCampaigns_AutomationBeneficiariesPage_vue__ = __webpack_require__("8eBL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172_src_components_Dashboard_Views_Marketing_DonationCampaigns_DonationCampaigns_vue__ = __webpack_require__("sqsr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173_src_components_Dashboard_Views_Marketing_DonationCampaigns_DonationCampaignAdd_vue__ = __webpack_require__("5stz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174_src_components_Dashboard_Views_Marketing_DonationCampaigns_DonationCampaignEdit_vue__ = __webpack_require__("cfI5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175_src_components_Dashboard_Views_Marketing_MenuSubscriptions_MenuSubscriptionPage_vue__ = __webpack_require__("w6nM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176_src_components_Dashboard_Views_Marketing_MenuSubscriptions_MenuSubscribersPage_vue__ = __webpack_require__("F9X5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177_src_components_Dashboard_Views_Marketing_DiscountCampaigns_DiscountCampaigns_vue__ = __webpack_require__("wGs9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178_src_components_Dashboard_Views_Marketing_DiscountCampaigns_DiscountCampaignAdd_vue__ = __webpack_require__("qbWl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179_src_components_Dashboard_Views_Marketing_DiscountCampaigns_DiscountCampaignEdit_vue__ = __webpack_require__("cFDW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180_src_components_Dashboard_Views_Marketing_ChallengeCampaigns_ChallengeCampaigns_vue__ = __webpack_require__("sSZn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181_src_components_Dashboard_Views_Marketing_ChallengeCampaigns_ChallengeCampaignAdd_vue__ = __webpack_require__("XiiD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182_src_components_Dashboard_Views_Marketing_ChallengeCampaigns_ChallengeCampaignEdit_vue__ = __webpack_require__("0afy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183_src_components_Dashboard_Views_Marketing_SpinningWheel_SpinningWheelCampaigns_vue__ = __webpack_require__("gz/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184_src_components_Dashboard_Views_Marketing_SpinningWheel_SpinningWheelCampaignAdd_vue__ = __webpack_require__("Y2no");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185_src_components_Dashboard_Views_Marketing_SpinningWheel_SpinningWheelCampaignEdit_vue__ = __webpack_require__("PWXs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186_src_components_Dashboard_Views_Marketing_Offers_Offers_vue__ = __webpack_require__("duJW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187_src_components_Dashboard_Views_Marketing_Offers_OffersEdit_vue__ = __webpack_require__("dRcJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188_src_components_Dashboard_Views_Marketing_Offers_OffersAdd_vue__ = __webpack_require__("R+jw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189_src_components_Dashboard_Views_Marketing_Offers_Group_GroupAdd_vue__ = __webpack_require__("yMe9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190_src_components_Dashboard_Views_Marketing_Offers_Group_GroupEdit_vue__ = __webpack_require__("c3Km");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191_src_components_Dashboard_Views_Marketing_Fidelities_Fidelities_vue__ = __webpack_require__("QSgq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192_src_components_Dashboard_Views_Marketing_Fidelities_UserLabel_UserLabeling_vue__ = __webpack_require__("a5PJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193_src_components_Dashboard_Views_Marketing_Fidelities_UserLabel_UserLabelingAdd_vue__ = __webpack_require__("X5Jl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194_src_components_Dashboard_Views_Marketing_Fidelities_UserLabel_UserLabelingEdit_vue__ = __webpack_require__("+0cg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195_src_components_Dashboard_Views_Marketing_Promos_Promos_vue__ = __webpack_require__("+gUM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196_src_components_Dashboard_Views_Marketing_Promos_PromosAdd_vue__ = __webpack_require__("DD47");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197_src_components_Dashboard_Views_Marketing_Promos_PromosEdit_vue__ = __webpack_require__("pYFp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198_src_components_Dashboard_Views_Marketing_Referral_ReferralCampaignAdd_vue__ = __webpack_require__("mu2Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199_src_components_Dashboard_Views_Marketing_Referral_ReferralCampaignEdit_vue__ = __webpack_require__("bsTH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200_src_components_Dashboard_Views_Marketing_RaffleCampaigns_RaffleCampaignAdd_vue__ = __webpack_require__("FTLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201_src_components_Dashboard_Views_Marketing_RaffleCampaigns_RaffleCampaignEdit_vue__ = __webpack_require__("lhu5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202_src_components_Dashboard_Views_Marketing_LoyaltyStore_LoyaltyStoreCampaignAdd_vue__ = __webpack_require__("De7v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203_src_components_Dashboard_Views_Marketing_LoyaltyStore_LoyaltyStoreCampaignEdit_vue__ = __webpack_require__("Bx1c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204_src_components_Dashboard_Views_Marketing_DynamicMenus_DynamicMenu_vue__ = __webpack_require__("E0xI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205_src_components_Dashboard_Views_RewardProgram_RewardProgramEdit_vue__ = __webpack_require__("zijR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206_src_components_Dashboard_Views_Reports_Reports_vue__ = __webpack_require__("uVnX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207_src_components_Dashboard_Views_Reports_ReportsCustomerDetails_vue__ = __webpack_require__("+wRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208_src_components_Dashboard_Views_Reports_Versions_2_CharismaItems_vue__ = __webpack_require__("nQ+w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209_src_components_Dashboard_Views_Reports_Versions_2_NexusItems_vue__ = __webpack_require__("p4Rg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210_src_components_Dashboard_Views_Reports_Versions_2_PosOrderActionsDetails_vue__ = __webpack_require__("Rwfi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211_src_components_Dashboard_Views_Reports_DonationCampaignOrdersReport_vue__ = __webpack_require__("pAPr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212_src_components_Dashboard_Views_Reports_RaffleCampaignParticipantsReport_vue__ = __webpack_require__("Zu6E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213_src_components_Dashboard_Views_Reports_LoyaltyStorePurchasesReport_vue__ = __webpack_require__("mV+r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214_src_components_Dashboard_Views_Reports_ChallengeCampaignUsersReport_vue__ = __webpack_require__("XssK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215_src_components_Dashboard_Views_Reports_ChallengeUserProgressLogsReport_vue__ = __webpack_require__("7Zo3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216_src_components_Dashboard_Views_Reports_SpinningWheelRewardsReport_vue__ = __webpack_require__("wl7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217_src_components_Dashboard_Views_Reports_SpinningWheelUsersReport_vue__ = __webpack_require__("qYTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218_src_components_Dashboard_Views_Reports_Versions_2_CharismaLocationReceiptDetails_vue__ = __webpack_require__("x7FO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219_src_components_Dashboard_Views_Reports_Versions_2_ReferralProgramAmbassadorDrilldownModal_vue__ = __webpack_require__("jssz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220_src_components_Dashboard_Views_Settings_SettingsSidebar_vue__ = __webpack_require__("c2yd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__components_Dashboard_Views_Settings_SettingsGeneral_vue__ = __webpack_require__("x8jG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222_src_components_Dashboard_Views_Settings_SettingsLocations_vue__ = __webpack_require__("Xzg0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223_src_components_Dashboard_Views_Settings_SettingsModules_vue__ = __webpack_require__("yQ4Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224_src_components_Dashboard_Views_Settings_Users_Users_vue__ = __webpack_require__("SvXL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225_src_components_Dashboard_Views_Settings_Users_UserAdd_vue__ = __webpack_require__("5Anz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226_src_components_Dashboard_Views_Settings_Users_UserEdit_vue__ = __webpack_require__("8aRt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227_src_components_Dashboard_Views_Settings_Printer_PrinterAdd_vue__ = __webpack_require__("3Wqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228_src_components_Dashboard_Views_Settings_Printer_PrinterEdit_vue__ = __webpack_require__("bler");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229_src_components_Dashboard_Views_Settings_Feedback_Feedback_vue__ = __webpack_require__("1s1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230_src_components_Dashboard_Views_Settings_Feedback_FeedbackView_vue__ = __webpack_require__("btJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231_src_components_Dashboard_Views_Settings_LocationGroups_LocationGroups_vue__ = __webpack_require__("MNRc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232_src_components_Dashboard_Views_Settings_LocationGroups_LocationGroupsAdd_vue__ = __webpack_require__("tpoi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233_src_components_Dashboard_Views_Settings_LocationGroups_LocationGroupsEdit_vue__ = __webpack_require__("lsTN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234_src_components_Dashboard_Views_Settings_Locations_LocationAdd_vue__ = __webpack_require__("Ijvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235_src_components_Dashboard_Views_Settings_Locations_LocationEdit_vue__ = __webpack_require__("fY5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236_src_components_Dashboard_Views_Settings_Locations_LocationEditWolt_vue__ = __webpack_require__("3FaB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237_src_components_Dashboard_Views_Integrations_PlatformMenuImports_PlatformMenuImports_vue__ = __webpack_require__("2FHI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238_src_components_Dashboard_Views_Settings_Locations_ProductImports_ProductImportList_vue__ = __webpack_require__("ukID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239_src_components_Dashboard_Views_Settings_Locations_ProductImports_ProductImportDetail_vue__ = __webpack_require__("V+jh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240_src_components_Dashboard_Views_Payment_Payment_vue__ = __webpack_require__("0+8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241_src_components_Dashboard_Views_Settings_PaymentGroups_PaymentGroupsAdd_vue__ = __webpack_require__("Evvf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242_src_components_Dashboard_Views_Settings_PaymentGroups_PaymentGroupsEdit_vue__ = __webpack_require__("QUE/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243_src_components_Dashboard_Views_Newsletter_NewsletterSidebar_vue__ = __webpack_require__("6R02");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244_src_components_Dashboard_Views_Newsletter_Tabs_News_vue__ = __webpack_require__("Ynvi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245_src_components_Dashboard_Views_Newsletter_Tabs_MonthlyInfo_vue__ = __webpack_require__("hbV7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246_src_components_Dashboard_Views_Newsletter_Tabs_VideoSupport_vue__ = __webpack_require__("tRiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247_src_components_Dashboard_Views_Pages_Login_vue__ = __webpack_require__("WI53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248_src_components_Dashboard_Views_Pages_Register_vue__ = __webpack_require__("sMOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249_src_components_Dashboard_Views_Pages_Recover_vue__ = __webpack_require__("wiU7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250_src_components_Dashboard_Views_Pages_Reset_vue__ = __webpack_require__("lX1G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251_src_components_Dashboard_Views_Pages_Wolt_vue__ = __webpack_require__("yUjI");



















































































































































































































































































































































var loginPage = {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_247_src_components_Dashboard_Views_Pages_Login_vue__["a" /* default */]
};

var registerPage = {
  path: '/register',
  name: 'Register',
  component: __WEBPACK_IMPORTED_MODULE_248_src_components_Dashboard_Views_Pages_Register_vue__["a" /* default */]
};

var recoverPage = {
  path: '/recover',
  name: 'Recover Password',
  component: __WEBPACK_IMPORTED_MODULE_249_src_components_Dashboard_Views_Pages_Recover_vue__["a" /* default */]
};

var resetPage = {
  path: '/reset',
  name: 'Reset Password',
  component: __WEBPACK_IMPORTED_MODULE_250_src_components_Dashboard_Views_Pages_Reset_vue__["a" /* default */]
};

var woltPage = {
  path: '/wolt/callback',
  name: 'wolt',
  component: __WEBPACK_IMPORTED_MODULE_251_src_components_Dashboard_Views_Pages_Wolt_vue__["a" /* default */]
};

var orderingMenu = {
  path: '/ordering-management',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Ordering Management',
    component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_OrderingManagement_OrderingManagement_vue__["a" /* default */]
  }, {
    path: 'view',
    name: 'Customer Details Ordering',
    component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Customers_CustomerView_vue__["a" /* default */]
  }]
};

var customersView = {
  path: '/customer',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Customers View',
    component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Customers_CustomersView_vue__["a" /* default */]
  }]
};

var approvalsView = {
  path: '/approvals',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Approvals View',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Customers_Approvals_Approvals_vue__["a" /* default */]
  }]
};

var customersMenu = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/customers',
    name: 'Customers',
    component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Customers_Customers_vue__["a" /* default */]
  }, {
    path: 'customers/view/:id',
    name: 'Customer Details',
    component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Customers_CustomerView_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var customersGroupsMenu = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: 'groups',
    name: 'Groups',
    component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Customers_Groups_Groups_vue__["a" /* default */]
  }, {
    path: 'groups/:id',
    name: 'Groups View',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Customers_Groups_GroupView_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var screens = {
  path: '/kds',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'kds',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Screens_ScreenView_vue__["a" /* default */]
  }]
};

var orderScreenView = {
  path: '/screens',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '',
    name: 'Screens',
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreenView_vue__["a" /* default */]
  }]
};

var orderScreenTabs = {
  path: '/screens/tabs',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '',
    name: 'Ods Screen Tabs',
    component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreenTabs_vue__["a" /* default */]
  }]
};

var kdsSettings = {
  path: '/screens/kds/settings',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Kds Settings',
    component: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Screens_Kds_KdsSettings_vue__["a" /* default */]
  }]
};

var kdsReport = {
  path: '/screens/kds/report',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Kds Report',
    component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Screens_Kds_KdsReport_vue__["a" /* default */]
  }]
};
var kdsSidebar = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/screens/kds',
    name: 'Kds',
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Screens_Kds_KdsSidebar_vue__["a" /* default */]
  }, {
    path: '/screens/kds',
    name: 'Kds Index',
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Screens_Kds_Kds_vue__["a" /* default */]
  }, {
    path: '/screens/kds/add',
    name: 'Kds Add',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Screens_Kds_KdsAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/screens/kds/edit/:id',
    name: 'Kds Edit',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Screens_Kds_KdsEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var kdsUsers = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/screens/kds/users',
    name: 'Kds Users',
    component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Screens_Kds_KdsSettingsUsers_vue__["a" /* default */]
  }, {
    path: '/screens/kds/users/add',
    name: 'Kds Users Add',
    component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Screens_Kds_Users_KdsUserAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/screens/kds/users/:id',
    name: 'Kds Users Edit',
    component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Screens_Kds_Users_KdsUserEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var kdsSections = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/screens/sections',
    name: 'Kds Section Index',
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Screens_Kds_Sections_KdsSections_vue__["a" /* default */]
  }, {
    path: '/screens/sections/add',
    name: 'Kds Section Add',
    component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Screens_Kds_Sections_KdsSectionAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/screens/sections/edit/:id',
    name: 'Kds Section Edit',
    component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Screens_Kds_Sections_KdsSectionEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var management = {
  path: '/management',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '',
    name: 'Management',
    component: __WEBPACK_IMPORTED_MODULE_34_src_components_Dashboard_Views_Management_ManagementTabs_vue__["a" /* default */]
  }]
};

var invoice = {
  path: '/invoice',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '',
    name: 'Invoice',
    component: __WEBPACK_IMPORTED_MODULE_89_src_components_Dashboard_Views_Invoice_InvoiceTabs_vue__["a" /* default */]
  }]
};

var invoiceTabs = {
  path: '/invoice-tabs',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: 'sidebar',
    name: 'InvoiceSidebar',
    component: __WEBPACK_IMPORTED_MODULE_90_src_components_Dashboard_Views_Invoice_InvoiceSidebar_vue__["a" /* default */]
  }, {
    path: 'dashboard',
    name: 'InvoiceDashboard',
    component: __WEBPACK_IMPORTED_MODULE_91_src_components_Dashboard_Views_Invoice_InvoiceDashboard_vue__["a" /* default */]
  }, {
    path: 'invoice/add',
    name: 'AddInvoice',
    component: __WEBPACK_IMPORTED_MODULE_92_src_components_Dashboard_Views_Invoice_InvoiceAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'invoice/edit/:id',
    name: 'EditInvoice',
    component: __WEBPACK_IMPORTED_MODULE_94_src_components_Dashboard_Views_Invoice_InvoiceEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'invoice/storno/:id',
    name: 'StornoInvoice',
    component: __WEBPACK_IMPORTED_MODULE_93_src_components_Dashboard_Views_Invoice_InvoiceStorno_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'proforma',
    name: 'Proforma',
    component: __WEBPACK_IMPORTED_MODULE_97_src_components_Dashboard_Views_Invoice_Proforma_Proforma_vue__["a" /* default */]
  }, {
    path: 'proforma/add',
    name: 'AddProforma',
    component: __WEBPACK_IMPORTED_MODULE_98_src_components_Dashboard_Views_Invoice_Proforma_ProformaAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'proforma/:id',
    name: 'EditProforma',
    component: __WEBPACK_IMPORTED_MODULE_99_src_components_Dashboard_Views_Invoice_Proforma_ProformaEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'reports',
    name: 'InvoiceReports',
    component: __WEBPACK_IMPORTED_MODULE_96_src_components_Dashboard_Views_Invoice_InvoiceReports_vue__["a" /* default */]
  }, {
    path: 'settings',
    name: 'InvoiceSettings',
    component: __WEBPACK_IMPORTED_MODULE_95_src_components_Dashboard_Views_Invoice_InvoiceSettings_vue__["a" /* default */]
  }]
};

var managementTabs = {
  path: '/management',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: 'sidebar',
    name: 'ManagementSidebar',
    component: __WEBPACK_IMPORTED_MODULE_38_src_components_Dashboard_Views_Management_ManagementSidebar_vue__["a" /* default */]
  }, {
    path: 'outputsTabs',
    name: 'ManagementOutputsTabs',
    component: __WEBPACK_IMPORTED_MODULE_35_src_components_Dashboard_Views_Management_ManagementOutputsTabs_vue__["a" /* default */]
  }, {
    path: 'entriesTabs',
    name: 'ManagementEntriesTabs',
    component: __WEBPACK_IMPORTED_MODULE_36_src_components_Dashboard_Views_Management_ManagementEntriesTabs_vue__["a" /* default */]
  }, {
    path: 'stocksTabs',
    name: 'ManagementStocksTabs',
    component: __WEBPACK_IMPORTED_MODULE_37_src_components_Dashboard_Views_Management_ManagementStocksTabs_vue__["a" /* default */]
  }, {
    path: 'production',
    name: 'ManagementProduction',
    component: __WEBPACK_IMPORTED_MODULE_47_src_components_Dashboard_Views_Management_ManagementProduction_vue__["a" /* default */]
  }, {
    path: 'lot',
    name: 'ManagementLot',
    component: __WEBPACK_IMPORTED_MODULE_48_src_components_Dashboard_Views_Management_ManagementLot_vue__["a" /* default */]
  }, {
    path: 'dashboard',
    name: 'ManagementDashboard',
    component: __WEBPACK_IMPORTED_MODULE_39_src_components_Dashboard_Views_Management_Dashboard_ManagementDashboard_vue__["a" /* default */]
  }, {
    path: 'nomenclatorTabs',
    name: 'NomenclatorTabs',
    component: __WEBPACK_IMPORTED_MODULE_40_src_components_Dashboard_Views_Management_Nomenclator_NomenclatorTabs_vue__["a" /* default */]
  }, {
    path: 'management-clients',
    name: 'ManagementClients',
    component: __WEBPACK_IMPORTED_MODULE_43_src_components_Dashboard_Views_Management_Nomenclator_ManagementClients_vue__["a" /* default */]
  }, {
    path: 'nomenclator-products',
    name: 'NomenclatorProducts',
    component: __WEBPACK_IMPORTED_MODULE_41_src_components_Dashboard_Views_Management_Nomenclator_NomenclatorProducts_vue__["a" /* default */]
  }, {
    path: 'nomenclator-products/edit/:id/:vatNumber',
    name: 'NomenclatorProductsEdit',
    component: __WEBPACK_IMPORTED_MODULE_42_src_components_Dashboard_Views_Management_Nomenclator_NomenclatorProductsEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'bon-product',
    name: 'ManagementBonProduct',
    component: __WEBPACK_IMPORTED_MODULE_49_src_components_Dashboard_Views_Management_Nomenclator_ManagementBonProduct_vue__["a" /* default */]
  }, {
    path: 'bon-product/add',
    name: 'AddManagementBonProduct',
    component: __WEBPACK_IMPORTED_MODULE_50_src_components_Dashboard_Views_Management_Nomenclator_ManagementBonProductAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'bon-product/edit/:series/:number',
    name: 'ManagementBonProductEdit',
    component: __WEBPACK_IMPORTED_MODULE_51_src_components_Dashboard_Views_Management_Nomenclator_ManagementBonProductEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'stocks',
    name: 'ManagementStocks',
    component: __WEBPACK_IMPORTED_MODULE_44_src_components_Dashboard_Views_Management_Stocks_ManagementStocks_vue__["a" /* default */]
  }, {
    path: 'stocks/add',
    name: 'AddManagementStocks',
    component: __WEBPACK_IMPORTED_MODULE_45_src_components_Dashboard_Views_Management_Stocks_ManagementStocksAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'stocks/edit/:series/:number',
    name: 'ManagementStocksEdit',
    component: __WEBPACK_IMPORTED_MODULE_46_src_components_Dashboard_Views_Management_Stocks_ManagementStocksEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'wasted',
    name: 'ManagementWasted',
    component: __WEBPACK_IMPORTED_MODULE_71_src_components_Dashboard_Views_Management_Wasted_ManagementWasted_vue__["a" /* default */]
  }, {
    path: 'wasted/add',
    name: 'AddManagementWasted',
    component: __WEBPACK_IMPORTED_MODULE_72_src_components_Dashboard_Views_Management_Wasted_ManagementWastedAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'wasted/edit/:series/:number',
    name: 'ManagementWastedEdit',
    component: __WEBPACK_IMPORTED_MODULE_73_src_components_Dashboard_Views_Management_Wasted_ManagementWastedEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'transfer',
    name: 'ManagementTransfer',
    component: __WEBPACK_IMPORTED_MODULE_52_src_components_Dashboard_Views_Management_Transfer_ManagementTransfer_vue__["a" /* default */]
  }, {
    path: 'transfer/add',
    name: 'AddManagementTransfer',
    component: __WEBPACK_IMPORTED_MODULE_53_src_components_Dashboard_Views_Management_Transfer_ManagementTransferAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'transfer/edit/:series/:number',
    name: 'ManagementTransferEdit',
    component: __WEBPACK_IMPORTED_MODULE_54_src_components_Dashboard_Views_Management_Transfer_ManagementTransferEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'entries',
    name: 'ManagementEntries',
    component: __WEBPACK_IMPORTED_MODULE_60_src_components_Dashboard_Views_Management_Entries_ManagementEntries_vue__["a" /* default */]
  }, {
    path: 'entries/add',
    name: 'AddManagementEntries',
    component: __WEBPACK_IMPORTED_MODULE_61_src_components_Dashboard_Views_Management_Entries_ManagementEntriesAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'entries/edit/:id',
    name: 'ManagementEntriesEdit',
    component: __WEBPACK_IMPORTED_MODULE_62_src_components_Dashboard_Views_Management_Entries_ManagementEntriesEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'invoice-supplier',
    name: 'ManagementInvoiceSupplier',
    component: __WEBPACK_IMPORTED_MODULE_63_src_components_Dashboard_Views_Management_Entries_ManagementInvoiceSupplier_vue__["a" /* default */]
  }, {
    path: 'view-invoice-supplier/:id',
    name: 'ManagementInvoiceSupplierView',
    component: __WEBPACK_IMPORTED_MODULE_64_src_components_Dashboard_Views_Management_Entries_ManagementInvoiceSupplierView_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'outputs',
    name: 'ManagementAviz',
    component: __WEBPACK_IMPORTED_MODULE_55_src_components_Dashboard_Views_Management_Outputs_ManagementAviz_vue__["a" /* default */]
  }, {
    path: 'outputs/:id',
    name: 'ManagementAvizEdit',
    component: __WEBPACK_IMPORTED_MODULE_57_src_components_Dashboard_Views_Management_Outputs_ManagementAvizEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'outputs/add/:orderData?',
    name: 'AddManagementAviz',
    component: __WEBPACK_IMPORTED_MODULE_56_src_components_Dashboard_Views_Management_Outputs_ManagementAvizAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'outputs',
    name: 'ManagementBonFiscal',
    component: __WEBPACK_IMPORTED_MODULE_58_src_components_Dashboard_Views_Management_Outputs_ManagementBonFiscal_vue__["a" /* default */]
  }, {
    path: 'outputs/view/:id',
    name: 'ManagementBonFiscalView',
    component: __WEBPACK_IMPORTED_MODULE_59_src_components_Dashboard_Views_Management_Outputs_ManagementBonFiscalView_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'inventory',
    name: 'ManagementInventory',
    component: __WEBPACK_IMPORTED_MODULE_65_src_components_Dashboard_Views_Management_Inventory_ManagementInventory_vue__["a" /* default */]
  }, {
    path: 'inventory/add',
    name: 'AddInventory',
    component: __WEBPACK_IMPORTED_MODULE_66_src_components_Dashboard_Views_Management_Inventory_ManagementInventoryAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'inventory/edit/:vatNumber/:series/:number/:externalLocationId',
    name: 'EditInventory',
    component: __WEBPACK_IMPORTED_MODULE_67_src_components_Dashboard_Views_Management_Inventory_ManagementInventoryEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'initialStock',
    name: 'ManagementInitialStock',
    component: __WEBPACK_IMPORTED_MODULE_68_src_components_Dashboard_Views_Management_InitialStock_ManagementInitialStock_vue__["a" /* default */]
  }, {
    path: 'initialStock/add',
    name: 'AddInitialStock',
    component: __WEBPACK_IMPORTED_MODULE_69_src_components_Dashboard_Views_Management_InitialStock_ManagementInitialStockAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'initialStock/edit/:id/',
    name: 'EditInitialStock',
    component: __WEBPACK_IMPORTED_MODULE_70_src_components_Dashboard_Views_Management_InitialStock_ManagementInitialStockEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'suppliers-tabs',
    name: 'ManagementSuppliersTabs',
    component: __WEBPACK_IMPORTED_MODULE_74_src_components_Dashboard_Views_Management_Suppliers_ManagementSuppliersTabs_vue__["a" /* default */]
  }, {
    path: 'suppliers',
    name: 'ManagementSuppliers',
    component: __WEBPACK_IMPORTED_MODULE_75_src_components_Dashboard_Views_Management_Suppliers_ManagementSuppliers_vue__["a" /* default */]
  }, {
    path: 'orders-suppliers',
    name: 'ManagementOrdersSuppliers',
    component: __WEBPACK_IMPORTED_MODULE_76_src_components_Dashboard_Views_Management_Suppliers_ManagementOrdersSuppliers_vue__["a" /* default */]
  }, {
    path: 'my-orders-suppliers',
    name: 'ManagementMyOrdersSuppliers',
    component: __WEBPACK_IMPORTED_MODULE_77_src_components_Dashboard_Views_Management_Suppliers_ManagementMyOrdersSuppliers_vue__["a" /* default */]
  }, {
    path: 'my-orders-suppliers/add',
    name: 'AddManagementMyOrdersSuppliers',
    component: __WEBPACK_IMPORTED_MODULE_78_src_components_Dashboard_Views_Management_Suppliers_ManagementMyOrdersSuppliersAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'my-orders-suppliers/edit/:id',
    name: 'EditManagementMyOrdersSuppliers',
    component: __WEBPACK_IMPORTED_MODULE_79_src_components_Dashboard_Views_Management_Suppliers_ManagementMyOrdersSuppliersEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'for-orders-suppliers/add',
    name: 'AddManagementForOrdersSuppliers',
    component: __WEBPACK_IMPORTED_MODULE_81_src_components_Dashboard_Views_Management_Suppliers_ManagementForOrdersSuppliersAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'for-orders-suppliers',
    name: 'ManagementForOrdersSuppliers',
    component: __WEBPACK_IMPORTED_MODULE_80_src_components_Dashboard_Views_Management_Suppliers_ManagementForOrdersSuppliers_vue__["a" /* default */]
  }, {
    path: 'for-orders-suppliers/edit/:id',
    name: 'EditManagementForOrdersSuppliers',
    component: __WEBPACK_IMPORTED_MODULE_82_src_components_Dashboard_Views_Management_Suppliers_ManagementForOrdersSuppliersEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'accounting-sales',
    name: 'AccountingSales',
    component: __WEBPACK_IMPORTED_MODULE_84_src_components_Dashboard_Views_Management_Accounting_AccountingSales_vue__["a" /* default */]
  }, {
    path: 'accounting-inbound-invoices',
    name: 'AccountingSales',
    component: __WEBPACK_IMPORTED_MODULE_83_src_components_Dashboard_Views_Management_Accounting_AccountingInboundInvoices_vue__["a" /* default */]
  }, {
    path: 'casa-register',
    name: 'ManagementCasaRegister',
    component: __WEBPACK_IMPORTED_MODULE_85_src_components_Dashboard_Views_Management_Casa_ManagementCasaRegister_vue__["a" /* default */]
  }, {
    path: 'settings-users',
    name: 'ManagementUsers',
    component: __WEBPACK_IMPORTED_MODULE_88_src_components_Dashboard_Views_Management_ManagementUsers_vue__["a" /* default */]
  }, {
    path: 'reports',
    name: 'ManagementReports',
    component: __WEBPACK_IMPORTED_MODULE_86_src_components_Dashboard_Views_Management_ManagementReports_vue__["a" /* default */]
  }, {
    path: 'settings',
    name: 'ManagementSettings',
    component: __WEBPACK_IMPORTED_MODULE_87_src_components_Dashboard_Views_Management_ManagementSettings_vue__["a" /* default */]
  }]
};

var orderScreen = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/ods/order-screen',
    name: 'Order Screen',
    component: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreen_vue__["a" /* default */]
  }, {
    path: '/ods/order-screen/add',
    name: 'Add Order Screen',
    component: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreenAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/ods/order-screen/edit/:id',
    name: 'Edit Order Screen',
    component: __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Screens_OrderScreen_OrderScreenEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/pos/screen/add',
    name: 'Add Screen',
    component: __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Screens_PosScreen_PosScreenAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/pos/screen/edit/:id',
    name: 'Edit Screen',
    component: __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Screens_PosScreen_PosScreenEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/digital/signage/add',
    name: 'Digital Order Screen Add',
    component: __WEBPACK_IMPORTED_MODULE_31_src_components_Dashboard_Views_Screens_DigitalSignage_DigitalSignageAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/digital/signage/edit/:id',
    name: 'Digital Order Screen Edit',
    component: __WEBPACK_IMPORTED_MODULE_32_src_components_Dashboard_Views_Screens_DigitalSignage_DigitalSignageEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var catalogView = {
  path: '/catalog',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Catalog',
    component: __WEBPACK_IMPORTED_MODULE_138_src_components_Dashboard_Views_Catalog_CatalogSidebar_vue__["a" /* default */]
  }]
};

var InfoPage = {
  path: '/info-pages',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Info Pages',
    component: __WEBPACK_IMPORTED_MODULE_100_src_components_Dashboard_Views_InfoPages_InfoPages_vue__["a" /* default */]
  }]
};

var infoPagesCustom = {
  path: '/custom-info-pages',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Pages Info Custom',
    component: __WEBPACK_IMPORTED_MODULE_101_src_components_Dashboard_Views_InfoPagesCustom_CustomInfoPages_vue__["a" /* default */]
  }, {
    path: '/custom-info-pages/add',
    name: 'Add Page Info Custom',
    component: __WEBPACK_IMPORTED_MODULE_102_src_components_Dashboard_Views_InfoPagesCustom_CustomInfoPageAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/custom-info-pages/edit/:id',
    name: 'Edit Page Info Custom',
    component: __WEBPACK_IMPORTED_MODULE_103_src_components_Dashboard_Views_InfoPagesCustom_CustomInfoPageEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var GiftCardFormRoute = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/gift-cards/:id',
    name: 'GiftCardForm',
    component: __WEBPACK_IMPORTED_MODULE_33_src_components_Dashboard_Views_Marketing_GiftCard_GiftCardForm_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var ordersPos = {
  path: '/add-order',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Orders',
    component: __WEBPACK_IMPORTED_MODULE_110_src_components_Dashboard_Views_OrdersPos_OrdersPos_vue__["a" /* default */]
  }, {
    path: '/add-order/:id',
    name: 'Order Details',
    component: __WEBPACK_IMPORTED_MODULE_111_src_components_Dashboard_Views_OrdersPos_OrdersPosView_vue__["a" /* default */]
  }]
};

var ordersPosClientScreen = {
  path: '/order-pos-client-screen',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Order Pos Client Screen',
    component: __WEBPACK_IMPORTED_MODULE_112_src_components_Dashboard_Views_OrdersPos_OrderPosClientScreen_vue__["a" /* default */]
  }]
};

var scanner = {
  path: '/scanner',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Scanner',
    component: __WEBPACK_IMPORTED_MODULE_109_src_components_Dashboard_Views_LoyaltyPointsScanner_LoyaltyPointsScanner_vue__["a" /* default */]
  }]
};

var online = {
  path: '/online',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Online',
    component: __WEBPACK_IMPORTED_MODULE_135_src_components_Dashboard_Views_Online_Online_vue__["a" /* default */]
  }]
};

var kiosk = {
  path: '/kiosk',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Kiosk',
    component: __WEBPACK_IMPORTED_MODULE_136_src_components_Dashboard_Views_Kiosk_Kiosk_vue__["a" /* default */]
  }]
};

var qr = {
  path: '/qr',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Qr',
    component: __WEBPACK_IMPORTED_MODULE_137_src_components_Dashboard_Views_Qr_Qr_vue__["a" /* default */]
  }]
};

var dispatch = {
  path: '/dispatch',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Dispatch',
    component: __WEBPACK_IMPORTED_MODULE_129_src_components_Dashboard_Views_Dispatch_Dispatch_vue__["a" /* default */]
  }]
};

var dispatchTabs = {
  path: '/dispatch-view',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Dispatch Tabs',
    component: __WEBPACK_IMPORTED_MODULE_130_src_components_Dashboard_Views_Dispatch_DispatchTabs_vue__["a" /* default */]
  }]
};

var dispatchOrders = {
  path: '/dispatch',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/dispach-orders',
    name: 'Dispatch Orders',
    component: __WEBPACK_IMPORTED_MODULE_131_src_components_Dashboard_Views_Dispatch_DispatchView_vue__["a" /* default */]
  }, {
    path: '/dispach-drivers',
    name: 'Dispatch Drivers',
    component: __WEBPACK_IMPORTED_MODULE_132_src_components_Dashboard_Views_Dispatch_DispatchDrivers_vue__["a" /* default */]
  }, {
    path: '/dispach-reports',
    name: 'Dispatch Reports',
    component: __WEBPACK_IMPORTED_MODULE_133_src_components_Dashboard_Views_Dispatch_DispatchReports_vue__["a" /* default */]
  }, {
    path: '/dispach-settings',
    name: 'Dispatch Settings',
    component: __WEBPACK_IMPORTED_MODULE_134_src_components_Dashboard_Views_Dispatch_DispatchSettings_vue__["a" /* default */]
  }]
};

var posSettings = {
  path: '/pos',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Pos Index',
    component: __WEBPACK_IMPORTED_MODULE_113_src_components_Dashboard_Views_PosSettings_PosView_vue__["a" /* default */]
  }, {
    path: '/pos/list',
    name: 'Pos List',
    component: __WEBPACK_IMPORTED_MODULE_115_src_components_Dashboard_Views_PosSettings_PosList_vue__["a" /* default */]
  }, {
    path: '/pos/add',
    name: 'Pos Add',
    component: __WEBPACK_IMPORTED_MODULE_119_src_components_Dashboard_Views_PosSettings_pos_PosAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/pos/edit/:id',
    name: 'Pos Edit',
    component: __WEBPACK_IMPORTED_MODULE_120_src_components_Dashboard_Views_PosSettings_pos_PosEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/pos/users',
    name: 'Pos Users',
    component: __WEBPACK_IMPORTED_MODULE_116_src_components_Dashboard_Views_PosSettings_PosSettingsUsers_vue__["a" /* default */]
  }, {
    path: '/pos/users/add',
    name: 'Pos Users Add',
    component: __WEBPACK_IMPORTED_MODULE_121_src_components_Dashboard_Views_PosSettings_users_PosUserAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/pos/users/:id',
    name: 'Pos Users Edit',
    component: __WEBPACK_IMPORTED_MODULE_122_src_components_Dashboard_Views_PosSettings_users_PosUserEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/pos/map/add',
    name: 'Pos Map Add',
    component: __WEBPACK_IMPORTED_MODULE_123_src_components_Dashboard_Views_PosSettings_maps_PosMapAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/pos/map/:id',
    name: 'Pos Map Edit',
    component: __WEBPACK_IMPORTED_MODULE_124_src_components_Dashboard_Views_PosSettings_maps_PosMapEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/pos/settings',
    name: 'Pos Settings',
    component: __WEBPACK_IMPORTED_MODULE_117_src_components_Dashboard_Views_PosSettings_PosSettingsSettings_vue__["a" /* default */]
  }, {
    path: '/pos/reports',
    name: 'Pos Reports',
    component: __WEBPACK_IMPORTED_MODULE_118_src_components_Dashboard_Views_PosSettings_PosSettingsReports_vue__["a" /* default */]
  }, {
    path: '/fiscal-printer/add',
    name: 'Fiscal Printer Add',
    component: __WEBPACK_IMPORTED_MODULE_125_src_components_Dashboard_Views_PosSettings_fiscalPrinter_FiscalPrinterAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/fiscal-printer/edit/:id',
    name: 'Fiscal Printer Edit',
    component: __WEBPACK_IMPORTED_MODULE_126_src_components_Dashboard_Views_PosSettings_fiscalPrinter_FiscalPrinterEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/cantar/add',
    name: 'Cantar Add',
    component: __WEBPACK_IMPORTED_MODULE_127_src_components_Dashboard_Views_PosSettings_cantar_CantarAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/cantar/edit/:id',
    name: 'Cantar Edit',
    component: __WEBPACK_IMPORTED_MODULE_128_src_components_Dashboard_Views_PosSettings_cantar_CantarEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var posSettings2 = {
  path: '/pos',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/pos/tabs',
    name: 'Pos tabs',
    component: __WEBPACK_IMPORTED_MODULE_114_src_components_Dashboard_Views_PosSettings_PosTabs_vue__["a" /* default */]
  }]
};

var reservations = {
  path: '/reservations',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Reservations',
    component: __WEBPACK_IMPORTED_MODULE_104_src_components_Dashboard_Views_Reservations_Reservations_vue__["a" /* default */],
    session: 'newReservations'
  }]
};

var tables = {
  path: '/tables',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Tables',
    component: __WEBPACK_IMPORTED_MODULE_105_src_components_Dashboard_Views_Tables_Tables_vue__["a" /* default */],
    session: 'newTables'
  }]
};

var ordersMenu = {
  path: '/orders',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Orders Menu',
    component: __WEBPACK_IMPORTED_MODULE_106_src_components_Dashboard_Views_Orders_Orders_vue__["a" /* default */],
    session: 'newOrders'
  }, {
    path: 'view/:id',
    name: 'Order Details Menu',
    component: __WEBPACK_IMPORTED_MODULE_107_src_components_Dashboard_Views_Orders_OrderView_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'edit/:id',
    name: 'Edit Order',
    component: __WEBPACK_IMPORTED_MODULE_108_src_components_Dashboard_Views_Orders_OrderEdit_vue__["a" /* default */]
  }]
};

var integrationPlatformMenuImports = {
  path: '/integrations',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/integrations/platform-menu-imports/:locationId/:importId?',
    name: 'Platform Menu Imports',
    component: __WEBPACK_IMPORTED_MODULE_237_src_components_Dashboard_Views_Integrations_PlatformMenuImports_PlatformMenuImports_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var integrationMenuFix = {
  path: '/integrations/menu-fix',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/integrations/menu-fix/product/:id',
    name: 'Integration Menu Fix Product',
    component: __WEBPACK_IMPORTED_MODULE_152_src_components_Dashboard_Views_Integrations_IntegrationMenuEntityEditPage_vue__["a" /* default */],
    meta: { entityType: 'product' }
  }, {
    path: '/integrations/menu-fix/product-option/:id',
    name: 'Integration Menu Fix Product Option',
    component: __WEBPACK_IMPORTED_MODULE_152_src_components_Dashboard_Views_Integrations_IntegrationMenuEntityEditPage_vue__["a" /* default */],
    meta: { entityType: 'product-option' }
  }, {
    path: '/integrations/menu-fix/group-option/:id',
    name: 'Integration Menu Fix Group Option',
    component: __WEBPACK_IMPORTED_MODULE_152_src_components_Dashboard_Views_Integrations_IntegrationMenuEntityEditPage_vue__["a" /* default */],
    meta: { entityType: 'group-option' }
  }]
};

var productsMenu = {
  path: '/products',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/products',
    name: 'Products',
    component: __WEBPACK_IMPORTED_MODULE_139_src_components_Dashboard_Views_Products_ProductsList_vue__["a" /* default */]
  }, {
    path: '/products/add',
    name: 'Add Product',
    component: __WEBPACK_IMPORTED_MODULE_140_src_components_Dashboard_Views_Products_ProductAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/products/edit/:id',
    name: 'Edit Product',
    component: __WEBPACK_IMPORTED_MODULE_141_src_components_Dashboard_Views_Products_ProductEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var priceListMenu = {
  path: '/price-profile',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/price-profile',
    name: 'Products',
    component: __WEBPACK_IMPORTED_MODULE_142_src_components_Dashboard_Views_Products_PriceProfile_vue__["a" /* default */]
  }, {
    path: '/price-profile/add',
    name: 'Add Price Profile',
    component: __WEBPACK_IMPORTED_MODULE_143_src_components_Dashboard_Views_Products_PriceProfileAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/price-profile/edit/:id',
    name: 'Edit Price Profile',
    component: __WEBPACK_IMPORTED_MODULE_144_src_components_Dashboard_Views_Products_PriceProfileEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var prodOptionsMenu = {
  path: '/product-options2',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/product-options2',
    name: 'Product Options Menu',
    component: __WEBPACK_IMPORTED_MODULE_145_src_components_Dashboard_Views_Settings_Tabs_ProductOptions_vue__["a" /* default */]
  }]
};

var prodOptions = {
  path: '/product-options',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/product-options',
    name: 'Product Options',
    component: __WEBPACK_IMPORTED_MODULE_146_src_components_Dashboard_Views_ProductOptions_ProductOptions_vue__["a" /* default */]
  }, {
    path: '/product-option/add',
    name: 'Add Product Option',
    component: __WEBPACK_IMPORTED_MODULE_147_src_components_Dashboard_Views_ProductOptions_ProductOptionsAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/product-option/edit/:id',
    name: 'Edit Product Option',
    component: __WEBPACK_IMPORTED_MODULE_148_src_components_Dashboard_Views_ProductOptions_ProductOptionsEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var groupOptionsMenu = {
  path: '/group-options',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/group-options',
    name: 'Group Options',
    component: __WEBPACK_IMPORTED_MODULE_149_src_components_Dashboard_Views_GroupOptions_GroupOptions_vue__["a" /* default */]
  }, {
    path: '/group-option/add',
    name: 'Add Group Option',
    component: __WEBPACK_IMPORTED_MODULE_150_src_components_Dashboard_Views_GroupOptions_GroupOptionsAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/group-option/edit/:id',
    name: 'Edit Group Option',
    component: __WEBPACK_IMPORTED_MODULE_151_src_components_Dashboard_Views_GroupOptions_GroupOptionsEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var prodFiltersMenu = {
  path: '/product-filters',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/product-filters',
    name: 'Product Filters',
    component: __WEBPACK_IMPORTED_MODULE_153_src_components_Dashboard_Views_Settings_Tabs_ProductFilters_vue__["a" /* default */]
  }]
};

var linksMenu = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/menu-links',
    name: 'Menu Links',
    component: __WEBPACK_IMPORTED_MODULE_160_src_components_Dashboard_Views_MenuLinks_MenuLinks_vue__["a" /* default */]
  }, {
    path: '/menu-links/add',
    name: 'Add Menu Link',
    component: __WEBPACK_IMPORTED_MODULE_161_src_components_Dashboard_Views_MenuLinks_MenuLinkAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/menu-links/edit/:id',
    name: 'Edit Menu Link',
    component: __WEBPACK_IMPORTED_MODULE_162_src_components_Dashboard_Views_MenuLinks_MenuLinkEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var categoriesMenu = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/categories',
    name: 'Categories',
    component: __WEBPACK_IMPORTED_MODULE_154_src_components_Dashboard_Views_Categories_Categories_vue__["a" /* default */]
  }, {
    path: '/categories/add',
    name: 'Add Category',
    component: __WEBPACK_IMPORTED_MODULE_155_src_components_Dashboard_Views_Categories_CategoryAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/categories/edit/:id',
    name: 'Edit Category',
    component: __WEBPACK_IMPORTED_MODULE_156_src_components_Dashboard_Views_Categories_CategoryEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var topCategoriesMenu = {
  path: '/top-categories',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/top-categories',
    name: 'TopCategories',
    component: __WEBPACK_IMPORTED_MODULE_157_src_components_Dashboard_Views_TopCategories_TopCategories_vue__["a" /* default */]
  }, {
    path: '/top-categories/add',
    name: 'Add Top Category',
    component: __WEBPACK_IMPORTED_MODULE_158_src_components_Dashboard_Views_TopCategories_TopCategoryAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/top-categories/edit/:id',
    name: 'Edit Top Category',
    component: __WEBPACK_IMPORTED_MODULE_159_src_components_Dashboard_Views_TopCategories_TopCategoryEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var marketingMenu = {
  path: '/marketing',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: 'campaigns',
    name: 'Campaigns',
    component: __WEBPACK_IMPORTED_MODULE_164_src_components_Dashboard_Views_Marketing_Campaigns_Campaigns_vue__["a" /* default */]
  }, {
    path: 'campaigns/add',
    name: 'Add Campaign',
    component: __WEBPACK_IMPORTED_MODULE_165_src_components_Dashboard_Views_Marketing_Campaigns_CampaignAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'campaigns/edit/:id',
    name: 'Edit Campaign',
    component: __WEBPACK_IMPORTED_MODULE_166_src_components_Dashboard_Views_Marketing_Campaigns_CampaignEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'coupons/add',
    name: 'Add Coupon',
    component: __WEBPACK_IMPORTED_MODULE_167_src_components_Dashboard_Views_Marketing_DiscountCoupons_CouponPage_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'coupons/edit/:id',
    name: 'Edit Coupon',
    component: __WEBPACK_IMPORTED_MODULE_167_src_components_Dashboard_Views_Marketing_DiscountCoupons_CouponPage_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'subscriptions/add',
    name: 'Add Subscription',
    component: __WEBPACK_IMPORTED_MODULE_168_src_components_Dashboard_Views_Marketing_Subscriptions_SubscriptionPage_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'subscriptions/edit/:id',
    name: 'Edit Subscription',
    component: __WEBPACK_IMPORTED_MODULE_168_src_components_Dashboard_Views_Marketing_Subscriptions_SubscriptionPage_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'subscriptions/subscribers',
    name: 'Subscription Subscribers',
    component: __WEBPACK_IMPORTED_MODULE_169_src_components_Dashboard_Views_Marketing_Subscriptions_SubscribersPage_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'automation/add',
    name: 'Add Automation Campaign',
    component: __WEBPACK_IMPORTED_MODULE_170_src_components_Dashboard_Views_Marketing_AutomationCampaigns_AutomationCampaignPage_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'automation/edit/:id',
    name: 'Edit Automation Campaign',
    component: __WEBPACK_IMPORTED_MODULE_170_src_components_Dashboard_Views_Marketing_AutomationCampaigns_AutomationCampaignPage_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'automation/beneficiaries',
    name: 'Automation Campaign Beneficiaries',
    component: __WEBPACK_IMPORTED_MODULE_171_src_components_Dashboard_Views_Marketing_AutomationCampaigns_AutomationBeneficiariesPage_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'donation-campaigns',
    name: 'Donation Campaigns',
    component: __WEBPACK_IMPORTED_MODULE_172_src_components_Dashboard_Views_Marketing_DonationCampaigns_DonationCampaigns_vue__["a" /* default */]
  }, {
    path: 'donation-campaigns/add',
    name: 'Add Donation Campaign',
    component: __WEBPACK_IMPORTED_MODULE_173_src_components_Dashboard_Views_Marketing_DonationCampaigns_DonationCampaignAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'donation-campaigns/edit/:id',
    name: 'Edit Donation Campaign',
    component: __WEBPACK_IMPORTED_MODULE_174_src_components_Dashboard_Views_Marketing_DonationCampaigns_DonationCampaignEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'menu-subscriptions/add',
    name: 'Add Menu Subscription',
    component: __WEBPACK_IMPORTED_MODULE_175_src_components_Dashboard_Views_Marketing_MenuSubscriptions_MenuSubscriptionPage_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'menu-subscriptions/edit/:id',
    name: 'Edit Menu Subscription',
    component: __WEBPACK_IMPORTED_MODULE_175_src_components_Dashboard_Views_Marketing_MenuSubscriptions_MenuSubscriptionPage_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'menu-subscriptions/subscribers',
    name: 'Menu Subscription Subscribers',
    component: __WEBPACK_IMPORTED_MODULE_176_src_components_Dashboard_Views_Marketing_MenuSubscriptions_MenuSubscribersPage_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'discount-campaigns',
    name: 'Discount Campaigns',
    component: __WEBPACK_IMPORTED_MODULE_177_src_components_Dashboard_Views_Marketing_DiscountCampaigns_DiscountCampaigns_vue__["a" /* default */]
  }, {
    path: 'discount-campaigns/add',
    name: 'Add Discount Campaign',
    component: __WEBPACK_IMPORTED_MODULE_178_src_components_Dashboard_Views_Marketing_DiscountCampaigns_DiscountCampaignAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'discount-campaigns/edit/:id',
    name: 'Edit Discount Campaign',
    component: __WEBPACK_IMPORTED_MODULE_179_src_components_Dashboard_Views_Marketing_DiscountCampaigns_DiscountCampaignEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'challenge-campaigns',
    name: 'Challenge Campaigns',
    component: __WEBPACK_IMPORTED_MODULE_180_src_components_Dashboard_Views_Marketing_ChallengeCampaigns_ChallengeCampaigns_vue__["a" /* default */]
  }, {
    path: 'challenge-campaigns/add',
    name: 'Add Challenge Campaign',
    component: __WEBPACK_IMPORTED_MODULE_181_src_components_Dashboard_Views_Marketing_ChallengeCampaigns_ChallengeCampaignAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'challenge-campaigns/edit/:id',
    name: 'Edit Challenge Campaign',
    component: __WEBPACK_IMPORTED_MODULE_182_src_components_Dashboard_Views_Marketing_ChallengeCampaigns_ChallengeCampaignEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'spinning-wheel-campaigns',
    name: 'Spinning Wheel Campaigns',
    component: __WEBPACK_IMPORTED_MODULE_183_src_components_Dashboard_Views_Marketing_SpinningWheel_SpinningWheelCampaigns_vue__["a" /* default */]
  }, {
    path: 'spinning-wheel-campaigns/add',
    name: 'Add Spinning Wheel Campaign',
    component: __WEBPACK_IMPORTED_MODULE_184_src_components_Dashboard_Views_Marketing_SpinningWheel_SpinningWheelCampaignAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'spinning-wheel-campaigns/edit/:id',
    name: 'Edit Spinning Wheel Campaign',
    component: __WEBPACK_IMPORTED_MODULE_185_src_components_Dashboard_Views_Marketing_SpinningWheel_SpinningWheelCampaignEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'offers',
    name: 'Offers Slider',
    component: __WEBPACK_IMPORTED_MODULE_186_src_components_Dashboard_Views_Marketing_Offers_Offers_vue__["a" /* default */]
  }, {
    path: 'offers/add',
    name: 'Add Offer Slider',
    component: __WEBPACK_IMPORTED_MODULE_188_src_components_Dashboard_Views_Marketing_Offers_OffersAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'offers/edit/:id',
    name: 'Edit Offer Slider',
    component: __WEBPACK_IMPORTED_MODULE_187_src_components_Dashboard_Views_Marketing_Offers_OffersEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'offers/:offer_id/add-group-banner',
    name: 'Add Offer Group',
    component: __WEBPACK_IMPORTED_MODULE_189_src_components_Dashboard_Views_Marketing_Offers_Group_GroupAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'offers/:offer_id/edit-group-banner/:id',
    name: 'Edit Offer Group',
    component: __WEBPACK_IMPORTED_MODULE_190_src_components_Dashboard_Views_Marketing_Offers_Group_GroupEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'dynamic-menus',
    name: 'menus',
    component: __WEBPACK_IMPORTED_MODULE_204_src_components_Dashboard_Views_Marketing_DynamicMenus_DynamicMenu_vue__["a" /* default */]
  }]
};

var marketingView = {
  path: '/marketing',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Marketing',
    component: __WEBPACK_IMPORTED_MODULE_163_src_components_Dashboard_Views_Marketing_MarketingSidebar_vue__["a" /* default */]
  }, {
    path: 'promos',
    name: 'Promos',
    component: __WEBPACK_IMPORTED_MODULE_195_src_components_Dashboard_Views_Marketing_Promos_Promos_vue__["a" /* default */]
  }, {
    path: 'promos/add',
    name: 'Add Promo',
    component: __WEBPACK_IMPORTED_MODULE_196_src_components_Dashboard_Views_Marketing_Promos_PromosAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'promos/edit/:id',
    name: 'Edit Promo',
    component: __WEBPACK_IMPORTED_MODULE_197_src_components_Dashboard_Views_Marketing_Promos_PromosEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'referral-campaigns/add',
    name: 'Add Referral Campaign',
    component: __WEBPACK_IMPORTED_MODULE_198_src_components_Dashboard_Views_Marketing_Referral_ReferralCampaignAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'referral-campaigns/edit/:id',
    name: 'Edit Referral Campaign',
    component: __WEBPACK_IMPORTED_MODULE_199_src_components_Dashboard_Views_Marketing_Referral_ReferralCampaignEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'raffle-campaigns/add',
    name: 'Add Raffle Campaign',
    component: __WEBPACK_IMPORTED_MODULE_200_src_components_Dashboard_Views_Marketing_RaffleCampaigns_RaffleCampaignAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'raffle-campaigns/edit/:id',
    name: 'Edit Raffle Campaign',
    component: __WEBPACK_IMPORTED_MODULE_201_src_components_Dashboard_Views_Marketing_RaffleCampaigns_RaffleCampaignEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'loyalty-store-campaigns/add',
    name: 'Add Loyalty Store Campaign',
    component: __WEBPACK_IMPORTED_MODULE_202_src_components_Dashboard_Views_Marketing_LoyaltyStore_LoyaltyStoreCampaignAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: 'loyalty-store-campaigns/edit/:id',
    name: 'Edit Loyalty Store Campaign',
    component: __WEBPACK_IMPORTED_MODULE_203_src_components_Dashboard_Views_Marketing_LoyaltyStore_LoyaltyStoreCampaignEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var marketingMenuNoSpacing = {
  path: '/marketing',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: 'fidelities',
    name: 'Fidelities',
    component: __WEBPACK_IMPORTED_MODULE_191_src_components_Dashboard_Views_Marketing_Fidelities_Fidelities_vue__["a" /* default */]
  }, {
    path: '/user-label',
    name: 'User Label',
    component: __WEBPACK_IMPORTED_MODULE_192_src_components_Dashboard_Views_Marketing_Fidelities_UserLabel_UserLabeling_vue__["a" /* default */]
  }, {
    path: '/user-label/add',
    name: 'Add User Label',
    component: __WEBPACK_IMPORTED_MODULE_193_src_components_Dashboard_Views_Marketing_Fidelities_UserLabel_UserLabelingAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/user-label/edit/:id',
    name: 'Edit User Label',
    component: __WEBPACK_IMPORTED_MODULE_194_src_components_Dashboard_Views_Marketing_Fidelities_UserLabel_UserLabelingEdit_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var rewardMenu = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/reward-program',
    name: 'Edit Reward Program',
    component: __WEBPACK_IMPORTED_MODULE_205_src_components_Dashboard_Views_RewardProgram_RewardProgramEdit_vue__["a" /* default */]
  }]
};

var reportsMenu = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/reports',
    name: 'Reports',
    component: __WEBPACK_IMPORTED_MODULE_206_src_components_Dashboard_Views_Reports_Reports_vue__["a" /* default */]
  }, {
    path: '/reports/referral-program/ambassador/:ambassadorId',
    name: 'Referral Program Ambassador Drilldown',
    component: __WEBPACK_IMPORTED_MODULE_219_src_components_Dashboard_Views_Reports_Versions_2_ReferralProgramAmbassadorDrilldownModal_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/reports/customer/:id',
    name: 'Customer Details Reports',
    component: __WEBPACK_IMPORTED_MODULE_207_src_components_Dashboard_Views_Reports_ReportsCustomerDetails_vue__["a" /* default */]
  }, {
    path: '/reports/charisma/items/:orderId',
    name: 'Charisma Items',
    component: __WEBPACK_IMPORTED_MODULE_208_src_components_Dashboard_Views_Reports_Versions_2_CharismaItems_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/reports/charisma/location-receipts/:locationId',
    name: 'Charisma Location Receipt Details',
    component: __WEBPACK_IMPORTED_MODULE_218_src_components_Dashboard_Views_Reports_Versions_2_CharismaLocationReceiptDetails_vue__["a" /* default */]
  }, {
    path: '/reports/nexus/items/:orderId',
    name: 'Nexus Items',
    component: __WEBPACK_IMPORTED_MODULE_209_src_components_Dashboard_Views_Reports_Versions_2_NexusItems_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/reports/pos-order-actions/:orderId',
    name: 'POS Order Actions Details',
    component: __WEBPACK_IMPORTED_MODULE_210_src_components_Dashboard_Views_Reports_Versions_2_PosOrderActionsDetails_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/reports/donation-campaigns/:campaignId/orders',
    name: 'Donation Campaign Orders Report',
    component: __WEBPACK_IMPORTED_MODULE_211_src_components_Dashboard_Views_Reports_DonationCampaignOrdersReport_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/reports/raffle-campaigns/:campaignId/participants',
    name: 'Raffle Campaign Participants Report',
    component: __WEBPACK_IMPORTED_MODULE_212_src_components_Dashboard_Views_Reports_RaffleCampaignParticipantsReport_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/reports/loyalty-store/rewards/:rewardId/purchases',
    name: 'Loyalty Store Purchases Report',
    component: __WEBPACK_IMPORTED_MODULE_213_src_components_Dashboard_Views_Reports_LoyaltyStorePurchasesReport_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/reports/challenge-campaigns/:challengeId/users',
    name: 'Challenge Campaign Users Report',
    component: __WEBPACK_IMPORTED_MODULE_214_src_components_Dashboard_Views_Reports_ChallengeCampaignUsersReport_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/reports/challenge-campaigns/:challengeId/users/:userId/logs',
    name: 'Challenge User Progress Logs Report',
    component: __WEBPACK_IMPORTED_MODULE_215_src_components_Dashboard_Views_Reports_ChallengeUserProgressLogsReport_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/reports/spinning-wheel/rewards/:rewardId/users',
    name: 'Spinning Wheel Users Report',
    component: __WEBPACK_IMPORTED_MODULE_217_src_components_Dashboard_Views_Reports_SpinningWheelUsersReport_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/reports/spinning-wheel/:campaignId/rewards',
    name: 'Spinning Wheel Rewards Report',
    component: __WEBPACK_IMPORTED_MODULE_216_src_components_Dashboard_Views_Reports_SpinningWheelRewardsReport_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var settingsMenu = {
  path: '/settings',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/',
    name: 'Sidebar Settings',
    component: __WEBPACK_IMPORTED_MODULE_220_src_components_Dashboard_Views_Settings_SettingsSidebar_vue__["a" /* default */]
  }, {
    path: '/settings/general',
    name: 'General Settings',
    component: __WEBPACK_IMPORTED_MODULE_221__components_Dashboard_Views_Settings_SettingsGeneral_vue__["a" /* default */]
  }, {
    path: '/settings/locations',
    name: 'Location Settings',
    component: __WEBPACK_IMPORTED_MODULE_222_src_components_Dashboard_Views_Settings_SettingsLocations_vue__["a" /* default */]
  }, {
    path: '/settings/modules',
    name: 'Module Manager',
    component: __WEBPACK_IMPORTED_MODULE_223_src_components_Dashboard_Views_Settings_SettingsModules_vue__["a" /* default */]
  }, {
    path: '/users',
    name: 'Users',
    component: __WEBPACK_IMPORTED_MODULE_224_src_components_Dashboard_Views_Settings_Users_Users_vue__["a" /* default */]
  }, {
    path: '/user/add',
    name: 'Add User',
    component: __WEBPACK_IMPORTED_MODULE_225_src_components_Dashboard_Views_Settings_Users_UserAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/user/edit/:id',
    name: 'Edit User',
    component: __WEBPACK_IMPORTED_MODULE_226_src_components_Dashboard_Views_Settings_Users_UserEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/feedback',
    name: 'Feedback',
    component: __WEBPACK_IMPORTED_MODULE_229_src_components_Dashboard_Views_Settings_Feedback_Feedback_vue__["a" /* default */],
    session: 'newFeedback'
  }, {
    path: '/feedback/view/:id',
    name: 'View Feedback',
    component: __WEBPACK_IMPORTED_MODULE_230_src_components_Dashboard_Views_Settings_Feedback_FeedbackView_vue__["a" /* default */]
  }, {
    path: '/printer/add',
    name: 'Add Printer',
    component: __WEBPACK_IMPORTED_MODULE_227_src_components_Dashboard_Views_Settings_Printer_PrinterAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/printer/edit/:id',
    name: 'Edit Printer',
    component: __WEBPACK_IMPORTED_MODULE_228_src_components_Dashboard_Views_Settings_Printer_PrinterEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/payment-groups/add',
    name: 'Add Payment Groups',
    component: __WEBPACK_IMPORTED_MODULE_241_src_components_Dashboard_Views_Settings_PaymentGroups_PaymentGroupsAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/payment-groups/edit/:id',
    name: 'Edit Payment Groups',
    component: __WEBPACK_IMPORTED_MODULE_242_src_components_Dashboard_Views_Settings_PaymentGroups_PaymentGroupsEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/location-groups',
    name: 'Location Groups',
    component: __WEBPACK_IMPORTED_MODULE_231_src_components_Dashboard_Views_Settings_LocationGroups_LocationGroups_vue__["a" /* default */]
  }, {
    path: '/location-groups/add',
    name: 'Add Location Groups',
    component: __WEBPACK_IMPORTED_MODULE_232_src_components_Dashboard_Views_Settings_LocationGroups_LocationGroupsAdd_vue__["a" /* default */]
  }, {
    path: '/location-groups/edit/:id',
    name: 'Edit Location Groups',
    component: __WEBPACK_IMPORTED_MODULE_233_src_components_Dashboard_Views_Settings_LocationGroups_LocationGroupsEdit_vue__["a" /* default */]
  }, {
    path: '/locations/add',
    name: 'Add New Location',
    component: __WEBPACK_IMPORTED_MODULE_234_src_components_Dashboard_Views_Settings_Locations_LocationAdd_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/locations/edit/:id',
    name: 'Edit Location',
    component: __WEBPACK_IMPORTED_MODULE_235_src_components_Dashboard_Views_Settings_Locations_LocationEdit_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/locations/edit-wolt/:id',
    name: 'Edit Location Wolt',
    component: __WEBPACK_IMPORTED_MODULE_236_src_components_Dashboard_Views_Settings_Locations_LocationEditWolt_vue__["a" /* default */]
  }, {
    path: '/locations/:locationId/product-imports',
    name: 'Product Import History',
    component: __WEBPACK_IMPORTED_MODULE_238_src_components_Dashboard_Views_Settings_Locations_ProductImports_ProductImportList_vue__["a" /* default */],
    meta: { modal: true }
  }, {
    path: '/locations/:locationId/product-imports/:importId',
    name: 'Product Import Detail',
    component: __WEBPACK_IMPORTED_MODULE_239_src_components_Dashboard_Views_Settings_Locations_ProductImports_ProductImportDetail_vue__["a" /* default */],
    meta: { modal: true }
  }]
};

var feedbackMenu = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/feedback',
    name: 'Feedback Menu',
    component: __WEBPACK_IMPORTED_MODULE_229_src_components_Dashboard_Views_Settings_Feedback_Feedback_vue__["a" /* default */],
    session: 'newFeedback'
  }, {
    path: '/feedback/view/:id',
    name: 'View Feedback Menu',
    component: __WEBPACK_IMPORTED_MODULE_230_src_components_Dashboard_Views_Settings_Feedback_FeedbackView_vue__["a" /* default */]
  }]
};

var adminOverviewNoSpacing = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/admin/overview',
  children: []
};

var adminOverview = {
  path: '/admin',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/admin/overview',
  children: [{
    path: 'overview',
    name: 'Overview',
    component: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Dashboard_Overview_vue__["a" /* default */]
  }, {
    path: 'stats',
    name: 'Stats',
    component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Dashboard_Stats_vue__["a" /* default */]
  }]
};

var notFound = {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */]
};

var payment = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/payment',
    name: 'Payment',
    component: __WEBPACK_IMPORTED_MODULE_240_src_components_Dashboard_Views_Payment_Payment_vue__["a" /* default */]
  }]
};

var newsletter = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: '/newsletter',
    name: 'Newsletter Sidebar',
    component: __WEBPACK_IMPORTED_MODULE_243_src_components_Dashboard_Views_Newsletter_NewsletterSidebar_vue__["a" /* default */]
  }, {
    path: '/newsletter/news',
    name: 'News',
    component: __WEBPACK_IMPORTED_MODULE_244_src_components_Dashboard_Views_Newsletter_Tabs_News_vue__["a" /* default */]
  }, {
    path: '/newsletter/monthly-info',
    name: 'MonthlyInfo',
    component: __WEBPACK_IMPORTED_MODULE_245_src_components_Dashboard_Views_Newsletter_Tabs_MonthlyInfo_vue__["a" /* default */]
  }, {
    path: '/newsletter/video-support',
    name: 'VideoSupport',
    component: __WEBPACK_IMPORTED_MODULE_246_src_components_Dashboard_Views_Newsletter_Tabs_VideoSupport_vue__["a" /* default */]
  }]
};

var routes = [adminOverviewNoSpacing, orderingMenu, customersMenu, customersGroupsMenu, screens, orderScreenView, kdsSidebar, kdsUsers, kdsSections, kdsSettings, orderScreenTabs, kdsReport, orderScreen, feedbackMenu, InfoPage, ordersPos, ordersPosClientScreen, online, kiosk, qr, dispatch, dispatchOrders, marketingView, customersView, approvalsView, catalogView, dispatchTabs, scanner, ordersMenu, reservations, tables, productsMenu, priceListMenu, prodOptionsMenu, prodOptions, groupOptionsMenu, integrationMenuFix, integrationPlatformMenuImports, prodFiltersMenu, categoriesMenu, marketingMenu, linksMenu, marketingMenuNoSpacing, rewardMenu, infoPagesCustom, GiftCardFormRoute, reportsMenu, settingsMenu, topCategoriesMenu, loginPage, registerPage, recoverPage, resetPage, woltPage, adminOverview, payment, newsletter, notFound, management, managementTabs, invoiceTabs, invoice, posSettings, posSettings2];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T2pQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSettings_vue__ = __webpack_require__("V3Zp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e88b05b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSettings_vue__ = __webpack_require__("IWKa");
function injectStyle (ssrContext) {
  __webpack_require__("Xc4l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e88b05b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e88b05b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T343":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"platform-import-page"},[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",class:{ disabled: _vm.busy },attrs:{"href":"#/settings?tabIndex=4","title":_vm.$t('general.back'),"aria-disabled":_vm.busy ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)},"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key," ")){ return null; }$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('general.back'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"platform-import"},[_c('header',{staticClass:"import-header"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.t('title')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.t('intro')))])])]),_vm._v(" "),_c('form',{staticClass:"url-form",on:{"submit":function($event){$event.preventDefault();return _vm.createImport($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.storeUrl),expression:"storeUrl",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"url","required":"","placeholder":"https://wolt.com/… / https://glovoapp.com/… / https://food.bolt.eu/…","disabled":_vm.busy,"aria-label":_vm.t('storeUrl')},domProps:{"value":(_vm.storeUrl)},on:{"invalid":function($event){_vm.validateStoreUrl($event.target)},"input":[function($event){if($event.target.composing){ return; }_vm.storeUrl=$event.target.value.trim()},function($event){$event.target.setCustomValidity('')}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('button',{staticClass:"import-button import-button--primary",attrs:{"type":"submit","disabled":_vm.busy || !_vm.storeUrl.trim()}},[_c('i',{staticClass:"fa",class:_vm.busy && _vm.activeAction === 'preview' ? 'fa-spinner fa-spin' : 'fa-download',attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.busy && _vm.activeAction === 'preview' ? _vm.t('loading') : _vm.t('preview')))])]),_vm._v(" "),(_vm.error && !_vm.draft)?_c('p',{staticClass:"import-error",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.busy && _vm.activeAction === 'preview')?_c('p',{staticClass:"import-progress",attrs:{"role":"status"}},[_vm._v(_vm._s(_vm.t('processing')))]):_vm._e(),_vm._v(" "),(_vm.batch)?_c('div',{staticClass:"import-workspace",attrs:{"aria-busy":_vm.busy ? 'true' : 'false'}},[_c('div',{staticClass:"import-summary"},[_c('span',{staticClass:"import-status"},[_vm._v(_vm._s(_vm.batch.platform)+" · #"+_vm._s(_vm.batch.id))]),_c('span',[_vm._v(_vm._s(_vm.batch.status))])]),_vm._v(" "),(_vm.batch.error && !_vm.error)?_c('p',{staticClass:"import-error"},[_vm._v(_vm._s(_vm.batch.error))]):_vm._e(),_vm._v(" "),(_vm.batch.status === 'PRODUCTS_DELETED')?_c('p',{staticClass:"import-progress",attrs:{"role":"status"}},[_vm._v(_vm._s(_vm.t('productsDeleted')))]):_vm._e(),_vm._v(" "),(_vm.batch.status === 'CONFIRMED')?_c('p',{staticClass:"import-success",attrs:{"role":"status"}},[_vm._v(_vm._s(_vm.t('done'))+" · "+_vm._s(_vm.resultCount)+" "+_vm._s(_vm.t('products')))]):_vm._e(),_vm._v(" "),(_vm.draft)?_c('div',[(_vm.diagnostics.length)?_c('details',{staticClass:"diagnostics"},[_c('summary',[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.t('gaps'))+" ("+_vm._s(_vm.diagnostics.length)+")")]),_vm._v(" "),_c('ul',_vm._l((_vm.diagnostics),function(issue,i){return _c('li',{key:i},[_vm._v(_vm._s(_vm.warningMessage(issue)))])}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"review-bar"},[_c('div',{staticClass:"review-tabs",attrs:{"role":"group","aria-label":_vm.t('view')}},[_c('button',{class:{ 'is-active': _vm.reviewMode === 'preview' },attrs:{"type":"button","aria-pressed":_vm.reviewMode === 'preview'},on:{"click":function($event){_vm.reviewMode = 'preview'}}},[_vm._v(_vm._s(_vm.t('menuPreview')))]),_vm._v(" "),_c('button',{class:{ 'is-active': _vm.reviewMode === 'edit' },attrs:{"type":"button","aria-pressed":_vm.reviewMode === 'edit'},on:{"click":function($event){_vm.reviewMode = 'edit'}}},[_vm._v(_vm._s(_vm.t('editDetails')))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"search","placeholder":_vm.t('search'),"aria-label":_vm.t('search')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"review-count"},[_vm._v(_vm._s(_vm.selectedCount)+" / "+_vm._s(_vm.draft.products.length)+" "+_vm._s(_vm.t('products'))+" · "+_vm._s(_vm.draft.currency))])]),_vm._v(" "),(_vm.reviewMode === 'preview')?_c('div',{staticClass:"preview-stage"},[(_vm.previewCategories.length)?_c(_vm.previewLayout,{tag:"component",attrs:{"categories":_vm.previewCategories,"currency":_vm.draft.currency}}):_c('p',{staticClass:"preview-empty"},[_vm._v(_vm._s(_vm.t('noResults')))])],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reviewMode === 'edit'),expression:"reviewMode === 'edit'"}],staticClass:"review-columns"},[_c('aside',[_c('h5',[_vm._v(_vm._s(_vm.t('categories')))]),_vm._v(" "),_vm._l((_vm.draft.categories),function(category){return _c('div',{key:category.id,staticClass:"category-row"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(category.included),expression:"category.included"}],attrs:{"type":"checkbox","disabled":!_vm.editable || _vm.busy},domProps:{"checked":Array.isArray(category.included)?_vm._i(category.included,null)>-1:(category.included)},on:{"change":[function($event){var $$a=category.included,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(category, "included", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(category, "included", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(category, "included", $$c)}},function($event){_vm.categoryChanged(category)}]}}),_vm._v(" "+_vm._s(category.name))]),_vm._v(" "),(category.image_urls[0])?_c('img',{attrs:{"src":category.image_urls[0],"alt":"","loading":"lazy","referrerpolicy":"no-referrer"}}):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(category.name),expression:"category.name"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy},domProps:{"value":(category.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(category, "name", $event.target.value)}}}),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"placeholder":_vm.t('image'),"disabled":!_vm.editable || _vm.busy},domProps:{"value":category.image_urls[0] || ''},on:{"change":function($event){_vm.setImage(category, $event.target.value)}}})])})],2),_vm._v(" "),_c('main',_vm._l((_vm.filteredProducts),function(product){return _c('details',{key:product.id,staticClass:"product-row"},[_c('summary',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(product.included),expression:"product.included"}],attrs:{"type":"checkbox","disabled":!_vm.editable || _vm.busy},domProps:{"checked":Array.isArray(product.included)?_vm._i(product.included,null)>-1:(product.included)},on:{"click":function($event){$event.stopPropagation();},"change":[function($event){var $$a=product.included,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(product, "included", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(product, "included", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(product, "included", $$c)}},function($event){_vm.productChanged(product)}]}}),_vm._v(" "+_vm._s(product.name)+" — "+_vm._s(product.price)+" "+_vm._s(_vm.draft.currency))]),_vm._v(" "),_c('div',{staticClass:"product-editor"},[(product.image_urls[0])?_c('img',{attrs:{"src":product.image_urls[0],"alt":"","loading":"lazy","referrerpolicy":"no-referrer"}}):_vm._e(),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.t('name'))),_c('input',{directives:[{name:"model",rawName:"v-model",value:(product.name),expression:"product.name"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy},domProps:{"value":(product.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(product, "name", $event.target.value)}}})]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.t('price'))),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(product.price),expression:"product.price",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01","disabled":!_vm.editable || _vm.busy},domProps:{"value":(product.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(product, "price", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.t('description'))),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(product.description),expression:"product.description"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy},domProps:{"value":(product.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(product, "description", $event.target.value)}}})]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.t('image'))),_c('textarea',{staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy},domProps:{"value":product.image_urls.join('\n')},on:{"change":function($event){_vm.setImages(product, $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(product.available),expression:"product.available"}],attrs:{"type":"checkbox","disabled":!_vm.editable || _vm.busy},domProps:{"checked":Array.isArray(product.available)?_vm._i(product.available,null)>-1:(product.available)},on:{"change":function($event){var $$a=product.available,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(product, "available", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(product, "available", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(product, "available", $$c)}}}}),_vm._v(" "+_vm._s(_vm.t('available')))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.t('tax'))),_c('select',{directives:[{name:"model",rawName:"v-model",value:(product.vat_id),expression:"product.vat_id"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(product, "vat_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.t('unknown')))]),_vm._l((_vm.taxes),function(tax){return _c('option',{key:tax.id,domProps:{"value":tax.id}},[_vm._v(_vm._s(tax.amount)+"%")])})],2)]),_vm._v(" "),(product.deposit)?_c('div',[_vm._v("SGR: "+_vm._s(product.deposit.name)+" · "+_vm._s(product.deposit.price))]):_vm._e(),_vm._v(" "),_vm._l((product.options),function(option){return _c('details',{key:option.id,staticClass:"option-row"},[_c('summary',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.included),expression:"option.included"}],attrs:{"type":"checkbox","disabled":!_vm.editable || _vm.busy},domProps:{"checked":Array.isArray(option.included)?_vm._i(option.included,null)>-1:(option.included)},on:{"click":function($event){$event.stopPropagation();},"change":function($event){var $$a=option.included,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(option, "included", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(option, "included", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(option, "included", $$c)}}}}),_vm._v(" "+_vm._s(option.name)+" · "+_vm._s(option.min)+"–"+_vm._s(option.max))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.name),expression:"option.name"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy},domProps:{"value":(option.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "name", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.t('mode'))),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.mode),expression:"option.mode"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"single"}},[_vm._v(_vm._s(_vm.t('single')))]),_c('option',{attrs:{"value":"multiple"}},[_vm._v(_vm._s(_vm.t('multiple')))]),_c('option',{attrs:{"value":"counter"}},[_vm._v(_vm._s(_vm.t('counter')))])])]),_vm._v(" "),_c('div',{staticClass:"range"},[_c('label',[_vm._v(_vm._s(_vm.t('groupMin'))),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(option.min),expression:"option.min",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","disabled":!_vm.editable || _vm.busy},domProps:{"value":(option.min)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "min", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_c('label',[_vm._v(_vm._s(_vm.t('groupMax'))),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(option.max),expression:"option.max",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","disabled":!_vm.editable || _vm.busy},domProps:{"value":(option.max)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "max", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_vm._l((option.values),function(value){return _c('div',{key:value.id,staticClass:"value-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.name),expression:"value.name"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy,"aria-label":_vm.t('name')},domProps:{"value":(value.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "name", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.t('price'))),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(value.price),expression:"value.price",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01","disabled":!_vm.editable || _vm.busy},domProps:{"value":(value.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "price", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"range"},[_c('label',[_vm._v(_vm._s(_vm.t('eachMin'))),_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":_vm.t('unknown'),"disabled":!_vm.editable || _vm.busy},domProps:{"value":value.min_quantity},on:{"input":function($event){_vm.setQuantity(value, 'min_quantity', $event.target.value)}}})]),_c('label',[_vm._v(_vm._s(_vm.t('eachMax'))),_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"1","placeholder":_vm.t('unknown'),"disabled":!_vm.editable || _vm.busy},domProps:{"value":value.max_quantity},on:{"input":function($event){_vm.setQuantity(value, 'max_quantity', $event.target.value)}}})])]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.t('tax'))),_c('select',{directives:[{name:"model",rawName:"v-model",value:(value.vat_id),expression:"value.vat_id"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(value, "vat_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.t('unknown')))]),_vm._l((_vm.taxes),function(tax){return _c('option',{key:tax.id,domProps:{"value":tax.id}},[_vm._v(_vm._s(tax.amount)+"%")])})],2)]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.available),expression:"value.available"}],attrs:{"type":"checkbox","disabled":!_vm.editable || _vm.busy},domProps:{"checked":Array.isArray(value.available)?_vm._i(value.available,null)>-1:(value.available)},on:{"change":function($event){var $$a=value.available,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(value, "available", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(value, "available", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(value, "available", $$c)}}}}),_vm._v(" "+_vm._s(_vm.t('available')))]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.selected_by_default),expression:"value.selected_by_default"}],attrs:{"type":"checkbox","disabled":!_vm.editable || _vm.busy},domProps:{"checked":Array.isArray(value.selected_by_default)?_vm._i(value.selected_by_default,null)>-1:(value.selected_by_default)},on:{"change":function($event){var $$a=value.selected_by_default,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(value, "selected_by_default", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(value, "selected_by_default", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(value, "selected_by_default", $$c)}}}}),_vm._v(" "+_vm._s(_vm.t('default')))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.t('image'))),_c('textarea',{staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy},domProps:{"value":value.image_urls.join('\n')},on:{"change":function($event){_vm.setImages(value, $event.target.value)}}})]),_vm._v(" "),(value.fee_label)?_c('p',{staticClass:"text-warning"},[_vm._v(_vm._s(value.fee_label)+" · "+_vm._s(_vm.t('reviewFee')))]):_vm._e(),_vm._v(" "),(!value.deposit && _vm.editable)?_c('button',{staticClass:"import-button import-button--secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.$set(value, 'deposit', { name: 'SGR', price: 0, representation: 'deposit' })}}},[_vm._v(_vm._s(_vm.t('addDeposit')))]):_vm._e(),_vm._v(" "),(value.deposit)?_c('div',{staticClass:"range"},[_c('label',[_vm._v("SGR"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.deposit.name),expression:"value.deposit.name"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy},domProps:{"value":(value.deposit.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value.deposit, "name", $event.target.value)}}})]),_c('label',[_vm._v(_vm._s(_vm.t('price'))),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(value.deposit.price),expression:"value.deposit.price",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01","disabled":!_vm.editable || _vm.busy},domProps:{"value":(value.deposit.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value.deposit, "price", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])]):_vm._e(),_vm._v(" "),(value.deposit)?_c('label',[_vm._v("SGR · "+_vm._s(_vm.t('tax'))),_c('select',{directives:[{name:"model",rawName:"v-model",value:(value.deposit.vat_id),expression:"value.deposit.vat_id"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable || _vm.busy},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(value.deposit, "vat_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.t('unknown')))]),_vm._l((_vm.taxes),function(tax){return _c('option',{key:tax.id,domProps:{"value":tax.id}},[_vm._v(_vm._s(tax.amount)+"%")])})],2)]):_vm._e(),_vm._v(" "),_c('details',[_c('summary',[_vm._v(_vm._s(_vm.t('source')))]),_c('pre',[_vm._v(_vm._s(JSON.stringify(value.source, null, 2)))])])])})],2)}),_vm._v(" "),_c('details',[_c('summary',[_vm._v(_vm._s(_vm.t('source')))]),_c('pre',[_vm._v(_vm._s(JSON.stringify(product.source, null, 2)))])])],2)])}))]),_vm._v(" "),(_vm.editable)?_c('footer',{staticClass:"confirm-bar"},[_c('div',{staticClass:"confirm-checks"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.draft.acknowledged_gaps),expression:"draft.acknowledged_gaps"}],attrs:{"type":"checkbox","disabled":_vm.busy},domProps:{"checked":Array.isArray(_vm.draft.acknowledged_gaps)?_vm._i(_vm.draft.acknowledged_gaps,null)>-1:(_vm.draft.acknowledged_gaps)},on:{"change":function($event){var $$a=_vm.draft.acknowledged_gaps,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.draft, "acknowledged_gaps", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.draft, "acknowledged_gaps", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.draft, "acknowledged_gaps", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.t('acknowledge')))])]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.draft.skip_failed_images),expression:"draft.skip_failed_images"}],attrs:{"type":"checkbox","disabled":_vm.busy},domProps:{"checked":Array.isArray(_vm.draft.skip_failed_images)?_vm._i(_vm.draft.skip_failed_images,null)>-1:(_vm.draft.skip_failed_images)},on:{"change":function($event){var $$a=_vm.draft.skip_failed_images,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.draft, "skip_failed_images", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.draft, "skip_failed_images", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.draft, "skip_failed_images", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.t('skipImages')))])])]),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"import-error",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"confirm-actions"},[(!_vm.draft.acknowledged_gaps)?_c('span',{staticClass:"confirm-hint"},[_vm._v(_vm._s(_vm.t('acknowledgeHint')))]):_c('span',{staticClass:"confirm-hint"},[_vm._v(_vm._s(_vm.selectedCount)+" "+_vm._s(_vm.t('products')))]),_vm._v(" "),_c('div',{staticClass:"confirm-buttons"},[_c('button',{staticClass:"import-button import-button--danger",attrs:{"type":"button","disabled":_vm.busy},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.t('cancel')))]),_vm._v(" "),_c('button',{staticClass:"import-button import-button--secondary",attrs:{"type":"button","disabled":_vm.busy},on:{"click":function($event){_vm.save(false)}}},[_c('i',{staticClass:"fa",class:_vm.busy && _vm.activeAction === 'save' ? 'fa-spinner fa-spin' : 'fa-save',attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.t('save')))]),_vm._v(" "),_c('button',{staticClass:"import-button import-button--primary",attrs:{"type":"button","disabled":_vm.busy || !_vm.draft.acknowledged_gaps || !_vm.selectedCount},on:{"click":function($event){_vm.save(true)}}},[_c('i',{staticClass:"fa",class:_vm.busy && _vm.activeAction === 'confirm' ? 'fa-spinner fa-spin' : 'fa-check',attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.t('confirm'))+" ("+_vm._s(_vm.selectedCount)+")")])])])]):_vm._e(),_vm._v(" "),(_vm.error && !_vm.editable)?_c('p',{staticClass:"import-error",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.error))]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"import-history",attrs:{"aria-label":_vm.t('history')}},[_c('div',{staticClass:"import-history__heading"},[_c('h5',[_vm._v(_vm._s(_vm.t('history')))]),_c('span',[_vm._v(_vm._s(_vm.history.length))])]),_vm._v(" "),_c('div',{staticClass:"import-history__table data-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.history,"empty-text":_vm.t('noHistory'),"row-class-name":_vm.historyRowClass}},[_c('el-table-column',{attrs:{"prop":"platform","label":_vm.t('platform'),"width":"120","align":"left","header-align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"history-platform"},[_vm._v(_vm._s(scope.row.platform))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"store_url","label":_vm.t('storeUrl'),"min-width":"260","align":"left","header-align":"left","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":_vm.t('date'),"width":"180","align":"left","header-align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":_vm.t('status'),"width":"170","align":"left","header-align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"history-status",class:'history-status--' + String(scope.row.status).toLowerCase()},[_vm._v(_vm._s(_vm.historyStatus(scope.row.status)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"130","align":"center","header-align":"center","class-name":"history-actions","label-class-name":"history-actions"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end","disabled":_vm.busy},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"disabled":_vm.busy},nativeOn:{"click":function($event){$event.stopPropagation();!_vm.busy && _vm.open(scope.row.id)}}},[_vm._v(_vm._s(_vm.t('open')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"disabled":_vm.busy || _vm.isImportRunning(scope.row)},nativeOn:{"click":function($event){$event.stopPropagation();_vm.historyAction(scope.row, 'reimport')}}},[_vm._v(_vm._s(_vm.t('reimport')))]),_vm._v(" "),(['CONFIRMED', 'PRODUCTS_DELETED'].indexOf(scope.row.status) !== -1)?_c('el-dropdown-item',{attrs:{"disabled":_vm.busy,"divided":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.historyAction(scope.row, 'deleteProducts')}}},[_vm._v(_vm._s(_vm.t(scope.row.status === 'PRODUCTS_DELETED' ? 'cleanupImport' : 'deleteProducts')))]):_vm._e(),_vm._v(" "),_c('el-dropdown-item',{attrs:{"disabled":_vm.busy || _vm.isImportRunning(scope.row),"divided":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.historyAction(scope.row, 'deleteImport')}}},[_vm._v(_vm._s(_vm.t('deleteImport')))])],1)],1)]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T54D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("v2o3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f88473_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("wR4F");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f88473_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T9EL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-end","gap":"10px","flex-wrap":"nowrap","margin-bottom":"20px"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"nowrap","gap":"8px","align-items":"flex-end","flex":"0 1 auto"}},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.id')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('catalogProd.id'),"size":"small","clearable":""},model:{value:(_vm.searchId),callback:function ($$v) {_vm.searchId=$$v},expression:"searchId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 180px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('catalogProd.name'),"size":"small","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(_vm.locations.length)?_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 200px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select'),"size":"small","multiple":"","collapse-tags":"","clearable":""},model:{value:(_vm.selectedLocations),callback:function ($$v) {_vm.selectedLocations=$$v},expression:"selectedLocations"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:loc.true_id,attrs:{"label":loc.name,"value":loc.true_id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.searchUsers}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"right-group",staticStyle:{"flex":"0 0 auto"}},[_c('button',{staticClass:"btn add",staticStyle:{"font-size":"12px","padding":"4px 8px","margin-right":"6px"},attrs:{"title":_vm.$t('general.associateTables')},on:{"click":function($event){$event.preventDefault();return _vm.openAssociateTablesModal($event)}}},[_c('i',{staticClass:"ti-layout-grid2"}),_vm._v("\n                "+_vm._s(_vm.$t('general.associateTables'))+"\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn add",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"10","prop":"name","label":"ID"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.id || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"location","label":_vm.$t('orders.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[(props.row.location_details && props.row.location_details.length)?_vm._l((props.row.location_details),function(locId,index){return _c('span',{key:locId},[_vm._v("\n                      "+_vm._s(_vm.getLocationName(locId))),(index < props.row.location_details.length - 1)?[_vm._v(", ")]:_vm._e()],2)}):[_vm._v("-")]],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"firstname","label":"Firstname"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.firstname ? props.row.firstname : "-"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"lastname","label":"Lastname"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.lastname ? props.row.lastname : "-"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"20","prop":"active","label":_vm.$t('settingLocationGroups.active')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center",on:{"click":function($event){$event.stopPropagation();}}},[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(props.row, $event)}},model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":320,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.send')},on:{"click":function($event){_vm.handleDelete(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")])]}}])})],1)],1)])])]),_vm._v(" "),_c('vmodal',{staticClass:"associateTablesModal",attrs:{"name":"associateTablesModal","minWidth":1200,"minHeight":850,"adaptive":true}},[_c('div',{staticClass:"associate-modal"},[_c('div',{staticClass:"associate-modal__header"},[_c('div',{staticClass:"associate-modal__title"},[_vm._v(_vm._s(_vm.$t('general.associateTables')))])]),_vm._v(" "),_c('div',{staticClass:"associate-modal__body"},[_c('div',{staticClass:"associate-section"},[_c('div',{staticClass:"associate-section__heading"},[_vm._v(_vm._s(_vm.$t('general.associateChooseUsers')))]),_vm._v(" "),_c('div',{staticClass:"associate-filters"},[(_vm.locations.length)?_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 280px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select'),"size":"small","multiple":"","collapse-tags":"","clearable":""},model:{value:(_vm.assocUserLocations),callback:function ($$v) {_vm.assocUserLocations=$$v},expression:"assocUserLocations"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:loc.true_id,attrs:{"label":loc.name,"value":loc.true_id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"1 1 280px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('catalogProd.name'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.fetchAssocUsers($event)}},model:{value:(_vm.assocUserSearch),callback:function ($$v) {_vm.assocUserSearch=$$v},expression:"assocUserSearch"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 120px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('general.search')},on:{"click":function($event){$event.preventDefault();return _vm.fetchAssocUsers($event)}}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"associate-grid"},[_c('div',{staticClass:"associate-results"},[_c('div',{staticClass:"associate-results__title"},[_vm._v(_vm._s(_vm.$t('general.search')))]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.assocLoadingUsers),expression:"assocLoadingUsers"}],staticClass:"associate-results__list"},[_vm._l((_vm.assocUsersResults),function(u){return _c('div',{key:u.id,staticClass:"associate-row",on:{"click":function($event){_vm.toggleAssocUser(u)}}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isAssocUserSelected(u.id)},on:{"click":function($event){$event.stopPropagation();_vm.toggleAssocUser(u)}}}),_vm._v(" "),_c('div',{staticClass:"associate-row__main"},[_c('div',{staticClass:"associate-row__name"},[_vm._v(_vm._s(_vm.formatUserName(u)))]),_vm._v(" "),_c('div',{staticClass:"associate-row__meta"},[_c('span',[_vm._v("ID: "+_vm._s(u.id))]),_vm._v(" "),(u.location_details && u.location_details.length)?_c('span',[_vm._v(" · "+_vm._s(u.location_details.map(_vm.getLocationName).join(', ')))]):_vm._e()])])])}),_vm._v(" "),(!_vm.assocUsersResults.length && !_vm.assocLoadingUsers)?_c('div',{staticClass:"associate-empty"},[_vm._v(_vm._s(_vm.$t('general.noResults')))]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"associate-selected"},[_c('div',{staticClass:"associate-results__title"},[_vm._v(_vm._s(_vm.$t('general.selected'))+" ("+_vm._s(_vm.assocSelectedUsers.length)+")")]),_vm._v(" "),_c('div',{staticClass:"associate-selected__box"},[_vm._l((_vm.assocSelectedUsers),function(u){return _c('div',{key:u.id,staticClass:"associate-chip"},[_c('span',{staticClass:"associate-chip__text"},[_vm._v(_vm._s(_vm.formatUserName(u)))])])}),_vm._v(" "),(!_vm.assocSelectedUsers.length)?_c('div',{staticClass:"associate-empty"},[_vm._v(_vm._s(_vm.$t('general.no_data')))]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"associate-section__actions"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"disabled":_vm.assocLoadingUsers || !_vm.assocUsersResults.length},on:{"click":function($event){$event.preventDefault();return _vm.selectAllAssocUsers($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('general.selectAll'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"disabled":_vm.assocLoadingUsers || !_vm.assocSelectedUsers.length},on:{"click":function($event){$event.preventDefault();return _vm.clearAssocUsersSelection($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('general.clearSelection'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"associate-section"},[_c('div',{staticClass:"associate-section__heading"},[_vm._v(_vm._s(_vm.$t('general.associateChooseTables')))]),_vm._v(" "),_c('div',{staticClass:"associate-filters"},[(_vm.locations.length)?_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 280px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select'),"size":"small","multiple":"","collapse-tags":"","clearable":""},model:{value:(_vm.assocTableLocations),callback:function ($$v) {_vm.assocTableLocations=$$v},expression:"assocTableLocations"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:loc.true_id,attrs:{"label":loc.name,"value":loc.true_id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 260px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.maps')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.search'),"size":"small","multiple":"","filterable":"","collapse-tags":"","clearable":""},model:{value:(_vm.assocTableMaps),callback:function ($$v) {_vm.assocTableMaps=$$v},expression:"assocTableMaps"}},_vm._l((_vm.assocMaps),function(m){return _c('el-option',{key:m.id,attrs:{"label":m.name || ('ID ' + m.id),"value":m.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 220px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.zone')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select'),"size":"small","clearable":""},model:{value:(_vm.assocTableZone),callback:function ($$v) {_vm.assocTableZone=$$v},expression:"assocTableZone"}},_vm._l((_vm.assocZones),function(z){return _c('el-option',{key:z.id,attrs:{"label":z.name,"value":z.name}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"1 1 280px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.number')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('settingTable.number'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.fetchAssocTables($event)}},model:{value:(_vm.assocTableSearch),callback:function ($$v) {_vm.assocTableSearch=$$v},expression:"assocTableSearch"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 120px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('general.search')},on:{"click":function($event){$event.preventDefault();return _vm.fetchAssocTables($event)}}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"associate-grid"},[_c('div',{staticClass:"associate-results"},[_c('div',{staticClass:"associate-results__title"},[_vm._v(_vm._s(_vm.$t('general.search')))]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.assocLoadingTables),expression:"assocLoadingTables"}],staticClass:"associate-results__list"},[_vm._l((_vm.assocTablesResults),function(t){return _c('div',{key:t.id,staticClass:"associate-row",on:{"click":function($event){_vm.toggleAssocTable(t)}}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isAssocTableSelected(t.id)},on:{"click":function($event){$event.stopPropagation();_vm.toggleAssocTable(t)}}}),_vm._v(" "),_c('div',{staticClass:"associate-row__main"},[_c('div',{staticClass:"associate-row__name"},[_vm._v(_vm._s(_vm.formatTableName(t)))]),_vm._v(" "),_c('div',{staticClass:"associate-row__meta"},[_c('span',[_vm._v("ID: "+_vm._s(t.id))]),_vm._v(" "),(t.location_id)?_c('span',[_vm._v(" · "+_vm._s(_vm.getLocationName(t.location_id)))]):_vm._e(),_vm._v(" "),(t.zone)?_c('span',[_vm._v(" · "+_vm._s(t.zone))]):_vm._e()])])])}),_vm._v(" "),(!_vm.assocTablesResults.length && !_vm.assocLoadingTables)?_c('div',{staticClass:"associate-empty"},[_vm._v(_vm._s(_vm.$t('general.noResults')))]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"associate-selected"},[_c('div',{staticClass:"associate-results__title"},[_vm._v(_vm._s(_vm.$t('general.selected'))+" ("+_vm._s(_vm.assocSelectedTables.length)+")")]),_vm._v(" "),_c('div',{staticClass:"associate-selected__box"},[_vm._l((_vm.assocSelectedTables),function(t){return _c('div',{key:t.id,staticClass:"associate-chip"},[_c('span',{staticClass:"associate-chip__text"},[_vm._v(_vm._s(_vm.formatTableName(t)))])])}),_vm._v(" "),(!_vm.assocSelectedTables.length)?_c('div',{staticClass:"associate-empty"},[_vm._v(_vm._s(_vm.$t('general.no_data')))]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"associate-section__actions"},[_c('button',{staticClass:"btn btn-info",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"disabled":_vm.assocLoadingTables || !_vm.assocTablesResults.length},on:{"click":function($event){$event.preventDefault();return _vm.selectAllAssocTables($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('general.selectAll'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"disabled":_vm.assocLoadingTables || !_vm.assocSelectedTables.length},on:{"click":function($event){$event.preventDefault();return _vm.clearAssocTablesSelection($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('general.clearSelection'))+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"associate-modal__footer"},[_c('button',{staticClass:"btn btn-icon btn-danger mar-rt-10",class:{'associate-confirm--loading': _vm.assocSaving},attrs:{"type":"button","disabled":_vm.assocSaving,"title":_vm.$t('general.cancel')},on:{"click":function($event){$event.preventDefault();return _vm.closeAssociateTablesModal($event)}}},[_c('i',{staticClass:"ti-close"}),_vm._v("\n          "+_vm._s(_vm.$t('general.cancel'))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn save",class:{'associate-confirm--loading': _vm.assocSaving},attrs:{"type":"button","disabled":_vm.isAssocConfirmDisabled},on:{"click":function($event){$event.preventDefault();return _vm.onConfirmAssocClick($event)}}},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),(!_vm.assocSaving)?_c('span',[_vm._v(_vm._s(_vm.$t('general.confirm')))]):_c('span',[_vm._v(_vm._s(_vm.$t('general.loading')))])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TC4q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"offers-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[(_vm.$route.params.id)?_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.handleDelete(_vm.$t('general.delete'))}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.delete'))+"\n          ")]):_vm._e(),_vm._v(" "),(!_vm.$route.params.id)?_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",attrs:{"title":_vm.$t('general.cancel')},on:{"click":function($event){$event.preventDefault();_vm.handleDelete(_vm.$t('general.cancel'))}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.cancel'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.title')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.title),expression:"modelValidations.title"},{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],staticClass:"form-control",attrs:{"type":"text","name":"title","placeholder":_vm.$t('marketingOffers.title')},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('title'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('title'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.startEndDate')))]),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":_vm.pickerOptions},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}}),_vm._v(" "),(_vm.errors.has('date_start'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('date_start'))+"\n              ")]):_vm._e()],1),_vm._v(" "),(_vm.groups.length > 1)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.groupClients')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.groups,"label":"name","placeholder":_vm.$t('general.all')},model:{value:(_vm.model.selected_groups),callback:function ($$v) {_vm.$set(_vm.model, "selected_groups", $$v)},expression:"model.selected_groups"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChange,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize'))+_vm._s(_vm.$t('validations.imageResolution')))])]),_vm._v(" "),(_vm.errors.has('image'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('image'))+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.imageWeb')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":1,"file-list":_vm.model.imageWeb,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChangeWeb,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemoveWeb,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize'))+_vm._s(_vm.$t('validations.imageResolutionWeb')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.linkType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.link_type),expression:"model.link_type"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "link_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.clearLinkSelection()}]}},[_c('option',[_vm._v("- "+_vm._s(_vm.$t('general.select'))+" -")]),_vm._v(" "),_c('option',{attrs:{"value":"category"}},[_vm._v(_vm._s(_vm.$t('marketingOffersTypes.category')))]),_vm._v(" "),_c('option',{attrs:{"value":"product"}},[_vm._v(_vm._s(_vm.$t('marketingOffersTypes.product')))]),_vm._v(" "),_c('option',{attrs:{"value":"page"}},[_vm._v(_vm._s(_vm.$t('marketingOffersTypes.page')))])]),_vm._v(" "),(_vm.errors.has('link_type'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('link_type'))+"\n              ")]):_vm._e()]),_vm._v(" "),(_vm.model.link_type == 'page')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.pageText')))]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.description),expression:"modelValidations.description"},{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"5","name":"description","placeholder":""},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('description'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('description'))+"\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.link_type == 'category')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.pickCateg')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.link_id),expression:"model.link_id"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "link_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null,"selected":true}},[_vm._v(_vm._s(_vm.$t('marketingOffers.none')))]),_vm._v(" "),_vm._l((_vm.categories),function(option){return [_c('option',{key:option.id,attrs:{"label":option.name},domProps:{"selected":option.id === _vm.model.link_id,"value":option.id}})]})],2),_vm._v(" "),(_vm.errors.has('link_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('link_id'))+"\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.link_type == 'product')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.pickProd')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.link_id),expression:"model.link_id"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "link_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null,"selected":true}},[_vm._v(_vm._s(_vm.$t('marketingOffers.none')))]),_vm._v(" "),_vm._l((_vm.products),function(option){return [_c('option',{key:option.id,attrs:{"label":option.name},domProps:{"selected":option.id === _vm.model.link_id,"value":option.id}})]})],2),_vm._v(" "),(_vm.errors.has('link_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('link_id'))+"\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.locations.length > 1)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.pickLoc')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.locations,"label":"name","placeholder":_vm.$t('general.all')},model:{value:(_vm.model.location_ids),callback:function ($$v) {_vm.$set(_vm.model, "location_ids", $$v)},expression:"model.location_ids"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.imageBanner')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imageBanner,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChangeBanner,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemoveBanner,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize'))+_vm._s(_vm.$t('validations.imageResolution')))])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.imageLanding')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imageLanding,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChangeLanding,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemoveLanding,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize'))+_vm._s(_vm.$t('validations.imageResolution')))])])],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TFIm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TGY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementEntriesTabs_vue__ = __webpack_require__("tbrf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5212e6e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementEntriesTabs_vue__ = __webpack_require__("pPlW");
function injectStyle (ssrContext) {
  __webpack_require__("LHZe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5212e6e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementEntriesTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5212e6e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementEntriesTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TIPk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TJSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInitialStockEdit_vue__ = __webpack_require__("5Eos");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e15541b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInitialStockEdit_vue__ = __webpack_require__("f+zA");
function injectStyle (ssrContext) {
  __webpack_require__("A4Ki")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e15541b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInitialStockEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e15541b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInitialStockEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TLBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PosMapForm_vue__ = __webpack_require__("QwF0");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PosMapForm', __WEBPACK_IMPORTED_MODULE_7__PosMapForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "TMxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('kds-user-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TN7w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TNB8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TO2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiscalPrinterForm_vue__ = __webpack_require__("Umb1");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'FiscalPrinterForm', __WEBPACK_IMPORTED_MODULE_7__FiscalPrinterForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "TOEP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RewardProgram_RewardProgramForm_vue__ = __webpack_require__("RYO5");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RewardForm: __WEBPACK_IMPORTED_MODULE_1__RewardProgram_RewardProgramForm_vue__["a" /* default */]
  },
  created: function created() {
    this.loadSettings();
    this.$bus.$on('company-data-updated', this.onCompanyDataUpdated);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('company-data-updated', this.onCompanyDataUpdated);
  },
  data: function data() {
    return {
      model: {},
      defaultData: {
        'available_languages': {},
        'countries': {},
        'currencies': {},
        'currency_display_format': [],
        'date_formats': [],
        'time_formats': [],
        'timezones': {}
      }
    };
  },

  props: {
    isLoyality: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isLoyality: function isLoyality() {
      if (this.isLoyality) {
        this.loadSettings();
      }
    }
  },
  methods: {
    loadSettings: function loadSettings() {
      var _this = this;

      var data = {
        token: this.$session.get('token')
      };
      var companyID = this.$session.get('selectedCompany');

      this.apiRequest('/listdefaults', 'GET', data, function (response) {
        if (response.status === true) {
          _this.defaultData = response.data[0];
        }
      });

      this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response) {
        if (response.status === true) {
          _this.model = response.data[0];
          _this.updateSelectedCompanyCache(response.data[0]);
        }
      });
    },
    isLoyaltyInUseEnabled: function isLoyaltyInUseEnabled(value) {
      return value === true || value === 1 || value === '1' || value === 'true';
    },
    normalizeCompanyCacheData: function normalizeCompanyCacheData(companyData) {
      if (!companyData) return companyData;
      var cached = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, companyData);
      cached.loyalty_in_use = this.isLoyaltyInUseEnabled(cached.loyalty_in_use);
      return cached;
    },
    updateSelectedCompanyCache: function updateSelectedCompanyCache(companyData) {
      if (!companyData) return;
      var cached = this.normalizeCompanyCacheData(companyData);
      this.$session.set('selectedCompanyData', cached);
      this.$bus.$emit('company-data-updated', cached);
    },
    onCompanyDataUpdated: function onCompanyDataUpdated(companyData) {
      if (!companyData || String(companyData.id) !== String(this.$session.get('selectedCompany'))) return;
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.model, companyData);
    }
  }
});

/***/ }),

/***/ "TOu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t12_vue__ = __webpack_require__("aGup");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42caf144_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t12_vue__ = __webpack_require__("MDZD");
function injectStyle (ssrContext) {
  __webpack_require__("RaHM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42caf144"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t12_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42caf144_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t12_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("2rGO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__ = __webpack_require__("nu7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_SidebarPlugin_UserMenu_vue__ = __webpack_require__("ij53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__ = __webpack_require__("BNE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);













__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default.a.directive);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_3__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_4__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_5__Content_vue__["a" /* default */],
    UserMenu: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_SidebarPlugin_UserMenu_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__["a" /* default */]
  },
  data: function data() {
    return {
      inRedNotice: false,
      fullscreenLoading: false
    };
  },
  created: function created() {
    this.$bus.$on('RedNotice', this.redNotice);
  },

  methods: {
    redNotice: function redNotice(show) {
      this.inRedNotice = show;
    },
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  computed: {},
  watch: {}
});

/***/ }),

/***/ "TQZs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TUUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoPages_vue__ = __webpack_require__("gSDC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687f8f70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoPages_vue__ = __webpack_require__("UXsg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoPages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687f8f70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoPages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TVvH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.inlineClass},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.isRequired),expression:"isRequired"},{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled,"name":_vm.name},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TZJI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementTransferForm_vue__ = __webpack_require__("y6XK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f53a2f6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementTransferForm_vue__ = __webpack_require__("J2tZ");
function injectStyle (ssrContext) {
  __webpack_require__("mCtB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f53a2f6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementTransferForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f53a2f6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementTransferForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TaTp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KdsForm_vue__ = __webpack_require__("rA/S");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'KdsForm', __WEBPACK_IMPORTED_MODULE_7__KdsForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      userLabel: {},
      modelValidations: {
        name: {
          required: true,
          min: 15
        },
        color: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.userLabel = model;
    }
  }
});

/***/ }),

/***/ "Tbq/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementForOrdersSuppliers_vue__ = __webpack_require__("i/I0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6e2410c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementForOrdersSuppliers_vue__ = __webpack_require__("jD3L");
function injectStyle (ssrContext) {
  __webpack_require__("p48S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a6e2410c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementForOrdersSuppliers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6e2410c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementForOrdersSuppliers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tbs+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DigitalSignageForm_vue__ = __webpack_require__("jeM8");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'DigitalSignageForm', __WEBPACK_IMPORTED_MODULE_7__DigitalSignageForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      digitalSignageModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.digitalSignageModel = model;
    }
  }
});

/***/ }),

/***/ "Tcqv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"referral-program-report-page"},[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.referralProgramReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15 referral-program-report-filters"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('referralProgram.filterByCampaign')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCampaignId),expression:"selectedCampaignId"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCampaignId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onCampaignFilterChange]}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.campaigns),function(c){return _c('option',{key:c.id,domProps:{"value":c.id}},[_vm._v("\n              "+_vm._s(c.name || _vm.$t('general.idHash', { id: c.id }))+"\n            ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('referralProgram.filterByAmbassador')))]),_vm._v(" "),_c('div',{staticClass:"referral-program-report-filters__ambassador-row"},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":_vm.$t('general.search'),"loading":_vm.loadingAmbassadorOptions},model:{value:(_vm.selectedAmbassadorId),callback:function ($$v) {_vm.selectedAmbassadorId=$$v},expression:"selectedAmbassadorId"}},_vm._l((_vm.ambassadorOptions),function(item){return _c('el-option',{key:'amb-' + _vm.ambassadorOptionId(item),attrs:{"label":_vm.ambassadorOptionLabel(item),"value":_vm.ambassadorOptionId(item)}})})),_vm._v(" "),_c('div',{staticClass:"btn btn-icon btn-info btn-search referral-program-report-filters__search-btn",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.applyFilters}},[_c('i',{staticClass:"ti-search"})])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"campaign-table width-table referral-program-report__table",staticStyle:{"width":"100%"},attrs:{"data":_vm.ambassadorsRows,"total":_vm.ambassadorsTotal,"pagination-props":_vm.paginationProps,"table-props":{ border: false }},on:{"query-change":_vm.onAmbassadorsPage,"row-click":_vm.onAmbassadorRow}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":70,"prop":"ambassador_user_id","label":_vm.$t('referralProgram.ambassadorId')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('span',{staticClass:"referral-report-table__ellipsis"},[_vm._v(_vm._s(p.row.ambassador_user_id || p.row.user_id || p.row.id))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":160,"label":_vm.$t('reports.name')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('span',{staticClass:"referral-report-table__ellipsis",attrs:{"title":_vm.displayPersonName(p.row, 'ambassador')}},[_vm._v(_vm._s(_vm.displayPersonName(p.row, 'ambassador')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":180,"label":_vm.$t('reports.email')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('span',{staticClass:"referral-report-table__ellipsis",attrs:{"title":_vm.displayPersonEmail(p.row) || _vm.$t('general.emDash')}},[_vm._v(_vm._s(_vm.displayPersonEmail(p.row) || _vm.$t('general.emDash')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":160,"prop":"campaign.name","label":_vm.$t('reports.campaign')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('span',{staticClass:"referral-report-table__ellipsis",attrs:{"title":_vm.campaignNameForRow(p.row)}},[_vm._v(_vm._s(_vm.campaignNameForRow(p.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":100,"label":_vm.$t('referralProgram.refereesCount')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.ambassadorRefereesCount(p.row))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":120,"label":_vm.$t('referralProgram.totalRewards')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatMoney(_vm.ambassadorEarningsTotal(p.row)))+"\n                "),(p.row.earnings && p.row.earnings.coupons_awarded)?_c('small',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.couponsAwarded'))+": "+_vm._s(p.row.earnings.coupons_awarded))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":120,"label":_vm.$t('referralProgram.totalCashbackPercent')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatMoney(_vm.ambassadorEarningsCashback(p.row)))+"\n              ")]}}])})],1)],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Td+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_json_excel__ = __webpack_require__("fXhN");















var _components;









__WEBPACK_IMPORTED_MODULE_14_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_19_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isSalesReportBeta: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isSalesReportBeta: function isSalesReportBeta() {
      if (this.isSalesReportBeta) {
        this.getOrders();
      }
    }
  },
  created: function created() {
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear();
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '-' + formattedDate + '.xls';
    this.getPaymentMethods();
    this.verifyUserLocations();
    this.verifyUserMethods();
    this.getPosUsers();
    this.getDrivers();
    this.getUsers();
    this.loadFiltersFromCookie();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.userSearchTimeout) {
      clearTimeout(this.userSearchTimeout);
      this.userSearchTimeout = null;
    }
  },
  data: function data() {
    var _jsonFields;

    return {
      valid_from: '05:00',
      valid_to: '05:00',
      products_valid_from: '00:00',
      products_valid_to: '23:59',
      drivers: [],
      posUsers: [],
      users: [],
      topCategories: [],
      loadingCategories: false,
      loadingUsers: false,
      userSearchTimeout: null,
      orderFormFlags: this.getOrderFormFlags(),
      paymentMethods: [],
      receiptOptions: [{ label: this.$t('reports.withoutReceipt'), value: 1 }, { label: this.$t('reports.withReceipt'), value: 2 }],
      selectedDriver: '',
      freeSearch: '',
      selectedPosUser: '',
      selected_user: '',
      orderId: null,
      zet: null,
      selectedCategories: [],
      selected_order_from: '',
      selected_payment_methods: [],

      unpaidOrdersFilter: 'paid',
      selectedTable: null,
      availableTables: [],
      loadingTables: false,
      loading: true,
      exportLoading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        valid: [__WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: '',
        methods: []
      },
      date_column: 'created_at',
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_18_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      ordersTableData: {},
      totals: {
        total: 0,
        totalCash: 0,
        totalVirament: 0,
        totalOnline: 0,
        totalProtocol: 0,
        totalStaffFood: 0,
        totalRoom: 0,
        totalEvent: 0,
        totalFolio: 0,
        totalSplit: 0,
        totalCard: 0,
        totalPOS: 0,
        totalCARDPOS: 0,
        totalTips: 0,
        totalDiscount: 0,
        totalDiscountItems: 0,
        totalDiscountLoyaltyPoints: 0,
        totalTax: 0,
        totalSlotTax: 0,
        totalSlotPartTax: 0,
        totalShipping: 0,
        avarageOrderValue: 0,
        totalBoltCard: 0,
        totalBoltCash: 0,
        totalGlovoCard: 0,
        totalGlovoCash: 0,
        totalWoltCard: 0,
        totalWoltCash: 0,
        totalWoltOtherMethods: 0,
        totalSplitCash: 0,
        totalSplitCard: 0,
        totalSplitVoucher: 0,
        totalUnpaid: 0,
        unfiscalTotal: 0,
        unfiscalTotalCard: 0,
        unfiscalTotalCash: 0,
        unfiscalTotalCredit: 0,
        unfiscalTotalOnline: 0
      },
      cardTotals: {
        total_amount: 0,
        total_cash: 0,
        total_online: 0,
        total_card: 0,
        total_credit: 0,
        total_other_methods: 0
      },
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      jsonFields: (_jsonFields = {}, __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.orderId'), 'id'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.location'), 'location'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.date'), 'date'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.closingOrder'), 'updated_at'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.order'), 'order'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.number'), 'number'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.tableNumber'), 'table_number'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.delivery_type'), 'deliveryType'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.name'), 'name'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.phone'), 'phone'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.totalAmount'), 'totalAmount'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.totalDiscount'), 'totalDiscount'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.totalTax'), 'totalTax'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.shipping'), 'shipping'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.zone'), 'zone'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.paymentType'), 'paymentType'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.orderProducts'), 'orderProducts'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.orderAdress'), 'orderAdress'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.orderComments'), 'orderComments'), _jsonFields),
      export_name: 'Export Raport Vanzari - ',
      json_fields: {
        'Id': 'id',
        'Location': 'location',
        'Date': 'date',
        'Closing Order': 'updated_at',
        '# Order': 'order',
        'Number': 'number',
        'Table Number': 'table_number',
        'Delivery Type': 'deliveryType',
        'Customer Name': 'name',
        'Phone': 'phone',
        'Total': 'totalAmount',
        'Discount': 'totalDiscount',
        'Taxes': 'totalTax',
        'Livrare': 'totalDelivery',
        'Zone': 'zone',
        'Payment Type': 'paymentType',
        'Ordered products': 'orderProducts',
        'Ordered adress': 'orderAdress',
        'Ordered comments': 'orderComments',
        'Receipt number': 'receiptNumber'
      },
      json_data: [],

      use_tips: true,
      hasRceipt: null,

      modalOrders: {
        valid: [__WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD')],
        location: '',
        search: '',
        methods: []
      },
      modalValidFrom: null,
      modalValidTo: null,
      modalSelectedDriver: '',
      modalSelectedPosUser: '',
      modalSelectedUser: '',
      modalSelectedOrderFrom: '',
      modalSelectedPaymentMethods: [],
      modalUnpaidOrdersFilter: 'paid',
      modalSelectedTable: null,
      modalOrderId: null,
      modalHasReceipt: null,
      modalFreeSearch: '',
      modalZet: null,
      modalSelectedCategories: [],

      isFiltersModalOpen: false
    };
  },

  computed: {
    appliedFilters: function appliedFilters() {
      var _this = this;

      var out = [];
      if (this.orders && this.orders.location) {
        var loc = (this.locations || []).find(function (l) {
          return String(l.id) === String(_this.orders.location);
        });
        out.push(this.$t('reports.location') + ': ' + (loc ? loc.name : this.orders.location));
      }
      if (this.hasRceipt && this.hasRceipt.label) {
        out.push(this.$t('reports.taxation') + ': ' + this.hasRceipt.label);
      }
      if (this.orders && Array.isArray(this.orders.methods) && this.orders.methods.length) {
        var labels = this.orders.methods.map(function (key) {
          var m = (_this.methods || []).find(function (x) {
            return String(x.key || x) === String(key);
          });
          return m ? m.label || key : key;
        }).filter(Boolean);
        out.push(this.$t('dashboard.selectMethod') + ': ' + labels.join(', '));
      }
      if (this.selected_user) {
        var u = (this.mergedUsers || []).find(function (x) {
          return String(x.id) === String(_this.selected_user);
        });
        var userName = this.selected_user;
        if (u) {
          userName = u.firstname && u.lastname ? u.firstname + ' ' + u.lastname : u.email || this.selected_user;
        }
        out.push(this.$t('dashboard.selectClient') + ': ' + userName);
      }
      if (this.selectedPosUser) {
        var op = (this.posUsers || []).find(function (x) {
          return String(x.id) === String(_this.selectedPosUser);
        });
        out.push(this.$t('reports.operator') + ': ' + (op ? op.firstname + ' ' + op.lastname : this.selectedPosUser));
      }
      if (this.selected_order_from) out.push(this.$t('dashboard.selectedOrderFormFlags') + ': ' + String(this.selected_order_from).toUpperCase());
      if (this.selected_payment_methods && Array.isArray(this.selected_payment_methods) && this.selected_payment_methods.length) {
        var names = this.selected_payment_methods.map(function (id) {
          var pm = (_this.paymentMethods || []).find(function (x) {
            return String(x.id) === String(id);
          });
          return pm ? pm.name : id;
        });
        out.push(this.$t('dashboard.selectedPaymentMethods') + ': ' + names.join(', '));
      }
      if (!this.isUnpaidSelected()) {
        if (this.unpaidOrdersFilter === 'unpaid') {
          out.push(this.$t('reports.orderPaidStatus') + ': ' + this.$t('reports.unpaid'));
        } else if (this.unpaidOrdersFilter === 'all') {
          out.push(this.$t('reports.orderPaidStatus') + ': ' + this.$t('general.all'));
        }
      }
      if (this.orders && this.orders.search) out.push(this.$t('reports.couponCode') + ': ' + this.orders.search);
      if (this.orderId) out.push(this.$t('general.orderId') + ': ' + this.orderId);
      if (this.zet) out.push(this.$t('reports.zet') + ': ' + this.zet);
      if (this.selectedCategories && Array.isArray(this.selectedCategories) && this.selectedCategories.length) {
        var _names = this.selectedCategories.map(function (cat) {
          if ((typeof cat === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(cat)) === 'object' && cat !== null) {
            return cat.label;
          }

          var found = (_this.topCategories || []).find(function (x) {
            return String(x.id) === String(cat);
          });
          return found ? found.label : cat;
        });
        out.push(this.$t('pages.topCategory') + ': ' + _names.join(', '));
      }
      if (this.selectedDriver) {
        var d = (this.drivers || []).find(function (x) {
          return String(x.id) === String(_this.selectedDriver);
        });
        out.push(this.$t('dashboard.selectDriver') + ': ' + (d ? d.firstname + ' ' + d.lastname : this.selectedDriver));
      }
      if (this.freeSearch) out.push(this.$t('general.search') + ': ' + this.freeSearch);
      if (this.selectedTable && this.selectedTable.id != null) {
        var label = this.selectedTable.label || String(this.selectedTable.id);
        out.push(this.$t('reports.tables') + ': ' + label);
      }

      var isDefaultDate = this.orders && this.orders.valid && this.orders.valid[0] === __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD') && this.orders.valid[1] === __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD') && this.valid_from === '05:00' && this.valid_to === '05:00';
      if (!isDefaultDate && this.orders && this.orders.valid) {
        out.push(this.$t('reports.date') + ': ' + this.orders.valid[0] + ' ' + this.valid_from + ' - ' + this.orders.valid[1] + ' ' + this.valid_to);
      }

      return out;
    },
    cashSummaryTotal: function cashSummaryTotal() {
      var fallbackSum = (this.totals.totalCash || 0) + (this.totals.totalGlovoCash || 0) + (this.totals.totalBoltCash || 0) + (this.totals.totalWoltCash || 0) + (this.totals.totalSplitCash || 0);

      if (this.cardTotals && this.cardTotals.total_cash !== undefined && this.cardTotals.total_cash !== null) {
        if (this.cardTotals.total_cash === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_cash;
      }

      return fallbackSum;
    },
    cardSummaryTotal: function cardSummaryTotal() {
      var fallbackSum = (this.totals.totalCard || 0) + (this.totals.totalPOS || 0) + (this.totals.totalCARDPOS || 0) + (this.totals.totalSplitCard || 0);

      if (this.cardTotals && this.cardTotals.total_card !== undefined && this.cardTotals.total_card !== null) {
        if (this.cardTotals.total_card === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_card;
      }

      return fallbackSum;
    },
    totalOnlineSummaryTotal: function totalOnlineSummaryTotal() {
      var fallbackSum = (this.totals.totalCard || 0) + (this.totals.totalOnline || 0);

      if (this.cardTotals && this.cardTotals.total_online !== undefined && this.cardTotals.total_online !== null) {
        if (this.cardTotals.total_online === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_online;
      }

      return fallbackSum;
    },
    totalCardSummaryTotal: function totalCardSummaryTotal() {
      var fallbackSum = (this.totals.totalPOS || 0) + (this.totals.totalCARDPOS || 0) + (this.totals.totalSplitCard || 0);

      if (this.cardTotals && this.cardTotals.total_card !== undefined && this.cardTotals.total_card !== null) {
        if (this.cardTotals.total_card === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_card;
      }

      return fallbackSum;
    },
    totalCreditSummaryTotal: function totalCreditSummaryTotal() {
      var fallbackSum = (this.totals.totalBoltCard || 0) + (this.totals.totalGlovoCard || 0) + (this.totals.totalWoltCard || 0);

      if (this.cardTotals && this.cardTotals.total_credit !== undefined && this.cardTotals.total_credit !== null) {
        if (this.cardTotals.total_credit === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_credit;
      }

      return fallbackSum;
    },
    nonFiscalSummaryTotal: function nonFiscalSummaryTotal() {
      var fallbackSum = (this.totals.totalProtocol || 0) + (this.totals.totalStaffFood || 0) + (this.totals.totalVirament || 0) + (this.totals.totalRoom || 0) + (this.totals.totalEvent || 0) + (this.totals.totalFolio || 0);

      if (this.cardTotals && this.cardTotals.total_other_methods !== undefined && this.cardTotals.total_other_methods !== null) {
        if (this.cardTotals.total_other_methods === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_other_methods;
      }

      return fallbackSum;
    },
    mergedCategories: function mergedCategories() {
      var map = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a(this.topCategories.map(function (item) {
        return [item.id, item];
      }));
      this.modalSelectedCategories.forEach(function (item) {
        if (item && item.id && !map.has(item.id)) {
          map.set(item.id, item);
        }
      });
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(map.values());
    },
    mergedUsers: function mergedUsers() {
      var _this2 = this;

      var map = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a(this.users.map(function (item) {
        return [item.id, item];
      }));

      if (this.modalSelectedUser && this.modalSelectedUser !== '') {
        var selectedUser = this.users.find(function (u) {
          return String(u.id) === String(_this2.modalSelectedUser);
        });
        if (selectedUser && !map.has(selectedUser.id)) {
          map.set(selectedUser.id, selectedUser);
        }
      }
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(map.values());
    },
    unpaidOrdersFilterOptions: function unpaidOrdersFilterOptions() {
      return [{ value: 'all', label: this.$t('general.all') }, { value: 'paid', label: this.$t('paymentStatus.paid') }, { value: 'unpaid', label: this.$t('reports.unpaid') }];
    },
    mergedSalesReportTables: function mergedSalesReportTables() {
      var map = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a((this.availableTables || []).map(function (t) {
        return [t.id, t];
      }));
      if (this.modalSelectedTable && this.modalSelectedTable.id != null && !map.has(this.modalSelectedTable.id)) {
        map.set(this.modalSelectedTable.id, this.modalSelectedTable);
      }
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(map.values());
    }
  },
  methods: {
    getLocationName: function getLocationName(storeId) {
      if (!storeId) return '';
      var location = this.locations.find(function (loc) {
        return loc.id === storeId;
      });
      return location ? location.name : '';
    },
    syncModalFromFilters: function syncModalFromFilters() {
      this.modalOrders = {
        valid: Array.isArray(this.orders.valid) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.orders.valid)) : [],
        location: this.orders.location || '',
        search: this.orders.search || '',
        methods: Array.isArray(this.orders.methods) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.orders.methods)) : []
      };
      this.modalValidFrom = this.valid_from;
      this.modalValidTo = this.valid_to;
      this.modalSelectedDriver = this.selectedDriver;
      this.modalSelectedPosUser = this.selectedPosUser;
      this.modalSelectedUser = this.selected_user;
      this.modalSelectedOrderFrom = this.selected_order_from;
      this.modalSelectedPaymentMethods = Array.isArray(this.selected_payment_methods) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.selected_payment_methods)) : [];
      this.modalUnpaidOrdersFilter = this.unpaidOrdersFilter || 'paid';
      this.modalSelectedTable = this.selectedTable && this.selectedTable.id != null ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.selectedTable) : null;
      this.modalOrderId = this.orderId;
      this.modalHasReceipt = this.hasRceipt;
      this.modalFreeSearch = this.freeSearch;
      this.modalZet = this.zet;
      this.modalSelectedCategories = Array.isArray(this.selectedCategories) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.selectedCategories)) : [];
    },
    searchTopCategories: function searchTopCategories(query) {
      var _this3 = this;

      if (!query) {
        return;
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      };

      this.loadingCategories = true;
      this.apiRequest('/search-top-categories', 'GET', data, function (response) {
        if (response.status) {
          _this3.topCategories = response.data;
        }
        _this3.$nextTick(function () {
          _this3.loadingCategories = false;
        });
      });
    },
    clearCategorySearch: function clearCategorySearch() {
      if (this.$refs.categorySelect) {
        this.$refs.categorySelect.focus();
        this.$refs.categorySelect.query = '';
        this.$refs.categorySelect.handleQueryChange('');
      }
    },
    getUsers: function getUsers() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.loadingUsers = true;
      this.apiRequest('/search-users', 'GET', data, function (response) {
        if (response.status === true && response.data) {
          if (Array.isArray(response.data)) {
            _this4.users = response.data;
          } else if (response.data.users && Array.isArray(response.data.users)) {
            _this4.users = response.data.users;
          } else if (response.data.user && Array.isArray(response.data.user)) {
            _this4.users = response.data.user;
          } else {
            _this4.users = [];
          }
        } else {
          _this4.users = [];
        }
        _this4.$nextTick(function () {
          _this4.loadingUsers = false;
        });
      });
    },
    searchUsers: function searchUsers(query) {
      var _this5 = this;

      if (this.userSearchTimeout) {
        clearTimeout(this.userSearchTimeout);
        this.userSearchTimeout = null;
      }

      if (!query) {
        this.users = [];
        return;
      }

      this.userSearchTimeout = setTimeout(function () {
        var data = {
          token: _this5.$session.get('token'),
          company_id: _this5.$session.get('selectedCompany'),
          search: query
        };

        _this5.loadingUsers = true;
        _this5.apiRequest('/search-users', 'GET', data, function (response) {
          if (response.status === true && response.data) {
            if (Array.isArray(response.data)) {
              _this5.users = response.data;
            } else if (response.data.users && Array.isArray(response.data.users)) {
              _this5.users = response.data.users;
            } else if (response.data.user && Array.isArray(response.data.user)) {
              _this5.users = response.data.user;
            } else {
              _this5.users = [];
            }
          } else {
            _this5.users = [];
          }
          _this5.$nextTick(function () {
            _this5.loadingUsers = false;
          });
        });
      }, 300);
    },
    searchUsersById: function searchUsersById(userId) {
      var _this6 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: userId
      };

      this.loadingUsers = true;
      this.apiRequest('/search-users', 'GET', data, function (response) {
        if (response.status === true && response.data) {
          if (Array.isArray(response.data)) {
            _this6.users = response.data;
          } else if (response.data.users && Array.isArray(response.data.users)) {
            _this6.users = response.data.users;
          } else if (response.data.user && Array.isArray(response.data.user)) {
            _this6.users = response.data.user;
          } else if (response.data && response.data.id) {
            _this6.users = [response.data];
          } else {
            _this6.users = [];
          }
        } else {
          _this6.users = [];
        }
        _this6.$nextTick(function () {
          _this6.loadingUsers = false;
        });
      });
    },
    clearUserSearch: function clearUserSearch() {
      if (this.$refs.userSelect) {
        this.$refs.userSelect.focus();
        this.$refs.userSelect.query = '';
        this.$refs.userSelect.handleQueryChange('');
      }
    },
    searchTables: function searchTables(query) {
      var _this7 = this;

      if (!query) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      };
      this.loadingTables = true;
      this.apiRequest('/search-tables', 'GET', data, function (response) {
        if (response.status) {
          _this7.availableTables = response.data || [];
        } else {
          _this7.availableTables = [];
        }
        _this7.$nextTick(function () {
          _this7.loadingTables = false;
        });
      });
    },
    clearTableSearch: function clearTableSearch() {
      var select = this.$refs.salesReportTableSelect;
      if (select) {
        select.focus();
        select.query = '';
        select.handleQueryChange('');
      }
    },
    openFiltersModal: function openFiltersModal() {
      this.syncModalFromFilters();

      if (this.modalSelectedUser && this.modalSelectedUser !== '') {
        this.searchUsersById(this.modalSelectedUser);
      }
      this.isFiltersModalOpen = true;
      this.$modal.show('salesReportBetaFiltersModal');
    },
    applyFilters: function applyFilters() {
      var _this8 = this;

      this.orders.valid = Array.isArray(this.modalOrders.valid) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.modalOrders.valid)) : this.orders.valid;
      this.orders.location = this.modalOrders.location;
      this.orders.search = this.modalOrders.search;
      this.orders.methods = Array.isArray(this.modalOrders.methods) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.modalOrders.methods)) : [];

      this.valid_from = this.modalValidFrom || '00:00';
      this.valid_to = this.modalValidTo || '23:59';
      this.selectedDriver = this.modalSelectedDriver || '';
      this.selectedPosUser = this.modalSelectedPosUser || '';
      this.selected_user = this.modalSelectedUser || '';
      this.selected_order_from = this.modalSelectedOrderFrom || '';
      this.selected_payment_methods = Array.isArray(this.modalSelectedPaymentMethods) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.modalSelectedPaymentMethods)) : [];
      this.unpaidOrdersFilter = this.modalUnpaidOrdersFilter || 'paid';
      this.selectedTable = this.modalSelectedTable && this.modalSelectedTable.id != null ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.modalSelectedTable) : null;
      this.orderId = this.modalOrderId || null;
      this.zet = this.modalZet || null;
      this.selectedCategories = Array.isArray(this.modalSelectedCategories) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.modalSelectedCategories)) : [];
      this.hasRceipt = this.modalHasReceipt || null;
      this.freeSearch = this.modalFreeSearch || '';

      this.saveFiltersToCookie();
      this.$modal.hide('salesReportBetaFiltersModal');
      this.isFiltersModalOpen = false;
      this.$nextTick(function () {
        return _this8.getOrders();
      });
    },
    resetModalFilters: function resetModalFilters() {
      this.resetFilters();

      this.syncModalFromFilters();
    },
    resetFilters: function resetFilters() {
      this.orders.location = '';
      this.orders.search = '';
      this.orders.methods = [];
      this.selectedDriver = '';
      this.selectedPosUser = '';
      this.selected_user = '';
      this.selected_order_from = '';
      this.selected_payment_methods = [];
      this.unpaidOrdersFilter = 'paid';
      this.selectedTable = null;
      this.availableTables = [];
      this.orderId = null;
      this.zet = null;
      this.selectedCategories = [];
      this.hasRceipt = null;
      this.freeSearch = '';
      this.valid_from = '05:00';
      this.valid_to = '05:00';
      this.orders.valid = [__WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD')];
      this.clearFiltersCookie();
      this.getOrders();
    },
    clientsExportData: function clientsExportData() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp, data, $dd, sortOptions, unpaidOrdersVal, ced, salesData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resp = [];

                if (!_this9.orders) {
                  _context.next = 26;
                  break;
                }

                _context.prev = 2;
                data = {
                  token: _this9.$session.get('token'),
                  company_id: _this9.$session.get('selectedCompany'),
                  start_date: _this9.orders.valid[0] + ' ' + _this9.valid_from + ':00',
                  end_date: _this9.orders.valid[1] + ' ' + _this9.valid_to + ':00',
                  date_column: _this9.date_column,
                  driver: _this9.selectedDriver,
                  operator: _this9.selectedPosUser,
                  selected_user: _this9.selected_user,
                  selected_order_from: _this9.selected_order_from,
                  selected_payment_methods: _this9.getPaymentMethodsArray(),
                  coupon: _this9.orders.search,
                  zet: _this9.zet,
                  top_category_ids: Array.isArray(_this9.selectedCategories) && _this9.selectedCategories.length ? _this9.selectedCategories.map(function (cat) {
                    return (typeof cat === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(cat)) === 'object' && cat !== null ? cat.id : cat;
                  }) : null
                };
                $dd = {};
                sortOptions = {
                  field: _this9.sortBy,
                  order: _this9.sortOrder
                };

                data = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, sortOptions);

                if (_this9.orders.location && _this9.orders.location !== '') {
                  data.location_id = _this9.orders.location;
                }

                unpaidOrdersVal = _this9.getUnpaidOrdersApiValue();

                if (unpaidOrdersVal !== undefined) {
                  data.unpaid_orders = unpaidOrdersVal;
                }
                if (_this9.selectedTable && _this9.selectedTable.id != null && _this9.selectedTable.id !== '') {
                  data.table_id = _this9.selectedTable.id;
                }

                ced = [];
                salesData = [];
                _context.next = 15;
                return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var ver = _this9.$route.query && _this9.$route.query.ver === 'V2' ? 'V2' : '';
                  _this9.apiRequest('/reports/sales-report-export-excel' + ver + '?withProducts=1&page=' + 1 + '&pageSize=' + 50000, 'GET', data, function (response) {
                    if (response.status === true && response.data) {
                      if (response.data.export_excel && Array.isArray(response.data.export_excel)) {
                        salesData = response.data.export_excel;
                      } else if (response.data.orders && response.data.orders.data) {
                        salesData = response.data.orders.data;
                      } else if (Array.isArray(response.data)) {
                        salesData = response.data;
                      } else {
                        salesData = [];
                      }

                      if (salesData && salesData.length > 0) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(salesData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var sale = _step.value;

                            $dd = {
                              location: sale.location || _this9.getLocationName(sale.store_id) || '',
                              date: sale.date || sale.created_at,
                              updated_at: sale.updated_at,
                              order: sale.order || sale.token,
                              number: sale.number,
                              deliveryType: sale.deliveryType || sale.delivery_type,
                              name: sale.name || (sale.customer ? sale.customer.firstname + ' ' + sale.customer.lastname : ''),
                              phone: sale.phone || (sale.customer ? sale.customer.phone : ''),
                              totalAmount: sale.totalAmount !== undefined ? sale.totalAmount : sale.totals_grandtotal,
                              totalDiscount: sale.totalDiscount !== undefined ? sale.totalDiscount : sale.totals_discount + sale.totals_discount_loyalty_points,
                              totalTax: sale.totalTax !== undefined ? sale.totalTax : sale.totals_extras,
                              totalDelivery: sale.totalDelivery !== undefined ? sale.totalDelivery : sale.totals_delivery,
                              zone: sale.zone || (sale.shipping_details ? sale.shipping_details.name : ''),
                              paymentType: sale.paymentType || sale.payment_type,
                              orderProducts: sale.orderProducts,
                              orderAdress: sale.orderAdress,
                              orderComments: sale.orderComments,
                              receiptNumber: sale.receiptNumber
                            };
                            ced.push($dd);
                          }
                        } catch (err) {
                          _didIteratorError = true;
                          _iteratorError = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                              _iterator.return();
                            }
                          } finally {
                            if (_didIteratorError) {
                              throw _iteratorError;
                            }
                          }
                        }
                      }
                    } else {
                      console.error('Failed to export sales report:', response && response.errors ? response.errors : response);
                    }
                    resolve(ced);
                  });
                });

              case 15:
                resp = _context.sent;
                return _context.abrupt('return', resp);

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](2);

                console.error('Unexpected error while exporting sales report:', _context.t0);
                return _context.abrupt('return', []);

              case 23:
                _context.prev = 23;

                _this9.finishDownload();
                return _context.finish(23);

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9, [[2, 19, 23, 26]]);
      }))();
    },
    startDownload: function startDownload() {
      this.exportLoading = true;
    },
    finishDownload: function finishDownload() {
      this.exportLoading = false;
    },
    changeValidFrom: function changeValidFrom() {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'valid_order';

      if (fields === 'valid_order') {
        if (!this.valid_from) {
          this.valid_from = '00:00';
        }
        if (!this.valid_to) {
          this.valid_to = '23:59';
        }
      } else {
        if (!this.products_valid_from) {
          this.products_valid_from = '00:00';
        }
        if (!this.products_valid_to) {
          this.products_valid_to = '23:59';
        }
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details;
      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }
      if (this.locations.length > 1) {
        this.showLocations = true;
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    isUnpaidSelected: function isUnpaidSelected() {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return false;
      }

      return this.selected_payment_methods.some(function (method) {
        var id = typeof method === 'string' ? method : method && method.id;
        return id === 'unpaid';
      });
    },
    getUnpaidOrdersApiValue: function getUnpaidOrdersApiValue() {
      if (this.isUnpaidSelected()) {
        return 1;
      }
      if (this.unpaidOrdersFilter === 'unpaid') {
        return 1;
      }
      if (this.unpaidOrdersFilter === 'paid') {
        return 0;
      }
      return undefined;
    },
    getPaymentMethodsArray: function getPaymentMethodsArray() {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return [];
      }

      return this.selected_payment_methods.map(function (method) {
        return typeof method === 'string' ? method : method && method.id ? method.id : null;
      }).filter(function (method) {
        return method && method !== 'unpaid';
      });
    },
    getPaymentMethods: function getPaymentMethods() {
      var _this10 = this;

      var sessionData = this.$session.get('selectedCompanyData');

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };

        this.apiRequest('/orders/get-payment-methods', 'GET', data, function (response) {
          if (response.status && response.data.length) {
            var result = response.data.map(function (item) {
              return { id: item || 'unpaid', name: _this10.$t('paymentTypes.' + item) };
            });

            if (!result.find(function (item) {
              return item.id === 'VOUCHER';
            })) {
              result.push({ id: 'VOUCHER', name: _this10.$t('paymentTypes.VOUCHER') });
            }
            sessionData['payment_methods'] = response.data;
            _this10.$session.set('selectedCompanyData', sessionData);

            __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(_this10, 'paymentMethods', result);
          }
        });
      } else {
        var result = sessionData['payment_methods'].map(function (item) {
          return { id: item || 'unpaid', name: _this10.$t('paymentTypes.' + item) };
        });

        if (!result.find(function (item) {
          return item.id === 'VOUCHER';
        })) {
          result.push({ id: 'VOUCHER', name: this.$t('paymentTypes.VOUCHER') });
        }
        __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(this, 'paymentMethods', result);
      }
    },
    getOrders: function getOrders(query) {
      var _this11 = this;

      if (!this.isSalesReportBeta) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      if (!this.products_valid_from) {
        this.products_valid_from = '00:00';
      }
      if (!this.products_valid_to || this.products_valid_to === '24:00') {
        this.products_valid_to = '23:59';
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.orders.valid[0] + ' ' + this.valid_from + ':00',
        end_date: this.orders.valid[1] + ' ' + this.valid_to + ':00',
        start_date_products: this.orders.valid[0] + ' ' + this.products_valid_from + ':00',
        end_date_products: this.orders.valid[1] + ' ' + this.products_valid_to + ':00',
        date_column: this.date_column,
        driver: this.selectedDriver,
        operator: this.selectedPosUser,
        selected_user: this.selected_user,
        selected_order_from: this.selected_order_from,
        selected_payment_methods: this.getPaymentMethodsArray(),
        coupon: this.orders.search,
        search: this.freeSearch,
        zet: this.zet,
        top_category_ids: Array.isArray(this.selectedCategories) && this.selectedCategories.length ? this.selectedCategories.map(function (cat) {
          return (typeof cat === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(cat)) === 'object' && cat !== null ? cat.id : cat;
        }) : null
      };

      var unpaidOrdersVal = this.getUnpaidOrdersApiValue();
      if (unpaidOrdersVal !== undefined) {
        data.unpaid_orders = unpaidOrdersVal;
      }

      if (this.orderId) {
        data.order_id = this.orderId;
      }
      if (this.selectedTable && this.selectedTable.id != null && this.selectedTable.id !== '') {
        data.table_id = this.selectedTable.id;
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }
      if (this.orders.method && this.orders.method !== '') {
        data.method = this.orders.method.toUpperCase();
      }
      if (this.orders.methods && this.orders.methods.length) {
        data.methods = this.orders.methods.filter(function (m) {
          return m != null;
        }).map(function (method) {
          if (typeof method === 'string') {
            return method.toUpperCase();
          }
          var key = method.key || method.value || method;
          return String(key).toUpperCase();
        });
      }
      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      var hasReceiptValue = this.hasRceipt && this.hasRceipt.value || null;

      this.apiRequest('/reports/sales-report-beta?page=' + page + '&pageSize=' + pageSize + '&has_receipt=' + hasReceiptValue, 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data.users && (!_this11.users || _this11.users.length === 0)) {
            _this11.users = Array.isArray(response.data.users) ? response.data.users : [];
          }
          _this11.ordersTableData = response.data.orders;
          _this11.totals.totalTips = response.data.payment_tips || 0;
          _this11.totals.totalCash = response.data.payment_cash || 0;
          _this11.totals.totalVirament = response.data.payment_virament || 0;
          _this11.totals.totalOnline = response.data.payment_online || 0;
          _this11.totals.totalProtocol = response.data.payment_protocol || 0;
          _this11.totals.totalStaffFood = response.data.payment_staff_food || 0;
          _this11.totals.totalRoom = response.data.payment_room || 0;
          _this11.totals.totalEvent = response.data.payment_event || 0;
          _this11.totals.totalFolio = response.data.payment_folio || 0;
          _this11.totals.totalSplit = response.data.payment_split || 0;
          _this11.totals.totalCard = response.data.payment_card || 0;
          _this11.totals.totalPOS = response.data.payment_pos || 0;
          _this11.totals.totalCARDPOS = response.data.payment_card_pos || 0;
          _this11.totals.totalDiscount = response.data.total_discount || 0;
          _this11.totals.totalDiscountItems = response.data.total_discount_items || 0;
          _this11.totals.totalDiscountLoyaltyPoints = response.data.total_discount_loyalty_points || 0;
          _this11.totals.totalTax = response.data.total_tax || 0;
          _this11.totals.totalSlotTax = response.data.total_slot_tax || 0;
          _this11.totals.totalSlotPartTax = response.data.total_slot_part_tax || 0;
          _this11.totals.avarageOrderValue = response.data.avarage_order_value || 0;
          _this11.totals.totalShipping = response.data.total_shipping;
          _this11.totals.totalBoltCard = response.data.payment_bolt_card || 0;
          _this11.totals.totalBoltCash = response.data.payment_bolt_cash || 0;
          _this11.totals.totalGlovoCard = response.data.payment_glovo_card || 0;
          _this11.totals.totalGlovoCash = response.data.payment_glovo_cash || 0;
          _this11.totals.totalWoltCard = response.data.payment_wolt_card || response.data.payment_woltCard || 0;
          _this11.totals.totalWoltCash = response.data.payment_wolt_cash || response.data.payment_woltCash || 0;
          _this11.totals.totalWoltOtherMethods = response.data.payment_wolt_other_methods || 0;
          _this11.totals.totalSplitCash = response.data.total_split_cash || 0;
          _this11.totals.totalSplitCard = response.data.total_split_card || 0;
          _this11.totals.totalSplitVoucher = response.data.total_split_voucher || 0;
          _this11.totals.totalUnpaid = response.data.payment_unpaid || 0;
          _this11.totals.unfiscalTotal = response.data.unfiscal_total || 0;
          _this11.totals.unfiscalTotalCard = response.data.unfiscal_total_card || 0;
          _this11.totals.unfiscalTotalCash = response.data.unfiscal_total_cash || 0;
          _this11.totals.unfiscalTotalCredit = response.data.unfiscal_total_credit || 0;
          _this11.totals.unfiscalTotalOnline = response.data.unfiscal_total_online || 0;

          if (response.data.card_totals) {
            _this11.cardTotals = {
              total_amount: response.data.card_totals.total_amount || 0,
              total_cash: response.data.card_totals.total_cash || 0,
              total_online: response.data.card_totals.total_online || 0,
              total_card: response.data.card_totals.total_card || 0,
              total_credit: response.data.card_totals.total_credit || 0,
              total_other_methods: response.data.card_totals.total_other_methods || 0
            };
          }

          var apiTotal = response.data.card_totals && response.data.card_totals.total_amount || response.data.total_sales || response.data.grand_total || response.data.total_grandtotal;
          if (apiTotal !== undefined && apiTotal !== null) {
            _this11.totals.total = parseFloat(apiTotal) || 0;
          } else {
            _this11.totals.total = (_this11.cashSummaryTotal || 0) + (_this11.totalOnlineSummaryTotal || 0) + (_this11.totalCardSummaryTotal || 0) + (_this11.totalCreditSummaryTotal || 0) + (_this11.nonFiscalSummaryTotal || 0) + (_this11.totals.totalUnpaid || 0);
          }

          _this11.totalOrders = response.data.orders.total || response.data.total_orders || 0;
          _this11.json_data = response.data.export_excel;

          var cardPayment = response.data.payment_card_counter;
          var cashPayment = response.data.payment_cash_counter;
          var viramentPayment = response.data.payment_virament_counter;
          var onlinePayment = response.data.payment_online_counter;
          var protocolPayment = response.data.payment_protocol_counter;
          var paymentStaffFoodPayment = response.data.payment_staff_food_counter;
          var paymentRoomPayment = response.data.payment_room_counter;
          var paymentEventPayment = response.data.payment_event_counter;
          var paymentFolioPayment = response.data.payment_folio_counter;
          var paymentSplitPayment = response.data.payment_split_counter;
          var posPayment = response.data.payment_pos_counter;
          var cardPosPayment = response.data.payment_card_pos_counter;
          var boltCardPayment = response.data.payment_bolt_card_counter;
          var boltCashPayment = response.data.payment_bolt_cash_counter;
          var glovoCardPayment = response.data.payment_glovo_card_counter;
          var glovoCashPayment = response.data.payment_glovo_cash_counter;
          var woltCardPayment = response.data.payment_wolt_card_counter;
          var woltCashPayment = response.data.payment_wolt_cash_counter;
          var woltOtherMethodsPayment = response.data.payment_wolt_other_methods_counter;
          var unpaidPayment = response.data.payment_unpaid_counter;

          var totalPayments = cardPayment + cashPayment + posPayment + cardPosPayment + viramentPayment + onlinePayment + protocolPayment + paymentStaffFoodPayment + paymentRoomPayment + paymentEventPayment + paymentFolioPayment + paymentSplitPayment + boltCardPayment + boltCashPayment + glovoCardPayment + glovoCashPayment + woltCardPayment + woltCashPayment + (woltOtherMethodsPayment || 0) + unpaidPayment;
          if (totalPayments) {
            _this11.salesReportChart.data.labels = [_this11.$t('reports.card') + ' - ' + parseFloat(cardPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.cash') + ' - ' + parseFloat(cashPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.pos') + ' - ' + parseFloat(posPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.cardPos') + ' - ' + parseFloat(cardPosPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.virament') + ' - ' + parseFloat(viramentPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.online') + ' - ' + parseFloat(onlinePayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.protocol') + ' - ' + parseFloat(protocolPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.staffFood') + ' - ' + parseFloat(paymentStaffFoodPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.room') + ' - ' + parseFloat(paymentRoomPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.event') + ' - ' + parseFloat(paymentEventPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.folio') + ' - ' + parseFloat(paymentFolioPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('paymentTypes.SPLIT') + ' - ' + parseFloat(paymentSplitPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.boltCard') + ' - ' + parseFloat(boltCardPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.boltCash') + ' - ' + parseFloat(boltCashPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.glovoCard') + ' - ' + parseFloat(glovoCardPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.glovoCash') + ' - ' + parseFloat(glovoCashPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.woltCard') + ' - ' + parseFloat(woltCardPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.woltCash') + ' - ' + parseFloat(woltCashPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.woltOtherMethods') + ' - ' + parseFloat((woltOtherMethodsPayment || 0) * 100 / totalPayments).toFixed(2) + '%'];
            _this11.salesReportChart.data.series = [{
              value: cardPayment,
              name: _this11.$t('reports.card')
            }, {
              value: cashPayment,
              name: _this11.$t('reports.cash')
            }, {
              value: posPayment,
              name: _this11.$t('reports.pos')
            }, {
              value: cardPosPayment,
              name: _this11.$t('reports.cardPos')
            }, {
              value: viramentPayment,
              name: _this11.$t('reports.virament')
            }, {
              value: onlinePayment,
              name: _this11.$t('reports.online')
            }, {
              value: protocolPayment,
              name: _this11.$t('reports.protocol')
            }, {
              value: paymentStaffFoodPayment,
              name: _this11.$t('reports.staffFood')
            }, {
              value: paymentRoomPayment,
              name: _this11.$t('reports.room')
            }, {
              value: paymentEventPayment,
              name: _this11.$t('reports.event')
            }, {
              value: paymentFolioPayment,
              name: _this11.$t('reports.folio')
            }, {
              value: paymentSplitPayment,
              name: _this11.$t('paymentTypes.SPLIT')
            }, {
              value: boltCardPayment,
              name: _this11.$t('reports.boltCard')
            }, {
              value: boltCashPayment,
              name: _this11.$t('reports.boltCash')
            }, {
              value: glovoCardPayment,
              name: _this11.$t('reports.glovoCard')
            }, {
              value: glovoCashPayment,
              name: _this11.$t('reports.glovoCash')
            }, {
              value: woltCardPayment,
              name: _this11.$t('reports.woltCard')
            }, {
              value: woltCashPayment,
              name: _this11.$t('reports.woltCash')
            }, {
              value: woltOtherMethodsPayment || 0,
              name: _this11.$t('reports.woltOtherMethods')
            }];
            _this11.$refs.salesReportChart.initChart();
          } else {
            _this11.salesReportChart.data.labels = [_this11.$t('reports.card') + ' - ' + 0, _this11.$t('reports.cash') + ' - ' + 0, _this11.$t('reports.pos') + ' - ' + 0, _this11.$t('reports.cardPos') + ' - ' + 0, _this11.$t('reports.virament') + ' - ' + 0, _this11.$t('reports.online') + ' - ' + 0, _this11.$t('reports.protocol') + ' - ' + 0, _this11.$t('reports.room') + ' - ' + 0, _this11.$t('reports.event') + ' - ' + 0, _this11.$t('reports.folio') + ' - ' + 0, _this11.$t('paymentTypes.SPLIT') + ' - ' + 0, _this11.$t('reports.boltCard') + ' - ' + 0, _this11.$t('reports.boltCash') + ' - ' + 0, _this11.$t('reports.glovoCard') + ' - ' + 0, _this11.$t('reports.glovoCash') + ' - ' + 0, _this11.$t('reports.woltCard') + ' - ' + 0, _this11.$t('reports.woltCash') + ' - ' + 0, _this11.$t('reports.woltOtherMethods') + ' - ' + 0];

            _this11.salesReportChart.data.series = [{
              value: 0,
              name: _this11.$t('reports.card')
            }, {
              value: 0,
              name: _this11.$t('reports.cash')
            }, {
              value: 0,
              name: _this11.$t('reports.pos')
            }, {
              value: 0,
              name: _this11.$t('reports.cardPos')
            }, {
              value: 0,
              name: _this11.$t('reports.virament')
            }, {
              value: 0,
              name: _this11.$t('reports.online')
            }, {
              value: 0,
              name: _this11.$t('reports.protocol')
            }, {
              value: 0,
              name: _this11.$t('reports.room')
            }, {
              value: 0,
              name: _this11.$t('reports.event')
            }, {
              value: 0,
              name: _this11.$t('reports.folio')
            }, {
              value: 0,
              name: _this11.$t('paymentTypes.SPLIT')
            }, {
              value: 0,
              name: _this11.$t('reports.boltCard')
            }, {
              value: 0,
              name: _this11.$t('reports.boltCash')
            }, {
              value: 0,
              name: _this11.$t('reports.glovoCard')
            }, {
              value: 0,
              name: _this11.$t('reports.glovoCash')
            }, {
              value: 0,
              name: _this11.$t('reports.woltCard')
            }, {
              value: 0,
              name: _this11.$t('reports.woltCash')
            }, {
              value: 0,
              name: _this11.$t('reports.woltOtherMethods')
            }];
            _this11.$refs.salesReportChart.initChart();
          }
        }
        _this11.$nextTick(function () {
          _this11.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.saveFiltersToCookie();
      this.getOrders();
    },
    goToRecordOrder: function goToRecordOrder(row, event, column) {
      this.$router.push('/orders/view/' + row.id);
    },
    formatReceiptNumber: function formatReceiptNumber(receiptNumber) {
      if (!receiptNumber) {
        return '-';
      }

      try {
        if ((typeof receiptNumber === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(receiptNumber)) === 'object' && receiptNumber !== null) {
          return receiptNumber.ReceiptNumber || receiptNumber.receiptNumber || receiptNumber.receipt_number || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(receiptNumber);
        }

        if (typeof receiptNumber === 'string') {
          if (!receiptNumber.trim()) {
            return '-';
          }
          var parsed = JSON.parse(receiptNumber);
          if ((typeof parsed === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(parsed)) === 'object' && parsed !== null) {
            return parsed.ReceiptNumber || parsed.receiptNumber || parsed.receipt_number || receiptNumber;
          }
          return parsed;
        }

        return receiptNumber;
      } catch (e) {
        return receiptNumber;
      }
    },
    parseZet: function parseZet(receiptNumber) {
      if (!receiptNumber) {
        return '-';
      }

      try {
        var data = receiptNumber;

        if (typeof data === 'string') {
          if (!data.trim()) {
            return '-';
          }
          data = JSON.parse(data);
        }

        if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(data)) === 'object' && data !== null) {
          var info = data.ReceiptInfo || data.receiptInfo || data.receipt_info || '';

          if (typeof info === 'string') {
            var match = info.match(/NRZ\s*=\s*(\d+)/);
            if (match && match[1]) {
              return match[1];
            }
          }
        }

        return '-';
      } catch (e) {
        return '-';
      }
    },
    saveFiltersToCookie: function saveFiltersToCookie() {
      var filters = {
        location: this.orders.location || '',
        valid: this.orders.valid || [__WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD')],
        valid_from: this.valid_from || '05:00',
        valid_to: this.valid_to || '05:00',
        methods: Array.isArray(this.orders.methods) ? this.orders.methods : [],
        search: this.orders.search || '',
        selected_user: this.selected_user || '',
        selectedPosUser: this.selectedPosUser || '',
        selected_order_from: this.selected_order_from || '',
        selected_payment_methods: Array.isArray(this.selected_payment_methods) ? this.selected_payment_methods : [],
        unpaidOrdersFilter: this.unpaidOrdersFilter || 'paid',
        selectedTable: this.selectedTable && this.selectedTable.id != null ? { id: this.selectedTable.id, label: this.selectedTable.label || '' } : null,
        orderId: this.orderId || null,
        zet: this.zet || null,
        selectedCategories: Array.isArray(this.selectedCategories) ? this.selectedCategories : [],
        hasRceipt: this.hasRceipt || null,
        freeSearch: this.freeSearch || '',
        selectedDriver: this.selectedDriver || ''
      };
      this.$cookie.set('sales-report-beta-filters', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filters), 30);

      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    loadFiltersFromCookie: function loadFiltersFromCookie() {
      var _this12 = this;

      var filtersCookie = this.$cookie.get('sales-report-beta-filters');
      if (filtersCookie) {
        try {
          var filters = JSON.parse(filtersCookie);

          if (filters.location !== undefined) {
            this.orders.location = filters.location || '';
          }
          if (filters.valid && Array.isArray(filters.valid) && filters.valid.length === 2) {
            this.orders.valid = filters.valid;
          }
          if (filters.valid_from) {
            this.valid_from = filters.valid_from;
          }
          if (filters.valid_to) {
            this.valid_to = filters.valid_to;
          }
          if (filters.methods && Array.isArray(filters.methods)) {
            this.orders.methods = filters.methods;
          }
          if (filters.search !== undefined) {
            this.orders.search = filters.search || '';
          }
          if (filters.selected_user !== undefined) {
            this.selected_user = filters.selected_user || '';
          }
          if (filters.selectedPosUser !== undefined) {
            this.selectedPosUser = filters.selectedPosUser || '';
          }
          if (filters.selected_order_from !== undefined) {
            this.selected_order_from = filters.selected_order_from || '';
          }
          if (filters.selected_payment_methods && Array.isArray(filters.selected_payment_methods)) {
            this.selected_payment_methods = filters.selected_payment_methods;
          }
          if (filters.unpaidOrdersFilter === 'all' || filters.unpaidOrdersFilter === 'paid' || filters.unpaidOrdersFilter === 'unpaid') {
            this.unpaidOrdersFilter = filters.unpaidOrdersFilter;
          }
          if (filters.selectedTable && filters.selectedTable.id != null) {
            this.selectedTable = {
              id: filters.selectedTable.id,
              label: filters.selectedTable.label || String(filters.selectedTable.id)
            };
          } else if (filters.selectedTable === null) {
            this.selectedTable = null;
          }
          if (filters.orderId !== undefined) {
            this.orderId = filters.orderId || null;
          }
          if (filters.zet !== undefined) {
            this.zet = filters.zet || null;
          }
          if (filters.selectedCategories && Array.isArray(filters.selectedCategories)) {
            this.selectedCategories = filters.selectedCategories;
          }
          if (filters.hasRceipt !== undefined) {
            this.hasRceipt = filters.hasRceipt || null;
          }
          if (filters.freeSearch !== undefined) {
            this.freeSearch = filters.freeSearch || '';
          }
          if (filters.selectedDriver !== undefined) {
            this.selectedDriver = filters.selectedDriver || '';
          }

          if (this.selected_user && this.selected_user !== '') {
            var userExists = this.users.find(function (u) {
              return String(u.id) === String(_this12.selected_user);
            });
            if (!userExists) {
              this.searchUsersById(this.selected_user);
            }
          }

          if (this.isSalesReportBeta) {
            this.$nextTick(function () {
              _this12.getOrders();
            });
          }
        } catch (e) {
          console.error('Error loading filters from cookie:', e);
        }
      } else {
        var filterCookie = this.$cookie.get('filter-locations');
        if (filterCookie) {
          try {
            var filterCookieParsed = JSON.parse(filterCookie);
            if (filterCookieParsed && filterCookieParsed[0]) {
              this.orders.location = filterCookieParsed[0];
            }
          } catch (e) {
            console.error('Error loading old filter-locations cookie:', e);
          }
        }
      }
    },
    clearFiltersCookie: function clearFiltersCookie() {
      this.$cookie.delete('sales-report-beta-filters');
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(['']), 30);
    },
    daysBetween: function daysBetween(date1, date2) {
      var oneDay = 1000 * 60 * 60 * 24;
      var date1Ms = date1.getTime();
      var date2Ms = date2.getTime();
      var differenceMs = date2Ms - date1Ms;
      return Math.round(differenceMs / oneDay);
    },
    firstDayofMonth: function firstDayofMonth() {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      return firstDay;
    },
    lastDayofMonth: function lastDayofMonth() {
      var date = new Date();
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return lastDay;
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    tabClicked: function tabClicked(selectedTab) {},
    tabChanged: function tabChanged(selectedTab) {},
    getPosUsers: function getPosUsers() {
      var _this13 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this13.posUsers = response.data.pos_user;
        }
      });
    },
    getDrivers: function getDrivers() {
      var _this14 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/reports/drivers-list', 'GET', data, function (response) {
        if (response.status) {
          _this14.drivers = response.data.drivers || response.data || [];
        }
      });
    }
  }
});

/***/ }),

/***/ "Tfw8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ThP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('digital-signage-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tjv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-offset-1 col-md-10"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"purple text-center"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.details')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[(_vm.isEdit && _vm.family)?_c('div',{staticClass:"sub-form-family"},[_c('i',{staticClass:"fa fa-clone"}),_vm._v("\n              "+_vm._s(_vm.$t('marketingSubscriptions.levelOf', { level: _vm.level, family: _vm.family.name }))+"\n            ")]):_c('div',{staticClass:"sub-form-family sub-form-family--choose"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.family'))+"*")]),_vm._v(" "),_c('div',{staticClass:"sub-form-modes"},[_c('label',{staticClass:"sub-form-mode"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.family_mode),expression:"form.family_mode"}],attrs:{"type":"radio","value":"new"},domProps:{"checked":_vm._q(_vm.form.family_mode,"new")},on:{"change":function($event){_vm.$set(_vm.form, "family_mode", "new")}}}),_vm._v(" "+_vm._s(_vm.$t('marketingSubscriptions.familyNew'))+"\n                  ")]),_vm._v(" "),_c('label',{staticClass:"sub-form-mode",class:{ 'is-disabled': !_vm.families.length }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.family_mode),expression:"form.family_mode"}],attrs:{"type":"radio","value":"existing","disabled":!_vm.families.length},domProps:{"checked":_vm._q(_vm.form.family_mode,"existing")},on:{"change":function($event){_vm.$set(_vm.form, "family_mode", "existing")}}}),_vm._v(" "+_vm._s(_vm.$t('marketingSubscriptions.familyExisting'))+"\n                  ")])])]),_vm._v(" "),(_vm.form.family_mode === 'new')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.familyName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.family_name),expression:"form.family_name"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"255","placeholder":_vm.form.name || _vm.$t('marketingSubscriptions.familyNameHint')},domProps:{"value":(_vm.form.family_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "family_name", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.familyNameHint')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.paymentProcessor'))+"*")]),_vm._v(" "),_c('el-select',{staticClass:"w-100",attrs:{"no-data-text":_vm.$t('marketingSubscriptions.noPaymentAccounts')},model:{value:(_vm.form.payment_group_key),callback:function ($$v) {_vm.$set(_vm.form, "payment_group_key", $$v)},expression:"form.payment_group_key"}},_vm._l((_vm.paymentGroups),function(group){return _c('el-option',{key:group.group_key,attrs:{"label":_vm.paymentGroupLabel(group),"value":group.group_key}})})),_vm._v(" "),(!_vm.paymentGroups.length)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.noPaymentAccounts')))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.formErrors.payment)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.paymentRequired')))]):_vm._e()])]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('el-select',{staticClass:"w-100",attrs:{"placeholder":_vm.$t('marketingSubscriptions.selectFamily')},model:{value:(_vm.form.subscription_family_id),callback:function ($$v) {_vm.$set(_vm.form, "subscription_family_id", $$v)},expression:"form.subscription_family_id"}},_vm._l((_vm.families),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})})),_vm._v(" "),(_vm.formErrors.family)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.familyRequired')))]):_vm._e()],1)]),_vm._v(" "),(_vm.selectedFamily && _vm.selectedFamily.top_level)?_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"sub-form-hint"},[_vm._v("\n                    "+_vm._s(_vm.$t('marketingSubscriptions.willBeLevel', { level: _vm.selectedFamily.next_level, name: _vm.selectedFamily.top_level.name, price: _vm.selectedFamily.top_level.price + ' ' + _vm.currency }))+"\n                  ")])]):_vm._e()])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7 col-md-offset-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.name'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('marketingSubscriptions.name'),"maxlength":_vm.NAME_MAX},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),(_vm.formErrors.name)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.nameRequired')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.price'))+"* "),_c('small',{staticClass:"text-muted"},[_vm._v("("+_vm._s(_vm.currency)+")")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.price),expression:"form.price"}],staticClass:"form-control",class:{ 'sub-price--invalid': _vm.priceOrderError },attrs:{"type":"number","min":_vm.minPrice,"step":"0.01"},domProps:{"value":(_vm.form.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "price", $event.target.value)}}}),_vm._v(" "),(_vm.priceOrderError)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.priceOrderError))]):(_vm.formErrors.price)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.formErrors.price))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.active')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.form.active),callback:function ($$v) {_vm.$set(_vm.form, "active", $$v)},expression:"form.active"}})],1)])]),_vm._v(" "),(_vm.levelBelow || _vm.levelAbove)?_c('div',{staticClass:"sub-form-hint sub-form-hint--price"},[(_vm.levelBelow)?_c('div',[_vm._v("\n                "+_vm._s(_vm.$t('marketingSubscriptions.priceHintBelow', { name: _vm.levelBelow.name, price: _vm.levelBelow.price + ' ' + _vm.currency, diff: _vm.upgradeDiffText }))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.levelAbove)?_c('div',[_vm._v("\n                "+_vm._s(_vm.$t('marketingSubscriptions.priceHintAbove', { name: _vm.levelAbove.name, price: _vm.levelAbove.price + ' ' + _vm.currency }))+"\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.description')))]),_vm._v(" "),(_vm.loaded)?_c('wysiwyg',{staticClass:"form-control subscription-editor",attrs:{"options":_vm.editorOptions},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.image'))+" "),_c('small',{staticClass:"text-muted"},[_vm._v("("+_vm._s(_vm.$t('marketingSubscriptions.imageHint'))+")")])]),_vm._v(" "),_c('el-upload',{attrs:{"action":"","list-type":"picture-card","accept":".jpg,.jpeg,.png","file-list":_vm.form.imagelist,"limit":1,"auto-upload":false,"on-change":_vm.handleImageChange,"on-remove":_vm.handleImageRemove,"on-exceed":_vm.handleExceed}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})])],1)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.inheritedCoupons')))]),_vm._v(" "),(_vm.inheritedGroups.length)?_vm._l((_vm.inheritedGroups),function(group){return _c('div',{key:'inhg' + group.level,staticClass:"sub-inherited-group"},[_c('span',{staticClass:"sub-inherited-group__level"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.inheritedFromLevel', { level: group.level, name: group.name }))+":")]),_vm._v(" "),_vm._l((group.coupons),function(coupon){return _c('span',{key:'inh' + group.level + '-' + coupon.id,staticClass:"sub-badge sub-badge--inherited"},[_vm._v(_vm._s(coupon.name))])}),_vm._v(" "),(!group.coupons.length)?_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.noneAssigned')))]):_vm._e()],2)}):_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.noInherited')))])],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"sub-own-head"},[_c('label',[_vm._v("\n                  "+_vm._s(_vm.$t('marketingSubscriptions.ownCouponsTitle'))+"\n                  "),(_vm.form.coupon_ids.length)?_c('span',{staticClass:"subscription-selected-count"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.selectedCount', { count: _vm.form.coupon_ids.length })))]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-purple",on:{"click":function($event){$event.preventDefault();return _vm.openCouponModal($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('marketingSubscriptions.newCoupon'))+"\n                ")])]),_vm._v(" "),_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-bottom":"8px"}},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.couponsHint')))]),_vm._v(" "),(!_vm.coupons.length)?_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.noCoupons')))]):[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couponSearch),expression:"couponSearch"}],staticClass:"form-control subscription-coupon-search",attrs:{"type":"text","placeholder":_vm.$t('marketingSubscriptions.searchCoupons')},domProps:{"value":(_vm.couponSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.couponSearch=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"subscription-coupon-list"},[_vm._l((_vm.filteredCoupons),function(coupon){return _c('div',{key:'coupon' + coupon.id,staticClass:"subscription-coupon-row",class:{ 'is-checked': _vm.isCouponChecked(coupon.id), 'is-inherited': _vm.inheritedById[coupon.id] },on:{"click":function($event){_vm.toggleCoupon(coupon.id)}}},[_c('input',{staticStyle:{"margin":"0","pointer-events":"none"},attrs:{"type":"checkbox","disabled":!!_vm.inheritedById[coupon.id]},domProps:{"checked":_vm.isCouponChecked(coupon.id) || !!_vm.inheritedById[coupon.id]}}),_vm._v(" "),_c('span',{staticStyle:{"flex":"1"}},[_c('strong',[_vm._v(_vm._s(coupon.name))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(" — "+_vm._s(_vm.couponDiscountText(coupon)))]),_vm._v(" "),(!coupon.active)?_c('span',{staticClass:"subscription-coupon-inactive"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.inactive')))]):_vm._e(),_vm._v(" "),(_vm.inheritedById[coupon.id])?_c('span',{staticClass:"subscription-coupon-inherited"},[_vm._v("\n                        "+_vm._s(_vm.$t('marketingSubscriptions.inheritedIncluded', { level: _vm.inheritedById[coupon.id].level, name: _vm.inheritedById[coupon.id].name }))+"\n                      ")]):_vm._e()])])}),_vm._v(" "),(!_vm.filteredCoupons.length)?_c('p',{staticClass:"text-muted",staticStyle:{"padding":"10px","margin":"0"}},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.noCouponsFound')))]):_vm._e()],2)]],2)])]),_vm._v(" "),_c('div',{staticClass:"text-center mar-to-10"},[_c('button',{staticClass:"btn btn-purple-light btn-fill btn-wd",attrs:{"disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])]),_vm._v(" "),_c('vmodal',{staticClass:"subscriptionCouponModal",attrs:{"name":"subscriptionCouponModal","width":"95%","maxWidth":1100,"minWidth":300,"height":"auto","scrollable":true,"adaptive":true,"clickToClose":false},on:{"opened":_vm.onCouponModalOpened}},[_c('div',{staticClass:"sub-coupon-modal__header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.newCouponTitle')))]),_vm._v(" "),_c('a',{staticClass:"sub-coupon-modal__close",on:{"click":function($event){_vm.$modal.hide('subscriptionCouponModal')}}},[_c('i',{staticClass:"fa fa-times"})])]),_vm._v(" "),_c('div',{staticClass:"sub-coupon-modal__body"},[(_vm.couponModalOpen)?_c('coupon-form',{attrs:{"embedded":"","force-subscription":""},on:{"saved":_vm.onCouponCreated}}):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TkD5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Management_Dashboard_ManagementDashboard_vue__ = __webpack_require__("NkqJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Management_Nomenclator_NomenclatorTabs_vue__ = __webpack_require__("IDoR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Management_Suppliers_ManagementOrdersSuppliers_vue__ = __webpack_require__("mzTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Management_Suppliers_ManagementSuppliersTabs_vue__ = __webpack_require__("EHmy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Management_Casa_ManagementCasaRegister_vue__ = __webpack_require__("vnQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Management_ManagementSettings_vue__ = __webpack_require__("T2pQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Management_ManagementReports_vue__ = __webpack_require__("PAqi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Management_ManagementOutputsTabs_vue__ = __webpack_require__("u9Do");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Management_ManagementEntriesTabs_vue__ = __webpack_require__("TGY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Management_ManagementStocksTabs_vue__ = __webpack_require__("V4Gz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Management_ManagementProduction_vue__ = __webpack_require__("ODHw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Management_ManagementExports_vue__ = __webpack_require__("LKKj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2__);





















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementOutputsTabs: __WEBPACK_IMPORTED_MODULE_13__Management_ManagementOutputsTabs_vue__["a" /* default */],
    ManagementEntriesTabs: __WEBPACK_IMPORTED_MODULE_14__Management_ManagementEntriesTabs_vue__["a" /* default */],
    ManagementStocksTabs: __WEBPACK_IMPORTED_MODULE_15__Management_ManagementStocksTabs_vue__["a" /* default */],
    ManagementSuppliersTabs: __WEBPACK_IMPORTED_MODULE_9__Management_Suppliers_ManagementSuppliersTabs_vue__["a" /* default */],
    ManagementDashboard: __WEBPACK_IMPORTED_MODULE_6__Management_Dashboard_ManagementDashboard_vue__["a" /* default */],
    NomenclatorTabs: __WEBPACK_IMPORTED_MODULE_7__Management_Nomenclator_NomenclatorTabs_vue__["a" /* default */],
    ManagementOrdersSuppliers: __WEBPACK_IMPORTED_MODULE_8__Management_Suppliers_ManagementOrdersSuppliers_vue__["a" /* default */],
    ManagementCasaRegister: __WEBPACK_IMPORTED_MODULE_10__Management_Casa_ManagementCasaRegister_vue__["a" /* default */],
    ManagementSettings: __WEBPACK_IMPORTED_MODULE_11__Management_ManagementSettings_vue__["a" /* default */],
    ManagementReports: __WEBPACK_IMPORTED_MODULE_12__Management_ManagementReports_vue__["a" /* default */],
    ManagementProduction: __WEBPACK_IMPORTED_MODULE_16__Management_ManagementProduction_vue__["a" /* default */],
    ManagementExports: __WEBPACK_IMPORTED_MODULE_17__Management_ManagementExports_vue__["a" /* default */]
  },
  data: function data() {
    return {
      selectedTabIndex: 0,
      groupedLocationsKey: 0,
      activeTabName: '',
      loadedTabs: new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(),
      locations: [],
      gestiuneOptions: [],
      hasMissingSyncStart: false,
      missingSyncLocations: []
    };
  },
  mounted: function mounted() {
    this.companyID = this.$session.get('selectedCompany');

    this.switchTab();
    this.fetchLocation();
    this.fetchGestiuni();
  },

  watch: {
    groupedLocations: function groupedLocations(newVal) {
      this.groupedLocationsKey++;
    }
  },
  computed: {
    groupedLocations: function groupedLocations() {
      var groups = {};

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    }
  },
  methods: {
    shouldLoadTab: function shouldLoadTab(tabName) {
      return this.activeTabName === tabName || this.loadedTabs.has(tabName);
    },
    getVisibleTabsIndexMap: function getVisibleTabsIndexMap() {
      var tabs = [{ name: 'dashboard', right: 'can_access_dashboard' }, { name: 'outputs', right: 'can_access_gestiune' }, { name: 'entries', right: 'can_access_gestiune' }, { name: 'stocks', right: 'can_access_gestiune' }, { name: 'production', right: 'can_access_gestiune' }, { name: 'reteta', right: 'can_access_gestiune' }, { name: 'ordersSuppliers', right: 'can_access_supplier_orders' }, { name: 'reports', right: 'can_access_reports' }, { name: 'settings', right: 'can_access_settings' }];

      var indexMap = {};
      var currentIndex = 0;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(tabs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tab = _step.value;

          if (this.userHasRight(tab.right)) {
            indexMap[tab.name] = currentIndex;
            currentIndex++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return indexMap;
    },
    switchTab: function switchTab() {
      var query = this.$route.query;
      var tabIndexMap = this.getVisibleTabsIndexMap();

      if (query.tab) {
        var tabName = query.tab;
        this.selectedTabIndex = tabIndexMap[tabName];
        this.activeTabName = tabName;
        this.loadedTabs.add(tabName);

        if (tabName === 'reteta' && query.vatNumber) {
          this.selectedVatNumber = query.vatNumber;
          console.log('VAT Number set from query for reteta:', this.selectedVatNumber);
        }
      } else {
        var firstAvailableTab = this.getFirstAvailableTab();
        if (firstAvailableTab) {
          this.activeTabName = firstAvailableTab;
          this.loadedTabs.add(firstAvailableTab);
        }
      }
    },
    getFirstAvailableTab: function getFirstAvailableTab() {
      var tabs = [{ name: 'dashboard', right: 'can_access_dashboard' }, { name: 'outputs', right: 'can_access_gestiune' }, { name: 'entries', right: 'can_access_gestiune' }, { name: 'stocks', right: 'can_access_gestiune' }, { name: 'production', right: 'can_access_gestiune' }, { name: 'reteta', right: 'can_access_gestiune' }, { name: 'ordersSuppliers', right: 'can_access_supplier_orders' }, { name: 'reports', right: 'can_access_reports' }, { name: 'settings', right: 'can_access_settings' }];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(tabs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var tab = _step2.value;

          if (this.userHasRight(tab.right)) {
            return tab.name;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    },
    handleTabChange: function handleTabChange(index, tab) {
      var tabName = null;
      if (tab && tab.$attrs) {
        tabName = tab.$attrs.name;
        this.activeTabName = tabName;

        this.loadedTabs.add(tabName);
      }

      var newQuery = { tab: tabName };

      if (tabName === 'reteta' && this.selectedVatNumber) {
        newQuery.vatNumber = this.selectedVatNumber;
      }

      this.$router.push({ path: this.$route.path, query: newQuery });
    },
    fetchLocation: function fetchLocation() {
      var _this = this;

      var dataToSend = {
        company_id: this.companyID,
        token: this.$session.get('token')
      };

      this.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
        if (!response || response.status !== true || !response.data || !response.data.locations) {
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
            title: 'Eroare!',
            text: response.message || 'Eroare la preluarea locațiilor.',
            type: 'error',
            timer: 3000,
            showConfirmButton: false
          });
          return;
        }

        _this.locations = response.data.locations;

        var missing = _this.locations.filter(function (loc) {
          console.log(loc);
          if (!loc.gestiune_id_default) {
            return false;
          }

          return !loc.gestiune_start_sync_order || loc.gestiune_start_sync_order === "0000-00-00 00:00:00";
        });

        _this.missingSyncLocations = missing.map(function (l) {
          return l.name;
        });
        _this.hasMissingSyncStart = missing.length > 0;
      });
    },
    openMissingSyncInfo: function openMissingSyncInfo() {
      __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
        title: "Acțiune necesară!",
        html: '\n          <p>Trebuie s\u0103 mergi \xEEn <strong>Set\u0103ri \u2192 Tab-ul Operatiuni</strong>.</p>\n          <p>Din dropdown, selecteaz\u0103 loca\u021Bia dorit\u0103 \u0219i seteaz\u0103 o <strong>dat\u0103 de \xEEnceput a sincroniz\u0103rii</strong>.</p>\n          <p>Doar dup\u0103 aceast\u0103 configurare v\xE2nzarea va fi activ\u0103 pentru loca\u021Bie.</p>\n          <p style="margin-top: 15px; font-weight: bold; color: #d32f2f;">\n            Dup\u0103 ce completezi aceste c\xE2mpuri, <br>\n            <span style="text-decoration: underline;">apas\u0103 butonul \u201EPORNE\u0218TE V\xC2NZ\u0102RILE\u201D.</span>\n          </p>\n        ',
        icon: "info",
        confirmButtonText: "Am înțeles",
        timer: 10000,
        buttons: true
      });
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this2.companyID);

              case 3:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context.next = 8;
                return response.json();

              case 8:
                data = _context.sent;

                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this2.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      externalLocationId: gest.externalLocationId || '',
                      categorie: gest.categorie || ''
                    };
                  });
                } else {
                  _this2.$message.error('Nu s-a primit un array valid de la server.');
                }
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                _this2.$message.error('Request failed: ' + _context.t0.message);
                console.error('Error fetching management data:', _context.t0);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    }
  }
});

/***/ }),

/***/ "TkQl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tl/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
















var _components;








__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      id: this.route.params.id || null,
      loading: true,
      model: {
        name: '',
        description: '',
        winners_description: '',
        type: 'order_count',
        min_order_value: null,
        fromto: [],
        active: true,
        imagelist: [],
        image: null,
        pdflist: [],
        pdf: null
      },
      modelValidations: {
        name: {
          required: true,
          min: 3
        }
      }
    };
  },

  computed: {
    typeOptions: function typeOptions() {
      return [{
        value: 'order_count',
        label: this.$t('raffleCampaigns.typeOrderCount')
      }, {
        value: 'order_total',
        label: this.$t('raffleCampaigns.typeOrderTotal')
      }];
    }
  },
  created: function created() {
    if (this.id) {
      this.getCampaign();
    } else {
      this.loading = false;
    }
  },

  methods: {
    setRaffleCampaignImagelist: function setRaffleCampaignImagelist(item) {
      if (item.image_url) {
        item.imagelist = item.image_url;
      } else if (item.image) {
        item.imagelist = [{ url: item.image }];
      } else {
        item.imagelist = [];
      }
      if (!Array.isArray(item.imagelist)) {
        item.imagelist = item.imagelist ? [{ url: String(item.imagelist) }] : [];
      }
    },
    setRaffleCampaignPdflist: function setRaffleCampaignPdflist(item) {
      if (item.pdf_url) {
        item.pdflist = [{ name: 'document.pdf', url: item.pdf_url }];
      } else if (item.pdf) {
        var pdfUrl = typeof item.pdf === 'string' ? item.pdf : '';
        item.pdflist = pdfUrl ? [{ name: 'document.pdf', url: pdfUrl }] : [];
      } else {
        item.pdflist = [];
      }
      if (!Array.isArray(item.pdflist)) {
        item.pdflist = item.pdflist ? [{ name: 'document.pdf', url: String(item.pdflist) }] : [];
      }
    },
    parseCampaignDateForPicker: function parseCampaignDateForPicker(value) {
      if (!value) return null;
      return __WEBPACK_IMPORTED_MODULE_19_moment___default()(String(value)).format('YYYY-MM-DD HH:mm:ss');
    },
    getCampaign: function getCampaign() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/raffle-campaigns/' + this.id, 'GET', data, function (response) {
        if (response.status === true) {
          var item = response.data && response.data[0] ? response.data[0] : response.data;
          if (item.starts_at && item.ends_at) {
            item.fromto = [_this.parseCampaignDateForPicker(item.starts_at), _this.parseCampaignDateForPicker(item.ends_at)];
          } else {
            item.fromto = [];
          }
          _this.setRaffleCampaignImagelist(item);
          _this.setRaffleCampaignPdflist(item);
          item.active = !!(parseInt(item.active) === 1 || item.active === true);
          if (!item.type) {
            item.type = 'order_count';
          }
          if (item.min_order_value === undefined || item.min_order_value === null) {
            item.min_order_value = null;
          }
          if (item.winners_description == null) {
            item.winners_description = '';
          }
          _this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.model, item);
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) return;
        if (!_this2.model.fromto || !_this2.model.fromto[0] || !_this2.model.fromto[1]) {
          _this2.errors.add('starts_at', _this2.$t('raffleCampaigns.periodRequired'));
          return;
        }
        if (!_this2.id && !_this2.model.type) {
          _this2.errors.add('type', _this2.$t('raffleCampaigns.typeRequired'));
          return;
        }
        _this2.errors.clear();
        _this2.saveCampaign();
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, prop)) {
          if (Array.isArray(errors[prop]) && errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        }
      }
    },
    saveCampaign: function saveCampaign() {
      var _this3 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        name: this.model.name,
        description: this.model.description || '',
        winners_description: this.model.winners_description || '',
        active: this.model.active ? 1 : 0,
        starts_at: this.model.fromto[0],
        ends_at: this.model.fromto[1]
      };

      if (!this.id) {
        data.type = this.model.type;
      }

      if (this.model.type === 'order_count') {
        data.min_order_value = this.model.min_order_value !== null && this.model.min_order_value !== '' ? this.model.min_order_value : null;
      }

      if (this.model.image) {
        data.image = this.model.image;
      } else if (Array.isArray(this.model.imagelist) && this.model.imagelist.length === 0) {
        data.image = '';
      }

      if (this.model.pdf && String(this.model.pdf).indexOf('data:') === 0) {
        data.pdf = this.model.pdf;
      } else if (Array.isArray(this.model.pdflist) && this.model.pdflist.length === 0) {
        data.pdf = '';
      }

      var url = this.id ? '/raffle-campaigns/' + this.id : '/raffle-campaigns';
      var httpMethod = this.id ? 'PUT' : 'POST';

      this.apiRequest(url, httpMethod, data, function (response) {
        _this3.loading = false;
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
            title: '',
            text: _this3.id ? _this3.$t('raffleCampaigns.campaignUpdated') : _this3.$t('raffleCampaigns.campaignAdded'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
          _this3.backButton();
        } else if (response.errors) {
          _this3.handleErrors(response.errors);
        } else {
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    deleteCampaign: function deleteCampaign() {
      var _this4 = this;

      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: this.$t('raffleCampaigns.areYouSureDelete') + ' ' + (this.model.name || '') + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this4.$session.get('token'),
            company_id: _this4.$session.get('selectedCompany')
          };
          _this4.apiRequest('/raffle-campaigns/' + _this4.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', _this4.$t('raffleCampaigns.campaignDeleted'), 'success').catch(function () {});
              _this4.backButton();
            } else {
              __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.disableConfirmButton();
      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.getConfirmButton().textContent = _this4.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.getConfirmButton().textContent = _this4.$t('general.yes');
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    handleImgChange: function handleImgChange(file, fileList) {
      var _this5 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: this.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
        return;
      }
      if (fileList.length > 1) {
        this.model.imagelist = fileList.slice(1);
      } else {
        this.model.imagelist = fileList;
      }
      if (this.model.imagelist && this.model.imagelist[0] && this.model.imagelist[0].status === 'ready') {
        this.getBase64(this.model.imagelist[0].raw).then(function (base64enc) {
          _this5.model.image = base64enc;
        });
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
        this.model.image = null;
      }
    },
    handleExceed: function handleExceed() {
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: this.$t('raffleCampaigns.removeCurrentImage'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    handlePdfChange: function handlePdfChange(file, fileList) {
      var _this6 = this;

      var isOkSize = file.size / 1024 / 1024 < 25;
      var isPdf = file.raw && file.raw.type === 'application/pdf';
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: this.$t('validations.pdfSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.pdfUpload.clearFiles();
        this.model.pdflist = [];
        return;
      }
      if (!isPdf) {
        __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: this.$t('validations.wrongFormat'),
          position: 'top-end',
          showConfirmButton: true,
          timer: 3000
        });
        this.$refs.pdfUpload.clearFiles();
        this.model.pdflist = [];
        return;
      }
      this.model.pdflist = fileList.slice(-1);
      if (this.model.pdflist[0] && this.model.pdflist[0].status === 'ready') {
        this.getBase64(this.model.pdflist[0].raw).then(function (base64enc) {
          _this6.model.pdf = base64enc;
        });
      }
    },
    handlePdfRemove: function handlePdfRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.pdflist = [];
        this.model.pdf = null;
      }
    },
    handlePdfExceed: function handlePdfExceed() {
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: this.$t('raffleCampaigns.removeCurrentPdf'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "TndE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);




















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    },
    isTable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.token = this.$session.get('token');
    this.getData();
  },
  data: function data() {
    return {
      loading: true,
      token: null,
      apiUrl: null,
      tableColumns: [{
        prop: 'id',
        label: 'ID',
        minWidth: 100
      }, {
        prop: 'name',
        label: this.$t('settingTable.name'),
        minWidth: 300
      }],
      tableData: []
    };
  },

  methods: {
    goToRecord: function goToRecord(row, event, column) {
      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/user/edit/');
      }
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/measurements-units', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data;

          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    },
    goToAdd: function goToAdd() {
      if (typeof this.callback === 'function') {
        this.callback(null);
      }
    }
  }
});

/***/ }),

/***/ "ToeX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RewardProgramForm_vue__ = __webpack_require__("RYO5");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'RewardForm', __WEBPACK_IMPORTED_MODULE_7__RewardProgramForm_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      couponModel: {},
      coupon: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onRewardSubmit: function onRewardSubmit(model, isValid) {
      this.offerModel = model;
    }
  }
});

/***/ }),

/***/ "Tqm7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t5_vue__ = __webpack_require__("1jbc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb4b496e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t5_vue__ = __webpack_require__("uthh");
function injectStyle (ssrContext) {
  __webpack_require__("w5TE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fb4b496e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t5_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb4b496e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t5_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TvcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSuppliersAdd_vue__ = __webpack_require__("un0T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bda9797_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSuppliersAdd_vue__ = __webpack_require__("VqRO");
function injectStyle (ssrContext) {
  __webpack_require__("5y5J")
  __webpack_require__("jyi0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bda9797"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSuppliersAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bda9797_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSuppliersAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tzjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative orders"},[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"})])]),_vm._v(" "),_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),(_vm.order.status)?_c('div',{staticClass:"row order-view"},[_c('div',{staticClass:" col-lg-12 col-md-12 pad-to-15"},[_c('div',{staticClass:"row",staticStyle:{"margin":"0px"}},[_c('div',{staticClass:"buttonsCall"},[_c('div',{staticClass:"row pad-bt-10 height-30-percent display-flex align-items-flex-end"},[_c('div',{staticClass:"col-lg-12 col-sm-12 col-xs-12 col-print-12 details-label",staticStyle:{"padding-right":"0px !important"}},[_c('div',{staticClass:"col-lg-1 col-sm-1 col-xs-12 col-print-6 details-label"}),_vm._v(" "),_c('div',{staticClass:"col-lg-11 col-sm-11 col-xs-12 col-print-6 justify-content-flex-end display-inline-flex"},[(_vm.order.delivery_type === 'DELIVERY' && _vm.order.hio_flag)?[(!_vm.cancelOrder && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-info mar-rt-10 call-courier",attrs:{"id":'call-hio-courier-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.courierHioCall(_vm.order.id, _vm.order.store_id)}}},[_c('img',{attrs:{"src":"/static/img/icons/fast-delivery.png"}}),_vm._v(" "+_vm._s(_vm.$t("orders.callHioCourier")))]):_vm._e(),_vm._v(" "),(_vm.cancelOrder && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-hio-order-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.cancelHioCourierOrder(_vm.order.id, _vm.order.store_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancelCourier")))]):_vm._e(),_vm._v(" "),(_vm.order.status.id === 'TRANSPORT' || _vm.order.status.id === 'CANCELED' || _vm.order.status.id === 'NOT_DELIVERED')?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-hio-order-disabled-' + _vm.order.id,"disabled":"disabled"},on:{"click":function($event){$event.preventDefault();_vm.cancelHioCourierOrder(_vm.order.id, _vm.order.store_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancel")))]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.packageez_flag)?[(!_vm.cancelOrder && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-info mar-rt-10 call-courier",attrs:{"id":'call-courier-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.courierCall(_vm.order.id, _vm.order.store_id)}}},[_c('img',{attrs:{"src":"/static/img/icons/fast-delivery.png"}}),_vm._v(" "+_vm._s(_vm.$t("orders.callCourier"))+" Eastride")]):_vm._e(),_vm._v(" "),(_vm.cancelOrder && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.cancelCourierOrder(_vm.order.id, _vm.order.store_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancelCourier"))+" Eastride")]):_vm._e(),_vm._v(" "),(_vm.order.status.id === 'TRANSPORT' || _vm.order.status.id === 'CANCELED' || _vm.order.status.id === 'NOT_DELIVERED')?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-disabled-' + _vm.order.id,"disabled":"disabled"},on:{"click":function($event){$event.preventDefault();_vm.cancelCourierOrder(_vm.order.id, _vm.order.store_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancel"))+" Eastride")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.glovo_flag)?[((_vm.order.glovo_status === 1 || _vm.order.glovo_status === 3 || _vm.order.glovo_status === 4) && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-info mar-rt-10 call-courier",attrs:{"id":'call-courier-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.glovoCourierCall(_vm.order.id, _vm.order.location_id)}}},[_c('img',{attrs:{"src":"/static/img/icons/fast-delivery.png"}}),_vm._v(" "+_vm._s(_vm.$t("orders.callCourier"))+" GLOVO")]):_vm._e(),_vm._v(" "),(_vm.order.glovo_status === 2 && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.cancelGlovoCourier(_vm.order.id, _vm.order.location_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancelCourier"))+" GLOVO")]):_vm._e(),_vm._v(" "),(_vm.order.status.id === 'TRANSPORT' || _vm.order.status.id === 'CANCELED' || _vm.order.status.id === 'NOT_DELIVERED')?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-disabled-' + _vm.order.id,"disabled":"disabled"},on:{"click":function($event){$event.preventDefault();_vm.cancelGlovoCourier(_vm.order.id, _vm.order.location_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancel"))+" GLOVO")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.integration && _vm.order.integration.wolt_drive_status !== undefined)?[((_vm.order.integration.wolt_drive_status === 1 || _vm.order.integration.wolt_drive_status === 3 || _vm.order.integration.wolt_drive_status === 4 || _vm.order.integration.wolt_drive_status === 6) && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-info mar-rt-10 call-courier",attrs:{"id":'call-courier-wolt-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.woltDriveCourierCall(_vm.order.id, _vm.order.location_id)}}},[_c('img',{attrs:{"src":"/static/img/icons/fast-delivery.png"}}),_vm._v(" "+_vm._s(_vm.$t("orders.callCourier"))+" WOLT DRIVE")]):_vm._e(),_vm._v(" "),(_vm.order.integration.wolt_drive_status === 2 && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-wolt-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.cancelWoltDriveCourier(_vm.order.id, _vm.order.location_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancelCourier"))+" WOLT DRIVE")]):_vm._e(),_vm._v(" "),(_vm.order.status.id === 'TRANSPORT' || _vm.order.status.id === 'CANCELED' || _vm.order.status.id === 'NOT_DELIVERED')?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-disabled-wolt-' + _vm.order.id,"disabled":"disabled"},on:{"click":function($event){$event.preventDefault();_vm.cancelWoltDriveCourier(_vm.order.id, _vm.order.location_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancel"))+" WOLT DRIVE")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.delivery_hero_flag)?[((_vm.deliveryHeroStatus === 0 || _vm.deliveryHeroStatus === 3 || _vm.deliveryHeroStatus === 4) && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-info mar-rt-10 call-courier",attrs:{"id":'call-courier-dh-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.deliveryHeroCourierCall(_vm.order.id, _vm.order.location_id)}}},[_c('img',{attrs:{"src":"/static/img/icons/fast-delivery.png"}}),_vm._v(" "+_vm._s(_vm.$t("orders.callCourier"))+" DELIVERY HERO")]):_vm._e(),_vm._v(" "),(_vm.deliveryHeroStatus === 2 && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-dh-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.cancelDeliveryHeroCourier(_vm.order.id, _vm.order.location_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancelCourier"))+" DELIVERY HERO")]):_vm._e(),_vm._v(" "),(_vm.order.status.id === 'TRANSPORT' || _vm.order.status.id === 'CANCELED' || _vm.order.status.id === 'NOT_DELIVERED')?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-disabled-dh-' + _vm.order.id,"disabled":"disabled"},on:{"click":function($event){$event.preventDefault();_vm.cancelDeliveryHeroCourier(_vm.order.id, _vm.order.location_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancel"))+" DELIVERY HERO")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.rapid_donkey_status > 0)?[(_vm.order.rapid_donkey_status === 1 || _vm.order.rapid_donkey_status === 3 && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-info mar-rt-10 call-courier",attrs:{"id":'rapid-donkey-call-courier-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.callRapidDonkey(_vm.order.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/fast-delivery.png"}}),_vm._v(" "+_vm._s(_vm.$t("orders.callCourier")))]):_vm._e(),_vm._v(" "),(_vm.order.rapid_donkey_status === 2 && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.cancelRapidDonkey()}}},[_vm._v(_vm._s(_vm.$t("general.cancelCourier")))]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.order.grandchef_status === 3)?[_c('button',{staticClass:"btn btn-info mar-rt-10",attrs:{"id":'grandchef-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.sendToGrandchef(_vm.order.id)}}},[_vm._v("Grandchef")])]:_vm._e(),_vm._v(" "),(_vm.order.hide_from_integration_link == 1)?[_c('button',{staticClass:"btn btn-info mar-rt-10",on:{"click":function($event){_vm.showOrderInIntegrationLink(_vm.order.id)}}},[_vm._v("Vectron")])]:_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.call_chopchop > 0)?[(_vm.order.call_chopchop == 1)?_c('button',{staticClass:"btn btn-info mar-rt-10 call-courier",attrs:{"id":'rapid-donkey-call-courier-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.callChopChopDriver(_vm.order.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/fast-delivery.png"}}),_vm._v(" "+_vm._s(_vm.$t("orders.callCourier")))]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.showDrCarmen() && _vm.order.dr_carmen_status == 0)?[_c('button',{staticClass:"btn btn-info mar-rt-10 call-courier",attrs:{"id":'rapid-donkey-call-courier-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.callDrCarmen(_vm.order.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/fast-delivery.png"}}),_vm._v(" "+_vm._s(_vm.$t("orders.callCourier"))+" Dr Carmen")])]:_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.showDrCarmen() && _vm.order.dr_carmen_status != 0)?[_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'rapid-donkey-call-courier-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.cancelDrCarmen(_vm.order.id)}}},[_vm._v(_vm._s(_vm.$t("general.cancelCourier"))+" Dr Carmen")])]:_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.tazz_flag && _vm.order.tazz_status !== 0)?[((_vm.order.tazz_status === 1 || _vm.order.tazz_status === 2) && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-info mar-rt-10 call-courier",attrs:{"id":'call-courier-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.tazzCourierCall(_vm.order.id, _vm.order.location_id)}}},[_c('img',{attrs:{"src":"/static/img/icons/fast-delivery.png"}}),_vm._v(" "+_vm._s(_vm.$t("orders.callCourier"))+" TAZZ")]):_vm._e(),_vm._v(" "),((_vm.order.tazz_status === 3 || _vm.order.tazz_status === 4) && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.cancelTazzCourier(_vm.order.id, _vm.order.location_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancelCourier")))]):_vm._e(),_vm._v(" "),(_vm.order.status.id === 'TRANSPORT' || _vm.order.status.id === 'CANCELED' || _vm.order.status.id === 'NOT_DELIVERED')?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-disabled-' + _vm.order.id,"disabled":"disabled"},on:{"click":function($event){$event.preventDefault();_vm.cancelTazzCourier(_vm.order.id, _vm.order.location_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancel")))]):_vm._e(),_vm._v(" "),(_vm.order.tazz_status && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-primary mar-rt-10",staticStyle:{"background":"#674bd2","color":"#fff"},attrs:{"disabled":_vm.order.tazz_status !== 3,"id":'set-prep-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.tazzSetOrderPrepared(_vm.order.id)}}},[_vm._v(_vm._s(_vm.$t("tazz.orderPrepared")))]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.tazz_laas_flag && _vm.order.tazz_laas_status)?[((_vm.order.tazz_laas_status === 1 || _vm.order.tazz_laas_status === 3 || _vm.order.tazz_laas_status === 4) && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-info mar-rt-10 btn-print",attrs:{"id":'call-courier-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.tazzLaasCourierCall(_vm.order.id, _vm.order.location_id)}}},[_c('img',{attrs:{"src":"/static/img/icons/fast-delivery.png"}}),_vm._v(" "+_vm._s(_vm.$t("orders.callTazzLaasCourier")))]):_vm._e(),_vm._v(" "),((_vm.order.tazz_laas_status === 2) && (_vm.order.status.id === 'NEW' || _vm.order.status.id === 'PROCESSING' || _vm.order.status.id === 'PREPARED'))?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-' + _vm.order.id},on:{"click":function($event){$event.preventDefault();_vm.tazzLaasCancelCourierCall(_vm.order.id, _vm.order.location_id)}}},[_vm._v(_vm._s(_vm.$t("general.cancelCourier")))]):_vm._e(),_vm._v(" "),(_vm.order.status.id === 'TRANSPORT' || _vm.order.status.id === 'CANCELED' || _vm.order.status.id === 'NOT_DELIVERED')?_c('button',{staticClass:"btn btn-danger mar-rt-10",attrs:{"id":'cancel-order-disabled-' + _vm.order.id,"disabled":"disabled"}},[_vm._v(_vm._s(_vm.$t("general.cancel")))]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.canShowRefundButton)?_c('button',{staticClass:"btn btn-warning mar-rt-10 noprint btn-print",attrs:{"disabled":_vm.refundLoading || _vm.refundAlreadyDone || _vm.btReturnPending},on:{"click":function($event){$event.preventDefault();return _vm.doRefundOrder($event)}}},[_c('i',{staticClass:"fa fa-undo"}),_vm._v(" "),(_vm.refundAlreadyDone)?[_vm._v(_vm._s(_vm.$t('orders.refundAlreadyDone')))]:(_vm.btReturnPending)?[_vm._v(_vm._s(_vm.$t('btPayments.returnPending')))]:[_vm._v(_vm._s(_vm.$t('orders.refundOrder')))]],2):_vm._e(),_vm._v(" "),(_vm.btReturnPending)?_c('div',{staticClass:"text-warning noprint",attrs:{"role":"status"}},[_vm._v("\n                  "+_vm._s(_vm.$t('btPayments.returnHelp'))+"\n                  "),_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.getData($event)}}},[_vm._v(_vm._s(_vm.$t('btPayments.refresh')))])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-info mar-rt-10 noprint btn-print",on:{"click":function($event){$event.preventDefault();return _vm.printPage($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/print-a4.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('orders.print'))+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info mar-rt-10 noprint btn-print",on:{"click":function($event){$event.preventDefault();return _vm.printToIframe($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/print-a4.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('orders.print2'))+"\n                ")]),_vm._v(" "),_c('download-excel',{staticClass:"btn btn-icon mar-rt-40 btn-xls noprint",attrs:{"fetch":_vm.orderExportData,"fields":_vm.jsonFields,"name":'Comanda ' + _vm.order.id,"before-generate":_vm.startDownload,"before-finish":_vm.finishDownload}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})]),_vm._v(" "),(_vm.showPrintBtn)?_c('button',{staticClass:"btn btn-info noprint mar-rt-10 btn-print",on:{"click":function($event){$event.preventDefault();return _vm.sendToPrinter($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/print-a4.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('orders.printerPrint'))+"\n                ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-info noprint mar-rt-10 btn-print",class:{ 'order-view-payment-type-disabled': _vm.isFiscalized() },attrs:{"disabled":_vm.isFiscalized()},on:{"click":function($event){$event.preventDefault();return _vm.printFiscal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/print-a4.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('orders.printFiscal'))+"\n                ")])],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 posunset"},[_c('div',{staticClass:"card hightfixed posunset noprint"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row noprint"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-sm-8"},[_c('h6',{staticClass:"noprint"},[_vm._v("\n                        "+_vm._s(_vm.$t('orders.updateStatus'))+"\n                        "),(_vm.order && _vm.order.payment_type)?_c('span',{staticStyle:{"color":"red","margin-left":"10px"}},[_vm._v("\n                          "+_vm._s(_vm.order.payment_type)+"\n                          "),(_vm.order.transaction_type_id)?_c('span',[_vm._v("\n                            ("+_vm._s(_vm.order.transaction_type_id)+")\n                          ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),(_vm.order.status.id == 'NEW' || _vm.order.status.id == 'PROCESSING')?_c('div',{staticClass:"col-sm-4",staticStyle:{"text-align":"right"}},[_c('button',{staticClass:"btn btn-default edit",on:{"click":function($event){_vm.editOrderNow()}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("\n                        "+_vm._s(_vm.$t('orders.editOrder'))+"\n                      ")])]):_vm._e()]),_vm._v(" "),_c('hr',{staticClass:"noprint",staticStyle:{"clear":"both"}})])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-15 sticky-order-view-header noprint"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left status-line pad-to-10 order-buttons resize-method overflow-container"},[_vm._l((_vm.orderStatuses),function(sts,i){return [_c('button',{staticClass:"btn btn-status-margin tablet-overflow ",class:(sts.type === 'NOT_DELIVERED' ? 'not-delivered-button' : '') + ' ' + (sts.type === 'CANCELED' ? 'canceled-button' : '') + ' ' + _vm.classForBtn + ' ' + ((_vm.currentOrdersStatus === sts.type ) ? sts.type : '') + ' ' +'mr-1-rem current btn-' + _vm.orderStatusClass(sts.type),attrs:{"disabled":(!sts.isAllowed || _vm.order.is_refunded === 1 || _vm.btStatusBlocked(sts.type)) || _vm.deliveredStatusValidation(sts)},on:{"click":function($event){$event.preventDefault();_vm.changeStatusFromButtons(sts.type)}}},[_vm._v("\n                        "+_vm._s(_vm.changeDeliveryStatusForLabel(sts.type))+"\n                        ")])]})],2),_vm._v(" "),_c('div',{staticClass:"pull-right",staticStyle:{"display":"inline-flex"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentOrdersStatus),expression:"currentOrdersStatus"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentOrdersStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){$event.preventDefault();return _vm.changeStatus($event)}]}},_vm._l((_vm.orderStatuses),function(sts,i){return _c('option',{attrs:{"disabled":(!sts.isAllowed || _vm.order.is_refunded === 1 || _vm.btStatusBlocked(sts.type)) || _vm.deliveredStatusValidation(sts)},domProps:{"value":sts.type}},[_vm._v("\n                              "+_vm._s(_vm.changeDeliveryStatusForLabel(sts.type))+"\n                            ")])}))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content mar-15"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 mar-bt-20"},[_c('div',{staticClass:"pull-left print-lg-font"},[_c('img',{staticClass:"mar-rt-5",attrs:{"src":"/static/img/icons/icon-shopping-cart.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('orders.single'))+"\n                    "),_c('span',{staticStyle:{"text-transform":"none","font-weight":"600"}},[_vm._v("#"+_vm._s(_vm.order.token))]),_vm._v(" "),_c('span',{staticStyle:{"margin-right":"20px","margin-left":"20px"}},[_vm._v("ID: "+_vm._s(_vm.order.id))]),_vm._v(" "),(_vm.order.app_id)?_c('span',{staticStyle:{"margin-right":"20px"}},[_vm._v("App ID: "+_vm._s(_vm.order.app_id))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.$t('orders.ordDetails')))]),_vm._v(" "),(_vm.order.check_in)?_c('h6',{staticStyle:{"display":"flex","align-items":"center","width":"auto","padding-left":"30px","color":"#5e35b1"}},[_vm._v("Checked")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row display-flex resized-min-width-1600 box-bg-white"},[_c('div',{staticClass:"col-md-6 col-print-6"},[(_vm.order && _vm.order.production_details && _vm.order.production_details.location)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('orders.ordLocation')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.order.production_details ? _vm.order.production_details.location.name : '-'))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6"},[_vm._v(_vm._s(_vm.$t('orders.date')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"},[_c('span',[_vm._v(_vm._s(_vm.formatDate(_vm.order.created_at)))])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6"},[_vm._v(_vm._s(_vm.$t('orders.madeAt')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"},[_c('span',[_vm._v(_vm._s(_vm.formatTime(_vm.order.created_at)))])])]),_vm._v(" "),(_vm.order.delivery_type !== 'EAT_LOCATION' && _vm.order.delivery_type !== 'SELF_ORDERING')?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6 text-color-red"},[_c('span',{staticStyle:{"font-size":"larger"}},[_vm._v(_vm._s(_vm.$t('orders.pickupTime')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"},[(!(_vm.order.just_date == 1))?[_c('div',{staticStyle:{"margin-right":"10px","display":"inline-block"}},[_c('el-time-picker',{staticClass:"in-inline-120",attrs:{"disabled":true,"arrow-control":"","value-format":_vm.timeFormat,"format":_vm.timeFormat,"placeholder":"Select time"},model:{value:(_vm.order.formatted_pickup_datetime),callback:function ($$v) {_vm.$set(_vm.order, "formatted_pickup_datetime", $$v)},expression:"order.formatted_pickup_datetime"}})],1)]:_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"background":"#fff","border":"1px solid #7C8DB5","font-size":"14px","padding":"12px 10px","border-radius":"6px","display":"inline-block","cursor":"not-allowed"}},[_vm._v(_vm._s(_vm.order.formatted_date_pickup_datetime))])],2)]):_vm._e(),_vm._v(" "),(_vm.order.delivery_type == 'EAT_LOCATION')?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6 text-color-red"},[_c('span',{staticStyle:{"font-size":"larger"}},[_vm._v(_vm._s(_vm.$t('orders.reservationTime')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 "},[_c('span',[_vm._v(_vm._s(_vm.formatDate(_vm.order.pickup_datetime))+" "+_vm._s(_vm.formatTime(_vm.order.pickup_datetime)))])])]):_vm._e(),_vm._v(" "),(!(_vm.order.just_date == 1))?[(_vm.order.delivery_type !== 'EAT_LOCATION' && _vm.order.delivery_type !== 'SELF_ORDERING')?[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6"}),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 order-delivery-time-buttons justify-space-evenly pad-lf-0"},[_vm._l((_vm.orderTimeDelivery()),function(min){return [_c('button',{staticClass:"btn btn-info btn-icon noprint mr-1-rem hour-button",attrs:{"disabled":_vm.order.status && _vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(min, 'add')}}},[_vm._v("+"+_vm._s(min)+"m")])]})],2)]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label pad-to-10 col-print-6"}),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6 order-delivery-time-buttons justify-space-evenly pad-lf-0"},[_c('button',{staticClass:"btn btn-danger btn-icon noprint mr-1-rem hour-button",staticStyle:{"width":"47px"},attrs:{"disabled":_vm.order.status && _vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(5, 'sub')}}},[_vm._v("-5m")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon noprint mr-1-rem hour-button",staticStyle:{"width":"51px"},attrs:{"disabled":_vm.order.status && _vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(15, 'sub')}}},[_vm._v("-15m")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon noprint mr-1-rem hour-button",staticStyle:{"width":"54px"},attrs:{"disabled":_vm.order.status && _vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(30, 'sub')}}},[_vm._v("-30m")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon noprint mr-1-rem hour-button",staticStyle:{"width":"54px"},attrs:{"disabled":_vm.order.status && _vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(45, 'sub')}}},[_vm._v("-45m")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon noprint mr-1-rem hour-button",staticStyle:{"width":"55px"},attrs:{"disabled":_vm.order.status && _vm.order.status.id === 'DELIVERED',"title":_vm.$t('general.save')},on:{"click":function($event){_vm.automatUpdateHour(55, 'sub')}}},[_vm._v("-60m")])])])]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.order.user_labeling)?[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6"},[_vm._v(_vm._s(_vm.$t('orders.note')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"},[(_vm.order.user_labeling)?[_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.convetLabelingJson(_vm.order.user_labeling)))])]:_vm._e()],2)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-print-6",attrs:{"_style":"padding-right: 0px !important;"}},[_c('div',{staticClass:"height-70-percent"},[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.payment')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6"},[_c('span',{style:((_vm.order.payment_type == 'CARD' ? 'color:#7AC29A; font-size:larger;' : ''))},[_vm._v(_vm._s(_vm.$t('paymentTypes.' + _vm.order.payment_type)))]),_vm._v(" "),(_vm.order.payment_type === 'CARD' && _vm.order.is_refunded === 0)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.getPaymetnStatus(_vm.order.capture_transaction_status))}}):_vm._e(),_vm._v(" "),(_vm.order.payment_id === 'btIpay')?_c('div',{staticClass:"help-block noprint"},[_c('strong',[_vm._v("BT iPay")]),_vm._v(" — "+_vm._s(_vm.$t('btPayments.captureHelp'))+"\n                          "),_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.getData($event)}}},[_vm._v(_vm._s(_vm.$t('btPayments.refresh')))])]):_vm._e(),_vm._v(" "),(_vm.order.payment_type === 'CARD' && _vm.order.is_refunded === 1)?_c('span',[_vm._v("\n                          - "),_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('orders.amountRefunded')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_c('small',[_vm._v(_vm._s(_vm.$t('orders.amountIntegralRefunded')))])])]):_vm._e()])]),_vm._v(" "),(_vm.order.payment_type == 'ROOM' && _vm.order.integration)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.roomNumber')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6"},[_c('span',[[_vm._v(_vm._s(_vm.order.integration.clock_pms_room_number))]],2)])]):_vm._e(),_vm._v(" "),(_vm.order.flags && _vm.order.flags.pager_number)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.pagerNumber')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6"},[_c('span',[_vm._v(_vm._s(_vm.order.flags.pager_number))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('general.deliveryMethod')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6"},[_c('span',[(_vm.order.company_id === 31 && _vm.order.delivery_type === 'MEET_HALF')?[_vm._v("Due Drive")]:_vm._e(),_vm._v(" "),(_vm.order.company_id === 46 && _vm.order.delivery_type === 'MEET_HALF')?[_vm._v("Yumm Drive")]:[_vm._v(_vm._s(_vm.$t('deliveryTypes.' + _vm.order.delivery_type)))]],2)])]),_vm._v(" "),(_vm.order.delivery_type == 'MEET_HALF')?_c('div',{staticClass:"row pad-bt-10"},[(_vm.order.company.is_allowed_on_hold)?[(_vm.order.check_in)?[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6"},[_vm._v(_vm._s(_vm.$t('orders.meetupLocation')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"},[_c('span',[_vm._v(_vm._s(_vm.order.delivery_details ? _vm.order.delivery_details.location.name : ''))])])]:_vm._e()]:[_c('div',{staticClass:"col-lg-5 col-sm-6 col-md-6 col-xs-12 details-label col-print-6"},[_vm._v(_vm._s(_vm.$t('orders.meetupLocation')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 col-print-6"},[_c('span',[_vm._v(_vm._s(_vm.order.delivery_details ? _vm.order.delivery_details.location.name : ''))])])]],2):_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'EAT_LOCATION')?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.reservationSeats')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6"},[_c('span',[_vm._v(_vm._s(_vm.order.delivery_details ? _vm.order.delivery_details.how_many : '-'))])])]):_vm._e(),_vm._v(" "),(_vm.order.order_from)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('addOrder.tags')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6"},[_c('span',[(_vm.order.delivery_type === 'SELF_ORDERING')?[_vm._v(_vm._s(_vm.order.order_from))]:[_vm._v(_vm._s(_vm.$t('addOrder.' + _vm.order.order_from)))]],2)])]):_vm._e(),_vm._v(" "),(_vm.order.table_data && _vm.order.delivery_type === 'EAT_LOCATION')?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('addOrder.fromTable')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6"},[_c('span',[(_vm.order.table_data['type'])?_c('span',[_vm._v(_vm._s(_vm.order.table_data['type']))]):_vm._e(),_vm._v(" "),(_vm.order.table_data['zone'])?_c('span',[_vm._v(_vm._s(_vm.order.table_data['zone']))]):_vm._e(),_vm._v(" "),(_vm.order.table_data['number'])?_c('span',[_vm._v(_vm._s(_vm.order.table_data['number']))]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.order.expressoft_id)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.expresoftStatus')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[(_vm.order.expressoft_id == 'in_queue')?_c('span',[_vm._v(_vm._s(_vm.$t('orders.expresoftQueue')))]):_vm._e(),_vm._v(" "),(_vm.order.expressoft_id == 'error')?_c('span',{staticClass:"text-color-red edit-icon-pointer",on:{"click":function($event){_vm.showExpressoftError()}}},[_vm._v(_vm._s(_vm.$t('orders.expresoftError')))]):_vm._e(),_vm._v(" "),(_vm.order.expressoft_id && _vm.order.expressoft_id != 'in_queue' && _vm.order.expressoft_id != 'error')?_c('span',{attrs:{"data-expressoft_id":_vm.order.expressoft_id}},[_vm._v(_vm._s(_vm.$t('orders.expresoftSuccess')))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.order.freya_status)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.freyaStatus')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.freyaStatus' + _vm.order.freya_status)))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"}),_vm._v(" "),(_vm.order.freya_status === 3)?_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 text-color-red"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.freyaSendAgain')))]),_c('i',{staticClass:"fa fa-repeat",on:{"click":function($event){_vm.resendOrderToFreya(_vm.order.id)}}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.order.rkeeper_status)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.rkeeperStatus')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.freyaStatus' + _vm.order.rkeeper_status)))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"}),_vm._v(" "),(_vm.order.rkeeper_status === 3)?_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12 text-color-red"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.freyaSendAgain')))]),_c('i',{staticClass:"fa fa-repeat",on:{"click":function($event){_vm.resendOrderToRKeeper(_vm.order.id)}}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.order.magister_status)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('magister.magisterStatus')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.$t('magister.magisterStatus' + _vm.order.magister_status)))])])]):_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.glovo_flag)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.glovoStatus')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[(!_vm.order.glovo_logs)?[_c('span',[_vm._v(_vm._s(_vm.$t('orders.courierStatus1')))])]:[_c('span',{class:_vm.order.glovo_status === 4 ? 'company-text' : ''},[_vm._v(_vm._s(_vm.$t('orders.courierStatus' + _vm.order.glovo_status)))])],_vm._v(" "),_c('i',{staticClass:"fa fa-eye mar-lt-5",staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$t('orders.glovoLaasEvents')},on:{"click":function($event){$event.preventDefault();_vm.getGlovoLaasWebhookLogs(_vm.order.id)}}})],2)]):_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.integration && _vm.order.integration.wolt_drive_status)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.woltDriveStatus')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[_c('span',{class:_vm.order.integration.wolt_drive_status === 4 ? 'company-text' : ''},[_vm._v(_vm._s(_vm.$t('orders.courierStatus' + _vm.order.integration.wolt_drive_status)))]),_vm._v(" "),_c('i',{staticClass:"fa fa-eye mar-lt-5",staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$t('orders.woltDriveEvents')},on:{"click":function($event){$event.preventDefault();_vm.getWoltDriveWebhookLogs(_vm.order.id)}}})])]):_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.delivery_hero_flag)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.deliveryHeroStatus')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[_c('span',{class:_vm.deliveryHeroStatus === 4 ? 'company-text' : ''},[_vm._v(_vm._s(_vm.$t('orders.courierStatus' + (_vm.deliveryHeroStatus || 1))))]),_vm._v(" "),_c('i',{staticClass:"fa fa-eye mar-lt-5",staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$t('orders.deliveryHeroEvents')},on:{"click":function($event){$event.preventDefault();_vm.getDeliveryHeroWebhookLogs(_vm.order.id)}}})])]):_vm._e(),_vm._v(" "),(_vm.order.delivery_type === 'DELIVERY' && _vm.order.boogit_flag && _vm.order.boogit_status)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('boogit.boogitStatus')))]),_vm._v(" "),(!_vm.order.boogit_logs)?[_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('boogit.boogitStatus1')))])])]:[_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('boogit.boogitStatus' + _vm.order.boogit_status)))])])]],2):_vm._e(),_vm._v(" "),(_vm.order.company && _vm.order.company.print_fiscal_from_dashboard)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.receipt')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[(_vm.order.receipt_number)?_c('span',[_vm._v(_vm._s(_vm.$t('orders.printedReceipt')))]):_vm._e(),_vm._v(" "),(!_vm.order.receipt_number)?_c('span',[_vm._v(_vm._s(_vm.$t('orders.notPrintedReceipt')))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[(_vm.order.comments)?[_vm._v(_vm._s(_vm.$t('orders.custComments')))]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-xs-12 col-print-6 ",class:_vm.order.comments ? 'text-danger' : ''},[(_vm.order.comments)?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.order.comments || '<small>'+_vm.$t('orders.none')+'</small>')}})]:_vm._e()],2)]),_vm._v(" "),(_vm.order.cancel_order_reason)?[_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-5 col-sm-6 col-xs-12 col-print-6 details-label"},[_vm._v(_vm._s(_vm.$t('orders.cancel_order_reason')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-7 col-sm-5 col-md-6 col-xs-12"},[_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.order.cancel_order_reason))])])])]:_vm._e()],2)])])])])]),_vm._v(" "),(_vm.order.customer && _vm.order.customer.email && !_vm.order.customer.email.includes('@tableTapTasty.com'))?_c('div',{staticClass:"col-md-12 col-print-12",staticStyle:{"display":"flex","justify-content":"space-between","margin-bottom":"20px","padding":"0"}},[_c('div',{class:(_vm.order.delivery_type == 'DELIVERY' && _vm.order.address && _vm.order.address.shipping ? 'col-md-6 col-print-6' : 'col-md-12 col-print-12')},[_c('div',{staticClass:"card",staticStyle:{"margin":"auto","height":"100%"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',{staticClass:"mar-to-0"},[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/user-sm.png"}}),_vm._v("  "+_vm._s(_vm.$t('orders.custDetails')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-4 col-sm-3 col-xs-12"},[_c('div',{class:{ 'company-text': _vm.order.billing_data }},[_vm._v("\n                      "+_vm._s(_vm.order.billing_data ? _vm.$t('orders.legalPerson') : _vm.$t('orders.individual'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-3 col-sm-3 col-xs-12 details-label"},[_c('div',[_vm._v(_vm._s(_vm.$t('customers.name')))])]),_vm._v(" "),(_vm.order.delivery_details_firstname)?_c('div',{staticClass:"col-lg-6 col-sm-8 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.order.delivery_details_firstname)+" ")])]):_c('div',{staticClass:"col-lg-6 col-sm-8 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.order.customer ? _vm.order.customer.firstname : '')+" "+_vm._s(_vm.order.customer ? _vm.order.customer.lastname : ''))])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-3 col-sm-3 col-xs-12 details-label"},[_c('div',[_vm._v(_vm._s(_vm.$t('customers.email')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-8 col-xs-12",on:{"click":function($event){_vm.copyToClipboard(_vm.order.customer ? _vm.order.customer.email : '')}}},[_c('span',[_vm._v(_vm._s(_vm.order.customer ? _vm.order.customer.email : ''))])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-3 col-sm-3 col-xs-12 details-label"},[_c('div',[_vm._v(_vm._s(_vm.$t('customers.phone')))])]),_vm._v(" "),(_vm.order.delivery_details_phone)?_c('div',{staticClass:"col-lg-7 col-sm-8 col-xs-12",on:{"click":function($event){_vm.copyToClipboard(_vm.order.delivery_details_phone)}}},[_c('span',[_vm._v(_vm._s(_vm.order.delivery_details_phone))])]):_c('div',{staticClass:"col-lg-6 col-sm-8 col-xs-12",on:{"click":function($event){_vm.copyToClipboard((_vm.order.customer && _vm.order.customer.phone) ? _vm.order.customer.phone : '-')}}},[_c('span',[_vm._v(_vm._s((_vm.order.customer && _vm.order.customer.phone) ? _vm.order.customer.phone : '-'))])])]),_vm._v(" "),(_vm.order.country_code || _vm.order.country_prefix)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-3 col-sm-3 col-xs-12 details-label"},[_c('div',[_vm._v(_vm._s(_vm.$t('orders.orderCountryPrefix')))])]),_vm._v(" "),(_vm.order.country_code)?_c('div',{staticClass:"col-lg-6 col-sm-8 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.order.country_code))]),_vm._v(" "),(_vm.order.country_code && _vm.order.country_prefix)?_c('span',[_vm._v(",")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("+"+_vm._s(_vm.order.country_prefix))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.order.customer.comment)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-3 col-sm-3 col-xs-12 details-label"},[_c('div',[_vm._v(_vm._s(_vm.$t('customers.commentsLabel')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-8 col-xs-12",on:{"click":function($event){_vm.copyToClipboard(_vm.order.customer ? _vm.order.customer.comment : '')}}},[_c('p',[_c('span',[_vm._v(_vm._s(_vm.order.customer ? _vm.order.customer.comment : ''))])])])]):_vm._e(),_vm._v(" "),(_vm.order.billing_data)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-3 details-label"},[_c('b',{staticClass:"company-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('orders.billingInfo'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-8 col-xs-12",on:{"click":function($event){_vm.copyToClipboard(_vm.order.customer ? _vm.order.billing_data : '')}}},[_c('p',{staticStyle:{"color":"red"}},[_c('b',[_vm._v(_vm._s(_vm.order.billing_data ? _vm.order.billing_data : ''))])])])]):_vm._e(),_vm._v(" "),(_vm.order.smartbill_is_active && _vm.order.billing_data)?_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-3 details-label"},[_c('b',{staticClass:"company-text"},[_vm._v("\n                      "+_vm._s(_vm.$t('paymentPage.invoice'))+"\n                    ")])]),_vm._v(" "),(_vm.order.billing_data && _vm.order.status.id === 'DELIVERED')?_c('div',{staticClass:"col-lg-6 col-sm-8 col-xs-12"},[_c('p',[_c('a',{attrs:{"href":this.apiUrl + 'open-order-invoice?token=' + this.$session.get('token') + '&order_id=' + this.order.id,"target":"_blank"}},[_vm._v("Vezi factura")])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.order.smartbill_is_active && !_vm.order.smartbill_send_auto && _vm.order.billing_data)?_c('div',{staticClass:"col-lg-12 col-sm-11 col-xs-12 col-print-6 justify-content-flex-end display-inline-flex mar-bt-15"},[_c('button',{staticClass:"btn btn-info noprint",attrs:{"disabled":!(_vm.order.status.id === 'DELIVERED')},on:{"click":function($event){$event.preventDefault();_vm.emitInvoice()}}},[_c('i',{staticClass:"fa fa-print print-icon"}),_vm._v("\n                    "+_vm._s(_vm.$t('settingCompany.sendInvoice'))+"\n                  ")])]):_vm._e()])])]),_vm._v(" "),(_vm.order.delivery_type == 'DELIVERY' && _vm.order.glovo_status != 5 && _vm.order.address && _vm.order.address.shipping)?[_c('div',{staticClass:"col-md-6 col-print-6"},[_c('div',{staticClass:"card address-box",staticStyle:{"margin":"auto","height":"100%"}},[_c('div',{staticClass:"card-content"},[_c('h6',[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/icon-address.png"}}),_vm._v(" "+_vm._s(_vm.$t('orders.shipping')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"address-content"},[_c('b',[_vm._v(_vm._s(_vm.order.address.shipping.address_name ? _vm.order.address.shipping.address_name : ''))]),_c('br'),_vm._v(_vm._s(_vm.order.address.shipping.street ? _vm.order.address.shipping.street : '')+" "+_vm._s(_vm.order.address.shipping.number ? _vm.order.address.shipping.number : '')+", "+_vm._s(_vm.order.address.shipping.apartment ? _vm.order.address.shipping.apartment : '')),_c('br'),_vm._v("\n                      "+_vm._s(_vm.order.address.shipping.city ? _vm.order.address.shipping.city : '')+",\n                      "+_vm._s(_vm.order.address.shipping.state ? _vm.order.address.shipping.state : '')),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.order.address.shipping.country),expression:"order.address.shipping.country"}]},[_vm._v(_vm._s(_vm.order.address.shipping.country ? _vm.order.address.shipping.country : '')),_c('br')]),_vm._v("\n                      "+_vm._s(_vm.order.address.shipping.other_info ? _vm.order.address.shipping.other_info : '')+"\n\n                  ")])])])])]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{},[_c('table',{staticClass:"table orders-table orders-table--items"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('orders.name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.category')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('orders.qty')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('orders.unit_price')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('orders.totals_discount')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('orders.total')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.order.parts),function(customer){return [(customer.is_open_order && _vm.order.order_type=='GROUP')?_c('tr',{staticClass:"active"},[_c('td',{attrs:{"colspan":"4"}},[_vm._v(_vm._s(_vm.$t('customers.single'))+": "+_vm._s(customer.customer_name))]),_vm._v(" "),(_vm.order.is_split_pay)?_c('td',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.$t('customers.pay'))+":\n                        "),(customer.payment_type)?_c('span',[_vm._v(_vm._s(_vm.$t('paymentTypes.' + (customer.payment_type).toUpperCase() )))]):(customer.is_open_order)?_c('span',[_vm._v("-Open-")]):_c('span',[_vm._v("-Pending-")])]):_vm._e()]):_vm._e(),_vm._v(" "),(!customer.is_open_order)?[_vm._l((_vm.getPartItems(customer)),function(prod,prodIndex){return [(
                          _vm.order.status.id != 'OPEN_DRAFT' ||
                          (
                            _vm.order.status.id == 'OPEN_DRAFT' &&
                            (prod.hasOwnProperty('status') && prod.status != 'Draft')
                          )
                        )?[_c('tr',{key:'p-' + (prod.id || prodIndex),staticClass:"orders-table__item-row",class:{ 'orders-table__item-row--has-options': _vm.getItemOptions(prod).length }},[_c('td',{staticClass:"orders-table__name"},[_vm._v("\n                              "+_vm._s(prod.name)+"\n                              "),(_vm.getItemAdditionalInfo(prod))?_c('div',{staticClass:"pad-to-10"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.custComments'))+": "),_c('i',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getItemAdditionalInfo(prod)))])])]):_vm._e(),_vm._v(" "),(prod.comment_image)?_c('div',[_c('a',{attrs:{"href":prod.comment_image,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('orders.seeImage')))])]):_vm._e(),_vm._v(" "),(prod.created_at)?_c('div',{staticClass:"orders-table__meta"},[_vm._v(_vm._s(_vm.formatToCompanyTimezone(prod.created_at)))]):_vm._e()]),_vm._v(" "),_c('td',[(_vm.getItemCategoryName(prod))?_c('span',[_vm._v(_vm._s(_vm.getItemCategoryName(prod)))]):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(prod.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.getItemUnitPrice(prod), _vm.currency)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"order-item-discount-badge"},[_vm._v(_vm._s(_vm.formatMoneyAmount(prod.discount || 0, _vm.currency)))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.getProductOnlyLineTotal(prod), _vm.currency)))])])]),_vm._v(" "),_vm._l((_vm.getItemOptions(prod)),function(opt,optIndex){return _c('tr',{key:'o-' + (prod.id || prodIndex) + '-' + (opt.id || optIndex),staticClass:"orders-table__option-row",class:{ 'orders-table__option-row--last': optIndex === _vm.getItemOptions(prod).length - 1 }},[_c('td',{staticClass:"orders-table__option-name"},[_vm._v("+ "+_vm._s(opt.name))]),_vm._v(" "),_c('td',[_vm._v("-")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.getOptionQuantity(opt)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.getOptionUnitPrice(opt), _vm.currency)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"order-item-discount-badge"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.getOptionDiscount(opt), _vm.currency)))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.getOptionLineTotal(prod, opt), _vm.currency)))])])})]:_vm._e()]})]:[_c('tr')],_vm._v(" "),((!_vm.order.is_split_pay && _vm.order.order_type=='GROUP') || (_vm.order.is_split_pay && customer.payment_type) || customer.is_open_order)?_c('tr',[_c('td',{attrs:{"colspan":"6"}},[_vm._v(_vm._s(_vm.$t('customers.singleTotal'))+" "),_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(customer.total_cart_price, _vm.currency)))])])]):_vm._e()]})],2)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-md-5 order-comment"}),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[(_vm.order.status.id != 'OPEN_DRAFT')?_c('table',{staticClass:"table no-border totals-table"},[_c('tbody',[_vm._l((_vm.totals),function(label){return [((label != 'totals_grandtotal' || label != 'totals_shipping') && _vm.checkEmailTrnsport(_vm.order))?[(label == 'totals_grandtotal' || _vm.order[label] > 0)?_c('tr',{class:_vm.getRowClass(label)},[_c('td',[(label == 'SGR')?_c('span',[_vm._v(_vm._s(label))]):_vm._e(),_vm._v(" "),(label != 'totals_extras')?_c('span',[_vm._v(_vm._s(_vm.$t('orders.' + label)))]):(_vm.$t('orders.' + label + '_' + _vm.order.company_id) != 'orders.' + label + '_' + _vm.order.company_id)?_c('span',[_vm._v("\n                              "+_vm._s(_vm.$t('orders.' + label + '_' + _vm.order.company_id))+"\n                            ")]):_c('span',[_vm._v(_vm._s(_vm.$t('orders.' + label)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(label == 'totals_discount'),expression:"label == 'totals_discount'"}]},[_vm._v("(Coupon: "+_vm._s(_vm.coupon)+")")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                            "+_vm._s(_vm.formatMoneyAmount(_vm.order[label], _vm.currency, true))+"\n                            "),(_vm.editOrderFlag)?_c('span',[(label == 'totals_grandtotal')?_c('button',{staticClass:"btn btn-default btn-icon",on:{"click":function($event){_vm.editOrderPrice(_vm.order.id)}}},[_c('i',{staticClass:"fa fa-pencil"})]):_vm._e(),_vm._v(" "),(label == 'totals_grandtotal' && _vm.order.edit_order_history && _vm.order.edit_order_history.length)?_c('div',[_c('small',{staticClass:"order_history_message"},[_vm._v(_vm._s(_vm.order.edit_order_history[0].reason))])]):_vm._e()]):_vm._e()])]):_vm._e(),_vm._v(" "),(label === 'totals_subtotals')?_vm._l((_vm.slotTaxes),function(tax){return _c('tr',{key:tax.id,class:_vm.getRowClass('totals_extras')},[_c('td',[_vm._v(_vm._s(tax.name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                              "+_vm._s(_vm.formatMoneyAmount(tax.tax_amount, _vm.currency, true))+"\n                            ")])])}):_vm._e()]:_vm._e()]}),_vm._v(" "),_vm._l((_vm.order.sgr_totals),function(sgrDetails,index){return [(sgrDetails.value > 0)?_c('tr',{class:_vm.getRowClass('totals_extras')},[_c('td',[_c('span',[_vm._v(_vm._s(index))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                            "+_vm._s(_vm.formatMoneyAmount(sgrDetails.value, _vm.currency, true))+"\n                          ")])]):_vm._e()]}),_vm._v(" "),_c('tr',{class:_vm.getRowClass('totals_grandtotal')},[_c('td',[_c('span',[_vm._v(_vm._s(_vm.$t('orders.totals_grandtotal')))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        "+_vm._s(_vm.formatMoneyAmount(_vm.order['totals_grandtotal'], _vm.currency, true))+"\n                        "),(_vm.editOrderFlag)?_c('span',[_c('button',{staticClass:"btn btn-default btn-icon edit",on:{"click":function($event){_vm.editOrderPrice(_vm.order.id)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("\n                            "+_vm._s(_vm.$t('general.edit'))+"\n                          ")]),_vm._v(" "),(_vm.order.edit_order_history && _vm.order.edit_order_history.length)?_c('div',[_c('small',{staticClass:"order_history_message"},[_vm._v(_vm._s(_vm.order.edit_order_history[0].reason))])]):_vm._e()]):_vm._e()])])],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-md-12 noprint"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h6',[_c('img',{staticClass:"pad-rg-5",attrs:{"src":"/static/img/icons/commentClient-sm.png"}}),_vm._v("  "+_vm._s(_vm.$t('orders.adminComments')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.backoffice_comments),expression:"order.backoffice_comments"}],staticClass:"form-control",attrs:{"placeholder":_vm.$t('orders.none'),"rows":"5"},domProps:{"value":(_vm.order.backoffice_comments)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.order, "backoffice_comments", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-icon btn-success noprint save",attrs:{"title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.saveComment($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.save'))+"\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.order.payment_type === 'CARD_POS' && _vm.order.capture_transaction_response)?[_c('div',{staticClass:"col-md-12 col-print-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h6',[_c('img',{staticClass:"pad-rg-5",attrs:{"src":"/static/img/icons/pos_response.png"}}),_vm._v("  "+_vm._s(_vm.$t('orders.pos_response_title')))]),_vm._v(" "),_c('textarea',{staticClass:"form-control capture_transaction_response_string",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.capture_transaction_response_string))])])])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.order.receipt_number)?[_c('div',{staticClass:"col-md-12 col-print-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h6',[_c('img',{staticClass:"pad-rg-5",attrs:{"src":"/static/img/icons/pos_response.png"}}),_vm._v("  "+_vm._s(_vm.$t('orders.fiscal_response_title')))]),_vm._v(" "),_c('textarea',{staticClass:"form-control capture_transaction_response_string",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.receipt_number_string))])])])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.order.ep_restaurant_log)?[_c('div',{staticClass:"col-md-12 col-print-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"flex-space-between"},[_c('h6',[_c('img',{staticClass:"pad-rg-5",attrs:{"src":"/static/img/icons/comment.png"}}),_vm._v("  "+_vm._s(_vm.$t('orders.orderNoArticulate')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-info btn-icon",on:{"click":function($event){$event.preventDefault();return _vm.sendOrderToEpRestaurant($event)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('marketingCampaigns.send'))+"\n                      ")])]),_vm._v(" "),_c('textarea',{staticClass:"form-control capture_transaction_response_string",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.order.ep_restaurant_log.data_to))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h6',[_c('img',{staticClass:"pad-rg-5",attrs:{"src":"/static/img/icons/comment.png"}}),_vm._v("  "+_vm._s(_vm.$t('feedback.response')))]),_vm._v(" "),_c('textarea',{staticClass:"form-control capture_transaction_response_string",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.order.ep_restaurant_log.data_from))])])])])])])]:_vm._e()],2)])]):_vm._e(),_vm._v(" "),_c('iframe',{staticStyle:{"display":"none"},attrs:{"id":"print-frame"}}),_vm._v(" "),_c('vmodal',{staticClass:"paymentModal",attrs:{"name":"paymentModal","title":"paymentModal","width":"70%","maxWidth":800,"minWidth":700,"height":"400px","adaptive":true}},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.$t('orders.type'))+" "+_vm._s(_vm.$t('orders.payment')))])]),_vm._v(" "),_c('div',{staticClass:"content-order-view"},[_c('div',{staticClass:"content_scrool"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"order_price"}},[_vm._v(_vm._s(_vm.$t('orders.cui')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cui),expression:"cui"}],staticClass:"form-control",attrs:{"type":"text","name":"cui"},domProps:{"value":(_vm.cui)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cui=$event.target.value}}})])])]),_vm._v(" "),[_c('div',{staticClass:"paymentModal__footer"},[_c('button',{staticClass:"payment-type-button",on:{"click":function($event){_vm.processPrinter(1)}}},[_vm._v(_vm._s(_vm.$t('orders.cash')))]),_vm._v(" "),_c('button',{staticClass:"payment-type-button",on:{"click":function($event){_vm.processPrinter(8)}}},[_vm._v(_vm._s(_vm.$t('orders.card_no_pos')))]),_vm._v(" "),_c('button',{staticClass:"payment-type-button",on:{"click":function($event){_vm.processPrinter(2)}}},[_vm._v(_vm._s(_vm.$t('orders.card')))]),_vm._v(" "),_c('button',{staticClass:"payment-type-button",on:{"click":function($event){_vm.processPrinter(7)}}},[_vm._v(_vm._s(_vm.$t('orders.online')))]),_vm._v(" "),_c('button',{staticClass:"payment-type-button",on:{"click":function($event){_vm.processPrinter(11)}}},[_vm._v(_vm._s(_vm.$t('orders.GLOVO')))]),_vm._v(" "),_c('button',{staticClass:"payment-type-button",on:{"click":function($event){_vm.processPrinter(12)}}},[_vm._v(_vm._s(_vm.$t('orders.BOLT')))]),_vm._v(" "),_c('button',{staticClass:"payment-type-button",on:{"click":function($event){_vm.processPrinter(13)}}},[_vm._v(_vm._s(_vm.$t('orders.WOLT')))]),_vm._v(" "),_c('button',{staticClass:"payment-type-button cancel-fiscal-print",on:{"click":function($event){_vm.closePaymentModal()}}},[_vm._v(_vm._s(_vm.$t('orders.cancel')))])])]],2),_vm._v(" "),_c('vmodal',{staticClass:"editPriceModal",attrs:{"name":"editPriceModal","title":"editPriceModal","width":"70%","height":"65%","maxWidth":800,"minWidth":200,"adaptive":true}},[_c('div',{staticClass:"header border-bottom"},[_c('h4',[_vm._v(_vm._s(_vm.$t('general.edit')))])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"content-order-view"},[_c('div',{staticClass:"content_scrool"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"order_price"}},[_vm._v(_vm._s(_vm.$t('catalogProd.price')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.groupValidations.order_price),expression:"groupValidations.order_price"},{name:"model",rawName:"v-model",value:(_vm.editOrder.price),expression:"editOrder.price"}],staticClass:"form-control",attrs:{"type":"text","name":"order_price","id":"order_price"},domProps:{"value":(_vm.editOrder.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editOrder, "price", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('order_price'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('order_price'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"reason"}},[_vm._v(_vm._s(_vm.$t('orders.cancelReason')))]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.groupValidations.reason),expression:"groupValidations.reason"},{name:"model",rawName:"v-model",value:(_vm.editOrder.reason),expression:"editOrder.reason"}],staticClass:"form-control",attrs:{"type":"text","name":"reason","id":"reason"},domProps:{"value":(_vm.editOrder.reason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editOrder, "reason", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('reason'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('reason'))+"\n              ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"editPriceModal__footer"},[_c('p',{staticClass:"d-inline-flex"},[_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){_vm.$modal.hide('editPriceModal')}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.delete'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n            ")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U/ZW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U0qm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaiterTipsReport_vue__ = __webpack_require__("D117");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b8a1e12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaiterTipsReport_vue__ = __webpack_require__("oriL");
function injectStyle (ssrContext) {
  __webpack_require__("1yuR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b8a1e12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaiterTipsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b8a1e12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaiterTipsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U4CI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U5bR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"sticky-header",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"top-bar"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.state')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive($event)}},model:{value:(_vm.model.loyalty_in_use),callback:function ($$v) {_vm.$set(_vm.model, "loyalty_in_use", $$v)},expression:"model.loyalty_in_use"}})],1),_vm._v(" "),(_vm.model.loyalty_in_use)?_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n          ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-25"},[_c('div',{staticClass:"col-md-12 "},[(_vm.model.loyalty_in_use)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.moneySpent')))]),_vm._v(" "),_c('br'),_vm._v("\n                  1 "+_vm._s(_vm.currency)+" = "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.loyalty_value_one_currency),expression:"modelValidations.loyalty_value_one_currency"},{name:"model",rawName:"v-model",value:(_vm.model.loyalty_value_one_currency),expression:"model.loyalty_value_one_currency"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","step":"0.1","name":"loyalty_value_one_currency"},domProps:{"value":(_vm.model.loyalty_value_one_currency)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "loyalty_value_one_currency", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.$t('settingsRewards.plural'))+"\n                  "),_c('span',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('settingsRewards.numberOfcurrencyNeedToSpend', {currency: _vm.currency})))]),_vm._v(" "),(_vm.errors.has('loyalty_value_one_currency'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('loyalty_value_one_currency'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.pointsTo')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.loyalty_value_one_point_amount),expression:"modelValidations.loyalty_value_one_point_amount"},{name:"model",rawName:"v-model",value:(_vm.model.loyalty_value_one_point_amount),expression:"model.loyalty_value_one_point_amount"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","default":"1","step":"0.1","name":"loyalty_value_one_point_amount"},domProps:{"value":(_vm.model.loyalty_value_one_point_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "loyalty_value_one_point_amount", $event.target.value)}}}),_vm._v("\n                  "+_vm._s(_vm.$t('settingsRewards.points'))+" = "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.loyalty_value_one_point),expression:"modelValidations.loyalty_value_one_point"},{name:"model",rawName:"v-model",value:(_vm.model.loyalty_value_one_point),expression:"model.loyalty_value_one_point"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"0","default":"1","step":"0.1","name":"loyalty_value_one_point"},domProps:{"value":(_vm.model.loyalty_value_one_point)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "loyalty_value_one_point", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.currency)+"\n                  "),_c('span',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('settingsRewards.numberOfpointsToReward')))]),_vm._v(" "),(_vm.errors.has('loyalty_value_one_point'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('loyalty_value_one_point'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.loyaltyOnlyFullPoints')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.loyalty_only_full_points),callback:function ($$v) {_vm.$set(_vm.model, "loyalty_only_full_points", $$v)},expression:"model.loyalty_only_full_points"}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('settingsRewards.loyaltyOnlyFullPointsHelp')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.loyaltyMinOrderValue'))),(_vm.currency)?_c('span',[_vm._v(" ("+_vm._s(_vm.currency)+")")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.loyalty_min_order_value),expression:"modelValidations.loyalty_min_order_value"},{name:"model",rawName:"v-model.number",value:(_vm.model.loyalty_min_order_value),expression:"model.loyalty_min_order_value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01","name":"loyalty_min_order_value"},domProps:{"value":(_vm.model.loyalty_min_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "loyalty_min_order_value", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('settingsRewards.loyaltyMinOrderValueHelp')))]),_vm._v(" "),(_vm.errors.has('loyalty_min_order_value'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('loyalty_min_order_value'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.enableNotifications')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleNotification($event)}},model:{value:(_vm.model.enable_notification_loyalty_points),callback:function ($$v) {_vm.$set(_vm.model, "enable_notification_loyalty_points", $$v)},expression:"model.enable_notification_loyalty_points"}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('settingsRewards.notifyUsersLoyaltyPoints'))+" "+_vm._s(_vm.$t('settingsRewards.customizeLoyaltyPointsNotification'))+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goToSettings()}}},[_vm._v(_vm._s(_vm.$t('settingsRewards.here'))+". ")])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.donationPointValue')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.donation_point_value),expression:"model.donation_point_value"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('settingCompany.donationPointValueNr'),"step":"0.1"},domProps:{"value":(_vm.model.donation_point_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "donation_point_value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.loyaltyPointsAppLimit')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.loyalty_points_use_limit),expression:"model.loyalty_points_use_limit",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"1"},domProps:{"value":(_vm.model.loyalty_points_use_limit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "loyalty_points_use_limit", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card moneyPoints"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.moneySpent')))]),_vm._v(" "),_c('div',{staticClass:"days"},_vm._l((_vm.arrayWithDays),function(day,deyName){return _c('div',{staticClass:"day"},[_c('span',{ref:deyName,refInFor:true,staticClass:"label",attrs:{"name":deyName}},[_vm._v(_vm._s(_vm.$t('daysShort')[deyName]))]),_vm._v(" "),_c('p-checkbox',{key:deyName,on:{"input":function($event){_vm.clickOnCheckbox(deyName)}},model:{value:(_vm.arrayWithDays[deyName]),callback:function ($$v) {_vm.$set(_vm.arrayWithDays, deyName, $$v)},expression:"arrayWithDays[deyName]"}}),_vm._v(" "),(day)?_c('span',{staticClass:"dayField"},[_vm._v("\n                        1 "+_vm._s(_vm.currency)+" = "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.loyalty_value_one_currency_per_days),expression:"modelValidations.loyalty_value_one_currency_per_days"},{name:"model",rawName:"v-model",value:(_vm.model.loyalty_value_one_currency_per_days[deyName].val),expression:"model.loyalty_value_one_currency_per_days[deyName].val"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","step":"0.1","name":"loyalty_value_one_currency_per_days"},domProps:{"value":(_vm.model.loyalty_value_one_currency_per_days[deyName].val)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.loyalty_value_one_currency_per_days[deyName], "val", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.$t('settingsRewards.plural'))+"\n                      ")]):_vm._e(),_vm._v(" "),(day)?_c('span',{staticClass:"dayField"},[_vm._v("\n                        "+_vm._s(_vm.$t('settingsRewards.timeInterval'))+"\n                      ")]):_vm._e(),_vm._v(" "),(day)?_c('p-checkbox',{key:deyName+'_time',on:{"input":function($event){_vm.setTimePeriod(deyName)}},model:{value:(_vm.arrayWithDaysTime[deyName]),callback:function ($$v) {_vm.$set(_vm.arrayWithDaysTime, deyName, $$v)},expression:"arrayWithDaysTime[deyName]"}}):_vm._e(),_vm._v(" "),(_vm.arrayWithDaysTime[deyName])?_c('span',{staticClass:"dayField"},[_vm._v("\n                        "+_vm._s(_vm.$t('settingsRewards.fromTime'))+"\n                      ")]):_vm._e(),_vm._v(" "),(_vm.arrayWithDaysTime[deyName])?_c('el-time-select',{key:_vm.timePickerKey[deyName].from,staticClass:"in-inline-160",attrs:{"placeholder":"Select time","picker-options":{
                          start: '00:00',
                          step: '00:15',
                          end: '24:00'
                        }},on:{"input":_vm.changeFrom},model:{value:(_vm.model.loyalty_value_one_currency_per_days[deyName].from),callback:function ($$v) {_vm.$set(_vm.model.loyalty_value_one_currency_per_days[deyName], "from", $$v)},expression:"model.loyalty_value_one_currency_per_days[deyName].from"}}):_vm._e(),_vm._v(" "),(_vm.arrayWithDaysTime[deyName])?_c('span',{staticClass:"dayField"},[_vm._v("\n                        "+_vm._s(_vm.$t('settingsRewards.toTime'))+"\n                      ")]):_vm._e(),_vm._v(" "),(_vm.arrayWithDaysTime[deyName])?_c('el-time-select',{staticClass:"in-inline-160",attrs:{"placeholder":"Select time","picker-options":{
                          start: '00:00',
                          step: '00:15',
                          end: '24:00'
                        }},on:{"input":_vm.changeFrom},model:{value:(_vm.model.loyalty_value_one_currency_per_days[deyName].to),callback:function ($$v) {_vm.$set(_vm.model.loyalty_value_one_currency_per_days[deyName], "to", $$v)},expression:"model.loyalty_value_one_currency_per_days[deyName].to"}}):_vm._e()],1)}))])])])]),_vm._v(" "),(_vm.referalModel.is_loyalty)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Modul recomandari")]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success","disabled":!_vm.referalModel.is_loyalty},on:{"input":function($event){_vm.handleActiveReferal($event)}},model:{value:(_vm.referalModel.is_active),callback:function ($$v) {_vm.$set(_vm.referalModel, "is_active", $$v)},expression:"referalModel.is_active"}})],1):_vm._e(),_vm._v(" "),(_vm.referalModel.is_active)?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group "},[_c('label',[_vm._v(_vm._s(_vm.$t('referalSettings.parent_receive_points')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.referalModel.parent_receive),callback:function ($$v) {_vm.$set(_vm.referalModel, "parent_receive", $$v)},expression:"referalModel.parent_receive"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsRewards.initialReferal')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('referalSettings.initial_parent_percentage')))]),_vm._v(" = "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.default_parent_referal_value),expression:"modelValidations.default_parent_referal_value"},{name:"model",rawName:"v-model",value:(_vm.referalModel.default_parent_referal_value),expression:"referalModel.default_parent_referal_value"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","step":"0.1","name":"default_parent_referal_value"},domProps:{"value":(_vm.referalModel.default_parent_referal_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.referalModel, "default_parent_referal_value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('referalSettings.initial_child_percentage')))]),_vm._v(" = "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.default_child_referal_value),expression:"modelValidations.default_child_referal_value"},{name:"model",rawName:"v-model",value:(_vm.referalModel.default_child_referal_value),expression:"referalModel.default_child_referal_value"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","step":"0.1","name":"default_child_referal_value"},domProps:{"value":(_vm.referalModel.default_child_referal_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.referalModel, "default_child_referal_value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('referalSettings.order_count')))]),_vm._v(" = "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referalModel.referal_iterations),expression:"referalModel.referal_iterations"}],staticClass:"form-control in-inline",attrs:{"type":"number","step":"1","name":"referal_iterations"},domProps:{"value":(_vm.referalModel.referal_iterations)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.referalModel, "referal_iterations", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('referalSettings.order_count_info')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('referalSettings.order_values')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('referalSettings.parent_order_percentage')))]),_vm._v(" = "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referalModel.referal_iteration_parent_value),expression:"referalModel.referal_iteration_parent_value"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"0","step":"0.1","name":"referal_iteration_parent_value"},domProps:{"value":(_vm.referalModel.referal_iteration_parent_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.referalModel, "referal_iteration_parent_value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('referalSettings.child_order_percentage')))]),_vm._v(" = "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referalModel.referal_iteration_child_value),expression:"referalModel.referal_iteration_child_value"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"0","step":"0.1","name":"referal_iteration_child_value"},domProps:{"value":(_vm.referalModel.referal_iteration_child_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.referalModel, "referal_iteration_child_value", $event.target.value)}}})])])]):_vm._e()]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U6TR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__ = __webpack_require__("5NHr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1b27df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__ = __webpack_require__("fYtj");
function injectStyle (ssrContext) {
  __webpack_require__("2vyi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1b27df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U6jD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosMapList_vue__ = __webpack_require__("Hrxw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768c92b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosMapList_vue__ = __webpack_require__("Rt3n");
function injectStyle (ssrContext) {
  __webpack_require__("uv+i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosMapList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768c92b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosMapList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U9DA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UB3S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInventoryAdd_vue__ = __webpack_require__("6Odg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4710a6ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInventoryAdd_vue__ = __webpack_require__("rPE1");
function injectStyle (ssrContext) {
  __webpack_require__("xsVP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4710a6ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInventoryAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4710a6ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInventoryAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UCPQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementAvizAdd_vue__ = __webpack_require__("bUkZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_107db8ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementAvizAdd_vue__ = __webpack_require__("bmRV");
function injectStyle (ssrContext) {
  __webpack_require__("GnSb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-107db8ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementAvizAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_107db8ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementAvizAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UFww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isBonFiscal },on:{"click":_vm.openBonFiscal}},[_vm._v(_vm._s(_vm.$t('gestiune.sales')))]),_vm._v(" "),(_vm.userHasRight('can_generate_invoice'))?_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInvoice },on:{"click":_vm.openInvoice}},[_vm._v(_vm._s(_vm.$t('invoice.invoices')))]):_vm._e(),_vm._v(" "),(_vm.userHasRight('can_generate_invoice'))?_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isProforma },on:{"click":_vm.openProforma}},[_vm._v(_vm._s(_vm.$t('invoice.proforma')))]):_vm._e(),_vm._v(" "),(_vm.userHasRight('can_generate_aviz'))?_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isAviz },on:{"click":_vm.openAviz}},[_vm._v(_vm._s(_vm.$t('gestiune.aviz')))]):_vm._e()])])])]),_vm._v(" "),(_vm.isBonFiscal)?_c('div',[_c('ManagementBonFiscal',{attrs:{"groupedLocations":_vm.groupedLocations}})],1):_vm._e(),_vm._v(" "),(_vm.isInvoice && _vm.userHasRight('can_generate_invoice'))?_c('div',[_c('Invoice',{attrs:{"groupedLocations":_vm.groupedLocations}})],1):_vm._e(),_vm._v(" "),(_vm.isProforma && _vm.userHasRight('can_generate_invoice'))?_c('div',[_c('Proforma',{attrs:{"groupedLocations":_vm.groupedLocations}})],1):_vm._e(),_vm._v(" "),(_vm.isAviz && _vm.userHasRight('can_generate_aviz'))?_c('div',[_c('ManagementAviz',{attrs:{"groupedLocations":_vm.groupedLocations}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UM+b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('fiscal-printer-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UTB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"div",class:[_vm.getSlideClass, {open:_vm.isOpen}],on:{"click":_vm.toggleDropDown}},[_vm._t("title",[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('p',{staticClass:"notification"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('b',{staticClass:"caret"})])])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UUgn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportRequest_vue__ = __webpack_require__("vNt5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f8145f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportRequest_vue__ = __webpack_require__("eLgs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f8145f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportRequest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UXsg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('form',{staticClass:"info-pages mar-15"},[_c('el-collapse',{attrs:{"accordion":""}},[(_vm.pages.length == 0)?_c('p',{staticClass:"pull-left pad-to-15"},[_vm._v(_vm._s(_vm.$t('settingsInfoPages.noPage')))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_vm._l((_vm.pages),function(page){return [(page.type !== 'CUSTOM')?[_c('el-collapse-item',{attrs:{"title":_vm.getTitle(page),"name":page.id}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsInfoPages.content')))]),_vm._v(" "),_c('wysiwyg',{model:{value:(page.description),callback:function ($$v) {_vm.$set(page, "description", $$v)},expression:"page.description"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success mar-to-10 save",on:{"click":function($event){$event.preventDefault();_vm.validate(page.id)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])],1)]:_vm._e()]})],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UZ+M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__);






















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_vue_js_modal___default.a, { componentName: 'vmodal' });
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    PPagination: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a),
  props: {},
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.token = this.$session.get('token');
    this.getData();
  },
  data: function data() {
    return {
      statuses: ['NEW', 'PROCESSING', 'DELIVERED', 'CANCELED'],
      reservationStatuses: ['RESERVED', 'COMPLETED', 'CANCELED'],
      locations: [],
      zones: [],
      selectedLocaion: 0,
      selectedZone: 0,
      loading: true,
      loadingOrders: true,
      token: null,
      apiUrl: null,
      locationDataForTableManagement: [],
      tableDataInPopup: [],
      tableData: []
    };
  },

  methods: {
    openOrdersModal: function openOrdersModal(tableId) {
      var _this = this;

      this.$modal.show('ordersModal');
      this.tableDataInPopup = [];
      this.loadingOrders = true;
      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany'),
        table_id: tableId
      };
      this.apiRequest('/get-table-itmes', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableDataInPopup = response.data.table;
        }
        _this.$nextTick(function () {
          _this.loadingOrders = false;
        });
      });
    },
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany'),
        location_id: this.selectedLocaion,
        table_zones_id: this.selectedZone
      };
      this.apiRequest('/get-table-orders', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.tableData = response.data.tables;
          _this2.locations = response.data.locations;
          _this2.zones = response.data.zones;

          _this2.$nextTick(function () {
            _this2.loading = false;
          });
        }
      });
    },
    changeStatus: function changeStatus(sts, order) {
      var _this3 = this;

      this.loading = true;
      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany'),
        status: sts,
        id: order.id
      };
      this.apiRequest('/order/' + order.id, 'PUT', data, function (response) {
        if (response.status === true) {
          _this3.getData();
        } else {
          _this3.loading = false;
        }
      });
    },
    changeStatusReservation: function changeStatusReservation(sts, reservations) {
      var _this4 = this;

      this.loading = true;
      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany'),
        status: sts,
        reservation_id: reservations.id
      };
      this.apiRequest('/edit-reservation', 'GET', data, function (response) {
        if (response.status === true) {
          if (_this4.tableDataInPopup) {
            _this4.openOrdersModal(_this4.tableDataInPopup.id);
          }
        }
      });
    },
    formatDateToShowJustDate: function formatDateToShowJustDate(date) {
      if (date) {
        return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).format('DD-MM');
      }
      return '';
    },
    formatDateToShowJustTime: function formatDateToShowJustTime(date) {
      if (date) {
        return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).format('hh:mm A');
      }
      return '';
    },
    goToOrder: function goToOrder(orderId) {
      this.$router.push('/orders/view/' + orderId);
    },
    goFullScreen: function goFullScreen() {
      var element = document.querySelector('.TablePage');
      if (this.isFullScreen) {
        document.exitFullscreen();
        this.isFullScreen = false;
      } else {
        this.isFullScreen = true;
        this.requestFullScreen(element);
      }
    },
    requestFullScreen: function requestFullScreen(element) {
      var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
      if (requestMethod) {
        requestMethod.call(element);
      } else if (window.ActiveXObject && typeof window.ActiveXObject !== 'undefined') {
        var wscript = new ActiveXObject('WScript.Shell');
        if (wscript !== null) {
          wscript.SendKeys('{F11}');
        }
      }
    },
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy).then(function (e) {}, function (e) {});
    }
  }
});

/***/ }),

/***/ "UZpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-collapse"},[_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('span',{staticClass:"handle"},[(_vm.groupsData.children && _vm.groupsData.children.length)?[_c('div',{staticClass:"pull-right disable-chck-location-groups"},[_c('div',{staticClass:"col-md-6"},[_c('p-checkbox',{key:_vm.groupsData.name + '_' + _vm.groupsData.id,on:{"input":function($event){_vm.handleActiveGroup(_vm.groupsData)}},model:{value:(_vm.groupsData.active),callback:function ($$v) {_vm.$set(_vm.groupsData, "active", $$v)},expression:"groupsData.active"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.enabled')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 mar-lt-15"},[_c('a',{staticClass:"btn btn-icon btn-info mar-rt-10",staticStyle:{"top":"-5px"},attrs:{"title":_vm.$t('general.edit')},on:{"click":function($event){_vm.openEditLocationGroupModal(_vm.groupsData)}}},[_c('i',{staticClass:"ti-pencil"})])])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":_vm.groupsData.name,"name":_vm.groupsData.name + '_' + _vm.groupsData.id}},[(_vm.groupsData.children.length)?[_vm._l((_vm.groupsData.children),function(newphew){return [_c('location-group-section',{attrs:{"name":newphew.name + '_' + newphew.id,"groupsDataProp":newphew,"groupToBeDeletedProp":_vm.groupToBeDeleted,"groupToBeAddedProp":_vm.groupToBeAdded,"groupToBeEditedProp":_vm.groupToBeEdited},on:{"open-modal":function($event){_vm.openEditLocationGroupModal($event)}}})]})]:[_c('div',{staticClass:"pull-left status-line pad-to-10 order-buttons resize-method overflow-container"},[_vm._l((_vm.groupsData.location_ids),function(loc,id){return [_c('button',{staticClass:"btn btn-status-margin tablet-overflow "},[_vm._v("\n                  "+_vm._s(loc.name)+"\n                ")])]})],2)]],2)]:[_c('div',{staticClass:"pull-right disable-chck-location-groups"},[_c('div',{staticClass:"col-md-6"},[_c('p-checkbox',{key:_vm.groupsData.name + '_' + _vm.groupsData.id,on:{"input":function($event){_vm.handleActiveGroup(_vm.groupsData)}},model:{value:(_vm.groupsData.active),callback:function ($$v) {_vm.$set(_vm.groupsData, "active", $$v)},expression:"groupsData.active"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.enabled')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 mar-lt-15"},[_c('a',{staticClass:"btn btn-icon btn-info mar-rt-10",staticStyle:{"top":"-5px"},attrs:{"title":_vm.$t('general.edit')},on:{"click":function($event){_vm.openEditLocationGroupModal(_vm.groupsData)}}},[_c('i',{staticClass:"ti-pencil"})])])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":_vm.groupsData.name,"name":_vm.groupsData.name + '_' + _vm.groupsData.id}},[_c('div',{staticClass:"pull-left status-line pad-to-10 order-buttons resize-method overflow-container"},[_vm._l((_vm.groupsData.location_ids),function(loc,id){return [_c('button',{staticClass:"btn btn-status-margin tablet-overflow "},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])]})],2)])]],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UcMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      qr_code: null,
      group_name: '',
      apiUrl: '',
      offerModel: {},
      client: null,
      new_client: {},
      existingNames: [],
      clientsTableData: [],
      not2timeByName2: 1,
      searchQuery: '',
      modelValidations: {
        required: {
          required: true
        }
      },
      filters: [{
        value: '',
        prop: ['name', 'status', 'type']
      }],
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [5, 25, 50],
        show: false,
        perPage: 5
      },
      pagesCount: 5
    };
  },

  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    var postData = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany'),
      group_id: this.route.params.id
    };
    this.getClients(postData);
  },
  methods: {
    handleSearch: function handleSearch() {
      var postData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        group_id: this.route.params.id,
        search: this.searchQuery.trim()
      };
      this.getClients(postData);
    },
    clearSearch: function clearSearch() {
      this.searchQuery = '';
      var postData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        group_id: this.route.params.id
      };
      this.getClients(postData);
    },
    regenerateQr: function regenerateQr() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        group_id: this.route.params.id
      };
      this.apiRequest('/customersgroup/regenerate-qr', 'POST', data, function (response) {
        if (response.status === true) {
          _this.qr_code = response.data.qr_code;
          _this.$nextTick(function () {
            this.loading = false;
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    handlePageChange: function handlePageChange(page) {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        group_id: this.route.params.id,
        page: page,
        perPage: this.paginationDef.perPage,
        filters: this.filters
      };

      if (this.searchQuery.trim()) {
        data.search = this.searchQuery.trim();
      }

      this.getClients(data);
    },
    searchByName: function searchByName() {
      var _this2 = this;

      if (this.not2timeByName2) {
        if (this.new_client.name === '') {
          this.existingNames = [];
        } else {
          this.not2timeByName2 = 0;
          this.existingClients = [];
          this.existingPhones = [];
          this.existingEmails = [];
          this.existingNames = [];
          setTimeout(function () {
            var data = {
              search: _this2.new_client.name,
              token: _this2.$session.get('token'),
              company_id: _this2.$session.get('selectedCompany'),
              group_id: _this2.route.params.id
            };
            _this2.apiRequest('/search-for-client', 'GET', data, function (response) {
              if (response.status === true) {
                _this2.existingNames = response.data.clients;
                _this2.loading = false;
              }
              _this2.not2timeByName2 = 1;
            });
          }, 500);
        }
      }
    },
    selectClient: function selectClient(client) {
      var _this3 = this;

      this.client = client;
      this.existingNames = [];
      this.new_client = {};

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        group_id: this.route.params.id,
        client_id: this.client.id
      };
      this.apiRequest('/customersgroup/add-client', 'POST', data, function (response) {
        if (response.status === true) {
          _this3.clientsTableData.push(response.data);
          _this3.$nextTick(function () {
            this.loading = false;
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    getClients: function getClients(data) {
      var _this4 = this;

      this.loading = true;
      this.apiRequest('/customersgroup/list', 'GET', data, function (response) {
        if (response.status === true) {
          _this4.clientsTableData = response.data.customers;
          _this4.paginationDef.page = response.data.pagination.page;
          _this4.paginationDef.perPage = response.data.pagination.perPage;
          _this4.paginationDef.totalPages = response.data.pagination.totalPages;
          _this4.paginationDef.totalRecords = response.data.pagination.totalRecords;
          _this4.qr_code = response.data.qr_code;
          _this4.group_name = response.data.name;
          _this4.$nextTick(function () {
            this.loading = false;
          });
        }
      });
    },
    approveClient: function approveClient(item) {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        xref_id: item.id,
        is_approved: 1
      };
      this.apiRequest('/customersgroup/approve-client', 'POST', data, function (response) {
        if (response.status === true) {
          item.is_approved = 1;
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()(_this5.$t('general.success') + '!', _this5.$t('customers.clientApproved') || 'Client aprobat cu succes!', 'success').catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this5.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    removeClient: function removeClient(item) {
      var _this6 = this;

      var idx = null;
      this.clientsTableData.forEach(function (el, index) {
        if (el.id === item.id) {
          idx = index;
        }
      });
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        text: this.$t('marketingCampaigns.areYouSureDelete') + (' \'' + item.customer.firstname + ' ' + item.customer.lastname + '\'?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this6.$session.get('token'),
            company_id: _this6.$session.get('selectedCompany')
          };
          _this6.apiRequest('/customersgroup/remove-client/' + item.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this6.$t('customers.deleteGroup'), 'success');
              _this6.clientsTableData.splice(idx, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this6.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function () {});
    },
    handleFocusOut: function handleFocusOut() {
      var _this7 = this;

      setTimeout(function () {
        _this7.existingNames = [];
        _this7.new_client.name = '';
      }, 600);
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "Uehx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      imagelist: [],
      url: null,
      images: []
    };
  },
  created: function created() {
    this.getData();
  },

  props: {
    handleModal: {
      required: false,
      type: Boolean
    }
  },
  watch: {
    handleModal: function handleModal(value) {
      if (value) {
        this.$modal.show('uploadImageModal');
      } else {
        this.$modal.hide('uploadImageModal');
      }
    }
  },
  methods: {
    deleteImage: function deleteImage(id) {
      var _this = this;

      var requestData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id
      };
      this.apiRequest('/campaign-images/' + id, 'DELETE', requestData, function (response) {
        if (response.status) {
          _this.images = response.data;
        }
      });
    },
    selectImage: function selectImage(image) {
      this.$emit('selected-image', image.filename);
      this.closeModal();
    },
    open: function open() {
      this.$modal.show('uploadImageModal');
      this.$emit('open');
    },
    closeModal: function closeModal() {
      this.$modal.hide('uploadImageModal');
    },
    getData: function getData() {
      var _this2 = this;

      var requestData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/campaign-images', 'GET', requestData, function (response) {
        if (response.status) {
          _this2.images = response.data;
        }
      });
    },
    uploadImage: function uploadImage() {
      var _this3 = this;

      var requestData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (this.imagelist && this.imagelist[0].status === 'ready') {
        this.getBase64(this.imagelist[0].raw).then(function (base64enc) {
          requestData.image = base64enc;
          _this3.apiRequest('/campaign-images', 'POST', requestData, function (response) {
            if (response.status) {
              _this3.imagelist = [];
              _this3.images = response.data;
            }
          });
        });
      }
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: this.$t('validations.pictureSizeExceed2MB'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.imagelist = fileList.slice(1);
        } else {
          this.imagelist = fileList;
        }
        this.uploadImage();
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.imagelist = [];
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        text: this.$t('validations.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: this.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    }
  }
});

/***/ }),

/***/ "UgX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-button"},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"1"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[(_vm.userHasRight('can_create_supplier_order'))?_c('button',{staticClass:"btn add mar-rt-10",attrs:{"type":"success"},on:{"click":function($event){_vm.addMyOrder()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('gestiune.addOrder'))+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"label":"Număr Document","prop":"documentNumber"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.documentNumber)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Serie","prop":"series"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.series)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Date","prop":"date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(new Date(scope.row.date).toLocaleDateString('ro-RO'))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Status","prop":"status"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{style:(_vm.getStatusStyle(scope.row.status))},[_vm._v("\n                    "+_vm._s(scope.row.status)+"\n                  ")])]}}])}),_vm._v(" "),(_vm.showAvizColumn)?_c('el-table-column',{attrs:{"label":"Aviz","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s((scope.row.externalDocIds && scope.row.externalDocIds.aviz)
                      ? scope.row.externalDocIds.aviz.series + ' - ' + scope.row.externalDocIds.aviz.number
                      : '-')+"\n                ")]}}])}):_vm._e(),_vm._v(" "),(_vm.showNirColumn)?_c('el-table-column',{attrs:{"label":"NIR","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s((scope.row.externalDocIds && scope.row.externalDocIds.nir)
                      ? scope.row.externalDocIds.nir.number
                      : '-')+"\n                ")]}}])}):_vm._e(),_vm._v(" "),(_vm.showInvoiceColumn)?_c('el-table-column',{attrs:{"label":"Factura","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s((scope.row.externalDocIds && scope.row.externalDocIds.invoice)
                      ? scope.row.externalDocIds.invoice.series + ' - ' + scope.row.externalDocIds.invoice.number
                      : '-')+"\n                ")]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status.toLowerCase() === 'new' && _vm.userHasRight('can_send_supplier_order'))?_c('a',{staticClass:"btn btn-info mar-rt-10",on:{"click":function($event){_vm.sendOrder(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('gestiune.sendOrder'))+"\n                  ")]):_vm._e(),_vm._v(" "),(scope.row.status.toLowerCase() === 'avizat' && _vm.userHasRight('can_receive_supplier_order'))?_c('a',{staticClass:"btn btn-info mar-rt-10",on:{"click":function($event){_vm.reception(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('gestiune.reception'))+"\n                  ")]):_vm._e(),_vm._v(" "),(scope.row.status.toLowerCase() === 'receptionat' && _vm.userHasRight('can_validate_supplier_order'))?_c('a',{staticClass:"btn btn-info mar-rt-10",on:{"click":function($event){_vm.validateOrder(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('gestiune.validate'))+"\n                  ")]):_vm._e(),_vm._v(" "),(
                      ['validat', 'facturat'].includes(scope.row.status.toLowerCase()) &&
                      !_vm.hasBonTransfer(scope.row) &&
                      _vm.userHasRight('can_generate_nir') &&
                      !(scope.row.externalDocIds && scope.row.externalDocIds.nir)
                    )?_c('a',{staticClass:"btn btn-info mar-rt-10",on:{"click":function($event){_vm.generateNir(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('gestiune.generateNir'))+"\n                  ")]):_vm._e(),_vm._v(" "),(['validat', 'facturat'].includes(scope.row.status.toLowerCase()) && _vm.hasBonTransfer(scope.row))?_c('a',{staticClass:"btn btn-info mar-rt-10",attrs:{"disabled":""}},[_vm._v("\n                    Bon transfer: "+_vm._s(_vm.getBonTransferNumber(scope.row))+"\n                  ")]):_vm._e()]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UgsK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UkeB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"company-details"},[_c('div',{ref:"compDetailsContainer",style:({height: _vm.windowHeight - _vm.pageTopHeight - _vm.navbarHeaderHeight - 1 + 'px'})},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_vm._l((_vm.locations),function(location,index){return _c('div',{staticClass:"card pad-bt-15"},[_c('div',{staticClass:"card-content"},[_c('h5',{staticClass:"pad-bt-15"},[_c('i',{staticClass:"ti-home"}),_vm._v(" "+_vm._s(_vm.$t('settingCompany.bussLoc'))+": "+_vm._s(location.name)+"\n          ")]),_vm._v(" "),[_c('div',{staticClass:"row"},[(location.dynamic_qr_code && location.dynamic_qr_code.length)?_c('div',{staticClass:"col-md-8 mar-lt-5"},[_c('display-qr',{attrs:{"location":location}})],1):_c('div',{staticClass:"col-md-8 mar-lt-5"},[_vm._v("\n                "+_vm._s(_vm.$t('marketingFidelities.noData'))+"\n              ")])])]],2)])}),_vm._v(" "),_c('div',{staticClass:"company-details"},[_c('div',{staticClass:"card pad-bt-15"},[_c('div',{staticClass:"row display-flex"},[_c('div',{staticClass:"card-content align-items-center mb-0 col-md-11 mar-lt-15 help-block warning"},[_c('span',{staticClass:"relative-top"},[_vm._v(_vm._s(_vm.$t('settingCompany.generateQrMenu'))+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goToCompany()}}},[_vm._v(_vm._s(_vm.$t('settingCompany.generateQrMenuSettings'))+".")])])])])])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ul8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('menu-link-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onLinkSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UleD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);












__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: { isChallengeCampaignsReport: { type: Boolean, default: false } },
  data: function data() {
    return {
      loading: false,
      tableData: [],
      challengeId: '',
      searchTitle: '',
      dateRange: null,
      locationId: null,
      locations: [],
      pickerOptions: {
        firstDayOfWeek: 1
      }
    };
  },

  watch: {
    isChallengeCampaignsReport: function isChallengeCampaignsReport(v) {
      if (v) this.init();
    }
  },
  created: function created() {
    if (this.isChallengeCampaignsReport) this.init();
    this.$bus.$on('refresh-challenge-report', this.loadReport);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh-challenge-report', this.loadReport);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.getLocations().then(function () {
        return _this.loadReport();
      });
    },
    getLocations: function getLocations() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var data = {
          token: _this2.$session.get('token'),
          company_id: _this2.$session.get('selectedCompany')
        };
        _this2.apiRequest('/get-locations', 'GET', data, function (response) {
          _this2.locations = response.status ? response.data || [] : [];
          resolve();
        });
      });
    },
    loadReport: function loadReport() {
      var _this3 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        date_from: this.dateRange && this.dateRange[0] ? this.dateRange[0] + ' 00:00:00' : null,
        date_to: this.dateRange && this.dateRange[1] ? this.dateRange[1] + ' 23:59:59' : null,
        location_id: this.locationId,
        challenge_id: this.challengeId !== null && String(this.challengeId).trim() !== '' ? String(this.challengeId).trim() : null,
        search: (this.searchTitle || '').trim() || null
      };
      this.apiRequest('/reports/challenges', 'GET', data, function (response) {
        _this3.loading = false;
        if (response.status) _this3.tableData = response.data || [];
      });
    },
    onRowClick: function onRowClick(row) {
      this.$router.push({
        path: '/reports/challenge-campaigns/' + row.id + '/users',
        query: { title: row.title }
      });
    }
  }
});

/***/ }),

/***/ "Ulu/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductCrossSellPicker',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    companyId: {
      type: [Number, String],
      required: true
    },
    locationId: {
      type: [Number, String],
      required: true
    },
    maxItems: {
      type: Number,
      default: 10
    }
  },
  data: function data() {
    return {
      search: '',
      categoryId: null,
      categories: [],
      results: [],
      selectedItems: [],
      loading: false,
      searchTimeout: null,
      page: 1,
      lastPage: 1,
      total: 0
    };
  },

  computed: {
    selectedIds: function selectedIds() {
      return this.selectedItems.map(function (item) {
        return item.id;
      });
    }
  },
  watch: {
    search: function search() {
      this.debouncedSearch();
    },
    categoryId: function categoryId() {
      this.page = 1;
      this.searchProducts();
    }
  },
  created: function created() {
    this.loadCategories();
    this.hydrateSelected();
    this.searchProducts();
  },

  methods: {
    baseParams: function baseParams() {
      var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
        token: this.$session.get('token'),
        company_id: this.companyId,
        location_id: this.locationId
      }, extra);
    },
    loadCategories: function loadCategories() {
      var _this = this;

      this.apiRequest('/location-cross-sell/categories', 'GET', this.baseParams(), function (response) {
        if (response.status) {
          _this.categories = response.data;
        }
      });
    },
    hydrateSelected: function hydrateSelected() {
      var _this2 = this;

      if (!this.value || !this.value.length) {
        this.selectedItems = [];
        return;
      }

      var params = this.baseParams({ ids: this.value.join(',') });
      this.apiRequest('/location-cross-sell/products-search', 'GET', params, function (response) {
        if (response.status) {
          var map = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a(response.data.map(function (p) {
            return [p.id, p];
          }));
          _this2.selectedItems = _this2.value.map(function (id) {
            return map.get(id) || map.get(Number(id));
          }).filter(Boolean);
        }
      });
    },
    debouncedSearch: function debouncedSearch() {
      var _this3 = this;

      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(function () {
        _this3.page = 1;
        _this3.searchProducts();
      }, 300);
    },
    goToPage: function goToPage(page) {
      if (page < 1 || page > this.lastPage || page === this.page) {
        return;
      }
      this.page = page;
      this.searchProducts();
    },
    searchProducts: function searchProducts() {
      var _this4 = this;

      var params = this.baseParams({
        q: this.search,
        category_id: this.categoryId || '',
        page: this.page
      });

      this.loading = true;
      this.apiRequest('/location-cross-sell/products-search', 'GET', params, function (response) {
        if (response.status) {
          _this4.results = response.data;
          if (response.pagination) {
            _this4.total = response.pagination.total;
            _this4.lastPage = response.pagination.last_page;
            _this4.page = response.pagination.current_page;
          }
        } else {
          _this4.results = [];
          _this4.total = 0;
          _this4.lastPage = 1;
        }
        _this4.loading = false;
      });
    },
    isChecked: function isChecked(id) {
      return this.selectedIds.indexOf(id) !== -1;
    },
    toggle: function toggle(product) {
      if (this.isChecked(product.id)) {
        this.removeItem(product.id);
        return;
      }

      if (this.selectedItems.length >= this.maxItems) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('', this.$t('crossSell.maxReached', { max: this.maxItems }), 'warning');
        return;
      }

      this.selectedItems.push({
        id: product.id,
        name: product.name,
        category_id: product.category_id
      });
      this.emitChange();
    },
    removeItem: function removeItem(id) {
      this.selectedItems = this.selectedItems.filter(function (item) {
        return item.id !== id;
      });
      this.emitChange();
    },
    emitChange: function emitChange() {
      this.$emit('input', this.selectedIds);
    }
  }
});

/***/ }),

/***/ "Umb1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiscalPrinterForm_vue__ = __webpack_require__("8HuY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2ce4c8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiscalPrinterForm_vue__ = __webpack_require__("SuKL");
function injectStyle (ssrContext) {
  __webpack_require__("78++")
  __webpack_require__("xEnV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d2ce4c8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiscalPrinterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2ce4c8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiscalPrinterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UmdO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uwvf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V+jh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductImportDetail_vue__ = __webpack_require__("cwHv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c406282_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductImportDetail_vue__ = __webpack_require__("nGk2");
function injectStyle (ssrContext) {
  __webpack_require__("IqUa")
  __webpack_require__("3o1n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c406282"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductImportDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c406282_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductImportDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V1ni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RaffleCampaignForm_vue__ = __webpack_require__("m4/V");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RaffleCampaignForm: __WEBPACK_IMPORTED_MODULE_0__RaffleCampaignForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),

/***/ "V3Zp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Management_ManagementUsers_vue__ = __webpack_require__("RnFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Management_ManagementSeriesAdd_vue__ = __webpack_require__("kgt7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Management_ManagementOrderErrors_vue__ = __webpack_require__("KtK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);














function getLocalDateTimeString() {
  var now = new Date();
  var year = now.getFullYear();
  var month = String(now.getMonth() + 1).padStart(2, '0');
  var day = String(now.getDate()).padStart(2, '0');
  var hours = String(now.getHours()).padStart(2, '0');
  var minutes = String(now.getMinutes()).padStart(2, '0');
  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementUsers: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Management_ManagementUsers_vue__["a" /* default */],
    ManagementSeriesAdd: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Management_ManagementSeriesAdd_vue__["a" /* default */],
    ManagementOrderErrors: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Management_ManagementOrderErrors_vue__["a" /* default */]
  },
  props: {
    locations: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      codContabil: '',
      analitic: '',
      typeGestion: '',
      selectedLocationSeries: '',
      selectedDate: getLocalDateTimeString(),
      editGestiuneId: null,
      spvStatus: {},
      spvStatusLoaded: false,
      editSeriesId: null,
      showBankModal: false,
      bankAccounts: [],
      tableData: [],
      isGestiuni: true,
      tipDepozit: '',
      isCategories: false,
      isOperation: false,
      isOrderErrors: false,
      isSeries: false,
      isUsers: false,
      isBankAccounts: false,
      codGestiune: '',
      showGestiuneModal: false,
      showSeriesModal: false,
      isDefaultGestiune: false,
      gestiune: '',
      tipGestiune: 'Cantitativ Valoric',
      adresaPunctLucru: '',
      administrator: '',
      selectedLocation: '',
      modelValidate: {
        gestiune: { required: true },
        typeGestion: { required: true }
      },
      newAccount: {
        iban: '',
        bank: '',
        currency: 'RON',
        swift: ''
      },
      tableDataCategories: [{ category: 'Marfa', account: 371 }, { category: 'Materii prime', account: 301 }, { category: 'Materiale consumabile', account: 302 }, { category: 'Semifabricate (Reteta)', account: 341 }, { category: 'Produs finit (Reteta)', account: 345 }, { category: 'Produs rezidual', account: 346 }, { category: 'Ambalaje', account: 381 }, { category: 'Obiecte de inventar', account: 303 }],
      tableDataSeries: [],
      series: '',
      startNumber: null,
      endNumber: null,
      tip: '',
      selectedVatExport: '',
      selectedVatSpv: ''
    };
  },

  computed: {
    spvEnrollUrl: function spvEnrollUrl() {
      if (!this.companyID || !this.selectedVatSpv) return '#';

      var base = "https://fiscal-dev.cdntaptasty.com" + ':4443/spv_enroll.html?externalCompanyId=' + this.companyID + '&vatNumber=' + encodeURIComponent(this.selectedVatSpv);

      if (this.spvStatus.hasToken && this.spvStatus.stateNonce) {
        base += '&state_nonce=' + this.spvStatus.stateNonce;
      }

      return base;
    },
    gestiuniGroupedByVatNumber: function gestiuniGroupedByVatNumber() {
      var _this = this;

      var groups = {};

      this.tableData.forEach(function (gestiune) {
        var vat = gestiune.vatNumber || 'no-vat';
        var locationName = _this.getLocationName(gestiune.externalLocationId || 'unknown');

        if (!groups[vat]) {
          groups[vat] = {
            locationNames: new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_set___default.a(),
            gestiuni: []
          };
        }
        if (locationName !== '') {
          groups[vat].locationNames.add(locationName);
          groups[vat].gestiuni.push(gestiune);
        }
      });

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            group = _ref2[1];

        return {
          vat: vat,
          label: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(group.locationNames).join(', '),
          gestiuni: group.gestiuni
        };
      });
    },
    groupedSeriesByVat: function groupedSeriesByVat() {
      var _this2 = this;

      if (!this.groupedLocations || !this.tableDataSeries) return [];

      return this.groupedLocations.map(function (group) {
        var seriesForGroup = _this2.tableDataSeries.filter(function (serie) {
          return serie.vatNumber === group.vat;
        });

        var locationsNames = group.locations.map(function (loc) {
          return loc.name;
        }).join(', ');

        return {
          vat: group.vat,
          locationsNames: locationsNames,
          series: seriesForGroup
        };
      }).filter(function (group) {
        return group.series.length > 0;
      });
    },
    maxDate: function maxDate() {
      return getLocalDateTimeString();
    },
    minDate: function minDate() {
      var date = new Date();
      date.setDate(date.getDate() - 30);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
    }
  },
  watch: {
    selectedLocation: function selectedLocation(newLoc) {
      if (newLoc && newLoc.gestiune_start_sync_order) {
        this.selectedDate = newLoc.gestiune_start_sync_order.replace(' ', 'T').slice(0, 16);
      } else {
        this.selectedDate = getLocalDateTimeString();
      }
    },
    codContabil: function codContabil(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.analitic = '';
      }
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.fetchGestiuni();
    this.getSeries();
  },

  methods: {
    fetchSpvStatus: function fetchSpvStatus() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vatNumber, params, res, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this3.companyID) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                vatNumber = _this3.selectedVatSpv;

                if (vatNumber) {
                  _context.next = 7;
                  break;
                }

                _this3.spvStatus = {};
                _this3.spvStatusLoaded = false;
                return _context.abrupt('return');

              case 7:
                _context.prev = 7;
                params = new URLSearchParams({
                  externalCompanyId: _this3.companyID,
                  vatNumber: vatNumber
                });
                _context.next = 11;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/auth/anaf/status?' + params.toString());

              case 11:
                res = _context.sent;
                _context.next = 14;
                return res.json();

              case 14:
                data = _context.sent;


                _this3.spvStatus = data;
                _this3.spvStatusLoaded = true;
                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](7);

                console.error('Eroare SPV status:', _context.t0);
                _this3.spvStatusLoaded = false;

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[7, 19]]);
      }))();
    },
    getVatOptionLabel: function getVatOptionLabel(group) {
      var count = group && group.locations ? group.locations.length : 0;
      var locationsLabel = count === 1 ? '1 locație' : count + ' loca\u021Bii';
      return group.vat + ' \u2014 ' + locationsLabel;
    },
    openSpvEnroll: function openSpvEnroll() {
      if (!this.selectedVatSpv || !this.spvEnrollUrl || this.spvEnrollUrl === '#') return;
      window.open(this.spvEnrollUrl, '_blank');
    },
    formatDate: function formatDate(timestamp) {
      if (!timestamp) return '-';
      return new Date(timestamp).toLocaleString();
    },
    getLocationName: function getLocationName(locationId) {
      var loc = this.locations.find(function (l) {
        return l.true_id === locationId;
      });
      return loc ? loc.name : '';
    },
    isDefaultForLocation: function isDefaultForLocation(gestiuneId, locationId) {
      var loc = this.locations.find(function (l) {
        return l.true_id === locationId;
      });
      return loc.gestiune_id_default === gestiuneId;
    },
    validate: function validate() {
      var _this4 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this4.saveGestiune();
        }
      });
    },
    openGestiuni: function openGestiuni() {
      this.isGestiuni = true;
      this.isCategories = false;
      this.isOperation = false;
      this.isOrderErrors = false;
      this.isSeries = false;
      this.isUsers = false;
      this.isBankAccounts = false;
    },
    openCategories: function openCategories() {
      this.isSeries = false;
      this.isGestiuni = false;
      this.isCategories = true;
      this.isUsers = false;
      this.isBankAccounts = false;
      this.isOperation = false;
      this.isOrderErrors = false;
    },
    openSeries: function openSeries() {
      this.isSeries = true;
      this.isGestiuni = false;
      this.isCategories = false;
      this.isUsers = false;
      this.isBankAccounts = false;
      this.isOperation = false;
      this.isOrderErrors = false;

      this.getSeries();
    },
    openBanckAccounts: function openBanckAccounts() {
      this.isSeries = false;
      this.isGestiuni = false;
      this.isCategories = false;
      this.isUsers = false;
      this.isBankAccounts = true;
      this.isOperation = false;
      this.isOrderErrors = false;
    },
    openUsers: function openUsers() {
      this.isSeries = false;
      this.isGestiuni = false;
      this.isCategories = false;
      this.isUsers = true;
      this.isBankAccounts = false;
      this.isOperation = false;
      this.isOrderErrors = false;
    },
    openOperation: function openOperation() {
      this.isSeries = false;
      this.isGestiuni = false;
      this.isCategories = false;
      this.isUsers = false;
      this.isBankAccounts = false;
      this.isOperation = true;
      this.isOrderErrors = false;
    },
    openOrderErrors: function openOrderErrors() {
      this.isSeries = false;
      this.isGestiuni = false;
      this.isCategories = false;
      this.isUsers = false;
      this.isBankAccounts = false;
      this.isOperation = false;
      this.isOrderErrors = true;
    },
    openGestiuneModal: function openGestiuneModal() {
      this.gestiune = '';
      this.codGestiune = '';
      this.tipGestiune = 'Cantitativ Valoric';
      this.selectedLocation = '';
      this.administrator = '';
      this.isDefaultGestiune = false;
      this.typeGestion = '';
      this.codContabil = '';
      this.analitic = '';

      this.$modal.show('addGestiuneModal');
    },
    openBankModal: function openBankModal() {
      this.$modal.show('bankAccountModal');
    },
    closeBankModal: function closeBankModal() {
      this.$modal.hide('bankAccountModal');
    },
    closeGestiuneModal: function closeGestiuneModal() {
      this.$modal.hide('addGestiuneModal');
    },
    openSeriesModal: function openSeriesModal() {
      this.editSeriesId = null;
      this.tip = '';
      this.series = '';
      this.startNumber = '';
      this.endNumber = '';

      this.$modal.show('addSeriesModal');
    },
    closeSeriesModal: function closeSeriesModal() {
      this.$modal.hide('addSeriesModal');
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this5.companyID) {
                  _context2.next = 3;
                  break;
                }

                console.error('Missing VAT number for fetching management data.');
                return _context2.abrupt('return');

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this5.companyID);

              case 6:
                response = _context2.sent;
                _context2.next = 9;
                return response.json();

              case 9:
                data = _context2.sent;


                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this5.tableData = data.gestiuni;
                } else {
                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                    title: 'Error!',
                    text: 'Nu s-a primit un array valid de la server.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](3);

                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  title: 'Error!',
                  text: 'Request failed: ' + _context2.t0.message,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching management data:', _context2.t0);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[3, 13]]);
      }))();
    },
    editRowGestiune: function editRowGestiune(row) {
      this.editGestiuneId = row._id;
      this.gestiune = row.name || '';
      this.codGestiune = row.cod_gestiune || '';
      var location = this.locations.find(function (loc) {
        return loc.true_id === row.externalLocationId;
      });
      this.selectedLocation = location ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, location, { street: row.adresa_punct_de_lucru }) : '';
      this.administrator = row.gestionar || '';
      this.typeGestion = row.categorie || '';
      this.tipDepozit = row.is_depozit ? 'Depozit' : '';
      this.tipGestiune = row.gestiune_type || '';
      this.vatNumber = row.vatNumber || '';
      this.isDefaultGestiune = false;
      this.codContabil = row.cod_contabil || '';
      this.analitic = row.analitic || '';
      this.$modal.show('addGestiuneModal');
    },
    editRowSeries: function editRowSeries(row) {
      this.editSeriesId = row._id || row.id || null;
      this.tip = row.tip || '';
      this.series = row.series || '';
      this.startNumber = row.startNumber || null;
      this.currentNumber = row.currentNumber || null;
      this.showSeriesModal = true;

      this.$modal.show('addSeriesModal');
    },
    exportNomenclator: function exportNomenclator() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var externalCompanyId, vatNumber, params, url, response, blob, downloadUrl, a;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (_this6.selectedVatExport) {
                  _context3.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  icon: 'error',
                  title: 'Selectează CIF-ul',
                  text: 'Trebuie să alegi un CIF pentru a filtra catalogul.'
                });
                return _context3.abrupt('return');

              case 4:
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  title: 'Se exportă catalogul...',
                  text: 'Așteaptă câteva secunde',
                  icon: 'info',
                  showCancelButton: false,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  didOpen: function didOpen() {
                    __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.showLoading();
                  }
                });

                externalCompanyId = _this6.companyID || null;
                vatNumber = _this6.selectedVatExport || null;

                if (!(!externalCompanyId && !vatNumber)) {
                  _context3.next = 10;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  icon: 'error',
                  title: 'Parametri lipsă',
                  text: 'Trebuie să existe externalCompanyId sau vatNumber.'
                });
                return _context3.abrupt('return');

              case 10:
                params = new URLSearchParams();


                if (externalCompanyId) params.append('externalCompanyId', externalCompanyId);
                if (vatNumber) params.append('vatNumber', vatNumber);

                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/nomenclator-export?' + params.toString();
                _context3.next = 16;
                return fetch(url);

              case 16:
                response = _context3.sent;

                if (!(response.status === 400)) {
                  _context3.next = 20;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  icon: 'error',
                  title: 'Cerere invalidă',
                  text: 'Lipsește externalCompanyId sau vatNumber.'
                });
                return _context3.abrupt('return');

              case 20:
                if (response.ok) {
                  _context3.next = 22;
                  break;
                }

                throw new Error('Eroare la generarea exportului.');

              case 22:
                _context3.next = 24;
                return response.blob();

              case 24:
                blob = _context3.sent;
                downloadUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');

                a.href = downloadUrl;
                a.download = 'nomenclator_' + Date.now() + '.csv';
                a.click();

                window.URL.revokeObjectURL(downloadUrl);

                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  icon: 'success',
                  title: 'Export finalizat',
                  text: 'Fișierul CSV a fost descărcat.'
                });
                _context3.next = 38;
                break;

              case 34:
                _context3.prev = 34;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  icon: 'error',
                  title: 'Eroare la export',
                  text: _context3.t0.message || 'A apărut o eroare.'
                });

              case 38:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 34]]);
      }))();
    },
    saveGestiune: function saveGestiune() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var existingGestiuniOnLocation, gestiuneData, response, responseData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (_this7.selectedLocation.inv_fiscal_code) {
                  _context4.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  icon: 'warning',
                  title: 'Lipsă cod fiscal',
                  text: 'Pentru locația selectată nu este setat codul VAT. Te rugăm să completezi codul VAT în pagina de locații înainte de a salva gestiunea.',
                  timer: 3000,
                  showConfirmButton: true
                });
                return _context4.abrupt('return');

              case 4:
                _context4.next = 6;
                return _this7.checkCompany();

              case 6:
                existingGestiuniOnLocation = _this7.tableData.filter(function (g) {
                  return g.externalLocationId === _this7.selectedLocation.true_id && (!_this7.gestiune.id || g._id !== _this7.gestiune.id);
                });


                if (existingGestiuniOnLocation.length === 0) {
                  _this7.isDefaultGestiune = true;
                }

                gestiuneData = {
                  name: _this7.gestiune,
                  cod_gestiune: _this7.codGestiune,
                  externalCompanyId: _this7.companyID,
                  externalLocationId: _this7.selectedLocation.true_id,
                  gestiune_type: _this7.tipGestiune,
                  is_depozit: _this7.tipDepozit === 'Depozit',
                  nume_punct_de_lucru: _this7.selectedLocation.name,
                  adresa_punct_de_lucru: _this7.selectedLocation.street,
                  gestionar: _this7.administrator,
                  categorie: _this7.typeGestion,
                  cod_contabil: _this7.codContabil,
                  analitic: _this7.analitic,
                  vatNumber: _this7.selectedLocation.inv_fiscal_code
                };


                if (_this7.editGestiuneId && _this7.gestiune.id) {
                  gestiuneData.id = _this7.gestiune.id;
                }

                _context4.next = 12;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiune', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(gestiuneData)
                });

              case 12:
                response = _context4.sent;
                _context4.next = 15;
                return response.json();

              case 15:
                responseData = _context4.sent;


                if (response.ok) {
                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                    title: 'Succes!',
                    text: 'Datele de gestiune au fost salvate cu succes.',
                    type: 'success',
                    timer: 2000,
                    showConfirmButton: false
                  });
                  if (_this7.isDefaultGestiune) {
                    _this7.modifyGestiune({
                      gestiuneCompanyId: responseData.externalCompanyId,
                      gestiuneIdDefault: responseData._id,
                      companyId: _this7.companyID,
                      locationId: responseData.externalLocationId
                    }, function () {
                      _this7.$modal.hide('addGestiuneModal');
                      _this7.fetchGestiuni();
                      _this7.$emit('fetchLocation');
                    });
                  } else {
                    _this7.$modal.hide('addGestiuneModal');
                    _this7.fetchGestiuni();
                    _this7.$emit('fetchLocation');
                  }
                } else {
                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                    title: 'Error!',
                    text: responseData.message || 'An error occurred while saving the management data.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context4.next = 23;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4['catch'](0);

                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  title: 'Error!',
                  text: 'Request failed: ' + _context4.t0.message,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error saving management data:', _context4.t0);

              case 23:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[0, 19]]);
      }))();
    },
    modifyGestiune: function modifyGestiune(_ref3) {
      var _this8 = this;

      var gestiuneCompanyId = _ref3.gestiuneCompanyId,
          gestiuneIdDefault = _ref3.gestiuneIdDefault,
          companyId = _ref3.companyId,
          locationId = _ref3.locationId;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dataToSend = {
                  gestiune_company_id: gestiuneCompanyId,
                  gestiune_id_default: gestiuneIdDefault,
                  company_id: companyId,
                  location_id: locationId,
                  token: _this8.$session.get('token')
                };


                _this8.apiRequest('/gestiune/modify-gestiune', 'POST', dataToSend, function (response) {
                  if (!response || response.error || response.status === false) {
                    __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Modificarea gestiunii a eșuat.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                  }
                  if (callback) {
                    callback(response);
                  }
                });

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    toggleSales: function toggleSales(isStart, vatNumber) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var requiredTypes, missingTypes, missingText, formattedDate, dataToSend;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (!isStart) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 4;
                return _this9.getSeries(vatNumber);

              case 4:
                requiredTypes = ['NIR', 'Bon casare', 'Bon de transfer', 'Bon consum', 'Bon de productie', 'Inventar', 'Invoice', 'Proforma', 'Aviz', 'Order'].map(function (t) {
                  return t.toLowerCase().replace(/\s+/g, '_');
                });
                missingTypes = requiredTypes.filter(function (normalizedType) {
                  return !_this9.tableDataSeries.some(function (serie) {
                    return serie.tip.toLowerCase().replace(/\s+/g, '_') === normalizedType;
                  });
                });

                if (!(missingTypes.length > 0)) {
                  _context6.next = 10;
                  break;
                }

                missingText = missingTypes.map(function (t) {
                  return '- ' + t.replace(/_/g, ' ');
                }).join('<br>');


                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  icon: 'error',
                  title: 'Nu se pot porni vânzările',
                  html: 'Lipsesc seriile urm\u0103toare:<br>' + missingText + '<br><br>Creeaz\u0103-le mai \xEEnt\xE2i din tabul "Serii documente".'
                });
                return _context6.abrupt('return');

              case 10:
                formattedDate = _this9.selectedDate.replace('T', ' ') + ':00';
                dataToSend = {
                  location_id: _this9.selectedLocation.true_id,
                  company_id: _this9.companyID,
                  gestiune_start_sync_order: isStart ? formattedDate : null,
                  token: _this9.$session.get('token')
                };

                _this9.apiRequest('/gestiune/modify-start-sync-order', 'POST', dataToSend, function (response) {
                  if (response && response.status === true) {
                    __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                      icon: 'success',
                      title: isStart ? 'Vânzările au fost pornite!' : 'Vânzările au fost oprite!'
                    }).then(function () {
                      if (isStart) {
                        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                          icon: 'warning',
                          title: 'Atenție!',
                          text: 'Asigură-te că toate produsele care necesită rețetă au rețetele complet definite și că pe această locație există serii active pentru documentele „Bon de producție” și „Bon de consum”. Dacă acestea lipsesc, le poți crea din tabul „Serii documente”. În lipsa lor, vânzările pot fi afectate.'
                        });
                      }
                    });

                    _this9.$emit('fetchLocation');
                  } else {
                    var errorMsg = 'A apărut o problemă.';
                    if (response && response.errors && response.errors.length > 0) {
                      errorMsg = response.errors.join(', ');
                    }
                    __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                      icon: 'error',
                      title: isStart ? 'Eroare la pornirea vânzărilor' : 'Eroare la oprirea vânzărilor',
                      text: errorMsg
                    });
                  }
                });
                _context6.next = 19;
                break;

              case 15:
                _context6.prev = 15;
                _context6.t0 = _context6['catch'](0);

                console.error(_context6.t0);
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  icon: 'error',
                  title: 'Eroare neașteptată',
                  text: _context6.t0.message || 'A apărut o eroare.'
                });

              case 19:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[0, 15]]);
      }))();
    },
    checkCompany: function checkCompany() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var url, response, responseData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log('Verificăm compania:', _this10.selectedLocation);

                _context7.prev = 1;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/company?externalCompanyId=' + encodeURIComponent(_this10.companyID);
                _context7.next = 5;
                return fetch(url, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    name: _this10.selectedLocation.inv_company_name || _this10.selectedLocation.name,
                    vatNumber: _this10.selectedLocation.inv_fiscal_code,
                    address: _this10.selectedLocation.inv_address + ' ' + _this10.selectedLocation.inv_city + ' ' + _this10.selectedLocation.inv_county,
                    city: _this10.selectedLocation.inv_city,
                    country: _this10.selectedLocation.inv_county,
                    phone: _this10.selectedLocation.inv_phone,
                    email: _this10.selectedLocation.email || '',
                    inv_bank_account: _this10.selectedLocation.inv_bank_account || '',
                    inv_bank: _this10.selectedLocation.inv_bank || '',
                    inv_bank_branch: _this10.selectedLocation.inv_bank_branch || '',
                    externalCompanyId: _this10.companyID
                  })
                });

              case 5:
                response = _context7.sent;
                _context7.next = 8;
                return response.json();

              case 8:
                responseData = _context7.sent;

                if (response.ok) {
                  _context7.next = 11;
                  break;
                }

                throw new Error(responseData.error || responseData.message || 'Compania nu există');

              case 11:

                console.log('Compania există deja:', responseData);
                return _context7.abrupt('return', responseData);

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7['catch'](1);

                console.error('Error checking company:', _context7.t0);
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  title: 'Eroare!',
                  text: _context7.t0.message || 'A apărut o eroare la verificarea companiei.',
                  type: 'error',
                  timer: 2500,
                  showConfirmButton: false
                });
                throw _context7.t0;

              case 20:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[1, 15]]);
      }))();
    },
    getSeries: function getSeries() {
      var _this11 = this;

      var vatNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var bodyData, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (_this11.companyID) {
                  _context8.next = 3;
                  break;
                }

                console.error('Missing company for fetching series.');
                return _context8.abrupt('return');

              case 3:
                _context8.prev = 3;
                bodyData = {
                  externalCompanyId: _this11.companyID
                };

                if (vatNumber) {
                  bodyData.vatNumber = vatNumber;
                }

                _context8.next = 8;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bodyData)
                });

              case 8:
                response = _context8.sent;

                if (response.ok) {
                  _context8.next = 11;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 11:
                _context8.next = 13;
                return response.json();

              case 13:
                data = _context8.sent;

                _this11.tableDataSeries = (data.series || []).map(function (serie) {
                  var readableTip = '';
                  switch (serie.tip) {
                    case 'nir':
                      readableTip = 'NIR';break;
                    case 'bon_casare':
                      readableTip = 'Bon casare';break;
                    case 'nota_de_consum':
                      readableTip = 'Nota de consum';break;
                    case 'bon_consum':
                      readableTip = 'Bon consum';break;
                    case 'bon_transfer':
                      readableTip = 'Bon de transfer';break;
                    case 'bon_productie':
                      readableTip = 'Bon de productie';break;
                    case 'inventar':
                      readableTip = 'Inventar';break;
                    case 'invoice':
                      readableTip = 'Invoice';break;
                    case 'proforma':
                      readableTip = 'Proforma';break;
                    case 'aviz':
                      readableTip = 'Aviz';break;
                    case 'order':
                      readableTip = 'Order';break;
                    default:
                      readableTip = serie.tip;
                  }

                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, serie, {
                    tip: readableTip
                  });
                });
                _context8.next = 20;
                break;

              case 17:
                _context8.prev = 17;
                _context8.t0 = _context8['catch'](3);

                console.error('Error fetching series:', _context8.t0);

              case 20:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[3, 17]]);
      }))();
    },
    handleDeleteGestiune: function handleDeleteGestiune(row) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (row._id) {
                  _context10.next = 3;
                  break;
                }

                console.error('Lipsește ID-ul gestiunii pentru ștergere.');
                return _context10.abrupt('return');

              case 3:

                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  title: 'Ești sigur că vrei să ștergi această gestiune?',
                  text: 'Această acțiune nu poate fi anulată!',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Da, șterge!',
                  cancelButtonText: 'Anulează'
                }).then(function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9(result) {
                    var gestiuniRamase, response, data, _gestiuniRamase;

                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            if (result) {
                              _context9.next = 2;
                              break;
                            }

                            return _context9.abrupt('return');

                          case 2:
                            if (!_this12.isDefaultForLocation(row._id, row.externalLocationId)) {
                              _context9.next = 8;
                              break;
                            }

                            gestiuniRamase = _this12.tableData.filter(function (g) {
                              return g.externalLocationId === row.externalLocationId && g._id !== row._id;
                            });

                            if (!(gestiuniRamase.length > 0)) {
                              _context9.next = 8;
                              break;
                            }

                            _context9.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                              title: 'Atenție!',
                              text: 'Această gestiune este setată ca default. Selectează mai întâi o altă gestiune default pentru această locație.',
                              type: 'warning',
                              confirmButtonText: 'OK'
                            });

                          case 7:
                            return _context9.abrupt('return');

                          case 8:
                            _context9.prev = 8;

                            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                              type: 'info',
                              title: 'Se șterge gestiunea...',
                              text: 'Vă rugăm să așteptați.',
                              allowOutsideClick: false,
                              allowEscapeKey: false,
                              showConfirmButton: false
                            });

                            _context9.next = 12;
                            return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                              method: 'DELETE',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                type: 'gestiune',
                                id: row._id,
                                externalCompanyId: _this12.companyID
                              })
                            });

                          case 12:
                            response = _context9.sent;

                            if (response.ok) {
                              _context9.next = 15;
                              break;
                            }

                            throw new Error('HTTP error! Status: ' + response.status);

                          case 15:
                            _context9.next = 17;
                            return response.json();

                          case 17:
                            data = _context9.sent;

                            console.log('Gestiunea a fost ștearsă cu succes:', data);

                            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.close();

                            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                              title: 'Succes',
                              text: 'Gestiunea a fost ștearsă cu succes.',
                              type: 'success',
                              timer: 2000,
                              showConfirmButton: false
                            });

                            if (_this12.isDefaultForLocation(row._id, row.externalLocationId)) {
                              _gestiuniRamase = _this12.tableData.filter(function (g) {
                                return g.externalLocationId === row.externalLocationId && g._id !== row._id;
                              });


                              if (_gestiuniRamase.length === 0) {
                                _this12.modifyGestiune({
                                  gestiuneCompanyId: row.externalCompanyId,
                                  gestiuneIdDefault: null,
                                  companyId: _this12.companyID,
                                  locationId: row.externalLocationId
                                }, function () {
                                  _this12.fetchGestiuni();
                                  _this12.$emit('fetchLocation');
                                });
                              } else {
                                _this12.fetchGestiuni();
                                _this12.$emit('fetchLocation');
                              }
                            }

                            _this12.fetchGestiuni();
                            _this12.$emit('fetchLocation');
                            _context9.next = 31;
                            break;

                          case 26:
                            _context9.prev = 26;
                            _context9.t0 = _context9['catch'](8);

                            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.close();
                            console.error('Eroare la ștergerea gestiunii:', _context9.t0);

                            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                              title: 'Eroare',
                              text: _context9.t0.message || 'A apărut o eroare la ștergerea gestiunii.',
                              type: 'error',
                              timer: 2000,
                              showConfirmButton: false
                            });

                          case 31:
                          case 'end':
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this12, [[8, 26]]);
                  }));

                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this12);
      }))();
    },
    handleDeleteSeries: function handleDeleteSeries(id) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (id) {
                  _context12.next = 3;
                  break;
                }

                console.error('Missing series ID for deletion.');
                return _context12.abrupt('return');

              case 3:

                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  title: 'Ești sigur că vrei să ștergi seria?',
                  text: 'Această acțiune nu poate fi anulată!',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Da, șterge!',
                  cancelButtonText: 'Anulează'
                }).then(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11(result) {
                    var response, data;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            if (result) {
                              _context11.next = 2;
                              break;
                            }

                            return _context11.abrupt('return');

                          case 2:
                            _context11.prev = 2;
                            _context11.next = 5;
                            return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                              method: 'DELETE',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                type: 'series',
                                id: id,
                                externalCompanyId: _this13.companyID
                              })
                            });

                          case 5:
                            response = _context11.sent;

                            if (response.ok) {
                              _context11.next = 8;
                              break;
                            }

                            throw new Error('HTTP error! Status: ' + response.status);

                          case 8:
                            _context11.next = 10;
                            return response.json();

                          case 10:
                            data = _context11.sent;

                            console.log('Series deleted successfully:', data);

                            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                              title: 'Succes',
                              text: 'Seria a fost ștearsă cu succes.',
                              type: 'success',
                              timer: 2000,
                              showConfirmButton: false
                            });

                            _this13.getSeries();
                            _context11.next = 20;
                            break;

                          case 16:
                            _context11.prev = 16;
                            _context11.t0 = _context11['catch'](2);

                            console.error('Error deleting series:', _context11.t0);

                            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                              title: 'Eroare',
                              text: _context11.t0.message || 'A apărut o eroare la ștergerea seriei.',
                              type: 'error',
                              timer: 2000,
                              showConfirmButton: false
                            });

                          case 20:
                          case 'end':
                            return _context11.stop();
                        }
                      }
                    }, _callee11, _this13, [[2, 16]]);
                  }));

                  return function (_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 4:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this13);
      }))();
    },
    addBankAccount: function addBankAccount() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this14.bankAccounts.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this14.newAccount));

                _this14.newAccount = { iban: '', bank: '', currency: 'RON', swift: '' };
                _this14.closeBankModal();

              case 3:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this14);
      }))();
    },
    deleteBankAccount: function deleteBankAccount(row) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this15.bankAccounts = _this15.bankAccounts.filter(function (account) {
                  return account !== row;
                });

              case 1:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this15);
      }))();
    }
  }
});

/***/ }),

/***/ "V42J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons "},[_c('div',{staticClass:"left-buttons mar-rt-10"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[(_vm.groupedLocations)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date și oră")]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"disabled":_vm.loading,"placeholder":"Selectează intervalul"},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"right-buttons",staticStyle:{"display":"flex","align-items":"center","justify-content":"flex-end"}},[_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.triggerFilter}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.fetchProductionReport('xls')}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"tableInvoice",staticStyle:{"overflow-x":"auto"}},[(_vm.tableData && _vm.tableData.length)?_c('div',{staticClass:"productieption-total-header"},[_c('strong',[_vm._v("TOTAL:")]),_vm._v("\n            "+_vm._s(_vm.totalItems)+" produse —\n            "),_c('strong',[_vm._v(_vm._s(_vm.totalValue.toFixed(2))+" lei")])]):_vm._e(),_vm._v(" "),_c('el-table',{staticStyle:{"min-width":"max-content"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.openViewProduction}},[_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('gestiune.product'),"min-width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.price'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.price !== null)?_c('span',[_vm._v("\n                  "+_vm._s(Number(scope.row.price).toFixed(2))+" lei\n                ")]):_c('span',{staticStyle:{"cursor":"pointer","text-decoration":"underline","color":"#409EFF"},on:{"click":function($event){_vm.openViewProduction(scope.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.see'))+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.cantitate'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.quantity).toFixed(2))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"UM","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.unit)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.stoc.valoareTotala'),"min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.value).toFixed(2))+" lei\n              ")]}}])})],1)],1)])]),_vm._v(" "),_c('vmodal',{ref:"productionModal",staticClass:"productionModal",attrs:{"name":"productionModal","height":"auto","width":"800"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v("Detalii produs: "+_vm._s(_vm.selectedProduct.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('el-table',{staticStyle:{"width":"100%","background":"transparent"},attrs:{"data":_vm.selectedProduct.productionDocuments}},[_c('el-table-column',{attrs:{"prop":"productId","label":"ID Produs"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":"Cantitate"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.quantity).toFixed(2))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unit","label":"UM"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"Valoare"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.value).toFixed(2))+" lei\n              ")]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeProductionModal}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V4Gz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementStocksTabs_vue__ = __webpack_require__("WFvq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2972e8e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementStocksTabs_vue__ = __webpack_require__("KMI6");
function injectStyle (ssrContext) {
  __webpack_require__("oahL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2972e8e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementStocksTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2972e8e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementStocksTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V5H8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V5v9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6Ob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page login-wrapper"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":"","data-image":"static/img/background/background-2.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-box"},[_vm._m(0),_vm._v(" "),_c('div',[_vm._v("If you were not redirected, please click this "),_c('a',{attrs:{"href":_vm.apiUrl + '/login'}},[_vm._v("Link")]),_vm._v(" in order to get to the TapTasty Dashboard")])])])]),_vm._v(" "),_c('div',{staticClass:"full-page-background"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header text-center"},[_c('a',{attrs:{"href":"//taptasty.com"}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo.png"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V7K+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.zone && _vm.zone.available_days)?_c('div',{staticClass:"zone-availability"},[_c('h5',{staticClass:"zone-availability-title"},[_vm._v(_vm._s(_vm.$t('zoneAvailability.title')))]),_vm._v(" "),_c('div',{staticClass:"zone-availability-switch"},[_c('p-switch',{attrs:{"name":'zaActive_' + _vm.uid,"type":"success"},model:{value:(_vm.zone.active),callback:function ($$v) {_vm.$set(_vm.zone, "active", $$v)},expression:"zone.active"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('zoneAvailability.active')))])],1),_vm._v(" "),_c('small',{staticClass:"text-muted zone-availability-help"},[_vm._v(_vm._s(_vm.$t('zoneAvailability.activeHelp')))]),_vm._v(" "),_c('div',{staticClass:"zone-availability-switch"},[_c('p-switch',{attrs:{"name":'zaSchedule_' + _vm.uid,"type":"success"},model:{value:(_vm.zone.schedule_enabled),callback:function ($$v) {_vm.$set(_vm.zone, "schedule_enabled", $$v)},expression:"zone.schedule_enabled"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('zoneAvailability.scheduleEnabled')))])],1),_vm._v(" "),_c('small',{staticClass:"text-muted zone-availability-help"},[_vm._v(_vm._s(_vm.$t('zoneAvailability.scheduleEnabledHelp')))]),_vm._v(" "),(_vm.zone.schedule_enabled)?[_vm._l((_vm.zone.available_days),function(day,dayIdx){return _c('div',{key:day.day,staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-3 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","id":'za_' + _vm.uid + '_' + day.day},domProps:{"checked":Array.isArray(day.open)?_vm._i(day.open,null)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":'za_' + _vm.uid + '_' + day.day}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + day.day))))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n            from\n            "),_c('el-time-select',{class:{'is-invalid': _vm.isInvalid(day, 0, day.open_from, day.open_to)},attrs:{"disabled":!day.open,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(day.open_from),callback:function ($$v) {_vm.$set(day, "open_from", $$v)},expression:"day.open_from"}}),_vm._v("\n            to\n            "),_c('el-time-select',{class:{'is-invalid': _vm.isInvalid(day, 0, day.open_from, day.open_to)},attrs:{"disabled":!day.open,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(day.open_to),callback:function ($$v) {_vm.$set(day, "open_to", $$v)},expression:"day.open_to"}})],1)]),_vm._v(" "),(day.intervals)?_c('div',{staticClass:"row intervals"},[_vm._l((day.intervals),function(interval,intervalKey){return [_c('div',{staticClass:"col-md-3 padd in-inline-160"}),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd",staticStyle:{"margin-bottom":"12px"}},[_vm._v("\n              from\n              "),_c('el-time-select',{class:{'is-invalid': _vm.isInvalid(day, intervalKey + 1, interval.open_from, interval.open_to)},attrs:{"disabled":!day.open,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(interval.open_from),callback:function ($$v) {_vm.$set(interval, "open_from", $$v)},expression:"interval.open_from"}}),_vm._v("\n              to\n              "),_c('el-time-select',{class:{'is-invalid': _vm.isInvalid(day, intervalKey + 1, interval.open_from, interval.open_to)},attrs:{"disabled":!day.open,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(interval.open_to),callback:function ($$v) {_vm.$set(interval, "open_to", $$v)},expression:"interval.open_to"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",staticStyle:{"width":"35px","height":"35px","padding":"0","margin-left":"8px"},on:{"click":function($event){$event.preventDefault();_vm.deleteInterval(dayIdx, intervalKey)}}},[_c('i',{staticClass:"ti-close"})])],1)]})],2):_vm._e(),_vm._v(" "),(day.open && _vm.hasOverlap(day))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('zoneAvailability.overlap')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn add",attrs:{"disabled":!day.open,"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addInterval(dayIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+"\n        ")])])])}),_vm._v(" "),(_vm.showErrors && _vm.error)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.error))]):_vm._e()]:_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V8Nv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.locationId)?_c('router-link',{staticClass:"btn btn-info",attrs:{"to":'/integrations/platform-menu-imports/' + _vm.locationId}},[_vm._v(_vm._s(_vm.$t('platformMenuImport.title')))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VAZx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VAbv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);






var _components;







/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isTrends: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isTrends: function isTrends() {
      if (this.isTrends) {
        this.getTrends();
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      trends: {
        valid: [__WEBPACK_IMPORTED_MODULE_8_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_8_moment___default()().endOf('month').format('YYYY-MM-DD')],
        location: ''
      },
      showLocations: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      pickerNames: ['date_from', 'date_to'],
      locations: [],
      ordersChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          },
          height: '200px'
        }
      },
      customersChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          },
          height: '200px'
        }
      },
      salesChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '200px',
          axisX: {
            showGrid: false
          },
          showLine: true
        }
      },
      topProdsChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '300px',
          axisX: {
            scaleMinSpace: 30,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      deliveryChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 10,
          showArea: true,
          height: '300px',
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      paymentsChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '300px',
          width: '300px'
        }
      },
      ageChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '300px'
        }
      },
      genderChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '300px'
        }
      }
    };
  },
  created: function created() {
    this.verifyUserLocations();
  },

  methods: {
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details;
      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }
      if (this.locations.length > 1) {
        this.showLocations = true;
        var filterCookie = this.$cookie.get('filter-locations');
        if (filterCookie) {
          filterCookie = JSON.parse(filterCookie);
          this.trends.location = filterCookie[0];
        }
      }
    },
    getTrends: function getTrends() {
      var _this = this;

      if (!this.isTrends) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.trends.valid[0],
        end_date: this.trends.valid[1]
      };
      if (this.trends.location && this.trends.location !== '') {
        data.location_id = this.trends.location;
      }
      this.loading = true;
      var ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : '';
      this.apiRequest('/reports/trends' + ver, 'GET', data, function (response) {
        if (response.status === true) {
          _this.ordersChart.data.labels = response.data.orders.labels;
          _this.ordersChart.data.series = [response.data.orders.delivered];
          _this.ordersChart.title = _this.$t('reports.total') + ' ' + response.data.counters.total_orders;

          _this.$refs.refOrdersChart.initChart();

          _this.customersChart.data.labels = response.data.customers.labels;
          _this.customersChart.data.series = [response.data.customers.values];
          _this.customersChart.title = _this.$t('reports.total') + ' ' + response.data.counters.customers;
          if (_this.$refs.customersChart) {
            _this.$refs.customersChart.initChart();
          }

          _this.salesChart.data.labels = response.data.sales.labels;
          _this.salesChart.data.series = [response.data.sales.values];
          _this.salesChart.title = _this.$t('reports.total') + ' ' + response.data.counters.revenue;
          _this.$refs.salesChart.initChart();

          _this.topProdsChart.data.labels = response.data.top_products['labels'];
          _this.topProdsChart.data.series = [response.data.top_products['values']];
          _this.$refs.topProdsChart.initChart();

          _this.deliveryChart.data.labels = response.data.delivery_types.labels;
          _this.deliveryChart.data.series = [response.data.delivery_types.values];
          _this.$refs.deliveryChart.initChart();

          var customersAgeLb = [];
          if (response.data.customers_age.labels.length) {
            customersAgeLb = response.data.customers_age.labels.map(function (val, key) {
              val = _this.$t('reportsAgesGroups.' + val) + ' - ' + parseFloat(response.data.customers_age.series[key] * 100 / response.data.counters.customers).toFixed(2) + '%';
              return val;
            });
          }
          _this.ageChart.data.labels = customersAgeLb;
          _this.ageChart.data.series = response.data.customers_age.series;
          if (response.data.customers_age.labels.length) {
            _this.$refs.ageChart.initChart();
          }

          var customersGenderLb = [];
          if (response.data.customers_gender.labels.length) {
            customersGenderLb = response.data.customers_gender.labels.map(function (val, key) {
              val = _this.$t('gender.' + val) + ' - ' + parseFloat(response.data.customers_gender.series[key] * 100 / response.data.counters.customers).toFixed(2) + '%';
              return val;
            });
          }
          _this.genderChart.data.labels = customersGenderLb;
          _this.genderChart.data.series = response.data.customers_gender.series;
          if (response.data.customers_gender.labels.length) {
            _this.$refs.genderChart.initChart();
          }
          var totalPayments = response.data.payments.card + response.data.payments.cash;
          if (totalPayments) {
            _this.paymentsChart.data.labels = [_this.$t('reports.card') + ' - ' + parseFloat(response.data.payments.card * 100 / totalPayments).toFixed(2) + '%', _this.$t('reports.cash') + ' - ' + parseFloat(response.data.payments.cash * 100 / totalPayments).toFixed(2) + '%'];
            _this.paymentsChart.data.series = [{
              value: response.data.payments.card,
              name: _this.$t('reports.card')
            }, {
              value: response.data.payments.cash,
              name: _this.$t('reports.cash')
            }];
            _this.$refs.paymentsChart.initChart();
          }

          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    },
    updateData: function updateData() {
      var _this2 = this;

      this.getTrends();
      this.$nextTick(function () {
        _this2.loading = false;
      });
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.trends.location]), 30);
    }
  }
});

/***/ }),

/***/ "VGc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5762af2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceReports_vue__ = __webpack_require__("nUmM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5762af2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VITf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vmodal',{staticClass:"addEditLocationGroupModal",attrs:{"name":"addEditLocationGroupModal","minWidth":1300,"minHeight":900,"adaptive":true}},[_c('location-groups-form',{attrs:{"editData":_vm.editData},on:{"close-modal":function($event){_vm.hideAddLocationGroupModal($event)},"on-submit":function($event){_vm.handleNewLocationGroup($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VJJN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VNNG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DAY_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COURSES; });
/* harmony export (immutable) */ __webpack_exports__["b"] = issuesText;
/* harmony export (immutable) */ __webpack_exports__["d"] = toCents;
/* harmony export (immutable) */ __webpack_exports__["e"] = formatMoney;
/* harmony export (immutable) */ __webpack_exports__["f"] = scalePrices;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);


var DAY_NAMES = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

var COURSES = [1, 2, 3, 4, 5, 6, 7, 8];

function issuesText(vm, issues) {
  return (issues || []).map(function (issue) {
    if (issue.key === 'menu_price_mismatch') {
      return vm.$t('menuSubscriptions.issues.menu_price_mismatch', { menus: (issue.menus || []).join(', ') });
    }
    return vm.$t('menuSubscriptions.issues.' + issue.key);
  }).join('; ');
}

function toCents(value) {
  var number = parseFloat(value);
  return isNaN(number) ? 0 : Math.round(number * 100);
}

function formatMoney(cents) {
  return (cents / 100).toFixed(2);
}

function scalePrices(lines, target) {
  var targetCents = toCents(target);
  if (!lines.length || targetCents < 0) {
    return null;
  }
  var qty = function qty(line) {
    return Math.max(1, parseInt(line.quantity, 10) || 1);
  };

  var weights = lines.map(function (line) {
    return Math.max(0, toCents(line.price)) * qty(line);
  });
  var weightSum = weights.reduce(function (a, b) {
    return a + b;
  }, 0);
  if (weightSum <= 0) {
    weights = lines.map(function (line) {
      return Math.max(0, toCents(line.catalog_price)) * qty(line);
    });
    weightSum = weights.reduce(function (a, b) {
      return a + b;
    }, 0);
  }
  if (weightSum <= 0) {
    weights = lines.map(function (line) {
      return qty(line);
    });
    weightSum = weights.reduce(function (a, b) {
      return a + b;
    }, 0);
  }

  var units = lines.map(function (line, i) {
    return Math.max(0, Math.round(targetCents * weights[i] / weightSum / qty(line)));
  });
  var sum = units.reduce(function (total, unit, i) {
    return total + unit * qty(lines[i]);
  }, 0);
  var diff = targetCents - sum;

  if (diff !== 0) {
    var order = lines.map(function (line, i) {
      return i;
    }).sort(function (a, b) {
      return units[b] * qty(lines[b]) - units[a] * qty(lines[a]);
    });
    var fixed = false;
    var _arr = [true, false];
    for (var _i = 0; _i < _arr.length; _i++) {
      var onlyOne = _arr[_i];var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(order), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          var q = qty(lines[i]);
          if (onlyOne && q !== 1 || diff % q !== 0 || units[i] + diff / q < 0) {
            continue;
          }
          units[i] += diff / q;
          fixed = true;
          break;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (fixed) {
        break;
      }
    }
    if (!fixed) {
      return null;
    }
  }

  return units.map(formatMoney);
}

/***/ }),

/***/ "VO75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-details"},[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p'),_vm._v(" "),_c('p',{},[_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{ref:"compDetailsContainer",staticClass:"mar-to-15",style:({height: _vm.windowHeight - _vm.pageTopHeight - _vm.navbarHeaderHeight - 1 + 'px'})},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingCompany.title')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('settingCompany.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.email_feedback')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email_feedback),expression:"model.email_feedback"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.email_feedback),expression:"modelValidate.email_feedback"}],staticClass:"form-control",attrs:{"type":"text","name":"email_feedback","placeholder":_vm.$t('settingCompany.email_feedback')},domProps:{"value":(_vm.model.email_feedback)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email_feedback", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.$t('settingCompany.email_feedback_helptext')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.lang')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.language),expression:"model.language"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.language),expression:"modelValidate.language"}],staticClass:"form-control",attrs:{"placeholder":" - Select Language - "},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.languages),function(label,key){return _c('option',{key:key,attrs:{"label":label},domProps:{"value":key}},[_vm._v("\n                  "+_vm._s(label)+"\n                ")])})),_vm._v(" "),(_vm.errors.has('language'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('language'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.overEighteen')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.over_eighteen),callback:function ($$v) {_vm.$set(_vm.model, "over_eighteen", $$v)},expression:"model.over_eighteen"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('general.logo')))]),_vm._v(" "),_c('el-upload',{ref:"uploadLogo",attrs:{"action":"","limit":2,"file-list":_vm.imagelistLogo,"list-type":"picture-card","accept":" .jpg, .jpeg, .png, .svg, .webp","on-change":_vm.handleImgChangeLogo,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemoveLogo,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureLogo')))])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('general.appImage')))]),_vm._v(" "),_c('el-upload',{ref:"uploadAppImage",attrs:{"action":"","limit":2,"file-list":_vm.imagelistAppImage,"list-type":"picture-card","accept":" .jpg, .jpeg, .png, .svg, .webp","on-change":_vm.handleImgChangeAppImage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemoveAppImage,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureLogo')))])])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingCompany.deliveryLabels')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.model.delivery_options_labels),function(labelObj){return _c('div',{staticClass:"pad-bt-15 col-md-6"},[_c('label',[_vm._v(" "+_vm._s(_vm.$t('settingCompany.' + labelObj['key']))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(labelObj['label']),expression:"labelObj['label']"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(labelObj['label'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(labelObj, 'label', $event.target.value)}}})])}))])]),_vm._v(" "),_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingCompany.orderStatus')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.allowSoundAtStatusNew')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_allowed_sound_at_new),callback:function ($$v) {_vm.$set(_vm.model, "is_allowed_sound_at_new", $$v)},expression:"model.is_allowed_sound_at_new"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.addStatusOnHold')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_allowed_on_hold),callback:function ($$v) {_vm.$set(_vm.model, "is_allowed_on_hold", $$v)},expression:"model.is_allowed_on_hold"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.addStatusPostponed')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_allowed_postponed),callback:function ($$v) {_vm.$set(_vm.model, "is_allowed_postponed", $$v)},expression:"model.is_allowed_postponed"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.automatedProcessedStatus')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.automated_processed_status),callback:function ($$v) {_vm.$set(_vm.model, "automated_processed_status", $$v)},expression:"model.automated_processed_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.allowSoundAtStatusProcessing')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('settingCompany.allowSoundAtStatusProcessing')},model:{value:(_vm.model.is_allowed_sound_at_processing),callback:function ($$v) {_vm.$set(_vm.model, "is_allowed_sound_at_processing", $$v)},expression:"model.is_allowed_sound_at_processing"}},[_c('el-option',{key:"is_allowed_sound_at_processing1",attrs:{"label":_vm.$t('settingCompany.allowSoundAtStatusProcessingV1'),"value":"1"}}),_vm._v(" "),_c('el-option',{key:"is_allowed_sound_at_processing2",attrs:{"label":_vm.$t('settingCompany.allowSoundAtStatusProcessingV2'),"value":"2"}}),_vm._v(" "),_c('el-option',{key:"is_allowed_sound_at_processing3",attrs:{"label":_vm.$t('settingCompany.allowSoundAtStatusProcessingV3'),"value":"3"}}),_vm._v(" "),_c('el-option',{key:"is_allowed_sound_at_processing0",attrs:{"label":_vm.$t('settingCompany.allowSoundAtStatusProcessingV0'),"value":"0"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.allowSoundForMehods')))]),_vm._v(" "),_c('v-select',{staticClass:"line-heigth-44",attrs:{"multiple":"","options":_vm.deliveryMethods,"placeholder":_vm.$t('general.all')},model:{value:(_vm.model.sound_delivery_methods),callback:function ($$v) {_vm.$set(_vm.model, "sound_delivery_methods", $$v)},expression:"model.sound_delivery_methods"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.alertMultipleOrders')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.alert_multiple_orders_per_hour),expression:"model.alert_multiple_orders_per_hour"}],staticClass:"form-control",attrs:{"type":"number","step":"1","min":"5","max":"500","placeholder":_vm.$t('settingCompany.alertMultipleOrdersNr')},domProps:{"value":(_vm.model.alert_multiple_orders_per_hour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "alert_multiple_orders_per_hour", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('settingCompany.initalOrderStatusApp')))]),_vm._v(" "),_c('v-select',{key:'has-receipt-select',staticClass:"w-100 white mar-bt-15 line-heigth-44",attrs:{"options":_vm.orderStatusOptions,"label":"label","placeholder":_vm.$t('ordersStatus.NEW')},model:{value:(_vm.model.initial_order_status_app_web),callback:function ($$v) {_vm.$set(_vm.model, "initial_order_status_app_web", $$v)},expression:"model.initial_order_status_app_web"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"card-containerf1"},[_c('div',{staticClass:"card location-card 50-width"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"flex-container"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingsTips.tipsLabel')))]),_vm._v(" "),_c('p-switch',{staticClass:"mar-bt-0",attrs:{"type":"success"},model:{value:(_vm.model.tips_in_use),callback:function ($$v) {_vm.$set(_vm.model, "tips_in_use", $$v)},expression:"model.tips_in_use"}})],1),_vm._v(" "),_c('hr',{staticClass:"mar-to-5"}),_vm._v(" "),_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsTips.tipsVat')))]),_vm._v(" "),(_vm.model && _vm.taxesVersion === 2)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tips_vat_rate_id),expression:"model.tips_vat_rate_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "tips_vat_rate_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{key:vat.id,attrs:{"disabled":!vat.is_active && String(vat.id) !== String(_vm.model.tips_vat_rate_id)},domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.rate)+"%"+_vm._s(!vat.is_active ? ' (inactiv)' : '')+"\n                    ")])})],2):(_vm.model)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tips_taxes),expression:"model.tips_taxes"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "tips_taxes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{attrs:{"id":vat.id},domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.amount)+"\n                    ")])}),_vm._v(" "),(_vm.model.tips_taxes !== null)?_c('option',{staticStyle:{"display":"none"},domProps:{"value":_vm.model.tips_taxes}},[_vm._v(_vm._s(_vm.model.tips_taxes))]):_vm._e()],2):_vm._e(),_vm._v(" "),(Array.isArray(_vm.model.tips_taxes) && _vm.errors.has('tips_taxes'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('tips_taxes'))+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.posid')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tips_pos_id),expression:"model.tips_pos_id"}],staticClass:"form-control",attrs:{"type":"string","placeholder":_vm.$t('catalogProd.posid')},domProps:{"value":(_vm.model.tips_pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "tips_pos_id", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has(_vm.model.tips_pos_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError(_vm.model.tips_pos_id))+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('general.tips_department_id')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tips_department_id),expression:"model.tips_department_id"}],staticClass:"form-control",attrs:{"type":"string","placeholder":_vm.$t('general.tips_department_id')},domProps:{"value":(_vm.model.tips_department_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "tips_department_id", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has(_vm.model.tips_department_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError(_vm.model.tips_department_id))+"\n                  ")]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card 50-width"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingCompany.sortProductsMethods')))]),_vm._v(" "),_c('hr',{staticClass:"mar-to-15"}),_vm._v(" "),_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.sort_product_method),expression:"model.sort_product_method"}],staticClass:"form-control",attrs:{"name":"sort_products_method"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "sort_product_method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sortMethodsList),function(opt,key){return _c('option',{domProps:{"value":key,"selected":key === _vm.model.sort_product_method}},[_vm._v(_vm._s(_vm.$t('settingCompany.'+key)))])}))])])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingCompany.languages')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"clearfix form-group"},[_c('div',{staticClass:"col-lg-8 col-md-8"},[_c('v-select',{attrs:{"multiple":"","options":_vm.dbLanguagesOptions,"placeholder":_vm.$t('general.all')},model:{value:(_vm.model.selected_languages),callback:function ($$v) {_vm.$set(_vm.model, "selected_languages", $$v)},expression:"model.selected_languages"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingCompany.preferences')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('settingCompany.initalOrderStatusKiosk')))]),_vm._v(" "),_c('v-select',{key:'has-receipt-select',staticClass:"w-100 white mar-bt-15 line-heigth-44",attrs:{"options":_vm.selfOrderStatusOptions,"label":"label","placeholder":_vm.$t('ordersStatus.NEW')},model:{value:(_vm.initalOrderStatusKiosk),callback:function ($$v) {_vm.initalOrderStatusKiosk=$$v},expression:"initalOrderStatusKiosk"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.allowPlaceUntilCloseHour')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_order_until_close_hour),callback:function ($$v) {_vm.$set(_vm.model, "allow_order_until_close_hour", $$v)},expression:"model.allow_order_until_close_hour"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.removeTotalsExtrasFromDiscount')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.remove_totals_extras_from_discount),callback:function ($$v) {_vm.$set(_vm.model, "remove_totals_extras_from_discount", $$v)},expression:"model.remove_totals_extras_from_discount"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.allow_fiscal_print')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.print_fiscal_from_dashboard),callback:function ($$v) {_vm.$set(_vm.model, "print_fiscal_from_dashboard", $$v)},expression:"model.print_fiscal_from_dashboard"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.payment_btns_v2')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.payment_btns_v2),callback:function ($$v) {_vm.$set(_vm.model, "payment_btns_v2", $$v)},expression:"model.payment_btns_v2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.just_card_txt_to_kiosk')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.just_card_txt_to_kiosk),callback:function ($$v) {_vm.$set(_vm.model, "just_card_txt_to_kiosk", $$v)},expression:"model.just_card_txt_to_kiosk"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.add_packing_method_to_comment')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.add_packing_method_to_comment),callback:function ($$v) {_vm.$set(_vm.model, "add_packing_method_to_comment", $$v)},expression:"model.add_packing_method_to_comment"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.allowToOrderUnderMinValueWithCoupon')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_allowed_order_under_min_value),callback:function ($$v) {_vm.$set(_vm.model, "is_allowed_order_under_min_value", $$v)},expression:"model.is_allowed_order_under_min_value"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.useGrandTotalForDeliveryZoneShippingCost')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.use_order_grandtotal_for_shipping_discount),callback:function ($$v) {_vm.$set(_vm.model, "use_order_grandtotal_for_shipping_discount", $$v)},expression:"model.use_order_grandtotal_for_shipping_discount"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.flagFastOrderFromAdmin')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.flag_fast_order_from_admin),callback:function ($$v) {_vm.$set(_vm.model, "flag_fast_order_from_admin", $$v)},expression:"model.flag_fast_order_from_admin"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.jump_to_categories_menu')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.jump_to_menu),callback:function ($$v) {_vm.$set(_vm.model, "jump_to_menu", $$v)},expression:"model.jump_to_menu"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 "},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.purchase_limit_interval_hours')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.purchase_limit_interval_hours),expression:"model.purchase_limit_interval_hours"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('settingCompany.purchase_limit_interval_hours')},domProps:{"value":(_vm.model.purchase_limit_interval_hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "purchase_limit_interval_hours", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12",staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6"})])])]),_vm._v(" "),_c('div',{staticClass:"card-containerf1"},[_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingCompany.unavailableRestaurantTitle')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-lg-6 col-md-6",staticStyle:{"clear":"both"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.unavailableRestaurantText')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.unavailable_text),expression:"model.unavailable_text"}],staticClass:"form-control",attrs:{"rows":"6","placeholder":_vm.$t('settingCompany.unavailableRestaurantTextPlaceHolder')},domProps:{"value":(_vm.model.unavailable_text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "unavailable_text", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.unavailableRestaurantImage')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingCompany.smsoIntegration')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"clearfix form-group"},[_c('div',{staticClass:"col-lg-8 col-md-8"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.smsoToken')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.smso_token),expression:"model.smso_token"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"zxQcP6vCIfMMjtrqxzLp1Pdfg1dKLx5D8StJmtgzno"},domProps:{"value":(_vm.model.smso_token)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "smso_token", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.smsoSender')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.smso_sender),expression:"model.smso_sender"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"420"},domProps:{"value":(_vm.model.smso_sender)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "smso_sender", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"clearfix form-group"},[_c('div',{staticClass:"col-lg-8 col-md-8"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.smsoTokenExtern')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.smso_token_extern),expression:"model.smso_token_extern"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"zxQcP6vCIfMMjtrqxzLp1Pdfg1dKLx5D8StJmtgzno"},domProps:{"value":(_vm.model.smso_token_extern)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "smso_token_extern", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.smsoSenderExtern')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.smso_sender_extern),expression:"model.smso_sender_extern"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"420"},domProps:{"value":(_vm.model.smso_sender_extern)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "smso_sender_extern", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-containerf1"},[_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingCompany.pos')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('form',{staticClass:"clearfix"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.use_pos_notifications')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.use_pos_notifications),callback:function ($$v) {_vm.$set(_vm.model, "use_pos_notifications", $$v)},expression:"model.use_pos_notifications"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.use_clients_offline')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.use_clients_offline),callback:function ($$v) {_vm.$set(_vm.model, "use_clients_offline", $$v)},expression:"model.use_clients_offline"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.use_gift_card_on_pos')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.use_gift_card_on_pos),callback:function ($$v) {_vm.$set(_vm.model, "use_gift_card_on_pos", $$v)},expression:"model.use_gift_card_on_pos"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingCompany.app')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('form',{staticClass:"clearfix"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.use_interactive_tour_first_login')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.use_interactive_tour_first_login),callback:function ($$v) {_vm.$set(_vm.model, "use_interactive_tour_first_login", $$v)},expression:"model.use_interactive_tour_first_login"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.use_interactive_tour_always')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.use_interactive_tour_always),callback:function ($$v) {_vm.$set(_vm.model, "use_interactive_tour_always", $$v)},expression:"model.use_interactive_tour_always"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.force_location_from_deeplink')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.force_location_from_deeplink),callback:function ($$v) {_vm.$set(_vm.model, "force_location_from_deeplink", $$v)},expression:"model.force_location_from_deeplink"}})],1)])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VSbs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VWkf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsList_vue__ = __webpack_require__("lNIM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f2a887e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsList_vue__ = __webpack_require__("4Brd");
function injectStyle (ssrContext) {
  __webpack_require__("YGbk")
  __webpack_require__("pWAP")
  __webpack_require__("1z+n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f2a887e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f2a887e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VWtb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__);





















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a),
  props: {},
  created: function created() {
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      tableColumns: [{
        prop: 'type',
        label: this.$t('settingTable.type'),
        minWidth: 50
      }, {
        prop: 'location_name',
        label: this.$t('settingTable.location'),
        minWidth: 50
      }, {
        prop: 'section.name',
        label: this.$t('kds.name'),
        minWidth: 50
      }],
      modelData: []
    };
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {
      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/pos/screen/edit/');
      }
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        type: 2,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos/all/screens', 'GET', data, function (response) {
        if (response.status === true) {
          _this.modelData = response.data.screens;
          _this.$nextTick(function () {
            this.loading = false;
          });
        }
      });
    },
    goToAdd: function goToAdd() {
      this.$router.push('/pos/screen/add');
    },
    copyToClipboard: function copyToClipboard(url) {
      url = url.replace(/\s/g, '');
      this.$copyText(url);
    },
    deleteOrderScreen: function deleteOrderScreen(id) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.loadingReset = true;
      });
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/pos/screens/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          _this2.$nextTick(function () {
            _this2.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        } else {
          _this2.$nextTick(function () {
            _this2.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ 'text': _this2.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
        _this2.getData();
      });
    }
  }
});

/***/ }),

/***/ "VamX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltDriveIntegrationForm_vue__ = __webpack_require__("d6ta");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltDriveIntegrationForm_vue__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltDriveIntegrationForm_vue__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltDriveIntegrationForm_vue__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72496cd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WoltDriveIntegrationForm_vue__ = __webpack_require__("cZgj");
function injectStyle (ssrContext) {
  __webpack_require__("GfWv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72496cd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltDriveIntegrationForm_vue__["d" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72496cd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WoltDriveIntegrationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["d"] = (Component.exports);


/***/ }),

/***/ "VjbB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"col-md-12"},[(_vm.showLocations)?_c('div',{staticClass:"pull-left mar-rt-10"},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.products.location),expression:"products.location"}],staticClass:"form-control inline-auto white ",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.products, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(" "+_vm._s(loc.name)+"\n              ")])]})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pull-left mar-rt-10"},[_c('v-select',{key:'name',ref:'name',attrs:{"multiple":"","options":_vm.category,"value":"name","label":"name","placeholder":_vm.$t('general.all')},on:{"input":_vm.resetCategorySelect},model:{value:(_vm.topCategorySelected),callback:function ($$v) {_vm.topCategorySelected=$$v},expression:"topCategorySelected"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left mar-rt-10"},[_c('v-select',{key:'name',ref:'name',attrs:{"multiple":"","options":_vm.allCategories,"value":"name","label":"name","placeholder":_vm.$t('general.all')},model:{value:(_vm.categorySelected),callback:function ($$v) {_vm.categorySelected=$$v},expression:"categorySelected"}})],1),_vm._v(" "),_c('p',{class:{'pull-left': true, 'sales-rectify-date-picker-padding': !_vm.showLocations}},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.products.valid),callback:function ($$v) {_vm.$set(_vm.products, "valid", $$v)},expression:"products.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"pull-right search-button-reports",attrs:{"title":_vm.$t('reports.export')}},[(this.$route.query && this.$route.query.ver !== 'V2')?_c('download-excel',{staticClass:"btn btn-icon btn-xls",attrs:{"data":_vm.json_data,"export-fields":_vm.jsonFields,"name":_vm.export_name}},[_vm._v("\n            "+_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})]):_vm._e(),_vm._v(" "),(this.$route.query && this.$route.query.ver !== 'V2')?_c('download-excel',{staticClass:"btn btn-icon mar-rt-40 btn-xls",attrs:{"data":_vm.custom_json_data,"export-fields":_vm.customJsonFields,"name":_vm.export_name}},[_vm._v("\n            "+_vm._s(_vm.$t('general.download_xls'))+" "+_vm._s(_vm.$t('general.detail'))),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})]):_vm._e(),_vm._v(" "),(this.$route.query && this.$route.query.ver === 'V2')?_c('download-excel',{staticClass:"btn btn-icon mar-rt-40 btn-xls",attrs:{"fetch":_vm.productExportData,"fields":_vm.jsonFieldsV2,"name":_vm.export_name,"before-generate":_vm.startDownload,"before-finish":_vm.finishDownload}},[_vm._v("\n            "+_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h5',{staticClass:"pad-bt-10 mar-to-15 display-flex justify-space-evenly"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.totalProducts'))+": "+_vm._s(_vm.totalQuantity))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('reports.totalSum'))+": "+_vm._s(_vm.formatMoneyAmount(_vm.totalSum.toFixed(2))))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content total-pagination"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsProductsTable",staticClass:"remove-row-highlight",staticStyle:{"width":"100%"},attrs:{"data":_vm.productsTableData.data,"search-def":{show: false},"total":_vm.totalRecords,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"min-width":100,"prop":"name","label":_vm.$t('reports.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"qty","label":_vm.$t('reports.quantity')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":70,"prop":"price","label":_vm.$t('reports.pricePerUnit')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(props.row.price)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"total_sales_value","label":_vm.$t('reports.totalSum')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(props.row.total_sales_value)))])]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VjcE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VkJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"report-filters",staticStyle:{"align-items":"end"}},[_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 form-group pull-left"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.location),expression:"filters.location"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onLocationChange]}},_vm._l((_vm.locations),function(loc,index){return _c('option',{key:index,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])}))]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6 col-xs-12 form-group pull-left"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.$t('stock.product')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","remote-method":_vm.searchProducts,"loading":_vm.loadingProducts,"disabled":!_vm.filters.location,"placeholder":_vm.$t('stock.productNamePlaceholder')},on:{"change":_vm.onProductChange},model:{value:(_vm.filters.product),callback:function ($$v) {_vm.$set(_vm.filters, "product", $$v)},expression:"filters.product"}},_vm._l((_vm.productOptions),function(product){return _c('el-option',{key:product.id,attrs:{"label":product.name + ' (#' + product.id + ')',"value":product.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left",staticStyle:{"margin-bottom":"34px"}},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",class:{ disabled: !_vm.canSearch },attrs:{"title":_vm.$t('reports.search')},on:{"click":function($event){_vm.getData(null)}}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left",staticStyle:{"margin-bottom":"34px"}},[_c('div',{staticClass:"btn btn-icon btn-info btn-print",class:{ disabled: !_vm.canSearch },attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_c('i',{staticClass:"ti-file"})])])]),_vm._v(" "),_c('div',{staticClass:"card-content total-pagination pad-15"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.movementsTableData,"search-def":{ show: false },"total":_vm.totalMovements,"pagination-props":_vm.paginationProps,"table-props":_vm.tableOptions},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"min-width":60,"prop":"id","label":"Id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"label":"Data"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.created_at))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"prop":"stock_movement","label":"Cantitate stoc"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"prop":"old_stock","label":"Stoc vechi"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"prop":"new_stock","label":"Stoc nou"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":140,"label":_vm.$t('reports.stockMovementType')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(_vm.typeLabel(props.row.type)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"label":"Comanda"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.order_id || props.row.order_app_id || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"label":"Optiune"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.is_option ? 'DA' : 'NU'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":140,"label":"Utilizator"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.user_name || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"label":_vm.$t('reports.stockMovementUserRole')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.user_role || '-'))])]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VmTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaxesV2_vue__ = __webpack_require__("LFMz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3638cd08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaxesV2_vue__ = __webpack_require__("YShu");
function injectStyle (ssrContext) {
  __webpack_require__("eYd0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3638cd08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaxesV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3638cd08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaxesV2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vmvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementWastedForm_vue__ = __webpack_require__("5h+L");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneStocuriForm', __WEBPACK_IMPORTED_MODULE_7__ManagementWastedForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "VqRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vmodal',{staticClass:"addSupplierModal",attrs:{"name":"addSupplierModal","height":"auto","width":"920","adaptive":true,"scrollable":true},on:{"opened":_vm.onSupplierModalOpened}},[_c('div',{staticClass:"supplier-modal card"},[_c('div',{staticClass:"card-content supplier-modal__content"},[_c('div',{staticClass:"supplier-modal__header"},[_c('h5',{staticClass:"supplier-modal__title"},[_vm._v("\n            "+_vm._s(_vm.editMode ? 'Editează furnizor' : _vm.$t('gestiune.addSupplier'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"supplier-modal__body"},[_c('div',{staticClass:"row supplier-modal__toolbar"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group supplier-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],key:'supplier-location-' + _vm.selectedLocationId,staticClass:"form-control supplier-modal__select",attrs:{"disabled":_vm.editMode},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":String(group.vat)}},_vm._l((group.locations),function(loc){return _c('option',{key:String(loc.true_id),domProps:{"value":String(loc.true_id)}},[_vm._v("\n                      "+_vm._s(loc.name)+"\n                    ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group supplier-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.searchByCUI')))]),_vm._v(" "),_c('form',{staticClass:"supplier-modal__search",on:{"submit":function($event){$event.preventDefault();return _vm.searchSupplier($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCUI),expression:"searchCUI"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":_vm.$t('gestiune.searchByCUI')},domProps:{"value":(_vm.searchCUI)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchCUI=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm supplier-modal__search-btn",attrs:{"type":"submit"}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.search'))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row supplier-modal__form-grid"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group supplier-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.companyName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.companyName),expression:"supplier.companyName"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.supplier.companyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "companyName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group supplier-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.abbreviation'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.abbreviation),expression:"supplier.abbreviation"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.supplier.abbreviation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "abbreviation", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group supplier-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.CUI'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.CUI),expression:"supplier.CUI"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.supplier.CUI)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "CUI", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group supplier-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.registrationNumber'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.registrationNumber),expression:"supplier.registrationNumber"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.supplier.registrationNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "registrationNumber", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group supplier-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.email'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.email),expression:"supplier.email"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.supplier.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group supplier-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.dueDays'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.dueDays),expression:"supplier.dueDays"}],staticClass:"form-control input-sm",attrs:{"type":"number"},domProps:{"value":(_vm.supplier.dueDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "dueDays", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group supplier-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.address'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.address),expression:"supplier.address"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.supplier.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "address", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group supplier-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.bank'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bank),expression:"supplier.bank"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.supplier.bank)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bank", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group supplier-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.IBAN'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.IBAN),expression:"supplier.IBAN"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.supplier.IBAN)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "IBAN", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"supplier-modal__footer"},[_c('a',{staticClass:"btn btn-danger btn-icon delete",on:{"click":function($event){_vm.closeAddSupplierModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('general.cancel2'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success save",on:{"click":function($event){_vm.saveSupplier()}}},[_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VqcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs",attrs:{"direction":"vertical","value":"Description"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('kds.ods')}},[(_vm.isOds)?_c('ods',{attrs:{"isOds":_vm.isOds}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.digitalSignage')}},[(_vm.isDigitalSignage)?_c('digital-signage'):_vm._e()],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vqwd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayQrApp_vue__ = __webpack_require__("myqB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9cdc170_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayQrApp_vue__ = __webpack_require__("DUbD");
function injectStyle (ssrContext) {
  __webpack_require__("2cDa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayQrApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9cdc170_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayQrApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vsht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementForOrdersSuppliersEdit_vue__ = __webpack_require__("cLGC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fe508b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementForOrdersSuppliersEdit_vue__ = __webpack_require__("Xkp9");
function injectStyle (ssrContext) {
  __webpack_require__("l4iL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fe508b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementForOrdersSuppliersEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fe508b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementForOrdersSuppliersEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W0tZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAxCAYAAABd2WCOAAAABHNCSVQICAgIfAhkiAAAA5dJREFUWEftWU1u2kAUfgNESlalJwg9QekJCptKZBOyrJqocIKQEzQ5QekJYougLks3SdQN9AQhJyi9AazSqjTT7/kvthnjGWyvykhREvvNm2++9/zNmxlBCe12KA+lpDZe1/DTSLIzeQ5/cyFoSoImVCK79VbMVP1F/OHNQDbQ6UNeQFJAW7t/6KzZFfOwXQTU7UCeSkF9k9lntWX2KiVqvnknpr6vANT1lezhn49ZB9mkfxyYA8oL2XgThzn2mSGUrziULqgryYBySeZMICVdtE7EubgeyDa+iC+ZnOXUmcN4cCKeC7Bkwef7nPxmdgNgR8zUBEy91vC2QIcO4v30+QrqqCYkic6EhB49NV9m0odBCJkp+EhvPANQO4pb4iNhMXzpP4fdJ9j1Vuz0I2JrgyJJTSThJD7YCtNesirs+ojIadr0Manv2qBgPNpbUjesvglSEnzaPoCbz7Iml3QHUNVcQbGzYO3iv4mqyK/6mkHCrGrLjRFTaTPM6/0WlC6TpkyxTlnII1cWSlSTj9AttcbZSDrLyUPOPVfPDnWAGYFiQTw4FpGyZnwpqw87NAXQ/dCAdutYMIhI0xVpI1BZdQryce4Vj2sJMwNFZIGBbtjjt6GsLx9pHNOfCeyaYTtm9NcO3eFZLS2EpqA4P3g947VyjnxijWokCOIMtiO2QycGwjqVCsjJQRNFT5thXu+3oHSZ3IQp1p+ZPwB2PlxfheXAeeU4Ru4Fdm7u6dRshjmlKEm8r4pBPgsx8RVfH29iIy1edyUxZ8ZUxnqqGJ1KYOqhQj/CssB1FyrPoxWmNHdMZky5o1hQ5SCnkF8dlf4wMFEK1ejS0Sn+SW2bgEp1mtVgC0qXQXOmJN1jTYsc22gNJqim0jNVX1NQyjpJB1RC3aXsagYqQad0QLFNITqlqjx1ATmgitApZ89Xoj7WuwkPsveb7uPHgmGQzgZU0n5JUhW/edlhTUttZuGLu0sJp264VtxmKvL+J1BgzjY5n4oyXRBTWE8vGJTWEc1KhhYEis/BxMYnw8WAWqBA5NMcIt3da4StIkD5p8M8EG8q/0pns6jf8gaFdXV3SY3gHN1R3KHsIMkutVHlC2pRFtTwr0IidzNGwHICheXrZ0VQW3k34zPknQ/wF7l+S1SmF0lXY06e6t312Lj66K29xQqHzgPH61UddXlQD/HM8KwfPxZShd27OOB1z92C+fWYQA1fplHSpP4Bee1a/oXZnE0AAAAASUVORK5CYII="

/***/ }),

/***/ "W3Kt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"mar-lt-20"},[_c('label',{staticClass:"pad-bt-5"},[_vm._v(_vm._s(_vm.$t('upload.uploadLabel')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","file-list":_vm.fileList,"on-change":_vm.handleChange,"on-remove":_vm.handleRemove,"on-exceed":_vm.handleExceed,"limit":1,"auto-upload":false,"accept":".pdf"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v(_vm._s(_vm.$t('upload.browse')))]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pdfSize')))]),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions"})],1)],1),_vm._v(" "),(_vm.location.qr_code)?[_c('div',{staticClass:"col-md-12 px-0"},[_c('img',{attrs:{"src":_vm.location.qr_code}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-5 ml-4 px-0"},[_c('a',{staticClass:"btn btn-info btn-icon duplicate-prod",attrs:{"href":this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + this.location.qr_code + '&name=' + _vm.location.city + ' ' + _vm.location.name + '.png',"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('upload.download')))])]),_vm._v(" "),(_vm.location.qr_code)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11 col-sm-5"},[_c('input',{ref:"clone",staticClass:"form-control",attrs:{"readonly":""},domProps:{"value":_vm.location.qr_code_url},on:{"focus":function($event){$event.target.select()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-sm-1"},[_c('button',{staticClass:"btn btn-info btn-icon duplicate-prod mar-to-3",on:{"click":function($event){$event.preventDefault();return _vm.copy($event)}}},[_c('i',{staticClass:"fa fa-copy"})])])]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W4Mh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Location_vue__ = __webpack_require__("d7/C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eb2db60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__ = __webpack_require__("mq1i");
function injectStyle (ssrContext) {
  __webpack_require__("Hqz5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Location_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eb2db60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W50H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W5NO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W5NV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('pos-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W7NN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CantarAdd_vue__ = __webpack_require__("RU0y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10360355_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CantarAdd_vue__ = __webpack_require__("lWw+");
function injectStyle (ssrContext) {
  __webpack_require__("BK0Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CantarAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10360355_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CantarAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WEM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscriptionMenus_vue__ = __webpack_require__("vIJo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15a97491_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscriptionMenus_vue__ = __webpack_require__("gBHD");
function injectStyle (ssrContext) {
  __webpack_require__("vWzQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscriptionMenus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15a97491_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscriptionMenus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WFvq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Stocks_ManagementStocks_vue__ = __webpack_require__("bTak");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Transfer_ManagementTransfer_vue__ = __webpack_require__("WO6t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Management_Inventory_ManagementInventory_vue__ = __webpack_require__("NdNc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Management_InitialStock_ManagementInitialStock_vue__ = __webpack_require__("EKzd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Management_Wasted_ManagementWasted_vue__ = __webpack_require__("DBPj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Management_Nomenclator_ManagementBonProduct_vue__ = __webpack_require__("deWJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Management_ManagementLot_vue__ = __webpack_require__("lLZK");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementStocks: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Stocks_ManagementStocks_vue__["a" /* default */],
    ManagementTransfer: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Transfer_ManagementTransfer_vue__["a" /* default */],
    ManagementInventory: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Management_Inventory_ManagementInventory_vue__["a" /* default */],
    ManagementInitialStock: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Management_InitialStock_ManagementInitialStock_vue__["a" /* default */],
    ManagementWasted: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Management_Wasted_ManagementWasted_vue__["a" /* default */],
    ManagementBonProduct: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Management_Nomenclator_ManagementBonProduct_vue__["a" /* default */],
    ManagementLot: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Management_ManagementLot_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isBonConsum: false,
      isBonTransfer: false,
      isInventar: false,
      isCasare: false,
      isInitialStock: true,
      isBonProduct: false,
      isLot: false
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  created: function created() {},

  methods: {
    openBonConsum: function openBonConsum() {
      this.isBonConsum = true;
      this.isBonTransfer = false;
      this.isInventar = false;
      this.isInitialStock = false;
      this.isCasare = false;
      this.isBonProduct = false;
      this.isLot = false;
    },
    openBonTrasnfer: function openBonTrasnfer() {
      this.isBonConsum = false;
      this.isBonTransfer = true;
      this.isInventar = false;
      this.isInitialStock = false;
      this.isCasare = false;
      this.isBonProduct = false;
      this.isLot = false;
    },
    openInventar: function openInventar() {
      this.isBonConsum = false;
      this.isBonTransfer = false;
      this.isInventar = true;
      this.isInitialStock = false;
      this.isCasare = false;
      this.isBonProduct = false;
      this.isLot = false;
    },
    openInitialStock: function openInitialStock() {
      this.isBonConsum = false;
      this.isBonTransfer = false;
      this.isInventar = false;
      this.isInitialStock = true;
      this.isCasare = false;
      this.isBonProduct = false;
      this.isLot = false;
    },
    openCasare: function openCasare() {
      this.isBonConsum = false;
      this.isBonTransfer = false;
      this.isInventar = false;
      this.isInitialStock = false;
      this.isCasare = true;
      this.isBonProduct = false;
      this.isLot = false;
    },
    openBonProduct: function openBonProduct() {
      this.isBonProduct = true;
      this.isLot = false;
      this.isBonConsum = false;
      this.isBonTransfer = false;
      this.isInventar = false;
      this.isInitialStock = false;
      this.isCasare = false;
    },
    openLot: function openLot() {
      this.isBonProduct = false;
      this.isLot = true;
      this.isBonConsum = false;
      this.isBonTransfer = false;
      this.isInventar = false;
      this.isInitialStock = false;
      this.isCasare = false;
    }
  }
});

/***/ }),

/***/ "WFzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__ = __webpack_require__("x/a9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ca0e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__ = __webpack_require__("qAvE");
function injectStyle (ssrContext) {
  __webpack_require__("iDTm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ca0e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WI53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("hJZU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bdd0322_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("DI0V");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bdd0322_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WKBS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscriptionPage_vue__ = __webpack_require__("iLVZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be36dba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionPage_vue__ = __webpack_require__("Hwfw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscriptionPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be36dba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WN5T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__);















var _components;








__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PSwitch: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_17_vuedraggable___default.a
  }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tableId: null,
    callback: {
      required: false
    },
    kdsSectionsParent: {
      type: Array,
      required: true
    }
  },
  watch: {
    tableId: function tableId(value) {
      this.id = value;
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var companyData;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.apiUrl = "https://gatewaydev.taptasty.com/";
              _this.deliveryMethods = _this.getCompanyDetail('delivery_options_labels');

              companyData = _this.$session.get('selectedCompanyData');

              _this.locations = companyData.locations_details;

              _this.showLocations = true;

              _context.next = 7;
              return _this.getData();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      apiUrl: '',
      roles: [],
      allProducts: [],
      allProductsHidden: [],
      selectedIdsForProducts: [],
      searchTimeout: null,
      searchProductsLoading: false,
      deletedOptionValues: [],
      vatOptions: [],
      taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
      id: this.value || this.tableId,
      showLocations: false,
      locations: [],
      optionValuesData: null,
      optionTypes: {
        'checkbox': this.$t('checkbox'),
        'radio': this.$t('radio'),
        'upload': this.$t('productOptions.upload')
      },
      showTypes: {
        null: 'Default',
        'grid': 'Grid',
        'inline': 'In linie'
      },
      showTypesKiosk: {
        null: 'Default',
        'default': 'Default with images',
        'steps': 'In Steps'
      },
      model: false,
      modelValidate: {
        name: { required: true },
        type: { required: true },
        status: { required: true }
      },
      languages: this.$session.get('defaultData')['available_languages'],
      loading: true,
      deliveryMethods: [],
      optionDeliveryMethods: [],
      initialOptionDeliveryMethods: [],
      optionLocationDetails: [],
      initialOptionLocationDetails: [],
      sourceOptions: [{ key: 'website', label: 'Website' }, { key: 'qr', label: 'QR' }, { key: 'kiosk', label: 'Kiosk' }, { key: 'pos', label: 'POS' }, { key: 'app', label: 'App' }, { key: 'glovo', label: 'Glovo' }, { key: 'bolt', label: 'Bolt' }, { key: 'wolt', label: 'Wolt' }],
      optionSources: [],
      initialOptionSources: []
    };
  },

  methods: {
    getVatOptions: function getVatOptions(locaitonIds) {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_ids: locaitonIds
      };
      var endpoint = this.taxesVersion === 2 ? '/taxes-v2/vat-rates' : '/location/vat';
      this.apiRequest(endpoint, 'GET', data, function (response) {
        if (response.status === true) {
          _this2.vatOptions = response.data;
        }
      });
    },
    isVatOptionDisabled: function isVatOptionDisabled(vat, selectedId) {
      return !!(this.taxesVersion === 2 && vat && !vat.is_active && String(vat.id) !== String(selectedId));
    },
    searchProducts: function searchProducts(query) {
      var _this3 = this;

      this.searchProductsLoading = true;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(function () {
        _this3.fetchProducts(query);
      }, 1000);
    },
    fetchProducts: function fetchProducts() {
      var _this4 = this;

      var searchText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this4.selectedIdsForProducts = [];
                  _this4.optionValuesData.forEach(function (el) {
                    if (el.product_id) {
                      _this4.selectedIdsForProducts.push(el.product_id);
                    }
                  });
                  _this4.searchProductsLoading = true;
                  var data = {
                    token: _this4.$session.get('token'),
                    company_id: _this4.$session.get('selectedCompany'),
                    search: searchText,
                    selected_ids: _this4.selectedIdsForProducts
                  };
                  _this4.apiRequest('/get-products-for-options', 'GET', data, function (response) {
                    _this4.searchProductsLoading = false;
                    if (response.status === true) {
                      _this4.allProducts = response.data.products;
                      _this4.allProductsHidden = response.data.selected_products;
                      resolve(response);
                    } else {
                      reject(new Error('Eroare la încărcare produse'));
                    }
                  });
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    principalData: function principalData() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var data = {
                    token: _this5.$session.get('token'),
                    company_id: _this5.$session.get('selectedCompany')
                  };
                  if (!_this5.isNew()) {
                    var id = _this5.route.params.id || _this5.id;
                    _this5.apiRequest('/get-company-option/' + id, 'GET', data, function (response) {
                      if (response.status === true) {
                        _this5.model = response.data.option;
                        _this5.optionValuesData = response.data.option_value;

                        _this5.optionValuesData.forEach(function (item, idx) {
                          var allowQty = item.allow_quantity == 1 ? 1 : 0;
                          __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(_this5.optionValuesData[idx], 'allow_quantity', allowQty);

                          var minQty = item.min_quantity !== null && item.min_quantity !== undefined && item.min_quantity !== '' ? Math.min(parseInt(item.min_quantity), 9999) : null;
                          var maxQty = item.max_quantity !== null && item.max_quantity !== undefined && item.max_quantity !== '' ? Math.min(parseInt(item.max_quantity), 9999) : null;

                          __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(_this5.optionValuesData[idx], 'min_quantity', minQty);
                          __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(_this5.optionValuesData[idx], 'max_quantity', maxQty);
                        });

                        _this5.optionDeliveryMethods = response.data.delivery_methods;
                        _this5.initialOptionDeliveryMethods = _this5.copyVar(_this5.optionDeliveryMethods);

                        _this5.optionLocationDetails = response.data.location_details;
                        _this5.initialOptionLocationDetails = _this5.copyVar(_this5.optionLocationDetails);

                        _this5.optionSources = response.data.sources || [];
                        _this5.initialOptionSources = _this5.copyVar(_this5.optionSources);

                        _this5.selectedIdsForProducts = [];
                        _this5.optionValuesData.forEach(function (el) {
                          if (el.product_id) {
                            _this5.selectedIdsForProducts.push(el.product_id);
                          }
                        });
                        resolve(true);
                      } else {
                        reject(new Error('Eroare la încărcare company-option'));
                      }
                    });
                  } else {
                    _this5.model = {
                      'id': null,
                      'active': true,
                      'image': [],
                      'prod_image': [],
                      'location_ids': '',
                      'type': 'checkbox',
                      'is_product': 0,
                      'is_modifier': 0,
                      'name': ''
                    };
                    _this5.optionValuesData = [];
                    _this5.addNewValue();
                    resolve(true);
                  }
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    getData: function getData() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.loading = true;
                _context4.prev = 1;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this6.getVatOptions()]);

              case 4:
                _context4.next = 6;
                return _this6.principalData();

              case 6:
                _context4.next = 8;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this6.fetchProducts(null)]);

              case 8:
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](1);

                console.error('❌ Eroare:', _context4.t0);

              case 13:
                _context4.prev = 13;

                _this6.loading = false;
                return _context4.finish(13);

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[1, 10, 13, 16]]);
      }))();
    },
    isNew: function isNew() {
      if (this.route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    validateProductIds: function validateProductIds() {
      if (!this.model.is_product) return true;
      var invalidItems = this.optionValuesData.filter(function (item, index) {
        if (item.delete === 1) return false;
        return !item.product_id || item.product_id === '';
      });
      return invalidItems.length === 0;
    },
    validateQuantities: function validateQuantities() {
      var invalidItems = this.optionValuesData.filter(function (item, index) {
        if (item.delete === 1) return false;

        if (item.allow_quantity != 1) return false;

        var min = item.min_quantity !== null && item.min_quantity !== '' ? parseInt(item.min_quantity) : null;
        var max = item.max_quantity !== null && item.max_quantity !== '' ? parseInt(item.max_quantity) : null;

        if (min !== null && max !== null && min > max) {
          return true;
        }
        return false;
      });
      return invalidItems.length === 0;
    },
    validate: function validate() {
      var _this7 = this;

      this.$validator.validateAll().then(function (isValid) {
        var productIdsValid = _this7.validateProductIds();
        if (!productIdsValid) {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
            text: _this7.$t('catalogProdOpt.productIdRequired'),
            type: 'error',
            showConfirmButton: true
          });
          return;
        }

        var quantitiesValid = _this7.validateQuantities();
        if (!quantitiesValid) {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
            text: _this7.$t('companyOptions.quantityMinMaxError'),
            type: 'error',
            showConfirmButton: true
          });
          return;
        }

        if (isValid && productIdsValid && quantitiesValid) {
          _this7.saveOption();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
    },
    prepareOptionValuesForSave: function prepareOptionValuesForSave() {
      var _this8 = this;

      return this.optionValuesData.map(function (item) {
        var preparedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);

        if (_this8.taxesVersion === 2) {
          delete preparedItem.vat_id;
          delete preparedItem.vat_id_sgr;
        } else {
          delete preparedItem.vat_rate_id;
          delete preparedItem.vat_rate_id_sgr;
        }

        if (!preparedItem.allow_quantity || preparedItem.allow_quantity == 0) {
          preparedItem.allow_quantity = 0;
          preparedItem.min_quantity = null;
          preparedItem.max_quantity = null;
        } else {
          preparedItem.allow_quantity = 1;
          preparedItem.min_quantity = preparedItem.min_quantity !== '' && preparedItem.min_quantity !== undefined && preparedItem.min_quantity !== null ? Math.min(parseInt(preparedItem.min_quantity), 9999) : null;
          preparedItem.max_quantity = preparedItem.max_quantity !== '' && preparedItem.max_quantity !== undefined && preparedItem.max_quantity !== null ? Math.min(parseInt(preparedItem.max_quantity), 9999) : null;
        }

        return preparedItem;
      });
    },
    saveOption: function saveOption() {
      var _this9 = this;

      this.loading = true;
      var id = this.route.params.id || 0;
      var data = {};
      var companyID = this.$session.get('selectedCompany');
      data.token = this.$session.get('token');
      data.company_id = companyID;
      data.option = this.model;

      data.option_value = this.prepareOptionValuesForSave();

      delete data.option.location_ids;

      var optionDeliveryMethodsToCreate = this.optionDeliveryMethods.filter(function (obj2) {
        return !_this9.initialOptionDeliveryMethods.find(function (obj1) {
          return obj1.key === obj2.key;
        });
      });
      var optionDeliveryMethodsToDelete = this.initialOptionDeliveryMethods.filter(function (obj2) {
        return !_this9.optionDeliveryMethods.find(function (obj1) {
          return obj1.key === obj2.key;
        });
      });

      if (optionDeliveryMethodsToCreate) {
        data.option_delivery_methods_to_create = optionDeliveryMethodsToCreate;
      }

      if (optionDeliveryMethodsToDelete) {
        data.option_delivery_methods_to_delete = optionDeliveryMethodsToDelete;
      }

      var optionLocationDetailsToCreate = this.optionLocationDetails.filter(function (obj2) {
        return obj2.true_id && !_this9.initialOptionLocationDetails.find(function (obj1) {
          return obj1.location_id === obj2.true_id;
        });
      });
      var optionLocationDetailsToDelete = this.initialOptionLocationDetails.filter(function (obj2) {
        return !_this9.optionLocationDetails.find(function (obj1) {
          return obj1.true_id && obj1.true_id === obj2.location_id || obj1.location_id && obj1.location_id === obj2.location_id;
        });
      });

      if (optionLocationDetailsToCreate) {
        data.option_location_details_to_create = optionLocationDetailsToCreate;
      }

      if (optionLocationDetailsToDelete) {
        data.option_location_details_to_delete = optionLocationDetailsToDelete;
      }

      var optionSourcesToCreate = this.optionSources.filter(function (obj2) {
        return !_this9.initialOptionSources.find(function (obj1) {
          return obj1.key === obj2.key;
        });
      });
      var optionSourcesToDelete = this.initialOptionSources.filter(function (obj2) {
        return !_this9.optionSources.find(function (obj1) {
          return obj1.key === obj2.key;
        });
      });

      if (optionSourcesToCreate) {
        data.option_sources_to_create = optionSourcesToCreate;
      }

      if (optionSourcesToDelete) {
        data.option_sources_to_delete = optionSourcesToDelete;
      }

      this.apiRequest('/save-option/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          _this9.loading = false;
          _this9.errors.clear();
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': _this9.$t('menuLink.updated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          _this9.cancelOption();
        } else {
          _this9.loading = false;
          _this9.handleErrors(response.errors);
        }
      });
    },
    addNewValue: function addNewValue() {
      var newRow = {
        'id': null,
        'name': '',
        'pos_id': null,
        'vat_id': null,
        'vat_rate_id': null,
        'vat_rate_id_sgr': null,
        'active': true,
        'allow_quantity': 0,
        'min_quantity': null,
        'max_quantity': null
      };

      this.optionValuesData.push(newRow);
    },
    deleteValue: function deleteValue(index) {
      __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(this.optionValuesData[index], 'delete', 1);
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': this.$t('companyOptions.deleteVal'), 'type': 'success', 'showConfirmButton': false, 'timer': 5000 }).then(function () {}).catch(function () {});
    },
    deleteOption: function deleteOption() {
      var _this10 = this;

      this.loading = true;
      var id = this.id || this.route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/delete-option/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          _this10.trackAdminEvent('ADMIN_COMPANY_OPTION_DELETED', 'company_option', id, {
            company_option_id: id,
            name: _this10.model && _this10.model.name || null
          });
          _this10.loading = false;
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': 'Deleted succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this10.cancelOption();
        } else {
          _this10.loading = false;
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': _this10.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    handleImgChnage1: function handleImgChnage1(file, fileList) {
      var _this11 = this;

      var pp = this.model;
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        pp.image = [];
      } else {
        if (fileList.length > 1) {
          pp.image = fileList.slice(1);
        } else {
          pp.image = fileList;
        }
      }
      this.model = null;
      this.model = pp;
      this.getBase64(this.model.image[0].raw).then(function (base64enc) {
        _this11.model.image[0].base64enc = base64enc;
      });
    },
    handleRemove1: function handleRemove1(file, fileList) {
      if (fileList.length === 0) {
        this.model.image = [];
      }
    },
    handleImgChnage: function handleImgChnage(file, fileList, index) {
      var _this12 = this;

      var self = this;
      var pp = this.optionValuesData;
      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        self.$refs.upload.clearFiles();
        pp[index].image = [];
      } else {
        if (fileList.length > 1) {
          pp[index].image = fileList.slice(1);
        } else {
          pp[index].image = fileList;
        }
      }
      this.optionValuesData = null;
      this.optionValuesData = pp;
      this.getBase64(this.optionValuesData[index].image[0].raw).then(function (base64enc) {
        _this12.optionValuesData[index].image[0].base64enc = base64enc;
      });
    },
    handleImgProdChnage: function handleImgProdChnage(file, fileList, index) {
      var _this13 = this;

      var self = this;
      var pp = this.optionValuesData;
      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        self.$refs.upload.clearFiles();
        pp[index].prod_image = [];
      } else {
        if (fileList.length > 1) {
          pp[index].prod_image = fileList.slice(1);
        } else {
          pp[index].prod_image = fileList;
        }
      }
      this.optionValuesData = null;
      this.optionValuesData = pp;
      this.getBase64(this.optionValuesData[index].prod_image[0].raw).then(function (base64enc) {
        _this13.optionValuesData[index].prod_image[0].base64enc = base64enc;
      });
    },
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        text: this.$t('general.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    handleRemove: function handleRemove(file, fileList, index) {
      if (fileList.length === 0) {
        this.optionValuesData[index].image = [];
      }
    },
    handleRemoveProd: function handleRemoveProd(file, fileList, index) {
      if (fileList.length === 0) {
        this.optionValuesData[index].prod_image = [];
      }
    },
    handleDeleteOption: function handleDeleteOption() {
      var btnCounter = 3;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        text: this.$t('companyOptions.deleteQues'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          self.deleteOption();
        }
      });
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    cancelOption: function cancelOption() {
      if (this.route.path && this.route.path.includes('/integrations/menu-fix')) {
        window.close();
        return;
      }

      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "WNrK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      loadingSuppliers: false,
      loadingProducts: false,
      fetchProductsTimeout: null,
      totalItems: 0,
      currentPage: 1,
      allLocations: [],
      pageSize: 20,
      tableData: [],
      vatNumber: null,
      selectedLocation: null,
      supplierResults: [],
      productResults: [],
      filter: {
        supplierVatNumber: null,
        invoiceNumber: '',
        productId: null,
        searchDate: null
      }
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.fetchNIRs(this.selectedLocation, this.currentPage, this.pageSize);
    },
    onLocationChange: function onLocationChange() {
      this.filter.supplierVatNumber = null;
      this.filter.productId = null;
      this.supplierResults = [];
      this.productResults = [];
    },
    onSearch: function onSearch() {
      if (!this.selectedLocation || Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        });

        this.tableData = [];
        this.totalItems = 0;

        return;
      }

      var locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation];

      this.currentPage = 1;
      this.fetchNIRs(locations, 1, this.pageSize);
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.fetchNIRs(this.selectedLocation, this.currentPage, this.pageSize);
    },
    fetchSuppliers: function fetchSuppliers(query) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vatNumber, params, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.companyID) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                _this.loadingSuppliers = true;
                _context.prev = 3;
                vatNumber = _this.selectedLocation && _this.selectedLocation.inv_fiscal_code;
                params = new URLSearchParams();

                params.append('externalCompanyId', _this.companyID);
                if (query) params.append('name', query);
                if (vatNumber) params.append('vatNumber', vatNumber);

                _context.next = 11;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/suppliers?' + params.toString());

              case 11:
                response = _context.sent;
                _context.next = 14;
                return response.json();

              case 14:
                data = _context.sent;


                if (Array.isArray(data.suppliers)) {
                  _this.supplierResults = data.suppliers.filter(function (s) {
                    return s.vatNumber;
                  }).map(function (supplier) {
                    return {
                      id: supplier._id,
                      nume: supplier.name,
                      vatNumber: supplier.vatNumber
                    };
                  });
                } else {
                  _this.supplierResults = [];
                }
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](3);

                console.error('Error fetching suppliers:', _context.t0);
                _this.supplierResults = [];

              case 22:
                _context.prev = 22;

                _this.loadingSuppliers = false;
                return _context.finish(22);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 18, 22, 25]]);
      }))();
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this2 = this;

      clearTimeout(this.fetchProductsTimeout);

      if (!searchTerm || searchTerm.length < 2 || !this.companyID) {
        this.productResults = [];
        return;
      }

      this.fetchProductsTimeout = setTimeout(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var vatNumber, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loadingProducts = true;
                _context2.prev = 1;
                vatNumber = _this2.selectedLocation && _this2.selectedLocation.inv_fiscal_code;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/products?externalCompanyId=' + _this2.companyID + '&name=' + encodeURIComponent(searchTerm);

                if (vatNumber) {
                  url += '&vatNumber=' + encodeURIComponent(vatNumber);
                }

                _context2.next = 7;
                return fetch(url);

              case 7:
                response = _context2.sent;
                _context2.next = 10;
                return response.json();

              case 10:
                data = _context2.sent;


                if (Array.isArray(data.products)) {
                  _this2.productResults = data.products.map(function (product) {
                    return {
                      id: product.posId || product.product_id || product._id,
                      name: product.name
                    };
                  });
                } else {
                  _this2.productResults = [];
                }
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](1);

                console.error('Error fetching products:', _context2.t0);
                _this2.productResults = [];

              case 18:
                _context2.prev = 18;

                _this2.loadingProducts = false;
                return _context2.finish(18);

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 14, 18, 21]]);
      })), 300);
    },
    fetchNIRs: function fetchNIRs() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this3 = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var params, ids, allLocations, _ids, response, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.companyID) {
                  _context3.next = 3;
                  break;
                }

                console.error('Missing VAT number for fetching series.');
                return _context3.abrupt('return');

              case 3:

                _this3.loading = true;

                params = new URLSearchParams();

                params.append('externalCompanyId', _this3.companyID);

                params.append('page', page);
                params.append('limit', pageSize);

                if (location) {
                  if (Array.isArray(location)) {
                    ids = location.map(function (l) {
                      return l.true_id;
                    }).filter(Boolean);

                    ids.forEach(function (id) {
                      return params.append('externalLocationId', id);
                    });
                  } else if (location.id && location.true_id) {
                    params.append('externalLocationId', location.true_id);
                  }
                } else {
                  allLocations = _this3.groupedLocations.flatMap(function (group) {
                    return group.locations;
                  });
                  _ids = allLocations.map(function (l) {
                    return l.true_id;
                  }).filter(Boolean);

                  _ids.forEach(function (id) {
                    return params.append('externalLocationId', id);
                  });
                }

                if (_this3.filter.supplierVatNumber) {
                  params.append('supplierVatNumber', _this3.filter.supplierVatNumber);
                }

                if (_this3.filter.invoiceNumber && _this3.filter.invoiceNumber.trim()) {
                  params.append('invoiceNumber', _this3.filter.invoiceNumber.trim());
                }

                if (_this3.filter.productId) {
                  params.append('productId', _this3.filter.productId);
                }

                if (_this3.filter.searchDate && _this3.filter.searchDate.length === 2) {
                  if (_this3.filter.searchDate[0]) {
                    params.append('startDate', _this3.filter.searchDate[0]);
                  }
                  if (_this3.filter.searchDate[1]) {
                    params.append('endDate', _this3.filter.searchDate[1]);
                  }
                }

                clearTimeout(_this3.loadingTimeout);
                _this3.loadingTimeout = setTimeout(function () {
                  _this3.loading = true;
                }, 100);
                _context3.prev = 15;
                _context3.next = 18;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/nirs?' + params.toString());

              case 18:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 21;
                  break;
                }

                throw new Error('Failed to fetch NIRs');

              case 21:
                _context3.next = 23;
                return response.json();

              case 23:
                data = _context3.sent;


                if (Array.isArray(data.nirs)) {
                  clearTimeout(_this3.loadingTimeout);
                  _this3.loading = false;

                  _this3.totalItems = data.total || 0;
                  _this3.currentPage = data.currentPage || page;
                  _this3.pageSize = data.pageSize || pageSize;

                  _this3.tableData = data.nirs.map(function (nir) {
                    return {
                      id: nir._id,
                      supplier: nir.nume_furnizor || 'N/A',
                      nirNumber: nir.nirNumber,
                      nr: nir.nirNumber,
                      series: nir.series,
                      vatNumberFurnizor: nir.vatNumberFurnizor,
                      valoare: nir.valoare || 'N/A',
                      dueDate: nir.data_scadentei || 'N/A',
                      data_document: nir.data_document || 'N/A',
                      issueDate: nir.data_document,
                      entryDate: nir.data_in_stoc
                    };
                  });
                } else {
                  clearTimeout(_this3.loadingTimeout);
                  _this3.loading = false;
                  _this3.tableData = [];
                  _this3.totalItems = 0;
                  console.error('NIRs data is not in expected format', data);
                }
                _context3.next = 32;
                break;

              case 27:
                _context3.prev = 27;
                _context3.t0 = _context3['catch'](15);

                clearTimeout(_this3.loadingTimeout);
                _this3.loading = false;

                console.error('Error fetching NIRs:', _context3.t0);

              case 32:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[15, 27]]);
      }))();
    },
    addEntries: function addEntries() {
      this.$router.push('/management/entries/add');
    },
    editNir: function editNir(row) {
      this.$router.push({
        path: '/management/entries/edit/' + row.id,
        query: {
          nirNumber: row.nirNumber,
          data_document: row.data_document,
          vatNumberFurnizor: row.vatNumberFurnizor,
          series: row.series
        }
      });
    },
    formatDate: function formatDate(dateString) {
      if (!dateString) return 'N/A';
      var date = new Date(dateString);
      if (isNaN(date.getTime())) return 'N/A';
      return date.toLocaleString('ro-RO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    handleDeleteNIR: function handleDeleteNIR(id) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (id) {
                  _context5.next = 3;
                  break;
                }

                console.error('Missing NIR ID for deletion.');
                return _context5.abrupt('return');

              case 3:

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: 'Ești sigur că vrei să ștergi acest NIR?',
                  text: 'Această acțiune nu poate fi anulată!',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Da, șterge-l!',
                  cancelButtonText: 'Anulează'
                }).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(result) {
                    var response, data;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!result) {
                              _context4.next = 19;
                              break;
                            }

                            _context4.prev = 1;
                            _context4.next = 4;
                            return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                              method: 'DELETE',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                type: 'nir',
                                id: id,
                                externalCompanyId: _this4.companyID
                              })
                            });

                          case 4:
                            response = _context4.sent;

                            if (response.ok) {
                              _context4.next = 7;
                              break;
                            }

                            throw new Error('HTTP error! Status: ' + response.status);

                          case 7:
                            _context4.next = 9;
                            return response.json();

                          case 9:
                            data = _context4.sent;

                            console.log('NIR deleted successfully:', data);

                            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                              title: 'Succes',
                              text: 'NIR a fost șters cu succes.',
                              type: 'success',
                              timer: 2000,
                              showConfirmButton: false
                            });

                            _this4.fetchNIRs();
                            _context4.next = 19;
                            break;

                          case 15:
                            _context4.prev = 15;
                            _context4.t0 = _context4['catch'](1);

                            console.error('Error deleting NIR:', _context4.t0);

                            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                              title: 'Eroare',
                              text: 'A apărut o eroare la ștergerea NIR.',
                              type: 'error',
                              timer: 2000,
                              showConfirmButton: false
                            });

                          case 19:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this4, [[1, 15]]);
                  }));

                  return function (_x4) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    downloadExcel: function downloadExcel(row) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                series = row.series;
                invoiceNumber = row.nr;
                externalCompanyId = _this5.companyID;

                if (!(!series || !invoiceNumber || !externalCompanyId)) {
                  _context6.next = 6;
                  break;
                }

                alert('Missing series, invoice number or company ID.');
                return _context6.abrupt('return');

              case 6:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/nir/' + series + '-' + invoiceNumber + '/xls?externalCompanyId=' + externalCompanyId;
                _context6.prev = 7;
                _context6.next = 10;
                return fetch(url);

              case 10:
                response = _context6.sent;

                if (!response.ok) {
                  _context6.next = 22;
                  break;
                }

                _context6.next = 14;
                return response.blob();

              case 14:
                blob = _context6.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + invoiceNumber + '.xls';
                link.click();
                URL.revokeObjectURL(link.href);
                _context6.next = 23;
                break;

              case 22:
                console.error('Error downloading invoice:', response.statusText);

              case 23:
                _context6.next = 28;
                break;

              case 25:
                _context6.prev = 25;
                _context6.t0 = _context6['catch'](7);

                console.error('Error fetching invoice:', _context6.t0);

              case 28:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this5, [[7, 25]]);
      }))();
    },
    download: function download(row) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                series = row.series;
                invoiceNumber = row.nr;
                externalCompanyId = _this6.companyID;

                if (!(!series || !invoiceNumber || !externalCompanyId)) {
                  _context7.next = 6;
                  break;
                }

                alert('Missing series, invoice number or company ID.');
                return _context7.abrupt('return');

              case 6:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/nir/' + series + '-' + invoiceNumber + '/pdf?externalCompanyId=' + externalCompanyId;
                _context7.prev = 7;
                _context7.next = 10;
                return fetch(url);

              case 10:
                response = _context7.sent;

                if (!response.ok) {
                  _context7.next = 22;
                  break;
                }

                _context7.next = 14;
                return response.blob();

              case 14:
                blob = _context7.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + invoiceNumber + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                _context7.next = 23;
                break;

              case 22:
                console.error('Error downloading invoice:', response.statusText);

              case 23:
                _context7.next = 28;
                break;

              case 25:
                _context7.prev = 25;
                _context7.t0 = _context7['catch'](7);

                console.error('Error fetching invoice:', _context7.t0);

              case 28:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this6, [[7, 25]]);
      }))();
    }
  }
});

/***/ }),

/***/ "WO6t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementTransfer_vue__ = __webpack_require__("Rk5Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0929b45a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementTransfer_vue__ = __webpack_require__("2vPa");
function injectStyle (ssrContext) {
  __webpack_require__("HdYx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0929b45a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementTransfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0929b45a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementTransfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WOuw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vmodal',{staticClass:"addClientModal",attrs:{"name":"addClientModal","height":"auto","width":"920","adaptive":true,"scrollable":true}},[_c('div',{staticClass:"client-modal card"},[_c('div',{staticClass:"card-content client-modal__content"},[_c('div',{staticClass:"client-modal__header"},[_c('h5',{staticClass:"client-modal__title"},[_vm._v("\n            "+_vm._s(_vm.editMode ? 'Editează client' : _vm.$t('gestiune.addClient'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"client-modal__body"},[_c('div',{staticClass:"row client-modal__toolbar"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control client-modal__select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":String(group.vat)}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                      "+_vm._s(loc.name)+"\n                    ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.searchClientsWithCUI')))]),_vm._v(" "),_c('form',{staticClass:"client-modal__search",on:{"submit":function($event){$event.preventDefault();return _vm.searchClient($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCUI),expression:"searchCUI"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":_vm.$t('gestiune.searchClientsWithCUI')},domProps:{"value":(_vm.searchCUI)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchCUI=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm client-modal__search-btn",attrs:{"type":"submit"}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.search'))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row client-modal__form-grid"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.companyName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.companyName),expression:"client.companyName"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.client.companyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "companyName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.abbreviation'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.abbreviation),expression:"client.abbreviation"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.client.abbreviation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "abbreviation", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.CUI'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.CUI),expression:"client.CUI"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.client.CUI)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "CUI", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.registrationNumber'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.registrationNumber),expression:"client.registrationNumber"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.client.registrationNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "registrationNumber", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.city'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.city),expression:"client.city"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.client.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "city", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.countries'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.countries),expression:"client.countries"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.client.countries)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "countries", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.address'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.address),expression:"client.address"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.client.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "address", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.bank'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.bank),expression:"client.bank"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.client.bank)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "bank", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.IBAN'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.IBAN),expression:"client.IBAN"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.client.IBAN)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "IBAN", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group client-modal__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.dueDays'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.dueDays),expression:"client.dueDays"}],staticClass:"form-control input-sm",attrs:{"type":"number"},domProps:{"value":(_vm.client.dueDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "dueDays", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"client-modal__footer"},[_c('a',{staticClass:"btn btn-danger btn-icon delete",on:{"click":function($event){_vm.closeAddClientModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('general.cancel2'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success save",on:{"click":function($event){_vm.saveClient()}}},[_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WPuu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('location-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WW1J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISCOUNT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNITS_SOLD_SCOPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UNITS_SOLD_POOLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INTERVAL_DAYS; });
/* unused harmony export comboKey */
/* unused harmony export PRICE_PROFILE_SOURCES */
/* harmony export (immutable) */ __webpack_exports__["h"] = sortCombosLikePriceProfile;
/* harmony export (immutable) */ __webpack_exports__["g"] = combosToPayload;
/* unused harmony export normalizeComboOption */
/* harmony export (immutable) */ __webpack_exports__["e"] = mergeComboOptions;
/* unused harmony export matchComboOption */
/* harmony export (immutable) */ __webpack_exports__["f"] = resolveSelectedCombos;
/* harmony export (immutable) */ __webpack_exports__["k"] = getComboLabels;
/* harmony export (immutable) */ __webpack_exports__["j"] = getProductLabels;
/* harmony export (immutable) */ __webpack_exports__["i"] = formatTruncatedList;
/* unused harmony export formatCombosLabels */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__("hiCB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


var DISCOUNT_TYPES = [{ id: 1, key: 'flat' }, { id: 2, key: 'percent' }];

var UNITS_SOLD_SCOPES = [{ id: 1, key: 'perLine' }, { id: 2, key: 'perSource' }];

var UNITS_SOLD_POOLS = [{ id: 1, key: 'perProduct' }, { id: 2, key: 'absolute' }];

var INTERVAL_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

function comboKey(source, method) {
  return source + '_' + method;
}

var PRICE_PROFILE_SOURCES = [{ id: 6, methods: [1] }, { id: 7, methods: [1] }, { id: 8, methods: [1] }, { id: 1, methods: [1, 2, 3] }, { id: 2, methods: [1] }, { id: 3, methods: [1, 2] }, { id: 4, methods: [1, 2, 3] }, { id: 5, methods: [1, 2, 3] }];

var COMBO_COLUMN_ORDER = PRICE_PROFILE_SOURCES.reduce(function (order, source) {
  source.methods.forEach(function (method) {
    order.push(comboKey(source.id, method));
  });
  return order;
}, []);

function sortCombosLikePriceProfile(combos) {
  return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(combos || [])).sort(function (a, b) {
    var keyA = comboKey(a.source, a.method);
    var keyB = comboKey(b.source, b.method);
    var indexA = COMBO_COLUMN_ORDER.indexOf(keyA);
    var indexB = COMBO_COLUMN_ORDER.indexOf(keyB);
    var orderA = indexA === -1 ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a : indexA;
    var orderB = indexB === -1 ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a : indexB;
    if (orderA !== orderB) return orderA - orderB;
    if (a.source !== b.source) return parseInt(a.source, 10) - parseInt(b.source, 10);
    return parseInt(a.method, 10) - parseInt(b.method, 10);
  });
}

function combosToPayload(selected) {
  return (selected || []).map(function (item) {
    return {
      source: parseInt(item.source, 10),
      method: parseInt(item.method, 10)
    };
  });
}

function normalizeComboOption(combo) {
  var source = parseInt(combo.source, 10);
  var method = parseInt(combo.method, 10);
  var key = combo.key || comboKey(source, method);
  return {
    source: source,
    method: method,
    key: key,
    label: combo.label || key,
    source_label: combo.source_label || null,
    method_label: combo.method_label || null
  };
}

function mergeComboOptions(options, combos) {
  var merged = [];
  var seen = {};
  var push = function push(combo) {
    if (!combo || combo.source == null || combo.method == null) return;
    var normalized = normalizeComboOption(combo);
    if (seen[normalized.key]) return;
    seen[normalized.key] = true;
    merged.push(normalized);
  };(options || []).forEach(push);(combos || []).forEach(push);
  return merged;
}

function matchComboOption(options, combo) {
  if (!combo) return null;
  return (options || []).find(function (opt) {
    return parseInt(opt.source, 10) === parseInt(combo.source, 10) && parseInt(opt.method, 10) === parseInt(combo.method, 10);
  }) || {
    source: combo.source,
    method: combo.method,
    key: comboKey(combo.source, combo.method),
    label: combo.label || comboKey(combo.source, combo.method)
  };
}

function resolveSelectedCombos(options, combos) {
  return (combos || []).map(function (combo) {
    return matchComboOption(options, combo);
  });
}

function getComboLabels(row) {
  if (!row) return [];
  if (row.combos && row.combos.length) {
    return row.combos.map(function (c) {
      return c.label || comboKey(c.source, c.method);
    });
  }
  if (row.source_method_combos && row.source_method_combos.length) {
    return row.source_method_combos.map(function (c) {
      return c.label || comboKey(c.source, c.method);
    });
  }
  if (row.combos_labels) {
    return String(row.combos_labels).split(',').map(function (label) {
      return label.trim();
    }).filter(Boolean);
  }
  return [];
}

function getProductLabels(row) {
  if (!row) return [];
  if (row.products && row.products.length) {
    return row.products.map(function (p) {
      return p.name || p.label || '#' + p.id;
    });
  }
  if (row.products_formatted && row.products_formatted.length) {
    return row.products_formatted.map(function (p) {
      return p.label || p.name || '#' + p.id;
    });
  }
  if (row.product_ids && row.product_ids.length) {
    return row.product_ids.map(function (id) {
      return '#' + id;
    });
  }
  return [];
}

function formatTruncatedList(items, getLabel, limit) {
  var max = limit == null ? 2 : limit;
  var labels = (items || []).map(function (item, index) {
    var label = typeof getLabel === 'function' ? getLabel(item, index) : item;
    return label == null ? '' : String(label).trim();
  }).filter(function (label) {
    return label !== '';
  });
  return {
    visible: labels.slice(0, max),
    rest: labels.slice(max),
    restCount: Math.max(labels.length - max, 0),
    full: labels
  };
}

function formatCombosLabels(row) {
  var labels = getComboLabels(row);
  return labels.length ? labels.join(', ') : '-';
}

/***/ }),

/***/ "WXLK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.cancelZone($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteZone($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("ID: "+_vm._s(_vm.model.id))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","data-vv-as":"name","placeholder":_vm.$t('settingTable.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('name'))+"\n                ")]):_vm._e()])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WcH1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[(_vm.isEdit)?_c('div',{staticClass:"col-md-12"}):_vm._e()]),_vm._v(" "),_c('div',[(_vm.model.is_sending)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-offset-1 col-md-10"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"sending-campaign display-flex"},[_c('h4',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.cannotModify')))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-offset-1 col-md-10"},[_c('div',{staticClass:"card card-wizard marketing-wizard access-vue-form-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"shape":"square","step-size":"xs","error-color":"#EB5E28","color":"#5e35b1"},on:{"on-complete":_vm.wizardComplete}},[_c('tab-content',{attrs:{"before-change":_vm.validateFirstStep,"title":"Campaign Details"}},[_c('first-step',{ref:"firstStep",attrs:{"modelFromParent":_vm.model,"daysParent":_vm.days}})],1),_vm._v(" "),_c('tab-content',{attrs:{"before-change":_vm.validateThirdStep,"title":"Target"}},[_c('third-step',{ref:"thirdStep",attrs:{"userLabels":_vm.userLabels,"modelFromParent":_vm.model,"customerGroups":_vm.customerGroups,"daysParent":_vm.days},on:{"groupCustomers":_vm.handleGroupCustomers}})],1),_vm._v(" "),_c('tab-content',{attrs:{"before-change":_vm.validateCouponStep,"title":_vm.$t('pages.coupons')}},[_c('coupon-select-step',{ref:"couponStep",attrs:{"modelFromParent":_vm.model}})],1),_vm._v(" "),_c('h2',{attrs:{"slot":"title"},slot:"title"}),_vm._v(" "),_c('button',{staticClass:"btn btn-purple-light btn btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v(_vm._s(_vm.$t('general.back')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-purple-light btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v(_vm._s(_vm.$t('general.next')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-purple-light btn-fill btn-wd",attrs:{"slot":"finish","disabled":_vm.model.is_sending},slot:"finish"},[_vm._v(_vm._s(_vm.$t('general.finish')))])],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "We6j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WhE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"card mar-to-15",staticStyle:{"width":"calc(75% - 20px)","margin-left":"10px","margin-right":"10px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"userList",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.send')},on:{"click":function($event){_vm.handleDelete(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.delete'))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n              ")])]}}])})],2)],1)]),_vm._v(" "),(_vm.tableData.length)?_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"option_name"}},[_c('p',[_vm._v(_vm._s(this.$t('kds.importTitle')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"section"}},[_vm._v(_vm._s(this.$t('kds.section')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sectionForImport),expression:"sectionForImport"}],staticClass:"form-control",attrs:{"name":"section","id":"id","data-vv-as":"location"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sectionForImport=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"label":_vm.$t('general.select')},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.tableData),function(el){return _c('option',{key:el.id,attrs:{"label":el.name},domProps:{"value":el.id}})})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"category_id"}},[_vm._v(_vm._s(this.$t('pages.categories')))]),_vm._v(" "),_c('el-select',{staticStyle:{"margin-bottom":"15px"},attrs:{"name":"category_id","value-key":"value","multiple":"","collapse-tags":"","label":"label","popper-class":"custom-dropdown-width"},on:{"change":_vm.handleChange},model:{value:(_vm.categoryForImport),callback:function ($$v) {_vm.categoryForImport=$$v},expression:"categoryForImport"}},[_c('el-option',{key:_vm.toggleOption.value,attrs:{"label":_vm.toggleOption.label,"value":_vm.toggleOption.value}}),_vm._v(" "),_vm._l((_vm.formattedCategories),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-orange",on:{"click":function($event){$event.preventDefault();_vm.setSectionOnProductsFromCategory()}}},[_vm._v(_vm._s(this.$t('general.set')))])],1)])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"space_for_alert_box",staticStyle:{"height":"100px","width":"100%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WugT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TopCategoryForm_vue__ = __webpack_require__("mtAm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);







var _components;





__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'TopCategoryForm', __WEBPACK_IMPORTED_MODULE_7__TopCategoryForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      categoryModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onCategorySubmit: function onCategorySubmit(model, isValid) {
      this.categoryModel = model;
    }
  }
});

/***/ }),

/***/ "WvLp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PosScreenForm_vue__ = __webpack_require__("4uSL");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PosScreenForm', __WEBPACK_IMPORTED_MODULE_7__PosScreenForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      PosScreenModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.PosScreenModel = model;
    }
  }
});

/***/ }),

/***/ "Wve1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('price-profile-form',{attrs:{"priceProfileData":_vm.priceProfileData,"route":_vm.route},on:{"on-submit":_vm.onProfileSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X+ky":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X2tq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-report",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"row mar-bt-15"},[(_vm.showLocations)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'loc-' + loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n        "+_vm._s(_vm.$t('general.from'))+"\n        "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
            start: '00:00',
            step: '00:10',
            end: '24:00'
          }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n        "+_vm._s(_vm.$t('general.to'))+"\n        "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
            start: '00:00',
            step: '00:10',
            end: '24:00'
          }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),(_vm.ordersTableData.data && _vm.ordersTableData.data.length > 0)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content"},[_c('div',{staticClass:"report-container-compact"},[_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.orderCounter')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.totalCounter))])])])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns mixed-report-table-wrapper"},[_c('div',{staticClass:"mixed-table-scroll-container"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"mixed-report-table",ref:"reportsTable",staticClass:"report-sales mixed-report-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"total":_vm.totalRecords,"search-def":{show: false},"pagination-props":_vm.paginationProps,"table-props":_vm.tableOptions},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"width":80,"prop":"id","label":_vm.$t('reports.id')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.id || '')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"left-align-cell","min-width":200,"width":200,"prop":"name","label":_vm.$t('reports.productName')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.name || '')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"sold","label":_vm.$t('reports.sold')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatNumber(props.row.sold))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"eatIn","label":_vm.$t('reports.eatIn')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatNumber(props.row.eatIn))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"takeOut","label":_vm.$t('reports.takeOut')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatNumber(props.row.takeOut))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"other","label":_vm.$t('reports.shipping')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatNumber(props.row.other))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"employee","label":_vm.$t('reports.employee')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatNumber(props.row.employee))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"refund","label":_vm.$t('reports.refund')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatNumber(props.row.refund))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":90,"prop":"netSold","label":_vm.$t('reports.unitQty')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatNumber(props.row.netSold))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":110,"prop":"unitPrice","label":_vm.$t('reports.unitPrice')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row._isCategoryTotal ? '' : _vm.formatNumber(props.row.unitPrice))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":110,"prop":"sales","label":_vm.$t('reports.sales')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatNumber(props.row.sales))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"totalDiscount","label":_vm.$t('reports.discount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatNumber(props.row.totalDiscount))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"netSales","label":_vm.$t('reports.netSales')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatNumber(props.row.netSales))+"\n              ")]}}])})],1)],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X5Jl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLabelingAdd_vue__ = __webpack_require__("Ouxb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c65448_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserLabelingAdd_vue__ = __webpack_require__("cDh+");
function injectStyle (ssrContext) {
  __webpack_require__("yX82")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLabelingAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c65448_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserLabelingAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X64J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__ = __webpack_require__("aAj7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_126f64bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__ = __webpack_require__("52Pd");
function injectStyle (ssrContext) {
  __webpack_require__("24WM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-126f64bf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Test_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_126f64bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Test_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X6sA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X8pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exportable-reports text-left"},[_c('h4',[_vm._v("Rapoarte exportabile")]),_vm._v(" "),_c('div',{staticClass:"export-report-grid"},[_c('section',{staticClass:"card export-report",attrs:{"aria-labelledby":"products-report-title"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"products-report-location"}},[_vm._v("Locație")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.productLocationId),expression:"productLocationId"}],staticClass:"form-control",attrs:{"id":"products-report-location"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.productLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Toate locațiile disponibile")]),_vm._v(" "),_vm._l((_vm.locations),function(location){return _c('option',{key:location.true_id,domProps:{"value":location.true_id}},[_vm._v(_vm._s(location.name))])})],2)]),_vm._v(" "),_c('label',{staticClass:"active-products"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeOnly),expression:"activeOnly"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.activeOnly)?_vm._i(_vm.activeOnly,null)>-1:(_vm.activeOnly)},on:{"change":function($event){var $$a=_vm.activeOnly,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.activeOnly=$$a.concat([$$v]))}else{$$i>-1&&(_vm.activeOnly=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.activeOnly=$$c}}}}),_vm._v(" Doar produsele active")])]),_vm._v(" "),_c('div',{staticClass:"report-actions"},[(_vm.error && _vm.errorReport === 'products')?_c('p',{staticClass:"text-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"disabled":!!_vm.requesting || !!_vm.exporting},on:{"click":function($event){_vm.download('products')}}},[_vm._v(_vm._s(_vm.exporting === 'products' ? 'Se exportă...' : 'Export CSV — toate produsele'))]),_vm._v(" "),(_vm.timedOut['products'])?_c('div',{staticClass:"report-request-fallback"},[_c('p',[_vm._v("Exportul direct nu a putut fi finalizat. Solicită raportul pentru a fi pregătit în fundal.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"disabled":!!_vm.requesting || !!_vm.exporting},on:{"click":function($event){_vm.requestReport('products')}}},[_vm._v(_vm._s(_vm.requesting === 'products' ? 'Se trimite...' : 'Solicită raport'))])]):_vm._e()])]),_vm._v(" "),_c('section',{staticClass:"card export-report",attrs:{"aria-labelledby":"coupon-report-title"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"sql-report-coupon"}},[_vm._v("Cupon")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"sql-report-coupon","filterable":"","clearable":"","placeholder":"Caută un cupon după nume sau cod","loading":_vm.loadingCoupons,"disabled":_vm.loadingCoupons,"no-match-text":"Niciun cupon găsit","no-data-text":"Nu există cupoane disponibile"},model:{value:(_vm.couponId),callback:function ($$v) {_vm.couponId=$$v},expression:"couponId"}},_vm._l((_vm.coupons),function(coupon){return _c('el-option',{key:coupon.id,attrs:{"value":coupon.id,"label":_vm.couponLabel(coupon)}})})),_vm._v(" "),(_vm.couponError)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.couponError)+" "),_c('button',{staticClass:"btn btn-sm",on:{"click":_vm.loadCoupons}},[_vm._v("Reîncearcă")])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"coupon-report-location"}},[_vm._v("Locație")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.couponLocationId),expression:"couponLocationId"}],staticClass:"form-control",attrs:{"id":"coupon-report-location"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.couponLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Toate locațiile disponibile")]),_vm._v(" "),_vm._l((_vm.locations),function(location){return _c('option',{key:location.true_id,domProps:{"value":location.true_id}},[_vm._v(_vm._s(location.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"report-dates"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"sql-report-from"}},[_vm._v("De la")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fromDate),expression:"fromDate"}],staticClass:"form-control",attrs:{"id":"sql-report-from","type":"date"},domProps:{"value":(_vm.fromDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fromDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"sql-report-to"}},[_vm._v("Până la (inclusiv)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toDate),expression:"toDate"}],staticClass:"form-control",attrs:{"id":"sql-report-to","type":"date"},domProps:{"value":(_vm.toDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.toDate=$event.target.value}}})])]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Perioada este opțională și se aplică datei adăugării comenzii.")])]),_vm._v(" "),_c('div',{staticClass:"report-actions"},[(_vm.error && _vm.errorReport === 'coupon-orders')?_c('p',{staticClass:"text-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(!_vm.couponRequiresRequest)?_c('button',{staticClass:"btn btn-info",attrs:{"disabled":!!_vm.requesting || !!_vm.exporting || !_vm.validDates || !_vm.couponId},on:{"click":function($event){_vm.download('coupon-orders')}}},[_vm._v(_vm._s(_vm.exporting === 'coupon-orders' ? 'Se exportă...' : 'Export CSV — comenzi cu cupon'))]):_vm._e(),_vm._v(" "),(_vm.couponRequiresRequest || _vm.timedOut['coupon-orders'])?_c('div',{staticClass:"report-request-fallback"},[(_vm.couponRequiresRequest)?_c('p',[_vm._v("Pentru perioade mai mari de o lună, raportul se pregătește în fundal. Îl vei găsi în Solicitări Rapoarte.")]):_c('p',[_vm._v("Exportul direct nu a putut fi finalizat. Solicită raportul pentru a fi pregătit în fundal.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"disabled":!!_vm.requesting || !!_vm.exporting || !_vm.validDates || !_vm.couponId},on:{"click":function($event){_vm.requestReport('coupon-orders')}}},[_vm._v(_vm._s(_vm.requesting === 'coupon-orders' ? 'Se trimite...' : 'Solicită raport'))])]):_vm._e()])])]),_vm._v(" "),_c('p',{staticClass:"report-request-info"},[_vm._v("\n    Rapoartele solicitate sunt pregătite în fundal. Le vei găsi în tabul\n    "),_c('button',{staticClass:"report-request-link",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('show-requests')}}},[_vm._v("Solicitări Rapoarte")]),_vm._v(",\n    de unde le poți descărca după procesare.\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"report-format"},[_vm._v("CSV")]),_vm._v(" "),_c('h4',{attrs:{"id":"products-report-title"}},[_vm._v("Toate produsele")]),_vm._v(" "),_c('p',[_vm._v("Exportă catalogul de produse, cu categorii, secții, POS ID, TVA și prețuri. Include variantele.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"report-format"},[_vm._v("CSV")]),_vm._v(" "),_c('h4',{attrs:{"id":"coupon-report-title"}},[_vm._v("Comenzi cu cupon")]),_vm._v(" "),_c('p',[_vm._v("Exportă comenzile care au folosit cuponul selectat, inclusiv codurile multiple. Include toate statusurile, fără ciorne.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XAsG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XCia":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XCy2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DigitalSignageForm_vue__ = __webpack_require__("jeM8");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'DigitalSignageForm', __WEBPACK_IMPORTED_MODULE_7__DigitalSignageForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      digitalSignageModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.digitalSignageModel = model;
    }
  }
});

/***/ }),

/***/ "XDm8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XE0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row blog-page"},[_c('div',{staticClass:"col-lg-9 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"blog-toolbar"},[_c('h5',{staticClass:"blog-card-title"},[_vm._v(_vm._s(_vm.$t('blogPage.articles')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.search),expression:"filters.search"}],staticClass:"form-control blog-search",attrs:{"type":"text","placeholder":_vm.$t('blogPage.searchByTitle')},domProps:{"value":(_vm.filters.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "search", $event.target.value)},_vm.onSearchInput]}}),_vm._v(" "),_c('el-select',{staticClass:"blog-filter",on:{"change":_vm.reloadArticles},model:{value:(_vm.filters.category_id),callback:function ($$v) {_vm.$set(_vm.filters, "category_id", $$v)},expression:"filters.category_id"}},[_c('el-option',{attrs:{"label":_vm.$t('blogPage.allCategories'),"value":""}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('blogPage.noCategory'),"value":"none"}}),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('el-option',{key:cat.id,attrs:{"label":cat.name,"value":String(cat.id)}})})],2),_vm._v(" "),_c('el-select',{staticClass:"blog-filter",on:{"change":_vm.reloadArticles},model:{value:(_vm.filters.status),callback:function ($$v) {_vm.$set(_vm.filters, "status", $$v)},expression:"filters.status"}},[_c('el-option',{attrs:{"label":_vm.$t('blogPage.allStatuses'),"value":""}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('blogPage.published'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('blogPage.draft'),"value":"0"}})],1),_vm._v(" "),_c('button',{staticClass:"btn add blog-add",on:{"click":_vm.openCreate}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('blogPage.addArticle'))+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"blog-table-wrap"},[_c('table',{staticClass:"table width-table blog-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"9%"}},[_vm._v(_vm._s(_vm.$t('blogPage.cover')))]),_vm._v(" "),_c('th',{attrs:{"width":"37%"}},[_vm._v(_vm._s(_vm.$t('blogPage.title')))]),_vm._v(" "),_c('th',{attrs:{"width":"14%"}},[_vm._v(_vm._s(_vm.$t('blogPage.category')))]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v(_vm._s(_vm.$t('blogPage.author')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('blogPage.publishedAt')))]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v(_vm._s(_vm.$t('blogPage.status')))]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.articles),function(item){return _c('tr',{key:item.id,staticClass:"blog-row",attrs:{"title":_vm.$t('general.edit')},on:{"click":function($event){_vm.openEdit(item)}}},[_c('td',[(item.image_url)?_c('img',{staticClass:"blog-thumb",attrs:{"src":item.image_url}}):_c('span',{staticClass:"text-muted"},[_vm._v("—")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"blog-clamp",attrs:{"title":item.title}},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('small',{staticClass:"text-muted blog-slug"},[_vm._v("/"+_vm._s(item.slug))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.category ? item.category.name : '—'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.author_name || '—'))]),_vm._v(" "),_c('td',{staticClass:"blog-nowrap"},[(item.published_at)?[_vm._v("\n                    "+_vm._s(_vm.formatDay(item.published_at))+"\n                    "),_c('small',{staticClass:"text-muted blog-time"},[_vm._v(_vm._s(_vm.formatTime(item.published_at)))])]:_c('span',{staticClass:"text-muted"},[_vm._v("—")])],2),_vm._v(" "),_c('td',[_c('span',{staticClass:"blog-badge",class:'blog-badge--' + _vm.articleStatus(item)},[_vm._v("\n                    "+_vm._s(_vm.$t('blogPage.' + _vm.articleStatus(item)))+"\n                  ")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"blog-actions"},[_c('a',{staticClass:"btn btn-danger btn-icon delete",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.deleteArticle(item, $event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])])])])}))])]),_vm._v(" "),(!_vm.loading && _vm.articles.length === 0)?_c('p',{staticClass:"text-center mar-tp-20"},[_vm._v("\n          "+_vm._s(_vm.$t('blogPage.noArticles'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.pagination.total > _vm.pagination.per_page)?_c('el-pagination',{staticClass:"active-pagination blog-pagination",attrs:{"total":_vm.pagination.total,"page-size":_vm.pagination.per_page,"current-page":_vm.pagination.page,"layout":"prev, pager, next, total"},on:{"current-change":_vm.handlePageChange}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',{staticClass:"blog-card-title"},[_vm._v(_vm._s(_vm.$t('blogPage.categories')))]),_vm._v(" "),_c('p',{staticClass:"text-muted blog-hint"},[_vm._v(_vm._s(_vm.$t('blogPage.categoriesHint')))]),_vm._v(" "),_c('div',{staticClass:"blog-cat-add"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCategoryName),expression:"newCategoryName"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.CATEGORY_NAME_MAX,"placeholder":_vm.$t('blogPage.categoryName')},domProps:{"value":(_vm.newCategoryName)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addCategory($event)},"input":function($event){if($event.target.composing){ return; }_vm.newCategoryName=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon",attrs:{"disabled":_vm.savingCategory,"title":_vm.$t('general.add')},on:{"click":_vm.addCategory}},[_c('i',{staticClass:"fa fa-plus"})])]),_vm._v(" "),_c('ul',{staticClass:"blog-cat-list"},_vm._l((_vm.categories),function(cat){return _c('li',{key:cat.id},[(_vm.editingCategoryId === cat.id)?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editingCategoryName),expression:"editingCategoryName"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.CATEGORY_NAME_MAX},domProps:{"value":(_vm.editingCategoryName)},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.saveCategory(cat)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }return _vm.cancelEditCategory($event)}],"input":function($event){if($event.target.composing){ return; }_vm.editingCategoryName=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"blog-cat-action text-success",attrs:{"title":_vm.$t('general.save')},on:{"click":function($event){_vm.saveCategory(cat)}}},[_c('i',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('a',{staticClass:"blog-cat-action",attrs:{"title":_vm.$t('general.cancel')},on:{"click":_vm.cancelEditCategory}},[_c('i',{staticClass:"fa fa-times"})])]:[_c('span',{staticClass:"blog-cat-name",attrs:{"title":cat.name}},[_vm._v(_vm._s(cat.name))]),_vm._v(" "),_c('span',{staticClass:"blog-cat-count"},[_vm._v(_vm._s(cat.articles_count || 0))]),_vm._v(" "),_c('a',{staticClass:"blog-cat-action",attrs:{"title":_vm.$t('general.edit')},on:{"click":function($event){_vm.startEditCategory(cat)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),_c('a',{staticClass:"blog-cat-action text-danger",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.deleteCategory(cat)}}},[_c('i',{staticClass:"fa fa-trash"})])]],2)})),_vm._v(" "),(!_vm.categories.length)?_c('p',{staticClass:"text-muted text-center"},[_vm._v(_vm._s(_vm.$t('blogPage.noCategories')))]):_vm._e()])])]),_vm._v(" "),_c('vmodal',{staticClass:"blogArticleModal",attrs:{"name":"blogArticleModal","width":"95%","maxWidth":1100,"minWidth":300,"height":"auto","scrollable":true,"adaptive":true,"clickToClose":false},on:{"opened":_vm.onModalOpened}},[_c('div',{staticClass:"header border-bottom"},[_c('h4',[_vm._v(_vm._s(_vm.form.id ? _vm.$t('blogPage.editArticle') : _vm.$t('blogPage.addArticle')))])]),_vm._v(" "),_c('div',{staticClass:"content-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.title'))+" *")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.title),expression:"form.title"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.TITLE_MAX},domProps:{"value":(_vm.form.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.slug')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.slug),expression:"form.slug"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.SLUG_MAX,"placeholder":_vm.slugPreview},domProps:{"value":(_vm.form.slug)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "slug", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('blogPage.slugHint')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.shortDescription')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.short_description),expression:"form.short_description"}],staticClass:"form-control",attrs:{"rows":"3","maxlength":_vm.SHORT_DESCRIPTION_MAX},domProps:{"value":(_vm.form.short_description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "short_description", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted pull-right"},[_vm._v(_vm._s((_vm.form.short_description || '').length)+" / "+_vm._s(_vm.SHORT_DESCRIPTION_MAX))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.content')))]),_vm._v(" "),(_vm.editorReady)?_c('wysiwyg',{staticClass:"form-control blog-editor",attrs:{"options":_vm.editorOptions},model:{value:(_vm.form.content),callback:function ($$v) {_vm.$set(_vm.form, "content", $$v)},expression:"form.content"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.status')))]),_vm._v(" "),_c('div',{staticClass:"blog-status-switch"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.form.is_active),callback:function ($$v) {_vm.$set(_vm.form, "is_active", $$v)},expression:"form.is_active"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.form.is_active ? _vm.$t('blogPage.published') : _vm.$t('blogPage.draft')))])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.publishedAt')))]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetime","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.form.published_at),callback:function ($$v) {_vm.$set(_vm.form, "published_at", $$v)},expression:"form.published_at"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('blogPage.publishedAtHint')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.category')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",attrs:{"clearable":"","placeholder":_vm.$t('blogPage.noCategory')},model:{value:(_vm.form.blog_category_id),callback:function ($$v) {_vm.$set(_vm.form, "blog_category_id", $$v)},expression:"form.blog_category_id"}},_vm._l((_vm.categories),function(cat){return _c('el-option',{key:cat.id,attrs:{"label":cat.name,"value":cat.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.author')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.author_name),expression:"form.author_name"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.AUTHOR_MAX},domProps:{"value":(_vm.form.author_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "author_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.cover'))+" "),_c('small',{staticClass:"text-muted"},[_vm._v("("+_vm._s(_vm.$t('blogPage.coverHint'))+")")])]),_vm._v(" "),_c('el-upload',{attrs:{"action":"","list-type":"picture-card","accept":".jpg,.jpeg,.png","file-list":_vm.form.imagelist,"limit":1,"auto-upload":false,"on-change":_vm.handleImageChange,"on-remove":_vm.handleImageRemove,"on-exceed":_vm.handleExceed}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.imageAlt')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.image_alt),expression:"form.image_alt"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.IMAGE_ALT_MAX},domProps:{"value":(_vm.form.image_alt)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "image_alt", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"blog-seo"},[_c('a',{staticClass:"blog-seo-toggle",on:{"click":function($event){_vm.seoOpen = !_vm.seoOpen}}},[_c('i',{staticClass:"fa",class:_vm.seoOpen ? 'fa-chevron-down' : 'fa-chevron-right'}),_vm._v("\n              "+_vm._s(_vm.$t('blogPage.seo'))+"\n            ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.seoOpen),expression:"seoOpen"}],staticClass:"blog-seo-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.metaTitle')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.meta_title),expression:"form.meta_title"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.META_TITLE_MAX,"placeholder":_vm.form.title},domProps:{"value":(_vm.form.meta_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "meta_title", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted pull-right"},[_vm._v(_vm._s((_vm.form.meta_title || '').length)+" / 60")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.metaDescription')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.meta_description),expression:"form.meta_description"}],staticClass:"form-control",attrs:{"rows":"3","maxlength":_vm.META_DESCRIPTION_MAX,"placeholder":_vm.form.short_description},domProps:{"value":(_vm.form.meta_description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "meta_description", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted pull-right"},[_vm._v(_vm._s((_vm.form.meta_description || '').length)+" / 160")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('blogPage.metaKeywords')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.meta_keywords),expression:"form.meta_keywords"}],staticClass:"form-control",attrs:{"type":"text","maxlength":_vm.META_KEYWORDS_MAX},domProps:{"value":(_vm.form.meta_keywords)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "meta_keywords", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"blogArticleModal__footer border-top"},[_c('button',{staticClass:"btn btn-default mar-rt-10",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_vm._v("\n        "+_vm._s(_vm.$t('general.cancel'))+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon save",attrs:{"type":"button","disabled":_vm.saving,"title":_vm.$t('general.save')},on:{"click":_vm.saveArticle}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n        "+_vm._s(_vm.$t('general.save'))+"\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XECX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 454.7 145.5"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 454.7 145.5","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_1_","y":"43.8","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_3_","d":"M0,92.7V52.8c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H9C4,101.7,0,97.7,0,92.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,101.7V43.8h57.9v57.9H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_5_","x":"270.9","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_7_","d":"M270.9,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C275,57.9,270.9,53.9,270.9,48.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M270.9,57.9V0h57.9v57.9H270.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_9_","x":"270.9","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_11_","d":"M270.9,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9\n            C275,145.5,270.9,141.5,270.9,136.5z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M270.9,145.5V87.6h57.9v57.9H270.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_13_","x":"347.8","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_15_","d":"M347.8,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C351.9,57.9,347.8,53.9,347.8,48.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M347.8,57.9V0h57.9v57.9H347.8z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_17_","x":"347.8","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_19_","d":"M347.8,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9\n            C351.9,145.5,347.8,141.5,347.8,136.5z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M347.8,145.5V87.6h57.9v57.9H347.8z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_21_","x":"368.4","y":"43.8","width":"86.3","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_23_","d":"M368.4,92.7V52.8c0-5,4-9,9-9h68.2c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-68.2\n            C372.4,101.7,368.4,97.7,368.4,92.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st2",attrs:{"d":"M368.4,101.7V43.8h86.2v57.9H368.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_25_","x":"194","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st13"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_27_","d":"M194,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H203C198,57.9,194,53.9,194,48.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('path',{staticClass:"st2",attrs:{"d":"M194,57.9V0h57.9v57.9H194z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_29_","x":"116.9","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_30_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_29_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_31_","d":"M116.9,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C121,57.9,116.9,53.9,116.9,48.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_32_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_31_"}})]),_vm._v(" "),_c('g',{staticClass:"st16"},[_c('path',{staticClass:"st2",attrs:{"d":"M116.9,57.9V0h57.9v57.9H116.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_33_","x":"46","y":"43.8","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_34_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_33_"}})]),_vm._v(" "),_c('g',{staticClass:"st17"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_35_","d":"M46,92.7V52.8c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H55C50,101.7,46,97.7,46,92.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_36_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_35_"}})]),_vm._v(" "),_c('g',{staticClass:"st18"},[_c('path',{staticClass:"st2",attrs:{"d":"M46,101.7V43.8h57.9v57.9H46z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_37_","x":"43.8","y":"0","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_38_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_37_"}})]),_vm._v(" "),_c('g',{staticClass:"st19"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_39_","d":"M52.8,0h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H52.8c-5,0-9-4-9-9V9C43.8,4,47.8,0,52.8,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_40_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_39_"}})]),_vm._v(" "),_c('g',{staticClass:"st20"},[_c('path',{staticClass:"st2",attrs:{"d":"M43.8,0h57.9v57.9H43.8V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_41_","x":"43.8","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_42_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_41_"}})]),_vm._v(" "),_c('g',{staticClass:"st21"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_43_","d":"M52.8,87.6h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H52.8c-5,0-9-4-9-9V96.6C43.8,91.6,47.8,87.6,52.8,87.6z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_44_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_43_"}})]),_vm._v(" "),_c('g',{staticClass:"st22"},[_c('path',{staticClass:"st2",attrs:{"d":"M43.8,87.6h57.9v57.9H43.8V87.6z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_45_","x":"116.9","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_46_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_45_"}})]),_vm._v(" "),_c('g',{staticClass:"st23"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_47_","d":"M125.9,87.6h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9c-5,0-9-4-9-9V96.6C116.9,91.6,121,87.6,125.9,87.6\n            z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_48_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_47_"}})]),_vm._v(" "),_c('g',{staticClass:"st24"},[_c('path',{staticClass:"st2",attrs:{"d":"M116.9,87.6h57.9v57.9h-57.9V87.6z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_49_","x":"194","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_50_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_49_"}})]),_vm._v(" "),_c('g',{staticClass:"st25"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_51_","d":"M194,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H203C198,145.5,194,141.5,194,136.5z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_52_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_51_"}})]),_vm._v(" "),_c('g',{staticClass:"st26"},[_c('path',{staticClass:"st2",attrs:{"d":"M194,145.5V87.6h57.9v57.9H194z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_53_","x":"10.2","y":"10.2","width":"433.8","height":"125.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_54_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_53_"}})]),_vm._v(" "),_c('g',{staticClass:"st27"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t12_55_","d":"M24.2,10.2h405.9c7.7,0,14,6.3,14,14v97.1c0,7.7-6.3,14-14,14H24.2c-7.7,0-14-6.3-14-14V24.2\n            C10.2,16.5,16.5,10.2,24.2,10.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_56_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_55_"}})]),_vm._v(" "),_c('g',{staticClass:"st28"},[_c('path',{staticClass:"st29",attrs:{"d":"M10.2,10.2H444v125.1H10.2V10.2z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t12_57_","x":"177.2","y":"25.2","width":"95.1","height":"95.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_58_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_57_"}})]),_vm._v(" "),_c('g',{staticClass:"st30"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"t12_59_","cx":"224.7","cy":"72.8","r":"47.6"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t12_60_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t12_59_"}})]),_vm._v(" "),_c('g',{staticClass:"st31"},[_c('path',{staticClass:"st2",attrs:{"d":"M177.2,25.2h95.1v95.1h-95.1V25.2z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XEoW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color__ = __webpack_require__("Zzkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'KioskColorsCard',
  components: {
    ChromePicker: __WEBPACK_IMPORTED_MODULE_2_vue_color__["Chrome"],
    PSwitch: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      model: this.value,
      color: {
        sideBarBg: '#fff',
        mainPageBg: '#F1F1F1',
        addBtnColor: '#ffca40',
        addBtnColorInv: '#000',
        iconsColor1: '#942007',
        iconsColor2: '#fff',
        secundarColor: '#ffca40',
        principalColor: '#4D966D'
      }
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(newVal) {
        this.model = newVal || {};
        this.model.table_scroll_menu_horizontal = !!this.model.table_scroll_menu_horizontal;
        if (this.model.table_colors) {
          try {
            this.color = JSON.parse(this.model.table_colors);
          } catch (e) {
            console.warn('Invalid table_colors JSON, folosim default');
          }
        }
      }
    }
  },
  methods: {
    updateColor: function updateColor(key, newColor) {
      this.color[key] = newColor.hex;
      this.model.table_colors = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.color);
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model));
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'table_colors': this.model.table_colors,
        'kiosk_pass': this.model.kiosk_pass,
        'text_fiscal_print': this.model.text_fiscal_print,
        'table_scroll_menu_horizontal': this.model.table_scroll_menu_horizontal ? 1 : 0
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ 'text': self.$t('settingsTips.tipsSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          self.$session.set('selectedCompanyData', self.buildCompanySessionData(response.data[0]));
        } else {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ 'text': self.$t('settingsTips.tipsError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    }
  }
});

/***/ }),

/***/ "XFTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.preordersItems')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[(_vm.showLocations)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'loc-' + loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n        "+_vm._s(_vm.$t('general.from'))+"\n        "),_c('el-time-select',{staticClass:"mar-rt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
            start: '00:00',
            step: '00:10',
            end: '24:00'
          }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n        "+_vm._s(_vm.$t('general.to'))+"\n        "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
            start: '00:00',
            step: '00:10',
            end: '24:00'
          }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),(_vm.ordersTableData.data && _vm.ordersTableData.data.length > 0)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content"},[_c('div',{staticClass:"report-container-compact"},[_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.orderCounter')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.totalCounter))])])])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"preorders-items-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"total":_vm.totalRecords,"search-def":{show: false},"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"quantity","label":_vm.$t('reports.quantity')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row._isProductRow)?[_vm._v(_vm._s(props.row.quantity || ''))]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":200,"prop":"product","label":_vm.$t('reports.productName')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row._isProductRow)?[_vm._v(_vm._s(props.row.product || props.row.item_name || props.row.name || ''))]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":300,"label":_vm.$t('reports.options')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.option || '-')+"\n              ")]}}])})],1)],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XH+H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XKKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyWeb_vue__ = __webpack_require__("tXqJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0c6579a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyWeb_vue__ = __webpack_require__("kPqi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyWeb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0c6579a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyWeb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XMpP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rebalanceRewards;
/* harmony export (immutable) */ __webpack_exports__["a"] = rewardTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);



function rebalanceRewards(rewards) {
  var createIfMissing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var rows = rewards.map(function (row) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, row);
  });
  if (rows.some(function (row) {
    return Number(row.type) !== 1 && (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(Number(row.winning_percentage)) || Number(row.winning_percentage) < 0.0001);
  })) {
    throw new Error('spinningWheel.percentageRequired');
  }
  var total = rows.filter(function (row) {
    return Number(row.type) !== 1 && row.active;
  }).reduce(function (sum, row) {
    return sum + Math.round(Number(row.winning_percentage) * 10000);
  }, 0);
  if (total > 1000000) throw new Error('spinningWheel.percentageOverflow');
  var nothing = rows.find(function (row) {
    return Number(row.type) === 1;
  });
  var result = rows.filter(function (row) {
    return Number(row.type) !== 1;
  });
  if (!nothing && createIfMissing && result.length) {
    nothing = { id: 'nothing', type: 1, display_title: '', display_description: '', sort_order: 9999 };
  }
  if (nothing) {
    nothing.winning_percentage = (1000000 - total) / 10000;
    nothing.active = total < 1000000;
    result.push(nothing);
  }
  result.forEach(function (row) {
    row._savedWinningPercentage = row.winning_percentage;
  });
  return result.sort(function (a, b) {
    return a.sort_order - b.sort_order;
  });
}

function rewardTitle(row, nothingLabel) {
  var title = row.display_title || row.name;
  return Number(row.type) === 1 && (!title || title === 'Nothing') ? nothingLabel : title;
}

/***/ }),

/***/ "XOix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XPMo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XRNR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XRj4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XRoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('product-form',{attrs:{"productData":_vm.productData,"mainCategoriesParent":_vm.mainCategories,"taxesParent":_vm.taxes,"kdsSectionsParent":_vm.kdsSections,"productOptionsParent":_vm.productOptions,"companyProductFilters":_vm.companyProductFilters,"measurementsUnits":_vm.measurementsUnits,"language":_vm.language,"languages":_vm.languages,"route":_vm.route},on:{"on-submit":_vm.onProductSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XU3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('custom-info-page-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XWuI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.productSaleTrendsReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[(_vm.showLocations)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.products')))]),_vm._v(" "),_c('el-select',{ref:"productSelect",staticStyle:{"width":"100%"},attrs:{"value-key":"id","multiple":"","filterable":"","remote":"","collapse-tags":"","reserve-keyword":"","label":"label","placeholder":_vm.$t('reports.searchProducts'),"remote-method":_vm.searchProducts,"loading":_vm.loadingProducts},on:{"change":_vm.clearSearch},model:{value:(_vm.selectedProducts),callback:function ($$v) {_vm.selectedProducts=$$v},expression:"selectedProducts"}},_vm._l((_vm.mergedProducts),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item}})}))],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('line-chart',{attrs:{"chartData":_vm.chartData,"options":_vm.chartOptions}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"search-def":{show: false},"total":_vm.ordersTableData.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"product_name","label":_vm.$t('reports.productName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"quantity_sold","label":_vm.$t('reports.quantity')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"total_sold","label":_vm.$t('reports.revenue')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_sold)))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"sale_date","label":_vm.$t('reports.date')}})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XWxU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('management-integrations',{attrs:{"grouped-locations":_vm.groupedLocations}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XXU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_transitions_collapse_transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AllModulesModal_vue__ = __webpack_require__("bk31");



var _components;




/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_transitions_collapse_transition___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'AllModulesModal', __WEBPACK_IMPORTED_MODULE_3__AllModulesModal_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      isClosed: false,
      companyName: this.$session.get('companyName'),
      userData: JSON.parse(this.$session.get('userData') || '{}'),
      companyAvatar: this.$session.get('companyAvatar'),
      modules: [{ name: this.$t('modules_reservations'), key: 'use_rezerve', image: __webpack_require__("nMQW") }, { name: this.$t('modules_tables'), key: 'use_table', image: __webpack_require__("9M6q") }, { name: this.$t('modules_dispatch'), key: 'use_dispatch', image: __webpack_require__("k0db") }, { name: this.$t('modules_kds'), key: 'use_kds', image: __webpack_require__("Y/9I") }, { name: this.$t('modules_pms'), key: 'use_pms', image: __webpack_require__("W0tZ") }, { name: this.$t('modules_app'), key: 'use_app', image: __webpack_require__("9720") }, { name: this.$t('modules_website'), key: 'use_website', image: __webpack_require__("DI3i") }, { name: this.$t('modules_catalog'), key: 'use_catalog', image: __webpack_require__("NOIG") }, { name: this.$t('modules_screens'), key: 'use_screens', image: __webpack_require__("mBJ5") }, { name: this.$t('modules_pos'), key: 'use_pos', image: __webpack_require__("PdiO") }, { name: this.$t('modules_inventory'), key: 'use_gestiune', image: __webpack_require__("xeGU") }, { name: this.$t('modules_clients'), key: 'use_client', image: __webpack_require__("JFQz") }, { name: this.$t('modules_orders'), key: 'use_ordering', image: __webpack_require__("P6UO") }, { name: this.$t('modules_add_order'), key: 'use_add_order', image: __webpack_require__("r651") }, { name: this.$t('modules_marketing'), key: 'use_marketing_standard', image: __webpack_require__("DkQd") }, { name: this.$t('modules_marketing_gift'), key: 'use_marketing_gift_card', image: __webpack_require__("japT") }, { name: this.$t('modules_kiosk'), key: 'use_kiosk', image: __webpack_require__("Y5WP") }, { name: this.$t('modules_qr_ordering'), key: 'use_qr_ordering', image: __webpack_require__("klo8") }]
    };
  },
  created: function created() {
    this.minimizeSidebar();

    console.log('userData', this.userData.companies);
    this.$on('companyName', function (name) {
      this.companyName = name;
    });
  },

  computed: {
    companyFeatures: function companyFeatures() {
      return this.userData.companies[0] || {};
    },
    enrichedModules: function enrichedModules() {
      var features = this.companyFeatures || {};
      var DEFAULT_ACTIVE = ['use_rezerve', 'use_catalog', 'use_client', 'use_ordering', 'use_add_order'];
      return this.modules.map(function (module) {
        var hasKey = Object.prototype.hasOwnProperty.call(features, module.key);
        var value = features[module.key];
        var active = DEFAULT_ACTIVE.includes(module.key) ? true : hasKey ? Number(value) === 1 : false;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, module, { active: active });
      });
    },
    activeModules: function activeModules() {
      return this.enrichedModules.filter(function (m) {
        return m.active;
      });
    },
    inactiveModules: function inactiveModules() {
      return this.enrichedModules.filter(function (m) {
        return !m.active;
      });
    },
    activeModulesPercent: function activeModulesPercent() {
      var total = this.enrichedModules.length;
      var active = this.enrichedModules.filter(function (m) {
        return m.active;
      }).length;
      return total ? Math.round(active / total * 100) : 0;
    }
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    goToSettings: function goToSettings() {
      this.$session.set('selecetdTab', 'Company Details');
      if (!this.isOwner()) {
        this.$router.push('/admin/overview');
      } else {
        this.$router.push('/settings');
      }
    },
    minimizeSidebar: function minimizeSidebar(isMinimizeFromButton) {
      if (isMinimizeFromButton) {
        this.$sidebar.toggleMinimize();
        this.$session.set('isMinimized', this.$sidebar.isMinimized);
      } else {
        var minMenu = this.$session.get('isMinimized');
        if (minMenu === undefined && this.$sidebar.isMinimized) {
          this.$sidebar.toggleMinimize();
        }
        if (minMenu === false && this.$sidebar.isMinimized) {
          this.$sidebar.toggleMinimize();
        } else if (minMenu && !this.$sidebar.isMinimized) {
          this.$sidebar.toggleMinimize();
        }
      }
    },
    openModulesModal: function openModulesModal() {
      this.$refs.allModulesModalRef.open();
    }
  }
});

/***/ }),

/***/ "Xc4l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XdhT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XiU3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductOptionsPanel_vue__ = __webpack_require__("BzuL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WoltMenuLayout',
  components: { ProductOptionsPanel: __WEBPACK_IMPORTED_MODULE_1__ProductOptionsPanel_vue__["a" /* default */] },
  props: {
    categories: { type: Array, default: function _default() {
        return [];
      } },
    currency: { type: String, default: 'RON' }
  },
  data: function data() {
    return {
      activeCategoryId: null,
      selectedProduct: null
    };
  },

  watch: {
    categories: {
      immediate: true,
      handler: function handler(cats) {
        if (cats && cats.length) {
          this.activeCategoryId = cats[0].id;
        }
        this.selectedProduct = null;
      }
    }
  },
  methods: {
    selectCategory: function selectCategory(id) {
      this.activeCategoryId = id;
      this.$nextTick(function () {
        var el = document.getElementById('wolt-cat-' + id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    truncate: function truncate(text) {
      var s = String(text || '');
      return s.length > 90 ? s.slice(0, 87) + '...' : s;
    },
    formatPrice: function formatPrice(price) {
      var n = Number(price);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(n)) return '';
      return n.toFixed(2).replace('.', ',') + ' ' + this.currency;
    }
  }
});

/***/ }),

/***/ "XiiD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaignAdd_vue__ = __webpack_require__("EtOM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f11b644_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaignAdd_vue__ = __webpack_require__("Yq2n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaignAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f11b644_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaignAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xipi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('payment-groups-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xkp9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('test',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XqGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuLinkEdit_vue__ = __webpack_require__("IAoy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_933c4ccc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuLinkEdit_vue__ = __webpack_require__("6+yi");
function injectStyle (ssrContext) {
  __webpack_require__("qGiE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuLinkEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_933c4ccc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuLinkEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XssK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaignUsersReport_vue__ = __webpack_require__("Nubt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e79b499_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaignUsersReport_vue__ = __webpack_require__("6cn/");
function injectStyle (ssrContext) {
  __webpack_require__("NlLU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e79b499"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaignUsersReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e79b499_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaignUsersReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XviY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('pos-user-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XwFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-top"},[_c('button',{staticClass:"btn add",on:{"click":_vm.openAddModal}},[_vm._v("\n            "+_vm._s(_vm.$t('giftCard.addgift'))+"\n          ")])]),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%","margin-top":"20px"},attrs:{"data":_vm.tableData},on:{"row-click":_vm.goToDetails}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('giftCard.type')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type == 1)?_c('span',[_vm._v(_vm._s(_vm.$t('giftCard.online')))]):_c('span',[_vm._v(_vm._s(_vm.$t('giftCard.offline')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":_vm.$t('giftCard.value')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"expiration_time","label":_vm.$t('giftCard.exp')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"gift_cards_count","label":_vm.$t('giftCard.generatedCards')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('giftCard.active')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.active == 1)?_c('span',[_vm._v(_vm._s(_vm.$t('giftCard.yes')))]):_c('span',[_vm._v(_vm._s(_vm.$t('giftCard.no')))])]}}])})],1),_vm._v(" "),(_vm.pagination.totalPages > 1)?_c('div',{staticClass:"pagination-wrapper"},[_c('el-pagination',{attrs:{"layout":"prev, pager, next","current-page":_vm.pagination.page,"page-size":_vm.pagination.perPage,"total":_vm.pagination.totalRecords},on:{"current-change":_vm.handlePageChange}})],1):_vm._e()],1)])]),_vm._v(" "),_c('vmodal',{attrs:{"name":"addModal","width":700,"height":"auto","clickToClose":false}},[_c('div',{staticClass:"modal-content",staticStyle:{"padding":"20px"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('giftCard.modalTitle')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('giftCard.typeLabel')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('giftCard.selectType')},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}},[_c('el-option',{attrs:{"label":_vm.$t('giftCard.online'),"value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('giftCard.offline'),"value":2}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('giftCard.valueLabel')))]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","max":"100000"},model:{value:(_vm.form.value),callback:function ($$v) {_vm.$set(_vm.form, "value", $$v)},expression:"form.value"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('giftCard.expLabel')))]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","max":"700"},model:{value:(_vm.form.expiration_time),callback:function ($$v) {_vm.$set(_vm.form, "expiration_time", $$v)},expression:"form.expiration_time"}})],1),_vm._v(" "),(_vm.form.type === 2)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('giftCard.totalCards')))]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","max":"10000"},model:{value:(_vm.form.total_number),callback:function ($$v) {_vm.$set(_vm.form, "total_number", $$v)},expression:"form.total_number"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dialog-footer",staticStyle:{"text-align":"right","margin-top":"20px"}},[_c('el-button',{on:{"click":function($event){_vm.$modal.hide('addModal')}}},[_vm._v(_vm._s(_vm.$t('giftCard.cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.saving},on:{"click":_vm.submitForm}},[_vm._v("\n          "+_vm._s(_vm.$t('giftCard.save'))+"\n        ")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xxll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.cancelZone($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteZone($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("ID: "+_vm._s(_vm.model.id))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Group Name")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.model.gateway === 'btIpay' ? {required: true} : _vm.modelValidate.group_name),expression:"model.gateway === 'btIpay' ? {required: true} : modelValidate.group_name"},{name:"model",rawName:"v-model",value:(_vm.model.group_name),expression:"model.group_name"}],staticClass:"form-control",attrs:{"type":"text","name":"group_name","data-vv-as":"Group Name","placeholder":"Group Name"},domProps:{"value":(_vm.model.group_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "group_name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('group_name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('group_name'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gateway")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.gateway),expression:"modelValidate.gateway"},{name:"model",rawName:"v-model",value:(_vm.model.gateway),expression:"model.gateway"}],staticClass:"form-control",attrs:{"name":"location"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "gateway", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.changeGateway()}]}},_vm._l((_vm.locations),function(loc){return _c('option',{key:loc,attrs:{"label":loc},domProps:{"value":loc}})}))]),_vm._v(" "),(_vm.model.gateway === 'btIpay')?[(_vm.btFormError)?_c('p',{staticClass:"text-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.btFormError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"bt-api-user"}},[_vm._v(_vm._s(_vm.$t('btPayments.apiUser')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.bt_ipay_data.api_user),expression:"model.bt_ipay_data.api_user"},{name:"validate",rawName:"v-validate",value:({required: true, max: 30}),expression:"{required: true, max: 30}"}],staticClass:"form-control",attrs:{"id":"bt-api-user","name":"bt_api_user","type":"text","autocomplete":"off","maxlength":"30"},domProps:{"value":(_vm.model.bt_ipay_data.api_user)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.bt_ipay_data, "api_user", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('bt_api_user')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"bt-api-password"}},[_vm._v(_vm._s(_vm.$t('btPayments.apiPassword')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.bt_ipay_data.api_password),expression:"model.bt_ipay_data.api_password"},{name:"validate",rawName:"v-validate",value:({required: !_vm.model.bt_ipay_data.has_api_password, max: 30}),expression:"{required: !model.bt_ipay_data.has_api_password, max: 30}"}],staticClass:"form-control",attrs:{"id":"bt-api-password","name":"bt_api_password","type":"password","autocomplete":"new-password","maxlength":"30"},domProps:{"value":(_vm.model.bt_ipay_data.api_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.bt_ipay_data, "api_password", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('bt_api_password')))]),_vm._v(" "),(_vm.model.bt_ipay_data.has_api_password)?_c('p',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('btPayments.passwordConfigured')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"bt-environment"}},[_vm._v(_vm._s(_vm.$t('btPayments.environment')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.bt_ipay_data.environment),expression:"model.bt_ipay_data.environment"}],staticClass:"form-control",attrs:{"id":"bt-environment"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.bt_ipay_data, "environment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"sandbox"}},[_vm._v(_vm._s(_vm.$t('btPayments.sandbox')))]),_vm._v(" "),_c('option',{attrs:{"value":"production"}},[_vm._v(_vm._s(_vm.$t('btPayments.production')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"bt-payment-mode"}},[_vm._v(_vm._s(_vm.$t('btPayments.mode')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.bt_ipay_data.payment_type),expression:"model.bt_ipay_data.payment_type"}],staticClass:"form-control",attrs:{"id":"bt-payment-mode"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.bt_ipay_data, "payment_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1phase"}},[_vm._v(_vm._s(_vm.$t('btPayments.onePhase')))]),_vm._v(" "),_c('option',{attrs:{"value":"2phase"}},[_vm._v(_vm._s(_vm.$t('btPayments.twoPhase')))])]),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('btPayments.modeHelp')))]),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('btPayments.captureHelp')))])])]:_vm._e(),_vm._v(" "),(_vm.model.gateway == 'euplatesc')?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gateway ID")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.gateway_id),expression:"modelValidate.gateway_id"},{name:"model",rawName:"v-model",value:(_vm.model.gateway_id),expression:"model.gateway_id"}],staticClass:"form-control",attrs:{"type":"text","name":"gateway_id","data-vv-as":"Gateway ID","placeholder":"Gateway ID"},domProps:{"value":(_vm.model.gateway_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "gateway_id", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('gateway_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('gateway_id'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Public Key")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.public_key),expression:"modelValidate.public_key"},{name:"model",rawName:"v-model",value:(_vm.model.public_key),expression:"model.public_key"}],staticClass:"form-control",attrs:{"type":"text","name":"public_key","data-vv-as":"Public Key","placeholder":"Public Key","disabled":""},domProps:{"value":(_vm.model.public_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "public_key", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('public_key'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('public_key'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Private Key")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.private_key),expression:"modelValidate.private_key"},{name:"model",rawName:"v-model",value:(_vm.model.private_key),expression:"model.private_key"}],staticClass:"form-control",attrs:{"type":"text","name":"private_key","data-vv-as":"Private Key","placeholder":"Private Key"},domProps:{"value":(_vm.model.private_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "private_key", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('private_key'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('private_key'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("UKEY")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.UKEY),expression:"modelValidate.UKEY"},{name:"model",rawName:"v-model",value:(_vm.model.UKEY),expression:"model.UKEY"}],staticClass:"form-control",attrs:{"type":"text","name":"UKEY","data-vv-as":"UKEY","placeholder":"UKEY"},domProps:{"value":(_vm.model.UKEY)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "UKEY", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('UKEY'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('UKEY'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("UAPI")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.UAPI),expression:"modelValidate.UAPI"},{name:"model",rawName:"v-model",value:(_vm.model.UAPI),expression:"model.UAPI"}],staticClass:"form-control",attrs:{"type":"text","name":"UAPI","data-vv-as":"UAPI","placeholder":"UAPI"},domProps:{"value":(_vm.model.UAPI)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "UAPI", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('UAPI'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('UAPI'))+"\n                  ")]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.model.gateway == 'paylike')?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gateway ID")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.gateway_id),expression:"modelValidate.gateway_id"},{name:"model",rawName:"v-model",value:(_vm.model.gateway_id),expression:"model.gateway_id"}],staticClass:"form-control",attrs:{"type":"text","name":"gateway_id","data-vv-as":"Gateway ID","placeholder":"Gateway ID"},domProps:{"value":(_vm.model.gateway_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "gateway_id", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('gateway_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('gateway_id'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Public Key")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.public_key),expression:"modelValidate.public_key"},{name:"model",rawName:"v-model",value:(_vm.model.public_key),expression:"model.public_key"}],staticClass:"form-control",attrs:{"type":"text","name":"public_key","data-vv-as":"Public Key","placeholder":"Public Key"},domProps:{"value":(_vm.model.public_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "public_key", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('public_key'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('public_key'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Private Key")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.private_key),expression:"modelValidate.private_key"},{name:"model",rawName:"v-model",value:(_vm.model.private_key),expression:"model.private_key"}],staticClass:"form-control",attrs:{"type":"text","name":"private_key","data-vv-as":"Private Key","placeholder":"Private Key"},domProps:{"value":(_vm.model.private_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "private_key", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('private_key'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('private_key'))+"\n                  ")]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.model.gateway == 'stripe')?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Gateway ID")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.gateway_id),expression:"modelValidate.gateway_id"},{name:"model",rawName:"v-model",value:(_vm.model.gateway_id),expression:"model.gateway_id"}],staticClass:"form-control",attrs:{"type":"text","name":"gateway_id","data-vv-as":"Gateway ID","placeholder":"Gateway ID","disabled":""},domProps:{"value":(_vm.model.gateway_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "gateway_id", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('gateway_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('gateway_id'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Public Key")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.public_key),expression:"modelValidate.public_key"},{name:"model",rawName:"v-model",value:(_vm.model.public_key),expression:"model.public_key"}],staticClass:"form-control",attrs:{"type":"text","name":"public_key","data-vv-as":"Public Key","placeholder":"Public Key"},domProps:{"value":(_vm.model.public_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "public_key", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('public_key'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('public_key'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Private Key")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.private_key),expression:"modelValidate.private_key"},{name:"model",rawName:"v-model",value:(_vm.model.private_key),expression:"model.private_key"}],staticClass:"form-control",attrs:{"type":"text","name":"private_key","data-vv-as":"Private Key","placeholder":"Private Key"},domProps:{"value":(_vm.model.private_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "private_key", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('private_key'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('private_key'))+"\n                  ")]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.model.gateway == 'vivaWallet')?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Public Key")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.public_key),expression:"modelValidate.public_key"},{name:"model",rawName:"v-model",value:(_vm.model.public_key),expression:"model.public_key"}],staticClass:"form-control",attrs:{"type":"text","name":"public_key","data-vv-as":"Public Key","placeholder":"Public Key"},domProps:{"value":(_vm.model.public_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "public_key", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('public_key'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('public_key'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Private Key")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.private_key),expression:"modelValidate.private_key"},{name:"model",rawName:"v-model",value:(_vm.model.private_key),expression:"model.private_key"}],staticClass:"form-control",attrs:{"type":"text","name":"private_key","data-vv-as":"Private Key","placeholder":"Private Key"},domProps:{"value":(_vm.model.private_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "private_key", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('private_key'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('private_key'))+"\n                  ")]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.model.gateway == 'libraPay')?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Merchant Name")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.merch_name),expression:"modelValidate.merch_name"},{name:"model",rawName:"v-model",value:(_vm.model.libra_pay_data.merch_name),expression:"model.libra_pay_data.merch_name"}],staticClass:"form-control",attrs:{"type":"text","name":"merch_name","data-vv-as":"Merchant Name","placeholder":"Merchant Name"},domProps:{"value":(_vm.model.libra_pay_data.merch_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.libra_pay_data, "merch_name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('merch_name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('merch_name'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Merchant URL")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.merch_url),expression:"modelValidate.merch_url"},{name:"model",rawName:"v-model",value:(_vm.model.libra_pay_data.merch_url),expression:"model.libra_pay_data.merch_url"}],staticClass:"form-control",attrs:{"type":"text","name":"merch_url","data-vv-as":"Merchant URL","placeholder":"Merchant URL"},domProps:{"value":(_vm.model.libra_pay_data.merch_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.libra_pay_data, "merch_url", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('merch_url'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('merch_url'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.email),expression:"modelValidate.email"},{name:"model",rawName:"v-model",value:(_vm.model.libra_pay_data.email),expression:"model.libra_pay_data.email"}],staticClass:"form-control",attrs:{"type":"text","name":"email","data-vv-as":"Email","placeholder":"Email"},domProps:{"value":(_vm.model.libra_pay_data.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.libra_pay_data, "email", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('email'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('email'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Key")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.key),expression:"modelValidate.key"},{name:"model",rawName:"v-model",value:(_vm.model.libra_pay_data.key),expression:"model.libra_pay_data.key"}],staticClass:"form-control",attrs:{"type":"text","name":"key","data-vv-as":"Key","placeholder":"Key"},domProps:{"value":(_vm.model.libra_pay_data.key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.libra_pay_data, "key", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('key'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('key'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Merchant")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.merchant),expression:"modelValidate.merchant"},{name:"model",rawName:"v-model",value:(_vm.model.libra_pay_data.merchant),expression:"model.libra_pay_data.merchant"}],staticClass:"form-control",attrs:{"type":"text","name":"merchant","data-vv-as":"Merchant","placeholder":"Merchant"},domProps:{"value":(_vm.model.libra_pay_data.merchant)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.libra_pay_data, "merchant", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('merchant'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('merchant'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Terminal")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.terminal),expression:"modelValidate.terminal"},{name:"model",rawName:"v-model",value:(_vm.model.libra_pay_data.terminal),expression:"model.libra_pay_data.terminal"}],staticClass:"form-control",attrs:{"type":"text","name":"terminal","data-vv-as":"Terminal","placeholder":"Terminal"},domProps:{"value":(_vm.model.libra_pay_data.terminal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.libra_pay_data, "terminal", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('terminal'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('terminal'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Post Action")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.postAction),expression:"modelValidate.postAction"},{name:"model",rawName:"v-model",value:(_vm.model.libra_pay_data.postAction),expression:"model.libra_pay_data.postAction"}],staticClass:"form-control",attrs:{"type":"text","name":"postAction","data-vv-as":"Post Action","placeholder":"Post Action"},domProps:{"value":(_vm.model.libra_pay_data.postAction)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.libra_pay_data, "postAction", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('postAction'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('postAction'))+"\n                  ")]):_vm._e()])]:_vm._e()],2)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xzg0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsLocations_vue__ = __webpack_require__("brt+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8e8a70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsLocations_vue__ = __webpack_require__("/lhP");
function injectStyle (ssrContext) {
  __webpack_require__("iQAi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsLocations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8e8a70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsLocations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XzuK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y+4g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y/9I":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAtCAYAAAAOYyOGAAAABHNCSVQICAgIfAhkiAAAAz5JREFUaEPtmkFyUkEQhnsSYiUr4wkkJzDeADZWkY2wtJKUcAL1BnoC8QQhlaRcBjehyg3xBIknCJ5AWCVVIYx/P2bwwXuY96bnvRKKtwKKme5v/p7ungFFeDpfdVEP6bNStIu3Rf5swZ5LrenL3qFqs9/KAF0BaHvBQCLuaqIPeweqqTqnmuleLzoQ+w+1+ltD2lEXJ/r3MqhkRQFYjZWCakv0aPq0gloIPVdKZSgT1xgkqzpMPBWbESmFwZtDat4V6JIUvXB2RlGjsq9a3kqLBGpd0ctX++q6e6S3ncEs0Jmuk6Yj54UJD3SFQg34hco9aaecwOKBjhGKbYTiuTOgM5SmH+izSmHDqcDmAFUOVP37md590HT1X0CxE4nAHgEajqhrOpyBU+IQKNWHUs/iVvMRsG9Qo8pNND3QjRl/zArxuNsC3QRAmn4iCZXunlA19V5zhTLNY822+rNwc8HWaafyRvVCIfYXaAMKEY4+BojnvLWfpYlFIVQbULV59uLAoAj8nn4ChXwBBast7f3M/kgKFgeF+tTC+LdWoXJD9XFyOAd+NY1Ak+9Kofj8UlijMterhGAtgDXC3wVAlbsJ1L2PPA8guV7VnYC8KMVqewCzAGIgX1AmaYgUC/bfRlBwS84K2YHS8As74KIYesYe9lIRYzkE/dyR+ISyiiG91SqH6jLhHhMLE5nAN1TIQA+viwY0kvoTdR6uuBlBcXvD9aKnEVJQ7jneRbKe2UcMLz9DTe0DaZ2KruYAqblkU/yMIhEw01lwqPoD86zUFNAkTZ/oEhJCdyze+LIxvBbewTxCxQKxw6Gue8wS04V4BfMElRzISpQlmAeo9EAGzF4HeA9FIZQzkK1pcX2jOBQlUPNWOrKH/lFv5nUhoiO9K5T9dYGPCdbn2KSQoIAiI15v3VM5PFcnlDETTDH9FVcok54nzrgCWW/CYNK5xIdEdmYN56DRiFrShpTnwhxtPaL3orkkSqUOi7wGrKDyWmmpnZVS0hXMa/zSKnVxqnvmIJfXWmZrR1OZ/3LQRF14l62l3GYfbN5TUWV6X5Aby9gQ/4eC7/eDu21zn82/5rld9ebs/Kw5RFoPDXbTXiP8Aeo0kMS1Mj7tAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Y/xN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y09D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__);















var _components;







__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a), _components),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    },
    isUsers: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.userRole = this.$session.get('userDataRole');
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      userRole: null,
      filters: {
        id: '',
        name: '',
        email: '',
        role: ''
      },
      roleOptions: ['OWNER', 'DRIVER', 'USER', 'LOCATION_ADMIN', 'LOCATION_STORE_ADMIN', 'MARKETER', 'OPERATOR', 'KDS_OPERATOR', 'USER_CUSTOM', 'DISPATCHER'],
      tableColumns: [{
        prop: 'id',
        label: 'ID',
        minWidth: 100
      }, {
        prop: 'firstname',
        label: this.$t('settingUsers.fn'),
        minWidth: 100
      }, {
        prop: 'lastname',
        label: this.$t('settingUsers.ln'),
        minWidth: 100
      }],
      tableData: []
    };
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    handleSearch: function handleSearch() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/user/edit/');
    },
    getData: function getData() {
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.filters.id !== null && String(this.filters.id).trim() !== '') {
        data.id = String(this.filters.id).trim();
      }
      if (this.filters.name !== null && String(this.filters.name).trim() !== '') {
        data.name = String(this.filters.name).trim();
      }
      if (this.filters.email !== null && String(this.filters.email).trim() !== '') {
        data.email = String(this.filters.email).trim();
      }
      if (this.filters.role !== null && String(this.filters.role).trim() !== '') {
        data.role = String(this.filters.role).trim();
      }

      this.loading = true;
      this.apiRequest('/profile', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data;

          self.$nextTick(function () {
            self.loading = false;
          });
        } else {
          self.loading = false;
        }
      });
    },
    goToAdd: function goToAdd() {
      if (typeof this.callback === 'function') {
        this.callback(null);
      }
    }
  }
});

/***/ }),

/***/ "Y2no":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelCampaignAdd_vue__ = __webpack_require__("MWvD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_090efa55_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelCampaignAdd_vue__ = __webpack_require__("SHkX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelCampaignAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_090efa55_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelCampaignAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y2xW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y5Cc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__ = __webpack_require__("Ark/");






var _components;









/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */],
    SearchableMultiSelect: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isStorno: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isStorno: function isStorno() {
      if (this.isStorno) {
        this.getOrders();
        this.verifyUserLocations();
        this.verifyUserMethods();
        this.getPosUsers();
      }
    }
  },
  computed: {
    posUsers: function posUsers() {
      return this.rawPosUsers.map(function (user) {
        return {
          value: user.id,
          label: user.firstname + ' ' + user.lastname
        };
      });
    }
  },
  mounted: function mounted() {
    if (this.$refs.topProductSales.chart) {
      this.$refs.topProductSales.initChartAndReturn();
    }
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      selectedCategories: [],
      selectedTopCategories: [],
      rawPosUsers: [],
      ordersTableData: {},
      selectedPosUser: null,
      topProductSales: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '500px',
          axisX: {
            scaleMinSpace: 50,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_8_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      colors: ['#f44336', '#2196f3', '#ff9800', '#9c27b0', '#00bcd4', '#8bc34a', '#ffc107', '#3f51b5', '#ff5722', '#795548', '#607d8b', '#009688', '#cddc39', '#673ab7', '#03a9f4', '#aed581', '#ffb74d', '#ba68c8'],
      noData: false
    };
  },

  methods: {
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (this.$session.get('userDataRole') === 'USER' || this.$session.get('userDataRole') === 'LOCATION_ADMIN' || this.$session.get('userDataRole') === 'LOCATION_STORE_ADMIN') {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        console.log(allowedLocations);
        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this = this;

      if (!this.isStorno) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.selectedPosUser && this.selectedPosUser.length) {
        data.operator_ids = this.selectedPosUser.map(function (element) {
          return element.value;
        });
      }

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;

      this.apiRequest('/reports/v2/storno' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          if (response.data.table_data.length) {
            _this.ordersTableData.data = response.data.table_data;
            _this.ordersTableData.total = response.pagination.total;
            _this.paginationProps.currentPage = response.pagination.page;
            _this.paginationProps.pageSize = response.pagination.perPage;
          } else {
            _this.ordersTableData.data = [];
            _this.ordersTableData.total = 0;
            _this.paginationProps.currentPage = 1;
            _this.paginationProps.pageSize = 20;
          }

          _this.topProductSales.options.chartPadding = {
            top: 30,
            right: 10,
            bottom: 20,
            left: 20
          };

          if (!response.data.labels.length) {
            _this.$nextTick(function () {
              _this.topProductSales.data.labels = [];
              _this.topProductSales.data.series = [[]];
              _this.noData = true;

              if (_this.$refs.topProductSales.chart) {
                _this.$refs.topProductSales.initChartAndReturn();
              }

              return false;
            });
          }

          _this.noData = false;
          _this.topProductSales.data.labels = response.data.labels.map(function (elem) {
            return _this.$t('reports.' + elem);
          });
          _this.topProductSales.data.series = [response.data.series];

          _this.$nextTick(function () {
            _this.$refs.topProductSales.initChartAndReturn();

            if (_this.$refs.topProductSales.chart) {
              _this.$refs.topProductSales.chart.on('draw', function (data) {
                if (data.type === 'bar') {
                  data.element.attr({
                    style: 'stroke: ' + _this.colors[data.index % _this.colors.length] + '; stroke-width: 60px;'
                  });
                }
              });
            }
          });
        } else {
          _this.topProductSales.data.labels = [];
          _this.topProductSales.data.series = [[]];
          _this.discounts = [];
          _this.noData = true;

          if (_this.$refs.topProductSales.chart) {
            _this.$refs.topProductSales.initChartAndReturn();
          }

          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    exportData: function exportData() {
      var _this2 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/storno-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
        }
        _this2.loading = false;
      });
    },
    getPosUsers: function getPosUsers() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this3.rawPosUsers = response.data.pos_user;
        }
      });
    },
    formatToCompanyTimezone: function formatToCompanyTimezone(utcString) {
      var date = new Date(utcString + 'Z');
      var formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: this.timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      var parts = formatter.formatToParts(date);

      return parts.find(function (p) {
        return p.type === 'year';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'month';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'day';
      }).value + ' ' + parts.find(function (p) {
        return p.type === 'hour';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'minute';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'second';
      }).value;
    }
  }
});

/***/ }),

/***/ "Y5WP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Y6cz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page login-wrapper"},[_c('div',{staticClass:"full-page reset-page",attrs:{"data-color":"","data-image":"static/img/background/background-2.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-box"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.login({ email: _vm.email, password: _vm.password })}}},[_c('div',{attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.recoverMsg !== ''),expression:"recoverMsg !== ''"}],staticClass:"text-success"},[_vm._v("\n                      "+_vm._s(_vm.recoverMsg)+"\n                    ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('error'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Reset Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.code),expression:"model.code"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.code),expression:"modelValidations.code"}],staticClass:"form-control",attrs:{"type":"text","name":"code","placeholder":"Reset code *"},domProps:{"value":(_vm.model.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "code", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('code')),expression:"errors.has('code')"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('code'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"}],staticClass:"form-control ",attrs:{"type":"email","name":"email","placeholder":"Email*"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('email'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":"Password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('password'))+"\n                      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password_confirmation),expression:"modelValidations.password_confirmation"},{name:"model",rawName:"v-model",value:(_vm.model.password_confirmation),expression:"model.password_confirmation"}],staticClass:"form-control",attrs:{"type":"password","name":"password_confirmation","placeholder":"Confirm Password","data-vv-as":"password"},domProps:{"value":(_vm.model.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password_confirmation", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('password_confirmation'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError('password_confirmation'))+"\n                      ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-orange-purple btn-fill btn-wd ",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Let's go")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"full-page-background"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Register")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/admin/overview","tag":"li"}},[_c('a',[_vm._v("Dashboard")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header text-center"},[_c('a',{attrs:{"href":"//taptasty.com"}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logo-taptasty.png"}})]),_vm._v(" "),_c('h4',{staticClass:"purple mar-to-0 mar-bt-25"},[_vm._v("Reset Password")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YBMp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YBPa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MenuLinkForm_vue__ = __webpack_require__("RyIs");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'MenuLinkForm', __WEBPACK_IMPORTED_MODULE_7__MenuLinkForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      linkModel: {},
      link: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onLinkSubmit: function onLinkSubmit(model, isValid) {
      this.linkModel = model;
    }
  }
});

/***/ }),

/***/ "YCPL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscriptions_vue__ = __webpack_require__("G9By");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d9e69a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscriptions_vue__ = __webpack_require__("+igg");
function injectStyle (ssrContext) {
  __webpack_require__("6xUT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscriptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d9e69a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscriptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YCRe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YDLQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.taxation')))]),_vm._v(" "),_c('v-select',{key:'has-receipt-select',staticClass:"w-100 white mar-bt-15 line-heigth-44",attrs:{"options":_vm.receiptOptions,"label":"label","reduce":function (method) { return method.key; },"placeholder":_vm.$t('general.all')},model:{value:(_vm.hasRceipt),callback:function ($$v) {_vm.hasRceipt=$$v},expression:"hasRceipt"}})],1),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100"},[_c('label',[_vm._v(_vm._s(_vm.$t('reports.topCategory')))]),_vm._v(" "),_c('v-select',{staticClass:"mar-bt-15 line-heigth-44",attrs:{"multiple":"","options":_vm.topCategories,"label":"name","placeholder":_vm.$t('general.all')},model:{value:(_vm.topCategoryId),callback:function ($$v) {_vm.topCategoryId=$$v},expression:"topCategoryId"}})],1),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100"},[_c('label',[_vm._v(_vm._s(_vm.$t('reports.section')))]),_vm._v(" "),_c('v-select',{staticClass:"line-heigth-44",attrs:{"multiple":"","options":_vm.sections,"label":"name","placeholder":_vm.$t('general.all')},model:{value:(_vm.sectionId),callback:function ($$v) {_vm.sectionId=$$v},expression:"sectionId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.paymentMethods.length)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectedPaymentMethods')))]),_vm._v(" "),_c('v-select',{key:'payment-methods-multiselect',staticClass:"w-100 white mar-bt-15 line-heigth-44",attrs:{"multiple":"","options":_vm.paymentMethods,"label":"name","reduce":function (method) { return method.id; },"placeholder":_vm.$t('general.all')},model:{value:(_vm.selected_payment_methods),callback:function ($$v) {_vm.selected_payment_methods=$$v},expression:"selected_payment_methods"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100 mar-bt-15"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('general.orderId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderId),expression:"orderId"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"price","placeholder":"3823231"},domProps:{"value":(_vm.orderId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orderId=$event.target.value}}})]),_vm._v(" "),(_vm.posUsers.length)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.operator')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPosUser),expression:"selectedPosUser"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedPosUser=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.alls')}},[_vm._v(_vm._s(_vm.$t('general.alls')))]),_vm._v(" "),_vm._l((_vm.posUsers),function(operator){return [_c('option',{attrs:{"label":operator.firstname + ' ' + operator.lastname},domProps:{"value":operator.id}},[_vm._v("\n                "+_vm._s(operator.firstname)+" "+_vm._s(operator.lastname)+"\n              ")])]})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.zet')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zet),expression:"zet"}],staticClass:"form-control mar-bt-15",attrs:{"type":"number","min":"0","placeholder":_vm.$t('reports.zet')},domProps:{"value":(_vm.zet)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zet=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_column),expression:"date_column"}],staticClass:"form-control pull-left",staticStyle:{"width":"auto","min-width":"140px","margin-left":"10px","height":"40px","vertical-align":"middle"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.date_column=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"created_at"}},[_vm._v(_vm._s(_vm.$t('reports.dateColumnCreate')))]),_vm._v(" "),_c('option',{attrs:{"value":"closed_at"}},[_vm._v(_vm._s(_vm.$t('reports.dateColumnClose')))]),_vm._v(" "),_c('option',{attrs:{"value":"fiscalized_at"}},[_vm._v(_vm._s(_vm.$t('reports.dateColumnFiscalize')))])]),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportVatTotalsPdf()}}},[_vm._v(_vm._s(_vm.$t('general.download_pdf'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])]),_vm._v(" "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(" "+_vm._s(_vm.$t('reports.interval'))+": "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":00")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card center-sales-report-stats",staticStyle:{"height":"100% !important"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content"},[_c('div',{staticClass:"report-container"},[_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.orderItemValueCollected')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.totalSum || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.shipping')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_order_shipping || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.tips')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_order_tips || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.totalTax')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_order_extras || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.orderItemDiscount')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_product_discount || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.orderDiscount')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_order_discount || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.orderLoyaltyDiscount')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(_vm.productsTableDataTotals.total_order_loyalty_points_discount || 0)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card center-sales-report-stats",staticStyle:{"height":"100% !important"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.vatLoading),expression:"vatLoading"}],staticClass:"card-content"},[_c('div',{staticClass:"report-container",staticStyle:{"max-height":"385px","overflow-y":"auto"}},[(_vm.vatSectionDisplay.length > 0)?[_c('div',[_c('div',{staticClass:"report-row",staticStyle:{"margin-bottom":"8px","font-weight":"bold","border-bottom":"1px solid #ddd","padding-bottom":"5px"}},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('invoice.vatPercent'))+" %")]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.$t('reports.fullPrice')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.$t('reports.orderItemNetPrice')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.$t('reports.vatAmount')))])]),_vm._v(" "),_vm._l((_vm.vatSectionDisplay),function(section){return _c('div',{key:section.sectionId,staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"report-row",staticStyle:{"margin-bottom":"8px"}},[_c('div',{staticClass:"report-col left-align",staticStyle:{"font-weight":"bold","font-size":"16px"}},[_vm._v("\n                          "+_vm._s(section.sectionName)+"\n                        ")])]),_vm._v(" "),_vm._l((section.records),function(vatRecord,index){return _c('div',{key:index,staticClass:"report-row",staticStyle:{"margin-bottom":"5px","padding-left":"20px"}},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(vatRecord.vat)+"%")]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(vatRecord.total_gross_price_fmt))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(vatRecord.total_net_price_fmt))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(vatRecord.total_vat_value_fmt))])])})],2)})],2)]:(!_vm.vatLoading)?[_vm._m(0)]:_vm._e()],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns master-report-table",staticStyle:{"width":"100%"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"reportsTable",staticClass:"master-report-table",attrs:{"data":_vm.productsTableData,"total":_vm.totalOrders,"pagination-props":_vm.paginationProps,"table-props":_vm.masterReportTableProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"order_id","label":_vm.$t('reports.orderId'),"min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_pos_id_fmt","label":_vm.$t('reports.posId'),"min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_item_pos_id_fmt","label":_vm.$t('reports.itemPosId'),"min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_menu_item_pos_id_fmt","label":_vm.$t('reports.menuItemPosId'),"min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_order_opening_time_fmt","label":_vm.$t('reports.orderCreatedAt'),"min-width":"160"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"order_number","label":_vm.$t('reports.orderNumber'),"min-width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_table_number_fmt","label":_vm.$t('reports.tableNumber'),"min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_product_opening_time_fmt","label":_vm.$t('reports.orderItemCreatedAt'),"min-width":"160"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"location_name","label":_vm.$t('reports.location'),"min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_product_marking_time_fmt","label":_vm.$t('reports.orderItemMarkingTime'),"min-width":"160"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_row_type_fmt","label":_vm.$t('reports.type'),"min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_top_category_fmt","label":_vm.$t('reports.topCategory'),"min-width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"category","label":_vm.$t('reports.category'),"min-width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_product_name_fmt","label":_vm.$t('reports.product'),"min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_is_storno_fmt","label":_vm.$t('reports.operation'),"min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_operator_name_fmt","label":_vm.$t('reports.operator'),"min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_section_name_fmt","label":_vm.$t('reports.section'),"min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_gross_price_fmt","min-width":"140","render-header":_vm.renderGrossPriceHeader}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_product_quantity_fmt","min-width":"120","render-header":_vm.renderQuantityHeader}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_product_quantity_quantitative_fmt","label":_vm.$t('reports.quantityUnit'),"min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_product_discount_fmt","min-width":"150","render-header":_vm.renderProductDiscountHeader}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_order_discount_fmt","min-width":"150","render-header":_vm.renderOrderDiscountHeader}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_order_loyalty_points_discount_fmt","min-width":"180","render-header":_vm.renderOrderLoyaltyDiscountHeader}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_order_extras_fmt","min-width":"180","render-header":_vm.renderOrderExtrasHeader}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_order_shipping_fmt","min-width":"100","render-header":_vm.renderOrderShippingHeader}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_order_tips_fmt","min-width":"100","render-header":_vm.renderOrderTipsHeader}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_collected_fmt","min-width":"140","render-header":_vm.renderCollectedHeader}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_vat_rate_fmt","label":_vm.$t('invoice.vatPercent'),"min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_vat_value_fmt","min-width":"120","render-header":_vm.renderVatValueHeader}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_price_excluding_vat_fmt","min-width":"120","render-header":_vm.renderPriceExcludingVatHeader}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_payment_method_fmt","label":_vm.$t('reports.paymentMethod'),"min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_is_fiscalized_fmt","label":_vm.$t('reports.fiscalization'),"min-width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_room_number_fmt","label":_vm.$t('reports.roomNumber'),"min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"_event_folio_id_fmt","label":_vm.$t('reports.folioId'),"min-width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"order_comments","label":_vm.$t('reports.orderComments'),"min-width":"160"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"product_comments","label":_vm.$t('reports.productComments'),"min-width":"160"}})],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"20px","text-align":"center","color":"#909399","padding":"40px 0"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Nu există date")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YEwK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YGYh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TopCategoryForm_vue__ = __webpack_require__("mtAm");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'TopCategoryForm', __WEBPACK_IMPORTED_MODULE_7__TopCategoryForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      categoryModel: {},
      category: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onCategorySubmit: function onCategorySubmit(model, isValid) {
      this.categoryModel = model;
    }
  }
});

/***/ }),

/***/ "YGbk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YJQT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YMMF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YOHX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YQHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEditModal_vue__ = __webpack_require__("/oG9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4796a992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEditModal_vue__ = __webpack_require__("VITf");
function injectStyle (ssrContext) {
  __webpack_require__("+woV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEditModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4796a992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEditModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YShu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"taxes-v2"},[(!_vm.showVatEditor && !_vm.showRuleEditor)?[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.activeTab === 'vat' },on:{"click":function($event){_vm.openTaxTab('vat')}}},[_vm._v("TVA")]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.activeTab === 'rules' },on:{"click":function($event){_vm.openTaxTab('rules')}}},[_vm._v("ALTE TAXE")])])])])]),_vm._v(" "),_c('div',{staticClass:"card tax-card tax-engine-card"},[_c('div',{staticClass:"card-content tax-engine-content"},[_vm._m(0),_vm._v(" "),_c('label',{staticClass:"tax-switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.taxesVersion === 2},on:{"change":function($event){_vm.setTaxesVersion($event.target.checked ? 2 : 1)}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.taxesVersion === 2 ? 'Activ' : 'Inactiv'))])])])])]:_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"tax-page","mode":"out-in"}},[(_vm.activeTab === 'vat')?_c('div',{key:_vm.showVatEditor ? 'vat-editor' : 'vat-list'},[(!_vm.showVatEditor)?_c('div',{staticClass:"card tax-card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"tax-list-header"},[_c('div',[_c('h3',{staticClass:"tax-card-title"},[_vm._v("Cote TVA")]),_vm._v(" "),_c('p',{staticClass:"help-block tax-help"},[_vm._v("Cotele inactive nu mai apar la selectare, dar rămân valabile acolo unde sunt deja folosite.")])]),_vm._v(" "),_c('button',{staticClass:"btn add",attrs:{"title":"Adaugă TVA"},on:{"click":function($event){$event.preventDefault();return _vm.openCreateVat($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("Adaugă TVA")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Cotă")]),_c('th',[_vm._v("Stare")]),_c('th',[_vm._v("Utilizare")]),_c('th',{staticClass:"text-right"},[_vm._v("Acțiuni")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.vatRates),function(vat){return _c('tr',{key:vat.id},[_c('td',{staticClass:"tax-rate-value"},[_vm._v(_vm._s(_vm.formatRate(vat.rate))+"%")]),_vm._v(" "),_c('td',[_c('label',{staticClass:"tax-switch tax-switch-small"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":vat.is_active},on:{"change":function($event){_vm.toggleVat(vat, $event.target.checked)}}}),_c('span',{staticClass:"tax-switch-track"},[_c('span',{staticClass:"tax-switch-thumb"})]),_c('span',[_vm._v(_vm._s(vat.is_active ? 'Activ' : 'Inactiv'))])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(vat.is_used ? _vm.usageLabel(vat.usage) : 'Nefolosit'))]),_vm._v(" "),_c('td',{staticClass:"text-right tax-actions-cell"},[_c('a',{staticClass:"btn delete mar-rt-10",class:{ disabled: vat.is_used },attrs:{"title":vat.is_used ? 'TVA-ul folosit nu poate fi șters' : 'Șterge'},on:{"click":function($event){$event.preventDefault();_vm.deleteVat(vat)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("Șterge")]),_vm._v(" "),_c('div',{staticClass:"edit tax-edit-action",on:{"click":function($event){_vm.openEditVat(vat)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Editează")])])])}),_vm._v(" "),(!_vm.vatRates.length)?_c('tr',[_c('td',{staticClass:"tax-empty",attrs:{"colspan":"4"}},[_vm._v("Nu există cote TVA configurate.")])]):_vm._e()],2)])])])]):_c('div',{staticClass:"tax-detail-view"},[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":"Înapoi"},on:{"click":function($event){$event.preventDefault();return _vm.closeVatEditor($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" Înapoi")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"button","disabled":_vm.saving},on:{"click":_vm.saveVat}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("Salvează")])])])]),_vm._v(" "),_c('div',{staticClass:"card tax-card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"tax-card-header"},[_c('div',[_c('h3',{staticClass:"tax-card-title"},[_vm._v(_vm._s(_vm.vatForm.id ? 'TVA ' + _vm.formatRate(_vm.vatForm.rate) + '%' : 'Adaugă TVA'))]),_c('p',{staticClass:"help-block tax-help"},[_vm._v(_vm._s(_vm.vatForm.id ? 'Configurează starea și aplicarea acestei cote TVA. Valoarea nu mai poate fi schimbată după salvare.' : 'Salvează cota, apoi o poți aplica pe produse și liste de preț.'))])])]),_vm._v(" "),_c('div',{staticClass:"tax-form-grid tax-vat-details-grid"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cotă TVA")]),_vm._v(" "),_c('div',{staticClass:"tax-rate-input"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.vatForm.rate),expression:"vatForm.rate",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"100","step":"0.01","disabled":!!_vm.vatForm.id,"placeholder":"Cotă TVA"},domProps:{"value":(_vm.vatForm.rate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vatForm, "rate", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_c('span',[_vm._v("%")])])]),_vm._v(" "),_c('div',{staticClass:"form-group tax-active-field"},[_c('label',[_vm._v("Stare")]),_vm._v(" "),_c('label',{staticClass:"tax-switch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vatForm.is_active),expression:"vatForm.is_active"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.vatForm.is_active)?_vm._i(_vm.vatForm.is_active,null)>-1:(_vm.vatForm.is_active)},on:{"change":function($event){var $$a=_vm.vatForm.is_active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.vatForm, "is_active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.vatForm, "is_active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.vatForm, "is_active", $$c)}}}}),_c('span',{staticClass:"tax-switch-track"},[_c('span',{staticClass:"tax-switch-thumb"})]),_c('span',[_vm._v(_vm._s(_vm.vatForm.is_active ? 'Activ' : 'Inactiv'))])])])])])]),_vm._v(" "),(_vm.vatForm.id)?[_c('div',{staticClass:"card tax-card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"tax-card-header"},[_c('div',[_c('h3',{staticClass:"tax-card-title"},[_vm._v("Aplică TVA pe produsele din categorii")]),_c('p',{staticClass:"help-block tax-help"},[_vm._v("Cota "+_vm._s(_vm.formatRate(_vm.vatForm.rate))+"% va fi salvată pe toate produsele din categoriile alese.")])])]),_vm._v(" "),_c('div',{staticClass:"tax-form-grid tax-category-vat-grid"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Categorii")]),_c('el-select',{staticClass:"tax-select",attrs:{"multiple":"","filterable":"","collapse-tags":"","clearable":"","placeholder":"Selectează"},model:{value:(_vm.productVatTool.category_ids),callback:function ($$v) {_vm.$set(_vm.productVatTool, "category_ids", $$v)},expression:"productVatTool.category_ids"}},_vm._l((_vm.categories),function(c){return _c('el-option',{key:c.id,attrs:{"label":c.name,"value":c.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"tax-selected-entity"},[_c('span',[_vm._v("TVA aplicat")]),_c('strong',[_vm._v(_vm._s(_vm.formatRate(_vm.vatForm.rate))+"%")])]),_vm._v(" "),_c('div',{staticClass:"tax-form-action"},[_c('button',{staticClass:"btn tax-primary-action",on:{"click":_vm.applyProductVat}},[_vm._v("Aplică pe produse")])])])])]),_vm._v(" "),_c('div',{staticClass:"card tax-card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"tax-card-header"},[_c('div',[_c('h3',{staticClass:"tax-card-title"},[_vm._v("Aplică TVA în lista de preț")]),_c('p',{staticClass:"help-block tax-help"},[_vm._v("Se actualizează numai TVA-ul și starea poziției. Prețul și POS ID rămân neschimbate.")])])]),_vm._v(" "),_c('div',{staticClass:"tax-form-grid tax-profile-grid"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Listă de preț / locații")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.profileVatTool.price_profile_id),expression:"profileVatTool.price_profile_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.profileVatTool, "price_profile_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează")]),_vm._l((_vm.priceProfiles),function(p){return _c('option',{key:p.id,domProps:{"value":p.id}},[_vm._v(_vm._s(_vm.profileLabel(p)))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group tax-grid-wide"},[_c('label',[_vm._v("Categorii")]),_c('el-select',{staticClass:"tax-select",attrs:{"multiple":"","filterable":"","collapse-tags":"","clearable":"","placeholder":"Selectează"},model:{value:(_vm.profileVatTool.category_ids),callback:function ($$v) {_vm.$set(_vm.profileVatTool, "category_ids", $$v)},expression:"profileVatTool.category_ids"}},_vm._l((_vm.categories),function(c){return _c('el-option',{key:c.id,attrs:{"label":c.name,"value":c.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Surse")]),_c('el-select',{staticClass:"tax-select",attrs:{"multiple":"","filterable":"","collapse-tags":"","clearable":"","placeholder":"Selectează"},model:{value:(_vm.profileVatTool.source_ids),callback:function ($$v) {_vm.$set(_vm.profileVatTool, "source_ids", $$v)},expression:"profileVatTool.source_ids"}},_vm._l((_vm.sources),function(s){return _c('el-option',{key:s.id,attrs:{"label":s.name,"value":s.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Metode")]),_c('el-select',{staticClass:"tax-select",attrs:{"multiple":"","filterable":"","collapse-tags":"","clearable":"","placeholder":"Selectează"},model:{value:(_vm.profileVatTool.method_ids),callback:function ($$v) {_vm.$set(_vm.profileVatTool, "method_ids", $$v)},expression:"profileVatTool.method_ids"}},_vm._l((_vm.methods),function(m){return _c('el-option',{key:m.id,attrs:{"label":m.name,"value":m.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"tax-card-footer"},[_c('span',{staticClass:"tax-field-hint"},[_vm._v("Locațiile sunt cele configurate pe lista de preț.")]),_c('button',{staticClass:"btn tax-primary-action",on:{"click":_vm.applyProfileVat}},[_vm._v("Aplică TVA "+_vm._s(_vm.formatRate(_vm.vatForm.rate))+"%")])])])])]:_vm._e()],2)]):_c('div',{key:_vm.showRuleEditor ? 'rule-editor' : 'rule-list'},[(!_vm.showRuleEditor)?_c('div',{staticClass:"card tax-card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"tax-list-header"},[_c('div',[_c('h3',{staticClass:"tax-card-title"},[_vm._v("Taxe configurate")]),_c('p',{staticClass:"help-block tax-help"},[_vm._v("Taxele pot fi activate, dezactivate sau editate direct din listă.")])]),_vm._v(" "),_c('button',{staticClass:"btn add",attrs:{"title":"Adaugă taxă"},on:{"click":function($event){$event.preventDefault();_vm.openCreateRule()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("Adaugă taxă")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table tax-rules-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Nume")]),_c('th',[_vm._v("Tip")]),_c('th',[_vm._v("Calcul")]),_c('th',[_vm._v("TVA")]),_c('th',[_vm._v("POS ID")]),_c('th',[_vm._v("Locații")]),_c('th',[_vm._v("Stare")]),_c('th',{staticClass:"text-right"},[_vm._v("Acțiuni")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.taxRules),function(rule){return _c('tr',{key:rule.id},[_c('td',[_c('strong',[_vm._v(_vm._s(rule.name))])]),_c('td',[_vm._v(_vm._s(_vm.taxTypeLabel(rule.applies_to)))]),_c('td',[_vm._v(_vm._s(rule.calculation_type === 'fixed' ? rule.value + ' fix' : rule.value + '%'))]),_c('td',[_vm._v(_vm._s(rule.vat_rate ? _vm.formatRate(rule.vat_rate.rate) + '%' : '-'))]),_c('td',[_vm._v(_vm._s(rule.pos_id || '-'))]),_c('td',{attrs:{"title":_vm.scopeSummary(rule)}},[_vm._v(_vm._s(_vm.relationNames(rule.location_ids, _vm.locations, 'Toate')))]),_vm._v(" "),_c('td',[_c('label',{staticClass:"tax-switch tax-switch-small"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":rule.is_active},on:{"change":function($event){_vm.toggleRule(rule, $event.target.checked)}}}),_c('span',{staticClass:"tax-switch-track"},[_c('span',{staticClass:"tax-switch-thumb"})]),_c('span',[_vm._v(_vm._s(rule.is_active ? 'Activ' : 'Inactiv'))])])]),_vm._v(" "),_c('td',{staticClass:"text-right tax-actions-cell"},[_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":"Șterge"},on:{"click":function($event){$event.preventDefault();_vm.deleteRule(rule)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("Șterge")]),_c('div',{staticClass:"edit tax-edit-action",on:{"click":function($event){_vm.openEditRule(rule)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v("Editează")])])])}),_vm._v(" "),(!_vm.taxRules.length)?_c('tr',[_c('td',{staticClass:"tax-empty",attrs:{"colspan":"8"}},[_vm._v("Nu există alte taxe configurate.")])]):_vm._e()],2)])])])]):_c('div',{staticClass:"tax-detail-view"},[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":"Înapoi"},on:{"click":function($event){$event.preventDefault();return _vm.closeRuleEditor($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" Înapoi")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"button","disabled":_vm.saving || _vm.loadingRule || _vm.applyingCategoryTaxes},on:{"click":_vm.saveRule}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("Salvează taxa")])])])]),_vm._v(" "),(_vm.loadingRule)?_c('div',{staticClass:"card tax-card"},[_c('div',{staticClass:"card-content tax-page-loading"},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])])]):[_c('div',{staticClass:"card tax-card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"tax-card-header"},[_c('div',[_c('h3',{staticClass:"tax-card-title"},[_vm._v(_vm._s(_vm.ruleForm.id ? _vm.ruleForm.name : 'Adaugă taxă'))]),_c('p',{staticClass:"help-block tax-help"},[_vm._v("Definește tipul, calculul și TVA-ul liniei separate care va apărea pe bon.")])])]),_vm._v(" "),_c('div',{staticClass:"tax-form-grid tax-rule-main-grid"},[_c('div',{staticClass:"form-group tax-grid-wide"},[_c('label',[_vm._v("Nume")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ruleForm.name),expression:"ruleForm.name"}],staticClass:"form-control",domProps:{"value":(_vm.ruleForm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ruleForm, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Taxă pentru")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ruleForm.applies_to),expression:"ruleForm.applies_to"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.ruleForm, "applies_to", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.handleRuleTypeChange]}},[_c('option',{attrs:{"value":"order"}},[_vm._v("Comandă")]),_c('option',{attrs:{"value":"item"}},[_vm._v("Produs/opțiune")]),_c('option',{attrs:{"value":"delivery"}},[_vm._v("Livrare")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Calcul")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ruleForm.calculation_type),expression:"ruleForm.calculation_type"}],staticClass:"form-control",attrs:{"disabled":_vm.ruleForm.applies_to === 'delivery'},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.ruleForm, "calculation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"fixed"}},[_vm._v("Fixă")]),_c('option',{attrs:{"value":"percentage"}},[_vm._v("Procent")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.ruleForm.applies_to === 'delivery' ? 'Cost livrare (lei)' : 'Valoare'))]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.ruleForm.value),expression:"ruleForm.value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.000001"},domProps:{"value":(_vm.ruleForm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ruleForm, "value", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("TVA obligatoriu")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ruleForm.vat_rate_id),expression:"ruleForm.vat_rate_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.ruleForm, "vat_rate_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează")]),_vm._l((_vm.selectableVatRates(_vm.ruleForm.vat_rate_id)),function(v){return _c('option',{key:v.id,attrs:{"disabled":!v.is_active},domProps:{"value":v.id}},[_vm._v(_vm._s(_vm.formatRate(v.rate))+"%"+_vm._s(v.is_active ? '' : ' (inactiv)'))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("POS ID")]),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.ruleForm.pos_id),expression:"ruleForm.pos_id",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Opțional"},domProps:{"value":(_vm.ruleForm.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ruleForm, "pos_id", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group tax-active-field"},[_c('label',[_vm._v("Stare")]),_vm._v(" "),_c('label',{staticClass:"tax-switch tax-status-switch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ruleForm.is_active),expression:"ruleForm.is_active"}],attrs:{"type":"checkbox","aria-label":"Taxă activă"},domProps:{"checked":Array.isArray(_vm.ruleForm.is_active)?_vm._i(_vm.ruleForm.is_active,null)>-1:(_vm.ruleForm.is_active)},on:{"change":function($event){var $$a=_vm.ruleForm.is_active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.ruleForm, "is_active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.ruleForm, "is_active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.ruleForm, "is_active", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"tax-switch-track"},[_c('span',{staticClass:"tax-switch-thumb"})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.ruleForm.is_active ? 'Activă' : 'Inactivă'))])])])])])]),_vm._v(" "),_c('div',{staticClass:"card tax-card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"tax-card-header"},[_c('div',[_c('h3',{staticClass:"tax-card-title"},[_vm._v("Aplicabilitate")]),_c('p',{staticClass:"help-block tax-help"},[_vm._v("Lasă un câmp gol dacă taxa se aplică tuturor valorilor din criteriul respectiv.")])])]),_vm._v(" "),_c('div',{staticClass:"tax-form-grid tax-scope-grid"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Locații")]),_c('el-select',{staticClass:"tax-select",attrs:{"multiple":"","filterable":"","collapse-tags":"","clearable":"","placeholder":"Toate locațiile"},model:{value:(_vm.ruleForm.location_ids),callback:function ($$v) {_vm.$set(_vm.ruleForm, "location_ids", $$v)},expression:"ruleForm.location_ids"}},_vm._l((_vm.locations),function(l){return _c('el-option',{key:l.id,attrs:{"label":l.name,"value":l.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Surse")]),_c('el-select',{staticClass:"tax-select",attrs:{"multiple":"","filterable":"","collapse-tags":"","clearable":"","placeholder":"Toate sursele"},model:{value:(_vm.ruleForm.source_ids),callback:function ($$v) {_vm.$set(_vm.ruleForm, "source_ids", $$v)},expression:"ruleForm.source_ids"}},_vm._l((_vm.sources),function(s){return _c('el-option',{key:s.id,attrs:{"label":s.name,"value":s.id}})}))],1),_vm._v(" "),(_vm.ruleForm.applies_to !== 'delivery')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Metode")]),_c('el-select',{staticClass:"tax-select",attrs:{"multiple":"","filterable":"","collapse-tags":"","clearable":"","placeholder":"Toate metodele"},model:{value:(_vm.ruleForm.method_ids),callback:function ($$v) {_vm.$set(_vm.ruleForm, "method_ids", $$v)},expression:"ruleForm.method_ids"}},_vm._l((_vm.methods),function(m){return _c('el-option',{key:m.id,attrs:{"label":m.name,"value":m.id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Zone")]),_c('el-select',{staticClass:"tax-select",attrs:{"multiple":"","filterable":"","collapse-tags":"","clearable":"","placeholder":"Toate zonele"},model:{value:(_vm.ruleForm.delivery_range_ids),callback:function ($$v) {_vm.$set(_vm.ruleForm, "delivery_range_ids", $$v)},expression:"ruleForm.delivery_range_ids"}},_vm._l((_vm.deliveryRanges),function(range){return _c('el-option',{key:range.id,attrs:{"label":_vm.deliveryRangeLabel(range),"value":range.id}})}))],1)])])]),_vm._v(" "),(_vm.ruleForm.applies_to === 'delivery')?_c('div',{staticClass:"card tax-card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"tax-card-header"},[_c('div',[_c('h3',{staticClass:"tax-card-title"},[_vm._v("Extra Cost Range")]),_c('p',{staticClass:"help-block tax-help"},[_vm._v("Intervalele suprascriu costul standard și POS ID-ul acestei taxe în funcție de distanță și valoarea comenzii.")])]),_vm._v(" "),_c('button',{staticClass:"btn add",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addDeliveryCostRange($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("Adaugă interval")])]),_vm._v(" "),_c('div',{staticClass:"tax-delivery-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_c('strong',[_vm._v("Aceste intervale se aplică doar dacă locația are cheia Google Maps configurată.")]),_vm._v(" Dacă cheia lipsește sau distanța nu poate fi calculată, se aplică prețul standard al taxei.")]),_vm._v(" "),(!_vm.ruleForm.delivery_cost_ranges.length)?_c('div',{staticClass:"tax-empty tax-range-empty"},[_vm._v("Nu există intervale suplimentare. Se va folosi costul standard.")]):_vm._e(),_vm._v(" "),_vm._l((_vm.ruleForm.delivery_cost_ranges),function(range,index){return _c('div',{key:range.id || 'new-' + index,staticClass:"tax-delivery-range"},[_c('div',{staticClass:"tax-range-heading"},[_c('strong',[_vm._v("Interval "+_vm._s(index + 1))]),_c('button',{staticClass:"btn delete",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.removeDeliveryCostRange(index)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("Șterge")])]),_vm._v(" "),_c('div',{staticClass:"tax-form-grid tax-delivery-range-grid"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Distanță până la (km)")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(range.distance_in_km),expression:"range.distance_in_km",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(range.distance_in_km)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(range, "distance_in_km", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cost (lei)")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(range.shipping_cost),expression:"range.shipping_cost",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(range.shipping_cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(range, "shipping_cost", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("POS ID")]),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(range.pos_id),expression:"range.pos_id",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Moștenește POS ID standard"},domProps:{"value":(range.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(range, "pos_id", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Comandă minimă (lei)")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(range.min_order_value),expression:"range.min_order_value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(range.min_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(range, "min_order_value", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Timp extra (minute)")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(range.extra_delivery_time),expression:"range.extra_delivery_time",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"1"},domProps:{"value":(range.extra_delivery_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(range, "extra_delivery_time", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])])])})],2)]):_vm._e(),_vm._v(" "),(_vm.ruleForm.applies_to === 'item')?_c('div',{staticClass:"card tax-card tax-assignment-tool"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"tax-card-header"},[_c('div',[_c('span',{staticClass:"tax-tool-badge"},[_c('i',{staticClass:"fa fa-calculator",attrs:{"aria-hidden":"true"}}),_vm._v(" Instrument de aplicare")]),_vm._v(" "),_c('h3',{staticClass:"tax-card-title"},[_vm._v("Aplică taxa pe categorii")]),_vm._v(" "),_c('p',{staticClass:"help-block tax-help"},[_vm._v("Adaugă taxa „"+_vm._s(_vm.ruleForm.name)+"” pe produsele existente în categoriile alese.")])])]),_vm._v(" "),_c('div',{staticClass:"tax-tool-explanation"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v("Confirmă selecția cu "),_c('strong',[_vm._v("„Aplică taxa”")]),_vm._v(". Butonul „Salvează taxa” de sus salvează doar configurarea taxei.")])]),_vm._v(" "),(!_vm.ruleForm.id)?_c('p',{staticClass:"tax-tool-pending"},[_vm._v("Salvează mai întâi taxa, apoi folosește acest instrument pentru a o atribui produselor.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tax-form-grid tax-rule-category-grid"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("1. Alege categoriile")]),_vm._v(" "),_c('el-select',{staticClass:"tax-select",attrs:{"disabled":!_vm.ruleForm.id || _vm.saving || _vm.applyingCategoryTaxes,"multiple":"","filterable":"","collapse-tags":"","clearable":"","placeholder":"Selectează categoriile"},on:{"change":function($event){_vm.categoryTaxResult = ''}},model:{value:(_vm.taxCategoryTool.category_ids),callback:function ($$v) {_vm.$set(_vm.taxCategoryTool, "category_ids", $$v)},expression:"taxCategoryTool.category_ids"}},_vm._l((_vm.categories),function(c){return _c('el-option',{key:c.id,attrs:{"label":c.name,"value":c.id}})})),_vm._v(" "),_c('span',{staticClass:"tax-field-hint"},[_vm._v("Taxele deja atribuite produselor se păstrează.")])],1),_vm._v(" "),_c('div',{staticClass:"form-group tax-option-choice"},[_c('label',[_vm._v("2. Include opțiuni, dacă este cazul")]),_vm._v(" "),_c('label',{staticClass:"tax-checkbox tax-options-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taxCategoryTool.include_option_values),expression:"taxCategoryTool.include_option_values"}],attrs:{"disabled":!_vm.ruleForm.id || _vm.saving || _vm.applyingCategoryTaxes,"type":"checkbox","aria-describedby":"tax-options-help"},domProps:{"checked":Array.isArray(_vm.taxCategoryTool.include_option_values)?_vm._i(_vm.taxCategoryTool.include_option_values,null)>-1:(_vm.taxCategoryTool.include_option_values)},on:{"change":[function($event){var $$a=_vm.taxCategoryTool.include_option_values,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.taxCategoryTool, "include_option_values", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.taxCategoryTool, "include_option_values", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.taxCategoryTool, "include_option_values", $$c)}},function($event){_vm.categoryTaxResult = ''}]}}),_vm._v(" "),_c('span',[_vm._v("Aplică taxa și pe opțiuni")])]),_vm._v(" "),_c('p',{staticClass:"tax-option-help",attrs:{"id":"tax-options-help"}},[_vm._v("De exemplu, „Extra brânză”. Aceeași valoare de opțiune primește taxa la toate produsele care o folosesc, conform aplicabilității taxei.")]),_vm._v(" "),(_vm.taxCategoryTool.include_option_values)?_c('p',{staticClass:"tax-option-note"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" Taxa se calculează separat pentru produs și pentru fiecare opțiune taxată aleasă.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tax-card-footer tax-tool-footer"},[_c('div',{attrs:{"aria-live":"polite"}},[(_vm.taxCategoryTool.category_ids.length)?_c('p',{staticClass:"tax-tool-pending"},[_c('strong',[_vm._v(_vm._s(_vm.taxCategoryTool.category_ids.length)+" categorii selectate — încă neaplicate.")]),_c('br'),_vm._v("Apasă „Aplică taxa” pentru a salva atribuirile.")]):_c('p',{staticClass:"tax-help"},[_vm._v("Atribuirile se salvează imediat prin „Aplică taxa”.")]),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('p',{staticClass:"tax-help"},[_vm._v("Atribuirile se păstrează pentru migrare. Taxa se va aplica în comenzi după activarea Taxe V2.")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn tax-primary-action tax-apply-action",attrs:{"type":"button","disabled":!_vm.ruleForm.id || !_vm.taxCategoryTool.category_ids.length || _vm.saving || _vm.applyingCategoryTaxes},on:{"click":_vm.applyCategoryTaxes}},[_c('i',{class:_vm.applyingCategoryTaxes ? 'fa fa-spinner fa-spin' : 'fa fa-check',attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.applyingCategoryTaxes ? 'Se aplică…' : 'Aplică taxa'))])]),_vm._v(" "),(_vm.categoryTaxResult)?_c('p',{staticClass:"tax-tool-result",attrs:{"role":"status"}},[_c('i',{staticClass:"fa fa-check-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.categoryTaxResult))]):_vm._e()])]):_vm._e()]],2)])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"tax-card-title"},[_vm._v("Motor taxe V2")]),_vm._v(" "),_c('p',{staticClass:"help-block tax-help"},[_vm._v("Versiunea se salvează pe fiecare comandă. Comenzile vechi continuă cu motorul vechi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tax-switch-track"},[_c('span',{staticClass:"tax-switch-thumb"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YU8E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trends_vue__ = __webpack_require__("VAbv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b5ac35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Trends_vue__ = __webpack_require__("lya+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trends_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44b5ac35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Trends_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YWVT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");

















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_dropdown_item___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PSwitch: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__["a" /* default */] },
  props: {
    isLoyaltyStoreCampaigns: { type: Boolean, default: false }
  },
  watch: {
    isLoyaltyStoreCampaigns: function isLoyaltyStoreCampaigns(v) {
      if (v) this.initPage();
    },
    tableData: function tableData() {
      var _this = this;

      this.$nextTick(function () {
        return _this.layoutTable();
      });
    }
  },
  data: function data() {
    return {
      loading: false,
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      filters: [{ value: '', prop: ['name', 'id'] }],
      tableData: []
    };
  },
  created: function created() {
    this.$bus.$on('refresh', this.handleRefresh);
  },
  mounted: function mounted() {
    var _this2 = this;

    this.initPage();
    this._onResizeTable = function () {
      return _this2.layoutTable();
    };
    window.addEventListener('resize', this._onResizeTable);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
    if (this._onResizeTable) {
      window.removeEventListener('resize', this._onResizeTable);
    }
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.initPage();
    },
    layoutTable: function layoutTable() {
      var dt = this.$refs.loyaltyStoreDataTables;
      var elTable = dt && dt.$refs && dt.$refs.elTable;
      if (elTable && typeof elTable.doLayout === 'function') {
        elTable.doLayout();
      }
    },
    goToRecord: function goToRecord(row, column, event) {
      if (column && column.property === 'actions') return;
      this.editRecord(row);
    },
    editRecord: function editRecord(row) {
      if (!row || !row.id) return;
      this.$router.push('/marketing/loyalty-store-campaigns/edit/' + row.id);
    },
    formatAvailabilityRange: function formatAvailabilityRange(row) {
      var dash = this.$t('general.emDash') || '—';
      var from = row.starts_at || null;
      var to = row.ends_at || null;
      if (!from && !to) return dash;
      var a = from ? this.formatDate(from) : dash;
      var b = to ? this.formatDate(to) : dash;
      return a + ' - ' + b;
    },
    normalizeList: function normalizeList(response) {
      if (!response || !response.data) return [];
      var d = response.data;
      if (Array.isArray(d)) return d;
      if (Array.isArray(d.data)) return d.data;
      return [];
    },
    initPage: function initPage() {
      var _this3 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/loyalty-store-campaigns', 'GET', data, function (response) {
        if (response.status) {
          _this3.tableData = _this3.normalizeList(response);
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error');
        }
        _this3.loading = false;
        _this3.$nextTick(function () {
          return _this3.layoutTable();
        });
      });
    },
    handleActive: function handleActive(row, val) {
      var _this4 = this;

      var previous = !!row.active;
      row.active = val;
      var body = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        active: val ? 1 : 0
      };
      this.apiRequest('/loyalty-store-campaigns/' + row.id, 'PUT', body, function (response) {
        if (!response.status) {
          row.active = previous;
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error');
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        title: this.$t('loyaltyStore.deleteConfirmation'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then(function (result) {
        if (result !== true && !(result && result.value === true)) return;
        var data = {
          token: _this5.$session.get('token'),
          company_id: _this5.$session.get('selectedCompany')
        };
        _this5.apiRequest('/loyalty-store-campaigns/' + row.id, 'DELETE', data, function (response) {
          if (response.status) {
            _this5.initPage();
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', _this5.$t('general.success'), 'success').catch(function () {});
          } else {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', _this5.$t('validations.wentWrong'), 'error');
          }
        });
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "YZnw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YczL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      tableDataBonProduct: [],
      allLocations: [],
      vatNumber: null,
      selectedLocation: null
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getBons(this.selectedLocation, this.currentPage, this.pageSize);
    },
    onSearch: function onSearch() {
      if (!this.selectedLocation || Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        });

        this.tableDataBonProduct = [];
        this.totalItems = 0;

        return;
      }

      var locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation];

      this.getBons(locations);
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getBons(this.selectedLocation, this.currentPage, this.pageSize);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveProduct();
        }
      });
    },
    getGestiuneNameById: function getGestiuneNameById(id) {
      var gest = this.gestiuneOptions.find(function (g) {
        return g._id === id || g.id === id;
      });
      return gest ? gest.name : id;
    },
    addBonProduct: function addBonProduct() {
      this.$router.push('/management/bon-product/add');
    },
    editBonProduct: function editBonProduct(row) {
      this.$router.push('/management/bon-product/edit/' + row.series + '/' + row.documentNumber);
    },
    getBons: function getBons() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this2 = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, ids, allLocations, _ids, response, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.loading = true;

                params = new URLSearchParams({
                  externalCompanyId: _this2.companyID,
                  tip: 'bon_productie'
                });


                params.append('page', page);
                params.append('limit', pageSize);

                if (location) {
                  if (Array.isArray(location)) {
                    ids = location.map(function (l) {
                      return l.true_id;
                    }).filter(Boolean);

                    ids.forEach(function (id) {
                      return params.append('externalLocationId', id);
                    });
                  } else if (location.id && location.true_id) {
                    params.append('externalLocationId', location.true_id);
                  }
                } else {
                  allLocations = _this2.groupedLocations.flatMap(function (group) {
                    return group.locations;
                  });
                  _ids = allLocations.map(function (l) {
                    return l.true_id;
                  }).filter(Boolean);

                  _ids.forEach(function (id) {
                    return params.append('externalLocationId', id);
                  });
                }

                clearTimeout(_this2.loadingTimeout);
                _this2.loadingTimeout = setTimeout(function () {
                  _this2.loading = true;
                }, 100);

                _context.next = 10;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/bons?' + params.toString(), {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 10:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 13;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 13:
                _context.next = 15;
                return response.json();

              case 15:
                data = _context.sent;


                if (Array.isArray(data.bons)) {
                  clearTimeout(_this2.loadingTimeout);
                  _this2.loading = false;

                  _this2.totalItems = data.total || 0;
                  _this2.currentPage = data.currentPage || page;
                  _this2.pageSize = data.pageSize || pageSize;

                  _this2.tableDataBonProduct = data.bons.map(function (bon) {
                    var extras = Array.isArray(bon.extraFields) ? Object.fromEntries(bon.extraFields.map(function (f) {
                      return [f.key, f.value];
                    })) : {};

                    return {
                      _id: bon._id,
                      documentNumber: bon.documentNumber,
                      gestiune_from: bon.gestiune_from,
                      gestiune_to: bon.gestiune_to,
                      series: bon.series,
                      lot: bon.lot || extras.lot || 'N/A',
                      dataProductie: extras.dataProductie || '',
                      dataExpirare: extras.dataExpirare || '',
                      total: bon.total || 'N/A',
                      items: Array.isArray(bon.items) ? bon.items : []
                    };
                  });
                } else {
                  console.error('Nu s-au găsit bonuri valide.');
                  _this2.tableDataBonProduct = [];
                }
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](0);

                clearTimeout(_this2.loadingTimeout);
                _this2.loading = false;

                console.error('Error fetching bons:', _context.t0);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 19]]);
      }))();
    },
    handleDeleteBonProductie: function handleDeleteBonProductie(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (id) {
                  _context2.next = 3;
                  break;
                }

                console.error('Missing Production Note ID for deletion.');
                return _context2.abrupt('return');

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    type: 'bon_productie',
                    id: id,
                    externalCompanyId: _this3.companyID
                  })
                });

              case 6:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 9;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 9:
                _context2.next = 11;
                return response.json();

              case 11:
                data = _context2.sent;

                console.log('Production Note deleted successfully:', data);

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Bonul de producție a fost șters cu succes!',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this3.getBons();
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](3);

                console.error('Error deleting Production Note:', _context2.t0);

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o eroare la ștergerea bonului de producție.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[3, 17]]);
      }))();
    },
    downloadExcel: function downloadExcel(row) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var type, series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = 'bon_productie';
                series = row.series;
                invoiceNumber = row.documentNumber;
                externalCompanyId = _this4.companyID;

                if (!(!type || !series || !invoiceNumber || !externalCompanyId)) {
                  _context3.next = 7;
                  break;
                }

                alert('Missing type, series, invoice number or company ID.');
                return _context3.abrupt('return');

              case 7:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/' + type + '/' + series + '-' + invoiceNumber + '/xls?externalCompanyId=' + externalCompanyId;
                _context3.prev = 8;
                _context3.next = 11;
                return fetch(url);

              case 11:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 15;
                return response.blob();

              case 15:
                blob = _context3.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = type + '-' + series + '-' + invoiceNumber + '.xls';
                link.click();
                URL.revokeObjectURL(link.href);
                _context3.next = 24;
                break;

              case 23:
                console.error('Error downloading document:', response.statusText);

              case 24:
                _context3.next = 29;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t0 = _context3['catch'](8);

                console.error('Error fetching document:', _context3.t0);

              case 29:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[8, 26]]);
      }))();
    },
    download: function download(row) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var type, series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                type = 'bon_productie';
                series = row.series;
                invoiceNumber = row.documentNumber;
                externalCompanyId = _this5.companyID;

                if (!(!type || !series || !invoiceNumber || !externalCompanyId)) {
                  _context4.next = 7;
                  break;
                }

                alert('Missing type, series, invoice number or company ID.');
                return _context4.abrupt('return');

              case 7:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/' + type + '/' + series + '-' + invoiceNumber + '/pdf?externalCompanyId=' + externalCompanyId;
                _context4.prev = 8;
                _context4.next = 11;
                return fetch(url);

              case 11:
                response = _context4.sent;

                if (!response.ok) {
                  _context4.next = 23;
                  break;
                }

                _context4.next = 15;
                return response.blob();

              case 15:
                blob = _context4.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = type + '-' + series + '-' + invoiceNumber + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                _context4.next = 24;
                break;

              case 23:
                console.error('Error downloading document:', response.statusText);

              case 24:
                _context4.next = 29;
                break;

              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4['catch'](8);

                console.error('Error fetching document:', _context4.t0);

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[8, 26]]);
      }))();
    }
  }
});

/***/ }),

/***/ "YeLk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Inputs_FileInput_vue__ = __webpack_require__("lcot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_DisplayQr_vue__ = __webpack_require__("+65S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2_dist_sweetalert2_css__);






var _components;










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'FileInput', __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Inputs_FileInput_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'DisplayQr', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_DisplayQr_vue__["a" /* default */]), _components),
  props: {
    countries: {},
    modeldata: {},
    taxesData: {},
    tabRefresh: {},
    isCompanyDetails: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    countries: function countries(value) {
      this.countriesList = value;
    },
    modeldata: function modeldata(value) {
      var _this = this;

      this.showDelete = value.locations_details.length > 1;
      this.model = value;
      if (this.model.languages) {
        this.model.selected_languages = this.model.languages.map(function (lang) {
          return {
            value: lang.id,
            label: lang.name
          };
        });
      }
      if (this.model.initial_order_status_app_web) {
        this.model.initial_order_status_app_web = this.orderStatusOptions.find(function (t) {
          return t.value === _this.model.initial_order_status_app_web;
        }) || null;
      }
      this.syncImageFileLists();
    },
    taxesData: function taxesData(value) {
      this.taxes = value;
    },
    tabRefresh: function tabRefresh(value) {
      if (value === 'Company Details') {
        this.showUpdateWarning = false;
        var data = {
          token: this.$session.get('token')
        };
        var self = this;
        var companyID = this.$session.get('selectedCompany');

        this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response) {
          if (response.status === true) {
            self.$emit('updateModelData', response.data[0]);
          }
        });
      }
    }
  },
  data: function data() {
    return {
      model: this.value || this.modeldata,
      sortMethodsList: [],
      taxes: this.value || this.taxesData,
      modelValidate: {
        name: { required: true },
        email: { required: true },
        phone: { required: true },
        number: { required: true },
        street: { required: true },
        city: { required: true },
        state: { required: true },
        country: { required: true },
        working_hours: { required: true },
        email_feedback: { required: true }
      },
      showUpdateWarning: false,
      languages: this.$session.get('defaultData')['available_languages'],
      dbLanguages: null,
      dbLanguagesOptions: null,
      windowHeight: 0,
      navbarHeaderHeight: 0,
      pageTopHeight: 76,
      loading: true,
      paymentGroups: null,
      deliveryMethods: [],
      imagelist: [],
      imagelistLogo: [],
      imagelistAppImage: [],
      menuType: [{ 'id': 0, 'label': 'PDF' }, { 'id': 1, 'label': 'Dynamic' }],
      vatOptions: [],
      taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
      selfOrderStatusOptions: [{ label: 'NEW', value: null }, { label: 'PROCESSING', value: 'PROCESSING' }],
      orderStatusOptions: [{ label: this.$t('ordersStatus.PROCESSING'), value: 'PROCESSING' }]
    };
  },

  updated: function updated() {},
  created: function created() {
    this.getData();
    this.syncImageFileLists();
  },

  computed: {
    initalOrderStatusKiosk: {
      get: function get() {
        var _this2 = this;

        return this.selfOrderStatusOptions.find(function (t) {
          return t.value === _this2.model.initial_order_status_self_order;
        }) || this.selfOrderStatusOptions[0];
      },
      set: function set(value) {
        this.$set(this.model, 'initial_order_status_self_order', value ? value.value : null);
      }
    },
    initalOrderStatusAppWeb: {
      get: function get() {
        var _this3 = this;

        return this.orderStatusOptions.find(function (t) {
          return t.value === _this3.model.initial_order_status_app_web;
        }) || null;
      },
      set: function set(value) {
        this.model.initial_order_status_app_web = value ? value.initial_order_status_app_web : null;
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.getDbLanguages();
    this.getVatOptions();
    this.$nextTick(function () {
      _this4.doHeightCalculation();
      _this4.loading = false;

      window.addEventListener('resize', function () {
        _this4.doHeightCalculation();
      });
    });
  },

  methods: {
    syncImageFileLists: function syncImageFileLists() {
      this.imagelistLogo = this.model.logo ? [{ 'url': this.model.logo }] : [];
      this.imagelistAppImage = this.model.app_image ? [{ 'url': this.model.app_image }] : [];
      this.imagelist = this.model.unavailable_image ? [{ 'url': this.model.unavailable_image }] : [];
    },
    getDbLanguages: function getDbLanguages() {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/get-db-languages', 'GET', data, function (response) {
        if (response.status === true) {
          _this5.dbLanguages = response.data.languages;
          _this5.dbLanguagesOptions = _this5.dbLanguages.map(function (lang) {
            return {
              label: lang.name,
              value: lang.id
            };
          });
        }
      });
    },
    getVatOptions: function getVatOptions() {
      var _this6 = this;

      var locaitonIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_ids: locaitonIds
      };
      var endpoint = this.taxesVersion === 2 ? '/taxes-v2/vat-rates' : '/location/vat';
      this.apiRequest(endpoint, 'GET', data, function (response) {
        if (response.status === true) {
          _this6.vatOptions = response.data;
        }
      });
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var _this7 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
        this.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.imagelist = fileList.slice(1);
        } else {
          this.imagelist = fileList;
        }
        if (this.imagelist && this.imagelist[0].status === 'ready') {
          this.getBase64(this.imagelist[0].raw).then(function (base64enc) {
            _this7.model.unavailable_image = base64enc;
          });
        }
      }
    },
    handleImgChangeLogo: function handleImgChangeLogo(file, fileList) {
      var _this8 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.uploadLogo.clearFiles();
        this.imagelistLogo = [];
      } else {
        if (fileList.length > 1) {
          this.imagelistLogo = fileList.slice(1);
        } else {
          this.imagelistLogo = fileList;
        }
        if (this.imagelistLogo && this.imagelistLogo[0].status === 'ready') {
          this.getBase64(this.imagelistLogo[0].raw).then(function (base64enc) {
            _this8.model.logo = base64enc;
          });
        }
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.imagelist = [];
        this.model.unavailable_image = '';
      }
    },
    handleRemoveLogo: function handleRemoveLogo(file, fileList) {
      if (fileList.length === 0) {
        this.imagelistLogo = [];
        this.model.logo = '';
      }
    },
    handleImgChangeAppImage: function handleImgChangeAppImage(file, fileList) {
      var _this9 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.uploadAppImage.clearFiles();
        this.imagelistAppImage = [];
      } else {
        if (fileList.length > 1) {
          this.imagelistAppImage = fileList.slice(1);
        } else {
          this.imagelistAppImage = fileList;
        }
        if (this.imagelistAppImage && this.imagelistAppImage[0].status === 'ready') {
          this.getBase64(this.imagelistAppImage[0].raw).then(function (base64enc) {
            _this9.model.app_image = base64enc;
          });
        }
      }
    },
    handleRemoveAppImage: function handleRemoveAppImage(file, fileList) {
      if (fileList.length === 0) {
        this.imagelistAppImage = [];
        this.model.app_image = '';
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
      }
      return isOkSize;
    },
    getData: function getData() {
      this.deliveryMethods = this.getCompanyDetail('delivery_options_labels');
      this.timeFormat = this.getCompanyDetail('time_format');
      this.dateFormat = this.getCompanyDetail('date_format');
      this.sortMethodsList = this.$session.get('defaultData').sort_products_methods;

      var self = this;
      var data = {
        token: this.$session.get('token')
      };
      this.apiRequest('/settings/payment-groups/' + self.$session.get('selectedCompany'), 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data.length === 0) {
            self.paymentGroups = null;
          } else {
            self.paymentGroups = response.data;
          }
        }
      });
    },
    checkVal: function checkVal(location) {},
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate(pageId) {
      var _this10 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this10.saveDetails(false, null);
        } else {}
      });
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
    },
    disableTaxOption: function disableTaxOption(locId, taxId) {
      var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details);
      var thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.model.locations_details[locIdx]['taxes']);

      if (thisTaxIdx !== false) {
        return true;
      } else {
        return false;
      }
    },
    scrollToPx: function scrollToPx(px) {
      var elem = this.$el;

      elem.scrollTop = elem.clientHeight;
      window.scrollTo({
        left: 0,
        top: elem.clientHeight - px,
        behavior: 'smooth'
      });
    },
    saveDetails: function saveDetails(isDel, locId) {
      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');

      if (this.taxesVersion !== 2 && this.model.tips_taxes === null) {
        this.model.tips_taxes = [];
      }
      if (this.model.alert_multiple_orders_per_hour < 5) {
        this.model.alert_multiple_orders_per_hour = null;
      }
      if (this.model.alert_multiple_orders_per_hour > 500) {
        this.model.alert_multiple_orders_per_hour = 500;
      }
      var data = {
        'token': this.$session.get('token'),
        'name': this.model.name,
        'language': this.model.language,
        'tips_in_use': this.model.tips_in_use ? 1 : 0,
        'tips_pos_id': this.model.tips_pos_id,
        'tips_department_id': this.model.tips_department_id,
        'email_feedback': this.model.email_feedback,
        'jump_to_menu': this.model.jump_to_menu ? 1 : 0,
        'over_eighteen': this.model.over_eighteen ? 1 : 0,
        'automated_processed_status': this.model.automated_processed_status ? 1 : 0,

        'alert_multiple_orders_per_hour': parseInt(this.model.alert_multiple_orders_per_hour),
        'smso_sender': this.model.smso_sender,
        'smso_token': this.model.smso_token,
        'smso_sender_extern': this.model.smso_sender_extern,
        'smso_token_extern': this.model.smso_token_extern,
        'allow_order_until_close_hour': this.model.allow_order_until_close_hour ? 1 : 0,
        'sort_product_method': this.model.sort_product_method,
        'is_allowed_on_hold': this.model.is_allowed_on_hold ? 1 : 0,
        'is_allowed_postponed': this.model.is_allowed_postponed ? 1 : 0,
        'remove_totals_extras_from_discount': this.model.remove_totals_extras_from_discount ? 1 : 0,
        'print_fiscal_from_dashboard': this.model.print_fiscal_from_dashboard ? 1 : 0,
        'payment_btns_v2': this.model.payment_btns_v2 ? 1 : 0,
        'just_card_txt_to_kiosk': this.model.just_card_txt_to_kiosk ? 1 : 0,
        'add_packing_method_to_comment': this.model.add_packing_method_to_comment ? 1 : 0,
        'is_allowed_sound_at_new': this.model.is_allowed_sound_at_new ? 1 : 0,
        'is_allowed_sound_at_processing': this.model.is_allowed_sound_at_processing,
        'is_allowed_order_under_min_value': this.model.is_allowed_order_under_min_value ? 1 : 0,
        'use_order_grandtotal_for_shipping_discount': this.model.use_order_grandtotal_for_shipping_discount ? 1 : 0,
        'flag_fast_order_from_admin': this.model.flag_fast_order_from_admin ? 1 : 0,
        'sound_delivery_methods': this.model.sound_delivery_methods,
        'unavailable_text': this.model.unavailable_text,
        'unavailable_image': this.model.unavailable_image,
        'logo': this.model.logo,
        'app_image': this.model.app_image,
        'delivery_options_labels': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model.delivery_options_labels),
        'selected_languages': this.model.selected_languages,
        'initial_order_status_self_order': this.model.initial_order_status_self_order === 'PROCESSING' ? 'PROCESSING' : null,
        'initial_order_status_app_web': this.model.initial_order_status_app_web ? this.model.initial_order_status_app_web.value : null,
        'purchase_limit_interval_hours': this.model.purchase_limit_interval_hours ? this.model.purchase_limit_interval_hours : null,
        'use_pos_notifications': this.model.use_pos_notifications ? 1 : 0,
        'use_clients_offline': this.model.use_clients_offline ? 1 : 0,
        'use_gift_card_on_pos': this.model.use_gift_card_on_pos ? 1 : 0,
        'use_interactive_tour_always': this.model.use_interactive_tour_always ? 1 : 0,
        'use_interactive_tour_first_login': this.model.use_interactive_tour_first_login ? 1 : 0,
        'force_location_from_deeplink': this.model.force_location_from_deeplink ? 1 : 0
      };

      if (this.taxesVersion === 2) {
        data.tips_vat_rate_id = this.model.tips_vat_rate_id || null;
      } else {
        data.tips_taxes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model.tips_taxes);
      }

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          self.trackAdminEvent('ADMIN_COMPANY_DETAILS_UPDATE', 'company', companyID, {
            company_id: companyID,
            name: data.name || null,
            request: data,
            response: response
          });
          self.$emit('updateModelData', response.data[0]);
          self.$session.set('companyName', data.name);
          self.errors.clear();
          self.$nextTick(function () {
            self.loading = false;
            self.syncCompanySessionAndCache(response.data[0]);
          });
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({ 'text': self.$t('settingCompany.companyUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          if (isDel) {
            var filterCookie = self.$cookie.get('filter-locations');
            if (filterCookie) {
              filterCookie = JSON.parse(filterCookie);
              var indexOf = filterCookie.indexOf(locId);
              if (indexOf !== -1) {
                filterCookie.splice(indexOf, 1);
                self.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filterCookie), 30);
              }
            }
          }
          self.$emit('companyName', data.name);
          self.showDelete = self.model.locations_details.length > 1;
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          if (response.errors.latlng !== undefined) {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({ 'text': self.$t('settingCompany.wrongAddress', { location: response.errors.latlng }), 'type': 'error', 'showConfirmButton': true }).catch(function () {});
          } else {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          }
        }
      });
    },
    goToCompany: function goToCompany() {
      this.$emit('setSelectedTab', this.$t('settingsPages.taxLabeling'));
    },
    handleMenu: function handleMenu(index, event) {
      this.model.locations_details[index].use_dynamic_menu = event.target.value;
    }
  }
});

/***/ }),

/***/ "Yf1v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('product-options-form',{attrs:{"route":_vm.route,"kdsSectionsParent":_vm.kdsSections},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YiTc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YlEC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__);











var _components;







__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PSwitch: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getData();
  },
  data: function data() {
    return {
      id: this.value || this.tableId,
      locations: [],
      model: {
        'id': 0,
        'role': 'KDS_OPERATOR',
        'language': 'en',
        'loyalty_points': 0,
        'has_push_notifications': 0,
        'has_email_notifications': 0,
        'is_verified': 0,
        'is_created_from_admin': 0,
        'is_siteadmin': 0,
        'firstname': null,
        'lastname': null,
        'login_code': null
      },
      modelValidate: {
        firstname: { required: true },
        lastname: { required: true },
        email: {
          required: true,
          regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        },
        login_code: {
          required: true,
          regex: /^[0-9]{4}$/
        }
      },
      loading: true
    };
  },

  methods: {
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy);
    },
    getData: function getData() {
      var _this = this;

      var id = this.id || this.route.params.id;
      if (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };
        this.apiRequest('/kds/user/' + id, 'GET', data, function (response) {
          if (response.status) {
            _this.model = response.data.kds_user;
          }
          _this.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveTable();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    saveTable: function saveTable() {
      var _this3 = this;

      this.loading = true;
      this.model.login_code = this.model.login_code;
      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany'),
        'kds_user': this.model
      };

      var id = this.id || this.route.params.id;
      var url = '';
      var request = '';
      if (id) {
        url = '/kds/user/' + id;
        request = 'PUT';
      } else {
        url = '/kds/user/add';
        request = 'POST';
      }
      this.apiRequest(url, request, data, function (response) {
        if (response.status === true) {
          _this3.errors.clear();
          if (request === 'POST') {
            _this3.$bus.$emit('refresh');
            _this3.$bus.$emit('close-modal');
          } else {
            _this3.backButton();
          }
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
            title: '',
            text: _this3.$t('settingTable.tableSave'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          _this3.handleErrors(response.errors);
        }
        _this3.loading = false;
      });
    },
    deleteOrderScreen: function deleteOrderScreen() {
      var _this4 = this;

      this.loadingReset = true;
      var id = this.id || this.route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/kds/user/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this4.backButton();
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({ 'text': _this4.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
        _this4.loadingReset = false;
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "YngB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableZonesForm_vue__ = __webpack_require__("IJPR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd3db6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableZonesForm_vue__ = __webpack_require__("WXLK");
function injectStyle (ssrContext) {
  __webpack_require__("SKRm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableZonesForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd3db6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableZonesForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ynvi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__("+1fW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a75338_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__("qBgz");
function injectStyle (ssrContext) {
  __webpack_require__("OKCc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33a75338"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a75338_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yp5G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yq2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('challenge-campaign-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Yq4J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yqnz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);




















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    },
    isTable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.token = this.$session.get('token');
    this.getData();
  },
  data: function data() {
    return {
      loading: true,
      token: null,
      apiUrl: null,
      tableColumns: [{
        prop: 'id',
        label: 'ID',
        minWidth: 100
      }, {
        prop: 'name',
        label: this.$t('settingTable.name'),
        minWidth: 300
      }],
      tableData: []
    };
  },

  methods: {
    goToRecord: function goToRecord(row, event, column) {
      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/user/edit/');
      }
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/table-zone', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data;

          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    },
    goToAdd: function goToAdd() {
      if (typeof this.callback === 'function') {
        this.callback(null);
      }
    }
  }
});

/***/ }),

/***/ "Yr/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('el-upload',{ref:"upload-location-image",attrs:{"action":"","limit":2,"file-list":_vm.fileList,"list-type":"picture-card","accept":" .jpg, .jpeg, .png, .svg, .webp","on-change":_vm.handleChange,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YrdT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YuZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yvs9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignEdit_vue__ = __webpack_require__("Q9x8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3238994f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignEdit_vue__ = __webpack_require__("R5eq");
function injectStyle (ssrContext) {
  __webpack_require__("2x2C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3238994f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YyoL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YyuL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YzgZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z+1f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();return _vm.deleteUserLabel($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15 mar-bt-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('marketingFidelities.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})])]),_vm._v(" "),(_vm.fidelitiesLabelsPrimaryOption == 'ordersValue')?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.ordersValue')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.order_value),expression:"modelValidations.order_value"},{name:"model",rawName:"v-model",value:(_vm.model.order_value),expression:"model.order_value"}],staticClass:"form-control removed_arrow",class:{ 'user-label-error-check' : _vm.model.showError },attrs:{"type":"number","placeholder":_vm.$t('marketingFidelities.value')},domProps:{"value":(_vm.model.order_value)},on:{"keyup":function($event){_vm.checkValueOrNumber(_vm.model)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "order_value", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.showError),expression:"model.showError"}],staticClass:"help text-danger"},[_vm._v(" "+_vm._s(_vm.$t('marketingFidelities.orderNumberRequired')))])])]):_vm._e(),_vm._v(" "),(_vm.fidelitiesLabelsPrimaryOption == 'ordersNumber')?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.ordersNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.order_numbers),expression:"modelValidations.order_numbers"},{name:"model",rawName:"v-model",value:(_vm.model.order_numbers),expression:"model.order_numbers"}],staticClass:"form-control removed_arrow",class:{ 'user-label-error-check' : _vm.model.showError },attrs:{"type":"number","placeholder":_vm.$t('marketingFidelities.number')},domProps:{"value":(_vm.model.order_numbers)},on:{"keyup":function($event){_vm.checkValueOrNumber(_vm.model)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "order_numbers", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.showError),expression:"model.showError"}],staticClass:"help text-danger"},[_vm._v(" "+_vm._s(_vm.$t('marketingFidelities.orderNumberRequired')))])])]):_vm._e(),_vm._v(" "),(_vm.fidelitiesLabelsPrimaryOption == 'MOR')?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.MORCalcComenzi')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.morValCalc),expression:"morValCalc"}],staticClass:"form-control removed_arrow",class:{ 'user-label-error-check' : _vm.model.showError },attrs:{"type":"number","placeholder":_vm.$t('marketingFidelities.number')},domProps:{"value":(_vm.morValCalc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.morValCalc=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.MOR')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.mor_value),expression:"modelValidations.mor_value"},{name:"model",rawName:"v-model",value:(_vm.model.mor_value),expression:"model.mor_value"}],staticClass:"form-control removed_arrow",class:{ 'user-label-error-check' : _vm.model.showError },attrs:{"type":"number","placeholder":_vm.$t('marketingFidelities.number')},domProps:{"value":(_vm.model.mor_value)},on:{"keyup":function($event){_vm.checkValueOrNumber(_vm.model)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "mor_value", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.showError),expression:"model.showError"}],staticClass:"help text-danger"},[_vm._v(" "+_vm._s(_vm.$t('marketingFidelities.orderNumberRequired')))])])])]),_vm._v(" "),_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.$t('marketingFidelities.MORInfo'))}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.color')))]),_vm._v(" "),_c('ChromePicker',{attrs:{"value":_vm.model.color},on:{"input":function($event){_vm.updateColor($event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.description')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.notification),expression:"model.notification"}],staticClass:"form-control",attrs:{"type":"text","title":_vm.model.notification,"placeholder":_vm.$t('marketingFidelities.descriptionPlaceholder')},domProps:{"value":(_vm.model.notification)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "notification", $event.target.value)}}}),_vm._v(" "),_c('small',[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('marketingFidelities.descriptionInfo')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.coupon')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.coupon),expression:"model.coupon"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('marketingFidelities.coupon')},domProps:{"value":(_vm.model.coupon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "coupon", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.product')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.product_id),expression:"model.product_id"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.productId),expression:"modelValidations.productId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "product_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"},domProps:{"selected":true}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.noReccurence')))]),_vm._v(" "),_vm._l((_vm.products),function(product){return [_c('option',{key:((product.id) + "-product"),domProps:{"value":product.id}},[_vm._v(_vm._s(product.name))])]})],2),_vm._v(" "),_c('small',[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('marketingFidelities.availableProducts')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.recurrence')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.recurrence),expression:"model.recurrence"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "recurrence", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.fidelitiesReccurenceOptions),function(opt,key){return _c('option',{key:key,domProps:{"value":key}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.'+opt))+"\n                  ")])})),_vm._v(" "),_c('small',[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('marketingFidelities.recurrenceInfo', {recurrence: _vm.model.recurrence !== '0' ? _vm.$t('marketingFidelities.'+_vm.fidelitiesReccurenceOptions[_vm.model.recurrence]) : '-'})))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.userNotification')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.user_notification),expression:"model.user_notification"}],staticClass:"form-control label-notification-textarea",attrs:{"rows":"4","placeholder":_vm.$t('marketingFidelities.userNotificationPlaceholder', {level: _vm.model.name})},domProps:{"value":(_vm.model.user_notification)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "user_notification", $event.target.value)}}}),_vm._v(" "),_c('small',[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('marketingFidelities.userNotificationInfo')))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"header",staticStyle:{"margin":"-15px 0 30px !important"}},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingsRewards.moneySpent')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"delivery_method"},[_c('div',{staticClass:"delivery_method_points"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.delivery')))]),_vm._v("\n                1 "+_vm._s(_vm.currency)+" =\n                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.loyalty_points.delivery),expression:"model.loyalty_points.delivery"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","step":"1","name":"loyalty_value_one_currency_delivery"},domProps:{"value":(_vm.model.loyalty_points.delivery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.loyalty_points, "delivery", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.$t('settingsRewards.plural'))+"\n\n                "),(_vm.errors.has('loyalty_value_one_currency'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('loyalty_value_one_currency'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"delivery_method_points"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.eat_location')))]),_vm._v("\n                1 "+_vm._s(_vm.currency)+" =\n                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.loyalty_points.eat_location),expression:"model.loyalty_points.eat_location"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","step":"1","name":"loyalty_value_one_currency_eat_location"},domProps:{"value":(_vm.model.loyalty_points.eat_location)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.loyalty_points, "eat_location", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.$t('settingsRewards.plural'))+"\n\n                "),(_vm.errors.has('loyalty_value_one_currency'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('loyalty_value_one_currency'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"delivery_method_points"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.meet_half')))]),_vm._v("\n                1 "+_vm._s(_vm.currency)+" =\n                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.loyalty_points.meet_half),expression:"model.loyalty_points.meet_half"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","step":"1","name":"loyalty_value_one_currency_meet_half"},domProps:{"value":(_vm.model.loyalty_points.meet_half)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.loyalty_points, "meet_half", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.$t('settingsRewards.plural'))+"\n\n                "),(_vm.errors.has('loyalty_value_one_currency'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('loyalty_value_one_currency'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"delivery_method_points"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.pick_up')))]),_vm._v("\n                1 "+_vm._s(_vm.currency)+" =\n                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.loyalty_points.pick_up),expression:"model.loyalty_points.pick_up"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","step":"1","name":"loyalty_value_one_currency_pick_up"},domProps:{"value":(_vm.model.loyalty_points.pick_up)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.loyalty_points, "pick_up", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.$t('settingsRewards.plural'))+"\n\n                "),(_vm.errors.has('loyalty_value_one_currency'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('loyalty_value_one_currency'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"delivery_method_points"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.self_ordering')))]),_vm._v("\n                1 "+_vm._s(_vm.currency)+" =\n                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.loyalty_points.self_ordering),expression:"model.loyalty_points.self_ordering"}],staticClass:"form-control in-inline",attrs:{"type":"number","min":"1","step":"1","name":"loyalty_value_one_currency_self_ordering"},domProps:{"value":(_vm.model.loyalty_points.self_ordering)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.loyalty_points, "self_ordering", $event.target.value)}}}),_vm._v(" "+_vm._s(_vm.$t('settingsRewards.plural'))+"\n\n                "),(_vm.errors.has('loyalty_value_one_currency'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('loyalty_value_one_currency'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"help-block"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('settingsRewards.numberOfcurrencyNeedToSpend', {currency: _vm.currency})))]),_vm._v(" "),_c('span',{staticClass:"help-block"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('settingsRewards.default')))])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z+bu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z/c3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"})])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.route && _vm.route.params && _vm.route.params.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteOrderScreen($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":"ID"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"name"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v("Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.type_name),expression:"model.type_name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.type_name),expression:"modelValidate.type_name"}],staticClass:"form-control color-option-default",attrs:{"name":"type_name"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "type_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"CAS"}},[_vm._v("CAS")]),_vm._v(" "),_c('option',{attrs:{"value":"CAS_II"}},[_vm._v("CAS II")]),_vm._v(" "),_c('option',{attrs:{"value":"Mettler_Toledo"}},[_vm._v("Mettler Toledo")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Port")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.port),expression:"modelValidate.port"},{name:"model",rawName:"v-model",value:(_vm.model.port),expression:"model.port"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"COM4"},domProps:{"value":(_vm.model.port)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "port", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Baud Rate")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.baudRate),expression:"modelValidate.baudRate"},{name:"model",rawName:"v-model",value:(_vm.model.baudRate),expression:"model.baudRate"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"9600"},domProps:{"value":(_vm.model.baudRate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "baudRate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Timeout Ms")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.timeoutMs),expression:"modelValidate.timeoutMs"},{name:"model",rawName:"v-model",value:(_vm.model.timeoutMs),expression:"model.timeoutMs"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"5000"},domProps:{"value":(_vm.model.timeoutMs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "timeoutMs", $event.target.value)}}})])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z3DB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      loading: false,
      companyID: null,
      selectedLocation: null,
      searchDate: null,
      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            var end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      }
    };
  },


  computed: {
    canExport: function canExport() {
      return this.selectedLocation && this.searchDate && this.searchDate.length === 2;
    }
  },

  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },


  methods: {
    exportFacturiIntrare: function exportFacturiIntrare() {
      var _this = this;

      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'XML';
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var startDate, endDate, externalLocationId, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (_this.canExport) {
                  _context.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
                  title: 'Atenție',
                  text: 'Selectează locația și intervalul de date!',
                  type: 'warning',
                  timer: 2500,
                  showConfirmButton: false
                });
                return _context.abrupt('return');

              case 4:

                _this.loading = true;

                startDate = new Date(_this.searchDate[0]).toISOString();
                endDate = new Date(_this.searchDate[1]).toISOString();
                externalLocationId = _this.selectedLocation.true_id;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/exports/accounting/facturi-intrare' + ('?startDate=' + encodeURIComponent(startDate)) + ('&endDate=' + encodeURIComponent(endDate)) + ('&externalLocationId=' + encodeURIComponent(externalLocationId)) + ('&externalCompanyId=' + encodeURIComponent(_this.companyID)) + ('&export=' + format);


                window.location.href = url;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                console.error('Export error:', _context.t0);

                __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
                  title: 'Eroare!',
                  text: 'Nu s-a putut genera exportul.',
                  type: 'error',
                  timer: 3000,
                  showConfirmButton: false
                });

              case 16:
                _context.prev = 16;

                _this.loading = false;
                return _context.finish(16);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 12, 16, 19]]);
      }))();
    }
  }
});

/***/ }),

/***/ "ZArx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('gestiune.generateNir')},on:{"click":function($event){$event.preventDefault();_vm.generateNir(_vm.invoice._id)}}},[_vm._v("\n            "+_vm._s(_vm.$t('gestiune.generateNir'))+"\n          ")])])])]),_vm._v(" "),(_vm.invoice)?_c('div',{staticClass:"card bon-details"},[_c('div',{staticClass:"box"},[_c('h5',[_vm._v(_vm._s(_vm.$t('gestiune.customer')))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('gestiune.name'))+":")]),_vm._v(" "+_vm._s(_vm.invoice.customer.name))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('gestiune.vat'))+":")]),_vm._v(" "+_vm._s(_vm.invoice.customer.vat))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('gestiune.identificationCode'))+":")]),_vm._v(" "+_vm._s(_vm.invoice.customer.identificationCode))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('gestiune.address'))+":")]),_vm._v(" "+_vm._s(_vm.formatAddress(_vm.invoice.customer.address)))])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('h5',[_vm._v(_vm._s(_vm.$t('gestiune.supplier'))+" & "+_vm._s(_vm.$t('gestiune.invoice')))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('gestiune.name'))+":")]),_vm._v(" "+_vm._s(_vm.invoice.supplier.name))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('gestiune.vat'))+":")]),_vm._v(" "+_vm._s(_vm.invoice.supplier.vat))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('gestiune.invoiceNumber'))+":")]),_vm._v(" "+_vm._s(_vm.invoice.invoiceNumber))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('invoice.issueDate'))+":")]),_vm._v(" "+_vm._s(_vm.formatDate(_vm.invoice.issueDate)))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('gestiune.dueDate'))+":")]),_vm._v(" "+_vm._s(_vm.formatDate(_vm.invoice.dueDate)))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","width":"60"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('gestiune.stockNameTable'),"width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row && scope.row.name ? scope.row.name : '')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.cantitate'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row && scope.row.quantity)?_c('span',[_vm._v("\n                "+_vm._s(scope.row.quantity.value)+"\n              ")]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.unit'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row && scope.row.quantity && scope.row.quantity.unit)?_c('span',[_vm._v("\n                "+_vm._s(_vm.getUnitText(scope.row.quantity.unit))+"\n              ")]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.price')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row && scope.row.price)?_c('span',[_vm._v("\n                "+_vm._s(scope.row.price.value)+"\n                "+_vm._s(scope.row.price.currency)+"\n              ")]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.lineTotal')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row && scope.row.lineExtensionAmount)?_c('span',[_vm._v("\n                "+_vm._s(scope.row.lineExtensionAmount.value)+"\n                "+_vm._s(scope.row.lineExtensionAmount.currency)+"\n              ")]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.taxRate')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row && scope.row.taxRate !== undefined ? scope.row.taxRate : '-')+"\n            ")]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZBX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinning-wheel-rewards-report"},[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":function($event){$event.preventDefault();return _vm.back($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('h5',{staticClass:"mar-bt-0"},[_vm._v(_vm._s(_vm.pageTitle))])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.onRowClick}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('customers.id'),"width":"70"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('spinningWheel.reward'),"min-width":"160","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":_vm.$t('spinningWheel.rewardType'),"width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('spinningWheel.winningPercentage'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.winning_percentage)+"%")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"wins","label":_vm.$t('spinningWheel.wins'),"width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"users_who_won","label":_vm.$t('spinningWheel.usersWhoWon'),"width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"redeemed","label":_vm.$t('spinningWheel.redeemed'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remaining","label":_vm.$t('spinningWheel.remaining'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('spinningWheel.redemptionRate'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(props.row.redemption_rate != null ? props.row.redemption_rate + '%' : '—')+"\n          ")]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZFeI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f6b188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("UTB8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f6b188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZR/e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DonationCampaignForm_vue__ = __webpack_require__("1kFH");







var _components;





__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'DonationCampaignForm', __WEBPACK_IMPORTED_MODULE_7__DonationCampaignForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      campaignModel: {}
    };
  },

  methods: {
    onCampaignSubmit: function onCampaignSubmit(model) {
      this.campaignModel = model;
    }
  }
});

/***/ }),

/***/ "ZREN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      view: 'list',
      loading: true,
      attemptedSave: false,
      formError: '',
      slots: [],
      model: this.emptyModel()
    };
  },
  created: function created() {
    this.getData();
  },

  methods: {
    sessionData: function sessionData() {
      var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, extra);
    },
    emptyModel: function emptyModel() {
      return {
        id: null,
        nume_admin: '',
        name: '',
        cost_per_parte: null,
        seats: [{ numar: null, cost: null }]
      };
    },
    getData: function getData() {
      var _this = this;

      this.loading = true;
      this.apiRequest('/delivery-slot', 'GET', this.sessionData(), function (response) {
        if (response.status === true) {
          _this.slots = response.data;
        }
        _this.loading = false;
      });
    },
    isFilled: function isFilled(v) {
      return v !== null && v !== '' && typeof v !== 'undefined' && !isNaN(v);
    },
    openForm: function openForm(id) {
      this.formError = '';
      this.attemptedSave = false;
      if (id) {
        var slot = this.slots.find(function (s) {
          return s.id === id;
        });
        this.model = {
          id: slot.id,
          nume_admin: slot.nume_admin,
          name: slot.name,
          cost_per_parte: slot.cost_per_parte !== null ? Number(slot.cost_per_parte) : null,
          seats: (slot.seats || []).map(function (s) {
            return { id: s.id, numar: Number(s.numar), cost: Number(s.cost) };
          })
        };
        if (!this.model.seats.length) this.model.seats.push({ numar: null, cost: null });
      } else {
        this.model = this.emptyModel();
      }
      this.view = 'form';
    },
    backToList: function backToList() {
      this.view = 'list';
      this.getData();
    },
    addSeat: function addSeat() {
      this.model.seats.push({ numar: null, cost: null });
    },
    removeSeat: function removeSeat(index) {
      this.model.seats.splice(index, 1);
    },
    save: function save() {
      var _this2 = this;

      this.attemptedSave = true;
      var seatsFilled = this.model.seats.length && this.model.seats.every(function (s) {
        return _this2.isFilled(s.numar) && _this2.isFilled(s.cost);
      });
      if (!this.model.nume_admin || !this.model.name || !seatsFilled) {
        this.formError = !this.model.nume_admin || !this.model.name ? this.$t('general.fillRequiredFields') : this.$t('deliveryPreferences.seatsRequired');
        return;
      }
      this.formError = '';
      this.loading = true;

      var payload = this.sessionData({
        nume_admin: this.model.nume_admin,
        name: this.model.name,
        cost_per_parte: this.model.cost_per_parte === '' || this.model.cost_per_parte === null || isNaN(this.model.cost_per_parte) ? null : this.model.cost_per_parte,
        seats: this.model.seats.map(function (s) {
          return {
            id: s.id,
            numar: s.numar,
            cost: s.cost
          };
        })
      });

      var url = this.model.id ? '/delivery-slot/' + this.model.id : '/delivery-slot';
      var method = this.model.id ? 'PUT' : 'POST';

      this.apiRequest(url, method, payload, function (response) {
        _this2.loading = false;
        if (response.success === true) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ text: _this2.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(function () {}).catch(function () {});
          _this2.backToList();
        } else {
          _this2.formError = _this2.firstError(response.errors);
        }
      });
    },
    remove: function remove() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: self.$t('deliveryPreferences.deleteConfirm'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result && (result.value || result === true)) {
          self.loading = true;
          self.apiRequest('/delivery-slot/' + self.model.id, 'PUT', self.sessionData({ delete: true }), function (response) {
            self.loading = false;
            if (response.success === true) {
              __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ text: self.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(function () {}).catch(function () {});
              self.backToList();
            } else {
              __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ text: self.firstError(response.errors) || self.$t('validations.wentWrong'), type: 'error', showConfirmButton: false, timer: 2500 }).then(function () {}).catch(function () {});
            }
          });
        }
      }).catch(function () {});
    },
    firstError: function firstError(errors) {
      if (!errors) return '';
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors);
      if (!keys.length) return '';
      var v = errors[keys[0]];
      return Array.isArray(v) ? v[0] : v;
    }
  }
});

/***/ }),

/***/ "ZRcl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r3_vue__ = __webpack_require__("pYrY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85187704_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r3_vue__ = __webpack_require__("7sZY");
function injectStyle (ssrContext) {
  __webpack_require__("lVN8")
  __webpack_require__("oA4C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-85187704"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85187704_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZSHb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generalTopBar_vue__ = __webpack_require__("+1Kz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a3f6da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generalTopBar_vue__ = __webpack_require__("bQL1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generalTopBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a3f6da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generalTopBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zci7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zco+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZdWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsSales_vue__ = __webpack_require__("dF93");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7958a7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsSales_vue__ = __webpack_require__("Dw7J");
function injectStyle (ssrContext) {
  __webpack_require__("ihiR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsSales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7958a7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsSales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ze7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"}),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.addCasaRegister($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.add'))+"\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.downloadCasaRegister}},[_vm._v("\n            "+_vm._s(_vm.$t('gestiune.downloadInventory'))+"\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"date","label":_vm.$t('gestiune.date')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"action","label":_vm.$t('gestiune.action')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"document","label":_vm.$t('gestiune.document')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"details","label":_vm.$t('gestiune.details')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"payments","label":_vm.$t('gestiune.payments')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"collections","label":_vm.$t('gestiune.collections')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"balance","label":_vm.$t('gestiune.balance')}})],1)],1)])]),_vm._v(" "),_c('vmodal',{staticClass:"casaRegisterModal",attrs:{"name":"casaRegisterModal","height":"auto","width":"800"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addCasaRegister')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",staticStyle:{"display":"grid"}},[_c('label',{attrs:{"for":"data"}},[_vm._v(_vm._s(_vm.$t('gestiune.data')))]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"Selectează data"},model:{value:(_vm.form.date),callback:function ($$v) {_vm.$set(_vm.form, "date", $$v)},expression:"form.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",staticStyle:{"display":"grid"}},[_c('label',{attrs:{"for":"document"}},[_vm._v(_vm._s(_vm.$t('gestiune.document')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introduceți documentul"},model:{value:(_vm.form.document),callback:function ($$v) {_vm.$set(_vm.form, "document", $$v)},expression:"form.document"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",staticStyle:{"display":"grid"}},[_c('label',{attrs:{"for":"reason"}},[_vm._v(_vm._s(_vm.$t('gestiune.motiv')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introduceți motivul"},model:{value:(_vm.form.reason),callback:function ($$v) {_vm.$set(_vm.form, "reason", $$v)},expression:"form.reason"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",staticStyle:{"display":"grid"}},[_c('label',{attrs:{"for":"value"}},[_vm._v(_vm._s(_vm.$t('gestiune.value')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introduceți valoarea"},model:{value:(_vm.form.value),callback:function ($$v) {_vm.$set(_vm.form, "value", $$v)},expression:"form.value"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save"},[_vm._v(_vm._s(_vm.$t('general.save')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete"},[_vm._v(_vm._s(_vm.$t('general.cancel2')))])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZgTq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZhiD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('category-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onCategorySubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZkTW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceStorno_vue__ = __webpack_require__("+8ZT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e7299a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceStorno_vue__ = __webpack_require__("930j");
function injectStyle (ssrContext) {
  __webpack_require__("KkTj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48e7299a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceStorno_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e7299a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceStorno_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zkgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopProducts_vue__ = __webpack_require__("Qq2o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c41522c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopProducts_vue__ = __webpack_require__("I0/X");
function injectStyle (ssrContext) {
  __webpack_require__("ST7i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c41522c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopProducts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zki6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZmjM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZnRb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QrPaymentSettings_vue__ = __webpack_require__("hfzk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d766f7f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QrPaymentSettings_vue__ = __webpack_require__("cDS1");
function injectStyle (ssrContext) {
  __webpack_require__("mx6W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d766f7f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QrPaymentSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d766f7f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QrPaymentSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZoNs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isLoyality },on:{"click":_vm.openLoyality}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.loyalityPoint')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isUserLabeling },on:{"click":_vm.openUserLabeling}},[_vm._v(_vm._s(_vm.$t('marketingFidelities.userLabeling')))])])])])]),_vm._v(" "),(_vm.isLoyality)?_c('div',[_c('Loyality')],1):_vm._e(),_vm._v(" "),(_vm.isUserLabeling)?_c('div',[_c('UserLabeling')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZpCo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row raffle-campaigns"},[_c('div',{staticClass:"col-xl-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-start","gap":"10px","flex-wrap":"wrap","flex-direction":"column"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px","align-items":"flex-end","flex":"1 1 auto"}},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.id')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('raffleCampaigns.id'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applyFilters($event)}},model:{value:(_vm.idFilter),callback:function ($$v) {_vm.idFilter=$$v},expression:"idFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"1 1 180px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.name')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('raffleCampaigns.search'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applyFilters($event)}},model:{value:(_vm.nameFilter),callback:function ($$v) {_vm.nameFilter=$$v},expression:"nameFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 140px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.active')))]),_vm._v(" "),_c('v-select',{attrs:{"options":[
                  { id: 1, type: _vm.$t('general.active') },
                  { id: 0, type: _vm.$t('general.inactive') }
                ],"label":"type","reduce":function (option) { return option.id; },"placeholder":_vm.$t('general.select'),"clearable":""},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 160px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.type')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","size":"small","placeholder":_vm.$t('general.select')},model:{value:(_vm.typeFilter),callback:function ($$v) {_vm.typeFilter=$$v},expression:"typeFilter"}},_vm._l((_vm.typeOptions),function(option){return _c('el-option',{key:option.value,attrs:{"label":option.label,"value":option.value}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 240px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.startEnd')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","size":"small","placeholder":_vm.$t('raffleCampaigns.startEnd')},model:{value:(_vm.dateRangeFilter),callback:function ($$v) {_vm.dateRangeFilter=$$v},expression:"dateRangeFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.applyFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right-group",staticStyle:{"flex":"0 0 auto","margin-bottom":"20px","margin-top":"10px"}},[_c('router-link',{staticClass:"btn add",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('raffleCampaigns.single'),"to":{ path: '/marketing/raffle-campaigns/add' }}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-sm.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+"\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"data-table",staticStyle:{"margin-top":"20px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"row-class-name":_vm.rowClass,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.onRowClick}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('raffleCampaigns.id'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('raffleCampaigns.name'),"min-width":"160","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('raffleCampaigns.type'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.typeLabel(props.row.type))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('raffleCampaigns.startEnd'),"min-width":"200","class-name":"date-range-cell"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatDate(props.row.starts_at))+" - "+_vm._s(_vm.formatDate(props.row.ends_at))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.active'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(scope.$index, scope.row, $event)}},model:{value:(scope.row.active),callback:function ($$v) {_vm.$set(scope.row, "active", $$v)},expression:"scope.row.active"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.goToRecord(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.edit'))+"\n                    ")]),_vm._v(" "),(scope.row.type === 'order_count')?_c('el-dropdown-item',{attrs:{"disabled":_vm.exportingId === scope.row.id},nativeOn:{"click":function($event){$event.stopPropagation();_vm.exportEntries(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('raffleCampaigns.exportEntries'))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.handleDelete(scope.$index, scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"current-page":_vm.paginationDef.page},on:{"update:currentPage":function($event){_vm.$set(_vm.paginationDef, "page", $event)},"current-change":_vm.handlePageChange}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZqJc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZtR2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zu6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaignParticipantsReport_vue__ = __webpack_require__("IQeM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567b8e68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaignParticipantsReport_vue__ = __webpack_require__("E1FO");
function injectStyle (ssrContext) {
  __webpack_require__("C+sr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-567b8e68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaignParticipantsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567b8e68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaignParticipantsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zvre":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zyt1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Management_ManagementSeriesAdd_vue__ = __webpack_require__("kgt7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);














function getLocalDateTimeString() {
  var now = new Date();
  var year = now.getFullYear();
  var month = String(now.getMonth() + 1).padStart(2, '0');
  var day = String(now.getDate()).padStart(2, '0');
  var hours = String(now.getHours()).padStart(2, '0');
  var minutes = String(now.getMinutes()).padStart(2, '0');
  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__["a" /* default */],
    ManagementSeriesAdd: __WEBPACK_IMPORTED_MODULE_9__Management_ManagementSeriesAdd_vue__["a" /* default */]
  },
  data: function data() {
    return {
      searchProdName: null,
      searchResults: [],
      selectedLocationId: '',
      selectedLocation: null,
      locations: [],
      gestiuneOptions: [],
      selectedProducts: [],
      seriesOptions: [],
      currencyOptions: [{ code: 'RON', name: 'Leu Românesc (RON)' }, { code: 'EUR', name: 'Euro (EUR)' }, { code: 'USD', name: 'Dolar American (USD)' }],
      bonCasare: {
        date: getLocalDateTimeString(),
        gestiune: null,
        serie: null,
        currency: 'RON',
        manager: '',
        receiver: '',
        internalNote: '',
        commandProject: '',
        consumptionType: '',
        lot: ''
      },
      debounceTimer: null,
      loading: false,
      isEdit: !!this.route.params.series && !!this.route.params.number,
      editIndex: null,
      tableData: [],
      stockGroups: [],
      newItem: {
        unitMeasure: '',
        quantity: 0,
        stocFaptic: 0
      }
    };
  },

  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    today: function today() {
      var now = new Date();
      now.setSeconds(0, 0);
      return now.toISOString().slice(0, 16);
    },
    seriesOptionsWithAdd: function seriesOptionsWithAdd() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(this.seriesOptions), [{ id: 'add', name: '➕ Adaugă serie' }]);
    },
    groupedLocations: function groupedLocations() {
      var groups = {};

      if (!this.locations || !this.locations.length) return [];

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocationId) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocationId;
      });
      return result;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.fetchGestiuni();
    this.fetchLocation();
  },

  watch: {
    selectedLocationId: function selectedLocationId(id) {
      if (!this.isEdit) {
        this.bonCasare.gestiune = null;
        this.bonCasare.serie = null;
        this.series = null;
        this.documentNumber = null;
        this.selectedLocation = null;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;
            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code);
            }
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    locations: function locations(newLocations) {
      if (newLocations && newLocations.length) {
        var s = this.route && this.route.params && this.route.params.series;
        var inv = this.route && this.route.params && this.route.params.number;
        if (s && inv) {
          this.fetchBonCasare(s, inv);
        }
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveWasted();
        }
      });
    },
    validateCasare: function validateCasare(entry) {
      if (entry.cantitate_casare > entry.available_quantity) {
        entry.cantitate_casare = entry.available_quantity;
      }
      if (entry.cantitate_casare < 0) {
        entry.cantitate_casare = null;
      }
    },
    getEmptyItem: function getEmptyItem() {
      return {
        editIndex: null,
        productObject: null,
        um: 'buc',
        cantitate: null
      };
    },
    handleSerieChange: function handleSerieChange(event) {
      var val = event.target.value;
      if (val === 'add') {
        this.openSeriesModal();
        this.bonCasare.serie = null;
      }
    },
    openSeriesModal: function openSeriesModal() {
      this.$modal.show('addSeriesModal');
    },
    fetchLocation: function fetchLocation() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataToSend = {
                  company_id: _this3.companyID,
                  token: _this3.$session.get('token')
                };


                _this3.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this3.locations = response.data.locations;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetchBonCasare: function fetchBonCasare(seriesParam, documentNumberParam) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                return _context3.delegateYield(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                  var response, data, bon, extra, getField, matchedGestiune, gestiuneId, foundLocation, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, group;

                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getDocument?tip=bon_casare&series=' + seriesParam + '&number=' + documentNumberParam + '&externalCompanyId=' + _this4.companyID);

                        case 2:
                          response = _context2.sent;

                          if (response.ok) {
                            _context2.next = 5;
                            break;
                          }

                          throw new Error('Failed to fetch bon de casare');

                        case 5:
                          _context2.next = 7;
                          return response.json();

                        case 7:
                          data = _context2.sent;

                          if (!(!data || !Array.isArray(data.documents) || !data.documents.length)) {
                            _context2.next = 10;
                            break;
                          }

                          throw new Error('Bon de casare inexistent');

                        case 10:
                          bon = data.documents[0];
                          extra = bon.extraFields || [];

                          getField = function getField(key) {
                            var field = extra.find(function (f) {
                              return f.key === key;
                            });
                            return field ? field.value : '';
                          };

                          matchedGestiune = _this4.gestiuneOptions.find(function (g) {
                            return g.name === bon.gestiune_from;
                          });
                          gestiuneId = matchedGestiune ? matchedGestiune.id : bon.gestiune_from;


                          _this4.bonCasare = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.bonCasare, {
                            gestiune: gestiuneId,
                            serie: bon.series,
                            lot: bon.lot || '',
                            date: bon.date ? new Date(bon.date).toISOString().slice(0, 16) : null,
                            documentNumber: bon.documentNumber,
                            manager: getField('manager'),
                            receiver: getField('receiver'),
                            internalNote: getField('internalNote'),
                            commandProject: getField('commandProject'),
                            consumptionType: getField('consumptionType')
                          });

                          _this4.selectedProducts = (bon.items || []).map(function (item) {
                            return {
                              product: {
                                _id: item.posId,
                                name: item.name,
                                um: item.um
                              },
                              cantitate_casare: item.quantity,
                              stockGroups: item.stockSelections.map(function (sel) {
                                return {
                                  entries: [{
                                    id: sel.source_move_id,
                                    cantitate_casare: sel.quantity
                                  }]
                                };
                              })
                            };
                          });

                          if (!(bon.externalLocationId && _this4.locations && _this4.locations.length)) {
                            _context2.next = 47;
                            break;
                          }

                          foundLocation = null;
                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _iteratorError2 = undefined;
                          _context2.prev = 22;
                          _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this4.groupedLocations);

                        case 24:
                          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                            _context2.next = 32;
                            break;
                          }

                          group = _step2.value;

                          foundLocation = group.locations.find(function (loc) {
                            return bon.externalLocationId && loc.true_id === bon.externalLocationId || bon.vatNumber && loc.inv_fiscal_code === bon.vatNumber;
                          });

                          if (!foundLocation) {
                            _context2.next = 29;
                            break;
                          }

                          return _context2.abrupt('break', 32);

                        case 29:
                          _iteratorNormalCompletion2 = true;
                          _context2.next = 24;
                          break;

                        case 32:
                          _context2.next = 38;
                          break;

                        case 34:
                          _context2.prev = 34;
                          _context2.t0 = _context2['catch'](22);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context2.t0;

                        case 38:
                          _context2.prev = 38;
                          _context2.prev = 39;

                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }

                        case 41:
                          _context2.prev = 41;

                          if (!_didIteratorError2) {
                            _context2.next = 44;
                            break;
                          }

                          throw _iteratorError2;

                        case 44:
                          return _context2.finish(41);

                        case 45:
                          return _context2.finish(38);

                        case 46:
                          if (foundLocation) {
                            _this4.selectedLocationId = foundLocation.true_id;
                          }

                        case 47:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this4, [[22, 34, 38, 46], [39,, 41, 45]]);
                })(), 't0', 2);

              case 2:
                _context3.next = 7;
                break;

              case 4:
                _context3.prev = 4;
                _context3.t1 = _context3['catch'](0);

                console.error('Error fetching bon de casare:', _context3.t1);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 4]]);
      }))();
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                clearTimeout(_this5.debounceTimer);

                _this5.debounceTimer = setTimeout(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
                  var url, response, data;
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _this5.searchResults = [];

                          if (!(!_this5.selectedLocation || !_this5.companyID || !_this5.bonCasare.gestiune || !searchTerm || searchTerm.length < 2)) {
                            _context4.next = 3;
                            break;
                          }

                          return _context4.abrupt('return');

                        case 3:
                          url = "https://fiscal-dev.cdntaptasty.com" + ':4443/products?externalCompanyId=' + _this5.companyID;

                          url += '&gestiune=' + _this5.bonCasare.gestiune;
                          url += '&externalLocationId=' + _this5.selectedLocation.true_id;
                          url += '&name=' + encodeURIComponent(searchTerm);

                          _this5.loading = true;
                          _context4.prev = 8;
                          _context4.next = 11;
                          return fetch(url);

                        case 11:
                          response = _context4.sent;
                          _context4.next = 14;
                          return response.json();

                        case 14:
                          data = _context4.sent;


                          if (Array.isArray(data.products)) {
                            _this5.searchResults = data.products.map(function (item) {
                              return {
                                label: item.name,
                                posId: item._id,
                                value: item
                              };
                            });
                            console.log(_this5.searchResults);
                          } else {
                            _this5.searchResults = [];
                            console.error('Invalid data format:', data);
                          }
                          _context4.next = 21;
                          break;

                        case 18:
                          _context4.prev = 18;
                          _context4.t0 = _context4['catch'](8);

                          console.error('Error fetching stock:', _context4.t0);

                        case 21:
                          _context4.prev = 21;

                          _this5.loading = false;
                          return _context4.finish(21);

                        case 24:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _callee4, _this5, [[8, 18, 21, 24]]);
                })), 400);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    onProductSelect: function onProductSelect(selected) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var product, exists, params, url, response, data, newItem;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (selected) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return');

              case 2:
                product = selected.value;
                exists = _this6.selectedProducts.some(function (item) {
                  return item.product._id === product._id;
                });

                if (!exists) {
                  _context6.next = 8;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  type: 'warning',
                  title: 'Produs deja selectat',
                  text: 'Acest produs a fost deja adăugat.'
                });
                _this6.searchProdName = null;
                return _context6.abrupt('return');

              case 8:
                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Se încarcă stocul...',
                  text: 'Așteaptă te rog.',
                  buttons: false,
                  closeOnClickOutside: false,
                  closeOnEsc: false,
                  type: 'info'
                });

                _context6.prev = 9;
                params = new URLSearchParams({
                  gestiune: _this6.bonCasare.gestiune,
                  product_id: product._id,
                  externalCompanyId: _this6.companyID,
                  externalLocationId: _this6.selectedLocation.true_id
                }).toString();
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/stock_details?' + params;
                _context6.next = 14;
                return fetch(url);

              case 14:
                response = _context6.sent;
                _context6.next = 17;
                return response.json();

              case 17:
                data = _context6.sent;

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.close();

                if (!(!data.groups || !Array.isArray(data.groups) || !data.groups.length)) {
                  _context6.next = 23;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  type: 'warning',
                  title: 'Produs indisponibil',
                  text: 'Acest produs nu are stoc disponibil în gestiune și nu poate fi casat.'
                });
                _this6.searchProdName = null;
                return _context6.abrupt('return');

              case 23:
                newItem = {
                  product: product,
                  cantitate_casare: null,
                  stockGroups: data.groups.map(function (g) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, g, {
                      entries: g.entries.map(function (e) {
                        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, e, { cantitate_casare: null });
                      })
                    });
                  })
                };


                _this6.selectedProducts.push(newItem);
                _this6.searchProdName = null;
                _context6.next = 33;
                break;

              case 28:
                _context6.prev = 28;
                _context6.t0 = _context6['catch'](9);

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.close();
                console.error('Eroare la preluarea stocurilor detaliate:', _context6.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  type: 'error',
                  title: 'Eroare',
                  text: 'Nu s-a putut verifica stocul produsului.'
                });

              case 33:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[9, 28]]);
      }))();
    },
    saveWasted: function saveWasted() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var items, selectedSerie, serieName, bonCasareData, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(!_this7.selectedProducts || _this7.selectedProducts.length === 0)) {
                  _context7.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Trebuie să adaugi cel puțin un produs pentru casare.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context7.abrupt('return');

              case 3:
                items = [];


                _this7.selectedProducts.forEach(function (productItem) {
                  if (productItem.stockGroups && Array.isArray(productItem.stockGroups)) {
                    productItem.stockGroups.forEach(function (group) {
                      if (group.entries && Array.isArray(group.entries)) {
                        var stockSelections = group.entries.filter(function (e) {
                          return e.cantitate_casare && e.cantitate_casare > 0;
                        }).map(function (e) {
                          return {
                            source_move_id: e.id,
                            quantity: e.cantitate_casare
                          };
                        });

                        if (stockSelections.length) {
                          var totalCasare = stockSelections.reduce(function (acc, s) {
                            return acc + s.quantity;
                          }, 0);

                          items.push({
                            posId: productItem.product._id,
                            name: productItem.product.name,
                            group_id: group.group_id || group.id || null,
                            lot: group.lot || null,
                            quantity: totalCasare,
                            um: productItem.product.um || group.um,
                            price: group.price,
                            stockSelections: stockSelections
                          });
                        }
                      }
                    });
                  }
                });

                if (items.length) {
                  _context7.next = 8;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Nu ai completat nicio cantitate pentru casare.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context7.abrupt('return');

              case 8:
                selectedSerie = _this7.seriesOptions.find(function (serie) {
                  return serie.id === _this7.bonCasare.serie || serie.name === _this7.bonCasare.serie;
                });
                serieName = selectedSerie ? selectedSerie.name : _this7.bonCasare.serie || null;
                bonCasareData = {
                  externalCompanyId: _this7.companyID,
                  externalLocationId: _this7.selectedLocation.true_id,
                  vatNumber: _this7.selectedLocation.inv_fiscal_code,
                  tip: 'bon_casare',
                  gestiune_from: _this7.bonCasare.gestiune,
                  date: _this7.bonCasare.date,
                  series: serieName,
                  items: items
                };

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Salvare în curs...',
                  text: 'Se salvează Bonul de Casare. Așteaptă te rog.',
                  buttons: false,
                  closeOnClickOutside: false,
                  closeOnEsc: false,
                  type: 'info'
                });

                _context7.prev = 12;
                _context7.next = 15;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/bon', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bonCasareData)
                });

              case 15:
                response = _context7.sent;
                _context7.next = 18;
                return response.json();

              case 18:
                data = _context7.sent;

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.close();

                if (response.ok) {
                  console.log('Bon casare salvat cu succes!', data);
                  __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                    title: 'Succes',
                    text: 'Bonul de casare a fost salvat cu succes!',
                    type: 'success',
                    timer: 1500,
                    showConfirmButton: false
                  });
                  _this7.$bus.$emit('refresh');
                  _this7.$bus.$emit('close-modal');
                } else {
                  console.error('Eroare la salvarea bonului casare', data);
                  __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                    title: 'Eroare',
                    text: data.details || data.error || 'A apărut o eroare la salvarea bonului de casare.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context7.next = 28;
                break;

              case 23:
                _context7.prev = 23;
                _context7.t0 = _context7['catch'](12);

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.close();
                console.error('Eroare la trimiterea cererii', _context7.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Nu s-a putut trimite cererea către server.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 28:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[12, 23]]);
      }))();
    },
    confirmCasare: function confirmCasare(entry) {
      console.log('Casare pentru ' + (entry.id || entry.product_id) + ': ' + entry.cantitate_casare + ' buc.');
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this8.companyID);

              case 3:
                response = _context8.sent;

                if (response.ok) {
                  _context8.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context8.next = 8;
                return response.json();

              case 8:
                data = _context8.sent;

                console.log('Date primite de la server:', data.gestiuni);
                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this8.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      externalLocationId: gest.externalLocationId || ''
                    };
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                    title: 'Error!',
                    text: 'Nu s-a primit un array valid de la server.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context8.next = 17;
                break;

              case 13:
                _context8.prev = 13;
                _context8.t0 = _context8['catch'](0);

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Error!',
                  text: 'Request failed: ' + _context8.t0.message,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching management data:', _context8.t0);

              case 17:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 13]]);
      }))();
    },
    getSeries: function getSeries(vatNumber) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this9.companyID,
                    vatNumber: vatNumber,
                    tip: 'bon_casare'
                  })
                });

              case 3:
                response = _context9.sent;

                if (response.ok) {
                  _context9.next = 6;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 6:
                _context9.next = 8;
                return response.json();

              case 8:
                data = _context9.sent;

                console.log('Serii primite:', data.series);

                if (Array.isArray(data.series)) {
                  _this9.seriesOptions = data.series.map(function (serie) {
                    return {
                      id: serie._id,
                      name: serie.series,
                      currentNumber: serie.currentNumber
                    };
                  });
                } else {
                  console.error('Format invalid pentru series:', data);
                }
                _context9.next = 16;
                break;

              case 13:
                _context9.prev = 13;
                _context9.t0 = _context9['catch'](0);

                console.error('Error fetching series:', _context9.t0);

              case 16:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[0, 13]]);
      }))();
    },
    removeProduct: function removeProduct(index) {
      this.selectedProducts.splice(index, 1);
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "a22L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_json_excel__ = __webpack_require__("fXhN");









var _components;










__WEBPACK_IMPORTED_MODULE_8_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_14_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isMasterReport: {
      type: Boolean,
      default: false
    },
    useFromColumns: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isMasterReport: function isMasterReport() {
      if (this.isMasterReport) {
        this.getTopCategories();
        this.getPaymentMethods();
        this.getSections();
        this.getOrders(null, { fetchVat: true });
        this.verifyUserLocations();
        this.verifyUserMethods();
        this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest';
        this._companyTimezoneFormatter = null;
        this.getPosUsers();
      }
    }
  },
  data: function data() {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      productsTableData: [],
      posUsers: [],
      selectedPosUser: null,
      timezone: null,
      productsTableDataTotals: {},
      paymentMethods: [],
      orderId: null,
      zet: null,
      receiptOptions: [{ label: this.$t('reports.withoutReceipt'), value: 1 }, { label: this.$t('reports.withReceipt'), value: 2 }],
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_methods: [],
      loading: true,
      vatLoading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_12_moment___default()().subtract(1, 'day').format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_12_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      date_column: 'created_at',
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      ordersTableData: {},
      totalOrders: null,

      topCategories: [],
      topCategoryId: [],
      sections: [],
      sectionId: [],
      hasRceipt: null,
      noData: false,
      pagination: {
        page: 1,
        pageSize: 20
      },
      totalSum: 0,
      vat_totals_by_section: {},
      vatSectionDisplay: [],
      _companyTimezoneFormatter: null,
      masterReportTableProps: {
        stripe: false,
        highlightCurrentRow: false,
        rowKey: '_rowKey',
        fit: false
      }
    };
  },

  methods: {
    getCompanyTimezoneFormatter: function getCompanyTimezoneFormatter() {
      var tz = this.timezone || 'Europe/Bucharest';
      if (!this._companyTimezoneFormatter || this._companyTimezoneFormatter.resolvedOptions().timeZone !== tz) {
        this._companyTimezoneFormatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: tz,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        });
      }
      return this._companyTimezoneFormatter;
    },
    formatToCompanyTimezone: function formatToCompanyTimezone(utcString) {
      if (!utcString) {
        return '-';
      }
      var date = new Date(utcString + 'Z');
      var parts = this.getCompanyTimezoneFormatter().formatToParts(date);
      var year = '';
      var month = '';
      var day = '';
      var hour = '';
      var minute = '';
      var second = '';
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        switch (part.type) {
          case 'year':
            year = part.value;break;
          case 'month':
            month = part.value;break;
          case 'day':
            day = part.value;break;
          case 'hour':
            hour = part.value;break;
          case 'minute':
            minute = part.value;break;
          case 'second':
            second = part.value;break;
        }
      }
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
    },
    mapMasterReportRows: function mapMasterReportRows(rows) {
      var _this = this;

      if (!rows || !rows.length) {
        return [];
      }
      var singleUnit = this.$t('reports.singleUnit');
      var yesLabel = this.$t('general.yes');
      var noLabel = this.$t('general.no');
      return rows.map(function (row, index) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze___default()({
          _rowKey: row.order_id + '-' + index,
          order_id: row.order_id,
          order_number: row.order_number,
          location_name: row.location_name,
          category: row.category,
          order_comments: row.order_comments,
          product_comments: row.product_comments,
          _pos_id_fmt: row.pos_id || '-',
          _item_pos_id_fmt: row.item_pos_id || row.option_pos_id || '-',
          _menu_item_pos_id_fmt: row.menu_item_pos_id || row.menu_option_pos_id || '-',
          _order_opening_time_fmt: row.order_opening_time ? _this.formatToCompanyTimezone(row.order_opening_time) : '-',
          _table_number_fmt: row.table_number || '-',
          _product_opening_time_fmt: row.product_opening_time ? _this.formatToCompanyTimezone(row.product_opening_time) : '-',
          _product_marking_time_fmt: row.product_marking_time ? _this.formatToCompanyTimezone(row.product_marking_time) : '-',
          _row_type_fmt: row.row_type ? _this.$t('reports.' + row.row_type) : '-',
          _top_category_fmt: row.top_category || '-',
          _product_name_fmt: row.product_name || row.option_name || '-',
          _is_storno_fmt: row.is_storno ? 'Storno' : 'Marcat',
          _operator_name_fmt: row.operator_name || '-',
          _section_name_fmt: row.section_name || '-',
          _gross_price_fmt: _this.formatMoneyAmount(Number(row.gross_price)),
          _product_quantity_fmt: row.product_quantity != null ? row.product_quantity : row.option_quantity,
          _product_quantity_quantitative_fmt: row.row_type === 'item' ? row.product_quantity_quantitative || singleUnit : '-',
          _product_discount_fmt: _this.formatMoneyAmount(Number(row.product_discount)),
          _order_discount_fmt: _this.formatMoneyAmount(Number(row.order_discount)),
          _order_loyalty_points_discount_fmt: _this.formatMoneyAmount(Number(row.order_loyalty_points_discount)),
          _order_extras_fmt: _this.formatMoneyAmount(Number(row.order_extras)),
          _order_shipping_fmt: _this.formatMoneyAmount(Number(row.order_shipping)),
          _order_tips_fmt: _this.formatMoneyAmount(Number(row.order_tips)),
          _collected_fmt: _this.formatMoneyAmount(Number(row.collected)),
          _vat_rate_fmt: row.vat_rate === 0 || row.vat_rate === '0' ? '0%' : row.vat_rate !== null && row.vat_rate !== undefined && row.vat_rate !== '' ? row.vat_rate + '%' : '-',
          _vat_value_fmt: _this.formatMoneyAmount(Number(row.vat_value)),
          _price_excluding_vat_fmt: _this.formatMoneyAmount(Number(row.price_excluding_vat)),
          _payment_method_fmt: _this.$t('paymentTypes.' + row.payment_method),
          _is_fiscalized_fmt: row.is_fiscalized ? yesLabel : noLabel,
          _room_number_fmt: row.room_number || '-',
          _event_folio_id_fmt: row.event_folio_id || '-'
        });
      });
    },
    buildVatSectionDisplay: function buildVatSectionDisplay(vatTotalsBySection) {
      var _this2 = this;

      if (!vatTotalsBySection) {
        return [];
      }
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(vatTotalsBySection).map(function (sectionId) {
        var parsedId = sectionId === 'null' || sectionId === null ? null : parseInt(sectionId, 10);
        var records = (vatTotalsBySection[sectionId] || []).map(function (record) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, record, {
            total_gross_price_fmt: _this2.formatMoneyAmount(record.total_gross_price || 0),
            total_net_price_fmt: _this2.formatMoneyAmount(record.total_net_price || 0),
            total_vat_value_fmt: _this2.formatMoneyAmount(record.total_vat_value || 0)
          });
        });
        return {
          sectionId: sectionId,
          sectionName: _this2.getSectionName(parsedId),
          records: records
        };
      });
    },
    renderGrossPriceHeader: function renderGrossPriceHeader(h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.grossPrice'), this.productsTableDataTotals.total_gross_price);
    },
    renderQuantityHeader: function renderQuantityHeader(h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.quantity'), this.productsTableDataTotals.total_product_quantity);
    },
    renderProductDiscountHeader: function renderProductDiscountHeader(h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.orderItemDiscount'), this.productsTableDataTotals.total_product_discount);
    },
    renderOrderDiscountHeader: function renderOrderDiscountHeader(h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.orderDiscount'), this.productsTableDataTotals.total_order_discount);
    },
    renderOrderLoyaltyDiscountHeader: function renderOrderLoyaltyDiscountHeader(h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.orderLoyaltyDiscount'), this.productsTableDataTotals.total_order_loyalty_points_discount);
    },
    renderOrderExtrasHeader: function renderOrderExtrasHeader(h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.tax'), this.productsTableDataTotals.total_order_extras);
    },
    renderOrderShippingHeader: function renderOrderShippingHeader(h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.shipping'), this.productsTableDataTotals.total_order_shipping);
    },
    renderOrderTipsHeader: function renderOrderTipsHeader(h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.tips'), this.productsTableDataTotals.total_order_tips);
    },
    renderCollectedHeader: function renderCollectedHeader(h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.orderItemValueCollected'), this.productsTableDataTotals.total_collected);
    },
    renderVatValueHeader: function renderVatValueHeader(h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.vatAmount'), this.productsTableDataTotals.total_vat_value);
    },
    renderPriceExcludingVatHeader: function renderPriceExcludingVatHeader(h) {
      return this.renderHeaderWithTotal(h, this.$t('reports.orderItemNetPrice'), this.productsTableDataTotals.total_price_excluding_vat);
    },
    getPaymentMethods: function getPaymentMethods() {
      var _this3 = this;

      var sessionData = this.$session.get('selectedCompanyData');

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };

        this.apiRequest('/orders/get-payment-methods', 'GET', data, function (response) {
          if (response.status && response.data.length) {
            var result = response.data.map(function (item) {
              return { id: item || 'unpaid', name: _this3.$t('paymentTypes.' + item) };
            });
            sessionData['payment_methods'] = response.data;
            _this3.$session.set('selectedCompanyData', sessionData);

            __WEBPACK_IMPORTED_MODULE_8_vue___default.a.set(_this3, 'paymentMethods', result);
          }
        });
      } else {
        var result = sessionData['payment_methods'].map(function (item) {
          return { id: item || 'unpaid', name: _this3.$t('paymentTypes.' + item) };
        });
        __WEBPACK_IMPORTED_MODULE_8_vue___default.a.set(this, 'paymentMethods', result);
      }
    },
    getTopCategories: function getTopCategories() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/topcategory', 'GET', data, function (response) {
        if (response.status === true) {
          _this4.topCategories = response.data;
        }
      });
    },
    getSections: function getSections() {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/sections', 'GET', data, function (response) {
        if (response.status === true) {
          _this5.sections = response.data;
        }
      });
    },
    startDownload: function startDownload() {
      this.loading = true;
    },
    finishDownload: function finishDownload() {
      this.loading = false;
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '05:00';
      }
      if (!this.valid_to) {
        this.valid_to = '05:00';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (this.loading) {
        return;
      }
      if (query.type === 'page') this.getOrders(query, { fetchVat: false });
      if (query.type === 'size') this.getOrders(query, { fetchVat: false });
      if (query.type === 'sort') this.getOrders(query, { fetchVat: false });
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    renderHeaderWithTotal: function renderHeaderWithTotal(h, label, total) {
      return h('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: '100%',
          textAlign: 'center',
          padding: '4px',
          boxSizing: 'border-box',
          justifyContent: 'space-between',
          overflow: 'visible'
        }
      }, [h('div', {
        style: {
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          hyphens: 'auto',
          whiteSpace: 'normal',
          lineHeight: '1.2',
          minWidth: '0'
        }
      }, label), h('div', {
        style: {
          display: 'flex',
          justifyContent: 'center',
          marginTop: '4px'
        }
      }, [h('span', {
        style: {
          background: '#674BD2',
          color: '#fff',
          borderRadius: '5px',
          padding: '2px 6px',
          fontWeight: 'bold',
          fontSize: '12px',
          lineHeight: '1',
          whiteSpace: 'nowrap',
          display: 'inline-block'
        }
      }, total)])]);
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    isUnpaidSelected: function isUnpaidSelected() {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return false;
      }

      return this.selected_payment_methods.some(function (method) {
        var id = typeof method === 'string' ? method : method && method.id;
        return id === 'unpaid';
      });
    },
    getPaymentMethodsArray: function getPaymentMethodsArray() {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return [];
      }

      return this.selected_payment_methods.map(function (method) {
        return typeof method === 'string' ? method : method && method.id ? method.id : null;
      }).filter(function (method) {
        return method && method !== 'unpaid';
      });
    },
    getOrders: function getOrders(query) {
      var _this6 = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$fetchVat = _ref.fetchVat,
          fetchVat = _ref$fetchVat === undefined ? false : _ref$fetchVat;

      if (!this.isMasterReport) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        date_column: this.date_column,
        order_id: this.orderId,
        selected_payment_methods: this.getPaymentMethodsArray(),
        unpaid_orders: this.isUnpaidSelected() ? 1 : 0,
        operator: this.selectedPosUser,
        zet: this.zet
      };

      if (this.topCategoryId) {
        var result = this.topCategoryId.map(function (elem) {
          return elem.id;
        });
        data.top_category_id = result;
      }

      if (this.sectionId) {
        var _result = this.sectionId.map(function (elem) {
          return elem.id;
        });
        data.section_id = _result;
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      if (fetchVat) {
        this.vatLoading = true;
      }
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      var hasReceiptValue = this.hasRceipt && this.hasRceipt.value || null;

      var masterEndpoint = this.useFromColumns ? '/reports/v2/master-report-from-columns' : '/reports/v2/master-report';
      var masterUrl = masterEndpoint + '?page=' + page + '&perPage=' + pageSize + '&has_receipt=' + hasReceiptValue;

      this.apiRequest(masterUrl, 'GET', data, function (response) {
        var masterSuccess = !!(response && response.status);
        if (masterSuccess) {
          try {
            _this6.productsTableData = _this6.mapMasterReportRows(response.data);
            var pag = response.pagination || {};
            _this6.totalOrders = pag.total;
            _this6.paginationProps.currentPage = pag.page;
            _this6.paginationProps.pageSize = pag.perPage;
            _this6.productsTableDataTotals = response.totals || {};

            var apiTotal = response.card_totals && response.card_totals.total_amount || response.total_gross_price;

            if (apiTotal !== undefined && apiTotal !== null) {
              _this6.totalSum = parseFloat(apiTotal) || 0;
            } else {
              var t = _this6.productsTableDataTotals;
              _this6.totalSum = Number(t.total_collected || 0) + Number(t.total_order_shipping || 0) + Number(t.total_order_tips || 0) - Number(t.total_order_discount || 0) - Number(t.total_order_loyalty_points_discount || 0);
            }
          } catch (e) {
            __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()('', _this6.$t('validations.wentWrong'), 'error');
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()('', response && response.errors && response.errors['id'] ? response.errors['id'] : _this6.$t('validations.wentWrong'), 'error');
        }
        _this6.$nextTick(function () {
          _this6.loading = false;
          _this6.syncMasterReportTableLayout();
        });
      });

      if (fetchVat) {
        this.apiRequest('/reports/v2/master-report-vat-totals-by-section', 'GET', data, function (vatResponse) {
          if (vatResponse && vatResponse.status) {
            _this6.vat_totals_by_section = vatResponse.vat_totals_by_section || vatResponse.data || {};
            _this6.vatSectionDisplay = _this6.buildVatSectionDisplay(_this6.vat_totals_by_section);
          } else {
            _this6.vat_totals_by_section = {};
            _this6.vatSectionDisplay = [];
          }
          _this6.$nextTick(function () {
            _this6.vatLoading = false;
          });
        });
      }
    },
    updateData: function updateData() {
      if (this.loading) {
        return;
      }
      this.getOrders(null, { fetchVat: true });
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    exportData: function exportData() {
      var _this7 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        date_column: this.date_column,
        order_id: this.orderId,
        selected_payment_methods: this.getPaymentMethodsArray(),
        unpaid_orders: this.isUnpaidSelected() ? 1 : 0,
        operator: this.selectedPosUser,
        pageSize: this.paginationProps.pageSize,
        page: this.paginationProps.currentPage,
        has_receipt: this.hasRceipt && this.hasRceipt.value || null,
        zet: this.zet
      };

      if (this.topCategoryId) {
        var result = this.topCategoryId.map(function (elem) {
          return elem.id;
        });
        data.top_category_id = result;
      }

      if (this.sectionId) {
        var _result2 = this.sectionId.map(function (elem) {
          return elem.id;
        });
        data.section_id = _result2;
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      var downloadEndpoint = this.useFromColumns ? '/reports/v2/master-report-from-columns-download' : '/reports/v2/master-report-download';
      this.apiRequest(downloadEndpoint, 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()('', _this7.$t('validations.wentWrong'), 'error');
        }
        _this7.loading = false;
      });
    },
    exportVatTotalsPdf: function exportVatTotalsPdf() {
      if (this.loading) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var params = new URLSearchParams();
      params.append('token', this.$session.get('token'));
      params.append('company_id', this.$session.get('selectedCompany'));
      params.append('lang', this.$i18n.locale || 'ro');
      params.append('from_date', fromDate);
      params.append('to_date', toDate);
      params.append('date_column', this.date_column);
      if (this.orderId) params.append('order_id', this.orderId);
      if (this.zet) params.append('zet', this.zet);
      params.append('unpaid_orders', this.isUnpaidSelected() ? 1 : 0);
      var hasReceipt = this.hasRceipt && this.hasRceipt.value || null;
      if (hasReceipt != null) params.append('has_receipt', hasReceipt);

      var paymentMethods = this.getPaymentMethodsArray();
      paymentMethods.forEach(function (id) {
        return params.append('selected_payment_methods', id);
      });

      if (this.topCategoryId && this.topCategoryId.length) {
        this.topCategoryId.forEach(function (elem) {
          return params.append('top_category_id', elem.id);
        });
      }
      if (this.sectionId && this.sectionId.length) {
        this.sectionId.forEach(function (elem) {
          return params.append('section_id', elem.id);
        });
      }
      if (this.orders.location && this.orders.location !== '') {
        params.append('location_id', this.orders.location);
      }

      var baseUrl = "https://gatewaydev.taptasty.com/".replace(/\/$/, '');
      var url = baseUrl + '/reports/v2/vat-totals-pdf?' + params.toString();

      window.open(url, '_blank');
    },
    getPosUsers: function getPosUsers() {
      var _this8 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this8.posUsers = response.data.pos_user;
        }
      });
    },
    getSectionName: function getSectionName(sectionId) {
      if (sectionId === null || isNaN(sectionId)) {
        return this.$t('general.unset');
      }
      var section = this.sections.find(function (s) {
        return s.id === sectionId;
      });
      return section ? section.name : 'Section ' + sectionId;
    },
    syncMasterReportTableLayout: function syncMasterReportTableLayout() {
      var _this9 = this;

      this.$nextTick(function () {
        var table = _this9.$refs.reportsTable && _this9.$refs.reportsTable.$refs.elTable;
        if (!table || typeof table.doLayout !== 'function') {
          return;
        }
        table.doLayout();
        requestAnimationFrame(function () {
          table.doLayout();
        });
      });
    }
  }
});

/***/ }),

/***/ "a5L6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LocationForm_vue__ = __webpack_require__("Oz8n");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LocationEditWolt',
  components: {
    LocationForm: __WEBPACK_IMPORTED_MODULE_0__LocationForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      route: null
    };
  },
  created: function created() {
    var locationId = this.$route.params.id;

    this.route = {
      params: {
        id: locationId
      }
    };

    console.log('Wolt Location Edit page loaded with ID:', locationId);

    this.$bus.$on('close-modal', this.handleBackButton);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('close-modal', this.handleBackButton);
  },

  methods: {
    handleBackButton: function handleBackButton() {
      this.$router.push('/settings/locations');
    }
  }
});

/***/ }),

/***/ "a5PJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLabeling_vue__ = __webpack_require__("/ZwV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525bedb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserLabeling_vue__ = __webpack_require__("DxqD");
function injectStyle (ssrContext) {
  __webpack_require__("qQIF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLabeling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525bedb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserLabeling_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a5a3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])]),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-md-offset-1 col-md-10"},[_c('h4',{staticClass:"purple text-center msub-page__title"},[_vm._v("\n        "+_vm._s(_vm.subscription ? _vm.subscription.name : _vm.$t('menuSubscriptions.newTitle'))+"\n      ")]),_vm._v(" "),(_vm.subscription && _vm.subscription.issues && _vm.subscription.issues.length)?_c('div',{staticClass:"msub-page__issues"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v("\n        "+_vm._s(_vm.$t('menuSubscriptions.notReady'))+": "+_vm._s(_vm.issuesText(_vm.subscription.issues))+"\n      ")]):(_vm.subscription)?_c('div',{staticClass:"msub-page__ready"},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v("\n        "+_vm._s(_vm.subscription.active ? _vm.$t('menuSubscriptions.readyActive') : _vm.$t('menuSubscriptions.readyInactive'))+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"msub-tabs"},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.key,staticClass:"btn msub-tabs__btn",class:{ 'is-active': _vm.currentTab === tab.key },attrs:{"disabled":tab.needsId && !_vm.subscriptionId,"title":tab.needsId && !_vm.subscriptionId ? _vm.$t('menuSubscriptions.saveFirst') : ''},on:{"click":function($event){_vm.currentTab = tab.key}}},[_c('i',{class:tab.icon}),_vm._v(" "+_vm._s(_vm.$t(tab.label))+"\n        ")])})),_vm._v(" "),_c('menu-subscription-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTab === 'general' || _vm.currentTab === 'delivery'),expression:"currentTab === 'general' || currentTab === 'delivery'"}],attrs:{"subscription-id":_vm.subscriptionId,"section":_vm.currentTab === 'delivery' ? 'delivery' : 'general'},on:{"loaded":_vm.onLoaded,"saved":_vm.onSaved}}),_vm._v(" "),(_vm.subscriptionId && _vm.subscription && _vm.currentTab === 'menus')?_c('menu-subscription-menus',{attrs:{"subscription":_vm.subscription,"assign-dates":_vm.pendingAssignDates},on:{"changed":_vm.reloadSubscription,"assigned":_vm.onAssigned}}):_vm._e(),_vm._v(" "),(_vm.subscriptionId && _vm.subscription && _vm.currentTab === 'calendar')?_c('menu-subscription-calendar',{attrs:{"subscription":_vm.subscription},on:{"new-menu-for-dates":_vm.onNewMenuForDates}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a6JB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__ = __webpack_require__("Ark/");






var _components;









/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */],
    SearchableMultiSelect: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isTopCategories: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isTopCategories: function isTopCategories() {
      if (this.isTopCategories) {
        this.getOrders();
        this.verifyUserLocations();
        this.verifyUserMethods();
      }
    }
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      selectedCategories: [],
      selectedTopCategories: [],
      ordersTableData: {},
      topProductSales: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '500px',
          axisX: {
            scaleMinSpace: 50,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_8_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      legendItems: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      colors: ['#f44336', '#2196f3', '#ff9800', '#9c27b0', '#00bcd4', '#8bc34a', '#ffc107', '#3f51b5', '#ff5722', '#795548', '#607d8b', '#009688', '#cddc39', '#673ab7', '#03a9f4', '#aed581', '#ffb74d', '#ba68c8'],
      noData: false
    };
  },

  methods: {
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        console.log(allowedLocations);
        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this = this;

      if (!this.isTopCategories) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;

      if (this.selectedCategories && this.selectedCategories.length) {
        data.categories = this.selectedCategories.map(function (table) {
          return table.id;
        });
      }

      if (this.selectedTopCategories && this.selectedTopCategories.length) {
        data.top_categories = this.selectedTopCategories.map(function (table) {
          return table.id;
        });
      }

      this.apiRequest('/reports/v2/top-categories' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          if (response.data.table_data.length) {
            _this.ordersTableData.data = response.data.table_data;
            _this.ordersTableData.total = response.pagination.total;
            _this.paginationProps.currentPage = response.pagination.page;
            _this.paginationProps.pageSize = response.pagination.perPage;
          } else {
            _this.ordersTableData.data = [];
            _this.ordersTableData.total = 0;
          }

          _this.topProductSales.options.chartPadding = {
            top: 30,
            right: 10,
            bottom: 20,
            left: 40
          };

          if (!response.data.products.length) {
            _this.$nextTick(function () {
              _this.topProductSales.data.labels = [];
              _this.topProductSales.data.series = [[]];
              _this.discounts = [];
              _this.noData = true;

              if (_this.$refs.topProductSales.chart) {
                _this.$refs.topProductSales.initChartAndReturn();
              }

              return false;
            });
          }

          var baseLabels = [];
          var salesSeries = [];
          var discountsSeries = [];

          response.data.products.forEach(function (product, index) {
            baseLabels.push(product);
            salesSeries.push(response.data.sales[index] || 0);
            discountsSeries.push(response.data.discounts[index] || 0);
          });

          _this.topProductSales.data.labels = baseLabels;
          _this.topProductSales.data.series = [salesSeries, discountsSeries];

          _this.discounts = response.data.discounts;

          _this.legendItems = _this.topProductSales.data.labels.map(function (product, index) {
            var baseColor = _this.colors[index % _this.colors.length];
            return {
              product: product,
              sales: {
                label: product + ' - ' + _this.topProductSales.data.series[0][index],
                color: baseColor
              },
              discount: {
                label: 'Discount ' + product + ' - ' + (_this.topProductSales.data.series[1][index] || 0),
                color: _this.lightenHexColor(baseColor, 40)
              }
            };
          });

          _this.noData = false;
          _this.topProductSales.data.labels = response.data.products;
          _this.topProductSales.data.series = [response.data.sales];
          _this.discounts = response.data.discounts;

          _this.$nextTick(function () {
            _this.$refs.topProductSales.initChartAndReturn();

            if (_this.$refs.topProductSales.chart) {
              _this.$refs.topProductSales.chart.on('draw', function (data) {
                if (data.type === 'bar') {
                  var productIndex = data.index;
                  var isDiscount = data.seriesIndex === 1;
                  var baseColor = _this.colors[productIndex % _this.colors.length];
                  var color = isDiscount ? _this.lightenHexColor(baseColor, 40) : baseColor;

                  data.element.attr({
                    style: 'stroke: ' + color + '; stroke-width: 30px;'
                  });
                }
              });
            }
          });
        } else {
          _this.topProductSales.data.labels = [];
          _this.topProductSales.data.series = [[]];
          _this.discounts = [];
          _this.noData = true;

          if (_this.$refs.topProductSales.chart) {
            _this.$refs.topProductSales.initChartAndReturn();
          }

          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    lightenHexColor: function lightenHexColor(hex, percent) {
      var num = parseInt(hex.replace('#', ''), 16);
      var amt = Math.round(2.55 * percent);
      var R = (num >> 16) + amt;
      var G = (num >> 8 & 0x00FF) + amt;
      var B = (num & 0x0000FF) + amt;

      return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    exportData: function exportData() {
      var _this2 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/top-categories-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
        }
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "a92Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('error'))+"\n        ")]),_vm._v(" "),_c('P',[_vm._v(_vm._s(_vm.$t('vat.generalTaxes')))]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.name')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.taxes),function(tax_rate){return _c('tr',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.id),expression:"tax_rate.id"}],attrs:{"type":"hidden","name":'tax_rate'+tax_rate.id},domProps:{"value":(tax_rate.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax_rate, "id", $event.target.value)}}}),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(tax_rate.name),expression:"tax_rate.name"}],staticClass:"form-control",attrs:{"type":"text","min":"0","name":'name'+tax_rate.id},domProps:{"value":(tax_rate.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax_rate, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has(tax_rate.hash_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError(tax_rate.hash_id))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();_vm.deleteTax(tax_rate.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.remove'))+"\n                ")])])])}),_vm._v(" "),[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn add pull-right",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingTaxes.singleTaxLabel')},on:{"click":function($event){$event.preventDefault();_vm.addNewTax()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('general.add'))+"\n                  ")])])])]],2),_vm._v(" "),_c('tfoot')])],1)]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('error'))+"\n        ")]),_vm._v(" "),_c('P',[_vm._v(_vm._s(_vm.$t('catalogCateg.vat'))+" ("+_vm._s(_vm.$t('catalogCateg.included'))+")")]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.name')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.vat),function(tax_rate){return _c('tr',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(tax_rate.id),expression:"tax_rate.id"}],attrs:{"type":"hidden","name":'tax_rate'+tax_rate.id},domProps:{"value":(tax_rate.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax_rate, "id", $event.target.value)}}}),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(tax_rate.name),expression:"tax_rate.name"}],staticClass:"form-control",attrs:{"type":"text","min":"0","name":'name'+tax_rate.id},domProps:{"value":(tax_rate.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax_rate, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has(tax_rate.hash_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError(tax_rate.hash_id))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();_vm.deleteTax(tax_rate.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.remove'))+"\n                ")])])])}),_vm._v(" "),[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn add pull-right",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingTaxes.singleTaxLabel')},on:{"click":function($event){$event.preventDefault();_vm.addNewVat()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('general.add'))+"\n                  ")])])])]],2),_vm._v(" "),_c('tfoot')])],1)])]),_vm._v(" "),_c('div',{staticClass:"company-details"},[_c('div',{staticClass:"card pad-bt-15"},[_c('div',{staticClass:"row display-flex"},[_c('div',{staticClass:"card-content align-items-center mb-0 col-md-12 mar-lt-15 help-block warning"},[_c('span',{staticClass:"relative-top"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('settingTaxes.notice'))+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goToCompanyLocations()}}},[_vm._v(_vm._s(_vm.$t('settingCompany.generateQrMenuSettings'))+".")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aA1u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isBlocked)?_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save save-draft",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","disabled":_vm.loading,"title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('gestiune.saveDraft'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.state === 'VALIDATED' && _vm.isBlocked)?_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","disabled":_vm.loading,"title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();_vm.saveInventar(true)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('gestiune.revalidated'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.isInEdit && !_vm.isBlocked)?_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","disabled":_vm.loading,"title":_vm.$t('general.save')},on:{"click":function($event){_vm.saveInventar(true)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('gestiune.saveAndValidate'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.state !== 'VALIDATED')?_c('button',{staticClass:"btn btn-icon btn-warning mar-rt-10",staticStyle:{"margin-bottom":"0"},attrs:{"type":"button","disabled":_vm.loading,"title":_vm.$t('gestiune.updateStockScriptic')},on:{"click":function($event){$event.preventDefault();return _vm.updateStockScriptic($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('gestiune.updateStockScriptic'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.state !== 'VALIDATED')?_c('button',{staticClass:"btn btn-icon btn-xls-slim",staticStyle:{"margin-bottom":"0"},attrs:{"type":"button","disabled":_vm.loading,"title":_vm.$t('gestiune.printInventorySheet')},on:{"click":function($event){$event.preventDefault();return _vm.onPrintInventory($event)}}},[_c('img',{attrs:{"src":"/static/img/export_xls.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('gestiune.printInventorySheet'))+"\n          ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.inventar')))])]),_vm._v(" "),(_vm.state === 'DRAFT')?_c('div',{staticClass:"alert alert-warning note-draft"},[_c('strong',[_vm._v("ℹ️ Notă informativă:")]),_c('br'),_vm._v("\n        Acest inventar este în status "),_c('b',[_vm._v("DRAFT")]),_vm._v(".\n        Mișcările de stoc "),_c('b',[_vm._v("nu vor apărea")]),_vm._v(" în rapoarte cât timp inventarul este în acest status.\n        Folosește butonul "),_c('b',[_vm._v("„Salvează și validează”")]),_vm._v(" pentru a trece inventarul în status "),_c('b',[_vm._v("VALIDAT")]),_vm._v(", moment în care mișcările de stoc vor fi incluse în raport.\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[(_vm.groupedLocations)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.location),expression:"modelValidate.location"}],staticClass:"form-control",attrs:{"disabled":_vm.loading || _vm.isInEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                    "+_vm._s(loc.name)+"\n                  ")])}))})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.gestiune),expression:"modelValidate.gestiune"}],attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading || _vm.isInEdit},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"inventoryNumber"}},[_vm._v(_vm._s(_vm.$t('invoice.seriesNumber')))]),_vm._v(" "),_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.serie),expression:"modelValidate.serie"}],attrs:{"options":_vm.inventoryNumberOptions,"disabled":_vm.isInEdit},on:{"change":_vm.handleSerieChange},model:{value:(_vm.inventoryNumber),callback:function ($$v) {_vm.inventoryNumber=$$v},expression:"inventoryNumber"}},_vm._l((_vm.seriesOptionsWithAdd),function(item){return _c('el-option',{key:item._id,attrs:{"label":item.label,"value":item._id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.date')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.date),expression:"modelValidate.date"},{name:"model",rawName:"v-model",value:(_vm.inventoryDate),expression:"inventoryDate"}],staticClass:"form-control",attrs:{"type":"datetime-local","disabled":_vm.isBlocked,"max":_vm.today},domProps:{"value":(_vm.inventoryDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inventoryDate=$event.target.value}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Filtreaza produsele dupa categorie:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategory),expression:"selectedCategory"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.filterProducts]}},[_c('option',{domProps:{"value":null}},[_vm._v("-- Toate categoriile --")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat,domProps:{"value":cat}},[_vm._v("\n              "+_vm._s(cat)+"\n            ")])})],2)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('invoice.productName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.unitMeasure')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.stocScriptic')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.stocFaptic')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.difference')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.productsList),function(item,index){return [(item.is_hiden !== 1)?[_c('tr',{key:index,class:{ 'row-updated': item._updated }},[_c('td',[_vm._v(_vm._s(item.productDetails.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.productDetails.categorie))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.productDetails.um))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.quantity.toFixed(2)))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.stocFaptic),expression:"item.stocFaptic"}],staticClass:"form-control",attrs:{"type":"number","disabled":_vm.isBlocked,"min":"0"},domProps:{"value":(item.stocFaptic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "stocFaptic", $event.target.value)}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(((item.quantity - (item.stocFaptic != null ? item.stocFaptic : item.quantity)) * -1).toFixed(2)))])])]:_vm._e()]}),_vm._v(" "),(_vm.loading)?_c('tr',[_c('td',[_c('div',{staticClass:"loadingTableCenter"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])])])])]):_vm._e(),_vm._v(" "),(!_vm.isBlocked)?_c('tr',[_c('td',[_c('v-select',{attrs:{"options":_vm.searchResults,"label":"label","placeholder":"Caută un produs...","filterable":true},on:{"input":_vm.onProductSelect},model:{value:(_vm.searchProdName),callback:function ($$v) {_vm.searchProdName=$$v},expression:"searchProdName"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.unitMeasure),expression:"newItem.unitMeasure",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","disabled":true,"placeholder":"UM"},domProps:{"value":(_vm.newItem.unitMeasure)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "unitMeasure", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.quantity),expression:"newItem.quantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","disabled":true,"placeholder":"Stoc scriptic"},domProps:{"value":(_vm.newItem.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "quantity", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.stocFaptic),expression:"newItem.stocFaptic",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Stoc faptic"},domProps:{"value":(_vm.newItem.stocFaptic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "stocFaptic", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.addItem}},[_vm._v(_vm._s(_vm.$t('general.add')))])])]):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v("Comisia de Inventariere")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"presedinteleComisiei"}},[_vm._v("Președintele Comisiei")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.presedinte),expression:"extraFields.presedinte"}],staticClass:"form-control",attrs:{"type":"text","id":"presedinteleComisiei","disabled":_vm.isBlocked,"placeholder":"Numele președintelui comisiei"},domProps:{"value":(_vm.extraFields.presedinte)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "presedinte", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gestionar"}},[_vm._v("Gestionar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.gestionar),expression:"extraFields.gestionar"}],staticClass:"form-control",attrs:{"type":"text","id":"gestionar","disabled":_vm.isBlocked,"placeholder":"Numele gestionarului"},domProps:{"value":(_vm.extraFields.gestionar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "gestionar", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"notaInternaComisie"}},[_vm._v("Notă internă")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.nota),expression:"extraFields.nota"}],staticClass:"form-control",attrs:{"id":"notaInternaComisie","disabled":_vm.isBlocked,"placeholder":"Informații suplimentare"},domProps:{"value":(_vm.extraFields.nota)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "nota", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"comisiaDeInventariere"}},[_vm._v("Comisia de Inventariere")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.comisia),expression:"extraFields.comisia"}],staticClass:"form-control",attrs:{"type":"text","id":"comisiaDeInventariere","disabled":_vm.isBlocked,"placeholder":"Denumirea comisiei"},domProps:{"value":(_vm.extraFields.comisia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "comisia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"contabilitate"}},[_vm._v("Contabilitate")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.contabilitate),expression:"extraFields.contabilitate"}],staticClass:"form-control",attrs:{"type":"text","id":"contabilitate","disabled":_vm.isBlocked,"placeholder":"Detalii contabilitate"},domProps:{"value":(_vm.extraFields.contabilitate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "contabilitate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"notaInternaCompletare"}},[_vm._v("Notă internă (completare)")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.nota_completare),expression:"extraFields.nota_completare"}],staticClass:"form-control",attrs:{"id":"notaInternaCompletare","disabled":_vm.isBlocked,"placeholder":"Detalii suplimentare notă internă"},domProps:{"value":(_vm.extraFields.nota_completare)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "nota_completare", $event.target.value)}}})])])])])]),_vm._v(" "),_c('ManagementSeriesAdd',{attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations,"vat-number":_vm.selectedLocation ? _vm.selectedLocation.inv_fiscal_code : ''},on:{"getSeries":_vm.getSeries}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aAj7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedDepositLocationId: '',
      selectedLocationId: '',
      locations: [],
      gestiuneOptions: [],
      seriesOptions: [],
      searchResults: [],
      currencyOptions: [{ code: 'RON', name: 'Leu Românesc (RON)' }, { code: 'EUR', name: 'Euro (EUR)' }, { code: 'USD', name: 'Dolar American (USD)' }],
      myOrder: {
        date: new Date(),
        location_id: null,
        gestiune: null,
        serie: null,
        currency: 'RON',
        manager: '',
        receiver: '',
        internalNote: '',
        commandProject: ''
      },
      tableData: [],
      isProcess: false,
      items: [],
      newItem: {
        productName: null,
        code: '',
        unitMeasure: '',
        quantity_scriptic: 1,
        quantity_faptic: 0,
        pret_fara_tva: 0,
        tva_percent: 19,
        vatValue: 0
      }
    };
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.fetchLocation();
    this.fetchGestiuni();
  },

  watch: {
    selectedLocationId: function selectedLocationId(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;

            var _route$query = this.route.query,
                series = _route$query.series,
                number = _route$query.number,
                isProcess = _route$query.isProcess;

            this.isProcess = isProcess === 'true' || isProcess === true;

            if (series && number && this.isProcess && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code);
            }
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    locations: function locations(newLocations) {
      if (newLocations && newLocations.length) {
        var _route$query2 = this.route.query,
            series = _route$query2.series,
            number = _route$query2.number,
            isProcess = _route$query2.isProcess;

        this.isProcess = isProcess === 'true' || isProcess === true;
        if (series && number && this.isProcess) {
          this.fetchOrder(series, number);
        }
      }
    }
  },
  computed: {
    groupedLocations: function groupedLocations() {
      var groups = {};

      if (!this.locations || !this.locations.length) return [];

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    },
    locationsWithDepositGestiune: function locationsWithDepositGestiune() {
      if (!Array.isArray(this.gestiuneOptions) || !this.gestiuneOptions.length || !Array.isArray(this.locations) || !this.locations.length) {
        return [];
      }

      var locationIdsFromDepositGestiuni = this.gestiuneOptions.filter(function (g) {
        return g.is_depozit === true;
      }).map(function (g) {
        return g.externalLocationId;
      });

      return this.locations.filter(function (loc) {
        return locationIdsFromDepositGestiuni.includes(loc.true_id);
      });
    },
    gestiuniForSelectedDepositLocation: function gestiuniForSelectedDepositLocation() {
      var _this = this;

      if (!this.selectedDepositLocationId) return [];
      return this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedDepositLocationId;
      });
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this2 = this;

      if (!this.selectedLocationId) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this2.selectedLocationId;
      });
      return result;
    }
  },
  methods: {
    resetNewItem: function resetNewItem() {
      this.newItem = {
        productName: null,
        code: '',
        unitMeasure: '',
        quantity_scriptic: 0,
        quantity_faptic: 0,
        pret_fara_tva: 0,
        tva_percent: 19,
        vatValue: 0
      };
    },
    calculateVatValue: function calculateVatValue(item) {
      var quantity = parseFloat(item.quantity_scriptic) || 0;
      var price = parseFloat(item.pret_fara_tva) || 0;
      var percent = parseFloat(item.tva_percent) || 0;
      var vat = quantity * price * percent / 100;
      return Number(vat.toFixed(2));
    },
    updateVatValue: function updateVatValue(item) {
      item.vatValue = this.calculateVatValue(item);
    },
    addItem: function addItem() {
      var item = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.newItem, {
        vatValue: this.calculateVatValue(this.newItem)
      });
      this.items.push(item);
      this.resetNewItem();
    },
    removeItem: function removeItem(index) {
      this.items.splice(index, 1);
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this3.selectedLocation || !searchTerm || searchTerm.length < 2)) {
                  _context.next = 3;
                  break;
                }

                _this3.searchResults = [];
                return _context.abrupt('return');

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/products?vatNumber=' + _this3.selectedLocation.inv_fiscal_code + '&name=' + encodeURIComponent(searchTerm) + '&externalCompanyId=' + _this3.companyID);

              case 6:
                response = _context.sent;
                _context.next = 9;
                return response.json();

              case 9:
                data = _context.sent;


                if (Array.isArray(data.products)) {
                  _this3.searchResults = data.products;
                } else {
                  _this3.searchResults = [];
                }
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](3);

                console.error('Error fetching products:', _context.t0);
                _this3.searchResults = [];

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[3, 13]]);
      }))();
    },
    onProductSelected: function onProductSelected(product) {
      if (product && (typeof product === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(product)) === 'object') {
        this.newItem.productName = product.name || '';
        this.newItem.code = product.product_code || '';
        this.newItem.unitMeasure = product.um || '';
        this.newItem.tva_percent = product.vat_percent || 0;
        this.newItem.pret_fara_tva = Array.isArray(product.pret_vanzare) && product.pret_vanzare.length > 0 ? product.pret_vanzare[0].price : 0;
      }
    },
    fetchLocation: function fetchLocation() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dataToSend = {
                  company_id: _this4.companyID,
                  token: _this4.$session.get('token')
                };


                _this4.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this4.locations = response.data.locations;
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this5.companyID);

              case 3:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context3.next = 8;
                return response.json();

              case 8:
                data = _context3.sent;

                console.log('Date primite de la server:', data.gestiuni);
                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this5.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      externalLocationId: gest.externalLocationId || null,
                      is_depozit: gest.is_depozit || false
                    };
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                    title: 'Error!',
                    text: 'Nu s-a primit un array valid de la server.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context3.next = 17;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](0);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Error!',
                  text: 'Request failed: ' + _context3.t0.message,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching management data:', _context3.t0);

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 13]]);
      }))();
    },
    getSeries: function getSeries(vatNumber) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this6.companyID,
                    vatNumber: vatNumber,
                    tip: 'order'
                  })
                });

              case 3:
                response = _context4.sent;

                if (response.ok) {
                  _context4.next = 6;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 6:
                _context4.next = 8;
                return response.json();

              case 8:
                data = _context4.sent;

                console.log('Serii primite:', data.series);

                if (Array.isArray(data.series)) {
                  _this6.seriesOptions = data.series.map(function (serie) {
                    return {
                      id: serie._id,
                      name: serie.series,
                      currentNumber: serie.currentNumber
                    };
                  });
                } else {
                  console.error('Format invalid pentru series:', data);
                }
                _context4.next = 16;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](0);

                console.error('Error fetching series:', _context4.t0);

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 13]]);
      }))();
    },
    saveMyOrder: function saveMyOrder() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var missingGestiune, selectedSerie, serieName, nextNumber, status, myOrderData, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                missingGestiune = _this7.items.some(function (item) {
                  return !item.gestiune;
                });

                if (!missingGestiune) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Atenție',
                  text: 'Toate produsele trebuie să aibă selectată o gestiune înainte de a salva comanda.',
                  icon: 'warning',
                  timer: 2000,
                  showConfirmButton: true
                });

              case 4:
                return _context5.abrupt('return');

              case 5:
                selectedSerie = _this7.seriesOptions.find(function (serie) {
                  return serie.id === _this7.myOrder.serie || serie.name === _this7.myOrder.serie;
                });
                serieName = selectedSerie ? selectedSerie.name : _this7.myOrder.serie || null;
                nextNumber = _this7.myOrder.currentNumber || 1;
                status = 'new';

                if (_this7.isProcess) status = 'processed';

                myOrderData = {
                  status: status,
                  products: _this7.items,
                  externalLocationId: _this7.selectedLocation.true_id,
                  vatNumber: _this7.selectedLocation.inv_fiscal_code,
                  externalCompanyId: _this7.companyID,
                  supplierExternalLocationId: _this7.myOrder.supplierExternalLocationId,
                  supplierVatNumber: _this7.myOrder.supplierVatNumber,
                  gestiune: _this7.myOrder.gestiune || null,
                  series: serieName,
                  number: nextNumber,
                  date: _this7.myOrder.date ? new Date(_this7.myOrder.date).toISOString() : new Date().toISOString()
                };
                _context5.prev = 11;
                _context5.next = 14;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/order', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(myOrderData)
                });

              case 14:
                response = _context5.sent;
                _context5.next = 17;
                return response.json();

              case 17:
                data = _context5.sent;


                if (response.ok) {
                  console.log('Comanda salvată cu succes!', data);

                  __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                    title: 'Succes',
                    text: 'Comanda a fost salvată cu succes!',
                    type: 'success',
                    timer: 1500,
                    showConfirmButton: false
                  });

                  _this7.$bus.$emit('refresh');
                  _this7.$bus.$emit('close-modal');
                } else {
                  console.error('Eroare la salvarea comenzii', data);

                  __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                    title: 'Eroare',
                    text: 'A apărut o eroare la salvarea comenzii.',
                    type: 'error',
                    timer: 1500,
                    showConfirmButton: false
                  });
                }
                _context5.next = 25;
                break;

              case 21:
                _context5.prev = 21;
                _context5.t0 = _context5['catch'](11);

                console.error('Eroare la trimiterea cererii', _context5.t0);

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o problemă la trimiterea cererii.',
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                });

              case 25:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[11, 21]]);
      }))();
    },
    openAddProductModal: function openAddProductModal() {
      this.$modal.show('addProductModal');
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    fetchOrder: function fetchOrder(series, number) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response, data, order, foundLocation, foundDepositLocation;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/order?series=' + series + '&number=' + number + '&externalCompanyId=' + _this8.companyID);

              case 3:
                response = _context6.sent;

                if (response.ok) {
                  _context6.next = 6;
                  break;
                }

                throw new Error('Eroare la fetch order: ' + response.status);

              case 6:
                _context6.next = 8;
                return response.json();

              case 8:
                data = _context6.sent;


                console.log('Comandă primită:', data);

                if (data && data) {
                  order = data;


                  _this8.myOrder.location_id = order.externalLocationId || null;
                  _this8.myOrder.gestiune = order.gestiune || null;
                  _this8.myOrder.serie = order.series || null;
                  _this8.myOrder.currentNumber = order.number || null;
                  _this8.myOrder.supplierVatNumber = order.supplierVatNumber || '';
                  _this8.myOrder.supplierExternalLocationId = order.supplierExternalLocationId || null;

                  _this8.items = order.products || [];

                  if (order.externalLocationId && _this8.locations && _this8.locations.length) {
                    foundLocation = _this8.locations.find(function (loc) {
                      return loc.true_id === order.externalLocationId;
                    });

                    if (!foundLocation && order.vatNumber) {
                      foundLocation = _this8.locations.find(function (loc) {
                        return loc.inv_fiscal_code === order.vatNumber;
                      });
                    }

                    if (foundLocation) {
                      _this8.selectedLocationId = foundLocation.true_id;
                    }
                  }

                  if (order.supplierExternalLocationId && _this8.locationsWithDepositGestiune && _this8.locationsWithDepositGestiune.length) {
                    foundDepositLocation = _this8.locationsWithDepositGestiune.find(function (loc) {
                      return loc.true_id === order.supplierExternalLocationId;
                    });


                    if (foundDepositLocation) {
                      _this8.selectedDepositLocationId = foundDepositLocation.true_id;
                    }
                  }
                } else {
                  console.error('Comandă invalidă primită:', data);
                  __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                    title: 'Eroare',
                    text: 'Comanda nu a fost găsită.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context6.next = 17;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6['catch'](0);

                console.error('Eroare la fetch order:', _context6.t0);
                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o problemă la încărcarea comenzii.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 13]]);
      }))();
    }
  }
});

/***/ }),

/***/ "aAvn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aBe/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aBwl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r2_vue__ = __webpack_require__("1jC5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba6e0b4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r2_vue__ = __webpack_require__("aXm7");
function injectStyle (ssrContext) {
  __webpack_require__("3RFX")
  __webpack_require__("q7Nh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba6e0b4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba6e0b4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aCDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "aDuw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {}
});

/***/ }),

/***/ "aEZk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-report"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"picker noprint"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions1},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('div',{staticClass:"btn btn-icon btn-info btn-search mar-rt-10 mar-lt-10",on:{"click":_vm.getData}},[_c('i',{staticClass:"ti-search"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-print",on:{"click":_vm.print}},[_c('img',{attrs:{"src":"/static/img/icons/print-a4.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('orders.print'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info mar-lt-10 noprint btn-print",on:{"click":function($event){$event.preventDefault();return _vm.printToIframe($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/print-a4.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('orders.print2'))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"btn btn-icon btn-xls mar-lt-20",attrs:{"title":_vm.$t('reports.export')},on:{"click":_vm.downloadReport}},[_vm._v("\n            "+_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.orders)?_c('div',{staticClass:"orders"},_vm._l((_vm.orders),function(order){return _c('div',{staticClass:"order card"},[_c('div',{staticClass:"orderdet"},[_c('span',{staticStyle:{"text-align":"center","width":"100%","margin-top":"20px"}},[_vm._v(_vm._s(order.number)+" - "+_vm._s(order.id)+" - "+_vm._s(order.token))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._m(0,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.delivery_type))])]),_vm._v(" "),_c('p',[_vm._m(1,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.payment_type))])])]),_vm._v(" "),_c('div',{staticClass:"client"},[_vm._m(2,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.delivery_details_firstname))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.delivery_details_phone))])]),_vm._v(" "),(order.address_shipping)?_c('div',{staticClass:"adress"},[_vm._m(3,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.address_shipping.state))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.address_shipping.city))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.address_shipping.street)+" "+_vm._s(order.address_shipping.number)+", "+_vm._s(order.address_shipping.apartment))])]):_vm._e(),_vm._v(" "),(order.pickup_datetime)?_c('div',{staticClass:"date"},[_vm._m(4,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.pickup_datetime))])]):_vm._e(),_vm._v(" "),(order.created_at)?_c('div',{staticClass:"date"},[_vm._m(5,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.created_at))])]):_vm._e(),_vm._v(" "),(order.comments)?_c('div',{staticClass:"com"},[_vm._m(6,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.comments))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"parts"},_vm._l((order.parts),function(part){return _c('div',{staticClass:"part"},[(order.order_type == 'GROUP')?_c('span',[_vm._m(7,true),_vm._v(" "),_c('span',[_vm._v(_vm._s(part.customer_name))])]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table mar-to-25 mar-bt-15"},[_vm._m(8,true),_vm._v(" "),_c('tbody',_vm._l((part.items),function(prod){return _c('tr',{key:prod.id},[_c('td',[_c('span',[_vm._v(_vm._s(prod.name))]),_vm._v(" "),_c('div',{staticClass:"options"},[_vm._l((prod.options),function(option){return _c('div',{key:option.id,staticClass:"option"},[_vm._v("\n                            + "),_c('span',[_vm._v(_vm._s(option.name))]),_vm._v(" "),(option.price)?_c('span',[_vm._v(_vm._s(option.price)+" "+_vm._s(order.currency))]):_vm._e()])}),_vm._v(" "),(prod.additional_info)?[_vm._v("\n                            - "),_c('span',[_vm._v(_vm._s(prod.additional_info))])]:_vm._e()],2)]),_vm._v(" "),_c('td',[_vm._v(_vm._s(prod.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(prod.price))])])}))])])})),_vm._v(" "),_c('div',{staticClass:"total"},[_c('p',[_c('span',[_vm._v("Subtotal:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.totals_subtotals)+" "+_vm._s(order.currency))])]),_vm._v(" "),(order.totals_extras)?_c('p',[_c('span',[_vm._v("Extra:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.totals_extras)+" "+_vm._s(order.currency))])]):_vm._e(),_vm._v(" "),(order.totals_shipping)?_c('p',[_c('span',[_vm._v("Livrare:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.totals_shipping)+" "+_vm._s(order.currency))])]):_vm._e(),_vm._v(" "),(order.totals_discount)?_c('p',[_c('span',[_vm._v("Reducere:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.totals_discount)+" "+_vm._s(order.currency))])]):_vm._e(),_vm._v(" "),_c('p',[_c('span',[_vm._v("Total: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.totals_grandtotal)+" "+_vm._s(order.currency))])])]),_vm._v(" "),_c('span')])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"200px"}},[_c('h4',[_vm._v("Produsele Comandate")]),_vm._v(" "),_vm._l((_vm.products),function(product){return _c('div',{staticClass:"orders"},[_c('span',{staticClass:"product"},[_vm._v(_vm._s(product))])])})],2)])]),_vm._v(" "),_c('iframe',{staticStyle:{"display":"none"},attrs:{"id":"print-frame"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("Metoda:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("Plata:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("Client:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("Adresa:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("Data Livrare:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("Data Creare:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("Comentarii:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("Client:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Nume")]),_vm._v(" "),_c('th',[_vm._v("Cantitate")]),_vm._v(" "),_c('th',[_vm._v("Preț")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aGLL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aGup":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't12'
});

/***/ }),

/***/ "aK6o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aPmv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      allLocations: [],
      vatNumber: null,
      selectedLocation: null,
      isStoc: true
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getBons(this.selectedLocation, this.currentPage, this.pageSize);
    },
    onSearch: function onSearch() {
      if (!this.selectedLocation || Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        });

        this.tableData = [];
        this.totalItems = 0;

        return;
      }

      var locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation];

      this.getBons(locations);
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getBons(this.selectedLocation, this.currentPage, this.pageSize);
    },
    getGestiuneNameById: function getGestiuneNameById(id) {
      var gest = this.gestiuneOptions.find(function (g) {
        return g._id === id || g.id === id;
      });
      return gest ? gest.name : id;
    },
    openStoc: function openStoc() {
      this.isStoc = true;
      this.isBonTransfer = false;
    },
    addBonConsum: function addBonConsum() {
      this.$router.push('/management/stocks/add');
    },
    editBonConsum: function editBonConsum(row) {
      this.$router.push('/management/stocks/edit/' + row.series + '/' + row.documentNumber);
    },
    getBons: function getBons() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, ids, allLocations, _ids, response, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;

                params = new URLSearchParams({
                  externalCompanyId: _this.companyID,
                  tip: 'bon_consum'
                });


                params.append('page', page);
                params.append('limit', pageSize);

                if (location) {
                  if (Array.isArray(location)) {
                    ids = location.map(function (l) {
                      return l.true_id;
                    }).filter(Boolean);

                    ids.forEach(function (id) {
                      return params.append('externalLocationId', id);
                    });
                  } else if (location.id && location.true_id) {
                    params.append('externalLocationId', location.true_id);
                  }
                } else {
                  allLocations = _this.groupedLocations.flatMap(function (group) {
                    return group.locations;
                  });
                  _ids = allLocations.map(function (l) {
                    return l.true_id;
                  }).filter(Boolean);

                  _ids.forEach(function (id) {
                    return params.append('externalLocationId', id);
                  });
                }

                clearTimeout(_this.loadingTimeout);
                _this.loadingTimeout = setTimeout(function () {
                  _this.loading = true;
                }, 100);

                _context.next = 10;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/bons?' + params.toString(), {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 10:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 13;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 13:
                _context.next = 15;
                return response.json();

              case 15:
                data = _context.sent;


                if (Array.isArray(data.bons)) {
                  clearTimeout(_this.loadingTimeout);
                  _this.loading = false;

                  _this.totalItems = data.total || 0;
                  _this.currentPage = data.currentPage || page;
                  _this.pageSize = data.pageSize || pageSize;

                  _this.tableData = data.bons.map(function (bon) {
                    return {
                      _id: bon._id,
                      documentNumber: bon.documentNumber,
                      gestiune_from: bon.gestiune_from,
                      lot: bon.lot,
                      series: bon.series
                    };
                  });
                } else {
                  console.error('Nu s-au găsit bonuri valide.');
                  _this.tableData = [];
                }
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](0);

                clearTimeout(_this.loadingTimeout);
                _this.loading = false;

                console.error('Error fetching bons:', _context.t0);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 19]]);
      }))();
    },
    handleDeleteBonConsum: function handleDeleteBonConsum(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (id) {
                  _context3.next = 3;
                  break;
                }

                console.error('Missing Bon Consum ID for deletion.');
                return _context3.abrupt('return');

              case 3:

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: 'Ești sigur?',
                  text: 'Această acțiune va șterge definitiv bonul de consum!',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Da, șterge!',
                  cancelButtonText: 'Anulează'
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
                    var response, data;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!result) {
                              _context2.next = 19;
                              break;
                            }

                            _context2.prev = 1;
                            _context2.next = 4;
                            return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                              method: 'DELETE',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                type: 'bon_consum',
                                id: id,
                                externalCompanyId: _this2.companyID
                              })
                            });

                          case 4:
                            response = _context2.sent;

                            if (response.ok) {
                              _context2.next = 7;
                              break;
                            }

                            throw new Error('HTTP error! Status: ' + response.status);

                          case 7:
                            _context2.next = 9;
                            return response.json();

                          case 9:
                            data = _context2.sent;

                            console.log('Bon consum deleted successfully:', data);

                            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                              title: 'Succes!',
                              text: 'Bon consum șters cu succes.',
                              type: 'success',
                              timer: 2000,
                              showConfirmButton: false
                            });

                            _this2.getBons();
                            _context2.next = 19;
                            break;

                          case 15:
                            _context2.prev = 15;
                            _context2.t0 = _context2['catch'](1);

                            console.error('Error deleting Bon Consum:', _context2.t0);

                            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                              title: 'Eroare!',
                              text: 'A apărut o problemă la ștergerea bonului de consum.',
                              type: 'error',
                              timer: 2000,
                              showConfirmButton: false
                            });

                          case 19:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2, [[1, 15]]);
                  }));

                  return function (_x4) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    downloadExcel: function downloadExcel(row) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var type, series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                type = 'bon_consum';
                series = row.series;
                invoiceNumber = row.documentNumber;
                externalCompanyId = _this3.companyID;

                if (!(!type || !series || !invoiceNumber || !externalCompanyId)) {
                  _context4.next = 7;
                  break;
                }

                alert('Missing type, series, invoice number or company ID.');
                return _context4.abrupt('return');

              case 7:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/' + type + '/' + series + '-' + invoiceNumber + '/xls?externalCompanyId=' + externalCompanyId;
                _context4.prev = 8;
                _context4.next = 11;
                return fetch(url);

              case 11:
                response = _context4.sent;

                if (!response.ok) {
                  _context4.next = 23;
                  break;
                }

                _context4.next = 15;
                return response.blob();

              case 15:
                blob = _context4.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = type + '-' + series + '-' + invoiceNumber + '.xls';
                link.click();
                URL.revokeObjectURL(link.href);
                _context4.next = 24;
                break;

              case 23:
                console.error('Error downloading document:', response.statusText);

              case 24:
                _context4.next = 29;
                break;

              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4['catch'](8);

                console.error('Error fetching document:', _context4.t0);

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[8, 26]]);
      }))();
    },
    download: function download(row) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var type, series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                type = 'bon_consum';
                series = row.series;
                invoiceNumber = row.documentNumber;
                externalCompanyId = _this4.companyID;

                if (!(!type || !series || !invoiceNumber || !externalCompanyId)) {
                  _context5.next = 7;
                  break;
                }

                alert('Missing type, series, invoice number or company ID.');
                return _context5.abrupt('return');

              case 7:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/' + type + '/' + series + '-' + invoiceNumber + '/pdf?externalCompanyId=' + externalCompanyId;
                _context5.prev = 8;
                _context5.next = 11;
                return fetch(url);

              case 11:
                response = _context5.sent;

                if (!response.ok) {
                  _context5.next = 23;
                  break;
                }

                _context5.next = 15;
                return response.blob();

              case 15:
                blob = _context5.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = type + '-' + series + '-' + invoiceNumber + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                _context5.next = 24;
                break;

              case 23:
                console.error('Error downloading document:', response.statusText);

              case 24:
                _context5.next = 29;
                break;

              case 26:
                _context5.prev = 26;
                _context5.t0 = _context5['catch'](8);

                console.error('Error fetching document:', _context5.t0);

              case 29:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4, [[8, 26]]);
      }))();
    }
  }
});

/***/ }),

/***/ "aS4d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryMethods_vue__ = __webpack_require__("EBxe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a648986_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryMethods_vue__ = __webpack_require__("tnDx");
function injectStyle (ssrContext) {
  __webpack_require__("A//q")
  __webpack_require__("Z+bu")
  __webpack_require__("u8ic")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a648986"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryMethods_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a648986_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryMethods_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aSfd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aVMA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltIntegrationForm_vue__ = __webpack_require__("RVZQ");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltIntegrationForm_vue__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltIntegrationForm_vue__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltIntegrationForm_vue__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltIntegrationForm_vue__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltIntegrationForm_vue__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c61290_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WoltIntegrationForm_vue__ = __webpack_require__("b3Co");
function injectStyle (ssrContext) {
  __webpack_require__("e7RR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17c61290"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltIntegrationForm_vue__["f" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c61290_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WoltIntegrationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["f"] = (Component.exports);


/***/ }),

/***/ "aVZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GroupOptionsForm_vue__ = __webpack_require__("BgVy");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ElementForm', __WEBPACK_IMPORTED_MODULE_7__GroupOptionsForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      elementForm: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.elementForm = model;
    }
  }
});

/***/ }),

/***/ "aXm7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 253.4 275.3"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 253.4 275.3","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_1_","x":"24.3","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r2_3_","d":"M24.3,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H33.3c-2.4,0-4.7-0.9-6.4-2.6S24.3,187.7,24.3,185.3z\n            "}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M24.3,194.3V80.9h113.4v113.4H24.3z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_5_","x":"125.7","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r2_7_","d":"M125.7,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-95.4c-2.4,0-4.7-0.9-6.4-2.6S125.7,187.7,125.7,185.3z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M125.7,194.3V80.9h113.4v113.4H125.7z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_9_","x":"74.3","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r2_11_","d":"M74.3,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H83.3c-2.4,0-4.7-0.9-6.4-2.6S74.3,187.7,74.3,185.3z\n            "}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M74.3,194.3V80.9h113.4v113.4H74.3z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_13_","x":"70","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r2_15_","d":"M79,0h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6H79\n            c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4C74.4,0.9,76.6,0,79,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M70,0h113.4v113.4H70V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_17_","x":"70","y":"161.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r2_19_","d":"M79,161.9h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6\n            H79c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4S76.6,161.9,79,161.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M70,161.9h113.4v113.4H70V161.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_21_","y":"10.9","width":"253.4","height":"253.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"r2_23_","cx":"126.7","cy":"137.6","r":"126.7"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st13",attrs:{"d":"M0,10.9h253.4v253.4H0V10.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_25_","x":"51.8","y":"62.7","width":"149.8","height":"149.8"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"r2_27_","cx":"126.7","cy":"137.6","r":"74.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('path',{staticClass:"st2",attrs:{"d":"M51.8,62.7h149.8v149.8H51.8V62.7z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "abJY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ac9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"available-days-schedule"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.available_days')))]),_vm._v(" "),_vm._l((_vm.availableDays),function(day,dayIdx){return _c('div',{key:day.day || dayIdx,staticClass:"row available-days-schedule__day"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","name":_vm.namePrefix + 'days',"id":_vm.namePrefix + day.day,"disabled":_vm.disabled},domProps:{"checked":Array.isArray(day.open)?_vm._i(day.open,null)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.namePrefix + day.day}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + day.day))))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n          "+_vm._s(_vm.$t('menuLink.from'))+"\n          "),_c('el-time-select',{attrs:{"disabled":!day.open || _vm.disabled,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(day.open_from),callback:function ($$v) {_vm.$set(day, "open_from", $$v)},expression:"day.open_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('menuLink.to'))+"\n          "),_c('el-time-select',{attrs:{"disabled":!day.open || _vm.disabled,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(day.open_to),callback:function ($$v) {_vm.$set(day, "open_to", $$v)},expression:"day.open_to"}})],1)]),_vm._v(" "),(day.intervals)?_c('div',{staticClass:"row intervals"},_vm._l((day.intervals),function(interval,intervalKey){return _c('div',{key:'interval-' + day.day + '-' + intervalKey,staticClass:"row"},[_c('div',{staticClass:"col-md-3 padd in-inline-160"}),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n            "+_vm._s(_vm.$t('menuLink.from'))+"\n            "),_c('el-time-select',{attrs:{"disabled":!day.open || _vm.disabled,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(interval.open_from),callback:function ($$v) {_vm.$set(interval, "open_from", $$v)},expression:"interval.open_from"}}),_vm._v("\n            "+_vm._s(_vm.$t('menuLink.to'))+"\n            "),_c('el-time-select',{attrs:{"disabled":!day.open || _vm.disabled,"placeholder":"Select time","picker-options":_vm.pickerOptions},model:{value:(interval.open_to),callback:function ($$v) {_vm.$set(interval, "open_to", $$v)},expression:"interval.open_to"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();_vm.deleteInterval(dayIdx, intervalKey)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])],1)])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn add mar-to-15",attrs:{"disabled":_vm.disabled,"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addInterval(dayIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n        "+_vm._s(_vm.$t('general.add'))+"\n      ")])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "acRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_BackgroundColorPicker_vue__ = __webpack_require__("8zHz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__);

















var _components;








__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PSwitch: __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Switch_vue__["a" /* default */],
    BackgroundColorPicker: __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_BackgroundColorPicker_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getData();
  },

  computed: {
    selectedPosOption: function selectedPosOption() {
      var _this = this;

      if (!this.model.pos_type_id) {
        return null;
      }
      return this.posOptions.find(function (pos) {
        return pos.id === _this.model.pos_type_id;
      });
    },
    dispatchFiscalPaymentMethods: function dispatchFiscalPaymentMethods() {
      return [{ id: 'CASH', label: 'Cash' }, { id: 'CARD_POS', label: 'Card' }, { id: 'POS', label: 'Pos Mobil' }];
    },
    dispatchFiscalPaymentMethodIds: function dispatchFiscalPaymentMethodIds() {
      return this.dispatchFiscalPaymentMethods.map(function (item) {
        return item.id;
      });
    },
    dispatchCheckoutButtonNames: function dispatchCheckoutButtonNames() {
      return ['Cash', 'Card', 'Pos Mobil'];
    },
    availableFiscalPaymentMethods: function availableFiscalPaymentMethods() {
      if (!this.model.is_dispatch) {
        return this.auto_print_receipt_on_metods_all;
      }
      return this.dispatchFiscalPaymentMethods;
    },
    availableCheckoutButtons: function availableCheckoutButtons() {
      var _this2 = this;

      if (!this.model.is_dispatch) {
        return this.checkout_buttons;
      }
      var fromList = this.checkout_buttons.filter(function (item) {
        return _this2.dispatchCheckoutButtonNames.indexOf(item.name) !== -1;
      });
      var names = fromList.map(function (item) {
        return item.name;
      });
      var extras = [];
      this.dispatchCheckoutButtonNames.forEach(function (name, index) {
        if (names.indexOf(name) === -1) {
          extras.push({ id: 100 + index, name: name });
        }
      });
      return fromList.concat(extras);
    }
  },
  watch: {
    'model.pos_type_id': function modelPos_type_id(newValue) {
      if (newValue) {
        var selectedOption = this.posOptions.find(function (pos) {
          return pos.id === newValue;
        });
        if (selectedOption) {
          this.model.integrated_bank_pos_id = selectedOption.id;
          this.model.integrated_bank_pos_name = selectedOption.name;
        }
      } else {
        this.model.integrated_bank_pos_id = null;
        this.model.integrated_bank_pos_name = null;
        this.model.integrated_bank_pos_port = null;
        this.model.integrated_bank_pos_tid_mid = null;
      }
    },
    'model.is_dispatch': function modelIs_dispatch(newValue) {
      if (newValue) {
        this.applyDispatchModeDefaults();
      } else {
        this.model.sync_products_from_all_locations = false;
        this.model.sync_location_ids = [];
        this.pendingSyncLocationIds = [];
      }
    }
  },
  data: function data() {
    return {
      id: this.value || this.tableId,
      locations: [],
      pendingSyncLocationIds: [],
      table_maps: [],
      fiscalPrinter: [],
      cantare: [],
      model: {
        'id': 0,
        'name': null,
        'location_id': null,
        'server_ip': null,
        'printer_ip': null,
        'table_maps_ids': [],
        'use_table_maps': false,
        'has_integrated_bank_terminal': false,
        'pos_type_id': null,
        'integrated_bank_pos_id': null,
        'integrated_bank_pos_name': null,
        'integrated_bank_pos_port': null,
        'integrated_bank_pos_tid_mid': null,
        'allow_closing_orders_without_receipt': false,
        'allow_closing_orders_without_driver': false,
        'allow_fiscal': true,
        'use_block_actions_after_print': false,
        'allowed_fiscal_payment_methods': [],
        'auto_print_fiscal_on_payment_methods': [],
        'allow_change_driver': false,
        'allow_print_note': false,
        'not_allowed_order_statuses': [],
        'is_dispatch': false,
        'sync_products_from_all_locations': false,
        'sync_location_ids': []
      },
      modelValidate: {
        name: { required: true },
        server_ip: { required: true },
        location_id: { required: true }
      },
      loading: true,
      auto_print_receipt_on_metods_all: [{ 'id': 'CASH' }, { 'id': 'CARD_POS' }, { 'id': 'POS' }, { 'id': 'GLOVO_CARD' }, { 'id': 'GLOVO_CASH' }, { 'id': 'WOLT_CARD' }, { 'id': 'WOLT_CASH' }, { 'id': 'BOLT_CARD' }, { 'id': 'BOLT_CASH' }, { 'id': 'ONLINE' }],
      auto_print_receipt_on_status_all: [{ 'id': 'NEW' }, { 'id': 'PROCESSING' }, { 'id': 'PREPARED' }, { 'id': 'DELIVERED' }, { 'id': 'CANCELED' }],
      auto_print_all_statuses: [{
        'id': 'NEW',
        'name': 'NEW'
      }, {
        'id': 'PROCESSING',
        'name': 'PROCESSING'
      }, {
        'id': 'PREPARED',
        'name': 'PREPARED'
      }],
      default_intervals_raport: [{
        'id': null,
        'name': this.$t('pos.default_intervals_raport0')
      }, {
        'id': 1,
        'name': this.$t('pos.default_intervals_raport1')
      }, {
        'id': 2,
        'name': this.$t('pos.default_intervals_raport2')
      }],
      auto_print_all_sources: [{
        'id': 'GLOVO',
        'name': 'GLOVO'
      }, {
        'id': 'BOLT',
        'name': 'BOLT'
      }, {
        'id': 'WOLT',
        'name': 'WOLT'
      }, {
        'id': 'APPLICATION',
        'name': 'APPLICATION'
      }, {
        'id': 'QR',
        'name': 'QR'
      }],
      checkout_buttons: [{
        'id': 1,
        'name': 'Cash'
      }, {
        'id': 2,
        'name': 'Card'
      }, {
        'id': 3,
        'name': 'Protocol'
      }, {
        'id': 4,
        'name': 'Modern'
      }, {
        'id': 5,
        'name': 'Discount'
      }, {
        'id': 6,
        'name': 'Coupons'
      }, {
        'id': 7,
        'name': 'Tva'
      }],
      allMethods: [{
        'id': 1,
        'name': 'Eat in'
      }, {
        'id': 2,
        'name': 'Delivery'
      }, {
        'id': 3,
        'name': 'Pick up'
      }, {
        'id': 4,
        'name': 'Drive in'
      }],
      colors: {
        defult: '#c850c0',
        black: '#000'
      },
      menuOrientation: ['horizontal', 'vertical'],
      posOptions: [{
        'id': 1,
        'name': 'Ingenico 3200 (bt)',
        'ip': true,
        'port': true,
        'tid_mid': true
      }, {
        'id': 2,
        'name': 'Ingenico 3200 (unicredit)',
        'ip': false,
        'port': true,
        'tid_mid': true
      }, {
        'id': 3,
        'name': 'Ingenico 3200 (raiffeisen)',
        'ip': false,
        'port': true,
        'tid_mid': true
      }, {
        'id': 4,
        'name': 'Viva Wallet',
        'ip': false,
        'port': true,
        'tid_mid': true
      }]
    };
  },

  methods: {
    changeAutoPrintReceipt: function changeAutoPrintReceipt() {
      if (!this.model.auto_print_receipt) {
        this.model.auto_print_receipt_on_metods = null;
        this.model.auto_print_receipt_on_status = null;
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;

      if (val.length > 4) {
        val.pop();
        this.$nextTick(function () {
          _this3.model.default_sort_checkout_buttons = val;
        });
      }
    },
    changeDisableMethods: function changeDisableMethods(method) {
      if (this.model[method]) {
        this.model.default_method = null;
      }
    },
    orderTypeSwitchValue: function orderTypeSwitchValue(disableKey) {
      if (this.model.is_dispatch) {
        return !this.model[disableKey];
      }
      return !!this.model[disableKey];
    },
    orderTypeSwitchLabel: function orderTypeSwitchLabel(disableKey) {
      if (!this.model.is_dispatch) {
        return this.$t('settingTable.' + disableKey);
      }
      var labels = {
        disable_eat_in: 'Eat In',
        disable_delivery: 'Delivery',
        disable_pick_up: 'Pick Up',
        disable_drive_in: 'Drive In'
      };
      return labels[disableKey] || this.$t('settingTable.' + disableKey);
    },
    onOrderTypeSwitchInput: function onOrderTypeSwitchInput(disableKey, value) {
      var _this4 = this;

      if (this.model.is_dispatch) {
        this.$nextTick(function () {
          _this4.applyDispatchOrderTypes();
        });
        return;
      }
      this.model[disableKey] = value;
      this.changeDisableMethods(disableKey);
    },
    applyDispatchOrderTypes: function applyDispatchOrderTypes() {
      this.model.disable_eat_in = true;
      this.model.disable_delivery = false;
      this.model.disable_pick_up = false;
      this.model.disable_drive_in = true;
      if (this.model.default_method === 1 || this.model.default_method === 4) {
        this.model.default_method = 2;
      }
    },
    applyDispatchModeDefaults: function applyDispatchModeDefaults() {
      this.model.use_table_maps = false;
      this.model.table_maps_ids = [];
      this.applyDispatchOrderTypes();
      this.model.allowed_fiscal_payment_methods = this.dispatchFiscalPaymentMethodIds.slice();
      this.model.default_sort_checkout_buttons = this.dispatchCheckoutButtonNames.slice();
    },
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy);
    },
    normalizeSyncLocationIdsForSelect: function normalizeSyncLocationIdsForSelect(ids) {
      if (!Array.isArray(ids)) {
        return [];
      }
      var asNumericIds = function asNumericIds() {
        var normalized = [];
        ids.forEach(function (raw) {
          if (raw == null || raw === '') {
            return;
          }
          var asNum = Number(raw);
          if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(asNum) && asNum > 0) {
            normalized.push(asNum);
          }
        });
        return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(normalized)));
      };

      if (!this.locations || !this.locations.length) {
        return asNumericIds();
      }
      var byToken = {};
      var byId = {};(this.locations || []).forEach(function (loc) {
        if (loc.token) {
          byToken[loc.token] = Number(loc.id);
        }
        byId[Number(loc.id)] = Number(loc.id);
      });
      var normalized = [];
      ids.forEach(function (raw) {
        if (raw == null || raw === '') {
          return;
        }
        var asNum = Number(raw);
        if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(asNum) && asNum > 0 && byId[asNum]) {
          normalized.push(asNum);
          return;
        }
        if (typeof raw === 'string' && byToken[raw]) {
          normalized.push(byToken[raw]);
        }
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(normalized)));
    },
    applyPendingSyncLocationIds: function applyPendingSyncLocationIds() {
      var pending = Array.isArray(this.pendingSyncLocationIds) ? this.pendingSyncLocationIds : this.model.sync_location_ids;
      if (!Array.isArray(pending)) {
        this.model.sync_location_ids = [];
        return;
      }
      this.model.sync_location_ids = this.normalizeSyncLocationIdsForSelect(pending);
    },
    getData: function getData() {
      var _this5 = this;

      var id = this.id || this.route.params.id;
      this.pendingSyncLocationIds = [];
      if (id) {
        var _data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };
        this.apiRequest('/pos/' + id, 'GET', _data, function (response) {
          if (response.status) {
            var pos = response.data.pos;
            _this5.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
              auto_print_fiscal_on_payment_methods: [],
              is_dispatch: false,
              sync_products_from_all_locations: false,
              sync_location_ids: []
            }, pos, {
              auto_print_fiscal_on_payment_methods: Array.isArray(pos.auto_print_fiscal_on_payment_methods) ? pos.auto_print_fiscal_on_payment_methods : []
            });

            if (_this5.model.integrated_bank_pos_id) {
              _this5.model.pos_type_id = _this5.model.integrated_bank_pos_id;
            }
            if (!Array.isArray(_this5.model.allowed_fiscal_payment_methods)) {
              _this5.model.allowed_fiscal_payment_methods = [];
            }
            if (!Array.isArray(_this5.model.not_allowed_order_statuses)) {
              _this5.model.not_allowed_order_statuses = [];
            }
            _this5.model.is_dispatch = !!_this5.model.is_dispatch;
            _this5.model.sync_products_from_all_locations = !!_this5.model.sync_products_from_all_locations;
            if (!Array.isArray(_this5.model.sync_location_ids)) {
              _this5.model.sync_location_ids = [];
            }
            if (_this5.model.is_dispatch) {
              _this5.pendingSyncLocationIds = _this5.model.sync_location_ids.slice();
              _this5.applyDispatchModeDefaults();
              _this5.applyPendingSyncLocationIds();
            } else {
              _this5.pendingSyncLocationIds = [];
              _this5.model.sync_products_from_all_locations = false;
              _this5.model.sync_location_ids = [];
            }
            if (_this5.model.location_id) {
              _this5.changeLocation(true);
            }
          }
          _this5.loading = false;
        });
      }

      this.locations = [];
      var requestData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/get-locations', 'GET', requestData, function (response) {
        if (response.status) {
          _this5.locations = response.data;
          _this5.applyPendingSyncLocationIds();
        }
        if (!id) {
          _this5.loading = false;
        }
      });

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/fiscal-printer', 'GET', data, function (response) {
        if (response.status === true) {
          _this5.fiscalPrinter = response.data.fiscalPrinter;
        }
        _this5.$nextTick(function () {
          _this5.loading = false;
        });
      });

      var dataCantar = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/cantar', 'GET', dataCantar, function (response) {
        if (response.status === true) {
          _this5.cantare = response.data.cantar;
        }
        _this5.$nextTick(function () {
          _this5.loading = false;
        });
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    areAllDeliveryMethodsDisabled: function areAllDeliveryMethodsDisabled() {
      return !!(this.model.disable_eat_in && this.model.disable_delivery && this.model.disable_pick_up && this.model.disable_drive_in);
    },
    validate: function validate() {
      var _this6 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          return;
        }
        if (_this6.areAllDeliveryMethodsDisabled()) {
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
            text: _this6.$t('settingTable.allDeliveryMethodsDisabled'),
            type: 'warning',
            showConfirmButton: true
          });
          return;
        }
        _this6.saveTable();
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    saveTable: function saveTable() {
      var _this7 = this;

      if (this.model.pos_type_id) {
        var selectedOption = this.posOptions.find(function (pos) {
          return pos.id === _this7.model.pos_type_id;
        });
        if (selectedOption) {
          this.model.integrated_bank_pos_id = selectedOption.id;
          this.model.integrated_bank_pos_name = selectedOption.name;
        }
      }

      if (this.model.is_dispatch) {
        this.applyDispatchModeDefaults();
        this.pendingSyncLocationIds = Array.isArray(this.model.sync_location_ids) ? this.model.sync_location_ids.slice() : [];
      } else {
        this.model.sync_products_from_all_locations = false;
        this.model.sync_location_ids = [];
        this.pendingSyncLocationIds = [];
      }

      this.loading = true;

      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany'),
        'pos': this.model
      };

      var id = this.id || this.route.params.id;
      var url = '';
      var request = '';
      if (id) {
        url = '/pos/' + id;
        request = 'PUT';
      } else {
        url = '/pos/add';
        request = 'POST';
      }
      this.apiRequest(url, request, data, function (response) {
        if (response.status === true) {
          if (response.data && response.data.pos && Array.isArray(response.data.pos.sync_location_ids)) {
            _this7.pendingSyncLocationIds = response.data.pos.sync_location_ids.slice();
            _this7.applyPendingSyncLocationIds();
          }
          var entityId = id || response.data && response.data.pos && response.data.pos.id || null;
          _this7.trackAdminEvent('ADMIN_POS_UPDATE', 'pos', entityId, {
            pos_id: entityId,
            name: _this7.model && _this7.model.name || null,
            request: data,
            response: response
          });
          _this7.errors.clear();
          if (request === 'POST') {
            _this7.$bus.$emit('refresh');
            _this7.$bus.$emit('close-modal');
          } else {
            _this7.backButton();
          }
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
            title: '',
            text: _this7.$t('settingTable.tableSave'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          _this7.handleErrors(response.errors);
        }
        _this7.loading = false;
      });
    },
    deleteOrderScreen: function deleteOrderScreen() {
      var _this8 = this;

      this.loadingReset = true;
      var id = this.id || this.route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/pos/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          _this8.trackAdminEvent('ADMIN_POS_DELETED', 'pos', id, {
            pos_id: id,
            name: _this8.model && _this8.model.name || null
          });
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this8.backButton();
        } else {
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({ 'text': _this8.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
        _this8.loadingReset = false;
      });
    },
    changeLocation: function changeLocation() {
      var _this9 = this;

      var doNotEmptyModel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!doNotEmptyModel) {
        this.model.table_maps_ids = [];
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_id: this.model.location_id
      };
      this.loading = true;
      this.apiRequest('/pos/all/map', 'GET', data, function (response) {
        if (response.status) {
          _this9.table_maps = response.data.table_maps;
        }
        _this9.loading = false;
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    deleteToken: function deleteToken() {
      var _this10 = this;

      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany')
      };

      var id = this.id || this.route.params.id;
      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
        type: 'question',
        title: this.$t('settingTable.deleteZoneTitle'),
        text: this.$t('settingTable.disableAuthInfo'),
        position: 'top-end',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        allowOutsideClick: false
      }).then(function (result) {
        _this10.apiRequest('/pos/' + id + '/delete-token', 'PUT', data, function (response) {
          _this10.model.token = null;
        });
      });
    },
    updateColor: function updateColor(value) {
      this.model.background_color = value;
    }
  }
});

/***/ }),

/***/ "af5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountCampaignForm_vue__ = __webpack_require__("eOL1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88dd6c5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountCampaignForm_vue__ = __webpack_require__("Syew");
function injectStyle (ssrContext) {
  __webpack_require__("TIPk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88dd6c5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountCampaignForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88dd6c5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountCampaignForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "agLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("Yq4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dialog__ = __webpack_require__("qubY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_color__ = __webpack_require__("Zzkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_sweetalert2_dist_sweetalert2_css__);




























var _components;










__WEBPACK_IMPORTED_MODULE_27_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_33_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    ChromePicker: __WEBPACK_IMPORTED_MODULE_28_vue_color__["Chrome"]
  }, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_checkbox___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_checkbox___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox_group___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox_group___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dialog___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_dialog___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_30_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_vee_validate__["b" /* mapFields */])(['name', 'notification_email', 'description', 'sort_order', 'parent_id', 'date_validfrom', 'date_validto', 'display_type']), {
    currency: function currency() {
      var companyData = this.$session.get('selectedCompanyData');
      return companyData ? this.getCurrencySymbol(companyData.currency_iso) : '';
    },

    preparationTimeInMinutes: {
      get: function get() {
        if (this.model.preparation_time_in_seconds === null || this.model.preparation_time_in_seconds === undefined || this.model.preparation_time_in_seconds === '') {
          return null;
        }
        return Number(this.model.preparation_time_in_seconds) / 60;
      },
      set: function set(minutes) {
        if (minutes === null || minutes === undefined || minutes === '') {
          this.$set(this.model, 'preparation_time_in_seconds', null);
          return;
        }
        this.$set(this.model, 'preparation_time_in_seconds', Math.round(Number(minutes) * 60));
      }
    }
  }),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      currentSubSection: 'l1',
      invalidTabs: [],
      language: '',
      languages: [],
      delivery_options_labels: false,
      originalLocationIds: [],
      selectedLocations: [],
      pickerOptions1: {},
      deliveryServices: [],
      pickerNames: ['date_validfrom', 'date_validto'],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      displayTypes: {
        'list': 'List',
        'grid': 'Grid'
      },
      mainCategories: [],
      topCategories: [],
      model: {
        parent_id: null,
        color: null,
        display_type: 'list',
        override_delivery: false,
        override_settings: [],
        is_age_restrict: false
      },
      filelist: [],
      filelistToUpload: [],
      generalSuccess: '',
      modelValidations: {
        name: {
          required: true
        }
      },
      loading: true,
      sortProductMethod: null,
      tableData: [],
      sortOrderChanges: {},
      debounceTimeout: null,
      filters: [],
      deleteImage: false,
      use_gestiune: false,
      has_charisma_location: false,
      locationsForGestiune: [],
      gestiuni: [],
      locations: [],
      overrideLocations: [],
      deleteOverrides: [],
      isCheckedDay: false,
      isCheckedDeliveryMethod: false,
      timePickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      administrations: [],
      administrationsToDelete: [],
      platforms: [{ id: 1, name: this.$t('addOrder.application') }, { id: 2, name: 'Website' }, { id: 6, name: 'QR' }],
      selectedPlatforms: [],
      userLabelings: [],
      selectedUserLabelings: [],

      disablableOrderSources: [{ id: 2, name: 'QR' }, { id: 3, name: 'POS' }],
      selectedDisabledOrderSources: []
    };
  },

  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      this.loading = true;
    });
    this.use_gestiune = this.$session.get('selectedCompanyData').use_gestiune;
    this.ensureCompanyLocationFlags(function (sessionData) {
      _this.has_charisma_location = !!sessionData.has_charisma_location;
    });
    if (this.use_gestiune) {
      this.fetchLocationsForGestiune();
    }
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    var self = this;
    this.loadLanguages();


    var sessionData = this.$session.get('selectedCompanyData');

    this.overrideLocations = sessionData['locations_details'] || [];

    if (!sessionData['locations_list']) {
      var locationsDetails = sessionData['locations_details'] || [];

      var locationsList = locationsDetails.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      this.locations = locationsList;
      sessionData['locations_list'] = locationsList;

      this.$session.set('selectedCompanyData', sessionData);
    } else {
      this.locations = sessionData['locations_list'];
    }

    if (!sessionData['administrations']) {
      this.apiRequest('/administration', 'GET', data, function (response) {
        if (response.status) {
          sessionData['administrations'] = response.data;
          _this.administrations = response.data;
          _this.$session.set('selectedCompanyData', sessionData);
        }
      });
    } else {
      this.administrations = sessionData['administrations'];
    }

    self.sortProductMethod = sessionData.sort_product_method;

    this.apiRequest('/settings/general/' + this.$session.get('selectedCompany'), 'GET', {
      token: this.$session.get('token')
    }, function (response) {
      if (response.status === true && response.data && response.data[0]) {
        var method = response.data[0].sort_product_method;
        if (method !== undefined && method !== null) {
          self.sortProductMethod = method;
          sessionData.sort_product_method = method;
          self.$session.set('selectedCompanyData', sessionData);
        }
      }
    });
    this.getProducts();
    this.getFilters();
    this.fetchUserLabelings();

    this.apiRequest('/topcategory', 'GET', data, function (response) {
      if (response.status === true) {
        self.topCategories = response.data;
      }
      self.$nextTick(function () {
        self.loading = false;
      });
    });
    if (this.route.params.id) {
      var id = this.route.params.id;
      this.apiRequest('/category/' + id, 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data[0].date_validfrom && response.data[0].date_validto) {
            response.data[0].fromto = [response.data[0].date_validfrom, response.data[0].date_validto];
          }
          if (response.data[0].image) {
            response.data[0].imagelist = [{ url: response.data[0].image }];
          } else {
            response.data[0].imagelist = [];
          }

          response.data[0].display_type = 'list';
          self.model = response.data[0];
          self.model.override_delivery = !!(self.model.override_delivery === true || self.model.override_delivery === 1 || self.model.override_delivery === '1');
          if (!Array.isArray(self.model.override_settings)) {
            self.model.override_settings = [];
          }
          self.deleteOverrides = [];

          var respLocations = response.data[0].locations;

          if (respLocations && respLocations.length) {
            _this.originalLocationIds = respLocations.slice();
            _this.selectedLocations = respLocations.map(function (item) {
              return _this.locations.find(function (loc) {
                return loc.id === item.location_id;
              });
            }).filter(Boolean);
          } else {
            _this.originalLocationIds = [];
            _this.selectedLocations = [];
          }

          if (!self.model.selectedGestiuni) {
            self.model.selectedGestiuni = {};
          }
          _this.locations.forEach(function (loc) {
            if (!(loc.id in self.model.selectedGestiuni)) {
              self.model.selectedGestiuni[loc.id] = null;
            }
          });

          _this.mapLocationIdsToObjects();
          self.delivery_options_labels = response.data[0].company.delivery_options_labels;

          self.changeTopCategory();

          if (_this.model.hide_from_platforms && _this.model.hide_from_platforms.length) {
            _this.selectedPlatforms = _this.model.hide_from_platforms.map(function (t) {
              return _this.platforms.find(function (f) {
                return f.id === t;
              });
            }) || [];
          }

          if (Array.isArray(self.model.user_labeling_ids)) {
            self.selectedUserLabelings = self.model.user_labeling_ids.map(function (id) {
              return self.userLabelings.find(function (ul) {
                return ul.id === id;
              });
            }).filter(Boolean);
          }

          _this.selectedDisabledOrderSources = (_this.model.disabled_order_sources || []).map(function (id) {
            return _this.disablableOrderSources.find(function (source) {
              return source.id === Number(id);
            });
          }).filter(Boolean);

          self.initLocalizedFields();
          self.updateDeliverySettings();

          self.$nextTick(function () {
            self.loading = false;
          });
        }
      });
    } else {
      self.model.override_delivery = false;
      self.model.override_settings = [];
      self.deleteOverrides = [];
      self.$nextTick(function () {
        self.loading = false;
      });
    }

    var allTypes = this.$session.get('defaultData')['delivery_types'];
    var locations = sessionData['locations_details'];

    var enabled = [];
    var enabledTypes = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(locations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var loc = _step.value;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(loc['ordering_management']), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var ordering = _step2.value;

            if (ordering['enabled'] === true) {
              enabled[ordering['type']] = true;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    for (var idx in allTypes) {
      if (enabled[idx.toLowerCase()] !== undefined) {
        enabledTypes.push(allTypes[idx]);
      }
    }
    this.deliveryServices = enabledTypes;
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    loadLanguages: function loadLanguages() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/company-data', 'GET', data, function (response) {
        if (response.status === true && response.data && response.data.company) {
          _this2.languages = response.data.company.languages || [];
          _this2.language = response.data.company.language || '';
          _this2.initLocalizedFields();
        }
      });
    },
    openSubSection: function openSubSection(section) {
      this.currentSubSection = section;
    },
    initLocalizedFields: function initLocalizedFields() {
      var _this3 = this;

      if (!this.languages || !this.languages.length) {
        return;
      }
      if (!this.model.localized_fields || Array.isArray(this.model.localized_fields)) {
        this.$set(this.model, 'localized_fields', {});
      }
      this.languages.forEach(function (lang) {
        if (!_this3.model.localized_fields[lang.short]) {
          _this3.$set(_this3.model.localized_fields, lang.short, {
            language_id: lang.id,
            language_short: lang.short,
            name: '',
            description: ''
          });
        } else {
          _this3.model.localized_fields[lang.short].language_id = lang.id;
          _this3.model.localized_fields[lang.short].language_short = lang.short;
        }
      });
    },
    validateLocalizedNames: function validateLocalizedNames() {
      var _this4 = this;

      this.invalidTabs = [];
      var firstInvalidTab = null;

      if (!this.model.name || !String(this.model.name).trim()) {
        this.invalidTabs.push('l1');
        firstInvalidTab = 'l1';
      }

      this.languages.forEach(function (lang) {
        var lf = _this4.model.localized_fields ? _this4.model.localized_fields[lang.short] : null;
        var tabKey = lang.id + '-' + lang.short;
        if (!lf || !lf.name || !String(lf.name).trim()) {
          if (!_this4.invalidTabs.includes(tabKey)) {
            _this4.invalidTabs.push(tabKey);
          }
          if (!firstInvalidTab) {
            firstInvalidTab = tabKey;
          }
        }
      });

      if (firstInvalidTab) {
        this.currentSubSection = firstInvalidTab;
      }

      return this.invalidTabs.length === 0;
    },
    fetchLocationsForGestiune: function fetchLocationsForGestiune() {
      var _this5 = this;

      var dataToSend = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token')
      };
      this.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
        _this5.locationsForGestiune = response.data.locations;
        _this5.locationsForGestiune.forEach(function (loc) {
          _this5.getGestiuneForLocation(loc.true_id, loc.inv_fiscal_code);
        });
      });
    },
    getGestiuneForLocation: function getGestiuneForLocation(locationId, vatNr) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        var companyId, response, data;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this6.gestiuni[locationId]) {
                  _context.next = 14;
                  break;
                }

                companyId = _this6.$session.get('selectedCompany');
                _context.prev = 2;
                _context.next = 5;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + companyId + '&vatNumber=' + vatNr + '&externalLocationId=' + locationId);

              case 5:
                response = _context.sent;
                _context.next = 8;
                return response.json();

              case 8:
                data = _context.sent;


                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this6.gestiuni[locationId] = data.gestiuni;
                } else {}
                _context.next = 14;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](2);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6, [[2, 12]]);
      }))();
    },
    deleteProducts: function deleteProducts() {
      var _this7 = this;

      var self = this;

      __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()({
        text: this.$t('catalogCateg.areYouSureDeleteProducts'),
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (result) {
          var data = {
            category_id: _this7.route.params.id,
            token: _this7.$session.get('token'),
            company_id: _this7.$session.get('selectedCompany')
          };
          _this7.apiRequest('/delete-category-products/', 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()('', self.$t('catalogCateg.prodDeleted'), 'success');
            } else {
              __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
            }
          });
        }
      });
    },
    validate: function validate() {
      var _this8 = this;

      this.$validator.validateAll().then(function (isValid) {

        if (_this8.has_charisma_location && _this8.model.administrations && _this8.model.administrations.length) {
          _this8.model.administrations.forEach(function (row, index) {
            var fieldName = 'administration_id_' + index;

            _this8.errors.remove(fieldName);

            if (!row.administration_id) {
              _this8.errors.add({
                field: fieldName,
                msg: _this8.$t('validations.requiredField')
              });
              isValid = false;
            } else {
              _this8.errors.remove(fieldName);
            }
          });
        }

        var localizedValid = _this8.validateLocalizedNames();
        if (!localizedValid) {
          isValid = false;
        }

        if (_this8.model.override_delivery && (_this8.errors.has('isCheckedDay') || _this8.errors.has('isCheckedDeliveryMethod'))) {
          isValid = false;
        }

        if (isValid) {
          _this8.errors.clear();
          _this8.saveCategory();
        } else if (!localizedValid) {
          __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()({
            title: '',
            text: 'Numele este obligatoriu pentru toate limbile.',
            type: 'error',
            timer: 3000,
            showConfirmButton: false
          }).catch(function () {});
        }
      });
    },
    addNewOverrideInterval: function addNewOverrideInterval(locId, deliveryMethod, deliveryMethodLabel) {
      if (!this.model.override_settings[locId]['delivery'][deliveryMethod]) {
        __WEBPACK_IMPORTED_MODULE_27_vue___default.a.set(this.model.override_settings[locId]['delivery'], deliveryMethod, []);
      }
      this.model.override_settings[locId]['delivery'][deliveryMethod].push(this.createEmptyOverrideInterval(deliveryMethodLabel));
    },
    removeOverrideInterval: function removeOverrideInterval(locId, deliveryMethod, intervalIndex) {
      if (this.model.override_settings[locId]['delivery'][deliveryMethod][intervalIndex].id) {
        this.deleteOverrides.push(this.model.override_settings[locId]['delivery'][deliveryMethod][intervalIndex].id);
      }
      this.model.override_settings[locId]['delivery'][deliveryMethod].splice(intervalIndex, 1);
    },
    handleCheckDay: function handleCheckDay(locId, intervalId, orderId) {
      var check = this.model.override_settings[locId]['delivery'][intervalId][orderId]['active'] && !this.model.override_settings[locId]['delivery'][intervalId][orderId].monday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].tuesday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].wednesday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].thursday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].friday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].saturday && !this.model.override_settings[locId]['delivery'][intervalId][orderId].sunday;

      this.isCheckedDay = !check;

      if (!this.isCheckedDay && this.model.override_delivery) {
        this.errors.add('isCheckedDay', 'Day is required.');
        return false;
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (element) {
            return element.field !== 'isCheckedDay';
          });
        }
      }
    },
    handleChangeIsCheckedDeliveryMethod: function handleChangeIsCheckedDeliveryMethod(locId, orderIntervalId, orderId) {
      var hasActive = false;
      var delivery = this.model.override_settings[locId]['delivery'];
      var groups = Array.isArray(delivery) ? delivery : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(delivery || {});
      groups.forEach(function (group) {
        if (Array.isArray(group)) {
          group.forEach(function (interval) {
            if (interval && (interval.active === true || interval.active === 1)) {
              hasActive = true;
            }
          });
        } else if (group && (group.active === true || group.active === 1)) {
          hasActive = true;
        }
      });

      this.isCheckedDeliveryMethod = !hasActive;
      this.handleChangeOverrideDelivery();
      if (orderIntervalId !== undefined && orderId !== undefined) {
        this.handleCheckDay(locId, orderIntervalId, orderId);
      }
    },
    handleChangeOverrideDelivery: function handleChangeOverrideDelivery() {
      if (this.isCheckedDeliveryMethod && this.model.override_delivery) {
        this.errors.add('isCheckedDeliveryMethod', 'Location is required.');
      } else {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(function (element) {
            return element.field !== 'isCheckedDeliveryMethod';
          });
        }
      }
    },
    createEmptyOverrideInterval: function createEmptyOverrideInterval(deliveryMethod) {
      return {
        active: true,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
        delivery_method: deliveryMethod,
        available_from: '',
        available_to: ''
      };
    },
    deliveryMethodLabel: function deliveryMethodLabel(orderInterval, orderIntervalId) {
      if (orderInterval && orderInterval[0] && orderInterval[0].delivery_method) {
        return orderInterval[0].delivery_method;
      }
      return orderIntervalId;
    },
    getLocationOrderingManagement: function getLocationOrderingManagement(loc) {
      if (loc && Array.isArray(loc.ordering_management) && loc.ordering_management.length) {
        return loc.ordering_management;
      }

      var allTypes = (this.$session.get('defaultData') || {}).delivery_types || {};
      var methods = [];

      if (Array.isArray(allTypes)) {
        allTypes.forEach(function (type) {
          var method = typeof type === 'string' ? type : type && (type.key || type.type);
          if (method) {
            methods.push({ type: String(method).toLowerCase() });
          }
        });
      } else if (allTypes && (typeof allTypes === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(allTypes)) === 'object') {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(allTypes).forEach(function (key) {
          methods.push({ type: String(key).toLowerCase() });
        });
      }

      if (!methods.length) {
        return [{ type: 'pick_up' }, { type: 'delivery' }, { type: 'eat_in' }];
      }

      return methods;
    },
    buildLocationDeliveryMap: function buildLocationDeliveryMap(loc, existingDelivery) {
      var delivery = {};

      if (Array.isArray(existingDelivery)) {
        existingDelivery.forEach(function (group) {
          if (!Array.isArray(group) || !group.length || !group[0] || !group[0].delivery_method) {
            return;
          }
          var method = group[0].delivery_method;
          delivery[method] = group.slice();
        });
      } else if (existingDelivery && (typeof existingDelivery === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(existingDelivery)) === 'object') {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(existingDelivery).forEach(function (method) {
          var group = existingDelivery[method];
          delivery[method] = Array.isArray(group) ? group.slice() : [];
        });
      }

      var orderingManagement = this.getLocationOrderingManagement(loc);
      orderingManagement.forEach(function (ordering) {
        var deliveryMethod = ordering.type;
        if (!deliveryMethod) {
          return;
        }
        if (!Object.prototype.hasOwnProperty.call(delivery, deliveryMethod)) {
          delivery[deliveryMethod] = [];
        }
      });

      return delivery;
    },
    overrideLocationTitle: function overrideLocationTitle(locId) {
      var idx = this.getObjectByElemKeyValue('id', locId, this.overrideLocations);
      if (idx === false || !this.overrideLocations[idx]) {
        return locId;
      }
      return this.overrideLocations[idx].name;
    },
    showThisOverrideLocation: function showThisOverrideLocation(locId) {
      if (!this.selectedLocations || !this.selectedLocations.length) {
        return this.getObjectByElemKeyValueBool('id', locId, this.overrideLocations) ? 1 : 0;
      }
      var overrideLocIdx = this.getObjectByElemKeyValue('id', locId, this.overrideLocations);
      if (overrideLocIdx === false || !this.overrideLocations[overrideLocIdx]) {
        return 0;
      }
      var trueId = this.overrideLocations[overrideLocIdx].true_id;
      return this.getObjectByElemKeyValueBool('id', trueId, this.selectedLocations) ? 1 : 0;
    },
    updateDeliverySettings: function updateDeliverySettings() {
      this.$nextTick(function () {
        var _this9 = this;

        var model = this.model;

        if (!Array.isArray(model.override_settings)) {
          __WEBPACK_IMPORTED_MODULE_27_vue___default.a.set(this.model, 'override_settings', []);
        }

        var deliveryDetails = [];
        var locationSource = this.overrideLocations || [];

        if (this.selectedLocations && this.selectedLocations.length) {
          locationSource = this.overrideLocations.filter(function (loc) {
            return _this9.getObjectByElemKeyValueBool('id', loc.true_id, _this9.selectedLocations);
          });
        }

        if (!locationSource.length) {
          locationSource = this.overrideLocations || [];
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(locationSource), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var loc = _step3.value;

            if (!loc) continue;

            var idx = this.getObjectByElemKeyValue('loc_id', loc.id, model.override_settings);
            var existing = idx !== false && idx !== null && idx !== undefined ? model.override_settings[idx] : null;

            deliveryDetails.push({
              loc_id: loc.id,
              delivery: this.buildLocationDeliveryMap(loc, existing ? existing.delivery : null)
            });
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_27_vue___default.a.set(this.model, 'override_settings', deliveryDetails);
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    isNew: function isNew() {
      if (this.route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    handleImgChange: function handleImgChange(file, fileList) {
      var _this10 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
      if (this.model.imagelist && this.model.imagelist[0].status === 'ready') {
        this.getBase64(this.model.imagelist[0].raw).then(function (base64enc) {
          _this10.model.image = base64enc;
          _this10.deleteImage = false;
        });
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
        this.model.image = null;
        this.deleteImage = true;
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()({
        text: this.$t('general.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    },
    updateDates: function updateDates(dates) {
      this.model.date_validfrom = __WEBPACK_IMPORTED_MODULE_31_moment___default()(String(dates.minDate)).format('YYYY-MM-DD');
      this.model.date_validto = __WEBPACK_IMPORTED_MODULE_31_moment___default()(String(dates.maxDate)).format('YYYY-MM-DD');
    },
    handleDelete: function handleDelete(label) {
      var _this11 = this;

      var btnCounter = 3;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()({
        text: this.$t('catalogCateg.areYouSure', { label: label }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          if (_this11.isNew()) {
            self.$bus.$emit('refresh');
            self.$bus.$emit('close-modal');
          } else {
            var id = _this11.route.params.id;
            var data = {
              id: id,
              token: _this11.$session.get('token'),
              company_id: _this11.$session.get('selectedCompany')
            };
            _this11.apiRequest('/category/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                self.trackAdminEvent('ADMIN_CATEGORY_DELETED', 'category', id, {
                  category_id: id,
                  name: self.model && self.model.name || null
                });
                __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()('', self.$t('catalogCateg.categDeleted'), 'success');
                self.$bus.$emit('refresh');
                self.$bus.$emit('close-modal');
              } else {
                __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    saveCategory: function saveCategory() {
      var _this12 = this;

      this.$nextTick(function () {
        this.loading = true;
      });
      var data = this.model;
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      data.version = 3;
      data.delete_image = this.deleteImage;
      data.override_delivery = !!(data.override_delivery === true || data.override_delivery === 1 || data.override_delivery === '1');
      data.delete_overrides = this.deleteOverrides;
      data.is_age_restrict = !!data.is_age_restrict;

      if (data.override_settings && data.override_settings.length) {
        data.override_settings.forEach(function (item) {
          item.version = 2;
        });
      }

      if (this.has_charisma_location) {
        data.administrationsToDelete = this.administrationsToDelete;
      }

      if (this.has_charisma_location && this.model.administrations && this.model.administrations.length) {
        var cleanedAdministrations = this.model.administrations.map(function (admin) {
          return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, admin, {
            location_ids: admin.location_ids.map(function (loc) {
              return (typeof loc === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(loc)) === 'object' ? loc.id : loc;
            })
          });
        });
        data.administrations = cleanedAdministrations;
      }

      var originalItems = Array.isArray(this.originalLocationIds) ? this.originalLocationIds : [];
      var originalMap = {};
      var originalIds = originalItems.map(function (item) {
        if (item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(item)) === 'object') {
          var locId = item.location_id;
          var relId = item.id || locId;
          if (locId) {
            originalMap[locId] = relId;
            return locId;
          }
        }
        originalMap[item] = item;
        return item;
      });

      var currentIds = Array.isArray(this.selectedLocations) ? this.selectedLocations.map(function (l) {
        return l && l.id;
      }).filter(Boolean) : [];

      var locationsPayload = [];

      if (Array.isArray(this.selectedLocations) && this.selectedLocations.length) {
        this.selectedLocations.forEach(function (loc) {
          if (!loc || !loc.id) return;
          var locId = loc.id;
          var relationId = originalMap[locId] || null;
          locationsPayload.push({
            id: relationId,
            location_id: locId,
            name: loc.name
          });
        });
      }

      if (originalIds.length) {
        originalIds.forEach(function (id) {
          if (!currentIds.includes(id)) {
            locationsPayload.push({
              id: originalMap[id] || id,
              location_id: id,
              delete: true
            });
          }
        });
      }

      data.locations = locationsPayload;

      if (data.fromto && data.fromto[0] && data.fromto[1]) {
        data.date_validfrom = data.fromto[0];
        data.date_validto = data.fromto[1];
      } else {
        data.date_validfrom = null;
        data.date_validto = null;
      }

      if (this.selectedPlatforms && this.selectedPlatforms.length) {
        data.hide_from_platforms = this.selectedPlatforms.map(function (element) {
          return element.id;
        });
      } else {
        data.hide_from_platforms = [];
      }

      data.disabled_order_sources = (this.selectedDisabledOrderSources || []).map(function (source) {
        return source.id;
      });

      if (data.monetary_conversion === '' || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(data.monetary_conversion) === 'object') {
        data.monetary_conversion = null;
      }

      data.user_labeling_ids = (this.selectedUserLabelings || []).map(function (item) {
        return (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(item)) === 'object' ? item.id : item;
      });

      var httpMethod = '';
      var url = '/category/';

      if (this.isNew()) {
        httpMethod = 'POST';
      } else {
        httpMethod = 'PUT';
        url += this.route.params.id;
      }

      delete data.parent_category;

      this.apiRequest(url, httpMethod, data, function (response) {
        if (response.status) {
          var entityId = _this12.route.params && _this12.route.params.id || response.data && response.data[0] && response.data[0].id || null;
          _this12.trackAdminEvent('ADMIN_CATEGORY_UPDATE', 'category', entityId, {
            category_id: entityId,
            name: _this12.model && _this12.model.name || null,
            active: !!(_this12.model && _this12.model.active),
            request: data,
            response: response
          });
          _this12.$nextTick(function () {
            this.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()({
            title: '',
            text: _this12.$t('catalogCateg.categAdded'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
          _this12.$bus.$emit('refresh');
          _this12.$bus.$emit('close-modal');
          _this12.mapLocationIdsToObjects();

          var respLocations = response.data[0].locations;

          if (respLocations && respLocations.length) {
            _this12.originalLocationIds = respLocations.slice();
            _this12.selectedLocations = respLocations.map(function (item) {
              return _this12.locations.find(function (loc) {
                return loc.id === item.location_id;
              });
            }).filter(Boolean);
          } else {
            _this12.originalLocationIds = [];
            _this12.selectedLocations = [];
          }

          if (response.data[0].override_settings) {
            _this12.model.override_settings = response.data[0].override_settings;
          }
          _this12.model.override_delivery = !!(response.data[0].override_delivery === true || response.data[0].override_delivery === 1 || response.data[0].override_delivery === '1');
          _this12.deleteOverrides = [];
          _this12.updateDeliverySettings();
        } else {
          _this12.$nextTick(function () {
            this.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()({
            title: '',
            text: response.errors.error,
            type: 'error',
            showConfirmButton: false,
            timer: 5000
          }).catch(function () {});
        }
      });
    },
    onSortOrderInput: function onSortOrderInput(item) {
      var _this13 = this;

      if (item.sort_order < 0) {
        item.sort_order = 0;
      } else if (item.sort_order > 1000) {
        item.sort_order = 1000;
      }

      this.sortOrderChanges[item.id] = item.sort_order;

      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(function () {
        _this13.sendSortOrderUpdates();
      }, 1000 * 5);
    },
    sendSortOrderUpdates: function sendSortOrderUpdates() {
      var _this14 = this;

      var updates = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.sortOrderChanges).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            id = _ref2[0],
            sortOrder = _ref2[1];

        return {
          id: parseInt(id),
          sortOrder: sortOrder
        };
      });

      if (!updates.length) {
        return;
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        category_id: parseInt(this.route.params.id),
        updates: updates
      };

      this.loading = true;

      this.apiRequest('/sort-product-mass-update', 'PUT', data, function (response) {
        if (response.status) {
          _this14.getProducts();
        } else {
          _this14.loading = false;
          __WEBPACK_IMPORTED_MODULE_32_sweetalert2___default()({
            title: '',
            text: response.errors && (response.errors.message || response.errors.error) || _this14.$t('validations.wentWrong'),
            type: 'error',
            showConfirmButton: false,
            timer: 5000
          }).catch(function () {});
        }
      });

      this.sortOrderChanges = {};
      this.debounceTimeout = null;
    },
    onlyDigits: function onlyDigits(event) {
      var char = String.fromCharCode(event.which);
      if (!/^\d$/.test(char)) {
        event.preventDefault();
      }
    },
    selectInputText: function selectInputText(event) {
      event.target.select();
    },
    getProducts: function getProducts() {
      this.loading = true;
      var self = this;
      var idCateg = this.route.params.id;
      if (!idCateg) {
        this.loading = false;
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        grouped: 1,
        category_id: idCateg,
        use_sort_order: 'asc'
      };
      this.apiRequest('/category-products', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data;
          self.loaded = true;
        }
        self.$nextTick(function () {
          self.loading = false;
        });
      });
    },
    fetchUserLabelings: function fetchUserLabelings() {
      var _this15 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/userlabeling', 'GET', data, function (response) {
        if (response.status === true && response.data && Array.isArray(response.data.items)) {
          _this15.userLabelings = response.data.items;
        }
      });
    },
    getFilters: function getFilters() {
      var _this16 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/filter', 'GET', data, function (response) {
        if (response.status === true) {
          _this16.filters = response.data;
          _this16.$nextTick(function () {
            _this16.loading = false;
          });
        }
      });
    },
    showMethods: function showMethods() {
      if (!this.model.is_force_method) {
        this.model.force_methods = null;
      }
    },
    changeTopCategory: function changeTopCategory() {
      if (this.model.top_category_id !== 'null' && this.model.top_category_id !== null) {
        this.model.is_force_method = false;
        this.model.force_methods = null;
      }
    },
    addRow: function addRow() {
      if (!this.model.administrations) {
        __WEBPACK_IMPORTED_MODULE_27_vue___default.a.set(this.model, 'administrations', []);
      }

      this.model.administrations.push({
        id: null,
        company_id: this.$session.get('selectedCompany'),
        administration_id: null,
        location_ids: []
      });
    },
    removeRow: function removeRow(index) {
      var removed = this.model.administrations[index];

      if (removed.id) {
        this.administrationsToDelete.push(removed.id);
      }

      this.model.administrations.splice(index, 1);
    },
    availableAdministrations: function availableAdministrations(currentId) {
      var used = this.model.administrations.map(function (r) {
        return r.administration_id;
      }).filter(function (id) {
        return id !== currentId;
      });
      return this.administrations.filter(function (a) {
        return !used.includes(a.id);
      });
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    mapLocationIdsToObjects: function mapLocationIdsToObjects() {
      var _this17 = this;

      var administrations = this.model.administrations;

      administrations.forEach(function (admin) {
        if (Array.isArray(admin.location_ids)) {
          admin.location_ids = admin.location_ids.map(function (id) {
            return _this17.locations.find(function (loc) {
              return loc.id === id;
            });
          }).filter(function (loc) {
            return loc;
          });
        }
      });
      this.model.administrations = administrations;
    }
  }
});

/***/ }),

/***/ "agUK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t2_vue__ = __webpack_require__("+WkA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518a722a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t2_vue__ = __webpack_require__("DCTk");
function injectStyle (ssrContext) {
  __webpack_require__("xqpA")
  __webpack_require__("BaIB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-518a722a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518a722a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ahTF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "apxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row management-tabs full-height-tabs items-align-management-tabs text-align-management-tabs",attrs:{"direction":"vertical","value":"Description"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('invoice.invoices')}},[(_vm.isDashboard)?_c('invoice-dashboard'):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('invoice.proforma')}},[(_vm.isProforma)?_c('proforma'):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('invoice.reports')}},[(_vm.isReports)?_c('invoice-reports'):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('invoice.settings')}},[(_vm.isSettings)?_c('invoice-settings'):_vm._e()],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ar4A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OrderScreenForm_vue__ = __webpack_require__("B5QA");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'OrderScreenForm', __WEBPACK_IMPORTED_MODULE_7__OrderScreenForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderScreenModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderScreenModel = model;
    }
  }
});

/***/ }),

/***/ "arw6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'r1'
});

/***/ }),

/***/ "avwN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"mar-lt-20"},[_c('label',{staticClass:"pad-bt-5"},[_vm._v(_vm._s(_vm.$t('upload.uploadLabel')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","on-change":_vm.handleChange,"on-remove":_vm.handleRemove,"on-exceed":_vm.handleExceed,"limit":1,"auto-upload":false,"accept":".csv"}},[_c('el-button',{staticClass:"btn add",attrs:{"slot":"trigger","size":"small","type":"primary"},slot:"trigger"},[_vm._v(_vm._s(_vm.$t('upload.browse')))]),_vm._v(" "),_c('el-button',{staticClass:"btn add",staticStyle:{"margin-left":"10px"},attrs:{"disabled":!_vm.canUpload,"size":"small","type":"primary"},on:{"click":_vm.upload}},[_vm._v(_vm._s(_vm.$t('upload.upload')))]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('upload.file'))+" .csv")]),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions"})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "awm+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationMenuPreviewModal_vue__ = __webpack_require__("xkQG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6882eb1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationMenuPreviewModal_vue__ = __webpack_require__("PiTK");
function injectStyle (ssrContext) {
  __webpack_require__("6ncc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6882eb1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationMenuPreviewModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6882eb1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationMenuPreviewModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "azRF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementAvizForm_vue__ = __webpack_require__("1P1l");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ManagementAvizForm', __WEBPACK_IMPORTED_MODULE_7__ManagementAvizForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "b1Qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      search: '',
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      tableData: [],
      total: 0,
      sortBy: 'id',
      sortOrder: 'asc',
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        style: 'width: 100%',
        defaultSort: {
          prop: 'id',
          order: 'ascending'
        }
      }
    };
  },
  created: function created() {
    this.getData();
  },

  methods: {
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page' || query.type === 'size') {
        this.getData(query);
      }
      if (query.type === 'sort') {
        if (query.sort.order) {
          this.sortBy = query.sort.prop;
          this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc';
        } else {
          this.sortBy = 'id';
          this.sortOrder = 'asc';
        }
        this.getData(query);
      }
    },
    getData: function getData(query) {
      var _this = this;

      var sortField = this.sortBy;
      var sortType = this.sortOrder;
      var pageSize = 20;
      var page = 1;

      if (query) {
        if (query.sort && query.sort.prop) {
          sortField = query.sort.prop;
        }
        if (query.sort && query.sort.order) {
          sortType = query.sort.order === 'descending' ? 'desc' : 'asc';
        }
        if (query.pageSize) {
          pageSize = query.pageSize;
        }
        if (query.page) {
          page = query.page;
        }
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: this.search,
        field: sortField,
        order: sortType
      };

      this.loading = true;
      this.apiRequest('/reports/wallet-report?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data.items;
          _this.total = response.data.total;
        }
        _this.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "b1nj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupOptions_vue__ = __webpack_require__("j/DZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37254ecb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupOptions_vue__ = __webpack_require__("FeL0");
function injectStyle (ssrContext) {
  __webpack_require__("zv6G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37254ecb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b3Co":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row wolt-integration-form marketplace-settings"},[_c('div',{staticClass:"col-md-12"},[_c('section',{staticClass:"marketplace-action-panel marketplace-setup-panel"},[_c('div',{staticClass:"marketplace-action-heading"},[_c('i',{staticClass:"ti-location-pin",attrs:{"aria-hidden":"true"}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('marketplace.locations')))]),_c('p',[_vm._v(_vm._s(_vm.$t('marketplace.locationsSectionHint')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('location_id') }},[_c('label',{attrs:{"for":"wolt-location_id"}},[_vm._v(_vm._s(_vm.$t('marketplace.menuLocation'))),(_vm.isRequired('location_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.location_id),expression:"formData.location_id"}],staticClass:"form-control",attrs:{"id":"wolt-location_id","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'wolt-loc-' + String(loc._integrationLocationId),domProps:{"value":loc._integrationLocationId}},[_vm._v("\n          "+_vm._s(loc.name)+"\n        ")])})],2),_vm._v(" "),_c('p',{staticClass:"marketplace-field-hint"},[_vm._v(_vm._s(_vm.$t('marketplace.menuHint')))]),_vm._v(" "),(_vm.showFieldError('location_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('location_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('orders_location_id') }},[_c('label',{attrs:{"for":"wolt-orders_location_id"}},[_vm._v(_vm._s(_vm.$t('marketplace.ordersLocation'))),(_vm.isRequired('orders_location_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.orders_location_id),expression:"formData.orders_location_id"}],staticClass:"form-control",attrs:{"id":"wolt-orders_location_id","disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "orders_location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'wolt-orders-loc-' + String(loc._integrationLocationId),domProps:{"value":_vm.locationOptionValue(loc)}},[_vm._v("\n          "+_vm._s(loc.name)+"\n        ")])})],2),_vm._v(" "),_c('p',{staticClass:"marketplace-field-hint"},[_vm._v(_vm._s(_vm.$t('marketplace.ordersHint')))]),_vm._v(" "),(_vm.showFieldError('orders_location_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('orders_location_id')))]):_vm._e()])])])]),_vm._v(" "),_c('section',{staticClass:"marketplace-action-panel marketplace-setup-panel"},[_c('div',{staticClass:"marketplace-action-heading"},[_c('i',{staticClass:"ti-key",attrs:{"aria-hidden":"true"}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('marketplace.credentials')))]),_c('p',[_vm._v(_vm._s(_vm.$t('marketplace.credentialsSectionHint')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('api_url') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('api_url'))),(_vm.isRequired('api_url'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.api_url),expression:"formData.api_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.api_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "api_url", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('api_url'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('api_url')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('api_key') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('api_key'))),(_vm.isRequired('api_key'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.api_key),expression:"formData.api_key"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.api_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "api_key", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('api_key'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('api_key')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('client_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('client_id'))),(_vm.isRequired('client_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.client_id),expression:"formData.client_id"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.client_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "client_id", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('client_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('client_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('client_secret') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('client_secret'))),(_vm.isRequired('client_secret'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.client_secret),expression:"formData.client_secret"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.client_secret)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "client_secret", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('client_secret'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('client_secret')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('venue_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('venue_id'))),(_vm.isRequired('venue_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.venue_id),expression:"formData.venue_id"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.venue_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "venue_id", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('venue_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('venue_id')))]):_vm._e()])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b8hO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bEDA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bFWQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("Yq4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_dialog__ = __webpack_require__("qubY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_select__);
























var _components;







__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_23_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_item___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_dialog___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_dialog___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_menu___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_menu___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_item___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_dropdown_item___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_25_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'vSelect', __WEBPACK_IMPORTED_MODULE_26_vue_select___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      campaignId: null,
      availabilityRange: [],
      locations: [],
      locationsFormatted: [],
      rewards: [],
      nextDraftRewardId: 1,
      rewardSaving: false,
      giftCardModuleEnabled: null,
      model: {
        name: '',
        description: '',
        active: true
      },
      rewardDialogVisible: false,
      editingReward: null,
      rewardForm: {
        type: 1,
        category_id: null,
        catalogproduct_id: null,
        gift_card_value: null,
        loyalty_points_cost: 1,
        active: true
      },
      categoryOptions: [],
      categoriesLoading: false,
      productOptions: [],
      productsLoading: false
    };
  },

  computed: {
    giftCardsEnabled: function giftCardsEnabled() {
      var company = this.$session.get('selectedCompanyData') || {};
      var value = this.giftCardModuleEnabled === null ? company.use_marketing_gift_card : this.giftCardModuleEnabled;
      return value === true || value === 1 || value === '1' || value === 'true';
    }
  },
  created: function created() {
    var fromProp = this.route && this.route.params && this.route.params.id;
    var fromRouter = this.$route && this.$route.params && this.$route.params.id;
    this.campaignId = fromProp || fromRouter || null;
    this.loadLocations();
    this.loadCompanyFeatures();
    if (this.campaignId) {
      this.loadCampaign();
    }
  },

  methods: {
    loadCompanyFeatures: function loadCompanyFeatures() {
      var _this = this;

      var companyId = this.$session.get('selectedCompany');
      this.apiRequest('/settings/general/' + companyId, 'GET', { token: this.$session.get('token') }, function (response) {
        var company = response.status && response.data && response.data[0];
        if (!company || company.use_marketing_gift_card === undefined) return;
        _this.giftCardModuleEnabled = company.use_marketing_gift_card;
        var session = _this.$session.get('selectedCompanyData') || {};
        _this.$session.set('selectedCompanyData', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, session, { use_marketing_gift_card: company.use_marketing_gift_card }));
      });
    },
    isGiftReward: function isGiftReward(row) {
      return Number(row.type) === 2 || row.type_label === 'gift_card';
    },
    rewardTypeLabel: function rewardTypeLabel(row) {
      return this.isGiftReward(row) ? this.$t('loyaltyStore.typeGiftCard') : this.$t('loyaltyStore.typeProduct');
    },
    backButton: function backButton() {
      this.$bus.$emit('close-modal');
    },
    loadLocations: function loadLocations() {
      this.setLocationsFromSession();
    },
    setLocationsFromSession: function setLocationsFromSession() {
      var company = this.$session.get('selectedCompanyData') || {};
      var locs = company.locations_details || [];
      this.locations = locs.map(function (l) {
        return {
          id: l.true_id || l.id,
          name: l.name
        };
      });
    },
    loadCampaign: function loadCampaign() {
      var _this2 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/loyalty-store-campaigns/' + this.campaignId, 'GET', data, function (response) {
        _this2.loading = false;
        if (!response.status || !response.data) {
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
          return;
        }
        var item = response.data;
        _this2.model.name = item.name || '';
        _this2.model.description = item.description || '';
        _this2.model.active = !!item.active;
        _this2.availabilityRange = [];
        if (item.starts_at || item.ends_at) {
          var from = item.starts_at ? String(item.starts_at).substring(0, 10) : null;
          var to = item.ends_at ? String(item.ends_at).substring(0, 10) : null;
          if (from || to) _this2.availabilityRange = [from || to, to || from];
        }
        var ids = item.location_ids || [];
        _this2.locationsFormatted = _this2.locations.filter(function (loc) {
          return ids.map(Number).includes(Number(loc.id));
        });
        _this2.rewards = item.rewards || [];
        _this2.$nextTick(function () {
          return _this2.layoutRewardsTable();
        });
      });
    },
    layoutRewardsTable: function layoutRewardsTable() {
      var table = this.$refs.rewardsTable;
      if (table && typeof table.doLayout === 'function') {
        table.doLayout();
      }
    },
    payload: function payload() {
      var range = this.availabilityRange || [];
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        name: this.model.name,
        description: this.model.description,
        active: this.model.active ? 1 : 0,
        starts_at: range[0] || null,
        ends_at: range[1] || null,
        location_ids: (this.locationsFormatted || []).map(function (l) {
          return l.id;
        })
      };
    },
    save: function save() {
      var _this3 = this;

      if (this.loading || this.rewardSaving) return;
      if (!this.model.name || !String(this.model.name).trim()) {
        __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', this.$t('loyaltyStore.nameRequired'), 'error');
        return;
      }
      this.loading = true;
      var body = this.payload();
      var done = function done(response) {
        if (!response.status) {
          _this3.loading = false;
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error');
          return;
        }
        if (!_this3.campaignId) {
          if (!response.data || !response.data.id) {
            _this3.loading = false;
            __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error');
            return;
          }
          _this3.campaignId = response.data.id;
        }
        _this3.saveDraftRewards(function () {
          _this3.loading = false;
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()(_this3.$t('general.success') + '!', '', 'success').catch(function () {});
          _this3.$bus.$emit('refresh');
          _this3.loadCampaign();
        });
      };
      if (this.campaignId) {
        this.apiRequest('/loyalty-store-campaigns/' + this.campaignId, 'PUT', body, done);
      } else {
        this.apiRequest('/loyalty-store-campaigns', 'POST', body, done);
      }
    },
    rewardPayload: function rewardPayload(reward) {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        type: reward.type,
        catalogproduct_id: reward.type === 1 ? reward.catalogproduct_id : null,
        gift_card_value: reward.type === 2 ? reward.gift_card_value : null,
        loyalty_points_cost: reward.loyalty_points_cost,
        active: reward.active ? 1 : 0
      };
    },
    saveDraftRewards: function saveDraftRewards(done) {
      var _this4 = this;

      var index = this.rewards.findIndex(function (reward) {
        return reward._draftId;
      });
      if (index === -1) {
        done();
        return;
      }
      var reward = this.rewards[index];
      this.apiRequest('/loyalty-store-campaigns/' + this.campaignId + '/rewards', 'POST', this.rewardPayload(reward), function (response) {
        if (!response.status || !response.data || !response.data.id) {
          _this4.loading = false;
          _this4.$bus.$emit('refresh');
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', _this4.$t('loyaltyStore.rewardsSaveFailed'), 'error');
          return;
        }

        _this4.rewards.splice(index, 1, response.data);
        _this4.saveDraftRewards(done);
      });
    },
    handleDelete: function handleDelete() {
      var _this5 = this;

      if (this.loading || this.rewardSaving) return;
      __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
        title: this.$t('loyaltyStore.deleteConfirmation'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then(function (result) {
        if (result !== true && !(result && result.value === true)) return;
        var data = {
          token: _this5.$session.get('token'),
          company_id: _this5.$session.get('selectedCompany')
        };
        _this5.apiRequest('/loyalty-store-campaigns/' + _this5.campaignId, 'DELETE', data, function (response) {
          if (response.status) {
            _this5.$bus.$emit('refresh');
            _this5.$bus.$emit('close-modal');
          } else {
            __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', _this5.$t('validations.wentWrong'), 'error');
          }
        });
      }).catch(function () {});
    },
    openRewardForm: function openRewardForm(row) {
      if (this.loading || this.rewardSaving) return;
      this.editingReward = row || null;
      if (row) {
        this.rewardForm = {
          type: Number(row.type) === 2 ? 2 : 1,
          category_id: row.product && row.product.category_id || row.category_id || null,
          catalogproduct_id: row.catalogproduct_id || null,
          gift_card_value: row.gift_card_value,
          loyalty_points_cost: row.loyalty_points_cost,
          active: !!row.active
        };
        if (row.product) {
          this.productOptions = [row.product];
          if (row.product.category_id) {
            this.categoryOptions = [{
              id: row.product.category_id,
              name: row.product.category_name || '#' + row.product.category_id
            }];
          }
        }
      } else {
        this.rewardForm = {
          type: 1,
          category_id: null,
          catalogproduct_id: null,
          gift_card_value: null,
          loyalty_points_cost: 1,
          active: true
        };
        this.productOptions = [];
        this.categoryOptions = [];
      }
      this.rewardDialogVisible = true;
      this.searchCategories('');
      this.searchProducts('');
    },
    loyaltyPickerBaseUrl: function loyaltyPickerBaseUrl() {
      return this.campaignId ? '/loyalty-store-campaigns/' + this.campaignId : '/loyalty-store-campaigns';
    },
    pickerLocationIds: function pickerLocationIds() {
      return (this.locationsFormatted || []).map(function (l) {
        return l.id;
      }).filter(function (id) {
        return id != null && id !== '';
      });
    },
    appendPickerLocationParams: function appendPickerLocationParams(data) {
      var ids = this.pickerLocationIds();

      data.location_ids = ids;
      return data;
    },
    onCategoryDropdown: function onCategoryDropdown(visible) {
      if (visible && !this.categoryOptions.length) this.searchCategories('');
    },
    onProductDropdown: function onProductDropdown(visible) {
      if (visible && !this.productOptions.length) this.searchProducts('');
    },
    onCategoryChange: function onCategoryChange() {
      this.rewardForm.catalogproduct_id = null;
      this.productOptions = [];
      this.searchProducts('');
    },
    searchCategories: function searchCategories(query) {
      var _this6 = this;

      this.categoriesLoading = true;
      var data = this.appendPickerLocationParams({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query || '',
        per_page: 20
      });
      this.apiRequest(this.loyaltyPickerBaseUrl() + '/available-categories', 'GET', data, function (response) {
        _this6.categoriesLoading = false;
        if (!response.status) return;
        var d = response.data;
        var options = Array.isArray(d) ? d : d && d.data ? d.data : [];
        var selectedId = _this6.rewardForm.category_id;
        if (selectedId && !options.some(function (c) {
          return Number(c.id) === Number(selectedId);
        })) {
          var existing = _this6.categoryOptions.find(function (c) {
            return Number(c.id) === Number(selectedId);
          });
          if (existing) options = [existing].concat(options);
        }
        _this6.categoryOptions = options;
      });
    },
    searchProducts: function searchProducts(query) {
      var _this7 = this;

      this.productsLoading = true;
      var data = this.appendPickerLocationParams({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query || '',
        per_page: 20
      });
      if (this.rewardForm.category_id) {
        data.category_id = this.rewardForm.category_id;
      }
      this.apiRequest(this.loyaltyPickerBaseUrl() + '/available-products', 'GET', data, function (response) {
        _this7.productsLoading = false;
        if (!response.status) return;
        var d = response.data;
        var options = Array.isArray(d) ? d : d && d.data ? d.data : [];
        var selectedId = _this7.rewardForm.catalogproduct_id;
        if (selectedId && !options.some(function (p) {
          return Number(p.id) === Number(selectedId);
        })) {
          var existing = _this7.productOptions.find(function (p) {
            return Number(p.id) === Number(selectedId);
          });
          if (existing) options = [existing].concat(options);
        }
        _this7.productOptions = options;
      });
    },
    saveReward: function saveReward() {
      var _this8 = this;

      if (this.loading || this.rewardSaving) return;
      if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(this.rewardForm.loyalty_points_cost) || this.rewardForm.loyalty_points_cost < 1) {
        __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', this.$t('loyaltyStore.pointsCostRequired'), 'error');
        return;
      }
      if (this.rewardForm.type === 1 && !this.rewardForm.catalogproduct_id) {
        __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', this.$t('loyaltyStore.productRequired'), 'error');
        return;
      }
      if (this.rewardForm.type === 2 && (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(this.rewardForm.gift_card_value) || this.rewardForm.gift_card_value <= 0)) {
        __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', this.$t('loyaltyStore.giftValueRequired'), 'error');
        return;
      }
      if (this.rewardForm.type === 2 && !this.giftCardsEnabled) {
        __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', this.$t('loyaltyStore.giftCardsModuleRequired'), 'error');
        return;
      }
      var body = this.rewardPayload(this.rewardForm);
      if (!this.campaignId || this.editingReward && this.editingReward._draftId) {
        var product = this.rewardForm.type === 1 ? this.productOptions.find(function (p) {
          return Number(p.id) === Number(_this8.rewardForm.catalogproduct_id);
        }) : null;
        var draft = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.rewardForm, {
          _draftId: this.editingReward ? this.editingReward._draftId : this.nextDraftRewardId++,
          product: product,
          name: product ? product.name : this.$t('loyaltyStore.typeGiftCard')
        });
        var index = this.rewards.indexOf(this.editingReward);
        if (index === -1) this.rewards.push(draft);else this.rewards.splice(index, 1, draft);
        this.rewardDialogVisible = false;
        this.$nextTick(function () {
          return _this8.layoutRewardsTable();
        });
        return;
      }
      this.rewardSaving = true;
      var done = function done(response) {
        _this8.rewardSaving = false;
        if (!response.status) {
          var msg = response.errors && (response.errors.type || response.errors.catalogproduct_id || response.errors.gift_card_value) || _this8.$t('validations.wentWrong');
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', Array.isArray(msg) ? msg[0] : msg, 'error');
          return;
        }
        _this8.rewardDialogVisible = false;
        var index = _this8.rewards.indexOf(_this8.editingReward);
        if (index === -1) _this8.rewards.push(response.data);else _this8.rewards.splice(index, 1, response.data);
        _this8.$nextTick(function () {
          return _this8.layoutRewardsTable();
        });
      };
      if (this.editingReward && this.editingReward.id) {
        this.apiRequest('/loyalty-store-rewards/' + this.editingReward.id, 'PUT', body, done);
      } else {
        this.apiRequest('/loyalty-store-campaigns/' + this.campaignId + '/rewards', 'POST', body, done);
      }
    },
    deleteReward: function deleteReward(row) {
      var _this9 = this;

      if (this.loading || this.rewardSaving) return;
      __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
        title: this.$t('loyaltyStore.deleteConfirmation'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then(function (result) {
        if (result !== true && !(result && result.value === true)) return;
        if (row._draftId) {
          _this9.rewards.splice(_this9.rewards.indexOf(row), 1);
          return;
        }
        var data = {
          token: _this9.$session.get('token'),
          company_id: _this9.$session.get('selectedCompany')
        };
        _this9.apiRequest('/loyalty-store-rewards/' + row.id, 'DELETE', data, function (response) {
          if (response.status) _this9.rewards = _this9.rewards.filter(function (reward) {
            return reward !== row;
          });else __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', _this9.$t('validations.wentWrong'), 'error');
        });
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "bFdq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bFwK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.nexusReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100 mar-bt-15"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('general.orderId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedOrderId),expression:"selectedOrderId"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"price","placeholder":"3823231"},domProps:{"value":(_vm.selectedOrderId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedOrderId=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100 mar-bt-15"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('nexus.nexusOrderId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedNexusOrderId),expression:"selectedNexusOrderId"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"nexus_order_id","placeholder":"12345"},domProps:{"value":(_vm.selectedNexusOrderId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedNexusOrderId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100 mar-bt-15"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('catalogProd.status')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.types,"label":"name","name":"type-select","placeholder":_vm.$t('catalogProd.status')},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('p',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('nexus.markResend')},on:{"click":function($event){_vm.bulkUpdateStatus(0)}}},[_c('i',{staticClass:"ti-reload"}),_vm._v("   "+_vm._s(_vm.$t('nexus.markResend'))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();_vm.bulkUpdateStatus(5)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('nexus.markCancellation'))+"\n          ")])]),_vm._v(" "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":00")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 nexus-table-wrap",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"card-content total-pagination reports-center-columns",staticStyle:{"width":"100%"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsTable",staticClass:"report-sales",attrs:{"data":_vm.ordersTableData.data,"search-def":{show: false},"total":_vm.ordersTableData.total,"pagination-props":_vm.paginationProps,"table-props":{'row-class-name': _vm.rowClass}},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":50,"prop":"id","label":"Id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"order_id","label":_vm.$t('reports.orderId')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"location_id","label":_vm.$t('reports.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.getLocationName(props.row.location_id))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"order_created_at","label":_vm.$t('nexus.pickupDatetime')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.order_created_at ? _vm.formatToCompanyTimezone(props.row.order_created_at, _vm.timezone) : '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"totals_grandtotal","label":_vm.$t('reports.orderTotal')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.totals_grandtotal || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":90,"prop":"payment_type","label":_vm.$t('nexus.paymentType')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.translatePaymentType(props.row.payment_type))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":110,"prop":"order_status","label":_vm.$t('nexus.orderStatus')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.translateOrderStatus(props.row.order_status))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":140,"prop":"is_sent","label":_vm.$t('nexus.isSent')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.$t('nexus.sentStatus' + props.row.is_sent))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":90,"prop":"retry_count","label":_vm.$t('nexus.retryCount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.retry_count != null ? props.row.retry_count : '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"retry_at","label":_vm.$t('nexus.retryAt')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.retry_at ? _vm.formatToCompanyTimezone(props.row.retry_at, _vm.timezone) : '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"receipt_number","label":_vm.$t('nexus.receiptNumber')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.parseReceiptNumber(props.row.receipt_number))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":110,"prop":"created_at","label":_vm.$t('charisma.createDate')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatToCompanyTimezone(props.row.created_at, _vm.timezone))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"align-campaign-info",attrs:{"min-width":160,"prop":"actions","label":_vm.$t('marketingCampaigns.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"display-flex",staticStyle:{"align-items":"center","margin":"auto"}},[_c('a',{staticClass:"btn btn-icon btn-success mar-rt-10",attrs:{"title":_vm.$t('nexus.markResend')},on:{"click":function($event){_vm.rowUpdateStatus(props.row.id, 0)}}},[_c('i',{staticClass:"ti-reload"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-icon btn-danger mar-rt-10",attrs:{"title":_vm.$t('nexus.markCancellation')},on:{"click":function($event){_vm.rowUpdateStatus(props.row.id, 5)}}},[_c('i',{staticClass:"ti-close"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-icon btn-purple",attrs:{"title":_vm.$t('marketingCampaigns.open')},on:{"click":function($event){_vm.goToItems(props.row)}}},[_c('i',{staticClass:"ti-angle-right"})])])]}}])})],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bGFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('referral-campaign-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bJkY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      tableData: [{
        date: '2024-11-01',
        action: 'Updated',
        document: 'Doc123',
        details: 'Updated the record details',
        payments: '200',
        collections: '150',
        balance: '50'
      }],
      form: {
        date: '',
        document: '',
        reason: '',
        value: ''
      }
    };
  },

  methods: {
    addCasaRegister: function addCasaRegister() {
      this.$modal.show('casaRegisterModal');
    }
  }
});

/***/ }),

/***/ "bK1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pad-to-15"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 form-group"},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.groups')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.statusOptions,"label":"label","placeholder":"Select status"},on:{"input":_vm.fetchData},model:{value:(_vm.selectedStatus),callback:function ($$v) {_vm.selectedStatus=$$v},expression:"selectedStatus"}})],1),_vm._v(" "),_c('a',{staticClass:"btn add mar-rt-10 mar-lt-20 mar-to-25",attrs:{"title":_vm.$t('general.deny')},on:{"click":function($event){_vm.handleAccept(0, 1)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.accept'))+" "+_vm._s(_vm.$t('general.all'))+"\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn delete mar-rt-10 mar-to-25",attrs:{"title":_vm.$t('general.deny')},on:{"click":function($event){_vm.handleAccept(0, 0)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.deny'))+" "+_vm._s(_vm.$t('general.all'))+"\n                ")]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"campaign-table width-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.pendingRequests,"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDefPending,"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":45,"prop":"id","label":"ID"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                    "+_vm._s(props.row.id)+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":45,"prop":"email","label":"Email"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                    "+_vm._s(props.row.user.email)+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":45,"prop":"created_at","label":_vm.$t('general.registrationDate')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                    "+_vm._s(props.row.created_at)+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":50,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(!_vm.selectedStatus.value)?_c('div',{staticClass:"display-flex",staticStyle:{"align-items":"center"}},[_c('a',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.accept')},on:{"click":function($event){_vm.handleAccept(props.row.id, 1)}}},[_vm._v("\n                                "+_vm._s(_vm.$t('general.accept'))+"\n                            ")]),_vm._v(" "),_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('general.deny')},on:{"click":function($event){_vm.handleAccept(props.row.id, 0)}}},[_vm._v("\n                                "+_vm._s(_vm.$t('general.deny'))+"\n                            ")])]):_c('div',{staticClass:"display-flex",staticStyle:{"align-items":"center"}},[(props.row.is_approved)?_c('a',{staticClass:"btn add mar-rt-10",staticStyle:{"pointer-events":"none","cursor":"default"},attrs:{"title":_vm.$t('general.accept')}},[_vm._v("\n                                "+_vm._s(_vm.$t('general.accepted'))+"\n                            ")]):_vm._e(),_vm._v(" "),(!props.row.is_approved)?_c('a',{staticClass:"btn delete mar-rt-10",staticStyle:{"pointer-events":"none","cursor":"default"},attrs:{"title":_vm.$t('general.deny')}},[_vm._v("\n                                "+_vm._s(_vm.$t('general.denied'))+"\n                            ")]):_vm._e()])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"active-pagination width-table",attrs:{"total":_vm.paginationDefPending.totalRecords,"page-size":_vm.paginationDefPending.perPage,"pager-count":_vm.pagerCount,"current-page":_vm.paginationDefPending.page,"layout":"prev, pager, next, total"},on:{"current-change":function($event){_vm.handlePageChange($event)},"prev-click":function($event){_vm.handlePageChange($event)},"next-click":function($event){_vm.handlePageChange($event)}}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bLKJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuedraggable__);











var _components;







__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'draggable', __WEBPACK_IMPORTED_MODULE_13_vuedraggable___default.a), _components),
  data: function data() {
    return {
      apiUrl: '',
      id: this.route.params.id || null,
      isNew: true,
      model: {
        'name': '',
        'statuses': []
      },
      modelValidate: {
        name: { required: true }
      },
      deliveryMethods: [],
      deleteStatuses: [],
      loading: true
    };
  },

  props: {
    callback: {
      required: false
    },
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    ID: function ID() {
      return this.route.params.id || null;
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.deliveryMethods = this.getCompanyDetail('delivery_options_labels');
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (this.route.params.id !== undefined && this.route.params.id || this.id !== undefined && this.id !== null) {
        this.isNew = false;
      } else {
        this.isNew = true;
      }
      if (!this.isNew) {
        var id = this.route.params.id || this.id;
        this.apiRequest('/sections/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            _this.model = response.data;
            _this.loading = false;
          }
        });
      } else {
        this.loading = false;
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveKdsSection();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    saveKdsSection: function saveKdsSection() {
      var _this3 = this;

      this.loading = true;
      var data = this.model;
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      var id = this.id || this.route.params.id;

      if (id) {
        data.delete_statuses = this.deleteStatuses;
        this.apiRequest('/sections/' + data.id, 'PUT', data, function (response) {
          if (response.status) {
            _this3.loading = false;
            _this3.errors.clear();
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this3.$t('general.success'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then(function () {}).catch(function () {});
            _this3.handleBack();
          } else {
            _this3.loading = false;
            _this3.handleErrors(response.errors);
          }
        });
      } else {
        this.apiRequest('/sections/', 'POST', data, function (response) {
          if (response.status) {
            _this3.loading = false;
            _this3.errors.clear();
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this3.$t('general.success'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then(function () {}).catch(function () {});
            _this3.handleBack();
          } else {
            _this3.loading = false;
            _this3.handleErrors(response.errors);
          }
        });
      }
    },
    handleDelete: function handleDelete() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        title: this.$t('general.generalAreYouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this4.deleteKdsSection();
        }
      });
    },
    deleteKdsSection: function deleteKdsSection() {
      var _this5 = this;

      this.loading = true;
      var id = this.id || this.route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/sections/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          _this5.loading = false;
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            title: _this5.$t('general.success'),
            type: 'success'
          });
          _this5.handleBack();
        } else {
          _this5.loading = false;
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            title: _this5.$t('general.error'),
            type: 'error'
          });
        }
      });
    },
    handleBack: function handleBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    addNewStatus: function addNewStatus() {
      var newRow = {
        'id': null,
        'company_id': this.$session.get('selectedCompany'),
        'location_id': this.model.location_id,
        'name': null,
        'delivery_methods': []
      };
      this.model.statuses.push(newRow);
    },
    deleteStatus: function deleteStatus(status, index) {
      if (status.id) {
        this.deleteStatuses.push(status);
      }
      this.model['statuses'].splice(index, 1);
    }
  }
});

/***/ }),

/***/ "bLSn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntegrationMenuTopCategoriesField',
  props: {
    formData: {
      type: Object,
      required: true
    },
    topCategories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    showFilterNote: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectedIds: []
    };
  },

  computed: {
    fieldLabel: function fieldLabel() {
      if (typeof this.fieldLabelFn === 'function') {
        return this.fieldLabelFn('menu_top_categories');
      }
      return this.$t('gestiune.integrationsFields.menu_top_categories');
    },
    activeTopCategories: function activeTopCategories() {
      return (this.topCategories || []).filter(function (item) {
        return item && item.active !== false && item.active !== 0;
      });
    }
  },
  watch: {
    'formData.menu_top_categories': {
      immediate: true,
      deep: true,
      handler: function handler(value) {
        this.selectedIds = this.normalizeIds(value);
      }
    }
  },
  created: function created() {
    this.ensureDefault();
  },

  methods: {
    normalizeIds: function normalizeIds(value) {
      if (!Array.isArray(value)) return [];
      return value.map(function (id) {
        var n = Number(id);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(n) ? id : n;
      }).filter(function (id) {
        return id !== null && id !== undefined && id !== '';
      });
    },
    ensureDefault: function ensureDefault() {
      if (!Array.isArray(this.formData.menu_top_categories)) {
        this.$set(this.formData, 'menu_top_categories', []);
      }
    },
    onSelectionChange: function onSelectionChange(value) {
      var ids = this.normalizeIds(value);
      this.$set(this.formData, 'menu_top_categories', ids);
    }
  }
});

/***/ }),

/***/ "bQL1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-top-bar"},[_c('div',{staticClass:"top-bar-image"},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":"Top Bar Icon"}})]),_vm._v(" "),_c('div',{staticClass:"page-title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bQaV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignAdd_vue__ = __webpack_require__("RX1z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68e2bd11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignAdd_vue__ = __webpack_require__("EfBi");
function injectStyle (ssrContext) {
  __webpack_require__("CFH9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68e2bd11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bRYy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bSoM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosTabs_vue__ = __webpack_require__("3IFN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d5fa1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosTabs_vue__ = __webpack_require__("I2DY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d5fa1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bTak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementStocks_vue__ = __webpack_require__("aPmv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4189a5c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementStocks_vue__ = __webpack_require__("9ke0");
function injectStyle (ssrContext) {
  __webpack_require__("Gtju")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4189a5c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementStocks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4189a5c9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementStocks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bUkZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementAvizForm_vue__ = __webpack_require__("1P1l");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ManagementAvizForm', __WEBPACK_IMPORTED_MODULE_7__ManagementAvizForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "bV0d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProformaForm_vue__ = __webpack_require__("6HlB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_266d253f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProformaForm_vue__ = __webpack_require__("KTmZ");
function injectStyle (ssrContext) {
  __webpack_require__("eU8U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-266d253f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProformaForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_266d253f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProformaForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bWcp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreenEdit_vue__ = __webpack_require__("ar4A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4892771a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreenEdit_vue__ = __webpack_require__("04fd");
function injectStyle (ssrContext) {
  __webpack_require__("epYj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderScreenEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4892771a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderScreenEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bbzh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-options row"},[_c('div',{ref:"optionsContainer",staticClass:"col-lg-12 col-md-10 col-sm-12 ",style:({height: _vm.windowHeight - _vm.pageTopHeight - _vm.navbarHeaderHeight - 1 + 'px'})},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix "},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-right",staticStyle:{"position":"relative","z-index":"2"}},[_c('button',{staticClass:"btn btn-icon btn-success mar-bt-20 save",attrs:{"type":"submit","title":_vm.$t('general.update')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.update'))+"\n              ")])])]),_vm._v(" "),_c('table',{staticClass:"table width-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"1%"}}),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.type')))]),_vm._v(" "),(_vm.showLocations)?_c('th',{attrs:{"width":"40%"}},[_vm._v(_vm._s(_vm.$t('catalogProd.availableIn')))]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"width":"25%"}},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.values'))+" ")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.model),function(filter,key){return _c('tr',[_c('td',[_c('button',{staticClass:"btn btn-icon btn-danger",attrs:{"title":_vm.$t('general.remove') + ' ' + _vm.$t('filter.filter')},on:{"click":function($event){$event.preventDefault();_vm.deleteFilter(filter.id)}}},[_c('i',{staticClass:"ti-close"})])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.type),expression:"filter.type"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('catalogProdOpt.name')},domProps:{"value":(filter.type)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter, "type", $event.target.value)}}})]),_vm._v(" "),(_vm.showLocations)?_c('td',[[_c('v-select',{key:'option' + filter.id,ref:'option' + filter.id,refInFor:true,attrs:{"multiple":"","options":_vm.locations,"value":"id","label":"name","placeholder":_vm.$t('general.all')},model:{value:(filter.location_ids),callback:function ($$v) {_vm.$set(filter, "location_ids", $$v)},expression:"filter.location_ids"}})]],2):_vm._e(),_vm._v(" "),_c('td',[_vm._l((filter.filter_value),function(val,key){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(val.value),expression:"val.value"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control mid mar-bt-5",attrs:{"type":"text","placeholder":""},domProps:{"value":(val.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(val, "value", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.deleteValue(filter.id, val.id)}}},[_c('i',{staticClass:"ti-close text-orange",attrs:{"title":_vm.$t('general.delete')}})]),_vm._v(" "),_c('br')]}),_vm._v(" "),_c('button',{staticClass:"btn add",on:{"click":function($event){$event.preventDefault();_vm.addNewValue(filter.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.value')))])],2),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-icon btn-info duplicate",attrs:{"title":_vm.$t('general.duplicate') + ' ' + _vm.$t('filter.filter')},on:{"click":function($event){$event.preventDefault();_vm.duplicateOption(filter.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/duplicate.png"}})])])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_c('button',{staticClass:"btn  add",on:{"click":function($event){$event.preventDefault();_vm.addNewOption()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('filter.filter')))])])])],2)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "beEL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bfPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ReferralRewardRule_vue__ = __webpack_require__("kdQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__referralCampaignDelete__ = __webpack_require__("N471");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__referralRewardSettings__ = __webpack_require__("g/71");








var _components;









__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ReferralRewardRule', __WEBPACK_IMPORTED_MODULE_10__ReferralRewardRule_vue__["a" /* default */]), _components),
  props: { route: { type: Object, default: function _default() {
        return {};
      } } },
  data: function data() {
    return {
      fieldErrors: {},
      loading: false,
      saving: false,
      loyaltyInUse: false,
      campaignId: null,
      availabilityRange: null,
      maxOrdersInput: '',
      rewardType: 'LOYALTY_POINTS',
      roles: __WEBPACK_IMPORTED_MODULE_12__referralRewardSettings__["a" /* rewardRoles */],
      cashbackRoles: __WEBPACK_IMPORTED_MODULE_12__referralRewardSettings__["c" /* cashbackRoles */],
      rewardSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__referralRewardSettings__["d" /* hydrateRewardSettings */])(),
      cashbackEnabled: false,
      coupons: [],
      couponsLoading: false,
      couponsLoadFailed: false,
      model: { name: '', active: true, is_visible_for_users: false, starts_at: null, ends_at: null, order_rewards_active: false }
    };
  },

  computed: {
    loyaltyPointsEnabled: function loyaltyPointsEnabled() {
      return this.loyaltyInUse;
    },
    defaultRewardType: function defaultRewardType() {
      return this.rewardType === 'WALLET' ? 2 : 1;
    },
    campaignIdFromRoute: function campaignIdFromRoute() {
      var fromProp = this.route && this.route.params && this.route.params.id;
      var fromRouter = this.$route && this.$route.params && this.$route.params.id;
      var id = fromProp != null && fromProp !== '' ? fromProp : fromRouter;
      return id != null && id !== '' ? id : null;
    },
    orderRewardsSummaryText: function orderRewardsSummaryText() {
      return this.rewardSummary('order_reward');
    },
    cashbackSummaryText: function cashbackSummaryText() {
      return this.cashbackEnabled ? this.rewardSummary('cashback') : this.$t('referralProgram.rewardSummaryDisabled');
    }
  },
  created: function created() {
    this.syncLoyaltyInUse();
    this.loadCoupons();
    this.$bus.$on('company-data-updated', this.onCompanyDataUpdated);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('company-data-updated', this.onCompanyDataUpdated);
  },

  watch: {
    campaignIdFromRoute: {
      immediate: true,
      handler: function handler(id) {
        this.campaignId = id;
        if (id != null) this.loadCampaign();
      }
    },
    availabilityRange: function availabilityRange(val) {
      this.model.starts_at = val && val.length === 2 ? val[0] : null;
      this.model.ends_at = val && val.length === 2 ? val[1] : null;
    }
  },
  methods: {
    rewardSummary: function rewardSummary(aspect) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__referralRewardSettings__["e" /* summarizeRewards */])({ reward_type: this.defaultRewardType,
        reward_settings: this.rewardSettings,
        order_rewards_active: this.model.order_rewards_active }, aspect, this.$t.bind(this), this.coupons);
    },
    clearFieldError: function clearFieldError(field) {
      this.$delete(this.fieldErrors, field);
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    goToLoyaltySettings: function goToLoyaltySettings() {
      var _this = this;

      this.$bus.$emit('close-modal');

      this.$nextTick(function () {
        _this.$router.push({ path: '/marketing', query: { tabIndex: 15 } }).catch(function () {});
      });
    },
    syncLoyaltyInUse: function syncLoyaltyInUse(companyData) {
      var data = companyData || this.$session.get('selectedCompanyData') || {};
      this.loyaltyInUse = data.loyalty_in_use === true || data.loyalty_in_use === 1 || data.loyalty_in_use === '1' || data.loyalty_in_use === 'true';
      if (!this.campaignId && !this.loyaltyInUse) this.rewardType = 'WALLET';
    },
    onCompanyDataUpdated: function onCompanyDataUpdated(companyData) {
      if (companyData && Number(companyData.id) === Number(this.$session.get('selectedCompany'))) this.syncLoyaltyInUse(companyData);
    },
    sessionPayload: function sessionPayload() {
      return { token: this.$session.get('token'), company_id: this.$session.get('selectedCompany') };
    },
    loadCoupons: function loadCoupons() {
      var _this2 = this;

      this.couponsLoading = true;
      this.couponsLoadFailed = false;
      this.apiRequest('/referral-campaign/coupon-options', 'GET', this.sessionPayload(), function (response) {
        _this2.couponsLoading = false;
        if (response.status) {
          var data = response.data && response.data.data ? response.data.data : response.data;
          _this2.coupons = Array.isArray(data) ? data : [];
        } else {
          _this2.couponsLoadFailed = true;
        }
      });
    },
    payload: function payload() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.sessionPayload(), {
        name: this.model.name.trim(),
        active: this.model.active,
        is_visible_for_users: this.model.is_visible_for_users,
        order_rewards_active: this.model.order_rewards_active,
        max_orders_for_order_rewards: String(this.maxOrdersInput).trim() === '' ? null : Number(this.maxOrdersInput),
        reward_type: this.defaultRewardType,
        reward_settings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__referralRewardSettings__["f" /* serializeRewardSettings */])(this.rewardSettings, this.cashbackEnabled),
        datetime_validfrom: this.model.starts_at ? this.model.starts_at + ' 00:00:00' : null,
        datetime_validto: this.model.ends_at ? this.model.ends_at + ' 23:59:59' : null
      });
    },
    applyRecord: function applyRecord(row) {
      var _this3 = this;

      var isEnabled = function isEnabled(value) {
        return value === true || value === 1 || value === '1';
      };
      this.model.name = row.name || '';
      this.model.active = row.active == null ? true : isEnabled(row.active);
      this.model.is_visible_for_users = isEnabled(row.is_visible_for_users);
      this.model.order_rewards_active = isEnabled(row.order_rewards_active);
      this.model.starts_at = row.datetime_validfrom ? String(row.datetime_validfrom).slice(0, 10) : null;
      this.model.ends_at = row.datetime_validto ? String(row.datetime_validto).slice(0, 10) : null;

      if (this.model.starts_at && this.model.ends_at) this.availabilityRange = [this.model.starts_at, this.model.ends_at];
      this.maxOrdersInput = row.max_orders_for_order_rewards == null || Number(row.max_orders_for_order_rewards) <= 0 ? '' : String(row.max_orders_for_order_rewards);
      this.rewardType = Number(row.reward_type) === 2 || String(row.reward_type).toUpperCase() === 'WALLET' ? 'WALLET' : 'LOYALTY_POINTS';
      this.rewardSettings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__referralRewardSettings__["d" /* hydrateRewardSettings */])(row);
      this.cashbackEnabled = this.cashbackRoles.some(function (role) {
        return _this3.rewardSettings[role].cashback.type !== 'NONE';
      });
    },
    loadCampaign: function loadCampaign() {
      var _this4 = this;

      this.loading = true;
      this.apiRequest('/referral-campaign/' + this.campaignId, 'GET', this.sessionPayload(), function (response) {
        _this4.loading = false;
        if (response.status && response.data) {
          _this4.applyRecord(response.data.data || response.data);
        } else {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error');
        }
      });
    },
    validate: function validate() {
      var _this5 = this;

      var errors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__referralRewardSettings__["g" /* validateRewardSettings */])(this.rewardSettings, this.model.order_rewards_active, this.cashbackEnabled);
      if (!this.model.name.trim()) errors.name = true;
      if (String(this.maxOrdersInput).trim() !== '' && (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(Number(this.maxOrdersInput)) || Number(this.maxOrdersInput) < 1)) errors.maxOrders = true;
      this.roles.forEach(function (role) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__referralRewardSettings__["h" /* rewardAspectsForRole */])(role).forEach(function (aspect) {
          if (!(aspect === 'order_reward' ? _this5.model.order_rewards_active : _this5.cashbackEnabled)) return;
          var rule = _this5.rewardSettings[role][aspect];
          if (rule.type === 'COUPON' && !_this5.couponsLoading && !_this5.couponsLoadFailed && !_this5.coupons.some(function (coupon) {
            return Number(coupon.id) === Number(rule.coupon_id);
          })) {
            errors[role + '.' + aspect] = 'couponUnavailable';
          }
        });
      });
      this.fieldErrors = errors;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors).length === 0;
    },
    save: function save() {
      var _this6 = this;

      if (this.loading || this.saving || !this.validate()) return;
      this.saving = true;
      this.apiRequest('/referral-campaign' + (this.campaignId ? '/' + this.campaignId : ''), this.campaignId ? 'PUT' : 'POST', this.payload(), function (response) {
        _this6.saving = false;
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()(_this6.$t('general.success') + '!', '', 'success').catch(function () {});
          _this6.backButton();
        } else {
          var errors = response.errors || {};
          var messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors).map(function (key) {
            return Array.isArray(errors[key]) ? errors[key].join(', ') : errors[key];
          }).filter(function (value) {
            return typeof value === 'string';
          });
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', messages.join('\n') || _this6.$t('validations.wentWrong'), 'error');
        }
      });
    },
    handleDelete: function handleDelete() {
      var _this7 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__referralCampaignDelete__["a" /* attemptReferralCampaignDelete */])(this, this.campaignId, {
        buildDeactivateBody: function buildDeactivateBody() {
          return _this7.payload();
        },
        onDeleted: function onDeleted() {
          _this7.backButton();
        },
        onDeactivated: function onDeactivated() {
          _this7.model.active = false;
          _this7.model.is_visible_for_users = false;
        }
      });
    }
  }
});

/***/ }),

/***/ "bfzT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__CustomerView_vue__ = __webpack_require__("viQu");






































__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_28_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dropdown_item___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_27_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_button___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_30_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_29_src_components_UIComponents_Switch_vue__["a" /* default */],
    CustomerView: __WEBPACK_IMPORTED_MODULE_33__CustomerView_vue__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      loading: true,
      paginationDef: {
        page: null,
        totalPages: null,
        totalRecords: null,
        show: true
      },
      searchId: null,
      searchDate: null,
      selectedPaymentMethod: null,
      route: {},
      pagerCount: 5,
      paymentMethods: [],
      filterOptions: this.$t('customers.filters'),
      filters: [],
      searchQuery: '',
      propsToSearch: ['name', 'email', 'age'],
      tableColumns: [],
      tableData: [],
      windowHeight: 0,
      tableTopHeight: 104,
      tableBottomHeight: 68,
      pageTopHeight: 0,
      search: '',
      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            var start = new Date();
            start.setDate(end.getDate() - 6);
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            var start = new Date();
            start.setDate(end.getDate() - 29);
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      }
    };
  },
  created: function created() {
    this.initializePage();
    this.getPaymentMethods();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.handleSearch();
    },
    buildRequestData: function buildRequestData() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var currentPage = page;

      if (!currentPage) {
        if (this.paginationDef && this.paginationDef.page) {
          currentPage = this.paginationDef.page;
        } else {
          currentPage = 1;
        }
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: currentPage,
        perPage: this.paginationDef.perPage,
        filters: this.filters
      };

      if (this.search && this.search.length > 3) {
        data.search = this.search;
      }

      if (this.searchId && this.searchId.length > 0) {
        data.id = this.searchId;
      }

      if (this.searchDate && this.searchDate.length === 2) {
        data.date_from = this.searchDate[0];
        data.date_to = this.searchDate[1];
      }

      if (this.selectedPaymentMethod && this.selectedPaymentMethod.length > 0) {
        data.payment_type = this.selectedPaymentMethod;
      }

      return data;
    },
    initializePage: function initializePage() {
      var data = this.buildRequestData();

      this.getCustomers(data);
    },
    handlePageChange: function handlePageChange(newPage) {
      this.paginationDef.page = newPage;
      this.requestPage = newPage;
      var data = this.buildRequestData();
      this.getCustomers(data);
    },
    handleSearch: function handleSearch() {
      this.requestPage = 1;
      var data = this.buildRequestData();
      this.getCustomers(data);
    },
    getCustomers: function getCustomers(data) {
      var _this = this;

      this.loading = true;
      this.apiRequest('customer-lightview', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data.data;
          _this.paginationDef.page = response.data.pagination.page;
          _this.paginationDef.perPage = response.data.pagination.perPage;
          _this.paginationDef.totalPages = response.data.pagination.totalPages;
          _this.paginationDef.totalRecords = response.data.pagination.totalRecords;
        }
        _this.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    getPaymentMethods: function getPaymentMethods() {
      var _this2 = this;

      var sessionData = this.$session.get('selectedCompanyData');

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };

        this.apiRequest('/orders/get-payment-methods', 'GET', data, function (response) {
          if (response.status && response.data.length) {
            var result = response.data.map(function (item) {
              return { id: item || 'unpaid', name: _this2.$t('paymentTypes.' + item) };
            });
            sessionData['payment_methods'] = response.data;
            _this2.$session.set('selectedCompanyData', sessionData);

            __WEBPACK_IMPORTED_MODULE_27_vue___default.a.set(_this2, 'paymentMethods', result);
          }
        });
      } else {
        var result = sessionData['payment_methods'].map(function (item) {
          return { id: item || 'unpaid', name: _this2.$t('paymentTypes.' + item) };
        });
        __WEBPACK_IMPORTED_MODULE_27_vue___default.a.set(this, 'paymentMethods', result);
      }
    },
    goToRecord: function goToRecord(row, event, column) {
      this.$router.push('/customers/view/' + row.id);
    },
    rowClass: function rowClass(row, index) {
      if (this.$route.params.id && parseInt(row.row.id) === parseInt(this.$route.params.id)) {
        return 'current';
      } else {
        return '';
      }
    },
    showForm: function showForm() {
      if (this.$route.path.indexOf('view') !== -1) {
        return true;
      } else {
        return false;
      }
    },
    handleActive: function handleActive(index, row) {
      var _this3 = this;

      var actionText = row.active ? 'activate' : 'deactivate';
      __WEBPACK_IMPORTED_MODULE_31_sweetalert2___default()({
        text: 'Are you sure you want to ' + actionText + ' ' + row.name + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          _this3.apiRequest('/hello', 'GET', [], function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_31_sweetalert2___default()('Success!', '', 'success');
            } else {
              __WEBPACK_IMPORTED_MODULE_31_sweetalert2___default()('', 'Something went wrong, please try again later...', 'error');
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_31_sweetalert2___default()('', 'Something went wrong, please try again later...', 'error');
        row.active = !row.active;
      });
    }
  }
});

/***/ }),

/***/ "bk31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllModulesModal_vue__ = __webpack_require__("t1ar");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f98a3a24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllModulesModal_vue__ = __webpack_require__("xdcT");
function injectStyle (ssrContext) {
  __webpack_require__("ityG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f98a3a24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllModulesModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f98a3a24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllModulesModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bler":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrinterEdit_vue__ = __webpack_require__("5yP9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74722d93_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrinterEdit_vue__ = __webpack_require__("B631");
function injectStyle (ssrContext) {
  __webpack_require__("3bPQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrinterEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74722d93_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrinterEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bmRV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('management-aviz-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "boZy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-lg-12"},[_c('div',{staticClass:"search-bar no-margin"},[_c('div',{staticClass:"col-sm-12 no-padding"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('reports.search')},model:{value:(_vm.filters[0].value),callback:function ($$v) {_vm.$set(_vm.filters[0], "value", $$v)},expression:"filters[0].value"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('marketingCampaigns.single'),"to":{ path: '/marketing/promos/add'}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"width-table campaign-table campaign-table--with-images",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":_vm.defaultSearchDef(),"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDef,"table-props":{'border': false},"filters":_vm.filters}},[_c('el-table-column',{attrs:{"min-width":45,"label":_vm.$t('marketingCampaigns.image')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"image-table"},[_c('img',{attrs:{"src":(props.row.image)?props.row.image : ''}})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"sortable":"","prop":"title","label":_vm.$t('marketingCampaigns.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":70,"sortable":"","prop":"name","label":_vm.$t('marketingCampaigns.startEnd')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatDate(props.row.date_start))+" - "+_vm._s(_vm.formatDate(props.row.date_end))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"sortable":"","prop":"treshold","label":_vm.$t('marketingPromos.treshold')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.treshold)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":45,"label":_vm.$t('marketingCampaigns.status'),"prop":"active"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(props.$index, props.row, $event)}},model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"align-campaign-info",attrs:{"min-width":70,"prop":"actions","label":_vm.$t('marketingCampaigns.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"display-flex"},[_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.handleDelete(props.$index, props.row)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")]),_vm._v(" "),(!props.row.isDisabledByLastSent)?[(props.row.active && props.row.mode == 'MANUAL')?_c('a',{staticClass:"btn btn-icon btn-purple ",attrs:{"title":_vm.$t('marketingCampaigns.send'),"disabled":props.row.isDisabledByLastSent},on:{"click":function($event){_vm.sendNotif(props.$index, props.row)}}},[_c('i',{staticClass:"ti-email"})]):_vm._e()]:[_c('div',{staticClass:"el-upload__tip"},[_vm._v(" "+_vm._s(_vm.$t('marketingCampaigns.campaignWasSent')))])]],2)]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bp77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReferralCampaignForm_vue__ = __webpack_require__("GyU5");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ReferralCampaignForm: __WEBPACK_IMPORTED_MODULE_0__ReferralCampaignForm_vue__["a" /* default */] },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),

/***/ "bq+c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "brEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      paginationDef: {
        page: 1,
        perPage: 20,
        totalPages: null,
        totalRecords: 0
      },
      tableData: []
    };
  },
  created: function created() {
    if (!this.guardPriceListsAccess()) {
      return;
    }
    this.getPriceProfiles();
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.paginationDef.page = 1;
      this.getPriceProfiles();
    },
    getPriceProfiles: function getPriceProfiles() {
      this.loading = true;
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.paginationDef.page,
        perPage: this.paginationDef.perPage
      };

      this.apiRequest('/price-profiles', 'GET', data, function (response) {
        if (response.status) {
          self.tableData = response.data || [];

          if (response.pagination) {
            self.paginationDef.page = response.pagination.page;
            self.paginationDef.perPage = response.pagination.perPage;
            self.paginationDef.totalPages = response.pagination.totalPages;
            self.paginationDef.totalRecords = response.pagination.totalRecords;
          }
        } else {
          self.tableData = [];
          self.paginationDef.totalRecords = 0;
        }
        self.loading = false;
      });
    },
    locationNameByToken: function locationNameByToken(token) {
      var companyData = this.$session.get('selectedCompanyData') || {};
      var locations = companyData.locations_details || [];
      var found = locations.find(function (loc) {
        return String(loc.token) === String(token);
      });
      return found ? found.name : token;
    },
    hasFilters: function hasFilters(row) {
      return !!(row.customers_groups && row.customers_groups.length || row.delivery_ranges && row.delivery_ranges.length || row.top_categories && row.top_categories.length);
    },
    onRowClick: function onRowClick(row, column, event) {
      if (event.target.closest('.el-dropdown')) {
        return;
      }
      this.goToEdit(row);
    },
    goToAdd: function goToAdd() {
      this.$router.push({
        name: 'Add Price Profile'
      });
    },
    goToEdit: function goToEdit(row) {
      this.$router.push({
        name: 'Edit Price Profile',
        params: {
          id: row.id
        }
      });
    },
    handlePageChange: function handlePageChange(page) {
      this.paginationDef.page = page;
      this.getPriceProfiles();
    },
    deleteProfile: function deleteProfile(row) {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        title: 'Confirmare ștergere',
        text: 'E\u0219ti sigur c\u0103 vrei s\u0103 \u0219tergi profilul "' + row.name + '"?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes'),
        cancelButtonText: self.$t('general.no'),
        confirmButtonColor: '#f56c6c'
      }).then(function (result) {
        if (result) {
          var data = {
            token: self.$session.get('token'),
            company_id: self.$session.get('selectedCompany')
          };

          self.apiRequest('/price-profiles/' + row.id, 'DELETE', data, function (response) {
            if (response.status) {
              self.trackAdminEvent('ADMIN_PRICE_LIST_DELETED', 'price_list', row.id, {
                price_list_id: row.id,
                name: row.name || null
              });
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
                type: 'success',
                title: self.$t('validations.success'),
                text: 'Profil șters cu succes',
                timer: 2000,
                showConfirmButton: false
              });

              if (self.tableData.length === 1 && self.paginationDef.page > 1) {
                self.paginationDef.page--;
              }
              self.getPriceProfiles();
            } else {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', response.message || self.$t('validations.wentWrong'), 'error');
            }
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "brt+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Locations_Location_vue__ = __webpack_require__("W4Mh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationGroups_LocationGroups_vue__ = __webpack_require__("MNRc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationGroups_LocationGroupsForm_vue__ = __webpack_require__("s1f/");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Locations: __WEBPACK_IMPORTED_MODULE_0__Locations_Location_vue__["a" /* default */],
    LocationGroups: __WEBPACK_IMPORTED_MODULE_1__LocationGroups_LocationGroups_vue__["a" /* default */],
    LocationGroupsForm: __WEBPACK_IMPORTED_MODULE_2__LocationGroups_LocationGroupsForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isCompanyLocations: true,
      isLocationGroups: false,

      selectedLocationGroups: false
    };
  },
  created: function created() {
    console.log('Created SettingsLocations.vue');
  },

  methods: {
    openTab: function openTab(tab) {
      var _this = this;

      this.isCompanyLocations = false;
      this.isLocationGroups = false;

      switch (tab) {
        case 'companyLocations':
          this.isCompanyLocations = true;
          break;
        case 'locationGroups':
          this.isLocationGroups = true;

          this.$nextTick(function () {
            if (_this.$refs.LocationGroups) {
              _this.$refs.LocationGroups.getData();
            }
          });
          break;
      }
    },
    getLocationGroups: function getLocationGroups(id) {
      this.selectedLocationGroups = id;
    },
    updateLocationGroups: function updateLocationGroups() {
      this.selectedLocationGroups = false;
      if (this.$refs.LocationGroups) {
        this.$refs.LocationGroups.getData();
      }
    },
    setSelectedTab: function setSelectedTab(tab) {
      this.openTab(tab);
    }
  }
});

/***/ }),

/***/ "bsLA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserLabelingForm_vue__ = __webpack_require__("HTxq");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'UserLabelingForm', __WEBPACK_IMPORTED_MODULE_7__UserLabelingForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      userLabel: {},
      modelValidations: {
        name: {
          required: true,
          min: 15
        },
        color: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.userLabel = model;
    }
  }
});

/***/ }),

/***/ "bsTH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralCampaignEdit_vue__ = __webpack_require__("csaI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ff2224_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralCampaignEdit_vue__ = __webpack_require__("bGFj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralCampaignEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ff2224_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralCampaignEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "btA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"mar-lt-20"},[_c('label',{staticClass:"pad-bt-5"},[_vm._v(_vm._s(_vm.$t('upload.uploadLabel')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","on-change":_vm.handleChange,"on-remove":_vm.handleRemove,"on-exceed":_vm.handleExceed,"limit":1,"auto-upload":false,"accept":".csv"}},[_c('el-button',{staticClass:"btn add",attrs:{"slot":"trigger","size":"small","type":"primary"},slot:"trigger"},[_vm._v(_vm._s(_vm.$t('upload.browse')))]),_vm._v(" "),_c('el-button',{staticClass:"btn add",staticStyle:{"margin-left":"10px"},attrs:{"disabled":!_vm.canUpload,"size":"small","type":"primary"},on:{"click":_vm.upload}},[_vm._v(_vm._s(_vm.$t('upload.upload')))]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('upload.file'))+" .csv")]),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions"})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "btJ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedbackView_vue__ = __webpack_require__("ITsO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_766671f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedbackView_vue__ = __webpack_require__("pQ2v");
function injectStyle (ssrContext) {
  __webpack_require__("gB//")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedbackView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_766671f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedbackView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bukA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsMenu_vue__ = __webpack_require__("zATB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8adbabc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsMenu_vue__ = __webpack_require__("oud0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8adbabc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "busv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-stocuri-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bwiK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0012b22c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("9nxM");
function injectStyle (ssrContext) {
  __webpack_require__("S6Lm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0012b22c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bx0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Task_vue__ = __webpack_require__("fm0D");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Task: __WEBPACK_IMPORTED_MODULE_1__Task_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tasks: [{
        title: 'Sign contract for "What are conference organizers afraid of?"'
      }, {
        title: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
      }, {
        title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
      }, {
        title: 'Create 4 Invisible User Experiences you Never Knew About'
      }, {
        title: 'Read "Following makes Medium better"'
      }, {
        title: 'Unfollow 5 enemies from twitter'
      }]
    };
  },

  methods: {
    handleTaskEdit: function handleTaskEdit(index) {
      alert('You want to edit task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    },
    handleTaskDelete: function handleTaskDelete(index) {
      alert('You want to delete task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    }
  }
});

/***/ }),

/***/ "bxGZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('donation-campaign-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onCampaignSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bzVD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c23J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentGroupsForm_vue__ = __webpack_require__("vizI");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PaymentGroupsForm', __WEBPACK_IMPORTED_MODULE_7__PaymentGroupsForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      paymentGroupsModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.paymentGroupsModel = model;
    }
  }
});

/***/ }),

/***/ "c2KQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Group_Group_vue__ = __webpack_require__("cStO");



















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default.a,

    Group: __WEBPACK_IMPORTED_MODULE_14__Group_Group_vue__["a" /* default */]
  },
  watch: {
    homepage: function homepage(newValue, oldValue) {
      this.homepageText = newValue === true ? this.$t('marketingOffers.offers') : this.$t('marketingOffers.banners');
      this.updateHomepage(newValue);
    }
  },
  computed: {},
  data: function data() {
    var _this = this;

    return {
      loading: true,
      homepage: this.$session.get('selectedCompanyData')['homepage'],
      homepageText: '',
      group_name: '',
      triggerModal: false,
      actionCol: {
        label: 'Delete',
        props: {
          align: 'center'
        },
        buttons: [{
          props: {
            type: 'danger',
            icon: 'el-icon-delete',
            class: 'btn btn-orange btn-fill'
          },
          handler: function handler(index, row) {
            _this.handleDelete(index, row);
          },
          label: 'delete'
        }]
      },
      paginationDef: {
        pageSize: 999,
        currentPage: 1,
        pageSizes: [999],
        show: false,
        disabled: true
      },
      searchQuery: '',
      propsToSearch: ['name', 'status', 'type', 'discount'],
      tableColumns: [],
      tableData: [],
      tableOffersData: [],
      tableOffersColumns: [],
      filters: [{
        value: '',
        prop: ['title', 'link_type', 'date_start', 'date_end']
      }]
    };
  },
  created: function created() {
    this.initPage();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.initPage();
    },
    initPage: function initPage() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.loading = true;
      });

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        use_sort_order: 'asc'
      };

      var homepageOption = this.$session.get('selectedCompanyData')['homepage'];
      this.homepageText = homepageOption ? this.$t('marketingOffers.offers') : this.$t('marketingOffers.banners');
      if (homepageOption) {
        this.getOffers(data);
      } else {
        this.getBanners(data);
      }
    },
    getBanners: function getBanners(data) {
      var _this3 = this;

      this.apiRequest('/banner', 'GET', data, function (response) {
        if (response.status === true) {
          _this3.tableData = response.data;
        }
        _this3.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    getOffers: function getOffers(data) {
      var _this4 = this;

      this.apiRequest('/homepage-offer', 'GET', data, function (response) {
        if (response.status === true) {
          _this4.tableOffersData = response.data;
        }
        _this4.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    updateHomepage: function updateHomepage(option) {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        option: option ? 1 : 0
      };

      this.apiRequest('/homepage-offer/update-company', 'POST', data, function (response) {
        if (response.status) {
          var selected = _this5.$session.get('selectedCompanyData');
          selected.homepage = option;
          _this5.$session.set('selectedCompanyData', selected);
          if (option) {
            _this5.getOffers(data);
          } else {
            _this5.getBanners(data);
          }
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()(_this5.$t('general.success') + '!', 'Optiune homepage updatata', 'success').catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this5.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    handleActive: function handleActive(row) {
      var _this6 = this;

      var actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + row.title + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this6.$session.get('token'),
            company_id: _this6.$session.get('selectedCompany'),
            active: row.active ? 1 : 0,
            id: row.id
          };

          var self = _this6;
          _this6.apiRequest('/banner/' + row.id, 'PUT', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()(self.$t('general.success') + '!', '', 'success').catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        row.active = !row.active;
      });
    },
    goToRecord: function goToRecord(row, event, column) {
      if (column.label !== 'Actions' && column.label !== 'Status') {
        this.globalGoToRecord(row, event, column, '/marketing/offers/edit/');
      }
    },
    adjustSort: function adjustSort(evt) {
      if (this.tableData.length > 1) {
        var idx = evt.newIndex;
        var after, before, sortOrder;

        if (idx === 0) {
          before = 0;
          after = this.tableData[idx + 1].sort_order;
        } else if (idx + 1 === this.tableData.length) {
          before = this.tableData[idx - 1].sort_order;
          after = parseFloat(before) + 1;
        } else {
          before = this.tableData[idx - 1].sort_order;
          after = this.tableData[idx + 1].sort_order;
        }

        sortOrder = (parseFloat(before) + parseFloat(after)) / 2;
        var id = this.tableData[idx].id;

        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: sortOrder
        };
        var self = this;
        this.apiRequest('/banner/' + id, 'PUT', data, function (response) {
          if (response.status !== true) {
            __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
              title: '',
              text: self.$t('validations.dataCouldNotBeSaved'),
              type: 'danger',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
          }
        });
      }
    },
    handleDelete: function handleDelete(index, row, event) {
      var _this7 = this;

      var self = this;
      event.stopPropagation();
      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        text: self.$t('marketingCampaigns.areYouSureDelete') + (' \'' + row.title + '\'?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this7.$session.get('token'),
            company_id: _this7.$session.get('selectedCompany')
          };
          _this7.apiRequest('/banner/' + row.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('marketingOffers.offerDeleted'), 'success');
              self.tableData.splice(index, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function () {});
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.disableConfirmButton();
      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + '(' + btnCounter + ')';
        } else {
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    }
  }
});

/***/ }),

/***/ "c2vN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c2yd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsSidebar_vue__ = __webpack_require__("isin");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33848b58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsSidebar_vue__ = __webpack_require__("E6Hi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33848b58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c3/S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForthStep_vue__ = __webpack_require__("ech5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153c3d2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForthStep_vue__ = __webpack_require__("cWo2");
function injectStyle (ssrContext) {
  __webpack_require__("6IqH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForthStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153c3d2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForthStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c3Km":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupEdit_vue__ = __webpack_require__("hzQ4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6863b705_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupEdit_vue__ = __webpack_require__("EGhD");
function injectStyle (ssrContext) {
  __webpack_require__("G1Mb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6863b705_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c6a9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c7YX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c8N3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('payment-groups-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cDBg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cDS1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-payment-settings"},[_c('h4',[_vm._v(_vm._s(_vm.$t('settingTable.qrPaymentMethods')))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.modes),function(mode){return _c('div',{key:mode,staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('settingTable.qrPaymentMode_' + mode)))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('p-checkbox',{attrs:{"checked":_vm.isSelected(mode, 'CASH'),"name":'qr_payment_' + mode + '_CASH'},on:{"input":function($event){_vm.toggleMethod(mode, 'CASH', $event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('settingTable.qrPaymentType_CASH'))+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-checkbox',{attrs:{"checked":_vm.isSelected(mode, 'POS'),"name":'qr_payment_' + mode + '_POS'},on:{"input":function($event){_vm.toggleMethod(mode, 'POS', $event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('settingTable.qrPaymentCard'))+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-checkbox',{attrs:{"checked":_vm.isMobileSelected(mode),"name":'qr_payment_' + mode + '_mobile'},on:{"input":function($event){_vm.toggleMobile(mode, $event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('settingTable.qrPaymentMobilePos'))+"\n            ")])],1),_vm._v(" "),(_vm.isMobileSelected(mode))?_c('div',{staticClass:"qr-mobile-payment-options"},[_c('div',{staticClass:"form-group"},[_c('p-radio',{attrs:{"value":_vm.mobileConnection(mode),"label":"NFC"},on:{"input":function($event){_vm.setMobileConnection(mode, $event)}}},[_vm._v("NFC")])],1),_vm._v(" "),(_vm.mobileConnection(mode) === 'NFC')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.qrPaymentBankTerminal')))]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"name":'qr_payment_' + mode + '_nfc_provider'},domProps:{"value":_vm.nfcProvider(mode) || ''},on:{"change":function($event){_vm.setNfcProvider(mode, $event.target.value)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_c('option',{attrs:{"value":"viva_wallet"}},[_vm._v("Viva Wallet")]),_vm._v(" "),_c('option',{attrs:{"value":"banca_transilvania"}},[_vm._v("BT")])]),_vm._v(" "),_vm._l((_vm.fieldErrors(mode, 'bank_terminal_provider')),function(message,index){return _c('small',{key:index,staticClass:"text-danger"},[_vm._v(_vm._s(message))])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-radio',{attrs:{"value":_vm.mobileConnection(mode),"label":"DIRECT"},on:{"input":function($event){_vm.setMobileConnection(mode, $event)}}},[_vm._v("\n                "+_vm._s(_vm.$t('settingTable.qrPaymentDirectConnection'))+"\n              ")])],1),_vm._v(" "),(_vm.mobileConnection(mode) === 'DIRECT')?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.type')))]),_vm._v(" "),_c('select',{staticClass:"form-control",domProps:{"value":_vm.terminalData(mode, 'CARD_POS').integrated_bank_pos_id || ''},on:{"change":function($event){_vm.setTerminalValue(mode, 'integrated_bank_pos_id', $event.target.value, 'CARD_POS')}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.posOptions),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v(_vm._s(option.name))])})],2),_vm._v(" "),_vm._l((_vm.fieldErrors(mode, 'integrated_bank_pos_id')),function(message,index){return _c('small',{key:index,staticClass:"text-danger"},[_vm._v(_vm._s(message))])})],2),_vm._v(" "),_vm._l((_vm.terminalFields),function(field){return _c('div',{key:field.key,staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(field.label === 'TID/MID' ? field.label : _vm.$t(field.label)))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","maxlength":"255"},domProps:{"value":_vm.terminalData(mode, 'CARD_POS')[field.key]},on:{"input":function($event){_vm.setTerminalValue(mode, field.key, $event.target.value, 'CARD_POS')}}}),_vm._v(" "),_vm._l((_vm.fieldErrors(mode, field.key)),function(message,index){return _c('small',{key:index,staticClass:"text-danger"},[_vm._v(_vm._s(message))])})],2)})]:_vm._e()],2):_vm._e(),_vm._v(" "),_vm._l((_vm.modeErrors(mode)),function(message,index){return _c('p',{key:'mode-' + index,staticClass:"text-danger"},[_vm._v(_vm._s(message))])})],2)])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cDSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cDh+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('user-labeling-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cFDW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountCampaignEdit_vue__ = __webpack_require__("fhxF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_451befe5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountCampaignEdit_vue__ = __webpack_require__("pAfr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountCampaignEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_451befe5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountCampaignEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cFks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_DELIVERY_HERO_API_URL; });
/* unused harmony export DELIVERY_HERO_AUTO_SEND_STATUS_VALUES */
/* unused harmony export DELIVERY_HERO_AUTO_SEND_TIME_VALUES */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Integrations_WoltDriveIntegrationForm_vue__ = __webpack_require__("VamX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__ = __webpack_require__("3z7E");






var DEFAULT_DELIVERY_HERO_API_URL = 'https://ondemand-api-glovoapp.deliveryhero.io/ro';

var DELIVERY_HERO_AUTO_SEND_STATUS_VALUES = __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Integrations_WoltDriveIntegrationForm_vue__["b" /* WOLT_DRIVE_AUTO_SEND_STATUS_VALUES */];
var DELIVERY_HERO_AUTO_SEND_TIME_VALUES = __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Integrations_WoltDriveIntegrationForm_vue__["c" /* WOLT_DRIVE_AUTO_SEND_TIME_VALUES */];

/* harmony default export */ __webpack_exports__["b"] = ({
  name: 'DeliveryHeroIntegrationForm',
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    requiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    credentialFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    validationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showFieldValidation: {
      type: Boolean,
      default: false
    },
    occupiedLocationIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isCreateMode: {
      type: Boolean,
      default: false
    },
    regeneratingKeys: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    autoSendStatusOptions: function autoSendStatusOptions() {
      var _this = this;

      return DELIVERY_HERO_AUTO_SEND_STATUS_VALUES.map(function (value) {
        return {
          value: value,
          label: _this.autoSendStatusLabel(value)
        };
      });
    },
    autoSendTimeOptions: function autoSendTimeOptions() {
      return DELIVERY_HERO_AUTO_SEND_TIME_VALUES.slice();
    },
    isAutoSendManual: function isAutoSendManual() {
      return String(this.formData.auto_send_at_status || '').toUpperCase() === 'MANUAL';
    },
    showCredentialRequired: function showCredentialRequired() {
      return !this.isCreateMode || !!this.formData.public_key;
    },
    canRegenerateKeys: function canRegenerateKeys() {
      return !this.isCreateMode && !!this.formData.id && !!this.formData.public_key;
    }
  },
  created: function created() {
    this.ensureDefaults();
  },

  methods: {
    fieldLabel: function fieldLabel(field) {
      if (typeof this.fieldLabelFn === 'function') return this.fieldLabelFn(field);
      return field;
    },
    isRequired: function isRequired(field) {
      if ((this.requiredFields || []).includes(field)) return true;

      return this.showCredentialRequired && (this.credentialFields || []).includes(field);
    },
    showFieldError: function showFieldError(field) {
      if (this.validationErrors && this.validationErrors[field]) return true;
      if (!this.showFieldValidation) return false;

      if (!(this.requiredFields || []).includes(field)) return false;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["a" /* hasIntegrationFieldError */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: true,
        requiredFields: this.requiredFields,
        formData: this.formData
      });
    },
    fieldErrorMessage: function fieldErrorMessage(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["b" /* getIntegrationFieldErrorMessage */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData,
        requiredMessage: this.$t('validations.requiredField')
      });
    },
    isLocationOccupied: function isLocationOccupied(locationId) {
      if (locationId == null || locationId === '') return false;
      return (this.occupiedLocationIds || []).map(String).includes(String(locationId));
    },
    locationOptionLabel: function locationOptionLabel(loc) {
      var name = loc && loc.name ? loc.name : '';
      if (this.isLocationOccupied(loc._integrationLocationId)) {
        return name + ' (' + this.$t('gestiune.integrationsLocationOccupied') + ')';
      }
      return name;
    },
    autoSendStatusLabel: function autoSendStatusLabel(value) {
      var key = 'gestiune.woltDriveAutoSendStatus_' + String(value || '').toLowerCase();
      var translated = this.$t(key);
      return translated !== key ? translated : String(value || '');
    },
    copyPublicKey: function copyPublicKey() {
      var key = this.formData.public_key;
      if (!key) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(key);
        return;
      }
      var el = document.createElement('textarea');
      el.value = key;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    },
    downloadPublicKey: function downloadPublicKey() {
      var key = this.formData.public_key;
      if (!key) return;
      var blob = new Blob([key], { type: 'application/x-pem-file' });
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = 'delivery-hero-odr.pub';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    ensureDefaults: function ensureDefaults() {
      var url = this.formData.api_url;
      if (url === undefined || url === null || String(url).trim() === '') {
        this.$set(this.formData, 'api_url', DEFAULT_DELIVERY_HERO_API_URL);
      }

      if (this.formData.active === undefined || this.formData.active === null) {
        this.$set(this.formData, 'active', true);
      }

      var status = this.formData.auto_send_at_status;
      status = status === undefined || status === null || String(status).trim() === '' ? '' : String(status).trim().toUpperCase();
      if (!status || !DELIVERY_HERO_AUTO_SEND_STATUS_VALUES.includes(status)) {
        status = 'MANUAL';
      }
      this.$set(this.formData, 'auto_send_at_status', status);

      var time = this.formData.auto_send_time;
      time = time === null || time === undefined || String(time).trim() === '' ? '' : String(parseInt(String(time).trim(), 10));
      if (!time || !DELIVERY_HERO_AUTO_SEND_TIME_VALUES.includes(time)) {
        time = '30';
      }
      this.$set(this.formData, 'auto_send_time', time);
    }
  }
});

/***/ }),

/***/ "cGpe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cJTk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Invoice_InvoiceDashboard_vue__ = __webpack_require__("fakT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Invoice_Proforma_Proforma_vue__ = __webpack_require__("mX3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Invoice_InvoiceReports_vue__ = __webpack_require__("VGc9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Invoice_InvoiceSettings_vue__ = __webpack_require__("94sP");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    InvoiceDashboard: __WEBPACK_IMPORTED_MODULE_0__Invoice_InvoiceDashboard_vue__["a" /* default */],
    Proforma: __WEBPACK_IMPORTED_MODULE_1__Invoice_Proforma_Proforma_vue__["a" /* default */],
    InvoiceReports: __WEBPACK_IMPORTED_MODULE_2__Invoice_InvoiceReports_vue__["a" /* default */],
    InvoiceSettings: __WEBPACK_IMPORTED_MODULE_3__Invoice_InvoiceSettings_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isDashboard: false,
      isProforma: false,
      isReports: false,
      isSettings: false
    };
  },
  mounted: function mounted() {
    this.switchTab();
  },

  methods: {
    resetStates: function resetStates() {
      this.isProforma = false;
      this.isDashboard = false;
      this.isReports = false;
      this.isSettings = false;
    },
    switchTab: function switchTab() {
      var _this = this;

      var index = this.$route.query.tabIndex;
      this.$nextTick(function () {
        if (index && _this.$refs.tabs) {
          _this.$refs.tabs.navigateToTab(parseInt(index));
        }
      });
    },
    handleTabChange: function handleTabChange(tabIndex, newTab) {
      this.resetStates();
      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);
      switch (newTab.title) {
        case this.$t('invoice.invoices'):
          this.isDashboard = true;
          break;
        case this.$t('invoice.reports'):
          this.isReports = true;
          break;
        case this.$t('invoice.settings'):
          this.isSettings = true;
          break;
        case this.$t('invoice.proforma'):
          this.isProforma = true;
          break;
        default:
          this.isDashboard = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ "cK/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_json_excel__ = __webpack_require__("fXhN");






var _components;










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_11_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isMasterReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isMasterReport: function isMasterReport() {
      if (this.isMasterReport) {
        this.getTopCategories();
        this.getPaymentMethods();
        this.getSections();
        this.getOrders();
        this.verifyUserLocations();
        this.verifyUserMethods();
        this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest';
        this.getPosUsers();
      }
    }
  },
  data: function data() {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      productsTableData: [],
      posUsers: [],
      selectedPosUser: null,
      timezone: null,
      productsTableDataTotals: {},
      paymentMethods: [],
      orderId: null,
      receiptOptions: [{ label: this.$t('reports.withoutReceipt'), value: 1 }, { label: this.$t('reports.withReceipt'), value: 2 }],
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_methods: [],
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_9_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: '',
        z_number: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_9_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      ordersTableData: {},
      totalOrders: null,

      topCategories: [],
      topCategoryId: [],
      sections: [],
      sectionId: [],
      hasRceipt: null,
      noData: false,
      totalSum: 0,
      selectedRawDataRow: {},
      rawExpanded: false
    };
  },

  computed: {
    rawSummarySections: function rawSummarySections() {
      var _this = this;

      var row = this.selectedRawDataRow || {};
      var has = function has(k) {
        return row[k] !== undefined && row[k] !== null && row[k] !== '';
      };
      var money = function money(k) {
        return _this.formatMoneyAmount(Number(row[k] || 0));
      };
      var count = function count(k) {
        return String(row[k] != null ? row[k] : 0);
      };

      var defs = [{
        id: 'payments',
        title: this.$t('reports.paymentMethod'),
        fields: [{ key: 'cash_in_drawer', label: this.$t('reports.cashInDrawer'), fmt: money }, { key: 'cash', label: this.$t('reports.cash'), fmt: money }, { key: 'card', label: this.$t('reports.cardPayment'), fmt: money }, { key: 'credit', label: this.$t('reports.credit'), fmt: money }, { key: 'meal_tickets', label: this.$t('reports.mealTickets'), fmt: money }, { key: 'value_tickets', label: this.$t('reports.valueTickets'), fmt: money }, { key: 'voucher', label: this.$t('reports.voucher'), fmt: money }, { key: 'modern_payment', label: this.$t('reports.modernPayment'), fmt: money }, { key: 'advance_in_cash', label: this.$t('reports.advanceInCash'), fmt: money }, { key: 'other_methods', label: this.$t('reports.otherMethods'), fmt: money }]
      }, {
        id: 'sales',
        title: this.$t('reports.totalSales'),
        fields: [{ key: 'total_sales_a', label: this.$t('reports.totalSalesA'), fmt: money }, { key: 'total_sales_b', label: this.$t('reports.totalSalesB'), fmt: money }, { key: 'total_sales_c', label: this.$t('reports.totalSalesC'), fmt: money }, { key: 'total_sales_d', label: this.$t('reports.totalSalesD'), fmt: money }, { key: 'total_sales_e', label: this.$t('reports.totalSalesE'), fmt: money }, { key: 'total_other_taxes', label: this.$t('reports.totalOtherTaxes'), fmt: money }, { key: 'total_vat_exempt', label: this.$t('reports.totalVatExempt'), fmt: money }, { key: 'total_sales', label: this.$t('reports.totalSales'), fmt: money }]
      }, {
        id: 'vat',
        title: this.$t('reports.totalVat'),
        fields: [{ key: 'total_vat_a', label: this.$t('reports.totalVatA'), fmt: money }, { key: 'total_vat_b', label: this.$t('reports.totalVatB'), fmt: money }, { key: 'total_vat_c', label: this.$t('reports.totalVatC'), fmt: money }, { key: 'total_vat_d', label: this.$t('reports.totalVatD'), fmt: money }, { key: 'total_vat_e', label: this.$t('reports.totalVatE'), fmt: money }, { key: 'total_vat', label: this.$t('reports.totalVat'), fmt: money }]
      }, {
        id: 'fiscal',
        title: this.$t('reports.fiscalization'),
        fields: [{ key: 'fiscal_code_clients_total_vat', label: this.$t('reports.fiscalCodeClientsTotalVat'), fmt: money }, { key: 'fiscal_code_clients_total_sum', label: this.$t('reports.fiscalCodeClientsTotalSum'), fmt: money }, { key: 'nr_fiscal_code_client_receipts', label: this.$t('reports.nrFiscalCodeClientReceipts'), fmt: count }, { key: 'nr_fiscal_receipts', label: this.$t('reports.nrFiscalReceipts'), fmt: count }, { key: 'nr_non_fiscal_receipts', label: this.$t('reports.nrNonFiscalReceipts'), fmt: count }]
      }];

      var sections = [];
      defs.forEach(function (def) {
        var rows = def.fields.filter(function (f) {
          return has(f.key);
        }).map(function (f) {
          return { key: f.key, label: f.label, value: f.fmt(f.key) };
        });
        if (rows.length) {
          sections.push({ id: def.id, title: def.title, rows: rows });
        }
      });
      return sections;
    },
    rawOutputText: function rawOutputText() {
      var raw = this.selectedRawDataRow && this.selectedRawDataRow.raw_data;
      if (raw == null || raw === '') return '';
      if (typeof raw === 'string') return raw;
      try {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(raw, null, 2);
      } catch (e) {
        return String(raw);
      }
    }
  },
  methods: {
    formatToCompanyTimezone: function formatToCompanyTimezone(utcString) {
      var date = new Date(utcString + 'Z');
      var formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: this.timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      var parts = formatter.formatToParts(date);

      return parts.find(function (p) {
        return p.type === 'year';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'month';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'day';
      }).value + ' ' + parts.find(function (p) {
        return p.type === 'hour';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'minute';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'second';
      }).value;
    },
    getPaymentMethods: function getPaymentMethods() {
      var _this2 = this;

      var sessionData = this.$session.get('selectedCompanyData');

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };

        this.apiRequest('/orders/get-payment-methods', 'GET', data, function (response) {
          if (response.status && response.data.length) {
            var result = response.data.map(function (item) {
              return { id: item || 'unpaid', name: _this2.$t('paymentTypes.' + item) };
            });
            sessionData['payment_methods'] = response.data;
            _this2.$session.set('selectedCompanyData', sessionData);

            __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(_this2, 'paymentMethods', result);
          }
        });
      } else {
        var result = sessionData['payment_methods'].map(function (item) {
          return { id: item || 'unpaid', name: _this2.$t('paymentTypes.' + item) };
        });
        __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(this, 'paymentMethods', result);
      }
    },
    getTopCategories: function getTopCategories() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/topcategory', 'GET', data, function (response) {
        if (response.status === true) {
          _this3.topCategories = response.data;
        }
      });
    },
    getSections: function getSections() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/sections', 'GET', data, function (response) {
        if (response.status === true) {
          _this4.sections = response.data;
        }
      });
    },
    startDownload: function startDownload() {
      this.loading = true;
    },
    finishDownload: function finishDownload() {
      this.loading = false;
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '05:00';
      }
      if (!this.valid_to) {
        this.valid_to = '05:00';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (this.loading) {
        return;
      }
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    renderHeaderWithTotal: function renderHeaderWithTotal(h, label, total) {
      return h('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: '100%',
          textAlign: 'center',
          padding: '4px',
          boxSizing: 'border-box',
          justifyContent: 'space-between',
          overflow: 'visible'
        }
      }, [h('div', {
        style: {
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          hyphens: 'auto',
          whiteSpace: 'normal',
          lineHeight: '1.2',
          minWidth: '0'
        }
      }, label), h('div', {
        style: {
          display: 'flex',
          justifyContent: 'center',
          marginTop: '4px'
        }
      }, [h('span', {
        style: {
          background: '#674BD2',
          color: '#fff',
          borderRadius: '5px',
          padding: '2px 6px',
          fontWeight: 'bold',
          fontSize: '12px',
          lineHeight: '1',
          whiteSpace: 'nowrap',
          display: 'inline-block'
        }
      }, total)])]);
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    isUnpaidSelected: function isUnpaidSelected() {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return false;
      }

      return this.selected_payment_methods.some(function (method) {
        var id = typeof method === 'string' ? method : method && method.id;
        return id === 'unpaid';
      });
    },
    getPaymentMethodsArray: function getPaymentMethodsArray() {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return [];
      }

      return this.selected_payment_methods.map(function (method) {
        return typeof method === 'string' ? method : method && method.id ? method.id : null;
      }).filter(function (method) {
        return method && method !== 'unpaid';
      });
    },
    getOrders: function getOrders(query) {
      var _this5 = this;

      if (!this.isMasterReport) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        order_id: this.orderId,
        selected_payment_methods: this.getPaymentMethodsArray(),
        unpaid_orders: this.isUnpaidSelected() ? 1 : 0,
        operator: this.selectedPosUser
      };

      if (this.topCategoryId) {
        var result = this.topCategoryId.map(function (elem) {
          return elem.id;
        });
        data.top_category_id = result;
      }

      if (this.sectionId) {
        var _result = this.sectionId.map(function (elem) {
          return elem.id;
        });
        data.section_id = _result;
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.orders.z_number !== '' && this.orders.z_number !== null && this.orders.z_number !== undefined) {
        data.z_number = this.orders.z_number;
      }

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      var hasReceiptValue = this.hasRceipt && this.hasRceipt.value || null;

      this.apiRequest('/reports/v2/fiscal-z-reports' + '?page=' + page + '&perPage=' + pageSize + '&has_receipt=' + hasReceiptValue, 'GET', data, function (response) {
        if (response.status) {
          _this5.productsTableData = response.data.table_data || [];
          _this5.totalOrders = response.pagination.total;
          _this5.paginationProps.currentPage = response.pagination.page;
          _this5.paginationProps.pageSize = response.pagination.perPage;
          _this5.productsTableDataTotals = response.data.totals || {};
          _this5.totalSum = parseFloat(response.data.totals.total_sales || 0);
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this5.$t('validations.wentWrong'), 'error');
        }

        _this5.$nextTick(function () {
          _this5.loading = false;
        });
      });
    },
    updateData: function updateData() {
      if (this.loading) {
        return;
      }
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    exportData: function exportData() {
      var _this6 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        order_id: this.orderId,
        selected_payment_methods: this.getPaymentMethodsArray(),
        unpaid_orders: this.isUnpaidSelected() ? 1 : 0,
        pageSize: this.paginationProps.pageSize,
        page: this.paginationProps.currentPage,
        has_receipt: this.hasRceipt && this.hasRceipt.value || null
      };

      if (this.topCategoryId) {
        var result = this.topCategoryId.map(function (elem) {
          return elem.id;
        });
        data.top_category_id = result;
      }

      if (this.sectionId) {
        var _result2 = this.sectionId.map(function (elem) {
          return elem.id;
        });
        data.section_id = _result2;
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.orders.z_number !== '' && this.orders.z_number !== null && this.orders.z_number !== undefined) {
        data.z_number = this.orders.z_number;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/fiscal-z-reports-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', _this6.$t('validations.wentWrong'), 'error');
        }
        _this6.loading = false;
      });
    },
    getPosUsers: function getPosUsers() {
      var _this7 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this7.posUsers = response.data.pos_user;
        }
      });
    },
    openRawDataModal: function openRawDataModal(row) {
      this.selectedRawDataRow = row || {};

      var r = this.selectedRawDataRow;
      var hasStructured = ['cash', 'card', 'total_sales', 'total_vat', 'nr_fiscal_receipts'].some(function (k) {
        return r[k] !== undefined && r[k] !== null && r[k] !== '';
      });
      this.rawExpanded = !hasStructured;
      this.$modal.show('rawDataModal');
    },
    closeRawDataModal: function closeRawDataModal() {
      this.$modal.hide('rawDataModal');
      this.selectedRawDataRow = {};
    },
    formatRawDataLabel: function formatRawDataLabel(key) {
      var camelCaseKey = key.split('_').map(function (word, index) {
        return index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1);
      }).join('');
      var translationKey = 'reports.rawData' + camelCaseKey.charAt(0).toUpperCase() + camelCaseKey.slice(1);
      var translated = this.$t(translationKey);

      if (translated && translated !== translationKey) {
        return translated;
      }
      return key.toUpperCase().replace(/_/g, ' ');
    },
    formatRawDataValue: function formatRawDataValue(key, value) {
      if (value === null || value === undefined) {
        return '0.00';
      }

      if (typeof value === 'number') {
        if (key.includes('tva') || key.includes('vanz') || key.includes('val') || key.includes('numerar') || key.includes('card') || key.includes('credit') || key.includes('tichete') || key.includes('voucher') || key.includes('plata') || key.includes('avans') || key.includes('metode') || key.includes('taxe') || key.includes('sumar') || key.includes('capacitate') || key.includes('spatiu')) {
          return this.formatMoneyAmount(value.toFixed(2));
        }
        return value.toString();
      }

      if (key === 'data' || key === 'nr_dmje_01') {
        return value;
      }

      if (key.includes('spatiu_liber_dmje') && typeof value === 'string' && value.includes('%')) {
        return value;
      }

      return String(value);
    }
  }
});

/***/ }),

/***/ "cKcE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cLGC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Test_vue__ = __webpack_require__("X64J");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'Test', __WEBPACK_IMPORTED_MODULE_7__Test_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "cOLK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentGroups_vue__ = __webpack_require__("DsSf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_694b86a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentGroups_vue__ = __webpack_require__("y0d6");
function injectStyle (ssrContext) {
  __webpack_require__("MyDR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentGroups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_694b86a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentGroups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cQRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelReport_vue__ = __webpack_require__("vFiI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60fb9e27_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelReport_vue__ = __webpack_require__("vTQ+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60fb9e27_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cQcw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserForm_vue__ = __webpack_require__("HOa3");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'UserForm', __WEBPACK_IMPORTED_MODULE_7__UserForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      userModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.userModel = model;
    }
  }
});

/***/ }),

/***/ "cQrm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersPosView_vue__ = __webpack_require__("AIwG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb79c50a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersPosView_vue__ = __webpack_require__("DbxY");
function injectStyle (ssrContext) {
  __webpack_require__("xXAM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersPosView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb79c50a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersPosView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cStO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__ = __webpack_require__("9OgK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6ddb84a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__ = __webpack_require__("Nijh");
function injectStyle (ssrContext) {
  __webpack_require__("Zci7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a6ddb84a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6ddb84a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cT4/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"challenge-campaigns-report"},[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"challenge-campaigns-report__filters"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.challengeId),expression:"challengeId"}],staticClass:"form-control challenge-campaigns-report__filter-id",attrs:{"type":"text","placeholder":_vm.$t('challengeCampaigns.id')},domProps:{"value":(_vm.challengeId)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.loadReport($event)},"input":function($event){if($event.target.composing){ return; }_vm.challengeId=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTitle),expression:"searchTitle"}],staticClass:"form-control challenge-campaigns-report__filter-title",attrs:{"type":"text","placeholder":_vm.$t('challengeCampaigns.searchByTitle')},domProps:{"value":(_vm.searchTitle)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.loadReport($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchTitle=$event.target.value}}}),_vm._v(" "),_c('el-date-picker',{staticClass:"challenge-campaigns-report__filter-date",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","picker-options":_vm.pickerOptions},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}}),_vm._v(" "),(_vm.locations.length)?_c('el-select',{staticClass:"challenge-campaigns-report__filter-location",attrs:{"clearable":"","filterable":"","placeholder":_vm.$t('orders.location')},model:{value:(_vm.locationId),callback:function ($$v) {_vm.locationId=$$v},expression:"locationId"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:loc.id,attrs:{"label":loc.name,"value":loc.id}})})):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.loadReport}},[_c('i',{staticClass:"ti-search"})])],1),_vm._v(" "),_c('p',{staticClass:"text-muted",staticStyle:{"padding":"0 15px","margin-top":"5px"}},[_vm._v("\n      "+_vm._s(_vm.$t('challengeCampaigns.reportDateHint'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"card-content total-pagination pad-15",staticStyle:{"position":"relative"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.onRowClick}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('challengeCampaigns.id'),"width":"70"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":_vm.$t('challengeCampaigns.title'),"min-width":"160"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.active'),"width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n            "+_vm._s(p.row.active ? _vm.$t('general.active') : _vm.$t('general.inactive'))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"completed_users","label":_vm.$t('challengeCampaigns.completedUsers'),"width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"in_progress_users","label":_vm.$t('challengeCampaigns.inProgressUsers'),"width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"started_users","label":_vm.$t('challengeCampaigns.startedUsers'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('challengeCampaigns.completionRate'),"width":"140","class-name":"challenge-completion-rate-col"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v(_vm._s(p.row.completion_rate)+"%")]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cWSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"card mar-to-15",staticStyle:{"width":"calc(100% - 20px)","margin-left":"10px","margin-right":"10px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"userList",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"width":150},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n              ")])]}}])})],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cWo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'coupon-fields--standalone': _vm.standalone}},[_c('div',{staticClass:"row"},[(!_vm.standalone)?_c('div',{staticClass:"col-md-12 text-center "},[_c('p-checkbox',{key:"COUPON",staticClass:"text-purple",attrs:{"label":_vm.$t('marketingCampaigns.addCoupon')},on:{"input":function($event){_vm.changeType()}},model:{value:(_vm.addcoupon),callback:function ($$v) {_vm.addcoupon=$$v},expression:"addcoupon"}},[_c('h4',{ref:"COUPON",staticClass:"coupon-selection",class:_vm.activeButton == 'COUPON' ? 'purple' : 'gray',attrs:{"name":"coupon_option"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.addCoupon')))])])],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"disabled":_vm.model.type != 'COUPON'}},[_c('div',{staticClass:"col-md-12 pad-bt-15 text-center"},[_c('label',{staticClass:"pad-rg-5 valign-top"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.applyTo'))+":")]),_vm._v(" "),_vm._l((_vm.couponUsageTypes),function(type,key){return _c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.usage_type),expression:"modelValidations.usage_type"}],key:key,attrs:{"label":key,"inline":true,"disabled":_vm.model.type != 'COUPON'},model:{value:(_vm.coupons.usage_type),callback:function ($$v) {_vm.$set(_vm.coupons, "usage_type", $$v)},expression:"coupons.usage_type"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.'+type)))])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-6 ",class:_vm.coupons.usage_type == 'PRODUCTS' && !_vm.isSpinningWheelFreeProductCoupon ? '' : 'col-md-offset-3'},[_c('div',{staticClass:"form-group"},[_vm._l((_vm.couponType),function(type,key){return _c('p-radio',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.type),expression:"modelValidations.type"}],key:key,attrs:{"label":key,"disabled":_vm.model.type != 'COUPON',"inline":true},model:{value:(_vm.coupons.type),callback:function ($$v) {_vm.$set(_vm.coupons, "type", $$v)},expression:"coupons.type"}},[_vm._v(_vm._s(_vm.$t('couponsTypes.' + key)))])}),_vm._v(" "),(_vm.isFreeProductCoupon)?_c('div',{staticClass:"box free-product-box",staticStyle:{"border":"1px solid #5e35b1","padding":"15px","margin-top":"15px","margin-bottom":"15px","background":"#faf8ff"}},[_c('label',{staticClass:"text-purple",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.freeProduct'))+"*")]),_vm._v(" "),_c('p',{staticClass:"help-block",staticStyle:{"margin-top":"5px","margin-bottom":"10px"}},[_vm._v(_vm._s(_vm.$t(_vm.isSpinningWheelFreeProductCoupon ? 'spinningWheel.freeProductCouponHelp' : 'marketingCampaigns.freeProductHelp')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.freeProducts,"label":"name","filterable":false,"disabled":_vm.model.type != 'COUPON',"placeholder":_vm.$t('marketingCampaigns.freeProductPlaceholder')},on:{"search":_vm.searchFreeProducts,"input":_vm.onFreeProductSelected},model:{value:(_vm.selectedFreeProduct),callback:function ($$v) {_vm.selectedFreeProduct=$$v},expression:"selectedFreeProduct"}}),_vm._v(" "),_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-top":"6px"}},[_vm._v("\n              "+_vm._s(_vm.$t('marketingCampaigns.freeProductSearchHint'))+"\n            ")]),_vm._v(" "),(_vm.errorFreeProduct)?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.errorFreeProduct)+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"15px","margin-bottom":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.minOrderValue')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.coupons.min_order_value),expression:"coupons.min_order_value"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01","placeholder":_vm.$t('marketingCampaigns.minOrderValuePlaceholder'),"disabled":_vm.model.type != 'COUPON'},domProps:{"value":(_vm.coupons.min_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coupons, "min_order_value", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted",staticStyle:{"display":"block","margin-top":"6px"}},[_vm._v("\n                "+_vm._s(_vm.$t('marketingCampaigns.minOrderValueHelp'))+"\n              ")])])],1):_vm._e(),_vm._v(" "),(!_vm.isFreeProductCoupon)?[_c('br'),_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.addValue')))]),_c('br'),_vm._v(" "),_c('div',{staticClass:"box",staticStyle:{"border":"1px solid #f2f2f2","padding":"10px"}},[_c('div',{staticClass:"form-group firstValue"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.minValue'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ required:true, min_value:0 }),expression:"{ required:true, min_value:0 }"},{name:"model",rawName:"v-model",value:(_vm.coupons.from_value),expression:"coupons.from_value"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":_vm.$t('marketingCampaigns.value'),"disabled":_vm.model.type != 'COUPON'},domProps:{"value":(_vm.coupons.from_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coupons, "from_value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.value'))+" ("+_vm._s(_vm.coupons.type != 'FIXED' ? '%' : _vm.currency)+")*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ customConditionCouponValue: _vm.customConditionCouponValue }),expression:"{ customConditionCouponValue }"},{name:"model",rawName:"v-model",value:(_vm.coupons.discount),expression:"coupons.discount"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":_vm.$t('marketingCampaigns.value'),"disabled":_vm.model.type != 'COUPON'},domProps:{"value":(_vm.coupons.discount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coupons, "discount", $event.target.value)}}}),_vm._v(" "),(_vm.errors.discount)?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('discount'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"})])]),_vm._v(" "),_vm._l((_vm.coupons.waterfall_discounts),function(waterfall,indexWaterfall){return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.minValue')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.from_value),expression:"modelValidations.from_value"},{name:"model",rawName:"v-model",value:(waterfall.from_value),expression:"waterfall.from_value"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":_vm.$t('marketingCampaigns.value'),"disabled":_vm.model.type != 'COUPON' && _vm.coupons.is_waterfall},domProps:{"value":(waterfall.from_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(waterfall, "from_value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.value'))+" ("+_vm._s(_vm.coupons.type != 'FIXED' ? '%' : _vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ required:true, customCondition: _vm.customCondition }),expression:"{ required:true, customCondition }"},{name:"model",rawName:"v-model",value:(waterfall.discount_value),expression:"waterfall.discount_value"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":_vm.$t('marketingCampaigns.value'),"disabled":_vm.model.type != 'COUPON' && _vm.coupons.is_waterfall},domProps:{"value":(waterfall.discount_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(waterfall, "discount_value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticStyle:{"padding-top":"30px"}},[_c('button',{staticClass:"btn btn-danger btn-icon",attrs:{"disabled":_vm.model.type != 'COUPON'},on:{"click":function($event){$event.preventDefault();_vm.deleteCascade(indexWaterfall)}}},[_c('i',{staticClass:"ti-close ",attrs:{"title":_vm.$t('general.remove')}})])])])])])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"disabled":_vm.model.type != 'COUPON'},on:{"click":function($event){$event.preventDefault();_vm.addNewCascade()}}},[_c('i',{staticClass:"ti-plus"})]),_vm._v(" "),(_vm.coupons.usage_type == 'PRODUCTS' && _vm.coupons.waterfall_discounts && _vm.coupons.waterfall_discounts.length >= 1)?_c('p-checkbox',{staticClass:"text-purple",staticStyle:{"margin-bottom":"-10px","margin-top":"20px"},model:{value:(_vm.coupons.waterfall_restriction),callback:function ($$v) {_vm.$set(_vm.coupons, "waterfall_restriction", $$v)},expression:"coupons.waterfall_restriction"}},[_c('h6',{staticClass:"coupon-selection pad-to-7"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.doesApplyOnPromotionalItems')))])]):_vm._e()],2)]:_vm._e()],2),_vm._v(" "),_vm._t("before-auto-apply"),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"couponAutoApply",staticClass:"text-purple",attrs:{"disabled":_vm.model.type != 'COUPON' || _vm.isSubscriptionCoupon || _vm.isAutomationCoupon || _vm.coupons.second_use_auto_coupon == true || _vm.coupons.coupon_has_multiple_codes == true,"label":""},on:{"input":function($event){_vm.handleAutoApply()}},model:{value:(_vm.coupons.auto_apply),callback:function ($$v) {_vm.$set(_vm.coupons, "auto_apply", $$v)},expression:"coupons.auto_apply"}},[_c('h6',{ref:"interval",staticClass:"coupon-selection pad-to-7",attrs:{"name":"coupon_interval"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.isAutoApplyCheck')))])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"cuponIsCumulative",staticClass:"text-purple",attrs:{"disabled":_vm.model.type != 'COUPON' || _vm.isSubscriptionCoupon,"label":""},on:{"input":function($event){}},model:{value:(_vm.coupons.is_cumulative),callback:function ($$v) {_vm.$set(_vm.coupons, "is_cumulative", $$v)},expression:"coupons.is_cumulative"}},[_c('h6',{ref:"interval",staticClass:"coupon-selection pad-to-7",attrs:{"name":"coupon_interval"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.isCumulativeCheck')))])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"isSecondUseCheck",staticClass:"text-purple",attrs:{"disabled":_vm.model.type != 'COUPON' || _vm.isSubscriptionCoupon || _vm.isAutomationCoupon || _vm.coupons.auto_apply == true || _vm.coupons.coupon_has_multiple_codes == true,"label":""},on:{"input":function($event){_vm.handleAutoApply()}},model:{value:(_vm.coupons.second_use_auto_coupon),callback:function ($$v) {_vm.$set(_vm.coupons, "second_use_auto_coupon", $$v)},expression:"coupons.second_use_auto_coupon"}},[_c('h6',{ref:"interval",staticClass:"coupon-selection pad-to-7",attrs:{"name":"coupon_interval"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.isSecondUseCheck')))])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"isSecondUseCheck",staticClass:"text-purple",attrs:{"disabled":_vm.model.type != 'COUPON' || _vm.isSubscriptionCoupon || _vm.isAutomationCoupon || _vm.coupons.auto_apply == true || _vm.coupons.second_use_auto_coupon == true,"label":""},on:{"input":function($event){_vm.handleAutoApply()}},model:{value:(_vm.coupons.coupon_has_multiple_codes),callback:function ($$v) {_vm.$set(_vm.coupons, "coupon_has_multiple_codes", $$v)},expression:"coupons.coupon_has_multiple_codes"}},[_c('h6',{ref:"interval",staticClass:"coupon-selection pad-to-7",attrs:{"name":"coupon_interval"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.couponHasMultipleCodes')))])])],1),_vm._v(" "),(_vm.isSubscriptionCoupon)?_c('div',{staticClass:"form-group coupon-subscription-nocode"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$t('marketingCoupons.subscriptionNoCode'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.isAutomationCoupon)?_c('div',{staticClass:"form-group coupon-automation-nocode"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$t('marketingCoupons.automationInfoCode', { cod: '{cod}' }))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.coupons.coupon_has_multiple_codes && !_vm.isSubscriptionCoupon)?_c('div',{staticClass:"form-group coupon-code-row"},[_c('div',{staticClass:"coupon-code-row__main"},[_c('label',[_vm._v(_vm._s(_vm.isAutomationCoupon ? _vm.$t('marketingCoupons.automationCodeLabel') : _vm.$t('marketingCampaigns.code') + '*'))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.isAutomationCoupon ? _vm.automationCodeValidation : _vm.modelValidations.coupon_code),expression:"isAutomationCoupon ? automationCodeValidation : modelValidations.coupon_code"},{name:"model",rawName:"v-model",value:(_vm.coupons.coupon_code),expression:"coupons.coupon_code"}],ref:"couponCode",staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.isAutomationCoupon ? _vm.$t('marketingCoupons.automationCodePlaceholder') : _vm.$t('marketingCampaigns.code'),"disabled":_vm.model.type != 'COUPON'},domProps:{"value":(_vm.coupons.coupon_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coupons, "coupon_code", $event.target.value)}}}),_vm._v(" "),(_vm.errors.coupon_code)?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.$t('validations.requiredField'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.couponError)?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.couponError)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.couponError)?_c('br'):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-purple mar-to-10 mar-bt-10 generate-code",attrs:{"disabled":_vm.model.type != 'COUPON'},on:{"click":function($event){$event.preventDefault();_vm.generateCode()}}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.generateCode')))])]),_vm._v(" "),(_vm.singleQrUrl && !_vm.isAutomationCoupon)?_c('div',{staticClass:"coupon-qr"},[_c('a',{attrs:{"href":_vm.singleQrUrl,"target":"_blank","title":_vm.$t('marketingCoupons.openQr')}},[_c('img',{staticClass:"coupon-qr__img",attrs:{"src":_vm.singleQrUrl,"alt":"QR"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-purple btn-sm",attrs:{"disabled":_vm.exporting},on:{"click":function($event){$event.preventDefault();_vm.exportCodes()}}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" "+_vm._s(_vm.$t('marketingCoupons.export'))+"\n            ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.coupons.coupon_has_multiple_codes)?_c('div',{staticClass:"box coupon-generator"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorTitle')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorCount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.generator.count),expression:"generator.count",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"1000"},domProps:{"value":(_vm.generator.count)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.generator, "count", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorLength')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.generator.length),expression:"generator.length",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"4","max":"20"},domProps:{"value":(_vm.generator.length)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.generator, "length", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorCharset')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.generator.charset),expression:"generator.charset"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.generator, "charset", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"alnum"}},[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorCharsetAlnum')))]),_vm._v(" "),_c('option',{attrs:{"value":"letters"}},[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorCharsetLetters')))]),_vm._v(" "),_c('option',{attrs:{"value":"digits"}},[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorCharsetDigits')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorPrefix')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.generator.prefix),expression:"generator.prefix"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"20","placeholder":"VARA-"},domProps:{"value":(_vm.generator.prefix)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.generator, "prefix", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorSuffix')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.generator.suffix),expression:"generator.suffix"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"20","placeholder":"-26"},domProps:{"value":(_vm.generator.suffix)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.generator, "suffix", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorGroup')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.generator.group),expression:"generator.group",modifiers:{"number":true}}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.generator, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorGroupNone')))]),_vm._v(" "),_c('option',{domProps:{"value":3}},[_vm._v("3 (ABC-DEF)")]),_vm._v(" "),_c('option',{domProps:{"value":4}},[_vm._v("4 (ABCD-EFGH)")]),_vm._v(" "),_c('option',{domProps:{"value":5}},[_vm._v("5 (ABCDE-FGHIJ)")])])])]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingCoupons.generatorExample'))+": "),_c('b',[_vm._v(_vm._s(_vm.generatorExample))])]),_vm._v(" "),(_vm.generatorError)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.generatorError)),_c('br')]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-purple",attrs:{"disabled":_vm.generating},on:{"click":function($event){$event.preventDefault();_vm.generateCodes()}}},[_c('i',{staticClass:"fa fa-magic"}),_vm._v(" "+_vm._s(_vm.$t('marketingCoupons.generate'))+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.coupons.coupon_has_multiple_codes)?_c('div',{staticClass:"box",staticStyle:{"border":"1px solid #f2f2f2","padding":"10px"}},[_c('label',[_vm._v("Import Codes")]),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.importedCodes),expression:"importedCodes"}],staticStyle:{"width":"100%","resize":"vertical"},domProps:{"value":(_vm.importedCodes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.importedCodes=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-purple",on:{"click":function($event){_vm.importCodes()}}},[_vm._v("Import")])])])])]):_vm._e(),_vm._v(" "),(_vm.coupons.coupon_has_multiple_codes)?_c('div',{staticClass:"box",staticStyle:{"border":"1px solid #f2f2f2","padding":"10px","display":"flex","align-items":"self-start","flex-direction":"column"}},[_c('div',{staticClass:"coupon-codes-header"},[_c('label',[_vm._v("Coduri Cupon ("+_vm._s(_vm.activeCodes.length)+")")]),_vm._v(" "),(_vm.activeCodes.length)?_c('div',[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.preventDefault();_vm.deleteAllCodes()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "+_vm._s(_vm.$t('marketingCoupons.deleteAllCodes'))+"\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-purple btn-sm",attrs:{"disabled":_vm.exporting},on:{"click":function($event){$event.preventDefault();_vm.exportCodes()}}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" "+_vm._s(_vm.$t('marketingCoupons.export'))+"\n              ")])]):_vm._e()]),_vm._v(" "),_vm._l((_vm.pagedCodes),function(item){return _c('div',{key:item.index,staticClass:"coupon-code-item",class:{'coupon-code-item--used': _vm.codeStatus(item.row) === 'used'}},[(_vm.codeQrUrl(item.row))?_c('a',{staticClass:"coupon-code-item__qr",attrs:{"href":_vm.codeQrUrl(item.row),"target":"_blank","title":_vm.$t('marketingCoupons.openQr')}},[_c('img',{attrs:{"src":_vm.codeQrUrl(item.row),"alt":"QR"}})]):_c('span',{staticClass:"coupon-code-item__qr coupon-code-item__qr--empty"}),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.coupons_codes.code),expression:"modelValidations.coupons_codes.code"},{name:"model",rawName:"v-model",value:(item.row.code),expression:"item.row.code"}],staticClass:"form-control coupon-code-item__input",attrs:{"type":"text","placeholder":_vm.$t('marketingCampaigns.code'),"disabled":item.row.used == 1},domProps:{"value":(item.row.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item.row, "code", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"coupon-code-status",class:'coupon-code-status--' + _vm.codeStatus(item.row)},[_vm._v("\n              "+_vm._s(_vm.$t('marketingCoupons.codeStatus_' + _vm.codeStatus(item.row)))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon",on:{"click":function($event){$event.preventDefault();_vm.deleteCode(item.index)}}},[_c('i',{staticClass:"ti-close ",attrs:{"title":_vm.$t('general.remove')}})])])}),_vm._v(" "),(_vm.activeCodes.length > _vm.codesPageSizes[0])?_c('el-pagination',{attrs:{"layout":"sizes, prev, pager, next","total":_vm.activeCodes.length,"page-sizes":_vm.codesPageSizes,"page-size":_vm.codesPageSize,"current-page":_vm.codesPage},on:{"update:currentPage":function($event){_vm.codesPage=$event},"size-change":_vm.onCodesPageSizeChange}}):_vm._e(),_vm._v(" "),(_vm.errors.coupon_code)?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.$t('validations.requiredField'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.couponError)?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.couponError)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.couponError)?_c('br'):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"disabled":_vm.model.type != 'COUPON'},on:{"click":function($event){$event.preventDefault();_vm.addNewCode()}}},[_c('i',{staticClass:"ti-plus"})])],2):_vm._e(),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"interval",staticClass:"text-purple",attrs:{"disabled":_vm.model.type != 'COUPON',"label":""},on:{"input":function($event){_vm.clearCurrentInterval(_vm.coupons.use_time_interval)}},model:{value:(_vm.coupons.use_time_interval),callback:function ($$v) {_vm.$set(_vm.coupons, "use_time_interval", $$v)},expression:"coupons.use_time_interval"}},[_c('h6',{ref:"interval",staticClass:"coupon-selection pad-to-7",attrs:{"name":"coupon_interval"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.useInterval')))])]),_vm._v(" "),(_vm.errorInterval)?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.errorInterval)+"\n          ")]):_vm._e()],1),_vm._v(" "),(_vm.coupons.use_time_interval)?[_vm._l((_vm.coupons.interval_settings),function(interval,index){return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.chooseDayForInterval')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.days,"disabled":_vm.model.type != 'COUPON',"placeholder":_vm.$t('general.all')},model:{value:(interval.day),callback:function ($$v) {_vm.$set(interval, "day", $$v)},expression:"interval.day"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.chooseHoursForInterval')))]),_vm._v(" "),_c('div',{staticClass:"campaign-forth-step-interval"},[_c('div',[_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.interval_settings.from),expression:"modelValidations.interval_settings.from"}],class:{ 'interval-field-error': _vm.errors.has('interval_from_' + index) },attrs:{"placeholder":_vm.$t('general.from'),"disabled":_vm.model.type != 'COUPON',"name":'interval_from_' + index,"data-vv-as":"interval.from","picker-options":_vm.pickerOptions},model:{value:(interval.from),callback:function ($$v) {_vm.$set(interval, "from", $$v)},expression:"interval.from"}}),_vm._v(" "),(_vm.errors.has('interval_from_' + index))?_c('small',{staticClass:"text-danger",staticStyle:{"display":"block","margin-top":"4px"}},[_vm._v("\n                      "+_vm._s(_vm.$t('validations.requiredField'))+"\n                    ")]):_vm._e()],1),_vm._v(" "),_c('div',[_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.interval_settings.to),expression:"modelValidations.interval_settings.to"}],class:{ 'interval-field-error': _vm.errors.has('interval_to_' + index) },attrs:{"placeholder":_vm.$t('general.to'),"disabled":_vm.model.type != 'COUPON',"name":'interval_to_' + index,"data-vv-as":"interval.to","picker-options":_vm.pickerOptions},model:{value:(interval.to),callback:function ($$v) {_vm.$set(interval, "to", $$v)},expression:"interval.to"}}),_vm._v(" "),(_vm.errors.has('interval_to_' + index))?_c('small',{staticClass:"text-danger",staticStyle:{"display":"block","margin-top":"4px"}},[_vm._v("\n                      "+_vm._s(_vm.$t('validations.requiredField'))+"\n                    ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_c('button',{staticClass:"btn btn-danger btn-icon pull-right",attrs:{"disabled":_vm.model.type != 'COUPON'},on:{"click":function($event){$event.preventDefault();_vm.deleteInterval(index)}}},[_c('i',{staticClass:"ti-close ",attrs:{"title":_vm.$t('general.remove')}})])])])]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"disabled":_vm.model.type != 'COUPON',"title":_vm.$t('marketingCampaigns.addInterval')},on:{"click":function($event){$event.preventDefault();_vm.addNewInterval()}}},[_c('i',{staticClass:"ti-plus"})])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.counter_max_usage')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.counter_max_usage),expression:"modelValidations.counter_max_usage"},{name:"model",rawName:"v-model",value:(_vm.coupons.counter_max_usage),expression:"coupons.counter_max_usage"}],ref:"couponCounterMaxUsage",staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('marketingCampaigns.counter_max_usage_example'),"disabled":_vm.model.type != 'COUPON' || _vm.coupons.coupon_has_multiple_codes || _vm.isSubscriptionCoupon || _vm.isAutomationCoupon},domProps:{"value":(_vm.coupons.counter_max_usage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coupons, "counter_max_usage", $event.target.value)}}}),_vm._v(" "),(_vm.errors.counter_max_usage)?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('counter_max_usage'))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.counter_max_usage_total')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.counter_max_usage_total),expression:"modelValidations.counter_max_usage_total"},{name:"model",rawName:"v-model",value:(_vm.coupons.counter_max_usage_total),expression:"coupons.counter_max_usage_total"}],ref:"couponCounterMaxUsage",staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('marketingCampaigns.counter_max_usage_total_example'),"disabled":_vm.model.type != 'COUPON' || _vm.coupons.coupon_has_multiple_codes || _vm.isSubscriptionCoupon || _vm.isAutomationCoupon},domProps:{"value":(_vm.coupons.counter_max_usage_total)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.coupons, "counter_max_usage_total", $event.target.value)}}}),_vm._v(" "),(_vm.errors.counter_max_usage_total)?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('counter_max_usage_total'))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.delivery_methods')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.deliveryMethods,"label":"label","disabled":_vm.model.type != 'COUPON',"placeholder":_vm.$t('general.all')},model:{value:(_vm.coupons.delivery_methods),callback:function ($$v) {_vm.$set(_vm.coupons, "delivery_methods", $$v)},expression:"coupons.delivery_methods"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.order_source_ids')))]),_vm._v(" "),_c('v-select',{attrs:{"value":_vm.selectedOrderSources,"multiple":"","options":_vm.orderSourceOptions,"label":"label","disabled":!_vm.isCampaignModel || _vm.model.type != 'COUPON',"placeholder":_vm.$t('marketingCampaigns.order_source_ids_all')},on:{"input":_vm.onOrderSourcesChanged}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.order_source_ids_help')))])],1),_vm._v(" "),(_vm.locations.length > 1)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.location_ids')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.locations,"label":"name","disabled":_vm.model.type != 'COUPON',"placeholder":_vm.$t('general.all')},on:{"input":_vm.getCategories},model:{value:(_vm.coupons.location_ids),callback:function ($$v) {_vm.$set(_vm.coupons, "location_ids", $$v)},expression:"coupons.location_ids"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingFidelities.userLabeling')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.userLabelLevels,"label":"label","placeholder":_vm.$t('general.all')},model:{value:(_vm.coupons.user_label_selected),callback:function ($$v) {_vm.$set(_vm.coupons, "user_label_selected", $$v)},expression:"coupons.user_label_selected"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.groups')))]),_vm._v(" "),_c('v-select',{attrs:{"placeholder":_vm.$t('general.all'),"multiple":"","disabled":_vm.model.type != 'COUPON',"options":_vm.customerGroups,"label":"name"},model:{value:(_vm.editableCustomerGroups),callback:function ($$v) {_vm.editableCustomerGroups=$$v},expression:"editableCustomerGroups"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.exclude_groups')))]),_vm._v(" "),_c('v-select',{attrs:{"placeholder":_vm.$t('general.all'),"multiple":"","options":_vm.customerGroups,"label":"name"},model:{value:(_vm.coupons.excluding_group_customers),callback:function ($$v) {_vm.$set(_vm.coupons, "excluding_group_customers", $$v)},expression:"coupons.excluding_group_customers"}})],1)],2),_vm._v(" "),(_vm.coupons.usage_type == 'PRODUCTS' && !_vm.isSpinningWheelFreeProductCoupon)?_c('div',{staticClass:"col-md-6 icon-search"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.chooseCategProduct'))+"*")]),_vm._v(" "),_c('el-tree',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.treeLoading),expression:"treeLoading"}],ref:"tree",staticClass:"el-product-border filter-tree",attrs:{"empty-text":_vm.treeLoading ? ' ' : _vm.$t('marketingCoupons.noCategories'),"data":_vm.newCategories,"props":_vm.treeConfig,"check-strictly":false,"filter-node-method":_vm.filterNode,"default-checked-keys":_vm.checkedKeys,"node-key":"id","show-checkbox":"","accordion":""},on:{"node-expand":_vm.loadProducts,"check-change":_vm.validate}}),_vm._v(" "),_c('div',{staticClass:"buttons mar-to-5"},[_c('el-button',{on:{"click":function($event){_vm.checkAll()}}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.checkAll')))]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.resetProductTree()}}},[_vm._v(_vm._s(_vm.$t('general.reset')))])],1),_vm._v(" "),(_vm.errorTree)?_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errorTree)+"\n        ")]):_vm._e()],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cXXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r6_vue__ = __webpack_require__("z4Ma");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_977eb182_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r6_vue__ = __webpack_require__("hI5E");
function injectStyle (ssrContext) {
  __webpack_require__("CtxG")
  __webpack_require__("oLmw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-977eb182"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_r6_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_977eb182_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_r6_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cZgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row wolt-drive-integration-form"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('location_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('location_id'))),(_vm.isRequired('location_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.location_id),expression:"formData.location_id"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'wolt-drive-loc-' + String(loc._integrationLocationId),class:{ 'integration-location-option--occupied': _vm.isLocationOccupied(loc._integrationLocationId) },attrs:{"disabled":_vm.isLocationOccupied(loc._integrationLocationId)},domProps:{"value":loc._integrationLocationId}},[_vm._v("\n          "+_vm._s(_vm.locationOptionLabel(loc))+"\n        ")])})],2),_vm._v(" "),(_vm.showFieldError('location_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('location_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('api_url') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('api_url'))),(_vm.isRequired('api_url'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.api_url),expression:"formData.api_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.api_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "api_url", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('api_url'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('api_url')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('access_token') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('access_token'))),(_vm.isRequired('access_token'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.access_token),expression:"formData.access_token"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.access_token)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "access_token", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('access_token'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('access_token')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('merchant_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('merchant_id'))),(_vm.isRequired('merchant_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.merchant_id),expression:"formData.merchant_id"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.merchant_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "merchant_id", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('merchant_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('merchant_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('venue_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('venue_id'))),(_vm.isRequired('venue_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.venue_id),expression:"formData.venue_id"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.venue_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "venue_id", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('venue_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('venue_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('order_total_handshake') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('order_total_handshake')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.order_total_handshake),expression:"formData.order_total_handshake"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.order_total_handshake)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "order_total_handshake", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('order_total_handshake'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('order_total_handshake')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"wolt-drive-integration-form__auto-send-row"},[_c('div',{staticClass:"wolt-drive-integration-form__auto-send-status"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('auto_send_at_status') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('auto_send_at_status')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.auto_send_at_status),expression:"formData.auto_send_at_status"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "auto_send_at_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.autoSendStatusOptions),function(opt){return _c('option',{key:'wolt-drive-status-' + opt.value,domProps:{"value":opt.value}},[_vm._v("\n              "+_vm._s(opt.label)+"\n            ")])})),_vm._v(" "),(_vm.showFieldError('auto_send_at_status'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('auto_send_at_status')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"wolt-drive-integration-form__auto-send-time"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('auto_send_time') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('auto_send_time')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.auto_send_time),expression:"formData.auto_send_time"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled || _vm.isAutoSendManual},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "auto_send_time", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.autoSendTimeOptions),function(mins){return _c('option',{key:'wolt-drive-time-' + mins,domProps:{"value":mins}},[_vm._v("\n              "+_vm._s(mins)+"\n            ")])})),_vm._v(" "),(_vm.showFieldError('auto_send_time'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('auto_send_time')))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group wolt-drive-integration-form__switch-row"},[_c('label',{staticClass:"wolt-drive-integration-form__switch-label"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"wolt-drive-integration-form__switch-control"},[_c('p-switch',{staticClass:"mar-bt-0",attrs:{"type":"success","name":"wolt-drive-active","disabled":_vm.disabled},model:{value:(_vm.formData.active),callback:function ($$v) {_vm.$set(_vm.formData, "active", $$v)},expression:"formData.active"}}),_vm._v(" "),_c('label',{attrs:{"for":"wolt-drive-active"}},[_vm._v(_vm._s(_vm.fieldLabel('active')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('feedback_emails') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('feedback_emails')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.feedback_emails),expression:"formData.feedback_emails"}],staticClass:"form-control",attrs:{"rows":"3","disabled":_vm.disabled,"placeholder":_vm.$t('gestiune.integrationsFeedbackEmailsHint')},domProps:{"value":(_vm.formData.feedback_emails)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "feedback_emails", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"help-block text-muted"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsFeedbackEmailsHint')))]),_vm._v(" "),(_vm.showFieldError('feedback_emails'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('feedback_emails')))]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cbEo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't10'
});

/***/ }),

/***/ "cdNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_json_excel__ = __webpack_require__("fXhN");















__WEBPACK_IMPORTED_MODULE_8_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_10_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_date_picker___default.a),
  props: {
    isProductSales: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isProductSales: function isProductSales() {
      if (this.isProductSales) {
        this.getProducts();
      }
    }
  },
  created: function created() {
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear();
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '_' + this.$t('reports.productsSalesReport') + '_' + formattedDate + '.xls';
    this.verifyUserLocations();
  },
  data: function data() {
    var _jsonFields, _jsonFieldsV;

    return {
      loading: true,
      category: [],
      topCategorySelected: [],
      categorySelected: [],
      allCategories: [],
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      products: {
        'valid': [__WEBPACK_IMPORTED_MODULE_9_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_9_moment___default()().endOf('month').format('YYYY-MM-DD')],
        location: ''
      },
      locations: [],
      showLocations: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_9_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      productsTableData: {},
      totalRecords: null,
      totalQuantity: null,
      jsonFields: (_jsonFields = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.productName'), 'name'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.quantity'), 'qty'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.pricePerUnit'), 'price_per_unit'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.totalSum'), 'total_sales_value'), _jsonFields),
      customJsonFields: {
        'Order ID': 'order_id',
        'Order Number': 'order_number',
        'Client': 'client',
        'Telefon': 'phone',
        'Adresa': 'address',
        'Comentariu': 'comment',
        'Produs': 'product_name',
        'Cantitate': 'product_qty',
        'Pret Net': 'product_price',
        'Nr Bon': 'receipt_number'
      },
      jsonFieldsV2: (_jsonFieldsV = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_jsonFieldsV, this.$t('reports.productName'), 'name'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_jsonFieldsV, this.$t('reports.quantity'), 'qty'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_jsonFieldsV, this.$t('reports.pricePerUnit'), 'price'), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_jsonFieldsV, this.$t('reports.totalSum'), 'total_sales_value'), _jsonFieldsV),
      export_name: '',
      json_data: [],
      custom_json_data: [],
      totalSum: 0
    };
  },

  methods: {
    productExportData: function productExportData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp, data, productSalesData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resp = [];

                if (!_this.totalQuantity) {
                  _context.next = 8;
                  break;
                }

                data = {
                  token: _this.$session.get('token'),
                  company_id: _this.$session.get('selectedCompany'),
                  start_date: _this.products.valid[0],
                  end_date: _this.products.valid[1],
                  categorySelected: _this.categorySelected,
                  topCategorySelected: _this.topCategorySelected
                };
                productSalesData = [];
                _context.next = 6;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var ver = _this.$route.query && _this.$route.query.ver === 'V2' ? 'V2' : '';
                  _this.apiRequest('/reports/products-sales-report' + ver + '?withProducts=1&page=' + 1 + '&pageSize=' + 50000, 'GET', data, function (response) {
                    productSalesData = response.data.products.data;
                    if (productSalesData) {
                      _this.json_data = response.data.export_excel;
                      _this.totalSum = response.data.total_sum;
                      _this.totalRecords = response.data.total;
                      _this.category = response.data.category;
                      _this.totalQuantity = response.data.total_quantity;
                    }
                    resolve(productSalesData);
                  });
                });

              case 6:
                resp = _context.sent;
                return _context.abrupt('return', resp);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    startDownload: function startDownload() {
      this.loading = true;
    },
    finishDownload: function finishDownload() {
      this.loading = false;
    },
    resetCategorySelect: function resetCategorySelect() {
      var _this2 = this;

      this.categorySelected = [];
      this.allCategories = [];
      this.topCategorySelected.forEach(function (element) {
        element.category.forEach(function (el) {
          _this2.allCategories.push(el);
        });
      });
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getProducts(query);
      if (query.type === 'size') this.getProducts(query);
      if (query.type === 'sort') this.getProducts(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details;
      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }
      if (this.locations.length > 1) {
        this.showLocations = true;
        var filterCookie = this.$cookie.get('filter-locations');
        if (filterCookie) {
          filterCookie = JSON.parse(filterCookie);
          this.products.location = filterCookie[0];
        }
      }
    },
    getProducts: function getProducts(query) {
      var _this3 = this;

      if (!this.isProductSales) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.products.valid[0],
        end_date: this.products.valid[1],
        categorySelected: this.categorySelected,
        topCategorySelected: this.topCategorySelected
      };
      if (this.products.location && this.products.location !== '') {
        data.location_id = this.products.location;
      }
      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      var ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : '';
      this.apiRequest('/reports/products-sales-report' + ver + '?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status === true) {
          _this3.productsTableData = response.data.products;
          _this3.json_data = response.data.export_excel;
          _this3.custom_json_data = response.data.export_custom_excel;
          _this3.totalSum = response.data.total_sum;
          _this3.totalRecords = response.data.total;
          _this3.category = response.data.category;
          _this3.totalQuantity = response.data.total_quantity;
        }
        _this3.$nextTick(function () {
          _this3.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getProducts();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.products.location]), 30);
    },
    goToRecordOrder: function goToRecordOrder(row, event, column) {
      window.open('/#/products/edit/' + row.id);
    },
    daysBetween: function daysBetween(date1, date2) {
      var oneDay = 1000 * 60 * 60 * 24;
      var date1Ms = date1.getTime();
      var date2Ms = date2.getTime();
      var differenceMs = date2Ms - date1Ms;
      return Math.round(differenceMs / oneDay);
    },
    firstDayofMonth: function firstDayofMonth() {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      return firstDay;
    },
    lastDayofMonth: function lastDayofMonth() {
      var date = new Date();
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return lastDay;
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    tabClicked: function tabClicked(selectedTab) {},
    tabChanged: function tabChanged(selectedTab) {}
  }
});

/***/ }),

/***/ "ce0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Test_vue__ = __webpack_require__("X64J");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'Test', __WEBPACK_IMPORTED_MODULE_7__Test_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "celo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cfI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaignEdit_vue__ = __webpack_require__("NEY0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c8dc14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaignEdit_vue__ = __webpack_require__("bxGZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaignEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c8dc14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaignEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "chgN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      bacsisView: false,
      isFullScreen: false,
      currency: '',
      timeoutGetOrder: null,
      bacsisViewTimeout: null,
      company_id: null,
      order: {}
    };
  },

  created: function created() {
    this.company_id = this.$session.get('selectedCompany');
    this.order = JSON.parse(localStorage.getItem('order_for_' + this.company_id));
    this.getCompanyDetail('currency');
    this.getOrder();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopGetOrder();
  },

  methods: {
    stopGetOrder: function stopGetOrder() {
      clearInterval(this.timeoutGetOrder);
    },
    getOrder: function getOrder() {
      var _this = this;

      clearInterval(this.timeoutGetOrder);
      this.timeoutGetOrder = setInterval(function () {
        _this.order = JSON.parse(localStorage.getItem('order_for_' + _this.company_id));
        _this.loading = true;

        if (_this.order && _this.order.people) {
          for (var i = _this.order.people.length - 1; i >= 0; i--) {
            if (_this.order.people[i].products.length) {
              _this.loading = false;
              _this.bacsisViewTimeout = setTimeout(function () {
                _this.bacsisView = true;
              }, 5000);
            }
          }
        }
      }, 500);
    },
    addTip: function addTip(proc) {
      var tip = this.order.total_order_price * (proc / 100);
      localStorage.setItem('order_for_' + this.company_id + '_add_tip', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(tip));
    },
    goFullScreen: function goFullScreen() {
      var element = document.querySelector('#orderPosClientScreen');
      this.requestFullScreen(element);
    },
    requestFullScreen: function requestFullScreen(element) {
      var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
      if (requestMethod) {
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== 'undefined') {
        var wscript = new ActiveXObject('WScript.Shell');
        if (wscript !== null) {
          wscript.SendKeys('{F11}');
        }
      }
    }
  }
});

/***/ }),

/***/ "csaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReferralCampaignForm_vue__ = __webpack_require__("GyU5");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ReferralCampaignForm: __WEBPACK_IMPORTED_MODULE_0__ReferralCampaignForm_vue__["a" /* default */] },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),

/***/ "ct2q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"})])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.$route.params.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteOrderScreen($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"width":"100%","margin":"0 0 20px"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":"ID"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}})])]),_vm._v(" "),(_vm.model.id)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.loginCode')))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","name":"token","disabled":"true","placeholder":_vm.$t('settingTable.loginCode')},domProps:{"value":_vm.model.company_id + '.' + _vm.model.id}})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Name"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.location')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.location_id),expression:"modelValidate.location_id"},{name:"model",rawName:"v-model",value:(_vm.model.location_id),expression:"model.location_id"}],staticClass:"form-control",attrs:{"name":"location"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.changeLocation()}]}},[_c('option',{attrs:{"value":"null","disabled":""}},[_vm._v(_vm._s(_vm.$t('general.none')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}})})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.is_dispatch')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_dispatch),callback:function ($$v) {_vm.$set(_vm.model, "is_dispatch", $$v)},expression:"model.is_dispatch"}})],1),_vm._v(" "),(_vm.model.is_dispatch)?_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.sync_products_from_all_locations')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.sync_products_from_all_locations),callback:function ($$v) {_vm.$set(_vm.model, "sync_products_from_all_locations", $$v)},expression:"model.sync_products_from_all_locations"}})],1):_vm._e(),_vm._v(" "),(_vm.model.is_dispatch)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.sync_location_ids')))]),_vm._v(" "),_c('el-select',{key:"sync_location_ids",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"sync_location_ids","multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.model.sync_location_ids),callback:function ($$v) {_vm.$set(_vm.model, "sync_location_ids", $$v)},expression:"model.sync_location_ids"}},[_vm._l((_vm.locations),function(item){return [_c('el-option',{key:item.id,attrs:{"value":Number(item.id),"label":item.name}})]})],2)],1):_vm._e(),_vm._v(" "),(!_vm.model.is_dispatch)?_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.use_table_maps')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.use_table_maps),callback:function ($$v) {_vm.$set(_vm.model, "use_table_maps", $$v)},expression:"model.use_table_maps"}})],1):_vm._e(),_vm._v(" "),(!_vm.model.is_dispatch)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.maps')))]),_vm._v(" "),_c('el-select',{key:"methods",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"methods","multiple":"","filterable":"","default-first-option":"","disabled":!_vm.model.use_table_maps,"placeholder":_vm.$t('general.add')},model:{value:(_vm.model.table_maps_ids),callback:function ($$v) {_vm.$set(_vm.model, "table_maps_ids", $$v)},expression:"model.table_maps_ids"}},[_c('el-option',{key:0,attrs:{"value":null,"label":_vm.$t('general.none'),"disabled":""}}),_vm._v(" "),_vm._l((_vm.table_maps),function(item){return [_c('el-option',{attrs:{"value":item.id,"label":item.name}})]})],2)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.series')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.series),expression:"modelValidate.series"},{name:"model",rawName:"v-model",value:(_vm.model.series),expression:"model.series"}],staticClass:"form-control",attrs:{"type":"text","name":"series","placeholder":_vm.$t('settingTable.series')},domProps:{"value":(_vm.model.series)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "series", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.start_number')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.start_number),expression:"modelValidate.start_number"},{name:"model",rawName:"v-model",value:(_vm.model.start_number),expression:"model.start_number"}],staticClass:"form-control",attrs:{"type":"number","name":"start_number","placeholder":_vm.$t('settingTable.start_number')},domProps:{"value":(_vm.model.start_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "start_number", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.serverIp')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.server_ip),expression:"modelValidate.server_ip"},{name:"model",rawName:"v-model",value:(_vm.model.server_ip),expression:"model.server_ip"}],staticClass:"form-control",attrs:{"type":"text","name":"server_ip","placeholder":_vm.$t('settingTable.serverIpExample')},domProps:{"value":(_vm.model.server_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "server_ip", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.printerIp')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.printer_ip),expression:"model.printer_ip"}],staticClass:"form-control",attrs:{"type":"text","name":"printer_ip","placeholder":_vm.$t('settingTable.printerIpExample')},domProps:{"value":(_vm.model.printer_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "printer_ip", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.fiscalPrinter')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.fiscal_printer_id),expression:"model.fiscal_printer_id"}],staticClass:"form-control",attrs:{"name":"fiscal_printer_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "fiscal_printer_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.none')))]),_vm._v(" "),_vm._l((_vm.fiscalPrinter),function(el){return _c('option',{key:el.id,attrs:{"label":el.series},domProps:{"value":el.id}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.cantar')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.cantar_id),expression:"model.cantar_id"}],staticClass:"form-control",attrs:{"name":"cantar_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "cantar_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.none')))]),_vm._v(" "),_vm._l((_vm.cantare),function(el){return _c('option',{key:el.id,attrs:{"label":el.name},domProps:{"value":el.id}})})],2)])])])])])])])]),_vm._v(" "),(_vm.model.id)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"width":"100%","margin":"0"}},[_c('div',{staticClass:"card-content",staticStyle:{"width":"100%","margin":"0","display":"flex","flex-direction":"column","flex-wrap":"nowrap","justify-content":"start"}},[(!_vm.model.is_dispatch)?_c('div',{staticClass:"pos-settings-group"},[_c('h5',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('settingTable.group_tables_users')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_tables_access_only_if_assigned')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_tables_access_only_if_assigned),callback:function ($$v) {_vm.$set(_vm.model, "allow_tables_access_only_if_assigned", $$v)},expression:"model.allow_tables_access_only_if_assigned"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.disable_seats')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.disable_seats),callback:function ($$v) {_vm.$set(_vm.model, "disable_seats", $$v)},expression:"model.disable_seats"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.disable_pager')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.disable_pager),callback:function ($$v) {_vm.$set(_vm.model, "disable_pager", $$v)},expression:"model.disable_pager"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.table_for_one_user')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.table_for_one_user),expression:"model.table_for_one_user"}],staticClass:"form-control color-option-default",attrs:{"name":"table_for_one_user"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "table_for_one_user", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:null,domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('settingTable.as_useer')))]),_vm._v(" "),_c('option',{key:false,domProps:{"value":false}},[_vm._v(_vm._s(_vm.$t('settingTable.inactiv')))]),_vm._v(" "),_c('option',{key:true,domProps:{"value":true}},[_vm._v(_vm._s(_vm.$t('settingTable.activ')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.sound_new_order')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.sound_new_order),callback:function ($$v) {_vm.$set(_vm.model, "sound_new_order", $$v)},expression:"model.sound_new_order"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.sound_notification')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.sound_notification),callback:function ($$v) {_vm.$set(_vm.model, "sound_notification", $$v)},expression:"model.sound_notification"}})],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pos-settings-group"},[_c('h5',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('settingTable.group_order_types')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group label-input",class:{ 'is-disabled': _vm.model.is_dispatch }},[_c('label',[_vm._v(_vm._s(_vm.orderTypeSwitchLabel('disable_eat_in')))]),_vm._v(" "),_c('p-switch',{attrs:{"value":_vm.orderTypeSwitchValue('disable_eat_in'),"disabled":_vm.model.is_dispatch,"type":"success"},on:{"input":function($event){_vm.onOrderTypeSwitchInput('disable_eat_in', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group label-input",class:{ 'is-disabled': _vm.model.is_dispatch }},[_c('label',[_vm._v(_vm._s(_vm.orderTypeSwitchLabel('disable_delivery')))]),_vm._v(" "),_c('p-switch',{attrs:{"value":_vm.orderTypeSwitchValue('disable_delivery'),"disabled":_vm.model.is_dispatch,"type":"success"},on:{"input":function($event){_vm.onOrderTypeSwitchInput('disable_delivery', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group label-input",class:{ 'is-disabled': _vm.model.is_dispatch }},[_c('label',[_vm._v(_vm._s(_vm.orderTypeSwitchLabel('disable_pick_up')))]),_vm._v(" "),_c('p-switch',{attrs:{"value":_vm.orderTypeSwitchValue('disable_pick_up'),"disabled":_vm.model.is_dispatch,"type":"success"},on:{"input":function($event){_vm.onOrderTypeSwitchInput('disable_pick_up', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group label-input",class:{ 'is-disabled': _vm.model.is_dispatch }},[_c('label',[_vm._v(_vm._s(_vm.orderTypeSwitchLabel('disable_drive_in')))]),_vm._v(" "),_c('p-switch',{attrs:{"value":_vm.orderTypeSwitchValue('disable_drive_in'),"disabled":_vm.model.is_dispatch,"type":"success"},on:{"input":function($event){_vm.onOrderTypeSwitchInput('disable_drive_in', $event)}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.default_method')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.default_method),expression:"model.default_method"}],staticClass:"form-control",attrs:{"name":"location"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "default_method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('general.none')))]),_vm._v(" "),_vm._l((_vm.allMethods),function(loc){return [(
                              !(loc.id == 1 && _vm.model.disable_eat_in) &&
                              !(loc.id == 2 && _vm.model.disable_delivery) &&
                              !(loc.id == 3 && _vm.model.disable_pick_up) &&
                              !(loc.id == 4 && _vm.model.disable_drive_in)
                            )?_c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}}):_vm._e()]})],2)])])])]),_vm._v(" "),_c('div',{staticClass:"pos-settings-group"},[_c('h5',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('settingTable.group_closing_orders')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allowClosingOrdersWithoutReceipt')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_closing_orders_without_receipt),callback:function ($$v) {_vm.$set(_vm.model, "allow_closing_orders_without_receipt", $$v)},expression:"model.allow_closing_orders_without_receipt"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_closing_orders_without_driver')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_closing_orders_without_driver),callback:function ($$v) {_vm.$set(_vm.model, "allow_closing_orders_without_driver", $$v)},expression:"model.allow_closing_orders_without_driver"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.close_order')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.close_order),callback:function ($$v) {_vm.$set(_vm.model, "close_order", $$v)},expression:"model.close_order"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_change_driver')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_change_driver),callback:function ($$v) {_vm.$set(_vm.model, "allow_change_driver", $$v)},expression:"model.allow_change_driver"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_print_note')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_print_note),callback:function ($$v) {_vm.$set(_vm.model, "allow_print_note", $$v)},expression:"model.allow_print_note"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.not_allowed_order_statuses')))]),_vm._v(" "),_c('el-select',{key:"not_allowed_order_statuses",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"not_allowed_order_statuses","multiple":"","collapse-tags":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.none')},model:{value:(_vm.model.not_allowed_order_statuses),callback:function ($$v) {_vm.$set(_vm.model, "not_allowed_order_statuses", $$v)},expression:"model.not_allowed_order_statuses"}},[_vm._l((_vm.auto_print_receipt_on_status_all),function(item){return [_c('el-option',{key:item.id,attrs:{"value":item.id,"label":_vm.$t('ordersStatus.' + item.id)}})]})],2)],1)])])]),_vm._v(" "),_c('div',{staticClass:"pos-settings-group"},[_c('h5',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('settingTable.group_payments')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.disable_tips')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.disable_tips),callback:function ($$v) {_vm.$set(_vm.model, "disable_tips", $$v)},expression:"model.disable_tips"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.disable_ballance')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.disable_ballance),callback:function ($$v) {_vm.$set(_vm.model, "disable_ballance", $$v)},expression:"model.disable_ballance"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.default_sort_checkout_buttons')))]),_vm._v(" "),_c('el-select',{key:"methods",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"methods","multiple":"","filterable":"","default-first-option":"","disabled":_vm.model.is_dispatch,"placeholder":_vm.$t('general.add')},on:{"change":_vm.handleSelectionChange},model:{value:(_vm.model.default_sort_checkout_buttons),callback:function ($$v) {_vm.$set(_vm.model, "default_sort_checkout_buttons", $$v)},expression:"model.default_sort_checkout_buttons"}},[_c('el-option',{key:0,attrs:{"value":null,"label":_vm.$t('general.none'),"disabled":""}}),_vm._v(" "),_vm._l((_vm.availableCheckoutButtons),function(item){return [_c('el-option',{key:item.id,attrs:{"value":item.name,"label":item.name}})]})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.has_bank_terminal')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.has_bank_terminal),callback:function ($$v) {_vm.$set(_vm.model, "has_bank_terminal", $$v)},expression:"model.has_bank_terminal"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.use_fiscal_net_at_modern_payment')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.use_fiscal_net_at_modern_payment),callback:function ($$v) {_vm.$set(_vm.model, "use_fiscal_net_at_modern_payment", $$v)},expression:"model.use_fiscal_net_at_modern_payment"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.has_integrated_bank_terminal')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.has_integrated_bank_terminal),callback:function ($$v) {_vm.$set(_vm.model, "has_integrated_bank_terminal", $$v)},expression:"model.has_integrated_bank_terminal"}})],1)])]),_vm._v(" "),(_vm.model.has_integrated_bank_terminal)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.server_ip')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.integrated_bank_pos_server_ip),expression:"model.integrated_bank_pos_server_ip"}],staticClass:"form-control",attrs:{"type":"text","name":"integrated_bank_pos_server_ip","data-vv-as":"integrated_bank_pos_server_ip","placeholder":_vm.$t('settingTable.server_ip')},domProps:{"value":(_vm.model.integrated_bank_pos_server_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "integrated_bank_pos_server_ip", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.type')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos_type_id),expression:"model.pos_type_id"}],staticClass:"form-control",attrs:{"name":"pos_type_id"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "pos_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:0,attrs:{"label":''},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.posOptions),function(z){return _c('option',{key:z.id,attrs:{"label":z.name},domProps:{"value":z.id}})})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.host')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.integrated_bank_pos_host),expression:"model.integrated_bank_pos_host"}],staticClass:"form-control",attrs:{"type":"text","name":"integrated_bank_pos_host","data-vv-as":"integrated_bank_pos_host","placeholder":_vm.$t('settingTable.host')},domProps:{"value":(_vm.model.integrated_bank_pos_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "integrated_bank_pos_host", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.port')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.integrated_bank_pos_port),expression:"model.integrated_bank_pos_port"}],staticClass:"form-control",attrs:{"type":"text","name":"integrated_bank_pos_port","data-vv-as":"integrated_bank_pos_port","placeholder":_vm.$t('settingTable.port')},domProps:{"value":(_vm.model.integrated_bank_pos_port)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "integrated_bank_pos_port", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("TID/MID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.integrated_bank_pos_tid_mid),expression:"model.integrated_bank_pos_tid_mid"}],staticClass:"form-control",attrs:{"type":"text","name":"integrated_bank_pos_tid_mid","data-vv-as":"integrated_bank_pos_tid_mid","placeholder":"TID/MID"},domProps:{"value":(_vm.model.integrated_bank_pos_tid_mid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "integrated_bank_pos_tid_mid", $event.target.value)}}})])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"pos-settings-group"},[_c('h5',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('settingTable.group_fiscal_printing')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_fiscal')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_fiscal),callback:function ($$v) {_vm.$set(_vm.model, "allow_fiscal", $$v)},expression:"model.allow_fiscal"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.use_block_actions_after_print')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.use_block_actions_after_print),callback:function ($$v) {_vm.$set(_vm.model, "use_block_actions_after_print", $$v)},expression:"model.use_block_actions_after_print"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.block_z_until_all_orders_fiscalized')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.block_z_until_all_orders_fiscalized),callback:function ($$v) {_vm.$set(_vm.model, "block_z_until_all_orders_fiscalized", $$v)},expression:"model.block_z_until_all_orders_fiscalized"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.stop_print_section')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.stop_print_section),callback:function ($$v) {_vm.$set(_vm.model, "stop_print_section", $$v)},expression:"model.stop_print_section"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_change_payment_type_on_fiscalization')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.allow_change_payment_type_on_fiscalization),callback:function ($$v) {_vm.$set(_vm.model, "allow_change_payment_type_on_fiscalization", $$v)},expression:"model.allow_change_payment_type_on_fiscalization"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.auto_print_receipt')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},on:{"input":_vm.changeAutoPrintReceipt},model:{value:(_vm.model.auto_print_receipt),callback:function ($$v) {_vm.$set(_vm.model, "auto_print_receipt", $$v)},expression:"model.auto_print_receipt"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.auto_print_receipt_on_metods')))]),_vm._v(" "),_c('el-select',{key:"auto_print_receipt_on_metods",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"auto_print_receipt_on_metods","multiple":"","collapse-tags":"","disabled":!_vm.model.auto_print_receipt,"filterable":"","default-first-option":"","placeholder":_vm.$t('general.none')},model:{value:(_vm.model.auto_print_receipt_on_metods),callback:function ($$v) {_vm.$set(_vm.model, "auto_print_receipt_on_metods", $$v)},expression:"model.auto_print_receipt_on_metods"}},[_c('el-option',{key:0,attrs:{"value":null,"label":_vm.$t('general.none'),"disabled":""}}),_vm._v(" "),_vm._l((_vm.auto_print_receipt_on_metods_all),function(item){return [_c('el-option',{key:item.id,attrs:{"value":item.id,"label":_vm.$t('paymentTypes.' + item.id)}})]})],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.auto_print_receipt_on_status')))]),_vm._v(" "),_c('el-select',{key:"auto_print_receipt_on_status",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"auto_print_receipt_on_status","multiple":"","collapse-tags":"","disabled":!_vm.model.auto_print_receipt,"filterable":"","default-first-option":"","placeholder":_vm.$t('general.none')},model:{value:(_vm.model.auto_print_receipt_on_status),callback:function ($$v) {_vm.$set(_vm.model, "auto_print_receipt_on_status", $$v)},expression:"model.auto_print_receipt_on_status"}},[_c('el-option',{key:0,attrs:{"value":null,"label":_vm.$t('general.none'),"disabled":""}}),_vm._v(" "),_vm._l((_vm.auto_print_receipt_on_status_all),function(item){return [_c('el-option',{key:item.id,attrs:{"value":item.id,"label":_vm.$t('ordersStatus.' + item.id)}})]})],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allowed_fiscal_payment_methods')))]),_vm._v(" "),_c('el-select',{key:"allowed_fiscal_payment_methods",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"allowed_fiscal_payment_methods","multiple":"","collapse-tags":!_vm.model.is_dispatch,"filterable":"","default-first-option":"","disabled":_vm.model.is_dispatch,"placeholder":_vm.$t('general.all')},model:{value:(_vm.model.allowed_fiscal_payment_methods),callback:function ($$v) {_vm.$set(_vm.model, "allowed_fiscal_payment_methods", $$v)},expression:"model.allowed_fiscal_payment_methods"}},[_vm._l((_vm.availableFiscalPaymentMethods),function(item){return [_c('el-option',{key:item.id,attrs:{"value":item.id,"label":item.label || _vm.$t('paymentTypes.' + item.id)}})]})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.auto_print_fiscal_on_status')))]),_vm._v(" "),_c('el-select',{key:"auto_print_fiscal_on_status",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"auto_print_fiscal_on_status","multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.model.auto_print_fiscal_on_status),callback:function ($$v) {_vm.$set(_vm.model, "auto_print_fiscal_on_status", $$v)},expression:"model.auto_print_fiscal_on_status"}},[_c('el-option',{key:0,attrs:{"value":null,"label":_vm.$t('general.none'),"disabled":""}}),_vm._v(" "),_vm._l((_vm.auto_print_all_statuses),function(item){return [_c('el-option',{attrs:{"value":item.name,"label":item.name}})]})],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.auto_print_fiscal_on_source')))]),_vm._v(" "),_c('el-select',{key:"auto_print_fiscal_on_source",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"auto_print_fiscal_on_source","multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.model.auto_print_fiscal_on_source),callback:function ($$v) {_vm.$set(_vm.model, "auto_print_fiscal_on_source", $$v)},expression:"model.auto_print_fiscal_on_source"}},[_c('el-option',{key:0,attrs:{"value":null,"label":_vm.$t('general.none'),"disabled":""}}),_vm._v(" "),_vm._l((_vm.auto_print_all_sources),function(item){return [_c('el-option',{attrs:{"value":item.name,"label":item.name}})]})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.auto_print_fiscal_on_payment_methods')))]),_vm._v(" "),_c('el-select',{key:"auto_print_fiscal_on_payment_methods",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"auto_print_fiscal_on_payment_methods","multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.model.auto_print_fiscal_on_payment_methods),callback:function ($$v) {_vm.$set(_vm.model, "auto_print_fiscal_on_payment_methods", $$v)},expression:"model.auto_print_fiscal_on_payment_methods"}},[_vm._l((_vm.auto_print_receipt_on_metods_all),function(item){return [_c('el-option',{key:item.id,attrs:{"value":item.id,"label":_vm.$t('paymentTypes.' + item.id)}})]})],2)],1)])])]),_vm._v(" "),_c('div',{staticClass:"pos-settings-group"},[_c('h5',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('settingTable.group_display')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.dispalyProductsImage')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.display_products_image),callback:function ($$v) {_vm.$set(_vm.model, "display_products_image", $$v)},expression:"model.display_products_image"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.disable_required_options')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.disable_required_options),callback:function ($$v) {_vm.$set(_vm.model, "disable_required_options", $$v)},expression:"model.disable_required_options"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.lock_screen_timeout_min')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.lock_screen_timeout_min),expression:"model.lock_screen_timeout_min"}],staticClass:"form-control",attrs:{"type":"text","name":"lock_screen_timeout_min","maxlength":"3"},domProps:{"value":(_vm.model.lock_screen_timeout_min)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lock_screen_timeout_min", $event.target.value)},function($event){_vm.model.lock_screen_timeout_min = $event.target.value.replace(/[^0-9]/g, '').slice(0, 3)}]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"menu_orientation"}},[_vm._v(_vm._s(_vm.$t('settingTable.menu_orientation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.menu_orientation),expression:"model.menu_orientation"}],staticClass:"form-control color-option-default",attrs:{"name":"menu_orientation"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "menu_orientation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.menuOrientation),function(item,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v("\n                        "+_vm._s(_vm.$t('settingTable.' + item))+"\n                      ")])}))]),_vm._v(" "),_c('BackgroundColorPicker',{attrs:{"title":_vm.$t('settingsWeb.background_color'),"color":_vm.model.background_color},on:{"color-change":_vm.updateColor}})],1)])]),_vm._v(" "),_c('div',{staticClass:"pos-settings-group"},[_c('h5',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('settingTable.group_reports')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.set_logged_user_in_reports')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.set_logged_user_in_reports),callback:function ($$v) {_vm.$set(_vm.model, "set_logged_user_in_reports", $$v)},expression:"model.set_logged_user_in_reports"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.comment_for_virament')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.comment_for_virament),callback:function ($$v) {_vm.$set(_vm.model, "comment_for_virament", $$v)},expression:"model.comment_for_virament"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('pos.default_interval_raport')))]),_vm._v(" "),_c('el-select',{key:"default_interval_raport",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"default_interval_raport","placeholder":_vm.$t('general.add')},model:{value:(_vm.model.default_interval_raport),callback:function ($$v) {_vm.$set(_vm.model, "default_interval_raport", $$v)},expression:"model.default_interval_raport"}},[_vm._l((_vm.default_intervals_raport),function(item){return [_c('el-option',{attrs:{"value":item.id,"label":item.name}})]})],2)],1)])])])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cwHv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("Yq4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog__ = __webpack_require__("qubY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue__);

















var _components;




__WEBPACK_IMPORTED_MODULE_17_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductImportDetail',
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      confirming: false,
      saving: false,
      batch: null,
      rows: [],
      editVisible: false,
      confirmVisible: false,
      editRowId: null,
      editData: null,
      locationId: null,
      importId: null,
      locationPriceProfiles: [],
      confirmPriceProfileId: null,
      topCategoryNames: [],
      categoryNames: [],
      secCategList: [],
      productSearchResults: [],
      searchProductsLoading: false,
      searchTimeout: null,
      selectedSearchProductId: null,
      productMatchState: 'idle',
      productMatchName: '',
      validatingProductId: false
    };
  },

  computed: {
    canConfirm: function canConfirm() {
      if (!this.batch) return false;
      return ['PENDING', 'PARTIALLY_CONFIRMED'].indexOf(this.batch.status) !== -1 && this.batch.pending_rows > 0;
    },
    priceProfileLabel: function priceProfileLabel() {
      if (!this.batch) return '';
      if (this.batch.price_profile && this.batch.price_profile.name) {
        return this.batch.price_profile.name;
      }
      if (this.batch.price_profiles_id) {
        return '#' + this.batch.price_profiles_id;
      }
      return '';
    },
    productIdInvalid: function productIdInvalid() {
      return this.productMatchState === 'unknown';
    },
    productMatchMessage: function productMatchMessage() {
      if (this.productMatchState === 'new') {
        return this.$t('productImport.productMatchNew');
      }
      if (this.productMatchState === 'found') {
        return this.$t('productImport.productMatchFound', { name: this.productMatchName });
      }
      if (this.productMatchState === 'unknown') {
        return this.$t('productImport.productMatchUnknown');
      }
      return '';
    },
    productMatchClass: function productMatchClass() {
      return {
        'is-muted': this.productMatchState === 'new' || this.productMatchState === 'idle',
        'is-success': this.productMatchState === 'found',
        'is-error': this.productMatchState === 'unknown'
      };
    },
    channelPriceGroups: function channelPriceGroups() {
      return [{
        key: 'glovo',
        label: 'GLOVO',
        fields: [{ key: 'price_glovo_eatin', label: 'PREȚ GLOVO EatIn' }]
      }, {
        key: 'bolt',
        label: 'BOLT',
        fields: [{ key: 'price_bolt_eatin', label: 'PREȚ BOLT EatIn' }]
      }, {
        key: 'wolt',
        label: 'Wolt',
        fields: [{ key: 'price_wolt_eatin', label: 'PREȚ Wolt EatIn' }]
      }, {
        key: 'website',
        label: 'Website',
        fields: [{ key: 'price_website_eatin', label: 'PREȚ Website EatIn' }, { key: 'price_website_togo', label: 'PREȚ Website ToGo' }, { key: 'price_website_delivery', label: 'PREȚ Website Delivery' }]
      }, {
        key: 'qr',
        label: 'QR',
        fields: [{ key: 'price_qr_eatin', label: 'PREȚ QR EatIn' }]
      }, {
        key: 'kiosk',
        label: 'Kiosk',
        fields: [{ key: 'price_kiosk_eatin', label: 'PREȚ Kiosk EatIn' }, { key: 'price_kiosk_togo', label: 'PREȚ Kiosk ToGo' }]
      }, {
        key: 'pos',
        label: 'POS',
        fields: [{ key: 'price_pos_eatin', label: 'PREȚ POS EatIn' }, { key: 'price_pos_togo', label: 'PREȚ POS ToGo' }, { key: 'price_pos_delivery', label: 'PREȚ POS Delivery' }]
      }, {
        key: 'app',
        label: 'App',
        fields: [{ key: 'price_app_eatin', label: 'PREȚ App EatIn' }, { key: 'price_app_togo', label: 'PREȚ App ToGo' }, { key: 'price_app_delivery', label: 'PREȚ App Delivery' }]
      }];
    }
  },
  watch: {
    editVisible: function editVisible(val) {
      this.syncDialogMaskClass();
      if (val) {
        this.loadCategoryOptions();
      }
    },
    confirmVisible: function confirmVisible() {
      this.syncDialogMaskClass();
    },
    secCategList: function secCategList(list) {
      if (!this.editData) return;
      this.editData.secCateg = Array.isArray(list) ? list.filter(Boolean).join(', ') : '';
    }
  },
  created: function created() {
    var params = this.route && this.route.params || this.$route.params;
    this.locationId = params.locationId;
    this.importId = params.importId;
    this.loadLocationPriceProfiles();
    this.reload();
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('tt-import-dialog-open');
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },

  methods: {
    syncDialogMaskClass: function syncDialogMaskClass() {
      var open = this.editVisible || this.confirmVisible;
      document.body.classList.toggle('tt-import-dialog-open', open);
    },
    statusLabel: function statusLabel(status) {
      var map = {
        PENDING: this.$t('productImport.statusPending'),
        CONFIRMED: this.$t('productImport.statusSuccessful'),
        PARTIALLY_CONFIRMED: this.$t('productImport.statusPartiallySuccessful'),
        CANCELED: this.$t('productImport.statusCanceled')
      };
      return map[status] || status;
    },
    rowStatusLabel: function rowStatusLabel(status) {
      var map = {
        PENDING: this.$t('productImport.statusPending'),
        ERROR: this.$t('productImport.statusError'),
        REMOVED: this.$t('productImport.statusRemoved'),
        CONFIRMED: this.$t('productImport.statusSuccessful')
      };
      return map[status] || status;
    },
    actionLabel: function actionLabel(action) {
      var map = {
        CREATE: this.$t('productImport.actionCreate'),
        UPDATE: this.$t('productImport.actionUpdate'),
        PRICE_LIST_UPDATE: this.$t('productImport.actionPriceListUpdate')
      };
      return map[action] || action;
    },
    canEditRow: function canEditRow(row) {
      return row.status === 'PENDING' || row.status === 'ERROR';
    },
    goBack: function goBack() {
      this.$router.push('/locations/' + this.locationId + '/product-imports');
    },
    loadLocationPriceProfiles: function loadLocationPriceProfiles() {
      var _this = this;

      this.apiRequest('/price-profiles', 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        perPage: 200,
        page: 1
      }, function (response) {
        if (!response || !response.status) {
          _this.locationPriceProfiles = [];
          return;
        }
        var items = response.data || [];
        var locationTrueId = _this.locationId;
        _this.locationPriceProfiles = items.filter(function (profile) {
          var locs = profile.location_details || profile.locationDetails || [];
          return locs.some(function (loc) {
            var locId = loc.true_id != null ? loc.true_id : loc.id;
            return String(locId) === String(locationTrueId);
          });
        });
      });
    },
    loadCategoryOptions: function loadCategoryOptions() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/topcategory', 'GET', data, function (response) {
        if (response && response.status) {
          var rows = Array.isArray(response.data) ? response.data : [];
          _this2.topCategoryNames = rows.map(function (row) {
            return row.name;
          }).filter(function (name) {
            return !!name;
          });
        }
      });
      this.apiRequest('/sorted-category', 'GET', data, function (response) {
        if (response && response.status) {
          var rows = Array.isArray(response.data) ? response.data : [];
          _this2.categoryNames = rows.map(function (row) {
            return row.name;
          }).filter(function (name) {
            return !!name;
          });
        }
      });
    },
    reload: function reload() {
      var _this3 = this;

      this.loading = true;
      this.apiRequest('/product-imports/' + this.importId, 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, function (response) {
        if (response && response.status) {
          _this3.batch = response.data;
          _this3.confirmPriceProfileId = _this3.batch.price_profiles_id;
        }
        _this3.apiRequest('/product-imports/' + _this3.importId + '/rows', 'GET', {
          token: _this3.$session.get('token')
        }, function (rowsResponse) {
          _this3.loading = false;
          if (rowsResponse && rowsResponse.status) {
            _this3.rows = rowsResponse.data || [];
          }
        });
      });
    },
    openConfirmModal: function openConfirmModal() {
      this.confirmPriceProfileId = this.batch && this.batch.price_profiles_id || null;
      this.confirmVisible = true;
    },
    emptyEditData: function emptyEditData() {
      return {
        product_id: '',
        name: '',
        topCateg: '',
        categ: '',
        secCateg: '',
        price: '',
        desc: '',
        nutritional: '',
        allergenic: '',
        active: '',
        pos_id: '',
        image: '',
        weight: '',
        ingredients: '',
        vat: '',
        section: '',
        price_glovo_eatin: '',
        price_wolt_eatin: '',
        price_bolt_eatin: '',
        price_website_eatin: '',
        price_website_togo: '',
        price_website_delivery: '',
        price_qr_eatin: '',
        price_kiosk_eatin: '',
        price_kiosk_togo: '',
        price_pos_eatin: '',
        price_pos_togo: '',
        price_pos_delivery: '',
        price_app_eatin: '',
        price_app_togo: '',
        price_app_delivery: ''
      };
    },
    openEdit: function openEdit(row) {
      var _this4 = this;

      this.editRowId = row.id;
      this.editData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.emptyEditData(), row.data || {});
      var sec = (this.editData.secCateg || '').toString().trim();
      this.secCategList = sec ? sec.split(',').map(function (s) {
        return s.trim();
      }).filter(Boolean) : [];
      this.selectedSearchProductId = null;
      this.productSearchResults = [];
      this.productMatchState = 'idle';
      this.productMatchName = '';
      this.editVisible = true;
      this.$nextTick(function () {
        _this4.validateProductId();
      });
    },
    onProductIdCleared: function onProductIdCleared() {
      this.selectedSearchProductId = null;
      this.productMatchState = 'new';
      this.productMatchName = '';
    },
    searchProducts: function searchProducts(query) {
      var _this5 = this;

      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(function () {
        _this5.fetchProducts(query);
      }, 400);
    },
    fetchProducts: function fetchProducts(searchText) {
      var _this6 = this;

      this.searchProductsLoading = true;
      var selectedIds = [];
      if (this.editData && this.editData.product_id) {
        selectedIds.push(this.editData.product_id);
      }
      this.apiRequest('/get-products-for-options', 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: searchText || '',
        selected_ids: selectedIds
      }, function (response) {
        _this6.searchProductsLoading = false;
        if (response && response.status) {
          var products = response.data && response.data.products || [];
          var selected = response.data && response.data.selected_products || [];
          var byId = {};
          products.concat(selected).forEach(function (p) {
            if (p && p.id != null) {
              byId[p.id] = p;
            }
          });
          _this6.productSearchResults = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(byId).map(function (id) {
            return byId[id];
          });
        }
      });
    },
    onSearchProductSelected: function onSearchProductSelected(productId) {
      if (!productId || !this.editData) {
        return;
      }
      var found = this.productSearchResults.find(function (p) {
        return String(p.id) === String(productId);
      });
      this.editData.product_id = String(productId);
      if (found) {
        if (!this.editData.name) {
          this.editData.name = found.name;
        }
        this.productMatchState = 'found';
        this.productMatchName = found.name;
      } else {
        this.validateProductId();
      }
    },
    validateProductId: function validateProductId() {
      var _this7 = this;

      if (!this.editData) {
        return;
      }
      var raw = (this.editData.product_id == null ? '' : String(this.editData.product_id)).trim();
      this.editData.product_id = raw;
      if (!raw) {
        this.productMatchState = 'new';
        this.productMatchName = '';
        this.selectedSearchProductId = null;
        return;
      }
      if (!/^\d+$/.test(raw)) {
        this.productMatchState = 'unknown';
        this.productMatchName = '';
        return;
      }
      this.validatingProductId = true;
      this.apiRequest('/get-products-for-options', 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: raw,
        selected_ids: [raw]
      }, function (response) {
        _this7.validatingProductId = false;
        if (!response || !response.status) {
          _this7.productMatchState = 'unknown';
          _this7.productMatchName = '';
          return;
        }
        var products = response.data && response.data.products || [];
        var selected = response.data && response.data.selected_products || [];
        var all = products.concat(selected);
        var match = all.find(function (p) {
          return String(p.id) === String(raw);
        });
        if (match) {
          _this7.productMatchState = 'found';
          _this7.productMatchName = match.name;
          _this7.selectedSearchProductId = match.id;
          if (!_this7.productSearchResults.some(function (p) {
            return String(p.id) === String(match.id);
          })) {
            _this7.productSearchResults = [match].concat(_this7.productSearchResults);
          }
        } else {
          _this7.productMatchState = 'unknown';
          _this7.productMatchName = '';
        }
      });
    },
    saveEdit: function saveEdit() {
      var _this8 = this;

      if (this.productIdInvalid) {
        return;
      }
      if (this.editData) {
        this.editData.secCateg = Array.isArray(this.secCategList) ? this.secCategList.filter(Boolean).join(', ') : this.editData.secCateg || '';
      }
      this.saving = true;
      this.apiRequest('/product-imports/' + this.importId + '/rows/' + this.editRowId, 'PUT', {
        token: this.$session.get('token'),
        data: this.editData
      }, function (response) {
        _this8.saving = false;
        if (response && response.status) {
          _this8.editVisible = false;
          _this8.reload();
        } else {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
            type: 'error',
            text: response && response.data || _this8.$t('general.error'),
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false
          });
        }
      });
    },
    removeRow: function removeRow(row) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        title: this.$t('productImport.removeConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('productImport.remove'),
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        if (result.value || result === true) {
          _this9.apiRequest('/product-imports/' + _this9.importId + '/rows/' + row.id + '/remove', 'POST', {
            token: _this9.$session.get('token')
          }, function (response) {
            if (response && response.status) {
              _this9.reload();
            }
          });
        }
      }).catch(function () {});
    },
    confirmBatch: function confirmBatch() {
      var _this10 = this;

      if (!this.confirmPriceProfileId) {
        __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
          type: 'warning',
          text: this.$t('productImport.priceProfileRequired'),
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false
        });
        return;
      }
      this.confirming = true;
      var pendingRowIds = {};(this.rows || []).forEach(function (row) {
        if (row && (row.status === 'PENDING' || row.status === 'ERROR')) {
          pendingRowIds[row.id] = true;
        }
      });
      var doConfirm = function doConfirm() {
        _this10.apiRequest('/product-imports/' + _this10.importId + '/confirm', 'POST', {
          token: _this10.$session.get('token')
        }, function (response) {
          _this10.confirming = false;
          if (response && response.status) {
            _this10.confirmVisible = false;
            var batch = response.data || {};
            _this10.trackAdminEvent('ADMIN_PRODUCT_IMPORT_CONFIRMED', 'product_import', _this10.importId, {
              product_import_id: _this10.importId,
              location_id: _this10.locationId,
              price_profiles_id: _this10.confirmPriceProfileId || batch.price_profiles_id || null,
              status: batch.status || null,
              total_rows: batch.total_rows != null ? batch.total_rows : null,
              confirmed_rows: batch.confirmed_rows != null ? batch.confirmed_rows : null,
              pending_rows: batch.pending_rows != null ? batch.pending_rows : null,
              error_rows: batch.error_rows != null ? batch.error_rows : null,
              removed_rows: batch.removed_rows != null ? batch.removed_rows : null,
              response: response
            });
            var confirmedRows = Array.isArray(batch.rows) ? batch.rows.filter(function (row) {
              return row && row.status === 'CONFIRMED' && row.product_id && pendingRowIds[row.id];
            }) : [];
            confirmedRows.forEach(function (row) {
              var productId = row.product_id;
              var action = row.action;
              var eventName = action === 'CREATE' ? 'ADMIN_PRODUCT_CREATED' : 'ADMIN_PRODUCT_UPDATE';
              _this10.trackAdminEvent(eventName, 'product', productId, {
                product_id: productId,
                product_import_id: _this10.importId,
                location_id: _this10.locationId,
                import_action: action || null,
                import_row_id: row.id || null,
                name: row.data && row.data.name || null,
                price_profiles_id: _this10.confirmPriceProfileId || batch.price_profiles_id || null
              });
            });
            __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
              type: 'success',
              text: _this10.$t('productImport.confirmSuccess'),
              toast: true,
              position: 'top-end',
              timer: 3000,
              showConfirmButton: false
            });
            _this10.reload();
          } else {
            __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
              type: 'error',
              text: response && response.data || _this10.$t('general.error'),
              toast: true,
              position: 'top-end',
              timer: 4000,
              showConfirmButton: false
            });
          }
        });
      };

      if (this.batch && this.confirmPriceProfileId === this.batch.price_profiles_id) {
        doConfirm();
        return;
      }

      this.apiRequest('/product-imports/' + this.importId, 'PUT', {
        token: this.$session.get('token'),
        price_profiles_id: this.confirmPriceProfileId
      }, function (response) {
        if (response && response.status) {
          _this10.batch = response.data;
          doConfirm();
        } else {
          _this10.confirming = false;
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
            type: 'error',
            text: response && response.data || _this10.$t('general.error'),
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false
          });
        }
      });
    },
    cancelBatch: function cancelBatch() {
      var _this11 = this;

      this.apiRequest('/product-imports/' + this.importId + '/cancel', 'POST', {
        token: this.$session.get('token')
      }, function (response) {
        if (response && response.status) {
          _this11.reload();
        }
      });
    }
  }
});

/***/ }),

/***/ "cxx/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__);














var _components;









__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PSwitch: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Switch_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a), _components),
  props: {
    userId: null,
    callback: {
      required: false
    },
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    userId: function userId(value) {
      this.id = value;
    },
    is_manager: function is_manager() {
      this.onChangeManager();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vee_validate__["b" /* mapFields */])(['name', 'last_name', 'email', 'job', 'role']), {
    filteredData: function filteredData() {
      var _this = this;

      if (!this.model || !Array.isArray(this.model.locations)) {
        return [];
      }
      var possibleRanges = this.locations.filter(function (location) {
        return _this.model.locations.some(function (modelLoc) {
          return modelLoc.id === location.id;
        });
      }).flatMap(function (location) {
        return (location.ranges || []).map(function (range) {
          return {
            delivery_ranges_id: range.id,
            name: range.name,
            user_id: _this.userId
          };
        });
      });

      if (!Array.isArray(this.model.delivery_ranges)) {
        this.model.delivery_ranges = [];
      }
      this.model.delivery_ranges = this.model.delivery_ranges.filter(function (range) {
        return possibleRanges.some(function (possible) {
          return range.delivery_ranges_id === possible.delivery_ranges_id;
        });
      });
      return possibleRanges;
    },
    dispatcherMode: function dispatcherMode() {
      return this.model.role === 'DISPATCHER';
    }
  }),
  created: function created() {
    this.userRole = this.$session.get('userDataRole');
    this.getData();
  },
  data: function data() {
    return {
      userRole: null,
      roles: [],
      locations: [],
      zones: [],
      id: this.value || this.userId,
      isNew: true,
      filelist: [],
      model: {
        'lastname': '',
        'firstname': '',
        'password': '',
        'confirm_password': '',
        'role': '',
        'locations': '',
        'login_code': null,
        'active': true
      },
      fiscalPrinter: [],
      fromDispatchSettings: false,
      fromDispatcherSettings: false,
      fromKdsSettings: false,
      driver_schedule_active: 0,
      driverCode: '',
      is_manager: false,
      is_manager_first: true,
      dispatcherErrors: {
        firstname: false,
        lastname: false,
        email: false,
        login_code: false
      },
      modelValidate: {
        available_days: { required: true },
        firstname: { required: true, min: 3 },
        lastname: { required: true, min: 3 },
        email: { required: true },
        role: { required: true },
        password: { required: true },
        password_confirmation: {
          required: true
        },
        username: { required: true },
        language: { required: true },
        locations: { required: true }
      },
      allowedPermissions: ['can_access_supplier_orders', 'can_create_supplier_order', 'can_send_supplier_order', 'can_receive_supplier_order', 'can_validate_supplier_order', 'can_generate_nir', 'can_process_supplier_order', 'can_generate_aviz', 'can_generate_invoice', 'can_access_dashboard', 'can_access_gestiune', 'can_access_reports', 'can_access_settings'],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '24:00'
      },
      available_days: [this.$t('days.monday'), this.$t('days.tuesday'), this.$t('days.wednesday'), this.$t('days.thursday'), this.$t('days.friday'), this.$t('days.saturday'), this.$t('days.sunday')],
      languages: this.$session.get('defaultData')['available_languages'],
      loading: true,
      loadingReset: true,
      loggedUserId: null
    };
  },

  methods: {
    checkQueryParams: function checkQueryParams() {
      var query = this.route && this.route.query ? this.route.query : {};
      this.fromDispatchSettings = query.from === 'dispatchSettings';
      this.fromDispatcherSettings = query.from === 'dispatcherSettings';
      this.fromKdsSettings = query.from === 'kdsSettings';
    },
    ensurePriceListPermission: function ensurePriceListPermission(user) {
      if (!this.model.permissions_map) {
        this.$set(this.model, 'permissions_map', {});
      }
      if (typeof this.model.permissions_map.general_can_access_price_lists === 'undefined') {
        var fromField = !!(user && (user.is_allowed_to_see_price_lists === true || user.is_allowed_to_see_price_lists === 1 || user.is_allowed_to_see_price_lists === '1'));
        this.$set(this.model.permissions_map, 'general_can_access_price_lists', fromField);
      }
      this.syncPriceListWithCatalog();
    },
    syncPriceListWithCatalog: function syncPriceListWithCatalog() {
      if (!this.model.permissions_map) {
        return;
      }
      if (!this.model.permissions_map.general_can_access_catalog) {
        this.$set(this.model.permissions_map, 'general_can_access_price_lists', false);
      }
    },
    onGeneralPermissionChange: function onGeneralPermissionChange(key, value) {
      if (key === 'general_can_access_catalog' && !value) {
        this.syncPriceListWithCatalog();
      }
    },
    addMoreIntervals: function addMoreIntervals(index) {
      var newObj = {
        'day': index,
        'from': '',
        'to': ''
      };
      this.model.driver_schedule[index].push(newObj);
    },
    deleteIntervals: function deleteIntervals(dayIdx, intervalKey) {
      this.model.driver_schedule[dayIdx].splice(intervalKey, 1);
    },
    getData: function getData() {
      var _this2 = this;

      var idFromRoute = this.route && this.route.params ? this.route.params.id : null;
      this.id = this.userId || idFromRoute || null;
      this.isNew = !this.id;

      this.checkQueryParams();

      this.loading = true;
      this.loadingReset = true;

      var dataToBeSent = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/get-locations-and-zones', 'GET', dataToBeSent, function (response) {
        if (response.status === true) {
          _this2.locations = response.data.locations;
        }
      });

      this.$validator.localize(this.$i18n.locale || 'en', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, this.$i18n.locale || 'en', {
        attributes: {
          firstname: this.$t('settingUsers.fn'),
          lastname: this.$t('settingUsers.ln'),
          email: this.$t('settingUsers.email'),
          login_code: this.$t('settingTable.login_code')
        },
        custom: {
          email: {
            required: this.$t('validations.requiredField'),
            email: this.$t('validations.requiredField')
          },
          login_code: {
            required: this.$t('validations.requiredField'),
            regex: this.$t('validations.requiredField')
          }
        }
      }));

      var userData = JSON.parse(this.$session.get('userData') || '{}');
      this.loggedUserId = userData.id || null;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/listdefaults', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.roles = response.data[0].user_roles || [];

          if (_this2.fromDispatchSettings) _this2.model.role = 'DRIVER';
          if (_this2.fromDispatcherSettings) _this2.model.role = 'DISPATCHER';
          if (_this2.fromKdsSettings) _this2.model.role = 'KDS_OPERATOR';
        }
      });

      var dataFiscal = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/fiscal-printer', 'GET', dataFiscal, function (response) {
        if (response.status === true) {
          _this2.fiscalPrinter = response.data.fiscalPrinter || null;
        }
      });

      if (!this.isNew) {
        var profileId = this.id;
        this.apiRequest('/profile/' + profileId, 'GET', data, function (response) {
          if (response.status === true && response.data && response.data[0]) {
            var user = response.data[0];
            user.imagelist = user.avatar ? [{ url: user.avatar }] : [];
            _this2.model = user;
            _this2.model.locations = user.locations_formatted || [];
            _this2.ensurePriceListPermission(user);
            if (_this2.model.role === 'DISPATCHER') {
              _this2.initDispatcherManagerFlags();
            }

            _this2.loading = false;
            _this2.loadingReset = false;
          }
        });
      } else {
        this.loading = false;
        this.loadingReset = false;
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    hasFieldError: function hasFieldError(field) {
      if (this.dispatcherMode) {
        return !!this.dispatcherErrors[field];
      }
      return this.errors.has(field);
    },
    onDispatcherFieldChange: function onDispatcherFieldChange(field) {
      if (!this.dispatcherMode) return;
      this.validateDispatcherField(field);
    },
    validateDispatcherField: function validateDispatcherField(field) {
      if (field === 'firstname') {
        this.dispatcherErrors.firstname = !(this.model.firstname || '').trim();
      } else if (field === 'lastname') {
        this.dispatcherErrors.lastname = !(this.model.lastname || '').trim();
      } else if (field === 'login_code') {
        var code = this.model.login_code == null ? '' : String(this.model.login_code).trim();
        this.dispatcherErrors.login_code = !/^[0-9]{4}$/.test(code);
      }
      return !this.dispatcherErrors[field];
    },
    checkDispatcherFields: function checkDispatcherFields() {
      if (!this.dispatcherMode) return true;
      this.validateDispatcherField('firstname');
      this.validateDispatcherField('lastname');
      this.validateDispatcherField('login_code');
      return !this.dispatcherErrors.firstname && !this.dispatcherErrors.lastname && !this.dispatcherErrors.login_code;
    },
    validate: function validate() {
      var _this3 = this;

      this.errors['items'] = this.removeErrorByName('password_confirmation', this.errors['items']);
      if (this.dispatcherMode) {
        if (this.checkDispatcherFields()) {
          this.saveUser();
        }
        return;
      }
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.saveUser();
        }
      });
    },
    validateReset: function validateReset() {
      if (this.model.password === undefined || this.model.password === '') {
        this.errors.add('password_2', this.$t('validations.passReq'));
      } else if (this.model.password.length < 6) {
        this.errors.add('password_2', this.$t('validations.passMin'));
      } else if (this.model.password_confirmation === undefined || this.model.password_confirmation === '') {
        this.errors.add('password_confirm_2', this.$t('validations.passReq'));
      } else if (this.model.password !== this.model.password_confirmation) {
        this.errors.add('password_confirm_2', this.$t('validations.passConf'));
      } else {
        this.resetPass();
      }
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
      }
      return isOkSize;
    },
    saveUser: function saveUser() {
      this.syncPriceListWithCatalog();
      this.$nextTick(function () {
        this.loading = true;
      });
      var data = {};
      var locationsIDs = Array.isArray(this.model.locations) && this.model.locations.length ? this.model.locations.map(function (el) {
        return el.id;
      }) : [];
      if (!this.isNew) {
        data = {
          id: this.model.id,
          firstname: this.model.firstname,
          lastname: this.model.lastname,
          email: this.model.email,
          phone: this.model.phone,
          driver_schedule_active: this.model.driver_schedule_active || 0,
          language: this.model.language,
          driver_schedule: this.model.driver_schedule,
          fiscal_printer_id: this.model.fiscal_printer_id,
          server_ip_port: this.model.server_ip_port,
          permissions_map: this.model.permissions_map,
          locations: locationsIDs
        };
        if (this.model.role !== 'OWNER') {
          data['role'] = this.model.role;
        }
        if (this.model.role === 'DISPATCHER') {
          data.login_code = this.model.login_code;
          data.active = this.model.active;
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(data, this.getDispatcherManagerPayload());
        }
      } else if (this.model.role === 'DISPATCHER') {
        var randomPass = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2) + 'Aa1!';
        data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
          role: 'DISPATCHER',
          firstname: this.model.firstname,
          lastname: this.model.lastname,
          login_code: this.model.login_code,
          active: this.model.active !== false,
          locations: locationsIDs,
          password: randomPass,
          password_confirmation: randomPass,
          language: this.model.language || (this.$session.get('selectedCompanyData') || {}).language || 'en'
        }, this.getDispatcherManagerPayload());
      } else {
        data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.model);
      }
      var companyID = this.$session.get('selectedCompany');
      data.token = this.$session.get('token');
      data.company_id = companyID;
      var self = this;
      if (this.isNew) {
        delete data.avatar;
        var postData = data;
        postData.locations = locationsIDs;

        this.apiRequest('/profile', 'POST', postData, function (response) {
          if (response.status === true) {
            var id = response.data[0].id;
            if (data.imagelist && data.imagelist.length && data.imagelist[0] && data.imagelist[0].status === 'ready') {
              self.getBase64(data.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.avatar = base64enc;
                data2.locations = postData.locations;

                self.apiRequest('/profile/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.errors.clear();
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
                      title: '',
                      text: self.$t('settingUsers.userAdded'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {}).catch(function () {});
                    if (typeof self.callback === 'function') {
                      self.callback();
                    } else {
                      self.$bus.$emit('refresh');
                      self.$bus.$emit('close-modal');
                    }
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
                      title: '',
                      text: self.$t('settingUsers.userPicError'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {}).catch(function () {});
                  }
                });
              });
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              self.errors.clear();
              __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
                title: '',
                text: self.$t('settingUsers.userAdded'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).then(function () {}).catch(function () {});
              if (typeof self.callback === 'function') {
                self.callback();
              } else {
                self.$bus.$emit('refresh');
                self.$bus.$emit('close-modal');
              }
            }
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
            var selectedLocations = [];
            self.locations.forEach(function (el) {
              if (self.model.locations.includes(el.id)) {
                selectedLocations.push({
                  id: el.id,
                  name: el.name
                });
              }
            });
            self.model.locations = selectedLocations;
          }
        });
      } else {
        var id = this.id || this.route.params.id;

        if (data.role === 'OWNER') {
          delete data.role;
        }

        delete data.avatar;

        if (this.model.imagelist.length === 0) {
          data.avatar = '';
        }

        data.locations = self.model.locations.map(function (el) {
          return el.id;
        });

        var user = JSON.parse(this.$session.get('userData'));
        if (id === user.id) {
          var url = '/profile/me';
        } else {
          url = '/profile/' + id;
        }

        this.apiRequest(url, 'PUT', data, function (response) {
          if (response.status === true) {
            if (id === user.id) {
              if (self.$i18n.locale !== data.language) {
                self.$i18n.locale = data.language;
              }
              self.$session.set('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data[0]));
            }
            if (self.model.imagelist.length && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.avatar = base64enc;
                data2.locations = data.locations;

                self.apiRequest('/profile/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    var user = JSON.parse(self.$session.get('userData'));
                    if (id === user.id) {
                      self.$session.set('companyAvatar', data2.avatar);
                    }
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
                      title: '',
                      text: self.$t('settingUsers.userUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {}).catch(function () {});
                    if (typeof self.callback === 'function') {
                      self.callback();
                    }
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
                      title: '',
                      text: self.$t('settingUsers.userPicError'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function () {}).catch(function () {});
                  }
                });
              });
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
                title: '',
                text: self.$t('settingUsers.userUpdated'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).then(function () {}).catch(function () {});
              if (typeof self.callback === 'function') {
                self.callback();
              }
            }
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
          }
        });
      }
    },
    resetPass: function resetPass() {
      this.$nextTick(function () {
        this.loadingReset = true;
      });
      var id = this.id || this.route.params.id;
      var userLocations = this.model.locations.length ? this.model.locations.map(function (el) {
        return el.id;
      }) : [];
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        password: this.model.password,
        password_confirmation: this.model.password_confirmation,
        locations: userLocations
      };

      var self = this;

      this.apiRequest('/profile/' + id, 'PUT', data, function (response) {
        if (response.status === true) {
          self.$nextTick(function () {
            self.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': 'New password saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        } else {
          self.$nextTick(function () {
            self.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    onDispatchRoleChange: function onDispatchRoleChange(role) {
      this.dispatcherErrors = {
        firstname: false,
        lastname: false,
        email: false,
        login_code: false
      };
      if (role === 'DRIVER') {
        this.getDriverCode(role);
      } else if (role === 'DISPATCHER') {
        this.model.email = '';
        this.model.active = true;
      }
    },
    getDriverCode: function getDriverCode(role) {
      if (role === 'DRIVER') {
        this.model.driver_schedule_active = 1;
        if (this.driverCode === '' || this.driverCode === null) {
          var id = this.$session.get('selectedCompany');
          var data = {
            company_id: id,
            token: this.$session.get('token')
          };
          var self = this;

          this.apiRequest('/settings/newdriver/' + id, 'GET', data, function (response) {
            if (response.status === true) {
              self.driverCode = response.data['email'];
              self.model.email = self.driverCode;
            } else {
              __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ 'text': response.error['email'] ? response.error['email'] : self.$t('validations.wentWrong'), 'type': 'error' }).catch({});
            }
          });
        } else {
          this.model.email = this.driverCode;
        }
      } else {
        this.model.email = '';
      }
    },
    clearDispatchExcludedManagerFlags: function clearDispatchExcludedManagerFlags() {
      this.model.pos_allow_storno = false;
      this.model.allow_access_all_tables = false;
      this.model.pos_allow_transfer = false;
      this.model.pos_allow_waiter_transfer = false;
      this.model.pos_allow_table_transfer = false;
    },
    getDispatcherManagerPayload: function getDispatcherManagerPayload() {
      this.clearDispatchExcludedManagerFlags();
      return {
        pos_allow_access_reports: !!this.model.pos_allow_access_reports,
        pos_allow_reports: !!this.model.pos_allow_reports,
        pos_allow_approvals: !!this.model.pos_allow_approvals,
        pos_allow_discount: !!this.model.pos_allow_discount,
        pos_allow_refund: !!this.model.pos_allow_refund,
        pos_allow_storno: false,
        allow_access_all_tables: false,
        pos_allow_transfer: false,
        pos_allow_waiter_transfer: false,
        pos_allow_table_transfer: false
      };
    },
    initDispatcherManagerFlags: function initDispatcherManagerFlags() {
      this.clearDispatchExcludedManagerFlags();
      var hasManagerFlags = this.model.pos_allow_access_reports || this.model.pos_allow_reports || this.model.pos_allow_approvals || this.model.pos_allow_discount || this.model.pos_allow_refund;
      if (hasManagerFlags) {
        this.is_manager_first = false;
        this.is_manager = true;
      } else {
        this.is_manager = false;
        this.is_manager_first = true;
      }
    },
    onChangeManager: function onChangeManager() {
      if (!this.dispatcherMode) {
        return;
      }
      if (this.is_manager_first) {
        if (this.is_manager) {
          this.model.pos_allow_discount = true;
          this.model.pos_allow_refund = true;
          this.model.pos_allow_reports = true;
          this.model.pos_allow_access_reports = true;
          this.model.pos_allow_approvals = true;
          this.clearDispatchExcludedManagerFlags();
        } else {
          this.model.pos_allow_discount = false;
          this.model.pos_allow_refund = false;
          this.model.pos_allow_reports = false;
          this.model.pos_allow_access_reports = false;
          this.model.pos_allow_approvals = false;
          this.clearDispatchExcludedManagerFlags();
        }
      }
      this.is_manager_first = true;
    },
    cancelUser: function cancelUser() {
      if (typeof this.callback === 'function') {
        this.callback();
      } else if (this.fromDispatchSettings) {
        this.$bus.$emit('refresh');
        this.$bus.$emit('close-modal');
      } else if (this.fromKdsSettings) {
        this.$bus.$emit('refresh');
        this.$bus.$emit('close-modal');
      } else {
        this.$bus.$emit('refresh');
        this.$bus.$emit('close-modal');
      }
    }
  }
});

/***/ }),

/***/ "d2AR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('order-screen-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d41/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);




















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);

var CHIPS = ['all', 'paid', 'active', 'pending', 'abandoned', 'stopped', 'finished'];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var offerId = this.route.query && this.route.query.menu_subscription_id ? parseInt(this.route.query.menu_subscription_id, 10) : null;
    return {
      chips: CHIPS,
      currency: '',
      offers: [],
      loading: false,
      items: [],
      counts: {},
      pagination: { total: 0, per_page: 20, current_page: 1, last_page: 1 },
      filters: {
        menu_subscription_id: offerId || null,
        status: 'all',
        search: '',
        page: 1
      },
      searchTimer: null,
      detail: null,
      detailLoading: false,
      box: null,
      busy: false,
      stopReason: '',
      refundAmount: '',
      refundReason: ''
    };
  },

  computed: {
    validRefund: function validRefund() {
      var amount = parseFloat(this.refundAmount);
      return !isNaN(amount) && amount > 0 && this.detail && amount <= parseFloat(this.detail.summary.refundable) + 0.001 && this.refundReason.trim() !== '';
    }
  },
  created: function created() {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso);
    this.getOffers();
    this.reload();
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.searchTimer);
  },

  methods: {
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    getOffers: function getOffers() {
      var _this = this;

      this.apiRequest('/menu-subscription', 'GET', this.requestData(), function (response) {
        if (response.status === true) {
          _this.offers = (response.data || []).map(function (offer) {
            return { id: offer.id, name: offer.name };
          });
        }
      });
    },
    reload: function reload() {
      this.filters.page = 1;
      this.getItems();
    },
    getItems: function getItems() {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestData(), { status: this.filters.status, page: this.filters.page });
      if (this.filters.menu_subscription_id) {
        data.menu_subscription_id = this.filters.menu_subscription_id;
      }
      if (this.filters.search.trim()) {
        data.search = this.filters.search.trim();
      }
      this.loading = true;
      this.apiRequest('/menu-subscription/subscribers', 'GET', data, function (response) {
        _this2.loading = false;
        if (response.status === true && response.data) {
          _this2.items = response.data.items || [];
          _this2.counts = response.data.counts || {};
          _this2.pagination = response.data.pagination || _this2.pagination;
        }
      });
    },
    setStatus: function setStatus(status) {
      this.filters.status = status;
      this.reload();
    },
    onSearchInput: function onSearchInput() {
      var _this3 = this;

      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        return _this3.reload();
      }, 400);
    },
    changePage: function changePage(page) {
      this.filters.page = page;
      this.getItems();
    },
    openDetail: function openDetail(row) {
      this.box = null;
      this.detail = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, row, { summary: { deliveries: {}, refundable: 0 }, delivery_list: [], payments: [], events: [] });
      this.loadDetail(row.id);
    },
    loadDetail: function loadDetail(id) {
      var _this4 = this;

      this.detailLoading = true;
      this.apiRequest('/menu-subscription/subscribers/' + id, 'GET', this.requestData(), function (response) {
        _this4.detailLoading = false;
        if (response.status === true && response.data) {
          _this4.detail = response.data;
        } else {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this4.firstError(response), 'error').catch(function () {});
        }
      });
    },
    closeDetail: function closeDetail() {
      this.detail = null;
      this.box = null;
      this.getItems();
    },
    toggleBox: function toggleBox(box) {
      this.box = this.box === box ? null : box;
      if (box === 'stop') {
        this.stopReason = '';
      }
      if (box === 'refund') {
        this.refundAmount = '';
        this.refundReason = '';
      }
    },
    stop: function stop() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        text: this.$t('menuSubscribers.stopQuestion', { name: this.detail.customer.name || '#' + this.detail.customer.id }),
        type: 'warning',
        showCancelButton: true
      }).then(function () {
        _this5.busy = true;
        _this5.apiRequest('/menu-subscription/subscribers/' + _this5.detail.id + '/stop', 'POST', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this5.requestData(), { reason: _this5.stopReason }), function (response) {
          _this5.busy = false;
          if (response.status === true && response.data) {
            _this5.detail = response.data;
            _this5.box = null;
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({ title: '', text: _this5.$t('menuSubscribers.stopped'), type: 'success', showConfirmButton: false, timer: 1500 }).catch(function () {});
          } else {
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this5.firstError(response), 'error').catch(function () {});
          }
        });
      }).catch(function () {});
    },
    refund: function refund() {
      var _this6 = this;

      var amount = parseFloat(this.refundAmount).toFixed(2);
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        text: this.$t('menuSubscribers.refundQuestion', { amount: amount + ' ' + this.currency }),
        type: 'warning',
        showCancelButton: true
      }).then(function () {
        _this6.busy = true;
        _this6.apiRequest('/menu-subscription/subscribers/' + _this6.detail.id + '/refund', 'POST', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this6.requestData(), { amount: amount, reason: _this6.refundReason }), function (response) {
          _this6.busy = false;

          if (response.data && response.data.id) {
            _this6.detail = response.data;
          }
          if (response.status === true) {
            _this6.box = null;
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({ title: '', text: _this6.$t('menuSubscribers.refundDone'), type: 'success', showConfirmButton: false, timer: 1500 }).catch(function () {});
          } else {
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this6.firstError(response), 'error').catch(function () {});
          }
        });
      }).catch(function () {});
    },
    money: function money(value) {
      var number = parseFloat(value);
      return isNaN(number) ? '0.00' : number.toFixed(2);
    },
    formatDate: function formatDate(value) {
      if (!value) {
        return '-';
      }
      var parts = String(value).substr(0, 10).split('-');
      return parts.length === 3 ? parts[2] + '.' + parts[1] + '.' + parts[0] : value;
    },
    formatDateTime: function formatDateTime(value) {
      if (!value) {
        return '-';
      }
      return this.formatDate(value) + ' ' + String(value).substr(11, 5);
    },
    addressText: function addressText(address) {
      if (!address) {
        return '-';
      }
      if (address.formatted_address) {
        return address.formatted_address;
      }
      return [address.street, address.number, address.city].filter(Boolean).join(' ');
    },
    firstError: function firstError(response) {
      var errors = response && response.errors || {};
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors)[0];
      if (!key) {
        return this.$t('validations.wentWrong');
      }
      return Array.isArray(errors[key]) ? errors[key][0] : errors[key];
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "d6ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_WOLT_DRIVE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WOLT_DRIVE_AUTO_SEND_STATUS_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WOLT_DRIVE_AUTO_SEND_TIME_VALUES; });
/* unused harmony export DEFAULT_WOLT_DRIVE_ORDER_TOTAL_HANDSHAKE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__ = __webpack_require__("3z7E");






var DEFAULT_WOLT_DRIVE_API_URL = 'https://daas-public-api.wolt.com';

var WOLT_DRIVE_AUTO_SEND_STATUS_VALUES = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(['MANUAL', 'PROCESSING', 'PREPARED']);

var WOLT_DRIVE_AUTO_SEND_TIME_VALUES = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(['1', '15', '30', '45', '60']);

var DEFAULT_WOLT_DRIVE_ORDER_TOTAL_HANDSHAKE = '150';

/* harmony default export */ __webpack_exports__["d"] = ({
  name: 'WoltDriveIntegrationForm',
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    requiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    validationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showFieldValidation: {
      type: Boolean,
      default: false
    },
    occupiedLocationIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isCreateMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    autoSendStatusOptions: function autoSendStatusOptions() {
      var _this = this;

      return WOLT_DRIVE_AUTO_SEND_STATUS_VALUES.map(function (value) {
        return {
          value: value,
          label: _this.autoSendStatusLabel(value)
        };
      });
    },
    autoSendTimeOptions: function autoSendTimeOptions() {
      return WOLT_DRIVE_AUTO_SEND_TIME_VALUES.slice();
    },
    isAutoSendManual: function isAutoSendManual() {
      return String(this.formData.auto_send_at_status || '').toUpperCase() === 'MANUAL';
    }
  },
  created: function created() {
    this.ensureBooleanDefaults();
    this.ensureApiUrlDefault();
    this.ensureAutoSendStatusDefault();
    this.ensureAutoSendTimeDefault();
    this.ensureOrderTotalHandshakeDefault();
  },

  methods: {
    fieldLabel: function fieldLabel(field) {
      if (typeof this.fieldLabelFn === 'function') return this.fieldLabelFn(field);
      return field;
    },
    isRequired: function isRequired(field) {
      return (this.requiredFields || []).includes(field);
    },
    hasFieldError: function hasFieldError(field) {
      return Boolean(this.validationErrors && this.validationErrors[field]);
    },
    showFieldError: function showFieldError(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["a" /* hasIntegrationFieldError */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData
      });
    },
    fieldErrorMessage: function fieldErrorMessage(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Integrations_integrationFormFieldHelpers_js__["b" /* getIntegrationFieldErrorMessage */])({
        field: field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData,
        requiredMessage: this.$t('validations.requiredField')
      });
    },
    isLocationOccupied: function isLocationOccupied(locationId) {
      if (locationId == null || locationId === '') return false;
      return (this.occupiedLocationIds || []).map(String).includes(String(locationId));
    },
    locationOptionLabel: function locationOptionLabel(loc) {
      var name = loc && loc.name ? loc.name : '';
      if (this.isLocationOccupied(loc._integrationLocationId)) {
        return name + ' (' + this.$t('gestiune.integrationsLocationOccupied') + ')';
      }
      return name;
    },
    autoSendStatusLabel: function autoSendStatusLabel(value) {
      var key = 'gestiune.woltDriveAutoSendStatus_' + String(value || '').toLowerCase();
      var translated = this.$t(key);
      return translated !== key ? translated : String(value || '');
    },
    ensureBooleanDefaults: function ensureBooleanDefaults() {
      if (this.formData.active === undefined || this.formData.active === null || this.formData.active === '') {
        this.$set(this.formData, 'active', false);
      } else {
        this.$set(this.formData, 'active', Boolean(this.formData.active));
      }
    },
    ensureApiUrlDefault: function ensureApiUrlDefault() {
      var url = this.formData.api_url;
      if (url === undefined || url === null || String(url).trim() === '') {
        this.$set(this.formData, 'api_url', DEFAULT_WOLT_DRIVE_API_URL);
      }
    },
    ensureAutoSendStatusDefault: function ensureAutoSendStatusDefault() {
      var raw = this.formData.auto_send_at_status;
      var normalized = raw === undefined || raw === null || String(raw).trim() === '' ? '' : String(raw).trim().toUpperCase();
      if (!normalized || !WOLT_DRIVE_AUTO_SEND_STATUS_VALUES.includes(normalized)) {
        normalized = 'MANUAL';
      }
      this.$set(this.formData, 'auto_send_at_status', normalized);
    },
    ensureAutoSendTimeDefault: function ensureAutoSendTimeDefault() {
      var raw = this.formData.auto_send_time;
      var normalized = raw === null || raw === undefined || String(raw).trim() === '' ? '' : String(parseInt(String(raw).trim(), 10));
      if (!normalized || !WOLT_DRIVE_AUTO_SEND_TIME_VALUES.includes(normalized)) {
        normalized = '30';
      }
      this.$set(this.formData, 'auto_send_time', normalized);
    },
    ensureOrderTotalHandshakeDefault: function ensureOrderTotalHandshakeDefault() {
      var raw = this.formData.order_total_handshake;
      if (raw === undefined || raw === null || String(raw).trim() === '') {
        this.$set(this.formData, 'order_total_handshake', DEFAULT_WOLT_DRIVE_ORDER_TOTAL_HANDSHAKE);
      }
    }
  }
});

/***/ }),

/***/ "d7/C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  created: function created() {
    this.initData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.doHeightCalculation();
      _this.loading = true;

      window.addEventListener('resize', function () {
        _this.doHeightCalculation();
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      isNew: false,
      showLocations: false,
      locations: [],
      model: [],
      searchQuery: '',
      windowHeight: 0,
      pageTopHeight: 76,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [5, 25, 50]
      }
    };
  },

  computed: {
    filteredData: function filteredData() {
      var query = this.searchQuery.toLowerCase();
      return this.model.filter(function (item) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(item).some(function (value) {
          return String(value).toLowerCase().includes(query);
        });
      });
    }
  },
  methods: {
    handleRefresh: function handleRefresh() {
      this.initData();
    },
    initData: function initData() {
      this.loading = true;
      this.getLocations();

      var companyData = this.$session.get('selectedCompanyData');
      if (companyData && companyData.locations_details) {
        this.locations = companyData.locations_details;
      }
    },
    handleActive: function handleActive(index, row, event) {
      var _this2 = this;

      if (event) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
          text: this.$t('settingCompany.activateLocationCost'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.cancel2')
        }).then(function (result) {
          if (result) {
            _this2.updateLocationStatus(row);
          }
        }).catch(function () {
          _this2.model[index].active = !event;
        });
      } else {
        this.updateLocationStatus(row);
      }
    },
    handleIsOpen: function handleIsOpen(index, row, event) {
      var _this3 = this;

      this.updateLocationIsOpen(row, function () {
        _this3.model[index].is_open = !event;
      });
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
    },
    updateLocationStatus: function updateLocationStatus(location) {
      var _this4 = this;

      this.loading = true;

      var data = {
        token: this.$session.get('token'),
        company_id: location.company_id,
        location_id: location.true_id,
        location_token: location.token,
        active: location.active
      };

      this.apiRequest('/locations/' + location.true_id + '/active', 'PUT', data, function (response) {
        if (response.status) {
          _this4.trackAdminEvent('ADMIN_LOCATION_UPDATE', 'location', location.true_id, {
            location_id: location.true_id,
            name: location.name || null,
            active: !!location.active
          });
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
            text: 'Sucess!',
            type: 'success',
            showConfirmButton: false,
            timer: 1000
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
            text: 'Error!',
            type: 'error',
            showConfirmButton: false,
            timer: 1000
          });
        }
        _this4.$nextTick(function () {
          _this4.loading = false;
        });
      });
    },
    updateLocationIsOpen: function updateLocationIsOpen(location, onError) {
      var _this5 = this;

      this.loading = true;

      var data = {
        token: this.$session.get('token'),
        company_id: location.company_id,
        location_id: location.true_id,
        location_token: location.token,
        is_open: location.is_open
      };

      this.apiRequest('/locations/' + location.true_id + '/is-open', 'PUT', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
            text: 'Sucess!',
            type: 'success',
            showConfirmButton: false,
            timer: 1000
          });
        } else {
          if (typeof onError === 'function') onError();
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
            text: 'Error!',
            type: 'error',
            showConfirmButton: false,
            timer: 1000
          });
        }
        _this5.$nextTick(function () {
          _this5.loading = false;
        });
      });
    },
    goToRecord: function goToRecord(row, event, column) {
      if (typeof this.callback === 'function') {
        this.callback(row.true_id);
      } else {
        row.id = row.true_id;
        this.globalGoToRecord(row, event, column, '/locations/edit/');
      }
    },
    goToAdd: function goToAdd() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
        text: this.$t('settingCompany.createLocationCost'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.cancel2')
      }).then(function (result) {
        if (result) {
          _this6.$session.set('selecetdTab', 'Company Details');
          _this6.$router.push('/locations/add');
        }
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getLocations: function getLocations() {
      var _this7 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        columns: ['id', 'token', 'company_id', 'name', 'email', 'street', 'phone', 'active', 'is_open']
      };

      this.apiRequest('/locations', 'GET', data, function (response) {
        if (response.status) {
          _this7.model = (response.data || []).map(function (loc) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, loc, {
              is_open: loc.is_open === undefined || loc.is_open === null ? true : !!loc.is_open
            });
          });
        }
        _this7.$nextTick(function () {
          _this7.loading = false;
        });
      });
    },
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'fidelities_labels_primary_option': this.labelsPrimaryOption,
        'enable_label_notification': this.enableLabelNotification,
        'fidelities_labels_interval': this.labelsInterval,
        'show_userlabel': this.showLabel
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({ 'text': self.$t('marketingFidelities.labelingSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 1000 }).catch(function () {});
          self.$session.set('selectedCompanyData', self.buildCompanySessionData(response.data[0]));
        } else {
          self.handleErrors(response.errors);
        }
      });
    },
    handleDelete: function handleDelete(id, trueId) {
      var _this8 = this;

      var btnCounter = 3;
      var self = this;
      var companyID = this.$session.get('selectedCompany');

      var data = {
        token: this.$session.get('token'),
        company_id: companyID,
        location_id: id,
        true_id: trueId
      };

      this.apiRequest('/settings/can-delete-location', 'POST', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
            text: self.$t('settingCompany.areYouSureDelete'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes (' + btnCounter + ')'
          }).then(function (result) {
            if (result) {
              _this8.loading = true;
              self.apiRequest('admin/location/' + trueId, 'DELETE', data, function (response) {
                if (response.status) {
                  var loc = (self.model || []).find(function (l) {
                    return l.true_id === trueId || l.id === id;
                  }) || {};
                  self.trackAdminEvent('ADMIN_LOCATION_DELETED', 'location', trueId, {
                    location_id: trueId,
                    name: loc.name || null
                  });
                  _this8.getLocations();
                  _this8.loading = false;
                  __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
                    text: 'Sucess!',
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1000
                  });
                }
              });
            }
          });
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.disableConfirmButton();

          var btnInterval = setInterval(function () {
            btnCounter--;

            if (btnCounter >= 1) {
              __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.getConfirmButton().textContent = 'Yes (' + btnCounter + ')';
            } else {
              __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.getConfirmButton().textContent = 'Yes';
              clearInterval(btnInterval);
              __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.enableConfirmButton();
            }
          }, 1000);
        } else if (response.status === false && response.errors.location_ids !== undefined) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({ 'text': self.$t('settingCompany.deleteLocationValidation'), 'type': 'error' }).catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    validate: function validate() {
      var _this9 = this;

      this.errors['items'] = this.removeErrorByName('error', this.errors['items']);
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this9.handleCreate();
        } else {}
      });
    },
    checkValueOrNumber: function checkValueOrNumber(item) {
      if (item) {
        item.showError = false;
      } else {
        this.model.showError = false;
      }
    }
  }
});

/***/ }),

/***/ "d7TW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d9Hv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosOrderActionsReport_vue__ = __webpack_require__("+ND1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f3ecd62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosOrderActionsReport_vue__ = __webpack_require__("qU3s");
function injectStyle (ssrContext) {
  __webpack_require__("VJJN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosOrderActionsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f3ecd62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosOrderActionsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dBEi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dCoM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuSubscriptionForm_vue__ = __webpack_require__("Q7tW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuSubscriptionMenus_vue__ = __webpack_require__("WEM7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuSubscriptionCalendar_vue__ = __webpack_require__("OM/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menuSubscriptionHelpers__ = __webpack_require__("VNNG");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MenuSubscriptionForm: __WEBPACK_IMPORTED_MODULE_0__MenuSubscriptionForm_vue__["a" /* default */],
    MenuSubscriptionMenus: __WEBPACK_IMPORTED_MODULE_1__MenuSubscriptionMenus_vue__["a" /* default */],
    MenuSubscriptionCalendar: __WEBPACK_IMPORTED_MODULE_2__MenuSubscriptionCalendar_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var id = this.route.params && this.route.params.id ? parseInt(this.route.params.id, 10) : null;
    var tab = this.route.query && this.route.query.tab;
    return {
      subscriptionId: id,
      subscription: null,
      currentTab: id && ['menus', 'calendar', 'delivery'].indexOf(tab) !== -1 ? tab : 'general',

      pendingAssignDates: [],
      tabs: [{ key: 'general', label: 'menuSubscriptions.tabGeneral', icon: 'fa fa-info-circle', needsId: false }, { key: 'delivery', label: 'menuSubscriptions.tabDelivery', icon: 'fa fa-truck', needsId: false }, { key: 'menus', label: 'menuSubscriptions.tabMenus', icon: 'fa fa-list', needsId: true }, { key: 'calendar', label: 'menuSubscriptions.tabCalendar', icon: 'fa fa-calendar', needsId: true }]
    };
  },

  methods: {
    issuesText: function issuesText(issues) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__menuSubscriptionHelpers__["b" /* issuesText */])(this, issues);
    },
    onLoaded: function onLoaded(data) {
      this.subscription = data;
    },
    onSaved: function onSaved(data, created) {
      this.subscription = data;
      this.subscriptionId = data.id;
      this.$bus.$emit('refresh');
      if (created) {
        this.currentTab = 'menus';
      }
    },
    reloadSubscription: function reloadSubscription() {
      var _this = this;

      this.apiRequest('/menu-subscription/' + this.subscriptionId, 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, function (response) {
        if (response.status === true && response.data) {
          _this.subscription = response.data;
        }
      });
      this.$bus.$emit('refresh');
    },
    onNewMenuForDates: function onNewMenuForDates(dates) {
      this.pendingAssignDates = dates.slice();
      this.currentTab = 'menus';
    },
    onAssigned: function onAssigned() {
      this.pendingAssignDates = [];
      this.currentTab = 'calendar';
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "dF93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_json_excel__ = __webpack_require__("fXhN");















var _components;









__WEBPACK_IMPORTED_MODULE_14_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_19_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isReports: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isReports: function isReports() {
      if (this.isReports) {
        this.getOrders();
      }
    }
  },
  created: function created() {
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear();
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '-' + formattedDate + '.xls';
    this.getPaymentMethods();
    this.verifyUserLocations();
    this.verifyUserMethods();
    this.getPosUsers();
    this.getDrivers();
    this.getUsers();
    this.loadFiltersFromCookie();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.userSearchTimeout) {
      clearTimeout(this.userSearchTimeout);
      this.userSearchTimeout = null;
    }
  },
  data: function data() {
    var _jsonFields;

    return {
      valid_from: '05:00',
      valid_to: '05:00',
      products_valid_from: '00:00',
      products_valid_to: '23:59',
      drivers: [],
      posUsers: [],
      users: [],
      topCategories: [],
      loadingCategories: false,
      loadingUsers: false,
      userSearchTimeout: null,
      orderFormFlags: this.getOrderFormFlags(),
      paymentMethods: [],
      receiptOptions: [{ label: this.$t('reports.withoutReceipt'), value: 1 }, { label: this.$t('reports.withReceipt'), value: 2 }],
      selectedDriver: '',
      freeSearch: '',
      selectedPosUser: '',
      selected_user: '',
      selected_user_name: '',
      orderId: null,
      zet: null,
      selectedCategories: [],
      selected_order_from: '',
      selected_payment_methods: [],

      unpaidOrdersFilter: 'paid',
      selectedTable: null,
      availableTables: [],
      loadingTables: false,
      loading: true,
      exportLoading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        valid: [__WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: '',
        methods: []
      },
      date_column: 'created_at',
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_18_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      ordersTableData: {},
      totals: {
        total: 0,
        totalCash: 0,
        totalVirament: 0,
        totalOnline: 0,
        totalProtocol: 0,
        totalStaffFood: 0,
        totalRoom: 0,
        totalEvent: 0,
        totalFolio: 0,
        totalSplit: 0,
        totalCard: 0,
        totalPOS: 0,
        totalCARDPOS: 0,
        totalTips: 0,
        totalDiscount: 0,
        totalDiscountItems: 0,
        totalDiscountLoyaltyPoints: 0,
        totalTax: 0,
        totalSlotTax: 0,
        totalSlotPartTax: 0,
        totalShipping: 0,
        avarageOrderValue: 0,
        totalPayFromWallet: 0,
        totalBoltCard: 0,
        totalBoltCash: 0,
        totalGlovoCard: 0,
        totalGlovoCash: 0,
        totalWoltCard: 0,
        totalWoltCash: 0,
        totalWoltOtherMethods: 0,
        totalSplitCash: 0,
        totalSplitCard: 0,
        totalSplitVoucher: 0,
        totalUnpaid: 0,
        unfiscalTotal: 0,
        unfiscalTotalCard: 0,
        unfiscalTotalCash: 0,
        unfiscalTotalCredit: 0,
        unfiscalTotalOnline: 0,
        giftCardsSoldCount: 0,
        giftCardsSoldAmount: 0
      },
      cardTotals: {
        total_amount: 0,
        total_cash: 0,
        total_online: 0,
        total_card: 0,
        total_credit: 0,
        total_other_methods: 0
      },
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      jsonFields: (_jsonFields = {}, __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.orderId'), 'id'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.location'), 'location'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.date'), 'date'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.closingOrder'), 'updated_at'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.order'), 'order'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.number'), 'number'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.tableNumber'), 'table_number'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.delivery_type'), 'deliveryType'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.name'), 'name'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.phone'), 'phone'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.totalAmount'), 'totalAmount'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.totalDiscount'), 'totalDiscount'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.totalTax'), 'totalTax'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.shipping'), 'shipping'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.zone'), 'zone'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.paymentType'), 'paymentType'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.orderProducts'), 'orderProducts'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.orderAdress'), 'orderAdress'), __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.orderComments'), 'orderComments'), _jsonFields),
      export_name: 'Export Raport Vanzari - ',
      json_fields: {
        'Id': 'id',
        'Location': 'location',
        'Date': 'date',
        'Closing Order': 'updated_at',
        '# Order': 'order',
        'Number': 'number',
        'Table Number': 'table_number',
        'Delivery Type': 'deliveryType',
        'Customer Name': 'name',
        'Phone': 'phone',
        'Total': 'totalAmount',
        'Discount': 'totalDiscount',
        'Taxes': 'totalTax',
        'Livrare': 'totalDelivery',
        'Zone': 'zone',
        'Payment Type': 'paymentType',
        'Ordered products': 'orderProducts',
        'Ordered adress': 'orderAdress',
        'Ordered comments': 'orderComments',
        'Receipt number': 'receiptNumber'
      },
      json_data: [],

      use_tips: true,
      hasRceipt: null,

      modalOrders: {
        valid: [__WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD')],
        location: '',
        search: '',
        methods: []
      },
      modalValidFrom: null,
      modalValidTo: null,
      modalSelectedDriver: '',
      modalSelectedPosUser: '',
      modalSelectedUser: '',
      modalSelectedUserName: '',
      modalSelectedOrderFrom: '',
      modalSelectedPaymentMethods: [],
      modalUnpaidOrdersFilter: 'paid',
      modalSelectedTable: null,
      modalOrderId: null,
      modalHasReceipt: null,
      modalFreeSearch: '',
      modalZet: null,
      modalSelectedCategories: [],

      isFiltersModalOpen: false
    };
  },

  computed: {
    appliedFilters: function appliedFilters() {
      var _this = this;

      var out = [];
      if (this.orders && this.orders.location) {
        var loc = (this.locations || []).find(function (l) {
          return String(l.id) === String(_this.orders.location);
        });
        out.push(this.$t('reports.location') + ': ' + (loc ? loc.name : this.orders.location));
      }
      if (this.hasRceipt && this.hasRceipt.label) {
        out.push(this.$t('reports.taxation') + ': ' + this.hasRceipt.label);
      }
      if (this.orders && Array.isArray(this.orders.methods) && this.orders.methods.length) {
        var labels = this.orders.methods.map(function (key) {
          var m = (_this.methods || []).find(function (x) {
            return String(x.key || x) === String(key);
          });
          return m ? m.label || key : key;
        }).filter(Boolean);
        out.push(this.$t('dashboard.selectMethod') + ': ' + labels.join(', '));
      }
      if (this.selected_user) {
        var userName = this.getSelectedUserDisplayName(this.selected_user, this.selected_user_name);
        out.push(this.$t('dashboard.selectClient') + ': ' + userName);
      }
      if (this.selectedPosUser) {
        var op = (this.posUsers || []).find(function (x) {
          return String(x.id) === String(_this.selectedPosUser);
        });
        out.push(this.$t('reports.operator') + ': ' + (op ? op.firstname + ' ' + op.lastname : this.selectedPosUser));
      }
      if (this.selected_order_from) out.push(this.$t('dashboard.selectedOrderFormFlags') + ': ' + String(this.selected_order_from).toUpperCase());
      if (this.selected_payment_methods && Array.isArray(this.selected_payment_methods) && this.selected_payment_methods.length) {
        var names = this.selected_payment_methods.map(function (id) {
          var pm = (_this.paymentMethods || []).find(function (x) {
            return String(x.id) === String(id);
          });
          return pm ? pm.name : id;
        });
        out.push(this.$t('dashboard.selectedPaymentMethods') + ': ' + names.join(', '));
      }
      if (!this.isUnpaidSelected()) {
        if (this.unpaidOrdersFilter === 'unpaid') {
          out.push(this.$t('reports.orderPaidStatus') + ': ' + this.$t('reports.unpaid'));
        } else if (this.unpaidOrdersFilter === 'all') {
          out.push(this.$t('reports.orderPaidStatus') + ': ' + this.$t('general.all'));
        }
      }
      if (this.orders && this.orders.search) out.push(this.$t('reports.couponCode') + ': ' + this.orders.search);
      if (this.orderId) out.push(this.$t('general.orderId') + ': ' + this.orderId);
      if (this.zet) out.push(this.$t('reports.zet') + ': ' + this.zet);
      if (this.selectedCategories && Array.isArray(this.selectedCategories) && this.selectedCategories.length) {
        var _names = this.selectedCategories.map(function (cat) {
          if ((typeof cat === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(cat)) === 'object' && cat !== null) {
            return cat.label;
          }

          var found = (_this.topCategories || []).find(function (x) {
            return String(x.id) === String(cat);
          });
          return found ? found.label : cat;
        });
        out.push(this.$t('pages.topCategory') + ': ' + _names.join(', '));
      }
      if (this.selectedDriver) {
        var d = (this.drivers || []).find(function (x) {
          return String(x.id) === String(_this.selectedDriver);
        });
        out.push(this.$t('dashboard.selectDriver') + ': ' + (d ? d.firstname + ' ' + d.lastname : this.selectedDriver));
      }
      if (this.freeSearch) out.push(this.$t('general.search') + ': ' + this.freeSearch);
      if (this.selectedTable && this.selectedTable.id != null) {
        var label = this.selectedTable.label || String(this.selectedTable.id);
        out.push(this.$t('reports.tables') + ': ' + label);
      }

      var isDefaultDate = this.orders && this.orders.valid && this.orders.valid[0] === __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD') && this.orders.valid[1] === __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD') && this.valid_from === '05:00' && this.valid_to === '05:00';
      if (!isDefaultDate && this.orders && this.orders.valid) {
        out.push(this.$t('reports.date') + ': ' + this.orders.valid[0] + ' ' + this.valid_from + ' - ' + this.orders.valid[1] + ' ' + this.valid_to);
      }

      return out;
    },
    cashSummaryTotal: function cashSummaryTotal() {
      var fallbackSum = (this.totals.totalCash || 0) + (this.totals.totalGlovoCash || 0) + (this.totals.totalBoltCash || 0) + (this.totals.totalWoltCash || 0) + (this.totals.totalSplitCash || 0);

      if (this.cardTotals && this.cardTotals.total_cash !== undefined && this.cardTotals.total_cash !== null) {
        if (this.cardTotals.total_cash === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_cash;
      }

      return fallbackSum;
    },
    cardSummaryTotal: function cardSummaryTotal() {
      var fallbackSum = (this.totals.totalCard || 0) + (this.totals.totalPOS || 0) + (this.totals.totalCARDPOS || 0) + (this.totals.totalSplitCard || 0);

      if (this.cardTotals && this.cardTotals.total_card !== undefined && this.cardTotals.total_card !== null) {
        if (this.cardTotals.total_card === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_card;
      }

      return fallbackSum;
    },
    totalOnlineSummaryTotal: function totalOnlineSummaryTotal() {
      var fallbackSum = (this.totals.totalCard || 0) + (this.totals.totalOnline || 0);

      if (this.cardTotals && this.cardTotals.total_online !== undefined && this.cardTotals.total_online !== null) {
        if (this.cardTotals.total_online === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_online;
      }

      return fallbackSum;
    },
    totalCardSummaryTotal: function totalCardSummaryTotal() {
      var fallbackSum = (this.totals.totalPOS || 0) + (this.totals.totalCARDPOS || 0) + (this.totals.totalSplitCard || 0);

      if (this.cardTotals && this.cardTotals.total_card !== undefined && this.cardTotals.total_card !== null) {
        if (this.cardTotals.total_card === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_card;
      }

      return fallbackSum;
    },
    totalCreditSummaryTotal: function totalCreditSummaryTotal() {
      var fallbackSum = (this.totals.totalBoltCard || 0) + (this.totals.totalGlovoCard || 0) + (this.totals.totalWoltCard || 0);

      if (this.cardTotals && this.cardTotals.total_credit !== undefined && this.cardTotals.total_credit !== null) {
        if (this.cardTotals.total_credit === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_credit;
      }

      return fallbackSum;
    },
    nonFiscalSummaryTotal: function nonFiscalSummaryTotal() {
      var fallbackSum = (this.totals.totalProtocol || 0) + (this.totals.totalStaffFood || 0) + (this.totals.totalVirament || 0) + (this.totals.totalRoom || 0) + (this.totals.totalEvent || 0) + (this.totals.totalFolio || 0);

      if (this.cardTotals && this.cardTotals.total_other_methods !== undefined && this.cardTotals.total_other_methods !== null) {
        if (this.cardTotals.total_other_methods === 0 && fallbackSum > 0) {
          return fallbackSum;
        }
        return this.cardTotals.total_other_methods;
      }

      return fallbackSum;
    },
    mergedCategories: function mergedCategories() {
      var map = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a(this.topCategories.map(function (item) {
        return [item.id, item];
      }));
      this.modalSelectedCategories.forEach(function (item) {
        if (item && item.id && !map.has(item.id)) {
          map.set(item.id, item);
        }
      });
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(map.values());
    },
    mergedUsers: function mergedUsers() {
      var _this2 = this;

      var map = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a(this.users.map(function (item) {
        return [item.id, item];
      }));

      if (this.modalSelectedUser && this.modalSelectedUser !== '') {
        var selectedUser = this.users.find(function (u) {
          return String(u.id) === String(_this2.modalSelectedUser);
        });
        if (selectedUser && !map.has(selectedUser.id)) {
          map.set(selectedUser.id, selectedUser);
        } else if (!selectedUser) {
          var fallbackLabel = this.modalSelectedUserName || this.selected_user_name || '';

          if (fallbackLabel) {
            map.set(this.modalSelectedUser, {
              id: this.modalSelectedUser,
              firstname: '',
              lastname: '',
              email: fallbackLabel
            });
          }
        }
      }
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(map.values());
    },
    unpaidOrdersFilterOptions: function unpaidOrdersFilterOptions() {
      return [{ value: 'all', label: this.$t('general.all') }, { value: 'paid', label: this.$t('paymentStatus.paid') }, { value: 'unpaid', label: this.$t('reports.unpaid') }];
    },
    mergedSalesReportTables: function mergedSalesReportTables() {
      var map = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a((this.availableTables || []).map(function (t) {
        return [t.id, t];
      }));
      if (this.modalSelectedTable && this.modalSelectedTable.id != null && !map.has(this.modalSelectedTable.id)) {
        map.set(this.modalSelectedTable.id, this.modalSelectedTable);
      }
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(map.values());
    }
  },
  methods: {
    getUserLabel: function getUserLabel(user) {
      if (!user) return '';
      return user.firstname && user.lastname ? user.firstname + ' ' + user.lastname : user.email || '';
    },
    getSelectedUserDisplayName: function getSelectedUserDisplayName(userId) {
      var cachedName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (cachedName) return cachedName;
      var user = (this.mergedUsers || []).find(function (x) {
        return String(x.id) === String(userId);
      }) || (this.users || []).find(function (x) {
        return String(x.id) === String(userId);
      });
      return this.getUserLabel(user) || '-';
    },
    handleUserChange: function handleUserChange(value) {
      if (!value) {
        this.modalSelectedUserName = '';
      } else {
        var selectedUser = (this.mergedUsers || []).find(function (u) {
          return String(u.id) === String(value);
        });
        this.modalSelectedUserName = this.getUserLabel(selectedUser);
      }
      this.clearUserSearch();
    },
    getLocationName: function getLocationName(storeId) {
      if (!storeId) return '';
      var location = this.locations.find(function (loc) {
        return loc.id === storeId;
      });
      return location ? location.name : '';
    },
    syncModalFromFilters: function syncModalFromFilters() {
      this.modalOrders = {
        valid: Array.isArray(this.orders.valid) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.orders.valid)) : [],
        location: this.orders.location || '',
        search: this.orders.search || '',
        methods: Array.isArray(this.orders.methods) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.orders.methods)) : []
      };
      this.modalValidFrom = this.valid_from;
      this.modalValidTo = this.valid_to;
      this.modalSelectedDriver = this.selectedDriver;
      this.modalSelectedPosUser = this.selectedPosUser;
      this.modalSelectedUser = this.selected_user;
      this.modalSelectedUserName = this.selected_user_name || this.getSelectedUserDisplayName(this.selected_user);
      this.modalSelectedOrderFrom = this.selected_order_from;
      this.modalSelectedPaymentMethods = Array.isArray(this.selected_payment_methods) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.selected_payment_methods)) : [];
      this.modalUnpaidOrdersFilter = this.unpaidOrdersFilter || 'paid';
      this.modalSelectedTable = this.selectedTable && this.selectedTable.id != null ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.selectedTable) : null;
      this.modalOrderId = this.orderId;
      this.modalHasReceipt = this.hasRceipt;
      this.modalFreeSearch = this.freeSearch;
      this.modalZet = this.zet;
      this.modalSelectedCategories = Array.isArray(this.selectedCategories) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.selectedCategories)) : [];
    },
    searchTopCategories: function searchTopCategories(query) {
      var _this3 = this;

      if (!query) {
        return;
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      };

      this.loadingCategories = true;
      this.apiRequest('/search-top-categories', 'GET', data, function (response) {
        if (response.status) {
          _this3.topCategories = response.data;
        }
        _this3.$nextTick(function () {
          _this3.loadingCategories = false;
        });
      });
    },
    clearCategorySearch: function clearCategorySearch() {
      if (this.$refs.categorySelect) {
        this.$refs.categorySelect.focus();
        this.$refs.categorySelect.query = '';
        this.$refs.categorySelect.handleQueryChange('');
      }
    },
    getUsers: function getUsers() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.loadingUsers = true;
      this.apiRequest('/search-users', 'GET', data, function (response) {
        if (response.status === true && response.data) {
          if (Array.isArray(response.data)) {
            _this4.users = response.data;
          } else if (response.data.users && Array.isArray(response.data.users)) {
            _this4.users = response.data.users;
          } else if (response.data.user && Array.isArray(response.data.user)) {
            _this4.users = response.data.user;
          } else {
            _this4.users = [];
          }
        } else {
          _this4.users = [];
        }
        _this4.$nextTick(function () {
          _this4.loadingUsers = false;
        });
      });
    },
    searchUsers: function searchUsers(query) {
      var _this5 = this;

      if (this.userSearchTimeout) {
        clearTimeout(this.userSearchTimeout);
        this.userSearchTimeout = null;
      }

      if (!query) {
        this.users = [];
        return;
      }

      this.userSearchTimeout = setTimeout(function () {
        var data = {
          token: _this5.$session.get('token'),
          company_id: _this5.$session.get('selectedCompany'),
          search: query
        };

        _this5.loadingUsers = true;
        _this5.apiRequest('/search-users', 'GET', data, function (response) {
          if (response.status === true && response.data) {
            if (Array.isArray(response.data)) {
              _this5.users = response.data;
            } else if (response.data.users && Array.isArray(response.data.users)) {
              _this5.users = response.data.users;
            } else if (response.data.user && Array.isArray(response.data.user)) {
              _this5.users = response.data.user;
            } else {
              _this5.users = [];
            }
          } else {
            _this5.users = [];
          }
          _this5.$nextTick(function () {
            _this5.loadingUsers = false;
          });
        });
      }, 300);
    },
    searchUsersById: function searchUsersById(userId) {
      var _this6 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: userId
      };

      this.loadingUsers = true;
      this.apiRequest('/search-users', 'GET', data, function (response) {
        var resolvedUser = null;
        if (response.status === true && response.data) {
          if (Array.isArray(response.data)) {
            _this6.users = response.data;
            resolvedUser = _this6.users.find(function (u) {
              return String(u.id) === String(userId);
            }) || null;
          } else if (response.data.users && Array.isArray(response.data.users)) {
            _this6.users = response.data.users;
            resolvedUser = _this6.users.find(function (u) {
              return String(u.id) === String(userId);
            }) || null;
          } else if (response.data.user && Array.isArray(response.data.user)) {
            _this6.users = response.data.user;
            resolvedUser = _this6.users.find(function (u) {
              return String(u.id) === String(userId);
            }) || null;
          } else if (response.data && response.data.id) {
            _this6.users = [response.data];
            resolvedUser = String(response.data.id) === String(userId) ? response.data : null;
          } else {
            _this6.users = [];
          }
        } else {
          _this6.users = [];
        }
        var resolvedLabel = _this6.getUserLabel(resolvedUser);
        if (resolvedLabel) {
          if (String(_this6.selected_user) === String(userId)) {
            _this6.selected_user_name = resolvedLabel;
          }
          if (String(_this6.modalSelectedUser) === String(userId)) {
            _this6.modalSelectedUserName = resolvedLabel;
          }
        }
        _this6.$nextTick(function () {
          _this6.loadingUsers = false;
        });
      });
    },
    clearUserSearch: function clearUserSearch() {
      if (this.$refs.userSelect) {
        this.$refs.userSelect.focus();
        this.$refs.userSelect.query = '';
        this.$refs.userSelect.handleQueryChange('');
      }
    },
    searchTables: function searchTables(query) {
      var _this7 = this;

      if (!query) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      };
      this.loadingTables = true;
      this.apiRequest('/search-tables', 'GET', data, function (response) {
        if (response.status) {
          _this7.availableTables = response.data || [];
        } else {
          _this7.availableTables = [];
        }
        _this7.$nextTick(function () {
          _this7.loadingTables = false;
        });
      });
    },
    clearTableSearch: function clearTableSearch() {
      var select = this.$refs.salesReportTableSelect;
      if (select) {
        select.focus();
        select.query = '';
        select.handleQueryChange('');
      }
    },
    openFiltersModal: function openFiltersModal() {
      this.syncModalFromFilters();

      if (this.modalSelectedUser && this.modalSelectedUser !== '') {
        this.searchUsersById(this.modalSelectedUser);
      }
      this.isFiltersModalOpen = true;
      this.$modal.show('salesReportFiltersModal');
    },
    applyFilters: function applyFilters() {
      var _this8 = this;

      this.orders.valid = Array.isArray(this.modalOrders.valid) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.modalOrders.valid)) : this.orders.valid;
      this.orders.location = this.modalOrders.location;
      this.orders.search = this.modalOrders.search;
      this.orders.methods = Array.isArray(this.modalOrders.methods) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.modalOrders.methods)) : [];

      this.valid_from = this.modalValidFrom || '00:00';
      this.valid_to = this.modalValidTo || '23:59';
      this.selectedDriver = this.modalSelectedDriver || '';
      this.selectedPosUser = this.modalSelectedPosUser || '';
      this.selected_user = this.modalSelectedUser || '';
      this.selected_user_name = this.modalSelectedUser ? this.modalSelectedUserName || this.getSelectedUserDisplayName(this.modalSelectedUser) : '';
      this.selected_order_from = this.modalSelectedOrderFrom || '';
      this.selected_payment_methods = Array.isArray(this.modalSelectedPaymentMethods) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.modalSelectedPaymentMethods)) : [];
      this.unpaidOrdersFilter = this.modalUnpaidOrdersFilter || 'paid';
      this.selectedTable = this.modalSelectedTable && this.modalSelectedTable.id != null ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.modalSelectedTable) : null;
      this.orderId = this.modalOrderId || null;
      this.zet = this.modalZet || null;
      this.selectedCategories = Array.isArray(this.modalSelectedCategories) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.modalSelectedCategories)) : [];
      this.hasRceipt = this.modalHasReceipt || null;
      this.freeSearch = this.modalFreeSearch || '';

      this.saveFiltersToCookie();
      this.$modal.hide('salesReportFiltersModal');
      this.isFiltersModalOpen = false;
      this.$nextTick(function () {
        return _this8.getOrders();
      });
    },
    resetModalFilters: function resetModalFilters() {
      this.resetFilters();

      this.syncModalFromFilters();
    },
    resetFilters: function resetFilters() {
      this.orders.location = '';
      this.orders.search = '';
      this.orders.methods = [];
      this.selectedDriver = '';
      this.selectedPosUser = '';
      this.selected_user = '';
      this.selected_user_name = '';
      this.selected_order_from = '';
      this.selected_payment_methods = [];
      this.unpaidOrdersFilter = 'paid';
      this.selectedTable = null;
      this.availableTables = [];
      this.orderId = null;
      this.zet = null;
      this.selectedCategories = [];
      this.hasRceipt = null;
      this.freeSearch = '';
      this.valid_from = '05:00';
      this.valid_to = '05:00';
      this.orders.valid = [__WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD')];
      this.clearFiltersCookie();
      this.getOrders();
    },
    clientsExportData: function clientsExportData() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp, data, $dd, sortOptions, unpaidOrdersVal, ced, salesData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resp = [];

                if (!_this9.orders) {
                  _context.next = 26;
                  break;
                }

                _context.prev = 2;
                data = {
                  token: _this9.$session.get('token'),
                  company_id: _this9.$session.get('selectedCompany'),
                  start_date: _this9.orders.valid[0] + ' ' + _this9.valid_from + ':00',
                  end_date: _this9.orders.valid[1] + ' ' + _this9.valid_to + ':00',
                  date_column: _this9.date_column,
                  driver: _this9.selectedDriver,
                  operator: _this9.selectedPosUser,
                  selected_user: _this9.selected_user,
                  selected_order_from: _this9.selected_order_from,
                  selected_payment_methods: _this9.getPaymentMethodsArray(),
                  coupon: _this9.orders.search,
                  zet: _this9.zet,
                  top_category_ids: Array.isArray(_this9.selectedCategories) && _this9.selectedCategories.length ? _this9.selectedCategories.map(function (cat) {
                    return (typeof cat === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(cat)) === 'object' && cat !== null ? cat.id : cat;
                  }) : null
                };
                $dd = {};
                sortOptions = {
                  field: _this9.sortBy,
                  order: _this9.sortOrder
                };

                data = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, sortOptions);

                if (_this9.orders.location && _this9.orders.location !== '') {
                  data.location_id = _this9.orders.location;
                }

                unpaidOrdersVal = _this9.getUnpaidOrdersApiValue();

                if (unpaidOrdersVal !== undefined) {
                  data.unpaid_orders = unpaidOrdersVal;
                }
                if (_this9.selectedTable && _this9.selectedTable.id != null && _this9.selectedTable.id !== '') {
                  data.table_id = _this9.selectedTable.id;
                }

                ced = [];
                salesData = [];
                _context.next = 15;
                return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var ver = _this9.$route.query && _this9.$route.query.ver === 'V2' ? 'V2' : '';
                  _this9.apiRequest('/reports/sales-report-export-excel' + ver + '?withProducts=1&page=' + 1 + '&pageSize=' + 50000, 'GET', data, function (response) {
                    if (response.status === true && response.data) {
                      if (response.data.export_excel && Array.isArray(response.data.export_excel)) {
                        salesData = response.data.export_excel;
                      } else if (response.data.orders && response.data.orders.data) {
                        salesData = response.data.orders.data;
                      } else if (Array.isArray(response.data)) {
                        salesData = response.data;
                      } else {
                        salesData = [];
                      }

                      if (salesData && salesData.length > 0) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(salesData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var sale = _step.value;

                            $dd = {
                              location: sale.location || _this9.getLocationName(sale.store_id) || '',
                              date: sale.date || sale.created_at,
                              updated_at: sale.updated_at,
                              order: sale.order || sale.token,
                              number: sale.number,
                              deliveryType: sale.deliveryType || sale.delivery_type,
                              name: sale.name || (sale.customer ? sale.customer.firstname + ' ' + sale.customer.lastname : ''),
                              phone: sale.phone || (sale.customer ? sale.customer.phone : ''),
                              totalAmount: sale.totalAmount !== undefined ? sale.totalAmount : sale.totals_grandtotal,
                              totalDiscount: sale.totalDiscount !== undefined ? sale.totalDiscount : sale.totals_discount + sale.totals_discount_loyalty_points,
                              totalTax: sale.totalTax !== undefined ? sale.totalTax : sale.totals_extras,
                              totalDelivery: sale.totalDelivery !== undefined ? sale.totalDelivery : sale.totals_delivery,
                              zone: sale.zone || (sale.shipping_details ? sale.shipping_details.name : ''),
                              paymentType: sale.paymentType || sale.payment_type,
                              orderProducts: sale.orderProducts,
                              orderAdress: sale.orderAdress,
                              orderComments: sale.orderComments,
                              receiptNumber: sale.receiptNumber
                            };
                            ced.push($dd);
                          }
                        } catch (err) {
                          _didIteratorError = true;
                          _iteratorError = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                              _iterator.return();
                            }
                          } finally {
                            if (_didIteratorError) {
                              throw _iteratorError;
                            }
                          }
                        }
                      }
                    } else {
                      console.error('Failed to export sales report:', response && response.errors ? response.errors : response);
                    }
                    resolve(ced);
                  });
                });

              case 15:
                resp = _context.sent;
                return _context.abrupt('return', resp);

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](2);

                console.error('Unexpected error while exporting sales report:', _context.t0);
                return _context.abrupt('return', []);

              case 23:
                _context.prev = 23;

                _this9.finishDownload();
                return _context.finish(23);

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9, [[2, 19, 23, 26]]);
      }))();
    },
    startDownload: function startDownload() {
      this.exportLoading = true;
    },
    finishDownload: function finishDownload() {
      this.exportLoading = false;
    },
    changeValidFrom: function changeValidFrom() {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'valid_order';

      if (fields === 'valid_order') {
        if (!this.valid_from) {
          this.valid_from = '00:00';
        }
        if (!this.valid_to) {
          this.valid_to = '23:59';
        }
      } else {
        if (!this.products_valid_from) {
          this.products_valid_from = '00:00';
        }
        if (!this.products_valid_to) {
          this.products_valid_to = '23:59';
        }
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details;
      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }
      if (this.locations.length > 1) {
        this.showLocations = true;
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    isUnpaidSelected: function isUnpaidSelected() {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return false;
      }

      return this.selected_payment_methods.some(function (method) {
        var id = typeof method === 'string' ? method : method && method.id;
        return id === 'unpaid';
      });
    },
    getUnpaidOrdersApiValue: function getUnpaidOrdersApiValue() {
      if (this.isUnpaidSelected()) {
        return 1;
      }
      if (this.unpaidOrdersFilter === 'unpaid') {
        return 1;
      }
      if (this.unpaidOrdersFilter === 'paid') {
        return 0;
      }
      return undefined;
    },
    getPaymentMethodsArray: function getPaymentMethodsArray() {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return [];
      }

      return this.selected_payment_methods.map(function (method) {
        return typeof method === 'string' ? method : method && method.id ? method.id : null;
      }).filter(function (method) {
        return method && method !== 'unpaid';
      });
    },
    getPaymentMethods: function getPaymentMethods() {
      var _this10 = this;

      var sessionData = this.$session.get('selectedCompanyData');

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };

        this.apiRequest('/orders/get-payment-methods', 'GET', data, function (response) {
          if (response.status && response.data.length) {
            var result = response.data.map(function (item) {
              return { id: item || 'unpaid', name: _this10.$t('paymentTypes.' + item) };
            });

            if (!result.find(function (item) {
              return item.id === 'VOUCHER';
            })) {
              result.push({ id: 'VOUCHER', name: _this10.$t('paymentTypes.VOUCHER') });
            }
            sessionData['payment_methods'] = response.data;
            _this10.$session.set('selectedCompanyData', sessionData);

            __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(_this10, 'paymentMethods', result);
          }
        });
      } else {
        var result = sessionData['payment_methods'].map(function (item) {
          return { id: item || 'unpaid', name: _this10.$t('paymentTypes.' + item) };
        });

        if (!result.find(function (item) {
          return item.id === 'VOUCHER';
        })) {
          result.push({ id: 'VOUCHER', name: this.$t('paymentTypes.VOUCHER') });
        }
        __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(this, 'paymentMethods', result);
      }
    },
    getOrders: function getOrders(query) {
      var _this11 = this;

      if (!this.isReports) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      if (!this.products_valid_from) {
        this.products_valid_from = '00:00';
      }
      if (!this.products_valid_to || this.products_valid_to === '24:00') {
        this.products_valid_to = '23:59';
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.orders.valid[0] + ' ' + this.valid_from + ':00',
        end_date: this.orders.valid[1] + ' ' + this.valid_to + ':00',
        start_date_products: this.orders.valid[0] + ' ' + this.products_valid_from + ':00',
        end_date_products: this.orders.valid[1] + ' ' + this.products_valid_to + ':00',
        date_column: this.date_column,
        driver: this.selectedDriver,
        operator: this.selectedPosUser,
        selected_user: this.selected_user,
        selected_order_from: this.selected_order_from,
        selected_payment_methods: this.getPaymentMethodsArray(),
        coupon: this.orders.search,
        search: this.freeSearch,
        zet: this.zet,
        top_category_ids: Array.isArray(this.selectedCategories) && this.selectedCategories.length ? this.selectedCategories.map(function (cat) {
          return (typeof cat === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(cat)) === 'object' && cat !== null ? cat.id : cat;
        }) : null
      };

      var unpaidOrdersVal = this.getUnpaidOrdersApiValue();
      if (unpaidOrdersVal !== undefined) {
        data.unpaid_orders = unpaidOrdersVal;
      }

      if (this.orderId) {
        data.order_id = this.orderId;
      }
      if (this.selectedTable && this.selectedTable.id != null && this.selectedTable.id !== '') {
        data.table_id = this.selectedTable.id;
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }
      if (this.orders.method && this.orders.method !== '') {
        data.method = this.orders.method.toUpperCase();
      }
      if (this.orders.methods && this.orders.methods.length) {
        data.methods = this.orders.methods.filter(function (m) {
          return m != null;
        }).map(function (method) {
          if (typeof method === 'string') {
            return method.toUpperCase();
          }
          var key = method.key || method.value || method;
          return String(key).toUpperCase();
        });
      }
      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      var ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : '';
      var hasReceiptValue = this.hasRceipt && this.hasRceipt.value || null;

      this.apiRequest('/reports/sales-report' + ver + '?page=' + page + '&pageSize=' + pageSize + '&has_receipt=' + hasReceiptValue, 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data.users && (!_this11.users || _this11.users.length === 0)) {
            _this11.users = Array.isArray(response.data.users) ? response.data.users : [];
          }
          _this11.ordersTableData = response.data.orders;
          _this11.totals.totalTips = response.data.payment_tips || 0;
          _this11.totals.totalCash = response.data.payment_cash || 0;
          _this11.totals.totalVirament = response.data.payment_virament || 0;
          _this11.totals.totalOnline = response.data.payment_online || 0;
          _this11.totals.totalProtocol = response.data.payment_protocol || 0;
          _this11.totals.totalStaffFood = response.data.payment_staff_food || 0;
          _this11.totals.totalRoom = response.data.payment_room || 0;
          _this11.totals.totalEvent = response.data.payment_event || 0;
          _this11.totals.totalFolio = response.data.payment_folio || 0;
          _this11.totals.totalSplit = response.data.payment_split || 0;
          _this11.totals.totalCard = response.data.payment_card || 0;
          _this11.totals.totalPOS = response.data.payment_pos || 0;
          _this11.totals.totalCARDPOS = response.data.payment_card_pos || 0;
          _this11.totals.totalDiscount = response.data.total_discount || 0;
          _this11.totals.totalDiscountItems = response.data.total_discount_items || 0;
          _this11.totals.totalDiscountLoyaltyPoints = response.data.total_discount_loyalty_points || 0;
          _this11.totals.totalTax = response.data.total_tax || 0;
          _this11.totals.totalSlotTax = response.data.total_slot_tax || 0;
          _this11.totals.totalSlotPartTax = response.data.total_slot_part_tax || 0;
          _this11.totals.avarageOrderValue = response.data.avarage_order_value || 0;
          _this11.totals.totalShipping = response.data.total_shipping;
          _this11.totals.totalBoltCard = response.data.payment_bolt_card || 0;
          _this11.totals.totalBoltCash = response.data.payment_bolt_cash || 0;
          _this11.totals.totalGlovoCard = response.data.payment_glovo_card || 0;
          _this11.totals.totalGlovoCash = response.data.payment_glovo_cash || 0;
          _this11.totals.totalWoltCard = response.data.payment_wolt_card || response.data.payment_woltCard || 0;
          _this11.totals.totalWoltCash = response.data.payment_wolt_cash || response.data.payment_woltCash || 0;
          _this11.totals.totalWoltOtherMethods = response.data.payment_wolt_other_methods || 0;
          _this11.totals.totalPayFromWallet = response.data.total_pay_from_wallet || 0;
          _this11.totals.totalSplitCash = response.data.total_split_cash || 0;
          _this11.totals.totalSplitCard = response.data.total_split_card || 0;
          _this11.totals.totalSplitVoucher = response.data.total_split_voucher || 0;
          _this11.totals.totalUnpaid = response.data.payment_unpaid || 0;
          _this11.totals.unfiscalTotal = response.data.unfiscal_total || 0;
          _this11.totals.unfiscalTotalCard = response.data.unfiscal_total_card || 0;
          _this11.totals.unfiscalTotalCash = response.data.unfiscal_total_cash || 0;
          _this11.totals.unfiscalTotalCredit = response.data.unfiscal_total_credit || 0;
          _this11.totals.unfiscalTotalOnline = response.data.unfiscal_total_online || 0;
          var giftCardsSold = response.data.gift_cards_sold;
          if (giftCardsSold && (typeof giftCardsSold === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(giftCardsSold)) === 'object') {
            _this11.totals.giftCardsSoldCount = giftCardsSold.count != null ? Number(giftCardsSold.count) || 0 : 0;
            _this11.totals.giftCardsSoldAmount = giftCardsSold.amount != null ? Number(giftCardsSold.amount) || 0 : 0;
          } else {
            _this11.totals.giftCardsSoldCount = 0;
            _this11.totals.giftCardsSoldAmount = 0;
          }

          if (response.data.card_totals) {
            _this11.cardTotals = {
              total_amount: response.data.card_totals.total_amount || 0,
              total_cash: response.data.card_totals.total_cash || 0,
              total_online: response.data.card_totals.total_online || 0,
              total_card: response.data.card_totals.total_card || 0,
              total_credit: response.data.card_totals.total_credit || 0,
              total_other_methods: response.data.card_totals.total_other_methods || 0
            };
          }

          var apiTotal = response.data.card_totals && response.data.card_totals.total_amount || response.data.total_sales || response.data.grand_total || response.data.total_grandtotal;
          if (apiTotal !== undefined && apiTotal !== null) {
            _this11.totals.total = parseFloat(apiTotal) || 0;
          } else {
            _this11.totals.total = (_this11.cashSummaryTotal || 0) + (_this11.totalOnlineSummaryTotal || 0) + (_this11.totalCardSummaryTotal || 0) + (_this11.totalCreditSummaryTotal || 0) + (_this11.nonFiscalSummaryTotal || 0) + (_this11.totals.totalUnpaid || 0) + (_this11.totals.giftCardsSoldAmount || 0);
          }

          _this11.totals.total = (Number(_this11.totals.total) || 0) + (Number(_this11.totals.giftCardsSoldAmount) || 0);

          _this11.totalOrders = response.data.orders.total || response.data.total_orders || 0;
          _this11.json_data = response.data.export_excel;

          var cardPayment = response.data.payment_card_counter;
          var cashPayment = response.data.payment_cash_counter;
          var viramentPayment = response.data.payment_virament_counter;
          var onlinePayment = response.data.payment_online_counter;
          var protocolPayment = response.data.payment_protocol_counter;
          var paymentStaffFoodPayment = response.data.payment_staff_food_counter;
          var paymentRoomPayment = response.data.payment_room_counter;
          var paymentEventPayment = response.data.payment_event_counter;
          var paymentFolioPayment = response.data.payment_folio_counter;
          var paymentSplitPayment = response.data.payment_split_counter;
          var posPayment = response.data.payment_pos_counter;
          var cardPosPayment = response.data.payment_card_pos_counter;
          var boltCardPayment = response.data.payment_bolt_card_counter;
          var boltCashPayment = response.data.payment_bolt_cash_counter;
          var glovoCardPayment = response.data.payment_glovo_card_counter;
          var glovoCashPayment = response.data.payment_glovo_cash_counter;
          var woltCardPayment = response.data.payment_wolt_card_counter;
          var woltCashPayment = response.data.payment_wolt_cash_counter;
          var woltOtherMethodsPayment = response.data.payment_wolt_other_methods_counter;
          var unpaidPayment = response.data.payment_unpaid_counter;

          var totalPayments = cardPayment + cashPayment + posPayment + cardPosPayment + viramentPayment + onlinePayment + protocolPayment + paymentStaffFoodPayment + paymentRoomPayment + paymentEventPayment + paymentFolioPayment + paymentSplitPayment + boltCardPayment + boltCashPayment + glovoCardPayment + glovoCashPayment + woltCardPayment + woltCashPayment + (woltOtherMethodsPayment || 0) + unpaidPayment;
          if (totalPayments) {
            _this11.salesReportChart.data.labels = [_this11.$t('reports.card') + ' - ' + parseFloat(cardPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.cash') + ' - ' + parseFloat(cashPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.pos') + ' - ' + parseFloat(posPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.cardPos') + ' - ' + parseFloat(cardPosPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.virament') + ' - ' + parseFloat(viramentPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.online') + ' - ' + parseFloat(onlinePayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.protocol') + ' - ' + parseFloat(protocolPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.staffFood') + ' - ' + parseFloat(paymentStaffFoodPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.room') + ' - ' + parseFloat(paymentRoomPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.event') + ' - ' + parseFloat(paymentEventPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.folio') + ' - ' + parseFloat(paymentFolioPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('paymentTypes.SPLIT') + ' - ' + parseFloat(paymentSplitPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.boltCard') + ' - ' + parseFloat(boltCardPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.boltCash') + ' - ' + parseFloat(boltCashPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.glovoCard') + ' - ' + parseFloat(glovoCardPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.glovoCash') + ' - ' + parseFloat(glovoCashPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.woltCard') + ' - ' + parseFloat(woltCardPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.woltCash') + ' - ' + parseFloat(woltCashPayment * 100 / totalPayments).toFixed(2) + '%', _this11.$t('reports.woltOtherMethods') + ' - ' + parseFloat((woltOtherMethodsPayment || 0) * 100 / totalPayments).toFixed(2) + '%'];
            _this11.salesReportChart.data.series = [{
              value: cardPayment,
              name: _this11.$t('reports.card')
            }, {
              value: cashPayment,
              name: _this11.$t('reports.cash')
            }, {
              value: posPayment,
              name: _this11.$t('reports.pos')
            }, {
              value: cardPosPayment,
              name: _this11.$t('reports.cardPos')
            }, {
              value: viramentPayment,
              name: _this11.$t('reports.virament')
            }, {
              value: onlinePayment,
              name: _this11.$t('reports.online')
            }, {
              value: protocolPayment,
              name: _this11.$t('reports.protocol')
            }, {
              value: paymentStaffFoodPayment,
              name: _this11.$t('reports.staffFood')
            }, {
              value: paymentRoomPayment,
              name: _this11.$t('reports.room')
            }, {
              value: paymentEventPayment,
              name: _this11.$t('reports.event')
            }, {
              value: paymentFolioPayment,
              name: _this11.$t('reports.folio')
            }, {
              value: paymentSplitPayment,
              name: _this11.$t('paymentTypes.SPLIT')
            }, {
              value: boltCardPayment,
              name: _this11.$t('reports.boltCard')
            }, {
              value: boltCashPayment,
              name: _this11.$t('reports.boltCash')
            }, {
              value: glovoCardPayment,
              name: _this11.$t('reports.glovoCard')
            }, {
              value: glovoCashPayment,
              name: _this11.$t('reports.glovoCash')
            }, {
              value: woltCardPayment,
              name: _this11.$t('reports.woltCard')
            }, {
              value: woltCashPayment,
              name: _this11.$t('reports.woltCash')
            }, {
              value: woltOtherMethodsPayment || 0,
              name: _this11.$t('reports.woltOtherMethods')
            }];
            _this11.$refs.salesReportChart.initChart();
          } else {
            _this11.salesReportChart.data.labels = [_this11.$t('reports.card') + ' - ' + 0, _this11.$t('reports.cash') + ' - ' + 0, _this11.$t('reports.pos') + ' - ' + 0, _this11.$t('reports.cardPos') + ' - ' + 0, _this11.$t('reports.virament') + ' - ' + 0, _this11.$t('reports.online') + ' - ' + 0, _this11.$t('reports.protocol') + ' - ' + 0, _this11.$t('reports.room') + ' - ' + 0, _this11.$t('reports.event') + ' - ' + 0, _this11.$t('reports.folio') + ' - ' + 0, _this11.$t('paymentTypes.SPLIT') + ' - ' + 0, _this11.$t('reports.boltCard') + ' - ' + 0, _this11.$t('reports.boltCash') + ' - ' + 0, _this11.$t('reports.glovoCard') + ' - ' + 0, _this11.$t('reports.glovoCash') + ' - ' + 0, _this11.$t('reports.woltCard') + ' - ' + 0, _this11.$t('reports.woltCash') + ' - ' + 0, _this11.$t('reports.woltOtherMethods') + ' - ' + 0];

            _this11.salesReportChart.data.series = [{
              value: 0,
              name: _this11.$t('reports.card')
            }, {
              value: 0,
              name: _this11.$t('reports.cash')
            }, {
              value: 0,
              name: _this11.$t('reports.pos')
            }, {
              value: 0,
              name: _this11.$t('reports.cardPos')
            }, {
              value: 0,
              name: _this11.$t('reports.virament')
            }, {
              value: 0,
              name: _this11.$t('reports.online')
            }, {
              value: 0,
              name: _this11.$t('reports.protocol')
            }, {
              value: 0,
              name: _this11.$t('reports.room')
            }, {
              value: 0,
              name: _this11.$t('reports.event')
            }, {
              value: 0,
              name: _this11.$t('reports.folio')
            }, {
              value: 0,
              name: _this11.$t('paymentTypes.SPLIT')
            }, {
              value: 0,
              name: _this11.$t('reports.boltCard')
            }, {
              value: 0,
              name: _this11.$t('reports.boltCash')
            }, {
              value: 0,
              name: _this11.$t('reports.glovoCard')
            }, {
              value: 0,
              name: _this11.$t('reports.glovoCash')
            }, {
              value: 0,
              name: _this11.$t('reports.woltCard')
            }, {
              value: 0,
              name: _this11.$t('reports.woltCash')
            }, {
              value: 0,
              name: _this11.$t('reports.woltOtherMethods')
            }];
            _this11.$refs.salesReportChart.initChart();
          }
        }
        _this11.$nextTick(function () {
          _this11.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.saveFiltersToCookie();
      this.getOrders();
    },
    goToRecordOrder: function goToRecordOrder(row, event, column) {
      this.$router.push('/orders/view/' + row.id);
    },
    formatReceiptNumber: function formatReceiptNumber(receiptNumber) {
      if (!receiptNumber) {
        return '-';
      }

      try {
        if ((typeof receiptNumber === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(receiptNumber)) === 'object' && receiptNumber !== null) {
          return receiptNumber.ReceiptNumber || receiptNumber.receiptNumber || receiptNumber.receipt_number || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(receiptNumber);
        }

        if (typeof receiptNumber === 'string') {
          if (!receiptNumber.trim()) {
            return '-';
          }
          var parsed = JSON.parse(receiptNumber);
          if ((typeof parsed === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(parsed)) === 'object' && parsed !== null) {
            return parsed.ReceiptNumber || parsed.receiptNumber || parsed.receipt_number || receiptNumber;
          }
          return parsed;
        }

        return receiptNumber;
      } catch (e) {
        return receiptNumber;
      }
    },
    parseZet: function parseZet(receiptNumber) {
      if (!receiptNumber) {
        return '-';
      }

      try {
        var data = receiptNumber;

        if (typeof data === 'string') {
          if (!data.trim()) {
            return '-';
          }
          data = JSON.parse(data);
        }

        if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(data)) === 'object' && data !== null) {
          var info = data.ReceiptInfo || data.receiptInfo || data.receipt_info || '';

          if (typeof info === 'string') {
            var match = info.match(/NRZ\s*=\s*(\d+)/);
            if (match && match[1]) {
              return match[1];
            }
          }
        }

        return '-';
      } catch (e) {
        return '-';
      }
    },
    saveFiltersToCookie: function saveFiltersToCookie() {
      var filters = {
        location: this.orders.location || '',
        valid: this.orders.valid || [__WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY-MM-DD')],
        valid_from: this.valid_from || '05:00',
        valid_to: this.valid_to || '05:00',
        methods: Array.isArray(this.orders.methods) ? this.orders.methods : [],
        search: this.orders.search || '',
        selected_user: this.selected_user || '',
        selected_user_name: this.selected_user_name || '',
        selectedPosUser: this.selectedPosUser || '',
        selected_order_from: this.selected_order_from || '',
        selected_payment_methods: Array.isArray(this.selected_payment_methods) ? this.selected_payment_methods : [],
        unpaidOrdersFilter: this.unpaidOrdersFilter || 'paid',
        selectedTable: this.selectedTable && this.selectedTable.id != null ? { id: this.selectedTable.id, label: this.selectedTable.label || '' } : null,
        orderId: this.orderId || null,
        zet: this.zet || null,
        selectedCategories: Array.isArray(this.selectedCategories) ? this.selectedCategories : [],
        hasRceipt: this.hasRceipt || null,
        freeSearch: this.freeSearch || '',
        selectedDriver: this.selectedDriver || ''
      };
      this.$cookie.set('sales-report-filters', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filters), 30);

      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    loadFiltersFromCookie: function loadFiltersFromCookie() {
      var _this12 = this;

      var filtersCookie = this.$cookie.get('sales-report-filters');
      if (filtersCookie) {
        try {
          var filters = JSON.parse(filtersCookie);

          if (filters.location !== undefined) {
            this.orders.location = filters.location || '';
          }
          if (filters.valid && Array.isArray(filters.valid) && filters.valid.length === 2) {
            this.orders.valid = filters.valid;
          }
          if (filters.valid_from) {
            this.valid_from = filters.valid_from;
          }
          if (filters.valid_to) {
            this.valid_to = filters.valid_to;
          }
          if (filters.methods && Array.isArray(filters.methods)) {
            this.orders.methods = filters.methods;
          }
          if (filters.search !== undefined) {
            this.orders.search = filters.search || '';
          }
          if (filters.selected_user !== undefined) {
            this.selected_user = filters.selected_user || '';
          }
          if (filters.selected_user_name !== undefined) {
            this.selected_user_name = filters.selected_user_name || '';
          }
          if (filters.selectedPosUser !== undefined) {
            this.selectedPosUser = filters.selectedPosUser || '';
          }
          if (filters.selected_order_from !== undefined) {
            this.selected_order_from = filters.selected_order_from || '';
          }
          if (filters.selected_payment_methods && Array.isArray(filters.selected_payment_methods)) {
            this.selected_payment_methods = filters.selected_payment_methods;
          }
          if (filters.unpaidOrdersFilter === 'all' || filters.unpaidOrdersFilter === 'paid' || filters.unpaidOrdersFilter === 'unpaid') {
            this.unpaidOrdersFilter = filters.unpaidOrdersFilter;
          }
          if (filters.selectedTable && filters.selectedTable.id != null) {
            this.selectedTable = {
              id: filters.selectedTable.id,
              label: filters.selectedTable.label || String(filters.selectedTable.id)
            };
          } else if (filters.selectedTable === null) {
            this.selectedTable = null;
          }
          if (filters.orderId !== undefined) {
            this.orderId = filters.orderId || null;
          }
          if (filters.zet !== undefined) {
            this.zet = filters.zet || null;
          }
          if (filters.selectedCategories && Array.isArray(filters.selectedCategories)) {
            this.selectedCategories = filters.selectedCategories;
          }
          if (filters.hasRceipt !== undefined) {
            this.hasRceipt = filters.hasRceipt || null;
          }
          if (filters.freeSearch !== undefined) {
            this.freeSearch = filters.freeSearch || '';
          }
          if (filters.selectedDriver !== undefined) {
            this.selectedDriver = filters.selectedDriver || '';
          }

          if (this.selected_user && this.selected_user !== '') {
            var userExists = this.users.find(function (u) {
              return String(u.id) === String(_this12.selected_user);
            });
            if (!userExists) {
              this.searchUsersById(this.selected_user);
            }
          }

          if (this.isReports) {
            this.$nextTick(function () {
              _this12.getOrders();
            });
          }
        } catch (e) {
          console.error('Error loading filters from cookie:', e);
        }
      } else {
        var filterCookie = this.$cookie.get('filter-locations');
        if (filterCookie) {
          try {
            var filterCookieParsed = JSON.parse(filterCookie);
            if (filterCookieParsed && filterCookieParsed[0]) {
              this.orders.location = filterCookieParsed[0];
            }
          } catch (e) {
            console.error('Error loading old filter-locations cookie:', e);
          }
        }
      }
    },
    clearFiltersCookie: function clearFiltersCookie() {
      this.$cookie.delete('sales-report-filters');
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(['']), 30);
    },
    daysBetween: function daysBetween(date1, date2) {
      var oneDay = 1000 * 60 * 60 * 24;
      var date1Ms = date1.getTime();
      var date2Ms = date2.getTime();
      var differenceMs = date2Ms - date1Ms;
      return Math.round(differenceMs / oneDay);
    },
    firstDayofMonth: function firstDayofMonth() {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      return firstDay;
    },
    lastDayofMonth: function lastDayofMonth() {
      var date = new Date();
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return lastDay;
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    tabClicked: function tabClicked(selectedTab) {},
    tabChanged: function tabChanged(selectedTab) {},
    getPosUsers: function getPosUsers() {
      var _this13 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this13.posUsers = response.data.pos_user;
        }
      });
    },
    getDrivers: function getDrivers() {
      var _this14 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/reports/drivers-list', 'GET', data, function (response) {
        if (response.status) {
          _this14.drivers = response.data.drivers || response.data || [];
        }
      });
    }
  }
});

/***/ }),

/***/ "dNLb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dRcJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersEdit_vue__ = __webpack_require__("slG6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fcdfdc3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersEdit_vue__ = __webpack_require__("QObC");
function injectStyle (ssrContext) {
  __webpack_require__("Lw9u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OffersEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fcdfdc3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OffersEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dTQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__ = __webpack_require__("Ark/");












/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */],
    SearchableMultiSelect: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a),
  props: {
    isCharismaReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isCharismaReport: {
      immediate: true,
      handler: function handler(val) {
        this.applyRouteFilters();
        this.getOrders({ page: this.paginationProps.currentPage || 1, pageSize: this.paginationProps.pageSize || 20 });
        this.verifyUserLocations();
        this.verifyUserMethods();
        this.initAdministrations();
      }
    }
  },
  created: function created() {
    this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest';
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      types: [{ id: null, name: this.$t('general.all') }, { id: 1, name: this.$t('charisma.charisma1') }, { id: 20, name: this.$t('charisma.charisma2') }, { id: 3, name: this.$t('charisma.charisma3') }, { id: 4, name: this.$t('charisma.charisma4') }],
      selectedType: null,
      documents: [{ id: null, name: this.$t('general.all') }, { id: 'bill', name: this.$t('charisma.bill') }, { id: 'invoice', name: this.$t('charisma.invoice') }],
      selectedDocument: null,
      selectedSeries: null,
      selectedNumber: null,
      administrations: [],
      selectedAdministration: null,
      selectedAdministrationIdFromRoute: null,
      selectedCategories: [],
      selectedTopCategories: [],
      rawPosUsers: [],
      ordersTableData: {},
      productsTableDataTotals: {},
      selectedPosUser: null,
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'day').format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total',
        currentPage: 1,
        pageSize: 20
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      noData: false,
      selectedOrderId: null,
      timezone: null
    };
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getOrders({
        page: this.paginationProps.currentPage || 1,
        pageSize: this.paginationProps.pageSize || 20
      });
    },
    applyRouteFilters: function applyRouteFilters() {
      var q = this.$route && this.$route.query ? this.$route.query : {};
      if (q.from && q.to) {
        this.orders.valid = [q.from, q.to];
      }
      if (q.timeFrom) this.valid_from = q.timeFrom;
      if (q.timeTo) this.valid_to = q.timeTo;
      if (q.location) this.orders.location = q.location;
      if (q.orderIdFilter) this.selectedOrderId = q.orderIdFilter;
      if (q.type !== undefined) {
        var typeId = Number(q.type);
        this.selectedType = this.types.find(function (t) {
          return t && t.id === typeId;
        }) || null;
      }
      if (q.document !== undefined) {
        this.selectedDocument = this.documents.find(function (d) {
          return d && d.id === q.document;
        }) || null;
      }
      if (q.series !== undefined) {
        this.selectedSeries = q.series;
      }
      if (q.number !== undefined) {
        this.selectedNumber = q.number ? Number(q.number) : null;
      }
      if (q.admin !== undefined) {
        var adminId = Number(q.admin);

        this.selectedAdministrationIdFromRoute = adminId;

        if (this.administrations && this.administrations.length > 0) {
          this.selectedAdministration = this.administrations.find(function (a) {
            return a && a.id === adminId;
          }) || null;
          this.selectedAdministrationIdFromRoute = null;
        }
      }
      if (q.page) this.paginationProps.currentPage = isNaN(q.page) ? q.page : Number(q.page);
      if (q.perPage) this.paginationProps.pageSize = isNaN(q.perPage) ? q.perPage : Number(q.perPage);
    },
    initAdministrations: function initAdministrations() {
      var _this = this;

      var sessionData = this.$session.get('selectedCompanyData') || {};
      if (sessionData['administrations']) {
        this.administrations = sessionData['administrations'];
        if (this.selectedAdministrationIdFromRoute && !this.selectedAdministration) {
          this.selectedAdministration = this.administrations.find(function (a) {
            return a && a.id === Number(_this.selectedAdministrationIdFromRoute);
          }) || null;
          this.selectedAdministrationIdFromRoute = null;
        }
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/administration', 'GET', data, function (response) {
        if (response && response.status && Array.isArray(response.data)) {
          _this.administrations = response.data;
          sessionData['administrations'] = response.data;
          _this.$session.set('selectedCompanyData', sessionData);
          if (_this.selectedAdministrationIdFromRoute && !_this.selectedAdministration) {
            _this.selectedAdministration = _this.administrations.find(function (a) {
              return a && a.id === Number(_this.selectedAdministrationIdFromRoute);
            }) || null;
            _this.selectedAdministrationIdFromRoute = null;
          }
        } else {
          _this.administrations = [];
        }
      });
    },
    goToItems: function goToItems(row) {
      var orderId = row.order_id || row.id;
      if (!orderId) {
        return;
      }
      var page = this.paginationProps.currentPage || 1;
      var perPage = this.paginationProps.pageSize || 20;
      var query = {
        tab: 'charisma',
        page: page,
        perPage: perPage,
        from: this.orders.valid[0],
        to: this.orders.valid[1],
        timeFrom: this.valid_from,
        timeTo: this.valid_to
      };
      if (this.orders.location) query.location = this.orders.location;
      if (this.selectedOrderId) query.orderIdFilter = this.selectedOrderId;
      if (this.selectedType) query.type = this.selectedType.id ? this.selectedType.id : this.selectedType;
      if (this.selectedDocument) query.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument;
      if (this.selectedSeries) query.series = this.selectedSeries;
      if (this.selectedNumber) query.number = this.selectedNumber;
      if (this.selectedAdministration) query.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration;
      this.$router.push({
        name: 'Charisma Items',
        params: { orderId: String(orderId) },
        query: query
      });
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page' || query.type === 'size' || query.type === 'sort') {
        var pageSize = query.pageSize || this.paginationProps.pageSize || 20;
        var page = query.page || this.paginationProps.currentPage || 1;
        var syncQuery = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query, {
          tab: 'charisma',
          page: page,
          perPage: pageSize,
          from: this.orders.valid[0],
          to: this.orders.valid[1],
          timeFrom: this.valid_from,
          timeTo: this.valid_to
        });
        if (this.orders.location) syncQuery.location = this.orders.location;
        if (this.selectedOrderId) syncQuery.orderIdFilter = this.selectedOrderId;
        if (this.selectedType) syncQuery.type = this.selectedType.id ? this.selectedType.id : this.selectedType;
        if (this.selectedDocument) syncQuery.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument;
        if (this.selectedSeries) syncQuery.series = this.selectedSeries;
        if (this.selectedNumber) syncQuery.number = this.selectedNumber;
        if (this.selectedAdministration) syncQuery.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration;
        this.$router.replace({ path: '/reports', query: syncQuery });
        this.getOrders(query);
      }
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this2 = this;

      if (!this.isCharismaReport) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from + ':00';
      var toDate = this.orders.valid[1] + ' ' + this.valid_to + ':00';

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.selectedOrderId) {
        data.order_id = this.selectedOrderId;
      }

      if (this.selectedType) {
        data.status = this.selectedType.id;
      }

      if (this.selectedDocument) {
        data.document = this.selectedDocument.id;
      }

      if (this.selectedSeries) {
        data.series = this.selectedSeries;
      }

      if (this.selectedNumber) {
        data.number = this.selectedNumber;
      }

      if (this.selectedAdministration) {
        data.administration_id = this.selectedAdministration.id;
      }

      this.loading = true;
      var pageSize = query && query.pageSize ? query.pageSize : this.paginationProps.pageSize || 20;
      var page = query && query.page ? query.page : this.paginationProps.currentPage || 1;

      this.apiRequest('/reports/v2/charisma' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          if (response.data.table_data.length) {
            _this2.ordersTableData.data = response.data.table_data;
            _this2.ordersTableData.total = response.pagination.total;
            _this2.paginationProps.currentPage = response.pagination.page;
            _this2.paginationProps.pageSize = response.pagination.perPage;
          } else {
            _this2.ordersTableData.data = [];
            _this2.ordersTableData.total = 0;
            _this2.paginationProps.currentPage = 1;
            _this2.paginationProps.pageSize = 20;
          }

          _this2.noData = false;
        } else {
          _this2.discounts = [];
          _this2.noData = true;

          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this2.$t('validations.wentWrong'), 'error');
        }

        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    sendAll: function sendAll() {
      var _this3 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: this.orders.valid[0],
        to_date: this.orders.valid[1]
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.selectedOrderId) {
        data.order_id = this.selectedOrderId;
      }

      if (this.selectedType) {
        data.status = this.selectedType.id;
      }

      if (this.selectedDocument) {
        data.document = this.selectedDocument.id;
      }

      if (this.selectedSeries) {
        data.series = this.selectedSeries;
      }

      if (this.selectedNumber) {
        data.number = this.selectedNumber;
      }

      if (this.selectedAdministration) {
        data.administration_id = this.selectedAdministration.id;
      }

      this.loading = true;

      this.apiRequest('/reports/v2/charisma/mark-orders', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', _this3.$t('charisma.sendAllMessage'), 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this3.$t('validations.wentWrong'), 'error');
        }

        _this3.$nextTick(function () {
          _this3.loading = false;
        });
      });
    },
    updateData: function updateData() {
      var syncQuery = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query, {
        tab: 'charisma',
        page: this.paginationProps.currentPage || 1,
        perPage: this.paginationProps.pageSize || 20,
        from: this.orders.valid[0],
        to: this.orders.valid[1],
        timeFrom: this.valid_from,
        timeTo: this.valid_to
      });
      if (this.orders.location) syncQuery.location = this.orders.location;
      if (this.selectedOrderId) syncQuery.orderIdFilter = this.selectedOrderId;
      if (this.selectedType) syncQuery.type = this.selectedType.id ? this.selectedType.id : this.selectedType;
      if (this.selectedDocument) syncQuery.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument;
      if (this.selectedSeries) syncQuery.series = this.selectedSeries;
      if (this.selectedNumber) syncQuery.number = this.selectedNumber;
      if (this.selectedAdministration) syncQuery.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration;
      this.$router.replace({ path: '/reports', query: syncQuery });
      this.getOrders({ page: syncQuery.page, pageSize: syncQuery.perPage });
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    }
  }
});

/***/ }),

/***/ "dVg1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dVmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaignsReport_vue__ = __webpack_require__("KWlb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_178d2851_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaignsReport_vue__ = __webpack_require__("o8kD");
function injectStyle (ssrContext) {
  __webpack_require__("0Gi9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-178d2851"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaignsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_178d2851_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaignsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dZc2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dZxm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "daN/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ddPp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementStocksEdit_vue__ = __webpack_require__("IuKo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bc7044_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementStocksEdit_vue__ = __webpack_require__("PAwV");
function injectStyle (ssrContext) {
  __webpack_require__("UgsK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17bc7044"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementStocksEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bc7044_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementStocksEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("OaMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81220d6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("Ma48");
function injectStyle (ssrContext) {
  __webpack_require__("39kX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81220d6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "deWJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonProduct_vue__ = __webpack_require__("YczL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4003f030_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonProduct_vue__ = __webpack_require__("8tlD");
function injectStyle (ssrContext) {
  __webpack_require__("qPUq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4003f030"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4003f030_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dfks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);




















__WEBPACK_IMPORTED_MODULE_11_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_13_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  props: {
    isRaffleCampaigns: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: true,
      idFilter: '',
      nameFilter: '',
      statusFilter: null,
      typeFilter: null,
      dateRangeFilter: [],
      tableData: [],
      exportingId: null,
      paginationDef: {
        page: 1,
        perPage: 25,
        totalRecords: 0
      }
    };
  },

  computed: {
    typeOptions: function typeOptions() {
      return [{ value: 'order_count', label: this.$t('raffleCampaigns.typeOrderCount') }, { value: 'order_total', label: this.$t('raffleCampaigns.typeOrderTotal') }];
    }
  },
  watch: {
    isRaffleCampaigns: function isRaffleCampaigns(active) {
      if (active) {
        this.getCampaigns();
      }
    }
  },
  created: function created() {
    this.getCampaigns();
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getCampaigns();
    },
    typeLabel: function typeLabel(type) {
      if (type === 'order_total') {
        return this.$t('raffleCampaigns.typeOrderTotal');
      }
      return this.$t('raffleCampaigns.typeOrderCount');
    },
    onRowClick: function onRowClick(row, column, event) {
      if (event.target.closest('.el-switch') || event.target.closest('.el-dropdown')) {
        return;
      }
      this.goToRecord(row);
    },
    goToRecord: function goToRecord(row) {
      this.$router.push({ path: '/marketing/raffle-campaigns/edit/' + row.id });
    },
    applyFilters: function applyFilters() {
      this.paginationDef.page = 1;
      this.getCampaigns();
    },
    handlePageChange: function handlePageChange(page) {
      this.paginationDef.page = page;
      this.getCampaigns();
    },
    normalizeActiveFilterValue: function normalizeActiveFilterValue(value) {
      var rawValue = value && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' && 'id' in value ? value.id : value;
      if (rawValue === true || rawValue === 1 || rawValue === '1') return true;
      if (rawValue === false || rawValue === 0 || rawValue === '0') return false;
      return null;
    },
    buildParams: function buildParams() {
      var params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.paginationDef.page,
        per_page: this.paginationDef.perPage
      };
      var id = String(this.idFilter || '').trim();
      if (id !== '') {
        params.id = id;
      }
      var name = String(this.nameFilter || '').trim();
      if (name !== '') {
        params.name = name;
      }
      var active = this.normalizeActiveFilterValue(this.statusFilter);
      if (active !== null) {
        params.active = active;
      }
      if (this.typeFilter) {
        params.type = this.typeFilter;
      }
      if (this.dateRangeFilter && this.dateRangeFilter.length === 2 && this.dateRangeFilter[0] && this.dateRangeFilter[1]) {
        params.start_date = this.dateRangeFilter[0];
        params.end_date = this.dateRangeFilter[1];
      }
      return params;
    },
    normalizeListResponse: function normalizeListResponse(response) {
      var payload = response.data || {};
      if (payload.pagination) {
        return {
          rows: payload.data || [],
          page: payload.pagination.page || this.paginationDef.page,
          perPage: payload.pagination.per_page || payload.pagination.perPage || this.paginationDef.perPage,
          total: payload.pagination.total || payload.pagination.totalRecords || 0
        };
      }
      if (response.pagination) {
        return {
          rows: Array.isArray(payload) ? payload : payload.data || [],
          page: response.pagination.page || this.paginationDef.page,
          perPage: response.pagination.per_page || response.pagination.perPage || this.paginationDef.perPage,
          total: response.pagination.total || response.pagination.totalRecords || 0
        };
      }
      if (Array.isArray(payload)) {
        return { rows: payload, page: 1, perPage: this.paginationDef.perPage, total: payload.length };
      }
      if (Array.isArray(payload.data)) {
        return { rows: payload.data, page: 1, perPage: this.paginationDef.perPage, total: payload.data.length };
      }
      return { rows: [], page: 1, perPage: this.paginationDef.perPage, total: 0 };
    },
    getCampaigns: function getCampaigns() {
      var _this = this;

      this.loading = true;
      this.apiRequest('/raffle-campaigns', 'GET', this.buildParams(), function (response) {
        if (response.status === true) {
          var normalized = _this.normalizeListResponse(response);
          _this.tableData = (normalized.rows || []).map(function (row) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, row, {
              active: !!(parseInt(row.active) === 1 || row.active === true)
            });
          });
          _this.paginationDef.page = normalized.page;
          _this.paginationDef.perPage = normalized.perPage;
          _this.paginationDef.totalRecords = normalized.total;
        } else {
          _this.tableData = [];
          _this.paginationDef.totalRecords = 0;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    rowClass: function rowClass(_ref) {
      var row = _ref.row;

      return row.active ? 'highlight-row' : '';
    },
    handleActive: function handleActive(index, row) {
      var _this2 = this;

      var actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + row.name + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this2.$session.get('token'),
            company_id: _this2.$session.get('selectedCompany'),
            active: row.active ? 1 : 0
          };
          _this2.apiRequest('/raffle-campaigns/' + row.id, 'PUT', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()(_this2.$t('general.success') + '!', '', 'success').catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error').catch(function () {});
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        row.active = !row.active;
      });
    },
    handleDelete: function handleDelete(index, row) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        text: this.$t('raffleCampaigns.areYouSureDelete') + ' ' + row.name + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this3.$session.get('token'),
            company_id: _this3.$session.get('selectedCompany')
          };
          _this3.apiRequest('/raffle-campaigns/' + row.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this3.$t('raffleCampaigns.campaignDeleted'), 'success').catch(function () {});
              _this3.tableData.splice(index, 1);
              _this3.paginationDef.totalRecords = Math.max(0, _this3.paginationDef.totalRecords - 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
    },
    exportEntries: function exportEntries(row) {
      var _this4 = this;

      if (!row || row.id == null || row.type !== 'order_count' || this.exportingId != null) return;
      this.exportingId = row.id;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/raffle-campaigns/' + row.id + '/export-entries', 'GET', data, function (response) {
        _this4.exportingId = null;
        if (response.status === true && response.data && response.data.file) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name || 'raffle-campaign-' + row.id + '-entries.txt');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    }
  }
});

/***/ }),

/***/ "djXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('product-options-form',{attrs:{"route":_vm.route,"kdsSectionsParent":_vm.kdsSections},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dkPp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row spinning-wheel-campaigns-page"},[_c('div',{staticClass:"col-md-12 col-lg-12"},[_c('div',{staticClass:"search-bar"},[_c('div',{staticClass:"col-sm-12 no-padding"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('reports.search')},model:{value:(_vm.filters[0].value),callback:function ($$v) {_vm.$set(_vm.filters[0], "value", $$v)},expression:"filters[0].value"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('pages.spinningWheelCampaigns'),"to":{ path: '/marketing/spinning-wheel-campaigns/add' }}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.add'))+"\n          ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"spinningWheelDataTables",staticClass:"width-table spinning-wheel-campaigns-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDef,"table-props":{ border: false },"filters":_vm.filters},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":70,"prop":"id","label":_vm.$t('customers.id')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":160,"prop":"title","label":_vm.$t('spinningWheel.campaignTitle')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":180,"label":_vm.$t('spinningWheel.availability')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatAvailabilityRange(props.row))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":120,"label":_vm.$t('spinningWheel.minOrderValue')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.minimum_order_value != null ? props.row.minimum_order_value : '—')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":100,"label":_vm.$t('spinningWheel.rewardsCount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.rewards_count != null ? props.row.rewards_count : (props.row.rewards ? props.row.rewards.length : 0))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":110,"label":_vm.$t('spinningWheel.percentages')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{class:props.row.percentages_valid ? 'text-success' : 'text-danger'},[_vm._v("\n                "+_vm._s(_vm.formatPercentage(props.row.percentage_sum))+"%\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":90,"label":_vm.$t('spinningWheel.active')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{attrs:{"value":!!props.row.active,"type":"success"},on:{"input":function (val) { return _vm.handleActive(props.row, val); }}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","width":120,"prop":"actions","label":_vm.$t('marketingCampaigns.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.editRecord(props.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.edit'))+"\n                  ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.handleDelete(props.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.delete'))+"\n                  ")])],1)],1)]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dkaT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  created: function created() {
    this.locations = this.$session.get('selectedCompanyData').locations_details || [];
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      tableData: [],
      search: '',
      searchId: '',
      selectedLocations: [],
      locations: []
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {

      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/pos/edit/');
      }
    },
    goToAdd: function goToAdd() {
      this.$router.push('/pos/add');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.searchId) {
        data.id = this.searchId;
      }
      if (this.search) {
        data.search = this.search;
      }
      if (Array.isArray(this.selectedLocations) && this.selectedLocations.length) {
        data.location_ids = this.selectedLocations;
      }

      this.apiRequest('/pos', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data.pos;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    searchPos: function searchPos() {
      this.getData();
    },
    handleDelete: function handleDelete(item) {
      var _this2 = this;

      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        text: this.$t('addOrder.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            id: item,
            token: _this2.$session.get('token'),
            company_id: _this2.$session.get('selectedCompany')
          };
          _this2.apiRequest('/pos/' + item, 'DELETE', data, function (response) {
            if (response.status === true) {
              _this2.trackAdminEvent('ADMIN_POS_DELETED', 'pos', item, {
                pos_id: item
              });
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this2.$t('general.success'), 'success');
              _this2.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : _this2.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function (err) {
        if (err) {}
      });
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.disableConfirmButton();
      var yes = this.$t('general.yes');
      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          if (__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton().textContent = yes + ' (' + btnCounter + ')';
          }
        } else {
          if (__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton().textContent = yes;
          }
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    }
  }
});

/***/ }),

/***/ "dmRH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dmW6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountingSales_vue__ = __webpack_require__("jPN6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74f71723_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountingSales_vue__ = __webpack_require__("uFkR");
function injectStyle (ssrContext) {
  __webpack_require__("xzfl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74f71723"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountingSales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74f71723_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountingSales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dnM/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CharismaLocationReceipt',
  components: {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  },
  props: {
    isCharismaLocationReceiptReport: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      locationReceipts: [],
      hasLoadedOnce: false
    };
  },

  watch: {
    isCharismaLocationReceiptReport: {
      immediate: true,
      handler: function handler(val) {
        if (val && (!this.hasLoadedOnce || !this.locationReceipts.length)) {
          this.fetchLocationReceipts();
        }
      }
    }
  },
  methods: {
    fetchLocationReceipts: function fetchLocationReceipts() {
      var _this = this;

      if (!this.isCharismaLocationReceiptReport) {
        return;
      }
      this.loading = true;
      var payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/reports/v2/charisma/location-receipts', 'GET', payload, function (response) {
        if (response && response.status) {
          _this.locationReceipts = Array.isArray(response.data) ? response.data : [];
          _this.hasLoadedOnce = true;
        } else {
          _this.locationReceipts = [];
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()('', response && response.errors && response.errors.id ? response.errors.id : _this.$t('validations.wentWrong'), 'error');
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    goToLocationReceipt: function goToLocationReceipt(row) {
      if (!row || !row.id) {
        return;
      }
      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query, {
        tab: 'charismaLocationReceipt',
        locationName: row.name || '',
        partnerCode: row.partner_code || '',
        administrationName: row.administration && row.administration.name ? row.administration.name : ''
      });
      this.$router.push({ path: '/reports/charisma/location-receipts/' + row.id, query: query });
    }
  }
});

/***/ }),

/***/ "doqb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Management_Pricelist_PricelistFieldsForm_vue__ = __webpack_require__("nl7c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Integrations_WoltIntegrationForm_vue__ = __webpack_require__("aVMA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Integrations_WoltDriveIntegrationForm_vue__ = __webpack_require__("VamX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__ = __webpack_require__("fff3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Integrations_DeliveryHeroIntegrationForm_vue__ = __webpack_require__("Odsf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Integrations_GlovoLaasIntegrationForm_vue__ = __webpack_require__("jAxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Integrations_GlovoIntegrationForm_vue__ = __webpack_require__("qhBy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Integrations_MenuPreview_IntegrationMenuPreviewModal_vue__ = __webpack_require__("awm+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Integrations_PlatformMenuImports_PlatformMenuImportLink_vue__ = __webpack_require__("KWii");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__IntegrationMenuTopCategoriesField_vue__ = __webpack_require__("y6bk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__IntegrationScheduleEditor_vue__ = __webpack_require__("pxe/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MarketplaceOrderSettings_vue__ = __webpack_require__("MYzf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Integrations_IntegrationMenuValidationCollapse_vue__ = __webpack_require__("5Nb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__ = __webpack_require__("Bef2");
























/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntegrationForm',
  components: {
    PricelistFieldsForm: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Management_Pricelist_PricelistFieldsForm_vue__["a" /* default */],
    WoltIntegrationForm: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Integrations_WoltIntegrationForm_vue__["f" /* default */],
    WoltDriveIntegrationForm: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Integrations_WoltDriveIntegrationForm_vue__["d" /* default */],
    BoltIntegrationForm: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["g" /* default */],
    DeliveryHeroIntegrationForm: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Integrations_DeliveryHeroIntegrationForm_vue__["b" /* default */],
    GlovoLaasIntegrationForm: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Integrations_GlovoLaasIntegrationForm_vue__["c" /* default */],
    GlovoIntegrationForm: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Integrations_GlovoIntegrationForm_vue__["a" /* default */],
    IntegrationMenuPreviewModal: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Integrations_MenuPreview_IntegrationMenuPreviewModal_vue__["a" /* default */],
    PlatformMenuImportLink: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Integrations_PlatformMenuImports_PlatformMenuImportLink_vue__["a" /* default */],
    IntegrationMenuTopCategoriesField: __WEBPACK_IMPORTED_MODULE_13__IntegrationMenuTopCategoriesField_vue__["a" /* default */],
    IntegrationScheduleEditor: __WEBPACK_IMPORTED_MODULE_14__IntegrationScheduleEditor_vue__["a" /* default */],
    MarketplaceOrderSettings: __WEBPACK_IMPORTED_MODULE_15__MarketplaceOrderSettings_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    busy: {
      type: Boolean,
      default: false
    },
    saveDisabled: {
      type: Boolean,
      default: false
    },
    fieldNames: {
      type: Array,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    formText: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    booleanFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    jsonFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    jsonHint: {
      type: String,
      default: ''
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    readOnlyFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    integrationType: {
      type: String,
      default: ''
    },
    locations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    woltRequiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    woltValidationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    woltDriveRequiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    woltDriveValidationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    deliveryHeroRequiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    deliveryHeroCredentialFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    deliveryHeroValidationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    regeneratingDeliveryHeroKeys: {
      type: Boolean,
      default: false
    },
    boltRequiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    boltValidationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    glovoLaasRequiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    glovoLaasValidationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    glovoRequiredFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    glovoValidationErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canValidate: {
      type: Boolean,
      default: false
    },
    validateDisabled: {
      type: Boolean,
      default: false
    },
    occupiedLocationIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isCreateMode: {
      type: Boolean,
      default: false
    },
    webhookRegistered: {
      type: Boolean,
      default: false
    },
    topCategories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showFieldValidation: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      acceptOrdersStatus: false,
      actionBusy: false,
      glovoTransactionId: null,
      trackedGlovoIntegrationId: null,
      credentialsFlowMode: 'activate',
      activationSteps: {
        save: { status: 'pending', message: '' },
        test: { status: 'pending', message: '' },
        webhook: { status: 'pending', message: '' }
      },
      menuValidationMounts: [],
      menuPreviewVisible: false,
      menuPreviewBusy: false,
      menuPreviewImporting: false,
      menuPreviewLayout: 'wolt',
      menuPreviewCurrency: 'RON',
      menuPreviewWarnings: [],
      menuPreviewCategories: [],
      menuPreviewError: '',
      menuPreviewTitle: '',
      menuPreviewSubtitle: ''
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyMenuValidationMounts();
  },

  computed: {
    isMarketplaceIntegration: function isMarketplaceIntegration() {
      return this.isWoltIntegration || this.isBoltIntegration || this.isGlovoIntegration;
    },
    isWoltIntegration: function isWoltIntegration() {
      return String(this.integrationType || '').toLowerCase() === 'wolt';
    },
    isWoltDriveIntegration: function isWoltDriveIntegration() {
      return String(this.integrationType || '').toLowerCase() === 'wolt_drive';
    },
    isDeliveryHeroIntegration: function isDeliveryHeroIntegration() {
      return String(this.integrationType || '').toLowerCase() === 'delivery_hero';
    },
    isBoltIntegration: function isBoltIntegration() {
      return String(this.integrationType || '').toLowerCase() === 'bolt';
    },
    isGlovoLaasIntegration: function isGlovoLaasIntegration() {
      return String(this.integrationType || '').toLowerCase() === 'glovo_laas';
    },
    isGlovoIntegration: function isGlovoIntegration() {
      return String(this.integrationType || '').toLowerCase() === 'glovo';
    },
    showIntegrationOtherSettings: function showIntegrationOtherSettings() {
      return this.isGlovoIntegration || this.isWoltIntegration || this.isBoltIntegration;
    },
    showMenuLocationOtherSetting: function showMenuLocationOtherSetting() {
      return this.isGlovoIntegration || this.isWoltIntegration || this.isBoltIntegration;
    },
    showIntegrationActions: function showIntegrationActions() {
      if (!this.formData || !this.formData.id || !this.formData.location_id) return false;
      return this.isGlovoIntegration || this.isWoltIntegration || this.isBoltIntegration;
    },
    showFormLoader: function showFormLoader() {
      return this.busy || this.actionBusy;
    },
    showScheduleAction: function showScheduleAction() {
      return this.showIntegrationActions && (this.isWoltIntegration || this.isBoltIntegration);
    },
    integrationRecordId: function integrationRecordId() {
      if (!this.formData) return null;
      var id = this.formData.id != null ? this.formData.id : this.formData._id;
      return id != null && id !== '' ? id : null;
    },
    showDeleteButton: function showDeleteButton() {
      return this.canDelete && this.integrationRecordId != null;
    },
    showValidateButton: function showValidateButton() {
      return this.canValidate && this.integrationRecordId != null && (this.isGlovoLaasIntegration || this.isWoltDriveIntegration || this.isDeliveryHeroIntegration);
    },
    showActivateButton: function showActivateButton() {
      return !this.isCreateMode && this.integrationRecordId != null && (this.isGlovoIntegration || this.isWoltIntegration || this.isBoltIntegration);
    },
    activateDisabled: function activateDisabled() {
      return this.saveDisabled;
    },
    useActivateFlow: function useActivateFlow() {
      return this.isCreateMode && (this.isGlovoLaasIntegration || this.isWoltDriveIntegration);
    },
    isWebhookCapableIntegration: function isWebhookCapableIntegration() {
      return this.isGlovoLaasIntegration || this.isWoltDriveIntegration;
    },
    showWebhookStatus: function showWebhookStatus() {
      return this.isWebhookCapableIntegration && !this.isCreateMode && this.integrationRecordId != null;
    },
    shouldIncludeWebhookStep: function shouldIncludeWebhookStep() {
      if (!this.isWebhookCapableIntegration) return false;

      if (this.credentialsFlowMode === 'validate') {
        return !this.webhookRegistered;
      }
      return true;
    },
    saveButtonLabel: function saveButtonLabel() {
      return this.useActivateFlow ? this.$t('general.activate') : this.$t('general.save');
    },
    saveButtonTitle: function saveButtonTitle() {
      return this.useActivateFlow ? this.$t('general.activate') : this.$t('general.save');
    },
    glovoMenuExportsToday: function glovoMenuExportsToday() {
      if (!this.formData || this.formData.menu_exports_today == null) return 0;
      return this.formData.menu_exports_today;
    },
    glovoLastMenuExport: function glovoLastMenuExport() {
      return this.formData && this.formData.last_menu_export ? this.formData.last_menu_export : null;
    },
    glovoLastExportLabel: function glovoLastExportLabel() {
      var exportRow = this.glovoLastMenuExport;
      if (!exportRow) {
        return this.$t('gestiune.integrationsGlovoNoExport');
      }
      var dateValue = this.resolveGlovoExportDateValue(exportRow);
      if (!dateValue) {
        return this.$t('gestiune.integrationsGlovoNoExport');
      }
      return this.formatDateTime(dateValue);
    },
    glovoLastExportStatus: function glovoLastExportStatus() {
      var exportRow = this.glovoLastMenuExport;
      if (!exportRow) return '';
      if (exportRow.export_status) return exportRow.export_status;
      if (exportRow.is_successful === null || exportRow.is_successful === undefined) {
        return this.$t('gestiune.integrationsGlovoExportPending');
      }
      return '';
    },
    glovoLastExportDetails: function glovoLastExportDetails() {
      var exportRow = this.glovoLastMenuExport;
      var details = exportRow && exportRow.provider_response && exportRow.provider_response.details;
      return Array.isArray(details) ? details : [];
    },
    glovoExportStatusBadge: function glovoExportStatusBadge() {
      var exportRow = this.glovoLastMenuExport;
      if (!exportRow) return null;
      if (exportRow.is_successful === true) {
        return { type: 'success', label: this.$t('gestiune.integrationsGlovoExportSuccess') };
      }
      if (exportRow.is_successful === false) {
        return { type: 'error', label: this.$t('gestiune.integrationsGlovoExportFailed') };
      }
      if (exportRow.export_status == null || exportRow.export_status === '') {
        return { type: 'pending', label: this.$t('gestiune.integrationsGlovoExportPending') };
      }
      return { type: 'pending', label: this.$t('gestiune.integrationsGlovoExportInProgress') };
    },
    canCheckGlovoExportStatus: function canCheckGlovoExportStatus() {
      if (this.glovoTransactionId) return true;
      var exportRow = this.glovoLastMenuExport;
      return Boolean(exportRow && exportRow.transaction_id);
    }
  },
  watch: {
    formData: {
      deep: true,
      immediate: true,
      handler: function handler(data) {
        if (!data) return;
        if (this.isGlovoIntegration) {
          if (this.trackedGlovoIntegrationId !== data.id) {
            this.trackedGlovoIntegrationId = data.id;
            this.glovoTransactionId = null;
          }
          this.acceptOrdersStatus = Boolean(data.store_active);
          var tx = data.last_menu_export && data.last_menu_export.transaction_id;
          if (tx) {
            this.glovoTransactionId = tx;
          }
        } else if (this.isWoltIntegration || this.isBoltIntegration) {
          this.acceptOrdersStatus = Boolean(data.active);
        }
      }
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      if (this.saveDisabled || this.actionBusy) return;
      if (this.useActivateFlow) {
        this.startActivationFlow();
        return;
      }
      this.$emit('save');
    },
    resetActivationSteps: function resetActivationSteps() {
      var steps = {};
      this.getActivationFlowConfig().steps.forEach(function (step) {
        steps[step.id] = { status: 'pending', message: '', validationGroups: [] };
      });
      this.activationSteps = steps;
    },
    getGlovoActivateFlowConfig: function getGlovoActivateFlowConfig() {
      return {
        title: this.$t('gestiune.integrationsGlovoActivateTitle'),
        confirm: this.$t('gestiune.integrationsGlovoActivateConfirm'),
        stay: this.$t('gestiune.integrationsGlovoActivateProgressStay'),
        steps: [{
          id: 'save',
          label: this.isCreateMode ? this.$t('gestiune.integrationsGlovoActivateStepSave') : this.$t('gestiune.integrationsValidateStepSave')
        }, { id: 'validateMenu', label: this.$t('gestiune.integrationsGlovoActivateStepValidateMenu') }, { id: 'deactivateLocation', label: this.$t('gestiune.integrationsGlovoActivateStepDeactivateLocation') }, { id: 'pushMenu', label: this.$t('gestiune.integrationsGlovoActivateStepPushMenu') }, { id: 'checkExportStatus', label: this.$t('gestiune.integrationsGlovoActivateStepCheckExportStatus') }, { id: 'activateLocation', label: this.$t('gestiune.integrationsGlovoActivateStepActivateLocation') }]
      };
    },
    getWoltBoltActivateFlowConfig: function getWoltBoltActivateFlowConfig() {
      return {
        title: this.$t('gestiune.integrationsActivateTitle'),
        confirm: this.$t('gestiune.integrationsMenuActivateConfirm'),
        stay: this.$t('gestiune.integrationsActivateProgressStay'),
        steps: [{
          id: 'save',
          label: this.isCreateMode ? this.$t('gestiune.integrationsActivateStepSave') : this.$t('gestiune.integrationsValidateStepSave')
        }, { id: 'validateMenu', label: this.$t('gestiune.integrationsMenuActivateStepValidateMenu') }, { id: 'deactivateLocation', label: this.$t('gestiune.integrationsMenuActivateStepDeactivateLocation') }, { id: 'pushMenu', label: this.$t('gestiune.integrationsMenuActivateStepPushMenu') }, { id: 'activateLocation', label: this.$t('gestiune.integrationsMenuActivateStepActivateLocation') }]
      };
    },
    getActivationFlowConfig: function getActivationFlowConfig() {
      if (this.credentialsFlowMode === 'activate' && this.isGlovoIntegration) {
        return this.getGlovoActivateFlowConfig();
      }
      if (this.credentialsFlowMode === 'activate' && (this.isWoltIntegration || this.isBoltIntegration)) {
        return this.getWoltBoltActivateFlowConfig();
      }
      return this.getCredentialsFlowConfig();
    },
    getCredentialsFlowConfig: function getCredentialsFlowConfig() {
      if (this.credentialsFlowMode === 'validate') {
        var _steps = [{ id: 'save', label: this.$t('gestiune.integrationsValidateStepSave') }, { id: 'test', label: this.$t('gestiune.integrationsValidateStepTest') }];
        if (this.shouldIncludeWebhookStep) {
          _steps.push({ id: 'webhook', label: this.$t('gestiune.integrationsValidateStepWebhook') });
        }
        return {
          title: this.$t('gestiune.integrationsValidateTitle'),
          confirm: this.$t('gestiune.integrationsValidateConfirm'),
          stay: this.$t('gestiune.integrationsValidateProgressStay'),
          steps: _steps
        };
      }
      var steps = [{ id: 'save', label: this.$t('gestiune.integrationsActivateStepSave') }, { id: 'test', label: this.$t('gestiune.integrationsActivateStepTest') }];
      if (this.shouldIncludeWebhookStep) {
        steps.push({ id: 'webhook', label: this.$t('gestiune.integrationsActivateStepWebhook') });
      }
      return {
        title: this.$t('gestiune.integrationsActivateTitle'),
        confirm: this.$t('gestiune.integrationsActivateConfirm'),
        stay: this.$t('gestiune.integrationsActivateProgressStay'),
        steps: steps
      };
    },
    escapeHtml: function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    activationStepIconHtml: function activationStepIconHtml(status) {
      if (status === 'running') {
        return '<span class="integration-activation-step__icon integration-activation-step__icon--running" aria-hidden="true"></span>';
      }
      if (status === 'success') {
        return '<span class="integration-activation-step__icon integration-activation-step__icon--success" aria-hidden="true">✓</span>';
      }
      if (status === 'error') {
        return '<span class="integration-activation-step__icon integration-activation-step__icon--error" aria-hidden="true">✕</span>';
      }
      return '<span class="integration-activation-step__icon integration-activation-step__icon--pending" aria-hidden="true"></span>';
    },
    buildActivationProgressHtml: function buildActivationProgressHtml() {
      var _this = this;

      var config = this.getActivationFlowConfig();
      var rows = config.steps.map(function (step) {
        var state = _this.activationSteps[step.id] || { status: 'pending', message: '', validationGroups: [] };
        var messageClass = state.status === 'running' ? 'integration-activation-step__progress' : 'integration-activation-step__error';
        var detailsHtml = '';
        if (state.message) {
          detailsHtml += '<div class="' + messageClass + '">' + _this.escapeHtml(state.message) + '</div>';
        }
        if (state.validationGroups && state.validationGroups.length) {
          detailsHtml += '<div class="integration-activation-step__details" data-menu-validation-mount="' + _this.escapeHtml(step.id) + '"></div>';
        }
        return '<li class="integration-activation-step integration-activation-step--' + _this.escapeHtml(state.status) + '">' + '<div class="integration-activation-step__row">' + _this.activationStepIconHtml(state.status) + ('<span class="integration-activation-step__label">' + _this.escapeHtml(step.label) + '</span>') + ('</div>' + detailsHtml + '</li>');
      }).join('');
      return '<p class="integration-activation-stay">' + this.escapeHtml(config.stay) + '</p>' + ('<ul class="integration-activation-steps">' + rows + '</ul>');
    },
    destroyMenuValidationMounts: function destroyMenuValidationMounts() {
      if (!Array.isArray(this.menuValidationMounts)) {
        this.menuValidationMounts = [];
        return;
      }
      this.menuValidationMounts.forEach(function (vm) {
        if (vm && typeof vm.$destroy === 'function') {
          vm.$destroy();
        }
      });
      this.menuValidationMounts = [];
    },
    mountMenuValidationCollapse: function mountMenuValidationCollapse(mountEl, groups) {
      var _this2 = this;

      if (!mountEl || !Array.isArray(groups) || !groups.length) return null;
      var Constructor = __WEBPACK_IMPORTED_MODULE_18_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Integrations_IntegrationMenuValidationCollapse_vue__["a" /* default */]);
      var vm = new Constructor({
        parent: this,
        propsData: {
          groups: groups,
          onEditEntry: function onEditEntry(target) {
            return _this2.openMenuValidationEntity(target);
          }
        }
      });
      vm.$mount(mountEl);
      this.menuValidationMounts.push(vm);
      return vm;
    },
    openMenuValidationEntity: function openMenuValidationEntity(target) {
      var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["g" /* getMenuValidationEntityEditPath */])(target);
      if (!path) return;
      var resolved = this.$router.resolve(path);
      var href = resolved.href || '/#' + path;
      window.open(href, '_blank');
    },
    mountActivationValidationCollapses: function mountActivationValidationCollapses() {
      var _this3 = this;

      var container = document.querySelector('.integration-activation-swal .swal2-content');
      if (!container) return;
      container.querySelectorAll('[data-menu-validation-mount]').forEach(function (mountEl) {
        var stepId = mountEl.getAttribute('data-menu-validation-mount');
        var state = _this3.activationSteps[stepId];
        if (!state || !Array.isArray(state.validationGroups) || !state.validationGroups.length) return;
        _this3.mountMenuValidationCollapse(mountEl, state.validationGroups);
      });
    },
    refreshActivationProgressModal: function refreshActivationProgressModal() {
      var _this4 = this;

      this.destroyMenuValidationMounts();
      var container = document.querySelector('.integration-activation-swal .swal2-content');
      if (container) {
        container.innerHTML = this.buildActivationProgressHtml();
        this.$nextTick(function () {
          return _this4.mountActivationValidationCollapses();
        });
      }
    },
    updateActivationStep: function updateActivationStep(stepId, status, message, validationGroups) {
      var _this5 = this;

      if (!this.activationSteps[stepId]) return;
      this.$set(this.activationSteps, stepId, {
        status: status || 'pending',
        message: message || '',
        validationGroups: Array.isArray(validationGroups) ? validationGroups : []
      });
      this.$nextTick(function () {
        return _this5.refreshActivationProgressModal();
      });
    },
    openActivationProgressModal: function openActivationProgressModal() {
      var _this6 = this;

      var resetSteps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (resetSteps) this.resetActivationSteps();
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        title: this.getActivationFlowConfig().title,
        html: this.buildActivationProgressHtml(),
        showConfirmButton: false,
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'integration-activation-swal',
        onOpen: function onOpen() {
          _this6.$nextTick(function () {
            return _this6.mountActivationValidationCollapses();
          });
        }
      }).catch(function () {});
    },
    finishActivationModal: function finishActivationModal(success, onClosed) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        title: this.getActivationFlowConfig().title,
        html: this.buildActivationProgressHtml(),
        showConfirmButton: true,
        confirmButtonText: this.$t('general.ok'),
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'integration-activation-swal',
        onOpen: function onOpen() {
          _this7.$nextTick(function () {
            return _this7.mountActivationValidationCollapses();
          });
        },
        onClose: function onClose() {
          _this7.destroyMenuValidationMounts();
        }
      }).then(function (result) {
        if (result && typeof onClosed === 'function') {
          onClosed({ success: Boolean(success) });
        }
      }).catch(function () {});
    },
    confirmMenuValidationOverride: function confirmMenuValidationOverride(response) {
      var _this8 = this;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["h" /* canProceedWithMenuValidation */])(response, function (key) {
        return _this8.$t(key);
      })) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(false);
      }
      var groups = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["e" /* extractMenuValidationGroups */])(response, function (key) {
        return _this8.$t(key);
      });
      this.updateActivationStep('validateMenu', 'error', this.$t('gestiune.integrationsMenuValidationProceedAnywayHint'), groups);
      return __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        title: this.getActivationFlowConfig().title,
        html: this.buildActivationProgressHtml(),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('gestiune.integrationsMenuValidationProceedAnyway'),
        cancelButtonText: this.$t('general.cancel2'),
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'integration-activation-swal',
        onOpen: function onOpen() {
          return _this8.$nextTick(function () {
            return _this8.mountActivationValidationCollapses();
          });
        },
        onClose: function onClose() {
          return _this8.destroyMenuValidationMounts();
        }
      }).then(function (result) {
        if (result) _this8.openActivationProgressModal(false);
        return Boolean(result);
      }).catch(function () {
        return false;
      });
    },
    startCredentialsFlow: function startCredentialsFlow(mode, eventName, finishedEventName) {
      var _this9 = this;

      this.credentialsFlowMode = mode;
      var config = this.getActivationFlowConfig();
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        text: config.confirm,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.cancel2')
      }).then(function (result) {
        if (!result) return;
        _this9.openActivationProgressModal();
        _this9.$emit(eventName, {
          updateStep: _this9.updateActivationStep,
          confirmMenuValidationOverride: _this9.confirmMenuValidationOverride,
          finish: function finish(success) {
            _this9.finishActivationModal(success, function (payload) {
              _this9.$emit(finishedEventName, payload);
            });
          }
        });
      }).catch(function () {});
    },
    startActivationFlow: function startActivationFlow() {
      if (this.activateDisabled || this.actionBusy) return;
      this.startCredentialsFlow('activate', 'activate', 'activation-finished');
    },
    startValidationFlow: function startValidationFlow() {
      if (this.validateDisabled || this.busy || this.disabled || this.actionBusy) return;
      this.startCredentialsFlow('validate', 'validate', 'validation-finished');
    },
    onDeleteClick: function onDeleteClick() {
      if (this.busy || this.disabled || this.actionBusy) return;
      this.$emit('delete');
    },
    buildIntegrationActionPayload: function buildIntegrationActionPayload() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_id: this.formData.location_id
      };
    },
    getApiResponseMessage: function getApiResponseMessage(response) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["a" /* extractApiResponseMessage */])(response);
    },
    resolveGlovoExportDateValue: function resolveGlovoExportDateValue(exportRow) {
      if (!exportRow || (typeof exportRow === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(exportRow)) !== 'object') return null;
      var candidates = [exportRow.created_at, exportRow.last_status_update];
      for (var i = 0; i < candidates.length; i += 1) {
        var value = candidates[i];
        if (typeof value === 'string' && value.trim()) return value.trim();
      }
      return null;
    },
    isExportTransactionNotFoundResponse: function isExportTransactionNotFoundResponse(response) {
      var message = this.getApiResponseMessage(response).toLowerCase();
      return message.includes('transaction not found') || message.includes('no export transaction');
    },
    isMenuNotFoundResponse: function isMenuNotFoundResponse(response) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["b" /* isMenuNotFoundResponse */])(response);
    },
    getIntegrationActionErrorMessage: function getIntegrationActionErrorMessage(response, action) {
      var _this10 = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["c" /* getIntegrationActionErrorMessage */])(response, this.integrationType, action, function (key) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return _this10.$t.apply(_this10, [key].concat(args));
      });
    },
    formatGlovoApiFeedback: function formatGlovoApiFeedback(response) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'generic';

      if (!response) return this.$t('gestiune.integrationsActionError');
      var message = this.getIntegrationActionErrorMessage(response, action);
      if (message) return message;
      return this.$t('gestiune.integrationsActionError');
    },
    extractGlovoTransactionId: function extractGlovoTransactionId(response) {
      if (!response || !response.data) return null;
      var data = response.data.data || response.data;
      return data.transaction_id || data.provider_response && data.provider_response.transaction_id || null;
    },
    showIntegrationActionSuccess: function showIntegrationActionSuccess(text) {
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        text: text || this.$t('bolt.sync'),
        type: 'success',
        showConfirmButton: false
      }).catch(function () {});
    },
    showIntegrationActionError: function showIntegrationActionError(text) {
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        text: text || this.$t('bolt.syncError'),
        type: 'error',
        showConfirmButton: false
      }).catch(function () {});
    },
    formatGlovoDetailsText: function formatGlovoDetailsText(value) {
      if (value == null || value === '') return '';
      if (typeof value === 'string') return value;
      try {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value, null, 2);
      } catch (e) {
        return String(value);
      }
    },
    showGlovoValidationSwal: function showGlovoValidationSwal(response, success) {
      var _this11 = this;

      var fromPreview = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var menuNotFound = !success && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["b" /* isMenuNotFoundResponse */])(response);
      var groups = menuNotFound ? [] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["e" /* extractMenuValidationGroups */])(response, function (key) {
        return _this11.$t(key);
      });
      var summary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["i" /* getMenuValidationSummary */])(response, success, function (key) {
        return _this11.$t(key);
      }, menuNotFound);
      var summaryHtml = summary ? '<p class="integration-glovo-swal__summary">' + this.escapeHtml(summary) + '</p>' : '';
      var mountId = 'menu-validation-swal-mount-' + Date.now();
      var canProceed = !success && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["h" /* canProceedWithMenuValidation */])(response, function (key) {
        return _this11.$t(key);
      });
      var proceedId = mountId + '-proceed';
      var proceedHtml = canProceed ? '<p>' + this.escapeHtml(this.$t('gestiune.integrationsMenuValidationProceedAnywayHint')) + '</p>' + ('<button type="button" id="' + proceedId + '" class="btn btn-warning">') + (this.escapeHtml(this.$t('gestiune.integrationsMenuValidationProceedAnyway')) + '</button>') : '';
      var proceeded = false;

      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        title: success ? this.$t('gestiune.integrationsGlovoValidateSuccessTitle') : this.$t('gestiune.integrationsGlovoValidationFailedTitle'),
        html: summaryHtml + '<div id="' + mountId + '"></div>' + proceedHtml,
        type: success ? 'success' : 'error',
        showCancelButton: !success,
        confirmButtonText: success ? this.$t('general.ok') : this.$t('gestiune.integrationsMenuValidationTryAgain'),
        cancelButtonText: this.$t('general.ok'),
        allowOutsideClick: success,
        customClass: 'integration-glovo-swal',
        onOpen: function onOpen() {
          var mountEl = document.getElementById(mountId);
          if (mountEl && groups.length) {
            _this11.mountMenuValidationCollapse(mountEl, groups);
          }
          var proceedButton = canProceed && document.getElementById(proceedId);
          if (proceedButton) {
            proceedButton.addEventListener('click', function () {
              if (proceeded) return;
              proceeded = true;
              proceedButton.disabled = true;
              __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default.a.close();
              _this11.validateAndPushMenu(true, fromPreview);
            });
          }
        },
        onClose: function onClose() {
          _this11.destroyMenuValidationMounts();
        }
      }).then(function (result) {
        if (!success && result && !proceeded) {
          _this11.validateAndPushMenu(false, fromPreview);
        }
      }).catch(function () {});
    },
    refreshIntegrationData: function refreshIntegrationData() {
      this.$emit('refresh');
    },
    buildGenericMenuValidatePayload: function buildGenericMenuValidatePayload() {
      var payload = this.buildIntegrationActionPayload();
      payload.integration = String(this.integrationType || '').toLowerCase();
      return payload;
    },
    requestMenuValidation: function requestMenuValidation(callback) {
      if (this.isGlovoIntegration) {
        var payload = this.buildIntegrationActionPayload();
        payload.glovo_company_id = this.formData.id;
        this.apiRequest('/glovo/menu/validate', 'POST', payload, callback);
        return;
      }
      if (this.isWoltIntegration || this.isBoltIntegration) {
        this.apiRequest('/integrations/menu/validate', 'POST', this.buildGenericMenuValidatePayload(), callback);
        return;
      }
      if (typeof callback === 'function') callback(null);
    },
    isMenuValidationPassed: function isMenuValidationPassed(response) {
      var _this12 = this;

      var fromPreview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var menuNotFound = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["b" /* isMenuNotFoundResponse */])(response);
      if (menuNotFound) {
        this.showGlovoValidationSwal({
          status: false,
          errors: [{
            code: 'MENU_EMPTY',
            message: this.$t('gestiune.integrationsGlovoMenuEmpty')
          }]
        }, false, fromPreview);
        return false;
      }
      var success = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["f" /* isMenuValidationSuccessful */])(response, function (key) {
        return _this12.$t(key);
      }, menuNotFound);
      if (!success) {
        this.showGlovoValidationSwal(response, false, fromPreview);
        return false;
      }
      return true;
    },
    openMenuPreview: function openMenuPreview() {
      var _this13 = this;

      if (!this.showIntegrationActions || this.actionBusy || this.menuPreviewBusy) return;

      this.menuPreviewVisible = true;
      this.menuPreviewBusy = true;
      this.menuPreviewError = '';
      this.menuPreviewWarnings = [];
      this.menuPreviewCategories = [];
      this.menuPreviewLayout = String(this.integrationType || 'wolt').toLowerCase();
      this.menuPreviewTitle = this.$t('gestiune.integrationsMenuPreviewTitle', {
        platform: String(this.integrationType || '').toUpperCase()
      });
      this.menuPreviewSubtitle = this.$t('gestiune.integrationsMenuPreviewSubtitle');

      var payload = this.buildIntegrationActionPayload();
      payload.integration = this.menuPreviewLayout;
      payload.id = this.formData.id;

      this.apiRequest('/integrations/menu/preview', 'POST', payload, function (response) {
        _this13.menuPreviewBusy = false;
        if (response && response.status && response.data) {
          var data = response.data.data || response.data;
          _this13.menuPreviewLayout = data.layout || _this13.menuPreviewLayout;
          _this13.menuPreviewCurrency = data.currency || 'RON';
          _this13.menuPreviewWarnings = data.warnings || [];
          _this13.menuPreviewCategories = data.display && data.display.categories || [];
          if (!_this13.menuPreviewCategories.length) {
            _this13.menuPreviewError = _this13.$t('gestiune.integrationsGlovoMenuEmpty');
          }
        } else {
          var msg = _this13.getApiResponseMessage(response);
          _this13.menuPreviewError = msg || _this13.$t('gestiune.integrationsGlovoMenuEmpty');
        }
      });
    },
    closeMenuPreview: function closeMenuPreview() {
      if (this.menuPreviewBusy || this.menuPreviewImporting) return;
      this.menuPreviewVisible = false;
      this.menuPreviewError = '';
      this.menuPreviewWarnings = [];
      this.menuPreviewCategories = [];
    },
    confirmImportMenuFromPreview: function confirmImportMenuFromPreview() {
      var _this14 = this;

      if (this.menuPreviewBusy || this.menuPreviewImporting || !this.menuPreviewCategories.length) return;

      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        title: this.$t('gestiune.integrationsMenuPreviewImportConfirmTitle'),
        text: this.$t('gestiune.integrationsMenuPreviewImportConfirmText'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('gestiune.integrationsMenuPreviewImport'),
        cancelButtonText: this.$t('general.cancel2')
      }).then(function (result) {
        if (!result) return;
        _this14.importMenuFromPreview();
      }).catch(function () {});
    },
    enrollWolt: function enrollWolt() {
      var _this15 = this;

      if (!this.isWoltIntegration || !this.showIntegrationActions || this.disabled || this.busy || this.actionBusy) return;
      this.actionBusy = true;
      var payload = this.buildIntegrationActionPayload();
      payload.return_to = 'integrations';
      this.apiRequest('/wolt/integrate-location/' + this.formData.id, 'POST', payload, function (response) {
        _this15.actionBusy = false;
        if (response && response.status && response.data) {
          window.location.href = response.data;
        } else {
          _this15.showIntegrationActionError(_this15.getIntegrationActionErrorMessage(response, 'enrollWolt'));
        }
      });
    },
    importMenuFromPreview: function importMenuFromPreview() {
      this.validateAndPushMenu(false, true);
    },
    validateAndPushMenu: function validateAndPushMenu() {
      var _this16 = this;

      var skipValidation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var fromPreview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.showIntegrationActions || this.disabled || this.actionBusy || this.menuPreviewBusy) return;
      this.actionBusy = true;
      if (fromPreview) this.menuPreviewImporting = true;
      var finish = function finish(pushResponse) {
        _this16.actionBusy = false;
        if (fromPreview) {
          _this16.menuPreviewImporting = false;
          if (pushResponse && pushResponse.status) _this16.menuPreviewVisible = false;
        }
      };
      var push = function push() {
        return _this16.pushIntegrationMenu(finish);
      };
      if (skipValidation === true) {
        push();
        return;
      }
      this.requestMenuValidation(function (response) {
        if (!_this16.isMenuValidationPassed(response, fromPreview)) {
          finish(null);
          return;
        }
        push();
      });
    },
    pushIntegrationMenu: function pushIntegrationMenu(onComplete) {
      var _this17 = this;

      var payload = this.buildIntegrationActionPayload();
      var url = '';

      if (this.isGlovoIntegration) {
        url = '/glovo/menu/send-url';
        payload.glovo_company_id = this.formData.id;
      } else if (this.isWoltIntegration) {
        url = '/wolt/export-menu';
        payload.wolt_company_id = this.formData.id;
      } else if (this.isBoltIntegration) {
        url = '/bolt/push-menu';
        payload.bolt_company_id = this.formData.id;
      } else {
        if (typeof onComplete === 'function') onComplete(null);
        return;
      }

      this.apiRequest(url, 'POST', payload, function (response) {
        if (typeof onComplete === 'function') onComplete(response);
        if (response && response.status) {
          if (_this17.isGlovoIntegration) {
            var tx = _this17.extractGlovoTransactionId(response);
            if (tx) _this17.glovoTransactionId = tx;
            var successText = tx ? _this17.$t('gestiune.integrationsGlovoPushAccepted') + '\n' + tx : _this17.$t('gestiune.integrationsGlovoPushAccepted');
            _this17.showIntegrationActionSuccess(successText);
            _this17.refreshIntegrationData();
          } else {
            _this17.showIntegrationActionSuccess();
          }
        } else {
          if (_this17.isMenuNotFoundResponse(response)) {
            _this17.showIntegrationActionError(_this17.$t('gestiune.integrationsGlovoMenuEmpty'));
          } else {
            var message = _this17.isGlovoIntegration ? _this17.formatGlovoApiFeedback(response, 'pushMenu') : _this17.getIntegrationActionErrorMessage(response, 'pushMenu');
            _this17.showIntegrationActionError(message || undefined);
          }
        }
      });
    },
    checkGlovoExportStatus: function checkGlovoExportStatus() {
      var _this18 = this;

      if (!this.isGlovoIntegration || this.actionBusy || !this.canCheckGlovoExportStatus) return;
      var payload = this.buildIntegrationActionPayload();
      payload.glovo_company_id = this.formData.id;
      if (this.glovoTransactionId) {
        payload.transaction_id = this.glovoTransactionId;
      }
      this.actionBusy = true;
      this.apiRequest('/glovo/menu/export-status', 'POST', payload, function (response) {
        _this18.actionBusy = false;
        if (response && response.status) {
          var tx = _this18.extractGlovoTransactionId(response);
          if (tx) _this18.glovoTransactionId = tx;
          var data = response.data && (response.data.data || response.data);
          var statusText = data && data.export_status ? String(data.export_status) : _this18.$t('gestiune.integrationsGlovoStatusUpdated');
          _this18.showIntegrationActionSuccess(statusText);
          _this18.refreshIntegrationData();
        } else if (_this18.isExportTransactionNotFoundResponse(response)) {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
            text: _this18.$t('gestiune.integrationsGlovoNoExport'),
            type: 'info',
            confirmButtonText: _this18.$t('general.ok')
          }).catch(function () {});
        } else {
          _this18.showIntegrationActionError(_this18.formatGlovoApiFeedback(response, 'pushMenu'));
        }
      });
    },
    handleAcceptOrdersStatus: function handleAcceptOrdersStatus() {
      var _this19 = this;

      if (!this.showIntegrationActions || this.actionBusy) return;

      var payload = this.buildIntegrationActionPayload();
      payload.active = this.acceptOrdersStatus;
      var url = '';

      if (this.isGlovoIntegration) {
        url = '/glovo/toggle-location-status';
        payload.glovo_company_id = this.formData.id;
      } else if (this.isWoltIntegration) {
        url = '/wolt/toggle-location-status';
        payload.wolt_company_id = this.formData.id;
      } else if (this.isBoltIntegration) {
        url = '/bolt/handle-open';
        payload.bolt_company_id = this.formData.id;
      } else {
        return;
      }

      this.actionBusy = true;
      this.apiRequest(url, 'POST', payload, function (response) {
        _this19.actionBusy = false;
        if (response && response.status) {
          if (_this19.isGlovoIntegration) {
            _this19.$set(_this19.formData, 'store_active', _this19.acceptOrdersStatus);
          } else {
            _this19.$set(_this19.formData, 'active', _this19.acceptOrdersStatus);
          }
          _this19.showIntegrationActionSuccess();
        } else {
          _this19.acceptOrdersStatus = !_this19.acceptOrdersStatus;
          _this19.showIntegrationActionError(_this19.getIntegrationActionErrorMessage(response, 'toggleLocation'));
        }
      });
    },
    syncIntegrationSchedule: function syncIntegrationSchedule() {
      var _this20 = this;

      if (!this.showScheduleAction || this.disabled || this.busy || this.actionBusy) return;

      var payload = this.buildIntegrationActionPayload();
      payload.schedule = Array.isArray(this.formData.schedule) ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formData.schedule)) : [];

      var url = '';
      if (this.isWoltIntegration) {
        url = '/wolt/update-schedule';
        payload.wolt_company_id = this.formData.id;
      } else if (this.isBoltIntegration) {
        url = '/bolt/update-schedule';
        payload.bolt_company_id = this.formData.id;
      } else {
        return;
      }

      this.actionBusy = true;
      this.apiRequest(url, 'POST', payload, function (response) {
        _this20.actionBusy = false;
        if (response && response.status) {
          _this20.showIntegrationActionSuccess();
        } else {
          _this20.showIntegrationActionError(_this20.getIntegrationActionErrorMessage(response, 'syncSchedule'));
        }
      });
    }
  }
});

/***/ }),

/***/ "drZW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "duJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Offers_vue__ = __webpack_require__("c2KQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d75caa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Offers_vue__ = __webpack_require__("McWu");
function injectStyle (ssrContext) {
  __webpack_require__("vig9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d75caa8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Offers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d75caa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Offers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dvqv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dxYK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row categories"},[_c('div',{staticClass:"col-lg-12 col-md-10 col-sm-12 "},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-right",staticStyle:{"position":"relative","z-index":"2"}},[_c('router-link',{staticClass:"btn btn-info add mar-bt-20",attrs:{"title":"","to":{ path: 'custom-info-pages/add'}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('infoPages.single'))+"\n            ")])],1)]),_vm._v(" "),_c('table',{ref:"sortableTable",staticClass:"table width-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"10%"}}),_vm._v(" "),_c('th',{attrs:{"width":"60%"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.name')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}})])]),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody'},on:{"end":_vm.adjustSort},model:{value:(_vm.pages),callback:function ($$v) {_vm.pages=$$v},expression:"pages"}},[_vm._l((_vm.pages),function(item,index){return [(item.type === 'CUSTOM')?_c('tr',{key:index.id,staticClass:"sortableRow",on:{"click":function($event){_vm.goToRecord(item,[],[], $event)}}},[_c('td',[_c('i',{staticClass:"fa fa-arrows sortHandle",staticStyle:{"cursor":"move"}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                  ")])])]):_vm._e()]})],2)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e0Nk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");









var _components;







/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  created: function created() {
    this.getData();
  },
  data: function data() {
    return {
      loading: false,
      paginationDef: {
        pageSize: 99999,
        currentPage: 1,
        pageSizes: [99999],
        show: false
      },
      filters: {
        'valid': []
      },
      customer: [],
      modelValidations: {
        required: {
          required: true
        }
      },
      ordersChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          },
          height: '200px'
        }
      },
      topProdsChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '300px',
          axisX: {
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      paymentsChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '300px',
          width: '300px'
        }
      },
      tableColumns: [{
        prop: 'number',
        label: 'Number',
        minWidth: 100
      }, {
        prop: 'created_date',
        label: 'Date Created',
        minWidth: 150
      }, {
        prop: 'delivery_service',
        label: 'Delivery',
        minWidth: 150
      }, {
        prop: 'type',
        label: 'Type',
        minWidth: 100
      }],
      pickerOptions1: {},
      pickerNames: ['date_from', 'date_to']
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.loading = true;
      var currency = this.getCompanyDetail('currency');
      this.currency = this.getCurrencySymbol(currency);
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.filters.valid ? this.filters.valid[0] : null,
        end_date: this.filters.valid ? this.filters.valid[1] : null
      };
      if (this.$route.params.id) {
        this.loading = true;
        var id = this.$route.params.id;
        this.apiRequest('/reports/clients/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            if (!_this.filters.valid || !_this.filters.valid.length) {
              _this.filters.valid = [__WEBPACK_IMPORTED_MODULE_8_moment___default()(String(response.data[0].created_at)).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD')];
              _this.$refs.dateRangePicker.$set(_this.filters.valid);
            }
            _this.customer = response.data[0];
            _this.ordersChart.data.labels = response.data[0].orders_chart.labels;
            _this.ordersChart.data.series = response.data[0].orders_chart.series;
            _this.ordersChart.title = _this.$t('reports.total') + ' ' + response.data[0].orders_count;
            _this.$refs.refOrdersChart.initChart();

            _this.topProdsChart.data.labels = response.data[0].products_chart['labels'];
            _this.topProdsChart.data.series = [response.data[0].products_chart['values']];
            _this.$refs.topProdsChart.initChart();

            var totalPayments = response.data[0].payments_chart.card + response.data[0].payments_chart.cash;
            if (totalPayments) {
              _this.paymentsChart.data.labels = [_this.$t('reports.card') + ' - ' + parseFloat(response.data[0].payments_chart.card * 100 / totalPayments).toFixed(2) + '%', _this.$t('reports.cash') + ' - ' + parseFloat(response.data[0].payments_chart.cash * 100 / totalPayments).toFixed(2) + '%'];
              _this.paymentsChart.data.series = [{
                value: response.data[0].payments_chart.card,
                name: _this.$t('reports.card')
              }, {
                value: response.data[0].payments_chart.cash,
                name: _this.$t('reports.cash')
              }];
              _this.$refs.paymentsChart.initChart();
            }

            _this.$nextTick(function () {
              _this.loading = false;
            });
          }
        });
      }
    },
    goToRecord: function goToRecord(row, event, column) {
      window.open('/#/orders/view/' + row.id);
    }
  }
});

/***/ }),

/***/ "e0m3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__QrPaymentSettings_vue__ = __webpack_require__("ZnRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Inputs_KioskVideoInput_vue__ = __webpack_require__("sIVt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_css__);



















var _components;








__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    QrPaymentSettings: __WEBPACK_IMPORTED_MODULE_19__QrPaymentSettings_vue__["a" /* default */],
    KioskVideoInput: __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Inputs_KioskVideoInput_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a), _components),
  props: {
    autoselectLocation: null,
    posUsers: {
      required: false,
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fromExternal: null,
    tableId: null,

    showOnlineQr: {
      required: false,
      type: Boolean,
      default: false
    },
    callback: {
      required: false
    }
  },
  watch: {
    tableId: function tableId(value) {
      this.id = value;
    }
  },
  created: function created() {
    this.company_id = this.$session.get('selectedCompany');
    if (this.autoselectLocation) {
      this.model.location_id = this.autoselectLocation;
    }
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getData();
    this.setAvailableTypes();
  },

  computed: {
    offlineUrl: function offlineUrl() {
      var isKiosk = this.model.type === 'Kiosk';
      var isOffline = isKiosk ? this.model.kiosk_offline : this.model.qr_offline;
      var companyId = this.model.company_id || this.company_id;
      if (!isOffline || !companyId || !this.model.id) return '';
      var baseUrl = isKiosk ? 'https://kioskoffline.taptasty.ro?auth=' : 'https://qrofflinelive.taptasty.ro?qr=';
      return baseUrl + encodeURIComponent(companyId + '.' + this.model.id);
    },
    waiterSelectStyle: function waiterSelectStyle() {
      return {
        width: '100%',
        '--waiter-overflow-label': __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()('+ ' + Math.max(0, this.selectedWaiterIds.length - 3))
      };
    },

    selectedWaiterIds: {
      get: function get() {
        return (this.model.users || []).map(function (user) {
          return user.user_id || user.id;
        });
      },
      set: function set(ids) {
        var _this = this;

        var existing = this.model.users || [];
        this.$set(this.model, 'users', ids.map(function (id) {
          return existing.find(function (user) {
            return (user.user_id || user.id) === id;
          }) || _this.posUsersFiltered.find(function (user) {
            return user.id === id;
          });
        }).filter(Boolean));
      }
    },
    waiterOptions: function waiterOptions() {
      var options = this.posUsersFiltered.slice();(this.model.users || []).forEach(function (user) {
        var id = user.user_id || user.id;
        if (!options.some(function (option) {
          return option.id === id;
        })) {
          options.push({ id: id, fullname: user.fullname });
        }
      });
      return options;
    },
    qrPosOptions: function qrPosOptions() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.pos);
    },
    isVivaWalletPos: function isVivaWalletPos() {
      return this.model.pos && Number(this.model.pos.id) === 4;
    },
    isOptionalServerPos: function isOptionalServerPos() {
      return this.model.pos && [1, 2, 3].includes(Number(this.model.pos.id));
    },
    hasPosServerFields: function hasPosServerFields() {
      return this.isVivaWalletPos || this.isOptionalServerPos;
    },
    hasBankTerminalProvider: function hasBankTerminalProvider() {
      return !!this.model.bank_terminal_provider;
    },
    posUsersFiltered: function posUsersFiltered() {
      var _this2 = this;

      return this.posUsers.filter(function (user) {
        if (!user.location_details || user.location_details.length === 0) {
          return true;
        }

        return user.location_details.includes(_this2.model.location_id);
      });
    },
    onlineQrImage: function onlineQrImage() {
      if (!this.model.online_qr_code) return '';
      return (/^https?:\/\//.test(this.model.online_qr_code) ? this.model.online_qr_code : this.apiUrl + '/images/' + this.model.online_qr_code
      );
    },
    onlineQrLink: function onlineQrLink() {
      return this.model.online_qr_token ? this.apiUrl + '/table-online/' + this.model.online_qr_token : '';
    }
  },
  data: function data() {
    return {
      apiUrl: '',
      company_id: null,
      roles: [],
      id: this.tableId,
      isNew: true,
      kioskUrl: 'https://live.taptasty.com/kiosk-nodejs/KioskApp.zip',
      filelist: [],
      fiscalPrinter: [],
      bankTerminalProviders: [{ value: 'viva_wallet', label: 'Viva Wallet' }, { value: 'banca_transilvania', label: 'Banca Transilvania' }],
      model: {
        'id': 0,
        'current_order_id': null,
        'location_id': '',
        'number': '',
        'external_id': '',
        'ga4Code': null,
        'qr_offline': false,
        'offline_pairing_code': null,
        'qr_payment_methods': null,
        'login_code': null,
        'kiosk_offline': false,
        'videos': [],
        'server_pos_ip': null,
        'yumm_integration_external_ip': '',
        'series': null,
        'start_number': null,
        'qr_link': '',
        'online_qr_token': '',
        'online_qr_code': '',
        'type': 'Masa',
        'scaner_position': 'left',
        'with_viva_wallet': false,
        'bank_terminal_provider': null,
        'bank_terminal_data': {
          merchantId: '',
          terminalId: '',
          activationCode: ''
        },
        'zone': '',
        'table_shape': 'squere',
        'user_id': 0
      },

      zone: [],
      type: ['Masa', 'Umbrela', 'Camera', 'Kiosk'],
      printer: {
        1: {
          'id': 1,
          'name': 'Network',
          'ip': '',
          'port': ''
        },
        2: {
          'id': 2,
          'name': 'USB',
          'p1': '',
          'p2': ''
        }
      },
      pos: {
        1: {
          'id': 1,
          'name': 'Ingenico 3200 (bt)',
          'ip': '',
          'port': '',
          'tid_mid': ''
        },
        2: {
          'id': 2,
          'name': 'Ingenico 3200 (unicredit)',
          'ip': null,
          'port': '',
          'tid_mid': ''
        },
        3: {
          'id': 3,
          'name': 'Ingenico 3200 (raiffeisen)',
          'ip': null,
          'port': '',
          'tid_mid': ''
        },
        4: {
          'id': 4,
          'name': 'Viva Wallet',
          'host': '',
          'port': '',
          'server_ip': '',
          'server_port': '',
          'tid_mid': ''
        }
      },
      fiscal: {
        1: {
          'id': 1,
          'name': 'Datex FP800',
          'port': ''
        }
      },
      locations: [],
      driverCode: '',
      modelValidate: {
        type: { required: true },
        zone: { required: true },
        number: { required: true },
        min_pers: { required: true, min: 1, max: 30 },
        max_pers: { required: true, min: 1, max: 30 }
      },
      languages: this.$session.get('defaultData')['available_languages'],
      loading: true,
      onlineQrLoading: false
    };
  },

  methods: {
    updateWoltMenu: function updateWoltMenu() {
      var _this3 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        wolt_company_id: this.location.wolt_company_id
      };
      this.apiRequest('/wolt/export-menu', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
            text: _this3.$t('bolt.sync'),
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
            text: _this3.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
        }
        _this3.loading = false;
      });
    },
    handleWoltStatus: function handleWoltStatus() {
      var _this4 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        wolt_company_id: this.location.wolt_company_id,
        active: this.woltStatus
      };
      this.apiRequest('/wolt/toggle-location-status', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
            text: _this4.$t('bolt.sync'),
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
            text: _this4.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
          _this4.woltStatus = !_this4.woltStatus;
        }
        _this4.loading = false;
      });
    },
    updateWoltSchedule: function updateWoltSchedule() {
      var _this5 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        wolt_company_id: this.location.wolt_company_id,
        schedule: this.woltSchedule
      };
      this.apiRequest('/wolt/update-schedule', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
            text: _this5.$t('bolt.sync'),
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
            text: _this5.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
        }
        _this5.loading = false;
      });
    },
    addMoreIntervals: function addMoreIntervals(dayIdx) {
      this.woltSchedule[dayIdx].intervals.push({
        opening_time: null,
        closing_time: null
      });
    },
    deleteIntervals: function deleteIntervals(intervalKey, dayIdx) {
      this.woltSchedule[dayIdx].intervals.splice(intervalKey, 1);
    },
    generateOnlineQr: function generateOnlineQr() {
      var _this6 = this;

      if (!this.model.id) return;
      this.onlineQrLoading = true;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/table-management/' + this.model.id + '/generate-online-qr', 'POST', data, function (response) {
        _this6.onlineQrLoading = false;
        if (response.success) {
          _this6.$set(_this6.model, 'online_qr_token', response.data.online_qr_token);
          _this6.$set(_this6.model, 'online_qr_code', response.data.online_qr_code);
        }
      });
    },
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy).then(function (e) {}, function (e) {});
    },
    ensureBankTerminalData: function ensureBankTerminalData() {
      var _this7 = this;

      var data = this.model.bank_terminal_data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          data = null;
        }
      }
      if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) !== 'object' || Array.isArray(data)) {
        this.$set(this.model, 'bank_terminal_data', {
          merchantId: '',
          terminalId: '',
          activationCode: ''
        });
        return;
      }
      this.$set(this.model, 'bank_terminal_data', data);['merchantId', 'terminalId', 'activationCode'].forEach(function (key) {
        if (typeof _this7.model.bank_terminal_data[key] === 'undefined' || _this7.model.bank_terminal_data[key] === null) {
          _this7.$set(_this7.model.bank_terminal_data, key, '');
        }
      });
    },
    normalizeBankTerminalFromResponse: function normalizeBankTerminalFromResponse() {
      this.model.with_viva_wallet = !!this.model.with_viva_wallet;
      if (!this.model.bank_terminal_provider) {
        this.model.bank_terminal_provider = this.model.with_viva_wallet ? 'viva_wallet' : null;
      }
      this.ensureBankTerminalData();
      this.model.with_viva_wallet = this.model.bank_terminal_provider === 'viva_wallet';
    },
    onBankTerminalProviderChange: function onBankTerminalProviderChange() {
      var provider = this.model.bank_terminal_provider || null;
      this.model.bank_terminal_provider = provider;
      this.model.with_viva_wallet = provider === 'viva_wallet';
      if (provider === 'banca_transilvania') {
        this.ensureBankTerminalData();
      } else {
        this.model.bank_terminal_data = {
          merchantId: '',
          terminalId: '',
          activationCode: ''
        };
      }
    },
    setAvailableTypes: function setAvailableTypes() {
      var url = window.location.href.toLowerCase();

      if (url.includes('kiosk')) {
        this.type = ['Kiosk'];

        this.model.type = 'Kiosk';
        return;
      }

      if (url.includes('qr')) {
        this.type = ['Masa', 'Umbrela', 'Camera'];

        if (!this.type.includes(this.model.type)) {
          this.model.type = 'Masa';
        }

        return;
      }

      this.type = ['Masa', 'Umbrela', 'Camera', 'Kiosk'];
    },
    getData: function getData() {
      var _this8 = this;

      this.loading = true;
      var companyData = this.$session.get('selectedCompanyData') || {};
      var locations = Array.isArray(companyData.locations_details) ? companyData.locations_details : [];
      this.locations = locations.filter(function (location) {
        return location && Array.isArray(location.ordering_management) && location.ordering_management.some(function (method) {
          return method && method.type === 'self_ordering';
        });
      });
      var data = {
        token: this.$session.get('token'),
        company_id: this.company_id
      };
      if (this.id !== undefined && this.id !== null) {
        this.isNew = false;
      } else {
        this.isNew = true;
      }
      if (!this.isNew) {
        var id = this.id || this.$route.params.id;
        this.apiRequest('/table-management/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            _this8.model = response.data;

            _this8.normalizeBankTerminalFromResponse();
            _this8.model.pos = JSON.parse(_this8.model.pos);
            if (_this8.model.pos && Number(_this8.model.pos.id) === 4) {
              if (typeof _this8.model.pos.host === 'undefined' || _this8.model.pos.host === null) {
                var fromIp = _this8.model.pos.ip != null && _this8.model.pos.ip !== '' ? String(_this8.model.pos.ip) : '';
                var fromLegacy = _this8.model.pos.viva_terminal != null && _this8.model.pos.viva_terminal !== '' ? String(_this8.model.pos.viva_terminal) : '';
                _this8.$set(_this8.model.pos, 'host', fromIp || fromLegacy || '');
              }
              if (typeof _this8.model.pos.port === 'undefined') _this8.$set(_this8.model.pos, 'port', '');
              if (typeof _this8.model.pos.server_ip === 'undefined') _this8.$set(_this8.model.pos, 'server_ip', '');
              if (typeof _this8.model.pos.server_port === 'undefined') _this8.$set(_this8.model.pos, 'server_port', '');
              if (typeof _this8.model.pos.tid_mid === 'undefined') _this8.$set(_this8.model.pos, 'tid_mid', '');
              if (typeof _this8.model.pos.ip !== 'undefined') _this8.$delete(_this8.model.pos, 'ip');
              if (typeof _this8.model.pos.viva_terminal !== 'undefined') _this8.$delete(_this8.model.pos, 'viva_terminal');
            }
            if (_this8.isOptionalServerPos) {
              if (_this8.model.pos.server_ip == null) _this8.$set(_this8.model.pos, 'server_ip', '');
              if (_this8.model.pos.server_port == null) _this8.$set(_this8.model.pos, 'server_port', '');
            }
            _this8.model.fiscal = JSON.parse(_this8.model.fiscal);
            _this8.model.use_fiscal_net = !!_this8.model.use_fiscal_net;
            _this8.model.use_fiscal_net_with_pos = !!_this8.model.use_fiscal_net_with_pos;
            _this8.model.use_pager = !!_this8.model.use_pager;
            _this8.model.use_tips = !!_this8.model.use_tips;
            _this8.model.use_methods = !!_this8.model.use_methods;
            _this8.model.use_cash_machine = !!_this8.model.use_cash_machine;
            _this8.model.disable_cash_payment = !!_this8.model.disable_cash_payment;
            _this8.model.kiosk_offline = !!_this8.model.kiosk_offline;
            _this8.$set(_this8.model, 'videos', Array.isArray(_this8.model.videos) ? _this8.model.videos : []);
            _this8.$set(_this8.model, 'qr_offline', !!_this8.model.qr_offline);
            _this8.$set(_this8.model, 'qr_payment_methods', _this8.model.qr_payment_methods || null);
            _this8.$set(_this8.model, 'login_code', _this8.model.login_code == null ? null : String(_this8.model.login_code));
            _this8.model.printer = JSON.parse(_this8.model.printer);
            if (_this8.model.table_colors) {
              _this8.model.table_colors_string = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this8.model.table_colors);
            }
            if (!_this8.model.table_shape) {
              _this8.model.table_shape = 'squere';
            }
            _this8.zone = _this8.model.zones;
            _this8.$nextTick(function () {
              this.loading = false;
            });
          }
        });
      } else {
        this.zone = [];
        var data2 = {
          token: this.$session.get('token'),
          company_id: this.company_id
        };
        this.apiRequest('/table-zone', 'GET', data2, function (response) {
          if (response.status === true) {
            if (response.data.length) {
              for (var i = 0; i <= response.data.length - 1; i++) {
                _this8.zone.push({
                  'id': response.data[i].id,
                  'name': response.data[i].name
                });
              }
            }
          }
          _this8.loading = false;
        });
      }

      var dataFiscal = {
        token: this.$session.get('token'),
        company_id: this.company_id
      };
      this.apiRequest('/fiscal-printer', 'GET', dataFiscal, function (response) {
        if (response.status === true) {
          _this8.fiscalPrinter = response.data.fiscalPrinter;
        }
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this9 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this9.saveTable();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    normalizePosForSave: function normalizePosForSave() {
      var p = this.model.pos;
      if (!p || (typeof p === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(p)) !== 'object' || Number(p.id) !== 4) return;
      if (typeof p.host === 'undefined' || p.host === null) this.$set(this.model.pos, 'host', '');
      if (typeof p.ip !== 'undefined') this.$delete(this.model.pos, 'ip');
      if (typeof p.viva_terminal !== 'undefined') this.$delete(this.model.pos, 'viva_terminal');
    },
    posForSave: function posForSave(pos) {
      if (!pos || (typeof pos === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(pos)) !== 'object' || ![1, 2, 3].includes(Number(pos.id))) return pos;
      var out = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, pos);['server_ip', 'server_port'].forEach(function (key) {
        var value = out[key] == null ? '' : String(out[key]).trim();
        if (value === '') delete out[key];else out[key] = value;
      });
      return out;
    },
    saveTable: function saveTable() {
      var _this10 = this;

      this.$nextTick(function () {
        _this10.loading = true;
      });
      this.normalizePosForSave();
      var legacyProvider = this.model.bank_terminal_provider || (this.model.with_viva_wallet ? 'viva_wallet' : null);
      this.onBankTerminalProviderChange();
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model);
      data.pos = this.posForSave(data.pos);
      if (data.bank_terminal_provider !== 'banca_transilvania') {
        data.bank_terminal_data = null;
      }
      if (data.type === 'Kiosk') {
        data.ga4Code = data.ga4Code ? data.ga4Code.trim() || null : null;
      } else {
        delete data.ga4Code;
      }
      delete data.offline_pairing_code;
      delete data.qr_pass;
      if (data.type === 'Kiosk' || !data.qr_offline) delete data.login_code;
      if (data.type === 'Kiosk') {
        data.video_ids = (data.videos || []).map(function (video) {
          return video.id;
        });
      }
      delete data.videos;
      if (data.type === 'Kiosk') {
        data.qr_offline = false;
        delete data.qr_payment_methods;
        delete data.login_code;
      }
      if (data.table_colors_string) {
        data.table_colors = JSON.parse(data.table_colors_string);
      } else {
        data.table_colors = null;
      }

      if (data.qr_payment_methods) {
        data.qr_payment_methods = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data.qr_payment_methods));['online', 'offline'].forEach(function (mode) {
          ;(data.qr_payment_methods[mode] || []).forEach(function (entry) {
            if (entry.type === 'POS') entry.data = null;
            if (legacyProvider && entry.type === 'CARD_POS' && entry.data === null) entry.data = { bank_terminal_provider: legacyProvider };
          });
        });
      }
      data.token = this.$session.get('token');
      data.company_id = this.company_id;
      this.apiRequest('/table-management/' + data.id, 'PUT', data, function (response) {
        if (response.success === true) {
          var _this10$trackAdminEve;

          var kind = _this10.tableEntityKind(data.type);
          var eventName = kind === 'kiosk' ? 'ADMIN_KIOSK_UPDATE' : kind === 'qr' ? 'ADMIN_QR_UPDATE' : 'ADMIN_TABLE_UPDATE';
          var entityId = response.data && response.data.table && response.data.table.id || data.id;
          _this10.trackAdminEvent(eventName, kind, entityId, (_this10$trackAdminEve = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_this10$trackAdminEve, kind + '_id', entityId), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_this10$trackAdminEve, 'type', data.type || null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_this10$trackAdminEve, 'name', data.number || null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_this10$trackAdminEve, 'request', data), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_this10$trackAdminEve, 'response', response), _this10$trackAdminEve));
          _this10.$nextTick(function () {
            _this10.loading = false;
          });
          _this10.errors.clear();
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
            title: '',
            text: _this10.$t('settingTable.tableSave'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).then(function () {}).catch(function () {});
          _this10.cancelTable(response.data.table);
        } else {
          _this10.$nextTick(function () {
            _this10.loading = false;
          });
          _this10.handleErrors(response.errors);
        }
      });
    },
    deleteTable: function deleteTable() {
      var _this11 = this;

      this.$nextTick(function () {
        _this11.loadingReset = true;
      });
      var id = this.id || this.$route.params.id;
      var data = {
        company_id: this.company_id,
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/table-management/' + id, 'PUT', data, function (response) {
        if (response.success === true) {
          var _this11$trackAdminEve;

          var kind = _this11.tableEntityKind(_this11.model && _this11.model.type);
          var eventName = kind === 'kiosk' ? 'ADMIN_KIOSK_DELETED' : kind === 'qr' ? 'ADMIN_QR_DELETED' : 'ADMIN_TABLE_DELETED';
          _this11.trackAdminEvent(eventName, kind, id, (_this11$trackAdminEve = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_this11$trackAdminEve, kind + '_id', id), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_this11$trackAdminEve, 'type', _this11.model && _this11.model.type || null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_this11$trackAdminEve, 'name', _this11.model && _this11.model.number || null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_this11$trackAdminEve, 'location_id', _this11.model && _this11.model.location_id || null), _this11$trackAdminEve));
          _this11.$nextTick(function () {
            _this11.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({ 'text': 'Ștergere cu succes', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this11.cancelTable(null, id);
        } else {
          _this11.$nextTick(function () {
            _this11.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({ 'text': _this11.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    cancelTable: function cancelTable(respTable, deletedTableId) {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal', 'tableModal');

      if (typeof this.callback === 'function') {
        this.callback(respTable, this.isNew, deletedTableId);
      }
    }
  }
});

/***/ }),

/***/ "e2cc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.labelEvolution')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('line-chart',{attrs:{"chartData":_vm.chartData,"options":_vm.chartOptions}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e7RR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e9Q6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320f184f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("R/cZ");
function injectStyle (ssrContext) {
  __webpack_require__("JGRj")
  __webpack_require__("0rET")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320f184f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eEcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);












__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_pagination___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      perPage: 50,
      locationMap: {},
      currency: this.getCurrencySymbol((this.$session.get('selectedCompanyData') || {})['currency_iso'])
    };
  },

  computed: {
    rewardId: function rewardId() {
      var fromProp = this.route && this.route.params && this.route.params.rewardId;
      var fromRouter = this.$route && this.$route.params && this.$route.params.rewardId;
      return fromProp || fromRouter;
    },
    rewardTitle: function rewardTitle() {
      return this.$route && this.$route.query && this.$route.query.title || '';
    },
    rewardType: function rewardType() {
      return this.$route && this.$route.query && this.$route.query.type || 'product';
    },
    isProductType: function isProductType() {
      return this.rewardType !== 'gift_card';
    },
    isGiftType: function isGiftType() {
      return this.rewardType === 'gift_card';
    }
  },
  mounted: function mounted() {
    this.initLocations();
    this.loadPurchases();
  },

  methods: {
    initLocations: function initLocations() {
      var company = this.$session.get('selectedCompanyData') || {};
      var locs = company.locations_details || [];
      var map = {};
      locs.forEach(function (l) {
        var id = l.true_id || l.id;
        if (id != null) map[id] = l.name;
      });
      this.locationMap = map;
    },
    locationName: function locationName(locationId) {
      if (!locationId) return null;
      return this.locationMap[locationId] || this.locationMap[String(locationId)] || null;
    },
    goBack: function goBack() {
      this.$bus.$emit('close-modal');
      this.$bus.$emit('refresh-loyalty-store-report');
    },
    getUserName: function getUserName(row) {
      if (row.user && row.user.name) return row.user.name;
      if (row.user) {
        return [row.user.firstname, row.user.lastname].filter(Boolean).join(' ') || row.user.email || row.user_id;
      }
      return row.user_id || '—';
    },
    formatDateTime: function formatDateTime(val) {
      if (!val) return '—';
      if (typeof this.formatDate === 'function') return this.formatDate(val);
      return String(val);
    },
    openOrder: function openOrder(orderId) {
      this.$router.push('/orders/view/' + orderId);
    },
    loadPurchases: function loadPurchases() {
      var _this = this;

      if (!this.rewardId) return;
      this.loading = true;
      var q = this.$route && this.$route.query || {};
      var params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.page,
        per_page: this.perPage
      };
      if (q.start_date) params.start_date = q.start_date;
      if (q.end_date) params.end_date = q.end_date;
      if (q.location_id) params.location_id = q.location_id;
      if (q.user_id) params.user_id = q.user_id;

      this.apiRequest('/reports/loyalty-store/rewards/' + this.rewardId + '/purchases', 'GET', params, function (response) {
        _this.loading = false;
        if (response.status && response.data) {
          _this.tableData = response.data.items || [];
          _this.total = response.data.total || 0;
        } else {
          _this.tableData = [];
          _this.total = 0;
        }
      });
    }
  }
});

/***/ }),

/***/ "eJNc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eLXi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaigns_vue__ = __webpack_require__("dfks");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fa8c056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaigns_vue__ = __webpack_require__("ZpCo");
function injectStyle (ssrContext) {
  __webpack_require__("c7YX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fa8c056"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fa8c056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eLgs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-content total-pagination pad-1"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.clientsTableData,"search-def":{ show: false },"pagination-props":_vm.paginationProps,"table-props":_vm.tableOptions}},[_c('el-table-column',{attrs:{"prop":"id","label":"Id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"label":_vm.$t('customers.type')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(_vm.mapReportType(props.row.type)))])]}}])},[_vm._v("\n          >")]),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"prop":"from_date","label":_vm.$t('reports.fromUppercase')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"prop":"to_date","label":_vm.$t('reports.toUppercase')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"prop":"available_until","label":_vm.$t('reports.availableUntil')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":80,"prop":"name","label":_vm.$t('customers.status')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(_vm.reportStatus(props.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":120,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.file && Number(props.row.is_executed) === 1)?_c('a',{staticClass:"btn btn-info btn-icon duplicate-prod",attrs:{"href":_vm.apiUrl + '/reports/download-report/' + props.row.id + '?token=' + _vm.$session.get('token'),"target":"_blank"}},[_c('i',{staticClass:"ti-download"})]):_vm._e()]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eOL1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__ = __webpack_require__("Ark/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DiscountCampaignPricingGrid_vue__ = __webpack_require__("6FLT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__ = __webpack_require__("WW1J");






























__WEBPACK_IMPORTED_MODULE_18_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_22_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__["a" /* default */],
    SearchableMultiSelect: __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__["a" /* default */],
    DiscountCampaignPricingGrid: __WEBPACK_IMPORTED_MODULE_21__DiscountCampaignPricingGrid_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    embedded: {
      type: Boolean,
      default: false
    },
    hidePreview: {
      type: Boolean,
      default: false
    },
    lockPriceProfile: {
      type: Boolean,
      default: false
    },
    prefill: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      id: this.route && this.route.params && this.route.params.id || null,
      loading: true,
      previewLoading: false,
      previewTimeout: null,
      previewDebounceMs: 2000,
      useIntervals: false,
      discountTypes: __WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__["a" /* DISCOUNT_TYPES */],
      unitsSoldScopes: __WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__["b" /* UNITS_SOLD_SCOPES */],
      unitsSoldPools: __WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__["c" /* UNITS_SOLD_POOLS */],
      priceProfiles: [],
      sourceMethodOptions: [],
      selectedSourceMethodCombos: [],
      selectedComboKeys: [],
      selectedCategories: [],
      selectedTopCategories: [],
      selectedProducts: [],
      lineAffectingSnapshot: null,
      model: {
        name: '',
        description: '',
        image: null,
        imagelist: [],
        active: false,
        discount: null,
        discount_type: 2,
        price_profile_id: null,
        source_method_combos: [],
        category_ids: [],
        top_category_ids: [],
        product_ids: [],
        number_of_units: null,
        units_sold_scope: 1,
        units_sold_pool: 1,
        fromto: [],
        intervals: []
      },
      modelValidations: {
        name: { required: true, min: 3 },
        discount: { required: true, min_value: 0 }
      },
      timePickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:45'
      },
      gridProducts: [],
      gridPricingData: {},
      gridCombos: [],
      gridProductsCount: 0,
      previewFilters: {
        name: '',
        product_id: ''
      },
      gridPagination: {
        page: 1,
        perPage: 20,
        totalPages: 0,
        totalRecords: 0
      }
    };
  },

  computed: {
    canPreview: function canPreview() {
      return this.model.price_profile_id && this.selectedSourceMethodCombos.length > 0 && this.model.discount != null && this.model.discount !== '';
    },
    intervalDayOptions: function intervalDayOptions() {
      var _this = this;

      var cap = function cap(value) {
        if (!value) return '';
        var text = String(value);
        return text.charAt(0).toUpperCase() + text.slice(1);
      };
      return [{ value: '', label: cap(this.$t('general.all')) }].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__["d" /* INTERVAL_DAYS */].map(function (day) {
        return {
          value: day,
          label: cap(_this.$t('days.' + day))
        };
      })));
    },
    topCategoriesFilterKey: function topCategoriesFilterKey() {
      var ids = this.model.top_category_ids || [];
      return ids.length ? ids.slice().sort(function (a, b) {
        return a - b;
      }).join(',') : 'all';
    },
    categorySearchParams: function categorySearchParams() {
      var params = {};
      if (this.model.top_category_ids && this.model.top_category_ids.length) {
        params.top_category_ids = this.model.top_category_ids;
      }
      return params;
    }
  },
  watch: {
    useIntervals: function useIntervals(value) {
      if (!value) {
        this.model.intervals = [];
      } else if (!this.model.intervals.length) {
        this.addInterval();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.previewTimeout);
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.loadPriceProfiles(), this.loadSourceMethodOptions()]).then(function () {
      if (_this2.id) {
        _this2.loadCampaign();
      } else {
        _this2.applyPrefill();
        _this2.loading = false;
      }
    }).catch(function () {
      _this2.loading = false;
    });
  },

  methods: {
    normalizeIntervalTime: function normalizeIntervalTime(value) {
      if (!value) return '';
      var parts = String(value).trim().split(':');
      if (parts.length >= 2) {
        var hours = parts[0].padStart(2, '0');
        var minutes = parts[1].padStart(2, '0');
        return hours + ':' + minutes;
      }
      return String(value).trim();
    },
    normalizeIntervalDay: function normalizeIntervalDay(day) {
      if (day == null || day === '') return null;
      if ((typeof day === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(day)) === 'object') {
        return day.value != null && day.value !== '' ? day.value : null;
      }
      return day;
    },
    intervalDaySelectValue: function intervalDaySelectValue(day) {
      var value = this.normalizeIntervalDay(day);
      return value == null ? '' : value;
    },
    setIntervalDay: function setIntervalDay(interval, value) {
      interval.day = value === '' || value == null ? null : value;
    },
    mapEntityOptions: function mapEntityOptions(entities, prefix) {
      return (entities || []).map(function (entity) {
        return {
          id: entity.id,
          label: entity.label || entity.name || (prefix || '') + '#' + entity.id
        };
      });
    },
    setSelectedCombos: function setSelectedCombos(combos) {
      this.sourceMethodOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__["e" /* mergeComboOptions */])(this.sourceMethodOptions, combos);
      this.selectedSourceMethodCombos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__["f" /* resolveSelectedCombos */])(this.sourceMethodOptions, combos);
      this.selectedComboKeys = this.selectedSourceMethodCombos.map(function (combo) {
        return combo.key;
      });
      this.model.source_method_combos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__["g" /* combosToPayload */])(this.selectedSourceMethodCombos);
    },
    seedPriceProfile: function seedPriceProfile(profile) {
      var _this3 = this;

      if (!profile || profile.id == null) return;
      var exists = this.priceProfiles.some(function (item) {
        return String(item.id) === String(profile.id);
      });
      if (!exists) {
        this.priceProfiles = [{ id: profile.id, name: profile.name || '#' + profile.id }].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.priceProfiles));
      }
      var match = this.priceProfiles.find(function (item) {
        return String(item.id) === String(_this3.model.price_profile_id);
      });
      if (match) {
        this.model.price_profile_id = match.id;
      }
    },
    applyPrefill: function applyPrefill() {
      if (!this.prefill) return;
      if (this.prefill.price_profile_id) {
        this.model.price_profile_id = this.prefill.price_profile_id;
      }
      if (this.prefill.source_method_combos && this.prefill.source_method_combos.length) {
        this.setSelectedCombos(this.prefill.source_method_combos);
      }
      if (this.prefill.products && this.prefill.products.length) {
        this.selectedProducts = this.mapEntityOptions(this.prefill.products);
        this.model.product_ids = this.selectedProducts.map(function (p) {
          return p.id;
        });
      } else if (this.prefill.product_ids && this.prefill.product_ids.length) {
        this.selectedProducts = this.prefill.product_ids.map(function (id) {
          return {
            id: id,
            label: '#' + id
          };
        });
        this.model.product_ids = this.prefill.product_ids.slice();
      }
    },
    loadPriceProfiles: function loadPriceProfiles() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        var data = {
          token: _this4.$session.get('token'),
          company_id: _this4.$session.get('selectedCompany'),
          perPage: 500,
          page: 1
        };
        _this4.apiRequest('/price-profiles', 'GET', data, function (response) {
          if (response.status) {
            _this4.priceProfiles = Array.isArray(response.data) ? response.data : response.data && response.data.data || [];
          }
          resolve();
        });
      });
    },
    loadSourceMethodOptions: function loadSourceMethodOptions() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        var data = {
          token: _this5.$session.get('token'),
          company_id: _this5.$session.get('selectedCompany')
        };
        _this5.apiRequest('/discount-campaigns/source-method-options', 'GET', data, function (response) {
          if (response.status) {
            _this5.sourceMethodOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__["e" /* mergeComboOptions */])(response.data, _this5.selectedSourceMethodCombos);
          }
          resolve();
        });
      });
    },
    applyGridResponse: function applyGridResponse(payload) {
      var grid = payload || {};
      this.gridProducts = grid.products || grid.data || [];
      this.gridPricingData = grid.pricingData || {};
      this.gridCombos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__["h" /* sortCombosLikePriceProfile */])(grid.combos || []);
      this.gridProductsCount = grid.products_count != null ? grid.products_count : this.gridProducts.length;
      if (grid.pagination) {
        this.gridPagination.page = grid.pagination.page;
        this.gridPagination.perPage = grid.pagination.perPage;
        this.gridPagination.totalPages = grid.pagination.totalPages;
        this.gridPagination.totalRecords = grid.pagination.totalRecords;
      }
    },
    loadCampaign: function loadCampaign() {
      var _this6 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/discount-campaigns/' + this.id, 'GET', data, function (response) {
        if (response.status === true) {
          var item = response.data;
          if (item.start_date && item.end_date) {
            item.fromto = [item.start_date, item.end_date];
          } else {
            item.fromto = [];
          }
          item.active = !!(parseInt(item.active, 10) === 1 || item.active === true);
          if (item.image) {
            item.imagelist = [{ url: item.image }];
          } else {
            item.imagelist = [];
          }
          if (!item.intervals) {
            item.intervals = [];
          }
          item.intervals = item.intervals.map(function (interval) {
            return {
              day: interval.day || null,
              time_from: _this6.normalizeIntervalTime(interval.time_from || interval.from || ''),
              time_to: _this6.normalizeIntervalTime(interval.time_to || interval.to || '')
            };
          });
          _this6.useIntervals = item.intervals.length > 0;
          _this6.id = item.id || _this6.id;
          _this6.model = item;
          _this6.model.units_sold_scope = parseInt(item.units_sold_scope, 10) || 1;
          _this6.model.units_sold_pool = parseInt(item.units_sold_pool, 10) || 1;

          _this6.seedPriceProfile(item.price_profile);

          _this6.sourceMethodOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__["e" /* mergeComboOptions */])(_this6.sourceMethodOptions, item.combos || []);
          _this6.setSelectedCombos(item.source_method_combos && item.source_method_combos.length ? item.source_method_combos : item.combos || []);

          if (item.top_categories_formatted && item.top_categories_formatted.length) {
            _this6.selectedTopCategories = item.top_categories_formatted;
          } else if (item.top_categories && item.top_categories.length) {
            _this6.selectedTopCategories = _this6.mapEntityOptions(item.top_categories, 'Top category ');
          } else if (item.top_category_ids && item.top_category_ids.length) {
            _this6.selectedTopCategories = item.top_category_ids.map(function (id) {
              return { id: id, label: 'Top category #' + id };
            });
          } else if (item.top_category_formatted) {
            _this6.selectedTopCategories = [item.top_category_formatted];
          } else if (item.top_category_id) {
            _this6.selectedTopCategories = [{
              id: item.top_category_id,
              label: item.top_category_label || 'Top category #' + item.top_category_id
            }];
          } else {
            _this6.selectedTopCategories = [];
          }
          _this6.model.top_category_ids = _this6.selectedTopCategories.map(function (cat) {
            return cat.id;
          });

          if (item.categories_formatted && item.categories_formatted.length) {
            _this6.selectedCategories = item.categories_formatted;
          } else if (item.categories && item.categories.length) {
            _this6.selectedCategories = _this6.mapEntityOptions(item.categories, 'Category ');
          } else if (item.category_ids && item.category_ids.length) {
            _this6.selectedCategories = item.category_ids.map(function (id) {
              return { id: id, label: 'Category #' + id };
            });
          }
          _this6.model.category_ids = (_this6.selectedCategories || []).map(function (cat) {
            return cat.id;
          });

          if (item.products_formatted && item.products_formatted.length) {
            _this6.selectedProducts = item.products_formatted;
          } else if (item.products && item.products.length) {
            _this6.selectedProducts = _this6.mapEntityOptions(item.products);
          } else if (item.product_ids && item.product_ids.length) {
            _this6.selectedProducts = item.product_ids.map(function (id) {
              return { id: id, label: '#' + id };
            });
          } else {
            _this6.selectedProducts = [];
          }
          _this6.model.product_ids = (_this6.selectedProducts || []).map(function (p) {
            return p.id;
          });

          _this6.applyGridResponse(item);
          _this6.lineAffectingSnapshot = _this6.getLineAffectingSnapshot();
        }
        _this6.$nextTick(function () {
          _this6.loading = false;
        });
      });
    },
    onSourceMethodCombosChange: function onSourceMethodCombosChange(keys) {
      var _this7 = this;

      this.selectedComboKeys = keys || [];
      this.selectedSourceMethodCombos = this.selectedComboKeys.map(function (key) {
        return _this7.sourceMethodOptions.find(function (option) {
          return option.key === key;
        });
      }).filter(Boolean);
      this.model.source_method_combos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__discountCampaignConstants__["g" /* combosToPayload */])(this.selectedSourceMethodCombos);
      this.schedulePreview();
    },
    onTopCategoriesChange: function onTopCategoriesChange(selected) {
      var previousKey = (this.model.top_category_ids || []).slice().sort(function (a, b) {
        return a - b;
      }).join(',');
      this.selectedTopCategories = selected || [];
      this.model.top_category_ids = this.selectedTopCategories.map(function (cat) {
        return cat.id;
      });
      var currentKey = this.model.top_category_ids.slice().sort(function (a, b) {
        return a - b;
      }).join(',');
      if (previousKey !== currentKey) {
        this.selectedCategories = [];
        this.model.category_ids = [];
      }
      this.schedulePreview();
    },
    onCategoriesChange: function onCategoriesChange(selected) {
      this.selectedCategories = selected || [];
      this.model.category_ids = this.selectedCategories.map(function (cat) {
        return cat.id;
      });
      this.schedulePreview();
    },
    onProductsChange: function onProductsChange(selected) {
      this.selectedProducts = selected || [];
      this.model.product_ids = this.selectedProducts.map(function (p) {
        return p.id;
      });
      this.schedulePreview();
    },
    addInterval: function addInterval() {
      this.model.intervals.push({
        day: null,
        time_from: '10:00',
        time_to: '14:00'
      });
    },
    removeInterval: function removeInterval(index) {
      this.model.intervals.splice(index, 1);
    },
    timeToMinutes: function timeToMinutes(value) {
      if (!/^(?:[01][0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$/.test(String(value || ''))) return null;
      var parts = String(value).split(':').map(Number);
      return parts[0] * 60 + parts[1] + (parts[2] || 0) / 60;
    },
    intervalWindows: function intervalWindows(interval) {
      var start = this.timeToMinutes(interval.time_from);
      var end = this.timeToMinutes(interval.time_to);
      if (start === null || end === null || start === end) return [];
      var days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
      var day = this.normalizeIntervalDay(interval.day);
      var selectedDays = day === null ? [0, 1, 2, 3, 4, 5, 6] : [days.indexOf(String(day).toLowerCase())];
      return selectedDays.map(function (index) {
        return [index * 1440 + start, index * 1440 + end + (end < start ? 1440 : 0)];
      });
    },
    intervalsConflict: function intervalsConflict(first, second) {
      var firstWindows = this.intervalWindows(first);
      var secondWindows = this.intervalWindows(second);
      return firstWindows.some(function (a) {
        return secondWindows.some(function (b) {
          return [-10080, 0, 10080].some(function (offset) {
            return a[0] < b[1] + offset && b[0] + offset < a[1];
          });
        });
      });
    },
    validateIntervals: function validateIntervals() {
      if (!this.useIntervals) return true;
      var intervals = this.model.intervals || [];
      for (var i = 0; i < intervals.length; i++) {
        var from = this.timeToMinutes(intervals[i].time_from);
        var to = this.timeToMinutes(intervals[i].time_to);
        if (from === null || to === null || from === to) {
          this.errors.add('intervals', this.$t('discountCampaigns.intervalInvalidRange'));
          return false;
        }
      }
      for (var _i = 0; _i < intervals.length; _i++) {
        for (var j = _i + 1; j < intervals.length; j++) {
          if (this.intervalsConflict(intervals[_i], intervals[j])) {
            this.errors.add('intervals', this.$t('discountCampaigns.intervalOverlap'));
            return false;
          }
        }
      }
      return true;
    },
    schedulePreview: function schedulePreview() {
      var _this8 = this;

      clearTimeout(this.previewTimeout);
      if (this.hidePreview || !this.canPreview) {
        this.gridProducts = [];
        this.gridPricingData = {};
        this.gridCombos = [];
        this.gridProductsCount = 0;
        return;
      }
      this.previewTimeout = setTimeout(function () {
        _this8.gridPagination.page = 1;
        _this8.fetchPreview();
      }, this.previewDebounceMs);
    },
    onPreviewPageChange: function onPreviewPageChange(page) {
      this.gridPagination.page = page;
      this.fetchPreview();
    },
    getCampaignId: function getCampaignId() {
      var raw = this.id || this.model && this.model.id || this.route && this.route.params && this.route.params.id || null;
      if (raw == null || raw === '') return null;
      var parsed = parseInt(raw, 10);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(parsed) ? null : parsed;
    },
    buildPreviewPayload: function buildPreviewPayload() {
      var payload = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        discount: parseFloat(this.model.discount),
        discount_type: parseInt(this.model.discount_type, 10),
        price_profile_id: this.model.price_profile_id,
        source_method_combos: this.model.source_method_combos || [],
        category_ids: this.model.category_ids || [],
        top_category_ids: this.model.top_category_ids || [],
        product_ids: this.model.product_ids || [],
        number_of_units: this.model.number_of_units ? parseInt(this.model.number_of_units, 10) : null,
        units_sold_scope: parseInt(this.model.units_sold_scope, 10) || 1,
        units_sold_pool: parseInt(this.model.units_sold_pool, 10) || 1,
        page: this.gridPagination.page,
        perPage: this.gridPagination.perPage
      };
      var campaignId = this.getCampaignId();
      if (campaignId != null) {
        payload.id = campaignId;
      }
      if (this.previewFilters.name) {
        payload.name = this.previewFilters.name;
      }
      if (this.previewFilters.product_id) {
        payload.product_id = parseInt(this.previewFilters.product_id, 10);
      }
      return payload;
    },
    fetchPreview: function fetchPreview() {
      var _this9 = this;

      if (!this.canPreview) return;
      this.previewLoading = true;
      this.apiRequest('/discount-campaigns/preview', 'POST', this.buildPreviewPayload(), function (response) {
        if (response.status) {
          _this9.applyGridResponse(response.data || {});
        }
        _this9.previewLoading = false;
      });
    },
    getLineAffectingSnapshot: function getLineAffectingSnapshot() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        discount: String(this.model.discount),
        discount_type: parseInt(this.model.discount_type, 10),
        price_profile_id: this.model.price_profile_id,
        source_method_combos: [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.model.source_method_combos || [])).map(function (c) {
          return c.source + '_' + c.method;
        }).sort(),
        category_ids: [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.model.category_ids || [])).sort(),
        top_category_ids: [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.model.top_category_ids || [])).sort(function (a, b) {
          return a - b;
        }),
        product_ids: [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.model.product_ids || [])).sort(function (a, b) {
          return a - b;
        }),
        number_of_units: this.model.number_of_units ? parseInt(this.model.number_of_units, 10) : null,
        units_sold_scope: parseInt(this.model.units_sold_scope, 10) || 1,
        units_sold_pool: parseInt(this.model.units_sold_pool, 10) || 1
      });
    },
    willRegenerateLines: function willRegenerateLines() {
      if (!this.id || !this.lineAffectingSnapshot) return false;
      return this.getLineAffectingSnapshot() !== this.lineAffectingSnapshot;
    },
    validate: function validate() {
      var _this10 = this;

      this.errors.clear();
      if (!this.model.price_profile_id) {
        this.errors.add('price_profile_id', this.$t('validations.requiredField'));
      }
      if (!this.selectedSourceMethodCombos.length) {
        this.errors.add('source_method_combos', this.$t('validations.requiredField'));
      }
      if (!this.model.fromto || this.model.fromto.length !== 2) {
        this.errors.add('start_date', this.$t('validations.requiredField'));
      }
      this.validateIntervals();
      this.$validator.validateAll().then(function (isValid) {
        if (isValid && !_this10.errors.has('price_profile_id') && !_this10.errors.has('source_method_combos') && !_this10.errors.has('start_date') && !_this10.errors.has('intervals')) {
          if (_this10.willRegenerateLines()) {
            __WEBPACK_IMPORTED_MODULE_23_sweetalert2___default()({
              text: _this10.$t('discountCampaigns.regenerateWarning'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: _this10.$t('general.yes')
            }).then(function (result) {
              if (result) {
                _this10.saveCampaign();
              }
            }).catch(function () {});
          } else {
            _this10.saveCampaign();
          }
        }
      });
    },
    buildSavePayload: function buildSavePayload() {
      var _this11 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        name: this.model.name,
        description: this.model.description || '',
        active: this.model.active ? 1 : 0,
        discount: parseFloat(this.model.discount),
        discount_type: parseInt(this.model.discount_type, 10),
        price_profile_id: this.model.price_profile_id,
        source_method_combos: this.model.source_method_combos || [],
        category_ids: this.model.category_ids || [],
        top_category_ids: this.model.top_category_ids || [],
        product_ids: this.model.product_ids || [],
        number_of_units: this.model.number_of_units ? parseInt(this.model.number_of_units, 10) : null,
        units_sold_scope: parseInt(this.model.units_sold_scope, 10) || 1,
        units_sold_pool: parseInt(this.model.units_sold_pool, 10) || 1
      };
      if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
        data.start_date = this.model.fromto[0];
        data.end_date = this.model.fromto[1];
      }
      if (this.model.image) {
        data.image = this.model.image;
      } else if (Array.isArray(this.model.imagelist) && this.model.imagelist.length === 0) {
        data.image = '';
      }
      if (this.useIntervals && this.model.intervals.length) {
        data.intervals = this.model.intervals.map(function (interval) {
          return {
            day: _this11.normalizeIntervalDay(interval.day),
            time_from: _this11.normalizeIntervalTime(interval.time_from),
            time_to: _this11.normalizeIntervalTime(interval.time_to)
          };
        });
      } else {
        data.intervals = [];
      }
      return data;
    },
    saveCampaign: function saveCampaign() {
      var _this12 = this;

      this.loading = true;
      var data = this.buildSavePayload();
      var url = this.id ? '/discount-campaigns/' + this.id : '/discount-campaigns';
      var method = this.id ? 'PUT' : 'POST';
      this.apiRequest(url, method, data, function (response) {
        if (response.status === true) {
          _this12.loading = false;
          __WEBPACK_IMPORTED_MODULE_23_sweetalert2___default()({
            title: '',
            text: _this12.id ? _this12.$t('discountCampaigns.campaignUpdated') : _this12.$t('discountCampaigns.campaignAdded'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
          _this12.backButton();
        } else {
          _this12.loading = false;
          if (response.errors) {
            _this12.handleErrors(response.errors);
          } else {
            __WEBPACK_IMPORTED_MODULE_23_sweetalert2___default()('', _this12.$t('validations.wentWrong'), 'error').catch(function () {});
          }
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, prop)) {
          var msg = Array.isArray(errors[prop]) ? errors[prop][0] : errors[prop];
          this.errors.add(prop, msg);
        }
      }
    },
    deleteCampaign: function deleteCampaign() {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_23_sweetalert2___default()({
        text: this.$t('discountCampaigns.areYouSureDelete') + ' ' + (this.model.name || '') + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this13.$session.get('token'),
            company_id: _this13.$session.get('selectedCompany')
          };
          _this13.apiRequest('/discount-campaigns/' + _this13.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_23_sweetalert2___default()('', _this13.$t('discountCampaigns.campaignDeleted'), 'success').catch(function () {});
              _this13.backButton();
            } else {
              __WEBPACK_IMPORTED_MODULE_23_sweetalert2___default()('', _this13.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
    },
    handleImgChange: function handleImgChange(file, fileList) {
      var _this14 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_23_sweetalert2___default()({ toast: true, type: 'warning', text: this.$t('validations.pictureSizeExceed'), position: 'top-end', showConfirmButton: false, timer: 3000 });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
        return;
      }
      if (fileList.length > 1) {
        this.model.imagelist = fileList.slice(1);
      } else {
        this.model.imagelist = fileList;
      }
      if (this.model.imagelist[0] && this.model.imagelist[0].status === 'ready') {
        this.getBase64(this.model.imagelist[0].raw).then(function (base64enc) {
          _this14.model.image = base64enc;
        });
      }
    },
    handleRemove: function handleRemove() {
      this.model.imagelist = [];
      this.model.image = null;
    },
    handleExceed: function handleExceed() {
      __WEBPACK_IMPORTED_MODULE_23_sweetalert2___default()({ text: this.$t('discountCampaigns.removeCurrentImage'), type: 'warning', showConfirmButton: true });
    },
    backButton: function backButton() {
      if (this.embedded) {
        this.$emit('saved');
        return;
      }
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    cancelEmbedded: function cancelEmbedded() {
      this.$emit('cancel');
    }
  }
});

/***/ }),

/***/ "eQuH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isMyOrders },on:{"click":_vm.openMyOrders}},[_vm._v(_vm._s(_vm.$t('gestiune.myOrders')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isForOrders },on:{"click":_vm.openForOrders}},[_vm._v(_vm._s(_vm.$t('gestiune.forOrders')))])])])])]),_vm._v(" "),(_vm.isMyOrders)?_c('div',[_c('ManagementMyOrdersSuppliers',{attrs:{"grouped-locations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isForOrders)?_c('div',[_c('ManagementForOrdersSuppliers',{attrs:{"grouped-locations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eSji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VideoSupportCard',
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "eTop":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-options"},[_c('div',{ref:"optionsTopBar",staticClass:"options-top-bar "},[_c('h6',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.$t('catalogProd.single'))+" "+_vm._s(_vm.$t('catalogProdOpt.plural')))]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-40",attrs:{"type":"submit","title":_vm.$t('general.update')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('i',{staticClass:"ti-save"})])])])]),_vm._v(" "),_c('div',{ref:"optionsContainer",staticClass:"options-content",style:({height: _vm.windowHeight - _vm.pageTopHeight - _vm.navbarHeaderHeight - 1 + 'px'})},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix "},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]),_vm._v(" "),_c('table',{staticClass:"table align-top"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"3%"}}),_vm._v(" "),_c('th',{attrs:{"width":"15%"}},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.name')))]),_vm._v(" "),_c('th',{attrs:{"width":"17%"}},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.type')))]),_vm._v(" "),(_vm.showLocations)?_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('catalogProd.availableIn')))]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"width":"3%"}},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.menuQr')))]),_vm._v(" "),_c('th',{attrs:{"width":"3%"}},[_vm._v(_vm._s(_vm.$t('settingLocationGroups.active')))]),_vm._v(" "),_c('th',{attrs:{"width":"55%"}},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.values'))+" - "+_vm._s(_vm.$t('catalogProd.price'))+" - "+_vm._s(_vm.$t('catalogProdOpt.posid'))+" - "+_vm._s(_vm.$t('catalogCateg.vat'))+" "),_c('small',[_vm._v("("+_vm._s(_vm.$t('catalogCateg.included'))+")")]),_vm._v(" - "+_vm._s(_vm.$t('catalogProd.status')))]),_vm._v(" "),_c('th',{attrs:{"width":"5%"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.model.products_options),function(option,optionKey){return _c('tr',[_c('td',[_c('button',{staticClass:"btn btn-icon btn-danger",attrs:{"title":_vm.$t('general.remove') + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.deleteOption(option.id, optionKey)}}},[_c('i',{staticClass:"ti-close"})])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.name),expression:"option.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('catalogProdOpt.name')},domProps:{"value":(option.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "name", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"row"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.type),expression:"option.type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.optionTypes),function(opt,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(opt))])}))]),_vm._v(" "),(_vm.extraFields)?_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-md-6",staticStyle:{"padding-left":"0"}},[_c('label',{attrs:{"for":"min_no"}},[_vm._v(_vm._s(_vm.$t('catalogProd.minNoSelected')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.min_no),expression:"option.min_no"}],staticClass:"form-control",attrs:{"type":"number","name":"min_no","placeholder":_vm.$t('catalogProd.minNoSelected')},domProps:{"value":(option.min_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "min_no", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6",staticStyle:{"padding-right":"0"}},[_c('label',{attrs:{"for":"min_no"}},[_vm._v(_vm._s(_vm.$t('catalogProd.maxNoSelected')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.max_no),expression:"option.max_no"}],staticClass:"form-control",attrs:{"type":"number","name":"max_no","placeholder":_vm.$t('catalogProd.maxNoSelected')},domProps:{"value":(option.max_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "max_no", $event.target.value)}}})])]):_vm._e()]),_vm._v(" "),(_vm.showLocations)?_c('td',[[_c('v-select',{key:'option' + option.id,ref:'option' + option.id,refInFor:true,attrs:{"multiple":"","options":_vm.locations,"value":"id","label":"name","placeholder":_vm.$t('general.all')},model:{value:(option.location_ids),callback:function ($$v) {_vm.$set(option, "location_ids", $$v)},expression:"option.location_ids"}})]],2):_vm._e(),_vm._v(" "),_c('td',[[_c('div',{staticClass:"form-group pad-lf-8 pad-to-8"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{staticClass:"text-purple",attrs:{"value":option.display_in_dynamic_menu,"label":_vm.$t('displayInMenu')},model:{value:(option.display_in_dynamic_menu),callback:function ($$v) {_vm.$set(option, "display_in_dynamic_menu", $$v)},expression:"option.display_in_dynamic_menu"}})],1)])]],2),_vm._v(" "),_c('td',[[_c('div',{staticClass:"form-group pad-lf-8 pad-to-8"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{staticClass:"text-purple",attrs:{"value":option.active,"label":_vm.$t('settingLocationGroups.active')},model:{value:(option.active),callback:function ($$v) {_vm.$set(option, "active", $$v)},expression:"option.active"}})],1)])]],2),_vm._v(" "),_c('td',[_vm._l((option.values),function(val,valueKey){return [_c('tr',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(val.name),expression:"val.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml mar-bt-5",attrs:{"type":"text","placeholder":""},domProps:{"value":(val.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(val, "name", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(val.pos_id),expression:"val.pos_id"}],staticClass:"form-control sml mar-bt-5",staticStyle:{"width":"20%"},attrs:{"type":"text","placeholder":_vm.$t('catalogProdOpt.posid')},domProps:{"value":(val.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(val, "pos_id", $event.target.value)}}}),_vm._v(" "),(_vm.taxesVersion === 2)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.products_options[optionKey].values[valueKey].vat_rate_id),expression:"model.products_options[optionKey].values[valueKey].vat_rate_id"}],staticClass:"form-control sml mar-bt-5",staticStyle:{"width":"20%"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.products_options[optionKey].values[valueKey], "vat_rate_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{key:vat.id,attrs:{"disabled":_vm.isVatOptionDisabled(vat, _vm.model.products_options[optionKey].values[valueKey].vat_rate_id)},domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.rate)+"%"+_vm._s(!vat.is_active ? ' (inactiv)' : '')+"\n                        ")])})],2):_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.products_options[optionKey].values[valueKey].vat_id),expression:"model.products_options[optionKey].values[valueKey].vat_id"}],staticClass:"form-control sml mar-bt-5",staticStyle:{"width":"20%"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.products_options[optionKey].values[valueKey], "vat_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.amount)+"\n                        ")])})],2),_vm._v(" "),_c('p-checkbox',{staticClass:"text-purple",staticStyle:{"display":"inline-block","margin-left":"30px"},attrs:{"disabled":_vm.model.products_options[optionKey].values[valueKey].active && _vm.isLastActiveOptionValue(_vm.model.products_options[optionKey].values),"value":_vm.model.products_options[optionKey].values[valueKey].active,"label":_vm.$t('settingLocationGroups.active')},model:{value:(_vm.model.products_options[optionKey].values[valueKey].active),callback:function ($$v) {_vm.$set(_vm.model.products_options[optionKey].values[valueKey], "active", $$v)},expression:"model.products_options[optionKey].values[valueKey].active"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.deleteValue(optionKey, parseInt(valueKey))}}},[_c('i',{staticClass:"ti-close text-orange",attrs:{"title":_vm.$t('general.delete')}})]),_vm._v(" "),(!_vm.model.products_options[optionKey].values[valueKey].show)?_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.expandRow(optionKey, parseInt(valueKey), 1)}}},[_c('i',{staticClass:"ti-arrow-down text-grey",attrs:{"title":_vm.$t('general.delete')}})]):_vm._e(),_vm._v(" "),(_vm.model.products_options[optionKey].values[valueKey].show)?_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.expandRow(optionKey, parseInt(valueKey), 0)}}},[_c('i',{staticClass:"ti-arrow-up text-grey",attrs:{"title":_vm.$t('general.delete')}})]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),(_vm.model.products_options[optionKey].values[valueKey].show)?_c('tr',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(val.name_sgr),expression:"val.name_sgr"}],staticClass:"form-control sml mar-bt-5",attrs:{"type":"text","placeholder":_vm.$t('catalogProdOpt.sgrName')},domProps:{"value":(val.name_sgr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(val, "name_sgr", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(val.pos_id_sgr),expression:"val.pos_id_sgr"}],staticClass:"form-control sml mar-bt-5",staticStyle:{"width":"20%"},attrs:{"type":"text","placeholder":_vm.$t('catalogProdOpt.sgrPos')},domProps:{"value":(val.pos_id_sgr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(val, "pos_id_sgr", $event.target.value)}}}),_vm._v(" "),(_vm.taxesVersion === 2)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.products_options[optionKey].values[valueKey].vat_rate_id_sgr),expression:"model.products_options[optionKey].values[valueKey].vat_rate_id_sgr"}],staticClass:"form-control sml mar-bt-5",staticStyle:{"width":"20%"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.products_options[optionKey].values[valueKey], "vat_rate_id_sgr", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{key:vat.id,attrs:{"disabled":_vm.isVatOptionDisabled(vat, _vm.model.products_options[optionKey].values[valueKey].vat_rate_id_sgr)},domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.rate)+"%"+_vm._s(!vat.is_active ? ' (inactiv)' : '')+"\n                        ")])})],2):_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.products_options[optionKey].values[valueKey].vat_id_sgr),expression:"model.products_options[optionKey].values[valueKey].vat_id_sgr"}],staticClass:"form-control sml mar-bt-5",staticStyle:{"width":"20%"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.products_options[optionKey].values[valueKey], "vat_id_sgr", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(vat){return _c('option',{domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.amount)+"\n                        ")])})],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(val.price_sgr),expression:"val.price_sgr"}],staticClass:"form-control sml mar-bt-5",staticStyle:{"width":"20%"},attrs:{"type":"text","placeholder":_vm.$t('catalogProdOpt.sgrVal')},domProps:{"value":(val.price_sgr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(val, "price_sgr", $event.target.value)}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]):_vm._e()]}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.addNewValue(option.id)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.value')))])],2),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('general.duplicate') + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.duplicateOption(option.id)}}},[_c('i',{staticClass:"ti-files"})])])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_c('button',{staticClass:"btn btn-icon btn-info",on:{"click":function($event){$event.preventDefault();_vm.addNewOption()}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('catalogProdOpt.single')))])])])],2)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fg-input',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    label: String
  }
});

/***/ }),

/***/ "eU8U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eV2F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eVBd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuedraggable__);

















var _components;








__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    draggable: __WEBPACK_IMPORTED_MODULE_20_vuedraggable___default.a
  }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.company_id = this.$session.get('selectedCompany');

    this.getData();
  },
  data: function data() {
    return {
      company_id: 0,
      apiUrl: '',
      roles: [],
      kdsSections: [],
      id: this.value || this.tableId,
      isNew: true,
      filelist: [],
      model: {
        'id': 0,
        'name': '',
        'location_id': '',
        'images': [],
        'location': {
          'id': null
        },
        'type': 3
      },
      type: ['ODS', 'POS', 'DSS'],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '24:00'
      },
      locations: [],
      modelValidate: {
        type: { required: true },
        server_ip: { required: true }
      },
      languages: [{ 'id': 'ro', 'label': 'Romana' }, { 'id': 'en', 'label': 'English' }, { 'id': 'es', 'label': 'Espagnol' }, { 'id': 'gr', 'label': 'Greek' }, { 'id': 'cz', 'label': 'Czech' }],
      loading: true
    };
  },

  methods: {
    getKdsSections: function getKdsSections() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.company_id
      };
      this.apiRequest('/kds-sections', 'GET', data, function (response) {
        if (response.status === true) {
          _this.kdsSections = response.data;

          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    },
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy);
    },
    getData: function getData() {
      var _this2 = this;

      this.locations = [];
      var requestData = {
        token: this.$session.get('token'),
        company_id: this.company_id
      };
      var id = this.route.params.id;
      if (id) {
        this.apiRequest('/pos/screens/' + id, 'GET', requestData, function (response) {
          if (response.status) {
            _this2.model = response.data.screens;
            _this2.model.pos_image = [{ 'url': _this2.model.pos_image }];
            _this2.model.images = _this2.model.images.map(function (item) {
              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, {
                images: item.images.map(function (img) {
                  return { url: img };
                })
              });
            });
          }
        });
      }

      this.apiRequest('/get-locations', 'GET', requestData, function (response) {
        if (response.status) {
          _this2.locations = response.data;
        }
      });
      this.$nextTick(function () {
        _this2.loading = false;
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.saveTable();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    saveTable: function saveTable() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, companyID, id, url, request;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.$nextTick(function () {
                  _this4.loading = true;
                });

                if (_this4.model.location && _this4.model.location.id != null && _this4.model.location.id !== 'null') {
                  _this4.model.location_id = _this4.model.location.id;
                }
                _context.prev = 2;
                _context.next = 5;
                return _this4.ensureSlideImagesBase64();

              case 5:
                _context.next = 12;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](2);

                _this4.$nextTick(function () {
                  _this4.loading = false;
                });
                __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
                  toast: true,
                  type: 'warning',
                  text: _this4.$t('validations.wentWrong'),
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000
                });
                return _context.abrupt('return');

              case 12:
                data = _this4.model;
                companyID = _this4.company_id;

                data.token = _this4.$session.get('token');
                data.company_id = companyID;

                id = _this4.id || _this4.route.params.id;
                url = '';
                request = '';

                if (id) {
                  url = '/pos/screens/' + id;
                  request = 'PUT';
                } else {
                  url = '/pos/screens/add';
                  request = 'POST';
                }
                _this4.apiRequest(url, request, data, function (response) {
                  if (response.status === true) {
                    _this4.$nextTick(function () {
                      _this4.loading = false;
                    });
                    _this4.errors.clear();
                    if (request === 'POST') {
                      _this4.$bus.$emit('refresh');
                      _this4.$bus.$emit('close-modal');
                    } else {
                      _this4.backButton();
                    }
                    __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
                      title: '',
                      text: _this4.$t('settingTable.tableSave'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    });
                  } else {
                    _this4.$nextTick(function () {
                      _this4.loading = false;
                    });
                    _this4.handleErrors(response.errors);
                  }
                });

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[2, 7]]);
      }))();
    },
    deleteOrderScreen: function deleteOrderScreen() {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.loadingReset = true;
      });
      var id = this.id || this.route.params.id;
      var data = {
        company_id: this.company_id,
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/pos/screens/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          _this5.$nextTick(function () {
            _this5.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this5.backButton();
        } else {
          _this5.$nextTick(function () {
            _this5.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({ 'text': _this5.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    deleteToken: function deleteToken() {
      var _this6 = this;

      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany'),
        'screen_id': this.model.id
      };
      __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
        type: 'question',
        title: this.$t('settingTable.deleteZoneTitle'),
        text: this.$t('settingTable.disableAuthScreenInfo'),
        position: 'top-end',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        allowOutsideClick: false
      }).then(function (result) {
        _this6.apiRequest('/pos/screens/delete-token', 'POST', data, function (response) {
          _this6.model.login_token = null;
        });
      });
    },
    backButton: function backButton() {
      this.$session.set('selectedTab', this.$t('pages.digitalSignage'));
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    updateLocationId: function updateLocationId(event) {
      if (event.target.value !== 'null') {
        var selectedLocation = this.locations.find(function (item) {
          return parseInt(item.id) === parseInt(event.target.value);
        });
        this.model.location_id = selectedLocation.id;
      }
    },
    addNewImageGroup: function addNewImageGroup() {
      var newRow = {
        'images': [],
        'from': '00:00',
        'to': '24:00',
        'time': 10,
        'active': true
      };
      if (!this.model.images) {
        this.model.images = [];
      }
      this.model.images.push(newRow);
    },
    deleteValue: function deleteValue(index) {
      this.model.images.splice(index, 1);
    },
    handleRemove: function handleRemove(file, fileList, index) {
      if (this.model.images[index]) {
        this.$set(this.model.images[index], 'images', fileList || []);
      }
    },
    ensureSlideImagesBase64: function ensureSlideImagesBase64() {
      var _this7 = this;

      var groups = this.model.images || [];
      var tasks = [];
      groups.forEach(function (group) {
        (group.images || []).forEach(function (img) {
          if (img && img.raw && !img.base64enc) {
            tasks.push(_this7.getBase64(img.raw).then(function (base64enc) {
              _this7.$set(img, 'base64enc', base64enc);
            }));
          }
        });
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(tasks);
    },
    handleImgChnage: function handleImgChnage(file, fileList, index) {
      var self = this;
      var pp = this.model.images;
      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        self.$refs.upload.clearFiles();
        pp[index].images = [];
      } else {
        pp[index].images = fileList;
      }
      this.model.images = null;
      this.model.images = pp;
      this.ensureSlideImagesBase64().catch(function () {});
    },
    handleImgChnagePosImage: function handleImgChnagePosImage(file, fileList) {
      var _this8 = this;

      var pp = this.model;

      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        pp.pos_image = [];
      } else {
        if (fileList.length > 1) {
          pp.pos_image = fileList.slice(1);
        } else {
          pp.pos_image = fileList;
        }
      }
      this.model = null;
      this.model = pp;
      this.getBase64(this.model.pos_image[0].raw).then(function (base64enc) {
        _this8.model.pos_image[0].base64enc = base64enc;
      });
    },
    handleRemovePosImage: function handleRemovePosImage(file, fileList) {
      if (fileList.length === 0) {
        this.model.pos_image = [];
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
        text: this.$t('general.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    }
  }
});

/***/ }),

/***/ "eYd0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eZ11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticStyle:{"margin-bottom":"50px"}},[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.$route.params.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteOrderScreen($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('error'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":"ID"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Name"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.location')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.location_id),expression:"modelValidate.location_id"},{name:"model",rawName:"v-model",value:(_vm.model.location_id),expression:"model.location_id"}],staticClass:"form-control",attrs:{"name":"location","disabled":_vm.id ? true : false},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getTables()}]}},[_c('option',{attrs:{"value":"null","disabled":""}},[_vm._v(_vm._s(_vm.$t('general.none')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Scale Factor")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scaleFactor),expression:"scaleFactor"}],staticClass:"form-control-range",attrs:{"type":"range","min":"0.5","max":"1.5","step":"0.1"},domProps:{"value":(_vm.scaleFactor)},on:{"change":function($event){_vm.updateTableManagerMapsDimensions()},"__r":function($event){_vm.scaleFactor=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.allow_some_top_categories_map')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-select',{key:"methods",staticStyle:{"width":"100%","color":"#fff"},attrs:{"name":"methods","multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.model.allowed_top_categories),callback:function ($$v) {_vm.$set(_vm.model, "allowed_top_categories", $$v)},expression:"model.allowed_top_categories"}},[_c('el-option',{key:0,attrs:{"value":null,"label":_vm.$t('general.all'),"disabled":""}}),_vm._v(" "),_vm._l((_vm.topCategories),function(item){return [_c('el-option',{attrs:{"value":item.id,"label":item.name}})]})],2)],1)])])])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-md-9"},[_c('div',{ref:"svgMap",staticClass:"map"},[_c('p',[_vm._v("Harta:")]),_vm._v(" "),_c('div',{class:(_vm.loadingTable ? 'show-loader' : 'hide-loader')},[_vm._m(1)]),_vm._v(" "),(_vm.tables)?_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('svg',{staticClass:"harta-bg",staticStyle:{"border":"1px solid #ddd"},attrs:{"width":"100%","height":"100%"},on:{"drop":_vm.onDrop,"dragover":function($event){$event.preventDefault();},"mousemove":_vm.resizeTable,"mouseup":_vm.endResize}},[_vm._l((_vm.model.table_manager_maps),function(table,index){return [(!table.deleted)?[_c('g',{key:index},[(table.table_manager_id !== -1)?_c('foreignObject',{staticStyle:{"cursor":"move"},attrs:{"x":table.draw_data.x,"y":table.draw_data.y,"width":table.draw_data.width,"height":table.draw_data.height,"transform":'rotate(' + table.draw_data.rotation + ' ' + (table.draw_data.x + table.draw_data.width / 2) + ' ' + (table.draw_data.y + table.draw_data.height / 2) + ')'},on:{"mousedown":function($event){_vm.selectTable(index, $event)}}},[_c(_vm.getTableComponent(table.table_manager_id),{tag:"component"})],1):_vm._e(),_vm._v(" "),(table.table_manager_id === -1)?_c('rect',{staticStyle:{"cursor":"move"},attrs:{"x":table.draw_data.x,"y":table.draw_data.y,"width":table.draw_data.width,"height":table.draw_data.height,"transform":'rotate(' + table.draw_data.rotation + ' ' + (table.draw_data.x + table.draw_data.width / 2) + ' ' + (table.draw_data.y + table.draw_data.height / 2) + ')',"fill":"#000"},on:{"mousedown":function($event){_vm.selectTable(index, $event)}}}):_vm._e(),_vm._v(" "),_c('text',{staticStyle:{"user-select":"none"},attrs:{"x":table.draw_data.x + table.draw_data.width / 2,"y":table.draw_data.y + table.draw_data.height / 2,"text-anchor":"middle","alignment-baseline":"middle","fill":"#fff","font-size":"14","pointer-events":"none"}},[(table.table_manager_id !== -1)?[_vm._v("\n                        "+_vm._s(_vm.tableMapTableNumber(table.table_manager_id))+"\n                      ")]:[_vm._v("Obiect")]],2),_vm._v(" "),_c('text',{staticStyle:{"cursor":"pointer","user-select":"none"},attrs:{"x":table.draw_data.x - 5,"y":table.draw_data.y + 15,"fill":"#FF0000","font-size":"16","font-weight":"bold"},on:{"click":function($event){$event.stopPropagation();_vm.deleteTable(index, table.table_manager_id)}}},[_vm._v("\n                      X\n                    ")]),_vm._v(" "),(table.table_manager_id !== -1)?_c('text',{staticStyle:{"cursor":"pointer","user-select":"none"},attrs:{"x":table.draw_data.x + table.draw_data.width - 10,"y":table.draw_data.y + 15,"fill":"#fff","font-size":"16"},on:{"click":function($event){$event.stopPropagation();_vm.editTable(table)}}},[_vm._v("\n                      ✏️\n                    ")]):_vm._e(),_vm._v(" "),(table.table_manager_id === -1)?_c('circle',{staticStyle:{"cursor":"se-resize"},attrs:{"cx":table.draw_data.x + table.draw_data.width,"cy":table.draw_data.y + table.draw_data.height,"r":"5","fill":"#674BD2"},on:{"mousedown":function($event){$event.stopPropagation();_vm.startResize(index)}}}):_vm._e()],1),_vm._v(" "),_c('text',{staticStyle:{"cursor":"pointer","user-select":"none"},attrs:{"x":table.draw_data.x + table.draw_data.width - 30,"y":table.draw_data.y + 15,"fill":"#fff","font-size":"16"},on:{"click":function($event){$event.stopPropagation();_vm.rotateTable(index, 10)}}},[_vm._v("\n                  🔄\n                ")])]:_vm._e()]})],2)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('p',[_vm._v("Mese:")]),_vm._v(" "),_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loadingTable ? 'show-loader' : 'hide-loader')},[_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"allTables"},[_c('div',{staticClass:"table newTable",attrs:{"draggable":"true"},on:{"dragstart":function($event){_vm.onDragStartNew($event)}}},[_vm._v("+ Masa Noua")]),_vm._v(" "),_c('div',{staticClass:"table newTable",attrs:{"draggable":"true"},on:{"dragstart":function($event){_vm.onDragObject($event)}}},[_vm._v("+ Obiect")]),_vm._v(" "),_c('p',[_vm._v("Mese existante:")]),_vm._v(" "),_c('div',{staticClass:"scrolDiv"},[_vm._l((_vm.tables),function(table){return [(!table.table_maps_id)?_c('div',{staticClass:"table",attrs:{"draggable":"true"},on:{"dragstart":function($event){_vm.onDragStart($event, table)}}},[_c('span',{staticClass:"edit1",on:{"click":function($event){_vm.editTable(null, table)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),_c('p',{staticClass:"number"},[_vm._v(_vm._s(table.number))]),_vm._v(" "),_c('div',[_c('p',{staticClass:"type"},[_vm._v(_vm._s(_vm.$t('settingTable.type'))+": "+_vm._s(table.type))]),_vm._v(" "),_c('p',{staticClass:"zone"},[_vm._v(_vm._s(_vm.$t('settingTable.zone'))+": "+_vm._s(table.zone))])])]):_vm._e()]})],2)])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-right"}},[(_vm.showTableModal)?_c('global-modal',{on:{"close":_vm.closeTableModal}},[_c('table-management-form',{attrs:{"callback":_vm.tableManagementUpdate,"tableId":_vm.selectedTable,"fromExternal":true,"autoselectLocation":_vm.model.location_id,"posUsers":_vm.formattedUsers},on:{"on-submit":_vm.onUserSubmit}},[_c('a',{staticClass:"btn btn-orange btn-icon back table-modal-back",attrs:{"slot":"back-button","title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.closeTableModal($event)}},slot:"back-button"},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])],1):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("Trage din dreapta mesele si aseazale pe harta")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',[_vm._v("Selecteaza locatia...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('span',[_vm._v("Selecteaza locatia...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eZ5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ec2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__ = __webpack_require__("2OT1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f51a13a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__ = __webpack_require__("3xT/");
function injectStyle (ssrContext) {
  __webpack_require__("yecq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f51a13a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f51a13a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ech5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_tree_css__ = __webpack_require__("s967");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_tree_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_tree_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tree__ = __webpack_require__("855/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_radio_css__ = __webpack_require__("8jhb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_radio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_radio_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_radio__ = __webpack_require__("RDoK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__spinningWheelCoupon__ = __webpack_require__("HDqy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_tree_halower_dist_halower_tree_min_css__ = __webpack_require__("ug9+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_tree_halower_dist_halower_tree_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_tree_halower_dist_halower_tree_min_css__);
























var ORDER_SOURCE_LABELS = {
  1: 'kiosk',
  2: 'qr',
  3: 'pos',
  4: 'app',
  5: 'website'
};

__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_radio___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_tree___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    userLabelLevels: {
      type: [Object, Array],
      required: true
    },
    modelFromParent: {
      type: [Object, Array]
    },
    couponsParent: {
      type: [Object, Array],
      required: true
    },
    groupedProductsParent: {
      type: [Object, Array]
    },
    halfChecksProp: {
      type: [Object, Array]
    },
    couponError: {
      type: String,
      required: false
    },
    customerGroups: {
      type: [Object, Array]
    },
    selectedCustomerGroups: {
      type: [Object, Array, String],
      required: false
    },
    checkedKeys: {
      type: Array
    },
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    standalone: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    filterText: function filterText(val) {
      if (this.$refs.tree) this.$refs.tree.filter(val);
    },
    modelFromParent: function modelFromParent(value) {
      if (!value || Array.isArray(value) || (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(value)) !== 'object') {
        return;
      }
      this.activeButton = value.type;
      this.addcoupon = value.type === 'COUPON';
      this.model = value;
      this.normalizeModelOrderSourceIds();
      this.syncSelectedOrderSourcesFromModel();
    },
    'coupons.coupon_code': function couponsCoupon_code() {
      this.refreshSingleQr();
    },

    pagedCodes: {
      handler: function handler() {
        this.refreshPagedCodesQr();
      },

      deep: true
    },
    'coupons.coupon_has_multiple_codes': function couponsCoupon_has_multiple_codes() {
      this.refreshSingleQr();
    },
    isSubscriptionCoupon: function isSubscriptionCoupon(value) {
      if (!value) {
        return;
      }
      this.coupons.auto_apply = false;
      this.coupons.second_use_auto_coupon = false;
      this.coupons.coupon_has_multiple_codes = false;

      this.$set(this.coupons, 'is_cumulative', true);
      this.coupons.coupon_code = null;
      this.coupons.counter_max_usage = null;
      this.coupons.counter_max_usage_total = null;
    },
    isAutomationCoupon: function isAutomationCoupon(value) {
      if (!value) {
        return;
      }
      this.coupons.auto_apply = false;
      this.coupons.second_use_auto_coupon = false;
      this.coupons.coupon_has_multiple_codes = false;
      this.coupons.counter_max_usage = null;
      this.coupons.counter_max_usage_total = null;
    },
    couponsParent: function couponsParent(value) {
      var _this = this;

      if (!value || Array.isArray(value)) {
        return;
      }
      this.coupons = value;
      this.seedCodeQrLinks();
      this.syncFreeProductSelection();
      this.coupons.user_label_selected = this.userLabelLevels.find(function (option) {
        return option.key === _this.coupons.user_label_id;
      });
    },
    couponError: function couponError() {
      if (this.couponError) {
        this.coupons.coupon_code = null;
        this.validate();
      }
    },
    halfChecksProp: function halfChecksProp(value) {
      this.halfChecks = value;
    },
    'coupons.type': function couponsType(value) {
      var _this2 = this;

      if (value === 'FREE_PRODUCT') {
        this.$nextTick(function () {
          _this2.syncFreeProductSelection();
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vee_validate__["b" /* mapFields */])(['firstName', 'lastName', 'email']), {
    isSubscriptionCoupon: function isSubscriptionCoupon() {
      return !!(this.coupons && this.coupons.is_subscription);
    },
    isAutomationCoupon: function isAutomationCoupon() {
      return !!(this.coupons && this.coupons.is_automation);
    },
    automationCodeValidation: function automationCodeValidation() {
      return this.modelValidations.automationCodeValidation;
    },
    isSpinningWheelFreeProductCoupon: function isSpinningWheelFreeProductCoupon() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__spinningWheelCoupon__["a" /* isSpinningWheelFreeProductCoupon */])(this.coupons, this.model);
    },
    isFreeProductCoupon: function isFreeProductCoupon() {
      return this.coupons.type === 'FREE_PRODUCT';
    },
    activeCodes: function activeCodes() {
      return (this.coupons.coupons_codes || []).map(function (row, index) {
        return { row: row, index: index };
      }).filter(function (item) {
        return !item.row.delete;
      });
    },
    pagedCodes: function pagedCodes() {
      var start = (this.codesPage - 1) * this.codesPageSize;
      return this.activeCodes.slice(start, start + this.codesPageSize);
    },
    generatorExample: function generatorExample() {
      var alphabets = {
        alnum: 'ABCDEFGHJKMNPQRSTUVWXYZ23456789',
        letters: 'ABCDEFGHJKMNPQRSTUVWXYZ',
        digits: '0123456789'
      };
      var alphabet = alphabets[this.generator.charset] || alphabets.alnum;
      var length = Math.min(Math.max(parseInt(this.generator.length, 10) || 8, 4), 20);
      var random = '';
      for (var i = 0; i < length; i++) {
        random += alphabet[(i * 7 + 3) % alphabet.length];
      }
      var group = parseInt(this.generator.group, 10) || 0;
      if (group > 0) {
        random = random.match(new RegExp('.{1,' + group + '}', 'g')).join('-');
      }
      return (this.generator.prefix || '').toUpperCase() + random + (this.generator.suffix || '').toUpperCase();
    },
    isCampaignModel: function isCampaignModel() {
      return this.model && !Array.isArray(this.model) && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.model) === 'object';
    },

    editableCustomerGroups: {
      get: function get() {
        return this.selectedCustomerGroups;
      },
      set: function set(val) {
        this.$emit('groupCustomers', val);
      }
    },
    orderSourceOptions: function orderSourceOptions() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(ORDER_SOURCE_LABELS).map(function (id) {
        return {
          id: parseInt(id, 10),
          label: _this3.orderSourceLabel(ORDER_SOURCE_LABELS[id], id)
        };
      });
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    this.$validator.extend('customConditionCouponValue', function (value) {
      var required = true;
      var valid = true;
      if (_this4.isFreeProductCoupon) {
        return { valid: true, data: { required: false } };
      }
      if (_this4.coupons.type === 'PERCENTAGE') {
        if (value > 100) {
          valid = false;
        }
      }
      if (parseInt(value) <= 0) {
        valid = false;
      }
      if (_this4.model.is_waterfall) {
        valid = true;
      }
      return {
        'error-messages': ['aaaaaaaaaaaaaaaaa'],
        valid: valid,
        data: {
          required: required,
          message: 'Not this value'
        }
      };
    }, {
      computesRequired: true
    });
    this.$validator.extend('customCondition', function (value) {
      var required = true;
      var valid = true;
      if (_this4.coupons.type === 'PERCENTAGE') {
        if (value > 100) {
          valid = false;
        }
      }
      if (parseInt(value) <= 0) {
        valid = false;
      }
      return {
        'error-messages': ['aaaaaaaaaaaaaaaaa'],
        valid: valid,
        data: {
          required: required,
          message: 'Not this value'
        }
      };
    }, {
      computesRequired: true
    });
  },
  created: function created() {
    var _this5 = this;

    this.onCreatedGetUserLabeling();
    this.loadDefaultFreeProducts();
    if (this.isCampaignModel) {
      this.normalizeModelOrderSourceIds();
      this.syncSelectedOrderSourcesFromModel();
    }
    if (!this.coupons.from_value) {
      this.coupons.from_value = 0;
    }
    this.seedCodeQrLinks();
    this.singleQrUrl = this.coupons.qr_url || null;
    if (!this.singleQrUrl) {
      this.refreshSingleQr();
    }
    this.$nextTick(function () {
      _this5.getCategories();
    });
  },
  data: function data() {
    return {
      importedCodes: '',
      newCategories: [],
      treeLoading: false,
      singleQrUrl: null,
      singleQrTimer: null,
      exporting: false,
      generating: false,
      generatorError: null,
      generator: {
        count: 100,
        length: 8,
        charset: 'alnum',
        prefix: '',
        suffix: '',
        group: 0
      },

      codeQrLinks: {},
      codeQrTimer: null,
      codesPage: 1,
      codesPageSize: 25,
      codesPageSizes: [25, 50, 100],
      filterText: '',
      expand: [],
      model: this.value || this.modelFromParent,
      groupedProducts: this.value || this.groupedProductsParent,
      customCondition: {},
      customConditionCouponValue: {},
      modelValidations: {
        coupons_codes: {
          code: {
            required: true,
            min: 4
          }
        },
        from_value: {
          required: true,
          min_value: 0
        },
        type: {
          required: true
        },
        usage_type: {
          required: true
        },
        discount: {
          required: true,
          min_value: 1
        },
        coupon_code: {
          required: true,
          min: 4
        },

        automationCodeValidation: {
          min: 4
        },
        counter_max_usage: {
          required: true,
          min: 0
        },
        counter_max_usage_total: {
          required: true,
          min: 0
        },
        interval_settings: {
          from: {
            required: true
          },
          to: {
            required: true
          }
        }
      },
      coupons: this.value || this.couponsParent,
      couponType: this.$session.get('defaultData')['coupons_types'],
      couponUsageTypes: this.$session.get('defaultData')['coupons_usage_types'],
      pickerOptions1: {},
      pickerNames: ['date_from', 'date_to'],
      searchword: '',
      activeButton: 0,
      addcoupon: false,
      treeData: [],
      currency: '',
      deliveryMethods: [],
      locations: [],
      intervals: [],
      errorInterval: null,
      errorTree: null,
      errorFreeProduct: null,
      freeProducts: [],
      selectedFreeProduct: null,
      loadingFreeProducts: false,
      freeProductSearchTimer: null,
      intervalDays: [],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '24:00'
      },
      days: [{
        key: 'monday',
        label: this.$t('days.monday')
      }, {
        key: 'tuesday',
        label: this.$t('days.tuesday')
      }, {
        key: 'wednesday',
        label: this.$t('days.wednesday')
      }, {
        key: 'thursday',
        label: this.$t('days.thursday')
      }, {
        key: 'friday',
        label: this.$t('days.friday')
      }, {
        key: 'saturday',
        label: this.$t('days.saturday')
      }, {
        key: 'sunday',
        label: this.$t('days.sunday')
      }],
      checkProducts: false,
      halfChecks: [],
      selectedOrderSources: [],
      treeConfig: {
        id: 'id',
        label: 'name',
        isLeaf: 'leaf',
        level: 'level',
        children: 'children',
        loading: false,
        loadedOnce: false
      }
    };
  },

  methods: {
    orderSourceLabel: function orderSourceLabel(label, orderSourceId) {
      var resolvedLabel = label || ORDER_SOURCE_LABELS[orderSourceId];
      if (!resolvedLabel) {
        return '';
      }
      var key = 'orderFrom.' + resolvedLabel;
      var translated = this.$t(key);
      if (translated !== key) {
        return translated;
      }
      var upperKey = 'orderFrom.' + String(resolvedLabel).toUpperCase();
      var upperTranslated = this.$t(upperKey);
      return upperTranslated !== upperKey ? upperTranslated : resolvedLabel;
    },
    normalizeModelOrderSourceIds: function normalizeModelOrderSourceIds() {
      if (!this.isCampaignModel) {
        return;
      }
      var raw = this.model.order_source_ids;
      if (raw == null || raw === '') {
        this.$set(this.model, 'order_source_ids', []);
        return;
      }
      var ids = raw;
      if (typeof raw === 'string') {
        try {
          ids = JSON.parse(raw);
        } catch (e) {
          ids = [];
        }
      }
      if (!Array.isArray(ids)) {
        this.$set(this.model, 'order_source_ids', []);
        return;
      }
      this.$set(this.model, 'order_source_ids', ids.map(function (id) {
        return parseInt(id, 10);
      }).filter(function (id) {
        return !isNaN(id);
      }));
    },
    syncSelectedOrderSourcesFromModel: function syncSelectedOrderSourcesFromModel() {
      if (!this.isCampaignModel) {
        this.selectedOrderSources = [];
        return;
      }
      var ids = this.model.order_source_ids;
      if (!Array.isArray(ids) || !ids.length) {
        this.selectedOrderSources = [];
        return;
      }
      var normalizedIds = ids.map(function (id) {
        return parseInt(id, 10);
      }).filter(function (id) {
        return !isNaN(id);
      });
      this.selectedOrderSources = this.orderSourceOptions.filter(function (option) {
        return normalizedIds.includes(option.id);
      });
    },
    onOrderSourcesChanged: function onOrderSourcesChanged(value) {
      this.selectedOrderSources = value || [];
      if (!this.isCampaignModel) {
        return;
      }
      this.$set(this.model, 'order_source_ids', this.selectedOrderSources.map(function (option) {
        return option.id;
      }));
    },
    importCodes: function importCodes() {
      var _this6 = this;

      var arrayCodes = this.importedCodes.split(/[\s,;]+/).filter(function (code) {
        return code !== '';
      });
      this.importedCodes = '';
      arrayCodes.forEach(function (code) {
        _this6.coupons.coupons_codes.push({ 'code': code });
      });
    },
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    refreshSingleQr: function refreshSingleQr() {
      var _this7 = this;

      clearTimeout(this.singleQrTimer);
      var code = (this.coupons.coupon_code || '').trim();
      if (this.coupons.coupon_has_multiple_codes || !code) {
        this.singleQrUrl = null;
        return;
      }
      this.singleQrTimer = setTimeout(function () {
        _this7.apiRequest('/coupon/qr-links', 'POST', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this7.requestData(), { codes: [code] }), function (response) {
          if (response.status === true && response.data.length && (_this7.coupons.coupon_code || '').trim() === code) {
            _this7.singleQrUrl = response.data[0].qr_url;
          }
        });
      }, 400);
    },
    generateCodes: function generateCodes() {
      var _this8 = this;

      this.generatorError = null;
      this.generating = true;
      var data = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.requestData(), this.generator, {
        exclude: this.activeCodes.map(function (item) {
          return item.row.code;
        })
      });
      this.apiRequest('/coupon/generate-codes', 'POST', data, function (response) {
        _this8.generating = false;
        if (response.status !== true) {
          var errors = response.errors || {};
          var first = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(errors).map(function (key) {
            return Array.isArray(errors[key]) ? errors[key][0] : errors[key];
          })[0];
          _this8.generatorError = first || _this8.$t('validations.wentWrong');
          return;
        }
        var codes = response.data.codes || [];
        if (!Array.isArray(_this8.coupons.coupons_codes)) {
          _this8.$set(_this8.coupons, 'coupons_codes', []);
        }
        codes.forEach(function (code) {
          return _this8.coupons.coupons_codes.push({ code: code });
        });
        _this8.codesPage = Math.max(1, Math.ceil(_this8.activeCodes.length / _this8.codesPageSize));
        _this8.$notify({
          message: _this8.$t('marketingCoupons.generatedCodes', { count: codes.length }),
          type: 'success'
        });
      });
    },
    exportCodes: function exportCodes() {
      var _this9 = this;

      var multiple = !!this.coupons.coupon_has_multiple_codes;
      var rows = multiple ? this.activeCodes.map(function (item) {
        return item.row;
      }).filter(function (row) {
        return (row.code || '').trim() !== '';
      }) : [{ code: (this.coupons.coupon_code || '').trim() }].filter(function (row) {
        return row.code !== '';
      });
      if (!rows.length) {
        return;
      }
      this.exporting = true;
      this.apiRequest('/coupon/qr-links', 'POST', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.requestData(), { codes: rows.map(function (row) {
          return row.code.trim();
        }) }), function (response) {
        _this9.exporting = false;
        if (response.status !== true) {
          _this9.$notify({ message: _this9.$t('validations.wentWrong'), type: 'danger' });
          return;
        }
        var linkByCode = {};
        response.data.forEach(function (item) {
          linkByCode[item.code] = item.qr_url;
        });
        var quote = function quote(value) {
          return '"' + String(value == null ? '' : value).replace(/"/g, '""') + '"';
        };
        var header = [_this9.$t('marketingCoupons.code'), _this9.$t('marketingCoupons.qrLink')];
        if (multiple) {
          header.push(_this9.$t('marketingCoupons.used'));
        }
        var lines = [header.map(quote).join(';')];
        rows.forEach(function (row) {
          var line = [row.code.trim(), linkByCode[row.code.trim()] || ''];
          if (multiple) {
            line.push(parseInt(row.used, 10) === 1 ? _this9.$t('general.yes') : _this9.$t('general.no'));
          }
          lines.push(line.map(quote).join(';'));
        });

        var blob = new Blob(['\uFEFF' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        var name = String(_this9.coupons.name || _this9.coupons.coupon_code || 'cupon').replace(/[^a-zA-Z0-9-_]+/g, '_');
        a.href = url;
        a.download = 'coduri-' + name + '.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      });
    },
    checkAll: function checkAll() {
      var nodes = this.$refs.tree.store.root.childNodes;
      var checkedKeys = nodes.map(function (node) {
        return node.key;
      });
      this.$refs.tree.setCheckedKeys(checkedKeys);
    },
    resetProductTree: function resetProductTree() {
      this.$refs.tree.setCheckedKeys([]);
    },
    loadProducts: function loadProducts(node) {
      var _this10 = this;

      var treeNode = this.$refs.tree.getNode(node);
      var locationIds = [];
      if (this.coupons['location_ids']) {
        locationIds = this.coupons['location_ids'].map(function (loc) {
          return loc.id;
        });
      }
      if (!this.expand.includes(node.id) && !node.loadedOnce) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          category_id: parseInt(node.id),
          location_ids: locationIds
        };
        node.loading = true;
        this.apiRequest('/product-tree-products', 'GET', data, function (response) {
          if (response.status) {
            node.children = response.data;
            node.expand = true;
            node.loading = false;
            node.loadedOnce = true;
            _this10.$nextTick(function () {
              if (treeNode.checked) {
                _this10.$refs.tree.setCheckedNodes(_this10.$refs.tree.getCheckedNodes().concat(treeNode.children));
              }
            });
          }
        });
      }
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;

      if (data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
        return true;
      }

      if (data.children) {
        for (var i = 0; i < data.children.length; i++) {
          if (this.filterNode(value, data.children[i])) {
            return true;
          }
        }
      }
      return false;
    },
    loadNode: function loadNode(node, resolve) {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        category_id: parseInt(node.data.id),
        category_name: node.data.name
      };
      this.apiRequest('/product-tree-category-products', 'GET', data, function (response) {
        if (response.status) {
          resolve(response.data.products);
        }
      });
    },
    getCategories: function getCategories() {
      var _this11 = this;

      var locationIds = [];
      if (this.coupons['location_ids']) {
        locationIds = this.coupons['location_ids'].map(function (loc) {
          return loc.id;
        });
      }
      var groupData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        usage_for_products: this.coupons['usage_for_products'],
        usage_for_categories: this.coupons['usage_for_categories'],
        location_ids: locationIds
      };
      if (this.standalone) {
        if (this.coupons && this.coupons.id) {
          groupData.coupon_id = this.coupons.id;
        }
      } else if (this.route.params.id) {
        groupData.campaign_id = this.route.params.id;
      }
      if (this.coupons && this.coupons.location_ids) {
        var _locationIds = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.coupons.location_ids), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var loc = _step.value;

            _locationIds.push(loc.id);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        groupData.location_ids = _locationIds;
      }
      this.treeLoading = true;
      this.apiRequest('/get-tree', 'GET', groupData, function (response) {
        _this11.treeLoading = false;
        if (response.status === true) {
          _this11.newCategories = response.data.tree;
          _this11.expand = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(response.data.expand);
        }
      });
    },
    onCreatedGetUserLabeling: function onCreatedGetUserLabeling() {
      this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso);
      this.deliveryMethods = this.getCompanyDetail('delivery_options_labels');
      this.locations = this.getCompanyDetail('locations_details');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      this.errors.clear();
      this.errorTree = null;
      this.errorFreeProduct = null;

      if (this.isFreeProductCoupon && !this.coupons.free_product_id) {
        this.errorFreeProduct = this.$t('marketingCampaigns.freeProductRequired');
        return false;
      }

      if (this.coupons.use_time_interval) {
        if (this.coupons.interval_settings === undefined || this.coupons.interval_settings === '' || this.coupons.interval_settings === null || this.coupons.interval_settings.length === 0) {
          this.errorInterval = this.$t('marketingCampaigns.intervalMustBeSet');
          return false;
        }
        for (var i = 0; i < this.coupons.interval_settings.length; i++) {
          var interval = this.coupons.interval_settings[i];
          if (!interval.from || interval.from === '') {
            this.errors.add('interval_from_' + i, this.$t('validations.requiredField'));
          }
          if (!interval.to || interval.to === '') {
            this.errors.add('interval_to_' + i, this.$t('validations.requiredField'));
          }
        }
        if (this.errors.items.some(function (item) {
          return item.field.startsWith('interval_from_') || item.field.startsWith('interval_to_');
        })) {
          return false;
        }
      }

      if (this.coupons['usage_type'] === 'PRODUCTS' && !this.isSpinningWheelFreeProductCoupon) {
        var checkedKeys = this.$refs.tree.getCheckedKeys();
        if (checkedKeys.length === 0) {
          this.errorTree = this.$t('marketingCampaigns.productTreeError');
          return false;
        } else {
          this.errorTree = null;
          return true;
        }
      }
      return this.$validator.validateAll();
    },
    loadDefaultFreeProducts: function loadDefaultFreeProducts() {
      this.searchFreeProducts('', true);
    },
    searchFreeProducts: function searchFreeProducts(search) {
      var _this12 = this;

      var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.freeProductSearchTimer) {
        clearTimeout(this.freeProductSearchTimer);
        this.freeProductSearchTimer = null;
      }

      var query = (search || '').trim();
      var delay = immediate ? 0 : 300;

      this.freeProductSearchTimer = setTimeout(function () {
        var data = {
          token: _this12.$session.get('token'),
          company_id: _this12.$session.get('selectedCompany')
        };

        if (query) {
          data.search = query;
        }

        if (_this12.coupons && Array.isArray(_this12.coupons.location_ids) && _this12.coupons.location_ids.length === 1) {
          var location = _this12.coupons.location_ids[0];
          data.location_id = location.id || location.true_id || location;
        }

        _this12.loadingFreeProducts = true;
        _this12.apiRequest('/search-order-products', 'GET', data, function (response) {
          if (response.status === true) {
            var options = (response.data || []).map(function (product) {
              return _this12.mapFreeProductOption(product);
            });
            if (_this12.selectedFreeProduct && !options.find(function (option) {
              return parseInt(option.id, 10) === parseInt(_this12.selectedFreeProduct.id, 10);
            })) {
              options.unshift(_this12.selectedFreeProduct);
            }
            _this12.freeProducts = options;
            _this12.syncFreeProductSelection();
          }
          _this12.$nextTick(function () {
            _this12.loadingFreeProducts = false;
          });
        });
      }, delay);
    },
    mapFreeProductOption: function mapFreeProductOption(product) {
      var id = parseInt(product.product_id || product.id, 10);
      return {
        id: id,
        name: product.name || product.label || 'Product #' + id
      };
    },
    findFreeProductOption: function findFreeProductOption(id) {
      var normalizedId = parseInt(id, 10);
      if (isNaN(normalizedId)) {
        return null;
      }
      return this.freeProducts.find(function (product) {
        return parseInt(product.id, 10) === normalizedId;
      }) || null;
    },
    onFreeProductSelected: function onFreeProductSelected(product) {
      this.selectedFreeProduct = product;
      this.coupons.free_product_id = product ? parseInt(product.id, 10) : null;
    },
    getFreeProductNameFromRelation: function getFreeProductNameFromRelation() {
      var relation = this.coupons.free_product;
      if (relation && relation.name) {
        return relation.name;
      }
      var value = this.coupons.free_product_id;
      if (value && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(value)) === 'object' && value.name) {
        return value.name;
      }
      return null;
    },
    upsertFreeProductOption: function upsertFreeProductOption(id, name) {
      var normalizedId = parseInt(id, 10);
      if (isNaN(normalizedId)) {
        return null;
      }
      var existingIndex = this.freeProducts.findIndex(function (product) {
        return parseInt(product.id, 10) === normalizedId;
      });
      var option = {
        id: normalizedId,
        name: name || 'Product #' + normalizedId
      };
      if (existingIndex === -1) {
        this.freeProducts.unshift(option);
      } else if (name) {
        this.$set(this.freeProducts, existingIndex, option);
      }
      return this.findFreeProductOption(normalizedId);
    },
    syncFreeProductSelection: function syncFreeProductSelection() {
      var id = this.normalizeFreeProductId(this.coupons.free_product_id);
      if (id == null) {
        this.selectedFreeProduct = null;
        return;
      }

      this.coupons.free_product_id = id;
      var relationName = this.getFreeProductNameFromRelation();
      var option = this.findFreeProductOption(id);

      if (option && relationName && option.name !== relationName) {
        option = this.upsertFreeProductOption(id, relationName);
      }

      if (option) {
        this.selectedFreeProduct = option;
        return;
      }

      if (relationName) {
        this.selectedFreeProduct = this.upsertFreeProductOption(id, relationName);
        return;
      }

      this.fetchMissingFreeProductName(id);
    },
    fetchMissingFreeProductName: function fetchMissingFreeProductName(id) {
      var _this13 = this;

      var normalizedId = parseInt(id, 10);
      if (isNaN(normalizedId)) {
        return;
      }

      var existing = this.findFreeProductOption(normalizedId);
      if (existing) {
        this.selectedFreeProduct = existing;
        return;
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: String(normalizedId)
      };
      this.apiRequest('/search-order-products', 'GET', data, function (response) {
        var product = null;
        if (response && response.status === true && Array.isArray(response.data)) {
          product = response.data.find(function (item) {
            return parseInt(item.id || item.product_id, 10) === normalizedId;
          }) || response.data[0];
        }
        if (product) {
          var option = _this13.upsertFreeProductOption(normalizedId, product.name || product.label);
          _this13.selectedFreeProduct = option;
          _this13.coupons.free_product_id = normalizedId;
          return;
        }

        _this13.apiRequest('/product/' + normalizedId, 'GET', {
          token: _this13.$session.get('token'),
          company_id: _this13.$session.get('selectedCompany')
        }, function (productResponse) {
          var fallbackProduct = null;
          if (productResponse && productResponse.status === true && productResponse.data) {
            fallbackProduct = Array.isArray(productResponse.data) ? productResponse.data[0] : productResponse.data;
          }
          if (fallbackProduct && fallbackProduct.name) {
            var _option = _this13.upsertFreeProductOption(normalizedId, fallbackProduct.name);
            _this13.selectedFreeProduct = _option;
            _this13.coupons.free_product_id = normalizedId;
          }
        });
      });
    },
    normalizeFreeProductId: function normalizeFreeProductId(value) {
      if (value == null || value === '') {
        return null;
      }
      if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(value)) === 'object') {
        var id = value.product_id || value.id;
        return id != null ? parseInt(id, 10) : null;
      }
      var parsed = parseInt(value, 10);
      return isNaN(parsed) ? null : parsed;
    },
    handleIntervalErrors: function handleIntervalErrors(errors) {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(errors).forEach(function (errorKey) {
        if (errorKey.startsWith('interval_settings.')) {
          var match = errorKey.match(/interval_settings\.(\d+)\.(from|to)/);
          if (match) {
            var index = match[1];
            var field = match[2];
            var fieldName = 'interval_' + field + '_' + index;
            _this14.errors.add(fieldName, _this14.$t('validations.requiredField'));
          }
        }
      });
    },
    changeType: function changeType() {
      var newType = 'TEXT';
      if (this.addcoupon) {
        newType = 'COUPON';
      }
      if (newType === 'TEXT') {
        this.errorInterval = null;
        this.coupons.use_time_interval = false;
      }
      this.model['type'] = newType;
      this.activeButton = newType;
      this.getCategories();
    },
    generateCode: function generateCode() {
      var _this15 = this;

      if (this.coupons['type'] === undefined) {
        this.coupons['type'] = 'PERCENTAGE';
      }
      this.apiRequest('/coupon/generate-codes', 'POST', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.requestData(), { count: 1, length: 8 }), function (response) {
        var code = response.status === true && response.data.codes && response.data.codes[0];
        _this15.coupons['coupon_code'] = code || Math.random().toString(36).substring(7).toUpperCase();
      });
    },
    addNewInterval: function addNewInterval() {
      this.errorInterval = null;
      var newRow = {
        'day': '',
        'from': '',
        'to': ''
      };
      this.coupons.interval_settings.push(newRow);
    },
    deleteInterval: function deleteInterval(index) {
      this.coupons.interval_settings.splice(index, 1);
    },
    addNewCode: function addNewCode() {
      this.errorCode = null;
      var newRow = {
        'code': ''
      };
      this.coupons.coupons_codes.push(newRow);
    },
    codeStatus: function codeStatus(row) {
      if (parseInt(row.used, 10) === 1) {
        return 'used';
      }
      return row.id ? 'available' : 'new';
    },
    codeQrUrl: function codeQrUrl(row) {
      var code = (row.code || '').trim();
      return code ? this.codeQrLinks[code] || null : null;
    },
    seedCodeQrLinks: function seedCodeQrLinks() {
      var _this16 = this;

      (this.coupons.coupons_codes || []).forEach(function (row) {
        if (row.qr_url && row.code) {
          _this16.$set(_this16.codeQrLinks, row.code.trim(), row.qr_url);
        }
      });
    },
    refreshPagedCodesQr: function refreshPagedCodesQr() {
      var _this17 = this;

      clearTimeout(this.codeQrTimer);
      this.codeQrTimer = setTimeout(function () {
        var missing = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(_this17.pagedCodes.map(function (item) {
          return (item.row.code || '').trim();
        }).filter(function (code) {
          return code !== '' && !_this17.codeQrLinks[code];
        }))));
        if (!missing.length) {
          return;
        }
        _this17.apiRequest('/coupon/qr-links', 'POST', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this17.requestData(), { codes: missing }), function (response) {
          if (response.status === true) {
            response.data.forEach(function (item) {
              return _this17.$set(_this17.codeQrLinks, item.code, item.qr_url);
            });
          }
        });
      }, 400);
    },
    onCodesPageSizeChange: function onCodesPageSizeChange(size) {
      this.codesPageSize = size;
      this.codesPage = 1;
    },
    deleteAllCodes: function deleteAllCodes() {
      var _this18 = this;

      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: this.$t('marketingCoupons.deleteAllCodesConfirm', { count: this.activeCodes.length }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (!result) {
          return;
        }
        _this18.coupons.coupons_codes = (_this18.coupons.coupons_codes || []).filter(function (row) {
          return row.id;
        }).map(function (row) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, row, { delete: true });
        });
        _this18.codesPage = 1;
      }).catch(function () {});
    },
    deleteCode: function deleteCode(index) {
      var cv = this.coupons.coupons_codes;
      this.coupons.coupons_codes = [];
      cv[index].delete = true;
      this.coupons.coupons_codes = cv;
      var lastPage = Math.max(1, Math.ceil(this.activeCodes.length / this.codesPageSize));
      if (this.codesPage > lastPage) {
        this.codesPage = lastPage;
      }
    },
    clearCurrentInterval: function clearCurrentInterval(couponInterval) {
      this.errorInterval = null;
      if (!couponInterval) {
        this.coupons.interval_settings = [];
      }
    },
    addNewCascade: function addNewCascade() {
      this.coupons.is_waterfall = true;
      if (!this.coupons.waterfall_discounts) {
        __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(this.coupons, 'waterfall_discounts', []);
      }
      this.coupons.waterfall_discounts.push({
        'from_value': '',
        'discount_value': ''
      });
    },
    deleteCascade: function deleteCascade(index) {
      this.coupons.waterfall_discounts.splice(index, 1);
      this.$nextTick(function () {
        if (!this.coupons.waterfall_discounts.length && !this.coupons.from_value) {
          this.coupons.is_waterfall = false;
        }
      });
    },
    handleAutoApply: function handleAutoApply() {
      if (this.coupons.auto_apply) {
        this.coupons.second_use_auto_coupon = false;
        this.coupons.coupon_has_multiple_codes = false;
      } else {
        this.coupons.auto_apply = false;
      }
    }
  }
});

/***/ }),

/***/ "efeo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eh/v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Maps_DeliveryGoogleMaps_vue__ = __webpack_require__("D+CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Settings_Taxes_DeliveryTaxPanel_vue__ = __webpack_require__("OZUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vuedraggable__);

















var _components;











__WEBPACK_IMPORTED_MODULE_16_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_21_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'DeliveryGoogleMaps', __WEBPACK_IMPORTED_MODULE_22__Maps_DeliveryGoogleMaps_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'DeliveryTaxPanel', __WEBPACK_IMPORTED_MODULE_23__Settings_Taxes_DeliveryTaxPanel_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'draggable', __WEBPACK_IMPORTED_MODULE_24_vuedraggable___default.a), _components),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vee_validate__["b" /* mapFields */])(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity'])),
  props: {
    defaultData: {},
    modeldata: {},
    drawDetails: {},
    isDeliveryMethods: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },
    modeldata: function modeldata(value) {
      var _this = this;

      for (var iLocation in value.locations_details) {
        var _loop = function _loop() {
          if (value.locations_details[iLocation].ordering_management[iOrder].locations === undefined) {
            value.locations_details[iLocation].ordering_management[iOrder].locations = [];
          }

          if (value.locations_details[iLocation].ordering_management[iOrder].period === undefined) {
            __WEBPACK_IMPORTED_MODULE_16_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'period', 1);
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].offset === undefined) {
            __WEBPACK_IMPORTED_MODULE_16_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'offset', 0);
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].no_preorders === undefined) {
            __WEBPACK_IMPORTED_MODULE_16_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'no_preorders', false);
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].is_always_open === undefined) {
            __WEBPACK_IMPORTED_MODULE_16_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'is_always_open', false);
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].is_always_open_preorder_hours === undefined) {
            __WEBPACK_IMPORTED_MODULE_16_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'is_always_open_preorder_hours', 0);
          }
          if ((value.locations_details[iLocation].ordering_management[iOrder].hour_and_date_delivery_hour_usage === undefined || !value.locations_details[iLocation].ordering_management[iOrder].hour_and_date_delivery_hour_usage) && (value.locations_details[iLocation].ordering_management[iOrder].just_date_delivery_hour_usage === undefined || !value.locations_details[iLocation].ordering_management[iOrder].just_date_delivery_hour_usage) && (value.locations_details[iLocation].ordering_management[iOrder].deactivate_delivery_hour_usage === undefined || !value.locations_details[iLocation].ordering_management[iOrder].deactivate_delivery_hour_usage)) {
            __WEBPACK_IMPORTED_MODULE_16_vue___default.a.set(value.locations_details[iLocation].ordering_management[iOrder], 'delivery_hour_usage', 0);
            _this.changeDeliveryHourUsage(value.locations_details[iLocation].ordering_management[iOrder]);
          }

          if (value.locations_details[iLocation].ordering_management[iOrder].shipping_cost === undefined) {
            value.locations_details[iLocation].ordering_management[iOrder].shipping_cost = [];
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].delivery_rules === undefined) {
            var newRow = _this.copyObject(_this.newRule);
            var newSubRule = _this.copyObject(_this.newSubRule);
            newRow.subrules = [];
            newRow.subrules.push(newSubRule);
            value.locations_details[iLocation].ordering_management[iOrder].delivery_rules = [];
            value.locations_details[iLocation].ordering_management[iOrder].delivery_rules.push(newRow);
          }
          if (value.locations_details[iLocation].ordering_management[iOrder].area === undefined && value.locations_details[iLocation].ordering_management[iOrder].type === 'delivery') {
            value.locations_details[iLocation].ordering_management[iOrder].area = 'radius';
          }

          for (iDay in _this.days) {
            day = _this.days[iDay];

            if (value.locations_details[iLocation].ordering_management[iOrder].available_days === undefined) {
              value.locations_details[iLocation].ordering_management[iOrder].available_days = [];
            }
            index = _this.getObjectByElemKeyValue('day', day, value.locations_details[iLocation].ordering_management[iOrder].available_days);

            if (index === false) {
              value.locations_details[iLocation].ordering_management[iOrder].available_days.push({ day: day, open_to: '', open_from: '', open: false });
            } else if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open === undefined) {
              if (value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_to !== '' && value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open_from !== '') {
                value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = true;
              } else {
                value.locations_details[iLocation].ordering_management[iOrder].available_days[index].open = false;
              }
            }
          }

          var self = _this;
          value.locations_details[iLocation].ordering_management[iOrder].available_days = value.locations_details[iLocation].ordering_management[iOrder].available_days.filter(function (value, index, arr) {
            return self.days.indexOf(value.day) !== -1;
          });
        };

        for (var iOrder in value.locations_details[iLocation].ordering_management) {
          var iDay;
          var day;
          var index;

          _loop();
        }
      }
      this.model = value;
    }
  },
  data: function data() {
    return {
      reservationTaxesIndex: 0,
      methodInfoIndex: 0,
      delivery_hour_usage: [{
        'id': 0,
        'name': 'hourAndDate'
      }, {
        'id': 1,
        'name': 'justDate'
      }, {
        'id': 2,
        'name': 'deactivateDeliveryHours'
      }],
      arrowsSimbolHtml: '<i style="cursor: move" class="fa fa-arrows sortHandle"></i>',
      colapsedItem: null,
      model: this.value || this.modeldata,
      deliveryRanges: [],
      defaults: this.value || this.defaultData,
      pickerOptions1: {},
      pickerOptionsTaxFrom: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      pickerOptionsTaxTo: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      tabIndex: 0,
      taxes: [],
      taxesPerLocation: [],
      activeNames: [],
      currency: this.$session.get('selectedCompanyData')['currency_iso'],
      modelValidate: {
        'available_days': { required: true },
        'required': { required: true },
        'offset': { required: true, min_value: 0, max_value: 365, decimal: 0 },
        'period': { required: true, min_value: 1, max_value: 1095, decimal: 0 }
      },
      paymentOptions: [{
        'payment_id': 'credit_card',
        'name': this.$t('paymentTypes.CARD')
      }, {
        'payment_id': 'cash',
        'name': this.$t('paymentTypes.CASH')
      }, {
        'payment_id': 'pos',
        'name': this.$t('paymentTypes.POS')
      }],
      pickerNames: ['date_from', 'date_to'],
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '24:00'
      },
      picker_options_orders_starts_from: {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      },
      newLocation: {
        street: '',
        city: '',
        state: '',
        country: ''
      },
      newRule: {
        delivery_range: '',
        subrules: []
      },
      newSubRule: {
        shipping_cost: 0,
        shipping_pos_id: '',
        cities: [],
        neighborhoods: [],
        min_order_value: 0
      },
      zoneLimitations: {
        'radius': 'setRadiusArea',
        'draw': 'setDrawArea'
      },
      windowHeight: 0,
      navbarHeaderHeight: 0,
      pageTopHeight: 76,
      loading: true,
      vatOptions: [],
      taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1)
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    this.getVatOptions();
    this.$nextTick(function () {
      _this2.doHeightCalculation();
      _this2.loading = false;
      window.addEventListener('resize', function () {
        _this2.doHeightCalculation();
      });
    });
    if (this.isDeliveryMethods) {
      this.getData();
    }
  },

  methods: {
    getVatOptions: function getVatOptions() {
      var _this3 = this;

      var locaitonIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_ids: locaitonIds
      };
      this.apiRequest('/location/vat', 'GET', data, function (response) {
        if (response.status === true) {
          _this3.vatOptions = response.data;
        }
      });
    },
    getData: function getData() {
      this.getDeliveryRanges();
      this.$bus.$on('drawingDetails', this.drawing);
      this.$bus.$on('changeDeliveryZone', this.changeDeliveryZone);
      this.currency = this.getCurrencySymbol(this.currency);
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getDeliveryRanges: function getDeliveryRanges() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token')
      };
      this.apiRequest('/settings/delivery-ranges', 'GET', data, function (response) {
        if (response.status === true) {
          _this4.deliveryRanges = response.data;
        }
      });
    },
    validate: function validate() {
      var _this5 = this;

      var self = this;
      this.errors.clear();
      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          var _loop2 = function _loop2(bussL) {
            var _loop3 = function _loop3(oIdx) {
              var o = bussL.ordering_management[oIdx];
              if (o.type === 'delivery') {
                if (o.delivery_rules && o.delivery_rules.length > 1) {
                  var _loop4 = function _loop4(rIdx) {
                    var rule = o.delivery_rules[rIdx];
                    if (rule.delivery_range.trim() === '') {
                      _this5.$nextTick().then(function () {
                        self.errors.add(bussL.id + o.type + 'delivery_range' + rIdx, 'invalid');
                        isValid = false;
                      });
                    } else {
                      var _loop5 = function _loop5(r2Idx) {
                        var rule2 = o.delivery_rules[r2Idx];
                        if (rule.delivery_range === rule2.delivery_range && rIdx !== r2Idx) {
                          _this5.$nextTick().then(function () {
                            self.errors.add(bussL.id + o.type + 'delivery_range' + rIdx, 'invalid');
                            self.errors.add(bussL.id + o.type + 'delivery_range' + r2Idx, 'invalid');
                            isValid = false;
                          });
                        }
                      };

                      for (var r2Idx in o.delivery_rules) {
                        _loop5(r2Idx);
                      }
                    }
                  };

                  for (var rIdx in o.delivery_rules) {
                    _loop4(rIdx);
                  }
                }

                if (o.delivery_rules && o.delivery_rules.length && o.enabled) {
                  var uniqueCities = void 0;
                  for (var rIdx3 in o.delivery_rules) {
                    if (o.delivery_rules[rIdx3].subrules !== undefined && o.delivery_rules[rIdx3].subrules.length > 1) {
                      uniqueCities = [];
                      var subrules = o.delivery_rules[rIdx3].subrules;
                      var _iteratorNormalCompletion2 = true;
                      var _didIteratorError2 = false;
                      var _iteratorError2 = undefined;

                      try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(subrules), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                          var subrule = _step2.value;

                          if (subrule.cities.length) {
                            var _iteratorNormalCompletion3 = true;
                            var _didIteratorError3 = false;
                            var _iteratorError3 = undefined;

                            try {
                              for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(subrule.cities), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var city = _step3.value;

                                if (uniqueCities.indexOf(city) > -1 && (subrule.neighborhoods === undefined || !subrule.neighborhoods.length)) {
                                  __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({ 'text': self.$t('settingsOrdering.citiesValidationError'), 'type': 'error', 'showConfirmButton': true }).catch(function () {});
                                  _this5.$nextTick().then(function () {
                                    isValid = false;
                                  });
                                  return {
                                    v: {
                                      v: false
                                    }
                                  };
                                } else {
                                  uniqueCities.push(city);
                                }
                              }
                            } catch (err) {
                              _didIteratorError3 = true;
                              _iteratorError3 = err;
                            } finally {
                              try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                  _iterator3.return();
                                }
                              } finally {
                                if (_didIteratorError3) {
                                  throw _iteratorError3;
                                }
                              }
                            }
                          }
                        }
                      } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }
                        } finally {
                          if (_didIteratorError2) {
                            throw _iteratorError2;
                          }
                        }
                      }
                    }
                  }
                }
              }
            };

            for (var oIdx in bussL.ordering_management) {
              var _ret3 = _loop3(oIdx);

              if ((typeof _ret3 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_ret3)) === "object") return _ret3.v;
            }
          };

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this5.model.locations_details), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var bussL = _step.value;

              var _ret2 = _loop2(bussL);

              if ((typeof _ret2 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_ret2)) === "object") return _ret2.v;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        _this5.$nextTick().then(function () {
          if (isValid) {
            self.saveDetails();
          } else {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.model.locations_details), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var bussLocation = _step4.value;
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                  for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(bussLocation.ordering_management), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var order = _step5.value;

                    var tabTtl = bussLocation.id + order.type;
                    if (order.enabled && self.errors.items.length) {
                      var _iteratorNormalCompletion6 = true;
                      var _didIteratorError6 = false;
                      var _iteratorError6 = undefined;

                      try {
                        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(self.errors.items), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                          var err = _step6.value;

                          if (err.field.includes(tabTtl)) {
                            self.activeNames.push(tabTtl);
                          }
                        }
                      } catch (err) {
                        _didIteratorError6 = true;
                        _iteratorError6 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                          }
                        } finally {
                          if (_didIteratorError6) {
                            throw _iteratorError6;
                          }
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError5 = true;
                  _iteratorError5 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                      _iterator5.return();
                    }
                  } finally {
                    if (_didIteratorError5) {
                      throw _iteratorError5;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }

            __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({ 'text': self.$t('settingsOrdering.notice'), 'type': 'error' });
          }
        });
      });
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
    },
    showStateDrop: function showStateDrop(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);
      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return true;
      } else {
        return false;
      }
    },
    getStatesOptions: function getStatesOptions(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);
      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return countries[countryIdx].states;
      } else {
        return [];
      }
    },
    updateCountry: function updateCountry(location) {
      location.state = null;
      location.state_id = null;
    },
    addNewLocation: function addNewLocation(locId, type) {
      var data = {
        'token': this.$session.get('token'),
        'type': 'hashes'
      };
      var self = this;
      this.apiRequest('/helpers', 'GET', data, function (response) {
        if (response.status === true) {
          var newRow = [];
          newRow = self.copyObject(self.newLocation);
          newRow.id = response.data[0].id;
          var locIdx = self.getObjectByElemKeyValue('id', locId, self.model.locations_details);
          var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.locations_details[locIdx].ordering_management);
          self.model.locations_details[locIdx].ordering_management[typeIdx].locations.push(newRow);
        } else {
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    addNewRule: function addNewRule(locId, type) {
      this.$nextTick(function () {
        var self = this;
        var newRow = [];
        newRow = this.copyObject(self.newRule);
        var newSubRule = this.copyObject(self.newSubRule);
        var locIdx = self.getObjectByElemKeyValue('id', locId, self.model.locations_details);
        var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.locations_details[locIdx].ordering_management);
        this.$nextTick().then(function () {
          newRow.subrules = [];
          newRow.subrules.push(newSubRule);
          if (self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules) {
            self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules.push(newRow);
          } else {
            self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules = [];
            self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules.push(newRow);
          }
        });
      });
    },
    addNewSubRule: function addNewSubRule(locId, type, idx) {
      this.$nextTick(function () {
        var self = this;
        var newRow = [];
        newRow = this.copyObject(self.newSubRule);
        var locIdx = self.getObjectByElemKeyValue('id', locId, self.model.locations_details);
        var typeIdx = self.getObjectByElemKeyValue('type', type, self.model.locations_details[locIdx].ordering_management);
        var subrules = this.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules[idx]['subrules'];

        this.$nextTick().then(function () {
          if (subrules) {
            self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules[idx]['subrules'].push(newRow);
          } else {
            self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules[idx]['subrules'] = [];
            self.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules[idx]['subrules'].push(newRow);
          }
        });
      });
    },
    updateTabs: function updateTabs(name, enabled) {
      this.$nextTick(function () {
        if (!enabled) {
          this.activeNames = [name];
        } else {
          this.activeNames = [];
        }
      });
    },
    removeLocation: function removeLocation(locId, idx, type) {
      var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details);
      var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.locations_details[locIdx].ordering_management);
      this.model.locations_details[locIdx].ordering_management[typeIdx].locations.splice(idx, 1);
    },
    removeRule: function removeRule(locId, idx, type) {
      this.$nextTick(function () {
        var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details);
        var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.locations_details[locIdx].ordering_management);
        this.$nextTick(function () {
          this.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules.splice(idx, 1);
        });
      });
    },
    removeSubRule: function removeSubRule(locId, idx, idxSubrule, type) {
      this.$nextTick(function () {
        var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details);
        var typeIdx = this.getObjectByElemKeyValue('type', type, this.model.locations_details[locIdx].ordering_management);
        this.$nextTick(function () {
          this.model.locations_details[locIdx].ordering_management[typeIdx].delivery_rules[idx].subrules.splice(idxSubrule, 1);
        });
      });
    },
    saveDetails: function saveDetails() {
      var _this6 = this;

      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');
      var currentLocations = [];
      var countries = this.$session.get('defaultData').countries;
      for (var locIdx in this.model.locations_details) {
        var locData = this.copyObject(this.model.locations_details[locIdx]);
        for (var orMngIdx in locData.ordering_management) {
          if (locData.ordering_management[orMngIdx].type === 'eat_location' && this.model.locations_details[locIdx].ordering_management[orMngIdx].delivery_hour_usage === 2 && this.model.locations_details[locIdx].ordering_management[orMngIdx].deactivate_delivery_hour_usage) {
            locData.ordering_management[orMngIdx].deactivate_delivery_hour_usage = 0;
            locData.ordering_management[orMngIdx].delivery_hour_usage = 0;
            locData.ordering_management[orMngIdx].hour_and_date_delivery_hour_usage = 1;
          }
          if (locData.ordering_management[orMngIdx].type === 'meet_half') {
            for (var idx in locData.ordering_management[orMngIdx].locations) {
              var countryIso = locData.ordering_management[orMngIdx].locations[idx].country;
              var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);
              var states = [];
              if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
                states = countries[countryIdx].states;
              }
              if (states.length && locData.ordering_management[orMngIdx].locations[idx].state_id) {
                var state = this.getObjectByElemKeyValue('id', locData.ordering_management[orMngIdx].locations[idx].state_id, states);
                if (state !== undefined) {
                  locData.ordering_management[orMngIdx].locations[idx].state = states[state].name;
                } else {
                  locData.ordering_management[orMngIdx].locations[idx].state = null;
                }
              }
              delete locData.ordering_management[orMngIdx].locations[idx].states;
            }
          }
        }
        currentLocations[locIdx] = locData;
      }

      var data = {
        'token': this.$session.get('token'),
        'locations_details': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(currentLocations),
        'delivery_options_labels': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.model.delivery_options_labels),
        'delivery_ranges': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.deliveryRanges)
      };
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          _this6.$nextTick(function () {
            this.loading = false;
            this.$session.set('selectedCompanyData', this.buildCompanySessionData(response.data[0]));
            this.model.locations_details = response.data[0].locations_details;
          });
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({ 'text': _this6.$t('settingsOrdering.saveSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 3000 }).catch(function () {});
        } else {
          _this6.$nextTick(function () {
            this.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({ 'text': _this6.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    drawing: function drawing(obj) {},
    changeDeliveryZone: function changeDeliveryZone(obj) {
      if (obj.action === 'delete') {
        this.deliveryRanges[obj.bussLocationId].splice(obj.indexZone, 1);
      }
    },
    addNewZone: function addNewZone(locId, type, locIdx) {
      this.pushEmptyDeliveryZones(locId, locIdx);
    },
    pushEmptyDeliveryZones: function pushEmptyDeliveryZones(locId, locIdx) {
      if (!this.deliveryRanges.hasOwnProperty(locId)) {
        this.deliveryRanges[locId] = [];
      }
      var length = this.deliveryRanges[locId].push({
        'name': '',
        'shape': {}
      });
      if (locIdx) {
        this.model.locations_details[locIdx].mapactive = length - 1;
      }
    },
    handleChangeArea: function handleChangeArea(area, locId) {
      var _this7 = this;

      this.$nextTick(function () {
        if (area === 'draw') {
          if (!_this7.deliveryRanges.hasOwnProperty(locId)) {
            _this7.deliveryRanges[locId] = [];
          }
          if (!_this7.deliveryRanges[locId].length) {
            _this7.pushEmptyDeliveryZones(locId);
          }
        }
      });
    },
    addMethodInfo: function addMethodInfo(orderIdx, indexBussLocation) {
      var newRow = {
        'title': '',
        'type': 'check',
        'options': []
      };

      if (!this.model.locations_details[indexBussLocation].ordering_management[orderIdx].hasOwnProperty('method_info')) {
        __WEBPACK_IMPORTED_MODULE_16_vue___default.a.set(this.model.locations_details[indexBussLocation].ordering_management[orderIdx], 'method_info', []);
      }

      this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info.push(newRow);

      this.methodInfoIndex = this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info ? this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info.length - 1 : 0;
    },
    deleteMethodInfo: function deleteMethodInfo(orderIdx, indexBussLocation, id) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
        text: this.$t('catalogProdOpt.areyouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this8.methodInfoIndex = _this8.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info.splice(id, 1);
        }
      });
    },
    addMethodInfoOptionValue: function addMethodInfoOptionValue(orderIdx, indexBussLocation, optIdx) {
      var newRow = {
        'title': ''
      };
      this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info[optIdx].options.push(newRow);
    },
    deleteMethodInfoOptionValue: function deleteMethodInfoOptionValue(orderIdx, indexBussLocation, optIdx, idx) {
      this.model.locations_details[indexBussLocation].ordering_management[orderIdx].method_info[optIdx].options.splice(idx, 1);
    },
    changeDeliveryHourUsage: function changeDeliveryHourUsage(order) {
      order.hour_and_date_delivery_hour_usage = false;
      order.just_date_delivery_hour_usage = false;
      order.deactivate_delivery_hour_usage = false;

      switch (order.delivery_hour_usage) {
        case 0:
          order.hour_and_date_delivery_hour_usage = true;
          break;
        case 1:
          order.just_date_delivery_hour_usage = true;
          break;
        default:
          order.deactivate_delivery_hour_usage = true;
      }
    },
    addMoreIntervals: function addMoreIntervals(dayIdx, orderIdx, indexBussLocation) {
      var index = 0;
      if (!this.model.locations_details[indexBussLocation].ordering_management[orderIdx].available_days[dayIdx].hasOwnProperty('intervals')) {
        __WEBPACK_IMPORTED_MODULE_16_vue___default.a.set(this.model.locations_details[indexBussLocation].ordering_management[orderIdx].available_days[dayIdx], 'intervals', []);
      } else {
        index = this.model.locations_details[indexBussLocation].ordering_management[orderIdx].available_days[dayIdx].intervals.length;
      }
      var newObj = {
        'open_from': '',
        'open_to': ''
      };
      __WEBPACK_IMPORTED_MODULE_16_vue___default.a.set(this.model.locations_details[indexBussLocation].ordering_management[orderIdx].available_days[dayIdx].intervals, index, newObj);
    },
    deleteIntervals: function deleteIntervals(intervalKey, dayIdx, orderIdx, indexBussLocation) {
      this.model.locations_details[indexBussLocation].ordering_management[orderIdx].available_days[dayIdx].intervals.splice(intervalKey, 1);
    },
    addReservationTaxesInfo: function addReservationTaxesInfo(indexBussLocation, orderIdx) {
      this.model.locations_details[indexBussLocation].ordering_management[orderIdx].reservation_taxes.push({
        'id': 0,
        'name': 'Rezervare',
        'price': 0,
        'table_zone_id': 0,
        'date_from': '',
        'date_to': '',
        'deleted_at': null
      });
    },
    deleteReservationTaxesInfo: function deleteReservationTaxesInfo(indexBussLocation, orderIdx, idTax) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
        text: this.$t('catalogProdOpt.areyouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          if (_this9.model.locations_details[indexBussLocation].ordering_management[orderIdx].reservation_taxes[idTax].id) {
            _this9.model.locations_details[indexBussLocation].ordering_management[orderIdx].reservation_taxes[idTax].deleted_at = 1;
          } else {
            _this9.reservationTaxesIndex = _this9.model.locations_details[indexBussLocation].ordering_management[orderIdx].reservation_taxes.splice(idTax, 1);
          }
        }
      });
    },
    goToCompany: function goToCompany() {
      this.$session.set('selectedTab', this.$t('settingsPages.locationGroups'));
      window.location.reload(true);
    }
  }
});

/***/ }),

/***/ "eiXA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DiscountCampaignForm_vue__ = __webpack_require__("af5b");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DiscountCampaignForm: __WEBPACK_IMPORTED_MODULE_0__DiscountCampaignForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),

/***/ "elzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductMixReport_vue__ = __webpack_require__("g0pE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaadc84e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductMixReport_vue__ = __webpack_require__("5AKc");
function injectStyle (ssrContext) {
  __webpack_require__("ApSM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aaadc84e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductMixReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaadc84e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductMixReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "epYj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eqLV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProformaForm_vue__ = __webpack_require__("bV0d");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ProformaForm', __WEBPACK_IMPORTED_MODULE_7__ProformaForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "eqta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinning-wheel-campaign-form"},[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[(_vm.campaignId)?_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",on:{"click":function($event){$event.preventDefault();return _vm.handleDelete($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.delete'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('spinningWheel.generalSettings')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.campaignTitle')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('spinningWheel.campaignTitle')},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"3","placeholder":_vm.$t('spinningWheel.description')},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}}),_vm._v(" "),_c('label',{staticClass:"mar-lt-10"},[_vm._v(_vm._s(_vm.$t('spinningWheel.active')))]),_vm._v(" "),_c('small',{staticClass:"display-block text-muted"},[_vm._v(_vm._s(_vm.$t('spinningWheel.activeRequires100')))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.availability')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy"},model:{value:(_vm.availabilityRange),callback:function ($$v) {_vm.availabilityRange=$$v},expression:"availabilityRange"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.minOrderValue')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model.minimum_order_value),expression:"model.minimum_order_value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(_vm.model.minimum_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "minimum_order_value", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('searchable-multi-select',{attrs:{"label":"spinningWheel.locations","url":"/get-locations","initial-limit":1000,"filter-locally":"","placeholder":_vm.$t('general.all')},model:{value:(_vm.locationsFormatted),callback:function ($$v) {_vm.locationsFormatted=$$v},expression:"locationsFormatted"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('spinningWheel.locationsInfo'))+"\n            ")])],1),_vm._v(" "),(_vm.rewards.length)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.percentages')))]),_vm._v(" "),_c('p',[_c('strong',{class:_vm.percentagesValid ? 'text-success' : 'text-danger'},[_vm._v("\n                "+_vm._s(_vm.formatPercentage(_vm.percentageSum))+"%\n              ")]),_vm._v(" "),(!_vm.percentagesValid)?_c('span',{staticClass:"text-danger"},[_vm._v(" — "+_vm._s(_vm.$t('spinningWheel.mustTotal100')))]):_vm._e()])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"display-flex",staticStyle:{"justify-content":"space-between","align-items":"center"}},[_c('h5',{staticClass:"mar-bt-0"},[_vm._v(_vm._s(_vm.$t('spinningWheel.rewards')))]),_vm._v(" "),_c('button',{staticClass:"btn add",attrs:{"type":"button"},on:{"click":function($event){_vm.openRewardForm()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('spinningWheel.addReward'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"text-muted mar-to-10"},[_vm._v(_vm._s(_vm.$t('spinningWheel.sortOrderHelp')))]),_vm._v(" "),_c('el-table',{ref:"rewardsTable",staticClass:"spinning-wheel-rewards-table",staticStyle:{"width":"100%","margin-top":"15px"},attrs:{"data":_vm.visibleRewards,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","label":_vm.$t('spinningWheel.sortOrder'),"min-width":90,"align":"center","header-align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(props.row.sort_order),expression:"props.row.sort_order",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"1000","step":"1"},domProps:{"value":(props.row.sort_order)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(props.row, "sort_order", _vm._n($event.target.value))},function($event){_vm.onSortOrderInput(props.row)}],"click":function($event){$event.stopPropagation();},"blur":function($event){_vm.$forceUpdate()}}})]}}])}),_vm._v(" "),(_vm.campaignId)?_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"id","label":_vm.$t('customers.id'),"min-width":60,"align":"center","header-align":"center"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","label":_vm.$t('spinningWheel.reward'),"min-width":"140","align":"center","header-align":"center","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.displayRewardTitle(props.row))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","label":_vm.$t('spinningWheel.rewardType'),"min-width":"130","align":"center","header-align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.rewardTypeLabel(props.row))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","label":_vm.$t('spinningWheel.winningPercentage'),"min-width":"120","align":"center","header-align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"display-flex",staticStyle:{"align-items":"center","justify-content":"center"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(props.row.winning_percentage),expression:"props.row.winning_percentage",modifiers:{"number":true}}],staticClass:"form-control",staticStyle:{"max-width":"90px"},attrs:{"type":"number","min":"0.0001","step":"0.0001","disabled":Number(props.row.type) === 1},domProps:{"value":(props.row.winning_percentage)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(props.row, "winning_percentage", _vm._n($event.target.value))},function($event){_vm.onPercentageInput(props.row)}],"click":function($event){$event.stopPropagation();},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{staticClass:"mar-lt-5"},[_vm._v("%")])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","label":_vm.$t('spinningWheel.active'),"min-width":"80","align":"center","header-align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{class:{ 'reward-active-toggle--disabled': Number(props.row.type) === 1 || _vm.rewardActiveSaving },attrs:{"value":!!props.row.active,"type":"success","disabled":Number(props.row.type) === 1 || _vm.rewardActiveSaving,"aria-disabled":Number(props.row.type) === 1 || _vm.rewardActiveSaving},on:{"input":function (value) { return _vm.handleRewardActive(props.row, value); }},nativeOn:{"click":function($event){$event.stopPropagation();}}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","label":_vm.$t('spinningWheel.actions'),"width":120,"align":"center","header-align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[(props.row.open_campaign_id || props.row.generated_campaign_id)?_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.openGeneratedCampaign(props.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('spinningWheel.openCampaign'))+"\n                ")]):_vm._e(),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.openRewardForm(props.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.edit'))+"\n                ")]),_vm._v(" "),(Number(props.row.type) !== 1)?_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.duplicateReward(props.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('spinningWheel.duplicate'))+"\n                ")]):_vm._e(),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.deleteReward(props.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")])],1)],1)]}}])})],1)],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.editingReward ? _vm.$t('spinningWheel.editReward') : _vm.$t('spinningWheel.addReward'),"visible":_vm.rewardDialogVisible,"width":"720px","top":"4vh","custom-class":"spinning-wheel-reward-dialog","append-to-body":"","modal-append-to-body":true,"close-on-click-modal":false,"z-index":100000},on:{"update:visible":function($event){_vm.rewardDialogVisible=$event}}},[_c('div',{staticClass:"spinning-wheel-reward-dialog__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.rewardType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.rewardForm.type),expression:"rewardForm.type",modifiers:{"number":true}}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.rewardForm, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":_vm.hasOtherNothing},domProps:{"value":1}},[_vm._v(_vm._s(_vm.$t('spinningWheel.typeNothing')))]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v(_vm._s(_vm.$t('spinningWheel.typeLoyaltyPoints')))]),_vm._v(" "),_c('option',{domProps:{"value":3}},[_vm._v(_vm._s(_vm.$t('spinningWheel.typeDiscountCoupon')))]),_vm._v(" "),_c('option',{domProps:{"value":4}},[_vm._v(_vm._s(_vm.$t('spinningWheel.typeFreeProduct')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.winningPercentage')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.rewardForm.winning_percentage),expression:"rewardForm.winning_percentage",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"disabled":_vm.rewardForm.type === 1,"type":"number","min":"0.0001","step":"0.0001"},domProps:{"value":(_vm.rewardForm.winning_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rewardForm, "winning_percentage", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.displayTitle')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rewardForm.display_title),expression:"rewardForm.display_title"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('spinningWheel.displayTitle')},domProps:{"value":(_vm.rewardForm.display_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rewardForm, "display_title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.displayDescription')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rewardForm.display_description),expression:"rewardForm.display_description"}],staticClass:"form-control",attrs:{"rows":"3","placeholder":_vm.$t('spinningWheel.displayDescription')},domProps:{"value":(_vm.rewardForm.display_description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rewardForm, "display_description", $event.target.value)}}})]),_vm._v(" "),(_vm.rewardForm.type === 2)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.loyaltyPoints')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.rewardForm.loyalty_points),expression:"rewardForm.loyalty_points",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","step":"1"},domProps:{"value":(_vm.rewardForm.loyalty_points)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rewardForm, "loyalty_points", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]):_vm._e(),_vm._v(" "),(_vm.rewardForm.type === 3)?[_c('div',{staticClass:"alert alert-info"},[_vm._v(_vm._s(_vm.$t('spinningWheel.autoGenerateNotice')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.couponAppliesTo')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.rewardForm.usage_type),expression:"rewardForm.usage_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.rewardForm, "usage_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"PRODUCTS"}},[_vm._v(_vm._s(_vm.$t('spinningWheel.couponProducts')))]),_vm._v(" "),_c('option',{attrs:{"value":"SHIPPING"}},[_vm._v(_vm._s(_vm.$t('spinningWheel.couponDelivery')))]),_vm._v(" "),_c('option',{attrs:{"value":"TAX"}},[_vm._v(_vm._s(_vm.$t('spinningWheel.couponTaxes')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.couponType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.rewardForm.coupon_type),expression:"rewardForm.coupon_type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.rewardForm, "coupon_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"PERCENTAGE"}},[_vm._v(_vm._s(_vm.$t('spinningWheel.couponPercentage')))]),_vm._v(" "),_c('option',{attrs:{"value":"FIXED"}},[_vm._v(_vm._s(_vm.$t('spinningWheel.couponFixed')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.discount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.rewardForm.discount),expression:"rewardForm.discount",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0.01","step":"0.01"},domProps:{"value":(_vm.rewardForm.discount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rewardForm, "discount", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])])])]:_vm._e(),_vm._v(" "),(_vm.rewardForm.type === 4)?[_c('div',{staticClass:"alert alert-info"},[_vm._v(_vm._s(_vm.$t('spinningWheel.autoGenerateNotice')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.product')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","remote-method":_vm.searchProducts,"loading":_vm.productsLoading,"placeholder":_vm.$t('spinningWheel.searchProduct')},on:{"visible-change":_vm.onProductDropdown},model:{value:(_vm.rewardForm.catalogproduct_id),callback:function ($$v) {_vm.$set(_vm.rewardForm, "catalogproduct_id", $$v)},expression:"rewardForm.catalogproduct_id"}},_vm._l((_vm.productOptions),function(p){return _c('el-option',{key:p.id,attrs:{"label":p.name + (p.price != null ? ' (' + p.price + ')' : ''),"value":p.id}})}))],1)]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('spinningWheel.sortOrder')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.rewardForm.sort_order),expression:"rewardForm.sort_order",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"1"},domProps:{"value":(_vm.rewardForm.sort_order)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rewardForm, "sort_order", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mar-to-25"},[(_vm.rewardForm.type !== 1)?_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.rewardForm.active),callback:function ($$v) {_vm.$set(_vm.rewardForm, "active", $$v)},expression:"rewardForm.active"}}):_vm._e(),_vm._v(" "),_c('label',{staticClass:"mar-lt-10"},[_vm._v(_vm._s(_vm.$t('spinningWheel.active')))])],1)])])],2),_vm._v(" "),_c('div',{staticClass:"dialog-footer spinning-wheel-reward-dialog__footer",attrs:{"slot":"footer"},slot:"footer"},[_c('a',{staticClass:"btn btn-danger btn-icon delete",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.rewardDialogVisible = false}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n        "+_vm._s(_vm.$t('general.cancel'))+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon save",attrs:{"type":"button","disabled":_vm.rewardSaving},on:{"click":_vm.saveReward}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n        "+_vm._s(_vm.$t('general.save'))+"\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "esvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchView_vue__ = __webpack_require__("GahT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce604dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchView_vue__ = __webpack_require__("oVXt");
function injectStyle (ssrContext) {
  __webpack_require__("IDcL")
  __webpack_require__("t1co")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ce604dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce604dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ettC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ew9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockMovements_vue__ = __webpack_require__("nsy5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e45b190_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockMovements_vue__ = __webpack_require__("VkJz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockMovements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e45b190_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockMovements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f+Xs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DiscountCoupons_CouponForm_vue__ = __webpack_require__("zKgQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__automationTypes__ = __webpack_require__("OEwP");










var _components;










__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_js_modal___default.a, { componentName: 'vmodal' });

var TITLE_MAX = 100;
var MESSAGE_MAX = 500;
var ANNOUNCE_DAYS_MAX = 30;
var DEFAULT_SEND_TIME = '10:00';

var DELAY_MIN = 10;
var FIRST_DELAY_MAX = 1440;
var SECOND_DELAY_MAX = 4320;
var COOLDOWN_MAX = 365;

var PUSHES = {
  announce: { title: 'announce_title', message: 'announce_message', exampleTitle: 'exampleAnnounceTitle', exampleMessage: 'exampleAnnounceMessage' },
  day: { title: 'day_title', message: 'day_message', exampleTitle: 'exampleDayTitle', exampleMessage: 'exampleDayMessage' },
  first: { title: 'first_title', message: 'first_message', exampleTitle: 'exampleCartFirstTitle', exampleMessage: 'exampleCartFirstMessage' },
  nocoupon: { title: 'nocoupon_title', message: 'nocoupon_message', exampleTitle: 'exampleCartNoCouponTitle', exampleMessage: 'exampleCartNoCouponMessage' },
  second: { title: 'second_title', message: 'second_message', exampleTitle: 'exampleCartSecondTitle', exampleMessage: 'exampleCartSecondMessage' }
};

var NO_COUPON_EXAMPLES = {
  exampleAnnounceTitle: 'exampleAnnounceNoCouponTitle',
  exampleAnnounceMessage: 'exampleAnnounceNoCouponMessage',
  exampleDayTitle: 'exampleDayNoCouponTitle',
  exampleDayMessage: 'exampleDayNoCouponMessage',
  exampleCartFirstTitle: 'exampleCartNoCouponTitle',
  exampleCartFirstMessage: 'exampleCartNoCouponMessage'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'CouponForm', __WEBPACK_IMPORTED_MODULE_14__DiscountCoupons_CouponForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      TYPE_BIRTHDAY: __WEBPACK_IMPORTED_MODULE_15__automationTypes__["b" /* AUTOMATION_TYPE_BIRTHDAY */],
      TYPE_CART: __WEBPACK_IMPORTED_MODULE_15__automationTypes__["c" /* AUTOMATION_TYPE_CART */],
      DELAY_MIN: DELAY_MIN,
      FIRST_DELAY_MAX: FIRST_DELAY_MAX,
      SECOND_DELAY_MAX: SECOND_DELAY_MAX,
      COOLDOWN_MAX: COOLDOWN_MAX,
      TITLE_MAX: TITLE_MAX,
      MESSAGE_MAX: MESSAGE_MAX,
      ANNOUNCE_DAYS_MAX: ANNOUNCE_DAYS_MAX,
      types: __WEBPACK_IMPORTED_MODULE_15__automationTypes__["a" /* AUTOMATION_TYPES */],
      loading: false,
      saving: false,
      currency: '',
      companyName: '',
      form: {
        name: '',
        period: null,
        active: true,
        type: __WEBPACK_IMPORTED_MODULE_15__automationTypes__["b" /* AUTOMATION_TYPE_BIRTHDAY */],
        settings: this.defaultSettings(__WEBPACK_IMPORTED_MODULE_15__automationTypes__["b" /* AUTOMATION_TYPE_BIRTHDAY */]),
        coupon_ids: []
      },
      formErrors: {},

      focused: 'day',
      coupons: [],
      couponSearch: '',
      couponModalOpen: false
    };
  },

  computed: {
    campaignId: function campaignId() {
      return this.route.params && this.route.params.id;
    },
    isEdit: function isEdit() {
      return !!this.campaignId;
    },
    activePush: function activePush() {
      var s = this.form.settings || {};
      if (this.form.type === __WEBPACK_IMPORTED_MODULE_15__automationTypes__["c" /* AUTOMATION_TYPE_CART */]) {
        if (this.focused === 'nocoupon' && this.form.coupon_ids.length) {
          return 'nocoupon';
        }
        if (this.focused === 'second' && s.second_enabled) {
          return 'second';
        }
        return 'first';
      }
      return this.focused === 'announce' && s.announce_enabled ? 'announce' : 'day';
    },
    previewPush: function previewPush() {
      var s = this.form.settings || {};
      var push = PUSHES[this.activePush];
      return { title: s[push.title], message: s[push.message] };
    },
    previewWhen: function previewWhen() {
      var s = this.form.settings || {};
      switch (this.activePush) {
        case 'announce':
          return this.$t('marketingAutomation.announceDaysBeforeShort', { days: s.announce_days_before || '?' });
        case 'first':
        case 'nocoupon':
          return this.$t('marketingAutomation.cartFirstWhen', { time: this.durationText(s.first_delay_minutes, false) });
        case 'second':
          return this.$t('marketingAutomation.cartSecondWhen', { time: this.durationText(s.second_delay_minutes, false) });
        default:
          return this.$t('marketingAutomation.onTheDayShort') + ' ' + (s.send_time || '');
      }
    },
    placeholders: function placeholders() {
      var list = [{ key: '{nume}', label: 'marketingAutomation.placeholderName' }];
      if (this.activePush === 'announce') {
        list.push({ key: '{zile}', label: 'marketingAutomation.placeholderDays' });
      }

      var noCoupon = !this.form.coupon_ids.length;
      list.push({
        key: '{cod}',
        label: 'marketingAutomation.placeholderCode',
        disabled: noCoupon || this.activePush === 'nocoupon',
        disabledHint: noCoupon ? 'marketingAutomation.codeNeedsCoupon' : 'marketingAutomation.codeNotInNoCoupon'
      });
      return list;
    },
    codeWithoutCoupon: function codeWithoutCoupon() {
      if (this.form.coupon_ids.length) {
        return false;
      }
      var s = this.form.settings || {};
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(PUSHES).some(function (key) {
        var push = PUSHES[key];
        return [s[push.title], s[push.message]].some(function (text) {
          return (text || '').indexOf('{cod}') !== -1;
        });
      });
    },
    previewExample: function previewExample() {
      var push = PUSHES[this.activePush];
      return { title: this.example(push.exampleTitle), message: this.example(push.exampleMessage) };
    },
    selectedCodes: function selectedCodes() {
      var _this = this;

      return this.coupons.filter(function (coupon) {
        return _this.form.coupon_ids.indexOf(coupon.id) !== -1 && coupon.coupon_code;
      }).map(function (coupon) {
        return coupon.coupon_code;
      });
    },
    codeMissing: function codeMissing() {
      var s = this.form.settings || {};
      var texts = [s.day_title, s.day_message];
      if (this.form.type === __WEBPACK_IMPORTED_MODULE_15__automationTypes__["c" /* AUTOMATION_TYPE_CART */]) {
        texts = [s.first_title, s.first_message];
        if (s.second_enabled) {
          texts.push(s.second_title, s.second_message);
        }
      } else if (s.announce_enabled) {
        texts.push(s.announce_title, s.announce_message);
      }
      var usesCode = texts.some(function (text) {
        return (text || '').indexOf('{cod}') !== -1;
      });
      return usesCode && this.form.coupon_ids.length > 0 && !this.selectedCodes.length;
    },
    filteredCoupons: function filteredCoupons() {
      var q = (this.couponSearch || '').trim().toLowerCase();
      if (!q) {
        return this.coupons;
      }
      return this.coupons.filter(function (coupon) {
        return (coupon.name || '').toLowerCase().indexOf(q) !== -1;
      });
    }
  },
  created: function created() {
    var companyData = this.$session.get('selectedCompanyData') || {};
    this.currency = this.getCurrencySymbol(companyData.currency_iso);
    this.companyName = companyData.name || '';
    this.getCoupons();
    if (this.isEdit) {
      this.getCampaign();
    }
  },

  methods: {
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    defaultSettings: function defaultSettings(type) {
      if (type === __WEBPACK_IMPORTED_MODULE_15__automationTypes__["b" /* AUTOMATION_TYPE_BIRTHDAY */]) {
        return {
          announce_enabled: true,
          announce_days_before: 3,
          announce_title: '',
          announce_message: '',
          day_title: '',
          day_message: '',
          send_time: DEFAULT_SEND_TIME
        };
      }
      if (type === __WEBPACK_IMPORTED_MODULE_15__automationTypes__["c" /* AUTOMATION_TYPE_CART */]) {
        return {
          first_delay_minutes: 60,
          first_title: '',
          first_message: '',
          nocoupon_title: '',
          nocoupon_message: '',
          second_enabled: true,
          second_delay_minutes: 1440,
          second_title: '',
          second_message: '',
          quiet_enabled: true,
          quiet_from: '22:00',
          quiet_to: '09:00',
          coupon_cooldown_days: 7
        };
      }
      return {};
    },
    defaultFocus: function defaultFocus(type) {
      return type === __WEBPACK_IMPORTED_MODULE_15__automationTypes__["c" /* AUTOMATION_TYPE_CART */] ? 'first' : 'day';
    },
    durationText: function durationText(minutes) {
      var withEquals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var total = parseInt(minutes, 10);
      if (!total || total < 0) {
        return '';
      }
      var days = Math.floor(total / 1440);
      var hours = Math.floor(total % 1440 / 60);
      var mins = total % 60;
      var parts = [];
      if (days) {
        parts.push(days + this.$t('marketingAutomation.unitDay'));
      }
      if (hours) {
        parts.push(hours + 'h');
      }
      if (mins) {
        parts.push(mins + 'min');
      }
      return (withEquals ? '= ' : '') + parts.join(' ');
    },
    canPickType: function canPickType(item) {
      return item.available && !this.isEdit;
    },
    pickType: function pickType(item) {
      if (!this.canPickType(item) || this.form.type === item.value) {
        return;
      }
      this.form.type = item.value;
      this.form.settings = this.defaultSettings(item.value);
      this.focused = this.defaultFocus(item.value);
    },
    getCampaign: function getCampaign() {
      var _this2 = this;

      this.loading = true;
      this.apiRequest('/automation-campaign/' + this.campaignId, 'GET', this.requestData(), function (response) {
        _this2.loading = false;
        if (!(response.status === true && response.data)) {
          return;
        }
        var data = response.data;
        _this2.form = {
          name: data.name || '',
          period: data.date_from && data.date_to ? [data.date_from, data.date_to] : null,
          active: !!data.active,
          type: data.type,
          settings: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.defaultSettings(data.type), data.settings || {}),
          coupon_ids: Array.isArray(data.coupon_ids) ? data.coupon_ids.slice() : []
        };
        if (data.type === __WEBPACK_IMPORTED_MODULE_15__automationTypes__["b" /* AUTOMATION_TYPE_BIRTHDAY */] && !_this2.form.settings.announce_days_before) {
          _this2.form.settings.announce_days_before = 3;
        }
        _this2.focused = _this2.defaultFocus(data.type);
      });
    },
    getCoupons: function getCoupons(callback) {
      var _this3 = this;

      this.apiRequest('/automation-campaign/coupons', 'GET', this.requestData(), function (response) {
        if (response.status === true) {
          _this3.coupons = response.data || [];
        }
        if (callback) {
          callback();
        }
      });
    },
    previewText: function previewText(text) {
      if (!text) {
        return '';
      }
      var days = this.form.settings && this.form.settings.announce_days_before || 3;
      var code = this.selectedCodes.length ? this.selectedCodes.join(', ') : this.form.type === __WEBPACK_IMPORTED_MODULE_15__automationTypes__["c" /* AUTOMATION_TYPE_CART */] ? 'COS10' : 'ZINASTERE20';

      if (!this.form.coupon_ids.length || this.activePush === 'nocoupon') {
        code = '';
      }
      var out = String(text).replace(/\{nume\}/g, 'Maria').replace(/\{zile\}/g, days).replace(/\{cod\}/g, code);
      if (!code) {
        out = out.replace(/[ \t]+([,.!?])/g, '$1').replace(/,(\s*[!?.])/g, '$1').replace(/:(\s*[!?.]|\s*$)/g, '$1').replace(/[ \t]{2,}/g, ' ').trim();
      }
      return out;
    },
    example: function example(key) {
      var finalKey = !this.form.coupon_ids.length && NO_COUPON_EXAMPLES[key] || key;
      return this.$t('marketingAutomation.' + finalKey, { nume: '{nume}', zile: '{zile}', cod: '{cod}' });
    },
    useExample: function useExample(which) {
      var _fields,
          _this4 = this;

      var s = this.form.settings;
      var push = PUSHES[which];
      var fields = (_fields = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_fields, push.title, push.exampleTitle), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_fields, push.message, push.exampleMessage), _fields);
      var apply = function apply() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(fields).forEach(function (field) {
          s[field] = _this4.example(fields[field]);
        });
        _this4.focused = which;
      };
      var hasText = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(fields).some(function (field) {
        return (s[field] || '').trim();
      });
      if (!hasText) {
        apply();
        return;
      }
      __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
        text: this.$t('marketingAutomation.useExampleConfirm'),
        type: 'question',
        showCancelButton: true
      }).then(function (result) {
        if (result) {
          apply();
        }
      }).catch(function () {});
    },
    insertPlaceholder: function insertPlaceholder(key) {
      var field = PUSHES[this.activePush].message;
      var current = this.form.settings[field] || '';
      if ((current + key).length > MESSAGE_MAX) {
        return;
      }
      this.form.settings[field] = current + (current && !/\s$/.test(current) ? ' ' : '') + key;
    },
    isCouponChecked: function isCouponChecked(id) {
      return this.form.coupon_ids.indexOf(id) !== -1;
    },
    toggleCoupon: function toggleCoupon(id) {
      var i = this.form.coupon_ids.indexOf(id);
      if (i === -1) {
        this.form.coupon_ids.push(id);
      } else {
        this.form.coupon_ids.splice(i, 1);
      }
    },
    couponDiscountText: function couponDiscountText(coupon) {
      if (coupon.type === 'FREE_PRODUCT') {
        return this.$t('marketingCoupons.freeProduct');
      }
      return (coupon.discount || 0) + ' ' + (coupon.type === 'FIXED' ? this.currency : '%');
    },
    formatDay: function formatDay(value) {
      if (!value) {
        return '-';
      }
      var parts = String(value).substr(0, 10).split('-');
      return parts.length === 3 ? parts[2] + '.' + parts[1] + '.' + parts[0] : value;
    },
    couponValidityText: function couponValidityText(coupon) {
      return this.formatDay(coupon.datetime_validfrom) + ' - ' + this.formatDay(coupon.datetime_validto);
    },
    couponExpired: function couponExpired(coupon) {
      if (!coupon.datetime_validto) {
        return true;
      }
      return String(coupon.datetime_validto).substr(0, 10) < new Date().toISOString().substr(0, 10);
    },
    openCouponModal: function openCouponModal() {
      this.couponModalOpen = true;
      this.$modal.show('automationCouponModal');
    },
    closeCouponModal: function closeCouponModal() {
      this.$modal.hide('automationCouponModal');
      this.couponModalOpen = false;
    },
    onCouponModalOpened: function onCouponModalOpened() {
      var el = document.querySelector('.automationCouponModal.vm--container');
      if (el && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    },
    onCouponCreated: function onCouponCreated(coupon) {
      var _this5 = this;

      this.closeCouponModal();
      this.getCoupons(function () {
        if (coupon && coupon.id && _this5.form.coupon_ids.indexOf(coupon.id) === -1) {
          _this5.form.coupon_ids.push(coupon.id);
        }
      });
    },
    validate: function validate() {
      var _this6 = this;

      this.formErrors = {};
      var required = this.$t('validations.requiredField');
      var s = this.form.settings || {};
      if (!(this.form.name || '').trim()) {
        this.$set(this.formErrors, 'name', required);
      }
      if (!this.form.period || !this.form.period[0] || !this.form.period[1]) {
        this.$set(this.formErrors, 'period', required);
      }
      if (!this.form.type) {
        this.$set(this.formErrors, 'type', required);
      }
      if (this.form.type === __WEBPACK_IMPORTED_MODULE_15__automationTypes__["b" /* AUTOMATION_TYPE_BIRTHDAY */]) {
        if (s.announce_enabled) {
          var days = Number(s.announce_days_before);
          if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(days) || days < 1 || days > ANNOUNCE_DAYS_MAX) {
            this.$set(this.formErrors, 'announce_days_before', this.$t('marketingAutomation.announceDaysInvalid', { max: ANNOUNCE_DAYS_MAX }));
          }
          if (!(s.announce_title || '').trim()) {
            this.$set(this.formErrors, 'announce_title', required);
          }
          if (!(s.announce_message || '').trim()) {
            this.$set(this.formErrors, 'announce_message', required);
          }
        }
        if (!(s.day_title || '').trim()) {
          this.$set(this.formErrors, 'day_title', required);
        }
        if (!(s.day_message || '').trim()) {
          this.$set(this.formErrors, 'day_message', required);
        }
      }
      if (this.form.type === __WEBPACK_IMPORTED_MODULE_15__automationTypes__["c" /* AUTOMATION_TYPE_CART */]) {
        var between = function between(value, min, max) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(Number(value)) && Number(value) >= min && Number(value) <= max && value !== '';
        };
        var text = function text(key) {
          if (!(s[key] || '').trim()) {
            _this6.$set(_this6.formErrors, key, required);
          }
        };
        if (!between(s.first_delay_minutes, DELAY_MIN, FIRST_DELAY_MAX)) {
          this.$set(this.formErrors, 'first_delay_minutes', this.$t('marketingAutomation.delayInvalid', { min: DELAY_MIN, max: FIRST_DELAY_MAX }));
        }
        text('first_title');
        text('first_message');
        if (this.form.coupon_ids.length) {
          text('nocoupon_title');
          text('nocoupon_message');
          if (!between(s.coupon_cooldown_days, 0, COOLDOWN_MAX)) {
            this.$set(this.formErrors, 'coupon_cooldown_days', this.$t('marketingAutomation.cooldownInvalid', { max: COOLDOWN_MAX }));
          }
        }
        if (s.second_enabled) {
          if (!between(s.second_delay_minutes, DELAY_MIN, SECOND_DELAY_MAX)) {
            this.$set(this.formErrors, 'second_delay_minutes', this.$t('marketingAutomation.delayInvalid', { min: DELAY_MIN, max: SECOND_DELAY_MAX }));
          }
          text('second_title');
          text('second_message');
        }
        if (s.quiet_enabled && s.quiet_from === s.quiet_to) {
          this.$set(this.formErrors, 'quiet_to', this.$t('marketingAutomation.quietInvalid'));
        }
      }
      return !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.formErrors).length;
    },
    save: function save() {
      var _this7 = this;

      if (!this.validate()) {
        return;
      }

      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestData(), {
        name: this.form.name,
        active: this.form.active ? 1 : 0,
        date_from: this.form.period[0],
        date_to: this.form.period[1],
        type: this.form.type,
        settings: this.form.settings,
        coupon_ids: this.form.coupon_ids
      });
      var url = this.isEdit ? '/automation-campaign/' + this.campaignId : '/automation-campaign';
      var method = this.isEdit ? 'PUT' : 'POST';

      this.saving = true;
      this.apiRequest(url, method, data, function (response) {
        _this7.saving = false;
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
            title: '',
            text: _this7.$t('marketingAutomation.saved'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
          _this7.goBack();
          return;
        }

        var errors = response.errors || {};
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(errors).forEach(function (key) {
          var message = Array.isArray(errors[key]) ? errors[key][0] : errors[key];
          var field = key.replace('settings.', '').replace(/^date_(from|to)$/, 'period');
          _this7.$set(_this7.formErrors, field, message);
        });
        var messages = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(errors).map(function (key) {
          return Array.isArray(errors[key]) ? errors[key][0] : errors[key];
        });
        __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()('', messages.join(' ') || _this7.$t('validations.wentWrong'), 'error').catch(function () {});
      });
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "f+zA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-inventar-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f/HY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])]),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('coupon-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f1GC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('form',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCurrency.currency')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('el-select',{staticClass:"col-md-6",attrs:{"placeholder":" - Select Currency - ","filterable":""},model:{value:(_vm.model.currency_iso),callback:function ($$v) {_vm.$set(_vm.model, "currency_iso", $$v)},expression:"model.currency_iso"}},_vm._l((_vm.currencies),function(cr){return _c('el-option',{key:cr.iso,attrs:{"value":cr.iso,"label":_vm.displayCurrecy(cr)}})}))],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f1TT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_json_excel__ = __webpack_require__("fXhN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_LineChart_vue__ = __webpack_require__("w3Bt");





var _components;








__WEBPACK_IMPORTED_MODULE_4_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_8_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'LineChart', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_LineChart_vue__["a" /* default */]), _components),
  props: {
    isLabelEvolution: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isLabelEvolution: function isLabelEvolution() {
      if (this.isLabelEvolution) {
        this.getOrders();
      }
    }
  },
  created: function created() {},

  computed: {},
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_5_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')]
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(12, 'months').startOf('day') || date > __WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf('day');
        }
      },
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: '',
              fontColor: 'red',
              fontSize: 22
            },
            ticks: { beginAtZero: true }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Data',
              fontColor: 'red',
              fontSize: 22
            }
          }]
        }
      }
    };
  },

  methods: {
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    getOrders: function getOrders(query) {
      var _this = this;

      if (!this.isLabelEvolution) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };
      this.loading = true;

      this.apiRequest('/reports/v2/label-evolution', 'GET', data, function (response) {
        if (response.status) {
          _this.$nextTick(function () {
            _this.chartData = {
              labels: response.data.labels,
              datasets: response.data.datasets
            };
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
    }
  }
});

/***/ }),

/***/ "f9Y/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('loyalty-store-campaign-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f9hE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaigns_vue__ = __webpack_require__("mY1+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51da3791_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Campaigns_vue__ = __webpack_require__("QkjM");
function injectStyle (ssrContext) {
  __webpack_require__("DosS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Campaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51da3791_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Campaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fDUP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])]),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.detail),expression:"!detail"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"subs-title"},[_vm._v("\n          "+_vm._s(_vm.$t('marketingSubscriptions.subscribersTitle'))+"\n          "),(_vm.family)?_c('small',[_vm._v(" — "+_vm._s(_vm.family.name))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"subs-chips"},_vm._l((_vm.stateChips),function(chip){return _c('a',{key:chip.value,staticClass:"subs-chip",class:['subs-chip--' + (chip.value || 'all'), { 'is-active': _vm.filters.state === chip.value }],on:{"click":function($event){_vm.setState(chip.value)}}},[_vm._v("\n            "+_vm._s(chip.label)+" "),_c('span',{staticClass:"subs-chip__count"},[_vm._v(_vm._s(_vm.counts[chip.value || 'all'] || 0))])])})),_vm._v(" "),_c('div',{staticClass:"subs-filters"},[_c('div',{staticClass:"subs-filter subs-filter--search"},[_c('label',{staticClass:"subs-filter__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.customer')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.search),expression:"filters.search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('marketingSubscriptions.searchSubscribers')},domProps:{"value":(_vm.filters.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "search", $event.target.value)},_vm.onSearchInput]}})]),_vm._v(" "),(_vm.family && _vm.family.levels.length > 1)?_c('div',{staticClass:"subs-filter"},[_c('label',{staticClass:"subs-filter__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.level')))]),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","placeholder":_vm.$t('marketingSubscriptions.allLevels')},on:{"change":_vm.reload},model:{value:(_vm.filters.subscription_id),callback:function ($$v) {_vm.$set(_vm.filters, "subscription_id", $$v)},expression:"filters.subscription_id"}},_vm._l((_vm.family.levels),function(level){return _c('el-option',{key:level.id,attrs:{"label":level.level + '. ' + level.name,"value":level.id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subs-filter"},[_c('label',{staticClass:"subs-filter__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.autoRenew')))]),_vm._v(" "),_c('el-select',{on:{"change":_vm.reload},model:{value:(_vm.filters.auto_renew),callback:function ($$v) {_vm.$set(_vm.filters, "auto_renew", $$v)},expression:"filters.auto_renew"}},[_c('el-option',{attrs:{"label":_vm.$t('marketingSubscriptions.stateAll'),"value":""}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('marketingSubscriptions.yes'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('marketingSubscriptions.no'),"value":"0"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"subs-filter subs-filter--dates"},[_c('label',{staticClass:"subs-filter__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.activeUntil')))]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd.MM.yyyy","range-separator":"-","start-placeholder":_vm.$t('marketingSubscriptions.dateFrom'),"end-placeholder":_vm.$t('marketingSubscriptions.dateTo')},on:{"change":_vm.reload},model:{value:(_vm.filters.active_until),callback:function ($$v) {_vm.$set(_vm.filters, "active_until", $$v)},expression:"filters.active_until"}})],1)]),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"subs-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.items,"empty-text":_vm.$t('marketingSubscriptions.noSubscribers'),"default-sort":{ prop: 'active_until', order: 'descending' }},on:{"row-click":_vm.openDetail,"sort-change":_vm.onSortChange}},[_c('el-table-column',{attrs:{"label":_vm.$t('marketingSubscriptions.customer'),"min-width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.user)?_c('div',[_c('strong',[_vm._v(_vm._s(props.row.user.name || ('#' + props.row.user.id)))]),_vm._v(" "),_c('div',{staticClass:"subs-muted"},[_vm._v(_vm._s(props.row.user.email)),(props.row.user.phone)?_c('span',[_vm._v(" · "+_vm._s(props.row.user.phone))]):_vm._e()])]):_c('span',{staticClass:"subs-muted"},[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('marketingSubscriptions.level'),"min-width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.subscription)?_c('span',[_vm._v(_vm._s(props.row.subscription.level)+". "+_vm._s(props.row.subscription.name))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('marketingSubscriptions.status'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"subs-state",class:'subs-state--' + props.row.state},[_vm._v(_vm._s(_vm.stateLabel(props.row.state)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"active_until","sortable":"custom","label":_vm.$t('marketingSubscriptions.activeUntil'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.active_until)?_c('span',[_vm._v(_vm._s(_vm._f("formatDateTime")(props.row.active_until)))]):_c('span',{staticClass:"subs-muted"},[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('marketingSubscriptions.autoRenew'),"min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"subs-renew",class:props.row.auto_renew ? 'subs-renew--on' : 'subs-renew--off',attrs:{"title":_vm.renewTitle(props.row)}},[_c('i',{staticClass:"fa",class:props.row.auto_renew ? 'fa-refresh' : 'fa-ban'}),_vm._v("\n                "+_vm._s(props.row.auto_renew ? _vm.$t('marketingSubscriptions.yes') : _vm.$t('marketingSubscriptions.no'))+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_paid","sortable":"custom","label":_vm.$t('marketingSubscriptions.totalPaid'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.total_paid)+" "+_vm._s(_vm.currency)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"last_payment_at","sortable":"custom","label":_vm.$t('marketingSubscriptions.lastPayment'),"min-width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.last_payment_at)?[_vm._v("\n                "+_vm._s(_vm._f("formatDateTime")(props.row.last_payment_at))+"\n                "),(props.row.last_payment_status !== null)?_c('span',{staticClass:"subs-pay",class:'subs-pay--' + props.row.last_payment_status},[_vm._v(_vm._s(_vm.paymentStatusLabel(props.row.last_payment_status)))]):_vm._e()]:_c('span',{staticClass:"subs-muted"},[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"110","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"subs-link",on:{"click":function($event){$event.stopPropagation();_vm.openDetail(props.row)}}},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.details'))+" "),_c('i',{staticClass:"fa fa-angle-right"})])]}}])})],1),_vm._v(" "),(_vm.pagination.total > _vm.pagination.per_page)?_c('el-pagination',{staticClass:"active-pagination subs-pagination",attrs:{"total":_vm.pagination.total,"page-size":_vm.pagination.per_page,"current-page":_vm.pagination.page,"layout":"prev, pager, next, total"},on:{"current-change":_vm.handlePageChange}}):_vm._e()],1)]),_vm._v(" "),(_vm.detail)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.detailLoading),expression:"detailLoading"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('a',{staticClass:"subs-link",on:{"click":function($event){_vm.detail = null}}},[_c('i',{staticClass:"fa fa-angle-left"}),_vm._v(" "+_vm._s(_vm.$t('marketingSubscriptions.backToList')))]),_vm._v(" "),_c('div',{staticClass:"subs-detail-head"},[_c('div',[_c('h4',{staticClass:"subs-title"},[_vm._v(_vm._s(_vm.detail.user ? (_vm.detail.user.name || ('#' + _vm.detail.user.id)) : '-'))]),_vm._v(" "),(_vm.detail.user)?_c('div',{staticClass:"subs-muted"},[_vm._v(_vm._s(_vm.detail.user.email)),(_vm.detail.user.phone)?_c('span',[_vm._v(" · "+_vm._s(_vm.detail.user.phone))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"subs-state subs-state--big",class:'subs-state--' + _vm.detail.state},[_vm._v(_vm._s(_vm.stateLabel(_vm.detail.state)))])]),_vm._v(" "),_c('div',{staticClass:"subs-facts"},[_c('div',{staticClass:"subs-fact"},[_c('div',{staticClass:"subs-fact__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.currentLevel')))]),_vm._v(" "),(_vm.detail.subscription)?_c('div',{staticClass:"subs-fact__value"},[_vm._v(_vm._s(_vm.detail.subscription.level)+". "+_vm._s(_vm.detail.subscription.name))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"subs-fact"},[_c('div',{staticClass:"subs-fact__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.activeUntil')))]),_vm._v(" "),_c('div',{staticClass:"subs-fact__value"},[_vm._v(_vm._s(_vm.detail.active_until ? _vm.$options.filters.formatDateTime(_vm.detail.active_until) : '-'))])]),_vm._v(" "),_c('div',{staticClass:"subs-fact"},[_c('div',{staticClass:"subs-fact__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.renewalPrice')))]),_vm._v(" "),_c('div',{staticClass:"subs-fact__value"},[_vm._v(_vm._s(_vm.detail.price)+" "+_vm._s(_vm.currency))])]),_vm._v(" "),_c('div',{staticClass:"subs-fact"},[_c('div',{staticClass:"subs-fact__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.totalPaid')))]),_vm._v(" "),_c('div',{staticClass:"subs-fact__value"},[_vm._v(_vm._s(_vm.detail.total_paid)+" "+_vm._s(_vm.currency))])]),_vm._v(" "),_c('div',{staticClass:"subs-fact"},[_c('div',{staticClass:"subs-fact__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.autoRenew')))]),_vm._v(" "),_c('div',{staticClass:"subs-fact__value"},[_c('span',{staticClass:"subs-renew",class:_vm.detail.auto_renew ? 'subs-renew--on' : 'subs-renew--off'},[_c('i',{staticClass:"fa",class:_vm.detail.auto_renew ? 'fa-refresh' : 'fa-ban'}),_vm._v("\n                "+_vm._s(_vm.detail.auto_renew ? _vm.$t('marketingSubscriptions.yes') : _vm.$t('marketingSubscriptions.no'))+"\n              ")]),_vm._v(" "),(!_vm.detail.auto_renew && _vm.detail.renewal_cancelled_at)?_c('div',{staticClass:"subs-muted"},[_vm._v("\n                "+_vm._s(_vm.$t('marketingSubscriptions.renewalCancelledAt'))+": "+_vm._s(_vm._f("formatDateTime")(_vm.detail.renewal_cancelled_at))+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"subs-fact"},[_c('div',{staticClass:"subs-fact__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.card')))]),_vm._v(" "),_c('div',{staticClass:"subs-fact__value"},[_vm._v(_vm._s(_vm.detail.card_mask || '-'))])]),_vm._v(" "),_c('div',{staticClass:"subs-fact"},[_c('div',{staticClass:"subs-fact__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.subscriberSince')))]),_vm._v(" "),_c('div',{staticClass:"subs-fact__value"},[_vm._v(_vm._s(_vm.detail.created_at ? _vm.$options.filters.formatDateTime(_vm.detail.created_at) : '-'))])])]),_vm._v(" "),(_vm.detail.can_cancel)?_c('div',{staticClass:"subs-actions"},[(_vm.detail.downgrade_levels && _vm.detail.downgrade_levels.length)?_c('a',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){_vm.openAction('downgrade')}}},[_c('i',{staticClass:"fa fa-level-down"}),_vm._v(" "+_vm._s(_vm.$t('marketingSubscriptions.downgrade'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){_vm.openAction('cancel')}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" "+_vm._s(_vm.$t('marketingSubscriptions.cancelSubscription'))+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.action)?_c('div',{staticClass:"subs-action-box",class:'subs-action-box--' + _vm.action},[_c('p',{staticClass:"subs-action-box__hint"},[_vm._v("\n            "+_vm._s(_vm.action === 'cancel' ? _vm.$t('marketingSubscriptions.cancelHint') : _vm.$t('marketingSubscriptions.downgradeHint'))+"\n          ")]),_vm._v(" "),(_vm.action === 'downgrade')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.downgradeTo'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.actionLevelId),expression:"actionLevelId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.actionLevelId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.detail.downgrade_levels),function(level){return _c('option',{key:'dl' + level.id,domProps:{"value":level.id}},[_vm._v("\n                "+_vm._s(level.level)+". "+_vm._s(level.name)+" - "+_vm._s(level.price)+" "+_vm._s(_vm.currency)+"\n              ")])}))]):_vm._e(),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.reason'))+"*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.actionComment),expression:"actionComment"}],staticClass:"form-control",attrs:{"rows":"3","maxlength":"1000"},domProps:{"value":(_vm.actionComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.actionComment=$event.target.value}}}),_vm._v(" "),(_vm.actionError)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.actionError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subs-refund__actions"},[_c('button',{staticClass:"btn btn-default btn-sm",attrs:{"disabled":_vm.actionSaving},on:{"click":function($event){$event.preventDefault();_vm.action = null}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-fill",class:_vm.action === 'cancel' ? 'btn-danger' : 'btn-warning',attrs:{"disabled":_vm.actionSaving},on:{"click":function($event){$event.preventDefault();return _vm.confirmAction($event)}}},[_c('i',{staticClass:"fa",class:_vm.actionSaving ? 'fa-spinner fa-spin' : 'fa-check'}),_vm._v("\n              "+_vm._s(_vm.action === 'cancel' ? _vm.$t('marketingSubscriptions.cancelSubscription') : _vm.$t('marketingSubscriptions.downgrade'))+"\n            ")])])]):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"subs-section"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.history')))]),_vm._v(" "),(!_vm.detail.events || !_vm.detail.events.length)?_c('p',{staticClass:"subs-muted"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.noHistory')))]):_vm._e(),_vm._v(" "),_vm._l((_vm.detail.events),function(event){return _c('div',{key:'ev' + event.id,staticClass:"subs-event",class:'subs-event--' + event.type},[_c('div',{staticClass:"subs-event__head"},[_c('strong',[_vm._v(_vm._s(_vm.eventLabel(event.type)))]),_vm._v(" "),_c('span',{staticClass:"subs-muted"},[_vm._v(_vm._s(_vm._f("formatDateTime")(event.created_at))),(event.by)?_c('span',[_vm._v(" · "+_vm._s(event.by))]):_vm._e()])]),_vm._v(" "),(_vm.eventDetails(event))?_c('div',{staticClass:"subs-event__details"},[_vm._v(_vm._s(_vm.eventDetails(event)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subs-event__comment"},[_vm._v(_vm._s(event.comment))])])}),_vm._v(" "),_c('h5',{staticClass:"subs-section"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.periods')))]),_vm._v(" "),(!_vm.detail.periods || !_vm.detail.periods.length)?_c('p',{staticClass:"subs-muted"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.noPeriods')))]):_vm._e(),_vm._v(" "),_vm._l((_vm.detail.periods),function(period){return _c('div',{key:'period' + period.id,staticClass:"subs-period"},[_c('div',{staticClass:"subs-period__head"},[_c('span',{staticClass:"subs-kind"},[_vm._v(_vm._s(_vm.kindLabel(period.kind)))]),_vm._v(" "),(period.subscription)?_c('strong',[_vm._v(_vm._s(period.subscription.level)+". "+_vm._s(period.subscription.name))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"subs-muted"},[_vm._v(_vm._s(_vm._f("formatDate")(period.period_start))+" → "+_vm._s(_vm._f("formatDate")(period.period_end)))]),_vm._v(" "),_c('span',{staticClass:"subs-period__amount"},[_vm._v(_vm._s(period.amount)+" "+_vm._s(_vm.currency))]),_vm._v(" "),_c('span',{staticClass:"subs-period-status",class:'subs-period-status--' + period.status},[_vm._v(_vm._s(_vm.periodStatusLabel(period.status)))])]),_vm._v(" "),(period.auto_charge_attempts || period.expiry_notified_at)?_c('div',{staticClass:"subs-muted subs-period__meta"},[(period.auto_charge_attempts)?_c('span',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.autoChargeAttempts'))+": "+_vm._s(period.auto_charge_attempts))]):_vm._e(),_vm._v(" "),(period.expiry_notified_at)?_c('span',[_vm._v(" · "+_vm._s(_vm.$t('marketingSubscriptions.notifiedAt'))+": "+_vm._s(_vm._f("formatDateTime")(period.expiry_notified_at)))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subs-payments"},[_c('div',{staticClass:"subs-payments__title"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.paymentAttempts')))]),_vm._v(" "),(!period.payments.length)?_c('p',{staticClass:"subs-muted"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.noPayments')))]):_vm._e(),_vm._v(" "),_vm._l((period.payments),function(payment){return _c('div',{key:'payment' + payment.id,staticClass:"subs-payment"},[_c('div',{staticClass:"subs-payment__row"},[_c('span',{staticClass:"subs-pay",class:'subs-pay--' + payment.status},[_vm._v(_vm._s(_vm.paymentStatusLabel(payment.status)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(payment.method === 2 ? _vm.$t('marketingSubscriptions.methodSavedCard') : _vm.$t('marketingSubscriptions.methodLink')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(payment.amount)+" "+_vm._s(_vm.currency))]),_vm._v(" "),_c('span',{staticClass:"subs-muted"},[_vm._v(_vm._s(_vm._f("formatDateTime")(payment.created_at)))]),_vm._v(" "),(payment.reference)?_c('span',{staticClass:"subs-muted"},[_vm._v("#"+_vm._s(payment.reference))]):_vm._e(),_vm._v(" "),(payment.gateway_transaction_id)?_c('span',{staticClass:"subs-muted"},[_vm._v("ep_id "+_vm._s(payment.gateway_transaction_id))]):_vm._e(),_vm._v(" "),(payment.card_mask)?_c('span',{staticClass:"subs-muted"},[_vm._v(_vm._s(payment.card_mask))]):_vm._e(),_vm._v(" "),(payment.logs.length)?_c('a',{staticClass:"subs-link subs-payment__logs-toggle",on:{"click":function($event){_vm.toggleLogs(payment.id)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('marketingSubscriptions.showLogs'))+" ("+_vm._s(payment.logs.length)+")\n                  "),_c('i',{staticClass:"fa",class:_vm.openLogs[payment.id] ? 'fa-angle-up' : 'fa-angle-down'})]):_vm._e()]),_vm._v(" "),(payment.error_message)?_c('div',{staticClass:"subs-payment__error"},[_vm._v(_vm._s(payment.error_message))]):_vm._e(),_vm._v(" "),(payment.status === 6)?_c('div',{staticClass:"subs-refund-info"},[_c('i',{staticClass:"fa fa-undo"}),_vm._v("\n                "+_vm._s(payment.refund_type === 'reversal' ? _vm.$t('marketingSubscriptions.refundTypeReversal') : _vm.$t('marketingSubscriptions.refundTypeRefund'))+"\n                · "+_vm._s(_vm._f("formatDateTime")(payment.refunded_at))+"\n                "),(payment.refunded_by)?_c('span',[_vm._v("· "+_vm._s(payment.refunded_by))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subs-refund-info__comment"},[_vm._v(_vm._s(payment.refund_comment))])]):_vm._e(),_vm._v(" "),(_vm.detail.refundable_payment_ids && _vm.detail.refundable_payment_ids.indexOf(payment.id) !== -1)?_c('div',{staticClass:"subs-refund"},[(_vm.refundPaymentId !== payment.id)?_c('a',{staticClass:"btn btn-sm btn-danger subs-refund__open",on:{"click":function($event){_vm.openRefund(payment.id)}}},[_c('i',{staticClass:"fa fa-undo"}),_vm._v(" "+_vm._s(_vm.$t('marketingSubscriptions.refundPayment'))+"\n                ")]):_c('div',{staticClass:"subs-refund__box"},[_c('p',{staticClass:"subs-refund__hint"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.refundHint', { amount: payment.amount + ' ' + _vm.currency })))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.reason'))+"*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.refundComment),expression:"refundComment"}],staticClass:"form-control",attrs:{"rows":"3","maxlength":"1000"},domProps:{"value":(_vm.refundComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.refundComment=$event.target.value}}}),_vm._v(" "),(_vm.refundError)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.refundError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subs-refund__actions"},[_c('button',{staticClass:"btn btn-default btn-sm",attrs:{"disabled":_vm.refunding},on:{"click":function($event){$event.preventDefault();_vm.refundPaymentId = null}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm btn-fill",attrs:{"disabled":_vm.refunding},on:{"click":function($event){$event.preventDefault();_vm.confirmRefund(payment)}}},[_c('i',{staticClass:"fa",class:_vm.refunding ? 'fa-spinner fa-spin' : 'fa-undo'}),_vm._v(" "+_vm._s(_vm.$t('marketingSubscriptions.refundConfirm'))+"\n                    ")])])])]):_vm._e(),_vm._v(" "),(_vm.openLogs[payment.id])?_c('div',{staticClass:"subs-logs"},_vm._l((payment.logs),function(log){return _c('div',{key:'log' + log.id,staticClass:"subs-log"},[_c('div',{staticClass:"subs-log__head"},[_c('strong',[_vm._v(_vm._s(log.action))]),_vm._v(" "),_c('span',{staticClass:"subs-muted"},[_vm._v(_vm._s(_vm._f("formatDateTime")(log.created_at)))]),_vm._v(" "),(log.http_code)?_c('span',{staticClass:"subs-muted"},[_vm._v("HTTP "+_vm._s(log.http_code))]):_vm._e(),_vm._v(" "),(log.duration_ms)?_c('span',{staticClass:"subs-muted"},[_vm._v(_vm._s(log.duration_ms)+" ms")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"subs-log__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.request')))]),_vm._v(" "),_c('pre',{staticClass:"subs-log__body"},[_vm._v(_vm._s(_vm.prettyJson(log.request)))]),_vm._v(" "),_c('div',{staticClass:"subs-log__label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.response')))]),_vm._v(" "),_c('pre',{staticClass:"subs-log__body"},[_vm._v(_vm._s(_vm.prettyJson(log.response)))])])})):_vm._e()])})],2)])})],2)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fGFU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fIC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var end = new Date();
    var start = new Date();
    start.setDate(end.getDate() - 29);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    return {
      loading: false,
      tableData: [],
      totalItems: 0,
      totalValue: 0,
      selectedGestiune: null,
      selectedLocation: null,
      searchDate: [start, end],
      selectedProduct: {},
      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            var end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      }
    };
  },

  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id;
      });
      return result;
    }
  },
  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.resetTable();

      this.selectedGestiune = null;
      this.tableData = [];
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    this.firstLoad();
  },

  methods: {
    firstLoad: function firstLoad() {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0];
      }
    },
    openViewSalesMarkup: function openViewSalesMarkup(row) {
      this.selectedProduct = {
        name: row.product_name,

        purchaseDocuments: row.purchaseDocuments || []
      };

      this.$refs.salesMarkupModal.open();
    },
    closesalesMarkupModal: function closesalesMarkupModal() {
      this.$modal.hide('salesMarkupModal');
    },
    triggerFilter: function triggerFilter() {
      if (!this.selectedGestiune) {
        return;
      }
      if (!this.selectedLocation) {
        return;
      }
      if (!this.searchDate || this.searchDate.length !== 2) {
        return;
      }

      this.resetTable();
      this.fetchSalesMarkupReport();
    },
    getCategoryClass: function getCategoryClass(categorie) {
      if (!categorie) return '';

      switch (categorie.toLowerCase().replace(/\s+/g, '-')) {
        case 'marfa':
          return 'marfa';
        case 'semifabricate-(reteta)':
          return 'semifabricate';
        case 'materii-prime':
          return 'materii-prime';
        case 'produs-finit-(reteta)':
          return 'produs-finit';
        default:
          return '';
      }
    },
    fetchSalesMarkupReport: function fetchSalesMarkupReport() {
      var _this2 = this;

      var exportFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var externalCompanyId, _searchDate, startDate, endDate, params, url, response, data, grouped;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.searchDate) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                _this2.loading = true;

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  type: 'info',
                  title: 'Se generează raportul de adaos',
                  text: 'Vă rugăm așteptați...',
                  allowOutsideClick: false,
                  didOpen: function didOpen() {
                    return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.showLoading();
                  }
                });

                _context.prev = 4;
                externalCompanyId = _this2.$session.get('selectedCompany');
                _searchDate = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_this2.searchDate, 2), startDate = _searchDate[0], endDate = _searchDate[1];
                params = new URLSearchParams({
                  startDate: new Date(startDate).toISOString(),
                  endDate: new Date(endDate).toISOString()
                });

                params.append('externalCompanyId', externalCompanyId);

                if (_this2.selectedLocation && _this2.selectedLocation.true_id) {
                  params.append('externalLocationId', _this2.selectedLocation.true_id);
                }

                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/raport-vazari-adaos?' + params.toString();


                if (exportFormat) {
                  url += '&export=' + exportFormat.toUpperCase();
                }

                _context.next = 14;
                return fetch(url);

              case 14:
                response = _context.sent;

                console.log('Răspuns raport adaos vânzări:', response);

                if (response.ok) {
                  _context.next = 18;
                  break;
                }

                throw new Error('HTTP ' + response.status);

              case 18:
                if (!exportFormat) {
                  _context.next = 22;
                  break;
                }

                window.location.href = url;

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.close();
                }, 800);

                return _context.abrupt('return');

              case 22:
                _context.next = 24;
                return response.json();

              case 24:
                data = _context.sent;


                if (Array.isArray(data.items)) {
                  grouped = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(data.items.reduce(function (acc, item) {
                    var key = item.productId || item.product_name;

                    if (!acc[key]) {
                      acc[key] = {
                        productId: item.productId,
                        product_name: item.product_name,
                        unit: item.unit,
                        quantity: 0,
                        in_price: item.in_price,
                        sale_price: item.sale_price,
                        vat_percent: item.vat_percent,
                        vat_value: 0,
                        discount_value: 0,
                        discount_vat_value: 0,
                        markup_value: 0,
                        purchaseDocuments: []
                      };
                    }

                    acc[key].quantity += Number(item.quantity) || 0;
                    acc[key].vat_value += Number(item.vat_value) || 0;
                    acc[key].discount_value += Number(item.discount_value) || 0;
                    acc[key].discount_vat_value += Number(item.discount_vat_value) || 0;
                    acc[key].markup_value += Number(item.markup_value) || 0;

                    acc[key].purchaseDocuments.push(item);

                    return acc;
                  }, {}));


                  _this2.totalValue = grouped.reduce(function (sum, item) {
                    return sum + (Number(item.markup_value) || 0);
                  }, 0);

                  _this2.tableData = grouped;
                } else {
                  _this2.tableData = [];
                }

                _this2.totalItems = data.totalItems || 0;
                _context.next = 34;
                break;

              case 29:
                _context.prev = 29;
                _context.t0 = _context['catch'](4);

                console.error('Eroare raport adaos vânzări:', _context.t0);
                _this2.tableData = [];

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Nu s-a putut genera raportul de adaos.',
                  icon: 'error'
                });

              case 34:
                _context.prev = 34;

                _this2.loading = false;
                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.close();
                return _context.finish(34);

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 29, 34, 38]]);
      }))();
    },
    resetTable: function resetTable() {
      this.tableData = [];
    }
  }
});

/***/ }),

/***/ "fKeh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyPointsScanner_vue__ = __webpack_require__("1rQM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeba8e82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyPointsScanner_vue__ = __webpack_require__("sSci");
function injectStyle (ssrContext) {
  __webpack_require__("M9c6")
  __webpack_require__("70Hq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aeba8e82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyPointsScanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeba8e82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyPointsScanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fNaR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"margin":"20px 0","font-size":"16px"}},[_vm._v("\n    Urmează un dashboard cu mai multe rapoarte, pentru a putea vizualiza informațiile importante într-un singur loc.\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fPPq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('reward-form',{on:{"on-submit":_vm.onRewardSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fPtS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  },
  data: function data() {
    var end = new Date();
    var start = new Date();
    start.setDate(end.getDate() - 29);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    return {
      loading: false,
      tableData: [],
      totalItems: 0,
      selectedGestiune: null,
      selectedLocation: null,
      searchDate: [start, end],
      selectedProduct: {},
      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            var end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      }
    };
  },

  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id;
      });
      return result;
    }
  },
  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.resetTable();

      this.selectedGestiune = null;
      this.tableData = [];
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    this.firstLoad();
  },

  methods: {
    formatNumber: function formatNumber(value) {
      if (value === null || value === undefined) return '';
      var num = Number(value);
      if (isNaN(num)) return '';
      return num.toFixed(2);
    },
    formatIfNotZero: function formatIfNotZero(value) {
      if (!value || Number(value) === 0) return '';
      return Number(value).toFixed(2);
    },
    firstLoad: function firstLoad() {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0];
      }
    },
    triggerFilter: function triggerFilter() {
      if (!this.selectedGestiune) {
        return;
      }
      if (!this.selectedLocation) {
        return;
      }
      if (!this.searchDate || this.searchDate.length !== 2) {
        return;
      }

      this.resetTable();
      this.fetchBalanceReport();
    },
    fetchBalanceReport: function fetchBalanceReport() {
      var _this2 = this;

      var exportFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _searchDate, startDate, endDate, externalCompanyId, params, url, response, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this2.selectedGestiune || !_this2.selectedLocation || !_this2.searchDate)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                _this2.loading = true;

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  type: 'info',
                  title: 'Se generează raportul de balanta centralizata',
                  text: 'Vă rugăm așteptați...',
                  allowOutsideClick: false,
                  didOpen: function didOpen() {
                    return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.showLoading();
                  }
                });

                _context.prev = 4;
                _searchDate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_this2.searchDate, 2), startDate = _searchDate[0], endDate = _searchDate[1];
                externalCompanyId = _this2.$session.get('selectedCompany');
                params = new URLSearchParams({
                  gestiune: _this2.selectedGestiune,
                  startDate: new Date(startDate).toISOString(),
                  endDate: new Date(endDate).toISOString(),
                  externalCompanyId: externalCompanyId,
                  externalLocationId: _this2.selectedLocation.true_id,
                  vatNumber: _this2.selectedLocation.inv_fiscal_code
                });


                if (exportFormat) {
                  params.append('export', exportFormat.toUpperCase());
                }

                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/reports/centralized-balance?' + params.toString();

                if (!exportFormat) {
                  _context.next = 14;
                  break;
                }

                window.location.href = url;
                setTimeout(function () {
                  return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.close();
                }, 800);
                return _context.abrupt('return');

              case 14:
                _context.next = 16;
                return fetch(url);

              case 16:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 19;
                  break;
                }

                throw new Error('HTTP ' + response.status);

              case 19:
                _context.next = 21;
                return response.json();

              case 21:
                data = _context.sent;

                _this2.tableData = data.items.map(function (item, index) {
                  return {
                    nr: index + 1,
                    product_name: item.product_name,
                    unit: item.unit,
                    stock_initial_qty: item.stock_initial.quantity,
                    stock_initial_val: item.stock_initial.value,
                    entries_nir_qty: item.entries.nir.quantity,
                    entries_nir_val: item.entries.nir.value,
                    entries_transfer_qty: item.entries.transfer.quantity,
                    entries_transfer_val: item.entries.transfer.value,
                    entries_productie_qty: item.entries.productie.quantity,
                    entries_productie_val: item.entries.productie.value,
                    exits_nir_qty: item.exits.nir.quantity,
                    exits_nir_val: item.exits.nir.value,
                    exits_vanzare_qty: item.exits.vanzare.quantity,
                    exits_vanzare_val: item.exits.vanzare.value,
                    exits_bon_consum_qty: item.exits.bon_consum.quantity,
                    exits_bon_consum_val: item.exits.bon_consum.value,
                    exits_transfer_qty: item.exits.transfer.quantity,
                    exits_transfer_val: item.exits.transfer.value,
                    exits_productie_qty: item.exits.productie.quantity,
                    exits_productie_val: item.exits.productie.value,
                    exits_casare_qty: item.exits.casare.quantity,
                    exits_casare_val: item.exits.casare.value,
                    exits_aviz_qty: item.exits.aviz.quantity,
                    exits_aviz_val: item.exits.aviz.value,
                    exits_inventar_qty: item.exits.inventar.quantity,
                    exits_inventar_val: item.exits.inventar.value,
                    stock_final_qty: item.stock_final.quantity,
                    stock_final_val: item.stock_final.value
                  };
                });

                _this2.totalItems = data.totalItems || 0;
                _context.next = 31;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context['catch'](4);

                console.error('Eroare raport balanta centralizata:', _context.t0);
                _this2.tableData = [];
                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Nu s-a putut genera raportul de balanta centralizata.',
                  icon: 'error'
                });

              case 31:
                _context.prev = 31;

                _this2.loading = false;
                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.close();
                return _context.finish(31);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 26, 31, 35]]);
      }))();
    },
    resetTable: function resetTable() {
      this.tableData = [];
    }
  }
});

/***/ }),

/***/ "fRB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__);














/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ElTable: __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a,
    ElTableColumn: __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a,
    ElButton: __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a,
    ElPagination: __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_pagination___default.a
  },
  data: function data() {
    return {
      items: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  created: function created() {
    this.fetchPdfFiles();
  },

  methods: {
    handlePageChange: function handlePageChange(page) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.pagination.currentPage = page;
                _context.next = 3;
                return _this.fetchPdfFiles();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchPdfFiles: function fetchPdfFiles() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  data = {
                    token: _this2.$session.get('token'),
                    limit: _this2.pagination.pageSize,
                    skip: (_this2.pagination.currentPage - 1) * _this2.pagination.pageSize
                  };

                  _this2.apiRequest('/pdf-files-monthly-info', 'GET', data, function (response) {
                    if (response.status === true) {
                      _this2.items = response.data;
                      _this2.pagination.total = response.total;
                      _this2.pagination.currentPage = response.currentPage || 1;
                    }
                  });
                } catch (error) {
                  console.error('Error fetching PDF files (Catch):', error.response);
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleDownload: function handleDownload(row) {
      var API_BASE_URL = "https://gatewaydev.taptasty.com/";
      var pdfUrl = API_BASE_URL + 'pdf-monthly-info/' + encodeURIComponent(row.name);
      window.open(pdfUrl, '_blank');
    },
    handleRowClick: function handleRowClick(row) {
      this.handleDownload(row);
    }
  }
});

/***/ }),

/***/ "fRZ+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fRg2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PosUserForm_vue__ = __webpack_require__("y5df");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PosUserForm: __WEBPACK_IMPORTED_MODULE_0__PosUserForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "fVLV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_json_excel__ = __webpack_require__("fXhN");










var _components;








__WEBPACK_IMPORTED_MODULE_9_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_14_vue_json_excel__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isClients: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isClients: function isClients() {
      if (this.isClients) {
        var firstQuery = {
          sort: {
            prop: 'name',
            order: 'asc'
          },
          page: 1,
          pageSize: 20
        };
        this.getClients(firstQuery);
      }
    }
  },
  data: function data() {
    var _jsonFields;

    return {
      loading: false,
      donation_points_enabled: false,
      jsonFields: (_jsonFields = {}, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.name'), 'firstname'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.email'), 'email'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.created_at'), 'created_at'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.gender'), 'gender'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.age'), 'age'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.donation_points'), 'donation_points'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.totalAmount'), 'sales'), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_jsonFields, this.$t('reports.ordersNumber'), 'orders_count'), _jsonFields),
      export_name: 'Export Clienti - ',
      clients: {
        'valid': [__WEBPACK_IMPORTED_MODULE_10_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_10_moment___default()().endOf('month').format('YYYY-MM-DD')],
        minOrder: null,
        maxOrder: null,
        minAmount: null,
        search: null
      },
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        defaultSort: {
          prop: 'name',
          order: 'ascending'
        }
      },
      labels: null,
      labelingPrimaryOption: null,
      totalClients: null,
      sortBy: 'name',
      sortOrder: 'asc',
      clientsTableData: [],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_10_moment___default()().subtract(6, 'months');
        }
      },
      pickerNames: ['date_from', 'date_to']
    };
  },

  methods: {
    clientsExportData: function clientsExportData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp, data, $dd, sortOptions, ced, clientsData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resp = [];

                if (!_this.clients) {
                  _context.next = 12;
                  break;
                }

                data = {
                  token: _this.$session.get('token'),
                  company_id: _this.$session.get('selectedCompany'),
                  start_date: _this.clients.valid[0],
                  end_date: _this.clients.valid[1],
                  min_orders: _this.clients.minOrder,
                  max_orders: _this.clients.maxOrder,
                  min_ammount: _this.clients.minAmount,
                  filter: _this.clients.search
                };
                $dd = {};
                sortOptions = {
                  field: _this.sortBy,
                  order: _this.sortOrder
                };

                data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, sortOptions);

                ced = [];
                clientsData = [];
                _context.next = 10;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this.apiRequest('/reports/clients?page=' + 1 + '&pageSize=' + 50000, 'GET', data, function (response) {
                    clientsData = response.data.clients.data;
                    if (clientsData) {
                      var _iteratorNormalCompletion = true;
                      var _didIteratorError = false;
                      var _iteratorError = undefined;

                      try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(clientsData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                          var customer = _step.value;

                          $dd = {
                            'firstname': customer.firstname,
                            'email': customer.email,
                            'created_at': customer.created_at,
                            'gender': customer.gender,
                            'birthdate': customer.birthdate,
                            'age': customer.age,
                            'orders_count': customer.orders_count,
                            'sales': _this.formatMoneyAmount(customer.sales, '')
                          };
                          if (customer.donation_points) {
                            $dd['donation_points'] = customer.donation_points;
                          }
                          ced.push($dd);
                        }
                      } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }
                        } finally {
                          if (_didIteratorError) {
                            throw _iteratorError;
                          }
                        }
                      }
                    }
                    resolve(ced);
                  });
                });

              case 10:
                resp = _context.sent;
                return _context.abrupt('return', resp);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    startDownload: function startDownload() {
      this.loading = true;
    },
    finishDownload: function finishDownload() {
      this.loading = false;
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getClients(query);
      if (query.type === 'size') this.getClients(query);
      if (query.type === 'sort') {
        if (query.sort.order) {
          this.sortBy = query.sort.prop;
          this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc';
        } else {
          this.sortBy = 'name';
          this.sortOrder = 'asc';
        }
        this.getClients(query);
      }
    },
    getClients: function getClients(query) {
      var _this2 = this;

      this.export_name = this.export_name + this.clients.valid[0] + ' - ' + this.clients.valid[1];
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        filter: this.clients.search,
        start_date: this.clients.valid[0],
        end_date: this.clients.valid[1],
        min_orders: this.clients.minOrder,
        max_orders: this.clients.maxOrder
      };

      var sortColumn = '';
      var sortType = '';

      if (query) {
        sortColumn = query.sort.prop;
        sortType = query.sort.order === 'descending' ? 'desc' : 'asc';
      } else {
        sortColumn = this.sortBy;
        sortType = this.sortOrder;
      }

      var sortOptions = {
        field: sortColumn,
        order: sortType
      };
      data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, data, sortOptions);

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      this.apiRequest('/reports/client-points?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status === true) {
          _this2.donation_points_enabled = response.data.use_donation_points;
          _this2.clientsTableData = response.data.clients.data;
          _this2.totalClients = response.data.clients.total;
          _this2.labels = response.data.labels;
          _this2.labelingPrimaryOption = response.data.fidelities_labels_primary_option;

          if (_this2.clientsTableData) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this2.clientsTableData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var customer = _step2.value;

                if (customer.lastname) {
                  customer['firstname'] = customer.firstname + ' ' + customer.lastname;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        }
        _this2.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    goToRecordCustomer: function goToRecordCustomer(row, event, column) {
      window.open('/#/reports/customer/' + row.id);
    }
  }
});

/***/ }),

/***/ "fX4L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = integrationLocationOptionValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = resolveLocationTrueId;
function integrationLocationOptionValue(loc) {
  if (!loc) return null;
  if (loc.true_id != null && loc.true_id !== '') return loc.true_id;
  if (loc._integrationLocationId != null && loc._integrationLocationId !== '') {
    return loc._integrationLocationId;
  }
  return null;
}

function resolveLocationTrueId(locations, value) {
  if (value == null || value === '') return null;
  var list = Array.isArray(locations) ? locations : [];
  var loc = list.find(function (entry) {
    var candidates = [entry.true_id, entry._integrationLocationId, entry.id, entry.location_id, entry._id];
    return candidates.some(function (v) {
      return v != null && v !== '' && String(v) === String(value);
    });
  });
  if (loc && loc.true_id != null && loc.true_id !== '') {
    return loc.true_id;
  }
  return value;
}

/***/ }),

/***/ "fXhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__ = __webpack_require__("uZUK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_56fa764e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__ = __webpack_require__("JHMb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_56fa764e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fY5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationEdit_vue__ = __webpack_require__("PrLq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ec02705_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationEdit_vue__ = __webpack_require__("0jgF");
function injectStyle (ssrContext) {
  __webpack_require__("cDBg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ec02705_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fYtj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._t("badge",[_c('div',{staticClass:"timeline-badge",class:_vm.badgeType},[_c('i',{class:_vm.badgeIcon})])]),_vm._v(" "),_c('div',{staticClass:"timeline-panel"},[_c('div',{staticClass:"timeline-heading"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"timeline-body"},[_vm._t("body")],2),_vm._v(" "),_c('h6',[_vm._t("footer")],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fakT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceDashboard_vue__ = __webpack_require__("sUtm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_802a0982_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceDashboard_vue__ = __webpack_require__("+Fja");
function injectStyle (ssrContext) {
  __webpack_require__("swva")
  __webpack_require__("rF8M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-802a0982"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_802a0982_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fff3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoltIntegrationForm_vue__ = __webpack_require__("Hz/p");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoltIntegrationForm_vue__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoltIntegrationForm_vue__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoltIntegrationForm_vue__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoltIntegrationForm_vue__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoltIntegrationForm_vue__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoltIntegrationForm_vue__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de53c0b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoltIntegrationForm_vue__ = __webpack_require__("52vF");
function injectStyle (ssrContext) {
  __webpack_require__("teaP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5de53c0b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoltIntegrationForm_vue__["g" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de53c0b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoltIntegrationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["g"] = (Component.exports);


/***/ }),

/***/ "fgC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.topCategoriesReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100"},[_c('searchable-multi-select',{attrs:{"label":'pages.categories',"url":"/search-categories"},model:{value:(_vm.selectedCategories),callback:function ($$v) {_vm.selectedCategories=$$v},expression:"selectedCategories"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('searchable-multi-select',{attrs:{"label":'pages.topCategory',"url":"/search-top-categories"},model:{value:(_vm.selectedTopCategories),callback:function ($$v) {_vm.selectedTopCategories=$$v},expression:"selectedTopCategories"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('chart-bars-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"topProductSales",attrs:{"chart-data":_vm.topProductSales.data,"chart-options":_vm.topProductSales.options}},[(_vm.noData)?[_c('div',{staticClass:"no-data-message",staticStyle:{"text-align":"center","margin":"20px"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('reports.noDataAvailable')))])])]:_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend",staticStyle:{"display":"flex","flex-wrap":"wrap"}},_vm._l((_vm.legendItems),function(item){return _c('div',{key:item.product,staticClass:"legend-item"},[_c('div',{staticClass:"legend-color-box",style:({ backgroundColor: item.sales.color })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.sales.label))]),_vm._v(" "),_c('div',{staticClass:"legend-color-box",style:({ backgroundColor: item.discount.color })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.discount.label))])])}))])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"search-def":{show: false},"total":_vm.ordersTableData.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"category_name","label":_vm.$t('reports.category')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"total_sales","label":_vm.$t('reports.revenue')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_sales)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"total_discount","label":_vm.$t('reports.discount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_discount)))+"\n            ")]}}])})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fhxF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DiscountCampaignForm_vue__ = __webpack_require__("af5b");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DiscountCampaignForm: __WEBPACK_IMPORTED_MODULE_0__DiscountCampaignForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),

/***/ "fimh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderStatus_vue__ = __webpack_require__("AS2v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24086348_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderStatus_vue__ = __webpack_require__("DEpc");
function injectStyle (ssrContext) {
  __webpack_require__("7VBo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24086348_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fklu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchableMultiSelect',
  props: {
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: ''
    },
    extraParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    filterLocally: {
      type: Boolean,
      default: false
    },
    initialLimit: {
      type: Number,
      default: 0
    },
    collapseTags: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      items: [],
      loading: false,
      selectedItems: this.value,
      allCategoriesMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a()
    };
  },

  watch: {
    selectedItems: function selectedItems(newVal) {
      this.$emit('input', newVal);
    },
    value: function value(newVal) {
      this.selectedItems = newVal;
    },

    extraParams: {
      deep: true,
      handler: function handler() {
        if (this.initialLimit > 0) {
          this.fetchItems(this.getCurrentQuery());
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.initialLimit > 0) {
      this.fetchItems('');
    }
  },

  computed: {
    mergedItems: function mergedItems() {
      var map = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(this.items.map(function (item) {
        return [item.id, item];
      }));
      this.selectedItems.forEach(function (item) {
        if (!map.has(item.id)) {
          map.set(item.id, item);
        }
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(map.values());
    }
  },
  methods: {
    getCurrentQuery: function getCurrentQuery() {
      if (this.$refs.select && this.$refs.select.query) {
        return this.$refs.select.query;
      }
      return '';
    },
    onVisibleChange: function onVisibleChange(visible) {
      if (visible && this.initialLimit > 0 && !this.items.length) {
        this.fetchItems('');
      }
    },
    searchItems: function searchItems(query) {
      if (!query && this.initialLimit <= 0) {
        return;
      }
      this.fetchItems(query);
    },
    fetchItems: function fetchItems(query) {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query || ''
      }, this.extraParams);
      if (this.initialLimit > 0 && !query) {
        data.limit = this.initialLimit;
      }

      this.loading = true;
      this.apiRequest(this.url, 'GET', data, function (response) {
        if (response.status) {
          response.data.forEach(function (item) {
            _this.allCategoriesMap.set(item.id, item);
          });
          _this.items = response.data.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { label: item.label || item.name });
          }).filter(function (item) {
            return !_this.filterLocally || String(item.label).toLocaleLowerCase().includes(String(query).toLocaleLowerCase());
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()('', response.errors.id || _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    clearSearch: function clearSearch() {
      this.$refs.select.focus();
      if (this.$refs.select) {
        this.$refs.select.query = '';
        this.$refs.select.handleQueryChange('');
      }
    }
  }
});

/***/ }),

/***/ "fl6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fluv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PosForm_vue__ = __webpack_require__("iVJX");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PosForm', __WEBPACK_IMPORTED_MODULE_7__PosForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "fm0D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__ = __webpack_require__("iGuY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be1dda7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__ = __webpack_require__("CRWE");
function injectStyle (ssrContext) {
  __webpack_require__("OyUV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be1dda7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fm9h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fqZq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fsa3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ftEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__);





















__WEBPACK_IMPORTED_MODULE_11_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_14_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  props: {
    isDonationCampaigns: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: true,
      onInputGetCampaignsTimeout: null,
      search: '',
      statusFilter: null,
      locationFilter: [],
      dateRangeFilter: [],
      locations: [],
      tableData: [],
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      paginationDef: {
        page: 1,
        perPage: 20,
        totalPages: null,
        totalRecords: null,
        show: true
      }
    };
  },
  created: function created() {
    this.initializePage();
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getCampaigns();
    },
    initializePage: function initializePage() {
      var _this = this;

      this.getLocations().then(function () {
        _this.getCampaigns();
      });
    },
    getLocations: function getLocations() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var data = {
          token: _this2.$session.get('token'),
          company_id: _this2.$session.get('selectedCompany')
        };
        _this2.apiRequest('/get-locations', 'GET', data, function (response) {
          if (response.status) {
            _this2.locations = response.data || [];
          } else {
            _this2.locations = (_this2.$session.get('selectedCompanyData') || {}).locations_details || [];
          }
          if (!_this2.isOwner()) {
            var allowedLocations = JSON.parse(_this2.$session.get('userDataLocations') || '[]');
            if (allowedLocations && allowedLocations.length > 0) {
              _this2.locations = _this2.locations.filter(function (loc) {
                return allowedLocations.some(function (allowedId) {
                  return _this2.locationMatchesId(loc, allowedId);
                });
              });
            }
          }
          resolve();
        });
      });
    },
    locationIdMatches: function locationIdMatches(a, b) {
      if (a === b) return true;
      if (a == null || b == null || a === '' || b === '') return false;
      return String(a) === String(b);
    },
    locationMatchesId: function locationMatchesId(loc, locationId) {
      return this.locationIdMatches(loc.id, locationId) || this.locationIdMatches(loc.true_id, locationId);
    },
    getLocationOptionValue: function getLocationOptionValue(loc) {
      return loc.true_id != null ? loc.true_id : loc.id;
    },
    normalizeLocationFilterValue: function normalizeLocationFilterValue(value) {
      if (value && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
        return this.getLocationOptionValue(value);
      }
      return value;
    },
    onRowClick: function onRowClick(row, column, event) {
      if (column.property === 'active' || column.property === 'actions' || event.target.closest('.el-switch') || event.target.closest('.el-dropdown')) {
        return;
      }
      this.goToRecord(row, null, event);
    },
    goToAdd: function goToAdd() {
      this.$router.push({ path: '/marketing/donation-campaigns/add' });
    },
    goToRecord: function goToRecord(row, column, event) {
      this.$router.push({ path: '/marketing/donation-campaigns/edit/' + row.id });
    },
    applyFilters: function applyFilters() {
      this.paginationDef.page = 1;
      this.getCampaigns();
    },
    onInput: function onInput() {
      var _this3 = this;

      clearTimeout(this.onInputGetCampaignsTimeout);
      this.onInputGetCampaignsTimeout = setTimeout(function () {
        _this3.getCampaigns();
      }, 500);
    },
    handlePageChange: function handlePageChange(page) {
      this.paginationDef.page = page;
      this.getCampaigns();
    },
    normalizeActiveFilterValue: function normalizeActiveFilterValue(value) {
      var rawValue = value && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && 'id' in value ? value.id : value;
      if (rawValue === true || rawValue === 1 || rawValue === '1') return true;
      if (rawValue === false || rawValue === 0 || rawValue === '0') return false;
      return null;
    },
    hasActiveFilter: function hasActiveFilter() {
      return this.normalizeActiveFilterValue(this.statusFilter) !== null;
    },
    buildParams: function buildParams() {
      var _this4 = this;

      var params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.paginationDef.page,
        perPage: this.paginationDef.perPage
      };
      if (this.search) {
        params.name = this.search;
      }
      if (this.hasActiveFilter()) {
        params.active = this.normalizeActiveFilterValue(this.statusFilter);
      }
      if (this.locationFilter && this.locationFilter.length) {
        params.location_ids = this.locationFilter.map(function (value) {
          return _this4.normalizeLocationFilterValue(value);
        });
      }
      if (this.dateRangeFilter && this.dateRangeFilter.length === 2) {
        params.date_start = this.dateRangeFilter[0];
        params.date_end = this.dateRangeFilter[1];
      }
      return params;
    },
    getCampaigns: function getCampaigns() {
      var _this5 = this;

      this.loading = true;
      var data = this.buildParams();
      this.apiRequest('/reports/donation-campaigns', 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data && response.data.pagination) {
            _this5.tableData = response.data.data;
            _this5.paginationDef.page = response.data.pagination.page;
            _this5.paginationDef.perPage = response.data.pagination.perPage;
            _this5.paginationDef.totalPages = response.data.pagination.totalPages;
            _this5.paginationDef.totalRecords = response.data.pagination.totalRecords;
          } else {
            _this5.tableData = response.data || [];
            _this5.paginationDef.totalRecords = _this5.tableData.length;
          }
        }
        _this5.$nextTick(function () {
          _this5.loading = false;
        });
      });
    },
    isActiveCampaignExistsResponse: function isActiveCampaignExistsResponse(response) {
      return !!(response && response.errors && response.errors.code === 'ACTIVE_CAMPAIGN_EXISTS' && response.data);
    },
    getRowLocationNames: function getRowLocationNames(row) {
      var _this6 = this;

      if (row.locations_formatted && row.locations_formatted.length) {
        return row.locations_formatted.map(function (loc) {
          return loc.name;
        });
      }
      var locationIds = row.location_ids;
      if (!locationIds || !locationIds.length || !this.locations.length) {
        return [];
      }
      return this.locations.filter(function (loc) {
        return locationIds.some(function (locationId) {
          return _this6.locationMatchesId(loc, locationId);
        });
      }).map(function (loc) {
        return loc.name;
      });
    },
    getVisibleLocationName: function getVisibleLocationName(row) {
      var names = this.getRowLocationNames(row);
      if (names.length) {
        return names[0];
      }
      if (!row.location_ids || !row.location_ids.length) {
        return this.$t('donationCampaigns.allLocations');
      }
      return '-';
    },
    getHiddenLocationCount: function getHiddenLocationCount(row) {
      var names = this.getRowLocationNames(row);
      if (names.length <= 1) {
        return 0;
      }
      return names.length - 1;
    },
    getLocationNames: function getLocationNames(row) {
      var names = this.getRowLocationNames(row);
      if (names.length) {
        return names.join(', ');
      }
      if (!row.location_ids || !row.location_ids.length) {
        return this.$t('donationCampaigns.allLocations');
      }
      return '-';
    },
    rowClass: function rowClass(_ref) {
      var row = _ref.row;

      return row.active ? 'highlight-row' : '';
    },
    handleActiveCampaignExists: function handleActiveCampaignExists(row, response) {
      var _this7 = this;

      var activeCampaign = response.data.active_campaign || {};
      var message = this.$t('donationCampaigns.activeCampaignExistsActivateMessage', { name: activeCampaign.name || '' });
      var warning = this.$t('donationCampaigns.activeCampaignExistsWarning');

      __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({
        title: '',
        html: message + '<br><br><strong>' + warning + '</strong>',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then(function (result) {
        if (result) {
          _this7.activateCampaign(row);
        }
      }).catch(function () {});
    },
    activateCampaign: function activateCampaign(row) {
      var _this8 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        active: 1,
        force_active: true
      };
      this.apiRequest('/reports/donation-campaigns/' + row.id, 'PUT', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()(_this8.$t('general.success') + '!', '', 'success').catch(function () {});
          _this8.getCampaigns();
        } else if (_this8.isActiveCampaignExistsResponse(response)) {
          row.active = false;
          _this8.handleActiveCampaignExists(row, response);
        } else {
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', _this8.$t('validations.wentWrong'), 'error').catch(function () {});
          row.active = false;
        }
      });
    },
    handleActive: function handleActive(index, row, e) {
      var _this9 = this;

      var actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + row.name + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this9.$session.get('token'),
            company_id: _this9.$session.get('selectedCompany'),
            active: row.active ? 1 : 0
          };
          _this9.apiRequest('/reports/donation-campaigns/' + row.id, 'PUT', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()(_this9.$t('general.success') + '!', '', 'success').catch(function () {});
              if (row.active) {
                _this9.getCampaigns();
              }
            } else if (_this9.isActiveCampaignExistsResponse(response)) {
              row.active = false;
              _this9.handleActiveCampaignExists(row, response);
            } else {
              __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', _this9.$t('validations.wentWrong'), 'error').catch(function () {});
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        row.active = !row.active;
      });
    },
    handleDelete: function handleDelete(index, row) {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({
        text: this.$t('donationCampaigns.areYouSureDelete') + ' ' + row.name + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this10.$session.get('token'),
            company_id: _this10.$session.get('selectedCompany')
          };
          _this10.apiRequest('/reports/donation-campaigns/' + row.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', _this10.$t('donationCampaigns.campaignDeleted'), 'success').catch(function () {});
              _this10.tableData.splice(index, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', _this10.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "g/71":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rewardRoles; });
/* unused harmony export rewardAspects */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cashbackRoles; });
/* harmony export (immutable) */ __webpack_exports__["h"] = rewardAspectsForRole;
/* harmony export (immutable) */ __webpack_exports__["j"] = emptyRule;
/* harmony export (immutable) */ __webpack_exports__["d"] = hydrateRewardSettings;
/* harmony export (immutable) */ __webpack_exports__["f"] = serializeRewardSettings;
/* harmony export (immutable) */ __webpack_exports__["g"] = validateRewardSettings;
/* harmony export (immutable) */ __webpack_exports__["i"] = describeRule;
/* harmony export (immutable) */ __webpack_exports__["e"] = summarizeRewards;
/* harmony export (immutable) */ __webpack_exports__["b"] = recordedRoleRewards;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);



var rewardRoles = ['ambassador_2', 'referee'];
var rewardAspects = ['order_reward', 'cashback'];
var cashbackRoles = ['ambassador_2'];

function rewardAspectsForRole(role) {
  return role === 'referee' ? ['order_reward'] : rewardAspects;
}

var enabled = function enabled(value) {
  return value === true || value === 1 || value === '1';
};
var present = function present(value) {
  return value !== null && value !== undefined && value !== '';
};

function emptyRule() {
  return { type: 'NONE', value: null, coupon_id: null, reward_type: null };
}

function hydrateRewardSettings() {
  var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var settings = {};
  rewardRoles.forEach(function (role) {
    settings[role] = {};
    rewardAspectsForRole(role).forEach(function (aspect) {
      settings[role][aspect] = emptyRule();
    });
  });

  var legacyOrder = function legacyOrder(prefix) {
    var fixed = row[prefix + '_fixed'];
    var percent = row[prefix + '_percent'];
    if (present(fixed) && present(percent)) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(emptyRule(), { type: 'LEGACY', fixed: fixed, percent: percent });
    }
    if (present(fixed)) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(emptyRule(), { type: 'FLAT', value: Number(fixed) });
    if (present(percent)) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(emptyRule(), { type: 'PERCENT', value: Number(percent) });
    return emptyRule();
  };
  settings.referee.order_reward = legacyOrder('referee_reward');
  settings.ambassador_2.order_reward = legacyOrder('ambassador_order_reward');
  if (enabled(row.ambassador_cashback_active)) {
    var flat = enabled(row.ambassador_cashback_is_flat) || String(row.ambassador_cashback_amount_type).toUpperCase() === 'FLAT';
    settings.ambassador_2.cashback = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(emptyRule(), {
      type: flat ? 'FLAT' : 'PERCENT',
      value: flat ? row.ambassador_cashback_fixed : row.ambassador_cashback_percent
    });
  }
  rewardRoles.forEach(function (role) {
    rewardAspectsForRole(role).forEach(function (aspect) {
      var saved = row.reward_settings && row.reward_settings[role] && row.reward_settings[role][aspect];
      if (saved) settings[role][aspect] = aspect === 'cashback' && saved.type === 'COUPON' ? emptyRule() : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(emptyRule(), saved);
    });
  });
  return settings;
}

function serializeRewardSettings(settings, cashbackEnabled) {
  var result = {};
  rewardRoles.forEach(function (role) {
    result[role] = {};
    rewardAspectsForRole(role).forEach(function (aspect) {
      var rule = aspect === 'cashback' && (!cashbackEnabled || settings[role][aspect].type === 'COUPON') ? emptyRule() : settings[role][aspect];

      if (rule.type === 'LEGACY') return;
      var saved = { type: rule.type };
      if (rule.type === 'COUPON') saved.coupon_id = Number(rule.coupon_id);
      if (rule.type === 'FLAT' || rule.type === 'PERCENT') {
        saved.value = Number(rule.value);
        if (present(rule.reward_type)) saved.reward_type = Number(rule.reward_type);
      }
      result[role][aspect] = saved;
    });
  });
  return result;
}

function validateRewardSettings(settings, orderEnabled, cashbackEnabled) {
  var errors = {};
  rewardRoles.forEach(function (role) {
    rewardAspectsForRole(role).forEach(function (aspect) {
      if (!(aspect === 'order_reward' ? orderEnabled : cashbackEnabled)) return;
      var rule = settings[role][aspect];
      var key = role + '.' + aspect;
      if (rule.type === 'COUPON' && (!present(rule.coupon_id) || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(Number(rule.coupon_id)) || Number(rule.coupon_id) <= 0)) {
        errors[key] = 'couponRequired';
      }
      if (rule.type === 'FLAT' || rule.type === 'PERCENT') {
        var amount = Number(rule.value);
        if (!present(rule.value) || !isFinite(amount) || amount < 0 || rule.type === 'PERCENT' && amount > 100) {
          errors[key] = rule.type === 'PERCENT' ? 'percentInvalid' : 'amountInvalid';
        }
      }
    });
  });
  return errors;
}

function describeRule(rule, t) {
  var defaultType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var coupons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (rule.type === 'NONE') return t('referralProgram.v2.none');
  if (rule.type === 'COUPON') {
    var coupon = coupons.find(function (item) {
      return Number(item.id) === Number(rule.coupon_id);
    });
    return t('referralProgram.v2.coupon') + (coupon ? ': ' + coupon.name : ' #' + (rule.coupon_id || '—'));
  }
  var destination = Number(rule.reward_type || defaultType) === 2 ? t('referralProgram.rewardTypeWallet') : t('referralProgram.rewardTypeLoyaltyPoints');
  if (rule.type === 'LEGACY') return rule.fixed + ' + ' + rule.percent + '% · ' + destination;
  return (present(rule.value) ? rule.value : '—') + (rule.type === 'PERCENT' ? '%' : '') + ' · ' + destination;
}

function summarizeRewards(row, aspect, t) {
  var coupons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (aspect === 'order_reward' && !enabled(row.order_rewards_active)) return t('referralProgram.rewardSummaryDisabled');
  var settings = hydrateRewardSettings(row);
  var summaries = rewardRoles.filter(function (role) {
    return settings[role][aspect] && settings[role][aspect].type !== 'NONE';
  }).map(function (role) {
    return t('referralProgram.v2.' + role) + ': ' + describeRule(settings[role][aspect], t, row.reward_type, coupons);
  });
  return summaries.join(' / ') || t('referralProgram.rewardSummaryDisabled');
}

function recordedRoleRewards(row, role, t) {
  if (!Array.isArray(row.reward_details)) return null;
  return row.reward_details.filter(function (detail) {
    return detail.role === role;
  }).map(function (detail) {
    var destination = Number(detail.reward_type) === 2 ? t('referralProgram.rewardTypeWallet') : t('referralProgram.rewardTypeLoyaltyPoints');
    return t('referralProgram.v2.' + detail.aspect) + ': ' + (detail.type === 'COUPON' ? t('referralProgram.v2.coupon') + ' #' + detail.coupon_id : Number(detail.amount).toFixed(2) + ' · ' + destination);
  });
}

/***/ }),

/***/ "g01Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchSettings_vue__ = __webpack_require__("ragw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b770891a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchSettings_vue__ = __webpack_require__("ntqj");
function injectStyle (ssrContext) {
  __webpack_require__("SFlb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b770891a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g0pE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      tableData: [{
        codProdus: 'CF001',
        numeProdus: 'Cafea Boabe 1kg',
        totalVanzari: 120,
        vanzariLocatie: 80,
        vanzariPachet: 30,
        alteMetode: 10,
        pierderiProduse: 2,
        pauzaMasa: 1,
        produseAnulate: 3,
        pretProdus: 25,
        bani: 3000
      }, {
        codProdus: 'LP002',
        numeProdus: 'Lapte 1L',
        totalVanzari: 200,
        vanzariLocatie: 150,
        vanzariPachet: 40,
        alteMetode: 10,
        pierderiProduse: 5,
        pauzaMasa: 2,
        produseAnulate: 1,
        pretProdus: 5,
        bani: 1000
      }, {
        codProdus: 'CH003',
        numeProdus: 'Cheesecake Slice',
        totalVanzari: 75,
        vanzariLocatie: 50,
        vanzariPachet: 20,
        alteMetode: 5,
        pierderiProduse: 1,
        pauzaMasa: 0,
        produseAnulate: 2,
        pretProdus: 15,
        bani: 1125
      }],
      selectedGestiune: null,
      selectedLocation: null
    };
  },

  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id;
      });
      return result;
    }
  },
  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.resetTable();

      this.selectedGestiune = null;
      this.selectedProduct = null;
      this.tableData = [];
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    this.firstLoad();
  },

  methods: {
    firstLoad: function firstLoad() {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0];
      }
    }
  }
});

/***/ }),

/***/ "g0uY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'file-input',
  inheritAttrs: false,
  props: {
    location: Object,
    type: String
  },
  data: function data() {
    return {
      apiUrl: ''
    };
  },

  computed: {
    fileList: function fileList() {
      if (!this.location || !this.location.qr_code) return [];
      return [{ name: 'menu', url: this.location.qr_code }];
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
  },

  methods: {
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pdfSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
      }
      return isOkSize;
    },
    handleChange: function handleChange(file, fileList) {
      var _this = this;

      var isOkSize = file.size / 1024 / 1024 < 25;
      var isPdf = file.raw.type === 'application/pdf';
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pdfSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
      } else if (!isPdf) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.wrongFormat'),
          position: 'top-end',
          showConfirmButton: true,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs.upload.clearFiles();
      } else {
        self.getBase64(file.raw).then(function (base64enc) {
          self.$bus.$emit('upload', { id: _this.location.id, file: base64enc });
        });
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      this.$bus.$emit('remove-upload', { id: this.location.id });
    },
    handleExceed: function handleExceed(files, fileList) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        toast: true,
        text: self.$t('validations.removePhoto'),
        type: 'warning',
        position: 'top-end',
        showConfirmButton: true
      });
    },
    copy: function copy() {
      this.$refs.clone.focus();
      document.execCommand('copy');
    }
  }
});

/***/ }),

/***/ "g2Ay":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g74j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons",staticStyle:{"display":"flex","align-items":"center","gap":"20px","margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n              "+_vm._s(loc.name)+"\n            ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"2"}},[_c('label',[_vm._v("Tip vânzare")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTipVanzare),expression:"selectedTipVanzare"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedTipVanzare=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.paymentMethods),function(method,index){return _c('option',{key:index,domProps:{"value":method.value}},[_vm._v("\n            "+_vm._s(method.label)+"\n          ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"1 1 3%"}},[_c('label',[_vm._v("Date și oră")]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"name":['date_from', 'date_to'],"disabled":_vm.loading},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"})]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.nr'),"prop":"nr","width":"100","formatter":function (row) { return row.nr ? row.nr : 'N/A'; }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":_vm.$t('gestiune.date'),"formatter":_vm.formatDate}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.nrProduse'),"formatter":function (row) { return (row.products && row.products.length) ? row.products.length : 0; }}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.fiscalizat'),"formatter":function (row) { return row.is_fiscal ? 'Da' : 'Nu'; }}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Nr. Bon Fiscal","formatter":function (row) { return (row.rawDataParsed && row.rawDataParsed.ReceiptNumber) ? row.rawDataParsed.ReceiptNumber : '—'; }}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Nr. Z Bon Fiscal","formatter":function (row) { return (row.rawDataParsed && row.rawDataParsed.ReceiptInfo) ? row.rawDataParsed.ReceiptInfo : '—'; }}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tip_vanzare","label":_vm.$t('gestiune.tipVanzare'),"formatter":_vm.formatTipVanzare}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Sursă"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.source || '—'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Order ID"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"order-id-label",on:{"click":function($event){$event.stopPropagation();_vm.goToOrder(scope.row)}}},[_vm._v("\n                "+_vm._s(scope.row.externalOrderId || 'N/A')+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                ▾ ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.goToBonFiscal(scope.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.see'))+"\n                ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g7AI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('user-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gAb5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__("LL4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item__ = __webpack_require__("BrEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__("U/ZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown_menu__ = __webpack_require__("+nRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__("Dzb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown__ = __webpack_require__("o6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__referralRewardSettings__ = __webpack_require__("g/71");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__referralCampaignDelete__ = __webpack_require__("N471");













var _components;








__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dropdown___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown_menu___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown_menu___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item___default.a), _components),
  props: {
    isReferralCampaigns: { type: Boolean, default: false }
  },
  watch: {
    isReferralCampaigns: function isReferralCampaigns(v) {
      if (v) this.initPage();
    },
    tableData: function tableData() {
      var _this = this;

      this.$nextTick(function () {
        return _this.layoutReferralTable();
      });
    }
  },
  data: function data() {
    return {
      loading: false,
      notificationLoading: false,
      notificationEmailsRaw: '',
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      filters: [{ value: '', prop: ['name', 'id'] }],
      tableData: []
    };
  },
  created: function created() {
    this.$bus.$on('refresh', this.handleRefresh);
  },
  mounted: function mounted() {
    var _this2 = this;

    this.initPage();
    this.loadNotificationEmails();
    this._onResizeReferralTable = function () {
      return _this2.layoutReferralTable();
    };
    window.addEventListener('resize', this._onResizeReferralTable);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
    if (this._onResizeReferralTable) {
      window.removeEventListener('resize', this._onResizeReferralTable);
    }
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.initPage();
    },
    goToRecord: function goToRecord(row, column, event) {
      if (column && column.property === 'actions') {
        return;
      }
      this.globalGoToRecord(row, event, column, '/marketing/referral-campaigns/edit/');
    },
    layoutReferralTable: function layoutReferralTable() {
      var dt = this.$refs.referralDataTables;
      var elTable = dt && dt.$refs && dt.$refs.elTable;
      if (elTable && typeof elTable.doLayout === 'function') {
        elTable.doLayout();
      }
    },
    formatAvailabilityRange: function formatAvailabilityRange(row) {
      var dash = this.$t('general.emDash');
      var from = row.datetime_validfrom || row.starts_at || row.date_start || null;
      var to = row.datetime_validto || row.ends_at || row.date_end || null;
      if (!from && !to) return dash;
      var a = from ? this.formatDate(from) : dash;
      var b = to ? this.formatDate(to) : dash;
      return a + ' - ' + b;
    },
    formatActiveColumn: function formatActiveColumn(row) {
      var v = row.active;
      if (v === undefined || v === null) return this.$t('general.yes');
      return v ? this.$t('general.yes') : this.$t('general.no');
    },
    formatBool: function formatBool(val) {
      return val ? this.$t('general.yes') : this.$t('general.no');
    },
    rewardEntries: function rewardEntries(row, aspect) {
      var _this3 = this;

      if (aspect === 'order_reward' && !row.order_rewards_active) return [];
      var settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__referralRewardSettings__["d" /* hydrateRewardSettings */])(row);
      return __WEBPACK_IMPORTED_MODULE_15__referralRewardSettings__["a" /* rewardRoles */].filter(function (role) {
        return settings[role][aspect] && settings[role][aspect].type !== 'NONE';
      }).map(function (role) {
        return {
          role: role,
          label: _this3.$t('referralProgram.v2.' + role),
          description: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__referralRewardSettings__["i" /* describeRule */])(settings[role][aspect], _this3.$t.bind(_this3), row.reward_type)
        };
      });
    },
    normalizeList: function normalizeList(response) {
      if (!response || !response.data) return [];
      var d = response.data;
      if (Array.isArray(d)) return d;
      if (Array.isArray(d.data)) return d.data;
      return [];
    },
    normalizeNotificationEmailsPayload: function normalizeNotificationEmailsPayload(payload) {
      if (payload == null) return [];
      var p = payload;
      if ((typeof p === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(p)) === 'object' && !Array.isArray(p) && p.data != null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(p.data) === 'object') {
        p = p.data;
      }
      if (Array.isArray(p)) {
        return p.map(function (e) {
          if (typeof e === 'string') return e.trim();
          if (e && (typeof e === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(e)) === 'object') return (e.email || e.address || '').trim();
          return String(e).trim();
        }).filter(Boolean);
      }
      if (typeof p === 'string') {
        try {
          var parsed = JSON.parse(p);
          if (Array.isArray(parsed)) return this.normalizeNotificationEmailsPayload(parsed);
        } catch (_) {}
        return p.split(/[,\n]/).map(function (s) {
          return s.trim();
        }).filter(Boolean);
      }
      if ((typeof p === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(p)) === 'object') {
        var keys = ['emails', 'referral_notification_emails', 'referralNotificationEmails', 'notification_emails'];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var k = _step.value;

            if (p[k] != null) return this.normalizeNotificationEmailsPayload(p[k]);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return [];
    },
    initPage: function initPage() {
      var _this4 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/referral-campaign', 'GET', data, function (response) {
        if (response.status) {
          _this4.tableData = _this4.normalizeList(response);
          _this4.$nextTick(function () {
            return _this4.layoutReferralTable();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error');
        }
        _this4.loading = false;
      });
    },
    loadNotificationEmails: function loadNotificationEmails() {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/referral-program/notification-emails', 'GET', data, function (response) {
        if (response.status && response.data != null) {
          var emails = _this5.normalizeNotificationEmailsPayload(response.data);
          _this5.notificationEmailsRaw = emails.join(', ');
        }
      });
    },
    saveNotificationEmails: function saveNotificationEmails() {
      var _this6 = this;

      var parts = this.notificationEmailsRaw.split(/[,\n]/).map(function (s) {
        return s.trim();
      }).filter(Boolean);
      this.notificationLoading = true;
      var body = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        emails: parts
      };
      this.apiRequest('/referral-program/notification-emails', 'PUT', body, function (response) {
        _this6.notificationLoading = false;
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()(_this6.$t('general.success') + '!', '', 'success').catch(function () {});
          _this6.loadNotificationEmails();
        } else {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this6.$t('validations.wentWrong'), 'error');
        }
      });
    },
    handleDelete: function handleDelete(_index, row) {
      var _this7 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__referralCampaignDelete__["a" /* attemptReferralCampaignDelete */])(this, row.id, {
        onDeleted: function onDeleted() {
          _this7.initPage();
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', _this7.$t('general.success'), 'success').catch(function () {});
        },
        onDeactivated: function onDeactivated() {
          _this7.initPage();
        }
      });
    }
  }
});

/***/ }),

/***/ "gB//":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gBHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[(!_vm.editor)?_c('div',[_c('div',{staticClass:"msub-menus__head"},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.menusTitle')))]),_vm._v(" "),_c('small',{staticClass:"text-muted msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.menusHint', { price: _vm.pricePerDay + ' ' + _vm.currency })))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-purple",on:{"click":function($event){_vm.openEditor(null)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.newMenu')))])]),_vm._v(" "),(!_vm.menus.length && !_vm.loading)?_c('p',{staticClass:"text-muted msub-menus__empty"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.noMenus')))]):_vm._e(),_vm._v(" "),_vm._l((_vm.menus),function(menu){return _c('div',{key:'menu' + menu.id,staticClass:"msub-menu",class:{ 'is-default': menu.is_default, 'is-wrong': !menu.matches_price }},[_c('div',{staticClass:"msub-menu__top"},[_c('div',[_c('a',{staticClass:"msub-menu__name",on:{"click":function($event){_vm.openEditor(menu)}}},[_vm._v(_vm._s(menu.name))]),_vm._v(" "),(menu.is_default)?_c('span',{staticClass:"msub-tag msub-tag--default"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.defaultMenu')))]):_vm._e(),_vm._v(" "),(!menu.matches_price)?_c('span',{staticClass:"msub-tag msub-tag--wrong"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.totalMismatch', { total: menu.total + ' ' + _vm.currency })))]):_vm._e(),_vm._v(" "),(menu.upcoming_days)?_c('span',{staticClass:"msub-tag"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.upcomingDays', { count: menu.upcoming_days })))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"msub-menu__actions"},[(!menu.is_default)?_c('a',{staticClass:"msub-icon",attrs:{"title":_vm.$t('menuSubscriptions.makeDefault')},on:{"click":function($event){_vm.setDefault(menu)}}},[_c('i',{staticClass:"fa fa-star-o"})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"msub-icon",attrs:{"title":_vm.$t('menuSubscriptions.duplicate')},on:{"click":function($event){_vm.duplicate(menu)}}},[_c('i',{staticClass:"fa fa-files-o"})]),_vm._v(" "),_c('a',{staticClass:"msub-icon",attrs:{"title":_vm.$t('general.edit')},on:{"click":function($event){_vm.openEditor(menu)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),_c('a',{staticClass:"msub-icon msub-icon--danger",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.remove(menu)}}},[_c('i',{staticClass:"fa fa-trash-o"})])])]),_vm._v(" "),_c('div',{staticClass:"msub-menu__items"},_vm._l((menu.items),function(item,index){return _c('span',{key:'mi' + menu.id + '-' + index,staticClass:"msub-menu__item"},[(item.course)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.courses.' + item.course))+":")]):_vm._e(),_vm._v(" "),_c('span',{class:{ 'text-danger': item.product_missing }},[_vm._v(_vm._s(item.quantity > 1 ? item.quantity + ' x ' : '')+_vm._s(item.name))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("("+_vm._s(item.price)+")")])])}))])})],2):_c('div',[_c('div',{staticClass:"msub-menus__head"},[_c('strong',[_vm._v(_vm._s(_vm.editor.id ? _vm.$t('menuSubscriptions.editMenu') : _vm.$t('menuSubscriptions.newMenu')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-default",on:{"click":_vm.closeEditor}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" "+_vm._s(_vm.$t('general.cancel')))])]),_vm._v(" "),(!_vm.editor.id && _vm.assignDates.length)?_c('div',{staticClass:"msub-assign-note"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.willAssignDates', { dates: _vm.assignDates.join(', ') }))+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.menuName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editor.name),expression:"editor.name"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"255","placeholder":_vm.$t('menuSubscriptions.menuNamePlaceholder')},domProps:{"value":(_vm.editor.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editor, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"msub-search"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.addProducts')))]),_vm._v(" "),_c('div',{staticClass:"msub-search__bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.q),expression:"search.q"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('menuSubscriptions.searchProducts')},domProps:{"value":(_vm.search.q)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "q", $event.target.value)},_vm.onSearchInput]}}),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":_vm.$t('menuSubscriptions.allCategories')},on:{"change":function($event){_vm.searchProducts(1)}},model:{value:(_vm.search.category_id),callback:function ($$v) {_vm.$set(_vm.search, "category_id", $$v)},expression:"search.category_id"}},_vm._l((_vm.categories),function(category){return _c('el-option',{key:category.id,attrs:{"label":category.name,"value":category.id}})}))],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.search.loading),expression:"search.loading"}],staticClass:"msub-search__results"},[_vm._l((_vm.search.items),function(product){return _c('div',{key:'p' + product.id,staticClass:"msub-search__row",on:{"click":function($event){_vm.addProduct(product)}}},[_c('span',{staticClass:"msub-search__name"},[_vm._v(_vm._s(product.name)+" "),_c('small',{staticClass:"text-muted"},[_vm._v("#"+_vm._s(product.id))])]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.catalogPrice'))+": "+_vm._s(product.price)+" "+_vm._s(_vm.currency)),(product.vat !== null)?[_vm._v(" · "+_vm._s(_vm.$t('menuSubscriptions.vat'))+" "+_vm._s(product.vat)+"%")]:_vm._e()],2),_vm._v(" "),_vm._m(0,true)])}),_vm._v(" "),(!_vm.search.loading && !_vm.search.items.length)?_c('p',{staticClass:"text-muted msub-search__empty"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.noProductsFound')))]):_vm._e(),_vm._v(" "),(_vm.search.lastPage > 1)?_c('div',{staticClass:"msub-search__pages"},[_c('a',{class:{ 'is-disabled': _vm.search.page <= 1 },on:{"click":function($event){_vm.search.page > 1 && _vm.searchProducts(_vm.search.page - 1)}}},[_c('i',{staticClass:"fa fa-chevron-left"})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.search.page)+" / "+_vm._s(_vm.search.lastPage))]),_vm._v(" "),_c('a',{class:{ 'is-disabled': _vm.search.page >= _vm.search.lastPage },on:{"click":function($event){_vm.search.page < _vm.search.lastPage && _vm.searchProducts(_vm.search.page + 1)}}},[_c('i',{staticClass:"fa fa-chevron-right"})])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"msub-items"},[_c('div',{staticClass:"msub-item msub-item--head"},[_c('span'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.course')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.product')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.quantity')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.unitPrice')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.lineTotal')))]),_vm._v(" "),_c('span')]),_vm._v(" "),(!_vm.editor.items.length)?_c('p',{staticClass:"text-muted msub-items__empty"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.noItems')))]):_vm._e(),_vm._v(" "),_vm._l((_vm.editor.items),function(item,index){return _c('div',{key:'it' + item.key,staticClass:"msub-item"},[_c('span',{staticClass:"msub-item__move"},[_c('a',{class:{ 'is-disabled': index === 0 },on:{"click":function($event){_vm.move(index, -1)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]),_vm._v(" "),_c('a',{class:{ 'is-disabled': index === _vm.editor.items.length - 1 },on:{"click":function($event){_vm.move(index, 1)}}},[_c('i',{staticClass:"fa fa-chevron-down"})])]),_vm._v(" "),_c('span',[_c('el-select',{attrs:{"clearable":"","size":"small","placeholder":'-'},model:{value:(item.course),callback:function ($$v) {_vm.$set(item, "course", $$v)},expression:"item.course"}},_vm._l((_vm.courses),function(course){return _c('el-option',{key:course,attrs:{"label":_vm.$t('menuSubscriptions.courses.' + course),"value":course}})}))],1),_vm._v(" "),_c('span',[_c('span',{class:{ 'text-danger': item.product_missing }},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('small',{staticClass:"text-muted msub-block"},[_vm._v("\n              "+_vm._s(_vm.$t('menuSubscriptions.catalogPriceHint'))+": "+_vm._s(item.catalog_price !== null && item.catalog_price !== undefined ? item.catalog_price + ' ' + _vm.currency : '-')),(item.vat !== null && item.vat !== undefined)?[_vm._v(" · "+_vm._s(_vm.$t('menuSubscriptions.vat'))+" "+_vm._s(item.vat)+"%")]:_vm._e()],2),_vm._v(" "),(item.product_missing)?_c('small',{staticClass:"text-danger msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.productMissing')))]):_vm._e()]),_vm._v(" "),_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.quantity),expression:"item.quantity"}],staticClass:"form-control input-sm",attrs:{"type":"number","min":"1","max":"99","step":"1"},domProps:{"value":(item.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", $event.target.value)}}})]),_vm._v(" "),_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.price),expression:"item.price"}],staticClass:"form-control input-sm",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(item.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "price", $event.target.value)}}})]),_vm._v(" "),_c('span',{staticClass:"msub-item__total"},[_vm._v(_vm._s(_vm.lineTotal(item)))]),_vm._v(" "),_c('span',{staticClass:"msub-item__actions"},[(_vm.diffCents !== 0)?_c('a',{staticClass:"msub-icon",attrs:{"title":_vm.$t('menuSubscriptions.putDifferenceHere')},on:{"click":function($event){_vm.putDifference(index)}}},[_c('i',{staticClass:"fa fa-magic"})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"msub-icon msub-icon--danger",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.editor.items.splice(index, 1)}}},[_c('i',{staticClass:"fa fa-trash-o"})])])])})],2),_vm._v(" "),_c('div',{staticClass:"msub-total",class:{ 'is-ok': _vm.diffCents === 0 && _vm.editor.items.length, 'is-wrong': _vm.diffCents !== 0 }},[_c('div',[_vm._v("\n          "+_vm._s(_vm.$t('menuSubscriptions.menuTotal'))+": "),_c('strong',[_vm._v(_vm._s(_vm.totalText)+" "+_vm._s(_vm.currency))]),_vm._v("\n          / "+_vm._s(_vm.$t('menuSubscriptions.pricePerDay'))+": "),_c('strong',[_vm._v(_vm._s(_vm.pricePerDay)+" "+_vm._s(_vm.currency))]),_vm._v(" "),(_vm.diffCents !== 0)?_c('span',[_vm._v(" · "+_vm._s(_vm.$t('menuSubscriptions.difference'))+": "),_c('strong',[_vm._v(_vm._s(_vm.diffText)+" "+_vm._s(_vm.currency))])]):(_vm.editor.items.length)?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()]),_vm._v(" "),(_vm.editor.items.length && _vm.diffCents !== 0)?_c('button',{staticClass:"btn btn-sm btn-default",on:{"click":_vm.rescale}},[_c('i',{staticClass:"fa fa-balance-scale"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.adjustProportionally', { price: _vm.pricePerDay }))+"\n        ")]):_vm._e()]),_vm._v(" "),_c('small',{staticClass:"text-muted msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.priceRuleHint')))]),_vm._v(" "),_c('div',{staticClass:"text-center mar-to-10"},[_c('button',{staticClass:"btn btn-purple-light btn-fill btn-wd",attrs:{"disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.saveMenu($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"msub-icon"},[_c('i',{staticClass:"fa fa-plus-circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gCpC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gGlf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Suppliers_ManagementSuppliersAdd_vue__ = __webpack_require__("TvcY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Management_ManagementSeriesAdd_vue__ = __webpack_require__("kgt7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);


















function getLocalDateTimeString() {
  var now = new Date();
  var year = now.getFullYear();
  var month = String(now.getMonth() + 1).padStart(2, '0');
  var day = String(now.getDate()).padStart(2, '0');
  var hours = String(now.getHours()).padStart(2, '0');
  var minutes = String(now.getMinutes()).padStart(2, '0');
  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__["a" /* default */],
    ManagementSuppliersAdd: __WEBPACK_IMPORTED_MODULE_12__Suppliers_ManagementSuppliersAdd_vue__["a" /* default */],
    ManagementSeriesAdd: __WEBPACK_IMPORTED_MODULE_13__Management_ManagementSeriesAdd_vue__["a" /* default */]
  },
  data: function data() {
    return {
      totalValue: 0,
      selectedQuantity: '',
      selectedUnit: '',
      previousSelectedUnit: '',
      supplierSelected: null,
      selectedLocation: null,
      name: '',
      description: '',
      type: '',
      umProduct: null,
      currencyProduct: 'RON',
      code: '',
      tableData: [],
      gestiuniList: [],
      selectedGestiuneId: null,
      locations: [],
      nume: '',
      codeFiscalFurnizor: '',
      selectedLocationId: '',
      dataScadenta: '',
      nrDocument: '',
      currentNumber: '',
      isNir: false,
      isInvoiceSupplier: false,
      seriesNumber: '',
      vats: [],
      seriesOptions: [],
      dataDocument: getLocalDateTimeString(),
      vatNumberFurnizor: '',
      dataInStoc: getLocalDateTimeString(),
      tipDocument: 'factura',
      valoare: '',
      loading: false,
      currency: 'RON',
      precizie: '2 zecimale',
      selectedCategory: '',
      companyID: '',
      numeFurnizor: '',
      searchResults: [],
      editIndex: null,
      addItem: false,
      isEdit: !!this.route.params.id,
      invoiceSupplierId: null,
      supplierResults: [],
      fetchTimeout: null,
      modelValidate: {
        nume: { required: true },
        selectedGestiuneId: { required: true },
        codeFiscalFurnizor: { required: true },
        dataInStoc: { required: true },
        dataDocument: { required: true },
        tipDocument: { required: true },
        nrDocument: { required: true }
      },
      defaultGestiuneId: '',
      item: {
        nr: '',
        productName: '',
        productInvoiceSupplier: '',
        umInvoiceSupplier: '',
        quantityInvoiceSupplier: null,
        categoria: '',
        gestiune: '',
        um: '',
        cantitate: null,
        tva: '',
        pretFaraTva: null,
        price: null,
        adaosLinie: null,
        adaosProc: null,
        adaosTotal: null,
        tvaProdusVanzare: null,
        currency: 'RON',
        valoare: 'fara_tva',
        posId: ''
      },
      adaos: 0,
      adaosProc: 0,
      categories: [{ value: 'Marfa', label: 'Marfa' }, { value: 'Materii prime', label: 'Materii prime' }, { value: 'Materiale consumabile', label: 'Materiale consumabile' }, { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' }, { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' }, { value: 'Produs rezidual', label: 'Produs rezidual' }, { value: 'Ambalaje', label: 'Ambalaje' }, { value: 'Obiecte de inventar', label: 'Obiecte de inventar' }],
      productCategories: [{ value: 'Marfa', label: 'Marfa' }, { value: 'Materii prime', label: 'Materii prime' }, { value: 'Materiale consumabile', label: 'Materiale consumabile' }, { value: 'Produs rezidual', label: 'Produs rezidual' }, { value: 'Ambalaje', label: 'Ambalaje' }, { value: 'Obiecte de inventar', label: 'Obiecte de inventar' }],
      mesurementsUnits: [],
      unit_calc: [],
      extraFields: {
        delegat: '',
        carteIdentitate: '',
        auto: '',
        notaInterna: ''
      }
    };
  },

  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    var _this = this;

    this.companyID = this.$session.get('selectedCompany');

    var i = this.route && this.route.params && this.route.params.id;

    function arrayToObject(arr) {
      var obj = {};
      arr.forEach(function (item) {
        obj[item.key] = item.value || '';
      });
      return obj;
    }

    if (i) {
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        title: 'Se încarcă...',
        text: 'Așteaptă încărcarea datelor',
        allowOutsideClick: false,
        didOpen: function didOpen() {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default.a.showLoading();
        }
      });
      this.fetchNir(i).then(function (result) {
        var nir = result && result.nir;
        if (!nir) {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default.a.close();
          return;
        }

        _this.nume = nir.nume_furnizor || '';
        _this.codeFiscalFurnizor = nir.vatNumberFurnizor || '';

        var supplier = _this.supplierResults.find(function (s) {
          return s.id === nir.supplierId;
        }) || {
          id: nir.supplierId || null,
          nume: nir.nume_furnizor,
          vatNumber: nir.vatNumberFurnizor
        };

        _this.supplierSelected = supplier;

        _this.dataDocument = nir.data_document || '';
        _this.dataInStoc = nir.data_in_stoc || '';
        _this.dataScadenta = nir.data_scadentei || '';
        _this.tipDocument = nir.tip_document || '';
        _this.nrDocument = nir.numar_document || '';
        _this.valoare = nir.valoare || '';
        _this.currency = nir.moneda || 'RON';
        _this.precizie = nir.precizie || '2 zecimale';
        _this.vatNumber = nir.vatNumber || null;

        _this.invoiceSupplierId = nir.invoice_supplier || null;

        _this.seriesOptions = [{
          series: nir.series,
          currentNumber: nir.nirNumber
        }];
        _this.seriesNumber = nir.series;
        _this.currentNumber = nir.nirNumber;

        _this.extraFields = arrayToObject(nir.extraFields || []);

        _this.tableData = (nir.items || []).map(function (item, index) {
          var cantitate = item.cantitate != null && item.cantitate !== '' ? item.cantitate : item.invoice_supplier_quantity != null && item.invoice_supplier_quantity !== '' ? item.invoice_supplier_quantity : null;
          var pretFaraTva = item.pret_fara_tva || 0;
          var tva = item.tva_percent;
          var valoareFaraTva = cantitate * pretFaraTva;

          var valoareTva = item.valoare_tva != null ? item.valoare_tva : +(valoareFaraTva * (tva / 100)).toFixed(2);

          return {
            nr: item.cod,
            productName: item.denumire_produs_sau_serviciu || '',
            categoria: item.categoria,
            gestiune: item.gestiune || (_this.gestiuniList.length ? _this.gestiuniList[0].name : ''),
            um: item.u_m,
            cantitate: cantitate,
            tva: tva,
            pretFaraTva: pretFaraTva,
            currency: item.currency || 'RON',
            valoareCalculata: item.valoare_calculata || null,
            valoareTva: valoareTva,
            price: item.pretVanzare,
            posId: item.posId || '',
            adaosLinie: item.adaosLinie || null,
            adaosTotal: item.adaosTotal || null,
            adaosProc: item.adaosProc || null,
            salePriceFaraTva: item.salePriceFaraTva || null,
            tvaProdusVanzare: item.tvaProdusVanzare || null,
            categorie: item.categorie
          };
        });

        if (nir.externalLocationId) {
          _this.selectedLocationId = nir.externalLocationId;
        }

        if (nir.gestiune) {
          _this.selectedGestiuneId = nir.gestiune || null;
        }
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default.a.close();
      }).catch(function (error) {
        console.error(error);
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default.a.close();
      });
    }
    this.fetchLocation();
    this.fetchGestiuni();
    this.loadMesurementsUnits();
  },

  computed: {
    today: function today() {
      var now = new Date();
      now.setSeconds(0, 0);
      return now.toISOString().slice(0, 16);
    },
    seriesOptionsWithAdd: function seriesOptionsWithAdd() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()(this.seriesOptions), [{ id: 'add', nume: '➕ Adaugă serie' }]);
    },
    groupedLocations: function groupedLocations() {
      var _this2 = this;

      var groups = {};

      if (!this.locations || !this.locations.length) return [];

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';

        if (_this2.isInvoiceSupplier && _this2.vatNumber && _this2.normalizeVat(vat) !== _this2.normalizeVat(_this2.vatNumber)) return;

        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this3 = this;

      if (!this.selectedLocation) return [];

      return this.gestiuniList.filter(function (g) {
        return g.externalLocationId === _this3.selectedLocation.true_id;
      });
    },
    totalFaraTva: function totalFaraTva() {
      return this.tableData.reduce(function (sum, row) {
        if (row.nr !== 'Corectie') {
          return sum + (row.valoareCalculata || 0);
        }
        return sum;
      }, 0);
    },
    totalTva: function totalTva() {
      return this.tableData.reduce(function (sum, row) {
        if (row.nr !== 'Corectie') {
          return sum + (row.valoareTva || 0);
        }
        return sum;
      }, 0);
    },
    totalCorectie: function totalCorectie() {
      return this.tableData.reduce(function (sum, row) {
        if (row.nr === 'Corectie') {
          if (row.productName === 'Corectie Negativa') {
            return sum - Math.abs(row.valoareCalculata || 0);
          }
          return sum + (row.valoareCalculata || 0);
        }
        return sum;
      }, 0);
    },
    totalFinal: function totalFinal() {
      var totalCorectie = this.totalCorectie;
      return this.totalFaraTva + this.totalTva + totalCorectie;
    },
    totalPretVanzare: function totalPretVanzare() {
      return this.tableData.reduce(function (sum, row) {
        if (row.nr !== 'Corectie' && row.price != null && row.cantitate != null) {
          return sum + row.price * row.cantitate;
        }
        return sum;
      }, 0);
    },
    valoareNir: function valoareNir() {
      return this.tableData.reduce(function (sum, item) {
        if (item.nr !== 'Corectie' && item.price != null && item.cantitate != null) {
          return sum + item.cantitate * item.price;
        }
        return sum;
      }, 0);
    },
    hasMarfaProducts: function hasMarfaProducts() {
      return this.tableData.some(function (row) {
        return row.categoria === 'Marfa';
      });
    }
  },
  watch: {
    locations: {
      handler: function handler(newLocations) {
        var _this4 = this;

        if (!newLocations || !newLocations.length) return;

        var _ref3 = this.route && this.route.query,
            series = _ref3.series,
            number = _ref3.number,
            isNir = _ref3.isNir;

        this.isNir = isNir === 'true' || isNir === true;
        if (this.isNir && series && number) {
          this.fetchOrder(series, number);
        }

        var _ref4 = this.route && this.route.query,
            id = _ref4.id,
            vatNumber = _ref4.vatNumber,
            isInvoiceSupplier = _ref4.isInvoiceSupplier;

        this.isInvoiceSupplier = isInvoiceSupplier === 'true' || isInvoiceSupplier === true;
        this.vatNumber = vatNumber || null;

        if (this.isInvoiceSupplier && id) {
          this.fetchInvoiceSupplier(id, vatNumber);
        }

        if (this.isEdit && this.selectedLocationId) {
          var loc = this.groupedLocations.flatMap(function (group) {
            return group.locations;
          }).find(function (l) {
            return l.true_id === _this4.selectedLocationId;
          });

          if (loc) {
            this.selectedLocation = loc;

            if (!this.selectedGestiuneId && loc.gestiune_id_default) {
              var defaultGestiune = this.filteredGestiuni.find(function (g) {
                return g._id === loc.gestiune_id_default;
              });
              if (defaultGestiune) {
                this.defaultGestiuneId = defaultGestiune._id;
                this.item.gestiune = defaultGestiune._id;
              }
            }

            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code, loc.true_id);
            }
            this.loadVats(loc.true_id);
          }
        }
      },

      immediate: true
    },
    selectedLocationId: function selectedLocationId(id) {
      var _this5 = this;

      console.log('Selected location ID changed to:', id);
      console.log('Grouped Locations:', this.groupedLocations);

      var _loop = function _loop(group) {
        var loc = group.locations.find(function (l) {
          return l.true_id === id;
        });
        if (!loc) return 'continue';

        if (!_this5.isNir && !_this5.isEdit && !_this5.isInvoiceSupplier && _this5.tableData && _this5.tableData.length > 0) {
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
            title: 'Atenție!',
            text: 'Ai produse adăugate. Pentru a putea schimba locația, te rog șterge mai întâi produsele existente.',
            type: 'warning',
            button: 'OK',
            dangerMode: true
          });

          _this5.$nextTick(function () {
            _this5.selectedLocationId = _this5.selectedLocation.true_id || null;
          });
          return {
            v: void 0
          };
        }

        _this5.selectedLocation = loc;

        if (!_this5.isEdit && loc.inv_fiscal_code) {
          _this5.getSeries(loc.inv_fiscal_code, loc.true_id);
        }

        _this5.loadVats(loc.true_id);

        if (!_this5.selectedGestiuneId && loc.gestiune_id_default) {
          var defaultGestiune = _this5.filteredGestiuni.find(function (g) {
            return g._id === loc.gestiune_id_default;
          });
          if (defaultGestiune) {
            _this5.defaultGestiuneId = defaultGestiune._id;
            _this5.item.gestiune = defaultGestiune._id;
          }
        }

        return 'break';
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        _loop2: for (var _iterator = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var _ret = _loop(group);

          switch (_ret) {
            case 'continue':
              continue;

            case 'break':
              break _loop2;

            default:
              if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    totalFinal: function totalFinal(newVal) {
      this.valoare = newVal.toFixed(2);
    },
    'selectedCategory': function selectedCategory(newCategory, oldCategory) {
      if (!newCategory || newCategory !== oldCategory) {
        this.item = {
          nr: '',
          gestiune: '',
          productName: '',
          categoria: '',
          um: '',
          cantitate: null,
          tva: '',
          pretFaraTva: null,
          price: null,
          currency: 'RON',
          valoare: 'fara_tva',
          posId: ''
        };

        this.searchResults = [];
      }
    },

    item: {
      handler: function handler() {
        this.calculateAdaos();
      },

      deep: true
    },
    selectedQuantity: function selectedQuantity() {
      this.calculateAdaos();
    }
  },
  methods: {
    calculateUnitPrice: function calculateUnitPrice() {
      if (this.totalValue && this.totalValue > 0 && this.selectedQuantity > 0) {
        this.item.pretFaraTva = this.totalValue / this.selectedQuantity;
      }
    },
    normalizeVat: function normalizeVat(vat) {
      return String(vat || '').replace(/^ro/i, '').trim();
    },
    normalizeUm: function normalizeUm(um) {
      var raw = String(um || '').trim().toUpperCase();
      if (raw === 'GR' || raw === 'GRAME' || raw === 'GRAM') return 'G';
      if (raw === 'KG' || raw === 'KILOGRAM' || raw === 'KILOGRAME') return 'KG';
      if (raw === 'ML' || raw === 'MILILITRU' || raw === 'MILILITRI') return 'ML';
      if (raw === 'L' || raw === 'LITRU' || raw === 'LITRI') return 'L';
      return raw;
    },
    normalizeInvoiceUm: function normalizeInvoiceUm(um) {
      var raw = String(um || '').trim().toUpperCase();
      if (!raw) return '';

      if (raw === '58' || raw === 'KGM' || raw === 'E4' || raw === 'MND') return 'KG';
      if (raw === 'GRM' || raw === 'GR' || raw === 'G') return 'G';
      if (raw === 'LTR' || raw === 'L') return 'L';
      if (raw === 'MLT' || raw === 'ML') return 'ML';
      if (raw === 'H87' || raw === 'BUC' || raw === 'C62') return 'BUC';

      if (raw.includes('KILOGRAM')) return 'KG';
      if (raw === 'GRAM' || raw.startsWith('GRAM ') || raw.endsWith(' GRAM') || raw === 'GRAME') return 'G';
      if (raw.includes('MILILITRU') || raw.includes('MILILITRI')) return 'ML';
      if (raw.includes('LITRU') || raw.includes('LITRI')) return 'L';

      return this.normalizeUm(um);
    },
    getCompatibleUmRatio: function getCompatibleUmRatio(fromUm, toUm) {
      var from = this.normalizeInvoiceUm(fromUm);
      var to = this.normalizeInvoiceUm(toUm);
      if (!from || !to || from === to) return 1;

      var known = {
        'KG|G': 1000,
        'G|KG': 0.001,
        'L|ML': 1000,
        'ML|L': 0.001
      };
      return known[from + '|' + to] != null ? known[from + '|' + to] : null;
    },
    getDocumentUmShort: function getDocumentUmShort() {
      var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedUnit;

      if (unit && (typeof unit === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(unit)) === 'object' && unit.short) return unit.short;
      if (typeof unit === 'string' && unit) return unit;
      return this.item.um || '';
    },
    getRowDocumentUmShort: function getRowDocumentUmShort(row) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : row.umDocument;

      if (unit && (typeof unit === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(unit)) === 'object' && unit.short) return unit.short;
      if (typeof unit === 'string' && unit) return unit;
      return row.um || '';
    },
    resolveInvoiceUmCanonical: function resolveInvoiceUmCanonical(row) {
      var candidates = [row.umInvoiceSupplier];
      var invoiceText = this.getUnitText(row.umInvoiceSupplier);
      if (invoiceText) candidates.push(invoiceText);
      if (this.getUnitCodeFromText) {
        var mapped = this.getUnitCodeFromText(row.umInvoiceSupplier);
        if (mapped) candidates.push(mapped);
        if (invoiceText) {
          var mappedText = this.getUnitCodeFromText(invoiceText);
          if (mappedText) candidates.push(mappedText);
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(candidates), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var candidate = _step2.value;

          var normalized = this.normalizeInvoiceUm(candidate);
          if (normalized === 'G' || normalized === 'KG' || normalized === 'ML' || normalized === 'L' || normalized === 'BUC') {
            return normalized;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return this.normalizeInvoiceUm(invoiceText || row.umInvoiceSupplier);
    },
    getRowUnitCalcObject: function getRowUnitCalcObject(row, umShort) {
      var _this6 = this;

      if (!row || !umShort) return umShort;
      if (row.um && this.normalizeUm(row.um) === this.normalizeUm(umShort)) return row.um;

      var fromRowCalc = (row.unit_calc || []).find(function (u) {
        return _this6.normalizeUm(u.short) === _this6.normalizeUm(umShort);
      });
      if (fromRowCalc) return fromRowCalc;

      var fromMesurements = (this.mesurementsUnits || []).find(function (u) {
        return _this6.normalizeUm(u.short) === _this6.normalizeUm(umShort);
      });
      return fromMesurements || umShort;
    },
    getRowDocumentUmOptions: function getRowDocumentUmOptions(row) {
      var _this7 = this;

      var opts = [];
      var add = function add(short) {
        if (short && !opts.some(function (o) {
          return _this7.normalizeUm(o) === _this7.normalizeUm(short);
        })) {
          opts.push(short);
        }
      };

      if (row.um) add(row.um);(row.unit_calc || []).forEach(function (unit) {
        return add(unit.short);
      });(this.mesurementsUnits || []).forEach(function (unit) {
        return add(unit.short);
      });

      return opts;
    },
    matchInvoiceUmToRowOptions: function matchInvoiceUmToRowOptions(row) {
      var _this8 = this;

      var options = this.getRowDocumentUmOptions(row);
      if (!options.length) return null;

      var invoiceCanonical = this.resolveInvoiceUmCanonical(row);
      var candidates = [row.umInvoiceSupplier, invoiceCanonical];
      var invoiceText = this.getUnitText(row.umInvoiceSupplier);
      if (invoiceText) candidates.push(invoiceText);
      if (this.getUnitCodeFromText) {
        var mapped = this.getUnitCodeFromText(row.umInvoiceSupplier);
        if (mapped) candidates.push(mapped);
      }

      var _loop3 = function _loop3(candidate) {
        var match = options.find(function (opt) {
          return _this8.normalizeUm(opt) === _this8.normalizeUm(candidate) || _this8.normalizeUm(opt) === _this8.normalizeInvoiceUm(candidate);
        });
        if (match) return {
            v: match
          };
      };

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(candidates), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var candidate = _step3.value;

          var _ret2 = _loop3(candidate);

          if ((typeof _ret2 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_ret2)) === "object") return _ret2.v;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return null;
    },
    resolveInvoiceRowDocumentUm: function resolveInvoiceRowDocumentUm(row) {
      var matched = this.matchInvoiceUmToRowOptions(row);
      if (matched) return matched;
      var options = this.getRowDocumentUmOptions(row);
      return row.um || options[0] || row.umInvoiceSupplier || '';
    },
    getRowBaseUnitsPerDocumentUnit: function getRowBaseUnitsPerDocumentUnit(row) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : row.umDocument;

      var productUm = this.normalizeUm(row.um);
      var docUm = this.normalizeInvoiceUm(this.getRowDocumentUmShort(row, unit));
      if (!productUm || !docUm || productUm === docUm) return 1;

      var ratio = this.getCompatibleUmRatio(docUm, productUm);
      if (ratio != null) return ratio;

      var unitObj = this.getRowUnitCalcObject(row, unit);
      if (unitObj && (typeof unitObj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(unitObj)) === 'object' && unitObj.value != null && Number(unitObj.value) > 0) {
        return 1 / Number(unitObj.value);
      }
      return 1;
    },
    getPretPerDocumentUnit: function getPretPerDocumentUnit(row) {
      var pretInvoice = Number(row.pretInvoiceSupplier != null ? row.pretInvoiceSupplier : row.pretFaraTva) || 0;
      if (!pretInvoice) return pretInvoice;

      var invoiceUm = this.resolveInvoiceUmCanonical(row);
      var docUm = this.normalizeInvoiceUm(this.getRowDocumentUmShort(row, row.umDocument));
      if (!invoiceUm || !docUm || invoiceUm === docUm) return pretInvoice;

      var invoiceUnitsPerDocUnit = this.getCompatibleUmRatio(docUm, invoiceUm);
      if (invoiceUnitsPerDocUnit == null) return pretInvoice;
      return pretInvoice * invoiceUnitsPerDocUnit;
    },
    getInvoicePriceFromDocumentUnit: function getInvoicePriceFromDocumentUnit(row, pretDocument) {
      var pretDoc = Number(pretDocument) || 0;
      if (!pretDoc) return pretDoc;

      var invoiceUm = this.resolveInvoiceUmCanonical(row);
      var docUm = this.normalizeInvoiceUm(this.getRowDocumentUmShort(row, row.umDocument));
      if (!invoiceUm || !docUm || invoiceUm === docUm) return pretDoc;

      var invoiceUnitsPerDocUnit = this.getCompatibleUmRatio(docUm, invoiceUm);
      if (invoiceUnitsPerDocUnit == null || !invoiceUnitsPerDocUnit) return pretDoc;
      return pretDoc / invoiceUnitsPerDocUnit;
    },
    applyInvoiceSupplierStockFromValue: function applyInvoiceSupplierStockFromValue(row, qtyDoc, valoareFaraTva, pretDocument) {
      var vatRate = Number(row.tva) || 0;
      row.valoareTva = parseFloat((valoareFaraTva * vatRate / 100).toFixed(2));

      if (row.um) {
        var mult = this.getRowBaseUnitsPerDocumentUnit(row);
        row.cantitate = parseFloat((qtyDoc * mult).toFixed(6));
        row.pretFaraTva = row.cantitate ? parseFloat((valoareFaraTva / row.cantitate).toFixed(6)) : pretDocument;
      } else {
        row.cantitate = qtyDoc;
        row.pretFaraTva = pretDocument;
      }
    },
    recalculateInvoiceSupplierRow: function recalculateInvoiceSupplierRow(row) {
      if (!row) return;

      var qtyDoc = Number(row.cantitateDocument);
      var valoareFaraTva = Number(row.valoareInvoiceSupplier) || Number(row.valoareCalculata) || 0;

      row.valoareCalculata = parseFloat(valoareFaraTva.toFixed(2));

      if (isNaN(qtyDoc) || qtyDoc <= 0) {
        row.cantitate = null;
        return;
      }

      var pretDocument = valoareFaraTva / qtyDoc;
      row.pretInvoiceSupplier = parseFloat(pretDocument.toFixed(3));

      this.applyInvoiceSupplierStockFromValue(row, qtyDoc, valoareFaraTva, pretDocument);
    },
    getBaseUnitsPerDocumentUnit: function getBaseUnitsPerDocumentUnit() {
      var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedUnit;

      var productUm = this.normalizeUm(this.item.um);
      var docUm = this.normalizeUm(this.getDocumentUmShort(unit));
      if (!productUm || !docUm || productUm === docUm) return 1;

      var known = {
        'G|KG': 1000,
        'KG|G': 0.001,
        'ML|L': 1000,
        'L|ML': 0.001
      };
      var key = productUm + '|' + docUm;
      if (known[key] != null) return known[key];

      if (unit && (typeof unit === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(unit)) === 'object' && unit.value != null && Number(unit.value) > 0) {
        return 1 / Number(unit.value);
      }
      return 1;
    },
    getDefaultUnitCalc: function getDefaultUnitCalc(productUm) {
      var um = this.normalizeUm(productUm);
      var defaults = {
        G: [{ short: 'KG', value: 0.001, name: 'Kilogram' }],
        KG: [{ short: 'G', value: 1000, name: 'Gram' }],
        ML: [{ short: 'L', value: 0.001, name: 'Litru' }],
        L: [{ short: 'ML', value: 1000, name: 'Mililitru' }]
      };
      return defaults[um] ? defaults[um].map(function (u) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, u);
      }) : [];
    },
    mergeUnitCalc: function mergeUnitCalc(configured, productUm) {
      var byShort = {};
      this.getDefaultUnitCalc(productUm).forEach(function (def) {
        byShort[String(def.short).toUpperCase()] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, def);
      });(Array.isArray(configured) ? configured : []).forEach(function (unit) {
        var short = String(unit.short || '').toUpperCase();
        if (!short || byShort[short]) return;
        byShort[short] = unit;
      });
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(byShort).map(function (k) {
        return byShort[k];
      });
    },
    convertPriceToProductUm: function convertPriceToProductUm(pricePerDocumentUnit) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selectedUnit;

      var mult = this.getBaseUnitsPerDocumentUnit(unit);
      return mult ? Number(pricePerDocumentUnit) / mult : Number(pricePerDocumentUnit);
    },
    checkGestiuneChange: function checkGestiuneChange(event) {
      var _this9 = this;

      if (!this.isEdit && !this.isInvoiceSupplier && this.tableData && this.tableData.length > 0) {
        event.preventDefault();

        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
          title: 'Atentie!',
          text: 'Ai produse adaugate cu pret de vanzare pe aceasta gestiune. Doresti stergerea produselor?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Da, șterge-l!',
          cancelButtonText: 'Anulează'
        }).then(function (result) {
          if (result) {
            _this9.tableData.splice(0, _this9.tableData.length);

            _this9.selectedGestiuneId = event.target.value;
          } else {}
        });
      }
    },
    calculateAdaos: function calculateAdaos() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var prod = item || this.item;
      var price = Number(prod.price) || 0;
      var pretRaw = Number(prod.pretFaraTva) || 0;

      var isModalItem = !item || item === this.item;
      var pretAchizitie = isModalItem ? this.convertPriceToProductUm(pretRaw) : pretRaw;
      var cantitate = Number(prod.cantitate || (isModalItem ? this.selectedQuantity : 1) || 1);
      var vatPercent = Number(prod.tva || 0);
      var isCuTva = prod.valoare === 'cu_tva';

      var salePriceFaraTva = 0;
      var adaosLinie = 0;
      var adaosTotal = 0;
      var adaosProc = 0;

      if (prod.categoria === 'Marfa' && price > 0 && pretAchizitie > 0) {
        salePriceFaraTva = isCuTva ? price / (1 + vatPercent / 100) : price;

        adaosLinie = salePriceFaraTva - pretAchizitie;
        adaosTotal = adaosLinie * cantitate;
        adaosProc = pretAchizitie > 0 ? adaosLinie / pretAchizitie * 100 : 0;
      }

      prod.adaosLinie = adaosLinie;
      prod.adaosTotal = adaosTotal;
      prod.adaosProc = adaosProc;
      this.salePriceFaraTva = salePriceFaraTva;

      return { adaosLinie: adaosLinie, adaosTotal: adaosTotal, adaosProc: adaosProc, salePriceFaraTva: salePriceFaraTva };
    },
    loadMesurementsUnits: function loadMesurementsUnits() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this10.getMesurementsUnits();

              case 2:
                _this10.mesurementsUnits = _context.sent;

                _this10.normalizeInvoiceSupplierRowsUm();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this10);
      }))();
    },
    normalizeInvoiceSupplierRowsUm: function normalizeInvoiceSupplierRowsUm() {
      var _this11 = this;

      if (!this.isInvoiceSupplier || !this.tableData.length) return;

      this.tableData.forEach(function (row) {
        var resolved = _this11.resolveInvoiceRowDocumentUm(row);
        if (resolved && resolved !== row.umDocument) {
          _this11.$set(row, 'umDocument', resolved);
        }
        if (row.um || row.pretInvoiceSupplier != null) {
          _this11.recalculateInvoiceSupplierRow(row);
        }
      });
    },
    loadVats: function loadVats(locationId) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('Loading VATs for location:', locationId);
                _context2.next = 3;
                return _this12.fetchVats(locationId);

              case 3:
                _this12.vats = _context2.sent;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this12);
      }))();
    },
    onInputQuantity: function onInputQuantity(event) {
      var qtyDoc = Number(this.selectedQuantity);
      if (!isNaN(qtyDoc)) {
        var mult = this.getBaseUnitsPerDocumentUnit();
        this.item.cantitate = parseFloat((qtyDoc * mult).toFixed(6));
      } else {
        this.item.cantitate = this.selectedQuantity;
      }

      this.calculateUnitPrice();
    },
    onInputNumber: function onInputNumber(event) {
      if (this.item.pretFaraTva < 0) {
        this.item.pretFaraTva = 0;
      }
    },
    getGestiuneNameById: function getGestiuneNameById(id) {
      var gest = this.filteredGestiuni.find(function (g) {
        return g._id === id;
      });
      return gest ? gest.name : id;
    },
    validate: function validate() {
      var _this13 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this13.saveNIR();
        }
      });
    },
    getEmptyItem: function getEmptyItem() {
      this.selectedQuantity = '';
      this.selectedUnit = '';
      this.previousSelectedUnit = '';
      this.totalValue = 0;
      this.unit_calc = [];
      return {
        nr: '',
        productName: '',
        categoria: '',
        gestiune: '',
        um: '',
        cantitate: null,
        tva: '',
        pretFaraTva: null,
        price: null,
        currency: 'RON',
        valoare: 'fara_tva',
        posId: '',
        selectedCategory: ''
      };
    },
    updateNumber: function updateNumber() {
      var _this14 = this;

      if (this.seriesNumber === 'add') {
        this.openSeriesModal();
        return;
      }

      var selectedSeries = this.seriesOptions.find(function (series) {
        return series.series === _this14.seriesNumber;
      });

      if (selectedSeries) {
        this.currentNumber = selectedSeries.currentNumber;
      } else {
        this.currentNumber = '';
      }
    },
    openSeriesModal: function openSeriesModal() {
      this.$modal.show('addSeriesModal');
    },
    fetchLocation: function fetchLocation() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dataToSend = {
                  company_id: _this15.companyID,
                  token: _this15.$session.get('token')
                };


                _this15.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this15.locations = response.data.locations;
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this15);
      }))();
    },
    getSeries: function getSeries(vatNumber) {
      var _this16 = this;

      var externalLocationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, data, seriesList, filtered;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this16.companyID,
                    vatNumber: vatNumber,
                    tip: 'nir'
                  })
                });

              case 3:
                response = _context4.sent;

                if (response.ok) {
                  _context4.next = 6;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 6:
                _context4.next = 8;
                return response.json();

              case 8:
                data = _context4.sent;


                if (Array.isArray(data.series) && data.series.length > 0) {
                  seriesList = data.series;

                  if (externalLocationId) {
                    filtered = seriesList.filter(function (serie) {
                      return serie.externalLocationId === externalLocationId;
                    });

                    if (filtered.length > 0) {
                      seriesList = filtered;
                    }
                  }

                  _this16.seriesOptions = seriesList.map(function (serie) {
                    return {
                      series: serie.series,
                      currentNumber: serie.currentNumber,
                      externalLocationId: serie.externalLocationId || null
                    };
                  });

                  _this16.seriesNumber = _this16.seriesOptions[0].series;
                  _this16.currentNumber = _this16.seriesOptions[0].currentNumber;
                } else {
                  console.warn('Nu există serii disponibile pentru acest cod fiscal.');
                  _this16.seriesOptions = [];
                  _this16.seriesNumber = '';
                  _this16.currentNumber = '';
                }
                _context4.next = 18;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](0);

                console.error('Error fetching series:', _context4.t0);
                _this16.seriesOptions = [];
                _this16.seriesNumber = '';
                _this16.currentNumber = '';

              case 18:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this16, [[0, 12]]);
      }))();
    },
    fetchOrder: function fetchOrder(series, number) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, data, foundLocation, _number;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/order?series=' + series + '&number=' + number + '&externalCompanyId=' + _this17.companyID);

              case 3:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 6;
                  break;
                }

                throw new Error('Eroare la fetch order: ' + response.status);

              case 6:
                _context5.next = 8;
                return response.json();

              case 8:
                data = _context5.sent;


                if (data) {
                  _this17.myOrder = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data);

                  if (data.supplierExternalLocationId) {
                    _this17.selectedLocationId = data.supplierExternalLocationId;
                  }

                  if (data.supplierExternalLocationId && _this17.locations && _this17.locations.length) {
                    foundLocation = _this17.locations.find(function (loc) {
                      return loc.true_id === data.supplierExternalLocationId;
                    });

                    if (foundLocation) {
                      _this17.nume = foundLocation.inv_company_name || '';
                      _this17.codeFiscalFurnizor = foundLocation.inv_fiscal_code || '';
                    }
                  }

                  if (data.externalDocIds && data.externalDocIds.aviz) {
                    _number = data.externalDocIds.aviz.number;

                    _this17.nrDocument = '' + _number;
                    _this17.tipDocument = 'aviz';
                  }

                  _this17.tableData = data.products.map(function (item, index) {
                    var quantity = item.quantity_faptic !== null && item.quantity_faptic !== undefined ? item.quantity_faptic : item.quantity_scriptic !== null && item.quantity_scriptic !== undefined ? item.quantity_scriptic : 0;
                    var priceFaraTVA = item.pret_fara_tva || 0;
                    var vatRate = item.tva_percent != null ? item.tva_percent : '';
                    var tvaValoareUnit = priceFaraTVA * vatRate / 100;
                    var valoareCalculata = parseFloat((priceFaraTVA * quantity).toFixed(2));
                    var valoareTva = parseFloat((tvaValoareUnit * quantity).toFixed(2));

                    return {
                      nr: index + 1,
                      productName: item.productName || '',
                      categoria: item.categoria,
                      gestiune: item.gestiune || _this17.myOrder.gestiune,
                      um: item.unitMeasure,
                      cantitate: quantity,
                      tva: vatRate,
                      pretFaraTva: priceFaraTVA,
                      currency: item.currency || 'RON',
                      valoareCalculata: valoareCalculata,
                      valoareTva: valoareTva,
                      posId: item.posId || ''
                    };
                  });

                  _this17.valoare = _this17.totalFinal;
                } else {
                  console.error('Comandă invalidă primită:', data);
                  __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                    title: 'Eroare',
                    text: 'Comanda nu a fost găsită.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](0);

                console.error('Eroare la fetch order:', _context5.t0);
                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o problemă la încărcarea comenzii.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this17, [[0, 12]]);
      }))();
    },
    fetchInvoiceSupplier: function fetchInvoiceSupplier(id) {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response, result, existingSupplier, newSupplier;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/purchase/' + id + '?externalCompanyId=' + _this18.companyID, { method: 'GET' });

              case 3:
                response = _context6.sent;

                if (response.ok) {
                  _context6.next = 6;
                  break;
                }

                throw new Error('HTTP ' + response.status);

              case 6:
                _context6.next = 8;
                return response.json();

              case 8:
                result = _context6.sent;


                _this18.nrDocument = result.invoiceNumber;
                _this18.invoiceSupplierId = result._id || id || null;

                if (result.supplier) {
                  _this18.nume = result.supplier.name || '';
                  _this18.codeFiscalFurnizor = result.supplier.vat || '';

                  existingSupplier = _this18.supplierResults.find(function (s) {
                    return s.vatNumber === result.supplier.vat;
                  });


                  if (existingSupplier) {
                    _this18.supplierSelected = existingSupplier;
                  } else {
                    newSupplier = {
                      id: result.supplier.id || result.supplier.vat,
                      nume: result.supplier.name,
                      vatNumber: result.supplier.vat
                    };


                    _this18.supplierResults.push(newSupplier);
                    _this18.supplierSelected = newSupplier;
                  }
                }

                _this18.tableData = result.items.map(function (item, index) {
                  var quantity = 0;
                  var unitMeasure = '';
                  var priceFaraTVA = 0;
                  var currency = 'RON';

                  if (item.quantity && item.quantity.value != null) {
                    quantity = item.quantity.value;
                  }
                  if (item.quantity && item.quantity.unit) {
                    unitMeasure = item.quantity.unit;
                  }
                  if (item.price && item.price.value != null) {
                    priceFaraTVA = item.price.value;
                  }
                  if (item.price && item.price.currency) {
                    currency = item.price.currency;
                  }

                  var vatRate = item.taxRate != null ? item.taxRate : 0;
                  var tvaValoareUnit = priceFaraTVA * vatRate / 100;
                  var valoareCalculata = parseFloat((priceFaraTVA * quantity).toFixed(2));
                  var valoareTva = parseFloat((tvaValoareUnit * quantity).toFixed(2));

                  return {
                    nr: index + 1,
                    productInvoiceSupplier: item.name || '',
                    categoria: item.categoria || '',
                    gestiune: item.gestiune || '',
                    umInvoiceSupplier: unitMeasure,
                    quantityInvoiceSupplier: quantity,
                    priceInvoiceSupplier: priceFaraTVA,
                    valoareInvoiceSupplier: valoareCalculata,
                    umDocument: unitMeasure,
                    cantitateDocument: quantity > 0 ? quantity : null,
                    unit_calc: [],
                    pretInvoiceSupplier: priceFaraTVA,
                    cantitate: null,
                    tva: vatRate,
                    pretFaraTva: priceFaraTVA,
                    currency: currency,
                    valoareCalculata: valoareCalculata,
                    valoareTva: valoareTva,
                    posId: item.posId || ''
                  };
                });

                _this18.normalizeInvoiceSupplierRowsUm();

                console.log('Invoice supplier data received:', result);
                _context6.next = 20;
                break;

              case 17:
                _context6.prev = 17;
                _context6.t0 = _context6['catch'](0);

                console.error('❌ Eroare la fetch bon fiscal by ID:', _context6.t0);

              case 20:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this18, [[0, 17]]);
      }))();
    },
    fetchNir: function fetchNir(id) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var nirData, response, result;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                nirData = {
                  externalCompanyId: _this19.companyID,
                  nirNumber: _this19.route.query.nirNumber,
                  data_document: _this19.route.query.data_document,
                  vatNumberFurnizor: _this19.route.query.vatNumberFurnizor,
                  series: _this19.route.query.series
                };
                _context7.next = 4;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/nir', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(nirData)
                });

              case 4:
                response = _context7.sent;

                if (response.ok) {
                  _context7.next = 7;
                  break;
                }

                throw new Error('Failed to fetch or create NIR');

              case 7:
                _context7.next = 9;
                return response.json();

              case 9:
                result = _context7.sent;
                return _context7.abrupt('return', result);

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7['catch'](0);

                console.error('Error fetching NIR:', _context7.t0);

              case 16:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this19, [[0, 13]]);
      }))();
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this20.companyID);

              case 3:
                response = _context8.sent;
                _context8.next = 6;
                return response.json();

              case 6:
                data = _context8.sent;


                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this20.gestiuniList = data.gestiuni;
                } else {
                  __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                    title: 'Error!',
                    text: 'Nu s-a primit un array valid de la server.',
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context8.next = 14;
                break;

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8['catch'](0);

                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  title: 'Error!',
                  text: 'Request failed: ' + _context8.t0.message,
                  icon: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching management data:', _context8.t0);

              case 14:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this20, [[0, 10]]);
      }))();
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(!_this21.selectedLocation || !searchTerm || searchTerm.length < 2)) {
                  _context10.next = 3;
                  break;
                }

                _this21.searchResults = [];
                return _context10.abrupt('return');

              case 3:
                clearTimeout(_this21.fetchTimeout);

                _this21.fetchTimeout = setTimeout(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
                  var categorieParam, allCategories, response, data;
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _this21.loading = true;

                          _context9.prev = 1;
                          categorieParam = '';

                          if (_this21.selectedCategory) {
                            categorieParam = '&categorie=' + encodeURIComponent(_this21.selectedCategory);
                          } else {
                            allCategories = _this21.productCategories.map(function (c) {
                              return c.value;
                            }).join(',');

                            categorieParam = '&categorie=' + encodeURIComponent(allCategories);
                          }

                          _context9.next = 6;
                          return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/products?externalCompanyId=' + _this21.companyID + '&vatNumber=' + _this21.selectedLocation.inv_fiscal_code + '&name=' + searchTerm + categorieParam);

                        case 6:
                          response = _context9.sent;
                          _context9.next = 9;
                          return response.json();

                        case 9:
                          data = _context9.sent;


                          if (Array.isArray(data.products)) {
                            _this21.searchResults = [].concat(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()(data.products), [{ id: 'add', name: '➕ Adaugă produs' }]);
                          } else {
                            _this21.searchResults = [{ id: 'add', name: '➕ Adaugă produs' }];
                          }
                          _context9.next = 17;
                          break;

                        case 13:
                          _context9.prev = 13;
                          _context9.t0 = _context9['catch'](1);

                          console.error('Error fetching products:', _context9.t0);
                          _this21.searchResults = [{ id: 'add', name: '➕ Adaugă produs' }];

                        case 17:
                          _context9.prev = 17;

                          _this21.loading = false;
                          return _context9.finish(17);

                        case 20:
                        case 'end':
                          return _context9.stop();
                      }
                    }
                  }, _callee9, _this21, [[1, 13, 17, 20]]);
                })), 300);
              case 5:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this21);
      }))();
    },
    fetchSuppliers: function fetchSuppliers(query) {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var vatNumber, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                vatNumber = _this22.selectedLocation && _this22.selectedLocation.inv_fiscal_code;


                _this22.loading = true;
                _context11.prev = 2;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/suppliers' + ('?name=' + encodeURIComponent(query)) + ('&externalCompanyId=' + _this22.companyID) + (vatNumber ? '&vatNumber=' + encodeURIComponent(vatNumber) : '');
                _context11.next = 6;
                return fetch(url);

              case 6:
                response = _context11.sent;
                _context11.next = 9;
                return response.json();

              case 9:
                data = _context11.sent;


                if (Array.isArray(data.suppliers)) {
                  _this22.supplierResults = [].concat(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()(data.suppliers.map(function (supplier) {
                    return {
                      id: supplier._id,
                      nume: supplier.name,
                      vatNumber: supplier.vatNumber,
                      fullData: supplier
                    };
                  })), [{ id: 'add', nume: '➕ Adaugă furnizor' }]);
                } else {
                  _this22.supplierResults = [{ id: 'add', nume: '➕ Adaugă furnizor' }];
                }
                _context11.next = 17;
                break;

              case 13:
                _context11.prev = 13;
                _context11.t0 = _context11['catch'](2);

                console.error('Error fetching suppliers:', _context11.t0);
                _this22.supplierResults = [{ id: 'add', nume: '➕ Adaugă furnizor' }];

              case 17:
                _context11.prev = 17;

                _this22.loading = false;
                return _context11.finish(17);

              case 20:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this22, [[2, 13, 17, 20]]);
      }))();
    },
    resetProduct: function resetProduct(row) {
      if (!row) return;

      row.productName = '';
      row.posId = '';
      row.categoria = '';
      row.searchResults = [];

      if (this.item && this.item.posId === row.posId) {
        this.item.productName = '';
        this.item.posId = '';
        this.item.categoria = '';
      }
    },
    onSupplierSelect: function onSupplierSelect(supplier) {
      if (supplier && supplier.id === 'add') {
        this.openAddSupplierModal();
        this.supplierSelected = null;
        this.nume = '';
        this.codeFiscalFurnizor = '';
      } else if (supplier) {
        this.supplierSelected = supplier;
        this.nume = supplier.nume || '';
        this.codeFiscalFurnizor = supplier.vatNumber || '';
      } else {
        this.supplierSelected = null;
        this.nume = '';
        this.codeFiscalFurnizor = '';
      }
    },
    openAddSupplierModal: function openAddSupplierModal() {
      this.supplier = {
        companyName: '',
        abbreviation: '',
        CUI: '',
        email: '',
        registrationNumber: '',
        address: '',
        bank: '',
        IBAN: '',
        dueDays: null,
        id: null,
        _rev: null
      };
      this.$modal.show('addSupplierModal');
    },
    convertUnit: function convertUnit(previousUnit) {
      var qtyDocOld = Number(this.selectedQuantity);
      var oldMult = this.getBaseUnitsPerDocumentUnit(previousUnit);
      var newMult = this.getBaseUnitsPerDocumentUnit(this.selectedUnit);

      var baseQty = Number(this.item.cantitate);
      if ((isNaN(baseQty) || baseQty === 0) && !isNaN(qtyDocOld) && qtyDocOld !== 0) {
        baseQty = qtyDocOld * oldMult;
      }

      if (!isNaN(baseQty) && baseQty !== 0) {
        this.item.cantitate = parseFloat(baseQty.toFixed(6));
        this.selectedQuantity = parseFloat((baseQty / newMult).toFixed(6));
      }

      this.calculateAdaos();
    },
    onDocumentUnitChange: function onDocumentUnitChange() {
      this.convertUnit(this.previousSelectedUnit);
      this.previousSelectedUnit = this.selectedUnit;
    },
    onProductSelect: function onProductSelect(selectedProduct, row) {
      var _this23 = this;

      if (!selectedProduct) return;
      row = row || {};

      if (this.isInvoiceSupplier && !selectedProduct) {
        this.resetProduct(row);
        return;
      }

      if (selectedProduct.id === 'add') {
        this.addProduct();
        return;
      }

      if (this.isInvoiceSupplier) {
        this.item.productName = selectedProduct.name || '';
        this.item.posId = selectedProduct.id || selectedProduct._id;
        row.nr = selectedProduct.product_code || row.nr || '';
        row.productName = selectedProduct;

        if (!this.item.categoria && selectedProduct.categorie) {
          var categoria = selectedProduct.categorie.trim().replace(/\s+/g, ' ');
          var categorieMap = {
            'marfa': 'Marfa',
            'materii prime': 'Materii prime',
            'materiale consumabile': 'Materiale consumabile',
            'produs rezidual': 'Produs rezidual',
            'ambalaje': 'Ambalaje',
            'obiecte de inventar': 'Obiecte de inventar'
          };
          var normalizedKey = categoria.toLowerCase();
          this.item.categoria = categorieMap[normalizedKey] || categoria;
        }

        if (selectedProduct.um) {
          row.um = selectedProduct.um;
          this.item.um = selectedProduct.um;
        }

        var unit = (this.mesurementsUnits || []).find(function (u) {
          return _this23.normalizeUm(u.short) === _this23.normalizeUm(selectedProduct.um);
        });
        this.$set(row, 'unit_calc', this.mergeUnitCalc(unit ? unit.unit_calc : [], selectedProduct.um));

        if (row.cantitateDocument == null || row.cantitateDocument === '') {
          row.cantitateDocument = row.quantityInvoiceSupplier;
        }

        var resolvedUm = this.resolveInvoiceRowDocumentUm(row);
        this.$set(row, 'umDocument', resolvedUm);
        this.$set(row, '_prevUmDocument', resolvedUm);
        this.recalculateInvoiceSupplierRow(row);
        this.syncRowToItem(row, this.item);

        return;
      }

      if (selectedProduct && selectedProduct.id === 'add') {
        this.addProduct();
      } else if (selectedProduct) {
        console.log('selectedProduct', selectedProduct);
        this.item.nr = selectedProduct.product_code || '';
        this.item.posId = selectedProduct.posId || selectedProduct._id;

        this.selectedUnit = selectedProduct.um;
        this.previousSelectedUnit = selectedProduct.um;
        this.item.um = selectedProduct.um;
        this.item.tvaProdusVanzare = selectedProduct.vat_percent != null ? selectedProduct.vat_percent : '';

        var hasVat = selectedProduct.vat_percent != null && selectedProduct.vat_percent !== '';
        if (this.addItem) {
          if (hasVat) {
            this.item.valoare = 'cu_tva';
            this.item.tva = Number(selectedProduct.vat_percent);
          } else {
            this.item.tva = '';
          }
        } else if (this.item.tva === '' || this.item.tva === null || this.item.tva === undefined) {
          this.item.tva = hasVat ? Number(selectedProduct.vat_percent) : '';
        }

        if (this.selectedGestiuneId && selectedProduct.prices) {
          this.item.price = selectedProduct.prices[this.selectedGestiuneId] || selectedProduct.price || '';
        } else {
          this.item.price = selectedProduct.price || '';
        }

        var _unit = (this.mesurementsUnits || []).find(function (u) {
          return _this23.normalizeUm(u.short) === _this23.normalizeUm(selectedProduct.um);
        });
        this.unit_calc = this.mergeUnitCalc(_unit ? _unit.unit_calc : [], selectedProduct.um);

        if (!this.item.categoria && selectedProduct.categorie) {
          var _categoria = selectedProduct.categorie.trim().replace(/\s+/g, ' ');
          var _categorieMap = {
            'marfa': 'Marfa',
            'materii prime': 'Materii prime',
            'materiale consumabile': 'Materiale consumabile',
            'produs rezidual': 'Produs rezidual',
            'ambalaje': 'Ambalaje',
            'obiecte de inventar': 'Obiecte de inventar'
          };

          var _normalizedKey = _categoria.toLowerCase();
          this.item.categoria = _categorieMap[_normalizedKey] || _categoria;
        }

        if (!this.selectedGestiuneId) {
          if (this.item.categoria) {
            var gestiuneCompatibila = this.filteredGestiuni.find(function (g) {
              return g.categorie && g.categorie.toLowerCase() === _this23.item.categoria.toLowerCase();
            });

            this.item.gestiune = gestiuneCompatibila ? gestiuneCompatibila._id : '';
          }
        } else {
          this.item.gestiune = this.selectedGestiuneId;
        }
      }
    },
    syncRowToItem: function syncRowToItem(row, item) {
      if (!row || !item) return;

      row.posId = item.posId || '';
      row.categoria = item.categoria || row.categoria || '';
    },
    isInvoiceSupplierRowMapped: function isInvoiceSupplierRowMapped(row) {
      if (!row) return false;
      if (row.nr === 'Corectie') return true;

      var hasPosId = !!row.posId;
      var hasUm = !!row.um;
      var name = row.productName;
      var hasProductName = !!(name && ((typeof name === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(name)) === 'object' ? name._id || name.id || name.name || name.posId : String(name).trim()));

      return hasPosId || hasUm && hasProductName;
    },
    onInvoiceSupplierUnitChange: function onInvoiceSupplierUnitChange(row) {
      var prevUm = row._prevUmDocument || row.umDocument;
      var newUm = row.umDocument;

      var ratioOldToNew = this.getCompatibleUmRatio(this.normalizeInvoiceUm(prevUm), this.normalizeInvoiceUm(newUm)) || 1;

      var oldQty = Number(row.cantitateDocument);

      if (oldQty > 0) {
        var newQty = parseFloat((oldQty * ratioOldToNew).toFixed(6));
        this.$set(row, 'cantitateDocument', newQty);
      }

      this.$set(row, '_prevUmDocument', newUm);
      this.recalculateInvoiceSupplierRow(row);
    },
    onInvoiceSupplierQuantityInput: function onInvoiceSupplierQuantityInput(row) {
      this.recalculateInvoiceSupplierRow(row);
    },
    addProduct: function addProduct() {
      this.$modal.show('addProduct');
    },
    closeProduct: function closeProduct() {
      this.$modal.hide('addProduct');
    },
    checkValidatedAfter: function checkValidatedAfter(field) {
      var _this24 = this;

      var products = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var selectedDate, queryParams, body, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                selectedDate = _this24[field];

                if (selectedDate) {
                  _context12.next = 4;
                  break;
                }

                return _context12.abrupt('return', false);

              case 4:

                if (!products) {
                  if (!_this24.tableData || _this24.tableData.length === 0) {
                    products = [];
                  } else {
                    products = _this24.tableData.map(function (item) {
                      return item.posId;
                    });
                  }
                }

                queryParams = new URLSearchParams({
                  date: new Date(selectedDate).toISOString(),
                  externalCompanyId: _this24.companyID,
                  externalLocationId: _this24.selectedLocationId
                });
                body = products.length > 0 ? { products: products } : null;
                _context12.next = 9;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/inventar/validated-after-products?' + queryParams.toString(), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: body ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(body) : null
                });

              case 9:
                response = _context12.sent;

                if (response.ok) {
                  _context12.next = 12;
                  break;
                }

                throw new Error('Request failed: ' + response.status);

              case 12:
                _context12.next = 14;
                return response.json();

              case 14:
                data = _context12.sent;

                console.log('Response from validated-after:', data);

                if (!data.exists) {
                  _context12.next = 21;
                  break;
                }

                _context12.next = 19;
                return __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  icon: 'warning',
                  title: 'Atenție!',
                  text: 'Există deja un inventar validat după această dată pentru unul sau mai multe produse selectate.'
                });

              case 19:
                _this24[field] = null;
                return _context12.abrupt('return', false);

              case 21:
                return _context12.abrupt('return', true);

              case 24:
                _context12.prev = 24;
                _context12.t0 = _context12['catch'](0);

                console.error(_context12.t0);
                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  icon: 'error',
                  title: 'Eroare!',
                  text: 'Nu s-a putut verifica inventarul.'
                });
                return _context12.abrupt('return', false);

              case 29:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this24, [[0, 24]]);
      }))();
    },
    addProductApi: function addProductApi() {
      var _this25 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var productData, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(!_this25.name || !_this25.code || !_this25.type)) {
                  _context13.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Toate câmpurile obligatorii trebuie completate!',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context13.abrupt('return');

              case 3:
                productData = {
                  name: _this25.name,
                  product_code: _this25.code,
                  is_with_vat: true,
                  vat_percent: 20,
                  currency: _this25.currencyProduct,
                  um: _this25.umProduct,
                  externalId: '',
                  is_external: 0,
                  externalCompanyId: _this25.companyID,
                  externalLocationId: _this25.selectedLocation.true_id,
                  vatNumber: _this25.selectedLocation.inv_fiscal_code,
                  categorie: _this25.type,
                  pret_vanzare: []
                };
                _context13.prev = 4;
                _context13.next = 7;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/nomenclator', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(productData)
                });

              case 7:
                response = _context13.sent;
                _context13.next = 10;
                return response.json();

              case 10:
                data = _context13.sent;

                if (response.ok) {
                  _context13.next = 14;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  title: 'Eroare',
                  text: data.details || 'A apărut o eroare la salvarea produsului.',
                  type: 'error',
                  timer: 4000,
                  showConfirmButton: false
                });
                return _context13.abrupt('return');

              case 14:
                _context13.next = 16;
                return _this25.fetchProducts();

              case 16:

                _this25.searchResults.push(data);
                _this25.productNameRecipe = data;
                _this25.codeProductRecipe = data.product_code;
                _this25.umRecipe = data.um;
                _this25.posId = data._id;

                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Produsul a fost salvat cu succes.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this25.$modal.hide('addProduct');
                _this25.resetFields();
                _context13.next = 30;
                break;

              case 26:
                _context13.prev = 26;
                _context13.t0 = _context13['catch'](4);

                console.error('Error saving product:', _context13.t0);
                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o eroare la salvarea produsului.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 30:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this25, [[4, 26]]);
      }))();
    },
    resetFields: function resetFields() {
      this.name = '';
      this.description = '';
      this.code = '';
    },
    saveProduct: function saveProduct() {
      var _this26 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var missingFields, productId, isValid, tva, qtyDocument, mult, cantitateCorecta, pretIntrodus, pretDocument, valoareFaraTvaRaw, pretFaraTva, valoareTvaRaw, valoareCalculata, valoareTva, gestiuneId, umDocument, itemToSave;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                missingFields = [];


                if (!_this26.item.productName) missingFields.push('Produsul nu a fost selectat');
                if (!_this26.item.nr) missingFields.push('Numărul lipsește');
                if (!_this26.item.cantitate) missingFields.push('Cantitatea lipsește');
                if (!_this26.item.pretFaraTva) missingFields.push('Prețul lipsește');
                if (!_this26.item.um) missingFields.push('Unitatea de măsură lipsește');
                if (!_this26.item.gestiune) missingFields.push('Gestiunea lipsește');

                if (!(missingFields.length > 0)) {
                  _context14.next = 10;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  title: 'Eroare',
                  html: missingFields.map(function (f) {
                    return '\u2022 ' + f;
                  }).join('<br>'),
                  type: 'error',
                  timer: 4000,
                  showConfirmButton: false
                });
                return _context14.abrupt('return');

              case 10:
                productId = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_this26.item.productName) === 'object' ? _this26.item.productName._id : _this26.item.productName;
                _context14.next = 13;
                return _this26.checkValidatedAfter('dataInStoc', [productId]);

              case 13:
                isValid = _context14.sent;

                if (isValid) {
                  _context14.next = 16;
                  break;
                }

                return _context14.abrupt('return');

              case 16:
                tva = parseFloat(_this26.item.tva);
                qtyDocument = Number(_this26.selectedQuantity);
                mult = _this26.getBaseUnitsPerDocumentUnit();
                cantitateCorecta = parseFloat((qtyDocument * mult).toFixed(6));

                _this26.item.cantitate = cantitateCorecta;
                pretIntrodus = parseFloat(_this26.item.pretFaraTva);
                pretDocument = pretIntrodus;

                if (_this26.item.valoare === 'cu_tva') {
                  pretDocument = pretIntrodus / (1 + tva / 100);
                }

                valoareFaraTvaRaw = pretDocument * qtyDocument;
                pretFaraTva = cantitateCorecta ? valoareFaraTvaRaw / cantitateCorecta : _this26.convertPriceToProductUm(pretDocument);
                valoareTvaRaw = valoareFaraTvaRaw * (tva / 100);
                valoareCalculata = valoareFaraTvaRaw;
                valoareTva = valoareTvaRaw;

                if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(_this26.item.productName) === 'object') {
                  _this26.item.productName = _this26.item.productName.name || _this26.item.productName.product_code;
                }

                gestiuneId = _this26.item.gestiune;
                umDocument = _this26.getDocumentUmShort();
                itemToSave = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this26.item, {
                  gestiune: gestiuneId,
                  pretFaraTva: pretFaraTva,
                  pretIntrodus: pretIntrodus,
                  umDocument: umDocument,
                  cantitateDocument: qtyDocument || cantitateCorecta,
                  valoareCalculata: valoareCalculata,
                  valoareTva: valoareTva
                });


                if (_this26.editIndex !== null) {
                  _this26.$set(_this26.tableData, _this26.editIndex, itemToSave);
                } else {
                  _this26.tableData.push(itemToSave);
                }

                _this26.editIndex = null;
                _this26.item = _this26.getEmptyItem();
                _this26.$modal.hide('addProductModal');

              case 37:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this26);
      }))();
    },
    saveNIR: function saveNIR() {
      var _this27 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var mappedRows, invalidQty, valoareIntrodusa, totalCalculat, diferenta, existaAjustare, ajustareItem, sourceRows, itemsWithAdaos, nirData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!_this27.isInvoiceSupplier) {
                  _context15.next = 6;
                  break;
                }

                mappedRows = _this27.tableData.filter(function (p) {
                  return _this27.isInvoiceSupplierRowMapped(p);
                });
                invalidQty = mappedRows.filter(function (p) {
                  return p.nr !== 'Corectie' && (!p.cantitate || p.cantitate <= 0);
                });

                if (!(invalidQty.length > 0)) {
                  _context15.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Cantitatea este obligatorie și trebuie să fie mai mare decât 0 pentru produsele mapate.',
                  type: 'error',
                  timer: 4000,
                  showConfirmButton: false
                });
                return _context15.abrupt('return');

              case 6:
                valoareIntrodusa = parseFloat(_this27.valoare);
                totalCalculat = parseFloat(_this27.totalFinal.toFixed(2));
                diferenta = parseFloat((valoareIntrodusa - totalCalculat).toFixed(2));
                existaAjustare = _this27.tableData.some(function (p) {
                  return p.nr === 'Corectie';
                });

                if (!(Math.abs(diferenta) > 0.01 && !existaAjustare)) {
                  _context15.next = 16;
                  break;
                }

                ajustareItem = {
                  productName: diferenta < 0 ? 'Corectie Negativa' : 'Corectie Pozitiva',
                  nr: 'Corectie',
                  categoria: 'Ajustare',
                  um: 'buc',
                  cantitate: 1,
                  valoareCalculata: diferenta,
                  gestiune: _this27.tableData.length > 0 && _this27.tableData[0].gestiune || '',
                  posId: null
                };
                _context15.next = 14;
                return __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  title: 'Corecție factură',
                  text: 'Diferen\u021Ba \xEEntre totalul documentului \u0219i totalul calculat este de ' + diferenta.toFixed(2) + '. Se va ad\u0103uga automat un produs pentru ajustare.',
                  type: 'info',
                  confirmButtonText: 'OK'
                });

              case 14:

                _this27.tableData.push(ajustareItem);

                return _context15.abrupt('return');

              case 16:
                sourceRows = _this27.isInvoiceSupplier ? _this27.tableData.filter(function (p) {
                  return _this27.isInvoiceSupplierRowMapped(p);
                }) : _this27.tableData;
                itemsWithAdaos = sourceRows.map(function (product) {
                  var adaos = _this27.calculateAdaos(product);

                  var finalProduct = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, product, adaos);

                  return finalProduct;
                });
                nirData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this27.selectedGestiuneId ? { gestiune: _this27.selectedGestiuneId } : {}, {
                  series: _this27.seriesNumber,
                  nirNumber: parseInt(_this27.currentNumber),
                  numar_document: _this27.nrDocument,
                  data_document: _this27.dataDocument,
                  vatNumberFurnizor: _this27.codeFiscalFurnizor,
                  externalCompanyId: _this27.companyID,
                  externalLocationId: _this27.selectedLocationId,
                  vatNumber: _this27.vatNumber,
                  nume_furnizor: _this27.nume,
                  data_in_stoc: _this27.dataInStoc,
                  data_scadentei: _this27.dataScadenta,
                  tip_document: _this27.tipDocument,
                  valoare: _this27.valoare,
                  moneda: _this27.currency,
                  precizie: _this27.precizie,
                  invoice_supplier: _this27.invoiceSupplierId,
                  items: itemsWithAdaos.map(function (product) {
                    var nirItem = {
                      denumire_produs_sau_serviciu: product.productName ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(product.productName) === 'object' ? product.productName.name : product.productName : '',
                      cod: product.nr,
                      denumire_descriere_produs: product.productName ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(product.productName) === 'object' ? product.productName.name : product.productName : '',
                      categoria: product.categoria,
                      u_m: product.um,

                      cantitate: product.cantitate != null && product.cantitate !== '' ? product.cantitate : product.quantityInvoiceSupplier,
                      tva_percent: parseInt(product.tva),
                      pret_fara_tva: product.pretFaraTva,
                      valoare_calculata: product.valoareCalculata,
                      gestiune: _this27.selectedGestiuneId || product.gestiune,
                      posId: product.posId,
                      pretVanzare: product.price,
                      tvaProdusVanzare: product.tvaProdusVanzare,
                      adaosLinie: product.adaosLinie,
                      adaosTotal: product.adaosTotal,
                      adaosProc: product.adaosProc,
                      salePriceFaraTva: product.salePriceFaraTva,
                      invoice_supplier_product_name: product.productInvoiceSupplier,
                      invoice_supplier_quantity: product.quantityInvoiceSupplier,
                      invoice_supplier_um: product.umInvoiceSupplier
                    };

                    if (_this27.isInvoiceSupplier) {
                      nirItem.um_document = product.umDocument;
                      nirItem.cantitate_document = product.cantitateDocument;
                      nirItem.cantitate = product.cantitate;
                    }

                    return nirItem;
                  }),
                  extraFields: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries___default()(_this27.extraFields).map(function (_ref6) {
                    var _ref7 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
                        key = _ref7[0],
                        value = _ref7[1];

                    return { key: key, value: value };
                  })
                });
                _context15.next = 21;
                return _this27.sendNIRToAPI(nirData);

              case 21:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this27);
      }))();
    },
    updateOrderWithANir: function updateOrderWithANir(number) {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var currentExternalDocs, updateOrderPayload, response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                currentExternalDocs = _this28.myOrder.externalDocIds || {};
                updateOrderPayload = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this28.myOrder, {
                  externalDocIds: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, currentExternalDocs, {
                    nir: {
                      number: number
                    }
                  }),
                  status: 'generat nir'
                });
                _context16.prev = 2;
                _context16.next = 5;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/order', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(updateOrderPayload)
                });

              case 5:
                response = _context16.sent;


                if (!response.ok) {
                  console.warn('Order update with aviz_id failed');
                } else {
                  console.log('Order updated with aviz:', number);
                }
                _context16.next = 12;
                break;

              case 9:
                _context16.prev = 9;
                _context16.t0 = _context16['catch'](2);

                console.error('Error updating order with aviz_id:', _context16.t0);

              case 12:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this28, [[2, 9]]);
      }))();
    },
    escapeHtml: function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    formatTimestampMs: function formatTimestampMs(value) {
      if (value == null || value === '') return '-';
      var timestamp = Number(value);
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(timestamp)) return String(value);

      return new Intl.DateTimeFormat('ro-RO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).format(new Date(timestamp));
    },
    translateSaveError: function translateSaveError(error) {
      var translations = {
        'Stock ledger recovery is required before stock operations can continue': 'Este necesară recuperarea registrului de stoc înainte de a continua operațiunile de stoc.'
      };

      return translations[error] || error;
    },
    translateDetailKey: function translateDetailKey(key) {
      var translations = {
        state: 'Stare',
        mutation_owner: 'Proprietar mutație',
        mutation_started_at_ms: 'Început mutație',
        lease_until_ms: 'Lease până la',
        recovery_reason: 'Motiv recuperare'
      };

      return translations[key] || key;
    },
    translateDetailValue: function translateDetailValue(key, value) {
      if (value == null || value === '') return '-';

      var translations = {
        RECOVERY_REQUIRED: 'Recuperare necesară',
        STOCK_LEDGER_MUTATION_LEASE_EXPIRED: 'Lease-ul mutației pe registrul de stoc a expirat'
      };

      if (typeof value === 'string' && translations[value]) {
        return translations[value];
      }

      if (typeof key === 'string' && key.endsWith('_ms')) {
        return this.formatTimestampMs(value);
      }

      if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(value)) === 'object') {
        try {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value);
        } catch (err) {
          return String(value);
        }
      }

      return String(value);
    },
    formatSaveError: function formatSaveError(data, status) {
      var _this29 = this;

      var fallback = 'A apărut o eroare la salvarea NIR-ului.';
      if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(data)) !== 'object') {
        return status ? fallback + '<br>Cod: ' + status : fallback;
      }

      var message = this.translateSaveError(data.error || data.message) || fallback;
      var details = data.details;

      if (details == null) {
        return this.escapeHtml(message);
      }

      if (typeof details === 'string') {
        return this.escapeHtml(message) + '<br><br>' + this.escapeHtml(details);
      }

      if ((typeof details === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(details)) !== 'object') {
        return this.escapeHtml(message);
      }

      var rows = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(details).map(function (key) {
        var label = _this29.translateDetailKey(key);
        var value = _this29.translateDetailValue(key, details[key]);
        return '<strong>' + _this29.escapeHtml(label) + ':</strong> ' + _this29.escapeHtml(value);
      });

      if (!rows.length) {
        return this.escapeHtml(message);
      }

      return this.escapeHtml(message) + '<br><br>' + rows.join('<br>');
    },
    showSaveError: function showSaveError(data, status) {
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default.a.close();
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        title: 'Eroare',
        html: this.formatSaveError(data, status),
        type: 'error',
        confirmButtonText: 'OK'
      });
    },
    sendNIRToAPI: function sendNIRToAPI(nirData) {
      var _this30 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;

                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  type: 'info',
                  title: 'Salvare în curs...',
                  text: 'Se salvează NIR-ul. Așteaptă te rog.',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  showConfirmButton: false
                });

                if (_this30.isEdit && _this30.nrDocument) {
                  nirData.updateRecord = true;
                }

                _context17.next = 5;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/nir', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(nirData)
                });

              case 5:
                response = _context17.sent;
                _context17.next = 8;
                return response.json().catch(function () {
                  return null;
                });

              case 8:
                data = _context17.sent;

                if (response.ok) {
                  _context17.next = 13;
                  break;
                }

                console.error('Error saving NIR:', data);
                _this30.showSaveError(data, response.status);
                return _context17.abrupt('return');

              case 13:

                console.log('NIR saved successfully:', data);

                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default.a.close();

                if (!(_this30.isNir && data.nir.numar_document)) {
                  _context17.next = 18;
                  break;
                }

                _context17.next = 18;
                return _this30.updateOrderWithANir(data.nir.numar_document);

              case 18:

                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                  title: 'Success',
                  text: 'NIR saved successfully.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this30.$bus.$emit('refresh');
                _this30.$bus.$emit('close-modal');
                _context17.next = 27;
                break;

              case 23:
                _context17.prev = 23;
                _context17.t0 = _context17['catch'](0);

                console.error('Error saving NIR:', _context17.t0);
                _this30.showSaveError(_context17.t0 && _context17.t0.payload || { error: _context17.t0 && _context17.t0.message }, _context17.t0 && _context17.t0.status);

              case 27:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this30, [[0, 23]]);
      }))();
    },
    editRow: function editRow(row) {
      var _this31 = this;

      var index = this.tableData.indexOf(row);
      if (index === -1) return;

      this.editIndex = index;
      this.selectedCategory = row.categoria || '';

      var selectedProduct = {
        name: row.productName || '',
        product_code: row.nr || '',
        categorie: (row.categoria || '').toLowerCase().replace(/\s+/g, '_'),
        vat_percent: row.tva,
        um: row.um,
        posId: row.posId || '',
        price: row.price,
        adaosLinie: row.adaosLinie || 0,
        adaosTotal: row.adaosTotal || 0,
        adaosProc: row.adaosProc || 0,
        salePriceFaraTva: row.salePriceFaraTva || 0
      };

      console.log('ROW', row);
      this.selectedQuantity = row.cantitateDocument != null ? row.cantitateDocument : row.cantitate || 0;

      this.$modal.show('addProductModal');

      console.log(row);

      this.$nextTick(function () {
        _this31.item = {
          nr: row.nr || '',
          productName: selectedProduct,
          categoria: row.categoria || '',
          gestiune: row.gestiune || '',
          um: row.um,
          cantitate: row.cantitate || _this31.selectedQuantity,
          tva: row.tva != null ? Number(row.tva) : null,
          pretFaraTva: row.pretIntrodus != null ? row.pretIntrodus : row.pretFaraTva || null,
          currency: row.currency || 'RON',
          valoare: row.valoare || 'fara_tva',
          posId: row.posId || '',
          umDocument: row.umDocument || row.um,

          price: row.price,
          adaosLinie: row.adaosLinie || 0,
          adaosTotal: row.adaosTotal || 0,
          adaosProc: row.adaosProc || 0,
          salePriceFaraTva: row.salePriceFaraTva || 0
        };
        _this31.addItem = false;

        _this31.onProductSelect(selectedProduct);

        _this31.$nextTick(function () {
          var docUm = _this31.normalizeUm(row.umDocument);
          var productUm = _this31.normalizeUm(row.um);
          if (docUm && docUm !== productUm && _this31.unit_calc && _this31.unit_calc.length) {
            var unit = _this31.unit_calc.find(function (u) {
              return _this31.normalizeUm(u.short) === docUm;
            });
            if (unit) {
              _this31.selectedUnit = unit;
              _this31.previousSelectedUnit = unit;
              _this31.selectedQuantity = row.cantitateDocument != null ? row.cantitateDocument : parseFloat((Number(row.cantitate || 0) / _this31.getBaseUnitsPerDocumentUnit(unit)).toFixed(6));
            }
          } else {
            _this31.previousSelectedUnit = _this31.selectedUnit;
          }
        });
      });
    },
    deleteRow: function deleteRow(row) {
      var index = this.tableData.indexOf(row);

      if (index !== -1) {
        this.tableData.splice(index, 1);
      }
    },
    openAddProductModal: function openAddProductModal() {
      this.addItem = true;

      this.editIndex = null;
      this.resetItem();
      this.$modal.show('addProductModal');
    },
    resetItem: function resetItem() {
      this.selectedCategory = '';
      this.selectedQuantity = '';
      this.totalValue = 0;
      this.selectedUnit = '';
      this.previousSelectedUnit = '';
      this.unit_calc = [];

      this.item = {
        nr: '',
        productName: null,
        categoria: '',
        gestiune: this.defaultGestiuneId || '',
        um: '',
        cantitate: null,
        tva: '',
        price: null,
        adaosTotal: null,
        adaosProc: null,
        adaosLinie: null,
        pretFaraTva: null,
        currency: 'RON',
        valoare: 'fara_tva'
      };
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "gK/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_picker_css__ = __webpack_require__("5ObC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_picker__ = __webpack_require__("4ZDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__);














var _components;








__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    defaultData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    modeldata: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    referalModel: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },

    modeldata: {
      immediate: true,
      handler: function handler(value) {
        this.applyModelData(value);
      }
    },
    'model.loyalty_value_one_currency_per_days': {
      deep: true,
      handler: function handler() {
        this.forceUpdateTimePicker();
      }
    }
  },
  data: function data() {
    return {
      arrayWithDays: {
        'Mon': false,
        'Tue': false,
        'Wed': false,
        'Thu': false,
        'Fri': false,
        'Sat': false,
        'Sun': false
      },
      arrayWithDaysTime: {
        'Mon': false,
        'Tue': false,
        'Wed': false,
        'Thu': false,
        'Fri': false,
        'Sat': false,
        'Sun': false
      },
      selectedDay: [],
      model: {},
      defaults: this.value || this.defaultData,
      modelValidations: {
        loyalty_value_one_point: { required: true },
        loyalty_value_one_point_amount: { required: true },
        loyalty_value_one_currency: { required: true },
        loyalty_min_order_value: { decimal: 2, min_value: 0, max_value: 99999999.99 }
      },
      timePickerKey: []
    };
  },

  computed: {
    currency: function currency() {
      var company = this.model || {};
      var details = company.price_details || {};
      if (details.symbol) return this.decodeHtml(details.symbol);
      if (company.currency_iso) return company.currency_iso;

      var selectedCompany = this.$session.get('selectedCompanyData') || {};
      var cachedDetails = selectedCompany.price_details || {};
      return cachedDetails.symbol ? this.decodeHtml(cachedDetails.symbol) : selectedCompany.currency_iso || '';
    }
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop][0]);
        }
      }
    },
    applyModelData: function applyModelData(value) {
      var _this2 = this;

      if (!value || (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(value)) !== 'object' || Array.isArray(value) || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(value).length) {
        return;
      }
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, value);
      if (data.loyalty_value_one_point_amount != null && data.loyalty_value_one_point_amount !== '') {
        data.loyalty_value_one_point_amount = Math.round(data.loyalty_value_one_point_amount * 10) / 10;
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.arrayWithDays).forEach(function (day) {
        _this2.arrayWithDays[day] = false;
        _this2.arrayWithDaysTime[day] = false;
      });
      if (data.loyalty_value_one_currency_per_days && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data.loyalty_value_one_currency_per_days) === 'object') {
        for (var day in data.loyalty_value_one_currency_per_days) {
          var dayData = data.loyalty_value_one_currency_per_days[day];
          if (!dayData || (typeof dayData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(dayData)) !== 'object') {
            continue;
          }
          this.arrayWithDays[day] = true;
          if (dayData.from) {
            this.arrayWithDaysTime[day] = true;
          }
        }
      }
      if (data.loyalty_min_order_value === undefined) {
        data.loyalty_min_order_value = null;
      }
      data.loyalty_only_full_points = this.isLoyaltyInUseEnabled(data.loyalty_only_full_points);
      data.loyalty_in_use = this.isLoyaltyInUseEnabled(data.loyalty_in_use);
      this.model = data;
    },
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'loyalty_value_one_currency': this.model.loyalty_value_one_currency,
        'loyalty_only_full_points': this.model.loyalty_only_full_points === true || this.model.loyalty_only_full_points === 1 || this.model.loyalty_only_full_points === '1' ? 1 : 0,
        'loyalty_min_order_value': this.model.loyalty_min_order_value === '' || this.model.loyalty_min_order_value == null ? null : Number(this.model.loyalty_min_order_value),
        'loyalty_value_one_point_amount': this.model.loyalty_value_one_point_amount,
        'loyalty_value_one_point': this.model.loyalty_value_one_point,
        'loyalty_value_one_currency_per_days': this.model.loyalty_value_one_currency_per_days,
        'donation_point_value': parseFloat(this.model.donation_point_value),
        'loyalty_points_use_limit': this.model.loyalty_points_use_limit !== null && this.model.loyalty_points_use_limit !== '' ? parseInt(this.model.loyalty_points_use_limit, 10) : null
      };
      var self = this;
      if (typeof this.saveReferal === 'function') {
        this.saveReferal();
      }
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ 'text': self.$t('settingsRewards.rewardSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          self.updateSelectedCompanyCache(response.data[0]);
        } else {
          self.handleErrors(response.errors);
        }
      });
    },
    isLoyaltyInUseEnabled: function isLoyaltyInUseEnabled(value) {
      return value === true || value === 1 || value === '1' || value === 'true';
    },
    normalizeCompanyCacheData: function normalizeCompanyCacheData(companyData) {
      if (!companyData) return companyData;
      var cached = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, companyData);
      cached.loyalty_in_use = this.isLoyaltyInUseEnabled(cached.loyalty_in_use);
      return cached;
    },
    updateSelectedCompanyCache: function updateSelectedCompanyCache(companyData) {
      if (!companyData) return;
      var cached = this.normalizeCompanyCacheData(companyData);
      this.$session.set('selectedCompanyData', cached);
      this.$bus.$emit('company-data-updated', cached);
    },
    handleActive: function handleActive(e) {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'loyalty_in_use': this.isLoyaltyInUseEnabled(this.model.loyalty_in_use)
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ 'text': self.$t('settingsRewards.rewardSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          self.updateSelectedCompanyCache(response.data[0]);
        } else {
          self.handleErrors(response.errors);
          self.model.loyalty_in_use = !self.model.loyalty_in_use;
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
        }
      });
    },
    handleNotification: function handleNotification(e) {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'enable_notification_loyalty_points': this.model.enable_notification_loyalty_points ? 1 : 0
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ 'text': self.$t('settingsRewards.rewardSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          self.updateSelectedCompanyCache(response.data[0]);
        } else {
          self.handleErrors(response.errors);
          self.model.enable_notification_loyalty_points = !self.model.enable_notification_loyalty_points;
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
        }
      });
    },
    goToSettings: function goToSettings() {
      this.$session.set('selectedTab', this.$t('settingsPages.push'));
      this.$router.push('/settings');
    },
    clickOnCheckbox: function clickOnCheckbox(day) {
      if (this.model.loyalty_value_one_currency_per_days == null || this.model.loyalty_value_one_currency_per_days.length === 0) {
        this.model.loyalty_value_one_currency_per_days = {};
        this.model.loyalty_value_one_currency_per_days[day] = { val: '', from: '', to: '' };
      }
      if (this.arrayWithDays[day]) {
        this.model.loyalty_value_one_currency_per_days[day] = { val: this.model.loyalty_value_one_currency, from: '', to: '' };
      } else {
        delete this.arrayWithDaysTime[day];
        delete this.model.loyalty_value_one_currency_per_days[day];
      }
    },
    setTimePeriod: function setTimePeriod(day) {
      if (this.arrayWithDaysTime[day]) {} else {
        delete this.model.loyalty_value_one_currency_per_days[day].from;
        delete this.model.loyalty_value_one_currency_per_days[day].to;
      }
    },
    forceUpdateTimePicker: function forceUpdateTimePicker() {
      var _this3 = this;

      if (this.arrayWithDaysTime) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.arrayWithDaysTime).forEach(function (index) {
          _this3.$set(_this3.timePickerKey, index, { from: 'from_' + index, to: 'to_' + index });
        });
      }
    },
    changeFrom: function changeFrom() {
      this.forceUpdateTimePicker();
    }
  }
});

/***/ }),

/***/ "gKTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gM1+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInitialStockAdd_vue__ = __webpack_require__("7F4u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83d2eb84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInitialStockAdd_vue__ = __webpack_require__("8n+4");
function injectStyle (ssrContext) {
  __webpack_require__("RVli")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83d2eb84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInitialStockAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83d2eb84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInitialStockAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gSDC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__("O5me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_wysiwyg_dist_vueWysiwyg_css__);















__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a),
  data: function data() {
    return {
      pages: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["b" /* mapFields */])(['title', 'description'])),
  created: function created() {
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    var self = this;

    __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
      title: this.$t('general.loading'),
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: function didOpen() {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.showLoading();
      }
    });

    this.apiRequest('/settings/infopages', 'GET', data, function (response) {
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.close();

      if (response.status === true) {
        self.pages = response.data;
      }
    });
  },
  methods: {
    getTitle: function getTitle(page) {
      if (page.type && ['CUSTOM_1', 'CUSTOM_2', 'CUSTOM_3', 'CUSTOM_4', 'CUSTOM_5'].includes(page.type)) {
        return page.title;
      }
      return this.$t('settingsInfoPages.' + page.title);
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate(pageId) {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.savePage(pageId);
        }
      });
    },
    savePage: function savePage(pageId) {
      var thisPageIdx = this.getObjectByElemKeyValue('id', pageId, this.pages);
      var data = this.pages[thisPageIdx];
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      delete data.company;
      var method = 'PUT';
      var linkId = '/' + data.id;

      if (pageId === undefined || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(pageId) && pageId.indexOf('new') === 0) {
        if (data.id) {
          delete data.id;
        }
        method = 'POST';
        linkId = '';
      }
      var self = this;
      this.apiRequest('/settings/infopages' + linkId, method, data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('settingsInfoPages.addedSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          if (method === 'POST') {
            self.pages[thisPageIdx].id = response.data[0].id;
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    addNewPage: function addNewPage() {
      var newPg = {
        'id': 'new_' + Math.floor(Math.random() * 10000),
        'title': this.$t('settingsInfoPages.newPage'),
        'description': ''
      };
      this.pages.push(newPg);
    },
    deletePage: function deletePage(pageId) {
      var _this2 = this;

      var thisPageIdx = this.getObjectByElemKeyValue('id', pageId, this.pages);

      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        text: self.$t('settingsInfoPages.deleteMsg'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result) {
          if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(pageId) && pageId.indexOf('new') === 0) {
            _this2.pages.splice(thisPageIdx, 1);
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('settingsInfoPages.deletedSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
          } else {
            var id = pageId;
            var data = {
              id: id,
              token: _this2.$session.get('token'),
              company_id: _this2.$session.get('selectedCompany')
            };
            _this2.apiRequest('/settings/infopages/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                self.pages.splice(thisPageIdx, 1);
                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('settingsInfoPages.deletedSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
              } else {
                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 });
              }
            });
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "gUiH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gb1l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gedM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-intrari-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gfa0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"challenge-user-logs-report"},[(_vm.loading)?_c('div',{staticClass:"challenge-report-fullscreen-loader"},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('h4',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.headerTitle))])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[(_vm.progressSummary)?_c('p',{staticClass:"text-muted challenge-progress-summary"},[_vm._v("\n        "+_vm._s(_vm.progressSummary.progress)+" / "+_vm._s(_vm.progressSummary.target)+" — "+_vm._s(_vm.formatChallengeStatus(_vm.progressSummary.status))+"\n        "),(_vm.progressSummary.completed_at)?_c('span',[_vm._v("\n          ("+_vm._s(_vm.formatDateTime(_vm.progressSummary.completed_at))+")\n        ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('el-table',{ref:"logsTable",staticClass:"challenge-logs-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData'),"show-summary":"","summary-method":_vm.getSummaries}},[_c('el-table-column',{attrs:{"prop":"created_at","label":_vm.$t('challengeCampaigns.dateTime'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v(_vm._s(_vm.formatDateTime(p.row.created_at) || '—'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"order_id","label":_vm.$t('challengeCampaigns.orderId'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.openOrder(p.row.order_id)}}},[_vm._v(_vm._s(p.row.order_id))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"order_number","label":_vm.$t('orders.orderNumber'),"min-width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"progress","label":_vm.$t('challengeCampaigns.progressGenerated'),"min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"products","label":_vm.$t('challengeCampaigns.products'),"min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [(p.row.products && p.row.products.length)?_vm._l((p.row.products),function(prod,idx){return _c('span',{key:idx},[_vm._v("\n                "+_vm._s(prod.name || ('#' + prod.product_id))+" x"+_vm._s(prod.quantity)),(idx < p.row.products.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])}):_c('span',[_vm._v("—")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totals_grandtotal","label":_vm.$t('orders.totals_grandtotal'),"min-width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n            "+_vm._s(_vm.formatMoneyAmount(p.row.totals_grandtotal, p.row.currency))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"location_name","label":_vm.$t('orders.location'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v(_vm._s(_vm.formatLocation(p.row)))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"order_status","label":_vm.$t('orders.status'),"min-width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v(_vm._s(_vm.formatOrderStatus(p.row.order_status)))]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ggir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-report",staticStyle:{"padding-top":"12px !important"}},[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back banner-back-button",attrs:{"title":_vm.$t('general.back'),"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n            "+_vm._s(_vm.$t('general.back'))+"\n          ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"auto"}},[_c('a',{staticClass:"btn btn-info btn-icon back",attrs:{"title":_vm.$t('general.reload'),"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.refreshNow($event)}}},[_c('i',{staticClass:"ti-reload"}),_vm._v("\n            "+_vm._s(_vm.$t('general.reload'))+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 pos-order-actions-details-table-wrap"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns",staticStyle:{"width":"100%"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"data":_vm.actions,"total":_vm.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"id","label":"ID","min-width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"pos-order-actions-action-col","prop":"action_type","label":_vm.$t('general.action'),"min-width":"260"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"pos-order-actions-action-text"},[_vm._v("\n                  "+_vm._s(_vm.actionTypeDisplay(props.row))+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"amount","label":"Total Comanda","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.amount != null ? props.row.amount : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"product_count","label":_vm.$t('reports.orderProductsCount'),"min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.product_count != null ? props.row.product_count : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"transfer_table_id","label":_vm.$t('reports.transferTable'),"min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.transferTableName(props.row.transfer_table_id))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"payment_method","label":_vm.$t('reports.paymentMethod'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.paymentMethodLabel(props.row.payment_method))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"pos_id","label":_vm.$t('reports.posId'),"min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.posDeviceName(props.row.pos_id))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"created_by","label":_vm.$t('reports.operator'),"min-width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.operatorDisplayName(props.row.created_by))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"created_at","label":_vm.$t('orders.date'),"min-width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.created_at ? _vm.formatToCompanyTimezone(props.row.created_at) : (props.row.timestamp ? _vm.formatToCompanyTimezone(props.row.timestamp) : '-'))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","label":_vm.$t('general.actions'),"min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row && (props.row.transfer_app_id || props.row.transfer_order_app_id))?_c('a',{staticClass:"btn btn-primary btn-icon pos-order-actions-details-action-btn",staticStyle:{"margin-right":"6px"},attrs:{"href":"#","title":"Open transfer order"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.openTransferOrder(props.row)}}},[_c('i',{staticClass:"ti-share"})]):_vm._e(),_vm._v(" "),(_vm.hasBeforeAfter(props.row))?_c('a',{staticClass:"btn btn-info btn-icon pos-order-actions-details-action-btn",attrs:{"href":"#","title":"Diff"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.openBeforeAfterModal(props.row)}}},[_c('i',{staticClass:"ti-eye"})]):_vm._e()]}}])})],1)],1)])])]),_vm._v(" "),_c('vmodal',{staticClass:"filtersAndSortModal sales-report-filters",attrs:{"name":"posOrderActionsBeforeAfterModal","height":"auto","width":"1200","adaptive":true,"scrollable":true}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header slim-header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('general.details')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body slim-body"},[_c('div',{staticClass:"filters-grid sales-report-filters-grid pos-order-actions-diff-grid"},[(_vm.diffModalRow && Number(_vm.diffModalRow.action_type) === 6)?[_c('div',{staticClass:"modal-column-left"},[_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.initialItems')))]),_vm._v(" "),(_vm.transferOutProducts.length)?_c('div',{staticClass:"pos-order-actions-products"},_vm._l((_vm.transferOutProducts),function(prod,idx){return _c('div',{key:'xfer-out-' + idx,staticClass:"pos-order-actions-product-row",class:Number(prod.is_storno) === 1 ? 'pos-order-actions-product-row--storno' : (_vm.isTransferredOutItem(prod) ? 'pos-order-actions-product-row--transfer' : '')},[_c('div',{staticClass:"pos-order-actions-product-header"},[_c('div',{staticClass:"pos-order-actions-product-name"},[_vm._v(_vm._s(prod.name))]),_vm._v(" "),(Number(prod.is_storno) === 1)?_c('div',{staticClass:"pos-order-actions-product-storno-tag"},[_vm._v("STORNO")]):(_vm.isTransferredOutItem(prod))?_c('div',{staticClass:"pos-order-actions-product-transfer-tag"},[_vm._v(_vm._s(_vm.$t('reports.transferredTag')))]):_vm._e()]),_vm._v(" "),(prod.options && prod.options.length)?_c('div',{staticClass:"pos-order-actions-product-options"},_vm._l((prod.options),function(opt,oidx){return _c('div',{key:'xfer-out-opt-' + idx + '-' + oidx},[_vm._v("\n                          + "+_vm._s(opt.name)),(Number(opt.price) > 0)?_c('span',[_vm._v(" ("+_vm._s(opt.price)+")")]):_vm._e()])})):_vm._e(),_vm._v(" "),(prod.additional_info)?_c('div',{staticClass:"pos-order-actions-product-info"},[_vm._v("\n                        "+_vm._s(_vm.$t('orders.custComments'))+": "),_c('i',{staticClass:"text-danger"},[_vm._v(_vm._s(prod.additional_info))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pos-order-actions-product-meta"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.qty'))+": "),_c('b',[_vm._v(_vm._s(prod.quantity))])]),_vm._v(" "),(prod.price != null)?_c('span',[_vm._v(" | "+_vm._s(_vm.$t('orders.unit'))+": "),_c('b',[_vm._v(_vm._s(prod.price))])]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" | "+_vm._s(_vm.$t('orders.date'))+": "),_c('b',[_vm._v(_vm._s(_vm.productCreatedAtDisplay(prod)))])])])])})):_c('div',{staticClass:"pos-order-actions-empty"},[_vm._v("-")])])]),_vm._v(" "),_c('div',{staticClass:"modal-column-right"},[_c('div',{staticClass:"filter-section"},[_c('div',{staticClass:"pos-order-actions-section-header"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.remainingItems')))]),_vm._v(" "),(_vm.transferRemainingStatus)?_c('div',{staticClass:"pos-order-actions-status-wrap"},[_c('span',{staticClass:"pos-order-actions-status-pill",class:_vm.statusPillClass(_vm.transferRemainingStatus)},[_vm._v("\n                        "+_vm._s(_vm.$t('ordersStatus.' + _vm.transferRemainingStatus))+"\n                      ")])]):_vm._e()]),_vm._v(" "),(_vm.transferRemainingDisplayProducts.length)?_c('div',{staticClass:"pos-order-actions-products",staticStyle:{"margin-top":"10px"}},_vm._l((_vm.transferRemainingDisplayProducts),function(prod,idx){return _c('div',{key:'xfer-rem-' + idx,staticClass:"pos-order-actions-product-row"},[_c('div',{staticClass:"pos-order-actions-product-name"},[_vm._v(_vm._s(prod.name))]),_vm._v(" "),(prod.options && prod.options.length)?_c('div',{staticClass:"pos-order-actions-product-options"},_vm._l((prod.options),function(opt,oidx){return _c('div',{key:'xfer-rem-opt-' + idx + '-' + oidx},[_vm._v("\n                          + "+_vm._s(opt.name)),(Number(opt.price) > 0)?_c('span',[_vm._v(" ("+_vm._s(opt.price)+")")]):_vm._e()])})):_vm._e(),_vm._v(" "),(prod.additional_info)?_c('div',{staticClass:"pos-order-actions-product-info"},[_vm._v("\n                        "+_vm._s(_vm.$t('orders.custComments'))+": "),_c('i',{staticClass:"text-danger"},[_vm._v(_vm._s(prod.additional_info))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pos-order-actions-product-meta"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.qty'))+": "),_c('b',[_vm._v(_vm._s(prod.quantity))])]),_vm._v(" "),(prod.price != null)?_c('span',[_vm._v(" | "+_vm._s(_vm.$t('orders.unit'))+": "),_c('b',[_vm._v(_vm._s(prod.price))])]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" | "+_vm._s(_vm.$t('orders.date'))+": "),_c('b',[_vm._v(_vm._s(_vm.productCreatedAtDisplay(prod)))])])])])})):_c('div',{staticClass:"pos-order-actions-empty"},[_vm._v("-")])])])]:(_vm.diffModalRow && Number(_vm.diffModalRow.action_type) === 7)?[_c('div',{staticClass:"filter-section wide-filter"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.itemsReceived')))]),_vm._v(" "),(_vm.transferInProducts.length)?_c('div',{staticClass:"pos-order-actions-products"},_vm._l((_vm.transferInProducts),function(prod,idx){return _c('div',{key:'xfer-in-' + idx,staticClass:"pos-order-actions-product-row"},[_c('div',{staticClass:"pos-order-actions-product-name"},[_vm._v(_vm._s(prod.name))]),_vm._v(" "),_c('div',{staticClass:"pos-order-actions-product-meta"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.qty'))+": "),_c('b',[_vm._v(_vm._s(prod.quantity))])]),_vm._v(" "),_c('span',[_vm._v(" | "+_vm._s(_vm.$t('orders.date'))+": "),_c('b',[_vm._v(_vm._s(_vm.productCreatedAtDisplay(prod)))])])])])})):_c('div',{staticClass:"pos-order-actions-empty"},[_vm._v("-")])])]:[_c('div',{staticClass:"filter-section wide-filter"},[(_vm.diffModalRow && (Number(_vm.diffModalRow.action_type) === 2 || Number(_vm.diffModalRow.action_type) === 3))?[(_vm.beforeProducts.length)?_c('div',{staticClass:"pos-order-actions-products"},_vm._l((_vm.beforeProducts),function(prod,idx){return _c('div',{key:'before-prod-' + idx,staticClass:"pos-order-actions-product-row"},[_c('div',{staticClass:"pos-order-actions-product-name"},[_vm._v("\n                        "+_vm._s(prod.name)+"\n                      ")]),_vm._v(" "),(prod.options && prod.options.length)?_c('div',{staticClass:"pos-order-actions-product-options"},_vm._l((prod.options),function(opt,oidx){return _c('div',{key:'before-opt-' + idx + '-' + oidx},[_vm._v("\n                          + "+_vm._s(opt.name)),(Number(opt.price) > 0)?_c('span',[_vm._v(" ("+_vm._s(opt.price)+")")]):_vm._e()])})):_vm._e(),_vm._v(" "),(prod.additional_info)?_c('div',{staticClass:"pos-order-actions-product-info"},[_vm._v("\n                        "+_vm._s(_vm.$t('orders.custComments'))+": "),_c('i',{staticClass:"text-danger"},[_vm._v(_vm._s(prod.additional_info))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pos-order-actions-product-meta"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.qty'))+": "),_c('b',[_vm._v(_vm._s(prod.quantity))])]),_vm._v(" "),(prod.price != null)?_c('span',[_vm._v(" | "+_vm._s(_vm.$t('orders.unit'))+": "),_c('b',[_vm._v(_vm._s(prod.price))])]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" | "+_vm._s(_vm.$t('orders.date'))+": "),_c('b',[_vm._v(_vm._s(_vm.productCreatedAtDisplay(prod)))])])])])})):_c('div',{staticClass:"pos-order-actions-empty"},[_vm._v("-")])]:(_vm.diffModalRow && Number(_vm.diffModalRow.action_type) === 4)?[(_vm.orderStatusAfter)?_c('div',{staticClass:"pos-order-actions-status-wrap"},[_c('span',{staticClass:"pos-order-actions-status-label"},[_vm._v(_vm._s(_vm.$t('orders.status'))+":")]),_vm._v(" "),_c('span',{staticClass:"pos-order-actions-status-pill",class:_vm.statusPillClass(_vm.orderStatusAfter)},[_vm._v("\n                      "+_vm._s(_vm.$t('ordersStatus.' + _vm.orderStatusAfter))+"\n                    ")])]):_c('div',{staticClass:"pos-order-actions-empty"},[_vm._v("-")])]:(_vm.diffModalRow && Number(_vm.diffModalRow.action_type) === 5)?[_c('div',{staticClass:"filter-section wide-filter"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.items')))]),_vm._v(" "),(_vm.stornoAfterProducts.length)?_c('div',{staticClass:"pos-order-actions-products"},_vm._l((_vm.stornoAfterProducts),function(prod,idx){return _c('div',{key:'storno-after-' + idx,staticClass:"pos-order-actions-product-row",class:Number(prod.is_storno) === 1 ? 'pos-order-actions-product-row--storno' : ''},[_c('div',{staticClass:"pos-order-actions-product-header"},[_c('div',{staticClass:"pos-order-actions-product-name"},[_vm._v(_vm._s(prod.name))]),_vm._v(" "),(Number(prod.is_storno) === 1)?_c('div',{staticClass:"pos-order-actions-product-storno-tag"},[_vm._v("STORNO")]):_vm._e()]),_vm._v(" "),(prod.options && prod.options.length)?_c('div',{staticClass:"pos-order-actions-product-options"},_vm._l((prod.options),function(opt,oidx){return _c('div',{key:'storno-after-opt-' + idx + '-' + oidx},[_vm._v("\n                            + "+_vm._s(opt.name)),(Number(opt.price) > 0)?_c('span',[_vm._v(" ("+_vm._s(opt.price)+")")]):_vm._e()])})):_vm._e(),_vm._v(" "),(prod.additional_info)?_c('div',{staticClass:"pos-order-actions-product-info"},[_vm._v("\n                          "+_vm._s(_vm.$t('orders.custComments'))+": "),_c('i',{staticClass:"text-danger"},[_vm._v(_vm._s(prod.additional_info))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pos-order-actions-product-meta"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.qty'))+": "),_c('b',[_vm._v(_vm._s(prod.quantity))])]),_vm._v(" "),(prod.price != null)?_c('span',[_vm._v(" | "+_vm._s(_vm.$t('orders.unit'))+": "),_c('b',[_vm._v(_vm._s(prod.price))])]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" | "+_vm._s(_vm.$t('orders.date'))+": "),_c('b',[_vm._v(_vm._s(_vm.productCreatedAtDisplay(prod)))])])])])})):_c('div',{staticClass:"pos-order-actions-empty"},[_vm._v("-")])])]:[_c('div',{staticClass:"pos-order-actions-empty"},[_vm._v("-")])],_vm._v(" "),(_vm.diffModalRow && Number(_vm.diffModalRow.action_type) === 3)?_c('div',{staticStyle:{"margin-top":"12px"}},[(_vm.printerStatusObj)?_c('div',{staticClass:"pos-order-actions-status-wrap"},[_c('span',{staticClass:"pos-order-actions-status-label"},[_vm._v("Printer status:")]),_vm._v(" "),_c('span',{staticClass:"pos-order-actions-status-pill",class:_vm.printerStatusObj.status === true ? 'ok' : 'bad'},[_vm._v("\n                      "+_vm._s(_vm.printerStatusObj.status === true ? 'OK' : 'FAILED')+"\n                    ")])]):_vm._e()]):_vm._e()],2)]],2),_vm._v(" "),_c('div',{staticClass:"modal-footer slim-footer"},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.closeBeforeAfterModal}},[_vm._v(_vm._s(_vm.$t('general.close')))])],1)])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ghJJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gk9I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gobJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"box-container row"},_vm._l((_vm.screenRoutes),function(route,index){return _c('div',{key:route.name,staticClass:"col-md-4"},[_c('router-link',{staticClass:"box",style:({ backgroundColor: _vm.getBoxColor(index) }),attrs:{"to":route.path}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('pages.' + route.key)))]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.getImageForRoute(route.key),"alt":'Image for ' + route.key}})])])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gwRB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('element-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gyD3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosScreenAdd_vue__ = __webpack_require__("ygx8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_302507b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosScreenAdd_vue__ = __webpack_require__("iCFt");
function injectStyle (ssrContext) {
  __webpack_require__("eZ5b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosScreenAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_302507b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosScreenAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gyk7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gz/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelCampaigns_vue__ = __webpack_require__("DYIL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57e456e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelCampaigns_vue__ = __webpack_require__("dkPp");
function injectStyle (ssrContext) {
  __webpack_require__("CgSl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelCampaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57e456e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelCampaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h2V8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-9 col-md-12 col-sm-12"},[_c('div',{staticClass:"pull-left "},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"title":"Edit","to":{ path: '/orders/view/123', params: { id: 123 }}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v(" Back")])],1),_vm._v(" "),_c('p',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"card col-lg-9 col-md-12 col-sm-12"},[_c('div',{staticClass:"row"},[_c('form',[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 pad-bt-15"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.formatDateTime(_vm.order.created_date)))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('el-time-select',{staticClass:"in-inline",attrs:{"type":"time","value":_vm.order.pickup_time,"placeholder":""},model:{value:(_vm.order.pickup_time),callback:function ($$v) {_vm.$set(_vm.order, "pickup_time", $$v)},expression:"order.pickup_time"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.type),expression:"order.type"}],staticClass:"form-control",attrs:{"name":"Payment type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.order, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_c('option',{attrs:{"value":"group"}},[_vm._v("Group")]),_vm._v(" "),_c('option',{attrs:{"value":"sigle"}},[_vm._v("Sigle")])])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.payment.id),expression:"order.payment.id"}],staticClass:"form-control",attrs:{"name":"Payment type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.order.payment, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_c('option',{attrs:{"value":"card"}},[_vm._v("Card")]),_vm._v(" "),_c('option',{attrs:{"value":"cash"}},[_vm._v("Cash on delivery")])])])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.delivery.id),expression:"order.delivery.id"}],staticClass:"form-control",attrs:{"name":"Payment type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.order.delivery, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.deliveryMethods),function(del){return _c('option',{domProps:{"value":del.id}},[_vm._v(_vm._s(del.type))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 pad-bt-15"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_c('el-select',{attrs:{"name":"customer","filterable":""},model:{value:(_vm.order.customer.id),callback:function ($$v) {_vm.$set(_vm.order.customer, "id", $$v)},expression:"order.customer.id"}},[_c('el-option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.customers),function(cust){return _c('el-option',{key:cust.id,attrs:{"value":cust.id,"label":cust.name}},[_vm._v(_vm._s(cust.name))])})],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_vm._l((_vm.order.address),function(address){return _c('div',{staticClass:"col-md-6 pad-bt-15"},[_c('h6',[_c('i',{staticClass:"ti-world"}),_vm._v(" "+_vm._s(_vm._f("capitalize")(address.type))+" Address")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 pad-bt-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(address.street),expression:"address.street"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.street),expression:"modelValidations.street"}],staticClass:"form-control",attrs:{"type":"text","name":"street","placeholder":"Street"},domProps:{"value":(address.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(address, "street", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pad-bt-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(address.city),expression:"address.city"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.city),expression:"modelValidations.city"}],staticClass:"form-control",attrs:{"type":"text","name":"city","placeholder":"City"},domProps:{"value":(address.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(address, "city", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12 pad-bt-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(address.country),expression:"address.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.country),expression:"modelValidations.country"}],staticClass:"select-primary form-control",attrs:{"name":"country"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateCounty(address.type)}]}},_vm._l((_vm.countries),function(country){return _c('option',{staticClass:"select-primary",domProps:{"value":country}},[_vm._v(_vm._s(country.name)+"\n                ")])}))]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12 pad-bt-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(address.state),expression:"address.state"}],staticClass:"select-primary form-control",attrs:{"name":"state"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(address, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.states[address.type]),function(state){return _c('option',{staticClass:"select-primary",domProps:{"value":state}},[_vm._v(_vm._s(state)+"\n                ")])})],2)])])])}),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-bt-15"},[_vm._m(8),_vm._v(" "),_c('hr'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.order.comments),expression:"order.comments"}],staticClass:"form-control",domProps:{"value":(_vm.order.comments)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.order, "comments", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_vm._m(9),_vm._v(" "),_c('table',{staticClass:"table"},[_vm._m(10),_vm._v(" "),_c('tbody',[_vm._l((_vm.order.products),function(customer){return [(_vm.order.type=='group')?_c('tr',{staticClass:"active"},[_c('td',{attrs:{"colspan":"5"}},[_vm._v("Customer: "+_vm._s(customer.customer.name))])]):_vm._e(),_vm._v(" "),_vm._l((customer.items),function(prod){return _c('tr',[_c('td',[_vm._v("\n                    "+_vm._s(prod.name)+"\n                    "),_c('ul',{directives:[{name:"id",rawName:"v-id",value:(prod.options),expression:"prod.options"}]},_vm._l((prod.options),function(opt){return _c('li',[_vm._v("\n                        "+_vm._s(opt.name)),(opt.price>0)?_c('span',[_vm._v(" +"+_vm._s(_vm.formatMoneyAmount(opt.price, _vm.order.currency)))]):_vm._e()])})),_vm._v(" "),_c('span',{},[_c('i',[_vm._v(_vm._s(prod.additional_info))])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(prod.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatMoneyAmount(prod.price, _vm.order.currency)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatMoneyAmount(prod.quantity * prod.price, _vm.order.currency)))]),_vm._v(" "),_vm._m(11,true)])})]}),_vm._v(" "),_vm._l((_vm.order.totals),function(total,label){return [_c('tr',{class:_vm.getRowClass(label)},[_c('td',{staticStyle:{"border-top":"0px solid black"}}),_vm._v(" "),_c('td',{staticStyle:{"border-top":"0px solid black"}}),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("capitalize")(label)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(total, _vm.order.currency)))])]),_vm._v(" "),_c('td')])]})],2)])]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" Person")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.person),expression:"modelValidations.person"},{name:"model",rawName:"v-model",value:(_vm.modelProduct.person),expression:"modelProduct.person"}],staticClass:"form-control",attrs:{"type":"text","name":"person","placeholder":""},domProps:{"value":(_vm.modelProduct.person)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelProduct, "person", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n              Product\n            ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.product),expression:"modelValidations.product"},{name:"model",rawName:"v-model",value:(_vm.modelProduct.product),expression:"modelProduct.product"}],staticClass:"form-control",attrs:{"name":"product"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modelProduct, "product", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- products -")]),_vm._v(" "),_vm._l((_vm.productsAll),function(prod){return _c('option',{ref:"productOpt",refInFor:true,domProps:{"value":prod.product_id}},[_vm._v(_vm._s(prod.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Quantity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelProduct.quantity),expression:"modelProduct.quantity"}],staticClass:"form-control",attrs:{"type":"number","name":"quantity","value":"1","placeholder":""},domProps:{"value":(_vm.modelProduct.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelProduct, "quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 pad-to-5"},[_c('label'),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-info ",on:{"click":function($event){$event.preventDefault();_vm.addProduct()}}},[_vm._v("Add")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pad-bt-15"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Coupon code")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.person),expression:"modelValidations.person"},{name:"model",rawName:"v-model",value:(_vm.modelProduct.person),expression:"modelProduct.person"}],staticClass:"form-control",attrs:{"type":"text","name":"person","placeholder":""},domProps:{"value":(_vm.modelProduct.person)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modelProduct, "person", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-info ",on:{"click":function($event){$event.preventDefault();}}},[_vm._v("Apply")])])])])]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('p',{staticClass:"clearfix"})],2)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_c('i',{staticClass:"ti-shopping-cart"}),_vm._v(" Order Details")]),_vm._v(" "),_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12"},[_c('b',[_vm._v("Order made at")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 pad-to-10"},[_c('b',[_vm._v("Order pickup time")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 pad-to-10"},[_c('b',[_vm._v("Type")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 pad-to-10"},[_c('b',[_vm._v("Payment")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 pad-to-10"},[_c('b',[_vm._v("Delivery")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h6',[_c('i',{staticClass:"ti-user"}),_vm._v(" Customer Details")]),_vm._v(" "),_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 pad-to-10"},[_c('b',[_vm._v("Customer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',[_c('i',{staticClass:"ti-comment"}),_vm._v(" Customer Comments")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h4',[_vm._v("Products")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Qty")]),_vm._v(" "),_c('th',[_vm._v("Unit Price")]),_vm._v(" "),_c('th',[_vm._v("Total")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('a',{staticClass:"ti-close text-danger",attrs:{"title":"Remove"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 pad-to-15"},[_c('h6',[_c('i',{staticClass:"ti-plus"}),_vm._v(" ADD PRODUCT(S)")]),_vm._v(" "),_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-sm-12 pad-to-15"},[_c('h6',[_vm._v("% Apply coupon")]),_vm._v(" "),_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 pad-bt-15 pad-to-15"},[_c('a',{staticClass:"btn btn-info",attrs:{"href":"","title":"Save"}},[_vm._v(" Update Order")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h3vL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GroupForm_vue__ = __webpack_require__("L8oI");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GroupForm', __WEBPACK_IMPORTED_MODULE_7__GroupForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      offerModel: {},
      offer: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onOfferSubmit: function onOfferSubmit(model, isValid) {
      this.offerModel = model;
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "h4VG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('p'),_vm._v(" "),_c('kds-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h6uT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h7fB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hASK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-switch',
  props: {
    label: String,
    value: [Array, Boolean, Number],
    disabled: [Boolean, String],
    onText: String,
    offText: String,
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    switchClass: function switchClass() {
      var base = 'bootstrap-switch-';
      var state = this.model ? 'on' : 'off';
      return base + state;
    },

    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    triggerToggle: function triggerToggle() {
      this.model = !this.model;
    }
  }
});

/***/ }),

/***/ "hAyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group",staticStyle:{"display":"grid","margin-top":"15px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.series')))]),_vm._v(" "),_c('el-input',{ref:"seriesInput",attrs:{"disabled":_vm.loading,"placeholder":"Introdu seria facturii"},on:{"input":_vm.onSeriesInput},model:{value:(_vm.filter.series),callback:function ($$v) {_vm.$set(_vm.filter, "series", $$v)},expression:"filter.series"}})],1)]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.addInvoice($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('gestiune.addAviz'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"prop":"invoiceNumber","label":_vm.$t('invoice.invoice')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"series","label":_vm.$t('invoice.series')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"client","label":_vm.$t('invoice.client')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"issueDate","label":_vm.$t('invoice.issueDate'),"formatter":_vm.formatDate}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valueNoVAT","label":_vm.$t('invoice.valueNoVAT')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vatValue","label":_vm.$t('invoice.vatValue')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalValue","label":_vm.$t('invoice.totalValue')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('invoice.status')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                        ▾ ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editInvoice(scope.row.invoiceNumber, scope.row.series)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('general.edit'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.invoice(scope.row.invoiceNumber, scope.row.series)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('invoice.invoiced'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadInvoice(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('invoice.download'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadExcel(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('gestiune.downloadExcel'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},attrs:{"disabled":scope.$index !== 0},nativeOn:{"click":function($event){scope.$index === 0 && _vm.handleDeleteInvoice(scope.row.id)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('general.delete'))+"\n                        ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hFMe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NomenclatorProducts_vue__ = __webpack_require__("nAPq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63db4213_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NomenclatorProducts_vue__ = __webpack_require__("L5Y3");
function injectStyle (ssrContext) {
  __webpack_require__("w8qs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63db4213"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NomenclatorProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63db4213_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NomenclatorProducts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hHSX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hI5E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 344.4 326"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 344.4 326","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_1_","x":"7.2","y":"143.4","width":"142.7","height":"142.7"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_3_","x":"24.1","y":"159.7","transform":"matrix(0.8755 -0.4832 0.4832 0.8755 -93.7626 64.7036)","width":"109.1","height":"109.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s6_5_","d":"M12.4,188.6l79.8-44c4.3-2.4,9.8-0.8,12.2,3.5l44,79.8c2.4,4.3,0.8,9.8-3.5,12.2l-79.8,44\n                c-4.3,2.4-9.8,0.8-12.2-3.5l-44-79.8C6.5,196.4,8.1,191,12.4,188.6z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{staticClass:"st3",attrs:{"d":"M4.5,192.9l95.6-52.7l52.7,95.6l-95.6,52.7L4.5,192.9z"}})])])])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_7_","x":"189.9","y":"150","width":"145.3","height":"145.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_9_","x":"207.9","y":"168.4","transform":"matrix(0.5944 -0.8042 0.8042 0.5944 -72.5461 301.5003)","width":"109.4","height":"108.5"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s6_11_","d":"M191.8,227.2l54.2-73.3c3-4,8.6-4.8,12.6-1.9l72.8,53.8c4,3,4.8,8.6,1.9,12.6l-54.2,73.3\n                c-3,4-8.6,4.8-12.6,1.9l-72.8-53.8C189.7,236.8,188.9,231.2,191.8,227.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st3",attrs:{"d":"M186.5,234.4l64.8-87.6l87.3,64.5l-64.8,87.6L186.5,234.4z"}})])])])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_13_","x":"113.9","y":"212.7","width":"113.3","height":"113.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_15_","x":"116.1","y":"214.9","transform":"matrix(3.150407e-02 -0.9995 0.9995 3.150407e-02 -104.2986 431.4664)","width":"108.9","height":"109.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s6_17_","d":"M126.6,213.7l91.1,2.9c5,0.2,8.9,4.3,8.7,9.3l-2.9,90.8c-0.2,5-4.3,8.9-9.3,8.7l-91.1-2.9\n                c-5-0.2-8.9-4.3-8.7-9.3l2.9-90.8C117.5,217.5,121.6,213.6,126.6,213.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('path',{staticClass:"st3",attrs:{"d":"M117.6,213.4l109.2,3.4l-3.4,108.8l-109.2-3.4L117.6,213.4z"}})])])])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_19_","x":"115.8","width":"109.6","height":"109.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s6_21_","d":"M115.8,100.1V9c0-5,4-9,9-9h91.3c5,0,9,4,9,9v91.1c0,5-4,9-9,9h-91.3\n            C119.8,109.1,115.8,105.1,115.8,100.1z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('path',{staticClass:"st3",attrs:{"d":"M115.8,109.1V0h109.1v109.1H115.8z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_23_","x":"201.9","y":"43.4","width":"140","height":"140"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_25_","x":"217.7","y":"59.1","transform":"matrix(0.9116 -0.411 0.411 0.9116 -22.6774 121.9436)","width":"109.1","height":"109.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st13"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s6_27_","d":"M208.3,82.7l83.1-37.5c4.5-2,9.9,0,11.9,4.5l37.5,83.1c2,4.5,0,9.9-4.5,11.9l-83.1,37.5\n                c-4.5,2-9.9,0-11.9-4.5l-37.5-83.1C201.7,90.1,203.8,84.7,208.3,82.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('path',{staticClass:"st3",attrs:{"d":"M200.1,86.4l99.5-44.9l44.9,99.5l-99.5,44.8L200.1,86.4z"}})])])])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_29_","x":"111.8","y":"97.4","width":"129.8","height":"129.8"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_30_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_29_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s6_31_","d":"M111.8,218.2V106.4c0-5,4-9,9-9h111.8c5,0,9,4,9,9v111.8c0,5-4,9-9,9H120.8\n            C115.8,227.2,111.8,223.2,111.8,218.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_32_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_31_"}})]),_vm._v(" "),_c('g',{staticClass:"st16"},[_c('path',{staticClass:"st3",attrs:{"d":"M111.8,227.2V97.4h129.8v129.8H111.8z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_33_","x":"1.9","y":"43.4","width":"141.3","height":"141.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_34_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_33_"}})]),_vm._v(" "),_c('g',{staticClass:"st17"},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_35_","x":"18.5","y":"59","transform":"matrix(0.4365 -0.8997 0.8997 0.4365 -61.1631 129.8804)","width":"109.1","height":"109.6"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_36_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_35_"}})]),_vm._v(" "),_c('g',{staticClass:"st18"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s6_37_","d":"M3.9,130.9l39.8-82c2.2-4.5,7.6-6.3,12-4.2l82.1,39.8c4.5,2.2,6.3,7.6,4.2,12l-39.8,82\n                c-2.2,4.5-7.6,6.3-12,4.2L8.1,142.9C3.6,140.7,1.8,135.3,3.9,130.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_38_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_37_"}})]),_vm._v(" "),_c('g',{staticClass:"st19"},[_c('path',{staticClass:"st3",attrs:{"d":"M0,139l47.6-98.2l98.2,47.6l-47.6,98.2L0,139z"}})])])])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_39_","x":"27.8","y":"17.3","width":"290","height":"290"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_40_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_39_"}})]),_vm._v(" "),_c('g',{staticClass:"st20"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"s6_41_","cx":"172.8","cy":"162.3","r":"145"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_42_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_41_"}})]),_vm._v(" "),_c('g',{staticClass:"st21"},[_c('path',{staticClass:"st22",attrs:{"d":"M27.8,17.3h290v290h-290V17.3z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s6_43_","x":"87.1","y":"75.6","width":"171.5","height":"171.5"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_44_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_43_"}})]),_vm._v(" "),_c('g',{staticClass:"st23"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s6_45_","d":"M172.8,75.6c-47.3,0-85.7,38.4-85.7,85.7s38.4,85.7,85.7,85.7c47.3,0,85.7-38.4,85.7-85.7\n            S220.2,75.6,172.8,75.6z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s6_46_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s6_45_"}})]),_vm._v(" "),_c('g',{staticClass:"st24"},[_c('path',{staticClass:"st3",attrs:{"d":"M87.1,75.6h171.5v171.5H87.1V75.6z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hINz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:" nav-mobile-menu"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hJZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");







__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      model: {
        email: '',
        password: '',
        company_id: 8
      },
      modelValidations: {
        email: {
          required: true,
          email: true,
          min: 4
        },
        password: {
          required: true,
          min: 6
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* mapFields */])(['email', 'password'])),
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.login();
      });
    },
    login: function login() {
      var self = this;
      var creds = {
        email: this.model.email,
        password: this.model.password
      };

      this.apiRequest('/auth', 'POST', creds, function (response) {
        if (response.status === true) {
          var usersCompanies = [];
          var hasCompany = false;
          var companies = response.data.user.companies;
          for (var key in companies) {
            if (companies[key].role === 'MARKETER' || companies[key].role === 'OPERATOR' || companies[key].role === 'OWNER' || companies[key].role === 'USER' || companies[key].role === 'LOCATION_ADMIN' || companies[key].role === 'USER_CUSTOM' || companies[key].role === 'LOCATION_STORE_ADMIN') {
              usersCompanies.push(companies[key]);
              hasCompany = true;
            }
          }

          if (!hasCompany) {
            self.errors.add('email', 'Failed to login, please try again.');
          } else {
            self.$session.start();
            self.$session.set('token', response.data.token);
            if (usersCompanies[0].id) {
              self.$session.set('selectedCompany', usersCompanies[0].id);
              self.$session.set('selectedCompanyData', self.buildCompanySessionData(usersCompanies[0], {}));
              self.$session.set('companyName', usersCompanies[0].name);
              self.$session.set('companyAvatar', response.data.user.avatar);
            } else {
              self.$session.set('selectedCompany', null);
              self.$session.set('selectedCompanyData', null);
              self.$session.set('companyName', null);
              self.$session.set('companyAvatar', null);
              self.$session.set('companyAvatar', null);
            }

            self.$cookie.set('filter-locations', '');

            self.$session.set('userData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.user));
            self.$session.set('userDataLocations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.user.locations));
            self.$session.set('userDataRole', response.data.user.role);
            self.$i18n.locale = response.data.user.language;
            self.initAuditClient();

            var selectedCompanyId = usersCompanies[0].id;
            self.apiRequest('/listdefaults', 'GET', { token: response.data.token, company_id: selectedCompanyId }, function (response2) {
              if (response2.status === true) {
                self.$session.set('defaultData', response2.data[0]);
                var companyData = self.$session.get('selectedCompanyData') || {};
                companyData.has_charisma_location = !!response2.data[0].has_charisma_location;
                companyData.has_nexus_location = !!response2.data[0].has_nexus_location;
                self.$session.set('selectedCompanyData', companyData);
              }
              self.initAuditClient();
              if (self.$session.get('userDataRole') === 'USER') {
                self.$router.push('/orders');
              } else {
                if (self.$session.get('userDataRole') === 'MARKETER') {
                  self.$router.push('/products');
                } else {
                  self.$router.push('/');
                }
              }
            });
          }
        } else {
          for (var prop in response.errors) {
            if (response.errors.hasOwnProperty(prop)) {
              self.errors.add({ field: prop, msg: response.errors[prop] });
            }
          }
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "hLvh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hMIh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hMue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      loading: false,
      tableData: [],
      campaignId: null,
      pageTitle: ''
    };
  },
  created: function created() {
    this.campaignId = this.route.params && this.route.params.campaignId || this.$route.params && this.$route.params.campaignId;
    this.pageTitle = this.$route.query && this.$route.query.title || this.$t('spinningWheel.rewards');
    this.loadReport();
  },

  methods: {
    back: function back() {
      this.$bus.$emit('refresh-spinning-wheel-report');
      this.$bus.$emit('close-modal');
    },
    loadReport: function loadReport() {
      var _this = this;

      if (!this.campaignId) return;
      this.loading = true;
      var params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      var q = this.$route.query || {};
      if (q.date_from) params.date_from = q.date_from;
      if (q.date_to) params.date_to = q.date_to;
      this.apiRequest('/reports/spinning-wheel/' + this.campaignId + '/rewards', 'GET', params, function (response) {
        _this.loading = false;
        if (response.status && response.data) {
          _this.tableData = response.data.rewards || [];
          if (response.data.campaign && response.data.campaign.title) {
            _this.pageTitle = response.data.campaign.title;
          }
        } else {
          _this.tableData = [];
        }
      });
    },
    onRowClick: function onRowClick(row) {
      if (!row || !row.id) return;
      var q = this.$route.query || {};
      this.$router.push({
        path: '/reports/spinning-wheel/rewards/' + row.id + '/users',
        query: {
          title: row.name || '#' + row.id,
          date_from: q.date_from || '',
          date_to: q.date_to || '',
          campaign_id: this.campaignId
        }
      });
    }
  }
});

/***/ }),

/***/ "hPfU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hQuq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomInfoPages_vue__ = __webpack_require__("qQTJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c912cd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomInfoPages_vue__ = __webpack_require__("dxYK");
function injectStyle (ssrContext) {
  __webpack_require__("daN/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomInfoPages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c912cd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomInfoPages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hZ/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      model: {
        email: ''
      },
      modelValidations: {
        email: {
          required: true,
          email: true,
          min: 4
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email'])),
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.recover();
        }
      });
    },
    recover: function recover() {
      var self = this;
      var creds = {
        email: this.model.email,
        company_id: -1
      };

      this.apiRequest('/recover', 'POST', creds, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('', response.data['message'] ? response.data['message'] : 'Please check your email adreess to get the reset code.', 'success').catch({});

          self.$router.push('/reset');
        } else {
          for (var prop in response.errors) {
            if (response.errors.hasOwnProperty(prop)) {
              self.errors.add(prop, response.errors[prop]);
            }
          }
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "haYA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AvailableDaysSchedule',
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_select___default.a),
  props: {
    availableDays: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    namePrefix: {
      type: String,
      default: 'schedule-'
    }
  },
  data: function data() {
    return {
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '24:00'
      }
    };
  },

  methods: {
    addInterval: function addInterval(dayIdx) {
      var day = this.availableDays[dayIdx];
      if (!day) return;
      if (!day.hasOwnProperty('intervals')) {
        __WEBPACK_IMPORTED_MODULE_4_vue___default.a.set(day, 'intervals', []);
      }
      var index = day.intervals.length;
      __WEBPACK_IMPORTED_MODULE_4_vue___default.a.set(day.intervals, index, {
        open_from: '',
        open_to: ''
      });
    },
    deleteInterval: function deleteInterval(dayIdx, intervalKey) {
      var day = this.availableDays[dayIdx];
      if (!day || !day.intervals) return;
      day.intervals.splice(intervalKey, 1);
    }
  }
});

/***/ }),

/***/ "hbV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyInfo_vue__ = __webpack_require__("fRB1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a9416b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyInfo_vue__ = __webpack_require__("Qf2k");
function injectStyle (ssrContext) {
  __webpack_require__("YrdT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31a9416b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a9416b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hbtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"delivery-tax-panel"},[_c('header',{staticClass:"delivery-tax-panel__header"},[_c('div',[_c('h5',[_vm._v("Taxe de livrare aplicate")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.deliveryRangeId ? 'Taxele de mai jos se aplică acestei zone.' : 'Taxele de mai jos se aplică acestei locații.'))])]),_vm._v(" "),_c('div',{staticClass:"delivery-tax-panel__actions"},[(_vm.deliveryRangeId)?_c('button',{staticClass:"delivery-tax-action is-secondary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openAssignment($event)}}},[_c('i',{staticClass:"ti-link"}),_vm._v(" Atribuie taxe existente")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"delivery-tax-action",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openCreate($event)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Creează taxă")])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"delivery-tax-empty"},[_vm._v("Se încarcă taxele...")]):(!_vm.appliedTaxes.length)?_c('div',{staticClass:"delivery-tax-empty"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n    Nu există taxe de livrare aplicate. Până la configurarea primei taxe, costul vechi rămâne activ pentru compatibilitate.\n  ")]):_c('div',{staticClass:"delivery-tax-list"},_vm._l((_vm.appliedTaxes),function(tax){return _c('article',{key:tax.id,staticClass:"delivery-tax-row"},[_c('div',{staticClass:"delivery-tax-row__title"},[_c('strong',[_vm._v(_vm._s(tax.name))]),_vm._v(" "),_c('span',{class:tax.is_active ? 'is-active' : 'is-inactive'},[_vm._v(_vm._s(tax.is_active ? 'Activă' : 'Inactivă'))])]),_vm._v(" "),_c('div',{staticClass:"delivery-tax-row__details"},[_c('span',[_c('small',[_vm._v("Cost standard")]),_c('b',[_vm._v(_vm._s(_vm.money(tax.value))+" "+_vm._s(_vm.currency))])]),_vm._v(" "),_c('span',[_c('small',[_vm._v("TVA")]),_c('b',[_vm._v(_vm._s(tax.vat_rate ? _vm.rate(tax.vat_rate.rate) + '%' : '-'))])]),_vm._v(" "),_c('span',[_c('small',[_vm._v("POS ID")]),_c('b',[_vm._v(_vm._s(tax.pos_id || '-'))])]),_vm._v(" "),_c('span',[_c('small',[_vm._v("Intervale")]),_c('b',[_vm._v(_vm._s((tax.delivery_cost_ranges || []).length))])])]),_vm._v(" "),_c('button',{staticClass:"delivery-tax-edit",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.openEdit(tax)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Editează")])])})),_vm._v(" "),(_vm.assignmentOpen)?_c('div',{ref:"assignmentEditor",staticClass:"delivery-tax-editor",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeAssignment($event)}}},[_c('div',{staticClass:"delivery-tax-editor__page delivery-tax-assignment-page"},[_c('header',{staticClass:"delivery-tax-editor__topbar"},[_c('div',{staticClass:"delivery-tax-editor__heading"},[_c('button',{staticClass:"delivery-tax-back",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closeAssignment($event)}}},[_c('i',{staticClass:"ti-close"}),_vm._v(" Renunță")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('button',{staticClass:"delivery-tax-save",attrs:{"type":"button","disabled":_vm.assigning || !_vm.selectedExistingTaxIds.length},on:{"click":function($event){$event.preventDefault();return _vm.assignExistingTaxes($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v(_vm._s(_vm.assigning ? 'Se salvează...' : 'Atribuie'))])]),_vm._v(" "),_c('main',{staticClass:"delivery-tax-editor__body"},[_c('section',{staticClass:"delivery-tax-editor__section"},[_vm._m(1),_vm._v(" "),(!_vm.assignableTaxes.length)?_c('div',{staticClass:"delivery-tax-empty"},[_vm._v("Toate taxele de livrare existente se aplică deja acestei zone.")]):_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Taxe de livrare")]),_vm._v(" "),_c('el-select',{staticClass:"delivery-tax-select",attrs:{"multiple":"","filterable":"","collapse-tags":"","clearable":"","placeholder":"Selectează taxele"},model:{value:(_vm.selectedExistingTaxIds),callback:function ($$v) {_vm.selectedExistingTaxIds=$$v},expression:"selectedExistingTaxIds"}},_vm._l((_vm.assignableTaxes),function(tax){return _c('el-option',{key:tax.id,attrs:{"label":_vm.existingTaxLabel(tax),"value":tax.id}})})),_vm._v(" "),_c('small',{staticClass:"delivery-tax-field-hint"},[_vm._v("Poți selecta mai multe taxe. Taxele inactive rămân inactive după atribuire.")])],1)])])])]):_vm._e(),_vm._v(" "),(_vm.editorOpen)?_c('div',{ref:"editor",staticClass:"delivery-tax-editor",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeEditor($event)}}},[_c('div',{staticClass:"delivery-tax-editor__page"},[_c('header',{staticClass:"delivery-tax-editor__topbar"},[_c('div',{staticClass:"delivery-tax-editor__heading"},[_c('button',{staticClass:"delivery-tax-back",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.closeEditor($event)}}},[_c('i',{staticClass:"ti-close"}),_vm._v(" Renunță")]),_vm._v(" "),_c('div',[_c('h3',[_vm._v(_vm._s(_vm.form.id ? _vm.form.name : 'Adaugă taxă de livrare'))]),_c('p',[_vm._v(_vm._s(_vm.deliveryRangeId ? 'Aplicabilitate: zona curentă' : 'Aplicabilitate: locația curentă'))])])]),_vm._v(" "),_c('button',{staticClass:"delivery-tax-save",attrs:{"type":"button","disabled":_vm.saving || _vm.editorLoading},on:{"click":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v(_vm._s(_vm.saving ? 'Se salvează...' : 'Salvează'))])]),_vm._v(" "),(_vm.editorLoading)?_c('div',{staticClass:"delivery-tax-editor__loading"},[_vm._v("Se încarcă taxa...")]):_c('main',{staticClass:"delivery-tax-editor__body"},[_c('section',{staticClass:"delivery-tax-editor__section"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"delivery-tax-form-grid"},[_c('div',{staticClass:"form-group is-wide"},[_c('label',[_vm._v("Nume taxă")]),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.name),expression:"form.name",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Ex: Livrare"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cost livrare (lei)")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.form.value),expression:"form.value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(_vm.form.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "value", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("TVA obligatoriu")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.vat_rate_id),expression:"form.vat_rate_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "vat_rate_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează TVA")]),_vm._l((_vm.selectableVatRates),function(vat){return _c('option',{key:vat.id,attrs:{"disabled":!vat.is_active},domProps:{"value":vat.id}},[_vm._v(_vm._s(_vm.rate(vat.rate))+"%"+_vm._s(vat.is_active ? '' : ' (inactiv)'))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("POS ID pentru cost livrare")]),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.pos_id),expression:"form.pos_id",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Opțional"},domProps:{"value":(_vm.form.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "pos_id", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Surse")]),_c('el-select',{staticClass:"delivery-tax-select",attrs:{"multiple":"","filterable":"","collapse-tags":"","clearable":"","placeholder":"Toate sursele"},model:{value:(_vm.form.source_ids),callback:function ($$v) {_vm.$set(_vm.form, "source_ids", $$v)},expression:"form.source_ids"}},_vm._l((_vm.sources),function(source){return _c('el-option',{key:source.id,attrs:{"label":source.name,"value":source.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Stare")]),_c('label',{staticClass:"delivery-tax-switch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.is_active),expression:"form.is_active"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.is_active)?_vm._i(_vm.form.is_active,null)>-1:(_vm.form.is_active)},on:{"change":function($event){var $$a=_vm.form.is_active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "is_active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "is_active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "is_active", $$c)}}}}),_c('span'),_c('b',[_vm._v(_vm._s(_vm.form.is_active ? 'Activă' : 'Inactivă'))])])])])]),_vm._v(" "),_c('section',{staticClass:"delivery-tax-editor__section"},[_c('div',{staticClass:"delivery-tax-editor__section-title with-action"},[_vm._m(3),_vm._v(" "),_c('button',{staticClass:"delivery-tax-action",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addCostRange($event)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Adaugă interval")])]),_vm._v(" "),_vm._m(4),_vm._v(" "),(!_vm.form.delivery_cost_ranges.length)?_c('div',{staticClass:"delivery-tax-empty"},[_vm._v("Nu există intervale suplimentare.")]):_vm._e(),_vm._v(" "),_vm._l((_vm.form.delivery_cost_ranges),function(rangeItem,index){return _c('article',{key:rangeItem.id || 'range-' + index,staticClass:"delivery-tax-range"},[_c('div',{staticClass:"delivery-tax-range__header"},[_c('strong',[_vm._v("Interval "+_vm._s(index + 1))]),_c('button',{attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.removeCostRange(index)}}},[_c('i',{staticClass:"ti-trash"}),_vm._v(" Șterge")])]),_vm._v(" "),_c('div',{staticClass:"delivery-tax-form-grid range-grid"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Distanță până la (km)")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(rangeItem.distance_in_km),expression:"rangeItem.distance_in_km",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(rangeItem.distance_in_km)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(rangeItem, "distance_in_km", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cost (lei)")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(rangeItem.shipping_cost),expression:"rangeItem.shipping_cost",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(rangeItem.shipping_cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(rangeItem, "shipping_cost", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("POS ID")]),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(rangeItem.pos_id),expression:"rangeItem.pos_id",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Moștenește valoarea standard"},domProps:{"value":(rangeItem.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(rangeItem, "pos_id", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Comandă minimă (lei)")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(rangeItem.min_order_value),expression:"rangeItem.min_order_value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(rangeItem.min_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(rangeItem, "min_order_value", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Timp extra (minute)")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(rangeItem.extra_delivery_time),expression:"rangeItem.extra_delivery_time",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"1"},domProps:{"value":(rangeItem.extra_delivery_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(rangeItem, "extra_delivery_time", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])])])})],2)])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Atribuie taxe existente")]),_c('p',[_vm._v("Selectează una sau mai multe taxe de livrare pentru zona curentă.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delivery-tax-editor__section-title"},[_c('h4',[_vm._v("Taxe disponibile")]),_c('p',[_vm._v("Detaliile taxelor rămân neschimbate. Se adaugă numai această zonă în aplicabilitatea lor.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delivery-tax-editor__section-title"},[_c('h4',[_vm._v("Detalii taxă")]),_c('p',[_vm._v("Taxa va apărea ca linie separată în coș și pe comandă.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Extra Cost Range")]),_c('p',[_vm._v("Costuri diferențiate în funcție de distanță și valoarea minimă a comenzii.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delivery-tax-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_c('span',[_c('strong',[_vm._v("Intervalele se aplică doar dacă locația are cheia Google Maps configurată.")]),_vm._v(" Altfel se folosește costul standard.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hcPu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInventoryEdit_vue__ = __webpack_require__("kQxY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b8dd4b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInventoryEdit_vue__ = __webpack_require__("JMkg");
function injectStyle (ssrContext) {
  __webpack_require__("VSbs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b8dd4b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInventoryEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b8dd4b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInventoryEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hcjE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row discount-campaigns"},[_c('div',{staticClass:"col-xl-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-start","gap":"10px","flex-wrap":"wrap"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px","align-items":"flex-end","flex":"1 1 auto"}},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"1 1 200px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('discountCampaigns.search')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('discountCampaigns.search'),"size":"small","clearable":""},on:{"input":_vm.onInput},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},on:{"click":_vm.applyFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right-group",staticStyle:{"flex":"0 0 auto","margin-bottom":"20px"}},[_c('button',{staticClass:"btn add",staticStyle:{"font-size":"12px","padding":"4px 8px"},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-sm.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('discountCampaigns.single'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"data-table",staticStyle:{"margin-top":"20px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"row-class-name":_vm.rowClass,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.onRowClick}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('discountCampaigns.id'),"width":"70"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('discountCampaigns.name'),"min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('discountCampaigns.discount'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatDiscount(props.row))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('discountCampaigns.priceProfile'),"min-width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.priceProfileName(props.row))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('discountCampaigns.sourceMethodCombos'),"min-width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.combosList.full.length)?_c('div',{staticClass:"truncated-cell"},[_c('span',{staticClass:"truncated-cell__text"},[_vm._v(_vm._s(props.row.combosList.visible.join(', ')))]),_vm._v(" "),(props.row.combosList.restCount)?_c('el-tooltip',{attrs:{"placement":"top","effect":"dark","open-delay":200}},[_c('div',{staticClass:"truncated-cell__tooltip",attrs:{"slot":"content"},slot:"content"},_vm._l((props.row.combosList.full),function(label,index){return _c('div',{key:index},[_vm._v(_vm._s(label))])})),_vm._v(" "),_c('span',{staticClass:"truncated-cell__more"},[_vm._v("+"+_vm._s(props.row.combosList.restCount))])]):_vm._e()],1):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('discountCampaigns.startEnd'),"min-width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatDate(props.row.start_date))+" - "+_vm._s(_vm.formatDate(props.row.end_date))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('discountCampaigns.products'),"min-width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.productsList.full.length)?_c('div',{staticClass:"truncated-cell"},[_c('span',{staticClass:"truncated-cell__text"},[_vm._v(_vm._s(props.row.productsList.visible.join(', ')))]),_vm._v(" "),(props.row.productsList.restCount)?_c('el-tooltip',{attrs:{"placement":"top","effect":"dark","open-delay":200}},[_c('div',{staticClass:"truncated-cell__tooltip",attrs:{"slot":"content"},slot:"content"},_vm._l((props.row.productsList.full),function(label,index){return _c('div',{key:index},[_vm._v(_vm._s(label))])})),_vm._v(" "),_c('span',{staticClass:"truncated-cell__more"},[_vm._v("+"+_vm._s(props.row.productsList.restCount))])]):_vm._e()],1):_c('span',[_vm._v(_vm._s(_vm.productsCountFallback(props.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.active'),"width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(scope.$index, scope.row, $event)}},model:{value:(scope.row.active),callback:function ($$v) {_vm.$set(scope.row, "active", $$v)},expression:"scope.row.active"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.goToRecord(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.edit'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.handleDelete(scope.$index, scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"current-page":_vm.paginationDef.page},on:{"update:currentPage":function($event){_vm.$set(_vm.paginationDef, "page", $event)},"current-change":_vm.handlePageChange}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hdtC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row delivery-hero-integration-form"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"delivery-hero-integration-form__setup",attrs:{"role":"status"}},[_c('p',{staticClass:"delivery-hero-integration-form__setup-title"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroSetupTitle')))]),_vm._v(" "),_c('ol',{staticClass:"delivery-hero-integration-form__setup-steps"},[_c('li',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroSetupStep1')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroSetupStep2')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroSetupStep3')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroSetupStep4')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('location_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('location_id'))),(_vm.isRequired('location_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.location_id),expression:"formData.location_id"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'delivery-hero-loc-' + String(loc._integrationLocationId),class:{ 'integration-location-option--occupied': _vm.isLocationOccupied(loc._integrationLocationId) },attrs:{"disabled":_vm.isLocationOccupied(loc._integrationLocationId)},domProps:{"value":loc._integrationLocationId}},[_vm._v("\n          "+_vm._s(_vm.locationOptionLabel(loc))+"\n        ")])})],2),_vm._v(" "),(_vm.showFieldError('location_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('location_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('api_url') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('api_url'))),(_vm.isRequired('api_url'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.api_url),expression:"formData.api_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.api_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "api_url", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('api_url'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('api_url')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group delivery-hero-integration-form__switch-row"},[_c('label',{staticClass:"delivery-hero-integration-form__switch-label"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"delivery-hero-integration-form__switch-control"},[_c('p-switch',{staticClass:"mar-bt-0",attrs:{"type":"success","name":"delivery-hero-active","disabled":_vm.disabled},model:{value:(_vm.formData.active),callback:function ($$v) {_vm.$set(_vm.formData, "active", $$v)},expression:"formData.active"}}),_vm._v(" "),_c('label',{attrs:{"for":"delivery-hero-active"}},[_vm._v(_vm._s(_vm.fieldLabel('active')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"delivery-hero-integration-form__keys"},[_c('p',{staticClass:"delivery-hero-integration-form__keys-title"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroKeysTitle')))]),_vm._v(" "),(!_vm.formData.public_key)?_c('p',{staticClass:"help-block text-muted"},[_vm._v("\n        "+_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroKeysPending'))+"\n      ")]):_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('public_key')))]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"rows":"6","readonly":""},domProps:{"value":_vm.formData.public_key}}),_vm._v(" "),_c('div',{staticClass:"delivery-hero-integration-form__key-actions"},[_c('button',{staticClass:"btn btn-info btn-sm delivery-hero-integration-form__key-btn",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.copyPublicKey($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroCopyPublicKey'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm delivery-hero-integration-form__key-btn",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.downloadPublicKey($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroDownloadPublicKey'))+"\n          ")]),_vm._v(" "),(_vm.canRegenerateKeys)?_c('button',{staticClass:"btn btn-warning btn-sm delivery-hero-integration-form__key-btn",attrs:{"type":"button","disabled":_vm.disabled || _vm.regeneratingKeys},on:{"click":function($event){$event.preventDefault();_vm.$emit('regenerate-keys')}}},[_vm._v("\n            "+_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroRegenerateKeys'))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('small',{staticClass:"help-block text-muted"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroPublicKeyHint')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"delivery-hero-integration-form__section-title"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroCredentialsTitle')))]),_vm._v(" "),_c('p',{staticClass:"help-block text-muted mar-bt-10"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroCredentialsHint')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('client_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('client_id'))),(_vm.isRequired('client_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.client_id),expression:"formData.client_id"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.client_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "client_id", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('client_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('client_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('key_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('key_id'))),(_vm.isRequired('key_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.key_id),expression:"formData.key_id"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.key_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "key_id", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('key_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('key_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('scope') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('scope'))),(_vm.isRequired('scope'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.scope),expression:"formData.scope"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.$t('gestiune.integrationsDeliveryHeroScopePlaceholder')},domProps:{"value":(_vm.formData.scope)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "scope", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('scope'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('scope')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('webhook_secret') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('webhook_secret')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.webhook_secret),expression:"formData.webhook_secret"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.webhook_secret)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "webhook_secret", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('webhook_secret'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('webhook_secret')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"delivery-hero-integration-form__auto-send-row"},[_c('div',{staticClass:"delivery-hero-integration-form__auto-send-status"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('auto_send_at_status') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('auto_send_at_status')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.auto_send_at_status),expression:"formData.auto_send_at_status"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "auto_send_at_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.autoSendStatusOptions),function(opt){return _c('option',{key:'delivery-hero-status-' + opt.value,domProps:{"value":opt.value}},[_vm._v("\n              "+_vm._s(opt.label)+"\n            ")])})),_vm._v(" "),(_vm.showFieldError('auto_send_at_status'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('auto_send_at_status')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"delivery-hero-integration-form__auto-send-time"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('auto_send_time') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('auto_send_time')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.auto_send_time),expression:"formData.auto_send_time"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled || _vm.isAutoSendManual},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "auto_send_time", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.autoSendTimeOptions),function(mins){return _c('option',{key:'delivery-hero-time-' + mins,domProps:{"value":mins}},[_vm._v("\n              "+_vm._s(mins)+"\n            ")])})),_vm._v(" "),(_vm.showFieldError('auto_send_time'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('auto_send_time')))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('feedback_emails') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('feedback_emails')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.feedback_emails),expression:"formData.feedback_emails"}],staticClass:"form-control",attrs:{"rows":"3","disabled":_vm.disabled,"placeholder":_vm.$t('gestiune.integrationsFeedbackEmailsHint')},domProps:{"value":(_vm.formData.feedback_emails)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "feedback_emails", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"help-block text-muted"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsFeedbackEmailsHint')))]),_vm._v(" "),(_vm.showFieldError('feedback_emails'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('feedback_emails')))]):_vm._e()])]),_vm._v(" "),(_vm.formData.status_callback_url || _vm.formData.refund_callback_url)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"delivery-hero-integration-form__callbacks"},[_c('p',{staticClass:"delivery-hero-integration-form__callbacks-title"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroCallbacksTitle')))]),_vm._v(" "),(_vm.formData.status_callback_url)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroStatusCallback')))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.formData.status_callback_url}})]):_vm._e(),_vm._v(" "),(_vm.formData.refund_callback_url)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroRefundCallback')))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.formData.refund_callback_url}})]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"help-block text-muted"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsDeliveryHeroCallbacksHint')))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hfzk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: { type: Object, default: null },
    posOptions: { type: Array, required: true },
    errorBag: { type: Object, default: null },
    legacyBankProvider: { type: String, default: null }
  },
  data: function data() {
    return {
      modes: ['online', 'offline'],
      terminalFields: [{ key: 'integrated_bank_pos_server_ip', label: 'settingTable.server_ip' }, { key: 'integrated_bank_pos_host', label: 'settingTable.host' }, { key: 'integrated_bank_pos_port', label: 'settingTable.terminal_port' }, { key: 'integrated_bank_pos_tid_mid', label: 'TID/MID' }]
    };
  },

  methods: {
    fieldErrors: function fieldErrors(mode, field) {
      var index = this.entries(mode).findIndex(function (entry) {
        return entry.type === 'CARD_POS';
      });
      var path = 'qr_payment_methods.' + mode + '.' + index + '.data.' + field;
      return (this.errorBag && this.errorBag.items ? this.errorBag.items : []).filter(function (item) {
        return item.field === path;
      }).map(function (item) {
        return item.msg;
      });
    },
    modeErrors: function modeErrors(mode) {
      var handled = this.mobileConnection(mode) === 'DIRECT' ? ['integrated_bank_pos_id'].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.terminalFields.map(function (field) {
        return field.key;
      }))) : ['bank_terminal_provider'];
      var index = this.entries(mode).findIndex(function (entry) {
        return entry.type === 'CARD_POS';
      });
      var prefix = 'qr_payment_methods.' + mode;
      return (this.errorBag && this.errorBag.items ? this.errorBag.items : []).filter(function (item) {
        return item.field && (item.field === prefix || item.field.indexOf(prefix + '.') === 0 || mode === 'online' && item.field === 'qr_payment_methods');
      }).filter(function (item) {
        return !handled.some(function (field) {
          return item.field === prefix + '.' + index + '.data.' + field;
        });
      }).map(function (item) {
        return item.msg;
      });
    },
    isMobileSelected: function isMobileSelected(mode) {
      return this.isSelected(mode, 'CARD_POS');
    },
    toggleMobile: function toggleMobile(mode, selected) {
      this.toggleMethod(mode, 'CARD_POS', selected);
    },
    mobileConnection: function mobileConnection(mode) {
      var entry = this.entries(mode).find(function (entry) {
        return entry.type === 'CARD_POS';
      });
      return entry ? entry.data && entry.data.connection_type || 'NFC' : null;
    },
    setMobileConnection: function setMobileConnection(mode, connection) {
      var settings = this.copySettings();
      var entry = settings[mode].find(function (entry) {
        return entry.type === 'CARD_POS';
      });
      if (!entry || this.mobileConnection(mode) === connection) return;
      entry.data = connection === 'DIRECT' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ connection_type: 'DIRECT' }, this.emptyTerminalData()) : { connection_type: 'NFC', bank_terminal_provider: this.legacyBankProvider };
      this.$emit('input', settings);
    },
    nfcProvider: function nfcProvider(mode) {
      var entry = this.entries(mode).find(function (entry) {
        return entry.type === 'CARD_POS';
      });
      if (!entry) return null;
      return entry.data ? entry.data.bank_terminal_provider : this.legacyBankProvider;
    },
    setNfcProvider: function setNfcProvider(mode, provider) {
      var settings = this.copySettings();
      var entry = settings[mode].find(function (entry) {
        return entry.type === 'CARD_POS';
      });
      if (!entry) return;
      entry.data = { connection_type: 'NFC', bank_terminal_provider: provider || null };
      this.$emit('input', settings);
    },
    entries: function entries(mode) {
      return this.value && Array.isArray(this.value[mode]) ? this.value[mode] : [];
    },
    isSelected: function isSelected(mode, type) {
      return this.entries(mode).some(function (entry) {
        return entry.type === type;
      });
    },
    emptyTerminalData: function emptyTerminalData() {
      return {
        integrated_bank_pos_id: null,
        integrated_bank_pos_name: null,
        integrated_bank_pos_server_ip: null,
        integrated_bank_pos_host: null,
        integrated_bank_pos_port: null,
        integrated_bank_pos_tid_mid: null
      };
    },
    terminalData: function terminalData(mode) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'CARD_POS';

      var entry = this.entries(mode).find(function (entry) {
        return entry.type === type;
      });
      return entry && entry.data ? entry.data : this.emptyTerminalData();
    },
    copySettings: function copySettings() {
      return {
        online: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entries('online'))).map(function (entry) {
          return entry.type === 'POS' ? { type: entry.type, data: null } : entry;
        }),
        offline: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entries('offline'))).map(function (entry) {
          return entry.type === 'POS' ? { type: entry.type, data: null } : entry;
        })
      };
    },
    toggleMethod: function toggleMethod(mode, type, selected) {
      var settings = this.copySettings();
      settings[mode] = settings[mode].filter(function (entry) {
        return entry.type !== type;
      });
      if (selected) {
        var data = type === 'CARD_POS' ? { connection_type: 'NFC', bank_terminal_provider: this.legacyBankProvider } : null;
        settings[mode].push({ type: type, data: data });
      }
      this.$emit('input', settings);
    },
    setTerminalValue: function setTerminalValue(mode, field, value) {
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'CARD_POS';

      var settings = this.copySettings();
      var entry = settings[mode].find(function (entry) {
        return entry.type === type;
      });
      if (!entry) return;
      if (!entry.data) entry.data = this.emptyTerminalData();
      if (field === 'integrated_bank_pos_id') {
        var id = value === '' ? null : Number(value);
        var option = this.posOptions.find(function (option) {
          return option.id === id;
        });
        entry.data.integrated_bank_pos_id = id;
        entry.data.integrated_bank_pos_name = option ? option.name : null;
      } else {
        entry.data[field] = value;
      }
      this.$emit('input', settings);
    }
  }
});

/***/ }),

/***/ "hlOD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hphe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInventoryForm_vue__ = __webpack_require__("w8TW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518a763a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInventoryForm_vue__ = __webpack_require__("aA1u");
function injectStyle (ssrContext) {
  __webpack_require__("3vOG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-518a763a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInventoryForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518a763a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInventoryForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hr6u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var end = new Date();
    var start = new Date();
    start.setDate(end.getDate() - 29);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    return {
      loading: false,
      tableData: [],
      totalItems: 0,
      totalValue: 0,
      selectedGestiune: null,
      selectedLocation: null,
      searchDate: [start, end],
      selectedProduct: {},
      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            var end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      }
    };
  },

  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id;
      });
      return result;
    }
  },
  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.resetTable();

      this.selectedGestiune = null;
      this.tableData = [];
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    this.firstLoad();
  },

  methods: {
    firstLoad: function firstLoad() {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0];
      }
    },
    openNirModal: function openNirModal(product) {
      console.log(product);
      this.selectedProduct = product;
      this.$modal.show('nirModal');
    },
    closeNirModal: function closeNirModal() {
      this.$modal.hide('nirModal');
    },
    openViewPurchase: function openViewPurchase(product) {
      this.selectedProduct = product;
      this.$modal.show('purchaseModal');
    },
    closePurchaseModal: function closePurchaseModal() {
      this.$modal.hide('purchaseModal');
    },
    goToNir: function goToNir(row) {
      this.$router.push({
        path: '/management/entries/edit/' + row._id,
        query: {
          nirNumber: row.number,
          data_document: row.data_document,
          vatNumberFurnizor: row.vatNumberFurnizor,
          series: row.series
        }
      });
    },
    triggerFilter: function triggerFilter() {
      if (!this.selectedGestiune) {
        return;
      }
      if (!this.selectedLocation) {
        return;
      }
      if (!this.searchDate || this.searchDate.length !== 2) {
        return;
      }

      this.resetTable();
      this.fetchPurchaseReport();
    },
    getCategoryClass: function getCategoryClass(categorie) {
      if (!categorie) return '';

      switch (categorie.toLowerCase().replace(/\s+/g, '-')) {
        case 'marfa':
          return 'marfa';
        case 'semifabricate-(reteta)':
          return 'semifabricate';
        case 'materii-prime':
          return 'materii-prime';
        case 'produs-finit-(reteta)':
          return 'produs-finit';
        default:
          return '';
      }
    },
    fetchPurchaseReport: function fetchPurchaseReport() {
      var _this2 = this;

      var exportFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var externalCompanyId, _searchDate, startDate, endDate, params, url, response, data, grouped;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this2.selectedLocation || !_this2.searchDate)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                _this2.loading = true;

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  type: 'info',
                  title: 'Se generează raportul de achiziții',
                  text: 'Vă rugăm așteptați...',
                  allowOutsideClick: false,
                  didOpen: function didOpen() {
                    return __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.showLoading();
                  }
                });

                _context.prev = 4;
                externalCompanyId = _this2.$session.get('selectedCompany');
                _searchDate = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_this2.searchDate, 2), startDate = _searchDate[0], endDate = _searchDate[1];
                params = new URLSearchParams({
                  externalCompanyId: externalCompanyId,

                  externalLocationId: _this2.selectedLocation.true_id,
                  vatNumber: _this2.selectedLocation.inv_fiscal_code,
                  startDate: new Date(startDate),
                  endDate: new Date(endDate)
                });
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/reports/purchases?' + params.toString();


                if (exportFormat) {
                  url += '&export=' + exportFormat.toUpperCase();
                }

                _context.next = 12;
                return fetch(url);

              case 12:
                response = _context.sent;

                console.log('Răspuns raport achiziții:', response);

                if (response.ok) {
                  _context.next = 16;
                  break;
                }

                throw new Error('HTTP ' + response.status);

              case 16:
                if (!exportFormat) {
                  _context.next = 20;
                  break;
                }

                window.location.href = url;

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.close();
                }, 800);

                return _context.abrupt('return');

              case 20:
                _context.next = 22;
                return response.json();

              case 22:
                data = _context.sent;


                if (Array.isArray(data.items)) {
                  grouped = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(data.items.reduce(function (acc, item) {
                    var _acc$key$nirDocuments;

                    var key = item.productId || item.name;

                    if (!acc[key]) {
                      acc[key] = {
                        productId: item.productId,
                        name: item.name,
                        unit: item.unit,
                        quantity: 0,
                        value: 0,
                        purchaseDocuments: [],
                        nirDocuments: [],
                        lineCount: 0
                      };
                    }

                    acc[key].quantity += Number(item.quantity) || 0;
                    acc[key].value += Number(item.value) || 0;
                    acc[key].purchaseDocuments.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item));
                    (_acc$key$nirDocuments = acc[key].nirDocuments).push.apply(_acc$key$nirDocuments, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(item.nirDocuments || []));
                    acc[key].lineCount++;

                    return acc;
                  }, {}));


                  grouped.forEach(function (item) {
                    item.price = item.lineCount === 1 ? item.purchaseDocuments[0].price : null;
                    delete item.lineCount;
                  });

                  _this2.tableData = grouped;
                } else {
                  _this2.tableData = [];
                }

                _this2.totalItems = data.totalItems || 0;
                _this2.totalValue = data.totalValue || 0;
                _context.next = 33;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context['catch'](4);

                console.error('Eroare raport achiziții:', _context.t0);
                _this2.tableData = [];
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Nu s-a putut genera raportul de achiziții.',
                  icon: 'error'
                });

              case 33:
                _context.prev = 33;

                _this2.loading = false;
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.close();
                return _context.finish(33);

              case 37:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 28, 33, 37]]);
      }))();
    },
    resetTable: function resetTable() {
      this.tableData = [];
    }
  }
});

/***/ }),

/***/ "hszr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleLocked_vue__ = __webpack_require__("xUnp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3e07e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleLocked_vue__ = __webpack_require__("ryyt");
function injectStyle (ssrContext) {
  __webpack_require__("cKcE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c3e07e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleLocked_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3e07e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleLocked_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hvya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__ = __webpack_require__("L7GT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-bars-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Bar' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.chartOptions['plugins'] = [this.$Chartist.plugins.tooltip()];
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions).on('draw', function (data) {
        if (data.type === 'bar') {
          data.element.attr({
            style: 'stroke-width: 30px'
          });
        }
      });
    },
    initChartAndReturn: function initChartAndReturn() {
      var chartIdQuery = '#' + this.chartId;
      this.chartOptions['plugins'] = [this.$Chartist.plugins.tooltip()];

      var chart = this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);

      chart.on('draw', function (data) {
        if (data.type === 'bar') {
          data.element.attr({
            style: 'stroke-width: 30px'
          });
        }
      });

      this.chart = chart;
      return chart;
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "hzQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GroupForm_vue__ = __webpack_require__("L8oI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);







var _components;






__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GroupForm', __WEBPACK_IMPORTED_MODULE_7__GroupForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      offerModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onOfferSubmit: function onOfferSubmit(model, isValid) {
      this.offerModel = model;
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "i//v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("Yq4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dialog__ = __webpack_require__("qubY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_UIComponents_Inputs_FileInput_vue__ = __webpack_require__("lcot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_sweetalert2_dist_sweetalert2_css__);





















var _components;










__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dialog___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_checkbox___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_checkbox___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox_group___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox_group___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dialog___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dialog___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'FileInput', __WEBPACK_IMPORTED_MODULE_22_src_components_UIComponents_Inputs_FileInput_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_23_src_components_UIComponents_Switch_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_23_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vee_validate__["b" /* mapFields */])(['name', 'description', 'sort_order', 'parent_id', 'date_validfrom', 'date_validto', 'display_type'])),
  data: function data() {
    return {
      id: this.route.params.id || null,
      locations_formatted: [],
      isInitializingLocations: true,
      categoriesRequestKey: null,
      categoriesRequestInFlightKey: null,
      apiUrl: '',
      seen: false,
      filteredProd: [],
      timeout_promo: 0,
      pickerOptions1: {},
      pickerNames: ['date_validfrom', 'date_validto'],
      userRole: this.$session.get('userDataRole'),
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      users: [],
      model: {
        qr_code: '',
        multiple: false,
        redeem_from_next_order: false,
        add_free_product_auto: false,
        allow_one_point_per_order: false,
        notification_text: ''
      },
      filelist: [],
      expandOrder: [],
      expandReceive: [],
      filelistToUpload: [],
      generalSuccess: '',
      locations: [],
      toOrder: [],
      toReceive: [],
      treeConfig: {
        id: 'id',
        label: 'name',
        isLeaf: 'leaf',
        level: 'level',
        children: 'children',
        loading: false,
        loadedOnce: false
      },
      modelValidations: {
        title: {
          required: true,
          min: 4
        },
        treshold: {
          required: true
        },
        expiry: {
          required: true
        },
        location: {
          required: true
        },
        qr_code: {
          required: true,
          min: 4
        }
      },
      products: [],
      loading: true,
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      errorTree: null,
      errorTreeReceive: null,
      filters: [{
        value: '',
        prop: ['firstname', 'lastname', 'email', 'points']
      }],
      receiveItems: [],
      orderItems: [],
      heartbeatSet: false
    };
  },

  created: function created() {
    var _this = this;

    this.apiUrl = "https://gatewaydev.taptasty.com/";

    this.$nextTick(function () {
      this.loading = true;
    });

    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };

    this.apiRequest('/product', 'GET', data, function (response) {
      if (response.status === true) {
        _this.products = response.data;
      }
    });

    if (this.route.params.id) {
      this.apiRequest('/promo/' + this.route.params.id, 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data[0].date_start && response.data[0].date_end) {
            response.data[0].fromto = [response.data[0].date_start, response.data[0].date_end];
          }
          if (response.data[0].image) {
            response.data[0].imagelist = [{ url: response.data[0].image }];
          } else {
            response.data[0].imagelist = [];
          }
          _this.model = response.data[0];
          _this.model.multiple = !!Number(_this.model.multiple);
          _this.model.redeem_from_next_order = !!Number(_this.model.redeem_from_next_order);
          _this.model.add_free_product_auto = !!Number(_this.model.add_free_product_auto);
          _this.model.allow_one_point_per_order = !!Number(_this.model.allow_one_point_per_order);
          _this.locations_formatted = response.data[0].locations_formatted;

          _this.getLocations().then(function () {
            _this.isInitializingLocations = false;
            _this.getCategories();
          });


          _this.model.product_id = JSON.parse(_this.model.product_id);
          _this.filteredProd = response.data[0].filteredProd;
          _this.users = response.data[0].users;
          _this.receiveItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(_this.model.receive_product).concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(_this.model.receive_category));
          _this.orderItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(_this.model.order_product).concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(_this.model.order_category));
          _this.$nextTick(function () {
            this.loading = false;
          });
        }
        _this.timeout_promo = setTimeout(function () {
          _this.heartbeat();
        }, 300000);
      });
    } else {
      this.getLocations().finally(function () {
        _this.isInitializingLocations = false;
      });
      this.$nextTick(function () {
        this.loading = false;
      });
    }
  },
  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timeout_promo);
  },
  methods: {
    onLocationsInput: function onLocationsInput() {
      if (this.isInitializingLocations) return;
      this.getCategories();
    },
    downloadPoints: function downloadPoints() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/reports/points/export/' + this.route.params.id, 'GET', data, function (response) {
        var link = document.createElement('a');
        link.href = response.file;
        link.setAttribute('download', response.file_name);
        document.body.appendChild(link);
        link.click();
        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    checkAll: function checkAll() {
      var nodes = this.$refs.order.store.root.childNodes;
      var checkedKeys = nodes.map(function (node) {
        return node.key;
      });
      this.$refs.order.setCheckedKeys(checkedKeys);
    },
    resetProductTree: function resetProductTree() {
      this.$refs.order.setCheckedKeys([]);
    },
    getCategories: function getCategories() {
      var _this3 = this;

      var locationsIDs = this.getLocationArray();
      var requestKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
        location_ids: (locationsIDs || []).slice().sort(),
        receive: (this.receiveItems || []).slice().sort(),
        order: (this.orderItems || []).slice().sort()
      });
      if (this.categoriesRequestInFlightKey === requestKey || this.categoriesRequestKey === requestKey) return;
      this.categoriesRequestInFlightKey = requestKey;

      var groupData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        usage_for_products: this.receiveItems,
        location_ids: locationsIDs
      };
      this.apiRequest('/get-tree?action=receive-products', 'GET', groupData, function (response) {
        if (response.status === true) {
          _this3.toReceive = response.data.tree;
          _this3.expandReceive = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(response.data.expand);
        }
      });
      groupData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        usage_for_products: this.orderItems,
        location_ids: locationsIDs
      };
      this.apiRequest('/get-tree?action=order-products', 'GET', groupData, function (response) {
        if (response.status === true) {
          _this3.toOrder = response.data.tree;
          _this3.expandOrder = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(response.data.expand);
        }
        _this3.categoriesRequestKey = requestKey;
        _this3.categoriesRequestInFlightKey = null;
      });
    },
    getLocations: function getLocations() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var data = {
          token: _this4.$session.get('token'),
          company_id: _this4.$session.get('selectedCompany')
        };

        _this4.apiRequest('/get-locations', 'GET', data, function (response) {
          if (response.status) {
            _this4.locations = response.data;
            resolve();
          } else {
            reject(new Error('Failed to fetch locations'));
          }
        });
      });
    },
    loadProducts: function loadProducts(node) {
      var _this5 = this;

      var treeNode = this.$refs.order.getNode(node);
      var locationsIDs = this.getLocationArray();
      if (!this.expandOrder.includes(node.id) && !node.loadedOnce) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          category_id: parseInt(node.id),
          location_ids: locationsIDs
        };
        node.loading = true;
        this.apiRequest('/product-tree-products', 'GET', data, function (response) {
          if (response.status) {
            node.children = response.data;
            node.expand = true;
            node.loading = false;
            node.loadedOnce = true;
            _this5.$nextTick(function () {
              if (treeNode.checked) {
                _this5.$refs.order.setCheckedNodes(_this5.$refs.order.getCheckedNodes().concat(treeNode.children));
              }
            });
          }
        });
      }
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;

      if (data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
        return true;
      }

      if (data.children) {
        for (var i = 0; i < data.children.length; i++) {
          if (this.filterNode(value, data.children[i])) {
            return true;
          }
        }
      }
      return false;
    },
    checkAllReceive: function checkAllReceive() {
      var nodes = this.$refs.receive.store.root.childNodes;
      var checkedKeys = nodes.map(function (node) {
        return node.key;
      });
      this.$refs.receive.setCheckedKeys(checkedKeys);
    },
    resetProductTreeReceive: function resetProductTreeReceive() {
      this.$refs.receive.setCheckedKeys([]);
    },
    loadProductsReceive: function loadProductsReceive(node) {
      var _this6 = this;

      var treeNode = this.$refs.receive.getNode(node);
      var locationsIDs = this.getLocationArray();
      if (!this.expandReceive.includes(node.id) && !node.loadedOnce) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          category_id: parseInt(node.id),
          location_ids: locationsIDs
        };
        node.loading = true;
        this.apiRequest('/product-tree-products', 'GET', data, function (response) {
          if (response.status) {
            node.children = response.data;
            node.expand = true;
            node.loading = false;
            node.loadedOnce = true;
            _this6.$nextTick(function () {
              if (treeNode.checked) {
                _this6.$refs.receive.setCheckedNodes(_this6.$refs.receive.getCheckedNodes().concat(treeNode.children));
              }
            });
          }
        });
      }
    },
    filterNodeReceive: function filterNodeReceive(value, data) {
      if (!value) return true;

      if (data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
        return true;
      }

      if (data.children) {
        for (var i = 0; i < data.children.length; i++) {
          if (this.filterNodeReceive(value, data.children[i])) {
            return true;
          }
        }
      }
      return false;
    },
    handleApprove: function handleApprove(flag, row, points) {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        waiting_approval: flag,
        rowId: row.id,
        points: this.$refs[row.id].value
      };

      var self = this;

      this.apiRequest('/promo_client/' + row.id, 'PUT', data, function (response) {
        if (response.status) {
          row.waiting_approval = !row.waiting_approval;
          row.points = response.data[0].points;
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()(self.$t('general.success') + '!', '', 'success').catch(function () {});
          var id = self.$route.params.id;
          var data = {
            token: self.$session.get('token'),
            company_id: self.$session.get('selectedCompany')
          };
          self.apiRequest('/promo/' + id, 'GET', data, function (response) {
            if (response.status === true) {
              self.users = response.data[0].users;
              self.loading = false;
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
          row.waiting_approval = !row.waiting_approval;
        }
      });
    },

    heartbeat: function heartbeat() {
      var self = this;
      var id = this.route.params.id;

      if (id) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };
        this.apiRequest('/promo/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            self.users = response.data[0].users;
            self.loading = false;
          }
          self.timeout_promo = setTimeout(function () {
            self.heartbeat();
          }, 8000);
        });
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this7 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this7.errors.clear();
          _this7.savePromo();
        }
      });
    },
    validateOrder: function validateOrder() {
      var checkedKeys = this.$refs.order.getCheckedKeys();
      if (checkedKeys.length === 0) {
        this.errorTree = this.$t('marketingCampaigns.productTreeError');
        return false;
      } else {
        this.errorTree = null;
        return true;
      }
    },
    validateReceive: function validateReceive() {
      var checkedKeys = this.$refs.receive.getCheckedKeys();
      if (checkedKeys.length === 0) {
        this.errorTreeReceive = this.$t('marketingCampaigns.productTreeError');
        return false;
      } else {
        this.errorTreeReceive = null;
        return true;
      }
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors[prop].length === 1) {
          this.errors.add(prop, errors[prop][0]);
        } else {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    isNew: function isNew() {
      if (this.route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var _this8 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }

      if (this.model.imagelist && this.model.imagelist[0].status === 'ready') {
        this.getBase64(this.model.imagelist[0].raw).then(function (base64enc) {
          _this8.model.image = base64enc;
        });
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
        this.model.image = null;
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    },
    handleDelete: function handleDelete(label) {
      var _this9 = this;

      var btnCounter = 3;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
        text: self.$t('marketingPromos.areYouSureDelete', { label: label }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          if (_this9.isNew()) {
            self.$bus.$emit('refresh');
            self.$bus.$emit('close-modal');
          } else {
            var id = _this9.route.params.id;
            var data = {
              id: id,
              token: _this9.$session.get('token'),
              company_id: _this9.$session.get('selectedCompany')
            };
            _this9.apiRequest('/promo/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', self.$t('validations.offerDeleted'), 'success');

                self.$bus.$emit('refresh');
                self.$bus.$emit('close-modal');
              } else {
                __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    clearLinkSelection: function clearLinkSelection() {
      this.model.link_id = null;
      this.model.description = null;
    },
    generateCode: function generateCode() {
      var random = Math.random().toString(36).substring(7);
      this.model['qr_code'] = random;
    },
    getLocationArray: function getLocationArray() {
      return this.locations_formatted && this.locations_formatted.length ? this.locations_formatted.map(function (el) {
        return el.token;
      }) : [];
    },
    savePromo: function savePromo() {
      var _this10 = this;

      this.$nextTick(function () {
        this.loading = true;
      });
      var checkedNodes = this.$refs.order.getCheckedNodes();

      var orderCategory = checkedNodes.reduce(function (acc, node) {
        if (node.level === 1) {
          acc.push(node.id);
        }
        return acc;
      }, []);

      var order = checkedNodes.filter(function (node) {
        return node.level === 2;
      }).filter(function (node) {
        var parent = _this10.$refs.order.getNode(node).parent;
        return !orderCategory.includes(parent.data.id);
      }).map(function (node) {
        return node.id;
      });

      checkedNodes = this.$refs.receive.getCheckedNodes();

      var receiveCategory = checkedNodes.reduce(function (acc, node) {
        if (node.level === 1) {
          acc.push(node.id);
        }
        return acc;
      }, []);

      var receive = checkedNodes.filter(function (node) {
        return node.level === 2;
      }).filter(function (node) {
        var parent = _this10.$refs.receive.getNode(node).parent;
        return !receiveCategory.includes(parent.data.id);
      }).map(function (node) {
        return node.id;
      });
      if (order.length === 0 && orderCategory.length === 0) {
        __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
          title: '',
          text: this.$t('marketingPromos.toOrderError'),
          type: 'error',
          showConfirmButton: true
        });
        this.$nextTick(function () {
          this.loading = false;
        });
        return;
      }

      if (receive.length === 0 && receiveCategory.length === 0) {
        __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
          title: '',
          text: this.$t('marketingPromos.toReceiveError'),
          type: 'error',
          showConfirmButton: true
        });
        this.$nextTick(function () {
          this.loading = false;
        });
        return;
      }

      var locationsIDs = this.getLocationArray();
      var data = {
        title: this.model.title,
        image: this.model.image,
        treshold: this.model.treshold,
        qr_code: this.model.qr_code,
        active: this.model.active,
        description: this.model.description,
        notification_text: this.model.notification_text,
        location: locationsIDs,
        multiple: this.model.multiple ? 1 : 0,
        redeem_from_next_order: this.model.redeem_from_next_order ? 1 : 0,
        add_free_product_auto: this.model.add_free_product_auto ? 1 : 0,
        allow_one_point_per_order: this.model.allow_one_point_per_order ? 1 : 0,
        order_product: order,
        receive_product: receive,
        order_category: orderCategory,
        receive_category: receiveCategory,
        expiry: this.model.expiry
      };

      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');

      if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
        data.date_start = this.model.fromto[0];
        data.date_end = this.model.fromto[1];
      } else {
        data.date_start = null;
        data.date_end = null;
      }

      var self = this;

      if (this.isNew()) {
        data.sort_order = 0;
        if (this.model.image) {
          this.apiRequest('/promo', 'POST', data, function (response) {
            if (response.status === true) {
              _this10.$nextTick(function () {
                this.loading = false;
              });
              _this10.backButton();
              __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
                title: '',
                text: _this10.$t('marketingPromos.promoAdded'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
              _this10.$bus.$emit('refresh');
              _this10.$bus.$emit('close-modal');
            } else {
              _this10.$nextTick(function () {
                this.loading = false;
              });
              _this10.handleErrors(response.errors);
            }
          });
        } else {
          this.$nextTick(function () {
            this.loading = false;
          });
          this.errors.add('image', this.$t('marketingPromos.validImg'));
        }
      } else {
        var id = this.route.params.id;

        if (this.model.imagelist === 0) {
          data.image = '';
        }
        if (self.model.image) {
          self.apiRequest('/promo/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              self.$nextTick(function () {
                self.loading = false;
              });
              self.backButton();
              __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
                title: '',
                text: self.$t('marketingPromos.promoUpdated'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
                title: '',
                text: self.$t('marketingPromos.weCouldNot'),
                type: 'danger',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
            }
          });
        } else {
          this.apiRequest('/promo/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              self.$nextTick(function () {
                self.loading = false;
              });
              self.backButton();
              __WEBPACK_IMPORTED_MODULE_24_sweetalert2___default()({
                title: '',
                text: self.$t('marketingPromos.promoUpdated'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(function () {});
            } else {
              self.$nextTick(function () {
                self.loading = false;
              });
              self.handleErrors(response.errors);
            }
          });
        }
      }
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "i/Hx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i/I0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      vatNumber: null,
      selectedLocation: null
    };
  },

  computed: {
    showAvizColumn: function showAvizColumn() {
      return this.tableData.some(function (row) {
        return row.externalDocIds && row.externalDocIds.aviz;
      });
    },
    showNirColumn: function showNirColumn() {
      return this.tableData.some(function (row) {
        return row.externalDocIds && row.externalDocIds.nir;
      });
    },
    showInvoiceColumn: function showInvoiceColumn() {
      return this.tableData.some(function (row) {
        return row.externalDocIds && row.externalDocIds.invoice;
      });
    }
  },
  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.tableData = [];
      this.tableData = [];
      this.totalItems = 0;
      this.currentPage = 1;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    var _this = this;

    this.$bus.$on('refresh', function () {
      _this.onSearch();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh');
  },

  methods: {
    onSearch: function onSearch() {
      if (!this.selectedLocation || Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        });
        return;
      }

      var locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation];

      this.getMyOrder(locations);
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getMyOrder(this.selectedLocation, this.currentPage, this.pageSize);
    },
    addMyOrder: function addMyOrder() {
      this.$router.push('/management/for-orders-suppliers/add');
    },
    editMyOrder: function editMyOrder(row) {
      this.$router.push('/management/for-orders-suppliers/edit/' + row.series + '/' + row.documentNumber);
    },
    getStatusStyle: function getStatusStyle(status) {
      switch (status.toLowerCase()) {
        case 'sent':
          return {
            backgroundColor: '#007bff',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
        case 'processed':
          return {
            backgroundColor: '#fd7e14',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
        case 'validat':
          return {
            backgroundColor: '#28a745',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
        case 'facturat':
          return {
            backgroundColor: '#6f42c1',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
        case 'new':
          return {
            backgroundColor: '#6c757d',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
        default:
          return {
            backgroundColor: '#343a40',
            color: 'white',
            fontWeight: 'bold',
            padding: '4px 10px',
            borderRadius: '50px',
            display: 'inline-block',
            minWidth: '70px',
            textAlign: 'center',
            userSelect: 'none'
          };
      }
    },
    processOrder: function processOrder(row) {
      this.$router.push({
        path: '/management/for-orders-suppliers/edit/' + row._id,
        query: {
          series: row.series,
          number: row.documentNumber,
          isProcess: true
        }
      });
    },
    aviz: function aviz(row) {
      this.$router.push({
        path: '/management/outputs/add',
        query: {
          series: row.series,
          number: row.documentNumber,
          isAviz: true
        }
      });
    },
    invoice: function invoice(row) {
      this.$router.push({
        path: '/invoice-tabs/invoice/add',
        query: {
          series: row.series,
          number: row.documentNumber,
          isInvoice: true
        }
      });
    },
    getMyOrder: function getMyOrder() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this2 = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, ids, allLocations, _ids, response, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;

                params = new URLSearchParams();

                params.append('externalCompanyId', _this2.companyID);

                params.append('page', page);
                params.append('limit', pageSize);

                if (location) {
                  if (Array.isArray(location)) {
                    ids = location.map(function (l) {
                      return l.true_id;
                    }).filter(Boolean);

                    ids.forEach(function (id) {
                      return params.append('externalLocationId', id);
                    });
                  } else if (location.id && location.true_id) {
                    params.append('externalLocationId', location.true_id);
                  }
                } else {
                  allLocations = _this2.groupedLocations.flatMap(function (group) {
                    return group.locations;
                  });
                  _ids = allLocations.map(function (l) {
                    return l.true_id;
                  }).filter(Boolean);

                  _ids.forEach(function (id) {
                    return params.append('externalLocationId', id);
                  });
                }

                clearTimeout(_this2.loadingTimeout);
                _this2.loadingTimeout = setTimeout(function () {
                  _this2.loading = true;
                }, 100);

                _context.prev = 8;
                _context.next = 11;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/orders?' + params.toString(), {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 11:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 14;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 14:
                _context.next = 16;
                return response.json();

              case 16:
                data = _context.sent;


                if (Array.isArray(data.comenzi)) {
                  clearTimeout(_this2.loadingTimeout);
                  _this2.loading = false;

                  _this2.totalItems = data.total || 0;
                  _this2.currentPage = data.currentPage || page;
                  _this2.pageSize = data.pageSize || pageSize;

                  _this2.tableData = data.comenzi.filter(function (order) {
                    return order.status.toLowerCase() !== 'new';
                  }).map(function (order) {
                    return {
                      _id: order._id,
                      series: order.series,
                      documentNumber: order.number,
                      status: order.status,
                      date: order.date,
                      externalLocationId: order.externalLocationId,
                      supplierVatNumber: order.supplierVatNumber,
                      supplierExternalLocationId: order.supplierExternalLocationId,
                      externalDocIds: order.externalDocIds || {},
                      vatNumber: order.vatNumber
                    };
                  });
                } else {
                  console.error('No valid orders found.');
                  _this2.tableData = [];
                }
                _context.next = 25;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](8);

                clearTimeout(_this2.loadingTimeout);
                _this2.loading = false;

                console.error('Error fetching orders:', _context.t0);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[8, 20]]);
      }))();
    }
  }
});

/***/ }),

/***/ "i1gK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.add'))+"\n          ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"30","prop":"id","label":"ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"50","prop":"type","label":_vm.$t('customers.type')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"50","prop":"location_name","label":_vm.$t('customers.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.location_name)?_c('span',[_vm._v(_vm._s(props.row.location_name))]):_c('span',[_vm._v(_vm._s(_vm.$t('general.all')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":150,"label":_vm.$t('reports.section')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.section)?_c('span',[_vm._v(_vm._s(props.row.section.name))]):_c('span',[_vm._v(" - ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":120,"label":_vm.$t('orderScreen.connectivity')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.ods_offline)?_c('span',{staticStyle:{"display":"inline-block","padding":"4px 10px","border-radius":"12px","background-color":"#f5365c","color":"#fff","font-size":"12px"}},[_vm._v("\n              "+_vm._s(_vm.$t('orderScreen.offline'))+"\n            ")]):_c('span',{staticStyle:{"display":"inline-block","padding":"4px 10px","border-radius":"12px","background-color":"#2dce89","color":"#fff","font-size":"12px"}},[_vm._v("\n              "+_vm._s(_vm.$t('orderScreen.online'))+"\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":200,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.deleteOrderScreen(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.delete'))+"\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":120,"label":_vm.$t('general.copyUrlToClipboard')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('button',{staticClass:"btn btn-icon btn-info duplicate mar-rt-10",attrs:{"title":_vm.$t('general.copyUrlToClipboard')},on:{"click":function($event){_vm.copyToClipboard(props.row.url)}}},[_c('img',{attrs:{"src":"/static/img/icons/duplicate.png"}})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":150,"label":_vm.$t('general.edit')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n            ")])]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i2PC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_css__);












__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a),
  props: {
    defaultData: {},
    modeldata: {
      type: [Object, Array],
      required: true
    }
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },
    modeldata: function modeldata(value) {

      this.model = value;

      this.errors.clear();

      this.$nextTick(function () {});
    }
  },
  data: function data() {
    return {
      model: this.value || this.modeldata,
      defaults: this.value || this.defaultData,
      modelValidate: {
        timezone: { required: true },
        time_format: { required: true },
        date_format: { required: true }
      },
      pickerNames: ['date_from', 'date_to'],
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      loading: false
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveDetails();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    saveDetails: function saveDetails() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'timezone': this.model.timezone,
        'date_format': this.model.date_format,
        'time_format': this.model.time_format
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          self.errors.clear();
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({ 'text': self.$t('settingDateTime.saveMsg'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          self.handleErrors(response.errors);
        }
      });
    }
  }
});

/***/ }),

/***/ "i3di":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { btReturnPending: false, btReturnTimer: null, btReturnChecks: 0, btReturnKey: null };
  },

  watch: {
    order: {
      immediate: true,
      handler: function handler(order) {
        var _this = this;

        if (!order || order.payment_id !== 'btIpay' || !order.id) {
          clearTimeout(this.btReturnTimer);
          this.btReturnTimer = null;
          this.btReturnPending = false;
          this.btReturnKey = null;
          return;
        }
        var key = 'bt-return:' + order.company_id + ':' + order.id;
        if (key !== this.btReturnKey) {
          clearTimeout(this.btReturnTimer);
          this.btReturnTimer = null;
          this.btReturnChecks = 0;
          this.btReturnKey = key;
        }
        var returned = Number(order.is_refunded) === 1 || ['refund OK', 'reversal OK'].indexOf(order.capture_transaction_status) >= 0;
        if (returned) this.$session.remove(key);
        this.btReturnPending = !returned && this.$session.get(key) === true;
        if (!this.btReturnPending) {
          clearTimeout(this.btReturnTimer);
          this.btReturnTimer = null;
        }
        if (this.btReturnPending && !this.btReturnTimer && this.btReturnChecks < 30) {
          this.btReturnTimer = setTimeout(function () {
            _this.btReturnTimer = null;
            _this.btReturnChecks++;
            _this.getData();
          }, 10000);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.btReturnTimer);
  },

  methods: {
    btStatusBlocked: function btStatusBlocked(status) {
      return this.order && this.order.payment_id === 'btIpay' && this.order.status && this.order.status.id === 'DRAFT_AWAITING_PAYMENT' && ['CANCELED', 'NOT_DELIVERED'].indexOf(status) < 0;
    },
    handleBtReturnQueued: function handleBtReturnQueued() {
      if (!this.order || this.order.payment_id !== 'btIpay') return;
      var key = 'bt-return:' + this.order.company_id + ':' + this.order.id;
      this.$session.set(key, true);
      this.btReturnPending = true;
      this.btReturnChecks = 0;
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({ text: this.$t('btPayments.returnPending'), type: 'info' }).catch(function () {});
      this.getData();
      this.$session.set('refreshOrdersCount', 'refresh');
      if (typeof this.callback === 'function') this.callback(this.order.id);
      if (this.$bus) this.$bus.$emit('refresh', this.order.id);
    }
  }
});

/***/ }),

/***/ "i67M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iCFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('pos-screen-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iDPB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iDTm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iE/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isSeries },on:{"click":_vm.openSeries}},[_vm._v(_vm._s(_vm.$t('invoice.series')))])])])])]),_vm._v(" "),(_vm.isSeries)?_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.series')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.series),expression:"series"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.series')},domProps:{"value":(_vm.series)},on:{"input":function($event){if($event.target.composing){ return; }_vm.series=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.startNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startNumber),expression:"startNumber"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('invoice.startNumber')},domProps:{"value":(_vm.startNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.endNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endNumber),expression:"endNumber"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('invoice.endNumber')},domProps:{"value":(_vm.endNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endNumber=$event.target.value}}})])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.saveSeries($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iGuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    task: {
      type: Object,
      default: function _default() {
        return {
          title: ''
        };
      }
    },
    index: Number
  },
  methods: {
    handleEditClick: function handleEditClick() {
      this.$emit('on-edit', this.index);
    },
    handleDeleteClick: function handleDeleteClick() {
      this.$emit('on-delete', this.index);
    }
  }
});

/***/ }),

/***/ "iJb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);







__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      locations: [],
      timezone: (this.$session.get('selectedCompanyData') || {}).timezone || 'Europe/Bucharest',
      tableData: [],
      total: 0,
      sortBy: 'credited_at',
      sortOrder: 'desc',
      paginationProps: {
        layout: 'prev, pager, next, sizes, total',
        currentPage: 1,
        pageSize: 25
      },
      tableOptions: {
        defaultSort: {
          prop: 'credited_at',
          order: 'descending'
        }
      }
    };
  },
  created: function created() {
    this.locations = this.getCompanyDetail('locations_details') || [];
  },

  computed: {
    campaignId: function campaignId() {
      var fromProp = this.route && this.route.params && this.route.params.campaignId;
      var fromRouter = this.$route && this.$route.params && this.$route.params.campaignId;
      return fromProp != null && fromProp !== '' ? fromProp : fromRouter;
    },
    campaignTitle: function campaignTitle() {
      var q = this.route && this.route.query || this.$route && this.$route.query || {};
      return q.title || '';
    }
  },
  watch: {
    campaignId: {
      immediate: true,
      handler: function handler(id) {
        if (id != null && id !== '') {
          this.paginationProps.currentPage = 1;
          this.getOrders();
        }
      }
    }
  },
  methods: {
    getClientName: function getClientName(row) {
      if (row.client_name) return row.client_name;
      var name = [row.firstname, row.lastname].filter(Boolean).join(' ').trim();
      if (name) return name;
      if (row.user) {
        return [row.user.firstname, row.user.lastname].filter(Boolean).join(' ').trim() || '-';
      }
      return '-';
    },
    getLocationName: function getLocationName(locationId) {
      if (locationId === null || locationId === undefined || locationId === '') return '';
      var numericId = Number(locationId);
      var location = this.locations.find(function (loc) {
        return loc.true_id === locationId || loc.id === locationId || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(numericId) && (loc.true_id === numericId || loc.id === numericId);
      });
      return location && location.name ? location.name : '';
    },
    getOrderDateValue: function getOrderDateValue(row) {
      if (row.credited_at && row.credited_at.date) return row.credited_at.date;
      if (row.order_created_at && row.order_created_at.date) return row.order_created_at.date;
      return row.created_at || row.date || null;
    },
    formatOrderDate: function formatOrderDate(row) {
      var date = this.getOrderDateValue(row);
      if (!date) return '-';
      var normalized = String(date).trim().replace(' ', 'T').replace(/\.\d+$/, '');
      return this.formatToCompanyTimezone(normalized, this.timezone);
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page' || query.type === 'size' || query.type === 'sort') {
        this.getOrders(query);
      }
    },
    getOrders: function getOrders(query) {
      var _this = this;

      if (!this.campaignId) return;

      var page = this.paginationProps.currentPage || 1;
      var pageSize = this.paginationProps.pageSize || 25;

      if (query) {
        if (query.page) page = query.page;
        if (query.pageSize) pageSize = query.pageSize;
        if (query.sort && query.sort.prop) {
          this.sortBy = query.sort.prop;
          this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc';
        }
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: page,
        per_page: pageSize,
        field: this.sortBy,
        order: this.sortOrder
      };

      this.loading = true;
      this.apiRequest('/reports/donation-campaigns/' + this.campaignId + '/orders', 'GET', data, function (response) {
        if (response.status === true) {
          var items = [];
          var pagination = null;
          if (Array.isArray(response.data)) {
            items = response.data;
          } else {
            var payload = response.data || {};
            items = payload.data || payload.items || [];
            pagination = payload.pagination || null;
          }
          _this.tableData = items;
          _this.total = pagination ? pagination.totalRecords || pagination.total || 0 : response.total || items.length;
          _this.paginationProps.currentPage = pagination ? pagination.page || page : page;
          _this.paginationProps.pageSize = pagination ? pagination.per_page || pagination.perPage || pageSize : pageSize;
        } else {
          _this.tableData = [];
          _this.total = 0;
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()('', _this.$t('validations.wentWrong'), 'error').catch(function () {});
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    goBack: function goBack() {
      this.$bus.$emit('refreshDonationCampaignsReport');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "iJg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't6'
});

/***/ }),

/***/ "iLVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubscriptionForm_vue__ = __webpack_require__("ls/v");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SubscriptionForm: __WEBPACK_IMPORTED_MODULE_0__SubscriptionForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "iOcN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iQAi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iQHX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iSHC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingSidebar_vue__ = __webpack_require__("FzzJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6929167c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingSidebar_vue__ = __webpack_require__("Qbyg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6929167c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iUih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dispatch-orders-page"},[_c('div',{staticClass:"dispatch-orders-filters"},[_c('div',{staticClass:"filterLocation"},[_c('el-button',{staticClass:"filter-btn",attrs:{"type":"default"},on:{"click":_vm.openFiltersModal}},[_c('img',{attrs:{"src":"/static/img/icons/filter.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"dispatch-orders-filters-body"},[(_vm.hasActiveFilters)?[_c('div',{staticClass:"filters-header",on:{"click":_vm.toggleFiltersCollapse}},[_c('button',{staticClass:"collapse-toggle-btn",attrs:{"type":"button"}},[_c('i',{class:_vm.showFiltersCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('span',{staticClass:"filters-label"},[_vm._v(_vm._s(_vm.$t('orders.filtersApplied'))+":")]),_vm._v(" "),_c('a',{staticClass:"reset-filters-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.resetFilters()}}},[_vm._v(_vm._s(_vm.$t('orders.resetFilters')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showFiltersCollapsed),expression:"!showFiltersCollapsed"}],staticClass:"filters-list"},[_vm._l((_vm.requestFilters[0].value),function(sts,key){return _c('span',{key:'status-filter-' + sts + '-' + key,staticClass:"filter-selection"},[_vm._v("\n              "+_vm._s(_vm.formatLabelFirstLetter('ordersStatus.' + sts))+"\n              "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeStatusFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}),_vm._v(" "),_vm._l((_vm.locationFilter),function(locId,key){return _c('span',{key:'location-filter-' + locId + '-' + key,staticClass:"filter-selection"},[_vm._v("\n              "+_vm._s(_vm.getLocationName(locId))+"\n              "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeLocationFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}),_vm._v(" "),(_vm.orderFilters.pickupDatetime && _vm.orderFilters.pickupDatetime.length === 2)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Pickup: "+_vm._s(_vm.formatDateRange(_vm.orderFilters.pickupDatetime))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removePickupDatetimeFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.placedDatetime && _vm.orderFilters.placedDatetime.length === 2)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Placed: "+_vm._s(_vm.formatDateRange(_vm.orderFilters.placedDatetime))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removePlacedDatetimeFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.orderId)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Order ID: "+_vm._s(_vm.orderFilters.orderId)+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOrderIdFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.orderNumber)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Order #: "+_vm._s(_vm.orderFilters.orderNumber)+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOrderNumberFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.normalizeOrderTotal(_vm.orderFilters.orderTotalMin) !== null || _vm.normalizeOrderTotal(_vm.orderFilters.orderTotalMax) !== null)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Total: "+_vm._s(_vm.orderFilters.orderTotalMin || '0')+" - "+_vm._s(_vm.orderFilters.orderTotalMax || '∞')+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOrderTotalFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.operator && _vm.orderFilters.operator.length > 0)?_vm._l((_vm.orderFilters.operator),function(opId,key){return _c('span',{key:'operator-filter-' + opId + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                Operator: "+_vm._s(_vm.getOperatorName(opId))+"\n                "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOperatorFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e(),_vm._v(" "),(_vm.orderFilters.paymentType && _vm.orderFilters.paymentType.length > 0)?_vm._l((_vm.orderFilters.paymentType),function(pt,key){return _c('span',{key:'payment-type-filter-' + pt + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                Payment: "+_vm._s(_vm.formatLabelFirstLetter('paymentTypes.' + pt))+"\n                "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removePaymentTypeFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e(),_vm._v(" "),(_vm.orderFilters.deliveryType && _vm.orderFilters.deliveryType.length > 0)?_vm._l((_vm.orderFilters.deliveryType),function(dt,key){return _c('span',{key:'delivery-type-filter-' + dt + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                "+_vm._s(_vm.$t('settingCompany.deliveryType'))+": "+_vm._s(_vm.formatLabelFirstLetter('deliveryTypes.' + dt))+"\n                "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeDeliveryTypeFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e(),_vm._v(" "),(_vm.orderFilters.source && _vm.orderFilters.source.length > 0)?_vm._l((_vm.orderFilters.source),function(src,key){return _c('span',{key:'source-filter-' + src + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                Source: "+_vm._s(_vm.formatLabelFirstLetter('ordersSource.' + src))+"\n                "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeSourceFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e()],2)]:[_c('span',{staticClass:"no-filters-label"},[_vm._v(_vm._s(_vm.$t('orders.noFiltersApplied')))])]],2)]),_vm._v(" "),_c('div',{staticClass:"canvaOrders"},[_c('div',{staticClass:"col-order new"},[_c('p',[_vm._v(_vm._s(_vm.$t('ordersStatus.NEW'))+" "),_c('span',[_vm._v(_vm._s(_vm.ordersCount.new))])]),_vm._v(" "),(_vm.orders.new && _vm.orders.new.length > 0)?_vm._l((_vm.orders.new),function(order){return _c('div',{key:order.id,staticClass:"order-card"},[_c('div',{staticClass:"order-top"},[_c('div',{staticClass:"örderId",on:{"click":function($event){_vm.goToOrder(order.id)}}},[_c('p',[_vm._v(_vm._s(_vm.$t('reports.order'))+" #"+_vm._s(order.number))])]),_vm._v(" "),_c('div',{staticClass:"orderDate"},[_c('img',{attrs:{"src":"/static/img/icon-calendar.png","alt":"Date Icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.pickup_datetime))])])]),_vm._v(" "),_c('div',{staticClass:"ord-client"},[_c('div',{staticClass:"client"},[_c('span',[_c('b',[_vm._v(_vm._s(order.delivery_details_firstname))])]),_vm._v(" "),_c('span',{staticClass:"phone"},[_vm._v(_vm._s(order.delivery_details_phone))]),_vm._v(" "),_c('div',{staticClass:"address"},[(order && order.address_shipping)?_c('div',{staticClass:"address_shipping"},[_c('span',[_c('img',{attrs:{"src":"/static/img/icon-location.png"}}),_vm._v("\n                        "+_vm._s(order.address_shipping.street)+" "+_vm._s(order.address_shipping.number)+"\n                      ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"address"},[(order.production_details && order.production_details.location)?_c('div',{staticClass:"production_details"},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('orders.ordLocation'))+":")]),_vm._v("\n                      "+_vm._s(order.production_details.location.name)+"\n                    ")]),_vm._v(" "),(order && order.shipping_details)?_c('span',{staticClass:"zone"},[_c('b',[_vm._v(_vm._s(_vm.$t('orders.zone'))+":")]),_vm._v("\n                      "+_vm._s(order.shipping_details.name)+"\n                    ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"total"},[_c('span',[_vm._v(_vm._s(order.totals_grandtotal)+" "+_vm._s(order.currency)+" ("+_vm._s(order.payment_type)+")")])]),_vm._v(" "),_c('div',{staticClass:"method"},[_c('div',{staticClass:"type"},[_vm._v(_vm._s(_vm.formatDeliveryType(order.delivery_type)))])])])])}):[_vm._m(0)]],2),_vm._v(" "),_c('div',{staticClass:"col-order processing"},[_c('p',[_vm._v(_vm._s(_vm.$t('ordersStatus.PROCESSING'))+" "),_c('span',[_vm._v(_vm._s(_vm.ordersCount.processing))])]),_vm._v(" "),(_vm.orders.processing && _vm.orders.processing.length > 0)?_vm._l((_vm.orders.processing),function(order){return _c('div',{key:order.id,staticClass:"order-card"},[_c('div',{staticClass:"order-top"},[_c('div',{staticClass:"örderId",on:{"click":function($event){_vm.goToOrder(order.id)}}},[_c('p',[_vm._v(_vm._s(_vm.$t('reports.order'))+" #"+_vm._s(order.number))])]),_vm._v(" "),_c('div',{staticClass:"orderDate"},[_c('img',{attrs:{"src":"/static/img/icon-calendar.png","alt":"Date Icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.pickup_datetime))])])]),_vm._v(" "),_c('div',{staticClass:"ord-client"},[_c('div',{staticClass:"client"},[_c('span',[_c('b',[_vm._v(_vm._s(order.delivery_details_firstname))])]),_vm._v(" "),_c('span',{staticClass:"phone"},[_vm._v(_vm._s(order.delivery_details_phone))])]),_vm._v(" "),_c('div',{staticClass:"address"},[(order && order.address_shipping)?_c('div',{staticClass:"address_shipping"},[_c('span',[_c('img',{attrs:{"src":"/static/img/icon-location.png"}}),_vm._v("\n                      "+_vm._s(order.address_shipping.street)+" "+_vm._s(order.address_shipping.number)+"\n                    ")])]):_vm._e(),_vm._v(" "),(order.production_details && order.production_details.location)?_c('div',{staticClass:"production_details"},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('orders.ordLocation'))+":")]),_vm._v("\n                      "+_vm._s(order.production_details.location.name)+"\n                    ")]),_vm._v(" "),(order && order.shipping_details)?_c('span',{staticClass:"zone"},[_c('b',[_vm._v(_vm._s(_vm.$t('orders.zone'))+":")]),_vm._v("\n                      "+_vm._s(order.shipping_details.name)+"\n                    ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"total"},[_c('span',[_vm._v(_vm._s(order.totals_grandtotal)+" "+_vm._s(order.currency)+" ("+_vm._s(order.payment_type)+")")])]),_vm._v(" "),_c('div',{staticClass:"method"},[_c('div',{staticClass:"type"},[_vm._v(_vm._s(_vm.formatDeliveryType(order.delivery_type)))])])])])}):[_vm._m(1)]],2),_vm._v(" "),_c('div',{staticClass:"col-order prepared"},[_c('p',[_vm._v(_vm._s(_vm.$t('ordersStatus.PREPARED'))+" "),_c('span',[_vm._v(_vm._s(_vm.ordersCount.prepared))])]),_vm._v(" "),(_vm.orders.prepared && _vm.orders.prepared.length > 0)?_vm._l((_vm.orders.prepared),function(order){return _c('div',{key:order.id,staticClass:"order-card"},[_c('div',{staticClass:"order-top"},[_c('div',{staticClass:"örderId",on:{"click":function($event){_vm.goToOrder(order.id)}}},[_c('p',[_vm._v(_vm._s(_vm.$t('reports.order'))+" #"+_vm._s(order.number))])]),_vm._v(" "),_c('div',{staticClass:"orderDate"},[_c('img',{attrs:{"src":"/static/img/icon-calendar.png","alt":"Date Icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.pickup_datetime))])])]),_vm._v(" "),_c('div',{staticClass:"ord-client"},[_c('div',{staticClass:"client"},[_c('span',[_c('b',[_vm._v(_vm._s(order.delivery_details_firstname))])]),_vm._v(" "),_c('span',{staticClass:"phone"},[_vm._v(_vm._s(order.delivery_details_phone))])]),_vm._v(" "),_c('div',{staticClass:"address"},[(order && order.address_shipping)?_c('div',{staticClass:"address_shipping"},[_c('span',[_c('img',{attrs:{"src":"/static/img/icon-location.png"}}),_vm._v("\n                      "+_vm._s(order.address_shipping.street)+" "+_vm._s(order.address_shipping.number)+"\n                    ")])]):_vm._e(),_vm._v(" "),(order.production_details && order.production_details.location)?_c('div',{staticClass:"production_details"},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('orders.ordLocation'))+":")]),_vm._v("\n                      "+_vm._s(order.production_details.location.name)+"\n                    ")]),_vm._v(" "),(order && order.shipping_details)?_c('span',{staticClass:"zone"},[_c('b',[_vm._v(_vm._s(_vm.$t('orders.zone'))+":")]),_vm._v("\n                      "+_vm._s(order.shipping_details.name)+"\n                    ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"total"},[_c('span',[_vm._v(_vm._s(order.totals_grandtotal)+" "+_vm._s(order.currency)+" ("+_vm._s(order.payment_type)+")")])]),_vm._v(" "),_c('div',{staticClass:"method"},[_c('div',{staticClass:"type"},[_vm._v(_vm._s(_vm.formatDeliveryType(order.delivery_type)))])])])])}):[_vm._m(2)]],2),_vm._v(" "),_c('div',{staticClass:"col-order transport"},[_c('p',[_vm._v(_vm._s(_vm.$t('ordersStatus.TRANSPORT'))+" "),_c('span',[_vm._v(_vm._s(_vm.ordersCount.transport))])]),_vm._v(" "),(_vm.orders.transport && _vm.orders.transport.length > 0)?_vm._l((_vm.orders.transport),function(order){return _c('div',{key:order.id,staticClass:"order-card"},[_c('div',{staticClass:"order-top"},[_c('div',{staticClass:"örderId",on:{"click":function($event){_vm.goToOrder(order.id)}}},[_c('p',[_vm._v(_vm._s(_vm.$t('reports.order'))+" #"+_vm._s(order.number))])]),_vm._v(" "),_c('div',{staticClass:"orderDate"},[_c('img',{attrs:{"src":"/static/img/icon-calendar.png","alt":"Date Icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.pickup_datetime))])])]),_vm._v(" "),_c('div',{staticClass:"ord-client"},[_c('div',{staticClass:"client"},[_c('span',[_c('b',[_vm._v(_vm._s(order.delivery_details_firstname))])]),_vm._v(" "),_c('span',{staticClass:"phone"},[_vm._v(_vm._s(order.delivery_details_phone))])]),_vm._v(" "),_c('div',{staticClass:"address"},[(order && order.address_shipping)?_c('div',{staticClass:"address_shipping"},[_c('span',[_c('img',{attrs:{"src":"/static/img/icon-location.png"}}),_vm._v("\n                      "+_vm._s(order.address_shipping.street)+" "+_vm._s(order.address_shipping.number)+"\n                    ")])]):_vm._e(),_vm._v(" "),(order.production_details && order.production_details.location)?_c('div',{staticClass:"production_details"},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('orders.ordLocation'))+":")]),_vm._v("\n                      "+_vm._s(order.production_details.location.name)+"\n                    ")]),_vm._v(" "),(order && order.shipping_details)?_c('span',{staticClass:"zone"},[_c('b',[_vm._v(_vm._s(_vm.$t('orders.zone'))+":")]),_vm._v("\n                      "+_vm._s(order.shipping_details.name)+"\n                    ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"total"},[_c('span',[_vm._v(_vm._s(order.totals_grandtotal)+" "+_vm._s(order.currency)+" ("+_vm._s(order.payment_type)+")")])]),_vm._v(" "),_c('div',{staticClass:"method"},[_c('div',{staticClass:"type"},[_vm._v(_vm._s(_vm.formatDeliveryType(order.delivery_type)))])])])])}):[_vm._m(3)]],2),_vm._v(" "),_c('div',{staticClass:"col-order delivered"},[_c('p',[_vm._v(_vm._s(_vm.$t('ordersStatus.DELIVERED'))+" "),_c('span',[_vm._v(_vm._s(_vm.ordersCount.delivered))])]),_vm._v(" "),(_vm.orders.delivered && _vm.orders.delivered.length > 0)?_vm._l((_vm.orders.delivered),function(order){return _c('div',{key:order.id,staticClass:"order-card"},[_c('div',{staticClass:"order-top"},[_c('div',{staticClass:"örderId",on:{"click":function($event){_vm.goToOrder(order.id)}}},[_c('p',[_vm._v(_vm._s(_vm.$t('reports.order'))+" #"+_vm._s(order.number))])]),_vm._v(" "),_c('div',{staticClass:"orderDate"},[_c('img',{attrs:{"src":"/static/img/icon-calendar.png","alt":"Date Icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.pickup_datetime))])])]),_vm._v(" "),_c('div',{staticClass:"ord-client"},[_c('div',{staticClass:"client"},[_c('span',[_c('b',[_vm._v(_vm._s(order.delivery_details_firstname))])]),_vm._v(" "),_c('span',{staticClass:"phone"},[_vm._v(_vm._s(order.delivery_details_phone))])]),_vm._v(" "),_c('div',{staticClass:"address"},[(order && order.address_shipping)?_c('div',{staticClass:"address_shipping"},[_c('span',[_c('img',{attrs:{"src":"/static/img/icon-location.png"}}),_vm._v("\n                      "+_vm._s(order.address_shipping.street)+" "+_vm._s(order.address_shipping.number)+"\n                    ")])]):_vm._e(),_vm._v(" "),(order.production_details && order.production_details.location)?_c('div',{staticClass:"production_details"},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('orders.ordLocation'))+":")]),_vm._v("\n                      "+_vm._s(order.production_details.location.name)+"\n                    ")]),_vm._v(" "),(order && order.shipping_details)?_c('span',{staticClass:"zone"},[_c('b',[_vm._v(_vm._s(_vm.$t('orders.zone'))+":")]),_vm._v("\n                      "+_vm._s(order.shipping_details.name)+"\n                    ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"total"},[_c('span',[_vm._v(_vm._s(order.totals_grandtotal)+" "+_vm._s(order.currency)+" ("+_vm._s(order.payment_type)+")")])]),_vm._v(" "),_c('div',{staticClass:"method"},[_c('div',{staticClass:"type"},[_vm._v(_vm._s(_vm.formatDeliveryType(order.delivery_type)))])])])])}):[_vm._m(4)]],2),_vm._v(" "),_c('div',{staticClass:"col-order canceled"},[_c('p',[_vm._v(_vm._s(_vm.$t('ordersStatus.CANCELED'))+" "),_c('span',[_vm._v(_vm._s(_vm.ordersCount.canceled))])]),_vm._v(" "),(_vm.orders.canceled && _vm.orders.canceled.length > 0)?_vm._l((_vm.orders.canceled),function(order){return _c('div',{key:order.id,staticClass:"order-card"},[_c('div',{staticClass:"order-top"},[_c('div',{staticClass:"örderId",on:{"click":function($event){_vm.goToOrder(order.id)}}},[_c('p',[_vm._v(_vm._s(_vm.$t('reports.order'))+" #"+_vm._s(order.number))])]),_vm._v(" "),_c('div',{staticClass:"orderDate"},[_c('img',{attrs:{"src":"/static/img/icon-calendar.png","alt":"Date Icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.pickup_datetime))])])]),_vm._v(" "),_c('div',{staticClass:"ord-client"},[_c('div',{staticClass:"client"},[_c('span',[_c('b',[_vm._v(_vm._s(order.delivery_details_firstname))])]),_vm._v(" "),_c('span',{staticClass:"phone"},[_vm._v(_vm._s(order.delivery_details_phone))])]),_vm._v(" "),_c('div',{staticClass:"address"},[(order && order.address_shipping)?_c('div',{staticClass:"address_shipping"},[_c('span',[_c('img',{attrs:{"src":"/static/img/icon-location.png"}}),_vm._v("\n                      "+_vm._s(order.address_shipping.street)+" "+_vm._s(order.address_shipping.number)+"\n                    ")])]):_vm._e(),_vm._v(" "),(order.production_details && order.production_details.location)?_c('div',{staticClass:"production_details"},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('orders.ordLocation'))+":")]),_vm._v("\n                      "+_vm._s(order.production_details.location.name)+"\n                    ")]),_vm._v(" "),(order && order.shipping_details)?_c('span',{staticClass:"zone"},[_c('b',[_vm._v(_vm._s(_vm.$t('orders.zone'))+":")]),_vm._v("\n                      "+_vm._s(order.shipping_details.name)+"\n                    ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"total"},[_c('span',[_vm._v(_vm._s(order.totals_grandtotal)+" "+_vm._s(order.currency)+" ("+_vm._s(order.payment_type)+")")])]),_vm._v(" "),_c('div',{staticClass:"method"},[_c('div',{staticClass:"type"},[_vm._v(_vm._s(_vm.formatDeliveryType(order.delivery_type)))])])])])}):[_vm._m(5)]],2)]),_vm._v(" "),_c('vmodal',{staticClass:"filtersAndSortModal dispatch-filters-modal",attrs:{"name":"dispatchOrdersFiltersModal","height":"auto","width":"1200","adaptive":true,"scrollable":true}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header slim-header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('orders.filtersAndSort')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body slim-body"},[_c('div',{staticClass:"filters-grid"},[_c('div',{staticClass:"modal-column-left"},[_c('h6',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('orders.filters')))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.status')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons"},_vm._l((_vm.filteredStatuses),function(key){return _c('button',{key:key,class:'btn btn-status-filter ' + (_vm.modalRequestFilters[0].value.includes(key) ? 'btn-' + _vm.orderStatusClass(key) + ' current ' + key : 'btn-default'),on:{"click":function($event){_vm.toggleModalStatusFilter(key)}}},[_vm._v("\n                      "+_vm._s(_vm.formatLabelFirstLetter('ordersStatus.' + key))+"\n                    ")])}))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingCompany.deliveryType')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons delivery-type-buttons"},_vm._l((_vm.deliveryTypeOptions),function(dt){return _c('button',{key:dt,class:'btn btn-status-filter ' + (_vm.modalOrderFilters.deliveryType && _vm.modalOrderFilters.deliveryType.includes(dt) ? 'btn-primary current ' + dt : 'btn-default'),on:{"click":function($event){_vm.toggleModalDeliveryTypeFilter(dt)}}},[_vm._v("\n                      "+_vm._s(_vm.formatLabelFirstLetter('deliveryTypes.' + dt))+"\n                    ")])}))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.source')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons source-filter-buttons"},_vm._l((_vm.sourceOptions),function(src){return _c('button',{key:src,class:'btn btn-status-filter ' + (_vm.modalOrderFilters.source && _vm.modalOrderFilters.source.includes(src) ? 'btn-primary current ' + src : 'btn-default'),on:{"click":function($event){_vm.toggleModalSourceFilter(src)}}},[_vm._v("\n                      "+_vm._s(_vm.formatLabelFirstLetter('ordersSource.' + src))+"\n                    ")])}))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.payment')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons payment-type-buttons"},_vm._l((_vm.paymentTypeOptions),function(pt){return _c('button',{key:pt,class:'btn btn-status-filter ' + (_vm.modalOrderFilters.paymentType && _vm.modalOrderFilters.paymentType.includes(pt) ? 'btn-primary current ' + pt : 'btn-default'),on:{"click":function($event){_vm.toggleModalPaymentTypeFilter(pt)}}},[_vm._v("\n                      "+_vm._s(_vm.formatLabelFirstLetter('paymentTypes.' + pt))+"\n                    ")])}))])]),_vm._v(" "),_c('div',{staticClass:"modal-column-right"},[_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.pickupDatetime')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","placeholder":_vm.$t('orders.selectDateRange')},on:{"change":function($event){_vm.adjustDatetimeRange('pickupDatetime')}},model:{value:(_vm.modalOrderFilters.pickupDatetime),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "pickupDatetime", $$v)},expression:"modalOrderFilters.pickupDatetime"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.placedDatetime')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","placeholder":_vm.$t('orders.selectDateRange')},on:{"change":function($event){_vm.adjustDatetimeRange('placedDatetime')}},model:{value:(_vm.modalOrderFilters.placedDatetime),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "placedDatetime", $$v)},expression:"modalOrderFilters.placedDatetime"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"multiple":"","clearable":"","filterable":"","collapse-tags":"","placeholder":_vm.$t('orders.location')},model:{value:(_vm.modalLocationFilter),callback:function ($$v) {_vm.modalLocationFilter=$$v},expression:"modalLocationFilter"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:'modal-location-' + loc.id,attrs:{"label":loc.name,"value":_vm.getLocationFilterValue(loc)}})}))],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.orderId')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('orders.enterOrderId')},model:{value:(_vm.modalOrderFilters.orderId),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderId", $$v)},expression:"modalOrderFilters.orderId"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.orderNumber')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('orders.enterOrderNumber')},model:{value:(_vm.modalOrderFilters.orderNumber),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderNumber", $$v)},expression:"modalOrderFilters.orderNumber"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.operator')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"multiple":"","clearable":"","filterable":"","collapse-tags":"","placeholder":_vm.$t('reports.operator')},model:{value:(_vm.modalOrderFilters.operator),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "operator", $$v)},expression:"modalOrderFilters.operator"}},_vm._l((_vm.operatorOptions),function(op){return _c('el-option',{key:'op-' + op.id,attrs:{"label":op.label,"value":op.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.orderTotal')))]),_vm._v(" "),_c('div',{staticClass:"range-row"},[_c('el-input-number',{staticStyle:{"flex":"1","line-height":"44px"},attrs:{"placeholder":_vm.$t('orders.min'),"precision":2,"controls":false},model:{value:(_vm.modalOrderFilters.orderTotalMin),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderTotalMin", $$v)},expression:"modalOrderFilters.orderTotalMin"}}),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"flex":"1","line-height":"44px"},attrs:{"placeholder":_vm.$t('orders.max'),"precision":2,"controls":false},model:{value:(_vm.modalOrderFilters.orderTotalMax),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderTotalMax", $$v)},expression:"modalOrderFilters.orderTotalMax"}})],1)]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('general.sortOrder')))]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.modalSortOrder),callback:function ($$v) {_vm.modalSortOrder=$$v},expression:"modalSortOrder"}},_vm._l((_vm.sortOptions),function(sort){return _c('el-radio',{key:'sort-' + sort.id,staticStyle:{"display":"block","margin-bottom":"10px"},attrs:{"label":sort.id}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.sort' + sort.name))+"\n                    ")])}))],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer slim-footer"},[_c('el-button',{attrs:{"type":"default","size":"small"},on:{"click":_vm.resetModalFilters}},[_vm._v(_vm._s(_vm.$t('general.reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.applyFilters}},[_vm._v(_vm._s(_vm.$t('general.apply')))])],1)])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-orders"},[_c('img',{attrs:{"src":"/static/img/no-orders.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-orders"},[_c('img',{attrs:{"src":"/static/img/no-orders.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-orders"},[_c('img',{attrs:{"src":"/static/img/no-orders.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-orders"},[_c('img',{attrs:{"src":"/static/img/no-orders.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-orders"},[_c('img',{attrs:{"src":"/static/img/no-orders.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-orders"},[_c('img',{attrs:{"src":"/static/img/no-orders.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iVJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosForm_vue__ = __webpack_require__("acRM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77398307_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosForm_vue__ = __webpack_require__("ct2q");
function injectStyle (ssrContext) {
  __webpack_require__("lTxc")
  __webpack_require__("h7fB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77398307"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77398307_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iVuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InvoiceForm_vue__ = __webpack_require__("vYda");







var _components;


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InvoiceEdit',
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'InvoiceForm', __WEBPACK_IMPORTED_MODULE_6__InvoiceForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: { required: { required: true } }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "iWJC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("Yq4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog__ = __webpack_require__("qubY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_UIComponents_AvailableDaysSchedule_vue__ = __webpack_require__("Ah4W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_UIComponents_availableDaysSchedule_js__ = __webpack_require__("pdgj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_sweetalert2_dist_sweetalert2_css__);






















var _components;










__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_checkbox___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_checkbox___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_checkbox_group___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_checkbox_group___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_23_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'AvailableDaysSchedule', __WEBPACK_IMPORTED_MODULE_24_src_components_UIComponents_AvailableDaysSchedule_vue__["a" /* default */]), _components),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_vee_validate__["b" /* mapFields */])(['name', 'description', 'sort_order']), {
    currency: function currency() {
      var companyData = this.$session.get('selectedCompanyData');
      return companyData ? this.getCurrencySymbol(companyData.currency_iso) : '';
    }
  }),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      currentSubSection: 'l1',
      invalidTabs: [],
      language: '',
      languages: [],
      forceMethod: false,
      delivery_options_labels: false,
      selected_delivery_options_labels: false,
      originalLocationIds: [],
      selectedLocations: [],
      locations: [],
      mainCategories: [],
      selectedPlatforms: [],
      model: {},
      filelist: [],
      filelistToUpload: [],
      generalSuccess: '',
      modelValidations: {
        name: {
          required: true
        }
      },
      loading: true,
      deleteImage: false,
      overrideSchedule: false,
      availableDays: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_src_components_UIComponents_availableDaysSchedule_js__["a" /* createDefaultAvailableDays */])(),
      platforms: [{ id: 1, name: this.$t('addOrder.application') }, { id: 2, name: 'Website' }, { id: 6, name: 'QR' }]
    };
  },

  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      this.loading = true;
    });

    this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
      return {
        id: location.true_id,
        name: location.name
      };
    });

    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    this.loadLanguages();

    if (this.route.params.id) {
      var id = this.route.params.id;

      this.apiRequest('/topcategory/' + id, 'GET', data, function (response) {
        if (response.status) {
          if (response.data.top_category.image) {
            response.data.top_category.imagelist = [{ url: response.data.top_category.image }];
          } else {
            response.data.top_category.imagelist = [];
          }
          _this.model = response.data.top_category;
          _this.delivery_options_labels = response.data.delivery_options_labels;

          _this.forceMethod = response.data.top_category.is_force_method;
          _this.selected_delivery_options_labels = response.data.top_category.force_methods;

          if (_this.model.hide_from_platforms && _this.model.hide_from_platforms.length) {
            _this.selectedPlatforms = _this.model.hide_from_platforms.map(function (t) {
              return _this.platforms.find(function (f) {
                return f.id === t;
              });
            }) || [];
          }

          _this.initLocalizedFields();

          if (response.data.locations && response.data.locations.length) {
            _this.originalLocationIds = response.data.locations.slice();
            _this.selectedLocations = response.data.locations.map(function (id) {
              return _this.locations.find(function (loc) {
                return loc.id === id.location_id;
              });
            }).filter(Boolean);
          } else {
            _this.originalLocationIds = [];
            _this.selectedLocations = [];
          }

          _this.overrideSchedule = !!response.data.top_category.override_schedule;
          if (response.data.schedule_settings && response.data.schedule_settings.available_days) {
            _this.availableDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_src_components_UIComponents_availableDaysSchedule_js__["b" /* normalizeAvailableDays */])(response.data.schedule_settings.available_days);
          } else {
            _this.availableDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_src_components_UIComponents_availableDaysSchedule_js__["a" /* createDefaultAvailableDays */])();
          }

          _this.$nextTick(function () {
            this.loading = false;
          });
        }
      });
    } else {
      this.$nextTick(function () {
        this.loading = false;
      });
    }
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    loadLanguages: function loadLanguages() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/company-data', 'GET', data, function (response) {
        if (response.status === true && response.data && response.data.company) {
          _this2.languages = response.data.company.languages || [];
          _this2.language = response.data.company.language || '';
          _this2.initLocalizedFields();
        }
      });
    },
    openSubSection: function openSubSection(section) {
      this.currentSubSection = section;
    },
    initLocalizedFields: function initLocalizedFields() {
      var _this3 = this;

      if (!this.languages || !this.languages.length) {
        return;
      }
      if (!this.model.localized_fields || Array.isArray(this.model.localized_fields)) {
        this.$set(this.model, 'localized_fields', {});
      }
      this.languages.forEach(function (lang) {
        if (!_this3.model.localized_fields[lang.short]) {
          _this3.$set(_this3.model.localized_fields, lang.short, {
            language_id: lang.id,
            language_short: lang.short,
            name: '',
            description: ''
          });
        } else {
          _this3.model.localized_fields[lang.short].language_id = lang.id;
          _this3.model.localized_fields[lang.short].language_short = lang.short;
        }
      });
    },
    validateLocalizedNames: function validateLocalizedNames() {
      var _this4 = this;

      this.invalidTabs = [];
      var firstInvalidTab = null;

      if (!this.model.name || !String(this.model.name).trim()) {
        this.invalidTabs.push('l1');
        firstInvalidTab = 'l1';
      }

      this.languages.forEach(function (lang) {
        var lf = _this4.model.localized_fields ? _this4.model.localized_fields[lang.short] : null;
        var tabKey = lang.id + '-' + lang.short;
        if (!lf || !lf.name || !String(lf.name).trim()) {
          if (!_this4.invalidTabs.includes(tabKey)) {
            _this4.invalidTabs.push(tabKey);
          }
          if (!firstInvalidTab) {
            firstInvalidTab = tabKey;
          }
        }
      });

      if (firstInvalidTab) {
        this.currentSubSection = firstInvalidTab;
      }

      return this.invalidTabs.length === 0;
    },
    validateSchedule: function validateSchedule() {
      if (!this.overrideSchedule) {
        return true;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_src_components_UIComponents_availableDaysSchedule_js__["c" /* validateAvailableDays */])(this.availableDays);
    },
    validate: function validate() {
      var _this5 = this;

      this.$validator.validateAll().then(function (isValid) {
        var localizedValid = _this5.validateLocalizedNames();
        if (!localizedValid) {
          isValid = false;
        }

        var scheduleValid = _this5.validateSchedule();
        if (!scheduleValid) {
          isValid = false;
        }

        if (isValid) {
          _this5.errors.clear();
          _this5.saveCategory();
        } else if (!localizedValid) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            title: '',
            text: 'Numele este obligatoriu pentru toate limbile.',
            type: 'error',
            timer: 3000,
            showConfirmButton: false
          }).catch(function () {});
        } else if (!scheduleValid) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
            title: '',
            text: _this5.$t('settingsOrdering.overrideIntervalMissingHours'),
            type: 'error',
            timer: 3000,
            showConfirmButton: false
          }).catch(function () {});
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    isNew: function isNew() {
      if (this.route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
        this.model.image = null;
        this.deleteImage = true;
      }
    },
    handleDelete: function handleDelete(label) {
      var _this6 = this;

      var btnCounter = 3;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        text: this.$t('catalogCateg.areYouSure', { label: label }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          if (_this6.isNew()) {
            self.$bus.$emit('refresh');
            self.$bus.$emit('close-modal');
          } else {
            var id = _this6.route.params.id;
            var data = {
              id: id,
              token: _this6.$session.get('token'),
              company_id: _this6.$session.get('selectedCompany')
            };
            _this6.apiRequest('/topcategory/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                self.trackAdminEvent('ADMIN_TOP_CATEGORY_DELETED', 'top_category', id, {
                  top_category_id: id,
                  name: self.model && self.model.name || null
                });
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  title: '',
                  text: self.$t('catalogCateg.categDeleted'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                });

                self.$bus.$emit('refresh');
                self.$bus.$emit('close-modal');
              } else {
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        text: this.$t('general.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    handleImgChange: function handleImgChange(file, fileList) {
      var _this7 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
      if (this.model.imagelist && this.model.imagelist[0].status === 'ready') {
        this.getBase64(this.model.imagelist[0].raw).then(function (base64enc) {
          _this7.model.image = base64enc;
          _this7.deleteImage = false;
        });
      }
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    buildSavePayload: function buildSavePayload() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var includeSchedule = options.includeSchedule !== false;
      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.model);
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      data.is_force_method = this.forceMethod;
      data.force_methods = this.selected_delivery_options_labels;
      data.version = 3;
      data.delete_image = this.deleteImage;
      data.active = this.model.active || false;

      var originalIds = Array.isArray(this.originalLocationIds) ? this.originalLocationIds : [];
      var currentIds = Array.isArray(this.selectedLocations) ? this.selectedLocations.map(function (l) {
        return l && l.id;
      }).filter(Boolean) : [];

      var locationsPayload = [];

      if (Array.isArray(this.selectedLocations) && this.selectedLocations.length) {
        this.selectedLocations.forEach(function (loc) {
          if (!loc || !loc.id) return;
          var isOriginal = originalIds.some(function (item) {
            var locationId = item && item.location_id !== undefined ? item.location_id : item;
            return locationId === loc.id;
          });
          locationsPayload.push({
            id: isOriginal ? loc.id : null,
            location_id: loc.id,
            name: loc.name
          });
        });
      }

      if (originalIds.length) {
        originalIds.forEach(function (item) {
          var id = item && item.location_id !== undefined ? item.location_id : item;
          if (!currentIds.includes(id)) {
            locationsPayload.push({
              id: id,
              location_id: id,
              delete: true
            });
          }
        });
      }

      data.locations = locationsPayload;

      if (this.selectedPlatforms && this.selectedPlatforms.length) {
        data.hide_from_platforms = this.selectedPlatforms.map(function (element) {
          return element.id;
        });
      } else {
        data.hide_from_platforms = [];
      }

      if (data.monetary_conversion === '' || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data.monetary_conversion) === 'object') {
        data.monetary_conversion = null;
      }

      if (includeSchedule) {
        if (this.overrideSchedule) {
          data.override_schedule = true;
          data.schedule_settings = {
            available_days: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_src_components_UIComponents_availableDaysSchedule_js__["d" /* prepareAvailableDaysForSave */])(this.availableDays)
          };
        } else {
          data.override_schedule = false;
          delete data.schedule_settings;
        }
      } else {
        delete data.override_schedule;
        delete data.schedule_settings;
      }

      delete data.parent_category;

      return data;
    },
    handleSaveSuccess: function handleSaveSuccess(response) {
      var _this8 = this;

      var entityId = this.route.params && this.route.params.id || response && response.data && response.data.id || null;
      this.trackAdminEvent('ADMIN_TOP_CATEGORY_UPDATE', 'top_category', entityId, {
        top_category_id: entityId,
        name: this.model && this.model.name || null,
        active: !!(this.model && this.model.active),
        request: this._lastSaveRequest || null,
        response: response
      });
      this.$nextTick(function () {
        _this8.loading = false;
      });
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: '',
        text: this.$t('catalogCateg.categAdded'),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      }).catch(function () {});
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');

      if (response.locations && response.locations.length) {
        this.originalLocationIds = response.locations.slice();
        this.selectedLocations = response.locations.map(function (id) {
          return _this8.locations.find(function (loc) {
            return loc.id === id.location_id;
          });
        }).filter(Boolean);
      } else {
        this.originalLocationIds = [];
        this.selectedLocations = [];
      }
    },
    handleSaveError: function handleSaveError(response) {
      var _this9 = this;

      this.$nextTick(function () {
        _this9.loading = false;
      });
      __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
        title: '',
        text: response.errors && response.errors.error ? response.errors.error : this.$t('validations.wentWrong'),
        type: 'error',
        showConfirmButton: false,
        timer: 5000
      }).catch(function () {});
    },
    saveCategoryWithPut: function saveCategoryWithPut(id, data, onSuccess) {
      var _this10 = this;

      this.apiRequest('/topcategory/' + id, 'PUT', data, function (response) {
        if (response.status) {
          _this10._lastSaveRequest = data;
          if (typeof onSuccess === 'function') {
            onSuccess(response);
          } else {
            _this10.handleSaveSuccess(response);
          }
        } else {
          _this10.handleSaveError(response);
        }
      });
    },
    saveCategory: function saveCategory() {
      var _this11 = this;

      this.$nextTick(function () {
        this.loading = true;
      });

      var data = this.buildSavePayload();

      if (this.isNew()) {
        var postData = this.buildSavePayload({ includeSchedule: false });
        this.apiRequest('/topcategory/', 'POST', postData, function (response) {
          if (!response.status) {
            _this11.handleSaveError(response);
            return;
          }

          var newId = response.data && response.data.id;
          if (_this11.overrideSchedule && newId) {
            var putData = _this11.buildSavePayload();
            _this11.saveCategoryWithPut(newId, putData, function (putResponse) {
              if (putResponse.status) {
                _this11.handleSaveSuccess(putResponse);
              } else {
                _this11.$nextTick(function () {
                  _this11.loading = false;
                });
                __WEBPACK_IMPORTED_MODULE_26_sweetalert2___default()({
                  title: '',
                  text: _this11.$t('catalogCateg.categAdded') + ' ' + _this11.$t('validations.wentWrong'),
                  type: 'warning',
                  showConfirmButton: true
                }).catch(function () {});
                _this11.$bus.$emit('refresh');
                _this11.$bus.$emit('close-modal');
              }
            });
          } else {
            _this11.handleSaveSuccess(response);
          }
        });
      } else {
        this.saveCategoryWithPut(this.route.params.id, data);
      }
    },
    showMethods: function showMethods() {
      if (!this.forceMethod) {
        this.selected_delivery_options_labels = null;
      }
    }
  }
});

/***/ }),

/***/ "iXuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__ = __webpack_require__("wH4b");






var GlobalComponents = {
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "iY8r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-bar"},[(_vm.extraProp)?[_c('div',{staticClass:"row"},[(_vm.selectedLocation && _vm.selectedLocation.gestiune_start_sync_order)?_c('div',{staticClass:"info-note"},[_c('span',{staticClass:"info-title"},[_vm._v("ℹ️ Notă informativă")]),_vm._v(" "),_c('p',[_vm._v("\n            Vânzările pentru locația "),_c('strong',[_vm._v(_vm._s(_vm.selectedLocation.name))]),_vm._v(" apar doar începând cu data:\n            "),_c('strong',[_vm._v(_vm._s(_vm.formatDate(null, null, _vm.selectedLocation.gestiune_start_sync_order)))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"action-item"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))}))]),_vm._v(" "),_c('div',{staticClass:"action-item",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"action-item"},[_c('label',[_vm._v("Date și oră")]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"name":['date_from', 'date_to'],"disabled":_vm.loading || _vm.stocLaZi},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.triggerFilter}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])])]:[_c('div',{staticClass:"row"},[(_vm.selectedLocation && _vm.selectedLocation.gestiune_start_sync_order)?_c('div',{staticClass:"info-note"},[_c('span',{staticClass:"info-title"},[_vm._v("ℹ️ Notă informativă")]),_vm._v(" "),_c('p',[_vm._v("\n            Vânzările pentru locația "),_c('strong',[_vm._v(_vm._s(_vm.selectedLocation.name))]),_vm._v(" apar doar începând cu data:\n            "),_c('strong',[_vm._v(_vm._s(_vm.formatDate(null, null, _vm.selectedLocation.gestiune_start_sync_order)))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"action-item"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))}))]),_vm._v(" "),_c('div',{staticClass:"action-item"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"action-item"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.categoria')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategory),expression:"selectedCategory"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.categories),function(category){return _c('option',{key:category.value,domProps:{"value":category.value}},[_vm._v("\n              "+_vm._s(category.label)+"\n            ")])}))]),_vm._v(" "),_c('div',{staticClass:"action-item"},[_c('label',[_vm._v("Produs")]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Caută produsul...","filterable":"","remote":"","clearable":"","remote-method":_vm.fetchProducts,"loading":_vm.loadingProducts,"disabled":_vm.loading},on:{"change":_vm.handleProductSelect,"clear":_vm.handleClearProduct},model:{value:(_vm.selectedProduct),callback:function ($$v) {_vm.selectedProduct=$$v},expression:"selectedProduct"}},_vm._l((_vm.searchProdResults),function(product){return _c('el-option',{key:product._id,attrs:{"label":product.name,"value":product._id}},[[_vm._v("\n              "+_vm._s(product.name)+"\n              "),(product.categorie)?_c('span',{class:_vm.getCategoryClass(product.categorie),staticStyle:{"margin-left":"6px","padding":"2px 6px","border-radius":"50px","color":"white","font-size":"11px"}},[_vm._v("\n                "+_vm._s(product.categorie)+"\n              ")]):_vm._e()]],2)}))],1),_vm._v(" "),_c('div',{staticClass:"action-item"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.tipDocument')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDocumentType),expression:"selectedDocumentType"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedDocumentType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.documentTypes),function(doc){return _c('option',{key:doc.value,domProps:{"value":doc.value}},[_vm._v("\n              "+_vm._s(doc.label)+"\n            ")])}))]),_vm._v(" "),_c('div',{staticClass:"action-item"},[_c('label',[_vm._v("Număr document")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documentNumber),expression:"documentNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Număr document","disabled":_vm.loading},domProps:{"value":(_vm.documentNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.documentNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px","align-items":"center","flex-wrap":"nowrap","max-width":"min-content"}},[_c('div',{staticClass:"action-item full-width",staticStyle:{"flex":"1 1 3%"}},[_c('label',[_vm._v("Date și oră")]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"name":['date_from', 'date_to'],"disabled":_vm.loading || _vm.stocLaZi},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1),_vm._v(" "),_c('div',{staticClass:"action-item checkbox-item",staticStyle:{"flex":"1 1 30%","display":"flex","align-items":"flex-end","margin-left":"15px","max-width":"50px"}},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.stocLaZi),expression:"stocLaZi"}],attrs:{"type":"checkbox","disabled":_vm.loading},domProps:{"checked":Array.isArray(_vm.stocLaZi)?_vm._i(_vm.stocLaZi,null)>-1:(_vm.stocLaZi)},on:{"change":[function($event){var $$a=_vm.stocLaZi,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.stocLaZi=$$a.concat([$$v]))}else{$$i>-1&&(_vm.stocLaZi=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.stocLaZi=$$c}},_vm.handleStocLaZi]}}),_vm._v("\n            Stoc la zi\n          ")])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.triggerFilter}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.getData(null, 1, 3, 'xls')}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.getData(null, 1, 3, 'pdf')}}},[_vm._v(_vm._s(_vm.$t('general.download_pdf'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])])]],2),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),[_c('div',{staticClass:"data-table-wrapper"},[_c('table',{staticClass:"main-table"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.groupedTableData.length > 0)?[_vm._l((_vm.groupedTableData),function(prod){return [(_vm.stocLaZi)?_c('tr',{key:("stoc-line-" + (prod.productId))},[_c('td',{staticClass:"align-right name-product",attrs:{"colspan":"1"}},[_vm._v(_vm._s(prod.productName))]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v(_vm._s(prod.um))]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v(_vm._s(_vm.formatNumberWithZecimale(prod.totalIntrare)))]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v(_vm._s(_vm.formatNumberWithZecimale(prod.totalIesire)))]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v(_vm._s(_vm.formatNumberWithZecimale(prod.running)))]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v(_vm._s(_vm.formatNumberWithZecimale(prod.valoareIntrare)))]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v(_vm._s(_vm.formatNumberWithZecimale(prod.valoareIesire)))]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v(_vm._s(_vm.formatNumberWithZecimale(prod.runningValue)))])]):[_c('tr',{key:prod.productId,staticClass:"product-name-row"},[_c('td',{staticClass:"product-name-cell",attrs:{"colspan":9}},[_vm._v("\n                              "+_vm._s(prod.productName)+"\n                            ")])]),_vm._v(" "),_vm._l((prod.history),function(entry,index){return _c('tr',{key:((prod.productId) + "-" + (entry.document_id || 'nodoc') + "-" + index),staticClass:"history-row",class:{ 'first-history-row': index === 0 }},[_c('td',[_c('div',{staticClass:"entry-document-number",class:{ 'tooltip-wrapper': entry.document_type === 'NIR' },on:{"click":function($event){_vm.goToDocument(entry)}}},[_vm._v("\n                                "+_vm._s(_vm.getDocumentNumberLabel(entry))+"\n\n                                "),_vm._v(" "),(entry.document_type === 'NIR')?_c('div',{staticClass:"custom-tooltip"},[_c('div',{staticClass:"tooltip-row"},[_c('span',{staticClass:"tooltip-label"},[_vm._v(_vm._s(_vm.$t('gestiune.stockDocumentType')))]),_vm._v(" "),_c('span',{staticClass:"tooltip-value"},[_vm._v(_vm._s(entry.document.tip_document))])]),_vm._v(" "),_c('div',{staticClass:"tooltip-row"},[_c('span',{staticClass:"tooltip-label"},[_vm._v(_vm._s(_vm.$t('gestiune.nrDocument')))]),_vm._v(" "),_c('span',{staticClass:"tooltip-value"},[_vm._v("\n                                      "+_vm._s(entry.document.nirNumber || '-')+"\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"tooltip-row"},[_c('span',{staticClass:"tooltip-label"},[_vm._v(_vm._s(_vm.$t('gestiune.supplier')))]),_vm._v(" "),_c('span',{staticClass:"tooltip-value"},[_vm._v(_vm._s(entry.document.nume_furnizor)+" / "+_vm._s(entry.document.vatNumberFurnizor))])]),_vm._v(" "),_c('div',{staticClass:"tooltip-divider"}),_vm._v(" "),_c('div',{staticClass:"tooltip-row"},[_c('span',{staticClass:"tooltip-label"},[_vm._v(_vm._s(_vm.$t('gestiune.value')))]),_vm._v(" "),_c('span',{staticClass:"tooltip-value"},[_vm._v("\n                                      "+_vm._s(_vm.formatNumberWithZecimale(entry.document.total || 0))+"\n                                    ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"entry-date"},[_vm._v("\n                                "+_vm._s(_vm.formatDate(null, null, entry.date))+"\n                              ")]),_vm._v(" "),(entry.document && entry.document.produced_posId)?_c('div',{staticClass:"produced-label",staticStyle:{"display":"flex","align-items":"baseline"},on:{"click":function($event){$event.stopPropagation();_vm.goToProduced(entry)}}},[_vm._v("\n                                Vezi unde este folosit\n                              ")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"baseline"}},[_c('span',{class:['tag', _vm.toCssClass(entry.document_type === 'BON_FISCAL' && entry.document && entry.document.tip_vanzare ? entry.document.tip_vanzare : entry.document_type)],style:({
                                    backgroundColor: entry.document_type === 'BON_FISCAL' ? '#4CAF50' /* verde */
                                      : _vm.randomColor(entry.document_type || '')
                                  }),on:{"click":function($event){_vm.goToDocument(entry)}}},[_vm._v("\n                                  "+_vm._s(entry.document_type === 'BON_FISCAL' && entry.document && entry.document.tip_vanzare
                                    ? _vm.formatDocumentTypeLabel(entry.document.tip_vanzare)
                                    : _vm.formatDocumentTypeLabel(entry.document_type))+"\n                                ")])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s((entry.item && (entry.item.u_m || entry.item.um || entry.item.unitMeasure)) || ''))]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v("\n                              "+_vm._s((entry.document_type !== 'STOCK_INITIAL' && entry.intrare !== 0)
                                  ? _vm.formatNumberWithZecimale(entry.intrare)
                                  : '')+"\n                            ")]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v("\n                              "+_vm._s((entry.document_type !== 'STOCK_INITIAL' && entry.iesire !== 0)
                                  ? _vm.formatNumberWithZecimale(entry.iesire)
                                  : '')+"\n                            ")]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_c('strong',[_vm._v(_vm._s((entry.stoc_final !== undefined && entry.stoc_final !== null) ? _vm.formatNumberWithZecimale(entry.stoc_final) : '-'))])]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v(_vm._s(_vm.formatNumberWithZecimale(entry.pret, 4)))]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v("\n                              "+_vm._s((entry.document_type !== 'STOCK_INITIAL' && entry.intrare != 0 && entry.pret)
                                  ? _vm.formatNumberWithZecimale(entry.intrare * parseFloat(entry.pret) || 0)
                                  : '')+"\n                            ")]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_vm._v("\n                              "+_vm._s((entry.document_type !== 'STOCK_INITIAL' && entry.iesire !== 0 && entry.pret)
                                  ? _vm.formatNumberWithZecimale(entry.iesire * parseFloat(entry.pret) || 0)
                                  : '')+"\n                            ")]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_c('strong',[_vm._v(_vm._s(_vm.formatNumberWithZecimale(entry.valoare_stoc)))])])])}),_vm._v(" "),_c('tr',{staticClass:"history-total-row"},[_vm._m(1,true),_vm._v(" "),_c('td',{staticClass:"align-right"},[_c('strong',[_vm._v("\n                                "+_vm._s((prod.totalIntrare !== 0) ? _vm.formatNumberWithZecimale(prod.totalIntrare) : '')+"\n                              ")])]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_c('strong',[_vm._v("\n                                "+_vm._s((prod.totalIesire !== 0) ? _vm.formatNumberWithZecimale(prod.totalIesire) : '')+"\n                              ")])]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_c('strong',[_vm._v(_vm._s(prod.running !== null ? _vm.formatNumberWithZecimale(prod.running) : ''))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"align-right"},[_c('strong',[_vm._v("\n                                "+_vm._s((prod.valoareIntrare != null) ? _vm.formatNumberWithZecimale(prod.valoareIntrare) : '')+"\n                              ")])]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_c('strong',[_vm._v("\n                                "+_vm._s((prod.valoareIesire != null) ? _vm.formatNumberWithZecimale(prod.valoareIesire) : '')+"\n                              ")])]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_c('strong',[_vm._v(_vm._s(prod.runningValue !== null ? _vm.formatNumberWithZecimale(prod.runningValue) : ''))])])])]]})]:_c('tr',[_c('td',{staticStyle:{"text-align":"center","color":"#909399","padding":"20px"},attrs:{"colspan":9}},[_vm._v("\n                        "+_vm._s(_vm.$t('gestiune.noData'))+"\n                      ")])]),_vm._v(" "),(_vm.groupedTableData.length > 0)?_c('tr',{staticClass:"general-total-row"},[_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"6"}},[_c('strong',[_vm._v("\n                          TOTAL "),(_vm.selectedGestiuneObject)?_c('span',[_c('b',[_vm._v(_vm._s(_vm.selectedGestiuneObject.name))])]):_vm._e(),_vm._v(":\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_c('strong',[_vm._v("\n                          "+_vm._s(_vm.totalGeneral.valoareIntrare !== 0 ? _vm.formatNumberWithZecimale(_vm.totalGeneral.valoareIntrare) : '')+"\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_c('strong',[_vm._v("\n                          "+_vm._s(_vm.totalGeneral.valoareIesire !== 0 ? _vm.formatNumberWithZecimale(_vm.totalGeneral.valoareIesire) : '')+"\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"align-right"},[_c('strong',[_vm._v("\n                          "+_vm._s(_vm.totalGeneral.valoareStoc !== 0 ? _vm.formatNumberWithZecimale(_vm.totalGeneral.valoareStoc) : '')+"\n                        ")])])]):_vm._e()],2)])]),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})]],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"align-left",attrs:{"rowspan":"2"}},[_vm._v("TIP DOCUMENT")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"rowspan":"2"}},[_vm._v("UM")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"3"}},[_vm._v("CANTITATI")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"rowspan":"2"}},[_vm._v("PRET UNITAR")]),_vm._v(" "),_c('th',{staticClass:"align-center",attrs:{"colspan":"3"}},[_vm._v("VALOARE")])]),_vm._v(" "),_c('tr',{staticClass:"subheaders"},[_c('th',{staticClass:"align-center"},[_vm._v("INTRARI")]),_vm._v(" "),_c('th',{staticClass:"align-center"},[_vm._v("IESIRI")]),_vm._v(" "),_c('th',{staticClass:"align-center"},[_vm._v("STOC")]),_vm._v(" "),_c('th',{staticClass:"align-center"},[_vm._v("INTRARI")]),_vm._v(" "),_c('th',{staticClass:"align-center"},[_vm._v("IESIRI")]),_vm._v(" "),_c('th',{staticClass:"align-center"},[_vm._v("SOLD")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"2"}},[_c('strong',[_vm._v("Total Produs:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iZ3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportableReports_vue__ = __webpack_require__("MjZx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b36b3ff6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportableReports_vue__ = __webpack_require__("X8pp");
function injectStyle (ssrContext) {
  __webpack_require__("dVg1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b36b3ff6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportableReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b36b3ff6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportableReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iaD/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "icdU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 371.7 145.5"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 371.7 145.5","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_1_","y":"43.8","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_3_","d":"M0,92.7V52.8c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H9C4,101.7,0,97.7,0,92.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,101.7V43.8h57.9v57.9H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_5_","x":"270.9","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_7_","d":"M270.9,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C275,57.9,270.9,53.9,270.9,48.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M270.9,57.9V0h57.9v57.9H270.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_9_","x":"270.9","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_11_","d":"M270.9,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9\n            C275,145.5,270.9,141.5,270.9,136.5z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M270.9,145.5V87.6h57.9v57.9H270.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_13_","x":"302.1","y":"43.8","width":"69.7","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_15_","d":"M302.1,92.7V52.8c0-5,4-9,9-9h51.5c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-51.5\n            C306.1,101.7,302.1,97.7,302.1,92.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M302.1,101.7V43.8h69.4v57.9H302.1z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_17_","x":"194","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_19_","d":"M194,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H203C198,57.9,194,53.9,194,48.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M194,57.9V0h57.9v57.9H194z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_21_","x":"116.9","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_23_","d":"M116.9,48.9V9c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9C121,57.9,116.9,53.9,116.9,48.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st2",attrs:{"d":"M116.9,57.9V0h57.9v57.9H116.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_25_","x":"46","y":"43.8","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st13"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_27_","d":"M46,92.7V52.8c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H55C50,101.7,46,97.7,46,92.7z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('path',{staticClass:"st2",attrs:{"d":"M46,101.7V43.8h57.9v57.9H46z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_29_","x":"43.8","y":"0","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_30_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_29_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_31_","d":"M52.8,0h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H52.8c-5,0-9-4-9-9V9C43.8,4,47.8,0,52.8,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_32_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_31_"}})]),_vm._v(" "),_c('g',{staticClass:"st16"},[_c('path',{staticClass:"st2",attrs:{"d":"M43.8,0h57.9v57.9H43.8V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_33_","x":"43.8","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_34_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_33_"}})]),_vm._v(" "),_c('g',{staticClass:"st17"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_35_","d":"M52.8,87.6h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H52.8c-5,0-9-4-9-9V96.6C43.8,91.6,47.8,87.6,52.8,87.6z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_36_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_35_"}})]),_vm._v(" "),_c('g',{staticClass:"st18"},[_c('path',{staticClass:"st2",attrs:{"d":"M43.8,87.6h57.9v57.9H43.8V87.6z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_37_","x":"116.9","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_38_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_37_"}})]),_vm._v(" "),_c('g',{staticClass:"st19"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_39_","d":"M125.9,87.6h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9h-39.9c-5,0-9-4-9-9V96.6C116.9,91.6,121,87.6,125.9,87.6\n            z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_40_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_39_"}})]),_vm._v(" "),_c('g',{staticClass:"st20"},[_c('path',{staticClass:"st2",attrs:{"d":"M116.9,87.6h57.9v57.9h-57.9V87.6z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_41_","x":"194","y":"87.6","width":"57.9","height":"57.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_42_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_41_"}})]),_vm._v(" "),_c('g',{staticClass:"st21"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_43_","d":"M194,136.5V96.6c0-5,4-9,9-9h39.9c5,0,9,4,9,9v39.9c0,5-4,9-9,9H203C198,145.5,194,141.5,194,136.5z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_44_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_43_"}})]),_vm._v(" "),_c('g',{staticClass:"st22"},[_c('path',{staticClass:"st2",attrs:{"d":"M194,145.5V87.6h57.9v57.9H194z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_45_","x":"10.2","y":"10.2","width":"349.8","height":"125.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_46_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_45_"}})]),_vm._v(" "),_c('g',{staticClass:"st23"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t10_47_","d":"M24.2,10.2h322c7.7,0,14,6.3,14,14v97.1c0,7.7-6.3,14-14,14h-322c-7.7,0-14-6.3-14-14V24.2\n            C10.2,16.5,16.5,10.2,24.2,10.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_48_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_47_"}})]),_vm._v(" "),_c('g',{staticClass:"st24"},[_c('path',{staticClass:"st25",attrs:{"d":"M10.2,10.2H360v125.1H10.2V10.2z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t10_49_","x":"138.6","y":"25.2","width":"95.1","height":"95.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_50_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_49_"}})]),_vm._v(" "),_c('g',{staticClass:"st26"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"t10_51_","cx":"186.2","cy":"72.8","r":"47.6"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t10_52_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t10_51_"}})]),_vm._v(" "),_c('g',{staticClass:"st27"},[_c('path',{staticClass:"st2",attrs:{"d":"M138.6,25.2h95.1v95.1h-95.1V25.2z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ieps":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "igoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopCategories_vue__ = __webpack_require__("a6JB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_628cdb92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopCategories_vue__ = __webpack_require__("fgC7");
function injectStyle (ssrContext) {
  __webpack_require__("w45s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_628cdb92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ihiR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ij53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__ = __webpack_require__("XXU8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09b53c38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__ = __webpack_require__("M3Di");
function injectStyle (ssrContext) {
  __webpack_require__("JOpd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09b53c38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ijTy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "im4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);


/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }

        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ "imS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);
















var _components;









__WEBPACK_IMPORTED_MODULE_15_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_17_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      id: this.route.params.id || null,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      loading: true,
      locations: [],
      locations_formatted: [],
      model: {
        name: '',
        description: '',
        target_amount: null,
        fromto: [],
        active: true,
        imagelist: [],
        image: null,
        location_ids: [],
        funding_mode: 'client_optional',
        restaurant_flat_amount: null,
        restaurant_percent: null
      },
      modelValidations: {
        name: {
          required: true,
          min: 3
        },
        target_amount: {
          required: true,
          min_value: 0
        }
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          }
          return false;
        }
      }
    };
  },

  computed: {
    fundingModeOptions: function fundingModeOptions() {
      return [{
        value: 'client_optional',
        label: this.$t('donationCampaigns.fundingModeClientOptional')
      }, {
        value: 'restaurant_flat',
        label: this.$t('donationCampaigns.fundingModeRestaurantFlat')
      }, {
        value: 'restaurant_percent',
        label: this.$t('donationCampaigns.fundingModeRestaurantPercent')
      }];
    }
  },
  watch: {
    'model.funding_mode': function modelFunding_mode(mode) {
      if (mode !== 'restaurant_flat') {
        this.model.restaurant_flat_amount = null;
        this.errors.remove('restaurant_flat_amount');
      }
      if (mode !== 'restaurant_percent') {
        this.model.restaurant_percent = null;
        this.errors.remove('restaurant_percent');
      }
    }
  },
  created: function created() {
    var _this = this;

    this.loading = true;
    this.getLocations().then(function () {
      if (_this.id) {
        _this.getCampaign();
      } else {
        _this.loading = false;
      }
    }).catch(function () {
      _this.loading = false;
    });
  },

  methods: {
    setDonationCampaignImagelist: function setDonationCampaignImagelist(item) {
      if (item.image_url) {
        item.imagelist = item.image_url;
      } else if (item.image) {
        item.imagelist = [{ url: item.image }];
      } else {
        item.imagelist = [];
      }
      if (!Array.isArray(item.imagelist)) {
        item.imagelist = item.imagelist ? [{ url: String(item.imagelist) }] : [];
      }
    },
    getLocations: function getLocations() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var data = {
          token: _this2.$session.get('token'),
          company_id: _this2.$session.get('selectedCompany')
        };
        _this2.apiRequest('/get-locations', 'GET', data, function (response) {
          if (response.status) {
            _this2.locations = response.data;
            resolve();
          } else {
            reject(new Error('Failed to fetch locations'));
          }
        });
      });
    },
    getCampaign: function getCampaign() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/reports/donation-campaigns/' + this.id, 'GET', data, function (response) {
        if (response.status === true) {
          var item = response.data && response.data[0] ? response.data[0] : response.data;
          var startAt = item.starts_at || item.date_start;
          var endAt = item.ends_at || item.date_end;
          if (startAt && endAt) {
            item.fromto = [_this3.parseCampaignDateForPicker(startAt), _this3.parseCampaignDateForPicker(endAt)];
          } else {
            item.fromto = [];
          }
          _this3.setDonationCampaignImagelist(item);
          item.active = !!(parseInt(item.active) === 1 || item.active === true);
          if (!item.funding_mode) {
            item.funding_mode = 'client_optional';
          }
          _this3.model = item;
          if (item.locations_formatted) {
            _this3.locations_formatted = item.locations_formatted;
          } else if (item.location_ids && _this3.locations.length) {
            _this3.locations_formatted = _this3.locations.filter(function (loc) {
              return item.location_ids.includes(loc.id);
            });
          }
        }
        _this3.$nextTick(function () {
          _this3.loading = false;
        });
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    parseCampaignDateForPicker: function parseCampaignDateForPicker(value) {
      if (!value) return null;
      return __WEBPACK_IMPORTED_MODULE_20_moment___default()(String(value)).format('YYYY-MM-DD');
    },
    formatCampaignStartsAt: function formatCampaignStartsAt(date) {
      if (!date) return null;
      return __WEBPACK_IMPORTED_MODULE_20_moment___default()(String(date)).format('YYYY-MM-DD') + ' 00:00:00';
    },
    formatCampaignEndsAt: function formatCampaignEndsAt(date) {
      if (!date) return null;
      return __WEBPACK_IMPORTED_MODULE_20_moment___default()(String(date)).format('YYYY-MM-DD') + ' 23:59:59';
    },
    validate: function validate() {
      var _this4 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this4.errors.clear();
          _this4.saveCampaign();
        }
      });
    },
    isActiveCampaignExistsResponse: function isActiveCampaignExistsResponse(response) {
      return !!(response && response.errors && response.errors.code === 'ACTIVE_CAMPAIGN_EXISTS' && response.data);
    },
    handleActiveCampaignExists: function handleActiveCampaignExists(response) {
      var _this5 = this;

      var savedCampaign = response.data;
      var activeCampaign = savedCampaign.active_campaign || {};
      var campaignId = savedCampaign.id || this.id;

      this.model.active = false;
      if (!this.id && campaignId) {
        this.id = campaignId;
      }

      var message = this.$t('donationCampaigns.activeCampaignExistsMessage', { name: activeCampaign.name || '' });
      var warning = this.$t('donationCampaigns.activeCampaignExistsWarning');

      __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
        title: this.$t('donationCampaigns.activeCampaignExistsTitle'),
        html: message + '<br><br><strong>' + warning + '</strong>',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then(function (result) {
        if (result) {
          _this5.activateCampaign(campaignId);
        } else {
          _this5.backButton();
        }
      }).catch(function () {
        _this5.backButton();
      });
    },
    activateCampaign: function activateCampaign(campaignId) {
      var _this6 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        active: 1,
        force_active: true
      };
      this.apiRequest('/reports/donation-campaigns/' + campaignId, 'PUT', data, function (response) {
        if (response.status === true) {
          _this6.loading = false;
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
            title: '',
            text: _this6.$t('donationCampaigns.campaignUpdated'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
          _this6.backButton();
        } else if (_this6.isActiveCampaignExistsResponse(response)) {
          _this6.loading = false;
          _this6.handleActiveCampaignExists(response);
        } else {
          _this6.loading = false;
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', _this6.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, prop)) {
          if (Array.isArray(errors[prop]) && errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        }
      }
    },
    saveCampaign: function saveCampaign() {
      var _this7 = this;

      this.loading = true;
      var locationIds = (this.locations_formatted || []).map(function (loc) {
        return loc.id;
      });
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        name: this.model.name,
        description: this.model.description,
        target_amount: this.model.target_amount,
        active: this.model.active ? 1 : 0,
        location_ids: locationIds,
        funding_mode: this.model.funding_mode
      };

      if (this.model.funding_mode === 'restaurant_flat') {
        data.restaurant_flat_amount = this.model.restaurant_flat_amount;
      } else if (this.model.funding_mode === 'restaurant_percent') {
        data.restaurant_percent = this.model.restaurant_percent;
      }

      if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
        data.starts_at = this.formatCampaignStartsAt(this.model.fromto[0]);
        data.ends_at = this.formatCampaignEndsAt(this.model.fromto[1]);
      } else {
        data.starts_at = null;
        data.ends_at = null;
      }

      if (this.model.image) {
        data.image = this.model.image;
      } else if (Array.isArray(this.model.imagelist) && this.model.imagelist.length === 0) {
        data.image = '';
      }

      var url = this.id ? '/reports/donation-campaigns/' + this.id : '/reports/donation-campaigns';
      var httpMethod = this.id ? 'PUT' : 'POST';

      this.apiRequest(url, httpMethod, data, function (response) {
        if (response.status === true) {
          _this7.loading = false;
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
            title: '',
            text: _this7.id ? _this7.$t('donationCampaigns.campaignUpdated') : _this7.$t('donationCampaigns.campaignAdded'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
          _this7.backButton();
        } else if (_this7.isActiveCampaignExistsResponse(response)) {
          _this7.loading = false;
          _this7.handleActiveCampaignExists(response);
        } else {
          _this7.loading = false;
          if (response.errors) {
            _this7.handleErrors(response.errors);
          } else {
            __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', _this7.$t('validations.wentWrong'), 'error').catch(function () {});
          }
        }
      });
    },
    deleteCampaign: function deleteCampaign() {
      var _this8 = this;

      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
        text: this.$t('donationCampaigns.areYouSureDelete') + ' ' + (this.model.name || '') + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this8.$session.get('token'),
            company_id: _this8.$session.get('selectedCompany')
          };
          _this8.apiRequest('/reports/donation-campaigns/' + _this8.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', _this8.$t('donationCampaigns.campaignDeleted'), 'success').catch(function () {});
              _this8.backButton();
            } else {
              __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', _this8.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
      __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default.a.disableConfirmButton();
      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default.a.getConfirmButton().textContent = _this8.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default.a.getConfirmButton().textContent = _this8.$t('general.yes');
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    handleImgChange: function handleImgChange(file, fileList) {
      var _this9 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: this.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
        return;
      }
      if (fileList.length > 1) {
        this.model.imagelist = fileList.slice(1);
      } else {
        this.model.imagelist = fileList;
      }
      if (this.model.imagelist && this.model.imagelist[0] && this.model.imagelist[0].status === 'ready') {
        this.getBase64(this.model.imagelist[0].raw).then(function (base64enc) {
          _this9.model.image = base64enc;
        });
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
        this.model.image = null;
      }
    },
    handleExceed: function handleExceed() {
      __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
        text: this.$t('donationCampaigns.removeCurrentImage'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "in8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row settings-tabs full-height-tabs"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('vue-tabs',{ref:"tabs",staticClass:"row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs",attrs:{"direction":"vertical","value":"Description"},on:{"tab-change":_vm.handleTabChange}},[_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.products')}},[(_vm.isProducts)?_c('products-list',{attrs:{"isProducts":_vm.isProducts}}):_vm._e()],1),_vm._v(" "),(_vm.canAccessPriceLists())?_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.isPriceList')}},[(_vm.isPriceList)?_c('price-profile',{attrs:{"isPriceList":_vm.isPriceList}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.stock')}},[(_vm.isStock)?_c('stock',{attrs:{"isStock":_vm.isStock}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.categories')}},[(_vm.isCategories)?_c('categories',{attrs:{"isCategories":_vm.isCategories}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.topCategory')}},[(_vm.isTopCategories)?_c('top-categories',{attrs:{"isTopCategories":_vm.isTopCategories}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.productOptions')}},[(_vm.isProductOptions)?_c('product-options',{attrs:{"isProductOptions":_vm.isProductOptions}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.groupOptions')}},[(_vm.isGroupOptions)?_c('group-options',{attrs:{"isGroupOptions":_vm.isGroupOptions}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.productFilters')}},[(_vm.isProductFilters)?_c('product-filters',{attrs:{"isProductFilters":_vm.isProductFilters}}):_vm._e()],1),_vm._v(" "),_c('v-tab',{staticClass:"text-left",attrs:{"title":_vm.$t('pages.menuLinks')}},[(_vm.isMenuLinks)?_c('menu-links',{attrs:{"isMenuLinks":_vm.isMenuLinks}}):_vm._e()],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "isE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "isgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "isin":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Settings_SettingsGeneral_vue__ = __webpack_require__("x8jG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Settings_SettingsLocations_vue__ = __webpack_require__("Xzg0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Payment_Payment_vue__ = __webpack_require__("0+8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Settings_SettingsModules_vue__ = __webpack_require__("yQ4Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Settings_SettingsIntegrations_vue__ = __webpack_require__("yz4R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Settings_DeliveryPreferences_SettingsDeliveryType_vue__ = __webpack_require__("HySc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Settings_TaxesV2_vue__ = __webpack_require__("VmTP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_PosSettings_FiscalPrinterList_vue__ = __webpack_require__("ittn");











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SettingsGeneral: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Settings_SettingsGeneral_vue__["a" /* default */],
    SettingsLocations: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Settings_SettingsLocations_vue__["a" /* default */],
    Payment: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Payment_Payment_vue__["a" /* default */],
    SettingsModules: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Settings_SettingsModules_vue__["a" /* default */],
    SettingsIntegrations: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Settings_SettingsIntegrations_vue__["a" /* default */],
    SettingsDeliveryType: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Settings_DeliveryPreferences_SettingsDeliveryType_vue__["a" /* default */],
    TaxesV2: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Settings_TaxesV2_vue__["a" /* default */],
    FiscalPrinterList: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_PosSettings_FiscalPrinterList_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isGeneralSettings: false,
      isLocationSettings: false,
      isModuleManager: false,
      isPayment: false,
      isIntegrations: false,
      isDeliveryType: false,
      isTaxes: false,
      isFiscalPrinter: false
    };
  },
  mounted: function mounted() {
    this.switchTab();
  },

  methods: {
    resetStates: function resetStates() {
      this.isGeneralSettings = false;
      this.isLocationSettings = false;
      this.isModuleManager = false;
      this.isPayment = false;
      this.isIntegrations = false;
      this.isDeliveryType = false;
      this.isTaxes = false;
      this.isFiscalPrinter = false;
    },
    switchTab: function switchTab() {
      var _this = this;

      var index = this.$route.query.tabIndex;
      this.$nextTick(function () {
        if (index && _this.$refs.tabs) {
          _this.$refs.tabs.navigateToTab(parseInt(index));
        }
      });
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      this.resetStates();
      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);
      switch (newTab.title) {
        case this.$t('settingsPages.generalSettings'):
          this.isGeneralSettings = true;
          break;
        case this.$t('deliveryPreferences.deliveryTypeTitle'):
          this.isDeliveryType = true;
          break;
        case this.$t('settingsPages.locationSettings'):
          this.isLocationSettings = true;
          break;
        case this.$t('settingsPages.moduleManager'):
          this.isModuleManager = true;
          break;
        case this.$t('pages.payment'):
          this.isPayment = true;
          break;
        case this.$t('settingsPages.integrations'):
          this.isIntegrations = true;
          break;
        case 'Taxe':
          this.isTaxes = true;
          break;
        case this.$t('settingsPages.fiscalPrinter'):
          this.isFiscalPrinter = true;
          break;
        default:
          this.isGeneralSettings = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ "ittn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiscalPrinterList_vue__ = __webpack_require__("DYlH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a72d3634_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiscalPrinterList_vue__ = __webpack_require__("xwFm");
function injectStyle (ssrContext) {
  __webpack_require__("ucEP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiscalPrinterList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a72d3634_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiscalPrinterList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ityG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iuHn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j/DZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);











var _components;









__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */],

    PSwitch: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'draggable', __WEBPACK_IMPORTED_MODULE_12_vuedraggable___default.a), _components),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    },
    isTable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.token = this.$session.get('token');
    this.getData();
  },
  mounted: function mounted() {
    this.$bus.$on('refresh', this.onRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh');
  },
  data: function data() {
    return {
      loading: true,
      loading2: true,
      token: null,
      apiUrl: null,
      optionData: []
    };
  },

  methods: {
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/group-option/edit/');
    },
    onRefresh: function onRefresh() {
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/group-options', 'GET', data, function (response) {
        if (response.status === true) {
          _this.optionData = response.data;

          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    },
    adjustSort: function adjustSort() {}
  }
});

/***/ }),

/***/ "j0rp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NexusItems',
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    activeRoute: function activeRoute() {
      return this.route && this.route.params ? this.route : this.$route;
    },
    orderId: function orderId() {
      return this.activeRoute.params.orderId || '-';
    }
  },
  watch: {
    orderId: function orderId(newVal, oldVal) {
      if (String(newVal || '') === String(oldVal || '')) return;
      this.currentPage = 1;
      this.fetchItems();
    }
  },
  data: function data() {
    return {
      loading: false,
      items: [],
      selectedLog: null,
      timezone: null,
      currentPage: 1,
      pageSize: 20,
      total: 0
    };
  },
  created: function created() {
    this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest';
    this.fetchItems();
  },

  methods: {
    goBackToReport: function goBackToReport() {
      var orderId = this.activeRoute.params.orderId;
      this.$bus.$emit('refresh', orderId);
      this.$bus.$emit('close-modal');
    },
    fetchItems: function fetchItems() {
      var _this = this;

      var orderId = this.activeRoute.params.orderId;
      if (!orderId) return;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.loading = true;
      var url = '/nexus/logs/' + orderId + '?page=' + this.currentPage + '&perPage=' + this.pageSize;
      this.apiRequest(url, 'GET', data, function (response) {
        if (response && response.status) {
          _this.items = Array.isArray(response.data) ? response.data : [];
          if (response.pagination) {
            _this.total = response.pagination.total || 0;
            _this.currentPage = response.pagination.page || 1;
            _this.pageSize = response.pagination.perPage || _this.pageSize;
          }
        } else {
          _this.items = [];
          _this.total = 0;
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()('', response && response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.fetchItems();
    },
    onPageSizeChange: function onPageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchItems();
    },
    openLogModal: function openLogModal(row) {
      this.selectedLog = row;
      this.$modal.show('nexusLogModal');
    },
    truncate: function truncate(val) {
      var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;

      if (!val) return '-';
      var str = typeof val === 'string' ? val : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val);
      return str.length > len ? str.slice(0, len) + '…' : str;
    },
    prettyJson: function prettyJson(val) {
      if (!val) return '';
      try {
        var parsed = typeof val === 'string' ? JSON.parse(val) : val;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(parsed, null, 2);
      } catch (e) {
        return typeof val === 'string' ? val : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val);
      }
    }
  }
});

/***/ }),

/***/ "j50F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j55m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat) + " — Locații: " + (group.locations.map(function (l) { return l.name; }).join(', ')))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group",staticStyle:{"display":"grid","margin-top":"15px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.series')))]),_vm._v(" "),_c('el-input',{ref:"seriesInput",attrs:{"disabled":_vm.loading,"placeholder":"Introdu seria facturii"},on:{"input":_vm.onSeriesInput},model:{value:(_vm.filter.series),callback:function ($$v) {_vm.$set(_vm.filter, "series", $$v)},expression:"filter.series"}})],1)]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.addInvoice($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('invoice.addProforma'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"prop":"invoiceNumber","label":_vm.$t('invoice.invoice'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"series","label":_vm.$t('invoice.series'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"client","label":_vm.$t('invoice.client'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"issueDate","label":_vm.$t('invoice.issueDate'),"formatter":_vm.formatDate}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valueNoVAT","label":_vm.$t('invoice.valueNoVAT')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vatValue","label":_vm.$t('invoice.vatValue')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalValue","label":_vm.$t('invoice.totalValue')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('invoice.status'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                    ▾ ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editInvoice(scope.row.invoiceNumber, scope.row.series)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.edit'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.invoice(scope.row.invoiceNumber, scope.row.series)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('invoice.invoiced'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadInvoice(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('invoice.download'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadExcel(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('gestiune.downloadExcel'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},attrs:{"disabled":scope.$index !== 0},nativeOn:{"click":function($event){scope.$index === 0 && _vm.handleDeleteProforma(scope.row.id)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j9Hv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j9UV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('management-my-orders-suppliers-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jAxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlovoLaasIntegrationForm_vue__ = __webpack_require__("/VMh");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlovoLaasIntegrationForm_vue__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlovoLaasIntegrationForm_vue__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ae5e5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlovoLaasIntegrationForm_vue__ = __webpack_require__("pHsS");
function injectStyle (ssrContext) {
  __webpack_require__("Dsif")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59ae5e5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlovoLaasIntegrationForm_vue__["c" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ae5e5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlovoLaasIntegrationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["c"] = (Component.exports);


/***/ }),

/***/ "jAzQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jCme":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_time_picker_css__ = __webpack_require__("5ObC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_time_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_picker__ = __webpack_require__("4ZDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__ = __webpack_require__("Ark/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_css__);






















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_time_picker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PSwitch: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Switch_vue__["a" /* default */], SearchableMultiSelect: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__["a" /* default */] },
  props: {
    route: { type: Object, default: function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      id: null,
      loading: true,
      locations: [],
      locationIds: [],
      productsSelected: [],
      categoriesSelected: [],
      deliveryMethodOptions: ['PICK_UP', 'DELIVERY', 'MEET_HALF', 'EAT_LOCATION', 'SELF_ORDERING'],
      sourceOptions: [{ id: 1, label: 'Kiosk' }, { id: 2, label: 'QR' }, { id: 3, label: 'POS' }, { id: 4, label: 'App' }, { id: 5, label: 'Website' }],
      dayOptions: [{ id: 0, label: this.$t('challengeCampaigns.daySun') }, { id: 1, label: this.$t('challengeCampaigns.dayMon') }, { id: 2, label: this.$t('challengeCampaigns.dayTue') }, { id: 3, label: this.$t('challengeCampaigns.dayWed') }, { id: 4, label: this.$t('challengeCampaigns.dayThu') }, { id: 5, label: this.$t('challengeCampaigns.dayFri') }, { id: 6, label: this.$t('challengeCampaigns.daySat') }],
      model: {
        title: '',
        description: '',
        target: 1,
        min_order_value: null,
        period_of_time_days: null,
        distinct_order: false,
        active: true,
        fromto: [],
        order_time_from: null,
        order_time_to: null,
        delivery_methods: [],
        order_source_ids: [],
        days: [],
        imagelist: [],
        image: null
      }
    };
  },

  computed: {
    currency: function currency() {
      var company = this.$session.get('selectedCompanyData') || {};
      return company.currency_iso || '';
    },
    conditionsSummaryText: function conditionsSummaryText() {
      return this.buildConditionsSummary();
    }
  },
  created: function created() {
    var _this = this;

    this.id = this.route && this.route.params && this.route.params.id || this.$route.params && this.$route.params.id || null;
    this.getLocations().then(function () {
      if (_this.id) _this.getCampaign();else _this.loading = false;
    }).catch(function () {
      _this.loading = false;
    });
  },

  methods: {
    formatList: function formatList(items) {
      return (items || []).filter(Boolean).join(', ');
    },
    shortTime: function shortTime(value) {
      if (!value) return '';
      return String(value).substring(0, 5);
    },
    buildConditionsSummary: function buildConditionsSummary() {
      var _this2 = this;

      var parts = [];
      var target = parseInt(this.model.target, 10) || 1;
      var hasProducts = (this.productsSelected || []).length > 0;
      var hasCategories = (this.categoriesSelected || []).length > 0;
      var membershipOnly = !!this.model.period_of_time_days && !hasProducts && !hasCategories;

      if (membershipOnly) {
        parts.push(this.$t('challengeCampaigns.summaryMembership', {
          days: this.model.period_of_time_days,
          target: target
        }));
      } else if (this.model.distinct_order || !hasProducts && !hasCategories) {
        parts.push(this.$t('challengeCampaigns.summaryOrders', { target: target }));
      } else {
        parts.push(this.$t('challengeCampaigns.summaryProductQty', { target: target }));
      }

      if (this.model.min_order_value) {
        parts.push(this.$t('challengeCampaigns.summaryMinOrder', {
          amount: this.model.min_order_value,
          currency: this.currency
        }));
      }

      if ((this.locationIds || []).length) {
        var names = this.locations.filter(function (l) {
          return _this2.locationIds.indexOf(l.id) !== -1;
        }).map(function (l) {
          return l.name;
        });
        parts.push(this.$t('challengeCampaigns.summaryLocations', { list: this.formatList(names) }));
      }

      if ((this.model.delivery_methods || []).length) {
        var _names = this.model.delivery_methods.map(function (m) {
          return _this2.$t('deliveryTypes.' + m);
        });
        parts.push(this.$t('challengeCampaigns.summaryDelivery', {
          list: this.formatList(_names)
        }));
      }

      if ((this.model.order_source_ids || []).length) {
        var _names2 = this.sourceOptions.filter(function (s) {
          return _this2.model.order_source_ids.indexOf(s.id) !== -1;
        }).map(function (s) {
          return s.label;
        });
        parts.push(this.$t('challengeCampaigns.summarySources', { list: this.formatList(_names2) }));
      }

      if ((this.model.days || []).length) {
        var _names3 = this.dayOptions.filter(function (d) {
          return _this2.model.days.indexOf(d.id) !== -1;
        }).map(function (d) {
          return d.label;
        });
        parts.push(this.$t('challengeCampaigns.summaryDays', { list: this.formatList(_names3) }));
      }

      if (this.model.order_time_from || this.model.order_time_to) {
        parts.push(this.$t('challengeCampaigns.summaryOrderTime', {
          from: this.shortTime(this.model.order_time_from) || '—',
          to: this.shortTime(this.model.order_time_to) || '—'
        }));
      }

      if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
        parts.push(this.$t('challengeCampaigns.summaryPeriod', {
          from: this.model.fromto[0],
          to: this.model.fromto[1]
        }));
      }

      if (hasProducts) {
        var _names4 = (this.productsSelected || []).map(function (p) {
          return p.label || p.name || '#' + p.id;
        });
        parts.push(this.$t('challengeCampaigns.summaryProducts', { list: this.formatList(_names4) }));
      }

      if (hasCategories) {
        var _names5 = (this.categoriesSelected || []).map(function (c) {
          return c.label || c.name || '#' + c.id;
        });
        parts.push(this.$t('challengeCampaigns.summaryCategories', { list: this.formatList(_names5) }));
      }

      if (this.model.period_of_time_days && !membershipOnly) {
        parts.push(this.$t('challengeCampaigns.summaryWithinDays', {
          days: this.model.period_of_time_days
        }));
      }

      return parts.join(' ');
    },
    getLocations: function getLocations() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var data = {
          token: _this3.$session.get('token'),
          company_id: _this3.$session.get('selectedCompany')
        };
        _this3.apiRequest('/get-locations', 'GET', data, function (response) {
          if (response.status) {
            _this3.locations = response.data || [];
            resolve();
          } else reject(new Error('locations'));
        });
      });
    },
    getCampaign: function getCampaign() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/challenge-campaigns/' + this.id, 'GET', data, function (response) {
        if (response.status && response.data) {
          var item = response.data;
          _this4.model.title = item.title;
          _this4.model.description = item.description;
          _this4.model.target = item.target;
          _this4.model.min_order_value = item.min_order_value;
          _this4.model.period_of_time_days = item.period_of_time_days;
          _this4.model.distinct_order = !!item.distinct_order;
          _this4.model.active = !!item.active;
          _this4.model.delivery_methods = item.delivery_methods || [];
          _this4.model.order_source_ids = item.order_source_ids || [];
          _this4.model.days = item.days || [];
          _this4.model.order_time_from = item.order_time_from;
          _this4.model.order_time_to = item.order_time_to;
          if (item.time_from && item.time_to) {
            _this4.model.fromto = [item.time_from, item.time_to];
          }
          if (item.image) {
            _this4.model.imagelist = [{ url: item.image }];
            _this4.model.image = item.image;
          }
          _this4.locationIds = item.location_ids || [];
          if (Array.isArray(item.products) && item.products.length) {
            _this4.productsSelected = item.products.map(function (p) {
              return {
                id: p.id,
                label: p.label || p.name || '#' + p.id
              };
            });
          } else {
            _this4.productsSelected = (item.product_ids || []).map(function (id) {
              return { id: id, label: '#' + id };
            });
          }
          if (Array.isArray(item.categories) && item.categories.length) {
            _this4.categoriesSelected = item.categories.map(function (c) {
              return {
                id: c.id,
                label: c.label || c.name || '#' + c.id
              };
            });
          } else {
            _this4.categoriesSelected = (item.category_ids || []).map(function (id) {
              return { id: id, label: '#' + id };
            });
          }
        }
        _this4.loading = false;
      });
    },
    validate: function validate() {
      var _this5 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) _this5.saveCampaign();
      });
    },
    saveCampaign: function saveCampaign() {
      var _this6 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        title: this.model.title,
        description: this.model.description,
        target: this.model.target || 1,
        min_order_value: this.model.min_order_value || null,
        period_of_time_days: this.model.period_of_time_days || null,
        distinct_order: this.model.distinct_order ? 1 : 0,
        active: this.model.active ? 1 : 0,
        location_ids: this.locationIds || [],
        delivery_methods: this.model.delivery_methods || [],
        order_source_ids: this.model.order_source_ids || [],
        days: this.model.days || [],
        product_ids: (this.productsSelected || []).map(function (p) {
          return p.id;
        }),
        category_ids: (this.categoriesSelected || []).map(function (c) {
          return c.id;
        }),
        order_time_from: this.model.order_time_from || null,
        order_time_to: this.model.order_time_to || null,
        time_from: this.model.fromto && this.model.fromto[0] ? this.model.fromto[0] : null,
        time_to: this.model.fromto && this.model.fromto[1] ? this.model.fromto[1] : null
      };
      if (this.model.image && String(this.model.image).indexOf('http') !== 0) {
        data.image = this.model.image;
      } else if (this.model.image && String(this.model.image).indexOf('data:') === 0) {
        data.image = this.model.image;
      } else if (Array.isArray(this.model.imagelist) && this.model.imagelist.length === 0) {
        data.image = '';
      } else if (this.model.image) {
        data.image = this.model.image;
      }

      var url = this.id ? '/challenge-campaigns/' + this.id : '/challenge-campaigns';
      var method = this.id ? 'PUT' : 'POST';
      this.apiRequest(url, method, data, function (response) {
        _this6.loading = false;
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
            title: '',
            text: _this6.id ? _this6.$t('challengeCampaigns.campaignUpdated') : _this6.$t('challengeCampaigns.campaignAdded'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
          _this6.backButton();
        } else if (response.errors) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.errors).forEach(function (k) {
            var msg = Array.isArray(response.errors[k]) ? response.errors[k][0] : response.errors[k];
            _this6.errors.add(k, msg);
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()('', _this6.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    deleteCampaign: function deleteCampaign() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({
        text: this.$t('challengeCampaigns.areYouSureDelete') + ' ' + (this.model.title || '') + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (!result) return;
        var data = {
          token: _this7.$session.get('token'),
          company_id: _this7.$session.get('selectedCompany')
        };
        _this7.apiRequest('/challenge-campaigns/' + _this7.id, 'DELETE', data, function (response) {
          if (response.status) _this7.backButton();else __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()('', _this7.$t('validations.wentWrong'), 'error').catch(function () {});
        });
      }).catch(function () {});
    },
    handleImgChange: function handleImgChange(file, fileList) {
      var _this8 = this;

      if (file.size / 1024 / 1024 >= 5) {
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
        return;
      }
      this.model.imagelist = fileList.length > 1 ? fileList.slice(1) : fileList;
      if (this.model.imagelist[0] && this.model.imagelist[0].raw) {
        this.getBase64(this.model.imagelist[0].raw).then(function (base64enc) {
          _this8.model.image = base64enc;
        });
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (!fileList.length) {
        this.model.imagelist = [];
        this.model.image = null;
      }
    },
    handleExceed: function handleExceed() {
      __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default()({ text: this.$t('challengeCampaigns.removeCurrentImage'), type: 'warning' });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "jD3L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-button"},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"1"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"})]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"label":"Număr Document","prop":"documentNumber"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.documentNumber)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Serie","prop":"series"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.series)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Date","prop":"date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(new Date(scope.row.date).toLocaleDateString('ro-RO'))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Status","prop":"status"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{style:(_vm.getStatusStyle(scope.row.status))},[_vm._v("\n                    "+_vm._s(scope.row.status)+"\n                  ")])]}}])}),_vm._v(" "),(_vm.showAvizColumn)?_c('el-table-column',{attrs:{"label":"Aviz","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s((scope.row.externalDocIds && scope.row.externalDocIds.aviz)
                      ? scope.row.externalDocIds.aviz.series + ' - ' + scope.row.externalDocIds.aviz.number
                      : '-')+"\n                ")]}}])}):_vm._e(),_vm._v(" "),(_vm.showNirColumn)?_c('el-table-column',{attrs:{"label":"NIR","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s((scope.row.externalDocIds && scope.row.externalDocIds.nir)
                      ? scope.row.externalDocIds.nir.number
                      : '-')+"\n                ")]}}])}):_vm._e(),_vm._v(" "),(_vm.showInvoiceColumn)?_c('el-table-column',{attrs:{"label":"Factura","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s((scope.row.externalDocIds && scope.row.externalDocIds.invoice)
                      ? scope.row.externalDocIds.invoice.series + ' - ' + scope.row.externalDocIds.invoice.number
                      : '-')+"\n                ")]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.userHasRight('can_process_supplier_order'))?_c('a',{directives:[{name:"show",rawName:"v-show",value:(scope.row.status.toLowerCase() === 'sent'),expression:"scope.row.status.toLowerCase() === 'sent'"}],staticClass:"btn btn-info mar-rt-10",on:{"click":function($event){_vm.processOrder(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('gestiune.process'))+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.userHasRight('can_generate_aviz'))?_c('a',{directives:[{name:"show",rawName:"v-show",value:(scope.row.status.toLowerCase() === 'processed' && !(scope.row.externalDocIds && scope.row.externalDocIds.aviz)),expression:"scope.row.status.toLowerCase() === 'processed' && !(scope.row.externalDocIds && scope.row.externalDocIds.aviz)"}],staticClass:"btn btn-info mar-rt-10",attrs:{"title":scope.row.status.toLowerCase() !== 'processed'
                            ? 'Avizul poate fi generat doar pentru comenzile procesate.'
                            : (scope.row.externalDocIds && scope.row.externalDocIds.aviz) ? 'Aviz deja generat' : ''},on:{"click":function($event){_vm.aviz(scope.row)}}},[(scope.row.externalDocIds && scope.row.externalDocIds.aviz)?[_vm._v("\n                      "+_vm._s(_vm.$t('gestiune.aviz'))+": "+_vm._s(scope.row.externalDocIds.aviz.series)+" - "+_vm._s(scope.row.externalDocIds.aviz.number)+"\n                    ")]:[_vm._v("\n                      "+_vm._s(_vm.$t('gestiune.aviz'))+"\n                    ")]],2):_vm._e(),_vm._v(" "),(_vm.userHasRight('can_generate_invoice') && !(scope.row.supplierVatNumber && scope.row.supplierVatNumber === scope.row.vatNumber))?_c('a',{directives:[{name:"show",rawName:"v-show",value:(!(
                      ['sent', 'processed'].includes(scope.row.status.toLowerCase())
                      || (scope.row.externalDocIds && scope.row.externalDocIds.invoice)
                      || (scope.row.externalDocIds && 'bonTransfer' in scope.row.externalDocIds)
                    )),expression:"!(\n                      ['sent', 'processed'].includes(scope.row.status.toLowerCase())\n                      || (scope.row.externalDocIds && scope.row.externalDocIds.invoice)\n                      || (scope.row.externalDocIds && 'bonTransfer' in scope.row.externalDocIds)\n                    )"}],staticClass:"btn btn-info mar-rt-10",attrs:{"title":['sent', 'processed'].includes(scope.row.status.toLowerCase())
                            ? 'Factura nu poate fi generată pentru comenzile cu status SENT sau PROCESSED.'
                            : (scope.row.externalDocIds && scope.row.externalDocIds.invoice) ? 'Factură deja generată'
                            : (scope.row.externalDocIds && 'bonTransfer' in scope.row.externalDocIds) ? 'Bon transfer deja generat'
                            : ''},on:{"click":function($event){_vm.invoice(scope.row)}}},[(scope.row.externalDocIds && scope.row.externalDocIds.invoice)?[_vm._v("\n                      "+_vm._s(_vm.$t('gestiune.invoice'))+": "+_vm._s(scope.row.externalDocIds.invoice.series)+" - "+_vm._s(scope.row.externalDocIds.invoice.number)+"\n                    ")]:[_vm._v("\n                      "+_vm._s(_vm.$t('gestiune.invoice'))+"\n                    ")]],2):_vm._e()]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jKDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Kds_vue__ = __webpack_require__("RMTn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KdsSettings_vue__ = __webpack_require__("An/G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KdsReport_vue__ = __webpack_require__("p7YO");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Kds: __WEBPACK_IMPORTED_MODULE_0__Kds_vue__["a" /* default */],
    KdsSettings: __WEBPACK_IMPORTED_MODULE_1__KdsSettings_vue__["a" /* default */],
    KdsReport: __WEBPACK_IMPORTED_MODULE_2__KdsReport_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isKds: false,
      isReport: false,
      isSettings: false,
      openUsers: false
    };
  },
  mounted: function mounted() {
    console.log(this.$route.query.openUsers);
    if (this.$route.query.openUsers) {
      this.openUsers = true;
    }
    this.switchTab();
  },

  methods: {
    resetStates: function resetStates() {
      this.isKds = false;
      this.isOds = false;
      this.isReport = false;
      this.isSettings = false;
      this.openUsers = false;
    },
    switchTab: function switchTab() {
      var _this = this;

      var index = this.$route.query.tabIndex;
      this.$nextTick(function () {
        if (index && _this.$refs.tabs) {
          _this.$refs.tabs.navigateToTab(parseInt(index));
        }
      });
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      this.resetStates();
      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);
      switch (newTab.title) {
        case this.$t('pages.settings'):
          this.isSettings = true;
          break;

        default:
          this.isKds = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ "jKkb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);



















__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);

var PUSH_SENT = 1;
var PUSH_NO_DEVICE = 2;
var PUSH_FAILED = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      currency: '',
      campaign: null,
      items: [],
      counts: {},
      years: [],
      filters: {
        status: null,
        search: '',
        year: ''
      },
      pagination: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 1
      },
      searchTimer: null
    };
  },

  computed: {
    isCart: function isCart() {
      return !!(this.campaign && this.campaign.type === 3);
    },
    chips: function chips() {
      if (this.isCart) {
        return [{ key: 'all', value: null, label: 'marketingAutomation.statusAllSent', icon: 'fa fa-paper-plane' }, { key: 'granted', value: 'granted', label: 'marketingAutomation.cartStatusGranted', icon: 'fa fa-gift' }, { key: 'notified', value: 'notified', label: 'marketingAutomation.status_notified', icon: 'fa fa-bell-o' }, { key: 'used', value: 'used', label: 'marketingAutomation.cartStatusUsed', icon: 'fa fa-check-circle' }, { key: 'converted', value: 'converted', label: 'marketingAutomation.status_converted', icon: 'fa fa-shopping-bag' }, { key: 'expired', value: 'expired', label: 'marketingAutomation.status_expired', icon: 'fa fa-clock-o' }];
      }
      return [{ key: 'all', value: null, label: 'marketingAutomation.statusAll', icon: 'fa fa-users' }, { key: 'granted', value: 'granted', label: 'marketingAutomation.status_granted', icon: 'fa fa-gift' }, { key: 'used', value: 'used', label: 'marketingAutomation.status_used', icon: 'fa fa-check-circle' }, { key: 'expired', value: 'expired', label: 'marketingAutomation.status_expired', icon: 'fa fa-clock-o' }];
    },
    campaignId: function campaignId() {
      var query = this.route && this.route.query || {};
      return parseInt(query.campaign_id, 10) || null;
    }
  },
  created: function created() {
    var companyData = this.$session.get('selectedCompanyData') || {};
    this.currency = this.getCurrencySymbol(companyData.currency_iso);
    this.load();
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.searchTimer);
  },

  methods: {
    load: function load() {
      var _this = this;

      if (!this.campaignId) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
      if (this.filters.status) {
        data.status = this.filters.status;
      }
      if (this.filters.year) {
        data.year = this.filters.year;
      }
      if ((this.filters.search || '').trim()) {
        data.search = this.filters.search.trim();
      }
      this.loading = true;
      this.apiRequest('/automation-campaign/' + this.campaignId + '/grants', 'GET', data, function (response) {
        _this.loading = false;
        if (response.status !== true || !response.data) {
          return;
        }
        _this.campaign = response.data.campaign;
        _this.items = response.data.items || [];
        _this.counts = response.data.counts || {};
        _this.years = response.data.years || [];
        _this.pagination = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.pagination, response.data.pagination || {});
      });
    },
    reload: function reload() {
      this.pagination.current_page = 1;
      this.load();
    },
    setStatus: function setStatus(value) {
      if (this.filters.status === value) {
        return;
      }
      this.filters.status = value;
      this.reload();
    },
    onSearch: function onSearch() {
      var _this2 = this;

      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        return _this2.reload();
      }, 400);
    },
    onPageChange: function onPageChange(page) {
      this.pagination.current_page = page;
      this.load();
    },
    onSizeChange: function onSizeChange(size) {
      this.pagination.per_page = size;
      this.reload();
    },
    statusLabel: function statusLabel(status) {
      if (this.isCart && status === 'granted') {
        return this.$t('marketingAutomation.cartStatusGranted');
      }
      if (this.isCart && status === 'used') {
        return this.$t('marketingAutomation.cartStatusUsed');
      }
      return this.$t('marketingAutomation.status_' + status);
    },
    initials: function initials(customer) {
      var name = (customer && customer.name || '?').trim();
      return name.split(/\s+/).slice(0, 2).map(function (part) {
        return part.charAt(0).toUpperCase();
      }).join('');
    },
    contact: function contact(customer) {
      if (!customer) {
        return '';
      }
      return [customer.phone, customer.email].filter(Boolean).join(' · ');
    },
    formatDay: function formatDay(value) {
      if (!value) {
        return '—';
      }
      var parts = String(value).substr(0, 10).split('-');
      return parts.length === 3 ? parts[2] + '.' + parts[1] + '.' + parts[0] : value;
    },
    formatDateTime: function formatDateTime(value) {
      if (!value) {
        return '';
      }
      return this.formatDay(value) + ' ' + String(value).substr(11, 5);
    },
    pushState: function pushState(push) {
      var status = push && push.status;
      if (status === PUSH_SENT) {
        return 'sent';
      }
      if (status === PUSH_NO_DEVICE) {
        return 'nodevice';
      }
      if (status === PUSH_FAILED) {
        return 'failed';
      }
      return 'none';
    },
    pushIcon: function pushIcon(push) {
      return {
        sent: 'fa fa-check',
        nodevice: 'fa fa-bell-slash-o',
        failed: 'fa fa-exclamation-triangle',
        none: 'fa fa-minus'
      }[this.pushState(push)];
    },
    pushText: function pushText(push) {
      var state = this.pushState(push);
      if (state === 'none') {
        return this.$t('marketingAutomation.pushNotSent');
      }
      var label = this.$t('marketingAutomation.push_' + state);
      return push.at ? label + ' · ' + this.formatDateTime(push.at) : label;
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "jKpd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('top-category-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onCategorySubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jL9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PromosForm_vue__ = __webpack_require__("SB3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);







var _components;






__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PromosForm', __WEBPACK_IMPORTED_MODULE_7__PromosForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      offerModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onOfferSubmit: function onOfferSubmit(model, isValid) {
      this.offerModel = model;
    },
    downloadPoints: function downloadPoints() {
      this.$refs.promos.downloadPoints();
    }
  }
});

/***/ }),

/***/ "jPN6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      loading: false,
      companyID: null,

      selectedLocation: null,
      searchDate: null,

      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            var end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      }
    };
  },


  computed: {
    canExport: function canExport() {
      return this.selectedLocation && this.searchDate && this.searchDate.length === 2;
    }
  },

  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },


  methods: {
    exportSales: function exportSales() {
      var _this = this;

      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'XML';
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var startDate, endDate, externalLocationId, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (_this.canExport) {
                  _context.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
                  title: 'Atenție',
                  text: 'Selectează locația și intervalul de date!',
                  type: 'warning',
                  timer: 2500,
                  showConfirmButton: false
                });
                return _context.abrupt('return');

              case 4:

                _this.loading = true;

                startDate = new Date(_this.searchDate[0]).toISOString();
                endDate = new Date(_this.searchDate[1]).toISOString();
                externalLocationId = _this.selectedLocation.true_id;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/exports/accounting/vanzari' + ('?startDate=' + encodeURIComponent(startDate)) + ('&endDate=' + encodeURIComponent(endDate)) + ('&externalLocationId=' + encodeURIComponent(externalLocationId)) + ('&externalCompanyId=' + encodeURIComponent(_this.companyID)) + ('&export=' + format);


                window.location.href = url;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

                __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
                  title: 'Eroare!',
                  text: 'Nu s-a putut genera exportul.',
                  type: 'error',
                  timer: 3000,
                  showConfirmButton: false
                });

              case 16:
                _context.prev = 16;

                _this.loading = false;
                return _context.finish(16);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 12, 16, 19]]);
      }))();
    }
  }
});

/***/ }),

/***/ "jTQK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersPos_vue__ = __webpack_require__("KsE3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d784b11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersPos_vue__ = __webpack_require__("mbo1");
function injectStyle (ssrContext) {
  __webpack_require__("va9p")
  __webpack_require__("dvqv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d784b11"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersPos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d784b11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersPos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jUCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosScreen_vue__ = __webpack_require__("VWtb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0ac3458_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosScreen_vue__ = __webpack_require__("mMIl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0ac3458_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jWkH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jZDA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "japT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "jeM8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalSignageForm_vue__ = __webpack_require__("eVBd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9051d2fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalSignageForm_vue__ = __webpack_require__("JTCb");
function injectStyle (ssrContext) {
  __webpack_require__("FP5N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalSignageForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9051d2fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalSignageForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jfB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('spinning-wheel-campaign-form',{attrs:{"route":_vm.route}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jgtC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loyality_vue__ = __webpack_require__("TOEP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc3d3e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loyality_vue__ = __webpack_require__("ALiV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loyality_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc3d3e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loyality_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jh6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Management_ManagementSeriesAdd_vue__ = __webpack_require__("kgt7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
















function getLocalDateTimeString() {
  var now = new Date();
  var year = now.getFullYear();
  var month = String(now.getMonth() + 1).padStart(2, '0');
  var day = String(now.getDate()).padStart(2, '0');
  var hours = String(now.getHours()).padStart(2, '0');
  var minutes = String(now.getMinutes()).padStart(2, '0');
  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Switch_vue__["a" /* default */],
    ManagementSeriesAdd: __WEBPACK_IMPORTED_MODULE_11__Management_ManagementSeriesAdd_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loadingTable: false,
      productNameRecipe: null,
      selectedCategory: 'Produs finit (Reteta)',
      selectedLocationId: '',
      selectedLocation: null,
      locations: [],
      costPerUnit: 0.00,
      pricePerUnit: 100.00,
      totalCost: 0.00,
      gestiuneOptions: [],
      seriesOptions: [],
      searchResults: [],
      bon_productOptions: [],
      loading: false,
      searchDebounceTimer: null,
      currencyOptions: [{ code: 'RON', name: 'Leu Românesc (RON)' }, { code: 'EUR', name: 'Euro (EUR)' }, { code: 'USD', name: 'Dolar American (USD)' }],
      categories: [{ value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' }, { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' }],
      isEdit: !!this.route.params.series && !!this.route.params.number,
      bonProduct: {
        date: null,
        fromGestiune: null,
        serie: null,
        currency: 'RON',
        manager: '',
        receiver: '',
        internalNote: '',
        lot: '',
        dataProductie: getLocalDateTimeString(),
        dataExpirare: getLocalDateTimeString(),
        cantitateProdusa: ''
      },
      tableData: [],
      editIndex: null,
      item: {
        productName: '',
        um: 'BUC',
        cantitate: null
      }
    };
  },

  computed: {
    today: function today() {
      var now = new Date();
      now.setSeconds(0, 0);
      return now.toISOString().slice(0, 16);
    },
    seriesOptionsWithAdd: function seriesOptionsWithAdd() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default()(this.seriesOptions), [{ id: 'add', name: '➕ Adaugă serie' }]);
    },
    groupedLocations: function groupedLocations() {
      var groups = {};

      if (!this.locations || !this.locations.length) return [];

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];

      return this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id && (g.categorie === 'Produs finit (Reteta)' || g.categorie === 'Semifabricate (Reteta)');
      });
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.fetchGestiuni();
    this.fetchLocation();
  },

  watch: {
    selectedLocationId: function selectedLocationId(id) {
      if (!this.isEdit) {
        this.bonProduct.fromGestiune = null;
        this.bonProduct.serie = null;
        this.bonProduct.lot = '';
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;
            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code);
            }
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    locations: function locations(newLocations) {
      if (newLocations && newLocations.length) {
        var s = this.route && this.route.params && this.route.params.series;
        var inv = this.route && this.route.params && this.route.params.number;
        if (s && inv) {
          this.fetchBonProduct(s, inv);
        }
      }
    },
    productNameRecipe: function productNameRecipe(newVal) {
      if (!newVal) {
        this.tableData = [];
      }
    },
    selectedCategory: function selectedCategory(newVal) {
      this.productNameRecipe = null;
      this.selectedLocationId = '';
      this.selectedLocation = null;
      this.bonProduct = {
        cantitateProdusa: null,
        fromGestiune: null,
        serie: null,
        lot: '',
        dataProductie: getLocalDateTimeString(),
        dataExpirare: getLocalDateTimeString(),
        date: null
      };

      this.tableData = [];
    },

    'bonProduct.fromGestiune': function bonProductFromGestiune(newGestiune) {
      if (!newGestiune) return;
      if (this.productNameRecipe && this.productNameRecipe.reteta && Array.isArray(this.productNameRecipe.reteta.items)) {
        this.populateTableFromReteta(this.productNameRecipe.reteta.items);
      }
    },
    'bonProduct.cantitateProdusa': function bonProductCantitateProdusa(newVal) {
      this.tableData = this.tableData.map(function (item) {
        var bazaCantitate = item.bazaCantitate || item.cantitate || 0;
        var bazaPrice = item.bazaPrice || item.price || 0;
        var cantitate = bazaCantitate;
        var price = bazaPrice;

        if (newVal && !isNaN(newVal) && parseFloat(newVal) > 0) {
          cantitate = bazaCantitate * newVal;
          price = bazaPrice * newVal;
        }

        if (item.scazamantValue && item.scazamantType) {
          if (item.scazamantType === 'procent') {
            price = price * (1 - parseFloat(item.scazamantValue) / 100);
          } else {
            cantitate = cantitate - parseFloat(item.scazamantValue);
            if (cantitate < 0) cantitate = 0;
          }
        }

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, item, {
          cantitate: cantitate.toFixed(2),
          price: price.toFixed(2),
          bazaCantitate: bazaCantitate
        });
      });
    }
  },
  methods: {
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveBonProduct();
        }
      });
    },
    openEditPriceModal: function openEditPriceModal() {
      this.$modal.show('openEditPriceModal');
    },
    handleSerieChange: function handleSerieChange(event) {
      var val = event.target.value;
      if (val === 'add') {
        this.openSeriesModal();
        this.bonConsum.serie = null;
      }
    },
    openSeriesModal: function openSeriesModal() {
      this.$modal.show('addSeriesModal');
    },
    getEmptyItem: function getEmptyItem() {
      return {
        productName: '',
        um: 'buc',
        cantitate: null,
        editIndex: null
      };
    },
    getCategoryClass: function getCategoryClass(categorie) {
      if (!categorie) return '';
      var name = categorie.replace(' (Reteta)', '').trim().toLowerCase();
      return name.replace(/\s+/g, '-');
    },
    fetchLocation: function fetchLocation() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataToSend = {
                  company_id: _this3.companyID,
                  token: _this3.$session.get('token')
                };


                _this3.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this3.locations = response.data.locations;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getGestiuneName: function getGestiuneName(id) {
      var gestiune = this.gestiuneOptions.find(function (g) {
        return g.id === id || g._id === id;
      });
      return gestiune ? gestiune.name : id;
    },
    checkValidatedAfter: function checkValidatedAfter(date, field) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var selectedDate, products, queryParams, body, response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                selectedDate = date;

                if (selectedDate) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return', false);

              case 4:
                products = [_this4.productNameRecipe._id];
                queryParams = new URLSearchParams({
                  date: new Date(selectedDate).toISOString(),
                  externalCompanyId: _this4.companyID,
                  externalLocationId: _this4.selectedLocationId
                });
                body = products.length > 0 ? { products: products } : null;
                _context2.next = 9;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/inventar/validated-after-products?' + queryParams.toString(), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: body ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(body) : null
                });

              case 9:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 12;
                  break;
                }

                throw new Error('Request failed: ' + response.status);

              case 12:
                _context2.next = 14;
                return response.json();

              case 14:
                data = _context2.sent;

                console.log('Response from validated-after:', data);

                if (!data.exists) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 19;
                return __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  icon: 'warning',
                  title: 'Atenție!',
                  text: 'Există deja un inventar validat după această dată pentru unul sau mai multe produse selectate.'
                });

              case 19:
                if (field) _this4[field] = null;
                return _context2.abrupt('return', false);

              case 21:
                return _context2.abrupt('return', true);

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  icon: 'error',
                  title: 'Eroare!',
                  text: 'Nu s-a putut verifica inventarul.'
                });
                return _context2.abrupt('return', false);

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 24]]);
      }))();
    },
    onProductSelect: function onProductSelect(product) {
      if (!product || !product.reteta || !Array.isArray(product.reteta.items)) {
        console.warn('Produsul selectat nu conține rețetă validă.');
        this.tableData = [];
        return;
      }

      this.productNameRecipe = product;

      if (this.bonProduct.fromGestiune && this.locationID) {
        this.populateTableFromReteta(product.reteta.items);
      }
    },
    fetchBonProduct: function fetchBonProduct(seriesParam, invoiceNumberParam) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                return _context4.delegateYield(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
                  var response, data, bon, extra, getField, categorie, lot, produsPrincipal, produsGasit, selectedSerie, gestiuneToObj, foundLocation, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, group, foundToLocation, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _group;

                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getDocument?tip=bon_productie&series=' + seriesParam + '&number=' + invoiceNumberParam + '&externalCompanyId=' + _this5.companyID);

                        case 2:
                          response = _context3.sent;

                          if (response.ok) {
                            _context3.next = 5;
                            break;
                          }

                          throw new Error('Failed to fetch bon de productie');

                        case 5:
                          _context3.next = 7;
                          return response.json();

                        case 7:
                          data = _context3.sent;

                          if (!(!data || !Array.isArray(data.documents) || !data.documents.length)) {
                            _context3.next = 10;
                            break;
                          }

                          throw new Error('Bon de productie inexistent');

                        case 10:
                          bon = data.documents[0];
                          extra = bon.extraFields || [];

                          getField = function getField(key) {
                            var field = extra.find(function (f) {
                              return f.key === key;
                            });
                            return field ? field.value : '';
                          };

                          categorie = getField('categorie');

                          if (categorie) {
                            _this5.selectedCategory = categorie;
                          }

                          lot = getField('lot');
                          produsPrincipal = bon.items && bon.items[0];

                          if (!produsPrincipal) {
                            _context3.next = 28;
                            break;
                          }

                          if (_this5.searchResults.length) {
                            _context3.next = 23;
                            break;
                          }

                          _context3.next = 21;
                          return _this5.fetchProducts(produsPrincipal.name, true);

                        case 21:
                          _context3.next = 23;
                          return _this5.$nextTick();

                        case 23:

                          console.log('produsPrincipal.name', produsPrincipal.name);
                          produsGasit = _this5.searchResults.find(function (p) {
                            return p.name === produsPrincipal.name;
                          });


                          console.log('produsGasit', produsGasit);

                          if (produsGasit) {
                            _this5.productNameRecipe = produsGasit;
                            _this5.onProductSelect(produsGasit);
                          } else {
                            console.warn('Produsul principal nu a fost găsit în lista de produse');
                          }

                          _this5.bonProduct.cantitateProdusa = produsPrincipal.quantity;

                        case 28:
                          selectedSerie = _this5.seriesOptions.find(function (s) {
                            return s.id === bon.series;
                          });

                          if (!selectedSerie) {
                            selectedSerie = { id: bon.series, name: bon.series };
                            _this5.seriesOptions.push(selectedSerie);
                            console.warn('Seria "' + bon.series + '" nu exista, a fost adaugat\u0103 automat.');
                          }
                          _this5.bonProduct.serie = selectedSerie.id;

                          gestiuneToObj = _this5.gestiuneOptions.find(function (g) {
                            return g.id === bon.gestiune_to || g._id === bon.gestiune_to || g.name === bon.gestiune_to;
                          });


                          _this5.bonProduct = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this5.bonProduct, {
                            fromGestiune: gestiuneToObj ? gestiuneToObj.id : bon.gestiune_to,
                            toGestiune: gestiuneToObj ? gestiuneToObj.id : bon.gestiune_to,
                            serie: bon.series,
                            date: bon.date,
                            documentNumber: bon.documentNumber,
                            manager: getField('manager'),
                            receiver: getField('receiver'),
                            internalNote: getField('internalNote'),
                            commandProject: getField('commandProject'),
                            lot: lot
                          });

                          _this5.consumptionType = bon.type;

                          if (!(bon.externalLocationId && _this5.locations && _this5.locations.length)) {
                            _context3.next = 64;
                            break;
                          }

                          foundLocation = null;
                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _iteratorError2 = undefined;
                          _context3.prev = 39;
                          _iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(_this5.groupedLocations);

                        case 41:
                          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                            _context3.next = 49;
                            break;
                          }

                          group = _step2.value;

                          foundLocation = group.locations.find(function (loc) {
                            return bon.externalLocationId && loc.true_id === bon.externalLocationId || bon.vatNumber && loc.inv_fiscal_code === bon.vatNumber;
                          });

                          if (!foundLocation) {
                            _context3.next = 46;
                            break;
                          }

                          return _context3.abrupt('break', 49);

                        case 46:
                          _iteratorNormalCompletion2 = true;
                          _context3.next = 41;
                          break;

                        case 49:
                          _context3.next = 55;
                          break;

                        case 51:
                          _context3.prev = 51;
                          _context3.t0 = _context3['catch'](39);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context3.t0;

                        case 55:
                          _context3.prev = 55;
                          _context3.prev = 56;

                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }

                        case 58:
                          _context3.prev = 58;

                          if (!_didIteratorError2) {
                            _context3.next = 61;
                            break;
                          }

                          throw _iteratorError2;

                        case 61:
                          return _context3.finish(58);

                        case 62:
                          return _context3.finish(55);

                        case 63:
                          if (foundLocation) {
                            _this5.selectedLocationId = foundLocation.true_id;
                          }

                        case 64:
                          if (!(bon.externalLocationIdTo && _this5.locations && _this5.locations.length)) {
                            _context3.next = 93;
                            break;
                          }

                          foundToLocation = null;
                          _iteratorNormalCompletion3 = true;
                          _didIteratorError3 = false;
                          _iteratorError3 = undefined;
                          _context3.prev = 69;
                          _iterator3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(_this5.groupedLocations);

                        case 71:
                          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                            _context3.next = 79;
                            break;
                          }

                          _group = _step3.value;

                          foundToLocation = _group.locations.find(function (loc) {
                            return loc.true_id === bon.externalLocationIdTo || loc.inv_fiscal_code === bon.vatNumberTo;
                          });

                          if (!foundToLocation) {
                            _context3.next = 76;
                            break;
                          }

                          return _context3.abrupt('break', 79);

                        case 76:
                          _iteratorNormalCompletion3 = true;
                          _context3.next = 71;
                          break;

                        case 79:
                          _context3.next = 85;
                          break;

                        case 81:
                          _context3.prev = 81;
                          _context3.t1 = _context3['catch'](69);
                          _didIteratorError3 = true;
                          _iteratorError3 = _context3.t1;

                        case 85:
                          _context3.prev = 85;
                          _context3.prev = 86;

                          if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                          }

                        case 88:
                          _context3.prev = 88;

                          if (!_didIteratorError3) {
                            _context3.next = 91;
                            break;
                          }

                          throw _iteratorError3;

                        case 91:
                          return _context3.finish(88);

                        case 92:
                          return _context3.finish(85);

                        case 93:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this5, [[39, 51, 55, 63], [56,, 58, 62], [69, 81, 85, 93], [86,, 88, 92]]);
                })(), 't0', 2);

              case 2:
                _context4.next = 7;
                break;

              case 4:
                _context4.prev = 4;
                _context4.t1 = _context4['catch'](0);

                console.error('Error fetching bon de transfer:', _context4.t1);

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 4]]);
      }))();
    },
    populateTableFromReteta: function populateTableFromReteta(items) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var produsFactor;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log('populateTableFromReteta', items);

                if (!(!items || !items.length)) {
                  _context5.next = 4;
                  break;
                }

                _this6.tableData = [];
                return _context5.abrupt('return');

              case 4:
                produsFactor = parseFloat(_this6.bonProduct.cantitateProdusa) || 1;


                _this6.tableData = items.map(function (item) {
                  var product = item.productDetails || {};
                  var bazaCantitate = parseFloat(item.qty) || 0;

                  return {
                    productName: product.name || item.name || 'N/A',
                    um: item.um || product.um || 'N/A',
                    cantitate: (bazaCantitate * produsFactor).toFixed(2),
                    bazaCantitate: bazaCantitate,
                    price: 0,
                    bazaPrice: 0,
                    id: product._id || item.posId || null,
                    stoc: 0,
                    categorie: product.categorie || '',
                    scazamantValue: item.scazamantValue || 0,
                    scazamantType: item.scazamantType || ''
                  };
                });

                console.log('tableData populated:', _this6.tableData);

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    saveProduct: function saveProduct() {
      if (!this.item.productName || !this.item.cantitate) {
        __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
          title: 'Eroare',
          text: 'Te rugăm să completezi toate câmpurile necesare!',
          type: 'error',
          timer: 2000,
          showConfirmButton: false
        });
        return;
      }

      var productName = this.item.productName;
      if ((typeof productName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(productName)) === 'object') {
        if (productName._id) {
          this.item.posId = productName._id;
        }
        productName = productName.name || productName.product_code || '';
      }

      var newItem = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.item, {
        productName: productName,
        posId: this.item.posId
      });

      if (this.editIndex !== null && this.editIndex >= 0) {
        this.$set(this.tableData, this.editIndex, newItem);
      } else {
        this.tableData.push(newItem);
      }

      this.item = this.getEmptyItem();
      this.editIndex = null;
      this.$modal.hide('addProductModal');
    },
    editRow: function editRow(row) {
      var index = this.tableData.indexOf(row);
      if (index === -1) return;

      this.editIndex = index;
      this.item = {
        productName: { name: row.productName },
        um: row.um,
        cantitate: row.cantitate,
        posId: row.posId || null
      };

      this.$modal.show('addProductModal');
    },
    deleteRow: function deleteRow(row) {
      var index = this.tableData.indexOf(row);

      if (index !== -1) {
        this.tableData.splice(index, 1);
      }
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this7 = this;

      var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (_this7.searchDebounceTimer) {
          clearTimeout(_this7.searchDebounceTimer);
          _this7.searchDebounceTimer = null;
        }

        var delay = immediate ? 0 : 300;

        _this7.searchDebounceTimer = setTimeout(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
          var categorieParam, response, data;
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!(!searchTerm || searchTerm.length < 2)) {
                    _context6.next = 4;
                    break;
                  }

                  _this7.searchResults = [];
                  resolve();
                  return _context6.abrupt('return');

                case 4:

                  _this7.loading = true;
                  _context6.prev = 5;
                  categorieParam = _this7.selectedCategory ? '&categorie=' + encodeURIComponent(_this7.selectedCategory) : '';
                  _context6.next = 9;
                  return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/products?externalCompanyId=' + _this7.companyID + '&name=' + searchTerm + categorieParam);

                case 9:
                  response = _context6.sent;
                  _context6.next = 12;
                  return response.json();

                case 12:
                  data = _context6.sent;

                  _this7.searchResults = Array.isArray(data.products) ? data.products : [];
                  console.log('this.searchResults', _this7.searchResults);
                  _context6.next = 21;
                  break;

                case 17:
                  _context6.prev = 17;
                  _context6.t0 = _context6['catch'](5);

                  console.error('Error fetching products:', _context6.t0);
                  _this7.searchResults = [];

                case 21:
                  _context6.prev = 21;

                  _this7.loading = false;
                  resolve();return _context6.finish(21);

                case 25:

                  _this7.searchDebounceTimer = null;

                case 26:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, _this7, [[5, 17, 21, 25]]);
        })), delay);
      });
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this8.companyID);

              case 3:
                response = _context7.sent;

                if (response.ok) {
                  _context7.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context7.next = 8;
                return response.json();

              case 8:
                data = _context7.sent;

                console.log('Date primite de la server:', data.gestiuni);
                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this8.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      externalLocationId: gest.externalLocationId || '',
                      categorie: gest.categorie || ''
                    };
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                    title: 'Error!',
                    text: 'Nu s-a primit un array valid de la server.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context7.next = 17;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7['catch'](0);

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Error!',
                  text: 'Request failed: ' + _context7.t0.message,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching management data:', _context7.t0);

              case 17:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[0, 13]]);
      }))();
    },
    getSeries: function getSeries(vatNumber) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this9.companyID,
                    vatNumber: vatNumber,
                    tip: 'bon_productie'
                  })
                });

              case 3:
                response = _context8.sent;

                if (response.ok) {
                  _context8.next = 6;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 6:
                _context8.next = 8;
                return response.json();

              case 8:
                data = _context8.sent;

                console.log('Serii primite:', data.series);

                if (Array.isArray(data.series)) {
                  _this9.seriesOptions = data.series.map(function (serie) {
                    return {
                      id: serie._id,
                      name: serie.series,
                      currentNumber: serie.currentNumber
                    };
                  });
                } else {
                  console.error('Format invalid pentru series:', data);
                }
                _context8.next = 16;
                break;

              case 13:
                _context8.prev = 13;
                _context8.t0 = _context8['catch'](0);

                console.error('Error fetching series:', _context8.t0);

              case 16:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9, [[0, 13]]);
      }))();
    },
    saveBonProduct: function saveBonProduct() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var problems, selectedSerie, serieName, isValid, bonProductData, response, data, serverMessage;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                problems = [];


                if (!_this10.selectedCategory) {
                  problems.push('Selectează categoria produsului.');
                }
                if (!_this10.productNameRecipe || !_this10.productNameRecipe._id) {
                  problems.push('Selectează produsul.');
                }
                if (!_this10.bonProduct.cantitateProdusa || isNaN(_this10.bonProduct.cantitateProdusa) || parseFloat(_this10.bonProduct.cantitateProdusa) <= 0) {
                  problems.push('Introdu o cantitate produsă mai mare decât 0.');
                }
                if (!_this10.selectedLocationId || !_this10.selectedLocation) {
                  problems.push('Selectează locația.');
                }
                if (!_this10.bonProduct.fromGestiune) {
                  problems.push('Selectează gestiunea.');
                }
                if (!Array.isArray(_this10.gestiuneOptions) || !_this10.gestiuneOptions.length) {
                  problems.push('Gestiunile nu sunt încărcate.');
                }
                if (!Array.isArray(_this10.seriesOptions)) {
                  problems.push('Seriile nu sunt încărcate.');
                }

                selectedSerie = Array.isArray(_this10.seriesOptions) ? _this10.seriesOptions.find(function (serie) {
                  return serie.id === _this10.bonProduct.serie;
                }) : null;


                if (!_this10.bonProduct.serie || !selectedSerie || selectedSerie.id === 'add') {
                  problems.push('Selectează o serie validă.');
                }
                if (!_this10.tableData || _this10.tableData.length === 0) {
                  problems.push('Rețeta nu are produse. Selectează un produs cu rețetă și o gestiune.');
                }
                if (!_this10.bonProduct.date) {
                  problems.push('Selectează data documentului.');
                }

                if (!problems.length) {
                  _context9.next = 15;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  icon: 'error',
                  title: 'Nu se poate salva',
                  html: '<ul style="text-align:left;margin:0 auto;padding-left:18px;display:inline-block;">' + problems.map(function (problem) {
                    return '<li>' + problem + '</li>';
                  }).join('') + '</ul>'
                });
                return _context9.abrupt('return');

              case 15:
                serieName = '' + selectedSerie.name;
                _context9.next = 18;
                return _this10.checkValidatedAfter(_this10.bonProduct.date, 'bonProduct.date');

              case 18:
                isValid = _context9.sent;

                if (isValid) {
                  _context9.next = 21;
                  break;
                }

                return _context9.abrupt('return');

              case 21:
                bonProductData = {
                  externalCompanyId: _this10.companyID,
                  externalLocationId: _this10.selectedLocation.true_id,
                  vatNumber: _this10.selectedLocation.inv_fiscal_code,
                  series: serieName,
                  tip: 'bon_productie',
                  gestiune_from: _this10.bonProduct.fromGestiune,
                  gestiune_to: _this10.bonProduct.fromGestiune,
                  lot: _this10.bonProduct.lot,
                  items: [{
                    posId: _this10.productNameRecipe._id,
                    name: _this10.productNameRecipe.name,
                    quantity: _this10.bonProduct.cantitateProdusa,
                    um: _this10.productNameRecipe.um
                  }],
                  currency: _this10.bonProduct.currency,
                  extraFields: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()({
                    manager: _this10.bonProduct.manager,
                    receiver: _this10.bonProduct.receiver,
                    internalNote: _this10.bonProduct.internalNote,
                    lot: _this10.bonProduct.lot,
                    dataProductie: _this10.bonProduct.dataProductie,
                    dataExpirare: _this10.bonProduct.dataExpirare,
                    categorie: _this10.selectedCategory
                  }).map(function (_ref4) {
                    var _ref5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
                        key = _ref5[0],
                        value = _ref5[1];

                    return { key: key, value: value };
                  })
                };


                if (_this10.bonProduct.date) {
                  bonProductData.date = _this10.bonProduct.date;
                }
                if (_this10.bonProduct.documentNumber) {
                  bonProductData.documentNumber = _this10.bonProduct.documentNumber;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Salvare în curs...',
                  text: 'Se salvează Bonul de Proctie. Așteaptă te rog.',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  showConfirmButton: false
                });

                _context9.prev = 25;
                _context9.next = 28;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/bon', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(bonProductData)
                });

              case 28:
                response = _context9.sent;
                _context9.next = 31;
                return response.json();

              case 31:
                data = _context9.sent;


                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();

                if (response.ok) {
                  console.log('Bon de procutie salvat cu succes!', data);

                  __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                    title: 'Succes',
                    text: 'Bon de procutie a fost salvat cu succes!',
                    type: 'success',
                    timer: 1500,
                    showConfirmButton: false
                  });

                  _this10.$bus.$emit('refresh');
                  _this10.$bus.$emit('close-modal');
                } else {
                  console.error('Eroare la salvarea bonului de procutie', data);

                  serverMessage = data && (data.message || data.error) || 'A apărut o eroare la salvarea bonului de producție.';

                  __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                    icon: 'error',
                    title: 'Eroare',
                    text: serverMessage
                  });
                }
                _context9.next = 41;
                break;

              case 36:
                _context9.prev = 36;
                _context9.t0 = _context9['catch'](25);

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                console.error('Eroare la trimiterea cererii', _context9.t0);

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  icon: 'error',
                  title: 'Eroare',
                  text: _context9.t0 && _context9.t0.message ? 'A ap\u0103rut o problem\u0103 la trimiterea cererii: ' + _context9.t0.message : 'A apărut o problemă la trimiterea cererii.'
                });

              case 41:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10, [[25, 36]]);
      }))();
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "ji1f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scanner-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}]},[_c('video',{ref:"scanner",attrs:{"poster":"data:image/gif,AAAA"}}),_vm._v(" "),_c('div',{staticClass:"overlay-element"}),_vm._v(" "),_c('div',{staticClass:"laser"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jjA+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsSales_vue__ = __webpack_require__("cdNQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f6e9204_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsSales_vue__ = __webpack_require__("VjbB");
function injectStyle (ssrContext) {
  __webpack_require__("/CcY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsSales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f6e9204_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsSales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jjFL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.charismaReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100 mar-bt-15"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('general.orderId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedOrderId),expression:"selectedOrderId"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"price","placeholder":"3823231"},domProps:{"value":(_vm.selectedOrderId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedOrderId=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100 mar-bt-15"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('charisma.categoryAdministration')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.administrations,"label":"name","name":"administration-select","placeholder":_vm.$t('general.select')},model:{value:(_vm.selectedAdministration),callback:function ($$v) {_vm.selectedAdministration=$$v},expression:"selectedAdministration"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100 mar-bt-15"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('catalogProd.status')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.types,"label":"name","name":"type-select","placeholder":_vm.$t('catalogProd.status')},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}})],1),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100 mar-bt-15"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('charisma.documentType')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.documents,"label":"name","name":"document-select","placeholder":_vm.$t('charisma.documentType')},model:{value:(_vm.selectedDocument),callback:function ($$v) {_vm.selectedDocument=$$v},expression:"selectedDocument"}})],1),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100 mar-bt-15"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('invoice.series')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSeries),expression:"selectedSeries"}],staticClass:"form-control",attrs:{"type":"text","name":"series","placeholder":""},domProps:{"value":(_vm.selectedSeries)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedSeries=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('invoice.number')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedNumber),expression:"selectedNumber"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"number","placeholder":""},domProps:{"value":(_vm.selectedNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedNumber=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('p',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('charisma.sendAll')},on:{"click":function($event){_vm.sendAll()}}},[_vm._v(_vm._s(_vm.$t('charisma.sendAll')))])]),_vm._v(" "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":00")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"search-def":{show: false},"total":_vm.ordersTableData.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":56,"prop":"id","label":_vm.$t('reports.id')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"order_id","label":_vm.$t('general.orderId')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"name","label":_vm.$t('reports.location')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"administration_name","label":_vm.$t('charisma.categoryAdministration')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"totals_grandtotal","label":_vm.$t('reports.orderTotal')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.totals_grandtotal || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"charisma_status","label":_vm.$t('charisma.bill')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.$t('charisma.charisma' + props.row.charisma_status))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"charisma_invoice_status","label":_vm.$t('charisma.invoice')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.$t('charisma.charisma' + props.row.charisma_invoice_status))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"series","label":_vm.$t('invoice.series')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.series ? props.row.series : '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"number","label":_vm.$t('invoice.number')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n               "+_vm._s(props.row.number ? props.row.number : '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"created_at","label":_vm.$t('charisma.createDate')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s((_vm.formatToCompanyTimezone(props.row.created_at, _vm.timezone)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"updated_at","label":_vm.$t('charisma.updateDate')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s((_vm.formatToCompanyTimezone(props.row.updated_at, _vm.timezone)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":110,"width":"110","prop":"actions","class-name":"centered-cell charisma-actions-column","label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"display-flex",staticStyle:{"align-items":"center","margin":"auto"}},[_c('a',{staticClass:"btn btn-icon btn-purple mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.open')},on:{"click":function($event){_vm.goToItems(props.row)}}},[_c('i',{staticClass:"ti-angle-right"})])])]}}])})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jkt6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductForm_vue__ = __webpack_require__("2mRZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_223bc3dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductForm_vue__ = __webpack_require__("I7+/");
function injectStyle (ssrContext) {
  __webpack_require__("RPJ8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_223bc3dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jmMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-stocuri-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "joYi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jokE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jssz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralProgramAmbassadorDrilldownModal_vue__ = __webpack_require__("xOTJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ac9656_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralProgramAmbassadorDrilldownModal_vue__ = __webpack_require__("nF5K");
function injectStyle (ssrContext) {
  __webpack_require__("6f3K")
  __webpack_require__("RcJs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24ac9656"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralProgramAmbassadorDrilldownModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ac9656_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralProgramAmbassadorDrilldownModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jxm0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-top":"40px"}},[_c('div',{staticClass:"col-md-12 "},[_c('div',{staticClass:"search-bar no-margin"},[_c('div',{staticClass:"col-sm-12 no-padding"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('feedback.search')},on:{"input":function($event){_vm.onInput()}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"feedback-table width-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":_vm.defaultSearchDef(),"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDef,"table-props":{'row-class-name': _vm.rowClass, 'border': false}},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"min-width":40,"prop":"type","label":_vm.$t('feedback.type')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"label",class:'label-' + _vm.feedbackTypeClass(props.row.type)},[_vm._v(_vm._s(_vm.$t('feedbackTypes.' + props.row.type)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"prop":"sent_by","label":_vm.$t('feedback.sentBy')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.firstname && props.row.lastname)?[_vm._v("\n                "+_vm._s(props.row.firstname)+" "+_vm._s(props.row.lastname)+"\n              ")]:[_vm._v(_vm._s(props.row.email))]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"prop":"text","label":_vm.$t('customers.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.location)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"prop":"seen","label":_vm.$t('feedback.seen')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.seen ? 'seen' : 'new')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"prop":"created_at","label":_vm.$t('feedback.sentAt')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatDateTime(props.row.created_at))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":160},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":90},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.admin_response)?_c('i',{staticClass:"fa fa-comment"}):_vm._e()]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"active-pagination width-table",attrs:{"total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"pager-count":_vm.pagerCount,"layout":"prev, pager, next, total"},on:{"current-change":function($event){_vm.handlePageChange($event)},"prev-click":function($event){_vm.handlePageChange($event)},"next-click":function($event){_vm.handlePageChange($event)}}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jxwq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionReport_vue__ = __webpack_require__("6Eo9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be8bcd7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductionReport_vue__ = __webpack_require__("V42J");
function injectStyle (ssrContext) {
  __webpack_require__("dZxm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-be8bcd7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be8bcd7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductionReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jyi0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k0db":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABHNCSVQICAgIfAhkiAAAAF96VFh0UmF3IHByb2ZpbGUgdHlwZSBBUFAxAAAImeNKT81LLcpMVigoyk/LzEnlUgADYxMuE0sTS6NEAwMDCwMIMDQwMDYEkkZAtjlUKNEABZgamFmaGZsZmgMxiM8FAEi2FMk61EMyAAAGSklEQVRYhe2YXYhcZxnHf897zpmd2dmdnSTdJKZt0LZo6JbYUiuWEJpaEaSoICZ3ggjeCGKpN+LNJlCqVkS8EApWvQpoCoIKVkVZtbFEu6aNbRLdJlk3n8adzWY3O99z3r8X55ztJDv7lSDe7AOHmTnzvP/n/3y8z/OeAxuyIRvyvxSZJCcpkBSOjSWXpHBsVOHoqNz/jdroqJwkW01Po3J3QnRVA0sMpqTMTJJy1Us8WDOeuD7D1uvXiJ2DrTsI+4tMbCnxWyva5XSdA2RmWo+9cL3kDh7EDh0yf+Ef2v3PEzxbrfLZQp5i1AflMjgHrRpamMUutjg3+bZe2rKTl8xsOo066yG55ghKMjPT7KzKV6b48vy8vhiGdq/3EMcs9OdVCSNbiDsUfIfh2FMKIhR3sMBxcnCQ5+8b4Sdm5tcTlDURXCQ3qfLFCt+t1fS5MLIA41JhgF/2hfxusMTkXVtUtz6LKlMMV6s8Pl/XU+2mfRjol2iVyzx3/wjfMLNOhnnHBDMgSeHp4/ygXuXzEhRL/P6ubXxteIeNr7A2P3mK/fNVXui02I4pLpft6w+M2Asgg/XV43JGHMCpE/rS+FHp+J+kd07oZ5K2Zg5keqPpjs2+Z/8tzOqRk+M6e/yo9LdXNf+vM3qqG/tOyBnAmTe19fWjOnn8NWni7zpWreruVMMkDUnaIynotX5sTCHAtfP+iTf+7GfePCa9Pa7fdGmtmMWVPTiYlMBCjc90OuwCFoqDfKtYtEvj44rSFG0HngYK3U5B0oqefNI6koLNO90fC0V70cdQr7HvYhrFI0dW5rDsn5LMDpmXfJ8Xn8jncUGkn+94L68APPoonVT1LHAQqGakesEBFAf5aQfOFwfJXauwb8XgpLJ8H0yip7des/e12/pQLjQGSnbMzBpHjigwszgl1FkWIxWzhOA99/FWZVonO7HtjPLsldRvZrWVdvSyETyYfvb1MSzZUKtOu1RiCmD/fta5+0wZiU3DNtFsQKPKrqvnGFxt5aq7SBEDQGhOLm5QWR+xFCOpy2REOuaiENpNBs6/Q+62CY6MJIC5HJEZkY/NBX18UFLezPxaDgrdkq55KHTsURr/gcJiHS+L1ZOgJHfggMXVir+n2dR+53CI5qUpvjp5ih/XZnRv2rzXQDJJ7X8u69nTb+hX01f4aLMBGP3RZn1B0tBKDi+5mdXKzIweujihH/nYHmu1EYb5mFZpkNzm7XzvPTvtmdWmgSSXGn9kaoKxmWmGWi3kHCahgQEsivjF+z/AM1awyV6bxd0CmI21kctndNhjjzU7eAzDwAUKWh1ot9grKZ8V/wrhM4D6dT7WajDUaNGxIK1Fw+YX8O02n7owxYuShntl5SaCGfsr53gujGx3vU4n05FPNYB2e+naFSWg35KBaEYac0Fg2I15xY0qH5++wKcBXn75ZtzFH10ztTx/nT035sA5guRmpgPmIDG29qOab0kInCUYiauAMGdmjRbU6zwNcOBA0l+XEMzk9F8J6g3yLgCvdFJaoulvprXmc50LE8d8Ss5b6rMl+B5odXR3dnjoTvMSgj5G7XYCYALFKZhSZZ/grpXcopFbV6TRzG7HHfM9tJYSHHkcK5XBe7AgAcpqBstSI59VZS/JnvT4Qxpvl+533r1Q8niQYRcKLPQad0sImtmME6/3RSAv71xX3WQp8hbD8jPYzLyZxexLIuIw3WraSFz0QBhCIc+rmXPdRMMuUGV9a+sOvn3pIh9pxtavWDFmTpkKhoVU3z0s3BS5pE019OBcVZ+crfDA/LRy9YYertcNky0GJM2njyJccUAXhrfbKxlMtyM3nWbMzAuZbbNfV/7tn/fnbbTZtijuIN9BHcwc4OJFbxcb6yK569p0ZkKHg8gertXxznBx21ioJonwcfIpocBwm7fQGr7H/5AoON4rG0uOW5Ymcss2+46Js5WrfKV2g925IQrmcL7DX8oDHO6BlTSOHLvC0Ebm5pJm7NMaHiwtNmgklO/DFUssFIfibxYHb3zfbFPPB6m1PDQV5iqM1Jvcb0Zj2w6OmdlVIbOuMdc1hTY3a+ydrZBzQt4nNrLmFgDkYGgIV8gzTchRM2utxmM5cut+83A7Nu7ITgqQvSAKVnvPkuoHa71um9iGbMiGJPJf4EOlKTu1p0sAAAAASUVORK5CYII="

/***/ }),

/***/ "k1fE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementStocksForm_vue__ = __webpack_require__("Fxae");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneStocuriForm', __WEBPACK_IMPORTED_MODULE_7__ManagementStocksForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "k5Wm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k8VF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__ = __webpack_require__("HHnu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869ed9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__ = __webpack_require__("A+TP");
function injectStyle (ssrContext) {
  __webpack_require__("QOjv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869ed9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kA6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Products_ProductEdit_vue__ = __webpack_require__("9sk9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_ProductOptions_ProductOptionsEdit_vue__ = __webpack_require__("tNYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_GroupOptions_GroupOptionsEdit_vue__ = __webpack_require__("raNR");








var ENTITY_COMPONENTS = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
  product: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Products_ProductEdit_vue__["a" /* default */],
  'product-option': __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_ProductOptions_ProductOptionsEdit_vue__["a" /* default */],
  'group-option': __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_GroupOptions_GroupOptionsEdit_vue__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntegrationMenuEntityEditPage',
  components: {
    ProductEdit: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Products_ProductEdit_vue__["a" /* default */],
    ProductOptionEdit: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_ProductOptions_ProductOptionsEdit_vue__["a" /* default */],
    GroupOptionsEdit: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_GroupOptions_GroupOptionsEdit_vue__["a" /* default */]
  },
  computed: {
    entityType: function entityType() {
      var matched = this.$route.matched || [];
      for (var i = matched.length - 1; i >= 0; i--) {
        var type = matched[i].meta && matched[i].meta.entityType;
        if (type) return type;
      }

      var segments = String(this.$route.path || '').split('/').filter(Boolean);
      var menuFixIdx = segments.indexOf('menu-fix');
      if (menuFixIdx >= 0 && segments[menuFixIdx + 1]) {
        var segment = segments[menuFixIdx + 1];
        if (segment === 'product') return 'product';
        if (segment === 'product-option') return 'product-option';
        if (segment === 'group-option') return 'group-option';
      }

      return null;
    },
    entityComponent: function entityComponent() {
      return ENTITY_COMPONENTS[this.entityType] || null;
    },
    entityRoute: function entityRoute() {
      return {
        params: { id: this.$route.params.id },
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query),
        path: this.$route.path,
        fullPath: this.$route.fullPath,
        name: this.$route.name
      };
    },
    entityRouteKey: function entityRouteKey() {
      return (this.entityType || 'unknown') + '-' + (this.$route.params.id || '');
    }
  }
});

/***/ }),

/***/ "kDXO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kEEq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kGmb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kHG/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();return _vm.deleteCampaign($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15 mar-bt-15 raffle-campaign-form"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card raffle-campaign-form__card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"header raffle-campaign-form__header"},[_c('h5',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.details')))])]),_vm._v(" "),(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('error')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('raffleCampaigns.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('name')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"4","name":"description","placeholder":_vm.$t('raffleCampaigns.description')},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.winnersDescription')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.winners_description),expression:"model.winners_description"}],staticClass:"form-control",attrs:{"rows":"4","name":"winners_description","placeholder":_vm.$t('raffleCampaigns.winnersPlaceholder')},domProps:{"value":(_vm.model.winners_description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "winners_description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.type')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":!!_vm.id,"placeholder":_vm.$t('raffleCampaigns.type')},model:{value:(_vm.model.type),callback:function ($$v) {_vm.$set(_vm.model, "type", $$v)},expression:"model.type"}},_vm._l((_vm.typeOptions),function(option){return _c('el-option',{key:option.value,attrs:{"label":option.label,"value":option.value}})})),_vm._v(" "),(_vm.id)?_c('small',{staticClass:"text-muted d-block"},[_vm._v(_vm._s(_vm.$t('raffleCampaigns.typeLocked')))]):_vm._e(),_vm._v(" "),(_vm.model.type === 'order_count')?_c('small',{staticClass:"text-muted d-block"},[_vm._v(_vm._s(_vm.$t('raffleCampaigns.typeOrderCountHint')))]):(_vm.model.type === 'order_total')?_c('small',{staticClass:"text-muted d-block"},[_vm._v(_vm._s(_vm.$t('raffleCampaigns.typeOrderTotalHint')))]):_vm._e(),_vm._v(" "),(_vm.errors.has('type'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('type')))]):_vm._e()],1),_vm._v(" "),(_vm.model.type === 'order_count')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.minOrderValue')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.min_order_value),expression:"model.min_order_value"}],staticClass:"form-control",attrs:{"type":"number","name":"min_order_value","min":"0","step":"0.01","placeholder":_vm.$t('raffleCampaigns.minOrderValue')},domProps:{"value":(_vm.model.min_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "min_order_value", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('min_order_value'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('min_order_value')))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.image')))]),_vm._v(" "),(!_vm.loading)?_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":".jpg, .jpeg, .png","on-change":_vm.handleImgChange,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize'))+_vm._s(_vm.$t('validations.imageResolution')))])]):_vm._e(),_vm._v(" "),(_vm.errors.has('image'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('image')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.pdf')))]),_vm._v(" "),(!_vm.loading)?_c('el-upload',{ref:"pdfUpload",attrs:{"action":"","limit":1,"file-list":_vm.model.pdflist,"accept":".pdf","on-change":_vm.handlePdfChange,"on-exceed":_vm.handlePdfExceed,"on-remove":_vm.handlePdfRemove,"auto-upload":false}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v(_vm._s(_vm.$t('upload.browse')))]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pdfSize')))])],1):_vm._e(),_vm._v(" "),(_vm.errors.has('pdf'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('pdf')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.startEnd')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm:ss","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}}),_vm._v(" "),(_vm.errors.has('starts_at'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('starts_at')))]):_vm._e(),_vm._v(" "),(_vm.errors.has('ends_at'))?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getError('ends_at')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.active')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}})],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kLQI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kPqi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.saveDetails($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',{},[_vm._v("\n              "+_vm._s(_vm.$t('settingsWeb.social_media'))+"\n            ")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.fbLink')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.facebookLink),expression:"modeldata.facebookLink"}],staticClass:"form-control",attrs:{"type":"text","name":"facebookLink","placeholder":_vm.$t('settingsWeb.fbLink')},domProps:{"value":(_vm.modeldata.facebookLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "facebookLink", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.igLink')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.instagramLink),expression:"modeldata.instagramLink"}],staticClass:"form-control",attrs:{"type":"text","name":"instagramLink","placeholder":_vm.$t('settingsWeb.igLink')},domProps:{"value":(_vm.modeldata.instagramLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "instagramLink", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.trpLink')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.tripadvisorLink),expression:"modeldata.tripadvisorLink"}],staticClass:"form-control",attrs:{"type":"text","name":"tripadvisorLink","placeholder":_vm.$t('settingsWeb.trpLink')},domProps:{"value":(_vm.modeldata.tripadvisorLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "tripadvisorLink", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.twitterLink')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.twitter_link),expression:"modeldata.twitter_link"}],staticClass:"form-control",attrs:{"type":"text","name":"twitter_link","placeholder":_vm.$t('settingsWeb.twitterLink')},domProps:{"value":(_vm.modeldata.twitter_link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "twitter_link", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.tiktokLink')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.tiktok_link),expression:"modeldata.tiktok_link"}],staticClass:"form-control",attrs:{"type":"text","name":"tiktok_link","placeholder":_vm.$t('settingsWeb.tiktokLink')},domProps:{"value":(_vm.modeldata.tiktok_link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "tiktok_link", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.linkedinLink')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.linkedin_link),expression:"modeldata.linkedin_link"}],staticClass:"form-control",attrs:{"type":"text","name":"linkedin_link","placeholder":_vm.$t('settingsWeb.linkedinLink')},domProps:{"value":(_vm.modeldata.linkedin_link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "linkedin_link", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.websitePrezentareLink')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.website_prezentare_link),expression:"modeldata.website_prezentare_link"}],staticClass:"form-control",attrs:{"type":"text","name":"website_prezentare_link","placeholder":_vm.$t('settingsWeb.websitePrezentareLink')},domProps:{"value":(_vm.modeldata.website_prezentare_link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "website_prezentare_link", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.whatsapp')))]),_vm._v(" "),_c('p-switch',{attrs:{"name":"use_whatsapp_chat","type":"success"},model:{value:(_vm.modeldata.use_whatsapp_chat),callback:function ($$v) {_vm.$set(_vm.modeldata, "use_whatsapp_chat", $$v)},expression:"modeldata.use_whatsapp_chat"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h5',{},[_vm._v("\n              "+_vm._s(_vm.$t('settingsWeb.link_app'))+"\n            ")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.gpLink')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.googlePlay),expression:"modeldata.googlePlay"}],staticClass:"form-control",attrs:{"type":"text","name":"googlePlay","placeholder":_vm.$t('settingsWeb.gpLink')},domProps:{"value":(_vm.modeldata.googlePlay)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "googlePlay", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.asLink')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.appleStore),expression:"modeldata.appleStore"}],staticClass:"form-control",attrs:{"type":"text","name":"appleStore","placeholder":_vm.$t('settingsWeb.asLink')},domProps:{"value":(_vm.modeldata.appleStore)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "appleStore", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.site')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.website_link),expression:"modeldata.website_link"}],staticClass:"form-control",attrs:{"type":"text","name":"website_link","placeholder":_vm.$t('settingsWeb.site')},domProps:{"value":(_vm.modeldata.website_link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "website_link", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h5',{},[_vm._v("\n              "+_vm._s(_vm.$t('settingsWeb.tracking'))+"\n            ")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.fbPixel')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.facebookPixel),expression:"modeldata.facebookPixel"}],staticClass:"form-control",attrs:{"type":"text","name":"facebookPixel","placeholder":_vm.$t('settingsWeb.fbPixel')},domProps:{"value":(_vm.modeldata.facebookPixel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "facebookPixel", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.fbapid')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.facebookAppId),expression:"modeldata.facebookAppId"}],staticClass:"form-control",attrs:{"type":"text","name":"facebookAppId","placeholder":_vm.$t('settingsWeb.fbapid')},domProps:{"value":(_vm.modeldata.facebookAppId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "facebookAppId", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.g4a')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.ga4Code),expression:"modeldata.ga4Code"}],staticClass:"form-control",attrs:{"type":"text","name":"ga4Code","placeholder":_vm.$t('settingsWeb.g4a')},domProps:{"value":(_vm.modeldata.ga4Code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "ga4Code", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h5',{},[_vm._v("\n              "+_vm._s(_vm.$t('settingsWeb.structure'))+"\n            ")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.category_proportion')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.image_proportion_category),expression:"modeldata.image_proportion_category"}],staticClass:"form-control",attrs:{"name":"image_proportion_category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modeldata, "image_proportion_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:"0",attrs:{"value":"cover","label":"Cover"}}),_vm._v(" "),_c('option',{key:"1",attrs:{"value":"contain","label":"Contain"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.product_proportion')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.image_proportion_product),expression:"modeldata.image_proportion_product"}],staticClass:"form-control",attrs:{"name":"image_proportion_product"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modeldata, "image_proportion_product", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:"0",attrs:{"value":"cover","label":"Cover"}}),_vm._v(" "),_c('option',{key:"1",attrs:{"value":"contain","label":"Contain"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.display_mode')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.display_mode),expression:"modeldata.display_mode"}],staticClass:"form-control",attrs:{"name":"display_mode"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modeldata, "display_mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:"0",attrs:{"value":"card","label":"Card"}}),_vm._v(" "),_c('option',{key:"1",attrs:{"value":"box","label":"Box"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.display_image_category')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.display_image_category),expression:"modeldata.display_image_category"}],staticClass:"form-control",attrs:{"name":"display_image_category"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modeldata, "display_image_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:"0",attrs:{"value":"0","label":_vm.$t('general.no')}}),_vm._v(" "),_c('option',{key:"1",attrs:{"value":"1","label":_vm.$t('general.yes')}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h5',{},[_vm._v("\n              "+_vm._s(_vm.$t('settingsWeb.design'))+"\n            ")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.header_color')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.header_color),expression:"modeldata.header_color"}],staticClass:"form-control",attrs:{"type":"text","name":"header_color","placeholder":_vm.$t('settingsWeb.header_color')},domProps:{"value":(_vm.modeldata.header_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "header_color", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.header_text_color')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.header_text_color),expression:"modeldata.header_text_color"}],staticClass:"form-control",attrs:{"type":"text","name":"header_text_color","placeholder":_vm.$t('settingsWeb.header_text_color')},domProps:{"value":(_vm.modeldata.header_text_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "header_text_color", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.interCol')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.interfaceColor),expression:"modeldata.interfaceColor"}],staticClass:"form-control",attrs:{"type":"text","name":"interfaceColor","placeholder":_vm.$t('settingsWeb.interCol')},domProps:{"value":(_vm.modeldata.interfaceColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "interfaceColor", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.background_color')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.background_color),expression:"modeldata.background_color"}],staticClass:"form-control",attrs:{"type":"text","name":"background_color","placeholder":_vm.$t('settingsWeb.background_color')},domProps:{"value":(_vm.modeldata.background_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.modeldata, "background_color", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.font_product_title')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.font_product_title),expression:"modeldata.font_product_title"}],staticClass:"form-control",attrs:{"name":"font_product_title"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modeldata, "font_product_title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:"0",attrs:{"value":"Poppins","label":"Poppins"}}),_vm._v(" "),_c('option',{key:"1",attrs:{"value":"Source Serif","label":"Source Serif"}}),_vm._v(" "),_c('option',{key:"2",attrs:{"value":"QuincyCF","label":"QuincyCF"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsWeb.font_product_description')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.modeldata.font_product_description),expression:"modeldata.font_product_description"}],staticClass:"form-control",attrs:{"name":"font_product_description"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.modeldata, "font_product_description", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{key:"0",attrs:{"value":"Poppins","label":"Poppins"}}),_vm._v(" "),_c('option',{key:"1",attrs:{"value":"Source Serif","label":"Source Serif"}}),_vm._v(" "),_c('option',{key:"2",attrs:{"value":"QuincyCF","label":"QuincyCF"}})])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),[_c('div',{staticClass:"col-md-12"},[_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":[{'url': _vm.modeldata.popup_image}],"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":function (file,fileList) {return _vm.handleImgChnage(file,fileList)},"on-exceed":_vm.handleExceed,"on-remove":function (file,fileList) {return _vm.handleRemove(file,fileList)},"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)]],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h5',{},[_vm._v("\n              Popup imagine\n            ")]),_vm._v(" "),_c('hr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kQ0V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableManagementForm_vue__ = __webpack_require__("e0m3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7c8f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableManagementForm_vue__ = __webpack_require__("EGZp");
function injectStyle (ssrContext) {
  __webpack_require__("gUiH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableManagementForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7c8f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableManagementForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kQxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementInventoryForm_vue__ = __webpack_require__("hphe");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneInventarForm', __WEBPACK_IMPORTED_MODULE_7__ManagementInventoryForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "kRTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons"},[_c('div',{staticClass:"form-group filter-item"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onLocationChange]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n              "+_vm._s(loc.name)+"\n            ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group filter-item"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.codeFiscalFurnizor')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",attrs:{"placeholder":"Selectează furnizor...","filterable":"","remote":"","clearable":"","remote-method":_vm.fetchSuppliers,"loading":_vm.loadingSuppliers,"disabled":_vm.loading || !_vm.selectedLocation},on:{"focus":function($event){_vm.fetchSuppliers('')}},model:{value:(_vm.filter.supplierVatNumber),callback:function ($$v) {_vm.$set(_vm.filter, "supplierVatNumber", $$v)},expression:"filter.supplierVatNumber"}},_vm._l((_vm.supplierResults),function(supplier){return _c('el-option',{key:supplier.vatNumber,attrs:{"label":((supplier.nume) + " (" + (supplier.vatNumber) + ")"),"value":supplier.vatNumber}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group filter-item"},[_c('label',[_vm._v("Numar document furnizor")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.invoiceNumber),expression:"filter.invoiceNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Numar document furnizor","disabled":_vm.loading || !_vm.selectedLocation},domProps:{"value":(_vm.filter.invoiceNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filter, "invoiceNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group filter-item"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.product')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",attrs:{"placeholder":"Caută produsul...","filterable":"","remote":"","clearable":"","remote-method":_vm.fetchProducts,"loading":_vm.loadingProducts,"disabled":_vm.loading || !_vm.selectedLocation},model:{value:(_vm.filter.productId),callback:function ($$v) {_vm.$set(_vm.filter, "productId", $$v)},expression:"filter.productId"}},_vm._l((_vm.productResults),function(product){return _c('el-option',{key:product.id,attrs:{"label":product.name,"value":product.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group filter-item filter-item-date"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.data')))]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","range-separator":"-","start-placeholder":"De la","end-placeholder":"Până la","disabled":_vm.loading || !_vm.selectedLocation,"clearable":""},model:{value:(_vm.filter.searchDate),callback:function ($$v) {_vm.$set(_vm.filter, "searchDate", $$v)},expression:"filter.searchDate"}})],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.addEntries($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('gestiune.adaugaIntrare'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.nr'),"prop":"nirNumber","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(scope.row.nirNumber)+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.furnizor'),"prop":"supplier"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(scope.row.supplier)+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.valoare'),"prop":"valoare","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(scope.row.valoare)+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.scadenta'),"prop":"dueDate","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm.formatDate(scope.row.dueDate))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.dataEmitere'),"prop":"issueDate","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm.formatDate(scope.row.issueDate))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.dataIntrare'),"prop":"entryDate","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm.formatDate(scope.row.issueDate))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('marketingOffers.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                        ▾ ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editNir(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('general.edit'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.download(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('invoice.download'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadExcel(scope.row)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('gestiune.downloadExcel'))+"\n                        ")]),_vm._v(" "),_c('el-dropdown-item',{staticStyle:{"color":"red","font-weight":"bold"},nativeOn:{"click":function($event){_vm.handleDeleteNIR(scope.row.id)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('general.delete'))+"\n                        ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.totalItems,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kRhx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kRrD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_json_excel__ = __webpack_require__("fXhN");








var _components;









__WEBPACK_IMPORTED_MODULE_7_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_13_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), _components),
  props: {
    isMixedReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isMixedReport: function isMixedReport() {
      if (this.isMixedReport) {
        this.getOrders();
      }
    }
  },
  created: function created() {
    this.getOrders();
    this.verifyUserLocations();
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      loading: true,
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_10_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('YYYY-MM-DD')],
        location: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total',
        pageSize: 20,
        currentPage: 1,
        pageSizes: [20, 50, 100]
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_10_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      ordersTableData: {
        data: []
      },
      totalRecords: 0,
      totalAmount: 0,
      totalCounter: 0,
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      hasRceipt: null,
      colors: ['#f44336', '#2196f3', '#ff9800', '#9c27b0', '#00bcd4', '#8bc34a', '#ffc107', '#3f51b5', '#ff5722', '#795548', '#607d8b', '#009688', '#cddc39', '#673ab7', '#03a9f4', '#aed581', '#ffb74d', '#ba68c8'],
      noData: false,
      tableOptions: {
        rowClassName: function rowClassName(_ref) {
          var row = _ref.row;

          if (!row) return '';
          if (row._isGrandTotal) return 'mixed-grand-total-row';
          if (row._isCategoryHeader) return 'mixed-category-header-row';
          if (row._isCategoryTotal) return 'mixed-category-total-row';
          return '';
        }
      }
    };
  },

  methods: {
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    getOrders: function getOrders(query) {
      var _this = this;

      if (!this.isMixedReport) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;

      this.apiRequest('/reports/v2/mixed-report' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          var rawItems = Array.isArray(response.data) ? response.data : response.data.items || response.data.table_data || [];

          var groupedRows = [];
          var categoryMap = {};

          var parseNumber = function parseNumber(value) {
            var n = Number(value);
            return isNaN(n) ? 0 : n;
          };

          var categoryTotals = {};
          var grandTotalItems = [];
          rawItems.forEach(function (item) {
            if (item.row_type === 'GRAND_TOTAL') {
              grandTotalItems.push(item);
            } else if (item.row_type === 'CATEGORY_TOTAL') {
              var catId = item.category_id || 'uncategorized';
              categoryTotals[catId] = item;
            } else {
              var _catId = item.category_id || 'uncategorized';
              if (!categoryMap[_catId]) {
                categoryMap[_catId] = {
                  category_id: _catId,
                  category_name: item.category_name || _this.$t('reports.uncategorized'),
                  products: []
                };
              }
              categoryMap[_catId].products.push(item);
            }
          });

          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(categoryMap).forEach(function (group) {
            groupedRows.push({
              _isCategoryHeader: true,
              _isCategoryRow: true,
              category_id: group.category_id,
              category_name: group.category_name,
              id: '',
              name: group.category_name,
              sold: '',
              eatIn: '',
              takeOut: '',
              other: '',
              mixed: '',
              employee: '',
              refund: '',
              usage: '',
              unitQty: '',
              unitPrice: '',
              sales: '',
              totalDiscount: '',
              netSales: ''
            });

            group.products.forEach(function (item) {
              var sold = parseNumber(item.units_total);
              var netSold = parseNumber(item.net_units_total);
              var eatIn = parseNumber(item.units_other_delivery);
              var takeOut = parseNumber(item.units_pickup);
              var other = parseNumber(item.units_delivery);
              var employee = parseNumber(item.units_staff_food);
              var refund = parseNumber(item.units_refunded);
              var unitPrice = Number(item.unit_price || 0);
              var sales = Number(item.sales || 0);
              var totalDiscount = Number(item.total_discount || 0);
              var netSales = Number(item.net_sales || 0);
              var usage = sold * unitPrice;

              groupedRows.push({
                _isCategoryHeader: false,
                _isCategoryRow: false,
                category_id: group.category_id,
                category_name: group.category_name,
                id: item.item_id,
                name: item.item_name,
                sold: sold,
                netSold: netSold,
                eatIn: eatIn,
                takeOut: takeOut,
                other: other,
                mixed: 0,
                employee: employee,
                refund: refund,
                usage: usage,
                unitQty: sold,
                unitPrice: unitPrice,
                sales: sales,
                totalDiscount: totalDiscount,
                netSales: netSales
              });
            });

            var apiTotal = categoryTotals[group.category_id];
            if (apiTotal) {
              var sold = parseNumber(apiTotal.units_total);
              var netSold = parseNumber(apiTotal.net_units_total);
              var eatIn = parseNumber(apiTotal.units_other_delivery);
              var takeOut = parseNumber(apiTotal.units_pickup);
              var other = parseNumber(apiTotal.units_delivery);
              var employee = parseNumber(apiTotal.units_staff_food);
              var refund = parseNumber(apiTotal.units_refunded);
              var unitPrice = Number(apiTotal.unit_price || 0);
              var sales = Number(apiTotal.sales || 0);
              var totalDiscount = Number(apiTotal.total_discount || 0);
              var netSales = Number(apiTotal.net_sales || 0);
              var usage = sold * unitPrice;

              groupedRows.push({
                _isCategoryTotal: true,
                _isCategoryRow: true,
                category_id: group.category_id,
                category_name: group.category_name,
                id: '',
                name: group.category_name,
                sold: sold,
                netSold: netSold,
                eatIn: eatIn,
                takeOut: takeOut,
                other: other,
                mixed: 0,
                employee: employee,
                refund: refund,
                usage: usage,
                unitQty: sold,
                unitPrice: unitPrice || '',
                sales: sales,
                totalDiscount: totalDiscount,
                netSales: netSales
              });
            }
          });

          grandTotalItems.forEach(function (item) {
            var sold = parseNumber(item.units_total);
            var netSold = parseNumber(item.net_units_total);
            var eatIn = parseNumber(item.units_other_delivery);
            var takeOut = parseNumber(item.units_pickup);
            var other = parseNumber(item.units_delivery);
            var employee = parseNumber(item.units_staff_food);
            var refund = parseNumber(item.units_refunded);
            var unitPrice = Number(item.unit_price || 0);
            var sales = Number(item.sales || 0);
            var totalDiscount = Number(item.total_discount || 0);
            var netSales = Number(item.net_sales || 0);
            var usage = sold * unitPrice;

            groupedRows.push({
              _isGrandTotal: true,
              _isCategoryRow: true,
              id: '',
              name: _this.$t('reports.grandTotal') || 'Grand Total',
              sold: sold,
              netSold: netSold,
              eatIn: eatIn,
              takeOut: takeOut,
              other: other,
              mixed: 0,
              employee: employee,
              refund: refund,
              usage: usage,
              unitQty: sold,
              unitPrice: unitPrice || '',
              sales: sales,
              totalDiscount: totalDiscount,
              netSales: netSales
            });
          });

          if (groupedRows && groupedRows.length) {
            _this.noData = false;
            _this.ordersTableData.data = groupedRows;
            _this.ordersTableData.total = groupedRows.length;

            _this.totalRecords = response.pagination ? response.pagination.total : groupedRows.length;
            _this.paginationProps.currentPage = response.pagination ? response.pagination.page : page;
            _this.paginationProps.pageSize = response.pagination ? response.pagination.perPage : pageSize;

            _this.totalCounter = response.pagination ? response.pagination.ordersTotal : 0;
          } else {
            _this.noData = true;
            _this.ordersTableData.data = [];
            _this.ordersTableData.total = 0;
            _this.totalRecords = 0;
            _this.paginationProps.currentPage = page;
            _this.paginationProps.pageSize = pageSize;
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    formatNumber: function formatNumber(value) {
      if (value === '' || value === null || value === undefined) {
        return '';
      }
      var n = Number(value);
      if (!isFinite(n) || n === 0) {
        return n === 0 ? '0' : '';
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(n) ? n : n.toFixed(2);
    },
    exportData: function exportData() {
      var _this2 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;

      this.apiRequest('/reports/v2/mixed-report?page=1&per_page=1', 'GET', data, function (response) {
        if (response && response.status) {
          var pagination = response.pagination || {};
          var total = pagination.total != null ? pagination.total : 0;

          if (!total) {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', _this2.$t('reports.noData') || 'Nu există date', 'info');
            _this2.loading = false;
            return;
          }

          _this2.apiRequest('/reports/v2/mixed-report-download', 'GET', data, function (downloadResponse) {
            if (downloadResponse && downloadResponse.status === true) {
              var link = document.createElement('a');
              link.href = downloadResponse.data.file;
              link.setAttribute('download', downloadResponse.data.file_name);
              document.body.appendChild(link);
              link.click();
            } else {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
            }
            _this2.loading = false;
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
          _this2.loading = false;
        }
      });
    },
    paginationChanged: function paginationChanged(query) {
      this.getOrders(query);
    }
  }
});

/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72178306_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("TVvH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72178306_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kXS+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    locations: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    },
    vatNumber: String
  },
  data: function data() {
    return {
      selectedLocationSeries: '',
      editSeriesId: null,
      series: '',
      startNumber: null,
      endNumber: null,
      tip: ''
    };
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },

  watch: {
    startNumber: function startNumber(value) {
      if (value === 0) {
        this.startNumber = 1;
      }
    }
  },
  methods: {
    openSeriesModal: function openSeriesModal() {
      this.editSeriesId = null;
      this.tip = '';
      this.series = '';
      this.startNumber = '';
      this.endNumber = '';

      this.$modal.show('addSeriesModal');
    },
    closeSeriesModal: function closeSeriesModal() {
      this.$modal.hide('addSeriesModal');
    },
    saveSeries: function saveSeries() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var mappedTip, seriesData, seriesResponse, seriesDataResponse;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this.series || !_this.startNumber || !_this.tip)) {
                  _context.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: 'Error',
                  text: 'All fields are required for the series.',
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                });
                return _context.abrupt('return');

              case 3:
                mappedTip = '';
                _context.t0 = _this.tip;
                _context.next = _context.t0 === 'NIR' ? 7 : _context.t0 === 'Nota de consum' ? 9 : _context.t0 === 'Bon consum' ? 11 : _context.t0 === 'Bon de transfer' ? 13 : _context.t0 === 'Bon de productie' ? 15 : _context.t0 === 'Inventar' ? 17 : _context.t0 === 'Invoice' ? 19 : _context.t0 === 'Proforma' ? 21 : _context.t0 === 'Aviz' ? 23 : _context.t0 === 'Order' ? 25 : _context.t0 === 'Casare' ? 27 : 29;
                break;

              case 7:
                mappedTip = 'nir';
                return _context.abrupt('break', 30);

              case 9:
                mappedTip = 'nota_de_consum';
                return _context.abrupt('break', 30);

              case 11:
                mappedTip = 'bon_consum';
                return _context.abrupt('break', 30);

              case 13:
                mappedTip = 'bon_transfer';
                return _context.abrupt('break', 30);

              case 15:
                mappedTip = 'bon_productie';
                return _context.abrupt('break', 30);

              case 17:
                mappedTip = 'inventar';
                return _context.abrupt('break', 30);

              case 19:
                mappedTip = 'invoice';
                return _context.abrupt('break', 30);

              case 21:
                mappedTip = 'proforma';
                return _context.abrupt('break', 30);

              case 23:
                mappedTip = 'aviz';
                return _context.abrupt('break', 30);

              case 25:
                mappedTip = 'order';
                return _context.abrupt('break', 30);

              case 27:
                mappedTip = 'bon_casare';
                return _context.abrupt('break', 30);

              case 29:
                mappedTip = _this.tip;

              case 30:
                seriesData = {
                  externalCompanyId: _this.companyID,
                  externalLocationId: _this.selectedLocationSeries.true_id,
                  vatNumber: _this.selectedLocationSeries.inv_fiscal_code,
                  series: _this.series,
                  startNumber: _this.startNumber,
                  endNumber: _this.endNumber || 999999,
                  tip: mappedTip
                };
                _context.prev = 31;
                _context.next = 34;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/series', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(seriesData)
                });

              case 34:
                seriesResponse = _context.sent;

                if (seriesResponse.ok) {
                  _context.next = 37;
                  break;
                }

                throw new Error('Error saving series');

              case 37:
                _context.next = 39;
                return seriesResponse.json();

              case 39:
                seriesDataResponse = _context.sent;

                console.log('Series saved successfully:', seriesDataResponse);

                _this.$modal.hide('addSeriesModal');

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Seria a fost salvată cu succes.',
                  type: 'success',
                  timer: 1500,
                  showConfirmButton: false
                });

                _this.$emit('getSeries', _this.vatNumber);
                _context.next = 50;
                break;

              case 46:
                _context.prev = 46;
                _context.t1 = _context['catch'](31);

                console.error('Error saving series:', _context.t1);

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  title: 'Error',
                  text: _context.t1.message,
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                });

              case 50:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[31, 46]]);
      }))();
    }
  }
});

/***/ }),

/***/ "kYML":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kbGJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonProductEdit_vue__ = __webpack_require__("Qafa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289bd6d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonProductEdit_vue__ = __webpack_require__("oZx1");
function injectStyle (ssrContext) {
  __webpack_require__("kpVk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-289bd6d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonProductEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289bd6d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonProductEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kbjP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInvoiceSupplierView_vue__ = __webpack_require__("oW06");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268a158b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInvoiceSupplierView_vue__ = __webpack_require__("ZArx");
function injectStyle (ssrContext) {
  __webpack_require__("+cGz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-268a158b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInvoiceSupplierView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268a158b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInvoiceSupplierView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kbwa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OffersForm_vue__ = __webpack_require__("41va");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'OffersForm', __WEBPACK_IMPORTED_MODULE_7__OffersForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      offerModel: {},
      offer: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onOfferSubmit: function onOfferSubmit(model, isValid) {
      this.offerModel = model;
    }
  }
});

/***/ }),

/***/ "kdQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralRewardRule_vue__ = __webpack_require__("ota6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6e33f16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralRewardRule_vue__ = __webpack_require__("8ODs");
function injectStyle (ssrContext) {
  __webpack_require__("eV2F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6e33f16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralRewardRule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6e33f16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralRewardRule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kdei":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kgt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSeriesAdd_vue__ = __webpack_require__("kXS+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f705a85_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSeriesAdd_vue__ = __webpack_require__("qUDU");
function injectStyle (ssrContext) {
  __webpack_require__("m/ts")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f705a85"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementSeriesAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f705a85_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementSeriesAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "khGH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsystem-setup"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('rsystem.apiKey')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.draft.api_key),expression:"draft.api_key"}],staticClass:"form-control",attrs:{"type":"password","autocomplete":"new-password"},domProps:{"value":(_vm.draft.api_key)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.draft, "api_key", $event.target.value)},_vm.credentialsChanged]}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('rsystem.settings')))]),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn add",attrs:{"type":"button","disabled":_vm.busy || !_vm.draft.api_key},on:{"click":_vm.loadOrganizations}},[_vm._v(_vm._s(_vm.$t('rsystem.fetchOrganizations')))])])]),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"text-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.organizations.length)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('rsystem.organisationId')))]),_vm._v(" "),_c('el-select',{attrs:{"filterable":"","disabled":_vm.busy,"placeholder":_vm.$t('rsystem.choose')},on:{"change":_vm.organizationChanged},model:{value:(_vm.draft.organization_id),callback:function ($$v) {_vm.$set(_vm.draft, "organization_id", $$v)},expression:"draft.organization_id"}},_vm._l((_vm.organizations),function(item){return _c('el-option',{key:item.id,staticClass:"rsystem-option",attrs:{"value":item.id,"label":item.name || item.id}},[_c('span',{staticClass:"option-title"},[_vm._v(_vm._s(item.name || item.id))]),_vm._v(" "),_c('span',{staticClass:"option-subtitle",attrs:{"title":item.id}},[_vm._v(_vm._s(item.id))]),_vm._v(" "),(item.address)?_c('span',{staticClass:"option-subtitle"},[_vm._v(_vm._s(item.address))]):_vm._e()])})),_vm._v(" "),(_vm.draft.organization_id)?_c('small',{staticClass:"selection-id"},[_vm._v(_vm._s(_vm.draft.organization_id))]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.options)?[_c('div',{staticClass:"row"},_vm._l((_vm.entityFields),function(field){return _c('div',{key:field.key,staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('rsystem.' + field.label)))]),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","filterable":"","disabled":_vm.busy,"placeholder":_vm.$t('rsystem.choose')},on:{"change":function($event){_vm.entityChanged(field.key)}},model:{value:(_vm.draft[field.key]),callback:function ($$v) {_vm.$set(_vm.draft, field.key, $$v)},expression:"draft[field.key]"}},_vm._l((_vm.options[field.list]),function(item){return _c('el-option',{key:item.id,staticClass:"rsystem-option",attrs:{"value":item.id,"label":item.name || item.id}},[_c('span',{staticClass:"option-title"},[_vm._v(_vm._s(item.name || item.id))]),_vm._v(" "),_c('span',{staticClass:"option-subtitle",attrs:{"title":item.id}},[_vm._v(_vm._s(item.id))]),_vm._v(" "),(item.mode)?_c('span',{staticClass:"option-detail"},[_vm._v(_vm._s(_vm.discountLabel(item)))]):_vm._e()])})),_vm._v(" "),(_vm.draft[field.key])?_c('small',{staticClass:"selection-id"},[_vm._v(_vm._s(_vm.draft[field.key]))]):_vm._e(),_vm._v(" "),(_vm.selectedEntity(field) && _vm.selectedEntity(field).mode)?_c('small',{staticClass:"selection-detail"},[_vm._v(_vm._s(_vm.discountLabel(_vm.selectedEntity(field))))]):_vm._e()],1)})),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('rsystem.paymentTypes')))]),_vm._v(" "),_vm._l((_vm.paymentTypes),function(type){return _c('div',{key:type,staticClass:"row form-group"},[_c('label',{staticClass:"col-md-3"},[_vm._v(_vm._s(_vm.$t('rsystem.payment_' + type)))]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('el-select',{attrs:{"clearable":"","filterable":"","disabled":_vm.busy,"placeholder":_vm.$t('rsystem.choose')},model:{value:(_vm.paymentIds[type]),callback:function ($$v) {_vm.$set(_vm.paymentIds, type, $$v)},expression:"paymentIds[type]"}},_vm._l((_vm.paymentChoices),function(item){return _c('el-option',{key:item.id,staticClass:"rsystem-option",attrs:{"value":item.id,"label":item.name || item.id}},[_c('span',{staticClass:"option-title"},[_vm._v(_vm._s(item.name || item.id))]),_vm._v(" "),_c('span',{staticClass:"option-subtitle",attrs:{"title":item.id}},[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('span',{staticClass:"option-detail"},[_vm._v(_vm._s(item.paymentTypeKind))])])})),_vm._v(" "),(_vm.paymentIds[type])?_c('small',{staticClass:"selection-id"},[_vm._v(_vm._s(_vm.paymentIds[type]))]):_vm._e()],1)])}),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('rsystem.reviewMappings')))]),_vm._v(" "),_c('p',{staticClass:"help-block"},[_c('strong',[_vm._v(_vm._s(_vm.$t('rsystem.destination'))+":")]),_vm._v(" "+_vm._s(_vm.selectedOrganizationLabel)+" / "+_vm._s(_vm.selectedTerminalLabel))])]:_vm._e(),_vm._v(" "),(_vm.notice)?_c('p',{staticClass:"help-block",attrs:{"role":"status"}},[_vm._v(_vm._s(_vm.notice))]):_vm._e(),_vm._v(" "),(_vm.menuRefreshRequired)?_c('p',{staticClass:"text-warning"},[_vm._v(_vm._s(_vm.$t('rsystem.refreshMenu')))]):_vm._e(),_vm._v(" "),(_vm.config.id)?_c('div',{staticClass:"form-group mar-to-15"},[_c('button',{staticClass:"btn add",attrs:{"type":"button","disabled":_vm.busy || _vm.dirty || !_vm.options},on:{"click":_vm.importMenu}},[_vm._v(_vm._s(_vm.$t('rsystem.import')))]),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$t('rsystem.deleteMenu'))+". "+_vm._s(_vm.$t('rsystem.seoText')))])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kjIg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"integration-form-shell"},[_c('div',{class:(_vm.showFormLoader ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();_vm.$emit('back')}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.showDeleteButton)?_c('a',{staticClass:"btn delete mar-rt-10",class:{ disabled: _vm.busy || _vm.disabled || _vm.actionBusy },attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();return _vm.onDeleteClick($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png","alt":""}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.showValidateButton)?_c('button',{staticClass:"btn btn-info btn-icon mar-rt-10 validate",attrs:{"type":"button","disabled":_vm.validateDisabled || _vm.actionBusy,"title":_vm.$t('general.validate')},on:{"click":function($event){$event.preventDefault();return _vm.startValidationFlow($event)}}},[_vm._v("\n          "+_vm._s(_vm.$t('general.validate'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","disabled":_vm.saveDisabled || _vm.actionBusy,"title":_vm.saveButtonTitle}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.saveButtonLabel)+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15 mar-bt-15 integration-form-layout"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card integration-form-layout__card"},[_c('div',{staticClass:"card-content"},[(_vm.heading)?_c('h5',{staticClass:"mar-bt-15"},[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),(_vm.isWoltIntegration)?_c('wolt-integration-form',{attrs:{"form-data":_vm.formData,"locations":_vm.locations,"top-categories":_vm.topCategories,"disabled":_vm.disabled,"field-label-fn":_vm.fieldLabelFn,"required-fields":_vm.woltRequiredFields,"validation-errors":_vm.woltValidationErrors,"show-field-validation":_vm.showFieldValidation}}):(_vm.isWoltDriveIntegration)?_c('wolt-drive-integration-form',{attrs:{"form-data":_vm.formData,"locations":_vm.locations,"disabled":_vm.disabled,"occupied-location-ids":_vm.occupiedLocationIds,"is-create-mode":_vm.isCreateMode,"field-label-fn":_vm.fieldLabelFn,"required-fields":_vm.woltDriveRequiredFields,"validation-errors":_vm.woltDriveValidationErrors,"show-field-validation":_vm.showFieldValidation}}):(_vm.isDeliveryHeroIntegration)?_c('delivery-hero-integration-form',{attrs:{"form-data":_vm.formData,"locations":_vm.locations,"disabled":_vm.disabled,"occupied-location-ids":_vm.occupiedLocationIds,"is-create-mode":_vm.isCreateMode,"field-label-fn":_vm.fieldLabelFn,"required-fields":_vm.deliveryHeroRequiredFields,"credential-fields":_vm.deliveryHeroCredentialFields,"validation-errors":_vm.deliveryHeroValidationErrors,"show-field-validation":_vm.showFieldValidation,"regenerating-keys":_vm.regeneratingDeliveryHeroKeys},on:{"regenerate-keys":function($event){_vm.$emit('regenerate-keys')}}}):(_vm.isBoltIntegration)?_c('bolt-integration-form',{attrs:{"form-data":_vm.formData,"locations":_vm.locations,"top-categories":_vm.topCategories,"disabled":_vm.disabled,"field-label-fn":_vm.fieldLabelFn,"required-fields":_vm.boltRequiredFields,"validation-errors":_vm.boltValidationErrors,"show-field-validation":_vm.showFieldValidation}}):(_vm.isGlovoLaasIntegration)?_c('glovo-laas-integration-form',{attrs:{"form-data":_vm.formData,"locations":_vm.locations,"disabled":_vm.disabled,"occupied-location-ids":_vm.occupiedLocationIds,"is-create-mode":_vm.isCreateMode,"field-label-fn":_vm.fieldLabelFn,"required-fields":_vm.glovoLaasRequiredFields,"validation-errors":_vm.glovoLaasValidationErrors,"show-field-validation":_vm.showFieldValidation}}):(_vm.isGlovoIntegration)?_c('glovo-integration-form',{attrs:{"form-data":_vm.formData,"locations":_vm.locations,"top-categories":_vm.topCategories,"disabled":_vm.disabled,"field-label-fn":_vm.fieldLabelFn,"required-fields":_vm.glovoRequiredFields,"validation-errors":_vm.glovoValidationErrors,"show-field-validation":_vm.showFieldValidation}}):(_vm.fieldNames && _vm.fieldNames.length)?_c('pricelist-fields-form',{attrs:{"field-names":_vm.fieldNames,"form-data":_vm.formData,"form-text":_vm.formText,"disabled":_vm.disabled,"boolean-fields":_vm.booleanFields,"json-fields":_vm.jsonFields,"json-hint":_vm.jsonHint,"field-label-fn":_vm.fieldLabelFn,"read-only-fields":_vm.readOnlyFields}}):_vm._e(),_vm._v(" "),(_vm.showWebhookStatus)?_c('div',{staticClass:"integration-webhook-status"},[_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"integration-webhook-status__row"},[_c('span',{staticClass:"integration-webhook-status__label"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsWebhookStatusLabel')))]),_vm._v(" "),_c('span',{staticClass:"integration-webhook-status__badge",class:_vm.webhookRegistered ? 'integration-webhook-status__badge--ok' : 'integration-webhook-status__badge--warn'},[_vm._v("\n                "+_vm._s(_vm.webhookRegistered ? _vm.$t('gestiune.integrationsWebhookRegistered') : _vm.$t('gestiune.integrationsWebhookNotRegistered'))+"\n              ")])]),_vm._v(" "),(!_vm.webhookRegistered)?_c('p',{staticClass:"integration-webhook-status__hint"},[_vm._v("\n              "+_vm._s(_vm.$t('gestiune.integrationsWebhookRegisterHint'))+"\n            ")]):_vm._e()]):_vm._e()],1)]),_vm._v(" "),(_vm.isMarketplaceIntegration)?_c('div',{staticClass:"card integration-form-layout__card integration-form-actions-card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('marketplace.operations')))]),_vm._v(" "),_c('div',{staticClass:"marketplace-action-grid"},[_c('section',{staticClass:"marketplace-action-panel marketplace-action-panel--menu"},[_c('div',{staticClass:"marketplace-action-heading"},[_c('i',{staticClass:"ti-menu-alt",attrs:{"aria-hidden":"true"}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('marketplace.menuActions')))]),_c('p',[_vm._v(_vm._s(_vm.$t('marketplace.menuActionsHint')))])])]),_vm._v(" "),_c('div',{staticClass:"row marketplace-menu-settings"},[_c('integration-menu-top-categories-field',{attrs:{"form-data":_vm.formData,"top-categories":_vm.topCategories,"disabled":_vm.disabled || _vm.busy || _vm.actionBusy,"field-label-fn":_vm.fieldLabelFn,"show-filter-note":!_vm.isGlovoIntegration}}),_vm._v(" "),(_vm.isBoltIntegration)?_c('div',{staticClass:"col-md-6 form-group marketplace-menu-settings__language"},[_c('label',{attrs:{"for":"bolt-menu-language"}},[_vm._v(_vm._s(_vm.fieldLabelFn ? _vm.fieldLabelFn('menu_language') : 'Menu language'))]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.menu_language),expression:"formData.menu_language"}],staticClass:"form-control",attrs:{"id":"bolt-menu-language","disabled":_vm.disabled || _vm.busy || _vm.actionBusy},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "menu_language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"ro-RO"}},[_vm._v("RO")]),_c('option',{attrs:{"value":"en-US"}},[_vm._v("EN")])])]):_vm._e()],1),_vm._v(" "),(!_vm.showIntegrationActions)?_c('p',{staticClass:"marketplace-field-hint"},[_vm._v(_vm._s(_vm.$t('marketplace.saveBeforeActions')))]):_vm._e(),_vm._v(" "),(_vm.isGlovoIntegration)?_c('div',{staticClass:"integration-glovo-menu"},[_c('div',{staticClass:"integration-glovo-menu__summary"},[_c('div',{staticClass:"integration-glovo-menu__summary-row"},[_c('span',{staticClass:"integration-glovo-menu__summary-label"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsGlovoExportsToday')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.glovoMenuExportsToday))])]),_vm._v(" "),_c('div',{staticClass:"integration-glovo-menu__summary-row"},[_c('span',{staticClass:"integration-glovo-menu__summary-label"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsGlovoLastExport')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.glovoLastExportLabel))]),_vm._v(" "),(_vm.glovoExportStatusBadge)?_c('span',{staticClass:"integration-glovo-menu__badge",class:'integration-glovo-menu__badge--' + _vm.glovoExportStatusBadge.type},[_vm._v("\n                  "+_vm._s(_vm.glovoExportStatusBadge.label)+"\n                ")]):_vm._e()]),_vm._v(" "),(_vm.glovoLastExportStatus)?_c('div',{staticClass:"integration-glovo-menu__summary-row"},[_c('span',{staticClass:"integration-glovo-menu__summary-label"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsGlovoExportStatus')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.glovoLastExportStatus))])]):_vm._e(),_vm._v(" "),(_vm.glovoLastExportDetails.length)?_c('div',{staticClass:"integration-glovo-menu__details"},_vm._l((_vm.glovoLastExportDetails),function(detail,detailIdx){return _c('p',{key:'glovo-export-detail-' + detailIdx,staticClass:"integration-glovo-menu__detail-line"},[_vm._v("\n                  "+_vm._s(detail)+"\n                ")])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"integration-glovo-menu__buttons"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button","disabled":_vm.disabled || _vm.busy || _vm.actionBusy || !_vm.showIntegrationActions},on:{"click":function($event){$event.preventDefault();return _vm.openMenuPreview($event)}}},[_vm._v("\n                "+_vm._s(_vm.$t('gestiune.integrationsMenuPreviewOpen'))+"\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"button","disabled":_vm.disabled || _vm.busy || _vm.actionBusy || !_vm.canCheckGlovoExportStatus || !_vm.showIntegrationActions,"title":_vm.canCheckGlovoExportStatus ? '' : _vm.$t('gestiune.integrationsGlovoCheckStatusDisabledHint')},on:{"click":function($event){$event.preventDefault();return _vm.checkGlovoExportStatus($event)}}},[_vm._v("\n                "+_vm._s(_vm.$t('gestiune.integrationsGlovoCheckStatus'))+"\n              ")])])]):_c('button',{staticClass:"btn btn-info marketplace-primary-action",attrs:{"type":"button","disabled":_vm.disabled || _vm.busy || _vm.actionBusy || !_vm.showIntegrationActions},on:{"click":function($event){$event.preventDefault();return _vm.openMenuPreview($event)}}},[_c('i',{staticClass:"ti-eye",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('gestiune.integrationsMenuPreviewOpen'))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"marketplace-import-action"},[_c('platform-menu-import-link',{attrs:{"location-id":_vm.formData.location_id}})],1),_vm._v(" "),_c('div',{staticClass:"marketplace-action-notice"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsMenuUploadCampaignsHint')))]),(_vm.isGlovoIntegration)?_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsGlovoMenuSyncDailyLimitHint')))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"marketplace-action-stack"},[(_vm.isWoltIntegration && _vm.showIntegrationActions)?_c('section',{staticClass:"marketplace-action-panel"},[_c('div',{staticClass:"marketplace-action-heading"},[_c('i',{staticClass:"ti-link",attrs:{"aria-hidden":"true"}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('marketplace.connection')))]),_c('p',[_vm._v(_vm._s(_vm.$t('marketplace.connectionHint')))])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"button","disabled":_vm.disabled || _vm.busy || _vm.actionBusy || !_vm.formData.venue_id || !_vm.formData.client_id || !_vm.formData.client_secret},on:{"click":function($event){$event.preventDefault();return _vm.enrollWolt($event)}}},[_vm._v(_vm._s(_vm.$t(_vm.formData.is_integrated ? 'wolt.updateCredentials' : 'wolt.getWolt')))])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"marketplace-action-panel"},[_c('div',{staticClass:"marketplace-action-heading"},[_c('i',{staticClass:"ti-shopping-cart",attrs:{"aria-hidden":"true"}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('marketplace.orderSettings')))]),_c('p',[_vm._v(_vm._s(_vm.$t('marketplace.orderSettingsHint')))])])]),_vm._v(" "),_c('marketplace-order-settings',{attrs:{"form-data":_vm.formData,"platform":_vm.integrationType,"disabled":_vm.disabled || _vm.busy || _vm.actionBusy,"field-label-fn":_vm.fieldLabelFn}}),_vm._v(" "),(_vm.showIntegrationActions)?_c('div',{staticClass:"marketplace-action-line"},[_c('label',[_vm._v(_vm._s(_vm.$t('bolt.acceptOrders')))]),_c('p-switch',{attrs:{"type":"success","name":"integration-accept-orders","disabled":_vm.disabled || _vm.busy || _vm.actionBusy},on:{"input":_vm.handleAcceptOrdersStatus},model:{value:(_vm.acceptOrdersStatus),callback:function ($$v) {_vm.acceptOrdersStatus=$$v},expression:"acceptOrdersStatus"}})],1):_vm._e()],1)])]),_vm._v(" "),(_vm.isWoltIntegration || _vm.isBoltIntegration)?_c('section',{staticClass:"marketplace-action-panel marketplace-schedule-panel"},[_c('div',{staticClass:"marketplace-schedule-panel__header"},[_c('div',{staticClass:"marketplace-action-heading"},[_c('i',{staticClass:"ti-time",attrs:{"aria-hidden":"true"}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('marketplace.scheduleTitle')))]),_c('p',[_vm._v(_vm._s(_vm.$t('marketplace.scheduleHint')))])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"type":"button","disabled":_vm.disabled || _vm.busy || _vm.actionBusy || !_vm.showScheduleAction},on:{"click":function($event){$event.preventDefault();return _vm.syncIntegrationSchedule($event)}}},[_c('i',{staticClass:"ti-reload",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t('gestiune.integrationsSyncSchedule')))])]),_vm._v(" "),_c('integration-schedule-editor',{attrs:{"form-data":_vm.formData,"platform":_vm.integrationType,"disabled":_vm.disabled || _vm.busy || _vm.actionBusy}}),_vm._v(" "),(!_vm.showIntegrationActions)?_c('p',{staticClass:"marketplace-field-hint"},[_vm._v(_vm._s(_vm.$t('marketplace.saveBeforeActions')))]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isBoltIntegration)?_c('section',{staticClass:"marketplace-action-panel marketplace-notifications-panel"},[_c('div',{staticClass:"marketplace-action-heading"},[_c('i',{staticClass:"ti-email",attrs:{"aria-hidden":"true"}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('marketplace.notifications')))]),_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsFeedbackEmailsHint')))])])]),_vm._v(" "),_c('label',{attrs:{"for":"bolt-feedback-emails"}},[_vm._v(_vm._s(_vm.fieldLabelFn ? _vm.fieldLabelFn('emails') : 'Emails'))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.emails),expression:"formData.emails"}],staticClass:"form-control",attrs:{"id":"bolt-feedback-emails","rows":"2","disabled":_vm.disabled || _vm.busy || _vm.actionBusy,"placeholder":_vm.$t('gestiune.integrationsFeedbackEmailsHint')},domProps:{"value":(_vm.formData.emails)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "emails", $event.target.value)}}}),_vm._v(" "),(_vm.boltValidationErrors.emails)?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.boltValidationErrors.emails))]):_vm._e()]):_vm._e()])]):_vm._e()])])]),_vm._v(" "),_c('integration-menu-preview-modal',{attrs:{"visible":_vm.menuPreviewVisible,"busy":_vm.menuPreviewBusy,"importing":_vm.menuPreviewImporting,"layout":_vm.menuPreviewLayout,"currency":_vm.menuPreviewCurrency,"categories":_vm.menuPreviewCategories,"error-message":_vm.menuPreviewError,"warnings":_vm.menuPreviewWarnings,"title":_vm.menuPreviewTitle,"subtitle":_vm.menuPreviewSubtitle},on:{"close":_vm.closeMenuPreview,"import":_vm.confirmImportMenuFromPreview}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "klo8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAABHNCSVQICAgIfAhkiAAAAsRJREFUWEftWE1SWkEQ7uZhRVfxBjEnCJ4gj02qcJNkmVJLOYF4AvEEwgmEQitb2UhVNrycQHKCkBNEV0lKoPP1yIPxwYP3A4FFporir/ub733T090zTIHR+iw70qcT/OwyUc7/W4RutnpUzBf5PugT9r19Kdu/snTJTB9GOEQdfPbYoWrhE3dtX8w3HrdXcoEfSmHgQnS6d8CVqGSAVwLexQy8CvBO/f9HZOB4ZysRAlAvHPBxVDKtK6nB9miWvSq+d8gf1caQuW1IBVLq0swaDw6T+26fVeZI48u15PpCHoxfziFUBaESa4xQn74HjcH4K5gqEFGGunh5wTWOwsjgD8jFa0ftsdQuHvzthK9Dr3mqKkLnhUMuR5ksiU2rIWWsyZnti4evcjBWVBFI5iaZJI4PRPBshaBYhxFkeLfGklXxZ5qmzirJuFiqtq3DJBmmYmGfa3EkT2ILZaaSuQHY+yHgAzmUS7Jr4hIa7mJNE/62r7NJ2Rt0rAkPeaQSJ4/EJRC0H+ahkgbv1iPVnpWDtOBp/dePjJFrHDdpHzC2v0PU1PCYnoFjw6V3eMrADfmJTLidHi4dAsjcaznoInBepYNagLfQNzbxMqAasuGbBUAmgwARJ2PSy/qM/2TC1mK9lNHa9CdLR8KmNlVXUJtOWKjzokd1bSFGVdvs9Szt/quqLT26s3Jcc+36mVW1nRE6vZX2wA3pBLKvh1NjftmpELGq/a87mkfLwdRzE1MZffD5sgi1ruUMp7myjW+qdtiJEoYeFPOw5T11QtT/SLLLzK2GPBVibGEXJFSNsSI+Iz1R6ucoZ23d9tkM5ePkIS3CvQG157Uoqoo5a/vE7HwTtjy+U9Tli3ILAawmYtTc3zy/n5lzG7Hw+5mhIv7DTdQms8Y9Usk0D9g9Tn3zkUpxb65+b6BXsvtr7Bo8lIdMXwnG4F+6JFUoEegUJAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "koIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Trends_vue__ = __webpack_require__("YU8E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExportableReports_vue__ = __webpack_require__("iZ3x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReportsSales_vue__ = __webpack_require__("ZdWa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReportsSalesBeta_vue__ = __webpack_require__("BdcM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccountingReport_vue__ = __webpack_require__("qLp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Clients_vue__ = __webpack_require__("zXsf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductsSales_vue__ = __webpack_require__("jjA+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OrderStatus_vue__ = __webpack_require__("fimh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PdfRaport_vue__ = __webpack_require__("yGpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LoyaltyPoints_vue__ = __webpack_require__("lkLB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ClientPoints_vue__ = __webpack_require__("6KiT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DonationReport_vue__ = __webpack_require__("HhpG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DonationCampaignsReport_vue__ = __webpack_require__("KiKy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RaffleCampaignsReport_vue__ = __webpack_require__("dVmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LoyaltyStoreReport_vue__ = __webpack_require__("SfqF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ChallengeCampaignsReport_vue__ = __webpack_require__("7dba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SpinningWheelReport_vue__ = __webpack_require__("cQRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Ocr_vue__ = __webpack_require__("HQw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__StockMovements_vue__ = __webpack_require__("ew9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ReorderPopupResponses_vue__ = __webpack_require__("37fh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Wallet_vue__ = __webpack_require__("Da5+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ReportRequest_vue__ = __webpack_require__("UUgn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Versions_2_SalesPaymentMethod_vue__ = __webpack_require__("N91b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Versions_2_SalesProducts_vue__ = __webpack_require__("ACsk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Versions_2_SalesProductsTrend_vue__ = __webpack_require__("ryVW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Versions_2_SalesTrend_vue__ = __webpack_require__("nJqr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Versions_2_TopProducts_vue__ = __webpack_require__("Zkgz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Versions_2_TopCategories_vue__ = __webpack_require__("igoA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Versions_2_OrderFromReport_vue__ = __webpack_require__("vQiK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Versions_2_ProductsAndOptionsReport_vue__ = __webpack_require__("yIa/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Versions_2_OperatorSalesReport_vue__ = __webpack_require__("N64B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Versions_2_WaiterTipsReport_vue__ = __webpack_require__("U0qm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Versions_2_DashboardReport_vue__ = __webpack_require__("IOOJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Versions_2_StornoReport_vue__ = __webpack_require__("BlQF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Versions_2_MasterReport_vue__ = __webpack_require__("uco5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Versions_2_FiscalZReport_vue__ = __webpack_require__("A5Ie");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Versions_2_TableOpenOrderReport_vue__ = __webpack_require__("sCPY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Versions_2_PosOrderActionsReport_vue__ = __webpack_require__("d9Hv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Versions_2_CustomerLifetimeValue_vue__ = __webpack_require__("thbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Versions_2_ReferralProgramReport_vue__ = __webpack_require__("GKg+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Versions_2_PreordersItems_vue__ = __webpack_require__("niY4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Versions_2_MixedReport_vue__ = __webpack_require__("PYU9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Versions_2_CharismaReport_vue__ = __webpack_require__("oCdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Versions_2_CharismaLocationReceipt_vue__ = __webpack_require__("sbNK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Versions_2_NexusReport_vue__ = __webpack_require__("K4Pz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Versions_2_LabelEvolution_vue__ = __webpack_require__("Ib+y");

















































/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Trends: __WEBPACK_IMPORTED_MODULE_0__Trends_vue__["a" /* default */],
    ExportableReports: __WEBPACK_IMPORTED_MODULE_1__ExportableReports_vue__["a" /* default */],
    ReportsSales: __WEBPACK_IMPORTED_MODULE_2__ReportsSales_vue__["a" /* default */],
    ReportsSalesBeta: __WEBPACK_IMPORTED_MODULE_3__ReportsSalesBeta_vue__["a" /* default */],
    AccountingReport: __WEBPACK_IMPORTED_MODULE_4__AccountingReport_vue__["a" /* default */],
    Clients: __WEBPACK_IMPORTED_MODULE_5__Clients_vue__["a" /* default */],
    ProductsSales: __WEBPACK_IMPORTED_MODULE_6__ProductsSales_vue__["a" /* default */],
    OrderStatus: __WEBPACK_IMPORTED_MODULE_7__OrderStatus_vue__["a" /* default */],
    PdfRaport: __WEBPACK_IMPORTED_MODULE_8__PdfRaport_vue__["a" /* default */],
    LoyaltyPoints: __WEBPACK_IMPORTED_MODULE_9__LoyaltyPoints_vue__["a" /* default */],
    ClientPoints: __WEBPACK_IMPORTED_MODULE_10__ClientPoints_vue__["a" /* default */],
    DonationReport: __WEBPACK_IMPORTED_MODULE_11__DonationReport_vue__["a" /* default */],
    DonationCampaignsReport: __WEBPACK_IMPORTED_MODULE_12__DonationCampaignsReport_vue__["a" /* default */],
    RaffleCampaignsReport: __WEBPACK_IMPORTED_MODULE_13__RaffleCampaignsReport_vue__["a" /* default */],
    LoyaltyStoreReport: __WEBPACK_IMPORTED_MODULE_14__LoyaltyStoreReport_vue__["a" /* default */],
    ChallengeCampaignsReport: __WEBPACK_IMPORTED_MODULE_15__ChallengeCampaignsReport_vue__["a" /* default */],
    SpinningWheelReport: __WEBPACK_IMPORTED_MODULE_16__SpinningWheelReport_vue__["a" /* default */],
    Ocr: __WEBPACK_IMPORTED_MODULE_17__Ocr_vue__["a" /* default */],
    StockMovements: __WEBPACK_IMPORTED_MODULE_18__StockMovements_vue__["a" /* default */],
    ReorderPopupResponses: __WEBPACK_IMPORTED_MODULE_19__ReorderPopupResponses_vue__["a" /* default */],
    Wallet: __WEBPACK_IMPORTED_MODULE_20__Wallet_vue__["a" /* default */],
    ReportRequest: __WEBPACK_IMPORTED_MODULE_21__ReportRequest_vue__["a" /* default */],
    SalesPaymentMethod: __WEBPACK_IMPORTED_MODULE_22__Versions_2_SalesPaymentMethod_vue__["a" /* default */],
    SalesProducts: __WEBPACK_IMPORTED_MODULE_23__Versions_2_SalesProducts_vue__["a" /* default */],
    SalesProductsTrend: __WEBPACK_IMPORTED_MODULE_24__Versions_2_SalesProductsTrend_vue__["a" /* default */],
    SalesTrend: __WEBPACK_IMPORTED_MODULE_25__Versions_2_SalesTrend_vue__["a" /* default */],
    TopProducts: __WEBPACK_IMPORTED_MODULE_26__Versions_2_TopProducts_vue__["a" /* default */],
    TopCategories: __WEBPACK_IMPORTED_MODULE_27__Versions_2_TopCategories_vue__["a" /* default */],
    OrderFrom: __WEBPACK_IMPORTED_MODULE_28__Versions_2_OrderFromReport_vue__["a" /* default */],
    ProductsAndOptionsReport: __WEBPACK_IMPORTED_MODULE_29__Versions_2_ProductsAndOptionsReport_vue__["a" /* default */],
    OperatorSales: __WEBPACK_IMPORTED_MODULE_30__Versions_2_OperatorSalesReport_vue__["a" /* default */],
    WaiterTipsReport: __WEBPACK_IMPORTED_MODULE_31__Versions_2_WaiterTipsReport_vue__["a" /* default */],
    DashboardReport: __WEBPACK_IMPORTED_MODULE_32__Versions_2_DashboardReport_vue__["a" /* default */],
    Storno: __WEBPACK_IMPORTED_MODULE_33__Versions_2_StornoReport_vue__["a" /* default */],
    MasterReport: __WEBPACK_IMPORTED_MODULE_34__Versions_2_MasterReport_vue__["a" /* default */],
    FiscalZReport: __WEBPACK_IMPORTED_MODULE_35__Versions_2_FiscalZReport_vue__["a" /* default */],
    TableOpenOrderReport: __WEBPACK_IMPORTED_MODULE_36__Versions_2_TableOpenOrderReport_vue__["a" /* default */],
    PosOrderActionsReport: __WEBPACK_IMPORTED_MODULE_37__Versions_2_PosOrderActionsReport_vue__["a" /* default */],
    CustomerLifetimeValue: __WEBPACK_IMPORTED_MODULE_38__Versions_2_CustomerLifetimeValue_vue__["a" /* default */],
    ReferralProgramReport: __WEBPACK_IMPORTED_MODULE_39__Versions_2_ReferralProgramReport_vue__["a" /* default */],
    PreordersItems: __WEBPACK_IMPORTED_MODULE_40__Versions_2_PreordersItems_vue__["a" /* default */],
    MixedReport: __WEBPACK_IMPORTED_MODULE_41__Versions_2_MixedReport_vue__["a" /* default */],
    CharismaReport: __WEBPACK_IMPORTED_MODULE_42__Versions_2_CharismaReport_vue__["a" /* default */],
    CharismaLocationReceipt: __WEBPACK_IMPORTED_MODULE_43__Versions_2_CharismaLocationReceipt_vue__["a" /* default */],
    NexusReport: __WEBPACK_IMPORTED_MODULE_44__Versions_2_NexusReport_vue__["a" /* default */],
    LabelEvolution: __WEBPACK_IMPORTED_MODULE_45__Versions_2_LabelEvolution_vue__["a" /* default */]
  },
  data: function data() {
    return {
      comapnyId: null,
      hasCharismaLocation: false,
      hasNexusLocation: false,
      selectedTab: 'Description',
      isSalesPaymentMethod: true,
      isSalesProducts: false,
      isSalesProductsTrend: false,
      isSalesTrend: false,
      isTopProducts: false,
      isTopCategories: false,
      isOrderFrom: false,
      isProductsAndOptions: false,
      isStorno: false,
      isOperatorSales: false,
      isWaiterTips: false,
      isDashboardReport: false,
      isMasterReport: false,
      isMasterReportBeta: false,
      isFiscalZReport: false,
      isCustomerLifetimeValueReport: false,
      isReferralProgramReport: false,
      isTrends: false,
      isReports: false,
      isSalesReportBeta: false,
      isClients: false,
      isProductSales: false,
      isOrderStatus: false,
      isPdfRaport: false,
      isLoyaltyPoints: false,
      isClientPoints: false,
      isDonationReport: false,
      isDonationCampaignsReport: false,
      isRaffleCampaignsReport: false,
      isLoyaltyStoreReport: false,
      isChallengeCampaignsReport: false,
      isSpinningWheelReport: false,
      isOCR: false,
      isStockMovements: false,
      isReorderPopupResponses: false,
      isWallet: false,
      isReportRequest: false,
      isCharismaReport: false,
      isCharismaLocationReceiptReport: false,
      isTableOpenOrderReport: false,
      isPosOrderActionsReport: false,
      isPreordersItems: false,
      isNexusReport: false,
      isLabelEvolution: false,
      isExportableReports: false,
      isMixedReport: false
    };
  },
  created: function created() {
    var _this = this;

    this.comapnyId = this.$session.get('selectedCompany');
    this.ensureCompanyLocationFlags(function (sessionData) {
      _this.hasCharismaLocation = !!sessionData.has_charisma_location;
      _this.hasNexusLocation = !!sessionData.has_nexus_location;
    });
    var tab = this.$route.query && this.$route.query.tab;
    if (tab === 'charisma') {
      this.selectedTab = this.$t('reports.charismaReport');
      this.isCharismaReport = true;
    } else if (tab === 'charisma-location-receipt') {
      this.selectedTab = this.$t('reports.charismaLocationReceipt');
      this.isCharismaLocationReceiptReport = true;
    } else if (tab === 'nexus') {
      this.selectedTab = this.$t('reports.nexusReport');
      this.isNexusReport = true;
    } else if (tab === 'donation-campaigns-report') {
      this.selectedTab = this.$t('reports.donationCampaignsReport');
      this.isDonationCampaignsReport = true;
    } else if (tab === 'raffle-campaigns-report') {
      this.selectedTab = this.$t('reports.raffleCampaignsReport');
      this.isRaffleCampaignsReport = true;
    } else if (tab === 'challenge-campaigns-report') {
      this.selectedTab = this.$t('reports.challengeCampaignsReport');
      this.isChallengeCampaignsReport = true;
    } else if (tab === 'spinning-wheel-report') {
      this.selectedTab = this.$t('reports.spinningWheelReport');
      this.isSpinningWheelReport = true;
    } else if (tab === 'pos-order-actions') {
      this.selectedTab = this.$t('reports.posOrderActionsReport');
      this.isPosOrderActionsReport = true;
    }
  },

  methods: {
    showReportRequests: function showReportRequests() {
      var _this2 = this;

      this.isReportRequest = true;
      this.selectedTab = this.$t('reports.reportRequestTab');
      this.$nextTick(function () {
        if (_this2.$refs.reportRequest) _this2.$refs.reportRequest.getData();
      });
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      var _this3 = this;

      this.selectedTab = newTab.title;
      switch (newTab.title) {
        case 'Export CSV':
          this.isExportableReports = true;
          break;
        case this.$t('reports.salesReport'):
          this.isReports = true;
          break;
        case this.$t('reports.salesReportBeta'):
          this.isSalesReportBeta = true;
          break;
        case this.$t('reports.clients'):
          this.isClients = true;
          break;
        case this.$t('reports.productsSalesReport'):
          this.isProductSales = true;
          break;
        case this.$t('reports.orderStatus'):
          this.isOrderStatus = true;
          break;
        case this.$t('reports.pdfRaport'):
          this.isPdfRaport = true;
          break;
        case this.$t('reports.loyaltyPoints'):
          this.isLoyaltyPoints = true;
          break;
        case this.$t('reports.isClientPoints'):
          this.isClientPoints = true;
          break;
        case this.$t('reports.donationReport'):
          this.isDonationReport = true;
          break;
        case this.$t('reports.donationCampaignsReport'):
          this.isDonationCampaignsReport = true;
          break;
        case this.$t('reports.loyaltyStoreReport'):
          this.isLoyaltyStoreReport = true;
          break;
        case this.$t('reports.challengeCampaignsReport'):
          this.isChallengeCampaignsReport = true;
          break;
        case this.$t('reports.spinningWheelReport'):
          this.isSpinningWheelReport = true;
          break;
        case this.$t('reports.ocr'):
          this.isOCR = true;
          break;
        case this.$t('reports.stockMovements'):
          this.isStockMovements = true;
          break;
        case this.$t('reports.reorderPopupResponses'):
          this.isReorderPopupResponses = true;
          break;
        case this.$t('reports.wallet'):
          this.isWallet = true;
          break;
        case this.$t('reports.reportRequestTab'):
          this.isReportRequest = true;
          this.$nextTick(function () {
            if (_this3.$refs.reportRequest) _this3.$refs.reportRequest.getData();
          });
          break;
        case this.$t('reports.charismaReport'):
          this.isCharismaReport = true;
          break;
        case this.$t('reports.charismaLocationReceipt'):
          this.isCharismaLocationReceiptReport = true;
          break;
        case this.$t('reports.nexusReport'):
          this.isNexusReport = true;
          break;
        case this.$t('reports.paymentType'):
          this.isSalesPaymentMethod = true;
          break;
        case this.$t('reports.productsSalesReport2'):
          this.isSalesProducts = true;
          break;
        case this.$t('reports.productSaleTrendsReport'):
          this.isSalesProductsTrend = true;
          break;
        case this.$t('reports.salesTrendsReport'):
          this.isSalesTrend = true;
          break;
        case this.$t('reports.topProductsReport'):
          this.isTopProducts = true;
          break;
        case this.$t('reports.topCategoriesReport'):
          this.isTopCategories = true;
          break;
        case this.$t('reports.orderFromReport'):
          this.isOrderFrom = true;
          break;
        case this.$t('reports.productsAndOptionsReport'):
          this.isProductsAndOptions = true;
          break;
        case this.$t('reports.stornoReport'):
          this.isStorno = true;
          break;
        case this.$t('reports.operatorSalesReport'):
          this.isOperatorSales = true;
          break;
        case this.$t('reports.waiterTipsReport'):
          this.isWaiterTips = true;
          break;
        case this.$t('reports.dashboardReport'):
          this.isDashboardReport = true;
          break;
        case this.$t('reports.masterReport'):
          this.isMasterReport = true;
          break;
        case this.$t('reports.masterReportBeta'):
          this.isMasterReportBeta = true;
          break;
        case this.$t('reports.fiscalZReport'):
          this.isFiscalZReport = true;
          break;
        case this.$t('reports.tableOpenOrders'):
          this.isTableOpenOrderReport = true;
          break;
        case this.$t('reports.posOrderActionsReport'):
          this.isPosOrderActionsReport = true;
          break;
        case this.$t('reports.customerLifetimeValueReport'):
          this.isCustomerLifetimeValueReport = true;
          break;
        case this.$t('reports.referralProgramReport'):
          this.isReferralProgramReport = true;
          break;
        case this.$t('reports.raffleCampaignsReport'):
          this.isRaffleCampaignsReport = true;
          break;
        case this.$t('reports.preordersItems'):
          this.isPreordersItems = true;
          break;
        case this.$t('reports.mixReport'):
          this.isMixedReport = true;
          break;
        case this.$t('reports.labelEvolution'):
          this.isLabelEvolution = true;
          break;
        default:
          this.isTrends = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ "kpVk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "krfC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalSignageAdd_vue__ = __webpack_require__("XCy2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eeea7c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalSignageAdd_vue__ = __webpack_require__("Dgnx");
function injectStyle (ssrContext) {
  __webpack_require__("IQj2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DigitalSignageAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eeea7c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DigitalSignageAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kzgQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTime_vue__ = __webpack_require__("i2PC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_205f2d78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTime_vue__ = __webpack_require__("zixD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_205f2d78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l+xS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t10_vue__ = __webpack_require__("cbEo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e38ef2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t10_vue__ = __webpack_require__("icdU");
function injectStyle (ssrContext) {
  __webpack_require__("oryI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e38ef2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t10_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e38ef2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t10_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l4iL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l8fr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons "},[_c('div',{staticClass:"left-buttons mar-rt-10"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Produs")]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Caută produsul...","filterable":"","remote":"","remote-method":_vm.fetchProducts,"loading":_vm.loadingProducts},on:{"change":_vm.handleProductSelect},model:{value:(_vm.selectedProduct),callback:function ($$v) {_vm.selectedProduct=$$v},expression:"selectedProduct"}},_vm._l((_vm.searchProdResults),function(product){return _c('el-option',{key:product._id,attrs:{"label":product.name,"value":product._id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":['date_from', 'date_to']},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"right-buttons"})]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.stockDate')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.date)?[_vm._v("\n                      "+_vm._s(_vm.formatDateTime(scope.row.date))+"\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"document_id","label":_vm.$t('gestiune.stockDocumentId')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"document_type","label":_vm.$t('gestiune.stockDocumentType')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"intrare","label":_vm.$t('gestiune.stockIntrare')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"iesire","label":_vm.$t('gestiune.stockIesire')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"stoc_final","label":_vm.$t('gestiune.stockStocFinal')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.stockPret')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.pret)?[_vm._v("\n                      "+_vm._s((scope.row.pret).toFixed(2))+"\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.stockValoareStoc')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valoare_stoc)?[_vm._v("\n                      "+_vm._s((scope.row.valoare_stoc).toFixed(2))+"\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"observatii","label":_vm.$t('gestiune.stockObservatii')}})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l8pN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"support"},[_c('div',{staticClass:"link-container"},[_c('a',{attrs:{"href":"https://helpdesk.taptasty.com/ro/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.$t('newsletterCard.helpVideoSupport')))])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('el-input',{staticClass:"icon-search",attrs:{"type":"text","placeholder":_vm.$t('newsletterCard.searchPlaceholder'),"clearable":""},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1)]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"video-grid"},_vm._l((_vm.displayedVideos),function(video){return _c('VideoSupportCard',{key:video.key,attrs:{"src":video.src,"title":video.title}})})),_vm._v(" "),(_vm.filteredVideos.length === 0)?_c('div',{staticClass:"no-results-message"},[_vm._v("\n        "+_vm._s(_vm.$t('newsletterCard.noResultsMessage'))+"\n      ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-pagination',{staticClass:"active-pagination",attrs:{"current-page":_vm.pagination.currentPage,"page-size":_vm.pagination.pageSize,"total":_vm.filteredVideos.length,"layout":"prev, pager, next"},on:{"update:currentPage":function($event){_vm.$set(_vm.pagination, "currentPage", $event)},"current-change":_vm.handlePageChange}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l9QA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row categories"},[_c('div',{staticClass:"col-lg-12 col-md-10 col-sm-12 "},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-right",staticStyle:{"position":"relative","z-index":"2"}},[_c('router-link',{staticClass:"btn btn-info btn-icon mar-bt-20 add",attrs:{"title":"","to":{ path: 'top-categories/add'}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])],1)]),_vm._v(" "),_c('table',{ref:"sortableTable",staticClass:"table width-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.$t('general.sortOrder')))]),_vm._v(" "),_c('th',{attrs:{"width":"30%"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.image')))]),_vm._v(" "),_c('th',{attrs:{"width":"40%"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.name')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}}),_vm._v(" "),_c('th',{attrs:{"width":"10%"}})])]),_vm._v(" "),_vm._l((_vm.tableData),function(item,index){return [_c('tr',{staticClass:"sortableRow"},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.sort_order),expression:"item.sort_order"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":_vm.$t('general.sortOrder'),"step":"1"},domProps:{"value":(item.sort_order)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "sort_order", $event.target.value)},function($event){_vm.onSortOrderInput(item)}],"keypress":function($event){_vm.onlyDigits($event)},"click":function($event){_vm.selectInputText($event)}}})]),_vm._v(" "),_c('td',[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"image-table"},[_c('img',{attrs:{"src":(item.image)?item.image : ''}})])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(item)}},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}})]],2),_vm._v(" "),_c('td',[_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(item,[],[], $event)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                    ")])])])]})],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l9bJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l9ed":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lFKZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GroupOptionsForm_vue__ = __webpack_require__("BgVy");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ElementForm', __WEBPACK_IMPORTED_MODULE_7__GroupOptionsForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      elementModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.elementModel = model;
    }
  }
});

/***/ }),

/***/ "lFUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  },
  data: function data() {
    var end = new Date();
    var start = new Date();
    start.setDate(end.getDate() - 29);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    return {
      loading: false,
      tableData: [],
      totalItems: 0,
      totalValue: 0,
      selectedGestiune: null,
      selectedLocation: null,
      searchDate: [start, end],
      selectedConsumptionSource: 'all',
      selectedProduct: {},
      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            var end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      }
    };
  },

  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id;
      });
      return result;
    }
  },
  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.resetTable();

      this.selectedGestiune = null;
      this.tableData = [];
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    this.firstLoad();
  },

  methods: {
    firstLoad: function firstLoad() {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0];
      }
    },
    triggerFilter: function triggerFilter() {
      if (!this.selectedGestiune) {
        return;
      }
      if (!this.selectedLocation) {
        return;
      }
      if (!this.searchDate || this.searchDate.length !== 2) {
        return;
      }

      this.resetTable();
      this.fetchConsumptionReport();
    },
    openViewConsumption: function openViewConsumption(row) {
      this.selectedProduct = row;
      this.$modal.show('consumptionModal');
    },
    closeConsumptionModal: function closeConsumptionModal() {
      this.$modal.hide('consumptionModal');
    },
    getConsumptionSummary: function getConsumptionSummary(_ref2) {
      var _this2 = this;

      var columns = _ref2.columns;

      var summary = [];

      columns.forEach(function (column, index) {
        if (index === 0) {
          summary[index] = 'TOTAL (' + _this2.totalItems + ' produse)';
          return;
        }

        if (column.property === 'value') {
          summary[index] = Number(_this2.totalValue).toFixed(2) + ' lei';
          return;
        }

        summary[index] = '';
      });

      return summary;
    },
    fetchConsumptionReport: function fetchConsumptionReport() {
      var _this3 = this;

      var exportFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _searchDate, startDate, endDate, externalCompanyId, params, url, response, data, grouped;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this3.selectedGestiune || !_this3.selectedLocation || !_this3.searchDate)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                _this3.loading = true;

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  type: 'info',
                  title: 'Se generează raportul de consum',
                  text: 'Vă rugăm așteptați...',
                  allowOutsideClick: false,
                  didOpen: function didOpen() {
                    return __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.showLoading();
                  }
                });

                _context.prev = 4;
                _searchDate = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_this3.searchDate, 2), startDate = _searchDate[0], endDate = _searchDate[1];
                externalCompanyId = _this3.$session.get('selectedCompany');
                params = new URLSearchParams({
                  externalCompanyId: externalCompanyId,
                  gestiune: _this3.selectedGestiune,
                  startDate: new Date(startDate),
                  endDate: new Date(endDate),
                  vatNumber: _this3.selectedLocation.inv_fiscal_code,
                  externalLocationId: _this3.selectedLocation.true_id,
                  consumptionSource: _this3.selectedConsumptionSource
                });


                if (exportFormat) {
                  params.append('export', exportFormat.toUpperCase());
                }

                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/reports/consumption?' + params.toString();
                _context.next = 12;
                return fetch(url);

              case 12:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 15;
                  break;
                }

                throw new Error('HTTP ' + response.status);

              case 15:
                if (!exportFormat) {
                  _context.next = 19;
                  break;
                }

                window.location.href = url;

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.close();
                }, 800);

                return _context.abrupt('return');

              case 19:
                _context.next = 21;
                return response.json();

              case 21:
                data = _context.sent;


                if (Array.isArray(data.items)) {
                  grouped = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(data.items.reduce(function (acc, item) {
                    var key = item.productId;

                    if (!acc[key]) {
                      acc[key] = {
                        productId: item.productId,
                        name: item.name,
                        unit: item.unit,
                        quantity: 0,
                        value: 0,
                        consumptionDocuments: [],
                        lineCount: 0
                      };
                    }

                    acc[key].quantity += Number(item.quantity) || 0;
                    acc[key].value += Number(item.value) || 0;
                    acc[key].consumptionDocuments.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item));
                    acc[key].lineCount++;

                    return acc;
                  }, {}));


                  grouped.forEach(function (item) {
                    item.price = item.lineCount === 1 ? item.consumptionDocuments[0].price : null;

                    delete item.lineCount;
                  });

                  _this3.tableData = grouped;
                } else {
                  _this3.tableData = [];
                }

                _this3.totalItems = data.totalItems || 0;
                _this3.totalValue = data.totalValue || 0;
                _context.next = 32;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context['catch'](4);

                console.error('Eroare raport consum:', _context.t0);
                _this3.tableData = [];

                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Nu s-a putut genera raportul de consum.',
                  icon: 'error'
                });

              case 32:
                _context.prev = 32;

                _this3.loading = false;
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.close();
                return _context.finish(32);

              case 36:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[4, 27, 32, 36]]);
      }))();
    },
    resetTable: function resetTable() {
      this.tableData = [];
    }
  }
});

/***/ }),

/***/ "lJ5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosUserAdd_vue__ = __webpack_require__("JovD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793552e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosUserAdd_vue__ = __webpack_require__("XviY");
function injectStyle (ssrContext) {
  __webpack_require__("malN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosUserAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_793552e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosUserAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lKSC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__ = __webpack_require__("Ark/");











/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */],
    SearchableMultiSelect: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a),
  props: {
    isProductsAndOptions: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isProductsAndOptions: function isProductsAndOptions() {
      if (this.isProductsAndOptions) {
        this.getOrders();
        this.verifyUserLocations();
        this.verifyUserMethods();
      }
    }
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      selectedCategories: [],
      selectedTopCategories: [],
      ordersTableData: {},
      productTotals: {
        quantity: 0,
        vat: 0,
        net_value: 0,
        total: 0
      },
      optionTotals: {
        quantity: 0,
        vat: 0,
        net_value: 0,
        total: 0
      },
      grandTotals: {
        quantity: 0,
        vat: 0,
        net_value: 0,
        total: 0
      },
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_5_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(12, 'months').startOf('day');
        }
      }
    };
  },

  methods: {
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        console.log(allowedLocations);
        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this = this;

      if (!this.isProductsAndOptions) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;

      this.apiRequest('/reports/v2/products-and-options' + '?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          if (response.data.table_data && response.data.table_data.length) {
            _this.ordersTableData.data = response.data.table_data;
            _this.ordersTableData.total = response.pagination ? response.pagination.total : response.data.table_data.length;
            _this.paginationProps.currentPage = response.pagination ? response.pagination.page : page;
            _this.paginationProps.pageSize = response.pagination ? response.pagination.perPage : pageSize;

            if (response.data.totals) {
              if (response.data.totals.products) {
                _this.productTotals = {
                  quantity: response.data.totals.products.quantity || 0,
                  vat: response.data.totals.products.vat || 0,
                  net_value: response.data.totals.products.net_value || response.data.totals.products.net_total || 0,
                  total: response.data.totals.products.total || 0
                };
              }
              if (response.data.totals.options) {
                _this.optionTotals = {
                  quantity: response.data.totals.options.quantity || 0,
                  vat: response.data.totals.options.vat || 0,
                  net_value: response.data.totals.options.net_value || response.data.totals.options.net_total || 0,
                  total: response.data.totals.options.total || 0
                };
              }
              if (response.data.totals.general) {
                _this.grandTotals = {
                  quantity: response.data.totals.general.quantity || 0,
                  vat: response.data.totals.general.vat || 0,
                  net_value: response.data.totals.general.net_value || response.data.totals.general.net_total || 0,
                  total: response.data.totals.general.total || 0
                };
              }
            }
          } else {
            _this.ordersTableData.data = [];
            _this.ordersTableData.total = 0;
            _this.paginationProps.currentPage = 1;
            _this.paginationProps.pageSize = 20;
            _this.productTotals = {
              quantity: 0,
              vat: 0,
              net_value: 0,
              total: 0
            };
            _this.optionTotals = {
              quantity: 0,
              vat: 0,
              net_value: 0,
              total: 0
            };
            _this.grandTotals = {
              quantity: 0,
              vat: 0,
              net_value: 0,
              total: 0
            };
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    exportData: function exportData() {
      var _this2 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/products-and-options-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
        }
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "lLZK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lNIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ProductForm_vue__ = __webpack_require__("jkt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2_dist_sweetalert2_css__);
























function normalizeFilterValue(value) {
  if (!Array.isArray(value)) return [];
  return value.map(function (v) {
    return (typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof___default()(v)) === 'object' && v !== null ? v.id : v;
  });
}

function createEmptyBulkOverrideInterval(deliveryMethod) {
  return {
    active: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
    delivery_method: deliveryMethod,
    available_from: '',
    available_to: ''
  };
}

__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_time_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__["a" /* default */],
    ProductForm: __WEBPACK_IMPORTED_MODULE_17__ProductForm_vue__["a" /* default */]
  },
  computed: {
    affectedProductCount: function affectedProductCount() {
      if (this.selectAllMatching) {
        return Math.max(0, (this.paginationDef.totalRecords || 0) - this.exceptionProductIds.length);
      }
      return this.selectedProductIds.length;
    },
    headerCheckboxChecked: function headerCheckboxChecked() {
      return this.selectAllMatching && this.exceptionProductIds.length === 0;
    },
    headerCheckboxIndeterminate: function headerCheckboxIndeterminate() {
      if (this.selectAllMatching) {
        return this.exceptionProductIds.length > 0 && this.affectedProductCount > 0;
      }
      return this.selectedProductIds.length > 0;
    },
    bulkModeOptions: function bulkModeOptions() {
      return [{ id: 'add', label: this.$t('catalogProd.bulkModeAdd') }, { id: 'remove', label: this.$t('catalogProd.bulkModeRemove') }];
    },
    massActionOptions: function massActionOptions() {
      return [{ id: 'locations', label: this.$t('catalogProd.changeLocations') }, { id: 'set_active', label: this.$t('catalogProd.bulkActionActive') }, { id: 'adjust_price', label: this.$t('catalogProd.bulkActionPrice') }, { id: 'set_vat', label: this.$t('catalogProd.bulkActionVat') }, { id: 'set_section', label: this.$t('catalogProd.bulkActionSection') }, { id: 'set_override_delivery', label: this.$t('catalogProd.overrideSettings') }, { id: 'option_groups', label: this.$t('catalogProd.bulkActionOptionGroups') }, { id: 'delete', label: this.$t('catalogProd.bulkActionDelete') }];
    },
    vatSelectOptions: function vatSelectOptions() {
      var bestByKey = {};(this.vatOptionsList || []).forEach(function (vat) {
        var taxName = vat.tax && vat.tax.name ? vat.tax.name : '';
        var key = String(vat.amount) + '|' + String(vat.tax_id || taxName);
        var isCompanyLevel = !vat.location_id && !vat.location_token;
        if (!bestByKey[key] || isCompanyLevel) {
          bestByKey[key] = {
            id: vat.id,
            label: taxName ? vat.amount + ' - ' + taxName : '' + vat.amount
          };
        }
      });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(bestByKey).map(function (k) {
        return bestByKey[k];
      });
    },
    priceDirectionOptions: function priceDirectionOptions() {
      return [{ id: 'increase', label: this.$t('catalogProd.bulkPriceIncrease') }, { id: 'decrease', label: this.$t('catalogProd.bulkPriceDecrease') }];
    },
    priceModeOptions: function priceModeOptions() {
      return [{ id: 'flat', label: this.$t('catalogProd.bulkPriceFlat') }, { id: 'percent', label: this.$t('catalogProd.bulkPricePercent') }];
    },
    optionGroupsModeOptions: function optionGroupsModeOptions() {
      return [{ id: 'add', label: this.$t('catalogProd.bulkModeAdd') }, { id: 'replace', label: this.$t('catalogProd.bulkModeReplace') }];
    },
    hasQueuedDelete: function hasQueuedDelete() {
      return !!this.bulkDeleteEnabled;
    },
    queuedMassActions: function queuedMassActions() {
      var _this = this;

      if (this.affectedProductCount <= 0) return [];

      if (this.bulkDeleteEnabled) {
        return [{ action: 'delete' }];
      }

      var queued = [];
      var order = ['set_active', 'adjust_price', 'set_vat', 'set_section', 'set_override_delivery', 'option_groups', 'locations'];

      var builders = {
        set_active: function set_active() {
          if (!_this.bulkActiveTouched) return null;
          if (_this.bulkActiveValue !== 0 && _this.bulkActiveValue !== 1) return null;
          return { action: 'set_active', active: _this.bulkActiveValue ? 1 : 0 };
        },
        adjust_price: function adjust_price() {
          if (_this.bulkPriceAmount === null || _this.bulkPriceAmount === '' || isNaN(_this.bulkPriceAmount) || Number(_this.bulkPriceAmount) < 0) {
            return null;
          }
          return {
            action: 'adjust_price',
            direction: _this.getBulkPriceDirectionId(),
            price_mode: _this.getBulkPriceModeId(),
            amount: Number(_this.bulkPriceAmount)
          };
        },
        set_vat: function set_vat() {
          var vatId = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof___default()(_this.bulkVatId) === 'object' && _this.bulkVatId !== null ? _this.bulkVatId.id : _this.bulkVatId;
          if (!vatId) return null;
          return { action: 'set_vat', vat_id: vatId };
        },
        set_section: function set_section() {
          var sectionId = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof___default()(_this.bulkSectionId) === 'object' && _this.bulkSectionId !== null ? _this.bulkSectionId.id : _this.bulkSectionId;
          if (!sectionId) return null;
          return { action: 'set_section', kds_section_id: sectionId };
        },
        set_override_delivery: function set_override_delivery() {
          if (!_this.bulkOverrideDeliveryTouched) return null;
          if (_this.bulkOverrideDeliveryValue !== 0 && _this.bulkOverrideDeliveryValue !== 1) return null;
          var payload = {
            action: 'set_override_delivery',
            override_delivery: _this.bulkOverrideDeliveryValue ? 1 : 0
          };
          if (_this.bulkOverrideDeliveryValue === 1) {
            var overrideSettings = _this.buildBulkOverrideSettings();
            if (!overrideSettings || !overrideSettings.length) return null;
            payload.override_settings = overrideSettings;
          }
          return payload;
        },
        option_groups: function option_groups() {
          var ids = (_this.bulkGroupOptionIds || []).map(function (id) {
            return (typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof___default()(id)) === 'object' && id !== null ? id.id : id;
          }).filter(Boolean);
          if (!ids.length) return null;
          return {
            action: 'option_groups',
            group_option_ids: ids,
            mode: _this.getBulkOptionGroupsModeId()
          };
        },
        locations: function locations() {
          var locationTokens = (_this.bulkLocationTokens || []).map(function (token) {
            return (typeof token === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof___default()(token)) === 'object' && token !== null ? token.token : token;
          }).filter(Boolean);
          if (!locationTokens.length) return null;
          return {
            action: 'locations',
            mode: _this.getBulkLocationModeId(),
            location_tokens: locationTokens,
            include_all_locations: _this.bulkIncludeAllLocations ? 1 : 0
          };
        }
      };

      order.forEach(function (key) {
        var item = builders[key]();
        if (item) queued.push(item);
      });
      return queued;
    },
    massConfirmEnabled: function massConfirmEnabled() {
      return this.queuedMassActions.length > 0;
    },
    bulkOverrideMethodKeys: function bulkOverrideMethodKeys() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.bulkOverrideDeliveryMap || {});
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      type: '',
      loaded: false,
      loading: true,
      pagerCount: 5,
      paginationDef: {
        page: null,
        totalPages: null,
        totalRecords: null,
        show: true
      },
      onInputGetProductsTimeout: null,
      search: '',
      searchId: '',
      propsToSearch: ['name', 'price', 'status'],
      tableColumns: [],
      tableData: [],
      categoryIds: [],
      groupedProducts: [],
      mainCategories: [],
      topCategories: [],
      productOptions: [],
      companyProductFilters: [],
      taxes: [],
      editedRowId: null,
      windowHeight: 0,
      tableTopHeight: 70,
      tableBottomHeight: 63,
      prodTopBarHeight: 70,
      pageTopHeight: 0,
      currency: this.$session.get('selectedCompanyData')['currency_iso'],
      showLocations: false,
      showStatus: true,
      locations: [],
      kdsSections: [],
      productFilters: [],
      measurementsUnits: [],
      language: null,
      languages: [],
      showProductFilters: false,
      locationFilter: [],
      allowedOnProductLocation: true,
      selectAllMatching: false,
      selectedProductIds: [],
      exceptionProductIds: [],
      showMassUpdateModal: false,
      massAction: 'locations',
      bulkLocationTokens: [],
      bulkLocationMode: 'add',
      bulkIncludeAllLocations: false,
      bulkActiveValue: null,
      bulkPriceDirection: 'increase',
      bulkPriceMode: 'flat',
      bulkPriceAmount: null,
      bulkGroupOptionIds: [],
      bulkOptionGroupsMode: 'add',
      bulkVatId: null,
      bulkSectionId: null,
      bulkOverrideDeliveryValue: null,
      bulkOverrideDeliveryTouched: false,
      bulkOverrideLocationTokens: [],
      bulkOverrideDeliveryMap: {},
      bulkOverridePickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      bulkActiveTouched: false,
      bulkDeleteEnabled: false,
      groupOptionsList: [],
      vatOptionsList: [],
      bulkUpdating: false,
      modelValidations: {
        price: {
          required: true,
          min_value: 0,
          max_value: 999999.99
        }
      },
      filters: [{
        value: '',
        prop: ['name', 'price']
      }, {
        value: [],
        prop: ['category'],
        filterFn: function filterFn(row, filter) {
          _this2.$nextTick(function () {
            _this2.tableTopHeight = _this2.$refs.tableTop.clientHeight;
          });
          return _this2.isInObject(row['category_id'], filter.value);
        }
      }, {
        value: [],
        prop: ['location_ids'],
        filterFn: function filterFn(row, filter) {
          _this2.$nextTick(function () {
            _this2.tableTopHeight = _this2.$refs.tableTop.clientHeight;
          });
          if (row['location_ids'] === null) {
            return 1;
          } else if (!row['location_ids'].length) {
            return 1;
          } else {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(row['location_ids']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var locId = _step.value;

                if (filter.value.indexOf(locId) !== -1) {
                  return 1;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          return 0;
        }
      }, {
        name: 'status',
        value: [],
        filterFn: function filterFn(row, filter) {
          if (filter.value[0] && filter.value[1]) {
            return true;
          }
          if (filter.value[0] === 'active') {
            if (row['active'] === 1) {
              return true;
            } else {
              return false;
            }
          } else {
            if (row['active'] === 0) {
              return true;
            } else {
              return false;
            }
          }
        }
      }, {
        name: 'specialPrice',
        value: [],
        filterFn: function filterFn(row, filter) {
          if (!filter.value || !filter.value.length) {
            return true;
          }

          if (filter.value.includes('discounted') && row['is_discounted']) {
            return true;
          }

          if (filter.value.includes('notDiscounted') && !row['is_discounted']) {
            return true;
          }

          return false;
        }
      }, {
        value: [],
        prop: ['top_category'],
        filterFn: function filterFn(row, filter) {
          _this2.$nextTick(function () {
            _this2.tableTopHeight = _this2.$refs.tableTop.clientHeight;
          });

          return _this2.categoryIds.includes(row['id']);
        }
      }, {
        name: 'override_delivery_method',
        value: [],
        prop: ['override_delivery_method']
      }]
    };
  },
  created: function created() {
    this.initializePage();

    this.$bus.$on('refresh', this.handleRefresh);
    this.$bus.$on('updateProductInList', this.updateList);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
    this.$bus.$off('updateProductInList', this.updateList);
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.doHeightCalculation();

      window.addEventListener('resize', function () {
        _this3.doHeightCalculation();
      });
    });
  },

  methods: {
    handleRefresh: function handleRefresh(editedId) {
      this.initializePage();

      if (editedId) {
        this.editedRowId = editedId;
      }
    },
    setLocations: function setLocations(locations) {
      this.locations = Array.isArray(locations) ? locations : [];
      if (!this.isOwner()) {
        var allowedLocations = void 0;
        try {
          allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        } catch (error) {
          allowedLocations = null;
        }
        this.locations = this.locations.filter(function (location) {
          return Array.isArray(allowedLocations) && (allowedLocations.length === 0 || allowedLocations.includes(location.id));
        });
      }
      this.showLocations = this.locations.length > 0;
    },
    initializePage: function initializePage() {
      var _this4 = this;

      var self = this;
      this.$bus.$on('doReloadProdEdit', this.doReloadProdEdit);
      this.setLocations((this.$session.get('selectedCompanyData') || {}).locations_details);


      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        inactive: 1
      };
      this.getProducts(data);
      this.currency = this.getCurrencySymbol(this.currency);
      this.apiRequest('/location/taxes', 'GET', data, function (response) {
        if (response.status === true) {
          self.taxes = response.data;
        }
      });

      this.apiRequest('/measurements-units', 'GET', data, function (response) {
        if (response.status) {
          _this4.measurementsUnits = response.data;
        }
      });

      this.apiRequest('/company-data', 'GET', data, function (response) {
        if (response.status) {
          _this4.languages = response.data.company.languages;
          _this4.language = response.data.company.language;
        }
      });

      this.apiRequest('/sections', 'GET', data, function (response) {
        if (response.status) {
          _this4.kdsSections = response.data;
        }
      });

      this.apiRequest('/settings/general/' + data['company_id'], 'GET', data, function (response) {
        if (response.status === true) {
          self.productOptions = response.data[0].products_options;
          if (Array.isArray(response.data[0].locations_details)) {
            self.setLocations(response.data[0].locations_details);
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', self.$t('catalogProd.couldNotFetchProductOptions'), 'error');
        }
      });

      this.apiRequest('/category', 'GET', data, function (response) {
        if (response.status === true) {
          self.mainCategories = response.data;
        }
      });
      this.apiRequest('/topcategory', 'GET', data, function (response) {
        if (response.status === true) {
          self.topCategories = response.data;
        }
      });
      data.from_product = 1;
      this.apiRequest('/filter', 'GET', data, function (response) {
        if (response.status === true) {
          self.companyProductFilters = response.data;
        }
      });
      window.removeEventListener('hashchange', this.dataEvent);
      window.addEventListener('hashchange', this.dataEvent);
    },
    dataEvent: function dataEvent() {
      if (this.$refs.prodForm) {
        this.$refs.prodForm.getData();
      }
    },
    onRowClick: function onRowClick(row, column, event) {
      if (event.target.tagName.toLowerCase() === 'button' || event.target.tagName.toLowerCase() === 'input' || event.target.closest('.el-switch') || event.target.closest('.product-select-checkbox')) {
        return;
      }

      if (column && (column.className || '').indexOf('selection-column') !== -1) {
        this.toggleProductSelection(row.id);
        return;
      }
      this.goToRecord(row, null, event);
    },
    showForm: function showForm() {
      if (this.$route.path.indexOf('edit') !== -1 || this.$route.path.indexOf('add') !== -1) {
        return true;
      } else {
        return false;
      }
    },
    isNew: function isNew() {
      if (this.$route.params.id && this.$route.params.id !== 'add') {
        this.type = this.$t('general.edit');
        return false;
      } else {
        this.type = this.$t('general.add');
        return true;
      }
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
      this.tableTopHeight = this.$refs.tableTop && this.$refs.tableTop.clientHeight ? this.$refs.tableTop.clientHeight : 0;
      this.tableBottomHeight = this.$refs.tableBottom && this.$refs.tableBottom.clientHeight ? this.$refs.tableBottom.clientHeight : 0;
      this.prodTopBarHeight = this.$refs.prodTopBar ? this.$refs.prodTopBar.clientHeight + 1 : 0;
      if (window.innerWidth < 1200) {
        this.pageTopHeight = 75;
      } else {
        this.pageTopHeight = 0;
      }
    },
    filterChanges: function filterChanges(data) {
      this.doHeightCalculation();
    },
    updateCookie: function updateCookie() {
      this.doHeightCalculation();
    },
    goToAdd: function goToAdd() {
      var _this5 = this;

      this.$router.push({
        name: 'Add Product',
        params: {
          productData: {},
          mainCategories: this.mainCategories,
          taxes: this.taxes,
          kdsSections: this.kdsSections,
          productOptions: this.productOptions,
          companyProductFilters: this.companyProductFilters,
          measurementsUnits: this.measurementsUnits,
          language: this.language,
          languages: this.languages
        }
      });

      this.$nextTick(function () {
        if (_this5.$refs.prodForm) {
          _this5.$refs.prodForm.getData();
          _this5.$refs.prodForm.getTrees();
        }
      });

      this.allowedOnProductLocation = true;
      this.doHeightCalculation();
    },
    applyFilters: function applyFilters() {
      this.clearProductSelection();
      this.onInput();
    },
    clearProductSelection: function clearProductSelection() {
      this.selectAllMatching = false;
      this.selectedProductIds = [];
      this.exceptionProductIds = [];
    },
    isProductSelected: function isProductSelected(id) {
      if (this.selectAllMatching) {
        return this.exceptionProductIds.indexOf(id) === -1;
      }
      return this.selectedProductIds.indexOf(id) !== -1;
    },
    toggleSelectAll: function toggleSelectAll() {
      if (this.selectAllMatching && this.exceptionProductIds.length === 0) {
        this.clearProductSelection();
        return;
      }
      this.selectAllMatching = true;
      this.selectedProductIds = [];
      this.exceptionProductIds = [];
    },
    toggleProductSelection: function toggleProductSelection(id) {
      if (this.selectAllMatching) {
        var _idx = this.exceptionProductIds.indexOf(id);
        if (_idx === -1) {
          this.exceptionProductIds.push(id);
        } else {
          this.exceptionProductIds.splice(_idx, 1);
        }
        return;
      }
      var idx = this.selectedProductIds.indexOf(id);
      if (idx === -1) {
        this.selectedProductIds.push(id);
      } else {
        this.selectedProductIds.splice(idx, 1);
      }
    },
    openMassUpdateModal: function openMassUpdateModal() {
      if (this.affectedProductCount <= 0) return;
      this.massAction = 'locations';
      this.bulkLocationTokens = [];
      this.bulkLocationMode = 'add';
      this.bulkIncludeAllLocations = false;
      this.bulkActiveValue = null;
      this.bulkActiveTouched = false;
      this.bulkPriceDirection = 'increase';
      this.bulkPriceMode = 'flat';
      this.bulkPriceAmount = null;
      this.bulkGroupOptionIds = [];
      this.bulkOptionGroupsMode = 'add';
      this.bulkVatId = null;
      this.bulkSectionId = null;
      this.bulkOverrideDeliveryValue = null;
      this.bulkOverrideDeliveryTouched = false;
      this.bulkOverrideLocationTokens = [];
      this.bulkOverrideDeliveryMap = this.createBulkOverrideDeliveryMap();
      this.bulkDeleteEnabled = false;
      this.showMassUpdateModal = true;
      this.loadGroupOptionsForBulk();
      this.loadVatOptionsForBulk();
    },
    closeMassUpdateModal: function closeMassUpdateModal() {
      if (this.bulkUpdating) return;
      this.showMassUpdateModal = false;
      this.bulkLocationTokens = [];
      this.bulkLocationMode = 'add';
      this.bulkIncludeAllLocations = false;
      this.bulkGroupOptionIds = [];
      this.bulkPriceAmount = null;
      this.bulkVatId = null;
      this.bulkSectionId = null;
      this.bulkOverrideDeliveryValue = null;
      this.bulkOverrideDeliveryTouched = false;
      this.bulkOverrideLocationTokens = [];
      this.bulkOverrideDeliveryMap = {};
      this.bulkActiveValue = null;
      this.bulkActiveTouched = false;
      this.bulkDeleteEnabled = false;
    },
    isMassActionQueued: function isMassActionQueued(actionId) {
      return this.queuedMassActions.some(function (item) {
        return item.action === actionId;
      });
    },
    onBulkActiveChange: function onBulkActiveChange(value) {
      if (value === 0 || value === 1) {
        this.bulkActiveTouched = true;
      } else {
        this.bulkActiveTouched = false;
        this.bulkActiveValue = null;
      }
    },
    onBulkOverrideDeliveryToggle: function onBulkOverrideDeliveryToggle(value) {
      var enabled = value === 1 || value === true;
      this.bulkOverrideDeliveryTouched = true;
      this.bulkOverrideDeliveryValue = enabled ? 1 : 0;
      if (enabled && !__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.bulkOverrideDeliveryMap || {}).length) {
        this.bulkOverrideDeliveryMap = this.createBulkOverrideDeliveryMap();
      }
    },
    getCompanyDeliveryMethodKeys: function getCompanyDeliveryMethodKeys() {
      var methods = [];
      var pushMethod = function pushMethod(method) {
        if (!method) return;
        var key = String(method).toLowerCase();
        if (methods.indexOf(key) === -1) {
          methods.push(key);
        }
      };

      var allTypes = (this.$session.get('defaultData') || {}).delivery_types || {};
      if (Array.isArray(allTypes)) {
        allTypes.forEach(function (type) {
          pushMethod(typeof type === 'string' ? type : type && (type.key || type.type));
        });
      } else if (allTypes && (typeof allTypes === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof___default()(allTypes)) === 'object') {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(allTypes).forEach(pushMethod);
      }

      ;(this.locations || []).forEach(function (loc) {
        var ordering = loc && loc.ordering_management;
        if (!Array.isArray(ordering)) return;
        ordering.forEach(function (entry) {
          pushMethod(entry && (entry.type || entry.delivery_method || entry.key));
        });
      });

      if (!methods.length) {
        return ['pick_up', 'delivery', 'eat_in'];
      }
      return methods;
    },
    createBulkOverrideDeliveryMap: function createBulkOverrideDeliveryMap() {
      var map = {};
      this.getCompanyDeliveryMethodKeys().forEach(function (method) {
        map[method] = [];
      });
      return map;
    },
    addBulkOverrideInterval: function addBulkOverrideInterval(methodKey) {
      if (!this.bulkOverrideDeliveryMap[methodKey]) {
        __WEBPACK_IMPORTED_MODULE_14_vue___default.a.set(this.bulkOverrideDeliveryMap, methodKey, []);
      }
      var interval = createEmptyBulkOverrideInterval(methodKey);
      interval.active = true;
      this.bulkOverrideDeliveryMap[methodKey].push(interval);
    },
    removeBulkOverrideInterval: function removeBulkOverrideInterval(methodKey, intervalIndex) {
      if (!this.bulkOverrideDeliveryMap[methodKey]) return;
      this.bulkOverrideDeliveryMap[methodKey].splice(intervalIndex, 1);
    },
    buildBulkOverrideSettings: function buildBulkOverrideSettings() {
      var _this6 = this;

      var delivery = {};
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.bulkOverrideDeliveryMap || {}).forEach(function (methodKey) {
        var intervals = (_this6.bulkOverrideDeliveryMap[methodKey] || []).filter(function (interval) {
          if (!interval || !interval.active) return false;
          return !!(interval.monday || interval.tuesday || interval.wednesday || interval.thursday || interval.friday || interval.saturday || interval.sunday);
        }).map(function (interval) {
          return {
            active: true,
            monday: !!interval.monday,
            tuesday: !!interval.tuesday,
            wednesday: !!interval.wednesday,
            thursday: !!interval.thursday,
            friday: !!interval.friday,
            saturday: !!interval.saturday,
            sunday: !!interval.sunday,
            delivery_method: methodKey,
            available_from: interval.available_from || '00:00',
            available_to: interval.available_to || '23:59'
          };
        });
        if (intervals.length) {
          delivery[methodKey] = intervals;
        }
      });
      if (!__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(delivery).length) return [];

      var locationTokens = (this.bulkOverrideLocationTokens || []).slice();
      if (!locationTokens.length) {
        locationTokens = (this.locations || []).map(function (loc) {
          return loc.token || loc.id;
        }).filter(Boolean);
      }
      if (!locationTokens.length) return [];

      return locationTokens.map(function (token) {
        return {
          loc_id: token,
          version: 2,
          delivery: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(delivery))
        };
      });
    },
    loadGroupOptionsForBulk: function loadGroupOptionsForBulk() {
      var _this7 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/group-options', 'GET', data, function (response) {
        if (response.status === true) {
          _this7.groupOptionsList = response.data || [];
        }
      });
    },
    loadVatOptionsForBulk: function loadVatOptionsForBulk() {
      var _this8 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/location/vat', 'GET', data, function (response) {
        if (response.status === true) {
          _this8.vatOptionsList = response.data || [];
        }
      });
    },
    getBulkLocationModeId: function getBulkLocationModeId() {
      if (!this.bulkLocationMode) return 'add';
      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof___default()(this.bulkLocationMode) === 'object' ? this.bulkLocationMode.id : this.bulkLocationMode;
    },
    getBulkOptionGroupsModeId: function getBulkOptionGroupsModeId() {
      if (!this.bulkOptionGroupsMode) return 'add';
      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof___default()(this.bulkOptionGroupsMode) === 'object' ? this.bulkOptionGroupsMode.id : this.bulkOptionGroupsMode;
    },
    getBulkPriceDirectionId: function getBulkPriceDirectionId() {
      if (!this.bulkPriceDirection) return 'increase';
      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof___default()(this.bulkPriceDirection) === 'object' ? this.bulkPriceDirection.id : this.bulkPriceDirection;
    },
    getBulkPriceModeId: function getBulkPriceModeId() {
      if (!this.bulkPriceMode) return 'flat';
      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_typeof___default()(this.bulkPriceMode) === 'object' ? this.bulkPriceMode.id : this.bulkPriceMode;
    },
    buildSidemenuFilterPayload: function buildSidemenuFilterPayload() {
      var data = {
        search: this.search,
        id: this.searchId,
        category: normalizeFilterValue(this.filters[1].value),
        status: normalizeFilterValue(this.filters[3].value),
        specialPrice: normalizeFilterValue(this.filters[4].value),
        top_category: normalizeFilterValue(this.filters[5].value),
        override_delivery_method: normalizeFilterValue(this.filters[6].value)
      };
      var normalizedLocations = normalizeFilterValue(this.filters[2].value).filter(function (v) {
        return v !== '' && v !== null && v !== undefined;
      });
      if (normalizedLocations.length > 0) {
        data.location_ids = normalizedLocations;
      }
      return data;
    },
    getConfirmLineForAction: function getConfirmLineForAction(item, count) {
      var productsLabel = count === 1 ? this.$t('catalogProd.bulkProductSingular') : this.$t('catalogProd.bulkProductPlural');
      var action = item.action;

      if (action === 'locations') {
        var names = this.resolveLocationNames(item.location_tokens);
        return item.mode === 'remove' ? this.$t('catalogProd.bulkSummaryRemoveLocations', { count: count, products: productsLabel, value: names }) : this.$t('catalogProd.bulkSummaryAddLocations', { count: count, products: productsLabel, value: names });
      }
      if (action === 'set_active') {
        return item.active ? this.$t('catalogProd.bulkSummarySetActive', { count: count, products: productsLabel }) : this.$t('catalogProd.bulkSummarySetInactive', { count: count, products: productsLabel });
      }
      if (action === 'adjust_price') {
        var direction = item.direction;
        var mode = item.price_mode;
        var amount = item.amount;
        var currency = this.currency || '';
        if (direction === 'increase' && mode === 'flat') {
          return this.$t('catalogProd.bulkSummaryIncreasePriceFlat', { count: count, products: productsLabel, amount: amount, currency: currency });
        }
        if (direction === 'increase' && mode === 'percent') {
          return this.$t('catalogProd.bulkSummaryIncreasePricePercent', { count: count, products: productsLabel, amount: amount });
        }
        if (direction === 'decrease' && mode === 'flat') {
          return this.$t('catalogProd.bulkSummaryDecreasePriceFlat', { count: count, products: productsLabel, amount: amount, currency: currency });
        }
        return this.$t('catalogProd.bulkSummaryDecreasePricePercent', { count: count, products: productsLabel, amount: amount });
      }
      if (action === 'option_groups') {
        var _names = this.resolveOptionGroupNames(item.group_option_ids);
        return item.mode === 'replace' ? this.$t('catalogProd.bulkSummaryReplaceOptionGroups', { count: count, products: productsLabel, value: _names }) : this.$t('catalogProd.bulkSummaryAddOptionGroups', { count: count, products: productsLabel, value: _names });
      }
      if (action === 'set_vat') {
        var vatLabel = this.resolveVatLabel(item.vat_id);
        return this.$t('catalogProd.bulkSummarySetVat', { count: count, products: productsLabel, value: vatLabel });
      }
      if (action === 'set_section') {
        var sectionName = this.resolveSectionName(item.kds_section_id);
        return this.$t('catalogProd.bulkSummarySetSection', { count: count, products: productsLabel, value: sectionName });
      }
      if (action === 'set_override_delivery') {
        if (!item.override_delivery) {
          return this.$t('catalogProd.bulkSummaryDisableOverride', { count: count, products: productsLabel });
        }
        var methodCount = (item.override_settings || []).reduce(function (acc, loc) {
          var delivery = loc && loc.delivery ? loc.delivery : {};
          return acc + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(delivery).length;
        }, 0);
        return this.$t('catalogProd.bulkSummaryEnableOverrideWithSchedule', {
          count: count,
          products: productsLabel,
          methods: methodCount
        });
      }
      if (action === 'delete') {
        return this.$t('catalogProd.bulkSummaryDelete', { count: count, products: productsLabel });
      }
      return this.$t('catalogProd.bulkSummaryGeneric', { count: count, products: productsLabel });
    },
    resolveVatLabel: function resolveVatLabel(vatId) {
      var match = (this.vatSelectOptions || []).find(function (v) {
        return String(v.id) === String(vatId);
      });
      return match ? match.label : vatId;
    },
    resolveSectionName: function resolveSectionName(sectionId) {
      var match = (this.kdsSections || []).find(function (s) {
        return String(s.id) === String(sectionId);
      });
      return match ? match.name : sectionId;
    },
    resolveOptionGroupNames: function resolveOptionGroupNames(ids) {
      var _this9 = this;

      var list = ids || [];
      var names = list.map(function (id) {
        var match = (_this9.groupOptionsList || []).find(function (g) {
          return String(g.id) === String(id);
        });
        return match ? match.name : id;
      });
      return names.join(', ');
    },
    resolveLocationNames: function resolveLocationNames(tokens) {
      var _this10 = this;

      var list = tokens || [];
      var names = list.map(function (token) {
        var match = (_this10.locations || []).find(function (l) {
          return String(l.token) === String(token) || String(l.id) === String(token);
        });
        return match ? match.name : token;
      });
      return names.join(', ');
    },
    getMassConfirmMessage: function getMassConfirmMessage(count) {
      var _this11 = this;

      var queued = this.queuedMassActions;
      var productsLabel = count === 1 ? this.$t('catalogProd.bulkProductSingular') : this.$t('catalogProd.bulkProductPlural');
      var header = this.$t('catalogProd.confirmBulkMultiple', { count: count, products: productsLabel });
      var items = queued.map(function (item) {
        return '<li>' + _this11.escapeHtml(_this11.getConfirmLineForAction(item, count)) + '</li>';
      }).join('');
      var footer = this.$t('catalogProd.confirmBulkAreYouSure');
      return '<div class="mass-confirm-swal"><p>' + this.escapeHtml(header) + '</p><ul>' + items + '</ul><p class="mass-confirm-footer">' + this.escapeHtml(footer) + '</p></div>';
    },
    escapeHtml: function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },
    buildMassAnalyticsPayload: function buildMassAnalyticsPayload(actions, responseData) {
      var companyId = this.$session.get('selectedCompany');
      var productIds = this.selectAllMatching ? [] : this.selectedProductIds.slice(0, 50);
      var payload = {
        product_count: this.affectedProductCount,
        select_all_matching: !!this.selectAllMatching,
        action_count: actions.length,
        actions: actions,
        product_ids_sample: productIds
      };
      if (responseData) {
        payload.updated = responseData.updated != null ? responseData.updated : null;
        payload.skipped = responseData.skipped != null ? responseData.skipped : null;
        payload.total_matched = responseData.total_matched != null ? responseData.total_matched : null;
        payload.results = responseData.results || null;
      }
      return { companyId: companyId, payload: payload };
    },
    confirmMassUpdate: function confirmMassUpdate() {
      if (!this.massConfirmEnabled || this.affectedProductCount <= 0) return;

      var self = this;
      var count = this.affectedProductCount;
      var hasDelete = this.hasQueuedDelete;

      __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
        html: this.getMassConfirmMessage(count),
        type: hasDelete ? 'warning' : 'question',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no')
      }).then(function (result) {
        if (result) {
          self.submitMassUpdate();
        }
      });
    },
    submitMassUpdate: function submitMassUpdate() {
      var self = this;
      var actions = this.queuedMassActions.slice();
      if (!actions.length) return;

      var companyId = this.$session.get('selectedCompany');
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        token: this.$session.get('token'),
        company_id: companyId,
        actions: actions,
        product_ids: this.selectAllMatching ? [] : this.selectedProductIds.slice(),
        exception_product_ids: this.selectAllMatching ? this.exceptionProductIds.slice() : []
      }, this.buildSidemenuFilterPayload());

      this.bulkUpdating = true;
      this.apiRequest('/sidemenu-products/bulk-mass-update', 'POST', data, function (response) {
        self.bulkUpdating = false;
        var analytics = self.buildMassAnalyticsPayload(actions, response.data || {});
        if (response.status) {
          self.trackAdminEvent('ADMIN_PRODUCT_MASS_UPDATE', 'product_mass', companyId, analytics.payload);
          var updatedCount = response.data && response.data.updated != null ? response.data.updated : null;
          self.showMassUpdateModal = false;
          self.clearProductSelection();
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
            type: 'success',
            title: self.$t('general.success') + '!',
            text: updatedCount != null ? self.$t('catalogProd.bulkMassUpdated', { updated: updatedCount }) : '',
            timer: 2500,
            showConfirmButton: false
          });
          self.getProducts();
        } else {
          var failPayload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, analytics.payload, {
            error: response.errors || response.message || 'unknown'
          });
          self.trackAdminEvent('ADMIN_PRODUCT_MASS_UPDATE_FAILED', 'product_mass', companyId, failPayload);
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
        }
      });
    },
    onInput: function onInput() {
      var _this12 = this;

      clearTimeout(this.onInputGetProductsTimeout);
      this.onInputGetProductsTimeout = setTimeout(function () {
        _this12.getProducts();
      }, 500);
    },
    handlePageChange: function handlePageChange(page) {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: page,
        perPage: this.paginationDef.perPage
      };
      if (this.search.length >= 3) {
        data.search = this.search;
      }
      this.getProducts(data);
    },
    getProducts: function getProducts(data) {
      this.loading = true;
      var self = this;

      data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: this.search,
        id: this.searchId,
        page: this.paginationDef.page
      };

      data[this.filters[1].prop[0]] = normalizeFilterValue(this.filters[1].value);

      var normalizedLocations = normalizeFilterValue(this.filters[2].value).filter(function (v) {
        return v !== '' && v !== null && v !== undefined;
      });
      if (normalizedLocations.length > 0) {
        data[this.filters[2].prop[0]] = normalizedLocations;
      }

      data[this.filters[3].name] = normalizeFilterValue(this.filters[3].value);
      data[this.filters[4].name] = normalizeFilterValue(this.filters[4].value);
      data[this.filters[5].prop[0]] = normalizeFilterValue(this.filters[5].value);

      data[this.filters[6].name] = normalizeFilterValue(this.filters[6].value);

      this.apiRequest('/sidemenu-products', 'GET', data, function (response) {
        if (response.status) {
          self.tableData = response.data.data;
          self.paginationDef.page = response.data.pagination.page;
          self.paginationDef.perPage = response.data.pagination.perPage;
          self.paginationDef.totalPages = response.data.pagination.totalPages;
          self.paginationDef.totalRecords = response.data.pagination.totalRecords;

          if (!self.isNew()) {
            self.$nextTick(function () {
              var el = self.$el.getElementsByClassName('current')[0];
              var container = self.$refs.tableContainerRef;
              var table = self.$refs.detailsScrollTable.$el.querySelector('.el-table__body tbody');
              var position = 1;

              for (var i = 0; i < table.children.length; i++) {
                if (table.children[i].classList.length > 1 && table.children[i].classList[1] === 'current') {
                  if (i > 1) {
                    position = i;
                  }
                }
              }
              container.scrollTo({
                left: 0,
                top: el.clientHeight * position,
                behavior: 'smooth'
              });
            });
          }
          self.loaded = true;
        }
        self.filterChanges();
        self.$nextTick(function () {
          self.loading = false;
        });
      });
    },
    goToRecord: function goToRecord(row, column, event) {
      if ((' ' + event.target.className + ' ').replace(/[\n\t]/g, ' ').includes(' doNotGoToRecord ')) {
        return;
      }

      this.allowedOnProductLocation = !!row.allowed_location;

      this.$router.push({
        name: 'Edit Product',
        params: {
          id: row.id,
          productData: row,
          mainCategories: this.mainCategories,
          taxes: this.taxes,
          kdsSections: this.kdsSections,
          productOptions: this.productOptions,
          companyProductFilters: this.companyProductFilters,
          measurementsUnits: this.measurementsUnits,
          language: this.language,
          languages: this.languages
        }
      });
    },
    updateName: function updateName(index, row, e) {
      var self = this;
      var data = {
        id: row.id,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        price: row.price
      };
      this.apiRequest('/product/' + row.id, 'PUT', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
            type: 'success',
            title: self.$t('validations.success'),
            text: self.$t('validations.priceUpdated'),
            timer: 2000,
            showConfirmButton: false
          });

          self.$refs['savePriceBtn' + index].classList.add('success-tick');
          if (self.$refs.prodForm && parseInt(row.id) === parseInt(self.$route.params.id)) {
            self.$refs.prodForm.getData();
          }
          setTimeout(function () {
            self.$refs['savePriceBtn' + index].classList.remove('success-tick');
          }, 2000);
        } else {
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error');
        }
      });
    },
    switchUnavailableOff: function switchUnavailableOff(row) {
      row.is_not_available = false;
    },
    checkBanner: function checkBanner(index, row, e) {
      var self = this;

      if (row.active) {
        self.switchUnavailableOff(row);
      }

      if (!row.active) {
        var productData = {
          token: self.$session.get('token'),
          company_id: self.$session.get('selectedCompany'),
          product_id: row.id
        };

        self.apiRequest('/check-banner-has-product', 'GET', productData, function (response) {
          if (response && response.data && response.data.product_banner) {
            productData.active = false;
            productData.id = response.data.banner_id;
            __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
              text: self.$t('catalogProd.disableProductUsedByBanner'),
              type: 'question',
              showCancelButton: true,
              confirmButtonText: self.$t('general.yes'),
              cancelButtonText: self.$t('general.no')
            }).then(function (result) {
              if (result) {
                self.apiRequest('/banner/' + productData.id, 'PUT', productData, function (response2) {
                  if (response2.status) {
                    self.handleActive(row);
                  }
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
                row.active = !row.active;
              }
            }, function (dismiss) {
              if (dismiss === 'cancel') {
                row.active = !row.active;
              }
            });
          } else {
            self.handleActive(row);
          }
        });
      } else {
        self.handleActive(row);
      }
    },
    handleActive: function handleActive(row) {
      var self = this;
      var actionText = row.active ? self.$t('general.enable') : self.$t('general.disable');

      __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()({
        text: self.$t('validations.doYouWantTo') + ' ' + actionText + ' ' + self.$t('general.product') + ' ' + row.name + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            id: row.id,
            token: self.$session.get('token'),
            company_id: self.$session.get('selectedCompany'),
            active: !!row.active,
            is_not_available: row.is_not_available
          };
          self.apiRequest('/product/' + row.id, 'PUT', data, function (response) {
            if (response.status) {
              self.trackAdminEvent('ADMIN_PRODUCT_UPDATE', 'product', row.id, {
                product_id: row.id,
                name: row.name || null,
                active: !!row.active,
                location_ids: row.location_ids || (row.locations ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(row.locations) : null)
              });
              self.$bus.$emit('doReloadProd', response.data[0]);
              __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()(self.$t('general.success') + '!', '', 'success');
            } else {
              __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
        row.active = !row.active;
      });
    },
    duplicateProduct: function duplicateProduct(index, row, e) {
      var self = this;
      var data = {
        id: row.id,
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/product/duplicate/' + row.id, 'POST', data, function (response) {
        if (response.status) {
          var currentIdx = self.getObjectByElemKeyValue('id', row.id, self.tableData);
          if (currentIdx !== false) {
            self.tableData = self.tableData.slice(0, parseInt(currentIdx) + 1).concat(response.data).concat(self.tableData.slice(parseInt(currentIdx) + 1));
            self.paginationDef.pageSize = self.tableData.length + 1;
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_18_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error');
        }
        self.getProducts();
      });
    },
    rowClass: function rowClass(rowData) {
      var row = rowData.row || rowData;
      return row.id === this.editedRowId ? 'highlight-row' : '';
    },
    handleDelete: function handleDelete(label) {
      this.$refs.prodForm.handleDelete(label);
    },
    validate: function validate() {
      this.$refs.prodForm.validate();
    },
    removeFilter: function removeFilter(filterKey, key) {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_14_vue___default.a.delete(this.filters[filterKey].value, key);
      this.$nextTick(function () {
        _this13.tableTopHeight = _this13.$refs.tableTop.clientHeight;
      });
    },
    updateList: function updateList(id, data) {
      var idx = this.getObjectByElemKeyValue('id', parseInt(id), this.tableData);
      if (idx) {
        this.tableData[idx]['name'] = data['name'];
        this.tableData[idx]['price'] = data['price'];
        this.tableData[idx]['active'] = data['active'];
        if (data['is_discounted'] !== undefined) {
          this.tableData[idx]['is_discounted'] = data['is_discounted'];
        }
        if (data['locations'] !== undefined) {
          this.tableData[idx]['locations'] = data['locations'];
        }
        if (data['delivery'] !== undefined) {
          this.tableData[idx]['delivery'] = data['delivery'];
        }
      }
    },
    doReloadProdEdit: function doReloadProdEdit() {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.getProducts(data);
    }
  }
});

/***/ }),

/***/ "lSJF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementTransferEdit_vue__ = __webpack_require__("r8wo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d20dce98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementTransferEdit_vue__ = __webpack_require__("NVSL");
function injectStyle (ssrContext) {
  __webpack_require__("zfTc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d20dce98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementTransferEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d20dce98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementTransferEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lTxc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lUWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PriceProfileForm_vue__ = __webpack_require__("2iTw");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PriceProfileForm: __WEBPACK_IMPORTED_MODULE_0__PriceProfileForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      priceProfileData: this.route.params.priceProfileData || {}
    };
  },

  methods: {
    onProfileSubmit: function onProfileSubmit(model, isValid) {
      this.priceProfileModel = model;
    }
  }
});

/***/ }),

/***/ "lVN8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lWAn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lWw+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('cantar-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lX1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__ = __webpack_require__("8yVT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_050216ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__ = __webpack_require__("Y6cz");
function injectStyle (ssrContext) {
  __webpack_require__("2RDU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_050216ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lZGK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptions_vue__ = __webpack_require__("/of0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53869887_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptions_vue__ = __webpack_require__("93oy");
function injectStyle (ssrContext) {
  __webpack_require__("fsa3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53869887_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "la1r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsAdd_vue__ = __webpack_require__("69bs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d3ea02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsAdd_vue__ = __webpack_require__("7QYl");
function injectStyle (ssrContext) {
  __webpack_require__("TkQl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d3ea02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lcot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileInput_vue__ = __webpack_require__("g0uY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a78e76e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileInput_vue__ = __webpack_require__("W3Kt");
function injectStyle (ssrContext) {
  __webpack_require__("dBEi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a78e76e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ldJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);








__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_data_tables___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_js_modal___default.a, { componentName: 'vmodal' });

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isAmbassadorRequests: { type: Boolean, default: false }
  },
  watch: {
    isAmbassadorRequests: function isAmbassadorRequests(v) {
      if (v) this.reload();
    },
    campaigns: function campaigns(list) {
      if (list.length && this.selectedRequest && !this.approveForm.campaignId) {
        this.approveForm.campaignId = list[0].id;
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      statusFilter: '',
      tableData: [],
      total: 0,
      paginationProps: { layout: 'prev, pager, next, sizes, total' },
      campaigns: [],
      approveForm: { campaignId: '', code: '' },
      approveCampaignError: false,
      selectedRequest: null,
      timezone: (this.$session.get('selectedCompanyData') || {}).timezone || 'Europe/Bucharest'
    };
  },

  computed: {
    canSubmitApprove: function canSubmitApprove() {
      return !!this.approveForm.campaignId;
    },
    campaignSelectInvalid: function campaignSelectInvalid() {
      return this.approveCampaignError && !this.approveForm.campaignId;
    }
  },
  mounted: function mounted() {
    this.loadCampaigns();
    this.reload();
  },

  methods: {
    formatRequestCreatedAt: function formatRequestCreatedAt(row) {
      var raw = row && (row.created_at || row.createdAt);
      if (!raw) return this.$t('general.emDash');
      var value = (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(raw)) === 'object' && raw.date ? raw.date : raw;
      if (!value) return this.$t('general.emDash');
      return this.formatToCompanyTimezone(value, this.timezone);
    },
    formatRequestStatus: function formatRequestStatus(row) {
      var s = (row && row.status ? String(row.status) : '').trim().toUpperCase();
      var keys = {
        PENDING: 'general.pending',
        APPROVED: 'general.accepted',
        DENIED: 'general.denied',
        REJECTED: 'general.denied',
        CANCELLED: 'reports.canceled'
      };
      var path = keys[s];
      if (path) return this.$t(path);
      return s ? this.$t('general.statusUnknown') : this.$t('general.emDash');
    },
    isPending: function isPending(row) {
      var s = (row.status || '').toUpperCase();
      return s === 'PENDING';
    },
    normalizeRows: function normalizeRows(response) {
      if (!response || !response.data) return [];
      var d = response.data;
      return Array.isArray(d) ? d : Array.isArray(d.data) ? d.data : [];
    },
    normalizeTotal: function normalizeTotal(response) {
      if (response.pagination && response.pagination.total != null) return response.pagination.total;
      if (response.meta && response.meta.total != null) return response.meta.total;
      var d = response.data;
      if (d && d.total != null) return d.total;
      return this.normalizeRows(response).length;
    },
    loadCampaigns: function loadCampaigns() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/referral-campaign', 'GET', data, function (response) {
        if (response.status) {
          var rows = _this.normalizeRows(response);
          _this.campaigns = rows;
        }
      });
    },
    paginationChanged: function paginationChanged(query) {
      this.fetchPage(query.page, query.pageSize);
    },
    reload: function reload() {
      this.fetchPage(1, 10);
    },
    fetchPage: function fetchPage(page, perPage) {
      var _this2 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: page,
        perPage: perPage
      };
      if (this.statusFilter) {
        data.status = this.statusFilter;
      }
      this.apiRequest('/referral-ambassador-request', 'GET', data, function (response) {
        if (response.status) {
          _this2.tableData = _this2.normalizeRows(response);
          _this2.total = _this2.normalizeTotal(response);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
        }
        _this2.loading = false;
      });
    },
    defaultCampaignId: function defaultCampaignId() {
      var first = this.campaigns[0];
      return first && first.id != null ? first.id : '';
    },
    openApprove: function openApprove(row) {
      this.selectedRequest = row;
      this.approveForm = {
        campaignId: this.defaultCampaignId(),
        code: row.desired_code || ''
      };
      this.$modal.show('referralApproveRequestModal');
    },
    closeApproveModal: function closeApproveModal() {
      this.$modal.hide('referralApproveRequestModal');
      this.resetApprove();
    },
    resetApprove: function resetApprove() {
      this.selectedRequest = null;
      this.approveForm = { campaignId: '', code: '' };
      this.approveCampaignError = false;
    },
    clearApproveCampaignError: function clearApproveCampaignError() {
      this.approveCampaignError = false;
    },
    submitApprove: function submitApprove() {
      var _this3 = this;

      if (!this.selectedRequest) return;
      if (!this.approveForm.campaignId) {
        this.approveCampaignError = true;
        return;
      }
      var body = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        decision: 'APPROVE',
        referral_campaign_id: Number(this.approveForm.campaignId),
        approved_referral_code: this.approveForm.code || undefined
      };
      this.loading = true;
      this.apiRequest('/referral-ambassador-request/' + this.selectedRequest.id, 'PUT', body, function (response) {
        _this3.loading = false;
        if (response.status) {
          _this3.closeApproveModal();
          __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()(_this3.$t('general.success') + '!', '', 'success').catch(function () {});
          _this3.reload();
        } else {
          __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error');
        }
      });
    },
    openDeny: function openDeny(row) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: this.$t('referralProgram.denyReason'),
        input: 'text',
        showCancelButton: true,
        confirmButtonText: this.$t('general.confirm'),
        cancelButtonText: this.$t('general.cancel')
      }).then(function (result) {
        if (!result) return;
        var reason = typeof result === 'string' ? result.trim() : '';
        var body = {
          token: _this4.$session.get('token'),
          company_id: _this4.$session.get('selectedCompany'),
          decision: 'DENY',
          denied_reason: reason || undefined
        };
        _this4.loading = true;
        _this4.apiRequest('/referral-ambassador-request/' + row.id, 'PUT', body, function (response) {
          _this4.loading = false;
          if (response.status) {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()(_this4.$t('general.success') + '!', '', 'success').catch(function () {});
            _this4.reload();
          } else {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error');
          }
        });
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "lgBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"glovo-menu-layout",class:{ 'glovo-menu-layout--product': !!_vm.selectedProduct }},[(_vm.selectedProduct)?_c('product-options-panel',{attrs:{"product":_vm.selectedProduct,"currency":_vm.currency,"variant":"glovo"},on:{"close":function($event){_vm.selectedProduct = null}}}):[_c('aside',{staticClass:"glovo-menu-layout__sidebar"},_vm._l((_vm.categories),function(category){return _c('button',{key:category.id,staticClass:"glovo-menu-layout__nav",class:{ 'is-active': category.id === _vm.activeCategoryId },attrs:{"type":"button"},on:{"click":function($event){_vm.selectCategory(category.id)}}},[_vm._v("\n        "+_vm._s(category.name)+"\n      ")])})),_vm._v(" "),_c('div',{ref:"main",staticClass:"glovo-menu-layout__main"},_vm._l((_vm.categories),function(category){return _c('section',{key:'sec-' + category.id,staticClass:"glovo-menu-layout__section",attrs:{"id":'glovo-cat-' + category.id}},[_c('h2',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_c('div',{staticClass:"glovo-menu-layout__row"},_vm._l((category.products),function(product){return _c('article',{key:product.id,staticClass:"glovo-menu-layout__card",on:{"click":function($event){_vm.selectedProduct = product}}},[_c('div',{staticClass:"glovo-menu-layout__image-wrap"},[(product.image_url)?_c('img',{attrs:{"src":product.image_url,"alt":product.name}}):_c('div',{staticClass:"glovo-menu-layout__placeholder"}),_vm._v(" "),_c('button',{staticClass:"glovo-menu-layout__add",attrs:{"type":"button"}},[_vm._v("+")])]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(product.name))]),_vm._v(" "),(product.description)?_c('p',{staticClass:"glovo-menu-layout__desc"},[_vm._v(_vm._s(_vm.truncate(product.description)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"glovo-menu-layout__price"},[_vm._v(_vm._s(_vm.formatPrice(product.price)))])])}))])}))]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lhu5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaignEdit_vue__ = __webpack_require__("V1ni");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6804ff50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaignEdit_vue__ = __webpack_require__("7WtQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaignEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6804ff50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaignEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lkLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyPoints_vue__ = __webpack_require__("KepL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1766b61a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyPoints_vue__ = __webpack_require__("6G0J");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyPoints_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1766b61a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyPoints_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lkiV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('proforma-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ll3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2_dist_sweetalert2_css__);















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  created: function created() {
    this.locations = this.$session.get('selectedCompanyData').locations_details || [];
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },

  watch: {
    assocTableLocations: function assocTableLocations() {
      this.getAssocMaps();
    }
  },
  data: function data() {
    return {
      loading: true,
      tableData: [],
      search: '',
      searchId: '',
      selectedLocations: [],
      locations: [],

      assocUserSearch: '',
      assocUserLocations: [],
      assocUsersResults: [],
      assocSelectedUsers: [],
      assocLoadingUsers: false,

      assocTableSearch: '',
      assocTableLocations: [],
      assocTableMaps: [],
      assocMaps: [],
      assocTableZone: '',
      assocZones: [],
      assocTablesResults: [],
      assocSelectedTables: [],
      assocLoadingTables: false,

      assocSaving: false
    };
  },

  computed: {
    isAssocConfirmDisabled: function isAssocConfirmDisabled() {
      return this.assocSaving || !this.assocSelectedUsers.length || !this.assocSelectedTables.length;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    onConfirmAssocClick: function onConfirmAssocClick() {
      if (this.assocSaving) return;
      if (!this.assocSelectedUsers.length || !this.assocSelectedTables.length) return;
      this.confirmAssoc();
    },
    getLocationName: function getLocationName(locationId) {
      var location = this.locations.find(function (loc) {
        return loc.id === locationId || loc.true_id === locationId;
      });
      return location ? location.name : '-';
    },
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {

      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/pos/users/');
      }
    },
    goToAdd: function goToAdd() {
      this.$router.push('/pos/users/add');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.searchId) {
        data.id = this.searchId;
      }
      if (this.search) {
        data.search = this.search;
      }
      if (Array.isArray(this.selectedLocations) && this.selectedLocations.length) {
        data.location_ids = this.selectedLocations;
      }

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = (response.data.pos_user || []).map(function (user) {
            return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, user, {
              active: user.active === undefined || user.active === null ? true : !!(+user.active || user.active === true)
            });
          });
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    searchUsers: function searchUsers() {
      this.getData();
    },
    handleActive: function handleActive(row, active) {
      var _this2 = this;

      var nextActive = !!active;
      row.active = nextActive;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        pos_user: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, row, {
          active: nextActive
        })
      };
      this.apiRequest('/pos/user/' + row.id, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
            title: '',
            text: _this2.$t('general.success'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).then(function () {}).catch(function () {});
        } else {
          row.active = !nextActive;
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
            title: '',
            text: _this2.$t('validations.wentWrong'),
            type: 'error',
            showConfirmButton: false,
            timer: 2000
          }).then(function () {}).catch(function () {});
        }
      });
    },
    openAssociateTablesModal: function openAssociateTablesModal() {
      this.$modal.show('associateTablesModal');
      this.assocUsersResults = [];
      this.assocTablesResults = [];
      this.assocSelectedUsers = [];
      this.assocSelectedTables = [];
      this.assocUserSearch = this.search || '';
      this.assocUserLocations = Array.isArray(this.selectedLocations) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.selectedLocations)) : [];
      this.assocTableSearch = '';
      this.assocTableLocations = Array.isArray(this.selectedLocations) ? [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.selectedLocations)) : [];
      this.assocTableMaps = [];
      this.assocTableZone = '';
      this.getAssocZones();
      this.getAssocMaps();
      this.fetchAssocUsers();
      this.fetchAssocTables();
    },
    closeAssociateTablesModal: function closeAssociateTablesModal() {
      this.$modal.hide('associateTablesModal');
    },
    formatUserName: function formatUserName(u) {
      var first = u && u.firstname ? u.firstname : '';
      var last = u && u.lastname ? u.lastname : '';
      var full = (first + ' ' + last).trim();
      return full || u && u.name || u && u.email || u && u.id || '-';
    },
    formatTableName: function formatTableName(t) {
      if (!t) return '-';
      var type = t.type ? String(t.type) : '';
      var number = t.number !== undefined && t.number !== null && String(t.number).length ? String(t.number) : '';
      var external = t.external_id ? String(t.external_id) : '';
      var label = [type, number].filter(Boolean).join(' ');
      return label || external || 'ID ' + t.id;
    },
    isAssocUserSelected: function isAssocUserSelected(userId) {
      return this.assocSelectedUsers.some(function (u) {
        return u.id === userId;
      });
    },
    isAssocTableSelected: function isAssocTableSelected(tableId) {
      return this.assocSelectedTables.some(function (t) {
        return t.id === tableId;
      });
    },
    toggleAssocUser: function toggleAssocUser(user) {
      if (!user || !user.id) return;
      if (this.isAssocUserSelected(user.id)) {
        this.removeAssocUser(user.id);
      } else {
        this.assocSelectedUsers = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.assocSelectedUsers), [user]);
      }
    },
    selectAllAssocUsers: function selectAllAssocUsers() {
      if (!Array.isArray(this.assocUsersResults) || !this.assocUsersResults.length) return;
      var map = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a(this.assocSelectedUsers.map(function (u) {
        return [u.id, u];
      }));
      this.assocUsersResults.forEach(function (u) {
        if (u && u.id && !map.has(u.id)) map.set(u.id, u);
      });
      this.assocSelectedUsers = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(map.values());
    },
    clearAssocUsersSelection: function clearAssocUsersSelection() {
      this.assocSelectedUsers = [];
    },
    removeAssocUser: function removeAssocUser(userId) {
      this.assocSelectedUsers = this.assocSelectedUsers.filter(function (u) {
        return u.id !== userId;
      });
    },
    toggleAssocTable: function toggleAssocTable(table) {
      if (!table || !table.id) return;
      if (this.isAssocTableSelected(table.id)) {
        this.removeAssocTable(table.id);
      } else {
        this.assocSelectedTables = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.assocSelectedTables), [table]);
      }
    },
    selectAllAssocTables: function selectAllAssocTables() {
      if (!Array.isArray(this.assocTablesResults) || !this.assocTablesResults.length) return;
      var map = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a(this.assocSelectedTables.map(function (t) {
        return [t.id, t];
      }));
      this.assocTablesResults.forEach(function (t) {
        if (t && t.id && !map.has(t.id)) map.set(t.id, t);
      });
      this.assocSelectedTables = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(map.values());
    },
    clearAssocTablesSelection: function clearAssocTablesSelection() {
      this.assocSelectedTables = [];
    },
    removeAssocTable: function removeAssocTable(tableId) {
      this.assocSelectedTables = this.assocSelectedTables.filter(function (t) {
        return t.id !== tableId;
      });
    },
    fetchAssocUsers: function fetchAssocUsers() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.assocUserSearch) data.search = this.assocUserSearch;
      if (Array.isArray(this.assocUserLocations) && this.assocUserLocations.length) {
        data.location_ids = this.assocUserLocations;
      }

      this.assocLoadingUsers = true;
      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response && response.status === true) {
          _this3.assocUsersResults = response.data.pos_user || [];
        } else {
          _this3.assocUsersResults = [];
        }
        _this3.$nextTick(function () {
          _this3.assocLoadingUsers = false;
        });
      });
    },
    fetchAssocTables: function fetchAssocTables() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.assocTableSearch) data.search = this.assocTableSearch;
      if (Array.isArray(this.assocTableLocations) && this.assocTableLocations.length) {
        data.location_ids = this.assocTableLocations;
      }
      if (Array.isArray(this.assocTableMaps) && this.assocTableMaps.length) {
        data.map_ids = this.assocTableMaps;
      }
      if (this.assocTableZone) data.zone = this.assocTableZone;

      this.assocLoadingTables = true;
      this.apiRequest('/table-management', 'GET', data, function (response) {
        if (response && response.status === true) {
          _this4.assocTablesResults = Array.isArray(response.data) ? response.data : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(response.data || {});
        } else {
          _this4.assocTablesResults = [];
        }
        _this4.$nextTick(function () {
          _this4.assocLoadingTables = false;
        });
      });
    },
    getAssocMaps: function getAssocMaps() {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (Array.isArray(this.assocTableLocations) && this.assocTableLocations.length) {
        data.location_ids = this.assocTableLocations;
      }
      this.apiRequest('/pos/all/map', 'GET', data, function (response) {
        if (response && response.status === true) {
          _this5.assocMaps = response.data.table_maps || [];
        } else {
          _this5.assocMaps = [];
        }
      });
    },
    getAssocZones: function getAssocZones() {
      var _this6 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/table-zone', 'GET', data, function (response) {
        if (response && response.status === true && Array.isArray(response.data) && response.data.length) {
          _this6.assocZones = response.data.map(function (z) {
            return {
              id: z.id,
              name: z.name
            };
          });
        } else {
          _this6.assocZones = [];
        }
      });
    },
    confirmAssoc: function confirmAssoc() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var userIds, tableIds, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this7.assocSaving) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (!(!_this7.assocSelectedUsers.length || !_this7.assocSelectedTables.length)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                userIds = _this7.assocSelectedUsers.map(function (u) {
                  return u.id;
                });
                tableIds = _this7.assocSelectedTables.map(function (t) {
                  return t.id;
                });


                _this7.assocSaving = true;
                _context.prev = 7;
                data = {
                  token: _this7.$session.get('token'),
                  company_id: _this7.$session.get('selectedCompany'),
                  table_ids: tableIds,
                  user_ids: userIds
                };
                _context.next = 11;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this7.apiRequest('/table-management/add-users-on-tables', 'POST', data, function (response) {
                    if (response && (response.status === true || response.success === true)) {
                      resolve(response);
                    } else {
                      reject(response);
                    }
                  });
                });

              case 11:

                __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
                  title: '',
                  text: _this7.$t('general.success'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function () {}).catch(function () {});

                _this7.closeAssociateTablesModal();
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](7);

                __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
                  title: '',
                  text: _context.t0 && _context.t0.errors && (_context.t0.errors.message || _context.t0.errors.error) ? _context.t0.errors.message || _context.t0.errors.error : _this7.$t('validations.wentWrong'),
                  type: 'error',
                  showConfirmButton: true
                }).then(function () {}).catch(function () {});

              case 18:
                _context.prev = 18;

                _this7.assocSaving = false;
                return _context.finish(18);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7, [[7, 15, 18, 21]]);
      }))();
    },
    handleDelete: function handleDelete(item) {
      var _this8 = this;

      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
        text: this.$t('addOrder.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            id: item,
            token: _this8.$session.get('token'),
            company_id: _this8.$session.get('selectedCompany')
          };
          _this8.apiRequest('/pos/user/' + item, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', _this8.$t('general.success'), 'success');
              _this8.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : _this8.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function (err) {
        if (err) {}
      });
      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.disableConfirmButton();
      var yes = this.$t('general.yes');
      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          if (__WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.getConfirmButton().textContent = yes + ' (' + btnCounter + ')';
          }
        } else {
          if (__WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.getConfirmButton().textContent = yes;
          }
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    }
  }
});

/***/ }),

/***/ "loWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();return _vm.handleDelete($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-icon",staticStyle:{"text-transform":"capitalize"},attrs:{"type":"button"},on:{"click":_vm.copyProduct}},[_c('img',{attrs:{"src":"/static/img/icons/duplicate.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('gestiune.copyProduct'))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":_vm.saveProduct}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15 mar-bt-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch","margin-top":"40px"}},[_c('div',{staticClass:"col-lg-12 col-md-12"},[(_vm.is_external == 1)?_c('div',{staticClass:"info-text info-text--bold"},[_vm._v("\n        "+_vm._s(_vm.$t('gestiune.umTaptastyInfo'))+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.productName),expression:"productName"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.productName),expression:"modelValidate.productName"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.is_external == 1,"placeholder":_vm.$t('gestiune.productName')},domProps:{"value":(_vm.productName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.productName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productDescription'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.productDescription),expression:"productDescription"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.productDescription),expression:"modelValidate.productDescription"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.is_external == 1,"placeholder":_vm.$t('gestiune.productDescription')},domProps:{"value":(_vm.productDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.productDescription=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.productType),expression:"productType"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.productType),expression:"modelValidate.productType"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.productType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează opțiunea")]),_vm._v(" "),_vm._l((_vm.filteredProductTypes),function(type,index){return _c('option',{key:index,domProps:{"value":type.value}},[_vm._v("\n                        "+_vm._s(type.label)+"\n                      ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.isRecipeProduct)?[_c('div',{staticClass:"d-flex",staticStyle:{"gap":"10px"}},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 150px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.um'))+" *")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.um),expression:"um"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.um),expression:"modelValidate.um"}],staticClass:"form-control",attrs:{"disabled":_vm.is_external == 1},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.um=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_vm._l((_vm.mesurementsUnits),function(unit){return [_c('option',{key:unit.short,domProps:{"value":unit.short}},[_vm._v(_vm._s(unit.short))])]})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"1"}},[_c('label',[_vm._v("Cantitate rezultată")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cantitateRezultata),expression:"cantitateRezultata"}],staticClass:"form-control form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"number","placeholder":"Cantitate rezultată"},domProps:{"value":(_vm.cantitateRezultata)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cantitateRezultata=$event.target.value}}})])])]:[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.um'))+" *")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.um),expression:"um"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.um),expression:"modelValidate.um"}],staticClass:"form-control",attrs:{"disabled":_vm.is_external == 1},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.um=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_vm._l((_vm.mesurementsUnits),function(unit){return [_c('option',{key:unit.short,domProps:{"value":unit.short}},[_vm._v(_vm._s(unit.short))])]})],2)])]],2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.tva'))+" *")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cotaTva),expression:"cotaTva"}],staticClass:"form-control",attrs:{"disabled":_vm.is_external == 1},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cotaTva=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează TVA")]),_vm._v(" "),(_vm.is_external == 1 && _vm.product)?_c('option',{domProps:{"value":_vm.product.vat_percent}},[_vm._v("\n                        "+_vm._s(_vm.product.vat_percent)+" %\n                      ")]):_vm._l((_vm.vats),function(vat){return _c('option',{key:vat.tax_id,domProps:{"value":vat.amount}},[_vm._v("\n                          "+_vm._s(vat.amount)+" %\n                        ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currency')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency),expression:"currency"}],staticClass:"form-control",attrs:{"disabled":_vm.is_external == 1},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currency=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"RON"}},[_vm._v("RON")]),_vm._v(" "),_c('option',{attrs:{"value":"EUR"}},[_vm._v("EURO")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.codeProduct')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.codeProduct),expression:"codeProduct"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.codeProduct'),"disabled":""},domProps:{"value":(_vm.codeProduct)},on:{"input":function($event){if($event.target.composing){ return; }_vm.codeProduct=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.termenValabilitate')))]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.validityValue),expression:"validityValue",modifiers:{"number":true}}],staticClass:"form-control",staticStyle:{"margin-right":"10px"},attrs:{"type":"number","min":"0","placeholder":"Valoare"},domProps:{"value":(_vm.validityValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.validityValue=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.validityUnit),expression:"validityUnit"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.validityUnit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"zile"}},[_vm._v("Zile")]),_vm._v(" "),_c('option',{attrs:{"value":"saptamani"}},[_vm._v("Săptămâni")]),_vm._v(" "),_c('option',{attrs:{"value":"luni"}},[_vm._v("Luni")]),_vm._v(" "),_c('option',{attrs:{"value":"ani"}},[_vm._v("Ani")]),_vm._v(" "),_c('option',{attrs:{"value":"ore"}},[_vm._v("Ore")]),_vm._v(" "),_c('option',{attrs:{"value":"minute"}},[_vm._v("Minute")])])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v("VAT Number: "),_c('strong',[_vm._v(_vm._s(_vm.route.params.vatNumber))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row mt-4"},_vm._l((_vm.filteredGestiuni),function(gestiune,index){return _c('div',{key:gestiune._id,staticClass:"col-md-4 mb-4"},[_c('div',{staticClass:"card-price"},[_c('div',{staticClass:"mb-1"},[_c('h6',{staticStyle:{"margin":"0","font-weight":"bold"}},[_vm._v("\n                "+_vm._s(gestiune.name)+"\n              ")]),_vm._v(" "),_c('small',{staticStyle:{"color":"#7C8DB5"}},[_vm._v("\n                Locație: "),_c('strong',[_vm._v(_vm._s(_vm.getLocationName(gestiune.externalLocationId)))])])]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('label',{staticStyle:{"font-weight":"500"}},[_vm._v("Preț:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gestiunePrices[gestiune._id]),expression:"gestiunePrices[gestiune._id]"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Introduceți prețul"},domProps:{"value":(_vm.gestiunePrices[gestiune._id])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gestiunePrices, gestiune._id, $event.target.value)}}})])])])}))])]),_vm._v(" "),(_vm.isRecipeProduct)?_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-md-12 d-flex align-items-center",staticStyle:{"gap":"10px","margin-bottom":"20px"}},[_c('p',{staticStyle:{"margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.$t('gestiune.addReteta')))])]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('el-table',{ref:"recipeTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"row-class-name":_vm.tableRowClassName}},[_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.productName'),"prop":"productNameRecipe"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.productNameRecipe)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.gestiune'),"prop":"productTypeRecipe"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.productTypeRecipe)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.codeProduct'),"prop":"codeProductRecipe"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.codeProductRecipe)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.um'),"prop":"umRecipe"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.umRecipe)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.cantitate'),"prop":"quantityRecipe"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.quantityRecipe)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.scazamant'),"prop":"scazamantValue"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.scazamantValue)+" - "+_vm._s(scope.row.scazamantType)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.openAddProductModal(scope.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.edit'))+"\n                ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.deleteRow(scope.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")])],1)],1)]}}])})],1),_vm._v(" "),_c('button',{staticClass:"btn add mar-rt-10 mar-bt-5 mar-to-15",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.openAddProductModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n        "+_vm._s(_vm.$t('gestiune.addReteta'))+"\n      ")])],1)]):_vm._e(),_vm._v(" "),(!_vm.loadingRecipes && _vm.recipes.length)?_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.recipes}},[_c('el-table-column',{attrs:{"label":"Rețetă"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('strong',{staticStyle:{"color":"#25396F"}},[_vm._v("\n              "+_vm._s(scope.row.denumire)+"\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Categorie"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.categorie || '-')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Grupă"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.grupa || '-')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Consum"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(parseFloat(String(scope.row.item.qty).replace(',', '.')).toFixed(3))+"\n            "+_vm._s(scope.row.item.um)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Ingredient"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.item.name || '-')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Scăzământ"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.item.scazamantValue)?_c('span',[_vm._v("\n              "+_vm._s(scope.row.item.scazamantValue)+"\n              "+_vm._s(scope.row.item.scazamantType)+"\n            ")]):_c('span',[_vm._v("\n              -\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Ingrediente"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n            "+_vm._s(scope.row.items ? scope.row.items.length : 0)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Acțiuni"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.recipe && scope.row.recipe.parentPosId)?_c('span',{staticStyle:{"cursor":"pointer","text-decoration":"underline","color":"#409EFF"},on:{"click":function($event){$event.stopPropagation();_vm.goToProduct(scope.row)}}},[_vm._v("\n              "+_vm._s(_vm.$t('general.see'))+"\n            ")]):_c('span',[_vm._v("\n              -\n            ")])]}}])})],1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_vm._m(2),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row mt-4 stock-cards-row"},_vm._l((_vm.gestiuniStockFiltered),function(g,index){return _c('div',{key:index + '-' + g._id,staticClass:"col-md-4 mb-4 stock-card-col"},[_c('div',{staticClass:"card-price stock-card"},[_c('div',{staticClass:"stock-header"},[_c('div',[_c('h5',{staticClass:"stock-title"},[_vm._v(_vm._s(g.name))]),_vm._v(" "),_c('small',{staticClass:"stock-subtitle"},[_vm._v("Cod: "+_vm._s(g.cod_gestiune))])]),_vm._v(" "),_c('div',{staticClass:"stock-badge"},[_vm._v("\n                "+_vm._s((g.product && g.product.um) ? g.product.um : '-')+"\n              ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),(g.loading)?_c('div',{staticClass:"card-loader"},[_c('div',{staticClass:"spinner"}),_vm._v(" "),_c('span',[_vm._v("Se încarcă stocul...")])]):_c('div',[_c('div',{staticClass:"summary-grid"},[_c('div',{staticClass:"summary-box"},[_c('small',[_vm._v("Cantitate")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.formatNumber(g.quantity)))])]),_vm._v(" "),_c('div',{staticClass:"summary-box"},[_c('small',[_vm._v("Valoare")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.formatNumber(g.value))+" RON")])]),_vm._v(" "),_c('div',{staticClass:"summary-box"},[_c('small',[_vm._v("Preț mediu")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.formatNumber(g.average_price))+" RON")])]),_vm._v(" "),_c('div',{staticClass:"summary-box"},[_c('small',[_vm._v("TVA")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s((g.product && g.product.vat_percent) ? g.product.vat_percent : 0)+"%")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"product-info"},[_c('div',{staticClass:"info-row"},[_c('span',[_vm._v("Produs")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s((g.product && g.product.name) ? g.product.name : '-'))])]),_vm._v(" "),_c('div',{staticClass:"info-row"},[_c('span',[_vm._v("Categorie")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s((g.product && g.product.categorie) ? g.product.categorie : '-'))])]),_vm._v(" "),_c('div',{staticClass:"info-row"},[_c('span',[_vm._v("Monedă")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s((g.product && g.product.currency) ? g.product.currency : 'RON'))])]),_vm._v(" "),_c('div',{staticClass:"info-row"},[_c('span',[_vm._v("Ultimul update")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(g.date ? _vm.formatDate(g.date) : '-'))])])])])])])}))])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_vm._m(3),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row mt-4"},_vm._l((_vm.gestiuniStockHistoryDetails),function(g,index){return _c('div',{key:index + '-' + g._id,staticClass:"col-md-6 mb-4"},[(g.loading || (g.products && g.products.length))?_c('div',{staticClass:"card-price stock-card"},[_c('div',{staticClass:"stock-header"},[_c('div',[_c('h5',{staticClass:"stock-title"},[_vm._v(_vm._s(g.name))]),_vm._v(" "),_c('small',{staticClass:"stock-subtitle"},[_vm._v("Cod: "+_vm._s(g.cod_gestiune))])]),_vm._v(" "),_c('div',{staticClass:"stock-badge"},[_vm._v("\n                "+_vm._s(_vm.getProductStockInfo(g))+"\n              ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),(g.loading)?_c('div',{staticClass:"card-loader"},[_c('div',{staticClass:"spinner"}),_vm._v(" "),_c('span',[_vm._v("Se încarcă istoricul...")])]):_c('div',[_c('div',{staticClass:"history-table-wrapper"},[_c('table',{staticClass:"table history-table"},[_vm._m(4,true),_vm._v(" "),_c('tbody',[_vm._l((g.products),function(prod,pIndex){return _vm._l((prod.history),function(h,hIndex){return _c('tr',{key:'hist-' + pIndex + '-' + hIndex,staticClass:"history-row"},[_c('td',{staticClass:"col-data"},[_c('small',[_vm._v(_vm._s(_vm.formatDate(h.date)))])]),_vm._v(" "),_c('td',{staticClass:"col-document"},[_c('div',{staticClass:"doc-info",on:{"click":function($event){_vm.goToDocument(h)}}},[_c('span',{staticClass:"badge clickable",class:_vm.getDocumentBadgeClass(h.document_type)},[_vm._v("\n                              "+_vm._s(_vm.formatDocumentType(h.document_type))+"\n                            ")]),_vm._v(" "),(_vm.getDocumentNumber(h))?_c('span',{staticClass:"doc-number-black"},[_vm._v("\n                              "+_vm._s(_vm.getDocumentNumber(h))+"\n                            ")]):_vm._e()]),_vm._v(" "),(h.document && h.document.produced_posId)?_c('div',{staticClass:"produced-label",on:{"click":function($event){$event.stopPropagation();_vm.goToProduced(h)}}},[_c('span',{staticClass:"label-badge"},[_vm._v("Produs fabricat")])]):_vm._e(),_vm._v(" "),(h.observatii)?_c('div',{staticClass:"text-muted"},[_c('small',[_vm._v(_vm._s(h.observatii))])]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"col-intrare text-right"},[(h.intrare && h.intrare !== 0)?_c('span',{staticClass:"text-success"},[_c('strong',[_vm._v(_vm._s(_vm.formatNumber(h.intrare)))])]):_c('span',{staticClass:"text-muted"},[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"col-iesire text-right"},[(h.iesire && h.iesire !== 0)?_c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.formatNumber(h.iesire)))])]):_c('span',{staticClass:"text-muted"},[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"col-stoc text-right"},[_c('strong',[_vm._v(_vm._s(_vm.formatNumber(h.running)))])]),_vm._v(" "),_c('td',{staticClass:"col-pret text-right"},[(h.pret)?_c('span',[_vm._v(_vm._s(_vm.formatNumber(h.pret))+" RON")]):_c('span',{staticClass:"text-muted"},[_vm._v("-")])])])})})],2)])])])]):_vm._e()])}))])]),_vm._v(" "),_c('vmodal',{attrs:{"name":"editGestionModal","height":"auto","width":"600"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.editPrice')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.pretVanzare')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editForm.price),expression:"editForm.price"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Introdu prețul"},domProps:{"value":(_vm.editForm.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editForm, "price", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currency')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.editForm.currency),expression:"editForm.currency"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.editForm, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"RON"}},[_vm._v("RON")]),_vm._v(" "),_c('option',{attrs:{"value":"EUR"}},[_vm._v("EUR")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.stocMinim')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editForm.minStock),expression:"editForm.minStock"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Introdu stocul minim"},domProps:{"value":(_vm.editForm.minStock)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editForm, "minStock", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeEditModal}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":function($event){$event.preventDefault();return _vm.saveGestionEdit($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])]),_vm._v(" "),_c('vmodal',{staticClass:"addProductModal",attrs:{"name":"addProductModal","height":"auto","width":"970"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addReteta')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategory),expression:"selectedCategory"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onCategoryChange]}},[_c('option',{attrs:{"value":""}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.limitedCategories),function(cat,index){return _c('option',{key:index,domProps:{"value":cat.value}},[_vm._v("\n                    "+_vm._s(cat.label)+"\n                  ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productName'))+"*")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.searchResults,"label":"name","placeholder":"Caută un produs...","filterable":false},on:{"search":_vm.fetchProducts,"input":_vm.onProductSelect},model:{value:(_vm.productNameRecipe),callback:function ($$v) {_vm.productNameRecipe=$$v},expression:"productNameRecipe"}},[[(!_vm.loadingProducts)?_c('span',[_vm._v("Niciun produs găsit")]):_vm._e()]],2),_vm._v(" "),(_vm.loadingProducts)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.codeProduct')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.codeProductRecipe),expression:"codeProductRecipe"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.codeProduct'),"disabled":""},domProps:{"value":(_vm.codeProductRecipe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.codeProductRecipe=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.um')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.umRecipe),expression:"umRecipe"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.um'),"disabled":""},domProps:{"value":(_vm.umRecipe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.umRecipe=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.cantitate'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quantityRecipe),expression:"quantityRecipe"}],staticClass:"form-control",attrs:{"type":"number","step":"any","placeholder":_vm.$t('gestiune.cantitate')},domProps:{"value":(_vm.quantityRecipe)},on:{"keydown":_vm.blockCommaKey,"input":[function($event){if($event.target.composing){ return; }_vm.quantityRecipe=$event.target.value},_vm.sanitizeQuantityRecipe]}}),_vm._v(" "),_c('small',{staticStyle:{"display":"block","font-size":"12px","font-style":"italic","color":"#7C8DB5","margin-top":"4px"}},[_vm._v("\n                  "+_vm._s(_vm.$t('gestiune.cantitateHint'))+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('gestiune.scazamant')))]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scazamantValue),expression:"scazamantValue"}],staticClass:"form-control mr-2",staticStyle:{"width":"60%"},attrs:{"type":"number","placeholder":"0"},domProps:{"value":(_vm.scazamantValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.scazamantValue=$event.target.value}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.scazamantType),expression:"scazamantType"}],staticClass:"form-control",staticStyle:{"width":"40%"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.scazamantType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează opțiunea")]),_vm._v(" "),_c('option',{attrs:{"value":"valoare"}},[_vm._v(_vm._s(_vm.$t('gestiune.valoare')))]),_vm._v(" "),_c('option',{attrs:{"value":"procent"}},[_vm._v(_vm._s(_vm.$t('gestiune.procent')))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeModal}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":function($event){$event.preventDefault();return _vm.saveRecipe($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])]),_vm._v(" "),_c('vmodal',{staticClass:"addProductModal",attrs:{"name":"addProduct","height":"auto","width":"970"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProduct')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productName'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.productName')},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.productDescription'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.productDescription')},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.type'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.type),expression:"type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează opțiunea")]),_vm._v(" "),_vm._l((_vm.limitedCategories),function(cat,index){return _c('option',{key:index,domProps:{"value":cat.value}},[_vm._v("\n                        "+_vm._s(cat.label)+"\n                      ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.um'))+" *")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.umProduct),expression:"umProduct"}],staticClass:"form-control",attrs:{"disabled":_vm.type === 'Semifabricate (Reteta)'},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.umProduct=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_vm._l((_vm.mesurementsUnits),function(unit){return [_c('option',{domProps:{"value":unit.short}},[_vm._v(_vm._s(unit.short))])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currency'))+" *")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currencyProduct),expression:"currencyProduct"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currencyProduct=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"RON"}},[_vm._v("RON")]),_vm._v(" "),_c('option',{attrs:{"value":"EUR"}},[_vm._v("EURO")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.codeProduct'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('gestiune.codeProduct')},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeProduct}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":function($event){$event.preventDefault();return _vm.addProduct($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-text",staticStyle:{"margin-bottom":"20px"}},[_vm._v("\n        Completează prețul pentru fiecare gestiune corespunzător."),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 d-flex align-items-center",staticStyle:{"gap":"10px","margin-bottom":"20px"}},[_c('p',{staticStyle:{"margin-bottom":"0px"}},[_vm._v("\n          Produs utilizat în urmatoarele rețete\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 d-flex align-items-center",staticStyle:{"gap":"10px","margin-bottom":"20px"}},[_c('p',{staticStyle:{"margin-bottom":"0px"}},[_vm._v("Detalii stoc (pe gestiuni)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 d-flex align-items-center",staticStyle:{"gap":"10px","margin-bottom":"20px"}},[_c('p',{staticStyle:{"margin-bottom":"0px"}},[_vm._v("Detalii istoric miscari de stoc pe ultimele 7 ZILE (pe gestiuni)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"col-data"},[_vm._v("Data")]),_vm._v(" "),_c('th',{staticClass:"col-document"},[_vm._v("Document")]),_vm._v(" "),_c('th',{staticClass:"col-intrare text-right"},[_vm._v("Intrare")]),_vm._v(" "),_c('th',{staticClass:"col-iesire text-right"},[_vm._v("Ieșire")]),_vm._v(" "),_c('th',{staticClass:"col-stoc text-right"},[_vm._v("Stoc")]),_vm._v(" "),_c('th',{staticClass:"col-pret text-right"},[_vm._v("Preț")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "loY+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ls/v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscriptionForm_vue__ = __webpack_require__("EySa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aba7af4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionForm_vue__ = __webpack_require__("Tjv0");
function injectStyle (ssrContext) {
  __webpack_require__("X6sA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubscriptionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aba7af4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubscriptionForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lsTN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationGroupsEdit_vue__ = __webpack_require__("Gonw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4260f922_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationGroupsEdit_vue__ = __webpack_require__("2RAR");
function injectStyle (ssrContext) {
  __webpack_require__("Zvre")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationGroupsEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4260f922_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationGroupsEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lsfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.stornoReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[(_vm.showLocations)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.posUsers)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.operator')))]),_vm._v(" "),_c('v-select',{staticClass:"line-heigth-44",attrs:{"options":_vm.posUsers,"multiple":"","placeholder":_vm.$t('general.alls')},model:{value:(_vm.selectedPosUser),callback:function ($$v) {_vm.selectedPosUser=$$v},expression:"selectedPosUser"}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('chart-bars-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"topProductSales",attrs:{"chart-data":_vm.topProductSales.data,"chart-options":_vm.topProductSales.options}},[(_vm.noData)?[_c('div',{staticClass:"no-data-message",staticStyle:{"text-align":"center","margin":"20px"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('reports.noDataAvailable')))])])]:_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend",staticStyle:{"display":"flex","flex-wrap":"wrap"}},_vm._l((_vm.topProductSales.data.labels),function(label,index){return _c('div',{key:index,staticStyle:{"display":"flex","align-items":"center","margin-right":"12px"}},[_c('i',{staticClass:"fa fa-circle",style:({ color: _vm.colors[index % _vm.colors.length], marginRight: '5px' })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(label)+" - "+_vm._s(_vm.topProductSales.data.series[0][index]))])])}))])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"search-def":{ show: false },"total":_vm.ordersTableData.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"order_id","label":_vm.$t('reports.orderId')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"order_number","label":_vm.$t('reports.orderNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":120,"prop":"operator_fullname","label":_vm.$t('reports.operator')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"order_total","label":_vm.$t('reports.orderTotal')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.formatMoneyAmount(Number(props.row.order_total)))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"prop":"product_name","label":_vm.$t('reports.productName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"product_price","label":_vm.$t('catalogProd.price')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.formatMoneyAmount(Number(props.row.product_price)))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"product_quantity","label":_vm.$t('reports.quantity')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"prop":"product_storno_comment","label":_vm.$t('feedback.comment')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"prop":"timestamp","label":_vm.$t('reports.orderItemMarkingTime')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(props.row.timestamp ? _vm.formatToCompanyTimezone(props.row.timestamp) : '-')+"\n          ")]}}])})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lvvt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ly2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.productsAndOptionsReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc,index){return _c('option',{key:index,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),(_vm.ordersTableData.data && _vm.ordersTableData.data.length > 0)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card center-sales-report-stats",staticStyle:{"height":"100% !important"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content"},[_c('div',{staticClass:"report-container"},[_c('div',{staticClass:"report-row",staticStyle:{"margin-bottom":"8px","font-weight":"bold","border-bottom":"1px solid #ddd","padding-bottom":"5px"}},[_c('div',{staticClass:"report-col left-align"}),_vm._v(" "),_c('div',{staticClass:"report-col right-align",staticStyle:{"color":"#25396F","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('reports.quantity')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align",staticStyle:{"color":"#25396F","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('reports.fullPrice')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align",staticStyle:{"color":"#25396F","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('reports.orderItemNetPrice')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align",staticStyle:{"color":"#25396F","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('reports.vatAmount')))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.products')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(Number(_vm.productTotals.quantity || 0)))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.productTotals.total || 0))))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.productTotals.net_value || 0))))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.productTotals.vat || 0))))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.options')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(Number(_vm.optionTotals.quantity || 0)))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.optionTotals.total || 0))))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.optionTotals.net_value || 0))))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.optionTotals.vat || 0))))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.total')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(Number(_vm.grandTotals.quantity || 0)))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.grandTotals.total || 0))))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.grandTotals.net_value || 0))))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.grandTotals.vat || 0))))])])])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"search-def":{show: false},"total":_vm.ordersTableData.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"product_id","label":"ID"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.product_id || '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"type","label":_vm.$t('reports.type')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.type ? _vm.$t('reports.' + props.row.type) : '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":150,"prop":"product_name","label":_vm.$t('catalogCateg.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.product_name)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"quantity","label":_vm.$t('reports.itemsSold')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(Number(props.row.quantity))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"total","label":_vm.$t('reports.fullPrice')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"net_value","label":_vm.$t('reports.orderItemNetPrice')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.net_value || 0)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"vat","label":_vm.$t('reports.vatAmount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.vat)))+"\n            ")]}}])})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lya+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"trends-report"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.showLocations)?_c('div',{staticClass:"pull-left mar-rt-10"},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.trends.location),expression:"trends.location"}],staticClass:"form-control inline-auto white",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.trends, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc,key){return [_c('option',{key:loc.id + key,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.trends.valid),callback:function ($$v) {_vm.$set(_vm.trends, "valid", $$v)},expression:"trends.valid"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])])])]),_vm._v(" "),_c('div',{staticClass:"row text-left"},[_c('div',{staticClass:"col-md-12"},[_c('chart-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"refOrdersChart",attrs:{"chart-data":_vm.ordersChart.data,"chart-options":_vm.ordersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.orderChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.ordersChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v("\n              "+_vm._s(_vm.$t('dashboard.completed'))+"\n            ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('chart-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"salesChart",attrs:{"chart-data":_vm.salesChart.data,"chart-options":_vm.salesChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.salesChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.salesChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v("\n              "+_vm._s(_vm.$t('reports.salesIn'))+" "+_vm._s(_vm.currency)+"\n            ")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row text-left"},[(!this.trends.location)?_c('div',{staticClass:"col-md-12"},[_c('chart-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"customersChart",attrs:{"chart-data":_vm.customersChart.data,"chart-options":_vm.customersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.newCustomersChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.customersChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v("\n              "+_vm._s(_vm.$t('reports.custWithAcc'))+"\n            ")])])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 chart-bar-label"},[_c('chart-bars-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"topProdsChart",attrs:{"chart-data":_vm.topProdsChart.data,"chart-options":_vm.topProdsChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.top10Chart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.topProdsChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v("\n              "+_vm._s(_vm.$t('reports.salesProductNr'))+"\n            ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 delivery-height"},[_c('chart-bars-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"deliveryChart",attrs:{"chart-data":_vm.deliveryChart.data,"chart-options":_vm.deliveryChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.orderingChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.deliveryChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v("\n              "+_vm._s(_vm.$t('reports.nrOfOrders'))+"\n            ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 delivery-height"},[_c('chart-pie-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"paymentsChart",attrs:{"chart-data":_vm.paymentsChart.data,"chart-options":_vm.paymentsChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.cash'))+" VS "+_vm._s(_vm.$t('reports.card')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.paymentsChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"})])])],1)]),_vm._v(" "),(!_vm.trends.location)?_c('div',{staticClass:"row text-left"},[_c('div',{staticClass:"col-md-6 pie-height"},[_c('chart-pie-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"ageChart",attrs:{"chart-data":_vm.ageChart.data,"chart-options":_vm.ageChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.customersAge')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.ageChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('p')])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 pie-height"},[_c('chart-pie-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"genderChart",attrs:{"chart-data":_vm.genderChart.data,"chart-options":_vm.genderChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('reports.customersGender')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.genderChart.title))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('p')])])])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m/ts":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m0L1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Dashboard_Views_Customers_states__ = __webpack_require__("myZ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_unitEfactura_json__ = __webpack_require__("sBir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_unitEfactura_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__mixins_unitEfactura_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_audit__ = __webpack_require__("AF16");


















window.appInstanceCache = {};
window.cache_date = null;
window.intervalForDatabaseCache = null;
var CACHE_TIME_LIMIT = 60000 * 720;
var MAX_REQUESTS_COUNT = 5;
var INTERVAL_MS = 10;
var PENDING_REQUESTS = 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isLoading: true
  },
  data: function data() {
    return {
      apiResponse: [],
      unitMapping: __WEBPACK_IMPORTED_MODULE_11__mixins_unitEfactura_json___default.a,
      statesData: __WEBPACK_IMPORTED_MODULE_10__components_Dashboard_Views_Customers_states__["a" /* default */]
    };
  },

  methods: {
    apiRequestPromise: function apiRequestPromise(url, method, data) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.apiRequest(url, method, data, function (response) {
          resolve(response);
        });
      });
    },
    isOwner: function isOwner() {
      if (this.$session.get('userDataRole') === 'OWNER') {
        return true;
      }
      return false;
    },
    userHasRight: function userHasRight(right) {
      if (right == '') {
        return true;
      }
      var userData = JSON.parse(this.$session.get('userData'));
      if (userData.role == 'OWNER') {
        return true;
      }
      if (userData.role == 'LOCATION_ADMIN' || userData.role == 'LOCATION_STORE_ADMIN' || userData.role == 'USER_CUSTOM') {
        if (right == 'GESTIUNE') {
          var hasAtLeastOnePermission = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(userData.permissions_map || {}).some(function (val) {
            return val === true;
          });
          return hasAtLeastOnePermission;
        }
        if (userData.permissions_map) {
          return userData.permissions_map[right] === true;
        }
      }
      return false;
    },
    canAccessPriceLists: function canAccessPriceLists() {
      if (this.$session.get('userDataRole') !== 'USER_CUSTOM') {
        return true;
      }
      return this.userHasRight('general_can_access_catalog') && this.userHasRight('general_can_access_price_lists');
    },
    guardPriceListsAccess: function guardPriceListsAccess() {
      if (this.canAccessPriceLists()) {
        return true;
      }
      this.$router.replace({ path: '/catalog', query: { tabIndex: 0 } });
      return false;
    },
    getUnitText: function getUnitText(unitCode) {
      if (this.unitMapping && this.unitMapping[unitCode] && this.unitMapping[unitCode].text) {
        var fullText = this.unitMapping[unitCode].text;

        var parts = fullText.split(" - ");
        if (parts.length > 1) {
          return parts.slice(1).join(" - ").trim();
        } else {
          return fullText;
        }
      }

      return unitCode;
    },
    getUnitCodeFromText: function getUnitCodeFromText(unitText) {
      if (!this.unitMapping) return unitText;

      for (var code in this.unitMapping) {
        var mapping = this.unitMapping[code];
        if (mapping && mapping.text && mapping.value) {
          var parts = mapping.text.split(" - ");
          var displayText = parts.length > 1 ? parts.slice(1).join(" - ").trim() : mapping.text;

          if (displayText.toLowerCase() === unitText.toLowerCase() || code.toLowerCase() === unitText.toLowerCase()) {
            return mapping.value;
          }
        }
      }

      console.log('unitText', unitText);

      return unitText;
    },
    getOrderFormFlags: function getOrderFormFlags() {
      return ['phone', 'email', 'inlocation', 'glovo', 'tazz'];
    },
    getAppIsLoading: function getAppIsLoading() {
      return this.isLoading;
    },
    setAppIsLoading: function setAppIsLoading(newVal) {
      this.isLoading = newVal;
    },
    localRequest: function localRequest(serverIpPort, url) {
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
      var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var callback = arguments[4];

      var apiRequestHeader = {
        'Access-Control-Allow-Origin': '*'
      };

      var target = null;
      if (!serverIpPort) {
        serverIpPort = 'http://localhost:65400';
      } else {
        target = serverIpPort;

        serverIpPort = 'http://localhost:3210';
      }

      var instance = this.axios.create({
        baseURL: serverIpPort,
        timeout: options.timeout || 90000,
        headers: apiRequestHeader
      });

      if (serverIpPort === 'http://localhost:3210' && target) {
        var separator = url.includes('?') ? '&' : '?';
        url = '' + url + separator + 'target=' + encodeURIComponent(target);
      }

      switch (method) {
        case 'GET':
          instance.get(url, { params: data }).then(function (response) {
            callback(response);
          }, function (error) {
            var response = { 'status': false, 'error': error };
            callback(response);
          }).catch(function (error) {
            var response = { 'status': false, 'error': error };
            callback(response);
          });
          break;
        case 'POST':
          instance.post(url, data).then(function (response) {
            callback(response);
          }).catch(function (error) {
            var response = { 'status': false, 'error': error };
            callback(response);
          });
          break;
        case 'PUT':
          instance.put(url, data).then(function (response) {
            callback(response);
          });
          break;
        case 'DELETE':
          instance.delete(url, { params: data }).then(function (response) {
            callback(response);
          });
          break;
      }
    },
    isExpiredAuthMessage: function isExpiredAuthMessage(message) {
      if (!message || typeof message !== 'string') {
        return false;
      }
      var normalized = message.toLowerCase();
      return normalized === 'token has expired' || normalized === 'token not provided' || normalized === 'token signature could not be verified.' || normalized.includes('token has expired') || normalized.includes('token not provided') || normalized.includes('token signature could not be verified');
    },
    isExpiredAuthPayload: function isExpiredAuthPayload(payload) {
      var _this2 = this;

      if (!payload || (typeof payload === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(payload)) !== 'object') {
        return false;
      }
      var candidates = [payload.error, payload.message, payload.errors && payload.errors.error, payload.errors && payload.errors.message, payload.data && payload.data.error, payload.data && payload.data.message];
      return candidates.some(function (value) {
        return _this2.isExpiredAuthMessage(value);
      });
    },
    killExpiredSession: function killExpiredSession(responseOrError) {
      if (responseOrError && responseOrError.data && this.isExpiredAuthPayload(responseOrError.data)) {
        this.forceLogout();
        return true;
      }

      var axiosResponse = responseOrError && responseOrError.response;
      if (axiosResponse) {
        var status = axiosResponse.status;
        var body = axiosResponse.data;
        if (status === 401 || this.isExpiredAuthPayload(body)) {
          this.forceLogout();
          return true;
        }
      }

      if (this.isExpiredAuthPayload(responseOrError)) {
        this.forceLogout();
        return true;
      }

      return false;
    },
    apiRequest: function apiRequest() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/hello';
      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var _this3 = this;

      var callback = arguments[3];
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

      var authToken = '';
      if (data.token) {
        authToken = 'Bearer ' + data.token;
      } else {
        authToken = '';
      }
      var apiRequestHeader = {
        'Access-Control-Allow-Origin': '*',
        'Authorization': authToken
      };

      var instance = this.axios.create({
        baseURL: "https://gatewaydev.taptasty.com/",
        timeout: options.timeout || 90000,
        adapter: this.cacheAdapterEnhancer,
        headers: apiRequestHeader
      });

      instance.interceptors.request.use(function (config) {
        return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var interval = setInterval(function () {
            if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
              PENDING_REQUESTS++;
              clearInterval(interval);
              resolve(config);
            }
          }, INTERVAL_MS);
        });
      });

      instance.interceptors.response.use(function (response) {
        PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1);
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(response);
      }, function (error) {
        PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1);
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(error);
      });

      var cacheKey = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()({ url: url, method: method, data: data });
      if (window.appInstanceCache[cacheKey] && Date.now() - window.appInstanceCache[cacheKey].timestamp < CACHE_TIME_LIMIT) {
        callback(JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(window.appInstanceCache[cacheKey].response.data)));
        return;
      }

      var handleSuccess = function handleSuccess(response) {
        if (_this3.killExpiredSession(response)) {
          return;
        }
        if (method === 'GET' && data.with_cache) {
          window.appInstanceCache[cacheKey] = {
            response: JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(response)),
            timestamp: Date.now()
          };
        }
        callback(response.data);
      };

      var handleError = function handleError(error) {
        if (_this3.killExpiredSession(error)) {
          return;
        }
        callback({ status: false, error: error });
      };

      switch (method) {
        case 'GET':
          instance.get(url, { params: data }).then(handleSuccess, handleError).catch(handleError);
          break;
        case 'POST':
          instance.post(url, data).then(handleSuccess).catch(handleError);
          break;
        case 'PUT':
          instance.put(url, data).then(handleSuccess).catch(handleError);
          break;
        case 'DELETE':
          instance.delete(url, { params: data }).then(handleSuccess).catch(handleError);
          break;
      }
    },
    openDatabaseAndReadOrCreate: function openDatabaseAndReadOrCreate(dbName, version, storeName, $insert1Read0) {
      var self = this;

      var request = indexedDB.open(dbName, version);

      request.onupgradeneeded = function (event) {
        var db = event.target.result;

        console.log(db.objectStoreNames);
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: 'key' });
        }
      };

      request.onsuccess = function (event) {
        var db = event.target.result;
        if ($insert1Read0) {
          self.insertDefaultData(db, storeName);
        } else {
          var transaction = db.transaction([storeName], 'readonly');
          var objectStore = transaction.objectStore(storeName);

          var getAllRequest = objectStore.getAll();

          getAllRequest.onsuccess = function (event) {
            var records = event.target.result;
            var reconstructedObject = {};
            records.forEach(function (record) {
              reconstructedObject[record.key] = record.value;
            });
            window.appInstanceCache = reconstructedObject;
            console.log('getFromDb');
          };

          getAllRequest.onerror = function (event) {};

          transaction.oncomplete = function () {
            db.close();
          };
        }
      };

      request.onerror = function (event) {
        console.error('Database error:', event.target.error);
      };
    },
    insertDefaultData: function insertDefaultData(db, storeName) {
      var transaction = db.transaction([storeName], 'readwrite');
      var objectStore = transaction.objectStore(storeName);

      var defaultData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(window.appInstanceCache);

      defaultData.forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        var item = {
          key: key,
          value: value
        };

        var putRequest = objectStore.put(item);

        putRequest.onsuccess = function (event) {};

        putRequest.onerror = function (event) {};
      });

      transaction.oncomplete = function () {
        db.close();
        console.log('savedInDb');
      };
    },
    clearAppInstanceCache: function clearAppInstanceCache() {
      window.appInstanceCache = {};
      var companyID = this.$session.get('selectedCompany');
      if (!companyID) {
        return;
      }
      var databaseName = 'tapTasty_' + companyID;
      indexedDB.deleteDatabase(databaseName);
      window.cache_date = new Date();
      localStorage['tapTastyMenu_cache_date_' + companyID] = window.cache_date.toISOString();
    },
    ensureCompanyLocationFlags: function ensureCompanyLocationFlags(callback) {
      var _this4 = this;

      var sessionData = this.$session.get('selectedCompanyData') || {};
      if (sessionData.has_charisma_location !== undefined && sessionData.has_nexus_location !== undefined) {
        if (callback) {
          callback(sessionData);
        }
        return;
      }

      var companyId = this.$session.get('selectedCompany');
      if (!companyId) {
        if (callback) {
          callback(sessionData);
        }
        return;
      }

      this.apiRequest('/listdefaults', 'GET', {
        token: this.$session.get('token'),
        company_id: companyId
      }, function (response) {
        if (response.status === true && response.data && response.data[0]) {
          sessionData.has_charisma_location = !!response.data[0].has_charisma_location;
          sessionData.has_nexus_location = !!response.data[0].has_nexus_location;
          _this4.$session.set('selectedCompanyData', sessionData);
        }
        if (callback) {
          callback(sessionData);
        }
      });
    },
    buildCompanySessionData: function buildCompanySessionData(companyData, existingData) {
      if (!companyData) {
        return companyData;
      }

      var existing = existingData || this.$session.get('selectedCompanyData') || {};
      var companyFields = ['id', 'name', 'role', 'currency_iso', 'currency_display_format', 'time_format', 'date_format', 'timezone', 'delivery_options_labels', 'homepage', 'use_gestiune', 'use_dispatch', 'default_location_for_admin_order', 'is_allowed_sound_at_new', 'is_allowed_sound_at_processing', 'is_allowed_on_hold', 'is_allowed_postponed', 'automated_processed_status', 'edit_price', 'print_fiscal_from_dashboard', 'api_client_key', 'use_pos_id_per_product_option', 'use_quantity_per_product_option', 'sort_product_method', 'price_details', 'loyalty_in_use', 'use_marketing_gift_card', 'loyalty_store_in_use', 'loyalty_value_one_point', 'loyalty_value_one_point_amount', 'loyalty_value_one_currency', 'fidelities_labels_primary_option'];
      var locationFields = ['id', 'true_id', 'name', 'token', 'use_printer', 'drcarmen_active', 'auto_print', 'google_maps_api_key'];
      var preserveFields = ['payment_methods', 'administrations', 'compact_pos_list', 'locations_list', 'has_charisma_location', 'has_nexus_location', 'role'];

      var slim = {};
      for (var i = 0; i < companyFields.length; i++) {
        var key = companyFields[i];
        if (existing[key] !== undefined) {
          slim[key] = existing[key];
        }
      }
      for (var _i = 0; _i < companyFields.length; _i++) {
        var _key = companyFields[_i];
        if (companyData[_key] !== undefined) {
          slim[_key] = companyData[_key];
        }
      }

      if (Array.isArray(companyData.locations_details)) {
        slim.locations_details = companyData.locations_details.map(function (loc) {
          var out = {};
          for (var _i2 = 0; _i2 < locationFields.length; _i2++) {
            var _key2 = locationFields[_i2];
            if (loc[_key2] !== undefined) {
              out[_key2] = loc[_key2];
            }
          }
          out.ordering_management = Array.isArray(loc.ordering_management) ? loc.ordering_management.map(function (om) {
            return {
              id: om.id,
              type: om.type,
              default_waiting_time: om.default_waiting_time
            };
          }) : [];
          if (loc.table_management) {
            out.table_management = {
              qr_code: loc.table_management.qr_code,
              qr_link: loc.table_management.qr_link,
              type: loc.table_management.type,
              number: loc.table_management.number
            };
          }
          return out;
        });
      } else if (Array.isArray(existing.locations_details)) {
        slim.locations_details = existing.locations_details;
      }

      for (var _i3 = 0; _i3 < preserveFields.length; _i3++) {
        var _key3 = preserveFields[_i3];
        if (slim[_key3] === undefined && existing[_key3] !== undefined) {
          slim[_key3] = existing[_key3];
        }
      }

      return slim;
    },
    syncCompanySessionAndCache: function syncCompanySessionAndCache(companyData, callback) {
      var _this5 = this;

      var applyCompanyData = function applyCompanyData(data) {
        if (data) {
          _this5.$session.set('selectedCompanyData', _this5.buildCompanySessionData(data));
        }
        _this5.clearAppInstanceCache();
        if (callback) {
          callback(data);
        }
      };

      if (companyData) {
        applyCompanyData(companyData);
        return;
      }

      var companyID = this.$session.get('selectedCompany');
      if (!companyID) {
        this.clearAppInstanceCache();
        if (callback) {
          callback();
        }
        return;
      }

      this.apiRequest('/settings/general/' + companyID, 'GET', {
        token: this.$session.get('token')
      }, function (response) {
        if (response.status === true && response.data && response.data[0]) {
          applyCompanyData(response.data[0]);
        } else {
          _this5.clearAppInstanceCache();
          if (callback) {
            callback();
          }
        }
      });
    },
    logout: function logout() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
        text: this.$t('general.doYouWantToLogout'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this6.forceLogout();
        }
      }).catch(function () {});
    },
    forceLogout: function forceLogout() {
      this.$session.set('newOrders', 0);
      this.$session.set('processingOrders', 0);
      this.$session.destroy();
      this.$router.push('/login');
      this.$i18n.locale = 'en';
    },
    getCompanyDetail: function getCompanyDetail(key) {
      var companyDetails = this.$session.get('selectedCompanyData');

      switch (key) {
        case 'currency':
          return companyDetails.currency_iso;
        case 'currency_display_format':
          return companyDetails.currency_display_format;
        case 'time_format':
        case 'date_format':
        case 'delivery_options_labels':
        case 'locations_details':
          return companyDetails[key];
      }

      return '';
    },
    getUserAddress: function getUserAddress(addressDetails) {
      var address = '';
      if (addressDetails.street) {
        address = addressDetails.street;
      }

      if (addressDetails.number) {
        if (address) {
          address += ' ' + addressDetails.number;
        } else {
          address += addressDetails.number;
        }
      }

      if (addressDetails.apartment) {
        if (address) {
          address += ', ' + addressDetails.apartment;
        } else {
          address += addressDetails.apartment;
        }
      }

      if (addressDetails.city) {
        if (address) {
          address += ', ' + addressDetails.city;
        } else {
          address += addressDetails.city;
        }
      }

      if (addressDetails.state) {
        if (address) {
          address += ', ' + addressDetails.state;
        } else {
          address += addressDetails.state;
        }
      }

      return address;
    },
    getUserLabel: function getUserLabel(labels, amount, orders, labelingPrimaryOption) {
      if (!amount) {
        amount = 0;
      }
      var userLabel = '';
      var userColor = '';
      var maxAmount = 0;
      var maxOrders = 0;
      labels.forEach(function (label) {
        if (label.order_value <= amount && label.order_numbers <= orders) {
          if (labelingPrimaryOption === 'ordersValue') {
            if (maxAmount < label.order_value) {
              maxAmount = label.order_value;
              maxOrders = label.order_numbers;
              userColor = label.color;
              userLabel = label.name;
            } else if (maxAmount === label.order_value) {
              if (maxOrders < label.order_numbers) {
                maxAmount = label.order_value;
                maxOrders = label.order_numbers;
                userColor = label.color;
                userLabel = label.name;
              }
            }
          } else {
            if (maxOrders < label.order_numbers) {
              maxAmount = label.order_value;
              maxOrders = label.order_numbers;
              userColor = label.color;
              userLabel = label.name;
            } else if (maxOrders === label.order_numbers) {
              if (maxAmount < label.order_value) {
                maxAmount = label.order_value;
                maxOrders = label.order_numbers;
                userColor = label.color;
                userLabel = label.name;
              }
            }
          }
        }
      });
      if (userColor) {
        return '<span style="color: ' + userColor + '">' + userLabel + '</span>';
      } else {
        return userLabel;
      }
    },
    getLocalDateTimeString: function getLocalDateTimeString() {
      var now = new Date();
      var year = now.getFullYear();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      var hours = String(now.getHours()).padStart(2, '0');
      var minutes = String(now.getMinutes()).padStart(2, '0');
      return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
    },
    formatToCompanyTimezone: function formatToCompanyTimezone(utcString, timezone) {
      var date = new Date(utcString + 'Z');
      var formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      var parts = formatter.formatToParts(date);

      return parts.find(function (p) {
        return p.type === 'year';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'month';
      }).value + '-' + parts.find(function (p) {
        return p.type === 'day';
      }).value + ' ' + parts.find(function (p) {
        return p.type === 'hour';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'minute';
      }).value + ':' + parts.find(function (p) {
        return p.type === 'second';
      }).value;
    },
    getMesurementsUnits: function getMesurementsUnits() {
      var _this7 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.apiRequest('/measurements-units', 'GET', data, function (response) {
          if (response.status === true) {
            resolve(response.data);
          } else {
            resolve([]);
          }
        });
      });
    },
    formatMoneyAmount: function formatMoneyAmount(amount) {
      var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var removezero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (currency === '') {
        currency = this.getCompanyDetail('currency');
      }
      var position = this.getCurrencyPosition(currency);
      currency = this.getCurrencySymbol(currency);
      var space = ' ';

      if (amount === null) {
        amount = 0;
      }

      if (removezero && amount % 1 === 0) {
        amount = Math.abs(amount);
      }


      if (amount !== 0) {
        amount = parseFloat(amount);
        amount = amount.toFixed(2);
      }
      if (position === 'left') {
        return currency + amount;
      } else {
        return amount + space + currency;
      }
    },
    getTimeFormat: function getTimeFormat() {
      var format = this.getCompanyDetail('time_format');
      var formatTime = format !== '' ? format : 'H:mm';
      return formatTime;
    },
    formatTime: function formatTime(value) {
      if (value) {
        var format = this.getCompanyDetail('time_format');
        var formatTime = format !== '' ? format : 'H:mm';
        return __WEBPACK_IMPORTED_MODULE_12_moment___default()(String(value)).format(formatTime);
      }
    },
    formatDate: function formatDate(value) {
      if (value) {
        var format = this.getCompanyDetail('date_format');
        var formatDate = format !== '' ? format : 'DD/MM/YYYY';
        var m = __WEBPACK_IMPORTED_MODULE_12_moment___default()(String(this.normalizeDateValue(value)));
        if (!m.isValid()) {
          return '';
        }
        return m.format(formatDate);
      }
    },
    formatDateTime: function formatDateTime(value) {
      if (value) {
        var format1 = this.getCompanyDetail('time_format');
        var format2 = this.getCompanyDetail('date_format');
        var format = format1 + ' ' + format2;
        return __WEBPACK_IMPORTED_MODULE_12_moment___default()(String(this.normalizeDateValue(value))).format(format);
      }
    },
    normalizeDateValue: function normalizeDateValue(value) {
      if (value && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(value)) === 'object' && !Array.isArray(value) && value.date) {
        return value.date;
      }
      return value;
    },
    limitChars: function limitChars(text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
      } else {
        return text;
      }
    },
    getObjectByElemKeyValue: function getObjectByElemKeyValue(key, value, objects) {
      for (var index in objects) {
        if (objects[index][key] === value) {
          return index;
        }
      }
      return false;
    },
    getObjectByElemKeyValueBool: function getObjectByElemKeyValueBool(key, value, objects) {
      for (var index in objects) {
        if (objects[index][key] === value) {
          return true;
        }
      }
      return false;
    },
    isInObject: function isInObject(value, object) {
      for (var index in object) {
        if (parseInt(object[index]) === parseInt(value)) {
          return true;
        }
      }
      return false;
    },
    globalGoToRecord: function globalGoToRecord(row, event) {
      var column = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var baseUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      var blockedColumns = ['actions', 'active'];

      if (!column || !blockedColumns.includes(column.property)) {
        this.$router.push(baseUrl + row.id);
      }
    },
    defaultActionDef: function defaultActionDef() {
      return {
        show: false,
        colProps: {
          span: 0
        },
        def: []
      };
    },
    defaultSearchDef: function defaultSearchDef() {
      return {
        colProps: {
          span: 14
        }
      };
    },
    orderStatusClass: function orderStatusClass(type) {
      switch (type) {
        case 'DELIVERED':
          return 'success';
        case 'CANCELED':
          return 'danger';
        case 'NOT_DELIVERED':
          return 'danger';
        case 'NEW':
          return 'info';
        case 'ON_HOLD':
          return 'hold';
        case 'POSTPONED':
          return 'postponed';
        case 'PROCESSING':
          return 'warning';
        case 'AWAITING_TRANSPORT':
          return 'yellow';
        case 'PICKED_UP_BY_DELIVERY':
          return 'grey';
        case 'TRANSPORT':
          return 'blue';
        default:
          return 'primary';
      }
    },
    orderStatusButtonColor: function orderStatusButtonColor(type) {
      switch (type) {
        case 'DELIVERED':
          return '#7AC29A';
        case 'CANCELED':
          return '#EB5E28';
        case 'NOT_DELIVERED':
          return '#EB5E28';
        case 'OPEN_DRAFT':
          return '#5e35b1';
        case 'NEW':
          return '#68B3C8';
        case 'ON_HOLD':
          return '#8d5e27';
        case 'POSTPONED':
          return '#8d5e27';
        case 'PROCESSING':
          return '#F3BB45';
        case 'AWAITING_TRANSPORT':
          return '#ffc107';
        case 'PICKED_UP_BY_DELIVERY':
          return '#66615B';
        case 'TRANSPORT':
          return '#66615B';
        default:
          return '#5e35b1';
      }
    },
    orderStatusAllowed: function orderStatusAllowed(currentSts, otherSts) {
      switch (currentSts) {
        case 'NEW':
          if (otherSts === 'NEW' || otherSts === 'PROCESSING' || otherSts === 'CANCELED' || otherSts === 'ON_HOLD' || otherSts === 'POSTPONED') {
            return true;
          } else {
            return false;
          }
        case 'CANCELED':
          return false;
        default:
          return true;
      }
    },
    feedbackTypeClass: function feedbackTypeClass(type) {
      switch (type) {
        case 'feedback':
          return 'success';
        case 'issue':
          return 'danger';
        case 'suggestion':
          return 'warning';
        default:
          return 'info';
      }
    },
    getBase64: function getBase64(file) {
      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = function () {
          return resolve(reader.result);
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    fetchVats: function fetchVats(locationId) {
      var _this8 = this;

      var dataToSend = {
        company_id: this.companyID,
        token: this.$session.get('token'),
        location_id: locationId
      };

      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this8.apiRequest('/gestiune/locations-vats', 'GET', dataToSend, function (response) {
          if (!response || response.status !== true || !response.data || !response.data.tax) {
            __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
              title: 'Eroare!',
              text: response.message || 'Eroare la preluarea cotelor TVA.',
              icon: 'error',
              timer: 3000,
              showConfirmButton: false
            });
            resolve([]);
            return;
          }

          _this8.vats = response.data.tax;
          resolve(response.data.tax);
        });
      });
    },
    getCoutryStates: function getCoutryStates(country) {
      var countryArr = this.statesData.countries;
      var stateArr = this.statesData.states;
      var index = 0;
      var i = 0;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(countryArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var name = _step.value;

          i++;
          if (name === country) {
            index = i;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var states = stateArr[index].split('|');

      return states;
    },
    getDaysLeft: function getDaysLeft(date) {
      var date1 = new Date(date);
      var date2 = new Date();
      var timeDiff = date1.getTime() - date2.getTime();
      var diffDays = timeDiff / (1000 * 3600 * 24);

      return diffDays > 0 ? Math.ceil(diffDays) : 0;
    },
    isJSONString: function isJSONString(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    copyObject: function copyObject(o) {
      var output, v, key;
      output = {};
      for (key in o) {
        v = o[key];
        output[key] = (typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(v)) === 'object' ? this.copyObject(v) : v;
      }
      return output;
    },
    copyCompanyOptionValueWithoutIds: function copyCompanyOptionValueWithoutIds(o) {
      var output, v, key;
      output = [];
      for (key in o) {
        v = o[key];
        output[key] = (typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(v)) === 'object' ? this.copyObject(v) : v;

        delete output[key]['id'];
        delete output[key]['option_id'];
        if (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(output[key]['pos_id']) === 'object') {
          delete output[key]['pos_id'];
        }

        if (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(output[key]['vat_id']) === 'object') {
          delete output[key]['vat_id'];
        }
      }
      return output;
    },
    copyVar: function copyVar(o) {
      var output, v, key;
      output = Array.isArray(o) ? [] : {};
      for (key in o) {
        v = o[key];
        output[key] = (typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(v)) === 'object' ? this.copyVar(v) : v;
      }
      return output;
    },
    arrDiff: function arrDiff(a1, a2) {
      var a = [];
      var diff = [];
      for (var i = 0; i < a1.length; i++) {
        a[a1[i]] = true;
      }

      for (var _i4 = 0; _i4 < a2.length; _i4++) {
        if (a[a2[_i4]]) {
          delete a[a2[_i4]];
        } else {
          a[a2[_i4]] = true;
        }
      }

      for (var k in a) {
        diff.push(k);
      }

      return diff;
    },
    removeErrorByName: function removeErrorByName(name, errors) {
      var returnErr = [];
      if (errors.length) {
        for (var idx in errors) {
          if (errors[idx]['field'] !== name) {
            returnErr.push(errors[idx]);
          }
        }
      }
      return returnErr;
    },
    getAge: function getAge(birthdate) {
      var timestamp = Math.floor(new Date().getTime() / 1000);
      return Math.floor((timestamp - __WEBPACK_IMPORTED_MODULE_12_moment___default()(birthdate).format('X')) / 31556926);
    },
    getCurrencyPosition: function getCurrencyPosition(iso) {
      var currencies = this.$session.get('defaultData')['currencies'];
      var currency = this.getObjectByElemKeyValue('iso', iso, currencies);

      return currencies[currency]['symbol_position'] ? currencies[currency]['symbol_position'] : 'right';
    },
    getCurrencySymbol: function getCurrencySymbol(iso) {
      var currencies = this.$session.get('defaultData')['currencies'];
      var currency = this.getObjectByElemKeyValue('iso', iso, currencies);

      if (!currency) {
        return iso;
      }

      return currencies[currency]['symbol'] ? this.decodeHtml(currencies[currency]['symbol']) : iso;
    },
    decodeHtml: function decodeHtml(html) {
      var txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },
    getGestiuneApiBaseUrl: function getGestiuneApiBaseUrl() {
      return String("https://fiscal-dev.cdntaptasty.com" || '').replace(/\/$/, '') + ':4443';
    },
    normalizeAnafCui: function normalizeAnafCui(cui) {
      return String(cui || '').replace(/\D/g, '');
    },
    parseAnafCuiResponse: function parseAnafCuiResponse(payload) {
      var root = payload && payload.date_generale ? payload : (payload && payload.data && payload.data.date_generale ? payload.data : payload) || {};

      var general = root.date_generale || root;
      var hq = root.adresa_sediu_social || {};
      var fiscal = root.adresa_domiciliu_fiscal || {};
      var address = hq.sdenumire_Strada || hq.snumar_Strada ? hq : fiscal;

      var street = address.sdenumire_Strada || address.ddenumire_Strada || '';
      var streetNumber = address.snumar_Strada || address.dnumar_Strada || '';
      var city = address.sdenumire_Localitate || address.ddenumire_Localitate || '';
      var countyCode = address.scod_JudetAuto || address.dcod_JudetAuto || '';
      var countyName = address.sdenumire_Judet || address.ddenumire_Judet || '';
      var postalCode = address.scod_Postal || address.dcod_Postal || general.codPostal || '';

      var addressParts = [street, streetNumber, city, countyName].filter(Boolean);
      var fullAddress = general.adresa || addressParts.join(', ');

      return {
        cui: String(general.cui || ''),
        name: general.denumire || '',
        phone: general.telefon || '',
        fax: general.fax || '',
        registrationNumber: general.nrRegCom || '',
        iban: general.iban || '',
        address: fullAddress,
        street: street,
        streetNumber: streetNumber,
        city: city,
        countyCode: countyCode,
        countyName: countyName,
        postalCode: postalCode,
        countryCode: 'RO',
        isVatPayer: !!(root.inregistrare_scop_Tva && root.inregistrare_scop_Tva.scpTVA)
      };
    },
    fetchAnafCompanyByCui: function fetchAnafCompanyByCui(cui) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var normalizedCui, url, response, payload, message;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                normalizedCui = _this9.normalizeAnafCui(cui);

                if (normalizedCui) {
                  _context.next = 3;
                  break;
                }

                throw new Error('CUI lipsă sau invalid.');

              case 3:
                url = _this9.getGestiuneApiBaseUrl() + '/anaf/verifica-cui?cui=' + encodeURIComponent(normalizedCui);
                _context.next = 6;
                return fetch(url, {
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json' }
                });

              case 6:
                response = _context.sent;
                payload = null;
                _context.prev = 8;
                _context.next = 11;
                return response.json();

              case 11:
                payload = _context.sent;
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](8);

                payload = null;

              case 17:
                if (response.ok) {
                  _context.next = 20;
                  break;
                }

                message = payload && (payload.error || payload.message || payload.eroare) || (response.status === 404 ? 'CUI negăsit la ANAF.' : 'Verificarea CUI a eșuat.');
                throw new Error(message);

              case 20:
                return _context.abrupt('return', _this9.parseAnafCuiResponse(payload));

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9, [[8, 14]]);
      }))();
    },
    applyAnafCompanyToFields: function applyAnafCompanyToFields(company) {
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'invoiceClient';

      if (!company) return;

      if (target === 'invoiceClient') {
        if (company.name) this.clientName = company.name;
        if (company.phone) this.clientPhone = company.phone;
        this.clientCountryCode = company.countryCode || this.clientCountryCode || 'RO';
        if (company.countyCode) this.clientCountyCode = company.countyCode;
        if (company.city) this.clientCity = company.city;
        if (company.street) this.clientStreet = company.street;
        if (company.streetNumber) this.clientStreetNumber = company.streetNumber;
        if (company.postalCode) this.clientPostalCode = company.postalCode;
        return;
      }

      if (target === 'simpleClient') {
        if (company.name) this.clientName = company.name;
        if (company.phone) this.clientPhone = company.phone;
        if (company.address) this.clientAddress = company.address;
        return;
      }

      if (target === 'nomenclatorClient') {
        this.client = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.client, {
          companyName: company.name || this.client.companyName,
          CUI: company.cui || this.client.CUI,
          registrationNumber: company.registrationNumber || this.client.registrationNumber,
          address: company.address || this.client.address,
          city: company.city || this.client.city,
          countries: company.countryCode || this.client.countries || 'RO',
          IBAN: company.iban || this.client.IBAN
        });
        return;
      }

      if (target === 'nomenclatorSupplier') {
        this.supplier = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.supplier, {
          companyName: company.name || this.supplier.companyName,
          CUI: company.cui || this.supplier.CUI,
          registrationNumber: company.registrationNumber || this.supplier.registrationNumber,
          address: company.address || this.supplier.address,
          IBAN: company.iban || this.supplier.IBAN
        });
      }
    },
    orderTimeDelivery: function orderTimeDelivery() {
      var minutes = [5, 15, 30, 45, 60];
      return minutes;
    },
    weekDays: function weekDays() {
      return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    },
    getCompany: function getCompany() {
      var inactive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        inactive: inactive
      };

      var request = this.apiRequest('/company-data', 'GET', data);

      console.log(request);

      return request;
    },
    initAuditClient: function initAuditClient(options) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__services_audit__["a" /* initAuditClient */])(this, options);
    },
    trackAdminEvent: function trackAdminEvent(eventName, entityType, entityId, payload) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__services_audit__["b" /* trackAdminEvent */])(this, eventName, entityType, entityId, payload || {});
    },
    tableEntityKind: function tableEntityKind(modelType) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__services_audit__["c" /* tableEntityKind */])(this, modelType);
    }
  }
});

/***/ }),

/***/ "m1h4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Management_Nomenclator_ManagementClientsAdd_vue__ = __webpack_require__("QxJS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Management_ManagementSeriesAdd_vue__ = __webpack_require__("kgt7");


















var ROMANIA_COUNTRY_OPTIONS = [{ code: 'RO', name: 'România' }];

var ROMANIAN_COUNTIES = [{ code: 'AB', name: 'Alba' }, { code: 'AR', name: 'Arad' }, { code: 'AG', name: 'Argeș' }, { code: 'BC', name: 'Bacău' }, { code: 'BH', name: 'Bihor' }, { code: 'BN', name: 'Bistrița-Năsăud' }, { code: 'BT', name: 'Botoșani' }, { code: 'BR', name: 'Brăila' }, { code: 'BV', name: 'Brașov' }, { code: 'B', name: 'București' }, { code: 'BZ', name: 'Buzău' }, { code: 'CS', name: 'Caraș-Severin' }, { code: 'CL', name: 'Călărași' }, { code: 'CJ', name: 'Cluj' }, { code: 'CT', name: 'Constanța' }, { code: 'CV', name: 'Covasna' }, { code: 'DB', name: 'Dâmbovița' }, { code: 'DJ', name: 'Dolj' }, { code: 'GL', name: 'Galați' }, { code: 'GR', name: 'Giurgiu' }, { code: 'GJ', name: 'Gorj' }, { code: 'HR', name: 'Harghita' }, { code: 'HD', name: 'Hunedoara' }, { code: 'IL', name: 'Ialomița' }, { code: 'IS', name: 'Iași' }, { code: 'IF', name: 'Ilfov' }, { code: 'MM', name: 'Maramureș' }, { code: 'MH', name: 'Mehedinți' }, { code: 'MS', name: 'Mureș' }, { code: 'NT', name: 'Neamț' }, { code: 'OT', name: 'Olt' }, { code: 'PH', name: 'Prahova' }, { code: 'SM', name: 'Satu Mare' }, { code: 'SJ', name: 'Sălaj' }, { code: 'SB', name: 'Sibiu' }, { code: 'SV', name: 'Suceava' }, { code: 'TR', name: 'Teleorman' }, { code: 'TM', name: 'Timiș' }, { code: 'TL', name: 'Tulcea' }, { code: 'VS', name: 'Vaslui' }, { code: 'VL', name: 'Vâlcea' }, { code: 'VN', name: 'Vrancea' }];

var BUCHAREST_SECTORS = [{ code: 'SECTOR1', name: 'Sector 1' }, { code: 'SECTOR2', name: 'Sector 2' }, { code: 'SECTOR3', name: 'Sector 3' }, { code: 'SECTOR4', name: 'Sector 4' }, { code: 'SECTOR5', name: 'Sector 5' }, { code: 'SECTOR6', name: 'Sector 6' }];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementClientsAdd: __WEBPACK_IMPORTED_MODULE_13__Management_Nomenclator_ManagementClientsAdd_vue__["a" /* default */],
    ManagementSeriesAdd: __WEBPACK_IMPORTED_MODULE_14__Management_ManagementSeriesAdd_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isInvoice: false,
      loading: false,
      loadingProducts: false,
      selectedLocationId: '',
      selectedLocation: null,
      romaniaCountryOptions: ROMANIA_COUNTRY_OPTIONS,
      romanianCounties: ROMANIAN_COUNTIES,
      bucharestSectors: BUCHAREST_SECTORS,
      invoiceCountryCode: 'RO',
      invoiceCountyCode: '',
      invoiceCity: '',
      invoiceStreet: '',
      invoiceStreetNumber: '',
      invoiceVATPayer: 'no',
      searchTerm: '',
      linkedOrderId: null,
      orderDate: '',
      orderNumber: '',
      bonData: '',
      bonNumber: '',
      bonNota: '',
      paymentType: '',
      currentNumber: '',
      clientName: '',
      clientCUI: '',
      clientEmail: '',
      clientPhone: '',
      clientCountryCode: 'RO',
      clientCountyCode: '',
      clientCity: '',
      clientStreet: '',
      clientStreetNumber: '',
      clientPostalCode: '',
      clientVATPayer: 'yes',
      clientLegalStatus: 'juridica_ro',
      issueDate: this.getLocalDateTimeString(),
      dueDate: this.getLocalDateTimeString(),
      seriesNumber: '',
      currency: 'RON',
      language: 'ro',
      productName: '',
      clientSelected: null,
      clientResults: [],
      quantity: 0,
      priceRON: 0,
      vatRate: 0,
      includeVAT: 'no',
      vatNumber: null,
      isDisabled: false,
      searchResults: [],
      items: [],
      isEdit: false,
      isStorno: false,
      gestiuneOptions: [],
      descarcaGestiunea: false,
      isEditMode: false,
      vats: [],
      newItem: {
        gestiuneId: null,
        productName: '',
        unitMeasure: 'buc',
        quantity: 1,
        priceRON: null,
        vatRate: '',
        includeVAT: 'no',
        type: '',
        code: ''
      },
      fetchClientsCalled: false,
      modelValidate: {
        clientCUI: { required: true },
        clientName: { required: true },
        productName: { required: true },
        unitMeasure: { required: true },
        clientPhone: { required: true },
        quantity: { required: true },
        priceRON: { required: true },
        vatRate: { required: true },
        includeVAT: { required: true }
      },
      locations: [],
      extraFields: {
        intocmitDe: '',
        cnp: '',
        delegat: '',
        carteIdentitate: '',
        auto: '',
        agentVanzari: '',
        punctDeLucruClient: '',
        numarComandaBT13: '',
        numarContractBT12: '',
        referintaProiectBT11: '',
        identificatorCumparatorBT46: '',
        numarAvizReceptieBT15: '',
        referintaContabilaCumparatorBT19: '',
        dataLivrarii: '',
        dataIncasarii: '',
        observatiiFactura: '',
        notaInterna: ''
      },
      seriesOptions: [],
      gestiuniList: [],
      apiClientKey: this.$session.get('selectedCompanyData')['api_client_key']
    };
  },

  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    today: function today() {
      var now = new Date();
      now.setSeconds(0, 0);
      return now.toISOString().slice(0, 16);
    },
    seriesOptionsWithAdd: function seriesOptionsWithAdd() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(this.seriesOptions), [{ id: 'add', nume: '➕ Adaugă serie' }]);
    },
    totalTva: function totalTva() {
      return this.items.reduce(function (acc, item) {
        return acc + (Number(item.tva) || 0);
      }, 0);
    },
    totalFaraTva: function totalFaraTva() {
      return this.items.reduce(function (acc, item) {
        var valoare = Number(item.valoare);
        var tva = Number(item.tva) || 0;
        if (__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_is_finite___default()(valoare)) {
          return acc + (valoare - tva);
        }

        var qty = Number(item.quantity) || 0;
        var priceNoVAT = Number(item.priceRON) || 0;
        return acc + priceNoVAT * qty;
      }, 0);
    },
    totalCorectie: function totalCorectie() {
      return 0;
    },
    totalFinal: function totalFinal() {
      return this.totalFaraTva + this.totalTva + this.totalCorectie;
    },
    groupedLocations: function groupedLocations() {
      var groups = {};

      if (!this.locations || !this.locations.length) return [];

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocationId) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocationId;
      });
      console.log('🚀 filteredGestiuni:', result);
      return result;
    },
    hasOrderInfo: function hasOrderInfo() {
      return !!(this.orderDate || this.orderNumber || this.bonData || this.bonNumber);
    },
    isClientBucharest: function isClientBucharest() {
      return this.clientCountyCode === 'B';
    },
    hasNexusLocation: function hasNexusLocation() {
      var defaultData = this.$session.get('defaultData') || {};
      return !!defaultData.has_nexus_location;
    },
    nexusOrderId: function nexusOrderId() {
      return String(this.orderNumber || this.searchTerm || '').trim();
    },
    showNexusActions: function showNexusActions() {
      return this.hasNexusLocation && !!this.nexusOrderId;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
    var path = this.route.path;

    var id = this.route && this.route.params && this.route.params.id;
    if (id) {
      var parts = id.split('-');
      if (parts.length === 2) {
        this.series = parts[0];
        this.invoiceNumber = parts[1];

        this.isStorno = path.includes('storno');
        this.isEdit = path.includes('edit');
        this.isEditMode = this.isEdit;

        if (this.isStorno) {
          this.issueDate = '';
          this.dueDate = '';
        }
      } else {
        console.error('Invalid invoice ID format:', id);
      }
    }

    this.fetchGestiuni();
    this.fetchLocation();
  },

  watch: {
    selectedLocationId: function selectedLocationId(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;
            if (!this.isEditMode && !this.isStorno && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code);

              this.loadVats(loc.true_id);
            }

            if (!this.isEditMode && !this.isStorno) {
              this.applySupplierDetailsFromLocation(loc);
              this.syncBonNotaField();
            }

            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    locations: function locations(newLocations) {
      if (newLocations && newLocations.length) {
        var _route$query = this.route.query,
            series = _route$query.series,
            number = _route$query.number,
            isInvoice = _route$query.isInvoice;

        this.isInvoice = isInvoice === 'true' || isInvoice === true;

        if (this.isInvoice) {
          this.fetchOrder(series, number);
        }

        var invoiceId = this.route && this.route.params && this.route.params.id;
        if (invoiceId) {
          this.getInvoiceDetails(invoiceId);
        }
      }
    },
    clientCountyCode: function clientCountyCode(newCode, oldCode) {
      if (newCode === oldCode) return;

      if (newCode === 'B') {
        var normalized = this.normalizeBucharestSector(this.clientCity);
        this.clientCity = this.isValidBucharestSector(normalized) ? normalized : '';
        return;
      }

      if (oldCode === 'B' && this.isValidBucharestSector(this.clientCity)) {
        this.clientCity = '';
      }
    },
    clientCUI: function clientCUI(newCUI) {
      if (this.isEdit || this.isStorno || this.isInvoice) {
        return;
      }

      if (this.fetchClientsCalled) return;

      if (newCUI.length >= 8) {
        this.fetchCompanyDetails(newCUI);
      }
    }
  },
  methods: {
    getInvoiceValidationErrors: function getInvoiceValidationErrors() {
      var errors = [];

      if (!this.selectedLocationId || !this.selectedLocation) {
        errors.push('Locația');
      }
      if (!this.seriesNumber) {
        errors.push('Seria facturii');
      }
      if (this.isStorno && !this.issueDate) {
        errors.push('Data Emiterii');
      }
      if (this.isStorno && !this.dueDate) {
        errors.push('Termen de Plată');
      }
      if (!this.currency) {
        errors.push('Moneda');
      }
      if (!String(this.clientName || '').trim()) {
        errors.push('Numele clientului');
      }
      if (!String(this.clientCUI || '').trim()) {
        errors.push('CUI/CNP client');
      }
      if (!String(this.clientPhone || '').trim()) {
        errors.push('Telefon client');
      }
      if (!this.clientCountyCode) {
        errors.push('Județ client');
      }
      if (!String(this.clientCity || '').trim()) {
        errors.push(this.isClientBucharest ? 'Sector client' : 'Oraș client');
      } else if (this.isClientBucharest && !this.isValidBucharestSector(this.clientCity)) {
        errors.push('Sector client');
      }
      if (!String(this.clientStreet || '').trim()) {
        errors.push('Strada client');
      }
      if (!String(this.clientStreetNumber || '').trim()) {
        errors.push('Număr stradă client');
      }
      if (!this.items || !this.items.length) {
        errors.push('Cel puțin un produs');
      }

      return errors;
    },
    showInvoiceValidationErrors: function showInvoiceValidationErrors(errors) {
      var text = errors.length === 1 ? 'Completa\u021Bi c\xE2mpul obligatoriu: ' + errors[0] + '.' : 'Completa\u021Bi c\xE2mpurile obligatorii: ' + errors.join(', ') + '.';

      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        title: 'Eroare',
        text: text,
        type: 'error',
        timer: errors.length > 1 ? 4500 : 2500,
        showConfirmButton: false
      });
    },
    validate: function validate() {
      var errors = this.getInvoiceValidationErrors();
      if (errors.length) {
        this.showInvoiceValidationErrors(errors);
        return;
      }

      this.saveInvoice();
    },
    isLocationVatPayer: function isLocationVatPayer(value) {
      return value === 1 || value === '1' || value === true;
    },
    applySupplierDetailsFromCompany: function applySupplierDetailsFromCompany(company) {
      if (!company || (typeof company === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(company)) !== 'object') return;

      var rawCountry = String(company.country || 'RO').trim().toUpperCase();
      if (this.romaniaCountryOptions.some(function (item) {
        return item.code === rawCountry;
      })) {
        this.invoiceCountryCode = rawCountry;
      } else {
        this.invoiceCountryCode = 'RO';
      }

      this.invoiceCountyCode = this.resolveCountyCode(company.state) || String(company.state || '').trim().toUpperCase() || '';
      this.invoiceCity = company.city || '';
      this.invoiceStreet = company.street || '';
      this.invoiceStreetNumber = company.numberAddress || '';
      this.invoiceVATPayer = company.isVatPayer === 1 || company.isVatPayer === true ? 'yes' : 'no';
    },
    applySupplierDetailsFromLocation: function applySupplierDetailsFromLocation(location) {
      if (!location || (typeof location === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(location)) !== 'object') return;

      var country = location.inv_country || location.country;
      if (country) {
        var rawCountry = String(country).trim().toUpperCase();
        if (this.romaniaCountryOptions.some(function (item) {
          return item.code === rawCountry;
        })) {
          this.invoiceCountryCode = rawCountry;
        }
      }

      var county = location.inv_county || location.state;
      if (county) {
        this.invoiceCountyCode = this.resolveCountyCode(county) || String(county).trim().toUpperCase();
      }

      if (location.inv_city || location.city) {
        this.invoiceCity = location.inv_city || location.city;
      }

      if (location.inv_address || location.street) {
        this.invoiceStreet = location.inv_address || location.street;
      }

      var streetNumber = location.inv_street_number || location.number;
      if (streetNumber) {
        this.invoiceStreetNumber = streetNumber;
      }

      this.invoiceVATPayer = this.isLocationVatPayer(location.inv_is_vat_payer) ? 'yes' : 'no';
    },
    buildCompanyPayload: function buildCompanyPayload() {
      var location = this.selectedLocation || {};
      var countyCode = this.invoiceCountyCode || this.resolveCountyCode(location.state || location.inv_county || '');
      var countyName = this.getCountyName(countyCode);
      var city = this.invoiceCity || location.inv_city || location.city || '';
      var street = this.invoiceStreet || location.street || location.inv_address || '';
      var streetNumber = this.invoiceStreetNumber || location.inv_street_number || location.number || '';
      var addressParts = [street, streetNumber, city, countyName].filter(Boolean);

      var payload = {
        name: location.inv_company_name || location.name,
        vatNumber: location.inv_fiscal_code,
        address: addressParts.join(' '),
        street: street,
        city: city,
        country: this.invoiceCountryCode || 'RO',
        state: countyCode,
        numberAddress: streetNumber,
        isVatPayer: (this.invoiceVATPayer || (this.isLocationVatPayer(location.inv_is_vat_payer) ? 'yes' : 'no')) === 'yes' ? 1 : 0,
        phone: location.inv_phone,
        externalCompanyId: this.companyID
      };

      if (location.inv_bank_account) {
        payload.inv_bank_account = location.inv_bank_account;
      }
      if (location.inv_bank) {
        payload.inv_bank = location.inv_bank;
      }
      if (location.inv_bank_branch) {
        payload.inv_bank_branch = location.inv_bank_branch;
      }

      return payload;
    },
    getCountyName: function getCountyName(code) {
      var county = this.romanianCounties.find(function (item) {
        return item.code === code;
      });
      return county ? county.name : code;
    },
    normalizeBucharestSector: function normalizeBucharestSector(value) {
      var raw = String(value || '').trim().toUpperCase().replace(/\s+/g, '');
      if (/^SECTOR[1-6]$/.test(raw)) return raw;

      var match = String(value || '').trim().match(/^sector\s*([1-6])$/i);
      if (match) return 'SECTOR' + match[1];

      return String(value || '').trim();
    },
    isValidBucharestSector: function isValidBucharestSector(value) {
      return this.bucharestSectors.some(function (sector) {
        return sector.code === value;
      });
    },
    normalizeCountyName: function normalizeCountyName(name) {
      return String(name || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
    resolveCountyCode: function resolveCountyCode(value) {
      var _this2 = this;

      if (!value) return '';

      var trimmed = String(value).trim();
      var byCode = this.romanianCounties.find(function (item) {
        return item.code === trimmed.toUpperCase();
      });
      if (byCode) return byCode.code;

      var normalized = this.normalizeCountyName(trimmed);
      var byName = this.romanianCounties.find(function (item) {
        return _this2.normalizeCountyName(item.name) === normalized;
      });
      return byName ? byName.code : '';
    },
    saveCompany: function saveCompany() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/company?externalCompanyId=' + encodeURIComponent(_this3.companyID);
                _context.next = 3;
                return fetch(url, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this3.buildCompanyPayload())
                });

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.json();

              case 6:
                data = _context.sent;

                if (response.ok) {
                  _context.next = 9;
                  break;
                }

                throw new Error(data.error || data.message || 'Nu s-a putut salva compania.');

              case 9:
                return _context.abrupt('return', data);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    loadVats: function loadVats(locationId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.fetchVats(locationId);

              case 2:
                _this4.vats = _context2.sent;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    onClientSelect: function onClientSelect(client) {
      if (client && client.id === 'add') {
        this.openAddClientModal();
        this.clientSelected = null;
        this.clientName = '';
        this.clientCUI = '';
        this.clientEmail = '';
        this.clientPhone = '';
        this.clientCountryCode = 'RO';
        this.clientCountyCode = '';
        this.clientCity = '';
        this.clientStreet = '';
        this.clientStreetNumber = '';
        this.clientPostalCode = '';
      } else if (client) {
        this.clientSelected = client;

        this.clientName = client.fullData.name || '';
        this.clientCUI = client.fullData.vatNumber || client.vatNumber || '';
        this.clientEmail = client.fullData.email || '';
        this.clientPhone = client.fullData.phone || '';
        var address = typeof client.fullData.address === 'string' ? client.fullData.address.trim() : '';
        var country = String(client.fullData.country || '').trim().toUpperCase();
        this.clientCountryCode = this.romaniaCountryOptions.some(function (item) {
          return item.code === country;
        }) ? country : 'RO';
        this.clientCountyCode = this.resolveCountyCode(client.fullData.county) || String(client.fullData.county || '').trim().toUpperCase();
        this.clientCity = this.clientCountyCode === 'B' ? this.normalizeBucharestSector(client.fullData.city) : client.fullData.city || '';
        this.clientStreet = address || client.fullData.street || '';
        this.clientStreetNumber = client.fullData.streetNumber || '';
        this.clientPostalCode = client.fullData.postalCode || '';
      } else {
        this.clientSelected = null;
        this.clientName = '';
        this.clientCUI = '';
        this.clientEmail = '';
        this.clientPhone = '';
        this.clientCountryCode = 'RO';
        this.clientCountyCode = '';
        this.clientCity = '';
        this.clientStreet = '';
        this.clientStreetNumber = '';
        this.clientPostalCode = '';
      }
    },
    openAddClientModal: function openAddClientModal() {
      this.client = {
        companyName: '',
        abbreviation: '',
        CUI: '',
        email: '',
        registrationNumber: '',
        address: '',
        bank: '',
        IBAN: '',
        dueDays: null,
        id: null,
        _rev: null
      };
      this.$modal.show('addClientModal');
    },
    openSeriesModal: function openSeriesModal() {
      this.$modal.show('addSeriesModal');
    },
    fetchClients: function fetchClients(query) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var vatNumber, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.fetchClientsCalled = true;

                vatNumber = _this5.selectedLocation && _this5.selectedLocation.inv_fiscal_code;


                _this5.loading = true;
                _context3.prev = 3;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/customers' + ('?name=' + encodeURIComponent(query)) + ('&externalCompanyId=' + _this5.companyID) + (vatNumber ? '&vatNumber=' + encodeURIComponent(vatNumber) : '');
                _context3.next = 7;
                return fetch(url);

              case 7:
                response = _context3.sent;
                _context3.next = 10;
                return response.json();

              case 10:
                data = _context3.sent;


                if (Array.isArray(data.customers)) {
                  _this5.clientResults = [].concat(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(data.customers.map(function (client) {
                    return {
                      id: client._id,
                      nume: client.name,
                      vatNumber: client.vatNumber,
                      fullData: client
                    };
                  })), [{ id: 'add', nume: '➕ Adaugă client' }]);
                } else {
                  _this5.clientResults = [{ id: 'add', nume: '➕ Adaugă client' }];
                }
                _context3.next = 18;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3['catch'](3);

                console.error('Error fetching clients:', _context3.t0);
                _this5.clientResults = [{ id: 'add', nume: '➕ Adaugă client' }];

              case 18:
                _context3.prev = 18;

                _this5.loading = false;
                return _context3.finish(18);

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[3, 14, 18, 21]]);
      }))();
    },
    fetchLocation: function fetchLocation() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dataToSend = {
                  company_id: _this6.companyID,
                  token: _this6.$session.get('token')
                };


                _this6.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this6.locations = response.data.locations;
                });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    fetchOrder: function fetchOrder(series, number) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/order?series=' + series + '&number=' + number + '&externalCompanyId=' + _this7.companyID);

              case 3:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 6;
                  break;
                }

                throw new Error('Eroare la fetch order: ' + response.status);

              case 6:
                _context5.next = 8;
                return response.json();

              case 8:
                data = _context5.sent;


                if (data) {
                  _this7.myOrder = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data);

                  if (data.externalLocationId) {
                    _this7.selectedLocationId = data.externalLocationId;
                  }

                  _this7.items = data.products.map(function (item) {
                    var quantity = item.quantity_faptic || item.quantity_scriptic || 0;
                    var priceRON = item.pret_fara_tva || 0;
                    var vatRate = item.tva_percent != null ? item.tva_percent : 19;
                    var includeVAT = vatRate > 0 ? 'yes' : 'no';

                    var priceFaraTVA = priceRON;
                    var tvaUnit = priceFaraTVA * vatRate / 100;

                    var totalFaraTVA = priceFaraTVA * quantity;
                    var totalTVA = tvaUnit * quantity;

                    return {
                      posId: item.posId,
                      productName: item.productName || '',
                      type: item.type || 'N/A',
                      code: item.code || 'N/A',
                      unitMeasure: item.unitMeasure || 'BUC',
                      quantity: quantity,
                      priceRON: (priceFaraTVA + tvaUnit).toFixed(2),
                      priceRON_gestiune: priceFaraTVA + tvaUnit,
                      vatRate: String(vatRate),
                      includeVAT: includeVAT,
                      gestiuneFrom: item.gestiune,
                      priceFaraTVA: priceFaraTVA.toFixed(2),
                      valoare: (totalFaraTVA + totalTVA).toFixed(2),
                      tva: totalTVA.toFixed(2)
                    };
                  });

                  if (_this7.locations && _this7.locations.length) {
                    _this7.populateClientFromLocation();
                  }
                } else {
                  console.error('Comandă invalidă primită:', data);
                  __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                    title: 'Eroare',
                    text: 'Comanda nu a fost găsită.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](0);

                console.error('Eroare la fetch order:', _context5.t0);
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o problemă la încărcarea comenzii.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 12]]);
      }))();
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    parseDateTimeLocal: function parseDateTimeLocal(dateString) {
      if (!dateString) return '';
      var d = new Date(dateString);
      var yyyy = d.getFullYear();
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var dd = String(d.getDate()).padStart(2, '0');
      var hh = String(d.getHours()).padStart(2, '0');
      var min = String(d.getMinutes()).padStart(2, '0');
      return yyyy + '-' + mm + '-' + dd + 'T' + hh + ':' + min;
    },
    formatPaymentTypeLabel: function formatPaymentTypeLabel(paymentType) {
      if (!paymentType) return '';

      var key = 'paymentTypes.' + paymentType;
      var translated = this.$t(key);
      return translated !== key ? translated : paymentType;
    },
    applyOrderInfoFromApi: function applyOrderInfoFromApi(orderData) {
      if (!orderData) return;

      this.orderDate = orderData.created_at_converted || '';
      this.orderNumber = orderData.id != null ? String(orderData.id) : '';
      this.bonData = orderData.fiscal_date_gmt || '';

      var fiscalNr = orderData.fiscal_nr;
      var fiscalNrz = orderData.fiscal_nrz;
      if (fiscalNr != null || fiscalNrz != null) {
        this.bonNumber = 'NR: ' + (fiscalNr != null ? fiscalNr : '-') + ' Z: ' + (fiscalNrz != null ? fiscalNrz : '-');
      } else {
        this.bonNumber = '';
      }

      this.paymentType = orderData.payment_type || orderData.paymentType || '';
      this.syncBonNotaField();
    },
    parseBonNumberParts: function parseBonNumberParts(bonNumber) {
      var match = String(bonNumber || '').match(/NR[:\s]*([^Z]+?)\s*Z[:\s]*(\S+)/i);
      if (!match) {
        return { nr: '', z: '' };
      }

      return {
        nr: match[1].trim(),
        z: match[2].trim()
      };
    },
    formatDateTimeForDisplay: function formatDateTimeForDisplay(value) {
      if (!value) return '';

      var normalized = String(value).trim().replace(' ', 'T');
      var date = new Date(normalized);

      if (!isNaN(date.getTime())) {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();
        var hh = String(date.getHours()).padStart(2, '0');
        var min = String(date.getMinutes()).padStart(2, '0');
        return dd + '.' + mm + '.' + yyyy + ', ' + hh + ':' + min;
      }

      return String(value).trim();
    },
    parseOrderInfoFromObservatiiText: function parseOrderInfoFromObservatiiText(text) {
      if (!text) return null;

      var value = String(text).trim();
      if (!value) return null;

      try {
        var parsed = JSON.parse(value);
        if (parsed && (typeof parsed === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(parsed)) === 'object') {
          var hasOrderInfo = !!(parsed.orderDate || parsed.orderNumber || parsed.bonData || parsed.bonNumber);

          if (hasOrderInfo) {
            return {
              orderDate: parsed.orderDate || '',
              orderNumber: parsed.orderNumber != null ? String(parsed.orderNumber) : '',
              bonData: parsed.bonData || '',
              bonNumber: parsed.bonNumber || '',
              note: parsed.note || ''
            };
          }
        }
      } catch (e) {}

      var orderMatch = value.match(/Comand[aă]\s+nr\.\s*(\d+)\s+din\s+([^\n.]+)/i);
      var bonMatch = value.match(/Bon fiscal\s+NR\s*([^/]+)\s*\/\s*Z\s*(\S+)\s+din\s+([^\n.]+)/i);

      if (!orderMatch && !bonMatch) return null;

      var note = value;
      note = note.replace(/Comand[aă]\s+nr\.\s*\d+\s+din\s+[^\n.]+\.?\s*/i, '');
      note = note.replace(/Bon fiscal\s+NR\s*[^/]+\s*\/\s*Z\s*\S+\s+din\s+[^\n.]+\.?\s*/i, '');
      note = note.replace(/^\s+|\s+$/g, '');

      return {
        orderDate: orderMatch ? orderMatch[2].trim() : '',
        orderNumber: orderMatch ? String(orderMatch[1]) : '',
        bonData: bonMatch ? bonMatch[3].trim() : '',
        bonNumber: bonMatch ? 'NR: ' + bonMatch[1].trim() + ' Z: ' + bonMatch[2].trim() : '',
        note: note
      };
    },
    getLocationInvAdditionalData: function getLocationInvAdditionalData() {
      var location = this.selectedLocation;
      if (!location || !location.inv_additional_data) return '';
      return String(location.inv_additional_data).trim();
    },
    buildBonNotaText: function buildBonNotaText() {
      var lines = [];

      if (this.orderNumber || this.orderDate) {
        var orderParts = [];
        if (this.orderNumber) orderParts.push('nr. ' + this.orderNumber);
        if (this.orderDate) {
          orderParts.push('din ' + this.formatDateTimeForDisplay(this.orderDate));
        }
        lines.push('Comand\u0103 ' + orderParts.join(' ') + '.');
      }

      if (this.bonNumber || this.bonData) {
        var _parseBonNumberParts = this.parseBonNumberParts(this.bonNumber),
            nr = _parseBonNumberParts.nr,
            z = _parseBonNumberParts.z;

        var bonParts = [];
        if (nr || z) {
          bonParts.push('NR ' + (nr || '-') + ' / Z ' + (z || '-'));
        }
        if (this.bonData) {
          bonParts.push('din ' + this.formatDateTimeForDisplay(this.bonData));
        }
        lines.push('Bon fiscal ' + bonParts.join(' ') + '.');
      }

      if (this.paymentType) {
        lines.push('Plat\u0103: ' + this.formatPaymentTypeLabel(this.paymentType) + '.');
      }

      var additionalData = this.getLocationInvAdditionalData();
      if (additionalData) {
        lines.push(additionalData);
      }

      return lines.join('\n');
    },
    buildBonNotaTextFromParsed: function buildBonNotaTextFromParsed(parsed) {
      if (!parsed) return '';

      var lines = [];

      if (parsed.orderNumber || parsed.orderDate) {
        var orderParts = [];
        if (parsed.orderNumber) orderParts.push('nr. ' + parsed.orderNumber);
        if (parsed.orderDate) {
          orderParts.push('din ' + this.formatDateTimeForDisplay(parsed.orderDate));
        }
        lines.push('Comand\u0103 ' + orderParts.join(' ') + '.');
      }

      if (parsed.bonNumber || parsed.bonData) {
        var _parseBonNumberParts2 = this.parseBonNumberParts(parsed.bonNumber),
            nr = _parseBonNumberParts2.nr,
            z = _parseBonNumberParts2.z;

        var bonParts = [];
        if (nr || z) {
          bonParts.push('NR ' + (nr || '-') + ' / Z ' + (z || '-'));
        }
        if (parsed.bonData) {
          bonParts.push('din ' + this.formatDateTimeForDisplay(parsed.bonData));
        }
        lines.push('Bon fiscal ' + bonParts.join(' ') + '.');
      }

      var additionalData = this.getLocationInvAdditionalData();
      if (additionalData) {
        lines.push(additionalData);
      }

      return lines.join('\n');
    },
    syncBonNotaField: function syncBonNotaField() {
      var text = this.buildBonNotaText();
      if (text) {
        this.bonNota = text;
      }
    },
    buildobservatiiFacturaText: function buildobservatiiFacturaText() {
      return this.buildBonNotaText();
    },
    buildobservatiiFacturaTextFromParsed: function buildobservatiiFacturaTextFromParsed(parsed) {
      return this.buildBonNotaTextFromParsed(parsed);
    },
    syncobservatiiFacturaField: function syncobservatiiFacturaField() {
      this.syncBonNotaField();
    },
    parseOrderInfoFromNotaInterna: function parseOrderInfoFromNotaInterna(notaInterna) {
      return this.parseOrderInfoFromObservatiiText(notaInterna);
    },
    buildOrderInfoNotaInternaForSave: function buildOrderInfoNotaInternaForSave() {
      return this.buildBonNotaText();
    },
    loadOrderInfoFromInvoice: function loadOrderInfoFromInvoice(data) {
      var extraFieldsMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.paymentType = data.paymentType || data.payment_type || extraFieldsMap.paymentType || extraFieldsMap.payment_type || '';

      var parsed = null;

      if (data.orderDate || data.orderNumber || data.bonData || data.bonNumber) {
        this.orderDate = data.orderDate || '';
        this.orderNumber = data.orderNumber != null ? String(data.orderNumber) : '';
        this.bonData = data.bonData || '';
        this.bonNumber = data.bonNumber || '';
        parsed = {
          orderDate: this.orderDate,
          orderNumber: this.orderNumber,
          bonData: this.bonData,
          bonNumber: this.bonNumber
        };
      }

      if (data.bonNota) {
        this.bonNota = data.bonNota;
        parsed = parsed || this.parseOrderInfoFromObservatiiText(data.bonNota);
      } else if (!this.bonNota && parsed) {
        this.bonNota = this.buildBonNotaText();
      }

      if (!parsed && extraFieldsMap.observatiiFactura) {
        this.bonNota = extraFieldsMap.observatiiFactura;
        parsed = this.parseOrderInfoFromObservatiiText(extraFieldsMap.observatiiFactura);
      }

      if (!parsed && extraFieldsMap.observatiiComanda) {
        this.bonNota = extraFieldsMap.observatiiComanda;
        parsed = this.parseOrderInfoFromObservatiiText(extraFieldsMap.observatiiComanda);
      }

      if (!parsed && extraFieldsMap.notaInterna) {
        parsed = this.parseOrderInfoFromObservatiiText(extraFieldsMap.notaInterna);
        if (parsed) {
          this.bonNota = this.buildBonNotaTextFromParsed(parsed);
          if (parsed.note) {
            this.extraFields.notaInterna = parsed.note;
          }
        }
      }

      if (parsed && !(data.orderDate || data.orderNumber || data.bonData || data.bonNumber)) {
        this.orderDate = parsed.orderDate;
        this.orderNumber = parsed.orderNumber;
        this.bonData = parsed.bonData;
        this.bonNumber = parsed.bonNumber;
      } else if (!parsed) {
        this.orderDate = data.orderDate || extraFieldsMap.orderDate || '';
        this.orderNumber = data.orderNumber != null ? String(data.orderNumber) : extraFieldsMap.orderNumber || '';
        this.bonData = data.bonData || extraFieldsMap.bonData || '';
        this.bonNumber = data.bonNumber || extraFieldsMap.bonNumber || '';
        if (!this.bonNota && this.hasOrderInfo) {
          this.bonNota = this.buildBonNotaText();
        }
      }

      if (this.orderNumber) {
        this.searchTerm = String(this.orderNumber);
      }
    },
    getInvoiceDetails: function getInvoiceDetails(invoiceId) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (invoiceId) {
                  _context7.next = 3;
                  break;
                }

                console.error('Missing invoice ID');
                return _context7.abrupt('return');

              case 3:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/getDocument/?tip=invoice&series=' + _this8.series + '&number=' + _this8.invoiceNumber + '&externalCompanyId=' + _this8.companyID;
                _context7.prev = 4;
                return _context7.delegateYield(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
                  var response, result, data, rawCountry, loadedCity, foundLocation, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, group, customer, clientObj;

                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return fetch(url, {
                            method: 'GET',
                            headers: {
                              'Content-Type': 'application/json'
                            }
                          });

                        case 2:
                          response = _context6.sent;

                          if (response.ok) {
                            _context6.next = 5;
                            break;
                          }

                          throw new Error('HTTP error! Status: ' + response.status);

                        case 5:
                          _context6.next = 7;
                          return response.json();

                        case 7:
                          result = _context6.sent;
                          data = result.documents && result.documents.length ? result.documents[0] : null;


                          _this8.parentSeries = data.series;
                          _this8.parentInvoiceNumber = data.invoiceNumber;

                          _this8.invoiceData = data;
                          _this8.items = data.items.map(function (item) {
                            var rawQuantity = parseFloat(item.quantity) || 0;
                            var quantity = _this8.isStorno ? -1 * Math.abs(rawQuantity) : rawQuantity;
                            var priceRON = parseFloat(item.price) || 0;
                            var vatRate = item.tva != null ? parseFloat(item.tva) || 0 : 19;
                            var includeVAT = vatRate > 0 ? 'yes' : 'no';

                            var priceFaraTVA = priceRON;
                            var totalFaraTVA = +(priceFaraTVA * quantity).toFixed(2);
                            var totalTVA = +(priceFaraTVA * quantity * vatRate / 100).toFixed(2);
                            var totalValoare = +(totalFaraTVA + totalTVA).toFixed(2);

                            return {
                              posId: item.posId,
                              productName: item.name || '',
                              type: item.type || 'N/A',
                              code: item.code || 'N/A',
                              unitMeasure: item.unitMeasure || 'BUC',
                              quantity: quantity,
                              priceRON: priceRON.toFixed(2),
                              priceRON_gestiune: priceRON,
                              vatRate: String(vatRate),
                              includeVAT: includeVAT,
                              gestiuneFrom: item.gestiune_from,
                              priceFaraTVA: priceFaraTVA.toFixed(2),
                              valoare: totalValoare.toFixed(2),
                              tva: totalTVA.toFixed(2)
                            };
                          });
                          _this8.currency = data.currency;
                          _this8.seriesNumber = data.series;
                          _this8.clientName = data.customer.name;
                          _this8.clientCUI = data.customer.cnp;
                          _this8.clientEmail = data.customer.email;
                          _this8.clientPhone = data.customer.phone;
                          _this8.clientCountryCode = 'RO';
                          rawCountry = String(data.customer.country || '').trim().toUpperCase();

                          if (_this8.romaniaCountryOptions.some(function (item) {
                            return item.code === rawCountry;
                          })) {
                            _this8.clientCountryCode = rawCountry;
                          }
                          _this8.clientCountyCode = _this8.resolveCountyCode(data.customer.county) || String(data.customer.county || '').trim().toUpperCase() || '';
                          loadedCity = data.customer.city || '';

                          _this8.clientCity = _this8.clientCountyCode === 'B' ? _this8.normalizeBucharestSector(loadedCity) : loadedCity;
                          _this8.clientStreet = data.customer.street || '';
                          _this8.clientStreetNumber = data.customer.streetNumber || '';
                          _this8.clientPostalCode = data.customer.postalCode || '';

                          if (data.company) {
                            _this8.applySupplierDetailsFromCompany(data.company);
                          }

                          _this8.seriesOptions = [{
                            series: data.series,
                            currentNumber: data.invoiceNumber
                          }];
                          _this8.seriesNumber = data.series;
                          _this8.currentNumber = data.invoiceNumber;

                          if (data.extraFields) {
                            _this8.extraFields = data.extraFields.reduce(function (acc, field) {
                              acc[field.key] = field.value;
                              return acc;
                            }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this8.extraFields));
                          }

                          _this8.loadOrderInfoFromInvoice(data, _this8.extraFields);

                          if (!_this8.isStorno) {
                            _this8.issueDate = _this8.parseDateTimeLocal(data.issueDate || data.date);
                            _this8.dueDate = _this8.parseDateTimeLocal(data.dueDate || data.date);
                          }

                          if (!(data.externalLocationId && _this8.locations && _this8.locations.length)) {
                            _context6.next = 65;
                            break;
                          }

                          foundLocation = null;
                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _iteratorError2 = undefined;
                          _context6.prev = 40;
                          _iterator2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(_this8.groupedLocations);

                        case 42:
                          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                            _context6.next = 50;
                            break;
                          }

                          group = _step2.value;

                          foundLocation = group.locations.find(function (loc) {
                            return data.externalLocationId && loc.true_id === data.externalLocationId || data.vatNumber && loc.inv_fiscal_code === data.vatNumber;
                          });

                          if (!foundLocation) {
                            _context6.next = 47;
                            break;
                          }

                          return _context6.abrupt('break', 50);

                        case 47:
                          _iteratorNormalCompletion2 = true;
                          _context6.next = 42;
                          break;

                        case 50:
                          _context6.next = 56;
                          break;

                        case 52:
                          _context6.prev = 52;
                          _context6.t0 = _context6['catch'](40);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context6.t0;

                        case 56:
                          _context6.prev = 56;
                          _context6.prev = 57;

                          if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                          }

                        case 59:
                          _context6.prev = 59;

                          if (!_didIteratorError2) {
                            _context6.next = 62;
                            break;
                          }

                          throw _iteratorError2;

                        case 62:
                          return _context6.finish(59);

                        case 63:
                          return _context6.finish(56);

                        case 64:
                          if (foundLocation) {
                            _this8.selectedLocationId = foundLocation.true_id;
                          }

                        case 65:

                          if (data.customer) {
                            console.log('Customer data found:', data.customer);
                            customer = data.customer;
                            clientObj = {
                              id: 'temp-' + customer.cnp,
                              nume: customer.name,
                              vatNumber: customer.cnp,
                              fullData: customer
                            };


                            _this8.clientSelected = clientObj;
                            console.log('Selected client from invoice:', clientObj);
                            _this8.onClientSelect(clientObj);
                          }

                        case 66:
                        case 'end':
                          return _context6.stop();
                      }
                    }
                  }, _callee6, _this8, [[40, 52, 56, 64], [57,, 59, 63]]);
                })(), 't0', 6);

              case 6:
                _context7.next = 11;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t1 = _context7['catch'](4);

                console.error('Error fetching invoice details:', _context7.t1);

              case 11:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[4, 8]]);
      }))();
    },
    fetchCompanyDetails: function fetchCompanyDetails(cui) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var company;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return _this9.fetchAnafCompanyByCui(cui);

              case 3:
                company = _context8.sent;

                _this9.applyAnafCompanyToFields(company, 'invoiceClient');
                _context8.next = 10;
                break;

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8['catch'](0);

                console.error('Error fetching company details:', _context8.t0);

              case 10:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9, [[0, 7]]);
      }))();
    },
    searchOrder: function searchOrder() {
      var _this10 = this;

      var id = this.searchTerm ? parseInt(this.searchTerm.trim(), 10) : null;
      var data = {
        token: this.$session.get('token'),
        company_id: this.companyID,
        id: id
      };

      if (!id) {
        __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
          type: 'warning',
          title: 'Atenție',
          text: 'Te rog introdu un ID de comandă.'
        });
        return;
      }

      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        title: 'Se caută comanda...',
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        content: {
          element: 'div',
          attributes: {
            innerHTML: '<div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>'
          }
        }
      });

      this.apiRequest('/get-products-from-order/', 'GET', data, function (response) {
        __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();

        if (response.status === true && response.data && Array.isArray(response.data.items) && response.data.items.length > 0) {
          _this10.isDisabled = true;
          _this10.linkedOrderId = response.data.id != null ? response.data.id : id;

          var firstGestiune = _this10.gestiuniList.length ? _this10.gestiuniList[0].name : '';
          _this10.receipt_number = response.data.receipt_number || null;
          _this10.applyOrderInfoFromApi(response.data);

          _this10.items = response.data.items.map(function (item) {
            var rawQuantity = parseFloat(item.quantity);
            var rawPrice = parseFloat(item.price);
            var quantity = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_is_finite___default()(rawQuantity) ? rawQuantity : 1;
            var price = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_number_is_finite___default()(rawPrice) ? rawPrice : 0;

            if (price < 0) {
              if (quantity > 0) quantity = -quantity;else if (quantity === 0) quantity = -1;
              price = Math.abs(price);
            }
            var vatRate = item.vat != null ? item.vat : '';
            var includeVAT = item.includeVAT === 'no' ? 'no' : 'yes';

            var priceFaraTVA = 0;
            var tvaUnit = 0;
            var priceCuTVA = 0;

            if (includeVAT === 'yes') {
              priceCuTVA = price;
              priceFaraTVA = price / (1 + vatRate / 100);
              tvaUnit = price - priceFaraTVA;
            } else {
              priceFaraTVA = price;
              tvaUnit = price * (vatRate / 100);
              priceCuTVA = price + tvaUnit;
            }

            var totalFaraTVA = priceFaraTVA * quantity;
            var totalTVA = tvaUnit * quantity;

            return {
              productName: item.name || '',
              type: item.type || 'N/A',
              code: item.product_code || 'N/A',
              unitMeasure: item.unit || 'BUC',
              quantity: quantity,
              priceRON: priceFaraTVA.toFixed(2),
              priceRON_gestiune: priceFaraTVA,
              priceCuTVA: priceCuTVA.toFixed(2),
              vatRate: String(vatRate),
              includeVAT: includeVAT,
              gestiune: firstGestiune,
              priceFaraTVA: priceFaraTVA.toFixed(2),
              valoare: (totalFaraTVA + totalTVA).toFixed(2),
              tva: totalTVA.toFixed(2)
            };
          });

          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
            icon: 'success',
            title: 'Comandă găsită',
            text: 'Am preluat ' + _this10.items.length + ' articole din comand\u0103.'
          });
        } else if (response && response.status === false) {
          _this10.showOrderApiError(response, 'Comanda nu a fost găsită.');
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
            icon: 'error',
            title: 'Eroare',
            text: 'Comanda nu a fost găsită.'
          });
        }
      });
    },
    escapeSwalHtml: function escapeSwalHtml(value) {
      return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    getOrderApiErrorInfo: function getOrderApiErrorInfo(response) {
      var errors = response && response.errors || {};
      var data = response && response.data || {};
      var isObject = errors && (typeof errors === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(errors)) === 'object' && !Array.isArray(errors);

      var message = '';
      if (isObject && typeof errors.message === 'string' && errors.message) {
        message = errors.message;
      } else if (response && typeof response.message === 'string' && response.message) {
        message = response.message;
      } else if (isObject) {
        message = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors).filter(function (key) {
          return !['code', 'invoice_series', 'invoice_number', 'message'].includes(key);
        }).map(function (key) {
          var value = errors[key];
          if (Array.isArray(value)) return value.join(' ');
          if (typeof value === 'string') return value;
          return '';
        }).filter(Boolean).join('\n');
      }

      return {
        message: message,
        code: isObject ? errors.code : '',
        invoiceSeries: isObject && errors.invoice_series || data.invoice_series || '',
        invoiceNumber: isObject && errors.invoice_number || data.invoice_number || '',
        isStorno: data.is_invoice_storno === 1 || data.is_invoice_storno === true
      };
    },
    showOrderApiError: function showOrderApiError(response) {
      var fallbackText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'A apărut o eroare.';

      var info = this.getOrderApiErrorInfo(response);
      var message = info.message || fallbackText;
      var isAlreadyInvoiced = info.code === 'ORDER_ALREADY_HAS_INVOICE';
      var detailRows = [];

      if (info.invoiceSeries) {
        detailRows.push('<div style="padding:4px 0;font-size:13px;color:#7a8ba8;">' + ('Serie: <strong style="color:#25396F;">' + this.escapeSwalHtml(info.invoiceSeries) + '</strong></div>'));
      }
      if (info.invoiceNumber) {
        detailRows.push('<div style="padding:4px 0;font-size:13px;color:#7a8ba8;">' + ('Num\u0103r: <strong style="color:#25396F;">' + this.escapeSwalHtml(info.invoiceNumber) + '</strong></div>'));
      }
      if (info.isStorno) {
        detailRows.push('<div style="padding:4px 0;font-size:13px;color:#7a8ba8;">' + 'Tip: <strong style="color:#25396F;">Storno</strong></div>');
      }

      var html = '<div style="text-align:center;">' + ('<p style="margin:0 0 12px;font-size:15px;color:#25396F;line-height:1.45;">' + this.escapeSwalHtml(message) + '</p>') + (detailRows.length ? '<div style="background:#f8fafd;border:1px solid #e8edf5;border-radius:8px;padding:10px 12px;display:inline-block;min-width:180px;">' + detailRows.join('') + '</div>' : '') + '</div>';

      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        title: isAlreadyInvoiced ? 'Factură existentă' : 'Eroare',
        html: html,
        type: isAlreadyInvoiced ? 'warning' : 'error',
        confirmButtonText: 'OK'
      });
    },
    calculateItemTotals: function calculateItemTotals(item) {
      var quantity = Number(item.quantity);
      var priceRON = Number(item.priceRON);
      var vatRate = Number(item.vatRate);
      var includeVAT = item.includeVAT === 'yes';

      console.log('Calculating totals for item:', vatRate);
      console.log('Include VAT:', includeVAT);

      var priceFaraTVA = void 0,
          tvaUnit = void 0,
          totalFaraTVA = void 0,
          totalTVA = void 0;

      if (includeVAT) {
        priceFaraTVA = priceRON / (1 + vatRate / 100);
        tvaUnit = priceRON - priceFaraTVA;
      } else {
        priceFaraTVA = priceRON;
        tvaUnit = priceFaraTVA * vatRate / 100;
      }

      totalFaraTVA = priceFaraTVA * quantity;
      totalTVA = tvaUnit * quantity;
      return {
        priceFaraTVA: priceFaraTVA,
        total: totalFaraTVA + totalTVA,
        tva: totalTVA };
    },
    populateClientFromLocation: function populateClientFromLocation() {
      var _this11 = this;

      if (this.myOrder && this.myOrder.supplierExternalLocationId) {
        var matchedLocation = this.locations.find(function (loc) {
          return loc.true_id === _this11.myOrder.supplierExternalLocationId;
        });

        if (matchedLocation) {
          this.clientName = matchedLocation.inv_company_name || '';
          this.clientCUI = matchedLocation.inv_fiscal_code || '';
          this.clientEmail = matchedLocation.inv_email || '';
          this.clientPhone = matchedLocation.inv_phone || '';
        }
      }
    },
    addItem: function addItem() {
      if (this.newItem.gestiuneId && this.newItem.productName && this.newItem.unitMeasure && this.newItem.quantity >= 0 && this.newItem.priceRON >= 0 && this.newItem.type && this.newItem.code && this.newItem.vatRate !== null && this.newItem.includeVAT !== '') {
        var totals = this.calculateItemTotals(this.newItem);

        console.log(totals);
        var newItemWithTotals = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.newItem, {
          priceRON: totals.priceFaraTVA.toFixed(2),
          priceRON_gestiune: totals.priceFaraTVA,
          valoare: totals.total.toFixed(2),
          tva: totals.tva.toFixed(2),
          gestiuneFrom: this.newItem.gestiuneId
        });
        this.items.push(newItemWithTotals);
        this.resetNewItem();
      } else {}
    },
    getGestiuneName: function getGestiuneName(gestiuneId) {
      var gestiune = this.gestiuneOptions.find(function (g) {
        return g.id === gestiuneId;
      });
      return gestiune ? gestiune.name : 'N/A';
    },
    removeItem: function removeItem(index) {
      this.items.splice(index, 1);
    },
    resetNewItem: function resetNewItem() {
      this.newItem = {
        gestiuneId: null,
        productName: '',
        unitMeasure: '',
        quantity: null,
        priceRON: null,
        type: '',
        code: '',
        vatRate: '',
        includeVAT: 'no'
      };
    },
    getSeries: function getSeries(vatNumber) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this12.companyID,
                    vatNumber: vatNumber,
                    tip: 'invoice'
                  })
                });

              case 3:
                response = _context9.sent;

                if (response.ok) {
                  _context9.next = 6;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 6:
                _context9.next = 8;
                return response.json();

              case 8:
                data = _context9.sent;


                if (Array.isArray(data.series) && data.series.length > 0) {
                  _this12.seriesOptions = data.series.map(function (serie) {
                    return {
                      series: serie.series,
                      currentNumber: serie.currentNumber
                    };
                  });

                  _this12.seriesNumber = _this12.seriesOptions[0].series;
                  _this12.currentNumber = _this12.seriesOptions[0].currentNumber;
                } else {
                  console.warn('Nu există serii disponibile pentru acest cod fiscal.');

                  _this12.seriesOptions = [];
                  _this12.seriesNumber = '';
                  _this12.currentNumber = '';
                }
                _context9.next = 18;
                break;

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9['catch'](0);

                console.error('Error fetching series:', _context9.t0);

                _this12.seriesOptions = [];
                _this12.seriesNumber = '';
                _this12.currentNumber = '';

              case 18:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12, [[0, 12]]);
      }))();
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this13.companyID);

              case 3:
                response = _context10.sent;

                if (response.ok) {
                  _context10.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context10.next = 8;
                return response.json();

              case 8:
                data = _context10.sent;

                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this13.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      externalLocationId: gest.externalLocationId || ''
                    };
                  });
                } else {
                  _this13.$message.error('Nu s-a primit un array valid de la server.');
                }
                _context10.next = 16;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10['catch'](0);

                _this13.$message.error('Request failed: ' + _context10.t0.message);
                console.error('Error fetching management data:', _context10.t0);

              case 16:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this13, [[0, 12]]);
      }))();
    },
    updateNumber: function updateNumber() {
      var _this14 = this;

      if (this.seriesNumber === 'add') {
        this.openSeriesModal();
        return;
      }

      var selectedSeries = this.seriesOptions.find(function (series) {
        return series.series === _this14.seriesNumber;
      });

      if (selectedSeries) {
        this.currentNumber = selectedSeries.currentNumber;
      } else {
        this.currentNumber = '';
      }
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(!searchTerm || searchTerm.length < 2)) {
                  _context11.next = 3;
                  break;
                }

                _this15.searchResults = [];
                return _context11.abrupt('return');

              case 3:

                _this15.loadingProducts = true;
                _context11.prev = 4;
                _context11.next = 7;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/products?externalCompanyId=' + _this15.companyID + '&name=' + searchTerm);

              case 7:
                response = _context11.sent;
                _context11.next = 10;
                return response.json();

              case 10:
                data = _context11.sent;


                if (Array.isArray(data.products)) {
                  _this15.searchResults = [].concat(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_toConsumableArray___default()(data.products));
                }
                _context11.next = 17;
                break;

              case 14:
                _context11.prev = 14;
                _context11.t0 = _context11['catch'](4);

                console.error('Error fetching products:', _context11.t0);

              case 17:
                _context11.prev = 17;

                _this15.loadingProducts = false;
                return _context11.finish(17);

              case 20:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this15, [[4, 14, 17, 20]]);
      }))();
    },
    onProductSelected: function onProductSelected(selectedProduct) {
      if (typeof selectedProduct === 'string' || !selectedProduct) {
        this.resetNewItem();
        return;
      }

      this.newItem.posId = selectedProduct.posId || selectedProduct._id;
      this.newItem.code = selectedProduct.product_code || '';
      this.newItem.type = selectedProduct.categorie || '';
      this.newItem.unitMeasure = selectedProduct.um || '';
      this.newItem.quantity = selectedProduct.quantity || 1;
      this.newItem.priceRON = selectedProduct.pret_vanzare && selectedProduct.pret_vanzare.length > 0 && selectedProduct.pret_vanzare[0].price || '';
      this.newItem.vatRate = selectedProduct.vat_percent != null ? String(selectedProduct.vat_percent) : '';
      this.newItem.includeVAT = selectedProduct.is_with_vat ? 'yes' : 'no';
    },
    getClientTypeCode: function getClientTypeCode(status) {
      switch (status) {
        case 'juridica_ro':
          return 1;
        case 'fizica':
          return 2;
        case 'juridica_vies':
          return 3;
        default:
          return 1;}
    },
    submitToAdminInvoice: function submitToAdminInvoice(invoiceResponse) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var adminData, adminResponse;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                console.log('Heading to submit to admin invoice with response:', invoiceResponse);
                _context12.prev = 1;
                adminData = {
                  _id: invoiceResponse._id,
                  company_id: _this16.companyID,
                  order_id: _this16.searchTerm,
                  series: invoiceResponse.series,
                  number: invoiceResponse.invoiceNumber,
                  is_vat_payer: _this16.clientVATPayer.toLowerCase() === 'yes',
                  client_type: _this16.getClientTypeCode(_this16.clientLegalStatus),
                  cui: _this16.clientCUI,
                  email: _this16.clientEmail,
                  phone: _this16.clientPhone,
                  address: '',
                  client_full_name: _this16.clientName,
                  issue_date: invoiceResponse.date.split('T')[0],
                  payment_type: _this16.paymentType,
                  receipt_number: _this16.receiptNumber || '',
                  token: _this16.$session.get('vue-session-key'),
                  jwtoken: _this16.apiClientKey
                };

                console.log('Submitting invoice to administration API:', adminData);

                _context12.next = 6;
                return _this16.apiRequest('/client-api/administration/invoice', 'POST', adminData, function (response) {
                  console.log('Intermediate response from API (callback):', response);
                });

              case 6:
                adminResponse = _context12.sent;

                console.log('Final response from administration API:', adminResponse);

                if (adminResponse && !adminResponse.status) {
                  console.error('Admin invoice error:', adminResponse.error);
                  __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                    title: 'Error',
                    text: adminResponse.error && adminResponse.error.message ? adminResponse.error.message : 'Error submitting to administration.',
                    icon: 'error',
                    timer: 3000,
                    showConfirmButton: false
                  });
                } else {
                  console.log('Admin invoice submitted successfully.', adminResponse && adminResponse.data ? adminResponse.data : adminResponse);
                }
                _context12.next = 15;
                break;

              case 11:
                _context12.prev = 11;
                _context12.t0 = _context12['catch'](1);

                console.error('Exception while submitting admin invoice:', _context12.t0);
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Exception',
                  text: _context12.t0.message || 'Unexpected error occurred.',
                  icon: 'error',
                  timer: 3000,
                  showConfirmButton: false
                });

              case 15:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this16, [[1, 11]]);
      }))();
    },
    markNexusInvoice: function markNexusInvoice(orderId, action, invoiceSeries, invoiceNumber) {
      if (!orderId) return;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: orderId,
        action: action
      };

      if (action === 'send') {
        if (invoiceSeries) data.invoice_series = invoiceSeries;
        if (invoiceNumber != null && invoiceNumber !== '') data.invoice_number = invoiceNumber;
      }

      this.apiRequest('/nexus/invoice/mark', 'POST', data, function (response) {
        if (!(response && response.status)) {
          console.warn('Nexus invoice mark failed:', response);
        }
      });
    },
    fetchNexusInvoiceStatus: function fetchNexusInvoiceStatus() {
      var _this17 = this;

      if (!this.nexusOrderId) return;

      this.apiRequest('/nexus/invoice/status/' + this.nexusOrderId, 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, function (response) {
        if (response && response.status) {
          _this17.showNexusInvoiceStatusSwal(response.data != null ? response.data : response);
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this17.$t('validations.wentWrong'), 'error');
        }
      });
    },
    showNexusInvoiceStatusSwal: function showNexusInvoiceStatusSwal(payload) {
      var status = Number(payload && (payload.nexus_invoice_status != null ? payload.nexus_invoice_status : payload.status));
      var config = this.getNexusInvoiceStatusSwalConfig(status);
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        title: config.title,
        text: config.text,
        type: config.type
      });
    },
    getNexusInvoiceStatusSwalConfig: function getNexusInvoiceStatusSwalConfig(status) {
      var map = {
        1: { type: 'info', titleKey: 'nexus.invoiceStatus1', textKey: 'nexus.invoiceStatus1Text' },
        2: { type: 'info', titleKey: 'nexus.invoiceStatus2', textKey: 'nexus.invoiceStatus2Text' },
        3: { type: 'success', titleKey: 'nexus.invoiceStatus3', textKey: 'nexus.invoiceStatus3Text' },
        4: { type: 'error', titleKey: 'nexus.invoiceStatus4', textKey: 'nexus.invoiceStatus4Text' },
        5: { type: 'warning', titleKey: 'nexus.invoiceStatus5', textKey: 'nexus.invoiceStatus5Text' },
        6: { type: 'success', titleKey: 'nexus.invoiceStatus6', textKey: 'nexus.invoiceStatus6Text' },
        7: { type: 'error', titleKey: 'nexus.invoiceStatus7', textKey: 'nexus.invoiceStatus7Text' }
      };
      var item = map[status];
      if (!item) {
        return {
          type: 'info',
          title: this.$t('nexus.invoiceStatus'),
          text: this.$t('nexus.invoiceStatusUnknown')
        };
      }
      return {
        type: item.type,
        title: this.$t(item.titleKey),
        text: this.$t(item.textKey)
      };
    },
    fetchNexusInvoiceLogs: function fetchNexusInvoiceLogs() {
      var _this18 = this;

      if (!this.nexusOrderId) return;

      this.apiRequest('/nexus/invoice/logs/' + this.nexusOrderId, 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, function (response) {
        if (response && response.status) {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
            title: _this18.$t('nexus.invoiceLog'),
            html: '<pre style="text-align:left;max-height:400px;overflow:auto;">' + __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(response.data != null ? response.data : response, null, 2) + '</pre>'
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this18.$t('validations.wentWrong'), 'error');
        }
      });
    },
    markNexusInvoiceManual: function markNexusInvoiceManual() {
      if (!this.nexusOrderId) return;

      var series = this.seriesNumber || this.invoiceData && this.invoiceData.series || this.series;
      var number = this.currentNumber || this.invoiceData && this.invoiceData.invoiceNumber || this.invoiceNumber;

      this.markNexusInvoice(this.nexusOrderId, this.isStorno ? 'storno' : 'send', series, number);
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', this.$t('nexus.invoiceMarkSuccess'), 'success');
    },
    updateOrderInvoiceFromSearch: function updateOrderInvoiceFromSearch(invoiceResponse) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var invoiceSeries, invoiceNumber, payload;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(_this19.isEdit || !_this19.linkedOrderId)) {
                  _context13.next = 2;
                  break;
                }

                return _context13.abrupt('return', { status: true, skipped: true });

              case 2:
                invoiceSeries = invoiceResponse && invoiceResponse.series;
                invoiceNumber = invoiceResponse && invoiceResponse.invoiceNumber;

                if (!(!invoiceSeries || invoiceNumber == null || invoiceNumber === '')) {
                  _context13.next = 6;
                  break;
                }

                return _context13.abrupt('return', { status: true, skipped: true });

              case 6:
                payload = {
                  token: _this19.$session.get('token'),
                  company_id: _this19.companyID,
                  id: _this19.linkedOrderId,
                  invoice_series: String(invoiceSeries),
                  invoice_number: String(invoiceNumber)
                };
                return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                  _this19.apiRequest('/update-order-invoice', 'POST', payload, function (response) {
                    resolve(response || { status: false });
                  });
                }));

              case 8:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this19);
      }))();
    },
    updateOrderWithInvoice: function updateOrderWithInvoice(series, number) {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var currentExternalDocs, updateOrderPayload, response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                currentExternalDocs = _this20.myOrder.externalDocIds || {};
                updateOrderPayload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this20.myOrder, {
                  externalDocIds: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, currentExternalDocs, {
                    invoice: {
                      series: series,
                      number: number
                    }
                  }),
                  status: 'facturat'
                });
                _context14.prev = 2;
                _context14.next = 5;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/order', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(updateOrderPayload)
                });

              case 5:
                response = _context14.sent;


                if (!response.ok) {
                  console.warn('Order update with aviz_id failed');
                } else {
                  console.log('Order updated with aviz:', series, number);
                }
                _context14.next = 12;
                break;

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14['catch'](2);

                console.error('Error updating order with aviz_id:', _context14.t0);

              case 12:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this20, [[2, 9]]);
      }))();
    },
    saveInvoice: function saveInvoice() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var validationErrors, bonNotaValue, extraFieldsForSave, invoiceData, response, errorData, errorMessage, data, orderInvoiceResponse, isInvoice, orderId;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                validationErrors = _this21.getInvoiceValidationErrors();

                if (!validationErrors.length) {
                  _context15.next = 4;
                  break;
                }

                _this21.showInvoiceValidationErrors(validationErrors);
                return _context15.abrupt('return');

              case 4:
                _context15.prev = 4;
                _context15.next = 7;
                return _this21.saveCompany();

              case 7:
                _context15.next = 14;
                break;

              case 9:
                _context15.prev = 9;
                _context15.t0 = _context15['catch'](4);

                console.error('Error saving company:', _context15.t0);
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Error',
                  text: _context15.t0.message || 'Nu s-a putut salva compania.',
                  type: 'error',
                  timer: 2500,
                  showConfirmButton: false
                });
                return _context15.abrupt('return');

              case 14:
                bonNotaValue = _this21.bonNota || _this21.buildBonNotaText();
                extraFieldsForSave = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this21.extraFields);

                delete extraFieldsForSave.orderDate;
                delete extraFieldsForSave.orderNumber;
                delete extraFieldsForSave.bonData;
                delete extraFieldsForSave.bonNumber;

                if (bonNotaValue) {
                  extraFieldsForSave.observatiiFactura = bonNotaValue;
                }

                if (_this21.paymentType) {
                  extraFieldsForSave.paymentType = _this21.paymentType;
                }

                invoiceData = {
                  tip: 'invoice',
                  externalCompanyId: _this21.companyID,
                  externalLocationId: _this21.selectedLocation.true_id,
                  vatNumber: _this21.selectedLocation.inv_fiscal_code,
                  dueDate: _this21.dueDate,
                  issueDate: _this21.issueDate,
                  items: _this21.items.map(function (item) {
                    return {
                      posId: item.posId,
                      name: item.productName.name || item.productName,
                      type: item.type,
                      code: item.code,
                      unitMeasure: item.unitMeasure,
                      quantity: item.quantity,
                      price: parseFloat(item.priceRON_gestiune != null && item.priceRON_gestiune !== '' ? item.priceRON_gestiune : item.priceRON),
                      tva: item.vatRate,
                      gestiune_from: item.gestiuneId || item.gestiuneFrom
                    };
                  }),
                  currency: _this21.currency,
                  series: _this21.seriesNumber,
                  customer: {
                    name: _this21.clientName,
                    cnp: _this21.clientCUI,
                    email: _this21.clientEmail,
                    phone: _this21.clientPhone,
                    country: _this21.clientCountryCode,
                    county: _this21.clientCountyCode,
                    city: _this21.clientCity,
                    street: _this21.clientStreet,
                    streetNumber: _this21.clientStreetNumber,
                    postalCode: _this21.clientPostalCode
                  },
                  extraFields: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries___default()(extraFieldsForSave).map(function (_ref3) {
                    var _ref4 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                        key = _ref4[0],
                        value = _ref4[1];

                    return { key: key, value: value };
                  }),
                  orderDate: _this21.orderDate,
                  orderNumber: _this21.orderNumber,
                  bonData: _this21.bonData,
                  bonNumber: _this21.bonNumber,
                  bonNota: bonNotaValue,
                  paymentType: _this21.paymentType,
                  payment_type: _this21.paymentType,
                  parentDocument: _this21.parentSeries && _this21.parentInvoiceNumber ? _this21.parentSeries + '-' + _this21.parentInvoiceNumber : null
                };


                if (_this21.isEdit && _this21.invoiceData && _this21.invoiceData.invoiceNumber) {
                  invoiceData.number = _this21.invoiceData.invoiceNumber;
                }

                _context15.prev = 24;
                _context15.next = 27;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/document', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(invoiceData)
                });

              case 27:
                response = _context15.sent;

                if (response.ok) {
                  _context15.next = 35;
                  break;
                }

                _context15.next = 31;
                return response.json();

              case 31:
                errorData = _context15.sent;
                errorMessage = errorData.error || 'Error saving invoice';


                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Error',
                  text: errorMessage,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

                throw new Error('Error saving invoice');

              case 35:
                _context15.next = 37;
                return response.json();

              case 37:
                data = _context15.sent;

                console.log('Invoice saved successfully:', data);

                _context15.next = 41;
                return _this21.submitToAdminInvoice(data);

              case 41:
                _context15.next = 43;
                return _this21.updateOrderInvoiceFromSearch(data);

              case 43:
                orderInvoiceResponse = _context15.sent;
                isInvoice = _this21.route.query.isInvoice;

                if (!(isInvoice && data.series && data.invoiceNumber)) {
                  _context15.next = 48;
                  break;
                }

                _context15.next = 48;
                return _this21.updateOrderWithInvoice(data.series, data.invoiceNumber);

              case 48:

                if (!_this21.isEdit && _this21.hasNexusLocation) {
                  orderId = _this21.nexusOrderId || (data.orderNumber != null ? String(data.orderNumber) : '');

                  if (orderId) {
                    _this21.markNexusInvoice(orderId, _this21.isStorno ? 'storno' : 'send', data.series, data.invoiceNumber);
                  }
                }

                if (orderInvoiceResponse && orderInvoiceResponse.status === false) {
                  _this21.showOrderApiError(orderInvoiceResponse, 'Nu s-a putut asocia factura la comandă.');
                } else {
                  __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                    title: 'Success',
                    text: 'Invoice saved successfully.',
                    type: 'success',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }

                _this21.$bus.$emit('refresh');
                _this21.$bus.$emit('close-modal');
                _context15.next = 58;
                break;

              case 54:
                _context15.prev = 54;
                _context15.t1 = _context15['catch'](24);

                console.error('Error saving invoice:', _context15.t1);

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Error',
                  text: _context15.t1.message || 'An unexpected error occurred.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 58:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this21, [[4, 9], [24, 54]]);
      }))();
    }
  }
});

/***/ }),

/***/ "m1oP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m4/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaignForm_vue__ = __webpack_require__("Tl/y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_714fabde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaignForm_vue__ = __webpack_require__("kHG/");
function injectStyle (ssrContext) {
  __webpack_require__("uY8W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-714fabde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RaffleCampaignForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_714fabde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RaffleCampaignForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m4Pk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m5DB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('invoice-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mAKn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mBJ5":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAvCAYAAABzJ5OsAAAABHNCSVQICAgIfAhkiAAAA79JREFUaEPtWUtSGzEQ7camClYhJwicIM4JYm9SmA1mmYALcwLMCRhOgH0CoIDKErPBVdngnCDOCeKcILDKB4jyemyR8Xg+GUuaOFXRhmIstV63Wt2vW0wR4/pILX0v0rZiqilFJWZaiprn6hv2vMGefVbUUUW6rL7mQdReHP7YPVf76ic18wacZAhF1Fq8o4PKDt8E5z2CF2t/m6cL/Fh2ZVETuVCgDwUqQQUewXfP1PWsAtdKhxXwwXdPlUdM+yaWyWst7kN7rc5N2Y/FXb4W6dMs+XiqIQq0IpeYr85UE+Y/TF0wQxO09fnqVPVg9ZczhO1PoAyqW7wi4L9YcRlFH3Gh/FCWhzEAnhlRBnsajVtSVKvWuaeldN+qZXogD/9vG0lOWGwD/G2Bqfxqk/tR+4gS6p6OXZyEMfhg2EqyMEKxJL4WwvFzWydhDB7uUhlzl3PVoDnqxXERUI8GFPYQ3Z6ZKmEfvL4/TN7CD2qHuYgA9mlIkZqmSdEdeIAUZjhH5K3WuR15H+SUFB1NewJOwQdADaDIHlJ6JwzUJMfkBV5j7iEy7QUjk0l2zxu8KHGCTRtaG1i+hjAqNDzzyA08suBngPSqm3wcRAnwLXzfzYwcC/IAL9m3hXAq2XZsjIqfD/i4PHPgJYEt3pMXGy4NqzbrlscFHCAB9alAzdhEdaaE78hJTGVxfUrm4Jl2wn4c5wI+RRhWa+Vp3CS8xhw8gQpscSUJzIicHeJi1myAtmd5kRRjfb+8nKd9uJFfb9oeNizvY8Ll7MDPW2tv+P27c1V6IFp33fsZgj9VfZtU1baF4+Rpyx9jgrOKx5EylwBfkxp26hTtCFiqWGTsvbUtbumm0z/jOkI10PYrSfLT4CUGS7tv5geCw4am1797lYbFQS5aKzoI8qSxFrfUmEKkAORJLmCybBKRTyb78zn0XLJgxtwT5BAviitNgNeCRw3YMiaUMm5mZ/ocDVDEd6JYqd4gFrwdBG6l/Afv1r7x0qey/KiEW0duWJbiY3WTL/+GApnBS1GBLHcRbIvLWxEXaCOuenKlGPvFwgPthqOKvIGGu10pT0AThUmA01uLWCNDtf1nnaRXQE2AtOXSSNzCHT0NhjbIli7ZugPLD19GUh4XxptEKe9X6Ii9CHbEIFteSpxka5/PJ7TcJh4O/CpJkfRaosYtBI4985u081JOyzfqkFUKJbgfb0UE++5BQXGuEHaxYKZGS9uaz1ORBjowZI42o0vrIdo0xCWEX+NvS4oDB76dKDIz+LwBJu33C9/Y8j/HuB5dAAAAAElFTkSuQmCC"

/***/ }),

/***/ "mBL5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mCtB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mMIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.add'))+"\n          ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.modelData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"50","prop":"name","label":_vm.$t('customers.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"50","prop":"location_name","label":_vm.$t('customers.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.location && props.row.location.name)?_c('span',[_vm._v(_vm._s(props.row.location.name))]):_c('span',[_vm._v(_vm._s(_vm.$t('general.all')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":200,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.deleteOrderScreen(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.delete'))+"\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":150,"label":_vm.$t('general.edit')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n            ")])]}}])})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mOD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSettingsUsers_vue__ = __webpack_require__("qgx5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6736d8ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSettingsUsers_vue__ = __webpack_require__("s6Iu");
function injectStyle (ssrContext) {
  __webpack_require__("C59m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSettingsUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6736d8ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSettingsUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mOkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row price-profiles"},[_c('div',{staticClass:"col-xl-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{ref:"tableTop",staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-start","gap":"10px","flex-wrap":"wrap","flex-direction":"column"}},[_c('div',{staticClass:"right-group",staticStyle:{"flex":"0 0 auto","margin-bottom":"20px","margin-top":"10px"}},[_c('button',{staticClass:"btn add",staticStyle:{"font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('general.add') + ' Price Profile'},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-sm.png"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" Price Profile\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"data-table",staticStyle:{"margin-top":"20px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.onRowClick}},[_c('el-table-column',{attrs:{"prop":"id","label":"Id","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Nume Profil"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"locations","label":"Locații Asignate"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"locations-scroll-horizontal"},[(scope.row.location_details && scope.row.location_details.length)?_vm._l((scope.row.location_details),function(loc){return _c('span',{key:loc.id,staticClass:"location-item"},[_vm._v("\n                      "+_vm._s(loc.name)+"\n                    ")])}):_c('span',{staticClass:"location-item text-muted"},[_vm._v("\n                    Nicio locație\n                  ")])],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"filters","label":"Filtre"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"locations-scroll-horizontal"},[_vm._l((scope.row.customers_groups),function(group){return _c('span',{key:'g' + group.id,staticClass:"location-item"},[_vm._v("\n                    Grup: "+_vm._s(group.name)+"\n                  ")])}),_vm._v(" "),_vm._l((scope.row.delivery_ranges),function(range){return _c('span',{key:'r' + range.id,staticClass:"location-item"},[_vm._v("\n                    Zonă: "+_vm._s(range.name)+" ("+_vm._s(_vm.locationNameByToken(range.location_id))+")\n                  ")])}),_vm._v(" "),_vm._l((scope.row.top_categories),function(category){return _c('span',{key:'c' + category.id,staticClass:"location-item"},[_vm._v("\n                    Categorie: "+_vm._s(category.name)+"\n                  ")])}),_vm._v(" "),(!_vm.hasFilters(scope.row))?_c('span',{staticClass:"location-item text-muted"},[_vm._v("\n                    Doar locație\n                  ")]):_vm._e()],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.goToEdit(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.edit'))+"\n                    ")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"divided":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.deleteProfile(scope.row)}}},[_c('span',{staticStyle:{"color":"#f56c6c"}},[_vm._v(_vm._s(_vm.$t('general.delete')))])])],1)],1)]}}])})],1),_vm._v(" "),(_vm.paginationDef.totalRecords > 0)?_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"right"},attrs:{"layout":"prev, pager, next","total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"current-page":_vm.paginationDef.page},on:{"update:currentPage":function($event){_vm.$set(_vm.paginationDef, "page", $event)},"current-change":_vm.handlePageChange}}):_vm._e()],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mV+r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStorePurchasesReport_vue__ = __webpack_require__("eEcC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2750faca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStorePurchasesReport_vue__ = __webpack_require__("Jcwn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoyaltyStorePurchasesReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2750faca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoyaltyStorePurchasesReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mWDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)]):_vm._e(),_vm._v(" "),(_vm.posUsers.length)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.operator')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPosUser),expression:"selectedPosUser"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedPosUser=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"null","selected":"","label":_vm.$t('general.alls')}},[_vm._v(_vm._s(_vm.$t('general.alls')))]),_vm._v(" "),_vm._l((_vm.posUsers),function(operator){return [_c('option',{attrs:{"label":operator.firstname + ' ' + operator.lastname},domProps:{"value":operator.id}},[_vm._v("\n                "+_vm._s(operator.firstname)+" "+_vm._s(operator.lastname)+"\n              ")])]})],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100 mar-bt-15"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('general.orderId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderId),expression:"orderId"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"price","placeholder":"3823231"},domProps:{"value":(_vm.orderId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orderId=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.tables')))]),_vm._v(" "),_c('el-select',{ref:"tableSelect",staticStyle:{"width":"100%"},attrs:{"value-key":"id","multiple":"","filterable":"","remote":"","reserve-keyword":"","placeholder":_vm.$t('settingTable.searchTable'),"remote-method":_vm.searchTables,"loading":_vm.loadingTables},on:{"change":_vm.clearSearch},model:{value:(_vm.selectedTables),callback:function ($$v) {_vm.selectedTables=$$v},expression:"selectedTables"}},_vm._l((_vm.mergedTables),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item}})}))],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(" "+_vm._s(_vm.$t('reports.lastSearch'))+": "),_c('b',[_vm._v(_vm._s(_vm.currentTime))]),_vm._v(" "),_c('span',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns",staticStyle:{"width":"100%"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"reportsTable",staticClass:"report-sales",attrs:{"data":_vm.productsTableData,"total":_vm.totalOrders,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"order_id","label":_vm.$t('reports.orderId'),"min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"table_number","label":_vm.$t('reports.tableNumber'),"min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.table_number ? props.row.table_number : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"table_zone","label":_vm.$t('orders.zone'),"min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.table_zone ? props.row.table_zone : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"pos_id","label":_vm.$t('reports.posId'),"min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"operator_name","label":_vm.$t('reports.operator'),"min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"order_opening_time","label":_vm.$t('reports.orderCreatedAt'),"min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.order_opening_time ? _vm.formatToCompanyTimezone(props.row.order_opening_time) : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"order_duration","label":_vm.$t('reports.duration'),"min-width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"order_number","label":_vm.$t('reports.orderNumber'),"min-width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"product_count","label":_vm.$t('reports.productCount'),"min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"order_total","label":_vm.$t('orders.totals_grandtotal'),"min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"payment_type","label":_vm.$t('reports.paymentMethod'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.$t('paymentTypes.' + props.row.payment_type))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"order_comments","label":_vm.$t('reports.orderComments'),"min-width":"140"}})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mX3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proforma_vue__ = __webpack_require__("1Dja");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87fd887e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proforma_vue__ = __webpack_require__("j55m");
function injectStyle (ssrContext) {
  __webpack_require__("oEWd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87fd887e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proforma_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87fd887e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proforma_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mY1+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);




















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__["a" /* default */],
    ChartBarsCard: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]
  },
  watch: {},
  computed: {},
  data: function data() {
    var _this = this;

    return {
      loading: true,
      loading2: true,
      actionCol: {
        label: 'Delete',
        props: {
          align: 'center'
        },
        buttons: [{
          props: {
            type: 'danger',
            icon: 'el-icon-delete',
            class: 'btn btn-orange btn-fill'
          },
          handler: function handler(index, row) {
            _this.handleDelete(index, row);
          },
          label: this.$t('general.delete')
        }]
      },
      pagerCount: 5,
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: false
      },
      searchQuery: '',
      propsToSearch: ['name', 'status', 'type', 'discount'],
      tableColumns: [],
      tableData: [],
      filters: [{
        value: '',
        prop: ['name', 'status', 'type']
      }],
      emailsChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '300px',
          axisX: {
            position: 'end',
            labelOffset: {
              x: 10,
              y: 10
            },
            showLabel: true,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      totalEmails: null
    };
  },
  created: function created() {
    this.loadData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.loadData();
    },
    loadData: function loadData() {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.getCampaigns(data);
      this.getEmailCampaignStatistics(data);
    },
    stopSending: function stopSending(row) {
      var _this2 = this;

      if (row.is_sending) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
          text: this.$t('marketingCampaigns.areYouSureCancelSending') + ' ' + row.name + '?',
          type: 'question',
          showCancelButton: true
        }).then(function (result) {
          if (result) {
            var data = {
              token: _this2.$session.get('token'),
              company_id: _this2.$session.get('selectedCompany'),
              id: row.id
            };
            _this2.apiRequest('/stop-sending-campaign', 'POST', data, function (response) {
              if (response.status) {
                row.is_sending = false;
                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()(_this2.$t('marketingCampaigns.campaignStoppedSuccessfuly'), '', 'success').catch(function () {});
              } else {
                row.is_sending = true;
                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()(_this2.$t('validations.wentWrong'), '', 'error').catch(function () {});
              }
            });
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()(row.name + ' ' + this.$t('marketingCampaigns.notBeingSending'), '', 'error').catch(function () {});
      }
    },
    onInput: function onInput() {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.searchQuery.length >= 3) {
        data.search = this.searchQuery;
        this.getCampaigns(data);
      }

      if (this.searchQuery.length === 0) {
        this.getCampaigns(data);
      }
    },
    handlePageChange: function handlePageChange(page) {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: page,
        perPage: this.paginationDef.perPage
      };
      if (this.searchQuery.length >= 3) {
        data.search = this.searchQuery;
      }
      this.getCampaigns(data);
    },
    getCampaigns: function getCampaigns(data) {
      var self = this;
      this.loading = true;
      this.apiRequest('/campaign', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data.data;
          self.paginationDef.page = response.data.pagination.page;
          self.paginationDef.perPage = response.data.pagination.perPage;
          self.paginationDef.totalPages = response.data.pagination.totalPages;
          self.paginationDef.totalRecords = response.data.pagination.totalRecords;
          self.tableData.forEach(function (element) {
            self.$set(element, 'isDisabledByLastSent', self.checkLastSent(element));
          });
        }
        self.$nextTick(function () {
          self.loading = false;
        });
      });
    },
    goToRecord: function goToRecord(row, column, event) {
      if (column.property !== 'actions' && column.property !== 'active') {
        this.globalGoToRecord(row, event, column, '/marketing/campaigns/edit/');
      }
    },
    duplicateCampaign: function duplicateCampaign(row) {
      this.$router.push({
        path: '/marketing/campaigns/add',
        query: { duplicateFrom: row.id }
      });
    },
    handleActive: function handleActive(index, row, e) {
      var _this3 = this;

      var actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + row.name + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var notificationTypes = [];
          for (var i in row.notification_type) {
            if (row.notification_type[i]) {
              for (var type in row.notification_type[i]) {
                notificationTypes.push({ 'type': row.notification_type[i][type] });
              }
            }
          }
          var data = {
            token: _this3.$session.get('token'),
            company_id: _this3.$session.get('selectedCompany'),
            name: row.name,
            type: row.type,
            mode: row.mode,
            notification_type: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(notificationTypes),
            active: row.active ? 1 : 0
          };
          var self = _this3;
          _this3.apiRequest('/campaign/' + row.id, 'PUT', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()(self.$t('general.success') + '!', '', 'success').catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        row.active = !row.active;
      });
    },
    sendNotif: function sendNotif(index, row) {
      var _this4 = this;

      if (row.isDisabledByLastSent) {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()(this.$t('marketingCampaigns.campaignWasSent') + '!', '', 'info').catch(function () {});
      } else {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
          text: this.$t('marketingCampaigns.areYouSureNotif'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then(function (result) {
          _this4.$nextTick(function () {
            this.loading = true;
          });
          if (result) {
            var data = {
              token: _this4.$session.get('token'),
              company_id: _this4.$session.get('selectedCompany'),
              campaign_id: row.id
            };
            var self = _this4;
            _this4.apiRequest('/queues/notifications', 'POST', data, function (response) {
              self.$nextTick(function () {
                this.loading = false;
              });
              if (response.status) {
                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', self.$t('marketingCampaigns.notifSent'), 'success').catch(function () {});
                self.$nextTick(function () {
                  var validIndex = self.tableData.findIndex(function (obj) {
                    return obj.id === row.id;
                  });
                  self.tableData[validIndex].last_sent = response.data.last_sent;
                  self.tableData[validIndex].is_sending = true;
                  self.tableData[validIndex].isDisabledByLastSent = self.checkLastSent(self.tableData[validIndex]);
                });
              } else {
                var msg = self.$t('validations.wentWrong');
                if (response.errors.campaign_id !== undefined) {
                  msg = response.errors.campaign_id;
                }
                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', msg, 'error').catch(function () {});
              }
            });
          }
        }).catch(function () {});
      }
    },
    handleDelete: function handleDelete(index, row) {
      var _this5 = this;

      var self = this;
      if (!row.is_sending) {
        var question = {
          text: this.$t('marketingCampaigns.areYouSureDelete') + ' ' + row.name + '?',
          type: 'question',
          showCancelButton: true
        };
        if (row.coupon) {
          question = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, question, {
            text: question.text + ' ' + this.$t('marketingCoupons.deleteCampaignCouponQuestion', { coupon: row.coupon.name }),
            input: 'radio',
            inputOptions: {
              keep: this.$t('marketingCoupons.keepCouponActive'),
              deactivate: this.$t('marketingCoupons.deactivateCoupon')
            },
            inputValue: 'keep'
          });
        }
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()(question).then(function (result) {
          if (result) {
            var data = {
              token: _this5.$session.get('token'),
              company_id: _this5.$session.get('selectedCompany')
            };
            if (row.coupon) {
              data.coupon_action = result === 'deactivate' ? 'deactivate' : 'keep';
            }
            _this5.apiRequest('/campaign/' + row.id, 'DELETE', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', self.$t('marketingCampaigns.campaignDeleted'), 'success').catch(function () {});
                self.tableData.splice(index, 1);
              } else {
                __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
              }
            });
          }
        }).catch(function () {});
      } else {
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
          text: self.$t('marketingCampaigns.cannotDelete'),
          type: 'error',
          showCancelButton: false
        });
      }
    },
    getEmailCampaignStatistics: function getEmailCampaignStatistics(data) {
      var _this6 = this;

      this.loading2 = true;
      this.apiRequest('/campaign-email-statistics', 'GET', data, function (response) {
        if (response.status === true) {
          _this6.emailsChart.data.labels = response.data.label;
          _this6.emailsChart.data.series = [response.data.value];
          _this6.totalEmails = response.data.total;
          _this6.emailsChart.title = _this6.$t('reports.emailSend');
          _this6.$refs.refEmailsChart.initChart();
        }
        _this6.$nextTick(function () {
          _this6.loading2 = false;
        });
      });
    },
    addZero: function addZero(i) {
      if (i < 10) {
        i = '0' + i;
      }
      return i;
    },
    checkLastSent: function checkLastSent(row) {
      if (row.last_sent && row.last_sent.length) {
        var data1 = new Date(row.last_sent);
        var data2 = new Date();
        var differenceInTime = data2.getTime() - data1.getTime();
        var minutes = Math.floor(differenceInTime / 60000);
        if (minutes < 30) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    }
  }
});

/***/ }),

/***/ "mYY+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('loyalty-store-campaign-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mYhK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltMenuLayout_vue__ = __webpack_require__("XiU3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019f3676_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WoltMenuLayout_vue__ = __webpack_require__("+tRN");
function injectStyle (ssrContext) {
  __webpack_require__("OUAZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-019f3676"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WoltMenuLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019f3676_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WoltMenuLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "malN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mbo1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row ordersposContainer"},[_c('div',{class:_vm.isInEditMode ? 'isInEditMode orderspos' : 'orderspos'},[_c('div',{staticClass:"floatBox"}),_vm._v(" "),_c('div',{staticClass:"middleSection"},[_c('div',{staticClass:"leftPart"},[(!_vm.isInEditMode)?_c('div',{staticClass:"topBar"},[_c('div',{staticClass:"topBar__left"},[_c('div',{class:(_vm.client) ? 'client selected' : 'client',on:{"click":function($event){_vm.openClientModal()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.titleClient')))]),_vm._v(" "),_c('div',{staticClass:"badge_wrapper"},[_vm._m(0),_vm._v(" "),_c('button',[(!_vm.client)?_c('span',[_vm._v("Selecteaza Clientul")]):_vm._e(),_vm._v(" "),(_vm.client && (_vm.client.firstname || _vm.client.lastname))?_c('span',[_vm._v(_vm._s(_vm.client.firstname)+" "+_vm._s(_vm.client.lastname))]):(_vm.client && _vm.client.email)?_c('span',[_vm._v(_vm._s(_vm.client.email))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"method_btns"},[_c('span',{staticStyle:{"width":"100%","text-align":"center"}},[_vm._v(_vm._s(_vm.$t('addOrder.titleMethod')))]),_vm._v(" "),_c('div',{staticClass:"badge_wrapper"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"method_btns_wrapper"},[_vm._l((_vm.company.delivery_options_labels),function(method){return [(method.enabled)?_c('button',{class:(method.key === _vm.activeMethod) ? 'methodBtn active' : 'methodBtn',attrs:{"disabled":!method.active || !_vm.client},on:{"click":function($event){_vm.changeMethod(method)}}},[_vm._v(_vm._s(_vm.$t('settingCompany.' + method.key)))]):_vm._e()]})],2)])]),_vm._v(" "),(!_vm.supraSelectedLocation)?_c('div',{staticClass:"loc"},[_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.titleLocation')))]),_vm._v(" "),_c('div',{staticClass:"badge_wrapper"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"buttonWithSearch"},[(!_vm.selectedLocation)?_c('button',{staticStyle:{"min-width":"150px"},attrs:{"disabled":!_vm.activeMethod},on:{"click":function($event){_vm.dropdownLocationActive = !_vm.dropdownLocationActive}}},[_vm._v(_vm._s(_vm.$t('addOrder.locSelect')))]):_c('button',{staticClass:"active",staticStyle:{"min-width":"150px"},on:{"click":function($event){_vm.dropdownLocationActive = !_vm.dropdownLocationActive}}},[_c('span',[_vm._v(_vm._s(_vm.curentLocation.name))])]),_vm._v(" "),(_vm.dropdownLocationActive)?_c('div',{staticClass:"buttonWithSearch_search"},[_vm._l((_vm.availableLocations),function(loc){return [_c('div',{staticClass:"searchList",on:{"click":function($event){_vm.selectedLocationChanged(loc)}}},[_c('div',{},[_c('span',[_vm._v(_vm._s(loc.name))])])])]})],2):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{class:(_vm.activeMethod && _vm.selectedLocation && _vm.activeMethod == 'delivery') ? 'adress' : 'adress disabled',on:{"click":function($event){_vm.openAdressModal()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.titleAdress')))]),_vm._v(" "),_c('div',{staticClass:"badge_wrapper"},[(_vm.supraSelectedLocation)?_c('div',{staticClass:"badge"},[_c('span',[_vm._v("3")])]):_vm._e(),_vm._v(" "),(!_vm.supraSelectedLocation)?_c('div',{staticClass:"badge"},[_c('span',[_vm._v("4")])]):_vm._e(),_vm._v(" "),_c('button',{class:(_vm.client && _vm.client.address) ? 'active' : ''},[(!_vm.client || (_vm.client && !_vm.client.address))?_c('span',[_vm._v("Selecteaza Adresa")]):_vm._e(),_vm._v(" "),(_vm.client && _vm.client.address)?_c('span',[_vm._v(_vm._s(_vm.client.address.address_name)+" "+_vm._s(_vm.client.address.street)+" "+_vm._s(_vm.client.address.number))]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),_c('div',{class:(_vm.activeMethod && _vm.selectedLocation) ? 'productList_wrapper' : 'productList_wrapper disabled'},[_c('div',{staticClass:"productList_wrapper_left"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('div',{staticClass:"filter__bar"},[_c('div',{staticClass:"filter__cat"},[_vm._l((_vm.category),function(cat){return [_c('a',{class:(cat.id == _vm.selectedCategory) ? 'selected' : '',style:('background-image: url('+cat.image+');'),on:{"click":function($event){_vm.getProducts(cat.id)}}},[_c('button',[_vm._v(_vm._s(cat.name))])])]})],2)])])]),_vm._v(" "),_c('div',{staticClass:"productList_wrapper_right"},[_c('div',{staticClass:"productList_topBar"},[_c('h3',[_vm._v("Produse")]),_vm._v(" "),(_vm.canScrollProductList)?_c('div',[_c('button',{staticClass:"scrollBtnProductList up",on:{"click":_vm.scrollUpProductList}},[_vm._v("⮝")]),_vm._v(" "),_c('button',{staticClass:"scrollBtnProductList down",on:{"click":_vm.scrollDownProductList}},[_vm._v("⮟")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_wrapper"},[_c('div',{class:_vm.searchFilterShow ? 'filter__search showw' : 'filter__search'},[_c('div',{staticClass:"search"},[_c('span',{staticClass:"icosearch"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"25.863","height":"25.863","viewBox":"0 0 25.863 25.863"}},[_c('g',{attrs:{"id":"Icon_feather-search","data-name":"Icon feather-search","transform":"translate(1.5 1.5)"}},[_c('path',{attrs:{"id":"Path_24745","data-name":"Path 24745","d":"M24.27,14.385A9.885,9.885,0,1,1,14.385,4.5,9.885,9.885,0,0,1,24.27,14.385Z","transform":"translate(-4.5 -4.5)","fill":"none","stroke":"#909090","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_24746","data-name":"Path 24746","d":"M30.35,30.35l-5.375-5.375","transform":"translate(-8.109 -8.109)","fill":"none","stroke":"#909090","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}})])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],ref:"searchText",attrs:{"type":"text","placeholder":_vm.$t('addOrder.searchProduct')},domProps:{"value":(_vm.searchText)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value},function($event){_vm.newText()}]}}),_vm._v(" "),_c('span',{class:_vm.showRemoveTextFromSearch ? 'closeSearch show' : 'closeSearch',on:{"click":function($event){_vm.deleteTextFromSearch()}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22.698","height":"22.698","viewBox":"0 0 22.698 22.698"}},[_c('path',{attrs:{"id":"Icon_ionic-ios-close-circle","data-name":"Icon ionic-ios-close-circle","d":"M14.724,3.375A11.349,11.349,0,1,0,26.073,14.724,11.347,11.347,0,0,0,14.724,3.375ZM17.6,18.833l-2.875-2.875-2.875,2.875A.872.872,0,1,1,10.615,17.6l2.875-2.875-2.875-2.875a.872.872,0,0,1,1.233-1.233l2.875,2.875L17.6,10.615a.872.872,0,0,1,1.233,1.233l-2.875,2.875L18.833,17.6a.876.876,0,0,1,0,1.233A.866.866,0,0,1,17.6,18.833Z","transform":"translate(-3.375 -3.375)","fill":"#909090"}})])])])])])]),_vm._v(" "),_c('div',{ref:"productList",staticClass:"productList"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{class:(((!_vm.activeMethod || !_vm.selectedLocation) && !_vm.loading) ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('h1',[_vm._v(_vm._s(_vm.$t('addOrder.pleaseSelectMethodAndLoc')))])])]),_vm._v(" "),_vm._l((_vm.products),function(product){return [_c('div',{staticClass:"product",on:{"click":function($event){_vm.openProduct(product)}}},[_c('div',{staticClass:"product_img_title"},[(product.image_url)?[_c('div',{staticClass:"productImage",style:('background-image: url(\'' + product.image_url + '\');'),on:{"click":function($event){$event.stopPropagation();_vm.addProductDirectlyToCart(product)}}})]:_vm._e(),_vm._v(" "),_c('p',{staticClass:"prod_title"},[_vm._v(_vm._s(product.name))])],2),_vm._v(" "),_c('p',{staticClass:"prod_price"},[_vm._v(_vm._s(product.price_details.formatted_price))])])]})],2)])])]),_vm._v(" "),_c('div',{staticClass:"rightPart"},[_c('div',{staticClass:"orderDetails_title"},[_c('p',[_vm._v(_vm._s(_vm.$t('addOrder.orderDet')))]),_vm._v(" "),_c('div',{staticClass:"right-box"},[_c('div',{staticClass:"settings-box"},[_c('div',{staticClass:"location statusAndHour"},[(_vm.availableStatuses && (_vm.availableStatuses.ON_HOLD || _vm.availableStatuses.POSTPONED || _vm.availableStatuses.PROCESSING || _vm.availableStatuses.DELIVERED))?_c('div',{staticClass:"statuses"},[_c('div',{staticClass:"buttonWithSearch"},[(_vm.selectedStatus)?_c('button',{staticClass:"active",on:{"click":function($event){_vm.showStatusDropdown = !_vm.showStatusDropdown}}},[_vm._v(_vm._s(_vm.$t('addOrder.titleStatus'))+": "+_vm._s(_vm.$t('ordersStatus.'+_vm.selectedStatus)))]):_vm._e(),_vm._v(" "),(_vm.showStatusDropdown)?_c('div',{staticClass:"buttonWithSearch_search"},[_c('div',{staticClass:"searchList",on:{"click":function($event){_vm.selectedStatus = 'NEW'; _vm.showStatusDropdown = false}}},[_c('div',{},[_c('span',[_vm._v(_vm._s(_vm.$t('ordersStatus.NEW')))])])]),_vm._v(" "),_vm._l((_vm.availableStatuses),function(acive,status){return [(acive)?_c('div',{staticClass:"searchList",on:{"click":function($event){_vm.selectedStatus = status; _vm.showStatusDropdown = false}}},[_c('div',{},[_c('span',[_vm._v(_vm._s(_vm.$t('ordersStatus.' + status )))])])]):_vm._e()]})],2):_vm._e()])]):_vm._e()]),_vm._v(" "),(_vm.curentLocation && !_vm.curentLocation.deactivate_delivery_hour_usage)?_c('div',{staticClass:"hour"},[(_vm.activeMethod && _vm.selectedLocation)?_c('div',[_c('button',{staticClass:"openHourDateBtn",on:{"click":function($event){_vm.openHourDate()}}},[_c('img',{attrs:{"src":"/static/img/icons/ios-time.png"}}),_vm._v(" "),(_vm.selectedDate)?[_vm._v(_vm._s(_vm.formatDate(_vm.selectedDate)))]:_vm._e(),_vm._v(" "),(_vm.selectedHour && !_vm.curentLocation.just_date_delivery_hour_usage)?[_vm._v(_vm._s(_vm.selectedHour))]:_vm._e()],2)]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"zoom",on:{"click":function($event){_vm.goFullScreen()}}},[_c('svg',{attrs:{"id":"Component_2_1","data-name":"Component 2 – 1","xmlns":"http://www.w3.org/2000/svg","width":"58","height":"60","viewBox":"0 0 58 60"}},[_c('rect',{attrs:{"id":"Rectangle_6606","data-name":"Rectangle 6606","width":"58","height":"60","rx":"10","fill":"#f3f3f3"}}),_vm._v(" "),_c('g',{attrs:{"id":"Icon_feather-maximize-2","data-name":"Icon feather-maximize-2","transform":"translate(20 21)"}},[_c('path',{attrs:{"id":"Path_24778","data-name":"Path 24778","d":"M22.5,4.5h6.141v6.141","transform":"translate(-10.218 -4.5)","fill":"none","stroke":"#8f8f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_24779","data-name":"Path 24779","d":"M10.641,28.641H4.5V22.5","transform":"translate(-4.5 -10.218)","fill":"none","stroke":"#8f8f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_24780","data-name":"Path 24780","d":"M28.164,4.5,21,11.664","transform":"translate(-9.742 -4.5)","fill":"none","stroke":"#8f8f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_24781","data-name":"Path 24781","d":"M4.5,28.164,11.664,21","transform":"translate(-4.5 -9.742)","fill":"none","stroke":"#8f8f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])])]),_vm._v(" "),_c('div',{class:(_vm.activeMethod && _vm.selectedLocation) ? 'cartDetail_wrapper' : 'cartDetail_wrapper disabled'},[_c('div',{staticClass:"settings"},[_c('div',{staticClass:"commentOrder",on:{"click":_vm.openCommentModal}},[_c('img',{attrs:{"src":"/static/img/icons/chat.png"}})]),_vm._v(" "),(!_vm.isFullScreen)?_c('div',{staticClass:"displayClient"},[_vm._m(4)]):_vm._e(),_vm._v(" "),(!_vm.isFullScreen)?_c('div',{staticClass:"settings",on:{"click":function($event){_vm.others()}}},[_c('img',{attrs:{"src":"/static/img/icons/settings.png"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"toGo"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"2px"}},[_c('label',{attrs:{"for":"toGo"}},[_vm._v(_vm._s(_vm.$t('addOrder.toGo'))+"\n                    "),_c('p-switch',{attrs:{"id":"toGo","name":"toGo","type":"success"},model:{value:(_vm.toGo),callback:function ($$v) {_vm.toGo=$$v},expression:"toGo"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"cartDetail"},[_c('div',{staticClass:"verify-card"},[_c('div',{staticClass:"cartDetail__head"},[_c('p',[_vm._v(_vm._s(_vm.$t('addOrder.cartDet')))]),_vm._v(" "),(_vm.cart && _vm.cart.myCart && _vm.cart.myCart.products.length && !_vm.isInEditMode)?_c('button',{staticClass:"emptyCart",on:{"click":_vm.emptyCart}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"13.769","height":"16.523","viewBox":"0 0 13.769 16.523"}},[_c('path',{attrs:{"id":"Icon_ionic-md-trash","data-name":"Icon ionic-md-trash","d":"M8.127,19.191a1.839,1.839,0,0,0,1.836,1.832h7.343a1.839,1.839,0,0,0,1.836-1.832V8.631H8.127ZM20.519,5.877H17.077L15.924,4.5H11.345L10.192,5.877H6.75V7.254H20.519Z","transform":"translate(-6.75 -4.5)","fill":"#ff3b30"}})])]):_vm._e()]),_vm._v(" "),(_vm.cart && _vm.cart.myCart && _vm.company)?_c('div',{class:[{ big: _vm.isInEditMode, heightbig: _vm.isFullScreen }, 'products']},[(_vm.cart && _vm.cart.myCart && _vm.company && _vm.cart.myCart.products.length)?[_vm._l((_vm.cart.myCart.products),function(prod,index){return [_c('div',{staticClass:"product"},[_c('span',[_vm._v(_vm._s(prod.name))]),_vm._v(" "),(prod.extra)?_c('span',{staticStyle:{"display":"block"}},[_vm._v(_vm._s(prod.extra))]):_vm._e(),_vm._v(" "),(prod.additional_info)?_c('span',{staticStyle:{"display":"block","color":"#0099FF"}},[_vm._v(_vm._s(_vm.$t('addOrder.info'))+": "+_vm._s(prod.additional_info))]):_vm._e(),_vm._v(" "),(prod.is_bonus)?_c('span',{staticStyle:{"display":"block","color":"#20C598"}},[_vm._v(_vm._s(_vm.$t('addOrder.freeProd')))]):_vm._e(),_vm._v(" "),(prod.partial_pay)?_c('span',{staticStyle:{"display":"block","color":"#f3bb45"},on:{"click":function($event){_vm.modifyProduct(prod)}}},[_vm._v(_vm._s(_vm.$t('addOrder.partialPay')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"product_wrapper"},[_c('div',{staticClass:"quantity"},[_c('button',{on:{"click":function($event){_vm.editToCartUpdateQuantity(prod.quantity-1, prod.id, prod.index)}}},[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(prod.quantity))]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.editToCartUpdateQuantity(prod.quantity+1, prod.id, prod.index)}}},[_vm._v("+")])]),_vm._v(" "),_c('div',{staticClass:"product_right"},[_c('div',[_c('span',[_vm._v(_vm._s(prod.price.toFixed(2))+" "+_vm._s(_vm.company.currency_symbol))])]),_vm._v(" "),_c('button',{staticClass:"product__modify",on:{"click":function($event){_vm.modifyProduct(prod)}}},[_vm._v(_vm._s(_vm.$t('addOrder.modif')))]),_vm._v(" "),_c('button',{staticClass:"product__delete",on:{"click":function($event){_vm.deleteProductPopup(prod.id, prod.index)}}},[_vm._v("X")])])])])]})]:[_c('div',{staticClass:"noProducts"},[_c('p',[_vm._v(_vm._s(_vm.$t('general.noProductPos')))])])]],2):_vm._e()])]),_vm._v(" "),(!_vm.isInEditMode && _vm.curentLocation && !_vm.company.flag_fast_order_from_admin)?_c('div',{staticClass:"location"},[_c('p',[_vm._v(_vm._s(_vm.$t('addOrder.selectPayment')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"60%"}},[_c('div',{staticClass:"payMethod"},[(_vm.payMethod != 'free' && _vm.posIsAvailable)?_c('button',{class:(_vm.payMethod == 'pos') ? 'active' : '',on:{"click":function($event){_vm.payMethod = 'pos'}}},[_vm._v(_vm._s(_vm.$t('addOrder.pos')))]):_vm._e(),_vm._v(" "),(_vm.payMethod != 'free' && !_vm.posIsAvailable)?_c('div'):_vm._e(),_vm._v(" "),(_vm.payMethod != 'free' && _vm.cashIsAvailable)?_c('button',{class:(_vm.payMethod == 'cash') ? 'active' : '',on:{"click":function($event){_vm.payMethod = 'cash'}}},[_vm._v(_vm._s(_vm.$t('addOrder.cash')))]):_vm._e(),_vm._v(" "),((!_vm.company.print_fiscal_from_dashboard))?_c('button',{class:(_vm.payMethod == 'protocol') ? 'active' : '',on:{"click":function($event){_vm.payMethod = 'protocol'}}},[_vm._v(_vm._s(_vm.$t('addOrder.protocol')))]):_vm._e(),_vm._v(" "),(_vm.payMethod === 'free')?_c('button',{class:(_vm.payMethod == 'free') ? 'active' : '',on:{"click":function($event){_vm.payMethod = 'free'}}},[_vm._v(_vm._s(_vm.$t('addOrder.free')))]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.cart && _vm.cart.myCart && _vm.company)?_c('div',{staticClass:"total-box"},[(_vm.curentLocation)?_c('div',{staticClass:"location marketing"},[(_vm.cart)?_c('div',{staticClass:"buttons"},[(_vm.cart.use_coupon_discount && _vm.cart.coupon_discount_value <= 0)?_c('button',{staticClass:"discount",on:{"click":function($event){_vm.addOrRemoveCupon(1)}}},[_vm._v(_vm._s(_vm.$t('addOrder.addCoupon')))]):_vm._e(),_vm._v(" "),(_vm.cart.use_coupon_discount && _vm.cart.coupon_discount_value > 0)?_c('button',{staticClass:"discount",on:{"click":function($event){_vm.addOrRemoveCupon(0)}}},[_vm._v(_vm._s(_vm.$t('addOrder.removeCoupon')))]):_vm._e(),_vm._v(" "),(_vm.$session.get('selectedCompany') != 109)?[(_vm.cart.use_loyalty_points && !_vm.cart.loyalty_discount_value)?_c('button',{staticClass:"loyalty_points",on:{"click":function($event){_vm.useOrRemoveLoyaltyPoints(1)}}},[_vm._v(_vm._s(_vm.$t('general.applyPoints'))+" "+_vm._s(_vm.client.loyalty_points))]):_vm._e(),_vm._v(" "),(_vm.cart.use_loyalty_points && _vm.cart.loyalty_discount_value)?_c('button',{staticClass:"loyalty_points",on:{"click":function($event){_vm.useOrRemoveLoyaltyPoints(0)}}},[_vm._v("Sterge punctele "+_vm._s(_vm.client.loyalty_points))]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.cart.use_tips && _vm.cart.order_totals.find( function (ref) {
	var name = ref.name;

	return name === 'Tip';
}).value <= 0)?_c('button',{staticClass:"tips",on:{"click":function($event){_vm.addOrRemoveTip(1)}}},[_vm._v(_vm._s(_vm.$t('addOrder.addTip')))]):_vm._e(),_vm._v(" "),(_vm.cart.use_tips && _vm.cart.order_totals.find( function (ref) {
	var name = ref.name;

	return name === 'Tip';
}).value > 0)?_c('button',{staticClass:"tips",on:{"click":function($event){_vm.addOrRemoveTip(0)}}},[_vm._v(_vm._s(_vm.$t('addOrder.removeTip')))]):_vm._e()],2):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"addToCart"},[_vm._l(((_vm.cart.order_totals || [])),function(totalsOptions){return [(totalsOptions.use)?[(totalsOptions.value != 0)?_c('div',{staticClass:"totalsOptions"},[_c('span',[_vm._v(_vm._s(totalsOptions.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(totalsOptions.value)+" "+_vm._s(_vm.company.currency_symbol))])]):_vm._e()]:_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"total"},[_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.total')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.cart.myCart.total_cart_price)+" "+_vm._s(_vm.company.currency_symbol))])]),_vm._v(" "),(_vm.isInEditMode)?_c('button',{staticClass:"orderNow",attrs:{"disabled":_vm.loadingCompleteOrder || _vm.loadingAddRemoveRequest > 0},on:{"click":function($event){_vm.editOrderNow()}}},[_vm._v(_vm._s(_vm.$t('addOrder.editOrderNow')))]):_vm._e(),_vm._v(" "),(!_vm.isInEditMode && (!_vm.company.print_fiscal_from_dashboard))?_c('button',{staticClass:"orderNow",attrs:{"disabled":_vm.loadingCompleteOrder || _vm.loadingAddRemoveRequest > 0},on:{"click":function($event){_vm.orderNow()}}},[_vm._v(_vm._s(_vm.$t('addOrder.orderNow')))]):_vm._e()],2),_vm._v(" "),(!_vm.isInEditMode && (_vm.company.print_fiscal_from_dashboard))?_c('div',{staticClass:"print-fiscal-buttons"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderCui),expression:"orderCui"}],staticClass:"input",attrs:{"type":"text","name":"cui","placeholder":_vm.$t('orders.cui')},domProps:{"value":(_vm.orderCui)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orderCui=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"pay-button",on:{"click":_vm.openPayModal}},[_vm._v("\n                  "+_vm._s(_vm.$t('paymentPage.pay'))+"\n                ")])]):_vm._e()]):_vm._e()])])])]),_vm._v(" "),_c('vmodal',{staticClass:"payModal",attrs:{"name":"payModal","title":"Pay Modal","width":"950","height":"310","maxWidth":950,"minWidth":200,"adaptive":true}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"actionTitle"},[_c('p',[_vm._v(_vm._s(_vm.$t('addOrder.choosePay')))])]),_vm._v(" "),(_vm.company.payment_btns_v2)?[_c('div',{staticClass:"actionButton"},[_c('div',{staticClass:"row",staticStyle:{"width":"100%","display":"flex","align-items":"center","justify-content":"space-around"}},[_c('button',{staticClass:"orderWithPaymentButton cash",staticStyle:{"width":"30%","margin":"0"},attrs:{"disabled":_vm.loadingCompleteOrder || _vm.loadingAddRemoveRequest > 0},on:{"click":function($event){_vm.orderNow(1)}}},[_vm._v(_vm._s(_vm.$t('orders.cash')))]),_vm._v(" "),_c('button',{staticClass:"orderWithPaymentButton blue card",staticStyle:{"width":"30%","margin":"0"},attrs:{"disabled":_vm.loadingCompleteOrder || _vm.loadingAddRemoveRequest > 0},on:{"click":function($event){_vm.orderNow(8)}}},[_vm._v(_vm._s(_vm.$t('orders.card')))]),_vm._v(" "),_c('button',{staticClass:"orderWithPaymentButton blue",staticStyle:{"width":"30%","margin":"0"},attrs:{"disabled":_vm.loadingCompleteOrder || _vm.loadingAddRemoveRequest > 0},on:{"click":function($event){_vm.orderNow(9)}}},[_vm._v(_vm._s(_vm.$t('orders.virament')))])])])]:[_c('div',{staticClass:"actionButton"},[_c('div',{staticClass:"row"},[_c('button',{staticClass:"orderWithPaymentButton cash",attrs:{"disabled":_vm.loadingCompleteOrder || _vm.loadingAddRemoveRequest > 0},on:{"click":function($event){_vm.orderNow(1)}}},[_vm._v(_vm._s(_vm.$t('orders.cash')))]),_vm._v(" "),_c('button',{staticClass:"orderWithPaymentButton noPos",attrs:{"disabled":_vm.loadingCompleteOrder || _vm.loadingAddRemoveRequest > 0},on:{"click":function($event){_vm.orderNow(8)}}},[_vm._v(_vm._s(_vm.$t('orders.card_no_pos')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('button',{staticClass:"orderWithPaymentButton blue",attrs:{"disabled":_vm.loadingCompleteOrder || _vm.loadingAddRemoveRequest > 0},on:{"click":function($event){_vm.orderNow(7)}}},[_vm._v(_vm._s(_vm.$t('orders.online')))]),_vm._v(" "),_c('button',{staticClass:"orderWithPaymentButton blue card",attrs:{"disabled":_vm.loadingCompleteOrder || _vm.loadingAddRemoveRequest > 0},on:{"click":function($event){_vm.orderNow(2)}}},[_vm._v(_vm._s(_vm.$t('orders.card')))]),_vm._v(" "),_c('button',{staticClass:"orderWithPaymentButton blue",attrs:{"disabled":_vm.loadingCompleteOrder || _vm.loadingAddRemoveRequest > 0},on:{"click":function($event){_vm.orderNow()}}},[_vm._v(_vm._s(_vm.$t('addOrder.orderNow')))])])])]],2)]),_vm._v(" "),_c('vmodal',{staticClass:"comment-modal",attrs:{"name":"commentModal","width":"550","height":"290","maxWidth":950,"minWidth":200,"adaptive":true}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('addOrder.commentTitle')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"textAndBtns"},[_c('div',{staticClass:"textarea"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderComent),expression:"orderComent"}],attrs:{"name":"comentariu","cols":"30","rows":"2","placeholder":_vm.$t('addOrder.coment')},domProps:{"value":(_vm.orderComent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orderComent=$event.target.value}}})]),_vm._v(" "),(_vm.isInEditMode)?_c('div',{staticClass:"textarea"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderClientNotification),expression:"orderClientNotification"}],attrs:{"name":"client_notif","cols":"30","rows":"2","placeholder":_vm.$t('addOrder.client_notif')},domProps:{"value":(_vm.orderClientNotification)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orderClientNotification=$event.target.value}}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{on:{"click":_vm.submitComment}},[_vm._v("Save")])])])]),_vm._v(" "),_c('vmodal',{staticClass:"userModal",attrs:{"name":"userModal","title":"userModal","width":"70%","maxWidth":800,"minWidth":200,"height":"90%","adaptive":true}},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.$t('addOrder.existingClient')))]),_vm._v(" "),_c('div',{staticClass:"tagg"},[_vm._l((_vm.availableTags),function(tag){return [_c('button',{class:_vm.selectedTag === tag ? 'active' : '',on:{"click":function($event){_vm.selectedTag = tag}}},[_vm._v(_vm._s(tag))])]})],2)]),_vm._v(" "),(_vm.client)?[_c('div',{staticClass:"content",staticStyle:{"overflow":"hidden","height":"auto"}},[_c('div',{staticClass:"content_scrool"},[_c('div',{staticClass:"add_client_wrapper"},[_c('h3',[_vm._v(_vm._s(_vm.$t('addOrder.clientSelected')))]),_vm._v(" "),(_vm.new_client)?_c('button',{staticClass:"add_client",on:{"click":function($event){_vm.addNewClient()}}},[_vm._v(_vm._s(_vm.$t('addOrder.clearFields')))]):_vm._e()]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('addOrder.contactPers')))]),_vm._v(" "),_c('div',{staticClass:"fields__wrapper"},[_c('div',{staticClass:"fields"},[_c('div',[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('addOrder.prodId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.id),expression:"client.id"}],attrs:{"type":"text","name":"name","disabled":""},domProps:{"value":(_vm.client.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "id", $event.target.value)}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('addOrder.lastName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.lastname),expression:"client.lastname"}],attrs:{"type":"text","name":"name"},domProps:{"value":(_vm.client.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "lastname", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('addOrder.firstName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.firstname),expression:"client.firstname"}],attrs:{"type":"text","name":"name"},domProps:{"value":(_vm.client.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "firstname", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',[_c('label',{attrs:{"for":"phone"}},[_vm._v(_vm._s(_vm.$t('customers.phone')))]),_vm._v(" "),(_vm.client_phone_is_empty)?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.phone),expression:"client.phone"}],attrs:{"type":"text","name":"phone"},domProps:{"value":(_vm.client.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "phone", $event.target.value)}}})]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.phone),expression:"client.phone"}],attrs:{"type":"text","disabled":"","name":"phone"},domProps:{"value":(_vm.client.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "phone", $event.target.value)}}})]],2),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"email"}},[_vm._v(_vm._s(_vm.$t('customers.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.email),expression:"client.email"}],attrs:{"type":"text","disabled":"","name":"email"},domProps:{"value":(_vm.client.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client, "email", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"fields__wrapper",staticStyle:{"justify-content":"flex-start","flex-direction":"row","align-items":"center"}},[_c('div',{staticClass:"datepicker"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.birthdate')))]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":_vm.pickerOptions},model:{value:(_vm.client.birthdate),callback:function ($$v) {_vm.$set(_vm.client, "birthdate", $$v)},expression:"client.birthdate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"sex"},[_c('label',{staticClass:"sex__title"},[_vm._v("Sex")]),_vm._v(" "),_c('label',{attrs:{"for":"Masculin"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.gender),expression:"client.gender"}],attrs:{"type":"radio","name":"gender","value":"M","id":"Masculin","placeholder":_vm.$t('addOrder.sexm')},domProps:{"checked":_vm._q(_vm.client.gender,"M")},on:{"change":function($event){_vm.$set(_vm.client, "gender", "M")}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.sexm')))])]),_vm._v(" "),_c('label',{attrs:{"for":"Feminin"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.gender),expression:"client.gender"}],attrs:{"type":"radio","name":"gender","value":"F","id":"Feminin","placeholder":_vm.$t('addOrder.sexf')},domProps:{"checked":_vm._q(_vm.client.gender,"F")},on:{"change":function($event){_vm.$set(_vm.client, "gender", "F")}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.sexf')))])])])]),_vm._v(" "),_c('div',[(_vm.activeMethod == 'eat_location')?_c('div',{staticClass:"fields__wrapper"},[_c('label',{attrs:{"for":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.how_many')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.how_many),expression:"how_many"}],attrs:{"type":"number","min":"1","max":"1000"},domProps:{"value":(_vm.how_many)},on:{"input":function($event){if($event.target.composing){ return; }_vm.how_many=$event.target.value}}})])]):_vm._e()]),_vm._v(" "),_c('div',[_c('button',{staticClass:"goToClient",on:{"click":function($event){_vm.goToClient(_vm.client.id)}}},[_vm._v("Go To Client")])])])]),_vm._v(" "),_c('div',{staticClass:"userModal__footer"},[_c('button',{on:{"click":function($event){_vm.saveClient()}}},[_vm._v(_vm._s(_vm.$t('addOrder.save1')))])])]:[_c('div',{staticClass:"content",staticStyle:{"overflow":"hidden","height":"auto"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('addOrder.newclient')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('addOrder.contactperson')))]),_vm._v(" "),_c('div',{staticClass:"fields__wrapper"},[_c('div',{staticClass:"fields"},[_c('div',{staticClass:"inputWithSearch"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('addOrder.prodId')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.id),expression:"new_client.id"}],ref:"clientIdRef",class:_vm.new_clientErrors.id,attrs:{"type":"text","autocomplete":"none","title":"name"},domProps:{"value":(_vm.new_client.id)},on:{"keyup":_vm.searchById,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "id", $event.target.value)}}}),_vm._v(" "),(_vm.existingId.length)?_c('div',{staticClass:"inputWithSearch_search"},[_vm._l((_vm.existingId),function(client){return [_c('div',{staticClass:"client",on:{"click":function($event){_vm.selectClient(client)}}},[_c('div',{staticClass:"client__details"},[(client.firstname)?_c('span',[_vm._v(_vm._s(client.firstname))]):_vm._e(),_vm._v(" "),(client.lastname)?_c('span',[_vm._v(_vm._s(client.lastname))]):_vm._e(),_vm._v(" "),(!client.firstname && !client.lastname)?_c('span',[_vm._v(_vm._s(client.email))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"client__adress"},[(client.phone)?_c('span',[_vm._v(_vm._s(client.phone))]):_vm._e()])])]})],2):_vm._e()]),_vm._v(" "),(_vm.canAddNoClient)?_c('div',{staticClass:"inputWithSearch"},[_c('div',{staticClass:"select_default"},[_c('button',{on:{"click":function($event){{_vm.selectClient(_vm.defaultUser); _vm.selectedTag = 'inlocation'}}}},[_vm._v(_vm._s(_vm.$t('addOrder.noClient')))])])]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"inputWithSearch"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('addOrder.lastName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.lastname),expression:"new_client.lastname"}],class:_vm.new_clientErrors.lastname,attrs:{"type":"text","autocomplete":"none","title":"name"},domProps:{"value":(_vm.new_client.lastname)},on:{"keyup":function($event){_vm.searchByName2()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "lastname", $event.target.value)}}}),_vm._v(" "),(_vm.existingNames2.length)?_c('div',{staticClass:"inputWithSearch_search"},[_vm._l((_vm.existingNames2),function(client){return [_c('div',{staticClass:"client",on:{"click":function($event){_vm.selectClient(client)}}},[_c('div',{staticClass:"client__details"},[(client.firstname)?_c('span',[_vm._v(_vm._s(client.firstname))]):_vm._e(),_vm._v(" "),(client.lastname)?_c('span',[_vm._v(_vm._s(client.lastname))]):_vm._e(),_vm._v(" "),(!client.firstname && !client.lastname)?_c('span',[_vm._v(_vm._s(client.email))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"client__adress"},[(client.phone)?_c('span',[_vm._v(_vm._s(client.phone))]):_vm._e()])])]})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"inputWithSearch"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('addOrder.firstName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.firstname),expression:"new_client.firstname"}],class:_vm.new_clientErrors.firstname,attrs:{"type":"text","autocomplete":"none","title":"name"},domProps:{"value":(_vm.new_client.firstname)},on:{"keyup":function($event){_vm.searchByName()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "firstname", $event.target.value)}}}),_vm._v(" "),(_vm.existingNames.length)?_c('div',{staticClass:"inputWithSearch_search"},[_vm._l((_vm.existingNames),function(client){return [_c('div',{staticClass:"client",on:{"click":function($event){_vm.selectClient(client)}}},[_c('div',{staticClass:"client__details"},[(client.firstname)?_c('span',[_vm._v(_vm._s(client.firstname))]):_vm._e(),_vm._v(" "),(client.lastname)?_c('span',[_vm._v(_vm._s(client.lastname))]):_vm._e(),_vm._v(" "),(!client.firstname && !client.lastname)?_c('span',[_vm._v(_vm._s(client.email))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"client__adress"},[(client.phone)?_c('span',[_vm._v(_vm._s(client.phone))]):_vm._e()])])]})],2):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"inputWithSearch"},[_c('label',{attrs:{"for":"phone"}},[_vm._v(_vm._s(_vm.$t('customers.phone')))]),_vm._v(" "),(_vm.company.use_calling_phone)?_c('button',{staticClass:"autoPhone",on:{"click":function($event){_vm.autocompletePhone()}}},[_vm._v(_vm._s(_vm.$t('customers.use_calling_phone')))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.phone),expression:"new_client.phone"}],class:_vm.new_clientErrors.phone,attrs:{"type":"text","autocomplete":"none","title":"phone"},domProps:{"value":(_vm.new_client.phone)},on:{"keyup":function($event){_vm.searchByPhone()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "phone", $event.target.value)}}}),_vm._v(" "),(_vm.existingPhones.length)?_c('div',{staticClass:"inputWithSearch_search"},[_vm._l((_vm.existingPhones),function(client){return [_c('div',{staticClass:"client",on:{"click":function($event){_vm.selectClient(client)}}},[_c('div',{staticClass:"client__details"},[(client.firstname)?_c('span',[_vm._v(_vm._s(client.firstname))]):_vm._e(),_vm._v(" "),(client.lastname)?_c('span',[_vm._v(_vm._s(client.lastname))]):_vm._e(),_vm._v(" "),(!client.firstname && !client.lastname)?_c('span',[_vm._v(_vm._s(client.email))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"client__adress"},[(client.phone)?_c('span',[_vm._v(_vm._s(client.phone))]):_vm._e()])])]})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"inputWithSearch"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.email),expression:"new_client.email"}],class:_vm.new_clientErrors.email,attrs:{"type":"text","autocomplete":"none","title":"email"},domProps:{"value":(_vm.new_client.email)},on:{"keyup":function($event){_vm.searchByEmail()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "email", $event.target.value)}}}),_vm._v(" "),(_vm.existingEmails.length)?_c('div',{staticClass:"inputWithSearch_search"},[_vm._l((_vm.existingEmails),function(client){return [_c('div',{staticClass:"client",on:{"click":function($event){_vm.selectClient(client)}}},[_c('div',{staticClass:"client__details"},[_c('span',[_vm._v(_vm._s(client.email))])])])]})],2):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"fields__wrapper",staticStyle:{"justify-content":"flex-start","flex-direction":"row","align-items":"center"}},[_c('div',{staticClass:"datepicker"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.birthdate')))]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":_vm.pickerOptions},model:{value:(_vm.new_client.birthdate),callback:function ($$v) {_vm.$set(_vm.new_client, "birthdate", $$v)},expression:"new_client.birthdate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"sex"},[_c('label',{staticClass:"sex__title"},[_vm._v(_vm._s(_vm.$t('addOrder.sex')))]),_vm._v(" "),_c('label',{attrs:{"for":"Masculin"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.gender),expression:"new_client.gender"}],attrs:{"type":"radio","name":"gender","value":"M","id":"Masculin","placeholder":_vm.$t('addOrder.sexm')},domProps:{"checked":_vm._q(_vm.new_client.gender,"M")},on:{"change":function($event){_vm.$set(_vm.new_client, "gender", "M")}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.sexm')))])]),_vm._v(" "),_c('label',{attrs:{"for":"Feminin"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.gender),expression:"new_client.gender"}],attrs:{"type":"radio","name":"gender","value":"F","id":"Feminin","placeholder":_vm.$t('addOrder.sexf')},domProps:{"checked":_vm._q(_vm.new_client.gender,"F")},on:{"change":function($event){_vm.$set(_vm.new_client, "gender", "F")}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.sexf')))])])])])]),_vm._v(" "),_c('div',{staticClass:"userModal__footer"},[_c('button',{on:{"click":function($event){_vm.addClient()}}},[_vm._v(_vm._s(_vm.$t('addOrder.add')))])])]],2),_vm._v(" "),_c('vmodal',{staticClass:"adressModal",attrs:{"name":"adressModal","title":"adressModal","width":"70%","height":"90%","maxWidth":800,"minWidth":200,"adaptive":true}},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.$t('addOrder.newadress')))])]),_vm._v(" "),(_vm.client)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"content_scrool"},[(_vm.client && _vm.client.addresses.length)?_c('h3',[_vm._v("Adresele Clientului")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"addresses"},[_vm._l((_vm.client.addresses),function(adr){return [_c('div',{staticClass:"adr2"},[_c('div',{class:(_vm.client.address && _vm.client.address.id == adr.id) ? 'adr selected' : 'adr',on:{"click":function($event){_vm.selectAdress(adr)}}},[_c('p',[_c('b',[_vm._v(_vm._s(adr.address_name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(adr.street)+" "+_vm._s(adr.number)+" "+_vm._s(adr.city)+" "+_vm._s(adr.state))])]),_vm._v(" "),_c('div',{staticClass:"deleteAdress__wrapper"},[_c('button',{staticClass:"deleteAdress",on:{"click":function($event){_vm.deleteAdress(adr.id)}}},[_vm._v("Delete")])])])]})],2),_vm._v(" "),(!_vm.client.address || (_vm.client.address && !_vm.client.address.id))?_c('div',{},[_c('h3',[_vm._v(_vm._s(_vm.$t('addOrder.deliveryAdress')))]),_vm._v(" "),_c('div',{staticClass:"fields__wrapper"},[_c('div',{staticClass:"fields"},[_c('div',[_c('label',{attrs:{"for":"address_name"}},[_vm._v(_vm._s(_vm.$t('addOrder.adressname')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.address_name),expression:"new_client.address_name"}],attrs:{"type":"text","name":"address_name"},domProps:{"value":(_vm.new_client.address_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "address_name", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"address_street"}},[_vm._v(_vm._s(_vm.$t('addOrder.street')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.address_street),expression:"new_client.address_street"}],class:_vm.new_clientErrors.address_street,attrs:{"type":"text","name":"address_street"},domProps:{"value":(_vm.new_client.address_street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "address_street", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',[_c('label',{attrs:{"for":"address_number"}},[_vm._v(_vm._s(_vm.$t('addOrder.number')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.address_number),expression:"new_client.address_number"}],class:_vm.new_clientErrors.address_number,attrs:{"type":"text","name":"address_number"},domProps:{"value":(_vm.new_client.address_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "address_number", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"address_apartment"}},[_vm._v(_vm._s(_vm.$t('addOrder.adress')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.address_apartment),expression:"new_client.address_apartment"}],class:_vm.new_clientErrors.address_apartment,attrs:{"type":"text","name":"address_apartment"},domProps:{"value":(_vm.new_client.address_apartment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "address_apartment", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',[_c('label',{attrs:{"for":"address_city"}},[_vm._v(_vm._s(_vm.$t('addOrder.city')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.address_city),expression:"new_client.address_city"}],class:_vm.new_clientErrors.address_city,attrs:{"type":"text","name":"address_city"},domProps:{"value":(_vm.new_client.address_city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "address_city", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"address_county"}},[_vm._v(_vm._s(_vm.$t('addOrder.state')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.address_county),expression:"new_client.address_county"}],class:_vm.new_clientErrors.address_county,attrs:{"type":"text","name":"address_county"},domProps:{"value":(_vm.new_client.address_county)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "address_county", $event.target.value)}}})])])])]):_vm._e(),_vm._v(" "),(_vm.client.address && _vm.client.address.id)?_c('div',{},[_c('div',{staticClass:"add_client_wrapper"},[_c('h3',[_vm._v(_vm._s(_vm.$t('addOrder.deliveryAdressEdit')))]),_vm._v(" "),_c('button',{staticClass:"add_client",on:{"click":function($event){_vm.addNewAdress()}}},[_vm._v(_vm._s(_vm.$t('addOrder.clearFields')))])]),_vm._v(" "),_c('div',{staticClass:"fields__wrapper"},[_c('div',{staticClass:"fields"},[_c('div',[_c('label',{attrs:{"for":"address_name"}},[_vm._v(_vm._s(_vm.$t('addOrder.adressname')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.address.address_name),expression:"client.address.address_name"}],attrs:{"type":"text","name":"address_name"},domProps:{"value":(_vm.client.address.address_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client.address, "address_name", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"address_street"}},[_vm._v(_vm._s(_vm.$t('addOrder.street')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.address.street),expression:"client.address.street"}],class:_vm.new_clientErrors.address_street,attrs:{"type":"text","name":"address_street"},domProps:{"value":(_vm.client.address.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client.address, "street", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',[_c('label',{attrs:{"for":"address_number"}},[_vm._v(_vm._s(_vm.$t('addOrder.number')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.address.number),expression:"client.address.number"}],class:_vm.new_clientErrors.address_number,attrs:{"type":"text","name":"address_number"},domProps:{"value":(_vm.client.address.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client.address, "number", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"address_apartment"}},[_vm._v(_vm._s(_vm.$t('addOrder.adress')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.address.apartment),expression:"client.address.apartment"}],class:_vm.new_clientErrors.address_apartment,attrs:{"type":"text","name":"address_apartment"},domProps:{"value":(_vm.client.address.apartment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client.address, "apartment", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',[_c('label',{attrs:{"for":"address_city"}},[_vm._v(_vm._s(_vm.$t('addOrder.city')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.address.city),expression:"client.address.city"}],class:_vm.new_clientErrors.address_city,attrs:{"type":"text","name":"address_city"},domProps:{"value":(_vm.client.address.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client.address, "city", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"address_county"}},[_vm._v(_vm._s(_vm.$t('addOrder.state')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.address.state),expression:"client.address.state"}],class:_vm.new_clientErrors.address_county,attrs:{"type":"text","name":"address_county"},domProps:{"value":(_vm.client.address.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.client.address, "state", $event.target.value)}}})])])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.client)?_c('div',{staticClass:"userModal__footer"},[(!_vm.client.address || (_vm.client.address && !_vm.client.address.id))?_c('button',{on:{"click":function($event){_vm.addAddress()}}},[_vm._v(_vm._s(_vm.$t('addOrder.add')))]):_vm._e(),_vm._v(" "),(_vm.client.address && _vm.client.address.id)?_c('button',{on:{"click":function($event){_vm.editAddress()}}},[_vm._v(_vm._s(_vm.$t('addOrder.edit')))]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('vmodal',{staticClass:"productModal",attrs:{"name":"productModal","width":"90%","height":"90%","maxWidth":755,"minWidth":200,"adaptive":true}},[_c('div',{staticClass:"productModal__wrapper"},[(_vm.currentProductInPopup && _vm.currentProductInPopup.image_url[0]['url'])?[_c('div',{staticClass:"photo",style:('background-image: url(\''+_vm.currentProductInPopup.image_url[0]['url']+'\');')})]:_vm._e(),_vm._v(" "),(_vm.currentProductInPopup)?_c('div',{staticClass:"productModal__product"},[_c('div',{staticClass:"title__wraper"},[_c('div',{staticClass:"title"},[_c('p',[_vm._v(_vm._s(_vm.currentProductInPopup.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.currentProductInPopup.price_details.formatted_price))])]),_vm._v(" "),_c('div',[(_vm.currentProductInPopup.description && _vm.currentProductInPopup.description.length > 255)?[_c('p',[_vm._v(_vm._s(_vm.currentProductInPopup.description.substring(0, 255))+"...")])]:[_c('p',[_vm._v(_vm._s(_vm.currentProductInPopup.description))])]],2)])]):_vm._e(),_vm._v(" "),(_vm.currentProductInPopup)?_c('div',{staticClass:"options__wrapper"},_vm._l((_vm.currentProductInPopup.product_options),function(option,optionIdx){return _c('div',{staticClass:"option"},[_c('p',[_vm._v(_vm._s(option.name)+" "),(option.min_no)?_c('span',[_vm._v("Min: "+_vm._s(option.min_no))]):_vm._e(),_vm._v(" "),(option.max_no)?_c('span',[_vm._v("Max: "+_vm._s(option.max_no))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"options"},_vm._l((option.values),function(values,valuesIdx){return _c('div',[_c('label',{attrs:{"for":values.id}},[((option.type === 'checkbox'))?[((option.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(values.checked),expression:"values.checked"}],attrs:{"name":option.id,"id":values.id,"type":"checkbox"},domProps:{"value":values.id,"checked":Array.isArray(values.checked)?_vm._i(values.checked,values.id)>-1:(values.checked)},on:{"change":[function($event){var $$a=values.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=values.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(values, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(values, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(values, "checked", $$c)}},function($event){_vm.updateCategories()}]}}):((option.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(values.checked),expression:"values.checked"}],attrs:{"name":option.id,"id":values.id,"type":"radio"},domProps:{"value":values.id,"checked":_vm._q(values.checked,values.id)},on:{"change":[function($event){_vm.$set(values, "checked", values.id)},function($event){_vm.updateCategories()}]}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(values.checked),expression:"values.checked"}],attrs:{"name":option.id,"id":values.id,"type":option.type},domProps:{"value":values.id,"value":(values.checked)},on:{"change":function($event){_vm.updateCategories()},"input":function($event){if($event.target.composing){ return; }_vm.$set(values, "checked", $event.target.value)}}})]:((option.type === 'radio'))?[((option.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.checked),expression:"option.checked"}],attrs:{"name":option.id,"id":values.id,"type":"checkbox"},domProps:{"value":values.id,"checked":Array.isArray(option.checked)?_vm._i(option.checked,values.id)>-1:(option.checked)},on:{"change":[function($event){var $$a=option.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=values.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(option, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(option, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(option, "checked", $$c)}},function($event){_vm.updateCategories()}]}}):((option.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.checked),expression:"option.checked"}],attrs:{"name":option.id,"id":values.id,"type":"radio"},domProps:{"value":values.id,"checked":_vm._q(option.checked,values.id)},on:{"change":[function($event){_vm.$set(option, "checked", values.id)},function($event){_vm.updateCategories()}]}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.checked),expression:"option.checked"}],attrs:{"name":option.id,"id":values.id,"type":option.type},domProps:{"value":values.id,"value":(option.checked)},on:{"change":function($event){_vm.updateCategories()},"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "checked", $event.target.value)}}})]:((option.type === 'upload'))?[_c('input',{ref:values.id,refInFor:true,attrs:{"type":"file","name":option.id,"id":values.id},on:{"change":function($event){_vm.updateCategories()}}})]:_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(values.name)+" "),(values.price > 0)?_c('span',[_vm._v("(+ "+_vm._s(values.price)+" "+_vm._s(_vm.currentProductInPopup.price_details.currency_symbol)+")")]):_vm._e()])],2),_vm._v(" "),((option.type === 'upload') && values.checked)?_c('div',{staticClass:"img",staticStyle:{"margin-bottom":"20px"}},[_c('img',{staticStyle:{"max-width":"70px","max-height":"70px"},attrs:{"src":values.file}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#FF0D19","margin-left":"20px","font-size":"20px","font-weight":"500"},on:{"click":function($event){_vm.removeImage(optionIdx, valuesIdx)}}},[_vm._v("X")])]):_vm._e()])}))])})):_vm._e(),_vm._v(" "),(_vm.currentProductInPopup && _vm.currentProductInPopup.allow_user_comments)?_c('div',{staticClass:"info__wrapper"},[_c('p',[_vm._v(_vm._s(_vm.$t('addOrder.infosup')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentProductInPopup.additional_info),expression:"currentProductInPopup.additional_info"}],attrs:{"name":"info"},domProps:{"value":(_vm.currentProductInPopup.additional_info)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentProductInPopup, "additional_info", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.currentProductInPopup && _vm.currentProductInPopup.other_info.length)?_c('div',{staticClass:"other_info"},[_c('el-collapse',{attrs:{"accordion":""}},_vm._l((_vm.currentProductInPopup.other_info),function(other_info){return _c('div',{staticClass:"info"},[_c('el-collapse-item',{attrs:{"title":other_info.title,"name":other_info.id}},[_c('div',{staticClass:"description"},[_c('span',{domProps:{"innerHTML":_vm._s(other_info.description)}})])])],1)}))],1):_vm._e()],2),_vm._v(" "),(_vm.currentProductInPopup)?_c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer__quantity"},[_c('button',{on:{"click":function($event){_vm.updateQuantity(_vm.currentProductInPopup, 0)}}},[_vm._v("-")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currentProductInPopup.quantity))]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.updateQuantity(_vm.currentProductInPopup, 1)}}},[_vm._v("+")])]),_vm._v(" "),_c('div',{staticClass:"footer__price"},[_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.total')))]),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.currentProductInPopup.price_details.price)+" "+_vm._s(_vm.currentProductInPopup.price_details.currency_symbol))])]),_vm._v(" "),(_vm.currentProductInPopup.partial_pay)?_c('span',{staticStyle:{"background":"#0099FF","color":"#EFF9FE","text-transform":"uppercase","font-weight":"500","font-size":"20px","border":"0 solid #707070","border-radius":"10px","padding":"10px 12px"},on:{"click":function($event){_vm.changePrice()}}},[_vm._v(_vm._s(_vm.$t('addOrder.modif')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"footer__addToCart"},[(_vm.currentProductInPopup.in_edit)?[_c('button',{attrs:{"disabled":_vm.addToCartDisabled},on:{"click":function($event){_vm.editToCart()}}},[_vm._v(_vm._s(_vm.$t('addOrder.edit')))])]:[_c('button',{attrs:{"disabled":_vm.addToCartDisabled},on:{"click":function($event){_vm.addToCart()}}},[_vm._v(_vm._s(_vm.$t('addOrder.add')))])]],2)]):_vm._e()]),_vm._v(" "),_c('vmodal',{staticClass:"hourDateModal",attrs:{"name":"hourDateModal","width":"90%","height":"50%","maxWidth":755,"minWidth":200,"adaptive":true}},[_c('div',{staticClass:"dateSelect"},[(_vm.curentLocation && ((_vm.curentLocation.hour_and_date_delivery_hour_usage && !_vm.noDate) || _vm.curentLocation.just_date_delivery_hour_usage))?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('addOrder.datepicker')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","name":"Date","clearable":false,"value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":{ firstDayOfWeek: 1, disabledDate: function (time) { return _vm.disabledEndDate(time); } }},on:{"change":function($event){_vm.selectedDateChange($event)}},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)]:_vm._e(),_vm._v(" "),(_vm.choosenHours && !_vm.curentLocation.just_date_delivery_hour_usage)?_c('div',{staticClass:"available_hours_today"},[_c('label',{attrs:{"for":"hourpicker"}},[_vm._v(_vm._s(_vm.$t('addOrder.hourpicker')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedHour),expression:"selectedHour"}],attrs:{"name":"available_hours_today"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedHour=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){}]}},[_vm._l((_vm.choosenHours),function(hour,key){return [_c('option',{domProps:{"value":hour}},[(key === 0)?[_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.fast'))+": ")])]:_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(hour))])],2)]})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"directBtns"},[(_vm.choosenHours && _vm.choosenHours[1])?_c('button',{class:_vm.selectedHour === _vm.choosenHours[1] ? 'active' : '',on:{"click":function($event){_vm.selectedHour = _vm.choosenHours[1]}}},[_vm._v(_vm._s(_vm.choosenHours[1]))]):_vm._e(),_vm._v(" "),(_vm.choosenHours && _vm.choosenHours[2])?_c('button',{class:_vm.selectedHour === _vm.choosenHours[2] ? 'active' : '',on:{"click":function($event){_vm.selectedHour = _vm.choosenHours[2]}}},[_vm._v(_vm._s(_vm.choosenHours[2]))]):_vm._e(),_vm._v(" "),(_vm.choosenHours && _vm.choosenHours[3])?_c('button',{class:_vm.selectedHour === _vm.choosenHours[3] ? 'active' : '',on:{"click":function($event){_vm.selectedHour = _vm.choosenHours[3]}}},[_vm._v(_vm._s(_vm.choosenHours[3]))]):_vm._e(),_vm._v(" "),(_vm.choosenHours && _vm.choosenHours[4])?_c('button',{class:_vm.selectedHour === _vm.choosenHours[4] ? 'active' : '',on:{"click":function($event){_vm.selectedHour = _vm.choosenHours[4]}}},[_vm._v(_vm._s(_vm.choosenHours[4]))]):_vm._e(),_vm._v(" "),(_vm.choosenHours && _vm.choosenHours[5])?_c('button',{class:_vm.selectedHour === _vm.choosenHours[5] ? 'active' : '',on:{"click":function($event){_vm.selectedHour = _vm.choosenHours[5]}}},[_vm._v(_vm._s(_vm.choosenHours[5]))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"userModal__footer"},[_c('button',{on:{"click":function($event){_vm.$modal.hide('hourDateModal')}}},[_vm._v(_vm._s(_vm.$t('addOrder.done')))])])]),_vm._v(" "),_c('div',{staticClass:"mySwal2",attrs:{"id":"mySwal2"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge"},[_c('span',[_vm._v("1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge"},[_c('span',[_vm._v("2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge"},[_c('span',[_vm._v("3")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"productList_filter"},[_c('h3',[_vm._v("Categorii")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#/order-pos-client-screen","target":"_blanck"}},[_c('img',{attrs:{"src":"/static/img/icons/display-frame.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "me3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__("hASK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3861df99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__("qSga");
function injectStyle (ssrContext) {
  __webpack_require__("KihW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3861df99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mhAJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationMenuEntityEditPage_vue__ = __webpack_require__("kA6Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25779da5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationMenuEntityEditPage_vue__ = __webpack_require__("4VJU");
function injectStyle (ssrContext) {
  __webpack_require__("3h9K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25779da5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationMenuEntityEditPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25779da5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationMenuEntityEditPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mi3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Settings_Tabs_App_vue__ = __webpack_require__("AnFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Settings_Tabs_CompanyWeb_vue__ = __webpack_require__("XKKy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UIComponents_ModuleLocked_vue__ = __webpack_require__("hszr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HomepageSections_vue__ = __webpack_require__("INfR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InteractiveTour_vue__ = __webpack_require__("/l4D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Blog_vue__ = __webpack_require__("ErY3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfoPagesCustom_CustomInfoPages_vue__ = __webpack_require__("hQuq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InfoPages_InfoPages_vue__ = __webpack_require__("TUUy");











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppForm: __WEBPACK_IMPORTED_MODULE_0__Settings_Tabs_App_vue__["a" /* default */],
    CompanyWebForm: __WEBPACK_IMPORTED_MODULE_1__Settings_Tabs_CompanyWeb_vue__["a" /* default */],
    ModuleLocked: __WEBPACK_IMPORTED_MODULE_2__UIComponents_ModuleLocked_vue__["a" /* default */],
    HomepageSections: __WEBPACK_IMPORTED_MODULE_3__HomepageSections_vue__["a" /* default */],
    InteractiveTour: __WEBPACK_IMPORTED_MODULE_4__InteractiveTour_vue__["a" /* default */],
    Blog: __WEBPACK_IMPORTED_MODULE_5__Blog_vue__["a" /* default */],
    CustomInfoPages: __WEBPACK_IMPORTED_MODULE_6__InfoPagesCustom_CustomInfoPages_vue__["a" /* default */],
    InfoPages: __WEBPACK_IMPORTED_MODULE_7__InfoPages_InfoPages_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isApp: false,
      isCompanyWeb: false,
      isHomepageSections: false,
      isInteractiveTour: false,
      isBlog: false,
      isInfoPagesCustom: false,
      isInfoPages: false,
      model: {},
      defaultData: {},
      websiteData: []
    };
  },

  computed: {
    company: function company() {
      return this.userData && this.userData.companies && this.userData.companies[0] || {};
    }
  },
  mounted: function mounted() {
    this.userData = JSON.parse(this.$session.get('userData') || '{}');

    this.switchTab();
    this.getModelData();
  },

  methods: {
    resetStates: function resetStates() {
      this.isApp = false;
      this.isCompanyWeb = false;
      this.isHomepageSections = false;
      this.isInteractiveTour = false;
      this.isBlog = false;
      this.isInfoPagesCustom = false;
      this.isInfoPages = false;
    },
    switchTab: function switchTab() {
      var _this = this;

      var index = this.$route.query.tabIndex;
      this.$nextTick(function () {
        if (index && _this.$refs.tabs) {
          _this.$refs.tabs.navigateToTab(parseInt(index));
        }
      });
    },
    getModelData: function getModelData() {
      var _this2 = this;

      var token = this.$session.get('token');
      var companyID = this.$session.get('selectedCompany');

      this.apiRequest('/settings/general/' + companyID, 'GET', { token: token }, function (response2) {
        if (response2.status === true) {
          _this2.model = response2.data[0];
          _this2.model.selected_languages = response2.data[0].languages.map(function (lang) {
            return {
              value: lang.id,
              label: lang.name
            };
          });
        }
      });

      this.apiRequest('/settings/website', 'GET', {
        token: token,
        company_id: companyID
      }, function (response) {
        if (response.status === true) {
          _this2.websiteData = response.data;
          console.log('this.websiteData', _this2.websiteData);
        }
      });
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      this.resetStates();
      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);
      switch (newTab.title) {
        case this.$t('settingsPages.app'):
          this.isApp = true;
          break;
        case this.$t('settingsPages.companyWeb'):
          this.isCompanyWeb = true;
          break;
        case this.$t('pages.infoPagesCustom'):
          this.isInfoPagesCustom = true;
          break;
        case this.$t('pages.infoPages'):
          this.isInfoPages = true;
          break;
        case this.$t('settingsPages.homepageSections'):
          this.isHomepageSections = true;
          break;
        case this.$t('settingsPages.interactiveTour'):
          this.isInteractiveTour = true;
          break;
        case this.$t('settingsPages.blog'):
          this.isBlog = true;
          break;
        default:
          this.isApp = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ "mj8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__);












var _components;







__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PSwitch: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_input___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.loading = true;
    this.locations = this.$session.get('selectedCompanyData').locations_details;
    this.getSections();
    if (this.route.params.id) {
      this.getData();
    }
  },
  data: function data() {
    return {
      id: this.route.params.id || null,
      model: {
        name: null,
        is_offline: false,
        server_ip: null,
        yumm_integration_external_ip: '',
        sections: []
      },
      modelValidations: {
        name: {
          required: true,
          min: 3
        },
        color: {
          required: true
        }
      },
      isNew: true,
      loading: true,
      locations: [],
      sectionOptions: []
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/kds/' + this.id, 'GET', data, function (response) {
        if (response.status) {
          var _data = response.data;
          if (!_data.sections || !_data.sections.length) {
            _data.sections = _data.section ? [_data.section] : [];
          }
          _this.model = _data;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    getSections: function getSections() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/sections', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.sectionOptions = response.data;
        }
        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.updateOrCreateKds();
        }
      });
    },
    updateOrCreateKds: function updateOrCreateKds() {
      var _this4 = this;

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model);
      data.company_id = this.$session.get('selectedCompany');
      data.token = this.$session.get('token');

      if (data.sections && data.sections.length) {
        data.sections = data.sections.map(function (section) {
          return { id: section.id };
        });
      } else {
        data.sections = [];
      }

      var url = '/kds/';
      var httpMethod = '';

      if (this.id) {
        url += this.id;
        httpMethod = 'PUT';
      } else {
        httpMethod = 'POST';
      }

      this.apiRequest(url, httpMethod, data, function (response) {
        if (response.status === true) {
          var entityId = _this4.id || response.data && response.data.id || null;
          _this4.trackAdminEvent('ADMIN_KDS_UPDATE', 'kds', entityId, {
            kds_id: entityId,
            name: data.name || null,
            request: data,
            response: response
          });
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()('', 'Success', 'success');
          _this4.backButton();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    limitToOne: function limitToOne(val) {
      if (this.model.is_offline && Array.isArray(this.model.locations) && this.model.locations.length > 1) {
        console.log('REMOVE');
        this.model.locations = [this.model.locations[this.model.locations.length - 1]];
      }
    },
    handleDelete: function handleDelete() {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.loading = true;
      });
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/kds/' + this.id, 'DELETE', data, function (response) {
        if (response.status) {
          _this5.trackAdminEvent('ADMIN_KDS_DELETED', 'kds', _this5.id, {
            kds_id: _this5.id,
            name: _this5.model && _this5.model.name || null
          });
          _this5.$nextTick(function () {
            _this5.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({ 'text': 'Success', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this5.backButton();
        } else {
          _this5.$nextTick(function () {
            _this5.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({ 'text': _this5.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "mjPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPieCard_vue__ = __webpack_require__("uWep");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5171148_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPieCard_vue__ = __webpack_require__("F5yH");
function injectStyle (ssrContext) {
  __webpack_require__("ItDH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartPieCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5171148_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartPieCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mq1i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",style:({height: _vm.windowHeight - _vm.pageTopHeight - 60 + 'px'})},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"pull-left mar-bt-20"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('reports.search')},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.add'))+"\n          ")])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.filteredData,"current-page":_vm.pagination.currentPage,"page-size":_vm.pagination.pageSize,"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"20","prop":"true_id","label":"ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"100","prop":"name","label":_vm.$t('settingCompany.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"100","prop":"street","label":_vm.$t('settingCompany.street')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"100","prop":"email","label":_vm.$t('settingCompany.email')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"break-word"},[_vm._v(_vm._s(props.row.email))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"50","prop":"phone","label":_vm.$t('settingCompany.phone')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"40","prop":"active","label":_vm.$t('settingLocationGroups.active')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(props.$index, props.row, $event)}},model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"40","prop":"is_open","label":_vm.$t('settingLocationGroups.isOpen')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleIsOpen(props.$index, props.row, $event)}},model:{value:(props.row.is_open),callback:function ($$v) {_vm.$set(props.row, "is_open", $$v)},expression:"props.row.is_open"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":300,"label":_vm.$t('marketingOffers.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.handleDelete(props.row.id, props.row.true_id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.delete'))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n              ")])]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "msZ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      data: [],
      loading: true,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [5, 25, 50]
      },
      pageTopHeight: 0,
      windowHeight: 0,
      posList: [],
      types: [{ id: 1, name: 'Port Forwarding' }, { id: 2, name: 'Local' }, { id: 3, name: 'Label Local' }, { id: 4, name: 'USB' }, { id: 5, name: 'Order Label' }]
    };
  },
  created: function created() {
    this.loading = true;
    this.loadPosList();
    this.index();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.index();
    },
    loadPosList: function loadPosList() {
      var _this = this;

      var sessionData = this.$session.get('selectedCompanyData') || {};
      if (sessionData['compact_pos_list'] && sessionData['compact_pos_list'].length) {
        this.posList = sessionData['compact_pos_list'];
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos-admin/compact-list', 'GET', data, function (response) {
        if (response.status) {
          _this.posList = response.data;
          sessionData['compact_pos_list'] = response.data;
          _this.$session.set('compact_pos_list', response.data);
        }
      });
    },
    getTypeName: function getTypeName(typeId) {
      var t = this.types.find(function (item) {
        return item.id === typeId;
      });
      return t ? t.name : '-';
    },
    getPosName: function getPosName(item) {
      var id = item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' ? item.id : item;
      var name = item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' && item.name ? item.name : null;
      if (name) {
        return name;
      }
      var pos = this.posList.find(function (p) {
        return p.id === id;
      });
      return pos ? pos.name : id;
    },
    getVisiblePosNames: function getVisiblePosNames(posIds) {
      if (!posIds || !posIds.length) {
        return '-';
      }
      return this.getPosName(posIds[0]);
    },
    getHiddenPosCount: function getHiddenPosCount(posIds) {
      if (!posIds || posIds.length <= 1) {
        return 0;
      }
      return posIds.length - 1;
    },
    getPosNames: function getPosNames(posIds) {
      var _this2 = this;

      if (!posIds || !posIds.length) {
        return '-';
      }
      var names = posIds.map(function (item) {
        return _this2.getPosName(item);
      });
      return names.join(', ');
    },
    index: function index() {
      var _this3 = this;

      this.loading = true;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/printer', 'GET', data, function (response) {
        if (response.status) {
          _this3.data = response.data;
        } else {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            text: 'Error!',
            type: 'error',
            showConfirmButton: false,
            timer: 1000
          });
        }
        _this3.$nextTick(function () {
          _this3.loading = false;
        });
      });
    },
    add: function add() {
      this.$router.push('/printer/add');
    },
    goToRecord: function goToRecord(id) {
      this.$router.push('/printer/edit/' + id);
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: this.$t('general.generalAreYouSure'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this4.deletePrinter(id);
        }
      });
    },
    deletePrinter: function deletePrinter(id) {
      var _this5 = this;

      this.loading = true;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/printer/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          _this5.trackAdminEvent('ADMIN_PRINTER_DELETED', 'printer', id, {
            printer_id: id
          });
          _this5.index();
          _this5.loading = false;
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            title: _this5.$t('general.success'),
            type: 'success'
          });
        } else {
          _this5.loading = false;
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            title: _this5.$t('general.error'),
            type: 'error'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "mtAm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopCategoryForm_vue__ = __webpack_require__("iWJC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_625040b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopCategoryForm_vue__ = __webpack_require__("DOX6");
function injectStyle (ssrContext) {
  __webpack_require__("AJDH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopCategoryForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_625040b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopCategoryForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mu2Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralCampaignAdd_vue__ = __webpack_require__("bp77");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e961037e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralCampaignAdd_vue__ = __webpack_require__("Lqom");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralCampaignAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e961037e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralCampaignAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mx6W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "myZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var countries = ['Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Angola', 'Anguilla', 'Antartica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Ashmore and Cartier Island', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Clipperton Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo, Democratic Republic of the', 'Congo, Republic of the', 'Cook Islands', 'Costa Rica', 'Cote d\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czeck Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Europa Island', 'Falkland Islands (Islas Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern and Antarctic Lands', 'Gabon', 'Gambia, The', 'Gaza Strip', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Glorioso Islands', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and McDonald Islands', 'Holy See (Vatican City)', 'Honduras', 'Hong Kong', 'Howland Island', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Ireland, Northern', 'Israel', 'Italy', 'Jamaica', 'Jan Mayen', 'Japan', 'Jarvis Island', 'Jersey', 'Johnston Atoll', 'Jordan', 'Juan de Nova Island', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia, Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Man, Isle of', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Midway Islands', 'Moldova', 'Monaco', 'Mongolia', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcaim Islands', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Scotland', 'Senegal', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and South Sandwich Islands', 'Spain', 'Spratly Islands', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Tobago', 'Toga', 'Tokelau', 'Tonga', 'Trinidad', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'Uruguay', 'USA', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Vietnam', 'Virgin Islands', 'Wales', 'Wallis and Futuna', 'West Bank', 'Western Sahara', 'Yemen', 'Yugoslavia', 'Zambia', 'Zimbabwe'];

var states = [];
states[0] = '';
states[1] = 'Badakhshan|Badghis|Baghlan|Balkh|Bamian|Farah|Faryab|Ghazni|Ghowr|Helmand|Herat|Jowzjan|Kabol|Kandahar|Kapisa|Konar|Kondoz|Laghman|Lowgar|Nangarhar|Nimruz|Oruzgan|Paktia|Paktika|Parvan|Samangan|Sar-e Pol|Takhar|Vardak|Zabol';
states[2] = 'Berat|Bulqize|Delvine|Devoll (Bilisht)|Diber (Peshkopi)|Durres|Elbasan|Fier|Gjirokaster|Gramsh|Has (Krume)|Kavaje|Kolonje (Erseke)|Korce|Kruje|Kucove|Kukes|Kurbin|Lezhe|Librazhd|Lushnje|Malesi e Madhe (Koplik)|Mallakaster (Ballsh)|Mat (Burrel)|Mirdite (Rreshen)|Peqin|Permet|Pogradec|Puke|Sarande|Shkoder|Skrapar (Corovode)|Tepelene|Tirane (Tirana)|Tirane (Tirana)|Tropoje (Bajram Curri)|Vlore';
states[3] = 'Adrar|Ain Defla|Ain Temouchent|Alger|Annaba|Batna|Bechar|Bejaia|Biskra|Blida|Bordj Bou Arreridj|Bouira|Boumerdes|Chlef|Constantine|Djelfa|El Bayadh|El Oued|El Tarf|Ghardaia|Guelma|Illizi|Jijel|Khenchela|Laghouat|M\'\'Sila|Mascara|Medea|Mila|Mostaganem|Naama|Oran|Ouargla|Oum el Bouaghi|Relizane|Saida|Setif|Sidi Bel Abbes|Skikda|Souk Ahras|Tamanghasset|Tebessa|Tiaret|Tindouf|Tipaza|Tissemsilt|Tizi Ouzou|Tlemcen';
states[4] = 'Eastern|Manu\'a|Rose Island|Swains Island|Western';
states[5] = 'Andorra la Vella|Bengo|Benguela|Bie|Cabinda|Canillo|Cuando Cubango|Cuanza Norte|Cuanza Sul|Cunene|Encamp|Escaldes-Engordany|Huambo|Huila|La Massana|Luanda|Lunda Norte|Lunda Sul|Malanje|Moxico|Namibe|Ordino|Sant Julia de Loria|Uige|Zaire';
states[6] = 'Anguilla';
states[7] = 'Antartica';
states[8] = 'Barbuda|Redonda|Saint George|Saint John|Saint Mary|Saint Paul|Saint Peter|Saint Philip';
states[9] = 'Antartica e Islas del Atlantico Sur|Buenos Aires|Buenos Aires Capital Federal|Catamarca|Chaco|Chubut|Cordoba|Corrientes|Entre Rios|Formosa|Jujuy|La Pampa|La Rioja|Mendoza|Misiones|Neuquen|Rio Negro|Salta|San Juan|San Luis|Santa Cruz|Santa Fe|Santiago del Estero|Tierra del Fuego|Tucuman';
states[10] = 'Aragatsotn|Ararat|Armavir|Geghark\'unik\'|Kotayk\'|Lorri|Shirak|Syunik\'|Tavush|Vayots\' Dzor|Yerevan';
states[11] = 'Aruba';
states[12] = 'Ashmore and Cartier Island';
states[13] = 'Australian Capital Territory|New South Wales|Northern Territory|Queensland|South Australia|Tasmania|Victoria|Western Australia';
states[14] = 'Burgenland|Kaernten|Niederoesterreich|Oberoesterreich|Salzburg|Steiermark|Tirol|Vorarlberg|Wien';
states[15] = 'Abseron Rayonu|Agcabadi Rayonu|Agdam Rayonu|Agdas Rayonu|Agstafa Rayonu|Agsu Rayonu|Ali Bayramli Sahari|Astara Rayonu|Baki Sahari|Balakan Rayonu|Barda Rayonu|Beylaqan Rayonu|Bilasuvar Rayonu|Cabrayil Rayonu|Calilabad Rayonu|Daskasan Rayonu|Davaci Rayonu|Fuzuli Rayonu|Gadabay Rayonu|Ganca Sahari|Goranboy Rayonu|Goycay Rayonu|Haciqabul Rayonu|Imisli Rayonu|Ismayilli Rayonu|Kalbacar Rayonu|Kurdamir Rayonu|Lacin Rayonu|Lankaran Rayonu|Lankaran Sahari|Lerik Rayonu|Masalli Rayonu|Mingacevir Sahari|Naftalan Sahari|Naxcivan Muxtar Respublikasi|Neftcala Rayonu|Oguz Rayonu|Qabala Rayonu|Qax Rayonu|Qazax Rayonu|Qobustan Rayonu|Quba Rayonu|Qubadli Rayonu|Qusar Rayonu|Saatli Rayonu|Sabirabad Rayonu|Saki Rayonu|Saki Sahari|Salyan Rayonu|Samaxi Rayonu|Samkir Rayonu|Samux Rayonu|Siyazan Rayonu|Sumqayit Sahari|Susa Rayonu|Susa Sahari|Tartar Rayonu|Tovuz Rayonu|Ucar Rayonu|Xacmaz Rayonu|Xankandi Sahari|Xanlar Rayonu|Xizi Rayonu|Xocali Rayonu|Xocavand Rayonu|Yardimli Rayonu|Yevlax Rayonu|Yevlax Sahari|Zangilan Rayonu|Zaqatala Rayonu|Zardab Rayonu';
states[16] = 'Acklins and Crooked Islands|Bimini|Cat Island|Exuma|Freeport|Fresh Creek|Governor\'s Harbour|Green Turtle Cay|Harbour Island|High Rock|Inagua|Kemps Bay|Long Island|Marsh Harbour|Mayaguana|New Providence|Nicholls Town and Berry Islands|Ragged Island|Rock Sound|San Salvador and Rum Cay|Sandy Point';
states[17] = 'Al Hadd|Al Manamah|Al Mintaqah al Gharbiyah|Al Mintaqah al Wusta|Al Mintaqah ash Shamaliyah|Al Muharraq|Ar Rifa\' wa al Mintaqah al Janubiyah|Jidd Hafs|Juzur Hawar|Madinat \'Isa|Madinat Hamad|Sitrah';
states[18] = 'Barguna|Barisal|Bhola|Jhalokati|Patuakhali|Pirojpur|Bandarban|Brahmanbaria|Chandpur|Chittagong|Comilla|Cox\'s Bazar|Feni|Khagrachari|Lakshmipur|Noakhali|Rangamati|Dhaka|Faridpur|Gazipur|Gopalganj|Jamalpur|Kishoreganj|Madaripur|Manikganj|Munshiganj|Mymensingh|Narayanganj|Narsingdi|Netrokona|Rajbari|Shariatpur|Sherpur|Tangail|Bagerhat|Chuadanga|Jessore|Jhenaidah|Khulna|Kushtia|Magura|Meherpur|Narail|Satkhira|Bogra|Dinajpur|Gaibandha|Jaipurhat|Kurigram|Lalmonirhat|Naogaon|Natore|Nawabganj|Nilphamari|Pabna|Panchagarh|Rajshahi|Rangpur|Sirajganj|Thakurgaon|Habiganj|Maulvi bazar|Sunamganj|Sylhet';
states[19] = 'Bridgetown|Christ Church|Saint Andrew|Saint George|Saint James|Saint John|Saint Joseph|Saint Lucy|Saint Michael|Saint Peter|Saint Philip|Saint Thomas';
states[20] = 'Brestskaya (Brest)|Homyel\'skaya (Homyel\')|Horad Minsk|Hrodzyenskaya (Hrodna)|Mahilyowskaya (Mahilyow)|Minskaya|Vitsyebskaya (Vitsyebsk)';
states[21] = 'Antwerpen|Brabant Wallon|Brussels Capitol Region|Hainaut|Liege|Limburg|Luxembourg|Namur|Oost-Vlaanderen|Vlaams Brabant|West-Vlaanderen';
states[22] = 'Belize|Cayo|Corozal|Orange Walk|Stann Creek|Toledo';
states[23] = 'Alibori|Atakora|Atlantique|Borgou|Collines|Couffo|Donga|Littoral|Mono|Oueme|Plateau|Zou';
states[24] = 'Devonshire|Hamilton|Hamilton|Paget|Pembroke|Saint George|Saint Georges|Sandys|Smiths|Southampton|Warwick';
states[25] = 'Bumthang|Chhukha|Chirang|Daga|Geylegphug|Ha|Lhuntshi|Mongar|Paro|Pemagatsel|Punakha|Samchi|Samdrup Jongkhar|Shemgang|Tashigang|Thimphu|Tongsa|Wangdi Phodrang';
states[26] = 'Beni|Chuquisaca|Cochabamba|La Paz|Oruro|Pando|Potosi|Santa Cruz|Tarija';
states[27] = 'Federation of Bosnia and Herzegovina|Republika Srpska';
states[28] = 'Central|Chobe|Francistown|Gaborone|Ghanzi|Kgalagadi|Kgatleng|Kweneng|Lobatse|Ngamiland|North-East|Selebi-Pikwe|South-East|Southern';
states[29] = 'Acre|Alagoas|Amapa|Amazonas|Bahia|Ceara|Distrito Federal|Espirito Santo|Goias|Maranhao|Mato Grosso|Mato Grosso do Sul|Minas Gerais|Para|Paraiba|Parana|Pernambuco|Piaui|Rio de Janeiro|Rio Grande do Norte|Rio Grande do Sul|Rondonia|Roraima|Santa Catarina|Sao Paulo|Sergipe|Tocantins';
states[30] = 'Anegada|Jost Van Dyke|Tortola|Virgin Gorda';
states[31] = 'Belait|Brunei and Muara|Temburong|Tutong';
states[32] = 'Blagoevgrad|Burgas|Dobrich|Gabrovo|Khaskovo|Kurdzhali|Kyustendil|Lovech|Montana|Pazardzhik|Pernik|Pleven|Plovdiv|Razgrad|Ruse|Shumen|Silistra|Sliven|Smolyan|Sofiya|Sofiya-Grad|Stara Zagora|Turgovishte|Varna|Veliko Turnovo|Vidin|Vratsa|Yambol';
states[33] = 'Bale|Bam|Banwa|Bazega|Bougouriba|Boulgou|Boulkiemde|Comoe|Ganzourgou|Gnagna|Gourma|Houet|Ioba|Kadiogo|Kenedougou|Komandjari|Kompienga|Kossi|Koupelogo|Kouritenga|Kourweogo|Leraba|Loroum|Mouhoun|Nahouri|Namentenga|Naumbiel|Nayala|Oubritenga|Oudalan|Passore|Poni|Samentenga|Sanguie|Seno|Sissili|Soum|Sourou|Tapoa|Tuy|Yagha|Yatenga|Ziro|Zondomo|Zoundweogo';
states[34] = 'Ayeyarwady|Bago|Chin State|Kachin State|Kayah State|Kayin State|Magway|Mandalay|Mon State|Rakhine State|Sagaing|Shan State|Tanintharyi|Yangon';
states[35] = 'Bubanza|Bujumbura|Bururi|Cankuzo|Cibitoke|Gitega|Karuzi|Kayanza|Kirundo|Makamba|Muramvya|Muyinga|Mwaro|Ngozi|Rutana|Ruyigi';
states[36] = 'Banteay Mean Cheay|Batdambang|Kampong Cham|Kampong Chhnang|Kampong Spoe|Kampong Thum|Kampot|Kandal|Kaoh Kong|Keb|Kracheh|Mondol Kiri|Otdar Mean Cheay|Pailin|Phnum Penh|Pouthisat|Preah Seihanu (Sihanoukville)|Preah Vihear|Prey Veng|Rotanah Kiri|Siem Reab|Stoeng Treng|Svay Rieng|Takev';
states[37] = 'Adamaoua|Centre|Est|Extreme-Nord|Littoral|Nord|Nord-Ouest|Ouest|Sud|Sud-Ouest';
states[38] = 'Alberta|British Columbia|Manitoba|New Brunswick|Newfoundland|Northwest Territories|Nova Scotia|Nunavut|Ontario|Prince Edward Island|Quebec|Saskatchewan|Yukon Territory';
states[39] = 'Boa Vista|Brava|Maio|Mosteiros|Paul|Porto Novo|Praia|Ribeira Grande|Sal|Santa Catarina|Santa Cruz|Sao Domingos|Sao Filipe|Sao Nicolau|Sao Vicente|Tarrafal';
states[40] = 'Creek|Eastern|Midland|South Town|Spot Bay|Stake Bay|West End|Western';
states[41] = 'Bamingui-Bangoran|Bangui|Basse-Kotto|Gribingui|Haut-Mbomou|Haute-Kotto|Haute-Sangha|Kemo-Gribingui|Lobaye|Mbomou|Nana-Mambere|Ombella-Mpoko|Ouaka|Ouham|Ouham-Pende|Sangha|Vakaga';
states[42] = 'Batha|Biltine|Borkou-Ennedi-Tibesti|Chari-Baguirmi|Guera|Kanem|Lac|Logone Occidental|Logone Oriental|Mayo-Kebbi|Moyen-Chari|Ouaddai|Salamat|Tandjile';
states[43] = 'Aisen del General Carlos Ibanez del Campo|Antofagasta|Araucania|Atacama|Bio-Bio|Coquimbo|Libertador General Bernardo O\'Higgins|Los Lagos|Magallanes y de la Antartica Chilena|Maule|Region Metropolitana (Santiago)|Tarapaca|Valparaiso';
states[44] = 'Anhui|Beijing|Chongqing|Fujian|Gansu|Guangdong|Guangxi|Guizhou|Hainan|Hebei|Heilongjiang|Henan|Hubei|Hunan|Jiangsu|Jiangxi|Jilin|Liaoning|Nei Mongol|Ningxia|Qinghai|Shaanxi|Shandong|Shanghai|Shanxi|Sichuan|Tianjin|Xinjiang|Xizang (Tibet)|Yunnan|Zhejiang';
states[45] = 'Christmas Island';
states[46] = 'Clipperton Island';
states[47] = 'Direction Island|Home Island|Horsburgh Island|North Keeling Island|South Island|West Island';
states[48] = 'Amazonas|Antioquia|Arauca|Atlantico|Bolivar|Boyaca|Caldas|Caqueta|Casanare|Cauca|Cesar|Choco|Cordoba|Cundinamarca|Distrito Capital de Santa Fe de Bogota|Guainia|Guaviare|Huila|La Guajira|Magdalena|Meta|Narino|Norte de Santander|Putumayo|Quindio|Risaralda|San Andres y Providencia|Santander|Sucre|Tolima|Valle del Cauca|Vaupes|Vichada';

states[49] = 'Anjouan (Nzwani)|Domoni|Fomboni|Grande Comore (Njazidja)|Moheli (Mwali)|Moroni|Moutsamoudou';
states[50] = 'Bandundu|Bas-Congo|Equateur|Kasai-Occidental|Kasai-Oriental|Katanga|Kinshasa|Maniema|Nord-Kivu|Orientale|Sud-Kivu';
states[51] = 'Bouenza|Brazzaville|Cuvette|Kouilou|Lekoumou|Likouala|Niari|Plateaux|Pool|Sangha';
states[52] = 'Aitutaki|Atiu|Avarua|Mangaia|Manihiki|Manuae|Mauke|Mitiaro|Nassau Island|Palmerston|Penrhyn|Pukapuka|Rakahanga|Rarotonga|Suwarrow|Takutea';
states[53] = 'Alajuela|Cartago|Guanacaste|Heredia|Limon|Puntarenas|San Jose';
states[54] = 'Abengourou|Abidjan|Aboisso|Adiake\'|Adzope|Agboville|Agnibilekrou|Ale\'pe\'|Bangolo|Beoumi|Biankouma|Bocanda|Bondoukou|Bongouanou|Bouafle|Bouake|Bouna|Boundiali|Dabakala|Dabon|Daloa|Danane|Daoukro|Dimbokro|Divo|Duekoue|Ferkessedougou|Gagnoa|Grand Bassam|Grand-Lahou|Guiglo|Issia|Jacqueville|Katiola|Korhogo|Lakota|Man|Mankono|Mbahiakro|Odienne|Oume|Sakassou|San-Pedro|Sassandra|Seguela|Sinfra|Soubre|Tabou|Tanda|Tiassale|Tiebissou|Tingrela|Touba|Toulepleu|Toumodi|Vavoua|Yamoussoukro|Zuenoula';
states[55] = 'Bjelovarsko-Bilogorska Zupanija|Brodsko-Posavska Zupanija|Dubrovacko-Neretvanska Zupanija|Istarska Zupanija|Karlovacka Zupanija|Koprivnicko-Krizevacka Zupanija|Krapinsko-Zagorska Zupanija|Licko-Senjska Zupanija|Medimurska Zupanija|Osjecko-Baranjska Zupanija|Pozesko-Slavonska Zupanija|Primorsko-Goranska Zupanija|Sibensko-Kninska Zupanija|Sisacko-Moslavacka Zupanija|Splitsko-Dalmatinska Zupanija|Varazdinska Zupanija|Viroviticko-Podravska Zupanija|Vukovarsko-Srijemska Zupanija|Zadarska Zupanija|Zagreb|Zagrebacka Zupanija';
states[56] = 'Camaguey|Ciego de Avila|Cienfuegos|Ciudad de La Habana|Granma|Guantanamo|Holguin|Isla de la Juventud|La Habana|Las Tunas|Matanzas|Pinar del Rio|Sancti Spiritus|Santiago de Cuba|Villa Clara';
states[57] = 'Famagusta|Kyrenia|Larnaca|Limassol|Nicosia|Paphos';
states[58] = 'Brnensky|Budejovicky|Jihlavsky|Karlovarsky|Kralovehradecky|Liberecky|Olomoucky|Ostravsky|Pardubicky|Plzensky|Praha|Stredocesky|Ustecky|Zlinsky';
states[59] = 'Arhus|Bornholm|Fredericksberg|Frederiksborg|Fyn|Kobenhavn|Kobenhavns|Nordjylland|Ribe|Ringkobing|Roskilde|Sonderjylland|Storstrom|Vejle|Vestsjalland|Viborg';
states[60] = '\'Ali Sabih|Dikhil|Djibouti|Obock|Tadjoura';
states[61] = 'Saint Andrew|Saint David|Saint George|Saint John|Saint Joseph|Saint Luke|Saint Mark|Saint Patrick|Saint Paul|Saint Peter';
states[62] = 'Azua|Baoruco|Barahona|Dajabon|Distrito Nacional|Duarte|El Seibo|Elias Pina|Espaillat|Hato Mayor|Independencia|La Altagracia|La Romana|La Vega|Maria Trinidad Sanchez|Monsenor Nouel|Monte Cristi|Monte Plata|Pedernales|Peravia|Puerto Plata|Salcedo|Samana|San Cristobal|San Juan|San Pedro de Macoris|Sanchez Ramirez|Santiago|Santiago Rodriguez|Valverde';

states[63] = 'Azuay|Bolivar|Canar|Carchi|Chimborazo|Cotopaxi|El Oro|Esmeraldas|Galapagos|Guayas|Imbabura|Loja|Los Rios|Manabi|Morona-Santiago|Napo|Orellana|Pastaza|Pichincha|Sucumbios|Tungurahua|Zamora-Chinchipe';
states[64] = 'Ad Daqahliyah|Al Bahr al Ahmar|Al Buhayrah|Al Fayyum|Al Gharbiyah|Al Iskandariyah|Al Isma\'iliyah|Al Jizah|Al Minufiyah|Al Minya|Al Qahirah|Al Qalyubiyah|Al Wadi al Jadid|As Suways|Ash Sharqiyah|Aswan|Asyut|Bani Suwayf|Bur Sa\'id|Dumyat|Janub Sina\'|Kafr ash Shaykh|Matruh|Qina|Shamal Sina\'|Suhaj';
states[65] = 'Ahuachapan|Cabanas|Chalatenango|Cuscatlan|La Libertad|La Paz|La Union|Morazan|San Miguel|San Salvador|San Vicente|Santa Ana|Sonsonate|Usulutan';
states[66] = 'Annobon|Bioko Norte|Bioko Sur|Centro Sur|Kie-Ntem|Litoral|Wele-Nzas';
states[67] = 'Akale Guzay|Barka|Denkel|Hamasen|Sahil|Semhar|Senhit|Seraye';
states[68] = 'Harjumaa (Tallinn)|Hiiumaa (Kardla)|Ida-Virumaa (Johvi)|Jarvamaa (Paide)|Jogevamaa (Jogeva)|Laane-Virumaa (Rakvere)|Laanemaa (Haapsalu)|Parnumaa (Parnu)|Polvamaa (Polva)|Raplamaa (Rapla)|Saaremaa (Kuessaare)|Tartumaa (Tartu)|Valgamaa (Valga)|Viljandimaa (Viljandi)|Vorumaa (Voru)';
states[69] = 'Adis Abeba (Addis Ababa)|Afar|Amara|Dire Dawa|Gambela Hizboch|Hareri Hizb|Oromiya|Sumale|Tigray|YeDebub Biheroch Bihereseboch na Hizboch';
states[70] = 'Europa Island';
states[71] = 'Falkland Islands (Islas Malvinas)';
states[72] = 'Bordoy|Eysturoy|Mykines|Sandoy|Skuvoy|Streymoy|Suduroy|Tvoroyri|Vagar';
states[73] = 'Central|Eastern|Northern|Rotuma|Western';
states[74] = 'Aland|Etela-Suomen Laani|Ita-Suomen Laani|Lansi-Suomen Laani|Lappi|Oulun Laani';
states[75] = 'Alsace|Aquitaine|Auvergne|Basse-Normandie|Bourgogne|Bretagne|Centre|Champagne-Ardenne|Corse|Franche-Comte|Haute-Normandie|Ile-de-France|Languedoc-Roussillon|Limousin|Lorraine|Midi-Pyrenees|Nord-Pas-de-Calais|Pays de la Loire|Picardie|Poitou-Charentes|Provence-Alpes-Cote d\'Azur|Rhone-Alpes';
states[76] = 'French Guiana';
states[77] = 'Archipel des Marquises|Archipel des Tuamotu|Archipel des Tubuai|Iles du Vent|Iles Sous-le-Vent';
states[78] = 'Adelie Land|Ile Crozet|Iles Kerguelen|Iles Saint-Paul et Amsterdam';
states[79] = 'Estuaire|Haut-Ogooue|Moyen-Ogooue|Ngounie|Nyanga|Ogooue-Ivindo|Ogooue-Lolo|Ogooue-Maritime|Woleu-Ntem';
states[80] = 'Banjul|Central River|Lower River|North Bank|Upper River|Western';
states[81] = 'Gaza Strip';
states[82] = 'Abashis|Abkhazia or Ap\'khazet\'is Avtonomiuri Respublika (Sokhumi)|Adigenis|Ajaria or Acharis Avtonomiuri Respublika (Bat\'umi)|Akhalgoris|Akhalk\'alak\'is|Akhalts\'ikhis|Akhmetis|Ambrolauris|Aspindzis|Baghdat\'is|Bolnisis|Borjomis|Ch\'khorotsqus|Ch\'okhatauris|Chiat\'ura|Dedop\'listsqaros|Dmanisis|Dushet\'is|Gardabanis|Gori|Goris|Gurjaanis|Javis|K\'arelis|K\'ut\'aisi|Kaspis|Kharagaulis|Khashuris|Khobis|Khonis|Lagodekhis|Lanch\'khut\'is|Lentekhis|Marneulis|Martvilis|Mestiis|Mts\'khet\'is|Ninotsmindis|Onis|Ozurget\'is|P\'ot\'i|Qazbegis|Qvarlis|Rust\'avi|Sach\'kheris|Sagarejos|Samtrediis|Senakis|Sighnaghis|T\'bilisi|T\'elavis|T\'erjolis|T\'et\'ritsqaros|T\'ianet\'is|Tqibuli|Ts\'ageris|Tsalenjikhis|Tsalkis|Tsqaltubo|Vanis|Zestap\'onis|Zugdidi|Zugdidis';
states[83] = 'Baden-Wuerttemberg|Bayern|Berlin|Brandenburg|Bremen|Hamburg|Hessen|Mecklenburg-Vorpommern|Niedersachsen|Nordrhein-Westfalen|Rheinland-Pfalz|Saarland|Sachsen|Sachsen-Anhalt|Schleswig-Holstein|Thueringen';
states[84] = 'Ashanti|Brong-Ahafo|Central|Eastern|Greater Accra|Northern|Upper East|Upper West|Volta|Western';
states[85] = 'Gibraltar';
states[86] = 'Ile du Lys|Ile Glorieuse';
states[87] = 'Aitolia kai Akarnania|Akhaia|Argolis|Arkadhia|Arta|Attiki|Ayion Oros (Mt. Athos)|Dhodhekanisos|Drama|Evritania|Evros|Evvoia|Florina|Fokis|Fthiotis|Grevena|Ilia|Imathia|Ioannina|Irakleion|Kardhitsa|Kastoria|Kavala|Kefallinia|Kerkyra|Khalkidhiki|Khania|Khios|Kikladhes|Kilkis|Korinthia|Kozani|Lakonia|Larisa|Lasithi|Lesvos|Levkas|Magnisia|Messinia|Pella|Pieria|Preveza|Rethimni|Rodhopi|Samos|Serrai|Thesprotia|Thessaloniki|Trikala|Voiotia|Xanthi|Zakinthos';
states[88] = 'Avannaa (Nordgronland)|Kitaa (Vestgronland)|Tunu (Ostgronland)';
states[89] = 'Carriacou and Petit Martinique|Saint Andrew|Saint David|Saint George|Saint John|Saint Mark|Saint Patrick';
states[90] = 'Basse-Terre|Grande-Terre|Iles de la Petite Terre|Iles des Saintes|Marie-Galante';
states[91] = 'Guam';
states[92] = 'Alta Verapaz|Baja Verapaz|Chimaltenango|Chiquimula|El Progreso|Escuintla|Guatemala|Huehuetenango|Izabal|Jalapa|Jutiapa|Peten|Quetzaltenango|Quiche|Retalhuleu|Sacatepequez|San Marcos|Santa Rosa|Solola|Suchitepequez|Totonicapan|Zacapa';
states[93] = 'Castel|Forest|St. Andrew|St. Martin|St. Peter Port|St. Pierre du Bois|St. Sampson|St. Saviour|Torteval|Vale';
states[94] = 'Beyla|Boffa|Boke|Conakry|Coyah|Dabola|Dalaba|Dinguiraye|Dubreka|Faranah|Forecariah|Fria|Gaoual|Gueckedou|Kankan|Kerouane|Kindia|Kissidougou|Koubia|Koundara|Kouroussa|Labe|Lelouma|Lola|Macenta|Mali|Mamou|Mandiana|Nzerekore|Pita|Siguiri|Telimele|Tougue|Yomou';
states[95] = 'Bafata|Biombo|Bissau|Bolama-Bijagos|Cacheu|Gabu|Oio|Quinara|Tombali';
states[96] = 'Barima-Waini|Cuyuni-Mazaruni|Demerara-Mahaica|East Berbice-Corentyne|Essequibo Islands-West Demerara|Mahaica-Berbice|Pomeroon-Supenaam|Potaro-Siparuni|Upper Demerara-Berbice|Upper Takutu-Upper Essequibo';
states[97] = 'Artibonite|Centre|Grand\'Anse|Nord|Nord-Est|Nord-Ouest|Ouest|Sud|Sud-Est';
states[98] = 'Heard Island and McDonald Islands';
states[99] = 'Holy See (Vatican City)';
states[100] = 'Atlantida|Choluteca|Colon|Comayagua|Copan|Cortes|El Paraiso|Francisco Morazan|Gracias a Dios|Intibuca|Islas de la Bahia|La Paz|Lempira|Ocotepeque|Olancho|Santa Barbara|Valle|Yoro';
states[101] = 'Hong Kong';
states[102] = 'Howland Island';
states[103] = 'Bacs-Kiskun|Baranya|Bekes|Bekescsaba|Borsod-Abauj-Zemplen|Budapest|Csongrad|Debrecen|Dunaujvaros|Eger|Fejer|Gyor|Gyor-Moson-Sopron|Hajdu-Bihar|Heves|Hodmezovasarhely|Jasz-Nagykun-Szolnok|Kaposvar|Kecskemet|Komarom-Esztergom|Miskolc|Nagykanizsa|Nograd|Nyiregyhaza|Pecs|Pest|Somogy|Sopron|Szabolcs-Szatmar-Bereg|Szeged|Szekesfehervar|Szolnok|Szombathely|Tatabanya|Tolna|Vas|Veszprem|Veszprem|Zala|Zalaegerszeg';
states[104] = 'Akranes|Akureyri|Arnessysla|Austur-Bardhastrandarsysla|Austur-Hunavatnssysla|Austur-Skaftafellssysla|Borgarfjardharsysla|Dalasysla|Eyjafjardharsysla|Gullbringusysla|Hafnarfjordhur|Husavik|Isafjordhur|Keflavik|Kjosarsysla|Kopavogur|Myrasysla|Neskaupstadhur|Nordhur-Isafjardharsysla|Nordhur-Mulasys-la|Nordhur-Thingeyjarsysla|Olafsfjordhur|Rangarvallasysla|Reykjavik|Saudharkrokur|Seydhisfjordhur|Siglufjordhur|Skagafjardharsysla|Snaefellsnes-og Hnappadalssysla|Strandasysla|Sudhur-Mulasysla|Sudhur-Thingeyjarsysla|Vesttmannaeyjar|Vestur-Bardhastrandarsysla|Vestur-Hunavatnssysla|Vestur-Isafjardharsysla|Vestur-Skaftafellssysla';
states[105] = 'Andaman and Nicobar Islands|Andhra Pradesh|Arunachal Pradesh|Assam|Bihar|Chandigarh|Chhattisgarh|Dadra and Nagar Haveli|Daman and Diu|Delhi|Goa|Gujarat|Haryana|Himachal Pradesh|Jammu and Kashmir|Jharkhand|Karnataka|Kerala|Lakshadweep|Madhya Pradesh|Maharashtra|Manipur|Meghalaya|Mizoram|Nagaland|Orissa|Pondicherry|Punjab|Rajasthan|Sikkim|Tamil Nadu|Tripura|Uttar Pradesh|Uttaranchal|West Bengal';
states[106] = 'Aceh|Bali|Banten|Bengkulu|East Timor|Gorontalo|Irian Jaya|Jakarta Raya|Jambi|Jawa Barat|Jawa Tengah|Jawa Timur|Kalimantan Barat|Kalimantan Selatan|Kalimantan Tengah|Kalimantan Timur|Kepulauan Bangka Belitung|Lampung|Maluku|Maluku Utara|Nusa Tenggara Barat|Nusa Tenggara Timur|Riau|Sulawesi Selatan|Sulawesi Tengah|Sulawesi Tenggara|Sulawesi Utara|Sumatera Barat|Sumatera Selatan|Sumatera Utara|Yogyakarta';
states[107] = 'Ardabil|Azarbayjan-e Gharbi|Azarbayjan-e Sharqi|Bushehr|Chahar Mahall va Bakhtiari|Esfahan|Fars|Gilan|Golestan|Hamadan|Hormozgan|Ilam|Kerman|Kermanshah|Khorasan|Khuzestan|Kohgiluyeh va Buyer Ahmad|Kordestan|Lorestan|Markazi|Mazandaran|Qazvin|Qom|Semnan|Sistan va Baluchestan|Tehran|Yazd|Zanjan';
states[108] = 'Al Anbar|Al Basrah|Al Muthanna|Al Qadisiyah|An Najaf|Arbil|As Sulaymaniyah|At Ta\'mim|Babil|Baghdad|Dahuk|Dhi Qar|Diyala|Karbala\'|Maysan|Ninawa|Salah ad Din|Wasit';
states[109] = 'Carlow|Cavan|Clare|Cork|Donegal|Dublin|Galway|Kerry|Kildare|Kilkenny|Laois|Leitrim|Limerick|Longford|Louth|Mayo|Meath|Monaghan|Offaly|Roscommon|Sligo|Tipperary|Waterford|Westmeath|Wexford|Wicklow';
states[110] = 'Antrim|Ards|Armagh|Ballymena|Ballymoney|Banbridge|Belfast|Carrickfergus|Castlereagh|Coleraine|Cookstown|Craigavon|Derry|Down|Dungannon|Fermanagh|Larne|Limavady|Lisburn|Magherafelt|Moyle|Newry and Mourne|Newtownabbey|North Down|Omagh|Strabane';
states[111] = 'Central|Haifa|Jerusalem|Northern|Southern|Tel Aviv';
states[112] = 'Abruzzo|Basilicata|Calabria|Campania|Emilia-Romagna|Friuli-Venezia Giulia|Lazio|Liguria|Lombardia|Marche|Molise|Piemonte|Puglia|Sardegna|Sicilia|Toscana|Trentino-Alto Adige|Umbria|Valle d\'Aosta|Veneto';
states[113] = 'Clarendon|Hanover|Kingston|Manchester|Portland|Saint Andrew|Saint Ann|Saint Catherine|Saint Elizabeth|Saint James|Saint Mary|Saint Thomas|Trelawny|Westmoreland';
states[114] = 'Jan Mayen';
states[115] = 'Aichi|Akita|Aomori|Chiba|Ehime|Fukui|Fukuoka|Fukushima|Gifu|Gumma|Hiroshima|Hokkaido|Hyogo|Ibaraki|Ishikawa|Iwate|Kagawa|Kagoshima|Kanagawa|Kochi|Kumamoto|Kyoto|Mie|Miyagi|Miyazaki|Nagano|Nagasaki|Nara|Niigata|Oita|Okayama|Okinawa|Osaka|Saga|Saitama|Shiga|Shimane|Shizuoka|Tochigi|Tokushima|Tokyo|Tottori|Toyama|Wakayama|Yamagata|Yamaguchi|Yamanashi';
states[116] = 'Jarvis Island';
states[117] = 'Jersey';
states[118] = 'Johnston Atoll';
states[119] = '\'Amman|Ajlun|Al \'Aqabah|Al Balqa\'|Al Karak|Al Mafraq|At Tafilah|Az Zarqa\'|Irbid|Jarash|Ma\'an|Madaba';
states[120] = 'Juan de Nova Island';
states[121] = 'Almaty|Aqmola|Aqtobe|Astana|Atyrau|Batys Qazaqstan|Bayqongyr|Mangghystau|Ongtustik Qazaqstan|Pavlodar|Qaraghandy|Qostanay|Qyzylorda|Shyghys Qazaqstan|Soltustik Qazaqstan|Zhambyl';
states[122] = 'Central|Coast|Eastern|Nairobi Area|North Eastern|Nyanza|Rift Valley|Western';
states[123] = 'Abaiang|Abemama|Aranuka|Arorae|Banaba|Banaba|Beru|Butaritari|Central Gilberts|Gilbert Islands|Kanton|Kiritimati|Kuria|Line Islands|Line Islands|Maiana|Makin|Marakei|Nikunau|Nonouti|Northern Gilberts|Onotoa|Phoenix Islands|Southern Gilberts|Tabiteuea|Tabuaeran|Tamana|Tarawa|Tarawa|Teraina';
states[124] = 'Chagang-do (Chagang Province)|Hamgyong-bukto (North Hamgyong Province)|Hamgyong-namdo (South Hamgyong Province)|Hwanghae-bukto (North Hwanghae Province)|Hwanghae-namdo (South Hwanghae Province)|Kaesong-si (Kaesong City)|Kangwon-do (Kangwon Province)|Namp\'o-si (Namp\'o City)|P\'yongan-bukto (North P\'yongan Province)|P\'yongan-namdo (South P\'yongan Province)|P\'yongyang-si (P\'yongyang City)|Yanggang-do (Yanggang Province)';
states[125] = 'Ch\'ungch\'ong-bukto|Ch\'ungch\'ong-namdo|Cheju-do|Cholla-bukto|Cholla-namdo|Inch\'on-gwangyoksi|Kangwon-do|Kwangju-gwangyoksi|Kyonggi-do|Kyongsang-bukto|Kyongsang-namdo|Pusan-gwangyoksi|Soul-t\'ukpyolsi|Taegu-gwangyoksi|Taejon-gwangyoksi|Ulsan-gwangyoksi';
states[126] = 'Al \'Asimah|Al Ahmadi|Al Farwaniyah|Al Jahra\'|Hawalli';
states[127] = 'Batken Oblasty|Bishkek Shaary|Chuy Oblasty (Bishkek)|Jalal-Abad Oblasty|Naryn Oblasty|Osh Oblasty|Talas Oblasty|Ysyk-Kol Oblasty (Karakol)';
states[128] = 'Attapu|Bokeo|Bolikhamxai|Champasak|Houaphan|Khammouan|Louangnamtha|Louangphabang|Oudomxai|Phongsali|Salavan|Savannakhet|Viangchan|Viangchan|Xaignabouli|Xaisomboun|Xekong|Xiangkhoang';
states[129] = 'Aizkraukles Rajons|Aluksnes Rajons|Balvu Rajons|Bauskas Rajons|Cesu Rajons|Daugavpils|Daugavpils Rajons|Dobeles Rajons|Gulbenes Rajons|Jekabpils Rajons|Jelgava|Jelgavas Rajons|Jurmala|Kraslavas Rajons|Kuldigas Rajons|Leipaja|Liepajas Rajons|Limbazu Rajons|Ludzas Rajons|Madonas Rajons|Ogres Rajons|Preilu Rajons|Rezekne|Rezeknes Rajons|Riga|Rigas Rajons|Saldus Rajons|Talsu Rajons|Tukuma Rajons|Valkas Rajons|Valmieras Rajons|Ventspils|Ventspils Rajons';
states[130] = 'Beyrouth|Ech Chimal|Ej Jnoub|El Bekaa|Jabal Loubnane';
states[131] = 'Berea|Butha-Buthe|Leribe|Mafeteng|Maseru|Mohales Hoek|Mokhotlong|Qacha\'s Nek|Quthing|Thaba-Tseka';
states[132] = 'Bomi|Bong|Grand Bassa|Grand Cape Mount|Grand Gedeh|Grand Kru|Lofa|Margibi|Maryland|Montserrado|Nimba|River Cess|Sinoe';
states[133] = 'Ajdabiya|Al \'Aziziyah|Al Fatih|Al Jabal al Akhdar|Al Jufrah|Al Khums|Al Kufrah|An Nuqat al Khams|Ash Shati\'|Awbari|Az Zawiyah|Banghazi|Darnah|Ghadamis|Gharyan|Misratah|Murzuq|Sabha|Sawfajjin|Surt|Tarabulus|Tarhunah|Tubruq|Yafran|Zlitan';
states[134] = 'Balzers|Eschen|Gamprin|Mauren|Planken|Ruggell|Schaan|Schellenberg|Triesen|Triesenberg|Vaduz';
states[135] = 'Akmenes Rajonas|Alytaus Rajonas|Alytus|Anyksciu Rajonas|Birstonas|Birzu Rajonas|Druskininkai|Ignalinos Rajonas|Jonavos Rajonas|Joniskio Rajonas|Jurbarko Rajonas|Kaisiadoriu Rajonas|Kaunas|Kauno Rajonas|Kedainiu Rajonas|Kelmes Rajonas|Klaipeda|Klaipedos Rajonas|Kretingos Rajonas|Kupiskio Rajonas|Lazdiju Rajonas|Marijampole|Marijampoles Rajonas|Mazeikiu Rajonas|Moletu Rajonas|Neringa Pakruojo Rajonas|Palanga|Panevezio Rajonas|Panevezys|Pasvalio Rajonas|Plunges Rajonas|Prienu Rajonas|Radviliskio Rajonas|Raseiniu Rajonas|Rokiskio Rajonas|Sakiu Rajonas|Salcininku Rajonas|Siauliai|Siauliu Rajonas|Silales Rajonas|Silutes Rajonas|Sirvintu Rajonas|Skuodo Rajonas|Svencioniu Rajonas|Taurages Rajonas|Telsiu Rajonas|Traku Rajonas|Ukmerges Rajonas|Utenos Rajonas|Varenos Rajonas|Vilkaviskio Rajonas|Vilniaus Rajonas|Vilnius|Zarasu Rajonas';
states[136] = 'Diekirch|Grevenmacher|Luxembourg';
states[137] = 'Macau';
states[138] = 'Aracinovo|Bac|Belcista|Berovo|Bistrica|Bitola|Blatec|Bogdanci|Bogomila|Bogovinje|Bosilovo|Brvenica|Cair (Skopje)|Capari|Caska|Cegrane|Centar (Skopje)|Centar Zupa|Cesinovo|Cucer-Sandevo|Debar|Delcevo|Delogozdi|Demir Hisar|Demir Kapija|Dobrusevo|Dolna Banjica|Dolneni|Dorce Petrov (Skopje)|Drugovo|Dzepciste|Gazi Baba (Skopje)|Gevgelija|Gostivar|Gradsko|Ilinden|Izvor|Jegunovce|Kamenjane|Karbinci|Karpos (Skopje)|Kavadarci|Kicevo|Kisela Voda (Skopje)|Klecevce|Kocani|Konce|Kondovo|Konopiste|Kosel|Kratovo|Kriva Palanka|Krivogastani|Krusevo|Kuklis|Kukurecani|Kumanovo|Labunista|Lipkovo|Lozovo|Lukovo|Makedonska Kamenica|Makedonski Brod|Mavrovi Anovi|Meseista|Miravci|Mogila|Murtino|Negotino|Negotino-Poloska|Novaci|Novo Selo|Oblesevo|Ohrid|Orasac|Orizari|Oslomej|Pehcevo|Petrovec|Plasnia|Podares|Prilep|Probistip|Radovis|Rankovce|Resen|Rosoman|Rostusa|Samokov|Saraj|Sipkovica|Sopiste|Sopotnika|Srbinovo|Star Dojran|Staravina|Staro Nagoricane|Stip|Struga|Strumica|Studenicani|Suto Orizari (Skopje)|Sveti Nikole|Tearce|Tetovo|Topolcani|Valandovo|Vasilevo|Veles|Velesta|Vevcani|Vinica|Vitoliste|Vranestica|Vrapciste|Vratnica|Vrutok|Zajas|Zelenikovo|Zileno|Zitose|Zletovo|Zrnovci';
states[139] = 'Antananarivo|Antsiranana|Fianarantsoa|Mahajanga|Toamasina|Toliara';
states[140] = 'Balaka|Blantyre|Chikwawa|Chiradzulu|Chitipa|Dedza|Dowa|Karonga|Kasungu|Likoma|Lilongwe|Machinga (Kasupe)|Mangochi|Mchinji|Mulanje|Mwanza|Mzimba|Nkhata Bay|Nkhotakota|Nsanje|Ntcheu|Ntchisi|Phalombe|Rumphi|Salima|Thyolo|Zomba';
states[141] = 'Johor|Kedah|Kelantan|Labuan|Melaka|Negeri Sembilan|Pahang|Perak|Perlis|Pulau Pinang|Sabah|Sarawak|Selangor|Terengganu|Wilayah Persekutuan';
states[142] = 'Alifu|Baa|Dhaalu|Faafu|Gaafu Alifu|Gaafu Dhaalu|Gnaviyani|Haa Alifu|Haa Dhaalu|Kaafu|Laamu|Lhaviyani|Maale|Meemu|Noonu|Raa|Seenu|Shaviyani|Thaa|Vaavu';
states[143] = 'Gao|Kayes|Kidal|Koulikoro|Mopti|Segou|Sikasso|Tombouctou';
states[144] = 'Valletta';
states[145] = 'Man, Isle of';
states[146] = 'Ailinginae|Ailinglaplap|Ailuk|Arno|Aur|Bikar|Bikini|Bokak|Ebon|Enewetak|Erikub|Jabat|Jaluit|Jemo|Kili|Kwajalein|Lae|Lib|Likiep|Majuro|Maloelap|Mejit|Mili|Namorik|Namu|Rongelap|Rongrik|Toke|Ujae|Ujelang|Utirik|Wotho|Wotje';
states[147] = 'Martinique';
states[148] = 'Adrar|Assaba|Brakna|Dakhlet Nouadhibou|Gorgol|Guidimaka|Hodh Ech Chargui|Hodh El Gharbi|Inchiri|Nouakchott|Tagant|Tiris Zemmour|Trarza';
states[149] = 'Agalega Islands|Black River|Cargados Carajos Shoals|Flacq|Grand Port|Moka|Pamplemousses|Plaines Wilhems|Port Louis|Riviere du Rempart|Rodrigues|Savanne';
states[150] = 'Mayotte';
states[151] = 'Aguascalientes|Baja California|Baja California Sur|Campeche|Chiapas|Chihuahua|Coahuila de Zaragoza|Colima|Distrito Federal|Durango|Guanajuato|Guerrero|Hidalgo|Jalisco|Mexico|Michoacan de Ocampo|Morelos|Nayarit|Nuevo Leon|Oaxaca|Puebla|Queretaro de Arteaga|Quintana Roo|San Luis Potosi|Sinaloa|Sonora|Tabasco|Tamaulipas|Tlaxcala|Veracruz-Llave|Yucatan|Zacatecas';
states[152] = 'Chuuk (Truk)|Kosrae|Pohnpei|Yap';
states[153] = 'Midway Islands';
states[154] = 'Balti|Cahul|Chisinau|Chisinau|Dubasari|Edinet|Gagauzia|Lapusna|Orhei|Soroca|Tighina|Ungheni';
states[155] = 'Fontvieille|La Condamine|Monaco-Ville|Monte-Carlo';
states[156] = 'Arhangay|Bayan-Olgiy|Bayanhongor|Bulgan|Darhan|Dornod|Dornogovi|Dundgovi|Dzavhan|Erdenet|Govi-Altay|Hentiy|Hovd|Hovsgol|Omnogovi|Ovorhangay|Selenge|Suhbaatar|Tov|Ulaanbaatar|Uvs';
states[157] = 'Saint Anthony|Saint Georges|Saint Peter\'s';
states[158] = 'Agadir|Al Hoceima|Azilal|Ben Slimane|Beni Mellal|Boulemane|Casablanca|Chaouen|El Jadida|El Kelaa des Srarhna|Er Rachidia|Essaouira|Fes|Figuig|Guelmim|Ifrane|Kenitra|Khemisset|Khenifra|Khouribga|Laayoune|Larache|Marrakech|Meknes|Nador|Ouarzazate|Oujda|Rabat-Sale|Safi|Settat|Sidi Kacem|Tan-Tan|Tanger|Taounate|Taroudannt|Tata|Taza|Tetouan|Tiznit';
states[159] = 'Cabo Delgado|Gaza|Inhambane|Manica|Maputo|Nampula|Niassa|Sofala|Tete|Zambezia';
states[160] = 'Caprivi|Erongo|Hardap|Karas|Khomas|Kunene|Ohangwena|Okavango|Omaheke|Omusati|Oshana|Oshikoto|Otjozondjupa';
states[161] = 'Aiwo|Anabar|Anetan|Anibare|Baiti|Boe|Buada|Denigomodu|Ewa|Ijuw|Meneng|Nibok|Uaboe|Yaren';
states[162] = 'Bagmati|Bheri|Dhawalagiri|Gandaki|Janakpur|Karnali|Kosi|Lumbini|Mahakali|Mechi|Narayani|Rapti|Sagarmatha|Seti';
states[163] = 'Drenthe|Flevoland|Friesland|Gelderland|Groningen|Limburg|Noord-Brabant|Noord-Holland|Overijssel|Utrecht|Zeeland|Zuid-Holland';
states[164] = 'Netherlands Antilles';
states[165] = 'Iles Loyaute|Nord|Sud';
states[166] = 'Akaroa|Amuri|Ashburton|Bay of Islands|Bruce|Buller|Chatham Islands|Cheviot|Clifton|Clutha|Cook|Dannevirke|Egmont|Eketahuna|Ellesmere|Eltham|Eyre|Featherston|Franklin|Golden Bay|Great Barrier Island|Grey|Hauraki Plains|Hawera|Hawke\'s Bay|Heathcote|Hikurangi|Hobson|Hokianga|Horowhenua|Hurunui|Hutt|Inangahua|Inglewood|Kaikoura|Kairanga|Kiwitea|Lake|Mackenzie|Malvern|Manaia|Manawatu|Mangonui|Maniototo|Marlborough|Masterton|Matamata|Mount Herbert|Ohinemuri|Opotiki|Oroua|Otamatea|Otorohanga|Oxford|Pahiatua|Paparua|Patea|Piako|Pohangina|Raglan|Rangiora|Rangitikei|Rodney|Rotorua|Runanga|Saint Kilda|Silverpeaks|Southland|Stewart Island|Stratford|Strathallan|Taranaki|Taumarunui|Taupo|Tauranga|Thames-Coromandel|Tuapeka|Vincent|Waiapu|Waiheke|Waihemo|Waikato|Waikohu|Waimairi|Waimarino|Waimate|Waimate West|Waimea|Waipa|Waipawa|Waipukurau|Wairarapa South|Wairewa|Wairoa|Waitaki|Waitomo|Waitotara|Wallace|Wanganui|Waverley|Westland|Whakatane|Whangarei|Whangaroa|Woodville';
states[167] = 'Atlantico Norte|Atlantico Sur|Boaco|Carazo|Chinandega|Chontales|Esteli|Granada|Jinotega|Leon|Madriz|Managua|Masaya|Matagalpa|Nueva Segovia|Rio San Juan|Rivas';
states[168] = 'Agadez|Diffa|Dosso|Maradi|Niamey|Tahoua|Tillaberi|Zinder';
states[169] = 'Abia|Abuja Federal Capital Territory|Adamawa|Akwa Ibom|Anambra|Bauchi|Bayelsa|Benue|Borno|Cross River|Delta|Ebonyi|Edo|Ekiti|Enugu|Gombe|Imo|Jigawa|Kaduna|Kano|Katsina|Kebbi|Kogi|Kwara|Lagos|Nassarawa|Niger|Ogun|Ondo|Osun|Oyo|Plateau|Rivers|Sokoto|Taraba|Yobe|Zamfara';
states[170] = 'Niue';
states[171] = 'Norfolk Island';
states[172] = 'Northern Islands|Rota|Saipan|Tinian';
states[173] = 'Akershus|Aust-Agder|Buskerud|Finnmark|Hedmark|Hordaland|More og Romsdal|Nord-Trondelag|Nordland|Oppland|Oslo|Ostfold|Rogaland|Sogn og Fjordane|Sor-Trondelag|Telemark|Troms|Vest-Agder|Vestfold';
states[174] = 'Ad Dakhiliyah|Al Batinah|Al Wusta|Ash Sharqiyah|Az Zahirah|Masqat|Musandam|Zufar';
states[175] = 'Balochistan|Federally Administered Tribal Areas|Islamabad Capital Territory|North-West Frontier Province|Punjab|Sindh';
states[176] = 'Aimeliik|Airai|Angaur|Hatobohei|Kayangel|Koror|Melekeok|Ngaraard|Ngarchelong|Ngardmau|Ngatpang|Ngchesar|Ngeremlengui|Ngiwal|Palau Island|Peleliu|Sonsoral|Tobi';
states[177] = 'Bocas del Toro|Chiriqui|Cocle|Colon|Darien|Herrera|Los Santos|Panama|San Blas|Veraguas';
states[178] = 'Bougainville|Central|Chimbu|East New Britain|East Sepik|Eastern Highlands|Enga|Gulf|Madang|Manus|Milne Bay|Morobe|National Capital|New Ireland|Northern|Sandaun|Southern Highlands|West New Britain|Western|Western Highlands';
states[179] = 'Alto Paraguay|Alto Parana|Amambay|Asuncion (city)|Boqueron|Caaguazu|Caazapa|Canindeyu|Central|Concepcion|Cordillera|Guaira|Itapua|Misiones|Neembucu|Paraguari|Presidente Hayes|San Pedro';
states[180] = 'Amazonas|Ancash|Apurimac|Arequipa|Ayacucho|Cajamarca|Callao|Cusco|Huancavelica|Huanuco|Ica|Junin|La Libertad|Lambayeque|Lima|Loreto|Madre de Dios|Moquegua|Pasco|Piura|Puno|San Martin|Tacna|Tumbes|Ucayali';
states[181] = 'Abra|Agusan del Norte|Agusan del Sur|Aklan|Albay|Angeles|Antique|Aurora|Bacolod|Bago|Baguio|Bais|Basilan|Basilan City|Bataan|Batanes|Batangas|Batangas City|Benguet|Bohol|Bukidnon|Bulacan|Butuan|Cabanatuan|Cadiz|Cagayan|Cagayan de Oro|Calbayog|Caloocan|Camarines Norte|Camarines Sur|Camiguin|Canlaon|Capiz|Catanduanes|Cavite|Cavite City|Cebu|Cebu City|Cotabato|Dagupan|Danao|Dapitan|Davao City Davao|Davao del Sur|Davao Oriental|Dipolog|Dumaguete|Eastern Samar|General Santos|Gingoog|Ifugao|Iligan|Ilocos Norte|Ilocos Sur|Iloilo|Iloilo City|Iriga|Isabela|Kalinga-Apayao|La Carlota|La Union|Laguna|Lanao del Norte|Lanao del Sur|Laoag|Lapu-Lapu|Legaspi|Leyte|Lipa|Lucena|Maguindanao|Mandaue|Manila|Marawi|Marinduque|Masbate|Mindoro Occidental|Mindoro Oriental|Misamis Occidental|Misamis Oriental|Mountain|Naga|Negros Occidental|Negros Oriental|North Cotabato|Northern Samar|Nueva Ecija|Nueva Vizcaya|Olongapo|Ormoc|Oroquieta|Ozamis|Pagadian|Palawan|Palayan|Pampanga|Pangasinan|Pasay|Puerto Princesa|Quezon|Quezon City|Quirino|Rizal|Romblon|Roxas|Samar|San Carlos (in Negros Occidental)|San Carlos (in Pangasinan)|San Jose|San Pablo|Silay|Siquijor|Sorsogon|South Cotabato|Southern Leyte|Sultan Kudarat|Sulu|Surigao|Surigao del Norte|Surigao del Sur|Tacloban|Tagaytay|Tagbilaran|Tangub|Tarlac|Tawitawi|Toledo|Trece Martires|Zambales|Zamboanga|Zamboanga del Norte|Zamboanga del Sur';
states[182] = 'Pitcaim Islands';
states[183] = 'Dolnoslaskie|Kujawsko-Pomorskie|Lodzkie|Lubelskie|Lubuskie|Malopolskie|Mazowieckie|Opolskie|Podkarpackie|Podlaskie|Pomorskie|Slaskie|Swietokrzyskie|Warminsko-Mazurskie|Wielkopolskie|Zachodniopomorskie';
states[184] = 'Acores (Azores)|Aveiro|Beja|Braga|Braganca|Castelo Branco|Coimbra|Evora|Faro|Guarda|Leiria|Lisboa|Madeira|Portalegre|Porto|Santarem|Setubal|Viana do Castelo|Vila Real|Viseu';
states[185] = 'Adjuntas|Aguada|Aguadilla|Aguas Buenas|Aibonito|Anasco|Arecibo|Arroyo|Barceloneta|Barranquitas|Bayamon|Cabo Rojo|Caguas|Camuy|Canovanas|Carolina|Catano|Cayey|Ceiba|Ciales|Cidra|Coamo|Comerio|Corozal|Culebra|Dorado|Fajardo|Florida|Guanica|Guayama|Guayanilla|Guaynabo|Gurabo|Hatillo|Hormigueros|Humacao|Isabela|Jayuya|Juana Diaz|Juncos|Lajas|Lares|Las Marias|Las Piedras|Loiza|Luquillo|Manati|Maricao|Maunabo|Mayaguez|Moca|Morovis|Naguabo|Naranjito|Orocovis|Patillas|Penuelas|Ponce|Quebradillas|Rincon|Rio Grande|Sabana Grande|Salinas|San German|San Juan|San Lorenzo|San Sebastian|Santa Isabel|Toa Alta|Toa Baja|Trujillo Alto|Utuado|Vega Alta|Vega Baja|Vieques|Villalba|Yabucoa|Yauco';
states[186] = 'Ad Dawhah|Al Ghuwayriyah|Al Jumayliyah|Al Khawr|Al Wakrah|Ar Rayyan|Jarayan al Batinah|Madinat ash Shamal|Umm Salal';
states[187] = 'Reunion';
states[188] = 'Alba|Arad|Arges|Bacau|Bihor|Bistrita-Nasaud|Botosani|Braila|Brasov|Bucuresti|Buzau|Calarasi|Caras-Severin|Cluj|Constanta|Covasna|Dimbovita|Dolj|Galati|Giurgiu|Gorj|Harghita|Hunedoara|Ialomita|Iasi|Maramures|Mehedinti|Mures|Neamt|Olt|Prahova|Salaj|Satu Mare|Sibiu|Suceava|Teleorman|Timis|Tulcea|Vaslui|Vilcea|Vrancea';
states[189] = 'Adygeya (Maykop)|Aginskiy Buryatskiy (Aginskoye)|Altay (Gorno-Altaysk)|Altayskiy (Barnaul)|Amurskaya (Blagoveshchensk)|Arkhangel\'skaya|Astrakhanskaya|Bashkortostan (Ufa)|Belgorodskaya|Bryanskaya|Buryatiya (Ulan-Ude)|Chechnya (Groznyy)|Chelyabinskaya|Chitinskaya|Chukotskiy (Anadyr\')|Chuvashiya (Cheboksary)|Dagestan (Makhachkala)|Evenkiyskiy (Tura)|Ingushetiya (Nazran\')|Irkutskaya|Ivanovskaya|Kabardino-Balkariya (Nal\'chik)|Kaliningradskaya|Kalmykiya (Elista)|Kaluzhskaya|Kamchatskaya (Petropavlovsk-Kamchatskiy)|Karachayevo-Cherkesiya (Cherkessk)|Kareliya (Petrozavodsk)|Kemerovskaya|Khabarovskiy|Khakasiya (Abakan)|Khanty-Mansiyskiy (Khanty-Mansiysk)|Kirovskaya|Komi (Syktyvkar)|Komi-Permyatskiy (Kudymkar)|Koryakskiy (Palana)|Kostromskaya|Krasnodarskiy|Krasnoyarskiy|Kurganskaya|Kurskaya|Leningradskaya|Lipetskaya|Magadanskaya|Mariy-El (Yoshkar-Ola)|Mordoviya (Saransk)|Moskovskaya|Moskva (Moscow)|Murmanskaya|Nenetskiy (Nar\'yan-Mar)|Nizhegorodskaya|Novgorodskaya|Novosibirskaya|Omskaya|Orenburgskaya|Orlovskaya (Orel)|Penzenskaya|Permskaya|Primorskiy (Vladivostok)|Pskovskaya|Rostovskaya|Ryazanskaya|Sakha (Yakutsk)|Sakhalinskaya (Yuzhno-Sakhalinsk)|Samarskaya|Sankt-Peterburg (Saint Petersburg)|Saratovskaya|Severnaya Osetiya-Alaniya [North Ossetia] (Vladikavkaz)|Smolenskaya|Stavropol\'skiy|Sverdlovskaya (Yekaterinburg)|Tambovskaya|Tatarstan (Kazan\')|Taymyrskiy (Dudinka)|Tomskaya|Tul\'skaya|Tverskaya|Tyumenskaya|Tyva (Kyzyl)|Udmurtiya (Izhevsk)|Ul\'yanovskaya|Ust\'-Ordynskiy Buryatskiy (Ust\'-Ordynskiy)|Vladimirskaya|Volgogradskaya|Vologodskaya|Voronezhskaya|Yamalo-Nenetskiy (Salekhard)|Yaroslavskaya|Yevreyskaya';
states[190] = 'Butare|Byumba|Cyangugu|Gikongoro|Gisenyi|Gitarama|Kibungo|Kibuye|Kigali Rurale|Kigali-ville|Ruhengeri|Umutara';
states[191] = 'Ascension|Saint Helena|Tristan da Cunha';
states[192] = 'Christ Church Nichola Town|Saint Anne Sandy Point|Saint George Basseterre|Saint George Gingerland|Saint James Windward|Saint John Capisterre|Saint John Figtree|Saint Mary Cayon|Saint Paul Capisterre|Saint Paul Charlestown|Saint Peter Basseterre|Saint Thomas Lowland|Saint Thomas Middle Island|Trinity Palmetto Point';
states[193] = 'Anse-la-Raye|Castries|Choiseul|Dauphin|Dennery|Gros Islet|Laborie|Micoud|Praslin|Soufriere|Vieux Fort';
states[194] = 'Miquelon|Saint Pierre';
states[195] = 'Charlotte|Grenadines|Saint Andrew|Saint David|Saint George|Saint Patrick';
states[196] = 'A\'ana|Aiga-i-le-Tai|Atua|Fa\'asaleleaga|Gaga\'emauga|Gagaifomauga|Palauli|Satupa\'itea|Tuamasaga|Va\'a-o-Fonoti|Vaisigano';
states[197] = 'Acquaviva|Borgo Maggiore|Chiesanuova|Domagnano|Faetano|Fiorentino|Monte Giardino|San Marino|Serravalle';
states[198] = 'Principe|Sao Tome';
states[199] = '\'Asir|Al Bahah|Al Hudud ash Shamaliyah|Al Jawf|Al Madinah|Al Qasim|Ar Riyad|Ash Sharqiyah (Eastern Province)|Ha\'il|Jizan|Makkah|Najran|Tabuk';
states[200] = 'Aberdeen City|Aberdeenshire|Angus|Argyll and Bute|City of Edinburgh|Clackmannanshire|Dumfries and Galloway|Dundee City|East Ayrshire|East Dunbartonshire|East Lothian|East Renfrewshire|Eilean Siar (Western Isles)|Falkirk|Fife|Glasgow City|Highland|Inverclyde|Midlothian|Moray|North Ayrshire|North Lanarkshire|Orkney Islands|Perth and Kinross|Renfrewshire|Shetland Islands|South Ayrshire|South Lanarkshire|Stirling|The Scottish Borders|West Dunbartonshire|West Lothian';
states[201] = 'Dakar|Diourbel|Fatick|Kaolack|Kolda|Louga|Saint-Louis|Tambacounda|Thies|Ziguinchor';
states[202] = 'Anse aux Pins|Anse Boileau|Anse Etoile|Anse Louis|Anse Royale|Baie Lazare|Baie Sainte Anne|Beau Vallon|Bel Air|Bel Ombre|Cascade|Glacis|Grand\' Anse (on Mahe)|Grand\' Anse (on Praslin)|La Digue|La Riviere Anglaise|Mont Buxton|Mont Fleuri|Plaisance|Pointe La Rue|Port Glaud|Saint Louis|Takamaka';
states[203] = 'Eastern|Northern|Southern|Western';
states[204] = 'Singapore';
states[205] = 'Banskobystricky|Bratislavsky|Kosicky|Nitriansky|Presovsky|Trenciansky|Trnavsky|Zilinsky';
states[206] = 'Ajdovscina|Beltinci|Bled|Bohinj|Borovnica|Bovec|Brda|Brezice|Brezovica|Cankova-Tisina|Celje|Cerklje na Gorenjskem|Cerknica|Cerkno|Crensovci|Crna na Koroskem|Crnomelj|Destrnik-Trnovska Vas|Divaca|Dobrepolje|Dobrova-Horjul-Polhov Gradec|Dol pri Ljubljani|Domzale|Dornava|Dravograd|Duplek|Gorenja Vas-Poljane|Gorisnica|Gornja Radgona|Gornji Grad|Gornji Petrovci|Grosuplje|Hodos Salovci|Hrastnik|Hrpelje-Kozina|Idrija|Ig|Ilirska Bistrica|Ivancna Gorica|Izola|Jesenice|Jursinci|Kamnik|Kanal|Kidricevo|Kobarid|Kobilje|Kocevje|Komen|Koper|Kozje|Kranj|Kranjska Gora|Krsko|Kungota|Kuzma|Lasko|Lenart|Lendava|Litija|Ljubljana|Ljubno|Ljutomer|Logatec|Loska Dolina|Loski Potok|Luce|Lukovica|Majsperk|Maribor|Medvode|Menges|Metlika|Mezica|Miren-Kostanjevica|Mislinja|Moravce|Moravske Toplice|Mozirje|Murska Sobota|Muta|Naklo|Nazarje|Nova Gorica|Novo Mesto|Odranci|Ormoz|Osilnica|Pesnica|Piran|Pivka|Podcetrtek|Podvelka-Ribnica|Postojna|Preddvor|Ptuj|Puconci|Race-Fram|Radece|Radenci|Radlje ob Dravi|Radovljica|Ravne-Prevalje|Ribnica|Rogasevci|Rogaska Slatina|Rogatec|Ruse|Semic|Sencur|Sentilj|Sentjernej|Sentjur pri Celju|Sevnica|Sezana|Skocjan|Skofja Loka|Skofljica|Slovenj Gradec|Slovenska Bistrica|Slovenske Konjice|Smarje pri Jelsah|Smartno ob Paki|Sostanj|Starse|Store|Sveti Jurij|Tolmin|Trbovlje|Trebnje|Trzic|Turnisce|Velenje|Velike Lasce|Videm|Vipava|Vitanje|Vodice|Vojnik|Vrhnika|Vuzenica|Zagorje ob Savi|Zalec|Zavrc|Zelezniki|Ziri|Zrece';
states[207] = 'Bellona|Central|Choiseul (Lauru)|Guadalcanal|Honiara|Isabel|Makira|Malaita|Rennell|Temotu|Western';
states[208] = 'Awdal|Bakool|Banaadir|Bari|Bay|Galguduud|Gedo|Hiiraan|Jubbada Dhexe|Jubbada Hoose|Mudug|Nugaal|Sanaag|Shabeellaha Dhexe|Shabeellaha Hoose|Sool|Togdheer|Woqooyi Galbeed';
states[209] = 'Eastern Cape|Free State|Gauteng|KwaZulu-Natal|Mpumalanga|North-West|Northern Cape|Northern Province|Western Cape';
states[210] = 'Bird Island|Bristol Island|Clerke Rocks|Montagu Island|Saunders Island|South Georgia|Southern Thule|Traversay Islands';
states[211] = 'Andalucia|Aragon|Asturias|Baleares (Balearic Islands)|Canarias (Canary Islands)|Cantabria|Castilla y Leon|Castilla-La Mancha|Cataluna|Ceuta|Communidad Valencian|Extremadura|Galicia|Islas Chafarinas|La Rioja|Madrid|Melilla|Murcia|Navarra|Pais Vasco (Basque Country)|Penon de Alhucemas|Penon de Velez de la Gomera';
states[212] = 'Spratly Islands';
states[213] = 'Central|Eastern|North Central|North Eastern|North Western|Northern|Sabaragamuwa|Southern|Uva|Western';
states[214] = 'A\'ali an Nil|Al Bahr al Ahmar|Al Buhayrat|Al Jazirah|Al Khartum|Al Qadarif|Al Wahdah|An Nil al Abyad|An Nil al Azraq|Ash Shamaliyah|Bahr al Jabal|Gharb al Istiwa\'iyah|Gharb Bahr al Ghazal|Gharb Darfur|Gharb Kurdufan|Janub Darfur|Janub Kurdufan|Junqali|Kassala|Nahr an Nil|Shamal Bahr al Ghazal|Shamal Darfur|Shamal Kurdufan|Sharq al Istiwa\'iyah|Sinnar|Warab';
states[215] = 'Brokopondo|Commewijne|Coronie|Marowijne|Nickerie|Para|Paramaribo|Saramacca|Sipaliwini|Wanica';
states[216] = 'Barentsoya|Bjornoya|Edgeoya|Hopen|Kvitoya|Nordaustandet|Prins Karls Forland|Spitsbergen';
states[217] = 'Hhohho|Lubombo|Manzini|Shiselweni';
states[218] = 'Blekinge|Dalarnas|Gavleborgs|Gotlands|Hallands|Jamtlands|Jonkopings|Kalmar|Kronobergs|Norrbottens|Orebro|Ostergotlands|Skane|Sodermanlands|Stockholms|Uppsala|Varmlands|Vasterbottens|Vasternorrlands|Vastmanlands|Vastra Gotalands';
states[219] = 'Aargau|Ausser-Rhoden|Basel-Landschaft|Basel-Stadt|Bern|Fribourg|Geneve|Glarus|Graubunden|Inner-Rhoden|Jura|Luzern|Neuchatel|Nidwalden|Obwalden|Sankt Gallen|Schaffhausen|Schwyz|Solothurn|Thurgau|Ticino|Uri|Valais|Vaud|Zug|Zurich';
states[220] = 'Al Hasakah|Al Ladhiqiyah|Al Qunaytirah|Ar Raqqah|As Suwayda\'|Dar\'a|Dayr az Zawr|Dimashq|Halab|Hamah|Hims|Idlib|Rif Dimashq|Tartus';
states[221] = 'Chang-hua|Chi-lung|Chia-i|Chia-i|Chung-hsing-hsin-ts\'un|Hsin-chu|Hsin-chu|Hua-lien|I-lan|Kao-hsiung|Kao-hsiung|Miao-li|Nan-t\'ou|P\'eng-hu|P\'ing-tung|T\'ai-chung|T\'ai-chung|T\'ai-nan|T\'ai-nan|T\'ai-pei|T\'ai-pei|T\'ai-tung|T\'ao-yuan|Yun-lin';
states[222] = 'Viloyati Khatlon|Viloyati Leninobod|Viloyati Mukhtori Kuhistoni Badakhshon';
states[223] = 'Arusha|Dar es Salaam|Dodoma|Iringa|Kagera|Kigoma|Kilimanjaro|Lindi|Mara|Mbeya|Morogoro|Mtwara|Mwanza|Pemba North|Pemba South|Pwani|Rukwa|Ruvuma|Shinyanga|Singida|Tabora|Tanga|Zanzibar Central/South|Zanzibar North|Zanzibar Urban/West';
states[224] = 'Amnat Charoen|Ang Thong|Buriram|Chachoengsao|Chai Nat|Chaiyaphum|Chanthaburi|Chiang Mai|Chiang Rai|Chon Buri|Chumphon|Kalasin|Kamphaeng Phet|Kanchanaburi|Khon Kaen|Krabi|Krung Thep Mahanakhon (Bangkok)|Lampang|Lamphun|Loei|Lop Buri|Mae Hong Son|Maha Sarakham|Mukdahan|Nakhon Nayok|Nakhon Pathom|Nakhon Phanom|Nakhon Ratchasima|Nakhon Sawan|Nakhon Si Thammarat|Nan|Narathiwat|Nong Bua Lamphu|Nong Khai|Nonthaburi|Pathum Thani|Pattani|Phangnga|Phatthalung|Phayao|Phetchabun|Phetchaburi|Phichit|Phitsanulok|Phra Nakhon Si Ayutthaya|Phrae|Phuket|Prachin Buri|Prachuap Khiri Khan|Ranong|Ratchaburi|Rayong|Roi Et|Sa Kaeo|Sakon Nakhon|Samut Prakan|Samut Sakhon|Samut Songkhram|Sara Buri|Satun|Sing Buri|Sisaket|Songkhla|Sukhothai|Suphan Buri|Surat Thani|Surin|Tak|Trang|Trat|Ubon Ratchathani|Udon Thani|Uthai Thani|Uttaradit|Yala|Yasothon';
states[225] = 'Tobago';
states[226] = 'De La Kara|Des Plateaux|Des Savanes|Du Centre|Maritime';
states[227] = 'Atafu|Fakaofo|Nukunonu';
states[228] = 'Ha\'apai|Tongatapu|Vava\'u';
states[229] = 'Arima|Caroni|Mayaro|Nariva|Port-of-Spain|Saint Andrew|Saint David|Saint George|Saint Patrick|San Fernando|Victoria';
states[230] = 'Ariana|Beja|Ben Arous|Bizerte|El Kef|Gabes|Gafsa|Jendouba|Kairouan|Kasserine|Kebili|Mahdia|Medenine|Monastir|Nabeul|Sfax|Sidi Bou Zid|Siliana|Sousse|Tataouine|Tozeur|Tunis|Zaghouan';
states[231] = 'Adana|Adiyaman|Afyon|Agri|Aksaray|Amasya|Ankara|Antalya|Ardahan|Artvin|Aydin|Balikesir|Bartin|Batman|Bayburt|Bilecik|Bingol|Bitlis|Bolu|Burdur|Bursa|Canakkale|Cankiri|Corum|Denizli|Diyarbakir|Duzce|Edirne|Elazig|Erzincan|Erzurum|Eskisehir|Gaziantep|Giresun|Gumushane|Hakkari|Hatay|Icel|Igdir|Isparta|Istanbul|Izmir|Kahramanmaras|Karabuk|Karaman|Kars|Kastamonu|Kayseri|Kilis|Kirikkale|Kirklareli|Kirsehir|Kocaeli|Konya|Kutahya|Malatya|Manisa|Mardin|Mugla|Mus|Nevsehir|Nigde|Ordu|Osmaniye|Rize|Sakarya|Samsun|Sanliurfa|Siirt|Sinop|Sirnak|Sivas|Tekirdag|Tokat|Trabzon|Tunceli|Usak|Van|Yalova|Yozgat|Zonguldak';
states[232] = 'Ahal Welayaty|Balkan Welayaty|Dashhowuz Welayaty|Lebap Welayaty|Mary Welayaty';
states[233] = 'Tuvalu';
states[234] = 'Adjumani|Apac|Arua|Bugiri|Bundibugyo|Bushenyi|Busia|Gulu|Hoima|Iganga|Jinja|Kabale|Kabarole|Kalangala|Kampala|Kamuli|Kapchorwa|Kasese|Katakwi|Kibale|Kiboga|Kisoro|Kitgum|Kotido|Kumi|Lira|Luwero|Masaka|Masindi|Mbale|Mbarara|Moroto|Moyo|Mpigi|Mubende|Mukono|Nakasongola|Nebbi|Ntungamo|Pallisa|Rakai|Rukungiri|Sembabule|Soroti|Tororo';
states[235] = 'Avtonomna Respublika Krym (Simferopol\')|Cherkas\'ka (Cherkasy)|Chernihivs\'ka (Chernihiv)|Chernivets\'ka (Chernivtsi)|Dnipropetrovs\'ka (Dnipropetrovs\'k)|Donets\'ka (Donets\'k)|Ivano-Frankivs\'ka (Ivano-Frankivs\'k)|Kharkivs\'ka (Kharkiv)|Khersons\'ka (Kherson)|Khmel\'nyts\'ka (Khmel\'nyts\'kyy)|Kirovohrads\'ka (Kirovohrad)|Kyyiv|Kyyivs\'ka (Kiev)|L\'vivs\'ka (L\'viv)|Luhans\'ka (Luhans\'k)|Mykolayivs\'ka (Mykolayiv)|Odes\'ka (Odesa)|Poltavs\'ka (Poltava)|Rivnens\'ka (Rivne)|Sevastopol\'|Sums\'ka (Sumy)|Ternopil\'s\'ka (Ternopil\')|Vinnyts\'ka (Vinnytsya)|Volyns\'ka (Luts\'k)|Zakarpats\'ka (Uzhhorod)|Zaporiz\'ka (Zaporizhzhya)|Zhytomyrs\'ka (Zhytomyr)';
states[236] = '\'Ajman|Abu Zaby (Abu Dhabi)|Al Fujayrah|Ash Shariqah (Sharjah)|Dubayy (Dubai)|Ra\'s al Khaymah|Umm al Qaywayn';
states[237] = 'Barking and Dagenham|Barnet|Barnsley|Bath and North East Somerset|Bedfordshire|Bexley|Birmingham|Blackburn with Darwen|Blackpool|Bolton|Bournemouth|Bracknell Forest|Bradford|Brent|Brighton and Hove|Bromley|Buckinghamshire|Bury|Calderdale|Cambridgeshire|Camden|Cheshire|City of Bristol|City of Kingston upon Hull|City of London|Cornwall|Coventry|Croydon|Cumbria|Darlington|Derby|Derbyshire|Devon|Doncaster|Dorset|Dudley|Durham|Ealing|East Riding of Yorkshire|East Sussex|Enfield|Essex|Gateshead|Gloucestershire|Greenwich|Hackney|Halton|Hammersmith and Fulham|Hampshire|Haringey|Harrow|Hartlepool|Havering|Herefordshire|Hertfordshire|Hillingdon|Hounslow|Isle of Wight|Islington|Kensington and Chelsea|Kent|Kingston upon Thames|Kirklees|Knowsley|Lambeth|Lancashire|Leeds|Leicester|Leicestershire|Lewisham|Lincolnshire|Liverpool|Luton|Manchester|Medway|Merton|Middlesbrough|Milton Keynes|Newcastle upon Tyne|Newham|Norfolk|North East Lincolnshire|North Lincolnshire|North Somerset|North Tyneside|North Yorkshire|Northamptonshire|Northumberland|Nottingham|Nottinghamshire|Oldham|Oxfordshire|Peterborough|Plymouth|Poole|Portsmouth|Reading|Redbridge|Redcar and Cleveland|Richmond upon Thames|Rochdale|Rotherham|Rutland|Salford|Sandwell|Sefton|Sheffield|Shropshire|Slough|Solihull|Somerset|South Gloucestershire|South Tyneside|Southampton|Southend-on-Sea|Southwark|St. Helens|Staffordshire|Stockport|Stockton-on-Tees|Stoke-on-Trent|Suffolk|Sunderland|Surrey|Sutton|Swindon|Tameside|Telford and Wrekin|Thurrock|Torbay|Tower Hamlets|Trafford|Wakefield|Walsall|Waltham Forest|Wandsworth|Warrington|Warwickshire|West Berkshire|West Sussex|Westminster|Wigan|Wiltshire|Windsor and Maidenhead|Wirral|Wokingham|Wolverhampton|Worcestershire|York';
states[238] = 'Artigas|Canelones|Cerro Largo|Colonia|Durazno|Flores|Florida|Lavalleja|Maldonado|Montevideo|Paysandu|Rio Negro|Rivera|Rocha|Salto|San Jose|Soriano|Tacuarembo|Treinta y Tres';
states[239] = 'Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|District of Columbia|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming';
states[240] = 'Andijon Wiloyati|Bukhoro Wiloyati|Farghona Wiloyati|Jizzakh Wiloyati|Khorazm Wiloyati (Urganch)|Namangan Wiloyati|Nawoiy Wiloyati|Qashqadaryo Wiloyati (Qarshi)|Qoraqalpoghiston (Nukus)|Samarqand Wiloyati|Sirdaryo Wiloyati (Guliston)|Surkhondaryo Wiloyati (Termiz)|Toshkent Shahri|Toshkent Wiloyati';
states[241] = 'Malampa|Penama|Sanma|Shefa|Tafea|Torba';
states[242] = 'Amazonas|Anzoategui|Apure|Aragua|Barinas|Bolivar|Carabobo|Cojedes|Delta Amacuro|Dependencias Federales|Distrito Federal|Falcon|Guarico|Lara|Merida|Miranda|Monagas|Nueva Esparta|Portuguesa|Sucre|Tachira|Trujillo|Vargas|Yaracuy|Zulia';
states[243] = 'An Giang|Ba Ria-Vung Tau|Bac Giang|Bac Kan|Bac Lieu|Bac Ninh|Ben Tre|Binh Dinh|Binh Duong|Binh Phuoc|Binh Thuan|Ca Mau|Can Tho|Cao Bang|Da Nang|Dac Lak|Dong Nai|Dong Thap|Gia Lai|Ha Giang|Ha Nam|Ha Noi|Ha Tay|Ha Tinh|Hai Duong|Hai Phong|Ho Chi Minh|Hoa Binh|Hung Yen|Khanh Hoa|Kien Giang|Kon Tum|Lai Chau|Lam Dong|Lang Son|Lao Cai|Long An|Nam Dinh|Nghe An|Ninh Binh|Ninh Thuan|Phu Tho|Phu Yen|Quang Binh|Quang Nam|Quang Ngai|Quang Ninh|Quang Tri|Soc Trang|Son La|Tay Ninh|Thai Binh|Thai Nguyen|Thanh Hoa|Thua Thien-Hue|Tien Giang|Tra Vinh|Tuyen Quang|Vinh Long|Vinh Phuc|Yen Bai';
states[244] = 'Saint Croix|Saint John|Saint Thomas';
states[245] = 'Blaenau Gwent|Bridgend|Caerphilly|Cardiff|Carmarthenshire|Ceredigion|Conwy|Denbighshire|Flintshire|Gwynedd|Isle of Anglesey|Merthyr Tydfil|Monmouthshire|Neath Port Talbot|Newport|Pembrokeshire|Powys|Rhondda Cynon Taff|Swansea|The Vale of Glamorgan|Torfaen|Wrexham';
states[246] = 'Alo|Sigave|Wallis';
states[247] = 'West Bank';
states[248] = 'Western Sahara';
states[249] = '\'Adan|\'Ataq|Abyan|Al Bayda\'|Al Hudaydah|Al Jawf|Al Mahrah|Al Mahwit|Dhamar|Hadhramawt|Hajjah|Ibb|Lahij|Ma\'rib|Sa\'dah|San\'a\'|Ta\'izz';
states[250] = 'Kosovo|Montenegro|Serbia|Vojvodina';
states[251] = 'Central|Copperbelt|Eastern|Luapula|Lusaka|North-Western|Northern|Southern|Western';
states[252] = 'Bulawayo|Harare|ManicalandMashonaland Central|Mashonaland East|Mashonaland West|Masvingo|Matabeleland North|Matabeleland South|Midlands';

/* harmony default export */ __webpack_exports__["a"] = ({ countries: countries, states: states });

/***/ }),

/***/ "myqB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'display-qr-app',
  inheritAttrs: false,
  props: {
    location: Object
  },
  data: function data() {
    return {
      apiUrl: ''
    };
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
  },

  methods: {
    copy: function copy(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy).then(function (e) {}, function (e) {});
    }
  }
});

/***/ }),

/***/ "mzTh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementOrdersSuppliers_vue__ = __webpack_require__("QJH9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111d9e2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementOrdersSuppliers_vue__ = __webpack_require__("o7NM");
function injectStyle (ssrContext) {
  __webpack_require__("uXGO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-111d9e2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementOrdersSuppliers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111d9e2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementOrdersSuppliers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mzhu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosSettingsUsers_vue__ = __webpack_require__("ll3j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b13630d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosSettingsUsers_vue__ = __webpack_require__("T9EL");
function injectStyle (ssrContext) {
  __webpack_require__("3V/3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosSettingsUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b13630d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosSettingsUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n4qE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n7HU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't3'
});

/***/ }),

/***/ "n7QK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_json_excel__ = __webpack_require__("fXhN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_LineChart_vue__ = __webpack_require__("w3Bt");








var _components;








__WEBPACK_IMPORTED_MODULE_7_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_11_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'LineChart', __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_LineChart_vue__["a" /* default */]), _components),
  props: {
    isSalesProductsTrend: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isSalesProductsTrend: function isSalesProductsTrend() {
      if (this.isSalesProductsTrend) {
        this.getOrders();
        this.verifyUserLocations();
        this.verifyUserMethods();
      }
    }
  },

  computed: {
    mergedProducts: function mergedProducts() {
      var map = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(this.availableProducts.map(function (t) {
        return [t.id, t];
      }));
      this.selectedProducts.forEach(function (t) {
        if (!map.has(t.id)) {
          map.set(t.id, t);
        }
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(map.values());
    }
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      productsTableData: [],
      productsTableDataTotals: {},
      paymentMethods: [],
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_method: '',
      loading: true,
      loadingProducts: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_8_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      ordersTableData: {},
      totals: {
        total: 0,
        totalCash: 0,
        totalVirament: 0,
        totalOnline: 0,
        totalProtocol: 0,
        totalCard: 0,
        totalPOS: 0,
        totalCARDPOS: 0,
        totalTips: 0,
        totalDiscount: 0,
        totalTax: 0,
        totalShipping: 0,
        avarageOrderValue: 0
      },
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '550px',
          width: '550px'
        }
      },
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Vânzari',
              fontColor: 'red',
              fontSize: 22
            },
            ticks: { beginAtZero: true }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Data',
              fontColor: 'red',
              fontSize: 22
            }
          }]
        }
      },

      use_tips: true,
      noData: false,
      selectedProducts: [],
      availableProducts: [],
      allProductsMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a()
    };
  },

  methods: {
    searchProducts: function searchProducts(query) {
      var _this = this;

      if (!query) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loadingProducts = true;

      this.apiRequest('/search-order-products', 'GET', data, function (response) {
        if (response.status) {
          response.data.forEach(function (item) {
            _this.allProductsMap.set(item.id, item);
          });

          _this.availableProducts = response.data;
        } else {
          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loadingProducts = false;
        });
      });
    },
    clearSearch: function clearSearch() {
      this.$refs.productSelect.focus();
      var select = this.$refs.productSelect;

      if (select) {
        select.query = '';
        select.handleQueryChange('');
      }
    },
    getPaymentMethods: function getPaymentMethods() {
      var _this2 = this;

      var sessionData = this.$session.get('selectedCompanyData');

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };

        this.apiRequest('/orders/get-payment-methods', 'GET', data, function (response) {
          if (response.status && response.data.length) {
            var result = response.data.map(function (item) {
              return { id: item || 'unpaid', name: _this2.$t('paymentTypes.' + item) };
            });
            sessionData['payment_methods'] = response.data;
            _this2.$session.set('selectedCompanyData', sessionData);

            __WEBPACK_IMPORTED_MODULE_7_vue___default.a.set(_this2, 'paymentMethods', result);
          }
        });
      } else {
        var result = sessionData['payment_methods'].map(function (item) {
          return { id: item || 'unpaid', name: _this2.$t('paymentTypes.' + item) };
        });
        __WEBPACK_IMPORTED_MODULE_7_vue___default.a.set(this, 'paymentMethods', result);
      }
    },
    summaryTotal: function summaryTotal() {
      var result = {
        revenue: 0,
        quantity: 0,
        discount: 0,
        vat: 0
      };

      this.productsTableData.forEach(function (item) {
        result.revenue += Number(item.total_revenue || 0);
        result.quantity += Number(item.quantity_sold || 0);
        result.discount += Number(item.discount || 0);
        result.vat += Number(item.vat || 0);
      });

      return result;
    },
    startDownload: function startDownload() {
      this.loading = true;
    },
    finishDownload: function finishDownload() {
      this.loading = false;
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this3 = this;

      if (!this.isSalesProductsTrend) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };
      if (this.selectedProducts && this.selectedProducts.length) {
        data.product_ids = this.selectedProducts.map(function (table) {
          return table.id;
        });
      }
      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }
      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;

      this.apiRequest('/reports/v2/product-trends' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          if (response.data.table_data.length) {
            _this3.ordersTableData.data = response.data.table_data;
            _this3.ordersTableData.total = response.pagination.total;
            _this3.paginationProps.currentPage = response.pagination.page;
            _this3.paginationProps.pageSize = response.pagination.perPage;
          } else {
            _this3.ordersTableData.data = [];
            _this3.ordersTableData.total = 0;
          }

          _this3.$nextTick(function () {
            _this3.chartData = {
              labels: response.data.labels,
              datasets: response.data.datasets
            };
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
        }

        _this3.$nextTick(function () {
          _this3.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    exportData: function exportData() {
      var _this4 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/product-trends-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error');
        }
        _this4.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "n7pR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2_dist_sweetalert2_css__);













var _components;






__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a), _components),
  props: {
    zoneId: null,
    callback: {
      required: false
    }
  },
  watch: {
    zoneId: function zoneId(value) {
      this.id = value;
    }
  },
  computed: {
    unitOptions: function unitOptions() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.unitMapping);
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getData();
    this.getAllUnits();
  },
  data: function data() {
    return {
      apiUrl: '',
      id: this.value || this.zoneId,
      isNew: true,
      allUnits: [],
      model: {
        'id': 0,
        'name': '',
        'short': '',
        'short_spv': null,
        'unit_calc': []
      },
      modelValidate: {
        name: { required: true },
        short: { required: true },
        short_spv: { required: true }
      },
      languages: this.$session.get('defaultData')['available_languages'],
      loading: true
    };
  },

  methods: {
    addConversion: function addConversion() {
      var mod = this.model;
      this.model = null;
      mod.unit_calc.push({
        unit_id: null,
        value: null,
        name: '',
        short: ''
      });
      this.model = mod;
    },
    removeConversion: function removeConversion(index) {
      var mod = this.model;
      this.model = null;
      mod.unit_calc.splice(index, 1);
      this.model = mod;
    },
    onUnitChange: function onUnitChange(index) {
      var mod = this.model;
      this.model = null;
      var selectedId = mod.unit_calc[index].unit_id;
      var unit = this.allUnits.find(function (u) {
        return u.id === selectedId;
      });
      if (unit) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(mod.unit_calc[index], {
          name: unit.name,
          short: unit.short
        });
      }
      this.model = mod;
    },
    isUnitAlreadyUsed: function isUnitAlreadyUsed(unit_id, currentIndex) {
      if (unit_id == null) return false;

      return this.model.unit_calc.some(function (conversion, index) {
        return index !== currentIndex && conversion.unit_id === unit_id;
      });
    },
    getData: function getData() {
      var _this = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (this.$route.params.id !== undefined && this.$route.params.id || this.id !== undefined && this.id !== null) {
        this.isNew = false;
      } else {
        this.isNew = true;
      }
      if (!this.isNew) {
        var id = this.$route.params.id || this.id;
        this.apiRequest('/measurements-units/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            response.data.short_spv = _this.unitMapping[response.data.short_spv];
            _this.model = response.data;
            if (!_this.model.unit_calc) {
              _this.model.unit_calc = [];
            }
            _this.loading = false;
          }
        });
      } else {
        this.loading = false;
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveZone();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    getAllUnits: function getAllUnits() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/measurements-units', 'GET', data, function (response) {
        if (response.status === true) {
          _this3.allUnits = response.data.filter(function (unit) {
            return unit.id !== _this3.model.id;
          });
        }
      });
    },
    saveZone: function saveZone() {
      var _this4 = this;

      this.loading = true;
      var data = this.model;
      if (data.short_spv && data.short_spv.value) {
        data.short_spv = data.short_spv.value;
      }
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      this.apiRequest('/measurements-units/' + data.id, 'PUT', data, function (response) {
        if (response.success === true) {
          _this4.loading = false;
          _this4.errors.clear();
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
            title: '',
            text: _this4.$t('settingTable.tableSave'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).then(function () {}).catch(function () {});
          _this4.cancelZone();
        } else {
          _this4.loading = false;
          _this4.handleErrors(response.errors);
        }
      });
    },
    deleteZone: function deleteZone() {
      var _this5 = this;

      var btnCounter = 1;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({
        title: self.$t('settingTable.deleteZoneTitle'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          _this5.deleteZone2();
        }
      });
      __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    deleteZone2: function deleteZone2() {
      var _this6 = this;

      this.loadingReset = true;
      var id = this.id || this.$route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/measurements-units/' + id, 'PUT', data, function (response) {
        if (response.success === true) {
          _this6.loadingReset = false;
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this6.cancelZone();
        } else {
          _this6.loadingReset = false;
          __WEBPACK_IMPORTED_MODULE_13_sweetalert2___default()({ 'text': _this6.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    cancelZone: function cancelZone() {
      if (typeof this.callback === 'function') {
        this.callback();
      }
    }
  }
});

/***/ }),

/***/ "nAPq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingProducts: false,
      loadingTimeout: null,
      onSeriesInputTimeout: null,
      searchTimeout: null,
      paginationKey: 0,
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      selectedVatNumber: null,
      selectedLocationId: '',
      selectedLocation: null,
      vatNumber: null,
      vats: [],
      locations: [],
      tableData: [],
      searchResults: [],
      productName: '',
      productDescription: '',
      productNameFilter: '',
      stocMinim: null,
      cotaTva: '',
      productType: '',
      productTypes: [{ value: 'Marfa', label: 'Marfa' }, { value: 'Materii prime', label: 'Materii prime' }, { value: 'Materiale consumabile', label: 'Materiale consumabile' }, { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' }, { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' }, { value: 'Produs rezidual', label: 'Produs rezidual' }, { value: 'Ambalaje', label: 'Ambalaje' }, { value: 'Obiecte de inventar', label: 'Obiecte de inventar' }],
      um: '',

      currency: 'RON',
      codeProduct: '',
      selectedCategory: '',
      categories: [{ value: 'Marfa', label: 'Marfa' }, { value: 'Materii prime', label: 'Materii prime' }, { value: 'Materiale consumabile', label: 'Materiale consumabile' }, { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' }, { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' }, { value: 'Produs rezidual', label: 'Produs rezidual' }, { value: 'Ambalaje', label: 'Ambalaje' }, { value: 'Obiecte de inventar', label: 'Obiecte de inventar' }, { value: 'fara_categorie', label: 'Fara categorie' }],
      mesurementsUnits: [],
      modelValidate: {
        productName: { required: true },
        productType: { required: true },
        price: { required: true },
        codeProduct: { required: true },
        um: { required: true },
        cotaTva: { required: true },
        selectedLocationId: { required: true }
      }
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
    this.loadMesurementsUnits();

    var query = this.$route.query;
    console.log('Query params on created:', query);
    var queryVatNumber = query.vatNumber;
    var queryLocationId = query.locationId;

    if (queryVatNumber || queryLocationId) {
      if (queryLocationId) {
        this.selectedLocationId = queryLocationId;
      }
      if (queryVatNumber) {
        this.selectedVatNumber = queryVatNumber;
      }
    } else if (this.groupedLocations && this.groupedLocations.length === 1) {
      var onlyGroup = this.groupedLocations[0];

      if (onlyGroup.locations && onlyGroup.locations.length > 0) {
        this.selectedLocationId = onlyGroup.locations[0].true_id;
      }

      this.selectedVatNumber = onlyGroup.vat;
    }

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  watch: {
    productNameFilter: function productNameFilter() {
      var _this = this;

      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$refs.searchTerm.focus();

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      })), 300);
    },
    selectedLocationId: function selectedLocationId(id) {
      if (!id) return;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;
            this.loadVats(loc.true_id);

            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    selectedVatNumber: function selectedVatNumber(newVat) {
      this.selectedVatNumber = newVat;

      if (!newVat) {
        this.tableData = [];
        this.totalItems = 0;
        this.currentPage = 1;
      }
    },
    productType: function productType(newVal) {
      if (newVal === 'Semifabricate (Reteta)') {
        this.um = 'BUC';
      }
    }
  },
  computed: {
    filteredProducts: function filteredProducts() {
      return this.tableData;
    }
  },
  methods: {
    handleRefresh: function handleRefresh() {
      this.handlePageChange(this.currentPage);
    },
    loadMesurementsUnits: function loadMesurementsUnits() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getMesurementsUnits();

              case 2:
                _this2.mesurementsUnits = _context2.sent;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadVats: function loadVats(locationId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.fetchVats(locationId);

              case 2:
                _this3.vats = _context3.sent;

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getProducts(this.currentPage, this.pageSize);
    },
    getCategoryClass: function getCategoryClass(categorie) {
      if (!categorie) return '';
      var name = categorie.replace(' (Reteta)', '').trim().toLowerCase();
      return name.replace(/\s+/g, '-');
    },
    validate: function validate() {
      var _this4 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this4.saveProduct();
        }
      });
    },
    addBonProduct: function addBonProduct() {
      this.$router.push('/management/bon-product/add');
    },
    editProduct: function editProduct(id, vatNumber) {
      this.$router.push('/management/nomenclator-products/edit/' + id + '/' + vatNumber);
    },
    saveProduct: function saveProduct() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var missingFields, productData, response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                missingFields = [];


                if (!_this5.selectedLocation) missingFields.push('Trebuie să selectați o locație');
                if (!_this5.productName) missingFields.push('Numele produsului este obligatoriu');
                if (!_this5.codeProduct) missingFields.push('Codul produsului este obligatoriu');
                if (_this5.cotaTva === null || _this5.cotaTva === undefined || _this5.cotaTva === '') {
                  missingFields.push('Cota TVA este obligatorie');
                }
                if (!_this5.currency) missingFields.push('Moneda este obligatorie');
                if (!_this5.um) missingFields.push('Unitatea de măsură (UM) este obligatorie');
                if (!_this5.productType) missingFields.push('Categoria produsului este obligatorie');

                if (!(missingFields.length > 0)) {
                  _context4.next = 11;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Câmpuri lipsă',
                  html: missingFields.map(function (f) {
                    return '\u2022 ' + f;
                  }).join('<br>'),
                  icon: 'warning',
                  showConfirmButton: true,
                  allowOutsideClick: false
                });
                return _context4.abrupt('return');

              case 11:
                productData = {
                  name: _this5.productName,
                  product_code: _this5.codeProduct,

                  is_with_vat: true,
                  vat_percent: parseInt(_this5.cotaTva),
                  currency: _this5.currency,
                  um: _this5.um,
                  externalId: '',
                  externalCompanyId: _this5.companyID,
                  externalLocationId: _this5.selectedLocation.true_id,
                  vatNumber: _this5.selectedLocation.inv_fiscal_code,
                  categorie: _this5.productType,
                  stocMinim: _this5.stocMinim,
                  is_external: 0,
                  pret_vanzare: []
                };
                _context4.prev = 12;
                _context4.next = 15;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/nomenclator', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(productData)
                });

              case 15:
                response = _context4.sent;
                _context4.next = 18;
                return response.json();

              case 18:
                data = _context4.sent;

                console.log('Product saved successfully:', data);

                if (response.ok) {
                  _context4.next = 23;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Eroare',
                  text: data.details || 'A apărut o eroare la salvarea produsului.',
                  type: 'error',
                  timer: 4000,
                  showConfirmButton: false
                });
                return _context4.abrupt('return');

              case 23:

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Produsul a fost salvat cu succes.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this5.$modal.hide('addProductModal');
                _this5.selectedVatNumber = _this5.selectedLocation.inv_fiscal_code;
                _context4.next = 28;
                return _this5.getProducts();

              case 28:
                _this5.resetFields();
                _context4.next = 35;
                break;

              case 31:
                _context4.prev = 31;
                _context4.t0 = _context4['catch'](12);

                console.error('Error saving product:', _context4.t0);
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o eroare la salvarea produsului.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 35:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[12, 31]]);
      }))();
    },
    getProducts: function getProducts() {
      var _this6 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.pageSize;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var categoryParam, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.tableData = [];
                _this6.totalItems = 0;

                if (_this6.companyID) {
                  _context5.next = 5;
                  break;
                }

                console.error('Missing companyID');
                return _context5.abrupt('return');

              case 5:

                clearTimeout(_this6.loadingTimeout);
                _this6.loadingTimeout = setTimeout(function () {
                  _this6.loading = true;
                }, 300);

                _this6.loadingProducts = true;
                _context5.prev = 8;
                categoryParam = _this6.selectedCategory ? '&categorie=' + encodeURIComponent(_this6.selectedCategory) + '&is_search=true' : '';
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/products?externalCompanyId=' + _this6.companyID + categoryParam;


                if (_this6.selectedVatNumber) {
                  url += '&vatNumber=' + encodeURIComponent(_this6.selectedVatNumber);
                }
                if (_this6.productNameFilter) {
                  url += '&name=' + encodeURIComponent(_this6.productNameFilter);
                }

                url += '&page=' + page + '&limit=' + pageSize;

                _context5.next = 16;
                return fetch(url);

              case 16:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 19;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 19:
                _context5.next = 21;
                return response.json();

              case 21:
                data = _context5.sent;

                console.log('Products fetched successfully:', data);

                if (Array.isArray(data.products)) {
                  clearTimeout(_this6.loadingTimeout);
                  _this6.loading = false;
                  _this6.totalItems = data.total || 0;
                  _this6.currentPage = data.currentPage || page;
                  _this6.pageSize = data.pageSize || pageSize;
                  _this6.tableData = data.products.map(function (product) {
                    return {
                      product: product.name,
                      vatNumber: product.vatNumber,
                      codeProduct: product.product_code,
                      categorie: product.categorie,
                      price: product.price && !isNaN(product.price) ? parseInt(product.price).toFixed(2) + ' ' + product.currency : 'N/A',
                      um: product.um,
                      currency: product.currency,
                      id: product._id,
                      hasReteta: !!(product.reteta && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(product.reteta).length > 0),
                      validity: product.validity
                    };
                  });

                  _this6.paginationKey++;
                } else {
                  console.error('Invalid data format:', data);
                }
                _context5.next = 30;
                break;

              case 26:
                _context5.prev = 26;
                _context5.t0 = _context5['catch'](8);

                console.error('Error fetching products:', _context5.t0);

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Error',
                  text: 'There was an error fetching products.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 30:
                _context5.prev = 30;

                _this6.loadingProducts = false;
                return _context5.finish(30);

              case 33:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[8, 26, 30, 33]]);
      }))();
    },
    resetFields: function resetFields() {
      this.productName = '';
      this.productDescription = '';
      this.codeProduct = '';
      this.price = '';
      this.currency = 'RON';
      this.um = 'BUC';
    },
    openAddProductModal: function openAddProductModal() {
      this.$modal.show('addProductModal');
    },
    closeModal: function closeModal() {
      this.$modal.hide('addProductModal');
    }
  }
});

/***/ }),

/***/ "nF5K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"referral-program-drilldown-modal"},[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back'),"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"sales-report mar-to-15"},[_c('div',{staticClass:"col-md-12 mar-bt-15"},[_c('p',{staticClass:"text-muted"},[_c('span',[_vm._v(_vm._s(_vm.$t('reports.referralProgramReport')))]),_vm._v("\n        "+_vm._s(_vm.$t('general.breadcrumbSeparator'))+"\n        "),_c('span',[_vm._v(_vm._s(_vm.ambassadorTitle))]),_vm._v(" "),(_vm.level === 'orders')?[_vm._v("\n          "+_vm._s(_vm.$t('general.breadcrumbSeparator'))+_vm._s(_vm.refereeTitle)+"\n        ")]:_vm._e()],2)]),_vm._v(" "),(_vm.level === 'referees')?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"campaign-table width-table referral-program-report__table",staticStyle:{"width":"100%"},attrs:{"data":_vm.refereesRows,"total":_vm.refereesTotal,"pagination-props":_vm.paginationProps,"table-props":{ border: false }},on:{"query-change":_vm.onRefereesPage,"row-click":_vm.onRefereeRow}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":70,"prop":"referee_user_id","label":_vm.$t('referralProgram.refereeId')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('span',{staticClass:"referral-report-table__ellipsis"},[_vm._v(_vm._s(p.row.referee_user_id || p.row.user_id || p.row.id))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":160,"label":_vm.$t('reports.name')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('span',{staticClass:"referral-report-table__ellipsis"},[_vm._v(_vm._s(_vm.displayPersonName(p.row, 'referee')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":120,"label":_vm.$t('referralProgram.totalCashbackPercent')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatMoney(_vm.refereeEarningsCashback(p.row)))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":120,"label":_vm.$t('referralProgram.ambassadorEarnings')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatMoney(_vm.refereeEarningsTotal(p.row)))+"\n                "),(p.row.earnings && p.row.earnings.coupons_awarded)?_c('small',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.$t('referralProgram.v2.couponsAwarded'))+": "+_vm._s(p.row.earnings.coupons_awarded))]):_vm._e()]}}])})],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.level === 'orders')?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"campaign-table width-table referral-program-report__table",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersRows,"total":_vm.ordersTotal,"pagination-props":_vm.paginationProps,"table-props":{ border: false }},on:{"query-change":_vm.onOrdersPage}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":90,"prop":"order_id","label":_vm.$t('general.orderId')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('span',{staticClass:"referral-report-table__ellipsis"},[_vm._v(_vm._s(p.row.order_id))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":120,"label":_vm.$t('orders.totals_grandtotal')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatMoney(_vm.orderGrandtotal(p.row)))+"\n              ")]}}])}),_vm._v(" "),_vm._l((_vm.rewardRoles),function(role){return (_vm.hasV2Rewards)?_c('el-table-column',{key:role,attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":190,"label":_vm.$t('referralProgram.v2.' + role)},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._l((_vm.roleRewards(p.row, role)),function(reward,index){return _c('div',{key:index},[_vm._v(_vm._s(reward))])}),_vm._v(" "),(!_vm.roleRewards(p.row, role).length)?_c('span',[_vm._v(_vm._s(_vm.$t('general.emDash')))]):_vm._e()]}}])}):_vm._e()}),_vm._v(" "),(!_vm.hasV2Rewards)?_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":120,"label":_vm.$t('referralProgram.refereeReward')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatMoney(_vm.orderRefereeReward(p.row)))+"\n              ")]}}])}):_vm._e(),_vm._v(" "),(!_vm.hasV2Rewards)?_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":120,"label":_vm.$t('referralProgram.ambassadorOrderReward')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatMoney(_vm.orderAmbassadorOrderReward(p.row)))+"\n              ")]}}])}):_vm._e(),_vm._v(" "),(!_vm.hasV2Rewards)?_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","min-width":120,"label":_vm.$t('referralProgram.ambassadorCashback')},scopedSlots:_vm._u([{key:"default",fn:function(p){return [_vm._v("\n                "+_vm._s(_vm.formatMoney(_vm.orderAmbassadorCashback(p.row)))+"\n              ")]}}])}):_vm._e()],2)],1)])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nFSe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomInfoPageEdit_vue__ = __webpack_require__("Somv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bb6462_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomInfoPageEdit_vue__ = __webpack_require__("XU3N");
function injectStyle (ssrContext) {
  __webpack_require__("NWZS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomInfoPageEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bb6462_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomInfoPageEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nGk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row product-import-detail"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n            "+_vm._s(_vm.$t('general.back'))+"\n          ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.batch && _vm.batch.status === 'PENDING')?_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('general.cancel')},on:{"click":function($event){$event.preventDefault();return _vm.cancelBatch($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png","alt":""}}),_vm._v("\n            "+_vm._s(_vm.$t('general.cancel'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.canConfirm)?_c('button',{staticClass:"btn btn-success btn-icon save",attrs:{"type":"button","disabled":_vm.confirming,"title":_vm.$t('productImport.confirm')},on:{"click":function($event){$event.preventDefault();return _vm.openConfirmModal($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png","alt":""}}),_vm._v("\n            "+_vm._s(_vm.$t('productImport.confirm'))+"\n          ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"import-detail-header"},[_c('div',{staticClass:"import-detail-header__title"},[_c('h5',[_vm._v(_vm._s(_vm.$t('productImport.import'))+" #"+_vm._s(_vm.batch && _vm.batch.id))]),_vm._v(" "),(_vm.batch)?_c('span',{staticClass:"import-status",class:'import-status--' + (_vm.batch.status || '').toLowerCase()},[_vm._v("\n              "+_vm._s(_vm.statusLabel(_vm.batch.status))+"\n            ")]):_vm._e()]),_vm._v(" "),(_vm.batch)?_c('p',{staticClass:"import-detail-meta text-muted"},[_vm._v("\n            "+_vm._s(_vm.batch.created_at)+"\n            "),(_vm.batch.original_filename)?_c('span',[_vm._v(" · "+_vm._s(_vm.batch.original_filename))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" · "+_vm._s(_vm.batch.total_rows)+" "+_vm._s(_vm.$t('productImport.products')))]),_vm._v(" "),(_vm.priceProfileLabel)?_c('span',[_vm._v(" · "+_vm._s(_vm.$t('productImport.selectPriceProfile'))+": "+_vm._s(_vm.priceProfileLabel))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.batch)?_c('p',{staticClass:"import-detail-stats text-muted"},[_vm._v("\n            "+_vm._s(_vm.$t('productImport.pending'))+": "+_vm._s(_vm.batch.pending_rows)+"\n            · "+_vm._s(_vm.$t('productImport.confirmed'))+": "+_vm._s(_vm.batch.confirmed_rows)+"\n            · "+_vm._s(_vm.$t('productImport.removed'))+": "+_vm._s(_vm.batch.removed_rows)+"\n            · "+_vm._s(_vm.$t('productImport.errors'))+": "+_vm._s(_vm.batch.error_rows)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{class:_vm.loading ? 'show-loader' : 'hide-loader'},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"product-import-table data-table mar-bt-20"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.rows}},[_c('el-table-column',{attrs:{"label":_vm.$t('productImport.product'),"min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s((scope.row.data && scope.row.data.name) || ('#' + (scope.row.product_id || scope.row.row_number)))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('productImport.actionType'),"width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(_vm.actionLabel(scope.row.action)))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('productImport.price'),"width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.data && scope.row.data.price !== '' ? scope.row.data.price : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('productImport.status'),"width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(_vm.rowStatusLabel(scope.row.status)))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('productImport.errors'),"width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.validation_errors && scope.row.validation_errors.length)?_c('span',{staticStyle:{"color":"#c0392b"}},[_vm._v("\n                  "+_vm._s(scope.row.validation_errors.join('; '))+"\n                ")]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"import-row-actions"},[(_vm.canEditRow(scope.row))?_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('productImport.remove')},on:{"click":function($event){$event.preventDefault();_vm.removeRow(scope.row)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png","alt":""}}),_vm._v("\n                    "+_vm._s(_vm.$t('productImport.remove'))+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.canEditRow(scope.row))?_c('div',{staticClass:"edit import-row-edit",on:{"click":function($event){$event.stopPropagation();_vm.openEdit(scope.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                  ")]):_vm._e()])]}}])})],1)],1)])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.$t('productImport.confirmTitle'),"visible":_vm.confirmVisible,"width":"440px","custom-class":"product-import-edit-dialog","append-to-body":"","modal-append-to-body":true,"close-on-click-modal":false,"close-on-press-escape":false},on:{"update:visible":function($event){_vm.confirmVisible=$event}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"pad-bt-5"},[_vm._v(_vm._s(_vm.$t('productImport.selectPriceProfile'))+" *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":_vm.$t('productImport.selectPriceProfile')},model:{value:(_vm.confirmPriceProfileId),callback:function ($$v) {_vm.confirmPriceProfileId=$$v},expression:"confirmPriceProfileId"}},_vm._l((_vm.locationPriceProfiles),function(profile){return _c('el-option',{key:profile.id,attrs:{"label":profile.name,"value":profile.id}})})),_vm._v(" "),_c('p',{staticClass:"text-muted",staticStyle:{"margin":"8px 0 0","font-size":"12px"}},[_vm._v(_vm._s(_vm.$t('productImport.confirmPriceHint')))])],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-info product-import-dialog-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.confirmVisible = false}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-success product-import-dialog-btn",attrs:{"type":"button","disabled":_vm.confirming || !_vm.confirmPriceProfileId},on:{"click":_vm.confirmBatch}},[_vm._v(_vm._s(_vm.$t('productImport.confirm')))])])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.$t('productImport.editRow'),"visible":_vm.editVisible,"width":"92%","top":"4vh","custom-class":"product-import-edit-dialog","append-to-body":"","modal-append-to-body":true,"close-on-click-modal":false,"close-on-press-escape":false},on:{"update:visible":function($event){_vm.editVisible=$event}}},[(_vm.editData)?_c('div',{staticClass:"product-import-edit-body"},[_c('h6',[_vm._v(_vm._s(_vm.$t('productImport.sectionIdentity')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("PRODUCT ID")]),_vm._v(" "),_c('el-input',{attrs:{"clearable":""},on:{"blur":_vm.validateProductId,"clear":_vm.onProductIdCleared},model:{value:(_vm.editData.product_id),callback:function ($$v) {_vm.$set(_vm.editData, "product_id", $$v)},expression:"editData.product_id"}}),_vm._v(" "),_c('p',{staticClass:"product-match-status",class:_vm.productMatchClass},[_vm._v(_vm._s(_vm.productMatchMessage))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.searchProduct')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","reserve-keyword":"","remote-method":_vm.searchProducts,"loading":_vm.searchProductsLoading,"placeholder":_vm.$t('productImport.searchProductPlaceholder')},on:{"change":_vm.onSearchProductSelected},model:{value:(_vm.selectedSearchProductId),callback:function ($$v) {_vm.selectedSearchProductId=$$v},expression:"selectedSearchProductId"}},_vm._l((_vm.productSearchResults),function(prod){return _c('el-option',{key:prod.id,attrs:{"value":prod.id,"label":'#' + prod.id + ' — ' + prod.name}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.product')))]),_vm._v(" "),_c('el-input',{model:{value:(_vm.editData.name),callback:function ($$v) {_vm.$set(_vm.editData, "name", $$v)},expression:"editData.name"}})],1)])]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.$t('productImport.sectionCategories')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.topCategory')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","allow-create":"","default-first-option":"","clearable":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.editData.topCateg),callback:function ($$v) {_vm.$set(_vm.editData, "topCateg", $$v)},expression:"editData.topCateg"}},_vm._l((_vm.topCategoryNames),function(name){return _c('el-option',{key:'tc-' + name,attrs:{"label":name,"value":name}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.category')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","allow-create":"","default-first-option":"","clearable":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.editData.categ),callback:function ($$v) {_vm.$set(_vm.editData, "categ", $$v)},expression:"editData.categ"}},_vm._l((_vm.categoryNames),function(name){return _c('el-option',{key:'c-' + name,attrs:{"label":name,"value":name}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.secCategory')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","clearable":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.secCategList),callback:function ($$v) {_vm.secCategList=$$v},expression:"secCategList"}},_vm._l((_vm.categoryNames),function(name){return _c('el-option',{key:'sc-' + name,attrs:{"label":name,"value":name}})}))],1)])]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.$t('productImport.sectionBase')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.price')))]),_vm._v(" "),_c('el-input',{model:{value:(_vm.editData.price),callback:function ($$v) {_vm.$set(_vm.editData, "price", $$v)},expression:"editData.price"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.active')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('productImport.activeHint')},model:{value:(_vm.editData.active),callback:function ($$v) {_vm.$set(_vm.editData, "active", $$v)},expression:"editData.active"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.posId')))]),_vm._v(" "),_c('el-input',{model:{value:(_vm.editData.pos_id),callback:function ($$v) {_vm.$set(_vm.editData, "pos_id", $$v)},expression:"editData.pos_id"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.vat')))]),_vm._v(" "),_c('el-input',{model:{value:(_vm.editData.vat),callback:function ($$v) {_vm.$set(_vm.editData, "vat", $$v)},expression:"editData.vat"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.section')))]),_vm._v(" "),_c('el-input',{model:{value:(_vm.editData.section),callback:function ($$v) {_vm.$set(_vm.editData, "section", $$v)},expression:"editData.section"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.weight')))]),_vm._v(" "),_c('el-input',{model:{value:(_vm.editData.weight),callback:function ($$v) {_vm.$set(_vm.editData, "weight", $$v)},expression:"editData.weight"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.imageFilename')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('productImport.imageFilenameHint')},model:{value:(_vm.editData.image),callback:function ($$v) {_vm.$set(_vm.editData, "image", $$v)},expression:"editData.image"}})],1)])]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.$t('productImport.sectionDescription')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.desc')))]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":3},model:{value:(_vm.editData.desc),callback:function ($$v) {_vm.$set(_vm.editData, "desc", $$v)},expression:"editData.desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.nutritional')))]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":3},model:{value:(_vm.editData.nutritional),callback:function ($$v) {_vm.$set(_vm.editData, "nutritional", $$v)},expression:"editData.nutritional"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.allergenic')))]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":2},model:{value:(_vm.editData.allergenic),callback:function ($$v) {_vm.$set(_vm.editData, "allergenic", $$v)},expression:"editData.allergenic"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('productImport.ingredients')))]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":2},model:{value:(_vm.editData.ingredients),callback:function ($$v) {_vm.$set(_vm.editData, "ingredients", $$v)},expression:"editData.ingredients"}})],1)])]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.$t('productImport.sectionPrices')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_vm._l((_vm.channelPriceGroups),function(group){return _c('div',{key:group.key,staticClass:"price-source-group"},[_c('div',{staticClass:"price-source-group__title"},[_vm._v(_vm._s(group.label))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((group.fields),function(field){return _c('div',{key:field.key,staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(field.label))]),_vm._v(" "),_c('el-input',{model:{value:(_vm.editData[field.key]),callback:function ($$v) {_vm.$set(_vm.editData, field.key, $$v)},expression:"editData[field.key]"}})],1)])}))])})],2):_vm._e(),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-info product-import-dialog-btn",attrs:{"type":"button"},on:{"click":function($event){_vm.editVisible = false}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-success product-import-dialog-btn",attrs:{"type":"button","disabled":_vm.saving || _vm.productIdInvalid},on:{"click":_vm.saveEdit}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nI7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coupons_vue__ = __webpack_require__("PgRl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d7f68de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coupons_vue__ = __webpack_require__("nzNW");
function injectStyle (ssrContext) {
  __webpack_require__("j50F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coupons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d7f68de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Coupons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nJqr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesTrend_vue__ = __webpack_require__("yJ4m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e63835c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesTrend_vue__ = __webpack_require__("7Y9/");
function injectStyle (ssrContext) {
  __webpack_require__("gCpC")
  __webpack_require__("i67M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesTrend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e63835c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesTrend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nKgJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosView_vue__ = __webpack_require__("wqfZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4506a232_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosView_vue__ = __webpack_require__("RYJx");
function injectStyle (ssrContext) {
  __webpack_require__("4kd5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4506a232"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4506a232_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nLoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.vat')))]),_vm._v(" "),_c('small',[_vm._v("("+_vm._s(_vm.$t('catalogCateg.included'))+")")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.output),expression:"output"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",on:{"input":function($event){_vm.handleClick()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.output=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.vatOptions),function(vat){return _c('option',{domProps:{"value":vat.amount}},[_vm._v(_vm._s(vat.amount)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nMQW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAApCAYAAACcGcHqAAAABHNCSVQICAgIfAhkiAAABCxJREFUWEfNWUtOG0EQreYjJavACQIniDlB8CaS2QDLCBDmBIETxDlByAkAAcoysMFSNjgnIJwgzgkwqyAh6LxqPKanp6e73PYkHilSgK6aelWvfj2KBM/lgZ67m6VVrWmNFC0ooppALOmIJvoJwY7SdN7YUh2JEtgTftonehvG7ytFc7GzFfy9M61o792GYmClTxAEABxAslmBccOpVLTT2FCHZUKlICYGQGZ5AIgXxMWxXgN9vg3nrmpPg9K9mSmq+6jlBYEo/IJJC9WalaS909hUdVeyAGISo2AbjURfcqNRAIEocAJtDwQ1XaOsvknyWxVCmj6h9LZs1T4QeSpBSCtq4uDrKmwaVidy48fKllqOgUC/sR5NdURiF79ZHfaFVZznBAeI+VIQ7WO9DIMv7QMv7mn+bgYgFH2MGHUL9C102mBjCulAxGuIOFPlVfBd07TYeK+62ZkcnS5O9C5+8dnOB/Cv5gPnvgQe+gIPccRGelBYeDr4EFQCdtgjSR5EUcERSlqz/VUv0ANxrpQ/ka4qRdY+1U3SxJNC+eMktwuiAy+8zaRBj72VTbXPP6Nq9UJh5sHt5T3V6zuKzyU9PGj+maVLwYBpnOun07G+yQ16VtgQ5hxAn5WcdJBPzwmNnBAMmuwwOHepAMJHGU7qzLPIi5YguZMikCKESAxYNPiPL3ntgyKupliTKGN3bhtEwdM2iO+nuvag6SrxnWMXA3XXUQ3PWPEzCHfcwB9tEP3kzjdCb2LQNer9YWq/4F4BtVzqwxOCVaEGINAjrtyqYOcE2ytJblcmJQSSkm6PH3Ykil52mkphOHQsdKtGCoBMBg7LV8qisi6YsjigUxnf7T5hIuF2dD+dct00BYhkQmC9Gd1NJAI7RK6pSJUj1GdqKq1f6EfTK9ZE4PtMMSDKeoCPHqBUPLlFFox+KGNKFonSbuxWKFCqG60co9sn0pANnU+RCOzU7jqIs1ybJ2W3MAtSBqKcIs50Kh0/uARCeUfkUt+hp34RdFa2IKlYsrp7Qux8355z0FCWnAGUsZJuRLEgqVjZdHdaSSPCPlBY5lMiInIYKpSKbVK+nTa6W6DEgqvrKYbbMqJIwGEMIroncMjsnVYiM0qvMEC0ubxrChxxxCBi7Z3siTHUVwQvHPsRU0BEzcvh+CTdEqKs/haBcJO7/9HlZuxuTVBoIiHkd+HCSiKXYFOKCHJCMplynlmbVD8vChdtKRaMKsN2qT41ulAWvnVD93Wv1WPleVQDo/K47ObLvdgontfjLEnGATMYLf7TrXk21z1vdpKbN6Iu1s8l+4KsH8lDoP23Q6E10+VuALnNmyW/fEm/BaW8X1G57CIi+1WP6VyN8Nlr1/7QUvg+wfwxBhEt49/gezW2rR7C14p9jjWr7qP53l3DC8f22Zgn4ukpOvO9/y8N3Bc8WSeLJQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "nOq8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nQ+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CharismaItems_vue__ = __webpack_require__("48Il");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_748b2328_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CharismaItems_vue__ = __webpack_require__("nYyy");
function injectStyle (ssrContext) {
  __webpack_require__("V5H8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CharismaItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_748b2328_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CharismaItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nUmM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("TEST")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nXWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",style:({height: _vm.windowHeight - _vm.pageTopHeight - 60 + 'px'})},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"pull-right mar-bt-20"},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.add($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                        "+_vm._s(_vm.$t('general.add'))+"\n                    ")])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.data,"current-page":_vm.pagination.currentPage,"page-size":_vm.pagination.pageSize,"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"20","label":"ID"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                          "+_vm._s(props.row.id)+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"40","label":_vm.$t('customers.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                        "+_vm._s(props.row.name || "-")+"\n                      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"50","prop":"location.name","label":_vm.$t('printer.location')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"40","prop":"section.name","label":_vm.$t('printer.section')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                            "+_vm._s(props.row.section ? props.row.section.name : _vm.$t('general.all'))+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"40","label":"IP"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                            "+_vm._s(props.row.ip || '-')+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"40","label":_vm.$t('settingTable.type')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                            "+_vm._s(_vm.getTypeName(props.row.type))+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"60","label":_vm.$t('printer.correspondingPos')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"pos-devices-cell",attrs:{"title":_vm.getPosNames(props.row.pos_ids)}},[_c('span',{staticClass:"pos-devices-name"},[_vm._v(_vm._s(_vm.getVisiblePosNames(props.row.pos_ids)))]),_vm._v(" "),(_vm.getHiddenPosCount(props.row.pos_ids))?_c('span',{staticClass:"pos-devices-more"},[_vm._v("\n                                    +"+_vm._s(_vm.getHiddenPosCount(props.row.pos_ids))+"\n                                ")]):_vm._e()])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":300,"label":_vm.$t('marketingOffers.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.handleDelete(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                            "+_vm._s(_vm.$t('general.delete'))+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row.id)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                          ")])]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nYyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.charismaReport')}}),_vm._v(" "),_c('div',{staticClass:"col-md-12 card text-left"},[_c('div',{staticClass:"card-header",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('div',[_c('p',{staticClass:"d-inline-flex"},[_c('a',{staticClass:"btn btn-orange back",on:{"click":function($event){$event.preventDefault();return _vm.goBackToReport($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('general.back'))+"\n          ")])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[(_vm.integration && _vm.integration.charisma_invoice_status != 0)?_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"button","title":_vm.$t('charisma.sendOnlyProform')},on:{"click":function($event){$event.preventDefault();_vm.saveDetailsAndSendOrder(1)}}},[_vm._v("\n              "+_vm._s(_vm.$t('charisma.sendOnlyProform'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.integration && _vm.integration.charisma_invoice_status != 0)?_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"button","title":_vm.$t('charisma.sendOnlyInvoice')},on:{"click":function($event){$event.preventDefault();_vm.saveDetailsAndSendOrder(2)}}},[_vm._v("\n              "+_vm._s(_vm.$t('charisma.sendOnlyInvoice'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.integration && _vm.integration.charisma_invoice_status != 0)?_c('span',{staticStyle:{"display":"inline-block","width":"20px"}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"button","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();_vm.saveDetailsAndSendOrder(0)}}},[_vm._v("\n              "+_vm._s(_vm.$t('general.saveAndSend'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-content total-pagination pad-1"},[_c('h5',{staticClass:"charisma-section-title"},[_vm._v(_vm._s(_vm.$t('charisma.orderItems')))]),_vm._v(" "),_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:_vm.tableKey,ref:"charismaTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.items,"search-def":{ show: false },"pagination-props":_vm.paginationProps,"table-props":_vm.tableOptions}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"options-wrapper"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.options || [],"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('charisma.orderOptionId'),"min-width":120}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cov_id","label":_vm.$t('charisma.companyOptionId'),"min-width":120}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"option_name","label":_vm.$t('charisma.optionName'),"min-width":200}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('charisma.optionValueName'),"min-width":200}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cov_external_id","label":_vm.$t('charisma.itemId'),"min-width":160},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                    "+_vm._s(props.row.cov_external_id ? props.row.cov_external_id : '-')+"\n                  ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('charisma.itemCode'),"min-width":160},scopedSlots:_vm._u([{key:"default",fn:function(opt){return [_c('el-input',{class:{ 'is-invalid': _vm.isOptionPosIdMissing(opt.row) },attrs:{"size":"mini","placeholder":_vm.$t('charisma.enterItemCode')},model:{value:(opt.row.cov_pos_id),callback:function ($$v) {_vm.$set(opt.row, "cov_pos_id", $$v)},expression:"opt.row.cov_pos_id"}})]}}])})],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"ID","min-width":40}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"c_id","label":_vm.$t('reports.productId'),"min-width":60}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('reports.productName'),"min-width":160}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"category_name","label":_vm.$t('catalogProd.category'),"min-width":120}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('charisma.categoryAdministration'),"min-width":120},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{class:{ 'is-invalid': _vm.isCategoryAdminInvalid(props.row) }},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"size":"small","value":_vm.categoryAdministrationByKey[_vm.getCategoryKey(props.row)] || props.row._category_admin || props.row.administration_id || null,"placeholder":_vm.$t('general.select')},on:{"change":function($event){_vm.onCategoryAdminChange(props.row, $event)}}},[_c('el-option',{key:'null',attrs:{"label":_vm.$t('general.select'),"value":null}}),_vm._v(" "),_vm._l((_vm.administrations),function(admin){return _c('el-option',{key:admin.id,attrs:{"label":admin.name,"value":admin.id}})})],2)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('charisma.itemId'),"min-width":60},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.c_external_id ? props.row.c_external_id : '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('charisma.itemCode'),"min-width":100},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-input',{class:{ 'is-invalid': _vm.isProductPosIdMissing(props.row) },attrs:{"size":"small","placeholder":_vm.$t('charisma.enterItemCode')},model:{value:(props.row.c_pos_id),callback:function ($$v) {_vm.$set(props.row, "c_pos_id", $$v)},expression:"props.row.c_pos_id"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('charisma.options'),"min-width":70},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s((props.row.options && props.row.options.length) ? props.row.options.length : 0)+"\n          ")]}}])})],1),_vm._v(" "),_c('h5',{staticClass:"charisma-section-title charisma-section-title--logs"},[_vm._v(_vm._s(_vm.$t('charisma.sendHistory')))]),_vm._v(" "),_c('div',{staticClass:"charisma-logs-table-wrap"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.logs,"empty-text":_vm.$t('reports.noDataAvailable')}},[_c('el-table-column',{attrs:{"prop":"action","label":_vm.$t('general.action'),"min-width":120},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.getLogActionLabel(scope.row.action))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('charisma.categoryAdministration'),"min-width":140},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.getLogAdministrationName(scope.row))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('charisma.logRvc'),"min-width":90},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.getLogRvcFromDataTo(scope.row.data_to))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('charisma.document'),"min-width":100},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.hasLogPayload(scope.row.data_to))?_c('a',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('general.visualize')},on:{"click":function($event){$event.preventDefault();_vm.openLogModal(scope.row, 'data_to')}}},[_c('i',{staticClass:"ti-eye"})]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('charisma.resultCharisma'),"min-width":120},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.hasLogPayload(scope.row.data_from))?_c('a',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('general.visualize')},on:{"click":function($event){$event.preventDefault();_vm.openLogModal(scope.row, 'data_from')}}},[_c('i',{staticClass:"ti-eye"})]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('charisma.logStatus'),"min-width":320,"class-name":"charisma-log-status-cell"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"charisma-log-status-text"},[_vm._v(_vm._s(_vm.getLogVerdict(scope.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":_vm.$t('charisma.createDate'),"min-width":160},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.created_at ? _vm.formatToCompanyTimezone(scope.row.created_at, _vm.timezone) : '-')+"\n            ")]}}])})],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nZuH":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "naAb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charisma-location-receipts"},[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.charismaLocationReceipt')}}),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-wrapper"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.locationReceipts,"empty-text":_vm.$t('reports.noDataAvailable')}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"id","min-width":"80","label":"ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"name","min-width":"120","label":_vm.$t('reports.location')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"administration","min-width":"160","label":_vm.$t('charisma.categoryAdministration')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.administration.name || '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"partner_code","min-width":"140","label":_vm.$t('reports.partnerCode')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.partner_code || '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"actions","min-width":"100","label":_vm.$t('marketingCampaigns.actions')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"display-flex",staticStyle:{"align-items":"center","justify-content":"center"}},[_c('a',{staticClass:"btn btn-icon btn-purple",attrs:{"title":_vm.$t('marketingCampaigns.open')},on:{"click":function($event){$event.preventDefault();_vm.goToLocationReceipt(scope.row)}}},[_c('i',{staticClass:"ti-angle-right"})])])]}}])})],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ncV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KdsSectionForm_vue__ = __webpack_require__("R2Bc");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'KdsSectionForm', __WEBPACK_IMPORTED_MODULE_7__KdsSectionForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      userLabel: {},
      modelValidations: {
        name: {
          required: true,
          min: 15
        },
        color: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.userLabel = model;
    }
  }
});

/***/ }),

/***/ "nddP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nhsC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "niY4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreordersItems_vue__ = __webpack_require__("EoWJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f9d812_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreordersItems_vue__ = __webpack_require__("XFTB");
function injectStyle (ssrContext) {
  __webpack_require__("0dTk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreordersItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f9d812_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreordersItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nl7c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricelistFieldsForm_vue__ = __webpack_require__("/nKj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81e61622_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricelistFieldsForm_vue__ = __webpack_require__("6ulu");
function injectStyle (ssrContext) {
  __webpack_require__("0Yz/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81e61622"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricelistFieldsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81e61622_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricelistFieldsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nlx2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isWalletReportActive },on:{"click":_vm.openWalletReport}},[_vm._v(_vm._s(_vm.$t('dispath.walletReport')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isActiveProgramActive },on:{"click":_vm.openActiveProgram}},[_vm._v(_vm._s(_vm.$t('dispath.programReport')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isActiveActivityActive },on:{"click":_vm.openActivityProgram}},[_vm._v(_vm._s(_vm.$t('dispath.activityReport')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isMapReportActive },on:{"click":_vm.openMapReport}},[_vm._v(_vm._s(_vm.$t('dispath.mapReport')))])])])])]),_vm._v(" "),(_vm.isWalletReportActive)?_c('div',[_c('div',{staticClass:"filter row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left mar-rt-10"},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dispath.selectDriver')))]),_vm._v(" "),_c('v-select',{staticStyle:{"display":"inline-block","max-width":"600px"},attrs:{"multiple":"","options":_vm.drivers,"label":"name"},model:{value:(_vm.selectedDriversWallet),callback:function ($$v) {_vm.selectedDriversWallet=$$v},expression:"selectedDriversWallet"}})],1),_vm._v(" "),_c('div',{staticClass:"datetime-picker pull-left"},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select From Date & Time","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions},model:{value:(_vm.fromDateTimeWallet),callback:function ($$v) {_vm.fromDateTimeWallet=$$v},expression:"fromDateTimeWallet"}}),_vm._v("\n                    to\n                    "),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select To Date & Time","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions},model:{value:(_vm.toDateTimeWallet),callback:function ($$v) {_vm.toDateTimeWallet=$$v},expression:"toDateTimeWallet"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.sendEncashmentReport}},[_c('i',{staticClass:"ti-search"})])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.walletData}},[_c('el-table-column',{attrs:{"prop":"driverId","label":_vm.$t('dispath.driverID')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"driverName","label":_vm.$t('dispath.driverName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":_vm.$t('dispath.value')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('dispath.from')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.adminName && scope.row.adminName !== 'N/A')?_c('span',[_vm._v(_vm._s(scope.row.adminName))]):_c('span',[_vm._v(_vm._s(scope.row.orderId || 'N/A'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdAt","label":"Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(_vm.formatDate(scope.row.createdAt))+"\n                        ")]}}])})],1)],1)])])]):_vm._e(),_vm._v(" "),(_vm.isActiveProgramActive)?_c('div',[_c('div',{staticClass:"filter row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left mar-rt-10"},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dispath.selectDriver')))]),_vm._v(" "),_c('v-select',{staticStyle:{"display":"inline-block","max-width":"600px"},attrs:{"multiple":"","options":_vm.drivers,"label":"name"},model:{value:(_vm.selectedDriversProgram),callback:function ($$v) {_vm.selectedDriversProgram=$$v},expression:"selectedDriversProgram"}})],1),_vm._v(" "),_c('div',{staticClass:"datetime-picker pull-left"},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select From Date & Time","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions},model:{value:(_vm.fromDateTimeProgram),callback:function ($$v) {_vm.fromDateTimeProgram=$$v},expression:"fromDateTimeProgram"}}),_vm._v("\n                    to\n                    "),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select To Date & Time","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions},model:{value:(_vm.toDateTimeProgram),callback:function ($$v) {_vm.toDateTimeProgram=$$v},expression:"toDateTimeProgram"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.sendProgramReport}},[_c('i',{staticClass:"ti-search"})])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.programData}},[_c('el-table-column',{attrs:{"prop":"driver_id","label":_vm.$t('dispath.driverID')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('dispath.driverName')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                "+_vm._s(scope.row.driver.firstname)+" "+_vm._s(scope.row.driver.lastname)+"\n                            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Status"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status)?_c('span',[_vm._v("START")]):_c('span',[_vm._v("STOP")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                              "+_vm._s(_vm.formatDate(scope.row.created_at))+"\n                          ")]}}])})],1)],1)])])]):_vm._e(),_vm._v(" "),(_vm.isActiveActivityActive)?_c('div',[_c('div',{staticClass:"filter row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left mar-rt-10"},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dispath.selectDriver')))]),_vm._v(" "),_c('v-select',{staticStyle:{"display":"inline-block","max-width":"600px"},attrs:{"multiple":"","options":_vm.drivers,"label":"name"},model:{value:(_vm.selectedDriversActivity),callback:function ($$v) {_vm.selectedDriversActivity=$$v},expression:"selectedDriversActivity"}})],1),_vm._v(" "),_c('div',{staticClass:"datetime-picker pull-left"},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select From Date & Time","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions},model:{value:(_vm.fromDateTimeActivity),callback:function ($$v) {_vm.fromDateTimeActivity=$$v},expression:"fromDateTimeActivity"}}),_vm._v("\n                    to\n                    "),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select To Date & Time","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions},model:{value:(_vm.toDateTimeActivity),callback:function ($$v) {_vm.toDateTimeActivity=$$v},expression:"toDateTimeActivity"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.sendActivityReport}},[_c('i',{staticClass:"ti-search"})])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{staticClass:"activityData",attrs:{"data":_vm.activityData}},[_c('el-table-column',{attrs:{"label":_vm.$t('dispath.driverID')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                              "+_vm._s(scope.row.driver.id)+"\n                          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('dispath.driverName')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                "+_vm._s(scope.row.driver.firstname)+" "+_vm._s(scope.row.driver.lastname)+"\n                            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_minutes_active","label":_vm.$t('dispath.totalActive')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"white-space":"nowrap"}},[_vm._v("\n                              "+_vm._s(scope.row.total_minutes_active)+" mins\n                              "),_c('span',{staticStyle:{"margin":"0 10px"}},[_vm._v("|")]),_vm._v("\n                              "+_vm._s(_vm.convertMinutesToHours(scope.row.total_minutes_active))+" hours\n                              "),_c('span',{staticStyle:{"margin":"0 10px"}},[_vm._v("|")]),_vm._v("\n                              "+_vm._s(_vm.convertMinutesToDays(scope.row.total_minutes_active))+" days\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_minutes_inactive","label":_vm.$t('dispath.totalInactive')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"white-space":"nowrap"}},[_vm._v("\n                              "+_vm._s(scope.row.total_minutes_inactive)+" mins\n                              "),_c('span',{staticStyle:{"margin":"0 10px"}},[_vm._v("|")]),_vm._v("\n                              "+_vm._s(_vm.convertMinutesToHours(scope.row.total_minutes_inactive))+" hours\n                              "),_c('span',{staticStyle:{"margin":"0 10px"}},[_vm._v("|")]),_vm._v("\n                              "+_vm._s(_vm.convertMinutesToDays(scope.row.total_minutes_inactive))+" days\n                            ")])]}}])})],1)],1)])])]):_vm._e(),_vm._v(" "),(_vm.isMapReportActive)?_c('div',[_c('div',{staticClass:"filter row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left mar-rt-10"},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dispath.selectDriver')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDriversMap),expression:"selectedDriversMap"}],staticClass:"form-control inline-auto white",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedDriversMap=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.drivers),function(driver){return _c('option',{key:driver.id,domProps:{"value":driver}},[_vm._v("\n                      "+_vm._s(driver.name)+"\n                    ")])}))]),_vm._v(" "),_c('div',{staticClass:"datetime-picker pull-left"},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select From Date & Time","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions},model:{value:(_vm.fromDateTimeMap),callback:function ($$v) {_vm.fromDateTimeMap=$$v},expression:"fromDateTimeMap"}}),_vm._v("\n                  to\n                  "),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select To Date & Time","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions},model:{value:(_vm.toDateTimeMap),callback:function ($$v) {_vm.toDateTimeMap=$$v},expression:"toDateTimeMap"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.sendMapReport}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"pull-right legend",on:{"click":_vm.showLegend}},[_c('div',{staticClass:"legends"},[_vm._v("\n                  "+_vm._s(_vm.$t('dispath.legend'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"mapsDispatch"},[[_vm._m(0)]],2)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card-map"},[_c('div',{staticClass:"full-screen-map",attrs:{"id":"map"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "npOj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nrBd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nrcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInitialStockForm_vue__ = __webpack_require__("Bm93");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_767c579a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInitialStockForm_vue__ = __webpack_require__("OcNi");
function injectStyle (ssrContext) {
  __webpack_require__("BRie")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-767c579a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementInitialStockForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_767c579a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementInitialStockForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nsy5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);







var _components;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), _components),
  created: function created() {
    this.verifyUserLocations();
  },
  data: function data() {
    return {
      loading: false,
      loadingProducts: false,
      filters: {
        location: '',
        product: ''
      },
      locations: [],
      productOptions: [],
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {},
      totalMovements: null,
      movementsTableData: []
    };
  },

  computed: {
    canSearch: function canSearch() {
      return !!this.filters.location && !!this.filters.product;
    }
  },
  methods: {
    typeLabel: function typeLabel(type) {
      if (parseInt(type) === 1) return this.$t('reports.stockMovementManualAdjustment');
      if (parseInt(type) === 2) return this.$t('reports.stockMovementOrderPlaced');
      return type;
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        if (allowedLocations.length > 0) {
          this.locations = this.locations.filter(function (el) {
            return allowedLocations.includes(el.id);
          });
        }
      }

      if (this.locations.length) {
        this.filters.location = this.locations[0].id;
        this.searchProducts('');
      }
    },
    onLocationChange: function onLocationChange() {
      this.filters.product = '';
      this.productOptions = [];
      this.movementsTableData = [];
      this.totalMovements = null;
      if (this.filters.location) {
        this.searchProducts('');
      }
    },
    onProductChange: function onProductChange() {
      this.movementsTableData = [];
      this.totalMovements = null;
      if (this.canSearch) {
        this.getData(null);
      }
    },
    searchProducts: function searchProducts(search) {
      var _this = this;

      if (!this.filters.location) {
        return;
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_id: this.filters.location,
        search: search,
        perPage: 50
      };

      this.loadingProducts = true;
      this.apiRequest('/product-stocks/products-search', 'GET', data, function (response) {
        if (response.status === true) {
          _this.productOptions = response.data;
        }
        _this.loadingProducts = false;
      });
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getData(query);
      if (query.type === 'size') this.getData(query);
    },
    buildParams: function buildParams() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_id: this.filters.location,
        product_id: this.filters.product
      };
    },
    getData: function getData(query) {
      var _this2 = this;

      if (!this.canSearch) {
        return;
      }

      var data = this.buildParams();

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      this.apiRequest('/reports/stock-movements?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status === true) {
          _this2.movementsTableData = response.data.data;
          _this2.totalMovements = response.data.total;
        }
        _this2.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    exportData: function exportData() {
      var _this3 = this;

      if (!this.canSearch) {
        return;
      }

      var data = this.buildParams();

      this.loading = true;
      this.apiRequest('/reports/stock-movements-export', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        }
        _this3.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "ntqj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isGeneral },on:{"click":_vm.openGeneral}},[_vm._v(_vm._s(_vm.$t('dispath.general')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isUsers },on:{"click":_vm.openUsers}},[_vm._v(_vm._s(_vm.$t('dispath.users')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isDispatchers },on:{"click":_vm.openDispatchers}},[_vm._v(_vm._s(_vm.$t('dispath.dispatchers')))])])])])]),_vm._v(" "),(_vm.isGeneral)?_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"auto-dispatch"},[_c('div',{staticClass:"form-group mar-bt-0",staticStyle:{"display":"flex"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.use_auto_dispatch')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success"},model:{value:(_vm.autoDispatch),callback:function ($$v) {_vm.autoDispatch=$$v},expression:"autoDispatch"}})],1),_vm._v(" "),(_vm.autoDispatch)?_c('div',{staticClass:"info-text"},[_vm._v("\n                            "+_vm._s(_vm.$t('settingCompany.autoModeText'))+"\n                          ")]):_c('div',{staticClass:"info-text"},[_vm._v("\n                            "+_vm._s(_vm.$t('settingCompany.manualModeText'))+"\n                          ")])]),_vm._v(" "),(_vm.autoDispatch)?_c('div',{staticClass:"auto-dispatch-automated"},[_c('div',{staticClass:"form-group mar-to-15 mar-bt-0",staticStyle:{"display":"flex"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.autoGroupingByZone')))]),_vm._v(" "),_c('p-switch',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success"},model:{value:(_vm.autoGroupingByZone),callback:function ($$v) {_vm.autoGroupingByZone=$$v},expression:"autoGroupingByZone"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-bt-0",staticStyle:{"display":"flex"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.newOrdersProcessing')))]),_vm._v(" "),_c('p-switch',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success"},model:{value:(_vm.newOrdersProcessing),callback:function ($$v) {_vm.newOrdersProcessing=$$v},expression:"newOrdersProcessing"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-bt-0",staticStyle:{"display":"flex"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.preparedStatus')))]),_vm._v(" "),_c('p-switch',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success"},model:{value:(_vm.preparedStatus),callback:function ($$v) {_vm.preparedStatus=$$v},expression:"preparedStatus"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15",staticStyle:{"display":"flex"}},[_c('label',[_vm._v(_vm._s(_vm.$t('dispath.walletSettings')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success"},model:{value:(_vm.walletSettings),callback:function ($$v) {_vm.walletSettings=$$v},expression:"walletSettings"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15",staticStyle:{"display":"flex"}},[_c('label',[_vm._v(_vm._s(_vm.$t('dispath.disableUndeliveredOrder')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success"},model:{value:(_vm.disableUndeliveredOrder),callback:function ($$v) {_vm.disableUndeliveredOrder=$$v},expression:"disableUndeliveredOrder"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","margin-bottom":"0px"}},[_c('label',[_c('a',{attrs:{"href":"https://drive.google.com/drive/u/2/folders/1zCCGg2I_lsFfkqH4JPFT2A5pB9w2CaUi","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('dispath.downloadApp')))])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.isUsers)?_c('div',[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":_vm.goToAdd}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                            "+_vm._s(_vm.$t('general.add'))+"\n                        ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"userList",staticStyle:{"width":"100%"},attrs:{"data":_vm.filteredTableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":150,"prop":"role","label":_vm.$t('settingUsers.role')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                            "+_vm._s(_vm.$t('settingUsers.' + props.row.role))+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":145},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                            ")])]}}])})],2)],1)])]):_vm._e(),_vm._v(" "),(_vm.isDispatchers)?_c('div',[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.DISPATCHER')},on:{"click":_vm.goToAddDispatcher}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                            "+_vm._s(_vm.$t('general.add'))+"\n                        ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"dispatcherList",staticStyle:{"width":"100%"},attrs:{"data":_vm.filteredDispatchersData,"search-def":{},"pagination-def":{},"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:'d-' + column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":150,"prop":"role","label":_vm.$t('settingUsers.role')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                            "+_vm._s(_vm.$t('settingUsers.' + props.row.role))+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":145},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                            ")])]}}])})],2)],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nvsd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();_vm.detail ? _vm.closeDetail() : _vm.goBack()}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])])]),_vm._v(" "),_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.detail),expression:"!detail"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h4',{staticClass:"msubs-title"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.title')))]),_vm._v(" "),_c('div',{staticClass:"msubs-filters"},[_c('div',{staticClass:"msubs-filter"},[_c('label',{staticClass:"msubs-label"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.offer')))]),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":_vm.$t('menuSubscribers.allOffers')},on:{"change":_vm.reload},model:{value:(_vm.filters.menu_subscription_id),callback:function ($$v) {_vm.$set(_vm.filters, "menu_subscription_id", $$v)},expression:"filters.menu_subscription_id"}},_vm._l((_vm.offers),function(offer){return _c('el-option',{key:offer.id,attrs:{"label":offer.name,"value":offer.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"msubs-filter msubs-filter--search"},[_c('label',{staticClass:"msubs-label"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.customer')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.search),expression:"filters.search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('menuSubscribers.searchPlaceholder')},domProps:{"value":(_vm.filters.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "search", $event.target.value)},_vm.onSearchInput]}})])]),_vm._v(" "),_c('div',{staticClass:"msubs-chips"},_vm._l((_vm.chips),function(chip){return _c('a',{key:chip,staticClass:"msubs-chip",class:['msubs-chip--' + chip, { 'is-active': _vm.filters.status === chip }],on:{"click":function($event){_vm.setStatus(chip)}}},[_vm._v("\n            "+_vm._s(_vm.$t('menuSubscribers.status.' + chip))+" "),_c('span',{staticClass:"msubs-chip__count"},[_vm._v(_vm._s(_vm.counts[chip] || 0))])])})),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"msubs-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.items,"empty-text":_vm.$t('menuSubscribers.empty')},on:{"row-click":_vm.openDetail}},[_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.customer'),"min-width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_vm._v(_vm._s(props.row.customer.name || ('#' + props.row.customer.id)))]),_vm._v(" "),_c('div',{staticClass:"msubs-muted"},[_vm._v(_vm._s(props.row.customer.phone)),(props.row.customer.email)?_c('span',[_vm._v(" · "+_vm._s(props.row.customer.email))]):_vm._e()])]}}])}),_vm._v(" "),(!_vm.filters.menu_subscription_id)?_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.offer'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.menu_subscription.name))]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.period'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatDate(props.row.start_date))+" - "+_vm._s(_vm.formatDate(props.row.end_date))+"\n              "),_c('div',{staticClass:"msubs-muted"},[_vm._v(_vm._s(props.row.delivery_from)+"-"+_vm._s(props.row.delivery_to)+" · "+_vm._s(_vm.$t('menuSubscribers.portions', { count: props.row.quantity })))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.deliveries'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{attrs:{"title":_vm.$t('menuSubscribers.deliveriesHint')}},[_c('strong',[_vm._v(_vm._s(props.row.deliveries.delivered))]),_vm._v(" / "+_vm._s(props.row.deliveries.ordered)+" / "+_vm._s(props.row.deliveries.total)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"msubs-muted"},[(props.row.deliveries.scheduled)?_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscribers.scheduledCount', { count: props.row.deliveries.scheduled })))]):_vm._e(),_vm._v(" "),(props.row.deliveries.cancelled)?_c('span',[_vm._v(" · "+_vm._s(_vm.$t('menuSubscribers.cancelledCount', { count: props.row.deliveries.cancelled })))]):_vm._e(),_vm._v(" "),(props.row.deliveries.errors)?_c('span',{staticClass:"text-danger"},[_vm._v(" · "+_vm._s(_vm.$t('menuSubscribers.errorsCount', { count: props.row.deliveries.errors })))]):_vm._e()])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.money'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.total)+" "+_vm._s(_vm.currency)+"\n              "),_c('div',{staticClass:"msubs-muted"},[_vm._v("\n                "+_vm._s(_vm.$t('menuSubscribers.paid'))+": "+_vm._s(props.row.total_paid)+"\n                "),(parseFloat(props.row.refunded_amount) > 0)?_c('span',{staticClass:"text-danger"},[_vm._v(" · "+_vm._s(_vm.$t('menuSubscribers.refunded'))+": "+_vm._s(props.row.refunded_amount))]):_vm._e()])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.statusLabel'),"min-width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"msubs-state",class:'msubs-state--' + props.row.status},[_vm._v(_vm._s(_vm.$t('menuSubscribers.status.' + props.row.status)))]),_vm._v(" "),_c('div',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.formatDateTime(props.row.paid_at || props.row.created_at)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"msubs-link",on:{"click":function($event){$event.stopPropagation();_vm.openDetail(props.row)}}},[_vm._v(_vm._s(_vm.$t('menuSubscribers.details'))+" "),_c('i',{staticClass:"fa fa-angle-right"})])]}}])})],1),_vm._v(" "),(_vm.pagination.last_page > 1)?_c('el-pagination',{staticClass:"msubs-pagination",attrs:{"layout":"prev, pager, next","current-page":_vm.pagination.current_page,"page-size":_vm.pagination.per_page,"total":_vm.pagination.total},on:{"current-change":_vm.changePage}}):_vm._e()],1)]),_vm._v(" "),(_vm.detail)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.detailLoading),expression:"detailLoading"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"msubs-detail__head"},[_c('div',[_c('h4',{staticClass:"msubs-title"},[_vm._v("\n              "+_vm._s(_vm.detail.customer.name || ('#' + _vm.detail.customer.id))+"\n              "),_c('span',{staticClass:"msubs-state",class:'msubs-state--' + _vm.detail.status},[_vm._v(_vm._s(_vm.$t('menuSubscribers.status.' + _vm.detail.status)))])]),_vm._v(" "),_c('div',{staticClass:"msubs-muted"},[_vm._v("\n              #"+_vm._s(_vm.detail.id)+" · "+_vm._s(_vm.detail.menu_subscription.name)+" · "+_vm._s(_vm.detail.customer.phone)),(_vm.detail.customer.email)?_c('span',[_vm._v(" · "+_vm._s(_vm.detail.customer.email))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"msubs-actions"},[(_vm.detail.can_stop)?_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){_vm.toggleBox('stop')}}},[_c('i',{staticClass:"fa fa-stop-circle"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscribers.stop'))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.detail.can_refund)?_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){_vm.toggleBox('refund')}}},[_c('i',{staticClass:"fa fa-undo"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscribers.refund'))+"\n            ")]):_vm._e()])]),_vm._v(" "),(_vm.box === 'stop')?_c('div',{staticClass:"msubs-box msubs-box--stop"},[_c('p',[_vm._v(_vm._s(_vm.$t('menuSubscribers.stopHint', { count: _vm.detail.summary.deliveries.scheduled + _vm.detail.summary.deliveries.errors })))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscribers.reason'))+"*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.stopReason),expression:"stopReason"}],staticClass:"form-control",attrs:{"rows":"2","placeholder":_vm.$t('menuSubscribers.reasonPlaceholder')},domProps:{"value":(_vm.stopReason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.stopReason=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"msubs-box__buttons"},[_c('button',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){_vm.box = null}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger btn-fill",attrs:{"disabled":_vm.busy || !_vm.stopReason.trim()},on:{"click":_vm.stop}},[_vm._v(_vm._s(_vm.$t('menuSubscribers.stopConfirm')))])])]):_vm._e(),_vm._v(" "),(_vm.box === 'refund')?_c('div',{staticClass:"msubs-box msubs-box--refund"},[_c('p',[_vm._v("\n            "+_vm._s(_vm.$t('menuSubscribers.refundHint', { max: _vm.money(_vm.detail.summary.refundable), notDelivered: _vm.money(_vm.detail.summary.value_not_delivered) }))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscribers.amount'))+"* "),_c('small',{staticClass:"text-muted"},[_vm._v("("+_vm._s(_vm.currency)+")")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.refundAmount),expression:"refundAmount"}],staticClass:"form-control",attrs:{"type":"number","min":"0.01","step":"0.01","max":_vm.detail.summary.refundable},domProps:{"value":(_vm.refundAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.refundAmount=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"msubs-link msubs-small",on:{"click":function($event){_vm.refundAmount = _vm.money(_vm.detail.summary.suggested_refund)}}},[_vm._v(_vm._s(_vm.$t('menuSubscribers.useSuggested', { amount: _vm.money(_vm.detail.summary.suggested_refund) })))])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscribers.reason'))+"*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.refundReason),expression:"refundReason"}],staticClass:"form-control",attrs:{"rows":"2","placeholder":_vm.$t('menuSubscribers.reasonPlaceholder')},domProps:{"value":(_vm.refundReason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.refundReason=$event.target.value}}})])]),_vm._v(" "),_c('small',{staticClass:"text-muted msubs-block"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.refundProcessorHint')))]),_vm._v(" "),_c('div',{staticClass:"msubs-box__buttons"},[_c('button',{staticClass:"btn btn-sm btn-default",on:{"click":function($event){_vm.box = null}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-warning btn-fill",attrs:{"disabled":_vm.busy || !_vm.validRefund},on:{"click":_vm.refund}},[_vm._v(_vm._s(_vm.$t('menuSubscribers.refundConfirm')))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"msubs-cards"},[_c('div',{staticClass:"msubs-card"},[_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscribers.total')))]),_c('strong',[_vm._v(_vm._s(_vm.detail.total)+" "+_vm._s(_vm.currency))])]),_vm._v(" "),_c('div',{staticClass:"msubs-card"},[_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscribers.paid')))]),_c('strong',[_vm._v(_vm._s(_vm.detail.total_paid)+" "+_vm._s(_vm.currency))])]),_vm._v(" "),_c('div',{staticClass:"msubs-card"},[_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscribers.refunded')))]),_c('strong',[_vm._v(_vm._s(_vm.detail.refunded_amount)+" "+_vm._s(_vm.currency))])]),_vm._v(" "),_c('div',{staticClass:"msubs-card"},[_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscribers.refundable')))]),_c('strong',[_vm._v(_vm._s(_vm.money(_vm.detail.summary.refundable))+" "+_vm._s(_vm.currency))])]),_vm._v(" "),_c('div',{staticClass:"msubs-card msubs-card--ok"},[_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscribers.valueDelivered')))]),_c('strong',[_vm._v(_vm._s(_vm.money(_vm.detail.summary.value_delivered))+" "+_vm._s(_vm.currency))])]),_vm._v(" "),_c('div',{staticClass:"msubs-card msubs-card--warn"},[_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscribers.valueNotDelivered')))]),_c('strong',[_vm._v(_vm._s(_vm.money(_vm.detail.summary.value_not_delivered))+" "+_vm._s(_vm.currency))])])]),_vm._v(" "),_c('p',{staticClass:"msubs-deliveries-line"},[_c('strong',[_vm._v(_vm._s(_vm.$t('menuSubscribers.deliveredOf', { delivered: _vm.detail.summary.deliveries.delivered, total: _vm.detail.summary.deliveries.total })))]),_vm._v("\n          · "+_vm._s(_vm.$t('menuSubscribers.orderedCount', { count: _vm.detail.summary.deliveries.ordered }))+"\n          · "+_vm._s(_vm.$t('menuSubscribers.scheduledCount', { count: _vm.detail.summary.deliveries.scheduled }))+"\n          "),(_vm.detail.summary.deliveries.cancelled)?_c('span',[_vm._v(" · "+_vm._s(_vm.$t('menuSubscribers.cancelledCount', { count: _vm.detail.summary.deliveries.cancelled })))]):_vm._e(),_vm._v(" "),(_vm.detail.summary.deliveries.errors)?_c('span',{staticClass:"text-danger"},[_vm._v(" · "+_vm._s(_vm.$t('menuSubscribers.errorsCount', { count: _vm.detail.summary.deliveries.errors })))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row msubs-info"},[_c('div',{staticClass:"col-md-6"},[_c('div',[_c('span',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.period'))+":")]),_vm._v(" "+_vm._s(_vm.formatDate(_vm.detail.start_date))+" - "+_vm._s(_vm.formatDate(_vm.detail.end_date)))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.interval'))+":")]),_vm._v(" "+_vm._s(_vm.detail.delivery_from)+"-"+_vm._s(_vm.detail.delivery_to))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.portionsLabel'))+":")]),_vm._v(" "+_vm._s(_vm.detail.quantity)+" · "+_vm._s(_vm.detail.price_per_day)+" "+_vm._s(_vm.currency)+"/"+_vm._s(_vm.$t('menuSubscribers.day'))+" · "+_vm._s(_vm.$t('menuSubscribers.deliveryFee'))+" "+_vm._s(_vm.detail.delivery_fee)+" "+_vm._s(_vm.currency))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.source'))+":")]),_vm._v(" "+_vm._s(_vm.detail.source === 'website' ? 'Website' : 'App'))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',[_c('span',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.address'))+":")]),_vm._v(" "+_vm._s(_vm.addressText(_vm.detail.address)))]),_vm._v(" "),(_vm.detail.zone_name)?_c('div',[_c('span',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.zone'))+":")]),_vm._v(" "+_vm._s(_vm.detail.zone_name))]):_vm._e(),_vm._v(" "),_c('div',[_c('span',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.phone'))+":")]),_vm._v(" "+_vm._s(_vm.detail.contact_phone))]),_vm._v(" "),(_vm.detail.comments)?_c('div',[_c('span',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.comments'))+":")]),_vm._v(" "+_vm._s(_vm.detail.comments))]):_vm._e(),_vm._v(" "),(_vm.detail.stopped_at)?_c('div',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.$t('menuSubscribers.stoppedInfo', { date: _vm.formatDateTime(_vm.detail.stopped_at), user: _vm.detail.stopped_by || '-' }))+": "+_vm._s(_vm.detail.stop_reason)+"\n            ")]):_vm._e()])]),_vm._v(" "),_c('h5',{staticClass:"msubs-section"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.deliveries')))]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detail.delivery_list,"empty-text":_vm.$t('menuSubscribers.noDeliveries')}},[_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.date'),"min-width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(_vm.formatDate(props.row.date)))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.menu'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.menu_name || '-'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.deliveryStatus'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"msubs-dstate",class:'msubs-dstate--' + props.row.status},[_vm._v(_vm._s(_vm.$t('menuSubscribers.deliveryStatuses.' + props.row.status)))]),_vm._v(" "),(props.row.status === 'scheduled')?_c('div',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.orderAt', { date: _vm.formatDateTime(props.row.create_order_at) })))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.order'),"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.order)?[_vm._v("\n                #"+_vm._s(props.row.order.number || '-')+" "),_c('span',{staticClass:"msubs-muted"},[_vm._v("(ID "+_vm._s(props.row.order.id)+")")]),_vm._v(" "),_c('div',[_c('span',{staticClass:"msubs-ostate"},[_vm._v(_vm._s(props.row.order.status))])])]:_c('span',{staticClass:"msubs-muted"},[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.value'),"min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.value)+" "+_vm._s(_vm.currency))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('menuSubscribers.note'),"min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('small',{class:{ 'text-danger': props.row.status === 'error' }},[_vm._v(_vm._s(props.row.error_message))])]}}])})],1),_vm._v(" "),_c('h5',{staticClass:"msubs-section"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.payments')))]),_vm._v(" "),(!_vm.detail.payments.length)?_c('p',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.noPayments')))]):_vm._e(),_vm._v(" "),_vm._l((_vm.detail.payments),function(payment){return _c('div',{key:'pay' + payment.id,staticClass:"msubs-payment"},[_c('div',{staticClass:"msubs-payment__row"},[_c('strong',[_vm._v(_vm._s(payment.reference))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(payment.amount)+" "+_vm._s(_vm.currency))]),_vm._v(" "),_c('span',{staticClass:"msubs-pstate",class:'msubs-pstate--' + payment.status},[_vm._v(_vm._s(_vm.$t('menuSubscribers.paymentStatuses.' + payment.status)))]),_vm._v(" "),_c('span',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.formatDateTime(payment.paid_at || payment.created_at)))]),_vm._v(" "),(payment.gateway_transaction_id)?_c('span',{staticClass:"msubs-muted"},[_vm._v("ep_id "+_vm._s(payment.gateway_transaction_id))]):_vm._e(),_vm._v(" "),(payment.refunded > 0)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.refunded'))+": "+_vm._s(_vm.money(payment.refunded)))]):_vm._e()]),_vm._v(" "),(payment.error_message)?_c('div',{staticClass:"msubs-muted msubs-small"},[_vm._v(_vm._s(payment.error_message))]):_vm._e(),_vm._v(" "),_vm._l((payment.refunds),function(refund){return _c('div',{key:'ref' + refund.id,staticClass:"msubs-refund",class:'msubs-refund--' + refund.status},[_c('i',{staticClass:"fa fa-undo"}),_vm._v("\n            "+_vm._s(refund.amount)+" "+_vm._s(_vm.currency)+"\n            · "+_vm._s(_vm.$t('menuSubscribers.refundStatuses.' + refund.status))),(refund.type)?_c('span',[_vm._v(" ("+_vm._s(refund.type)+")")]):_vm._e(),_vm._v("\n            · "+_vm._s(_vm.formatDateTime(refund.created_at))),(refund.user)?_c('span',[_vm._v(" · "+_vm._s(refund.user))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"msubs-small"},[_vm._v(_vm._s(refund.reason)),(refund.error_message)?_c('span',{staticClass:"text-danger"},[_vm._v(" — "+_vm._s(refund.error_message))]):_vm._e()])])})],2)}),_vm._v(" "),_c('h5',{staticClass:"msubs-section"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.history')))]),_vm._v(" "),(!_vm.detail.events.length)?_c('p',{staticClass:"msubs-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscribers.noHistory')))]):_vm._e(),_vm._v(" "),_vm._l((_vm.detail.events),function(event,index){return _c('div',{key:'ev' + index,staticClass:"msubs-event"},[_c('strong',[_vm._v(_vm._s(_vm.$t('menuSubscribers.events.' + event.type)))]),_vm._v(" "),(event.type === 'refund' && event.data)?_c('span',[_vm._v(" "+_vm._s(_vm.money(event.data.amount))+" "+_vm._s(_vm.currency))]):_vm._e(),_vm._v(" "),(event.type === 'stop' && event.data)?_c('span',[_vm._v(" · "+_vm._s(_vm.$t('menuSubscribers.cancelledCount', { count: event.data.cancelled_deliveries })))]):_vm._e(),_vm._v("\n          · "+_vm._s(_vm.formatDateTime(event.created_at))),(event.user)?_c('span',[_vm._v(" · "+_vm._s(event.user))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"msubs-small"},[_vm._v(_vm._s(event.comment))])])})],2)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nzNW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-lg-12 "},[_c('div',{staticClass:"search-bar"},[_c('div',{staticClass:"col-sm-12 no-padding"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('reports.search')},on:{"input":function($event){_vm.onInput()}},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn add ",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('marketingCoupons.single'),"to":{ path: '/marketing/coupons/add'}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"coupons-table width-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDef,"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"min-width":45,"prop":"name","label":_vm.$t('marketingCoupons.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":35,"prop":"coupon_code","label":_vm.$t('marketingCoupons.code')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.is_subscription)?_c('span',{staticClass:"coupon-sub-pill",attrs:{"title":_vm.subscriptionTitle(props.row)}},[_c('i',{staticClass:"fa fa-ticket"}),_vm._v("\n                "+_vm._s(_vm.$t('marketingCoupons.subscriptionBadge'))+"\n                "),(props.row.subscription_levels && props.row.subscription_levels.length)?_c('span',{staticClass:"coupon-sub-pill__count"},[_vm._v(_vm._s(props.row.subscription_levels.length))]):_vm._e()]):(props.row.is_automation)?[_c('span',{staticClass:"coupon-auto-pill",attrs:{"title":_vm.automationTitle(props.row)}},[_c('i',{staticClass:"fa fa-magic"}),_vm._v("\n                  "+_vm._s(_vm.$t('marketingCoupons.automationBadge'))+"\n                  "),(props.row.automation_campaigns && props.row.automation_campaigns.length)?_c('span',{staticClass:"coupon-auto-pill__count"},[_vm._v(_vm._s(props.row.automation_campaigns.length))]):_vm._e()]),_vm._v(" "),(props.row.coupon_code)?_c('span',{staticClass:"coupon-auto-code"},[_vm._v(_vm._s(props.row.coupon_code))]):_vm._e()]:(props.row.coupon_has_multiple_codes)?[_vm._v("\n                "+_vm._s(_vm.$t('marketingCoupons.multipleCodes'))+" ("+_vm._s(props.row.coupons_codes_count || 0)+")\n              ")]:[_vm._v(_vm._s(props.row.coupon_code))]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":30,"label":_vm.$t('marketingCoupons.discount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.type === 'FREE_PRODUCT')?[_vm._v(_vm._s(_vm.$t('marketingCoupons.freeProduct')))]:[_vm._v(_vm._s(props.row.discount)+" "+_vm._s(props.row.type === 'FIXED' ? _vm.currency : '%'))]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":45,"label":_vm.$t('marketingCoupons.validFromTo')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.datetime_validfrom && props.row.datetime_validto)?[_vm._v("\n                "+_vm._s(_vm.formatDate(props.row.datetime_validfrom))+" - "+_vm._s(_vm.formatDate(props.row.datetime_validto))+"\n              ")]:[_vm._v("-")]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":25,"label":_vm.$t('marketingCoupons.daysLeft')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(props.row.datetime_validto ? _vm.getDaysLeft(props.row.datetime_validto) : '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":45,"label":_vm.$t('marketingCoupons.pushCampaigns')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.push_campaigns && props.row.push_campaigns.length)?_vm._l((props.row.push_campaigns),function(campaign){return _c('span',{key:campaign.id,staticClass:"coupon-badge coupon-badge--campaign"},[_vm._v(_vm._s(campaign.name))])}):_c('span',{staticClass:"coupon-badge coupon-badge--empty"},[_vm._v(_vm._s(_vm.$t('marketingCoupons.notAssigned')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":30,"label":_vm.$t('marketingCoupons.sources')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.orderSourcesText(props.row.order_source_ids))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":25,"label":_vm.$t('marketingCoupons.status'),"prop":"active"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(props.row)}},model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":90,"prop":"actions","class-name":"centered-cell","align":"center","header-align":"center","label":_vm.$t('marketingCampaigns.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-icon-small btn-danger",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.stopPropagation();_vm.handleDelete(props.row)}}},[_c('i',{staticClass:"fa fa-trash-o"})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":160,"class-name":"centered-cell","align":"center","header-align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")])]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nzlA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o/RM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      tableData: []
    };
  },

  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    console.log('Mounted ManagementBonFiscalView.vue');
    var id = this.route && this.route.params && this.route.params.id;
    if (id) {
      this.fetchBonFiscalById(id);
    }
  },

  computed: {
    summary: function summary() {
      var rows = this.tableData || [];

      var totalQty = rows.reduce(function (s, r) {
        return s + (Number(r.productQty) || 0);
      }, 0);

      var totalWithoutDiscount = rows.reduce(function (s, r) {
        return s + Number(r.productOriginalPrice) * Number(r.productQty || 1);
      }, 0);

      var totalWithDiscount = rows.reduce(function (s, r) {
        return s + Number(r.productPrice) * Number(r.productQty || 1);
      }, 0);

      var totalNet = rows.reduce(function (s, r) {
        return s + Number(r.productNetPrice) * Number(r.productQty || 1);
      }, 0);

      var totalVat = rows.reduce(function (s, r) {
        return s + Number(r.productVatValue) * Number(r.productQty || 1);
      }, 0);

      var totalDiscount = rows.reduce(function (s, r) {
        return s + (Number(r.productDiscount) || 0);
      }, 0);

      return {
        totalQty: totalQty,
        totalWithoutDiscount: totalWithoutDiscount,
        totalWithDiscount: totalWithDiscount,
        totalNet: totalNet,
        totalVat: totalVat,
        totalDiscount: totalDiscount
      };
    }
  },
  methods: {
    goBack: function goBack() {
      this.$bus.$emit('close-modal');
    },
    goToOrder: function goToOrder(row) {
      if (row && row.externalOrderId) {
        this.$router.push('/orders/view/' + row.externalOrderId);
      }
    },
    formatDate: function formatDate(value) {
      if (!value) return '';
      var date = new Date(value);
      return isNaN(date.getTime()) ? '' : date.toLocaleDateString();
    },
    formatTipVanzare: function formatTipVanzare(value) {
      if (!value || typeof value !== 'string') return '';

      return value.replace(/_/g, ' ').toLowerCase().split(' ').map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join(' ');
    },
    fetchBonFiscalById: function fetchBonFiscalById(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, response, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$bus.$emit('set-loading', true);
                _context.prev = 1;
                params = new URLSearchParams({
                  externalCompanyId: _this.companyID,
                  id: id
                });
                _context.next = 5;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/bons_fiscale/?' + params.toString(), { method: 'GET' });

              case 5:
                response = _context.sent;
                _context.next = 8;
                return response.json();

              case 8:
                result = _context.sent;

                _this.tableData = [];

                if (Array.isArray(result.bons_fiscale)) {
                  result.bons_fiscale.forEach(function (bon) {
                    var rawDataParsed = {};
                    try {
                      if (bon.raw_data && typeof bon.raw_data === 'string') {
                        rawDataParsed = JSON.parse(atob(bon.raw_data));
                      }
                    } catch (e) {
                      console.warn('❗ Eroare la decodare raw_data', e);
                    }

                    (bon.products || []).forEach(function (prod) {
                      var productId = prod.externalProdId || prod.externalCovId || prod.externalCovSgrId || null;

                      var grossPrice = Number(prod.price - (prod.pondered_discount_amount || 0) || 0);
                      var vatRate = Number(prod.vat || 0);
                      var qty = Number(prod.qty || 1);

                      var discount = Number((prod.product_discount || 0) + (prod.pondered_discount_amount || 0));

                      var originalPrice = discount ? grossPrice + discount : grossPrice;

                      var netPrice = vatRate ? grossPrice / (1 + vatRate / 100) : grossPrice;

                      var vatValue = grossPrice - netPrice;

                      var discountNet = vatRate ? discount / (1 + vatRate / 100) : discount;

                      var discountVat = discount - discountNet;

                      _this.tableData.push({
                        _id: bon._id,
                        created_at: bon.created_at,
                        created_timestamp: bon.created_timestamp,

                        date: bon.date,
                        externalCompanyId: bon.externalCompanyId,
                        externalLocationId: bon.externalLocationId,
                        externalOrderId: bon.externalOrderId,
                        is_fiscal: bon.is_fiscal,
                        nr: bon.nr,
                        type: bon.type,
                        rawDataParsed: rawDataParsed,
                        source: bon.source,
                        tip_vanzare: bon.tip_vanzare,

                        productId: productId,
                        productName: prod.name,
                        productQty: qty,
                        productUm: prod.um,
                        vat: vatRate,

                        department_id: prod.department_id || null,

                        productDiscountNet: Number(discountNet.toFixed(2)),
                        productDiscountVat: Number(discountVat.toFixed(2)),

                        productPrice: Number(grossPrice.toFixed(2)),
                        productTotalPrice: Number((grossPrice * qty).toFixed(2)),

                        productVatRate: vatRate,
                        productNetPrice: Number(netPrice.toFixed(2)),
                        productVatValue: Number(vatValue.toFixed(2)),

                        productDiscount: Number(discount.toFixed(2)),
                        productOriginalPrice: Number(originalPrice.toFixed(2))
                      });
                    });
                  });
                }
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](1);

                console.error('❌ Eroare la fetch bon fiscal by ID:', _context.t0);

              case 16:
                _context.prev = 16;

                _this.$bus.$emit('set-loading', false);
                return _context.finish(16);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 13, 16, 19]]);
      }))();
    }
  }
});

/***/ }),

/***/ "o2vL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4UX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gestiune-order-errors"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"mar-b-15"},[_c('h5',[_vm._v(_vm._s(_vm.$t('gestiune.orderErrors')))]),_vm._v(" "),_c('div',{staticClass:"info-text"},[_vm._v("\n          Comenzile care nu au putut fi trimise în gestiune. Trimiterea automată se reîncearcă de 3 ori;\n          după a 3-a eroare comanda poate fi retrimisă doar de aici. Click pe o comandă pentru a vedea ce s-a trimis și ce a răspuns gestiunea.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"filters-row"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.location_id),expression:"filters.location_id"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.search]}},[_c('option',{attrs:{"value":""}},[_vm._v("Toate locațiile")]),_vm._v(" "),_vm._l((_vm.locations),function(location){return _c('option',{key:location.true_id,domProps:{"value":location.true_id}},[_vm._v("\n            "+_vm._s(location.name)+"\n          ")])})],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.search),expression:"filters.search"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"ID comandă"},domProps:{"value":(_vm.filters.search)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "search", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"only-final"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.only_final),expression:"filters.only_final"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.filters.only_final)?_vm._i(_vm.filters.only_final,null)>-1:(_vm.filters.only_final)},on:{"change":[function($event){var $$a=_vm.filters.only_final,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.filters, "only_final", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.filters, "only_final", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.filters, "only_final", $$c)}},_vm.search]}}),_vm._v("\n          Doar erori finale (3 încercări)\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":_vm.search}},[_vm._v("Caută")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",attrs:{"disabled":!_vm.selectedIds.length || _vm.resending},on:{"click":_vm.resend}},[_vm._v("\n          "+_vm._s(_vm.resending ? 'Se retrimite...' : 'Retrimite (' + _vm.selectedIds.length + ')')+"\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data-table"},[_c('el-table',{ref:"ordersTable",staticClass:"clickable-rows",staticStyle:{"width":"100%"},attrs:{"data":_vm.orders,"row-key":"id"},on:{"selection-change":_vm.onSelectionChange,"row-click":_vm.openLogs}},[_c('el-table-column',{attrs:{"type":"selection","width":"45"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ID comandă","prop":"id","width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Data","prop":"created_at","width":"160"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Locație","prop":"location_name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Nr. bon","prop":"receipt_nr","width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.receipt_nr || '-'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Total","prop":"total","width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Încercări","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('span',{staticClass:"badge",class:row.is_final ? 'badge-danger' : 'badge-warning'},[_vm._v("\n                "+_vm._s(row.error_level)+" / 3\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Ultima eroare","min-width":"260"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"last-error"},[_vm._v(_vm._s(row.last_error || '-'))]),_vm._v(" "),(row.last_details)?_c('small',{staticClass:"last-details"},[_vm._v(_vm._s(row.last_details))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Ultima încercare","prop":"last_attempt_at","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.last_attempt_at || '-'))]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"active-pagination width-table mar-to-15",attrs:{"total":_vm.pagination.total,"page-size":_vm.pagination.perPage,"current-page":_vm.pagination.page,"layout":"prev, pager, next, total"},on:{"current-change":_vm.handlePageChange}})],1)])]),_vm._v(" "),_c('vmodal',{attrs:{"name":"gestiuneOrderLogsModal","height":"auto","width":"950","adaptive":true,"scrollable":true}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v("Istoric trimitere în gestiune — comanda #"+_vm._s(_vm.logsOrderId))])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.logsLoading),expression:"logsLoading"}],staticClass:"modal-body logs-modal-body"},[(!_vm.logsLoading && !_vm.logs.length)?_c('p',[_vm._v("Nu există log-uri pentru această comandă.")]):_vm._e(),_vm._v(" "),_vm._l((_vm.logs),function(log){return _c('div',{key:log.id,staticClass:"log-entry",class:log.status ? 'log-success' : 'log-error'},[_c('div',{staticClass:"log-head"},[_c('span',{staticClass:"badge",class:log.status ? 'badge-success' : 'badge-danger'},[_vm._v("\n                "+_vm._s(log.status ? 'Succes' : 'Eroare')+"\n              ")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(log.created_at))]),_vm._v(" "),_c('span',[_vm._v("· "+_vm._s(log.source === 'manual' ? 'Manual' + (log.user_name ? ' (' + log.user_name + ')' : '') : 'Automat (cron)'))]),_vm._v(" "),_c('span',[_vm._v("· gestiune_order_id: "),_c('code',[_vm._v(_vm._s(log.gestiune_order_id))])])]),_vm._v(" "),(log.error)?_c('div',{staticClass:"log-error-text"},[_vm._v("\n              "+_vm._s(log.error)),(log.details)?_c('span',[_vm._v(" — "+_vm._s(log.details))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"log-json"},[_c('div',[_c('div',{staticClass:"json-label"},[_c('label',[_vm._v("Trimis")]),_vm._v(" "),_c('a',{staticClass:"copy-json",on:{"click":function($event){_vm.copyJson(log.data_to, log.id + '-to')}}},[_c('i',{class:_vm.copiedKey === log.id + '-to' ? 'ti-check' : 'ti-clipboard'}),_vm._v("\n                    "+_vm._s(_vm.copiedKey === log.id + '-to' ? 'Copiat!' : 'Copiază')+"\n                  ")])]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.pretty(log.data_to)))])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"json-label"},[_c('label',[_vm._v("Primit")]),_vm._v(" "),_c('a',{staticClass:"copy-json",on:{"click":function($event){_vm.copyJson(log.data_from, log.id + '-from')}}},[_c('i',{class:_vm.copiedKey === log.id + '-from' ? 'ti-check' : 'ti-clipboard'}),_vm._v("\n                    "+_vm._s(_vm.copiedKey === log.id + '-from' ? 'Copiat!' : 'Copiază')+"\n                  ")])]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.pretty(log.data_from)))])])])])})],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":function($event){_vm.$modal.hide('gestiuneOrderLogsModal')}}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o694":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementTabs_vue__ = __webpack_require__("vkzn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f2b1626_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementTabs_vue__ = __webpack_require__("2Iil");
function injectStyle (ssrContext) {
  __webpack_require__("ygnR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f2b1626"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f2b1626_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o7NM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"searchInput"}},[_vm._v(_vm._s(_vm.$t('gestiune.searchSuppliers')))]),_vm._v(" "),_c('el-input',{attrs:{"id":"searchInput","placeholder":"Search by distributor name","clearable":""},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.filterByProvider')))]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Filter by provider"},model:{value:(_vm.filterForm.provider),callback:function ($$v) {_vm.$set(_vm.filterForm, "provider", $$v)},expression:"filterForm.provider"}},[_c('el-option',{attrs:{"label":"Provider A","value":"providerA"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Provider B","value":"providerB"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.filterByTag')))]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Filter by tag"},model:{value:(_vm.filterForm.tag),callback:function ($$v) {_vm.$set(_vm.filterForm, "tag", $$v)},expression:"filterForm.tag"}},[_c('el-option',{attrs:{"label":"Tag A","value":"tagA"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Tag B","value":"tagB"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.filterByQuantity')))]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Enter quantity"},model:{value:(_vm.filterForm.quantity),callback:function ($$v) {_vm.$set(_vm.filterForm, "quantity", $$v)},expression:"filterForm.quantity"}},[_c('el-option',{attrs:{"label":"1","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"2","value":"2"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"","prop":"rawMaterial"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{class:scope.row.type === 'Marfă' ? 'item-marfa' : 'item-materie-prima'},[_vm._v("\n                        "+_vm._s(scope.row.type)+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('gestiune.nume')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unitPrice","label":_vm.$t('gestiune.unitPrice')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"inStock","label":((_vm.$t('gestiune.inStock')) + " / " + (_vm.$t('gestiune.necessary')))}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"inStock","label":((_vm.$t('gestiune.inStock')) + " / " + (_vm.$t('gestiune.necessary')))}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){_vm.yourAddFunction(scope.row)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                        "+_vm._s(_vm.$t('general.add'))+"\n                    ")])]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o8/5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o8kD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row raffle-campaigns-report"},[_c('div',{staticClass:"col-xl-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-start","gap":"10px","flex-wrap":"wrap"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px","align-items":"flex-end","flex":"1 1 auto"}},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.id')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('raffleCampaigns.id'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applyFilters($event)}},model:{value:(_vm.idFilter),callback:function ($$v) {_vm.idFilter=$$v},expression:"idFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"1 1 180px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.name')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('raffleCampaigns.search'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applyFilters($event)}},model:{value:(_vm.nameFilter),callback:function ($$v) {_vm.nameFilter=$$v},expression:"nameFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 140px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.active')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","size":"small","placeholder":_vm.$t('general.select')},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}},[_c('el-option',{attrs:{"label":_vm.$t('general.active'),"value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('general.inactive'),"value":0}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 160px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.type')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","size":"small","placeholder":_vm.$t('general.select')},model:{value:(_vm.typeFilter),callback:function ($$v) {_vm.typeFilter=$$v},expression:"typeFilter"}},_vm._l((_vm.typeOptions),function(option){return _c('el-option',{key:option.value,attrs:{"label":option.label,"value":option.value}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 240px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('raffleCampaigns.startEnd')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","size":"small","placeholder":_vm.$t('raffleCampaigns.startEnd')},model:{value:(_vm.dateRangeFilter),callback:function ($$v) {_vm.dateRangeFilter=$$v},expression:"dateRangeFilter"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.applyFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"data-table raffle-campaigns-report__table-wrap",staticStyle:{"margin-top":"20px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('raffleCampaigns.id'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('raffleCampaigns.name'),"min-width":"160","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('raffleCampaigns.type'),"min-width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.typeLabel(props.row.type))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('raffleCampaigns.startEnd'),"min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatDate(props.row.starts_at))+" - "+_vm._s(_vm.formatDate(props.row.ends_at))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('orders.status'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.active ? _vm.$t('general.active') : _vm.$t('general.inactive'))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('raffleCampaigns.usersJoined'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.users_joined != null ? props.row.users_joined : 0)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('raffleCampaigns.ordersCount'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.orders_count != null ? props.row.orders_count : 0)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('raffleCampaigns.ordersTotal'),"width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoney(props.row.orders_total))+" "+_vm._s(_vm.currency)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"min-width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"raffle-campaigns-report__actions"},[_c('button',{staticClass:"btn add raffle-campaigns-report__action",attrs:{"title":_vm.$t('raffleCampaigns.participants')},on:{"click":function($event){$event.stopPropagation();_vm.goToParticipants(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('raffleCampaigns.participants'))+"\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn add raffle-campaigns-report__action",attrs:{"disabled":_vm.exportingId === scope.row.id,"title":_vm.$t('raffleCampaigns.exportEntries')},on:{"click":function($event){$event.stopPropagation();_vm.exportEntries(scope.row)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('raffleCampaigns.exportEntries'))+"\n                  ")])])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"raffle-campaigns-report__pagination"},[_c('el-pagination',{attrs:{"layout":"prev, pager, next","total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"current-page":_vm.paginationDef.page},on:{"update:currentPage":function($event){_vm.$set(_vm.paginationDef, "page", $event)},"current-change":_vm.handlePageChange}})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oA4C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oCBC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationForm_vue__ = __webpack_require__("doqb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b340a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationForm_vue__ = __webpack_require__("kjIg");
function injectStyle (ssrContext) {
  __webpack_require__("bzVD")
  __webpack_require__("Qv2Q")
  __webpack_require__("l9ed")
  __webpack_require__("/mYi")
  __webpack_require__("jWkH")
  __webpack_require__("TN7w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00b340a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b340a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oCdl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CharismaReport_vue__ = __webpack_require__("dTQU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4947c904_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CharismaReport_vue__ = __webpack_require__("jjFL");
function injectStyle (ssrContext) {
  __webpack_require__("ahTF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CharismaReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4947c904_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CharismaReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oEWd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oJuI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stock_vue__ = __webpack_require__("KkB8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11fd88fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stock_vue__ = __webpack_require__("FV8V");
function injectStyle (ssrContext) {
  __webpack_require__("ZtR2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11fd88fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11fd88fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oKKX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('promos-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onOfferSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oKhd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      screenRoutes: [{ path: '/screens/kds?tabIndex=0', key: 'kds' }, { path: '/screens/kds?tabIndex=3', key: 'settings' }]
    };
  },

  methods: {
    getImageForRoute: function getImageForRoute(routeKey) {
      var images = {
        kds: 'static/img/kds.png',

        settings: 'static/img/kds-settings.png'
      };
      return images[routeKey] || 'static/img/default.jpg';
    },
    getBoxColor: function getBoxColor(index) {
      var colors = ['#3AB7CD', '#FFD93D'];
      return colors[index] || '#FFFFFF';
    }
  }
});

/***/ }),

/***/ "oLmw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oM1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Integrations_IntegrationForm_vue__ = __webpack_require__("oCBC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_WoltIntegrationForm_vue__ = __webpack_require__("aVMA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Integrations_WoltDriveIntegrationForm_vue__ = __webpack_require__("VamX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Integrations_DeliveryHeroIntegrationForm_vue__ = __webpack_require__("Odsf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__ = __webpack_require__("fff3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Integrations_GlovoLaasIntegrationForm_vue__ = __webpack_require__("jAxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Integrations_integrationLocationHelpers_js__ = __webpack_require__("fX4L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__ = __webpack_require__("Bef2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Integrations_integrationEmailHelpers_js__ = __webpack_require__("73l2");































var INTEGRATION_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()({
  glovo_laas: ['company_id', 'location_id', 'api_url', 'pos_implementation_name', 'brand_name', 'laas_client_id', 'laas_client_secret', 'auto_send_at_status', 'auto_send_time'],
  glovo: ['company_id', 'location_id', 'orders_location_id', 'api_url', 'pos_implementation_name', 'store_id', 'is_menu_location', 'is_using_pricelist', 'platform_status_polling_enabled', 'menu_top_categories'],
  bolt: ['company_id', 'location_id', 'orders_location_id', 'api_url', 'integrator_id', 'provider_id', 'secret_key', 'emails', 'active', 'user', 'password', 'menu_language', 'has_own_delivery', 'is_menu_location', 'is_using_pricelist', 'is_auto_accept', 'prep_time_buffer_in_minutes', 'schedule', 'platform_status_polling_enabled', 'menu_top_categories'],
  wolt: ['company_id', 'location_id', 'orders_location_id', 'active', 'api_url', 'api_key', 'client_id', 'client_secret', 'venue_id', 'is_menu_location', 'is_using_pricelist', 'is_auto_accept', 'schedule', 'platform_status_polling_enabled', 'menu_top_categories'],
  wolt_drive: ['company_id', 'location_id', 'active', 'api_url', 'access_token', 'merchant_id', 'venue_id', 'auto_send_at_status', 'auto_send_time', 'feedback_emails', 'webhook_id', 'order_total_handshake'],
  delivery_hero: ['company_id', 'location_id', 'active', 'api_url', 'client_id', 'key_id', 'scope', 'webhook_secret', 'auto_send_at_status', 'auto_send_time', 'feedback_emails', 'public_key'],
  nexus: ['company_id', 'location_id', 'active', 'ip', 'port', 'failover_ip', 'failover_port', 'administration_id', 'fiscal_device_id', 'product_type', 'delegated_id', 'agent_id'],
  charisma: ['company_id', 'location_id', 'location_token', 'stock_administration_id', 'site_code', 'partner_site_code', 'cash_location_id', 'tenant_id', 'currency_id', 'active', 'api_url', 'user', 'password', 'exclude_top_category_ids'],
  clock_pms: ['company_id', 'location_id', 'active', 'api_url', 'api_key', 'api_user', 'subscription_number', 'account_number', 'payment_types_map', 'charge_template_id', 'discount_revenue_group', 'eod_folio_id', 'eod_folio_company_id', 'eod_folio_date', 'exclude_top_category_ids'],
  ebriza: ['company_id', 'location_id', 'location_token', 'public_key', 'private_key', 'api_url', 'client_id', 'app_name'],
  rkeeper: ['company_id', 'location_id', 'location_token', 'user', 'password', 'token', 'url', 'table_id', 'station_id', 'right_level_id', 'payment_method_id', 'comment_modifier_id', 'taxes_id', 'delivery_ident'],
  rsystem: ['company_id', 'location_id', 'location_token', 'active', 'api_url', 'api_key', 'organization_id', 'terminal_group_id', 'import_products_revision', 'customer_type', 'payment_types', 'discount_pos_id', 'tips_pos_id'],
  ep_restaurant: ['company_id', 'location_id', 'location_token', 'send_status', 'url', 'user', 'password'],
  freya_on_premise: ['company_id', 'location_id', 'send_freya_at_status', 'api_key', 'host', 'table_code', 'user_code', 'tax_pos_id'],
  freya_cloud: ['company_id', 'location_id', 'location_token', 'host', 'api_key', 'freya_cloud_location_uid', 'username', 'password', 'sync_order_status'],
  grandchef: ['company_id', 'status', 'host', 'port', 'password', 'partner_id']
});

var WOLT_FORM_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'orders_location_id', 'active', 'api_url', 'api_key', 'client_id', 'client_secret', 'venue_id', 'is_menu_location', 'is_using_pricelist', 'is_auto_accept', 'schedule', 'platform_status_polling_enabled', 'menu_top_categories']);

var WOLT_REQUIRED_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'orders_location_id', 'api_url', 'api_key', 'client_id', 'client_secret', 'venue_id']);

var WOLT_LIST_COLUMNS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'integration_role', 'active']);

var WOLT_DRIVE_FORM_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'active', 'api_url', 'access_token', 'merchant_id', 'venue_id', 'auto_send_at_status', 'auto_send_time', 'order_total_handshake', 'feedback_emails']);

var WOLT_DRIVE_REQUIRED_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'api_url', 'access_token', 'merchant_id', 'venue_id']);

var WOLT_DRIVE_LIST_COLUMNS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['id', 'location_id', 'auto_send_at_status', 'active']);

var DELIVERY_HERO_FORM_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'active', 'api_url', 'client_id', 'key_id', 'scope', 'webhook_secret', 'auto_send_at_status', 'auto_send_time', 'feedback_emails']);

var DELIVERY_HERO_REQUIRED_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'api_url']);

var DELIVERY_HERO_CREDENTIAL_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['client_id', 'key_id', 'scope']);

var DELIVERY_HERO_LIST_COLUMNS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['id', 'location_id', 'auto_send_at_status', 'active']);

var BOLT_FORM_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'orders_location_id', 'api_url', 'integrator_id', 'provider_id', 'secret_key', 'emails', 'active', 'menu_language', 'has_own_delivery', 'is_menu_location', 'is_using_pricelist', 'is_auto_accept', 'prep_time_buffer_in_minutes', 'schedule', 'platform_status_polling_enabled', 'menu_top_categories']);

var BOLT_LIST_COLUMNS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['id', 'location_id', 'integration_role', 'active']);

var BOLT_REQUIRED_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'orders_location_id', 'api_url', 'integrator_id', 'provider_id', 'secret_key']);

var GLOVO_LAAS_FORM_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'api_url', 'pos_implementation_name', 'brand_name', 'laas_client_id', 'laas_client_secret', 'auto_send_at_status', 'auto_send_time']);

var GLOVO_LAAS_LIST_COLUMNS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['id', 'location_id', 'auto_send_at_status', 'auto_send_time']);

var GLOVO_LAAS_REQUIRED_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'api_url', 'pos_implementation_name', 'brand_name', 'laas_client_id', 'laas_client_secret']);

var GLOVO_FORM_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'orders_location_id', 'api_url', 'pos_implementation_name', 'store_id', 'is_menu_location', 'is_using_pricelist', 'platform_status_polling_enabled', 'menu_top_categories']);

var GLOVO_REQUIRED_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'orders_location_id', 'api_url', 'pos_implementation_name', 'store_id']);

var GLOVO_LIST_COLUMNS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['location_id', 'integration_role', 'active']);

var ALL_INTEGRATIONS_LIST_COLUMNS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['type', 'integration_role', 'id', 'location_id', 'created_at']);

var INTEGRATION_FIELDS_SKIP_ON_SAVE = new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a(['id', '_id', 'menu_exports_today', 'last_menu_export', 'store_active']);

var INTEGRATIONS_WITH_DELETE = new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a(['glovo', 'glovo_laas', 'wolt', 'wolt_drive', 'delivery_hero', 'bolt']);

var INTEGRATIONS_WITH_OCCUPIED_LOCATIONS = new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a(['glovo_laas', 'wolt_drive', 'delivery_hero']);

var INTEGRATION_COMPANY_SHARED_FIELDS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()({
  wolt: ['client_id', 'client_secret', 'api_key'],
  wolt_drive: ['access_token', 'merchant_id'],
  bolt: ['integrator_id', 'secret_key']
});

var OCCUPIED_LOCATIONS_FETCH_PER_PAGE = 500;

var INTEGRATION_OPTION_VALUES = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()(['glovo', 'glovo_laas', 'bolt', 'wolt', 'wolt_drive', 'delivery_hero']);

var BOOLEAN_FIELDS = new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a(['platform_status_polling_enabled', 'active', 'store_active', 'has_own_delivery', 'is_menu_location', 'is_using_pricelist', 'is_integrated', 'is_auto_accept', 'send_status', 'sync_order_status']);

var JSON_FIELDS = new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a(['emails', 'schedule', 'exclude_top_category_ids', 'payment_types_map', 'payment_types']);

function normalizeIntegration(value) {
  if (!value) return null;
  var cleaned = String(value).trim().toLowerCase().replace(/[\s-]+/g, '_');

  var aliases = {
    glovo_laas: ['glovo_laas', 'glovo_laas', 'glovo_laas'],
    wolt_drive: ['wolt_drive', 'wolt_drive'],
    delivery_hero: ['delivery_hero', 'deliveryhero', 'delivery_hero'],
    clock_pms: ['clock_pms', 'clock_pms'],
    rkeeper: ['rkeeper', 'r_keeper'],
    rsystem: ['rsystem', 'r_system'],
    ep_restaurant: ['ep_restaurant', 'eprestaurant', 'ep_restaurant'],
    freya_on_premise: ['freya_on_premise', 'freya', 'freya_premise', 'freya_on_premise'],
    freya_cloud: ['freya_cloud', 'freya_cloud'],
    grandchef: ['grandchef', 'grand_chef']
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_object_entries___default()(aliases)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

      var canonical = _ref2[0];
      var list = _ref2[1];

      if (list.includes(cleaned)) return canonical;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return cleaned;
}

var DEFAULT_INTEGRATIONS_PER_PAGE = 20;
var INTEGRATIONS_PAGE_SIZE_OPTIONS = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_freeze___default()([10, 20, 50, 100]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ManagementIntegrations',
  components: {
    IntegrationForm: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Integrations_IntegrationForm_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  props: {
    groupedLocations: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      selectedIntegration: null,
      activeRowIntegration: null,
      selectedLocationId: null,
      readData: null,
      loading: false,
      saving: false,
      readError: '',
      formData: {},
      formText: {},
      isCreateMode: false,
      isNoData: false,
      hasSearched: false,
      page: 1,
      perPage: DEFAULT_INTEGRATIONS_PER_PAGE,
      integrationsTotalItems: 0,
      integrationsPaginationProps: {
        pageSize: DEFAULT_INTEGRATIONS_PER_PAGE,
        currentPage: 1,
        pageSizes: INTEGRATIONS_PAGE_SIZE_OPTIONS.slice(),
        layout: 'prev, pager, next, sizes, total'
      },
      integrationListRows: [],
      integrationRowsForSharedFields: [],
      occupiedLocationIds: [],
      woltValidationErrors: {},
      woltDriveValidationErrors: {},
      deliveryHeroValidationErrors: {},
      regeneratingDeliveryHeroKeys: false,
      boltValidationErrors: {},
      glovoLaasValidationErrors: {},
      glovoValidationErrors: {},
      topCategories: [],
      integrationFormValidationAttempted: false
    };
  },

  watch: {
    formData: {
      deep: true,
      handler: function handler() {
        if (!this.integrationFormValidationAttempted) return;
        this.refreshIntegrationFormValidation();
      }
    }
  },
  created: function created() {
    this.fetchTopCategories();
    if (this.canLoad) {
      this.fetchRead();
    }
  },

  computed: {
    companyId: function companyId() {
      return this.$session.get('selectedCompany');
    },
    companyTimezone: function companyTimezone() {
      var data = this.$session.get('selectedCompanyData') || {};
      return data.timezone || 'Europe/Bucharest';
    },
    integrationOptions: function integrationOptions() {
      var _this = this;

      return INTEGRATION_OPTION_VALUES.map(function (value) {
        return {
          value: value,
          label: _this.integrationDisplayLabel(value)
        };
      });
    },
    normalizedIntegration: function normalizedIntegration() {
      return normalizeIntegration(this.activeRowIntegration || this.selectedIntegration);
    },
    hasIntegrationFilter: function hasIntegrationFilter() {
      return Boolean(normalizeIntegration(this.selectedIntegration));
    },
    showIntegrationFieldForm: function showIntegrationFieldForm() {
      return this.isCreateMode || Boolean(this.readData);
    },
    showIntegrationEditView: function showIntegrationEditView() {
      return this.isCreateMode || Boolean(this.readData);
    },
    woltRequiredFields: function woltRequiredFields() {
      return WOLT_REQUIRED_FIELDS.slice();
    },
    woltDriveRequiredFields: function woltDriveRequiredFields() {
      return WOLT_DRIVE_REQUIRED_FIELDS.slice();
    },
    deliveryHeroRequiredFields: function deliveryHeroRequiredFields() {
      return DELIVERY_HERO_REQUIRED_FIELDS.slice();
    },
    deliveryHeroCredentialFields: function deliveryHeroCredentialFields() {
      return DELIVERY_HERO_CREDENTIAL_FIELDS.slice();
    },
    boltRequiredFields: function boltRequiredFields() {
      return BOLT_REQUIRED_FIELDS.slice();
    },
    glovoLaasRequiredFields: function glovoLaasRequiredFields() {
      return GLOVO_LAAS_REQUIRED_FIELDS.slice();
    },
    glovoRequiredFields: function glovoRequiredFields() {
      return GLOVO_REQUIRED_FIELDS.slice();
    },
    isWoltFormValid: function isWoltFormValid() {
      if (this.normalizedIntegration !== 'wolt' || !this.showIntegrationFieldForm) return true;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(this.woltValidationErrors).length === 0;
    },
    isWoltDriveFormValid: function isWoltDriveFormValid() {
      if (this.normalizedIntegration !== 'wolt_drive' || !this.showIntegrationFieldForm) return true;
      if (this.isLocationOccupied(this.formData.location_id)) return false;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(this.woltDriveValidationErrors).length === 0;
    },
    isDeliveryHeroFormValid: function isDeliveryHeroFormValid() {
      if (this.normalizedIntegration !== 'delivery_hero' || !this.showIntegrationFieldForm) return true;
      if (this.isLocationOccupied(this.formData.location_id)) return false;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(this.deliveryHeroValidationErrors).length === 0;
    },
    isBoltFormValid: function isBoltFormValid() {
      if (this.normalizedIntegration !== 'bolt' || !this.showIntegrationFieldForm) return true;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(this.boltValidationErrors).length === 0;
    },
    isGlovoLaasFormValid: function isGlovoLaasFormValid() {
      if (this.normalizedIntegration !== 'glovo_laas' || !this.showIntegrationFieldForm) return true;
      if (this.isLocationOccupied(this.formData.location_id)) return false;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(this.glovoLaasValidationErrors).length === 0;
    },
    isGlovoFormValid: function isGlovoFormValid() {
      if (this.normalizedIntegration !== 'glovo' || !this.showIntegrationFieldForm) return true;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(this.glovoValidationErrors).length === 0;
    },
    canSubmitIntegration: function canSubmitIntegration() {
      if (this.normalizedIntegration === 'wolt' && this.showIntegrationFieldForm) {
        return this.isWoltFormValid;
      }
      if (this.normalizedIntegration === 'wolt_drive' && this.showIntegrationFieldForm) {
        return this.isWoltDriveFormValid;
      }
      if (this.normalizedIntegration === 'delivery_hero' && this.showIntegrationFieldForm) {
        return this.isDeliveryHeroFormValid;
      }
      if (this.normalizedIntegration === 'bolt' && this.showIntegrationFieldForm) {
        return this.isBoltFormValid;
      }
      if (this.normalizedIntegration === 'glovo_laas' && this.showIntegrationFieldForm) {
        return this.isGlovoLaasFormValid;
      }
      if (this.normalizedIntegration === 'glovo' && this.showIntegrationFieldForm) {
        return this.isGlovoFormValid;
      }
      return true;
    },
    integrationFormTitle: function integrationFormTitle() {
      var name = this.integrationDisplayLabel(this.normalizedIntegration);
      if (this.isCreateMode) {
        return this.$t('general.add') + ' — ' + name;
      }
      if (this.normalizedIntegration === 'wolt' || this.normalizedIntegration === 'glovo') {
        return name;
      }
      var id = this.readData && (this.readData.id != null ? this.readData.id : this.readData._id);
      var suffix = id != null ? ' #' + id : '';
      return name + suffix;
    },
    editableFields: function editableFields() {
      if (this.normalizedIntegration === 'wolt') {
        if (this.readData) return this.getEditableFieldListForSource(this.readData);
        return WOLT_FORM_FIELDS.slice();
      }
      if (this.normalizedIntegration === 'wolt_drive') {
        if (this.readData) return this.getEditableFieldListForSource(this.readData);
        return WOLT_DRIVE_FORM_FIELDS.slice();
      }
      if (this.normalizedIntegration === 'delivery_hero') {
        if (this.readData) return this.getEditableFieldListForSource(this.readData);
        return DELIVERY_HERO_FORM_FIELDS.slice();
      }
      if (this.normalizedIntegration === 'bolt') {
        if (this.readData) return this.getEditableFieldListForSource(this.readData);
        return BOLT_FORM_FIELDS.slice();
      }
      if (this.normalizedIntegration === 'glovo_laas') {
        if (this.readData) return this.getEditableFieldListForSource(this.readData);
        return GLOVO_LAAS_FORM_FIELDS.slice();
      }
      if (this.normalizedIntegration === 'glovo') {
        if (this.readData) return this.getEditableFieldListForSource(this.readData);
        return GLOVO_FORM_FIELDS.slice();
      }
      if (this.readData) return this.getEditableFieldListForSource(this.readData);
      var all = INTEGRATION_FIELDS[this.normalizedIntegration] || [];
      return all.filter(function (f) {
        return f !== 'company_id' && f !== 'location_id';
      });
    },
    booleanFieldsArray: function booleanFieldsArray() {
      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from___default()(BOOLEAN_FIELDS);
    },
    jsonFieldsArray: function jsonFieldsArray() {
      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from___default()(JSON_FIELDS);
    },
    flatLocations: function flatLocations() {
      var groups = Array.isArray(this.groupedLocations) ? this.groupedLocations : [];
      var out = [];

      groups.forEach(function (group) {
        var locs = group && Array.isArray(group.locations) ? group.locations : [];
        locs.forEach(function (loc) {
          var id = loc && (loc.true_id || loc.id || loc.location_id || loc._id);
          if (!id) return;
          out.push(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, loc, {
            _integrationLocationId: id
          }));
        });
      });

      out.sort(function (a, b) {
        return String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' });
      });
      return out;
    },
    currentRowId: function currentRowId() {
      if (!this.readData) return null;
      return this.readData.id || this.readData._id || null;
    },
    hasExistingData: function hasExistingData() {
      return Boolean(this.currentRowId);
    },
    areFieldsLocked: function areFieldsLocked() {
      if (!this.normalizedIntegration) return true;
      if (this.isBusy) return true;
      if (!this.showIntegrationFieldForm) return true;
      return false;
    },
    canLoad: function canLoad() {
      return Boolean(this.companyId);
    },
    canDeleteIntegration: function canDeleteIntegration() {
      return INTEGRATIONS_WITH_DELETE.has(this.normalizedIntegration);
    },
    canValidateIntegration: function canValidateIntegration() {
      return this.normalizedIntegration === 'glovo_laas' || this.normalizedIntegration === 'wolt_drive' || this.normalizedIntegration === 'delivery_hero';
    },
    isWebhookCapableIntegration: function isWebhookCapableIntegration() {
      return this.normalizedIntegration === 'glovo_laas' || this.normalizedIntegration === 'wolt_drive';
    },
    isWebhookRegistered: function isWebhookRegistered() {
      if (!this.isWebhookCapableIntegration) return false;
      return this.hasWebhookRegistration(this.readData);
    },
    tracksOccupiedLocations: function tracksOccupiedLocations() {
      return INTEGRATIONS_WITH_OCCUPIED_LOCATIONS.has(this.normalizedIntegration);
    },
    occupiedLocationIdsForSelect: function occupiedLocationIdsForSelect() {
      if (!this.tracksOccupiedLocations) return [];
      var ids = this.occupiedLocationIds.map(String);
      if (!this.isCreateMode) {
        var currentLocationId = this.getCurrentIntegrationLocationId();
        if (currentLocationId != null && currentLocationId !== '') {
          var current = String(currentLocationId);
          ids = ids.filter(function (id) {
            return id !== current;
          });
        }
      }
      return ids;
    },
    canSave: function canSave() {
      return this.canLoad;
    },
    isBusy: function isBusy() {
      return this.saving === true || this.loading === true;
    },
    integrationTableColumnKeys: function integrationTableColumnKeys() {
      if (!this.hasIntegrationFilter) {
        return ALL_INTEGRATIONS_LIST_COLUMNS.slice();
      }
      if (this.normalizedIntegration === 'wolt') {
        return WOLT_LIST_COLUMNS.slice();
      }
      if (this.normalizedIntegration === 'wolt_drive') {
        return WOLT_DRIVE_LIST_COLUMNS.slice();
      }
      if (this.normalizedIntegration === 'delivery_hero') {
        return DELIVERY_HERO_LIST_COLUMNS.slice();
      }
      if (this.normalizedIntegration === 'bolt') {
        return BOLT_LIST_COLUMNS.slice();
      }
      if (this.normalizedIntegration === 'glovo_laas') {
        return GLOVO_LAAS_LIST_COLUMNS.slice();
      }
      if (this.normalizedIntegration === 'glovo') {
        return GLOVO_LIST_COLUMNS.slice();
      }
      var rows = Array.isArray(this.integrationListRows) ? this.integrationListRows : [];
      var keys = new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a();
      rows.forEach(function (row) {
        if (row && (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(row)) === 'object' && !Array.isArray(row)) {
          __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(row).forEach(function (k) {
            if (k !== '_rowKey') keys.add(k);
          });
        }
      });
      return this.orderIntegrationTableColumnKeys(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from___default()(keys));
    },
    integrationTableDisplayColumnKeys: function integrationTableDisplayColumnKeys() {
      var keys = this.integrationTableColumnKeys;
      if (keys.length) return keys;
      var base = INTEGRATION_FIELDS[this.normalizedIntegration] || [];
      var filtered = base.filter(function (f) {
        return f !== 'company_id';
      });
      return this.orderIntegrationTableColumnKeys(filtered.length ? filtered : ['id', 'location_id', 'active']);
    },
    integrationsTableRows: function integrationsTableRows() {
      if (!this.hasSearched) return [];
      return this.integrationListRows;
    },
    integrationsTableTotal: function integrationsTableTotal() {
      if (!this.hasSearched) return 0;
      return this.integrationsTotalItems;
    },
    integrationsTablePaginationProps: function integrationsTablePaginationProps() {
      if (!this.hasSearched) {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, this.integrationsPaginationProps, {
          currentPage: 1,
          pageSize: this.perPage
        });
      }
      return this.integrationsPaginationProps;
    },
    integrationsTableEmptyText: function integrationsTableEmptyText() {
      if (!this.hasSearched) {
        return this.$t('gestiune.integrationsSelectIntegrationHint');
      }
      return this.$t('gestiune.integrationsEmptyTableHint');
    }
  },
  methods: {
    validateWoltForm: function validateWoltForm() {
      var _this2 = this;

      var errors = {};
      WOLT_REQUIRED_FIELDS.forEach(function (field) {
        var v = _this2.formData[field];
        var empty = field === 'location_id' || field === 'orders_location_id' ? v === null || v === undefined || v === '' : v === null || v === undefined || String(v).trim() === '';
        if (empty) {
          errors[field] = _this2.$t('validations.requiredField');
        }
      });
      this.woltValidationErrors = errors;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(errors).length === 0;
    },
    validateCommaSeparatedEmails: function validateCommaSeparatedEmails(value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Integrations_integrationEmailHelpers_js__["a" /* validateEmailListInput */])(value);
    },
    resetIntegrationValidationState: function resetIntegrationValidationState() {
      this.integrationFormValidationAttempted = false;
      this.woltValidationErrors = {};
      this.woltDriveValidationErrors = {};
      this.deliveryHeroValidationErrors = {};
      this.boltValidationErrors = {};
      this.glovoLaasValidationErrors = {};
      this.glovoValidationErrors = {};
    },
    refreshIntegrationFormValidation: function refreshIntegrationFormValidation() {
      if (!this.showIntegrationFieldForm) return;
      if (this.normalizedIntegration === 'wolt') {
        this.validateWoltForm();
      } else if (this.normalizedIntegration === 'wolt_drive') {
        this.validateWoltDriveForm();
      } else if (this.normalizedIntegration === 'delivery_hero') {
        this.validateDeliveryHeroForm();
      } else if (this.normalizedIntegration === 'bolt') {
        this.validateBoltForm();
      } else if (this.normalizedIntegration === 'glovo_laas') {
        this.validateGlovoLaasForm();
      } else if (this.normalizedIntegration === 'glovo') {
        this.validateGlovoForm();
      }
    },
    validateWoltDriveForm: function validateWoltDriveForm() {
      var _this3 = this;

      var errors = {};
      WOLT_DRIVE_REQUIRED_FIELDS.forEach(function (field) {
        var v = _this3.formData[field];
        if (v === null || v === undefined || String(v).trim() === '') {
          errors[field] = _this3.$t('validations.requiredField');
        }
      });
      if (this.isLocationOccupied(this.formData.location_id)) {
        errors.location_id = this.$t('gestiune.integrationsLocationOccupied');
      }
      if (!this.validateCommaSeparatedEmails(this.formData.feedback_emails)) {
        errors.feedback_emails = this.$t('validations.invalidEnteredData');
      }
      this.woltDriveValidationErrors = errors;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(errors).length === 0;
    },
    validateDeliveryHeroForm: function validateDeliveryHeroForm() {
      var _this4 = this;

      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$requireCredenti = _ref3.requireCredentials,
          requireCredentials = _ref3$requireCredenti === undefined ? false : _ref3$requireCredenti;

      var errors = {};
      DELIVERY_HERO_REQUIRED_FIELDS.forEach(function (field) {
        var v = _this4.formData[field];
        var empty = field === 'location_id' ? v === null || v === undefined || v === '' : v === null || v === undefined || String(v).trim() === '';
        if (empty) {
          errors[field] = _this4.$t('validations.requiredField');
        }
      });
      if (requireCredentials) {
        DELIVERY_HERO_CREDENTIAL_FIELDS.forEach(function (field) {
          var v = _this4.formData[field];
          if (v === null || v === undefined || String(v).trim() === '') {
            errors[field] = _this4.$t('validations.requiredField');
          }
        });
      }
      if (this.isLocationOccupied(this.formData.location_id)) {
        errors.location_id = this.$t('gestiune.integrationsLocationOccupied');
      }
      if (!this.validateCommaSeparatedEmails(this.formData.feedback_emails)) {
        errors.feedback_emails = this.$t('validations.invalidEnteredData');
      }
      this.deliveryHeroValidationErrors = errors;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(errors).length === 0;
    },
    validateBoltForm: function validateBoltForm() {
      var _this5 = this;

      var errors = {};
      BOLT_REQUIRED_FIELDS.forEach(function (field) {
        var v = _this5.formData[field];
        var empty = field === 'location_id' || field === 'orders_location_id' ? v === null || v === undefined || v === '' : v === null || v === undefined || String(v).trim() === '';
        if (empty) {
          errors[field] = _this5.$t('validations.requiredField');
        }
      });
      if (!this.validateCommaSeparatedEmails(this.formData.emails)) {
        errors.emails = this.$t('validations.invalidEnteredData');
      }
      this.boltValidationErrors = errors;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(errors).length === 0;
    },
    validateGlovoLaasForm: function validateGlovoLaasForm() {
      var _this6 = this;

      var errors = {};
      GLOVO_LAAS_REQUIRED_FIELDS.forEach(function (field) {
        var v = _this6.formData[field];
        var empty = field === 'location_id' ? v === null || v === undefined || v === '' : v === null || v === undefined || String(v).trim() === '';
        if (empty) {
          errors[field] = _this6.$t('validations.requiredField');
        }
      });
      if (this.isLocationOccupied(this.formData.location_id)) {
        errors.location_id = this.$t('gestiune.integrationsLocationOccupied');
      }
      this.glovoLaasValidationErrors = errors;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(errors).length === 0;
    },
    validateGlovoForm: function validateGlovoForm() {
      var _this7 = this;

      var errors = {};
      GLOVO_REQUIRED_FIELDS.forEach(function (field) {
        var v = _this7.formData[field];
        var empty = field === 'location_id' || field === 'orders_location_id' ? v === null || v === undefined || v === '' : v === null || v === undefined || String(v).trim() === '';
        if (empty) {
          errors[field] = _this7.$t('validations.requiredField');
        }
      });
      this.glovoValidationErrors = errors;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(errors).length === 0;
    },
    normalizeFeedbackEmails: function normalizeFeedbackEmails(value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Integrations_integrationEmailHelpers_js__["b" /* formatEmailListForInput */])(value);
    },
    formatWoltDriveAutoSendStatus: function formatWoltDriveAutoSendStatus(value) {
      if (value == null || value === '') return '—';
      var key = 'gestiune.woltDriveAutoSendStatus_' + String(value).toLowerCase();
      var translated = this.$t(key);
      return translated !== key ? translated : String(value);
    },
    getApiResponseMessage: function getApiResponseMessage(response) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["a" /* extractApiResponseMessage */])(response);
    },
    extractIntegrationIdFromResponse: function extractIntegrationIdFromResponse(response) {
      if (!response) return null;
      var raw = response.data !== undefined && response.data !== null ? response.data : response;
      var data = raw && raw.data !== undefined && raw.data !== null ? raw.data : raw;
      var id = data && (data.id != null ? data.id : data._id);
      if (id != null && id !== '') return id;
      if (data && data.glovo_company_id != null) return data.glovo_company_id;
      return null;
    },
    extractCredentialsTestErrorItems: function extractCredentialsTestErrorItems(response) {
      var items = [];
      if (!response) return items;
      var lists = [response.errors, response.data && response.data.errors].filter(Array.isArray);
      lists.forEach(function (list) {
        list.forEach(function (err) {
          if (err && (typeof err === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(err)) === 'object') items.push(err);
        });
      });
      var seen = new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a();
      return items.filter(function (err) {
        var key = [err.error_code || '', err.third_party_message || '', err.third_party && err.third_party.body && err.third_party.body.message].join('|');
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
    resolveCredentialsTestErrorMessage: function resolveCredentialsTestErrorMessage(errorItem) {
      if (!errorItem || (typeof errorItem === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(errorItem)) !== 'object') return '';
      var code = errorItem.error_code;
      if (code != null && String(code).trim() !== '') {
        var i18nKey = 'gestiune.integrationsCredentialErrorCodes.' + String(code).trim();
        var translated = this.$t(i18nKey);
        if (translated !== i18nKey) return translated;
      }
      var thirdPartyBody = errorItem.third_party && errorItem.third_party.body;
      if (thirdPartyBody && thirdPartyBody.message != null && String(thirdPartyBody.message).trim() !== '') {
        return String(thirdPartyBody.message).trim();
      }
      if (errorItem.third_party_message != null && String(errorItem.third_party_message).trim() !== '') {
        return String(errorItem.third_party_message).trim();
      }
      return '';
    },
    formatCredentialsTestErrorResponse: function formatCredentialsTestErrorResponse(response) {
      var _this8 = this;

      var items = this.extractCredentialsTestErrorItems(response);
      var messages = items.map(function (item) {
        return _this8.resolveCredentialsTestErrorMessage(item);
      }).filter(function (message) {
        return message !== '';
      });
      var uniqueMessages = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a(messages)));
      var baseMessage = uniqueMessages.length ? uniqueMessages.join('\n') : this.getApiResponseMessage(response) || this.$t('gestiune.integrationsCredentialsTestError');
      return baseMessage + '\n\n' + this.$t('gestiune.integrationsCredentialsTestRetryHint');
    },
    buildCredentialsTestPayload: function buildCredentialsTestPayload() {
      return {
        token: this.$session.get('token'),
        company_id: this.companyId,
        location_id: this.formData.location_id
      };
    },
    getCredentialsTestUrl: function getCredentialsTestUrl(integrationId) {
      if (!integrationId) return '';
      if (this.normalizedIntegration === 'glovo_laas') {
        return '/integrations/glovo-laas/' + integrationId + '/test-credentials';
      }
      if (this.normalizedIntegration === 'wolt_drive') {
        return '/integrations/wolt-drive/' + integrationId + '/test-credentials';
      }
      if (this.normalizedIntegration === 'delivery_hero') {
        return '/integrations/delivery-hero/' + integrationId + '/test-credentials';
      }
      return '';
    },
    testIntegrationCredentials: function testIntegrationCredentials(integrationId) {
      var _this9 = this;

      var url = this.getCredentialsTestUrl(integrationId);
      if (!url) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve({
          ok: false,
          message: this.$t('gestiune.integrationsSaveError')
        });
      }

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this9.apiRequest(url, 'POST', _this9.buildCredentialsTestPayload(), function (response) {
          if (!response || response.status === false || response.data && response.data.valid === false) {
            resolve({
              ok: false,
              message: _this9.formatCredentialsTestErrorResponse(response)
            });
            return;
          }
          resolve({ ok: true, response: response });
        });
      });
    },
    hasWebhookRegistration: function hasWebhookRegistration(source) {
      if (!source || (typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(source)) !== 'object') return false;
      var candidates = ['webhook_id', 'webhook_secret', 'webhook_secret_id', 'is_webhook_registered', 'webhook_registered'];
      return candidates.some(function (key) {
        var v = source[key];
        if (typeof v === 'boolean') return v;
        return v != null && String(v).trim() !== '';
      });
    },
    getRegisterWebhookUrl: function getRegisterWebhookUrl(integrationId) {
      if (!integrationId) return '';
      if (this.normalizedIntegration === 'glovo_laas') {
        return '/integrations/glovo-laas/' + integrationId + '/register-webhook';
      }
      if (this.normalizedIntegration === 'wolt_drive') {
        return '/integrations/wolt-drive/' + integrationId + '/register-webhook';
      }
      return '';
    },
    registerIntegrationWebhook: function registerIntegrationWebhook(integrationId) {
      var _this10 = this;

      var url = this.getRegisterWebhookUrl(integrationId);
      if (!url) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve({
          ok: false,
          message: this.$t('gestiune.integrationsWebhookRegisterError')
        });
      }

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this10.apiRequest(url, 'POST', _this10.buildCredentialsTestPayload(), function (response) {
          if (!response || response.status === false || response.data && response.data.valid === false) {
            resolve({
              ok: false,
              message: _this10.getApiResponseMessage(response) || _this10.$t('gestiune.integrationsWebhookRegisterError')
            });
            return;
          }
          resolve({ ok: true, response: response });
        });
      });
    },
    runSaveAndTestCredentialsFlow: function runSaveAndTestCredentialsFlow(_ref4) {
      var _this11 = this;

      var updateStep = _ref4.updateStep,
          finish = _ref4.finish,
          isCreate = _ref4.isCreate;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var webhookAlreadyRegistered, saveResult, integrationId, testResult, shouldRegisterWebhook, webhookResult;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                webhookAlreadyRegistered = _this11.isWebhookRegistered;


                if (updateStep) updateStep('save', 'running');

                _context.next = 4;
                return _this11.save({
                  silent: true,
                  activationFlow: isCreate === true,
                  skipFetchRead: true,
                  requireCredentials: _this11.normalizedIntegration === 'delivery_hero'
                });

              case 4:
                saveResult = _context.sent;

                if (saveResult.ok) {
                  _context.next = 9;
                  break;
                }

                if (updateStep) updateStep('save', 'error', saveResult.message);
                if (finish) finish(false);
                return _context.abrupt('return');

              case 9:

                if (updateStep) updateStep('save', 'success');
                if (isCreate) _this11.isCreateMode = false;

                integrationId = saveResult.id || _this11.currentRowId || _this11.formData.id;

                if (updateStep) updateStep('test', 'running');

                _context.next = 15;
                return _this11.testIntegrationCredentials(integrationId);

              case 15:
                testResult = _context.sent;

                if (testResult.ok) {
                  _context.next = 20;
                  break;
                }

                if (updateStep) updateStep('test', 'error', testResult.message);
                if (finish) finish(false);
                return _context.abrupt('return');

              case 20:

                if (updateStep) updateStep('test', 'success');

                shouldRegisterWebhook = _this11.isWebhookCapableIntegration && (isCreate === true || !webhookAlreadyRegistered);

                if (!shouldRegisterWebhook) {
                  _context.next = 32;
                  break;
                }

                if (updateStep) updateStep('webhook', 'running');

                _context.next = 26;
                return _this11.registerIntegrationWebhook(integrationId);

              case 26:
                webhookResult = _context.sent;

                if (webhookResult.ok) {
                  _context.next = 31;
                  break;
                }

                if (updateStep) updateStep('webhook', 'error', webhookResult.message);
                if (finish) finish(false);
                return _context.abrupt('return');

              case 31:

                if (updateStep) updateStep('webhook', 'success');

              case 32:

                if (finish) finish(true);

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this11);
      }))();
    },
    apiRequestAsync: function apiRequestAsync(url, method, payload) {
      var _this12 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this12.apiRequest(url, method, payload, resolve);
      });
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    buildGlovoActionPayload: function buildGlovoActionPayload(glovoCompanyId) {
      return {
        token: this.$session.get('token'),
        company_id: this.companyId,
        location_id: this.formData.location_id,
        glovo_company_id: glovoCompanyId
      };
    },
    isGlovoMenuNotFoundResponse: function isGlovoMenuNotFoundResponse(response) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["b" /* isMenuNotFoundResponse */])(response);
    },
    normalizeGlovoValidationList: function normalizeGlovoValidationList(value) {
      var items = [];
      var collect = function collect(entry) {
        if (entry == null) return;
        if (Array.isArray(entry)) {
          entry.forEach(collect);
          return;
        }
        if ((typeof entry === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(entry)) === 'object') {
          if (entry.message) collect(entry.message);else if (entry.error) collect(entry.error);
          return;
        }
        var text = String(entry).trim();
        if (text) items.push(text);
      };
      collect(value);
      return [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a(items)));
    },
    extractGlovoValidationErrors: function extractGlovoValidationErrors(response) {
      var items = [];
      var failed = !response || response.status === false;
      var payload = response && response.data;
      if (Array.isArray(response && response.errors)) {
        items.push.apply(items, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.normalizeGlovoValidationList(response.errors)));
      }
      if (payload) {
        items.push.apply(items, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.normalizeGlovoValidationList(payload.errors)));
        if (failed) {
          items.push.apply(items, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.normalizeGlovoValidationList(payload.details)));
        }
        if (payload.provider_response) {
          items.push.apply(items, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.normalizeGlovoValidationList(payload.provider_response.errors)));
          if (failed) {
            items.push.apply(items, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(this.normalizeGlovoValidationList(payload.provider_response.details)));
          }
        }
      }
      return [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a(items)));
    },
    formatGlovoApiFeedback: function formatGlovoApiFeedback(response) {
      var _this13 = this;

      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'generic';

      if (!response) return this.$t('gestiune.integrationsActionError');
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["c" /* getIntegrationActionErrorMessage */])(response, this.normalizedIntegration, action, function (key) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return _this13.$t.apply(_this13, [key].concat(args));
      });
    },
    extractGlovoTransactionId: function extractGlovoTransactionId(response) {
      if (!response || !response.data) return null;
      var data = response.data.data || response.data;
      return data.transaction_id || data.provider_response && data.provider_response.transaction_id || null;
    },
    getGlovoValidationErrorMessage: function getGlovoValidationErrorMessage(response) {
      return this.getMenuValidateErrorMessage(response);
    },
    buildMenuValidatePayload: function buildMenuValidatePayload() {
      var locationId = this.formData.location_id;
      return {
        token: this.$session.get('token'),
        company_id: this.companyId,
        location_id: locationId == null || locationId === '' ? null : this.getLocationTrueId(locationId),
        integration: this.normalizedIntegration
      };
    },
    getMenuValidateErrorMessage: function getMenuValidateErrorMessage(response) {
      var _this14 = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["d" /* getMenuValidationShortMessage */])(response, function (key) {
        return _this14.$t(key);
      }, this.isGlovoMenuNotFoundResponse(response));
    },
    failMenuValidationStep: function failMenuValidationStep(updateStep, finish, response) {
      var _this15 = this;

      var translate = function translate(key) {
        return _this15.$t(key);
      };
      var isEmptyMenu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["b" /* isMenuNotFoundResponse */])(response);
      var validationGroups = response ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["e" /* extractMenuValidationGroups */])(response, translate) : [];
      var message = '';
      if (isEmptyMenu) {
        message = this.$t('gestiune.integrationsGlovoMenuEmpty') + '\n\n' + this.$t('gestiune.integrationsGlovoActivateMenuEmptyHint');
        validationGroups = [];
      } else if (!validationGroups.length) {
        message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["d" /* getMenuValidationShortMessage */])(response, translate, false) || this.$t('gestiune.integrationsActionError');
      }
      if (updateStep) updateStep('validateMenu', 'error', message, validationGroups);
      if (finish) finish(false);
    },
    requestMenuValidate: function requestMenuValidate() {
      var _this16 = this;

      return this.apiRequestAsync('/integrations/menu/validate', 'POST', this.buildMenuValidatePayload()).then(function (response) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["f" /* isMenuValidationSuccessful */])(response, function (key) {
          return _this16.$t(key);
        }, _this16.isGlovoMenuNotFoundResponse(response))) {
          return { ok: true, response: response };
        }
        return { ok: false, message: _this16.getMenuValidateErrorMessage(response), response: response };
      });
    },
    buildWoltBoltActionPayload: function buildWoltBoltActionPayload(integrationId) {
      var locationId = this.formData.location_id;
      var payload = {
        token: this.$session.get('token'),
        company_id: this.companyId,
        location_id: locationId == null || locationId === '' ? null : this.getLocationTrueId(locationId)
      };
      if (this.normalizedIntegration === 'wolt') {
        payload.wolt_company_id = integrationId;
      } else if (this.normalizedIntegration === 'bolt') {
        payload.bolt_company_id = integrationId;
      }
      return payload;
    },
    getWoltBoltActionErrorMessage: function getWoltBoltActionErrorMessage(response, pushFailed) {
      var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pushMenu';

      if (this.isGlovoMenuNotFoundResponse(response)) {
        return this.$t('gestiune.integrationsGlovoMenuEmpty') + '\n\n' + this.$t('gestiune.integrationsGlovoActivateMenuEmptyHint');
      }
      var suffix = pushFailed ? '\n\n' + this.$t('gestiune.integrationsGlovoActivatePushFailedHint') : '';
      return '' + this.formatGlovoApiFeedback(response, action) + suffix;
    },
    requestWoltBoltToggleLocation: function requestWoltBoltToggleLocation(integrationId, active) {
      var _this17 = this;

      var payload = this.buildWoltBoltActionPayload(integrationId);
      payload.active = Boolean(active);
      var url = this.normalizedIntegration === 'wolt' ? '/wolt/toggle-location-status' : '/bolt/handle-open';
      return this.apiRequestAsync(url, 'POST', payload).then(function (response) {
        if (response && response.status) {
          return { ok: true, response: response };
        }
        return { ok: false, message: _this17.getWoltBoltActionErrorMessage(response, false, 'toggleLocation') };
      });
    },
    requestWoltBoltPushMenu: function requestWoltBoltPushMenu(integrationId) {
      var _this18 = this;

      var url = this.normalizedIntegration === 'wolt' ? '/wolt/export-menu' : '/bolt/push-menu';
      return this.apiRequestAsync(url, 'POST', this.buildWoltBoltActionPayload(integrationId)).then(function (response) {
        if (!response || response.status === false) {
          return {
            ok: false,
            message: _this18.getWoltBoltActionErrorMessage(response, true)
          };
        }
        var transactionId = _this18.extractGlovoTransactionId(response);
        return { ok: true, response: response, transactionId: transactionId };
      });
    },
    formatGlovoExportFailureMessage: function formatGlovoExportFailureMessage(data) {
      var items = this.normalizeGlovoValidationList([data && data.export_status, data && data.errors, data && data.details, data && data.provider_response && data.provider_response.errors, data && data.provider_response && data.provider_response.details]);
      var base = items.length ? items.join('\n') : this.$t('gestiune.integrationsGlovoExportFailed');
      return base + '\n\n' + this.$t('gestiune.integrationsGlovoActivateExportFailedHint');
    },
    resolveGlovoExportStatusFromResponse: function resolveGlovoExportStatusFromResponse(response) {
      if (!response || response.status === false) {
        return {
          terminal: true,
          ok: false,
          message: this.formatGlovoApiFeedback(response, 'pushMenu')
        };
      }
      var data = response.data && (response.data.data || response.data);
      if (!data) {
        return {
          terminal: false,
          ok: false,
          message: this.$t('gestiune.integrationsGlovoExportInProgress')
        };
      }
      if (data.is_successful === true) {
        return { terminal: true, ok: true, message: '' };
      }
      if (data.is_successful === false) {
        return {
          terminal: true,
          ok: false,
          message: this.formatGlovoExportFailureMessage(data)
        };
      }
      var statusLabel = data.export_status ? String(data.export_status) : this.$t('gestiune.integrationsGlovoExportInProgress');
      return { terminal: false, ok: false, message: statusLabel };
    },
    requestGlovoMenuValidate: function requestGlovoMenuValidate(glovoCompanyId) {
      var _this19 = this;

      return this.apiRequestAsync('/glovo/menu/validate', 'POST', this.buildGlovoActionPayload(glovoCompanyId)).then(function (response) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["f" /* isMenuValidationSuccessful */])(response, function (key) {
          return _this19.$t(key);
        }, _this19.isGlovoMenuNotFoundResponse(response))) {
          return { ok: true, response: response };
        }
        if (_this19.isGlovoMenuNotFoundResponse(response)) {
          return {
            ok: false,
            message: _this19.$t('gestiune.integrationsGlovoMenuEmpty') + '\n\n' + _this19.$t('gestiune.integrationsGlovoActivateMenuEmptyHint'),
            response: response
          };
        }
        return { ok: false, message: _this19.getGlovoValidationErrorMessage(response), response: response };
      });
    },
    requestGlovoToggleLocation: function requestGlovoToggleLocation(glovoCompanyId, active) {
      var _this20 = this;

      var payload = this.buildGlovoActionPayload(glovoCompanyId);
      payload.active = Boolean(active);
      return this.apiRequestAsync('/glovo/toggle-location-status', 'POST', payload).then(function (response) {
        if (response && response.status) {
          return { ok: true, response: response };
        }
        return { ok: false, message: _this20.formatGlovoApiFeedback(response, 'toggleLocation') };
      });
    },
    requestGlovoPushMenu: function requestGlovoPushMenu(glovoCompanyId) {
      var _this21 = this;

      return this.apiRequestAsync('/glovo/menu/send-url', 'POST', this.buildGlovoActionPayload(glovoCompanyId)).then(function (response) {
        if (!response || response.status === false) {
          var message = _this21.isGlovoMenuNotFoundResponse(response) ? _this21.$t('gestiune.integrationsGlovoMenuEmpty') + '\n\n' + _this21.$t('gestiune.integrationsGlovoActivateMenuEmptyHint') : _this21.formatGlovoApiFeedback(response, 'pushMenu') + '\n\n' + _this21.$t('gestiune.integrationsGlovoActivatePushFailedHint');
          return { ok: false, message: message };
        }
        var transactionId = _this21.extractGlovoTransactionId(response);
        return { ok: true, response: response, transactionId: transactionId };
      });
    },
    requestGlovoExportStatus: function requestGlovoExportStatus(glovoCompanyId, transactionId) {
      var payload = this.buildGlovoActionPayload(glovoCompanyId);
      if (transactionId) payload.transaction_id = transactionId;
      return this.apiRequestAsync('/glovo/menu/export-status', 'POST', payload);
    },
    pollGlovoExportStatus: function pollGlovoExportStatus(glovoCompanyId, transactionId, onProgress) {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var maxAttempts, intervalMs, attempt, response, outcome;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                maxAttempts = 60;
                intervalMs = 3000;
                attempt = 0;

              case 3:
                if (!(attempt < maxAttempts)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 6;
                return _this22.requestGlovoExportStatus(glovoCompanyId, transactionId);

              case 6:
                response = _context2.sent;
                outcome = _this22.resolveGlovoExportStatusFromResponse(response);

                if (typeof onProgress === 'function' && outcome.message) {
                  onProgress(outcome.message);
                }

                if (!outcome.terminal) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt('return', outcome.ok ? { ok: true } : { ok: false, message: outcome.message || _this22.$t('gestiune.integrationsGlovoExportFailed') });

              case 11:
                if (!(attempt < maxAttempts - 1)) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 14;
                return _this22.sleep(intervalMs);

              case 14:
                attempt += 1;
                _context2.next = 3;
                break;

              case 17:
                return _context2.abrupt('return', {
                  ok: false,
                  message: _this22.$t('gestiune.integrationsGlovoActivateExportTimeout') + '\n\n' + _this22.$t('gestiune.integrationsGlovoActivateExportFailedHint')
                });

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this22);
      }))();
    },
    runGlovoActivateFlow: function runGlovoActivateFlow(_ref5) {
      var _this23 = this;

      var updateStep = _ref5.updateStep,
          finish = _ref5.finish,
          confirmMenuValidationOverride = _ref5.confirmMenuValidationOverride;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var fail, saveResult, integrationId, validateResult, proceed, deactivateResult, pushResult, pollResult, activateResult;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fail = function fail(stepId, message) {
                  if (updateStep) updateStep(stepId, 'error', message);
                  if (finish) finish(false);
                };

                if (updateStep) updateStep('save', 'running');
                _context3.next = 4;
                return _this23.save({
                  silent: true,
                  activationFlow: true,
                  skipFetchRead: true
                });

              case 4:
                saveResult = _context3.sent;

                if (saveResult.ok) {
                  _context3.next = 8;
                  break;
                }

                fail('save', saveResult.message);
                return _context3.abrupt('return');

              case 8:
                if (updateStep) updateStep('save', 'success');
                _this23.isCreateMode = false;

                integrationId = saveResult.id || _this23.currentRowId || _this23.formData.id;

                if (integrationId) {
                  _context3.next = 14;
                  break;
                }

                fail('save', _this23.$t('gestiune.integrationsSaveError'));
                return _context3.abrupt('return');

              case 14:

                if (updateStep) updateStep('validateMenu', 'running');
                _context3.next = 17;
                return _this23.requestGlovoMenuValidate(integrationId);

              case 17:
                validateResult = _context3.sent;

                if (validateResult.ok) {
                  _context3.next = 31;
                  break;
                }

                _context3.t0 = typeof confirmMenuValidationOverride === 'function';

                if (!_context3.t0) {
                  _context3.next = 24;
                  break;
                }

                _context3.next = 23;
                return confirmMenuValidationOverride(validateResult.response);

              case 23:
                _context3.t0 = _context3.sent;

              case 24:
                proceed = _context3.t0;

                if (proceed) {
                  _context3.next = 28;
                  break;
                }

                _this23.failMenuValidationStep(updateStep, finish, validateResult.response);
                return _context3.abrupt('return');

              case 28:
                if (updateStep) updateStep('validateMenu', 'success', _this23.$t('gestiune.integrationsMenuValidationProceedingAnyway'));
                _context3.next = 32;
                break;

              case 31:
                if (updateStep) {
                  updateStep('validateMenu', 'success');
                }

              case 32:
                if (updateStep) updateStep('deactivateLocation', 'running');
                _context3.next = 35;
                return _this23.requestGlovoToggleLocation(integrationId, false);

              case 35:
                deactivateResult = _context3.sent;

                if (deactivateResult.ok) {
                  _context3.next = 39;
                  break;
                }

                fail('deactivateLocation', deactivateResult.message);
                return _context3.abrupt('return');

              case 39:
                if (updateStep) updateStep('deactivateLocation', 'success');

                if (updateStep) updateStep('pushMenu', 'running');
                _context3.next = 43;
                return _this23.requestGlovoPushMenu(integrationId);

              case 43:
                pushResult = _context3.sent;

                if (pushResult.ok) {
                  _context3.next = 47;
                  break;
                }

                fail('pushMenu', pushResult.message);
                return _context3.abrupt('return');

              case 47:
                if (pushResult.transactionId) {
                  _context3.next = 50;
                  break;
                }

                fail('pushMenu', _this23.$t('gestiune.integrationsGlovoActivateNoTransactionId'));
                return _context3.abrupt('return');

              case 50:
                if (updateStep) updateStep('pushMenu', 'success');

                if (updateStep) updateStep('checkExportStatus', 'running');
                _context3.next = 54;
                return _this23.pollGlovoExportStatus(integrationId, pushResult.transactionId, function (statusMessage) {
                  if (updateStep) updateStep('checkExportStatus', 'running', statusMessage);
                });

              case 54:
                pollResult = _context3.sent;

                if (pollResult.ok) {
                  _context3.next = 58;
                  break;
                }

                fail('checkExportStatus', pollResult.message);
                return _context3.abrupt('return');

              case 58:
                if (updateStep) updateStep('checkExportStatus', 'success');

                if (updateStep) updateStep('activateLocation', 'running');
                _context3.next = 62;
                return _this23.requestGlovoToggleLocation(integrationId, true);

              case 62:
                activateResult = _context3.sent;

                if (activateResult.ok) {
                  _context3.next = 66;
                  break;
                }

                fail('activateLocation', activateResult.message);
                return _context3.abrupt('return');

              case 66:
                if (updateStep) updateStep('activateLocation', 'success');

                if (finish) finish(true);

              case 68:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this23);
      }))();
    },
    runWoltBoltActivateFlow: function runWoltBoltActivateFlow(_ref6) {
      var _this24 = this;

      var updateStep = _ref6.updateStep,
          finish = _ref6.finish,
          confirmMenuValidationOverride = _ref6.confirmMenuValidationOverride;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var fail, saveResult, integrationId, validateResult, proceed, deactivateResult, pushResult, activateResult;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fail = function fail(stepId, message) {
                  if (updateStep) updateStep(stepId, 'error', message);
                  if (finish) finish(false);
                };

                if (updateStep) updateStep('save', 'running');
                _context4.next = 4;
                return _this24.save({
                  silent: true,
                  activationFlow: true,
                  skipFetchRead: true
                });

              case 4:
                saveResult = _context4.sent;

                if (saveResult.ok) {
                  _context4.next = 8;
                  break;
                }

                fail('save', saveResult.message);
                return _context4.abrupt('return');

              case 8:
                if (updateStep) updateStep('save', 'success');
                _this24.isCreateMode = false;

                integrationId = saveResult.id || _this24.currentRowId || _this24.formData.id;

                if (integrationId) {
                  _context4.next = 14;
                  break;
                }

                fail('save', _this24.$t('gestiune.integrationsSaveError'));
                return _context4.abrupt('return');

              case 14:

                if (updateStep) updateStep('validateMenu', 'running');
                _context4.next = 17;
                return _this24.requestMenuValidate();

              case 17:
                validateResult = _context4.sent;

                if (validateResult.ok) {
                  _context4.next = 31;
                  break;
                }

                _context4.t0 = typeof confirmMenuValidationOverride === 'function';

                if (!_context4.t0) {
                  _context4.next = 24;
                  break;
                }

                _context4.next = 23;
                return confirmMenuValidationOverride(validateResult.response);

              case 23:
                _context4.t0 = _context4.sent;

              case 24:
                proceed = _context4.t0;

                if (proceed) {
                  _context4.next = 28;
                  break;
                }

                _this24.failMenuValidationStep(updateStep, finish, validateResult.response);
                return _context4.abrupt('return');

              case 28:
                if (updateStep) updateStep('validateMenu', 'success', _this24.$t('gestiune.integrationsMenuValidationProceedingAnyway'));
                _context4.next = 32;
                break;

              case 31:
                if (updateStep) {
                  updateStep('validateMenu', 'success');
                }

              case 32:
                if (updateStep) updateStep('deactivateLocation', 'running');
                _context4.next = 35;
                return _this24.requestWoltBoltToggleLocation(integrationId, false);

              case 35:
                deactivateResult = _context4.sent;

                if (deactivateResult.ok) {
                  _context4.next = 39;
                  break;
                }

                fail('deactivateLocation', deactivateResult.message);
                return _context4.abrupt('return');

              case 39:
                if (updateStep) updateStep('deactivateLocation', 'success');

                if (updateStep) updateStep('pushMenu', 'running');
                _context4.next = 43;
                return _this24.requestWoltBoltPushMenu(integrationId);

              case 43:
                pushResult = _context4.sent;

                if (pushResult.ok) {
                  _context4.next = 47;
                  break;
                }

                fail('pushMenu', pushResult.message);
                return _context4.abrupt('return');

              case 47:
                if (updateStep) updateStep('pushMenu', 'success');

                if (updateStep) updateStep('activateLocation', 'running');
                _context4.next = 51;
                return _this24.requestWoltBoltToggleLocation(integrationId, true);

              case 51:
                activateResult = _context4.sent;

                if (activateResult.ok) {
                  _context4.next = 55;
                  break;
                }

                fail('activateLocation', activateResult.message);
                return _context4.abrupt('return');

              case 55:
                if (updateStep) updateStep('activateLocation', 'success');

                if (finish) finish(true);

              case 57:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this24);
      }))();
    },
    activateIntegration: function activateIntegration(_ref7) {
      var _this25 = this;

      var updateStep = _ref7.updateStep,
          finish = _ref7.finish,
          confirmMenuValidationOverride = _ref7.confirmMenuValidationOverride;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this25.isBusy) {
                  _context5.next = 3;
                  break;
                }

                if (finish) finish(false);
                return _context5.abrupt('return');

              case 3:
                if (!(_this25.normalizedIntegration === 'glovo')) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 6;
                return _this25.runGlovoActivateFlow({ updateStep: updateStep, finish: finish, confirmMenuValidationOverride: confirmMenuValidationOverride });

              case 6:
                return _context5.abrupt('return');

              case 7:
                if (!(_this25.normalizedIntegration === 'wolt' || _this25.normalizedIntegration === 'bolt')) {
                  _context5.next = 11;
                  break;
                }

                _context5.next = 10;
                return _this25.runWoltBoltActivateFlow({ updateStep: updateStep, finish: finish, confirmMenuValidationOverride: confirmMenuValidationOverride });

              case 10:
                return _context5.abrupt('return');

              case 11:
                if (_this25.isCreateMode) {
                  _context5.next = 14;
                  break;
                }

                if (finish) finish(false);
                return _context5.abrupt('return');

              case 14:
                if (!(_this25.normalizedIntegration !== 'glovo_laas' && _this25.normalizedIntegration !== 'wolt_drive')) {
                  _context5.next = 17;
                  break;
                }

                if (finish) finish(false);
                return _context5.abrupt('return');

              case 17:
                _context5.next = 19;
                return _this25.runSaveAndTestCredentialsFlow({ updateStep: updateStep, finish: finish, isCreate: true });

              case 19:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this25);
      }))();
    },
    validateIntegration: function validateIntegration(_ref8) {
      var _this26 = this;

      var updateStep = _ref8.updateStep,
          finish = _ref8.finish;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var integrationId;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this26.isCreateMode || _this26.isBusy)) {
                  _context6.next = 3;
                  break;
                }

                if (finish) finish(false);
                return _context6.abrupt('return');

              case 3:
                if (_this26.canValidateIntegration) {
                  _context6.next = 6;
                  break;
                }

                if (finish) finish(false);
                return _context6.abrupt('return');

              case 6:
                if (!(_this26.normalizedIntegration === 'delivery_hero' && !_this26.validateDeliveryHeroForm({ requireCredentials: true }))) {
                  _context6.next = 11;
                  break;
                }

                _this26.integrationFormValidationAttempted = true;
                _this26.showValidationErrorSwal();
                if (finish) finish(false);
                return _context6.abrupt('return');

              case 11:
                integrationId = _this26.currentRowId || _this26.formData.id;

                if (integrationId) {
                  _context6.next = 15;
                  break;
                }

                if (finish) finish(false);
                return _context6.abrupt('return');

              case 15:
                _context6.next = 17;
                return _this26.runSaveAndTestCredentialsFlow({ updateStep: updateStep, finish: finish, isCreate: false });

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this26);
      }))();
    },
    onActivationFinished: function onActivationFinished(_ref9) {
      var success = _ref9.success;

      if (success) {
        this.fetchRead();
        return;
      }
      this.fetchRead({ keepEditView: true });
    },
    onValidationFinished: function onValidationFinished(_ref10) {
      var success = _ref10.success;

      if (success) {
        this.fetchRead();
        return;
      }
      this.fetchRead({ keepEditView: true });
    },
    showIntegrationsSwalError: function showIntegrationsSwalError(response) {
      var text = this.getApiResponseMessage(response) || this.$t('gestiune.integrationsSaveError');
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        title: this.$t('general.error'),
        text: text,
        type: 'error',
        timer: 2500,
        showConfirmButton: false
      });
    },
    showIntegrationsSwalSuccess: function showIntegrationsSwalSuccess(response, isUpdate) {
      if (!isUpdate && ['glovo', 'wolt', 'bolt'].includes(this.normalizedIntegration)) {
        __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
          title: this.$t('marketplace.credentialsSavedTitle'),
          text: this.$t(this.normalizedIntegration === 'glovo' ? 'marketplace.credentialsSavedSyncMenu' : 'marketplace.credentialsSavedSyncMenuSchedule'),
          type: 'success',
          showConfirmButton: true,
          confirmButtonText: 'OK'
        });
        return;
      }
      var text = this.getApiResponseMessage(response) || this.$t(isUpdate ? 'gestiune.integrationsUpdateSuccess' : 'gestiune.integrationsCreateSuccess');
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        title: this.$t('general.success'),
        text: text,
        type: 'success',
        timer: 2500,
        showConfirmButton: false
      });
    },
    integrationDisplayLabel: function integrationDisplayLabel(key) {
      var k = normalizeIntegration(key);
      if (!k) return '';
      return this.$t('gestiune.integrationsTypes.' + k);
    },
    integrationFieldLabel: function integrationFieldLabel(key) {
      var k = key === 'locationId' ? 'location_id' : String(key || '');
      if (!k) return '';
      if (k === 'integration_role') return this.$t('marketplace.role');
      if (k === 'type') return this.$t('gestiune.integrationsIntegration');
      if (k === 'created_at') return this.$t('charisma.createDate');
      if (k === 'updated_at') return this.$t('charisma.updateDate');
      if (k === 'location_id') {
        var integration = this.hasIntegrationFilter ? this.normalizedIntegration : null;
        if (integration === 'glovo' || integration === 'bolt' || integration === 'wolt') {
          return this.$t('gestiune.integrationsLocation');
        }
      }
      var i18nKey = 'gestiune.integrationsFields.' + k;
      var translated = this.$t(i18nKey);
      return translated !== i18nKey ? translated : k.replace(/_/g, ' ');
    },
    getLocationId: function getLocationId(loc) {
      return loc && (loc.true_id || loc.id || loc.location_id || loc._id);
    },
    getLocationTrueId: function getLocationTrueId(value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Integrations_integrationLocationHelpers_js__["a" /* resolveLocationTrueId */])(this.flatLocations, value);
    },
    normalizeIntegrationLocationFieldValue: function normalizeIntegrationLocationFieldValue(value) {
      if (value == null || value === '') return null;
      return this.getLocationTrueId(value);
    },
    prettyJson: function prettyJson(v) {
      try {
        if (v === null || v === undefined) return '';
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(v, null, 2);
      } catch (e) {
        return String(v);
      }
    },
    isBooleanField: function isBooleanField(field) {
      return BOOLEAN_FIELDS.has(field);
    },
    isJsonField: function isJsonField(field) {
      return JSON_FIELDS.has(field);
    },
    orderIntegrationTableColumnKeys: function orderIntegrationTableColumnKeys(keys) {
      var list = (Array.isArray(keys) ? keys.slice() : []).filter(function (k) {
        return k !== 'created_at' && k !== 'updated_at';
      });
      var leading = ['id', 'location_id'];
      var ordered = [];
      leading.forEach(function (k) {
        if (list.includes(k) && !ordered.includes(k)) ordered.push(k);
      });
      list.filter(function (k) {
        return !leading.includes(k);
      }).sort(function (a, b) {
        return a.localeCompare(b, undefined, { sensitivity: 'base' });
      }).forEach(function (k) {
        if (!ordered.includes(k)) ordered.push(k);
      });
      return ordered;
    },
    resetState: function resetState() {
      this.readData = null;
      this.formData = {};
      this.formText = {};
      this.readError = '';
      this.isCreateMode = false;
      this.isNoData = false;
      this.hasSearched = false;
      this.activeRowIntegration = null;
      this.page = 1;
      this.integrationsTotalItems = 0;
      this.syncIntegrationsPaginationProps();
      this.integrationListRows = [];
      this.integrationRowsForSharedFields = [];
      this.occupiedLocationIds = [];
    },
    onSelectionChange: function onSelectionChange() {
      this.readData = null;
      this.readError = '';
      this.saveError = '';
      this.isCreateMode = false;
      this.isNoData = false;
      this.activeRowIntegration = null;
      this.page = 1;
      this.integrationsTotalItems = 0;
      this.syncIntegrationsPaginationProps();
      this.formData = {};
      this.formText = {};
      this.integrationListRows = [];
      this.integrationRowsForSharedFields = [];
      this.occupiedLocationIds = [];
      this.resetIntegrationValidationState();

      if (!this.canLoad || this.isBusy) {
        this.hasSearched = false;
        return;
      }

      this.fetchRead();
    },
    buildBaseParams: function buildBaseParams() {
      var p = {
        token: this.$session.get('token'),
        company_id: this.companyId
      };
      if (this.hasIntegrationFilter) {
        p.integration = normalizeIntegration(this.selectedIntegration);
      }
      if (this.selectedLocationId != null && this.selectedLocationId !== '') {
        p.location_id = this.selectedLocationId;
      }
      return p;
    },
    buildReadParamsWithoutLocationFilter: function buildReadParamsWithoutLocationFilter() {
      var p = this.buildBaseParams();
      delete p.location_id;
      return p;
    },
    extractLocationIdsFromIntegrationRows: function extractLocationIdsFromIntegrationRows(rows) {
      var ids = new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a();(rows || []).forEach(function (row) {
        var lid = row && (row.location_id != null ? row.location_id : row.locationId);
        if (lid != null && lid !== '') ids.add(String(lid));
      });
      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from___default()(ids);
    },
    syncOccupiedLocationIdsFromRows: function syncOccupiedLocationIdsFromRows(rows) {
      if (!this.tracksOccupiedLocations) return;
      this.occupiedLocationIds = this.extractLocationIdsFromIntegrationRows(rows);
    },
    getCurrentIntegrationLocationId: function getCurrentIntegrationLocationId() {
      if (this.isCreateMode || !this.readData) return null;
      var fromRead = this.readData.location_id != null ? this.readData.location_id : this.readData.locationId;
      if (fromRead != null && fromRead !== '') return fromRead;
      return null;
    },
    isLocationOccupied: function isLocationOccupied(locationId) {
      if (locationId == null || locationId === '') return false;
      return this.occupiedLocationIdsForSelect.includes(String(locationId));
    },
    clearOccupiedLocationSelection: function clearOccupiedLocationSelection() {
      if (!this.isLocationOccupied(this.formData.location_id)) return;
      this.$set(this.formData, 'location_id', null);
    },
    fetchOccupiedLocationIds: function fetchOccupiedLocationIds() {
      var _this27 = this;

      if (!this.tracksOccupiedLocations || !this.canLoad) {
        this.occupiedLocationIds = [];
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve([]);
      }

      var params = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, this.buildReadParamsWithoutLocationFilter(), {
        page: 1,
        perPage: OCCUPIED_LOCATIONS_FETCH_PER_PAGE
      });
      if (!params.integration && this.normalizedIntegration) {
        params.integration = this.normalizedIntegration;
      }

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this27.apiRequest('/integrations/read', 'GET', params, function (response) {
          if (!response || response.status === false) {
            _this27.occupiedLocationIds = [];
            resolve([]);
            return;
          }
          var list = _this27.normalizeIntegrationsReadToList(response);
          _this27.integrationRowsForSharedFields = list;
          _this27.syncOccupiedLocationIdsFromRows(list);
          resolve(_this27.occupiedLocationIds);
        });
      });
    },
    buildDeleteParams: function buildDeleteParams(row) {
      return {
        token: this.$session.get('token'),
        integration: this.resolveRowIntegration(row) || this.normalizedIntegration,
        company_id: this.companyId
      };
    },
    resolveRowIntegration: function resolveRowIntegration(row) {
      if (!row || (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(row)) !== 'object') return null;
      return normalizeIntegration(row.type || row.integration || row.integration_type || row.integration_key);
    },
    canDeleteIntegrationRow: function canDeleteIntegrationRow(row) {
      var type = this.resolveRowIntegration(row) || this.normalizedIntegration;
      return INTEGRATIONS_WITH_DELETE.has(type);
    },
    hydrateFormFromRead: function hydrateFormFromRead(readPayload) {
      var data = readPayload && (readPayload.data || readPayload) || {};
      this.readData = data;
      var fields = this.getEditableFieldListForSource(data);

      var initial = {};
      var initialText = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(fields), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var f = _step2.value;

          var v = data && Object.prototype.hasOwnProperty.call(data, f) ? data[f] : '';
          if (this.normalizedIntegration === 'wolt' && f === 'schedule') {
            initial[f] = this.normalizeWoltSchedule(v);
          } else if (this.normalizedIntegration === 'bolt' && f === 'schedule') {
            initial[f] = this.normalizeBoltSchedule(v);
          } else if ((this.normalizedIntegration === 'wolt_drive' || this.normalizedIntegration === 'delivery_hero') && f === 'feedback_emails' || this.normalizedIntegration === 'bolt' && f === 'emails') {
            initial[f] = this.normalizeFeedbackEmails(v);
          } else if (this.normalizedIntegration === 'bolt' && f === 'menu_language') {
            initial[f] = v === null || v === undefined || String(v).trim() === '' ? __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["a" /* DEFAULT_BOLT_MENU_LANGUAGE */] : String(v);
          } else if (this.isBooleanField(f)) {
            initial[f] = Boolean(v);
          } else if (this.isJsonField(f) && !(this.normalizedIntegration === 'bolt' && f === 'emails')) {
            initialText[f] = typeof v === 'string' ? v : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(v || null, null, 2);
            initial[f] = v;
          } else if (f === 'menu_top_categories') {
            initial[f] = this.normalizeMenuTopCategories(v);
          } else if (f === 'location_id' || f === 'orders_location_id') {
            initial[f] = v === null || v === undefined || v === '' ? null : this.normalizeIntegrationLocationFieldValue(v);
          } else {
            initial[f] = v === null || v === undefined ? '' : String(v);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.formData = initial;
      this.formText = initialText;
      if (['glovo', 'wolt', 'bolt', 'wolt_drive', 'glovo_laas', 'delivery_hero'].includes(this.normalizedIntegration) && data) {
        this.formData.id = data.id != null ? data.id : data._id != null ? data._id : '';
        if (this.normalizedIntegration === 'glovo' && data.store_active !== undefined && data.store_active !== null) {
          this.formData.store_active = Boolean(data.store_active);
        }
        if (this.normalizedIntegration === 'glovo') {
          this.formData.menu_exports_today = data.menu_exports_today != null ? data.menu_exports_today : 0;
          this.formData.last_menu_export = data.last_menu_export || null;
        }
        if (this.normalizedIntegration === 'delivery_hero') {
          this.$set(this.formData, 'public_key', data.public_key || '');
          this.$set(this.formData, 'status_callback_url', data.status_callback_url || '');
          this.$set(this.formData, 'refund_callback_url', data.refund_callback_url || '');
        }
      }
    },
    hydrateEmptyForm: function hydrateEmptyForm() {
      var initial = {};
      var initialText = {};
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(this.editableFields), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var f = _step3.value;

          if (this.normalizedIntegration === 'wolt' && f === 'schedule') {
            initial[f] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_WoltIntegrationForm_vue__["a" /* defaultWoltSchedule */])();
          } else if (this.normalizedIntegration === 'bolt' && f === 'schedule') {
            initial[f] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["b" /* defaultBoltSchedule */])();
          } else if (this.normalizedIntegration === 'delivery_hero' && f === 'active') {
            initial[f] = true;
          } else if (this.isBooleanField(f)) {
            initial[f] = false;
          } else if (this.isJsonField(f)) {
            initialText[f] = '';
            initial[f] = null;
          } else if (f === 'location_id' && this.selectedLocationId != null && this.selectedLocationId !== '') {
            initial[f] = this.selectedLocationId;
          } else if (f === 'location_id' || f === 'orders_location_id') {
            initial[f] = null;
          } else if (this.normalizedIntegration === 'wolt' && f === 'api_url') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_WoltIntegrationForm_vue__["b" /* DEFAULT_WOLT_API_URL */];
          } else if (this.normalizedIntegration === 'wolt' && f === 'api_key') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_WoltIntegrationForm_vue__["c" /* DEFAULT_WOLT_API_KEY */];
          } else if (this.normalizedIntegration === 'wolt' && f === 'client_id') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_WoltIntegrationForm_vue__["d" /* DEFAULT_WOLT_CLIENT_ID */];
          } else if (this.normalizedIntegration === 'wolt' && f === 'client_secret') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_WoltIntegrationForm_vue__["e" /* DEFAULT_WOLT_CLIENT_SECRET */];
          } else if (this.normalizedIntegration === 'wolt_drive' && f === 'api_url') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Integrations_WoltDriveIntegrationForm_vue__["a" /* DEFAULT_WOLT_DRIVE_API_URL */];
          } else if (this.normalizedIntegration === 'wolt_drive' && f === 'auto_send_at_status') {
            initial[f] = 'MANUAL';
          } else if (this.normalizedIntegration === 'wolt_drive' && f === 'auto_send_time') {
            initial[f] = '30';
          } else if (this.normalizedIntegration === 'wolt_drive' && f === 'order_total_handshake') {
            initial[f] = '150';
          } else if (this.normalizedIntegration === 'delivery_hero' && f === 'api_url') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Integrations_DeliveryHeroIntegrationForm_vue__["a" /* DEFAULT_DELIVERY_HERO_API_URL */];
          } else if (this.normalizedIntegration === 'delivery_hero' && f === 'auto_send_at_status') {
            initial[f] = 'MANUAL';
          } else if (this.normalizedIntegration === 'delivery_hero' && f === 'auto_send_time') {
            initial[f] = '30';
          } else if (this.normalizedIntegration === 'bolt' && f === 'api_url') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["c" /* DEFAULT_BOLT_API_URL */];
          } else if (this.normalizedIntegration === 'bolt' && f === 'secret_key') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["d" /* DEFAULT_BOLT_SECRET_KEY */];
          } else if (this.normalizedIntegration === 'bolt' && f === 'user') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["e" /* DEFAULT_BOLT_USER */];
          } else if (this.normalizedIntegration === 'bolt' && f === 'password') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["f" /* DEFAULT_BOLT_PASSWORD */];
          } else if (this.normalizedIntegration === 'bolt' && f === 'menu_language') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["a" /* DEFAULT_BOLT_MENU_LANGUAGE */];
          } else if (this.normalizedIntegration === 'bolt' && f === 'emails') {
            initial[f] = '';
          } else if (this.normalizedIntegration === 'glovo_laas' && f === 'api_url') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Integrations_GlovoLaasIntegrationForm_vue__["a" /* DEFAULT_GLOVO_LAAS_API_URL */];
          } else if (this.normalizedIntegration === 'glovo_laas' && f === 'pos_implementation_name') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Integrations_GlovoLaasIntegrationForm_vue__["b" /* DEFAULT_GLOVO_LAAS_POS_IMPLEMENTATION_NAME */];
          } else if (this.normalizedIntegration === 'glovo_laas' && f === 'auto_send_at_status') {
            initial[f] = 'MANUAL';
          } else if (this.normalizedIntegration === 'glovo_laas' && f === 'auto_send_time') {
            initial[f] = '30';
          } else if (this.normalizedIntegration === 'glovo' && f === 'api_url') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Integrations_GlovoLaasIntegrationForm_vue__["a" /* DEFAULT_GLOVO_LAAS_API_URL */];
          } else if (this.normalizedIntegration === 'glovo' && f === 'pos_implementation_name') {
            initial[f] = __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Integrations_GlovoLaasIntegrationForm_vue__["b" /* DEFAULT_GLOVO_LAAS_POS_IMPLEMENTATION_NAME */];
          } else if (f === 'menu_top_categories') {
            initial[f] = [];
          } else {
            initial[f] = '';
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.formData = initial;
      this.formText = initialText;
      this.applySharedCompanyFieldsFromExisting();
    },
    getIntegrationCompanySharedFields: function getIntegrationCompanySharedFields() {
      return INTEGRATION_COMPANY_SHARED_FIELDS[this.normalizedIntegration] || [];
    },
    getIntegrationRowsForSharedFieldsLookup: function getIntegrationRowsForSharedFieldsLookup() {
      var _this28 = this;

      var rows = [];
      var seen = new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_set___default.a();
      var addRows = function addRows(list) {
        ;(list || []).forEach(function (row) {
          if (!row || (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(row)) !== 'object') return;
          var rowId = _this28.getIntegrationRowId(row);
          var key = rowId != null ? 'id:' + rowId : 'hash:' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(row);
          if (seen.has(key)) return;
          seen.add(key);
          rows.push(row);
        });
      };
      addRows(this.integrationListRows);
      addRows(this.integrationRowsForSharedFields);
      return rows;
    },
    findIntegrationRowForSharedFields: function findIntegrationRowForSharedFields() {
      var sharedFields = this.getIntegrationCompanySharedFields();
      if (!sharedFields.length) return null;

      var rows = this.getIntegrationRowsForSharedFieldsLookup();
      return rows.find(function (row) {
        return sharedFields.some(function (field) {
          var value = row[field];
          return value != null && String(value).trim() !== '';
        });
      }) || null;
    },
    applySharedCompanyFieldsFromExisting: function applySharedCompanyFieldsFromExisting() {
      var _this29 = this;

      var sharedFields = this.getIntegrationCompanySharedFields();
      if (!sharedFields.length) return;

      var source = this.findIntegrationRowForSharedFields();
      if (!source) return;

      sharedFields.forEach(function (field) {
        if (!Object.prototype.hasOwnProperty.call(source, field)) return;
        var value = source[field];
        if (value == null || String(value).trim() === '') return;
        if (_this29.isBooleanField(field)) {
          _this29.$set(_this29.formData, field, Boolean(value));
          return;
        }
        if (_this29.isJsonField(field)) {
          _this29.$set(_this29.formData, field, value);
          _this29.$set(_this29.formText, field, typeof value === 'string' ? value : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(value || null, null, 2));
          return;
        }
        _this29.$set(_this29.formData, field, String(value));
      });
    },
    fetchIntegrationRowsForSharedFields: function fetchIntegrationRowsForSharedFields() {
      var _this30 = this;

      if (!this.getIntegrationCompanySharedFields().length) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve();
      }
      if (this.findIntegrationRowForSharedFields()) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve();
      }
      if (!this.canLoad || this.integrationsTotalItems === 0) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve();
      }

      var params = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, this.buildReadParamsWithoutLocationFilter(), {
        page: 1,
        perPage: OCCUPIED_LOCATIONS_FETCH_PER_PAGE
      });

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this30.apiRequest('/integrations/read', 'GET', params, function (response) {
          if (!response || response.status === false) {
            resolve();
            return;
          }
          _this30.integrationRowsForSharedFields = _this30.normalizeIntegrationsReadToList(response);
          resolve();
        });
      });
    },
    normalizeMenuTopCategories: function normalizeMenuTopCategories(value) {
      if (!Array.isArray(value)) return [];
      return value.map(function (id) {
        var n = Number(id);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(n) ? id : n;
      }).filter(function (id) {
        return id !== null && id !== undefined && id !== '';
      });
    },
    fetchTopCategories: function fetchTopCategories() {
      var _this31 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.companyId,
        use_sort_order: 'asc'
      };
      this.apiRequest('/topcategory', 'GET', data, function (response) {
        if (response && response.status === true) {
          _this31.topCategories = Array.isArray(response.data) ? response.data : [];
        }
      });
    },
    parseJsonField: function parseJsonField(field) {
      var raw = this.formText[field];
      if (raw === '' || raw === null || raw === undefined) return null;
      if (typeof raw !== 'string') return raw;
      try {
        return JSON.parse(raw);
      } catch (e) {
        return raw;
      }
    },
    buildUpsertBody: function buildUpsertBody() {
      var base = this.buildBaseParams();
      var body = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, base);

      if (this.normalizedIntegration) {
        body.integration = this.normalizedIntegration;
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(this.editableFields), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var f = _step4.value;

          if (INTEGRATION_FIELDS_SKIP_ON_SAVE.has(f)) continue;
          if (this.normalizedIntegration === 'wolt' && f === 'schedule') {
            body[f] = Array.isArray(this.formData.schedule) ? JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.formData.schedule)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_WoltIntegrationForm_vue__["a" /* defaultWoltSchedule */])();
          } else if (this.normalizedIntegration === 'bolt' && f === 'schedule') {
            body[f] = Array.isArray(this.formData.schedule) ? JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.formData.schedule)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["b" /* defaultBoltSchedule */])();
          } else if (this.normalizedIntegration === 'bolt' && f === 'emails') {
            body[f] = this.parseCommaSeparatedEmails(this.formData.emails);
          } else if ((this.normalizedIntegration === 'wolt_drive' || this.normalizedIntegration === 'delivery_hero') && f === 'feedback_emails') {
            body[f] = this.parseCommaSeparatedEmails(this.formData.feedback_emails);
          } else if (f === 'menu_top_categories') {
            body[f] = this.normalizeMenuTopCategories(this.formData.menu_top_categories);
          } else if ((f === 'orders_location_id' || f === 'location_id') && ['glovo', 'wolt', 'bolt'].includes(this.normalizedIntegration)) {
            var val = this.formData[f];
            body[f] = val === '' || val == null ? null : this.getLocationTrueId(val);
          } else if (this.isBooleanField(f)) {
            body[f] = Boolean(this.formData[f]);
          } else if (this.isJsonField(f)) {
            body[f] = this.parseJsonField(f);
          } else {
            var _val = this.formData[f];
            body[f] = _val === '' ? null : _val;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (this.tracksOccupiedLocations && this.occupiedLocationIds.length) {
        body.location_ids = this.occupiedLocationIds.map(function (id) {
          var n = Number(id);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(n) ? id : n;
        });
      }
      if (this.normalizedIntegration === 'bolt') {
        var user = this.formData.user;
        var password = this.formData.password;
        body.user = user === undefined || user === null || String(user).trim() === '' ? __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["e" /* DEFAULT_BOLT_USER */] : user;
        body.password = password === undefined || password === null || String(password).trim() === '' ? __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["f" /* DEFAULT_BOLT_PASSWORD */] : password;
      }
      return body;
    },
    normalizeWoltSchedule: function normalizeWoltSchedule(value) {
      if (Array.isArray(value) && value.length) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(value));
      }
      if (typeof value === 'string' && value.trim()) {
        try {
          var parsed = JSON.parse(value);
          if (Array.isArray(parsed) && parsed.length) return parsed;
        } catch (e) {}
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Integrations_WoltIntegrationForm_vue__["a" /* defaultWoltSchedule */])();
    },
    normalizeBoltSchedule: function normalizeBoltSchedule(value) {
      if (Array.isArray(value) && value.length) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(value));
      }
      if (typeof value === 'string' && value.trim()) {
        try {
          var parsed = JSON.parse(value);
          if (Array.isArray(parsed) && parsed.length) return parsed;
        } catch (e) {}
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Integrations_BoltIntegrationForm_vue__["b" /* defaultBoltSchedule */])();
    },
    parseCommaSeparatedEmails: function parseCommaSeparatedEmails(value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Integrations_integrationEmailHelpers_js__["c" /* parseEmailListInput */])(value);
    },
    getEditableFieldListForSource: function getEditableFieldListForSource(dataObj) {
      if (this.normalizedIntegration === 'wolt') {
        return WOLT_FORM_FIELDS.slice();
      }
      if (this.normalizedIntegration === 'wolt_drive') {
        return WOLT_DRIVE_FORM_FIELDS.slice();
      }
      if (this.normalizedIntegration === 'delivery_hero') {
        return DELIVERY_HERO_FORM_FIELDS.slice();
      }
      if (this.normalizedIntegration === 'bolt') {
        return BOLT_FORM_FIELDS.slice();
      }
      if (this.normalizedIntegration === 'glovo_laas') {
        return GLOVO_LAAS_FORM_FIELDS.slice();
      }
      if (this.normalizedIntegration === 'glovo') {
        return GLOVO_FORM_FIELDS.slice();
      }
      var base = INTEGRATION_FIELDS[this.normalizedIntegration] || [];
      var filtered = base.filter(function (f) {
        return f !== 'company_id' && f !== 'location_id';
      });
      if (!dataObj || (typeof dataObj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(dataObj)) !== 'object') return filtered;
      var extra = [];
      __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_keys___default()(dataObj).forEach(function (k) {
        if (k === 'id' || k === '_id') return;
        if (!filtered.includes(k) && !extra.includes(k)) extra.push(k);
      });
      extra.sort(function (a, b) {
        return a.localeCompare(b, undefined, { sensitivity: 'base' });
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(filtered), extra);
    },
    formatColumnHeaderLabel: function formatColumnHeaderLabel(key) {
      return this.integrationFieldLabel(key);
    },
    integrationColumnMinWidth: function integrationColumnMinWidth(key) {
      var k = String(key || '').toLowerCase();
      if (!this.hasIntegrationFilter) {
        var widths = {
          type: 140,
          id: 80,
          location_id: 180,
          created_at: 160,
          updated_at: 160
        };
        if (widths[k]) return widths[k];
      }
      if (this.normalizedIntegration === 'wolt') {
        var _widths = {
          id: 80,
          location_id: 160,
          is_menu_location: 130,
          is_using_pricelist: 150,
          active: 90,
          created_at: 160,
          updated_at: 160
        };
        if (_widths[k]) return _widths[k];
      }
      if (this.normalizedIntegration === 'wolt_drive') {
        var _widths2 = {
          id: 80,
          location_id: 160,
          auto_send_at_status: 150,
          active: 90,
          created_at: 160,
          updated_at: 160
        };
        if (_widths2[k]) return _widths2[k];
      }
      if (this.normalizedIntegration === 'delivery_hero') {
        var _widths3 = {
          id: 80,
          location_id: 160,
          auto_send_at_status: 150,
          active: 90,
          created_at: 160,
          updated_at: 160
        };
        if (_widths3[k]) return _widths3[k];
      }
      if (this.normalizedIntegration === 'bolt') {
        var _widths4 = {
          id: 80,
          location_id: 160,
          is_menu_location: 130,
          is_using_pricelist: 150,
          active: 90,
          created_at: 160,
          updated_at: 160
        };
        if (_widths4[k]) return _widths4[k];
      }
      if (this.normalizedIntegration === 'glovo_laas') {
        var _widths5 = {
          id: 80,
          location_id: 160,
          auto_send_at_status: 150,
          auto_send_time: 120,
          created_at: 160,
          updated_at: 160
        };
        if (_widths5[k]) return _widths5[k];
      }
      if (this.normalizedIntegration === 'glovo') {
        var _widths6 = {
          id: 80,
          location_id: 160,
          is_menu_location: 130,
          is_using_pricelist: 150,
          active: 90,
          created_at: 160,
          updated_at: 160
        };
        if (_widths6[k]) return _widths6[k];
      }
      if (k.includes('token') || k.includes('url') || k.includes('secret') || k.includes('password')) return 180;
      if (k === 'id' || k === '_id') return 80;
      if (k === 'created_at' || k === 'updated_at') return 160;
      if (k.includes('email') || k.includes('webhook')) return 160;
      return 120;
    },
    formatIntegrationDateTime: function formatIntegrationDateTime(value) {
      if (value == null || value === '') return '—';
      try {
        return this.formatToCompanyTimezone(String(value), this.companyTimezone);
      } catch (e) {
        return String(value);
      }
    },
    formatIntegrationTableCell: function formatIntegrationTableCell(key, value, row) {
      if (key === 'integration_role') {
        var platform = this.resolveRowIntegration(row) || this.normalizedIntegration;
        if (!['glovo', 'wolt', 'bolt'].includes(platform)) return '—';
        var role = value || (row.is_using_pricelist ? 'menu_orders' : row.is_menu_location ? 'menu' : 'orders');
        return this.$t('marketplace.' + role);
      }
      if (key === 'type') {
        var type = value != null && value !== '' ? value : this.resolveRowIntegration(row);
        return this.integrationDisplayLabel(type) || (type ? String(type) : '—');
      }
      if (key === 'id') {
        var id = value != null && value !== '' ? value : row && (row.id != null ? row.id : row._id);
        if (id == null || id === '') return '—';
        return String(id);
      }
      if (key === 'location_id' || key === 'locationId' || key === 'orders_location_id') {
        var locationId = key === 'orders_location_id' ? value : null;
        return this.locationNameForIntegrationRow(row, locationId);
      }
      if (key === 'auto_send_at_status' && (this.normalizedIntegration === 'wolt_drive' || this.normalizedIntegration === 'glovo_laas' || this.normalizedIntegration === 'delivery_hero')) {
        return this.formatWoltDriveAutoSendStatus(value);
      }
      if (key === 'created_at' || key === 'updated_at') {
        return this.formatIntegrationDateTime(value);
      }
      var v = value;
      if (key === 'active' && (v === null || v === undefined) && row && row.store_active !== undefined && row.store_active !== null) {
        v = row.store_active;
      }
      if (BOOLEAN_FIELDS.has(key) || typeof v === 'boolean') {
        if (v === null || v === undefined) return '—';
        return v ? this.$t('general.yes') : this.$t('general.no');
      }
      if (v === null || v === undefined) return '—';
      if ((typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(v)) === 'object') {
        try {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(v);
        } catch (e) {
          return String(v);
        }
      }
      return String(v);
    },
    normalizeIntegrationsReadToList: function normalizeIntegrationsReadToList(response) {
      var _this32 = this;

      var raw = response && (response.data !== undefined && response.data !== null ? response.data : response);
      var list = [];
      if (Array.isArray(raw)) list = raw;else if (raw && Array.isArray(raw.data)) list = raw.data;else if (raw && Array.isArray(raw.rows)) list = raw.rows;else if (raw && Array.isArray(raw.items)) list = raw.items;else if (raw && (typeof raw === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(raw)) === 'object' && (raw.id || raw._id)) list = [raw];else list = [];

      return list.map(function (row, index) {
        if (!row || (typeof row === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(row)) !== 'object' || Array.isArray(row)) return row;
        var id = row.id != null ? row.id : row._id;
        var type = _this32.resolveRowIntegration(row) || '';
        var active = row.active != null ? Boolean(row.active) : row.store_active != null ? Boolean(row.store_active) : undefined;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, row, active !== undefined ? { active: active } : {}, {
          _rowKey: [type, id, index].filter(function (v) {
            return v !== '' && v != null;
          }).join('-')
        });
      });
    },
    extractIntegrationsPaginationTotal: function extractIntegrationsPaginationTotal(response, listLength) {
      var pag = response && response.pagination || response && response.data && response.data.pagination || {};
      var candidates = [pag.total, pag.total_count, pag.totalCount, response && response.total, response && response.data && response.data.total, response && response.data && response.data.total_count];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_get_iterator___default()(candidates), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var n = _step5.value;

          if (n != null && n !== '' && !isNaN(Number(n))) {
            return Number(n);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      if (listLength < this.perPage) {
        return (this.page - 1) * this.perPage + listLength;
      }
      return this.page * this.perPage + 1;
    },
    integrationsPaginationChanged: function integrationsPaginationChanged(query) {
      if (!this.hasSearched) return;
      if (!this.canLoad || this.isBusy) return;
      if (query.type !== 'page' && query.type !== 'size') return;
      var nextPage = query.page || 1;
      var nextPerPage = query.pageSize || this.perPage;
      if (nextPage === this.page && nextPerPage === this.perPage) return;
      this.page = nextPage;
      this.perPage = nextPerPage;
      this.fetchRead();
    },
    syncIntegrationsPaginationProps: function syncIntegrationsPaginationProps() {
      this.integrationsPaginationProps = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, this.integrationsPaginationProps, {
        currentPage: this.page,
        pageSize: this.perPage
      });
    },
    locationNameForIntegrationRow: function locationNameForIntegrationRow(row, locationIdOverride) {
      var id = locationIdOverride != null && locationIdOverride !== '' ? locationIdOverride : row && (row.location_id != null ? row.location_id : row.locationId);
      if (id == null || id === '') return '—';
      var loc = this.flatLocations.find(function (l) {
        var candidates = [l._integrationLocationId, l.true_id, l.id, l.location_id, l._id];
        return candidates.some(function (v) {
          return v != null && v !== '' && String(v) === String(id);
        });
      });
      return loc && loc.name ? loc.name : String(id);
    },
    refreshIntegrationRead: function refreshIntegrationRead() {
      var _this33 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var currentId, currentType, ok, row;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                currentId = _this33.currentRowId || _this33.formData && _this33.formData.id;

                if (!(!currentId || !_this33.canLoad)) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt('return');

              case 3:
                currentType = _this33.normalizedIntegration;
                _context7.next = 6;
                return _this33.fetchRead({ keepEditView: true });

              case 6:
                ok = _context7.sent;

                if (ok) {
                  _context7.next = 9;
                  break;
                }

                return _context7.abrupt('return');

              case 9:
                row = _this33.integrationListRows.find(function (r) {
                  if (String(_this33.getIntegrationRowId(r)) !== String(currentId)) return false;
                  if (!currentType) return true;
                  return _this33.resolveRowIntegration(r) === currentType;
                });

                if (row) {
                  _this33.hydrateFormFromRead({ data: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, row) });
                }

              case 11:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this33);
      }))();
    },
    handleIntegrationTableClick: function handleIntegrationTableClick(event) {
      if (this.isBusy || !this.hasSearched) return;
      var target = event.target;
      if (!target || !target.closest || target.closest('a, button, input, .el-dropdown, .el-switch, .arrow-box')) return;
      var element = target.closest('.el-table__body-wrapper tr.el-table__row');
      if (!element) return;
      var index = Array.prototype.indexOf.call(element.parentNode.children, element);
      var row = this.integrationsTableRows[index];
      if (row) this.openIntegrationListRow(row);
    },
    openIntegrationListRow: function openIntegrationListRow(row) {
      var _this34 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var copy, rowIntegration;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                copy = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, row);

                delete copy._rowKey;
                if (copy.menu_row_id && copy.menu_location_id) {
                  copy.id = copy.menu_row_id;
                  copy.location_id = copy.menu_location_id;
                }
                rowIntegration = _this34.resolveRowIntegration(copy);

                _this34.activeRowIntegration = rowIntegration || null;

                if (_this34.normalizedIntegration) {
                  _context8.next = 8;
                  break;
                }

                _this34.activeRowIntegration = null;
                return _context8.abrupt('return');

              case 8:
                _this34.resetIntegrationValidationState();
                _this34.isCreateMode = false;
                _this34.isNoData = false;

                if (!_this34.tracksOccupiedLocations) {
                  _context8.next = 14;
                  break;
                }

                _context8.next = 14;
                return _this34.fetchOccupiedLocationIds();

              case 14:
                _this34.hydrateFormFromRead({ data: copy });

              case 15:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this34);
      }))();
    },
    getIntegrationRowId: function getIntegrationRowId(row) {
      if (!row) return null;
      var id = row.id != null ? row.id : row._id;
      return id != null && id !== '' ? id : null;
    },
    getIntegrationRowActive: function getIntegrationRowActive(row) {
      if (!row) return false;
      if (row.active != null) return Boolean(row.active);
      if (row.store_active != null) return Boolean(row.store_active);
      return false;
    },
    setIntegrationRowActive: function setIntegrationRowActive(row, value) {
      if (!row) return;
      var next = Boolean(value);
      if (Object.prototype.hasOwnProperty.call(row, 'store_active') && !Object.prototype.hasOwnProperty.call(row, 'active')) {
        this.$set(row, 'store_active', next);
        return;
      }
      this.$set(row, 'active', next);
      if (Object.prototype.hasOwnProperty.call(row, 'store_active')) {
        this.$set(row, 'store_active', next);
      }
    },
    integrationRowClassName: function integrationRowClassName(_ref11) {
      var row = _ref11.row;

      return this.getIntegrationRowActive(row) ? 'highlight-row' : '';
    },
    handleIntegrationActiveToggle: function handleIntegrationActiveToggle(row, value) {
      var _this35 = this;

      var rowId = this.getIntegrationRowId(row);
      var integration = this.resolveRowIntegration(row) || this.normalizedIntegration;
      if (!rowId || !integration || this.isBusy) {
        this.setIntegrationRowActive(row, !value);
        return;
      }

      var previous = !value;
      this.setIntegrationRowActive(row, value);

      var actionText = value ? this.$t('general.activate') : this.$t('general.deactivate');
      var label = this.locationNameForIntegrationRow(row);
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + label + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.cancel2')
      }).then(function (result) {
        if (!result) {
          _this35.setIntegrationRowActive(row, previous);
          return;
        }

        var body = {
          token: _this35.$session.get('token'),
          company_id: _this35.companyId,
          integration: integration
        };
        if (integration === 'glovo') {
          body.store_active = Boolean(value);
        } else {
          body.active = Boolean(value);
        }
        var locationId = row.location_id != null ? row.location_id : row.locationId;
        if (locationId != null && locationId !== '') {
          body.location_id = locationId;
        }

        _this35.apiRequest('/integrations/' + rowId, 'PUT', body, function (response) {
          if (!response || response.status === false) {
            _this35.setIntegrationRowActive(row, previous);
            _this35.showIntegrationsSwalError(response || { message: _this35.$t('validations.wentWrong') });
            return;
          }
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
            title: _this35.$t('general.success'),
            text: _this35.getApiResponseMessage(response) || '',
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          });
        });
      }).catch(function () {
        _this35.setIntegrationRowActive(row, previous);
      });
    },
    handleDeleteFromForm: function handleDeleteFromForm() {
      var row = this.readData ? __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, this.readData) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, this.formData, { id: this.currentRowId || this.formData.id });
      this.handleDeleteIntegration(row);
    },
    handleDeleteIntegration: function handleDeleteIntegration(row) {
      var _this36 = this;

      var rowId = this.getIntegrationRowId(row);
      if (!rowId || this.isBusy || !this.canDeleteIntegrationRow(row)) return;

      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: this.$t('gestiune.integrationsDeleteConfirm'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.cancel2')
      }).then(function (result) {
        if (!result) return;

        _this36.saving = true;
        _this36.loading = true;
        var params = _this36.buildDeleteParams(row);

        _this36.apiRequest('/integrations/' + rowId, 'DELETE', params, function () {
          var _ref12 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9(response) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    _this36.saving = false;
                    _this36.loading = false;

                    if (!(!response || response.status === false)) {
                      _context9.next = 5;
                      break;
                    }

                    _this36.showIntegrationsSwalError(response || { message: _this36.$t('gestiune.integrationsDeleteError') });
                    return _context9.abrupt('return');

                  case 5:
                    _this36.trackAdminEvent('ADMIN_INTEGRATION_DELETED', 'integration', rowId, {
                      integration_id: rowId,
                      type: row && row.type || null,
                      location_id: row && row.location_id || null,
                      request: params,
                      response: response
                    });
                    __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
                      title: _this36.$t('general.success'),
                      text: _this36.getApiResponseMessage(response) || _this36.$t('gestiune.integrationsDeleteSuccess'),
                      type: 'success',
                      timer: 2500,
                      showConfirmButton: false
                    });
                    if (_this36.currentRowId != null && String(_this36.currentRowId) === String(rowId)) {
                      _this36.closeIntegrationListEdit();
                    }
                    _context9.next = 10;
                    return _this36.fetchRead();

                  case 10:
                  case 'end':
                    return _context9.stop();
                }
              }
            }, _callee9, _this36);
          }));

          return function (_x4) {
            return _ref12.apply(this, arguments);
          };
        }());
      }).catch(function () {});
    },
    closeIntegrationListEdit: function closeIntegrationListEdit() {
      this.readData = null;
      this.formData = {};
      this.formText = {};
      this.isCreateMode = false;
      this.activeRowIntegration = null;
      this.occupiedLocationIds = [];
      this.resetIntegrationValidationState();
    },
    onSearch: function onSearch() {
      if (!this.canLoad || this.isBusy) return;
      this.page = 1;
      this.syncIntegrationsPaginationProps();
      this.fetchRead();
    },
    fetchRead: function fetchRead() {
      var _this37 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var keepEditView = options.keepEditView === true;
      this.readError = '';
      var params = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, this.buildBaseParams(), {
        page: this.page,
        perPage: this.perPage
      });
      if (!keepEditView) {
        this.loading = true;
      }

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this37.apiRequest('/integrations/read', 'GET', params, function (response) {
          if (!keepEditView) {
            _this37.loading = false;
          }
          _this37.hasSearched = true;
          if (!response || response.status === false) {
            if (!keepEditView) {
              _this37.readError = response && (response.message || response.error && response.error.message) || 'Failed to load integration data.';
              _this37.readData = null;
              _this37.formData = {};
              _this37.formText = {};
              _this37.integrationListRows = [];
              _this37.integrationsTotalItems = 0;
              _this37.isNoData = true;
              _this37.isCreateMode = false;
            }
            resolve(false);
            return;
          }
          var list = _this37.normalizeIntegrationsReadToList(response);
          _this37.integrationListRows = list;
          _this37.syncOccupiedLocationIdsFromRows(list);
          _this37.integrationsTotalItems = _this37.extractIntegrationsPaginationTotal(response, list.length);
          var pag = response.pagination || response.data && response.data.pagination;
          if (pag) {
            if (pag.page != null && !isNaN(Number(pag.page))) {
              _this37.page = Number(pag.page);
            }
            if (pag.perPage != null && !isNaN(Number(pag.perPage))) {
              _this37.perPage = Number(pag.perPage);
            }
          }
          _this37.syncIntegrationsPaginationProps();
          if (!keepEditView) {
            _this37.readData = null;
            _this37.formData = {};
            _this37.formText = {};
            _this37.isCreateMode = false;
          }
          _this37.isNoData = _this37.integrationsTotalItems === 0;
          resolve(true);
        });
      });
    },
    startCreate: function startCreate() {
      var _this38 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (_this38.hasIntegrationFilter) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt('return');

              case 2:
                _this38.activeRowIntegration = null;
                _this38.isCreateMode = true;
                _this38.readData = null;
                _this38.resetIntegrationValidationState();

                if (!_this38.tracksOccupiedLocations) {
                  _context10.next = 11;
                  break;
                }

                _context10.next = 9;
                return _this38.fetchOccupiedLocationIds();

              case 9:
                _context10.next = 12;
                break;

              case 11:
                _this38.occupiedLocationIds = [];

              case 12:
                _context10.next = 14;
                return _this38.fetchIntegrationRowsForSharedFields();

              case 14:
                _this38.hydrateEmptyForm();
                _this38.clearOccupiedLocationSelection();

              case 16:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this38);
      }))();
    },
    showValidationErrorSwal: function showValidationErrorSwal() {
      var errors = this.normalizedIntegration === 'wolt_drive' ? this.woltDriveValidationErrors : this.normalizedIntegration === 'delivery_hero' ? this.deliveryHeroValidationErrors : this.normalizedIntegration === 'bolt' ? this.boltValidationErrors : {};
      var messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(errors || {});
      var text = messages.includes(this.$t('validations.invalidEnteredData')) ? this.$t('validations.invalidEnteredData') : this.$t('validations.requiredField');

      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        title: this.$t('general.error'),
        text: text,
        type: 'error',
        timer: 2500,
        showConfirmButton: false
      });
    },
    validateIntegrationFormForSave: function validateIntegrationFormForSave() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.integrationFormValidationAttempted = true;
      if (this.normalizedIntegration === 'wolt' && !this.validateWoltForm()) {
        return false;
      }
      if (this.normalizedIntegration === 'wolt_drive' && !this.validateWoltDriveForm()) {
        return false;
      }
      if (this.normalizedIntegration === 'delivery_hero' && !this.validateDeliveryHeroForm({
        requireCredentials: options.requireCredentials === true
      })) {
        return false;
      }
      if (this.normalizedIntegration === 'bolt' && !this.validateBoltForm()) {
        return false;
      }
      if (this.normalizedIntegration === 'glovo_laas' && !this.validateGlovoLaasForm()) {
        return false;
      }
      if (this.normalizedIntegration === 'glovo' && !this.validateGlovoForm()) {
        return false;
      }
      return true;
    },
    save: function save() {
      var _this39 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var silent = options.silent === true;
      var activationFlow = options.activationFlow === true;
      var skipFetchRead = options.skipFetchRead === true;
      var requireCredentials = options.requireCredentials === true;
      var keepEditAfterCreate = options.keepEditAfterCreate === true;

      if (!this.canSave) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve({ ok: false, message: this.$t('gestiune.integrationsSaveError') });
      }
      if (this.isNoData && !this.isCreateMode) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve({ ok: false, message: this.$t('gestiune.integrationsSaveError') });
      }
      if (this.isBusy) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve({ ok: false, message: this.$t('gestiune.integrationsSaveError') });
      }
      if (!this.validateIntegrationFormForSave({ requireCredentials: requireCredentials })) {
        if (!silent) this.showValidationErrorSwal();
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve({ ok: false, message: this.$t('validations.requiredField') });
      }

      var body = this.buildUpsertBody();
      var isUpdate = Boolean(this.currentRowId) && !this.isCreateMode;
      var wasCreate = this.isCreateMode;
      var url = isUpdate ? '/integrations/' + this.currentRowId : '/integrations/upsert';
      var method = isUpdate ? 'PUT' : 'POST';

      this.saving = true;
      if (!activationFlow) {
        this.loading = true;
      }

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this39.apiRequest(url, method, body, function () {
          var _ref13 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11(response) {
            var message, integrationId, marketplaceCreated, stayOnForm, raw, saved, row;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    _this39.saving = false;
                    if (!activationFlow) {
                      _this39.loading = false;
                    }

                    if (!(!response || response.status === false)) {
                      _context11.next = 7;
                      break;
                    }

                    message = _this39.getApiResponseMessage(response) || _this39.$t('gestiune.integrationsSaveError');

                    if (!silent) _this39.showIntegrationsSwalError(response);
                    resolve({ ok: false, message: message, response: response });
                    return _context11.abrupt('return');

                  case 7:
                    integrationId = _this39.extractIntegrationIdFromResponse(response) || _this39.currentRowId;

                    if (integrationId != null) {
                      _this39.$set(_this39.formData, 'id', integrationId);
                      if (!_this39.readData) {
                        _this39.readData = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, _this39.formData, { id: integrationId });
                      } else {
                        _this39.$set(_this39.readData, 'id', integrationId);
                      }
                    }

                    _this39.applyDeliveryHeroExtrasFromResponse(response);

                    if (!silent) {
                      _this39.showIntegrationsSwalSuccess(response, isUpdate);
                    }

                    marketplaceCreated = wasCreate && ['glovo', 'wolt', 'bolt'].includes(_this39.normalizedIntegration);
                    stayOnForm = keepEditAfterCreate || marketplaceCreated || wasCreate && _this39.normalizedIntegration === 'delivery_hero';

                    if (!stayOnForm) {
                      _context11.next = 23;
                      break;
                    }

                    _this39.isCreateMode = false;

                    if (marketplaceCreated) {
                      raw = response.data || response;
                      saved = raw.data || raw;

                      _this39.hydrateFormFromRead({ data: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, _this39.formData, saved.config || {}, { id: integrationId }) });
                    }
                    _context11.next = 18;
                    return _this39.fetchRead({ keepEditView: true });

                  case 18:
                    if (marketplaceCreated) _this39.isNoData = false;
                    row = _this39.integrationListRows.find(function (r) {
                      return String(_this39.getIntegrationRowId(r)) === String(integrationId);
                    });

                    if (row) {
                      _this39.hydrateFormFromRead({ data: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, row) });
                    }
                    _context11.next = 26;
                    break;

                  case 23:
                    if (skipFetchRead) {
                      _context11.next = 26;
                      break;
                    }

                    _context11.next = 26;
                    return _this39.fetchRead();

                  case 26:
                    resolve({
                      ok: true,
                      id: integrationId,
                      response: response,
                      isUpdate: isUpdate
                    });

                  case 27:
                  case 'end':
                    return _context11.stop();
                }
              }
            }, _callee11, _this39);
          }));

          return function (_x8) {
            return _ref13.apply(this, arguments);
          };
        }());
      });
    },
    applyDeliveryHeroExtrasFromResponse: function applyDeliveryHeroExtrasFromResponse(response) {
      if (this.normalizedIntegration !== 'delivery_hero' || !response) return;
      var raw = response.data !== undefined && response.data !== null ? response.data : response;
      var config = raw && raw.config || raw || {};
      if (config.public_key) {
        this.$set(this.formData, 'public_key', config.public_key);
      }
      if (config.status_callback_url) {
        this.$set(this.formData, 'status_callback_url', config.status_callback_url);
      }
      if (config.refund_callback_url) {
        this.$set(this.formData, 'refund_callback_url', config.refund_callback_url);
      }
    },
    regenerateDeliveryHeroKeys: function regenerateDeliveryHeroKeys() {
      var _this40 = this;

      var integrationId = this.currentRowId || this.formData.id;
      if (!integrationId || this.isBusy || this.regeneratingDeliveryHeroKeys) return;

      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: this.$t('gestiune.integrationsDeliveryHeroRegenerateKeysConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.cancel2')
      }).then(function (result) {
        if (!result) return;

        _this40.regeneratingDeliveryHeroKeys = true;
        _this40.loading = true;
        var payload = {
          token: _this40.$session.get('token'),
          company_id: _this40.companyId
        };
        _this40.apiRequest('/integrations/delivery-hero/' + integrationId + '/regenerate-keys', 'POST', payload, function (response) {
          _this40.regeneratingDeliveryHeroKeys = false;
          _this40.loading = false;
          if (!response || response.status === false) {
            _this40.showIntegrationsSwalError(response);
            return;
          }
          var data = response.data && (response.data.data || response.data) || response.data || {};
          if (data.public_key) {
            _this40.$set(_this40.formData, 'public_key', data.public_key);
          }
          if (data.status_callback_url) {
            _this40.$set(_this40.formData, 'status_callback_url', data.status_callback_url);
          }
          if (data.refund_callback_url) {
            _this40.$set(_this40.formData, 'refund_callback_url', data.refund_callback_url);
          }
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
            title: _this40.$t('general.success'),
            text: _this40.$t('gestiune.integrationsDeliveryHeroRegenerateKeysSuccess'),
            type: 'success',
            timer: 2500,
            showConfirmButton: false
          });
        });
      });
    },
    saveUpsertById: function saveUpsertById() {
      var _this41 = this;

      if (!this.currentRowId) return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve(false);

      this.saving = true;
      var body = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, this.buildUpsertBody(), { id: this.currentRowId });

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this41.apiRequest('/integrations/upsert', 'POST', body, function () {
          var _ref14 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12(response) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    _this41.saving = false;

                    if (!(!response || response.status === false)) {
                      _context12.next = 5;
                      break;
                    }

                    _this41.showIntegrationsSwalError(response);
                    resolve(false);
                    return _context12.abrupt('return');

                  case 5:
                    _this41.showIntegrationsSwalSuccess(response, true);
                    _context12.next = 8;
                    return _this41.fetchRead();

                  case 8:
                    resolve(true);

                  case 9:
                  case 'end':
                    return _context12.stop();
                }
              }
            }, _callee12, _this41);
          }));

          return function (_x9) {
            return _ref14.apply(this, arguments);
          };
        }());
      });
    },
    savePutById: function savePutById() {
      var _this42 = this;

      if (!this.currentRowId) return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve(false);

      this.saving = true;
      var body = this.buildUpsertBody();

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this42.apiRequest('/integrations/' + _this42.currentRowId, 'PUT', body, function () {
          var _ref15 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee13(response) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    _this42.saving = false;

                    if (!(!response || response.status === false)) {
                      _context13.next = 5;
                      break;
                    }

                    _this42.showIntegrationsSwalError(response);
                    resolve(false);
                    return _context13.abrupt('return');

                  case 5:
                    _this42.showIntegrationsSwalSuccess(response, true);
                    _context13.next = 8;
                    return _this42.fetchRead();

                  case 8:
                    resolve(true);

                  case 9:
                  case 'end':
                    return _context13.stop();
                }
              }
            }, _callee13, _this42);
          }));

          return function (_x10) {
            return _ref15.apply(this, arguments);
          };
        }());
      });
    }
  }
});

/***/ }),

/***/ "oMhr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.section === 'general'),expression:"section === 'general'"}]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.name'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"255","placeholder":_vm.$t('menuSubscriptions.namePlaceholder')},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.name)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.active')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-switch',{attrs:{"type":"success","disabled":!_vm.subscriptionId},model:{value:(_vm.form.active),callback:function ($$v) {_vm.$set(_vm.form, "active", $$v)},expression:"form.active"}}),_vm._v(" "),(!_vm.subscriptionId)?_c('small',{staticClass:"text-muted msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.activeAfterMenus')))]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.location'))+"*")]),_vm._v(" "),_c('el-select',{staticClass:"w-100",attrs:{"filterable":"","placeholder":_vm.$t('menuSubscriptions.locationPlaceholder')},on:{"change":_vm.onLocationChange},model:{value:(_vm.form.location_id),callback:function ($$v) {_vm.$set(_vm.form, "location_id", $$v)},expression:"form.location_id"}},_vm._l((_vm.locations),function(location){return _c('el-option',{key:location.id,attrs:{"label":location.name,"value":location.id}})})),_vm._v(" "),_c('small',{staticClass:"text-muted msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.locationHint')))]),_vm._v(" "),(_vm.errors.location_id)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.location_id))]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.pricePerDay'))+"* "),_c('small',{staticClass:"text-muted"},[_vm._v("("+_vm._s(_vm.currency)+")")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.price_per_day),expression:"form.price_per_day"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.01"},domProps:{"value":(_vm.form.price_per_day)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "price_per_day", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.pricePerDayHint')))]),_vm._v(" "),(_vm.errors.price_per_day)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.price_per_day))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.duration'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.duration_days),expression:"form.duration_days"}],staticClass:"form-control msub-duration-input",attrs:{"type":"number","min":"1","max":"366","step":"1"},domProps:{"value":(_vm.form.duration_days)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "duration_days", $event.target.value)}}}),_vm._v(" "),(_vm.errors.duration_days)?_c('small',{staticClass:"text-danger msub-block"},[_vm._v(_vm._s(_vm.errors.duration_days))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"msub-note"},[_c('div',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.durationHint', { days: _vm.maxStartDaysAhead })))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.durationWeekendHint')))]),_vm._v(" "),(_vm.deliveryEstimate)?_c('div',{staticClass:"msub-note__estimate"},[_c('i',{staticClass:"fa fa-calendar-check-o"}),_vm._v("\n                    "+_vm._s(_vm.$t('menuSubscriptions.durationEstimate', { range: _vm.deliveryEstimate, days: _vm.form.duration_days }))+"\n                  ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.maxSubscribers')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.max_active_subscribers),expression:"form.max_active_subscribers"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"1","placeholder":_vm.$t('menuSubscriptions.unlimited')},domProps:{"value":(_vm.form.max_active_subscribers)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "max_active_subscribers", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.maxSubscribersHint')))]),_vm._v(" "),(_vm.errors.max_active_subscribers)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.max_active_subscribers))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.minQuantity')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.min_quantity),expression:"form.min_quantity"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"50","step":"1"},domProps:{"value":(_vm.form.min_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "min_quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.maxQuantity')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.max_quantity),expression:"form.max_quantity"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"50","step":"1"},domProps:{"value":(_vm.form.max_quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "max_quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('small',{staticClass:"text-muted msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.quantityHint')))]),_vm._v(" "),(_vm.errors.quantity)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.quantity))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group msub-mt"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.description')))]),_vm._v(" "),(_vm.loaded)?_c('wysiwyg',{staticClass:"form-control msub-editor",attrs:{"options":_vm.editorOptions},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.image'))+" "),_c('small',{staticClass:"text-muted"},[_vm._v("("+_vm._s(_vm.$t('menuSubscriptions.imageHint'))+")")])]),_vm._v(" "),_c('el-upload',{attrs:{"action":"","list-type":"picture-card","accept":".jpg,.jpeg,.png","file-list":_vm.form.imagelist,"limit":1,"auto-upload":false,"on-change":_vm.handleImageChange,"on-remove":_vm.handleImageRemove,"on-exceed":_vm.handleExceed}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}})]),_vm._v(" "),(_vm.errors.image)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.image))]):_vm._e()],1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.section === 'delivery'),expression:"section === 'delivery'"}]},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.deliveryDays'))+"*")]),_vm._v(" "),_c('div',{staticClass:"msub-days"},_vm._l((_vm.dayNames),function(day){return _c('label',{key:day,staticClass:"msub-day",class:{ 'is-checked': _vm.form.delivery_days.indexOf(day) !== -1 }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.delivery_days),expression:"form.delivery_days"}],attrs:{"type":"checkbox"},domProps:{"value":day,"checked":Array.isArray(_vm.form.delivery_days)?_vm._i(_vm.form.delivery_days,day)>-1:(_vm.form.delivery_days)},on:{"change":function($event){var $$a=_vm.form.delivery_days,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "delivery_days", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "delivery_days", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "delivery_days", $$c)}}}}),_vm._v(" "+_vm._s(_vm.$t('days.' + day))+"\n          ")])})),_vm._v(" "),_c('small',{staticClass:"text-muted msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.deliveryDaysHint')))]),_vm._v(" "),(_vm.errors.delivery_days)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.delivery_days))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.deliveryHours'))+"*")]),_vm._v(" "),_vm._l((_vm.form.delivery_hours),function(interval,index){return _c('div',{key:'hour' + index,staticClass:"msub-hour"},[_c('el-time-select',{attrs:{"picker-options":_vm.pickerFrom,"placeholder":_vm.$t('menuSubscriptions.from')},model:{value:(interval.from),callback:function ($$v) {_vm.$set(interval, "from", $$v)},expression:"interval.from"}}),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('el-time-select',{attrs:{"picker-options":_vm.pickerTo,"placeholder":_vm.$t('menuSubscriptions.to')},model:{value:(interval.to),callback:function ($$v) {_vm.$set(interval, "to", $$v)},expression:"interval.to"}}),_vm._v(" "),_c('a',{staticClass:"msub-icon msub-icon--danger",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.form.delivery_hours.splice(index, 1)}}},[_c('i',{staticClass:"fa fa-trash-o"})])],1)}),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-default",on:{"click":_vm.addHour}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('menuSubscriptions.addInterval')))]),_vm._v(" "),_c('small',{staticClass:"text-muted msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.deliveryHoursHint')))]),_vm._v(" "),(_vm.errors.delivery_hours)?_c('small',{staticClass:"text-danger msub-block"},[_vm._v(_vm._s(_vm.errors.delivery_hours))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.orderLead'))+"*")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.order_lead_minutes),expression:"form.order_lead_minutes"}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"2880","step":"5"},domProps:{"value":(_vm.form.order_lead_minutes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "order_lead_minutes", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.minutes')))])]),_vm._v(" "),(_vm.errors.order_lead_minutes)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.order_lead_minutes))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('p',{staticClass:"text-muted msub-lead-hint"},[_vm._v(_vm._s(_vm.orderLeadHint))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.zones'))+"*")]),_vm._v(" "),(!_vm.form.location_id)?_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.zonesPickLocation')))]):(!_vm.zones.length)?_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.noZones')))]):_c('div',{staticClass:"msub-zones"},[_c('div',{staticClass:"msub-zone msub-zone--head"},[_c('span'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.zone')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.zoneDefaultFee')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('menuSubscriptions.zoneFee')))])]),_vm._v(" "),_vm._l((_vm.zones),function(zone){return _c('div',{key:'zone' + zone.id,staticClass:"msub-zone",class:{ 'is-checked': _vm.isZoneSelected(zone.id) }},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isZoneSelected(zone.id)},on:{"change":function($event){_vm.toggleZone(zone)}}}),_vm._v(" "),_c('span',{staticClass:"msub-zone__name",on:{"click":function($event){_vm.toggleZone(zone)}}},[_vm._v("\n              "+_vm._s(zone.name)+"\n              "),_c('small',{staticClass:"text-muted"},[_vm._v("· "+_vm._s(zone.company_zone ? _vm.$t('menuSubscriptions.companyZone') : _vm.$t('menuSubscriptions.locationZone')))]),_vm._v(" "),(!zone.active)?_c('span',{staticClass:"msub-badge"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.zoneInactive')))]):_vm._e()]),_vm._v(" "),_c('span',[_vm._v(_vm._s(zone.shipping_cost)+" "+_vm._s(_vm.currency))]),_vm._v(" "),_c('span',[(_vm.isZoneSelected(zone.id))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedZone(zone.id).delivery_fee),expression:"selectedZone(zone.id).delivery_fee"}],staticClass:"form-control input-sm",attrs:{"type":"number","min":"0","step":"0.01","placeholder":zone.shipping_cost},domProps:{"value":(_vm.selectedZone(zone.id).delivery_fee)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedZone(zone.id), "delivery_fee", $event.target.value)}}}):_vm._e()])])})],2),_vm._v(" "),_c('small',{staticClass:"text-muted msub-block"},[_vm._v(_vm._s(_vm.$t('menuSubscriptions.zonesHint')))]),_vm._v(" "),(_vm.errors.zones)?_c('small',{staticClass:"text-danger msub-block"},[_vm._v(_vm._s(_vm.errors.zones))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"text-center mar-to-10"},[_c('button',{staticClass:"btn btn-purple-light btn-fill btn-wd",attrs:{"disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oNp7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userRole != 'USER_CUSTOM')?[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"users-filters",staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px","align-items":"flex-end","justify-content":"space-between","margin-bottom":"15px"}},[_c('div',{staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px","align-items":"flex-end","flex":"1 1 auto"}},[_c('div',{staticClass:"form-group",staticStyle:{"max-width":"150px","margin-bottom":"0"}},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":'ID'},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSearch($event)}},model:{value:(_vm.filters.id),callback:function ($$v) {_vm.$set(_vm.filters, "id", $$v)},expression:"filters.id"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"max-width":"220px","margin-bottom":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.fn'))+" / "+_vm._s(_vm.$t('settingUsers.ln')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('settingUsers.fn') + ' / ' + _vm.$t('settingUsers.ln')},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSearch($event)}},model:{value:(_vm.filters.name),callback:function ($$v) {_vm.$set(_vm.filters, "name", $$v)},expression:"filters.name"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"max-width":"220px","margin-bottom":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.email')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('settingUsers.email')},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSearch($event)}},model:{value:(_vm.filters.email),callback:function ($$v) {_vm.$set(_vm.filters, "email", $$v)},expression:"filters.email"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"max-width":"220px","margin-bottom":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingUsers.role')))]),_vm._v(" "),_c('el-select',{staticClass:"filter-select",staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":_vm.$t('settingUsers.role')},model:{value:(_vm.filters.role),callback:function ($$v) {_vm.$set(_vm.filters, "role", $$v)},expression:"filters.role"}},_vm._l((_vm.roleOptions),function(role){return _c('el-option',{key:role,attrs:{"label":_vm.$t('settingUsers.' + role),"value":role}})}))],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports",staticStyle:{"margin-bottom":"0"}},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.search')},on:{"click":function($event){$event.preventDefault();return _vm.handleSearch($event)}}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"userList",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":150,"prop":"role","label":_vm.$t('settingUsers.role')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.$t('settingUsers.' + props.row.role))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":145},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(_vm.c,[],[], $event)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n              ")])]}}])})],2)],1)])]:[_c('h3',[_vm._v(_vm._s(_vm.$t('general.noAccessUsers')))])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oQNv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_css__);

















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Pagination_vue__["a" /* default */],

    PSwitch: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  watch: {},
  computed: {},
  data: function data() {
    var _this = this;

    return {
      loading: true,
      actionCol: {
        label: 'Delete',
        props: {
          align: 'center'
        },
        buttons: [{
          props: {
            type: 'danger',
            icon: 'el-icon-delete',
            class: 'btn btn-orange btn-fill'
          },
          handler: function handler(index, row) {
            _this.handleDelete(index, row);
          },
          label: this.$t('general.delete')
        }]
      },
      paginationDef: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 25, 50],
        show: true
      },
      searchQuery: '',
      propsToSearch: ['title', 'category', 'treshold', 'active'],
      tableColumns: [],
      tableData: [],
      filters: [{
        value: '',
        prop: ['title', 'category', 'treshold', 'active']
      }],
      totalEmails: null
    };
  },
  created: function created() {
    this.initPage();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.initPage();
    },
    initPage: function initPage() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/promo', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.tableData = response.data;

          _this2.tableData.forEach(function (element) {
            _this2.$set(element, 'isDisabledByLastSent', _this2.checkLastSent(element));
          });
        }

        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    goToRecord: function goToRecord(row, column, event) {
      if (column.property !== 'actions' && column.property !== 'active') {
        this.globalGoToRecord(row, event, column, '/marketing/promos/edit/');
      }
    },
    handleActive: function handleActive(index, row, e) {
      var _this3 = this;

      var actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + row.title + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var notificationTypes = [];
          for (var i in row.notification_type) {
            if (row.notification_type[i]) {
              for (var type in row.notification_type[i]) {
                notificationTypes.push({ 'type': row.notification_type[i][type] });
              }
            }
          }
          var data = {
            token: _this3.$session.get('token'),
            company_id: _this3.$session.get('selectedCompany'),
            id: row.id,
            active: row.active ? 1 : 0
          };

          var self = _this3;
          _this3.apiRequest('/promo/update-status', 'POST', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()(self.$t('general.success') + '!', '', 'success').catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
              row.active = !row.active;
            }
          });
        }
      }).catch(function () {
        row.active = !row.active;
      });
    },
    sendNotif: function sendNotif(index, row) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: this.$t('marketingCampaigns.areYouSureNotif'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        _this4.$nextTick(function () {
          this.loading = true;
        });
        if (result) {
          var data = {
            token: _this4.$session.get('token'),
            company_id: _this4.$session.get('selectedCompany'),
            campaign_id: row.id
          };
          var self = _this4;
          _this4.apiRequest('/queues/notifications', 'POST', data, function (response) {
            self.$nextTick(function () {
              this.loading = false;
            });
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', self.$t('marketingCampaigns.notifSent'), 'success').catch(function () {});
              self.$nextTick(function () {
                var validIndex = self.tableData.findIndex(function (obj) {
                  return obj.id === row.id;
                });
                self.tableData[validIndex].last_sent = response.data.last_sent;
                self.tableData[validIndex].isDisabledByLastSent = self.checkLastSent(self.tableData[validIndex]);
              });
            } else {
              var msg = self.$t('validations.wentWrong');
              if (response.errors.campaign_id !== undefined) {
                msg = response.errors.campaign_id;
              }
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', msg, 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
    },
    handleDelete: function handleDelete(index, row) {
      var _this5 = this;

      var self = this;
      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: this.$t('marketingPromos.areYouSureDelete') + ' ' + row.title + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this5.$session.get('token'),
            company_id: _this5.$session.get('selectedCompany')
          };
          _this5.apiRequest('/promo/' + row.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', self.$t('marketingPromos.promoDeleted'), 'success').catch(function () {});
              self.tableData.splice(index, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.disableConfirmButton();
      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    addZero: function addZero(i) {
      if (i < 10) {
        i = '0' + i;
      }
      return i;
    },
    checkLastSent: function checkLastSent(row) {
      if (row.last_sent && row.last_sent.length) {
        var data1 = new Date(row.last_sent);
        var data2 = new Date();
        var differenceInTime = data2.getTime() - data1.getTime();
        var minutes = Math.floor(differenceInTime / 60000);
        if (minutes < 30) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    }
  }
});

/***/ }),

/***/ "oVBA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DispatchView_vue__ = __webpack_require__("esvh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrdersPos_OrdersPos_vue__ = __webpack_require__("jTQK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DispatchDrivers_vue__ = __webpack_require__("w4Yf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DispatchOrders_vue__ = __webpack_require__("rVZm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DispatchSettings_vue__ = __webpack_require__("g01Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DispatchReports_vue__ = __webpack_require__("H9OI");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Dispatch: __WEBPACK_IMPORTED_MODULE_0__DispatchView_vue__["a" /* default */],
    OrderPos: __WEBPACK_IMPORTED_MODULE_1__OrdersPos_OrdersPos_vue__["a" /* default */],
    DispatchDrivers: __WEBPACK_IMPORTED_MODULE_2__DispatchDrivers_vue__["a" /* default */],
    DispatchOrders: __WEBPACK_IMPORTED_MODULE_3__DispatchOrders_vue__["a" /* default */],
    DispatchSettings: __WEBPACK_IMPORTED_MODULE_4__DispatchSettings_vue__["a" /* default */],
    DispatchReports: __WEBPACK_IMPORTED_MODULE_5__DispatchReports_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isDispatch: false,
      isDriver: false,
      isAddNewOrder: false,
      isOrder: false,
      isReport: false,
      isSettings: false
    };
  },
  mounted: function mounted() {
    this.switchTab();
  },

  methods: {
    resetStates: function resetStates() {
      this.isDispatch = false;
      this.isAddNewOrder = false;
      this.isDriver = false;
      this.isOrder = false;
      this.isReport = false;
      this.isSettings = false;
    },
    switchTab: function switchTab() {
      var _this = this;

      var index = this.$route.query.tabIndex;
      this.$nextTick(function () {
        if (index && _this.$refs.tabs) {
          _this.$refs.tabs.navigateToTab(parseInt(index));
        }
      });
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      this.resetStates();
      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);
      switch (newTab.title) {
        case this.$t('dispath.drivers'):
          this.isDriver = true;
          break;
        case this.$t('dispath.addNewOrder'):
          this.isAddNewOrder = true;
          break;
        case this.$t('dispath.orders'):
          this.isOrder = true;
          break;
        case this.$t('dispath.reports'):
          this.isReport = true;
          break;
        case this.$t('dispath.settings'):
          this.isSettings = true;
          break;
        default:
          this.isDispatch = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ "oVXt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"ordersposContainer"},[_c('div',{staticClass:"dispatch"},[_c('div',{staticClass:"col-orders"},[_c('div',{staticClass:"newOrder"},[_c('div',{staticClass:"buttonAdd batched"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":"Add group order"},on:{"click":_vm.showAddOrdersGroupModal}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('dispath.addGroupOrder'))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"filterLocation"},[_c('el-button',{staticClass:"filter-btn",attrs:{"type":"default"},on:{"click":_vm.openFiltersModal}},[_c('img',{attrs:{"src":"/static/img/icons/filter.png"}})])],1)]),_vm._v(" "),_c('div',{staticClass:"dispatch-filters-content pad-to-10 text-bold-500",staticStyle:{"font-size":"13px","padding":"0 10px 10px"}},[(_vm.hasActiveFilters)?[_c('div',{staticClass:"filters-header",on:{"click":_vm.toggleFiltersCollapse}},[_c('button',{staticClass:"collapse-toggle-btn",attrs:{"type":"button"}},[_c('i',{class:_vm.showFiltersCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('orders.filtersApplied'))+":")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showFiltersCollapsed),expression:"!showFiltersCollapsed"}],staticClass:"filters-list"},[_vm._l((_vm.requestFilters[0].value),function(sts,key){return _c('span',{key:'status-filter-' + sts + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                  "+_vm._s(_vm.formatLabelFirstLetter('ordersStatus.' + sts))),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeStatusFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}),_vm._v(" "),_vm._l((_vm.locationFilter),function(locId,key){return _c('span',{key:'location-filter-' + locId + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                  "+_vm._s(_vm.getLocationName(locId))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeLocationFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}),_vm._v(" "),(_vm.orderFilters.pickupDatetime && _vm.orderFilters.pickupDatetime.length === 2)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Pickup: "+_vm._s(_vm.formatDateRange(_vm.orderFilters.pickupDatetime))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removePickupDatetimeFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.placedDatetime && _vm.orderFilters.placedDatetime.length === 2)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Placed: "+_vm._s(_vm.formatDateRange(_vm.orderFilters.placedDatetime))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removePlacedDatetimeFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.orderId)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Order ID: "+_vm._s(_vm.orderFilters.orderId)+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOrderIdFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.orderNumber)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Order #: "+_vm._s(_vm.orderFilters.orderNumber)+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOrderNumberFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.orderTotalMin || _vm.orderFilters.orderTotalMax)?[_c('span',{staticClass:"filter-selection"},[_vm._v("Total: "+_vm._s(_vm.orderFilters.orderTotalMin || '0')+" - "+_vm._s(_vm.orderFilters.orderTotalMax || '∞')+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOrderTotalFilter()}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])]:_vm._e(),_vm._v(" "),(_vm.orderFilters.operator && _vm.orderFilters.operator.length > 0)?_vm._l((_vm.orderFilters.operator),function(opId,key){return _c('span',{key:'operator-filter-' + opId + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                    Operator: "+_vm._s(_vm.getOperatorName(opId))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeOperatorFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e(),_vm._v(" "),(_vm.orderFilters.paymentType && _vm.orderFilters.paymentType.length > 0)?_vm._l((_vm.orderFilters.paymentType),function(pt,key){return _c('span',{key:'payment-type-filter-' + pt + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                    Payment: "+_vm._s(_vm.formatLabelFirstLetter('paymentTypes.' + pt))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removePaymentTypeFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e(),_vm._v(" "),(_vm.orderFilters.deliveryType && _vm.orderFilters.deliveryType.length > 0)?_vm._l((_vm.orderFilters.deliveryType),function(dt,key){return _c('span',{key:'delivery-type-filter-' + dt + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                    "+_vm._s(_vm.$t('settingCompany.deliveryType'))+": "+_vm._s(_vm.formatLabelFirstLetter('deliveryTypes.' + dt))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeDeliveryTypeFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e(),_vm._v(" "),(_vm.orderFilters.source && _vm.orderFilters.source.length > 0)?_vm._l((_vm.orderFilters.source),function(src,key){return _c('span',{key:'source-filter-' + src + '-' + key,staticClass:"filter-selection"},[_vm._v("\n                    Source: "+_vm._s(_vm.formatLabelFirstLetter('ordersSource.' + src))+" "),_c('a',{attrs:{"title":"Remove filter","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeSourceFilter(key)}}},[_c('i',{staticClass:"text-warning el-icon-circle-close-outline"})])])}):_vm._e()],2),_vm._v(" "),_c('a',{staticClass:"reset-filters-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.resetFilters()}}},[_vm._v(_vm._s(_vm.$t('orders.resetFilters')))])]:[_vm._v("\n              "+_vm._s(_vm.$t('orders.noFiltersApplied'))+"\n            ")]],2),_vm._v(" "),_c('div',{staticClass:"statuses order-buttons"},[_c('div',{staticClass:"status new",class:{ selected: _vm.requestFilters[0].value.includes('NEW') },on:{"click":function($event){_vm.toggleStatus('NEW')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('ordersStatus.NEW')))])]),_vm._v(" "),_c('div',{staticClass:"status processing",class:{ selected: _vm.requestFilters[0].value.includes('PROCESSING') },on:{"click":function($event){_vm.toggleStatus('PROCESSING')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('ordersStatus.PROCESSING')))])]),_vm._v(" "),_c('div',{staticClass:"status prepared",class:{ selected: _vm.requestFilters[0].value.includes('PREPARED') },on:{"click":function($event){_vm.toggleStatus('PREPARED')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('ordersStatus.PREPARED')))])]),_vm._v(" "),_c('div',{staticClass:"status in-transport",class:{ selected: _vm.requestFilters[0].value.includes('TRANSPORT') },on:{"click":function($event){_vm.toggleStatus('TRANSPORT')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('ordersStatus.TRANSPORT')))])])]),_vm._v(" "),_c('div',{staticClass:"drivers"},[_c('div',{staticClass:"driver"},[[(_vm.groupsDispatch.length)?_c('div',{staticClass:"groups-container"},_vm._l((_vm.groupsDispatch),function(group){return _c('div',{key:group.id,staticClass:"group-box"},[_c('div',{staticClass:"order"},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"orderId"},[_c('span',[_vm._v("Group ID: "+_vm._s(group.id))])]),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"ord"},[_vm._l((group.orders),function(order){return _c('p',{key:order.id,class:{
                            'status-prepared': order.status === 'PREPARED',
                            'status-processing': order.status === 'PROCESSING',
                            'status-new': order.status === 'NEW'
                          },on:{"click":function($event){_vm.goToOrder(order.id)}}},[_vm._v("\n                          Order #"+_vm._s(order.number)+"\n                        ")])}),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"buttons"},[_c('div',{staticClass:"goToDriver"},[_c('button',{staticClass:"btn btn-info",on:{"click":function($event){$event.stopPropagation();_vm.addGroupOrderDriverModal(group.id)}}},[_vm._v("\n                                ASSIGN DRIVER\n                              ")])])])])],2)])])})):_vm._e()],_vm._v(" "),(_vm.orders.length)?_vm._l((_vm.orders),function(order){return _c('div',{key:order.id,attrs:{"data-order_id":order.id}},[[_c('div',[(order)?_c('div',{class:[
                            'order',
                            order.id === _vm.selectedOrderId ? 'selected' : ''
                            ],on:{"click":function($event){$event.stopPropagation();_vm.highlightOrderOnMap(order.id)}}},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"orderId",on:{"click":function($event){_vm.goToOrder(order.id)}}},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.orderNoArticulate'))+" #"+_vm._s(_vm.formatOrderNr(order.number)))])]),_vm._v(" "),_c('div',{staticClass:"statusHeader"},[_c('span',{class:_vm.getStatusClass(order.status, order.driver)},[_vm._v("\n                                "+_vm._s(_vm.getStatusText(order.status, order.driver))+"\n                              ")])]),_vm._v(" "),_c('div',{staticClass:"date"},[_c('img',{attrs:{"src":order.id === _vm.selectedOrderId
                                ? '/static/img/icon-date-white.png'
                                : '/static/img/icon-calendar.png',"alt":"Date Icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.pickup_datetime))])])]),_vm._v(" "),_c('div',{staticClass:"ord"},[_c('div',{staticClass:"ord_mid"},[_c('div',{staticClass:"client"},[_c('span',[_c('b',[_vm._v(_vm._s(order.delivery_details_firstname))])]),_vm._v(" "),_c('span',{staticClass:"phone"},[_vm._v(_vm._s(order.delivery_details_phone))]),_vm._v(" "),_c('div',{staticClass:"address"},[(order && order.address_shipping)?_c('div',{staticClass:"address_shipping"},[_c('span',[_c('img',{attrs:{"src":"/static/img/icon-location.png"}}),_vm._v(" "),_vm._v("\n                                      "+_vm._s(order.address_shipping.street)+" "+_vm._s(order.address_shipping.number)+"\n                                    ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"address"},[(order.production_details && order.production_details.location)?_c('div',{staticClass:"production_details"},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('orders.ordLocation'))+":")]),_vm._v("\n                                    "+_vm._s(order.production_details.location.name)+"\n                                    "),(order && (order.status === 'PROCESSING' || order.status === 'NEW'))?_c('i',{staticClass:"fa fa-pencil",on:{"click":function($event){_vm.showLocationModal(order.id)}}}):_vm._e()]),_vm._v(" "),(order && order.shipping_details)?_c('span',{staticClass:"zone"},[_c('b',[_vm._v(_vm._s(_vm.$t('dispath.zone'))+":")]),_vm._v("\n                                    "+_vm._s(order.shipping_details.name)+"\n                                  ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"total"},[_c('span',[_vm._v(_vm._s(order.totals_grandtotal)+" "+_vm._s(order.currency)+" ("+_vm._s(order.payment_type)+")")])]),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('div',{staticClass:"updateStatus"},[(order && order.status == 'NEW')?_c('button',{staticClass:"btn btn-info btn-processing",on:{"click":function($event){$event.stopPropagation();_vm.updateStatus(order.id, 'PROCESSING')}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('ordersStatus.PROCESSING'))+"\n                                  ")]):_vm._e(),_vm._v(" "),(order && order.status == 'PROCESSING')?_c('button',{staticClass:"btn btn-info btn-prepared",on:{"click":function($event){$event.stopPropagation();_vm.updateStatus(order.id, 'PREPARED')}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('ordersStatus.PREPARED'))+"\n                                  ")]):_vm._e()]),_vm._v(" "),(order && order.status == 'PREPARED')?_c('div',{staticClass:"goToDriver"},[(!order.driver)?_c('button',{staticClass:"btn btn-info",on:{"click":function($event){$event.stopPropagation();_vm.showDriverModal(order.id)}}},[_vm._v("\n                                    ASSIGN DRIVER\n                                  ")]):_c('button',{staticClass:"btn btn-info assigned-driver",on:{"click":function($event){$event.stopPropagation();_vm.showDriverModal(order.id)}}},[_vm._v("\n                                    "+_vm._s(order.driver.firstname)+" "+_vm._s(order.driver.lastname)+"\n                                  ")])]):_vm._e(),_vm._v(" "),(order && order.driver && order.status == 'TRANSPORT')?_c('div',{staticClass:"goToDriver"},[_c('button',{staticClass:"btn btn-info assigned-driver",on:{"click":function($event){$event.stopPropagation();_vm.showDriverOnMap(order.driver)}}},[_vm._v("\n                                    "+_vm._s(order.driver.firstname)+" "+_vm._s(order.driver.lastname)+"\n                                  ")])]):_vm._e()])])])]):_vm._e()])]],2)}):[_vm._m(1)]],2)])]),_vm._v(" "),_c('div',{staticClass:"col-maps"},[_c('div',{staticClass:"maps-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",on:{"click":_vm.resetMap}},[_vm._v("\n              "+_vm._s(_vm.$t('dispath.reset_map'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedButtons),expression:"selectedButtons"}],attrs:{"type":"checkbox"},domProps:{"value":'delivery',"checked":Array.isArray(_vm.selectedButtons)?_vm._i(_vm.selectedButtons,'delivery')>-1:(_vm.selectedButtons)},on:{"change":[function($event){var $$a=_vm.selectedButtons,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='delivery',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedButtons=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedButtons=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedButtons=$$c}},function($event){_vm.updateSelection('delivery')}]}}),_vm._v(" "),_c('label',{staticClass:"checkbox-label"},[_vm._v(_vm._s(_vm.$t('dispath.drivers')))])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedButtons),expression:"selectedButtons"}],attrs:{"type":"checkbox"},domProps:{"value":'orders',"checked":Array.isArray(_vm.selectedButtons)?_vm._i(_vm.selectedButtons,'orders')>-1:(_vm.selectedButtons)},on:{"change":[function($event){var $$a=_vm.selectedButtons,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='orders',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedButtons=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedButtons=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedButtons=$$c}},function($event){_vm.updateSelection('orders')}]}}),_vm._v(" "),_c('label',{staticClass:"checkbox-label"},[_vm._v(_vm._s(_vm.$t('dispath.orders')))])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedButtons),expression:"selectedButtons"}],attrs:{"type":"checkbox"},domProps:{"value":'zones',"checked":Array.isArray(_vm.selectedButtons)?_vm._i(_vm.selectedButtons,'zones')>-1:(_vm.selectedButtons)},on:{"change":[function($event){var $$a=_vm.selectedButtons,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='zones',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedButtons=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedButtons=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedButtons=$$c}},function($event){_vm.updateSelection('zones')}]}}),_vm._v(" "),_c('label',{staticClass:"checkbox-label"},[_vm._v(_vm._s(_vm.$t('dispath.zone')))])])]),_vm._v(" "),_c('div',{staticClass:"mapsDispatch"},[[_vm._m(2)]],2)])])])]),_vm._v(" "),_c('vmodal',{staticClass:"filtersAndSortModal dispatch-filters-modal",attrs:{"name":"dispatchFiltersModal","height":"auto","width":"1200","adaptive":true,"scrollable":true}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header slim-header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('orders.filtersAndSort')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body slim-body"},[_c('div',{staticClass:"filters-grid"},[_c('div',{staticClass:"modal-column-left"},[_c('h6',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('orders.filters')))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.status')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons"},_vm._l((_vm.filteredStatuses),function(key){return _c('button',{key:key,class:'btn btn-status-filter ' + (_vm.modalRequestFilters[0].value.includes(key) ? 'btn-' + _vm.orderStatusClass(key) + ' current ' + key : 'btn-default'),on:{"click":function($event){_vm.toggleModalStatusFilter(key)}}},[_vm._v("\n                    "+_vm._s(_vm.formatLabelFirstLetter('ordersStatus.' + key))+"\n                  ")])}))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingCompany.deliveryType')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons delivery-type-buttons"},_vm._l((_vm.deliveryTypeOptions),function(dt){return _c('button',{key:dt,class:'btn btn-status-filter ' + (_vm.modalOrderFilters.deliveryType && _vm.modalOrderFilters.deliveryType.includes(dt) ? 'btn-primary current ' + dt : 'btn-default'),on:{"click":function($event){_vm.toggleModalDeliveryTypeFilter(dt)}}},[_vm._v("\n                    "+_vm._s(_vm.formatLabelFirstLetter('deliveryTypes.' + dt))+"\n                  ")])}))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.source')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons source-filter-buttons"},_vm._l((_vm.sourceOptions),function(src){return _c('button',{key:src,class:'btn btn-status-filter ' + (_vm.modalOrderFilters.source && _vm.modalOrderFilters.source.includes(src) ? 'btn-primary current ' + src : 'btn-default'),on:{"click":function($event){_vm.toggleModalSourceFilter(src)}}},[_vm._v("\n                    "+_vm._s(_vm.formatLabelFirstLetter('ordersSource.' + src))+"\n                  ")])}))]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.payment')))]),_vm._v(" "),_c('div',{staticClass:"button-group-wrap status-filter-buttons payment-type-buttons"},_vm._l((_vm.paymentTypeOptions),function(pt){return _c('button',{key:pt,class:'btn btn-status-filter ' + (_vm.modalOrderFilters.paymentType && _vm.modalOrderFilters.paymentType.includes(pt) ? 'btn-primary current ' + pt : 'btn-default'),on:{"click":function($event){_vm.toggleModalPaymentTypeFilter(pt)}}},[_vm._v("\n                    "+_vm._s(_vm.formatLabelFirstLetter('paymentTypes.' + pt))+"\n                  ")])}))])]),_vm._v(" "),_c('div',{staticClass:"modal-column-right"},[_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.pickupDatetime')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","placeholder":_vm.$t('orders.selectDateRange')},on:{"change":function($event){_vm.adjustDatetimeRange('pickupDatetime')}},model:{value:(_vm.modalOrderFilters.pickupDatetime),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "pickupDatetime", $$v)},expression:"modalOrderFilters.pickupDatetime"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.placedDatetime')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","placeholder":_vm.$t('orders.selectDateRange')},on:{"change":function($event){_vm.adjustDatetimeRange('placedDatetime')}},model:{value:(_vm.modalOrderFilters.placedDatetime),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "placedDatetime", $$v)},expression:"modalOrderFilters.placedDatetime"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"multiple":"","clearable":"","filterable":"","collapse-tags":"","placeholder":_vm.$t('orders.location')},model:{value:(_vm.modalLocationFilter),callback:function ($$v) {_vm.modalLocationFilter=$$v},expression:"modalLocationFilter"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:'modal-location-' + loc.id,attrs:{"label":loc.name,"value":_vm.getLocationFilterValue(loc)}})}))],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.orderId')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('orders.enterOrderId')},model:{value:(_vm.modalOrderFilters.orderId),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderId", $$v)},expression:"modalOrderFilters.orderId"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.orderNumber')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('orders.enterOrderNumber')},model:{value:(_vm.modalOrderFilters.orderNumber),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderNumber", $$v)},expression:"modalOrderFilters.orderNumber"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.operator')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"multiple":"","clearable":"","filterable":"","collapse-tags":"","placeholder":_vm.$t('reports.operator')},model:{value:(_vm.modalOrderFilters.operator),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "operator", $$v)},expression:"modalOrderFilters.operator"}},_vm._l((_vm.operatorOptions),function(op){return _c('el-option',{key:'op-' + op.id,attrs:{"label":op.label,"value":op.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.orderTotal')))]),_vm._v(" "),_c('div',{staticClass:"range-row"},[_c('el-input-number',{staticStyle:{"flex":"1","line-height":"44px"},attrs:{"placeholder":_vm.$t('orders.min'),"precision":2,"controls":false},model:{value:(_vm.modalOrderFilters.orderTotalMin),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderTotalMin", $$v)},expression:"modalOrderFilters.orderTotalMin"}}),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"flex":"1","line-height":"44px"},attrs:{"placeholder":_vm.$t('orders.max'),"precision":2,"controls":false},model:{value:(_vm.modalOrderFilters.orderTotalMax),callback:function ($$v) {_vm.$set(_vm.modalOrderFilters, "orderTotalMax", $$v)},expression:"modalOrderFilters.orderTotalMax"}})],1)]),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('general.sortOrder')))]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.modalSortOrder),callback:function ($$v) {_vm.modalSortOrder=$$v},expression:"modalSortOrder"}},_vm._l((_vm.sortOptions),function(sort){return _c('el-radio',{key:'sort-' + sort.id,staticStyle:{"display":"block","margin-bottom":"10px"},attrs:{"label":sort.id}},[_vm._v("\n                    "+_vm._s(_vm.$t('general.sort' + sort.name))+"\n                  ")])}))],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer slim-footer"},[_c('el-button',{attrs:{"type":"default","size":"small"},on:{"click":_vm.resetModalFilters}},[_vm._v(_vm._s(_vm.$t('general.reset')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.applyFilters}},[_vm._v(_vm._s(_vm.$t('general.apply')))])],1)])])])]),_vm._v(" "),_c('vmodal',{staticClass:"modalDriver",attrs:{"name":"driverModal","height":"auto","width":"900"}},[_c('div',{staticClass:"card height-95-vh"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingCompany.assignOrderToDriver')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":_vm.hideDriverModal}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"driverList",staticStyle:{"width":"100%"},attrs:{"data":_vm.driverTableData,"table-props":{'border': false, 'height': 'auto'}}},[_c('el-table-column',{attrs:{"min-width":200,"prop":"name","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":200,"prop":"orders","label":"Orders"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":200,"prop":"distance","label":"Distance"}}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":150,"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('button',{staticClass:"btn",class:scope.row.hasAssignedOrder ? 'btn-info' : 'btn-info',attrs:{"disabled":!scope.row.canAssign},on:{"click":function($event){scope.row.hasAssignedOrder ? _vm.unassignDriver(scope.row) : _vm.assignDriver(scope.row)}}},[_vm._v("\n                  "+_vm._s(scope.row.hasAssignedOrder ? 'Unassign Driver' : 'Assign Driver')+"\n                ")])]}}])})],1)],1)])])]),_vm._v(" "),_c('vmodal',{staticClass:"ordersPosModal",attrs:{"name":"ordersPosModal","height":"auto","width":"1900"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",on:{"click":_vm.hideOrdersPosModal}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('OrdersPos')],1)])])]),_vm._v(" "),_c('vmodal',{staticClass:"changeLocation",attrs:{"name":"changeLocation","height":"auto","width":"800"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",on:{"click":_vm.hideLocationModal}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},_vm._l((_vm.locations),function(loc){return _c('div',{key:loc.true_id,staticClass:"location-item",on:{"click":function($event){_vm.changeOrderLocation(loc.true_id)}}},[_vm._v("\n          "+_vm._s(loc.name)+"\n          ")])}))])])]),_vm._v(" "),_c('vmodal',{staticClass:"ordersGroupModal",attrs:{"name":"ordersGroupModal","height":"auto","width":"1400"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",on:{"click":_vm.hideAddOrdersGroupModal}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row grouped"},[_c('div',{staticClass:"col-order ungrouped"},[_c('div',{staticClass:"ungrouped-title"},[_c('p',[_vm._v(_vm._s(_vm.$t('dispath.unassigned')))])]),_vm._v(" "),(_vm.groupingOrders.length)?[_c('div',{staticClass:"overflow-box"},[_c('div',{staticClass:"box-ungrouped"},[_c('draggable',{staticClass:"order-list",staticStyle:{"display":"contents"},attrs:{"group":"ungroupedOrders","name":"gr1"},on:{"end":_vm.onDropOrder},model:{value:(_vm.groupingOrders),callback:function ($$v) {_vm.groupingOrders=$$v},expression:"groupingOrders"}},[_c('transition-group',{staticClass:"transition box-ungrouped",attrs:{"data-group_id":0,"name":"tr1"}},_vm._l((_vm.groupingOrders),function(order){return _c('div',{key:order.id,staticClass:"order-card",attrs:{"data-order-id":order.id}},[_c('div',{staticClass:"order-top"},[_c('div',{staticClass:"örderId"},[_c('p',[_vm._v("Order #"+_vm._s(order.number))])]),_vm._v(" "),_c('div',{staticClass:"orderDate"},[_c('img',{attrs:{"src":"/static/img/icon-calendar.png","alt":"Date Icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.pickup_datetime.split(' ')[1]))])])]),_vm._v(" "),_c('div',{staticClass:"ord-client"},[_c('div',{staticClass:"address"},[(order && order.address_shipping)?_c('div',{staticClass:"address_shipping"},[(order && order.address_shipping)?_c('span',{staticClass:"address-tooltip",attrs:{"title":((order.address_shipping.street) + " " + (order.address_shipping.number))}},[_c('img',{attrs:{"src":"/static/img/icon-location.png"}}),_vm._v(" "),_c('span',{staticClass:"ellipsis-text"},[_vm._v(_vm._s(order.address_shipping.street)+" "+_vm._s(order.address_shipping.number))])]):_vm._e()]):_vm._e(),_vm._v(" "),(order.production_details && order.production_details.location)?_c('div',{staticClass:"production_details"},[(order && order.shipping_details)?_c('span',{staticClass:"zone"},[_c('b',[_vm._v(_vm._s(_vm.$t('dispath.zone'))+":")]),_vm._v("\n                                  "+_vm._s(order.shipping_details.name)+"\n                                ")]):_vm._e()]):_vm._e()])])])}))],1)],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-order separator"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-order grouped"},[_c('div',{staticClass:"ungrouped-title"},[_c('p',[_vm._v(_vm._s(_vm.$t('dispath.batched')))])]),_vm._v(" "),_c('div',{staticClass:"overflow-box"},[[(_vm.groupingOrdersByZone.length)?_c('div',{staticClass:"grouped-orders posibleGroup"},_vm._l((_vm.groupingOrdersByZone),function(group){return _c('div',{key:group.delivery_ranges_id,staticClass:"group-card"},[_c('div',{staticClass:"group-header"},[_c('div',{staticClass:"sugestion-id"},[_c('p',[_vm._v(_vm._s(_vm.$t('orders.zone'))+": "+_vm._s(group.delivery_range.name))])]),_vm._v(" "),_c('div',{staticClass:"sugestion-flag"},[_c('p',[_vm._v(_vm._s(_vm.$t('dispath.sugestion'))+"!")])]),_vm._v(" "),_c('div',{staticClass:"saveGrouped"},[_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){_vm.createOrderGroup(group)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n                            "+_vm._s(_vm.$t('general.save'))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"sugestion-box"},_vm._l((group.orders),function(order){return _c('div',{key:order.id,staticClass:"order-card"},[_c('div',{staticClass:"order-top"},[_c('div',{staticClass:"örderId"},[_c('p',[_vm._v("Order #"+_vm._s(order.number))])]),_vm._v(" "),_c('div',{staticClass:"orderDate"},[_c('img',{attrs:{"src":"/static/img/icon-calendar.png","alt":"Date Icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.pickup_datetime.split(' ')[1]))])]),_vm._v(" "),_c('button',{staticClass:"close-btn",on:{"click":function($event){_vm.removeOrderGroupPosibile(group, order.id)}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"ord-client"},[_c('div',{staticClass:"address"},[(order && order.address_shipping)?_c('div',{staticClass:"address_shipping"},[(order && order.address_shipping)?_c('span',{staticClass:"address-tooltip",attrs:{"title":((order.address_shipping.street) + " " + (order.address_shipping.number))}},[_c('img',{attrs:{"src":"/static/img/icon-location.png"}}),_vm._v(" "),_c('span',{staticClass:"ellipsis-text"},[_vm._v(_vm._s(order.address_shipping.street)+" "+_vm._s(order.address_shipping.number))])]):_vm._e()]):_vm._e(),_vm._v(" "),(order.production_details && order.production_details.location)?_c('div',{staticClass:"production_details"},[(order && order.shipping_details)?_c('span',{staticClass:"zone"},[_c('b',[_vm._v(_vm._s(_vm.$t('orders.zone'))+":")]),_vm._v("\n                                  "+_vm._s(order.shipping_details.name)+"\n                                ")]):_vm._e()]):_vm._e()])])])}))])})):_vm._e()],_vm._v(" "),[(_vm.groups.length)?_c('div',{staticClass:"grouped-orders"},[_c('draggable',{attrs:{"disabled":true,"group":"groups"},model:{value:(_vm.groups),callback:function ($$v) {_vm.groups=$$v},expression:"groups"}},_vm._l((_vm.groups),function(group){return _c('div',{key:group.id,staticClass:"group-card",class:{ 'has-suggestions': group.orders_suggestions && group.orders_suggestions.length > 0 },attrs:{"data-group-id":group.id}},[_c('div',{staticClass:"group-header"},[_c('p',[_vm._v("ID: "+_vm._s(group.id))]),_vm._v(" "),(group.orders_suggestions && group.orders_suggestions.length)?_c('div',{staticClass:"sugestion-flag"},[_c('p',[_vm._v(_vm._s(_vm.$t('dispath.sugestion'))+"!")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box-inline-groups"},[_c('div',{staticClass:"orders-container"},[(group.orders_suggestions && group.orders_suggestions.length)?_c('div',{staticClass:"formated-group orders-suggestions"},[_c('transition-group',{staticClass:"transition formated-group",attrs:{"data-group_id":group.id,"name":"tr1"}},_vm._l((group.orders_suggestions),function(suggestion){return _c('div',{key:suggestion.id,staticClass:"order-card suggested-order",attrs:{"data-order-id":suggestion.id}},[_c('div',{staticClass:"order-top"},[_c('div',{staticClass:"örderId"},[_c('p',[_vm._v("Order #"+_vm._s(suggestion.number))])]),_vm._v(" "),_c('div',{staticClass:"orderDate"},[_c('img',{attrs:{"src":"/static/img/icon-calendar.png","alt":"Date Icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(suggestion.pickup_datetime.split(' ')[1]))])]),_vm._v(" "),_c('button',{staticClass:"plus-btn",on:{"click":function($event){_vm.addOrderGroupPosibile(group, suggestion.id)}}},[_vm._v("+")])]),_vm._v(" "),_c('div',{staticClass:"ord-client"},[_c('div',{staticClass:"address"},[(suggestion.address_shipping)?_c('span',{attrs:{"title":((suggestion.address_shipping.street) + " " + (suggestion.address_shipping.number))}},[_c('img',{attrs:{"src":"/static/img/icon-location.png"}}),_vm._v(" "),_c('span',{staticClass:"ellipsis-text"},[_vm._v(_vm._s(suggestion.address_shipping.street)+" "+_vm._s(suggestion.address_shipping.number))])]):_vm._e(),_vm._v(" "),(suggestion.shipping_details)?_c('div',{staticClass:"zone"},[_c('b',[_vm._v(_vm._s(_vm.$t('dispath.zone'))+":")]),_vm._v(" "+_vm._s(suggestion.shipping_details.name)+"\n                                      ")]):_vm._e()])])])}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"formated-group"},[_c('draggable',{staticClass:"formated-group",attrs:{"name":'gr'+group.id,"group":{ name: 'groupedOrders', pull: 'clone', put: true }},model:{value:(group.orders),callback:function ($$v) {_vm.$set(group, "orders", $$v)},expression:"group.orders"}},[_c('transition-group',{staticClass:"transition formated-group",attrs:{"data-group_id":group.id,"name":"tr1"}},_vm._l((group.orders),function(order){return _c('div',{key:order.id,staticClass:"order-card",attrs:{"data-order-id":order.id}},[_c('div',{staticClass:"order-top"},[_c('div',{staticClass:"örderId"},[_c('p',[_vm._v("Order #"+_vm._s(order.number))])]),_vm._v(" "),_c('div',{staticClass:"orderDate"},[_c('img',{attrs:{"src":"/static/img/icon-calendar.png","alt":"Date Icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(order.pickup_datetime.split(' ')[1]))])]),_vm._v(" "),_c('button',{staticClass:"close-btn",on:{"click":function($event){_vm.removeOrderGroup(group, order.id)}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"ord-client"},[_c('div',{staticClass:"address"},[(order && order.address_shipping)?_c('span',{staticClass:"address-tooltip",attrs:{"title":((order.address_shipping.street) + " " + (order.address_shipping.number))}},[_c('img',{attrs:{"src":"/static/img/icon-location.png"}}),_vm._v(" "),_c('span',{staticClass:"ellipsis-text"},[_vm._v(_vm._s(order.address_shipping.street)+" "+_vm._s(order.address_shipping.number))])]):_vm._e(),_vm._v(" "),(order.production_details && order.production_details.location)?_c('div',{staticClass:"production_details"},[(order && order.shipping_details)?_c('span',{staticClass:"zone"},[_c('b',[_vm._v(_vm._s(_vm.$t('dispath.zone'))+":")]),_vm._v("\n                                            "+_vm._s(order.shipping_details.name)+"\n                                          ")]):_vm._e()]):_vm._e()])])])}))],1)],1)])])])}))],1):_vm._e()]],2)])])])])])]),_vm._v(" "),_c('vmodal',{staticClass:"ordersViewModal",attrs:{"name":"ordersViewModal","height":"auto","width":"1900"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",on:{"click":_vm.hideOrdersViewModal}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.orderId)?_c('iframe',{attrs:{"src":("/orders/view/" + _vm.orderId),"width":"100%","height":"600","frameborder":"0"}}):_vm._e()])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusHeader"},[_c('span',{staticClass:"bached"},[_vm._v("\n                            Batched\n                          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-orders"},[_c('img',{attrs:{"src":"/static/img/no-orders.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card-map"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"full-screen-map",attrs:{"id":"map"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oViy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.groups.length)?_c('div',{staticClass:"integration-menu-validation-list"},_vm._l((_vm.groups),function(group,index){return _c('section',{key:'menu-validation-group-' + index + '-' + String(group.code || group.label),staticClass:"integration-menu-validation-list__group"},[_c('h6',{staticClass:"integration-menu-validation-list__title"},[_vm._v(_vm._s(_vm.groupTitle(group)))]),_vm._v(" "),_c('ul',{staticClass:"integration-menu-validation-list__items"},_vm._l((_vm.groupEntries(group)),function(entry,itemIdx){return _c('li',{key:'menu-validation-item-' + index + '-' + itemIdx,staticClass:"integration-menu-validation-list__item"},[_c('span',{staticClass:"integration-menu-validation-list__text"},[_vm._v(_vm._s(entry.text))]),_vm._v(" "),(entry.editTarget)?_c('button',{staticClass:"btn btn-info btn-sm integration-menu-validation-list__edit",attrs:{"type":"button","title":_vm.$t('gestiune.integrationsMenuValidationEditEntityHint')},on:{"click":function($event){_vm.onEditClick(entry.editTarget)}}},[_vm._v("\n          "+_vm._s(_vm.$t('gestiune.integrationsMenuValidationEditEntity'))+"\n        ")]):_vm._e()])}))])})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oVxW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oW06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      tableData: [],
      invoice: null
    };
  },

  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    var id = this.route && this.route.params && this.route.params.id;
    if (id) {
      this.fetchInvoiceSupplier(id);
    }
  },

  methods: {
    goBack: function goBack() {
      this.$bus.$emit('close-modal');
    },
    formatDate: function formatDate(value) {
      if (!value) return '';
      var date = new Date(value);
      return isNaN(date.getTime()) ? '' : date.toLocaleDateString();
    },
    formatAddress: function formatAddress(address) {
      if (!address) return '';
      return address.street + ', ' + address.city + ', ' + address.county + ', ' + address.country;
    },
    generateNir: function generateNir(id) {
      this.$router.push({
        path: '/management/entries/add',
        query: {
          id: id,
          vatNumber: this.invoice && this.invoice.customer ? this.invoice.customer.vat : '',
          isInvoiceSupplier: true
        }
      });
    },
    fetchInvoiceSupplier: function fetchInvoiceSupplier(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$bus.$emit('set-loading', true);
                _context.prev = 1;
                _context.next = 4;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/purchase/' + id + '?externalCompanyId=' + _this.companyID, { method: 'GET' });

              case 4:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 7;
                  break;
                }

                throw new Error('HTTP ' + response.status);

              case 7:
                _context.next = 9;
                return response.json();

              case 9:
                result = _context.sent;


                _this.invoice = result;
                _this.tableData = result.items || [];

                console.log('✅ Bon fiscal details fetched successfully:', _this.tableData);
                _context.next = 20;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](1);

                console.error('❌ Eroare la fetch bon fiscal by ID:', _context.t0);
                _this.invoice = null;
                _this.tableData = [];

              case 20:
                _context.prev = 20;

                _this.$bus.$emit('set-loading', false);
                return _context.finish(20);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 15, 20, 23]]);
      }))();
    }
  }
});

/***/ }),

/***/ "oZx1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-bon-product-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oahL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ohf7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ZONE_DAY_NAMES */
/* unused harmony export buildZoneAvailableDays */
/* harmony export (immutable) */ __webpack_exports__["b"] = ensureZoneAvailability;
/* harmony export (immutable) */ __webpack_exports__["c"] = overlappingIntervalKeys;
/* harmony export (immutable) */ __webpack_exports__["d"] = intervalPairInvalid;
/* harmony export (immutable) */ __webpack_exports__["a"] = zoneAvailabilityError;
/* harmony export (immutable) */ __webpack_exports__["e"] = zoneAvailabilityPayload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



var ZONE_DAY_NAMES = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

function buildZoneAvailableDays(existing) {
  var source = Array.isArray(existing) ? existing : [];
  return ZONE_DAY_NAMES.map(function (name) {
    var found = source.find(function (d) {
      return d && d.day === name;
    });
    if (found) {
      return {
        day: name,
        open: !!found.open,
        open_from: found.open_from || '',
        open_to: found.open_to || '',
        intervals: Array.isArray(found.intervals) ? found.intervals.map(function (iv) {
          return { open_from: iv.open_from || '', open_to: iv.open_to || '' };
        }) : []
      };
    }

    return { day: name, open: !source.length, open_from: '08:00', open_to: '22:00', intervals: [] };
  });
}

function ensureZoneAvailability(vm, zone) {
  if (!zone) return;
  vm.$set(zone, 'active', zone.active === undefined || zone.active === null ? true : !!zone.active);
  vm.$set(zone, 'schedule_enabled', !!zone.schedule_enabled);
  vm.$set(zone, 'available_days', buildZoneAvailableDays(zone.available_days));
}

function toMinutes(time) {
  if (!time || typeof time !== 'string') return null;
  var m = time.match(/^(\d{1,2}):(\d{2})/);
  if (!m) return null;
  return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
}

function dayPairs(day) {
  var pairs = [{ key: 0, from: day.open_from, to: day.open_to }];(day.intervals || []).forEach(function (iv, i) {
    pairs.push({ key: i + 1, from: iv.open_from, to: iv.open_to });
  });
  return pairs;
}

function overlappingIntervalKeys(day) {
  var valid = dayPairs(day).map(function (p) {
    return { key: p.key, from: toMinutes(p.from), to: toMinutes(p.to) };
  }).filter(function (p) {
    return p.from !== null && p.to !== null && p.from < p.to;
  }).sort(function (a, b) {
    return a.from - b.from;
  });
  var keys = {};
  for (var i = 1; i < valid.length; i++) {
    for (var j = 0; j < i; j++) {
      if (valid[i].from < valid[j].to) {
        keys[valid[i].key] = true;
        keys[valid[j].key] = true;
      }
    }
  }
  return keys;
}

function intervalPairInvalid(from, to) {
  var f = toMinutes(from);
  var t = toMinutes(to);
  return f === null || t === null || f >= t;
}

function zoneAvailabilityError(zone, t) {
  if (!zone || !zone.schedule_enabled) return '';
  var days = zone.available_days || [];
  var hasOpenDay = false;
  for (var i = 0; i < days.length; i++) {
    var day = days[i];
    if (!day.open) continue;
    hasOpenDay = true;
    var pairs = dayPairs(day);
    for (var j = 0; j < pairs.length; j++) {
      if (!pairs[j].from || !pairs[j].to) return t('zoneAvailability.hoursRequired');
      if (intervalPairInvalid(pairs[j].from, pairs[j].to)) return t('zoneAvailability.hoursOrder');
    }
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(overlappingIntervalKeys(day)).length) {
      return t('zoneAvailability.overlap') + ' (' + t('days.' + day.day) + ')';
    }
  }
  if (!hasOpenDay) return t('zoneAvailability.noOpenDay');
  return '';
}

function zoneAvailabilityPayload(zone) {
  return {
    active: zone.active === undefined || zone.active === null ? true : !!zone.active,
    schedule_enabled: !!zone.schedule_enabled,
    available_days: Array.isArray(zone.available_days) ? zone.available_days : null
  };
}

/***/ }),

/***/ "olp1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInViewElement.nirs },on:{"click":function($event){_vm.changeView('nirs')}}},[_vm._v(_vm._s(_vm.$t('gestiune.reportStock')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInViewElement.purchase },on:{"click":function($event){_vm.changeView('purchase')}}},[_vm._v(_vm._s(_vm.$t('gestiune.purchase')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInViewElement.consumption },on:{"click":function($event){_vm.changeView('consumption')}}},[_vm._v(_vm._s(_vm.$t('gestiune.consumption')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInViewElement.production },on:{"click":function($event){_vm.changeView('production')}}},[_vm._v(_vm._s(_vm.$t('gestiune.production')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInViewElement.balance },on:{"click":function($event){_vm.changeView('balance')}}},[_vm._v(_vm._s(_vm.$t('gestiune.BalanceReport')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInViewElement.stocLaZi },on:{"click":function($event){_vm.changeView('stocLaZi')}}},[_vm._v(_vm._s(_vm.$t('gestiune.stocLaZi')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInViewElement.productMix },on:{"click":function($event){_vm.changeView('productMix')}}},[_vm._v(_vm._s(_vm.$t('gestiune.productMix')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInViewElement.salesMarkup },on:{"click":function($event){_vm.changeView('salesMarkup')}}},[_vm._v(_vm._s(_vm.$t('gestiune.salesMarkup')))])])])])]),_vm._v(" "),(_vm.isInViewElement.isStock)?_c('div',[_c('StockReport',{key:'nirs',attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isInViewElement.isStockHistory)?_c('div',[_c('StockHistoryReport',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isInViewElement.nirs)?_c('div',[_c('NirsReport',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isInViewElement.inventory)?_c('div',[_c('InventoryReport',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isInViewElement.purchase)?_c('div',[_c('PurchaseReport',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isInViewElement.consumption)?_c('div',[_c('ConsumptionReport',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isInViewElement.production)?_c('div',[_c('ProductionReport',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isInViewElement.balance)?_c('div',[_c('BalanceReport',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isInViewElement.stocLaZi)?_c('div',[_c('NirsReport',{key:'stocLaZi',attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions,"extraProp":true}})],1):_vm._e(),_vm._v(" "),(_vm.isInViewElement.productMix)?_c('div',[_c('MixReport')],1):_vm._e(),_vm._v(" "),(_vm.isInViewElement.salesMarkup)?_c('div',[_c('SalesMarkupReport',{attrs:{"groupedLocations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "omsB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Invoice_InvoiceDashboard_vue__ = __webpack_require__("fakT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Invoice_Proforma_Proforma_vue__ = __webpack_require__("mX3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Management_Outputs_ManagementAviz_vue__ = __webpack_require__("t5XZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Management_Outputs_ManagementBonFiscal_vue__ = __webpack_require__("23P3");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Invoice: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Invoice_InvoiceDashboard_vue__["a" /* default */],
    Proforma: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Invoice_Proforma_Proforma_vue__["a" /* default */],
    ManagementAviz: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Management_Outputs_ManagementAviz_vue__["a" /* default */],
    ManagementBonFiscal: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Management_Outputs_ManagementBonFiscal_vue__["a" /* default */]
  },
  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isInvoice: false,
      isProforma: false,
      isAviz: false,
      isBonFiscal: true
    };
  },
  created: function created() {},

  methods: {
    openInvoice: function openInvoice() {
      this.isInvoice = true;
      this.isProforma = false;
      this.isAviz = false;
      this.isBonFiscal = false;
    },
    openProforma: function openProforma() {
      this.isInvoice = false;
      this.isProforma = true;
      this.isAviz = false;
      this.isBonFiscal = false;
    },
    openAviz: function openAviz() {
      this.isInvoice = false;
      this.isProforma = false;
      this.isAviz = true;
      this.isBonFiscal = false;
    },
    openBonFiscal: function openBonFiscal() {
      this.isInvoice = false;
      this.isProforma = false;
      this.isAviz = false;
      this.isBonFiscal = true;
    }
  }
});

/***/ }),

/***/ "oqhj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oqzg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__ = __webpack_require__("AhS5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc19a72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__ = __webpack_require__("0mka");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc19a72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oriL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.waiterTipsReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report waiter-tips-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.waiterTipsMode')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reportMode),expression:"reportMode"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.reportMode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"waiter"}},[_vm._v(_vm._s(_vm.$t('reports.waiterTipsModeWaiter')))]),_vm._v(" "),_c('option',{attrs:{"value":"delivery"}},[_vm._v(_vm._s(_vm.$t('reports.waiterTipsModeDelivery')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.personFilterLabel))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.waiterOptions,"multiple":"","placeholder":_vm.$t('general.alls')},model:{value:(_vm.selectedWaiters),callback:function ($$v) {_vm.selectedWaiters=$$v},expression:"selectedWaiters"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v("\n          "+_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v("\n        "+_vm._s(_vm.$t('reports.filteredData'))+"\n        "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"row mar-bt-15 waiter-tips-summary"},[_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"waiter-tips-stat"},[_c('div',{staticClass:"waiter-tips-stat-label"},[_vm._v(_vm._s(_vm.$t('reports.tips')))]),_vm._v(" "),_c('div',{staticClass:"waiter-tips-stat-value"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.displayedTotals.total_tips || 0))))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"waiter-tips-stat"},[_c('div',{staticClass:"waiter-tips-stat-label"},[_vm._v(_vm._s(_vm.$t('reports.ordersNumber')))]),_vm._v(" "),_c('div',{staticClass:"waiter-tips-stat-value"},[_vm._v(_vm._s(_vm.displayedTotals.order_count || 0))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6"},[_c('div',{staticClass:"waiter-tips-stat"},[_c('div',{staticClass:"waiter-tips-stat-label"},[_vm._v(_vm._s(_vm.$t('reports.waiterTipsZRange')))]),_vm._v(" "),_c('div',{staticClass:"waiter-tips-stat-value"},[_vm._v(_vm._s(_vm.zRangeLabel))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"waiter-tips-sheet"},[(!_vm.loading && !_vm.filteredWaiters.length)?[_c('div',{staticClass:"no-data-message",staticStyle:{"text-align":"center","margin":"20px"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('reports.noDataAvailable')))])])]:_c('table',{staticClass:"waiter-tips-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"col-name"},[_vm._v(_vm._s(_vm.$t('reports.waiterTipsUserName')))]),_vm._v(" "),_c('th',{staticClass:"col-count"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"col-value"},[_vm._v(_vm._s(_vm.$t('reports.waiterTipsValue')))])])]),_vm._v(" "),_vm._l((_vm.pagedWaiters),function(waiter){return _c('tbody',{key:waiter.waiter_id},[_c('tr',{staticClass:"waiter-group-header"},[_c('td',{attrs:{"colspan":"3"}},[_vm._v(_vm._s(waiter.waiter_name))])]),_vm._v(" "),_vm._l((waiter.payment_methods),function(method,methodIndex){return _c('tr',{key:'method-' + waiter.waiter_id + '-' + methodIndex,staticClass:"waiter-method-row",class:methodIndex % 2 === 0 ? 'is-even' : 'is-odd'},[_c('td',{staticClass:"col-name method-label"},[_vm._v(_vm._s(_vm.paymentLabel(method.payment_type)))]),_vm._v(" "),_c('td',{staticClass:"col-count"},[_vm._v(_vm._s(method.order_count))]),_vm._v(" "),_c('td',{staticClass:"col-value"},[_vm._v(_vm._s(_vm.formatTips(method.total_tips)))])])}),_vm._v(" "),_c('tr',{staticClass:"waiter-subtotal-row"},[_c('td',{staticClass:"col-name"},[_vm._v(_vm._s(waiter.waiter_name))]),_vm._v(" "),_c('td',{staticClass:"col-count"},[_vm._v(_vm._s(waiter.total && waiter.total.order_count))]),_vm._v(" "),_c('td',{staticClass:"col-value"},[_vm._v(_vm._s(_vm.formatTips(waiter.total && waiter.total.total_tips)))])])],2)}),_vm._v(" "),(_vm.filteredWaiters.length)?_c('tbody',[_c('tr',{staticClass:"waiter-grand-total-row"},[_c('td',{staticClass:"col-name"},[_vm._v(_vm._s(_vm.$t('reports.total'))+":")]),_vm._v(" "),_c('td',{staticClass:"col-count"},[_vm._v(_vm._s(_vm.displayedTotals.order_count))]),_vm._v(" "),_c('td',{staticClass:"col-value"},[_vm._v(_vm._s(_vm.formatTips(_vm.displayedTotals.total_tips)))])])]):_vm._e()],2),_vm._v(" "),(_vm.filteredWaiters.length)?_c('div',{staticClass:"waiter-tips-pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next, sizes, total","page-sizes":[10, 20, 50, 100],"page-size":_vm.pageSize,"current-page":_vm.currentPage,"total":_vm.filteredWaiters.length},on:{"current-change":_vm.handlePageChange,"size-change":_vm.handleSizeChange}})],1):_vm._e()],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oryI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ota6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__referralRewardSettings__ = __webpack_require__("g/71");






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: { type: Object, required: true },
    allowCoupons: { type: Boolean, default: true },
    title: { type: String, required: true },
    columnClass: { type: String, default: 'col-md-4' },
    fieldId: { type: String, required: true },
    coupons: { type: Array, default: function _default() {
        return [];
      } },
    couponsLoading: { type: Boolean, default: false },
    loyaltyEnabled: { type: Boolean, default: false },
    defaultRewardType: { type: Number, default: 1 },
    error: { type: String, default: '' }
  },
  computed: {
    missingCoupon: function missingCoupon() {
      var _this = this;

      return this.value.coupon_id && !this.coupons.some(function (coupon) {
        return Number(coupon.id) === Number(_this.value.coupon_id);
      });
    },
    summary: function summary() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__referralRewardSettings__["i" /* describeRule */])(this.value, this.$t.bind(this), this.defaultRewardType, this.coupons);
    }
  },
  methods: {
    update: function update(key, value) {
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.value, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, value)));
    },
    changeType: function changeType(type) {
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__referralRewardSettings__["j" /* emptyRule */])(), { type: type, reward_type: this.value.reward_type }));
    }
  }
});

/***/ }),

/***/ "otpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoltMenuLayout_vue__ = __webpack_require__("2zJD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64010738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoltMenuLayout_vue__ = __webpack_require__("PO7A");
function injectStyle (ssrContext) {
  __webpack_require__("xp8n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64010738"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoltMenuLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64010738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoltMenuLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ouLj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marketplace-order-settings"},[(_vm.platform !== 'glovo')?_c('div',{staticClass:"marketplace-order-settings__switches"},[_c('div',{staticClass:"marketplace-action-line"},[_c('label',{attrs:{"for":_vm.platform + '-integration-active'}},[_vm._v(_vm._s(_vm.$t('marketplace.integrationActive')))]),_c('p-switch',{attrs:{"type":"success","name":_vm.platform + '-integration-active',"disabled":_vm.disabled},model:{value:(_vm.formData.active),callback:function ($$v) {_vm.$set(_vm.formData, "active", $$v)},expression:"formData.active"}})],1),_vm._v(" "),_c('div',{staticClass:"marketplace-action-line"},[_c('label',{attrs:{"for":_vm.platform + '-auto-accept'}},[_vm._v(_vm._s(_vm.fieldLabel('is_auto_accept')))]),_c('p-switch',{attrs:{"type":"success","name":_vm.platform + '-auto-accept',"disabled":_vm.disabled},model:{value:(_vm.formData.is_auto_accept),callback:function ($$v) {_vm.$set(_vm.formData, "is_auto_accept", $$v)},expression:"formData.is_auto_accept"}})],1),_vm._v(" "),(_vm.platform === 'bolt')?_c('div',{staticClass:"marketplace-action-line"},[_c('label',{attrs:{"for":"bolt-own-delivery"}},[_vm._v(_vm._s(_vm.fieldLabel('has_own_delivery')))]),_c('p-switch',{attrs:{"type":"success","name":"bolt-own-delivery","disabled":_vm.disabled},model:{value:(_vm.formData.has_own_delivery),callback:function ($$v) {_vm.$set(_vm.formData, "has_own_delivery", $$v)},expression:"formData.has_own_delivery"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.platform === 'bolt')?_c('div',{staticClass:"form-group marketplace-order-settings__buffer"},[_c('label',{attrs:{"for":"bolt-preparation-buffer"}},[_vm._v(_vm._s(_vm.fieldLabel('prep_time_buffer_in_minutes')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.prep_time_buffer_in_minutes),expression:"formData.prep_time_buffer_in_minutes"}],staticClass:"form-control",attrs:{"id":"bolt-preparation-buffer","type":"number","min":"0","disabled":_vm.disabled},domProps:{"value":(_vm.formData.prep_time_buffer_in_minutes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "prep_time_buffer_in_minutes", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row marketplace-order-settings__polling"},[_c('integration-status-polling-field',{attrs:{"form-data":_vm.formData,"disabled":_vm.disabled}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oud0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"mode":"vertical","default-active":"1"}},[_c('el-menu-item-group',{attrs:{"title":"Group One"}},[_c('el-menu-item',{attrs:{"index":"1"}},[_c('i',{staticClass:"el-icon-message"}),_vm._v("Navigator One")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"2"}},[_c('i',{staticClass:"el-icon-message"}),_vm._v("Navigator Two")])],1),_vm._v(" "),_c('el-menu-item-group',{attrs:{"title":"Group Two"}},[_c('el-menu-item',{attrs:{"index":"3"}},[_c('i',{staticClass:"el-icon-message"}),_vm._v("Navigator Three")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"4"}},[_c('i',{staticClass:"el-icon-message"}),_vm._v("Navigator Four")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ow6R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p48S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p4Rg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NexusItems_vue__ = __webpack_require__("j0rp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8c65ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NexusItems_vue__ = __webpack_require__("N7/s");
function injectStyle (ssrContext) {
  __webpack_require__("NNhe")
  __webpack_require__("R4s4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b8c65ed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NexusItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8c65ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NexusItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p7YO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsReport_vue__ = __webpack_require__("aDuw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c1e8ab0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsReport_vue__ = __webpack_require__("jokE");
function injectStyle (ssrContext) {
  __webpack_require__("dNLb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c1e8ab0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p9mx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pAPr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaignOrdersReport_vue__ = __webpack_require__("iJb0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ffd219_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaignOrdersReport_vue__ = __webpack_require__("D81y");
function injectStyle (ssrContext) {
  __webpack_require__("XzuK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11ffd219"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaignOrdersReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ffd219_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaignOrdersReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pAUm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = btSettings;
/* harmony export (immutable) */ __webpack_exports__["c"] = btStatusKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = btApiError;
/* harmony export (immutable) */ __webpack_exports__["d"] = btAmount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);




function btSettings() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ api_user: '', environment: 'sandbox', payment_type: '2phase', has_api_password: false }, settings, { api_password: '' });
}

function btStatusKey(status) {
  return ['created', 'pending', 'captured', 'failed', 'expired', 'reversed', 'refunded', 'authorized', 'partial'][Number(status)] || 'unknown';
}

function btApiError(response, fallback) {
  var body = response && response.error && response.error.response ? response.error.response.data : response;
  if (!body) return fallback;
  if (body.errors && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(body.errors) === 'object') {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(body.errors).map(function (key) {
      return [].concat(body.errors[key]).join(' ');
    }).join(' ');
  }
  return body.message || (typeof body.error === 'string' ? body.error : fallback);
}

function btAmount(minor, currency) {
  var value = Number(minor);
  return (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value) ? (value / 100).toFixed(2) : '—') + ' ' + currency;
}

/***/ }),

/***/ "pAfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('discount-campaign-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pBDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"})])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.$route.params.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteOrderScreen($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":"ID"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.firstname')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.firstname),expression:"modelValidate.firstname"},{name:"model",rawName:"v-model",value:(_vm.model.firstname),expression:"model.firstname"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"John"},domProps:{"value":(_vm.model.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingPromos.lastname')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.lastname),expression:"modelValidate.lastname"},{name:"model",rawName:"v-model",value:(_vm.model.lastname),expression:"model.lastname"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Doe"},domProps:{"value":(_vm.model.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.email),expression:"modelValidate.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"johndoe@gmail.com"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.loginCode')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.login_code),expression:"modelValidate.login_code"},{name:"model",rawName:"v-model",value:(_vm.model.login_code),expression:"model.login_code"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"1234"},domProps:{"value":(_vm.model.login_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "login_code", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('login_code'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.$t('kds.loginCodeNotUnique'))+"\n                  ")]):_vm._e()])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pCH6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n        "+_vm._s(_vm.$t('general.back'))+"\n      ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isEdit)?_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){_vm.saveWasted()}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.casare')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                    "+_vm._s(loc.name)+"\n                  ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gestiune"}},[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonCasare.gestiune),expression:"bonCasare.gestiune"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.bonCasare, "gestiune", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selectează gestiunea")]),_vm._v(" "),_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('option',{key:gestiune.id,domProps:{"value":gestiune.id}},[_vm._v("\n                  "+_vm._s(gestiune.name)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"serie"}},[_vm._v(_vm._s(_vm.$t('invoice.series'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonCasare.serie),expression:"bonCasare.serie"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.bonCasare, "serie", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.handleSerieChange]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selectează seria")]),_vm._v(" "),_vm._l((_vm.seriesOptionsWithAdd),function(serie){return _c('option',{key:serie.id,domProps:{"value":serie.id}},[_vm._v("\n                  "+_vm._s(serie.id === 'add' ? serie.name : ((serie.name) + " - " + (serie.currentNumber)))+"\n                ")])}),_vm._v(" "),(_vm.bonCasare.serie && !_vm.seriesOptionsWithAdd.some(function (s) { return s.id === _vm.bonCasare.serie; }))?_c('option',{domProps:{"value":_vm.bonCasare.serie}},[_vm._v("\n                  "+_vm._s(_vm.bonCasare.serie)+"\n                ")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"lot"}},[_vm._v(_vm._s(_vm.$t('gestiune.lot')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Introdu lotul","disabled":_vm.isEdit},model:{value:(_vm.bonCasare.lot),callback:function ($$v) {_vm.$set(_vm.bonCasare, "lot", $$v)},expression:"bonCasare.lot"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.data'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonCasare.date),expression:"bonCasare.date"}],staticClass:"form-control",attrs:{"type":"datetime-local","name":"date","max":_vm.today,"disabled":!_vm.selectedLocationId},domProps:{"value":(_vm.bonCasare.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bonCasare, "date", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProductInCasare')))]),_vm._v(" "),_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"product-search",staticStyle:{"position":"relative","width":"20%","margin-bottom":"25px"}},[(!_vm.isEdit)?_c('v-select',{staticStyle:{"width":"100%","position":"relative"},attrs:{"disabled":!_vm.selectedLocationId,"options":_vm.searchResults,"label":"label","placeholder":"Caută un produs...","filterable":true},on:{"search":_vm.fetchProducts,"input":_vm.onProductSelect},model:{value:(_vm.searchProdName),callback:function ($$v) {_vm.searchProdName=$$v},expression:"searchProdName"}}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1),_vm._v(" "),(_vm.selectedProducts.length > 0)?_c('table',{staticClass:"tree-table"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"25%"}},[_vm._v("Produs")]),_vm._v(" "),_c('th',{staticStyle:{"width":"55%"}},[_vm._v("Structură Stoc (Grupuri → Intrări)")]),_vm._v(" "),(!_vm.isEdit)?_c('th',{staticStyle:{"width":"20%"}},[_vm._v("Acțiuni")]):_vm._e()])]),_vm._v(" "),_c('tbody',[_vm._m(0),_vm._v(" "),_vm._l((_vm.selectedProducts),function(item,index){return [_c('tr',{key:'product-' + item.product._id,staticClass:"product-row"},[_c('td',{staticClass:"product-cell",attrs:{"colspan":"2"}},[_c('div',{staticStyle:{"font-weight":"600","font-size":"16px"}},[_vm._v("\n                    "+_vm._s(item.product.name)+"\n                    "),_c('span',{staticClass:"badge-um"},[_vm._v(_vm._s(item.product.um))])])]),_vm._v(" "),(!_vm.isEdit)?_c('td',{staticClass:"actions-cell"},[_c('button',{staticClass:"btn btn-danger btn-sm action-button",attrs:{"title":"Șterge produs"},on:{"click":function($event){_vm.removeProduct(index)}}},[_vm._v("\n                    Șterge Produs\n                  ")])]):_vm._e()]),_vm._v(" "),_c('tr',{key:'tree-' + item.product._id},[_c('td',{staticClass:"tree-content-cell",attrs:{"colspan":"3"}},[_vm._l((item.stockGroups),function(group,groupIndex){return [_c('div',{key:'group-' + groupIndex,staticClass:"group-branch"},[_c('div',{staticClass:"group-header"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('div',[_c('strong',{staticStyle:{"color":"#28a745"}},[_vm._v("Lot:")]),_vm._v(" "+_vm._s(group.lot || 'N/A')+"\n                          ")]),_vm._v(" "),(group.price != null)?_c('div',[_c('strong',{staticStyle:{"color":"#0066cc"}},[_vm._v("Preț:")]),_vm._v(" "+_vm._s(group.price)+" "+_vm._s(group.currency)+"\n                          ")]):_vm._e()])]),_vm._v(" "),_vm._l((group.entries),function(entry,entryIndex){return _c('div',{key:'entry-' + entry.id,staticClass:"entry-branch"},[_c('div',{staticClass:"entry-row"},[_c('div',{staticClass:"entry-field",staticStyle:{"flex":"2"}},[_c('label',[_vm._v("Document")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(entry.document_type || entry.id))])]),_vm._v(" "),_c('div',{staticClass:"entry-field",staticStyle:{"flex":"0.8"}},[_c('label',[_vm._v("UM")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(entry.um || item.product.um))])]),_vm._v(" "),_c('div',{staticClass:"entry-field",staticStyle:{"flex":"1"}},[_c('label',[_vm._v("Disponibil")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(entry.available_quantity))])]),_vm._v(" "),_c('div',{staticClass:"entry-field",staticStyle:{"flex":"1.5"}},[_c('label',[_vm._v("Cant. Casare")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(entry.cantitate_casare),expression:"entry.cantitate_casare",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"type":"number","min":"0","disabled":_vm.isEdit,"max":entry.available_quantity,"placeholder":"Introduce"},domProps:{"value":(entry.cantitate_casare)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(entry, "cantitate_casare", _vm._n($event.target.value))},function($event){_vm.validateCasare(entry)}],"blur":function($event){_vm.$forceUpdate()}}})])])])}),_vm._v(" "),(group.total_quantity && group.total_value)?_c('div',{staticClass:"group-total"},[_c('div',[_vm._v("Total cantitate: "),_c('strong',[_vm._v(_vm._s(group.total_quantity))])]),_vm._v(" "),_c('div',[_vm._v("\n                          Total valoare:\n                          "),_c('strong',[_vm._v(_vm._s(new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(group.total_value))+" "+_vm._s(group.currency))])])]):_vm._e()],2)]})],2)])]})],2)]):_vm._e()])])]),_vm._v(" "),_c('ManagementSeriesAdd',{attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations,"vat-number":_vm.selectedLocation ? _vm.selectedLocation.inv_fiscal_code : ''},on:{"getSeries":_vm.getSeries}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticStyle:{"height":"3px"}},[_c('td',{attrs:{"colspan":"3"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pHsS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row glovo-laas-integration-form"},[(_vm.isCreateMode)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"glovo-laas-integration-form__setup",attrs:{"role":"status"}},[_c('p',{staticClass:"glovo-laas-integration-form__setup-title"},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsGlovoLaasSetupTitle')))]),_vm._v(" "),_c('ol',{staticClass:"glovo-laas-integration-form__setup-steps"},[_c('li',[_vm._v("\n          "+_vm._s(_vm.$t('gestiune.integrationsGlovoLaasSetupStep1'))+"\n          "),_c('a',{attrs:{"href":"https://laaspartners.glovoapp.com/orders","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("https://laaspartners.glovoapp.com/orders")])]),_vm._v(" "),_c('li',[_vm._v("\n          "+_vm._s(_vm.$t('gestiune.integrationsGlovoLaasSetupStep2'))+"\n          "),_c('a',{attrs:{"href":"https://portal.integrations.cloud.onlineservice.io/partner","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("https://portal.integrations.cloud.onlineservice.io/partner")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('location_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('location_id'))),(_vm.isRequired('location_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.location_id),expression:"formData.location_id"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "location_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:'glovo-laas-loc-' + String(loc._integrationLocationId),class:{ 'integration-location-option--occupied': _vm.isLocationOccupied(loc._integrationLocationId) },attrs:{"disabled":_vm.isLocationOccupied(loc._integrationLocationId)},domProps:{"value":loc._integrationLocationId}},[_vm._v("\n          "+_vm._s(_vm.locationOptionLabel(loc))+"\n        ")])})],2),_vm._v(" "),(_vm.showFieldError('location_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('location_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('api_url') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('api_url'))),(_vm.isRequired('api_url'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.api_url),expression:"formData.api_url"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.api_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "api_url", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('api_url'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('api_url')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('pos_implementation_name') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('pos_implementation_name'))),(_vm.isRequired('pos_implementation_name'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.pos_implementation_name),expression:"formData.pos_implementation_name"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.pos_implementation_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "pos_implementation_name", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('pos_implementation_name'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('pos_implementation_name')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('brand_name') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('brand_name'))),(_vm.isRequired('brand_name'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.brand_name),expression:"formData.brand_name"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.brand_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "brand_name", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('brand_name'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('brand_name')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('laas_client_id') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('laas_client_id'))),(_vm.isRequired('laas_client_id'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.laas_client_id),expression:"formData.laas_client_id"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.laas_client_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "laas_client_id", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('laas_client_id'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('laas_client_id')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('laas_client_secret') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('laas_client_secret'))),(_vm.isRequired('laas_client_secret'))?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.laas_client_secret),expression:"formData.laas_client_secret"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":(_vm.formData.laas_client_secret)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "laas_client_secret", $event.target.value)}}}),_vm._v(" "),(_vm.showFieldError('laas_client_secret'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('laas_client_secret')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"glovo-laas-integration-form__auto-send-row"},[_c('div',{staticClass:"glovo-laas-integration-form__auto-send-status"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('auto_send_at_status') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('auto_send_at_status')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.auto_send_at_status),expression:"formData.auto_send_at_status"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "auto_send_at_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.autoSendStatusOptions),function(opt){return _c('option',{key:'glovo-laas-status-' + opt.value,domProps:{"value":opt.value}},[_vm._v("\n              "+_vm._s(opt.label)+"\n            ")])})),_vm._v(" "),(_vm.showFieldError('auto_send_at_status'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('auto_send_at_status')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"glovo-laas-integration-form__auto-send-time"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.showFieldError('auto_send_time') }},[_c('label',[_vm._v(_vm._s(_vm.fieldLabel('auto_send_time')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.auto_send_time),expression:"formData.auto_send_time"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled || _vm.isAutoSendManual},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "auto_send_time", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.autoSendTimeOptions),function(mins){return _c('option',{key:'glovo-laas-time-' + mins,domProps:{"value":mins}},[_vm._v("\n              "+_vm._s(mins)+"\n            ")])})),_vm._v(" "),(_vm.showFieldError('auto_send_time'))?_c('span',{staticClass:"text-danger help-block"},[_vm._v(_vm._s(_vm.fieldErrorMessage('auto_send_time')))]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pJrd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px","margin-bottom":"0"},on:{"click":function($event){$event.preventDefault();_vm.handleDelete('delete')}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px","margin-bottom":"0"},on:{"click":function($event){$event.preventDefault();_vm.handleDelete('cancel')}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.cancel'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('menuLink.title')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.title),expression:"modelValidations.title"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('menuLink.title')},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}})]),_vm._v(" "),(_vm.errors.has('title'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('title'))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',[_c('label',{staticClass:"pad-to-10"},[_vm._v(_vm._s(_vm.$t('menuLink.alias')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.alias),expression:"model.alias"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.alias),expression:"modelValidations.alias"}],staticClass:"form-control",attrs:{"name":"alias"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "alias", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.aliases),function(alias,index){return [_c('option',{key:index,domProps:{"value":alias,"selected":index === _vm.model.alias && !_vm.isNew()}},[_vm._v(_vm._s(_vm.$t('menuLink.' + alias))+"\n                    ")])]})],2),_vm._v(" "),(_vm.errors.has('alias'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('alias'))+"\n                ")]):_vm._e()])]),_vm._v(" "),(_vm.model.alias =='custom')?[_c('label',{staticClass:"pad-to-10"},[_vm._v(_vm._s(_vm.$t('menuLink.externUrl')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.external_url),expression:"model.external_url"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('menuLink.externUrl')},domProps:{"value":(_vm.model.external_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "external_url", $event.target.value)}}})])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":1,"file-list":_vm.model.image,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pLD+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pLVm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Newsletter_Tabs_News_vue__ = __webpack_require__("Ynvi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Newsletter_Tabs_MonthlyInfo_vue__ = __webpack_require__("hbV7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Newsletter_Tabs_VideoSupport_vue__ = __webpack_require__("tRiA");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    News: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Newsletter_Tabs_News_vue__["a" /* default */],
    MonthlyInfo: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Newsletter_Tabs_MonthlyInfo_vue__["a" /* default */],
    VideoSupport: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Newsletter_Tabs_VideoSupport_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isTitleNews: false,
      isTitleMonthlyInfo: false,
      isTitleVideoSupport: false,
      hasNewFiles: false
    };
  },
  mounted: function mounted() {
    this.switchTab();
  },
  created: function created() {
    this.fetchNews();
  },

  methods: {
    resetStates: function resetStates() {
      this.isTitleNews = false;
      this.isTitleMonthlyInfo = false;
      this.isTitleVideoSupport = false;
    },
    switchTab: function switchTab() {
      var _this = this;

      var index = this.$route.query.tabIndex;
      this.$nextTick(function () {
        if (index && _this.$refs.tabs) {
          _this.$refs.tabs.navigateToTab(parseInt(index));
        }
      });
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      this.resetStates();
      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);
      switch (newTab.title) {
        case this.$t('newsletterCard.titleNews'):
          this.isTitleNews = true;
          break;
        case this.$t('newsletterCard.titleMonthlyInfo'):
          this.isTitleMonthlyInfo = true;
          break;
        case this.$t('newsletterCard.titleVideoSupport'):
          this.isTitleVideoSupport = true;
          break;
        default:
          this.isTitleNews = true;
          break;
      }
    },
    fetchNews: function fetchNews() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  data = {
                    token: _this2.$session.get('token')
                  };

                  _this2.apiRequest('/pdf-files/new', 'GET', data, function (response) {
                    if (response.status === true) {
                      _this2.hasNewFiles = response.data;
                    }
                  });
                } catch (error) {
                  console.error('Error fetching new files status (Catch):', error.response);
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "pLZ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons "},[_c('div',{staticClass:"left-buttons mar-rt-10"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[(_vm.groupedLocations)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date și oră")]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"disabled":_vm.loading || !_vm.selectedGestiune,"placeholder":"Selectează intervalul"},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"right-buttons",staticStyle:{"display":"flex","align-items":"center","justify-content":"flex-end"}},[_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.triggerFilter}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.fetchSalesMarkupReport('xls')}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"tableInvoice",staticStyle:{"overflow-x":"auto"}},[(_vm.tableData && _vm.tableData.length)?_c('div',{staticClass:"consumption-total-header"},[_c('strong',[_vm._v("TOTAL ADAOS:")]),_vm._v("\n            "+_vm._s(_vm.totalItems)+" produse —\n            "),_c('strong',[_vm._v(_vm._s(_vm.totalValue.toFixed(2))+" lei")])]):_vm._e(),_vm._v(" "),_c('el-table',{staticStyle:{"min-width":"max-content"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.openViewSalesMarkup}},[_c('el-table-column',{attrs:{"prop":"product_name","label":_vm.$t('gestiune.product'),"min-width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.cantitate'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.quantity > 0 ? Number(scope.row.quantity).toFixed(2) : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"UM","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.unit || '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Preț intrare","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.in_price > 0)?_c('span',[_vm._v("\n                  "+_vm._s(Number(scope.row.in_price).toFixed(2))+" lei\n                ")]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Preț vânzare","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.sale_price > 0)?_c('span',[_vm._v("\n                  "+_vm._s(Number(scope.row.sale_price).toFixed(2))+" lei\n                ")]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"TVA %","min-width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.vat_percent > 0 ? scope.row.vat_percent + '%' : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"TVA valoare","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.vat_value > 0)?_c('span',[_vm._v("\n                  "+_vm._s(Number(scope.row.vat_value).toFixed(2))+" lei\n                ")]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Discount","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.discount_value > 0)?_c('span',[_vm._v("\n                  "+_vm._s(Number(scope.row.discount_value).toFixed(2))+" lei\n                ")]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Discount TVA","min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.discount_vat_value > 0)?_c('span',[_vm._v("\n                  "+_vm._s(Number(scope.row.discount_vat_value).toFixed(2))+" lei\n                ")]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Adaos","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.markup_value > 0)?_c('span',[_vm._v("\n                  "+_vm._s(Number(scope.row.markup_value).toFixed(2))+" lei\n                ")]):_c('span',[_vm._v("-")])]}}])})],1)],1)])]),_vm._v(" "),_c('vmodal',{ref:"salesMarkupModal",staticClass:"salesMarkupModal",attrs:{"name":"salesMarkupModal","height":"auto","width":"1200"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v("Detalii produs: "+_vm._s(_vm.selectedProduct.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.selectedProduct.purchaseDocuments}},[_c('el-table-column',{attrs:{"label":"Cantitate"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.quantity).toFixed(2))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unit","label":"UM"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Preț intrare"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.in_price).toFixed(2))+" lei\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Preț vânzare"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.sale_price).toFixed(2))+" lei\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"TVA %"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.vat_percent)+"%\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"TVA valoare"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.vat_value).toFixed(2))+" lei\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Discount"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.discount_value).toFixed(2))+" lei\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Discount TVA"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.discount_vat_value).toFixed(2))+" lei\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Adaos"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.markup_value).toFixed(2))+" lei\n              ")]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closesalesMarkupModal}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pMOA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.title')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],staticClass:"form-control",attrs:{"type":"text","name":"title","placeholder":_vm.$t('marketingOffers.title')},domProps:{"value":(_vm.model.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.startEndDate')))]),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":_vm.pickerOptions},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}}),_vm._v(" "),(_vm.errors.has('date_start'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('date_start'))+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.image')))]),_vm._v(" "),_c('el-upload',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.imagelist),expression:"modelValidations.imagelist"}],ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChange,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize'))+_vm._s(_vm.$t('validations.imageResolution')))])]),_vm._v(" "),(_vm.errors.has('image'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('image'))+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.imageWeb')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":1,"file-list":_vm.model.imageWeb,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChangeWeb,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemoveWeb,"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize'))+_vm._s(_vm.$t('validations.imageResolutionWeb')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.linkType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.link_type),expression:"model.link_type"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "link_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.clearLinkSelection()}]}},[_c('option',[_vm._v("- "+_vm._s(_vm.$t('general.select'))+" -")]),_vm._v(" "),_c('option',{attrs:{"value":"category"}},[_vm._v(_vm._s(_vm.$t('marketingOffersTypes.category')))]),_vm._v(" "),_c('option',{attrs:{"value":"product"}},[_vm._v(_vm._s(_vm.$t('marketingOffersTypes.product')))]),_vm._v(" "),_c('option',{attrs:{"value":"page"}},[_vm._v(_vm._s(_vm.$t('marketingOffersTypes.page')))])]),_vm._v(" "),(_vm.errors.has('link_type'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('link_type'))+"\n            ")]):_vm._e()]),_vm._v(" "),(_vm.model.link_type == 'page')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.pageText')))]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.description),expression:"modelValidations.description"},{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"5","name":"description","placeholder":""},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('description'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('description'))+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.link_type == 'category')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.pickCateg')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.link_id),expression:"model.link_id"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "link_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null,"selected":true}},[_vm._v(_vm._s(_vm.$t('marketingOffers.none')))]),_vm._v(" "),_vm._l((_vm.categories),function(option){return [_c('option',{key:option.id,attrs:{"label":option.name},domProps:{"selected":option.id === _vm.model.link_id,"value":option.id}})]})],2),_vm._v(" "),(_vm.errors.has('link_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('link_id'))+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.model.link_type == 'product')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.pickProd')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.link_id),expression:"model.link_id"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "link_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null,"selected":true}},[_vm._v(_vm._s(_vm.$t('marketingOffers.none')))]),_vm._v(" "),_vm._l((_vm.products),function(option){return [_c('option',{key:option.id,attrs:{"label":option.name},domProps:{"selected":option.id === _vm.model.link_id,"value":option.id}})]})],2),_vm._v(" "),(_vm.errors.has('link_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('link_id'))+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.locations.length > 1)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.pickLoc')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.locations,"label":"name","placeholder":_vm.$t('general.all')},model:{value:(_vm.model.location_ids),callback:function ($$v) {_vm.$set(_vm.model, "location_ids", $$v)},expression:"model.location_ids"}})],1):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"offer_id"},domProps:{"value":_vm.$route.params.offer_id}})])])]),_vm._v(" "),_c('div',{staticClass:"card-footer "},[_c('button',{staticClass:"btn btn-icon btn-success",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('i',{staticClass:"ti-save"})]),_vm._v(" "),(!_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-icon",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.handleDelete(_vm.$t('general.delete'))}}},[_c('i',{staticClass:"ti-close"})]):_vm._e(),_vm._v(" "),(_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-icon",attrs:{"title":_vm.$t('general.cancel')},on:{"click":function($event){$event.preventDefault();_vm.handleDelete(_vm.$t('general.cancel'))}}},[_c('i',{staticClass:"ti-close"})]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pPlW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isEntries },on:{"click":_vm.openEntries}},[_vm._v(_vm._s(_vm.$t('gestiune.docFurnizori')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isInvoiceSupplier },on:{"click":_vm.openInvoiceSupplier}},[_vm._v(_vm._s(_vm.$t('invoice.invoiceSupplier')))])])])])]),_vm._v(" "),(_vm.isEntries)?_c('div',[_c('ManagementEntries',{attrs:{"groupedLocations":_vm.groupedLocations}})],1):_vm._e(),_vm._v(" "),(_vm.isInvoiceSupplier)?_c('div',[_c('ManagementInvoiceSupplier',{attrs:{"groupedLocations":_vm.groupedLocations}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pQ2v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"category-top-bar",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return (function () {_vm.$router.push('/feedback')})($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.saveComment($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-12 pad-to-15"},[_c('div',{staticClass:"card feedback-card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7 feedback-sides"},[_c('p',{staticClass:"feedback-top"},[_c('span',{staticClass:"label",class:'label-' + _vm.feedbackTypeClass(_vm.message.type)},[_vm._v(_vm._s(_vm.$t('feedbackTypes.' + _vm.message.type)))]),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.formatDateTime(_vm.message.created_at)))]),_vm._v(" "),(_vm.message.location)?_c('span',{staticClass:"time"},[_c('span',{staticClass:"text-bold"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "+_vm._s(_vm.message.location))]):_vm._e()]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.message.creater.firstname ? _vm.message.creater.firstname : '')+" "+_vm._s(_vm.message.creater.lastname ? _vm.message.creater.lastname : ''))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.message.text))]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group mt-5"},[_c('label',[_vm._v(_vm._s(_vm.$t('feedback.response')))]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(_vm.message.admin_response),expression:"message.admin_response"}],staticClass:"form-control",attrs:{"name":"adminResponse","rows":"6","placeholder":_vm.$t('feedback.response')},domProps:{"value":(_vm.message.admin_response)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.message, "admin_response", $event.target.value)}}}),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('feedback.send'))+".\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 feedback-sides"},[_c('h6',{staticClass:"mar-to-0"},[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/user-sm.png"}}),_vm._v("  "+_vm._s(_vm.$t('customers.title')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 details-label"},[_c('span',[_vm._v(_vm._s(_vm.$t('customers.name')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.message.creater.firstname ? _vm.message.creater.firstname : '')+" "+_vm._s(_vm.message.creater.lastname ? _vm.message.creater.lastname : ''))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 details-label"},[_c('span',[_vm._v(_vm._s(_vm.$t('customers.email')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.message.creater.email ? _vm.message.creater.email : '-'))])]),_vm._v(" "),_c('div',{staticClass:"row pad-bt-10"},[_c('div',{staticClass:"col-lg-4 col-sm-5 col-xs-12 details-label"},[_c('span',[_vm._v(_vm._s(_vm.$t('customers.phone')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-sm-7 col-xs-12"},[_vm._v(_vm._s(_vm.message.creater.phone ? _vm.message.creater.phone : '-'))])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pUJd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__("8VFO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73470336_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__("R2fV");
function injectStyle (ssrContext) {
  __webpack_require__("8DTi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73470336_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pWAP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pWD6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pYFp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromosEdit_vue__ = __webpack_require__("jL9f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65336e82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromosEdit_vue__ = __webpack_require__("ytkV");
function injectStyle (ssrContext) {
  __webpack_require__("H/7z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromosEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65336e82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromosEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pYrY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'r3'
});

/***/ }),

/***/ "pa/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__ = __webpack_require__("bx0x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094478c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__ = __webpack_require__("whIq");
function injectStyle (ssrContext) {
  __webpack_require__("bFdq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094478c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pbbe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pdgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WEEK_DAYS */
/* harmony export (immutable) */ __webpack_exports__["a"] = createDefaultAvailableDays;
/* unused harmony export normalizeTimeValue */
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeAvailableDays;
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareAvailableDaysForSave;
/* harmony export (immutable) */ __webpack_exports__["c"] = validateAvailableDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


var WEEK_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

function createDefaultAvailableDays() {
  return WEEK_DAYS.map(function (day) {
    return {
      day: day,
      open: true,
      open_from: '10:00',
      open_to: '22:00',
      intervals: []
    };
  });
}

function normalizeTimeValue(val) {
  if (val === null || val === undefined) return '';
  if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(val)) === 'object' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(val).length === 0) return '';
  if (Array.isArray(val) && val.length === 0) return '';
  return val;
}

function normalizeAvailableDays(apiDays) {
  var byDay = {};
  if (Array.isArray(apiDays)) {
    apiDays.forEach(function (day) {
      if (day && day.day) {
        byDay[day.day] = {
          day: day.day,
          open: !!day.open,
          open_from: normalizeTimeValue(day.open_from),
          open_to: normalizeTimeValue(day.open_to),
          intervals: Array.isArray(day.intervals) ? day.intervals.map(function (interval) {
            return {
              open_from: normalizeTimeValue(interval.open_from),
              open_to: normalizeTimeValue(interval.open_to)
            };
          }) : []
        };
      }
    });
  }

  return WEEK_DAYS.map(function (day) {
    if (byDay[day]) {
      return byDay[day];
    }
    return {
      day: day,
      open: false,
      open_from: '',
      open_to: '',
      intervals: []
    };
  });
}

function prepareAvailableDaysForSave(availableDays) {
  return WEEK_DAYS.map(function (dayName) {
    var source = (availableDays || []).find(function (d) {
      return d.day === dayName;
    }) || {
      day: dayName,
      open: false,
      open_from: '',
      open_to: '',
      intervals: []
    };

    if (!source.open) {
      return {
        day: dayName,
        open: false,
        open_from: null,
        open_to: null,
        intervals: []
      };
    }

    var intervals = (source.intervals || []).map(function (interval) {
      return {
        open_from: normalizeTimeValue(interval.open_from),
        open_to: normalizeTimeValue(interval.open_to)
      };
    }).filter(function (interval) {
      return interval.open_from && interval.open_to;
    });

    return {
      day: dayName,
      open: true,
      open_from: normalizeTimeValue(source.open_from),
      open_to: normalizeTimeValue(source.open_to),
      intervals: intervals
    };
  });
}

function validateAvailableDays(availableDays) {
  var errors = [];(availableDays || []).forEach(function (day) {
    if (!day.open) return;

    if (!normalizeTimeValue(day.open_from) || !normalizeTimeValue(day.open_to)) {
      errors.push(day.day);
      return;
    }

    ;(day.intervals || []).forEach(function (interval) {
      var from = normalizeTimeValue(interval.open_from);
      var to = normalizeTimeValue(interval.open_to);
      if (from && !to || !from && to) {
        errors.push(day.day);
      }
    });
  });

  return errors.length === 0;
}

/***/ }),

/***/ "pe4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__btPayments__ = __webpack_require__("OQGY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platformMenuImport__ = __webpack_require__("NGTP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Integrations_marketplaceLabels__ = __webpack_require__("Qn0H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_ro__ = __webpack_require__("jU9l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_ro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_ro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_el__ = __webpack_require__("6YPE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_el___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_el__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_nl__ = __webpack_require__("Ti3X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_nl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_nl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_it__ = __webpack_require__("zGag");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_de__ = __webpack_require__("18iE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_de__);
var messages={en:__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({btPayments:__WEBPACK_IMPORTED_MODULE_1__btPayments__["a" /* default */].en,zoneAvailability:{title:'Zone availability',active:'Active zone',activeHelp:'An inactive zone is not available for delivery (addresses inside it are treated as outside the delivery area).',inactive:'Inactive',activeColumn:'Active',scheduleEnabled:'Enable hour schedule',scheduleEnabledHelp:'When off, the zone works as before (available whenever the location delivers). When on, the zone is available only in the intervals below.',withSchedule:'Schedule',column:'Availability',hoursRequired:'Set the start and end hour for every interval of the open days.',hoursOrder:'The start hour must be earlier than the end hour.',overlap:'The intervals of a day must not overlap.',noOpenDay:'Select at least one open day for the schedule (or make the zone inactive).',zoneLabel:'Zone'},marketplace:__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Integrations_marketplaceLabels__["a" /* default */].en,platformMenuImport:__WEBPACK_IMPORTED_MODULE_2__platformMenuImport__["a" /* default */].en,deliveryPreferences:{deliveryTypeTitle:'Delivery preferences',zonesTitle:'Zones',slotsTitle:'Slots',preferencesTitle:'Delivery type',name:'External name (shown in app)',numeAdmin:'Internal name',numeAdminPlaceholder:'e.g. Standard delivery for location X',add:'Add',edit:'Edit',clone:'Clone',back:'Back',noData:'No records yet',saved:'Saved',deleteConfirm:'Are you sure you want to delete this record?',drawShapeRequired:'Draw a zone on the map before saving.',seatsRequired:'Fill in all the seats rows (count and price).',duplicateZone:'This zone is already added.',zoneRequired:'Add at least one delivery zone.',hoursRequired:'Set the start and end hours for the active days/rows.',hoursOrder:'The start time must be earlier than the end time.',slotRequired:'Select a slot for the active rows.',slotAdd:'Add slot',slotSingle:'slot',costPerParte:'Cost per part (optional urgency fee)',costPerParteHelp:'If set, the customer can pick which part of the slot to be served in (first / last) for this extra fee.',seats:'Seats',seatsCount:'Number of seats (0 = unlimited)',seatCost:'Price',addSeatTier:'Add seats row',seatsHelp:'Seats are taken cheapest first; the later a customer books, the higher the price.',zoneAdd:'Add zone',zoneSingle:'zone',companyZone:'Company zone',locationZone:'Location zone',legacyReadonly:'Legacy location zone — read-only. Clone it to use it in the new system.',cloneName:'New zone name',showOtherZones:'Show other zones on the map',showOtherZonesPlaceholder:'Pick zones to display for reference',shippingCost:'Shipping cost',minOrderValue:'Minimum order value',extraDeliveryTime:'Extra delivery time (min)',preferenceAdd:'Add delivery type',preferenceSingle:'preference',type:'Type',typeClassic:'Classic',typeSlot:'Slot',typeClassicHelp:'The customer can pick — based on the options below — an exact date/time, or the variant without date and time.',typeSlotHelp:'Several slots are shown and the customer picks the one that fits.',enabled:'Enabled',hourMode:'Hours & date',hourModeHourDate:'Hour and date',hourModeDateOnly:'Date only',hourModeDisabled:'Disable hour and date',hourModeHourDateHelp:'The customer picks the time and date (date only when offset and period are not 0 and 1).',hourModeDateOnlyHelp:'The customer picks only the date.',hourModeDisabledHelp:"The customer picks nothing — delivery follows the restaurant's delivery schedule. In this mode the schedule isn't available either: the customer places the order and is notified when it will arrive.",offsetPeriodHelp:'Offset = number of working (open) days from now until the customer is allowed to order. Period = number of working (open) days after the offset ends during which the customer can order. E.g. offset 1, period 2 → today they can only order for tomorrow and the day after; if today is closed, counting starts from the next open day.',availableDays:'Available days',noPreorders:'Accept orders only during working hours',isAlwaysOpen:'Non-stop working hours',minimumOrderValue:'Minimum order value',defaultWaitingTime:'Minimum interval before closing (prep + delivery time)',autoAssignFirstSlot:"Don't let the customer pick the slot, assign the first available one",delayHours:'Delay (hours)',delayHoursHelp:'Customers can only pick slots that start at least this many hours from now.',schedule:'Weekly schedule',addScheduleRow:'Add slot',slot:'Slot',selectSlot:'Select slot',startTime:'Start',endTime:'End',active:'Active',closedDates:'Calendar override of the delivery schedule',closedDatesHelp:'For a specific date you can stop deliveries for the whole day or replace the weekly schedule with a schedule of its own (slots and hours, just like the weekly one), e.g. holidays.',closedAllDay:'Closed all day',closedOverrideSchedule:'Override schedule',closedNoDelivery:'No delivery on this day',closedEmpty:'No calendar overrides added.',closedScheduleEmpty:'No slots added for this day yet.',closedScheduleRequired:'Add at least one slot to every overridden day (or choose "Closed all day").',closedCopyWeekly:'Copy the {day} schedule',closedCopyConfirm:'Replace this day\'s slots with the weekly {day} schedule?',closedDateDuplicate:'The same date is added more than once in the calendar override.',addClosedDate:'Add date',zones:'Delivery zones',selectZone:'Select zone',noZone:'No zone',methods:'Delivery methods',mon:'Monday',tue:'Tuesday',wed:'Wednesday',thu:'Thursday',fri:'Friday',sat:'Saturday',sun:'Sunday',useMultiplePreferences:'Use multiple delivery types',useMultiplePreferencesHelp:'When enabled, this method uses the new delivery types below instead of the classic settings.',selectPreferences:'Delivery type'},general:{noAccessRaport:'Permission for reports is required!',noAccessUsers:'Only administrators have access to users',contactAdmin:'Contact the administrator',tips_department_id:'Department Id',addConversion:'Add Conversion',selectUnit:'Select Unit',download:'Download',see:'Look',visualize:'View',search:'Search',home:'Home',add:'Add',edit:'Edit',delete:'Delete',remove:'Remove',save:'Save',saveAndSend:'Save & Send',fillRequiredFields:'Fill required fields',update:'Update',cancel:'Cancel',copy:'Copy',close:'Close',details:'Details',cancel2:'Cancel',continue:'Continue',activate:'Activate',deactivate:'Deactivate',active:'active',inactive:'inactive',specialPrice:'Special Price',removePhoto:'Too many images uploaded',download_xls:'export to xls',download_pdf:'export to pdf',detail:'Detail',yes:'Yes',no:'No',success:'Success',required:'Required',back:'Back',next:'Next',finish:'Finish',duplicate:'Duplicate',select:'Select',all:'All',alls:'All',reset:'Reset',export:'Export',loadMore:'Load More',viewDetails:'View Details',showing:'Showing {length} result(s)',action:'Action',enable:'activate',disable:'deactivate',generalLoader:'Please wait...',no_data:'Not Found',product:'product',logout:'Logout',from:'from ',to:'to ',cancelCourier:'Cancel courier',agree:'Agree',agreePopupMessage:'To allow the browser to play audio you need to click "Agree". This will play a test sound in order to activate sound play.',orderLocaionNoDriverLocation:'Careful! The order location does not correspond to the driver\'s location',day:'day',notCompleted:'not completed',saveChanges:'Save Changes',doYouWantToLogout:'Do you want to logout?',minutes:'minutes',hour:'hour',hours:'hours',customSort:'Company use custom sort',deliveryMethod:'Delivery Methods',none:'None',unset:'Unset',included:'Included',error:'Error',logo:'Logo',appImage:'App image',copyToClipboard:'Copy to Clipboard',copyUrlToClipboard:'Copy URL',start:'Start',actions:'Actions',leavePageQuestion:'Unsaved changes will be lost. Are you sure you want to leave the page?',sortOrder:'Sort',sortCreatedAscending:'Order Placed: Oldest First',sortCreatedDescending:'Order Placed: Newest First',sortPickupAscending:'Expected Delivery: Earliest First',sortPickupDescending:'Expected Delivery: Latest First',wallet:'Load wallet',walletAdd:'Add amount to wallet',walletRemove:'Unload wallet',walletAddFor:'Add the amount for',walletRemoveFor:'Remove the amount for',walletPlaceholder:'Enter the amount:',walletSuccess:'The amount has been added to your wallet!',walletRemoved:'The amount has been removed to your wallet!',walletError:'An error occurred while adding the amount.',invalidAmount:'Please enter a valid number',amountExceedsBalance:'The amount exceeds the current wallet balance',changeOrderLocationSuccess:'The location has been successfully updated!',changeOrderLocationFailed:'Failed to update the location. Please try again.',generalAreYouSure:'Are you sure?',set:'Set',regenerateQr:'Regenerate QR Code',noProduct:'There are no products',noProductPos:'Select an item from the menu to begin.',applyPoints:'Use Loyalty Points',loyaltyPoints:'Loyalty Points:',apply:'Apply',load:'Load',reload:'Reload',retry:'Retry',normal:'Normal',big:'Big',registrationDate:'Registration Date',accept:'Accept',deny:'Deny',accepted:'Accepted',denied:'Denied',pending:'Pending',completed:'Completed',contactSuportFeature:'Contact support for this feature',administration:'Inventory',noAdministrationsAvailable:'No Inventory available',setAdministration:'Press "Add" to set an Inventory',loading:'Please wait',justMoment:'It may take a moment',orderId:'Order ID',year:'Year',month:'Month',segment:'Current Segment',selectAll:'Select all',deselectAll:'Deselect all',confirm:'Confirm',ok:'OK',validate:'Validate',noResults:'No results.',clearSelection:'Clear selection',associateTables:'Associate tables',associateChooseUsers:'1) Choose users',associateChooseTables:'2) Choose tables',selected:'Selected',emDash:'\u2014',idHash:'#{id}',breadcrumbSeparator:' \xBB ',statusUnknown:'Unknown status',modulesActivate:'Active modules',ecosystem:'TAPTASTY ECOSYSTEM',ecosystem_more_than_you_use:'Taptasty is more than what you are currently using.',how_much_you_use:'How much you use',only_this_much_you_use:'Is this all you use?',you_use_full_system:'You are using the full system',all_taptasty_modules:'All TapTasty modules',modules_reservations:'Reservations',modules_tables:'Tables',modules_dispatch:'Dispatch',modules_kds:'KDS',modules_pms:'PMS',modules_catalog:'Catalog',modules_screens:'Screens',modules_pos:'POS',modules_inventory:'Inventory',modules_clients:'Clients',modules_orders:'Orders',modules_add_order:'Add order',modules_marketing:'Marketing',modules_marketing_gift:'Gift Card',modules_kiosk:'Kiosk',modules_website:'Website',modules_app:'App',modules_qr_ordering:'QR Ordering',modules_active:'Active modules',modules_inactive_hint:'Missed using these?',modules_website_title:'Website Module',modules_website_message:'The Website module is not enabled for this company.',modules_website_hint:'Enable it from company settings.',modules_marketing_title:'Marketing module is disabled',modules_marketing_message:'This module is not included in your current plan or is not enabled for this company.',modules_marketing_hint:'Contact your administrator or upgrade your plan to enable marketing features.',modules_gift_card_title:'Gift Card module is disabled',modules_gift_card_message:'This module is not enabled for your company or is not included in your current plan.',modules_gift_card_hint:'Contact your administrator or enable the Gift Card module to continue.'},pos:{default_interval_raport:'Select the report range',default_intervals_raport0:'00:00 from 23:59',default_intervals_raport1:'from the last Z',default_intervals_raport2:'05:00 la 05:00'},giftCard:{errorTotalNumberMax:'The total number cannot be greater than 10000',errorExpirationTimeMax:'Expiration time cannot be greater than 700',addgift:'+ Add Gift Card Base',value:'Value',exp:'Expiration (months)',type:'Type',generatedCards:'Generated Cards',active:'Active',online:'ONLINE',offline:'OFFLINE',yes:'Yes',no:'No',modalTitle:'Add Gift Card Base',typeLabel:'Type',selectType:'Select type',valueLabel:'Value',expLabel:'Expiration Time (months)',totalCards:'Total Cards (Offline)',cancel:'Cancel',save:'Save',errorTitle:'Error!',errorRequired:'Type and Value are required.',errorOffline:'Total cards required for OFFLINE.',successTitle:'Success!',successMessage:'Gift Card Base created.',errorCreate:'Error creating base.',ok:'OK',baseTitle:'Gift Card Base',inactive:'Inactive',fromDate:'From',toDate:'To',cardsListTitle:'Gift Cards List',allStatus:'All Status',used:'Used',unused:'Unused',allPayments:'All Payments',payed:'Payed',unpayed:'Unpayed',export:'Export',qr:'QR',status:'Status',payment:'Payment',assignedTo:'Assigned To',created:'Created',copyLink:'Copy Link',notAssigned:'Not assigned',showingRecords:'Showing {from} to {to} of {total} records',confirmDeleteTitle:'Are you sure?',confirmDeleteText:'All unused cards will be deleted too!',yesButton:'Yes',noButton:'No',deleteSuccess:'Gift card base deleted successfully',deleteError:'Error deleting gift card base',linkCopied:'Link copied to clipboard!',updateSuccess:'Updated successfully',updateError:'Error updating',notAvailable:'N/A',user:'User'},txtForColors:{sideBarBg:{title:'Sidebar Background',msg:'Change the background color of the sidebar'},mainPageBg:{title:'Menu Content Background',msg:'Change the background color of the menu content'},addBtnColor:{title:'Main Buttons Background',msg:'Change the background color of the main buttons'},addBtnColorInv:{title:'Main Buttons Text Background',msg:'Change the text background of the main buttons'},iconsColor1:{title:'Icons/Buttons Background Color',msg:'Change the background color of all icons and buttons'},iconsColor2:{title:'Text Background',msg:'Change the background color of some texts'},secundarColor:{title:'Start Page',msg:'Change the background color when the kiosk is idle'},principalColor:{title:'Primary Color',msg:'Primary color for background and tools'}},stock:{saving:'Se salvează...',saveStocks:'Salvează Stockuri',title:'Configurare Stock',subtitle:'Setează stockul pentru fiecare produs per locație',searchByName:'Caută după nume',productNamePlaceholder:'Nume produs...',searchById:'Caută după ID',productIdPlaceholder:'ID produs...',allCategories:'Toate categoriile',resetFilters:'Reset filters',loadingProducts:'Se încarcă produsele...',product:'Produs',idLabel:'ID: {id}',currency:'RON',notAvailable:'Nu e disponibil',active:'Activ',stock:'Stock',stockPlaceholder:'0',reservation:'Rezervare (buc)',reservationPlaceholder:'0',reservationError:'Rezervarea nu poate depăși stockul',allowNegative:'Permite Negativ',activateForSources:'Activează pentru sursele:',pos:'POS',app:'App',website:'Website',qr:'QR',kiosk:'Kiosk',page:'Pagina {page} din {totalPages}',productsCount:'({totalRecords} produse)',previous:'Anterior',next:'Următor',noProductsAvailable:'Nu există produse disponibile',stocksSavedSuccess:'Stocurile au fost salvate cu succes!'},pricesFor:{1:'Price Website',2:'Price QR',3:'Price Kiosk',4:'Price POS',5:'Price GLOVO',6:'Price BOLT',7:'Price Wolt'},dispath:{reset_map:'Reset Map',dispatch:'Dispatch',drivers:'Drivers',driverID:'Driver ID',driverName:'Driver Name',value:'Value',from:'From',orders:'Orders',reports:'Reports',totalActive:'Total active',totalInactive:'Total inactive',walletReport:'Wallet',programReport:'Timesheet',activityReport:'Active time',mapReport:'Map',selectDriver:'Select drivers',addGroupOrder:'Order batch',unassigned:'Unassigned',batched:'Batched',grouped:'Grouped',posibleGrouped:'Posibile grouped',sugestion:'Sugestion',createOrderGroupSuccess:'The order group has been created successfully.',createOrderGroupError:'Failed to create order group',addOrderGroupPosibileSuccess:'The order has been added to the group.',addOrderGroupPosibileError:'Failed to add the order to the group.',assign:'Assigned',legend:'Legend',driverWithOrder:'Driver with order',driverWithoutOrder:'Driver without order',movementDirection:'Movement direction',stopWithDelivery:'Stop with order',stopWithoutDelivery:'Stop without order',general:'General',users:'Users',dispatchers:'Dispatchers',walletSettings:'Cash payment wallet / Payment on order',disableUndeliveredOrder:'Disable undelivered order',downloadApp:'Download the delivery app',settings:'Settings',addNewOrder:'Add new order',zone:'Areas'},kds:{importTitle:'Set selected section to all products from selected category',section:'Section',status:'Status',location:'Location',name:'Name',deliveryMethods:'Delivery Methods',noData:'Click +Add for a custom status',areYouSureDelete:'Are you sure you want to delete this KDS?',kitchenDisplayScreen:'Kitchen Display Screen',kds:'KDS',kdsSections:'Sections',settings:'Settings',general:'General',useStartTimerForAllItems:'Use start timer for all items',startTimer:'Start timer',orderAveragePrepTime:'Order average prep time',users:'Users',sections:'Sections',ods:'ODS',report:'Report',orderDisplayScreen:'Order Display Screen',kdsCode:'Kds Code',loginCode:'Login Code (unique 4 digits code)',loginCodeNotUnique:'Login Code is not unique',useOrderLanes:'Display orders on 2 columns (Eat In / Delivery)',lane_1_color:'Background color for Eat In orders',lane_2_color:'Background color for Delivery orders',allowOptionTimer:'Allow start timer for options',allowOptionTimerInfo:'You need to set sections on options',allowCourseTimer:'Allow start timer per course',timeProcessingStatus:'Time order spent in processing',displayStartedOrdersFirst:'Display started orders first',groupProductsByCategory:'Group products by category',hidePreparedItems:'Hide prepared items',displayWaiterName:'Display waiter name',displayDeliveryTime:'Display delivery time',useAutoCloseOrders:'Section KDS can close order when last item is prepared',useAutoCloseOrdersInfo:'When this setting is off, the central KDS has to close the order',autoPrint:'Auto print',displayOrdersGrid:'Display orders as grid',displayOrdersMode:'Display orders mode',displayOrdersModeVertical:'Vertical',displayOrdersModeOscilloscopic:'Oscilloscopic',displayOrdersModeHorizontal:'Horizontal',ordersSortColumn:'Sort orders by',ordersSortColumnPickup:'Order pickup time',ordersSortColumnCreated:'Order placement time',productSorting:'Product sorting',productSortingChronologic:'Chronologic',productSortingPrepTime:'Prep time',notificationSound:'Notification sound',sound1:'Sound 1',sound2:'Sound 2',sound3:'Sound 3',playSound:'Play'},printer:{title:'Printer',subtitle:'Configure printer settings',deleteConfirm:'Are you sure you want to delete this printer?',sectionGeneral:'General information',sectionType:'Type settings',sectionConnectivity:'Connectivity',sectionVersion:'Version and connection type',sectionOptions:'Options and integrations',location:'Location',section:'Section',printerReceipt:'Printer for receipts',printOptions:'Print product\'s options',printProductClientComments:'Print clients\' comments on products',printHotelFields:'Print hotel fields',mergeItems:'Merge products',groupItemsByCategoryOnReceipt:'Group items by category on receipt',correspondingPos:'Corresponding POS',fontSize:'Font size',paymentMethodsPrintTwice:'Print the receipt twice for following payment methods',none:'None',printAddress:'Print address',hideSingleOptionQty:'Hide option quantity of 1',displayPricesAndTotals:'Display prices and totals',orderLabelPrintMode:'Order label printing',orderLabelGrouped:'Print as before (7 lines on the first label, then 13 per label)',orderLabelPerProduct:'Print each product on its own label',orderLabelPerProductHint:'To print a product, enable order label printing in its Product catalog > Label settings.',isLan:'LAN connection',printerIpHost:'Printer IP/Host',printerPortName:'Printer port'},invoice:{number:'Number',vatPercent:'VAT %',storno:'Storno',proforma:'Proforma',addProforma:'Add Proforma',invoiced:'Invoiced',addSeries:'Add series',type:'Type',invoices:'Invoices',invoiceSupplier:'Invoices supplier',reports:'Reports',settings:'Settings',addInvoice:'Add Invoice',invoice:'Invoice',client:'Client',clientName:'Client Name',clientCUI:'CUI',clientEmail:'Email',clientPhone:'Phone',clientAddress:'Address',clientCountry:'Country',clientCounty:'County',selectCounty:'Select county',clientCity:'City',clientSector:'Sector',selectSector:'Select sector',clientStreet:'Street',clientStreetNumber:'No.',clientPostalCode:'Postal code',issueDate:'Issue Date',dueDate:'Due Date',seriesNumber:'Series and Number',seriesDocument:'Series and Document',series:'Series',currency:'Currency',language:'Language',valueNoVAT:'Excl. VAT',vatValue:'VAT Value',lineExtensionAmount:'Line Extension Amount',totalValue:'Total',status:'Status',spvStatus:'SPV Status',spvStatusNotSent:'Not sent',spvStatusSent:'Sent',spvStatusError:'Error',spvStatusPending:'Processing',spvUploadIndex:'Upload ID',invoiceDetails:'Invoice Details',supplierDetails:'Supplier Details',clientDetails:'Client Details',proformaDetails:'Proforma Details',otherDetails:'Other Details',productName:'Product/Service Name',unitMeasure:'UM',quantity:'Quantity',priceRON:'Price (RON)',vatRate:'VAT Rate',includeVAT:'Does the price include VAT?',yes:'Yes',no:'No',download:'Download PDF',filter:'Filter',startNumber:'Start Number',endNumber:'End Number',selectSeries:'Select Series',vatPayer:'VAT Payer',legalStatus:'Legal Status',statusLegal:{fizica:'Individual',juridicaRo:'Romanian Legal Entity',juridicaEu:'European Legal Entity'}},gestiune:{autoActive:'Auto Asign',changeProduct:'Change product management',searchProduct:'Search for product...',productManagement:'Product management links',prodLoading:'Loading product...',noGestion:'There is no connection',change:'Schimbă',removeLink:'Delete Link (no sales will be made if this product appears)',city:'City',countries:'Countries',addInvoiceSupplier:'Add Invoice Supplier',sendToSPV:'Send to SPV',checkSpvStatus:'Check SPV status',downloadEfacturaXml:'Download SPV XML',viewSpvPdf:'View SPV PDF',taxRate:'Tax Rate (%)',customer:'Customer',fetchInvoice:'Fetch Invoices E-Factura',fetchSpvMessages:'Fetch SPV messages',downloadSpvMessage:'Download',viewSpvMessage:'View SPV message',fetchInvoiceDaysLabel:'For how many days?',fetchInvoiceDaysInvalid:'Select a valid number of days.',identificationCode:'Identification Code',purchase:'Purchase',productMix:'Product Mix',codContabil:'Code Contabil',salesMarkup:'Sales Markup',analitic:'Analitic',casare:'Wasted',category:'Category',categoriesSettings:'Categories / Accounts',addCasare:'Add wasted',downloadExcel:'Download XLS',activeProducts:'Activate product',lineTotal:'Line Total',seePDF:'See PDF',exportDocument:'Export Document SPV',number:'Number',validity:'Validity',stocLaZi:'Current Stock',reportStock:'Warehouse sheet',reportInventory:'Inventory inputs–outputs',copyProduct:'Copy Product',addProductInCasare:'Add product(s) in wasted',addProductInInvoice:'Add product(s) in invoice',addProductInProforma:'Add product(s) in proforma',addProductInAviz:'Add product(s) in aviz',addProductInNir:'Add product(s) in reception note',addProductInBonConsum:'Add product(s) in consumption receipt',addProductInBonTransfer:'Add product(s) in transfer note',addProductInBonProductie:'Add product(s) in production note',addProductInOrder:'Add product(s) in order',addBonProduction:'Adaugă bon de producție',addInitialStock:'Adaugă stoc inițial',initialStock:'Initial Stock',operations:'General Operations',orderErrors:'Order sending errors',integrations:'Integrations',integrationsIntegration:'Integration',integrationsLocation:'Location',integrationsConfig:'Config (read-only)',integrationsData:'Integration fields',integrationsJsonHint:'Tip: you can paste JSON here (array/object).',integrationsUpdateById:'Update by row id (POST /integrations/upsert)',integrationsPutById:'Update by row id (PUT /integrations/{id})',integrationsNoteTitle:'How it works',integrationsNoteBody:'Select an integration, optionally a location, then Search. Results appear as a table; open a row to edit. Save creates or updates the integration row.',integrationsAllLocations:'All locations',integrationsOptional:'optional',integrationsOpenRow:'Open',integrationsBackToList:'Back to list',integrationsSelectRowHint:'Choose a row to edit the integration, or add a new one.',integrationsSelectIntegrationHint:'Choose an integration (or All) and optionally a location, then Search.',integrationsEmptyTableHint:'No data available. Use the Add button above to create a new integration.',integrationsDeleteConfirm:'Are you sure you want to delete this integration?',integrationsDeleteSuccess:'Integration deleted successfully.',integrationsDeleteError:'Could not delete the integration. Please try again.',integrationsLocationOccupied:'integration exists',integrationsCreateSuccess:'Integration created successfully.',integrationsUpdateSuccess:'Integration updated successfully.',integrationsSaveError:'Could not save the integration. Please try again.',integrationsMenuActivateConfirm:'This will save the integration, validate and push the menu, then activate the location. Continue?',integrationsMenuActivateStepValidateMenu:'Validating menu',integrationsMenuActivateStepDeactivateLocation:'Deactivating location',integrationsMenuActivateStepPushMenu:'Pushing menu',integrationsMenuActivateStepCheckExportStatus:'Waiting for menu export to complete',integrationsMenuActivateStepActivateLocation:'Activating location',integrationsActivateConfirm:'Are you sure the credentials, location address and coordinates are correct?',integrationsActivateProgressStay:'Please stay on this screen until activation is complete.',integrationsActivateStepSave:'Saving the new integration',integrationsActivateStepTest:'Testing credentials',integrationsActivateStepWebhook:'Registering webhook',integrationsActivateTitle:'Activation',integrationsValidateConfirm:'Are you sure the credentials, location address and coordinates are correct?',integrationsValidateProgressStay:'Please stay on this screen until validation is complete.',integrationsValidateStepSave:'Updating integration',integrationsValidateStepTest:'Testing credentials',integrationsValidateStepWebhook:'Registering webhook',integrationsValidateTitle:'Validation',integrationsWebhookStatusLabel:'Webhook',integrationsWebhookRegistered:'Registered',integrationsWebhookNotRegistered:'Not registered',integrationsWebhookRegisterHint:'Click Validate to register the webhook.',integrationsWebhookRegisterError:'Could not register the webhook. Please try again.',integrationsCredentialsTestError:'Credentials test failed.',integrationsCredentialsTestRetryHint:'After addressing the issues, you can test again using the Validate button.',integrationsCredentialErrorCodes:{glovo_laas_missing_api_url:'Glovo API URL is not set.',glovo_laas_missing_client_id:'Client ID is missing.',glovo_laas_missing_client_secret:'Client secret is missing.',glovo_laas_missing_location_id:'No location is linked.',wolt_drive_missing_api_url:'Wolt Drive API URL is not set.',wolt_drive_missing_client_id:'Client ID is missing.',wolt_drive_missing_client_secret:'Client secret is missing.',wolt_drive_missing_access_token:'Access token is missing.',wolt_drive_missing_merchant_id:'Merchant ID is missing.',wolt_drive_missing_venue_id:'Venue ID is missing.',wolt_drive_missing_location_id:'No location is linked.',delivery_hero_missing_api_url:'Delivery Hero API URL is not set.',delivery_hero_missing_client_id:'Client ID is missing.',delivery_hero_missing_key_id:'Key ID is missing.',delivery_hero_missing_scope:'Scope is missing.',delivery_hero_missing_private_key:'Private key is missing. Save the integration to generate keys.',delivery_hero_missing_location_id:'No location is linked.',laas_location_not_found:'The selected location ID is invalid.',laas_location_missing_address:'The location is missing city, street, or street number.',laas_location_missing_coordinates:'The location is missing latitude or longitude.',laas_location_missing_phone:'The location is missing a phone number.',laas_no_user_email:'No company user with an email address was found.',laas_invalid_credentials:'Invalid credentials (401 / invalid token from partner).',laas_call_courier_failed:'Test courier scheduling failed.',laas_cancel_courier_failed:'Test courier cancellation failed.',laas_no_partner_response:'No response was received from the partner API.',wolt_drive_reference_not_found:'Wolt reference is missing after create.'},integrationsGlovoLaasSetupTitle:'Complete these steps before creating the integration:',integrationsGlovoLaasSetupStep1:'Get client ID and client secret from',integrationsGlovoLaasSetupStep2:'Create a brand at',integrationsDeliveryHeroSetupTitle:'Complete these steps to onboard Delivery Hero ODR:',integrationsDeliveryHeroSetupStep1:'Select a location and API URL, then Save — we generate a PKCS#8 RSA key pair on the server.',integrationsDeliveryHeroSetupStep2:'Download the .pub public key and send it to Delivery Hero to receive a Key ID.',integrationsDeliveryHeroSetupStep3:'Enter the Client ID, Key ID, and Scope provided by Delivery Hero.',integrationsDeliveryHeroSetupStep4:'Click Validate to test credentials, then register the callback URLs with Delivery Hero ops.',integrationsDeliveryHeroKeysTitle:'RSA keys',integrationsDeliveryHeroKeysPending:'Save the integration to generate the public/private key pair.',integrationsDeliveryHeroCopyPublicKey:'Copy public key',integrationsDeliveryHeroDownloadPublicKey:'Download .pub',integrationsDeliveryHeroRegenerateKeys:'Regenerate keys',integrationsDeliveryHeroRegenerateKeysConfirm:'Regenerating keys invalidates the previous public key. You must send the new .pub file to Delivery Hero again. Continue?',integrationsDeliveryHeroRegenerateKeysSuccess:'New RSA key pair generated.',integrationsDeliveryHeroCredentialsTitle:'Credentials from Delivery Hero',integrationsDeliveryHeroCredentialsHint:'Fill these in after Delivery Hero returns your Key ID for the public key you shared.',integrationsDeliveryHeroScopePlaceholder:'e.g. pandago.api.ro.*',integrationsDeliveryHeroPublicKeyHint:'Share this public key (.pub) with Delivery Hero so they can issue a Key ID. Private key stays on the server (PKCS#8, 2048-bit).',integrationsDeliveryHeroCallbacksTitle:'Callback URLs (register with Delivery Hero)',integrationsDeliveryHeroStatusCallback:'Status callback URL',integrationsDeliveryHeroRefundCallback:'Refund callback URL',integrationsDeliveryHeroCallbacksHint:'These URLs are fixed for your company. Provide them to Delivery Hero ops when onboarding.',integrationsActionsTitle:'Actions',integrationsSyncMenu:'Sync menu',integrationsMenuUploadCampaignsHint:'Uploading the menu will remove campaigns from the platform.',integrationsGlovoMenuSyncDailyLimitHint:'The Glovo platform does not allow more than 5 menu synchronizations per day.',integrationsActionError:'Action failed. Please try again.',integrationsPlatformErrors:{unauthorized:'The platform rejected the request because the credentials are invalid or expired.',unauthorized_bolt:'Bolt rejected the request (401). Check {secretKey}, {integratorId}, and {providerId} in the integration settings.',unauthorized_glovo:'Glovo rejected the request (401). Check {apiKey} and {storeId} in the integration settings.',unauthorized_wolt:'Wolt rejected the request (401). Check {apiKey}, {clientId}, and {venueId}, then try again.',forbidden:'The platform refused this action. Your account may not have permission for this location.',forbidden_bolt:'Bolt refused this action. Verify that the {providerId} matches the store configured in Bolt.',forbidden_glovo:'Glovo refused this action. Verify {storeId} and that the store is linked to your account.',forbidden_wolt:'Wolt refused this action. Verify {venueId} and that the venue is linked to your account.',not_found:'The platform could not find the store or venue. Check the integration identifiers.',not_found_bolt:'Bolt could not find this provider. Check {providerId} and {apiUrl}.',not_found_glovo:'Glovo could not find this store. Check {storeId} and {apiUrl}.',not_found_wolt:'Wolt could not find this venue. Check {venueId} and {apiUrl}.',rate_limited:'The platform is rate-limiting requests. Please wait a few minutes and try again.',network:'Could not reach the platform. Check your network connection and try again.',unavailable:'The platform is temporarily unavailable. Please try again later.',toggleLocation_failed:'Could not update whether the location accepts orders on the platform.',pushMenu_failed:'Could not publish the menu to the platform.',syncSchedule_failed:'Could not sync the opening schedule with the platform.',generic_failed:'The platform action failed. Please try again.'},integrationsMenuTopCategoriesPlaceholder:'All top categories',integrationsMenuTopCategoriesHint:'Leave empty to export the full menu.',integrationsMenuTopCategoriesExportNote:'Filtering applies on the next menu export.',integrationsGlovoValidateMenu:'Validate menu',integrationsGlovoPushMenu:'Push menu',integrationsValidateAndPushMenu:'Validate and push menu',integrationsMenuPreviewOpen:'Open menu',integrationsMenuPreviewLoading:'Loading menu…',integrationsMenuPreviewOrder:'Order',integrationsMenuPreviewAdd:'Add',integrationsMenuPreviewAddFor:'Add {qty} for {price}',integrationsMenuPreviewRequiredShort:'Required',integrationsMenuPreviewChooseOne:'Choose 1 item',integrationsMenuPreviewTitle:'{platform} menu preview',integrationsMenuPreviewSubtitle:'Browse categories, products, and options as they will appear on the platform.',integrationsMenuPreviewImport:'Import',integrationsMenuPreviewImporting:'Importing…',integrationsMenuPreviewSearchPlaceholder:'Search products, options, ids…',integrationsMenuPreviewSearchEmpty:'No products match your search.',integrationsMenuPreviewSearchClear:'Clear',integrationsMenuPreviewImportConfirmTitle:'Import menu?',integrationsMenuPreviewImportConfirmText:'This will validate and push the menu to the platform.',integrationsMenuPreviewBack:'Back to menu',integrationsMenuPreviewOutOfStock:'Out of stock',integrationsMenuPreviewOptionRequired:'Required',integrationsMenuPreviewOptionOptional:'Optional',integrationsMenuPreviewOptionRange:'Choose {min}–{max}',integrationsGlovoCheckStatus:'Check export status',integrationsGlovoExportsToday:'Exports today',integrationsGlovoLastExport:'Last export',integrationsGlovoExportStatus:'Status',integrationsGlovoNoExport:'No export yet',integrationsGlovoExportPending:'Pending — check status',integrationsGlovoExportInProgress:'In progress',integrationsGlovoExportSuccess:'Successful',integrationsGlovoExportFailed:'Failed',integrationsGlovoValidationResult:'Validation result',integrationsGlovoStatusResult:'Export status',integrationsGlovoValidateSuccess:'Menu validation completed.',integrationsGlovoValidateSuccessTitle:'Menu validation',integrationsGlovoValidationFailedTitle:'Menu validation failed',integrationsGlovoShowMore:'Show more',integrationsGlovoShowLess:'Show less',integrationsGlovoValidationErrors:'Errors',integrationsGlovoValidationWarnings:'Warnings',integrationsMenuValidationExpandHint:'Open the details below to see the affected categories, products, and options.',integrationsMenuValidationEditEntity:'Edit',integrationsMenuValidationEditEntityHint:'Opens in a new tab',integrationsMenuValidationTryAgain:'Try again',integrationsMenuValidationProceedAnyway:'Proceed anyway',integrationsMenuValidationProceedAnywayHint:'Validation reported issues. If these are false positives, you can proceed with the menu export.',integrationsMenuValidationProceedingAnyway:'Proceeding despite validation issues.',integrationsMenuValidationEditPageHint:'After saving, close this tab and try again.',integrationsMenuValidationErrorCodes:{CATEGORY_EMPTY:'Categories with no exportable products',PRODUCT_INVALID_PRICE:'Products with a price of zero or less',OPTION_MISSING_VALUES:'Options with missing values',OPTION_INVALID_MIN:'Options with an invalid minimum selection',MENU_EMPTY:'Menu is empty',MENU_NO_MATCHING_CATEGORIES:'No categories match the selected menu filter'},integrationsMenuValidationItemCategory:'Category',integrationsMenuValidationItemProduct:'Product',integrationsMenuValidationItemOption:'Option',integrationsMenuValidationCategoriesEmpty:'Categories with no exportable products',integrationsMenuValidationProductsInvalidPrice:'Products with invalid price',integrationsMenuValidationOptionsMissingValues:'Options with missing values',integrationsMenuValidationOptionsInvalidMin:'Options with invalid minimum',integrationsGlovoCheckStatusDisabledHint:'Push a menu first, or open an integration that already has an export.',integrationsGlovoStatusUpdated:'Export status updated.',integrationsGlovoPushAccepted:'Menu push accepted by Glovo.',integrationsGlovoMenuEmpty:'No products to export.',integrationsGlovoActivateTitle:'Activation',integrationsGlovoActivateConfirm:'This will save the integration, validate and push the menu to Glovo, then activate the location. Continue?',integrationsGlovoActivateProgressStay:'Please stay on this screen until activation is complete.',integrationsGlovoActivateStepSave:'Saving the new integration',integrationsGlovoActivateStepValidateMenu:'Validating menu',integrationsGlovoActivateStepDeactivateLocation:'Deactivating Glovo location',integrationsGlovoActivateStepPushMenu:'Pushing menu to Glovo',integrationsGlovoActivateStepCheckExportStatus:'Waiting for menu export to complete',integrationsGlovoActivateStepActivateLocation:'Activating Glovo location',integrationsGlovoActivateExportTimeout:'Menu export is still in progress after several minutes.',integrationsGlovoActivateExportFailedHint:'Review the export errors above, fix the menu, then use Push menu and Check export status in Actions.',integrationsGlovoActivateValidationFailedHint:'Fix the menu issues above, then try Activate again.',integrationsGlovoActivateMenuEmptyHint:'Add products to the menu for this location, then try Activate again.',integrationsGlovoActivatePushFailedHint:'Fix the issue above, then try Activate again.',integrationsGlovoActivateNoTransactionId:'Glovo did not return an export transaction ID. Try Push menu from Actions.',integrationsSyncSchedule:'Sync schedule',integrationsColActive:'Active',integrationsColActions:'Actions',integrationsColIsMenuLocation:'Menu location',integrationsColIsUsingPricelist:'Menu and orders location',integrationsFields:{id:'ID',location_id:'Location',orders_location_id:'Orders location',active:'Active',api_url:'API URL',api_key:'API key',client_id:'Client ID',client_secret:'Client secret',venue_id:'Venue ID',is_integrated:'Integrated',is_using_pricelist:'Menu and orders location',is_auto_accept:'Auto accept orders',platform_status_polling_enabled:'Monitor platform availability',schedule:'Schedule',is_menu_location:'Menu location',created_at:'Created at',updated_at:'Updated at',access_token:'Access token',merchant_id:'Merchant ID',auto_send_at_status:'Auto send at status',auto_send_time:'Auto send time',order_total_handshake:'Require code for orders above',feedback_emails:'Feedback emails',integrator_id:'Integrator ID',provider_id:'Provider ID',secret_key:'Secret key',emails:'Emails',user:'User',password:'Password',menu_language:'Menu language',has_own_delivery:'Own delivery',prep_time_buffer_in_minutes:'Prep time buffer (minutes)',pos_implementation_name:'POS implementation name',brand_name:'Brand name',brand_code:'Brand code',store_id:'Store ID',laas_client_id:'Client ID',laas_client_secret:'Client secret',menu_top_categories:'Menu top categories',key_id:'Key ID',scope:'Scope',webhook_secret:'Webhook secret',public_key:'Public key'},integrationsFeedbackEmailsHint:'Enter email addresses separated by commas, semicolons, or new lines',woltDriveAutoSendStatus_manual:'Manual',woltDriveAutoSendStatus_processing:'Processing',woltDriveAutoSendStatus_prepared:'Prepared',integrationsTypes:{glovo:'Glovo',glovo_laas:'Glovo LaaS',bolt:'Bolt',wolt:'Wolt',wolt_drive:'Wolt Drive',delivery_hero:'Delivery Hero',nexus:'Nexus',charisma:'Charisma',clock_pms:'Clock PMS',ebriza:'Ebriza',rkeeper:'rKeeper',rsystem:'R-System',ep_restaurant:'eP Restaurant',freya_on_premise:'Freya (on-premise)',freya_cloud:'Freya Cloud',grandchef:'GrandChef'},notaTransfer:'Transfer note',dataStart:'Start Date',dataEnd:'End Date',updateStockScriptic:'Update scriptic stock',printInventorySheet:'Inventory sheet',saveDraft:'Save draft',saveAndValidate:'Save and apply modifications',cost:'Cost',gestiune_descarcare:'Download management',noteEntries:'Entrance note at reception',receptionOrder:'Reception Order',validateOrder:'Validate Order',processingOrder:'Processing Order',forLocation:'For Location',toLocation:'To Location',stockNameTable:'Item name',stockUm:'MU',stockPrice:'Unit price',stockStocMinim:'Minimum stock',stockQuantity:'Current stock',stockValue:'Stock value',stockStatus:'Status',stockStatus1:'✅ OK',stockStatus2:'⚠️ Below minimum stock',stockStatus3:'❗ Critical',stocksHistory:'Stock History',nirs:'Nir',stockDate:'Data',stockDocumentId:'Nr. doc',stockDocumentType:'Tip Document',stockIntrare:'Intrare',stockIesire:'Iesire',stockStocFinal:'Stock Final',stockPret:'Pret',stockValoareStoc:'Valoare stoc',stockObservatii:'Observatii',noSeries:'No series available',noGestiuni:'No Inventory available',default:'Sales management default',quantityScriptic:'Scriptic Quantity',quantityFaptic:'Faptic Quantity',procesata:'Processed',nrProduse:'Number of products',fiscalizate:'Fiscalized',tipVanzare:'Type of sale',email:'Email',process:'Process',invoice:'Invoice',sendOrder:'Send Order',reception:'Reception',validate:'Validate',generateNir:'Generate Nir',ore:'Hours',zile:'Days',searchClientsWithCUI:'Search client with CUI',searchClients:'Search client',addClient:'Add client',clientName:'Client name',termenValabilitate:'Validity Term',scazamant:'Shrinkage',addBonConsum:'Add consumption receipt',addNoteTransfer:'Add transfer note',procent:'Procent',stocScriptic:'Scriptic Stock',stocFaptic:'Faptic Stock',difference:'Difference',status:'Status',inventoryNumber:'Inventory #',differences:'Differences',users:'Utilizatori',note:'Note',inventar:'Inventory',reports:'Reports',myOrders:'My orders',forOrders:'Orders received',bankAccounts:'Bank accounts',costPerUnit:'Cost per unit',pricePerUnit:'Price per unit',totalCost:'Total cost',editPrice:'Edit price',stocK:'Stock',pretVanzare:'Selling price (VAT INCLUDE)',stocMinim:'Minimum stock',docFurnizori:'Reception entry notes',clients:'Clients',lot:'Lot',dataProductie:'Production date',dataExpirare:'Expiration date',aviz:'Notice',pretPerUnitate:'Price per unit',cantitateNecesara:'Required quantity',cantitateConsumata:'Consumed quantity',addAviz:'Add notice',products:'Products',bonFiscal:'Fiscal Receipt',sales:'Sales',addOrder:'Add Order',outputs:'Outputs',commandProject:'Command/Project',production:'Production',preview:'Preview',manager:'Manager',receiver:'Receiver',internalNote:'Internal Note',isBonProductie:'Production Receipt',fromGestiune:'From Warehouse',toGestiune:'To Warehouse',transfer:'Transfer Receipt',cui:'CUI',dashboard:'Dashboard',numeGestionar:'Name administrator',numeGestiune:'Name management',gestiuni:'Managment',categorii:'Categories',contContabil:'Accounting Account',currentNumber:'Current Number',codGestiune:'Code managment',consumption:'Consumption',addManagment:'Add managment',tipGestiune:'Management type',cantitativValoric:'Quantitative Valuation (Recommended)',cantitativValoricDesc:'Products appear on the NIR at Acquisition Cost. Used by stores and warehouses. Suitable for any type of product: Merchandise, Raw Materials, Consumable Materials, etc.',globalValoric:'Global Valuation',globalValoricDesc:'Products appear on the NIR at Sale Price. Used by small stores. Only for Merchandise and Packaging products. You will not be able to issue consumption receipts from this management, for example.',terti:'Third Parties',tertiDesc:'When your products are sent to Third Parties for storage or processing.',workPoint:'Work Point',adresaPunctLucru:'Work Point Address',administrator:'Administrator',stocks:'Stocks / Consumables',priceAchizitie:'Purchase price',reteta:'Nomenclature',emptyData:'There is no data',noData:'There is no data, use the filters for selection and press the "SEARCH" button',addReteta:'Add product to recipe',history:'History',entries:'Entries',suppliers:'Suppliers',bonTransfer:'Bon Transer',supplierOrders:'Supplier Orders',generateAvizNIR:'Generate Aviz & NIR',avizGestiuneaPredatoare:'Aviz (in the supplying warehouse)',dataAviz:'Aviz Date',nirGestiuneaPrimitoare:'NIR (in the receiving warehouse)',dataNIR:'NIR Date',nomenclatorProducts:'Product Products',addProduct:'Add product',product:'Product',codeProduct:'Code Product',code:'Code',name:'Name',price:'Price',gestiune:'Inventory',nr:'No.',categoria:'Category',tva:'VAT %',pretFaraTva:'Price(without VAT)',currency:'Currency',settings:'Settings',productName:'Product Name',productDescription:'Product Description',type:'Type',gestiuneDefault:'Gestiune',codeFiscalFurnizor:'Fiscal Code of the supplier',dataDocument:'Document date',dataInStoc:'Date in stock',dataScadenta:'Due date',tipDocument:'Document type',nrDocument:'Document number',valoare:'Value',valoareTaxable:'Taxable base',valoareTva:'VAT',valoareTotal:'Total',valoarePayable:'Payable',precizie:'Precision',prețAchiziție:'Purchase Price',nirsProduct:'Product NIRs:',BalanceReport:'Centralized balance',exports:'Exports',inboundInvoices:'Accounting Inbound Invoices',accountingSales:'Accounting Sales',download_xml:'Export arhive SAGA XML',exportAccounting:{infoText:'To generate the accounting export, select a location and a date and time range. Then choose the desired format (XML or XLS) and wait for the generation process to complete. Depending on the data volume, the export may take a few seconds.'},exportAccountingSales:{infoText:'To generate the sales accounting export, select a location and a date and time range. Then choose the desired format (XML or XLS) and wait for the generation process to complete. Depending on the data volume, the export may take a few seconds.'},miscareStoc:{vanzare:'STOCK MOVEMENT: SALE',intrare:'STOCK MOVEMENT: ENTRY',resetare:'STOCK MOVEMENT: RESET',inventar:'STOCK MOVEMENT: INVENTORY',intrareTransfer:'STOCK MOVEMENT: TRANSFER IN',iesireTransfer:'STOCK MOVEMENT: TRANSFER OUT',bonConsum:'STOCK MOVEMENT: CONSUMPTION NOTE',intrareProductie:'STOCK MOVEMENT: PRODUCTION IN',iesireProduse:'STOCK MOVEMENT: PRODUCTS OUT',bonAnulat:'STOCK MOVEMENT: CANCELED NOTE',protocol:'STOCK MOVEMENT: PROTOCOL',donatie:'STOCK MOVEMENT: DONATION'},stoc:{checkbox:'',nume:'Name',tag:'Tag',tva:'VAT',um:'Unit Measure',cantitateRamasa:'Remaining Quantity',costMediuAchizitie:'Average Purchase Cost',valoareTotala:'Total Value',action:{editareMultipla:'Bulk Edit',bonConsum:'Consumption Voucher',transferStoc:'Stock Transfer',resetareStoc:'Reset Stock',exporta:'Export All'}},locatie:'Location',nume:'Name',cantitate:'Quantity',cantitateHint:'Enter quantity with a dot (.), not a comma (,)',umTaptastyInfo:'The unit of measure for products managed from Taptasty can be changed from CATALOG -> Products!',modifCantRamasa:'Remaining Qty',pretUnitar:'Unit Price',costMediuAchizitie:'Average Purchase Cost',costTotal:'Total Cost',data:'Date',detalii:'Details',schimbaCotaTVA:'Change VAT Rate',schimbaTag:'Change Tag',stergeTot:'Delete All',motiv:'Reason',cantitateDeConsum:'Consumption Quantity',um:'UM',pretUnitarFaraTVA:'Unit Price (Excl. VAT)',pretTotal:'Total Price',furnizor:'Supplier',nrFactura:'Invoice Number',scadenta:'Due Date',dataEmitere:'Issue Date',dataIntrare:'Entry Date',adaugaIntrare:'Add Entry',nirInfoNote:'⚠️ <strong>Attention!</strong> The Reception Entry Note (NIR) is intended exclusively for recording the reception and entry of products into warehouse management. For managing supplier invoices, go to <strong>Entries → Supplier Invoices</strong>.'},menuLink:{alias:'Alias',title:'Title',updated:'Updated',areYouSure:'Are you sure to {label} menu link ?',deleted:'Deleted',couldNotUpdate:'Not updated',cancel:'cancel',delete:'delete',added:'Menu link added',promotions:'Promotions',history:'History',orders:'Orders',reservations:'Reservations',tables:'Tables',orderspos:'Add New Order',dispatch:'Dispatch',favorite_orders:'Favorite orders',tutorial:'Tutorial',personal_info:'Personal informations',single:'Menu link',cancelCourier:'Cancel courier',logout:'Logout',from:'from',to:'to',linkFor:'Link for',externUrl:'External URL',custom:'Custom',day:'day',couldNotSave:'Menu link could not be saved'},pages:{allModules:'See all modules',automationMarketing:'Automatic marketing',stock:'Stock',supportTicket:'Support Ticket',supportWidgetTokenUnavailable:'Support widget token is not available for this location',login:'Login',register:'Register',recoverPassword:'Recover Password',resetPassword:'Reset Password',programTitle:'Program',dashboard:'Dashboard',orderingManagement:'Ordering Management',customerDetails:'Customer Details',customers:'Customers',approvals:'Registration approvals',giftCard:'Gift Card',customersGroups:'Customer groups',orders:'Orders',reservations:'Reservations',tables:'Tables',orderspos:'Add New Order',dispatch:'Dispatch',screens:'Screens',transfer:'Trasnfer',pos:'Pos',tableMaps:'Table Maps',products:'Products',isPriceList:'Price List',catalog:'Catalog',categories:'Categories',productOptions:'Product Options',groupOptions:'Group Options',marketing:'Marketing',campaigns:'Campaigns',pushCampaigns:'Push notification campaigns',coupons:'Coupons',subscriptions:'Subscriptions',referralCampaigns:'Referral campaigns',loyaltyStoreCampaigns:'Loyalty Store',ambassadorRequests:'Ambassador requests',raffleCampaigns:'Raffle Campaigns',donationCampaigns:'Donation Campaigns',spinningWheelCampaigns:'Spinning Wheel',discountCampaigns:'Discount Campaigns',challengeCampaigns:'Challenges',offersSlider:'Offers Slider',reports:'Reports',feedback:'Feedback',settings:'Settings',logout:'Logout',fidelities:'Fidelities',topCategory:'Top Category',infoPagesCustom:'Custom Pages',menuLinks:'Menu Links',infoPages:'Info Pages',productFilters:'Product Filters',promos:'Fidelity Card',menus:'QR Menus',menuSubscriptions:'Menu subscriptions',orderScreen:'Order Screen',clientOrderView:'Display PickUp',payment:'Payment',newsletter:'Newsletter',support:'Support',scanner:'Scan',gestiune:'Inventory',stocuri:'Stocks',intrari:'Entries',kds:'KDS',ods:'ODS',posScreen:'Pos Screen',digitalSignage:'Digital Signage Screen',orderDisplayScreen:'Display Screens',online:'Online',invoice:'Invoice',kiosk:'Kiosk',qr:'Qr'},infoPages:{single:'page',title:'Title',shortDescription:'Short Description',updated:'Updated',areYouSure:'Are you sure to delete this page?',deleted:'Deleted',couldNotUpdate:'Could not updated',added:'Custom info page added',changeLinkTab:'In case if is added an link change the text box with TAB for next and SHIFT + TAB for previous',infoPages:'Info Pages'},ordersStatus:{bill:'Bill',AWAITING_TRANSPORT:'Awaiting Transport',CANCELED:'Canceled',DELIVERED:'Delivered',DRAFT:'Draft',OPEN_DRAFT:'Open order',NEW:'New',ON_HOLD:'On Hold',POSTPONED:'Postponed',NOT_DELIVERED:'Not Delivered',PICKED_UP_BY_DELIVERY:'Picked up for delivery',PROCESSING:'Processing',PREPARED:'Prepared',TRANSPORT:'In transport',RESERVED:'Reserved',COMPLETED:'Completed',FINISH:'Finish',DRAFT_AWAITING_PAYMENT:'Awaiting Payment',reservedReady:'Reserved / Ready',completedReady:'Completed / Ready',deliveredReady:'Delivered / Ready',canceledForever:'canceled? This action is irreversible!',checkIn:'Checked-in'},ordersTypes:{GROUP:'Group',SINGLE:'Single'},paymentTypes:{CASH:'Cash',CARD:'Online Card',POS:'POS for delivery (NOT paid)',CARD_POS:'Physical POS terminal (PAID)',CASH_MACHINE:'Cash machine (PAID)',POS_KIOSK:'POS Kiosk (NOT paid)',VIVA_INTENT:'VIVA App',VIRAMENT:'VIRAMENT',SPLIT:'Split payment',ROOM:'Room Charge',FOLIO:'Folio Charge',EVENT:'Event Charge',MANCARE_PERSONAL:'Staff Food',PROTOCOL:'Protocol',ONLINE:'Online',Online:'Online',GLOVO:'GLOVO',GLOVO_CARD:'GLOVO CARD',GLOVO_CASH:'GLOVO CASH',BOLT:'BOLT',BOLT_CASH:'BOLT CASH',BOLT_CARD:'BOLT CARD',WOLT:'WOLT',WOLT_CASH:'WOLT CASH',WOLT_CARD:'WOLT CARD',VOUCHER:'Voucher',GIFT_CARD:'Gift card',null:'Not Paid'},paymentStatus:{notPaid:'Authorized (Amount blocked)',notPaidDetails:'The amount will be charged once the order is marked as Delivered.',paid:'Paid',notOk:'Declined'},campaignsModes:{AUTO:'Automatic',MANUAL:'Manual'},campaignsNotificationTypes:{EMAIL:'E-mail',PUSH:'Push Notification'},days:{monday:'Monday',tuesday:'Tuesday',wednesday:'Wednesday',thursday:'Thursday',friday:'Friday',saturday:'Saturday',sunday:'Sunday',0:'Sunday',1:'Monday',2:'Tuesday',3:'Wednesday',4:'Thursday',5:'Friday',6:'Saturday'},daysShort:{Mon:'Mon',Tue:'Tue',Wed:'Wed',Thu:'Thu',Fri:'Fri',Sat:'Sat',Sun:'Sun'},months:{1:'January',2:'February',3:'March',4:'April',5:'May',6:'June',7:'July',8:'August',9:'September',10:'October',11:'November',12:'December'},gender:{selectGender:'Select Gender',male:'male',female:'female',Male:'Male',Female:'Female',Other:'Other'},reportsAgesGroups:{selectAge:'Select Age','20':'Under 20','Under 20':'Under 20','20-30':'20 - 30','30-40':'30 - 40','40-50':'40 - 50','50':'50+','50+':'50+',Unspecified:'Unspecified'},deliveryTypes:{SELF_ORDERING:'Table Or Kiosk',DELIVERY:'Delivery',EAT_LOCATION:'Table Order',MEET_HALF:'Meet me half way',PICK_UP:'Pick-up'},couponsTypes:{FIXED:'Fixed',PERCENTAGE:'Percentage',FREE_PRODUCT:'Free product'},taxTypes:{FIXED_INCLUDED:'Fixed (included)',PERCENTAGE_INCLUDED:'Percentage (included)',FIXED_EXCLUDED:'Fixed',PERCENTAGE_EXCLUDED:'Percentage'},productOptions:{checkbox:'Allows selecting multiple options on the product',radio:'Allows selecting only one option on the product',upload:'Option with image upload',hidePrices:'Hide prices',hasDefaultValue:'Select first value by default'},validations:{success:'Success',priceUpdated:'Price updated successfully',areYouSureYouWantTo:'Are you sure you want to ',areYouSure:'Are you sure you want to update the status to ',wentWrong:'Something went wrong, please try again later...',pictureSize2MB:'jpg/png files with a size less than 2MB ',pictureSizeExceed2MB:'Picture size can not exceed 2MB!',pictureSize:'jpg/png files with a size less than 5MB ',pictureLogo:'jpg/png/svg files with a size less than 5MB ',pictureSizeExceed:'Picture size can not exceed 5MB!',pdfSize:'Files with a size less than 25MB ',pdfSizeExceed:'File size can not exceed 25MB!',archiveSizeExceed:'File size can not exceed 500MB!',wrongFormat:'Wrong format',removePhoto:'Please remove the current file in order to be able to add a new one',dataCouldNotBeSaved:'Data could not be saved, please try again later.',passReq:'Password field id required.',passMin:'Password must be at least 6 characters.',passConf:'Password and password confirmation do not match.',validPoinsNo:'Please add a valid money amount and a comment.',imageResolution:', recommanded resolution 300px height and 820px width.',imageResolutionWeb:', recommanded resolution 300px height and 1920px width.',doYouWantTo:'Do you want to ',hourIsSmallerThanCreated:'The selected hour is smaller then the placed hour for the order',cancelReason:'Cancellation reason is required.',requiredField:'This field is required',invalidEnteredData:'The entered data is not valid.',vatPrinterIdRange:'0–10 only.',vatPrinterIdNumeric:'Numbers only.',chooseDay:'Choose at least one day for the product to be available!',chooseLocation:'Choose at least one location for the product to be available!',chooseLocationAndDeliveryMethod:'Choose at least one location and delivery method for the product to be available!',timeInterval:'Wrong time interval!',noOverrideIntervals:'Override delivery is enabled but no intervals have been added. Please add at least one interval.',overrideIntervalMissingHours:'All intervals must have both "From" and "To" times set.',overrideIntervalMissingDay:'All intervals must have at least one day selected.',subtractPoints:'Are you sure you want to consume'},upload:{uploadLabel:'Upload Menu',uploadMenuTemplateLabel:'Upload Menu Form',browse:'Browse',download:'Download QR Code',dynamicMenu:'Dynamic Menu',staticMenu:'PDF Menu',downloadImportProductsTemplate:'Download Menu Form',upload:'Upload',downloadButton:'Download',uploadImagesArchive:'Upload Images Archive',file:'File'},productImport:{import:'Import',importHistory:'Import History',batch:'Batch',date:'Date',file:'File',products:'Products',status:'Status',review:'Review',confirm:'Confirm',cancel:'Cancel batch',remove:'Remove',removeConfirm:'Remove this row from the import? It will not be applied.',editRow:'Edit import row',product:'Product',action:'Action',actionType:'Type',actionCreate:'Create',actionUpdate:'Update',actionPriceListUpdate:'Price list update',price:'Price',category:'Category',errors:'Errors',pending:'Pending',confirmed:'Successful',removed:'Removed',uploadSuccess:'Import uploaded. Review and confirm changes.',confirmSuccess:'Import applied successfully',statusPending:'Pending',statusConfirmed:'Confirmed',statusSuccessful:'Successful',statusPartiallyConfirmed:'Partially Confirmed',statusPartiallySuccessful:'Partially successful',statusCanceled:'Canceled',statusError:'Error',statusRemoved:'Removed',exportProducts:'Export products',exportImages:'Download images',selectPriceProfile:'Price profile',priceProfileRequired:'Select a price profile before confirming',confirmTitle:'Confirm import',confirmPriceHint:'Choose the price profile where channel prices will be applied.',step1Title:'Download / export',step1Intro:'Choose one option: start from an empty form, or export the products already on this location.',optionEmptyTitle:'Empty form',optionEmptyDesc:'Download a blank CSV template and fill it offline.',downloadEmptyForm:'Download empty form',optionExportTitle:'Export existing products',optionExportDesc:'Export current location products into the menu CSV (requires a price list).',defaultPriceListHint:'If this location has no price list, we automatically create one named “<location name> default”.',noProductsForExport:'This location has no products yet, so export is disabled.',step2Title:'Fill in the form',step2Body:'Open the CSV in Excel or Google Sheets. Fill PRODUCT ID, PREȚ, and channel prices offline, then save as CSV.',step3Title:'Images (.zip)',step3Hint:'Upload a .zip with product images',step4Title:'Menu (.csv)',step4Hint:'Upload the completed CSV. You will review and confirm the import in the preview before changes are applied.',sectionIdentity:'Product identity',sectionCategories:'Categories',sectionBase:'Base details',sectionDescription:'Description & labels',sectionPrices:'Channel prices',searchProduct:'Match existing product',searchProductPlaceholder:'Search by name…',productMatchNew:'Empty PRODUCT ID — a new product will be created on confirm.',productMatchFound:'Matched: {name}',productMatchUnknown:'Unknown product — search and select an existing product, or clear the ID to create new.',topCategory:'Top category',secCategory:'Secondary categories',active:'Active',activeHint:'1 / 0 / yes / no',posId:'POS ID',vat:'VAT',section:'Section',weight:'Weight',imageFilename:'Image filename',imageFilenameHint:'Filename from the uploaded zip',desc:'Description',nutritional:'Nutritional',allergenic:'Allergens',ingredients:'Ingredients',legacyTitle:'Legacy import',legacyHint:'Applies the CSV immediately without review. Uses the classic template (creates products only — no PRODUCT ID / channel prices). Upload images as .zip here before importing the CSV.',legacyDownloadLabel:'Download menu form',legacyDownload:'Download',legacyUpload:'Upload',legacyUploadSuccess:'Legacy import completed'},dashboard:{selectLocation:'Select location:',selectZone:'Zone:',selectMethod:'Method:',selectDriver:'Driver:',selectUsers:'User/Admins:',selectClient:'Client',selectedOrderFormFlags:'Pentru comenzile din:',selectedPaymentMethods:'For orders with:',serchCoupon:'Search(Cupon)',tile1Title:'New Orders',tile2Title:'Total Orders',tile3Title:'Revenue',tile4Title:'Average Order',today:'Today',orderChart:'Orders',completed:'Number of orders',canceled:'Canceled',salesChart:'Sales',salesIn:'Sales in',top5Chart:'Top 5 products',orderingChart:'Ordering types',nrOfOrders:'Number of orders',nrOfEmails:'Number of emails'},customers:{addCustomerToGroup:'Add customer to group...',noApprovalRequired:'No approval required',searchPlaceholder:'Search by name, phone or email...',myGroups:'My Groups',pendingApproval:'pending',noGroups:'Not part of any group',approvalStatus:'Status',approved:'Approved',approve:'Approve',clientApproved:'Client approved successfully!',membersRequireApproval:'Members require approval',totalSales:'Total sales',settings:'User settings',allow_virament:'Allow virament',singleTotal:'Total customer: ',noCustomer:'No Customer Selected',single:'customer',plural:'customers',deliveryOrders:'Customer Delivery Orders',pickupOrders:'Customer Pick-Up Orders',meetHalfwayOrders:'Customer Meet Halfway Orders',customerReservations:'Customer Reservations',title:'Customer Details',pointsTitle:'Customer Loyalty Points',currentPoints:'Current Points',pointsAddTitle:'Add Points',pay:'Pay Type',id:'ID',name:'Name',email:'Email',phone:'Phone',use_calling_phone:'Pick up phone number',gender:'Gender',birth:'Birth Day',location:'Location',address:'Address',number:'Number',dateCreated:'Date Created',delivery:'Delivery',type:'Type',status:'Status',fidelities:'Label',total:'Total',allTimeSale:'All time sale',none:'None',pointsLabel:'Money spent',pointsLabelInPoints:'Points earned',points:'points',point:'point',clientCanUse:'Customer can use',commentsLabel:'Comment',pointsSuccess:'Loyalty points added successfully.',pointsError:'We could not add the points to the customer.',addCommentPerClient:'Add comment per client',newCommentAdded:'The comment has been updated',clientNotification:'Would you like to use the comment in order notify the customer?',filters:{withOrders:'With Orders',withoutOrders:'Without Orders'},addGroup:'Add Group',deleteGroup:'Group successfully deleted.',saveGroup:'Group was successfully added.',updateGroup:'Group was successfully updated.'},orders:{cancel_order_reason:'Cancel Reason',counterPerCustomer:'Number of Orders',noOrders:'No Order Selected',single:'Order',the_order:'Order',category:'Category',plural:'orders',status:'Status',location:'Location',updateStatus:'Update Status',editOrder:'Edit Order',ordDetails:'Order Details',date:'Date',madeAt:'Order made at',pickupTime:'Delivery / Pick-up at',preorder:'PREORDER',preorderFilter:'Preorders',allOrders:'All orders',pendingPreorders:'Pending preorders',withoutPendingPreorders:'Without pending preorders',reservationTime:'Reservation Time',expresoftStatus:'Expresoft Status',expresoftQueue:'In Queue',expresoftError:'Sending error',expresoftSuccess:'Sent',rating:'Rating',meetupLocation:'Meet-up Location',ordLocation:'Location',delivery:'Delivery',type:'Type',payment:'Payment',name:'Name',qty:'Qty',unit:'Unit Price',unit_price:'Unit Price',final_price:'Final Price',total:'Total',totals_subtotals:'Subtotal',totals_discount:'Discount',totals_discount_loyalty_points:'Discount from loyalty points',totals_grandtotal:'Total',totals_shipping:'Shipping',totals_extras:'Shopping Bag',totals_extras_27:'Packing Tax',totals_extras_30:'Shopping Bag',totals_extras_38:'Shopping Bag',totals_extras_40:'Shopping Bag',totals_extras_50:'Shopping Bag',totals_tip:'Tips',totals_donation:'Donation',app:'Aplication',custComments:'Customer Comment',adminComments:'Admin Comment',pos_response_title:'POS response',fiscal_response_title:'Fiscal response',custDetails:'Customer Details',shipping:'Shipping Address',billing:'Billing Address',orderStatusSuccess:'Order status updated successfully',orderPrinterError:', but there was an error to the connection with the printer.',orderCommnetSuccess:'Order comment updated successfully',orderHourSuccess:'Order delivery / pick-up time updated successfully',orderHourError:'Please provide a valid hour.',none:'No Comment',at:'at',filtersApplied:'Filters applied - click on filter button to see more',filtersList:'Filters applied',customFilters:'Custom filters applied',resetFilters:'click here to reset and see live data',noFiltersApplied:'No filters applied',filtersAndSort:'Filters & Sort',filters:'Filters',pickupDatetime:'Order Pickup - Datetime',placedDatetime:'When Order Was Placed - Datetime',orderId:'Order ID',orderNumber:'Order Number',orderTotal:'Order Total',enterOrderId:'Enter order ID',enterOrderNumber:'Enter order number',selectDateRange:'Select date range',min:'Min',max:'Max',operator:'Operator',source:'Source',note:'Note',orderNoArticulate:'Order',print:'Print (A4)',print2:'Print (A4 Concise)',printerPrint:'Print (80mm)',printFiscal:'Collect',receipt:'Receipt',printedReceipt:'The order has been collected',notPrintedReceipt:'The order has not been collected',rePrintFiscal:'Re-Print receipt',printerSuccess:'Order successfully printed.',printerErrror:'There was an error to the connection with the printer.',callCourier:'Call courier',callHioCourier:'Hio',callTazzLaasCourier:'Tazz Direct',callCourierCancel:'Are you sure to cancel courier call?',orderSentSuccess:'Call courier was sent with success',orderCancelSuccess:'Call courier was cancelled',packageDetails:'Select package details',packageSize:'Package size: ',courierTime:'Courier pickup time: ',sameStatus:'Order is already ',now:'Now',addTime:'Add time',amountRefunded:'Amount Refunded',amountIntegralRefunded:'Amount was refunded integral to customer',refundSuccess:'Amount refunded with success',refundManual:'The amount will be returned from the paylike manual',refundAutomat:'Do you want to refund amount automatically?',refundOrder:'Refund',refundAlreadyDone:'Already refunded',refundConfirmTitle:'Refund order?',refundConfirmText:'The paid amount will be returned to the customer through EuPlatesc. This action cannot be undone.',refundAskCancel:'Refund done. Do you want to cancel the order as well?',refundError:'An error occurred while processing the refund.',orderCloseToDelivery:'Order with delivery hour closer',erorrPaylike:'Error from Paylike, log was made with error',sendToGrandchef:'Send order to Grandchef?',grandchefError:'Error from Grandchef',grandchefWait:'You can only try once in 30 minutes',cancelReason:'Enter the reason...',orderCountryPrefix:'Prefix',contactPakageez:'Error! Please contact pakageez!',seeImage:'See Image',freyaStatus:'Freya Status',freyaStatus1:'Sending',freyaStatus2:'Sent successfully',freyaStatus3:'Couldn\'t send',freyaStatus4:'Cancelled',freyaSendAgain:'Introduce the order manually or try again',legalPerson:'Company',individual:'Individual',billingInfo:'Billing info',callDriver:'Call delivery driver?',virament:'Virament',cash:'Cash',card:'Card',online:'Online',BOLT:'BOLT',GLOVO:'GLOVO',WOLT:'WOLT',card_no_pos:'Pos mobil',cancel:'Cancel',cui:'Tax number(optional)',glovoStatus:'Glovo Status',glovoLaasEvents:'Glovo LaaS logs',glovoLaasEventsEvent:'Action',glovoLaasEventsTime:'Time',glovoLaasTrackCourier:'Track Courier',glovoLaasLogResponse:'Response',glovoLaasLogAction_Create_delivery:'Create delivery',glovoLaasLogAction_Create_delivery_failed:'Create delivery failed',glovoLaasLogAction_Cancel_delivery:'Cancel delivery',glovoLaasLogAction_Cron_callCourier:'Automatic courier call (cron)',glovoLaasLogAction_Webhook_event_received:'Webhook event received',tazzStatus:'Tazz Status',tazzDirectStatus:'Tazz Direct Status',courierStatus1:'The courier was not called',courierStatus2:'The courier was called',courierStatus3:'The courier was not called',courierStatus4:'The courier was canceled',courierStatus5:'The delivery is managed by glovo',courierStatus6:'An error occurred',courier:'Courier',courierDeliveryError:'Error',courierDeliverySuccess:'Success',courierNoCall:'The courier not was called',packageNumber:'Package count: ',zone:'Zone',roomNumber:'Room Number',pagerNumber:'Pager Number',woltDriveStatus:'Wolt Drive Status',deliveryHeroStatus:'Delivery Hero Status',deliveryHeroAreYouSure:'Call Delivery Hero courier?',deliveryHeroEvents:'Delivery Hero logs',deliveryHeroEventsEvent:'Action',deliveryHeroEventsTime:'Time',deliveryHeroLogResponse:'Response',deliveryHeroLogAction_Create_order:'Create order',deliveryHeroLogAction_Create_order_failed:'Create order failed',deliveryHeroLogAction_Cancel_order:'Cancel order',deliveryHeroLogAction_Cancel_order_failed:'Cancel order failed',deliveryHeroLogAction_OAuth_token:'OAuth token',deliveryHeroLogAction_Status_webhook:'Status webhook',deliveryHeroLogAction_Refund_webhook:'Refund webhook',deliveryHeroLogAction_Autopilot_skip:'Autopilot skip',noShipmentPromises:'No shipment promises available for the selected time.',selectShipmentPromise:'Select Shipment Promise',pleaseSelectPromise:'Please select a shipment promise.',confirmDeliveryDetails:'Confirm delivery details',woltDriveEvents:'Wolt Drive logs',woltDriveEventsEvent:'Action',woltDriveEventsTime:'Time',woltDriveTrackCourier:'Track Courier',woltDriveLogResponse:'Response',woltDriveLogResponse_success:'Success',woltDriveLogAction_Get_shipment_promise:'Get shipment promise',woltDriveLogAction_Get_shipment_promise_failed:'Get shipment promise failed',woltDriveLogAction_Create_delivery:'Create delivery',woltDriveLogAction_Create_delivery_failed:'Create delivery failed',woltDriveLogAction_Cron_callCourier:'Automatic courier call (cron)',woltDriveLogAction_No_binding_shipment_promise:'No binding shipment promise',woltDriveLogAction_Autopilot_No_valid_promises:'Autopilot - No valid promises',woltDriveLogAction_Skip_create_delivery_autopilot_gate:'Skip create delivery (autopilot gate)',woltDriveLogAction_Skip_callCourierAndRetry:'Skip callCourierAndRetry',woltDriveLogAction_Cancel_courier:'Cancel courier',woltDriveLogAction_Cancel_delivery_by_order:'Cancel delivery by order',woltDriveLogAction_Cancel_delivery:'Cancel delivery',woltDriveLogAction_Webhook_event_received:'Webhook event received',woltDriveEventType_order_received:'Order received',woltDriveEventType_order_rejected:'Order rejected',woltDriveEventType_order_pickup_eta_updated:'Pickup ETA updated',woltDriveEventType_order_pickup_started:'Pickup started',woltDriveEventType_order_picked_up:'Order picked up',woltDriveEventType_order_pickup_arrival:'Courier arriving to pickup',woltDriveEventType_order_dropoff_started:'Dropoff started',woltDriveEventType_order_dropoff_arrival:'Courier arriving to dropoff',woltDriveEventType_order_dropoff_completed:'Dropoff completed',woltDriveEventType_order_delivered:'Order delivered',woltDriveEventType_order_customer_no_show:'Customer no-show',woltDriveEventType_order_location_updated:'Courier location updated',woltDriveEventType_order_dropoff_eta_updated:'Dropoff ETA updated',woltDriveEventType_order_handshake_delivery:'Handshake delivery',woltDriveEventType_order_status_updated:'Order status updated',woltDriveCancelErrorCode_INVALID_ORDER_STATE_TRANSITION:'Cannot cancel this delivery: order is not in a cancelable state. Please contact support.',woltDriveShipmentPromisesErrorCode_DROPOFF_OUTSIDE_OF_DELIVERY_AREA:'Dropoff location is outside the delivery area.',woltDriveCreateDeliveryErrorCode_CASH_ON_DELIVERY_DISABLED:'Cash on delivery is not available for Wolt Drive. Please contact Wolt Drive support.'},ordersSource:{1:'Kiosk',2:'Qr',3:'Pos',4:'App',5:'Website',6:'Glovo',7:'Wolt',8:'Bolt'},boogit:{boogitStatus:'Boogit Status',boogitStatus1:'Not sent',boogitStatus2:'Sent successfully',boogitStatus3:'Couldn\'t send',boogitStatus4:'Cancelled'},charisma:{location:'Location',posIds:'POS IDs',partnerCode:'Partner Code',tipsItemId:'Tips Item ID',createDate:'Create Date',updateDate:'Update Date',orderOptionId:'Order Option ID',companyOptionId:'Company Option ID',optionName:'Option Name',optionValueName:'Option Value Name',categoryAdministration:'Administration',charismaInventory:'Charisma Inventory',logRvc:'RVC',dataFrom:'Data From',dataTo:'Data To',enterPosId:'Enter POS ID',enterExternalId:'Enter External ID',options:'Options #',itemCode:'Item Code',itemId:'Item ID',enterItemCode:'Enter Item Code if empty',sendAll:'Send selection',sendAllMessage:'Orders were marked and will be sent to Charisma in a matter of minutes depending on the number of orders',bill:'Bill',invoice:'Invoice',documentType:'Document Type',charisma0:'-',charisma1:'Not sent',charisma2:'Sending',charisma20:'Sending',charisma3:'Sent',charisma4:'Error',sendOnlyProform:'Send only Bill',sendOnlyInvoice:'Send only Invoice',orderItems:'Order items',sendHistory:'Send history',document:'Document',resultCharisma:'Charisma result',verdict:'Verdict',logStatus:'Status',logVerdictSuccess:'Sent successfully',logVerdictError:'Error sending to Charisma',logVerdictCharismaError:'Charisma error',logVerdictAwaitingResponse:'Sent, awaiting response',logVerdictNoPayload:'No data recorded',logVerdictUnknown:'Unknown status',logVerdictMissingPosIds:'Validation error, missing Charisma IDs. Please complete the fields above and send again.',logVerdictMissingCategoryAdministration:'Missing category administration. Please complete the fields above and send again.',logVerdictConnectionError:'Charisma server connection error',logVerdictOrderNotDelivered:'Order is not delivered yet.',resendConfirm:'The order has been sent already, are you sure you want to send the order again?'},fiscalZ:{id:'ID',zNumber:'Number',zTimestamp:'Timestamp',totalSalesA:'Total Sales A',totalSalesB:'Total Sales B',totalSalesC:'Total Sales C',totalSalesD:'Total Sales D',totalSalesE:'Total Sales E',totalOtherTaxes:'Total Other Taxes',totalVatExempt:'Total VAT Exempt',totalSales:'Total Sales',totalVatA:'Total VAT A',totalVatB:'Total VAT B',totalVatC:'Total VAT C',totalVatD:'Total VAT D',totalVatE:'Total VAT E',totalVat:'Total VAT'},companyOptions:{id:'Id',name:'Name',image:'Image',prod_image:'Product Image (just custom app)',info:'Info',type:'Type',print_with_product_label:'Print with product label (for label printers)',product_id:'The option is the Product',deleteQues:'This action will also remove the option from the products it is placed on. Are you sure you want to continue?',deleteVal:'This action will also delete the value from the products it is placed on. If you don\'t want this, don\'t save!',active:'Active',quantitySettings:'Quantity Settings',allowQuantity:'Allow quantity',minQuantity:'Minimum quantity',maxQuantity:'Maximum quantity',quantityMinMaxError:'Minimum quantity cannot be greater than maximum quantity'},catalogProd:{prod_desc:'Description',prod_general:'General',prod_price:'Price',prod_loc:'Location',prod_opt:'Options',prod_mark:'Markenting',prod_lab:'Label',prod_set:'Settings',same_name_are_you_shore:'This name is also found on another product, Are you sure you want to save?',max_purchases_per_customer:'Max Purchases Per Customer',preparation_time_in_minutes:'Preparation time (minutes)',category_preparation_time_hint:'Category preparation time: {minutes} min',label_type:'Type',orderLabelSettings:'Order label printing',printOnOrderLabel:'Print this product on order labels',printOnOrderLabelHint:'This product prints when enabled here and an Order Label printer is set to “Print each product on its own label”.',label_name:'Product name on label',label_ingredients:'Ingredients on Label',label_allergens:'Allergens on Label',label_exp_txt:'Expiration text (eg: Expires within 2 hours of opening)',sold_with_menu_suggestion:'With Menu Suggestion',sold_with_menu_suggestion_pos:'Activate this functionality on POS!',noProducts:'No Product Selected',single:'product',plural:'products',generalDetails:'General Details',aditionalInfo:'Additional Info',id:'ID',name:'Name',desc:'Description',image:'Image',image_size:'Image Size',video_thumbnail:'Video Thumbnail',imageMore:'More images',video:'Video',category:'Category',topCategory:'Top Category',partialPay:'With partialal pay',isDeposit:'Is Deposit',isAgeRestrict:'Age restricted',limitQuantityKioskQr:'Quantity 1 for Kiosk/Qr',secondaryCategory:'Secondary categories',coursesType:'Course type',coursesTypeMaxAllowed:'Maximum value allowed by location: {max}',coursesTypeLocationNotPermitted:'The location does not permit courses',price:'Price',usePriceToShow:'Use price to show',priceToShow:'Price to show',oldPrice:'Old price',newPrice:'New price',deliveryMethod:'Delivery Method',useDiscountPrice:'Use discounted price',taxes:'Applied taxes',status:'Status',posid:'POS ID',allowUserComments:'Allow user comments',availableInStore:'Available only in store',validFromTo:'Valid from - to',prodType:'Product Type',singleType:'single',groupType:'group',rewardPoints:'Reward points',moneySpent:'Money to Points',numberOfYouNeedToSpend:'Number of {currency} that the customer needs to spend to get a point.',points:'points',soldWith:'Sold with',pickAnOption:'Pick an option',minNoSelected:'Min no. selected',maxNoSelected:'Max no. selected',optVal:'Value',leaveEmpty:'Leave empty or put 0 if option does not cost extra',prodDeleted:'Product deleted successfully',prodAdded:'Product added successfully',prodUpdated:'Product updated successfully',prodPhotoError:'We could not save the product photo, please try again later.',rewardPossibelValue:'Possible values',errorOptions:'Please make sure that all product fields are filled in correctly.',productOptionError:'Please make sure that all option fields are filled in correctly.',minNoNegative:'Min no. can\'t be less than 0',maxNoNegative:'Max no. can\'t be less than 0',minNoTooHigh:'Min no. can\'t be greater than max no.',maxNoTooHigh:'Max no. can\'t be greater than the values no.',optionInUse:'This option is used by some products. Remove it first from the products that use it.',locationSettings:'Locations Settings',availableIn:'Available in',availableInLocation:'Available in location',availableFor:'Available for',availableForSource:'Available for source',groupOption:'Options group',deliveryMethodsandHours:'Delivery Methods and Hours',overrideSettings:'Override Settings',addLocationValidation:'Some product options are not compatible with the selected locations, if you continue, the options will be removed, if not, the location will not be added.',productAvailableIn:'Product is available in',particularLocationSettings:'Custom settings by location',activateParticularSettings:'Activate custom settings',withoutThisOptionDefault:'*without activating this option default settings will be used',highlightsProduct:'Highlights product',search:'Search',availability:'Availability',setLimitedAvailability:'Set limited availability',leaveEmptyAvailability:'Leave empty for unlimited.',timeOptions:'Date Time Options',picktimeOptions:'Pick an option:',timeOptionsValues:{none:'None',dateTimePicker:'Date Time Picker',dateRangePicker:'Date Range Picker'},maxQuantityIn:'Maxim quantity in',unitOfTime:'unit of time',youChoose:'You choose',isUsedFor:'*Is used just for location which is set.',isHiddenFromListing:'Hide from products listing',isHiddenFromSearch:'Hide from products search',isHiddenFromQrMenu:'Hide from Qr menu',isHiddenFromPOS:'Hide from POS',isHiddenFromKiosk:'Hide from Kiosk and Meniu Qr',Monday:'Mon',Tuesday:'Tue',Wednesday:'Wed',Thursday:'Thu',Friday:'Fri',Saturday:'Sat',Sunday:'Sun',accesRestricted:'Sorry, you do not have access to this product',disableProductUsedByBanner:'Disabling this product will disable the related banner. Are you sure?',deleteProductUsedByBanner:'Deleting this product will disable the related banner. Are you sure?',availabilityTitle:'Product availability',fromTime:'From',toTime:'to',timePlaceholder:'Select time',productNotAvailable:'Product unavailable',productNotAvailableError:'Please fill these two fields.',swalTitleChangeStatus:'Please set the product status to "active" first.',externalProductId:'External product ID',minQuantity:'Minimum quantity',hideFromPlatforms:'Hide from platforms',changeLocations:'Change locations',includeAllLocationsProducts:'Include also the products available in all locations',bulkLocationsMode:'Action',bulkModeAdd:'Add',bulkModeRemove:'Remove',bulkModeReplace:'Replace',massUpdate:'Mass update',massUpdateSubtitle:'You are about to update {count} products',bulkActionActive:'Active / Inactive',bulkActionPrice:'Price',bulkActionVat:'VAT',bulkActionSection:'Section',bulkActionOptionGroups:'Option groups',bulkActionDelete:'Delete',bulkOverrideDeliveryHint:'When activating, add only the delivery methods you need (+). Existing override schedules on the selected products are replaced. Inactive intervals are not saved. Disabling clears existing override schedules.',bulkOverrideLocationsHint:'Leave empty to use all company locations. Only locations that already belong to each product are applied.',bulkOverrideAddIntervalHint:'Click + to add a schedule interval for this method.',bulkPriceDirection:'Direction',bulkPriceIncrease:'Increase',bulkPriceDecrease:'Decrease',bulkPriceMode:'Type',bulkPriceFlat:'Flat amount',bulkPricePercent:'Percentage (%)',bulkPriceAmount:'Amount',bulkPriceBaseOnlyHint:'Only the base price is changed. The new price will never go below 0.',bulkOptionGroupsMode:'Association mode',bulkOptionGroupsModeHint:'Add keeps existing groups. Replace overwrites them with the selected ones.',bulkDeleteWarning:'This will permanently delete {count} products. This action cannot be undone easily.',bulkDeleteEnableLabel:'Yes, delete the selected products (other mass actions will be ignored)',confirmBulkMultiple:'Apply these changes to {count} {products}:',bulkProductSingular:'product',bulkProductPlural:'products',confirmBulkAreYouSure:'Are you sure?',bulkSummaryAddLocations:'add locations ({value}) to {count} {products}',bulkSummaryRemoveLocations:'remove locations ({value}) from {count} {products}',bulkSummarySetActive:'set {count} {products} as active',bulkSummarySetInactive:'set {count} {products} as inactive',bulkSummaryIncreasePriceFlat:'increase the base price of {count} {products} by {amount} {currency}',bulkSummaryIncreasePricePercent:'increase the base price of {count} {products} by {amount}%',bulkSummaryDecreasePriceFlat:'decrease the base price of {count} {products} by {amount} {currency}',bulkSummaryDecreasePricePercent:'decrease the base price of {count} {products} by {amount}%',bulkSummaryAddOptionGroups:'add option groups ({value}) to {count} {products}',bulkSummaryReplaceOptionGroups:'replace option groups on {count} {products} with ({value})',bulkSummarySetVat:'set VAT {value} on {count} {products}',bulkSummarySetSection:'set section {value} on {count} {products}',bulkSummaryEnableOverride:'enable override settings on {count} {products}',bulkSummaryEnableOverrideWithSchedule:'replace override schedules on {count} {products}',bulkSummaryDisableOverride:'disable override settings on {count} {products}',bulkSummaryDelete:'delete {count} {products}',bulkSummaryGeneric:'update {count} {products}',confirmBulkAddLocations:'Are you sure you want to add locations to {count} products?',confirmBulkRemoveLocations:'Are you sure you want to remove locations from {count} products?',confirmBulkSetActive:'Are you sure you want to set {count} products as active?',confirmBulkSetInactive:'Are you sure you want to set {count} products as inactive?',confirmBulkIncreasePriceFlat:'Are you sure you want to increase the base price of {count} products by {amount}?',confirmBulkIncreasePricePercent:'Are you sure you want to increase the base price of {count} products by {amount}%?',confirmBulkDecreasePriceFlat:'Are you sure you want to decrease the base price of {count} products by {amount}?',confirmBulkDecreasePricePercent:'Are you sure you want to decrease the base price of {count} products by {amount}%?',confirmBulkAddOptionGroups:'Are you sure you want to add option groups to {count} products?',confirmBulkReplaceOptionGroups:'Are you sure you want to replace option groups on {count} products?',confirmBulkSetVat:'Are you sure you want to set VAT on {count} products?',confirmBulkSetSection:'Are you sure you want to set the section on {count} products?',confirmBulkDelete:'Are you sure you want to delete {count} products?',confirmBulkGeneric:'Are you sure you want to update {count} products?',bulkLocationsUpdated:'Updated locations for {updated} products',bulkMassUpdated:'Updated {updated} products',couldNotFetchProductOptions:'Could not fetch product options. Please contact support.'},vat:{selectVat:'VAT %',generalTaxes:'General Taxes',deleteVatSuccess:'VAT deleted successfully',deleteVatError:'Error occured while deleting VAT'},magister:{syncLabel:'Magister Menu Sync',syncPrices:'Products Prices Sync',syncStocks:'Stocks Prices Sync',magisterStatus:'Magister Status',magisterStatus1:'Sending',magisterStatus2:'Sent successfully',magisterStatus3:'Couldn\'t send',magisterStatus4:'Order has been cancelled'},catalogProdRewardsHints:{hint1:'Leave empty to apply default value from settings',hint2:'Put 0 to not apply reward program on this product',hint3:'Add a positive value to override default value from settings'},catalogCateg:{no_discount_allowed:'Do not accept discounts on this category at the pos!',disabledOrderSources:'Disable the category for sources',disabledOrderSourcesHelp:'The category will not be available on the selected sources.',isAgeRestrict:'Age restricted',notification_email:'E-mail Notification',single:'category',plural:'categories',color:'Color',name:'Name',image:'Image',displayType:'Display Type',shortDescription:'Short Description',validFromTo:'Valid from - to',areYouSure:'Are you sure you want to {label} this category?',categAdded:'Category added successfully',categUpdated:'Category updated successfully',categDeleted:'Category deleted successfully',prodDeleted:'Products deleted successfully',couldNotSave:'We could not save the category photo, please try again later.',List:'List',Grid:'Grid',assignTopCategory:'Assign top category',pleaseSelect:'Please select / Not applicable',categoriesWithoutParent:'Categories without parent',topCategory:'Top Category',forceMethod:'Force delivery method',selectMethod:'Select Methods',enableMethod:'(To enable remove top category)',vat:'VAT %',vatTitle:'VAT',included:'included',preparation_time_in_minutes:'Preparation time (minutes)',areYouSureDeleteProducts:'Are you sure you want to delete all products from this category?',deleteProducts:'Delete all product from this category',overrideSettingsHelp:'When enabled, this category only appears in the menu for the selected location, delivery method, day and time window.',userLabelings:'User labelings',userLabelingsHelp:'This category will be visible only for users with one of these labels',schedule:'Schedule',useSchedule:'Use schedule',scheduleActive:'Schedule active',scheduleHelp:'One schedule for this top category across all locations. Outside these hours, ordering from this category is unavailable in the app.',secondaryMember:'secondary'},catalogProdOpt:{addNewOptionValue:'Add New Option',active:'Option Value Status',image:'Option Image',generalInformation:'General Info',settings:'Settings',optionType:'Option Type',info:'Optional (nutritional) information',infoPlaceholder:'This information will appear under the kiosk/qr option',single:'Option',plural:'options',new:'New Option',name:'Name',option_name:'Option Name',label:'Label (visible only in Inventory panel)',type:'Type',show_type:'Displayed in app',show_type_kiosk:'Displayed on Kiosk/Table',vat:'Cota TVA optiune',vatSGR:'Cota TVA SGR',section:'Option Section',value:'Value',values:'Values',posid:'POS ID 1 (integration)',posid2:'POS ID 2 (integration)',variants_id:'Pos ID Variants (integration)',optionSaved:'Product options saved successfully.',areyouSure:'Are you sure you want to delete this option?',optLocationError:'{opt_name} option needs to include {loc_name} for available locations',menuQr:'QR Menu',displayInMenu:'Display in QR menu',alsoSaveProduct:'After changing and saving the options, you must also save the products to which they are applied. Visit the page of',sgrName:'SGR Name',sgrPos:'SGR POS ID',sgrPrice:'SGR Price',isModifier:'Plus/No/Side in POS',isProduct:'Option is a product',isProductDesc:'e.g.: cola, whipped cream, bacon, mushrooms, large, small, etc...',isModifier2:'Option is a modifier',isModifierDesc:'e.g.: hot, cold, well done, etc... (DOES NOT AFFECT INVENTORY)',productIdRequired:'Product ID is required for all values when the option is set as product!'},marketingSubscriptions:{single:'subscription',refundPayment:'Give the money back',reason:'Reason (required)',reasonRequired:'Write the reason',cancelSubscription:'Cancel the subscription',cancelHint:'The subscription ends now and is not renewed. No money is given back (use the button of each payment for that).',cancelAreYouSure:'Cancel the subscription now?',cancelDone:'The subscription was cancelled',downgrade:'Downgrade',downgradeTo:'Move to the level',downgradeHint:'The customer moves now to a lower level; the next renewal is at that level\'s price. No money is moved.',downgradeAreYouSure:'Move the customer to {name} now?',downgradeDone:'The subscription was moved to the lower level',history:'History of actions',noHistory:'No operator action yet.',eventCancel:'Cancelled',eventDowngrade:'Downgraded',eventRefund:'Money given back',payRefunded:'Refunded',refundAndCancel:'Refund and cancel the subscription',refundHint:'The {amount} of this payment goes back to the customer (reversal if the transaction is not captured yet, refund if it is). The subscription is NOT changed: use Cancel / Downgrade above for that.',refundComment:'Reason (required)',refundCommentRequired:'Write the reason of the refund',refundConfirm:'Confirm refund',refundAreYouSure:'Give {amount} back to the customer? The subscription is not changed.',refundDone:'The payment was given back',refundTypeRefund:'Refund',refundTypeReversal:'Reversal',dateFrom:'From',dateTo:'To',renewalCancelledAt:'Renewal cancelled on',customerActiveSubscriptions:'Active subscriptions',customerNoSubscriptions:'No active subscription',until:'until',newCoupon:'New coupon',newCouponTitle:'New subscription coupon',inheritedFromLevel:'From level {level} - {name}',ownCouponsTitle:'+ Coupons of this level',inheritedIncluded:'included from level {level} - {name}',details:'Details',name:'Name',price:'Price',description:'Description (how it works)',image:'Image',imageHint:'jpg / png, max 5MB',active:'Active',status:'Status',coupons:'Coupons',couponsHint:'Only coupons ticked as "Subscription coupon". The customer also gets the coupons of the lower levels.',selectedCount:'{count} selected',searchCoupons:'Search coupon by name or code',noCoupons:'There are no subscription coupons yet. Create one with "New coupon".',noCouponsFound:'No coupon matches the search.',multipleCodes:'Multiple codes',freeProduct:'Free product',inactive:'inactive',noneAssigned:'No coupons',actions:'Actions',saved:'The subscription was saved',deleted:'The subscription was deleted',areYouSureDelete:'Are you sure you want to delete the subscription',deleteLastLevelWarning:'It is the only level, so the family is deleted too.',nameRequired:'The name is required',priceRequired:'The price is required (0 or more)',noSubscriptions:'There are no subscriptions yet. Add the first one.',levelsCount:'{count} levels',oneLevel:'1 level',activeSubscribersCount:'{count} active subscribers',paymentAccount:'Payment account',editFamily:'Edit family',allSubscribers:'All subscribers',subscribers:'Subscribers',addLevelOnTop:'Add a level on top of {name}',level:'Level',benefits:'Benefits',inheritedCount:'+{count} from lower levels',inheritedTitle:'Inherited from the lower levels',lockedDelete:'It has subscribers (active or awaiting payment), you can only deactivate it.',notTopDelete:'Only the top level of a family can be deleted.',inactiveHint:'Inactive = can no longer be bought. Customers who have it keep it and renew.',family:'Family',familyName:'Family name',familyNew:'New family',familyExisting:'Add to an existing family',familyNameHint:'Defaults to the subscription name',selectFamily:'Choose the family',familyRequired:'Choose the family',willBeLevel:'It will be level {level}, on top of {name} ({price})',levelOf:'Level {level} of the family {family}',priceHintBelow:'Level below: {name} - {price}. Upgrade difference: {diff}',priceHintAbove:'Level above: {name} - {price}',priceTooLow:'The price must be higher than the level below ({price})',priceTooHigh:'The price must be lower than the level above ({price})',inheritedCoupons:'Inherited benefits',noInherited:'No inherited benefits (base level).',paymentProcessor:'Payment processor',paymentRequired:'Choose the payment processor',noPaymentAccounts:'There is no euPlatesc payment processor on the company. Add one in Settings > Payments.',paymentLockedHint:'The payment processor can\'t change while the family has active subscribers.',familySaved:'The family was saved',familyNameRequired:'The family name is required',subscribersTitle:'Subscribers',stateAll:'All',stateActive:'Active',stateExpiring:'Expiring in 5 days',stateUnpaid:'Unpaid',stateExpired:'Expired',stateCancelled:'Cancelled',statePending:'Awaiting first payment',stateAbandoned:'Abandoned (never paid)',customer:'Customer',activeFrom:'Active from',activeUntil:'Active until',activeUntilRange:'Active until (interval)',autoRenew:'Auto renew',autoRenewAll:'Auto renew: all',yes:'Yes',no:'No',totalPaid:'Total paid',lastPayment:'Last payment',searchSubscribers:'Search by name, email or phone',allLevels:'All levels',noSubscribers:'No subscribers for the selected filters.',backToList:'Back to the list',periods:'Periods',kindFirst:'First payment',kindRenewal:'Renewal',kindUpgrade:'Upgrade',periodPaid:'Paid',periodUnpaid:'Unpaid',periodCancelled:'Cancelled',paymentAttempts:'Payment attempts',methodLink:'Payment link',methodSavedCard:'Saved card',payCreated:'Created',payPending:'Pending',paySuccess:'Successful',payFailed:'Failed',payExpired:'Expired',payCancelled:'Cancelled',showLogs:'Processor logs',request:'Request',response:'Response',noPeriods:'No periods yet.',noPayments:'No payment attempts.',card:'Card',currentLevel:'Current level',renewalPrice:'Renewal price',subscriberSince:'Subscriber since',autoChargeAttempts:'Automatic charge attempts',notifiedAt:'Expiry notification sent'},marketingAutomation:{single:'automatic campaign',details:'Automatic campaign details',name:'Name',type:'Campaign type',period:'Running period',active:'Active',status:'Status',notifications:'Notifications',coupons:'Coupons',state_running:'Running',state_scheduled:'Scheduled',state_ended:'Ended',typeBirthday:'Birthday',typeGeofencing:'Geofencing (in range)',typeAbandonedCart:'Forgotten items in the cart',typeProductViews:'Product viewed several times',comingSoon:'coming soon',typeLocked:'The type can not be changed after the campaign is created.',birthdayRule:'The coupons are applied automatically only on the customer\'s birthday, once per year. A customer who already benefited this year is not notified again.',announceTitleBox:'Announcement before the birthday',announceDaysBefore:'Send it',daysBeforeBirthday:'days before the birthday',announceOffHint:'No announcement: the customer gets only the notification on the day.',announceDaysBeforeShort:'Announcement {days} days before',announceDaysInvalid:'Between 1 and {max} days.',dayTitleBox:'Notification on the birthday',onTheDayShort:'On the birthday',sentAt:'sent at {time}',endsIn:'ends in {days} days',endsToday:'ends today',startsIn:'starts in {days} days',pushTitle:'Notification title',pushMessage:'Notification text',sendTime:'Sending hour',sendTimeHint:'The notifications are sent at this hour (company timezone).',preview:'Preview',placeholdersHint:'You can use in the text (click to add):',clickToInsert:'Click to add it to the text',placeholderName:'customer first name',placeholderDays:'days left until the birthday',placeholderCode:'the coupon code (informative)',codeNeedsCoupon:'available after you select a coupon (below)',codeNotInNoCoupon:'not used in the notification without coupon',codeWithoutCoupon:'The campaign has no coupon: {cod} is sent empty (the text goes out without a code).',exampleAnnounceNoCouponTitle:'Your birthday is coming! Only {zile} days left 🎉',exampleAnnounceNoCouponMessage:'Hi {nume}! We are happy to be part of this special moment. Come with your friends or order from the app and let\'s celebrate together!',exampleDayNoCouponTitle:'Happy birthday, {nume}! 🎂',exampleDayNoCouponMessage:'We wish you a wonderful day, full of joy and dear people around you. We are waiting for you to celebrate together!',optional:'optional',cartRule:'Only app carts of logged customers, created after the campaign and less than 5 days old, not empty. Notification 1 comes X minutes after the last cart change (with the coupon, valid 24h, once, on any order). Notification 2 only if notification 1 was sent and the cart did not change since. Max 2 notifications per cart; a new cart = new notifications.',cartFirstBox:'Notification 1',variantWithCoupon:'with coupon',variantNoCampaignCoupon:'reminder (the campaign has no coupon)',variantNoCoupon:'without coupon',noCouponNeedsCoupon:'available after you select a coupon (below); without coupons everybody gets the notification above',cartFirstDelay:'Send it',minutesAfterChange:'minutes after the last cart change',cartNoCouponBox:'Notification 1 without coupon',cartNoCouponHint:'Goes instead of the one above to the customers who get no coupon this time (they already got one in the last X days - see "Coupon recurrence" - or the coupon is no longer valid). Do not promise a discount here.',cartSecondBox:'Notification 2',cartSecondDelay:'Send it',minutesAfterFirst:'minutes after notification 1',cartSecondHint:'Only if notification 1 was sent and the customer did not change the cart since. It also goes to the customers without coupon, so keep it general (or use {cod}, empty for them).',cartSecondOffHint:'Only notification 1 is sent.',quietBox:'Quiet hours (no notifications at night)',quietFrom:'from',quietTo:'to',quietHint:'A notification due in this interval is sent when it ends (company timezone). Notification 2 counts from the moment notification 1 was really sent.',quietOffHint:'Notifications are sent at any hour.',cooldownBox:'Coupon recurrence',cooldownLabel:'The coupon again only after',cooldownNeedsCoupon:'available after you select a coupon (above)',cooldownDays:'days (0 = with every forgotten cart)',cooldownHint:'After a customer got a cart coupon, the next forgotten carts in this interval get only the reminder (the text without coupon).',cartFirstWhen:'{time} after the last change',cartSecondWhen:'{time} after notification 1',unitDay:'d',delayInvalid:'Between {min} and {max} minutes.',cooldownInvalid:'Between 0 and {max} days.',quietInvalid:'The start and the end of the quiet hours must be different.',exampleCartFirstTitle:'{nume}, you forgot something in your cart 🛒',exampleCartFirstMessage:'Your products are waiting for you! Finish the order in the next 24 hours and get 10% off with the code {cod} - it is applied automatically.',exampleCartNoCouponTitle:'{nume}, your cart is waiting for you 🛒',exampleCartNoCouponMessage:'The products you picked are still in your cart. Finish the order in a few seconds, from the app.',exampleCartSecondTitle:'Last chance, {nume}!',exampleCartSecondMessage:'Your cart is still here. Do not miss what you picked - order now from the app.',statusAllSent:'Notified',status_notified:'Reminder only',status_converted:'Cart ordered',cartStatusGranted:'Coupon active',cartStatusUsed:'Used the coupon',validUntil:'until {time}',cart:'Cart',cartPush1Short:'Notif. 1',cartPush2Short:'Notif. 2',cartPlaced:'ordered',beneficiaries:'Beneficiaries',beneficiariesTitle:'Beneficiaries',viewBeneficiaries:'See the list',statusAll:'All',status_granted:'Granted',status_used:'Benefited',status_expired:'Expired (not used)',customer:'Customer',birthday:'Birthday',yearLabel:'year {year}',order:'Order',searchCustomer:'Search name, phone, email...',allYears:'All years',noBeneficiaries:'Nobody yet.',announcePushShort:'Announcement',dayPushShort:'On the day',pushNotSent:'not sent',push_sent:'sent',push_nodevice:'no notifications',push_failed:'failed',useExample:'Use the example',useExampleConfirm:'Replace the current title and text with the example?',previewExampleNote:'Empty fields: the preview shows the example text.',codeMissing:'The text uses {cod}, but none of the selected coupons has a code.',exampleAnnounceTitle:'Your birthday is coming! Only {zile} days left 🎉',exampleAnnounceMessage:'Hi {nume}! We are happy to be part of this special moment, so on your birthday you get 20% off an order of at least 100 lei with the code {cod}. Come with your friends or order from the app and let\'s celebrate together!',exampleDayTitle:'Happy birthday, {nume}! 🎂',exampleDayMessage:'Today is your day and our gift is waiting: 20% off all dishes on an order of at least 100 lei. Your code {cod} is applied automatically. Enjoy it now!',couponsHint:'Optional: without coupon the campaign sends only the notifications. Only the coupons ticked "Used in automatic marketing" are listed; the customer gets all the selected coupons.',selectedCount:'{count} selected',newCoupon:'New coupon',newCouponTitle:'New automatic marketing coupon',noCoupons:'There is no coupon used in automatic marketing yet. Create one with "New coupon".',searchCoupons:'Search coupon...',noCouponsFound:'No coupon found.',couponsRequired:'Select at least one coupon.',couponInactive:'Inactive coupon',inactive:'inactive',expired:'expired',saved:'The campaign was saved.',deleted:'The campaign was deleted.',areYouSureDelete:'Are you sure you want to delete the campaign {name}?'},marketingCoupons:{single:'coupon',isAutomation:'Used in automatic marketing',isAutomationHint:'The coupon is not applied to everybody and its code can not be typed in: it is applied automatically only to the customers an automatic campaign gives it to (e.g. on their birthday).',automationCampaigns:'Automatic campaigns',automationLockedUsed:'Given by automatic campaigns: remove it from them first.',automationLockedCampaign:'Announced by push campaigns: it can not be used in automatic marketing.',automationInfoCode:'Automatic marketing coupon: the code is only informative (it can be shown in the notifications with {cod}). It can not be typed in anywhere: the discount is applied automatically to the customers who meet the campaign conditions.',automationCodeLabel:'Informative code (optional)',automationCodePlaceholder:'e.g. BIRTHDAY20',automationBadge:'Automatic',subscriptionAutomationExclusive:'A coupon can not be both a subscription and an automatic marketing coupon.',isSubscription:'Subscription coupon',isSubscriptionHint:'Applies only to customers with an active subscription that includes it: no code, never applied automatically, no usage limits.',subscriptionBadge:'Subscription',subscriptionLevels:'Given by the subscriptions',subscriptionLockedUsed:'Subscriptions give this coupon: remove it from them before unticking.',subscriptionLockedCampaign:'Push campaigns announce this coupon, so it can not become a subscription coupon.',subscriptionNoCode:'A subscription coupon has no code: it applies only to customers with an active subscription.',name:'Name',code:'Code',multipleCodes:'Multiple codes',discount:'Discount',freeProduct:'Free product',validFromTo:'Valid from - to',daysLeft:'Days left',status:'Status',active:'Active',pushCampaigns:'Push campaigns',notAssigned:'Not assigned',couponDetails:'Coupon details',couponSaved:'The coupon was saved.',couponDeleted:'The coupon was deleted.',areYouSureDelete:'Are you sure you want to delete the coupon',deleteAssignedWarning:'This coupon is announced by the push campaigns: {campaigns}. They will remain without a coupon.',selectCoupon:'Coupon announced by this campaign',selectCouponHelp:'The discount is applied by the coupon (its own validity and conditions). The campaign only announces it. Coupons are managed in the Coupons tab.',noCoupon:'No coupon',couponInactive:'The selected coupon is inactive.',couponOutsideCampaign:'The campaign period is outside the coupon validity.',deleteCampaignCouponQuestion:'This campaign announces the coupon {coupon}. The coupon is not deleted together with the campaign. What do you want to do with it?',keepCouponActive:'Keep the coupon as it is',deactivateCoupon:'Deactivate the coupon',export:'Export',openQr:'Open the QR image',qrLink:'QR image link',used:'Used',sources:'Order sources',allSources:'All',noCategories:'No categories / products',generatorTitle:'Generate codes',generatorCount:'Number of codes (max 1000)',generatorLength:'Length of the random part',generatorCharset:'Characters',generatorCharsetAlnum:'Letters + digits (without 0/O, 1/I/L)',generatorCharsetLetters:'Letters only',generatorCharsetDigits:'Digits only',generatorPrefix:'Prefix (in front)',generatorSuffix:'Suffix (at the end)',generatorGroup:'Group with "-"',generatorGroupNone:'No grouping',generatorExample:'Example',generate:'Generate',generatedCodes:'{count} codes were generated. Save the coupon to keep them.',deleteAllCodes:'Delete all',deleteAllCodesConfirm:'Delete all {count} codes? Saved codes are removed when you save the coupon.',codeStatus_available:'Available',codeStatus_used:'Used',codeStatus_new:'New (not saved)'},marketingCampaigns:{intern:'Intern',extern:'Extern',url:'URL',category:'Category',product:'Product',single:'campaign',plural:'campaigns',name:'Name',nameHelper:'This name will be used as a subject for the e-mail notifications sent for this campaign.',image:'Image',startEnd:'Start - End Date',daysLeft:'Days Left',timesUsed:'Times used',status:'Status',actions:'Actions',send:'Send',stopSending:'Stop sending',campaignStoppedSuccessfuly:'Sending the campaign has been stopped',areYouSureCancelSending:'Are you sure you want to cancel sending',notBeingSending:'is not being sent',cannotDelete:'Campaign cannot be deleted while being sent',cannotModify:'Campaign cannot be modified while being sent',off:'from',sentData:'Submission data',sent:'Total sent',notif_sent:'Notification',email_sent:'E-mail',areYouSureNotif:'Are you sure you want to send out the notifications?',notifSent:'Notifications have been queued and are about to be sent!',campaignDeleted:'Campaign deleted successfully.',areYouSureDelete:'Are you sure you want to delete ',campaignAdded:'Campaign added successfully',campaignUpdated:'Campaign updated successfully',campaignPhotoError:'We could not save the campaign photo, please try again later.',campaignDetails:'Campaign Details',description:'Notification text',maxDescription:'(max. 400 characters)',characters:'characters',validFromTo:'Valid from - to',notif:'Notifications',mode:'Mode',setHours:'Set Hours',selectTime:'Select time',chooseTarget:'Choose target audience',gender:'Gender',age:'Age',donation_points:'Donation points',city:'City',locations:'Locations',visibleInLocations:'Visible in the following locations',visibleInLocationsInfo:'This functionality is available only on Application',ordersAbove:'Orders above',ordersBelow:'Orders below',ordersAboveNr:'Nr of orders above',ordersBelowNr:'Nr of Orders below',addCoupon:'Add Coupon',applyTo:'Apply to',value:'Value',code:'Code',addValue:'Add Value',minValue:'Minimum amount',counter_max_usage:'How many times a person can use this coupon?',counter_max_usage_total:'How many times can this coupon be used in total?',counter_max_usage_example:'Type in a number for the max number of usages per person. Type 0 for unlimited.',counter_max_usage_total_example:'Type in a number for the max number of usage. Type 0 for unlimited.',generateCode:'Generate Code',Products:'Products',Shipping:'Shipping',Tax:'Taxes',chooseCategProduct:'Choose categories or products on which the coupon will apply:',delivery_methods:'On which delivery methods should the coupon be applied?',order_source_ids:'Order sources',order_source_ids_all:'All sources',order_source_ids_help:'Leave empty to apply on all order sources.',location_ids:'On which location should the coupon be applied?',sendNotificationTo:'Send notification to',chooseDayForInterval:'Choose day for interval',chooseHoursForInterval:'Choose hours for interval',useInterval:'Use interval',isCumulativeCheck:'This coupon applies cumulatively',isAutoApplyCheck:'This coupon applies directly',doesApplyOnPromotionalItems:'This coupon applies only on promotional products',intervalMustBeSet:'Interval must be set',campaignWasSent:'Campaign was sent in last 30 min',isSecondUseCheck:'This coupon applies directly after first use',couponHasMultipleCodes:'Use multiple coupons codes',withOrdersLabel:'With/out Orders',withOrders:'with orders',withoutOrders:'without orders',withLoyaltyPointsLabel:'With/out Loyalty Points',withLoyaltyPointsAll:'All',withLoyaltyPoints:'with loyalty points',withoutLoyaltyPoints:'without loyalty points',loyaltyPointsColumn:'Loyalty Points',groups:'Client Groups',exclude_groups:'Excluding Client Groups',chooseImage:'Choose an image',template:'Template',useEmailTemplate:'Use this text for both push notification AND email',productTreeError:'Check at least one product',checkAll:'Check all',freeProduct:'Free product to add to cart',freeProductPlaceholder:'Type the product name to search...',freeProductRequired:'Please select a free product',freeProductSelectTypeHint:'Select the "Free product" coupon type above to choose which product is added to the cart.',freeProductHelp:'This is the product automatically added to the customer\'s cart. The list on the right defines which products/categories qualify for the coupon.',freeProductSearchHint:'Start typing the product name to find and select it.',minOrderValue:'Minimum order subtotal',minOrderValuePlaceholder:'0 = no minimum',minOrderValueHelp:'Free product is applied only when order subtotal (products + extras) is at least this amount. Leave empty or 0 for no minimum.',registeredAfter:'Registered after',period:'From date - to date',location:'Location',open:'Open'},loyaltyStore:{campaignName:'Campaign name',description:'Description',generalSettings:'General settings',active:'Active',availability:'Availability',locations:'Locations',locationsInfo:'Leave empty for all locations',rewards:'Rewards',rewardsCount:'Rewards',addReward:'Add reward',editReward:'Edit reward',reward:'Reward',rewardType:'Type',typeProduct:'Product',typeGiftCard:'Gift card',product:'Product',category:'Category',searchCategory:'Search category',searchProduct:'Search product',giftCardValue:'Gift card value',pointsCost:'Loyalty points cost',deleteConfirmation:'Are you sure you want to delete?',rewardsSaveFailed:'The campaign was saved, but some rewards could not be saved. Your remaining rewards are still here. Click Save to retry.',nameRequired:'Campaign name is required',pointsCostRequired:'Loyalty points cost is required',productRequired:'Product is required',giftValueRequired:'Gift card value is required',giftCardsModuleRequired:'Enable marketing gift cards on the company to use gift card rewards.',timesSold:'Times sold',totalPointsSpent:'Total points spent',totalGiftValue:'Gift value issued',purchases:'Purchases',user:'User',orderId:'Order ID',giftCardId:'Gift card ID',datetime:'Date & time',campaign:'Campaign'},donationCampaigns:{single:'donation campaign',plural:'donation campaigns',id:'ID',search:'Search',name:'Name',beneficiary:'Beneficiary',description:'Description',image:'Image',startEnd:'Start - End Date',daysLeft:'Days Left',targetAmount:'Target Amount',suggestedAmount:'Suggested Amount',collectedAmount:'Collected Amount',progress:'Progress',donorsCount:'Donors',donationsCount:'Donations',details:'Donation Campaign Details',stats:'Statistics',active:'Active',location:'Locations',locationInfo:'Leave empty to make available in all locations',allCampaigns:'All Campaigns',areYouSureDelete:'Are you sure you want to delete',campaignDeleted:'Donation campaign deleted successfully.',campaignAdded:'Donation campaign added successfully.',campaignUpdated:'Donation campaign updated successfully.',removeCurrentImage:'Please remove the current image before adding a new one',fundingMode:'Funding Mode',fundingModeClientOptional:'Customer chooses donation at checkout',fundingModeRestaurantFlat:'Restaurant pays a fixed amount per order',fundingModeRestaurantPercent:'Restaurant pays % of order subtotal',restaurantFlatAmount:'Amount per order',restaurantPercent:'Percentage of order subtotal (0–100)',allLocations:'All locations',onlyOneActivePerLocation:'There can be only 1 active donation campaign per location.',fiscalizationInfoPrefix:'To configure how donations are fiscalized, open ',fiscalizationInfoLink:'Locations,',fiscalizationInfoSuffix:' edit a location, go to Other Settings → Pos Settings, and set "{field}".',activeCampaignExistsTitle:'Campaign saved',activeCampaignExistsMessage:'The campaign was saved successfully, but there is another active campaign ({name}). Do you want to activate this one instead?',activeCampaignExistsActivateMessage:'There is another active campaign ({name}). Do you want to activate this one instead?',activeCampaignExistsWarning:'Warning: this means the other campaign will not be visible for users!'},raffleCampaigns:{single:'raffle campaign',plural:'raffle campaigns',id:'ID',name:'Name',search:'Search',searchParticipants:'Search email or name',userId:'User ID',description:'Description',winnersDescription:'Winners list',winnersPlaceholder:'Use this field to let users know who won the raffle',image:'Image',startEnd:'Start - End',details:'Raffle Campaign Details',active:'Active',type:'Type',typeOrderCount:'Raffle',typeOrderTotal:'Hero',typeOrderCountHint:'Based on number of orders. A random winner is picked with a third-party tool.',typeOrderTotalHint:'The winner is determined by the amount spent in the app.',typeLocked:'Type cannot be changed after creation.',typeRequired:'Type is required.',minOrderValue:'Minimum order value',pdf:'PDF',periodRequired:'Start and end dates are required.',areYouSureDelete:'Are you sure you want to delete',campaignDeleted:'Raffle campaign deleted successfully.',campaignAdded:'Raffle campaign added successfully.',campaignUpdated:'Raffle campaign updated successfully.',removeCurrentImage:'Please remove the current image before adding a new one',removeCurrentPdf:'Please remove the current PDF before adding a new one',usersJoined:'Users joined',ordersCount:'Orders count',ordersTotal:'Orders total',participants:'Participants',exportEntries:'Export entries',joinedAt:'Joined at',score:'Score',orderNumber:'Order number',orderCreatedAt:'Order created at',registeredAt:'Registered at'},challengeCampaigns:{single:'challenge',plural:'challenges',id:'ID',search:'Search',searchByTitle:'Search by title',title:'Title',titlePlaceholder:'e.g. Early Bird',description:'Description',descriptionPlaceholder:'e.g. Order 5 coffees before 9 AM',image:'Image',details:'Challenge Details',target:'Target',minOrderValue:'Minimum order value',periodOfTimeDays:'Membership period (days)',periodOfTimeDaysHint:'e.g. 365 = client for 1 year from first order',distinctOrder:'Distinct order',distinctOrderHint:'When enabled, each qualifying order counts as 1 step regardless of product quantity.',timePeriod:'Challenge period',orderTimeFrom:'Order time from',orderTimeTo:'Order time to',conditions:'Conditions (AND)',conditionsAndInfo:'Configured conditions are combined with AND. Leave a condition empty to ignore it.',deliveredOnlyInfo:'Only orders in Delivered status count toward progress.',goalGroup:'Goal',orderFiltersGroup:'Order filters',scheduleGroup:'Schedule',catalogGroup:'Products & categories',locations:'Locations',deliveryMethods:'Delivery methods',sources:'Order sources',days:'Days of week',products:'Products',categories:'Categories',leaveEmptyAll:'Leave empty for all',daySun:'Sunday',dayMon:'Monday',dayTue:'Tuesday',dayWed:'Wednesday',dayThu:'Thursday',dayFri:'Friday',daySat:'Saturday',summaryMembership:'User must be a client for at least {days} days (target {target}).',summaryOrders:'Complete {target} orders.',summaryProductQty:'Reach a total quantity of {target} from the selected products/categories.',summaryMinOrder:'Only orders with a minimum value of {amount} {currency}.',summaryLocations:'Only at: {list}.',summaryDelivery:'Only delivery methods: {list}.',summarySources:'Only order sources: {list}.',summaryDays:'Only on: {list}.',summaryOrderTime:'Only between {from} and {to}.',summaryPeriod:'Challenge available from {from} to {to}.',summaryProducts:'Products: {list}.',summaryCategories:'Categories: {list}.',summaryWithinDays:'Progress must be completed within {days} days.',areYouSureDelete:'Are you sure you want to delete',campaignDeleted:'Challenge deleted successfully.',campaignAdded:'Challenge added successfully.',campaignUpdated:'Challenge updated successfully.',removeCurrentImage:'Please remove the current image before adding a new one',dateFrom:'Date from',dateTo:'Date to',reportDateHint:'Completion stats use completion date. In-progress stats use last progress date.',completedUsers:'Completed',inProgressUsers:'In progress',startedUsers:'Started',completionRate:'Completion rate',allUsers:'All',status_COMPLETED:'Completed',status_IN_PROGRESS:'In progress',status_NOT_STARTED:'Not started',user:'User',progress:'Progress',startedAt:'First progress',lastProgressAt:'Last progress',completedAt:'Completed at',userProgress:'User progress',dateTime:'Date / time',orderId:'Order ID',progressGenerated:'Progress'},spinningWheel:{confirmDelete:'Are you sure you want to delete this record?',percentageOverflow:'Active reward probabilities cannot exceed 100%. The change was not saved.',campaignTitle:'Campaign title',description:'Description',availability:'Availability',minOrderValue:'Minimum order value',locations:'Locations',locationsInfo:'Leave empty to apply to all locations.',rewardsCount:'Rewards',percentages:'Winning % total',active:'Active',generalSettings:'General settings',activeRequires100:'Campaign can be activated only when active rewards total exactly 100%.',mustTotal100:'must total 100%',rewards:'Rewards',addReward:'Add reward',editReward:'Edit reward',reward:'Reward',rewardType:'Reward type',winningPercentage:'Winning %',displayTitle:'Display title',displayDescription:'Display description',loyaltyPoints:'Loyalty points',couponType:'Discount type',couponAppliesTo:'Coupon applies to',couponProducts:'Products',couponDelivery:'Delivery',couponTaxes:'Taxes',couponPercentage:'Percentage',couponFixed:'Fixed amount',discount:'Discount',product:'Product',searchProduct:'Search product',sortOrder:'Display order',sortOrderHelp:'This controls the display order on the wheel, not the order of winning. Each prize is selected randomly according to its winning probability.',freeProductCouponHelp:'This free product is the prize won on the spinning wheel. No additional categories or products need to be selected.',actions:'Actions',openCampaign:'Open Campaign',duplicate:'Duplicate',datesRequired:'Availability from and to dates are required.',autoGenerateNotice:'A campaign and coupon will be automatically created for this reward. You can modify the generated campaign and configure notifications later.',typeNothing:'Nothing',typeLoyaltyPoints:'Loyalty points',typeDiscountCoupon:'Discount coupon',typeFreeProduct:'Free product coupon',titleRequired:'Campaign title is required.',percentageRequired:'Winning percentage must be greater than 0.',loyaltyPointsRequired:'Loyalty points are required.',discountRequired:'Discount is required.',productRequired:'Product is required.',spins:'Spins',usersWhoSpun:'Users who spun',rewardsWon:'Rewards won',rewardsRedeemed:'Rewards redeemed',redemptionRate:'Redemption rate',wins:'Wins',usersWhoWon:'Users who won',redeemed:'Redeemed',remaining:'Remaining',users:'Users',user:'User',used:'Used',available:'Available',spinId:'Spin ID',dateWon:'Date won',status:'Status',dateRedeemed:'Date redeemed',qualifyingOrder:'Qualifying order'},discountCampaigns:{single:'discount campaign',plural:'discount campaigns',id:'ID',search:'Search',name:'Name',description:'Description',image:'Image',details:'Discount Campaign Details',startEnd:'Start - End',active:'Active',discount:'Discount',discountType:'Discount type',discountType_flat:'Flat amount',discountType_percent:'Percent',priceProfile:'Price profile',source:'Channel',sourceMethodCombos:'Channels / methods',productStandardPrice:'Product (standard price)',pageInfo:'Page {page} of {total} ({count} products)',topCategory:'Top category',topCategories:'Top categories',categories:'Categories',numberOfUnits:'Units cap',numberOfUnitsPlaceholder:'Leave empty for unlimited',numberOfUnitsHint:'Maximum discounted units. How the limit is shared is controlled by the settings below.',unitsSoldScope:'Unit limit by channel',unitsSoldScope_perLine:'Per line (source + method)',unitsSoldScope_perSource:'Per source (methods share)',unitsSoldScopeHint:'Per line: Eat-in and Takeout each have their own cap. Per source: all methods under the same channel share one cap.',unitsSoldPool:'Unit limit by product',unitsSoldPool_perProduct:'Per product',unitsSoldPool_absolute:'Absolute (all products share)',unitsSoldPoolHint:'Per product: each product has its own cap. Absolute: all products in the campaign share the same cap.',useIntervals:'Limit to time windows',useIntervalsHint:'When off, the campaign is active all day within the date range.',intervalDay:'Day',addInterval:'Add time window',intervalOverlap:'Time windows overlap or one includes another. Use different days/times, or remove the redundant window.',intervalInvalidRange:'Enter valid, different start and end times. An earlier end time means the window ends the following day.',previewTitle:'Affected products',previewCount:'{count} products match',searchProduct:'Search by product name',searchProductId:'Product ID',product:'Product',pricingType:'Pricing',pricingProfile:'Profile',pricingCatalog:'Catalog',method:'Method',originalPrice:'Original price',discountAmount:'Discount',discountedPrice:'Discounted price',cap:'Cap',unitsSold:'Units sold',productsCount:'Products',regenerateWarning:'Product lines will be regenerated. Continue?',areYouSureDelete:'Are you sure you want to delete',campaignDeleted:'Discount campaign deleted successfully.',campaignAdded:'Discount campaign added successfully.',campaignUpdated:'Discount campaign updated successfully.',removeCurrentImage:'Please remove the current image before adding a new one',products:'Products',productsIncluded:'Included products',createCampaign:'Create campaign',campaignButton:'Discount campaign',applyDiscount:'Apply discount',clearSelection:'Clear selection',selectionSummary:'{cells} cells selected · {products} products',selectForCampaign:'Select for campaign',noPriceConfigured:'No price configured',viewEditDiscount:'View / edit discount',discShort:'Disc.',newCampaignModal:'New discount campaign',newCampaignSubtitle:'Price list: {name} · {cells} cells selected',priceProfileLocked:'Locked to current price profile',period:'Period',listPrice:'List price',invalidDiscount:'Invalid discount',discountExceedsPrice:'Discount cannot exceed list price',confirmDeleteLine:'Remove this discount and the product from the campaign?'},donationReport:{campaign:'Campaign',client:'Client',amount:'Amount',date:'Date',totalAmount:'Total Amount',totalDonations:'Total Donations',totalDonors:'Total Donors',campaignOrders:'Orders'},marketingOffers:{single:'offer banner',plural:'offer banners',title:'Title',status:'Status',image:'Image',imageWeb:'Web Image',imageBanner:'Imagine Banner',imageLanding:'Imagine Landing',linkType:'Link Type',startEndDate:'Start - End Date',actions:'Actions',offerAdded:'Offer banner added successfully.',offerUpdated:'Offer banner updated successfully.',offerDeleted:'Offer banner deleted successfully.',weCouldNot:'We could not save the slider photo, please try again later.',validImg:'Please add a valid image.',areYouSure:'Are you sure you want to {label} this offer banner?',pageText:'Page Text',pickCateg:'Pick Category',pickProd:'Pick Product',pickLoc:'Pick Location',groupClients:'Choose the customer group',none:'None',banners:'Banner',offers:'Offers',display:'Display',addGroup:'Add group',offerSuccess:'Group offer succesfully added',categoryBanner:'Categories to be displayed in',dispalyBannerInCategory:'Display banner in category'},marketingOffersTypes:{category:'category',product:'product',page:'page'},marketingFidelities:{fidelities:'Fidelities',loyalityPoint:'Loyality Points',referal:'Referal',userLabeling:'Customer segmentation',name:'Name',ordersValue:'Orders Value',ordersNumber:'Orders number',MOR:'Average Orders Period (MOR)',MORCalcComenzi:'Yearly orders number',MORInfo:'\n        <div class="info" style="font-size: 12px;">\n          <p><b>What do you enter here?</b></p>\n\n          <p>\n            You enter the <b>average number of orders</b> you want a client to place\n            <b>per month</b>, calculated on an annual basis.\n          </p>\n\n          <p><b>System formula:</b></p>\n\n          <p>\n            <i>MOR average = Number of orders per year \xF7 12 months</i>\n          </p>\n\n          <p><b>Practical example (Silver rank):</b></p>\n\n          <p>\n            If you want a client to have <b>6 orders per year</b>,\n            you enter <b>0.5</b> (because 6 \xF7 12 = 0.5).\n          </p>\n        </div>\n      ',color:'Color',notification:'Notification',userNotification:'User Notification',userNotificationPlaceholder:'Congratulations! You reached {level}!',userNotificationInfo:'Notification sent to user when reaches the label',coupon:'Coupon',product:'Free Product',recurrenceInfo:'Free Product/ Coupon applies once every {recurrence}',description:'Description',descriptionPlaceholder:'add free desert to order',descriptionInfo:'Description available only in admin panel',nameLabel:'Label name',addLabel:'Add Label',noData:'No Data',updateUserLabeling:'Updated User Labeling',createdUserLabeling:'Created User Labeling',areYouSureDelete:'Are you sure to delete this label',labelDeleted:'Label Deleted',orderNumberRequired:'This field or order numbers is required',orderValueRequired:'This field or order value is required',yes:'Yes',applyCupon:'Apply coupon',applyproduct:'Apply product',badgeColor:'Badge Color',badgeName:'Badge Name',value:'Value',number:'Number',appliedForLastMonth:'Labels are applied only for orders from last 30 days',checkTermsAndConditionFidelities:'Check fidelities promotions from info pages',labelingPrimaryOption:'Select the primary option for labels',labelingSuccess:'The settings for labels was updated successfully!',updatePrimaryOption:'Update option',showLabelOnUser:'Display labels to users in mobile app',sentUserLabelNotification:'Allow sending user label update notifications',infoAboutShowUserLabelUpdated:'Info about show user label was updated',labelingInterval:'Select applicability interval','0':'Lifetime','30':'30 days','60':'60 days','90':'90 days','120':'120 days','150':'150 days','180':'180 days',recurrence:'Recurrence',noReccurence:'None',oneDay:'1 Day',threeDays:'3 Days',fiveDays:'5 Days',sevenDays:'7 Days',tenDays:'10 Days',fifteenDays:'15 Days',twentyDays:'20 Days',twentyFiveDays:'25 Days',updatePoints:'Update points',availableProducts:'Products must be available in all locations'},marketingPromos:{to_receive:'To receive',multiple:'Can be redeemed multiple times per order',redeemFromNextOrder:'Can be redeemed only from next order',addFreeProductAutomatically:'Add free product automatically to order',allowOnePointPerOrder:'Allow one point per order',expiryInfo:'Set 0 to allow points only for the current order',to_order:'To order',toOrderError:'Please select products that can be ordered',toReceiverError:'Please select products that can redeemed',location:'Location',title:'Title',treshold:'Treshold n',category:'Category',product:'Product',products:'Products',expiry:'Point expiry(days)',none:'None',marketingPromos:'Promo',generateQrCode:'Generate Qr Code',code:'Code',promoDeleted:'Promotion deleted',areYouSureDelete:'Are you sure you want to delete this promotion',promoAdded:'Promo updated',promoUpdated:'Promotion updated successfully.',weCouldNot:'We could not save the  data, please try again later.',startEndDate:'Start - End Date',image:'Image',validImg:'Please add a valid image.',print:'Print',firstname:'First Name',lastname:'Last Name',points:'Points',email:'Email',description:'Description',descriptionPlaceholder:'The description will be displayed in the application',notificationText:'Notification text',notificationTextPlaceholder:'This message will be sent to user when earning enough points for a free product (Leave empty to omit the notification)',send:'Send'},referralProgram:{v2:{ambassador_1:'Ambassador 1',ambassador_2:'Ambassador',referee:'Referee',none:'No reward',coupon:'Coupon',rewardKind:'Reward option',selectCoupon:'Select coupon',campaignDefault:'Campaign default',legacyCombined:'Existing fixed amount + percentage',unavailableCoupon:'Unavailable coupon (#{id})',loadingCoupons:'Loading coupons…',noCoupons:'No active coupons available.',couponsLoadFailed:'Could not load coupons.',retry:'Retry',couponRequired:'Select a coupon.',couponUnavailable:'Select an available coupon.',percentInvalid:'Enter a percentage between 0 and 100.',amountInvalid:'Enter a non-negative reward amount.',maxOrdersInvalid:'Enter a positive whole number or leave empty for unlimited orders.',visibleInApp:'Show in application',hierarchyTitle:'Ambassador referrals',hierarchy:'Ambassador → Affiliate',purchaseFlow:'Affiliate orders reward the affiliate and their direct ambassador. Ambassador orders do not generate referral rewards.',cashbackTitle:'Rewards on every order',cashbackHelp:'These rewards continue after the first-order limit is reached. Configure each recipient independently.',order_reward:'First-order reward',cashback:'Every-order reward',couponsAwarded:'Coupons awarded'},generalSettings:'General settings',campaignName:'Campaign name',active:'Active',availableBetween:'Availability (dates)',optionalAvailability:'Optional — leave empty for no date limits.',tableAvailability:'Availability',orderRewardsSection:'Rewards on first orders',orderRewardsActive:'Order rewards enabled',refereeRewardFlat:'Referee reward',ambassadorOrderRewardFlat:'Ambassador reward',maxOrdersForOrderRewards:'Max counted orders',unlimitedPlaceholder:'Leave empty for unlimited',cashbackSection:'Ambassador cashback from referee orders',cashbackFlatOrPercent:'Choose whether cashback is a percent of the order total or a fixed amount per order.',ambassadorCashbackActive:'Cashback enabled',cashbackAmountType:'Cashback type',cashbackTypePercent:'Percent (%)',cashbackTypeFlat:'Fixed amount',cashbackPercentValue:'Percent of order total (%)',cashbackFlatValue:'Fixed amount per order',cashbackHintPercent:'Percentage of the referee order total paid to the ambassador.',cashbackHintFlat:'Fixed monetary amount per delivered order for the ambassador.',nameRequired:'Please enter a campaign name.',cashbackPercentRequired:'Enter a cashback percentage when cashback is enabled.',cashbackFlatRequired:'Enter a fixed cashback amount when cashback is enabled.',notificationEmailsTitle:'Referral notification emails',notificationEmailsHelp:'Addresses that receive new ambassador-request notifications (comma or newline separated).',notificationEmailsPlaceholder:'team@company.com',orderRewards:'Order rewards',cashback:'Cashback',requestStatus:'Status',desiredCode:'Desired code',createdAt:'Requested at',approveRequest:'Approve ambassador',selectCampaign:'Referral campaign',selectCampaignRequired:'Please select a referral campaign.',rewardSummaryDisabled:'Disabled',approvedCodeOptional:'Approved referral code (optional)',denyReason:'Denial reason (optional)',ambassadorId:'Ambassador',refereesCount:'Referees',totalRewards:'Total rewards',totalCashbackPercent:'Cashback total',refereeId:'Referee',refereeTotals:'Referee orders total',ambassadorEarnings:'Ambassador earnings',refereeReward:'Referee reward',ambassadorOrderReward:'Ambassador order reward',ambassadorCashback:'Ambassador cashback',rewardType:'Reward type',rewardTypeLoyaltyPoints:'Loyalty points',rewardTypeWallet:'Wallet credit',loyaltyPointsModuleRequired:'To choose loyalty points as reward, you need to set up the loyalty points module first.',loyaltyPointsModuleLink:'Go to loyalty points settings',orderRewardsSummaryIncomplete:'Configure referee and/or ambassador fixed rewards.',cashbackSummaryIncomplete:'Configure the cashback amount to see a summary.',cannotDeleteHasEnrolledUsers:'This campaign cannot be deleted because users are already enrolled. Deactivate it instead to stop new enrollments.',deactivateCampaign:'Deactivate campaign',filterByCampaign:'By campaign',filterByAmbassador:'By ambassador'},reports:{labelEvolution:'Label Evolution',items:'Items',wallet_id:'ID',wallet_firstname:'Firstname',wallet_lastname:'Lastname',wallet_email:'Email',wallet_phone:'Phone',wallet_loyalty_points:'Loyalty Points',wallet_donation_points:'Donation Points',wallet_value:'Wallet',wallet_driver_wallet:'Driver Wallet',salesPaymentMethod:'Sales Report',paymentTypes:'Payment Types',giftCardsSoldTotal:'Total gift cards sold',giftCardsSoldAmount:'Gift cards sold',orderedProducts:'Ordered Products',number:'Order nr',trends:'Performance',clients:'Clients',products:'Products',marketing:'Marketing',today:'Today',orderChart:'Orders',clientsChart:'Clients',completed:'Completed',canceled:'Canceled',salesChart:'Sales',salesIn:'Sales in',customersChart:'Customers',appInstalls:'App Installs',custWithAcc:'Customers with account',top10Chart:'Top 10 products',top5Chart:'Top 5 products',orderingChart:'Ordering types',nrOfOrders:'Number of orders',periodExceeds6Months:'Please select a period smaller than 6 months',timerApp:'Timer app',customersAge:'Customers Age',customersGender:'Customers Gender',name:'Name',appInstalled:'App Installed',gender:'Gender',location:'Location',partnerCode:'Partner code',email:'Email',phone:'Phone',age:'Age',donation_points:'Puncte donatie',filter:'Filter',label:'Label',userDetails:'Customer Details',salesDetails:'Sales Details',salesProductNr:'Product sales number',totalAmount:'Total Amount',totalProducts:'Total Products',ordersNumber:'Orders',minAmount:'Minimum Total Amount',minOrders:'Minimum Orders',maxOrders:'Maximum Orders',itemsSold:'Items Sold',campaign:'Campaign',couponsTimesUsed:'Coupons Times Used',revenue:'Sales',total:'Total',paymentType:'Payment type',date:'Date',closingOrder:'Closing Order',dateColumnCreate:'Create',dateColumnClose:'Close',dateColumnFiscalize:'Fiscalize',salesReport:'Sales Report',salesReportBeta:'Sales Report BETA',accountingReport:'Accounting Report',order:'Order',export:'Export',cash:'Cash',card:'Online (App)',cardPayment:'Card',pos:'Delivery POS',cardPos:'Bank POS',splitCardPos:'Split Card',splitCash:'Split Cash',virament:'Bank Transfer',online:'Online',protocol:'Protocol',staffFood:'Staff Food',room:'Room Transfer',event:'Event Transfer',folio:'Folio Transfer',tips:'Tips',splitVoucher:'Split Voucher',unpaid:'Unpaid',orderPaidStatus:'Paid status',boltCard:'Bolt Card',boltCash:'Bolt Cash',glovoCard:'Glovo Card',glovoCash:'Glovo Cash',woltCard:'Wolt Card',woltCash:'Wolt Cash',woltOtherMethods:'Wolt Other Methods',totalPayFromWallet:'Total Wallet Pay',totalSum:'Total Amount',totalSales:'Total Sales',totalCash:'Total Cash',totalOnline:'Total Online',totalCard:'Total Card',totalCredit:'Total Credit',totalNonFiscal:'Total Non-Fiscal',unfiscalTotal:'Total Unfiscalized',unfiscalCash:'Unfiscalized Cash',unfiscalOnline:'Unfiscalized Online',unfiscalCard:'Unfiscalized Card',unfiscalCredit:'Unfiscalized Credit',search:'Search',searchFilter:'Search(name, email, phone)',noRawData:'No data available',rawDataTvaA:'TVA A',rawDataTvaB:'TVA B',rawDataTvaC:'TVA C',rawDataTvaD:'TVA D',rawDataTvaE:'TVA E',rawDataTvaS:'SCUTIT TVA S',rawDataAlteTaxe:'ALTE TAXE #',rawDataNrAnulariNefiscale:'NR. ANULARI NEFISCALE',rawDataValAnulariNefiscale:'VAL. ANULARI NEFISCALE',rawDataNumerarInSertar:'NUMERAR IN SERTAR LEI',rawDataNumerar:'NUMERAR',rawDataCard:'CARD',rawDataCredit:'CREDIT',rawDataTicheteMasa:'TICHETE MASA',rawDataTicheteValorice:'TICHETE VALORICE',rawDataVoucher:'VOUCHER',rawDataPlataModerna:'PLATA MODERNA',rawDataAvansInNumerar:'AVANS IN NUMERAR',rawDataAlteMetode:'ALTE METODE',rawDataValTotalVanzA:'VAL. TOTAL VANZ - A',rawDataValTotalVanzB:'VAL. TOTAL VANZ - B',rawDataValTotalVanzC:'VAL. TOTAL VANZ - C',rawDataValTotalVanzD:'VAL. TOTAL VANZ - D',rawDataValTotalVanzE:'VAL. TOTAL VANZ - E',rawDataValTotalAlteTaxe:'VAL. TOTAL ALTE TAXE #',rawDataValTotalScutitTvaS:'VAL. TOTAL SCUTIT DE TVA - S',rawDataValTotalVanzari:'VAL. TOTAL VANZARI',rawDataTotalTvaA:'TOTAL TVA A 21%',rawDataTotalTvaB:'TOTAL TVA B 11%',rawDataTotalTvaC:'TOTAL TVA C 0%',rawDataTotalTvaD:'TOTAL TVA D 0%',rawDataTotalTvaE:'TOTAL TVA E 0%',rawDataTotalTva:'TOTAL TVA',rawDataClientiCodFiscalTotalTva:'CLIENTI COD FISCAL - TOTAL TVA',rawDataClientiCodFiscalTotalSumar:'CLIENTI COD FISCAL - TOTAL SUMAR',rawDataNrBonuriClientiCodFiscal:'NR. BONURI CLIENTI COD FISCAL',rawDataNumarBonuriFiscale:'NUMAR BONURI FISCALE',rawDataNumarBonuriNefiscale:'NUMAR BONURI NEFISCALE',rawDataNrDmje01:'NR. DMJE 01',rawDataDmjeCapacitate:'DMJE CAPACITATE',rawDataSpatiuLiberDmje:'SPATIU LIBER DMJE',rawDataSpatiuOcupat:'SPATIU OCUPAT',rawDataNrAmef:'NR.AMEF',rawDataTd:'TD',rawDataData:'DATA',rawDataOra:'ORA',rawDataSN:'S/N',rawDataLogo:'{LOGO}',rawDataSha256:'SHA-256 PENTRU Z',discount:'Discount',tax:'Tax',shipping:'Shipping',delivery_type:'Delivery method',zone:'Zone',totalDiscount:'Total Discount',ordersWithDiscount:'Orders with Discount',ordersWithFidelity:'Orders with Fidelity',totalFidelityDiscount:'Total Fidelity Discount',newCustomers:'New Customers',totalTax:'Total Taxes',slotTax:'Slot Fee',slotPartTax:'Slot Part Fee',avarageOrderValue:'Avarage Order Value',clientsWOrders:'Clients with orders',emailSend:'Emails sent in last 6 months',emailTotal:'Total emails sent: ',newCustomersChart:'New Customers',productsSalesReport:'Product sales report',productsSalesReport2:'Product sales',productSaleTrendsReport:'Product sale Trends',salesTrendsReport:'Sales Trends',topProductsReport:'Top Products',topCategoriesReport:'Top Categories',orderFromReport:'Vertical Sales',productsAndOptionsReport:'Products and Options Report',options:'Options',netValue:'Net Value',stornoReport:'User Storno',operatorSalesReport:'Operator Protocol Sales',waiterTipsReport:'Waiter Tips',waiterTipsUserName:'User name',waiterTipsValue:'Value',waiterTipsZRange:'Z range',waiterTipsMode:'Mode',waiterTipsModeWaiter:'Waiters',waiterTipsModeDelivery:'Delivery',waiterTipsSelectWaiters:'Waiters',waiterTipsSelectDrivers:'Drivers',masterReport:'Master Report',masterReportBeta:'Master Report (Beta)',fiscalZReport:'Fiscal Z Report',withoutOptions:'without options, without sgr',customerLifetimeValueReport:'Customer Lifetime Value',referralProgramReport:'Referral program',raffleCampaignsReport:'Raffle Campaigns Report',pricePerUnit:'Price per unit',quantity:'Quantity',average:'Average',productName:'Product Name',orderStatus:'Order status report',pdfRaport:'Order report for delivery',couponCode:'Coupon',checkOrder:'Use order',loyaltyPoints:'Loyalty Points',donationReport:'Donation Report',donationCampaignsReport:'Donation Campaigns Report',loyaltyStoreReport:'Loyalty Store',challengeCampaignsReport:'Challenges Report',spinningWheelReport:'Spinning Wheel Report',ocr:'Ocr',stockMovements:'Product Stock Movements',reorderPopupResponses:'Reorder Popup Responses',dateTime:'Date & Time',reorderResponse:'Response',reorderResponseYes:'Yes',reorderResponseNo:'No',dateInterval:'Date interval',allLocations:'All locations',stockMovementType:'Movement Type',stockMovementUserRole:'User Role',stockMovementOrderPlaced:'Order placed',stockMovementManualAdjustment:'Manual adjustment',wallet:'Wallet',clientLoyalty:'Clinet points report',requestReport:'Request Report',requestSuccess:'Request Sent',requestInfo:'The report would be available for download tomorrow',requestConfirm:'I understand',reportRequestTab:'Report Requests',charismaReport:'Report Charisma',charismaLocationReceipt:'Report Z Charisma',nexusReport:'Report Nexus',nexusItems:'Order Log',nexusOrderLogs:'Nexus Order Logs',sendReceipts:'Send Receipts',dashboardReport:'Dashboard Report',reportTypePlaceholder:'Report',pointsReport:'Points Report',fromUppercase:'From',toUppercase:'To',availableUntil:'Available until',pdfRaportDeliveryOrders:'Delivery Orders',statusReport:'Processing Orders Time',taxation:'Taxation',withReceipt:'Taxed',withoutReceipt:'Untaxed',receiptNumber:'Receipt No',zet:'Zet',noDataAvailable:'No data available',topCategory:'Top Category',orderId:'Order ID',posId:'Pos ID',productId:'Product ID',itemPosId:'Pos ID Item',menuItemPosId:'Pos ID Menu Item',orderCreatedAt:'Order Opening Time',orderNumber:'Order Number',tableNumber:'Table Number',orderItemCreatedAt:'Product Opening Time',orderItemMarkingTime:'Product Marking Time',category:'Category',product:'Product',operation:'Operation',operator:'Operator',section:'Section',fullPrice:'Gross Price',grossPrice:'Gross Price per Product',orderItemDiscount:'Product Discount',orderDiscount:'Order Discount',orderLoyaltyDiscount:'Order Loyalty Discount',orderItemValueCollected:'Collected Amount',vatAmount:'VAT Amount',orderItemNetPrice:'Net Price',paymentMethod:'Payment Method',fiscalization:'Fiscalization',roomNumber:'Room Number',folioId:'Folio ID',interval:'Interval',split:'Split',orderComments:'Order comments',productComments:'Product comments',tableOpenOrders:'Table Open Orders',orderSeriesNumber:'Series / order no.',posDeviceName:'POS',waiterName:'Waiter',orderTransfersCount:'Transfers',orderStornosCount:'Storno',posOrderActionTypes:{openOrder:'Open order',markProduct:'Mark product',preNote:'Pre note',closeOrder:'Close order',storno:'Storno',transferOut:'Transfer OUT',transferIn:'Transfer IN'},posOrderActionMarkProduct:'Mark "{name}"',posOrderActionMarkProductGeneric:'Mark product',orderProductsCount:'Order products count',transferTable:'Transfer table',initialItems:'Initial items',transferredTag:'Transferred',transferOut:'Transferred items',remainingItems:'Remaining items',itemsReceived:'Items received',posOrderActionsReport:'POS Order Actions Report',zNumber:'Z Number',deviceName:'Device Name',zTimestamp:'Z Timestamp',credit:'Credit',mealTickets:'Meal Tickets',valueTickets:'Value Tickets',voucher:'Voucher',modernPayment:'Modern Payment',advanceInCash:'Advance in Cash',otherMethods:'Other Methods',cashInDrawer:'Cash in Drawer',nrFiscalReceipts:'Nr. Fiscal Receipts',nrNonFiscalReceipts:'Nr. Non-Fiscal Receipts',fiscalReceiptsAmount:'Fiscal receipts amount',nonFiscalReceiptsAmount:'Non-fiscal receipts amount',paymentMethodsStandard:'Standard payment methods',paymentMethodsOther:'Other payment methods',paymentMethodsIntegration:'Integration payment methods',totalSalesA:'Total Sales A',totalSalesB:'Total Sales B',totalSalesC:'Total Sales C',totalSalesD:'Total Sales D',totalSalesE:'Total Sales E',totalVat:'Total VAT',totalVatA:'Total VAT A',totalVatB:'Total VAT B',totalVatC:'Total VAT C',totalVatD:'Total VAT D',totalVatE:'Total VAT E',totalOtherTaxes:'Total Other Taxes',totalVatExempt:'Total VAT Exempt',nrFiscalCodeClientReceipts:'Nr. Fiscal Code Client Receipts',fiscalCodeClientsTotalSum:'Fiscal Code Clients Total Sum',fiscalCodeClientsTotalVat:'Fiscal Code Clients Total VAT',productCount:'Product Counter',lastSearch:'Last search',duration:'Order duration',tables:'Tables',quantityUnit:'Quantity Unit',singleUnit:'Unit',clientId:'Client ID',clientName:'Client Name',registrationDate:'Registration Date',firstOrderDate:'First Order Date',lastOrderDate:'Last Order Date',monthlyOrderCount:'Total Order Count',monthlyOrderValueTotal:'Monthly Order Value (Total)',averageOrderValue:'Average Order Value',monthlyOrderAverage:'Monthly frequency',isNewClient:'New Client',isInactiveClient:'Inactive Client',daysSinceLastOrder:'Days Since Last Order',acquisitionChannel:'Acquisition Channel',estimatedCLV:'CLV 12 Months',churnRate:'Churn Rate',option:'Option',item:'Product',type:'Type',searchProducts:'Search',orderCounter:'Orders Count',preordersItems:'Preorders Items',itemName:'Item Name',saleWeek:'Week',filteredData:'The data displayed is from period:',source:'Source',withStorno:'Storno',withoutStorno:'Without Storno',orderTotal:'Order Total',old:'Old',custom:'Custom',salesProtocol:'Total Sales Protocol',salesStaff:'Total Sales Staff',countProtocol:'Orders Staff',countStaff:'Orders Staff',salesProtocolStaff:'Total Sales Protocol + Staff',countProtocolStaff:'Orders Protocol + Personal',salesReportSearch:'Search by Product, Category, Waiter',id:'ID',sold:'Sold',eatIn:'Eat In',takeOut:'Take Out',other:'Other',waste:'Waste',employee:'Employee',refund:'Refund',usage:'Usage',unitQty:'Unit Qty',unitPrice:'Unit Price',sales:'Sales',netSales:'Net Sales',grandTotal:'Grand Total',mixReport:'Mix Report',noData:'No Data',uncategorized:'Uncategorized'},orderFrom:{unknown:'Unknown',kiosk:'Kiosk',qr:'QR',pos:'POS',app:'Application',website:'Website',glovo:'Glovo',wolt:'Wolt',bolt:'Bolt',POS:'POS',application:'Application',online:'Website',table:'Table',tazz:'Tazz',phone:'Phone',inlocation:'Reservation'},feedback:{sigle:'feedback',type:'Type',sentBy:'Sent By',text:'Text',seen:'Seen',sentAt:'Sent At',search:'Search',comment:'Comment',response:'Response',send:'The answer will be sent to the user by notification and email at the time of saving'},orderScreen:{typeKitchen:'Kitchen',typeClient:'Client',selectLocation:'Select a location in order to select the Client mode',excludeSections:'Exclude sections',includeTableOrders:'Include table orders',posIds:'POS',odsBackgroundColor:'Background color',odsTextColor:'Text color',odsStatus1Color:'Processing orders color',odsStatus2Color:'Preparing orders color',odsStatus3Color:'Prepared colors color',odsColumn1Text:'Text header 1',odsColumn2Text:'Text header 2',odsOffline:'ODS offline',ipServer:'Server IP',odsCode:'ODS code',connectivity:'Connectivity',offline:'Offline',online:'Online'},feedbackTypes:{feedback:'Feedback',issue:'Issue',suggestion:'Suggestion'},settings:{},blogPage:{categories:'Categories',categoriesHint:'Optional — articles can also have no category.',categoryName:'Category name',noCategories:'No categories yet.',articles:'Articles',addArticle:'Add article',editArticle:'Edit article',allCategories:'All categories',noCategory:'No category',allStatuses:'All statuses',searchByTitle:'Search by title',noArticles:'No articles found.',cover:'Cover',coverHint:'recommended 1200x630px, max 5MB',imageAlt:'Image alt text (SEO)',title:'Title',slug:'Article link (slug)',slugHint:'Generated from the title if left empty.',shortDescription:'Short description (under the title)',content:'Content',category:'Category',author:'Author',publishedAt:'Publish date',publishedAtHint:'If empty, the current date is used when publishing.',status:'Status',published:'Published',draft:'Draft',scheduled:'Scheduled',seo:'SEO',metaTitle:'Meta title',metaDescription:'Meta description',metaKeywords:'Keywords (comma separated)',titleRequired:'The title is required.',deleteCategoryConfirm:'Delete category "{name}"? {count} article(s) will remain without a category.',deleteArticleConfirm:'Delete article "{name}"?'},settingsPages:{homepageSections:'Homepage Sections',interactiveTour:'Interactive Tour',blog:'Blog',interactiveTourFirstLogin:'Use interactive tour on first login',interactiveTourAlways:'Use interactive tour always',interactiveTourDisplayMode:'Image display mode',interactiveTourDisplayContain:'Contain',interactiveTourDisplayCover:'Cover',interactiveTourDisplayFullPage:'Full page',searchNameEmail:'Search by Name or Email',ordersFilter:'With Orders / Without Orders',userSettings:'User Settings',generalSettings:'General Settings',moduleManager:'Module Manager',locationSettings:'Location Settings',myProfile:'My Profile',users:'Users',general:'General',companyDetails:'Company Details',printers:'Printers',fiscalPrinter:'Fiscal Printer',tableManager:'Table Manager',tableZones:'Zone Manager',measurementsUnits:'Measurements Manager',kdsSections:'Sections',paymentGroups:'Payment Groups',companyLocations:'Locations',dateTime:'Date & Time',currency:'Currency',accounting:'Accounting',tax:'Tax',payment:'Payment',orderingMng:'Ordering Management',loyalty:'Loyalty Program',push:'Push Notifications',tips:'Tips',kioskModule:'Kiosk',qrModule:'Qr',app:'Aplication',locationGroups:'Location groups',locationGroupsName:'Name',locationGroupsDescription:'Description',locationGroupsPhoto:'Photo',locationGroupsAdded:'New location groups added successfully',locationGroupsUpdated:'Location groups updated successfully',locationGroupsPicError:'We could not save the location groups photo, please try again later.',locationGroupsDelete:'Delete Location Group',locationGroupsAreYouSure:'Are you sure you want to delete this location group?',locationGroupsSelect:'Select the location group to which it belongs:',subscription:'Subscription',myPlan:'My Plan',infoPages:'Info Pages',taxLabeling:'Tax Labelling',deliveryMethods:'Delivery methods',filters:'Filters',filterProducts:'Filters Products',companyWeb:'Company website',services:'Services',scanner:'Client Scanner',settings:'Settings',integrations:'Integrations'},permission:{general_can_access_dashboard:'Allow access to Dashboard',general_can_access_clients:'Allow access to Clients',general_can_access_orders:'Allow access to Orders',general_can_access_tables:'Allow access to Tables',general_can_access_reservations:'Allow access to Reservations',general_can_access_add_order:'Allow access to Add Order',general_can_access_dispatch:'Allow access to Dispatch',general_can_access_kds:'Allow access to KDS',general_can_access_screens:'Allow access to Screens',general_can_access_pos:'Allow access to POS',general_can_access_inventory:'Allow access to Inventory',general_can_access_catalog:'Allow access to Catalog',general_can_access_marketing:'Allow access to Marketing',general_can_access_scan:'Allow access to Scan',general_can_access_reports:'Allow access to Reports',general_can_access_feedback:'Allow access to Feedback',general_can_access_setings:'Allow access to Settings',general_can_access_pay:'Allow access to Payments',general_can_access_suport:'Allow access to Support',general_can_access_price_lists:'Allow viewing price lists',can_access_supplier_orders:'Inventory - Access to Supplier Orders',can_create_supplier_order:'Inventory - Create Supplier Orders',can_send_supplier_order:'Inventory - Send Supplier Orders',can_receive_supplier_order:'Inventory - Receive Supplier Orders',can_validate_supplier_order:'Inventory - Validate Supplier Orders',can_generate_nir:'Inventory - Generate NIR',can_process_supplier_order:'Inventory - Process Supplier Orders',can_generate_aviz:'Inventory - Can Generate Delivery Note',can_generate_invoice:'Inventory - Can Generate Invoices',can_access_dashboard:'Inventory - Access to Dashboard',can_access_gestiune:'Inventory - Access to Inventory',can_access_reports:'Inventory - Access to Reports',can_access_settings:'Inventory - Access to Settings'},settingUsers:{permissions:'Permissions:',permissionsGestiune:'Permissions Management',permissionsGeneral:'Generale Permissions',single:'user',fn:'First Name',ln:'Last Name',email:'Email',phone:'Phone',active:'Active Schedule',scheduleStatus:'The schedule is:',scheduleActive:'active',scheduleInactive:'inactive',username:'Username',program:'Choose schedule',lang:'Interface language',langMsg:'This is the language in which you will see the Inventory area.',avatar:'Avatar',role:'Role',locations:'Access Orders from Locations',locations_helptext:'Important: If no location is selected this user will have access to all locations.',resetPass:'Reset Password',password:'Password',pass:'Password',confPass:'Confirm Password',userAdded:'New user added successfully',userUpdated:'User updated successfully',userPicError:'We could not save the user avatar, please try again later.',USER:'USER',OWNER:'OWNER',DRIVER:'DRIVER',LOCATION_ADMIN:'LOCATION ADMIN',LOCATION_STORE_ADMIN:'LOCATION STORE ADMIN',MARKETER:'MARKETER',OPERATOR:'OPERATOR',KDS_OPERATOR:'KDS OPERATOR',USER_CUSTOM:'Custom User',DISPATCHER:'DISPATCHER'},settingTable:{'use_tips':'Use Tips','yumm_integration_external_ip':'Yumm integration external ip',onlineQrTitle:'Online ordering QR',onlineQrDesc:'QR code that opens online ordering for this table.',onlineQrEmpty:'No online QR generated yet.',onlineQrGenerate:'Generate QR',onlineQrRegenerate:'Regenerate QR',onlineQrCopy:'Copy link','all':'All','activ':'Active','inactiv':'Inactive','as_useer':'As User','series':'Order Series','start_number':'Start nr order','allow_maps':'Table Maps','use_table_maps':'Use table maps',disable_eat_in:'Disable Eat In',disable_delivery:'Disable Delivery',disable_pick_up:'Disable Pick Up',disable_drive_in:'Disable Drive In',allDeliveryMethodsDisabled:'At least one delivery method must remain enabled (Eat In, Delivery, Pick Up or Drive In).',default_method:'Default Method',default_sort_checkout_buttons:'Sort the first 4 buttons in checkout',disable_tips:'Disable Tips',disable_ballance:'Disable Balance',auto_print_receipt:'Print the receipt automatically',auto_print_receipt_on_metods:'Print the receipt automatically for metods',auto_print_receipt_on_status:'Print the receipt automatically for statuses',allowClosingOrdersWithoutReceipt:'Allow closing orders without a fiscal receipt','allow_close_order_without_receipt':'Allow closing orders without a fiscal receipt','allow_closing_orders_without_driver':'Allow closing orders without a driver','comment_for_virament':'Comment for virament','stop_print_section':'Stop print serction','close_order':'Close Orders with status delivered all the time','set_logged_user_in_reports':'Filter reports by logged user','disable_seats':'Disable the popup with the number of seats at the table','disable_pager':'Disable the pager number popup','block_z_until_all_orders_fiscalized':'Block Z until all orders are fiscalized','allowed_fiscal_payment_methods':'Allowed fiscal payment methods','allow_fiscal':'Allow fiscal','allow_change_payment_type_on_fiscalization':'Allow changing payment type on fiscalization','use_block_actions_after_print':'Block actions after print','auto_print_fiscal_on_status':'Select the statuses for which you want self-taxation','auto_print_fiscal_on_source':'Select the sources for which you want self-taxation','auto_print_fiscal_on_payment_methods':'Select the payment methods for automatic fiscalization',disable_required_options:'Disable Option Validation','is_manager':'Is Manager','table_for_one_user':'Table is assigned to the first user','pos_allow_order_change_status':'Allows status changes on orders','pos_allow_reports':'Allow filter reports','pos_allow_approvals':'Allow approving actions','pos_allow_advanced_settings':'Allow advanced settings','pos_allow_advanced_settings_info':'example: deleting orders older than 2 days','pos_allow_access_reports':'Allow access reports','bank_terminal':'Bank terminal','has_bank_terminal':'Bank terminal is connected (FiscalNet)','has_integrated_bank_terminal':'Integrated bank terminal is connected','sound_new_order':'Play sound for new orders','sound_notification':'Play sound for notifications','sync_products_from_all_locations':'Sync products from all locations','sync_location_ids':'Locations to sync','is_dispatch':'Dispatch mode','menu_orientation':'Menu orientation','vertical':'Vertical','horizontal':'Horizontal','allow_tables_access_only_if_assigned':'Table cannot be used without an assigned user','use_fiscal_net_at_modern_payment':'Use FiscalNet at Modern Payment','allow_bank_transfer':'Allow payment via Bank Transfer','pos_allow_transfer':'Allow Transfer','pos_allow_waiter_transfer':'Allow waiter transfer','pos_allow_table_transfer':'Allow table transfer','pos_allow_staff_food':'Allow payment Staff Food','allow_some_top_categories':'Allow just some top categories for this user','allow_some_top_categories_map':'Allow just some top categories for this map','staff_food_daily_budget':'Staff food daily budget','pos_allow_discount':'Allow Discount','pos_allow_storno':'Allow Storno','pos_allow_refund':'Allow Refund','allow_access_all_tables':'Allow access to all tables','allow_change_driver':'Allow change driver','allow_print_note':'Allow payment notes','not_allowed_order_statuses':'Not allowed order statuses','pos_allow_mobile_pos':'Allow Mobil Pos','pos_allow_plata_moderna':'Allow Modern Payment','pos_allow_protocol':'Allow Protocol','pos_allow_glovo':'Allow Glovo','pos_allow_bolt':'Allow Bolt','pos_allow_wolt':'Allow Wolt','pos_allow_tips':'Allow Tips','pos_disable_cancel_order':'Disable Cancel Order','pos_filter_status_orders':'Choose the statuses you want to be selected by default for orders','email':'Email','lastname':'Lastname','firstname':'Firstname','login_code':'Login Code (unique 4 digits)','login_code_already_used':'This login code is already in use.','lock_screen_timeout_min':'Screen lock timeout (minutes)','round':'Round','squere':'Squere','table_shape':'Shape','deleteZoneTitle':'Are you sure?','deleteZoneTxt':'This action will delete all tables and kiosks belonging to this area along with their availability settings!','app_available':'Available for booking','min_pers':'Minimum number of people','max_pers':'Maximum number of people','with_open_order':'Open Order','with_split_pay':'Pay separately','tableSave':'Save successfully','short_spv':'SPV value','short':'Shortening','name':'Name','number':'Identifier','kioskName':'Kiosk name','offlineLoginCode':'Login code:','location':'Location','type':'Type','zone':'Zone','maps':'Table Maps','loginCode':'Login Code:','printOrder':'Print order','posSet':'Pos Settings','fiscalSet':'Fiscal Settings','use_pager':'With Pager','use_methods':'Activate kiosk methods (Pickup, eat in)','kiosk_offline':'Offline kiosk','kioskVideo':'Kiosk video (plays on the start screen)','kioskVideoHint':'MP4 or WEBM, max 50MB. Save the kiosk after the upload.','kioskVideoTooBig':'The video must be at most 50MB','kioskVideoUploaded':'Video uploaded. Save the kiosk to apply it.','kioskVideoRemove':'Remove','kioskVideoHintAuto':'MP4 or WEBM, max 50MB. The video is saved on the kiosk automatically after the upload.','kioskVideoSaved':'Video uploaded and saved on the kiosk.','kioskVideoRemoved':'Video deleted.','qr_offline':'Offline QR','qrSettings':'QR settings','qrGeneralSettings':'General details','qrConnectionSettings':'Offline connection','qrServiceSettings':'Service settings','qrCapacitySettings':'Capacity and availability','qrNumberingSettings':'Document numbering','qrPaymentMethods':'QR payment methods','qrPaymentMobilePos':'Mobile POS','qrPaymentCard':'Card','qrPaymentBankTerminal':'Bank terminal','qrPaymentDirectConnection':'Direct connection','qrPaymentMode_online':'Online QR','qrPaymentMode_offline':'Offline QR','qrPaymentType_CASH':'Cash','qrPaymentType_POS':'Mobile POS — without terminal trigger','qrPaymentType_CARD_POS':'Mobile POS — trigger terminal','qrServiceCode':'Service-mode code','reloadAllKiosks':'Reload all kiosks','reload':'Reload','reloadPending':'Reload pending','kiosksWillReloadNextOrder':'The kiosks will reload at the next order!','use_cash_machine':'With Cash Machine','disable_cash_payment':'Disable cash payment','kiosk_is_using_fiscal_receipt_for_sections':'Kiosk is using fiscal receipt for sections','without_OrderFormFlags':'Without','use_fiscal_net':'With FiscalNet','use_fiscal_net_with_pos':'Pos with FiscalNet','printerSet':'Printer Settings','server_ip':'Server IP','server_port':'Server Port','terminal_port':'Terminal Port','ip':'Ip','port':'Port','host':'Host','p1':'Adr1','p2':'Adr2','kioskUrl':'Download Kiosk Installer','disableAuth':'Disable POS','disableAuthInfo':'The POS will be disabled untill performing a new setup','disableAuthScreen':'Disable Screen','disableAuthScreenInfo':'The screen will be disabled untill performing a new setup','printerIp':'Printer IP and Port','printerIpExample':'ex. 127.0.0.1:8080','serverIp':'Server Ip','serverIpExample':'eg. 192.168.1.100','waiters':'Waiers','dispalyProductsImage':'Display products image','assignWaiter':'Assign waiters','allowPosUseCoupons':'Verify active coupons in real time','posSetClientOnOrder':'Always ask for client details','pos_confirm_order_close_on_method_select':'Confirm order closure and fiscalization when selecting payment method','posDisplayAllProductOptions':'Display all product options at once','forceCreditForIntegrationCashOrders':'Force "Credit" for integration orders paid in "Cash"','posUseYummVoucher':'Use YUMM voucher','posUseStock':'Use stock on POS','posAskStornoBackInStock':'Ask to put products back in stock on storno','pos_keep_first_waiter_id_order_split':'Keep first waiter ID on order split','posDisplayTipsOnOrder':'Display tips on order','posDefaultCourseCount':'Number of courses','searchTable':'Search table by name',externalId:'External ID',externalIdPlaceholder:'External reference (e.g. POS or integration)',group_tables_users:'Tables & users',group_order_types:'Order types',group_closing_orders:'Closing orders',group_payments:'Payments & terminals',group_fiscal_printing:'Fiscal & printing',group_display:'Display & interface',group_reports:'Reports',fiscalPrinter:'Fiscal printer',cantar:'Scale'},referalSettings:{'inactive_loyalty':'Please activate loyalty points','points_handle':'How points should be added','only_referal':'Only referal points','only_fidelity':'Only fidelity points','both_points':'Both points are added','higher_point':'Only higher points are added','initial_parent_percentage':'Parent initial order value percentage points','initial_order_percentage':'percent ar first order','initial_child_percentage':'Child initial order value percentage points','order_count':'How many orders after first points can be received','order_count_info':'How many other orders beside first we will give them points, if blank, no limit','order_values':'Values after initial order','parent_order_percentage':'Parent order value percentage points','parent_order_percentage_info':'Beside first order what percentage of order value will added as points','child_order_percentage':'Child order value percentage points','parent_receive_points':'Rewards for the person who is recommended'},addOrder:{toGo:'To Go',commentTitle:'Add comment',choosePay:'Choose payment method','areYouSureDelete':'Are you sure you want to delete?','adressDeleted':'Deleted successfully','titleClient':'Customer','titleMethod':'Delivery method','titleLocation':'Location','titleAdress':'Delivery address','titleStatus':'Status','done':'Done','datepicker':'Pick a date','hourpicker':'Pick a hour','how_many':'For how many people the reservation is made','tags':'Order from','fromTable':'For: ','titlePopupTip':'Add Value','btnPopup':'Add','titlePopupPriceModify':'Edit product price','titlePopupCoupon':'Add coupon','errorPopupCoupon':'Wrong coupon','freeCouponProductAdded':'Free product added to cart: {products}','errorProduct1':'The products are no longer available and have been deleted from the cart','errorProduct2':'One or more products are no longer available and have been deleted from the cart','errorProduct3':'You must have products in your cart to be able to order!','errorProduct4':'Please select the method and location','errorProduct5':'Please add a customer','errorProduct6':'Payment method not selected','errorProduct7':'Please add an adress','errorProduct8':'ERROR, Please check the fiscal printer and banking POS device!','add':'Add','edit':'Edit','total':'TOTAL','infosup':'Add additional information','state':'County','city':'Town','adress':'Block, staircase, floor, apartment','number':'Number','street':'Street','adressname':'Address Name','sexf':'Female','sexm':'Male','sex':'Sex','birthdate':'Date of birth','contactperson':'Contact person','newclient':'Add or choose client','newadress':'Add or choose the address','save1':'Choose and save changes','deliveryAdress':'Add address','deliveryAdressEdit':'Edit adresa','prodId':'ID / Client Code','firstName':'First name','lastName':'Last name','contactPers':'Contact person','clientSelected':'Selected customer','clearFields':'Clear the fields','addAdress':'+ Add the address','existingClient':'Order from','orderNow':'Place order','editOrderNow':'Finish the edit','POS':'Pos','pos':'Pos','cash':'Cash','free':'Free','protocol':'Protocol','coment':'Comment Order','client_notif':'This text will be sent to the customer','addTip':'Add tip','removeTip':'Remove tip','addCoupon':'Add discount coupon','removeCoupon':'Delete discount coupon','modif':'modify','freeProd':'Free Product','partialPay':'Edit Price','info':'Info','orderDet':'Order Details','cartDet':'Order summary','fast':'As soon as possible','selectHour':'Select the time','selectPayment':'Select the payment method','pleaseSelectMethodAndLoc':'Please select the method and location!','locSelect':'Select a location','searchProduct':'search products','phone':'Phone','email':'E-mail','inlocation':'In Location','glovo':'Glovo','tazz':'Tazz','bolt':'Bolt','wolt':'Wolt','application':'Application','online':'Online','adressNotInRange':'Not in range, please change the adress!','adressNotCorect':'Adress is not correct','noClient':'Order without client','other':'Others'},settingCompany:{authAppCode:'Location authentication code',generateAuthAppCode:'Generete code',purchase_limit_interval_hours:'Disponibility purchase limit interval hours',integrators_department:'Integrators Tax',integrators_tax_vat_printer_id:'Vat Printer Id',other_taxes_vat_printer_id:'Printer id for corrections',donation_vat_printer_id:'Printer id for donations',vatPrinterIdColumn:'Printer ID',integrators_tax_vat_amount:'Tax Vat Amount',integrators_department_id:'Department Id',title:'Company',location:'Location',name:'Name',selfOrderDomain:'Self Ordering Domain',appLink:'Link aplication',appLinkAndroid:'Android link aplication',appLinkIos:'Ios link aplication',lang:'Application language',bussLoc:'Business Location',deliveryLabels:'Delivery methods labels',deliveryType:'Delivery method',pick_up:'Pick-up',meet_half:'Meet me half way',delivery:'Delivery',eat_location:'Reserve a table',self_ordering:'Self Ordering',phone:'Phone',street:'Street',number:'No.',latitude:'Latitude',longitude:'Longitude',email:'Email',city:'City',country:'Country',state:'State',availableDaysHrs:'AVAILABLE DAYS AND HOURS',from:'from',to:'to',preOrder:'pre-order from',allowPreOrder:'Allow Pre-order',cardPaymentDetails:'Card Payment Settings',paylikeKeys:'Paylike used keys',posDiscount:'POS id for discount',userTaxes:'USED TAXES',noTaxMsg:'Info: You have made changes on taxes, don\'t forget to save them.',areYouSureDelete:'Are you sure you want to delete this location? This action will also delete the ordering settings for this location.',pickLocationToCopy:'Pick a location from where you want to copy the products',areYouSureTax:'Are you sure you want to remove this tax from taxes list? Don\'t forget to save the changes!',areYouSureVat:'Are you sure you want to remove this VAT from the list?',companyUpdated:'Company data updated successfully',locationUpdated:'Location data updated successfully',updateError:'The data have not been saved. Please check again and retry!',companyProdCopied:'Products copied successfully.',companyProdAddLoc:'Location added to products successfully.',copyBtn:'Add location to Products',companyProdDeleted:'Products deleted successfully.',areYouSureDeleteProd:'Are you sure you want to delete all product from this location?',wrongAddress:'The address of "{location}" location is not correct.',deleteLocationValidation:'This location is in use. You may not delete it. You have to remove it first from the products where it is in use.',email_feedback:'E-mails for receiving feedbacks from the mobile apps',email_feedback_helptext:'You may use multiple e-mail addresses separated by commas.',printSettings:'Print settings',automatPrintOrder:'A4 Web print order automatically',autoSendOrderToPrinter:'80 mm print order',autoPrintLocalServer:'Auto-print section receipt from local server (new or processing orders)',printerIp:'Printer IP/Host',printerPort:'Printer Port',hostname:'Hostname (pc)',printerName:'Printer Name (from windows)',printer_is_usb:'Is USB concted',copyProductsFrom:'Copy products from ',deleteProducts:'Delete all product from this location',menuActions:'Menu actions',overEighteen:'Restricting users under 18 (required to sell alcohol through the application)',setRadiusArea:'Set Radius Area',setDrawArea:'Set Draw Area',jump_to_menu:'Jump to menu',jump_to_categories_menu:'Allows direct access to the menu in the application, before delivery methods.',allow_fiscal_print:'Allow printing receipt',payment_btns_v2:'Btns V2',pos:'POS',use_pos_notifications:'Use POS notifications',use_clients_offline:'Use clients offline',use_gift_card_on_pos:'Use gift card on POS',app:'App',use_interactive_tour_always:'Use interactive tour always',use_interactive_tour_first_login:'Use interactive tour on first login',force_location_from_deeplink:'Force location from deeplinks',just_card_txt_to_kiosk:'Text just card to Kiosk',table_scroll_menu_horizontal:'Scroll menu horizontally',add_packing_method_to_comment:'Add packing method (eat in / take away) to the Kiosk order comment',useProdTimeOpt:'Use time options for products (on Reserve/Book method only)',allowPlaceUntilCloseHour:'Allow place orders until close hour',sortProductsMethods:'Sort products method',alphabetic_asc:'After name ascendent',alphabetic_desc:'After name descendent',price:'After Price',custom:'Custom',infoCustomSort:'(custom sort is made in each category edit section)',filters:'Filters',allowSoundAtStatusNew:'Allow sound at orders status NEW',addStatusOnHold:'Allow On Hold status',addStatusPostponed:'Allow Postponed status',removeTotalsExtrasFromDiscount:'Do not apply discount on taxes',useGrandTotalForDeliveryZoneShippingCost:'Apply shipping discounts based on final order value',allowSoundAtStatusProcessing:'Allow sound at orders status PROCESSING',allowSoundAtStatusProcessingV1:'Allows sound according to the default waiting time',allowSoundAtStatusProcessingV2:'Allows sound according to 1/4 of the default waiting time',allowSoundAtStatusProcessingV3:'Allows sound based on 1/2 of the default waiting time',allowSoundAtStatusProcessingV0:'No sound',allowToOrderUnderMinValueWithCoupon:'Allow to place order under min value when apply coupon',flagFastOrderFromAdmin:'Fast location order',allowSoundForMehods:'Allow sound for following delivery methods',generateQrMenu:'In order to generate QR codes update the',generateClientViewLink:'In order to generate the access links update the',generateQrMenuSettings:'company locations',email_transport:'Transport e-mail',lateOrders:'Late orders',tipSuggestion:'Tip Suggestion',reorderPopupTitle:'Reorder popup (QR menu)',reorderPopupMinutes:'Inactivity minutes before showing the popup',reorderPopupHelp:'0 or empty disables the popup. Not shown on kiosk. Only appears if there is at least one product in the cart.',kioskQrSettingsTab:'Kiosk/QR settings',kioskSettingsTitle:'Kiosk/QR settings',kioskUsingTopCategoryLabel:'Uses top categories',kioskUsingTopCategoryHelp:'When enabled, the menu is grouped by top categories in details, kiosk and QR.',kioskFiscalReceiptForCashLabel:'Kiosk uses fiscal receipt for cash',kioskNonFiscalReceiptForCardLabel:'Kiosk uses non-fiscal receipt for card',kioskAddToCartNotificationPositionLabel:'Notification position when adding a product to cart',kioskAddToCartNotificationPositionPopup:'Popup',kioskAddToCartNotificationPositionSidebar:'Sidebar',tipSuggestionType:'Type',tipSuggestionSuggestion:'Suggestion',discountSuggestion:'Discount Suggestion',discountSuggestionType:'Type',discountSuggestionSuggestion:'Suggestion',discountSuggestionFix:'Fix',discountSuggestionProc:'Percent',twilio_call:'Remind me of late orders via phone call',twilio_call_early_mark:'Remind me in the first 5 minutes',transport_setings:'Transport settings',google_maps_api_key:'Google key API',deliveryMethodsReflect:'Delivery methods updates must refelct on the',locationGroups:'location groups',automatedProcessedStatus:'Set automated status from "New" to "Processed"',donationPointValue:'Parity donation points',donationPointValueNr:'(loyalty points * this value = donation points)',alertMultipleOrders:'Hourly order alert',alertMultipleOrdersNr:'Number of orders per hour',smsoToken:'Token',smsoSender:'User ID',smsoTokenExtern:'Token Extern',smsoSenderExtern:'User ID Extern',locationImage:'Location\'s image',holidayTitle:'Holiday schedule',holidayAlert:'Delivery days automatically deactivate/reactivate depending on the holiday schedule interval.',holidayEnabled:'Enabled',holidayValidFromTo:'Valid from - to',apiKey:'API Key',cif:'CIF',addToCC:'Add me to CC',automatedInvoice:'Emit invoice automatically',invoicePerOrder:'Emit Invoice per Order',series:'Invoice Series',sendInvoice:'Send Invoice',openInvoice:'Open Invoice',use_auto_dispatch:'Automatic mode',newOrdersProcessing:'Process new orders',autoGroupingByZone:'Auto grouping by zone',preparedStatus:'Prepared status',autoModeText:'The system is now operating in automatic mode. Orders will be automatically received, processed, and organized into batches based on geographical zones. Once batched, the system will allocate deliveries to the nearest available driver, ensuring efficient and timely distribution of orders.',manualModeText:'The system is now operating in manual mode. Orders will be processed individually by a human operator. This includes receiving orders, organizing them into batches based on geographical zones, and manually assigning deliveries to the nearest available driver to ensure optimal distribution.',assignOrderToDriver:'Assign the order to a driver',drivers:'Drivers',unavailableRestaurantTitle:'Unavailable Mobile App',unavailableRestaurantText:'Message',unavailableRestaurantImage:'Image',unavailableRestaurantTextPlaceHolder:'This message will be displayed to users when no location has at least 1 delivery method enabled',digitalWaiter:'Digital Waiter',invoices:'Invoices',printer:'Printer',menuIntegration:'Integration',orderStatus:'Order status',smsoIntegration:'SMSO Integration',languages:'Languages',preferences:'Preferences',appQRCode:'Mobile App QR Code',digitalWaiterMode:'QR Menu Mode',allowOpenOrderLabel:'Open order mode',allowOpenOrderHelp:'Enables open order mode on the QR menu, letting guests keep adding to the same order across multiple rounds.',paymentGroup:'Payment Group',createLocationCost:'Creating a new location implies additional costs. Do you want to proceed?',activateLocationCost:'Activating a new location implies additional costs. Do you want to proceed?',closeOrders:'Close all {deliveryMethod} orders',closeOrdersAfter:'after x hours',closeOrdersAt:'at selected hour',autoChangeStatus:'Auto change Status for all {deliveryMethod} orders',otherSettings:'Other Settings',accessAndVisibility:'Access and visibility',measurements_units_id:'Measurement unit',quantitative_unit:'Quantitative unit',reportProductOptionTitle:'Products and Options Report',email__prod_opt_report:'Email address where the report will be sent',time__prod_opt_report:'Time the report will be sent',inv_company_name:'Company Name',inv_fiscal_code:'Fiscal Code',inv_trade_register:'Trade Register',inv_phone:'Phone',inv_email:'Email',inv_country:'Country',inv_address:'Street',inv_street_number:'Number',inv_county:'County',inv_city:'City',inv_additional_data:'Additional Data',inv_is_vat_payer:'VAT state',inv_is_vat_payer_0:'He is NOT a VAT payer',inv_is_vat_payer_1:'IS a VAT payer',inv_bank_account:'Bank account',inv_bank:'Bank',inv_bank_branch:'Branch',initalOrderStatusKiosk:'Initial status for Kiosk orders',initalOrderStatusApp:'Initial status for Mobile and Web orders'},menuSubscriptions:{single:'menu subscription',newTitle:'New menu subscription',noSubscriptions:'There are no menu subscriptions. Add the first one.',perDayShort:'day',durationDays:'{days} days',menusCount:'{count} menus',defaultMenuShort:'default',zonesCount:'{count} zones',notReady:'Can not be sold yet, missing',notReadyHint:'Complete what is missing to activate it',readyActive:'The subscription is complete and active (it can be bought).',readyInactive:'The subscription is complete. Activate it so it can be bought.',saveFirst:'Save the subscription first',active:'Active',activeAfterMenus:'Can be activated after you add at least one menu.',saved:'The subscription was saved.',deleted:'The subscription was deleted.',areYouSureDelete:'Are you sure you want to delete the subscription {name}?',tabGeneral:'General',tabDelivery:'Delivery',tabMenus:'Menus',tabCalendar:'Calendar',name:'Name',namePlaceholder:'e.g. Vegan - Lunch',nameRequired:'The name is required.',location:'Location that prepares the orders',locationPlaceholder:'Choose the location',locationHint:'The daily orders are created on this location; the products are picked from its menu.',locationRequired:'Choose the location.',pricePerDay:'Price per day',pricePerDayHint:'One portion for one day. Every menu must add up exactly to it.',priceRequired:'The price per day is required.',duration:'Duration (calendar days)',durationHint:'The customer picks the start date (at most {days} days ahead) and gets a delivery on every delivery day in this period.',durationWeekendHint:'If we set 30 days but do not deliver at the weekend, there will actually be about 21 delivery days (depending on how the non-delivery days fall).',durationEstimate:'With the delivery days ticked now: {range} delivery days out of {days} calendar days.',maxSubscribers:'Max active subscribers',unlimited:'Unlimited',maxSubscribersHint:'Empty = unlimited.',minQuantity:'Min quantity',maxQuantity:'Max quantity',quantityHint:'How many portions the customer can buy (e.g. 2 = double food every day).',description:'Description',image:'Image',imageHint:'jpg/png, max 5MB',deliveryDays:'Delivery days',deliveryDaysHint:'On these days an order is created for every subscriber.',deliveryHours:'Delivery intervals',deliveryHoursHint:'The customer picks one of the intervals when buying.',hoursInvalid:'Every delivery interval needs a start and an end (start before end).',from:'From',to:'To',addInterval:'Add interval',orderLead:'Create the order',minutes:'minutes before',orderLeadExample:'E.g. for the {from} delivery the order enters the system (POS/kitchen) at {time}.',orderLeadExampleDayBefore:'E.g. for the {from} delivery the order enters the system (POS/kitchen) at {time} the day before.',zones:'Delivery zones',zonesPickLocation:'Choose the location first (General tab).',noZones:'There are no delivery zones for the company or for this location.',zone:'Zone',zoneDefaultFee:'Zone fee',zoneFee:'Fee per delivery',companyZone:'company zone',locationZone:'location zone',zoneInactive:'inactive',zonesHint:'The fee is paid for every delivery. Empty = the zone fee; 0 = free delivery.',fixErrors:'Complete the marked fields',rescaleQuestion:'The price per day changed. Adjust the product prices of the {count} menus proportionally so they add up to {price}?',rescaleYes:'Yes, adjust',rescaleNo:'No, I will adjust them',dayShort:{monday:'Mo',tuesday:'Tu',wednesday:'We',thursday:'Th',friday:'Fr',saturday:'Sa',sunday:'Su'},months:{0:'January',1:'February',2:'March',3:'April',4:'May',5:'June',6:'July',7:'August',8:'September',9:'October',10:'November',11:'December'},issues:{no_location:'the location',no_price:'the price per day',no_delivery_days:'the delivery days',no_delivery_hours:'the delivery intervals',no_zones:'the delivery zones',no_menu:'at least one menu',menu_price_mismatch:'menus whose total differs from the price per day ({menus})'},menusTitle:'Menus',menusHint:'The default menu is delivered on every day without another menu in the calendar. Every menu must add up to {price}.',newMenu:'New menu',editMenu:'Edit menu',noMenus:'There are no menus. The first menu added becomes the default menu.',defaultMenu:'Default',makeDefault:'Make it the default menu',duplicate:'Duplicate',totalMismatch:'total {total} - does not match the price per day',upcomingDays:'{count} days in the calendar',willAssignDates:'After saving, the menu will be set on: {dates}',menuName:'Menu name',menuNamePlaceholder:'e.g. Monday - week 1',menuNameRequired:'The menu name is required.',addProducts:'Add products',searchProducts:'Search product by name or ID',allCategories:'All categories',noProductsFound:'No products found.',catalogPrice:'catalog price',catalogPriceHint:'Catalog price (hint)',vat:'VAT',course:'Course',product:'Product',quantity:'Quantity',unitPrice:'Price in menu',lineTotal:'Total',noItems:'Add at least one product to the menu.',productMissing:'The product no longer exists. Replace it.',putDifferenceHere:'Put the difference on this product',cannotPutDifference:'The difference can not be split exactly by this product quantity. Pick a product with quantity 1.',cannotRescale:'The total can not be reached exactly with these quantities. Add a product with quantity 1 or adjust manually.',menuTotal:'Menu total',difference:'Difference',adjustProportionally:'Adjust proportionally to {price}',priceRuleHint:'The menu prices are the ones on the order and on the fiscal receipt. The catalog price is only a hint.',totalMustMatch:'The menu total ({total}) must be equal to the price per day ({price}).',deleteMenuQuestion:'Are you sure you want to delete the menu {name}?',deleteMenuDays:'Its {count} calendar days will get the default menu.',deleteMenuDefault:'The next menu becomes the default menu.',menuSaved:'The menu was saved.',menuSavedAssigned:'The menu was saved and set on the selected days.',courses:{1:'Course 1',2:'Course 2',3:'Course 3',4:'Dessert',5:'Breakfast',6:'Lunch',7:'Dinner',8:'Snack'},calendarHint:'Select delivery days and choose their menu. Days without a chosen menu get the default menu.',calendarCustom:'Chosen menu',calendarDefault:'Default menu',calendarNoDelivery:'No delivery',calendarNoDeliveryShort:'no delivery',calendarNoMenus:'Add a menu first (Menus tab).',calendarNoMenu:'no menu',calendarSaved:'The calendar was saved.',selectMonth:'Select the whole month',clearSelection:'Clear selection',selectedDays:'{count} days selected',chooseMenu:'Choose the menu',applyMenu:'Set menu',resetToDefault:'Back to the default menu',newMenuForDays:'New menu for these days'},menuSubscribers:{title:'Subscribers',offer:'Subscription',allOffers:'All subscriptions',customer:'Customer',searchPlaceholder:'Name, email, phone or ID',statusLabel:'Status',status:{all:'All',paid:'Paid',active:'Active',pending:'Only tried',abandoned:'Abandoned',stopped:'Stopped',finished:'Finished'},empty:'There are no subscribers.',period:'Period',portions:'{count} portions',portionsLabel:'Portions',deliveries:'Deliveries',deliveriesHint:'delivered / orders created / total',scheduledCount:'{count} scheduled',cancelledCount:'{count} cancelled',errorsCount:'{count} with error',orderedCount:'{count} orders created',deliveredOf:'{delivered} delivered of {total}',money:'Money',total:'Total',paid:'Paid',refunded:'Refunded',refundable:'Can still be refunded',valueDelivered:'Delivered value',valueNotDelivered:'Not delivered value',details:'Details',stop:'Stop subscription',stopHint:'No more orders are created: the {count} remaining deliveries are cancelled. Money is not refunded automatically (use Refund).',stopConfirm:'Stop',stopQuestion:'Are you sure you want to stop the subscription of {name}?',stopped:'The subscription was stopped.',refund:'Refund',refundHint:'At most {max} can be refunded. The value of the deliveries not made is {notDelivered} (a hint - you choose the amount).',amount:'Amount',useSuggested:'use {amount}',refundProcessorHint:'If the payment is not settled at euPlatesc yet (usually the same day), it can only be cancelled in full; a partial amount can be refunded after settlement.',refundConfirm:'Refund',refundQuestion:'Are you sure you want to refund {amount} to the customer?',refundDone:'The amount was refunded.',reason:'Reason',reasonPlaceholder:'The reason (kept in the history)',interval:'Delivery interval',day:'day',deliveryFee:'delivery fee',source:'Bought from',address:'Address',zone:'Zone',phone:'Phone',comments:'Comments',stoppedInfo:'Stopped on {date} by {user}',noDeliveries:'There are no deliveries (the subscription was not paid).',date:'Date',menu:'Menu',deliveryStatus:'Delivery',deliveryStatuses:{scheduled:'Scheduled',order_created:'Order created',cancelled:'Cancelled',error:'Error'},orderAt:'order at {date}',order:'Order',value:'Value',note:'Note',payments:'Payments',noPayments:'No payment.',paymentStatuses:{created:'Created',pending:'Link generated',success:'Paid',failed:'Failed',expired:'Link expired',cancelled:'Cancelled',refunded:'Fully refunded'},refundStatuses:{pending:'in progress',success:'refunded',failed:'failed'},history:'Action history',noHistory:'No action.',events:{stop:'Stopped',refund:'Refunded'}},crossSell:{posSettingsTab:'POS settings',title:'Cross-sell / upsell products',help:'The selected products will be suggested to the POS operator at checkout.',selectedTitle:'Selected products',noneSelected:'No products selected yet.',searchPlaceholder:'Search products...',allCategories:'All categories',loading:'Loading...',noResults:'No products found.',maxReached:'You can select at most {max} products.',pageInfo:'Page {page} of {pages} ({total} products)'},scanner:{notFound:'Client was not found',notEnoughFunds:'Wrong Value! Please check again',expired:'Code has expired',confirm:'Confirm',wrongInput:'Wrong Value! Please check again',scanCode:'Scan clients\' QR code'},settingDateTime:{timezone:'Timezone',timeFormat:'Time format',dateFormat:'Date format',saveMsg:'Date & Time settings saved successfully'},settingCurrency:{currency:'Shop currency',saveMsg:'Currency data saved successfully'},settingTaxes:{single:'Tax',name:'Name',type:'Type',amount:'Amount',notice:'In this section you only define a label name for the tax to be applied. To define the tax details such as value or type you need to go to',notice2:'company details',singleTaxLabel:'Tax Label',notice3:'In this section you define the taxes which are applied, details such as value or type, to create other tax labels go to',notice4:'tax labeling',notice5:'In this section you define your quota, to create other VAT lables go to'},settingsPayment:{publicKey:'Public key',privateKey:'Private key'},settingsWeb:{header_color:'Color background header',header_text_color:'Color text header',success:'Details updated succesfully',fbLink:'Facebook Link',igLink:'Instagram Link',trpLink:'Tripadvisor Link',twitterLink:'Twitter Link',tiktokLink:'Tiktok Link',linkedinLink:'LinkedIn Link',websitePrezentareLink:'Website Prezentation Link',whatsapp:'WhatsApp Chat',gpLink:'Google Play',asLink:'Apple Store',fbPixel:'Facebook Pixel',fbapid:'Facebook App ID',interCol:'Interface color',g4a:'GA4 integration',site:'Website link',category_proportion:'Image category',product_proportion:'Image product',display_mode:'Display mode',background_color:'Background color',font_product_title:'Product/Category title font',font_product_description:'Product description font',display_image_category:'Display image category',social_media:'Social media links',link_app:'App links',tracking:'Analytics',design:'App design',structure:'App structure'},settingsOrdering:{shipping_department_id:'Shipping Department Id',reservation_pay_per_person:'Pay per person',extraCostRange:'Extra Cost Range',panaLa:'Up to: ',distanceInKm:'Distance in km',showTheRestOfTheZones:'Show the other areas on the map',copyRangesFromLocation:'Copy ranges from location',selectLocationToLoadRanges:'Select a location to load the ranges.',location:'Location',selectLocation:'Select location',ranges:'Ranges',min_interval_reservations:'The number of minutes for interval reservation',min_standard_reservations:'The number of hours allocated to the reservation',min_between_reservations:'The number of minutes between bookings',available_days:'Orar',reservation_available_in_app:'Accept table reservations in the app',max_number_seats:'Maximum seat capacity at the location',reservationWidgetTitle:'Website reservation widget',reservationWidgetHint:'Copy this script to your website. Company ID, method ID and location token are filled in automatically.',reservationWidgetPosition:'Position',reservationWidgetLanguage:'Language',reservationWidgetHoursToStay:'Hours to stay',reservationWidgetDefaultPersons:'Default guests',reservationWidgetTableZone:'Table zone',reservationWidgetCountryPrefix:'Country code prefix',reservationWidgetRestaurantName:'Restaurant name',reservationWidgetScript:'Embed script',reservationWidgetCopy:'Copy script',reservationWidgetCopied:'Copied',reservationWidgetPreview:'Preview',reservationWidgetPosBottomRight:'Bottom right',reservationWidgetPosBottomLeft:'Bottom left',reservationWidgetPosTopRight:'Top right',reservationWidgetPosTopLeft:'Top left',offnoPreorders:'You must have offset 0 and period 1 to work',noPreorders:'We do not accept pre-orders',isAlwaysOpen:'Always open',isAlwaysOpenPreorderHours:'Preorder hours',reservationTaxesTitle:'Adauga program mese',reservationTaxesTitleEmpty:'Niciun program adaugat',reservationTaxAdvanceConsumption:'Acest preț reprezintă avans în consumație',infoBoxTitle:'Add extra information',infoBoxRadioCheck:'Change the option',infoBoxRadio:'Only one option allowed',infoBoxCheck:'Multiple options allowed',enabled:'Enabled',allow_fidelities:'Allow fidelities',allow_fidelitiesHelp:'Required fidelities active',allow_sms_notifications:'Allows sms to notify the customer of the prepared status (*required smso integration active)',paymentOptions:'Payment Options',paymentOptionsErr:'The payment option field is required.',closeOrderAfterHours:'This value must be between 0 and 23.',waitingTime:'Default waiting time',count_orders_starts_from_hour:'The time from which the order number starts',maxDistanceInMeter:'Distance in meters for the table access radius:',minimumOrderValue:'Minimum order value',extraDeliveryTime:'EXTRA time',minutes:'min',hours:'hours',shippingCost:'Shipping cost',deliveryRange:'Delivery Range',deliveryRangeUnit:'m',posId:'Shipping cost POS ID',shippingTax:'Shipping tax',locations:'Locations',selectLocations:'Select or leave blank for all',street:'Street',city:'City',country:'Country',state:'State',availableDays:'Available days and hours',availableDaysErr:'The available days and hours option field is required.',notice:'Please check for empty fields in the enabled ordering methods',saveSuccess:'Ordering details data saved successfully',deliveryRules:'Delivery rules',addRange:'Add rule',shippingCities:'Cities / Villages',shippingNeighborhoods:'Neighborhoods',citiesValidationError:'Please make sure cities values are unique for each delivery range.',errorAutoChangeStatusAfterMin:'This value must be between 0 and 360.',hourAndDate:'Hour and Date',justDate:'Just date',deactivateDeliveryHours:'Deactivate hour and date',offset:'Offset',period:'Period',chooseZone:'Choose zone',addZone:'Add Zone',newZone:'New Zone'},settingsZone:{edit:'Zone name',deleteBtn:'Delete Zone',deleteShape:'Delete Shape to create another one',overridePayment:'Override payment method',acceptCash:'Accept cash',acceptCard:'Accept card',acceptPos:'POS on delivery (unpaid)'},settingsInfoPages:{single:'page',noPage:'No pages added yet.',title:'Page Title',content:'Page Content',newPage:'New Page',showInHeader:'Show in header',showInFooter:'Show in footer',imageSize:'Image size',imageSizeContain:'Contain',imageSizeCover:'Cover',imageSizeFullPage:'Full Page',addedSuccess:'Page saved successfully.',deletedSuccess:'Page deleted successfully',deleteMsg:'Are you sure you want to delete this page?',TERMS_CONDITIONS:'Terms and Conditions',PRIVACY_POLICY:'Privacy Policy',CONTACT_DETAILS:'Contact Details',FIDELITIES_PROMOTIONS:'Fidelities Promotions',LOYALITY_POINTS:'Loyalty points rules',DONATION_POINTS:'Rules for donating points',CUSTOM:'Custom',ABOUT_US:'Despre Noi',COOKIE_POLICY:'Politica Cookies'},settingsRewards:{single:'point',plural:'points',state:'State',points:'point(s)',moneySpent:'Money Spent to points',pointsTo:'Points to Money',numberOfcurrencyNeedToSpend:'Number of points earned for each {currency} spent.',default:'If left blank, default values will be used',numberOfpointsToReward:'Amount of points client needs when he wants to pay using points.',rewardSuccess:'Loyalty program data saved successfully',referalActive:'Referal module has been activate',referalInActive:'Referal module has been de-activate',enableNotifications:'Enable Notifications',notifyUsersLoyaltyPoints:'Notify the users when they receive loyalty points.',customizeLoyaltyPointsNotification:'Customize the notification message from ',timeInterval:'Time interval ',fromTime:'From',toTime:'To',from:'Time interval ',here:'here',initialReferal:'Percentage of first order total to gain',parentReferal:'Percentage gained by parent',loyaltyOnlyFullPoints:'Allow only full points',loyaltyOnlyFullPointsHelp:'Round earned points down to whole numbers per order, after discounts, using the configured conversion rates. Partial points do not carry forward. Existing balances and redemption value stay unchanged.',loyaltyMinOrderValue:'Minimum order value to earn loyalty points',loyaltyMinOrderValueHelp:'Product value after discounts, excluding shipping and tips. Orders below this amount earn no points. Leave empty for no minimum.',loyaltyPointsAppLimit:'Max loyalty points allowed as discount per order'},settingsPushNotif:{order_new:'New order message',order_completed_pickup:'Completed order message - Pick-up',order_completed_meet:'Completed order message - Meet me half way',order_completed_delivery:'Completed order message - Delivery',order_completed_eat:'Completed order message - Eat on location',order_canceled:'Canceled order message',notifUpdated:'Push notifications data saved successfully',preview:'Preview',time:'time',dateTime:'date and time',persons:'persons number',timePrev:'11:30 (in 30 minutes)',personsPrev:'3',dateTimePrev:'Tuesday, February 15, 2019, at 6pm',info:'* In case you do not need the delivery time to be shown please leave empty the last field.',selectedLocations:'Selected locations:',pointsPrev:'(number of points)',worthPrev:'(points\' worth)'},settingsTips:{tipsLabel:'Tips',tipsTaxes:'Tips taxes',tipsVat:'Tips VAT',state:'Use tips',tipsSuccess:'Tips saved successfully'},settingsPlans:{plan1Title:'Monthly',plan1Rate:'160€ / month',plan1Description:'Get started with a monthly fixed fee, no matter the amount of sales you make through the app.',plan2Title:'Sales percentage',plan2Rate:'10%',plan2Description:'Pay as you sell. Chose the Sales Percentage and pay a monthly fee in relation with the amount you sell through the app.',current:'Current subscription',switch:'Switch'},settingLocationGroups:{active:'Active',isOpen:'Open',displayInSlider:'Display groups in slider',noData:'No data. Create new groups with "+" button. ',parentGroup:'Parent Group',write:'(Write...)'},paymentPage:{invoice:'Invoice',total:'Total',forDate:'For date',payed:'Payed',transaction:'Transaction',payLink:'Pay Link',viewInvoice:'View invoice',download:'Download',pay:'Pay',invoiceList:'Invoice list'},filter:{filter:'Filter',action:'Action',create:'Filter Created',update:'Filter Updated',areYouSureDelete:'Are you sure you want to delete this filter',yes:'Yes',deleted:'Filter deleted',noFilters:'No filters',name:'Name',addFilter:'Add filter',filters:'Filters',value:'Value',filterProducts:'Filters Products',filterName:'Filter Name',val:'Val',filterUpdated:'Filters Updated',minOneFilterValueRequired:'Minim one filter value per filter required',filterType:'Filter Type',type_exists:'Filter Type Exists',filter_value_exists:'Filter Value Exists',some_filter_applied:'Successfully updated but some filter or value are applied on products and it can\'t be deleted'},newsletterCard:{title:'List with news, info and support',titleNews:'News',titleMonthlyInfo:'Monthly Info',titleVideoSupport:'Video and Support',helpVideoSupport:'Do you need help?',searchPlaceholder:'Search',noResultsMessage:'Could not find any video with this name or title.',tableName:'Name',tableDate:'Date',tableDownload:'Download',buttonDownload:'Download',allArticles:'All articles',articleFound:'article found',searchArticle:'Search article',readArticle:'Read article'},groupOption:{areYouSure:'Are you sure?',importTitle:'Add this group to all products in the category',importAdd:'Add'},rkeeperV2:{title:'RKeeper V2',url:'Endpoint URL',slug:'Restaurant Slug',apiUser:'API User (X-Api-User)',apiSecret:'API Secret (X-Api-Secret)',secret:'Webhook Secret',testLogin:'Test login',save:'Save',saved:'Saved',error:'An error occurred',active:'Active',loginOk:'Login successful',loginFail:'Login failed',syncMenu:'Sync menu',syncQueued:'Menu sync started…',running:'Menu sync in progress…'},rkeeper:{rkeeper:'RKeeper',import:'Import',products:'Import All Products',categories:'Import Categories',sync:'RKeeper Synchronization',onlyProducts:'Sync Only New Products',onlyOptions:'Sync Only New Options',productPrices:'Sync Product Prices',optionPrices:'Sync Option Prices',importSuccess:'The import was successful. Don\'t forget to sync prices.',importError:'The import could not be completed',syncSuccess:'The synchronization was successful',syncError:'The synchronization could not be completed',importInProgress:'The import has started. This process can take a few minutes',syncInProgress:'The synchronization has started. This process can take a few minutes'},glovo:{noTrackingNumber:'No tracking number was found. Courier was not canceled',areYouSure:'Are you sure you want to call Glovo courier?',errorPickupTime:'Choosen pick up time is not available',outOfWorkingAreaDeliveryAddress:'Delivery address is not available',canNotCancel:'The order has been picked up already, it cannot be canceled',CAN_NOT_CANCEL:'The order has been picked up already, it cannot be canceled',addressesNotInSameCityCode:'Choosen addresses are not in the same city',outOfWorkingHours:'There are no couriers available at the moment',outOfWorkingAreaPickupAddress:'Pick up address is not available',error:'An error occurred',syncLabel:'Sync Glovo Menu',noTopCat:'Deactivate unused top categories and try again',noCat:'The categories that are active have no active products'},tazz:{noTrackingNumber:'No tracking number was found. Courier was not canceled',areYouSure:'Are you sure you want to call Tazz courier?',areYouSureCancel:'Are you sure you want to cancel Tazz courier?',errorPickupTime:'Choosen pick up time is not available',outOfWorkingAreaDeliveryAddress:'Delivery address is not available',canNotCancel:'The order has been picked up already, it cannot be canceled',CAN_NOT_CANCEL:'The order has been picked up already, it cannot be canceled',addressesNotInSameCityCode:'Choosen addresses are not in the same city',outOfWorkingHours:'There are no couriers available at the moment',outOfWorkingAreaPickupAddress:'Pick up address is not available',error:'An error occurred',syncLabel:'Sync Tazz Menu',tazzStatus1:'The courier was not called',tazzStatus2:'The courier was called',tazzStatus3:'The courier was not called',tazzStatus4:'The courier was canceled',tazzStatus5:'An error ocurred',orderPrepared:'O. Prepared'},importProductsError:{noTopCat:'Deactivate unused top categories and try again',noCat:'The categories that are active have no active products'},bolt:{acceptOrders:'Accept Orders',menu:'Menu',sync:'Update started, it make take a while',syncError:'Updated could not be made'},wolt:{integrateLocation:'Choose location to onboard',getWolt:'Get onto Wolt',updateCredentials:'Update Credentials',redirectToWolt:'Redirect to Wolt'},posnet:{enableReport:'Enable report',reportDate:'Report Date',confirmActivateReport:'Do you want to activate the report for date {date}?',confirmActivateReportAutomated:'Are you sure you want to activate the report in automated mode for yesterday\'s date ({date})?'},epRestaurant:{importLabel:'Import Ep Restaurant Menu',resendQuestion:'Are you sure you want to resend this order?'},nexus:{ordersPeriod:'Orders Interval',elgibleOrders:'In order to be eligible for integration, orders must be collected and in status "DELIVERED".',ordersAlreadyIntegrated:'Orders that are already successfully integrated are not considered.',pickupDatetime:'Pickup Date',paymentType:'Payment Type',orderStatus:'Order Status',isSent:'Status',retryCount:'Retries',retryAt:'Retry At',receiptNumber:'Receipt Number',nexusOrderId:'Nexus Document ID',sentStatus0:'Pending',sentStatus1:'Sent',sentStatus2:'Failed',sentStatus3:'Cancelled',sentStatus4:'Retry Scheduled',sentStatus5:'Pending Cancellation',vatRate:'VAT Rate',markResend:'Resend',markCancellation:'Cancel',markResendConfirm:'The filtered selection will be marked to be sent again to Nexus. Do you wish to proceed?',markCancellationConfirm:'The filtered selection will be marked for cancellation in Nexus. Do you wish to proceed?',markSuccessMessage:'The orders have been marked and will be sent in a few minutes. The logs can be found in the Actions column.',invoiceStatus:'Nexus Status',invoiceLog:'Nexus Log',invoiceSend:'Send to Nexus',invoiceSendConfirm:'Mark this invoice to be sent to Nexus?',invoiceStornoConfirm:'Mark this invoice for storno in Nexus?',invoiceMarkSuccess:'The invoice has been marked for Nexus and will be processed shortly.',invoiceNoOrder:'This invoice has no linked order ID.',invoiceStatusUnknown:'Nexus status is unavailable for this invoice.',invoiceStatus1:'Queued for Nexus',invoiceStatus1Text:'The invoice is waiting to be sent to Nexus.',invoiceStatus2:'Sending to Nexus',invoiceStatus2Text:'The invoice is currently being sent to Nexus.',invoiceStatus3:'Sent successfully',invoiceStatus3Text:'The invoice was sent to Nexus successfully.',invoiceStatus4:'Send failed',invoiceStatus4Text:'An error occurred while sending the invoice to Nexus.',invoiceStatus5:'Queued for storno',invoiceStatus5Text:'The invoice is marked for storno in Nexus.',invoiceStatus6:'Storno completed',invoiceStatus6Text:'The invoice was successfully cancelled in Nexus.',invoiceStatus7:'Storno failed',invoiceStatus7Text:'An error occurred while cancelling the invoice in Nexus.'},rsystem:{fetchOrganizations:'Retrieve organizations',choose:'Choose an option',tipsId:'Tips type',completeSetup:'Complete the R Systems organization, terminal group and payment mappings before saving.',proc:'Proc (percentage)',fix:'Fix (fixed amount)',adjustable:'Adjustable',recommended:'Recommended',payment_CASH:'Cash',payment_CARD:'Online card',payment_POS:'POS',payment_CARD_POS:'Card at POS',payment_ONLINE:'Online',reviewMappings:'Review suggested mappings. Choose explicitly where multiple methods match.',destination:'Destination',refreshMenu:'The organization changed. Reconcile the old menu and explicitly import the selected organization’s menu before taking orders.',requestFailed:'Unable to retrieve R Systems settings. Retry.',saved:'Integration settings saved.',importConfirm:'Import the menu for the saved organization? Reconcile the old menu first; existing orders will retain their saved product IDs.',importQueued:'Menu retrieved and queued for processing.',apiKey:'API Key',organisationId:'Organization',terminalGroupId:'Terminal group',paymentTypes:'Payment Methods',discountId:'Discount',settings:'Settings',deleteMenu:'Delete old menu before import',seoText:'Make sure your menu has SEO text TapTasty before importing',import:'Import'},checkbox:'Allows selecting multiple options on the product',radio:'Allows selecting only one option on the product',ebriza:{title:'Ebriza',woltDriveErrorsUrl:'Wolt Drive errors notification endpoint'}},__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default.a),ro:__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({btPayments:__WEBPACK_IMPORTED_MODULE_1__btPayments__["a" /* default */].ro,zoneAvailability:{title:'Disponibilitate zonă',active:'Zonă activă',activeHelp:'O zonă inactivă nu mai este disponibilă pentru livrare (adresele din ea sunt tratate ca fiind în afara zonei de livrare).',inactive:'Inactivă',activeColumn:'Activă',scheduleEnabled:'Activează programul orar',scheduleEnabledHelp:'Când e dezactivat, zona funcționează ca până acum (disponibilă oricând livrează locația). Când e activat, zona e disponibilă doar în intervalele de mai jos.',withSchedule:'Program',column:'Disponibilitate',hoursRequired:'Setează ora de început și de sfârșit pentru fiecare interval al zilelor bifate.',hoursOrder:'Ora de început trebuie să fie mai mică decât ora de sfârșit.',overlap:'Intervalele dintr-o zi nu se pot suprapune.',noOpenDay:'Bifează cel puțin o zi în program (sau fă zona inactivă).',zoneLabel:'Zona'},marketplace:__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Integrations_marketplaceLabels__["a" /* default */].ro,platformMenuImport:__WEBPACK_IMPORTED_MODULE_2__platformMenuImport__["a" /* default */].ro,deliveryPreferences:{deliveryTypeTitle:'Preferințe livrare',zonesTitle:'Zone',slotsTitle:'Sloturi',preferencesTitle:'Tip livrare',name:'Denumire externă (afișat în aplicație)',numeAdmin:'Denumire internă',numeAdminPlaceholder:'ex: Livrare standard pt locația X',add:'Adaugă',edit:'Editează',clone:'Clonează',back:'Înapoi',noData:'Nu există înregistrări încă',saved:'Salvat',deleteConfirm:'Sigur vrei să ștergi această înregistrare?',drawShapeRequired:'Desenează o zonă pe hartă înainte de salvare.',seatsRequired:'Completează toate rândurile de locuri (număr și preț).',duplicateZone:'Această zonă este deja adăugată.',zoneRequired:'Adaugă cel puțin o zonă de livrare.',hoursRequired:'Setează ora de început și de sfârșit pentru zilele/rândurile active.',hoursOrder:'Ora de început trebuie să fie mai mică decât ora de sfârșit.',slotRequired:'Alege un slot pentru rândurile active.',slotAdd:'Adaugă slot',slotSingle:'slot',costPerParte:'Cost per parte (taxă de urgență, opțional)',costPerParteHelp:'Dacă e setat, clientul poate alege în ce parte a slotului să vină (prima / ultima) pentru această taxă în plus.',seats:'Locuri',seatsCount:'Număr locuri (0 = nelimitat)',seatCost:'Preț',addSeatTier:'Adaugă rând de locuri',seatsHelp:'Locurile se ocupă de la cel mai ieftin; cu cât clientul comandă mai târziu, cu atât e mai scump.',zoneAdd:'Adaugă zonă',zoneSingle:'zonă',companyZone:'Zonă companie',locationZone:'Zonă locație',legacyReadonly:'Zonă veche pe locație — needitabilă. Cloneaz-o ca s-o folosești în sistemul nou.',cloneName:'Nume zonă nouă',showOtherZones:'Arată alte zone pe hartă',showOtherZonesPlaceholder:'Alege zone de afișat ca referință',shippingCost:'Cost livrare',minOrderValue:'Valoare minimă comandă',extraDeliveryTime:'Timp livrare suplimentar (min)',preferenceAdd:'Adaugă tip livrare',preferenceSingle:'preferință',type:'Tip',typeClassic:'Clasică',typeSlot:'Slot',typeClassicHelp:'Clientul poate să selecteze, în funcție de bifele de jos, o dată/oră exactă sau varianta fără dată și oră.',typeSlotHelp:'Apar mai multe sloturi și clientul își alege cel potrivit.',enabled:'Activă',hourMode:'Ore și dată',hourModeHourDate:'Oră și dată',hourModeDateOnly:'Doar dată',hourModeDisabled:'Dezactivează ora și data',hourModeHourDateHelp:'Clientul alege ora și data (data doar dacă offset și period nu sunt 0 și 1).',hourModeDateOnlyHelp:'Clientul alege doar data.',hourModeDisabledHelp:'Clientul nu alege nimic — livrarea se face după programul de livrări al restaurantului. În acest mod nu este disponibil nici programul: clientul pune comanda și va fi informat când o va primi.',offsetPeriodHelp:'Offset = numărul de zile lucrătoare (deschise) de acum până când clientul are voie să comande. Period = numărul de zile lucrătoare (deschise) de la terminarea offset-ului în care clientul poate comanda. Ex: offset 1, period 2 → azi nu poate comanda, doar mâine și poimâine; dacă azi programul e închis, numărătoarea începe din următoarea zi deschisă.',availableDays:'Zile disponibile',noPreorders:'Acceptăm comenzi doar în timpul programului',isAlwaysOpen:'Program de lucru non stop',minimumOrderValue:'Valoare minimă comandă',defaultWaitingTime:'Interval minim înainte de închidere (durata preparării comenzii + livrare)',autoAssignFirstSlot:'Nu permite clientului să aleagă slotul, atribuie primul slot disponibil',delayHours:'Întârziere (ore)',delayHoursHelp:'Clientul poate alege doar sloturi care încep peste cel puțin atâtea ore de acum.',schedule:'Program săptămânal',addScheduleRow:'Adaugă slot',slot:'Slot',selectSlot:'Alege slot',startTime:'Început',endTime:'Sfârșit',active:'Activ',closedDates:'Suprascriere calendaristică a programului de livrare',closedDatesHelp:'Pentru o dată anume poți opri livrarea toată ziua sau poți înlocui programul săptămânal cu un program propriu (sloturi și intervale, la fel ca mai sus), ex: sărbători.',closedAllDay:'Nu se livrează toată ziua',closedOverrideSchedule:'Suprascrie program',closedNoDelivery:'Fără livrări în această zi',closedEmpty:'Nicio suprascriere adăugată.',closedScheduleEmpty:'Niciun slot adăugat pentru această zi.',closedScheduleRequired:'Adaugă cel puțin un slot pentru fiecare zi cu program suprascris (sau alege „Nu se livrează toată ziua”).',closedCopyWeekly:'Copiază programul de {day}',closedCopyConfirm:'Înlocuiești sloturile acestei zile cu programul săptămânal de {day}?',closedDateDuplicate:'Aceeași dată apare de mai multe ori în suprascrierea calendaristică.',addClosedDate:'Adaugă dată',zones:'Zone de livrare',selectZone:'Alege zonă',noZone:'Fără zonă',methods:'Metode de livrare',mon:'Luni',tue:'Marți',wed:'Miercuri',thu:'Joi',fri:'Vineri',sat:'Sâmbătă',sun:'Duminică',useMultiplePreferences:'Folosește mai multe tipuri de livrare',useMultiplePreferencesHelp:'Când e activ, această metodă folosește tipurile de livrare de mai jos în locul setărilor clasice.',selectPreferences:'Tip livrare'},general:{noAccessRaport:'Este necesara permisiunea la rapoarte!',noAccessUsers:'Doar administratorii au acces la utilizatori',contactAdmin:'Contactati administratorul',tips_department_id:'Department Id',addConversion:'Adauga Conversie',selectUnit:'Selecteaza Unitate',download:'Descarca',see:'Vezi',visualize:'Vizualizează',search:'Caută',home:'Acasă',add:'Adaugă',edit:'Editează',delete:'Șterge',remove:'Elimină',save:'Salvează',saveAndSend:'Salvează & Trimite',fillRequiredFields:'Completați câmpurile obligatorii',update:'Actualizează',cancel:'Anulează',copy:'Copiază',cancel2:'Renunță',close:'Închide',continue:'Continuă',activate:'Activează',deactivate:'Dezactivează',active:'Activ',inactive:'Inactiv',specialPrice:'Preț Special',removePhoto:'Prea multe imagini încărcate',yes:'Da',no:'Nu',success:'Succes',required:'Necesar',back:'Înapoi',next:'Următorul',finish:'Finalizează',download_xls:'exportă in xls',download_pdf:'exportă in pdf',detail:'Amănunt',duplicate:'Duplică',select:'Selectează',all:'Toate',alls:'Toți',reset:'Resetează',export:'Exportă',loadMore:'Încarcă mai mult',viewDetails:'Vezi Detalii',details:'Detalii',showing:'{length} rezultate afișate',action:'Acțiune',enable:'activezi',disable:'dezactivezi',product:'produsul',logout:'Deconectare',from:'de la ',to:'pana la ',cancelCourier:'Anulează curier',agree:'De accord',agreePopupMessage:'Pentru a permite browserului să redea sunete, trebuie să faceți clic pe butonul „De acord”. Aceasta va reda un sunet de test pentru a activa redarea sunetului in browser.',orderLocaionNoDriverLocation:'Atentie! Locatia comenzi nu corespunde cu locatia soferului',day:'ziua',notCompleted:'necompletat',saveChanges:'Salvează schimbările',doYouWantToLogout:'Vrei sa te deconectezi?',minutes:'minute',hour:'ora',hours:'ore',deliveryMethod:'Metode Livrare',customSort:'Compania folosește sortarea custom',none:'Niciunul',unset:'Nesetat',included:'Inclus',error:'Eroare',logo:'Logo',appImage:'Imagine aplicație',copyToClipboard:'Copiază',copyUrlToClipboard:'Copiază URL',start:'Începe',actions:'Acțiuni',leavePageQuestion:'Modificările nesalvate se vor pierde. Ești sigur că dorești să părăsești pagina?',sortOrder:'Sortează',sortCreatedAscending:'Comandă plasată: cele mai vechi primele',sortCreatedDescending:'Comandă plasată: cele mai noi primele',sortPickupAscending:'Livrare așteptată: cele mai devreme primele',sortPickupDescending:'Livrare așteptată: cele mai târzii primele',wallet:'Încarcă bani',walletRemove:'Descarcă portofel',walletAdd:'Adaugă sumă în portofel',walletAddFor:'Adaugă suma pentru',walletRemoveFor:'Șterge suma pentru',walletPlaceholder:'Introdu suma:',walletSuccess:'Suma a fost adăugată în portofel!',walletRemoved:'Suma a fost ștearsă în portofel!',walletError:'A apărut o eroare la adăugarea sumei.',invalidAmount:'Te rog să introduci un număr valid',amountExceedsBalance:'Suma depășește soldul actual al portofelului',changeOrderLocationSuccess:'Locația a fost actualizată cu succes!',changeOrderLocationFailed:'Nu s-a putut actualiza locația. Vă rugăm să încercați din nou.',generalAreYouSure:'Sunteți sigur?',generalLoader:'Se încarcă, vă rugăm așteptați...',no_data:'Nu s-au găsit date',set:'Setează',regenerateQr:'Regenerare cod QR',noProduct:'Nu sunt produse',noProductPos:'Selectați un element din meniu pentru a începe.',applyPoints:'Folosește punctele',loyaltyPoints:'Puncte de loialitate:',apply:'Aplică',load:'Încarcă',reload:'Reîncarcă',retry:'Reîncearcă',normal:'Normal',big:'Mare',registrationDate:'Dată înregistrare',accept:'Aprobă',deny:'Refuză',accepted:'Acceptat',denied:'Refuzat',pending:'În așteptare',completed:'Finalizat',contactSuportFeature:'Contactați suportul pentru această funcționalitate',administration:'Gestiune',noAdministrationsAvailable:'Nu s-au găsit gestiuni',setAdministration:'Apasă pe "Adaugă" pentru a seta o gestiune',loading:'Vă rugăm așteptați',justMoment:'Doar un moment...',orderId:'ID Comandă',year:'An',month:'Lună',segment:'Segment Curent',selectAll:'Selectează tot',deselectAll:'Anulează selecția',confirm:'Confirmă',ok:'OK',validate:'Validează',noResults:'Nu există rezultate.',clearSelection:'Șterge selecția',associateTables:'Asociază mese',associateChooseUsers:'1) Alege utilizatori',associateChooseTables:'2) Alege mese',selected:'Selectați',emDash:'\u2014',idHash:'#{id}',breadcrumbSeparator:' \xBB ',statusUnknown:'Status necunoscut',modulesActivate:'Module activate',ecosystem:'ECOSISTEMUL TAPTASTY',ecosystem_more_than_you_use:'Taptasty este mai mult decât folosești acum.',how_much_you_use:'Cât folosești tu',only_this_much_you_use:'Doar atât folosești?',you_use_full_system:'Folosești tot sistemul',all_taptasty_modules:'Toate modulele TapTasty',modules_reservations:'Rezervări',modules_tables:'Mese',modules_dispatch:'Dispecerat',modules_kds:'KDS',modules_pms:'PMS',modules_catalog:'Catalog',modules_screens:'Ecrane',modules_pos:'POS',modules_inventory:'Gestiune',modules_clients:'Clienți',modules_orders:'Comenzi',modules_add_order:'Adaugă comandă',modules_marketing:'Marketing',modules_marketing_gift:'Card cadou',modules_kiosk:'Kiosk',modules_qr_ordering:'Comandă QR',modules_website:'Website',modules_app:'App',modules_active:'Module active',modules_inactive_hint:'Ți-ai dori să folosești?',modules_website_title:'Modul Website',modules_website_message:'Modulul Website nu este activat pentru această companie.',modules_website_hint:'Activează-l din setările companiei.',modules_marketing_title:'Modul Marketing este dezactivat',modules_marketing_message:'Acest modul nu este inclus în planul tău actual sau nu este activat pentru companie.',modules_marketing_hint:'Contactează administratorul sau upgradează planul pentru a activa funcționalitățile de marketing.',modules_gift_card_title:'Modul Gift Card este dezactivat',modules_gift_card_message:'Acest modul nu este activat pentru compania ta sau nu este inclus în planul actual.',modules_gift_card_hint:'Contactează administratorul sau activează modulul Gift Card pentru a continua.'},pos:{default_interval_raport:'Selecteaza intervalul rapoartelor',default_intervals_raport0:'00:00 la 23:59',default_intervals_raport1:'de la ultimul Z',default_intervals_raport2:'05:00 la 05:00'},giftCard:{errorTotalNumberMax:'Numărul total nu poate fi mai mare de 10000',errorExpirationTimeMax:'Timpul de expirare nu poate fi mai mare de 700',addgift:'+ Adaugă Bază Card Cadou',value:'Valoare',exp:'Expirare (luni)',type:'Tip',generatedCards:'Carduri Generate',active:'Activ',online:'ONLINE',offline:'OFFLINE',yes:'Da',no:'Nu',modalTitle:'Adaugă Bază Card Cadou',typeLabel:'Tip',selectType:'Selectează tipul',valueLabel:'Valoare',expLabel:'Timp Expirare (luni)',totalCards:'Total Carduri (Offline)',cancel:'Anulează',save:'Salvează',errorTitle:'Eroare!',errorRequired:'Tipul și Valoarea sunt obligatorii.',errorOffline:'Total carduri obligatoriu pentru OFFLINE.',successTitle:'Succes!',successMessage:'Baza Card Cadou a fost creată.',errorCreate:'Eroare la crearea bazei.',ok:'OK',baseTitle:'Bază Card Cadou',inactive:'Inactiv',fromDate:'De la',toDate:'Până la',cardsListTitle:'Listă Carduri Cadou',allStatus:'Toate Statusurile',used:'Folosit',unused:'Nefolosit',allPayments:'Toate Plățile',payed:'Plătit',unpayed:'Neplătit',export:'Export',qr:'QR',status:'Status',payment:'Plată',assignedTo:'Atribuit Către',created:'Creat',copyLink:'Copiază Link',notAssigned:'Neatribuit',showingRecords:'Se afișează {from} până la {to} din {total} înregistrări',confirmDeleteTitle:'Ești sigur?',confirmDeleteText:'Toate cardurile nefolosite vor fi șterse de asemenea!',yesButton:'Da',noButton:'Nu',deleteSuccess:'Baza de carduri cadou a fost ștearsă cu succes',deleteError:'Eroare la ștergerea bazei de carduri cadou',linkCopied:'Link copiat în clipboard!',updateSuccess:'Actualizat cu succes',updateError:'Eroare la actualizare',notAvailable:'N/A',user:'Utilizator'},txtForColors:{sideBarBg:{title:'Fundal bara laterala',msg:'Schimba culoarea fundalului la bara laterala'},mainPageBg:{title:'Fundal continut meniu',msg:'Schimba culoarea fundalului la continutul meniului'},addBtnColor:{title:'Fundal culoarea butoane principale',msg:'Schimba culoarea fundalului la butoanele principale'},addBtnColorInv:{title:'Fundal texte butoane principale',msg:'Schimba fundal textelor la butoanele principale'},iconsColor1:{title:'Culoare fundal iconite/butoane',msg:'Schimba culoarea fundalului la toate iconitele si butoaneele'},iconsColor2:{title:'Fundal texte',msg:'Schimba culoarea fundalului la unele textele'},secundarColor:{title:'Pagina de start',msg:'Schimba culoarea fundalului cand kiosskul este in asteptare'},principalColor:{title:'Culoarea Principala',msg:'Culoare principala a fundalului si a instrumentelor'}},stock:{saving:'Saving...',saveStocks:'Save Stocks',title:'Stock Configuration',subtitle:'Set stock for each product per location',searchByName:'Search by name',productNamePlaceholder:'Product name...',searchById:'Search by ID',productIdPlaceholder:'Product ID...',allCategories:'All categories',resetFilters:'Reset filters',loadingProducts:'Loading products...',product:'Product',idLabel:'ID: {id}',currency:'RON',notAvailable:'Not available',active:'Active',stock:'Stock',stockPlaceholder:'0',reservation:'Reservation (pcs)',reservationPlaceholder:'0',reservationError:'Reservation cannot exceed stock',allowNegative:'Allow Negative',activateForSources:'Activate for sources:',pos:'POS',app:'App',website:'Website',qr:'QR',kiosk:'Kiosk',page:'Page {page} of {totalPages}',productsCount:'({totalRecords} products)',previous:'Previous',next:'Next',noProductsAvailable:'No products available',stocksSavedSuccess:'Stocks saved successfully!'},pricesFor:{1:'Preț Website',2:'Preț QR',3:'Preț Kiosk',4:'Preț POS',5:'Preț GLOVO',6:'Preț BOLT',7:'Preț Wolt'},dispath:{reset_map:'Reinițializează harta',dispatch:'Dispecerat',drivers:'Șoferi',driverID:'Sofer ID',driverName:'Nume sofer',value:'Valoare',from:'De la',totalActive:'Total activi',totalInactive:'Total inactivi',orders:'Comenzi',reports:'Rapoarte',walletReport:'Portofel',programReport:'Pontaj',activityReport:'Timp activ',mapReport:'Map',selectDriver:'Selectează livratori',addGroupOrder:'Batch de comenzi',unassigned:'Nealocate',batched:'Lot',grouped:'Grupate',posibleGrouped:'Grupuri posibile',sugestion:'Sugestie',createOrderGroupSuccess:'Grupul de comenzi a fost creat cu succes.',createOrderGroupError:'Nu s-a putut crea grupul de comenzi',addOrderGroupPosibileSuccess:'Comanda a fost adăugată la grup.',addOrderGroupPosibileError:'Nu s-a putut adăuga comanda în grup.',assign:'Asignat',legend:'Legenda',driverWithOrder:'Sofer cu comanda',driverWithoutOrder:'Șofer fără comanda',movementDirection:'Direcția de mișcare',stopWithDelivery:'Oprit cu livrare',stopWithoutDelivery:'Oprit fără livrare',general:'General',users:'Utilizatori',dispatchers:'Dispeceri',walletSettings:'Portofel plata cash / Plata la comanda',disableUndeliveredOrder:'Dezactiveaza Comanda nelivrata',downloadApp:'Descarca aplicatia de livrator',settings:'Setări',addNewOrder:'Adauga Comanda',zone:'Zone'},kds:{importTitle:'Setează secția selectată pe toate produsele din categoria selectată',section:'Secție',status:'Status',location:'Locație',name:'Nume',deliveryMethods:'Metode de livrare',noData:'Apăsați +Adaugă pentru un status nou',areYouSureDelete:'Sigur dorești să ștergi aceast KDS?',kds:'KDS',kitchenDisplayScreen:'Ecran de bucătărie',kdsSections:'Secții KDS',settings:'Setări',general:'General',useStartTimerForAllItems:'Permite pornirea cronometrului pe toată comanda',startTimer:'Pornește cronometrul',orderAveragePrepTime:'Timp mediu de preparare',users:'Utilizatori',sections:'Secții',ods:'ODS',report:'Raport',orderDisplayScreen:'Ecran de comandă',kdsCode:'Cod Kds',loginCode:'Login Code (cod unic din 4 cifre)',loginCodeNotUnique:'Codul nu este unic',useOrderLanes:'Afișare comenzi pe 2 coloane (Sala / Livrare)',lane_1_color:'Culoare de fundal pentru comenzi pe sala',lane_2_color:'Culoare de fundal pentru comenzi livrare',allowOptionTimer:'Permite pornirea cronometrului pe opțiuni',allowOptionTimerInfo:'Necesită setarea secților pe opțiuni',allowCourseTimer:'Permite pornirea cronometrului pe feluri',timeProcessingStatus:'Cronometreaza timpul petrecut in processing',displayStartedOrdersFirst:'Afișează comenzile pornite primele',groupProductsByCategory:'Grupează produsele după categorie',hidePreparedItems:'Ascunde produsele preparate',displayWaiterName:'Afișează numele ospătarului',displayDeliveryTime:'Afișează ora de livrare',useAutoCloseOrders:'Închide comanda automat când ultimul articol este preparat',useAutoCloseOrdersInfo:'Când această setare este dezactivată, KDS central trebuie să închidă comanda',autoPrint:'Printează automat',displayOrdersGrid:'Afișează comenzile in grid',displayOrdersMode:'Mod afișare comenzi',displayOrdersModeVertical:'Vertical',displayOrdersModeOscilloscopic:'Osciloscopic',displayOrdersModeHorizontal:'Orizontal',ordersSortColumn:'Sortare comenzi după',ordersSortColumnPickup:'Ora ridicare comandă',ordersSortColumnCreated:'Ora plasare comandă',productSorting:'Sortare produse',productSortingChronologic:'Cronologic',productSortingPrepTime:'Timp preparare',notificationSound:'Sunet notificare',sound1:'Sunet 1',sound2:'Sunet 2',sound3:'Sunet 3',playSound:'Redă'},printer:{title:'Imprimantă',subtitle:'Configurează setările imprimantei',deleteConfirm:'Sigur vrei să ștergi această imprimantă?',sectionGeneral:'Informații generale',sectionType:'Setări tip',sectionConnectivity:'Conectivitate',sectionVersion:'Versiune și tip conexiune',sectionOptions:'Opțiuni și integrări',location:'Locație',section:'Secție',printerReceipt:'Imprimantă notă de plată',printOptions:'Imprimă opțiunile produselor',printProductClientComments:'Imprimă comentariile clienților pe produse',printHotelFields:'Imprimă câmpuri hotel',mergeItems:'Grupează produsele',groupItemsByCategoryOnReceipt:'Grupează produsele pe categorii pe bon',correspondingPos:'POS-uri asociate',fontSize:'Mărime font',paymentMethodsPrintTwice:'Printează de două ori bonul pentru următoarele metode de plată',none:'Niciuna',printAddress:'Printează adresa',hideSingleOptionQty:'Ascunde cantitatea 1 la opțiuni',displayPricesAndTotals:'Afișează prețurile și totalurile',orderLabelPrintMode:'Imprimare etichete comandă',orderLabelGrouped:'Imprimare ca până acum (primele 7 rânduri, apoi câte 13 pe etichetă)',orderLabelPerProduct:'Câte o etichetă pentru fiecare produs',orderLabelPerProductHint:'Pentru a imprima un produs, activează opțiunea „Imprimă pe etichetele comenzii” din Catalog produse > Etichetă.',isLan:'Este LAN',printerIpHost:'IP/Host imprimantă',printerPortName:'Port imprimantă'},invoice:{number:'Număr',vatPercent:'Cotă TVA',storno:'Storno',proforma:'Proforma',addProforma:'Adaugă Proformă',invoiced:'Factureaza',addSeries:'Adaugă serie',type:'Tip',invoices:'Facturi',invoiceSupplier:'Facturi furnizor',reports:'Rapoarte',settings:'Setări',addInvoice:'Adaugă factura',invoice:'Factura',client:'Client',clientName:'Nume Client',clientCUI:'CUI',clientEmail:'Email',clientPhone:'Telefon',clientAddress:'Adresă',clientCountry:'Țară',clientCounty:'Județ',selectCounty:'Selectează județul',clientCity:'Oraș',clientSector:'Sector',selectSector:'Selectează sectorul',clientStreet:'Stradă',clientStreetNumber:'Nr.',clientPostalCode:'Cod poștal',issueDate:'Data Emiterii',dueDate:'Termen de Plată',seriesNumber:'Serie și Număr',series:'Serie',seriesDocument:'Serii Documente',currency:'Monedă',language:'Limbă',valueNoVAT:'Val. fără TVA',vatValue:'Valoare TVA',lineExtensionAmount:'Valoare linie',totalValue:'Total',status:'Status',spvStatus:'Status SPV',spvStatusNotSent:'Netrimis',spvStatusSent:'Trimis',spvStatusError:'Eroare',spvStatusPending:'În procesare',spvUploadIndex:'ID încărcare',invoiceDetails:'Detalii Factura',supplierDetails:'Detalii furnizor',clientDetails:'Detalii client',proformaDetails:'Detalii Proforma',otherDetails:'Alte Detalii',productName:'Denumire produs/serviciu',unitMeasure:'UM',quantity:'Cantitate',priceRON:'Preț (RON)',vatRate:'Cota TVA',includeVAT:'Prețul include TVA?',yes:'Da',no:'Nu',download:'Descarca PDF',filter:'Filtru',startNumber:'Număr de start',endNumber:'Număr de sfârșit',seriesName:'Nume serie',selectSeries:'Selectează seria',vatPayer:'Plătitor TVA',legalStatus:'Statut Legal',statusLegal:{fizica:'Persoană Fizică',juridicaRo:'Persoană Juridică Română',juridicaEu:'Persoană Juridică Europa'}},gestiune:{autoActive:'Asigneaza automat',city:'Oras',countries:'Tara',taxRate:'Cota TVA',customer:'Client',fetchInvoice:'Preia facturi E-Factura',changeProduct:'Schimbă produs gestiune',searchProduct:'Caută produs...',productManagement:'Legături produs gestiune',prodLoading:'Se încarcă produsul...',noGestion:'Nu există legătură',change:'Change',removeLink:'Sterge Legatura (nu se vor face vanzari daca produsul asta apare)',sendToSPV:'Trimite in SPV',salesMarkup:'Vanzari Adaos',checkSpvStatus:'Verificare status in SPV',downloadEfacturaXml:'Descarcă XML SPV',viewSpvPdf:'Vezi PDF SPV',fetchSpvMessages:'Preia mesaje SPV',downloadSpvMessage:'Descarcă',viewSpvMessage:'Vezi mesaj SPV',fetchInvoiceDaysLabel:'Pe câte zile?',fetchInvoiceDaysInvalid:'Selectați un număr valid de zile.',purchase:'Achiziție',codContabil:'Cod contabil',analitic:'Analitic',identificationCode:'Cod de identificare',addInvoiceSupplier:'Adauga factura furnizor',productMix:'Product Mix',casare:'Pierdere',category:'Categorie',categoriesSettings:'Categorii / Conturi',addCasare:'Adaugă Pierdere',downloadExcel:'Descarca XLS',activeProducts:'Activeaza produs',number:'Numar',validity:'Valabilitate',stocLaZi:'Stoc la zi',reportStock:'Fisa magazie',reportInventory:'Intrari–iesiri stocuri',copyProduct:'Copiază produs',addProductInCasare:'Adaugă produs(e) în casare',addProductInInvoice:'Adaugă produs(e) în factura',addProductInProforma:'Adaugă produs(e) în proforma',addProductInAviz:'Adaugă produs(e) în aviz',addProductInNir:'Adaugă produs(e) în notă intrare recepție',addProductInBonConsum:'Adaugă produs(e) în bon de consum',addProductInBonTransfer:'Adaugă produs(e) în nota de transfer',addProductInBonProductie:'Adaugă produs(e) în bon de producție',addProductInOrder:'Adaugă produs(e) în comandă',addBonProduction:'Adaugă bon de producție',addInitialStock:'Adaugă stoc inițial',initialStock:'Stoc Inițial',operations:'Operatiuni generale',orderErrors:'Erori trimitere comenzi',integrations:'Integrări',integrationsIntegration:'Integrare',integrationsLocation:'Locație',integrationsConfig:'Config (doar citire)',integrationsData:'Câmpuri integrare',integrationsJsonHint:'Hint: poți lipi JSON aici (array/obiect).',integrationsUpdateById:'Update după id (POST /integrations/upsert)',integrationsPutById:'Update după id (PUT /integrations/{id})',integrationsNoteTitle:'Cum funcționează',integrationsNoteBody:'Selectează integrarea, opțional locația, apoi Caută. Rezultatele apar ca tabel; deschide un rând pentru editare. Salvare creează sau actualizează rândul.',integrationsAllLocations:'Toate locațiile',integrationsOptional:'opțional',integrationsOpenRow:'Deschide',integrationsBackToList:'Înapoi la listă',integrationsSelectRowHint:'Alege un rând pentru a edita integrarea sau adaugă una nouă.',integrationsSelectIntegrationHint:'Alegeți o integrare (sau Toate) și opțional o locație, apoi căutați.',integrationsEmptyTableHint:'Nu există date. Folosește butonul Adaugă de sus pentru a crea o integrare nouă.',integrationsDeleteConfirm:'Sigur doriți să ștergeți această integrare?',integrationsDeleteSuccess:'Integrarea a fost ștearsă cu succes.',integrationsDeleteError:'Integrarea nu a putut fi ștearsă. Încearcă din nou.',integrationsLocationOccupied:'integrare existentă',integrationsCreateSuccess:'Integrarea a fost creată cu succes.',integrationsUpdateSuccess:'Integrarea a fost actualizată cu succes.',integrationsSaveError:'Integrarea nu a putut fi salvată. Încearcă din nou.',integrationsMenuActivateConfirm:'Se va salva integrarea, se va valida și trimite meniul, apoi se va activa locația. Continuați?',integrationsMenuActivateStepValidateMenu:'Validare meniu',integrationsMenuActivateStepDeactivateLocation:'Dezactivare locație',integrationsMenuActivateStepPushMenu:'Trimitere meniu',integrationsMenuActivateStepCheckExportStatus:'Așteptare finalizare export meniu',integrationsMenuActivateStepActivateLocation:'Activare locație',integrationsActivateConfirm:'Sigur că datele de autentificare, adresa locației și coordonatele sunt corecte?',integrationsActivateProgressStay:'Vă rugăm să rămâneți pe acest ecran până la finalizarea activării.',integrationsActivateStepSave:'Salvare integrare nouă',integrationsActivateStepTest:'Testare credențiale',integrationsActivateStepWebhook:'Înregistrare webhook',integrationsActivateTitle:'Activare',integrationsValidateConfirm:'Sigur că datele de autentificare, adresa locației și coordonatele sunt corecte?',integrationsValidateProgressStay:'Vă rugăm să rămâneți pe acest ecran până la finalizarea validării.',integrationsValidateStepSave:'Actualizare integrare',integrationsValidateStepTest:'Testare credențiale',integrationsValidateStepWebhook:'Înregistrare webhook',integrationsValidateTitle:'Validare',integrationsWebhookStatusLabel:'Webhook',integrationsWebhookRegistered:'Înregistrat',integrationsWebhookNotRegistered:'Neînregistrat',integrationsWebhookRegisterHint:'Apăsați Validează pentru a înregistra webhook-ul.',integrationsWebhookRegisterError:'Webhook-ul nu a putut fi înregistrat. Încercați din nou.',integrationsCredentialsTestError:'Testarea credențialelor a eșuat.',integrationsCredentialsTestRetryHint:'După remedierea problemelor, puteți testa din nou folosind butonul Validează.',integrationsCredentialErrorCodes:{glovo_laas_missing_api_url:'URL-ul API Glovo nu este setat.',glovo_laas_missing_client_id:'ID Client lipsește.',glovo_laas_missing_client_secret:'Client secret lipsește.',glovo_laas_missing_location_id:'Nicio locație nu este asociată.',wolt_drive_missing_api_url:'URL-ul API Wolt Drive nu este setat.',wolt_drive_missing_client_id:'ID Client lipsește.',wolt_drive_missing_client_secret:'Client secret lipsește.',wolt_drive_missing_access_token:'Token-ul de acces lipsește.',wolt_drive_missing_merchant_id:'ID Merchant lipsește.',wolt_drive_missing_venue_id:'ID Venue lipsește.',wolt_drive_missing_location_id:'Nicio locație nu este asociată.',delivery_hero_missing_api_url:'URL-ul API Delivery Hero nu este setat.',delivery_hero_missing_client_id:'ID Client lipsește.',delivery_hero_missing_key_id:'Key ID lipsește.',delivery_hero_missing_scope:'Scope lipsește.',delivery_hero_missing_private_key:'Cheia privată lipsește. Salvați integrarea pentru a genera cheile.',delivery_hero_missing_location_id:'Nicio locație nu este asociată.',laas_location_not_found:'ID-ul locației selectate este invalid.',laas_location_missing_address:'Locației îi lipsesc orașul, strada sau numărul.',laas_location_missing_coordinates:'Locației îi lipsesc latitudinea sau longitudinea.',laas_location_missing_phone:'Locației îi lipsește numărul de telefon.',laas_no_user_email:'Nu există un utilizator al companiei cu adresă de email.',laas_invalid_credentials:'Credențiale invalide (401 / invalid token de la partener).',laas_call_courier_failed:'Programarea curierului de test a eșuat.',laas_cancel_courier_failed:'Anularea curierului de test a eșuat.',laas_no_partner_response:'Nu s-a primit răspuns de la API-ul partenerului.',wolt_drive_reference_not_found:'Referința Wolt lipsește după creare.'},integrationsGlovoLaasSetupTitle:'Finalizați acești pași înainte de a crea integrarea:',integrationsGlovoLaasSetupStep1:'Obțineți ID Client și ID Secret de la',integrationsGlovoLaasSetupStep2:'Creați un brand la',integrationsDeliveryHeroSetupTitle:'Finalizați acești pași pentru onboarding Delivery Hero ODR:',integrationsDeliveryHeroSetupStep1:'Selectați locația și URL-ul API, apoi Salvați — generăm pe server o pereche de chei RSA PKCS#8.',integrationsDeliveryHeroSetupStep2:'Descărcați cheia publică .pub și trimiteți-o către Delivery Hero pentru a primi Key ID.',integrationsDeliveryHeroSetupStep3:'Introduceți Client ID, Key ID și Scope primite de la Delivery Hero.',integrationsDeliveryHeroSetupStep4:'Apăsați Validează pentru a testa credențialele, apoi înregistrați URL-urile de callback la Delivery Hero ops.',integrationsDeliveryHeroKeysTitle:'Chei RSA',integrationsDeliveryHeroKeysPending:'Salvați integrarea pentru a genera perechea de chei publică/privată.',integrationsDeliveryHeroCopyPublicKey:'Copiază cheia publică',integrationsDeliveryHeroDownloadPublicKey:'Descarcă .pub',integrationsDeliveryHeroRegenerateKeys:'Regenerează cheile',integrationsDeliveryHeroRegenerateKeysConfirm:'Regenerarea cheilor invalidează cheia publică anterioară. Trebuie să trimiteți noul fișier .pub către Delivery Hero. Continuați?',integrationsDeliveryHeroRegenerateKeysSuccess:'Noua pereche de chei RSA a fost generată.',integrationsDeliveryHeroCredentialsTitle:'Credențiale de la Delivery Hero',integrationsDeliveryHeroCredentialsHint:'Completați aceste câmpuri după ce Delivery Hero returnează Key ID pentru cheia publică trimisă.',integrationsDeliveryHeroScopePlaceholder:'ex: pandago.api.ro.*',integrationsDeliveryHeroPublicKeyHint:'Trimiteți această cheie publică (.pub) către Delivery Hero pentru a primi Key ID. Cheia privată rămâne pe server (PKCS#8, 2048 biți).',integrationsDeliveryHeroCallbacksTitle:'URL-uri callback (de înregistrat la Delivery Hero)',integrationsDeliveryHeroStatusCallback:'URL callback status',integrationsDeliveryHeroRefundCallback:'URL callback refund',integrationsDeliveryHeroCallbacksHint:'Aceste URL-uri sunt fixe pentru compania dvs. Furnizați-le către Delivery Hero ops la onboarding.',integrationsActionsTitle:'Acțiuni',integrationsSyncMenu:'Sincronizează meniul',integrationsMenuUploadCampaignsHint:'Încărcarea meniului va șterge campaniile de pe platformă.',integrationsGlovoMenuSyncDailyLimitHint:'Platforma Glovo nu permite mai mult de 5 sincronizări de meniu pe zi.',integrationsActionError:'Acțiunea a eșuat. Încearcă din nou.',integrationsPlatformErrors:{unauthorized:'Platforma a respins cererea deoarece credențialele sunt invalide sau expirate.',unauthorized_bolt:'Bolt a respins cererea (401). Verificați {secretKey}, {integratorId} și {providerId} în setările integrării.',unauthorized_glovo:'Glovo a respins cererea (401). Verificați {apiKey} și {storeId} în setările integrării.',unauthorized_wolt:'Wolt a respins cererea (401). Verificați {apiKey}, {clientId} și {venueId}, apoi încercați din nou.',forbidden:'Platforma a refuzat această acțiune. Contul poate să nu aibă permisiunea pentru această locație.',forbidden_bolt:'Bolt a refuzat acțiunea. Verificați că {providerId} corespunde magazinului configurat în Bolt.',forbidden_glovo:'Glovo a refuzat acțiunea. Verificați {storeId} și că magazinul este legat de contul dvs.',forbidden_wolt:'Wolt a refuzat acțiunea. Verificați {venueId} și că locația este legată de contul dvs.',not_found:'Platforma nu a găsit magazinul sau locația. Verificați identificatorii din integrare.',not_found_bolt:'Bolt nu a găsit acest provider. Verificați {providerId} și {apiUrl}.',not_found_glovo:'Glovo nu a găsit acest magazin. Verificați {storeId} și {apiUrl}.',not_found_wolt:'Wolt nu a găsit această locație. Verificați {venueId} și {apiUrl}.',rate_limited:'Platforma limitează temporar numărul de cereri. Așteptați câteva minute și încercați din nou.',network:'Nu s-a putut contacta platforma. Verificați conexiunea la internet și încercați din nou.',unavailable:'Platforma este temporar indisponibilă. Încercați din nou mai târziu.',toggleLocation_failed:'Nu s-a putut actualiza pe platformă dacă locația acceptă comenzi.',pushMenu_failed:'Nu s-a putut publica meniul pe platformă.',syncSchedule_failed:'Nu s-a putut sincroniza programul de lucru cu platforma.',generic_failed:'Acțiunea pe platformă a eșuat. Încercați din nou.'},integrationsMenuTopCategoriesPlaceholder:'Toate categoriile de top',integrationsMenuTopCategoriesHint:'Lasă gol pentru a exporta meniul complet.',integrationsMenuTopCategoriesExportNote:'Filtrarea se aplică la următorul export de meniu.',integrationsGlovoValidateMenu:'Validează meniul',integrationsGlovoPushMenu:'Trimite meniul',integrationsValidateAndPushMenu:'Validează și trimite meniul',integrationsMenuPreviewOpen:'Deschide meniul',integrationsMenuPreviewLoading:'Se încarcă meniul…',integrationsMenuPreviewOrder:'Comandă',integrationsMenuPreviewAdd:'Adaugă',integrationsMenuPreviewAddFor:'Adaugă {qty} pentru {price}',integrationsMenuPreviewRequiredShort:'Necesar',integrationsMenuPreviewChooseOne:'Alege 1 articol',integrationsMenuPreviewTitle:'Previzualizare meniu {platform}',integrationsMenuPreviewSubtitle:'Răsfoiți categoriile, produsele și opțiunile așa cum vor apărea pe platformă.',integrationsMenuPreviewImport:'Importă',integrationsMenuPreviewImporting:'Se importă…',integrationsMenuPreviewSearchPlaceholder:'Caută produse, opțiuni, id-uri…',integrationsMenuPreviewSearchEmpty:'Niciun produs nu corespunde căutării.',integrationsMenuPreviewSearchClear:'Șterge',integrationsMenuPreviewImportConfirmTitle:'Importați meniul?',integrationsMenuPreviewImportConfirmText:'Meniu va fi validat și trimis pe platformă.',integrationsMenuPreviewBack:'Înapoi la meniu',integrationsMenuPreviewOutOfStock:'Stoc epuizat',integrationsMenuPreviewOptionRequired:'Obligatoriu',integrationsMenuPreviewOptionOptional:'Opțional',integrationsMenuPreviewOptionRange:'Alegeți {min}–{max}',integrationsGlovoCheckStatus:'Verifică status export',integrationsGlovoExportsToday:'Exporturi azi',integrationsGlovoLastExport:'Ultimul export',integrationsGlovoExportStatus:'Status',integrationsGlovoNoExport:'Niciun export încă',integrationsGlovoExportPending:'În așteptare — verifică statusul',integrationsGlovoExportInProgress:'În curs',integrationsGlovoExportSuccess:'Reușit',integrationsGlovoExportFailed:'Eșuat',integrationsGlovoValidationResult:'Rezultat validare',integrationsGlovoStatusResult:'Status export',integrationsGlovoValidateSuccess:'Validarea meniului s-a finalizat.',integrationsGlovoValidateSuccessTitle:'Validare meniu',integrationsGlovoValidationFailedTitle:'Validarea meniului a eșuat',integrationsGlovoShowMore:'Arată mai mult',integrationsGlovoShowLess:'Arată mai puțin',integrationsGlovoValidationErrors:'Erori',integrationsGlovoValidationWarnings:'Avertismente',integrationsMenuValidationExpandHint:'Deschideți detaliile de mai jos pentru a vedea categoriile, produsele și opțiunile afectate.',integrationsMenuValidationEditEntity:'Editează',integrationsMenuValidationEditEntityHint:'Se deschide într-un tab nou',integrationsMenuValidationTryAgain:'Încearcă din nou',integrationsMenuValidationProceedAnyway:'Continuă oricum',integrationsMenuValidationProceedAnywayHint:'Validarea a raportat probleme. Dacă sunt rezultate fals pozitive, puteți continua exportul meniului.',integrationsMenuValidationProceedingAnyway:'Se continuă exportul în ciuda problemelor de validare.',integrationsMenuValidationEditPageHint:'După salvare, închideți acest tab și încercați din nou.',integrationsMenuValidationErrorCodes:{CATEGORY_EMPTY:'Categorii fără produse exportabile',PRODUCT_INVALID_PRICE:'Produse cu preț zero sau negativ',OPTION_MISSING_VALUES:'Opțiuni cu valori lipsă',OPTION_INVALID_MIN:'Opțiuni cu selecție minimă invalidă',MENU_EMPTY:'Meniul este gol',MENU_NO_MATCHING_CATEGORIES:'Nicio categorie nu corespunde filtrului de meniu selectat'},integrationsMenuValidationItemCategory:'Categorie',integrationsMenuValidationItemProduct:'Produs',integrationsMenuValidationItemOption:'Opțiune',integrationsMenuValidationCategoriesEmpty:'Categorii fără produse exportabile',integrationsMenuValidationProductsInvalidPrice:'Produse cu preț invalid',integrationsMenuValidationOptionsMissingValues:'Opțiuni cu valori lipsă',integrationsMenuValidationOptionsInvalidMin:'Opțiuni cu minim invalid',integrationsGlovoCheckStatusDisabledHint:'Trimite mai întâi meniul sau deschide o integrare care are deja un export.',integrationsGlovoStatusUpdated:'Statusul exportului a fost actualizat.',integrationsGlovoPushAccepted:'Trimiterea meniului a fost acceptată de Glovo.',integrationsGlovoMenuEmpty:'Nu există produse de exportat.',integrationsGlovoActivateTitle:'Activare',integrationsGlovoActivateConfirm:'Se va salva integrarea, se va valida și trimite meniul către Glovo, apoi se va activa locația. Continuați?',integrationsGlovoActivateProgressStay:'Vă rugăm să rămâneți pe acest ecran până la finalizarea activării.',integrationsGlovoActivateStepSave:'Salvare integrare nouă',integrationsGlovoActivateStepValidateMenu:'Validare meniu',integrationsGlovoActivateStepDeactivateLocation:'Dezactivare locație Glovo',integrationsGlovoActivateStepPushMenu:'Trimitere meniu către Glovo',integrationsGlovoActivateStepCheckExportStatus:'Așteptare finalizare export meniu',integrationsGlovoActivateStepActivateLocation:'Activare locație Glovo',integrationsGlovoActivateExportTimeout:'Exportul meniului este încă în curs după câteva minute.',integrationsGlovoActivateExportFailedHint:'Verificați erorile de export de mai sus, remediați meniul, apoi folosiți Trimite meniul și Verifică status export din Acțiuni.',integrationsGlovoActivateValidationFailedHint:'Remediați problemele de meniu de mai sus, apoi încercați din nou Activare.',integrationsGlovoActivateMenuEmptyHint:'Adăugați produse în meniul acestei locații, apoi încercați din nou Activare.',integrationsGlovoActivatePushFailedHint:'Remediați problema de mai sus, apoi încercați din nou Activare.',integrationsGlovoActivateNoTransactionId:'Glovo nu a returnat un ID de tranzacție pentru export. Încercați Trimite meniul din Acțiuni.',integrationsSyncSchedule:'Sincronizează orarul',integrationsColActive:'Activ',integrationsColActions:'Acțiuni',integrationsColIsMenuLocation:'Locație meniu',integrationsColIsUsingPricelist:'Locație meniu și comenzi',integrationsFields:{id:'ID',location_id:'Locație',orders_location_id:'Locație comenzi',active:'Activ',api_url:'URL API',api_key:'Cheie API',client_id:'ID Client',client_secret:'Secret client',venue_id:'ID Venue',is_integrated:'Integrat',is_using_pricelist:'Locație meniu și comenzi',is_auto_accept:'Acceptă automat comenzile',platform_status_polling_enabled:'Monitorizează disponibilitatea pe platformă',schedule:'Program',is_menu_location:'Locație meniu',created_at:'Creat la',updated_at:'Modificat la',access_token:'Token acces',merchant_id:'ID Merchant',auto_send_at_status:'Trimite automat la status',auto_send_time:'Timp trimitere automată',order_total_handshake:'Cod obligatoriu pentru comenzi peste',feedback_emails:'Email-uri feedback',integrator_id:'ID Integrator',provider_id:'ID Provider',secret_key:'Cheie secretă',emails:'Email-uri',user:'Utilizator',password:'Parolă',menu_language:'Limba meniului',has_own_delivery:'Livrare proprie',prep_time_buffer_in_minutes:'Buffer timp pregătire (minute)',pos_implementation_name:'Nume implementare POS',brand_name:'Nume brand',brand_code:'Cod brand',store_id:'ID magazin',laas_client_id:'ID Client',laas_client_secret:'ID Secret',menu_top_categories:'Categorii de top pentru meniu',key_id:'Key ID',scope:'Scope',webhook_secret:'Secret webhook',public_key:'Cheie publică'},integrationsFeedbackEmailsHint:'Introduceți adresele de email separate prin virgulă, punct și virgulă sau pe linii noi',woltDriveAutoSendStatus_manual:'Manual',woltDriveAutoSendStatus_processing:'În procesare',woltDriveAutoSendStatus_prepared:'Pregătită',integrationsTypes:{glovo:'Glovo',glovo_laas:'Glovo LaaS',bolt:'Bolt',wolt:'Wolt',wolt_drive:'Wolt Drive',delivery_hero:'Delivery Hero',nexus:'Nexus',charisma:'Charisma',clock_pms:'Clock PMS',ebriza:'Ebriza',rkeeper:'rKeeper',rsystem:'R-System',ep_restaurant:'eP Restaurant',freya_on_premise:'Freya (on-premise)',freya_cloud:'Freya Cloud',grandchef:'GrandChef'},dataStart:'Data inceput',notaTransfer:'Nota transfer',updateStockScriptic:'Actualizeaza stoc scriptic',printInventorySheet:'Fisa inventar',saveDraft:'Salveaza ca Draft',saveAndValidate:'Salveaza si Valideaza modificarile',cost:'Cost',gestiune_descarcare:'Gestiune descarcare',noteEntries:'Nota intrare receptie',receptionOrder:'Recepție Comandă',validateOrder:'Validează Comandă',processingOrder:'Procesare Comandă',stockNameTable:'Denumire articol',stockUm:'UM',stockPrice:'Preț unitar',stockStocMinim:'Stoc minim',stockQuantity:'Stoc actual',stockValue:'Valoare stoc ',stockStatus:'Status',stockStatus1:'✅ OK',stockStatus2:'⚠️ Sub stoc minim',stockStatus3:'❗ Critic',stocksHistory:'Istoric Stocuri',nirs:'Nir',stockDate:'Data',stockDocumentId:'Nr. doc',stockDocumentType:'Tip Document',revalidated:'Salveaza si Revalideaza',stockIntrare:'Intrare',stockIesire:'Iesire',stockStocFinal:'Stock Final',stockPret:'Pret',stockValoareStoc:'Valoare stoc ',stockObservatii:'Observatii',noSeries:'Nu există serii disponibile.',noGestiuni:'Nu există gestiuni disponibile.',default:'Default gestiune vanzare',quantityScriptic:'Cantitate Scriptică',quantityFaptic:'Cantitate Faptic',procesata:'Procesată',nrProduse:'Nr. Produse',fiscalizat:'Fiscalizat',tipVanzare:'Tip Vânzare',email:'Email',process:'Procesează',invoice:'Factura',sendOrder:'Trimite comanda',reception:'Recepție',validate:'Validează',generateNir:'Generează Nir',searchClientsWithCUI:'Cauta client dupa CUI',searchClients:'Cauta client',termenValabilitate:'Termen de valabilitate',scazamant:'Scăzământ',addBonConsum:'Adaugă bon de consum',addNoteTransfer:'Adaugă notă de transfer',addClient:'Adaugă client',clientName:'Nume Client',ore:'Ore',zile:'Zile',procent:'Procent',stocScriptic:'Stoc Scriptic',stocFaptic:'Stoc Faptic',difference:'Difference',status:'Status',inventoryNumber:'Inventar #',differences:'Diferențe',note:'Notă',inventar:'Inventar',users:'Utilizatori',myOrders:'Comenzile mele',forOrders:'Comenzi primite',reports:'Rapoarte',bankAccounts:'Conturi bancare',pretPerUnitate:'Preț per unitate',costPerUnit:'Cost pe unitate',pricePerUnit:'Preț per unitate',totalCost:'Cost total',editPrice:'Editează preț',stocK:'Stoc',addOrder:'Adaugă comandă',pretVanzare:'Preț vânzare (TVA INCLUS)',stocMinim:'Stoc minim',docFurnizori:'Note intrare receptie',aviz:'Aviz',addAviz:'Adauga aviz',bonFiscal:'Bon Fiscal',sales:'Vanzari / Bonuri',outputs:'Iesiri',commandProject:'Comanda/Proiect',production:'Productie',products:'Produse',clients:'Clienti',preview:'Previzualizare',manager:'Gestionar',receiver:'Primitor',generateAvizNIR:'Generează Aviz & NIR',cantitateNecesara:'Cantitate necesară',cantitateConsumata:'Cantitate consumată',avizGestiuneaPredatoare:'Aviz (în gestiunea predatoare)',dataAviz:'Data Aviz',nirGestiuneaPrimitoare:'NIR (în gestiunea primitoare)',dataNIR:'Data NIR',internalNote:'Notă Internă',isBonProductie:'Bon de Productie',fromGestiune:'Din Gestiunea',toGestiune:'La Gestiunea',fromLocation:'Din Locația',toLocation:'La Locația',transfer:'Bon Transfer',cui:'CUI',dashboard:'Dashboard',numeGestiune:'Nume gestiune',numeGestionar:'Nume gestionar',gestiuni:'Gestiuni',categorii:'Categorii',contContabil:'Cont contabil',currentNumber:'Număr curent',codGestiune:'Cod gestiune',consumption:'Consum',addManagment:'Adaugă gestiune',tipGestiune:'Tip gestiune',cantitativValoric:'Cantitativ Valorica (Recomandat)',cantitativValoricDesc:'Produsele apar pe NIR la Cost de Achizitie. Folosita de magazine si depozite. Pentru orice tip de Produs: Marfa, Materii Prime, Materiale Consumabile..etc.',globalValoric:'Global Valorica',globalValoricDesc:'Produsele apar pe NIR la Pret de Vanzare. Folosita de magazinele mici. Doar pentru produse de tip Marfa si Ambalaje. Nu vei putea emite bonuri de consum de pe aceasta gestiune, de exemplu.',terti:'Terti',tertiDesc:'Atunci cand produsele tale sunt trimise la Terti pentru depozitare sau prelucrare.',workPoint:'Punct lucru',adresaPunctLucru:'Adresa Punct Lucru',administrator:'Gestionar',stocks:'Stocuri / Consumuri',history:'Istoric',priceAchizitie:'Pret achizitie',entries:'Intrari',suppliers:'Furnizori',lot:'Lot',dataProductie:'Data producției',dataExpirare:'Data expirării',supplierOrders:'Comenzi Furnizori',nomenclatorProducts:'Nomenclator Produse',addProduct:'Adaugă produs',product:'Produs',codeProduct:'Cod Produs',code:'Cod',name:'Nume',price:'Pret',lineTotal:'Valoare totală',gestiune:'Gestiune',reteta:'Nomenclatoare',emptyData:'Nu există date',noData:'Nu există date, folosește filtrele pentru selecție și apasă butonul "CAUTĂ"',recipte:'Reteta',addReteta:'Adauga produs in reteta',nr:'Nr.',categoria:'Categoria',tva:'TVA %',pretFaraTva:'Pret(fara TVA)',um:'UM',seePDF:'Vezi PDF',exportDocument:'Exportă document SPV',currency:'Moneda',settings:'Setări',productName:'Nume produs',productDescription:'Descriere produs',type:'Tip',codeFiscalFurnizor:'Cod Fiscal furnizor',dataDocument:'Data document',dataInStoc:'Data in stoc',dataScadenta:'Data scadentei',tipDocument:'Tip document',nrDocument:'Numar document',valoare:'Valoare',valoareTaxable:'Bază impozabilă',valoareTva:'TVA',valoareTotal:'Total',valoarePayable:'De plată',precizie:'Precizie',prețAchiziție:'Preț Achiziție',nirsProduct:'NIR-uri produs:',exports:'Exporturi',inboundInvoices:'Facturi de intrare contabilitate',accountingSales:'Vânzări contabilitate',download_xml:'Exportă arhiva SAGA XML',exportAccounting:{infoText:'Pentru a genera exportul contabil, selectează o locație și un interval de dată și oră. Alege apoi formatul dorit (XML sau XLS) și așteaptă finalizarea procesului de generare. În funcție de volum, exportul poate dura câteva secunde.'},exportAccountingSales:{infoText:'Pentru a genera exportul contabil al vânzărilor, selectează o locație și un interval de dată și oră. Alege apoi formatul dorit (XML sau XLS) și așteaptă finalizarea procesului de generare. În funcție de volum, exportul poate dura câteva secunde.'},miscareStoc:{vanzare:'MISCARE STOC: VANZARE',intrare:'MISCARE STOC: INTRARE',resetare:'MISCARE STOC: RESETARE',inventar:'MISCARE STOC: INVENTAR',intrareTransfer:'MISCARE STOC: INTRARE TRANSFER',iesireTransfer:'MISCARE STOC: IESIRE TRANSFER',bonConsum:'MISCARE STOC: BON CONSUM',intrareProductie:'MISCARE STOC: INTRARE PRODUCTIE',iesireProduse:'MISCARE STOC: IESIRE PRODUSE',bonAnulat:'MISCARE STOC: BON ANULAT',protocol:'MISCARE STOC: PROTOCOL',donatie:'MISCARE STOC: DONATIE'},stoc:{checkbox:'',nume:'Nume',tag:'Tag',tva:'TVA',um:'UM',cantitateRamasa:'Cantitate Rămasă',costMediuAchizitie:'Cost Mediu Achiziție',valoareTotala:'Valoare Totală',action:{editareMultipla:'Editare Multipla',bonConsum:'Bon Consum',transferStoc:'Transfer Stoc',resetareStoc:'Resetare Stoc',exporta:'Exportă Tot'}},bonTransfer:'Bon Transer',locatie:'Locație',nume:'Nume',cantitate:'Cantitate',cantitateHint:'Cantitatea se adaugă cu punct (.), nu cu virgulă (,)',umTaptastyInfo:'Unitatea de măsură la produsele gestionate din Taptasty se poate schimba din CATALOG -> Produse!',modifCantRamasa:'Modif. Cant. Rămasă',pretUnitar:'Preț Unitar',costMediuAchizitie:'Cost Mediu Achiziție',costTotal:'Cost Total',data:'Data',detalii:'Detalii',schimbaCotaTVA:'Schimbă Cotă TVA',schimbaTag:'Schimbă Tag',stergeTot:'Șterge Tot',motiv:'Motiv',cantitateDeConsum:'Cantitate de Consum',pretUnitarFaraTVA:'Preț Unitar fără TVA',pretTotal:'Preț Total',furnizor:'Furnizor',nrFactura:'Nr. Factura',scadenta:'Scadență',dataEmitere:'Data Emitere',dataIntrare:'Data Intrare',adaugaIntrare:'Adaugă Intrare',nirInfoNote:'⚠️ <strong>Atenție!</strong> Nota de Intrare Recepție (NIR) este destinată exclusiv înregistrării recepției și intrării produselor în gestiune. Pentru gestionarea facturilor de furnizori, accesați <strong>Intrări → Facturi furnizori</strong>.',location:'Locatie',supplier:'Furnizor',invoiceDate:'Data Emitere Factura',invoiceNumber:'Nr Factura',dueDate:'Scadenta',paid:'Platit',invoiceDetails:'Detalii Factura',invoiceProducts:'Produse Factura',stockName:'Denumire Stoc',companyName:'Nume Companie',quantity1:'Cant.',quantity2:'Cant. Unitate',unit:'Unitate',quantity3:'Cant.',unitPrice:'Pret Unitar',discount:'Discount',valueNoVAT:'Valoare Fara TVA',vat:'TVA',valueVAT:'Valoare TVA',valueWithVAT:'Valoare Incl. TVA',searchByCUI:'Cauta furnizor dupa CUI',addSupplier:'Adaugă furnizor',abbreviation:'Prescurtare',CUI:'CUI',registrationNumber:'Nr. Înregistrare',address:'Adresă',bank:'Bancă',IBAN:'IBAN',dueDays:'Scadența în zile',enterCUI:'Introduceți CUI',search:'Caută',invoiceEmissionDate:'Data Emiterii Facturii',total:'Total',balanceDue:'Rest de Plată',addDiscount:'Adaugă Discount',quantity:'Cant',tag:'Tag',sku:'SKU',allExplanations:'Toate explicațiile',explanations:'Explicații utilizare produs',useAsGoods:'Folosesc produsul ca și Marfă',useAsRawMaterial:'Folosesc produsul ca și Materie Prima',useAsPackaging:'Folosesc produsul ca și Ambalaj',useAsConsumable:'Folosesc produsul ca și Consumabil',description:'DESCRIERE',inventory:'Inventar',createdBy:'CREAT DE',modifiedBy:'MODIFICAT DE',resetBy:'RESETAT DE',date:'Data',scriptDate:'DATA SCRIPTICĂ',addInventory:'Adaugă inventar',downloadInventory:'Descarcă',fizica:'Fizică',descriptionInventory:'Descriere inventar',addFilter:'Aduga Filtru',consumable:'Consumabil',merchandise:'Marfă',rawMaterialFull:'Materie Primă',for:'Pentru',filterName:'Nume Filtru',selectColor:'Selectați Culoarea',filterByNameSku:'Filtrează după Nume sau SKU',filterByType:'Filtrează după Tip',filterByTag:'Filtrează după Tag',filterByQuantity:'Filtrează după Cantitate',filterBySupplier:'Filtrează după Furnizor',filterByVAT:'Filtrează după TVA',selection:'Selectare',view:'Vizualizează',stockFilter:'Filtru Stocuri',addCompany:'Adaugă companie',distributorName:'Distributor Name',balance:'Balance',BalanceReport:'Balanta centralizata',searchSuppliers:'Caută după',ordersSuppliers:'Comenzi furnizori',filterByProvider:'Filtrează după furnizor',inStock:'În stoc',necessary:'Necesar',casaRegister:'Registru de casa',action:'Acțiune',document:'Document',details:'Detalii',payments:'Plăți',collections:'Încasări',addCasaRegister:'Adaugă in registru de casa',value:'Valoare'},menuLink:{alias:'Alias',title:'Titlu',updated:'Actualizată',areYouSure:'Sigur dorești să {label} pagina ?',deleted:'Ștearsă',couldNotUpdate:'Nu s-a actualizat',cancel:'anulezi',delete:'ștergi',added:'Meniu link adăugat',promotions:'Promoții',history:'Istoric',orders:'Comenzi',reservations:'Rezervari',tables:'Mese',orderspos:'Adauga Comanda',dispatch:'Dispecerat',favorite_orders:'Comenzi favorite',tutorial:'Tutorial',personal_info:'Informații personale',single:'Meniu link',cancelCourier:'Anulează curier',logout:'Deconectare',from:'de la',to:'până la',linkFor:'Link pentru',externUrl:'URL Extern',custom:'Personalizat',day:'ziua',couldNotSave:'Nu s-a salvat'},pages:{allModules:'Vezi toate modulele',automationMarketing:'Marketing automat',stock:'Stock',supportTicket:'Suport Tichete',supportWidgetTokenUnavailable:'Tokenul widgetului de suport nu este disponibil pentru această locație',login:'Logare',register:'Înregistrare',recoverPassword:'Recuperează Parola',resetPassword:'Resetează Parola',programTitle:'Program',dashboard:'Panou comandă',orderingManagement:'Gestionare Comenzi',customerDetails:'Detalii Client',customers:'Clienți',approvals:'Cereri de Inregistrare',giftCard:'Gift Card',customersGroups:'Grupuri de clienți',orders:'Comenzi',reservations:'Rezervari',tables:'Mese',orderspos:'Adauga Comanda',dispatch:'Dispecerat',screens:'Ecrane',transfer:'Trasnfer',pos:'Pos',tableMaps:'Harti Mese',products:'Produse',isPriceList:'Liste Pret',catalog:'Catalog',categories:'Categorii',productOptions:'Optiuni Produs',groupOptions:'Grupuri Optiuni',marketing:'Marketing',campaigns:'Campanii',pushCampaigns:'Campanii push notification',coupons:'Cupoane',subscriptions:'Abonamente',referralCampaigns:'Campanii referral',loyaltyStoreCampaigns:'Oferte Loialitate',ambassadorRequests:'Cereri ambasadori',raffleCampaigns:'Campanii tombolă',donationCampaigns:'Campanii Donații',spinningWheelCampaigns:'Roata Norocului',discountCampaigns:'Campanii Reduceri',challengeCampaigns:'Provocări',offersSlider:'Banner oferte',reports:'Rapoarte',feedback:'Feedback',settings:'Setări',logout:'Delogare',fidelities:'Fidelitate',topCategory:'Categorii de top',infoPagesCustom:'Pagini Personalizate',menuLinks:'Linkuri meniu',infoPages:'Pagini Informative',productFilters:'Filtre Produs',promos:'Card De Loialitate',menus:'Meniuri QR',menuSubscriptions:'Abonamente meniuri',orderScreen:'Ecran Comenzi',clientOrderView:'Display PickUp',payment:'Facturi',newsletter:'Noutăți',support:'Suport',scanner:'Scanează',gestiune:'Gestiune',stocuri:'Stocuri',intrari:'Intrari',kds:'KDS',ods:'ODS',orderDisplayScreen:'Ecrane',online:'Online',invoice:'Facturi',kiosk:'Kiosk',qr:'Qr'},infoPages:{single:'pagină',title:'Titlu',shortDescription:'Scurtă descriere',updated:'Actualizată',areYouSure:'Sigur dorești să {label} pagina?',deleted:'Ștearsă',couldNotUpdate:'Nu s-a actualizat',cancel:'anulezi',delete:'ștergi',added:'Pagină informativă personalizată adaugată',changeLinkTab:'În caz că se adaugă un link, casuțele de text se vor schimba cu tasata TAB pentru următoarea și cu SHIFT + TAB pentru cea precedentă',infoPages:'Pagini informative'},ordersStatus:{bill:'Nota',AWAITING_TRANSPORT:'În așteptarea transportului',CANCELED:'Anulată',DELIVERED:'Livrată',DRAFT:'Ciornă',OPEN_DRAFT:'Comanda deschisa',NEW:'Nou',ON_HOLD:'Asteptare',POSTPONED:'Amânare',NOT_DELIVERED:'Nelivrată',PICKED_UP_BY_DELIVERY:'Preluată pentru livrare',PROCESSING:'Procesată',PREPARED:'Preparată',TRANSPORT:'În transport',RESERVED:'Rezervată',COMPLETED:'Finalizată',FINISH:'Finalizată',DRAFT_AWAITING_PAYMENT:'Plată nefinalizată',reservedReady:'Rezervată / Pregătită',completedReady:'Finalizată / Pregătită',deliveredReady:'Livrată / Pregătită',canceledForever:'comenzii in anulată?  Aceasta actiune  este ireversibila!',checkIn:'Checked-in'},ordersTypes:{GROUP:'Grup',SINGLE:'Individual'},paymentTypes:{CASH:'Cash',CARD:'Card Online',POS:'POS la livrare (Neplătit)',CARD_POS:'Terminal POS fizic (Platit)',CASH_MACHINE:'Cash machine (Platit)',POS_KIOSK:'POS Kiosk (Neplătit)',VIVA_INTENT:'VIVA App',VIRAMENT:'Virament',SPLIT:'Fiecare Separat',ROOM:'Transfer pe Camera',FOLIO:'Transfer pe Folio',EVENT:'Transfer pe Eveniment',MANCARE_PERSONAL:'Mancare personal',PROTOCOL:'Protocol',ONLINE:'Online',Online:'Online',GLOVO:'GLOVO',GLOVO_CARD:'GLOVO CARD',GLOVO_CASH:'GLOVO CASH',BOLT:'BOLT',BOLT_CASH:'BOLT CASH',BOLT_CARD:'BOLT CARD',WOLT:'WOLT',WOLT_CASH:'WOLT CASH',WOLT_CARD:'WOLT CARD',VOUCHER:'Voucher',GIFT_CARD:'Card cadou',null:'Neachitat'},paymentStatus:{notPaid:'Suma Reţinută',notPaidDetails:'Suma va fi retrasă de pe card în momentul în care comanda va fi marcată ca fiind "Livrată".',paid:'Achitat',notOk:'Refuzat'},campaignsModes:{AUTO:'Automat',MANUAL:'Manual'},campaignsNotificationTypes:{EMAIL:'E-mail',PUSH:'Notificări'},days:{monday:'Luni',tuesday:'Marți',wednesday:'Miercuri',thursday:'Joi',friday:'Vineri',saturday:'Sâmbătă',sunday:'Duminică',0:'Duminică',1:'Luni',2:'Marți',3:'Miercuri',4:'Joi',5:'Vineri',6:'Sâmbătă'},months:{1:'Ianuarie',2:'Februarie',3:'Martie',4:'Aprilie',5:'Mai',6:'Iunie',7:'Iulie',8:'August',9:'Septembrie',10:'Octombrie',11:'Noiembrie',12:'Decembrie'},daysShort:{Mon:'Lu',Tue:'Ma',Wed:'Mi',Thu:'Jo',Fri:'Vi',Sat:'Sa',Sun:'Du'},gender:{selectGender:'Selectează Genul',male:'masculin',female:'feminin',Male:'Masculin',Female:'Feminin',Other:'Altul'},reportsAgesGroups:{selectAge:'Selectează Vârsta','20':'Sub 20','Under 20':'Sub 20','20-30':'20 - 30','30-40':'30 - 40','40-50':'40 - 50','50':'50+','50+':'50+',Unspecified:'Nespecificat'},deliveryTypes:{SELF_ORDERING:'Masa/Kiosk',DELIVERY:'Livrare',EAT_LOCATION:'Comandă La Masă',MEET_HALF:'Ne întâlnim la jumătate',PICK_UP:'Ridicare comandă'},couponsTypes:{FIXED:'Fix',PERCENTAGE:'Procent',FREE_PRODUCT:'Produs gratuit'},taxTypes:{FIXED_INCLUDED:'Fix (inclus)',PERCENTAGE_INCLUDED:'Procent (inclus)',FIXED_EXCLUDED:'Fix',PERCENTAGE_EXCLUDED:'Procent'},productOptions:{checkbox:'Permite selectarea mai multor opțiuni pe produs',radio:'Permite selectarea unei singure opțiuni pe produs',upload:'Optiunea cu upload de imagine',hidePrices:'Ascunde prețurile',hasDefaultValue:'Preselectează prima opțiune'},validations:{success:'Success',priceUpdated:'Prețul a fost actualizat cu succes',areYouSureYouWantTo:'Sigur că dorești modificarea ',areYouSure:'Sigur dorești să actualizezi statusul ',wentWrong:'A apărut o eroare, te rugăm să încerci mai târziu...',pictureSize2MB:'Fișiere jpg/png cu o dimensiune mai mică de 2MB ',pictureSizeExceed2MB:'Dimensiunea pozelor nu poate depăși 2MB!',pictureSize:'Fișiere jpg/png cu o dimensiune mai mică de 5MB',pictureLogo:'Fișiere jpg/png/svg cu o dimensiune mai mică de 5MB ',pictureSizeExceed:'Dimensiunea pozelor nu poate depăși 5MB!',pdfSize:'Fișiere cu o dimensiune mai mică de 25MB ',pdfSizeExceed:'Dimensiunea fișierului nu poate depăși 25MB!',archiveSizeExceed:'Dimensiunea fișierului nu poate depăși 500MB!',wrongFormat:'Formatul fisierului este gresit',removePhoto:'Te rugăm să ștergi documentele existente pentru a putea adăuga altele noi',dataCouldNotBeSaved:'Datele nu au putut fi salvate, te rugăm să încerci mai târziu.',passReq:'ID-ul câmpului de parolă este necesar.',passMin:'Parola trebuie să conțină cel puțin 6 caractere.',passConf:'Parola și confirmarea parolei nu corespund.',validPoinsNo:'Te rugăm să adaugi o sumă valabilă de bani și un comentariu.',imageResolution:'. Rezoluție recomandată 300px înălțime și 820px lățime.',imageResolutionWeb:'. Rrezoluție recomandată 300px înălțime și 1920px lățime.',doYouWantTo:'Dorești să',hourIsSmallerThanCreated:'Ora dorită este mai mică decât ora de plasare a comenzii',cancelReason:'Motivul anularii este obligatoriu.',requiredField:'Acest câmp este obligatoriu',invalidEnteredData:'Datele introduse nu sunt valide.',vatPrinterIdRange:'Doar 0–10.',vatPrinterIdNumeric:'Doar cifre.',chooseDay:'Alegeți cel puțin  o zi în care produsul va fi disponibil!',chooseLocation:'Alegeți cel puțin o locație în care produsul va fi disponibil!',chooseLocationAndDeliveryMethod:'Alegeți cel puțin o locație și o metodă de livrare pentru care produsul va fi disponibil!',timeInterval:'Interval orar invalid!',noOverrideIntervals:'Livrarea personalizată este activată dar nu există niciun interval adăugat. Adăugați cel puțin un interval.',overrideIntervalMissingHours:'Toate intervalele trebuie să aibă orele "De la" și "Până la" completate.',overrideIntervalMissingDay:'Toate intervalele trebuie să aibă cel puțin o zi selectată.',subtractPoints:'Sigur doriti stergerea a'},upload:{uploadLabel:'Încarcă Meniu',uploadMenuTemplateLabel:'Încarcă Formular Meniu',browse:'Caută',download:'Descarca Codul QR',dynamicMenu:'Meniu dinamic',staticMenu:'Meniu PDF',downloadImportProductsTemplate:'Descarcă formular meniu',upload:'Încarcă',downloadButton:'Descarcă',uploadImagesArchive:'Încarcă arhivă cu imagini',file:'Fișier'},productImport:{import:'Import',importHistory:'Istoric importuri',batch:'Batch',date:'Dată',file:'Fișier',products:'Produse',status:'Status',review:'Revizuiește',confirm:'Confirmă',cancel:'Anulează batch',remove:'Elimină',removeConfirm:'Eliminați acest rând din import? Nu va fi aplicat.',editRow:'Editează rând import',product:'Produs',action:'Acțiune',actionType:'Tip',actionCreate:'Creare',actionUpdate:'Actualizare',actionPriceListUpdate:'Actualizare listă prețuri',price:'Preț',category:'Categorie',errors:'Erori',pending:'În așteptare',confirmed:'Reușite',removed:'Eliminate',uploadSuccess:'Import încărcat. Revizuiți și confirmați modificările.',confirmSuccess:'Import aplicat cu succes',statusPending:'În așteptare',statusConfirmed:'Confirmat',statusSuccessful:'Reușit',statusPartiallyConfirmed:'Parțial confirmat',statusPartiallySuccessful:'Parțial reușit',statusCanceled:'Anulat',statusError:'Eroare',statusRemoved:'Eliminat',exportProducts:'Exportă produse',exportImages:'Descarcă imagini',selectPriceProfile:'Listă de prețuri',priceProfileRequired:'Selectați o listă de prețuri înainte de confirmare',confirmTitle:'Confirmă importul',confirmPriceHint:'Alegeți lista de prețuri unde vor fi aplicate prețurile pe canale.',step1Title:'Descarcă / exportă',step1Intro:'Alegeți o opțiune: formular gol sau export cu produsele existente pe locație.',optionEmptyTitle:'Formular gol',optionEmptyDesc:'Descărcați un CSV gol și completați-l offline.',downloadEmptyForm:'Descarcă formular gol',optionExportTitle:'Exportă produsele existente',optionExportDesc:'Exportați produsele curente ale locației în CSV-ul de meniu (necesită o listă de prețuri).',defaultPriceListHint:'Dacă locația nu are listă de prețuri, creăm una cu numele „{location} default”.',noProductsForExport:'Locația nu are produse, deci exportul este dezactivat.',step2Title:'Completează formularul',step2Body:'Deschide CSV-ul în Excel sau Google Sheets. Completează PRODUCT ID, PREȚ și prețurile pe canale offline, apoi salvează ca CSV.',step3Title:'Imagini (.zip)',step3Hint:'Încărcați un .zip cu imaginile produselor.',step4Title:'Meniu (.csv)',step4Hint:'Încărcați CSV-ul completat. Veți revizui și confirma importul în previzualizare înainte ca modificările să fie aplicate.',sectionIdentity:'Identitate produs',sectionCategories:'Categorii',sectionBase:'Detalii de bază',sectionDescription:'Descriere și etichete',sectionPrices:'Prețuri pe canale',searchProduct:'Potrivește produs existent',searchProductPlaceholder:'Caută după nume…',productMatchNew:'PRODUCT ID gol — la confirmare se creează un produs nou.',productMatchFound:'Potrivit: {name}',productMatchUnknown:'Produs necunoscut — căutați și selectați un produs existent, sau goliți ID-ul pentru creare.',topCategory:'Categorie de top',secCategory:'Categorii secundare',active:'Activ',activeHint:'1 / 0 / da / nu',posId:'POS ID',vat:'TVA',section:'Secțiune',weight:'Greutate',imageFilename:'Nume fișier imagine',imageFilenameHint:'Numele din arhiva zip încărcată',desc:'Descriere',nutritional:'Valori nutriționale',allergenic:'Alergeni',ingredients:'Ingrediente',legacyTitle:'Import vechi',legacyHint:'Aplică CSV-ul imediat, fără previzualizare. Folosește formularul clasic (doar creare produse — fără PRODUCT ID / prețuri pe canale). Încărcați imaginile ca .zip aici înainte de importul CSV.',legacyDownloadLabel:'Descarcă formular meniu',legacyDownload:'Descarcă',legacyUpload:'Încarcă',legacyUploadSuccess:'Importul vechi a fost finalizat'},dashboard:{selectLocation:'Selectează locația',selectZone:'Zona',selectMethod:'Metodă',selectDriver:'Sofer',selectUsers:'Administratori',selectClient:'Client',selectedOrderFormFlags:'Pentru comenzile din',selectedPaymentMethods:'Pentru comenzile cu',serchCoupon:'Caută(Cupon)',tile1Title:'Comenzi Noi',tile2Title:'Total Comenzi',tile3Title:'Venituri',tile4Title:'Comandă Medie',today:'Azi',orderChart:'Comenzi',completed:'Număr de comenzi',canceled:'Anulate',salesChart:'Vânzări',salesIn:'Vânzări în',top5Chart:'Top 5 produse',orderingChart:'Tipuri de comenzi',nrOfOrders:'Număr de comenzi',nrOfEmails:'Număr de emailuri'},customers:{addCustomerToGroup:'Adaugă client în grup...',noApprovalRequired:'Fără aprobare',searchPlaceholder:'Caută după nume, telefon sau email...',myGroups:'Grupurile mele',pendingApproval:'în așteptare',noGroups:'Nu face parte din niciun grup',approvalStatus:'Status',approved:'Aprobat',approve:'Aprobă',clientApproved:'Client aprobat cu succes!',membersRequireApproval:'Membrii necesită aprobare',totalSales:'Total vanzari',settings:'Setari utilizator',allow_virament:'Permiteti virament',singleTotal:'Total client: ',noCustomer:'Nici un Client Selectat',single:'client',plural:'clienți',deliveryOrders:'Comenzi cu Livrare',pickupOrders:'Comenzi cu Ridicare',meetHalfwayOrders:'Comnezi "Ne intalnim la jumatate"',customerReservations:'Rezervari',title:'DETALII CLIENT',pointsTitle:'Puncte Loialitate Client',currentPoints:'Puncte Actuale',pointsAddTitle:'Adaugă Puncte',pay:'Tip Plata',id:'ID',name:'Nume',email:'Email',phone:'Telefon',use_calling_phone:'Preia numar telefon',gender:'Gen',birth:'Data nașterii',location:'Locație',address:'Adresă',number:'Număr',dateCreated:'Data creare',delivery:'Livrare',type:'Tip',status:'Status',total:'Total',allTimeSale:'Vânzări totale',fidelities:'Label',none:'Nici unul',pointsLabel:'Bani cheltuiți',pointsLabelInPoints:'Puncte primite',points:'puncte',point:'punct',clientCanUse:'Clientul va putea folosi',commentsLabel:'Comentariu',pointsSuccess:'Puncte loialitate adăugate cu succes.',pointsError:'Nu am putut adăuga punctele de loialitate clientului.',addCommentPerClient:'Adaugă comentariu per client',newCommentAdded:'Comentariul a fost actualizat',clientNotification:'Dorești sa folosești comenatariul pentru a notifica clientul?',filters:{withOrders:'Cu Comenzi',withoutOrders:'Fara Comenzi'},addGroup:'Adaugă grup',deleteGroup:'Grupul a fost șters.',saveGroup:'Grupul a fost adăugat cu succes.',updateGroup:'Grupul a fost actualizat cu succes.'},orders:{cancel_order_reason:'Motiv Anulare',counterPerCustomer:'Număr Comenzi',noOrders:'Nici o comandă Selectată',single:'Comanda',the_order:'Comandă',category:'Categorie',plural:'comenzi',status:'Status',location:'Locație',updateStatus:'Actualizează Status',editOrder:'Editează',ordDetails:'Detalii Comenzi',date:'Data',madeAt:'Comandă plasată la',pickupTime:'Livrare / Ridicare la',preorder:'PRECOMANDĂ',preorderFilter:'Precomenzi',allOrders:'Toate comenzile',pendingPreorders:'Precomenzi în așteptare',withoutPendingPreorders:'Fără precomenzi în așteptare',reservationTime:'Oră Rezervare',expresoftStatus:'Expresoft Status',expresoftQueue:'In Trimitere',expresoftError:'Eroare trimitere',expresoftSuccess:'Trimis',reservationSeats:'Rezervare Locuri',rating:'Evaluare',meetupLocation:'Punct de intalnire',ordLocation:'Locație',delivery:'Livrare',type:'Tip',payment:'Plată',name:'Nume',qty:'Cantitate',unit:'Preț buc',unit_price:'Preț pe bucată',final_price:'Preț final',total:'Total',totals_subtotals:'Subtotal',totals_extras:'Ecotaxă',totals_extras_27:'Taxa Ambalaj',totals_extras_30:'Ecotaxă',totals_extras_38:'Sacosa Spartan',totals_extras_40:'Ecotaxă',totals_extras_50:'Ambalaj',totals_discount:'Discount',totals_discount_loyalty_points:'Discount puncte loialitate',totals_grandtotal:'Total',totals_shipping:'Livrare',totals_tip:'Bacșiș',totals_donation:'Donație',custComments:'Comentariu Client',adminComments:'Comentariu Admin',pos_response_title:'Raspuns POS',fiscal_response_title:'Raspuns Fiscal',custDetails:'Detalii Clienți',shipping:'Adresă Livrare',billing:'Adresă Facturare',orderStatusSuccess:'Statusul comenzii a fost actualizat cu succes',orderPrinterError:', dar a aparut o eroare la conexiunea cu imprimanta.',orderCommnetSuccess:'Comentariul pe comandă a fost actualizat cu succes',orderHourSuccess:'Timpul de livrare / ridicare comandă actualizat cu succes',orderHourError:'Te rugăm să oferi o oră validă.',none:'Nici un comentariu',at:'la',filtersApplied:'Filtre aplicate - apasă butonul de filtru pentru a vedea mai mult',filtersList:'Filtre aplicate',customFilters:'Filtre specifice aplicate',resetFilters:'apasă aici pentru a reseta și a vedea datele actualizate',noFiltersApplied:'Nu sunt filtre aplicate',filtersAndSort:'Filtre și Sortare',filters:'Filtrează',pickupDatetime:'Data și Ora Ridicare Comandă',placedDatetime:'Data și Ora Plasare Comandă',orderId:'ID Comandă',orderNumber:'Număr Comandă',orderTotal:'Total Comandă',enterOrderId:'Introdu ID comandă',enterOrderNumber:'Introdu număr comandă',selectDateRange:'Selectează interval dată',min:'Min',max:'Max',operator:'Operator',source:'Sursă',note:'Notificare',orderNoArticulate:'Comanda',print:'Printează (A4)',print2:'Printează (A4 Restrâns)',printerPrint:'Print (80mm)',printFiscal:'Încasează',receipt:'Bon fiscal',printedReceipt:'Comanda a fost încasată',notPrintedReceipt:'Comanda nu a fost încasată',rePrintFiscal:'Reprintare bon',printerSuccess:'Comanda a fost printată cu success.',printerErrror:'A aparut o eroare la conexiunea cu imprimanta.',callCourier:'Cheamă curier',callHioCourier:'Hio',callTazzLaasCourier:'Tazz Direct',callCourierCancel:'Sigur dorești să anulezi chemarea curierului?',orderSentSuccess:'Chemarea curierului a avut loc cu succes',orderCancelSuccess:'Chemarea curierului a fost anulată',packageDetails:'Selecteaza detalii colet',packageSize:'Marime colet: ',courierTime:'Timp de ridicare colet: ',sameStatus:'Comanda este deja ',now:'Acum',addTime:'Adăugă timp',amountRefunded:'Sumă returnată',amountIntegralRefunded:'Suma a fost returnată integral clientului',refundSuccess:'Returnarea banilor a fost realizată cu succes',refundManual:'Returnarea banilor se va face din paylike manual',refundAutomat:'Dorești returnarea automată a sumei ?',refundOrder:'Rambursează',refundAlreadyDone:'Deja rambursat',refundConfirmTitle:'Rambursezi comanda?',refundConfirmText:'Suma plătită va fi returnată clientului prin EuPlatesc. Această acțiune nu poate fi anulată.',refundAskCancel:'Rambursarea a fost efectuată. Vrei să anulezi și comanda?',refundError:'A apărut o eroare la procesarea rambursării.',orderCloseToDelivery:'Comandă cu oră de livrare apropiată',erorrPaylike:'Eroare din Paylike, un log s-a facut pe server cu eroarea returnată',sendToGrandchef:'Dorești trimiterea comenzii către Grandchef?',grandchefError:'Eroare din Grandchef',grandchefWait:'Poți încerca doar o dată la 30 minute',cancelReason:'Introduceti motivul...',contactPakageez:'Eroare! Luați legătura cu Pakageez!',contactRapidDonkey:'Eroare! Luați legătura cu Rapid Donkey!',contactChopChop:'Eroare! Luați legătura cu Chop Chop!',contactDrCarmen:'Eroare! Luați legătura cu Dr Carmen!',seeImage:'Vezi Imaginea',freyaStatus:'Status Freya',rkeeperStatus:'Status RKeeper',freyaStatus1:'In Trimitere',freyaStatus2:'S-a trimis cu succes',freyaStatus3:'Trimiterea a eșuat.',freyaStatus4:'Anulat.',freyaSendAgain:'Introduceți comanda manual sau încercați din nou.',legalPerson:'Persoană juridică',individual:'Persoană fizică',billingInfo:'Date facturare',callDriver:'Cheama curierul?',virament:'Virament',cash:'Cash',card:'Card',online:'Online',BOLT:'BOLT',GLOVO:'GLOVO',WOLT:'WOLT',cancel:'Anulează',card_no_pos:'POS MOBIL',cui:'CUI(optional)',glovoStatus:'Status Glovo',glovoLaasEvents:'Jurnale Glovo LaaS',glovoLaasEventsEvent:'Acțiune',glovoLaasEventsTime:'Oră',glovoLaasTrackCourier:'Urmărește curierul',glovoLaasLogResponse:'Răspuns',glovoLaasLogAction_Create_delivery:'Creează livrare',glovoLaasLogAction_Create_delivery_failed:'Creare livrare eșuată',glovoLaasLogAction_Cancel_delivery:'Anulează livrare',glovoLaasLogAction_Cron_callCourier:'Chemare curier automată (cron)',glovoLaasLogAction_Webhook_event_received:'Eveniment webhook primit',tazzStatus:'Status Tazz',tazzDirectStatus:'Status Tazz Direct',courierStatus1:'Curierul nu a fost chemat',courierStatus2:'Curierul a fost chemat',courierStatus3:'Curierul nu a fost chemat',courierStatus4:'Curierul a fost anulat',courierStatus5:'Livrare administrată de Glovo',courierStatus6:'A apărut o eroare',courier:'Curier',courierDeliveryError:'Eroare',courierDeliverySuccess:'Succes',packageNumber:'Numar colete: ',zone:'Zonă',roomNumber:'Număr Cameră',pagerNumber:'Număr pager',woltDriveStatus:'Status Wolt Drive',deliveryHeroStatus:'Status Delivery Hero',deliveryHeroAreYouSure:'Chemați curierul Delivery Hero?',deliveryHeroEvents:'Jurnale Delivery Hero',deliveryHeroEventsEvent:'Acțiune',deliveryHeroEventsTime:'Oră',deliveryHeroLogResponse:'Răspuns',deliveryHeroLogAction_Create_order:'Creare comandă',deliveryHeroLogAction_Create_order_failed:'Creare comandă eșuată',deliveryHeroLogAction_Cancel_order:'Anulare comandă',deliveryHeroLogAction_Cancel_order_failed:'Anulare comandă eșuată',deliveryHeroLogAction_OAuth_token:'Token OAuth',deliveryHeroLogAction_Status_webhook:'Webhook status',deliveryHeroLogAction_Refund_webhook:'Webhook refund',deliveryHeroLogAction_Autopilot_skip:'Autopilot skip',noShipmentPromises:'Nu sunt promisiuni de livrare disponibile pentru timpul selectat.',selectShipmentPromise:'Selectează Promisiunea de Livrare',pleaseSelectPromise:'Te rugăm să selectezi o promisiune de livrare.',confirmDeliveryDetails:'Confirmă detaliile livrării',woltDriveEvents:'Jurnale Wolt Drive',woltDriveEventsEvent:'Acțiune',woltDriveEventsTime:'Oră',woltDriveTrackCourier:'Urmărește Curier',woltDriveLogResponse:'Răspuns',woltDriveLogResponse_success:'Succes',woltDriveLogAction_Get_shipment_promise:'Obține promisiunea de livrare',woltDriveLogAction_Get_shipment_promise_failed:'Estimare de livrare',woltDriveLogAction_Create_delivery:'Creează livrare',woltDriveLogAction_Create_delivery_failed:'Creare livrare eșuată',woltDriveLogAction_Cron_callCourier:'Chemare curier automată (cron)',woltDriveLogAction_No_binding_shipment_promise:'No binding shipment promise',woltDriveLogAction_Autopilot_No_valid_promises:'Autopilot - No valid promises',woltDriveLogAction_Skip_create_delivery_autopilot_gate:'Skip create delivery (autopilot gate)',woltDriveLogAction_Skip_callCourierAndRetry:'Skip callCourierAndRetry',woltDriveLogAction_Cancel_courier:'Cancel courier',woltDriveLogAction_Cancel_delivery_by_order:'Cancel delivery by order',woltDriveLogAction_Cancel_delivery:'Cancel delivery',woltDriveLogAction_Webhook_event_received:'Webhook event received',woltDriveEventType_order_received:'Comandă primită',woltDriveEventType_order_rejected:'Comandă respinsă',woltDriveEventType_order_pickup_eta_updated:'ETA ridicare actualizat',woltDriveEventType_order_pickup_started:'Ridicare începută',woltDriveEventType_order_picked_up:'Comandă ridicată',woltDriveEventType_order_pickup_arrival:'Curierul ajunge la ridicare',woltDriveEventType_order_dropoff_started:'Livrare începută',woltDriveEventType_order_dropoff_arrival:'Curierul ajunge la livrare',woltDriveEventType_order_dropoff_completed:'Livrare finalizată',woltDriveEventType_order_delivered:'Comandă livrată',woltDriveEventType_order_customer_no_show:'Client indisponibil',woltDriveEventType_order_location_updated:'Locația curierului actualizată',woltDriveEventType_order_dropoff_eta_updated:'ETA livrare actualizat',woltDriveEventType_order_handshake_delivery:'Livrare cu PIN',woltDriveEventType_order_status_updated:'Status comandă actualizat',woltDriveCancelErrorCode_INVALID_ORDER_STATE_TRANSITION:'Nu se poate anula această livrare: comanda nu este într-o stare anulabilă. Vă rugăm să contactați suportul.',woltDriveShipmentPromisesErrorCode_DROPOFF_OUTSIDE_OF_DELIVERY_AREA:'Locația de livrare este în afara zonei de livrare.',woltDriveCreateDeliveryErrorCode_CASH_ON_DELIVERY_DISABLED:'Plata la livrare nu este disponibilă pentru Wolt Drive. Vă rugăm să contactați echipa Wolt Drive.'},ordersSource:{1:'Kiosk',2:'Qr',3:'Pos',4:'App',5:'Website',6:'Glovo',7:'Wolt',8:'Bolt'},boogit:{boogitStatus:'Status Boogit',boogitStatus1:'Nu s-a trimis',boogitStatus2:'S-a trimis cu succes',boogitStatus3:'Trimiterea a eșuat.',boogitStatus4:'Anulat.'},charisma:{location:'Locație',posIds:'ID-uri POS',partnerCode:'Cod partener',tipsItemId:'ID articol bacșiș',createDate:'Creat',updateDate:'Modificat',orderOptionId:'ID Opțiune Comandă',companyOptionId:'ID Opțiune Companie',optionName:'Nume Opțiune',optionValueName:'Nume Valoare Opțiune',categoryAdministration:'Gestiune',charismaInventory:'Gestiune Charisma',logRvc:'RVC',dataFrom:'Răspuns',dataTo:'Trimis',enterPosId:'Introduceți Item Code',options:'Opțiuni #',itemCode:'Item Code',itemId:'Item ID',enterItemCode:'Introduceți Item Code dacă lipsește',sendAll:'Trimite selecția',sendAllMessage:'Comenzile au fost marcate și vor fi importate în Charisma în câteva minute, în funcție de numărul de comenzi',bill:'Proformă',invoice:'Factura Fiscală',documentType:'Tip Document',charisma0:'-',charisma1:'Netrimis',charisma2:'Se trimite',charisma20:'Se trimite',charisma3:'Trimis',charisma4:'Eroare',sendOnlyProform:'Trimite doar Proforma',sendOnlyInvoice:'Trimite doar Factura',orderItems:'Articole comandă',sendHistory:'Istoric trimitere',document:'Document',resultCharisma:'Rezultat Charisma',verdict:'Verdict',logStatus:'Status',logVerdictSuccess:'Trimis cu succes',logVerdictError:'Eroare la trimitere în Charisma',logVerdictCharismaError:'Eroare Charisma',logVerdictAwaitingResponse:'Trimis, așteaptă răspuns',logVerdictNoPayload:'Nu există date înregistrate',logVerdictUnknown:'Status necunoscut',logVerdictMissingPosIds:'Eroare validare, lipsă id-uri Charisma. Vă rugăm completați mai sus și trimiteți.',logVerdictMissingCategoryAdministration:'Lipsă gestiune de pe categorie, completați mai sus și trimiteți.',logVerdictConnectionError:'Eroare conexiune server Charisma',logVerdictOrderNotDelivered:'Comanda nu a fost livrată încă.',resendConfirm:'Comanda a fost deja trimisă, ești sigur că vrei să trimiți din nou comanda?'},fiscalZ:{id:'ID',zNumber:'Număr',zTimestamp:'Dată și oră',totalSalesA:'Total Vânzări A',totalSalesB:'Total Vânzări B',totalSalesC:'Total Vânzări C',totalSalesD:'Total Vânzări D',totalSalesE:'Total Vânzări E',totalOtherTaxes:'Total Alte Taxe',totalVatExempt:'Total Scutit TVA',totalSales:'Total Vânzări',totalVatA:'Total TVA A',totalVatB:'Total TVA B',totalVatC:'Total TVA C',totalVatD:'Total TVA D',totalVatE:'Total TVA E',totalVat:'Total TVA'},companyOptions:{id:'Id',name:'Nume',image:'Imagine',prod_image:'Imagine Produs (doar pt aplicatii custom)',info:'Info',print_with_product_label:'Imprimați cu eticheta produsului (pentru imprimantele de etichete)',product_id:'Optiunea este Produsul',type:'Tip',deleteQues:'Această acțiune va șterge opțiunea și de pe produsele pe care este pusă. Ești sigură că dorești să continui?',deleteVal:'Această acțiune va șterge valoarea și de pe produsele pe care este pusă. Daca nu doresti asta, nu salva!',active:'Activ',quantitySettings:'Setări Cantitate',allowQuantity:'Permite cantitate',minQuantity:'Cantitate minimă',maxQuantity:'Cantitate maximă',quantityMinMaxError:'Cantitatea minimă nu poate fi mai mare decât cantitatea maximă'},catalogProd:{prod_desc:'Descriere',prod_general:'General',prod_price:'Pret',prod_loc:'Locatie',prod_opt:'Optiuni',prod_mark:'Marketing',prod_lab:'Label',prod_set:'Setari',same_name_are_you_shore:'Acest nume se mai regaseste si la alt produs, Esti sigur ca vrei sa salvezi?',max_purchases_per_customer:'Achiziții maxime per client',preparation_time_in_minutes:'Timp de preparare (minute)',category_preparation_time_hint:'Timp de preparare categorie: {minutes} min',label_type:'Tip',orderLabelSettings:'Etichete de comandă',printOnOrderLabel:'Imprimă pe etichetele comenzii',printOnOrderLabelHint:'Produsul se imprimă dacă îl bifezi aici și alegi „Câte o etichetă pentru fiecare produs” pe imprimanta Order Label.',label_name:'Nume produs pe eticheta',label_ingredients:'Ingrediente pe eticheta',label_allergens:'Alergeni pe eticheta',label_exp_txt:'Text expirare (ex: A se consuma de preferabil dupa 2 ore de la deschidere)',sold_with_menu_suggestion:'Cu sugestii de meniu',sold_with_menu_suggestion_pos:'Activează pe POS această funcționalitate!',noProducts:'Nici un produs selectat',single:'produs',plural:'produse',generalDetails:'Detalii Generale',aditionalInfo:'Informatii aditionale',id:'ID',name:'Nume',desc:'Descriere',image:'Imagine',image_size:'Dimensiune Image',video_thumbnail:'Video Thumbnail',imageMore:'Alte imagini',video:'Video',category:'Categorie',topCategory:'Categorie de top',partialPay:'Plata partiala',isDeposit:'Este Avans',isAgeRestrict:'Restricție de vârstă',limitQuantityKioskQr:'Cantitate 1 pentru Kiosk/Qr',secondaryCategory:'Categorie secundara',coursesType:'Tip fel',coursesTypeMaxAllowed:'Valoarea maximă permisă de locație: {max}',coursesTypeLocationNotPermitted:'Locația nu permite feluri',price:'Preț',usePriceToShow:'Folosește afișare de preț',priceToShow:'Preț pentru afișare',oldPrice:'Preț vechi',newPrice:'Preț nou',deliveryMethod:'Metodă de livrare',useDiscountPrice:'Folosește preț redus',taxes:'Taxe aplicate',status:'Status',posid:'POS ID',allowUserComments:'Permite utilizatorilor să lase un mesaj',availableInStore:'Disponibil doar in restaurant',validFromTo:'Valabil de la - până la',prodType:'Tip Produs',singleType:'indivuald',groupType:'grup',rewardPoints:'Puncte loialitate',moneySpent:'Bani în Puncte',numberOfYouNeedToSpend:'Suma de {currency} pe care clientul trebuie să o cheltuiască pentru a primi 1 punct.',points:'puncte',soldWith:'Vândut cu',pickAnOption:'Alege o opțiune',minNoSelected:'Nr. min selectat',maxNoSelected:'Nr. max selectat',optVal:'Valoare',leaveEmpty:'Lasă gol sau pune 0 dacă opțiunea nu costă suplimentar',prodDeleted:'Produs șters cu succes',prodAdded:'Produs adăugat cu succes',prodUpdated:'Produs actualizat cu succes',prodPhotoError:'Nu am putut salva poza de produs, te rugăm să încerci mai târziu.',rewardPossibelValue:'Posibile valori',errorOptions:'Vă rugăm să verificați ca toate câmpurile produsului să fie completate corespunzător.',productOptionError:'Vă rugăm să verificați ca toate opțiunile produsului să fie completate corespunzător.',minNoNegative:'Nr. minim nu poate fi mai mic de 0',maxNoNegative:'Nr. maxim nu poate fi mai mic de 0',minNoTooHigh:'Nr. minim nu poate depăși nr. maxim',maxNoTooHigh:'Nr. maxim nu poate depăși nr. valorilor',optionInUse:'Această opțiune este folosită de unele produse. Ștergeți-o mai întâi de pe produse.',locationSettings:'Setări de locație',availableIn:'Disponibil în',availableInLocation:'Disponibil în locație',availableFor:'Disponibil pentru',availableForSource:'Disponibil pentru sursă',groupOption:'Grup de opțiuni',deliveryMethodsandHours:'Metode si ore de livrare',overrideSettings:'Suprascrie Setarile',addLocationValidation:'Unele optiuni nu sunt compatibile cu locatiile selctate, dacă continuați, optiunile vor fi eliminate, daca nu, locatia dorită nu va fi adaugată.',productAvailableIn:'Produsul este disponibil în',particularLocationSettings:'Setări particular per locație',activateParticularSettings:'Activează setări particular',withoutThisOptionDefault:'*fără activarea acestei opțiuni vor fi folosite setările implicite',highlightsProduct:'Evidențiază produs',search:'Căutare',availability:'Disponibilitate',setLimitedAvailability:'Aplica disponibilitate limitata',leaveEmptyAvailability:'Lasă gol pentru cantitale nelimitată.',timeOptions:'Opțiuni de dată și timp',picktimeOptions:'Selectează opțiunea:',timeOptionsValues:{none:'Niciuna',dateTimePicker:'Selector de dată și oră',dateRangePicker:'Selector de interval de dată'},maxQuantityIn:'Cantitate maximă în',unitOfTime:'unitatea de timp',youChoose:'Ai ales',isUsedFor:'*Este folosită doar pe locațiile bifate în setări',isHiddenFromListing:'Ascunde din lista de produse',isHiddenFromSearch:'Ascunde din cautarea de produse',isHiddenFromQrMenu:'Ascunde din meniul Qr',isHiddenFromPOS:'Ascunde din POS',isHiddenFromKiosk:'Ascunde din Kiosk si Meniu Qr',Monday:'Lu',Tuesday:'Ma',Wednesday:'Mi',Thursday:'Jo',Friday:'Vin',Saturday:'Sam',Sunday:'Dum',accesRestricted:'Ne pare rău dar nu ai acces la acest produs',disableProductUsedByBanner:'Dezactivarea acestui produs va dezactiva și oferta aferentă. Ești sigur?',deleteProductUsedByBanner:'Ștergerea acestui produs va dezactiva și oferta aferentă. Ești sigur?',availabilityTitle:'Disponibilitate produs',fromTime:'De la',toTime:'până la',timePlaceholder:'Selectează ora',productNotAvailable:'Produs indisponibil',productNotAvailableError:'Vă rog completați aceste două câmpuri.',swalTitleChangeStatus:'Vă rog setați statusul produsului ca "activ" înainte.',externalProductId:'ID Extern',minQuantity:'Cantitate Minimă',hideFromPlatforms:'Ascunde de pe platforme',changeLocations:'Schimbă locațiile',includeAllLocationsProducts:'Include și produsele disponibile în toate locațiile',bulkLocationsMode:'Acțiune',bulkModeAdd:'Adaugă',bulkModeRemove:'Elimină',bulkModeReplace:'Înlocuiește',massUpdate:'Actualizare în masă',massUpdateSubtitle:'Urmează să actualizezi {count} produse',bulkActionActive:'Activ / Inactiv',bulkActionPrice:'Preț',bulkActionVat:'TVA',bulkActionSection:'Secție',bulkActionOptionGroups:'Grupuri de opțiuni',bulkActionDelete:'Șterge',bulkOverrideDeliveryHint:'La activare, adaugă doar metodele de livrare necesare (+). Programele de override existente pe produsele selectate sunt înlocuite. Intervalele inactive nu se salvează. Dezactivarea șterge programele existente.',bulkOverrideLocationsHint:'Lasă gol pentru toate locațiile companiei. Se aplică doar locațiile pe care le are deja fiecare produs.',bulkOverrideAddIntervalHint:'Apasă + pentru a adăuga un interval pentru această metodă.',bulkPriceDirection:'Direcție',bulkPriceIncrease:'Crește',bulkPriceDecrease:'Scade',bulkPriceMode:'Tip',bulkPriceFlat:'Sumă fixă',bulkPricePercent:'Procent (%)',bulkPriceAmount:'Valoare',bulkPriceBaseOnlyHint:'Se modifică doar prețul de bază. Noul preț nu va coborî sub 0.',bulkOptionGroupsMode:'Mod asociere',bulkOptionGroupsModeHint:'Adaugă păstrează grupurile existente. Înlocuiește le schimbă cu cele selectate.',bulkDeleteWarning:'Această acțiune va șterge {count} produse. Nu poate fi anulată ușor.',bulkDeleteEnableLabel:'Da, șterge produsele selectate (celelalte acțiuni în masă vor fi ignorate)',confirmBulkMultiple:'Aplică aceste modificări pe {count} {products}:',bulkProductSingular:'produs',bulkProductPlural:'produse',confirmBulkAreYouSure:'Ești sigur?',bulkSummaryAddLocations:'să adaugi locații ({value}) la {count} {products}',bulkSummaryRemoveLocations:'să elimini locații ({value}) de la {count} {products}',bulkSummarySetActive:'să setezi {count} {products} ca activ',bulkSummarySetInactive:'să setezi {count} {products} ca inactiv',bulkSummaryIncreasePriceFlat:'să crești prețul de bază la {count} {products} cu {amount} {currency}',bulkSummaryIncreasePricePercent:'să crești prețul de bază la {count} {products} cu {amount}%',bulkSummaryDecreasePriceFlat:'să scazi prețul de bază la {count} {products} cu {amount} {currency}',bulkSummaryDecreasePricePercent:'să scazi prețul de bază la {count} {products} cu {amount}%',bulkSummaryAddOptionGroups:'să adaugi grupuri de opțiuni ({value}) la {count} {products}',bulkSummaryReplaceOptionGroups:'să înlocuiești grupurile de opțiuni pe {count} {products} cu ({value})',bulkSummarySetVat:'să setezi TVA {value} pe {count} {products}',bulkSummarySetSection:'să setezi secția {value} pe {count} {products}',bulkSummaryEnableOverride:'să activezi suprascrierea setărilor pe {count} {products}',bulkSummaryEnableOverrideWithSchedule:'să înlocuiești programele de override pe {count} {products}',bulkSummaryDisableOverride:'să dezactivezi suprascrierea setărilor pe {count} {products}',bulkSummaryDelete:'să ștergi {count} {products}',bulkSummaryGeneric:'să actualizezi {count} {products}',confirmBulkAddLocations:'Ești sigur că vrei să adaugi locații la {count} produse?',confirmBulkRemoveLocations:'Ești sigur că vrei să elimini locații de la {count} produse?',confirmBulkSetActive:'Ești sigur că vrei să setezi {count} produse ca active?',confirmBulkSetInactive:'Ești sigur că vrei să setezi {count} produse ca inactive?',confirmBulkIncreasePriceFlat:'Ești sigur că vrei să crești prețul de bază la {count} produse cu {amount}?',confirmBulkIncreasePricePercent:'Ești sigur că vrei să crești prețul de bază la {count} produse cu {amount}%?',confirmBulkDecreasePriceFlat:'Ești sigur că vrei să scazi prețul de bază la {count} produse cu {amount}?',confirmBulkDecreasePricePercent:'Ești sigur că vrei să scazi prețul de bază la {count} produse cu {amount}%?',confirmBulkAddOptionGroups:'Ești sigur că vrei să adaugi grupuri de opțiuni la {count} produse?',confirmBulkReplaceOptionGroups:'Ești sigur că vrei să înlocuiești grupurile de opțiuni pe {count} produse?',confirmBulkSetVat:'Ești sigur că vrei să setezi TVA pe {count} produse?',confirmBulkSetSection:'Ești sigur că vrei să setezi secția pe {count} produse?',confirmBulkDelete:'Ești sigur că vrei să ștergi {count} produse?',confirmBulkGeneric:'Ești sigur că vrei să actualizezi {count} produse?',bulkLocationsUpdated:'Locațiile au fost actualizate pentru {updated} produse',bulkMassUpdated:'Au fost actualizate {updated} produse',couldNotFetchProductOptions:'Nu am putut prelua opțiunile de produs. Te rugăm să contactezi suportul'},vat:{selectVat:'Cota Tva',generalTaxes:'Taxe Generale',deleteVatSuccess:'TVA șters cu succes',deleteVatError:'Eroare! TVA-ul nu a fost șters'},magister:{syncLabel:'Sincronizare meniu Magister',syncPrices:'Sincronizare prețuri',syncStocks:'Sincronizare stocuri',magisterStatus:'Status Magister',magisterStatus1:'In Trimitere',magisterStatus2:'S-a trimis cu succes',magisterStatus3:'Trimiterea a eșuat',magisterStatus4:'Comanda a fost anulată'},catalogProdRewardsHints:{hint1:'Lasă gol pentru a putea aplica valoarea implicită din setări',hint2:'Pune 0 pentru a nu aplica punctele de loialitate pentru acest produs',hint3:'Adaugă o valoare pozivită pentru a trece peste valoarea implicită din setări'},catalogCateg:{no_discount_allowed:'Nu accepta discount la aceasta categorie pe pos!',disabledOrderSources:'Dezactivează categoria pentru sursele',disabledOrderSourcesHelp:'Categoria nu va fi disponibilă pe sursele selectate.',isAgeRestrict:'Restricție de vârstă',notification_email:'Notificare E-mail',single:'categorie',plural:'categorii',color:'Culoare',name:'Nume',image:'Imagine',displayType:'Tip afișare',shortDescription:'Scurtă Descriere',validFromTo:'Valabil de la - până la',areYouSure:'Ești sigur că vrei să {label} această categorie?',categAdded:'Categorie adăugată cu succes',categUpdated:'Categorie actualizată cu succes',categDeleted:'Categorie ștearsă cu succes',prodDeleted:'Produse ștearse cu succes',couldNotSave:'Poza de categorie nu a fost salvată, te rugăm să încerci mai târziu.',List:'Listă',Grid:'Grilă',assignTopCategory:'Asignează categorie de top',pleaseSelect:'Va rugam selectati / Nu are categorie părinte',categoriesWithoutParent:'Categorii fara parinte',topCategory:'Categorie de top',forceMethod:'Forteaza metodele de livrare',selectMethod:'Selecteaza metodele',enableMethod:'(Pentru activare scoate categoria de top)',vat:'TVA %',vatTitle:'TVA',included:'inclus',preparation_time_in_minutes:'Timp de preparare (minute)',areYouSureDeleteProducts:'Sigur dorești să ștergi toate produsele din această categorie?',deleteProducts:'Șterge toate produsele din această categorie',overrideSettingsHelp:'Când este activat, categoria apare în meniu doar pentru locația, metoda de livrare, ziua și intervalul orar selectate.',userLabelings:'Etichetări utilizator',userLabelingsHelp:'Această categorie va fi vizibilă doar pentru utilizatorii cu una din aceste etichete',schedule:'Orar',useSchedule:'Folosește orar',scheduleActive:'Orar activ',scheduleHelp:'Un singur orar pentru această categorie de top, valabil în toate locațiile. În afara acestor intervale, comanda din această categorie nu este disponibilă în aplicație.',secondaryMember:'secundar'},catalogProdOpt:{addNewOptionValue:'Adauga Optiune Noua',active:'Status Valoare Optiune',image:'Imagine Optiune',generalInformation:'Informatii Generale',settings:'Setari',optionType:'Tip Optine',info:'Informatii optiune (nutritionale)',infoPlaceholder:'Aceste informatii vor aparea sub optiune pe kiosk/qr',single:'Opțiune',plural:'opțiuni',new:'Opțiune Nouă',name:'Nume',option_name:'Nume Optiune',label:'Etichetă (vizibilă doar in panoul de administrare)',type:'Tip',show_type:'Cum apare în aplicație',show_type_kiosk:'Cum apare pe Kiosk / Comanda la masă',vat:'Cota TVA optiune',vatSGR:'Cota TVA SGR',section:'Sectia Optiunii',value:'Valoare',values:'Valori',posid:'POS ID 1 (integrari)',posid2:'POS ID 2 (integrari)',variants_id:'Pos ID Variants (integrari)',optionSaved:'Opțiune produs salvată cu succes.',areyouSure:'Ești sigur că dorești să ștergi această opțiune?',optLocationError:'Optiunea {opt_name} trebuie sa includa locația {loc_name}',menuQr:'Meniu QR',displayInMenu:'Afișați în meniu QR',alsoSaveProduct:'După modificarea și salvarea opțiunilor este necesar să salvați și produsele pe care sunt aplicate acestea. Vizitați pagina de',sgrName:'Taxa SGR',sgrPos:'POS ID SGR',sgrPrice:'Pret SGR',isModifier:'Plus/No/Side in POS',isProduct:'Opțiune este produs',isProductDesc:'ex: cola, frișcă, bacon, ciuperci, mare, mic, etc...',isModifier2:'Opțiune este modificator',isModifierDesc:'ex: cald, rece, bine făcut, etc... (NU ARE IMPLICAȚII ÎN GESTIUNE)',productIdRequired:'Product ID este obligatoriu pentru toate valorile când opțiunea este setată ca produs!'},marketingSubscriptions:{single:'abonament',refundPayment:'Returnează suma',reason:'Motiv (obligatoriu)',reasonRequired:'Scrie motivul',cancelSubscription:'Anulează abonamentul',cancelHint:'Abonamentul se oprește acum și nu se mai reînnoiește. Nu se returnează bani (pentru asta folosește butonul de la fiecare plată).',cancelAreYouSure:'Anulezi abonamentul acum?',cancelDone:'Abonamentul a fost anulat',downgrade:'Retrogradează',downgradeTo:'Mută pe nivelul',downgradeHint:'Clientul trece acum pe un nivel mai mic; următoarea reînnoire va fi la prețul acelui nivel. Nu se mișcă bani.',downgradeAreYouSure:'Muți clientul pe {name} acum?',downgradeDone:'Abonamentul a fost mutat pe nivelul mai mic',history:'Istoric acțiuni',noHistory:'Nicio acțiune a operatorului încă.',eventCancel:'Anulat',eventDowngrade:'Retrogradat',eventRefund:'Sumă returnată',payRefunded:'Rambursată',refundAndCancel:'Rambursează și anulează abonamentul',refundHint:'Suma de {amount} a acestei plăți se returnează clientului (reversal dacă tranzacția nu e încă încasată, refund dacă e încasată). Abonamentul NU se modifică: pentru asta folosește Anulează / Retrogradează de sus.',refundComment:'Motiv (obligatoriu)',refundCommentRequired:'Scrie motivul rambursării',refundConfirm:'Confirmă rambursarea',refundAreYouSure:'Returnezi {amount} clientului? Abonamentul nu se modifică.',refundDone:'Plata a fost returnată',refundTypeRefund:'Refund',refundTypeReversal:'Reversal',dateFrom:'De la',dateTo:'Până la',renewalCancelledAt:'A renunțat la reînnoire pe',customerActiveSubscriptions:'Abonamente active',customerNoSubscriptions:'Niciun abonament activ',until:'până la',newCoupon:'Cupon nou',newCouponTitle:'Cupon nou pentru abonament',inheritedFromLevel:'Din nivelul {level} - {name}',ownCouponsTitle:'+ Cupoanele acestui nivel',inheritedIncluded:'inclus din nivelul {level} - {name}',details:'Detalii',name:'Nume',price:'Preț',description:'Descriere (cum funcționează)',image:'Poză',imageHint:'jpg / png, max 5MB',active:'Activ',status:'Status',coupons:'Cupoane',couponsHint:'Doar cupoanele bifate "Cupon pentru abonament". Clientul primește și cupoanele nivelurilor de dedesubt.',selectedCount:'{count} selectate',searchCoupons:'Caută cupon după nume sau cod',noCoupons:'Nu există încă cupoane de abonament. Creează unul cu butonul "Cupon nou".',noCouponsFound:'Niciun cupon nu corespunde căutării.',multipleCodes:'Coduri multiple',freeProduct:'Produs gratuit',inactive:'inactiv',noneAssigned:'Fără cupoane',actions:'Acțiuni',saved:'Abonamentul a fost salvat',deleted:'Abonamentul a fost șters',areYouSureDelete:'Sigur vrei să ștergi abonamentul',deleteLastLevelWarning:'Este singurul nivel, așa că se șterge și familia.',nameRequired:'Numele este obligatoriu',priceRequired:'Prețul este obligatoriu (0 sau mai mare)',noSubscriptions:'Nu ai încă abonamente. Adaugă primul.',levelsCount:'{count} niveluri',oneLevel:'1 nivel',activeSubscribersCount:'{count} abonați activi',paymentAccount:'Cont de plată',editFamily:'Editează familia',allSubscribers:'Toți abonații',subscribers:'Abonați',addLevelOnTop:'Adaugă nivel peste {name}',level:'Nivel',benefits:'Beneficii',inheritedCount:'+{count} din nivelurile de dedesubt',inheritedTitle:'Moștenite din nivelurile de dedesubt',lockedDelete:'Are abonați (activi sau care așteaptă plata), îl poți doar dezactiva.',notTopDelete:'Doar ultimul nivel din familie poate fi șters.',inactiveHint:'Inactiv = nu se mai poate cumpăra. Cei care îl au îl păstrează și se reînnoiesc.',family:'Familie',familyName:'Numele familiei',familyNew:'Familie nouă',familyExisting:'Adaugă într-o familie existentă',familyNameHint:'Implicit, numele abonamentului',selectFamily:'Alege familia',familyRequired:'Alege familia',willBeLevel:'Va fi nivelul {level}, peste {name} ({price})',levelOf:'Nivelul {level} din familia {family}',priceHintBelow:'Nivelul de dedesubt: {name} - {price}. Diferența la upgrade: {diff}',priceHintAbove:'Nivelul de deasupra: {name} - {price}',priceTooLow:'Prețul trebuie să fie mai mare decât al nivelului de dedesubt ({price})',priceTooHigh:'Prețul trebuie să fie mai mic decât al nivelului de deasupra ({price})',inheritedCoupons:'Beneficii moștenite',noInherited:'Fără beneficii moștenite (nivel de bază).',paymentProcessor:'Procesator de plăți',paymentRequired:'Alege procesatorul de plăți',noPaymentAccounts:'Compania nu are niciun procesator de plăți euPlatesc. Adaugă unul din Setări > Plăți.',paymentLockedHint:'Procesatorul de plăți nu se poate schimba cât timp familia are abonați activi.',familySaved:'Familia a fost salvată',familyNameRequired:'Numele familiei este obligatoriu',subscribersTitle:'Abonați',stateAll:'Toți',stateActive:'Activi',stateExpiring:'Expiră în 5 zile',stateUnpaid:'Neplătit',stateExpired:'Expirați',stateCancelled:'Anulați',statePending:'Așteaptă prima plată',stateAbandoned:'Abandonat (neplătit)',customer:'Client',activeFrom:'Activ de la',activeUntil:'Activ până la',activeUntilRange:'Activ până la (interval)',autoRenew:'Reînnoire automată',autoRenewAll:'Reînnoire: toate',yes:'Da',no:'Nu',totalPaid:'Total plătit',lastPayment:'Ultima plată',searchSubscribers:'Caută după nume, email sau telefon',allLevels:'Toate nivelurile',noSubscribers:'Niciun abonat pentru filtrele alese.',backToList:'Înapoi la listă',periods:'Istoric pe luni',kindFirst:'Prima plată',kindRenewal:'Reînnoire',kindUpgrade:'Upgrade',periodPaid:'Plătit',periodUnpaid:'Neplătit',periodCancelled:'Anulat',paymentAttempts:'Încercări de plată',methodLink:'Link de plată',methodSavedCard:'Card salvat',payCreated:'Creată',payPending:'În așteptare',paySuccess:'Reușită',payFailed:'Eșuată',payExpired:'Expirată',payCancelled:'Anulată',showLogs:'Loguri procesator',request:'Request',response:'Răspuns',noPeriods:'Nu există încă perioade.',noPayments:'Nicio încercare de plată.',card:'Card',currentLevel:'Nivel curent',renewalPrice:'Preț reînnoire',subscriberSince:'Abonat din',autoChargeAttempts:'Încercări de debitare automată',notifiedAt:'Notificare de expirare trimisă'},marketingAutomation:{single:'campanie automată',details:'Detalii campanie automată',name:'Nume',type:'Tip campanie',period:'Perioada de funcționare',active:'Activă',status:'Status',notifications:'Notificări',coupons:'Cupoane',state_running:'În desfășurare',state_scheduled:'Programată',state_ended:'Încheiată',typeBirthday:'Zi de naștere',typeGeofencing:'Geofencing (în rază)',typeAbandonedCart:'Produse uitate în coș',typeProductViews:'Produs văzut de mai multe ori',comingSoon:'în curând',typeLocked:'Tipul nu se mai poate schimba după crearea campaniei.',birthdayRule:'Cupoanele se aplică automat doar în ziua de naștere a clientului, o singură dată pe an. Un client care a beneficiat deja anul acesta nu mai este notificat.',announceTitleBox:'Anunț înainte de ziua de naștere',announceDaysBefore:'Trimite-l cu',daysBeforeBirthday:'zile înainte de ziua de naștere',announceOffHint:'Fără anunț: clientul primește doar notificarea din ziua respectivă.',announceDaysBeforeShort:'Anunț cu {days} zile înainte',announceDaysInvalid:'Între 1 și {max} zile.',dayTitleBox:'Notificare în ziua de naștere',onTheDayShort:'În ziua de naștere',sentAt:'trimise la {time}',endsIn:'se încheie în {days} zile',endsToday:'se încheie azi',startsIn:'începe în {days} zile',pushTitle:'Titlu notificare',pushMessage:'Text notificare',sendTime:'Ora de trimitere',sendTimeHint:'Notificările se trimit la această oră (fusul orar al companiei).',preview:'Previzualizare',placeholdersHint:'Poți folosi în text (click pentru a adăuga):',clickToInsert:'Click pentru a-l adăuga în text',placeholderName:'prenumele clientului',placeholderDays:'câte zile mai sunt până la ziua de naștere',placeholderCode:'codul cuponului (informativ)',codeNeedsCoupon:'disponibil după ce selectezi un cupon (mai jos)',codeNotInNoCoupon:'nu se folosește în notificarea fără cupon',codeWithoutCoupon:'Campania nu are cupon: {cod} se trimite gol (textul pleacă fără cod).',exampleAnnounceNoCouponTitle:'Ziua ta se apropie! Mai sunt {zile} zile 🎉',exampleAnnounceNoCouponMessage:'Bună, {nume}! Ne bucurăm să fim alături de tine la acest moment frumos. Vino cu prietenii la noi sau comandă din aplicație și hai să sărbătorim împreună!',exampleDayNoCouponTitle:'La mulți ani, {nume}! 🎂',exampleDayNoCouponMessage:'Îți dorim o zi minunată, plină de bucurii și oameni dragi alături. Te așteptăm cu drag să sărbătorim împreună!',optional:'opțional',cartRule:'Doar coșurile din aplicație ale clienților logați, create după pornirea campaniei, mai noi de 5 zile și cu produse. Notificarea 1 pleacă la X minute după ultima modificare a coșului (cu cuponul, valabil 24h, o singură dată, pe orice comandă). Notificarea 2 doar dacă prima a fost trimisă și coșul nu s-a mai modificat. Maxim 2 notificări pe coș; un coș nou = notificări noi.',cartFirstBox:'Notificarea 1',variantWithCoupon:'cu cupon',variantNoCampaignCoupon:'reminder (campania nu are cupon)',variantNoCoupon:'fără cupon',noCouponNeedsCoupon:'disponibilă după ce selectezi un cupon (mai jos); fără cupoane, toți primesc notificarea de mai sus',cartFirstDelay:'Trimite-o la',minutesAfterChange:'minute după ultima modificare a coșului',cartNoCouponBox:'Notificarea 1 fără cupon',cartNoCouponHint:'Pleacă în locul celei de mai sus clienților care nu primesc cupon de data asta (au primit deja unul în ultimele X zile – vezi „Recurența cuponului” – sau cuponul nu mai e valabil). Nu promite reducere aici.',cartSecondBox:'Notificarea 2',cartSecondDelay:'Trimite-o la',minutesAfterFirst:'minute după notificarea 1',cartSecondHint:'Doar dacă notificarea 1 a fost trimisă și clientul nu a mai modificat coșul. Pleacă și la clienții fără cupon, așa că scrie-o general (sau folosește {cod}, gol pentru ei).',cartSecondOffHint:'Se trimite doar notificarea 1.',quietBox:'Ore de liniște (fără notificări noaptea)',quietFrom:'de la',quietTo:'până la',quietHint:'O notificare care ar cădea în acest interval pleacă imediat după ce se termină (fusul orar al companiei). Notificarea 2 se calculează de la ora la care a plecat efectiv prima.',quietOffHint:'Notificările pleacă la orice oră.',cooldownBox:'Recurența cuponului',cooldownLabel:'Cuponul din nou abia după',cooldownNeedsCoupon:'disponibil după ce selectezi un cupon (mai sus)',cooldownDays:'zile (0 = la fiecare coș uitat)',cooldownHint:'După ce un client a primit un cupon de coș, coșurile uitate din acest interval primesc doar reminder-ul (textul fără cupon).',cartFirstWhen:'la {time} după ultima modificare',cartSecondWhen:'la {time} după notificarea 1',unitDay:'z',delayInvalid:'Între {min} și {max} minute.',cooldownInvalid:'Între 0 și {max} zile.',quietInvalid:'Începutul și sfârșitul orelor de liniște trebuie să fie diferite.',exampleCartFirstTitle:'{nume}, ai uitat ceva în coș 🛒',exampleCartFirstMessage:'Produsele tale te așteaptă! Finalizează comanda în următoarele 24 de ore și ai 10% reducere cu codul {cod} – se aplică automat.',exampleCartNoCouponTitle:'{nume}, coșul tău te așteaptă 🛒',exampleCartNoCouponMessage:'Produsele alese sunt încă în coș. Finalizează comanda în câteva secunde, din aplicație.',exampleCartSecondTitle:'Ultima șansă, {nume}!',exampleCartSecondMessage:'Coșul tău e încă aici. Nu rata ce ți-ai ales – comandă acum din aplicație.',statusAllSent:'Notificați',status_notified:'Doar reminder',status_converted:'Coș comandat',cartStatusGranted:'Cupon activ',cartStatusUsed:'A folosit cuponul',validUntil:'până la {time}',cart:'Coș',cartPush1Short:'Notif. 1',cartPush2Short:'Notif. 2',cartPlaced:'comandat',beneficiaries:'Beneficiari',beneficiariesTitle:'Beneficiari',viewBeneficiaries:'Vezi lista',statusAll:'Toți',status_granted:'Acordat',status_used:'A beneficiat',status_expired:'Expirat (nefolosit)',customer:'Client',birthday:'Ziua de naștere',yearLabel:'anul {year}',order:'Comandă',searchCustomer:'Caută nume, telefon, email...',allYears:'Toți anii',noBeneficiaries:'Nimeni deocamdată.',announcePushShort:'Anunț',dayPushShort:'În zi',pushNotSent:'netrimis',push_sent:'trimis',push_nodevice:'fără notificări',push_failed:'eșuat',useExample:'Folosește exemplul',useExampleConfirm:'Înlocuiești titlul și textul actual cu exemplul?',previewExampleNote:'Câmpuri goale: previzualizarea arată textul exemplu.',codeMissing:'Textul folosește {cod}, dar niciun cupon selectat nu are cod.',exampleAnnounceTitle:'Ziua ta se apropie! Mai sunt {zile} zile 🎉',exampleAnnounceMessage:'Bună, {nume}! Ne bucurăm să fim alături de tine la acest moment frumos, așa că de ziua ta îți oferim 20% reducere la o comandă de minimum 100 lei, cu codul {cod}. Vino cu prietenii la noi sau comandă din aplicație și hai să sărbătorim împreună!',exampleDayTitle:'La mulți ani, {nume}! 🎂',exampleDayMessage:'Azi e ziua ta, iar cadoul nostru te așteaptă: 20% reducere la toate preparatele, la o comandă de minimum 100 lei. Codul tău {cod} se aplică automat. Bucură-te de el chiar acum!',couponsHint:'Opțional: fără cupon, campania trimite doar notificările. Apar doar cupoanele bifate „Se folosește în marketing automat”; clientul primește toate cupoanele selectate.',selectedCount:'{count} selectate',newCoupon:'Cupon nou',newCouponTitle:'Cupon nou de marketing automat',noCoupons:'Nu există încă niciun cupon de marketing automat. Creează unul cu „Cupon nou”.',searchCoupons:'Caută cupon...',noCouponsFound:'Niciun cupon găsit.',couponsRequired:'Selectează cel puțin un cupon.',couponInactive:'Cupon inactiv',inactive:'inactiv',expired:'expirat',saved:'Campania a fost salvată.',deleted:'Campania a fost ștearsă.',areYouSureDelete:'Sigur vrei să ștergi campania {name}?'},marketingCoupons:{single:'cupon',isAutomation:'Se folosește în marketing automat',isAutomationHint:'Cuponul nu se aplică tuturor și codul lui nu poate fi introdus: se aplică automat doar clienților cărora li-l acordă o campanie automată (ex. de ziua lor).',automationCampaigns:'Campanii automate',automationLockedUsed:'Acordat de campanii automate: scoate-l întâi din ele.',automationLockedCampaign:'Anunțat de campanii push: nu poate fi folosit în marketing automat.',automationInfoCode:'Cupon de marketing automat: codul este doar informativ (poate apărea în notificări cu {cod}). Nu poate fi introdus nicăieri: reducerea se aplică automat clienților care îndeplinesc condițiile campaniei.',automationCodeLabel:'Cod informativ (opțional)',automationCodePlaceholder:'ex. ZINASTERE20',automationBadge:'Automat',subscriptionAutomationExclusive:'Un cupon nu poate fi și de abonament, și de marketing automat.',isSubscription:'Cupon pentru abonament',isSubscriptionHint:'Se aplică doar clienților cu un abonament activ care îl include: fără cod, niciodată aplicat automat, fără limite de utilizare.',subscriptionBadge:'Abonament',subscriptionLevels:'Inclus în abonamentele',subscriptionLockedUsed:'Cuponul e inclus în abonamente: scoate-l din ele ca să-l poți debifa.',subscriptionLockedCampaign:'Cuponul e anunțat în campanii push, deci nu poate deveni cupon de abonament.',subscriptionNoCode:'Cuponul de abonament nu are cod: se aplică doar clienților cu abonament activ.',name:'Nume',code:'Cod',multipleCodes:'Coduri multiple',discount:'Reducere',freeProduct:'Produs gratuit',validFromTo:'Valabil de la - până la',daysLeft:'Zile rămase',status:'Status',active:'Activ',pushCampaigns:'Campanii push',notAssigned:'Neasignat',couponDetails:'Detalii cupon',couponSaved:'Cuponul a fost salvat.',couponDeleted:'Cuponul a fost șters.',areYouSureDelete:'Ești sigur că vrei să ștergi cuponul',deleteAssignedWarning:'Cuponul este anunțat de campaniile push: {campaigns}. Acestea vor rămâne fără cupon.',selectCoupon:'Cuponul anunțat de campanie',selectCouponHelp:'Reducerea este aplicată de cupon (cu valabilitatea și condițiile lui). Campania doar îl anunță. Cupoanele se gestionează din tab-ul Cupoane.',noCoupon:'Fără cupon',couponInactive:'Cuponul selectat este inactiv.',couponOutsideCampaign:'Perioada campaniei iese din valabilitatea cuponului.',deleteCampaignCouponQuestion:'Campania anunță cuponul {coupon}. Cuponul nu se șterge odată cu campania. Ce faci cu el?',keepCouponActive:'Păstrează cuponul neschimbat',deactivateCoupon:'Dezactivează cuponul',export:'Export',openQr:'Deschide imaginea QR',qrLink:'Link imagine QR',used:'Folosit',sources:'Surse comenzi',allSources:'Toate',noCategories:'Nu există categorii / produse',generatorTitle:'Generare coduri',generatorCount:'Număr de coduri (max 1000)',generatorLength:'Lungimea părții aleatorii',generatorCharset:'Caractere',generatorCharsetAlnum:'Litere + cifre (fără 0/O, 1/I/L)',generatorCharsetLetters:'Doar litere',generatorCharsetDigits:'Doar cifre',generatorPrefix:'Prefix (în față)',generatorSuffix:'Sufix (în spate)',generatorGroup:'Grupare cu "-"',generatorGroupNone:'Fără grupare',generatorExample:'Exemplu',generate:'Generează',generatedCodes:'Au fost generate {count} coduri. Salvează cuponul ca să le păstrezi.',deleteAllCodes:'Șterge toate',deleteAllCodesConfirm:'Ștergi toate cele {count} coduri? Codurile deja salvate se șterg la salvarea cuponului.',codeStatus_available:'Disponibil',codeStatus_used:'Folosit',codeStatus_new:'Nou (nesalvat)'},marketingCampaigns:{intern:'Intern',extern:'Extern',url:'URL',category:'Categorie',product:'Produs',single:'campanie',plural:'campanii',name:'Nume',nameHelper:'Acest nume va fi folosit ca subiect in notificarile trimise pe e-mail.',image:'Imagine',startEnd:'Start - Sfârșit Perioadă',daysLeft:'Zile rămase',timesUsed:'Nr. folosiri',status:'Status',actions:'Acțiuni',send:'Trimite',stopSending:'Oprește trimiterea',campaignStoppedSuccessfuly:'Trimiterea campaniei a fost oprită',areYouSureCancelSending:'Sigur vrei să oprești trimiterea',notBeingSending:'nu se trimite',cannotDelete:'Campania nu poate fi ștearsă in timp ce este trimisă',cannotModify:'Campania nu poate fi modificată in timpul trimiterii',off:'din',sentData:'Date despre trimitere',sent:'Total trimise',notif_sent:'Notificări',email_sent:'E-mailuri',areYouSureNotif:'Ești sigur că dorești să trimiți aceste notificări?',notifSent:'Notificările au fost puse în listă și urmează a fi trimise!',campaignDeleted:'Campanie ștearsă cu succes.',areYouSureDelete:'Ești sigur că vrei să ștergi ',campaignAdded:'Campanie adăugată cu succes',campaignUpdated:'Campanie actualizată cu succes',campaignPhotoError:'Poza de campanie nu a fost salvată, te rugăm să încerci mai târziu.',campaignDetails:'Detalii Campanie',description:'Text notificari',maxDescription:'(max. 400 caractere)',characters:'caractere',validFromTo:'Valabil de la - până la',notif:'Notificări',mode:'Mod',setHours:'Setează Orele',selectTime:'Alege Ora',chooseTarget:'Alege publicul țintă',gender:'Gen',age:'Vârstă',city:'Oraș',locations:'Locații',visibleInLocations:'Categorie vizibilă în următoarele locații',visibleInLocationsInfo:'Această funcționalitate este disponibilă doar în Aplicație',ordersAbove:'Comenzi mai sus',ordersBelow:'Comenzi mai jos',ordersAboveNr:'Nr comenzi mai sus',ordersBelowNr:'Nr comenzi mai jos',addCoupon:'Adaugă cupon',applyTo:'Aplică la',value:'Valoare',code:'Cod',addValue:'Adauga Valoare',minValue:'Suma Minima',counter_max_usage:'De cate ori poate folosi o persoana acest cupon?',counter_max_usage_example:'Tastați numarul maxim de utilizari/persoana. Tastati 0 pentru nelimitat.',counter_max_usage_total:'De cate ori poate folosi acest cupon in total?',counter_max_usage_total_example:'Tastați numarul maxim de utilizari. Tastati 0 pentru nelimitat.',generateCode:'Generează Cod',Products:'Produse',Shipping:'Livrare',Tax:'Taxe',chooseCategProduct:'Alege categoriile sau produsele pe care se va aplica cuponul:',delivery_methods:'Pe care metode de livrare sa se aplice cuponul?',order_source_ids:'Surse comenzi',order_source_ids_all:'Toate sursele',order_source_ids_help:'Lasă gol pentru a aplica cuponul pe toate sursele de comenzi.',location_ids:'Pe care locatii sa se aplice cuponul?',sendNotificationTo:'Trimite notificare la',chooseDayForInterval:'Alegeți ziua pentru interval',chooseHoursForInterval:'Alegeți orele pentru interval',useInterval:'Folosește interval',isCumulativeCheck:'Acest cupon se aplica cumulat',isAutoApplyCheck:'Acest cupon se aplica direct',doesApplyOnPromotionalItems:'Acest cupon se aplica doar pe produsele din promoție',intervalMustBeSet:'Intervalul trebuie setat',campaignWasSent:'Campania a fost trimisă în ultimele 30 de min',isSecondUseCheck:'Acest cupon se aplica direct dupa prima utilizare',couponHasMultipleCodes:'Foloseste mai multe coduri de coupon',withOrdersLabel:'Cu/fără comenzi',withOrders:'cu comenzi',withoutOrders:'fără comenzi',withLoyaltyPointsLabel:'Puncte de loialitate',withLoyaltyPointsAll:'Toți',withLoyaltyPoints:'cu puncte',withoutLoyaltyPoints:'fără puncte',loyaltyPointsColumn:'Puncte de loialitate',groups:'Grupuri clienți',exclude_groups:'Exclude Grupuri clienți',chooseImage:'Alege o imagine',template:'Model',useEmailTemplate:'Folosește textul atât pentru notificări cât și pentru email',productTreeError:'Bifați cel puțin un produs',checkAll:'Bifează tot',freeProduct:'Produs gratuit de adăugat în coș',freeProductPlaceholder:'Tastează numele produsului pentru a căuta...',freeProductRequired:'Selectează un produs gratuit',freeProductSelectTypeHint:'Selectează tipul «Produs gratuit» de mai sus pentru a alege produsul care se adaugă în coș.',freeProductHelp:'Acesta este produsul adăugat automat în coșul clientului. Lista din dreapta definește produsele/categoriile pentru care se aplică cuponul.',freeProductSearchHint:'Începe să tastezi numele produsului pentru a-l găsi și selecta.',minOrderValue:'Subtotal minim comandă',minOrderValuePlaceholder:'0 = fără minim',minOrderValueHelp:'Produsul gratuit se aplică doar când subtotalul comenzii (produse + extra) este cel puțin această valoare. Lasă gol sau 0 pentru fără minim.',registeredAfter:'Înregistrat după',period:'De la - până la',location:'Locația',open:'Deschide'},loyaltyStore:{campaignName:'Nume campanie',description:'Descriere',generalSettings:'Setări generale',active:'Activ',availability:'Disponibilitate',locations:'Locații',locationsInfo:'Lasă gol pentru toate locațiile',rewards:'Recompense',rewardsCount:'Recompense',addReward:'Adaugă recompensă',editReward:'Editează recompensa',reward:'Recompensă',rewardType:'Tip',typeProduct:'Produs',typeGiftCard:'Gift card',product:'Produs',category:'Categorie',searchCategory:'Caută categorie',searchProduct:'Caută produs',giftCardValue:'Valoare gift card',pointsCost:'Cost puncte fidelitate',deleteConfirmation:'Ești sigur că vrei să ștergi?',rewardsSaveFailed:'Campania a fost salvată, dar unele recompense nu au putut fi salvate. Recompensele rămase sunt păstrate aici. Apasă Salvează pentru a reîncerca.',nameRequired:'Numele campaniei este obligatoriu',pointsCostRequired:'Costul în puncte este obligatoriu',productRequired:'Produsul este obligatoriu',giftValueRequired:'Valoarea gift card este obligatorie',giftCardsModuleRequired:'Activează gift card-urile de marketing pe companie pentru recompense tip gift card.',timesSold:'Vânzări',totalPointsSpent:'Total puncte cheltuite',totalGiftValue:'Valoare gift cards emise',purchases:'Achiziții',user:'Utilizator',orderId:'ID comandă',giftCardId:'ID gift card',datetime:'Dată și oră',campaign:'Campanie'},donationCampaigns:{single:'campanie donație',plural:'campanii donații',id:'ID',search:'Caută',name:'Nume',beneficiary:'Beneficiar',description:'Descriere',image:'Imagine',startEnd:'Data început - sfârșit',daysLeft:'Zile rămase',targetAmount:'Sumă țintă',suggestedAmount:'Sumă sugerată',collectedAmount:'Sumă colectată',progress:'Progres',donorsCount:'Donatori',donationsCount:'Donații',details:'Detalii Campanie Donație',stats:'Statistici',active:'Activ',location:'Locații',locationInfo:'Lasă gol pentru a fi disponibilă în toate locațiile',allCampaigns:'Toate campaniile',areYouSureDelete:'Ești sigur că vrei să ștergi',campaignDeleted:'Campania de donație a fost ștearsă cu succes.',campaignAdded:'Campania de donație a fost adăugată cu succes.',campaignUpdated:'Campania de donație a fost actualizată cu succes.',removeCurrentImage:'Te rugăm să ștergi imaginea curentă înainte de a adăuga una nouă',fundingMode:'Mod finanțare',fundingModeClientOptional:'Clientul alege donația la checkout',fundingModeRestaurantFlat:'Restaurantul plătește o sumă fixă per comandă',fundingModeRestaurantPercent:'Restaurantul plătește un procent din subtotalul comenzii',restaurantFlatAmount:'Sumă per comandă',restaurantPercent:'Procent din subtotalul comenzii (0–100)',allLocations:'Toate locațiile',onlyOneActivePerLocation:'Poate exista o singură campanie de donație activă per locație.',fiscalizationInfoPrefix:'Pentru a configura cum sunt fiscalizate donațiile, deschide ',fiscalizationInfoLink:'Locații,',fiscalizationInfoSuffix:' editează locația, mergi la Alte setări → Setări Pos și setează "{field}".',activeCampaignExistsTitle:'Campanie salvată',activeCampaignExistsMessage:'Campania a fost salvată cu succes, dar există o altă campanie activă ({name}). Dorești să activezi această campanie în loc?',activeCampaignExistsActivateMessage:'Există o altă campanie activă ({name}). Dorești să activezi această campanie în loc?',activeCampaignExistsWarning:'Atenție: aceasta înseamnă că cealaltă campanie nu va mai fi vizibilă pentru utilizatori!'},raffleCampaigns:{single:'campanie tombolă',plural:'campanii tombolă',id:'ID',name:'Nume',search:'Caută',searchParticipants:'Caută email sau nume',userId:'ID utilizator',description:'Descriere',winnersDescription:'Lista câștigătorilor',winnersPlaceholder:'Utilizează acest câmp pentru a informa utilizatorii despre cine a câștigat tombola',image:'Imagine',startEnd:'Început - Sfârșit',details:'Detalii campanie tombolă',active:'Activ',type:'Tip',typeOrderCount:'Tombolă',typeOrderTotal:'Erou',typeOrderCountHint:'Pe baza numărului de comenzi. Câștigătorul aleatoriu este ales cu un instrument terț.',typeOrderTotalHint:'Câștigătorul este determinat pe baza sumei cheltuite în aplicație.',typeLocked:'Tipul nu poate fi schimbat după creare.',typeRequired:'Tipul este obligatoriu.',minOrderValue:'Valoare minimă comandă',pdf:'PDF',periodRequired:'Datele de început și sfârșit sunt obligatorii.',areYouSureDelete:'Ești sigur că vrei să ștergi',campaignDeleted:'Campania tombolă a fost ștearsă cu succes.',campaignAdded:'Campania tombolă a fost adăugată cu succes.',campaignUpdated:'Campania tombolă a fost actualizată cu succes.',removeCurrentImage:'Te rugăm să ștergi imaginea curentă înainte de a adăuga una nouă',removeCurrentPdf:'Te rugăm să ștergi PDF-ul curent înainte de a adăuga unul nou',usersJoined:'Utilizatori înscriși',ordersCount:'Număr comenzi',ordersTotal:'Total comenzi',participants:'Participanți',exportEntries:'Export înscrieri',joinedAt:'Data înscrierii',score:'Scor',orderNumber:'Număr comandă',orderCreatedAt:'Data comenzii',registeredAt:'Data înregistrării'},challengeCampaigns:{single:'provocare',plural:'provocări',id:'ID',search:'Caută',searchByTitle:'Caută după titlu',title:'Titlu',titlePlaceholder:'ex. Early Bird',description:'Descriere',descriptionPlaceholder:'ex. Comandă 5 cafele înainte de ora 9',image:'Imagine',details:'Detalii provocare',target:'Țintă',minOrderValue:'Valoare minimă comandă',periodOfTimeDays:'Perioadă membru (zile)',periodOfTimeDaysHint:'ex. 365 = client de 1 an de la prima comandă',distinctOrder:'Comandă distinctă',distinctOrderHint:'Când este activ, fiecare comandă eligibilă contează ca 1 pas, indiferent de cantitate.',timePeriod:'Perioada provocării',orderTimeFrom:'Ora comenzii de la',orderTimeTo:'Ora comenzii până la',conditions:'Condiții (ȘI)',conditionsAndInfo:'Condițiile configurate se combină cu ȘI. Lasă o condiție goală pentru a o ignora.',deliveredOnlyInfo:'Doar comenzile în status Livrat contează pentru progres.',goalGroup:'Obiectiv',orderFiltersGroup:'Filtre comandă',scheduleGroup:'Program',catalogGroup:'Produse & categorii',locations:'Locații',deliveryMethods:'Metode livrare',sources:'Surse comandă',days:'Zilele săptămânii',products:'Produse',categories:'Categorii',leaveEmptyAll:'Lasă gol pentru toate',daySun:'Duminică',dayMon:'Luni',dayTue:'Marți',dayWed:'Miercuri',dayThu:'Joi',dayFri:'Vineri',daySat:'Sâmbătă',summaryMembership:'Utilizatorul trebuie să fie client de cel puțin {days} zile (țintă {target}).',summaryOrders:'Finalizează {target} comenzi.',summaryProductQty:'Ajunge la o cantitate totală de {target} din produsele/categoriile selectate.',summaryMinOrder:'Doar comenzi cu valoare minimă de {amount} {currency}.',summaryLocations:'Doar la: {list}.',summaryDelivery:'Doar metode: {list}.',summarySources:'Doar surse: {list}.',summaryDays:'Doar în: {list}.',summaryOrderTime:'Doar între {from} și {to}.',summaryPeriod:'Provocarea este disponibilă de la {from} până la {to}.',summaryProducts:'Produse: {list}.',summaryCategories:'Categorii: {list}.',summaryWithinDays:'Progresul trebuie finalizat în {days} zile.',areYouSureDelete:'Ești sigur că vrei să ștergi',campaignDeleted:'Provocarea a fost ștearsă.',campaignAdded:'Provocarea a fost adăugată.',campaignUpdated:'Provocarea a fost actualizată.',removeCurrentImage:'Șterge imaginea curentă înainte de a adăuga una nouă',dateFrom:'Data de la',dateTo:'Data până la',reportDateHint:'Statisticile de finalizare folosesc data completării. Progresul folosește data ultimului progres.',completedUsers:'Finalizate',inProgressUsers:'În progres',startedUsers:'Începute',completionRate:'Rată finalizare',allUsers:'Toți',status_COMPLETED:'Finalizat',status_IN_PROGRESS:'În progres',status_NOT_STARTED:'Neînceput',user:'Utilizator',progress:'Progres',startedAt:'Primul progres',lastProgressAt:'Ultimul progres',completedAt:'Finalizat la',userProgress:'Progres utilizator',dateTime:'Data / ora',orderId:'ID comandă',progressGenerated:'Progres'},spinningWheel:{confirmDelete:'Sigur dorești să ștergi această înregistrare?',percentageOverflow:'Probabilitățile premiilor active nu pot depăși 100%. Modificarea nu a fost salvată.',campaignTitle:'Titlu campanie',description:'Descriere',availability:'Disponibilitate',minOrderValue:'Valoare minimă comandă',locations:'Locații',locationsInfo:'Lasă gol pentru a aplica la toate locațiile.',rewardsCount:'Premii',percentages:'Total % câștig',active:'Activ',generalSettings:'Setări generale',activeRequires100:'Campania poate fi activată doar când premiile active însumează exact 100%.',mustTotal100:'trebuie să însumeze 100%',rewards:'Premii',addReward:'Adaugă premiu',editReward:'Editează premiu',reward:'Premiu',rewardType:'Tip premiu',winningPercentage:'Probabilitatea în % de câștig',displayTitle:'Titlu afișat',displayDescription:'Descriere afișată',loyaltyPoints:'Puncte de loialitate',couponType:'Tip discount',couponAppliesTo:'Cuponul se aplică la',couponProducts:'Produse',couponDelivery:'Livrare',couponTaxes:'Taxe',couponPercentage:'Procent',couponFixed:'Sumă fixă',discount:'Discount',product:'Produs',searchProduct:'Caută produs',sortOrder:'Ordine de afișare',sortOrderHelp:'Ordinea stabilește afișarea premiilor pe roată, nu ordinea câștigării. Premiul se alege aleatoriu, conform probabilității de câștig.',freeProductCouponHelp:'Produsul gratuit este premiul câștigat la Roata norocului. Nu este necesară selectarea unor categorii sau produse suplimentare.',actions:'Acțiuni',openCampaign:'Deschide campania',duplicate:'Duplică',datesRequired:'Datele de disponibilitate (de la / până la) sunt obligatorii.',autoGenerateNotice:'O campanie și un cupon vor fi create automat pentru acest premiu. Poți modifica campania generată și configura notificările ulterior.',typeNothing:'Nimic',typeLoyaltyPoints:'Puncte de loialitate',typeDiscountCoupon:'Cupon discount',typeFreeProduct:'Cupon produs gratuit',titleRequired:'Titlul campaniei este obligatoriu.',percentageRequired:'Procentul de câștig trebuie să fie mai mare decât 0.',loyaltyPointsRequired:'Punctele de loialitate sunt obligatorii.',discountRequired:'Discountul este obligatoriu.',productRequired:'Produsul este obligatoriu.',spins:'Învârtiri',usersWhoSpun:'Utilizatori care au învârtit',rewardsWon:'Premii câștigate',rewardsRedeemed:'Premii valorificate',redemptionRate:'Rată valorificare',wins:'Câștiguri',usersWhoWon:'Utilizatori care au câștigat',redeemed:'Valorificat',remaining:'Rămas',users:'Utilizatori',user:'Utilizator',used:'Folosit',available:'Disponibil',spinId:'ID învârtire',dateWon:'Data câștigului',status:'Status',dateRedeemed:'Data valorificării',qualifyingOrder:'Comandă eligibilă'},discountCampaigns:{single:'campanie reducere',plural:'campanii reduceri',id:'ID',search:'Caută',name:'Nume',description:'Descriere',image:'Imagine',details:'Detalii campanie reducere',startEnd:'Start - Sfârșit',active:'Activ',discount:'Reducere',discountType:'Tip reducere',discountType_flat:'Sumă fixă',discountType_percent:'Procent',priceProfile:'Profil de preț',source:'Canal',sourceMethodCombos:'Canale / metode',productStandardPrice:'Produs (preț standard)',pageInfo:'Pagina {page} din {total} ({count} produse)',topCategory:'Categorie top',topCategories:'Categorii top',categories:'Categorii',numberOfUnits:'Limită unități',numberOfUnitsPlaceholder:'Lăsați gol pentru nelimitat',numberOfUnitsHint:'Număr maxim de unități cu reducere. Cum se împarte limita este controlat de setările de mai jos.',unitsSoldScope:'Limită unități pe canal',unitsSoldScope_perLine:'Per linie (sursă + metodă)',unitsSoldScope_perSource:'Per sursă (metodele partajează)',unitsSoldScopeHint:'Per linie: Eat-in și Takeout au fiecare limita lor. Per sursă: toate metodele din același canal partajează o singură limită.',unitsSoldPool:'Limită unități pe produs',unitsSoldPool_perProduct:'Per produs',unitsSoldPool_absolute:'Absolut (toate produsele partajează)',unitsSoldPoolHint:'Per produs: fiecare produs are limita lui. Absolut: toate produsele din campanie partajează aceeași limită.',useIntervals:'Limitează la intervale orare',useIntervalsHint:'Când este dezactivat, campania este activă toată ziua în perioada selectată.',intervalDay:'Zi',addInterval:'Adaugă interval',intervalOverlap:'Intervalele se suprapun sau unul îl include pe celălalt. Folosiți zile/ore diferite sau ștergeți intervalul redundant.',intervalInvalidRange:'Introduceți ore valide și diferite pentru început și sfârșit. O oră de sfârșit mai mică înseamnă că intervalul se încheie în ziua următoare.',previewTitle:'Produse afectate',previewCount:'{count} produse se potrivesc',searchProduct:'Caută după nume produs',searchProductId:'ID produs',product:'Produs',pricingType:'Preț',pricingProfile:'Profil',pricingCatalog:'Catalog',method:'Metodă',originalPrice:'Preț original',discountAmount:'Reducere',discountedPrice:'Preț redus',cap:'Limită',unitsSold:'Unități vândute',productsCount:'Produse',regenerateWarning:'Liniile de produse vor fi regenerate. Continuați?',areYouSureDelete:'Sigur doriți să ștergeți',campaignDeleted:'Campania de reducere a fost ștearsă cu succes.',campaignAdded:'Campania de reducere a fost adăugată cu succes.',campaignUpdated:'Campania de reducere a fost actualizată cu succes.',removeCurrentImage:'Eliminați imaginea curentă înainte de a adăuga una nouă',products:'Produse',productsIncluded:'Produse incluse',createCampaign:'Creează campanie',campaignButton:'Campanie reducere',applyDiscount:'Aplică reducere',clearSelection:'Deselectează tot',selectionSummary:'{cells} celule selectate · {products} produse',selectForCampaign:'Selectează pentru campanie',noPriceConfigured:'Fără preț configurat',viewEditDiscount:'Vezi / editează reducerea',discShort:'Disc.',newCampaignModal:'Campanie reducere nouă',newCampaignSubtitle:'Lista de preț: {name} · {cells} celule selectate',priceProfileLocked:'Blocat pe profilul de preț curent',period:'Perioadă',listPrice:'Preț listă',invalidDiscount:'Reducere invalidă',discountExceedsPrice:'Reducerea nu poate depăși prețul',confirmDeleteLine:'Elimini reducerea și produsul din campanie?'},donationReport:{campaign:'Campanie',client:'Client',amount:'Sumă',date:'Dată',totalAmount:'Sumă totală',totalDonations:'Total Donații',totalDonors:'Total Donatori',campaignOrders:'Comenzi'},marketingOffers:{single:'banner ofertă',plural:'banner oferte',title:'Titlu',status:'Status',image:'Imagine',imageWeb:'Imagine Web',imageBanner:'Imagine Banner',imageLanding:'Imagine Landing',linkType:'Tip Link',startEndDate:'Valabil de la - până la',actions:'Acțiuni',offerAdded:'Banner ofertă adăugat cu succes.',offerUpdated:'Banner ofertă actualizat cu succes.',offerDeleted:'Banner ofertă șters cu succes.',weCouldNot:'Poza pentru bannerul de oferă nu a fost salvată, te rugăm să încerci mai târziu.',validImg:'Te rugăm să adaugi o imagine validă.',areYouSure:'Ești sigur că dorești să {label} acest banner ofertă?',pageText:'Text Pagină',pickCateg:'Alege Categoria',pickProd:'Alege Produsul',pickLoc:'Alege Locația',groupClients:'Alege grupul de clienti',none:'Nici unul',banners:'Bannere',offers:'Oferte',display:'Afisare',addGroup:'Adaugă grup',offerSuccess:'Ofertă de grup adăugată cu succes.',categoryBanner:'Categoriile în care vă fi afișat',dispalyBannerInCategory:'Afișează banner în categorie'},marketingOffersTypes:{category:'categorie',product:'produs',page:'pagină'},marketingFidelities:{fidelities:'Fidelitate',userLabeling:'Segmentare clienti',name:'Nume',ordersValue:'Valoare Comenzi',ordersNumber:'Număr Comenzi',MOR:'Media Comenzi Perioada (MOR)',MORCalcComenzi:'Numar comenzi anuale',MORInfo:'\n        <div class="info" style="font-size: 12px;">\n          <p><b>Ce introduci aici?</b></p>\n\n          <p>\n            Introduci <b>num\u0103rul mediu de comenzi</b> pe care vrei s\u0103 le\n            plaseze un client <b>pe lun\u0103</b>, calculat la nivel de an.\n          </p>\n\n          <p><b>Formula sistemului:</b></p>\n\n          <p>\n            <i>Medie MOR = Num\u0103r comenzi pe an \xF7 12 luni</i>\n          </p>\n\n          <p><b>Exemplu practic (Pentru rangul Silver):</b></p>\n\n          <p>\n            Dac\u0103 vrei ca un client s\u0103 aib\u0103 <b>6 comenzi pe an</b>,\n            introduci valoarea <b>0.5</b> (deoarece 6 \xF7 12 = 0.5).\n          </p>\n        </div>\n      ',color:'Culoare',notification:'Notificare',userNotification:'Notificare Utilizator',userNotificationPlaceholder:'Felicitări! Ați ajuns la {level}!',userNotificationInfo:'Notificare primită de către client la atingerea pragului',coupon:'Cupon',product:'Produs gratuit',recurrenceInfo:'Produsul gratuit/ cuponul setat se aplică o dată la {recurrence}',description:'Descriere',descriptionPlaceholder:'adaugă desert gratuit la comandă',descriptionInfo:'Descriere disponibilă doar in panoul de administrare',nameLabel:'Nume Etichetă',addLabel:'Adaugă Etichetă',noData:'Nu sunt date',updateUserLabeling:'Etichetă Utilizator Actualizată',createdUserLabeling:'Etichetă Utilizator Creată',areYouSureDelete:'Sigur dorești să ștergi această etichetă ?',labelDeleted:'Etichetă ștersă',orderNumberRequired:'Acest câmp sau numărul de comenzi este obligatoriu',orderValueRequired:'Acest câmp sau valoare comenzilor este obligatoriu',yes:'Da',applyCupon:'Aplică Cupon',applyproduct:'Aplică Produs',badgeColor:'Culoare Etichetă',badgeName:'Nume Etichetă',value:'Valoare',number:'Număr',appliedForLastMonth:'Etichetele se vor aplica doar pentru comenzile din ultimele 30 de zile',checkTermsAndConditionFidelities:'Verifică promoțiile de fidelitate de la paginile informative',labelingPrimaryOption:'Selectați opțiunea principală pentru etichete',labelingSuccess:'Setările pentru etichete au fost actualizată cu succes!',updatePrimaryOption:'Actualizează opțiunea',showLabelOnUser:'Afișează nivelul utilizatorilor în aplicația mobil',sentUserLabelNotification:'Permiteți trimiterea notificărilor de actualizare a etichetei utilizatorului',infoAboutShowUserLabelUpdated:'Informațiile despre afișarea etichetei de utilizator au fost actualizate',labelingInterval:'Alegeți intervalul de aplicare','0':'Pe viață','30':'30 de zile','60':'60 de zile','90':'90 de zile','120':'120 de zile','150':'150 de zile','180':'180 de zile',recurrence:'Recurență',noReccurence:'fără',oneDay:'1 zi',threeDays:'3 zile',fiveDays:'5 zile',sevenDays:'7 zile',tenDays:'10 zile',fifteenDays:'15 zile',twentyDays:'20 zile',twentyFiveDays:'25 zile',updatePoints:'Actualizare puncte',availableProducts:'Un produs trebuie sa fie disponibil in toate locatiile pentru a fi eligibil'},marketingPromos:{to_receive:'De primit',multiple:'Se poate revendica de mai multe ori per comandă',redeemFromNextOrder:'Se poate revendica doar de la următoarea comandă',addFreeProductAutomatically:'Adaugă produsul gratuit automat la comandă',allowOnePointPerOrder:'Permite un singur punct pe comandă',expiryInfo:'Setați 0 pentru a acorda puncte doar pentru comanda curentă',to_order:'De comandat',toOrderError:'Vă rugăm selectați produse care pot fi comandate',toReceiveError:'Vă rugăm selectați produse care pot fi primite',location:'Locația',title:'Titlu',treshold:'Limita n',category:'Categorie',product:'Produs',products:'Produse',expiry:'Valabilitate puncte (zile)',none:'Nici unul',marketingPromos:'Promo',generateQrCode:'Generează Qr Code',code:'Code',promoDeleted:'Promoție ștearsă',areYouSureDelete:'Sigur dorești să ștergi această etichetă',promoAdded:'Promoție adăugată cu succes.',promoUpdated:'Promoție ofertă actualizat cu succes.',weCouldNot:'Datele nu au fost salvate, te rugăm să încerci mai târziu.',startEndDate:'Valabil de la - până la',image:'Imagine',validImg:'Te rugăm să adaugi o imagine validă.',print:'Print',firstname:'Nume',lastname:'Prenume',points:'Puncte',email:'Email',description:'Descriere',descriptionPlaceholder:'Descrierea va fi afișată în aplicație',notificationText:'Text notificare',notificationTextPlaceholder:'Acest mesaj va fi trimis utilizatorului când acumulează suficiente puncte pentru un produs gratuit (Lăsați gol pentru a omite notificarea)',send:'Trimite'},referralProgram:{v2:{ambassador_1:'Ambasador 1',ambassador_2:'Ambasador',referee:'Afiliat',none:'Fără recompensă',coupon:'Cupon',rewardKind:'Tip recompensă',selectCoupon:'Selectează cuponul',campaignDefault:'Setarea campaniei',legacyCombined:'Sumă fixă + procent existente',unavailableCoupon:'Cupon indisponibil (#{id})',loadingCoupons:'Se încarcă cupoanele…',noCoupons:'Nu există cupoane active disponibile.',couponsLoadFailed:'Cupoanele nu au putut fi încărcate.',retry:'Reîncearcă',couponRequired:'Selectează un cupon.',couponUnavailable:'Selectează un cupon disponibil.',percentInvalid:'Introdu un procent între 0 și 100.',amountInvalid:'Introdu o valoare mai mare sau egală cu zero.',maxOrdersInvalid:'Introdu un număr întreg pozitiv sau lasă gol pentru comenzi nelimitate.',visibleInApp:'Afișează în aplicație',hierarchyTitle:'Recomandări ambasador',hierarchy:'Ambasador → Afiliat',purchaseFlow:'Comenzile afiliatului recompensează afiliatul și ambasadorul său direct. Comenzile ambasadorului nu generează recompense referral.',cashbackTitle:'Recompense la fiecare comandă',cashbackHelp:'Aceste recompense continuă după atingerea limitei primelor comenzi. Configurează separat fiecare beneficiar.',order_reward:'Recompensă la primele comenzi',cashback:'Recompensă la fiecare comandă',couponsAwarded:'Cupoane acordate'},generalSettings:'Setări generale',campaignName:'Nume campanie',active:'Activă',availableBetween:'Disponibilitate (calendar)',optionalAvailability:'Lasă gol pentru perioada nelimitată',tableAvailability:'Disponibilitate',orderRewardsSection:'Recompense la primele comenzi',orderRewardsActive:'Recompense la comenzi activate',refereeRewardFlat:'Recompensă afiliat',ambassadorOrderRewardFlat:'Recompensă ambasador',maxOrdersForOrderRewards:'Număr maxim comenzi contorizate',unlimitedPlaceholder:'Lasă gol pentru nelimitat',cashbackSection:'Cashback ambasador din comenzile afiliaților',cashbackFlatOrPercent:'Alege dacă cashback-ul este procent din total sau sumă fixă pe comandă.',ambassadorCashbackActive:'Cashback activ',cashbackAmountType:'Tip cashback',cashbackTypePercent:'Procent (%)',cashbackTypeFlat:'Sumă fixă',cashbackPercentValue:'Procent din total comandă (%)',cashbackFlatValue:'Sumă fixă pe comandă livrată',cashbackHintPercent:'Procent din totalul comenzii afiliatului plătit ambasadorului.',cashbackHintFlat:'Sumă monetară fixă pe fiecare comandă livrată pentru ambasador.',nameRequired:'Introduceți numele campaniei.',cashbackPercentRequired:'Introduceți procentul de cashback când cashback-ul este activ.',cashbackFlatRequired:'Introduceți suma fixă de cashback când cashback-ul este activ.',notificationEmailsTitle:'Emailuri notificări referral',notificationEmailsHelp:'Adrese care primesc cereri noi de ambasador (separate prin virgulă sau linie nouă).',notificationEmailsPlaceholder:'echipa@companie.ro',orderRewards:'Recompense comenzi',cashback:'Cashback',requestStatus:'Status',desiredCode:'Cod dorit',createdAt:'Solicitat la',approveRequest:'Aprobă ambasador',selectCampaign:'Campanie referral',selectCampaignRequired:'Selectați o campanie referral.',rewardSummaryDisabled:'Dezactivat',approvedCodeOptional:'Cod referral aprobat (opțional)',denyReason:'Motiv respingere (opțional)',ambassadorId:'Ambasador',refereesCount:'Afiliați',totalRewards:'Total recompense',totalCashbackPercent:'Total cashback',refereeId:'Afiliat',refereeTotals:'Total comenzi afiliat',ambassadorEarnings:'Câștig ambasador',refereeReward:'Recompensă afiliat',ambassadorOrderReward:'Recompensă ambasador (comandă)',ambassadorCashback:'Cashback ambasador',rewardType:'Tip recompensă',rewardTypeLoyaltyPoints:'Puncte fidelitate',rewardTypeWallet:'Credit portofel',loyaltyPointsModuleRequired:'Pentru a alege punctele de loialitate ca recompensă, trebuie să configurați mai întâi modulul de puncte de loialitate.',loyaltyPointsModuleLink:'Mergi la setările punctelor de loialitate',orderRewardsSummaryIncomplete:'Configurați recompensele fixe pentru afiliați și/sau ambasador.',cashbackSummaryIncomplete:'Configurați valoarea cashback-ului pentru a vedea rezumatul.',cannotDeleteHasEnrolledUsers:'Campania nu poate fi ștearsă deoarece există deja utilizatori înscriși. Dezactivați-o în schimb pentru a opri noile înscrieri.',deactivateCampaign:'Dezactivează campania',filterByCampaign:'După campanie',filterByAmbassador:'După ambasador'},reports:{labelEvolution:'Evoluție Etichete',items:'Produse',wallet_id:'ID',wallet_firstname:'Prenume',wallet_lastname:'Nume',wallet_email:'Email',wallet_phone:'Telefon',wallet_loyalty_points:'Puncte fidelitate',wallet_donation_points:'Puncte donație',wallet_value:'Portofel',wallet_driver_wallet:'Portofel șofer',salesPaymentMethod:'Raport Vanzari',paymentTypes:'Metode de plată',giftCardsSoldTotal:'Total vânzări carduri cadou',giftCardsSoldAmount:'Vânzări carduri cadou',orderedProducts:'Produse comandate',number:'Nr Comandă',trends:'Performanță',clients:'Clienți',products:'Produse',marketing:'Marketing',today:'Azi',orderChart:'Comenzi',clientsChart:'Clienți',completed:'Finalizate',canceled:'Anulate',salesChart:'Vânzări',salesIn:'Vânzări în',customersChart:'Clienți',appInstalls:'Aplicații Instalate',custWithAcc:'Conturi clienți',top10Chart:'Top 10 produse',top5Chart:'Top 5 produse',orderingChart:'Tip comandă',periodExceeds6Months:'Te rugăm să selectezi o perioadă mai mică de 6 luni',nrOfOrders:'Număr comenzi',customersAge:'Vârsta client',customersGender:'Gen client',name:'Nume',timerApp:'Timp în aplicație',appInstalled:'Aplicații Instalate',gender:'Gen',location:'Locație',partnerCode:'Cod partener',email:'Email',phone:'Telefon',age:'Vârstă',donation_points:'Puncte donatie',label:'Etichetă',filter:'Filtrează',userDetails:'Detalii Client',salesDetails:'Detalii Vânzări',salesProductNr:'Număr vânzări produs',totalAmount:'Sumă Totală',totalProducts:'Total Produse',ordersNumber:'Număr Comenzi',minAmount:'Sumă totală minimă',minOrders:'Nr min comenzi',maxOrders:'Nr max comenzi',itemsSold:'Produse vândute',campaign:'Campanii',couponsTimesUsed:'Număr cupoane utilizate',revenue:'Vânzări',total:'Total',paymentType:'Metodă plată',date:'Dată',closingOrder:'Închidere comandă',dateColumnCreate:'Creare',dateColumnClose:'Închidere',dateColumnFiscalize:'Fiscalizare',salesReport:'Raport Vânzări',salesReportBeta:'Raport Vânzări BETA',accountingReport:'Raport Contabil',orderorder:'Comandă',export:'Exportă',cash:'Numerar',card:'Online (Aplicatie)',cardPayment:'Card',pos:'POS Mobil',cardPos:'POS Fizic',splitCardPos:'Separat Card',splitCash:'Separat Numerar',virament:'Virament',protocol:'Protocol',staffFood:'Mancare Personal',room:'Transfer Camera',event:'Transfer Eveniment',folio:'Transfer Folio',tips:'Bacșiș',splitVoucher:'Voucher',unpaid:'Neachitat',orderPaidStatus:'Achitat',boltCard:'Card Bolt',boltCash:'Numerar Bolt',glovoCard:'Card Glovo',glovoCash:'Numerar Glovo',woltCard:'Card Wolt',woltCash:'Numerar Wolt',woltOtherMethods:'Wolt Alte metode',totalPayFromWallet:'Total plată portofel',totalSum:'Sumă Totală',totalSales:'Total Vânzări',totalCash:'Total Numerar',totalOnline:'Total Online',totalCard:'Total Card',totalCredit:'Total Credit',totalNonFiscal:'Total Alte Metode',unfiscalTotal:'Total Nefiscalizat',unfiscalCash:'Nefiscalizat Numerar',unfiscalOnline:'Nefiscalizat Online',unfiscalCard:'Nefiscalizat Card',unfiscalCredit:'Nefiscalizat Credit',search:'Căutare',searchFilter:'Caută(nume, email, telefon)',searchClient:'Caută client (nume, email, telefon)',noRawData:'Nu există date disponibile',rawDataTvaA:'TVA A',rawDataTvaB:'TVA B',rawDataTvaC:'TVA C',rawDataTvaD:'TVA D',rawDataTvaE:'TVA E',rawDataTvaS:'SCUTIT TVA S',rawDataAlteTaxe:'ALTE TAXE #',rawDataNrAnulariNefiscale:'NR. ANULARI NEFISCALE',rawDataValAnulariNefiscale:'VAL. ANULARI NEFISCALE',rawDataNumerarInSertar:'NUMERAR IN SERTAR LEI',rawDataNumerar:'NUMERAR',rawDataCard:'CARD',rawDataCredit:'CREDIT',rawDataTicheteMasa:'TICHETE MASA',rawDataTicheteValorice:'TICHETE VALORICE',rawDataVoucher:'VOUCHER',rawDataPlataModerna:'PLATA MODERNA',rawDataAvansInNumerar:'AVANS IN NUMERAR',rawDataAlteMetode:'ALTE METODE',rawDataValTotalVanzA:'VAL. TOTAL VANZ - A',rawDataValTotalVanzB:'VAL. TOTAL VANZ - B',rawDataValTotalVanzC:'VAL. TOTAL VANZ - C',rawDataValTotalVanzD:'VAL. TOTAL VANZ - D',rawDataValTotalVanzE:'VAL. TOTAL VANZ - E',rawDataValTotalAlteTaxe:'VAL. TOTAL ALTE TAXE #',rawDataValTotalScutitTvaS:'VAL. TOTAL SCUTIT DE TVA - S',rawDataValTotalVanzari:'VAL. TOTAL VANZARI',rawDataTotalTvaA:'TOTAL TVA A 21%',rawDataTotalTvaB:'TOTAL TVA B 11%',rawDataTotalTvaC:'TOTAL TVA C 0%',rawDataTotalTvaD:'TOTAL TVA D 0%',rawDataTotalTvaE:'TOTAL TVA E 0%',rawDataTotalTva:'TOTAL TVA',rawDataClientiCodFiscalTotalTva:'CLIENTI COD FISCAL - TOTAL TVA',rawDataClientiCodFiscalTotalSumar:'CLIENTI COD FISCAL - TOTAL SUMAR',rawDataNrBonuriClientiCodFiscal:'NR. BONURI CLIENTI COD FISCAL',rawDataNumarBonuriFiscale:'NUMAR BONURI FISCALE',rawDataNumarBonuriNefiscale:'NUMAR BONURI NEFISCALE',rawDataNrDmje01:'NR. DMJE 01',rawDataDmjeCapacitate:'DMJE CAPACITATE',rawDataSpatiuLiberDmje:'SPATIU LIBER DMJE',rawDataSpatiuOcupat:'SPATIU OCUPAT',rawDataNrAmef:'NR.AMEF',rawDataTd:'TD',rawDataData:'DATA',rawDataOra:'ORA',rawDataSN:'S/N',rawDataLogo:'{LOGO}',rawDataSha256:'SHA-256 PENTRU Z',searchEmployee:'Caută operator (nume, email, telefon)',discount:'Reducere',totalDiscount:'Discount Total',ordersWithDiscount:'Comenzi cu Discount',ordersWithFidelity:'Comenzi cu Fidelitate',totalFidelityDiscount:'Total Fidelitate',newCustomers:'Clienți noi',totalTax:'Total Taxe',slotTax:'Taxa Slot',slotPartTax:'Taxa Slot Parte',tax:'Taxe',shipping:'Livrare',delivery_type:'Metoda de livrare',zone:'Zona de livrare',avarageOrderValue:'Valoare medie per Comanda',clientsWOrders:'Clienți cu comenzi',emailSend:'Emailuri trimise în ultimele 6 luni',emailTotal:'Total emailuri trimise: ',newCustomersChart:'Clienți Noi',productsSalesReport:'Raport vânzări produse',productsSalesReport2:'Vânzări produse',productSaleTrendsReport:'Trend vânzări produse',salesTrendsReport:'Trend vânzări',topProductsReport:'Top Produse',topCategoriesReport:'Top Categorii',orderFromReport:'Vânzari Verticale',productsAndOptionsReport:'Raport Produse și Opțiuni',options:'Opțiuni',netValue:'Valoare Netă',stornoReport:'Storno Utilizatori',operatorSalesReport:'Vânzari Protocol Operator',waiterTipsReport:'Bacșiș ospătari',waiterTipsUserName:'Nume utilizator',waiterTipsValue:'Valoare',waiterTipsZRange:'Interval Z',waiterTipsMode:'Mod',waiterTipsModeWaiter:'Ospătari',waiterTipsModeDelivery:'Livrare',waiterTipsSelectWaiters:'Ospătari',waiterTipsSelectDrivers:'Șoferi',masterReport:'Raport General',masterReportBeta:'Raport General (Beta)',fiscalZReport:'Raport Fiscal Z',withoutOptions:'fără opțiuni, fără sgr',customerLifetimeValueReport:'Raport Venituri Client',referralProgramReport:'Raport Afiliați',raffleCampaignsReport:'Raport campanii tombolă',orderStatus:'Raport status comenzi',pdfRaport:'Raport comenzi pentru livrare',pricePerUnit:'Preț pe bucată',quantity:'Cantitate',average:'Medie',productName:'Nume Produs',couponCode:'Cupon',checkOrder:'Folosește comanda',loyaltyPoints:'Puncte de Fidelidate',donationReport:'Raport Donații',donationCampaignsReport:'Raport Campanii Donații',loyaltyStoreReport:'Loyalty Store',challengeCampaignsReport:'Raport Provocări',spinningWheelReport:'Raport Roata Norocului',ocr:'Ocr',stockMovements:'Mișcări stoc produse',reorderPopupResponses:'Răspunsuri popup comandă',dateTime:'Dată și oră',reorderResponse:'Răspuns',reorderResponseYes:'Da',reorderResponseNo:'Nu',dateInterval:'Interval dată',allLocations:'Toate locațiile',stockMovementType:'Tip mișcare',stockMovementUserRole:'Rol utilizator',stockMovementOrderPlaced:'Plasare comandă',stockMovementManualAdjustment:'Ajustare manuală',wallet:'Wallet',requestReport:'Solicită Raport',requestSuccess:'Solicitare Trimisă',requestInfo:'Raportul va putea fi descarcat de mâine',requestConfirm:'Am înțeles',reportRequestTab:'Solicitări Rapoarte',charismaReport:'Raport Charisma',charismaLocationReceipt:'Raport Z Charisma',nexusReport:'Raport Nexus',nexusItems:'Jurnal Comandă',nexusOrderLogs:'Nexus Jurnale Comenzi',sendReceipts:'Trimite Bonuri',dashboardReport:'Raport Panou Comanda',reportTypePlaceholder:'Raport',pointsReport:'Raport Puncte',fromUppercase:'De la',toUppercase:'Până la',availableUntil:'Valabil până la',pdfRaportDeliveryOrders:'Comenzi Livrare',statusReport:'Timp Procesare Comenzi',taxation:'Fiscalizare',withReceipt:'Fiscalizate',withoutReceipt:'Nefiscalizate',receiptNumber:'Nr Bon',zet:'Zet',noDataAvailable:'Nu sunt date disponibile',topCategory:'Categorie de top',orderId:'ID Comandă',posId:'ID Pos',productId:'ID Produs',itemPosId:'ID Pos Item',menuItemPosId:'ID Pos Item Meniu',orderCreatedAt:'Oră deschidere comandă',orderNumber:'Număr comandă',tableNumber:'Număr masă',orderItemCreatedAt:'Oră deschidere produs',orderItemMarkingTime:'Oră marcare produs',category:'Categorie',product:'Produs',operation:'Operație',operator:'Operator',section:'Secție',fullPrice:'Preț întreg',grossPrice:'Preț întreg per produs',orderItemDiscount:'Reducere produs',orderDiscount:'Reducere comandă',orderLoyaltyDiscount:'Reducere fidelitate comandă',orderItemValueCollected:'Sumă încasată',vatAmount:'Sumă TVA',orderItemNetPrice:'Preț fără TVA',paymentMethod:'Metodă de plată',fiscalization:'Fiscalizare',roomNumber:'Număr cameră',folioId:'ID folio',interval:'Interval',split:'Separat',orderComments:'Comentarii comandă',productComments:'Comentarii produs',tableOpenOrders:'Comenzi deschise la mase',orderSeriesNumber:'Serie / nr. comandă',posDeviceName:'POS',waiterName:'Ospătar',orderTransfersCount:'Transferuri',orderStornosCount:'Storno',posOrderActionTypes:{openOrder:'Deschidere comandă',markProduct:'Marcare produs',preNote:'Pre notă',closeOrder:'Închidere comandă',storno:'Storno',transferOut:'Transfer OUT',transferIn:'Transfer IN'},posOrderActionMarkProduct:'Marcare "{name}"',posOrderActionMarkProductGeneric:'Marcare produse',orderProductsCount:'Număr produse comandă',transferTable:'Masă transfer',initialItems:'Produse initiale',transferredTag:'Transferat',transferOut:'Produse transferate',remainingItems:'Produse rămase',itemsReceived:'Produse primite',posOrderActionsReport:'Raport acțiuni comenzi POS',zNumber:'Număr Z',deviceName:'Nume Dispozitiv',zTimestamp:'Data și Ora Z',credit:'Credit',mealTickets:'Tichete Masă',valueTickets:'Tichete Valorice',voucher:'Voucher',modernPayment:'Plată Modernă',advanceInCash:'Avans în Numerar',otherMethods:'Alte Metode',cashInDrawer:'Numerar în Sertar',nrFiscalReceipts:'Nr. Bonuri Fiscale',nrNonFiscalReceipts:'Nr. Bonuri Nefiscale',fiscalReceiptsAmount:'Valoare bonuri fiscale',nonFiscalReceiptsAmount:'Valoare bonuri nefiscale',paymentMethodsStandard:'Metode de plată standard',paymentMethodsOther:'Alte metode de plată',paymentMethodsIntegration:'Metode de plată integrări',totalSalesA:'Total Vânzări A',totalSalesB:'Total Vânzări B',totalSalesC:'Total Vânzări C',totalSalesD:'Total Vânzări D',totalSalesE:'Total Vânzări E',totalVat:'Total TVA',totalVatA:'Total TVA A',totalVatB:'Total TVA B',totalVatC:'Total TVA C',totalVatD:'Total TVA D',totalVatE:'Total TVA E',totalOtherTaxes:'Total Alte Taxe',totalVatExempt:'Total Scutit TVA',nrFiscalCodeClientReceipts:'Nr. Bonuri cu Cod Fiscal Client',fiscalCodeClientsTotalSum:'Sumă Totală Clienți cu Cod Fiscal',fiscalCodeClientsTotalVat:'TVA Total Clienți cu Cod Fiscal',productCount:'Număr produse',lastSearch:'Ultima căutare',duration:'Durată comandă',tables:'Mese',quantityUnit:'Unitate măsură',singleUnit:'buc',clientId:'ID Client',clientName:'Nume Client',registrationDate:'Data Înregistrării',firstOrderDate:'Data Primei Comenzi',lastOrderDate:'Data Ultimei Comenzi',monthlyOrderCount:'Număr Comenzi (total)',monthlyOrderValueTotal:'Valoare Totală Comenzi',averageOrderValue:'Valoare Medie Comandă',monthlyOrderAverage:'Frecvență lunară',isNewClient:'Client Nou',isInactiveClient:'Client Inactiv',daysSinceLastOrder:'Zile de la Ultima Comandă',acquisitionChannel:'Canal de Achiziție',estimatedCLV:'CLV 12 Luni',churnRate:'Rata Churn',option:'Opțiune',item:'Produs',type:'Tip',searchProducts:'Caută',orderCounter:'Număr comenzi',preordersItems:'Produse Precomandă',itemName:'Nume Produs',saleWeek:'Săptămâna',filteredData:'Datele afișate sunt din perioada:',source:'Sursă',withStorno:'Storno',withoutStorno:'Fără Storno',orderTotal:'Total Comandă',old:'Vechi',custom:'Personalizat',salesProtocol:'Total Vânzări Protocol',salesStaff:'Total Vânzări Personal',countProtocol:'Număr comenzi Protocol',countStaff:'Număr comenzi Personal',salesProtocolStaff:'Total Vânzări Protocol + Personal',countProtocolStaff:'Număr comenzi Protocol + Personal',salesReportSearch:'Caută după produs, categorie, operator',id:'ID',sold:'Vândut',eatIn:'În locație',takeOut:'La pachet',other:'Altele',waste:'Risipă',employee:'Angajat',refund:'Rambursat',usage:'Utilizare',unitQty:'Cantitate unitară',unitPrice:'Preț unitar',sales:'Vânzări',netSales:'Vânzări Nete',grandTotal:'Total General',mixReport:'Raport Mix',noData:'Nu există date',uncategorized:'Necategorizat'},orderFrom:{unknown:'Necunoscut',kiosk:'Kiosk',qr:'QR',pos:'POS',app:'Aplicație',website:'Site',glovo:'Glovo',wolt:'Wolt',bolt:'Bolt',POS:'POS',application:'Aplicație',online:'Site',table:'Masă',tazz:'Tazz',phone:'Telefonic',inlocation:'Rezervare'},feedback:{sigle:'feedback',type:'Tip',sentBy:'Trimis prin',text:'Text',seen:'Văzut',sentAt:'Trimis la',search:'Caută',comment:'Comentariu',response:'Răspuns',send:'Răspunsul vă fii trimis către utilizator prin notificare și email la momentul salvării'},orderScreen:{typeKitchen:'Bucătărie',typeClient:'Client',selectLocation:'Selectați o locație pentru a putea opta pentru metoda Client',excludeSections:'Exclude secțiile',includeTableOrders:'Include comenzi de la Masă și Kiosk',posIds:'POS-uri',odsBackgroundColor:'Culoare fundal',odsHeaderTextColor:'Culoare text antet',odsBodyTextColor:'Culoare text numere',odsStatus1Color:'Culoare comenzi procesate',odsStatus2Color:'Culoare comenzi in lucru',odsStatus3Color:'Culoare comenzi preparate',odsColumn1TextLanguage1:'Text coloana 1 (limba 1)',odsColumn1TextLanguage2:'Text coloana 1 (limba 2)',odsColumn2TextLanguage1:'Text coloana 2 (limba 1)',odsColumn2TextLanguage2:'Text coloana 2 (limba 2)',odsOffline:'ODS offline',ipServer:'IP Server',odsCode:'Cod ODS',connectivity:'Conectivitate',offline:'Offline',online:'Online'},feedbackTypes:{feedback:'Feedback',issue:'Problemă',suggestion:'Sugestie'},settings:{},blogPage:{categories:'Categorii',categoriesHint:'Opțional — articolele pot fi și fără categorie.',categoryName:'Nume categorie',noCategories:'Nicio categorie încă.',articles:'Articole',addArticle:'Adaugă articol',editArticle:'Editează articol',allCategories:'Toate categoriile',noCategory:'Fără categorie',allStatuses:'Toate statusurile',searchByTitle:'Caută după titlu',noArticles:'Niciun articol găsit.',cover:'Copertă',coverHint:'recomandat 1200x630px, max 5MB',imageAlt:'Text alternativ poză (SEO)',title:'Titlu',slug:'Link articol (slug)',slugHint:'Se generează din titlu dacă rămâne gol.',shortDescription:'Descriere scurtă (sub titlu)',content:'Conținut',category:'Categorie',author:'Autor',publishedAt:'Data publicării',publishedAtHint:'Dacă e gol, la publicare se folosește data curentă.',status:'Status',published:'Publicat',draft:'Ciornă',scheduled:'Programat',seo:'SEO',metaTitle:'Meta titlu',metaDescription:'Meta descriere',metaKeywords:'Cuvinte cheie (separate prin virgulă)',titleRequired:'Titlul este obligatoriu.',deleteCategoryConfirm:'Ștergi categoria „{name}”? {count} articol(e) vor rămâne fără categorie.',deleteArticleConfirm:'Ștergi articolul „{name}”?'},settingsPages:{homepageSections:'Secțiuni Homepage',interactiveTour:'Tur Interactiv',blog:'Blog',interactiveTourFirstLogin:'Folosește turul interactiv la prima autentificare',interactiveTourAlways:'Folosește turul interactiv mereu',interactiveTourDisplayMode:'Mod de afișare imagine',interactiveTourDisplayContain:'Încadrată (contain)',interactiveTourDisplayCover:'Umplere (cover)',interactiveTourDisplayFullPage:'Pagină întreagă',searchNameEmail:'Caută după nume sau email',ordersFilter:'Comenzi / Fără comenzi',userSettings:'Setări utilizator',generalSettings:'Setări generale',moduleManager:'Manager module',locationSettings:'Setări locație',myProfile:'Profilul meu',users:'Utilizatori',general:'General',companyDetails:'Detalii Companie',printers:'Imprimante',fiscalPrinter:'Imprimantă fiscală',tableManager:'Manager Mese',kioskModule:'Kiosk',qrModule:'Qr',tableZones:'Manager Zone',measurementsUnits:'Unitati de masura',kdsSections:'Secții',paymentGroups:'Procesatori Plăți',companyLocations:'Locații',dateTime:'Dată și Timp',currency:'Monedă',accounting:'Contabilitate',tax:'Taxe',payment:'Plata',orderingMng:'Management Comenzi',loyalty:'Program Loialitate',push:'Notificări',tips:'Bacșiș',integrations:'Integrări',app:'Aplicație',locationGroups:'Grupuri de Locații',locationGroupsName:'Nume',locationGroupsDescription:'Descriere',locationGroupsPhoto:'Fotografie',locationGroupsAdded:'S-au adăugat noi grupuri de locații',locationGroupsUpdated:'Grupurile de locații au fost actualizate cu succes',locationGroupsPicError:'Nu am putut salva fotografia grupurilor de locații. Încercați din nou mai târziu.',locationGroupsDelete:'Ștergeți grupul de locații',locationGroupsAreYouSure:'Sigur doriți să ștergeți acest grup de locații?',locationGroupsSelect:'Selecteaza grupul de locatii din care face parte:',subscription:'Subscripție',myPlan:'Abonamentul meu',infoPages:'Pagini informative',taxLabeling:'Etichete Taxe',deliveryMethods:'Metode livrare',filters:'Filtre',filterProducts:'Filtre Produse',companyWeb:'Website Companie',services:'Servicii',scanner:'Scanner clienti',settings:'Setări'},permission:{general_can_access_dashboard:'Permite acces la Dashboard',general_can_access_clients:'Permite acces la Clienți',general_can_access_orders:'Permite acces la Comenzi',general_can_access_tables:'Permite acces la Mese',general_can_access_reservations:'Permite acces la Rezervări',general_can_access_add_order:'Permite acces la Adăugare comandă',general_can_access_dispatch:'Permite acces la Livrări',general_can_access_kds:'Permite acces la KDS',general_can_access_screens:'Permite acces la Ecrane',general_can_access_pos:'Permite acces la POS',general_can_access_inventory:'Permite acces la Gestiune',general_can_access_catalog:'Permite acces la Catalog',general_can_access_marketing:'Permite acces la Marketing',general_can_access_scan:'Permite acces la Scanare',general_can_access_reports:'Permite acces la Rapoarte',general_can_access_feedback:'Permite acces la Feedback',general_can_access_setings:'Permite acces la Setări',general_can_access_pay:'Permite acces la Plăți',general_can_access_suport:'Permite acces la Suport',general_can_access_price_lists:'Permite vizualizarea listelor de prețuri',can_access_supplier_orders:'Gestiune - Access la Comenzi Furnizor',can_create_supplier_order:'Gestiune - Creaza Comenzi Furnizor',can_send_supplier_order:'Gestiune - Trimite Comenzi Furnizor',can_receive_supplier_order:'Gestiune - Receptie Comenzi Furnizor',can_validate_supplier_order:'Gestiune - Valideaza Comenzi Furnizor',can_generate_nir:'Gestiune - Generare Nir',can_process_supplier_order:'Gestiune - Proceseaza Comenzi Furnizor',can_generate_aviz:'Gestiune - Poate genera aviz',can_generate_invoice:'Gestiune - Poate genera facturi',can_access_dashboard:'Gestiune - Access la dashboard',can_access_gestiune:'Gestiune - Access la gestiune',can_access_reports:'Gestiune - Access la rapoarte',can_access_settings:'Gestiune - Access la setari'},settingUsers:{permissions:'Permisiuni:',permissionsGestiune:'Permisiuni Gestiune',permissionsGeneral:'Permisiuni Generale',single:'utilizator',fn:'Prenume',ln:'Nume',email:'Email',phone:'Telefon',active:'Program Activ',scheduleStatus:'Programul este:',scheduleActive:'activ',scheduleInactive:'inactiv',username:'Nume utilizator',program:'Alege programul',lang:'Limba interfață',langMsg:'Acesta este limba în care vei vedea panoul de administrare.',avatar:'Avatar',role:'Rol',locations:'Access la comenzi din locatiile',locations_helptext:'Important: In cazul in care nu sunt selectate locatii, utilizatorul va avea acces la toate locatiile.',resetPass:'Resetează Parolă',password:'Parolă',pass:'Parolă',confPass:'Confirmă Parolă',userAdded:'Utilizator nou adăugat cu succes',userUpdated:'Utilizator actualizat cu succes',userPicError:'Avatarul utilizatorului nu a fost salvat, te rugăm să încerci mai târziu.',USER:'USER',DRIVER:'DRIVER',OWNER:'OWNER',LOCATION_ADMIN:'LOCATION ADMIN',MARKETER:'MARKETER',OPERATOR:'OPERATOR',KDS_OPERATOR:'KDS OPERATOR',USER_CUSTOM:'Utilizator Custom',DISPATCHER:'DISPATCHER'},settingTable:{'use_tips':'Foloseste Bacsis','yumm_integration_external_ip':'Ip extern integrare Yumm',onlineQrTitle:'QR comandă online',onlineQrDesc:'Cod QR care deschide comanda online pentru această masă.',onlineQrEmpty:'Încă nu a fost generat un QR online.',onlineQrGenerate:'Generează QR',onlineQrRegenerate:'Regenerează QR',onlineQrCopy:'Copiază linkul','all':'Toate','activ':'Activ','inactiv':'Inactiv','as_useer':'Ca Utilizator','series':'Serie Comanda','start_number':'Numar de start Comanda','allow_maps':'Harti Mese','use_table_maps':'Foloseste harti mese','disable_eat_in':'Opreste Eat In','disable_delivery':'Opreste Delivery','disable_pick_up':'Opreste Pick Up','disable_drive_in':'Opreste Drive In',allDeliveryMethodsDisabled:'Cel puțin o metodă de livrare trebuie să rămână activă (Eat In, Delivery, Pick Up sau Drive In).','default_method':'Metoda Default','default_sort_checkout_buttons':'Ordoneaza primele 4 butoane din checkout','disable_tips':'Opreste Tips','disable_ballance':'Opreste Balance','auto_print_receipt':'Printează nota de plată automat','auto_print_receipt_on_metods':'Printează nota de plată automat pt metodele','auto_print_receipt_on_status':'Printează nota de plată automat pentru statusurile',allowClosingOrdersWithoutReceipt:'Permite închiderea comenzilor fără bon fiscal','allow_close_order_without_receipt':'Permite închiderea comenzilor fără bon fiscal','allow_closing_orders_without_driver':'Permite închiderea comenzilor fără șofer','comment_for_virament':'Comentariu pentru virament','stop_print_section':'Opreste printarea pe sectii','close_order':'Inchide Comenzile cu status delivered tot timpul','set_logged_user_in_reports':'Filtrează rapoartele după utilizatorul autentificat','disable_seats':'Dezactiveaza aparitia popupului cu numarul de locuri la masa','disable_pager':'Dezactiveaza aparitia popupului cu numarul de pager','block_z_until_all_orders_fiscalized':'Blocheaza Z pana toate comenzile sunt fiscalizate','allowed_fiscal_payment_methods':'Metode de plată fiscale permise','allow_fiscal':'Permite fiscalizarea','allow_change_payment_type_on_fiscalization':'Permite schimbarea tipului de plată la fiscalizare','use_block_actions_after_print':'Blochează acțiunile după printare','auto_print_fiscal_on_status':'Selecteaza statusurile pentru care vrei auto fiscalizare','auto_print_fiscal_on_source':'Selecteaza sursele pentru care vrei auto fiscalizare','auto_print_fiscal_on_payment_methods':'Selecteaza metodele de plata pentru care vrei auto fiscalizare','disable_required_options':'Opreste Validarea optiunilor','is_manager':'Este Manager','table_for_one_user':'Masa este atribuită primului utilizator','pos_allow_order_change_status':'Permite schimbarea de status pe comenzi','pos_allow_reports':'Permite filtrarea rapoartelor','pos_allow_approvals':'Permite aprobarea actiunilor','pos_allow_advanced_settings':'Permite setări avansate','pos_allow_advanced_settings_info':'exemplu: ștergerea comenzilor mai vechi de 2 zile','pos_allow_access_reports':'Permite accesul la rapoarte','bank_terminal':'Terminal Bancar','has_bank_terminal':'Are terminal bancar conectat (FiscalNet)','has_integrated_bank_terminal':'Are terminal bancar propriu conectat','sound_new_order':'Activează sonerie pentru comenzi noi','sound_notification':'Activează sunet pentru notificări','sync_products_from_all_locations':'Sincronizează produsele din locatiile setate','sync_location_ids':'Locații de sincronizat','is_dispatch':'Mod dispatch','menu_orientation':'Orientarea meniului','vertical':'Vertical','horizontal':'Orizontal','allow_tables_access_only_if_assigned':'Masa nu poate fi utilizată fără un utilizator atribuit','use_fiscal_net_at_modern_payment':'Folosește FiscalNet la Plata Modernă','allow_bank_transfer':'Permite plată prin Virament Bancar','pos_allow_transfer':'Permite Transfer','pos_allow_waiter_transfer':'Permite transfer ospătar','pos_allow_table_transfer':'Permite transfer masă','pos_allow_staff_food':'Permite plată pentru Mâncare Personal','allow_some_top_categories':'Permite doar câteva categorii de top pentru acest utilizator','allow_some_top_categories_map':'Permite doar câteva categorii de top pentru aceasta harta','staff_food_daily_budget':'Buget zilnic mâncare personal','pos_allow_discount':'Accepta Discount','pos_allow_storno':'Permite Storno','pos_allow_refund':'Permite Refund','allow_access_all_tables':'Permite accesul la toate mesele','allow_change_driver':'Permite schimbarea șoferului','allow_print_note':'Permite note de plată','not_allowed_order_statuses':'Statusuri de comandă nepermise','pos_allow_mobile_pos':'Accepta Pos Mobil','pos_allow_plata_moderna':'Accepta Plata Moderna','pos_allow_protocol':'Accepta Protocol','pos_allow_glovo':'Accepta Glovo','pos_allow_bolt':'Accepta Bolt','pos_allow_wolt':'Accepta Wolt','pos_allow_tips':'Accepta Bacșiș','pos_disable_cancel_order':'Dezactivează anularea comenzii','pos_filter_status_orders':'Alege statusurile care vrei sa fie selectate default pt comenzii','email':'Email','lastname':'Nume','firstname':'Prenume','login_code':'Login Code (unique 4 digits)','login_code_already_used':'Acest cod de autentificare este deja folosit.','lock_screen_timeout_min':'Durata pentru blocarea ecranului (minute)','round':'Rotund','squere':'Patrat','table_shape':'Forma','deleteZoneTitle':'Ești sigur?','deleteZoneTxt':'Prin această acțiune vor fi șterse toate mesele și kioskurile care aparțin acestei zone împreună cu setările de disponibilitate ale acestora!','app_available':'Disponibilă pentru rezervare','min_pers':'Numărul minim de persoane','max_pers':'Numărul maxim de persoane','with_open_order':'Comanda deschisa','with_split_pay':'Plateste separat','tableSave':'Salvat cu success','short_spv':'Valoare SPV','short':'Prescurtare','name':'Nume','number':'Nume masă','kioskName':'Nume Kiosk','offlineLoginCode':'Cod login:','location':'Locație','type':'Tip','zone':'Zonă','maps':'Harti Mese','loginCode':'Cod Logare','printOrder':'Printeaza bonul de comanda:','posSet':'Setări Pos','fiscalSet':'Setări Imprimantă Fiscală','use_pager':'Cu Pager','use_methods':'Activeaza metodele la kiosk (Pickup, eat in)','kiosk_offline':'Kiosk offline','kioskVideo':'Video kiosk (rulează pe ecranul de start)','kioskVideoHint':'MP4 sau WEBM, max 50MB. Salvează kioskul după upload.','kioskVideoTooBig':'Video-ul poate avea maxim 50MB','kioskVideoUploaded':'Video încărcat. Salvează kioskul ca să se aplice.','kioskVideoRemove':'Șterge','kioskVideoHintAuto':'MP4 sau WEBM, max 50MB. Video-ul se salvează automat pe kiosk după upload.','kioskVideoSaved':'Video încărcat și salvat pe kiosk.','kioskVideoRemoved':'Video șters.','qr_offline':'QR offline','qrSettings':'Setări QR','qrGeneralSettings':'Detalii generale','qrConnectionSettings':'Conexiune offline','qrServiceSettings':'Setări service','qrCapacitySettings':'Capacitate și disponibilitate','qrNumberingSettings':'Numerotare documente','qrPaymentMethods':'Metode de plată QR','qrPaymentMobilePos':'POS mobil','qrPaymentCard':'Card','qrPaymentBankTerminal':'Terminal bancar','qrPaymentDirectConnection':'Legat direct','qrPaymentMode_online':'QR online','qrPaymentMode_offline':'QR offline','qrPaymentType_CASH':'Numerar','qrPaymentType_POS':'POS mobil — fără declanșare terminal','qrPaymentType_CARD_POS':'POS mobil — declanșare terminal','qrServiceCode':'Cod mod service','reloadAllKiosks':'Reload all kiosks','reload':'Reload','reloadPending':'Reload în așteptare','kiosksWillReloadNextOrder':'Kioscurile isi vor face reload la urmatoarea comanda!','use_cash_machine':'Cu Cash Machine','disable_cash_payment':'Dezactivează plata cash','kiosk_is_using_fiscal_receipt_for_sections':'Chioșcul folosește imprimanta fiscala pentru secții','without_OrderFormFlags':'Fara comenzile din:','use_fiscal_net':'Cu FiscalNet','use_fiscal_net_with_pos':'Pos cu FiscalNet','printerSet':'Setări Imprimantă','server_ip':'IP server','server_port':'Port server','terminal_port':'Port terminal','ip':'Ip','port':'Port','host':'Host','p1':'Adr1','p2':'Adr2','kioskUrl':'Descarcare installer Kiosk','disableAuth':'Oprește POS','disableAuthInfo':'POS-ul nu va mai funcționa până la efecutarea unei noi instalări','disableAuthScreen':'Oprește Ecran','disableAuthScreenInfo':'Ecranul nu va mai funcționa până la efecutarea unei noi instalări','printerIp':'IP și Port Imprimantă','printerIpExample':'ex. 127.0.0.1:8080','serverIp':'Ip server','serverIpExample':'ex. 192.168.1.100','waiters':'Ospătari','dispalyProductsImage':'Afișează imaginile produselor','assignWaiter':'Alege ospătari','allowPosUseCoupons':'Verifică cupoanele active în timp real','posSetClientOnOrder':'Întreabă clientul dacă are cont','pos_confirm_order_close_on_method_select':'Confirmă închiderea și fiscalizarea comenzii la selectarea metodei de plată','posDisplayAllProductOptions':'Afișează toate opțiunile pe produs','posDefaultCourseCount':'Numărul de feluri','posAllowGroupProducts':'Permite gruparea produselor identice în comandă','forceCreditForIntegrationCashOrders':'Forțează „Credit” pentru comenzile din integrări plătite în „Numerar”','posUseYummVoucher':'Folosește voucher YUMM','posUseStock':'Folosește stoc pe POS','posAskStornoBackInStock':'Întreabă dacă produsele se pun înapoi pe stoc la storno','pos_keep_first_waiter_id_order_split':'Păstrează ID-ul primului ospătar la împărțirea comenzii','posDisplayTipsOnOrder':'Afișează bacșișurile pe comandă','searchTable':'Caută mese după nume',externalId:'ID extern',externalIdPlaceholder:'Referință externă (ex. POS sau integrare)',group_tables_users:'Mese și utilizatori',group_order_types:'Tipuri de comandă',group_closing_orders:'Închiderea comenzilor',group_payments:'Plăți și terminale',group_fiscal_printing:'Fiscalizare și tipărire',group_display:'Afișare și interfață',group_reports:'Rapoarte',fiscalPrinter:'Imprimantă fiscală',cantar:'Cântar'},referalSettings:{'inactive_loyalty':'Vă rugăm să activați punctele de fidelitate!','points_handle':'Cum sa fie adaugate punctele','only_referal':'Numai punctele pentru modul recomandări','only_fidelity':'Numai punctele de fidelitate','both_points':'Ambele puncte','higher_point':'Doar valoarea mai mare','initial_parent_percentage':'Procentaj din prima comandă pentru persoana care recomandă','initial_order_percentage':'procent din comanda','initial_child_percentage':'Procentaj din prima comandă pentru persoana recomandată','order_count':'Pentru câte comenzi se aplică beneficiile (în afară de prima comandă)','order_count_info':'Dacă nu este completat, numărul de comenzi este nelimitat.','order_values':'Procentaj după prima comandă','parent_order_percentage':'Procentaj din comandă pentru persoana care recomandă','parent_order_percentage_info':'Dupa prima comanda ce procentaj din comanda se aplica','child_order_percentage':'Procentaj din comandă pentru persoana recomandată','parent_receive_points':'Beneficii și pentru persoana care este recomandată'},addOrder:{toGo:'La Pachet',commentTitle:'Adaugă comentariu',choosePay:'Alege metoda de plată','areYouSureDelete':'Ești sigur că vrei să ștergi?','adressDeleted':'Adresă ștearsă cu succes','titleClient':'Detalii client','titleMethod':'Metoda livrare','titleLocation':'Locație','titleAdress':'Adresă livrare','titleStatus':'Status','done':'Gata','datepicker':'Alege data de livrare','hourpicker':'Alege ora de livrare','how_many':'Pentru cate persoame se face rezervarea','tags':'Comanda din','fromTable':'Pentru: ','titlePopupTip':'Adauga Valoarea','btnPopup':'Adauga','titlePopupPriceModify':'Editare pret produs','titlePopupCoupon':'Adauga cupon','errorPopupCoupon':'Cupon gresit','freeCouponProductAdded':'Produs gratuit adăugat în coș: {products}','errorProduct1':'Produsele nu mai sunt disponibile și au fost șterse din coș','errorProduct2':'Unul sau mai multe produse nu mai sunt disponibile și au fost șterse din coș','errorProduct3':'Trebuie sa aveti produse in cos pentru a putea comanda!','errorProduct4':'Te rugam sa selectezi metoda si locatia','errorProduct5':'Te rog adauga un client','errorProduct6':'Metoda de plata neselectata','errorProduct7':'Te rog adauga o adresa','errorProduct8':'ERROR, Va rugăm să verificați imprimantă fiscală și dispozitivul bancar POS!','add':'Adaugă','edit':'Editează','total':'TOTAL','infosup':'Adaugă informații suplimentare','state':'Județ','city':'Oraș','adress':'Bloc, scară, etaj, apartament','number':'Număr','street':'Strada','adressname':'Nume Adresa','sexf':'Feminin','sexm':'Masculin','sex':'Sex','birthdate':'Data nașterii','contactperson':'Persoana de contact','newclient':'Adaugă un client','newadress':'Adaugă sau alege adresa ','save1':'Alege și salveaza modificarile','deliveryAdress':'Adaugă o adresa nouă','deliveryAdressEdit':'Editează adresa','prodId':'ID / Cod Client','firstName':'Prenume','lastName':'Nume','contactPers':'Persoana de contact','clientSelected':'Client selectat','clearFields':'Gloeste Campurile','addAdress':'+ Adaugă adresă','existingClient':'Comandă trimisa din','orderNow':'Plasează Comanda','editOrderNow':'Finalizează editarea','POS':'Pos','pos':'Pos','cash':'Cash','free':'Gratis','protocol':'Protocol','coment':'Comentariu Comandă','client_notif':'Acest text se va trimite clientului','addTip':'Adaugă bacșiș','removeTip':'Sterge bacșiș','addCoupon':'Adaugă cupon de reducere','removeCoupon':'Sterge cupon de reducere','modif':'modifică','freeProd':'Produs Gratuit','partialPay':'Editare Pret','info':'Info','orderDet':'Detalii','cartDet':'Sumar comanda','fast':'Cat mai rapid','selectHour':'Selecteaza ora','selectPayment':'Selecteaza metoda de plata','pleaseSelectMethodAndLoc':'Va rugam sa selectati metoda si locatia!','locSelect':'Selectati o locatie','searchProduct':'caută produse','phone':'Telefon','email':'E-mail','inlocation':'In Locatie','glovo':'Glovo','tazz':'Tazz','bolt':'Bolt','wolt':'Wolt','application':'Aplicatie','online':'Online','adressNotInRange':'Esti prea departe, te rog schimba adresa!','adressNotCorect':'Adresa nu este corecta','noClient':'Comanda fara client','other':'Altele'},settingCompany:{authAppCode:'Cod autentificare in Locatie',generateAuthAppCode:'Genereaza code',purchase_limit_interval_hours:'Disponibilitate interval limită de achiziție în ore',integrators_department:'Taxe Integratori',integrators_tax_vat_printer_id:'ID imprimantă TVA',other_taxes_vat_printer_id:'ID imprimantă pentru corecții',donation_vat_printer_id:'ID imprimantă pentru donații',vatPrinterIdColumn:'ID imprimantă',integrators_tax_vat_amount:'Valoarea TVA-ului',integrators_department_id:'ID departament',title:'Companie',location:'Locație',name:'Nume',selfOrderDomain:'Self Ordering Domain',appLink:'Link Aplicatie',appLinkAndroid:'Android link aplicatie',appLinkIos:'Ios link aplicatie',lang:'Limba aplicație',bussLoc:'Locație local',deliveryLabels:'Status metode de livrare',deliveryType:'Metoda de livrare',pick_up:'Ridicare comandă',meet_half:'Ne întâlnim la jumătate',delivery:'Livrare',eat_location:'Rezervare masă',self_ordering:'Self Ordering',phone:'Telefon',street:'Stradă',number:'Nr.',latitude:'Latitudine',longitude:'Longitudine',email:'Email',city:'Oraș',country:'Țară',state:'Județ',availableDaysHrs:'ZILE ȘI ORE DISPONIBILE',from:'de la',to:'până la',preOrder:'pre-comandă de la',allowPreOrder:'Permite Pre-comandă',cardPaymentDetails:'Setari plată cu cardul',paylikeKeys:'Chei utilizate pentru Paylike',posDiscount:'POS id pentru discount',userTaxes:'TAXE UTILIZATE',noTaxMsg:'Info: Ai făcut modificări la taxe, nu uita să le salvezi.',areYouSureDelete:'Ești sigur că dorești să ștergi această locație? Această acțiune va șterge, de asemenea, setările de comandă pentru această opțiune.',pickLocationToCopy:'Alege locația de la acre vrei să copiezi produsele',areYouSureTax:'Sigur dorești să elimini această taxă din lista impozitelor? Nu uita să salvezi modificările făcute!',areYouSureVat:'Sigur dorești să elimini această cotă din lista TVA? ',companyUpdated:'Datele companiei au fost actualizate cu succes',locationUpdated:'Datele locației au fost actualizate cu succes',updateError:'Datele nu au fost salvate. Vă rugăm să verificați din nou datele introduse!',companyProdCopied:'Produsele au fost copiate cu success.',companyProdAddLoc:'Locatie adaugata pe produse cu succes.',copyBtn:'Adauga locatii pe produse',companyProdDeleted:'Produsele au fost sterse cu success.',areYouSureDeleteProd:'Ești sigur că dorești să ștergi toate produsele din locație?',wrongAddress:'Adresa locației "{location}" nu este corectă.',deleteLocationValidation:'Această locație nu se poate șterge pentru ca este folosită pe produse sau opțiuni.',email_feedback:'Adrese de e-mail pentru a primi feedback din aplicaţii',email_feedback_helptext:'Puteți folosi mai multe adrese separata prin virgulă.',printSettings:'Setari printare',automatPrintOrder:'Printare web automată A4',autoSendOrderToPrinter:'Printare comandă imprimantă 80 mm',autoPrintLocalServer:'Printare automată nota de secție de pe serverul local (comenzi noi sau în procesare)',printerIp:'IP/Host Imprimantă',printerPort:'Port Imprimantă',hostname:'Hostname (pc)',printerName:'Nume Imprimanta (din windows)',printer_is_usb:'Este pe USB',copyProductsFrom:'Copiază produse din ',deleteProducts:'Șterge toate produsele din această locație',menuActions:'Acțiuni meniu',overEighteen:'Restricționarea utilizatorilor sub 18 ani (necesară pentru vânzarea de alcool prin aplicație)',setRadiusArea:'Setează rază de livrare',setDrawArea:'Setează rază desenată de livrare',jump_to_menu:'Sari direct la meniu',jump_to_categories_menu:'Permite accesarea directă a meniului din aplicație, înaintea metodelor de livrare.',allow_fiscal_print:'Permite printarea bonurilor fiscale.',payment_btns_v2:'Butoane de payment V2',pos:'POS',use_pos_notifications:'Folosește notificări POS',use_clients_offline:'Folosește clienți offline',use_gift_card_on_pos:'Folosește card cadou în POS',app:'App',use_interactive_tour_always:'Folosește turul interactiv mereu',use_interactive_tour_first_login:'Folosește turul interactiv la prima autentificare',force_location_from_deeplink:'Forțează locația din deeplink-uri',just_card_txt_to_kiosk:'Text doar card pe Kiosk',table_scroll_menu_horizontal:'Scroll meniu orizontal',add_packing_method_to_comment:'Adaugă metoda de servire (în locație / la pachet) în comentariul comenzii pe Kiosk',useProdTimeOpt:'Foloseste optiuni de timp pentru produse (doar pentru metoda de rezervare)',allowPlaceUntilCloseHour:'Permite plasare comenzi până la ora închiderii',sortProductsMethods:'Metode de sortat produse',alphabetic_asc:'După nume ascendent',alphabetic_desc:'După nume descendent',price:'După preț',custom:'Custom',infoCustomSort:'(sortarea custom este facută pe fiecare categorie în secțiunea de editare)',filters:'Filtre',allowSoundAtStatusNew:'Permite sunet de atenționare la comenzi cu status NOU',addStatusOnHold:'Permite statusul In Asteptare',addStatusPostponed:'Permite statusul Amânare',removeTotalsExtrasFromDiscount:'Nu aplica discount si din taxe',useGrandTotalForDeliveryZoneShippingCost:'Aplică costul de livrare pe baza valorii finale a comenzii',allowSoundAtStatusProcessing:'Permite sunet de atenționare la comenzi cu status PROCESATĂ',allowSoundAtStatusProcessingV1:'Permite sunet in funcție de timpul implicit de așteptare',allowSoundAtStatusProcessingV2:'Permite sunet in funcție de 1/4 din timpul implicit de așteptare',allowSoundAtStatusProcessingV3:'Permite sunet in funcție de 1/2 din timpul implicit de așteptare',allowSoundAtStatusProcessingV0:'Fără sunet',allowToOrderUnderMinValueWithCoupon:'Permite plasarea de comenzi sub valoarea minimă, când este aplicat un cupon',flagFastOrderFromAdmin:'Comanda in locatie rapida',allowSoundForMehods:'Permite sunet pentru următoarele metode de livrare',generateQrMenu:'Pentru a genera coduri QR actualizati',generateClientViewLink:'Pentru a genera link-urile actualizati',generateQrMenuSettings:'locațiile companiei',email_transport:'Email transport',lateOrders:'Comnezi întârziate',tipSuggestion:'Sugesti Bacsis',reorderPopupTitle:'Popup comandă (meniu QR)',reorderPopupMinutes:'Minute de inactivitate până la afișarea popup-ului',reorderPopupHelp:'0 sau gol dezactivează popup-ul. Nu apare pe kiosk. Apare doar dacă există cel puțin un produs în coș.',kioskQrSettingsTab:'Setări Kiosk/QR',kioskSettingsTitle:'Setări Kiosk/Qr',kioskUsingTopCategoryLabel:'Folosește categoriile principale',kioskUsingTopCategoryHelp:'Când este activat, meniul este grupat pe categorii principale la detalii, kiosk și QR.',kioskFiscalReceiptForCashLabel:'Kiosk-ul folosește bon fiscal pentru numerar',kioskNonFiscalReceiptForCardLabel:'Kiosk-ul folosește bon nefiscal pentru card',kioskAddToCartNotificationPositionLabel:'Poziția notificării la adăugarea produsului în coș',kioskAddToCartNotificationPositionPopup:'Pop-up',kioskAddToCartNotificationPositionSidebar:'Bară laterală',tipSuggestionType:'Tip',tipSuggestionSuggestion:'Sugestia',discountSuggestion:'Sugestie Discount',discountSuggestionType:'Tip',discountSuggestionSuggestion:'Sugestia',discountSuggestionFix:'Fix',discountSuggestionProc:'Procent',twilio_call:'Amintește-mi de comenzile întârziate prin apel telefonic',twilio_call_early_mark:'Amintește-mi în primele 5 minute',transport_setings:'Setari Transport',google_maps_api_key:'Cheie google API',deliveryMethodsReflect:'Actualizările metodelor de livrare trebuie să se reflecte în',locationGroups:'grupurile de locații',automatedProcessedStatus:'Setează automat statusul comenzii din "Nou" in "Procesată"',donationPointValue:'Paritate puncte donatie',donationPointValueNr:'(loyalty * thisValue = donationPoints)',alertMultipleOrders:'Alerta pentru comenzi per ora',alertMultipleOrdersNr:'Numar de comenzi per ora',smsoToken:'Token',smsoSender:'User ID',smsoTokenExtern:'Token Extern',smsoSenderExtern:'User ID Extern',locationImage:'Imaginea Locației',holidayTitle:'Orar de vacanță',holidayAlert:'Zilele din metodele de livrare se dezactivează/reactivează automat în funcție de intervalul orarului de vacanță.',holidayEnabled:'Activat',holidayValidFromTo:'Valabil de la - până la',apiKey:'Cheie API',cif:'CIF',addToCC:'Adaugă-mă la CC',automatedInvoice:'Emite factura automat',invoicePerOrder:'Emitere Factura pe Comandă',series:'Seria Facturii',sendInvoice:'Trimite Factura',openInvoice:'Deschide Factura',use_auto_dispatch:'Mod automat',newOrdersProcessing:'Procesează comenzi noi',autoGroupingByZone:'Grupare automată după zonă',preparedStatus:'Statusul "Preparată"',autoModeText:'Sistemul este acum în modul automat. Comenzi vor fi primite, procesate și organizate automat în loturi pe baza zonelor geografice. Odată batch-uite, sistemul va aloca livrările la cel mai apropiat livrator disponibil, asigurând o distribuție eficientă și la timp a comenzilor.',manualModeText:'Sistemul este acum în modul manual. Comenzi vor fi procesate individual de un operator uman. Acest lucru include primirea comenzilor, organizarea lor în loturi pe baza zonelor geografice și manual atribuirea livrărilor la cel mai apropiat livrator disponibil pentru a asigura o distribuție optimă.',assignOrderToDriver:'Atribuie comanda unui livrator',drivers:'Drivers',unavailableRestaurantTitle:'Aplicație Indisponibilă',unavailableRestaurantText:'Mesaj',unavailableRestaurantImage:'Imagine',unavailableRestaurantTextPlaceHolder:'Acest mesaj va fi afișat utilizatorilor atunci când nici o locație nu are cel puțin o metodă de livrare activată',digitalWaiter:'Ospătar Digital',invoices:'Facturi',printer:'Imprimantă',menuIntegration:'Integrare',orderStatus:'Status comandă',smsoIntegration:'Integrare SMSO',languages:'Limbi disponibile',preferences:'Preferințe',appQRCode:'Cod QR Aplicație Mobilă',digitalWaiterMode:'Mod Meniu QR',allowOpenOrderLabel:'Mod comandă deschisă',allowOpenOrderHelp:'Activează modul comandă deschisă de pe meniul QR, permițând clienților să adauge la aceeași comandă în mai multe reprize.',paymentGroup:'Procesator de plată',createLocationCost:'Crearea unei noi locații implică costuri suplimentare. Dorești să continui?',activateLocationCost:'Activarea unei noi locații implică costuri suplimentare. Dorești să continui?',closeOrders:'Închide toate comenzile cu {deliveryMethod}',closeOrdersAfter:'după x ore',closeOrdersAt:'la ora selectată',autoChangeStatus:'Schimba statusul automat pentru comenzile cu {deliveryMethod}',otherSettings:'Alte setări',accessAndVisibility:'Acces si vizibilitate',measurements_units_id:'Unitate de masura',quantitative_unit:'Unitate Cantitativa',reportProductOptionTitle:'Raport Produse si Optiuni',email__prod_opt_report:'Adresa email unde se va trimite raportul',time__prod_opt_report:'Ora la care se va trimite raportul',inv_company_name:'Denumire firmă',inv_fiscal_code:'Cod fiscal',inv_trade_register:'Reg comerțului',inv_phone:'Telefon',inv_email:'E-mail',inv_country:'Tara',inv_address:'Strada',inv_street_number:'Numar',inv_county:'Județ',inv_city:'Localitate',inv_additional_data:'Date adiționale',inv_is_vat_payer:'Platitor de TVA',inv_is_vat_payer_0:'NU este platitor de TVA',inv_is_vat_payer_1:'ESTE platitor de TVA',inv_bank_account:'Cont bancar',inv_bank:'Banca',inv_bank_branch:'Sucursala',initalOrderStatusKiosk:'Status initial pentru comenzile de la Kiosk',initalOrderStatusApp:'Status initial pentru comenzile din Aplicatie si Web'},menuSubscriptions:{single:'abonament meniu',newTitle:'Abonament meniu nou',noSubscriptions:'Nu există abonamente de meniuri. Adaugă primul abonament.',perDayShort:'zi',durationDays:'{days} zile',menusCount:'{count} meniuri',defaultMenuShort:'implicit',zonesCount:'{count} zone',notReady:'Nu poate fi vândut încă, lipsesc',notReadyHint:'Completează ce lipsește ca să îl poți activa',readyActive:'Abonamentul este complet și activ (se poate cumpăra).',readyInactive:'Abonamentul este complet. Activează-l ca să poată fi cumpărat.',saveFirst:'Salvează întâi abonamentul',active:'Activ',activeAfterMenus:'Se poate activa după ce adaugi cel puțin un meniu.',saved:'Abonamentul a fost salvat.',deleted:'Abonamentul a fost șters.',areYouSureDelete:'Sigur ștergi abonamentul {name}?',tabGeneral:'General',tabDelivery:'Livrare',tabMenus:'Meniuri',tabCalendar:'Calendar',name:'Nume',namePlaceholder:'ex: Vegan - Prânz',nameRequired:'Numele este obligatoriu.',location:'Locația care pregătește comenzile',locationPlaceholder:'Alege locația',locationHint:'Comenzile zilnice se creează pe această locație; produsele se aleg din meniul ei.',locationRequired:'Alege locația.',pricePerDay:'Preț pe zi',pricePerDayHint:'O porție pentru o zi. Fiecare meniu trebuie să dea exact acest total.',priceRequired:'Prețul pe zi este obligatoriu.',duration:'Durata (zile calendaristice)',durationHint:'Clientul alege data de start (cu maxim {days} zile înainte) și primește livrări în zilele de livrare din această perioadă.',durationWeekendHint:'Dacă punem 30 de zile, dar nu livrăm în weekend, real vor fi aprox. 21 de zile de livrare (depinde cum pică zilele în care nu livrăm).',durationEstimate:'Cu zilele de livrare alese acum: {range} zile de livrare din {days} zile calendaristice.',maxSubscribers:'Maxim abonați activi',unlimited:'Nelimitat',maxSubscribersHint:'Gol = nelimitat.',minQuantity:'Cantitate minimă',maxQuantity:'Cantitate maximă',quantityHint:'Câte porții poate cumpăra clientul (ex: 2 = mâncare dublă în fiecare zi).',description:'Descriere',image:'Imagine',imageHint:'jpg/png, max 5MB',deliveryDays:'Zile de livrare',deliveryDaysHint:'În aceste zile se creează câte o comandă pentru fiecare abonat.',deliveryHours:'Intervale de livrare',deliveryHoursHint:'Clientul alege unul dintre intervale la cumpărare.',hoursInvalid:'Fiecare interval de livrare trebuie să aibă început și sfârșit (începutul înaintea sfârșitului).',from:'De la',to:'Până la',addInterval:'Adaugă interval',orderLead:'Creează comanda cu',minutes:'minute înainte',orderLeadExample:'Ex: pentru livrarea de la {from}, comanda intră în sistem (POS/bucătărie) la {time}.',orderLeadExampleDayBefore:'Ex: pentru livrarea de la {from}, comanda intră în sistem (POS/bucătărie) la {time} cu o zi înainte.',zones:'Zone de livrare',zonesPickLocation:'Alege întâi locația (tab-ul General).',noZones:'Nu există zone de livrare pentru companie sau pentru această locație.',zone:'Zonă',zoneDefaultFee:'Taxa zonei',zoneFee:'Taxa pe livrare',companyZone:'zonă companie',locationZone:'zonă locație',zoneInactive:'inactivă',zonesHint:'Taxa se plătește pentru fiecare livrare. Gol = taxa zonei; 0 = livrare gratuită.',fixErrors:'Completează câmpurile marcate',rescaleQuestion:'Prețul pe zi s-a schimbat. Ajustez proporțional prețurile produselor din cele {count} meniuri ca să dea {price}?',rescaleYes:'Da, ajustează',rescaleNo:'Nu, le ajustez eu',dayShort:{monday:'Lu',tuesday:'Ma',wednesday:'Mi',thursday:'Jo',friday:'Vi',saturday:'Sâ',sunday:'Du'},months:{0:'Ianuarie',1:'Februarie',2:'Martie',3:'Aprilie',4:'Mai',5:'Iunie',6:'Iulie',7:'August',8:'Septembrie',9:'Octombrie',10:'Noiembrie',11:'Decembrie'},issues:{no_location:'locația',no_price:'prețul pe zi',no_delivery_days:'zilele de livrare',no_delivery_hours:'intervalele de livrare',no_zones:'zonele de livrare',no_menu:'cel puțin un meniu',menu_price_mismatch:'meniuri cu totalul diferit de prețul pe zi ({menus})'},menusTitle:'Meniuri',menusHint:'Meniul implicit se livrează în toate zilele fără alt meniu în calendar. Fiecare meniu trebuie să dea {price}.',newMenu:'Meniu nou',editMenu:'Editează meniul',noMenus:'Nu există meniuri. Primul meniu adăugat devine meniul implicit.',defaultMenu:'Implicit',makeDefault:'Fă-l meniul implicit',duplicate:'Duplică',totalMismatch:'total {total} - nu corespunde prețului pe zi',upcomingDays:'{count} zile în calendar',willAssignDates:'După salvare, meniul va fi pus pe zilele: {dates}',menuName:'Nume meniu',menuNamePlaceholder:'ex: Luni - săptămâna 1',menuNameRequired:'Numele meniului este obligatoriu.',addProducts:'Adaugă produse',searchProducts:'Caută produs după nume sau ID',allCategories:'Toate categoriile',noProductsFound:'Nu s-au găsit produse.',catalogPrice:'preț catalog',catalogPriceHint:'Preț catalog (orientativ)',vat:'TVA',course:'Fel',product:'Produs',quantity:'Cantitate',unitPrice:'Preț în meniu',lineTotal:'Total',noItems:'Adaugă cel puțin un produs în meniu.',productMissing:'Produsul nu mai există. Înlocuiește-l.',putDifferenceHere:'Pune diferența pe acest produs',cannotPutDifference:'Diferența nu se poate împărți exact la cantitatea acestui produs. Alege un produs cu cantitatea 1.',cannotRescale:'Nu se poate ajunge exact la total cu aceste cantități. Adaugă un produs cu cantitatea 1 sau ajustează manual.',menuTotal:'Total meniu',difference:'Diferență',adjustProportionally:'Ajustează proporțional la {price}',priceRuleHint:'Prețurile din meniu sunt cele care apar pe comandă și pe bonul fiscal. Prețul din catalog este doar orientativ.',totalMustMatch:'Totalul meniului ({total}) trebuie să fie egal cu prețul pe zi ({price}).',deleteMenuQuestion:'Sigur ștergi meniul {name}?',deleteMenuDays:'Cele {count} zile din calendar vor primi meniul implicit.',deleteMenuDefault:'Următorul meniu devine meniul implicit.',menuSaved:'Meniul a fost salvat.',menuSavedAssigned:'Meniul a fost salvat și pus pe zilele selectate.',courses:{1:'Felul 1',2:'Felul 2',3:'Felul 3',4:'Desert',5:'Mic dejun',6:'Prânz',7:'Cină',8:'Gustare'},calendarHint:'Selectează zilele de livrare și alege meniul lor. Zilele fără meniu ales primesc meniul implicit.',calendarCustom:'Meniu ales',calendarDefault:'Meniul implicit',calendarNoDelivery:'Fără livrare',calendarNoDeliveryShort:'fără livrare',calendarNoMenus:'Adaugă întâi un meniu (tab-ul Meniuri).',calendarNoMenu:'fără meniu',calendarSaved:'Calendarul a fost salvat.',selectMonth:'Selectează toată luna',clearSelection:'Deselectează',selectedDays:'{count} zile selectate',chooseMenu:'Alege meniul',applyMenu:'Pune meniul',resetToDefault:'Revino la meniul implicit',newMenuForDays:'Meniu nou pentru aceste zile'},menuSubscribers:{title:'Abonați',offer:'Abonament',allOffers:'Toate abonamentele',customer:'Client',searchPlaceholder:'Nume, email, telefon sau ID',statusLabel:'Status',status:{all:'Toți',paid:'Au plătit',active:'Activi',pending:'Doar au încercat',abandoned:'Abandonați',stopped:'Opriți',finished:'Finalizați'},empty:'Nu există abonați.',period:'Perioada',portions:'{count} porții',portionsLabel:'Porții',deliveries:'Livrări',deliveriesHint:'livrate / comenzi create / total',scheduledCount:'{count} programate',cancelledCount:'{count} anulate',errorsCount:'{count} cu eroare',orderedCount:'{count} comenzi create',deliveredOf:'{delivered} livrate din {total}',money:'Bani',total:'Total',paid:'Plătit',refunded:'Returnat',refundable:'Se mai poate returna',valueDelivered:'Valoare livrată',valueNotDelivered:'Valoare nelivrată',details:'Detalii',stop:'Oprește abonamentul',stopHint:'Nu se mai creează comenzi: cele {count} livrări rămase se anulează. Banii nu se returnează automat (folosește Returnează bani).',stopConfirm:'Oprește',stopQuestion:'Sigur oprești abonamentul lui {name}?',stopped:'Abonamentul a fost oprit.',refund:'Returnează bani',refundHint:'Se pot returna maxim {max}. Valoarea livrărilor nefăcute este {notDelivered} (orientativ - suma o alegi tu).',amount:'Suma',useSuggested:'folosește {amount}',refundProcessorHint:'Dacă plata nu e încă decontată la euPlatesc (de obicei în aceeași zi), se poate anula doar integral; o sumă parțială se poate returna după decontare.',refundConfirm:'Returnează',refundQuestion:'Sigur returnezi {amount} clientului?',refundDone:'Suma a fost returnată.',reason:'Motiv',reasonPlaceholder:'Motivul (rămâne în istoric)',interval:'Interval livrare',day:'zi',deliveryFee:'taxă livrare',source:'Cumpărat din',address:'Adresa',zone:'Zona',phone:'Telefon',comments:'Observații',stoppedInfo:'Oprit pe {date} de {user}',noDeliveries:'Nu există livrări (abonamentul nu a fost plătit).',date:'Data',menu:'Meniu',deliveryStatus:'Livrare',deliveryStatuses:{scheduled:'Programată',order_created:'Comandă creată',cancelled:'Anulată',error:'Eroare'},orderAt:'comanda la {date}',order:'Comanda',value:'Valoare',note:'Notă',payments:'Plăți',noPayments:'Nicio plată.',paymentStatuses:{created:'Creată',pending:'Link generat',success:'Plătită',failed:'Eșuată',expired:'Link expirat',cancelled:'Anulată',refunded:'Returnată integral'},refundStatuses:{pending:'în curs',success:'returnat',failed:'eșuat'},history:'Istoric acțiuni',noHistory:'Nicio acțiune.',events:{stop:'Oprit',refund:'Returnat'}},crossSell:{posSettingsTab:'Setări POS',title:'Produse cross-sell / upsell',help:'Produsele selectate îi vor fi sugerate operatorului de POS la finalizarea comenzii (checkout).',selectedTitle:'Produse selectate',noneSelected:'Niciun produs selectat încă.',searchPlaceholder:'Caută produse...',allCategories:'Toate categoriile',loading:'Se încarcă...',noResults:'Niciun produs găsit.',maxReached:'Poți selecta cel mult {max} produse.',pageInfo:'Pagina {page} din {pages} ({total} produse)'},scanner:{clientNotFound:'Clientul nu a fost găsit',notEnoughFunds:'Numărul introdus este prea mare',expired:'Codul a expirat',confirm:'Confirmă',wrongInput:'Numărul introdus nu este valid',scanCode:'Scanează codul QR al clientului'},settingDateTime:{timezone:'Fus orar',timeFormat:'Formatul de timp',dateFormat:'Formatul de dată',saveMsg:'Setările pentru dată și oră salvate cu succes'},settingCurrency:{currency:'Moneda localului',saveMsg:'Moneda localului salvată cu succes'},settingTaxes:{single:'Taxă',name:'Nume',type:'Tip',amount:'Cost',notice:'La "Etichete Taxe" definește doar un nume de etichetă pentru impozitul ce trebuie aplicat. Pentru a defini detaliile fiscale, cum ar fi valoarea sau tipul, trebuie să accesați ',notice2:'detalii companie',singleTaxLabel:'Etichetă Taxă',notice3:'La secțiunea "Taxe Generale" definești taxele care sunt aplicate, valoarea sau tipul acestora, dacă dorești să creezi o etichetă nouă accesează',notice4:'etichete taxe',notice5:'La secțiunea "TVA%" definești cotele TVA incluse in preț, dacă dorești să creezi o etichetă nouă accesează'},settingsPayment:{publicKey:'Cheie publică',privateKey:'Cheie privată'},settingsWeb:{header_color:'Culoare background header',header_text_color:'Culoare text header',success:'Detaliile au fost actualizate cu succes',fbLink:'Link Facebook',igLink:'Link Instagram',trpLink:'Link Tripadvisor',twitterLink:'Link Twitter',tiktokLink:'Link Tiktok',linkedinLink:'Link LinkedIn',websitePrezentareLink:'Link Website Prezentare',whatsapp:'Chat WhatsApp',gpLink:'Google Play',asLink:'Apple Store',fbPixel:'Facebook Pixel',fbapid:'Facebook App ID',interCol:'Culoare interfata',g4a:'Integrare GA4',site:'Link website',category_proportion:'Imagine categorie',product_proportion:'Imagine produs',background_color:'Culoare fundal',font_product_title:'Font titlu produs/categorie',font_product_description:'Font descriere produs',display_mode:'Mod afisare',display_image_category:'Afisare imagine categorie',social_media:'Linkuri social media',link_app:'Linkuri aplicatii',tracking:'Analytics',design:'Design aplicatie',structure:'Structura aplicatie'},settingsOrdering:{shipping_department_id:'ID-ul departamentului de expediere',reservation_pay_per_person:'Plateste pe persoana',extraCostRange:'Extra Cost Range',panaLa:'Pana la: ',distanceInKm:'Distanta in km',showTheRestOfTheZones:'Arata si celelalte zone pe harta',copyRangesFromLocation:'Copiază raze din locație',selectLocationToLoadRanges:'Selectează o locație pentru a încărca razele.',location:'Locație',selectLocation:'Selectează locație',ranges:'Raze',min_interval_reservations:'Durata in minute dintre intervalele posibile pentru rezervare',min_standard_reservations:'Durata unei rezervări (ore)',min_between_reservations:'Durata dintre rezervări (minute)',available_days:'Orar',reservation_available_in_app:'Permite rezervări la masă',reservationWidgetTitle:'Widget rezervări pentru site',reservationWidgetHint:'Copiază scriptul pe site. Company ID, Method ID și token-ul locației se completează automat.',reservationWidgetPosition:'Poziție',reservationWidgetLanguage:'Limbă',reservationWidgetHoursToStay:'Ore de ședere',reservationWidgetDefaultPersons:'Număr implicit de persoane',reservationWidgetTableZone:'Zonă mese',reservationWidgetCountryPrefix:'Prefix țară',reservationWidgetRestaurantName:'Nume restaurant',reservationWidgetScript:'Script de integrare',reservationWidgetCopy:'Copiază scriptul',reservationWidgetCopied:'Copiat',reservationWidgetPreview:'Previzualizare',reservationWidgetPosBottomRight:'Jos dreapta',reservationWidgetPosBottomLeft:'Jos stânga',reservationWidgetPosTopRight:'Sus dreapta',reservationWidgetPosTopLeft:'Sus stânga',max_number_seats:'Capacitate maximă de locuri în locație',offnoPreorders:'Trebuie sa ai offset 0 si period 1 pt a functiona',noPreorders:'Nu aceptam precomenzi',isAlwaysOpen:'Deschis permanent',isAlwaysOpenPreorderHours:'Ore precomandă după miezul nopții',reservationTaxesTitle:'Adaugă program mese',reservationTaxesTitleEmpty:'Niciun program adaugat',reservationTaxAdvanceConsumption:'Acest preț reprezintă avans în consumație',infoBoxTitle:'Adauga informatii extra',infoBoxRadioCheck:'Modifica optiunea',infoBoxRadio:'O singura optiune',infoBoxCheck:'Mai multe optiuni',enabled:'Activat',allow_fidelities:'Permite fidelizarea',allow_fidelitiesHelp:'Necesită fidelizarea activă',allow_sms_notifications:'Permite sms de anuntare client la statusul preparată (*necesita integrare smso activa)',paymentOptions:'Opțiuni de plată',paymentOptionsErr:'Câmpul de opțiuni de plată este obligatoriu.',closeOrderAfterHours:'Valorile posibile sunt între 0 și 23.',waitingTime:'Timpul de așteptare implicit',count_orders_starts_from_hour:'Ora de la care începe numerotarea comenzilor',maxDistanceInMeter:'Distanta in metri pentru raza de accesare masa:',minimumOrderValue:'Comanda minima',extraDeliveryTime:'Timp EXTRA',minutes:'min',hours:'ore',shippingCost:'Cost livrare',deliveryRange:'Rază de livrare',deliveryRangeUnit:'m',posId:'POS ID pentru cost livrare',shippingTax:'Taxe livrare',locations:'Locație',selectLocations:'Selectează sau lasă gol pentru toate',street:'Stradă',city:'Oraș',country:'Țară',state:'Județ',availableDays:'Zile și ore disponibile',availableDaysErr:'Câmpul pentru zilele și orele disponibile este obligatoriu.',notice:'Verifică câmpurile necompletate din cadrul modalităților de livrare active',saveSuccess:'Datele despre detaliile comenzilor au fost salvate cu succes',deliveryRules:'Reguli de livrare',addRange:'Adauga regula',shippingCities:'Localitati',shippingNeighborhoods:'Cartiere',citiesValidationError:'Valorile localitatilor trebuie sa fie unice pentru o regula de livrare.',errorAutoChangeStatusAfterMin:'Valorile posibile sunt între 0 și 360.',hourAndDate:'Ora si Data',justDate:'Doar data',deactivateDeliveryHours:'Dezactivează ora si data',offset:'Offset',period:'Period',chooseZone:'Alege zonă',addZone:'Adaugă zonă',newZone:'Zonă Nouă'},settingsZone:{edit:'Nume Zona',deleteBtn:'Sterge Zona',deleteShape:'Sterge forma pt a crea una noua',overridePayment:'Suprascrie metoda de plată',acceptCash:'Accept cash',acceptCard:'Accept card',acceptPos:'POS la livrare (neplătit)'},settingsInfoPages:{single:'pagină',noPage:'Nu s-au adăugat pagini încă.',title:'Titlu Pagină',content:'Conținut Pagină',newPage:'Pagină nouă',showInHeader:'Afișare în header',showInFooter:'Afișare în footer',imageSize:'Mărime imagine',imageSizeContain:'Încadrare',imageSizeCover:'Acoperire',imageSizeFullPage:'Pagină completă',addedSuccess:'Pagină salvată cu succes.',deletedSuccess:'Pagină ștearsă cu succes',deleteMsg:'Ești sigur că dorești să ștergi această pagină?',TERMS_CONDITIONS:'Termeni și Condiții',PRIVACY_POLICY:'Politica de Confidențialitate',CONTACT_DETAILS:'Date Contact',FIDELITIES_PROMOTIONS:'Promoții fidelitate',LOYALITY_POINTS:'Reguli puncte de loialitate',DONATION_POINTS:'Reguli puncte de donat',CUSTOM:'Personalizată',ABOUT_US:'Despre Noi',COOKIE_POLICY:'Politica Cookies'},settingsRewards:{single:'punct',plural:'puncte',state:'Status',points:'punct(e)',moneySpent:'Suprascriere rată de conversie',pointsTo:'Puncte în Bani',numberOfcurrencyNeedToSpend:'Număr de puncte primit la fiecare {currency} cheltuit.',default:'Câmpurile goale nu modifică rata de conversie inițială',numberOfpointsToReward:'Suma de puncte de care clientul are nevoie atunci când vrea să plătească folosind puncte.',rewardSuccess:'Datele programului de loialitate salvate cu succes',referalActive:'Modulul de recomandări a fost activat',referalInActive:'Modulul de recomandări a fost dezactivat',enableNotifications:'Activează Notificările',notifyUsersLoyaltyPoints:'Notifică clienții când primesc puncte de fideliate.',customizeLoyaltyPointsNotification:'Personalizează notificarea de ',timeInterval:'Interval orar ',fromTime:'De la ora',toTime:'La ora',here:'aici',initialReferal:'Procent din prima comanda pentru a castiga puncte',parentReferal:'Puncte primite de parinte',loyaltyOnlyFullPoints:'Permite doar puncte întregi',loyaltyOnlyFullPointsHelp:'Rotunjește în jos punctele câștigate pe comandă, după reduceri, folosind ratele de conversie configurate. Fracțiunile de punct nu se reportează. Soldul existent și valoarea punctelor la utilizare rămân neschimbate.',loyaltyMinOrderValue:'Valoarea minimă a comenzii pentru acordarea punctelor de loialitate',loyaltyMinOrderValueHelp:'Valoarea produselor după reduceri, fără livrare și bacșiș. Comenzile sub această valoare nu primesc puncte. Lăsați gol pentru a nu aplica un prag minim.',loyaltyPointsAppLimit:'Numărul maxim de puncte de loialitate permise ca discount pe comandă'},settingsPushNotif:{order_new:'Mesaj nou comandă',order_completed_pickup:'Mesaj comandă finalizată - Ridicare comandă',order_completed_meet:'Mesaj comandă finalizată - Ne întâlnim la jumătate',order_completed_delivery:'Mesaj comandă finalizată - Livrare',order_completed_eat:'Mesaj comandă finalizată - Rezervare masă',order_canceled:'Mesaj comandă anulată',notifUpdated:'Datele notificărilor prin mesaj salvate cu succes',preview:'Previzualizare',time:'oră',dateTime:'data și ora',persons:'numărul clientului',timePrev:'11:30 (în 30 de minute)',personsPrev:'3',dateTimePrev:'Marți, 15 februarie 2026, la 18',pointsPrev:'numărul punctelor',worthPrev:'echivalentul punctelor',info:'* În cazul în care nu doriți afișarea orei de livrare, lăsați liber ultimul câmp.',selectedLocations:'Locații selectate:'},settingsTips:{tipsLabel:'Bacșiș',tipsTaxes:'Taxe bacșiș',tipsVat:'TVA bacșiș',state:'Folosește bacșiș',tipsSuccess:'Bacșiș salvat cu succes'},settingsPlans:{plan1Title:'Lunar',plan1Rate:'160Euro / lună',plan1Description:'Începe cu o taxă fixă lunară, indiferent de suma facturată prin aplicație.',plan2Title:'Procentaj vânzari',plan2Rate:'10%',plan2Description:'Plătești în funcție de cât vinzi. Alege procentul din vânzări și vei plăti o taxă lunară raportată doar la vânzările tale prin aplicație.',current:'Subscripția actuală',switch:'Schimbă'},settingLocationGroups:{active:'Activ',isOpen:'Deschis',displayInSlider:'Pune grupurile în "slider"',noData:'Creați noi grupuri folosind butonul "+"',parentGroup:'Grupul Părinte',write:'(Scrie...)'},paymentPage:{invoice:'Factura',total:'Total',forDate:'Pentru data',payed:'Plătită',transaction:'Tranzacția',payLink:'Link Plată',viewInvoice:'Vezi factura',download:'Descarcă',pay:'Plătește',invoiceList:'Listă Facturi'},filter:{filter:'Filtru',action:'Acțiuni',create:'Filtru Creat',update:'Filtru Actualizat',areYouSureDelete:'Sigur vrei să ștergi acest filtru',yes:'Da',deleted:'Filtru șters',noFilters:'Nu există filtre',name:'Nume',addFilter:'Adaugă filtru',remove:'șterge',filters:'Filtre',value:'Valoare',filterProducts:'Filtre Produse',filterName:'Denumire Filtru',val:'val',filterUpdated:'Filtre Actualizate',minOneFilterValueRequired:'Minim o valoare pe filtru este obligatorie',filterType:'Tipul filtrului',type_exists:'Tipul filtrului exista',filter_value_exists:'Valoarea filtrului exista',some_filter_applied:'Actualizare cu succes, dar unele filtre/valori sunt aplicate pe produse și nu au putut fi șterse'},newsletterCard:{title:'Listă cu noutăți, informații și suport',titleNews:'Noutăți',titleMonthlyInfo:'Informații lunare',titleVideoSupport:'Video și Suport',helpVideoSupport:'Ai nevoie de ajutor?',searchPlaceholder:'Caută',noResultsMessage:'Nu s-a găsit nici un video cu acest nume sau titlu.',tableName:'Nume',tableDate:'Dată',tableDownload:'Descarcă',buttonDownload:'Descarcă',allArticles:'Toate articolele',articleFound:'articole găsite',searchArticle:'Caută un articol',readArticle:'Citește articolul'},groupOption:{areYouSure:'Ești sigur?',importTitle:'Adaugă acest grup la toate produsele din categoria',importAdd:'Adaugă'},rkeeperV2:{title:'RKeeper V2',url:'URL Endpoint',slug:'Restaurant Slug',apiUser:'API User (X-Api-User)',apiSecret:'API Secret (X-Api-Secret)',secret:'Webhook Secret',testLogin:'Testează login',save:'Salvează',saved:'Salvat',error:'A apărut o eroare',active:'Activ',loginOk:'Login reușit',loginFail:'Login eșuat',syncMenu:'Sincronizează meniu',syncQueued:'Sincronizarea meniului a pornit…',running:'Sincronizare în curs…'},rkeeper:{rkeeper:'RKeeper',import:'Import',products:'Importă Toate Produsele',categories:'Import Categorii',sync:'Sincronizare RKeeper',onlyProducts:'Sincronizează Doar Produse Noi',onlyOptions:'Sincronizează Doar Opțiuni Noi',productPrices:'Sincronizează Prețuri Produse',optionPrices:'Sincronizează Prețuri Opțiuni',importSuccess:'Importul a fost făcut cu succes. Nu uitați să sincronizați prețurile',importError:'Importul nu a putut fi efectuat',syncSuccess:'Sincronizarea a fost făcută cu succes',syncError:'Sincronizarea nu a putut fi efectuată',importInProgress:'Importul a început. Acest proces poate dura câteva minute',syncInProgress:'Sincronizarea a început. Acest proces poate dura câteva minute'},glovo:{noTrackingNumber:'Numărul comenzii nu a fost găsit, curierul nu a fost anulat.',areYouSure:'Sigur vrei să chemi curier Glovo?',errorPickupTime:'Ora aleasă este înafară orarului de serviciu',outOfWorkingAreaDeliveryAddress:'Adresa de livrare este înafară arieri de serviciu',canNotCancel:'Comanda a fost deja preluată, livrarea nu poate fi anulată',CAN_NOT_CANCEL:'Comanda a fost deja preluată, livrarea nu poate fi anulată',addressesNotInSameCityCode:'Adresele nu sunt în același oraș',outOfWorkingHours:'Nici un curier nu este disponibil',outOfWorkingAreaPickupAddress:'Adresa de ridicare este înafara ariei de livrare',error:'A apărut o eroare',syncLabel:'Sincronizare meniu Glovo',noTopCat:'Dezactivați categoriile de top nefolosite și încercați din nou',noCat:'Categoriile active nu conțin produse active'},tazz:{noTrackingNumber:'Numărul comenzii nu a fost găsit, curierul nu a fost anulat.',areYouSure:'Sigur vrei să chemi curier Tazz?',areYouSureCancel:'Sigur vrei să anulezi curierul Tazz?',errorPickupTime:'Ora aleasă este înafară orarului de serviciu',outOfWorkingAreaDeliveryAddress:'Adresa de livrare este înafară arieri de serviciu',canNotCancel:'Comanda a fost deja preluată, livrarea nu poate fi anulată',CAN_NOT_CANCEL:'Comanda a fost deja preluată, livrarea nu poate fi anulată',addressesNotInSameCityCode:'Adresele nu sunt în același oraș',outOfWorkingHours:'Nici un curier nu este disponibil',outOfWorkingAreaPickupAddress:'Adresa de ridicare este înafara ariei de livrare',error:'A apărut o eroare',syncLabel:'Sincronizare meniu Tazz',tazzStatus1:'Curierul nu a fost chemat',tazzStatus2:'Curierul a fost chemat',tazzStatus3:'Curierul nu a fost chemat',tazzStatus4:'Curierul a fost anulat',tazzStatus5:'A aparut o eroare',orderPrepared:'C. Preparată'},importProductsError:{noTopCat:'Dezactivați categoriile de top nefolosite și încercați din nou',noCat:'Categoriile active nu conțin produse active'},bolt:{acceptOrders:'Acceptă comenzi din marketplace',menu:'Meniu',sync:'Sincronizarea a inceput, poate dura cateva minute',syncError:'Sincronizarea nu poate fi realizata'},wolt:{integrateLocation:'Alege locația pentru integrare',getWolt:'Înrolare Wolt',updateCredentials:'Actualizează Credențiale',redirectToWolt:'Redirecționare Wolt'},posnet:{enableReport:'Activează raportul',reportDate:'Data raportului',confirmActivateReport:'Doriți să activați raportul pentru data {date}?',confirmActivateReportAutomated:'Sunteți sigur că doriți să activați raportul în mod automat pentru data de ieri ({date})?'},epRestaurant:{importLabel:'Ep Restaurant - Acțiuni Meniu',importButton:'Importă',syncButton:'Sincronizează',resendQuestion:'Sunteți sigur că doriți să retrimiteți această comandă?'},nexus:{ordersPeriod:'Perioada Comenzi',elgibleOrders:'Pentru a fi considerate eligibile pentru integrare comenzile trebuie sa fie fiscalizate, in statusul "LIVRAT".',ordersAlreadyIntegrated:'Nu se iau in considerare comenzile deja integrate cu succes.',pickupDatetime:'Dată Ridicare',paymentType:'Tip Plată',orderStatus:'Status Comandă',isSent:'Status',retryCount:'Reîncercări',retryAt:'Reîncercare la',receiptNumber:'Nr. Bon',nexusOrderId:'ID Document Nexus',sentStatus0:'În așteptare',sentStatus1:'Trimis',sentStatus2:'Eșuat',sentStatus3:'Anulat',sentStatus4:'Reîncercare programată',sentStatus5:'Anulare în curs',vatRate:'Cotă TVA',markResend:'Retrimitere',markCancellation:'Anulare',markResendConfirm:'Selecția filtrată va fi marcată pentru retrimitere către Nexus. Doriți să continuați?',markCancellationConfirm:'Selecția filtrată va fi marcată pentru anulare în Nexus. Doriți să continuați?',markSuccessMessage:'Comenzile au fost marcate și vor fi trimise în câteva minute. Jurnalele pot fi găsite în coloana Acțiuni.',invoiceStatus:'Status Nexus',invoiceLog:'Log Nexus',invoiceSend:'Trimite în Nexus',invoiceSendConfirm:'Marcați această factură pentru trimitere în Nexus?',invoiceStornoConfirm:'Marcați această factură pentru stornare în Nexus?',invoiceMarkSuccess:'Factura a fost marcată pentru Nexus și va fi procesată în scurt timp.',invoiceNoOrder:'Această factură nu are un ID de comandă asociat.',invoiceStatusUnknown:'Statusul Nexus nu este disponibil pentru această factură.',invoiceStatus1:'În așteptare',invoiceStatus1Text:'Factura urmează să fie trimisă în Nexus.',invoiceStatus2:'În trimitere',invoiceStatus2Text:'Factura este în curs de trimitere către Nexus.',invoiceStatus3:'Trimisă cu succes',invoiceStatus3Text:'Factura a fost trimisă cu succes în Nexus.',invoiceStatus4:'Eroare la trimitere',invoiceStatus4Text:'A apărut o eroare la trimiterea facturii în Nexus.',invoiceStatus5:'Marcată pentru stornare',invoiceStatus5Text:'Factura a fost marcată pentru stornare în Nexus.',invoiceStatus6:'Stornată cu succes',invoiceStatus6Text:'Factura a fost stornată cu succes în Nexus.',invoiceStatus7:'Eroare la stornare',invoiceStatus7Text:'A apărut o eroare la stornarea facturii în Nexus.'},rsystem:{fetchOrganizations:'Preia organizațiile',choose:'Alege o opțiune',tipsId:'Tip bacșiș',completeSetup:'Completează organizația, grupul terminal și mapările de plată R Systems înainte de salvare.',proc:'Proc (procentual)',fix:'Fix (sumă fixă)',adjustable:'Ajustabil',recommended:'Recomandat',payment_CASH:'Numerar',payment_CARD:'Card online',payment_POS:'POS',payment_CARD_POS:'Card la POS',payment_ONLINE:'Online',reviewMappings:'Verifică mapările sugerate. Alege explicit când există mai multe metode posibile.',destination:'Destinație',refreshMenu:'Organizația s-a schimbat. Reconciliază meniul vechi și importă explicit meniul organizației selectate înainte de a prelua comenzi.',requestFailed:'Setările R Systems nu au putut fi preluate. Reîncearcă.',saved:'Setările integrării au fost salvate.',importConfirm:'Importați meniul organizației salvate? Reconciliați mai întâi meniul vechi; comenzile existente păstrează ID-urile produselor salvate.',importQueued:'Meniul a fost preluat și pus în coada de procesare.',apiKey:'Cheie API',organisationId:'Organizație',terminalGroupId:'Grup terminal',paymentTypes:'Metode de Plată',discountId:'Discount',settings:'Setări',deleteMenu:'Ștergeți meniul vechi înainte de import',seoText:'Asigurați-vă că meniul conține text SEO TapTasty înainte de a-l importa',import:'Import'},checkbox:'Permite selectarea mai multor opțiuni pe produs',radio:'Permite selectarea unei singure opțiuni pe produs',ebriza:{title:'Ebriza',woltDriveErrorsUrl:'Endpoint notificare erori Wolt Drive'}},__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_ro___default.a),el:__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({btPayments:__WEBPACK_IMPORTED_MODULE_1__btPayments__["a" /* default */].en,marketplace:__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Integrations_marketplaceLabels__["a" /* default */].el,general:{search:'Αναζήτηση',home:'Αρχική',add:'Προσθέτω',edit:'Επεξεργασία',delete:'Διαγραφή',remove:'Αφαίρεσε',save:'Αποθηκευση',update:'Ενημέρωση',cancel:'Ακηρωση',continue:' Συνέχισε',activate:'Ενεργοποίησε',deactivate:'Απενεργοποίησε',active:'Ενεργός',inactive:'Ανενεργό',specialPrice:'Ειδική τιμή',yes:'Ναι',no:'Οχι',success:'Επιτυχία',required:'Απαιτείται',back:'πίσω',next:'Επόμενο',finish:'Τέλος',duplicate:'Αντίγραφο',select:'Επιλέγω',all:'Ολα',reset:'Επαναφορά',export:'Εξαγωγή',loadMore:'Φόρτωσε περισσότερα',viewDetails:'Δείτε λεπτομέρειες',showing:'Εμφάνιση {length} αποτέλεσμα (s)',logout:'Αποσύνδεση',from:'από',to:'προς το',agree:'Συμφωνώ',agreePopupMessage:'Για να επιτρέψετε στο πρόγραμμα περιήγησης να αναπαράγει ήχο, πρέπει να κάνετε κλικ στο "Συμφωνώ". Αυτό θα αναπαράγει έναν δοκιμαστικό ήχο προκειμένου να ενεργοποιηθεί η αναπαραγωγή ήχου. ',day:'ημέρα',notCompleted:'μη ολοκληρωμένο',saveChanges:'αποθήκευσε τις αλλαγές',doYouWantToLogout:'Θέλετε να αποσυνδεθείτε?',deliveryMethod:'ΜΕΘΟΔΟΙ ΠΑΡΑΔΟΣΗΣ',none:'Κανένας',unset:'Μη ορισμένο',couldNotSave:'Δεν ήταν δυνατή η αποθήκευση του συνδέσμου μενού',couldNotUpdate:'Δεν ήταν δυνατή η ενημέρωση του συνδέσμου μενού'},pages:{login:'Σύνδεση',register:'Εγγραφη',recoverPassword:'Ανάκτηση κωδικού πρόσβασης',resetPassword:'Επαναφορά κωδικού πρόσβασης',dashboard:'Ταμπλό',orderingManagement:'Διαχείριση Παραγγελιών',customerDetails:'Πληροφορίες Πελάτη',customers:'Πελάτες',customersGroups:'Ομάδες',orders:'Παραγγελίες',reservations:'Reservations',products:'Προϊόντα',catalog:'Κατάλογος',categories:'Κατηγορίες',productOptions:'Επιλογές προϊόντος',marketing:'Μάρκετινγκ',campaigns:'Καμπάνιες',raffleCampaigns:'Καμπάνιες κλήρωσης',donationCampaigns:'Καμπάνιες Δωρεών',spinningWheelCampaigns:'Spinning Wheel',offersSlider:'Προσφορά Slider',reports:'Αναφορές',feedback:'Ανατροφοδότηση',settings:'Ρυθμίσεις',logout:'Αποσύνδεση',fidelities:'Πόντοι',infoPages:'Σελίδες πληροφοριών',productFilters:'Φίλτρα προϊόντων',promos:'προσφορές',menus:'Μενού',clientOrderView:'Οθόνη PickUp'},ordersStatus:{bill:'Bill',AWAITING_TRANSPORT:'Περιμένοντας τη μεταφορά',CANCELED:'Ακυρώθηκε',DELIVERED:'Παραδόθηκε',DRAFT:'Προσχέδιο',NEW:'Νέος',ON_HOLD:'Σε κράτηση',POSTPONED:'Αναβλήθηκε',NOT_DELIVERED:'Δεν έχει παραδωθεί',PICKED_UP_BY_DELIVERY:'Έγινε παραλαβή για παράδοση',PROCESSING:'Επεξεργασία',PREPARED:'Ετοιμος',TRANSPORT:'Σε μεταφορά',RESERVED:'Κατοχυρωμένα',COMPLETED:'Οριστικοποίηση',FINISH:'Τέλος',reservedReady:'Δεσμευμένο / έτοιμο',completedReady:'Ολοκληρώθηκε / Έτοιμο',deliveredReady:'Παραδόθηκε / προετοιμάστηκε'},ordersTypes:{GROUP:'Ομάδα',SINGLE:'Ατομικό'},paymentTypes:{CASH:'Μετρητά',CARD:'Κάρτα'},paymentStatus:{notPaid:'Δεν πληρώθηκε',notPaidDetails:' Το ποσό θα χρεωθεί μόλις η παραγγελία επισημανθεί ως παραδόθηκε',paid:'Πληρώθηκε',notOk:'Απορρίφθηκε'},campaignsModes:{AUTO:'Αυτόματο',MANUAL:'Εγχειρίδιο'},campaignsNotificationTypes:{EMAIL:'Ηλεκτρονική διέυθυνση',PUSH:'Ειδοποίηση'},days:{monday:'Δευτερα',tuesday:'Τριτη',wednesday:'Τεταρτη',thursday:'Πεμπτη',friday:'Παρασκευη',saturday:'Σαββατο',sunday:'Κυριακη'},daysShort:{Mon:'Δευτερα',Tue:'Τριτη',Wed:'Τεταρτη',Thu:'Πεμπτη',Fri:'Παρασκευη',Sat:'Σαββατο',Sun:'Κυριακη'},gender:{selectGender:'Επιλογή φύλου',male:'Αρσενικό',female:'Θηλυκό',Male:'Αρσενικό',Female:'Θηλυκό',Other:' Άλλο'},reportsAgesGroups:{selectAge:'Επιλέξτε Ηλικία','Under 20':'Κάτω από 20','20':'Κάτω από 20','20-30':'20 - 30','30-40':'30 - 40','40-50':'40 - 50','50':'50+',Unspecified:' Απροσδιόριστος'},deliveryTypes:{DELIVERY:'Διανομή',EAT_LOCATION:'Φάτε στην τοποθεσία',MEET_HALF:'Συναντηση στη μεση της διαδρομης',PICK_UP:'Παραλαβη'},couponsTypes:{FIXED:'Σταθερό',PERCENTAGE:'Ποσοστό',FREE_PRODUCT:'Δωρεάν προϊόν'},taxTypes:{FIXED_INCLUDED:'Σταθερό (περιλαμβάνεται)',PERCENTAGE_INCLUDED:'Ποσοστό (συμπεριλαμβάνεται)',FIXED_EXCLUDED:'Σταθερό (εξαιρούμενο)',PERCENTAGE_EXCLUDED:'Ποσοστό (εξαιρούμενο)'},productOptions:{checkbox:'Επιτρέπει την επιλογή πολλαπλών επιλογών στο προϊόν',radio:' Επιτρέπει την επιλογή μόνο μίας επιλογής στο προϊόν'},validations:{areYouSureYouWantTo:' Είστε σίγουροι ότι θέλετε να',areYouSure:'Είστε βέβαιοι ότι θέλετε να ενημερώσετε την κατάσταση σε',wentWrong:' Κάτι πήγε στραβά, δοκιμάστε ξανά αργότερα …',pictureSize:'jpg/png αρχεία με μέγεθος μικρότερο από 5MB',pictureSizeExceed:'Το μέγεθος εικόνας δεν μπορεί να υπερβαίνει τα 5MB!',pdfSize:'pdf αρχεία με μέγεθος μικρότερο από 25MB',pdfSizeExceed:'Το μέγεθος pdf δεν μπορεί να ξεπεράσει τα 25MB!',archiveSizeExceed:'Το μέγεθος του αρχείου δεν μπορεί να ξεπεράσει τα 500MB!',wrongFormat:'Λάθος μορφή',removePhoto:'Παρακαλώ αφαιρέστε το τρέχον αρχείο για να μπορέσετε να προσθέσετε ένανέο.',dataCouldNotBeSaved:'Δεν ήταν δυνατή η αποθήκευση δεδομένων, δοκιμάστε ξανά αργότερα.',passReq:'Απαιτείται το αναγνωριστικό πεδίου κωδικού πρόσβασης',passMin:'Ο κωδικός πρόσβασης πρέπει να είναι τουλάχιστον 6 χαρακτήρες.',passConf:'Η επιβεβαίωση του κωδικού πρόσβασης και του κωδικού πρόσβασης δεν ταιριάζει',validPoinsNo:'Προσθέστε ένα έγκυρο χρηματικό ποσό και ένα σχόλιο.',hourIsSmallerThanCreated:'Ο επιλεγμένος χρόνος είναι μικρότερος από τον χρόνο υποβολής της παραγγελίας',vatPrinterIdRange:'0–10 only.',vatPrinterIdNumeric:'Numbers only.'},upload:{uploadLabel:'Μεταφόρτωση μενού',browse:'Ξεφυλλίζω',download:'Λήψη κωδικού QR'},dashboard:{selectLocation:'Τοποθεσία:',tile1Title:'Νέες παραγγελίες',tile2Title:'Συνολικές παραγγελίες',tile3Title:'Εσοδα',tile4Title:'Πρόσφατα εγγεγραμμένοι χρήστες',today:'Σήμερα',orderChart:'Παραγγελιες',completed:'Αριθμός παραγγελιών',canceled:'Ακυρώθηκε',salesChart:'Πωλήσεις',salesIn:'Πωλήσεις σε',top5Chart:'Κορυφαία 5 προϊόντα',orderingChart:'Τύποι παραγγελιών',nrOfOrders:'Αριθμός παραγγελιών',nrOfEmails:'Αριθμός email'},customers:{noCustomer:'Δεν έχει επιλεχθεί πελάτης',single:'πελάτης',plural:'πελάτες',title:'ΠΛΗΡΟΦΟΡΙΕΣ ΠΕΛΑΤΗ',pointsTitle:'Πόντοι Επιβράβευσης Πελατών',currentPoints:'Τρέχοντες πόντοι',pointsAddTitle:'Πρόσθεσε πόντους',pay:'Pay Type',id:'Ταυτότητα',name:'Ονομα',email:'ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ',phone:'Τηλέφωνο',use_calling_phone:'Preia numar telefon',gender:'Γένος',birth:'Ημέρα Γέννησης',location:'Τοποθεσία',address:'Διεύθυνση',number:'Αριθμός',dateCreated:'Ημερομηνία Δημιουργίας',delivery:'Διανομή',type:'Τύπος',status:'Κατάσταση',total:'Σύνολο',allTimeSale:'Πώληση όλων των εποχών ',none:'Κανένα',pointsLabel:'Χρήματα που δαπανήθηκαν',pointsLabelInPoints:'Points earned',points:'points',point:'point',clientCanUse:'Customer can use',commentsLabel:'Σχόλιο',pointsSuccess:' Οι πόντοι επιβράβευσης προστέθηκαν με επιτυχια.',pointsError:'Δεν μπορούσαμε να προσθέσουμε τους πόντους στον πελάτη.',addCommentPerClient:'Προσθήκη σχολίου ανά πελάτη',newCommentAdded:'Το σχόλιο έχει ενημερωθεί',filters:{withOrders:'Cu Comenzi',withoutOrders:'Χωρίς Παραγγελίες'},addGroup:'Προσθήκη ομάδας',deleteGroup:'Η ομάδα διαγράφηκε με επιτυχία.',saveGroup:'Η ομάδα προστέθηκε με επιτυχία',updateGroup:'Η ομάδα ενημερώθηκε με επιτυχία'},orders:{counterPerCustomer:'Αριθμός παραγγελιών',noOrders:'Δεν έχει επιλεγεί καμία παραγγελία',single:'παραγγελία',the_order:'H παραγγελία',plural:'Οι παραγγελιες',status:'Κατάσταση',location:'Τοποθεσία',updateStatus:'Ενημέρωση κατάστασης',editOrder:'Edit Order',ordDetails:'Λεπτομέρειες Παραγγελίας',date:'Ημερομηνία',madeAt:'Παραγγελία που έγινε στο',pickupTime:'Διανομή / Παραλαβή από το κατάστημα στο',preorder:'ΠΡΟΠΑΡΑΓΓΕΛΙΑ',preorderFilter:'Προπαραγγελίες',allOrders:'Όλες οι παραγγελίες',pendingPreorders:'Εκκρεμείς προπαραγγελίες',withoutPendingPreorders:'Χωρίς εκκρεμείς προπαραγγελίες',reservationTime:' Ώρα Κράτησης',reservationSeats:'Θέσεις κράτησης',rating:'Εκτίμηση',meetupLocation:'Τοποθεσία συναντήσεως',ordLocation:'Παραγγελία Τοποθεσία',delivery:'Διανομή',type:'Τύπος',payment:'Πληρωμή',name:'Ονομα',qty:'Qty',unit:'Τιμή μονάδας',unit_price:'Τιμή μονάδας',final_price:'Τελική τιμή',total:'Σύνολο',totals_subtotals:'Συνολο',totals_discount:'Εκπτωση',totals_discount_loyalty_points:'Εκπτωση απο τους ποντους',totals_grandtotal:'Σύνολο',totals_shipping:'Αποστολή',totals_extras:' Σακούλα',totals_tip:'Συμβουλές',totals_donation:'Δωρεά',custComments:'Σχόλιο πελάτη',adminComments:'Σχόλιο διαχειριστή',custDetails:'Πληροφορίες Πελάτη',shipping:'Διεύθυνση αποστολής',billing:'Διεύθυνση χρέωσης',orderStatusSuccess:'Η κατάσταση παραγγελίας ενημερώθηκε με επιτυχία',orderCommnetSuccess:'Σχόλιο Παραγγελία ενημερώθηκε με επιτυχία',orderHourSuccess:'Η επιλογη του χρονο  διανομή / παραλαβή από το κατάστημα  ενημερώθηκε με επιτυχία',orderHourError:'Καταχωρίστε μια έγκυρη ώρα.',none:'Κανένα σχόλιο',at:' στο',filtersApplied:'Εφαρμοσμένα φίλτρα - κάντε κλικ στο κουμπί φίλτρου για να δείτε περισσότερα',customFilters:'Εφαρμόστηκαν προσαρμοσμένα φίλτρα',resetFilters:'Κάντε κλικ εδώ για επαναφορά και προβολή ζωντανών δεδομένων',note:' Σημείωση',orderNoArticulate:'Σειρά',print:' Τυπώνω (A4)',printerPrint:' Τυπώνω (80mm)',printerSuccess:'Η παραγγελία εκτυπώθηκε με επιτυχία.',printerErrror:'Παρουσιάστηκε σφάλμα στη σύνδεση με τον εκτυπωτή.',addTime:'Προσθέστε χρόνο',amountRefunded:'Επιστροφή χρημάτων',amountIntegralRefunded:'Το ποσό επιστράφηκε αναπόσπαστο στον πελάτη',refundSuccess:'Το ποσό επιστράφηκε με επιτυχία',refundManual:'Τα χρήματα θα επιστραφούν από τη μη αυτόματη πληρωμή',refundAutomat:'Θέλετε αυτόματη επιστροφή χρημάτων ?',refundOrder:'Επιστροφή χρημάτων',refundAlreadyDone:'Έχει ήδη επιστραφεί',refundConfirmTitle:'Επιστροφή χρημάτων παραγγελίας;',refundConfirmText:'Το ποσό θα επιστραφεί στον πελάτη μέσω EuPlatesc. Η ενέργεια δεν μπορεί να αναιρεθεί.',refundAskCancel:'Η επιστροφή ολοκληρώθηκε. Θέλετε να ακυρώσετε και την παραγγελία;',refundError:'Παρουσιάστηκε σφάλμα κατά την επεξεργασία της επιστροφής.',orderCloseToDelivery:'Παραγγελία με ώρα παράδοσης πιο κοντά',erorrPaylike:'Σφάλμα Paylike, δημιουργήθηκε ένα αρχείο καταγραφής στο διακομιστή με το σφάλμα να επιστραφεί'},companyOptions:{id:'Id',name:'Name',image:'Image',prod_image:'Product Image (just custom app)',info:'Info',type:'Type',deleteQues:'This action will also remove the option from the products it is placed on. Are you sure you want to continue?',deleteVal:'This action will also delete the value from the products it is placed on. If you don\'t want this, don\'t save!',active:'Active',quantitySettings:'Quantity Settings',allowQuantity:'Allow quantity',minQuantity:'Minimum quantity',maxQuantity:'Maximum quantity',quantityMinMaxError:'Minimum quantity cannot be greater than maximum quantity'},catalogProd:{noProducts:'Δεν έχει επιλεγεί κανένα προϊόν',single:'προϊόν',plural:'προϊόντα',generalDetails:'Γενικές λεπτομέρειες',name:'Ονομα',desc:'Περιγραφή',image:'Εικόνα',category:'Κατηγορία',price:'Τιμή',oldPrice:'Παλιά τιμή',newPrice:'Νέα τιμή',useDiscountPrice:'Χρησιμοποιήστε μειωμένη τιμή',taxes:'Εφαρμοσμένοι φόροι',status:'Κατάσταση',posid:'Αναγνωριστικό POS',allowUserComments:'Επιτρέψτε σχόλια χρηστών',availableInStore:'Διατίθεται μόνο στο κατάστημα',validFromTo:'Ισχύει από - έως',prodType:'Τύπος Προϊόντος',singleType:'ατομικο',groupType:'ομάδα',rewardPoints:'Πόντοι επιβράβευσης',moneySpent:'Χρήματα σε πόντους',numberOfYouNeedToSpend:'Ο αριθμός {currency} που ο πελάτης πρέπει να δαπανήσει για να πάρει ένα σημείο.',points:'ποντους',soldWith:'Πωλείται με',pickAnOption:'Επιλέξτε μια επιλογή',minNoSelected:'Ελάχιστος αριθμός. επιλεγμένο',maxNoSelected:'Μέγ αριθμός. επιλεγμένο',optVal:'Αξία',leaveEmpty:'Αφήστε κενό ή βάλτε το 0 αν η επιλογή δεν κοστίζει επιπλέον',prodDeleted:'Το προϊόν διαγράφηκε με επιτυχία',prodAdded:'Το προϊόν προστέθηκε με επιτυχία',prodUpdated:'Το προϊόν ενημερώθηκε με επιτυχία',prodPhotoError:'Δεν ήταν δυνατή η αποθήκευση της φωτογραφίας του προϊόντος, δοκιμάστε ξανά αργότερα.',rewardPossibelValue:'Πιθανές τιμές',errorOptions:'Ελέγξτε όλες τις επιλογές προϊόντον, μερικές ενδέχεται να μην συμπληρώνονται.',locationSettings:'Ρυθμίσεις τοποθεσιών',availableIn:'Διαθέσιμο σε',deliveryMethodsandHours:'Μέθοδοι παράδοσης και ώρες',overrideSettings:'Παράκαμψη ρυθμίσεων',addLocationValidation:'Ορισμένες επιλογές προϊόντος δεν είναι συμβατές με τις επιλεγμένες τοποθεσίες, εάν συνεχίσετε, οι επιλογές θα καταργηθούν, εάν όχι, η τοποθεσία δεν θα προστεθεί.',productAvailableIn:'Το προϊόν είναι διαθέσιμο σε',particularLocationSettings:'Ειδικές ρυθμίσεις για κάθε τοποθεσία',activateParticularSettings:'Ενεργοποίηση προσαρμοσμένων ρυθμίσεων',withoutThisOptionDefault:'*χωρίς να ενεργοποιήσετε αυτήν την επιλογή, θα χρησιμοποιηθούν οι προεπιλεγμένες ρυθμίσεις',highlightsProduct:'Το προϊόν επισημαίνει',search:'Αναζήτηση',isHiddenFromListing:'Απόκρυψη από τη λίστα προϊόντων',isHiddenFromSearch:'Απόκρυψη από την αναζήτηση προϊόντων',isHiddenFromQrMenu:'Hide from Qr menu',isHiddenFromPOS:'Ascunde din POS',isHiddenFromKiosk:'Ascunde din Kiosk si Meniu Qr',Monday:'Δευ',Tuesday:'Τρι',Wednesday:'Τετ',Thursday:'Πεμ',Friday:'Παρ',Saturday:'Σαβ',Sunday:'Κυρ',accesRestricted:'Δυστυχώς, δεν έχετε πρόσβαση σε αυτό το προϊόν',changeLocations:'Change locations',includeAllLocationsProducts:'Include also the products available in all locations',bulkLocationsMode:'Action',bulkModeAdd:'Add',bulkModeRemove:'Remove',bulkModeReplace:'Replace',massUpdate:'Mass update',massUpdateSubtitle:'You are about to update {count} products',bulkActionActive:'Active / Inactive',bulkActionPrice:'Price',bulkActionVat:'VAT',bulkActionSection:'Section',bulkActionOptionGroups:'Option groups',bulkActionDelete:'Delete',bulkOverrideDeliveryHint:'When activating, add only the delivery methods you need (+). Existing override schedules on the selected products are replaced. Inactive intervals are not saved. Disabling clears existing override schedules.',bulkOverrideLocationsHint:'Leave empty to use all company locations. Only locations that already belong to each product are applied.',bulkOverrideAddIntervalHint:'Click + to add a schedule interval for this method.',bulkPriceDirection:'Direction',bulkPriceIncrease:'Increase',bulkPriceDecrease:'Decrease',bulkPriceMode:'Type',bulkPriceFlat:'Flat amount',bulkPricePercent:'Percentage (%)',bulkPriceAmount:'Amount',bulkPriceBaseOnlyHint:'Only the base price is changed. The new price will never go below 0.',bulkOptionGroupsMode:'Association mode',bulkOptionGroupsModeHint:'Add keeps existing groups. Replace overwrites them with the selected ones.',bulkDeleteWarning:'This will permanently delete {count} products. This action cannot be undone easily.',bulkDeleteEnableLabel:'Yes, delete the selected products (other mass actions will be ignored)',confirmBulkMultiple:'Apply these changes to {count} {products}:',bulkProductSingular:'product',bulkProductPlural:'products',confirmBulkAreYouSure:'Are you sure?',bulkSummaryAddLocations:'add locations ({value}) to {count} {products}',bulkSummaryRemoveLocations:'remove locations ({value}) from {count} {products}',bulkSummarySetActive:'set {count} {products} as active',bulkSummarySetInactive:'set {count} {products} as inactive',bulkSummaryIncreasePriceFlat:'increase the base price of {count} {products} by {amount} {currency}',bulkSummaryIncreasePricePercent:'increase the base price of {count} {products} by {amount}%',bulkSummaryDecreasePriceFlat:'decrease the base price of {count} {products} by {amount} {currency}',bulkSummaryDecreasePricePercent:'decrease the base price of {count} {products} by {amount}%',bulkSummaryAddOptionGroups:'add option groups ({value}) to {count} {products}',bulkSummaryReplaceOptionGroups:'replace option groups on {count} {products} with ({value})',bulkSummarySetVat:'set VAT {value} on {count} {products}',bulkSummarySetSection:'set section {value} on {count} {products}',bulkSummaryEnableOverride:'enable override settings on {count} {products}',bulkSummaryEnableOverrideWithSchedule:'replace override schedules on {count} {products}',bulkSummaryDisableOverride:'disable override settings on {count} {products}',bulkSummaryDelete:'delete {count} {products}',bulkSummaryGeneric:'update {count} {products}',confirmBulkAddLocations:'Are you sure you want to add locations to {count} products?',confirmBulkRemoveLocations:'Are you sure you want to remove locations from {count} products?',confirmBulkSetActive:'Are you sure you want to set {count} products as active?',confirmBulkSetInactive:'Are you sure you want to set {count} products as inactive?',confirmBulkIncreasePriceFlat:'Are you sure you want to increase the base price of {count} products by {amount}?',confirmBulkIncreasePricePercent:'Are you sure you want to increase the base price of {count} products by {amount}%?',confirmBulkDecreasePriceFlat:'Are you sure you want to decrease the base price of {count} products by {amount}?',confirmBulkDecreasePricePercent:'Are you sure you want to decrease the base price of {count} products by {amount}%?',confirmBulkAddOptionGroups:'Are you sure you want to add option groups to {count} products?',confirmBulkReplaceOptionGroups:'Are you sure you want to replace option groups on {count} products?',confirmBulkSetVat:'Are you sure you want to set VAT on {count} products?',confirmBulkSetSection:'Are you sure you want to set the section on {count} products?',confirmBulkDelete:'Are you sure you want to delete {count} products?',confirmBulkGeneric:'Are you sure you want to update {count} products?',bulkLocationsUpdated:'Updated locations for {updated} products',bulkMassUpdated:'Updated {updated} products',couldNotFetchProductOptions:'Could not fetch product options. Please contact support.'},catalogProdRewardsHints:{hint1:'Αφήστε κενό για να εφαρμόσετε την προεπιλεγμένη τιμή από τις ρυθμίσεις',hint2:'Βάλτε 0 για να μην εφαρμόσετε πρόγραμμα ανταμοιβής σε αυτό το προϊόν',hint3:'Προσθέστε μια θετική τιμή για να παρακάμψετε την προεπιλεγμένη τιμή από τις ρυθμίσεις'},catalogCateg:{single:'κατηγορία',plural:'κατηγορίες',color:'Culoare',name:'Ονομα',image:'Εικονα',displayType:'Τύπος οθόνης',shortDescription:'Σύντομη περιγραφή',validFromTo:'Ισχύει από - έως',areYouSure:'Είστε βέβαιοι ότι θέλετε να {label} αυτήν την κατηγορία;',categAdded:'Η κατηγορία προστέθηκε με επιτυχία',categUpdated:'Η κατηγορία ενημερώθηκε με επιτυχία',categDeleted:'Η κατηγορία διαγράφηκε επιτυχώς',couldNotSave:'Δεν ήταν δυνατή η αποθήκευση της φωτογραφίας κατηγορίας, δοκιμάστε ξανά αργότερα.',List:'Λίστα',Grid:'Πλέγμα',pleaseSelect:'Επιλέξτε / Δεν ισχύει',categoriesWithoutParent:'Κατηγορίες χωρίς γονέα',topCategory:'Κορυφαία κατηγορία',forceMethod:'Μέθοδοι παράδοσης δυνάμεων',selectMethod:'Επιλέξτε μεθόδους',enableMethod:'(Για να ενεργοποιήσετε την κατάργηση της κορυφαίας κατηγορίας)',overrideSettingsHelp:'Όταν είναι ενεργοποιημένο, η κατηγορία εμφανίζεται στο μενού μόνο για την επιλεγμένη τοποθεσία, μέθοδο παράδοσης, ημέρα και χρονικό παράθυρο.',userLabelings:'Ετικέτες χρηστών',userLabelingsHelp:'Αυτή η κατηγορία θα είναι ορατή μόνο για χρήστες με μία από αυτές τις ετικέτες',schedule:'Πρόγραμμα',useSchedule:'Χρήση προγράμματος',scheduleHelp:'Ένα πρόγραμμα για αυτή την κορυφαία κατηγορία σε όλες τις τοποθεσίες. Εκτός αυτών των ωρών, η παραγγελία από αυτή την κατηγορία δεν είναι διαθέσιμη στην εφαρμογή.'},catalogProdOpt:{single:'Επιλογή',plural:'επιλογές',new:'Νέα επιλογή',name:'Ονομα',type:'Τύπος',value:'Αξία',values:'Αξίες',optionSaved:'Οι επιλογές προϊόντος αποθηκεύτηκαν με επιτυχία.',areyouSure:'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την επιλογή;',optLocationError:'{opt_name} η επιλογή πρέπει να περιλαμβάνει {loc_name} διαθέσιμες τοποθεσίες',menuQr:'Μενού QR',displayInMenu:'Εμφάνιση στο μενού QR'},marketingCampaigns:{single:'καμπάνια',plural:'καμπάνιες',name:'Ονομα',nameHelper:'Αυτό το όνομα θα χρησιμοποιηθεί ως θέμα για τις ειδοποιήσεις μέσω ηλεκτρονικού ταχυδρομείου που αποστέλλονται για αυτήν την καμπάνια.',image:'Εικόνα',startEnd:'Ημερομηνία Έναρξης - Τέλους',daysLeft:'Μέρες που απομένουν',timesUsed:'Φορές που χρησιμοποιήθηκαν',status:'Κατάσταση',actions:'Ενέργειες',send:'Στείλετε',in_queue:'To be sent',sent:'Total sent',notif_sent:'Notification',email_sent:'E-mail',areYouSureNotif:'Είστε βέβαιοι ότι θέλετε να στείλετε τις ειδοποιήσεις;',notifSent:'Έγινε αποστολή ειδοποιήσεων',campaignDeleted:'Η καμπάνια διαγράφεται με επιτυχία.',areYouSureDelete:'Είστε σίγουροι ότι θέλετε να διαγράψετε',campaignAdded:'Η καμπάνια προστέθηκε με επιτυχία',campaignUpdated:'Η καμπάνια ενημερώθηκε με επιτυχία',campaignPhotoError:'Δεν ήταν δυνατή η αποθήκευση της φωτογραφίας της καμπάνιας, δοκιμάστε ξανά αργότερα.',campaignDetails:'Στοιχεία καμπάνιας',description:'Περιγραφή',maxDescription:'(μέγιστο 400 χαρακτήρες)',characters:'χαρακτήρες',validFromTo:'Ισχύει από - έως',notif:'Ειδοποιήσεις',model:'Μοντέλο',setHours:'Ορίστε Ώρες',selectTime:'Επιλέξτε χρόνο',chooseTarget:'Επιλέξτε το κοινό-στόχο',gender:'Γένος',age:'Ηλικία',city:'Πόλη',location:'Τοποθεσία',visibleInLocations:'Ορατό στις ακόλουθες τοποθεσίες',visibleInLocationsInfo:'Αυτή η λειτουργία είναι διαθέσιμη μόνο στην Εφαρμογή',ordersAbove:'παραγγελίες άνω',addCoupon:'Προσθήκη κουπονιού',applyTo:'Προσθήκη κουπονιού',value:'Αξία',code:'Κώδικας',counter_max_usage:'Πόσες φορές ένα άτομο μπορεί να χρησιμοποιήσει αυτό το κουπόνι ; ',counter_max_usage_total:'Πόσες φορές μπορεί να χρησιμοποιηθεί αυτό το κουπόνι συνολικά;',counter_max_usage_example:'Πληκτρολογήστε έναν αριθμό για τον μέγιστο αριθμό χρήσεων ανά άτομο. Πληκτρολογήστε 0 για απεριόριστο.',counter_max_usage_total_example:'Πληκτρολογήστε έναν αριθμό για τον μέγιστο αριθμό χρήσης. Πληκτρολογήστε 0 για απεριόριστο.',generateCode:'Δημιουργία κώδικα',Products:' Προϊόντα',Shipping:' Αποστολή',chooseCategProduct:'Επιλέξτε κατηγορίες ή προϊόντα στα οποία θα εφαρμοστεί το κουπόνι: ',delivery_methods:'Σε ποιες μεθόδους παράδοσης πρέπει να εφαρμοστεί το κουπόνι;',order_source_ids:'Order sources',order_source_ids_all:'All sources',order_source_ids_help:'Leave empty to apply on all order sources.',location_ids:'Σε ποια τοποθεσία πρέπει να εφαρμοστεί το κουπόνι;',sendNotificationTo:'Αποστολή ειδοποίηση σε',chooseDayForInterval:'Επιλέξτε μια ημέρα για διάστημα',chooseHoursForInterval:'Επιλέξτε ώρες για διάστημα',useInterval:'χρησιμοποιήστε το διάστημα',intervalMustBeSet:'Το διάστημα πρέπει να οριστεί',campaignWasSent:'Η καμπάνια εστάλη τα τελευταία 30 λεπτά',isSecondUseCheck:'Αυτό το κουπόνι ισχύει αμέσως μετά την πρώτη χρήση',groups:'Ομάδες πελατών',freeProduct:'Δωρεάν προϊόν για προσθήκη στο καλάθι',freeProductPlaceholder:'Επιλέξτε προϊόν',freeProductRequired:'Επιλέξτε ένα δωρεάν προϊόν'},marketingOffers:{single:'προσφορά πανό',plural:'Προσφορες πανό',title:'Τίτλος',status:'Κατάσταση',image:'Εικόνα',imageWeb:'Εικόνα Ιστού',imageBanner:'Imagine Banner',imageLanding:'Imagine Landing',linkType:'Τύπος συνδέσμου',startEndDate:'Ημερομηνία έναρξης - λήξης',actions:'Ενέργειες',offerAdded:'Προστέθηκε με επιτυχία το banner προσφοράς.',offerUpdated:'Το banner προσφοράς ενημερώθηκε με επιτυχία.',offerDeleted:'Το banner της προσφοράς διαγράφηκε επιτυχώς.',weCouldNot:'Δεν ήταν δυνατή η αποθήκευση της φωτογραφίας του slider, δοκιμάστε ξανά αργότερα.',validImg:'Προσθέστε μια έγκυρη εικόνα.',areYouSure:'Είστε βέβαιοι ότι θέλετε να {label} αυτό το banner προσφοράς;',pageText:'Κείμενο σελίδας',pickCateg:'Διαλέξτε κατηγορία',pickProd:'Επιλογή προϊόντος',pickLoc:'Επιλέξτε τοποθεσία',none:'Κανένα',banners:'Πανό',offers:'Προσφορές',display:'Απεικόνιση',addGroup:'Προσθήκη ομάδας',offerSuccess:'Η ομαδική προσφορά προστέθηκε με επιτυχία'},marketingOffersTypes:{category:'κατηγορία',product:'προϊόν',page:'σελίδα'},marketingFidelities:{fidelities:'Πιστότητα',loyalityPoint:'Πόντους',userLabeling:'Προσθήκη ετικετών χρήστη',name:' Όνομα',ordersValue:'Αξία παραγγελίας',ordersNumber:'Αριθμός παραγγελιών',color:'Χρώμα',notification:'Ειδοποίηση',coupon:'Κουπόνι',product:'Προϊόν',nameLabel:'Όνομα ετικέτας',addLabel:'Προσθήκη ετικέτας',noData:'Χωρίς δεδομένα',updateUserLabeling:'Ενημερωμένη ετικέτα χρήστη',createdUserLabeling:'Δημιουργήθηκε ετικέτα χρήστη',areYouSureDelete:'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την ετικέτα;',labelDeleted:'Η ετικέτα διαγράφηκε',orderNumberRequired:'Αυτό το πεδίο ή ο αριθμός εντολών απαιτείται',orderValueRequired:'Αυτό το πεδίο ή, η αξία των παραγγελιών απαιτείται',yes:'Ναι',applyCupon:'Εφάρμοσε το κουπόνι',applyproduct:'Εφαρμογή προϊόντος',badgeColor:'Χρώμα ετικέτας',badgeName:'Όνομα ετικέτας',value:' Αξία',number:'Αριθμός',appliedForLastMonth:'Οι ετικέτες θα ισχύουν μόνο για παραγγελίες εντός των τελευταίων 30 ημερών',checkTermsAndConditionFidelities:'Ελέγξτε τις προσφορές στις σελίδες πληροφοριών',labelingPrimaryOption:'Επιλέξτε την κύρια επιλογή για τις ετικέτες',labelingSuccess:'Η κύρια επιλογή ετικέτας ενημερώθηκε με επιτυχία!',updatePrimaryOption:'Ενημερώστε την επιλογή',showLabelOnUser:'πώς να προσθέσετε ετικέτες στους χρήστες',infoAboutShowUserLabelUpdated:'Ενημερωμένες πληροφορίες σχετικά με την ετικέτα χρήστη της εκπομπής',labelingInterval:'Επιλέξτε ένα διάστημα εφαρμογής','0':'Διάρκεια Ζωής','30':'30 ημέρες','60':'60 ημέρες','90':'90 ημέρες','120':'120 ημέρες',recurrence:'επανάληψη',noReccurence:'None',oneDay:'1 ημέρες',threeDays:'3 ημέρες',fiveDays:'5 ημέρες',sevenDays:'7 ημέρες',tenDays:'10 ημέρες',fifteenDays:'15 ημέρες',twentyDays:'20 ημέρες',twentyFiveDays:'25 ημέρες'},marketingPromos:{title:'Τίτλος',treshold:'Treshold n',category:'Κατηγορία',product:'Προϊόν',products:'Προϊόντα',none:'Κανένας',marketingPromos:'Προώθηση',generateQrCode:'Δημιουργία κωδικού Qr',code:'Κώδικας',promoDeleted:'Η προώθηση διαγράφηκε',areYouSureDelete:'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την προσφορά ?',promoAdded:'Προστέθηκε η προσφορά',promoUpdated:'Η προώθηση ενημερώθηκε με επιτυχία.',weCouldNot:'Δεν ήταν δυνατή η αποθήκευση των δεδομένων, δοκιμάστε ξανά αργότερα.',startEndDate:'Ημερομηνία Έναρξης - Λήξης',image:'Εικόνα',validImg:'Προσθέστε μια έγκυρη εικόνα.',print:'Τυπώνω',firstname:'Ονομα',lastname:'Επίθετο',points:'Πόντοι',email:'Ηλεκτρονική διέυθυνση',description:'Περιγραφή'},reports:{orderedProducts:'Παραγγελθέντα Προϊόντα',giftCardsSoldTotal:'Total gift cards sold',giftCardsSoldAmount:'Gift cards sold',number:'Order nr',average:'Μέση τιμή',trends:'Τάσεις',clients:'Πελάτες',products:'Προϊόντα',marketing:'Μάρκετινγκ',today:'Σήμερα',orderChart:'Παραγγελίες',clientsChart:'Πελάτες',completed:'Ολοκληρώθηκε',canceled:'Ακυρώθηκε',salesChart:'Πωλήσεις',salesIn:'Πωλήσεις σε',customersChart:'Πελάτες',appInstalls:'εγκαταστάσεις εφαρμογών',custWithAcc:'Πελάτες με λογαριασμό',top10Chart:'Top 10 προϊόντα',top5Chart:'Top 5 προϊόντα',orderingChart:'Τύποι παραγγελιών',nrOfOrders:'Αριθμός παραγγελιών',customersAge:'Περίοδος πελατών',customersGender:'Πελάτες Φύλο',name:'Ονομα',appInstalled:'Εγκατασταμενες εφαρμογές',gender:'Γένος',location:'Τοποθεσία',partnerCode:'Κωδικός συνεργάτη',email:'ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ',phone:'Τηλέφωνο',age:' Ηλικία',filter:'Φίλτρο',label:'Ετικέτα',userDetails:'Πληροφορίες Πελάτη',salesDetails:'Λεπτομέρειες πωλήσεων',salesProductNr:'Αριθμός πωλήσεων προϊόντων',totalAmount:'Συνολικό ποσό',totalProducts:'Σύνολο προϊόντων',ordersNumber:'Παραγγελίες',minAmount:'Ελάχιστο συνολικό ποσό',minOrders:'Ελάχιστες παραγγελίες',maxOrders:'Μέγιστες παραγγελίες',itemsSold:'Είδη που πωλήθηκαν',campaign:'Καμπάνια',couponsTimesUsed:'Χρήση των χρόνων κουπονιών',revenue:'Εσοδα',total:'Σύνολο',paymentType:'Τρόπος πληρωμής',date:'Ημερομηνία',salesReport:'Αναφορά πωλήσεων',salesReportBeta:'Αναφορά πωλήσεων BETA',order:'Σειρά',export:'Εξαγωγή',cash:'Μετρητά',card:'Κάρτα',pos:'POS',tips:'Φιλοδώρημα',totalSum:'Συνολικό ποσό',search:'Αναζήτηση',searchFilter:'Αναζήτηση (όνομα, ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ, τηλέφωνο)',discount:'Εκπτωση',totalDiscount:'Συνολική έκπτωση',ordersWithDiscount:'Παραγγελίες με Έκπτωση',ordersWithFidelity:'Παραγγελίες με Fidelity',totalFidelityDiscount:'Συνολική Έκπτωση Fidelity',clientsWOrders:'Πελάτες με παραγγελίες',emailSend:'Τα μηνύματα που στάλθηκαν τους τελευταίους 6 μήνες',emailTotal:'Σύνολο email που στάλθηκαν: ',newCustomersChart:'νέοι πελάτες',productsSalesReport:'Πωλήσεις προϊόντων',pricePerUnit:'Τιμή ανά μονάδα',quantity:'Ποσότητα',productname:'Ονομασία προϊόντος',couponCode:'Κουπόνι',checkOrder:'Χρήση παραγγελίας',donationReport:'Αναφορά Δωρεών'},feedback:{sigle:'Αξιολόγηση',type:'Τύπος',sentBy:'Στάλθηκε από',text:'Κείμενο',seen:'Δει',sentAt:'Αποστολή σε',search:'Αναζήτηση',comment:'Σχόλιο'},feedbackTypes:{feedback:'Αξιολόγηση',issue:'Θέμα',suggestion:'Πρόταση'},settings:{},blogPage:{categories:'Κατηγορίες',categoriesHint:'Προαιρετικό — τα άρθρα μπορούν να μην έχουν κατηγορία.',categoryName:'Όνομα κατηγορίας',noCategories:'Δεν υπάρχουν κατηγορίες ακόμα.',articles:'Άρθρα',addArticle:'Προσθήκη άρθρου',editArticle:'Επεξεργασία άρθρου',allCategories:'Όλες οι κατηγορίες',noCategory:'Χωρίς κατηγορία',allStatuses:'Όλες οι καταστάσεις',searchByTitle:'Αναζήτηση με τίτλο',noArticles:'Δεν βρέθηκαν άρθρα.',cover:'Εξώφυλλο',coverHint:'προτείνεται 1200x630px, έως 5MB',imageAlt:'Εναλλακτικό κείμενο εικόνας (SEO)',title:'Τίτλος',slug:'Σύνδεσμος άρθρου (slug)',slugHint:'Δημιουργείται από τον τίτλο αν μείνει κενό.',shortDescription:'Σύντομη περιγραφή (κάτω από τον τίτλο)',content:'Περιεχόμενο',category:'Κατηγορία',author:'Συντάκτης',publishedAt:'Ημερομηνία δημοσίευσης',publishedAtHint:'Αν είναι κενό, χρησιμοποιείται η τρέχουσα ημερομηνία κατά τη δημοσίευση.',status:'Κατάσταση',published:'Δημοσιευμένο',draft:'Πρόχειρο',scheduled:'Προγραμματισμένο',seo:'SEO',metaTitle:'Meta τίτλος',metaDescription:'Meta περιγραφή',metaKeywords:'Λέξεις-κλειδιά (χωρισμένες με κόμμα)',titleRequired:'Ο τίτλος είναι υποχρεωτικός.',deleteCategoryConfirm:'Διαγραφή της κατηγορίας "{name}"; {count} άρθρο(α) θα μείνουν χωρίς κατηγορία.',deleteArticleConfirm:'Διαγραφή του άρθρου "{name}";'},settingsPages:{homepageSections:'Ενότητες αρχικής σελίδας',interactiveTour:'Διαδραστική περιήγηση',blog:'Blog',interactiveTourFirstLogin:'Χρήση διαδραστικής περιήγησης στην πρώτη σύνδεση',interactiveTourAlways:'Χρήση διαδραστικής περιήγησης πάντα',interactiveTourDisplayMode:'Λειτουργία εμφάνισης εικόνας',interactiveTourDisplayContain:'Contain',interactiveTourDisplayCover:'Cover',interactiveTourDisplayFullPage:'Πλήρης σελίδα',userSettings:'Ρυθμίσεις χρήστη',myProfile:'Το προφίλ μου',users:'Χρήστες',general:'Γενικά',companyDetails:'ΣΤΟΙΧΕΙΑ ΕΤΑΙΡΕΙΑΣ',dateTime:'Ημερομηνία και ώρα',currency:'Νόμισμα',accounting:'Λογιστική',tax:'Φόρος',payment:'Πληρωμή',orderingMng:'Διαχείριση παραγγελιών',loyalty:'Πρόγραμμα Επιβράβευσης',push:'Ειδοποιήσεις',tips:'Συμβουλές',locationGroups:'Ομάδες τοποθεσίας',locationGroupsName:'Ονομα',locationGroupsDescription:'Περιγραφή',locationGroupsPhoto:'φωτογραφία',locationGroupsAdded:'Προστέθηκαν νέες ομάδες τοποθεσιών',locationGroupsUpdated:'Οι ομάδες τοποθεσιών ενημερώθηκαν με επιτυχία',locationGroupsPicError:'Δεν ήταν δυνατή η αποθήκευση της φωτογραφίας της ομάδας τοποθεσιών. Προσπαθήστε ξανά αργότερα.',locationGroupsDelete:'Διαγράψτε την ομάδα τοποθεσιών',locationGroupsAreYouSure:'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την ομάδα τοποθεσιών;',locationGroupsSelect:'Επιλέξτε την ομάδα τοποθεσιών στην οποία ανήκετε:',subscription:'Συνδρομή',myPlan:'Το σχέδιό μου',infoPages:'Πληροφορίες Σελίδες',taxLabeling:'Φορολογική επισήμανση',deliveryMethods:'Τοποθεσίες και μέθοδοι παράδοσης',filters:'Φίλτρα',filterProducts:'Προϊόντα φίλτρων'},settingUsers:{single:'χρήστης',fn:'Ονομα',ln:'Επίθετο',email:'ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ',username:'Όνομα χρήστη',lang:'Γλώσσα διεπαφής',langMsg:'Αυτή είναι η γλώσσα που θα δείτε στην περιοχή διαχείρισης.',avatar:'Avatar',role:'Ρόλος',locations:'Πρόσβαση σε παραγγελίες από τοποθεσίες',locations_helptext:'Σημαντικό: Εάν δεν έχει επιλεγεί τοποθεσία, αυτός ο χρήστης θα έχει πρόσβαση σε όλες τις τοποθεσίες .',resetPass:'Επαναφορά κωδικού πρόσβασης',password:'Κωδικός πρόσβασης',pass:'Κωδικός πρόσβασης',confPass:'Επιβεβαίωση Κωδικού',userAdded:'Νέος χρήστης προστέθηκε με επιτυχία',userUpdated:'Ο χρήστης ενημερώθηκε με επιτυχία',userPicError:'Δεν ήταν δυνατή η αποθήκευση του avatar χρήστη, δοκιμάστε ξανά αργότερα.',USER:'USER',DRIVER:'DRIVER',LOCATION_ADMIN:'LOCATION ADMIN',MARKETER:'MARKETER'},settingCompany:{title:'Εταιρία',location:'Τοποθεσία',name:'Ονομα',selfOrderDomain:'Self Ordering Domain',appLink:'Link Aplicatie',appLinkAndroid:'Android link aplicatie',appLinkIos:'Ios link aplicatie',lang:'Γλώσσα εφαρμογής',bussLoc:'Τοποθεσία επιχείρησης',deliveryLabels:'Ετικέτες τύπων παραδόσεων',deliveryType:'Τρόπος παράδοσης',pick_up:'Παραλαβή από το κατάστημα',meet_half:'Συνάντηση  στα μισά',delivery:'Διανομή',eat_location:'Φάτε στην τοποθεσία',self_ordering:'Self Ordering',phone:'Τηλέφωνο',street:'Οδός',number:'’Οχι .',latitude:'Γεωγραφικό πλάτος',longitude:'Γεωγραφικό μήκος',email:'Ηλεκτρονική διέυθυνση',city:'Πόλη',country:'Χώρα',state:'Περιοχή',availableDaysHrs:'ΔΙΑΘΕΣΙΜΕΣ ΗΜΕΡΕΣ ΚΑΙ ΩΡΕΣ',from:'από',to:'προς το',preOrder:'προ-παραγγελία από',allowPreOrder:'Αφήστε Προπαραγγελία',cardPaymentDetails:'Ρυθμίσεις πληρωμής κάρτας',paylikeKeys:'Paylike χρησιμοποιημένα κλειδιά',posDiscount:'Αναγνωριστικό POS για έκπτωση',userTaxes:'ΦΟΡΟΙ ΧΡΗΣΗΣ',noTaxMsg:'Πληροφορίες: Έχετε κάνει αλλαγές στους φόρους, μην ξεχάσετε να τις αποθηκεύσετε.',areYouSureDelete:'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την τοποθεσία; Αυτή η ενέργεια θα διαγράψει επίσης τις ρυθμίσεις παραγγελίας για αυτήν την τοποθεσία.',pickLocationToCopy:'Επιλέξτε μια τοποθεσία από την οποία θέλετε να αντιγράψετε τα προϊόντα',areYouSureTax:'Είστε βέβαιοι ότι θέλετε να καταργήσετε αυτόν τον φόρο από τον κατάλογο των φόρων; Μην ξεχάσετε να αποθηκεύσετε τις αλλαγές!',companyUpdated:'Τα δεδομένα της εταιρείας ενημερώθηκαν με επιτυχία.',companyProdCopied:'Τα προϊόντα αντιγράφηκαν με επιτυχία.',wrongAddress:' Η διεύθυνση της &quot;{location}&quot; τοποθεσίας δεν είναι σωστή.',deleteLocationValidation:'Αυτή η τοποθεσία χρησιμοποιείται. Δεν μπορείτε να την διαγράψετε. Πρέπει να την αφαιρέσετε πρώτα από τα προϊόντα όπου χρησιμοποιείται.',email_feedback:'E-mail για λήψη σχολίων από τις εφαρμογές για κινητά',email_feedback_helptext:'Μπορείτε να χρησιμοποιήσετε πολλές διευθύνσεις ηλεκτρονικού ταχυδρομείου διαχωρισμένες με κόμματα.',printSettings:'Ρυθμίσεις εκτύπωσης',automatPrintOrder:' A4 Παραγγελία εκτύπωσης Ιστού αυτόματα',autoSendOrderToPrinter:'80 mm παραγγελία εκτύπωσης',autoPrintLocalServer:'Αυτόματη εκτύπωση σημείωσης τμήματος από τον τοπικό διακομιστή (νέες παραγγελίες ή σε επεξεργασία)',printerIp:'Εκτυπωτής IP/Host',printerPort:' Εκτυπωτής Port',copyProductsFrom:'Αντιγραφή προϊόντων από ',overEighteen:'Περιορισμός χρηστών κάτω των 18 ετών (απαιτείται η πώληση αλκοόλ μέσω της εφαρμογής)',setRadiusArea:'Ορίστε την περιοχή της ακτίνας',setDrawArea:'Ορισμός περιοχής κλήρωσης',allowPlaceUntilCloseHour:'Επιτρέψτε τις παραγγελίες μέχρι την ώρα κλεισίματος',sortProductsMethods:'Μέθοδος ταξινόμησης προϊόντων',alphabetic_asc:'Μετά την ανύψωση του ονόματος',alphabetic_desc:'Μετά το όνομα απόγονος',price:'Μετά την τιμή',custom:'Εθιμο',infoCustomSort:'(η προσαρμοσμένη ταξινόμηση γίνεται σε κάθε ενότητα επεξεργασίας κατηγορίας)',filters:'φίλτρα',allowSoundAtStatusNew:'Να επιτρέπεται ο ήχος στην κατάσταση παραγγελιών ΝΕΟ',allowSoundAtStatusProcessing:'Επιτρέψτε τον ήχο στην κατάσταση παραγγελιών ΕΠΕΞΕΡΓΑΣΙΑ',allowSoundAtStatusProcessingV1:'Επιτρέπει τον ήχο σύμφωνα με τον προεπιλεγμένο χρόνο αναμονής',allowSoundAtStatusProcessingV2:'Επιτρέπει τον ήχο σύμφωνα με το 1/4 του προεπιλεγμένου χρόνου αναμονής',allowSoundAtStatusProcessingV3:'Επιτρέπει τον ήχο βάσει του 1/2 του προεπιλεγμένου χρόνου αναμονής',allowSoundAtStatusProcessingV0:'Χωρίς ήχο',allowToOrderUnderMinValueWithCoupon:'Επιτρέψτε να κάνετε παραγγελία κάτω από την ελάχιστη τιμή κατά την εφαρμογή κουπονιού',allowSoundForMehods:'Επιτρέπει τον ήχο για τις ακόλουθες μεθόδους παράδοσης'},settingDateTime:{timezone:'Ζώνη ώρας',timeFormat:'Μορφή ώρας',dateFormat:'Μορφή ημερομηνίας',saveMsg:'Οι ρυθμίσεις ημερομηνίας και ώρας αποθηκεύτηκαν με επιτυχία'},settingCurrency:{currency:'Νόμισμα καταστήματος',saveMsg:'Τα δεδομένα νομίσματος αποθηκεύτηκαν με επιτυχία'},settingTaxes:{single:'Φόρος',name:'Ονομα',type:'Τύπος',amount:'Ποσό',notice:'Πληροφορίες: Στο πεδίο &quot;Φορολογία&quot; ορίζετε μόνο ένα όνομα ετικέτας για τον φόρο που πρέπει να εφαρμοστεί. Για να ορίσετε τις φορολογικές λεπτομέρειες όπως η αξία ή ο τύπος που πρέπει να μεταβείτε',notice2:'ΣΤΟΙΧΕΙΑ ΕΤΑΙΡΕΙΑΣ',singleTaxLabel:'Φορολογική ετικέτα',notice3:'Πληροφορίες: Στην ενότητα "Μεταχειρισμένοι φόροι" ορίζετε τους φόρους που εφαρμόζονται, λεπτομέρειες όπως αξία ή τύπος, εάν θέλετε να δημιουργήσετε ετικέτα φόρου μεταβείτε στη διεύθυνση',notice4:'επισήμανση φόρου'},settingsPayment:{publicKey:'Δημόσιο κλειδί',privateKey:'Ιδιωτικό κλειδί'},settingsOrdering:{shipping_department_id:'Shipping Department Id',distanceInKm:'Distanta in km',min_interval_reservations:'The number of minutes for interval reservation',min_standard_reservations:'Numarul de ore alocat rezervarii',min_between_reservations:'Numarul de minute intre rezervari',available_days:'Timetable',reservation_available_in_app:'Accepta rezervari la mese in app',offnoPreorders:'You must have offset 0 and period 1 to work',noPreorders:'Nu aceptam precomenzi',isAlwaysOpen:'Always open',isAlwaysOpenPreorderHours:'Preorder hours',reservationTaxesTitle:'Adauga program mese',reservationTaxesTitleEmpty:'Niciun program adaugat',reservationTaxAdvanceConsumption:'Acest preț reprezintă avans în consumație',infoBoxTitle:'Adauga informatii extra',infoBoxRadioCheck:'Modifica optiunea',infoBoxRadio:'O singura optiune',infoBoxCheck:'Mai multe optiuni',enabled:'Ενεργοποιήθηκε',paymentOptions:'Επιλογές πληρωμής',paymentOptionsErr:'Απαιτείται το πεδίο επιλογής πληρωμής.',waitingTime:'Προεπιλεγμένος χρόνος αναμονής',minimumOrderValue:'Ελάχιστη τιμή παραγγελίας',minutes:'λεπτά',shippingCost:'Κόστος αποστολής',deliveryRange:'Εύρος παράδοσης',deliveryRangeUnit:'m',posId:'Κόστος αποστολής POS ID',shippingTax:'Φόρος αποστολής',locations:'Τοποθεσίες',street:'Οδός',city:'Πόλη',country:'Χώρα',state:'Περιοχή',availableDays:'Διαθέσιμες ημέρες και ώρες',availableDaysErr:'Απαιτείται το διαθέσιμο πεδίο επιλογής ημερών και ωρών.',notice:'Ελέγξτε το σφάλμα στις καρτέλες μεθόδων παραγγελίας και, στη συνέχεια, προσπαθήστε να αποθηκεύσετε ξανά τη φόρμα',saveSuccess:'Η παραγγελία δεδομένων στοιχείων αποθηκεύτηκε με επιτυχία',deliveryRules:'Κανόνες παράδοσης',addRange:'Προσθήκη κανόνα',shippingCities:'Πόλη / Χωριά',shippingNeighborhoods:' Γειτονιές',citiesValidationError:'Βεβαιωθείτε ότι οι τιμές της πόλης είναι μοναδικές για κάθε εύρος παράδοσης',addZone:'Προσθήκη ζώνης',newZone:'Νέα ζώνη'},settingsZone:{edit:'Edit',deleteBtn:'Delete Zone',deleteShape:'Delete Shape to create another one',overridePayment:'Παράκαμψη τρόπου πληρωμής',acceptCash:'Αποδοχή μετρητών',acceptCard:'Αποδοχή κάρτας',acceptPos:'POS κατά την παράδοση (απλήρωτο)'},settingsInfoPages:{single:'σελίδα',noPage:'Δεν υπάρχουν σελίδες ακόμα.',title:'Τίτλος σελίδας',content:'Περιεχόμενο σελίδας',newPage:'Νέα σελίδα',showInHeader:'Εμφάνιση στην κεφαλίδα',showInFooter:'Εμφάνιση στο υποσέλιδο',addedSuccess:'Η σελίδα αποθηκεύτηκε με επιτυχία.',deletedSuccess:'Η σελίδα διαγράφηκε επιτυχώς',deleteMsg:'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν τη σελίδα;',TERMS_CONDITIONS:'Οροι και Προϋποθέσεις',PRIVACY_POLICY:'Πολιτική Απορρήτου',CONTACT_DETAILS:'Στοιχεία επικοινωνίας',FIDELITIES_PROMOTIONS:'Προσφορές πιστότητας'},settingsRewards:{single:'πόντο',plural:'πόντους',state:'κατάσταση',points:'πόντοι',moneySpent:'Χρήματα που ξοδεύτηκαν σε πόντους',pointsTo:'Πόντοι σε χρήματα',numberOfcurrencyNeedToSpend:'Το ποσό των χρημάτων που ο πελάτης πρέπει να ξοδέψει για να κερδίσει 1 πόντο.',numberOfpointsToReward:'Το ποσό των πόντων που χρειάζεται ο πελάτης όταν θέλει να πληρώσει με πόντους.',timeInterval:'Χρονοθήκη',fromTime:'Από',toTime:'Στην τάξη',rewardSuccess:'Τα δεδομένα του προγράμματος επιβράβευσης αποθηκεύτηκαν με επιτυχία'},settingsPushNotif:{order_new:'Νέο μήνυμα παραγγελίας',order_completed_pickup:'Ολοκληρωμένο μήνυμα παραγγελίας - Παραλαβή',order_completed_meet:'Συμπληρωμένο μήνυμα παραγγελίας - Έλα να συναντηθούμε',order_completed_delivery:'Ολοκληρωμένο μήνυμα παραγγελίας - Διαμονή',order_completed_eat:'Ολοκληρωμένο μήνυμα παραγγελίας - Φάτε στην τοποθεσία',order_canceled:'Ακυρωμένο μήνυμα παραγγελίας',notifUpdated:'Τα δεδομένα ειδοποιήσεις αποθηκεύτηκαν με επιτυχία',preview:'Προεπισκόπηση',time:'χρόνος',dateTime:'ημερομηνία και ώρα',persons:'αριθμός ατόμων',timePrev:'45 λεπτά',personsPrev:'3',dateTimePrev:'Τρίτη, 15 Φεβρουαρίου 2019, στις 6μμ',info:'Σε περίπτωση που δεν χρειάζεται να εμφανιστεί ο χρόνος παράδοσης, αφήστε κενό το τελευταίο πεδίο.',selectedLocations:'Επιλεγμένες τοποθεσίες:'},settingsTips:{tipsTaxes:'Συμβουλές φόρους',state:'Χρήση συμβουλών',tipsSuccess:'Χρήση συμβουλών'},settingsPlans:{plan1Title:'Μηνιαίο',plan1Rate:'160 € / μήνα',plan1Description:'Ξεκινήστε με ένα μηνιαίο σταθερό κόστος , ανεξάρτητα από το ποσό των πωλήσεων που πραγματοποιείται μέσω της εφαρμογής.',plan2Title:'Ποσοστό πωλήσεων',plan2Rate:'10%',plan2Description:'Πληρώστε καθώς πωλείται. Επιλέξτε το Ποσοστό Πωλήσεων και καταβάλλετε ένα μηνιαίο τέλος σε σχέση με το ποσό που πωλήσατε μέσω της εφαρμογής.',current:'Τρέχουσα συνδρομή',switch:'Αλλαγή',value:'αξία'},filter:{filter:'Φίλτρο',action:'Ενέργειες',create:'δημιουργία',update:'εκσυγχρονίζω',areYouSureDelete:'Θέλετε σίγουρα να διαγράψετε αυτό το φίλτρο',yes:'Ναί',deleted:'Το φίλτρο διαγράφηκε',noFilters:'Δεν υπάρχουν φίλτρα',name:'Ονομα',addFilter:'Προσθήκη φίλτρου',remove:'αφαιρώ',filters:'φίλτρου',filterProducts:'Προϊόντα φίλτρων',filterName:'Όνομα φίλτρου',val:'βαλ',filterUpdated:'Τα φίλτρα ενημερώθηκαν',minOneFilterValueRequired:'Το ελάχιστο o valoare είναι υποχρεωτικό',filterType:'Τύπος φίλτρου',type_exists:'Ο τύπος φίλτρου υπάρχει',filter_value_exists:'Η τιμή του φίλτρου υπάρχει',some_filter_applied:'Η ενημέρωση ήταν επιτυχής, αλλά ορισμένα φίλτρα εφαρμόζονται στα προϊόντα'},ordersSource:{1:'Kiosk',2:'Qr',3:'Pos',4:'App',5:'Website',6:'Glovo',7:'Wolt',8:'Bolt'},checkbox:'Επιτρέπει την επιλογή πολλαπλών επιλογών στο προϊόν',radio:'Επιτρέπει την επιλογή μίας μόνο επιλογής στο προϊόν'},__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_el___default.a),nl:__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({btPayments:__WEBPACK_IMPORTED_MODULE_1__btPayments__["a" /* default */].en,marketplace:__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Integrations_marketplaceLabels__["a" /* default */].nl,general:{search:'Zoeken',home:'Home',add:'Toevoegen',edit:'Bewerken',delete:'Verwijderen',remove:'Weghalen',save:'Opslaan',update:'Bijwerken',cancel:'Annuleren',continue:'Doorgaan',activate:'activeren',deactivate:'uitschakelen',active:'actief',inactive:'inactief',specialPrice:'Speciale prijs',yes:'Ja',no:'Nee',success:'Succes',required:'vereist',back:'terug',next:'Volgende',finish:'Einde',duplicate:'Duplicaat',select:'Selecteer',all:'Alles',reset:'Reset',export:'Exporteer',loadMore:'Laad Meer',viewDetails:'Details bekijken',showing:'Toon {lengte} resultaat(en)',enable:'activeren',disable:'deactiveren',product:'product',logout:'Afmelden',from:'van',to:'aan',cancelCourier:'Bezorging annuleren',agree:'Bevestigen',agreePopupMessage:'Om de browser audio te laten afspelen, moet u op "Akkoord" klikken. Hiermee wordt een testgeluid afgespeeld om het geluid te activeren',day:'dag',notCompleted:'niet voltooid',saveChanges:'Wijzigingen opslaan',doYouWantToLogout:'Wilt u zich afmelden?',minutes:'minuten',hour:'uur',hours:'uren',customSort:'Bedrijf gebruikt aangepaste sortering',deliveryMethod:'Leveringsmethoden',none:'Geen',unset:'Niet ingesteld'},menuLink:{alias:'Alias',title:'Titel',updated:'Bijgewerkt',areYouSure:'Weet u zeker dat u de menukoppeling {label} hebt?',deleted:'Verwijderd',couldNotUpdate:'Niet bijgewerkt',cancel:'annuleren',delete:'verwijderen',added:'Menu link toegevoegd',promotions:'Promoties',history:'Geschiedenis',orders:'Bestellingen',reservations:'Reservations',favorite_orders:'Voorkeur bestellingen',tutorial:'Handleiding',personal_info:'Persoonsgegevens',single:'Menu link',cancelCourier:'Bezorging annuleren',logout:'Afmelden',from:'van',to:'aan',linkFor:'Link voor',externUrl:'Externe URL',custom:'Aangepast',day:'dag',couldNotSave:'Kon de menulink niet opslaan'},pages:{login:'Inloggen',register:'Register',recoverPassword:'Herstel wachtwoord',resetPassword:'Reset wachtwoord',dashboard:'Dashboard',orderingManagement:'Ordermanagement',customerDetails:'Klantgegevens',customers:'Klanten',customersGroups:'Groepen',orders:'Bestellingen',reservations:'Reservations',products:'Producten',catalog:'Catalogus',categories:'Categorieën',productOptions:'Productopties',marketing:'Marketing',campaigns:'Campagnes',donationCampaigns:'Donatie Campagnes',raffleCampaigns:'Loterij campagnes',spinningWheelCampaigns:'Spinning Wheel',offersSlider:'Aanbiedingen Slider',reports:'Rapporten',feedback:'Feedback',settings:'Instellingen',logout:'Afmelden',fidelities:'Fidelity programma',topCategory:'Top categorie',infoPagesCustom:'Aangepaste pagina’s',menuLinks:'Menulinks',infoPages:'Info pagina’s',productFilters:'Productfilters',promos:'Promoties',menus:'Menus',clientOrderView:'Ophalen weergeven'},infoPages:{single:'pagina',title:'Titel',shortDescription:'Korte Omschrijving',updated:'Bijgewerkt',areYouSure:'Weet u zeker dat u deze pagina wilt verwijderen?',deleted:'Verwijderd',couldNotUpdate:'Kon niet bijwerken',added:'Aangepaste infopagina toegevoegd',changeLinkTab:'Als er een koppeling wordt toegevoegd, wijzigt u het tekstvak met TAB voor volgende en SHIFT + TAB voor vorige',infoPages:'Info pagina’s'},ordersStatus:{bill:'Bill',AWAITING_TRANSPORT:'Wacht op bezorging',CANCELED:'Geannuleerd',DELIVERED:'Geleverd',DRAFT:'Ontwerp',NEW:'Nieuw',ON_HOLD:'In de wacht',POSTPONED:'Uitgesteld',NOT_DELIVERED:'Niet bezorgd',PICKED_UP_BY_DELIVERY:'Opgehaald voor bezorging',PROCESSING:'Verwerking',PREPARED:'Voorbereid',TRANSPORT:'Onderweg',RESERVED:'Gereserveerd',COMPLETED:'Voltooid',FINISH:'Voltooid',reservedReady:'Gereserveerd / Gereed',completedReady:'Voltooid / Gereed',deliveredReady:'Afgeleverd / Klaar'},ordersTypes:{GROUP:'Groep',SINGLE:'Enkel'},paymentTypes:{CASH:'Cash',CARD:'Online (Kaart)'},paymentStatus:{notPaid:'Geautoriseerd (bedrag geblokkeerd)',notPaidDetails:'Het bedrag wordt in rekening gebracht zodra de bestelling is gemarkeerd als Afgeleverd',paid:'Betaald',notOk:'Geweigerd'},campaignsModes:{AUTO:'Auto',MANUAL:'Handleiding'},campaignsNotificationTypes:{EMAIL:'Email',PUSH:'Push-melding'},days:{monday:'Maandag',tuesday:'Dinsdag',wednesday:'Woensdag',thursday:'Donderdag',friday:'Vrijdag',saturday:'Zaterdag',sunday:'Zondag'},gender:{selectGender:'Selecteer geslacht',male:'mannelijk',female:'vrouwelijk',Male:'Man',Female:'Vrouw',Other:'Ander'},reportsAgesGroups:{selectAge:'Selecteer leeftijd','20':'Jonger dan 20','Under 20':'Under 20','20-30':'20 - 30','30-40':'30 - 40','40-50':'40 - 50','50':'50+','50+':'50+',Unspecified:'Niet gespecificeerd'},deliveryTypes:{DELIVERY:'Levering',EAT_LOCATION:'Reserveer een tafel',MEET_HALF:'Ontmoet me halverwege',PICK_UP:'Ophalen'},couponsTypes:{FIXED:'Vast',PERCENTAGE:'Percentage',FREE_PRODUCT:'Gratis product'},taxTypes:{FIXED_INCLUDED:'Vast (inbegrepen)',PERCENTAGE_INCLUDED:'Percentage (inbegrepen)',FIXED_EXCLUDED:'Vast (exclusief)',PERCENTAGE_EXCLUDED:'Percentage (exclusief)'},productOptions:{checkbox:'Hiermee kunt u meerdere product opties selecteren',radio:'Maakt het mogelijk om slechts één product optie te selecteren'},validations:{areYouSureYouWantTo:'Weet je zeker dat je wilt',areYouSure:'Weet je zeker dat je de status wilt bijwerken naar ',wentWrong:'Er is iets misgegaan, probeer het later nog eens...',pictureSize:'jpg/png bestanden met een grootte kleiner dan 5MB',pictureSizeExceed:'De beeldgrootte mag niet groter zijn dan 5 MB!',pdfSize:'pdf bestanden met een grootte kleiner dan 25MB',pdfSizeExceed:'De pdf-grootte mag niet groter zijn dan 25MB!',archiveSizeExceed:'De bestandsgrootte mag niet groter zijn dan 500MB!',wrongFormat:'Verkeerd formaat',removePhoto:'Verwijder het huidige bestand om een nieuw bestand toe te kunnen voegen',dataCouldNotBeSaved:'Gegevens kunnen niet worden opgeslagen, probeer het later opnieuw. ',passReq:'Wachtwoordveld id vereist.',passMin:'Wachtwoord moet minimaal 6 tekens bevatten.',passConf:'Wachtwoord en wachtwoordbevestiging komen niet overeen.',validPoinsNo:'Voeg een geldig geldbedrag en een opmerking toe.',imageResolution:'aanbevolen resolutie: 300px hoogte en 820px breedte.',imageResolutionWeb:'aanbevolen resolutie: 300px hoogte en 1920px breedte.',doYouWantTo:'Wilt u',hourIsSmallerThanCreated:'Het uur dat u instelt is eerder dan het afgesproken uur',vatPrinterIdRange:'0–10 only.',vatPrinterIdNumeric:'Numbers only.'},upload:{uploadLabel:'Menu Uploaden',browse:'Bladeren',download:'QR-Code Downloaden'},dashboard:{selectLocation:'Locatie:',tile1Title:'Nieuw Bestellingen',tile2Title:'Totaal aantal bestellingen',tile3Title:'Opbrengst',tile4Title:'Nieuw geregistreerde gebruikers',today:'Vandaag',orderChart:'Bestellingen',completed:'Aantal bestellingen',canceled:'Geannuleerd',salesChart:'Verkoop',salesIn:'Verkoop in',top5Chart:'Top 5 producten',orderingChart:'Besteltypes',nrOfOrders:'Aantal bestellingen',nrOfEmails:'Aantal emails'},customers:{noCustomer:'Geen klant geselecteerd',single:'Klant',plural:'Klanten',title:'KLANT DETAILS',pointsTitle:'Klant loyaliteits punten',currentPoints:'Huidige punten',pointsAddTitle:'Punten toevoegen',pay:'Pay Type',id:'ID',name:'Naam',email:'Email',phone:'Telefoon',use_calling_phone:'Preia numar telefon',gender:'Geslacht,',birth:'Verjaardag',location:'Locatie',address:'Adres',number:'Nummer',dateCreated:'Datum aangemaakt',delivery:'Levering',type:'Type',status:'Status',total:'Totaal',allTimeSale:'All time sale',none:'Geen',pointsLabel:'Uitgegeven geld',pointsLabelInPoints:'Points earned',points:'points',point:'point',clientCanUse:'Customer can use',commentsLabel:'Commentaar',pointsSuccess:'Loyaliteitspunten succesvol toegevoegd',pointsError:'We konden de punten niet toevoegen aan de klant',addCommentPerClient:'Opmerking toevoegen per client',newCommentAdded:'De opmerking is toegevoegd',filters:{withOrders:'Met bestellingen',withoutOrders:'Zonder bestellingen'},addGroup:'Groep toevoegen',deleteGroup:'Groep succesvol verwijderd.',saveGroup:'Groep is succesvol toegevoegd',updateGroup:'Groep is succesvol bijgewerkt'},orders:{counterPerCustomer:'Aantal bestelling',noOrders:'Geen bestelling geselecteerd',single:'bestelling',the_order:'Order',plural:'Orders',status:'Status',location:'Locatie',updateStatus:'Update status',editOrder:'Edit Order',ordDetails:'Bestelgegevens',date:'Datum',madeAt:'Bestelling gedaan bij',pickupTime:'Bezorgen /ophalen bij',preorder:'PRE-ORDER',preorderFilter:'Voorbestellingen',allOrders:'Alle bestellingen',pendingPreorders:'Openstaande voorbestellingen',withoutPendingPreorders:'Zonder openstaande voorbestellingen',reservationTime:'Reserveringstijd',reservationSeats:'Zitplaatsen reserveren',rating:'Waardering',meetupLocation:'Ontmoetingsplaats',ordLocation:'Bestel locatie',delivery:'Levering',type:'Type',payment:'Betaling',name:'Naam',qty:'Qty',unit:'Eenheidsprijs',unit_price:'Eenheidsprijs',final_price:'Eindprijs',total:'Total',totals_subtotals:'Subtotaal',totals_discount:'Korting',totals_discount_loyalty_points:'Korting van loyaliteitpunten',totals_grandtotal:'Total',totals_shipping:'Bezorging',totals_extras:'Boodschappentas',totals_extras_30:'Boodschappentas',totals_extras_38:'Boodschappentas',totals_extras_40:'Boodschappentas',totals_extras_50:'Ambalaj',totals_tip:'Tips',totals_donation:'Donatie',custComments:'Klantcommentaar',adminComments:'Admin Commentaar',custDetails:'Klantgegevens',shipping:'Verzendadres',billing:'Factuuradres',orderStatusSuccess:'De status van de bestelling is bijgewerkt',orderPrinterError:'maar er is een fout opgetreden in de verbinding met de printer.',orderCommnetSuccess:'Het ordercommentaar is met success bijgewerkt. ',orderHourSuccess:'Bestellevering / ophaaltijd is succesvol bijgewerkt. ',orderHourError:'Selecteer een geldig tijd. ',none:'Geen commentaar',at:'bij',filtersApplied:'Filters toegepast - klik op de filterknop om meer te zien.',customFilters:'Aangepaste filters toegepast',resetFilters:'Klik hier voor reset en de gegevens te zien',note:'Aantekening',orderNoArticulate:'Order',print:'Afdrukken (A4) ',printerPrint:'Afdrukken (80mm)',printerSuccess:'Bestelling is succesvol afgedrukt.',printerErrror:'Er is een fout opgetreden tijdens het verbinden met de printer',callCourier:'Bel bezorger',callHioCourier:'Hio',callCourierCancel:'Weet u zeker het gesprek met de bezorger te annuleren?',orderSentSuccess:'Bezorgersoproep is succesvol verzonden',orderCancelSuccess:'Bezorgersoproep is geannuleerd',packageDetails:'Pakketdetails selecteren',packageSize:'Verpakkingsgrootte',courierTime:'Ophaaltijd bezorger',now:'Nu',addTime:'Tijd toevoegen',amountRefunded:'Terugbetaald bedrag',amountIntegralRefunded:'Het volledig bedrag is terugbetaald aan de klant',refundSuccess:'Met succes terugbetaald bedrag',refundManual:'Bedrag wordt handmatig geretourneerd van de paylike',refundAutomat:'Wilt u het bedrag automatisch terugbetalen? ',refundOrder:'Terugbetalen',refundAlreadyDone:'Al terugbetaald',refundConfirmTitle:'Bestelling terugbetalen?',refundConfirmText:'Het betaalde bedrag wordt via EuPlatesc aan de klant terugbetaald. Deze actie kan niet ongedaan worden gemaakt.',refundAskCancel:'Terugbetaling voltooid. Wilt u de bestelling ook annuleren?',refundError:'Er is een fout opgetreden bij het verwerken van de terugbetaling.',orderCloseToDelivery:'Bestel met een vaste levertijd',erorrPaylike:'Fout van Paylike, er is een fout gemaakt'},companyOptions:{id:'Id',name:'Name',image:'Image',type:'Type',deleteQues:'This action will also remove the option from the products it is placed on. Are you sure you want to continue?',deleteVal:'This action will also delete the value from the products it is placed on. If you don\'t want this, don\'t save!',active:'Active'},catalogProd:{noProducts:'Geen product geselecteerd',single:'product',plural:'producten',generalDetails:'Algemene details',name:'Naam',desc:'Beschrijving',image:'Afbeelding',category:'Categorie',price:'Prijs',oldPrice:'Oude prijs',newPrice:'Nieuwe prijs',useDiscountPrice:'Gebruik kortingsprijs',taxes:'Toegepaste belastingen',status:'Status',posid:'POS-ID',allowUserComments:'Gebruikerscommentaar toestaan',availableInStore:'Alleen verkrijgbaar in de winkel',validFromTo:'Geldig van - tot',prodType:'Product type',singleType:'single',groupType:'groep',rewardPoints:'Beloningspunten',moneySpent:'Geld voor Punten',numberOfYouNeedToSpend:'Bedrag {valuta} dat de klant moet uitgeven om een loyaliteitspunt te krijgen.',points:'punten',soldWith:'Verkocht met',pickAnOption:'Kies een optie',minNoSelected:'Min aantal geselecteerd',maxNoSelected:'Max aantal geselecteerd',optVal:'Waarde',leaveEmpty:'Laat leeg of zet 0 indien optie geen extra kosten heeft',prodDeleted:'Product succesvol verwijderd',prodAdded:'Product succesvol toegevoegd',prodUpdated:'Product succesvol bijgewerkt',prodPhotoError:'We konden de productfoto niet opslaan, probeer het later opnieuw',rewardPossibelValue:'Mogelijke waarden',errorOptions:'Zorg ervoor dat alle productvelden correct zijn ingevuld.',locationSettings:'Locatie-instellingen',availableIn:'Beschikbaar in',deliveryMethodsandHours:'Bezorgingsmethoden en -uren',overrideSettings:'Overschrijf de instellingen',addLocationValidation:'Sommige productopties zijn niet compatibel met de geselecteerde locaties, als u doorgaat, worden de opties verwijderd, zo niet, dan wordt de locatie niet toegevoegd',productAvailableIn:'Product is beschikbaar in',particularLocationSettings:'Aangepaste instellingen per locatie',activateParticularSettings:'Activeer de aangepaste instellingen',withoutThisOptionDefault:'*zonder deze optie te activeren worden de standaardinstellingen gebruikt',highlightsProduct:'Highlight product',search:'Zoeken',availability:'Beschikbaarheid',setLimitedAvailability:'Beperkte beschikbaarheid instellen',leaveEmptyAvailability:'Laat onbeperkt leeg',timeOptions:'Opties voor datumtijd',picktimeOptions:'Kies een optie',timeOptionsValues:{none:'Geen',dateTimePicker:'Datum tijdkiezer',dateRangePicker:'Datum bereikkiezer'},maxQuantityIn:'Maximum hoeveelheid in',unitOfTime:'tijdseenheid',youChoose:'Je kiest',isUsedFor:'Wordt alleen gebruikt voor de locatie die is ingesteld.',isHiddenFromListing:'Verbergen voor productenlijst',isHiddenFromSearch:'Verbergen voor producten zoeken',isHiddenFromQrMenu:'Hide from Qr menu',Monday:'ma',Tuesday:'di',Wednesday:'wo',Thursday:'do',Friday:'vr',Saturday:'za',Sunday:'zo',accesRestricted:'Sorry, u heeft geen toegang tot dit product',changeLocations:'Change locations',includeAllLocationsProducts:'Include also the products available in all locations',bulkLocationsMode:'Action',bulkModeAdd:'Add',bulkModeRemove:'Remove',bulkModeReplace:'Replace',massUpdate:'Mass update',massUpdateSubtitle:'You are about to update {count} products',bulkActionActive:'Active / Inactive',bulkActionPrice:'Price',bulkActionVat:'VAT',bulkActionSection:'Section',bulkActionOptionGroups:'Option groups',bulkActionDelete:'Delete',bulkOverrideDeliveryHint:'When activating, add only the delivery methods you need (+). Existing override schedules on the selected products are replaced. Inactive intervals are not saved. Disabling clears existing override schedules.',bulkOverrideLocationsHint:'Leave empty to use all company locations. Only locations that already belong to each product are applied.',bulkOverrideAddIntervalHint:'Click + to add a schedule interval for this method.',bulkPriceDirection:'Direction',bulkPriceIncrease:'Increase',bulkPriceDecrease:'Decrease',bulkPriceMode:'Type',bulkPriceFlat:'Flat amount',bulkPricePercent:'Percentage (%)',bulkPriceAmount:'Amount',bulkPriceBaseOnlyHint:'Only the base price is changed. The new price will never go below 0.',bulkOptionGroupsMode:'Association mode',bulkOptionGroupsModeHint:'Add keeps existing groups. Replace overwrites them with the selected ones.',bulkDeleteWarning:'This will permanently delete {count} products. This action cannot be undone easily.',bulkDeleteEnableLabel:'Yes, delete the selected products (other mass actions will be ignored)',confirmBulkMultiple:'Apply these changes to {count} {products}:',bulkProductSingular:'product',bulkProductPlural:'products',confirmBulkAreYouSure:'Are you sure?',bulkSummaryAddLocations:'add locations ({value}) to {count} {products}',bulkSummaryRemoveLocations:'remove locations ({value}) from {count} {products}',bulkSummarySetActive:'set {count} {products} as active',bulkSummarySetInactive:'set {count} {products} as inactive',bulkSummaryIncreasePriceFlat:'increase the base price of {count} {products} by {amount} {currency}',bulkSummaryIncreasePricePercent:'increase the base price of {count} {products} by {amount}%',bulkSummaryDecreasePriceFlat:'decrease the base price of {count} {products} by {amount} {currency}',bulkSummaryDecreasePricePercent:'decrease the base price of {count} {products} by {amount}%',bulkSummaryAddOptionGroups:'add option groups ({value}) to {count} {products}',bulkSummaryReplaceOptionGroups:'replace option groups on {count} {products} with ({value})',bulkSummarySetVat:'set VAT {value} on {count} {products}',bulkSummarySetSection:'set section {value} on {count} {products}',bulkSummaryEnableOverride:'enable override settings on {count} {products}',bulkSummaryEnableOverrideWithSchedule:'replace override schedules on {count} {products}',bulkSummaryDisableOverride:'disable override settings on {count} {products}',bulkSummaryDelete:'delete {count} {products}',bulkSummaryGeneric:'update {count} {products}',confirmBulkAddLocations:'Are you sure you want to add locations to {count} products?',confirmBulkRemoveLocations:'Are you sure you want to remove locations from {count} products?',confirmBulkSetActive:'Are you sure you want to set {count} products as active?',confirmBulkSetInactive:'Are you sure you want to set {count} products as inactive?',confirmBulkIncreasePriceFlat:'Are you sure you want to increase the base price of {count} products by {amount}?',confirmBulkIncreasePricePercent:'Are you sure you want to increase the base price of {count} products by {amount}%?',confirmBulkDecreasePriceFlat:'Are you sure you want to decrease the base price of {count} products by {amount}?',confirmBulkDecreasePricePercent:'Are you sure you want to decrease the base price of {count} products by {amount}%?',confirmBulkAddOptionGroups:'Are you sure you want to add option groups to {count} products?',confirmBulkReplaceOptionGroups:'Are you sure you want to replace option groups on {count} products?',confirmBulkSetVat:'Are you sure you want to set VAT on {count} products?',confirmBulkSetSection:'Are you sure you want to set the section on {count} products?',confirmBulkDelete:'Are you sure you want to delete {count} products?',confirmBulkGeneric:'Are you sure you want to update {count} products?',bulkLocationsUpdated:'Updated locations for {updated} products',bulkMassUpdated:'Updated {updated} products',couldNotFetchProductOptions:'Could not fetch product options. Please contact support.'},catalogProdRewardsHints:{hint1:'Laat leeg om de standaardwaarden van instellingen toe te passen',hint2:'Zet 0 als je geen beloningsprogramma op dit product wilt',hint3:'Voeg een positieve waarde toe om de standaardwaarde van instellingen te overschrijven'},catalogCateg:{single:'categorie',plural:'categorieën',color:'Culoare',name:'Naam',image:'Afbeelding',displayType:'Weergavetype',shortDescription:'Korte Omschrijving',validFromTo:'Geldig van - tot',areYouSure:'Weet u zeker dat u deze categorie wilt {labelen)?',categAdded:'Categorie is succesvol toegevoegd',categUpdated:'Categorie is succesvol bijgewerkt',categDeleted:'Categorie is met succes verwijderd',couldNotSave:'We konden de foto niet opslaan in deze categorie, probeer het later opnieuw.',List:'Lijst',Grid:'Grid',assignTopCategory:'Toewijzen aan een topcategorie',pleaseSelect:'Selecteer / Niet van toepassing',categoriesWithoutParent:'Categorieën zonder koppeling',topCategory:'Top Categorie',overrideSettingsHelp:'Indien ingeschakeld verschijnt deze categorie alleen in het menu voor de geselecteerde locatie, bezorgmethode, dag en tijdsvenster.',schedule:'Rooster',useSchedule:'Rooster gebruiken',scheduleActive:'Rooster actief',scheduleHelp:'Eén rooster voor deze topcategorie in alle locaties. Buiten deze uren is bestellen uit deze categorie niet beschikbaar in de app.'},catalogProdOpt:{single:'Optie',plural:'Opties',new:'Nieuwe optie',name:'Naam',type:'Type',value:'Waarde',values:'Waarden',posid:'POS-ID',optionSaved:'Productopties zijn met succes opgeslagen',areyouSure:'Weet u zeker deze optie te willen verwijderen?',optLocationError:'de optie {opt_name} moet {loc_name} bevatten voor beschikbare locaties',menuQr:'QR-menu',displayInMenu:'Weergeven in QR-menu'},marketingCampaigns:{single:'campagne',plural:'campagnes',name:'Naam',nameHelper:'Deze naam wordt gebruikt als onderwerp voor de emailmeldingen die voor deze campagne worden verzonden',image:'Afbeelding',startEnd:'Begin - Einddatum',daysLeft:'Dagen over',timesUsed:'Gebruikte tijden',status:'Status',actions:'Acties',send:'Verzenden',in_queue:'To be sent',sent:'Total sent',notif_sent:'Notification',email_sent:'E-mail',areYouSureNotif:'Weet u zeker deze meldingen te willen verzenden?',notifSent:'Meldingen zijn verzonden.',campaignDeleted:'Campagne is verwijderd.',areYouSureDelete:'Weet u zeker dat u wilt verwijderen',campaignAdded:'Campagne is succesvol toegevoegd',campaignUpdated:'Campagne is succesvol bijgewerkt',campaignPhotoError:'We konden de campagnefoto niet opslaan, probeer het later opnieuw.',campaignDetails:'Campagnedetails',description:'Omschrijving',maxDescription:' (max. 400 tekens) ',characters:'Karakters',validFromTo:'Geldig van - tot',notif:'Kennisgevingen',model:'Model',setHours:'Uren instellen',selectTime:'Tijd selecteren',chooseTarget:'Kies de doelgroep',gender:'Geslacht',age:'Leeftijd',city:'Stad',location:'Locatie',visibleInLocations:'Zichtbaar op de volgende locaties',visibleInLocationsInfo:'Deze functionaliteit is alleen beschikbaar in de Applicatie',ordersAbove:'Bestelling boven',addCoupon:'Coupon toevoegen',applyTo:'Toepassen op',value:'Waarde',code:'Code',addValue:'Waarde toevoegen',minValue:'minimum te besteden',counter_max_usage:'Hoeveel keer kan iemand deze coupon gebruiken? ',counter_max_usage_total:'Hoe vaak kan deze coupon in totaal worden gebruikt? ',counter_max_usage_example:'Typ een getal in voor het maximale aantal gebruik per persoon. Type 0 voor onbeperkt. ',counter_max_usage_total_example:'Typ een getal in voor het maximale aantal gebruik. Type 0 voor onbeperkt. ',generateCode:'Code genereren',Products:'Producten',Shipping:'Verzending',chooseCategProduct:'Kies categorieën of producten waarop de coupon van toepassing is: ',delivery_methods:'Op welke leveringsmethoden moet de coupon worden toegepast? ',order_source_ids:'Order sources',order_source_ids_all:'All sources',order_source_ids_help:'Leave empty to apply on all order sources.',location_ids:'Op welke locatie moet de coupon worden toegepast? ',sendNotificationTo:'Melding verzenden naar',chooseDayForInterval:'Kies het dageninterval',chooseHoursForInterval:'Kies de intervaluren',useInterval:'Gebruiksinterval',intervalMustBeSet:'Interval moet worden ingesteld',isCumulativeCheck:'Deze coupon is cumulatief geldig',isAutoApplyCheck:'Deze coupon is rechtstreeks van toepassing',campaignWasSent:'Campagne werd verzonden in de laatste 30 minuten',isSecondUseCheck:'Deze coupon is direct geldig na het eerste gebruik',groups:'Klantengroepen',freeProduct:'Gratis product om toe te voegen aan winkelwagen',freeProductPlaceholder:'Selecteer een product',freeProductRequired:'Selecteer een gratis product'},marketingOffers:{single:'aanbiedingsbanner',plural:'banners aanbieden',title:'Titel',status:'Status',image:'Afbeelding',imageWeb:'Webafbeelding',imageBanner:'Imagine Banner',imageLanding:'Imagine Landing',linkType:'Link type',startEndDate:'Start - Einddatum',actions:'Acties',offerAdded:'Aanbiedingsbanner succesvol toegevoegd',offerUpdated:'Aanbiedingsbanner succesvol bijgewerkt. ',offerDeleted:'Aanbiedingsbanner met succes verwijderd',weCouldNot:'We konden de slider-foto niet opslaan, probeer het later opnieuw',validImg:'Voeg een geldige afbeelding toe. ',areYouSure:'Weet u zeker dat u deze aanbiedingsbanner wilt {labelen}?',pageText:'Paginatekst',pickCateg:'Categorie',pickProd:'Kies Product',pickLoc:'Kies locatie',none:'Geen',banners:'Spandoeken',offers:'Aanbiedingen',display:'Weergave',addGroup:'Groep toevoegen',offerSuccess:'Groepsaanbieding succesvol toegevoegd'},marketingOffersTypes:{category:'categorie',product:'product',page:'pagina'},marketingFidelities:{fidelities:'Trouw',loyalityPoint:'Loyaliteitspunten',userLabeling:'Gebruikerslabels',name:'Naam',ordersValue:'Orderwaarde',ordersNumber:'Bestelnummer',color:'Kleur',notification:'Kennisgeving',coupon:'Coupon',product:'Product',nameLabel:'Labelnaam',addLabel:'Label toevoegen',noData:'Geen Data',updateUserLabeling:'Bijgewerkte gebruikerslabels',createdUserLabeling:'Gebruikerslabels gemaakt',areYouSureDelete:'Weet u zeker dat u dit label wilt verwijderen',labelDeleted:'Label is verwijderd',orderNumberRequired:'De ordernummers zijn vereist op dit veld',orderValueRequired:'De orderwaarde is vereist op dit veld',yes:'Ja',applyCupon:'Pas de coupon toe',applyproduct:'Product aanpassen',badgeColor:'Kleur Kaart',badgeName:'Naam Kaart',value:'Waarde',number:'Nummer',appliedForLastMonth:'Labels worden alleen toegepast voor de bestellingen die in de afgelopen 30 dagen zijn geplaatst',checkTermsAndConditionFidelities:'Controleer acties van de info pagina’s',labelingPrimaryOption:'Selecteer de primaire optie voor de labels',labelingSuccess:'De instellingen voor labels zijn met succes bijgewerkt',updatePrimaryOption:'Update optie',showLabelOnUser:'Label weergeven op gebruikers',infoAboutShowUserLabelUpdated:'Info over het gebruikerslabel is bijgewerkt',labelingInterval:'Selecteer het toepasbaarheidsinterval','0':'Levenslang','30':'30 dagen','60':'60 dagen','90':'90 dagen','120':'120 dagen',recurrence:'Herhaal',noReccurence:'Geen',oneDay:'1 dag',threeDays:'3 dagen',fiveDays:'5 dagen ',sevenDays:'7 dagen ',tenDays:'10 dagen ',fifteenDays:'15 dagen ',twentyDays:'20 dagen',twentyFiveDays:'25 dagen'},marketingPromos:{title:'Titel',treshold:'Drempel n',category:'Categorie',product:'Product',products:'Producten',none:'Geen',marketingPromos:'Promotie',generateQrCode:'Qr-code genereren',code:'Code',promoDeleted:'Promotie verwijderd',areYouSureDelete:'Weet je zeker dat je deze promotie wilt verwijderen?',promoAdded:'Promotie toegevoegd',promoUpdated:'Promotie geüpdatet.',weCouldNot:'We konden de gegevens niet opslaan, probeer het later opnieuw.',startEndDate:'Begin - Einddatum',image:'Afbeelding',validImg:'Voeg een geldige afbeelding toe.',print:'Afdrukken',firstname:'Voornaam',lastname:'Achternaam',points:'Punten',email:'E-mail',description:'Beschrijving'},reports:{orderedProducts:'Bestelde producten',giftCardsSoldTotal:'Total gift cards sold',giftCardsSoldAmount:'Gift cards sold',number:'Order nr',average:'Gemiddeld',trends:'Trends',clients:'Klanten',products:'Producten',marketing:'Marketing',today:'Vandaag',orderChart:'Bestellingen',clientsChart:'Klanten',completed:'Voltooid',canceled:'Geannuleerd',salesChart:'Verkoop',salesIn:'Verkoop in',customersChart:'Klanten',appInstalls:'App installeert',custWithAcc:'Klanten met een account',top10Chart:'Top 10 producten',top5Chart:'Top 5 producten',orderingChart:'Besteltypes',nrOfOrders:'Aantal bestellingen',customersAge:'Klanten leeftijd',customersGender:'Geslacht van klant',name:'Naam',appInstalled:'App geïnstalleerd',gender:'Geslacht',location:'Locatie',partnerCode:'Partnercode',email:'Email',phone:'Telefoon',age:'Leeftijd',filter:'Filter',label:'Etiket',userDetails:'Klantgegevensv',salesDetails:'Verkoopgegevens',salesProductNr:'Productverkoopnummer',totalAmount:'Totaal producten',totalProducts:'Σύνολο προϊόντων',ordersNumber:'Bestellingen',minAmount:'Minimum Totaal bedrag',minOrders:'Minimum bestellingen',maxOrders:'Maximum bestellingen',itemsSold:'Verkochte artikelen',campaign:'Campagne',couponsTimesUsed:'Aantal coupons gebruik',revenue:'Ontvangsten',total:'Totaal',paymentType:'Betalingswijze',date:'Datum',salesReport:'Verkooprapport',salesReportBeta:'Verkooprapport BETA',order:'Bestellen',export:'Export',cash:'Contant',card:'Kaart',pos:'POS',tips:'Fooien',totalSum:'Totaal bedrag',search:'Zoeken',searchFilter:'Zoeken (naam, e-mail, telefoon) ',discount:'Korting',totalDiscount:'Totale korting',ordersWithDiscount:'Bestellingen met Korting',ordersWithFidelity:'Bestellingen met Fideliteit',totalFidelityDiscount:'Totale Fideliteitskorting',newCustomers:'Nieuwe klanten',clientsWOrders:'Klanten met bestellingen',emailSend:'Verzonden emails in de afgelopen 6 maanden',emailTotal:'Totaal aantal verzonden emails',newCustomersChart:'Nieuwe klanten',productsSalesReport:'Productverkooprapport',pricePerUnit:'Prijs per eenheid',quantity:'Aantal',productName:'Productnaam',couponCode:'Coupon',checkOrder:'Gebruik bestelling',donationReport:'Donatie Rapport'},feedback:{sigle:'terugkoppeling',type:'Type',sentBy:'Verzonden door',text:'Tekst',seen:'Gezien',sentAt:'Verzonden op',search:'Zoeken',comment:'Commentaar'},feedbackTypes:{feedback:'Terugkoppeling',issue:'Probleem',suggestion:'Suggestie'},settings:{},blogPage:{categories:'Categorieën',categoriesHint:'Optioneel — artikelen kunnen ook zonder categorie.',categoryName:'Categorienaam',noCategories:'Nog geen categorieën.',articles:'Artikelen',addArticle:'Artikel toevoegen',editArticle:'Artikel bewerken',allCategories:'Alle categorieën',noCategory:'Geen categorie',allStatuses:'Alle statussen',searchByTitle:'Zoeken op titel',noArticles:'Geen artikelen gevonden.',cover:'Omslag',coverHint:'aanbevolen 1200x630px, max 5MB',imageAlt:'Alt-tekst afbeelding (SEO)',title:'Titel',slug:'Artikellink (slug)',slugHint:'Wordt uit de titel gegenereerd als leeg.',shortDescription:'Korte beschrijving (onder de titel)',content:'Inhoud',category:'Categorie',author:'Auteur',publishedAt:'Publicatiedatum',publishedAtHint:'Indien leeg, wordt bij publicatie de huidige datum gebruikt.',status:'Status',published:'Gepubliceerd',draft:'Concept',scheduled:'Gepland',seo:'SEO',metaTitle:'Metatitel',metaDescription:'Metabeschrijving',metaKeywords:'Trefwoorden (kommagescheiden)',titleRequired:'De titel is verplicht.',deleteCategoryConfirm:'Categorie "{name}" verwijderen? {count} artikel(en) blijven zonder categorie.',deleteArticleConfirm:'Artikel "{name}" verwijderen?'},settingsPages:{homepageSections:'Homepage secties',interactiveTour:'Interactieve tour',blog:'Blog',interactiveTourFirstLogin:'Gebruik interactieve tour bij eerste aanmelding',interactiveTourAlways:'Gebruik interactieve tour altijd',interactiveTourDisplayMode:'Weergavemodus afbeelding',interactiveTourDisplayContain:'Contain',interactiveTourDisplayCover:'Cover',interactiveTourDisplayFullPage:'Volledige pagina',userSettings:'Gebruikers instellingen',myProfile:'Mijn Profiel',users:'Gebruikers',general:'Algemeen',companyDetails:'Bedrijfsgegevens',dateTime:'Datum & Tijd',currency:'Valuta',accounting:'Boekhouding',tax:'Belasting',payment:'Betaling',orderingMng:'Orderbeheer',loyalty:'Loyaliteits programma',push:'Pushmeldingen',tips:'Tips',subscription:'Abonnement',myPlan:'Mijn Plan',infoPages:'Info pagina’s',taxLabeling:'Belasting etikettering',deliveryMethods:'Locaties en leveringsmethoden',filters:'Filters',filterProducts:'Filters Producten'},settingUsers:{single:'Gebruiker',fn:'Voornaam',ln:'Achternaam',email:'Email',username:'Gebruikersnaam',lang:'Interface taal',langMsg:'Dit is de taal waarin u het administratiegebied ziet',avatar:'Avatar',role:'Rol',locations:'Toegangsorders vanaf locaties',locations_helptext:'Belangrijk: Als er geen locatie is geselecteerd, heeft deze gebruiker toegang tot alle locaties.',resetPass:'Wachtwoord opnieuw instellen',password:'Wachtwoord',pass:'Wachtwoord',confPass:'Wachtwoord bevestingen',userAdded:'Er is een nieuwe gebruiker toegevoegd',userUpdated:'De gebruiker is bijgewerkt',userPicError:'We konden de gebruikers avatar niet opslaan, probeer het later opnieuw',USER:'GEBRUIKER',DRIVER:'STUURPROGRAMMA',LOCATION_ADMIN:'LOCATIEBEHEERDER',MARKETER:'MARKETEER'},settingCompany:{title:'Bedrijf',location:'Locatie',name:'Naam',lang:'Toepassingstaal',bussLoc:'Locatie bedrijf',deliveryLabels:'Leveringstypes',deliveryType:'Leveringsmethode',pick_up:'Ophalen',meet_half:'Ontmoet me halverwege',delivery:'Levering',eat_location:'Reserveer een tafel',self_ordering:'Self Ordering',phone:'Telefoon',street:'Straat',number:'Nr. ',latitude:'Breedtegraad',longitude:'Lengtegraad',email:'Email',city:'Stad',country:'Land',state:'Staat',availableDaysHrs:'BESCHIKBARE DAGEN EN UREN',from:'van',to:'to',preOrder:'reservering van',allowPreOrder:'reservering toestaan',cardPaymentDetails:'Betalingsinstellingen voor kaarten',paylikeKeys:'Paylike gebruikte sleutels',posDiscount:'POS-ID voor korting',userTaxes:'TOEGEPASTE BELASTINGEN',noTaxMsg:'Info: U heeft wijzigingen aangebracht in belastingen, vergeet ze niet op te slaan. ',areYouSureDelete:'Weet u zeker dat u deze locatie wilt verwijderen? Met deze actie worden ook de bestelinstellingen voor deze locatie verwijderd.',pickLocationToCopy:'Kies een locatie waaruit u de producten wilt kopiëren',areYouSureTax:'Weet u zeker dat u deze belasting uit de belastinglijst wilt verwijderen? Vergeet niet de wijzigingen op te slaan! ',companyUpdated:'Bedrijfsgegevens zijn succesvol bijgewerkt.',companyProdCopied:'Producten werden met succes gekopieerd.',wrongAddress:'Het adres van de locatie {locatie} is niet correct.',deleteLocationValidation:'Deze locatie is in gebruik. U mag het niet verwijderen. U moet het eerst verwijderen uit de producten waar het in gebruik is. ',email_feedback:'Emails waarin u de feedback ontvangt die bij de gebruikers van mobiele apps is geplaatst',email_feedback_helptext:'U kunt meerdere emailadressen toevoegen, gescheiden door komma\'s.',printSettings:'Afdrukinstellingen',automatPrintOrder:'A4 Web print order automatisch',autoSendOrderToPrinter:'80 mm printorder',autoPrintLocalServer:'Automatisch sectiebon printen vanaf de lokale server (nieuwe of in verwerking zijnde bestellingen)',printerIp:'Printer IP/Host',printerPort:'Printerpoort',copyProductsFrom:'Producten kopiëren van',overEighteen:'Beperking voor gebruikers jonger dan 18 jaar (verplicht om alcohol te verkopen via de applicatie) ',setRadiusArea:'Drempelgebied instellen',setDrawArea:'Tekengebied instellen',jump_to_menu:'Ga naar het menu',jump_to_categories_menu:'Geeft directe toegang tot het menu in de applicatie, voordat u de leveringsmethoden invoert. ',allow_fiscal_print:'Sta toe om bonnetjes te printen',useProdTimeOpt:'Gebruik tijdopties voor producten (alleen op reservering/boekmethode) ',allowPlaceUntilCloseHour:'Sta gebruiker toe bestellingen te plaatsen tot het sluitingsuur',sortProductsMethods:'Sorteer product methoden',alphabetic_asc:'Na naam naar boven',alphabetic_desc:'Na naam naar beneden',price:'Na prijs',custom:'Aangepast',infoCustomSort:'(aangepaste sortering wordt gemaakt in elke bewerkte categorie sectie)',filters:'Filters',allowSoundAtStatusNew:'Sta geluid toe voor bestellingen met de status NIEUW',allowSoundAtStatusProcessing:'Sta geluid toe voor bestellingen met de status PROCESSING',allowToOrderUnderMinValueWithCoupon:'Toestaan om bestelling te plaatsen onder min waarde bij het toepassen van coupon',allowSoundForMehods:'Staat geluid toe voor de volgende bezorgmethoden'},settingDateTime:{timezone:'Tijdzone',timeFormat:'Tijdnotatie',dateFormat:'Datumnotatie',saveMsg:'Tijdinstellingen succesvol opgeslagen'},settingCurrency:{currency:'Winkelvaluta',saveMsg:'Valutagegevens succesvol opgeslagen'},settingTaxes:{single:'Belasting',name:'Naam',type:'Type',amount:'Bedrag',notice:'Info: Bij \'Tax Labeling\' hoeft u alleen een labelnaam voor de belasting te definiëren om te kunnen worden toegepast. Om de belastinggegevens te definiëren, zoals waarde of type, moet u naar',notice2:'bedrijfgegevens',singleTaxLabel:'Belastinglabel',notice3:'Info: In de sectie \'Gebruikte belastingen\' definieert u de belasting die wordt toegepast, details zoals waarde of type, als u een belastinglabel wilt maken, gaat u naar',notice4:'belasting etikettering'},settingsPayment:{publicKey:'Openbare sleutel',privateKey:'Privésleutel'},settingsOrdering:{offnoPreorders:'You must have offset 0 and period 1 to work',noPreorders:'We do not accept pre-orders',isAlwaysOpen:'Always open',isAlwaysOpenPreorderHours:'Preorder hours',reservationTaxesTitle:'Add meal plan',reservationTaxesTitleEmpty:'No program added yet',reservationTaxAdvanceConsumption:'This amount is an advance on consumption',infoBoxTitle:'Adauga informatii extra',infoBoxRadioCheck:'Modifica optiunea',infoBoxRadio:'O singura optiune',infoBoxCheck:'Mai multe optiuni',enabled:'Ingeschakeld',paymentOptions:'Betalingsopties',paymentOptionsErr:'Het veld betalingsoptie is vereist.',waitingTime:'Standaard wachttijd',minimumOrderValue:'Minimale bestelwaarde',minutes:'min. ',shippingCost:'Verzendkosten',deliveryRange:'Standaard wachttijd',deliveryRangeUnit:'m',posId:'Verzendkosten POS-ID',shippingTax:'Verzendkosten',locations:'Locaties',street:'Straat',city:'Stad',country:'Land',state:'Staat',availableDays:'Dagen en uren beschikbaar',availableDaysErr:'Het optieveld beschikbare dagen en uren is vereist. ',notice:'Controleer de fout in de tabbladen met ingeschakelde bestelmethoden en probeer vervolgens het formulier opnieuw op te slaan',saveSuccess:'Bestelgegevens gegevens succesvol opgeslagen',deliveryRules:'Leveringsregels',addRange:'Regel toevoegen',shippingCities:'Steden / Dorpen',shippingNeighborhoods:'Buurten',citiesValidationError:'Zorg ervoor dat de stadswaarden uniek zijn voor elk leveringsbereik. ',deactivateDeliveryHours:'Deactiveer bezorgtijden',addZone:'Zone toevoegen',newZone:'Nieuwe zone'},settingsZone:{edit:'Zonenaam',deleteBtn:'Zone verwijderen',deleteShape:'Verwijder conditie om een andere te creëren',overridePayment:'Betaalmethode overschrijven',acceptCash:'Contant accepteren',acceptCard:'Kaart accepteren',acceptPos:'POS bij levering (onbetaald)'},settingsInfoPages:{single:'pagina',noPage:'Nog geen pagina\'s toegevoegd.',title:'Pagina Titel',content:'Pagina-inhoud',newPage:'Nieuwe pagina',showInHeader:'Weergeven in koptekst',showInFooter:'Weergeven in voettekst',addedSuccess:'Pagina succesvol opgeslagen. ',deletedSuccess:'Pagina met succes verwijderd',deleteMsg:'Weet u zeker dat u deze pagina wilt verwijderen? ',TERMS_CONDITIONS:'Algemene Voorwaarden',PRIVACY_POLICY:'Privacybeleid',CONTACT_DETAILS:'Contact details',FIDELITIES_PROMOTIONS:'Vaste klant Promoties',CUSTOM:'Klant'},settingsRewards:{single:'punt',plural:'punten',state:'Staat',points:'punten',moneySpent:'Geld besteed aan punten',pointsTo:'Punten voor geld',numberOfcurrencyNeedToSpend:'Bedrag dat klant moet uitgeven om 1 punt te verdienen.',numberOfpointsToReward:'Aantal punten dat de klant nodig heeft wanneer hij wil betalen met de loyaliteitspunten.',timeInterval:'Tijdslot.',fromTime:'Van',toTime:'To',rewardSuccess:'Loyaliteits programma gegevens succesvol opgeslagen'},settingsPushNotif:{order_new:'Bericht nieuwe bestelling',order_completed_pickup:'Voltooid bestelbericht – Ophalen. ',order_completed_meet:'Voltooid bestelbericht - Ontmoet me halverwege',order_completed_delivery:'Voltooid bestelbericht - Bezorging',order_completed_eat:'Voltooid bestelbericht - Eten op locatie',order_canceled:'Geannuleerd bestelbericht',notifUpdated:'Pushmeldingen gegevens succesvol opgeslagen',preview:'Voorbeeld',time:'tijd',dateTime:'datum en tijd',persons:'persoonsnummer',timePrev:'11:30(binnen 30 minuten)',personsPrev:'3',dateTimePrev:'dinsdag 15 februari 2019, om 18.00 uur',info:'Als u de getoonde levertijd niet nodig heeft, laat dan het laatste veld leeg.',selectedLocations:'Geselecteerde locaties:'},settingsTips:{tipsTaxes:'Tips belastingen',state:'Tips gebruiken',tipsSuccess:'Tips succesvol opgeslagen'},settingsPlans:{plan1Title:'Maandelijks',plan1Rate:'160€ / maand',plan1Description:'Ga aan de slag met een maandelijks vast bedrag, ongeacht de hoeveelheid verkopen die je via de app doet.',plan2Title:'Verkooppercentage',plan2Rate:'10%',plan2Description:'Betaal als je verkoopt. Kies het verkooppercentage en betaal een maandelijks bedrag in verhouding tot het bedrag dat u via de app verkoopt.',current:'Huidig abonnement',switch:'Schakelaar'},filter:{filter:'Filter',action:'Actie',create:'Filter gemaakt',update:'Filter Updated',areYouSureDelete:'Weet u zeker dat u dit filter wilt verwijderen',yes:'Ja',deleted:'Filter verwijderd',noFilters:'Geen filter',name:'Naam',addFilter:'Filter toevoegen',filters:'Filters',value:'Waarde',filterProducts:'Filter producten',filterName:'Filternaam',val:'Valuta',filterUpdated:'Filter bijgewerkt',minOneFilterValueRequired:'Minimaal één filterwaarde per filter vereist',filterType:'Filtertype',type_exists:'Filtertype bestaat al',filter_value_exists:'Filterwaarde bestaat al',some_filter_applied:'De update is met succes uitgevoerd, maar sommige filters of waarden worden toegepast op producten en kunnen niet worden verwijderd'},ordersSource:{1:'Kiosk',2:'Qr',3:'Pos',4:'App',5:'Website',6:'Glovo',7:'Wolt',8:'Bolt'},checkbox:'Hiermee kunt u meerdere productopties selecteren',radio:'Hiermee kunt u slechts één optie op het product kiezen'},__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_nl___default.a),it:__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({btPayments:__WEBPACK_IMPORTED_MODULE_1__btPayments__["a" /* default */].en,marketplace:__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Integrations_marketplaceLabels__["a" /* default */].it,general:{search:'Cerca',home:'Home',add:'Inserisci',edit:'Modifica',delete:'Cancella',remove:'Rimuovi',save:'Salva',update:'Aggiorna',cancel:'Annulla',continue:'Continua',activate:'Attiva',deactivate:'Disattiva',active:'Attivo',inactive:'Disattivo',removePhoto:'Troppe immagini caricate',yes:'Sì',no:'No',success:'Successo',required:'Richiesto',back:'Indietro',next:'Avanti',finish:'Fine',duplicate:'Duplica',select:'Seleziona',all:'Tutto',reset:'Ripristina',export:'Esporta',loadMore:'Carica di più',viewDetails:'Visualizza Dettagli',showing:'Mostra (lunghezza) risultato(i)',enable:'Abilita',disable:'Disabilita',product:'Prodotto',cancelCourier:'Annulla corriere',logout:'Esci',from:'da',to:'a',agree:'Sono d\'accordo',agreePopupMessage:'Per permettere al browser di riprodurre l\'audio è necessario cliccare su "Sono d\'accordo". Questo riprodurrà un suono di prova per attivare la riproduzione audio.',notCompleted:'Non completato',saveChanges:'Salva modifiche',doYouWantToLogout:'Sei sicuro di voler uscire?',deliveryMethod:'Metodi di consegna',customSort:'L\'azienda usa l\'ordinamento personalizzato"',none:'Nessuno',unset:'Non impostato'},menuLink:{alias:'Alias',title:'Titolo',updated:'aggiornato',areYouSure:'Sei sicuro di {etichetta} nel menu link ?',deleted:'Cancellato',couldNotUpdate:'Non aggiornato',cancel:'annulla',delete:'cancella',added:'Menu link aggiunto',promotions:'Promozioni',history:'Cronologia',orders:'Ordini',reservations:'Reservations',favorite_orders:'Ordini preferiti',tutorial:'Tutorial',personal_info:'Informazioni personali',single:'Menu link',linkFor:'Link per',externUrl:'URL esterno',custom:'Personalizzato',day:'giorno',couldNotSave:'Impossibile salvare il collegamento del menu'},pages:{login:'Accedi',register:'Registrati',recoverPassword:'Recupera Password',resetPassword:'Reimposta password',dashboard:'Pannello di controllo',orderingManagement:'Gestione degli ordini',customerDetails:'Dettagli cliente',customers:'Clienti',customersGroups:'Gruppi',orders:'Ordini',reservations:'Reservations',products:'Prodotti',catalog:'Catalogo',categories:'Categorie',productOptions:'Opzioni prodotto',marketing:'Marketing',campaigns:'Campagne',donationCampaigns:'Campagne di Donazione',raffleCampaigns:'Campagne lotteria',spinningWheelCampaigns:'Spinning Wheel',offersSlider:'Slides offerte',reports:'Reports',feedback:'Feedback',settings:'Impostazioni',logout:'Esci',fidelities:'Fedeltà',topCategory:'Categorie Top',infoPagesCustom:'Pagine personalizzate',menuLinks:'Menu link',infoPages:'Pagine informative',productFilters:'Filtri prodotto',promos:'Promozioni',menus:'Menù',clientOrderView:'Mostra ritiro'},infoPages:{single:'pagina',title:'Titolo',shortDescription:'Descrizione breve',updated:'Aggiornato',areYouSure:'Sei sicuro di voler eliminare questa pagina?',deleted:'Eliminato',couldNotUpdate:'Impossibile aggiornare',added:'Pagina informativa personalizzata aggiunta',changeLinkTab:'Nel caso in cui venga aggiunto un link, cambiare la casella di testo con TAB per il prossimo e SHIFT + TAB per il precedente.',infoPages:'Pagine Informative'},ordersStatus:{bill:'Bill',AWAITING_TRANSPORT:'In attesa del trasporto',CANCELED:'Annullato',DELIVERED:'Consegnato',DRAFT:'Bozza',NEW:'Nuovo',ON_HOLD:'In attesa',POSTPONED:'Rinviato',NOT_DELIVERED:'Non consegnato',PICKED_UP_BY_DELIVERY:'Pronto per la consegna',PROCESSING:'In Elaborazione',PREPARED:'Preparato',TRANSPORT:'In trasporto',RESERVED:'Riservato',COMPLETED:'Completato',FINISH:'Completato',reservedReady:'Riservato / Pronto',completedReady:'Completato / Pronto',deliveredReady:'Consegnato / Pronto',canceledForever:'Vuoi annullare? Questa azione è irreversibile'},ordersTypes:{GROUP:'Gruppo',SINGLE:'Singolo'},paymentTypes:{CASH:'Contanti',CARD:'Online (Carta)'},paymentStatus:{notPaid:'Autorizzato (Importo bloccato)',notPaidDetails:'L\'importo sarà addebitato una volta che l\'ordine è contrassegnato come Consegnato.',paid:'Pagato',notOk:'Rifiutato'},campaignsModes:{AUTO:'Automatica',MANUAL:'Manuale'},campaignsNotificationTypes:{EMAIL:'E-mail',PUSH:'Notifica Push'},days:{monday:'Lunedì',tuesday:'Martedì',wednesday:'Mercoledì',thursday:'Giovedì',friday:'Venerdì',saturday:'Sabato',sunday:'Domenica'},daysShort:{Mon:'Lun',Tue:'Mar',Wed:'Mer',Thu:'Gio',Fri:'Ven',Sat:'Sab',Sun:'Dom'},gender:{selectGender:'Seleziona Genere',male:'maschio',female:'femmina',Male:'Maschio',Female:'Femmina',Other:'Altro'},reportsAgesGroups:{selectAge:'Seleziona Età','20':'Sotto i 20','Under 20':'Sopra i 20','20-30':'20 - 30','30-40':'30 - 40','40-50':'40 - 50','50':'50','50+':'50+',Unspecified:'Non specificato'},deliveryTypes:{DELIVERY:'Consegna a domicilio',EAT_LOCATION:'Prenota un tavolo',MEET_HALF:'Incontro a metà strada',PICK_UP:'Ritiro in negozio'},couponsTypes:{FIXED:'Fisso',PERCENTAGE:'Percentuale',FREE_PRODUCT:'Prodotto gratuito'},taxTypes:{FIXED_INCLUDED:'Fissa (inclusa)',PERCENTAGE_INCLUDED:'Percentuale (inclusa)',FIXED_EXCLUDED:'Fissa',PERCENTAGE_EXCLUDED:'Percentuale'},productOptions:{checkbox:'Permette di selezionare più opzioni sul prodotto',radio:'Permette di selezionare solo un\'opzione'},validations:{areYouSureYouWantTo:'Sei sicuro di volere',areYouSure:'Sei sicuro di volere aggiornare lo stato a',wentWrong:'Qualcosa è andato storto, per favore riprova più tardi...',pictureSize:'file jpg/png con una dimensione inferiore a 5MB',pictureSizeExceed:'La dimensione dell\'immagine non può superare i 5MB!',removePhoto:'Si prega di rimuovere il file corrente per poterne aggiungere uno nuovo',dataCouldNotBeSaved:'Non è stato possibile salvare i dati, riprova più tardi.',passReq:'Richiesto campo password ID',passMin:'La Password deve essere almeno di 6 caratteri',passConf:'La password e la conferma della password non corrispondono',validPoinsNo:'Si prega di aggiungere un importo di denaro valido e un commento',imageResolution:', risoluzione consigliata 300px di altezza e 820px di larghezza.',imageResolutionWeb:', risoluzione consigliata 300px di altezza e 1920px di larghezza.',doYouWantTo:'Vuoi',hourIsSmallerThanCreated:'L\'ora impostata è inferiore all\'ora inserita',vatPrinterIdRange:'0–10 only.',vatPrinterIdNumeric:'Numbers only.'},dashboard:{selectLocation:'Località:',selectMethod:'Metodo',tile1Title:'Nuovi Ordini',tile2Title:'Ordini totali',tile3Title:'Ricavi',tile4Title:'Nuovi utenti registrati',today:'Oggi',orderChart:'Ordini',completed:'Numero di ordini',canceled:'Annullato',salesChart:'Vendite',salesIn:'Vendite in',top5Chart:'Top 5 prodotti',orderingChart:'Tipi di ordinazione',nrOfOrders:'Numero di ordini',nrOfEmails:'Numero di emails'},customers:{noCustomer:'Nessun cliente selezionato',single:'cliente',plural:'clienti',title:'DETTAGLI CLIENTE',pointsTitle:'Punti fedeltà del cliente',currentPoints:'Punti attuali',pointsAddTitle:'Aggiungi Punti',pay:'Pay Type',id:'ID',name:'Nome e Cognome',email:'Email',phone:'Telefono',use_calling_phone:'Preia numar telefon',gender:'Genere',birth:'Data di nascita',location:'Località',address:'Indirizzo',number:'Numero',dateCreated:'Data di creazione',delivery:'Consegna',type:'Tipo',status:'Stato',total:'Totale',allTimeSale:'Totale venduto',none:'Nessuno',pointsLabel:'Soldi spesi',pointsLabelInPoints:'Points earned',points:'points',point:'point',clientCanUse:'Customer can use',commentsLabel:'Commento',pointsSuccess:'Punti fedeltà aggiunti con successo.',pointsError:'Non è stato possibile aggiungere i punti al cliente.',addCommentPerClient:'Aggiungi commento per cliente',newCommentAdded:'Il commento è stato aggiornato',filters:{withOrders:'Con gli Ordini',withoutOrders:'Senza Ordini'},addGroup:'Aggiungere gruppo',deleteGroup:'Gruppo eliminato con successo.',saveGroup:'Il gruppo è stato aggiunto con successo',updateGroup:'Il gruppo è stato aggiornato correttamente'},orders:{counterPerCustomer:'Numero di ordini',noOrders:'Nessun ordine selezionato',single:'Ordine',the_order:'Ordine',plural:'ordini',status:'Stato',location:'Località',updateStatus:'Aggiornamento dello stato',editOrder:'Edit Order',ordDetails:'Dettagli dell\'Ordine',date:'Data',madeAt:'Ordine effettuato alle',pickupTime:'Consegna / Ritiro alle',preorder:'PREORDINE',preorderFilter:'Preordini',allOrders:'Tutti gli ordini',pendingPreorders:'Preordini in attesa',withoutPendingPreorders:'Senza preordini in attesa',reservationTime:'Orario di prenotazione',reservationSeats:'Prenotazione posti',rating:'Valutazione',meetupLocation:'Luogo dell\'incontro',ordLocation:'Località dell\'ordine',delivery:'Consegna',type:'Tipo',payment:'Pagamento',name:'Nome',qty:'Qtà',unit:'Prezzo Unitario',unit_price:'Prezzo unitario',final_price:'Prezzo finale',total:'Totale',totals_subtotals:'Subtotale',totals_discount:'Sconto',totals_discount_loyalty_points:'Sconto dai punti fedeltà',totals_grandtotal:'Totale',totals_shipping:'Spedizione',totals_extras:'Sacchetto',totals_extras_27:'Tassa sull\'imballaggio',totals_extras_30:'Sacchetto',totals_extras_38:'Sacchetto',totals_extras_40:'Sacchetto',totals_extras_50:'Ambalaj',totals_tip:'Mance',totals_donation:'Donazione',custComments:'Commento del cliente',adminComments:'Commento dell\'Amministratore',custDetails:'Dettagli del Cliente',shipping:'Indirizzo di spedizione',billing:'Indirizzo di fatturazione',orderStatusSuccess:'Stato dell\'ordine aggiornato con successo',orderPrinterError:',ma c\'è stato un errore nella connessione con la stampante.',orderCommnetSuccess:'Commento dell\'ordine aggiornato con successo',orderHourSuccess:'Ora di consegna/ritiro dell\'ordine aggiornato con successo',orderHourError:'Prego fornire un\'ora valida.',none:'Nessun commento',at:'in',filtersApplied:'Filtri applicati - clicca sul pulsante del filtro per vederne altri',customFilters:'Filtri personalizzati applicati',resetFilters:'clicca qui per ripristinare e vedere i dati in tempo reale',note:'Nota',orderNoArticulate:'Ordine',print:'Stampa (A4)',printerPrint:'Stampa (80mm)',printerSuccess:'Ordine stampato con successo',printerErrror:'C\'è stato un errore nella connessione con la stampante.',callCourier:'Chiama il corriere',callHioCourier:'Hio',callCourierCancel:'Sei sicuro di voler annullare la chiamata del corriere?',orderSentSuccess:'La chiamata al corriere è stata inviata con successo',orderCancelSuccess:'La chiamata al corriere è stata annullata',packageDetails:'Seleziona i dettagli del pacchetto',packageSize:'Dimensione del pacchetto:',courierTime:'Orario di ritiro del corriere: ',now:'Adesso',addTime:'Aggiungi tempo',orderCloseToDelivery:'Ordina con l\'ora di consegna più vicina',amountRefunded:'Importo rimborsato',amountIntegralRefunded:'L\'importo è stato rimborsato integralmente al cliente',refundSuccess:'Importo rimborsato con successo',refundManual:'L\'importo sarà restituito dal manuale paylike',refundAutomat:'Vuoi rimborsare l\'importo automaticamente?',refundOrder:'Rimborsa',refundAlreadyDone:'Già rimborsato',refundConfirmTitle:'Rimborsare l\'ordine?',refundConfirmText:'L\'importo pagato sarà restituito al cliente tramite EuPlatesc. Questa azione non può essere annullata.',refundAskCancel:'Rimborso effettuato. Vuoi annullare anche l\'ordine?',refundError:'Si è verificato un errore durante l\'elaborazione del rimborso.',erorrPaylike:'Errore da Paylike, accesso errato'},companyOptions:{id:'Id',name:'Name',image:'Image',type:'Type',deleteQues:'This action will also remove the option from the products it is placed on. Are you sure you want to continue?',deleteVal:'This action will also delete the value from the products it is placed on. If you don\'t want this, don\'t save!',active:'Active'},catalogProd:{noProducts:'Nessun prodotto selezionato',single:'prodotto',plural:'prodotti',generalDetails:'Dettagli Generali',aditionalInfo:'Informazioni aggiuntive',name:'Nome',desc:'Descrizione',image:'Immagine',imageMore:'Altre immagini',video:'Video',category:'Categoria',partialPay:'Plata partiala',secondaryCategory:'Secondary categories',price:'Prezzo',taxes:'Tasse applicate',status:'Stato',posid:'POS ID',allowUserComments:'Consenti i commenti degli utenti',validFromTo:'Valido da - a',prodType:'Tipo Prodotto',singleType:'singolo',groupType:'gruppo',rewardPoints:'Punti premio',moneySpent:'Soldi in punti',numberOfYouNeedToSpend:'Numero di {valuta} che il cliente deve spendere per ottenere un punto.',points:'punti',soldWith:'Venduto con',pickAnOption:'Scegli un\'opzione',minNoSelected:'N. minimo selezionato',maxNoSelected:'N. massimo selezionato',optVal:'Valore',leaveEmpty:'Lasciare vuoto o mettere 0 se l\'opzione non costa extra',prodDeleted:'Prodotto eliminato con successo',prodAdded:'Prodotto aggiunto con successo',prodUpdated:'Prodotto aggiornato con successo',prodPhotoError:'Non è stato possibile salvare la foto del prodotto, si prega di riprovare più tardi.',rewardPossibelValue:'Possibili valori',errorOptions:'Si prega di controllare tutte le opzioni del prodotto, alcune potrebbero non essere compilate.',locationSettings:'Impostazioni Località',availableIn:'Disponibili in',deliveryMethodsandHours:'Metodi e orari di consegna',overrideSettings:'Impostazioni sovrascritte',addLocationValidation:'Alcune opzioni del prodotto non sono compatibili con le località selezionate, se si continua, le opzioni saranno rimosse, altrimenti la località non sarà aggiunta',highlightsProduct:'Prodotto in evidenza',search:'Cerca',isHiddenFromListing:'Nascondere dall\'elenco dei prodotti',isHiddenFromSearch:'Nascondere dalla ricerca dei prodotti',isHiddenFromQrMenu:'Hide from Qr menu',Monday:'Lun',Tuesday:'Mar',Wednesday:'Mer',Thursday:'Gio',Friday:'Ven',Saturday:'Sab',Sunday:'Dom',accesRestricted:'Spiacente, non hai accesso a questo prodotto',changeLocations:'Change locations',includeAllLocationsProducts:'Include also the products available in all locations',bulkLocationsMode:'Action',bulkModeAdd:'Add',bulkModeRemove:'Remove',bulkModeReplace:'Replace',massUpdate:'Mass update',massUpdateSubtitle:'You are about to update {count} products',bulkActionActive:'Active / Inactive',bulkActionPrice:'Price',bulkActionVat:'VAT',bulkActionSection:'Section',bulkActionOptionGroups:'Option groups',bulkActionDelete:'Delete',bulkOverrideDeliveryHint:'When activating, add only the delivery methods you need (+). Existing override schedules on the selected products are replaced. Inactive intervals are not saved. Disabling clears existing override schedules.',bulkOverrideLocationsHint:'Leave empty to use all company locations. Only locations that already belong to each product are applied.',bulkOverrideAddIntervalHint:'Click + to add a schedule interval for this method.',bulkPriceDirection:'Direction',bulkPriceIncrease:'Increase',bulkPriceDecrease:'Decrease',bulkPriceMode:'Type',bulkPriceFlat:'Flat amount',bulkPricePercent:'Percentage (%)',bulkPriceAmount:'Amount',bulkPriceBaseOnlyHint:'Only the base price is changed. The new price will never go below 0.',bulkOptionGroupsMode:'Association mode',bulkOptionGroupsModeHint:'Add keeps existing groups. Replace overwrites them with the selected ones.',bulkDeleteWarning:'This will permanently delete {count} products. This action cannot be undone easily.',bulkDeleteEnableLabel:'Yes, delete the selected products (other mass actions will be ignored)',confirmBulkMultiple:'Apply these changes to {count} {products}:',bulkProductSingular:'product',bulkProductPlural:'products',confirmBulkAreYouSure:'Are you sure?',bulkSummaryAddLocations:'add locations ({value}) to {count} {products}',bulkSummaryRemoveLocations:'remove locations ({value}) from {count} {products}',bulkSummarySetActive:'set {count} {products} as active',bulkSummarySetInactive:'set {count} {products} as inactive',bulkSummaryIncreasePriceFlat:'increase the base price of {count} {products} by {amount} {currency}',bulkSummaryIncreasePricePercent:'increase the base price of {count} {products} by {amount}%',bulkSummaryDecreasePriceFlat:'decrease the base price of {count} {products} by {amount} {currency}',bulkSummaryDecreasePricePercent:'decrease the base price of {count} {products} by {amount}%',bulkSummaryAddOptionGroups:'add option groups ({value}) to {count} {products}',bulkSummaryReplaceOptionGroups:'replace option groups on {count} {products} with ({value})',bulkSummarySetVat:'set VAT {value} on {count} {products}',bulkSummarySetSection:'set section {value} on {count} {products}',bulkSummaryEnableOverride:'enable override settings on {count} {products}',bulkSummaryEnableOverrideWithSchedule:'replace override schedules on {count} {products}',bulkSummaryDisableOverride:'disable override settings on {count} {products}',bulkSummaryDelete:'delete {count} {products}',bulkSummaryGeneric:'update {count} {products}',confirmBulkAddLocations:'Are you sure you want to add locations to {count} products?',confirmBulkRemoveLocations:'Are you sure you want to remove locations from {count} products?',confirmBulkSetActive:'Are you sure you want to set {count} products as active?',confirmBulkSetInactive:'Are you sure you want to set {count} products as inactive?',confirmBulkIncreasePriceFlat:'Are you sure you want to increase the base price of {count} products by {amount}?',confirmBulkIncreasePricePercent:'Are you sure you want to increase the base price of {count} products by {amount}%?',confirmBulkDecreasePriceFlat:'Are you sure you want to decrease the base price of {count} products by {amount}?',confirmBulkDecreasePricePercent:'Are you sure you want to decrease the base price of {count} products by {amount}%?',confirmBulkAddOptionGroups:'Are you sure you want to add option groups to {count} products?',confirmBulkReplaceOptionGroups:'Are you sure you want to replace option groups on {count} products?',confirmBulkSetVat:'Are you sure you want to set VAT on {count} products?',confirmBulkSetSection:'Are you sure you want to set the section on {count} products?',confirmBulkDelete:'Are you sure you want to delete {count} products?',confirmBulkGeneric:'Are you sure you want to update {count} products?',bulkLocationsUpdated:'Updated locations for {updated} products',bulkMassUpdated:'Updated {updated} products',couldNotFetchProductOptions:'Could not fetch product options. Please contact support.'},catalogProdRewardsHints:{hint1:'Lasciare vuoto per applicare il valore predefinito dalle impostazioni',hint2:'Metti 0 per non applicare il programma premi su questo prodotto',hint3:'Aggiungi un valore positivo per modificare il valore predefinito dalle impostazioni'},catalogCateg:{single:'categoria',plural:'categorie',color:'Culoare',name:'Nome',image:'Immagine',displayType:'Visualizzazione Display',shortDescription:'Descrizione breve',validFromTo:'Valido da - a',areYouSure:'Sei sicuro di voler {etichetta} questa categoria?',categAdded:'Categoria aggiunta con successo',categUpdated:'Categoria aggiornata con successo',categDeleted:'Categoria rimossa con successo',couldNotSave:'Non è stato possibile salvare la foto della categoria, riprova più tardi.',List:'Elenco',Grid:'Griglia',assignTopCategory:'Assegna la categoria top',pleaseSelect:'Si prega di selezionare / Non applicabile',categoriesWithoutParent:'Categorie indipendenti',topCategory:'Categoria Top',forceMethod:'Unico metodo di consegna',selectMethod:'Seleziona metodi',enableMethod:'(Per abilitare la rimozione della categoria top)',overrideSettingsHelp:'Se abilitata, questa categoria appare nel menu solo per la località, il metodo di consegna, il giorno e la fascia oraria selezionati.',schedule:'Orario',useSchedule:'Usa orario',scheduleActive:'Orario attivo',scheduleHelp:'Un unico orario per questa categoria top in tutte le sedi. Al di fuori di queste ore, gli ordini da questa categoria non sono disponibili nell\'app.'},catalogProdOpt:{single:'Opzione',plural:'optioni',new:'Nuova Opzione',name:'Nome',type:'Tipo',value:'Valore',values:'Valori',posid:'POS ID',optionSaved:'Opzioni prodotto salvate con successo.',areyouSure:'Sei sicuro di voler eliminare questa opzione?',optLocationError:'L\'opzione {opz_nome} deve includere {loc_nome} per i luoghi disponibili',menuQr:'Menù QR',displayInMenu:'Visualizza nel menu QR'},marketingCampaigns:{single:'campagna',plural:'campagne',name:'Nome',nameHelper:'Questo nome sarà usato come soggetto per le notifiche e-mail inviate per questa campagna.',image:'Immagine',startEnd:'Data di inizio e fine',daysLeft:'Giorni rimanenti',timesUsed:'Tempi di utilizzo',status:'Stato',actions:'Azioni',send:'Invia',in_queue:'To be sent',sent:'Total sent',notif_sent:'Notification',email_sent:'E-mail',areYouSureNotif:'Sei sicuro di voler inviare le notifiche?',notifSent:'Le notifiche sono state inviate.',campaignDeleted:'Campagna rimossa con successo.',areYouSureDelete:'Sei sicuro di voler eliminare ',campaignAdded:'Campagna aggiunta con successo',campaignUpdated:'Campagna caricata con successo',campaignPhotoError:'Non è stato possibile salvare la foto della campagna, riprova più tardi.',campaignDetails:'Dettagli della campagna',description:'Descrizione',maxDescription:'(max. 400 caratteri)',characters:'caratteri',validFromTo:'Valida da - a',notif:'Notifiche',model:'Modalità',setHours:'Imposta gli orari',selectTime:'Seleziona l\'ora',chooseTarget:'Scegliere il pubblico di riferimento',gender:'Genere',age:'Età',city:'Città',location:'Luogo',visibleInLocations:'Visibile nelle seguenti località',visibleInLocationsInfo:'Questa funzionalità è disponibile solo nell\'Applicazione',ordersAbove:'Ordini al di sopra',ordersBelow:'Ordini al di sotto',addCoupon:'Aggiungi Coupon',applyTo:'Applica a',value:'Valore',code:'Codice',addValue:'Aggiungi Valore',minValue:'Quantità minima',counter_max_usage:'Quante volte una persona può utilizzare questo coupon?',counter_max_usage_total:'Quante volte può essere utilizzato in totale questo coupon?',counter_max_usage_example:'Digita un numero per impostare il numero massimo di utilizzi per persona. Digitare 0 per illimitato.',counter_max_usage_total_example:'Digita un numero per impostare il numero massimo di utilizzo. Digitare 0 per illimitato.',generateCode:'Genera il codice',Products:'Prodotti',Shipping:'Spedizione,',chooseCategProduct:'Scegli le categorie o i prodotti su cui si applicherà il coupon:',delivery_methods:'Su quali modalità di consegna deve essere applicato il coupon?',order_source_ids:'Order sources',order_source_ids_all:'All sources',order_source_ids_help:'Leave empty to apply on all order sources.',location_ids:'In quale località deve essere applicato il coupon?',sendNotificationTo:'Invia notifiche a',campaignWasSent:'La campagna è stata inviata negli ultimi 30 minuti',chooseDayForInterval:'Scegli il giorno per l\'intervallo',chooseHoursForInterval:'Scegli gli orari per l\'intervallo',useInterval:'Usa intervallo',isCumulativeCheck:'Questo coupon si applica cumulativamente',isAutoApplyCheck:'Questo coupon si applica direttamente',intervalMustBeSet:'L\'intervallo deve essere impostato',isSecondUseCheck:'Questo coupon si applica subito dopo il primo utilizzo',groups:'Gruppi di clienti',freeProduct:'Prodotto gratuito da aggiungere al carrello',freeProductPlaceholder:'Seleziona un prodotto',freeProductRequired:'Seleziona un prodotto gratuito'},marketingOffers:{single:'offerta banner',plural:'offerte banner',title:'Titolo',status:'Stato',image:'Immagine',imageWeb:'Immagine Web',imageBanner:'Immagine Banner',imageLanding:'Immagine Landing',linkType:'Tipo Link',startEndDate:'Data di inizio e fine',actions:'Azioni',offerAdded:'Banner dell\'offerta aggiunto con successo.',offerUpdated:'Banner dell\'offerta aggiornato con successo.',offerDeleted:'Banner dell\'offerta rimosso con successo.',weCouldNot:'Non è stato possibile salvare la foto della slide, riprova più tardi.',validImg:'Si prega di aggiungere un\'immagine valida.',areYouSure:'Sei sicuro di voler {etichetta} questo banner dell\'offerta?',pageText:'Pagina Testo',pickCateg:'Scegli Categoria',pickProd:'Scegli Prodotto',pickLoc:'Scegli la posizione',none:'Nessuno',banners:'Banner',offers:'Offerte',display:'Schermo',addGroup:'Aggiungere gruppo',offerSuccess:'Offerta di gruppo aggiunta con successo'},marketingOffersTypes:{category:'categoria',product:'prodotto',page:'pagina'},marketingFidelities:{fidelities:'fedeltà',loyalityPoint:'Punti fedeltà',userLabeling:'Etichetta Utente',name:'Nome',ordersValue:'Valore ordini',ordersNumber:'Numero ordini',color:'Colore',notification:'Notifica',coupon:'Coupon',product:'Prodotto',nameLabel:'Nome etichetta',addLabel:'Aggiungi etichetta',noData:'Nessun dato',updateUserLabeling:'Etichetta utente aggiornata',createdUserLabeling:'Etichetta utente creata',areYouSureDelete:'Sei sicuro di voler rimuovere questa etichetta',labelDeleted:'Etichetta rimossa',orderNumberRequired:'Questo campo o i numeri d\'ordine sono obbligatori',orderValueRequired:'Questo campo o valore dell\'ordine è obbligatorio',yes:'Sì',applyCupon:'Applica coupon',applyproduct:'Applica prodotto',badgeColor:'Colore Badge',badgeName:'Nome Badge',value:'Valore',number:'Numero',appliedForLastMonth:'Le etichette sono applicate solo per gli ordini degli ultimi 30 giorni,',checkTermsAndConditionFidelities:'Controlla le promozioni fedeltà dalle pagine informative',labelingPrimaryOption:'Seleziona l\'opzione principale per le etichette',labelingSuccess:'Le impostazioni per le etichette sono state aggiornate con successo!',updatePrimaryOption:'Aggiorna l\'opzione',showLabelOnUser:'Mostra l\'etichetta sugli utenti',infoAboutShowUserLabelUpdated:'L\'informazione \'Mostra l\'etichetta sugli utenti\' è stata aggiornata',labelingInterval:'Seleziona intervallo da applicare','0':'Sempre','30':'30 giorni','60':'60 giorni','90':'90 giorni','120':'120 giorni',recurrence:'Ricorrenza',noReccurence:'Nessuna',oneDay:'1 Giorno',threeDays:'3 Giorni',fiveDays:'5 Giorni',sevenDays:'7 Giorni',tenDays:'10 Giorni',fifteenDays:'15 Giorni',twentyDays:'20 Giorni',twentyFiveDays:'25 Giorni'},marketingPromos:{title:'Titolo',treshold:'Soglia n',category:'Categoria',product:'Prodotto',products:'Prodotti',none:'Nessuno',marketingPromos:'Promo',generateQrCode:'Genera codice QR',code:'Codice',promoDeleted:'Promozione eliminata',areYouSureDelete:'Sei sicuro di voler eliminare questa promozione?',promoAdded:'Promo aggiunta.',promoUpdated:'Promozione aggiornata correttamente.',weCouldNot:'Non è stato possibile salvare i dati, riprova più tardi.',startEndDate:'Inizio - Data di fine',image:'Immagine',validImg:'Si prega di aggiungere un\'immagine valida.',print:'Stampa',firstname:'Nome di battesimo',lastname:'Cognome',points:'Punti',email:'E-mail',description:'Descrizione'},reports:{orderedProducts:'Prodotti ordinati',giftCardsSoldTotal:'Total gift cards sold',giftCardsSoldAmount:'Gift cards sold',number:'Order nr',trends:'Tendenze',clients:'Clienti',products:'Prodotti',marketing:'Marketing',today:'Oggi',orderChart:'Ordini',clientsChart:'Clienti',completed:'Completato',canceled:'Annullato',salesChart:'Vendite',salesIn:'Vendite in',customersChart:'Clienti',appInstalls:'Installazioni di app',custWithAcc:'Clienti con account',top10Chart:'Top 10 prodotti',top5Chart:'Top 5 prodotti',orderingChart:'Tipi di ordine',nrOfOrders:'Numero di ordini',customersAge:'Età dei clienti',customersGender:'Genere dei clienti',name:'Nome e Cognome',appInstalled:'App Installate',gender:'Genere',location:'Luogo',partnerCode:'Codice partner',email:'Email',phone:'Telefono',age:'Età',filter:'Filtro',label:'Etichetta',userDetails:'Dettagli Cliente',salesDetails:'Dettagli Vendite',salesProductNr:'Numero di vendite del prodotto',totalAmount:'Importo totale',totalProducts:'Prodotti totali',ordersNumber:'Ordini',minAmount:'Importo totale Minimo',minOrders:'Ordini Minimi',maxOrders:'Ordini Massimi',itemsSold:'Articoli venduti',campaign:'Campagna',couponsTimesUsed:'Tempi di utilizzo dei coupon',revenue:'Ricavi',total:'Totale',paymentType:'Modalità di pagamento',date:'Data',salesReport:'Report delle vendite',salesReportBeta:'Report delle vendite BETA',order:'Ordine',export:'Esporta',cash:'Contanti',card:'Carta',pos:'POS',tips:'Mancia',totalSum:'Importo Totale',search:'Cerca',searchFilter:'Cerca(nome, email, telefono)',discount:'Sconto',tax:'Tassa',shipping:'Livrare',delivery_type:'Metodo di consegna',zone:'Zona',totalDiscount:'Sconto Totale',ordersWithDiscount:'Ordini con Sconto',ordersWithFidelity:'Ordini con Fedeltà',totalFidelityDiscount:'Sconto Totale Fedeltà',totalTax:'Tasse Totali',avarageOrderValue:'Valore medio dell\'ordine',clientsWOrders:'Clienti con ordini',emailSend:'Email inviate negli ultimi 6 mesi',emailTotal:'Totali email inviate: ',newCustomersChart:'Nuovi Clienti',productsSalesReport:'Report sulle vendite del prodotto',pricePerUnit:'Prezzo per unità',quantity:'Quantità',productName:'Nome Prodotto',couponCode:'Buono',checkOrder:'Usa ordine',donationReport:'Rapporto Donazioni'},feedback:{sigle:'feedback',type:'Tipo',sentBy:'Inviato da',text:'Testo',seen:'Visto',sentAt:'Inviato a',search:'Cerca',comment:'Commento'},feedbackTypes:{feedback:'Feedback',issue:'Problema',suggestion:'Suggerimento'},blogPage:{categories:'Categorie',categoriesHint:'Facoltativo — gli articoli possono anche non avere una categoria.',categoryName:'Nome categoria',noCategories:'Ancora nessuna categoria.',articles:'Articoli',addArticle:'Aggiungi articolo',editArticle:'Modifica articolo',allCategories:'Tutte le categorie',noCategory:'Nessuna categoria',allStatuses:'Tutti gli stati',searchByTitle:'Cerca per titolo',noArticles:'Nessun articolo trovato.',cover:'Copertina',coverHint:'consigliato 1200x630px, max 5MB',imageAlt:'Testo alternativo immagine (SEO)',title:'Titolo',slug:'Link articolo (slug)',slugHint:'Generato dal titolo se lasciato vuoto.',shortDescription:'Descrizione breve (sotto il titolo)',content:'Contenuto',category:'Categoria',author:'Autore',publishedAt:'Data di pubblicazione',publishedAtHint:'Se vuota, alla pubblicazione viene usata la data corrente.',status:'Stato',published:'Pubblicato',draft:'Bozza',scheduled:'Programmato',seo:'SEO',metaTitle:'Meta titolo',metaDescription:'Meta descrizione',metaKeywords:'Parole chiave (separate da virgola)',titleRequired:'Il titolo è obbligatorio.',deleteCategoryConfirm:'Eliminare la categoria "{name}"? {count} articolo/i resteranno senza categoria.',deleteArticleConfirm:'Eliminare l\'articolo "{name}"?'},settingsPages:{homepageSections:'Sezioni Homepage',interactiveTour:'Tour interattivo',blog:'Blog',interactiveTourFirstLogin:'Usa il tour interattivo al primo accesso',interactiveTourAlways:'Usa sempre il tour interattivo',interactiveTourDisplayMode:'Modalità di visualizzazione immagine',interactiveTourDisplayContain:'Contain',interactiveTourDisplayCover:'Cover',interactiveTourDisplayFullPage:'Pagina intera',userSettings:'Impostazioni Utente',myProfile:'Il mio profilo',users:'Utenti',general:'Generale',companyDetails:'Dettagli Azienda',dateTime:'Data e ora',currency:'Valuta',accounting:'Contabilità',tax:'Tassa',payment:'Pagamento',orderingMng:'Gestione degli ordini',loyalty:'Programma fedeltà',push:'Notifiche push',tips:'Mance',locationGroups:'Gruppi di località',locationGroupsName:'Nome',locationGroupsDescription:'Descrizione',locationGroupsPhoto:'Foto',locationGroupsAdded:'Nuovi gruppi di località aggiunti con successo',locationGroupsUpdated:'Gruppi di località aggiornati con successo',locationGroupsPicError:'Non è stato possibile salvare la foto dei gruppi di località, riprova più tardi.',locationGroupsDelete:'Elimina gruppo di località',locationGroupsAreYouSure:'Sei sicuro di voler eliminare questo gruppo di località?',locationGroupsSelect:'Seleziona il gruppo di località a cui appartiene:',subscription:'Sottoscrizione',myPlan:'Il mio piano',infoPages:'Pagine informative',taxLabeling:'Etichettatura delle tasse',deliveryMethods:'Luoghi e metodi di consegna',filters:'Filtri',filterProducts:'Filtri Prodotto'},settingUsers:{single:'utente',fn:'Nome',ln:'Cognome',email:'Email',username:'Username',lang:'Linguaggio d\'interfaccia',langMsg:'Questa è la lingua in cui visualizzerai l\'area di amministrazione.',avatar:'Avatar',role:'Ruolo',locations:'Accedi agli ordini dalle sedi',locations_helptext:'Importante: se non viene selezionata alcuna località, questo utente avrà accesso a tutte le località.',resetPass:'Reimposta Password',password:'Password',pass:'Password',confPass:'Conferma Password',userAdded:'Nuovo utente aggiunto con successo',userUpdated:'Nuovo utente aggiornato con successo',userPicError:'Non è stato possibile salvare l\'avatar dell\'utente, riprova più tardi.',USER:'UTENTE',DRIVER:'RIDER',LOCATION_ADMIN:'AMMINISTRAZIONE LOCALITÀ',MARKETER:'MARKETER'},settingCompany:{title:'Azienda',location:'Luogo',name:'Nome',lang:'Lingua dell\'applicazione',bussLoc:'Sede dell\'attività',deliveryLabels:'Etichette dei tipi di consegna',pick_up:'Ritiro in negozio',meet_half:'Incontro a metà strada',delivery:'Consegna a domicilio',eat_location:'Prenota un tavolo',self_ordering:'Self Ordering',phone:'Telefono',street:'Strada',number:'N.',latitude:'Latitudine',longitude:'Longitudine',email:'Email',city:'Città',country:'Paese',state:'Stato',availableDaysHrs:'GIORNI E ORARI DISPONIBILI',from:'da',to:'a',preOrder:'pre-ordine da',allowPreOrder:'Consenti Pre-ordine',cardPaymentDetails:'Impostazioni di pagamento con carta',paylikeKeys:'Chiavi usate di Paylike',posDiscount:'POS id per lo sconto',userTaxes:'TASSE UTILIZZATE',noTaxMsg:'Info: Hai fatto delle modifiche alle tasse, non dimenticare di salvarle',areYouSureDelete:'Sei sicuro di voler eliminare questa località? Questa azione eliminerà anche le impostazioni di ordinazione per questa località',pickLocationToCopy:'Scegli una località da cui desideri copiare i prodotti',areYouSureTax:'Sei sicuro di voler rimuovere questa tassa dall\'elenco delle tasse? Non dimenticare di salvare le modifiche!',companyUpdated:'Dati dell\'azienda aggiornati con successo.',companyProdCopied:'Prodotti copiati con successo.',wrongAddress:'L\'indirizzo della "{località}" non è corretto.',deleteLocationValidation:'Questa località è in uso. Non puoi eliminarla. Devi prima rimuoverla dai prodotti in cui è in uso.',email_feedback:'E-mail per ricevere feedback dalle app mobili',email_feedback_helptext:'Puoi utilizzare più indirizzi e-mail separati da virgole.',printSettings:'Impostazioni di stampa',automatPrintOrder:'Ordine di stampa Web A4 automatico',autoSendOrderToPrinter:'80 mm ordine di stampa',autoPrintLocalServer:'Stampa automatica della nota di sezione dal server locale (ordini nuovi o in elaborazione)',printerIp:'IP/Host della stampante',printerPort:'Porta della stampante',copyProductsFrom:'Copia prodotti da',overEighteen:'Limitare gli utenti sotto i 18 anni (necessario per vendere alcolici attraverso l\'applicazione)',setRadiusArea:'Imposta il raggio dell\'area',setDrawArea:'Imposta area di disegno',jump_to_menu:'Vai al menu',jump_to_categories_menu:'Permette l\'accesso diretto al menu nell\'applicazione, prima dei metodi di consegna.',allow_fiscal_print:'Consenti la stampa delle ricevute',allowPlaceUntilCloseHour:'Permettere di fare ordini fino all\'orario di chiusura',sortProductsMethods:'Metodo di ordinamento dei prodotti',alphabetic_asc:'In ordine alfabetico ascendente',alphabetic_desc:'In ordine alfabetico discendente',price:'In ordine di prezzo',custom:'Personalizzato',infoCustomSort:'(l\'ordinamento personalizzato viene effettuato in ogni sezione di modifica della categoria)',allowSoundAtStatusNew:'Consenti l\'audio per lo stato degli ordini NUOVO',allowSoundAtStatusProcessing:'Consenti l\'audio per lo stato degli ordini IN ELABORAZIONE',allowSoundAtStatusProcessingV1:'Consente l\'audio in base al tempo di attesa predefinito',allowSoundAtStatusProcessingV2:'Consente l\'audio in base a 1/4 del tempo di attesa predefinito',allowSoundAtStatusProcessingV3:'Consente l\'audio in base a 1/2 del tempo di attesa predefinito',allowSoundAtStatusProcessingV0:'Nessun suono',allowToOrderUnderMinValueWithCoupon:'Consenti di effettuare l\'ordine con un valore minimo quando si applica il coupon',filters:'Filtri',allowSoundForMehods:'Consente il suono per i seguenti metodi di consegna'},settingDateTime:{timezone:'Fuso orario',timeFormat:'Formato orario',dateFormat:'Formato data',saveMsg:'Impostazioni di data e ora salvate con successo'},settingCurrency:{currency:'Valuta del negozio',saveMsg:'Dati valuta salvati con successo'},settingTaxes:{single:'Tassa',name:'Nome',type:'Tipo',amount:'Importo',notice:'Informazioni: in "Etichettatura delle tasse" si definisce solo un nome di etichetta per l\'imposta da applicare. Per definire i dettagli fiscali come valore o tipo è necessario andare su ',notice2:'dettagli azienda',singleTaxLabel:'Etichetta tassa',notice3:'Informazioni: nella sezione "Tasse utilizzate" si definiscono le tasse che vengono applicate, dettagli come valore o tipo, se si desidera creare un\'etichetta fiscale vai a',notice4:'etichettatura delle tasse'},settingsPayment:{publicKey:'Chiave pubblica',privateKey:'Chiave privata'},settingsOrdering:{offnoPreorders:'You must have offset 0 and period 1 to work',noPreorders:'We do not accept pre-orders',isAlwaysOpen:'Sempre aperto',isAlwaysOpenPreorderHours:'Ore preordine',infoBoxTitle:'Aggiungi ulteriori informazioni',infoBoxRadioCheck:'Modifica opzione',infoBoxRadio:'Una sola opzione',infoBoxCheck:'Più opzioni',enabled:'Abilitato',paymentOptions:'Opzioni di pagamento',paymentOptionsErr:'Il campo dell\'opzione di pagamento è obbligatorio.',waitingTime:'Tempo di attesa predefinito',minimumOrderValue:'Valore minimo di ordine',minutes:'min',shippingCost:'Costo di spedizione',deliveryRange:'Raggio di consegne',deliveryRangeUnit:'m',posId:'Costo di spedizione ID POS',shippingTax:'Tassa di spedizione',locations:'Località',street:'Via',city:'Città',country:'Paese',state:'Stato',availableDays:'Giorni e orari disponibili',availableDaysErr:'Il campo opzione giorni e orari disponibili è obbligatorio.',notice:'Si prega di controllare l\'errore nelle schede dei metodi di ordinazione abilitati e poi provare a salvare di nuovo il modulo',saveSuccess:'Dati dei dettagli ordine salvati con successo',deliveryRules:'Regole di consegna',addRange:'Aggiungi regola',shippingCities:'Città',shippingNeighborhoods:'Quartieri',citiesValidationError:'Assicurati che i valori delle città siano univoci per ogni raggio di consegna.',hourAndDate:'Ora e Data',justDate:'solo data',deactivateDeliveryHours:'Disattiva ora e data',offset:'Periodo di ritardo',period:'Periodo',addZone:'Aggiungi Zona',newZone:'Nuova Zona'},settingsZone:{edit:'Nome zona',deleteBtn:'Elimina Zona',deleteShape:'Elimina forma per crearne un\'altra',overridePayment:'Sovrascrivi metodo di pagamento',acceptCash:'Accetta contanti',acceptCard:'Accetta carta',acceptPos:'POS alla consegna (non pagato)'},settingsInfoPages:{single:'pagina',noPage:'Nessuna pagina ancora aggiunta.',title:'Titolo pagina',content:'Contenuto Pagina',newPage:'Nuova Pagina',showInHeader:'Mostra nell\'intestazione',showInFooter:'Mostra nel piè di pagina',addedSuccess:'Pagina salvata con successo.',deletedSuccess:'Pagina rimossa con successo.',deleteMsg:'Sei sicuro di voler eliminare questa pagina?',TERMS_CONDITIONS:'Termini e Condizioni',PRIVACY_POLICY:'Politica sulla Privacy',CONTACT_DETAILS:'Dettagli contatto',FIDELITIES_PROMOTIONS:'Promozioni Fedeltà',CUSTOM:'Personalizzato'},settingsRewards:{single:'punto',plural:'punti',state:'Stato',points:'punto(i)',moneySpent:'Soldi spesi in punti',pointsTo:'Punti in denaro',numberOfcurrencyNeedToSpend:'Importo di denaro che il cliente deve spendere per guadagnare 1 punto.',numberOfpointsToReward:'Quantità di punti di cui il cliente ha bisogno quando vuole pagare utilizzando i punti.',timeInterval:'Fascia oraria.',fromTime:'Da ora',toTime:'A ora',rewardSuccess:'Dati del programma fedeltà salvati con successo'},settingsPushNotif:{order_new:'Nuovo messaggio d\'ordine',order_completed_pickup:'Messaggio d\'ordine completato - Ritiro',order_completed_meet:'Messaggio d\'ordine completato - Incontro a metà strada',order_completed_delivery:'Messaggio d\'ordine completato - Consegna',order_completed_eat:'Messaggio d\'ordine completato - Mangia sul posto',order_canceled:'Messaggio di ordine annullato',notifUpdated:'Dati delle notifiche push salvati con successo',preview:'Anteprima',time:'orario',dateTime:'data e ora',persons:'numero di persone',timePrev:'11:30 (in 30 minuti)',personsPrev:'3',dateTimePrev:'Martedì, 15 Febbraio 2019, alle 18:00',info:'*Nel caso in cui non sia necessario visualizzare l\'orario di consegna, lasciare vuoto l\'ultimo campo.*',selectedLocations:'Località selezionate:'},settingsTips:{tipsTaxes:'Mance tasse',state:'Utilizza Mance',tipsSuccess:'Mance salvate con successo'},settingsPlans:{plan1Title:'Mensile',plan1Rate:'160€ / mese',plan1Description:'Inizia con una tariffa fissa mensile, indipendentemente dall\'importo delle vendite effettuate tramite l\'app.',plan2Title:'Percentuale Vendite',plan2Rate:'10%',plan2Description:'Paga come vendi. Scegli la Percentuale di vendita e paga un canone mensile in relazione all\'importo che vendi tramite l\'app.',current:'Abbonamento attuale',switch:'Switch'},filter:{filter:'Filtro',action:'Azione',create:'Filtro Creato',update:'Filtro Aggiornato',areYouSureDelete:'Sei sicuro di voler eliminare questo filtro?',yes:'Sì',deleted:'Filtro rimosso',noFilters:'Nessun filtro',name:'Nome',addFilter:'Aggiungi Filtro',filters:'Filtri',value:'Valore',filterProducts:'Filtri Prodotti',filterName:'Nomi Filtri',val:'Val',filterUpdated:'Filtri Aggiornati',minOneFilterValueRequired:'È richiesto almeno un valore per ogni filtro',filterType:'Tipo di Filtro',type_exists:'Il tipo di filtro esiste',filter_value_exists:'Il valore del filtro esiste',some_filter_applied:'Aggiornato con successo, ma alcuni filtri o valori sono applicati ai prodotti e non possono essere eliminati'},ordersSource:{1:'Kiosk',2:'Qr',3:'Pos',4:'App',5:'Website',6:'Glovo',7:'Wolt',8:'Bolt'},checkbox:'Consente di selezionare più opzioni sul prodotto',radio:'Consente di selezionare una sola opzione sul prodotto'},__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_it___default.a),de:__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({btPayments:__WEBPACK_IMPORTED_MODULE_1__btPayments__["a" /* default */].en,marketplace:__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Integrations_marketplaceLabels__["a" /* default */].de,general:{search:'Suche',home:'Startseite',add:'Hinzufügen',edit:'Bearbeiten',delete:'Löschen',remove:'Entfernen',save:'Speichern',update:'Aktualisieren',cancel:'Abbrechen',continue:'Fortfahren',activate:'Aktivieren',deactivate:'Deaktivieren',active:'aktiv',inactive:'inaktiv',removePhoto:'Zu viele Fotos hochgeladen',yes:'Ja',no:'Nein',success:'Erfolg',required:'erforderlich',back:'Zurück',next:'Nächste',finish:'Fertigstellen',duplicate:'Duplizieren',select:'Auswählen',all:'Alle',reset:'Zurücksetzen',export:'Exportieren',loadMore:'Mehr anzeigen',viewDetails:'Details anzeigen',showing:'{length} Ergebnis(se) anzeigen',enable:'aktivieren',disable:'deaktivieren',product:'Produkt',cancelCourier:'Lieferant stornieren',logout:'Abmelden',from:'von',to:'bis',agree:'Zustimmen',agreePopupMessage:'Klicken Sie auf "Zustimmen", um dem Browser die Audiowiedergabe zu erlauben. Anschließend wird ein Testton abgespielt, um die Audiowiedergabe zu aktivieren.',notCompleted:'nicht abgeschlossen',saveChanges:'Änderungen speichern',doYouWantToLogout:'Möchten Sie sich abmelden?',deliveryMethod:'Lieferoptionen',customSort:'Unternehmen verwendet benutzerdefinierte Sortierung',none:'Keine',unset:'Nicht gesetzt'},menuLink:{alias:'Alias',title:'Titel',updated:'aktualisiert',areYouSure:'Möchten Sie die Verknüpfung wirklich {label}?',deleted:'Gelöscht',couldNotUpdate:'Konnte nicht aktualisiert werden',cancel:'Abbrechen',delete:'Löschen',added:'Verknüpfung hinzugefügt',promotions:'Angebote',history:'Historie',orders:'Bestellungen',reservations:'Reservations',favorite_orders:'Beliebteste Bestellungen',tutorial:'Anleitung',personal_info:'Persönliche Informationen',single:'Verknüpfung',linkFor:'Verknüpfung für',externUrl:'Externe URL',custom:'benutzerdefiniert',day:'Tag',couldNotSave:'Der Menülink konnte nicht gespeichert werden'},pages:{login:'Anmelden',register:'Registrieren',recoverPassword:'Passwort wiederherstellen',resetPassword:'Passwort zurücksetzen',dashboard:'Dashboard',orderingManagement:'Verwaltung der Bestellungen',customerDetails:'Kundendaten',customers:'Kunden',customersGroups:'Gruppen',orders:'Bestellungen',reservations:'Reservations',products:'Produkte',catalog:'Produktkatalog',categories:'Kategorien',productOptions:'Produkt Optionen',marketing:'Marketing',campaigns:'Kampagnen',donationCampaigns:'Spendenkampagnen',raffleCampaigns:'Verlosungskampagnen',spinningWheelCampaigns:'Glücksrad',offersSlider:'Angebotsbanner',reports:'Berichte',feedback:'Feedback',settings:'Einstellungen',logout:'Abmelden',fidelities:'Treueprogramm',topCategory:'Überkategorie',infoPagesCustom:'Benutzerdefinierte Seiten',menuLinks:'Verknüpfungen',infoPages:'Informationen',productFilters:'Produkt Filter',promos:'Werbeaktionen',menus:'Speisekarte',clientOrderView:'Abholung anzeigen'},infoPages:{single:'Seite',title:'Titel',shortDescription:'Kurzbeschreibung',updated:'Aktualisiert',areYouSure:'Möchten Sie die Seite wirklich löschen?',deleted:'Gelöscht',couldNotUpdate:'Seite konnte nicht aktualisiert werden',added:'Informationsseite hinzugefügt',changeLinkTab:'Um einen weiteren Link hinzuzufügen, wechseln Sie die Zeile mit TAB und gelangen zur vorherigen mit SHIFT + TAB',infoPages:'Informationen'},ordersStatus:{bill:'Bill',AWAITING_TRANSPORT:'Warten auf Lieferung',CANCELED:'Storniert',DELIVERED:'Geliefert',DRAFT:'Entwurf',NEW:'Neu',ON_HOLD:'In Wartestellung',POSTPONED:'Verschoben',NOT_DELIVERED:'Nicht geliefert',PICKED_UP_BY_DELIVERY:'Zur Lieferung abgeholt',PROCESSING:'In Bearbeitung',PREPARED:'Zubereitet',TRANSPORT:'Wird geliefert',RESERVED:'Reserviert',COMPLETED:'Abgeschlossen',FINISH:'Abgeschlossen',reservedReady:'Reserviert / Fertig',completedReady:'Abgeschlossen / Fertig',deliveredReady:'Geliefert / Fertig',canceledForever:'Stornieren? Diese Aktion ist unwiderruflich'},ordersTypes:{GROUP:'Gruppe',SINGLE:'Einzel'},paymentTypes:{CASH:'Bar',CARD:'Karte'},paymentStatus:{notPaid:'Autorisiert (Betrag vorgemerkt)',notPaidDetails:'Der Betrag wird abgebucht, sobald die Bestellung geliefert wurde.',paid:'Bezahlt',notOk:'Abgelehnt'},campaignsModes:{AUTO:'Automatisch',MANUAL:'Manuell'},campaignsNotificationTypes:{EMAIL:'E-Mail',PUSH:'Push-Benachrichtigung'},days:{monday:'Montag',tuesday:'Dienstag',wednesday:'Mittwoch',thursday:'Donnerstag',friday:'Freitag',saturday:'Samstag',sunday:'Sonntag'},daysShort:{Mon:'Mo',Tue:'Di',Wed:'Mi',Thu:'Do',Fri:'Fr',Sat:'Sa',Sun:'So'},gender:{selectGender:'Geschlecht',male:'männlich',female:'weiblich',Male:'Mann',Female:'Frau',Other:'Sonstiges'},reportsAgesGroups:{selectAge:'Alter','20':'Unter 20','Under 20':'Unter 20','20-30':'20 - 30','30-40':'30 - 40','40-50':'40 - 50','50':'50+','50+':'50+',Unspecified:'Unbestimmt'},deliveryTypes:{DELIVERY:'Lieferung',EAT_LOCATION:'Tisch reservieren',MEET_HALF:'Komm mir entgegen',PICK_UP:'Abholung'},couponsTypes:{FIXED:'Fest',PERCENTAGE:'Prozentuell',FREE_PRODUCT:'Gratisprodukt'},taxTypes:{FIXED_INCLUDED:'Fest (inbegriffen)',PERCENTAGE_INCLUDED:'Prozentuell (inbegriffen)',FIXED_EXCLUDED:'Fest',PERCENTAGE_EXCLUDED:'Prozentuell'},productOptions:{checkbox:'Ermöglicht die Auswahl mehrerer Optionen für ein Produkt',radio:'Ermöglicht die Auswahl von nur einer Option für ein Produkt'},validations:{areYouSureYouWantTo:'Möchten Sie wirklich ',areYouSure:'Möchten Sie den Status ändern zu ',wentWrong:'Etwas ist fehlgeschlagen. Versuchen Sie es später bitte erneut...',pictureSize:'jpg/png Dateien mit einer Dateigröße kleiner als 5MB ',pictureSizeExceed:'Dateigröße darf 5MB nicht übersteigen!',removePhoto:'Entfernen Sie die aktuelle Datei, um eine neue hinzuzufügen',dataCouldNotBeSaved:'Daten konnten nicht gespeichert werden. Versuchen Sie es später bitte erneut.',passReq:'Passwort erforderlich.',passMin:'Das Passwort muss mind. 6 Zeichen lang sein.',passConf:'Passwort und Passwortbestätigung stimmen nicht überein.',validPoinsNo:'Bitte geben Sie einen gültigen Betrag in € und einen Kommentar an.',imageResolution:', Empfohlene Auflösung: 300 x 820 Pixel (H x B).',imageResolutionWeb:', Empfohlene Auflösung: 300 x 1920 Pixel (H x B).',doYouWantTo:'Möchten Sie ',hourIsSmallerThanCreated:'Die von Ihnen eingestellte Uhrzeit ist vor der Uhrzeit der Bestellung',vatPrinterIdRange:'0–10 only.',vatPrinterIdNumeric:'Numbers only.'},dashboard:{selectLocation:'Standort:',selectMethod:'Methode:',tile1Title:'Neue Bestellungen',tile2Title:'Alle Bestellungen',tile3Title:'Umsatz',tile4Title:'Neu registrierte Kunden',today:'Heute',orderChart:'Bestellungen',completed:'Anzahl der Bestellungen',canceled:'Storniert',salesChart:'Verkäufe',salesIn:'Verkäufe in',top5Chart:'Top 5 Produkte',orderingChart:'Art der Bestellungen',nrOfOrders:'Anzahl der Bestellungen',nrOfEmails:'Anzahl der E-Mails'},customers:{noCustomer:'Kein Kunde ausgewählt',single:'Kunde',plural:'Kunden',title:'Kundendaten',pointsTitle:'Treuepunkte des Kunden',currentPoints:'Aktuelle Punkte',pointsAddTitle:'Punkte hinzufügen',pay:'Pay Type',id:'ID',name:'Name',email:'E-Mail',phone:'Telefonnummer',use_calling_phone:'Preia numar telefon',gender:'Geschlecht',birth:'Geburtsdatum',location:'Standort',address:'Adresse',number:'Nummer',dateCreated:'Erstelldatum',delivery:'Lieferung',type:'Art',status:'Status',total:'Gesamt',allTimeSale:'Gesamtverkäufe',none:'Keine',pointsLabel:'Ausgegebenes Geld',pointsLabelInPoints:'Points earned',points:'points',point:'point',clientCanUse:'Customer can use',commentsLabel:'Kommentar',pointsSuccess:'Treuepunkte erfolgreich hinzugefügt.',pointsError:'Die Treuepunkte konnten dem Kunden nicht gutgeschrieben werden.',addCommentPerClient:'Kommentar für Kunden hinzufügen',newCommentAdded:'Der Kommentar wurde hinzugefügt',filters:{withOrders:'Mit Bestellungen',withoutOrders:'Ohne Befehle'},addGroup:'Gruppe hinzufügen',deleteGroup:'Gruppe erfolgreich gelöscht.',saveGroup:'Gruppe wurde erfolgreich hinzugefügt',updateGroup:'Gruppe wurde erfolgreich aktualisiert'},orders:{counterPerCustomer:'Anzahl der Bestellungen',noOrders:'Keine Bestellung ausgewählt',single:'Bestellung',the_order:'Bestellung',plural:'Bestellungen',status:'Status',location:'Standort',updateStatus:'Status',editOrder:'Edit Order',ordDetails:'Bestelldetails',date:'Datum',madeAt:'Bestellung aufgegeben um',pickupTime:'Lieferung / Abholung um',preorder:'VORBESTELLUNG',preorderFilter:'Vorbestellungen',allOrders:'Alle Bestellungen',pendingPreorders:'Ausstehende Vorbestellungen',withoutPendingPreorders:'Ohne ausstehende Vorbestellungen',reservationTime:'Reservierungszeit',reservationSeats:'Reservierte Plätze',rating:'Bewertung',meetupLocation:'Treffpunkt',ordLocation:'Standort der Bestellung',delivery:'Lieferung',type:'Art',payment:'Bezahlung',name:'Name',qty:'Menge',unit:'Stückpreis',unit_price:'Stückpreis',final_price:'Endpreis',total:'Gesamt',totals_subtotals:'Zwischensumme',totals_discount:'Rabatt',totals_discount_loyalty_points:'Rabatt durch Treuepunkte',totals_grandtotal:'Gesamt',totals_shipping:'Lieferung',totals_extras:'Einkaufstasche',totals_extras_27:'Verpackungsgebühr',totals_extras_30:'Einkaufstasche',totals_extras_38:'Einkaufstasche',totals_extras_40:'Einkaufstasche',totals_extras_50:'Ambalaj',totals_tip:'Trinkgeld',totals_donation:'Spende',custComments:'Kundenkommentar',adminComments:'Adminkommentar',custDetails:'Kundendaten',shipping:'Lieferadresse',billing:'Rechnungsadresse',orderStatusSuccess:'Bestellstatus erfolgreich aktualisiert',orderPrinterError:', die Verbindung zum Drucker ist fehlgeschlagen.',orderCommnetSuccess:'Kommentar erfolgreich hinzugefügt',orderHourSuccess:'Liefer- / Abholzeit erfolgreich aktualisiert',orderHourError:'Bitte geben Sie eine gültige Uhrzeit ein.',none:'Kein Kommentar',at:'um',filtersApplied:'Filter angewandt - tippen Sie auf das Filtersymbol, um mehr zu sehen',customFilters:'Personalisierte Filter angewandt',resetFilters:'Tippen Sie hier, um die Filter zurückzusetzen und aktuelle Daten zu sehen',note:'Notiz',orderNoArticulate:'Bestellung',print:'Drucken (A4)',printerPrint:'Drucken (80mm)',printerSuccess:'Bestellung erfolgreich ausgedruckt.',printerErrror:'Die Verbindung zum Drucker ist fehlgeschlagen.',callCourier:'Lieferanten-Ruf',callHioCourier:'Hio',callCourierCancel:'Möchten Sie den Lieferanten-Ruf abbrechen?',orderSentSuccess:'Lieferanten-Ruf wurde erfolgreich gesendet',orderCancelSuccess:'Lieferanten-Ruf wurde abgebrochen',packageDetails:'Verpackungsdetails auswählen',packageSize:'Verpackungsgröße: ',courierTime:'Abholzeit für den Lieferanten: ',now:'Jetzt',addTime:'Zeit hinzufügen',orderCloseToDelivery:'Bestellung näher an Lieferzeit',amountRefunded:'Betrag erstattet',amountIntegralRefunded:'Der gesamte Betrag wurde dem Kunden erstattet',refundSuccess:'Betrag erfolgreich erstattet',refundManual:'Der Betrag wird von dem Zahlungsdienst erstattet',refundAutomat:'Möchten Sie den Betrag automatisch erstatten lassen ?',refundOrder:'Erstatten',refundAlreadyDone:'Bereits erstattet',refundConfirmTitle:'Bestellung erstatten?',refundConfirmText:'Der bezahlte Betrag wird dem Kunden über EuPlatesc erstattet. Diese Aktion kann nicht rückgängig gemacht werden.',refundAskCancel:'Erstattung abgeschlossen. Möchten Sie die Bestellung ebenfalls stornieren?',refundError:'Bei der Verarbeitung der Erstattung ist ein Fehler aufgetreten.',erorrPaylike:'Störung von Paylike, Zahlungsprozess fehlerhaft'},companyOptions:{id:'Id',name:'Name',image:'Image',prod_image:'Product Image',type:'Type',deleteQues:'This action will also remove the option from the products it is placed on. Are you sure you want to continue?',deleteVal:'This action will also delete the value from the products it is placed on. If you don\'t want this, don\'t save!',active:'Active'},catalogProd:{noProducts:'Kein Produkt ausgewählt',single:'Produkt',plural:'Produkte',generalDetails:'Allgemeine Informationen',aditionalInfo:'Zusätzliche Informationen',name:'Name',desc:'Beschreibung',image:'Bilder',imageMore:'Mehr Bilder',video:'Video',category:'Kategorie',partialPay:'Plata partiala',secondaryCategory:'Secondary categories',price:'Preis',taxes:'Angewandte Steuern',status:'Status',posid:'POS ID',allowUserComments:'Kundenkommentare zulassen',validFromTo:'Gültig von - bis',prodType:'Produkttyp',singleType:'Einzel',groupType:'Gruppe',rewardPoints:'Treuepunkte',moneySpent:'Geld in Punkte',numberOfYouNeedToSpend:'Anzahl an {currency} die der Kunde ausgeben muss, um einen Punkt zu erhalten.',points:'Punkte',soldWith:'Verkauft mit',pickAnOption:'Wähle eine Option',minNoSelected:'Minimal auszuwählende Anzahl',maxNoSelected:'Maximal auszuwählende Anzahl',optVal:'Zutat',leaveEmpty:'Leer lassen oder 0 eintippen, wenn die Option kostenfrei ist',prodDeleted:'Produkt erfolgreich gelöscht',prodAdded:'Produkt erfolgreich hinzugefügt',prodUpdated:'Produkt erfolgreich aktualisiert',prodPhotoError:'Produktbild konnte nicht gespeichert werden. Versuchen Sie es später erneut.',rewardPossibelValue:'Mögliche Werte',errorOptions:'Überprüfen Sie bitte alle Produktoptionen, einige sind nicht ausgefüllt.',locationSettings:'Standort Einstellungen',availableIn:'Verfügbar in',deliveryMethodsandHours:'Lieferarten und -zeiten',overrideSettings:'Einstellungen überschreiben',addLocationValidation:'Einige Produktoptionen sind an dem gewählten Standort nicht verfügbar. Wenn Sie fortfahren, werden die Optionen entfernt, wenn Sie nicht fortfahren, wird der Standort nicht ausgewählt.',highlightsProduct:'Produkt hervorheben',search:'Suche',isHiddenFromListing:'Aus der Produktliste ausblenden',isHiddenFromSearch:'Bei der Produktsuche ausblenden',isHiddenFromQrMenu:'Hide from Qr menu',Monday:'Mo',Tuesday:'Di',Wednesday:'Mi',Thursday:'Do',Friday:'Fr',Saturday:'Sa',Sunday:'So',accesRestricted:'Sie haben leider keinen Zugang zu diesem Produkt',changeLocations:'Change locations',includeAllLocationsProducts:'Include also the products available in all locations',bulkLocationsMode:'Action',bulkModeAdd:'Add',bulkModeRemove:'Remove',bulkModeReplace:'Replace',massUpdate:'Mass update',massUpdateSubtitle:'You are about to update {count} products',bulkActionActive:'Active / Inactive',bulkActionPrice:'Price',bulkActionVat:'VAT',bulkActionSection:'Section',bulkActionOptionGroups:'Option groups',bulkActionDelete:'Delete',bulkOverrideDeliveryHint:'When activating, add only the delivery methods you need (+). Existing override schedules on the selected products are replaced. Inactive intervals are not saved. Disabling clears existing override schedules.',bulkOverrideLocationsHint:'Leave empty to use all company locations. Only locations that already belong to each product are applied.',bulkOverrideAddIntervalHint:'Click + to add a schedule interval for this method.',bulkPriceDirection:'Direction',bulkPriceIncrease:'Increase',bulkPriceDecrease:'Decrease',bulkPriceMode:'Type',bulkPriceFlat:'Flat amount',bulkPricePercent:'Percentage (%)',bulkPriceAmount:'Amount',bulkPriceBaseOnlyHint:'Only the base price is changed. The new price will never go below 0.',bulkOptionGroupsMode:'Association mode',bulkOptionGroupsModeHint:'Add keeps existing groups. Replace overwrites them with the selected ones.',bulkDeleteWarning:'This will permanently delete {count} products. This action cannot be undone easily.',bulkDeleteEnableLabel:'Yes, delete the selected products (other mass actions will be ignored)',confirmBulkMultiple:'Apply these changes to {count} {products}:',bulkProductSingular:'product',bulkProductPlural:'products',confirmBulkAreYouSure:'Are you sure?',bulkSummaryAddLocations:'add locations ({value}) to {count} {products}',bulkSummaryRemoveLocations:'remove locations ({value}) from {count} {products}',bulkSummarySetActive:'set {count} {products} as active',bulkSummarySetInactive:'set {count} {products} as inactive',bulkSummaryIncreasePriceFlat:'increase the base price of {count} {products} by {amount} {currency}',bulkSummaryIncreasePricePercent:'increase the base price of {count} {products} by {amount}%',bulkSummaryDecreasePriceFlat:'decrease the base price of {count} {products} by {amount} {currency}',bulkSummaryDecreasePricePercent:'decrease the base price of {count} {products} by {amount}%',bulkSummaryAddOptionGroups:'add option groups ({value}) to {count} {products}',bulkSummaryReplaceOptionGroups:'replace option groups on {count} {products} with ({value})',bulkSummarySetVat:'set VAT {value} on {count} {products}',bulkSummarySetSection:'set section {value} on {count} {products}',bulkSummaryEnableOverride:'enable override settings on {count} {products}',bulkSummaryEnableOverrideWithSchedule:'replace override schedules on {count} {products}',bulkSummaryDisableOverride:'disable override settings on {count} {products}',bulkSummaryDelete:'delete {count} {products}',bulkSummaryGeneric:'update {count} {products}',confirmBulkAddLocations:'Are you sure you want to add locations to {count} products?',confirmBulkRemoveLocations:'Are you sure you want to remove locations from {count} products?',confirmBulkSetActive:'Are you sure you want to set {count} products as active?',confirmBulkSetInactive:'Are you sure you want to set {count} products as inactive?',confirmBulkIncreasePriceFlat:'Are you sure you want to increase the base price of {count} products by {amount}?',confirmBulkIncreasePricePercent:'Are you sure you want to increase the base price of {count} products by {amount}%?',confirmBulkDecreasePriceFlat:'Are you sure you want to decrease the base price of {count} products by {amount}?',confirmBulkDecreasePricePercent:'Are you sure you want to decrease the base price of {count} products by {amount}%?',confirmBulkAddOptionGroups:'Are you sure you want to add option groups to {count} products?',confirmBulkReplaceOptionGroups:'Are you sure you want to replace option groups on {count} products?',confirmBulkSetVat:'Are you sure you want to set VAT on {count} products?',confirmBulkSetSection:'Are you sure you want to set the section on {count} products?',confirmBulkDelete:'Are you sure you want to delete {count} products?',confirmBulkGeneric:'Are you sure you want to update {count} products?',bulkLocationsUpdated:'Updated locations for {updated} products',bulkMassUpdated:'Updated {updated} products',couldNotFetchProductOptions:'Could not fetch product options. Please contact support.'},catalogProdRewardsHints:{hint1:'Leer lassen, um den Standardwert aus den Einstellungen zu übernehmen',hint2:'Tippen Sie 0 ein, um das Treueprogramm nicht auf dieses Produkt anzuwenden',hint3:'Fügen Sie einen positiven Wert ein, um den Standardwert aus den Einstellungen zu überschreiben'},catalogCateg:{single:'Kategorie',plural:'Kategorien',color:'Culoare',name:'Name',image:'Bild',displayType:'Darstellungsansicht',shortDescription:'Kurzbeschreibung',validFromTo:'Gültig von - bis',areYouSure:'Sind Sie sicher, dass Sie diese Kategorie {label} möchten?',categAdded:'Kategorie erfolgreich hinzugefügt',categUpdated:'Kategorie erfolgreich aktualisiert',categDeleted:'Kategorie erfolgreich gelöscht',couldNotSave:'Kategoriebild konnte nicht gespeichert werden. Versuchen Sie es später erneut.',List:'Liste',Grid:'Raster',assignTopCategory:'Überkategorie hinzufügen',pleaseSelect:'Bitte auswählen / Nicht anwendbar',categoriesWithoutParent:'Kategorien ohne Überkategorie',topCategory:'Überkategorie',forceMethod:'Liefermethode notwendig',selectMethod:'Methode auswählen',enableMethod:'(um zu aktivieren, Überkategorie entfernen)',overrideSettingsHelp:'Wenn aktiviert, erscheint diese Kategorie im Menü nur für den ausgewählten Standort, die Lieferart, den Tag und das Zeitfenster.',schedule:'Zeitplan',useSchedule:'Zeitplan verwenden',scheduleActive:'Zeitplan aktiv',scheduleHelp:'Ein Zeitplan für diese Überkategorie in allen Standorten. Außerhalb dieser Zeiten ist die Bestellung aus dieser Kategorie in der App nicht verfügbar.'},catalogProdOpt:{single:'Option',plural:'Optionen',new:'Neue Option',name:'Name',type:'Typ',value:'Zutat',values:'Zutaten',posid:'POS ID',optionSaved:'Produktoptionen erfolgreich gespeichert.',areyouSure:'Möchten Sie diese Option wirklich löschen?',optLocationError:'Die Option {opt_name} muss an dem Standort {loc_name} verfügbar sein',menuQr:'QR-Menü',displayInMenu:'Anzeige im QR-Menü'},marketingCampaigns:{single:'Kampagne',plural:'Kampagnen',name:'Titel',nameHelper:'Dieser Titel wird als Betreff für versendete E-Mail Benachrichtigungen bezüglich dieser Kampagne verwendet.',image:'Bild',startEnd:'Start - Enddatum',daysLeft:'verbleibende Tage',timesUsed:'Anzahl der Verwendung',status:'Status',actions:'Aktionen',send:'Senden',in_queue:'To be sent',sent:'Total sent',notif_sent:'Notification',email_sent:'E-mail',areYouSureNotif:'Möchten Sie die Benachrichtigungen versenden?',notifSent:'Benachrichtigungen wurden versendet.',campaignDeleted:'Kampagne erfolgreich gelöscht.',areYouSureDelete:'Möchten Sie ... wirklich löschen?',campaignAdded:'Kampagne erfolgreich hinzugefügt',campaignUpdated:'Kampagne erfolgreich aktualisiert',campaignPhotoError:'Bild konnte nicht gespeichert werden. Versuchen Sie es später erneut.',campaignDetails:'Kampagnen Details',description:'Beschreibung',maxDescription:'(max. 400 Zeichen)',characters:'Zeichen',validFromTo:'Gültig von - bis',notif:'Benachrichtigungen',model:'Benachrichtigungsweise',setHours:'Stunden festlegen',selectTime:'Zeit auswählen',chooseTarget:'Zielgruppe auswählen',gender:'Geschlecht',age:'Alter',city:'Stadt',location:'Standort',visibleInLocations:'Sichtbar an folgenden Standorten',visibleInLocationsInfo:'Diese Funktionalität ist nur in der Anwendung verfügbar',ordersAbove:'Bestellungen über',ordersBelow:'Bestellungen unter',addCoupon:'Gutschein hinzufügen',applyTo:'Anwenden auf',value:'Prozent',code:'Code',addValue:'Kenndaten hinzufügen',minValue:'Minimale Menge',counter_max_usage:'Wie oft kann ein Kunde diesen Gutschein anwenden?',counter_max_usage_total:'Wie oft kann dieser Gutschein insgesamt angewendet werden?',counter_max_usage_example:'Geben Sie eine Zahl für die maximale Anwendung pro Person an. Geben Sie 0 für unbegrenzte Anwendung an.',counter_max_usage_total_example:'Geben Sie eine Zahl für die maximale gesamte Anwendung an. Geben Sie 0 für unbegrenzte Anwendung an.',generateCode:'Code generieren',Products:'Produkte',Shipping:'Lieferung',chooseCategProduct:'Wählen Sie Kategorien oder Produkte aus, auf die der Gutschein anwendbar ist:',delivery_methods:'Auf welche Liefermöglichkeiten soll dieser Gutschein angewendet werden?',order_source_ids:'Order sources',order_source_ids_all:'All sources',order_source_ids_help:'Leave empty to apply on all order sources.',location_ids:'An welchem Standort soll dieser Gutschein anwendbar sein?',sendNotificationTo:'Benachrichtigung senden an',campaignWasSent:'Kampagne wurde innerhalb der letzten 30 Minuten versendet',chooseDayForInterval:'Wähle Tag(e) für das Intervall',chooseHoursForInterval:'Wähle Zeiten für das Intervall',useInterval:'Nutze Intervall für wiederkehrenden Gutschein',isCumulativeCheck:'Dieser Gutschein wird kumulativ angewendet',isAutoApplyCheck:'Dieser Gutschein wird exklusiv angewendet',intervalMustBeSet:'Intervall muss festgelegt sein',isSecondUseCheck:'Dieser Gutschein gilt direkt nach der ersten Nutzung',groups:'Kundengruppen',freeProduct:'Gratisprodukt für den Warenkorb',freeProductPlaceholder:'Produkt auswählen',freeProductRequired:'Bitte ein Gratisprodukt auswählen'},marketingOffers:{single:'Angebotsbanner',plural:'Angebotsbanner',title:'Titel',status:'Status',image:'Bild',imageWeb:'Web-Bild',imageBanner:'Imagine Banner',imageLanding:'Imagine Landing',linkType:'Verknüpfung',startEndDate:'Start - Enddatum',actions:'Aktionen',offerAdded:'Angebotsbanner erfolgreich hinzugefügt.',offerUpdated:'Angebotsbanner erfolgreich aktualisiert.',offerDeleted:'Angebotsbanner erfolgreich gelöscht.',weCouldNot:'Das Foto konnte nicht hinzugefügt werden. Versuchen Sie es später erneut.',validImg:'Fügen Sie bitte ein gültiges Bild ein.',areYouSure:'Möchten Sie diesen Angebotsbanner {label}?',pageText:'Textseite',pickCateg:'Kategorie auswählen',pickProd:'Produkt auswählen',pickLoc:'Standort auswählen',none:'Keine',banners:'Banner',offers:'Bietet an',display:'Anzeige',addGroup:'Gruppe hinzufügen',offerSuccess:'Gruppenangebot erfolgreich hinzugefügt'},marketingOffersTypes:{category:'Kategorie',product:'Produkt',page:'Seite'},marketingFidelities:{fidelities:'Treueprogramm',loyalityPoint:'Treuepunkte',userLabeling:'Kundenstatus',name:'Name',ordersValue:'Bestellwert',ordersNumber:'Anzahl der Bestellungen',color:'Farbe',notification:'Benachrichtigung',coupon:'Gutschein',product:'Produkt',nameLabel:'Kundenstatus',addLabel:'Kundenstatus hinzufügen',noData:'Keine Daten',updateUserLabeling:'Kundenstatus aktualisiert',createdUserLabeling:'Kundenstatus erstellt',areYouSureDelete:'Möchten Sie diesen Kundenstatus wirklich löschen?',labelDeleted:'Kundenstatus gelöscht',orderNumberRequired:'Dieses Feld oder Anzahl der Bestellungen muss ausgefüllt sein',orderValueRequired:'Dieses Feld oder Bestellwert muss ausgefüllt sein',yes:'Ja',applyCupon:'Gutschein',applyproduct:'Produkt',badgeColor:'Statusfarbe',badgeName:'Kundenstatus',value:'Wert',number:'Anzahl',appliedForLastMonth:'Kundenstatus werden nur für Bestellungen der letzten 30 Tage angewendet',checkTermsAndConditionFidelities:'Überprüfen Sie das Treueprogramm auf der Infoseite',labelingPrimaryOption:'Wählen Sie die Primäroption für Kundenstatus',labelingSuccess:'Die Einstellungen für Kundenstatus wurden erfolgreich aktualisiert!',updatePrimaryOption:'Optionen aktualisieren',showLabelOnUser:'Kunden ihren Status anzeigen',infoAboutShowUserLabelUpdated:'Kunden ihren Status anzeigen wurde aktualisiert',labelingInterval:'Anwendbarkeitszeitraum auswählen','0':'Unbegrenzt','30':'30 Tage','60':'60 Tage','90':'90 Tage','120':'120 Tage',recurrence:'Wiederholung',noReccurence:'Keine',oneDay:'1 Tag',threeDays:'3 Tage',fiveDays:'5 Tage',sevenDays:'7 Tage',tenDays:'10 Tage',fifteenDays:'15 Tage',twentyDays:'20 Tage',twentyFiveDays:'25 Tage'},marketingPromos:{title:'Titel',treshold:'Schwelle n',category:'Kategorie',product:'Produkt',products:'Produkte',none:'Keiner',marketingPromos:'Aktion',generateQrCode:'QR-Code generieren',code:'',promoDeleted:'Promotion deleted',areYouSureDelete:'Are you sure you want to delete this promotion',promoAdded:'Werbeaktion erfolgreich hinzugefügt.',promoUpdated:'Werbeaktion erfolgreich aktualisiert.',weCouldNot:'Wir konnten die Daten nicht speichern, bitte versuchen Sie es später erneut.',startEndDate:'Start - Enddatum',image:'Bild',validImg:'Bitte fügen Sie ein gültiges Bild hinzu.',print:'Drucken',firstname:'Vorname',lastname:'Nachname',points:'Punkte',email:'Email',description:'Beschreibung'},reports:{orderedProducts:'Bestellte Produkte',giftCardsSoldTotal:'Total gift cards sold',giftCardsSoldAmount:'Gift cards sold',number:'Order nr',trends:'Trends',clients:'Kunden',products:'Produkte',marketing:'Marketing',today:'Heute',orderChart:'Bestellungen',clientsChart:'Kunden',completed:'Abgeschlossen',canceled:'Storniert',salesChart:'Verkäufe',salesIn:'Verkäufe in',customersChart:'Kunden',appInstalls:'App Installationen',custWithAcc:'Kunden mit Account',top10Chart:'Top 10 Produkte',top5Chart:'Top 5 Produkte',orderingChart:'Bestellarten',nrOfOrders:'Anzahl der Bestellungen',customersAge:'Alter der Kunden',customersGender:'Geschlecht der Kunden',name:'Name',appInstalled:'App installiert',gender:'Geschlecht',location:'Standort',partnerCode:'Partnercode',email:'E-Mail',phone:'Telefon',age:'Alter',filter:'Filter',label:'Kundenstatus',userDetails:'Kundendaten',salesDetails:'Verkaufsdaten',salesProductNr:'Anzahl der verkauften Produkte',totalAmount:'Gesamtmenge',totalProducts:'Produkte insgesamt',ordersNumber:'Bestellungen',minAmount:'Minimale Gesamtmenge',minOrders:'Minimale Anzahl an Bestellungen',maxOrders:'Maximale Anzahl an Bestellungen',itemsSold:'Verkaufte Produkte',campaign:'Kampagne',couponsTimesUsed:'Verwendungshäufigkeit der Gutscheine',revenue:'Umsatz',total:'Gesamt',paymentType:'Zahlungsart',date:'Datum',salesReport:'Verkaufsbericht',salesReportBeta:'Verkaufsbericht BETA',order:'Bestellung',export:'Exportieren',cash:'Bar',card:'Karte',pos:'POS',tips:'Trinkgeld',totalSum:'Gesamtbetrag',search:'Suche',searchFilter:'Suche (Name, E-Mail, Telefon)',discount:'Rabatt',tax:'Steuer',shipping:'Total Livrare',delivery_type:'Lieferart',zone:'Zone',totalDiscount:'Gesamtrabatt',ordersWithDiscount:'Bestellungen mit Rabatt',ordersWithFidelity:'Bestellungen mit Treue',totalFidelityDiscount:'Gesamt-Treuerabatt',totalTax:'Gesamtsteuern',avarageOrderValue:'Durchschnittlicher Bestellwert',clientsWOrders:'Kunden mit Bestellungen',emailSend:'Gesendete E-Mails der letzten 6 Monate',emailTotal:'Gesamte gesendete E-Mails: ',newCustomersChart:'Neue Kunden',productsSalesReport:'Produktverkaufsbericht',orderStatus:'Auftragsstatusbericht',pricePerUnit:'Preis pro Einheit',quantity:'Menge',productName:'Produktname',couponCode:'Coupon',checkOrder:'Reihenfolge verwenden',donationReport:'Spendenbericht'},feedback:{sigle:'Feedback',type:'Art',sentBy:'Gesendet von',text:'Text',seen:'Gelesen',sentAt:'Datum',search:'Suche',comment:'Kommentar'},feedbackTypes:{feedback:'Feedback',issue:'Problem',suggestion:'Vorschlag'},settings:{},blogPage:{categories:'Kategorien',categoriesHint:'Optional — Artikel können auch ohne Kategorie sein.',categoryName:'Kategoriename',noCategories:'Noch keine Kategorien.',articles:'Artikel',addArticle:'Artikel hinzufügen',editArticle:'Artikel bearbeiten',allCategories:'Alle Kategorien',noCategory:'Keine Kategorie',allStatuses:'Alle Status',searchByTitle:'Nach Titel suchen',noArticles:'Keine Artikel gefunden.',cover:'Titelbild',coverHint:'empfohlen 1200x630px, max. 5MB',imageAlt:'Alt-Text des Bildes (SEO)',title:'Titel',slug:'Artikel-Link (Slug)',slugHint:'Wird aus dem Titel erzeugt, wenn leer.',shortDescription:'Kurzbeschreibung (unter dem Titel)',content:'Inhalt',category:'Kategorie',author:'Autor',publishedAt:'Veröffentlichungsdatum',publishedAtHint:'Wenn leer, wird beim Veröffentlichen das aktuelle Datum verwendet.',status:'Status',published:'Veröffentlicht',draft:'Entwurf',scheduled:'Geplant',seo:'SEO',metaTitle:'Meta-Titel',metaDescription:'Meta-Beschreibung',metaKeywords:'Schlüsselwörter (durch Komma getrennt)',titleRequired:'Der Titel ist erforderlich.',deleteCategoryConfirm:'Kategorie "{name}" löschen? {count} Artikel bleiben ohne Kategorie.',deleteArticleConfirm:'Artikel "{name}" löschen?'},settingsPages:{homepageSections:'Startseiten-Abschnitte',interactiveTour:'Interaktive Tour',blog:'Blog',interactiveTourFirstLogin:'Interaktive Tour bei erster Anmeldung verwenden',interactiveTourAlways:'Interaktive Tour immer verwenden',interactiveTourDisplayMode:'Bildanzeigemodus',interactiveTourDisplayContain:'Contain',interactiveTourDisplayCover:'Cover',interactiveTourDisplayFullPage:'Ganze Seite',userSettings:'Benutzereinstellungen',myProfile:'Mein Profil',users:'Benutzer',general:'Allgemein',companyDetails:'Unternehmensdetails',dateTime:'Datum & Zeit',currency:'Währung',accounting:'Buchführung',tax:'Steuer',delivery_type:'Versandart',payment:'Zahlung',orderingMng:'Bestellmanagement',loyalty:'Treueprogramm',push:'Push-Benachrichtigungen',tips:'Trinkgeld',locationGroups:'Standort-Gruppen',locationGroupsName:'Name',locationGroupsDescription:'Beschreibung',locationGroupsPhoto:'Foto',locationGroupsAdded:'Neue Standort-Gruppe erfolgreich hinzugefügt',locationGroupsUpdated:'Standort-Gruppe erfolgreich aktualisiert',locationGroupsPicError:'Standort-Gruppe konnte nicht gespeichert werden. Versuchen Sie es später erneut.',locationGroupsDelete:'Standort-Gruppe löschen',locationGroupsAreYouSure:'Möchten Sie diese Standort-Gruppe wirklich löschen?',locationGroupsSelect:'Wählen Sie die zugehörige Standort-Gruppe:',subscription:'Abonnement',myPlan:'Mein Plan',infoPages:'Informationen',taxLabeling:'Steuerbezeichnung',deliveryMethods:'Standorte und Lieferarten',filters:'Filter',filterProducts:'Produkte filtern'},settingUsers:{single:'Benutzer',fn:'Vorname',ln:'Nachname',email:'E-Mail',username:'Benutzername',lang:'Sprache der Benutzeroberfläche',langMsg:'In dieser Sprache werden Sie die Benutzeroberfläche sehen.',avatar:'Avatar',role:'Rolle',locations:'Zugang zu Bestellungen der Standorte',locations_helptext:'Wichtig: Wenn kein Standort ausgewählt ist, hat der Benutzer Zugang zu allen Standorten.',resetPass:'Passwort zurücksetzen',password:'Passwort',pass:'Passwort',confPass:'Passwort bestätigen',userAdded:'Neuer Benutzer erfolgreich hinzugefügt',userUpdated:'Benutzer erfolgreich aktualisiert',userPicError:'Der Avatar konnte nicht gespeichert werden. Versuchen Sie es später erneut.',USER:'NUTZER',DRIVER:'FAHRER',LOCATION_ADMIN:'STANDORT ADMINISTRATOR',MARKETER:'VERMARKTER'},settingCompany:{title:'Unternehmen',location:'Standort',name:'Name',lang:'App-Sprache',bussLoc:'Unternehmensstandort',deliveryLabels:'Bezeichnung der Lieferarten',pick_up:'Abholung',meet_half:'Komm mir entgegen',delivery:'Lieferung',eat_location:'Tisch reservieren',self_ordering:'Self Ordering',phone:'Telefon',street:'Straße',number:'Nr.',latitude:'Breitengrad',longitude:'Längengrad',email:'E-Mail',city:'Stadt',country:'Land',state:'Bundesland',availableDaysHrs:'Öffnungszeiten',from:'von',to:'bis',preOrder:'Vorbestellung von',allowPreOrder:'Vorbestellung ermöglichen',cardPaymentDetails:'Einstellungen für die Kartenzahlung',paylikeKeys:'Bezeichnung bei Paylike',posDiscount:'POS ID für Rabatt',userTaxes:'Angewandte Steuern',noTaxMsg:'Info: Sie haben Änderungen an den Steuern vorgenommen, vergessen Sie nicht, diese zu speichern.',areYouSureDelete:'Möchten Sie diesen Standort wirklich löschen? Somit werden auch die Bestelleinstellungen des Standortes gelöscht.',pickLocationToCopy:'Wählen Sie einen Standort aus, von dem die Produkte kopiert werden sollen',areYouSureTax:'Möchten Sie diesen Steuertyp wirklich von der Steuerliste löschen? Vergessen Sie nicht, die Änderungen zu speichern!',companyUpdated:'Unternehmensdetails erfolgreich aktualisiert.',companyProdCopied:'Produkte erfolgreich kopiert.',wrongAddress:'Die Adresse von dem Standort "{location}" ist nicht korrekt.',deleteLocationValidation:'Dieser Standort wird verwendet. Er kann nicht gelöscht werden. Zuerst müssen die Verknüpfungen zu den Produkten entfernt werden.',email_feedback:'E-Mails um Feedback aus der App zu erhalten',email_feedback_helptext:'Sie können mehrere E-Mail Adressen hinterlegen, indem Sie diese durch Kommata trennen.',printSettings:'Drucker Einstellungen',automatPrintOrder:'Bestellung automatisch in A4 drucken',autoSendOrderToPrinter:'Bestellung automatisch mit 80 mm-Drucker drucken',autoPrintLocalServer:'Abschnittsbeleg automatisch vom lokalen Server drucken (neue oder in Bearbeitung befindliche Bestellungen)',printerIp:'Drucker IP/Host',printerPort:'Drucker Schnittstelle',copyProductsFrom:'Kopiere Produkte von ',overEighteen:'Nutzer unter 18 einschränken (notwendig, um Alkohol über die App zu verkaufen)',setRadiusArea:'Radius festlegen',setDrawArea:'Zeichenbereich festlegen',jump_to_menu:'Springe zum Menü',jump_to_categories_menu:'Ermöglicht direkten Zugang zum Menü in der App, ohne vorher die Liefermethode auszuwählen.',allow_fiscal_print:'Belegdruck zulassen',allowPlaceUntilCloseHour:'Ermöglicht das Aufgeben von Bestellungen bis zur Schließungszeit',sortProductsMethods:'Sortieren der Produkte',alphabetic_asc:'Nach Namen aufsteigend',alphabetic_desc:'Nach Namen absteigend',price:'Nach Preis',custom:'Benutzerdefiniert',infoCustomSort:'(benutzerdefinierte Sortierung wird in jeder Kategorieerstellung gemacht)',allowSoundAtStatusNew:'Ton für Bestellungen mit dem Status NEU',allowSoundAtStatusProcessing:'Ton für Bestellungen mit dem Status IN BEARBEITUNG',allowSoundAtStatusProcessingV1:'Ton bei Erreichen der voreingestellten Wartezeit',allowSoundAtStatusProcessingV2:'Ton bei Erreichen von 1/4 der voreingestellten Wartezeit',allowSoundAtStatusProcessingV3:'Ton bei Erreichen von 1/2 der voreingestellten Wartezeit',allowSoundAtStatusProcessingV0:'Kein Ton',allowToOrderUnderMinValueWithCoupon:'Ermöglicht Bestellungen unter dem Mindestbestellwert, wenn Gutschein verwendet wird',filters:'Filter',allowSoundForMehods:'Ermöglicht Ton für die folgenden Übermittlungsmethoden'},settingDateTime:{timezone:'Zeitzone',timeFormat:'Zeitformat',dateFormat:'Datumsformat',saveMsg:'Datums- & Zeiteinstellungen erfolgreich gespeichert'},settingCurrency:{currency:'Einkaufs-Währung',saveMsg:'Währungsdaten erfolgreich gespeichert'},settingTaxes:{single:'Steuer',name:'Name',type:'Typ',amount:'Betrag',notice:'Info: Unter "Steuerbezeichnung" erstellen Sie nur die Bezeichnung der angewandten Steuer. Um die Steuerdetails wie Steuerwert und -typ zu definieren, gehen Sie zu',notice2:'Unternehmensdetails',singleTaxLabel:'Steuerbezeichnung',notice3:'Info: Unter "Angewandte Steuern" definieren Sie die Steuerdetails wie Steuerwert und -typ. Um eine Steuerbezeichnung zu erstellen, gehen Sie zu',notice4:'Steuerbezeichnung'},settingsPayment:{publicKey:'Public key',privateKey:'Private key'},settingsOrdering:{offnoPreorders:'You must have offset 0 and period 1 to work',noPreorders:'We do not accept pre-orders',isAlwaysOpen:'Immer geöffnet',isAlwaysOpenPreorderHours:'Vorbestellstunden',infoBoxTitle:'Zusatzinformationen hinzufügen',infoBoxRadioCheck:'Optionen ändern',infoBoxRadio:'Nur eine Option zulässig',infoBoxCheck:'Mehrere Optionen zulässig',enabled:'Aktiviert',paymentOptions:'Zahlungsmöglichkeiten',paymentOptionsErr:'Das Feld Zahlungsmöglichkeiten muss ausgefüllt sein.',waitingTime:'Voraussichtliche Wartezeit',minimumOrderValue:'Mindestbestellwert',minutes:'Min',shippingCost:'Lieferkosten',deliveryRange:'Lieferradius',deliveryRangeUnit:'m',posId:'Lieferkosten POS ID',shippingTax:'Liefersteuer',locations:'Standorte',street:'Straße',city:'Stadt',country:'Land',state:'Bundesland',availableDays:'Öffnungszeiten',availableDaysErr:'Das Feld Öffnungszeiten muss ausgefüllt sein.',notice:'Überprüfen Sie bitte den Fehler bei den aktivierten Bestellmethoden und versuchen Sie das Speichern erneut',saveSuccess:'Bestelldetails erfolgreich gespeichert',deliveryRules:'Lieferdetails',addRange:'Lieferdetail hinzufügen',shippingCities:'Städte / Orte',shippingNeighborhoods:'Stadtteile',citiesValidationError:'Stellen Sie sicher, dass sich die Städte der einzelnen Lieferradien unterscheiden.',hourAndDate:'Uhrzeit und Datum',justDate:'Nur Datum',deactivateDeliveryHours:'Uhrzeit und Datum deaktivieren',offset:'Abweichung',period:'Periode',addZone:'Zone hinzufügen',newZone:'Neue Zone'},settingsZone:{edit:'Name der Zone',deleteBtn:'Zone löschen',deleteShape:'Form löschen, um eine neue zu erstellen',overridePayment:'Zahlungsmethode überschreiben',acceptCash:'Bargeld akzeptieren',acceptCard:'Karte akzeptieren',acceptPos:'POS bei Lieferung (unbezahlt)'},settingsInfoPages:{single:'Seite',noPage:'Noch keine Seite hinzugefügt.',title:'Titel der Seite',content:'Inhalt der Seite',newPage:'Neue Seite',showInHeader:'Im Header anzeigen',showInFooter:'Im Footer anzeigen',addedSuccess:'Seite erfolgreich gespeichert.',deletedSuccess:'Seite erfolgreich gelöscht',deleteMsg:'Möchten Sie diese Seite wirklich löschen?',TERMS_CONDITIONS:'Bedingungen und Konditionen',PRIVACY_POLICY:'Datenschutzerklärung',CONTACT_DETAILS:'Kontaktinformationen',FIDELITIES_PROMOTIONS:'Treueprogramm',CUSTOM:'Benutzerdefiniert'},settingsRewards:{single:'Punkt',plural:'Punkte',state:'Status',points:'Punkt(e)',moneySpent:'Ausgegebenes Geld in Punkten',pointsTo:'Punkte in Geld',numberOfcurrencyNeedToSpend:'Geldbetrag, den der Kunde zahlen muss, um einen Punkt zu erhalten.',numberOfpointsToReward:'Anzahl der Punkte, die der Kunde braucht, um damit zu bezahlen.',timeInterval:'Zeitfenster',fromTime:'Von Stunde',toTime:'Zur Stunde',rewardSuccess:'Daten des Treueprogramms erfolgreich gespeichert'},settingsPushNotif:{order_new:'Nachricht Neue Bestellung',order_completed_pickup:'Nachricht Bestellung zubereitet - Abholen',order_completed_meet:'Nachricht Bestellung zubereitet - Komm mir entgegen',order_completed_delivery:'Nachricht Bestellung zubereitet - Lieferung',order_completed_eat:'Nachricht Bestellung zubereitet - vor Ort',order_canceled:'Nachricht Bestellung storniert',notifUpdated:'Daten der Push-Benachrichtigung erfolgreich gespeichert',preview:'Vorschau',time:'Uhrzeit',dateTime:'Datum und Uhrzeit',persons:'Anzahl der Personen',timePrev:'11:30 Uhr (in 30 Minuten)',personsPrev:'3',dateTimePrev:'Dienstag, 15. Februar, 2022, um 18 Uhr',info:'* Falls die Lieferzeit nicht angezeigt werden soll, lassen Sie das letzte Feld frei.',selectedLocations:'Ausgewählte Standorte:'},settingsTips:{tipsTaxes:'Trinkgeld Steuer',state:'Trinkgeld akzeptieren',tipsSuccess:'Daten zum Trinkgeld erfolgreich gespeichert'},settingsPlans:{plan1Title:'Monatlicher Festbetrag',plan1Rate:'160€ / Monat',plan1Description:'Starten Sie mit einer festen monatlichen Gebühr, unabhängig von der Umsatzhöhe in der App.',plan2Title:'Prozentsatz der Verkäufe',plan2Rate:'10%',plan2Description:'Zahlen Sie abhängig davon, wie viel Sie verkaufen. Wählen Sie die Option Prozentsatz der Verkäufe und zahlen Sie eine monatliche Gebühr abhängig von der Umsatzhöhe in der App.',current:'Aktuelles Abonnement',switch:'Wechseln'},filter:{filter:'Filter',action:'Aktion',create:'Filter erstellt',update:'Filter aktualisiert',areYouSureDelete:'Möchten Sie diesen Filter wirklich löschen',yes:'Ja',deleted:'Filter gelöscht',noFilters:'Keine Filter',name:'Name',addFilter:'Filter hinzufügen',filters:'Filter',value:'Wert',filterProducts:'Produkte filtern',filterName:'Filtername',val:'Wert',filterUpdated:'Filter aktualisiert',minOneFilterValueRequired:'Mindestens ein Filterwert pro Filter benötigt',filterType:'Filtertyp',type_exists:'Filtertyp existiert bereits',filter_value_exists:'Filterwert existiert bereits',some_filter_applied:'Erfolgreich aktualisiert. Einige Filter oder Werte sind auf Produkte angewendet und können (nicht) gelöscht werden'},ordersSource:{1:'Kiosk',2:'Qr',3:'Pos',4:'App',5:'Website',6:'Glovo',7:'Wolt',8:'Bolt'},checkbox:'Ermöglicht, mehrere Optionen für das Produkt auszuwählen',radio:'Ermöglicht, nur eine Option für das Produkt auszuwählen'},__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_de___default.a)};/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),

/***/ "pfxT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementMyOrdersSuppliersAdd_vue__ = __webpack_require__("AGp5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afde80be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementMyOrdersSuppliersAdd_vue__ = __webpack_require__("j9UV");
function injectStyle (ssrContext) {
  __webpack_require__("JcV3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-afde80be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementMyOrdersSuppliersAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afde80be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementMyOrdersSuppliersAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pg+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-bon-product-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ph0e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t6_vue__ = __webpack_require__("iJg3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d4c986c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t6_vue__ = __webpack_require__("BdU3");
function injectStyle (ssrContext) {
  __webpack_require__("kdei")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d4c986c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t6_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d4c986c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t6_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "phjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2_dist_sweetalert2_css__);







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Pagination: __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a
    },
    created: function created() {
        var data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
        };
        this.getData(data);
    },
    data: function data() {
        return {
            groupsData: [],
            modelValidations: {
                title: {
                    required: true
                }
            },
            loading: true,
            pagerCount: 7,
            pendingRequests: [],
            oldPendingRequests: [],
            paginationDefPending: {
                page: null,
                totalPages: null,
                perPage: null,
                totalRecords: null,
                show: true
            },
            selectedStatus: { label: this.$t('general.pending'), value: 0 },
            statusOptions: [{ label: this.$t('general.pending'), value: 0 }, { label: this.$t('general.completed'), value: 1 }]
        };
    },

    methods: {
        fetchData: function fetchData() {
            if (!this.selectedStatus) {
                return;
            }

            this.loading = true;
            var data = {
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany'),
                isApproved: this.selectedStatus.value
            };
            this.getData(data);
        },
        getData: function getData(data) {
            var _this = this;

            this.apiRequest('/registration-approval', 'GET', data, function (response) {
                if (response.status) {
                    _this.pendingRequests = response.data.data;

                    _this.paginationDefPending.page = response.data.page;
                    _this.paginationDefPending.totalPages = response.data.totalPages;
                    _this.paginationDefPending.perPage = response.data.perPage;
                    _this.paginationDefPending.totalRecords = response.data.totalRecords;
                }
                _this.$nextTick(function () {
                    this.loading = false;
                });
            });
        },
        handleAccept: function handleAccept(id, accept) {
            var _this2 = this;

            var data = {
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany'),
                id: id,
                is_approved: accept
            };

            this.apiRequest('/registration-approval', 'PUT', data, function (response) {
                _this2.getData(data);
            });
        },
        handlePageChange: function handlePageChange(page) {
            var data = {
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany'),
                page: page,
                perPage: this.paginationDefPending.perPage
            };

            this.getData(data);
        }
    }
});

/***/ }),

/***/ "pipV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__);





















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a),
  props: {},
  created: function created() {
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      tableColumns: [{
        prop: 'type',
        label: this.$t('settingTable.type'),
        minWidth: 50
      }, {
        prop: 'location_name',
        label: this.$t('settingTable.location'),
        minWidth: 50
      }, {
        prop: 'section.name',
        label: this.$t('kds.name'),
        minWidth: 50
      }],
      modelData: []
    };
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {
      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/digital/signage/edit/');
      }
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        type: 3,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos/all/screens', 'GET', data, function (response) {
        if (response.status === true) {
          _this.modelData = response.data.screens;
          _this.$nextTick(function () {
            this.loading = false;
          });
        }
      });
    },
    goToAdd: function goToAdd() {
      this.$router.push('/digital/signage/add');
    },
    copyToClipboard: function copyToClipboard(url) {
      url = url.replace(/\s/g, '');
      this.$copyText(url);
    },
    deleteOrderScreen: function deleteOrderScreen(id) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.loadingReset = true;
      });
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/pos/screens/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          _this2.$nextTick(function () {
            _this2.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        } else {
          _this2.$nextTick(function () {
            _this2.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ 'text': _this2.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
        _this2.getData();
      });
    }
  }
});

/***/ }),

/***/ "plct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('test',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pmdb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__ = __webpack_require__("Ark/");








var _components;









var ORDER_SOURCE_LABELS = {
  0: 'unknown',
  1: 'kiosk',
  2: 'qr',
  3: 'pos',
  4: 'app',
  5: 'website',
  6: 'glovo',
  7: 'wolt',
  8: 'bolt'
};

var SALES_REPORT_PAYMENT_GROUPS = [{
  key: 'cash',
  labelKey: 'reports.totalCash',
  methods: ['CASH', 'GLOVO_CASH', 'BOLT_CASH', 'WOLT_CASH']
}, {
  key: 'online',
  labelKey: 'reports.totalOnline',
  methods: ['CARD', 'ONLINE']
}, {
  key: 'card',
  labelKey: 'reports.totalCard',
  methods: ['POS', 'CARD_POS', 'SPLIT']
}, {
  key: 'credit',
  labelKey: 'reports.totalCredit',
  methods: ['BOLT_CARD', 'GLOVO_CARD', 'WOLT_CARD']
}, {
  key: 'nonFiscal',
  labelKey: 'reports.totalNonFiscal',
  methods: ['PROTOCOL', 'MANCARE_PERSONAL', 'VIRAMENT', 'ROOM', 'EVENT', 'FOLIO']
}];

var SALES_REPORT_PAYMENT_METHODS = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a(SALES_REPORT_PAYMENT_GROUPS.reduce(function (acc, group) {
  return acc.concat(group.methods);
}, []));

var PAYMENT_METHOD_ALIASES = {
  online: 'ONLINE',
  glovo_cash: 'GLOVO_CASH',
  'glovo cash': 'GLOVO_CASH',
  glovo_card: 'GLOVO_CARD',
  'glovo card': 'GLOVO_CARD',
  glovo: 'GLOVO',
  bolt_cash: 'BOLT_CASH',
  'bolt cash': 'BOLT_CASH',
  bolt_card: 'BOLT_CARD',
  'bolt card': 'BOLT_CARD',
  bolt: 'BOLT',
  wolt_cash: 'WOLT_CASH',
  'wolt cash': 'WOLT_CASH',
  wolt_card: 'WOLT_CARD',
  'wolt card': 'WOLT_CARD',
  wolt: 'WOLT',
  card_pos: 'CARD_POS',
  cash_machine: 'CASH_MACHINE',
  pos_kiosk: 'POS_KIOSK',
  mancare_personal: 'MANCARE_PERSONAL',
  viva_intent: 'VIVA_INTENT'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */],
    SearchableMultiSelect: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isOrderFrom: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isOrderFrom: function isOrderFrom() {
      if (this.isOrderFrom) {
        this.getOrders();
        this.verifyUserLocations();
        this.verifyUserMethods();
      }
    }
  },
  computed: {
    hasReportTotals: function hasReportTotals() {
      return this.totalCounter > 0 || this.ordersTableData.total > 0;
    },
    orderSourceFilterOptions: function orderSourceFilterOptions() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(ORDER_SOURCE_LABELS).map(function (id) {
        return {
          value: String(id),
          label: _this.orderSourceLabel(ORDER_SOURCE_LABELS[id], id)
        };
      });
    },
    paymentMethodFilterGroups: function paymentMethodFilterGroups() {
      var _this2 = this;

      var buildOption = function buildOption(value) {
        return {
          value: value,
          label: value === '__unpaid__' ? _this2.$t('reports.unpaid') : _this2.paymentMethodLabel(value)
        };
      };

      var groups = SALES_REPORT_PAYMENT_GROUPS.map(function (group) {
        var seen = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a();
        var options = group.methods.map(function (method) {
          return _this2.normalizePaymentMethod(method);
        }).filter(function (value) {
          if (seen.has(value)) return false;
          seen.add(value);
          return true;
        }).map(buildOption);
        return { key: group.key, label: _this2.$t(group.labelKey), options: options };
      });

      groups.push({
        key: 'other',
        label: this.$t('reports.other'),
        options: [buildOption('__unpaid__')]
      });

      return groups;
    }
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      selectedCategories: [],
      selectedTopCategories: [],
      ordersTableData: {
        data: [],
        total: 0
      },
      filterOrderSource: '',
      filterPaymentMethod: '',
      totalAmount: 0,
      totalCounter: 0,
      fiscalTotal: 0,
      fiscalCounter: 0,
      nonFiscalTotal: 0,
      nonFiscalCounter: 0,
      topProductSales: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '500px',
          axisX: {
            scaleMinSpace: 50,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_10_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_10_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      colors: ['#f44336', '#2196f3', '#ff9800', '#9c27b0', '#00bcd4', '#8bc34a', '#ffc107', '#3f51b5', '#ff5722', '#795548', '#607d8b', '#009688', '#cddc39', '#673ab7', '#03a9f4', '#aed581', '#ffb74d', '#ba68c8'],
      noData: false
    };
  },

  methods: {
    parseReportNumber: function parseReportNumber(value) {
      var n = Number(value);
      return isNaN(n) ? 0 : n;
    },
    formatReportAmount: function formatReportAmount(value) {
      var amount = Number(this.parseReportNumber(value).toFixed(2));
      if (amount === 0) {
        var currency = this.getCurrencySymbol(this.getCompanyDetail('currency'));
        var position = this.getCurrencyPosition(this.getCompanyDetail('currency'));
        var formatted = '0.00';
        return position === 'left' ? currency + formatted : formatted + ' ' + currency;
      }
      return this.formatMoneyAmount(amount);
    },
    normalizePaymentMethod: function normalizePaymentMethod(method) {
      if (method == null || method === '' || method === 'unpaid') {
        return '__unpaid__';
      }
      var raw = String(method).trim();
      var lower = raw.toLowerCase();
      if (PAYMENT_METHOD_ALIASES[lower]) {
        return PAYMENT_METHOD_ALIASES[lower];
      }
      var upperUnderscore = raw.toUpperCase().replace(/\s+/g, '_');
      if (SALES_REPORT_PAYMENT_METHODS.has(upperUnderscore)) {
        return upperUnderscore;
      }
      if (SALES_REPORT_PAYMENT_METHODS.has(raw)) {
        return raw;
      }
      return upperUnderscore;
    },
    getPaymentMethodFilterValue: function getPaymentMethodFilterValue(method) {
      return this.normalizePaymentMethod(method);
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    buildReportRequestData: function buildReportRequestData() {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.filterOrderSource !== '') {
        data.order_source_id = this.filterOrderSource;
      }

      if (this.filterPaymentMethod !== '') {
        data.payment_method = this.filterPaymentMethod === '__unpaid__' ? 'unpaid' : this.filterPaymentMethod;
      }

      return data;
    },
    orderSourceLabel: function orderSourceLabel(label, orderSourceId) {
      var resolvedLabel = label || ORDER_SOURCE_LABELS[orderSourceId];
      if (!resolvedLabel) return '';
      var key = 'orderFrom.' + resolvedLabel;
      var translated = this.$t(key);
      if (translated !== key) return translated;
      var upperKey = 'orderFrom.' + String(resolvedLabel).toUpperCase();
      var upperTranslated = this.$t(upperKey);
      return upperTranslated !== upperKey ? upperTranslated : resolvedLabel;
    },
    paymentMethodLabel: function paymentMethodLabel(method) {
      var normalized = this.normalizePaymentMethod(method);
      if (normalized === '__unpaid__') {
        return this.$t('reports.unpaid');
      }
      var key = 'paymentTypes.' + normalized;
      var translated = this.$t(key);
      if (translated !== key) return translated;
      var upperKey = 'paymentTypes.' + String(normalized).toUpperCase();
      var upperTranslated = this.$t(upperKey);
      if (upperTranslated !== upperKey) return upperTranslated;
      if (normalized === 'GLOVO_CASH') return this.$t('reports.glovoCash');
      if (normalized === 'GLOVO_CARD') return this.$t('reports.glovoCard');
      if (normalized === 'BOLT_CASH') return this.$t('reports.boltCash');
      if (normalized === 'BOLT_CARD') return this.$t('reports.boltCard');
      if (normalized === 'WOLT_CASH') return this.$t('reports.woltCash');
      if (normalized === 'WOLT_CARD') return this.$t('reports.woltCard');
      return normalized;
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        console.log(allowedLocations);
        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this3 = this;

      if (!this.isOrderFrom) {
        return;
      }
      var data = this.buildReportRequestData();
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;

      this.loading = true;

      this.apiRequest('/reports/v2/order-from?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          var reportData = response.data || {};
          var tableRows = reportData.table_rows || [];
          var pagination = response.pagination || {};

          _this3.ordersTableData.data = tableRows;
          _this3.ordersTableData.total = pagination.total != null ? pagination.total : tableRows.length;
          _this3.paginationProps.currentPage = pagination.page || page;
          _this3.paginationProps.pageSize = pagination.perPage || pageSize;

          if (tableRows.length || pagination.total != null && pagination.total > 0) {
            _this3.totalAmount = reportData.total || 0;
            _this3.totalCounter = reportData.total_counter || 0;
            _this3.fiscalTotal = reportData.fiscal_total || 0;
            _this3.fiscalCounter = reportData.fiscal_counter || 0;
            _this3.nonFiscalTotal = reportData.non_fiscal_total || 0;
            _this3.nonFiscalCounter = reportData.non_fiscal_counter || 0;
          } else {
            _this3.ordersTableData.data = [];
            _this3.ordersTableData.total = 0;
            _this3.paginationProps.currentPage = 1;
            _this3.paginationProps.pageSize = pageSize;
            _this3.totalAmount = 0;
            _this3.totalCounter = 0;
            _this3.fiscalTotal = 0;
            _this3.fiscalCounter = 0;
            _this3.nonFiscalTotal = 0;
            _this3.nonFiscalCounter = 0;
          }

          _this3.topProductSales.options.chartPadding = {
            top: 30,
            right: 10,
            bottom: 20,
            left: 20
          };

          var sources = reportData.source || [];
          var sales = reportData.sales || [];

          if (!sources.length) {
            _this3.$nextTick(function () {
              _this3.topProductSales.data.labels = [];
              _this3.topProductSales.data.series = [[]];
              _this3.noData = true;

              if (_this3.$refs.topProductSales.chart) {
                _this3.$refs.topProductSales.initChartAndReturn();
              }

              return false;
            });
          }

          _this3.noData = false;
          _this3.topProductSales.data.labels = sources.map(function (element) {
            return _this3.orderSourceLabel(element);
          });
          _this3.topProductSales.data.series = [sales];

          _this3.$nextTick(function () {
            _this3.$refs.topProductSales.initChartAndReturn();

            if (_this3.$refs.topProductSales.chart) {
              _this3.$refs.topProductSales.chart.on('draw', function (data) {
                if (data.type === 'bar') {
                  data.element.attr({
                    style: 'stroke: ' + _this3.colors[data.index % _this3.colors.length] + '; stroke-width: 60px;'
                  });
                }
              });
            }
          });
        } else {
          _this3.ordersTableData.data = [];
          _this3.ordersTableData.total = 0;
          _this3.topProductSales.data.labels = [];
          _this3.topProductSales.data.series = [[]];
          _this3.noData = true;

          if (_this3.$refs.topProductSales.chart) {
            _this3.$refs.topProductSales.initChartAndReturn();
          }

          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this3.$t('validations.wentWrong'), 'error');
        }

        _this3.$nextTick(function () {
          _this3.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('DD-MM-YYYY') + '.xls';
    },
    exportData: function exportData() {
      var _this4 = this;

      var data = this.buildReportRequestData();

      this.loading = true;
      this.apiRequest('/reports/v2/order-from-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error');
        }
        _this4.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "ppKS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row categories"},[_c('div',{staticClass:"col-lg-12 col-md-10 col-sm-12 "},[_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-right",staticStyle:{"position":"relative","z-index":"2"}},[_c('router-link',{staticClass:"btn btn-info add mar-bt-20",attrs:{"title":"","to":{ path: 'menu-links/add'}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('menuLink.single'))+"\n            ")])],1)]),_vm._v(" "),_c('table',{ref:"sortableTable",staticClass:"table width-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"10%"}}),_vm._v(" "),_c('th',{attrs:{"width":"30%"}},[_vm._v(_vm._s(_vm.$t('menuLink.title')))]),_vm._v(" "),_c('th',{attrs:{"width":"50%"}},[_vm._v(_vm._s(_vm.$t('menuLink.alias')))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}})])]),_vm._v(" "),_c('draggable',{attrs:{"element":'tbody'},on:{"end":_vm.adjustSort},model:{value:(_vm.links),callback:function ($$v) {_vm.links=$$v},expression:"links"}},[_vm._l((_vm.links),function(item,index){return [_c('tr',{key:index.id,staticClass:"sortableRow",on:{"click":function($event){_vm.goToRecord(item,[],[], $event)}}},[_c('td',[_c('i',{staticClass:"fa fa-arrows sortHandle",staticStyle:{"cursor":"move"}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.alias)+" - "+_vm._s(_vm.$t('menuLink.' + item.alias)))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                  ")])])])]})],2)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "psqB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pvLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__("O5me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_wysiwyg_dist_vueWysiwyg_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__menuSubscriptionHelpers__ = __webpack_require__("VNNG");
























__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_time_select___default.a);

var MAX_IMAGE_MB = 5;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  props: {
    subscriptionId: {
      type: Number,
      default: null
    },

    section: {
      type: String,
      default: 'general'
    }
  },
  data: function data() {
    return {
      dayNames: __WEBPACK_IMPORTED_MODULE_19__menuSubscriptionHelpers__["a" /* DAY_NAMES */],

      editorOptions: {
        hideModules: { code: true, table: true, image: true }
      },
      pickerFrom: { start: '00:00', step: '00:15', end: '23:45' },
      pickerTo: { start: '00:15', step: '00:15', end: '24:00' },
      loading: false,
      loaded: false,
      saving: false,
      currency: '',
      maxStartDaysAhead: 10,
      locations: [],
      zones: [],

      savedPrice: null,
      menusCount: 0,
      form: {
        name: '',
        active: false,
        location_id: '',
        price_per_day: '',
        duration_days: 30,
        min_quantity: 1,
        max_quantity: 5,
        max_active_subscribers: '',
        description: '',
        imagelist: [],
        delivery_days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
        delivery_hours: [{ from: '12:00', to: '13:00' }],
        order_lead_minutes: 120,
        zones: []
      },
      errors: {}
    };
  },

  computed: {
    deliveryEstimate: function deliveryEstimate() {
      var days = parseInt(this.form.duration_days, 10);
      var delivery = this.form.delivery_days || [];
      if (!days || days < 1 || days > 366 || !delivery.length) {
        return '';
      }
      var min = null;
      var max = null;
      for (var start = 0; start < 7; start++) {
        var count = 0;
        for (var i = 0; i < days; i++) {
          if (delivery.indexOf(__WEBPACK_IMPORTED_MODULE_19__menuSubscriptionHelpers__["a" /* DAY_NAMES */][(start + i) % 7]) !== -1) {
            count++;
          }
        }
        min = min === null ? count : Math.min(min, count);
        max = max === null ? count : Math.max(max, count);
      }
      return min === max ? String(min) : min + '-' + max;
    },
    orderLeadHint: function orderLeadHint() {
      var minutes = parseInt(this.form.order_lead_minutes, 10) || 0;
      var first = this.form.delivery_hours.find(function (hour) {
        return hour.from;
      }) || { from: '12:00' };
      var parts = first.from.split(':');
      var total = parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10) - minutes;
      var dayBefore = false;
      while (total < 0) {
        total += 1440;
        dayBefore = true;
      }
      var time = String(Math.floor(total / 60)).padStart(2, '0') + ':' + String(total % 60).padStart(2, '0');
      return this.$t(dayBefore ? 'menuSubscriptions.orderLeadExampleDayBefore' : 'menuSubscriptions.orderLeadExample', { from: first.from, time: time });
    }
  },
  created: function created() {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso);

    this.locations = (this.$session.get('selectedCompanyData').locations_details || []).map(function (location) {
      return { id: location.token || location.id, name: location.name };
    });
    if (this.subscriptionId) {
      this.getSubscription();
    } else {
      if (this.locations.length === 1) {
        this.form.location_id = this.locations[0].id;
        this.getZones();
      }
      this.loaded = true;
    }
  },

  methods: {
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    getZones: function getZones() {
      var _this = this;

      if (!this.form.location_id) {
        this.zones = [];
        return;
      }
      this.apiRequest('/menu-subscription/zones', 'GET', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.requestData(), { location_id: this.form.location_id }), function (response) {
        if (response.status === true) {
          _this.zones = response.data || [];

          var ids = _this.zones.map(function (zone) {
            return zone.id;
          });
          _this.form.zones = _this.form.zones.filter(function (zone) {
            return ids.indexOf(zone.delivery_range_id) !== -1;
          });
        }
      });
    },
    onLocationChange: function onLocationChange() {
      this.getZones();
    },
    getSubscription: function getSubscription() {
      var _this2 = this;

      this.loading = true;
      this.apiRequest('/menu-subscription/' + this.subscriptionId, 'GET', this.requestData(), function (response) {
        _this2.loading = false;
        if (!(response.status === true && response.data)) {
          __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', _this2.firstError(response), 'error').catch(function () {});
          return;
        }
        _this2.fillForm(response.data);
        _this2.$emit('loaded', response.data);
        _this2.getZones();
        _this2.loaded = true;
      });
    },
    fillForm: function fillForm(data) {
      this.savedPrice = data.price_per_day;
      this.menusCount = data.menus_count || 0;
      this.maxStartDaysAhead = data.max_start_days_ahead || 10;
      this.form = {
        name: data.name || '',
        active: !!data.active,
        location_id: data.location_token || '',
        price_per_day: data.price_per_day,
        duration_days: data.duration_days,
        min_quantity: data.min_quantity,
        max_quantity: data.max_quantity,
        max_active_subscribers: data.max_active_subscribers || '',
        description: data.description || '',
        imagelist: data.image_filename ? [{ url: data.image_url, name: data.image_filename, filename: data.image_filename }] : [],
        delivery_days: (data.delivery_days || []).slice(),
        delivery_hours: (data.delivery_hours || []).map(function (hour) {
          return { from: hour.from, to: hour.to };
        }),
        order_lead_minutes: data.order_lead_minutes,
        zones: (data.zones || []).map(function (zone) {
          return {
            delivery_range_id: zone.delivery_range_id,
            delivery_fee: zone.delivery_fee === null ? '' : zone.delivery_fee
          };
        })
      };
    },
    addHour: function addHour() {
      var last = this.form.delivery_hours[this.form.delivery_hours.length - 1];
      this.form.delivery_hours.push(last ? { from: last.to === '24:00' ? '' : last.to, to: '' } : { from: '12:00', to: '13:00' });
    },
    isZoneSelected: function isZoneSelected(id) {
      return !!this.selectedZone(id);
    },
    selectedZone: function selectedZone(id) {
      return this.form.zones.find(function (zone) {
        return zone.delivery_range_id === id;
      });
    },
    toggleZone: function toggleZone(zone) {
      var index = this.form.zones.findIndex(function (item) {
        return item.delivery_range_id === zone.id;
      });
      if (index === -1) {
        this.form.zones.push({ delivery_range_id: zone.id, delivery_fee: '' });
      } else {
        this.form.zones.splice(index, 1);
      }
    },
    handleImageChange: function handleImageChange(file, fileList) {
      if (file.size && file.size / 1024 / 1024 > MAX_IMAGE_MB) {
        __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ toast: true, type: 'warning', text: this.$t('validations.pictureSizeExceed'), position: 'top-end', showConfirmButton: false, timer: 3000 }).catch(function () {});
        this.form.imagelist = fileList.filter(function (f) {
          return f.uid !== file.uid;
        }).slice(-1);
        return;
      }
      this.form.imagelist = fileList.slice(-1);
    },
    handleImageRemove: function handleImageRemove() {
      this.form.imagelist = [];
    },
    handleExceed: function handleExceed() {
      __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', this.$t('validations.pictureSizeExceed'), 'warning').catch(function () {});
    },
    collectImage: function collectImage() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var f;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                f = _this3.form.imagelist && _this3.form.imagelist[0];

                if (f) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', '');

              case 3:
                if (!f.raw) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', _this3.getBase64(f.raw));

              case 5:
                return _context.abrupt('return', f.filename || '');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    validate: function validate() {
      var errors = {};
      if (!(this.form.name || '').trim()) {
        errors.name = this.$t('menuSubscriptions.nameRequired');
      }
      if (!this.form.location_id) {
        errors.location_id = this.$t('menuSubscriptions.locationRequired');
      }
      var price = parseFloat(this.form.price_per_day);
      if (this.form.price_per_day === '' || isNaN(price) || price < 0) {
        errors.price_per_day = this.$t('menuSubscriptions.priceRequired');
      }
      if (this.form.delivery_hours.some(function (hour) {
        return !hour.from || !hour.to || hour.from >= hour.to;
      })) {
        errors.delivery_hours = this.$t('menuSubscriptions.hoursInvalid');
      }
      this.errors = errors;
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors).length) {
        var generalKeys = ['name', 'location_id', 'price_per_day'];
        __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', this.$t('menuSubscriptions.fixErrors') + ' (' + (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors).some(function (key) {
          return generalKeys.indexOf(key) !== -1;
        }) ? this.$t('menuSubscriptions.tabGeneral') : this.$t('menuSubscriptions.tabDelivery')) + ')', 'warning').catch(function () {});
        return false;
      }
      return true;
    },
    save: function save() {
      var _this4 = this;

      if (!this.validate()) {
        return;
      }
      var priceChanged = this.subscriptionId && this.menusCount > 0 && Math.round(parseFloat(this.form.price_per_day) * 100) !== Math.round(parseFloat(this.savedPrice) * 100);
      if (!priceChanged) {
        this.send(false);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({
        title: '',
        text: this.$t('menuSubscriptions.rescaleQuestion', { count: this.menusCount, price: this.form.price_per_day + ' ' + this.currency }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('menuSubscriptions.rescaleYes'),
        cancelButtonText: this.$t('menuSubscriptions.rescaleNo')
      }).then(function () {
        _this4.send(true);
      }).catch(function (dismiss) {
        if (dismiss === 'cancel') {
          _this4.send(false);
        }
      });
    },
    send: function send(rescale) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var image, data, created, url;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.saving = true;
                image = void 0;
                _context2.prev = 2;
                _context2.next = 5;
                return _this5.collectImage();

              case 5:
                image = _context2.sent;
                _context2.next = 13;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](2);

                _this5.saving = false;
                __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', _this5.$t('validations.wentWrong'), 'error').catch(function () {});
                return _context2.abrupt('return');

              case 13:
                data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this5.requestData(), {
                  name: _this5.form.name,
                  location_id: _this5.form.location_id,
                  price_per_day: _this5.form.price_per_day,
                  duration_days: String(_this5.form.duration_days),
                  min_quantity: String(_this5.form.min_quantity),
                  max_quantity: String(_this5.form.max_quantity),
                  max_active_subscribers: _this5.form.max_active_subscribers === '' || _this5.form.max_active_subscribers === null ? '' : String(_this5.form.max_active_subscribers),
                  description: _this5.form.description,
                  image: image,
                  delivery_days: _this5.form.delivery_days,
                  delivery_hours: _this5.form.delivery_hours,
                  order_lead_minutes: String(_this5.form.order_lead_minutes),
                  zones: _this5.form.zones.map(function (zone) {
                    return {
                      delivery_range_id: zone.delivery_range_id,
                      delivery_fee: zone.delivery_fee === '' || zone.delivery_fee === null ? null : zone.delivery_fee
                    };
                  })
                });

                if (_this5.subscriptionId) {
                  data.active = _this5.form.active ? 1 : 0;
                  data.rescale_menus = rescale ? 1 : 0;
                }

                created = !_this5.subscriptionId;
                url = created ? '/menu-subscription' : '/menu-subscription/' + _this5.subscriptionId;

                _this5.apiRequest(url, created ? 'POST' : 'PUT', data, function (response) {
                  _this5.saving = false;
                  if (response.status === true && response.data) {
                    _this5.errors = {};
                    _this5.fillForm(response.data);
                    __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()({ title: '', text: _this5.$t('menuSubscriptions.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).catch(function () {});
                    _this5.$emit('saved', response.data, created);
                    return;
                  }
                  var errors = response.errors || {};
                  var normalized = {};
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors).forEach(function (key) {
                    normalized[key] = Array.isArray(errors[key]) ? errors[key][0] : errors[key];
                  });
                  _this5.errors = normalized;
                  __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default()('', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(normalized).join(' ') || _this5.$t('validations.wentWrong'), 'error').catch(function () {});
                });

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[2, 8]]);
      }))();
    },
    firstError: function firstError(response) {
      var errors = response && response.errors || {};
      var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors)[0];
      if (!key) {
        return this.$t('validations.wentWrong');
      }
      return Array.isArray(errors[key]) ? errors[key][0] : errors[key];
    }
  }
});

/***/ }),

/***/ "pvPl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":function($event){_vm.model=_vm.label}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pxe/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationScheduleEditor_vue__ = __webpack_require__("111K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed76a5d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationScheduleEditor_vue__ = __webpack_require__("276U");
function injectStyle (ssrContext) {
  __webpack_require__("Jlsm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ed76a5d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationScheduleEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed76a5d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationScheduleEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pzYo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pznp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderingManagement_vue__ = __webpack_require__("eh/v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dec7fce4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderingManagement_vue__ = __webpack_require__("ApCQ");
function injectStyle (ssrContext) {
  __webpack_require__("7hXV")
  __webpack_require__("fl6c")
  __webpack_require__("846y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dec7fce4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderingManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dec7fce4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderingManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q0FD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderView_vue__ = __webpack_require__("KheQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d17aac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderView_vue__ = __webpack_require__("Tzjk");
function injectStyle (ssrContext) {
  __webpack_require__("6nV6")
  __webpack_require__("8A7+")
  __webpack_require__("YzgZ")
  __webpack_require__("6Yrw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d17aac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q7Nh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q98Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementEntries_vue__ = __webpack_require__("WNrK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5161eeae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementEntries_vue__ = __webpack_require__("kRTJ");
function injectStyle (ssrContext) {
  __webpack_require__("IRf1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5161eeae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementEntries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5161eeae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementEntries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qAvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-circle-chart",attrs:{"data-background-color":_vm.color}},[_c('div',{staticClass:"card-header text-center"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{ref:"chart",staticClass:"chart-circle",attrs:{"data-percent":_vm.percentage}},[_vm._v(_vm._s(_vm.percentage)+"%")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qAw5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group searchable-multi-select"},[_c('label',[_vm._v(_vm._s(_vm.$t(_vm.label)))]),_vm._v(" "),_c('el-select',{ref:"select",staticClass:"searchable-multi-select__control",attrs:{"value-key":"id","multiple":"","filterable":"","remote":"","collapse-tags":_vm.collapseTags,"reserve-keyword":"","placeholder":_vm.placeholder || _vm.$t('reports.searchProducts'),"remote-method":_vm.searchItems,"loading":_vm.loading},on:{"change":_vm.clearSearch,"visible-change":_vm.onVisibleChange},model:{value:(_vm.selectedItems),callback:function ($$v) {_vm.selectedItems=$$v},expression:"selectedItems"}},_vm._l((_vm.mergedItems),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label || item.name,"value":item}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qBXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'id': 1,
  'name': 'Noelia O\'Kon',
  'email': 'otho.smitham@example.com',
  'age': 39,
  'gender': 'female',
  'location': 'Oradea',
  'sales': 654,
  'phone': '+44 745 000 111',
  'active': true
}, {
  'id': 2,
  'name': 'Mr. Enid Von PhD',
  'nickname': 'alias',
  'email': 'pollich.cecilia@example.com',
  'sales': '35978.00',
  'age': 26,
  'gender': 'male',
  'currency': 'lei',
  'phone': '+44 745 000 111',
  'active': false
}, {
  'id': 3,
  'name': 'Colton Koch',
  'nickname': 'customer_id',
  'email': 'little.myrna@example.net',
  'sales': '26278.00',
  'age': 48,
  'gender': 'male',
  'currency': 'lei',
  'phone': '+44 745 000 111',
  'active': false
}, {
  'id': 4,
  'name': 'Gregory Vandervort',
  'nickname': 'vel',
  'email': 'dock47@example.org',
  'sales': '25537.00',
  'gender': 'male',
  'age': 27,
  'currency': 'lei',
  'phone': '+44 745 000 111',
  'active': true
}, {
  'customer_id': 5,
  'name': 'Miss Rahsaan Heaney IV',
  'nickname': 'qui',
  'email': 'ugrady@example.org',
  'salary': '49003.00',
  'age': 21
}, {
  'customer_id': 6,
  'name': 'Ms. Crystel Zemlak IV',
  'nickname': 'reiciendis',
  'email': 'amari.rau@example.com',
  'salary': '12383.00',
  'age': 48
}, {
  'customer_id': 7,
  'name': 'Nona McDermott',
  'nickname': 'quaerat',
  'email': 'adrien.baumbach@example.org',
  'salary': '18512.00',
  'age': 31
}, {
  'customer_id': 8,
  'name': 'Miss Genoveva Murazik V',
  'nickname': 'rerum',
  'email': 'ohettinger@example.net',
  'salary': '31209.00',
  'age': 28
}, {
  'customer_id': 9,
  'name': 'Beulah Huels',
  'nickname': 'non',
  'email': 'stefan99@example.com',
  'salary': '36920.00',
  'age': 53
}, {
  'customer_id': 10,
  'name': 'Zoe Klein',
  'nickname': 'ex',
  'email': 'ejacobson@example.org',
  'salary': '35616.00',
  'age': 27
}, {
  'customer_id': 11,
  'name': 'Vickie Kiehn',
  'nickname': 'assumenda',
  'email': 'ayost@example.com',
  'salary': '30790.00',
  'age': 29
}, {
  'customer_id': 12,
  'name': 'Elwyn Herzog',
  'nickname': 'praesentium',
  'email': 'ckassulke@example.net',
  'salary': '35785.00',
  'age': 27
}, {
  'customer_id': 13,
  'name': 'Selena Hettinger',
  'nickname': 'et',
  'email': 'bashirian.hyman@example.net',
  'salary': '31836.00',
  'age': 35
}, {
  'customer_id': 14,
  'name': 'Edwin Beier',
  'nickname': 'eos',
  'email': 'janis71@example.org',
  'salary': '11902.00',
  'age': 38
}, {
  'customer_id': 15,
  'name': 'Lexi Braun MD',
  'nickname': 'autem',
  'email': 'dusty74@example.net',
  'salary': '11927.00',
  'age': 45
}, {
  'customer_id': 16,
  'name': 'Jovany Spencer',
  'nickname': 'fugit',
  'email': 'gbogisich@example.org',
  'salary': '44686.00',
  'age': 43
}, {
  'customer_id': 17,
  'name': 'Prof. Maci Anderson DVM',
  'nickname': 'dolorem',
  'email': 'btorp@example.com',
  'salary': '25055.00',
  'age': 29
}, {
  'customer_id': 18,
  'name': 'Joel Kulas MD',
  'nickname': 'sed',
  'email': 'phoebe.sauer@example.org',
  'salary': '11650.00',
  'age': 24
}, {
  'customer_id': 19,
  'name': 'Mr. Dawson Greenholt',
  'nickname': 'nostrum',
  'email': 'asawayn@example.org',
  'salary': '46962.00',
  'age': 53
}, {
  'customer_id': 20,
  'name': 'Prof. Lloyd Green',
  'nickname': 'velit',
  'email': 'laila.hintz@example.org',
  'salary': '12928.00',
  'age': 46
}, {
  'customer_id': 21,
  'name': 'Shayna Morar',
  'nickname': 'rerum',
  'email': 'wfay@example.org',
  'salary': '22638.00',
  'age': 26
}, {
  'customer_id': 22,
  'name': 'Krista Schulist',
  'nickname': 'qui',
  'email': 'gregoria.jakubowski@example.com',
  'salary': '49345.00',
  'age': 42
}, {
  'customer_id': 23,
  'name': 'Leone Lemke',
  'nickname': 'repellat',
  'email': 'ltorphy@example.com',
  'salary': '17560.00',
  'age': 42
}, {
  'customer_id': 24,
  'name': 'Dr. Willie Kemmer II',
  'nickname': 'quasi',
  'email': 'ivy51@example.net',
  'salary': '35370.00',
  'age': 30
}, {
  'customer_id': 25,
  'name': 'Deonte Lebsack',
  'nickname': 'nesciunt',
  'email': 'alisa83@example.net',
  'salary': '32725.00',
  'age': 24
}, {
  'customer_id': 26,
  'name': 'Prof. Shayne Nader',
  'nickname': 'voluptas',
  'email': 'bosco.shaina@example.net',
  'salary': '9844.00',
  'age': 23
}, {
  'customer_id': 27,
  'name': 'Prof. Kennith Kertzmann',
  'nickname': 'alias',
  'email': 'satterfield.jonathan@example.com',
  'salary': '41950.00',
  'age': 25
}, {
  'customer_id': 28,
  'name': 'Miss Meagan O\'Keefe',
  'nickname': 'corporis',
  'email': 'tracy.barrows@example.com',
  'salary': '41803.00',
  'age': 50
}, {
  'customer_id': 29,
  'name': 'Prof. Edward Pagac MD',
  'nickname': 'quia',
  'email': 'gerhard65@example.org',
  'salary': '22896.00',
  'age': 43
}, {
  'customer_id': 30,
  'name': 'Samantha Weissnat',
  'nickname': 'est',
  'email': 'crystel66@example.net',
  'salary': '18805.00',
  'age': 43
}, {
  'customer_id': 31,
  'name': 'Dr. Gilbert Ward',
  'nickname': 'dolorum',
  'email': 'sandrine06@example.net',
  'salary': '16644.00',
  'age': 32
}, {
  'customer_id': 32,
  'name': 'Mike West',
  'nickname': 'laudantium',
  'email': 'jborer@example.net',
  'salary': '35728.00',
  'age': 42
}, {
  'customer_id': 33,
  'name': 'Prof. Isabell Cruickshank I',
  'nickname': 'recusandae',
  'email': 'ondricka.lurline@example.org',
  'salary': '44574.00',
  'age': 35
}, {
  'customer_id': 34,
  'name': 'Prof. Lonny Rath',
  'nickname': 'nihil',
  'email': 'rfeest@example.net',
  'salary': '19949.00',
  'age': 48
}, {
  'customer_id': 35,
  'name': 'Santina Medhurst MD',
  'nickname': 'suscipit',
  'email': 'ila24@example.net',
  'salary': '36323.00',
  'age': 51
}, {
  'customer_id': 36,
  'name': 'Jeff Lehner',
  'nickname': 'quo',
  'email': 'jarred77@example.com',
  'salary': '48462.00',
  'age': 42
}, {
  'customer_id': 37,
  'name': 'Samanta Pfeffer',
  'nickname': 'officia',
  'email': 'fgoyette@example.net',
  'salary': '19601.00',
  'age': 42
}, {
  'customer_id': 38,
  'name': 'Ofelia Torp',
  'nickname': 'a',
  'email': 'ericka44@example.net',
  'salary': '33149.00',
  'age': 35
}, {
  'customer_id': 39,
  'name': 'Mrs. Margarete Raynor',
  'nickname': 'quia',
  'email': 'jlegros@example.net',
  'salary': '21951.00',
  'age': 40
}, {
  'customer_id': 40,
  'name': 'Mr. Brant Howell V',
  'nickname': 'perspiciatis',
  'email': 'franecki.gerald@example.org',
  'salary': '41552.00',
  'age': 53
}, {
  'customer_id': 41,
  'name': 'Reilly Ruecker DVM',
  'nickname': 'ad',
  'email': 'ldeckow@example.net',
  'salary': '22709.00',
  'age': 42
}, {
  'customer_id': 42,
  'name': 'Zachery McDermott',
  'nickname': 'molestiae',
  'email': 'gladyce84@example.com',
  'salary': '32354.00',
  'age': 25
}, {
  'customer_id': 43,
  'name': 'Heloise Kulas',
  'nickname': 'aut',
  'email': 'kessler.helen@example.net',
  'salary': '45086.00',
  'age': 54
}, {
  'customer_id': 44,
  'name': 'Norma Dibbert',
  'nickname': 'amet',
  'email': 'eudora36@example.net',
  'salary': '15661.00',
  'age': 46
}, {
  'customer_id': 45,
  'name': 'Immanuel Auer',
  'nickname': 'quia',
  'email': 'halvorson.theodora@example.org',
  'salary': '15862.00',
  'age': 39
}, {
  'customer_id': 46,
  'name': 'Lamont Borer',
  'nickname': 'expedita',
  'email': 'trantow.neoma@example.com',
  'salary': '12544.00',
  'age': 25
}, {
  'customer_id': 47,
  'name': 'Brooke Purdy',
  'nickname': 'cupiditate',
  'email': 'bhermiston@example.net',
  'salary': '14457.00',
  'age': 50
}, {
  'customer_id': 48,
  'name': 'Dr. Leo Dach',
  'nickname': 'et',
  'email': 'camila.ward@example.com',
  'salary': '40278.00',
  'age': 49
}, {
  'customer_id': 49,
  'name': 'Krystal Langosh',
  'nickname': 'voluptatum',
  'email': 'pacocha.yesenia@example.org',
  'salary': '9305.00',
  'age': 34
}, {
  'customer_id': 50,
  'name': 'Florence Greenfelder',
  'nickname': 'odit',
  'email': 'kenyatta.oconnell@example.com',
  'salary': '36980.00',
  'age': 38
}]);

/***/ }),

/***/ "qBgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('aside',{staticClass:"a"},[_c('div',{staticClass:"brand"},[_c('div',{staticClass:"logo"},[_vm._v("!")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('newsletterCard.titleNews')))])]),_vm._v(" "),_c('nav',{staticClass:"nav-section"},[_c('h4',[_vm._v(_vm._s(_vm.$t('pages.categories')))]),_vm._v(" "),_c('ul',{staticClass:"nav-list"},[_c('li',{staticClass:"nav-item"},[_c('button',{staticClass:"category-btn",class:{ active: _vm.selectedCategory === null },on:{"click":function($event){_vm.selectCategory(null)}}},[_c('span',{staticClass:"cat-name"},[_vm._v(_vm._s(_vm.$t('newsletterCard.allArticles')))]),_vm._v(" "),_c('span',{staticClass:"cat-count"},[_vm._v(_vm._s(_vm.posts.length))])])]),_vm._v(" "),_vm._l((_vm.rootCategories),function(cat){return _c('li',{key:cat.id,staticClass:"nav-item"},[_c('button',{staticClass:"category-btn",class:{ active: _vm.selectedCategory === cat.id },on:{"click":function($event){_vm.selectCategory(cat.id)}}},[_c('span',{staticClass:"cat-name"},[_vm._v(_vm._s(cat.name))]),_vm._v(" "),_c('span',{staticClass:"cat-count"},[_vm._v(_vm._s(_vm.getCategoryCount(cat.id)))])]),_vm._v(" "),(_vm.getChildren(cat.id).length)?_c('ul',{staticClass:"sub-nav"},_vm._l((_vm.getChildren(cat.id)),function(child){return _c('li',{key:child.id},[_c('button',{staticClass:"subcategory-btn",class:{ active: _vm.selectedCategory === child.id },on:{"click":function($event){$event.stopPropagation();_vm.selectCategory(child.id)}}},[_vm._v("\n                "+_vm._s(child.name)+"\n              ")])])})):_vm._e()])})],2)]),_vm._v(" "),_c('div',{staticClass:"sidebar-footer"},[_c('p',[_vm._v("© "+_vm._s(_vm.currentYear)+" TapTasty")])])]),_vm._v(" "),_c('main',{staticClass:"main-content"},[(!_vm.selectedPost)?_c('div',{staticClass:"list-view"},[_c('header',{staticClass:"page-header"},[_c('div',{staticClass:"header-content"},[_c('h1',[_vm._v(_vm._s(_vm.currentCategoryName))]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.filteredPosts.length)+" "+_vm._s(_vm.$t('newsletterCard.articleFound')))])]),_vm._v(" "),_c('div',{staticClass:"header-actions"},[_c('div',{staticClass:"search-box"},[_c('div',{staticClass:"search-inner"},[_c('svg',{staticClass:"search-icon",attrs:{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor"}},[_c('circle',{attrs:{"cx":"11","cy":"11","r":"8"}}),_vm._v(" "),_c('path',{attrs:{"d":"m21 21-4.35-4.35"}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],attrs:{"type":"text","placeholder":_vm.$t('newsletterCard.searchArticle')},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"articles-grid"},_vm._l((_vm.filteredPosts),function(post){return _c('article',{key:post.id,staticClass:"article-card",on:{"click":function($event){_vm.openPost(post)}}},[_c('div',{staticClass:"card-image-wrapper"},[_c('img',{attrs:{"src":post.featured_image,"alt":_vm.getTitle(post)}}),_vm._v(" "),_c('div',{staticClass:"card-overlay"},[_c('span',{staticClass:"read-more"},[_vm._v(_vm._s(_vm.$t('newsletterCard.readArticle')))])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"card-meta"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatDate(post.date)))]),_vm._v(" "),_c('span',{staticClass:"dot"},[_vm._v("•")]),_vm._v(" "),_c('span',{staticClass:"read-time"},[_vm._v("5 min read")])]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.getTitle(post)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.getExcerpt(post)))])])])}))]):_c('article',{staticClass:"detail-view"},[_c('button',{staticClass:"back-btn",on:{"click":function($event){_vm.selectedPost = null}}},[_c('svg',{attrs:{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","width":"16","height":"16"}},[_c('path',{attrs:{"d":"M19 12H5M12 19l-7-7 7-7"}})]),_vm._v("\n        Back to articles\n      ")]),_vm._v(" "),_c('header',{staticClass:"article-header"},[_c('h1',[_vm._v(_vm._s(_vm.getTitle(_vm.selectedPost)))]),_vm._v(" "),_c('div',{staticClass:"article-meta"},[_c('span',{staticClass:"published"},[_vm._v("Published "+_vm._s(_vm.formatDate(_vm.selectedPost.date)))]),_vm._v(" "),_c('span',{staticClass:"separator"},[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"author"},[_vm._v("By TapTasty Team")])])]),_vm._v(" "),(_vm.selectedPost.featured_image)?_c('img',{staticClass:"hero-image",attrs:{"src":_vm.selectedPost.featured_image,"alt":_vm.getTitle(_vm.selectedPost)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"article-body",domProps:{"innerHTML":_vm._s(_vm.getContent(_vm.selectedPost))}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qE+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loyalty-store-campaign-form"},[_c('div',{staticClass:"category-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[(_vm.campaignId)?_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",on:{"click":function($event){$event.preventDefault();return _vm.handleDelete($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.delete'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",attrs:{"type":"button","disabled":_vm.loading || _vm.rewardSaving},on:{"click":function($event){$event.preventDefault();return _vm.save($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('loyaltyStore.generalSettings')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('loyaltyStore.campaignName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('loyaltyStore.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}}),_vm._v(" "),_c('label',{staticClass:"mar-lt-10"},[_vm._v(_vm._s(_vm.$t('loyaltyStore.active')))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('loyaltyStore.availability')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy"},model:{value:(_vm.availabilityRange),callback:function ($$v) {_vm.availabilityRange=$$v},expression:"availabilityRange"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('loyaltyStore.locations')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.locations,"placeholder":_vm.$t('general.all'),"label":"name"},model:{value:(_vm.locationsFormatted),callback:function ($$v) {_vm.locationsFormatted=$$v},expression:"locationsFormatted"}}),_vm._v(" "),_c('small',[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$t('loyaltyStore.locationsInfo')))])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"display-flex",staticStyle:{"justify-content":"space-between","align-items":"center"}},[_c('h5',{staticClass:"mar-bt-0"},[_vm._v(_vm._s(_vm.$t('loyaltyStore.rewards')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm",attrs:{"type":"button","disabled":_vm.loading || _vm.rewardSaving},on:{"click":function($event){_vm.openRewardForm()}}},[_vm._v("\n          "+_vm._s(_vm.$t('loyaltyStore.addReward'))+"\n        ")])]),_vm._v(" "),_c('el-table',{ref:"rewardsTable",staticClass:"loyalty-store-rewards-table",staticStyle:{"width":"100%","margin-top":"15px"},attrs:{"data":_vm.rewards,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","prop":"id","label":_vm.$t('customers.id'),"min-width":70},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.id || '—'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","label":_vm.$t('loyaltyStore.reward'),"min-width":180},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(props.row.name || props.row.reward_name || (props.row.product && props.row.product.name) || ('#' + props.row.id))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","label":_vm.$t('loyaltyStore.rewardType'),"min-width":110},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.rewardTypeLabel(props.row))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","label":_vm.$t('loyaltyStore.pointsCost'),"min-width":150},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(props.row.loyalty_points_cost)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","label":_vm.$t('loyaltyStore.giftCardValue'),"min-width":140},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.isGiftReward(props.row))?_c('span',[_vm._v(_vm._s(props.row.gift_card_value))]):_c('span',[_vm._v("—")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","label":_vm.$t('loyaltyStore.active'),"min-width":90},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n            "+_vm._s(props.row.active ? _vm.$t('general.yes') : _vm.$t('general.no'))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","align":"center","header-align":"center","label":_vm.$t('marketingCampaigns.actions'),"width":100},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.openRewardForm(props.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.edit'))+"\n                ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.deleteReward(props.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")])],1)],1)]}}])})],1)],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.editingReward ? _vm.$t('loyaltyStore.editReward') : _vm.$t('loyaltyStore.addReward'),"visible":_vm.rewardDialogVisible,"width":"520px","append-to-body":"","modal-append-to-body":true,"z-index":100000,"custom-class":"loyalty-store-reward-dialog"},on:{"update:visible":function($event){_vm.rewardDialogVisible=$event}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('loyaltyStore.rewardType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.rewardForm.type),expression:"rewardForm.type"}],staticClass:"form-control",attrs:{"disabled":!!(_vm.editingReward && _vm.editingReward.id)},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.rewardForm, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":1}},[_vm._v(_vm._s(_vm.$t('loyaltyStore.typeProduct')))]),_vm._v(" "),_c('option',{attrs:{"disabled":!_vm.giftCardsEnabled},domProps:{"value":2}},[_vm._v(_vm._s(_vm.$t('loyaltyStore.typeGiftCard')))])]),_vm._v(" "),(!_vm.giftCardsEnabled)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('loyaltyStore.giftCardsModuleRequired')))]):_vm._e()]),_vm._v(" "),(_vm.rewardForm.type === 1)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('loyaltyStore.category')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","remote-method":_vm.searchCategories,"loading":_vm.categoriesLoading,"placeholder":_vm.$t('loyaltyStore.searchCategory')},on:{"visible-change":_vm.onCategoryDropdown,"change":_vm.onCategoryChange},model:{value:(_vm.rewardForm.category_id),callback:function ($$v) {_vm.$set(_vm.rewardForm, "category_id", $$v)},expression:"rewardForm.category_id"}},_vm._l((_vm.categoryOptions),function(c){return _c('el-option',{key:c.id,attrs:{"label":c.name || c.label,"value":c.id}})}))],1):_vm._e(),_vm._v(" "),(_vm.rewardForm.type === 1)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('loyaltyStore.product')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","remote-method":_vm.searchProducts,"loading":_vm.productsLoading,"placeholder":_vm.$t('loyaltyStore.searchProduct')},on:{"visible-change":_vm.onProductDropdown},model:{value:(_vm.rewardForm.catalogproduct_id),callback:function ($$v) {_vm.$set(_vm.rewardForm, "catalogproduct_id", $$v)},expression:"rewardForm.catalogproduct_id"}},_vm._l((_vm.productOptions),function(p){return _c('el-option',{key:p.id,attrs:{"label":p.name + (p.price != null ? ' (' + p.price + ')' : ''),"value":p.id}})}))],1):_vm._e(),_vm._v(" "),(_vm.rewardForm.type === 2)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('loyaltyStore.giftCardValue')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.rewardForm.gift_card_value),expression:"rewardForm.gift_card_value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0.01","step":"0.01"},domProps:{"value":(_vm.rewardForm.gift_card_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rewardForm, "gift_card_value", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('loyaltyStore.pointsCost')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.rewardForm.loyalty_points_cost),expression:"rewardForm.loyalty_points_cost",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","step":"1"},domProps:{"value":(_vm.rewardForm.loyalty_points_cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rewardForm, "loyalty_points_cost", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.rewardForm.active),callback:function ($$v) {_vm.$set(_vm.rewardForm, "active", $$v)},expression:"rewardForm.active"}}),_vm._v(" "),_c('label',{staticClass:"mar-lt-10"},[_vm._v(_vm._s(_vm.$t('loyaltyStore.active')))])],1),_vm._v(" "),_c('span',{staticClass:"loyalty-store-reward-dialog__footer",attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.rewardDialogVisible = false}}},[_vm._v(_vm._s(_vm.$t('general.cancel') || 'Cancel'))]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"button","disabled":_vm.rewardSaving},on:{"click":_vm.saveReward}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qGiE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qJAE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomersView_vue__ = __webpack_require__("HuGI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f70ff0d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomersView_vue__ = __webpack_require__("JB2j");
function injectStyle (ssrContext) {
  __webpack_require__("7bzV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f70ff0d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomersView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f70ff0d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomersView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qLp7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountingReport_vue__ = __webpack_require__("znbb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d536d5e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountingReport_vue__ = __webpack_require__("/pMg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountingReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d536d5e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountingReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qOx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pad-to-15"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"buttonAdd row"},[_c('div',{staticClass:"pull-left"},[_c('div',{staticClass:"search-filter",staticStyle:{"display":"flex","align-items":"center","gap":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",staticStyle:{"width":"300px"},attrs:{"type":"text","placeholder":_vm.$t('customers.searchPlaceholder') || 'Caută după nume, telefon sau email...'},domProps:{"value":(_vm.searchQuery)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSearch($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('general.search')},on:{"click":_vm.handleSearch}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),(_vm.searchQuery)?_c('button',{staticClass:"btn btn-icon btn-default",attrs:{"title":_vm.$t('general.clear')},on:{"click":_vm.clearSearch}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-icon add",attrs:{"title":_vm.$t('customers.addGroup')},on:{"click":function($event){_vm.$modal.show('groupModal')}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('customers.addGroup'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"group-container"},[(!_vm.groupsData.length)?_c('div',{staticClass:"no_group"},[_c('span',[_vm._v(_vm._s(_vm.$t('general.noData') || 'No data.'))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.groupsData),function(item,idx){return _c('div',{key:item.id,staticClass:"group"},[_c('span',{staticStyle:{"display":"flex","align-items":"center","gap":"10px"},attrs:{"title":_vm.$t('general.edit')},on:{"dblclick":function($event){_vm.handleEdit(idx, true)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!item.visibility),expression:"!item.visibility"}]},[_vm._v(_vm._s(item.name))]),_vm._v(" "),(item.members_require_approval)?_c('span',{staticClass:"approval-badge",attrs:{"title":_vm.$t('customers.membersRequireApproval')}},[_c('img',{staticStyle:{"width":"16px","height":"16px","opacity":"0.7"},attrs:{"src":"/static/img/icons/icon-warning.png"}})]):_c('span',{staticClass:"no-approval-badge",attrs:{"title":_vm.$t('customers.noApprovalRequired')}},[_c('i',{staticClass:"fa fa-check-circle",staticStyle:{"color":"#28a745","font-size":"16px"}})]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(item.visibility),expression:"item.visibility"}],ref:"text_items",refInFor:true,staticClass:"edit_input",staticStyle:{"flex":"1"},attrs:{"type":"text","autofocus":""},domProps:{"value":item.name},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onEnter(idx)},"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.handleEdit(idx, false)}}}),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(item.visibility),expression:"item.visibility"}],staticClass:"checkbox-label",staticStyle:{"display":"flex","align-items":"center","cursor":"pointer","font-size":"13px","margin-left":"10px","white-space":"nowrap"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.members_require_approval),expression:"item.members_require_approval"}],staticStyle:{"margin-right":"5px"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.members_require_approval)?_vm._i(item.members_require_approval,null)>-1:(item.members_require_approval)},on:{"change":function($event){var $$a=item.members_require_approval,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "members_require_approval", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "members_require_approval", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "members_require_approval", $$c)}}}}),_vm._v("\n                  "+_vm._s(_vm.$t('customers.membersRequireApproval'))+"\n                ")])]),_vm._v(" "),_c('span',[_c('router-link',{staticClass:"btn btn-icon add",attrs:{"to":{ path: '/groups/' + item.id},"title":_vm.$t('general.add') + ' ' + _vm.$t('settingsPages.users').toLowerCase()}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('general.add'))+" "+_vm._s(_vm.$t('settingsPages.users'))+"\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-icon delete",on:{"click":function($event){_vm.handleDelete(idx, item)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('general.delete'))+"\n                ")])],1)])})],2)])])])]),_vm._v(" "),_c('vmodal',{staticClass:"groupModal",attrs:{"name":"groupModal","height":"auto","width":"900"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('customers.addGroup')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"group_name"}},[_vm._v(_vm._s(_vm.$t('marketingOffers.title')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.title),expression:"modelValidations.title"},{name:"model",rawName:"v-model",value:(_vm.group.title),expression:"group.title"}],staticClass:"form-control",attrs:{"type":"text","id":"title","name":"title"},domProps:{"value":(_vm.group.title)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.validate($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.group, "title", $event.target.value)}}})]),_vm._v(" "),(_vm.errors.has('title'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('title'))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"15px"}},[_c('label',{staticClass:"checkbox-label",staticStyle:{"display":"flex","align-items":"center","cursor":"pointer","font-weight":"normal"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.group.members_require_approval),expression:"group.members_require_approval"}],staticStyle:{"margin-right":"8px","width":"18px","height":"18px","cursor":"pointer"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.group.members_require_approval)?_vm._i(_vm.group.members_require_approval,null)>-1:(_vm.group.members_require_approval)},on:{"change":function($event){var $$a=_vm.group.members_require_approval,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.group, "members_require_approval", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.group, "members_require_approval", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.group, "members_require_approval", $$c)}}}}),_vm._v("\n                      "+_vm._s(_vm.$t('customers.membersRequireApproval'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":_vm.validate}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qPUq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qPfg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__ = __webpack_require__("Bef2");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntegrationMenuValidationCollapse',
  props: {
    groups: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onEditEntry: {
      type: Function,
      default: null
    }
  },
  methods: {
    groupTitle: function groupTitle(group) {
      var count = this.groupEntries(group).length;
      return group.label + ' (' + count + ')';
    },
    groupEntries: function groupEntries(group) {
      var _this = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Integrations_integrationMenuValidationHelpers_js__["j" /* getMenuValidationGroupEntries */])(group, function (key) {
        return _this.$t(key);
      });
    },
    onEditClick: function onEditClick(editTarget) {
      if (typeof this.onEditEntry === 'function') {
        this.onEditEntry(editTarget);
      }
    }
  }
});

/***/ }),

/***/ "qPiD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qQIF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qQTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_col_css__ = __webpack_require__("jZDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_col_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_col_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_col__ = __webpack_require__("91Nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_sweetalert2_dist_sweetalert2_css__);




























__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_col___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Pagination_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_18_vuedraggable___default.a
  },
  data: function data() {
    return {
      pages: [],
      loading: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_vee_validate__["b" /* mapFields */])(['title', 'description'])),
  created: function created() {
    this.getData();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    getData: function getData() {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        sort_order: 'asc'
      };
      var self = this;
      this.apiRequest('/settings/infopages', 'GET', data, function (response) {
        if (response.status === true) {
          self.pages = response.data;
          self.loading = false;
        }
      });
    },
    goToRecord: function goToRecord(row, event, column) {
      this.globalGoToRecord(row, event, column, '/custom-info-pages/edit/');
    },
    adjustSort: function adjustSort(evt) {
      var _this = this;

      if (this.pages.length > 1) {
        var idx = evt.newIndex;
        var after, before, sortOrder;

        if (idx === 0) {
          before = 0;
          after = this.pages[idx + 1].sort_order;
        } else if (idx + 1 === this.pages.length) {
          before = this.pages[idx - 1].sort_order;
          after = parseFloat(before) + 1;
        } else {
          before = this.pages[idx - 1].sort_order;
          after = this.pages[idx + 1].sort_order;
        }

        sortOrder = (parseFloat(before) + parseFloat(after)) / 2;
        var id = this.pages[idx].id;

        var data = {
          id: id,
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: sortOrder
        };
        this.apiRequest('/settings/infopages/' + id, 'PUT', data, function (response) {
          if (response.status !== true) {
            __WEBPACK_IMPORTED_MODULE_21_sweetalert2___default()({
              title: '',
              text: _this.$t('validations.dataCouldNotBeSaved'),
              type: 'danger',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "qQeu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qRa1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      tableData: [],
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      companyID: null,
      vatNumber: null,
      selectedLocation: null,
      searchDate: null,
      selectedTipVanzare: null,
      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            var start = new Date();
            start.setDate(end.getDate() - 6);
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            var start = new Date();
            start.setDate(end.getDate() - 29);
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      }
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    paymentMethods: function paymentMethods() {
      return [{ value: 'CASH', label: 'CASH' }, { value: 'CARD_POS', label: 'CARD POS' }, { value: 'bon_fiscal', label: 'BON FISCAL' }, { value: 'PROTOCOL', label: 'PROTOCOL' }, { value: 'VIRAMENT', label: 'VIRAMENT' }, { value: 'MANACARE_PERSONAL', label: 'STAFF FOOD' }, { value: 'ROOM', label: 'ROOM' }, { value: 'EVENT', label: 'EVENT' }, { value: 'FOLIO', label: 'FOLIO' }, { value: 'SPLIT', label: 'SPLIT' }, { value: 'ONLINE', label: 'ONLINE' }, { value: 'GLOVO_CARD', label: 'GLOVO CARD' }, { value: 'GLOVO_CASH', label: 'GLOVO CASH' }, { value: 'WOLT_CARD', label: 'WOLT CARD' }, { value: 'BOLT_CARD', label: 'BOLT CARD' }];
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },

  methods: {
    onSearch: function onSearch() {
      this.currentPage = 1;

      this.fetchBonsFiscale(this.selectedLocation, this.currentPage, this.pageSize);
    },
    goToOrder: function goToOrder(row) {
      if (row && row.externalOrderId) {
        this.$router.push('/orders/view/' + row.externalOrderId);
      }
    },
    goToBonFiscal: function goToBonFiscal(row) {
      if (row && row._id) {
        this.$router.push({
          name: 'ManagementBonFiscalView',
          params: { id: row._id }
        });
      }
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.fetchBonsFiscale(this.selectedLocation, this.currentPage, this.pageSize);
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (!cellValue) return '';

      var date = new Date(cellValue);

      return date.toLocaleString('ro-RO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    fetchBonsFiscale: function fetchBonsFiscale() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var startDate, endDate, today, isoDate, params, ids, allLocations, _ids, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, id, response, result;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!location || Array.isArray(location) && location.length === 0)) {
                  _context.next = 5;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  type: 'warning',
                  title: _this.$t('general.required'),
                  text: 'Selectați cel puțin o locație',
                  confirmButtonText: 'OK'
                });

                _this.tableData = [];
                _this.totalItems = 0;

                return _context.abrupt('return');

              case 5:
                if (!(!_this.searchDate || _this.searchDate.length !== 2)) {
                  _context.next = 10;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                  type: 'warning',
                  title: _this.$t('general.required'),
                  text: 'Selectați un interval de dată și oră pentru căutare',
                  confirmButtonText: 'OK'
                });

                _this.tableData = [];
                _this.totalItems = 0;

                return _context.abrupt('return');

              case 10:
                _context.prev = 10;
                startDate = void 0, endDate = void 0;


                if (_this.searchDate && _this.searchDate.length === 2) {
                  startDate = new Date(_this.searchDate[0]).toISOString();
                  endDate = new Date(_this.searchDate[1]).toISOString();
                } else {
                  today = new Date();
                  isoDate = today.toISOString().split('T')[0];

                  startDate = isoDate + 'T00:00:00Z';
                  endDate = isoDate + 'T23:59:59Z';
                }

                params = new URLSearchParams({
                  externalCompanyId: _this.companyID,
                  startDate: startDate,
                  endDate: endDate
                });

                if (!location) {
                  _context.next = 18;
                  break;
                }

                if (Array.isArray(location)) {
                  ids = location.map(function (l) {
                    return l.true_id;
                  }).filter(Boolean);

                  ids.forEach(function (id) {
                    return params.append('externalLocationId', id);
                  });
                } else if (location.id && location.true_id) {
                  params.append('externalLocationId', location.true_id);
                }
                _context.next = 39;
                break;

              case 18:
                allLocations = _this.groupedLocations.flatMap(function (group) {
                  return group.locations;
                });
                _ids = allLocations.map(function (l) {
                  return l.true_id;
                }).filter(Boolean);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 23;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_ids); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  id = _step.value;

                  params.append('externalLocationId', encodeURIComponent(id));
                }
                _context.next = 31;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context['catch'](23);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 31:
                _context.prev = 31;
                _context.prev = 32;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 34:
                _context.prev = 34;

                if (!_didIteratorError) {
                  _context.next = 37;
                  break;
                }

                throw _iteratorError;

              case 37:
                return _context.finish(34);

              case 38:
                return _context.finish(31);

              case 39:

                params.append('page', page);
                params.append('limit', pageSize);

                if (_this.selectedTipVanzare) {
                  params.append('tip_vanzare', _this.selectedTipVanzare);
                }
                clearTimeout(_this.loadingTimeout);
                _this.loadingTimeout = setTimeout(function () {
                  _this.loading = true;
                }, 100);
                _context.next = 46;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/bons_fiscale?' + params.toString(), {
                  method: 'GET'
                });

              case 46:
                response = _context.sent;
                _context.next = 49;
                return response.json();

              case 49:
                result = _context.sent;

                clearTimeout(_this.loadingTimeout);
                _this.loading = false;
                _this.totalItems = result.total || 0;
                _this.currentPage = result.currentPage || page;
                _this.pageSize = result.pageSize || pageSize;

                _this.tableData = Array.isArray(result.bons_fiscale) ? result.bons_fiscale.map(function (bon) {
                  try {
                    if (bon.raw_data && typeof bon.raw_data === 'string') {
                      bon.rawDataParsed = JSON.parse(bon.raw_data);
                    }
                  } catch (e) {
                    console.warn('❗ Eroare la decodare/parsing raw_data:', e);
                    bon.rawDataParsed = {};
                  }

                  bon.source = bon.source;
                  return bon;
                }) : [];
                _context.next = 61;
                break;

              case 58:
                _context.prev = 58;
                _context.t1 = _context['catch'](10);

                console.error('❌ Eroare la fetch bons fiscale:', _context.t1);

              case 61:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[10, 58], [23, 27, 31, 39], [32,, 34, 38]]);
      }))();
    },
    formatTipVanzare: function formatTipVanzare(row, column, cellValue) {
      if (!cellValue) return '';

      return cellValue.toLowerCase().split('_').map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join(' ');
    }
  }
});

/***/ }),

/***/ "qSga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate",class:_vm.switchClass},[_c('div',{staticClass:"bootstrap-switch-container",on:{"click":function($event){_vm.triggerToggle()}}},[_c('span',{staticClass:"bootstrap-switch-handle-on ",class:("bootstrap-switch-" + _vm.type)},[_vm._t("on",[_vm._v("\n          "+_vm._s(_vm.onText)+"\n      ")])],2),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-label"}),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-handle-off bootstrap-switch-default"},[_vm._t("off",[_vm._v("\n          "+_vm._s(_vm.offText)+"\n      ")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qU3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"filters-applied-row"},[_c('el-button',{staticStyle:{"margin-right":"10px"},attrs:{"type":"primary","size":"small"},on:{"click":_vm.openFiltersModal}},[_vm._v("\n            "+_vm._s(_vm.$t('orders.filters'))+"\n          ")]),_vm._v(" "),(_vm.appliedFilters.length)?[_c('span',{staticClass:"filters-applied-label"},[_vm._v(_vm._s(_vm.$t('orders.filtersList'))+":")]),_vm._v(" "),_vm._l((_vm.appliedFilters),function(flt,idx){return _c('span',{key:'pos-order-actions-filter-' + idx,staticClass:"filter-selection"},[_vm._v("\n              "+_vm._s(flt)+"\n            ")])}),_vm._v(" "),_c('a',{staticClass:"reset-filters-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.resetFilters()}}},[_vm._v(_vm._s(_vm.$t('orders.resetFilters')))])]:[_c('span',{staticClass:"filters-applied-label"},[_vm._v(_vm._s(_vm.$t('orders.noFiltersApplied')))])]],2)])]),_vm._v(" "),_c('vmodal',{staticClass:"filtersAndSortModal sales-report-filters",attrs:{"name":"posOrderActionsFiltersModal","height":"auto","width":"1200","adaptive":true,"scrollable":true}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header slim-header"},[_c('h4',[_vm._v(_vm._s(_vm.$t('orders.filters')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body slim-body"},[_c('div',{staticClass:"filters-grid sales-report-filters-grid"},[_c('div',{staticClass:"modal-column-left"},[(_vm.locations.length)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select'),"multiple":"","collapse-tags":"","clearable":"","filterable":""},model:{value:(_vm.modalSelectedLocationIds),callback:function ($$v) {_vm.modalSelectedLocationIds=$$v},expression:"modalSelectedLocationIds"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:loc.true_id,attrs:{"label":loc.name,"value":loc.true_id}})}))],1):_vm._e(),_vm._v(" "),(_vm.tableMaps.length)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingTable.maps')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.search'),"multiple":"","filterable":"","collapse-tags":"","clearable":""},model:{value:(_vm.modalSelectedTableMapIds),callback:function ($$v) {_vm.modalSelectedTableMapIds=$$v},expression:"modalSelectedTableMapIds"}},_vm._l((_vm.tableMaps),function(m){return _c('el-option',{key:m.id,attrs:{"label":m.name || ('ID ' + m.id),"value":m.id}})}))],1):_vm._e(),_vm._v(" "),(_vm.zones.length)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingTable.zone')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select'),"multiple":"","collapse-tags":"","clearable":"","filterable":""},model:{value:(_vm.modalSelectedZoneIds),callback:function ($$v) {_vm.modalSelectedZoneIds=$$v},expression:"modalSelectedZoneIds"}},_vm._l((_vm.zones),function(z){return _c('el-option',{key:z.id,attrs:{"label":z.name,"value":z.id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.tables')))]),_vm._v(" "),_c('el-select',{ref:"tableSelect",staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"value-key":"id","filterable":"","remote":"","reserve-keyword":"","clearable":"","placeholder":_vm.$t('settingTable.searchTable'),"remote-method":_vm.searchTables,"loading":_vm.loadingTables},on:{"change":_vm.clearSearch},model:{value:(_vm.modalSelectedTable),callback:function ($$v) {_vm.modalSelectedTable=$$v},expression:"modalSelectedTable"}},_vm._l((_vm.mergedTables),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"modal-column-right"},[_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('general.orderId')))]),_vm._v(" "),_c('el-input',{staticClass:"w-100",attrs:{"type":"number","min":"0","placeholder":"3823231"},model:{value:(_vm.modalSelectedOrderId),callback:function ($$v) {_vm.modalSelectedOrderId=$$v},expression:"modalSelectedOrderId"}})],1),_vm._v(" "),(_vm.posUsers.length)?_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('reports.operator')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.alls'),"filterable":"","clearable":""},model:{value:(_vm.modalSelectedPosUser),callback:function ($$v) {_vm.modalSelectedPosUser=$$v},expression:"modalSelectedPosUser"}},_vm._l((_vm.posUsers),function(operator){return _c('el-option',{key:operator.id,attrs:{"label":operator.firstname + ' ' + operator.lastname,"value":operator.id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('orders.status')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.all'),"clearable":"","filterable":""},model:{value:(_vm.modalSelectedStatus),callback:function ($$v) {_vm.modalSelectedStatus=$$v},expression:"modalSelectedStatus"}},[_c('el-option',{attrs:{"value":null,"label":_vm.$t('general.all')}}),_vm._v(" "),_vm._l((_vm.orderStatusOptions),function(st){return _c('el-option',{key:'pos-order-actions-status-' + st,attrs:{"value":st,"label":_vm.$t('ordersStatus.' + st)}})})],2)],1),_vm._v(" "),_c('div',{staticClass:"filter-section"},[_c('h6',[_vm._v(_vm._s(_vm.$t('general.action')))]),_vm._v(" "),_c('el-select',{staticClass:"w-100",staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.all'),"clearable":"","filterable":""},model:{value:(_vm.modalSelectedActionType),callback:function ($$v) {_vm.modalSelectedActionType=$$v},expression:"modalSelectedActionType"}},[_c('el-option',{attrs:{"value":null,"label":_vm.$t('general.all')}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('reports.posOrderActionTypes.openOrder')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('reports.posOrderActionTypes.markProduct')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('reports.posOrderActionTypes.preNote')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('reports.posOrderActionTypes.closeOrder')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('reports.posOrderActionTypes.storno')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('reports.posOrderActionTypes.transferOut')}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":_vm.$t('reports.posOrderActionTypes.transferIn')}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer slim-footer"},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.resetModalFilters}},[_vm._v(_vm._s(_vm.$t('general.reset')))]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.applyFilters}},[_vm._v(_vm._s(_vm.$t('general.apply')))])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"10px","align-items":"center"}},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"8px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])])],1)]),_vm._v(" "),(_vm.period && _vm.period.length === 2)?_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v("\n        "+_vm._s(_vm.$t('reports.interval'))+":\n        "),_c('b',[_vm._v(_vm._s(_vm.period[0])+" "+_vm._s(_vm.valid_from))]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.period[1])+" "+_vm._s(_vm.valid_to))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns",staticStyle:{"width":"100%"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"reportsTable",attrs:{"data":_vm.rows,"total":_vm.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged,"sort-change":_vm.handleSortChange,"row-click":_vm.goToOrder}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"id","label":_vm.$t('reports.orderId'),"min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":140,"label":_vm.$t('reports.orderSeriesNumber')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatOrderSeriesNumber(props.row))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"label":_vm.$t('reports.location')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.orderLocationName(props.row))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":140,"label":_vm.$t('reports.posDeviceName')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.posDeviceName(props.row.pos_id))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","label":_vm.$t('settingTable.zone'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s((props.row.table_data && props.row.table_data.zone) ? props.row.table_data.zone : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","label":_vm.$t('reports.tableNumber'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s((props.row.table_data && props.row.table_data.number) ? props.row.table_data.number : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":160,"label":_vm.$t('reports.waiterName')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.waiterDisplayName(props.row.waiter_id))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"status","label":_vm.$t('orders.status'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.rowStatusKey(props.row))?_c('button',{staticClass:"btn pos-order-actions-status-btn",class:_vm.rowStatusKey(props.row),attrs:{"type":"button","aria-disabled":"true","tabindex":"-1"}},[_vm._v("\n                  "+_vm._s(_vm.changeDeliveryStatus(_vm.rowStatusKey(props.row), props.row.delivery_type))+"\n                ")]):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"totals_grandtotal","sortable":"custom","min-width":130,"label":_vm.$t('orders.totals_grandtotal')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(Number(props.row.totals_grandtotal) || 0))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"transfers_count","sortable":"custom","min-width":140,"label":_vm.$t('reports.orderTransfersCount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.transfers_count != null ? props.row.transfers_count : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"stornos_count","sortable":"custom","min-width":120,"label":_vm.$t('reports.orderStornosCount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.stornos_count != null ? props.row.stornos_count : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","prop":"created_at","sortable":"custom","label":_vm.$t('reports.orderCreatedAt'),"min-width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.created_at ? _vm.formatToCompanyTimezone(props.row.created_at) : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","label":_vm.$t('general.action'),"min-width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"pos-order-actions-actions"},[_c('a',{staticClass:"btn btn-info btn-icon pos-order-actions-action-btn",attrs:{"href":"#","title":_vm.$t('reports.posOrderActionOpenOrder') || _vm.$t('reports.openOrder') || _vm.$t('general.open')},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.openOrderInNewTab(props.row)}}},[_c('i',{staticClass:"ti-new-window"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary btn-icon pos-order-actions-action-btn",attrs:{"href":"#","title":_vm.$t('reports.posOrderActionOpenLogs') || _vm.$t('general.details') || _vm.$t('general.open')},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.openLogs(props.row)}}},[_c('i',{staticClass:"ti-eye"})])])]}}])})],1)],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qUDU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vmodal',{attrs:{"name":"addSeriesModal","height":"auto","width":"800"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v(_vm._s(_vm.$t('invoice.addSeries')))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationSeries),expression:"selectedLocationSeries"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationSeries=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc}},[_vm._v("\n                                      "+_vm._s(loc.name)+"\n                                    ")])}))})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.type')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tip),expression:"tip"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tip=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează optiunea")]),_vm._v(" "),_c('option',{attrs:{"value":"NIR"}},[_vm._v("NIR")]),_vm._v(" "),_c('option',{attrs:{"value":"Bon de transfer"}},[_vm._v("Nota transfer")]),_vm._v(" "),_c('option',{attrs:{"value":"Bon consum"}},[_vm._v("Bon consum")]),_vm._v(" "),_c('option',{attrs:{"value":"Bon de productie"}},[_vm._v("Bon de productie")]),_vm._v(" "),_c('option',{attrs:{"value":"Inventar"}},[_vm._v("Inventar")]),_vm._v(" "),_c('option',{attrs:{"value":"Invoice"}},[_vm._v("Invoice")]),_vm._v(" "),_c('option',{attrs:{"value":"Proforma"}},[_vm._v("Proforma")]),_vm._v(" "),_c('option',{attrs:{"value":"Aviz"}},[_vm._v("Aviz")]),_vm._v(" "),_c('option',{attrs:{"value":"Order"}},[_vm._v("Order")]),_vm._v(" "),_c('option',{attrs:{"value":"Casare"}},[_vm._v("Casare")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.series')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.series),expression:"series"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.series')},domProps:{"value":(_vm.series)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.series=$event.target.value},function($event){_vm.series = _vm.series.replace(/[^a-zA-Z0-9]/g, '')}]}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.startNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.startNumber),expression:"startNumber",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('invoice.startNumber'),"min":"0"},domProps:{"value":(_vm.startNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startNumber=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"button-group"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeSeriesModal}},[_vm._v(_vm._s(_vm.$t('general.cancel2')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",on:{"click":function($event){$event.preventDefault();return _vm.saveSeries($event)}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qYTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelUsersReport_vue__ = __webpack_require__("KEOC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2815d08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelUsersReport_vue__ = __webpack_require__("B560");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelUsersReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2815d08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelUsersReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qbWl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountCampaignAdd_vue__ = __webpack_require__("eiXA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1de786f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountCampaignAdd_vue__ = __webpack_require__("ERsw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountCampaignAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1de786f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountCampaignAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qd75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementMyOrdersSuppliersEdit_vue__ = __webpack_require__("Qimq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56ea13dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementMyOrdersSuppliersEdit_vue__ = __webpack_require__("1iZU");
function injectStyle (ssrContext) {
  __webpack_require__("80MR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56ea13dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementMyOrdersSuppliersEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56ea13dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementMyOrdersSuppliersEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qgrA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelCampaignForm_vue__ = __webpack_require__("PIUN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fd994dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelCampaignForm_vue__ = __webpack_require__("eqta");
function injectStyle (ssrContext) {
  __webpack_require__("JQr7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelCampaignForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fd994dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelCampaignForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qgx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  created: function created() {
    this.getData();
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  data: function data() {
    return {
      loading: true,
      tableData: []
    };
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getData();
    },
    goToRecord: function goToRecord(row, event, column) {

      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, column, '/screens/kds/users/');
      }
    },
    goToAdd: function goToAdd() {
      this.$router.push('/screens/kds/users/add');
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/kds/all/users', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data.kds_user;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    handleDelete: function handleDelete(item) {
      var _this2 = this;

      var btnCounter = 3;
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        text: this.$t('addOrder.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          var data = {
            id: item,
            token: _this2.$session.get('token'),
            company_id: _this2.$session.get('selectedCompany')
          };
          _this2.apiRequest('/kds/user/' + item, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this2.$t('general.success'), 'success');
              _this2.getData();
            } else {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : _this2.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function (err) {
        if (err) {}
      });
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.disableConfirmButton();
      var yes = this.$t('general.yes');
      var btnInterval = setInterval(function () {
        btnCounter--;
        if (btnCounter >= 1) {
          if (__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton().textContent = yes + ' (' + btnCounter + ')';
          }
        } else {
          if (__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton()) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.getConfirmButton().textContent = yes;
          }
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    }
  }
});

/***/ }),

/***/ "qhBy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlovoIntegrationForm_vue__ = __webpack_require__("S/Xs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee1b8252_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlovoIntegrationForm_vue__ = __webpack_require__("4UmR");
function injectStyle (ssrContext) {
  __webpack_require__("wn2q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee1b8252"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlovoIntegrationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee1b8252_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlovoIntegrationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qhTQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qj8w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CouponSelectStep_vue__ = __webpack_require__("568L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1693b54c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CouponSelectStep_vue__ = __webpack_require__("vgdn");
function injectStyle (ssrContext) {
  __webpack_require__("pbbe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CouponSelectStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1693b54c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CouponSelectStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qkXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.$route.params.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteOrderScreen($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15 mar-bt-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.location')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.location_token),expression:"modelValidate.location_token"},{name:"model",rawName:"v-model",value:(_vm.model.location_token),expression:"model.location_token"}],staticClass:"form-control",attrs:{"name":"location"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "location_token", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateLocationId($event)}]}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.token}})})],2),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.invalid),expression:"type.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('type'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.type')))]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.type),expression:"modelValidate.type"},{name:"model",rawName:"v-model",value:(_vm.model.type),expression:"model.type"}],staticClass:"form-control",attrs:{"name":"type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.type),function(typ){return _c('option',{key:typ,attrs:{"disabled":_vm.model.location_token == 'null' && typ == 'Client',"label":_vm.$t('orderScreen.type'+typ)},domProps:{"value":typ}})})),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.invalid),expression:"type.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('type'))+"\n                ")]),_vm._v(" "),_c('i',{staticClass:"fa fa-info-circle mar-to-10",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('orderScreen.selectLocation'))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.section')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.kds_section_id),expression:"model.kds_section_id"}],staticClass:"form-control",attrs:{"name":"type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "kds_section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"label":_vm.$t('general.all')},domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.kdsSections),function(section){return _c('option',{key:section.id,attrs:{"label":section.name},domProps:{"value":section.id}})})],2)]),_vm._v(" "),(_vm.model.type === 'Client')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('orderScreen.excludeSections')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","filterable":"","disabled":!!_vm.model.kds_section_id,"placeholder":_vm.$t('general.select')},model:{value:(_vm.model.excluded_kds_section_ids),callback:function ($$v) {_vm.$set(_vm.model, "excluded_kds_section_ids", $$v)},expression:"model.excluded_kds_section_ids"}},_vm._l((_vm.kdsSections),function(section){return _c('el-option',{key:section.id,attrs:{"label":section.name,"value":section.id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Limba")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.language),expression:"model.language"}],staticClass:"form-control",attrs:{"name":"type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.languages),function(lang){return _c('option',{key:lang.id,attrs:{"label":lang.label},domProps:{"value":lang.id}})})),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.type.invalid),expression:"type.invalid"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('type'))+"\n                ")])]),_vm._v(" "),(_vm.model.type == 'Kitchen')?_c('div',{staticClass:"form-group"},[_c('p-checkbox',{model:{value:(_vm.model.print_order),callback:function ($$v) {_vm.$set(_vm.model, "print_order", $$v)},expression:"model.print_order"}},[_vm._v(_vm._s(_vm.$t('settingTable.printOrder')))])],1):_vm._e(),_vm._v(" "),(_vm.model.type == 'Client')?_c('div',{staticClass:"form-group"},[_c('p-checkbox',{model:{value:(_vm.model.include_table_orders),callback:function ($$v) {_vm.$set(_vm.model, "include_table_orders", $$v)},expression:"model.include_table_orders"}},[_vm._v(_vm._s(_vm.$t('orderScreen.includeTableOrders')))])],1):_vm._e(),_vm._v(" "),(_vm.model.type == 'Client')?_c('div',{staticClass:"form-group"},[_c('p-checkbox',{model:{value:(_vm.model.ods_offline),callback:function ($$v) {_vm.$set(_vm.model, "ods_offline", $$v)},expression:"model.ods_offline"}},[_vm._v(_vm._s(_vm.$t('orderScreen.odsOffline')))]),_vm._v(" "),(_vm.model.ods_offline)?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.ip_server),expression:"model.ip_server"}],staticClass:"form-control mar-to-10",attrs:{"type":"text","name":"ip_server","data-vv-as":"IP Server","placeholder":_vm.$t('orderScreen.ipServer')},domProps:{"value":(_vm.model.ip_server)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ip_server", $event.target.value)}}}):_vm._e(),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('ip_server')),expression:"errors.has('ip_server')"}],staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('ip_server'))+"\n                ")])],1):_vm._e(),_vm._v(" "),(_vm.model.type == 'Client')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('orderScreen.posIds')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%","height":"auto","min-height":"40px"},attrs:{"multiple":"","collapse-tags":"","filterable":"","placeholder":_vm.$t('general.select')},model:{value:(_vm.model.pos_ids),callback:function ($$v) {_vm.$set(_vm.model, "pos_ids", $$v)},expression:"model.pos_ids"}},_vm._l((_vm.allPoses),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))],1):_vm._e(),_vm._v(" "),(_vm.model.type == 'Kitchen' && _vm.model.id)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.without_OrderFormFlags')))]),_vm._v(" "),_c('v-select',{key:'name',ref:'name',attrs:{"multiple":"","options":_vm.getOrderFormFlags(),"value":"","label":"","placeholder":_vm.$t('general.all')},model:{value:(_vm.model.no_orders_selected_order_flags),callback:function ($$v) {_vm.$set(_vm.model, "no_orders_selected_order_flags", $$v)},expression:"model.no_orders_selected_order_flags"}})],1):_vm._e(),_vm._v(" "),(_vm.model.type == 'Kitchen' && _vm.model.id)?_c('div',{staticClass:"form-group"},[_c('p-checkbox',{model:{value:(_vm.model.use_fiscal_net),callback:function ($$v) {_vm.$set(_vm.model, "use_fiscal_net", $$v)},expression:"model.use_fiscal_net"}},[_vm._v(_vm._s(_vm.$t('settingTable.use_fiscal_net')))]),_vm._v(" "),(_vm.model.use_fiscal_net)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.fiscal_ip),expression:"model.fiscal_ip"}],staticClass:"form-control",attrs:{"type":"text","name":"ip","data-vv-as":"ip","placeholder":"IP"},domProps:{"value":(_vm.model.fiscal_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "fiscal_ip", $event.target.value)}}}):_vm._e()],1):_vm._e()])]),_vm._v(" "),(_vm.model.type == 'Client')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('BackgroundColorPicker',{attrs:{"title":_vm.$t('orderScreen.odsBackgroundColor'),"palette":'odsColors',"color":_vm.model.ods_background_color},on:{"color-change":function($event){_vm.updateColor($event, 'ods_background_color')}}})],1)]):_vm._e(),_vm._v(" "),(_vm.model.type == 'Client')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('BackgroundColorPicker',{attrs:{"title":_vm.$t('orderScreen.odsHeaderTextColor'),"palette":'odsColors',"color":_vm.model.ods_header_text_color},on:{"color-change":function($event){_vm.updateColor($event, 'ods_header_text_color')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('BackgroundColorPicker',{attrs:{"title":_vm.$t('orderScreen.odsBodyTextColor'),"palette":'odsColors',"color":_vm.model.ods_body_text_color},on:{"color-change":function($event){_vm.updateColor($event, 'ods_body_text_color')}}})],1)]):_vm._e(),_vm._v(" "),(_vm.model.type == 'Client')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('BackgroundColorPicker',{attrs:{"title":_vm.$t('orderScreen.odsStatus1Color'),"palette":'odsColors',"color":_vm.model.ods_status_1_color},on:{"color-change":function($event){_vm.updateColor($event, 'ods_status_1_color')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('BackgroundColorPicker',{attrs:{"title":_vm.$t('orderScreen.odsStatus2Color'),"palette":'odsColors',"color":_vm.model.ods_status_2_color},on:{"color-change":function($event){_vm.updateColor($event, 'ods_status_2_color')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('BackgroundColorPicker',{attrs:{"title":_vm.$t('orderScreen.odsStatus3Color'),"palette":'odsColors',"color":_vm.model.ods_status_3_color},on:{"color-change":function($event){_vm.updateColor($event, 'ods_status_3_color')}}})],1)]):_vm._e(),_vm._v(" "),(_vm.model.type == 'Client')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('orderScreen.odsColumn1TextLanguage1')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ods_column_1_text_language_1),expression:"model.ods_column_1_text_language_1"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"In preparare","name":"odsColumn1TextLanguage1"},domProps:{"value":(_vm.model.ods_column_1_text_language_1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ods_column_1_text_language_1", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('orderScreen.odsColumn2TextLanguage1')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ods_column_2_text_language_1),expression:"model.ods_column_2_text_language_1"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Gata","name":"odsColumn1TextLanguage2"},domProps:{"value":(_vm.model.ods_column_2_text_language_1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ods_column_2_text_language_1", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(_vm.model.type == 'Client')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('orderScreen.odsColumn1TextLanguage2')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ods_column_1_text_language_2),expression:"model.ods_column_1_text_language_2"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Preparing","name":"odsColumn2TextLanguage1"},domProps:{"value":(_vm.model.ods_column_1_text_language_2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ods_column_1_text_language_2", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('orderScreen.odsColumn2TextLanguage2')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ods_column_2_text_language_2),expression:"model.ods_column_2_text_language_2"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Ready","name":"odsColumn2TextLanguage2"},domProps:{"value":(_vm.model.ods_column_2_text_language_2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ods_column_2_text_language_2", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(_vm.model.type == 'Client')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('upload.browse')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":1,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize2MB')))])])],1)])]):_vm._e()])])]),_vm._v(" "),(_vm.model.id)?_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{staticClass:"card-content",staticStyle:{"height":"100%","width":"100%","margin":"0","display":"flex","flex-direction":"column","flex-wrap":"nowrap","justify-content":"center"}},[(_vm.model.ods_offline)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-6"},[_c('p',{staticStyle:{"margin":"0","min-width":"110px"}},[_vm._v(_vm._s(_vm.$t('orderScreen.odsCode')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('input',{staticClass:"copy_link",staticStyle:{"margin":"0"},attrs:{"type":"text","disabled":"true"},domProps:{"value":_vm.odsCode},on:{"click":function($event){_vm.copyToClipboard(_vm.odsCode)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('a',{staticClass:"btn btn-icon btn-info",staticStyle:{"padding":"6px 5px"},attrs:{"title":_vm.$t('general.copyToClipboard')},on:{"click":function($event){_vm.copyToClipboard(_vm.odsCode)}}},[_c('i',{staticClass:"fa fa-copy"})])])])])]):_vm._e(),_vm._v(" "),(!_vm.model.ods_offline)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('input',{staticClass:"copy_link",staticStyle:{"margin":"0"},attrs:{"type":"text","disabled":"true"},domProps:{"value":_vm.model.url},on:{"click":function($event){_vm.copyToClipboard(_vm.model.url)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('a',{staticClass:"btn btn-icon btn-info",staticStyle:{"padding":"6px 5px"},attrs:{"title":_vm.$t('general.copyToClipboard')},on:{"click":function($event){_vm.copyToClipboard(_vm.model.url)}}},[_c('i',{staticClass:"fa fa-copy"})])])])])]):_vm._e(),_vm._v(" "),(!_vm.model.ods_offline)?_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-lg-4 col-md-6"},[_c('p',{staticStyle:{"margin":"0","min-width":"110px"}},[_vm._v(_vm._s(_vm.$t('settingTable.loginCode')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('input',{staticClass:"copy_link",staticStyle:{"margin":"0"},attrs:{"type":"text","disabled":"true"},domProps:{"value":_vm.model.login_code},on:{"click":function($event){_vm.copyToClipboard(_vm.model.login_code)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('a',{staticClass:"btn btn-icon btn-info mar-rt-10",staticStyle:{"padding":"6px 5px"},attrs:{"title":_vm.$t('general.copyToClipboard')},on:{"click":function($event){_vm.copyToClipboard(_vm.model.login_code)}}},[_c('i',{staticClass:"fa fa-copy"})])])])])]):_vm._e()])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-4 col-md-6"},[_c('p',{staticStyle:{"margin":"0","min-width":"110px"}},[_vm._v("URL")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qm2r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qprm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qqky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductOptionsPanel_vue__ = __webpack_require__("BzuL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GlovoMenuLayout',
  components: { ProductOptionsPanel: __WEBPACK_IMPORTED_MODULE_1__ProductOptionsPanel_vue__["a" /* default */] },
  props: {
    categories: { type: Array, default: function _default() {
        return [];
      } },
    currency: { type: String, default: 'RON' }
  },
  data: function data() {
    return {
      activeCategoryId: null,
      selectedProduct: null
    };
  },

  watch: {
    categories: {
      immediate: true,
      handler: function handler(cats) {
        if (cats && cats.length) this.activeCategoryId = cats[0].id;
        this.selectedProduct = null;
      }
    }
  },
  methods: {
    selectCategory: function selectCategory(id) {
      this.activeCategoryId = id;
      this.$nextTick(function () {
        var el = document.getElementById('glovo-cat-' + id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    truncate: function truncate(text) {
      var s = String(text || '');
      return s.length > 90 ? s.slice(0, 87) + '...' : s;
    },
    formatPrice: function formatPrice(price) {
      var n = Number(price);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(n)) return '';
      return n.toFixed(2).replace('.', ',') + ' ' + this.currency;
    }
  }
});

/***/ }),

/***/ "qyL6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r+e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('raffle-campaign-form',{attrs:{"route":_vm.route}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r1A8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r37d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomInfoPageForm_vue__ = __webpack_require__("Iddv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1129e00a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomInfoPageForm_vue__ = __webpack_require__("75Cv");
function injectStyle (ssrContext) {
  __webpack_require__("We6j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomInfoPageForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1129e00a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomInfoPageForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r651":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAoCAYAAAB0HkOaAAAABHNCSVQICAgIfAhkiAAAA4ZJREFUWEfVmEtuGkEQhqt5RM4q5ATBNzAnCGyi4E3wMsKW4QTxDYJPEHICsIyVJbAxUjaQE5icIOQGZhWkAJ2/mmnoaeYNFs5Ilpnp6upvqqqrq0aQdQ1uZZEEXeJxEX95e3zH+4mUNIaOm9ML0bN1Cf1g2JK5PxlqCUGVHReMOn1EaaqXP4qJnqBgFEiWhrg5MTRN8fuVj+agsagwBCs9igwVNJCCub+V3bVFJP2kDFVY4PudPFlIGhlQ07Sg4ruqGA++ybxc0AgK3kRe3UNQEo1Pz0WBh4QTI8O1nIDpqqKt7wHaBOgndS/punwhGuuxjrwCzJddYNRcZ00x6EhemAN2dR0ARluHYX4BIW+83QSBVWI3sdUgyC7MKcPAx5kUldhN7ML5EnHmjO1qnfK5EAyD9Q5/IRYLzwYG8Vh65jAgxI4ZPbXjtsLD0zL/EwwnOzOFJ7XgzpZBAqxgK3d5i7+c03GpLh4PBoO800BS/Oxk451iK7Fl+CCdvcCRIKlmJMiRczwkCvZEMM6B2LVOdNM7bWTPelx3JYK578iHAJAVg3WARgGLDTO4kzUs1ApTniSg48N0JJeGH8JgnEP0zKuU9Ju7BZOm4+3jAEnvaE7jWZYerNM8lAkW+gqgq1BBCLjqJNTEiLuaJ4xSJmhTcEXRrkKHfqNqy0cUJ1XY4dLHjycMD3LRhTeNrFjxp6htVokaimsf/s11UBCoL0zUtwuIiUtYistSs8hn643xrAm33NhzGYZT+qYLSLBNTaUR8pISV1BpOnO1KoBx7Zgk21TDKJA5PUQtRbdaFa9cwtQpQY33VdGP466ABMl9Fl9bfZirVWEJKJnE6H8m2GnXdqAGJkh0HI5vvBOoblVYyKNZCzXI0V96bZYQgccGcpdS6JMu1q2Kuf2s7jEQiKt5c6sGdhkhMLyQalXMFZ3mv4GnNS//GrJ9TF5/IODApQVx/6WvKYKzBuWq+OKMzv9nmdU2hyVyWKPtWoOPA7/X19nRa9wu2G0YtUtS1FzPTdEqpyw3natcIgeZDWAQTGjQWAJ7d1NcAFPezlcuXeExo9zu66a4YHvb2nEX9pNHWTBCHLy1x1UM+XwgwNgPlB1FnrM3y7AyVbhnaeLaJcFvOkW+yut8tVcYDYRvgz0vC5lcbBH0XhUzce4dRi/oxBDnIrts7cMfPa+658lgTCuw+/g+rAP9B+ZxD9+k17LkAAAAAElFTkSuQmCC"

/***/ }),

/***/ "r6BL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KdsUserForm_vue__ = __webpack_require__("7FDv");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    KdsUserForm: __WEBPACK_IMPORTED_MODULE_0__KdsUserForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "r8wo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagementTransferForm_vue__ = __webpack_require__("TZJI");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'GestiuneTransferForm', __WEBPACK_IMPORTED_MODULE_7__ManagementTransferForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "r9jT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentGroupsForm_vue__ = __webpack_require__("vizI");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PaymentGroupsForm', __WEBPACK_IMPORTED_MODULE_7__PaymentGroupsForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      paymentGroupsModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.paymentGroupsModel = model;
    }
  }
});

/***/ }),

/***/ "rA/S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsForm_vue__ = __webpack_require__("mj8g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51c5d8c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsForm_vue__ = __webpack_require__("u0pN");
function injectStyle (ssrContext) {
  __webpack_require__("QoUj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51c5d8c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51c5d8c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rE7J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("Yq4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog__ = __webpack_require__("qubY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_css__);



















var _components;







__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_upload___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_checkbox___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_checkbox_group___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dialog___default.a), _components),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_vee_validate__["b" /* mapFields */])(['name', 'description', 'sort_order', 'parent_id', 'date_validfrom', 'date_validto', 'display_type'])),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pickerOptions1: {},
      pickerNames: ['date_validfrom', 'date_validto'],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          if (time.getTime() + 86401 * 1000 < Date.now()) {
            return true;
          } else {
            return false;
          }
        }
      },
      model: {},
      filelist: [],
      filelistToUpload: [],
      generalSuccess: '',
      modelValidations: {
        image: {
          required: true
        }
      },
      categories: [],
      products: [],
      loading: true,
      locations: [],
      imageWeb: []
    };
  },

  created: function created() {
    var _this = this;

    this.locations = this.getCompanyDetail('locations_details');
    this.$nextTick(function () {
      this.loading = true;
    });

    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    var self = this;

    this.apiRequest('/category', 'GET', data, function (response) {
      if (response.status === true) {
        self.categories = response.data;
      }
    });
    this.apiRequest('/product', 'GET', data, function (response) {
      if (response.status === true) {
        self.products = response.data;
      }
    });

    if (this.route.params.id) {
      var id = this.route.params.id;

      this.apiRequest('/homepage-offer/edit/' + id, 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data[0].date_start && response.data[0].date_end) {
            response.data[0].fromto = [response.data[0].date_start, response.data[0].date_end];
          }
          if (response.data[0].image) {
            response.data[0].imagelist = [{ url: response.data[0].image }];
          } else {
            response.data[0].imagelist = [];
          }
          if (response.data[0].image_web) {
            response.data[0].imageWeb = [{ url: response.data[0].image_web }];
          } else {
            response.data[0].imageWeb = [];
          }
          _this.model = response.data[0];

          _this.$nextTick(function () {
            this.loading = false;
          });
        }
      });
    } else {
      this.$nextTick(function () {
        this.loading = false;
      });
    }
  },
  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.errors.clear();
          _this2.saveOffer();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors[prop].length === 1) {
          this.errors.add(prop, errors[prop][0]);
        } else {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    isNew: function isNew() {
      if (this.route.params.id) {
        return false;
      } else {
        return true;
      }
    },
    handleImgChangeWeb: function handleImgChangeWeb(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imageWeb = [];
      } else {
        if (fileList.length > 1) {
          this.model.imageWeb = fileList.slice(1);
        } else {
          this.model.imageWeb = fileList;
        }
      }
    },
    handleImgChange: function handleImgChange(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 1;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }
    },
    handleRemoveWeb: function handleRemoveWeb(file, fileList) {
      if (fileList.length === 0) {
        this.model.imageWeb = [];
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
      }
    },
    uploadImage: function uploadImage(upload) {},
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    },
    handleDelete: function handleDelete(label) {
      var _this3 = this;

      var btnCounter = 3;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
        text: self.$t('marketingOffers.areYouSure', { label: label }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes (' + btnCounter + ')'
      }).then(function (result) {
        if (result) {
          if (_this3.isNew()) {
            self.$router.push('/marketing/offers');
          } else {
            var id = _this3.route.params.id;
            var data = {
              id: id,
              token: _this3.$session.get('token'),
              company_id: _this3.$session.get('selectedCompany')
            };
            _this3.apiRequest('/homepage-offer/delete-banner/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', self.$t('validations.offerDeleted'), 'success');
                self.$router.push('/marketing/offers');
              } else {
                __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()('', response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
              }
            });
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.disableConfirmButton();

      var btnInterval = setInterval(function () {
        btnCounter--;

        if (btnCounter >= 1) {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')';
        } else {
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.getConfirmButton().textContent = self.$t('general.yes');
          clearInterval(btnInterval);
          __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default.a.enableConfirmButton();
        }
      }, 1000);
    },
    clearLinkSelection: function clearLinkSelection() {
      this.model.link_id = null;
      this.model.description = null;
    },
    saveOffer: function saveOffer() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var locIds = [];
      for (var idxL in this.model.location_ids) {
        locIds.push(this.model.location_ids[idxL]['id']);
      }
      locIds = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(locIds);

      var data = {
        title: this.model.title,
        link_type: this.model.link_type,
        link_id: this.model.link_id,
        description: this.model.description,
        location_ids: locIds,
        offer_id: this.route.params.offer_id
      };
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');
      if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
        data.date_start = this.model.fromto[0];
        data.date_end = this.model.fromto[1];
      } else {
        data.date_start = null;
        data.date_end = null;
      }

      var self = this;

      if (this.isNew()) {
        data.sort_order = 0;
        if (self.model.imagelist && self.model.imagelist[0].status === 'ready') {
          self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
            data.image = base64enc;
            if (self.model.imageWeb && self.model.imageWeb[0].status === 'ready') {
              self.getBase64(self.model.imageWeb[0].raw).then(function (base64enc) {
                data.imageWeb = base64enc;
              });
            }
            self.apiRequest('/homepage-offer/store', 'POST', data, function (response) {
              if (response.status === true) {
                self.$nextTick(function () {
                  self.loading = false;
                });
                __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                  title: '',
                  text: self.$t('marketingOffers.offerAdded'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }).catch(function () {});
                var id = response.data[0].id;
                data.id = id;
                data.sort_order = id;
                self.apiRequest('/homepage-offer/update-banner' + id, 'PUT', data, function (response2) {});
                self.$router.push('/marketing/offers/' + response.data[0].offer_id + '/edit-group-banner/' + id);
              } else {
                self.$nextTick(function () {
                  self.loading = false;
                });
                self.handleErrors(response.errors);
              }
            });
          });
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          self.errors.add('image', self.$t('marketingOffers.validImg'));
        }
      } else {
        var id = this.route.params.id;

        if (this.model.imagelist === 0) {
          data.image = '';
        }
        if (this.model.imageWeb) {
          data.imageWeb = '';
        }
        this.apiRequest('/homepage-offer/update-banner/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            if (self.model.imagelist[0] !== undefined && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
              self.getBase64(self.model.imagelist[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.image = base64enc;

                self.apiRequest('/homepage-offer/update-banner/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.offerUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.weCouldNot'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  }
                });
              });
            }
            if (self.model.imageWeb[0] !== undefined && self.model.imageWeb[0].status && self.model.imageWeb[0].status === 'ready') {
              self.getBase64(self.model.imageWeb[0].raw).then(function (base64enc) {
                var data2 = {};
                data2.id = id;
                data2.token = data.token;
                data2.company_id = data.company_id;
                data2.imageWeb = base64enc;
                self.apiRequest('/homepage-offer/update-banner/' + id, 'PUT', data2, function (response2) {
                  if (response2.status === true) {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.offerUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  } else {
                    self.$nextTick(function () {
                      self.loading = false;
                    });
                    __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
                      title: '',
                      text: self.$t('marketingOffers.weCouldNot'),
                      type: 'danger',
                      showConfirmButton: false,
                      timer: 1500
                    }).catch(function () {});
                  }
                });
              });
            }
            self.$nextTick(function () {
              self.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_20_sweetalert2___default()({
              title: '',
              text: self.$t('marketingOffers.offerUpdated'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).catch(function () {});

            self.$router.push('/marketing/offers/ ' + this.route.params.offer_id + ' edit-group/' + id);
          } else {
            self.$nextTick(function () {
              self.loading = false;
            });
            self.handleErrors(response.errors);
          }
        });
      }
    }
  }
});

/***/ }),

/***/ "rF8M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rIb9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Settings_TableZones_TableZonesForm_vue__ = __webpack_require__("YngB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Settings_TableZones_TableZones_vue__ = __webpack_require__("C47s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Settings_TableManagement_TableManagementForm_vue__ = __webpack_require__("kQ0V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Settings_TableManagement_TableManagement_vue__ = __webpack_require__("+suy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_KioskColorsCard_vue__ = __webpack_require__("4Ds/");











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TableZoneForm: __WEBPACK_IMPORTED_MODULE_1__Settings_TableZones_TableZonesForm_vue__["a" /* default */],
    TableZoneList: __WEBPACK_IMPORTED_MODULE_2__Settings_TableZones_TableZones_vue__["a" /* default */],
    TableManagementForm: __WEBPACK_IMPORTED_MODULE_3__Settings_TableManagement_TableManagementForm_vue__["a" /* default */],
    TableManagementList: __WEBPACK_IMPORTED_MODULE_4__Settings_TableManagement_TableManagement_vue__["a" /* default */],
    KioskColorsCard: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_KioskColorsCard_vue__["a" /* default */]
  },

  data: function data() {
    return {
      isTableZones: true,
      isTableManager: false,

      selectedZone: false,
      selectedTable: false,

      model: {},
      defaultData: {},
      websiteData: [],

      posUsers: []
    };
  },


  computed: {
    formattedUsers: function formattedUsers() {
      return this.posUsers.map(function (user) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user, {
          fullname: user.firstname + ' ' + user.lastname
        });
      });
    }
  },

  created: function created() {
    this.getModelData();
    this.getPosUsers();
  },


  methods: {
    handleTabChange: function handleTabChange(tabIndex, newTab) {
      this.isTableZones = false;
      this.isTableManager = false;

      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);

      switch (newTab.title) {
        case this.$t('settingsPages.tableZones'):
          this.isTableZones = true;
          break;

        case this.$t('settingsPages.kioskModule'):
          this.isTableManager = true;
          break;

        default:
          this.isTableZones = true;
          break;
      }
    },
    getPosUsers: function getPosUsers() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this.posUsers = response.data.pos_user;
        }
      });
    },
    getModelData: function getModelData() {
      var _this2 = this;

      var token = this.$session.get('token');
      var companyID = this.$session.get('selectedCompany');

      this.apiRequest('/settings/general/' + companyID, 'GET', { token: token }, function (response2) {
        if (response2.status === true) {
          _this2.model = response2.data[0];

          _this2.model.selected_languages = response2.data[0].languages.map(function (lang) {
            return {
              value: lang.id,
              label: lang.name
            };
          });
        }
      });

      this.apiRequest('/settings/website', 'GET', {
        token: token,
        company_id: companyID
      }, function (response) {
        if (response.status === true) {
          _this2.websiteData = response.data;
        }
      });
    },
    onUserSubmit: function onUserSubmit(model, isValid) {},
    tableManagementUpdate: function tableManagementUpdate() {
      this.selectedTable = false;

      if (this.$refs.tableManagement) {
        this.$refs.tableManagement.getData();
      }
    },
    tableZoneUpdate: function tableZoneUpdate() {
      this.selectedZone = false;

      if (this.$refs.tableZone) {
        this.$refs.tableZone.getData();
      }
    },
    getTable: function getTable(id) {
      this.selectedTable = id;
    },
    getZone: function getZone(id) {
      this.selectedZone = id;
    }
  }
});

/***/ }),

/***/ "rKkS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-details",attrs:{"id":"outer-container"}},[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();return _vm.handleDelete($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","disabled":_vm.loading || _vm.rSystemBusy || _vm.initialLoadError || !_vm.location,"title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10 space-between"},[_c('a',{staticClass:"btn btn-fill",class:[_vm.hasLocationErrors ? 'btn-danger' : 'btn-primary', _vm.currentSection === 'start' ? 'active' : ''],on:{"click":function($event){$event.preventDefault();_vm.openSection('start')}}},[_vm._v(_vm._s(_vm.$t('settingCompany.location')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill",class:[_vm.hasDeliveryMethodsErrors ? 'btn-danger' : 'btn-primary', _vm.currentSection === 'delivery-methods' ? 'active' : ''],on:{"click":function($event){$event.preventDefault();_vm.openSection('delivery-methods')}}},[_vm._v(_vm._s(_vm.$t('general.deliveryMethod')))]),_vm._v(" "),(_vm.displayIntegrationCard)?_c('a',{staticClass:"btn btn-primary",class:{ 'active': _vm.currentSection === 'import-integrations' },on:{"click":function($event){$event.preventDefault();_vm.openSection('import-integrations')}}},[_vm._v(_vm._s(_vm.$t('settingCompany.menuIntegration')))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:[_vm.currentSection === 'menu-actions' ? 'active' : ''],on:{"click":function($event){$event.preventDefault();_vm.openSection('menu-actions')}}},[_vm._v(_vm._s(_vm.$t('settingCompany.menuActions')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ 'active': _vm.currentSection === 'taxes' },on:{"click":function($event){$event.preventDefault();_vm.openSection('taxes')}}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.Tax')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill",class:[_vm.hasVatErrors ? 'btn-danger' : 'btn-primary', { 'active': _vm.currentSection === 'vat' }],on:{"click":function($event){$event.preventDefault();_vm.openSection('vat')}}},[_vm._v(_vm._s(_vm.$t('catalogCateg.vatTitle')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ 'active': _vm.currentSection === 'invoices' },on:{"click":function($event){$event.preventDefault();_vm.openSection('invoices')}}},[_vm._v(_vm._s(_vm.$t('settingCompany.invoices')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ 'active': _vm.currentSection === 'digital-waiter' },on:{"click":function($event){$event.preventDefault();_vm.openSection('digital-waiter')}}},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.menuQr')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ 'active': _vm.currentSection === 'kiosk-qr-settings' },on:{"click":function($event){$event.preventDefault();_vm.openSection('kiosk-qr-settings')}}},[_vm._v(_vm._s(_vm.$t('settingCompany.kioskQrSettingsTab')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ 'active': _vm.currentSection === 'pos-settings' },on:{"click":function($event){$event.preventDefault();_vm.openSection('pos-settings')}}},[_vm._v(_vm._s(_vm.$t('crossSell.posSettingsTab')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill",class:[_vm.hasPaymentGroupErrors ? 'btn-danger' : 'btn-primary', _vm.currentSection === 'printer' ? 'active' : ''],on:{"click":function($event){$event.preventDefault();_vm.openSection('printer')}}},[_vm._v(_vm._s(_vm.$t('settingCompany.otherSettings')))])])])]),_vm._v(" "),(_vm.initialLoadError)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.$t('validations.wentWrong'))+"\n    "),_c('button',{staticClass:"btn btn-sm btn-default",attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.loadLocationForm}},[_vm._v("\n      "+_vm._s(_vm.$t('general.retry'))+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),(_vm.location)?_c('div',{ref:"compDetailsContainer",staticClass:"company-wrap",style:({height: _vm.windowHeight - _vm.pageTopHeight - _vm.navbarHeaderHeight - _vm.navButtonsHeight - 1 + 'px'}),attrs:{"id":"inner-container"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'start'),expression:"currentSection === 'start'"}],staticClass:"card location-card",attrs:{"id":"start"}},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("\n              "+_vm._s(_vm.$t('settingCompany.bussLoc'))+": "+_vm._s(_vm.location.name)+"\n            ")]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 pad-lf-0"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.name),expression:"location.name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('settingCompany.name')},domProps:{"value":(_vm.location.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.email),expression:"location.email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.email),expression:"modelValidate.email"}],staticClass:"form-control",attrs:{"type":"text","name":"email","placeholder":_vm.$t('settingCompany.email')},domProps:{"value":(_vm.location.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.phone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.phone),expression:"location.phone"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.phone),expression:"modelValidate.phone"}],staticClass:"form-control",attrs:{"type":"text","name":"phone","placeholder":_vm.$t('settingCompany.phone')},domProps:{"value":(_vm.location.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.country')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.country),expression:"location.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.country),expression:"modelValidate.country"}],ref:"country",staticClass:"select-primary form-control",attrs:{"name":"country"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.location, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateCountry(_vm.location)}]}},_vm._l((_vm.countries),function(country){return _c('option',{staticClass:"select-primary",domProps:{"value":country.alpha2}},[_vm._v(_vm._s(country.name)+"\n                  ")])}))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.state')))]),_vm._v(" "),(_vm.showStateDrop(_vm.location))?[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.state_id),expression:"location.state_id"}],staticClass:"select-primary form-control",attrs:{"name":"state"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.location, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.getStatesOptions(_vm.location)),function(state){return _c('option',{staticClass:"select-primary",domProps:{"value":state.id}},[_vm._v(_vm._s(state.name)+"\n                    ")])}))]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.state),expression:"location.state"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.state),expression:"modelValidate.state"}],staticClass:"form-control",attrs:{"type":"text","name":"state"},domProps:{"value":(_vm.location.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "state", $event.target.value)}}})]],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.city')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.city),expression:"location.city"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.city),expression:"modelValidate.city"}],staticClass:"form-control",attrs:{"type":"text","name":"city","placeholder":_vm.$t('settingCompany.city')},domProps:{"value":(_vm.location.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "city", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-8",staticStyle:{"padding":"0"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.street')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.street),expression:"location.street"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.street),expression:"modelValidate.street"}],staticClass:"form-control",attrs:{"type":"text","name":"street","placeholder":_vm.$t('settingCompany.street')},domProps:{"value":(_vm.location.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "street", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4",staticStyle:{"padding-right":"0"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.number')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.number),expression:"location.number"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.number),expression:"modelValidate.number"}],staticClass:"form-control",attrs:{"type":"text","name":"street-number","placeholder":_vm.$t('settingCompany.number')},domProps:{"value":(_vm.location.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "number", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6",staticStyle:{"padding":"0"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.latitude')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.lat),expression:"location.lat"}],staticClass:"form-control",attrs:{"type":"number","step":"any","name":"lat","placeholder":_vm.$t('settingCompany.latitude')},domProps:{"value":(_vm.location.lat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "lat", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6",staticStyle:{"padding-right":"0"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.longitude')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.lng),expression:"location.lng"}],staticClass:"form-control",attrs:{"type":"number","step":"any","name":"lng","placeholder":_vm.$t('settingCompany.longitude')},domProps:{"value":(_vm.location.lng)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "lng", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 no-padding"},[_c('image-input',{staticStyle:{"margin-bottom":"30px"},attrs:{"location":_vm.location,"label":_vm.$t('settingCompany.locationImage'),"image":_vm.location.image,"imageField":"image"}})],1),_vm._v(" "),(_vm.location.app_link)?_c('div',{staticClass:"col-md-6 no-padding"},[_c('display-qr-app',{attrs:{"location":_vm.location}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6 no-padding"},[_c('image-input',{attrs:{"location":_vm.location,"label":_vm.$t('general.logo'),"image":_vm.location.dynamic_menu_logo,"imageField":"dynamic_menu_logo"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 no-padding"},[_c('image-input',{attrs:{"location":_vm.location,"label":_vm.$t('marketingOffers.banners'),"image":_vm.location.dynamic_menu_banner,"imageField":"dynamic_menu_banner"}})],1),_vm._v(" "),(_vm.location.true_id)?_c('div',{staticClass:"col-md-8 no-padding"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.authAppCode')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){$event.preventDefault();_vm.generateCode()}}},[_vm._v(_vm._s(_vm.$t('settingCompany.generateAuthAppCode')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.location.auth_code)?_c('input',{attrs:{"type":"text","disabled":""},domProps:{"value":_vm.location.auth_code}}):_vm._e(),_vm._v(" "),(_vm.location.auth_code)?_c('button',{staticClass:"btn btn-info btn-icon duplicate-prod",on:{"click":function($event){$event.preventDefault();_vm.copy(_vm.location.auth_code)}}},[_c('i',{staticClass:"fa fa-copy"})]):_vm._e(),_vm._v(" "),(_vm.location.auth_qr_code)?_c('div',{staticClass:"form-group"},[[_c('div',{staticClass:"col-md-12 px-0"},[_c('img',{staticStyle:{"height":"170px","width":"170px"},attrs:{"src":_vm.location.auth_qr_code}}),_vm._v(" "),_c('a',{staticClass:"btn btn-info btn-icon duplicate-prod",attrs:{"href":_vm.location.auth_qr_code,"target":"_blank"}},[_c('i',{staticClass:"fa fa-download"})])])]],2):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('h5',{staticStyle:{"margin-bottom":"0"}},[_vm._v("\n              Date Facturare\n            ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px","font-weight":"400"}},[_vm._v("Aceste date se folosesc la facturare si gestiune")]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 pad-lf-0"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_company_name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_company_name),expression:"location.inv_company_name"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.inv_company_name),expression:"modelValidate.inv_company_name"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_company_name","placeholder":_vm.$t('settingCompany.inv_company_name')},domProps:{"value":(_vm.location.inv_company_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_company_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_fiscal_code ')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_fiscal_code ),expression:"location.inv_fiscal_code "},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.inv_fiscal_code ),expression:"modelValidate.inv_fiscal_code "}],staticClass:"form-control",attrs:{"type":"text","name":"inv_fiscal_code ","placeholder":_vm.$t('settingCompany.inv_fiscal_code'),"disabled":_vm.inv_fiscal_code_disabled_field},domProps:{"value":(_vm.location.inv_fiscal_code )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_fiscal_code", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_trade_register')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_trade_register),expression:"location.inv_trade_register"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.inv_trade_register),expression:"modelValidate.inv_trade_register"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_trade_register","placeholder":_vm.$t('settingCompany.inv_trade_register')},domProps:{"value":(_vm.location.inv_trade_register)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_trade_register", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_phone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_phone),expression:"location.inv_phone"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.inv_phone),expression:"modelValidate.inv_phone"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_phone","placeholder":_vm.$t('settingCompany.inv_phone')},domProps:{"value":(_vm.location.inv_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_email),expression:"location.inv_email"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.inv_email),expression:"modelValidate.inv_email"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_email","placeholder":_vm.$t('settingCompany.inv_email')},domProps:{"value":(_vm.location.inv_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_bank_account')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_bank_account),expression:"location.inv_bank_account"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_bank_account","placeholder":_vm.$t('settingCompany.inv_bank_account')},domProps:{"value":(_vm.location.inv_bank_account)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_bank_account", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_bank')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_bank),expression:"location.inv_bank"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_bank","placeholder":_vm.$t('settingCompany.inv_bank')},domProps:{"value":(_vm.location.inv_bank)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_bank", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_bank_branch')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_bank_branch),expression:"location.inv_bank_branch"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_bank_branch","placeholder":_vm.$t('settingCompany.inv_bank_branch')},domProps:{"value":(_vm.location.inv_bank_branch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_bank_branch", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_country')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_country),expression:"location.inv_country"}],staticClass:"select-primary form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.location, "inv_country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onCountryChange]}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('settingCompany.inv_country')))]),_vm._v(" "),_vm._l((_vm.countriesList),function(country){return _c('option',{key:country.name,domProps:{"value":country.name}},[_vm._v("\n                        "+_vm._s(country.name)+"\n                      ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_county')))]),_vm._v(" "),(_vm.selectedCountry && _vm.selectedCountry.counties.length > 0)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_county),expression:"location.inv_county"}],staticClass:"select-primary form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.location, "inv_county", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('settingCompany.inv_county')))]),_vm._v(" "),_vm._l((_vm.selectedCountry.counties),function(county){return _c('option',{key:county.code,domProps:{"value":county.name}},[_vm._v("\n                        "+_vm._s(county.name)+"\n                      ")])})],2):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_county),expression:"location.inv_county"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.inv_county),expression:"modelValidate.inv_county"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_county","placeholder":_vm.$t('settingCompany.inv_county')},domProps:{"value":(_vm.location.inv_county)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_county", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_city')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_city),expression:"location.inv_city"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.inv_city),expression:"modelValidate.inv_city"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_city","placeholder":_vm.$t('settingCompany.inv_city')},domProps:{"value":(_vm.location.inv_city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_city", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_address')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_address),expression:"location.inv_address"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.inv_address),expression:"modelValidate.inv_address"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_address","placeholder":_vm.$t('settingCompany.inv_address')},domProps:{"value":(_vm.location.inv_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_address", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_street_number')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_street_number),expression:"location.inv_street_number"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.inv_street_number),expression:"modelValidate.inv_street_number"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_street_number","placeholder":_vm.$t('settingCompany.inv_street_number')},domProps:{"value":(_vm.location.inv_street_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_street_number", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_additional_data')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_additional_data),expression:"location.inv_additional_data"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.inv_additional_data),expression:"modelValidate.inv_additional_data"}],staticClass:"form-control",attrs:{"type":"text","name":"inv_additional_data","placeholder":_vm.$t('settingCompany.inv_additional_data')},domProps:{"value":(_vm.location.inv_additional_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "inv_additional_data", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.inv_is_vat_payer')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.inv_is_vat_payer),expression:"location.inv_is_vat_payer"}],ref:"inv_is_vat_payer",staticClass:"select-primary form-control inline-auto",staticStyle:{"width":"100%"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.location, "inv_is_vat_payer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{staticClass:"select-primary",domProps:{"value":0}},[_vm._v(_vm._s(_vm.$t('settingCompany.inv_is_vat_payer_0'))+"\n                      ")]),_vm._v(" "),_c('option',{staticClass:"select-primary",domProps:{"value":1}},[_vm._v(_vm._s(_vm.$t('settingCompany.inv_is_vat_payer_1'))+"\n                      ")])])])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'delivery-methods'),expression:"currentSection === 'delivery-methods'"}],staticClass:"card location-card",attrs:{"id":"delivery-methods"}},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingsPages.deliveryMethods')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('delivery-methods',{ref:"deliveryMethods",attrs:{"modeldata":_vm.location,"defaultData":_vm.defaultData},on:{"mapactive":_vm.updateLocationMapActive}})],1)])])])]),_vm._v(" "),(_vm.displayIntegrationCard)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'import-integrations'),expression:"currentSection === 'import-integrations'"}],attrs:{"id":"import-integrations"}},[(_vm.location.is_magister_location)?_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('magister.syncLabel')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"pad-bt-5",attrs:{"for":"download"}},[_vm._v(_vm._s(_vm.$t('magister.syncPrices')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.updateProductPricesMagister(_vm.location)}}},[_vm._v(_vm._s(_vm.$t('general.start')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"pad-bt-5",attrs:{"for":"download"}},[_vm._v(_vm._s(_vm.$t('magister.syncStocks')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.updateProductStocksMagister(_vm.location)}}},[_vm._v(_vm._s(_vm.$t('general.start')))])],1)])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.location.is_tazz_location)?_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('tazz.syncLabel')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.updateTazzMenu(_vm.location)}}},[_vm._v(_vm._s(_vm.$t('general.start')))])],1)])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.location.is_rkeeper_location)?_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('rkeeper.sync')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.importCategories(_vm.location)}}},[_vm._v(_vm._s(_vm.$t('rkeeper.categories')))]),_vm._v(" "),_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.importProducts(_vm.location)}}},[_vm._v(_vm._s(_vm.$t('rkeeper.products')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.importProducts(_vm.location, 1)}}},[_vm._v(_vm._s(_vm.$t('rkeeper.onlyProducts')))]),_vm._v(" "),_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.importProducts(_vm.location, 2)}}},[_vm._v(_vm._s(_vm.$t('rkeeper.onlyOptions')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.syncProductPrices(_vm.location)}}},[_vm._v(_vm._s(_vm.$t('rkeeper.productPrices')))]),_vm._v(" "),_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.syncOptionPrices(_vm.location)}}},[_vm._v(_vm._s(_vm.$t('rkeeper.optionPrices')))])],1)])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.ensureRkV2(_vm.location))?_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('rkeeperV2.title')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v(_vm._s(_vm.$t('rkeeperV2.url')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.rkeeper_v2.url),expression:"location.rkeeper_v2.url"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.location.rkeeper_v2.active},domProps:{"value":(_vm.location.rkeeper_v2.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.rkeeper_v2, "url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v(_vm._s(_vm.$t('rkeeperV2.slug')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.rkeeper_v2.restaurant_slug),expression:"location.rkeeper_v2.restaurant_slug"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.location.rkeeper_v2.active},domProps:{"value":(_vm.location.rkeeper_v2.restaurant_slug)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.rkeeper_v2, "restaurant_slug", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('rkeeperV2.apiUser')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.rkeeper_v2.api_user),expression:"location.rkeeper_v2.api_user"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.location.rkeeper_v2.active},domProps:{"value":(_vm.location.rkeeper_v2.api_user)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.rkeeper_v2, "api_user", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('rkeeperV2.apiSecret')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.rkeeper_v2.api_secret),expression:"location.rkeeper_v2.api_secret"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.location.rkeeper_v2.active},domProps:{"value":(_vm.location.rkeeper_v2.api_secret)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.rkeeper_v2, "api_secret", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v(" ")]),_vm._v(" "),_c('div',[_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"info","loading":_vm.location.rkeeper_v2.testing},on:{"click":function($event){$event.preventDefault();_vm.testRkV2Login(_vm.location)}}},[_vm._v(_vm._s(_vm.$t('rkeeperV2.testLogin')))]),_vm._v(" "),_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary","loading":_vm.location.rkeeper_v2.saving,"disabled":_vm.location.rkeeper_v2.active},on:{"click":function($event){$event.preventDefault();_vm.saveRkV2(_vm.location)}}},[_vm._v(_vm._s(_vm.$t('rkeeperV2.save')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"checkbox-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.rkeeper_v2.active),expression:"location.rkeeper_v2.active"}],attrs:{"type":"checkbox","disabled":!_vm.location.rkeeper_v2.login_ok && !_vm.location.rkeeper_v2.active},domProps:{"checked":Array.isArray(_vm.location.rkeeper_v2.active)?_vm._i(_vm.location.rkeeper_v2.active,null)>-1:(_vm.location.rkeeper_v2.active)},on:{"change":[function($event){var $$a=_vm.location.rkeeper_v2.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.location.rkeeper_v2, "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.location.rkeeper_v2, "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.location.rkeeper_v2, "active", $$c)}},function($event){_vm.toggleRkV2Active(_vm.location)}]}}),_vm._v(" "+_vm._s(_vm.$t('rkeeperV2.active'))+"\n                    ")])]),_vm._v(" "),(_vm.location.rkeeper_v2.login_message)?_c('div',{staticClass:"col-md-8"},[_c('span',{class:_vm.location.rkeeper_v2.login_ok ? 'text-success' : 'text-danger'},[_vm._v(_vm._s(_vm.location.rkeeper_v2.login_message))])]):_vm._e()]),_vm._v(" "),(_vm.location.rkeeper_v2.active)?_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-md-4"},[_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary","loading":_vm.location.rkeeper_v2.is_running,"disabled":_vm.location.rkeeper_v2.is_running},on:{"click":function($event){$event.preventDefault();_vm.syncRkV2Menu(_vm.location)}}},[_vm._v(_vm._s(_vm.$t('rkeeperV2.syncMenu')))])],1),_vm._v(" "),(_vm.location.rkeeper_v2.sync_message)?_c('div',{staticClass:"col-md-8"},[_c('span',[_vm._v(_vm._s(_vm.location.rkeeper_v2.sync_message))])]):_vm._e()]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.location.glovo_company_id)?_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',[_c('div',{staticClass:"form-group col-md-12"},[_c('h5',[_vm._v("Glovo")]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-1"},[_c('label',[_vm._v(_vm._s(_vm.$t('bolt.menu')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.update')},on:{"click":function($event){$event.preventDefault();_vm.updateGlovoMenu()}}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.update'))+"\n                      ")])])])]),_vm._v(" "),_c('p-switch',{staticClass:"mar-bt-0",attrs:{"type":"success","name":"bolt-orders"},on:{"input":function($event){_vm.handleGlovoStatus()}},model:{value:(_vm.glovoStatus),callback:function ($$v) {_vm.glovoStatus=$$v},expression:"glovoStatus"}}),_vm._v(" "),_c('label',{attrs:{"for":"bolt-orders"}},[_vm._v(_vm._s(_vm.$t('bolt.acceptOrders')))])],1)])])])]):_vm._e(),_vm._v(" "),(_vm.location.freya_cloud_id)?_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v("Freya Cloud Import")]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.syncFreyaCloudMenu(_vm.location)}}},[_vm._v(_vm._s(_vm.$t('general.start')))])],1)])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.location.ep_restaurant_id)?_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('epRestaurant.importLabel')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.syncEpRestaurantMenu(_vm.location)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('epRestaurant.importButton'))+"\n                        ")]),_vm._v(" "),_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){$event.preventDefault();_vm.syncEpRestaurantMenu(_vm.location, true)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('epRestaurant.syncButton'))+"\n                        ")])],1)])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.location.nexus_id)?_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v("NEXUS")]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 datetime-picker pull-left"},[_c('label',{attrs:{"for":"orders-period"}},[_vm._v(_vm._s(_vm.$t('nexus.ordersPeriod')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"id":"orders-period","type":"datetime","placeholder":"Select From Date & Time","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions},model:{value:(_vm.nexusFrom),callback:function ($$v) {_vm.nexusFrom=$$v},expression:"nexusFrom"}}),_vm._v("\n                    -\n                    "),_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select To Date & Time","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions},on:{"change":_vm.handleNexusToChange},model:{value:(_vm.nexusTo),callback:function ($$v) {_vm.nexusTo=$$v},expression:"nexusTo"}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('nexus.elgibleOrders'))+" "),_c('br'),_vm._v(" "+_vm._s(_vm.$t('nexus.ordersAlreadyIntegrated')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 datetime-picker pull-left"},[_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary","disabled":!_vm.isNexusDatesValid},on:{"click":function($event){$event.preventDefault();return _vm.createNexusOrders($event)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.load'))+"\n                    ")]),_vm._v(" "),_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary","disabled":!_vm.isNexusDatesValid},on:{"click":function($event){$event.preventDefault();return _vm.cancelNexusOrders($event)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.cancel'))+"\n                    ")]),_vm._v(" "),_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary","disabled":!_vm.isNexusDatesValid},on:{"click":function($event){$event.preventDefault();return _vm.retryFailedOrders($event)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.retry'))+"\n                    ")])],1)])])])])])]):_vm._e(),_vm._v(" "),(_vm.location.wolt_company_id)?_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',[_c('div',{staticClass:"form-group col-md-12"},[_c('h5',[_vm._v("Wolt")]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),(!_vm.location.wolt_is_integrated)?_c('span',[_c('label',{staticClass:"pad-bt-5",attrs:{"for":"getOntoWolt"}},[_vm._v(_vm._s(_vm.$t('wolt.integrateLocation')))]),_vm._v(" "),_c('div',{attrs:{"name":"getOntoWolt"}},[_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.redirectToWolt()}}},[_vm._v(_vm._s(_vm.$t('wolt.getWolt')))])],1)]):_vm._e(),_vm._v(" "),(_vm.location.wolt_is_integrated)?_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-1"},[_c('label',[_vm._v(_vm._s(_vm.$t('bolt.menu')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.update')},on:{"click":function($event){$event.preventDefault();_vm.updateWoltMenu()}}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.update'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-1"},[_c('label',[_vm._v(_vm._s(_vm.$t('wolt.updateCredentials')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('wolt.updateCredentials')},on:{"click":function($event){$event.preventDefault();_vm.redirectToWolt()}}},[_vm._v("\n                        "+_vm._s(_vm.$t('wolt.redirectToWolt'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-1"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.available_days')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.update')},on:{"click":function($event){$event.preventDefault();_vm.updateWoltSchedule()}}},[_vm._v("\n                        "+_vm._s(_vm.$t('general.update'))+"\n                      ")])])]),_vm._v(" "),_vm._l((_vm.woltSchedule),function(day,dayIdx){return _c('div',{key:dayIdx,staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","name":("day-checkbox-" + dayIdx),"id":("day-checkbox-" + dayIdx)},domProps:{"checked":Array.isArray(day.open)?_vm._i(day.open,null)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":("day-checkbox-" + dayIdx)}},[_vm._v("\n                              "+_vm._s(_vm._f("capitalize")(_vm.$t('days.' + dayIdx)))+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._l((day.intervals),function(interval,intervalKey){return [_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                              "+_vm._s(_vm.$t('menuLink.from'))+"\n                              "),_c('el-time-select',{staticStyle:{"width":"150px","display":"inline-block","vertical-align":"middle"},attrs:{"disabled":!day.open,"placeholder":"Start time","picker-options":_vm.pickerOptions},model:{value:(interval.opening_time),callback:function ($$v) {_vm.$set(interval, "opening_time", $$v)},expression:"interval.opening_time"}}),_vm._v("\n                              "+_vm._s(_vm.$t('menuLink.to'))+"\n                              "),_c('el-select',{staticStyle:{"width":"150px","display":"inline-block","vertical-align":"middle"},attrs:{"disabled":!day.open,"placeholder":"End time","filterable":""},model:{value:(interval.closing_time),callback:function ($$v) {_vm.$set(interval, "closing_time", $$v)},expression:"interval.closing_time"}},_vm._l((_vm.boltEndTimeOptions),function(time){return _c('el-option',{key:'wolt-end-time-' + time,attrs:{"label":time,"value":time}})})),_vm._v(" "),(intervalKey != 0)?_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.deleteWoltIntervals(intervalKey, dayIdx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})]):_vm._e()],1)]}),_vm._v(" "),_c('button',{staticClass:"btn add",staticStyle:{"margin-left":"10px"},attrs:{"title":_vm.$t('general.add') + ' moreIntervals'},on:{"click":function($event){$event.preventDefault();_vm.addMoreWoltIntervals(dayIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                            "+_vm._s(_vm.$t('general.add'))+"\n                          ")])],2)])])])})],2):_vm._e(),_vm._v(" "),(_vm.location.wolt_is_integrated)?_c('p-switch',{staticClass:"mar-bt-0",attrs:{"type":"success","name":"wolt-orders"},on:{"input":function($event){_vm.handleWoltStatus()}},model:{value:(_vm.woltStatus),callback:function ($$v) {_vm.woltStatus=$$v},expression:"woltStatus"}}):_vm._e(),_vm._v(" "),(_vm.location.wolt_is_integrated)?_c('label',{attrs:{"for":"wolt-orders"}},[_vm._v(_vm._s(_vm.$t('bolt.acceptOrders')))]):_vm._e()],1)])])])]):_vm._e(),_vm._v(" "),(_vm.location.bolt_company_id)?_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',[_c('div',{staticClass:"form-group col-md-12"},[_c('h5',[_vm._v("Bolt Food")]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-1"},[_c('label',[_vm._v(_vm._s(_vm.$t('bolt.menu')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.update')},on:{"click":function($event){$event.preventDefault();_vm.updateBoltMenu()}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.update'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-1"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.available_days')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.update')},on:{"click":function($event){$event.preventDefault();_vm.updateBoltSchedule()}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.update'))+"\n                    ")])])]),_vm._v(" "),_vm._l((_vm.boltSchedule),function(day,dayIdx){return _c('div',{key:dayIdx,staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","name":("day-checkbox-" + dayIdx),"id":("day-checkbox-" + dayIdx)},domProps:{"checked":Array.isArray(day.open)?_vm._i(day.open,null)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":("day-checkbox-" + dayIdx)}},[_vm._v("\n                            "+_vm._s(_vm._f("capitalize")(_vm.$t('days.' + dayIdx)))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._l((day.intervals),function(interval,intervalKey){return [_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                            "+_vm._s(_vm.$t('menuLink.from'))+"\n                            "),_c('el-time-select',{staticStyle:{"width":"150px","display":"inline-block","vertical-align":"middle"},attrs:{"disabled":!day.open,"placeholder":"Start time","picker-options":_vm.pickerOptions},model:{value:(interval.start_at_minutes_from_midnight),callback:function ($$v) {_vm.$set(interval, "start_at_minutes_from_midnight", $$v)},expression:"interval.start_at_minutes_from_midnight"}}),_vm._v("\n                            "+_vm._s(_vm.$t('menuLink.to'))+"\n                            "),_c('el-select',{staticStyle:{"width":"150px","display":"inline-block","vertical-align":"middle"},attrs:{"disabled":!day.open,"placeholder":"End time","filterable":""},model:{value:(interval.stop_at_minutes_from_midnight),callback:function ($$v) {_vm.$set(interval, "stop_at_minutes_from_midnight", $$v)},expression:"interval.stop_at_minutes_from_midnight"}},_vm._l((_vm.boltEndTimeOptions),function(time){return _c('el-option',{key:'bolt-end-time-' + time,attrs:{"label":time,"value":time}})})),_vm._v(" "),(intervalKey != 0)?_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.deleteBoltIntervals(intervalKey, dayIdx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})]):_vm._e()],1)]}),_vm._v(" "),_c('button',{staticClass:"btn add",staticStyle:{"margin-left":"10px"},attrs:{"title":_vm.$t('general.add') + ' moreIntervals'},on:{"click":function($event){$event.preventDefault();_vm.addMoreBoltIntervals(dayIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                          "+_vm._s(_vm.$t('general.add'))+"\n                        ")])],2)])])])})],2),_vm._v(" "),_c('p-switch',{staticClass:"mar-bt-0",attrs:{"type":"success","name":"bolt-orders"},on:{"input":function($event){_vm.handleBoltStatus()}},model:{value:(_vm.boltStatus),callback:function ($$v) {_vm.boltStatus=$$v},expression:"boltStatus"}}),_vm._v(" "),_c('label',{attrs:{"for":"bolt-orders"}},[_vm._v(_vm._s(_vm.$t('bolt.acceptOrders')))])],1)])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',[_c('div',{staticClass:"form-group col-md-12"},[_c('h5',[_vm._v("R System")]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('r-system-setup',{ref:"rSystemSetup",attrs:{"location":_vm.location},on:{"busy":function($event){_vm.rSystemBusy = $event},"saved":function($event){_vm.$set(_vm.location, 'r_system_company', $event)}}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',[_c('div',{staticClass:"form-group col-md-12"},[_c('h5',[_vm._v(_vm._s(_vm.$t('ebriza.title')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"mb-3 w-100 mar-bt-15"},[_c('label',[_vm._v(_vm._s(_vm.$t('ebriza.woltDriveErrorsUrl')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.wolt_drive_errors_url),expression:"location.wolt_drive_errors_url"}],staticClass:"form-control",attrs:{"type":"text","name":"wolt_drive_errors_url","placeholder":"https://ebriza.ro/send/logs/here"},domProps:{"value":(_vm.location.wolt_drive_errors_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "wolt_drive_errors_url", $event.target.value)}}})])])])])])])])])]),_vm._v(" "),(_vm.location.posnet_company_id)?_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12",staticStyle:{"display":"flex","align-items":"center","gap":"15px"}},[_c('div',{staticClass:"col-md-4",staticStyle:{"display":"flex","align-items":"center","padding-left":"0"}},[_c('p-switch',{staticClass:"mar-bt-0",attrs:{"type":"success","name":"posnet-report"},on:{"input":_vm.handlePosnetReportToggle},model:{value:(_vm.location.posnet_company_show_report),callback:function ($$v) {_vm.$set(_vm.location, "posnet_company_show_report", $$v)},expression:"location.posnet_company_show_report"}}),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"0","margin-left":"8px"}},[_vm._v(_vm._s(_vm.$t('posnet.enableReport')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4",staticStyle:{"display":"flex","align-items":"center","padding-left":"0"}},[_c('label',{staticStyle:{"margin-bottom":"0","margin-right":"8px"}},[_vm._v(_vm._s(_vm.$t('posnet.reportDate')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"flex":"1"},attrs:{"type":"date","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","clearable":""},on:{"change":_vm.handlePosnetDateChange,"focus":_vm.handlePosnetDateFocus,"visible-change":_vm.handlePosnetDateVisible},model:{value:(_vm.location.posnet_company_report_date),callback:function ($$v) {_vm.$set(_vm.location, "posnet_company_report_date", $$v)},expression:"location.posnet_company_report_date"}})],1)])])])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'menu-actions'),expression:"currentSection === 'menu-actions'"}],attrs:{"id":"menu-actions"}},[_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"flex-container"},[_c('h5',[_vm._v(_vm._s(_vm.$t('upload.uploadMenuTemplateLabel')))]),_vm._v(" "),(_vm.location && _vm.location.true_id)?_c('button',{staticClass:"btn btn-info import-history-btn",attrs:{"type":"button"},on:{"click":_vm.openImportHistory}},[_c('i',{staticClass:"ti-list"}),_vm._v("\n                    "+_vm._s(_vm.$t('productImport.importHistory'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row import-steps"},[_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 mar-bt-15 import-step"},[_c('div',{staticClass:"import-step__head"},[_c('span',{staticClass:"import-step__badge"},[_vm._v("1")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('productImport.step1Title')))])]),_vm._v(" "),_c('div',{staticClass:"import-step__body"},[_c('p',{staticClass:"import-step__hint text-muted"},[_vm._v(_vm._s(_vm.$t('productImport.step1Intro')))]),_vm._v(" "),_c('div',{staticClass:"import-option"},[_c('div',{staticClass:"import-option__label"},[_vm._v(_vm._s(_vm.$t('productImport.optionEmptyTitle')))]),_vm._v(" "),_c('p',{staticClass:"import-option__desc text-muted"},[_vm._v(_vm._s(_vm.$t('productImport.optionEmptyDesc')))]),_vm._v(" "),_c('a',{attrs:{"name":"download","href":_vm.downloadImportHref,"target":"_blank"}},[_c('button',{staticClass:"btn btn-info import-step__btn",attrs:{"type":"button"},on:{"click":function($event){_vm.downloadForm()}}},[_vm._v(_vm._s(_vm.$t('productImport.downloadEmptyForm')))])])]),_vm._v(" "),_c('div',{staticClass:"import-option import-option--secondary"},[_c('div',{staticClass:"import-option__label"},[_vm._v(_vm._s(_vm.$t('productImport.optionExportTitle')))]),_vm._v(" "),_c('p',{staticClass:"import-option__desc text-muted"},[_vm._v(_vm._s(_vm.$t('productImport.optionExportDesc')))]),_vm._v(" "),_c('label',{staticClass:"pad-bt-5"},[_vm._v(_vm._s(_vm.$t('productImport.selectPriceProfile')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":_vm.$t('productImport.selectPriceProfile'),"disabled":_vm.creatingDefaultPriceProfile},model:{value:(_vm.selectedPriceProfileId),callback:function ($$v) {_vm.selectedPriceProfileId=$$v},expression:"selectedPriceProfileId"}},_vm._l((_vm.locationPriceProfiles),function(profile){return _c('el-option',{key:profile.id,attrs:{"label":profile.name,"value":profile.id}})})),_vm._v(" "),_c('p',{staticClass:"import-option__note text-muted"},[_vm._v(_vm._s(_vm.$t('productImport.defaultPriceListHint')))]),_vm._v(" "),_c('div',{staticClass:"import-option__actions",staticStyle:{"display":"flex","align-items":"center","flex-wrap":"nowrap","gap":"8px"}},[(_vm.canExportProducts)?_c('a',{attrs:{"href":_vm.exportProductsHref,"target":"_blank"}},[_c('button',{staticClass:"btn btn-info import-step__btn",attrs:{"type":"button"}},[_vm._v(_vm._s(_vm.$t('productImport.exportProducts')))])]):_c('button',{staticClass:"btn btn-info import-step__btn",attrs:{"type":"button","disabled":"","title":_vm.exportDisabledReason}},[_vm._v(_vm._s(_vm.$t('productImport.exportProducts')))]),_vm._v(" "),(_vm.canExportImages)?_c('a',{attrs:{"href":_vm.exportImagesHref,"target":"_blank"}},[_c('button',{staticClass:"btn btn-info import-step__btn",staticStyle:{"font-size":"12px","padding":"4px 10px"},attrs:{"type":"button"}},[_vm._v(_vm._s(_vm.$t('productImport.exportImages')))])]):_c('button',{staticClass:"btn btn-info import-step__btn",staticStyle:{"font-size":"12px","padding":"4px 10px"},attrs:{"type":"button","disabled":"","title":_vm.exportImagesDisabledReason}},[_vm._v(_vm._s(_vm.$t('productImport.exportImages')))])]),_vm._v(" "),(!_vm.locationHasProducts)?_c('p',{staticClass:"import-option__note text-muted"},[_vm._v(_vm._s(_vm.$t('productImport.noProductsForExport')))]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 mar-bt-15 import-step"},[_c('div',{staticClass:"import-step__head"},[_c('span',{staticClass:"import-step__badge"},[_vm._v("2")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('productImport.step2Title')))])]),_vm._v(" "),_c('div',{staticClass:"import-step__body"},[_c('p',{staticClass:"text-muted",staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.$t('productImport.step2Body')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 mar-bt-15 import-step"},[_c('div',{staticClass:"import-step__head"},[_c('span',{staticClass:"import-step__badge"},[_vm._v("3")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('productImport.step3Title')))])]),_vm._v(" "),_c('div',{staticClass:"import-step__body"},[_c('p',{staticClass:"import-step__hint text-muted"},[_vm._v(_vm._s(_vm.$t('productImport.step3Hint')))]),_vm._v(" "),_c('archive-input',{attrs:{"location":_vm.location}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 mar-bt-15 import-step"},[_c('div',{staticClass:"import-step__head"},[_c('span',{staticClass:"import-step__badge"},[_vm._v("4")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t('productImport.step4Title')))])]),_vm._v(" "),_c('div',{staticClass:"import-step__body"},[_c('p',{staticClass:"import-step__hint text-muted"},[_vm._v(_vm._s(_vm.$t('productImport.step4Hint')))]),_vm._v(" "),_c('import-products-input',{attrs:{"location":_vm.location}})],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('productImport.legacyTitle')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"pad-bt-5",attrs:{"for":"download-legacy"}},[_vm._v(_vm._s(_vm.$t('upload.downloadImportProductsTemplate')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"name":"download-legacy","href":_vm.downloadLegacyImportHref,"target":"_blank"}},[_c('el-button',{staticClass:"btn add",attrs:{"size":"small","type":"primary"}},[_vm._v(_vm._s(_vm.$t('upload.downloadButton')))])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('archive-input',{attrs:{"location":_vm.location}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('import-products-legacy-input',{attrs:{"location":_vm.location}})],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-containerf1"},[_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.menuActions')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),(_vm.allLocations.length > 1)?[_vm._v("\n                  "+_vm._s(_vm.$t('settingCompany.copyProductsFrom'))+"\n                  "),_c('select',{ref:"copyFrom",staticClass:"select-primary form-control inline-auto mar-lt-5"},[_vm._l((_vm.allLocations),function(l){return [(l.id !== _vm.location.id)?_c('option',{staticClass:"select-primary",domProps:{"value":l.id}},[_vm._v(_vm._s(l.name)+"\n                      ")]):_vm._e()]})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-icon duplicate-prod mar-to--5 mar-lt-5",on:{"click":function($event){$event.preventDefault();_vm.copyProducts()}}},[_c('i',{staticClass:"fa fa-copy"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-icon duplicate-prod mar-to--5 mar-lt-5",on:{"click":function($event){$event.preventDefault();_vm.addLocationToProducts()}}},[_vm._v(_vm._s(_vm.$t('settingCompany.copyBtn')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]:_vm._e(),_vm._v("\n                "+_vm._s(_vm.$t('settingCompany.deleteProducts'))+"\n                "),_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteProducts(_vm.location.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")])],2)])])]),_vm._v(" "),_c('div',{staticClass:"width-50"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'taxes'),expression:"currentSection === 'taxes'"}],staticClass:"card location-card",attrs:{"id":"taxes"}},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('vat.generalTaxes')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('table',{staticClass:"table mar-bt-0"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.single')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.type')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('settingTaxes.amount')))]),_vm._v(" "),_c('th',{staticStyle:{"padding-left":"55px"}},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.posid')))]),_vm._v(" "),_c('th',{staticStyle:{"padding-left":"55px"}},[_vm._v(_vm._s(_vm.$t('general.tips_department_id')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.location.taxes),function(taxRate,taxIndex){return _c('tr',[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(taxRate.id),expression:"taxRate.id"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",on:{"input":function($event){_vm.updateVatPrinterId($event, taxIndex)},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(taxRate, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.taxes),function(tax){return _c('option',{attrs:{"data-name":tax.name,"disabled":_vm.disableTaxOption(_vm.location.id, tax.id) && tax.id != taxRate.id},domProps:{"value":tax.id}},[_vm._v(_vm._s(tax.name)+"\n                        ")])})),_vm._v(" "),(_vm.errors.has(taxRate.hash_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError(taxRate.hash_id))+"\n                      ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(taxRate.type),expression:"taxRate.type"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",attrs:{"name":'type'+taxRate.id},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(taxRate, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"FIXED_EXCLUDED"}},[_vm._v(_vm._s(_vm.$t('taxTypes.FIXED_EXCLUDED')))]),_vm._v(" "),_c('option',{attrs:{"value":"PERCENTAGE_EXCLUDED"}},[_vm._v(_vm._s(_vm.$t('taxTypes.PERCENTAGE_EXCLUDED')))])])]),_vm._v(" "),_c('td',[_c('label',{staticClass:"label-currency"},[_vm._v(_vm._s(taxRate.type == 'FIXED_EXCLUDED' ? _vm.currency : '%'))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(taxRate.amount),expression:"taxRate.amount"},{name:"validate",rawName:"v-validate",value:({required: true, min_value:0}),expression:"{required: true, min_value:0}"}],staticClass:"form-control field-currency",attrs:{"type":"number","min":"0","name":'amount'+taxRate.id},domProps:{"value":(taxRate.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(taxRate, "amount", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(taxRate.pos_id),expression:"taxRate.pos_id"}],staticClass:"form-control field-currency",attrs:{"type":"number","min":"0","name":'pos_id'+taxRate.pos_id},domProps:{"value":(taxRate.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(taxRate, "pos_id", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(taxRate.department_id),expression:"taxRate.department_id"}],staticClass:"form-control field-currency",staticStyle:{"max-width":"150px"},attrs:{"type":"number","min":"0","name":'department_id'+taxRate.department_id},domProps:{"value":(taxRate.department_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(taxRate, "department_id", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-icon pull-right",on:{"click":function($event){$event.preventDefault();_vm.deleteTax(_vm.location.id, taxRate.id)}}},[_c('i',{staticClass:"ti-trash ",attrs:{"title":"Remove"}})])])])}),_vm._v(" "),(_vm.location.taxes.length < _vm.taxes.length)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]):_vm._e()],2)]),_vm._v(" "),(_vm.location.taxes.length < _vm.taxes.length)?_c('button',{staticClass:"btn add mar-to-15",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingTaxes.single')},on:{"click":function($event){$event.preventDefault();_vm.addNewTax(_vm.location.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"help-block warning mb-0"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('settingTaxes.notice3'))+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goToCompany()}}},[_vm._v(_vm._s(_vm.$t('settingTaxes.notice4')))]),_vm._v(".")])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'vat'),expression:"currentSection === 'vat'"}],staticClass:"card location-card",attrs:{"id":"vat"}},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('catalogCateg.vat'))+" ("+_vm._s(_vm.$t('catalogCateg.included'))+")")]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('table',{staticClass:"table mar-bt-0 location-vat-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"location-vat-th",attrs:{"width":"25%"}},[_c('span',{staticClass:"location-vat-th-inner"},[_vm._v(_vm._s(_vm.$t('catalogCateg.vat')))])]),_vm._v(" "),_c('th',{staticClass:"location-vat-th",attrs:{"width":"25%"}},[_c('span',{staticClass:"location-vat-th-inner"},[_vm._v(_vm._s(_vm.$t('settingTaxes.type')))])]),_vm._v(" "),_c('th',{staticClass:"location-vat-th",attrs:{"width":"20%"}},[_c('span',{staticClass:"location-vat-th-inner"},[_vm._v(_vm._s(_vm.$t('settingTaxes.amount')))])]),_vm._v(" "),_c('th',{staticClass:"location-vat-th",attrs:{"width":"20%"}},[_c('span',{staticClass:"location-vat-th-inner"},[_vm._v(_vm._s(_vm.$t('settingCompany.vatPrinterIdColumn')))])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.location.vat),function(taxRate,vatIndex){return _c('tr',[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(taxRate.tax_id),expression:"taxRate.tax_id"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(taxRate, "tax_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.vat),function(tax){return _c('option',{attrs:{"disabled":_vm.disableVatOption(tax.id) && tax.id != taxRate.tax_id},domProps:{"value":tax.id}},[_vm._v(_vm._s(tax.name))])})),_vm._v(" "),(_vm.errors.has(taxRate.hash_id))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError(taxRate.hash_id))+"\n                      ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],staticClass:"form-control",attrs:{"disabled":"","name":'type'+taxRate.id}},[_c('option',{attrs:{"selected":"true","value":"PERCENTAGE_EXCLUDED"}},[_vm._v(_vm._s(_vm.$t('taxTypes.PERCENTAGE_EXCLUDED')))])])]),_vm._v(" "),_c('td',[_c('label',{staticClass:"label-currency"},[_vm._v(_vm._s(taxRate.type == 'FIXED_EXCLUDED' ? _vm.currency : '%'))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(taxRate.amount),expression:"taxRate.amount"},{name:"validate",rawName:"v-validate",value:({required: true, min_value:0}),expression:"{required: true, min_value:0}"}],staticClass:"form-control field-currency",attrs:{"type":"number","min":"0","name":'amount'+taxRate.id},domProps:{"value":(taxRate.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(taxRate, "amount", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"vat-printer-td",class:{'has-error': _vm.errors.has(_vm.vatPrinterFieldName(taxRate, vatIndex))}},[_c('div',{staticClass:"vat-printer-input-wrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(taxRate.printer_id),expression:"taxRate.printer_id"},{name:"validate",rawName:"v-validate",value:({ required: true, numeric: true, min_value: 0, max_value: 10 }),expression:"{ required: true, numeric: true, min_value: 0, max_value: 10 }"}],staticClass:"form-control field-currency",attrs:{"type":"number","min":"0","max":"10","placeholder":_vm.$t('settingCompany.integrators_tax_vat_printer_id'),"name":_vm.vatPrinterFieldName(taxRate, vatIndex)},domProps:{"value":(taxRate.printer_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(taxRate, "printer_id", $event.target.value)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.vatPrinterFieldName(taxRate, vatIndex))),expression:"errors.has(vatPrinterFieldName(taxRate, vatIndex))"}],staticClass:"vat-printer-error-abs"},[_c('small',{staticClass:"text-danger vat-printer-error"},[_vm._v("\n                            "+_vm._s(_vm.localizedValidatorMessage(_vm.vatPrinterFieldName(taxRate, vatIndex)))+"\n                          ")])])])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-icon pull-right",on:{"click":function($event){$event.preventDefault();_vm.deleteVat(taxRate.id, vatIndex)}}},[_c('i',{staticClass:"ti-trash ",attrs:{"title":"Remove"}})])])])}),_vm._v(" "),(!_vm.location.vat || _vm.location.vat.length < _vm.vat.length)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]):_vm._e()],2)]),_vm._v(" "),(!_vm.location.vat || _vm.location.vat.length < _vm.vat.length)?_c('button',{staticClass:"btn add mar-to-15",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingTaxes.single')},on:{"click":function($event){$event.preventDefault();_vm.addNewVat()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"help-block warning mb-0"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('settingTaxes.notice5'))+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goToCompany()}}},[_vm._v(_vm._s(_vm.$t('settingTaxes.notice4')))]),_vm._v(".")])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'printer'),expression:"currentSection === 'printer'"}],staticClass:"card location-card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.accessAndVisibility')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.hideFromPlatforms')))]),_vm._v(" "),_c('v-select',{staticClass:"line-heigth-44",attrs:{"multiple":"","options":_vm.locationPlatforms,"label":"name","placeholder":_vm.$t('catalogProd.timeOptionsValues.none')},model:{value:(_vm.selectedHiddenPlatforms),callback:function ($$v) {_vm.selectedHiddenPlatforms=$$v},expression:"selectedHiddenPlatforms"}})],1)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'printer'),expression:"currentSection === 'printer'"}],staticClass:"card-containerf1",attrs:{"id":"printer"}},[_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.cardPaymentDetails')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.paymentGroup')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.payment_group),expression:"location.payment_group"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.paymentGroups),expression:"modelValidate.paymentGroups"}],staticClass:"select-primary form-control",attrs:{"name":"paymentGroups"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.location, "payment_group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.paymentGroups),function(pId,pVal){return _c('option',{staticClass:"select-primary",domProps:{"value":pVal}},[_vm._v(_vm._s(pId)+"\n                      ")])}))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.posDiscount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.id_discount_pos),expression:"location.id_discount_pos"}],staticClass:"form-control",attrs:{"type":"text","name":"posDiscount"},domProps:{"value":(_vm.location.id_discount_pos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "id_discount_pos", $event.target.value)}}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.transport_setings')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.email_transport),callback:function ($$v) {_vm.$set(_vm.location, "email_transport", $$v)},expression:"location.email_transport"}},[_vm._v(_vm._s(_vm.$t('settingCompany.email_transport')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('br'),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.google_maps_api_key')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.google_maps_api_key),expression:"location.google_maps_api_key"}],staticClass:"form-control",attrs:{"type":"text","name":"google_maps_api_key","placeholder":_vm.$t('settingCompany.google_maps_api_key')},domProps:{"value":(_vm.location.google_maps_api_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "google_maps_api_key", $event.target.value)}}})])])])])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'printer'),expression:"currentSection === 'printer'"}],attrs:{"id":"printer"}},[_c('div',{staticClass:"card-containerf1"},[_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.lateOrders')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.use_twilio),callback:function ($$v) {_vm.$set(_vm.location, "use_twilio", $$v)},expression:"location.use_twilio"}},[_vm._v(_vm._s(_vm.$t('settingCompany.twilio_call')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{attrs:{"disabled":!_vm.location.use_twilio},model:{value:(_vm.location.use_twilio_early_mark),callback:function ($$v) {_vm.$set(_vm.location, "use_twilio_early_mark", $$v)},expression:"location.use_twilio_early_mark"}},[_vm._v("\n                  "+_vm._s(_vm.$t('settingCompany.twilio_call_early_mark'))+"\n                  ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"phone"}},[_vm._v("\n                    "+_vm._s(_vm.$t('reports.phone'))+" Twilio\n                  ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.twilio_phone),expression:"location.twilio_phone"}],staticClass:"form-control",attrs:{"type":"text","id":"phone","placeholder":"+40770123123"},domProps:{"value":(_vm.location.twilio_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "twilio_phone", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.tipSuggestion')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('settingCompany.tipSuggestionType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.tip_suggestion.type),expression:"location.tip_suggestion.type"}],staticClass:"form-control",on:{"input":function($event){_vm.handleTipType($event)},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.location.tip_suggestion, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"fix"}},[_vm._v("Fix")]),_vm._v(" "),_c('option',{attrs:{"value":"proc"}},[_vm._v("Procent")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"sugestion1"}},[_vm._v(_vm._s(_vm.$t('settingCompany.tipSuggestionSuggestion'))+" 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.tip_suggestion.values[0]),expression:"location.tip_suggestion.values[0]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"sugestion1"},domProps:{"value":(_vm.location.tip_suggestion.values[0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.tip_suggestion.values, 0, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"sugestion1"}},[_vm._v(_vm._s(_vm.$t('settingCompany.tipSuggestionSuggestion'))+" 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.tip_suggestion.values[1]),expression:"location.tip_suggestion.values[1]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"sugestion1"},domProps:{"value":(_vm.location.tip_suggestion.values[1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.tip_suggestion.values, 1, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"sugestion1"}},[_vm._v(_vm._s(_vm.$t('settingCompany.tipSuggestionSuggestion'))+" 3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.tip_suggestion.values[2]),expression:"location.tip_suggestion.values[2]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"sugestion1"},domProps:{"value":(_vm.location.tip_suggestion.values[2])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.tip_suggestion.values, 2, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"sugestion1"}},[_vm._v(_vm._s(_vm.$t('settingCompany.tipSuggestionSuggestion'))+" 4")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.tip_suggestion.values[3]),expression:"location.tip_suggestion.values[3]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"sugestion1"},domProps:{"value":(_vm.location.tip_suggestion.values[3])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.tip_suggestion.values, 3, $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.discountSuggestion')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.discountSuggestionFix')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"discountSugestionFix1"}},[_vm._v(_vm._s(_vm.$t('settingCompany.discountSuggestionSuggestion'))+" 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.discount_suggestion.fix[0]),expression:"location.discount_suggestion.fix[0]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"discountSugestionFix1"},domProps:{"value":(_vm.location.discount_suggestion.fix[0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.discount_suggestion.fix, 0, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"discountSugestionFix2"}},[_vm._v(_vm._s(_vm.$t('settingCompany.discountSuggestionSuggestion'))+" 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.discount_suggestion.fix[1]),expression:"location.discount_suggestion.fix[1]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"discountSugestionFix2"},domProps:{"value":(_vm.location.discount_suggestion.fix[1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.discount_suggestion.fix, 1, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"discountSugestionFix3"}},[_vm._v(_vm._s(_vm.$t('settingCompany.discountSuggestionSuggestion'))+" 3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.discount_suggestion.fix[2]),expression:"location.discount_suggestion.fix[2]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"discountSugestionFix3"},domProps:{"value":(_vm.location.discount_suggestion.fix[2])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.discount_suggestion.fix, 2, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"discountSugestionFix4"}},[_vm._v(_vm._s(_vm.$t('settingCompany.discountSuggestionSuggestion'))+" 4")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.discount_suggestion.fix[3]),expression:"location.discount_suggestion.fix[3]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"discountSugestionFix4"},domProps:{"value":(_vm.location.discount_suggestion.fix[3])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.discount_suggestion.fix, 3, $event.target.value)}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.discountSuggestionProc')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"discountSugestionProc1"}},[_vm._v(_vm._s(_vm.$t('settingCompany.discountSuggestionSuggestion'))+" 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.discount_suggestion.proc[0]),expression:"location.discount_suggestion.proc[0]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"discountSugestionProc1"},domProps:{"value":(_vm.location.discount_suggestion.proc[0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.discount_suggestion.proc, 0, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"discountSugestionProc2"}},[_vm._v(_vm._s(_vm.$t('settingCompany.discountSuggestionSuggestion'))+" 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.discount_suggestion.proc[1]),expression:"location.discount_suggestion.proc[1]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"discountSugestionProc2"},domProps:{"value":(_vm.location.discount_suggestion.proc[1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.discount_suggestion.proc, 1, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"discountSugestionProc3"}},[_vm._v(_vm._s(_vm.$t('settingCompany.discountSuggestionSuggestion'))+" 3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.discount_suggestion.proc[2]),expression:"location.discount_suggestion.proc[2]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"discountSugestionProc3"},domProps:{"value":(_vm.location.discount_suggestion.proc[2])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.discount_suggestion.proc, 2, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"discountSugestionProc4"}},[_vm._v(_vm._s(_vm.$t('settingCompany.discountSuggestionSuggestion'))+" 4")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.discount_suggestion.proc[3]),expression:"location.discount_suggestion.proc[3]"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","id":"discountSugestionProc4"},domProps:{"value":(_vm.location.discount_suggestion.proc[3])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location.discount_suggestion.proc, 3, $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-containerf1"},[_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.printSettings')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.auto_print),callback:function ($$v) {_vm.$set(_vm.location, "auto_print", $$v)},expression:"location.auto_print"}},[_vm._v(_vm._s(_vm.$t('settingCompany.automatPrintOrder')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row mar-bt-10"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.auto_print_local_server),callback:function ($$v) {_vm.$set(_vm.location, "auto_print_local_server", $$v)},expression:"location.auto_print_local_server"}},[_vm._v(_vm._s(_vm.$t('settingCompany.autoPrintLocalServer')))])],1)]),_vm._v(" "),_c('div',{staticClass:"row mar-bt-10"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.use_printer),callback:function ($$v) {_vm.$set(_vm.location, "use_printer", $$v)},expression:"location.use_printer"}},[_vm._v(_vm._s(_vm.$t('settingCompany.autoSendOrderToPrinter')))])],1)]),_vm._v(" "),(_vm.location.use_printer)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.printerIp')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.printer_ip),expression:"location.printer_ip"}],staticClass:"form-control",attrs:{"type":"text","name":"printer_ip","placeholder":_vm.$t('settingCompany.printerIp')},domProps:{"value":(_vm.location.printer_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "printer_ip", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.printerPort')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.printer_port),expression:"location.printer_port"}],staticClass:"form-control",attrs:{"type":"text","name":"printer_port","placeholder":_vm.$t('settingCompany.printerPort')},domProps:{"value":(_vm.location.printer_port)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "printer_port", $event.target.value)}}})])])]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-containerf1"},[_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.reportProductOptionTitle')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.email__prod_opt_report')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.email__prod_opt_report),expression:"location.email__prod_opt_report"}],staticClass:"form-control",attrs:{"type":"text","name":"email__prod_opt_report","placeholder":_vm.$t('settingCompany.email__prod_opt_report')},domProps:{"value":(_vm.location.email__prod_opt_report)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "email__prod_opt_report", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._v("\n                        "+_vm._s(_vm.$t('settingCompany.time__prod_opt_report'))+"\n                          "),_c('el-time-select',{attrs:{"placeholder":"Start time","picker-options":_vm.pickerOptionsReport},model:{value:(_vm.location.time__prod_opt_report),callback:function ($$v) {_vm.$set(_vm.location, "time__prod_opt_report", $$v)},expression:"location.time__prod_opt_report"}})],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.integrators_department')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.integrators_department_id')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.integrators_department_id),expression:"location.integrators_department_id"}],staticClass:"form-control",attrs:{"type":"number","name":"integrators_department_id","placeholder":_vm.$t('settingCompany.integrators_department_id')},domProps:{"value":(_vm.location.integrators_department_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "integrators_department_id", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.integrators_tax_vat_amount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.integrators_tax_vat_amount),expression:"location.integrators_tax_vat_amount"}],staticClass:"form-control",attrs:{"type":"number","name":"integrators_tax_vat_amount","placeholder":_vm.$t('settingCompany.integrators_tax_vat_amount')},domProps:{"value":(_vm.location.integrators_tax_vat_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "integrators_tax_vat_amount", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.errors.has('integrators_tax_vat_printer_id')}},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.integrators_tax_vat_printer_id')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.integrators_tax_vat_printer_id),expression:"location.integrators_tax_vat_printer_id"},{name:"validate",rawName:"v-validate",value:(_vm.integratorsTaxVatPrinterRules),expression:"integratorsTaxVatPrinterRules"}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"10","name":"integrators_tax_vat_printer_id","placeholder":_vm.$t('settingCompany.integrators_tax_vat_printer_id')},domProps:{"value":(_vm.location.integrators_tax_vat_printer_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "integrators_tax_vat_printer_id", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('integrators_tax_vat_printer_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.localizedValidatorMessage('integrators_tax_vat_printer_id'))+"\n                        ")]):_vm._e()])])])])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'invoices'),expression:"currentSection === 'invoices'"}],staticClass:"card location-card",attrs:{"id":"invoices"}},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"flex-container"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.invoicePerOrder')))]),_vm._v(" "),_c('p-switch',{staticClass:"mar-bt-0",attrs:{"type":"success"},model:{value:(_vm.location.smartbill_status),callback:function ($$v) {_vm.$set(_vm.location, "smartbill_status", $$v)},expression:"location.smartbill_status"}})],1),_vm._v(" "),_c('hr',{staticClass:"mar-to-5"})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.apiKey')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: _vm.location.smartbill_status}),expression:"{required: location.smartbill_status}"},{name:"model",rawName:"v-model",value:(_vm.location.smartbill_api_key),expression:"location.smartbill_api_key"}],staticClass:"form-control",attrs:{"disabled":!_vm.location.smartbill_status,"type":"text","name":"street","placeholder":_vm.$t('settingCompany.apiKey')},domProps:{"value":(_vm.location.smartbill_api_key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "smartbill_api_key", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.cif')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.smartbill_cif),expression:"location.smartbill_cif"},{name:"validate",rawName:"v-validate",value:({required: _vm.location.smartbill_status}),expression:"{required: location.smartbill_status}"}],staticClass:"form-control",attrs:{"disabled":!_vm.location.smartbill_status,"type":"text","name":"street","placeholder":_vm.$t('settingCompany.cif')},domProps:{"value":(_vm.location.smartbill_cif)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "smartbill_cif", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.email')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: _vm.location.smartbill_status}),expression:"{required: location.smartbill_status}"},{name:"model",rawName:"v-model",value:(_vm.location.smartbill_email),expression:"location.smartbill_email"}],staticClass:"form-control",attrs:{"disabled":!_vm.location.smartbill_status,"type":"text","name":"street","placeholder":_vm.$t('marketingPromos.email')},domProps:{"value":(_vm.location.smartbill_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "smartbill_email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.series')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.smartbill_series),expression:"location.smartbill_series"},{name:"validate",rawName:"v-validate",value:({required: _vm.location.smartbill_status}),expression:"{required: location.smartbill_status}"}],staticClass:"form-control",attrs:{"disabled":!_vm.location.smartbill_status,"type":"text","name":"street","placeholder":_vm.$t('settingCompany.series')},domProps:{"value":(_vm.location.smartbill_series)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "smartbill_series", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p-checkbox',{attrs:{"disabled":!_vm.location.smartbill_status},model:{value:(_vm.location.smartbill_send_auto),callback:function ($$v) {_vm.$set(_vm.location, "smartbill_send_auto", $$v)},expression:"location.smartbill_send_auto"}},[_vm._v(_vm._s(_vm.$t('settingCompany.automatedInvoice')))]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":!_vm.location.smartbill_status},model:{value:(_vm.location.smartbill_add_to_cc),callback:function ($$v) {_vm.$set(_vm.location, "smartbill_add_to_cc", $$v)},expression:"location.smartbill_add_to_cc"}},[_vm._v(_vm._s(_vm.$t('settingCompany.addToCC')))])],1)])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'digital-waiter'),expression:"currentSection === 'digital-waiter'"}],staticClass:"card location-card",attrs:{"id":"digital-waiter"}},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v(_vm._s(_vm.$t('catalogProdOpt.menuQr')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-2"},[_vm._v("\n                  "+_vm._s(_vm.$t('settingCompany.digitalWaiterMode'))+"\n                  "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.use_dynamic_menu),expression:"location.use_dynamic_menu"}],staticClass:"form-control",on:{"input":function($event){_vm.handleMenu($event)},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.location, "use_dynamic_menu", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.menuType),function(menu){return _c('option',{domProps:{"value":menu.id}},[_vm._v(_vm._s(menu.label))])}))])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),(!_vm.location.use_dynamic_menu)?_c('div',{staticClass:"col-md-6"},[_c('file-input',{attrs:{"location":_vm.location}})],1):_vm._e(),_vm._v(" "),(_vm.location.use_dynamic_menu)?_c('div',{staticClass:"col-md-6"},[(_vm.location.dynamic_qr_code)?_c('display-qr',{attrs:{"location":_vm.location}}):_vm._e()],1):_vm._e()]],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'kiosk-qr-settings'),expression:"currentSection === 'kiosk-qr-settings'"}],attrs:{"id":"kiosk-qr-settings"}},[_c('div',{staticClass:"card-containerf1"},[_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.kioskSettingsTitle')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.kiosk_is_using_top_category),callback:function ($$v) {_vm.$set(_vm.location, "kiosk_is_using_top_category", $$v)},expression:"location.kiosk_is_using_top_category"}},[_vm._v(_vm._s(_vm.$t('settingCompany.kioskUsingTopCategoryLabel')))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('settingCompany.kioskUsingTopCategoryHelp')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 mar-to-15"},[_c('p-checkbox',{model:{value:(_vm.location.kiosk_is_using_fiscal_receipt_for_cash),callback:function ($$v) {_vm.$set(_vm.location, "kiosk_is_using_fiscal_receipt_for_cash", $$v)},expression:"location.kiosk_is_using_fiscal_receipt_for_cash"}},[_vm._v(_vm._s(_vm.$t('settingCompany.kioskFiscalReceiptForCashLabel')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.kiosk_is_using_non_fiscal_receipt_for_card),callback:function ($$v) {_vm.$set(_vm.location, "kiosk_is_using_non_fiscal_receipt_for_card", $$v)},expression:"location.kiosk_is_using_non_fiscal_receipt_for_card"}},[_vm._v(_vm._s(_vm.$t('settingCompany.kioskNonFiscalReceiptForCardLabel')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 mar-to-15"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.kioskAddToCartNotificationPositionLabel')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.location.kiosk_add_to_cart_notification_position),expression:"location.kiosk_add_to_cart_notification_position",modifiers:{"number":true}}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.location, "kiosk_add_to_cart_notification_position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":1}},[_vm._v(_vm._s(_vm.$t('settingCompany.kioskAddToCartNotificationPositionPopup')))]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v(_vm._s(_vm.$t('settingCompany.kioskAddToCartNotificationPositionSidebar')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mar-to-15"},[_c('p-checkbox',{attrs:{"disabled":!_vm.companyLoyaltyInUse},model:{value:(_vm.location.kiosk_allow_fidelities),callback:function ($$v) {_vm.$set(_vm.location, "kiosk_allow_fidelities", $$v)},expression:"location.kiosk_allow_fidelities"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.allow_fidelities')))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('settingsOrdering.allow_fidelitiesHelp')))])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingCompany.reorderPopupTitle')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"reorderPopupMinutes"}},[_vm._v(_vm._s(_vm.$t('settingCompany.reorderPopupMinutes')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.location.reorder_popup_minutes),expression:"location.reorder_popup_minutes",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","id":"reorderPopupMinutes"},domProps:{"value":(_vm.location.reorder_popup_minutes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "reorder_popup_minutes", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('settingCompany.reorderPopupHelp')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mar-to-15"},[_c('p-checkbox',{model:{value:(_vm.location.allow_open_order),callback:function ($$v) {_vm.$set(_vm.location, "allow_open_order", $$v)},expression:"location.allow_open_order"}},[_vm._v(_vm._s(_vm.$t('settingCompany.allowOpenOrderLabel')))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('settingCompany.allowOpenOrderHelp')))])],1)])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSection === 'pos-settings'),expression:"currentSection === 'pos-settings'"}],attrs:{"id":"pos-settings"}},[_c('div',{staticClass:"card-containerf1"},[_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('crossSell.title')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('p',{staticClass:"text-muted mar-bt-10"},[_vm._v(_vm._s(_vm.$t('crossSell.help')))]),_vm._v(" "),(_vm.location && _vm.location.id)?_c('product-cross-sell-picker',{key:'cross-sell-' + _vm.location.id,attrs:{"company-id":_vm.location.company_id,"location-id":_vm.location.true_id || _vm.location.id,"max-items":10},model:{value:(_vm.location.cross_sell_products),callback:function ($$v) {_vm.$set(_vm.location, "cross_sell_products", $$v)},expression:"location.cross_sell_products"}}):_vm._e()],1)])])])]),_vm._v(" "),_c('div',{staticClass:"card location-card width-50"},[_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('form',{staticClass:"clearfix row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('h5',[_vm._v(_vm._s(_vm.$t('settingTable.posSet')))]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.allow_pos_use_coupons),callback:function ($$v) {_vm.$set(_vm.location, "allow_pos_use_coupons", $$v)},expression:"location.allow_pos_use_coupons"}},[_vm._v(_vm._s(_vm.$t('settingTable.allowPosUseCoupons')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.pos_always_set_client),callback:function ($$v) {_vm.$set(_vm.location, "pos_always_set_client", $$v)},expression:"location.pos_always_set_client"}},[_vm._v(_vm._s(_vm.$t('settingTable.posSetClientOnOrder')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.pos_confirm_order_close_on_method_select),callback:function ($$v) {_vm.$set(_vm.location, "pos_confirm_order_close_on_method_select", $$v)},expression:"location.pos_confirm_order_close_on_method_select"}},[_vm._v(_vm._s(_vm.$t('settingTable.pos_confirm_order_close_on_method_select')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.pos_display_all_product_options),callback:function ($$v) {_vm.$set(_vm.location, "pos_display_all_product_options", $$v)},expression:"location.pos_display_all_product_options"}},[_vm._v(_vm._s(_vm.$t('settingTable.posDisplayAllProductOptions')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.pos_allow_group_products),callback:function ($$v) {_vm.$set(_vm.location, "pos_allow_group_products", $$v)},expression:"location.pos_allow_group_products"}},[_vm._v(_vm._s(_vm.$t('settingTable.posAllowGroupProducts')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.force_credit_for_integration_cash_orders),callback:function ($$v) {_vm.$set(_vm.location, "force_credit_for_integration_cash_orders", $$v)},expression:"location.force_credit_for_integration_cash_orders"}},[_vm._v(_vm._s(_vm.$t('settingTable.forceCreditForIntegrationCashOrders')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.pos_use_yumm_voucher),callback:function ($$v) {_vm.$set(_vm.location, "pos_use_yumm_voucher", $$v)},expression:"location.pos_use_yumm_voucher"}},[_vm._v(_vm._s(_vm.$t('settingTable.posUseYummVoucher')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.pos_use_stock),callback:function ($$v) {_vm.$set(_vm.location, "pos_use_stock", $$v)},expression:"location.pos_use_stock"}},[_vm._v(_vm._s(_vm.$t('settingTable.posUseStock')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.pos_ask_storno_back_in_stock),callback:function ($$v) {_vm.$set(_vm.location, "pos_ask_storno_back_in_stock", $$v)},expression:"location.pos_ask_storno_back_in_stock"}},[_vm._v(_vm._s(_vm.$t('settingTable.posAskStornoBackInStock')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.pos_keep_first_waiter_id_order_split),callback:function ($$v) {_vm.$set(_vm.location, "pos_keep_first_waiter_id_order_split", $$v)},expression:"location.pos_keep_first_waiter_id_order_split"}},[_vm._v(_vm._s(_vm.$t('settingTable.pos_keep_first_waiter_id_order_split')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p-checkbox',{model:{value:(_vm.location.pos_display_tips_on_order),callback:function ($$v) {_vm.$set(_vm.location, "pos_display_tips_on_order", $$v)},expression:"location.pos_display_tips_on_order"}},[_vm._v(_vm._s(_vm.$t('settingTable.posDisplayTipsOnOrder')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"details-label mar-rt-10"},[_vm._v(_vm._s(_vm.$t('settingTable.posDefaultCourseCount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.pos_default_course_count),expression:"location.pos_default_course_count"}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"10"},domProps:{"value":(_vm.location.pos_default_course_count)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "pos_default_course_count", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"details-label mar-rt-10 mar-to-5"},[_vm._v(_vm._s(_vm.$t('settingTable.staff_food_daily_budget')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.staff_food_daily_budget),expression:"location.staff_food_daily_budget"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"5"},domProps:{"value":(_vm.location.staff_food_daily_budget)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "staff_food_daily_budget", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12",class:{'has-error': _vm.errors.has('other_taxes_vat_printer_id')}},[_c('label',{staticClass:"details-label mar-rt-10 mar-to-5"},[_vm._v(_vm._s(_vm.$t('settingCompany.other_taxes_vat_printer_id')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.other_taxes_vat_printer_id),expression:"location.other_taxes_vat_printer_id"},{name:"validate",rawName:"v-validate",value:(_vm.otherTaxesVatPrinterRules),expression:"otherTaxesVatPrinterRules"}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"10","name":"other_taxes_vat_printer_id"},domProps:{"value":(_vm.location.other_taxes_vat_printer_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "other_taxes_vat_printer_id", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('other_taxes_vat_printer_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.localizedValidatorMessage('other_taxes_vat_printer_id'))+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12",class:{'has-error': _vm.errors.has('donation_vat_printer_id')}},[_c('label',{staticClass:"details-label mar-rt-10 mar-to-5"},[_vm._v(_vm._s(_vm.$t('settingCompany.donation_vat_printer_id')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.donation_vat_printer_id),expression:"location.donation_vat_printer_id"},{name:"validate",rawName:"v-validate",value:(_vm.donationVatPrinterRules),expression:"donationVatPrinterRules"}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"10","name":"donation_vat_printer_id"},domProps:{"value":(_vm.location.donation_vat_printer_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "donation_vat_printer_id", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('donation_vat_printer_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.localizedValidatorMessage('donation_vat_printer_id'))+"\n                          ")]):_vm._e()])])])])])])])])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group col-md-12",staticStyle:{"margin-bottom":"0px !important"}},[_c('h5',[_vm._v("Posnet")]),_vm._v(" "),_c('hr',{staticClass:"sm"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"location-vat-th location-vat-th-icon"},[_c('span',{staticClass:"location-vat-th-inner"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('hr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rKzl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ManagementClientsAdd_vue__ = __webpack_require__("QxJS");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementClientsAdd: __WEBPACK_IMPORTED_MODULE_5__ManagementClientsAdd_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      selectedVatNumber: null,
      selectedLocationId: '',
      selectedLocation: null,
      vatNumber: null,
      tableData: [],
      editMode: false,
      client: {
        companyName: '',
        abbreviation: '',
        CUI: '',
        registrationNumber: '',
        address: '',
        city: '',
        countries: '',
        bank: '',
        IBAN: '',
        dueDays: null
      },
      searchQuery: ''
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  watch: {
    selectedLocationId: function selectedLocationId(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    selectedVatNumber: function selectedVatNumber(newVat) {
      this.selectedVatNumber = newVat;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },

  computed: {
    filteredClients: function filteredClients() {
      var _this = this;

      if (!this.searchQuery) {
        return this.tableData;
      }

      return this.tableData.filter(function (client) {
        return client.clientName.toLowerCase().includes(_this.searchQuery.toLowerCase());
      });
    }
  },
  methods: {
    onSearch: function onSearch() {
      if (!this.selectedVatNumber) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectateaza locatiați după cod TVA',
          confirmButtonText: 'OK'
        });

        this.tableData = [];
        this.totalItems = 0;
        this.currentPage = 1;
        return;
      }

      this.getClients();
    },
    openAddClientModal: function openAddClientModal() {
      this.editMode = false;
      this.client = {
        companyName: '',
        abbreviation: '',
        CUI: '',
        email: '',
        registrationNumber: '',
        address: '',
        city: '',
        countries: '',
        bank: '',
        IBAN: '',
        dueDays: null,
        id: null,
        _rev: null
      };
      this.$modal.show('addClientModal');
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getClients(this.currentPage, this.pageSize);
    },
    mapCustomerRowToForm: function mapCustomerRowToForm() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return {
        companyName: row.clientName || row.companyName || row.name || '',
        abbreviation: row.abbreviation || '',
        CUI: row.vatNumber || row.cui || row.customerVatNumber || '',
        email: row.email || '',
        registrationNumber: row.registrationNumber || '',
        address: row.address || '',
        city: row.city || '',
        countries: row.countries || '',
        bank: row.bank || '',
        IBAN: row.IBAN || row.iban || '',
        dueDays: row.dueDays != null ? row.dueDays : null,
        id: row.id || row._id || null,
        _rev: row._rev || null,
        externalLocationId: row.externalLocationId || null
      };
    },
    editRow: function editRow(row) {
      this.editMode = true;
      this.client = this.mapCustomerRowToForm(row);
      this.$modal.show('addClientModal');
    },
    getClients: function getClients() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.tableData = [];
                _this2.totalItems = 0;
                _this2.currentPage = 1;

                _context.prev = 3;

                if (_this2.companyID) {
                  _context.next = 7;
                  break;
                }

                console.error('Company ID is missing');
                return _context.abrupt('return');

              case 7:
                if (_this2.selectedVatNumber) {
                  _context.next = 10;
                  break;
                }

                console.warn('VAT number is missing. Skipping product fetch.');
                return _context.abrupt('return');

              case 10:

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  title: 'Se încarcă...',
                  text: 'Așteaptă încărcarea datelor',
                  allowOutsideClick: false,
                  didOpen: function didOpen() {
                    __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.showLoading();
                  }
                });

                clearTimeout(_this2.loadingTimeout);
                _this2.loadingTimeout = setTimeout(function () {
                  _this2.loading = true;
                }, 100);

                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/customers?externalCompanyId=' + _this2.companyID + '&page=' + page + '&limit=' + pageSize;


                if (_this2.selectedVatNumber) {
                  url += '&vatNumber=' + encodeURIComponent(_this2.selectedVatNumber);
                }

                _context.next = 17;
                return fetch(url, {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 17:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 20;
                  break;
                }

                throw new Error('Error fetching clients');

              case 20:
                _context.next = 22;
                return response.json();

              case 22:
                data = _context.sent;

                if (!(!data.customers || !Array.isArray(data.customers))) {
                  _context.next = 25;
                  break;
                }

                throw new Error('Invalid data format: customers not found');

              case 25:

                clearTimeout(_this2.loadingTimeout);
                _this2.loading = false;
                _this2.totalItems = data.total || 0;
                _this2.currentPage = data.currentPage || page;
                _this2.pageSize = data.pageSize || pageSize;

                _this2.tableData = data.customers.map(function (client) {
                  return {
                    id: client._id,
                    _rev: client._rev,
                    clientName: client.name || '',
                    abbreviation: client.abbreviation || '',
                    registrationNumber: client.registrationNumber || '',
                    address: client.address || '',
                    city: client.city || '',
                    countries: client.countries || '',
                    bank: client.bank || '',
                    IBAN: client.IBAN || client.iban || '',
                    dueDays: client.dueDays != null ? client.dueDays : null,
                    cui: client.customerVatNumber || client.vatNumber || '',
                    vatNumber: client.customerVatNumber || client.vatNumber || '',
                    email: client.email || '',
                    externalLocationId: client.externalLocationId || null
                  };
                });

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.close();
                _context.next = 38;
                break;

              case 34:
                _context.prev = 34;
                _context.t0 = _context['catch'](3);

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.close();

                console.error('Error fetching clients:', _context.t0);

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[3, 34]]);
      }))();
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var confirm, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (id) {
                  _context2.next = 3;
                  break;
                }

                console.error('Missing product ID for deletion.');
                return _context2.abrupt('return');

              case 3:
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  title: 'Ești sigur?',
                  text: 'Clientul va fi șters definitiv.',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Da, șterge',
                  cancelButtonText: 'Anulează'
                });

              case 5:
                confirm = _context2.sent;

                if (confirm) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return');

              case 8:
                _context2.prev = 8;
                _context2.next = 11;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    type: 'customer',
                    id: id,
                    externalCompanyId: _this3.companyID
                  })
                });

              case 11:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 14;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 14:
                _context2.next = 16;
                return response.json();

              case 16:
                data = _context2.sent;

                console.log('Client deleted successfully:', data);

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Clientul a fost șters cu succes.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this3.getClients();
                _context2.next = 26;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2['catch'](8);

                console.error('Error deleting client:', _context2.t0);

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o eroare la ștergerea clientului.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[8, 22]]);
      }))();
    }
  }
});

/***/ }),

/***/ "rLJo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"})])]),_vm._v(" "),_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"display-flex",staticStyle:{"align-items":"baseline"}},[_c('div',{staticClass:"col-lg-7 col-md-10 col-sm-12 pad-to-15 display-flex"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"row card-content customer-details"},[_c('div',{staticClass:"col-md-12 title"},[_c('h6',{},[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/user-sm.png"}}),_vm._v(" "+_vm._s(_vm.$t('customers.title')))]),_vm._v(" "),_c('hr',{staticClass:"sm",staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12 box-bg border-top-left-radius border-top-right-radius"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.id')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[(_vm.customer.id)?[_c('span',[_vm._v(_vm._s(_vm.customer.id))])]:[_c('i',{staticClass:"user-details-incomplete"},[_vm._v(" - "+_vm._s(_vm.$t('general.notCompleted'))+" - ")])]],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 box-bg"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.name')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[(_vm.customer.firstname || _vm.customer.lastname )?[_c('span',[_vm._v(_vm._s(_vm.customer.firstname)+" "+_vm._s(_vm.customer.lastname))])]:_vm._e(),_vm._v(" "),(!_vm.customer.firstname && !_vm.customer.lastname)?[_c('i',{staticClass:"user-details-incomplete"},[_vm._v(" - "+_vm._s(_vm.$t('general.notCompleted'))+" - ")])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 box-bg"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.email')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[(_vm.customer.email)?[_c('span',[_vm._v(_vm._s(_vm.customer.email))])]:_vm._e(),_vm._v(" "),(!_vm.customer.email)?[_c('i',{staticClass:"user-details-incomplete"},[_vm._v(" - "+_vm._s(_vm.$t('general.notCompleted'))+" - ")])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 box-bg"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.phone')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[(_vm.customer.phone)?[_c('span',[_vm._v(_vm._s(_vm.customer.phone))])]:_vm._e(),_vm._v(" "),(!_vm.customer.phone)?[_c('i',{staticClass:"user-details-incomplete"},[_vm._v(" - "+_vm._s(_vm.$t('general.notCompleted'))+" - ")])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 box-bg"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.gender')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[(_vm.customer.gender)?[_c('span',[_vm._v(_vm._s(_vm.customer.gender))])]:_vm._e(),_vm._v(" "),(!_vm.customer.gender)?[_c('i',{staticClass:"user-details-incomplete"},[_vm._v(" - "+_vm._s(_vm.$t('general.notCompleted'))+" - ")])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 box-bg"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.birth')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[(_vm.customer.birthdate)?[_c('span',[_vm._v(_vm._s(_vm.formatDate(_vm.customer.birthdate)))])]:_vm._e(),_vm._v(" "),(!_vm.customer.birthdate)?[_c('i',{staticClass:"user-details-incomplete"},[_vm._v(" - "+_vm._s(_vm.$t('general.notCompleted'))+" - ")])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 box-bg"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.dateCreated')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[(_vm.customer.created_at)?[_c('span',[_vm._v(_vm._s(_vm.formatDate(_vm.customer.created_at)))])]:_vm._e(),_vm._v(" "),(!_vm.customer.created_at)?[_c('i',{staticClass:"user-details-incomplete"},[_vm._v(" - "+_vm._s(_vm.$t('general.notCompleted'))+" - ")])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 box-bg"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.address')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[(_vm.customer.addresses && _vm.customer.addresses.length)?[_c('span',[_vm._v(_vm._s(_vm.getUserAddress(_vm.customer.addresses[0])))])]:[_c('i',{staticClass:"user-details-incomplete"},[_vm._v(" - "+_vm._s(_vm.$t('general.notCompleted'))+" - ")])]],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 box-bg"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.myGroups')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[(_vm.customer.my_groups && _vm.customer.my_groups.length)?[_c('div',{staticClass:"customer-groups-list"},_vm._l((_vm.customer.my_groups),function(group){return _c('div',{key:group.id,staticClass:"group-badge",class:{ 'approved': group.is_approved, 'pending': !group.is_approved }},[_c('span',{staticClass:"group-name"},[_vm._v(_vm._s(group.name))]),_vm._v(" "),_c('span',{staticClass:"group-status"},[(group.is_approved)?[_c('i',{staticClass:"fa fa-check-circle text-success"}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t('customers.approved')))])]:[_c('i',{staticClass:"fa fa-clock-o text-warning"}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t('customers.pendingApproval')))])]],2)])}))]:[_c('i',{staticClass:"user-details-incomplete"},[_vm._v(" - "+_vm._s(_vm.$t('customers.noGroups'))+" - ")])]],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 box-bg"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('marketingSubscriptions.customerActiveSubscriptions')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[(_vm.activeSubscriptions.length)?_vm._l((_vm.activeSubscriptions),function(item){return _c('div',{key:'cs' + item.id,staticClass:"customer-subscription",class:'customer-subscription--' + item.state},[_c('strong',[_vm._v(_vm._s(item.subscription ? item.subscription.name : '-'))]),_vm._v(" "),(item.active_until)?_c('span',[_vm._v(" · "+_vm._s(_vm.$t('marketingSubscriptions.until'))+" "+_vm._s(_vm._f("formatDate")(item.active_until)))]):_vm._e(),_vm._v(" "),(!item.auto_renew)?_c('i',{staticClass:"fa fa-ban customer-subscription__norenew",attrs:{"title":_vm.$t('marketingSubscriptions.autoRenew') + ': ' + _vm.$t('marketingSubscriptions.no')}}):_vm._e()])}):_c('i',{staticClass:"user-details-incomplete"},[_vm._v(" - "+_vm._s(_vm.$t('marketingSubscriptions.customerNoSubscriptions'))+" - ")])],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 box-bg"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.pointsTitle')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.customer.loyalty_points))])])])]),_vm._v(" "),(_vm.customer.orders_count)?_c('div',{staticClass:"col-md-12 box-bg"},[_c('h6',[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 pad-bt-10"},[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/orders-icon.png"}}),_vm._v(" "+_vm._s(_vm.$t('menuLink.orders')))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.customer.orders_count))])]),_vm._v(" "),_c('hr',{staticClass:"sm",staticStyle:{"clear":"both"}})]):_vm._e(),_vm._v(" "),(_vm.customer.delivery_orders_count)?_c('div',{staticClass:"col-md-12 box-bg border-bottom-left-radius border-bottom-right-radius"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.deliveryOrders')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.customer.delivery_orders_count))])])])]):_vm._e(),_vm._v(" "),(_vm.customer.pickup_orders_count)?_c('div',{staticClass:"col-md-12 box-bg border-bottom-left-radius border-bottom-right-radius"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.pickupOrders')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.customer.pickup_orders_count))])])])]):_vm._e(),_vm._v(" "),(_vm.customer.meethalfway_orders_count)?_c('div',{staticClass:"col-md-12 box-bg border-bottom-left-radius border-bottom-right-radius"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.meetHalfwayOrders')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.customer.meethalfway_orders_count))])])])]):_vm._e(),_vm._v(" "),(_vm.customer.reservations_count)?_c('div',{staticClass:"col-md-12 box-bg border-bottom-left-radius border-bottom-right-radius"},[_c('div',{staticClass:"row pad-bt-15"},[_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12 details-label"},[_vm._v(_vm._s(_vm.$t('customers.customerReservations')))]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6 col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.customer.reservations_count))])])])]):_vm._e()])])]),_vm._v(" "),(!_vm.is_marketer)?_c('div',{staticClass:"col-lg-7 col-md-10 col-sm-12 pad-to-15 display-flex"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"row card-content money_section"},[_c('div',{staticClass:"col-md-12 title"},[_c('h6',{},[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/points-sm.png"}}),_vm._v(_vm._s(_vm.$t('customers.pointsAddTitle')))]),_vm._v(" "),_c('hr',{staticClass:"sm",staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"details-label mar-rt-10"},[_vm._v(_vm._s(_vm.$t('customers.pointsLabel'))+" ("+_vm._s(_vm.currency)+") "),_c('span',[_vm._v("1 "+_vm._s(_vm.currency)+" = "+_vm._s(_vm.loyalty_value_one_currency)+" "+_vm._s(_vm.loyalty_value_one_currency > 1 ? _vm.$t('customers.points') : _vm.$t('customers.point')))])]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.newPoints.money_spent),expression:"newPoints.money_spent"}],staticClass:"form-control",attrs:{"type":"number","min":"1","disabled":_vm.loyalty_usage == 0},domProps:{"value":(_vm.newPoints.money_spent)},on:{"change":function($event){_vm.calcPoints(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newPoints, "money_spent", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"details-label mar-rt-10"},[_vm._v(_vm._s(_vm.$t('customers.pointsLabelInPoints'))+" "),_c('span',[_vm._v(_vm._s(_vm.loyalty_value_one_point_amount)+" "+_vm._s(_vm.loyalty_value_one_point_amount > 1 ? _vm.$t('customers.points') : _vm.$t('customers.point'))+" = "+_vm._s(_vm.loyalty_value_one_point)+" "+_vm._s(_vm.currency))])]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.newPoints.points_earned),expression:"newPoints.points_earned"}],staticClass:"form-control",attrs:{"type":"number","min":"1","disabled":_vm.loyalty_usage == 0},domProps:{"value":(_vm.newPoints.points_earned)},on:{"change":function($event){_vm.calcPoints(2)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newPoints, "points_earned", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('span',[_vm._v(_vm._s(_vm.$t('customers.clientCanUse'))+" "+_vm._s(_vm.loyalty_value_one_point/_vm.loyalty_value_one_point_amount * _vm.newPoints.points_earned)+" "+_vm._s(_vm.currency))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"details-label mar-rt-10"},[_vm._v(_vm._s(_vm.$t('customers.commentsLabel')))]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.newPoints.comments),expression:"newPoints.comments"}],staticClass:"form-control ",attrs:{"type":"text","min":"1","maxlength":"255","rows":"6","disabled":_vm.loyalty_usage == 0},domProps:{"value":(_vm.newPoints.comments)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newPoints, "comments", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save mar-to-10",attrs:{"type":"submit","disabled":_vm.loyalty_usage == 0,"title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.addPoints($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n                        "+_vm._s(_vm.$t('general.save'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-25"},[_c('h6',{},[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/commentClient-sm.png"}}),_vm._v(_vm._s(_vm.$t('customers.addCommentPerClient')))]),_vm._v(" "),_c('hr',{staticClass:"sm",staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"details-label mar-rt-10"},[_vm._v(_vm._s(_vm.$t('customers.commentsLabel')))]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate"},{name:"model",rawName:"v-model",value:(_vm.customer.comment),expression:"customer.comment"}],staticClass:"form-control ",attrs:{"type":"text","min":"1","rows":"8"},domProps:{"value":(_vm.customer.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "comment", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.addComment($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('general.save'))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-25"},[_c('h6',{},[_c('img',{staticClass:"icon-card-header",staticStyle:{"max-width":"30px"},attrs:{"src":"/static/img/icons/icon-topBar-settings.png"}}),_vm._v(_vm._s(_vm.$t('customers.settings')))]),_vm._v(" "),_c('hr',{staticClass:"sm",staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"details-label mar-rt-10"},[_vm._v(_vm._s(_vm.$t('customers.allow_virament')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.customer.allow_virament),callback:function ($$v) {_vm.$set(_vm.customer, "allow_virament", $$v)},expression:"customer.allow_virament"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.saveSettings($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n                    "+_vm._s(_vm.$t('general.save'))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.customer.user_has_auth_acces)?_vm._l((_vm.customer.user_has_auth_acces),function(location,index){return _c('div',{key:location.true_id,staticClass:"location-item"},[_c('span',[_vm._v(_vm._s(location.name))]),_vm._v(" "),_c('button',{staticClass:"delete-btn",on:{"click":function($event){_vm.removeLocation(location.true_id)}}},[_vm._v("\n                            ✕\n                          ")])])}):_vm._e()],2)])])])]):_vm._e()]),_vm._v(" "),(!_vm.is_marketer)?_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"action-buttons",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"nowrap","gap":"8px","align-items":"flex-end","flex":"0 1 auto","margin-top":"20px","margin-bottom":"20px"}},[_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsPages.dateTime')))]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"name":['date_from', 'date_to'],"disabled":_vm.loading},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('label',[_vm._v(_vm._s(_vm.$t('addOrder.choosePay')))]),_vm._v(" "),_c('el-select',{staticClass:"filter-select",attrs:{"multiple":"","collapse-tags":"","placeholder":_vm.$t('settingsPages.filters')},model:{value:(_vm.selectedPaymentMethod),callback:function ($$v) {_vm.selectedPaymentMethod=$$v},expression:"selectedPaymentMethod"}},_vm._l((_vm.paymentMethods),function(val,key){return _c('el-option',{key:key,attrs:{"label":val.name,"value":val.name}})}))],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.getData}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"cust-sales"},[_c('div',{staticClass:"pull-left"},[_c('span',{staticClass:"details-label"},[_vm._v(_vm._s(_vm.$t('customers.allTimeSale'))+":")]),_c('b',[_vm._v(" "+_vm._s(_vm.formatMoneyAmount(_vm.customer.sales)))])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-bt-0 card-tables"},[_c('div',{staticClass:"row card-content pad-to-0"},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.customer.orders,"action-def":_vm.defaultActionDef(),"pagination-def":_vm.paginationDef,"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"min-width":40,"sortable":"","prop":"number","label":_vm.$t('customers.number')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                #"+_vm._s(props.row.token)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":50,"sortable":"","prop":"date","label":_vm.$t('customers.dateCreated')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatDateTime(props.row.created_at))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":50,"sortable":"","prop":"delivery_type","label":_vm.$t('customers.delivery')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.delivery_type ? _vm.$t('deliveryTypes.' + props.row.delivery_type) : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"sortable":"","prop":"order_type","label":_vm.$t('customers.type')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{class:'text-lowercase'},[_vm._v("\n                "+_vm._s(_vm.$t('ordersTypes.' + props.row.order_type))+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"sortable":"","prop":"status","label":_vm.$t('customers.status')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{class:'label label-' + _vm.orderStatusClass(props.row.status.id)},[_vm._v(_vm._s(_vm.$t('ordersStatus.' + props.row.status.id)))])]}}])}),_vm._v(" "),_c('el-table-column',{class:'text-right',attrs:{"min-width":40,"sortable":"","prop":"payment_type","label":_vm.$t('customers.pay')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.payment_type)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{class:'text-right',attrs:{"min-width":40,"sortable":"","prop":"total","label":_vm.$t('customers.total')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatMoneyAmount(props.row.totals_grandtotal, props.row.currency))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":50},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")])]}}])})],1)],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"card mar-bt-0 card-tables",staticStyle:{"padding":"20px"}},[_c('div',{staticClass:"row card-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"data-table wallet-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.walletTransactions,"empty-text":_vm.$t('gestiune.noData')}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","sortable":"","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"current_value","label":"Amount","sortable":"","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm.formatMoneyAmount(scope.row.current_value))+"\n                  ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type","sortable":"","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm.walletTypeLabel(scope.row))+"\n                  ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"Date","sortable":"","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm.formatDateTime(scope.row.created_at))+"\n                  ")]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"center"},attrs:{"total":_vm.paginationDef2.total,"page-size":_vm.paginationDef2.pageSize,"current-page":_vm.paginationDef2.currentPage,"layout":"prev, pager, next, total"},on:{"current-change":_vm.getWaletData}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 title"},[_c('h6',{},[_c('img',{staticClass:"icon-card-header",attrs:{"src":"/static/img/icons/user-sm.png"}}),_vm._v("Wallet")]),_vm._v(" "),_c('hr',{staticClass:"sm",staticStyle:{"clear":"both"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rMZ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_StreamBarcodeReader_vue__ = __webpack_require__("smpd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_eee31630_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_StreamBarcodeReader_vue__ = __webpack_require__("ji1f");
function injectStyle (ssrContext) {
  __webpack_require__("qQeu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eee31630"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_StreamBarcodeReader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_eee31630_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_StreamBarcodeReader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rNmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2_dist_sweetalert2_css__);





















__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    PPagination: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a),
  props: {},
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.token = this.$session.get('token');
    this.getData();
  },
  data: function data() {
    return {
      statuses: ['RESERVED', 'COMPLETED', 'CANCELED'],
      loading: true,
      token: null,
      apiUrl: null,
      locationDataForTableManagement: [],
      tableData: []
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.loading = true;
      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/get-table-reservations', 'GET', data, function (response) {
        if (response.status === true) {
          _this.tableData = response.data.tables;

          _this.$nextTick(function () {
            _this.loading = false;
          });
        }
      });
    },
    changeStatus: function changeStatus(sts, resTable) {
      var _this2 = this;

      this.loading = true;
      var data = {
        token: this.token,
        company_id: this.$session.get('selectedCompany'),
        status: sts,
        reservation_id: resTable.reservations.id
      };
      this.apiRequest('/edit-reservation', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.tableData = response.data.tables;

          _this2.$nextTick(function () {
            _this2.loading = false;
          });
        }
      });
    },
    formatDateToShowJustDate: function formatDateToShowJustDate(date) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).format('DD-MM-YYYY');
    },
    formatDateToShowJustTime: function formatDateToShowJustTime(date) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).format('hh:mm A');
    },
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy).then(function (e) {}, function (e) {});
    }
  }
});

/***/ }),

/***/ "rPCk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.orderFromReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[(_vm.locations.length)?_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.locations.length ? 'col-md-4' : 'col-md-6'},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectedOrderFormFlags')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterOrderSource),expression:"filterOrderSource"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterOrderSource=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.orderSourceFilterOptions),function(opt){return _c('option',{key:opt.value,domProps:{"value":opt.value}},[_vm._v(_vm._s(opt.label))])})],2)])]),_vm._v(" "),_c('div',{class:_vm.locations.length ? 'col-md-4' : 'col-md-6'},[_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.paymentMethod')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterPaymentMethod),expression:"filterPaymentMethod"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterPaymentMethod=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.paymentMethodFilterGroups),function(group){return _c('optgroup',{key:group.key,attrs:{"label":group.label}},_vm._l((group.options),function(opt){return _c('option',{key:opt.value,domProps:{"value":opt.value}},[_vm._v(_vm._s(opt.label))])}))})],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('chart-bars-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"topProductSales",attrs:{"chart-data":_vm.topProductSales.data,"chart-options":_vm.topProductSales.options}},[(_vm.noData)?[_c('div',{staticClass:"no-data-message",staticStyle:{"text-align":"center","margin":"20px"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('reports.noDataAvailable')))])])]:_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend",staticStyle:{"display":"flex","flex-wrap":"wrap"}},_vm._l((_vm.topProductSales.data.labels),function(label,index){return _c('div',{key:index,staticStyle:{"display":"flex","align-items":"center","margin-right":"12px"}},[_c('i',{staticClass:"fa fa-circle",style:({ color: _vm.colors[index % _vm.colors.length], marginRight: '5px' })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(label)+" - "+_vm._s(_vm.formatReportAmount(_vm.topProductSales.data.series[0][index])))])])}))])],2)],1)]),_vm._v(" "),(_vm.hasReportTotals)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card center-sales-report-stats",staticStyle:{"height":"100% !important"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content"},[_c('div',{staticClass:"report-container"},[_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.total')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatReportAmount(_vm.totalAmount)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.orderCounter')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.totalCounter))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.fiscalReceiptsAmount')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatReportAmount(_vm.fiscalTotal)))])]),_vm._v(" "),_c('div',{staticClass:"report-row"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.nonFiscalReceiptsAmount')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatReportAmount(_vm.nonFiscalTotal)))])])])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"search-def":{show: false},"total":_vm.ordersTableData.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":90,"prop":"order_source_label","label":_vm.$t('reports.source')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.orderSourceLabel(props.row.order_source_label, props.row.order_source_id))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":100,"prop":"payment_method","label":_vm.$t('reports.paymentMethod')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.paymentMethodLabel(props.row.payment_method))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":70,"prop":"counter","label":_vm.$t('reports.orderCounter')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.parseReportNumber(props.row.counter))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":90,"prop":"total","label":_vm.$t('reports.salesChart')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatReportAmount(props.row.total))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":90,"prop":"fiscal_total","label":_vm.$t('reports.fiscalReceiptsAmount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatReportAmount(props.row.fiscal_total))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":90,"prop":"non_fiscal_total","label":_vm.$t('reports.nonFiscalReceiptsAmount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatReportAmount(props.row.non_fiscal_total))+"\n            ")]}}])})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rPE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-inventar-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rVZm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchOrders_vue__ = __webpack_require__("Nxv7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b86d49c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchOrders_vue__ = __webpack_require__("iUih");
function injectStyle (ssrContext) {
  __webpack_require__("OsC+")
  __webpack_require__("nhsC")
  __webpack_require__("u6us")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b86d49c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchOrders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b86d49c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchOrders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rVyl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiscalPrinterAdd_vue__ = __webpack_require__("TO2d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da3fcdb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiscalPrinterAdd_vue__ = __webpack_require__("UM+b");
function injectStyle (ssrContext) {
  __webpack_require__("Grt+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FiscalPrinterAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da3fcdb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiscalPrinterAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "raNR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupOptionsEdit_vue__ = __webpack_require__("aVZQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa58d568_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupOptionsEdit_vue__ = __webpack_require__("gwRB");
function injectStyle (ssrContext) {
  __webpack_require__("gyk7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupOptionsEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa58d568_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupOptionsEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ragw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");













var _components;








__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue_data_tables___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    PPagination: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    callback: {
      required: false
    },
    callbackAdd: {
      required: false
    }
  },
  data: function data() {
    return {
      loading: false,
      isGeneral: true,
      isUsers: false,
      isDispatchers: false,
      tableColumns: [{
        prop: 'firstname',
        label: this.$t('settingUsers.fn'),
        minWidth: 100
      }, {
        prop: 'lastname',
        label: this.$t('settingUsers.ln'),
        minWidth: 100
      }],
      tableData: [],
      autoDispatch: false,
      walletSettings: false,
      disableUndeliveredOrder: false,
      autoGroupingByZone: false,
      newOrdersProcessing: false,
      preparedStatus: false
    };
  },

  computed: {
    filteredTableData: function filteredTableData() {
      return this.tableData.filter(function (user) {
        return user.role === 'DRIVER' || user.role === 'DISPATCHER';
      });
    },
    filteredDispatchersData: function filteredDispatchersData() {
      return this.tableData.filter(function (user) {
        return user.role === 'DISPATCHER';
      });
    }
  },
  mounted: function mounted() {
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },
  created: function created() {
    this.getUsers();
    this.getSettings();

    this.$bus.$on('refresh', this.handleRefresh);
  },

  watch: {
    autoDispatch: function autoDispatch(newValue) {
      this.updateSetting('use_auto_dispatch', newValue);
    },
    walletSettings: function walletSettings(newValue) {
      this.updateSetting('has_wallet_in_version', newValue);
    },
    disableUndeliveredOrder: function disableUndeliveredOrder(newValue) {
      this.updateSetting('disable_undelivered_order', newValue);
    }
  },
  methods: {
    handleRefresh: function handleRefresh() {
      this.getUsers();
    },
    openGeneral: function openGeneral() {
      this.isGeneral = true;
      this.isUsers = false;
      this.isDispatchers = false;
    },
    openUsers: function openUsers() {
      this.isUsers = true;
      this.isGeneral = false;
      this.isDispatchers = false;
    },
    openDispatchers: function openDispatchers() {
      this.isDispatchers = true;
      this.isUsers = false;
      this.isGeneral = false;
    },
    globalGoToRecord: function globalGoToRecord(row, event, path) {
      var userId = row.id;
      this.$router.push('' + path + userId);
    },
    goToRecord: function goToRecord(row, event) {
      if (typeof this.callback === 'function') {
        this.callback(row.id);
      } else {
        this.globalGoToRecord(row, event, '/user/edit/');
      }
    },
    getUsers: function getUsers() {
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/profile', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data;

          self.$nextTick(function () {
            self.loading = false;
          });
        }
      });
    },
    getSettings: function getSettings() {
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/dispatch-get-settings', 'GET', data, function (response) {
        if (response.status === true) {
          self.autoDispatch = response.data.use_auto_dispatch === 1;
          self.walletSettings = response.data.has_wallet_in_version === 1;
          self.disableUndeliveredOrder = response.data.disable_undelivered_order === 1;
          self.loading = false;
        }
      });
    },
    updateSetting: function updateSetting(setting, value) {
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, setting, value ? 1 : 0);

      this.apiRequest('/dispatch-set-settings', 'POST', data, function (response) {
        if (response.status === true) {} else {}
      });
    },
    goToAdd: function goToAdd() {
      this.$router.push({ path: '/user/add', query: { from: 'dispatchSettings' } });
    },
    goToAddDispatcher: function goToAddDispatcher() {
      this.$router.push({ path: '/user/add', query: { from: 'dispatcherSettings' } });
    }
  }
});

/***/ }),

/***/ "rat0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'id': 'pickup',
  'type': 'Pick up'
}, {
  'id': 'halfway',
  'type': 'Meet me half way'
}, {
  'id': 'athome',
  'type': 'At home'
}, {
  'id': 'location',
  'type': 'Consume on location'
}]);

/***/ }),

/***/ "rcIA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScreenView_vue__ = __webpack_require__("oKhd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398439fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScreenView_vue__ = __webpack_require__("S8Ll");
function injectStyle (ssrContext) {
  __webpack_require__("XDm8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-398439fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScreenView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398439fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScreenView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rfzv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoyaltyStoreCampaignForm_vue__ = __webpack_require__("SJ2J");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { LoyaltyStoreCampaignForm: __WEBPACK_IMPORTED_MODULE_0__LoyaltyStoreCampaignForm_vue__["a" /* default */] },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),

/***/ "rhnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row management-integrations-list"},[_c('transition',{attrs:{"name":"integrations-slide","mode":"out-in"}},[(_vm.showIntegrationEditView)?_c('div',{key:"integrations-edit",staticClass:"col-xl-12 col-md-12 col-xs-12 integrations-edit-pane"},[(_vm.showIntegrationFieldForm)?_c('integration-form',{attrs:{"heading":_vm.integrationFormTitle,"busy":_vm.isBusy,"save-disabled":_vm.areFieldsLocked || _vm.isBusy || !_vm.canSubmitIntegration,"field-names":_vm.editableFields,"form-data":_vm.formData,"form-text":_vm.formText,"disabled":_vm.areFieldsLocked,"boolean-fields":_vm.booleanFieldsArray,"json-fields":_vm.jsonFieldsArray,"json-hint":_vm.$t('gestiune.integrationsJsonHint'),"field-label-fn":_vm.integrationFieldLabel,"integration-type":_vm.normalizedIntegration,"locations":_vm.flatLocations,"wolt-required-fields":_vm.woltRequiredFields,"wolt-validation-errors":_vm.woltValidationErrors,"wolt-drive-required-fields":_vm.woltDriveRequiredFields,"wolt-drive-validation-errors":_vm.woltDriveValidationErrors,"delivery-hero-required-fields":_vm.deliveryHeroRequiredFields,"delivery-hero-credential-fields":_vm.deliveryHeroCredentialFields,"delivery-hero-validation-errors":_vm.deliveryHeroValidationErrors,"regenerating-delivery-hero-keys":_vm.regeneratingDeliveryHeroKeys,"bolt-required-fields":_vm.boltRequiredFields,"bolt-validation-errors":_vm.boltValidationErrors,"glovo-laas-required-fields":_vm.glovoLaasRequiredFields,"glovo-laas-validation-errors":_vm.glovoLaasValidationErrors,"glovo-required-fields":_vm.glovoRequiredFields,"glovo-validation-errors":_vm.glovoValidationErrors,"occupied-location-ids":_vm.occupiedLocationIdsForSelect,"is-create-mode":_vm.isCreateMode,"can-delete":_vm.canDeleteIntegration && !_vm.isCreateMode,"can-validate":_vm.canValidateIntegration && !_vm.isCreateMode,"validate-disabled":_vm.areFieldsLocked || _vm.isBusy || !_vm.canSubmitIntegration,"webhook-registered":_vm.isWebhookRegistered,"top-categories":_vm.topCategories,"show-field-validation":_vm.integrationFormValidationAttempted},on:{"back":_vm.closeIntegrationListEdit,"save":_vm.save,"refresh":_vm.refreshIntegrationRead,"activate":_vm.activateIntegration,"activation-finished":_vm.onActivationFinished,"validate":_vm.validateIntegration,"validation-finished":_vm.onValidationFinished,"delete":_vm.handleDeleteFromForm,"regenerate-keys":_vm.regenerateDeliveryHeroKeys}}):_vm._e()],1):_c('div',{key:"integrations-list",staticClass:"col-xl-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"integrations-filters mar-bt-20"},[_c('div',{staticClass:"integrations-filters__fields"},[_c('div',{staticClass:"form-group integrations-filters__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsIntegration')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedIntegration),expression:"selectedIntegration"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedIntegration=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onSelectionChange]}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.integrationOptions),function(opt){return _c('option',{key:opt.value,domProps:{"value":opt.value}},[_vm._v("\n                  "+_vm._s(opt.label)+"\n                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group integrations-filters__field"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.integrationsLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onSelectionChange]}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('gestiune.integrationsAllLocations')))]),_vm._v(" "),_vm._l((_vm.flatLocations),function(loc){return _c('option',{key:'loc-' + String(loc._integrationLocationId),attrs:{"label":loc.name},domProps:{"value":loc._integrationLocationId}},[_vm._v("\n                  "+_vm._s(loc.name)+"\n                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group integrations-filters__field integrations-filters__field--btn"},[_c('label',[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn add",attrs:{"type":"button","disabled":!_vm.canLoad || _vm.isBusy,"title":_vm.$t('reports.search')},on:{"click":_vm.onSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])]),_vm._v(" "),(_vm.hasIntegrationFilter && _vm.hasSearched && !_vm.readError)?_c('div',{staticClass:"form-group integrations-filters__field integrations-filters__field--btn integrations-filters__field--add"},[_c('label',[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn add",attrs:{"type":"button","disabled":_vm.isBusy || !_vm.canLoad,"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.startCreate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png","alt":""}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])]):_vm._e()])]),_vm._v(" "),(_vm.readError)?_c('div',{staticClass:"spv-error-box"},[_vm._v(_vm._s(_vm.readError))]):_vm._e(),_vm._v(" "),(!_vm.readError)?_c('div',{staticClass:"integrations-locations-table data-table mar-bt-20"},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading && _vm.hasSearched),expression:"loading && hasSearched"}],ref:"integrationsTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.integrationsTableRows,"search-def":{ show: false },"total":_vm.integrationsTableTotal,"pagination-props":_vm.integrationsTablePaginationProps,"table-props":{ border: false, rowKey: '_rowKey', rowClassName: _vm.integrationRowClassName }},on:{"query-change":_vm.integrationsPaginationChanged},nativeOn:{"click":function($event){return _vm.handleIntegrationTableClick($event)}}},[_vm._l((_vm.integrationTableDisplayColumnKeys),function(col){return _c('el-table-column',{key:'int-col-' + col,attrs:{"prop":col,"label":_vm.formatColumnHeaderLabel(col),"min-width":_vm.integrationColumnMinWidth(col),"width":col === 'active' || col === 'store_active' ? 100 : undefined,"align":"left","header-align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(col === 'active' || col === 'store_active')?_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('p-switch',{attrs:{"value":_vm.getIntegrationRowActive(scope.row),"type":"success"},on:{"input":function($event){_vm.handleIntegrationActiveToggle(scope.row, $event)}}})],1):(col === 'integration_role')?_c('span',{staticClass:"marketplace-role",class:'marketplace-role--' + scope.row.integration_role},[_vm._v(_vm._s(_vm.formatIntegrationTableCell(col, scope.row[col], scope.row)))]):[_vm._v("\n                  "+_vm._s(_vm.formatIntegrationTableCell(col, scope.row[col], scope.row))+"\n                ")]]}}])})}),_vm._v(" "),_c('el-table-column',{attrs:{"width":120,"label":_vm.$t('general.actions'),"align":"left","header-align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.hasSearched)?_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("▾")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.openIntegrationListRow(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.edit'))+"\n                    ")]),_vm._v(" "),(_vm.canDeleteIntegrationRow(scope.row))?_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.handleDeleteIntegration(scope.row)}}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")]):_vm._e()],1)],1):_vm._e()]}}])}),_vm._v(" "),_c('template',{slot:"empty"},[_c('span',[_vm._v(_vm._s(_vm.integrationsTableEmptyText))])])],2)],1):_vm._e()])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rjjY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);










/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a),
  props: {
    isDonationReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isDonationReport: function isDonationReport() {
      if (this.isDonationReport) {
        this.getData();
      }
    }
  },
  created: function created() {
    this.getCampaigns();
    this.getData();
  },
  data: function data() {
    return {
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      filters: {
        valid: [__WEBPACK_IMPORTED_MODULE_4_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('month').format('YYYY-MM-DD')],
        searchClient: null,
        campaignId: null
      },
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        defaultSort: {
          prop: 'created_at',
          order: 'descending'
        }
      },
      tableData: [],
      campaigns: [],
      total: 0,
      totals: null,
      sortBy: 'created_at',
      sortOrder: 'desc',
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(12, 'months');
        }
      },
      pickerNames: ['date_from', 'date_to']
    };
  },

  methods: {
    getCampaigns: function getCampaigns() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/reports/donation-campaigns', 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data && response.data.data) {
            _this.campaigns = response.data.data;
          } else {
            _this.campaigns = response.data || [];
          }
        }
      });
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page' || query.type === 'size') {
        this.getData(query);
      }
      if (query.type === 'sort') {
        if (query.sort.order) {
          this.sortBy = query.sort.prop;
          this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc';
        } else {
          this.sortBy = 'created_at';
          this.sortOrder = 'desc';
        }
        this.getData(query);
      }
    },
    getData: function getData(query) {
      var _this2 = this;

      if (!this.isDonationReport) {
        return;
      }
      var sortField = this.sortBy;
      var sortType = this.sortOrder;
      var pageSize = 20;
      var page = 1;

      if (query) {
        if (query.sort && query.sort.prop) {
          sortField = query.sort.prop;
        }
        if (query.sort && query.sort.order) {
          sortType = query.sort.order === 'descending' ? 'desc' : 'asc';
        }
        if (query.pageSize) {
          pageSize = query.pageSize;
        }
        if (query.page) {
          page = query.page;
        }
      }

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.filters.valid && this.filters.valid[0],
        end_date: this.filters.valid && this.filters.valid[1],
        search_client: this.filters.searchClient,
        campaign_id: this.filters.campaignId,
        field: sortField,
        order: sortType
      };

      this.loading = true;
      this.apiRequest('/reports/donations?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status === true) {
          _this2.tableData = response.data.data || response.data.items || [];
          _this2.total = response.data.total || 0;
          if (response.data.totals) {
            _this2.totals = response.data.totals;
          }
        }
        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    exportData: function exportData() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.filters.valid && this.filters.valid[0],
        end_date: this.filters.valid && this.filters.valid[1],
        search_client: this.filters.searchClient,
        campaign_id: this.filters.campaignId
      };
      this.loading = true;
      this.apiRequest('/reports/donations-export', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error');
        }
        _this3.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "rlOj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VideoSupportCard__ = __webpack_require__("O1IU");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VideoSupport',
  components: {
    VideoSupportCard: __WEBPACK_IMPORTED_MODULE_0__VideoSupportCard__["a" /* default */]
  },
  data: function data() {
    return {
      allVideos: [{ src: 'https://www.youtube.com/embed/4eczYFQS4hA', title: 'Demo Sistem TapTasty' }, { src: 'https://www.youtube.com/embed/63rU-z9eIHo?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adăugăm un banner oferte în TapTasty?' }, { src: 'https://www.youtube.com/embed/9H5rj1veCzY', title: 'Cum adaug și șterg filtrele unui produs în TapTasty?' }, { src: 'https://www.youtube.com/embed/cIqper3XBiU?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cu adaug o pagină personalizată în TapTasty?' }, { src: 'https://www.youtube.com/embed/yc2opgjLkB0?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug o opțiune produs în TapTasty?' }, { src: 'https://www.youtube.com/embed/CYKdOxTLAV0?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizezi lista de clienți în TapTasty?' }, { src: 'https://www.youtube.com/embed/EfUsmQAWsxI?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez istoricul comenzilor unui client în TapTasty?' }, { src: 'https://www.youtube.com/embed/qMbIYBGgCt0?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez informațiile unui client în TapTasty?' }, { src: 'https://www.youtube.com/embed/0WjBNd3Cm8M?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez un feedback în TapTasty?' }, { src: 'https://www.youtube.com/embed/vk0fSikUx1k?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez meniul QR în TapTasty?' }, { src: 'https://www.youtube.com/embed/ZpJda4HyYdg?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum șterg un produs în TapTasty?' }, { src: 'https://www.youtube.com/embed/ulinM2wIuJM?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum ștergem opțiune produs în TapTasty?' }, { src: 'https://www.youtube.com/embed/jsJlatp7iAs?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum șterg o categorie în TapTasty?' }, { src: 'https://www.youtube.com/embed/lGwdMphOe-w?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum șterg etichetarea clienților în TapTasty?' }, { src: 'https://www.youtube.com/embed/BxNndq5KgD8?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum sortez categoriile în TapTasty?' }, { src: 'https://www.youtube.com/embed/8d_Vtii0d-Y?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum setez punctele de loialitate în TapTasty?' }, { src: 'https://www.youtube.com/embed/vid31FqL81A?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum etichetez clienții în TapTasty?' }, { src: 'https://www.youtube.com/embed/pGKG9LinAeY?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum editez un produs existent în TapTasty?' }, { src: 'https://www.youtube.com/embed/vzG9xoWFrwE?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum editez paginile informative în TapTasty?' }, { src: 'https://www.youtube.com/embed/4uobb3y0tsY?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug puncte de loialitate unui client în TapTasty?' }, { src: 'https://www.youtube.com/embed/1UEyLE-zgFs?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum dezactivez sau șterg o campanie în TapTasty?' }, { src: 'https://www.youtube.com/embed/Rv9dJ1byuLc?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug un produs nou în TapTasty?' }, { src: 'https://www.youtube.com/embed/qLczEQc9aZY?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug comentariu la un client în TapTasty?' }, { src: 'https://www.youtube.com/embed/1d7Je3K-pXY?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug o promoție în TapTasty?' }, { src: 'https://www.youtube.com/embed/joppOQr7jqw?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug o campanie nouă în TapTasty?' }, { src: 'https://www.youtube.com/embed/p7mLJoFZ3cE?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum trimit o campanie în TapTasty?' }, { src: 'https://www.youtube.com/embed/ZSs0n2D68kk?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug o categorie în TapTasty?' }, { src: 'https://www.youtube.com/embed/MZ0hJwPuRM8?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug o categorie de top nouă în TapTasty?' }, { src: 'https://www.youtube.com/embed/QUfrropYOK0?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum setez regulile de livrare în TapTasty?' }, { src: 'https://www.youtube.com/embed/BtaJjt-mpO8?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug și șterg etichete taxe în TapTasty?' }, { src: 'https://www.youtube.com/embed/mMVG87qjwGM?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum adaug taxe de bacșiș în TapTasty?' }, { src: 'https://www.youtube.com/embed/oxyUjsG_A70?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez detaliile comenzii în TapTasty?' }, { src: 'https://www.youtube.com/embed/Joy60i7Ywg0?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum vizualizez detaliile companiei în TapTasty?' }, { src: 'https://www.youtube.com/embed/qe2khy0UDHo?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum editez o notificare în TapTasty?' }, { src: 'https://www.youtube.com/embed/KB0GM6joByY?list=PLW4MyjNB_Dw1560dSjFyjoG4WXcYFtzW3', title: 'Cum setez raza de livrare în TapTasty?' }],
      pagination: {
        currentPage: 1,
        pageSize: 6
      },
      searchQuery: ''
    };
  },

  computed: {
    displayedVideos: function displayedVideos() {
      var start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      var end = start + this.pagination.pageSize;

      return this.filteredVideos.slice(start, end);
    },
    filteredVideos: function filteredVideos() {
      var _this = this;

      if (this.searchQuery.trim() === '') {
        return this.allVideos;
      }
      var normalizedSearchQuery = this.removeDiacritics(this.searchQuery).toLowerCase();

      return this.allVideos.filter(function (video) {
        return _this.removeDiacritics(video.title).toLowerCase().includes(normalizedSearchQuery);
      });
    }
  },
  methods: {
    handlePageChange: function handlePageChange(page) {
      this.pagination.currentPage = page;
    },
    removeDiacritics: function removeDiacritics(str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
  }
});

/***/ }),

/***/ "royS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementStocksAdd_vue__ = __webpack_require__("k1fE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c87db132_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementStocksAdd_vue__ = __webpack_require__("jmMD");
function injectStyle (ssrContext) {
  __webpack_require__("JgGs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c87db132"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementStocksAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c87db132_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementStocksAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rpXM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rsl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementEntriesEdit_vue__ = __webpack_require__("1ge/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e21f255_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementEntriesEdit_vue__ = __webpack_require__("BiTS");
function injectStyle (ssrContext) {
  __webpack_require__("xwWO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e21f255"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementEntriesEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e21f255_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementEntriesEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ry9P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ryVW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesProductsTrend_vue__ = __webpack_require__("n7QK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535db760_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesProductsTrend_vue__ = __webpack_require__("XWuI");
function injectStyle (ssrContext) {
  __webpack_require__("gk9I")
  __webpack_require__("NETA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesProductsTrend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535db760_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesProductsTrend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ryuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosUserEdit_vue__ = __webpack_require__("fRg2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9985edf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosUserEdit_vue__ = __webpack_require__("2OAG");
function injectStyle (ssrContext) {
  __webpack_require__("qPiD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosUserEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9985edf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosUserEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ryyt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-locked"},[_c('div',{staticClass:"icon"},[_vm._v("\n    "+_vm._s(_vm.icon)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.hint)?_c('small',[_vm._v(_vm._s(_vm.hint))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s+lY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportProductsInput_vue__ = __webpack_require__("AC8s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b018dece_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportProductsInput_vue__ = __webpack_require__("avwN");
function injectStyle (ssrContext) {
  __webpack_require__("6Ib2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportProductsInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b018dece_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportProductsInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s1f/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationGroupsForm_vue__ = __webpack_require__("EYdS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f46bd93_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationGroupsForm_vue__ = __webpack_require__("wdBc");
function injectStyle (ssrContext) {
  __webpack_require__("nOq8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationGroupsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f46bd93_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationGroupsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s6Iu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"10","prop":"name","label":"ID"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.id || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"firstname","label":_vm.$t('marketingPromos.firstname')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.firstname ? props.row.firstname : "-"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"lastname","label":_vm.$t('marketingPromos.lastname')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.lastname ? props.row.lastname : "-"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"lastname","label":_vm.$t('kds.kdsCode')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.login_code))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":320,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.send')},on:{"click":function($event){_vm.handleDelete(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")])]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s8oF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s967":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s9LM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"clearfix "},[_vm._l((_vm.model),function(notif,keyNotif){return [_c('div',{staticClass:"card card-inline100"},[_c('div',{staticClass:"form-group card col-md-12",staticStyle:{"background-color":"#fff"}},[_c('div',{staticClass:"card__title"},[_c('h6',[_vm._v(_vm._s(_vm.$t('deliveryTypes.' + notif.delivery_type)))])]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_vm._l((notif.messages),function(message,keyMessage){return [_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v(_vm._s(_vm.changeDeliveryStatusOnEatLocation( notif.delivery_type, message.status)))]),_vm._v(" "),(message.status === 'PROCESSING' || (message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION'))?_c('div',[(notif.delivery_type === 'EAT_LOCATION')?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifBits[notif.delivery_type][message.status][0]),expression:"notifBits[notif.delivery_type][message.status][0]"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifBits[notif.delivery_type][message.status][0].length + 1)*8 + 20) + 'px'),attrs:{"type":"text","name":"validateDefault"},domProps:{"value":(_vm.notifBits[notif.delivery_type][message.status][0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifBits[notif.delivery_type][message.status], 0, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.persons'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifBits[notif.delivery_type][message.status][1]),expression:"notifBits[notif.delivery_type][message.status][1]"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifBits[notif.delivery_type][message.status][1].length + 1)*8 + 20) + 'px'),attrs:{"type":"text","name":"validateDefault"},domProps:{"value":(_vm.notifBits[notif.delivery_type][message.status][1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifBits[notif.delivery_type][message.status], 1, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.dateTime'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifBits[notif.delivery_type][message.status][2]),expression:"notifBits[notif.delivery_type][message.status][2]"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifBits[notif.delivery_type][message.status][2].length + 1)*8 + 20) + 'px'),attrs:{"type":"text"},domProps:{"value":(_vm.notifBits[notif.delivery_type][message.status][2])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifBits[notif.delivery_type][message.status], 2, $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_vm._v("\n                  "+_vm._s(_vm.$t('settingsPushNotif.preview'))+": \n                  "),_c('span',{staticClass:"text-italic"},[_vm._v("\n                  "+_vm._s(_vm.notifBits[notif.delivery_type][message.status][0])+" \n                  "+_vm._s(_vm.$t('settingsPushNotif.personsPrev'))+" \n                  "+_vm._s(_vm.notifBits[notif.delivery_type][message.status][1])+"\n                  "),(_vm.notifBits[notif.delivery_type][message.status][2] !== '')?[(_vm.notifBits[notif.delivery_type][message.status][2] !== ' ')?[_vm._v("\n                      "+_vm._s(_vm.$t('settingsPushNotif.dateTimePrev'))+" \n                      "+_vm._s(_vm.notifBits[notif.delivery_type][message.status][2])+"\n                    ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_c('span',{staticStyle:{"font-size":"0.7em"}},[_vm._v(_vm._s(_vm.$t('settingsPushNotif.info')))])])]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifBits[notif.delivery_type][message.status][0]),expression:"notifBits[notif.delivery_type][message.status][0]"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifBits[notif.delivery_type][message.status][0].length + 1)*8 + 20) + 'px'),attrs:{"type":"text","name":"validateDefault"},domProps:{"value":(_vm.notifBits[notif.delivery_type][message.status][0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifBits[notif.delivery_type][message.status], 0, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.time'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifBits[notif.delivery_type][message.status][1]),expression:"notifBits[notif.delivery_type][message.status][1]"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifBits[notif.delivery_type][message.status][1].length + 1)*8 + 20) + 'px'),attrs:{"type":"text"},domProps:{"value":(_vm.notifBits[notif.delivery_type][message.status][1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifBits[notif.delivery_type][message.status], 1, $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_vm._v("\n                  "+_vm._s(_vm.$t('settingsPushNotif.preview'))+": \n                  "),_c('span',{staticClass:"text-italic"},[_vm._v(_vm._s(_vm.notifBits[notif.delivery_type][message.status][0])+"\n                    "),(_vm.notifBits[notif.delivery_type][message.status][1] !== '')?[(_vm.notifBits[notif.delivery_type][message.status][1] !== ' ')?[_vm._v("\n                        "+_vm._s(_vm.$t('settingsPushNotif.timePrev'))+" "+_vm._s(_vm.notifBits[notif.delivery_type][message.status][1])+"\n                      ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_c('span',{staticStyle:{"font-size":"0.7em"}},[_vm._v(_vm._s(_vm.$t('settingsPushNotif.info')))])])]],2):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(message.message),expression:"message.message"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(message.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(message, "message", $event.target.value)}}})])])]}),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon save mar-bt-15",attrs:{"title":_vm.$t('general.update')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.save'))+"\n            ")])],2)]),_vm._v(" "),_vm._l((_vm.customNotifications),function(message,keyMessage){return [(message.delivery_type.toLowerCase() === notif.delivery_type.toLowerCase())?[_c('div',{staticClass:"form-group card col-md-12",staticStyle:{"background-color":"#fff"}},[_c('div',{staticClass:"form-group"},[_c('br'),_vm._v(" "),(message.id)?[_vm._v("\n                "+_vm._s(_vm.$t('settingsPushNotif.selectedLocations'))+"\n                "),_vm._l((message.location_ids),function(loc,keyloc){return [_c('b',{staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(_vm.getLocationById(loc)))])]}),_vm._v(" "),_c('br')]:[_c('label',{attrs:{"for":""}},[_vm._v("\n                  "+_vm._s(_vm.$t('dashboard.selectLocation'))+"\n                "),(_vm.savedLocations.length)?_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.customModelValidations.select),expression:"customModelValidations.select"}],key:'select' + message.id,attrs:{"name":'section_' + message.id + '_'+message.delivery_type,"multiple-limit":(_vm.locationsAvailable2(message).length - 1),"multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(message.location_ids),callback:function ($$v) {_vm.$set(message, "location_ids", $$v)},expression:"message.location_ids"}},[_vm._l((_vm.locationsAvailable(message)),function(item){return [_vm._l((item.ordering_management),function(or){return [(message.delivery_type.toLowerCase() === or.type)?[_c('el-option',{key:item.id,attrs:{"disabled":or.notifSelected,"label":item.name,"value":item.id}})]:_vm._e()]})]})],2):_vm._e()],1)],_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((message.message),function(msg){return [_c('label',{},[_vm._v(_vm._s(_vm.changeDeliveryStatusOnEatLocation( message.delivery_type.toUpperCase(), msg.status)))]),_vm._v(" "),(msg.status === 'PROCESSING' || (msg.status === 'DELIVERED' && message.delivery_type.toUpperCase() === 'EAT_LOCATION'))?_c('div',[(message.bits)?[(message.delivery_type.toLowerCase() === 'eat_location')?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(message.bits[0]),expression:"message.bits[0]"},{name:"validate",rawName:"v-validate",value:(_vm.customModelValidations.text),expression:"customModelValidations.text"}],staticClass:"form-control auto-width",style:('width: ' + ((message.bits[0].length + 1)*8 + 20) + 'px'),attrs:{"type":"text","name":'section_' + message.id + '_'+message.delivery_type},domProps:{"value":(message.bits[0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(message.bits, 0, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.persons'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(message.bits[1]),expression:"message.bits[1]"},{name:"validate",rawName:"v-validate",value:(_vm.customModelValidations.text),expression:"customModelValidations.text"}],staticClass:"form-control auto-width",style:('width: ' + ((message.bits[1].length + 1)*8 + 20) + 'px'),attrs:{"type":"text","name":'section_' + message.id + '_'+message.delivery_type},domProps:{"value":(message.bits[1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(message.bits, 1, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.dateTime'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(message.bits[2]),expression:"message.bits[2]"}],staticClass:"form-control auto-width",style:('width: ' + ((message.bits[2].length + 1)*8 + 20) + 'px'),attrs:{"type":"text","name":'section_' + message.id + '_'+message.delivery_type},domProps:{"value":(message.bits[2])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(message.bits, 2, $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_vm._v("\n                        "+_vm._s(_vm.$t('settingsPushNotif.preview'))+": \n                        "),_c('span',{staticClass:"text-italic"},[_vm._v("\n                        "+_vm._s(message.bits[0])+" \n                        "+_vm._s(_vm.$t('settingsPushNotif.personsPrev'))+" \n                        "+_vm._s(message.bits[1])+"\n                        "),(message.bits[2] !== '')?[(message.bits[2] !== ' ')?[_vm._v("\n                            "+_vm._s(_vm.$t('settingsPushNotif.dateTimePrev'))+" \n                            "+_vm._s(message.bits[2])+"\n                          ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_c('span',{staticStyle:{"font-size":"0.7em"}},[_vm._v(_vm._s(_vm.$t('settingsPushNotif.info')))])]),_vm._v(" "),_c('br')]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(message.bits[0]),expression:"message.bits[0]"},{name:"validate",rawName:"v-validate",value:(_vm.customModelValidations.text),expression:"customModelValidations.text"}],staticClass:"form-control auto-width",style:('width: ' + ((message.bits[0].length + 1)*8 + 20) + 'px'),attrs:{"type":"text","name":'section_' + message.id + '_'+message.delivery_type},domProps:{"value":(message.bits[0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(message.bits, 0, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.time'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(message.bits[1]),expression:"message.bits[1]"}],staticClass:"form-control auto-width",style:('width: ' + ((message.bits[1].length + 1)*8 + 20) + 'px'),attrs:{"type":"text"},domProps:{"value":(message.bits[1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(message.bits, 1, $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_vm._v("\n                        "+_vm._s(_vm.$t('settingsPushNotif.preview'))+": \n                        "),_c('span',{staticClass:"text-italic"},[_vm._v(_vm._s(message.bits[0])+" \n                          "),(message.bits[1] !== '')?[(message.bits[1] !== ' ')?[_vm._v("\n                              "+_vm._s(_vm.$t('settingsPushNotif.timePrev'))+" "+_vm._s(message.bits[1])+"\n                            ")]:_vm._e()]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_c('span',{staticStyle:{"font-size":"0.7em"}},[_vm._v(_vm._s(_vm.$t('settingsPushNotif.info')))])])]]:_vm._e()],2):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(msg.message),expression:"msg.message"},{name:"validate",rawName:"v-validate",value:(_vm.customModelValidations.text),expression:"customModelValidations.text"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(msg.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(msg, "message", $event.target.value)}}})])]}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('button',{staticClass:"btn btn-success btn-icon save",attrs:{"title":_vm.$t('general.update')},on:{"click":function($event){$event.preventDefault();_vm.validateSingleSection('section_' + message.id + '_'+message.delivery_type, message.id, message.delivery_type)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.save'))+"\n                ")]),_vm._v(" "),(message.id)?[_c('button',{staticClass:"btn btn-danger btn-icon",on:{"click":function($event){$event.preventDefault();_vm.deleteBox(message.id, message.delivery_type)}}},[_c('i',{staticClass:"ti-close"})])]:_vm._e()],2)],2)])]:_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIfHasMultipleLocation[notif.delivery_type]),expression:"showIfHasMultipleLocation[notif.delivery_type]"}],staticClass:"btn add mar-bt-15",on:{"click":function($event){$event.preventDefault();_vm.addBoxForLocation(notif.delivery_type)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.add'))+"\n        ")])])]}),_vm._v(" "),_vm._l((_vm.defaults),function(notif,keyNotif){return [_c('div',{staticClass:"card card-inline100"},[_c('div',{staticClass:"form-group card col-md-12",staticStyle:{"background-color":"#fff"}},[_c('div',{staticClass:"card__title"},[_c('h6',[_vm._v(_vm._s(_vm.$t('marketingFidelities.loyalityPoint')))])]),_vm._v(" "),_c('hr',{staticClass:"sm"}),_vm._v(" "),_vm._l((notif.messages),function(message,keyMessage){return [_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v(_vm._s(_vm.$t('ordersStatus.DELIVERED')))]),_vm._v(" "),_c('div',[(_vm.customLoyaltyPointsNotifications[0] && _vm.customLoyaltyPointsNotifications[0]['bits'])?[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"},{name:"model",rawName:"v-model",value:(_vm.customLoyaltyPointsNotifications[0]['bits'][0]),expression:"customLoyaltyPointsNotifications[0]['bits'][0]"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.customLoyaltyPointsNotifications[0]['bits'][0].length + 1)*8 + 20) + 'px'),attrs:{"type":"text","name":"validateDefault"},domProps:{"value":(_vm.customLoyaltyPointsNotifications[0]['bits'][0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customLoyaltyPointsNotifications[0]['bits'], 0, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.pointsPrev'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.text),expression:"modelValidations.text"},{name:"model",rawName:"v-model",value:(_vm.customLoyaltyPointsNotifications[0]['bits'][1]),expression:"customLoyaltyPointsNotifications[0]['bits'][1]"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.customLoyaltyPointsNotifications[0]['bits'][1].length + 1)*8 + 20) + 'px'),attrs:{"type":"text","name":"validateDefault"},domProps:{"value":(_vm.customLoyaltyPointsNotifications[0]['bits'][1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customLoyaltyPointsNotifications[0]['bits'], 1, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.worthPrev'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customLoyaltyPointsNotifications[0]['bits'][2]),expression:"customLoyaltyPointsNotifications[0]['bits'][2]"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.customLoyaltyPointsNotifications[0]['bits'][2].length + 1)*8 + 20) + 'px'),attrs:{"type":"text"},domProps:{"value":(_vm.customLoyaltyPointsNotifications[0]['bits'][2])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customLoyaltyPointsNotifications[0]['bits'], 2, $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_vm._v("\n                    "+_vm._s(_vm.$t('settingsPushNotif.preview'))+":\n                    "),_c('span',{staticClass:"text-italic"},[_vm._v("\n                      "+_vm._s(_vm.customLoyaltyPointsNotifications[0]['bits'][0])+"\n                      "+_vm._s(_vm.loyalty_value_one_point_amount ? _vm.loyalty_value_one_point_amount : 'X')+"\n                      "+_vm._s(_vm.customLoyaltyPointsNotifications[0]['bits'][1])+"\n                      "),(_vm.customLoyaltyPointsNotifications[0]['bits'][2].trim().length > 0)?[_vm._v("\n                        "+_vm._s(_vm.loyalty_value_one_point ? _vm.loyalty_value_one_point : 'Y')+"\n                        "+_vm._s(_vm.currency)+"\n                      ")]:_vm._e(),_vm._v(" "),(_vm.customLoyaltyPointsNotifications[0]['bits'][2].trim().length > 0)?[_vm._v("\n                        "+_vm._s(_vm.customLoyaltyPointsNotifications[0]['bits'][2])+"\n                      ")]:_vm._e()],2)])]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifLoyaltyPoints[notif.delivery_type][message.status][0]),expression:"notifLoyaltyPoints[notif.delivery_type][message.status][0]"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifLoyaltyPoints[notif.delivery_type][message.status][0].length + 1)*8 + 20) + 'px'),attrs:{"type":"text","name":"validateDefault"},domProps:{"value":(_vm.notifLoyaltyPoints[notif.delivery_type][message.status][0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifLoyaltyPoints[notif.delivery_type][message.status], 0, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.pointsPrev'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifLoyaltyPoints[notif.delivery_type][message.status][1]),expression:"notifLoyaltyPoints[notif.delivery_type][message.status][1]"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifLoyaltyPoints[notif.delivery_type][message.status][1].length + 1)*8 + 20) + 'px'),attrs:{"type":"text","name":"validateDefault"},domProps:{"value":(_vm.notifLoyaltyPoints[notif.delivery_type][message.status][1])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifLoyaltyPoints[notif.delivery_type][message.status], 1, $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsPushNotif.worthPrev'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notifLoyaltyPoints[notif.delivery_type][message.status][2]),expression:"notifLoyaltyPoints[notif.delivery_type][message.status][2]"}],staticClass:"form-control auto-width",style:('width: ' + ((_vm.notifLoyaltyPoints[notif.delivery_type][message.status][2].length + 1)*8 + 20) + 'px'),attrs:{"type":"text"},domProps:{"value":(_vm.notifLoyaltyPoints[notif.delivery_type][message.status][2])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.notifLoyaltyPoints[notif.delivery_type][message.status], 2, $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"pad-to-5"},[_vm._v("\n                    "+_vm._s(_vm.$t('settingsPushNotif.preview'))+": \n                    "),_c('span',{staticClass:"text-italic"},[_vm._v("\n                      "+_vm._s(_vm.notifLoyaltyPoints[notif.delivery_type][message.status][0])+" \n                      "+_vm._s(_vm.loyalty_value_one_point_amount ? _vm.loyalty_value_one_point_amount : 'X')+" \n                      "+_vm._s(_vm.notifLoyaltyPoints[notif.delivery_type][message.status][1])+"\n                      "),(_vm.notifLoyaltyPoints[notif.delivery_type][message.status][2].trim().length > 0)?[_vm._v("                        \n                        "+_vm._s(_vm.loyalty_value_one_point ? _vm.loyalty_value_one_point : 'Y')+"\n                        "+_vm._s(_vm.currency)+"\n                      ")]:_vm._e(),_vm._v(" "),(_vm.notifLoyaltyPoints[notif.delivery_type][message.status][2].trim().length > 0)?[_vm._v("\n                        "+_vm._s(_vm.notifLoyaltyPoints[notif.delivery_type][message.status][2])+"\n                      ")]:_vm._e()],2)])]],2)])]}),_vm._v(" "),_c('div',{staticClass:"pad-bt-10"},[_c('button',{staticClass:"btn btn-success btn-icon save",attrs:{"title":_vm.$t('general.update')},on:{"click":function($event){$event.preventDefault();_vm.saveLoyaltyPointsNotification()}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n            ")])])],2)])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sAdI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Taxes_vue__ = __webpack_require__("xidW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a2e7590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Taxes_vue__ = __webpack_require__("a92Y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Taxes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a2e7590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Taxes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sBir":
/***/ (function(module, exports) {

module.exports = {"10":{"text":"10 - Grup","value":"10"},"11":{"text":"11 - Ţinută","value":"11"},"13":{"text":"13 - Ratia","value":"13"},"14":{"text":"14 - Doză","value":"14"},"15":{"text":"15 - Stick, militar","value":"15"},"20":{"text":"20 - Container (20ft)","value":"20"},"21":{"text":"21 - Container (40ft)","value":"21"},"22":{"text":"22 - Decilitru pe gram","value":"22"},"23":{"text":"23 - Gram pe centimetru cub","value":"23"},"24":{"text":"24 - Livră teoretică","value":"24"},"25":{"text":"25 - Gram pe centimetru pătrat","value":"25"},"27":{"text":"27 - Tonă teoretică","value":"27"},"28":{"text":"28 - Kilogram pe metru pătrat","value":"28"},"33":{"text":"33 - Kilopascal pătrat metru pe gram","value":"33"},"34":{"text":"34 - Kilopascal pe milimetru","value":"34"},"35":{"text":"35 - Mililitru pe centimetru pătrat secundă","value":"35"},"37":{"text":"37 - Uncie pe metru pătrat","value":"37"},"38":{"text":"38 - Uncie pe metru pătrat la 0,01 inci","value":"38"},"40":{"text":"40 - Mililitru pe secundă","value":"40"},"41":{"text":"41 - Mililitru pe minut","value":"41"},"56":{"text":"56 - Sitas","value":"56"},"57":{"text":"57 - Plasă","value":"57"},"58":{"text":"58 - Kilogram net","value":"58"},"59":{"text":"59 - Parte la milion","value":"59"},"60":{"text":"60 - Greutate procentuală","value":"60"},"61":{"text":"61 - Parte pe miliard (SUA)","value":"61"},"74":{"text":"74 - Milipascal","value":"74"},"77":{"text":"77 - Milli-inch","value":"77"},"80":{"text":"80 - Kilogram pe centimetru pătrat absolut","value":"80"},"81":{"text":"81 - Henry","value":"81"},"85":{"text":"85 - Livră picior (lucru mecanic)","value":"85"},"87":{"text":"87 - Livră pe picior cub (densitate)","value":"87"},"89":{"text":"89 - Vâscozitate dinamică (pascal/sec)","value":"89"},"91":{"text":"91 - Stokes","value":"91"},"1I":{"text":"1I - Rată fixă","value":"1I"},"2A":{"text":"2A - Radian pe secundă","value":"2A"},"2B":{"text":"2B - Radian pe secundă la pătrat","value":"2B"},"2C":{"text":"2C - Roentgen","value":"2C"},"2G":{"text":"2G - Volt AC","value":"2G"},"2H":{"text":"2H - Volt DC","value":"2H"},"2I":{"text":"2I - BTU (tabel internațional) pe oră","value":"2I"},"2J":{"text":"2J - Centimetru cub pe secundă","value":"2J"},"2K":{"text":"2K - Picior cubic pe oră","value":"2K"},"2L":{"text":"2L - Picior cubic pe minut","value":"2L"},"2M":{"text":"2M - Centimetru pe secundă","value":"2M"},"2N":{"text":"2N - Decibel","value":"2N"},"2P":{"text":"2P - Kilobyte","value":"2P"},"2Q":{"text":"2Q - Kilobecquerel","value":"2Q"},"2R":{"text":"2R - Kilocurie","value":"2R"},"2U":{"text":"2U - Megagram","value":"2U"},"2X":{"text":"2X - Metru pe minut","value":"2X"},"2Y":{"text":"2Y - Miliroentgen","value":"2Y"},"2Z":{"text":"2Z - Milivolt","value":"2Z"},"3B":{"text":"3B - Megajoule","value":"3B"},"3C":{"text":"3C - Lună om","value":"3C"},"4C":{"text":"4C - Centistokes","value":"4C"},"4G":{"text":"4G - Microlitru","value":"4G"},"4H":{"text":"4H - Micrometru (micron)","value":"4H"},"4K":{"text":"4K - Milliamper","value":"4K"},"4L":{"text":"4L - Megabyte","value":"4L"},"4M":{"text":"4M - Miligram pe oră","value":"4M"},"4N":{"text":"4N - Megabecquerel","value":"4N"},"4O":{"text":"4O - Microfarad","value":"4O"},"4P":{"text":"4P - Newton pe metru","value":"4P"},"4Q":{"text":"4Q - Uncie pe inch","value":"4Q"},"4R":{"text":"4R - Uncie pe picior","value":"4R"},"4T":{"text":"4T - Picofarad","value":"4T"},"4U":{"text":"4U - Livră pe oră","value":"4U"},"4W":{"text":"4W - Tonă (SUA) pe oră","value":"4W"},"4X":{"text":"4X - Kilolitru pe oră","value":"4X"},"5A":{"text":"5A - Baril (SUA) pe minut","value":"5A"},"5B":{"text":"5B - Lot","value":"5B"},"5E":{"text":"5E - MMSCF/zi","value":"5E"},"5J":{"text":"5J - Cal putere hidraulic","value":"5J"},"A10":{"text":"A10 - Amper pe metru pătrat pe joule secundă","value":"A10"},"A11":{"text":"A11 - Angstrom","value":"A11"},"A12":{"text":"A12 - Unitate astronomică","value":"A12"},"A13":{"text":"A13 - Joule atomic","value":"A13"},"A14":{"text":"A14 - Barn","value":"A14"},"A15":{"text":"A15 - Barn per electronvolt","value":"A15"},"A16":{"text":"A16 - Barn per electronvolt steradian","value":"A16"},"A17":{"text":"A17 - Barn pe steradian","value":"A17"},"A18":{"text":"A18 - Becquerel pe kilogram","value":"A18"},"A19":{"text":"A19 - Becquerel pe metru cub","value":"A19"},"A2":{"text":"A2 - Amperi pe centimetru","value":"A2"},"A20":{"text":"A20 - BTU pe secundă grad de metru pătrat Rankine","value":"A20"},"A21":{"text":"A21 - BTU pe grad de lira Rankine","value":"A21"},"A22":{"text":"A22 - BTU pe grad secund Rankine","value":"A22"},"A23":{"text":"A23 - BTU pe oră grad de metru pătrat Rankine","value":"A23"},"A24":{"text":"A24 - Candelă pe metru pătrat/Lux","value":"A24"},"A26":{"text":"A26 - Coulomb metru","value":"A26"},"A27":{"text":"A27 - Coulomb metru pătrat per volt","value":"A27"},"A28":{"text":"A28 - Coulomb pe centimetru cub","value":"A28"},"A29":{"text":"A29 - Coulomb pe metru cub","value":"A29"},"A3":{"text":"A3 - Amper pe milimetru","value":"A3"},"A30":{"text":"A30 - Coulomb pe milimetru cub","value":"A30"},"A31":{"text":"A31 - Coulomb pe kilogram pe secundă","value":"A31"},"A32":{"text":"A32 - Coulomb pe mol","value":"A32"},"A33":{"text":"A33 - Coulomb pe centimetru pătrat","value":"A33"},"A34":{"text":"A34 - Coulomb pe metru pătrat","value":"A34"},"A35":{"text":"A35 - Coulomb pe milimetru pătrat","value":"A35"},"A36":{"text":"A36 - Centimetru cub pe mol","value":"A36"},"A37":{"text":"A37 - Decimetru cub pe mol","value":"A37"},"A38":{"text":"A38 - Metru cub pe coulomb","value":"A38"},"A39":{"text":"A39 - Metru cub pe kilogram","value":"A39"},"A4":{"text":"A4 - Amper pe centimetru pătrat","value":"A4"},"A40":{"text":"A40 - Metru cub pe mol","value":"A40"},"A41":{"text":"A41 - Amperi pe metru pătrat","value":"A41"},"A42":{"text":"A42 - Curie pe kilogram","value":"A42"},"A43":{"text":"A43 - Tonă TWD","value":"A43"},"A44":{"text":"A44 - Decalitru","value":"A44"},"A45":{"text":"A45 - Decametru","value":"A45"},"A47":{"text":"A47 - Decitex","value":"A47"},"A48":{"text":"A48 - Grad Rankine","value":"A48"},"A49":{"text":"A49 - Denier","value":"A49"},"A5":{"text":"A5 - Amper metru pătrat","value":"A5"},"A53":{"text":"A53 - Electronvolt","value":"A53"},"A54":{"text":"A54 - Electronvolt pe metru","value":"A54"},"A55":{"text":"A55 - Metru pătrat de electronvolt","value":"A55"},"A56":{"text":"A56 - Electronvolt metru pătrat pe kilogram","value":"A56"},"A59":{"text":"A59 - Okta","value":"A59"},"A6":{"text":"A6 - Amper pe metru pătrat Kelvin pătrat","value":"A6"},"A68":{"text":"A68 - Exajoule","value":"A68"},"A69":{"text":"A69 - Farad pe metru","value":"A69"},"A7":{"text":"A7 - Amper pe milimetru pătrat","value":"A7"},"A70":{"text":"A70 - Femtojoule","value":"A70"},"A71":{"text":"A71 - Femtometri","value":"A71"},"A73":{"text":"A73 - Picior pe secundă la pătrat","value":"A73"},"A74":{"text":"A74 - Livră picior forță pe secundă","value":"A74"},"A75":{"text":"A75 - Tonă de marfă","value":"A75"},"A76":{"text":"A76 - Gal","value":"A76"},"A8":{"text":"A8 - Amper secundă","value":"A8"},"A84":{"text":"A84 - Gigacoulomb pe metru cub","value":"A84"},"A85":{"text":"A85 - Gigaelectronvolt","value":"A85"},"A86":{"text":"A86 - Gigahertz","value":"A86"},"A87":{"text":"A87 - Gigaohm","value":"A87"},"A88":{"text":"A88 - Gigaohm metru","value":"A88"},"A89":{"text":"A89 - Gigapascal","value":"A89"},"A9":{"text":"A9 - Rata","value":"A9"},"A90":{"text":"A90 - Gigawatt","value":"A90"},"A91":{"text":"A91 - Gon","value":"A91"},"A93":{"text":"A93 - Gram pe metru cub","value":"A93"},"A94":{"text":"A94 - Moleculă-gram","value":"A94"},"A95":{"text":"A95 - Gray","value":"A95"},"A96":{"text":"A96 - Gray pe secundă","value":"A96"},"A97":{"text":"A97 - Hectopascal","value":"A97"},"A98":{"text":"A98 - Henry pe metru","value":"A98"},"A99":{"text":"A99 - Bit","value":"A99"},"AA":{"text":"AA - Spera solida","value":"AA"},"AB":{"text":"AB - Ambalaj în vrac","value":"AB"},"ACR":{"text":"ACR - Ar","value":"ACR"},"ACT":{"text":"ACT - Activitate","value":"ACT"},"AD":{"text":"AD - Byte","value":"AD"},"AE":{"text":"AE - Amper pe metru","value":"AE"},"AH":{"text":"AH - Minut suplimentar","value":"AH"},"AI":{"text":"AI - Minut mediu pe apel","value":"AI"},"AK":{"text":"AK - stânjen","value":"AK"},"AL":{"text":"AL - Linie de acces","value":"AL"},"AMH":{"text":"AMH - Amper-oră","value":"AMH"},"AMP":{"text":"AMP - Amper","value":"AMP"},"ANN":{"text":"ANN - An","value":"ANN"},"APZ":{"text":"APZ - Uncie troy sau uncie farmaceutică","value":"APZ"},"AQ":{"text":"AQ - Unitate de factor antihemofilic (AHF)","value":"AQ"},"AS":{"text":"AS - Sortiment","value":"AS"},"ASM":{"text":"ASM - Grad alcool (masic)","value":"ASM"},"ASU":{"text":"ASU - Grad alcool (volumic)","value":"ASU"},"ATM":{"text":"ATM - Atmosferă standard","value":"ATM"},"AWG":{"text":"AWG - Ecartament cale ferată","value":"AWG"},"AY":{"text":"AY - Mulțime","value":"AY"},"AZ":{"text":"AZ - BTU (tabel internațional) per kilogram","value":"AZ"},"B1":{"text":"B1 - Baril (SUA) pe zi","value":"B1"},"B10":{"text":"B10 - Bit pe secundă","value":"B10"},"B11":{"text":"B11 - Joule pe kilogram de Kelvin","value":"B11"},"B12":{"text":"B12 - Joule pe metru","value":"B12"},"B13":{"text":"B13 - Joule pe metru pătrat","value":"B13"},"B14":{"text":"B14 - Joule pe metru la puterea a patra","value":"B14"},"B15":{"text":"B15 - Joule pe mol","value":"B15"},"B16":{"text":"B16 - Joule pe mol Kelvin","value":"B16"},"B17":{"text":"B17 - Credit","value":"B17"},"B18":{"text":"B18 - Joule pe secundă","value":"B18"},"B19":{"text":"B19 - Cifră","value":"B19"},"B20":{"text":"B20 - Joule metru pătrat pe kilogram","value":"B20"},"B21":{"text":"B21 - Kelvin pe watt","value":"B21"},"B22":{"text":"B22 - Kiloamper","value":"B22"},"B23":{"text":"B23 - Kiloamper pe metru pătrat","value":"B23"},"B24":{"text":"B24 - Kiloamper pe metru","value":"B24"},"B25":{"text":"B25 - Kilobecquerel pe kilogram","value":"B25"},"B26":{"text":"B26 - Kilocoulomb","value":"B26"},"B27":{"text":"B27 - Kilocoulomb pe metru cub","value":"B27"},"B28":{"text":"B28 - Kilocoulomb pe metru pătrat","value":"B28"},"B29":{"text":"B29 - Kiloelectronvolt","value":"B29"},"B3":{"text":"B3 - Livra putere","value":"B3"},"B30":{"text":"B30 - Gibit","value":"B30"},"B31":{"text":"B31 - Kilogram metru pe secundă","value":"B31"},"B32":{"text":"B32 - Kilogram metru pătrat","value":"B32"},"B33":{"text":"B33 - Kilogram metru pătrat pe secundă","value":"B33"},"B34":{"text":"B34 - Kilogram pe decimetru cub","value":"B34"},"B35":{"text":"B35 - Kilogram pe litru","value":"B35"},"B4":{"text":"B4 - Baril, imperial","value":"B4"},"B41":{"text":"B41 - Kilojoul pe Kelvin","value":"B41"},"B42":{"text":"B42 - Kilojoul pe kilogram","value":"B42"},"B43":{"text":"B43 - Kilojoul pe kilogram Kelvin","value":"B43"},"B44":{"text":"B44 - Kilojoul pe mol","value":"B44"},"B45":{"text":"B45 - Kilomol","value":"B45"},"B46":{"text":"B46 - Kilomol pe metru cub","value":"B46"},"B47":{"text":"B47 - Kilonewton","value":"B47"},"B48":{"text":"B48 - Kilonewton pe metru","value":"B48"},"B49":{"text":"B49 - Kiloohm","value":"B49"},"B50":{"text":"B50 - Kiloohm pe metru","value":"B50"},"B52":{"text":"B52 - Kilosecunde","value":"B52"},"B53":{"text":"B53 - Kilosiemens","value":"B53"},"B54":{"text":"B54 - Kilosiemens pe metru","value":"B54"},"B55":{"text":"B55 - Kilovolt pe metru","value":"B55"},"B56":{"text":"B56 - Kiloweber pe metru","value":"B56"},"B57":{"text":"B57 - An-lumină","value":"B57"},"B58":{"text":"B58 - Litru per mol","value":"B58"},"B59":{"text":"B59 - Lumen pe oră","value":"B59"},"B60":{"text":"B60 - Lumen pe metru pătrat","value":"B60"},"B61":{"text":"B61 - Lumen pe watt","value":"B61"},"B62":{"text":"B62 - Lumen pe secundă","value":"B62"},"B63":{"text":"B63 - lux pe oră","value":"B63"},"B64":{"text":"B64 - lux pe secundă","value":"B64"},"B66":{"text":"B66 - Megaamper pe metru pătrat","value":"B66"},"B67":{"text":"B67 - Megabecquerel pe kilogram","value":"B67"},"B68":{"text":"B68 - Gigabit","value":"B68"},"B69":{"text":"B69 - Megacoulomb pe metru cub","value":"B69"},"B7":{"text":"B7 - Ciclu","value":"B7"},"B70":{"text":"B70 - Megacoulomb pe metru pătrat","value":"B70"},"B71":{"text":"B71 - Megaelectronvolt","value":"B71"},"B72":{"text":"B72 - Megagram pe metru cub","value":"B72"},"B73":{"text":"B73 - Meganewton","value":"B73"},"B74":{"text":"B74 - meganewton pe metru","value":"B74"},"B75":{"text":"B75 - Megaohm","value":"B75"},"B76":{"text":"B76 - Megaohm pe metru","value":"B76"},"B77":{"text":"B77 - Megasiemens pe metru","value":"B77"},"B78":{"text":"B78 - Megavolt","value":"B78"},"B79":{"text":"B79 - Megavolt pe metru","value":"B79"},"B8":{"text":"B8 - Joule pe metru cub","value":"B8"},"B80":{"text":"B80 - Gigabit pe secundă","value":"B80"},"B81":{"text":"B81 - Metru pătrat reciproc - reciproca secundară","value":"B81"},"B82":{"text":"B82 - inch pe metru liniar","value":"B82"},"B83":{"text":"B83 - Metru la puterea a patra","value":"B83"},"B84":{"text":"B84 - Microamper","value":"B84"},"B85":{"text":"B85 - Microbar","value":"B85"},"B86":{"text":"B86 - Microcoulomb","value":"B86"},"B87":{"text":"B87 - Microcoulomb pe metru cub","value":"B87"},"B88":{"text":"B88 - Microcoulomb pe metru pătrat","value":"B88"},"B89":{"text":"B89 - Microfarad pe metru","value":"B89"},"B90":{"text":"B90 - Microhenry","value":"B90"},"B91":{"text":"B91 - Microhenry pe metru","value":"B91"},"B92":{"text":"B92 - Micronewton","value":"B92"},"B93":{"text":"B93 - micronewton pe metru","value":"B93"},"B94":{"text":"B94 - Microohm","value":"B94"},"B95":{"text":"B95 - microohm pe metru","value":"B95"},"B96":{"text":"B96 - Micropascal","value":"B96"},"B97":{"text":"B97 - Microradian","value":"B97"},"B98":{"text":"B98 - Microsecundă","value":"B98"},"B99":{"text":"B99 - Microsiemens","value":"B99"},"BAR":{"text":"BAR - Bar [unitate de presiune]","value":"BAR"},"BB":{"text":"BB - Casetă","value":"BB"},"BFT":{"text":"BFT - Picior cubic (cherestea)","value":"BFT"},"BHP":{"text":"BHP - Cal putere la frânare","value":"BHP"},"BIL":{"text":"BIL - Miliard (EUR)","value":"BIL"},"BLD":{"text":"BLD - Baril uscat (SUA)","value":"BLD"},"BLL":{"text":"BLL - Baril (SUA)","value":"BLL"},"BP":{"text":"BP - Kilo pasi (cherestea)","value":"BP"},"BPM":{"text":"BPM - Bătăi pe minut","value":"BPM"},"BQL":{"text":"BQL - Becquerel","value":"BQL"},"BTU":{"text":"BTU - BTU (tabel internațional)","value":"BTU"},"BUA":{"text":"BUA - Baniță (SUA)","value":"BUA"},"BUI":{"text":"BUI - Baniță (UK)","value":"BUI"},"C0":{"text":"C0 - Apel","value":"C0"},"C10":{"text":"C10 - Millifarad","value":"C10"},"C11":{"text":"C11 - Miligal","value":"C11"},"C12":{"text":"C12 - Miligram pe metru","value":"C12"},"C13":{"text":"C13 - Milligray","value":"C13"},"C14":{"text":"C14 - Milihenry","value":"C14"},"C15":{"text":"C15 - Milijoul","value":"C15"},"C16":{"text":"C16 - Milimetru pe secundă","value":"C16"},"C17":{"text":"C17 - Milimetru pătrat pe secundă","value":"C17"},"C18":{"text":"C18 - Millimol","value":"C18"},"C19":{"text":"C19 - Mol pe kilogram","value":"C19"},"C20":{"text":"C20 - Millinewton","value":"C20"},"C21":{"text":"C21 - Kibibit","value":"C21"},"C22":{"text":"C22 - Milinewton pe metru","value":"C22"},"C23":{"text":"C23 - Miliohm pe metru","value":"C23"},"C24":{"text":"C24 - Milipascal pe secundă","value":"C24"},"C25":{"text":"C25 - Milliradian","value":"C25"},"C26":{"text":"C26 - Milisecundă","value":"C26"},"C27":{"text":"C27 - Milisiemens","value":"C27"},"C28":{"text":"C28 - Milisievert","value":"C28"},"C29":{"text":"C29 - Millitesla","value":"C29"},"C3":{"text":"C3 - Microvolt pe metru","value":"C3"},"C30":{"text":"C30 - Milivolt pe metru","value":"C30"},"C31":{"text":"C31 - Miliwatt","value":"C31"},"C32":{"text":"C32 - Miliwatt pe metru pătrat","value":"C32"},"C33":{"text":"C33 - Miliweber","value":"C33"},"C34":{"text":"C34 - Mol","value":"C34"},"C35":{"text":"C35 - Mol pe decimetru cub","value":"C35"},"C36":{"text":"C36 - Mol pe metru cub","value":"C36"},"C37":{"text":"C37 - Kilobit","value":"C37"},"C38":{"text":"C38 - Mol pe litru","value":"C38"},"C39":{"text":"C39 - Nanoamper","value":"C39"},"C40":{"text":"C40 - Nanocoulomb","value":"C40"},"C41":{"text":"C41 - Nanofarad","value":"C41"},"C42":{"text":"C42 - Nanofarad pe metru","value":"C42"},"C43":{"text":"C43 - Nanohenry","value":"C43"},"C44":{"text":"C44 - Nanohenry pe metru","value":"C44"},"C45":{"text":"C45 - Nanometri","value":"C45"},"C46":{"text":"C46 - Nanoohm metru","value":"C46"},"C47":{"text":"C47 - Nanosecundă","value":"C47"},"C48":{"text":"C48 - Nanotesla","value":"C48"},"C49":{"text":"C49 - Nanowatt","value":"C49"},"C50":{"text":"C50 - Neper","value":"C50"},"C51":{"text":"C51 - Neper pe secundă","value":"C51"},"C52":{"text":"C52 - Picometru","value":"C52"},"C53":{"text":"C53 - Newton metru pe secundă","value":"C53"},"C54":{"text":"C54 - Newton metru pătrat pe kilogram la pătrat","value":"C54"},"C55":{"text":"C55 - Newton pe metru pătrat","value":"C55"},"C56":{"text":"C56 - Newton pe milimetru pătrat","value":"C56"},"C57":{"text":"C57 - Newton secundă","value":"C57"},"C58":{"text":"C58 - Newton secundă pe metru","value":"C58"},"C59":{"text":"C59 - Octavă","value":"C59"},"C60":{"text":"C60 - Ohm pe centimetru","value":"C60"},"C61":{"text":"C61 - Ohm metru","value":"C61"},"C62":{"text":"C62 - Unitate","value":"C62"},"C63":{"text":"C63 - Parsec","value":"C63"},"C64":{"text":"C64 - Pascal pe Kelvin","value":"C64"},"C65":{"text":"C65 - Pascal secundă","value":"C65"},"C66":{"text":"C66 - Pascal secundă pe metru cub","value":"C66"},"C67":{"text":"C67 - Pascal secundă pe metru","value":"C67"},"C68":{"text":"C68 - Petajoule","value":"C68"},"C69":{"text":"C69 - Fon","value":"C69"},"C7":{"text":"C7 - centipoise","value":"C7"},"C70":{"text":"C70 - Picoamper","value":"C70"},"C71":{"text":"C71 - Picocoulomb","value":"C71"},"C72":{"text":"C72 - Picofarad pe metru","value":"C72"},"C73":{"text":"C73 - Picohenry","value":"C73"},"C74":{"text":"C74 - Kilobit pe secundă","value":"C74"},"C75":{"text":"C75 - Picowatt","value":"C75"},"C76":{"text":"C76 - Picowatt pe metru pătrat","value":"C76"},"C78":{"text":"C78 - Livra-forță","value":"C78"},"C79":{"text":"C79 - Kilovolt amper oră","value":"C79"},"C8":{"text":"C8 - Miliicoulomb pe kilogram","value":"C8"},"C80":{"text":"C80 - Rad","value":"C80"},"C81":{"text":"C81 - Radian","value":"C81"},"C82":{"text":"C82 - Radian metru pătrat pe mol","value":"C82"},"C83":{"text":"C83 - Radian metru pătrat pe kilogram","value":"C83"},"C84":{"text":"C84 - Radian pe metru","value":"C84"},"C85":{"text":"C85 - Angstrom reciproc","value":"C85"},"C86":{"text":"C86 - Metru cub reciproc","value":"C86"},"C87":{"text":"C87 - Metru cub reciproc pe secundă","value":"C87"},"C88":{"text":"C88 - Electron volt reciproc per metru cub","value":"C88"},"C89":{"text":"C89 - Henry reciproc","value":"C89"},"C9":{"text":"C9 - Grup de bobine","value":"C9"},"C90":{"text":"C90 - Joule reciproce pe metru cub","value":"C90"},"C91":{"text":"C91 - Reciproc Kelvin sau Kelvin la puterea minus unu","value":"C91"},"C92":{"text":"C92 - Metru reciproc","value":"C92"},"C93":{"text":"C93 - Metru pătrat reciproc","value":"C93"},"C94":{"text":"C94 - Minut reciproc","value":"C94"},"C95":{"text":"C95 - Mol reciproc","value":"C95"},"C96":{"text":"C96 - Pascal reciproc sau pascal la puterea minus unu","value":"C96"},"C97":{"text":"C97 - Secundă la puterea minus unu","value":"C97"},"C99":{"text":"C99 - Secundă la puterea minus unu pe metru pătrat","value":"C99"},"CCT":{"text":"CCT - Capacitate de transport în tone metrice","value":"CCT"},"CDL":{"text":"CDL - Candelă","value":"CDL"},"CEL":{"text":"CEL - Grad Celsius","value":"CEL"},"CEN":{"text":"CEN - Suta","value":"CEN"},"CG":{"text":"CG - Card","value":"CG"},"CGM":{"text":"CGM - Centigram","value":"CGM"},"CKG":{"text":"CKG - Coulomb pe kilogram","value":"CKG"},"CLF":{"text":"CLF - Sac (ciment)","value":"CLF"},"CLT":{"text":"CLT - Centilitru","value":"CLT"},"CMK":{"text":"CMK - Centimetru pătrat","value":"CMK"},"CMQ":{"text":"CMQ - Centimetru cub","value":"CMQ"},"CMT":{"text":"CMT - Centimetru","value":"CMT"},"CNP":{"text":"CNP - Pachet de o suta","value":"CNP"},"CNT":{"text":"CNT - Cental (UK)","value":"CNT"},"COU":{"text":"COU - Coulomb","value":"COU"},"CTG":{"text":"CTG - Conținut gram","value":"CTG"},"CTM":{"text":"CTM - Carat metric","value":"CTM"},"CTN":{"text":"CTN - Tonă de conţinut (metric)","value":"CTN"},"CUR":{"text":"CUR - Curie","value":"CUR"},"CWA":{"text":"CWA - Sute de livre (cwt)/sute de kilograme (SUA)","value":"CWA"},"CWI":{"text":"CWI - Chintal","value":"CWI"},"D03":{"text":"D03 - Kilowatt oră pe oră","value":"D03"},"D04":{"text":"D04 - Lot [unitate de greutate]","value":"D04"},"D1":{"text":"D1 - Secundă la puterea minus unu per steradian","value":"D1"},"D10":{"text":"D10 - Siemens pe metru","value":"D10"},"D11":{"text":"D11 - Mebibit","value":"D11"},"D12":{"text":"D12 - Siemens metru pătrat per mol","value":"D12"},"D13":{"text":"D13 - Sievert","value":"D13"},"D15":{"text":"D15 - Son","value":"D15"},"D16":{"text":"D16 - Centimetru pătrat pe erg","value":"D16"},"D17":{"text":"D17 - Centimetru pătrat pe erg steradian","value":"D17"},"D18":{"text":"D18 - Metru Kelvin","value":"D18"},"D19":{"text":"D19 - Metru pătrat Kelvin pe watt","value":"D19"},"D2":{"text":"D2 - Secundă la puterea minus unu pe metru steradian pătrat","value":"D2"},"D20":{"text":"D20 - Metru pătrat pe joule","value":"D20"},"D21":{"text":"D21 - Metru pătrat pe kilogram","value":"D21"},"D22":{"text":"D22 - Metru pătrat pe mol","value":"D22"},"D23":{"text":"D23 - 10 cmc per gram","value":"D23"},"D24":{"text":"D24 - Metru pătrat pe steradian","value":"D24"},"D25":{"text":"D25 - Metru pătrat pe joule steradian","value":"D25"},"D26":{"text":"D26 - Metru pătrat pe secundă volt","value":"D26"},"D27":{"text":"D27 - Steradian","value":"D27"},"D29":{"text":"D29 - Terahertz","value":"D29"},"D30":{"text":"D30 - Terajoule","value":"D30"},"D31":{"text":"D31 - Terawatt","value":"D31"},"D32":{"text":"D32 - Terawatt oră","value":"D32"},"D33":{"text":"D33 - Tesla","value":"D33"},"D34":{"text":"D34 - Tex","value":"D34"},"D36":{"text":"D36 - Megabit","value":"D36"},"D41":{"text":"D41 - Tonă pe metru cub","value":"D41"},"D42":{"text":"D42 - An tropic","value":"D42"},"D43":{"text":"D43 - Unitate de masă atomică unificată","value":"D43"},"D44":{"text":"D44 - Var","value":"D44"},"D45":{"text":"D45 - Volt pătrat pe Kelvin pătrat","value":"D45"},"D46":{"text":"D46 - Volt-amper","value":"D46"},"D47":{"text":"D47 - Volt pe centimetru","value":"D47"},"D48":{"text":"D48 - Volt per Kelvin","value":"D48"},"D49":{"text":"D49 - Milivolt per Kelvin","value":"D49"},"D5":{"text":"D5 - Kilogram pe centimetru pătrat","value":"D5"},"D50":{"text":"D50 - Volt pe metru","value":"D50"},"D51":{"text":"D51 - Volt pe milimetru","value":"D51"},"D52":{"text":"D52 - Watt per Kelvin","value":"D52"},"D53":{"text":"D53 - Watt pe metru Kelvin","value":"D53"},"D54":{"text":"D54 - Watt pe metru pătrat","value":"D54"},"D55":{"text":"D55 - Watt pe metru pătrat Kelvin","value":"D55"},"D56":{"text":"D56 - Watt pe metru pătrat Kelvin la a patra putere","value":"D56"},"D57":{"text":"D57 - Watt per steradian","value":"D57"},"D58":{"text":"D58 - Watt per metru pătrat steradian","value":"D58"},"D59":{"text":"D59 - Weber pe metru","value":"D59"},"D6":{"text":"D6 - Roentgen pe secundă","value":"D6"},"D60":{"text":"D60 - Weber pe milimetru","value":"D60"},"D61":{"text":"D61 - Minut [unghi]","value":"D61"},"D62":{"text":"D62 - Secunda [unitate de unghi]","value":"D62"},"D63":{"text":"D63 - Carte","value":"D63"},"D65":{"text":"D65 - Buștean","value":"D65"},"D68":{"text":"D68 - Număr de cuvinte","value":"D68"},"D69":{"text":"D69 - Inch la puterea a patra","value":"D69"},"D73":{"text":"D73 - Joule metru pătrat","value":"D73"},"D74":{"text":"D74 - Kilogram pe mol","value":"D74"},"D77":{"text":"D77 - Megacoulomb","value":"D77"},"D78":{"text":"D78 - Megajoule pe secundă","value":"D78"},"D80":{"text":"D80 - Microwatt","value":"D80"},"D81":{"text":"D81 - Microtesla","value":"D81"},"D82":{"text":"D82 - Microvolt","value":"D82"},"D83":{"text":"D83 - Milinewton metru","value":"D83"},"D85":{"text":"D85 - Microwatt pe metru pătrat","value":"D85"},"D86":{"text":"D86 - Miliicoulomb","value":"D86"},"D87":{"text":"D87 - Millimol pe kilogram","value":"D87"},"D88":{"text":"D88 - Miliicoulomb pe metru cub","value":"D88"},"D89":{"text":"D89 - Miliicoulomb pe metru pătrat","value":"D89"},"D91":{"text":"D91 - REM","value":"D91"},"D93":{"text":"D93 - Secundă pe metru cub","value":"D93"},"D94":{"text":"D94 - Secundă pe metru cub radian","value":"D94"},"D95":{"text":"D95 - Joule pe gram","value":"D95"},"DAA":{"text":"DAA - Decare","value":"DAA"},"DAD":{"text":"DAD - Decadă","value":"DAD"},"DAY":{"text":"DAY - Zi","value":"DAY"},"DB":{"text":"DB - Livra uscata","value":"DB"},"DD":{"text":"DD - Grad [unitate de unghi]","value":"DD"},"DEC":{"text":"DEC - Deceniu","value":"DEC"},"DG":{"text":"DG - Decigramă","value":"DG"},"DJ":{"text":"DJ - Decagramă","value":"DJ"},"DLT":{"text":"DLT - Decilitru","value":"DLT"},"DMA":{"text":"DMA - Decametru cub","value":"DMA"},"DMK":{"text":"DMK - Decimetru pătrat","value":"DMK"},"DMO":{"text":"DMO - Kilolitru standard (la 15 grd C)","value":"DMO"},"DMQ":{"text":"DMQ - Decimetru cub","value":"DMQ"},"DMT":{"text":"DMT - Decimetru","value":"DMT"},"DN":{"text":"DN - Decinewton metru","value":"DN"},"DPC":{"text":"DPC - Duzină","value":"DPC"},"DPR":{"text":"DPR - Duzină de perechi","value":"DPR"},"DPT":{"text":"DPT - Deplasament metric (tone)","value":"DPT"},"DRA":{"text":"DRA - DRAM (SUA)","value":"DRA"},"DRI":{"text":"DRI - DRAM (UK)","value":"DRI"},"DRL":{"text":"DRL - Duzina de rolă","value":"DRL"},"DT":{"text":"DT - Tonă uscată","value":"DT"},"DTN":{"text":"DTN - Decitonă","value":"DTN"},"DWT":{"text":"DWT - Pennyweight","value":"DWT"},"DZN":{"text":"DZN - Duzină","value":"DZN"},"DZP":{"text":"DZP - Duzină de pachete","value":"DZP"},"E01":{"text":"E01 - Newton pe centimetru pătrat","value":"E01"},"E07":{"text":"E07 - Megawatt oră pe oră","value":"E07"},"E08":{"text":"E08 - Megawatt per hertz","value":"E08"},"E09":{"text":"E09 - Miliamper ora","value":"E09"},"E10":{"text":"E10 - Grad pe zi","value":"E10"},"E12":{"text":"E12 - Mille","value":"E12"},"E14":{"text":"E14 - Kilocalorie (tabel internațional)","value":"E14"},"E15":{"text":"E15 - Kilocalorie (termochimică) pe oră","value":"E15"},"E16":{"text":"E16 - Milioane Btu(IT) pe oră","value":"E16"},"E17":{"text":"E17 - Picior cubic pe secundă","value":"E17"},"E18":{"text":"E18 - Tonă pe oră","value":"E18"},"E19":{"text":"E19 - Ping","value":"E19"},"E20":{"text":"E20 - Megabit pe secundă","value":"E20"},"E21":{"text":"E21 - Acțiuni","value":"E21"},"E22":{"text":"E22 - TEU","value":"E22"},"E23":{"text":"E23 - Pneu","value":"E23"},"E25":{"text":"E25 - Unitate activa","value":"E25"},"E27":{"text":"E27 - Doză","value":"E27"},"E28":{"text":"E28 - Tonă uscată de aer","value":"E28"},"E30":{"text":"E30 - Componentă","value":"E30"},"E31":{"text":"E31 - Metru pătrat pe litru","value":"E31"},"E32":{"text":"E32 - Litru pe oră","value":"E32"},"E33":{"text":"E33 - Picior la mie","value":"E33"},"E34":{"text":"E34 - Gigabyte","value":"E34"},"E35":{"text":"E35 - Terabyte","value":"E35"},"E36":{"text":"E36 - Petabyte","value":"E36"},"E37":{"text":"E37 - Pixel","value":"E37"},"E38":{"text":"E38 - Megapixel","value":"E38"},"E39":{"text":"E39 - Puncte pe inch","value":"E39"},"E4":{"text":"E4 - Kilogram brut","value":"E4"},"E40":{"text":"E40 - Partea la o suta de mii","value":"E40"},"E41":{"text":"E41 - Kilogram-forță pe milimetru pătrat","value":"E41"},"E42":{"text":"E42 - Kilogram-forță pe centimetru pătrat","value":"E42"},"E43":{"text":"E43 - Joule pe centimetru pătrat","value":"E43"},"E44":{"text":"E44 - Kilogram-forță metru pe centimetru pătrat","value":"E44"},"E45":{"text":"E45 - Miliohm","value":"E45"},"E46":{"text":"E46 - Kilowatt oră pe metru cub","value":"E46"},"E47":{"text":"E47 - Kilowatt oră per Kelvin","value":"E47"},"E48":{"text":"E48 - Unitate de service","value":"E48"},"E49":{"text":"E49 - Zi lucrătoare","value":"E49"},"E50":{"text":"E50 - Unitate de contabilitate","value":"E50"},"E51":{"text":"E51 - Loc de muncă","value":"E51"},"E52":{"text":"E52 - Pasi deplasare","value":"E52"},"E53":{"text":"E53 - Test","value":"E53"},"E54":{"text":"E54 - Deplasare","value":"E54"},"E55":{"text":"E55 - Utilizare","value":"E55"},"E56":{"text":"E56 - Unitate de foraj","value":"E56"},"E57":{"text":"E57 - Zonă","value":"E57"},"E58":{"text":"E58 - Exabit pe secundă","value":"E58"},"E59":{"text":"E59 - Exbibyte","value":"E59"},"E60":{"text":"E60 - Pebibyte","value":"E60"},"E61":{"text":"E61 - Tebibyte","value":"E61"},"E62":{"text":"E62 - Gibibyte","value":"E62"},"E63":{"text":"E63 - Mebibyte","value":"E63"},"E64":{"text":"E64 - Kibibyte","value":"E64"},"E65":{"text":"E65 - Exbibit pe metru","value":"E65"},"E66":{"text":"E66 - Exbibit pe metru pătrat","value":"E66"},"E67":{"text":"E67 - Exbibit pe metru cub","value":"E67"},"E68":{"text":"E68 - Gigabyte pe secundă","value":"E68"},"E69":{"text":"E69 - Gibibit pe metru","value":"E69"},"E70":{"text":"E70 - Gibibit pe metru pătrat","value":"E70"},"E71":{"text":"E71 - Gibibit pe metru cub","value":"E71"},"E72":{"text":"E72 - Kibibit pe metru","value":"E72"},"E73":{"text":"E73 - Kibibit pe metru pătrat","value":"E73"},"E74":{"text":"E74 - Kibibit pe metru cub","value":"E74"},"E75":{"text":"E75 - Mebibit pe metru","value":"E75"},"E76":{"text":"E76 - Mebibit pe metru pătrat","value":"E76"},"E77":{"text":"E77 - Mebibit pe metru cub","value":"E77"},"E78":{"text":"E78 - Petabit","value":"E78"},"E79":{"text":"E79 - Petabit pe secundă","value":"E79"},"E80":{"text":"E80 - Pebibit pe metru","value":"E80"},"E81":{"text":"E81 - Pebibit pe metru pătrat","value":"E81"},"E82":{"text":"E82 - Pebibit pe metru cub","value":"E82"},"E83":{"text":"E83 - Terabit","value":"E83"},"E84":{"text":"E84 - Terabit pe secundă","value":"E84"},"E85":{"text":"E85 - Tebibit pe metru","value":"E85"},"E86":{"text":"E86 - Tebibit pe metru cub","value":"E86"},"E87":{"text":"E87 - Tebibit pe metru pătrat","value":"E87"},"E88":{"text":"E88 - Bit pe metru","value":"E88"},"E89":{"text":"E89 - Bit pe metru pătrat","value":"E89"},"E90":{"text":"E90 - Centimetru la puterea minus unu","value":"E90"},"E91":{"text":"E91 - Zi la puterea minus unu","value":"E91"},"E92":{"text":"E92 - Decimetru cub pe oră","value":"E92"},"E93":{"text":"E93 - Kilogram pe oră","value":"E93"},"E94":{"text":"E94 - Kilomol pe secundă","value":"E94"},"E95":{"text":"E95 - Mol pe secundă","value":"E95"},"E96":{"text":"E96 - Grad pe secundă","value":"E96"},"E97":{"text":"E97 - Milimetri pe grad celcius metru","value":"E97"},"E98":{"text":"E98 - Grad Celsius pe Kelvin","value":"E98"},"E99":{"text":"E99 - Hectopascal per bar","value":"E99"},"EA":{"text":"EA - Unitate","value":"EA"},"EB":{"text":"EB - Căsută poștală electronică","value":"EB"},"EQ":{"text":"EQ - Galon echivalent","value":"EQ"},"F01":{"text":"F01 - Bit pe metru cub","value":"F01"},"F02":{"text":"F02 - Kelvin per Kelvin","value":"F02"},"F03":{"text":"F03 - Kilopascal pe bar","value":"F03"},"F04":{"text":"F04 - Milibar pe bar","value":"F04"},"F05":{"text":"F05 - Megapascal pe bar","value":"F05"},"F06":{"text":"F06 - Poise pe bar","value":"F06"},"F07":{"text":"F07 - Pascal pe bar","value":"F07"},"F08":{"text":"F08 - Milliampere pe inch","value":"F08"},"F10":{"text":"F10 - Kelvin pe oră","value":"F10"},"F11":{"text":"F11 - Kelvin pe minut","value":"F11"},"F12":{"text":"F12 - Kelvin pe secundă","value":"F12"},"F13":{"text":"F13 - Slug","value":"F13"},"F14":{"text":"F14 - Gram pe Kelvin","value":"F14"},"F15":{"text":"F15 - Kilogram pe Kelvin","value":"F15"},"F16":{"text":"F16 - Miligram per Kelvin","value":"F16"},"F17":{"text":"F17 - Livră-forță pe picior","value":"F17"},"F18":{"text":"F18 - Kilogram de centimetru pătrat","value":"F18"},"F19":{"text":"F19 - Kilogram milimetru pătrat","value":"F19"},"F20":{"text":"F20 - Livra inch pătrat","value":"F20"},"F21":{"text":"F21 - Livra-forță inch","value":"F21"},"F22":{"text":"F22 - Livra-forță picior pe amperi","value":"F22"},"F23":{"text":"F23 - Gram pe decimetru cub","value":"F23"},"F24":{"text":"F24 - Kilogram pe kilomol","value":"F24"},"F25":{"text":"F25 - Gram per hertz","value":"F25"},"F26":{"text":"F26 - Gram pe zi","value":"F26"},"F27":{"text":"F27 - Gram pe oră","value":"F27"},"F28":{"text":"F28 - Gram pe minut","value":"F28"},"F29":{"text":"F29 - Gram pe secundă","value":"F29"},"F30":{"text":"F30 - Kilogram pe zi","value":"F30"},"F31":{"text":"F31 - Kilogram pe minut","value":"F31"},"F32":{"text":"F32 - Miligram pe zi","value":"F32"},"F33":{"text":"F33 - Miligram pe minut","value":"F33"},"F34":{"text":"F34 - Miligram pe secundă","value":"F34"},"F35":{"text":"F35 - Gram pe zi Kelvin","value":"F35"},"F36":{"text":"F36 - Gram pe oră Kelvin","value":"F36"},"F37":{"text":"F37 - Gram pe minut Kelvin","value":"F37"},"F38":{"text":"F38 - Gram pe secundă Kelvin","value":"F38"},"F39":{"text":"F39 - Kg pe zi Kelvin","value":"F39"},"F40":{"text":"F40 - Kilogram pe oră Kelvin","value":"F40"},"F41":{"text":"F41 - Kilogram pe minut Kelvin","value":"F41"},"F42":{"text":"F42 - Kilogram pe secundă Kelvin","value":"F42"},"F43":{"text":"F43 - Miligram pe zi Kelvin","value":"F43"},"F44":{"text":"F44 - Miligram pe oră Kelvin","value":"F44"},"F45":{"text":"F45 - Miligram pe minut Kelvin","value":"F45"},"F46":{"text":"F46 - Miligram pe secundă Kelvin","value":"F46"},"F47":{"text":"F47 - Newton pe milimetru","value":"F47"},"F48":{"text":"F48 - Livră-forță pe centimetru","value":"F48"},"F49":{"text":"F49 - Tijă [unitate de distanță]","value":"F49"},"F50":{"text":"F50 - Micrometru per Kelvin","value":"F50"},"F51":{"text":"F51 - Centimetru pe Kelvin","value":"F51"},"F52":{"text":"F52 - Metru pe Kelvin","value":"F52"},"F53":{"text":"F53 - Milimetru pe Kelvin","value":"F53"},"F54":{"text":"F54 - Miliohm pe metru","value":"F54"},"F55":{"text":"F55 - Ohm pe milă (statute mile)","value":"F55"},"F56":{"text":"F56 - Ohm pe kilometru","value":"F56"},"F57":{"text":"F57 - Miliamper per kilogram-forță pe centimetru pătrat","value":"F57"},"F58":{"text":"F58 - Bar la puterea minus unu","value":"F58"},"F59":{"text":"F59 - Milliamper pe bar","value":"F59"},"F60":{"text":"F60 - Grad Celsius pe bar","value":"F60"},"F61":{"text":"F61 - Kelvin pe bar","value":"F61"},"F62":{"text":"F62 - Gram pe zi bar","value":"F62"},"F63":{"text":"F63 - Gram pe oră bar","value":"F63"},"F64":{"text":"F64 - Gram pe bar pe minut","value":"F64"},"F65":{"text":"F65 - Gram pe secundă bar","value":"F65"},"F66":{"text":"F66 - Kilogram pe bar pe zi","value":"F66"},"F67":{"text":"F67 - Kilogram pe oră bar","value":"F67"},"F68":{"text":"F68 - Kilogram pe minut bar","value":"F68"},"F69":{"text":"F69 - Kilogram pe secundă bar","value":"F69"},"F70":{"text":"F70 - Miligram pe zi bar","value":"F70"},"F71":{"text":"F71 - Miligram pe oră bar","value":"F71"},"F72":{"text":"F72 - Miligram pe bar de minut","value":"F72"},"F73":{"text":"F73 - Miligram pe secundă bar","value":"F73"},"F74":{"text":"F74 - Gram pe bar","value":"F74"},"F75":{"text":"F75 - Miligram pe bar","value":"F75"},"F76":{"text":"F76 - Miliamper pe milimetru","value":"F76"},"F77":{"text":"F77 - Pascal pe secundă pe Kelvin","value":"F77"},"F78":{"text":"F78 - Inch coloană de apă","value":"F78"},"F79":{"text":"F79 - Centimetru coloană de mercur","value":"F79"},"F80":{"text":"F80 - Cal putere hidraulic","value":"F80"},"F81":{"text":"F81 - Bar pe Kelvin","value":"F81"},"F82":{"text":"F82 - Hectopascal per Kelvin","value":"F82"},"F83":{"text":"F83 - Kilopascal pe Kelvin","value":"F83"},"F84":{"text":"F84 - Milibar pe Kelvin","value":"F84"},"F85":{"text":"F85 - Megapascal pe Kelvin","value":"F85"},"F86":{"text":"F86 - Poise per Kelvin","value":"F86"},"F87":{"text":"F87 - Volt pe litru minut","value":"F87"},"F88":{"text":"F88 - Centimetru Newton","value":"F88"},"F89":{"text":"F89 - Newton metru pe grad","value":"F89"},"F90":{"text":"F90 - Newton metru pe amper","value":"F90"},"F91":{"text":"F91 - Bar litru pe secundă","value":"F91"},"F92":{"text":"F92 - Bar cub metru pe secundă","value":"F92"},"F93":{"text":"F93 - Hectopascal litru pe secundă","value":"F93"},"F94":{"text":"F94 - Metru cub hectopascal pe secundă","value":"F94"},"F95":{"text":"F95 - Milibar litru pe secundă","value":"F95"},"F96":{"text":"F96 - Milibar metru cub pe secundă","value":"F96"},"F97":{"text":"F97 - Megapascal litru pe secundă","value":"F97"},"F98":{"text":"F98 - Metru cub megapascal pe secundă","value":"F98"},"F99":{"text":"F99 - Litru Pascal pe secundă","value":"F99"},"FAH":{"text":"FAH - Grad Fahrenheit","value":"FAH"},"FAR":{"text":"FAR - Farad","value":"FAR"},"FBM":{"text":"FBM - Metru de fibră","value":"FBM"},"FC":{"text":"FC - Kilo pași cub","value":"FC"},"FF":{"text":"FF - Sută metri cubi","value":"FF"},"FH":{"text":"FH - Micromol","value":"FH"},"FIT":{"text":"FIT - Defect în timp","value":"FIT"},"FL":{"text":"FL - Tonă fulgi","value":"FL"},"FOT":{"text":"FOT - Pas","value":"FOT"},"FP":{"text":"FP - Livră pe metru pătrat","value":"FP"},"FR":{"text":"FR - Picior pe minut","value":"FR"},"FS":{"text":"FS - Picior pe secundă","value":"FS"},"FTK":{"text":"FTK - Picior pătrat","value":"FTK"},"FTQ":{"text":"FTQ - Picior cubic","value":"FTQ"},"G01":{"text":"G01 - Metru cub pascal pe secundă","value":"G01"},"G04":{"text":"G04 - Centimetru pe bar","value":"G04"},"G05":{"text":"G05 - Metru pe bar","value":"G05"},"G06":{"text":"G06 - Milimetri per bar","value":"G06"},"G08":{"text":"G08 - Pătrat inch pe secundă","value":"G08"},"G09":{"text":"G09 - Metru pătrat pe secundă Kelvin","value":"G09"},"G10":{"text":"G10 - Stokes per Kelvin","value":"G10"},"G11":{"text":"G11 - Gram pe bar centimetru cub","value":"G11"},"G12":{"text":"G12 - Gram pe bar de decimetru cub","value":"G12"},"G13":{"text":"G13 - Gram pe litru bar","value":"G13"},"G14":{"text":"G14 - Gram pe metru cub bar","value":"G14"},"G15":{"text":"G15 - Gram pe bar mililitru","value":"G15"},"G16":{"text":"G16 - Kilogram pe bar centimetru cub","value":"G16"},"G17":{"text":"G17 - Kilogram pe litru bar","value":"G17"},"G18":{"text":"G18 - Kilogram pe metru cub bar","value":"G18"},"G19":{"text":"G19 - Newton metru pe kilogram","value":"G19"},"G2":{"text":"G2 - Galon (SUA) pe minut","value":"G2"},"G20":{"text":"G20 - Livră-forță picior pe kilogram","value":"G20"},"G21":{"text":"G21 - Cupă [unitate de volum]","value":"G21"},"G23":{"text":"G23 - Peck","value":"G23"},"G24":{"text":"G24 - Lingură (SUA)","value":"G24"},"G25":{"text":"G25 - Linguriță (SUA)","value":"G25"},"G26":{"text":"G26 - Ster","value":"G26"},"G27":{"text":"G27 - Centimetru cub pe Kelvin","value":"G27"},"G28":{"text":"G28 - Litru pe Kelvin","value":"G28"},"G29":{"text":"G29 - Metru cub per Kelvin","value":"G29"},"G3":{"text":"G3 - Galon imperial pe minut","value":"G3"},"G30":{"text":"G30 - Mililitru pe Kelvin","value":"G30"},"G31":{"text":"G31 - Kilogram pe centimetru cub","value":"G31"},"G32":{"text":"G32 - Uncie (avoirdupois) per picior cubic","value":"G32"},"G33":{"text":"G33 - Gram pe centimetru cub Kelvin","value":"G33"},"G34":{"text":"G34 - Gram pe decimetru cub Kelvin","value":"G34"},"G35":{"text":"G35 - Gram pe litru Kelvin","value":"G35"},"G36":{"text":"G36 - Gram pe metru cub Kelvin","value":"G36"},"G37":{"text":"G37 - Gram pe mililitru Kelvin","value":"G37"},"G38":{"text":"G38 - Kilogram pe centimetru cub Kelvin","value":"G38"},"G39":{"text":"G39 - Kilogram pe litru Kelvin","value":"G39"},"G40":{"text":"G40 - Kilogram pe metru cub Kelvin","value":"G40"},"G41":{"text":"G41 - Metru pătrat pe bar secundă","value":"G41"},"G42":{"text":"G42 - Microsiemens pe centimetru","value":"G42"},"G43":{"text":"G43 - Microsiemens pe metru","value":"G43"},"G44":{"text":"G44 - Nanosiemens pe centimetru","value":"G44"},"G45":{"text":"G45 - Nanosiemens pe metru","value":"G45"},"G46":{"text":"G46 - Stokes pe bar","value":"G46"},"G47":{"text":"G47 - Centimetru cub pe zi","value":"G47"},"G48":{"text":"G48 - Centimetru cub pe oră","value":"G48"},"G49":{"text":"G49 - Centimetru cub pe minut","value":"G49"},"G50":{"text":"G50 - Galon (SUA) pe oră","value":"G50"},"G51":{"text":"G51 - Litru pe secundă","value":"G51"},"G52":{"text":"G52 - Metru cub pe zi","value":"G52"},"G53":{"text":"G53 - Metru cub pe minut","value":"G53"},"G54":{"text":"G54 - Mililitru pe zi","value":"G54"},"G55":{"text":"G55 - Mililitru pe oră","value":"G55"},"G56":{"text":"G56 - Centimetru cub pe oră","value":"G56"},"G57":{"text":"G57 - Centimetru cub pe minut","value":"G57"},"G58":{"text":"G58 - Centimetru cub pe secundă","value":"G58"},"G59":{"text":"G59 - Miliamper pe litru minut","value":"G59"},"G60":{"text":"G60 - Volt pe bar","value":"G60"},"G61":{"text":"G61 - Centimetru cub pe zi Kelvin","value":"G61"},"G62":{"text":"G62 - Centimetru cub pe oră Kelvin","value":"G62"},"G63":{"text":"G63 - Centimetru cub pe minut Kelvin","value":"G63"},"G64":{"text":"G64 - Centimetru cub pe secundă Kelvin","value":"G64"},"G65":{"text":"G65 - Litru pe zi Kelvin","value":"G65"},"G66":{"text":"G66 - Litru pe oră Kelvin","value":"G66"},"G67":{"text":"G67 - Litru pe minut Kelvin","value":"G67"},"G68":{"text":"G68 - Litru pe secundă Kelvin","value":"G68"},"G69":{"text":"G69 - Metru cub pe zi Kelvin","value":"G69"},"G70":{"text":"G70 - Metru cub pe oră Kelvin","value":"G70"},"G71":{"text":"G71 - Metru cub pe minut Kelvin","value":"G71"},"G72":{"text":"G72 - Metru cub pe secundă Kelvin","value":"G72"},"G73":{"text":"G73 - Mililitru pe zi Kelvin","value":"G73"},"G74":{"text":"G74 - Mililitru pe oră Kelvin","value":"G74"},"G75":{"text":"G75 - Mililitru pe minut Kelvin","value":"G75"},"G76":{"text":"G76 - Mililitru pe secundă Kelvin","value":"G76"},"G77":{"text":"G77 - Milimetri la puterea a patra","value":"G77"},"G78":{"text":"G78 - Centimetru cub pe bar zi","value":"G78"},"G79":{"text":"G79 - Centimetru cub pe bar oră","value":"G79"},"G80":{"text":"G80 - Centimetru cub pe bar minut","value":"G80"},"G81":{"text":"G81 - Centimetru cub pe bar secundă","value":"G81"},"G82":{"text":"G82 - Litru pe zi bar","value":"G82"},"G83":{"text":"G83 - Litru pe oră bar","value":"G83"},"G84":{"text":"G84 - Litru pe minut bar","value":"G84"},"G85":{"text":"G85 - Litru pe secundă bar","value":"G85"},"G86":{"text":"G86 - Metru cub pe zi bar","value":"G86"},"G87":{"text":"G87 - Metru cub pe oră bar","value":"G87"},"G88":{"text":"G88 - Metru cub pe minut bar","value":"G88"},"G89":{"text":"G89 - Metru cub pe secundă bar","value":"G89"},"G90":{"text":"G90 - Mililitru pe zi bar","value":"G90"},"G91":{"text":"G91 - Mililitru pe oră bar","value":"G91"},"G92":{"text":"G92 - Mililitru pe minut bar","value":"G92"},"G93":{"text":"G93 - Mililitru pe secundă bar","value":"G93"},"G94":{"text":"G94 - Centimetru cub pe bar","value":"G94"},"G95":{"text":"G95 - Litru pe bar","value":"G95"},"G96":{"text":"G96 - Metru cub pe bar","value":"G96"},"G97":{"text":"G97 - Mililitru pe bar","value":"G97"},"G98":{"text":"G98 - Microhenry pe kiloohm","value":"G98"},"G99":{"text":"G99 - Microhenry pe ohm","value":"G99"},"GB":{"text":"GB - Galon (SUA) pe zi","value":"GB"},"GBQ":{"text":"GBQ - Gigabecquerel","value":"GBQ"},"GDW":{"text":"GDW - Gram, greutate uscată","value":"GDW"},"GE":{"text":"GE - Livră pe galon (SUA)","value":"GE"},"GF":{"text":"GF - Gram pe metru","value":"GF"},"GFI":{"text":"GFI - Gram de izotop fisionabil","value":"GFI"},"GGR":{"text":"GGR - Unitate brută","value":"GGR"},"GIA":{"text":"GIA - Gill (SUA)","value":"GIA"},"GIC":{"text":"GIC - Gram, inclusiv recipientul","value":"GIC"},"GII":{"text":"GII - Gill (UK)","value":"GII"},"GIP":{"text":"GIP - Gram, inclusiv ambalajul interior","value":"GIP"},"GJ":{"text":"GJ - Gram pe mililitru","value":"GJ"},"GL":{"text":"GL - Gram pe litru","value":"GL"},"GLD":{"text":"GLD - Galon uscat (SUA)","value":"GLD"},"GLI":{"text":"GLI - Galon (UK)","value":"GLI"},"GLL":{"text":"GLL - Galon (SUA)","value":"GLL"},"GM":{"text":"GM - Gram pe metru pătrat","value":"GM"},"GO":{"text":"GO - Miligram pe metru pătrat","value":"GO"},"GP":{"text":"GP - Miligram pe metru cub","value":"GP"},"GQ":{"text":"GQ - Microgram pe metru cub","value":"GQ"},"GRM":{"text":"GRM - Gram","value":"GRM"},"GRN":{"text":"GRN - Bob [unitate farmaceutică]","value":"GRN"},"GRO":{"text":"GRO - Brut","value":"GRO"},"GV":{"text":"GV - Gigajoule","value":"GV"},"GWH":{"text":"GWH - Gigawatt oră","value":"GWH"},"H03":{"text":"H03 - Henry pe kiloohm","value":"H03"},"H04":{"text":"H04 - Henry pe ohm","value":"H04"},"H05":{"text":"H05 - Milihenry pe kiloohm","value":"H05"},"H06":{"text":"H06 - Milihenry per ohm","value":"H06"},"H07":{"text":"H07 - Pascal secundă pe bar","value":"H07"},"H08":{"text":"H08 - Microbecquerel","value":"H08"},"H09":{"text":"H09 - An la puterea minus unu","value":"H09"},"H10":{"text":"H10 - Oră la puterea minus unu","value":"H10"},"H11":{"text":"H11 - Lună la puterea minus unu","value":"H11"},"H12":{"text":"H12 - Grad Celsius pe oră","value":"H12"},"H13":{"text":"H13 - Grad Celsius pe minut","value":"H13"},"H14":{"text":"H14 - Grad Celsius pe secundă","value":"H14"},"H15":{"text":"H15 - Centimetru pătrat pe gram","value":"H15"},"H16":{"text":"H16 - Decametru pătrat","value":"H16"},"H18":{"text":"H18 - Hectometri pătrați","value":"H18"},"H19":{"text":"H19 - Hectometri cubi","value":"H19"},"H20":{"text":"H20 - Kilometru cub","value":"H20"},"H21":{"text":"H21 - Blanchetă","value":"H21"},"H22":{"text":"H22 - Volt pe inch pătrat pe kilogram-forță","value":"H22"},"H23":{"text":"H23 - Volt pe inch","value":"H23"},"H24":{"text":"H24 - Volt pe microsecundă","value":"H24"},"H25":{"text":"H25 - Procent per Kelvin","value":"H25"},"H26":{"text":"H26 - Ohm pe metru","value":"H26"},"H27":{"text":"H27 - Grad pe metru","value":"H27"},"H28":{"text":"H28 - Microfarad pe kilometru","value":"H28"},"H29":{"text":"H29 - Microgram per litru","value":"H29"},"H30":{"text":"H30 - Micrometru pătrat (micron pătrat)","value":"H30"},"H31":{"text":"H31 - Amper pe kilogram","value":"H31"},"H32":{"text":"H32 - Amper pătrat pe secundă","value":"H32"},"H33":{"text":"H33 - Farad pe kilometru","value":"H33"},"H34":{"text":"H34 - Hertz metru","value":"H34"},"H35":{"text":"H35 - Kelvin metru pe watt","value":"H35"},"H36":{"text":"H36 - Megaohm pe kilometru","value":"H36"},"H37":{"text":"H37 - Megaohm pe metru","value":"H37"},"H38":{"text":"H38 - Megaamper","value":"H38"},"H39":{"text":"H39 - Megahertz kilometru","value":"H39"},"H40":{"text":"H40 - Newton pe amper","value":"H40"},"H41":{"text":"H41 - Newton metru watt la puterea minus 0,5","value":"H41"},"H42":{"text":"H42 - Pascal pe metru","value":"H42"},"H43":{"text":"H43 - Siemens pe centimetru","value":"H43"},"H44":{"text":"H44 - Teraohm","value":"H44"},"H45":{"text":"H45 - Volt secundă pe metru","value":"H45"},"H46":{"text":"H46 - Volt pe secundă","value":"H46"},"H47":{"text":"H47 - Watt pe metru cub","value":"H47"},"H48":{"text":"H48 - Attofarad","value":"H48"},"H49":{"text":"H49 - Centimetru pe oră","value":"H49"},"H50":{"text":"H50 - Centimetru cub reciproc","value":"H50"},"H51":{"text":"H51 - Decibel pe kilometru","value":"H51"},"H52":{"text":"H52 - Decibel pe metru","value":"H52"},"H53":{"text":"H53 - Kilogram per bar","value":"H53"},"H54":{"text":"H54 - Kilogram pe decimetru cub Kelvin","value":"H54"},"H55":{"text":"H55 - Kilogram pe bara de decimetru cub","value":"H55"},"H56":{"text":"H56 - Kilogram pe metru pătrat secundă","value":"H56"},"H57":{"text":"H57 - Inch per doi pi radiant","value":"H57"},"H58":{"text":"H58 - Metru pe secundă volt","value":"H58"},"H59":{"text":"H59 - Metru pătrat pe newton","value":"H59"},"H60":{"text":"H60 - Metru cub pe metru cub","value":"H60"},"H61":{"text":"H61 - Milisiemens pe centimetru","value":"H61"},"H62":{"text":"H62 - Milivolt pe minut","value":"H62"},"H63":{"text":"H63 - Miligram pe centimetru pătrat","value":"H63"},"H64":{"text":"H64 - Miligram pe gram","value":"H64"},"H65":{"text":"H65 - Mililitru pe metru cub","value":"H65"},"H66":{"text":"H66 - Milimetri pe an","value":"H66"},"H67":{"text":"H67 - Milimetri pe oră","value":"H67"},"H68":{"text":"H68 - Millimol pe gram","value":"H68"},"H69":{"text":"H69 - Picopascal pe kilometru","value":"H69"},"H70":{"text":"H70 - Picosecundă","value":"H70"},"H71":{"text":"H71 - Procente pe lună","value":"H71"},"H72":{"text":"H72 - Procent pe hectobar","value":"H72"},"H73":{"text":"H73 - Procente pe decaKelvin","value":"H73"},"H74":{"text":"H74 - Watt pe metru","value":"H74"},"H75":{"text":"H75 - Decapascal","value":"H75"},"H76":{"text":"H76 - Gram pe milimetru","value":"H76"},"H77":{"text":"H77 - Lățime modulară","value":"H77"},"H79":{"text":"H79 - Ecartament francez","value":"H79"},"H80":{"text":"H80 - Unitate de rack","value":"H80"},"H81":{"text":"H81 - Milimetri pe minut","value":"H81"},"H82":{"text":"H82 - Punct tipografic","value":"H82"},"H83":{"text":"H83 - Litru pe kilogram","value":"H83"},"H84":{"text":"H84 - Gram milimetru","value":"H84"},"H85":{"text":"H85 - Săptămână la puterea minus unu","value":"H85"},"H87":{"text":"H87 - Bucată","value":"H87"},"H88":{"text":"H88 - Megaohm kilometru","value":"H88"},"H89":{"text":"H89 - Procent pe ohm","value":"H89"},"H90":{"text":"H90 - Procent pe grad","value":"H90"},"H91":{"text":"H91 - Procent la zece mii","value":"H91"},"H92":{"text":"H92 - Procent la suta de mii","value":"H92"},"H93":{"text":"H93 - Procent la sută","value":"H93"},"H94":{"text":"H94 - Procent la mie","value":"H94"},"H95":{"text":"H95 - Procent per volt","value":"H95"},"H96":{"text":"H96 - Procent per bar","value":"H96"},"H98":{"text":"H98 - Procent pe inch","value":"H98"},"H99":{"text":"H99 - Procent pe metru","value":"H99"},"HA":{"text":"HA - Hank","value":"HA"},"HBA":{"text":"HBA - Hectobar","value":"HBA"},"HBX":{"text":"HBX - Sute de cutii","value":"HBX"},"HC":{"text":"HC - Set de o suta","value":"HC"},"HDW":{"text":"HDW - Chintal, greutate uscată","value":"HDW"},"HEA":{"text":"HEA - Capete","value":"HEA"},"HGM":{"text":"HGM - Hectogram","value":"HGM"},"HH":{"text":"HH - O sută de metri cubi","value":"HH"},"HIU":{"text":"HIU - O sută de unități internaționale","value":"HIU"},"HKM":{"text":"HKM - Chintal, masă netă","value":"HKM"},"HLT":{"text":"HLT - Hectolitru","value":"HLT"},"HM":{"text":"HM - Milă pe oră (milometru statuat)","value":"HM"},"HMQ":{"text":"HMQ - Milioane de metri cubi","value":"HMQ"},"HMT":{"text":"HMT - Hectometri","value":"HMT"},"HPA":{"text":"HPA - Hectolitru de alcool pur","value":"HPA"},"HTZ":{"text":"HTZ - Hertz","value":"HTZ"},"HUR":{"text":"HUR - Oră","value":"HUR"},"IA":{"text":"IA - Inch pe livră","value":"IA"},"IE":{"text":"IE - Persoană","value":"IE"},"INH":{"text":"INH - Inch","value":"INH"},"INK":{"text":"INK - Centimetru pătrat","value":"INK"},"INQ":{"text":"INQ - Inch cub","value":"INQ"},"ISD":{"text":"ISD - Grad internațional de zahăr","value":"ISD"},"IU":{"text":"IU - Inch pe secundă","value":"IU"},"IUG":{"text":"IUG - Unitate internațională pe gram","value":"IUG"},"IV":{"text":"IV - Centimetru pe secundă la pătrat","value":"IV"},"J10":{"text":"J10 - Procent pe milimetru","value":"J10"},"J12":{"text":"J12 - Per mille pe psi","value":"J12"},"J13":{"text":"J13 - Grad API","value":"J13"},"J14":{"text":"J14 - Grad Baume (scară de origine)","value":"J14"},"J15":{"text":"J15 - Grad Baume (SUA, mai dens decât apa)","value":"J15"},"J16":{"text":"J16 - Grad Baume (SUA, mai ușor decât apa)","value":"J16"},"J17":{"text":"J17 - Grad Balling","value":"J17"},"J18":{"text":"J18 - Grad Brix","value":"J18"},"J19":{"text":"J19 - Grad Fahrenheit oră metru pătrat pe BTU (termochimic)","value":"J19"},"J2":{"text":"J2 - Joule pe kilogram","value":"J2"},"J20":{"text":"J20 - Grad Fahrenheit per Kelvin","value":"J20"},"J21":{"text":"J21 - Grad Fahrenheit per bar","value":"J21"},"J22":{"text":"J22 - Grad Fahrenheit oră pătrată pe BTU (masă internațională)","value":"J22"},"J23":{"text":"J23 - Grad Fahrenheit pe orp","value":"J23"},"J24":{"text":"J24 - Grad Fahrenheit pe minut","value":"J24"},"J25":{"text":"J25 - Grad Fahrenheit pe secundă","value":"J25"},"J26":{"text":"J26 - Grad reciproc Fahrenheit","value":"J26"},"J27":{"text":"J27 - Grad Oechsle","value":"J27"},"J28":{"text":"J28 - Grad Rankine pe oră","value":"J28"},"J29":{"text":"J29 - Grad Rankine pe minut","value":"J29"},"J30":{"text":"J30 - Grad Rankine pe secundă","value":"J30"},"J31":{"text":"J31 - Grad Twaddell","value":"J31"},"J32":{"text":"J32 - MicroPoise","value":"J32"},"J33":{"text":"J33 - Microgram per kilogram","value":"J33"},"J34":{"text":"J34 - Microgram pe metru cub Kelvin","value":"J34"},"J35":{"text":"J35 - Microgram pe metru cub bar","value":"J35"},"J36":{"text":"J36 - Microlitru pe litru","value":"J36"},"J38":{"text":"J38 - Baud","value":"J38"},"J39":{"text":"J39 - BTU (medie)","value":"J39"},"J40":{"text":"J40 - BTU (măsură internațională) picior pe oră picior pătrat grad Fahrenheit","value":"J40"},"J41":{"text":"J41 - BTU (măsură internațională) inch pe oră picior pătrat grad Fahrenheit","value":"J41"},"J42":{"text":"J42 - BTU (măsură internațională) inch pe secundă picior pătrat grad Fahrenheit","value":"J42"},"J43":{"text":"J43 - BTU (tabel internațional) pe grad pe livra Fahrenheit","value":"J43"},"J44":{"text":"J44 - BTU (tabel internațional) pe minut","value":"J44"},"J45":{"text":"J45 - BTU (tabel internațional) pe secundă","value":"J45"},"J46":{"text":"J46 - BTU (termochimică) picior pe oră picior pătrat grad Fahrenheit","value":"J46"},"J47":{"text":"J47 - BTU (termochimică) pe oră","value":"J47"},"J48":{"text":"J48 - BTU (termochimică) inch pe oră picior pătrat grad Fahrenheit","value":"J48"},"J49":{"text":"J49 - BTU (termochimică) inch pe secundă picior pătrat grad Fahrenheit","value":"J49"},"J50":{"text":"J50 - BTU (termochimică) pe grad de lira Fahrenheit","value":"J50"},"J51":{"text":"J51 - BTU (termochimică) pe minut","value":"J51"},"J52":{"text":"J52 - BTU (termochimică) pe secundă","value":"J52"},"J53":{"text":"J53 - Coulomb metru pătrat per kilogram","value":"J53"},"J54":{"text":"J54 - Megabaud","value":"J54"},"J55":{"text":"J55 - Watt pe secundă","value":"J55"},"J56":{"text":"J56 - Bar pe bar","value":"J56"},"J57":{"text":"J57 - Baril (UK petrol)","value":"J57"},"J58":{"text":"J58 - Baril (UK Oil) pe minut","value":"J58"},"J59":{"text":"J59 - Baril (UK Oil) pe zi","value":"J59"},"J60":{"text":"J60 - Baril (UK petrol) pe oră","value":"J60"},"J61":{"text":"J61 - Baril (UK Oil) pe secundă","value":"J61"},"J62":{"text":"J62 - Baril (U.A. petrol) pe oră","value":"J62"},"J63":{"text":"J63 - Baril (U.A. petrol) pe secundă","value":"J63"},"J64":{"text":"J64 - Baniță (UK) pe zi","value":"J64"},"J65":{"text":"J65 - Baniță (UK) pe oră","value":"J65"},"J66":{"text":"J66 - Baniță (UK) pe minut","value":"J66"},"J67":{"text":"J67 - Baniță (UK) pe secundă","value":"J67"},"J68":{"text":"J68 - Baniță (SUA uscată) pe zi","value":"J68"},"J69":{"text":"J69 - Baniță (SUA uscată) pe oră","value":"J69"},"J70":{"text":"J70 - Bushel (US uscat) pe minut","value":"J70"},"J71":{"text":"J71 - Bushel (US uscat) pe secundă","value":"J71"},"J72":{"text":"J72 - Centinewton metru","value":"J72"},"J73":{"text":"J73 - Centipoise pe Kelvin","value":"J73"},"J74":{"text":"J74 - Centipoise pe bar","value":"J74"},"J75":{"text":"J75 - Calorie (medie)","value":"J75"},"J76":{"text":"J76 - Calorie (tabel internațional) pe gram grad Celsius","value":"J76"},"J78":{"text":"J78 - Calorie (termochimic) pe centimetru secundă grad Celsius","value":"J78"},"J79":{"text":"J79 - Calorie (termochimic) pe gram grad Celsius","value":"J79"},"J81":{"text":"J81 - Calorii (termochimice) pe minut","value":"J81"},"J82":{"text":"J82 - Calorii (termochimice) pe secundă","value":"J82"},"J83":{"text":"J83 - Clo","value":"J83"},"J84":{"text":"J84 - Centimetru pe secundă Kelvin","value":"J84"},"J85":{"text":"J85 - Centimetru pe bar secundă","value":"J85"},"J87":{"text":"J87 - Centimetru cub pe metru cub","value":"J87"},"J90":{"text":"J90 - Decimetru cub pe zi","value":"J90"},"J91":{"text":"J91 - Decimetru cub pe metru cub","value":"J91"},"J92":{"text":"J92 - Decimetru cub pe minut","value":"J92"},"J93":{"text":"J93 - Decimetru cub pe secundă","value":"J93"},"J95":{"text":"J95 - Uncie (lichid Marea Britanie) pe zi","value":"J95"},"J96":{"text":"J96 - Uncie (lichid Marea Britanie) pe oră","value":"J96"},"J97":{"text":"J97 - Uncie (lichid Marea Britanie) pe minut","value":"J97"},"J98":{"text":"J98 - Uncie (lichid Marea Britanie) pe secundă","value":"J98"},"J99":{"text":"J99 - Uncie (lichid american) pe zi","value":"J99"},"JE":{"text":"JE - Joule per Kelvin","value":"JE"},"JK":{"text":"JK - Megajoul pe kilogram","value":"JK"},"JM":{"text":"JM - Megajoul pe metru cub","value":"JM"},"JNT":{"text":"JNT - Bucăți îmbinare conductă","value":"JNT"},"JOU":{"text":"JOU - Joule","value":"JOU"},"JPS":{"text":"JPS - O suta de metri","value":"JPS"},"JWL":{"text":"JWL - Carat","value":"JWL"},"K1":{"text":"K1 - Kilowatt oră - putere activă","value":"K1"},"K10":{"text":"K10 - Uncie (lichid american) pe oră","value":"K10"},"K11":{"text":"K11 - Uncie (lichid american) pe minut","value":"K11"},"K12":{"text":"K12 - Uncie (lichid american) pe secundă","value":"K12"},"K13":{"text":"K13 - Picior pe grad Fahrenheit","value":"K13"},"K14":{"text":"K14 - Picior pe oră","value":"K14"},"K15":{"text":"K15 - Livra pas-forță pe oră","value":"K15"},"K16":{"text":"K16 - Livra pas-forță pe minut","value":"K16"},"K17":{"text":"K17 - Picior pe psi","value":"K17"},"K18":{"text":"K18 - Picior pe secundă grad Fahrenheit","value":"K18"},"K19":{"text":"K19 - Picior pe secundă psi","value":"K19"},"K2":{"text":"K2 - Amper kilovolt - putere reactivă","value":"K2"},"K20":{"text":"K20 - Picior cubic la puterea minus unu","value":"K20"},"K21":{"text":"K21 - Picior cubic pe grad Fahrenheit","value":"K21"},"K22":{"text":"K22 - Picior cubic pe zi","value":"K22"},"K23":{"text":"K23 - Picior cubic pe psi","value":"K23"},"K26":{"text":"K26 - Galon (UK) pe zi","value":"K26"},"K27":{"text":"K27 - Galon (UK) pe oră","value":"K27"},"K28":{"text":"K28 - Galon (UK) pe secundă","value":"K28"},"K3":{"text":"K3 - Kilovolt ampere reactiv ora","value":"K3"},"K30":{"text":"K30 - Galon (lichid SUA) pe secundă","value":"K30"},"K31":{"text":"K31 - Gram-forță pe centimetru pătrat","value":"K31"},"K32":{"text":"K32 - Gill (UK) pe zi","value":"K32"},"K33":{"text":"K33 - Gill (UK) pe oră","value":"K33"},"K34":{"text":"K34 - Gill (UK) pe minut","value":"K34"},"K35":{"text":"K35 - Gill (UK) pe secundă","value":"K35"},"K36":{"text":"K36 - Gill (SUA) pe zi","value":"K36"},"K37":{"text":"K37 - Gill (SUA) pe oră","value":"K37"},"K38":{"text":"K38 - Gill (SUA) pe minut","value":"K38"},"K39":{"text":"K39 - Gill (SUA) pe secundă","value":"K39"},"K40":{"text":"K40 - Accelerația standard în cădere liberă (g)","value":"K40"},"K41":{"text":"K41 - Cereale pe galon (SUA)","value":"K41"},"K42":{"text":"K42 - Cal putere (boiler)","value":"K42"},"K43":{"text":"K43 - Cal putere (electric)","value":"K43"},"K45":{"text":"K45 - Inch pe grad Fahrenheit","value":"K45"},"K46":{"text":"K46 - Inch pe psi","value":"K46"},"K47":{"text":"K47 - Inch pe secundă grad Fahrenheit","value":"K47"},"K48":{"text":"K48 - Inch pe secundă psi","value":"K48"},"K49":{"text":"K49 - Centimetru cub reciproc","value":"K49"},"K50":{"text":"K50 - Kilobaud","value":"K50"},"K51":{"text":"K51 - Kilocalorie (medie)","value":"K51"},"K52":{"text":"K52 - Kilocalorie (tabel internațional) pe oră grad Celsius","value":"K52"},"K53":{"text":"K53 - Kilocalorie (termochimic)","value":"K53"},"K54":{"text":"K54 - Kilocalorie (termochimică) pe minut","value":"K54"},"K55":{"text":"K55 - Kilocalorie (termochimică) pe secundă","value":"K55"},"K58":{"text":"K58 - Kilomol pe oră","value":"K58"},"K59":{"text":"K59 - Kilomol pe metru cub Kelvin","value":"K59"},"K6":{"text":"K6 - Kilolitrul","value":"K6"},"K60":{"text":"K60 - Kilomol pe metru cub bar","value":"K60"},"K61":{"text":"K61 - Kilomol pe minut","value":"K61"},"K62":{"text":"K62 - Litru pe litru","value":"K62"},"K63":{"text":"K63 - Litru reciproc","value":"K63"},"K64":{"text":"K64 - Livra (avoirdupois) pe grad Fahrenheit","value":"K64"},"K65":{"text":"K65 - Livra (avoirdupois) picior pătrat","value":"K65"},"K66":{"text":"K66 - Livra (avoirdupois) pe zi","value":"K66"},"K67":{"text":"K67 - Livra pe metru ora","value":"K67"},"K68":{"text":"K68 - Livra pe secundă picior","value":"K68"},"K69":{"text":"K69 - Livra (avoirdupois) per grad de picior cubic Fahrenheit","value":"K69"},"K70":{"text":"K70 - Livra (avoirdupois) per psi picior cub","value":"K70"},"K71":{"text":"K71 - Livra (avoirdupois) pe galon (UK)","value":"K71"},"K73":{"text":"K73 - Livra (avoirdupois) pe oră grad Fahrenheit","value":"K73"},"K74":{"text":"K74 - Livra (avoirdupois) pe oră psi","value":"K74"},"K75":{"text":"K75 - Livra (avoirdupois) per grad cub inch Fahrenheit","value":"K75"},"K76":{"text":"K76 - Livra (avoirdupois) per centimetru cub psi","value":"K76"},"K77":{"text":"K77 - Livra (avoirdupois) per psi","value":"K77"},"K78":{"text":"K78 - Livra (avoirdupois) pe minut","value":"K78"},"K79":{"text":"K79 - Livra (avoirdupois) pe minut grad Fahrenheit","value":"K79"},"K80":{"text":"K80 - Livra (avoirdupois) pe minut psi","value":"K80"},"K81":{"text":"K81 - Livra (avoirdupois) pe secundă","value":"K81"},"K82":{"text":"K82 - Livră (avoirdupois) pe gradul doi Fahrenheit","value":"K82"},"K83":{"text":"K83 - Livra (avoirdupois) pe secundă psi","value":"K83"},"K84":{"text":"K84 - Livra pe curte cubica","value":"K84"},"K85":{"text":"K85 - Livra-forță pe metru pătrat","value":"K85"},"K86":{"text":"K86 - Livra-forță pe grad pătrat inch Fahrenheit","value":"K86"},"K87":{"text":"K87 - PSI cubic inch pe secundă","value":"K87"},"K88":{"text":"K88 - Litru PSI pe secundă","value":"K88"},"K89":{"text":"K89 - PSI metru cub pe secundă","value":"K89"},"K90":{"text":"K90 - Picior cubic psi pe secundă","value":"K90"},"K91":{"text":"K91 - Livra-forță a doua pe metru pătrat","value":"K91"},"K92":{"text":"K92 - Livra-forță secundă pe centimetru pătrat","value":"K92"},"K93":{"text":"K93 - Psi la puterea minus unu","value":"K93"},"K94":{"text":"K94 - Quart (lichid UK) pe zi","value":"K94"},"K95":{"text":"K95 - Quart (lichid UK) pe oră","value":"K95"},"K96":{"text":"K96 - Quart (lichid UK) pe minut","value":"K96"},"K97":{"text":"K97 - Quart (lichid UK) pe secundă","value":"K97"},"K98":{"text":"K98 - Quart (lichid US) pe zi","value":"K98"},"K99":{"text":"K99 - Quart (lichid US) pe oră","value":"K99"},"KA":{"text":"KA - Disc","value":"KA"},"KAT":{"text":"KAT - Katal","value":"KAT"},"KB":{"text":"KB - Kilocaracter","value":"KB"},"KBA":{"text":"KBA - Kilobar","value":"KBA"},"KCC":{"text":"KCC - Kilogram de clorură de colină","value":"KCC"},"KDW":{"text":"KDW - Kg greutate netă scursă","value":"KDW"},"KEL":{"text":"KEL - Kelvin","value":"KEL"},"KGM":{"text":"KGM - Kilogram","value":"KGM"},"KGS":{"text":"KGS - Kilogram pe secundă","value":"KGS"},"KHY":{"text":"KHY - Kilogram de peroxid de hidrogen","value":"KHY"},"KHZ":{"text":"KHZ - Kilohertz","value":"KHZ"},"KI":{"text":"KI - Kilogram pe milimetru lățime","value":"KI"},"KIC":{"text":"KIC - Kilogram, inclusiv recipient","value":"KIC"},"KIP":{"text":"KIP - Kilogram, inclusiv ambalajul interior","value":"KIP"},"KJ":{"text":"KJ - Kilosegment","value":"KJ"},"KJO":{"text":"KJO - Kilojoule","value":"KJO"},"KL":{"text":"KL - Kilogram pe metru","value":"KL"},"KLK":{"text":"KLK - Procentul de substanta uscata lactica","value":"KLK"},"KLX":{"text":"KLX - Kilolux","value":"KLX"},"KMA":{"text":"KMA - Kilogram de metilamină","value":"KMA"},"KMH":{"text":"KMH - Kilometru pe oră","value":"KMH"},"KMK":{"text":"KMK - Kilometru pătrat","value":"KMK"},"KMQ":{"text":"KMQ - Kilogram pe metru cub","value":"KMQ"},"KMT":{"text":"KMT - Kilometru","value":"KMT"},"KNI":{"text":"KNI - Kilogram de azot","value":"KNI"},"KNM":{"text":"KNM - Kilonewton pe metru pătrat","value":"KNM"},"KNS":{"text":"KNS - Kilogram de substanță numită","value":"KNS"},"KNT":{"text":"KNT - Nod","value":"KNT"},"KO":{"text":"KO - Potasa caustica de miliechivalenta per gram de produs","value":"KO"},"KPA":{"text":"KPA - Kilopascal","value":"KPA"},"KPH":{"text":"KPH - Kilogram de hidroxid de potasiu (potasă caustică)","value":"KPH"},"KPO":{"text":"KPO - Kilogram de oxid de potasiu","value":"KPO"},"KPP":{"text":"KPP - Kilogram de pentoxid de fosfor (anhidridă fosforică)","value":"KPP"},"KR":{"text":"KR - Kiloroentgen","value":"KR"},"KSD":{"text":"KSD - Kilogram de substanță 90 % uscată","value":"KSD"},"KSH":{"text":"KSH - Kilogram de hidroxid de sodiu (sodă caustică)","value":"KSH"},"KT":{"text":"KT - Kit","value":"KT"},"KTN":{"text":"KTN - Kilotonă","value":"KTN"},"KUR":{"text":"KUR - Kilogram de uraniu","value":"KUR"},"KVA":{"text":"KVA - Kilovolt-amper","value":"KVA"},"KVR":{"text":"KVR - Kilovar","value":"KVR"},"KVT":{"text":"KVT - Kilovolt","value":"KVT"},"KW":{"text":"KW - Kilogram pe milimetru","value":"KW"},"KWH":{"text":"KWH - Kilowatt oră","value":"KWH"},"KWN":{"text":"KWN - Kilowatt oră per metru cub normalizat","value":"KWN"},"KWO":{"text":"KWO - Kilogram de trioxid de tungsten","value":"KWO"},"KWS":{"text":"KWS - Kilowatt oră pe metru cub standard","value":"KWS"},"KWT":{"text":"KWT - Kilowatt","value":"KWT"},"KX":{"text":"KX - Mililitru pe kilogram","value":"KX"},"L10":{"text":"L10 - Litru (lichid american) pe minut","value":"L10"},"L11":{"text":"L11 - Litru (lichid american) pe secundă","value":"L11"},"L12":{"text":"L12 - Metru pe secundă Kelvin","value":"L12"},"L13":{"text":"L13 - Metru pe secundă bar","value":"L13"},"L14":{"text":"L14 - Metru pătrat grad Celsius pe kilocalorie (tabel internațional)","value":"L14"},"L15":{"text":"L15 - Milipascal secundă pe Kelvin","value":"L15"},"L16":{"text":"L16 - Milipascal secundă pe bar","value":"L16"},"L17":{"text":"L17 - Miligram pe metru cub Kelvin","value":"L17"},"L18":{"text":"L18 - Miligram pe metru cub bar","value":"L18"},"L19":{"text":"L19 - Mililitru pe litru","value":"L19"},"L2":{"text":"L2 - Litru pe minut","value":"L2"},"L20":{"text":"L20 - Milimetri cubi reciproci","value":"L20"},"L21":{"text":"L21 - Milimetri cubi pe metru cub","value":"L21"},"L23":{"text":"L23 - Mol pe oră","value":"L23"},"L24":{"text":"L24 - Mol pe kilogram Kelvin","value":"L24"},"L25":{"text":"L25 - Mol pe kilogram bar","value":"L25"},"L26":{"text":"L26 - Mol pe litru Kelvin","value":"L26"},"L27":{"text":"L27 - Mol pe litru bara","value":"L27"},"L28":{"text":"L28 - Mol pe metru cub Kelvin","value":"L28"},"L29":{"text":"L29 - Mol pe metru cub bara","value":"L29"},"L30":{"text":"L30 - Mol pe minut","value":"L30"},"L31":{"text":"L31 - Miliroentgen echivalent kilocorp","value":"L31"},"L32":{"text":"L32 - Nanograme per kilogram","value":"L32"},"L33":{"text":"L33 - Uncie (avoirdupois) pe zi","value":"L33"},"L34":{"text":"L34 - Uncie (avoirdupois) pe oră","value":"L34"},"L35":{"text":"L35 - Uncie (avoirdupois) pe minut","value":"L35"},"L36":{"text":"L36 - Uncie (avoirdupois) pe secundă","value":"L36"},"L37":{"text":"L37 - Uncie (avoirdupois) per galon (UK)","value":"L37"},"L38":{"text":"L38 - Uncie (avoirdupois) pe galon (SUA)","value":"L38"},"L39":{"text":"L39 - Uncie (avoirdupois) per centimetru cub","value":"L39"},"L40":{"text":"L40 - Uncie (avoirdupois)-forță","value":"L40"},"L41":{"text":"L41 - Uncie (avoirdupois)-forță inch","value":"L41"},"L42":{"text":"L42 - Picosiemens pe metru","value":"L42"},"L43":{"text":"L43 - Peck (UK)","value":"L43"},"L44":{"text":"L44 - Peck (UK) pe zi","value":"L44"},"L45":{"text":"L45 - Peck (UK) pe oră","value":"L45"},"L46":{"text":"L46 - Peck (UK) pe minut","value":"L46"},"L47":{"text":"L47 - Peck (UK) pe secundă","value":"L47"},"L48":{"text":"L48 - Peck (SUA uscat) pe zi","value":"L48"},"L49":{"text":"L49 - Peck (SUA uscat) pe oră","value":"L49"},"L50":{"text":"L50 - Peck (US uscat) pe minut","value":"L50"},"L51":{"text":"L51 - Peck (US uscat) pe secundă","value":"L51"},"L52":{"text":"L52 - PSI pe psi","value":"L52"},"L53":{"text":"L53 - Halba (UK) pe zi","value":"L53"},"L54":{"text":"L54 - Halba (UK) pe oră","value":"L54"},"L55":{"text":"L55 - Halba (UK) pe minut","value":"L55"},"L56":{"text":"L56 - Halba (UK) pe secundă","value":"L56"},"L57":{"text":"L57 - Halba lichidă (SUA) pe zi","value":"L57"},"L58":{"text":"L58 - Halba lichidă (SUA) pe orĂ","value":"L58"},"L59":{"text":"L59 - Halba lichidă (SUA) pe minut","value":"L59"},"L60":{"text":"L60 - Halba lichidă (SUA) pe secundă","value":"L60"},"L63":{"text":"L63 - Slug pe zi","value":"L63"},"L64":{"text":"L64 - Slug pe secundă picior","value":"L64"},"L65":{"text":"L65 - Slug pe picior cub","value":"L65"},"L66":{"text":"L66 - Slug pe oră","value":"L66"},"L67":{"text":"L67 - Slug pe minut","value":"L67"},"L68":{"text":"L68 - Slug pe secundă","value":"L68"},"L69":{"text":"L69 - Tonă per Kelvin","value":"L69"},"L70":{"text":"L70 - Tonă per bar","value":"L70"},"L71":{"text":"L71 - Tonă pe zi","value":"L71"},"L72":{"text":"L72 - Tonă pe zi Kelvin","value":"L72"},"L73":{"text":"L73 - Tonă pe zi bar","value":"L73"},"L74":{"text":"L74 - Tonă pe oră Kelvin","value":"L74"},"L75":{"text":"L75 - Tonă pe oră bar","value":"L75"},"L76":{"text":"L76 - Tonă pe metru cub Kelvin","value":"L76"},"L77":{"text":"L77 - Tonă pe metru cub bar","value":"L77"},"L78":{"text":"L78 - Tonă pe minut","value":"L78"},"L79":{"text":"L79 - Tonă pe minut Kelvin","value":"L79"},"L80":{"text":"L80 - Tonă pe minut bar","value":"L80"},"L81":{"text":"L81 - Tonă pe secundă","value":"L81"},"L82":{"text":"L82 - Tonă pe secundă Kelvin","value":"L82"},"L83":{"text":"L83 - Tonă pe secundă bar","value":"L83"},"L84":{"text":"L84 - Ton (transport maritim în Marea Britanie)","value":"L84"},"L85":{"text":"L85 - O tona lunga pe zi","value":"L85"},"L86":{"text":"L86 - Ton (transport maritim american)","value":"L86"},"L87":{"text":"L87 - Ton scurt pe grad Fahrenheit","value":"L87"},"L88":{"text":"L88 - O tona scurta pe zi","value":"L88"},"L89":{"text":"L89 - Ton scurt pe oră grad Fahrenheit","value":"L89"},"L90":{"text":"L90 - O tona scurta pe oră psi","value":"L90"},"L91":{"text":"L91 - O tona scurta per psi","value":"L91"},"L92":{"text":"L92 - Tonă (Marea Britanie lunga) per yard cubic","value":"L92"},"L93":{"text":"L93 - Tonă (SUA) pe yard cubic","value":"L93"},"L94":{"text":"L94 - Forta tona (Scurta în SUA)","value":"L94"},"L95":{"text":"L95 - An comun","value":"L95"},"L96":{"text":"L96 - An sideral","value":"L96"},"L98":{"text":"L98 - Yard pe grad Fahrenheit","value":"L98"},"L99":{"text":"L99 - Yard per psi","value":"L99"},"LA":{"text":"LA - Livră pe centimetru cub","value":"LA"},"LAC":{"text":"LAC - Procentajul excesului de lactoză","value":"LAC"},"LBR":{"text":"LBR - Livră","value":"LBR"},"LBT":{"text":"LBT - Troy pound (SUA)","value":"LBT"},"LD":{"text":"LD - Litru pe zi","value":"LD"},"LEF":{"text":"LEF - Frunză","value":"LEF"},"LF":{"text":"LF - Picior liniar","value":"LF"},"LH":{"text":"LH - Ora travaliului","value":"LH"},"LK":{"text":"LK - Link","value":"LK"},"LM":{"text":"LM - Metru liniar","value":"LM"},"LN":{"text":"LN - Lungime","value":"LN"},"LO":{"text":"LO - Lot [unitatea de achiziții]","value":"LO"},"LP":{"text":"LP - Livră lichidă","value":"LP"},"LPA":{"text":"LPA - Litru de alcool pur","value":"LPA"},"LR":{"text":"LR - Strat","value":"LR"},"LS":{"text":"LS - Sumă forfetară","value":"LS"},"LTN":{"text":"LTN - Tonă (Marea Britanie) sau tonă lungă (SUA)","value":"LTN"},"LTR":{"text":"LTR - Litru","value":"LTR"},"LUB":{"text":"LUB - Tonă metrică, ulei lubrifiant","value":"LUB"},"LUM":{"text":"LUM - Lumen","value":"LUM"},"LUX":{"text":"LUX - Lux","value":"LUX"},"LY":{"text":"LY - Yard liniar","value":"LY"},"M1":{"text":"M1 - Miligram pe litru","value":"M1"},"M10":{"text":"M10 - Yard cubic reciproc","value":"M10"},"M11":{"text":"M11 - Yard cubic pe grad Fahrenheit","value":"M11"},"M12":{"text":"M12 - Yard cubic pe zi","value":"M12"},"M13":{"text":"M13 - Yard cubic pe oră","value":"M13"},"M14":{"text":"M14 - Yard cubic per psi","value":"M14"},"M15":{"text":"M15 - Yard cubic pe minut","value":"M15"},"M16":{"text":"M16 - Yard cubic pe secundă","value":"M16"},"M17":{"text":"M17 - Kilohertz metru","value":"M17"},"M18":{"text":"M18 - Gigahertz metru","value":"M18"},"M19":{"text":"M19 - Beaufort","value":"M19"},"M20":{"text":"M20 - Reciproc megaKelvin sau megaKelvin la puterea minus unu","value":"M20"},"M21":{"text":"M21 - Kilovolt reciproc-amper oră reciprocă","value":"M21"},"M22":{"text":"M22 - Mililitru pe minut de centimetru pătrat","value":"M22"},"M23":{"text":"M23 - Newton pe centimetru","value":"M23"},"M24":{"text":"M24 - Ohm kilometru","value":"M24"},"M25":{"text":"M25 - Procent pe grad Celsius","value":"M25"},"M26":{"text":"M26 - Gigaohm pe metru","value":"M26"},"M27":{"text":"M27 - Metru megahertz","value":"M27"},"M29":{"text":"M29 - Kilogram pe kilogram","value":"M29"},"M30":{"text":"M30 - Volt reciproc secundă amper reciproc","value":"M30"},"M31":{"text":"M31 - Kilogram pe kilometru","value":"M31"},"M32":{"text":"M32 - Pascal secundă pe litru","value":"M32"},"M33":{"text":"M33 - Millimol per litru","value":"M33"},"M34":{"text":"M34 - Newton metru pe metru pătrat","value":"M34"},"M35":{"text":"M35 - Milivolt - amper","value":"M35"},"M36":{"text":"M36 - Lună de 30 zile","value":"M36"},"M37":{"text":"M37 - Actual/360","value":"M37"},"M38":{"text":"M38 - Kilometru pe secundă la pătrat","value":"M38"},"M39":{"text":"M39 - Centimetru pe secundă la pătrat","value":"M39"},"M4":{"text":"M4 - Valoare monetară","value":"M4"},"M40":{"text":"M40 - Yard pe secundă la pătrat","value":"M40"},"M41":{"text":"M41 - Milimetri pe secundă la pătrat","value":"M41"},"M42":{"text":"M42 - Milă (milometru statuat) pe secundă la pătrat","value":"M42"},"M43":{"text":"M43 - Mil","value":"M43"},"M44":{"text":"M44 - Rotație","value":"M44"},"M45":{"text":"M45 - Grad [unitate de unghi] pe secundă la pătrat","value":"M45"},"M46":{"text":"M46 - Rotație pe minut","value":"M46"},"M47":{"text":"M47 - Mil circulară","value":"M47"},"M48":{"text":"M48 - Milă pătrată (bazată pe piciorul studiului american)","value":"M48"},"M49":{"text":"M49 - Lanț (bazat pe picior releveu SUA)","value":"M49"},"M5":{"text":"M5 - Microcurie","value":"M5"},"M50":{"text":"M50 - Furlong","value":"M50"},"M51":{"text":"M51 - Picior (releveu SUA)","value":"M51"},"M52":{"text":"M52 - Mile (bazat pe piciorul de sondaj american)","value":"M52"},"M53":{"text":"M53 - Metru pe pascal","value":"M53"},"M55":{"text":"M55 - Metru pe radiant","value":"M55"},"M56":{"text":"M56 - Se agita","value":"M56"},"M57":{"text":"M57 - Milă pe minut","value":"M57"},"M58":{"text":"M58 - Milă pe secundă","value":"M58"},"M59":{"text":"M59 - Metru pe secundă pascal","value":"M59"},"M60":{"text":"M60 - Metru pe oră","value":"M60"},"M61":{"text":"M61 - Inch pe an","value":"M61"},"M62":{"text":"M62 - Kilometru pe secundă","value":"M62"},"M63":{"text":"M63 - Inch pe minut","value":"M63"},"M64":{"text":"M64 - Yard pe secundă","value":"M64"},"M65":{"text":"M65 - Yard pe minut","value":"M65"},"M66":{"text":"M66 - Yard pe oră","value":"M66"},"M67":{"text":"M67 - Acre-picior (bazat pe piciorul de sondaj american)","value":"M67"},"M68":{"text":"M68 - Cordonul (128 ft3)","value":"M68"},"M69":{"text":"M69 - Mile cub (statutul Marii Britanii)","value":"M69"},"M7":{"text":"M7 - Micro-inch","value":"M7"},"M70":{"text":"M70 - Ton, înregistrare","value":"M70"},"M71":{"text":"M71 - Metru cub per pascal","value":"M71"},"M72":{"text":"M72 - Bel","value":"M72"},"M73":{"text":"M73 - Kilogram pe metru cub pascal","value":"M73"},"M74":{"text":"M74 - Kilogram per pascal","value":"M74"},"M75":{"text":"M75 - Kilometru-forță","value":"M75"},"M76":{"text":"M76 - Poundal","value":"M76"},"M77":{"text":"M77 - Kilogram metru pe secundă la pătrat","value":"M77"},"M78":{"text":"M78 - Iaz","value":"M78"},"M79":{"text":"M79 - Picior pătrat pe oră","value":"M79"},"M80":{"text":"M80 - Stokes per pascal","value":"M80"},"M81":{"text":"M81 - Centimetru pătrat pe secundă","value":"M81"},"M82":{"text":"M82 - Metru pătrat pe secundă pascal","value":"M82"},"M83":{"text":"M83 - Denier","value":"M83"},"M84":{"text":"M84 - Livră pe metru","value":"M84"},"M85":{"text":"M85 - Ton, test de","value":"M85"},"M86":{"text":"M86 - Pfund","value":"M86"},"M87":{"text":"M87 - Kilogram pe secundă pascal","value":"M87"},"M88":{"text":"M88 - Tonă pe lună","value":"M88"},"M89":{"text":"M89 - Tonă pe an","value":"M89"},"M9":{"text":"M9 - Milioane Btu per 1000 picior cub","value":"M9"},"M90":{"text":"M90 - Kilometru pe oră","value":"M90"},"M91":{"text":"M91 - Livră pe kilogram","value":"M91"},"M92":{"text":"M92 - Livră-forță picior","value":"M92"},"M93":{"text":"M93 - Newton metru pe radian","value":"M93"},"M94":{"text":"M94 - Kilogram de metru","value":"M94"},"M95":{"text":"M95 - Piciorul poundal","value":"M95"},"M96":{"text":"M96 - Livră inch","value":"M96"},"M97":{"text":"M97 - Dyne metru","value":"M97"},"M98":{"text":"M98 - Kilogram centimetru pe secundă","value":"M98"},"M99":{"text":"M99 - Gram centimetru pe secundă","value":"M99"},"MAH":{"text":"MAH - Megavolt amper reactiv oră","value":"MAH"},"MAL":{"text":"MAL - Megalitre","value":"MAL"},"MAM":{"text":"MAM - Megametre","value":"MAM"},"MAR":{"text":"MAR - Megavar","value":"MAR"},"MAW":{"text":"MAW - Megawatt","value":"MAW"},"MBE":{"text":"MBE - O mie echivalent caramida standard","value":"MBE"},"MBF":{"text":"MBF - O mie de picioare la bord","value":"MBF"},"MBR":{"text":"MBR - Milibar","value":"MBR"},"MC":{"text":"MC - Microgram","value":"MC"},"MCU":{"text":"MCU - Milicurie","value":"MCU"},"MD":{"text":"MD - Tonă metrică uscată de aer","value":"MD"},"MGM":{"text":"MGM - Miligram","value":"MGM"},"MHZ":{"text":"MHZ - Megahertz","value":"MHZ"},"MIK":{"text":"MIK - Milă pătrată (milometru statuat)","value":"MIK"},"MIL":{"text":"MIL - Mii de persoane","value":"MIL"},"MIN":{"text":"MIN - Minut [timp]","value":"MIN"},"MIO":{"text":"MIO - Un milion","value":"MIO"},"MIU":{"text":"MIU - Milioane de unitati internaționale","value":"MIU"},"MLD":{"text":"MLD - Biliard","value":"MLD"},"MLT":{"text":"MLT - Mililitru","value":"MLT"},"MMK":{"text":"MMK - Milimetru pătrat","value":"MMK"},"MMQ":{"text":"MMQ - Milimetri cubi","value":"MMQ"},"MMT":{"text":"MMT - Milimetri","value":"MMT"},"MND":{"text":"MND - Kilogram, greutate uscată","value":"MND"},"MON":{"text":"MON - Lună","value":"MON"},"MPA":{"text":"MPA - Megapascal","value":"MPA"},"MQH":{"text":"MQH - Metru cub pe oră","value":"MQH"},"MQS":{"text":"MQS - Metru cub pe secundă","value":"MQS"},"MSK":{"text":"MSK - Metru pe secundă la pătrat","value":"MSK"},"MTK":{"text":"MTK - Metru pătrat","value":"MTK"},"MTQ":{"text":"MTQ - Metru cub","value":"MTQ"},"MTR":{"text":"MTR - Metru","value":"MTR"},"MTS":{"text":"MTS - Metru pe secundă","value":"MTS"},"MVA":{"text":"MVA - Megavolt amper","value":"MVA"},"MWH":{"text":"MWH - Megawatt oră (1000 kW.h)","value":"MWH"},"N1":{"text":"N1 - Caloria stiloului injector (pen)","value":"N1"},"N10":{"text":"N10 - Livră picior pe secundă","value":"N10"},"N11":{"text":"N11 - Livră inch pe secundă","value":"N11"},"N12":{"text":"N12 - Pferdestaerke","value":"N12"},"N13":{"text":"N13 - Centimetru de mercur (0 grd C)","value":"N13"},"N14":{"text":"N14 - Centimetru de apa (4 grd C)","value":"N14"},"N15":{"text":"N15 - Picior de apa (39,2 ›F)","value":"N15"},"N16":{"text":"N16 - Centimetru de mercur (32 grd F)","value":"N16"},"N17":{"text":"N17 - Centimetru de mercur (60 grd F)","value":"N17"},"N18":{"text":"N18 - Inci de apă (39,2 ›F)","value":"N18"},"N19":{"text":"N19 - Inci de apă (60 ›F)","value":"N19"},"N20":{"text":"N20 - Kip pe inch pătrat","value":"N20"},"N21":{"text":"N21 - Poundal pe metru pătrat","value":"N21"},"N22":{"text":"N22 - Uncie (avoirdupois) pe centimetru pătrat","value":"N22"},"N23":{"text":"N23 - Metru convențional de apă","value":"N23"},"N24":{"text":"N24 - Gram pe milimetru pătrat","value":"N24"},"N25":{"text":"N25 - Livră pe metru pătrat","value":"N25"},"N26":{"text":"N26 - Poundal pe centimetru pătrat","value":"N26"},"N27":{"text":"N27 - Picior la a patra putere","value":"N27"},"N28":{"text":"N28 - Decimetru cub per kilogram","value":"N28"},"N29":{"text":"N29 - Picior cub pe kilogram","value":"N29"},"N3":{"text":"N3 - Punct de imprimare","value":"N3"},"N30":{"text":"N30 - Centimetru cub per kilogram","value":"N30"},"N31":{"text":"N31 - Kilonewton pe metru","value":"N31"},"N32":{"text":"N32 - Poundal pe inch","value":"N32"},"N33":{"text":"N33 - Livră-forță pe metru","value":"N33"},"N34":{"text":"N34 - Poundal-sedundă pe picior pătrat","value":"N34"},"N35":{"text":"N35 - Poise per pascal","value":"N35"},"N36":{"text":"N36 - Newton secundă pe metru pătrat","value":"N36"},"N37":{"text":"N37 - Kilogram pe metru de secundă","value":"N37"},"N38":{"text":"N38 - Kilogram pe metru minut","value":"N38"},"N39":{"text":"N39 - Kilogram pe metru de zi","value":"N39"},"N40":{"text":"N40 - Kilogram pe metru oră","value":"N40"},"N41":{"text":"N41 - Gram pe centimetru secundă","value":"N41"},"N42":{"text":"N42 - Poundal-secundă pe țol pătrat","value":"N42"},"N43":{"text":"N43 - Livră pe minut picior","value":"N43"},"N44":{"text":"N44 - Livră pe zi picior","value":"N44"},"N45":{"text":"N45 - Metru cub pe secundă pascal","value":"N45"},"N46":{"text":"N46 - Livră picior","value":"N46"},"N47":{"text":"N47 - Inch poundal","value":"N47"},"N48":{"text":"N48 - Watt pe centimetru pătrat","value":"N48"},"N49":{"text":"N49 - Watt pe inch pătrat","value":"N49"},"N50":{"text":"N50 - BTU (masură internațională) pe metru pătrat ora","value":"N50"},"N51":{"text":"N51 - BTU (termochimică) pe metru pătrat ora","value":"N51"},"N52":{"text":"N52 - BTU (termochimică) pe minut de metru pătrat","value":"N52"},"N53":{"text":"N53 - BTU (masură internațională) pe secundă metru pătrat","value":"N53"},"N54":{"text":"N54 - BTU (termochimică) pe secundă metru pătrat","value":"N54"},"N55":{"text":"N55 - BTU (masa internaționala) pe secundă pătrată","value":"N55"},"N56":{"text":"N56 - Calorie (termochimic) pe centimetru pătrat minut","value":"N56"},"N57":{"text":"N57 - Calorie (termochimic) pe centimetru pătrat secundă","value":"N57"},"N58":{"text":"N58 - BTU (masură internațională) pe picior cub","value":"N58"},"N59":{"text":"N59 - BTU (termochimică) pe picior cub","value":"N59"},"N60":{"text":"N60 - BTU (tabel internațional) pe grad Fahrenheit","value":"N60"},"N61":{"text":"N61 - BTU (termochimică) pe grad Fahrenheit","value":"N61"},"N62":{"text":"N62 - BTU (tabel internațional) pe grad Rankine","value":"N62"},"N63":{"text":"N63 - BTU (termochimică) pe grad Rankine","value":"N63"},"N64":{"text":"N64 - BTU (termochimică) pe lira Rankine grad","value":"N64"},"N65":{"text":"N65 - Kilocalorie (tabel internațional) pe gram Kelvin","value":"N65"},"N66":{"text":"N66 - BTU (39 grd F)","value":"N66"},"N67":{"text":"N67 - BTU (59 grd F)","value":"N67"},"N68":{"text":"N68 - BTU (60 grd F)","value":"N68"},"N69":{"text":"N69 - Calorii (20 grdC)","value":"N69"},"N70":{"text":"N70 - Quad (1015 BtuIT)","value":"N70"},"N71":{"text":"N71 - Term (CE)","value":"N71"},"N72":{"text":"N72 - Therm (SUA)","value":"N72"},"N73":{"text":"N73 - BTU (termochimică) per kilogram","value":"N73"},"N74":{"text":"N74 - BTU (masură internațională) pe oră grad de metru pătrat Fahrenheit","value":"N74"},"N75":{"text":"N75 - BTU (termochimică) pe oră grad de picior pătrat Fahrenheit","value":"N75"},"N76":{"text":"N76 - BTU (masură internațională) pe secundă grad de picior pătrat Fahrenheit","value":"N76"},"N77":{"text":"N77 - BTU (termochimică) pe secundă grad de picior pătrat Fahrenheit","value":"N77"},"N78":{"text":"N78 - Kilowatt pe metru pătrat Kelvin","value":"N78"},"N79":{"text":"N79 - Kelvin per pascal","value":"N79"},"N80":{"text":"N80 - Watt pe metru grad Celsius","value":"N80"},"N81":{"text":"N81 - Kilowatt pe metru Kelvin","value":"N81"},"N82":{"text":"N82 - Kilowatt pe metru grad Celsius","value":"N82"},"N83":{"text":"N83 - Metru pe grad celcius metru","value":"N83"},"N84":{"text":"N84 - Grad Fahrenheit oră per unitate termică britanică (tabel internațional)","value":"N84"},"N85":{"text":"N85 - Grad Fahrenheit oră per unitate termică britanică (termochimic)","value":"N85"},"N86":{"text":"N86 - Grad Fahrenheit secundă pe unitate termică britanică (tabel internațional)","value":"N86"},"N87":{"text":"N87 - Grad Fahrenheit secundă pe unitate termică britanică (termochimic)","value":"N87"},"N88":{"text":"N88 - Grad Fahrenheit oră metru pătrat per unitate termică britanică (masa internaționala) inch","value":"N88"},"N89":{"text":"N89 - Grad Fahrenheit oră metru pătrat per unitate termică britanică (termochimic) inch","value":"N89"},"N90":{"text":"N90 - Kilofarad","value":"N90"},"N91":{"text":"N91 - Joule reciproce","value":"N91"},"N92":{"text":"N92 - Picosiemens","value":"N92"},"N93":{"text":"N93 - Amperi per pascal","value":"N93"},"N94":{"text":"N94 - Franklin","value":"N94"},"N95":{"text":"N95 - Amper minut","value":"N95"},"N96":{"text":"N96 - Biot","value":"N96"},"N97":{"text":"N97 - Gilbert","value":"N97"},"N98":{"text":"N98 - Volt per pascal","value":"N98"},"N99":{"text":"N99 - Picovolt","value":"N99"},"NA":{"text":"NA - Miligram pe kilogram","value":"NA"},"NAR":{"text":"NAR - Număr de articole","value":"NAR"},"NCL":{"text":"NCL - Număr de celule","value":"NCL"},"NEW":{"text":"NEW - Newton","value":"NEW"},"NF":{"text":"NF - Mesaj","value":"NF"},"NIL":{"text":"NIL - Nul","value":"NIL"},"NIU":{"text":"NIU - Număr de unități internaționale","value":"NIU"},"NL":{"text":"NL - Sarcina","value":"NL"},"NM3":{"text":"NM3 - Metru cub normalizat","value":"NM3"},"NMI":{"text":"NMI - Milă marină","value":"NMI"},"NMP":{"text":"NMP - Număr de ambalaje","value":"NMP"},"NPT":{"text":"NPT - Număr de părți","value":"NPT"},"NT":{"text":"NT - Tonă netă","value":"NT"},"NU":{"text":"NU - Newton metru","value":"NU"},"NX":{"text":"NX - Parte la o mie","value":"NX"},"OA":{"text":"OA - Panou","value":"OA"},"ODE":{"text":"ODE - Echivalent ODS","value":"ODE"},"ODG":{"text":"ODG - Gram ODS","value":"ODG"},"ODK":{"text":"ODK - Kilogram ODS","value":"ODK"},"ODM":{"text":"ODM - Miligram ODS","value":"ODM"},"OHM":{"text":"OHM - Ohm","value":"OHM"},"ON":{"text":"ON - Uncie pe metru pătrat","value":"ON"},"ONZ":{"text":"ONZ - Uncie (avoirdupois)","value":"ONZ"},"OPM":{"text":"OPM - Oscilatii pe minut","value":"OPM"},"OT":{"text":"OT - Ore suplimentare ora","value":"OT"},"OZA":{"text":"OZA - Uncie de lichid (SUA)","value":"OZA"},"OZI":{"text":"OZI - Uncie de lichid (UK)","value":"OZI"},"P1":{"text":"P1 - Procent","value":"P1"},"P10":{"text":"P10 - Coulomb pe metru","value":"P10"},"P11":{"text":"P11 - Kiloweber","value":"P11"},"P12":{"text":"P12 - Gama","value":"P12"},"P13":{"text":"P13 - Kilotesla","value":"P13"},"P14":{"text":"P14 - Joule pe secundă","value":"P14"},"P15":{"text":"P15 - Joule pe minut","value":"P15"},"P16":{"text":"P16 - Joule pe oră","value":"P16"},"P17":{"text":"P17 - Joule pe zi","value":"P17"},"P18":{"text":"P18 - Kilojoul pe secundă","value":"P18"},"P19":{"text":"P19 - Kilojoul pe minut","value":"P19"},"P2":{"text":"P2 - Livră pe picior","value":"P2"},"P20":{"text":"P20 - Kilojoul pe oră","value":"P20"},"P21":{"text":"P21 - Kilojoul pe zi","value":"P21"},"P22":{"text":"P22 - Nanoohm","value":"P22"},"P23":{"text":"P23 - Ohm circular-mil pe picior","value":"P23"},"P24":{"text":"P24 - Kilohenry","value":"P24"},"P25":{"text":"P25 - Lumen pe metru pătrat","value":"P25"},"P26":{"text":"P26 - ?Phot? ? ?Phot?","value":"P26"},"P27":{"text":"P27 - Licoare pentru picioare","value":"P27"},"P28":{"text":"P28 - Candelă pe centimetru pătrat","value":"P28"},"P29":{"text":"P29 - Footlambert","value":"P29"},"P30":{"text":"P30 - Lambert","value":"P30"},"P31":{"text":"P31 - Stilb","value":"P31"},"P32":{"text":"P32 - Candelă pe metru pătrat","value":"P32"},"P33":{"text":"P33 - Kilocandela","value":"P33"},"P34":{"text":"P34 - Millicandela","value":"P34"},"P35":{"text":"P35 - Hefner-Kerze","value":"P35"},"P36":{"text":"P36 - Candelă internațională","value":"P36"},"P37":{"text":"P37 - BTU (masură internațională) pe metru pătrat","value":"P37"},"P38":{"text":"P38 - BTU (termochimică) pe metru pătrat","value":"P38"},"P39":{"text":"P39 - Calorii (termochimice) pe centimetru pătrat","value":"P39"},"P40":{"text":"P40 - Langley","value":"P40"},"P41":{"text":"P41 - Decadă (logaritmică)","value":"P41"},"P42":{"text":"P42 - Pascal la pătrat secundă","value":"P42"},"P43":{"text":"P43 - Bel pe metru","value":"P43"},"P44":{"text":"P44 - Livră mol","value":"P44"},"P45":{"text":"P45 - Livră mol pe secundă","value":"P45"},"P46":{"text":"P46 - Livră mol pe minut","value":"P46"},"P47":{"text":"P47 - Kilomol pe kilogram","value":"P47"},"P48":{"text":"P48 - Livră mol pe kilogram","value":"P48"},"P49":{"text":"P49 - Newton metru pătrat pe amperi","value":"P49"},"P5":{"text":"P5 - Cinci pachete","value":"P5"},"P50":{"text":"P50 - Weber metru","value":"P50"},"P51":{"text":"P51 - Mol pe kilogram pascal","value":"P51"},"P52":{"text":"P52 - Mol pe metru cub pascal","value":"P52"},"P53":{"text":"P53 - Pol unitate de unitate","value":"P53"},"P54":{"text":"P54 - Milligray pe secundă","value":"P54"},"P55":{"text":"P55 - Micrograie pe secundă","value":"P55"},"P56":{"text":"P56 - Nanogray pe secundă","value":"P56"},"P57":{"text":"P57 - Gri pe minut","value":"P57"},"P58":{"text":"P58 - Milligray pe minut","value":"P58"},"P59":{"text":"P59 - Micrograie pe minut","value":"P59"},"P60":{"text":"P60 - Nanogray pe minut","value":"P60"},"P61":{"text":"P61 - Gri pe oră","value":"P61"},"P62":{"text":"P62 - Milligray pe oră","value":"P62"},"P63":{"text":"P63 - Micrograie pe oră","value":"P63"},"P64":{"text":"P64 - Nanogray pe oră","value":"P64"},"P65":{"text":"P65 - Sievert pe secundă","value":"P65"},"P66":{"text":"P66 - Milisievert pe secundă","value":"P66"},"P67":{"text":"P67 - Microsievert pe secundă","value":"P67"},"P68":{"text":"P68 - Nanosievert pe secundă","value":"P68"},"P69":{"text":"P69 - REM pe secundă","value":"P69"},"P70":{"text":"P70 - Sievert pe oră","value":"P70"},"P71":{"text":"P71 - Milisievert pe oră","value":"P71"},"P72":{"text":"P72 - Microsievert pe oră","value":"P72"},"P73":{"text":"P73 - Nanosievert pe oră","value":"P73"},"P74":{"text":"P74 - Sievert pe minut","value":"P74"},"P75":{"text":"P75 - Milisievert pe minut","value":"P75"},"P76":{"text":"P76 - Microsievert pe minut","value":"P76"},"P77":{"text":"P77 - Nanosievert pe minut","value":"P77"},"P78":{"text":"P78 - Centimetru pătrat reciproc","value":"P78"},"P79":{"text":"P79 - Patrat Pascal metru per kilogram","value":"P79"},"P80":{"text":"P80 - Milipascal pe metru","value":"P80"},"P81":{"text":"P81 - Kilopascal pe metru","value":"P81"},"P82":{"text":"P82 - Hectopascal per metru","value":"P82"},"P83":{"text":"P83 - Atmosferă standard pe metru","value":"P83"},"P84":{"text":"P84 - Atmosferă tehnică pe metru","value":"P84"},"P85":{"text":"P85 - Torr pe metru","value":"P85"},"P86":{"text":"P86 - PSI pe inch","value":"P86"},"P87":{"text":"P87 - Metru cub pe secundă metru pătrat","value":"P87"},"P88":{"text":"P88 - Rhe","value":"P88"},"P89":{"text":"P89 - Livră-forță picior pe inch","value":"P89"},"P90":{"text":"P90 - Livră-forță inch pe inch","value":"P90"},"P91":{"text":"P91 - Perm (0 ›C)","value":"P91"},"P92":{"text":"P92 - Perm (23 ›C)","value":"P92"},"P93":{"text":"P93 - Byte pe secundă","value":"P93"},"P94":{"text":"P94 - Kilobyte pe secundă","value":"P94"},"P95":{"text":"P95 - Megabyte pe secundă","value":"P95"},"P96":{"text":"P96 - Volt reciproc","value":"P96"},"P97":{"text":"P97 - Radian reciproc","value":"P97"},"P98":{"text":"P98 - Pascal la suma de putere a numerelor stoichiometrice","value":"P98"},"P99":{"text":"P99 - Mol pe metru de cubiv la suma de putere a numerelor stoechiometrice","value":"P99"},"PAL":{"text":"PAL - Pascal","value":"PAL"},"PD":{"text":"PD - Pad","value":"PD"},"PFL":{"text":"PFL - Litru de proba","value":"PFL"},"PGL":{"text":"PGL - Galon de probă","value":"PGL"},"PI":{"text":"PI - Pas","value":"PI"},"PLA":{"text":"PLA - Grad Plato","value":"PLA"},"PO":{"text":"PO - Livră pe centimetru de lungime","value":"PO"},"PQ":{"text":"PQ - Pagina pe inch","value":"PQ"},"PR":{"text":"PR - Pereche","value":"PR"},"PS":{"text":"PS - Livră-forță pe centimetru pătrat","value":"PS"},"PTD":{"text":"PTD - Halba uscată (SUA)","value":"PTD"},"PTI":{"text":"PTI - Halba (UK)","value":"PTI"},"PTL":{"text":"PTL - Halba lichidă (SUA)","value":"PTL"},"PTN":{"text":"PTN - Porțiune","value":"PTN"},"Q10":{"text":"Q10 - Joule per tesla","value":"Q10"},"Q11":{"text":"Q11 - Erlang","value":"Q11"},"Q12":{"text":"Q12 - Octet","value":"Q12"},"Q13":{"text":"Q13 - Octet pe secundă","value":"Q13"},"Q14":{"text":"Q14 - Shannon","value":"Q14"},"Q15":{"text":"Q15 - Hartley","value":"Q15"},"Q16":{"text":"Q16 - Unitate naturală de informații","value":"Q16"},"Q17":{"text":"Q17 - Shannon pe secundă","value":"Q17"},"Q18":{"text":"Q18 - Hartley pe secundă","value":"Q18"},"Q19":{"text":"Q19 - Unitate naturala de informatii pe secundă","value":"Q19"},"Q20":{"text":"Q20 - Secundă pe kilogram","value":"Q20"},"Q21":{"text":"Q21 - Metru pătrat Watt","value":"Q21"},"Q22":{"text":"Q22 - Secundă pe radian metru cub","value":"Q22"},"Q23":{"text":"Q23 - Weber la puterea minus unu","value":"Q23"},"Q24":{"text":"Q24 - Centimetru reciproc","value":"Q24"},"Q25":{"text":"Q25 - Dioptru","value":"Q25"},"Q26":{"text":"Q26 - Una pe una","value":"Q26"},"Q27":{"text":"Q27 - Newton metru pe metru","value":"Q27"},"Q28":{"text":"Q28 - Kilogram pe metru pătrat pascal secundă","value":"Q28"},"Q29":{"text":"Q29 - Microgram per hectograma","value":"Q29"},"Q30":{"text":"Q30 - PH (potential de hidrogen)","value":"Q30"},"Q31":{"text":"Q31 - Kilojoul pe gram","value":"Q31"},"Q32":{"text":"Q32 - Femtolitre","value":"Q32"},"Q33":{"text":"Q33 - Picolitre","value":"Q33"},"Q34":{"text":"Q34 - Nanolitrul","value":"Q34"},"Q35":{"text":"Q35 - Megawati pe minut","value":"Q35"},"Q36":{"text":"Q36 - Metru pătrat pe metru cub","value":"Q36"},"Q37":{"text":"Q37 - Metru cub standard pe zi","value":"Q37"},"Q38":{"text":"Q38 - Metru cub standard pe oră","value":"Q38"},"Q39":{"text":"Q39 - Metru cub normalizat pe zi","value":"Q39"},"Q40":{"text":"Q40 - Metru cub normalizat pe oră","value":"Q40"},"Q41":{"text":"Q41 - Joule per metru cub normalizat","value":"Q41"},"Q42":{"text":"Q42 - Joule pe metru cub standard","value":"Q42"},"Q3":{"text":"Q3 - Masă","value":"Q3"},"QA":{"text":"QA - Pagina-facsimil","value":"QA"},"QAN":{"text":"QAN - Trimestru (de un an)","value":"QAN"},"QB":{"text":"QB - Pagina-copie pe suport de hârtie","value":"QB"},"QR":{"text":"QR - Quire","value":"QR"},"QTD":{"text":"QTD - Litru uscat (SUA)","value":"QTD"},"QTI":{"text":"QTI - Quart (UK)","value":"QTI"},"QTL":{"text":"QTL - Litru lichid (SUA)","value":"QTL"},"QTR":{"text":"QTR - Trimestru (Regatul Unit)","value":"QTR"},"R1":{"text":"R1 - Pica","value":"R1"},"R9":{"text":"R9 - Mii de metri cubi","value":"R9"},"RH":{"text":"RH - Ora de functionare sau de functionare","value":"RH"},"RM":{"text":"RM - Ream","value":"RM"},"ROM":{"text":"ROM - Cameră","value":"ROM"},"RP":{"text":"RP - Livră pe ream","value":"RP"},"RPM":{"text":"RPM - Rotații pe minut","value":"RPM"},"RPS":{"text":"RPS - Rotații pe secundă","value":"RPS"},"RT":{"text":"RT - Venituri de o mila","value":"RT"},"S3":{"text":"S3 - Picior pătrat pe secundă","value":"S3"},"S4":{"text":"S4 - Metru pătrat pe secundă","value":"S4"},"SAN":{"text":"SAN - Jumatate de an (6 luni)","value":"SAN"},"SCO":{"text":"SCO - Punctaj","value":"SCO"},"SCR":{"text":"SCR - Scrupula","value":"SCR"},"SEC":{"text":"SEC - Secundă [unitate de timp]","value":"SEC"},"SET":{"text":"SET - Set","value":"SET"},"SG":{"text":"SG - Segment","value":"SG"},"SIE":{"text":"SIE - Siemens","value":"SIE"},"SM3":{"text":"SM3 - Metru cub standard","value":"SM3"},"SMI":{"text":"SMI - Mile (milometru statuat)","value":"SMI"},"SQ":{"text":"SQ - Patrat","value":"SQ"},"SQR":{"text":"SQR - Patrat, acoperisuri","value":"SQR"},"SR":{"text":"SR - Benzi","value":"SR"},"STC":{"text":"STC - Stick","value":"STC"},"STI":{"text":"STI - Stone (UK)","value":"STI"},"STK":{"text":"STK - Stick, tigara","value":"STK"},"STL":{"text":"STL - Litru standard (la 15 grd C)","value":"STL"},"STN":{"text":"STN - Tonă (SUA) sau tona scurtă (UK/SUA)","value":"STN"},"STW":{"text":"STW - Paie","value":"STW"},"SW":{"text":"SW - Skein","value":"SW"},"SX":{"text":"SX - Transport","value":"SX"},"SYR":{"text":"SYR - Seringa","value":"SYR"},"T0":{"text":"T0 - Linie de telecomunicații în exploatare","value":"T0"},"T3":{"text":"T3 - O mie de bucăți","value":"T3"},"TAH":{"text":"TAH - Kiloampere oră (mii de amper ora)","value":"TAH"},"TAN":{"text":"TAN - Număr total de acid","value":"TAN"},"TI":{"text":"TI - O mie de centimetri pătrați","value":"TI"},"TIC":{"text":"TIC - Tonă metrică, inclusiv recipient","value":"TIC"},"TIP":{"text":"TIP - Tonă metrică, inclusiv ambalajul interior","value":"TIP"},"TKM":{"text":"TKM - Tonă kilometru","value":"TKM"},"TMS":{"text":"TMS - Kilogram de carne importată, mai puțin organe comestibile","value":"TMS"},"TNE":{"text":"TNE - Tonă (metrică)","value":"TNE"},"TP":{"text":"TP - Zece pachete","value":"TP"},"TPI":{"text":"TPI - Dinți pe centimetru","value":"TPI"},"TPR":{"text":"TPR - Zece perechi","value":"TPR"},"TQD":{"text":"TQD - Mii de metri cubi pe zi","value":"TQD"},"TRL":{"text":"TRL - Trilion (EUR)","value":"TRL"},"TST":{"text":"TST - Zece set","value":"TST"},"TTS":{"text":"TTS - Zece mii de bete","value":"TTS"},"U1":{"text":"U1 - Tratament","value":"U1"},"U2":{"text":"U2 - Comprimat","value":"U2"},"UB":{"text":"UB - Media liniei de telecomunicații în exploatare","value":"UB"},"UC":{"text":"UC - Port de telecomunicații","value":"UC"},"VA":{"text":"VA - Volt ? amper pe kilogram","value":"VA"},"VLT":{"text":"VLT - Volt","value":"VLT"},"VP":{"text":"VP - Volumul procentual","value":"VP"},"W2":{"text":"W2 - Kg umed","value":"W2"},"WA":{"text":"WA - Watt pe kilogram","value":"WA"},"WB":{"text":"WB - Livră umedă","value":"WB"},"WCD":{"text":"WCD - Cordonul","value":"WCD"},"WE":{"text":"WE - Tonă umedă","value":"WE"},"WEB":{"text":"WEB - Weber","value":"WEB"},"WEE":{"text":"WEE - Săptămână","value":"WEE"},"WG":{"text":"WG - Galon de vin","value":"WG"},"WHR":{"text":"WHR - Ora Watt","value":"WHR"},"WM":{"text":"WM - Lună de lucru","value":"WM"},"WSD":{"text":"WSD - Standard","value":"WSD"},"WTT":{"text":"WTT - Watt","value":"WTT"},"X1":{"text":"X1 - Lantul lui Gunter","value":"X1"},"YDK":{"text":"YDK - Yard pătrat","value":"YDK"},"YDQ":{"text":"YDQ - Yard cubic","value":"YDQ"},"YRD":{"text":"YRD - Yard","value":"YRD"},"Z11":{"text":"Z11 - Container suspendat","value":"Z11"},"ZP":{"text":"ZP - Pagina","value":"ZP"},"ZZ":{"text":"ZZ - Unitate definită de comun acord","value":"ZZ"},"X1A":{"text":"X1A - Tambur, oțel","value":"X1A"},"X1B":{"text":"X1B - Tambur, aluminiu","value":"X1B"},"X1D":{"text":"X1D - Tambur, placaj","value":"X1D"},"X1F":{"text":"X1F - Container, flexibil","value":"X1F"},"X1G":{"text":"X1G - Tambur, fibre","value":"X1G"},"X1W":{"text":"X1W - Tambur, din lemn","value":"X1W"},"X2C":{"text":"X2C - Butoi, din lemn","value":"X2C"},"X3A":{"text":"X3A - Jerrican, oțel","value":"X3A"},"X3H":{"text":"X3H - Jerrican, plastic","value":"X3H"},"X43":{"text":"X43 - Sac, super vrac","value":"X43"},"X44":{"text":"X44 - Pungă, pungă de poligam","value":"X44"},"X4A":{"text":"X4A - Cutie, oțel","value":"X4A"},"X4B":{"text":"X4B - Cutie, aluminiu","value":"X4B"},"X4C":{"text":"X4C - Cutie, lemn natural","value":"X4C"},"X4D":{"text":"X4D - Cutie, placaj","value":"X4D"},"X4F":{"text":"X4F - Cutie, lemn reconstituit","value":"X4F"},"X4G":{"text":"X4G - Cutie, panouri fibrolemnoase","value":"X4G"},"X4H":{"text":"X4H - Cutie, plastic","value":"X4H"},"X5H":{"text":"X5H - Pungă, țesută din plastic","value":"X5H"},"X5L":{"text":"X5L - Sac, textil","value":"X5L"},"X5M":{"text":"X5M - Sac, hârtie","value":"X5M"},"X6H":{"text":"X6H - Ambalaj compozit, recipient din plastic","value":"X6H"},"X6P":{"text":"X6P - Ambalaj compozit, recipient din sticlă","value":"X6P"},"X7A":{"text":"X7A - Case, masina","value":"X7A"},"X7B":{"text":"X7B - Carcasă, din lemn","value":"X7B"},"X8A":{"text":"X8A - Palet, din lemn","value":"X8A"},"X8B":{"text":"X8B - Ladă, din lemn","value":"X8B"},"X8C":{"text":"X8C - Pachet, din lemn","value":"X8C"},"XAA":{"text":"XAA - Recipient mare pentru vrac, din plastic rigid","value":"XAA"},"XAB":{"text":"XAB - Recipient, fibră","value":"XAB"},"XAC":{"text":"XAC - Recipient, hârtie","value":"XAC"},"XAD":{"text":"XAD - Recipient din lemn","value":"XAD"},"XAE":{"text":"XAE - Aerosoli","value":"XAE"},"XAF":{"text":"XAF - Palet, modular, manșon 80x60 cm","value":"XAF"},"XAG":{"text":"XAG - Palet, înfășurat în vrac","value":"XAG"},"XAH":{"text":"XAH - Palet, 100cm x 110cm","value":"XAH"},"XAI":{"text":"XAI - Scoica de scoica","value":"XAI"},"XAJ":{"text":"XAJ - Con de con","value":"XAJ"},"XAL":{"text":"XAL - Bilă","value":"XAL"},"XAM":{"text":"XAM - Fiola, neprotejată","value":"XAM"},"XAP":{"text":"XAP - Fiola, protejată","value":"XAP"},"XAT":{"text":"XAT - Atomizor","value":"XAT"},"XAV":{"text":"XAV - Capsulă","value":"XAV"},"XB4":{"text":"XB4 - Centură","value":"XB4"},"XBA":{"text":"XBA - Baril","value":"XBA"},"XBB":{"text":"XBB - Bobină","value":"XBB"},"XBC":{"text":"XBC - Bottlecrate/bottlerack","value":"XBC"},"XBD":{"text":"XBD - Board","value":"XBD"},"XBE":{"text":"XBE - Pachet","value":"XBE"},"XBF":{"text":"XBF - Balon, neprotejat","value":"XBF"},"XBG":{"text":"XBG - Sac","value":"XBG"},"XBH":{"text":"XBH - Buchet","value":"XBH"},"XBI":{"text":"XBI - Coș de gunoi","value":"XBI"},"XBJ":{"text":"XBJ - Găleată","value":"XBJ"},"XBK":{"text":"XBK - Coș","value":"XBK"},"XBL":{"text":"XBL - Balot, comprimat","value":"XBL"},"XBM":{"text":"XBM - Bazin","value":"XBM"},"XBN":{"text":"XBN - Balot, necomprimat","value":"XBN"},"XBO":{"text":"XBO - Sticlă, neprotejată, cilindrică","value":"XBO"},"XBP":{"text":"XBP - Balon, protejat","value":"XBP"},"XBQ":{"text":"XBQ - Flacon, protejat cilindric","value":"XBQ"},"XBR":{"text":"XBR - Bar","value":"XBR"},"XBS":{"text":"XBS - Sticlă, neprotejată, cu bulbi","value":"XBS"},"XBT":{"text":"XBT - Șurub","value":"XBT"},"XBU":{"text":"XBU - Cap la cap","value":"XBU"},"XBV":{"text":"XBV - Sticlă, protejată, cu bulbi","value":"XBV"},"XBW":{"text":"XBW - Cutie, pentru lichide","value":"XBW"},"XBX":{"text":"XBX - Cutie","value":"XBX"},"XBY":{"text":"XBY - Masă, în pachet/bucata/truss","value":"XBY"},"XBZ":{"text":"XBZ - Bare, în pachet/bucată/truss","value":"XBZ"},"XCA":{"text":"XCA - Cutie, dreptunghiulară","value":"XCA"},"XCB":{"text":"XCB - Ladă, bere","value":"XCB"},"XCC":{"text":"XCC - Churn","value":"XCC"},"XCD":{"text":"XCD - Poate, cu mâner și gura de scurgere","value":"XCD"},"XCE":{"text":"XCE - Creel","value":"XCE"},"XCF":{"text":"XCF - Cufăr","value":"XCF"},"XCG":{"text":"XCG - Cușcă","value":"XCG"},"XCH":{"text":"XCH - Piept","value":"XCH"},"XCI":{"text":"XCI - Canistră","value":"XCI"},"XCJ":{"text":"XCJ - Coșciug","value":"XCJ"},"XCK":{"text":"XCK - Butoiaș","value":"XCK"},"XCL":{"text":"XCL - Bobină","value":"XCL"},"XCM":{"text":"XCM - Card","value":"XCM"},"XCN":{"text":"XCN - Container, nespecificat altfel ca echipament de transport","value":"XCN"},"XCO":{"text":"XCO - Carboy, neprotejat","value":"XCO"},"XCP":{"text":"XCP - Carboy, protejat","value":"XCP"},"XCQ":{"text":"XCQ - Cartuș","value":"XCQ"},"XCR":{"text":"XCR - Ladă","value":"XCR"},"XCS":{"text":"XCS - Cutie (case)","value":"XCS"},"XCT":{"text":"XCT - Cutie de carton","value":"XCT"},"XCU":{"text":"XCU - Cupă","value":"XCU"},"XCV":{"text":"XCV - Copertă","value":"XCV"},"XCW":{"text":"XCW - Cușcă, rolă","value":"XCW"},"XCX":{"text":"XCX - Can, cilindric","value":"XCX"},"XCY":{"text":"XCY - Cilindru","value":"XCY"},"XCZ":{"text":"XCZ - Canvas","value":"XCZ"},"XDA":{"text":"XDA - Cutie, strat multiplu, plastic","value":"XDA"},"XDB":{"text":"XDB - Ladă, strat multiplu, din lemn","value":"XDB"},"XDC":{"text":"XDC - Cutie, strat multiplu, carton","value":"XDC"},"XDG":{"text":"XDG - Cușcă (CHEP)","value":"XDG"},"XDH":{"text":"XDH - Box, CHEP, Eurobox","value":"XDH"},"XDI":{"text":"XDI - Tambur, fier","value":"XDI"},"XDJ":{"text":"XDJ - Demijohn, neprotejat","value":"XDJ"},"XDK":{"text":"XDK - Cutie, vrac, carton","value":"XDK"},"XDL":{"text":"XDL - Cutie, vrac, din plastic","value":"XDL"},"XDM":{"text":"XDM - Ladă, vrac, din lemn","value":"XDM"},"XDN":{"text":"XDN - Seringa dozatoare","value":"XDN"},"XDP":{"text":"XDP - Demijohn, protejat","value":"XDP"},"XDR":{"text":"XDR - Tambur","value":"XDR"},"XDS":{"text":"XDS - Tavă, un strat fără capac, plastic","value":"XDS"},"XDT":{"text":"XDT - Tavă, un strat fără capac, din lemn","value":"XDT"},"XDU":{"text":"XDU - Tavă, un strat fără capac, polistiren","value":"XDU"},"XDV":{"text":"XDV - Tavă, un strat fără capac, carton","value":"XDV"},"XDW":{"text":"XDW - Tavă, două straturi fără capac, plastic","value":"XDW"},"XDX":{"text":"XDX - Tavă, două straturi fără capac, din lemn","value":"XDX"},"XDY":{"text":"XDY - Tavă, două straturi fără capac, carton","value":"XDY"},"XEC":{"text":"XEC - Pungă, plastic","value":"XEC"},"XED":{"text":"XED - Caz, cu baza de paleti","value":"XED"},"XEE":{"text":"XEE - Carcasă, cu suport palet, din lemn","value":"XEE"},"XEF":{"text":"XEF - Carcasă, cu suport palet, carton","value":"XEF"},"XEG":{"text":"XEG - Carcasă, cu suport palet, plastic","value":"XEG"},"XEH":{"text":"XEH - Carcasă, cu suport palet, metal","value":"XEH"},"XEI":{"text":"XEI - Caz, izotermie","value":"XEI"},"XEN":{"text":"XEN - Plic","value":"XEN"},"XFB":{"text":"XFB - FlexiBag","value":"XFB"},"XFC":{"text":"XFC - Ladă, fructe","value":"XFC"},"XFD":{"text":"XFD - Ladă, înrămată","value":"XFD"},"XFE":{"text":"XFE - Flexitank","value":"XFE"},"XFI":{"text":"XFI - Bradkin","value":"XFI"},"XFL":{"text":"XFL - Balon","value":"XFL"},"XFO":{"text":"XFO - Cufăr de picior","value":"XFO"},"XFP":{"text":"XFP - Pachet de filme","value":"XFP"},"XFR":{"text":"XFR - Cadru","value":"XFR"},"XFT":{"text":"XFT - Furnizor de alimente","value":"XFT"},"XFW":{"text":"XFW - Cărucior, cu platformă","value":"XFW"},"XFX":{"text":"XFX - Sac, recipient flexibil","value":"XFX"},"XGB":{"text":"XGB - Sticla, gaz","value":"XGB"},"XGI":{"text":"XGI - Grinzi","value":"XGI"},"XGL":{"text":"XGL - Recipient, galon","value":"XGL"},"XGR":{"text":"XGR - Recipient, sticlă","value":"XGR"},"XGU":{"text":"XGU - Tavă, cu elemente plane stivuite orizontal","value":"XGU"},"XGY":{"text":"XGY - Sac, gunny","value":"XGY"},"XGZ":{"text":"XGZ - Grinzi, în pachet/bucata/truss","value":"XGZ"},"XHA":{"text":"XHA - Coș, cu mâner, plastic","value":"XHA"},"XHB":{"text":"XHB - Coș, cu mâner, din lemn","value":"XHB"},"XHC":{"text":"XHC - Coș, cu mâner, carton","value":"XHC"},"XHG":{"text":"XHG - Butoi hogshead","value":"XHG"},"XHN":{"text":"XHN - Umeraş","value":"XHN"},"XHR":{"text":"XHR - Coș nuiele","value":"XHR"},"XIA":{"text":"XIA - Pachet, afisaj, lemn","value":"XIA"},"XIB":{"text":"XIB - Pachet, afisaj, carton","value":"XIB"},"XIC":{"text":"XIC - Pachet, afisaj, plastic","value":"XIC"},"XID":{"text":"XID - Pachet, afisaj, metal","value":"XID"},"XIE":{"text":"XIE - Pachet, arata","value":"XIE"},"XIF":{"text":"XIF - Pachet, flux","value":"XIF"},"XIG":{"text":"XIG - Pachet, hârtie învelită","value":"XIG"},"XIH":{"text":"XIH - Tambur, plastic","value":"XIH"},"XIK":{"text":"XIK - Pachet, carton, cu capace de prindere","value":"XIK"},"XIL":{"text":"XIL - Tavă rigidă, cu capac stivuit (CEN TS 14482:2002)","value":"XIL"},"XIN":{"text":"XIN - Lingou","value":"XIN"},"XIZ":{"text":"XIZ - Lingouri, în pachet/bucata/truss","value":"XIZ"},"XJB":{"text":"XJB - Sac, jumbo","value":"XJB"},"XJC":{"text":"XJC - Jerrican, dreptunghiular","value":"XJC"},"XJG":{"text":"XJG - Ulcior","value":"XJG"},"XJR":{"text":"XJR - Borcan","value":"XJR"},"XJT":{"text":"XJT - Jutebag","value":"XJT"},"XJY":{"text":"XJY - Jerrican, cilindric","value":"XJY"},"XKG":{"text":"XKG - Butoi de bere","value":"XKG"},"XKI":{"text":"XKI - Kit","value":"XKI"},"XLE":{"text":"XLE - Bagaj","value":"XLE"},"XLG":{"text":"XLG - Jurnal","value":"XLG"},"XLT":{"text":"XLT - Lot","value":"XLT"},"XLU":{"text":"XLU - Lug","value":"XLU"},"XLV":{"text":"XLV - Liftvan","value":"XLV"},"XLZ":{"text":"XLZ - Bușteni, în pachet/truss","value":"XLZ"},"XMA":{"text":"XMA - Ladă, metal","value":"XMA"},"XMB":{"text":"XMB - Sac, se înmulteste?","value":"XMB"},"XMC":{"text":"XMC - Ladă, lapte","value":"XMC"},"XME":{"text":"XME - Recipient, din metal","value":"XME"},"XMR":{"text":"XMR - Recipient, din metal","value":"XMR"},"XMS":{"text":"XMS - Sack, cu mai multe pereti","value":"XMS"},"XMT":{"text":"XMT - Mat","value":"XMT"},"XMW":{"text":"XMW - Recipient, înfășurat din plastic","value":"XMW"},"XMX":{"text":"XMX - Cutie de chibrituri","value":"XMX"},"XNA":{"text":"XNA - Nedisponibil","value":"XNA"},"XNE":{"text":"XNE - Despachetat sau neambalat","value":"XNE"},"XNF":{"text":"XNF - Despachetat sau neambalat, o singură unitate","value":"XNF"},"XNG":{"text":"XNG - Despachetate sau neambalate, mai multe unități","value":"XNG"},"XNS":{"text":"XNS - Cuib","value":"XNS"},"XNT":{"text":"XNT - Plasă","value":"XNT"},"XNU":{"text":"XNU - Plasă, tub, plastic","value":"XNU"},"XNV":{"text":"XNV - Net, tub, textile","value":"XNV"},"XOA":{"text":"XOA - Palet, CHEP 40 cm x 60 cm","value":"XOA"},"XOB":{"text":"XOB - Palet, CHEP 80 cm x 120 cm","value":"XOB"},"XOC":{"text":"XOC - Palet, CHEP 100 cm x 120 cm","value":"XOC"},"XOD":{"text":"XOD - Palet, AS 4068-1993","value":"XOD"},"XOE":{"text":"XOE - Palet, ISO T11","value":"XOE"},"XOF":{"text":"XOF - Platformă, greutate sau dimensiune nespecificată","value":"XOF"},"XOK":{"text":"XOK - Bloc","value":"XOK"},"XOT":{"text":"XOT - Octabina","value":"XOT"},"XOU":{"text":"XOU - Recipient, exterior","value":"XOU"},"XP2":{"text":"XP2 - Pan","value":"XP2"},"XPA":{"text":"XPA - Pachet","value":"XPA"},"XPB":{"text":"XPB - Palet, cutie combinată cu cutie deschisă și palet","value":"XPB"},"XPC":{"text":"XPC - Parcela","value":"XPC"},"XPD":{"text":"XPD - Palet, modular, manșon 80x100 cm","value":"XPD"},"XPE":{"text":"XPE - Palet, modular, manșon 80x120 cm","value":"XPE"},"XPF":{"text":"XPF - Stilou injector (pen)","value":"XPF"},"XPG":{"text":"XPG - Placă","value":"XPG"},"XPH":{"text":"XPH - Ulcior","value":"XPH"},"XPI":{"text":"XPI - Țeavă","value":"XPI"},"XPJ":{"text":"XPJ - Punnet","value":"XPJ"},"XPK":{"text":"XPK - Pachet","value":"XPK"},"XPL":{"text":"XPL - Găleată","value":"XPL"},"XPN":{"text":"XPN - Scândură","value":"XPN"},"XPO":{"text":"XPO - Husă","value":"XPO"},"XPR":{"text":"XPR - Recipient, din plastic","value":"XPR"},"XPT":{"text":"XPT - Oala","value":"XPT"},"XPU":{"text":"XPU - Tavă","value":"XPU"},"XPV":{"text":"XPV - Țevi, în pachet/bucata/truss","value":"XPV"},"XPX":{"text":"XPX - Palet","value":"XPX"},"XPY":{"text":"XPY - Plăci, în pachet/bucata/truss","value":"XPY"},"XPZ":{"text":"XPZ - Scânduri, în pachet/bucată/truss","value":"XPZ"},"XQA":{"text":"XQA - Tambur, otel, cap nedetașabil","value":"XQA"},"XQB":{"text":"XQB - Tambur, oțel, cap detașabil","value":"XQB"},"XQC":{"text":"XQC - Tambur, din aluminiu, cap nedetașabil","value":"XQC"},"XQD":{"text":"XQD - Tambur, aluminiu, cap detașabil","value":"XQD"},"XQF":{"text":"XQF - Tambur, din plastic, cap nedetașabil","value":"XQF"},"XQG":{"text":"XQG - Tambur, plastic, cap detașabil","value":"XQG"},"XQH":{"text":"XQH - Butoi lemn, tip cep","value":"XQH"},"XQJ":{"text":"XQJ - Butoi lemn, cap detașabil","value":"XQJ"},"XQK":{"text":"XQK - Jerican, otel, cap nedetașabil","value":"XQK"},"XQL":{"text":"XQL - Jerrican, otel, cap detasabil","value":"XQL"},"XQM":{"text":"XQM - Cap de plastic, nedetașabil","value":"XQM"},"XQN":{"text":"XQN - Jerrican, plastic, cap detasabil","value":"XQN"},"XQP":{"text":"XQP - Cutie, lemn, lemn natural, obișnuit","value":"XQP"},"XQQ":{"text":"XQQ - Cutie, lemn, lemn natural, cu pereți rezistenti la cernere","value":"XQQ"},"XQR":{"text":"XQR - Cutie, plastic, extins","value":"XQR"},"XQS":{"text":"XQS - Cutie, plastic, solid","value":"XQS"},"XRD":{"text":"XRD - Tijă","value":"XRD"},"XRG":{"text":"XRG - Inel","value":"XRG"},"XRJ":{"text":"XRJ - Rack, umeras de îmbrăcăminte","value":"XRJ"},"XRK":{"text":"XRK - Rack","value":"XRK"},"XRL":{"text":"XRL - Rolă","value":"XRL"},"XRO":{"text":"XRO - Rolă","value":"XRO"},"XRT":{"text":"XRT - ReDNet","value":"XRT"},"XRZ":{"text":"XRZ - Tije, în pachet/bucata/truss","value":"XRZ"},"XSA":{"text":"XSA - Sack","value":"XSA"},"XSB":{"text":"XSB - Lespede","value":"XSB"},"XSC":{"text":"XSC - Ladă, superficială","value":"XSC"},"XSD":{"text":"XSD - Ax","value":"XSD"},"XSE":{"text":"XSE - Pieptul marii","value":"XSE"},"XSH":{"text":"XSH - Plic","value":"XSH"},"XSI":{"text":"XSI - Derapeaza","value":"XSI"},"XSK":{"text":"XSK - Carcasă, cutie, cadru","value":"XSK"},"XSL":{"text":"XSL - Foaia de alunecare","value":"XSL"},"XSM":{"text":"XSM - Tablă de metal","value":"XSM"},"XSO":{"text":"XSO - Bobină","value":"XSO"},"XSP":{"text":"XSP - Folie de plastic","value":"XSP"},"XSS":{"text":"XSS - Caz, din otel","value":"XSS"},"XST":{"text":"XST - Foaia de hartie","value":"XST"},"XSU":{"text":"XSU - Valiză","value":"XSU"},"XSV":{"text":"XSV - Plic, otel","value":"XSV"},"XSW":{"text":"XSW - Infoliată","value":"XSW"},"XSY":{"text":"XSY - Mânecă","value":"XSY"},"XSZ":{"text":"XSZ - Foi, în pachet/bucată/truss","value":"XSZ"},"XT1":{"text":"XT1 - Comprimat","value":"XT1"},"XTB":{"text":"XTB - Cadă","value":"XTB"},"XTC":{"text":"XTC - Piept de ceai","value":"XTC"},"XTD":{"text":"XTD - Tub, pliabil","value":"XTD"},"XTE":{"text":"XTE - Pneu","value":"XTE"},"XTG":{"text":"XTG - Recipient pentru cisterna, generic","value":"XTG"},"XTI":{"text":"XTI - Cravata","value":"XTI"},"XTK":{"text":"XTK - Rezervor, dreptunghiular","value":"XTK"},"XTL":{"text":"XTL - Cadă, cu capac","value":"XTL"},"XTN":{"text":"XTN - Staniu","value":"XTN"},"XTO":{"text":"XTO - Tun","value":"XTO"},"XTR":{"text":"XTR - Trunchi","value":"XTR"},"XTS":{"text":"XTS - Truss","value":"XTS"},"XTT":{"text":"XTT - Sac, tote","value":"XTT"},"XTU":{"text":"XTU - Tub","value":"XTU"},"XTV":{"text":"XTV - Tub, cu duză","value":"XTV"},"XTW":{"text":"XTW - Palet, triwall","value":"XTW"},"XTY":{"text":"XTY - Cisternă, cilindrică","value":"XTY"},"XTZ":{"text":"XTZ - Tuburi, în pachet/bucată/truss","value":"XTZ"},"XUC":{"text":"XUC - Neascutita","value":"XUC"},"XUN":{"text":"XUN - Unitate","value":"XUN"},"XVA":{"text":"XVA - VAT","value":"XVA"},"XVG":{"text":"XVG - Vrac, gaz (la 1031 mbar și 15 grdC)","value":"XVG"},"XVI":{"text":"XVI - Flacon","value":"XVI"},"XVK":{"text":"XVK - Vanpack","value":"XVK"},"XVL":{"text":"XVL - Vrac, lichid","value":"XVL"},"XVO":{"text":"XVO - Vrac, solide, particule mari","value":"XVO"},"XVP":{"text":"XVP - Ambalaj vidat","value":"XVP"},"XVQ":{"text":"XVQ - Vrac, gaz lichefiat (la temp./presiune anormală)","value":"XVQ"},"XVN":{"text":"XVN - Vehicul","value":"XVN"},"XVR":{"text":"XVR - Particule groase, solide, granulare","value":"XVR"},"XVS":{"text":"XVS - Vrac, deșeuri metalice","value":"XVS"},"XVY":{"text":"XVY - Vrac, solide, particule fine (pulberi)","value":"XVY"},"XWA":{"text":"XWA - Recipient vrac","value":"XWA"},"XWB":{"text":"XWB - Biberonul de Wickerbottle","value":"XWB"},"XWC":{"text":"XWC - Recipient vrac, oțel","value":"XWC"},"XWD":{"text":"XWD - Recipient vrac, aluminiu","value":"XWD"},"XWF":{"text":"XWF - Recipient vrac, din metal","value":"XWF"},"XWG":{"text":"XWG - Recipient vrac, din oțel, presurizat > 10 kpa","value":"XWG"},"XWH":{"text":"XWH - Recipient vrac, din aluminiu, presurizat > 10 kpa","value":"XWH"},"XWJ":{"text":"XWJ - Recipient vrac, metal, presurizat 10 kpa","value":"XWJ"},"XWK":{"text":"XWK - Recipient vrac, din oțel, lichide","value":"XWK"},"XWL":{"text":"XWL - Recipient vrac, aluminiu, lichide","value":"XWL"},"XWM":{"text":"XWM - Recipient vrac, metalic, lichide","value":"XWM"},"XWN":{"text":"XWN - Recipient vrac, plastic țesut, fără acoperire/căptușeală","value":"XWN"},"XWP":{"text":"XWP - Recipient vrac, plastic țesut, acoperit","value":"XWP"},"XWQ":{"text":"XWQ - Recipient vrac, plastic țesut, căptușit","value":"XWQ"},"XWR":{"text":"XWR - Recipient vrac, plastic țesut, acoperit/căptușit","value":"XWR"},"XWS":{"text":"XWS - Recipient vrac, pelicula din plastic","value":"XWS"},"XWT":{"text":"XWT - Recipient vrac, textil, acoperit/căptușit","value":"XWT"},"XWU":{"text":"XWU - Recipient vrac, din lemn natural, cu sigiliu interior","value":"XWU"},"XWV":{"text":"XWV - Recipient vrac, textil, acoperit","value":"XWV"},"XWW":{"text":"XWW - Recipient vrac, textil, căptușit","value":"XWW"},"XWX":{"text":"XWX - Recipient vrac, textil, acoperite și căptușit","value":"XWX"},"XWY":{"text":"XWY - Recipient vrac, placaj, căptușit","value":"XWY"},"XWZ":{"text":"XWZ - Recipient vrac, lemn reconstituit, căptușit","value":"XWZ"},"XXA":{"text":"XXA - Pungă, plastic țesut, fără strat interior/căptușeală","value":"XXA"},"XXB":{"text":"XXB - Sac, plastic țesut, dovada cernerii","value":"XXB"},"XXC":{"text":"XXC - Pungă, plastic țesut, rezistentă la apă","value":"XXC"},"XXD":{"text":"XXD - Pungă, folie de plastic","value":"XXD"},"XXF":{"text":"XXF - Sac, textil, fără strat interior","value":"XXF"},"XXG":{"text":"XXG - Sac, textil, probă de cernere","value":"XXG"},"XXH":{"text":"XXH - Sac, textil, rezistent la apă","value":"XXH"},"XXJ":{"text":"XXJ - Pungă, hârtie, multi-perete","value":"XXJ"},"XXK":{"text":"XXK - Pungă, hârtie, multi-perete, rezistente la apă","value":"XXK"},"XYA":{"text":"XYA - Ambalaj compozit, recipient din plastic în tambur de oțel","value":"XYA"},"XYB":{"text":"XYB - Ambalaj compozit, recipient din plastic în cutie de oțel","value":"XYB"},"XYC":{"text":"XYC - Ambalaj compozit, recipient din plastic în tambur de aluminiu","value":"XYC"},"XYD":{"text":"XYD - Ambalaj compozit, recipient din plastic în ladă de aluminiu","value":"XYD"},"XYF":{"text":"XYF - Ambalaj compozit, recipient din plastic în cutie de lemn","value":"XYF"},"XYG":{"text":"XYG - Ambalaj compozit, recipient din plastic în tambur din placaj","value":"XYG"},"XYH":{"text":"XYH - Ambalaj compozit, recipient din plastic în cutie din placaj","value":"XYH"},"XYJ":{"text":"XYJ - Ambalaj compozit, recipient din plastic în tambur din fibre","value":"XYJ"},"XYK":{"text":"XYK - Ambalaj compozit, recipient din plastic în cutie pentru panouri fibrolemn","value":"XYK"},"XYL":{"text":"XYL - Ambalaj compozit, recipient din plastic în tambur de plastic","value":"XYL"},"XYM":{"text":"XYM - Ambalaj compozit, recipient din plastic în cutie din plastic solid","value":"XYM"},"XYN":{"text":"XYN - Ambalaj compozit, recipient din sticlă în tambur de oțel","value":"XYN"},"XYP":{"text":"XYP - Ambalaj compozit, recipient din sticlă în cutie de otel","value":"XYP"},"XYQ":{"text":"XYQ - Ambalaj compozit, recipient din sticlă în tambur de aluminiu","value":"XYQ"},"XYR":{"text":"XYR - Ambalaj compozit, recipient din sticlă în ladă de aluminiu","value":"XYR"},"XYS":{"text":"XYS - Ambalaj compozit, recipient din sticlă în cutie de lemn","value":"XYS"},"XYT":{"text":"XYT - Ambalaj compozit, recipient din sticlă în tambur din placaj","value":"XYT"},"XYV":{"text":"XYV - Ambalaj compozit, recipient din sticlă în coș de răchită","value":"XYV"},"XYW":{"text":"XYW - Ambalaj compozit, recipient din sticlă în tambur din fibră","value":"XYW"},"XYX":{"text":"XYX - Ambalaj compozit, recipient din sticlă în cutie pentru panouri fibrolemn","value":"XYX"},"XYY":{"text":"XYY - Ambalaj compozit, recipient din sticlă în ambalaj din plastic expandabil","value":"XYY"},"XYZ":{"text":"XYZ - Ambalaj compozit, recipient din sticlă în ambalaj din plastic solid","value":"XYZ"},"XZA":{"text":"XZA - Recipient vrac, hârtie, multi-perete","value":"XZA"},"XZB":{"text":"XZB - Sac mare","value":"XZB"},"XZC":{"text":"XZC - Recipient vrac, hârtie, multi-perete, rezistent la apă","value":"XZC"},"XZD":{"text":"XZD - Recipient vrac, plastic rigid, cu echipamente structurale, solide","value":"XZD"},"XZF":{"text":"XZF - Recipient vrac, plastic rigid, de sine statator, solide","value":"XZF"},"XZG":{"text":"XZG - Recipient vrac, plastic rigid, cu echipament structural, presurizat","value":"XZG"},"XZH":{"text":"XZH - Recipient vrac, plastic rigid, de sine statator, presurizat","value":"XZH"},"XZJ":{"text":"XZJ - Recipient vrac, plastic rigid, cu echipamente structurale, lichide","value":"XZJ"},"XZK":{"text":"XZK - Recipient vrac, plastic rigid, de sine statator, lichide","value":"XZK"},"XZL":{"text":"XZL - Recipient vrac, compozit, plastic rigid, solide","value":"XZL"},"XZM":{"text":"XZM - Recipient vrac, compozit, plastic flexibil, solide","value":"XZM"},"XZN":{"text":"XZN - Recipient vrac, compozit, plastic rigid, presurizat","value":"XZN"},"XZP":{"text":"XZP - Recipient vrac, compozit, plastic flexibil, presurizat","value":"XZP"},"XZQ":{"text":"XZQ - Recipient vrac, compozit, plastic rigid, lichide","value":"XZQ"},"XZR":{"text":"XZR - Recipient vrac, compozit, plastic flexibil, lichide","value":"XZR"},"XZS":{"text":"XZS - Recipient vrac, compozit","value":"XZS"},"XZT":{"text":"XZT - Recipient vrac, panouri fibrolemnoase","value":"XZT"},"XZU":{"text":"XZU - Recipient vrac, flexibil","value":"XZU"},"XZV":{"text":"XZV - Recipient vrac, din metal, altele decât oțelul","value":"XZV"},"XZW":{"text":"XZW - Recipient vrac, lemn natural","value":"XZW"},"XZX":{"text":"XZX - Recipient vrac, placaj","value":"XZX"},"XZY":{"text":"XZY - Recipient vrac, lemn reconstituit","value":"XZY"},"XZZ":{"text":"XZZ - Unitate definită de comun acord","value":"XZZ"},"DBM":{"text":"DBM - Decibel-miliwați","value":"DBM"},"DBW":{"text":"DBW - Decibel Watt","value":"DBW"},"FNU":{"text":"FNU - Unitate nefelometrică de formazină","value":"FNU"},"HAD":{"text":"HAD - Bucată zi","value":"HAD"},"HMO":{"text":"HMO - Bucată lună","value":"HMO"},"HWE":{"text":"HWE - Bucată săptămână","value":"HWE"},"KWY":{"text":"KWY - kilowați an","value":"KWY"},"MKD":{"text":"MKD - Zi metru pătrat","value":"MKD"},"MKM":{"text":"MKM - Lună metru pătrat","value":"MKM"},"MKW":{"text":"MKW - Săptămâna metru pătrat","value":"MKW"},"MNJ":{"text":"MNJ - Mega Joule pe metru cub normalizat","value":"MNJ"},"MQD":{"text":"MQD - Zi metru cub","value":"MQD"},"MQM":{"text":"MQM - Luna metru cub","value":"MQM"},"MQW":{"text":"MQW - Săptămâna metru cub","value":"MQW"},"MRD":{"text":"MRD - Zi metru","value":"MRD"},"MRM":{"text":"MRM - Lună metru","value":"MRM"},"MRW":{"text":"MRW - Săptămână metru","value":"MRW"},"MTZ":{"text":"MTZ - milihertz","value":"MTZ"},"NTU":{"text":"NTU - Unitatea de turbiditate nefelometrică","value":"NTU"},"Z9":{"text":"Z9 - nanomol","value":"Z9"},"XO1":{"text":"XO1 - Cușcă pe două fețe pe roți cu curea de fixare","value":"XO1"},"XO2":{"text":"XO2 - Cărucior","value":"XO2"},"XO3":{"text":"XO3 - Palet unic ISO 0 - 1/2 EURO Palet","value":"XO3"},"XO4":{"text":"XO4 - Palet unic ISO 1 - 1/1 EURO Palet","value":"XO4"},"XO5":{"text":"XO5 - Palet unic ISO 2 - 2/1 EURO Palet","value":"XO5"},"XO6":{"text":"XO6 - Palet cu dimensiuni exceptionale","value":"XO6"},"XO7":{"text":"XO7 - Palet din lemn 40 cm x 80 cm","value":"XO7"},"XO8":{"text":"XO8 - Palet plastic SRS 60 cm x 80 cm","value":"XO8"},"XO9":{"text":"XO9 - Palet plastic SRS 80 cm x 120 cm","value":"XO9"},"XOG":{"text":"XOG - Palet ISO 0 - 1/2 EURO Palet","value":"XOG"},"XOH":{"text":"XOH - Palet ISO 1 - 1/1 EURO Palet","value":"XOH"},"XOI":{"text":"XOI - Palet ISO 2 – 2/1 EURO Palet","value":"XOI"},"XOJ":{"text":"XOJ - Palet 1/4 EURO","value":"XOJ"},"XOL":{"text":"XOL - Palet 1/8 EURO","value":"XOL"},"XOM":{"text":"XOM - Palet sintetic ISO 1","value":"XOM"},"XON":{"text":"XON - Palet sintetic ISO 2","value":"XON"},"XOP":{"text":"XOP - Palet angro","value":"XOP"},"XOQ":{"text":"XOQ - Palet 80 X 100 cm","value":"XOQ"},"XOR":{"text":"XOR -","value":"XOR"},"XOS":{"text":"XOS - Palet unic","value":"XOS"},"XOV":{"text":"XOV - Palet returnabil","value":"XOV"},"XOW":{"text":"XOW - Geanta mare, dimensiunea paletului","value":"XOW"},"XOX":{"text":"XOX - Un palet pe roți cu margine ridicată (81 x 67 x 135)","value":"XOX"},"XOY":{"text":"XOY - Palet pe roți cu margine ridicată (81 x 72 x 135)","value":"XOY"},"XOZ":{"text":"XOZ - Palet cu roți cu jantă ridicată ( 81 x 60 x 16)","value":"XOZ"},"XP1":{"text":"XP1 - Palet CHEP 60 cm x 80 cm","value":"XP1"},"XP3":{"text":"XP3 - Palet LPR 60 cm x 80 cm","value":"XP3"},"XP4":{"text":"XP4 - Palet LPR 80 cm x 120 cm","value":"XP4"},"XSX":{"text":"XSX - Set","value":"XSX"}}

/***/ }),

/***/ "sCPY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableOpenOrderReport_vue__ = __webpack_require__("B7bJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2527e3e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableOpenOrderReport_vue__ = __webpack_require__("mWDo");
function injectStyle (ssrContext) {
  __webpack_require__("pWD6")
  __webpack_require__("HfNC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableOpenOrderReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2527e3e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableOpenOrderReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sDlK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptionsForm_vue__ = __webpack_require__("WN5T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5f02a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptionsForm_vue__ = __webpack_require__("/3Kn");
function injectStyle (ssrContext) {
  __webpack_require__("M8kF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptionsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5f02a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptionsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sEIX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalModal_vue__ = __webpack_require__("2KDK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80ee95ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalModal_vue__ = __webpack_require__("+82s");
function injectStyle (ssrContext) {
  __webpack_require__("7Gbx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-80ee95ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80ee95ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sIVt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KioskVideoInput_vue__ = __webpack_require__("wYu/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30ef8e95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KioskVideoInput_vue__ = __webpack_require__("F9Yb");
function injectStyle (ssrContext) {
  __webpack_require__("l9bJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30ef8e95"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KioskVideoInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30ef8e95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KioskVideoInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sKTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"text-center purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.sendNotificationTo')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 pad-bt-15"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group"},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.gender')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[1].value),expression:"filters[1].value"}],staticClass:"form-control",attrs:{"placeholder":_vm.$t('marketingCampaigns.gender')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters[1], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('general.all'))+" - ")]),_vm._v(" "),_c('option',{attrs:{"value":"M"}},[_vm._v(_vm._s(_vm.$t('gender.male')))]),_vm._v(" "),_c('option',{attrs:{"value":"F"}},[_vm._v(_vm._s(_vm.$t('gender.female')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group"},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.age')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[3].value),expression:"filters[3].value"}],staticClass:"form-control",attrs:{"name":"age","placeholder":_vm.$t('marketingCampaigns.age')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters[3], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('general.all'))+" - ")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups.20')))]),_vm._v(" "),_c('option',{attrs:{"value":"20-30"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups["20-30"]')))]),_vm._v(" "),_c('option',{attrs:{"value":"30-40"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups["30-40"]')))]),_vm._v(" "),_c('option',{attrs:{"value":"40-50"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups["40-50"]')))]),_vm._v(" "),_c('option',{attrs:{"value":"50+"}},[_vm._v(_vm._s(_vm.$t('reportsAgesGroups["50"]')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-6 col-xs-12 form-group"},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.locations')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.locations,"value":"token","label":"name"},model:{value:(_vm.filters[4].value),callback:function ($$v) {_vm.$set(_vm.filters[4], "value", $$v)},expression:"filters[4].value"}}),_vm._v(" "),(_vm.errors.has('location'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('location'))+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group"},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.withOrdersLabel')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[9].value),expression:"filters[9].value"}],staticClass:"form-control",attrs:{"name":"with_orders"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters[9], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('general.all'))+" - ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.withOrders')))]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.withoutOrders')))])])]),_vm._v(" "),_c('div',{class:_vm.colsClass + ' col-sm-6 col-xs-12 form-group'},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.ordersAbove'))+" ("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[2].value),expression:"filters[2].value"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"E.g. 200"},domProps:{"value":(_vm.filters[2].value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters[2], "value", $event.target.value)}}})]),_vm._v(" "),_c('div',{class:_vm.colsClass + ' col-sm-6 col-xs-12 form-group'},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.ordersBelow'))+" ("+_vm._s(_vm.currency)+")")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[6].value),expression:"filters[6].value"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"E.g. 200"},domProps:{"value":(_vm.filters[6].value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters[6], "value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group"},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingFidelities.userLabeling')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[5].value),expression:"filters[5].value"}],staticClass:"form-control",attrs:{"name":"user_label_id","placeholder":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters[5], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.handleFilter()}]}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('general.all'))+" - ")]),_vm._v(" "),_vm._l((_vm.userLabels),function(user_label){return _c('option',{key:user_label.id,domProps:{"value":user_label.id}},[_vm._v(_vm._s(user_label.name))])})],2)]),_vm._v(" "),_c('div',{class:_vm.colsClass + ' col-sm-6 col-xs-12 form-group'},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.ordersAboveNr')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[7].value),expression:"filters[7].value"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"E.g. 1"},domProps:{"value":(_vm.filters[7].value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters[7], "value", $event.target.value)}}})]),_vm._v(" "),_c('div',{class:_vm.colsClass + ' col-sm-6 col-xs-12 form-group'},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.ordersBelowNr')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[8].value),expression:"filters[8].value"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"E.g. 300"},domProps:{"value":(_vm.filters[8].value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters[8], "value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12 form-group"},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.groups')))]),_vm._v(" "),_c('v-select',{attrs:{"placeholder":_vm.$t('general.all'),"multiple":"","options":_vm.customerGroups,"label":"name","input":_vm.groupCustomersEvent()},on:{"change":function($event){_vm.handleFilter()}},model:{value:(_vm.filters[10].value),callback:function ($$v) {_vm.$set(_vm.filters[10], "value", $$v)},expression:"filters[10].value"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-6 col-xs-12 form-group"},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.withLoyaltyPointsLabel')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters[12].value),expression:"filters[12].value"}],staticClass:"form-control",attrs:{"name":"with_loyalty_points"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters[12], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('marketingCampaigns.withLoyaltyPointsAll'))+" - ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.withLoyaltyPoints')))]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.withoutLoyaltyPoints')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 form-group"},[_c('label',{staticClass:"control-label text-purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.period')))]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":"period","picker-options":_vm.pickerOptions},model:{value:(_vm.filters[11].value),callback:function ($$v) {_vm.$set(_vm.filters[11], "value", $$v)},expression:"filters[11].value"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 form-group"},[_c('label',{}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.applyFilters()}}},[_vm._v("\n              "+_vm._s(_vm.$t('reports.filter'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"reset"},on:{"click":function($event){_vm.resetFilters()}}},[_vm._v("\n              "+_vm._s(_vm.$t('general.reset'))+"\n            ")])])])])])]),_vm._v(" "),_c('data-tables',{staticClass:"campaign-clients-table",staticStyle:{"width":"100%","background":"#fff"},attrs:{"data":_vm.tableData,"table-props":{'border': false, 'stripe': false,}},on:{"filtered-data":_vm.dataFiltered}},[_c('el-table-column',{attrs:{"label":_vm.$t('settingsPages.users'),"min-width":80},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.firstname != null || props.row.lastname != null)?[_vm._v("\n          "+_vm._s(props.row.firstname)+" "+_vm._s(props.row.lastname)+"\n        ")]:[_vm._v("\n          "+_vm._s(props.row.email)+"\n        ")]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('reports.gender'),"min-width":60},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.gender ? props.row.gender.toUpperCase() : '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('reports.age'),"min-width":60},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.age ? props.row.age : '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('marketingCampaigns.loyaltyPointsColumn'),"min-width":80},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b',[_vm._v(_vm._s(props.row.loyalty_points != null ? props.row.loyalty_points : '-'))])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"active-pagination",attrs:{"total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"current-page":_vm.paginationDef.page,"page-count":_vm.paginationDef.totalPages,"pageSizes":[10,20,50],"layout":"prev, pager, next, total"},on:{"update:currentPage":function($event){_vm.$set(_vm.paginationDef, "page", $event)},"current-change":function($event){_vm.handlePageChange($event)},"prev-click":function($event){_vm.handlePageChange($event)},"next-click":function($event){_vm.handlePageChange($event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sMOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("wfBj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67947a4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("2OUi");
function injectStyle (ssrContext) {
  __webpack_require__("r1A8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67947a4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    slide: {
      type: String,
      default: 'down'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    getSlideClass: function getSlideClass() {
      return this.slide === 'down' ? 'dropdown' : 'dropup';
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),

/***/ "sQwZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GiftCard_vue__ = __webpack_require__("3wCJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03d9f582_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GiftCard_vue__ = __webpack_require__("XwFy");
function injectStyle (ssrContext) {
  __webpack_require__("oqhj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GiftCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03d9f582_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GiftCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sRwN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Management_ManagementSeriesAdd_vue__ = __webpack_require__("kgt7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);














/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__["a" /* default */],
    ManagementSeriesAdd: __WEBPACK_IMPORTED_MODULE_10__Management_ManagementSeriesAdd_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      selectedLocationId: '',
      selectedDepositLocationId: '',
      locations: [],
      gestiuneOptions: [],
      seriesOptions: [],
      searchResults: [],
      currencyOptions: [{ code: 'RON', name: 'Leu Românesc (RON)' }, { code: 'EUR', name: 'Euro (EUR)' }, { code: 'USD', name: 'Dolar American (USD)' }],
      isEdit: !!this.route.params.series && !!this.route.params.number,
      myOrder: {
        date: new Date()
      },
      tableData: [],
      mesurementsUnits: [],
      selectedLocation: null,
      isReception: false,
      onFetchProductsTimeout: null,
      isValidate: false,
      items: [],
      newItem: {
        gestiune: null,
        productName: null,
        code: '',
        unitMeasure: '',
        quantity_scriptic: 1,
        quantity_faptic: 0,
        pret_fara_tva: 0,
        tva_percent: 19,
        vatValue: 0
      },
      selectedSerieName: '',
      seriePromiseResolver: null
    };
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.fetchLocation();
    this.fetchGestiuni();
  },

  watch: {
    selectedLocationId: function selectedLocationId(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;

            var _route$query = this.route.query,
                series = _route$query.series,
                number = _route$query.number,
                isReception = _route$query.isReception,
                isValidate = _route$query.isValidate;

            this.isReception = isReception === 'true' || isReception === true;
            this.isValidate = isValidate === 'true' || isValidate === true;

            var shouldSkipSeries = this.isValidate || this.isReception;

            if (!shouldSkipSeries && series && number && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code);
            } else if (!this.isEdit && !shouldSkipSeries && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code);
            }

            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    locations: function locations(newLocations) {
      if (newLocations && newLocations.length) {
        var _route$query2 = this.route.query,
            series = _route$query2.series,
            number = _route$query2.number,
            isReception = _route$query2.isReception,
            isValidate = _route$query2.isValidate;

        this.isReception = isReception === 'true' || isReception === true;
        this.isValidate = isValidate === 'true' || isValidate === true;
        if (series && number && (this.isReception || this.isValidate)) {
          this.fetchOrder(series, number);
        }
      }
    }
  },
  computed: {
    seriesOptionsWithAdd: function seriesOptionsWithAdd() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(this.seriesOptions), [{ id: 'add', name: '➕ Adaugă serie' }]);
    },
    groupedLocations: function groupedLocations() {
      var groups = {};

      if (!this.locations || !this.locations.length) return [];

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    },
    locationsWithDepositGestiune: function locationsWithDepositGestiune() {
      if (!Array.isArray(this.gestiuneOptions) || !this.gestiuneOptions.length || !Array.isArray(this.locations) || !this.locations.length) {
        return [];
      }

      var locationIdsFromDepositGestiuni = this.gestiuneOptions.filter(function (g) {
        return g.is_depozit === true;
      }).map(function (g) {
        return g.externalLocationId;
      });

      return this.locations.filter(function (loc) {
        return locationIdsFromDepositGestiuni.includes(loc.true_id);
      });
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocationId) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocationId;
      });
      return result;
    },
    modalOrderTitle: function modalOrderTitle() {
      if (this.isReception) {
        return this.$t('gestiune.receptionOrder');
      } else if (this.isValidate) {
        return this.$t('gestiune.validateOrder');
      } else {
        return this.$t('gestiune.addOrder');
      }
    }
  },
  methods: {
    resetNewItem: function resetNewItem() {
      this.newItem = {
        productName: null,
        code: '',
        unitMeasure: '',
        quantity_scriptic: 0,
        quantity_faptic: 0,
        pret_fara_tva: 0,
        tva_percent: 19,
        vatValue: 0
      };
    },
    handleSerieChange: function handleSerieChange(val) {
      if (val === 'add') {
        this.openSeriesModal();
        this.myOrder.serie = null;
      }
    },
    openSeriesModal: function openSeriesModal() {
      this.$modal.show('addSeriesModal');
    },
    calculateVatValue: function calculateVatValue(item) {
      var quantity = parseFloat(item.quantity_scriptic) || 0;
      var price = parseFloat(item.pret_fara_tva) || 0;
      var percent = parseFloat(item.tva_percent) || 0;
      var vat = quantity * price * percent / 100;
      return Number(vat.toFixed(2));
    },
    addItem: function addItem() {
      var item = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.newItem, {
        vatValue: this.calculateVatValue(this.newItem)
      });
      this.items.push(item);
      this.resetNewItem();
    },
    removeItem: function removeItem(index) {
      this.items.splice(index, 1);
    },
    fetchLocation: function fetchLocation() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataToSend = {
                  company_id: _this2.companyID,
                  token: _this2.$session.get('token')
                };


                _this2.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this2.locations = response.data.locations;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this3 = this;

      if (!this.selectedLocation || !searchTerm || searchTerm.length < 2) {
        this.searchResults = [];
        return;
      }

      this.loading = true;
      fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/products?vatNumber=' + this.selectedLocation.inv_fiscal_code + '&name=' + encodeURIComponent(searchTerm) + '&externalCompanyId=' + this.companyID).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (Array.isArray(data.products)) {
          _this3.searchResults = data.products;
        } else {
          _this3.searchResults = [];
        }
      }).catch(function (err) {
        console.error('Error fetching products:', err);
        _this3.searchResults = [];
      }).finally(function () {
        _this3.loading = false;
      });
    },
    onInputSearch: function onInputSearch(searchTerm) {
      var _this4 = this;

      clearTimeout(this.onFetchProductsTimeout);
      this.onFetchProductsTimeout = setTimeout(function () {
        _this4.fetchProducts(searchTerm);
      }, 500);
    },
    onProductSelected: function onProductSelected(product) {
      if (product && (typeof product === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(product)) === 'object') {
        this.newItem.posId = product.posId || product._id;
        this.newItem.productName = product.name || '';
        this.newItem.code = product.product_code || '';
        this.newItem.unitMeasure = product.um || '';
        this.newItem.tva_percent = product.vat_percent || 0;
        this.newItem.pret_fara_tva = Array.isArray(product.pret_vanzare) && product.pret_vanzare.length > 0 ? product.pret_vanzare[0].price : 0;
      }
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this5.companyID);

              case 3:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context2.next = 8;
                return response.json();

              case 8:
                data = _context2.sent;

                console.log('Date primite de la server:', data.gestiuni);
                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this5.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      vatNumber: gest.vatNumber || '',
                      externalLocationId: gest.externalLocationId || null,
                      is_depozit: gest.is_depozit || false
                    };
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                    title: 'Error!',
                    text: 'Nu s-a primit un array valid de la server.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](0);

                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  title: 'Error!',
                  text: 'Request failed: ' + _context2.t0.message,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching management data:', _context2.t0);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[0, 13]]);
      }))();
    },
    getSeries: function getSeries(vatNumber) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, data, mappedSeries;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this6.companyID,
                    vatNumber: vatNumber,
                    tip: 'order'
                  })
                });

              case 3:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 6;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 6:
                _context3.next = 8;
                return response.json();

              case 8:
                data = _context3.sent;

                console.log('Serii primite:', data.series);

                if (Array.isArray(data.series)) {
                  mappedSeries = data.series.map(function (serie) {
                    return {
                      id: serie._id,
                      name: serie.series,
                      currentNumber: serie.currentNumber
                    };
                  });


                  _this6.seriesOptions = mappedSeries;
                } else {
                  console.error('Format invalid pentru series:', data);
                }
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](0);

                console.error('Error fetching series:', _context3.t0);

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 13]]);
      }))();
    },
    saveMyOrder: function saveMyOrder() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var selectedSerie, serieName, nextNumber, selectedGestiune, depositLocations, selectedDepositLocation, supplierVatNumber, supplierExternalLocationId, myOrderData, response, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!_this7.items || _this7.items.length === 0)) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Trebuie să adaugi cel puțin un produs înainte de a salva comanda.',
                  icon: 'warning',
                  timer: 2000,
                  showConfirmButton: true
                });

              case 3:
                return _context4.abrupt('return');

              case 4:
                selectedSerie = _this7.seriesOptions.find(function (serie) {
                  return serie.id === _this7.myOrder.serie || serie.name === _this7.myOrder.serie;
                });
                serieName = selectedSerie ? selectedSerie.name : _this7.myOrder.serie || null;
                nextNumber = selectedSerie && selectedSerie.currentNumber ? selectedSerie.currentNumber : _this7.myOrder.currentNumber || null;
                selectedGestiune = _this7.gestiuneOptions.find(function (gest) {
                  return gest.id === _this7.myOrder.gestiune;
                });
                depositLocations = _this7.locationsWithDepositGestiune || [];
                selectedDepositLocation = depositLocations.find(function (loc) {
                  return loc.true_id === _this7.selectedDepositLocationId;
                });
                supplierVatNumber = selectedDepositLocation ? selectedDepositLocation.inv_fiscal_code : null;
                supplierExternalLocationId = selectedDepositLocation ? selectedDepositLocation.true_id : null;
                myOrderData = {
                  status: _this7.isValidate ? 'validat' : _this7.isReception ? 'receptionat' : 'new',
                  externalDocIds: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_this7.myOrder.externalDocIds) === 'object' && _this7.myOrder.externalDocIds !== null ? _this7.myOrder.externalDocIds : {}),
                  products: _this7.items,
                  externalLocationId: _this7.selectedLocation.true_id,
                  vatNumber: _this7.selectedLocation.inv_fiscal_code,
                  externalCompanyId: _this7.companyID,
                  supplierExternalLocationId: supplierExternalLocationId,
                  supplierVatNumber: supplierVatNumber,
                  gestiune: selectedGestiune ? selectedGestiune.id : _this7.myOrder.gestiune,
                  series: serieName,
                  number: nextNumber,
                  date: _this7.myOrder.date ? new Date(_this7.myOrder.date).toISOString() : new Date().toISOString()
                };
                _context4.prev = 13;
                _context4.next = 16;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/order', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(myOrderData)
                });

              case 16:
                response = _context4.sent;
                _context4.next = 19;
                return response.json();

              case 19:
                data = _context4.sent;


                if (response.ok) {
                  console.log('Comanda salvată cu succes!', data);
                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                    title: 'Succes',
                    text: 'Comanda a fost salvată cu succes!',
                    type: 'success',
                    timer: 1500,
                    showConfirmButton: false
                  });

                  _this7.$bus.$emit('refresh');
                  _this7.$bus.$emit('close-modal');
                } else {
                  console.error('Eroare la salvarea comenzii', data);

                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                    title: 'Eroare',
                    text: 'A apărut o eroare la salvarea comenzii.',
                    type: 'error',
                    timer: 1500,
                    showConfirmButton: false
                  });
                }
                _context4.next = 27;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t0 = _context4['catch'](13);

                console.error('Eroare la trimiterea cererii', _context4.t0);

                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o problemă la trimiterea cererii.',
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                });

              case 27:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[13, 23]]);
      }))();
    },
    openAddProductModal: function openAddProductModal() {
      this.$modal.show('addProductModal');
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    fetchOrder: function fetchOrder(series, number) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, data, order, foundLocation, foundDepositLocation;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/order?series=' + series + '&number=' + number + '&externalCompanyId=' + _this8.companyID);

              case 3:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 6;
                  break;
                }

                throw new Error('Eroare la fetch order: ' + response.status);

              case 6:
                _context5.next = 8;
                return response.json();

              case 8:
                data = _context5.sent;


                console.log('Comandă primită:', data);

                if (data) {
                  order = data;


                  console.log('Order details:', order);

                  _this8.myOrder = {
                    date: order.date ? order.date.slice(0, 10) : '',
                    location_id: order.externalLocationId || null,
                    gestiune: order.gestiune || null,
                    serie: order.series || null,
                    externalDocIds: order.externalDocIds || {},
                    currentNumber: order.number || null,
                    supplierVatNumber: order.supplierVatNumber || '',
                    supplierExternalLocationId: order.supplierExternalLocationId || null,
                    vatNumber: order.vatNumber || '',

                    currency: _this8.myOrder.currency || 'RON',
                    manager: _this8.myOrder.manager || '',
                    receiver: _this8.myOrder.receiver || '',
                    internalNote: _this8.myOrder.internalNote || '',
                    commandProject: _this8.myOrder.commandProject || ''
                  };

                  _this8.items = order.products || [];

                  if (order.externalLocationId && _this8.locations && _this8.locations.length) {
                    foundLocation = _this8.locations.find(function (loc) {
                      return loc.true_id === order.externalLocationId;
                    });


                    if (!foundLocation && order.vatNumber) {
                      foundLocation = _this8.locations.find(function (loc) {
                        return loc.inv_fiscal_code === order.vatNumber;
                      });
                    }

                    if (foundLocation) {
                      _this8.selectedLocationId = foundLocation.true_id;
                    }
                  }

                  if (order.supplierExternalLocationId && _this8.locationsWithDepositGestiune && _this8.locationsWithDepositGestiune.length) {
                    foundDepositLocation = _this8.locationsWithDepositGestiune.find(function (loc) {
                      return loc.true_id === order.supplierExternalLocationId;
                    });

                    if (foundDepositLocation) {
                      _this8.selectedDepositLocationId = foundDepositLocation.true_id;
                    }
                  }

                  if (_this8.myOrder.gestiune && !_this8.gestiuneOptions.find(function (g) {
                    return g.id === _this8.myOrder.gestiune;
                  })) {
                    _this8.gestiuneOptions.push({
                      id: _this8.myOrder.gestiune,
                      name: _this8.myOrder.gestiune
                    });
                  }
                } else {
                  console.error('Comandă invalidă primită:', data);
                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                    title: 'Eroare',
                    text: 'Comanda nu a fost găsită.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context5.next = 17;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5['catch'](0);

                console.error('Eroare la fetch order:', _context5.t0);
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o problemă la încărcarea comenzii.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[0, 13]]);
      }))();
    }
  }
});

/***/ }),

/***/ "sSO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscriptions_vue__ = __webpack_require__("IIzT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb6666ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscriptions_vue__ = __webpack_require__("7Xe3");
function injectStyle (ssrContext) {
  __webpack_require__("6OhQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscriptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb6666ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscriptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sSZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaigns_vue__ = __webpack_require__("Ewy/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b7a3fe8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaigns_vue__ = __webpack_require__("8iMY");
function injectStyle (ssrContext) {
  __webpack_require__("mBL5")
  __webpack_require__("RG8w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b7a3fe8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChallengeCampaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b7a3fe8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChallengeCampaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sSci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.showScanner)?[_c('div',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('div',{staticClass:"col-md-6 col-sm-6"},[(_vm.client)?_c('div',{staticClass:"pull-left"},[(_vm.client.gender === 'F')?_c('img',{staticStyle:{"height":"141px","width":"141px"},attrs:{"src":"/static/img/woman.svg","alt":"Woman"}}):_c('img',{staticStyle:{"height":"141px","width":"141px"},attrs:{"src":"/static/img/man.svg","alt":"Man"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mar-lt-15"},[(_vm.client)?_c('div',[_c('h4',[_vm._v(_vm._s(_vm.client.name))])]):_vm._e(),_vm._v(" "),(_vm.client)?_c('div',{staticClass:"email"},[_c('h5',[_vm._v(_vm._s(_vm.client.email))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4"},[_c('div',{staticClass:"row"},[(_vm.client)?_c('div',[_c('h2',{staticClass:"mar-bt-0"},[_vm._v(_vm._s(_vm.client.points)+" pts.")])]):_vm._e(),_vm._v(" "),(_vm.client)?_c('div',[_c('h2',{staticClass:"mar-to-0"},[_c('small',[_vm._v("("+_vm._s(parseFloat(_vm.client.points_to_money).toFixed(2))+" "+_vm._s(_vm.company.currency)+")")])])]):_vm._e()])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12 flex-center"},[_c('div',{staticClass:"points-input",attrs:{"name":"minus-input"}},[_c('button',{on:{"click":function($event){_vm.subtract()}}},[_vm._v("-")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.points),expression:"points"}],staticClass:"points-input",attrs:{"type":"number"},domProps:{"value":(_vm.points)},on:{"input":function($event){if($event.target.composing){ return; }_vm.points=$event.target.value}}})]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.increment()}}},[_vm._v("+")])])])]),_vm._v(" "),(parseInt(_vm.points))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12 flex-center"},[_c('small',{staticClass:"points-input points-to-money"},[_vm._v(_vm._s(parseInt(_vm.points) / parseInt(_vm.company.loyalty_value_one_point_amount))+" "+_vm._s(_vm.company.currency))])])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12 flex-center"},[_c('div',{staticClass:"confirm-button"},[_c('button',{staticClass:"confirm-button",on:{"click":function($event){_vm.subtractPoints()}}},[_vm._v(_vm._s(_vm.$t('scanner.confirm')))])])])])]:_vm._e(),_vm._v(" "),(_vm.showScanner)?[_c('div',{staticClass:"card flex-center mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h4',{staticClass:"mar-to-15"},[_vm._v(_vm._s(_vm.$t('scanner.scanCode')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row flex-center",staticStyle:{"margin-top":"5%"}},[_c('div',{staticClass:"col-md-6 col-sm-12"},[_c('StreamBarcodeReader',{on:{"decode":_vm.onDecodeQr,"loaded":_vm.onLoaded}})],1)])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sT6j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block","width":"100%"}},[_c('div',{staticClass:"card card-map"},[_c('div',{staticClass:"card-header "},[_c('div',{staticClass:"row inline-100"},[_c('div',{staticClass:"col-lg-5 col-md-12"},[_c('label',{attrs:{"for":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('settingsZone.edit'))+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zone.name),expression:"zone.name"}],staticClass:"form-control ",class:{'is-invalid': _vm.nameInvalid},attrs:{"type":"text","placeholder":_vm.$t('settingsZone.edit')},domProps:{"value":(_vm.zone.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zone, "name", $event.target.value)}}})]),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.zone.delivery_range_cost_rules && _vm.zone.delivery_range_cost_rules.length == 0),expression:"zone.delivery_range_cost_rules && zone.delivery_range_cost_rules.length == 0"}]},[_c('span',[_vm._v(_vm._s(_vm.$t('settingsOrdering.shippingCost'))+" ("+_vm._s(_vm.currency)+"):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zone.shipping_cost),expression:"zone.shipping_cost"}],staticClass:"form-control ",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.zone.shipping_cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zone, "shipping_cost", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('catalogCateg.vat'))),_c('small',[_vm._v("("+_vm._s(_vm.$t('catalogCateg.included'))+")")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.zone.shipping_cost_vat_id),expression:"zone.shipping_cost_vat_id"}],staticClass:"form-control",staticStyle:{"width":"227.25px !important"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.zone, "shipping_cost_vat_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptionsForLocation),function(vat){return _c('option',{key:vat.id,attrs:{"id":vat.id},domProps:{"value":vat.id}},[_vm._v(_vm._s(vat.amount)+"\n              ")])}),_vm._v(" "),(_vm.zone.vat !== null)?_c('option',{staticStyle:{"display":"none"},domProps:{"value":_vm.zone.vat}},[_vm._v(_vm._s(_vm.zone.vat))]):_vm._e()],2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 col-md-0"}),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-md-12"},[(_vm.taxesVersion !== 2)?_c('div',{staticClass:"fields"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.zone.delivery_range_cost_rules && _vm.zone.delivery_range_cost_rules.length == 0),expression:"zone.delivery_range_cost_rules && zone.delivery_range_cost_rules.length == 0"}]},[_c('span',[_vm._v(_vm._s(_vm.$t('settingsOrdering.posId'))+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zone.shipping_pos_id),expression:"zone.shipping_pos_id"}],staticClass:"form-control ",attrs:{"type":"text"},domProps:{"value":(_vm.zone.shipping_pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zone, "shipping_pos_id", $event.target.value)}}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.zone.delivery_range_cost_rules && _vm.zone.delivery_range_cost_rules.length == 0),expression:"zone.delivery_range_cost_rules && zone.delivery_range_cost_rules.length == 0"}]},[_c('span',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minimumOrderValue'))+" ("+_vm._s(_vm.currency)+"):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zone.min_order_value),expression:"zone.min_order_value"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.zone.min_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zone, "min_order_value", $event.target.value)}}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.zone.delivery_range_cost_rules && _vm.zone.delivery_range_cost_rules.length == 0),expression:"zone.delivery_range_cost_rules && zone.delivery_range_cost_rules.length == 0"}]},[_c('span',[_vm._v(_vm._s(_vm.$t('settingsOrdering.extraDeliveryTime'))+" ("+_vm._s(_vm.$t('general.minutes'))+"):")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({min: 0}),expression:"{min: 0}"},{name:"model",rawName:"v-model",value:(_vm.zone.extra_delivery_time),expression:"zone.extra_delivery_time"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('general.minutes')},domProps:{"value":(_vm.zone.extra_delivery_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.zone, "extra_delivery_time", $event.target.value)}}})])]):_vm._e()]),_vm._v(" "),(_vm.taxesVersion !== 2 && _vm.googleMapsapiKey)?_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"card",staticStyle:{"box-shadow":"none","border":"1px solid #dcdfe6"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('div',{staticClass:"col-md-12 display-flex align-items-center justify-content-space-between"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingsOrdering.extraCostRange')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-icon ",attrs:{"title":_vm.$t('general.add')  + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.addCostRules()}}},[_c('i',{staticClass:"ti-plus"})])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":_vm.$t('catalogProdOpt.plural')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.zone.delivery_range_cost_rules && _vm.zone.delivery_range_cost_rules.length == 0)?_c('p',{},[_vm._v("No options added yet.")]):_vm._e(),_vm._v(" "),_c('el-collapse',{ref:"elColl",attrs:{"accordion":""},model:{value:(_vm.zoneCostRulesIndex),callback:function ($$v) {_vm.zoneCostRulesIndex=$$v},expression:"zoneCostRulesIndex"}},_vm._l((_vm.visibleCostRanges),function(item){return _c('div',{key:item.costRange.id || item.idxO,staticClass:"align"},[_c('el-collapse-item',{staticClass:"customItem",attrs:{"title":_vm.$t('settingsOrdering.panaLa') + item.costRange.distance_in_km + ' km',"name":item.idxO}},[_c('div',{staticClass:"clearfix"},[_c('hr',{staticClass:"no-margin mar-bt-15"})]),_vm._v(" "),_c('div',{staticClass:"boxCostRange"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('settingsOrdering.distanceInKm'))+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.costRange.distance_in_km),expression:"item.costRange.distance_in_km"}],staticClass:"form-control",class:{'is-invalid': _vm.costRangeDistanceHasError(item.idxO, item.costRange)},attrs:{"type":"number","min":"0","required":""},domProps:{"value":(item.costRange.distance_in_km)},on:{"blur":function($event){_vm.touchCostRangeDistance(item.idxO, item.costRange)},"input":[function($event){if($event.target.composing){ return; }_vm.$set(item.costRange, "distance_in_km", $event.target.value)},function($event){_vm.validateCostRangeDistance(item.idxO, item.costRange)}]}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('settingsOrdering.shippingCost'))+" ("+_vm._s(_vm.currency)+"):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.costRange.shipping_cost),expression:"item.costRange.shipping_cost"}],staticClass:"form-control ",attrs:{"type":"number","min":"0"},domProps:{"value":(item.costRange.shipping_cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item.costRange, "shipping_cost", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('settingsOrdering.posId'))+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.costRange.shipping_pos_id),expression:"item.costRange.shipping_pos_id"}],staticClass:"form-control ",attrs:{"type":"text"},domProps:{"value":(item.costRange.shipping_pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item.costRange, "shipping_pos_id", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minimumOrderValue'))+" ("+_vm._s(_vm.currency)+"):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.costRange.min_order_value),expression:"item.costRange.min_order_value"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(item.costRange.min_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item.costRange, "min_order_value", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('settingsOrdering.extraDeliveryTime'))+" ("+_vm._s(_vm.$t('general.minutes'))+"):")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({min: 0}),expression:"{min: 0}"},{name:"model",rawName:"v-model",value:(item.costRange.extra_delivery_time),expression:"item.costRange.extra_delivery_time"}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('general.minutes')},domProps:{"value":(item.costRange.extra_delivery_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item.costRange, "extra_delivery_time", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"closeBtn"},[_c('button',{staticClass:"btn btn-danger pull-left btn-icon mar-15",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteCostRules(item.idxO)}}},[_c('i',{staticClass:"ti-close"})])])],1)}))],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15 pad-bt-10"})])])])])])])]):_vm._e(),_vm._v(" "),(_vm.taxesVersion === 2)?_c('div',{staticClass:"col-lg-12 col-md-12 delivery-tax-zone-wrap"},[(_vm.zone && _vm.zone.id)?_c('delivery-tax-panel',{attrs:{"location-id":_vm.location_id,"delivery-range-id":_vm.zone && _vm.zone.id,"currency":_vm.currency}}):_c('div',{staticClass:"delivery-tax-zone-save-first"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Salvează zona înainte să îi atribui taxe de livrare.")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12 mar-to-15"},[_c('div',{staticClass:"form-group override-payment text-left"},[_c('div',{staticClass:"checkbox mar-bt-20"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zone.override_payment_method),expression:"zone.override_payment_method"}],attrs:{"type":"checkbox","id":_vm.bussLocationId + '_' + _vm.indexZone + '_override_payment'},domProps:{"checked":Array.isArray(_vm.zone.override_payment_method)?_vm._i(_vm.zone.override_payment_method,null)>-1:(_vm.zone.override_payment_method)},on:{"change":[function($event){var $$a=_vm.zone.override_payment_method,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.zone, "override_payment_method", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.zone, "override_payment_method", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.zone, "override_payment_method", $$c)}},_vm.emitZoneUpdate]}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.bussLocationId + '_' + _vm.indexZone + '_override_payment'}},[_vm._v(_vm._s(_vm.$t('settingsZone.overridePayment')))])]),_vm._v(" "),(_vm.zone.override_payment_method)?[_c('div',{staticClass:"checkbox mar-bt-20"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zone.accept_cash),expression:"zone.accept_cash"}],attrs:{"type":"checkbox","id":_vm.bussLocationId + '_' + _vm.indexZone + '_accept_cash'},domProps:{"checked":Array.isArray(_vm.zone.accept_cash)?_vm._i(_vm.zone.accept_cash,null)>-1:(_vm.zone.accept_cash)},on:{"change":[function($event){var $$a=_vm.zone.accept_cash,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.zone, "accept_cash", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.zone, "accept_cash", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.zone, "accept_cash", $$c)}},_vm.emitZoneUpdate]}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.bussLocationId + '_' + _vm.indexZone + '_accept_cash'}},[_vm._v(_vm._s(_vm.$t('settingsZone.acceptCash')))])]),_vm._v(" "),_c('div',{staticClass:"checkbox mar-bt-20"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zone.accept_card),expression:"zone.accept_card"}],attrs:{"type":"checkbox","id":_vm.bussLocationId + '_' + _vm.indexZone + '_accept_card'},domProps:{"checked":Array.isArray(_vm.zone.accept_card)?_vm._i(_vm.zone.accept_card,null)>-1:(_vm.zone.accept_card)},on:{"change":[function($event){var $$a=_vm.zone.accept_card,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.zone, "accept_card", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.zone, "accept_card", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.zone, "accept_card", $$c)}},_vm.emitZoneUpdate]}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.bussLocationId + '_' + _vm.indexZone + '_accept_card'}},[_vm._v(_vm._s(_vm.$t('settingsZone.acceptCard')))])]),_vm._v(" "),_c('div',{staticClass:"checkbox mar-bt-20"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zone.accept_pos),expression:"zone.accept_pos"}],attrs:{"type":"checkbox","id":_vm.bussLocationId + '_' + _vm.indexZone + '_accept_pos'},domProps:{"checked":Array.isArray(_vm.zone.accept_pos)?_vm._i(_vm.zone.accept_pos,null)>-1:(_vm.zone.accept_pos)},on:{"change":[function($event){var $$a=_vm.zone.accept_pos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.zone, "accept_pos", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.zone, "accept_pos", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.zone, "accept_pos", $$c)}},_vm.emitZoneUpdate]}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.bussLocationId + '_' + _vm.indexZone + '_accept_pos'}},[_vm._v(_vm._s(_vm.$t('settingsZone.acceptPos')))])])]:_vm._e()],2),_vm._v(" "),(_vm.selectedShape)?_c('button',{staticClass:"btn btn-danger btn-fill pull-right",on:{"click":function($event){$event.preventDefault();return _vm.deleteSelectedShape($event)}}},[_vm._v(_vm._s(_vm.$t('settingsZone.deleteShape')))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"full-screen-map",attrs:{"id":'map_'+_vm.indexZone+'_'+_vm.bussLocationId}})]),_vm._v(" "),(!_vm.hideDeleteZone)?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-danger btn-fill",on:{"click":function($event){$event.preventDefault();_vm.deleteZone(_vm.indexZone)}}},[_vm._v(_vm._s(_vm.$t('settingsZone.deleteBtn')))])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 pad-lf-0 pad-rg-0"},[_c('hr',{staticClass:"sm"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sUtm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      onSeriesInputTimeout: null,
      tableData: [],
      allLocations: [],
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      filter: {
        series: ''
      },
      vatNumber: null,
      selectedLocation: null,
      spvStatusRefreshInProgress: false
    };
  },

  computed: {
    hasNexusLocation: function hasNexusLocation() {
      var defaultData = this.$session.get('defaultData') || {};
      return !!defaultData.has_nexus_location;
    }
  },
  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.$bus.$on('refresh', this.handleRefresh);
  },
  mounted: function mounted() {
    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.getInvoices(this.filter.series || '', 'invoice', { locations: this.allLocations });
    },
    onSearch: function onSearch() {
      if (!this.selectedLocation || Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0) {
        __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        });

        this.tableData = [];
        this.totalItems = 0;

        return;
      }

      var locations = Array.isArray(this.selectedLocation) ? this.selectedLocation : [this.selectedLocation];
      this.getInvoices(this.filter.series || '', 'invoice', { locations: locations });
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getInvoices(this.filter.series || '', 'invoice', this.selectedLocation, this.currentPage, this.pageSize);
    },
    onSeriesInput: function onSeriesInput(value) {
      this.filter.series = value;
    },
    addInvoice: function addInvoice() {
      this.$router.push('/invoice-tabs/invoice/add');
    },
    promptSpvInboxDays: function promptSpvInboxDays(titleKey) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
        var daysResult, hasSwalShape, zile;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.companyID) {
                  _context.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this.$t('general.error'),
                  text: 'Lipsește compania selectată.',
                  confirmButtonText: 'OK'
                });
                return _context.abrupt('return', null);

              case 3:
                if (!(!_this.selectedLocation || !_this.selectedLocation.inv_fiscal_code)) {
                  _context.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'warning',
                  title: _this.$t('general.required'),
                  text: 'Selectați o locație cu CIF fiscal pentru preluarea mesajelor SPV.',
                  confirmButtonText: 'OK'
                });
                return _context.abrupt('return', null);

              case 6:
                _context.next = 8;
                return _this.openSpvSwal({
                  title: ' ',
                  html: '\n          <div class="spv-prompt-card">\n            <div class="spv-prompt-header">\n              <span class="spv-prompt-logo">SPV</span>\n              <div>\n                <p class="spv-prompt-title">' + _this.escapeHtml(_this.$t(titleKey)) + '</p>\n                <p class="spv-prompt-subtitle">' + _this.escapeHtml(_this.$t('gestiune.fetchInvoiceDaysLabel')) + '</p>\n              </div>\n            </div>\n            <select id="spv-inbox-days" class="spv-prompt-select form-control">\n              <option value="1">1 zi</option>\n              <option value="7" selected>7 zile</option>\n              <option value="15">15 zile</option>\n              <option value="30">30 zile</option>\n            </select>\n          </div>\n        ',
                  type: 'question',
                  customClass: 'spv-swal spv-swal--prompt',
                  showCancelButton: true,
                  confirmButtonText: _this.$t(titleKey),
                  cancelButtonText: _this.$t('general.cancel') || 'Anulează',
                  focusConfirm: false,
                  preConfirm: function preConfirm() {
                    var select = document.getElementById('spv-inbox-days');
                    var value = select ? Number(select.value) : 0;

                    if (![1, 7, 15, 30].includes(value)) {
                      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise___default.a.reject(_this.$t('gestiune.fetchInvoiceDaysInvalid'));
                    }

                    return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise___default.a.resolve(value);
                  }
                });

              case 8:
                daysResult = _context.sent;

                if (!(daysResult === undefined || daysResult === null)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return', null);

              case 11:
                hasSwalShape = (typeof daysResult === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(daysResult)) === 'object' && (Object.prototype.hasOwnProperty.call(daysResult, 'value') || Object.prototype.hasOwnProperty.call(daysResult, 'dismiss'));

                if (!(hasSwalShape && daysResult.dismiss)) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt('return', null);

              case 14:
                zile = hasSwalShape ? daysResult.value : daysResult;

                if (zile) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt('return', null);

              case 17:
                return _context.abrupt('return', Number(zile));

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    openSpvSwal: function openSpvSwal() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var defaults = {
        confirmButtonText: 'OK',
        customClass: 'spv-swal',
        confirmButtonClass: 'spv-swal-btn spv-swal-btn--confirm',
        cancelButtonClass: 'spv-swal-btn spv-swal-btn--cancel',
        buttonsStyling: false
      };

      return __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, defaults, options));
    },
    showSpvSimpleAlert: function showSpvSimpleAlert(type, title, text) {
      return this.openSpvSwal({
        type: type,
        title: title,
        text: text,
        customClass: 'spv-swal spv-swal--' + (type || 'info')
      });
    },
    buildSpvInboxQueryParams: function buildSpvInboxQueryParams(zile) {
      return new URLSearchParams({
        externalCompanyId: this.companyID,
        zile: String(zile),
        cif: this.normalizeCif(this.selectedLocation.inv_fiscal_code),
        mode: this.getSpvMode()
      });
    },
    formatSpvInboxDate: function formatSpvInboxDate(value) {
      var raw = String(value || '');
      if (raw.length < 12) return raw;

      var year = raw.slice(0, 4);
      var month = raw.slice(4, 6);
      var day = raw.slice(6, 8);
      var hour = raw.slice(8, 10);
      var minute = raw.slice(10, 12);

      return day + '.' + month + '.' + year + ', ' + hour + ':' + minute;
    },
    extractSpvInboxMessages: function extractSpvInboxMessages(data) {
      if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(data)) !== 'object') return [];
      if (Array.isArray(data)) return data;
      if (Array.isArray(data.mesaje)) return data.mesaje;
      if (Array.isArray(data.messages)) return data.messages;
      if (Array.isArray(data.items)) return data.items;
      if (Array.isArray(data.data)) return data.data;
      return [];
    },
    getSpvInboxTipClass: function getSpvInboxTipClass(tip) {
      var value = String(tip || '').toUpperCase();
      if (value.includes('EROARE') || value.includes('ERORI')) return 'spv-inbox-tip--error';
      if (value.includes('PRIMIT') || value === 'P') return 'spv-inbox-tip--received';
      if (value.includes('TRIMIS') || value === 'T') return 'spv-inbox-tip--sent';
      return 'spv-inbox-tip--default';
    },
    buildSpvInboxMessageRowHtml: function buildSpvInboxMessageRowHtml(message) {
      var tip = message.tip || message.type || '-';
      var tipClass = this.getSpvInboxTipClass(tip);
      var messageId = message.id || message.anafMessageId || message.messageId || '';

      return '\n        <tr>\n          <td>' + this.escapeHtml(this.formatSpvInboxDate(message.data_creare || message.data || message.date)) + '</td>\n          <td><span class="spv-inbox-tip ' + tipClass + '">' + this.escapeHtml(String(tip)) + '</span></td>\n          <td>' + this.escapeHtml(String(message.id || '-')) + '</td>\n          <td>' + this.escapeHtml(String(message.id_solicitare || message.id_incarcare || '-')) + '</td>\n          <td class="spv-inbox-details">' + this.escapeHtml(String(message.detalii || message.details || '-')) + '</td>\n          <td class="spv-inbox-actions">\n            <button\n              type="button"\n              class="spv-inbox-download-btn"\n              data-message-id="' + this.escapeHtml(String(messageId)) + '"\n              ' + (messageId ? '' : 'disabled') + '\n            >\n              ' + this.escapeHtml(this.$t('gestiune.downloadSpvMessage')) + '\n            </button>\n          </td>\n        </tr>\n      ';
    },
    buildSpvInboxMessagesHtml: function buildSpvInboxMessagesHtml(data, zile) {
      var _this2 = this;

      var messages = this.extractSpvInboxMessages(data);
      var total = data.total != null ? data.total : messages.length;
      var title = data.titlu || data.title || 'Lista mesaje';
      var infoMessage = data.eroare || data.message || null;

      if (!messages.length) {
        return '\n          <div class="spv-inbox-card">\n            <div class="spv-inbox-header spv-inbox-header--empty">\n              <span class="spv-inbox-logo">SPV</span>\n              <div>\n                <p class="spv-inbox-title">' + this.escapeHtml(title) + '</p>\n                <div class="spv-inbox-chips">\n                  <span class="spv-inbox-chip">Total: 0</span>\n                  <span class="spv-inbox-chip spv-inbox-chip--muted">' + zile + ' zile</span>\n                </div>\n              </div>\n            </div>\n            ' + (infoMessage ? '<div class="spv-inbox-empty-msg">' + this.escapeHtml(infoMessage) + '</div>' : '') + '\n          </div>\n        ';
      }

      var rows = messages.map(function (message) {
        return _this2.buildSpvInboxMessageRowHtml(message);
      }).join('');

      return '\n        <div class="spv-inbox-card">\n          <div class="spv-inbox-header">\n            <span class="spv-inbox-logo">SPV</span>\n            <div>\n              <p class="spv-inbox-title">' + this.escapeHtml(title) + '</p>\n              <div class="spv-inbox-chips">\n                <span class="spv-inbox-chip spv-inbox-chip--primary">' + total + ' mesaje</span>\n                <span class="spv-inbox-chip spv-inbox-chip--muted">Ultimele ' + zile + ' zile</span>\n              </div>\n            </div>\n          </div>\n          <div class="spv-inbox-table-wrap">\n            <table class="spv-inbox-table">\n              <thead>\n                <tr>\n                  <th>Data</th>\n                  <th>Tip</th>\n                  <th>ID mesaj</th>\n                  <th>ID \xEEnc\u0103rcare</th>\n                  <th>Detalii</th>\n                  <th>Ac\u021Biuni</th>\n                </tr>\n              </thead>\n              <tbody>' + rows + '</tbody>\n            </table>\n          </div>\n        </div>\n      ';
    },
    buildSpvInboxDownloadBaseUrl: function buildSpvInboxDownloadBaseUrl(messageId) {
      return this.getEfacturaBaseUrl() + '/efactura/inbox/messages/' + encodeURIComponent(messageId) + '/download';
    },
    buildSpvInboxDownloadQueryParams: function buildSpvInboxDownloadQueryParams() {
      var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var params = new URLSearchParams({
        externalCompanyId: this.companyID,
        cif: this.normalizeCif(this.selectedLocation.inv_fiscal_code),
        mode: this.getSpvMode()
      });

      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(extra).forEach(function (key) {
        params.set(key, extra[key]);
      });

      return params;
    },
    buildEfacturaPurchasePdfBaseUrl: function buildEfacturaPurchasePdfBaseUrl(invoiceId) {
      return this.getEfacturaBaseUrl() + '/efactura/invoice/pdf/' + encodeURIComponent(invoiceId);
    },
    buildEfacturaPurchasePdfQueryParams: function buildEfacturaPurchasePdfQueryParams() {
      var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var params = new URLSearchParams({
        externalCompanyId: this.companyID,
        cif: this.normalizeCif(this.selectedLocation.inv_fiscal_code),
        mode: this.getSpvMode()
      });

      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(extra).forEach(function (key) {
        params.set(key, extra[key]);
      });

      return params;
    },
    formatEfacturaErrorMessage: function formatEfacturaErrorMessage(msg) {
      var text = String(msg || '').trim();
      if (!text) return 'A apărut o eroare.';

      if (/no anaf access token/i.test(text)) {
        return 'Nu există token SPV activ pentru compania/CIF-ul selectat. Activați tokenul din Setări Gestiune > Operațiuni generale.';
      }

      return text;
    },
    handleSpvInboxDownloadResponse: function handleSpvInboxDownloadResponse(url, errorTitle) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, dataText, parsed, msg, anafObj;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch(url, { method: 'GET' });

              case 2:
                response = _context2.sent;
                _context2.next = 5;
                return response.text();

              case 5:
                dataText = _context2.sent;
                parsed = null;

                try {
                  parsed = JSON.parse(dataText);
                } catch (e) {
                  parsed = null;
                }

                if (!(!response.ok || parsed && parsed.error)) {
                  _context2.next = 14;
                  break;
                }

                msg = 'A apărut o eroare.';


                if (parsed && parsed.anaf_error) {
                  try {
                    anafObj = JSON.parse(parsed.anaf_error);

                    if (anafObj && anafObj.eroare) msg = anafObj.eroare;
                  } catch (e) {}
                } else if (parsed && parsed.error) {
                  msg = parsed.error;
                } else if (parsed && parsed.eroare) {
                  msg = parsed.eroare;
                } else if (parsed && parsed.message) {
                  msg = parsed.message;
                }

                msg = _this3.formatEfacturaErrorMessage(msg);

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: errorTitle || _this3.$t('general.error'),
                  text: msg,
                  type: 'error',
                  showConfirmButton: true,
                  confirmButtonText: 'OK',
                  confirmButtonClass: 'spv-swal-btn spv-swal-btn--confirm',
                  customClass: 'spv-swal spv-swal--error spv-swal--toast'
                });

                return _context2.abrupt('return', null);

              case 14:
                return _context2.abrupt('return', parsed);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    bindSpvInboxDownloadButtons: function bindSpvInboxDownloadButtons() {
      var _this4 = this;

      var buttons = document.querySelectorAll('.spv-inbox-download-btn');

      buttons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          var messageId = button.getAttribute('data-message-id');
          if (messageId) _this4.downloadSpvInboxMessage(messageId);
        });
      });
    },
    downloadSpvInboxMessage: function downloadSpvInboxMessage(messageId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var base, checkUrl, result, downloadUrl;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (messageId) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                if (!(!_this5.companyID || !_this5.selectedLocation || !_this5.selectedLocation.inv_fiscal_code)) {
                  _context3.next = 5;
                  break;
                }

                _this5.showSpvSimpleAlert('warning', _this5.$t('general.required'), 'Selectați o locație cu CIF fiscal pentru descărcare.');
                return _context3.abrupt('return');

              case 5:
                _context3.prev = 5;
                base = _this5.buildSpvInboxDownloadBaseUrl(messageId);
                checkUrl = base + '?' + _this5.buildSpvInboxDownloadQueryParams({ check: '1' }).toString();
                _context3.next = 10;
                return _this5.handleSpvInboxDownloadResponse(checkUrl, 'Eroare descărcare');

              case 10:
                result = _context3.sent;

                if (result) {
                  _context3.next = 13;
                  break;
                }

                return _context3.abrupt('return');

              case 13:
                if (!(result.status === true)) {
                  _context3.next = 17;
                  break;
                }

                downloadUrl = base + '?' + _this5.buildSpvInboxDownloadQueryParams({ download: '1' }).toString();

                window.open(downloadUrl, '_blank');
                return _context3.abrupt('return');

              case 17:

                _this5.showSpvSimpleAlert('error', _this5.$t('general.error'), result.message || result.eroare || 'Descărcarea nu este disponibilă.');
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3['catch'](5);

                console.error('Error downloading SPV inbox message:', _context3.t0);
                _this5.showSpvSimpleAlert('error', _this5.$t('general.error'), _context3.t0.message || 'Eroare neașteptată la descărcare.');

              case 24:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[5, 20]]);
      }))();
    },
    fetchSpvInboxMessages: function fetchSpvInboxMessages() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var zile, url, response, data, messages, infoMessage;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this6.promptSpvInboxDays('gestiune.fetchSpvMessages');

              case 2:
                zile = _context4.sent;

                if (zile) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt('return');

              case 5:
                url = _this6.getEfacturaBaseUrl() + '/efactura/inbox/messages?' + _this6.buildSpvInboxQueryParams(zile).toString();
                _context4.prev = 6;

                _this6.loading = true;

                _context4.next = 10;
                return fetch(url);

              case 10:
                response = _context4.sent;
                _context4.next = 13;
                return _this6.parseEfacturaResponseBody(response);

              case 13:
                data = _context4.sent;
                messages = _this6.extractSpvInboxMessages(data);
                infoMessage = data.eroare || data.message || null;

                if (response.ok) {
                  _context4.next = 18;
                  break;
                }

                throw new Error(infoMessage || data.error || 'Preluarea mesajelor SPV a eșuat.');

              case 18:

                _this6.openSpvSwal({
                  title: ' ',
                  html: _this6.buildSpvInboxMessagesHtml(data, zile),
                  customClass: 'spv-swal spv-swal--inbox' + (messages.length ? '' : ' spv-swal--inbox-empty'),
                  width: messages.length > 0 ? 1040 : 520,
                  onOpen: function onOpen() {
                    _this6.bindSpvInboxDownloadButtons();
                  }
                });
                _context4.next = 25;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4['catch'](6);

                console.error('Error fetching SPV inbox messages:', _context4.t0);
                _this6.showSpvSimpleAlert('error', _this6.$t('general.error'), _context4.t0.message || 'Eroare la preluarea mesajelor SPV.');

              case 25:
                _context4.prev = 25;

                _this6.loading = false;
                return _context4.finish(25);

              case 28:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[6, 21, 25, 28]]);
      }))();
    },
    fetchSpvInboxImport: function fetchSpvInboxImport() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var zile, url, response, data, importedCount, infoMessage;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this7.promptSpvInboxDays('gestiune.fetchInvoice');

              case 2:
                zile = _context5.sent;

                if (zile) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt('return');

              case 5:
                url = _this7.getEfacturaBaseUrl() + '/efactura/inbox/import?' + _this7.buildSpvInboxQueryParams(zile).toString();
                _context5.prev = 6;

                _this7.loading = true;

                _context5.next = 10;
                return fetch(url);

              case 10:
                response = _context5.sent;
                _context5.next = 13;
                return _this7.parseEfacturaResponseBody(response);

              case 13:
                data = _context5.sent;

                if (response.ok) {
                  _context5.next = 16;
                  break;
                }

                throw new Error(data.eroare || data.message || data.error || 'Importul facturilor SPV a eșuat.');

              case 16:
                importedCount = data.imported && data.imported.length || 0;
                infoMessage = data.eroare || data.message || null;


                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: importedCount > 0 ? 'success' : 'info',
                  title: data.titlu || data.title || _this7.$t('gestiune.fetchInvoice'),
                  html: '\n            <div style="text-align:left;">\n              ' + (infoMessage ? '<p>' + _this7.escapeHtml(infoMessage) + '</p>' : '') + '\n              <p><b>Importate:</b> ' + importedCount + '</p>\n              <p><b>S\u0103rite:</b> ' + (data.skipped && data.skipped.length || 0) + '</p>\n              <p><b>Zile:</b> ' + zile + '</p>\n            </div>\n          ',
                  confirmButtonText: 'OK'
                });
                _context5.next = 25;
                break;

              case 21:
                _context5.prev = 21;
                _context5.t0 = _context5['catch'](6);

                console.error('Error importing SPV inbox messages:', _context5.t0);
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this7.$t('general.error'),
                  text: _context5.t0.message || 'Eroare la importul facturilor SPV.',
                  confirmButtonText: 'OK'
                });

              case 25:
                _context5.prev = 25;

                _this7.loading = false;
                return _context5.finish(25);

              case 28:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[6, 21, 25, 28]]);
      }))();
    },
    addStorno: function addStorno(invoiceNumber, series) {
      if (!invoiceNumber || !series) {
        console.error('Missing invoice number or series');
        return;
      }

      var stornoId = series + '-' + invoiceNumber;
      this.$router.push('/invoice-tabs/invoice/storno/' + stornoId);
    },
    editInvoice: function editInvoice(invoiceNumber, series) {
      if (!invoiceNumber || !series) {
        console.error('Missing invoice number or series');
        return;
      }

      var stornoId = series + '-' + invoiceNumber;
      this.$router.push('/invoice-tabs/invoice/edit/' + stornoId);
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (!cellValue) return '';
      return new Date(cellValue).toLocaleDateString();
    },
    parseOrderInfoFromObservatiiText: function parseOrderInfoFromObservatiiText(text) {
      if (!text) return null;

      var value = String(text).trim();
      if (!value) return null;

      try {
        var parsed = JSON.parse(value);
        if (parsed && (typeof parsed === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(parsed)) === 'object') {
          var hasOrderInfo = !!(parsed.orderDate || parsed.orderNumber || parsed.bonData || parsed.bonNumber);

          if (hasOrderInfo) {
            return {
              orderDate: parsed.orderDate || '',
              orderNumber: parsed.orderNumber != null ? String(parsed.orderNumber) : '',
              bonData: parsed.bonData || '',
              bonNumber: parsed.bonNumber || ''
            };
          }
        }
      } catch (e) {}

      var orderMatch = value.match(/Comand[aă]\s+nr\.\s*(\d+)\s+din\s+([^\n.]+)/i);
      var bonMatch = value.match(/Bon fiscal\s+NR\s*([^/]+)\s*\/\s*Z\s*(\S+)\s+din\s+([^\n.]+)/i);

      if (!orderMatch && !bonMatch) return null;

      return {
        orderDate: orderMatch ? orderMatch[2].trim() : '',
        orderNumber: orderMatch ? String(orderMatch[1]) : '',
        bonData: bonMatch ? bonMatch[3].trim() : '',
        bonNumber: bonMatch ? 'NR: ' + bonMatch[1].trim() + ' Z: ' + bonMatch[2].trim() : ''
      };
    },
    parseOrderInfoFromNotaInterna: function parseOrderInfoFromNotaInterna(notaInterna) {
      return this.parseOrderInfoFromObservatiiText(notaInterna);
    },
    formatPaymentTypeLabel: function formatPaymentTypeLabel(paymentType) {
      if (!paymentType) return '';

      var key = 'paymentTypes.' + paymentType;
      var translated = this.$t(key);
      return translated !== key ? translated : paymentType;
    },
    extractPaymentTypeFromInvoice: function extractPaymentTypeFromInvoice(invoice) {
      var extraFieldsMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!invoice) {
        return extraFieldsMap.paymentType || extraFieldsMap.payment_type || '';
      }

      return invoice.paymentType || invoice.payment_type || extraFieldsMap.paymentType || extraFieldsMap.payment_type || '';
    },
    extractOrderInfoFromInvoice: function extractOrderInfoFromInvoice(invoice) {
      if (!invoice) {
        return {
          orderDate: '',
          orderNumber: '',
          bonData: '',
          bonNumber: '',
          paymentType: ''
        };
      }

      var extraFieldsMap = {};
      if (Array.isArray(invoice.extraFields)) {
        extraFieldsMap = invoice.extraFields.reduce(function (acc, field) {
          acc[field.key] = field.value;
          return acc;
        }, {});
      }

      var result = null;

      var fromBonNota = this.parseOrderInfoFromObservatiiText(invoice.bonNota);
      if (fromBonNota) {
        result = fromBonNota;
      } else if (invoice.orderDate || invoice.orderNumber || invoice.bonData || invoice.bonNumber) {
        result = {
          orderDate: invoice.orderDate || '',
          orderNumber: invoice.orderNumber != null ? String(invoice.orderNumber) : '',
          bonData: invoice.bonData || '',
          bonNumber: invoice.bonNumber || ''
        };
      } else {
        var fromObservatii = this.parseOrderInfoFromObservatiiText(extraFieldsMap.observatiiFactura || extraFieldsMap.observatiiComanda);
        if (fromObservatii) {
          result = fromObservatii;
        } else {
          var fromNotaInterna = this.parseOrderInfoFromObservatiiText(extraFieldsMap.notaInterna);
          if (fromNotaInterna) {
            result = fromNotaInterna;
          } else {
            result = {
              orderDate: invoice.orderDate || extraFieldsMap.orderDate || '',
              orderNumber: invoice.orderNumber != null ? String(invoice.orderNumber) : extraFieldsMap.orderNumber || '',
              bonData: invoice.bonData || extraFieldsMap.bonData || '',
              bonNumber: invoice.bonNumber || extraFieldsMap.bonNumber || ''
            };
          }
        }
      }

      result.paymentType = this.extractPaymentTypeFromInvoice(invoice, extraFieldsMap);
      return result;
    },
    applyOrderInfoToRow: function applyOrderInfoToRow(row, invoice) {
      var orderInfo = this.extractOrderInfoFromInvoice(invoice);

      row.orderDate = orderInfo.orderDate;
      row.orderNumber = orderInfo.orderNumber;
      row.bonData = orderInfo.bonData;
      row.bonNumber = orderInfo.bonNumber;
      row.paymentType = orderInfo.paymentType;
      row.orderInfoDisplay = orderInfo.orderNumber || orderInfo.bonNumber || '';
      row.hasOrderInfo = !!(orderInfo.orderDate || orderInfo.orderNumber || orderInfo.bonData || orderInfo.bonNumber || orderInfo.paymentType);

      return row;
    },
    ensureOrderInfo: function ensureOrderInfo(row) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var url, response, result, data;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!row || row._orderInfoLoading)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return', row);

              case 2:
                if (!(row.hasOrderInfo && row.paymentType)) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt('return', row);

              case 4:

                row._orderInfoLoading = true;

                _context6.prev = 5;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/getDocument/?tip=invoice&series=' + encodeURIComponent(row.series) + '&number=' + encodeURIComponent(row.invoiceNumber) + '&externalCompanyId=' + _this8.companyID;
                _context6.next = 9;
                return fetch(url);

              case 9:
                response = _context6.sent;

                if (response.ok) {
                  _context6.next = 12;
                  break;
                }

                return _context6.abrupt('return', row);

              case 12:
                _context6.next = 14;
                return response.json();

              case 14:
                result = _context6.sent;
                data = result.documents && result.documents.length ? result.documents[0] : result.document || result;


                if (data && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(data)) === 'object') {
                  _this8.applyOrderInfoToRow(row, data);
                  row.rawInvoice = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, row.rawInvoice || {}, data);
                }
                _context6.next = 22;
                break;

              case 19:
                _context6.prev = 19;
                _context6.t0 = _context6['catch'](5);

                console.error('Error loading invoice order info:', _context6.t0);

              case 22:
                _context6.prev = 22;

                row._orderInfoLoading = false;
                return _context6.finish(22);

              case 25:
                return _context6.abrupt('return', row);

              case 26:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[5, 19, 22, 25]]);
      }))();
    },
    buildOrderInfoHtml: function buildOrderInfoHtml(row) {
      var rows = [row.orderDate ? this.buildEfacturaDetailRow('Data comandă', row.orderDate) : '', row.orderNumber ? this.buildEfacturaDetailRow('Nr. comandă', '#' + row.orderNumber) : '', row.bonData ? this.buildEfacturaDetailRow('Data bon', row.bonData) : '', row.bonNumber ? this.buildEfacturaDetailRow('Bon fiscal', row.bonNumber) : '', row.paymentType ? this.buildEfacturaDetailRow('Plată', this.formatPaymentTypeLabel(row.paymentType) + ' (' + row.paymentType + ')') : ''].filter(Boolean).join('');

      return '\n        <div class="invoice-order-info-card">\n          <div class="invoice-order-info-card-header">\n            <span class="invoice-order-info-card-icon"><i class="ti-receipt"></i></span>\n            <div>\n              <p class="invoice-order-info-card-title">Informa\u021Bii comand\u0103</p>\n              <p class="invoice-order-info-card-subtitle">Factur\u0103 ' + this.escapeHtml(row.series + '-' + row.invoiceNumber) + '</p>\n            </div>\n          </div>\n          <div class="invoice-order-info-card-body">' + rows + '</div>\n        </div>\n      ';
    },
    showOrderInfo: function showOrderInfo(row) {
      if (!row || !row.hasOrderInfo) return;

      this.openSpvSwal({
        title: ' ',
        html: this.buildOrderInfoHtml(row),
        customClass: 'spv-swal spv-swal--order-info',
        width: 460,
        confirmButtonText: 'Închide'
      });
    },
    openOrderInfo: function openOrderInfo(row) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (row) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt('return');

              case 2:
                _context7.next = 4;
                return _this9.ensureOrderInfo(row);

              case 4:
                if (row.hasOrderInfo) {
                  _context7.next = 7;
                  break;
                }

                _this9.showSpvSimpleAlert('info', 'Date comandă', 'Această factură nu are date de comandă sau bon fiscal asociate.');
                return _context7.abrupt('return');

              case 7:

                _this9.showOrderInfo(row);

              case 8:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },
    normalizeSpvStatusKey: function normalizeSpvStatusKey(status) {
      var value = String(status || '').toLowerCase().trim();

      if (['sent', 'trimis', 'ok', 'success', 'processed', 'finalizat'].includes(value)) {
        return 'sent';
      }
      if (['error', 'eroare', 'failed', 'nok', 'respins'].includes(value)) {
        return 'error';
      }
      if (['pending', 'processing', 'in_procesare', 'in procesare', 'in prelucrare', 'waiting'].includes(value)) {
        return 'pending';
      }

      return 'not_sent';
    },
    resolveSpvStatusFromInvoice: function resolveSpvStatusFromInvoice(invoice) {
      if (!invoice) return 'not_sent';

      if (invoice.spvStatus) {
        return this.normalizeSpvStatusKey(invoice.spvStatus);
      }

      var spv = invoice.spv || invoice.efactura;
      if (spv && (typeof spv === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(spv)) === 'object') {
        if (spv.error || spv.anafError) return 'error';
        if (spv.status) return this.normalizeSpvStatusKey(spv.status);
        if (spv.id_incarcare || spv.idIncarcare || spv.index_incarcare) {
          return spv.id_descarcare || spv.spvMessageId || spv.messageId ? 'sent' : 'pending';
        }
      }

      if (typeof spv === 'string') {
        return this.normalizeSpvStatusKey(spv);
      }

      if (invoice.spv_status) return this.normalizeSpvStatusKey(invoice.spv_status);
      if (invoice.efacturaStatus) return this.normalizeSpvStatusKey(invoice.efacturaStatus);
      if (invoice.spvIndex || invoice.id_incarcare || invoice.idIncarcare) {
        return this.extractSpvMessageIdFromInvoice(invoice) ? 'sent' : 'pending';
      }

      if (Array.isArray(invoice.extraFields)) {
        var field = invoice.extraFields.find(function (item) {
          return ['spv_status', 'efactura_status', 'spvStatus'].includes(item.key);
        });
        if (field && field.value) {
          return this.normalizeSpvStatusKey(field.value);
        }
      }

      return 'not_sent';
    },
    getSpvStatusMeta: function getSpvStatusMeta(status) {
      var key = this.normalizeSpvStatusKey(status);

      var map = {
        not_sent: { labelKey: 'invoice.spvStatusNotSent', className: 'spv-status--none' },
        sent: { labelKey: 'invoice.spvStatusSent', className: 'spv-status--sent' },
        error: { labelKey: 'invoice.spvStatusError', className: 'spv-status--error' },
        pending: { labelKey: 'invoice.spvStatusPending', className: 'spv-status--pending' }
      };

      return map[key] || map.not_sent;
    },
    extractSpvIdIncarcareFromInvoice: function extractSpvIdIncarcareFromInvoice(invoice) {
      if (!invoice) return null;

      var spv = invoice.spv || {};
      return invoice.spvIndex || invoice.id_incarcare || invoice.idIncarcare || spv.id_incarcare || spv.idIncarcare || spv.index_incarcare || null;
    },
    extractSpvMessageIdFromInvoice: function extractSpvMessageIdFromInvoice(invoice) {
      if (!invoice) return null;

      return invoice.spvMessageId || invoice.id_descarcare || invoice.idDescarcare || null;
    },
    buildSpvStatusTitle: function buildSpvStatusTitle(invoice) {
      var idIncarcare = this.extractSpvIdIncarcareFromInvoice(invoice);
      var messageId = this.extractSpvMessageIdFromInvoice(invoice);
      var parts = [];

      if (idIncarcare) parts.push('ID \xEEnc\u0103rcare: ' + idIncarcare);
      if (messageId) parts.push('ID mesaj: ' + messageId);

      return parts.join(' · ');
    },
    applySpvStatusToRow: function applySpvStatusToRow(row, invoice) {
      var status = this.resolveSpvStatusFromInvoice(invoice);
      var meta = this.getSpvStatusMeta(status);
      var idIncarcare = this.extractSpvIdIncarcareFromInvoice(invoice);

      row.spvStatus = status;
      row.spvStatusLabel = this.$t(meta.labelKey);
      row.spvStatusClass = meta.className;
      row.spvIdIncarcare = idIncarcare;
      row.spvMessageId = this.extractSpvMessageIdFromInvoice(invoice);
      row.spvStatusTitle = this.buildSpvStatusTitle(invoice);

      return row;
    },
    canSendToSpv: function canSendToSpv(row) {
      if (!row || !row.rawInvoice) return false;

      var status = this.normalizeSpvStatusKey(row.spvStatus || row.rawInvoice.spvStatus || this.resolveSpvStatusFromInvoice(row.rawInvoice));

      return !['sent', 'pending'].includes(status);
    },
    canDeleteInvoice: function canDeleteInvoice(row, index) {
      if (index !== 0 || !row) return false;

      var status = this.normalizeSpvStatusKey(row.spvStatus || row.rawInvoice.spvStatus || this.resolveSpvStatusFromInvoice(row.rawInvoice));

      return !['sent', 'pending'].includes(status);
    },
    getPendingSpvRows: function getPendingSpvRows() {
      var _this10 = this;

      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.tableData;

      return (rows || []).filter(function (row) {
        var invoice = row.rawInvoice;
        if (!invoice) return false;

        var idIncarcare = _this10.extractSpvIdIncarcareFromInvoice(invoice) || row.spvIdIncarcare;
        if (!idIncarcare) return false;

        var status = _this10.normalizeSpvStatusKey(invoice.spvStatus || row.spvStatus || 'not_sent');
        return status === 'pending';
      });
    },
    getSpvCifForBatch: function getSpvCifForBatch() {
      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (this.selectedLocation && this.selectedLocation.inv_fiscal_code) {
        return this.normalizeCif(this.selectedLocation.inv_fiscal_code);
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(rows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var row = _step.value;

          var cif = this.getSpvCif(row.rawInvoice);
          if (cif) return cif;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    },
    normalizeBatchStatusResult: function normalizeBatchStatusResult(item, cif) {
      var idIncarcare = item && (item.id || item.idIncarcare) ? String(item.id || item.idIncarcare) : null;

      if (!item || item.success === false) {
        var errorPayload = item && item.error;
        var anafError = typeof errorPayload === 'string' ? errorPayload : errorPayload && (errorPayload.message || errorPayload.error || errorPayload.eroare) || 'Nu s-a putut verifica statusul ANAF.';

        return {
          success: false,
          pending: false,
          idIncarcare: idIncarcare,
          anafError: anafError,
          cif: cif,
          mode: this.getSpvMode()
        };
      }

      var payload = item.data != null ? item.data : item;
      var normalized = this.normalizeEfacturaApiResponse(payload, cif);
      normalized.idIncarcare = normalized.idIncarcare || idIncarcare;

      return normalized;
    },
    checkEfacturaStatusesBatch: function checkEfacturaStatusesBatch(ids, cif) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var uniqueIds, params, response, data;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                uniqueIds = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a((ids || []).map(function (id) {
                  return String(id);
                }).filter(Boolean))));

                if (uniqueIds.length) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt('return', { results: [] });

              case 3:
                params = new URLSearchParams({
                  externalCompanyId: _this11.companyID,
                  cif: _this11.normalizeCif(cif),
                  mode: _this11.getSpvMode()
                });
                _context8.next = 6;
                return fetch(_this11.getEfacturaBaseUrl() + '/efactura/statuses?' + params.toString(), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ ids: uniqueIds })
                });

              case 6:
                response = _context8.sent;
                _context8.next = 9;
                return _this11.parseEfacturaResponseBody(response);

              case 9:
                data = _context8.sent;

                if (response.ok) {
                  _context8.next = 12;
                  break;
                }

                throw new Error(_this11.parseAnafError(data, 'Nu s-a putut verifica statusul facturilor în SPV.'));

              case 12:
                if (!Array.isArray(data)) {
                  _context8.next = 14;
                  break;
                }

                return _context8.abrupt('return', { results: data });

              case 14:
                if (!Array.isArray(data.results)) {
                  _context8.next = 16;
                  break;
                }

                return _context8.abrupt('return', data);

              case 16:
                return _context8.abrupt('return', { results: [] });

              case 17:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    resolveSpvStatusFromEfacturaResult: function resolveSpvStatusFromEfacturaResult(result) {
      if (!result) return 'error';
      if (result.pending || this.isEfacturaStatusPending(result)) return 'pending';
      if (result.success) return 'sent';
      return 'error';
    },
    refreshInvoicesSpvStatuses: function refreshInvoicesSpvStatuses() {
      var _this12 = this;

      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.tableData;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var _options$persist, persist, pendingRows, cif, idToRow, ids, batch, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item, id, row, normalized, spvStatus, spvMessageId;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _options$persist = options.persist, persist = _options$persist === undefined ? true : _options$persist;
                pendingRows = _this12.getPendingSpvRows(rows);

                if (!(!pendingRows.length || !_this12.companyID || _this12.spvStatusRefreshInProgress)) {
                  _context9.next = 4;
                  break;
                }

                return _context9.abrupt('return');

              case 4:
                cif = _this12.getSpvCifForBatch(pendingRows);

                if (cif) {
                  _context9.next = 7;
                  break;
                }

                return _context9.abrupt('return');

              case 7:
                idToRow = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                ids = pendingRows.map(function (row) {
                  var id = String(_this12.extractSpvIdIncarcareFromInvoice(row.rawInvoice) || row.spvIdIncarcare);
                  idToRow.set(id, row);
                  return id;
                });


                _this12.spvStatusRefreshInProgress = true;

                _context9.prev = 10;
                _context9.next = 13;
                return _this12.checkEfacturaStatusesBatch(ids, cif);

              case 13:
                batch = _context9.sent;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context9.prev = 17;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(batch.results || []);

              case 19:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context9.next = 41;
                  break;
                }

                item = _step2.value;
                id = item && (item.id || item.idIncarcare);
                row = idToRow.get(String(id));

                if (row) {
                  _context9.next = 25;
                  break;
                }

                return _context9.abrupt('continue', 38);

              case 25:
                normalized = _this12.normalizeBatchStatusResult(item, cif);
                spvStatus = _this12.resolveSpvStatusFromEfacturaResult(normalized);
                spvMessageId = normalized.spvMessageId || normalized.idDescarcare || null;


                _this12.updateRowSpvStatus(row.id, spvStatus, normalized.idIncarcare || id, spvMessageId);

                if (!persist) {
                  _context9.next = 38;
                  break;
                }

                _context9.prev = 30;
                _context9.next = 33;
                return _this12.persistInvoiceSpvStatus(row, normalized);

              case 33:
                _context9.next = 38;
                break;

              case 35:
                _context9.prev = 35;
                _context9.t0 = _context9['catch'](30);

                console.error('Error persisting batch SPV status:', _context9.t0);

              case 38:
                _iteratorNormalCompletion2 = true;
                _context9.next = 19;
                break;

              case 41:
                _context9.next = 47;
                break;

              case 43:
                _context9.prev = 43;
                _context9.t1 = _context9['catch'](17);
                _didIteratorError2 = true;
                _iteratorError2 = _context9.t1;

              case 47:
                _context9.prev = 47;
                _context9.prev = 48;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 50:
                _context9.prev = 50;

                if (!_didIteratorError2) {
                  _context9.next = 53;
                  break;
                }

                throw _iteratorError2;

              case 53:
                return _context9.finish(50);

              case 54:
                return _context9.finish(47);

              case 55:
                _context9.next = 60;
                break;

              case 57:
                _context9.prev = 57;
                _context9.t2 = _context9['catch'](10);

                console.error('Error refreshing SPV statuses:', _context9.t2);

              case 60:
                _context9.prev = 60;

                _this12.spvStatusRefreshInProgress = false;
                return _context9.finish(60);

              case 63:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12, [[10, 57, 60, 63], [17, 43, 47, 55], [30, 35], [48,, 50, 54]]);
      }))();
    },
    updateRowSpvStatus: function updateRowSpvStatus(rowId, status) {
      var idIncarcare = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var spvMessageId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var row = this.tableData.find(function (item) {
        return item.id === rowId;
      });
      if (!row) return;

      var meta = this.getSpvStatusMeta(status);

      row.spvStatus = this.normalizeSpvStatusKey(status);
      row.spvStatusLabel = this.$t(meta.labelKey);
      row.spvStatusClass = meta.className;

      if (idIncarcare) {
        row.spvIdIncarcare = idIncarcare;
      }

      if (spvMessageId) {
        row.spvMessageId = spvMessageId;
      }

      if (row.rawInvoice) {
        row.rawInvoice.spvStatus = row.spvStatus;
        if (idIncarcare) row.rawInvoice.spvIndex = String(idIncarcare);
        if (spvMessageId) row.rawInvoice.spvMessageId = String(spvMessageId);
      }

      row.spvStatusTitle = this.buildSpvStatusTitle(row.rawInvoice || {
        spvIndex: idIncarcare,
        spvMessageId: spvMessageId
      });
    },
    mapEfacturaResultToSpvDocumentFields: function mapEfacturaResultToSpvDocumentFields(result) {
      var spvStatus = 'error';

      if (result && (result.pending || this.isEfacturaStatusPending(result))) {
        spvStatus = 'pending';
      } else if (result && result.success) {
        spvStatus = 'sent';
      }

      var spvIndex = result && (result.idIncarcare || result.spvIndex) ? String(result.idIncarcare || result.spvIndex) : null;
      var spvMessageId = result && (result.spvMessageId || result.idDescarcare) ? String(result.spvMessageId || result.idDescarcare) : null;

      return {
        spvStatus: spvStatus,
        spvIndex: spvIndex,
        spvMessageId: spvMessageId
      };
    },
    saveInvoiceSpvDocument: function saveInvoiceSpvDocument(invoice, spvFields) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var location, payload, response, data;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                location = _this13.selectedLocation || {};
                payload = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, invoice, spvFields, {
                  tip: invoice.tip || 'invoice',
                  externalCompanyId: invoice.externalCompanyId || _this13.companyID,
                  externalLocationId: invoice.externalLocationId || location && location.true_id,
                  vatNumber: invoice.vatNumber || location && location.inv_fiscal_code,
                  number: invoice.number || invoice.invoiceNumber
                });
                _context10.next = 4;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/document', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(payload)
                });

              case 4:
                response = _context10.sent;
                _context10.next = 7;
                return response.json().catch(function () {
                  return {};
                });

              case 7:
                data = _context10.sent;

                if (response.ok) {
                  _context10.next = 10;
                  break;
                }

                throw new Error(data.error || data.message || 'Nu s-a putut salva statusul SPV pe document.');

              case 10:
                return _context10.abrupt('return', data);

              case 11:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    persistInvoiceSpvStatus: function persistInvoiceSpvStatus(row, result) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var spvFields, savedDocument;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(!row || !row.rawInvoice)) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt('return', null);

              case 2:
                spvFields = _this14.mapEfacturaResultToSpvDocumentFields(result);
                _context11.next = 5;
                return _this14.saveInvoiceSpvDocument(row.rawInvoice, spvFields);

              case 5:
                savedDocument = _context11.sent;


                row.rawInvoice = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, row.rawInvoice, spvFields, savedDocument && (typeof savedDocument === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(savedDocument)) === 'object' ? savedDocument : {});

                _this14.applySpvStatusToRow(row, row.rawInvoice);

                return _context11.abrupt('return', row.rawInvoice);

              case 9:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this14);
      }))();
    },
    buildEfacturaQueryParams: function buildEfacturaQueryParams(cif) {
      var standard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UBL';

      return new URLSearchParams({
        externalCompanyId: this.companyID,
        cif: this.normalizeCif(cif),
        mode: this.getSpvMode(),
        standard: standard
      });
    },
    showSpvProgress: function showSpvProgress(title, text) {
      this.openSpvSwal({
        title: ' ',
        html: '\n          <div class="spv-progress">\n            <div class="spv-progress-spinner"></div>\n            ' + (title ? '<p class="spv-progress-title">' + this.escapeHtml(title) + '</p>' : '') + '\n            <p class="spv-progress-text">' + this.escapeHtml(text) + '</p>\n          </div>\n        ',
        customClass: 'spv-swal spv-swal--progress',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      });
    },
    postEfacturaJson: function postEfacturaJson(path, cif, body) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var standard, params, response, data;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                standard = body.standard || 'UBL';
                params = _this15.buildEfacturaQueryParams(cif, standard);
                _context12.next = 4;
                return fetch('' + _this15.getEfacturaBaseUrl() + path + '?' + params.toString(), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(body)
                });

              case 4:
                response = _context12.sent;
                _context12.next = 7;
                return _this15.parseEfacturaResponseBody(response);

              case 7:
                data = _context12.sent;
                return _context12.abrupt('return', { response: response, data: data });

              case 9:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    },
    parseEfacturaResponseBody: function parseEfacturaResponseBody(response) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var text, parsed;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return response.text();

              case 2:
                text = _context13.sent;

                if (!(!text || !text.trim())) {
                  _context13.next = 5;
                  break;
                }

                return _context13.abrupt('return', {});

              case 5:
                _context13.prev = 5;
                parsed = JSON.parse(text);

                if (!(typeof parsed === 'string' && parsed.trim().startsWith('<'))) {
                  _context13.next = 9;
                  break;
                }

                return _context13.abrupt('return', { anaf_response: parsed.trim() });

              case 9:
                return _context13.abrupt('return', parsed);

              case 12:
                _context13.prev = 12;
                _context13.t0 = _context13['catch'](5);

                if (!text.trim().startsWith('<')) {
                  _context13.next = 16;
                  break;
                }

                return _context13.abrupt('return', { anaf_response: text.trim() });

              case 16:
                return _context13.abrupt('return', { message: text.trim() });

              case 17:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this16, [[5, 12]]);
      }))();
    },
    generateEfacturaXml: function generateEfacturaXml(invoice, cif) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var payload, _ref, response, data;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                payload = _this17.prepareInvoiceForEfactura(invoice);
                _context14.next = 3;
                return _this17.postEfacturaJson('/efactura/xml/generate', cif, {
                  invoice: payload,
                  standard: 'UBL'
                });

              case 3:
                _ref = _context14.sent;
                response = _ref.response;
                data = _ref.data;

                if (!(!response.ok || !data.xml)) {
                  _context14.next = 8;
                  break;
                }

                throw new Error(_this17.parseAnafError(data, 'Generarea XML UBL a eșuat.'));

              case 8:
                return _context14.abrupt('return', data.xml);

              case 9:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this17);
      }))();
    },
    sendEfacturaDocument: function sendEfacturaDocument(_ref2) {
      var _this18 = this;

      var invoice = _ref2.invoice,
          xml = _ref2.xml,
          cif = _ref2.cif;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var payload, _ref3, response, data, result;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                payload = _this18.prepareInvoiceForEfactura(invoice);
                _context15.next = 3;
                return _this18.postEfacturaJson('/efactura/send', cif, {
                  invoice: payload,
                  xml: xml,
                  standard: 'UBL'
                });

              case 3:
                _ref3 = _context15.sent;
                response = _ref3.response;
                data = _ref3.data;
                result = _this18.normalizeEfacturaApiResponse(data, cif);


                if (!response.ok) {
                  result.success = false;
                  if (!result.anafError) {
                    result.anafError = _this18.parseAnafError(data, 'Trimiterea în SPV a eșuat.');
                  }
                }

                return _context15.abrupt('return', result);

              case 9:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this18);
      }))();
    },
    getEfacturaBaseUrl: function getEfacturaBaseUrl() {
      return "https://fiscal-dev.cdntaptasty.com".replace(/\/$/, '') + ':4443';
    },
    getSpvMode: function getSpvMode() {
      var raw = String("TEST" || 'TEST').trim().replace(/^['"]+|['"]+$/g, '').toUpperCase();

      return raw === 'PROD' ? 'PROD' : 'TEST';
    },
    normalizeCif: function normalizeCif(cif) {
      return String(cif || '').replace(/^ro/i, '').trim();
    },
    getSpvCif: function getSpvCif(invoice) {
      var fromLocation = this.selectedLocation && this.selectedLocation.inv_fiscal_code;
      var fromInvoice = invoice.company && invoice.company.vatNumber || invoice.vatNumber;
      return this.normalizeCif(fromLocation || fromInvoice);
    },
    prepareInvoiceForEfactura: function prepareInvoiceForEfactura(invoice) {
      var payload = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, invoice);

      if (!payload.externalCompanyId && this.companyID) {
        payload.externalCompanyId = this.companyID;
      }

      if (!payload.externalLocationId && this.selectedLocation && this.selectedLocation.true_id) {
        payload.externalLocationId = this.selectedLocation.true_id;
      }

      if (!payload.vatNumber && payload.company && payload.company.vatNumber) {
        payload.vatNumber = payload.company.vatNumber;
      }

      return payload;
    },
    escapeHtml: function escapeHtml(value) {
      return String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    getExecutionStatusLabel: function getExecutionStatusLabel(status) {
      if (status === '0') return 'Succes';
      if (status === '1') return 'Eroare';
      return status || '-';
    },
    parseAnafError: function parseAnafError(parsed, fallback) {
      if (!parsed) return fallback;

      var indexedXml = this.reconstructIndexedString(parsed);
      if (indexedXml) {
        var xmlError = this.parseAnafXmlResponse(indexedXml);
        if (xmlError && xmlError.errorMessage) {
          var hint = /drept in spv/i.test(xmlError.errorMessage) ? ' Verifica\u021Bi token-ul SPV (ANAF) \xEEn Set\u0103ri Gestiune.' : '';
          return xmlError.errorMessage + hint;
        }
      }

      if (parsed.anaf_error) {
        try {
          var anafObj = typeof parsed.anaf_error === 'string' ? JSON.parse(parsed.anaf_error) : parsed.anaf_error;
          if (anafObj && anafObj.eroare) return anafObj.eroare;
          if (anafObj && anafObj.message) return anafObj.message;
        } catch (e) {
          return parsed.anaf_error;
        }
      }

      if (typeof parsed === 'string' && parsed.trim().startsWith('<')) {
        var _xmlError = this.parseAnafXmlResponse(parsed);
        if (_xmlError && _xmlError.errorMessage) return _xmlError.errorMessage;
      }

      return parsed.message || parsed.error || fallback;
    },
    reconstructIndexedString: function reconstructIndexedString(data) {
      if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(data)) !== 'object') return null;

      var numericKeys = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(data).filter(function (key) {
        return (/^\d+$/.test(key)
        );
      });
      if (numericKeys.length === 0) return null;

      return numericKeys.sort(function (a, b) {
        return Number(a) - Number(b);
      }).map(function (key) {
        return data[key];
      }).join('');
    },
    parseAnafXmlResponse: function parseAnafXmlResponse(xml) {
      if (!xml || typeof xml !== 'string') return null;

      var errorMessages = [];
      var errorRegex = /errorMessage="([^"]+)"/gi;
      var errorMatch = errorRegex.exec(xml);
      while (errorMatch) {
        errorMessages.push(errorMatch[1]);
        errorMatch = errorRegex.exec(xml);
      }

      var executionMatch = xml.match(/ExecutionStatus="(\d+)"/i);
      var dateMatch = xml.match(/dateResponse="([^"]+)"/i);
      var stareMatch = xml.match(/\bstare="([^"]+)"/i);
      var idDescarcareMatch = xml.match(/\bid_descarcare="(\d+)"/i);
      var idMatch = xml.match(/index_incarcare="(\d+)"/i) || xml.match(/id_incarcare="(\d+)"/i);

      var executionStatus = executionMatch ? executionMatch[1] : null;
      var stare = stareMatch ? stareMatch[1] : null;
      var stareNorm = stare ? String(stare).toLowerCase().trim() : '';
      var isStareError = ['nok', 'eroare', 'error', 'respins'].includes(stareNorm);
      var isError = errorMessages.length > 0 || isStareError || executionStatus !== null && executionStatus !== '0';

      return {
        executionStatus: executionStatus,
        dateResponse: dateMatch ? dateMatch[1] : null,
        errorMessage: errorMessages[0] || null,
        errorMessages: errorMessages,
        idIncarcare: idMatch ? idMatch[1] : null,
        idDescarcare: idDescarcareMatch ? idDescarcareMatch[1] : null,
        stare: stare,
        isError: isError
      };
    },
    extractXmlFromResponse: function extractXmlFromResponse(data) {
      if (!data) return null;
      if (typeof data === 'string' && data.trim().startsWith('<')) return data;

      var indexedXml = this.reconstructIndexedString(data);
      if (indexedXml) return indexedXml;

      if (typeof data.xml === 'string') return data.xml;
      if (typeof data.anaf_response === 'string') return data.anaf_response;

      return null;
    },
    normalizeEfacturaStare: function normalizeEfacturaStare(stare) {
      return String(stare || '').toLowerCase().trim();
    },
    isEfacturaStatusPending: function isEfacturaStatusPending(statusData) {
      if (!statusData) return false;
      if (statusData.pending) return true;

      var stare = this.normalizeEfacturaStare(statusData.stare || statusData.status);
      return ['in prelucrare', 'in procesare', 'processing', 'pending', 'waiting'].includes(stare);
    },
    normalizeEfacturaApiResponse: function normalizeEfacturaApiResponse(data, cif) {
      var xmlSource = this.extractXmlFromResponse(data);
      var xmlParsed = xmlSource ? this.parseAnafXmlResponse(xmlSource) : null;
      var idIncarcare = this.extractIdIncarcare(data) || xmlParsed && xmlParsed.idIncarcare;
      var anafErrors = xmlParsed && xmlParsed.errorMessages || [];
      var anafError = anafErrors[0] || data.error || data.message || null;
      var resolvedCif = data.cif || cif || null;
      var stare = data.stare || data.status || xmlParsed && xmlParsed.stare || null;
      var stareNorm = this.normalizeEfacturaStare(stare);
      var isPending = this.isEfacturaStatusPending({ stare: stare });
      var isStareOk = ['ok', 'processed', 'finalizat', 'succes', 'success'].includes(stareNorm);
      var isStareError = ['nok', 'eroare', 'error', 'respins'].includes(stareNorm);

      var success = false;
      var pending = false;

      if (anafErrors.length || xmlParsed && xmlParsed.isError || isStareError) {
        success = false;
      } else if (isStareOk || xmlParsed && xmlParsed.idDescarcare) {
        success = true;
      } else if (isPending) {
        pending = true;
        success = true;
      } else if (idIncarcare || xmlParsed && xmlParsed.executionStatus === '0') {
        success = true;
      } else if (!data.error && (idIncarcare || stare)) {
        success = !isStareError;
      }

      var hint = anafError && /drept in spv/i.test(anafError) ? ('Verifica\u021Bi token-ul SPV (ANAF) activ pentru CIF ' + (resolvedCif || '') + ' \xEEn Set\u0103ri Gestiune.').replace(/\s+/g, ' ').trim() : null;

      return {
        success: success,
        pending: pending,
        cif: resolvedCif,
        mode: this.getSpvMode(),
        standard: data.standard || 'UBL',
        b2c: data.b2c,
        idIncarcare: idIncarcare,
        idDescarcare: data.id_descarcare || data.idDescarcare || xmlParsed && xmlParsed.idDescarcare || null,
        spvMessageId: data.spvMessageId || data.id_message || data.messageId || data.id_descarcare || data.idDescarcare || xmlParsed && xmlParsed.idDescarcare || null,
        executionStatus: xmlParsed && xmlParsed.executionStatus,
        dateResponse: xmlParsed && xmlParsed.dateResponse,
        stare: stare,
        anafErrors: anafErrors,
        anafError: anafError,
        hint: hint,
        message: data.message || null
      };
    },
    formatAnafDateResponse: function formatAnafDateResponse(value) {
      var raw = String(value || '');
      if (raw.length < 12) return raw;

      var year = raw.slice(0, 4);
      var month = raw.slice(4, 6);
      var day = raw.slice(6, 8);
      var hour = raw.slice(8, 10);
      var minute = raw.slice(10, 12);

      return day + '.' + month + '.' + year + ', ' + hour + ':' + minute;
    },
    buildEfacturaDetailRow: function buildEfacturaDetailRow(label, value) {
      if (value === null || value === undefined || value === '') return '';

      return '\n        <div class="spv-result-row">\n          <span class="spv-result-label">' + this.escapeHtml(label) + '</span>\n          <span class="spv-result-value">' + this.escapeHtml(value) + '</span>\n        </div>\n      ';
    },
    buildEfacturaDetailRowWithDownload: function buildEfacturaDetailRowWithDownload(label, value, messageId) {
      if (value === null || value === undefined || value === '') return '';

      var downloadButton = messageId ? '<button type="button" class="spv-inbox-download-btn spv-result-download-btn" data-message-id="' + this.escapeHtml(String(messageId)) + '">' + this.escapeHtml(this.$t('gestiune.viewSpvMessage')) + '</button>' : '';

      return '\n        <div class="spv-result-row spv-result-row--with-action">\n          <span class="spv-result-label">' + this.escapeHtml(label) + '</span>\n          <span class="spv-result-value spv-result-value--with-action">\n            <span>' + this.escapeHtml(String(value)) + '</span>\n            ' + downloadButton + '\n          </span>\n        </div>\n      ';
    },
    buildEfacturaResultHtml: function buildEfacturaResultHtml(result, invoiceLabel) {
      var _this19 = this;

      var isPending = this.isEfacturaStatusPending(result);
      var isSuccess = !!result.success && !isPending;
      var badgeText = isPending ? 'În procesare ANAF' : isSuccess ? 'Trimis cu succes în SPV' : 'Respins de ANAF';
      var statusLabel = result.executionStatus !== null && result.executionStatus !== undefined ? this.getExecutionStatusLabel(result.executionStatus) : null;
      var formattedDate = result.dateResponse ? this.formatAnafDateResponse(result.dateResponse) : null;
      var spvMessageId = result.spvMessageId || result.idDescarcare;

      var details = [this.buildEfacturaDetailRow('Factură', invoiceLabel), this.buildEfacturaDetailRow('CIF', result.cif), this.buildEfacturaDetailRow('Mediu SPV', result.mode), this.buildEfacturaDetailRow('Standard', result.standard), this.buildEfacturaDetailRow('Tip', result.b2c ? 'B2C' : 'B2B'), this.buildEfacturaDetailRow('ID încărcare', result.idIncarcare), spvMessageId ? this.buildEfacturaDetailRowWithDownload('ID mesaj SPV', spvMessageId, spvMessageId) : this.buildEfacturaDetailRow('ID descărcare', result.idDescarcare), this.buildEfacturaDetailRow('Status ANAF', statusLabel), this.buildEfacturaDetailRow('Data răspuns', formattedDate), this.buildEfacturaDetailRow('Stare procesare', result.stare)].filter(Boolean).join('');

      var messageBlock = '';

      if (result.anafErrors && result.anafErrors.length) {
        var items = result.anafErrors.map(function (err) {
          return '<li>' + _this19.escapeHtml(err) + '</li>';
        }).join('');

        messageBlock = '\n          <div class="spv-result-message spv-result-message--error">\n            <div class="spv-result-message-title">Mesaj ANAF</div>\n            <ul class="spv-result-errors">' + items + '</ul>\n          </div>\n        ';
      } else if (result.anafError && !isSuccess) {
        messageBlock = '\n          <div class="spv-result-message spv-result-message--error">\n            <div class="spv-result-message-title">Mesaj ANAF</div>\n            <p>' + this.escapeHtml(result.anafError) + '</p>\n          </div>\n        ';
      } else if (isPending) {
        messageBlock = '\n          <div class="spv-result-message spv-result-message--pending">\n            <div class="spv-result-message-title">Status ANAF</div>\n            <p>Factura a fost \xEEnc\u0103rcat\u0103, dar ANAF \xEEnc\u0103 o proceseaz\u0103. Verifica\u021Bi statusul mai t\xE2rziu folosind ID-ul de \xEEnc\u0103rcare.</p>\n          </div>\n        ';
      } else if (isSuccess && result.message) {
        messageBlock = '\n          <div class="spv-result-message spv-result-message--success">\n            <div class="spv-result-message-title">Confirmare</div>\n            <p>' + this.escapeHtml(result.message) + '</p>\n          </div>\n        ';
      }

      var hintBlock = result.hint ? '<div class="spv-result-hint">' + this.escapeHtml(result.hint) + '</div>' : '';

      var headerClass = isPending ? 'spv-result-header--pending' : isSuccess ? 'spv-result-header--success' : 'spv-result-header--error';

      return '\n        <div class="spv-result-card">\n          <div class="spv-result-header ' + headerClass + '">\n            <span class="spv-result-header-icon"></span>\n            <div class="spv-result-header-body">\n              <strong>' + this.escapeHtml(badgeText) + '</strong>\n              <span>' + this.escapeHtml(invoiceLabel || '') + '</span>\n            </div>\n          </div>\n          <div class="spv-result-details">' + details + '</div>\n          ' + messageBlock + '\n          ' + hintBlock + '\n        </div>\n      ';
    },
    showEfacturaAlert: function showEfacturaAlert(type, title, result, invoiceLabel) {
      var _this20 = this;

      this.openSpvSwal({
        title: title,
        html: this.buildEfacturaResultHtml(result, invoiceLabel),
        customClass: 'spv-swal spv-swal--result spv-swal--' + (type || 'info'),
        width: 560,
        onOpen: function onOpen() {
          _this20.bindSpvInboxDownloadButtons();
        }
      });
    },
    mergeEfacturaResults: function mergeEfacturaResults(sendResult, statusResult) {
      var pending = this.isEfacturaStatusPending(statusResult);
      var statusFailed = statusResult.success === false && !pending;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, sendResult, {
        success: sendResult.success && !statusFailed,
        pending: pending,
        mode: this.getSpvMode(),
        stare: statusResult.stare || sendResult.stare,
        idDescarcare: statusResult.idDescarcare || sendResult.idDescarcare,
        spvMessageId: statusResult.spvMessageId || sendResult.spvMessageId || statusResult.idDescarcare || sendResult.idDescarcare,
        executionStatus: statusResult.executionStatus || sendResult.executionStatus,
        dateResponse: statusResult.dateResponse || sendResult.dateResponse,
        anafErrors: statusResult.anafErrors && statusResult.anafErrors.length ? statusResult.anafErrors : sendResult.anafErrors || [],
        anafError: statusResult.anafError || sendResult.anafError,
        hint: statusResult.hint || sendResult.hint,
        message: statusResult.message || sendResult.message
      });
    },
    extractIdIncarcare: function extractIdIncarcare(data) {
      return data.id_incarcare || data.idIncarcare || data.index_incarcare || data.uploadIndex || null;
    },
    checkEfacturaStatus: function checkEfacturaStatus(idIncarcare, cif) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var params, response, data, normalized;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                params = _this21.buildEfacturaQueryParams(cif);
                _context16.next = 3;
                return fetch(_this21.getEfacturaBaseUrl() + '/efactura/status/' + encodeURIComponent(idIncarcare) + '?' + params.toString());

              case 3:
                response = _context16.sent;
                _context16.next = 6;
                return _this21.parseEfacturaResponseBody(response);

              case 6:
                data = _context16.sent;
                normalized = _this21.normalizeEfacturaApiResponse(data, cif);


                if (!response.ok) {
                  normalized.success = false;
                  normalized.pending = false;
                  if (!normalized.anafError) {
                    normalized.anafError = _this21.parseAnafError(data, 'Nu s-a putut verifica statusul e-Factura.');
                  }
                }

                return _context16.abrupt('return', normalized);

              case 10:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this21);
      }))();
    },
    triggerXmlFileDownload: function triggerXmlFileDownload(xml, filename) {
      var blob = new Blob([xml], { type: 'application/xml;charset=utf-8' });
      var link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    downloadEfacturaXml: function downloadEfacturaXml(row) {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var invoice, cif, invoiceLabel, xml;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (_this22.companyID) {
                  _context17.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this22.$t('general.error'),
                  text: 'Lipsește compania selectată.',
                  confirmButtonText: 'OK'
                });
                return _context17.abrupt('return');

              case 3:
                invoice = row.rawInvoice;

                if (invoice) {
                  _context17.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this22.$t('general.error'),
                  text: 'Datele facturii nu sunt disponibile.',
                  confirmButtonText: 'OK'
                });
                return _context17.abrupt('return');

              case 7:
                cif = _this22.getSpvCif(invoice);

                if (cif) {
                  _context17.next = 11;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'warning',
                  title: _this22.$t('general.required'),
                  text: 'Selectați o locație cu CIF fiscal pentru generarea XML.',
                  confirmButtonText: 'OK'
                });
                return _context17.abrupt('return');

              case 11:
                invoiceLabel = row.series + '-' + row.invoiceNumber;
                _context17.prev = 12;

                _this22.showSpvProgress(_this22.$t('gestiune.downloadEfacturaXml'), 'Se generează XML UBL...');

                _context17.next = 16;
                return _this22.generateEfacturaXml(invoice, cif);

              case 16:
                xml = _context17.sent;


                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                _this22.triggerXmlFileDownload(xml, invoiceLabel + '.xml');
                _context17.next = 26;
                break;

              case 21:
                _context17.prev = 21;
                _context17.t0 = _context17['catch'](12);

                console.error('Error downloading e-Factura XML:', _context17.t0);
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this22.$t('general.error'),
                  text: _context17.t0.message || 'Generarea XML UBL a eșuat.',
                  confirmButtonText: 'OK'
                });

              case 26:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this22, [[12, 21]]);
      }))();
    },
    viewSpvPdf: function viewSpvPdf(row) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var invoiceLabel, base, checkUrl, result, pdfUrl, unavailableMessage;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (!(!row || !row.id)) {
                  _context18.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this23.$t('general.error'),
                  text: 'Factura nu are un identificator valid.',
                  confirmButtonText: 'OK'
                });
                return _context18.abrupt('return');

              case 3:
                if (_this23.companyID) {
                  _context18.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this23.$t('general.error'),
                  text: 'Lipsește compania selectată.',
                  confirmButtonText: 'OK'
                });
                return _context18.abrupt('return');

              case 6:
                if (!(!_this23.selectedLocation || !_this23.selectedLocation.inv_fiscal_code)) {
                  _context18.next = 9;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'warning',
                  title: _this23.$t('general.required'),
                  text: 'Selectați o locație cu CIF fiscal pentru vizualizarea PDF SPV.',
                  confirmButtonText: 'OK'
                });
                return _context18.abrupt('return');

              case 9:
                invoiceLabel = row.series + '-' + row.invoiceNumber;
                _context18.prev = 10;

                _this23.showSpvProgress(_this23.$t('gestiune.viewSpvPdf'), 'Se pregătește PDF-ul SPV...');

                base = _this23.buildEfacturaPurchasePdfBaseUrl(row.id);
                checkUrl = base + '?' + _this23.buildEfacturaPurchasePdfQueryParams({ check: '1' }).toString();


                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();

                _context18.next = 17;
                return _this23.handleSpvInboxDownloadResponse(checkUrl, 'Eroare PDF SPV');

              case 17:
                result = _context18.sent;

                if (result) {
                  _context18.next = 20;
                  break;
                }

                return _context18.abrupt('return');

              case 20:
                if (!(result.status === true)) {
                  _context18.next = 24;
                  break;
                }

                pdfUrl = base + '?' + _this23.buildEfacturaPurchasePdfQueryParams().toString();

                window.open(pdfUrl, '_blank');
                return _context18.abrupt('return');

              case 24:
                unavailableMessage = result.message || result.hint || result.eroare || 'PDF-ul SPV nu este disponibil pentru această factură.';


                _this23.showSpvSimpleAlert('info', 'PDF SPV \u2014 ' + invoiceLabel, unavailableMessage);
                _context18.next = 33;
                break;

              case 28:
                _context18.prev = 28;
                _context18.t0 = _context18['catch'](10);

                console.error('Error opening SPV PDF:', _context18.t0);
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this23.$t('general.error'),
                  text: _context18.t0.message || 'Eroare neașteptată la încărcarea PDF-ului SPV.',
                  confirmButtonText: 'OK'
                });

              case 33:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this23, [[10, 28]]);
      }))();
    },
    sendToSPV: function sendToSPV(row) {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee20() {
        var invoice, cif, invoiceLabel, confirmResult, finalizeSpvFlow, xml, result, statusResult;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (_this24.canSendToSpv(row)) {
                  _context20.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'info',
                  title: _this24.$t('gestiune.sendToSPV'),
                  text: 'Factura a fost deja trimisă în SPV sau este în procesare.',
                  confirmButtonText: 'OK'
                });
                return _context20.abrupt('return');

              case 3:
                if (_this24.companyID) {
                  _context20.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this24.$t('general.error'),
                  text: 'Lipsește compania selectată.',
                  confirmButtonText: 'OK'
                });
                return _context20.abrupt('return');

              case 6:
                invoice = row.rawInvoice;

                if (invoice) {
                  _context20.next = 10;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this24.$t('general.error'),
                  text: 'Datele facturii nu sunt disponibile.',
                  confirmButtonText: 'OK'
                });
                return _context20.abrupt('return');

              case 10:
                cif = _this24.getSpvCif(invoice);

                if (cif) {
                  _context20.next = 14;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'warning',
                  title: _this24.$t('general.required'),
                  text: 'Selectați o locație cu CIF fiscal pentru trimiterea în SPV.',
                  confirmButtonText: 'OK'
                });
                return _context20.abrupt('return');

              case 14:
                invoiceLabel = row.series + '-' + row.invoiceNumber;
                _context20.next = 17;
                return _this24.openSpvSwal({
                  title: ' ',
                  html: '\n          <div class="spv-prompt-card spv-prompt-card--confirm">\n            <div class="spv-prompt-header">\n              <span class="spv-prompt-logo">SPV</span>\n              <div>\n                <p class="spv-prompt-title">' + _this24.escapeHtml(_this24.$t('gestiune.sendToSPV')) + '</p>\n                <p class="spv-prompt-subtitle">Factura <strong>' + _this24.escapeHtml(invoiceLabel) + '</strong></p>\n              </div>\n            </div>\n            <p class="spv-prompt-question">Confirma\u021Bi trimiterea facturii \xEEn SPV (ANAF)?</p>\n          </div>\n        ',
                  customClass: 'spv-swal spv-swal--prompt spv-swal--confirm',
                  showCancelButton: true,
                  confirmButtonText: 'Trimite',
                  cancelButtonText: _this24.$t('general.cancel') || 'Anulează'
                });

              case 17:
                confirmResult = _context20.sent;

                if (confirmResult) {
                  _context20.next = 20;
                  break;
                }

                return _context20.abrupt('return');

              case 20:
                finalizeSpvFlow = function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee19(result) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
                      while (1) {
                        switch (_context19.prev = _context19.next) {
                          case 0:
                            _context19.prev = 0;
                            _context19.next = 3;
                            return _this24.persistInvoiceSpvStatus(row, result);

                          case 3:
                            _context19.next = 8;
                            break;

                          case 5:
                            _context19.prev = 5;
                            _context19.t0 = _context19['catch'](0);

                            console.error('Error saving SPV status on invoice document:', _context19.t0);

                          case 8:
                            _context19.next = 10;
                            return _this24.refreshInvoicesSpvStatuses(_this24.tableData);

                          case 10:
                          case 'end':
                            return _context19.stop();
                        }
                      }
                    }, _callee19, _this24, [[0, 5]]);
                  }));

                  return function finalizeSpvFlow(_x12) {
                    return _ref4.apply(this, arguments);
                  };
                }();

                _context20.prev = 21;

                _this24.showSpvProgress(_this24.$t('gestiune.sendToSPV'), 'Se trimite factura ' + invoiceLabel + ' \xEEn SPV (ANAF)...');
                _context20.next = 25;
                return _this24.generateEfacturaXml(invoice, cif);

              case 25:
                xml = _context20.sent;
                _context20.next = 28;
                return _this24.sendEfacturaDocument({ invoice: invoice, xml: xml, cif: cif });

              case 28:
                result = _context20.sent;

                if (result.success) {
                  _context20.next = 35;
                  break;
                }

                _context20.next = 32;
                return finalizeSpvFlow(result);

              case 32:
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                _this24.showEfacturaAlert('error', 'Eroare trimitere SPV', result, invoiceLabel);
                return _context20.abrupt('return');

              case 35:
                if (!result.idIncarcare) {
                  _context20.next = 52;
                  break;
                }

                _context20.next = 38;
                return _this24.checkEfacturaStatus(result.idIncarcare, cif);

              case 38:
                statusResult = _context20.sent;

                result = _this24.mergeEfacturaResults(result, statusResult);

                if (result.success) {
                  _context20.next = 46;
                  break;
                }

                _context20.next = 43;
                return finalizeSpvFlow(result);

              case 43:
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                _this24.showEfacturaAlert('error', 'Eroare procesare SPV', result, invoiceLabel);
                return _context20.abrupt('return');

              case 46:
                if (!_this24.isEfacturaStatusPending(result)) {
                  _context20.next = 52;
                  break;
                }

                _context20.next = 49;
                return finalizeSpvFlow(result);

              case 49:
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                _this24.showEfacturaAlert('warning', 'Factură în procesare ANAF', result, invoiceLabel);
                return _context20.abrupt('return');

              case 52:
                _context20.next = 54;
                return finalizeSpvFlow(result);

              case 54:
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                _this24.showEfacturaAlert('success', _this24.$t('general.success'), result, invoiceLabel);
                _context20.next = 65;
                break;

              case 58:
                _context20.prev = 58;
                _context20.t0 = _context20['catch'](21);

                console.error('Error sending invoice to SPV:', _context20.t0);
                _context20.next = 63;
                return finalizeSpvFlow({
                  success: false,
                  anafError: _context20.t0.message || 'Trimiterea în SPV a eșuat.'
                });

              case 63:
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                _this24.showEfacturaAlert('error', _this24.$t('general.error'), {
                  success: false,
                  cif: cif,
                  mode: _this24.getSpvMode(),
                  standard: 'UBL',
                  anafError: _context20.t0.message || 'Trimiterea în SPV a eșuat.'
                }, invoiceLabel);

              case 65:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, _this24, [[21, 58]]);
      }))();
    },
    verifySpvStatus: function verifySpvStatus(row) {
      var _this25 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee21() {
        var invoice, cif, idIncarcare, invoiceLabel, result, spvMessageId;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (_this25.companyID) {
                  _context21.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this25.$t('general.error'),
                  text: 'Lipsește compania selectată.',
                  confirmButtonText: 'OK'
                });
                return _context21.abrupt('return');

              case 3:
                invoice = row.rawInvoice;

                if (invoice) {
                  _context21.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'error',
                  title: _this25.$t('general.error'),
                  text: 'Datele facturii nu sunt disponibile.',
                  confirmButtonText: 'OK'
                });
                return _context21.abrupt('return');

              case 7:
                cif = _this25.getSpvCif(invoice);

                if (cif) {
                  _context21.next = 11;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'warning',
                  title: _this25.$t('general.required'),
                  text: 'Selectați o locație cu CIF fiscal pentru verificarea statusului SPV.',
                  confirmButtonText: 'OK'
                });
                return _context21.abrupt('return');

              case 11:
                idIncarcare = _this25.extractSpvIdIncarcareFromInvoice(invoice) || row.spvIdIncarcare;

                if (idIncarcare) {
                  _context21.next = 15;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'warning',
                  title: _this25.$t('general.required'),
                  text: 'Factura nu are ID de încărcare SPV. Trimiteți factura în SPV mai întâi.',
                  confirmButtonText: 'OK'
                });
                return _context21.abrupt('return');

              case 15:
                invoiceLabel = row.series + '-' + row.invoiceNumber;
                _context21.prev = 16;

                _this25.showSpvProgress(_this25.$t('gestiune.checkSpvStatus'), 'Se verific\u0103 statusul ANAF (ID: ' + idIncarcare + ')...');

                _context21.next = 20;
                return _this25.checkEfacturaStatus(idIncarcare, cif);

              case 20:
                result = _context21.sent;

                result.idIncarcare = result.idIncarcare || idIncarcare;
                spvMessageId = result.spvMessageId || result.idDescarcare || null;


                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();

                if (!(!result.success && !_this25.isEfacturaStatusPending(result))) {
                  _context21.next = 28;
                  break;
                }

                _this25.updateRowSpvStatus(row.id, 'error', idIncarcare, spvMessageId);
                _this25.showEfacturaAlert('error', 'Eroare status SPV', result, invoiceLabel);
                return _context21.abrupt('return');

              case 28:
                if (!_this25.isEfacturaStatusPending(result)) {
                  _context21.next = 32;
                  break;
                }

                _this25.updateRowSpvStatus(row.id, 'pending', idIncarcare, spvMessageId);
                _this25.showEfacturaAlert('warning', 'Factură în procesare ANAF', result, invoiceLabel);
                return _context21.abrupt('return');

              case 32:

                _this25.updateRowSpvStatus(row.id, 'sent', idIncarcare, spvMessageId);
                _this25.showEfacturaAlert('success', _this25.$t('gestiune.checkSpvStatus'), result, invoiceLabel);
                _context21.next = 41;
                break;

              case 36:
                _context21.prev = 36;
                _context21.t0 = _context21['catch'](16);

                console.error('Error checking SPV status:', _context21.t0);
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                _this25.showEfacturaAlert('error', _this25.$t('general.error'), {
                  success: false,
                  cif: cif,
                  mode: _this25.getSpvMode(),
                  standard: 'UBL',
                  idIncarcare: idIncarcare,
                  anafError: _context21.t0.message || 'Verificarea statusului SPV a eșuat.'
                }, invoiceLabel);

              case 41:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, _this25, [[16, 36]]);
      }))();
    },
    fetchNexusInvoiceStatus: function fetchNexusInvoiceStatus(row) {
      var _this26 = this;

      var orderId = row && row.orderNumber;
      if (!orderId) return;

      this.apiRequest('/nexus/invoice/status/' + orderId, 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, function (response) {
        if (response && response.status) {
          _this26.showNexusInvoiceStatusSwal(response.data != null ? response.data : response);
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this26.$t('validations.wentWrong'), 'error');
        }
      });
    },
    showNexusInvoiceStatusSwal: function showNexusInvoiceStatusSwal(payload) {
      var status = Number(payload && (payload.nexus_invoice_status != null ? payload.nexus_invoice_status : payload.status));
      var config = this.getNexusInvoiceStatusSwalConfig(status);
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        title: config.title,
        text: config.text,
        type: config.type
      });
    },
    getNexusInvoiceStatusSwalConfig: function getNexusInvoiceStatusSwalConfig(status) {
      var map = {
        1: { type: 'info', titleKey: 'nexus.invoiceStatus1', textKey: 'nexus.invoiceStatus1Text' },
        2: { type: 'info', titleKey: 'nexus.invoiceStatus2', textKey: 'nexus.invoiceStatus2Text' },
        3: { type: 'success', titleKey: 'nexus.invoiceStatus3', textKey: 'nexus.invoiceStatus3Text' },
        4: { type: 'error', titleKey: 'nexus.invoiceStatus4', textKey: 'nexus.invoiceStatus4Text' },
        5: { type: 'warning', titleKey: 'nexus.invoiceStatus5', textKey: 'nexus.invoiceStatus5Text' },
        6: { type: 'success', titleKey: 'nexus.invoiceStatus6', textKey: 'nexus.invoiceStatus6Text' },
        7: { type: 'error', titleKey: 'nexus.invoiceStatus7', textKey: 'nexus.invoiceStatus7Text' }
      };
      var item = map[status];
      if (!item) {
        return {
          type: 'info',
          title: this.$t('nexus.invoiceStatus'),
          text: this.$t('nexus.invoiceStatusUnknown')
        };
      }
      return {
        type: item.type,
        title: this.$t(item.titleKey),
        text: this.$t(item.textKey)
      };
    },
    fetchNexusInvoiceLogs: function fetchNexusInvoiceLogs(row) {
      var _this27 = this;

      var orderId = row && row.orderNumber;
      if (!orderId) return;

      this.apiRequest('/nexus/invoice/logs/' + orderId, 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, function (response) {
        if (response && response.status) {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
            title: _this27.$t('nexus.invoiceLog'),
            html: '<pre style="text-align:left;max-height:400px;overflow:auto;">' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data != null ? response.data : response, null, 2) + '</pre>'
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this27.$t('validations.wentWrong'), 'error');
        }
      });
    },
    markNexusInvoice: function markNexusInvoice(row) {
      var _this28 = this;

      var orderId = row && row.orderNumber;
      if (!orderId) return;

      var action = row.hasParent ? 'storno' : 'send';
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: orderId,
        action: action
      };

      if (action === 'send') {
        data.invoice_series = row.series;
        data.invoice_number = row.invoiceNumber;
      }

      this.apiRequest('/nexus/invoice/mark', 'POST', data, function (response) {
        if (response && response.status) {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this28.$t('nexus.invoiceMarkSuccess'), 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this28.$t('validations.wentWrong'), 'error');
        }
      });
    },
    getInvoices: function getInvoices() {
      var series = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var tip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'invoice';
      var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var _this29 = this;

      var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var pageSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 25;
      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee22() {
        var externalCompanyId, url, ids, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, id, allLocations, _ids, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _id, response, data;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                externalCompanyId = _this29.companyID;


                _this29.loading = true;

                if (externalCompanyId) {
                  _context22.next = 4;
                  break;
                }

                return _context22.abrupt('return');

              case 4:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/documents?externalCompanyId=' + externalCompanyId + '&tip=' + tip;

                if (series) {
                  url += '&series=' + series;
                }

                url += '&page=' + page + '&limit=' + pageSize;

                if (!location) {
                  _context22.next = 34;
                  break;
                }

                if (!Array.isArray(location.locations)) {
                  _context22.next = 31;
                  break;
                }

                ids = location.locations.map(function (l) {
                  return l.true_id;
                }).filter(Boolean);
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context22.prev = 13;

                for (_iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(ids); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  id = _step3.value;

                  url += '&externalLocationId=' + encodeURIComponent(id);
                }
                _context22.next = 21;
                break;

              case 17:
                _context22.prev = 17;
                _context22.t0 = _context22['catch'](13);
                _didIteratorError3 = true;
                _iteratorError3 = _context22.t0;

              case 21:
                _context22.prev = 21;
                _context22.prev = 22;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 24:
                _context22.prev = 24;

                if (!_didIteratorError3) {
                  _context22.next = 27;
                  break;
                }

                throw _iteratorError3;

              case 27:
                return _context22.finish(24);

              case 28:
                return _context22.finish(21);

              case 29:
                _context22.next = 32;
                break;

              case 31:
                if (location.id) {
                  if (location.true_id) {
                    url += '&externalLocationId=' + encodeURIComponent(location.true_id);
                  }
                }

              case 32:
                _context22.next = 55;
                break;

              case 34:
                allLocations = _this29.groupedLocations.flatMap(function (group) {
                  return group.locations;
                });
                _ids = allLocations.map(function (l) {
                  return l.true_id;
                }).filter(Boolean);
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context22.prev = 39;

                for (_iterator4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(_ids); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  _id = _step4.value;

                  url += '&externalLocationId=' + encodeURIComponent(_id);
                }
                _context22.next = 47;
                break;

              case 43:
                _context22.prev = 43;
                _context22.t1 = _context22['catch'](39);
                _didIteratorError4 = true;
                _iteratorError4 = _context22.t1;

              case 47:
                _context22.prev = 47;
                _context22.prev = 48;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 50:
                _context22.prev = 50;

                if (!_didIteratorError4) {
                  _context22.next = 53;
                  break;
                }

                throw _iteratorError4;

              case 53:
                return _context22.finish(50);

              case 54:
                return _context22.finish(47);

              case 55:

                clearTimeout(_this29.loadingTimeout);
                _this29.loadingTimeout = setTimeout(function () {
                  _this29.loading = true;
                }, 100);
                _context22.prev = 57;
                _context22.next = 60;
                return fetch(url);

              case 60:
                response = _context22.sent;
                _context22.next = 63;
                return response.json();

              case 63:
                data = _context22.sent;

                if (!Array.isArray(data.documents)) {
                  _context22.next = 75;
                  break;
                }

                clearTimeout(_this29.loadingTimeout);
                _this29.loading = false;

                _this29.totalItems = data.total || 0;
                _this29.currentPage = data.currentPage || page;
                _this29.pageSize = data.pageSize || pageSize;

                _this29.tableData = data.documents.map(function (invoice) {
                  var vatValue = 0;
                  if (invoice.vatTotals && __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(invoice.vatTotals) === 'object') {
                    vatValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(invoice.vatTotals).reduce(function (sum, val) {
                      return sum + val;
                    }, 0);
                  }

                  var orderInfo = _this29.extractOrderInfoFromInvoice(invoice);

                  var row = {
                    id: invoice._id || invoice.id,
                    invoiceNumber: invoice.invoiceNumber,
                    client: invoice.customer ? invoice.customer.name : 'N/A',
                    issueDate: invoice.date,
                    valueNoVAT: invoice.subtotal.toFixed(2) + ' ' + invoice.currency,
                    vatValue: vatValue.toFixed(2) + ' ' + invoice.currency,
                    totalValue: invoice.total.toFixed(2) + ' ' + invoice.currency,
                    series: invoice.series || 'N/A',
                    hasParent: !!invoice.parentDocument,
                    orderDate: orderInfo.orderDate,
                    orderNumber: orderInfo.orderNumber,
                    bonData: orderInfo.bonData,
                    bonNumber: orderInfo.bonNumber,
                    paymentType: orderInfo.paymentType,
                    orderInfoDisplay: orderInfo.orderNumber || orderInfo.bonNumber || '',
                    hasOrderInfo: !!(orderInfo.orderDate || orderInfo.orderNumber || orderInfo.bonData || orderInfo.bonNumber || orderInfo.paymentType),
                    _orderInfoLoading: false,
                    rawInvoice: invoice
                  };

                  return row;
                }).map(function (row) {
                  return _this29.applySpvStatusToRow(row, row.rawInvoice);
                });

                _context22.next = 73;
                return _this29.refreshInvoicesSpvStatuses(_this29.tableData);

              case 73:
                _context22.next = 76;
                break;

              case 75:
                console.error('Invalid data format:', data);

              case 76:
                _context22.next = 81;
                break;

              case 78:
                _context22.prev = 78;
                _context22.t2 = _context22['catch'](57);

                console.error('Error fetching invoices:', _context22.t2);

              case 81:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, _this29, [[13, 17, 21, 29], [22,, 24, 28], [39, 43, 47, 55], [48,, 50, 54], [57, 78]]);
      }))();
    },
    downloadExcel: function downloadExcel(row) {
      var _this30 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee23() {
        var series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                series = row.series;
                invoiceNumber = row.invoiceNumber;
                externalCompanyId = _this30.companyID;

                if (!(!series || !invoiceNumber || !externalCompanyId)) {
                  _context23.next = 6;
                  break;
                }

                alert('Missing series, invoice number or company ID.');
                return _context23.abrupt('return');

              case 6:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/invoice/' + series + '-' + invoiceNumber + '/xls?externalCompanyId=' + externalCompanyId;
                _context23.prev = 7;
                _context23.next = 10;
                return fetch(url);

              case 10:
                response = _context23.sent;

                if (!response.ok) {
                  _context23.next = 22;
                  break;
                }

                _context23.next = 14;
                return response.blob();

              case 14:
                blob = _context23.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + invoiceNumber + '.xls';
                link.click();
                URL.revokeObjectURL(link.href);
                _context23.next = 23;
                break;

              case 22:
                console.error('Error downloading invoice:', response.statusText);

              case 23:
                _context23.next = 28;
                break;

              case 25:
                _context23.prev = 25;
                _context23.t0 = _context23['catch'](7);

                console.error('Error fetching invoice:', _context23.t0);

              case 28:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, _this30, [[7, 25]]);
      }))();
    },
    downloadInvoice: function downloadInvoice(row) {
      var _this31 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee24() {
        var series, invoiceNumber, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                series = row.series;
                invoiceNumber = row.invoiceNumber;
                externalCompanyId = _this31.companyID;

                if (!(!series || !invoiceNumber)) {
                  _context24.next = 6;
                  break;
                }

                alert('Missing series or invoice number.');
                return _context24.abrupt('return');

              case 6:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/invoice/' + series + '-' + invoiceNumber + '/pdf?externalCompanyId=' + externalCompanyId;
                _context24.prev = 7;
                _context24.next = 10;
                return fetch(url);

              case 10:
                response = _context24.sent;

                if (!response.ok) {
                  _context24.next = 22;
                  break;
                }

                _context24.next = 14;
                return response.blob();

              case 14:
                blob = _context24.sent;
                link = document.createElement('a');

                link.href = URL.createObjectURL(blob);
                link.download = series + '-' + invoiceNumber + '.pdf';
                link.click();
                URL.revokeObjectURL(link.href);
                _context24.next = 23;
                break;

              case 22:
                console.error('Error downloading invoice:', response.statusText);

              case 23:
                _context24.next = 28;
                break;

              case 25:
                _context24.prev = 25;
                _context24.t0 = _context24['catch'](7);

                console.error('Error fetching invoice:', _context24.t0);

              case 28:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, _this31, [[7, 25]]);
      }))();
    },
    handleDeleteInvoice: function handleDeleteInvoice(id) {
      var _this32 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee26() {
        var row, rowIndex, status;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                console.log(id);

                if (id) {
                  _context26.next = 4;
                  break;
                }

                console.error('Missing Invoice ID for deletion.');
                return _context26.abrupt('return');

              case 4:
                row = _this32.tableData.find(function (item) {
                  return item.id === id;
                });
                rowIndex = row ? _this32.tableData.indexOf(row) : -1;

                if (!(!row || rowIndex !== 0)) {
                  _context26.next = 8;
                  break;
                }

                return _context26.abrupt('return');

              case 8:
                status = _this32.normalizeSpvStatusKey(row.spvStatus || row.rawInvoice.spvStatus || _this32.resolveSpvStatusFromInvoice(row.rawInvoice));

                if (!(status === 'sent' || status === 'pending')) {
                  _context26.next = 12;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  type: 'info',
                  title: _this32.$t('general.delete'),
                  text: status === 'pending' ? 'Factura în procesare SPV nu poate fi ștearsă.' : 'Factura trimisă în SPV nu poate fi ștearsă.',
                  confirmButtonText: 'OK'
                });
                return _context26.abrupt('return');

              case 12:

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Ești sigur?',
                  text: 'Această acțiune va șterge definitiv factura!',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Da, șterge!',
                  cancelButtonText: 'Anulează'
                }).then(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee25(result) {
                    var response, data;
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
                      while (1) {
                        switch (_context25.prev = _context25.next) {
                          case 0:
                            if (!result) {
                              _context25.next = 19;
                              break;
                            }

                            _context25.prev = 1;
                            _context25.next = 4;
                            return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                              method: 'DELETE',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                                type: 'invoice',
                                id: id,
                                externalCompanyId: _this32.companyID
                              })
                            });

                          case 4:
                            response = _context25.sent;

                            if (response.ok) {
                              _context25.next = 7;
                              break;
                            }

                            throw new Error('HTTP error! Status: ' + response.status);

                          case 7:
                            _context25.next = 9;
                            return response.json();

                          case 9:
                            data = _context25.sent;

                            console.log('Invoice deleted successfully:', data);

                            __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                              title: 'Succes!',
                              text: 'Factura a fost ștearsă cu succes.',
                              type: 'success',
                              timer: 2000,
                              showConfirmButton: false
                            });

                            _this32.getInvoices();
                            _context25.next = 19;
                            break;

                          case 15:
                            _context25.prev = 15;
                            _context25.t0 = _context25['catch'](1);

                            console.error('Error deleting Invoice:', _context25.t0);

                            __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                              title: 'Eroare!',
                              text: 'A apărut o problemă la ștergerea facturii.',
                              type: 'error',
                              timer: 2000,
                              showConfirmButton: false
                            });

                          case 19:
                          case 'end':
                            return _context25.stop();
                        }
                      }
                    }, _callee25, _this32, [[1, 15]]);
                  }));

                  return function (_x18) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 13:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, _this32);
      }))();
    }
  }
});

/***/ }),

/***/ "sbNK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CharismaLocationReceipt_vue__ = __webpack_require__("dnM/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da8dc976_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CharismaLocationReceipt_vue__ = __webpack_require__("naAb");
function injectStyle (ssrContext) {
  __webpack_require__("EB1b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da8dc976"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CharismaLocationReceipt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da8dc976_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CharismaLocationReceipt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sdfu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Maps_DeliveryGoogleMaps_vue__ = __webpack_require__("D+CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ZoneAvailabilityEditor_vue__ = __webpack_require__("P77k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zoneAvailability__ = __webpack_require__("ohf7");











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DeliveryGoogleMaps: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Maps_DeliveryGoogleMaps_vue__["a" /* default */],
    ZoneAvailabilityEditor: __WEBPACK_IMPORTED_MODULE_6__ZoneAvailabilityEditor_vue__["a" /* default */],
    PSwitch: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      view: 'list',
      loading: true,
      mapReady: false,
      attemptedSave: false,
      formError: '',
      zones: [],
      overlayZoneIds: [],
      model: this.emptyModel(),
      vatOptions: [],
      deliveryTaxRules: [],
      taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
      currency: '',
      mapContext: { google_maps_api_key: '', city: '', lat: null, lng: null, name: '', token: null }
    };
  },

  computed: {
    overlayOptions: function overlayOptions() {
      var _this = this;

      return this.zones.filter(function (z) {
        return z.id !== _this.model.id && z.shape && z.shape.type;
      });
    },
    overlayZones: function overlayZones() {
      var _this2 = this;

      return this.overlayOptions.filter(function (z) {
        return _this2.overlayZoneIds.indexOf(z.id) !== -1;
      });
    },
    mapZones: function mapZones() {
      return [this.model].concat(this.overlayZones);
    },
    mapKey: function mapKey() {
      return 'zmap-' + (this.model.id || 'new') + '-' + this.overlayZoneIds.slice().sort().join('_');
    }
  },
  created: function created() {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']);
    this.loadMapContext();
    this.getData();
    this.loadDeliveryTaxes();
  },

  methods: {
    sessionData: function sessionData() {
      var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, extra);
    },
    emptyModel: function emptyModel() {
      return {
        id: null,
        name: '',
        shipping_cost: 0,
        shipping_cost_vat_id: null,
        shipping_pos_id: '',
        min_order_value: 0,
        extra_delivery_time: 0,
        shape: {},
        override_payment_method: false,
        accept_cash: false,
        accept_card: false,
        accept_pos: false,
        delivery_range_cost_rules: []
      };
    },
    getData: function getData() {
      var _this3 = this;

      this.loading = true;
      this.apiRequest('/delivery-zone', 'GET', this.sessionData(), function (response) {
        if (response.status === true) {
          _this3.zones = response.data;
        }
        _this3.loading = false;
      });
    },
    loadDeliveryTaxes: function loadDeliveryTaxes() {
      var _this4 = this;

      if (this.taxesVersion !== 2) return;
      this.apiRequest('/taxes-v2/rules', 'GET', this.sessionData(), function (response) {
        _this4.deliveryTaxRules = response.status ? response.data || [] : [];
      });
    },
    zoneDeliveryTaxes: function zoneDeliveryTaxes(zoneId) {
      return this.deliveryTaxRules.filter(function (rule) {
        if (!rule || rule.applies_to !== 'delivery') return false;
        var ranges = rule.delivery_range_ids || [];
        return !ranges.length || ranges.some(function (id) {
          return String(id) === String(zoneId);
        });
      });
    },
    loadMapContext: function loadMapContext() {
      var _this5 = this;

      var companyData = this.$session.get('selectedCompanyData') || {};
      var locations = companyData.locations_details || [];
      this.apiRequest('/location/vat', 'GET', this.sessionData({ location_ids: null }), function (response) {
        if (response.status === true) {
          _this5.vatOptions = response.data || [];
        }
        var tokensWithVat = {};
        _this5.vatOptions.forEach(function (v) {
          tokensWithVat[v.location_token] = true;
        });
        var chosen = locations.find(function (l) {
          return l.google_maps_api_key && tokensWithVat[l.token];
        }) || locations.find(function (l) {
          return l.google_maps_api_key;
        }) || locations[0];
        if (chosen) {
          _this5.mapContext = {
            google_maps_api_key: chosen.google_maps_api_key || '',
            city: chosen.city || '',
            lat: null,
            lng: null,
            name: chosen.name || '',
            token: chosen.token
          };
        }
      });
    },
    openForm: function openForm(id) {
      var _this6 = this;

      this.formError = '';
      this.attemptedSave = false;
      this.mapReady = false;
      this.overlayZoneIds = [];
      if (id) {
        var zone = this.zones.find(function (z) {
          return z.id === id;
        });

        var clone = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(zone));
        if (!clone.shape || Array.isArray(clone.shape)) clone.shape = clone.shape && clone.shape.length ? clone.shape : {};
        if (!clone.delivery_range_cost_rules) clone.delivery_range_cost_rules = [];
        this.model = clone;
      } else {
        this.model = this.emptyModel();
      }
      this.view = 'form';

      this.$nextTick(function () {
        _this6.mapReady = true;
      });
    },
    backToList: function backToList() {
      this.mapReady = false;
      this.view = 'list';
      this.getData();
      this.loadDeliveryTaxes();
    },
    toggleActive: function toggleActive(zone, active) {
      var _this7 = this;

      var previous = zone.active !== false;
      this.$set(zone, 'active', active);
      this.apiRequest('/delivery-zone/' + zone.id + '/active', 'POST', this.sessionData({ active: active }), function (response) {
        if (response.success === true) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ text: _this7.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1200 }).then(function () {}).catch(function () {});
        } else {
          _this7.$set(zone, 'active', previous);
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ text: _this7.firstError(response.errors) || _this7.$t('validations.wentWrong'), type: 'error', showConfirmButton: false, timer: 2500 }).then(function () {}).catch(function () {});
        }
      });
    },
    handleUpdateZone: function handleUpdateZone(zone) {
      this.model = zone;
    },
    cloneZone: function cloneZone(zone) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: self.$t('deliveryPreferences.cloneName'),
        input: 'text',
        inputValue: (zone.name || '') + ' (copy)',
        showCancelButton: true,
        confirmButtonText: self.$t('deliveryPreferences.clone')
      }).then(function (result) {
        var name = result && result.value !== undefined ? result.value : result;
        if (name === false || name === undefined || name === null) return;
        self.loading = true;
        self.apiRequest('/delivery-zone/' + zone.id + '/clone', 'POST', self.sessionData({ name: name }), function (response) {
          self.loading = false;
          if (response.success === true) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ text: self.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(function () {}).catch(function () {});
            self.getData();
          } else {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ text: self.firstError(response.errors) || self.$t('validations.wentWrong'), type: 'error', showConfirmButton: false, timer: 2500 }).then(function () {}).catch(function () {});
          }
        });
      }).catch(function () {});
    },
    save: function save() {
      var _this8 = this;

      this.attemptedSave = true;
      var hasShape = !!(this.model.shape && this.model.shape.type);
      if (!this.model.name || !hasShape) {
        if (!this.model.name && !hasShape) {
          this.formError = this.$t('general.fillRequiredFields') + ' ' + this.$t('deliveryPreferences.drawShapeRequired');
        } else if (!this.model.name) {
          this.formError = this.$t('general.fillRequiredFields');
        } else {
          this.formError = this.$t('deliveryPreferences.drawShapeRequired');
        }
        return;
      }
      var availabilityError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__zoneAvailability__["a" /* zoneAvailabilityError */])(this.model, this.$t.bind(this));
      if (availabilityError) {
        this.formError = availabilityError;
        return;
      }
      this.formError = '';
      this.loading = true;

      var costRules = (this.model.delivery_range_cost_rules || []).filter(function (r) {
        return !r.deleted;
      }).map(function (r) {
        return {
          id: r.id,
          min_order_value: r.min_order_value,
          shipping_cost: r.shipping_cost,
          shipping_pos_id: r.shipping_pos_id,
          distance_in_km: r.distance_in_km,
          extra_delivery_time: r.extra_delivery_time
        };
      });

      var payload = this.sessionData(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
        name: this.model.name,
        shipping_cost: this.model.shipping_cost,
        shipping_cost_vat_id: this.model.shipping_cost_vat_id,
        shipping_pos_id: this.model.shipping_pos_id,
        min_order_value: this.model.min_order_value,
        extra_delivery_time: this.model.extra_delivery_time,
        shape: this.model.shape,
        override_payment_method: this.model.override_payment_method,
        accept_cash: this.model.accept_cash,
        accept_card: this.model.accept_card,
        accept_pos: this.model.accept_pos,
        cost_rules: costRules
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__zoneAvailability__["e" /* zoneAvailabilityPayload */])(this.model)));

      var url = this.model.id ? '/delivery-zone/' + this.model.id : '/delivery-zone';
      var method = this.model.id ? 'PUT' : 'POST';

      this.apiRequest(url, method, payload, function (response) {
        _this8.loading = false;
        if (response.success === true) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ text: _this8.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(function () {}).catch(function () {});
          _this8.backToList();
        } else {
          _this8.formError = _this8.firstError(response.errors);
        }
      });
    },
    remove: function remove() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: self.$t('deliveryPreferences.deleteConfirm'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result && (result.value || result === true)) {
          self.loading = true;
          self.apiRequest('/delivery-zone/' + self.model.id, 'PUT', self.sessionData({ delete: true }), function (response) {
            self.loading = false;
            if (response.success === true) {
              __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ text: self.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(function () {}).catch(function () {});
              self.backToList();
            } else {
              __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({ text: self.firstError(response.errors) || self.$t('validations.wentWrong'), type: 'error', showConfirmButton: false, timer: 2500 }).then(function () {}).catch(function () {});
            }
          });
        }
      }).catch(function () {});
    },
    firstError: function firstError(errors) {
      if (!errors) return '';
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors);
      if (!keys.length) return '';
      var v = errors[keys[0]];
      return Array.isArray(v) ? v[0] : v;
    }
  }
});

/***/ }),

/***/ "seR9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row customers"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-xs-12 noprint"},[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"nowrap","gap":"8px","align-items":"flex-end","flex":"0 1 auto","margin-top":"20px"}},[_c('div',{staticClass:"form-group",staticStyle:{"max-width":"150px"}},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":'Introdu ID-ul'},model:{value:(_vm.searchId),callback:function ($$v) {_vm.searchId=$$v},expression:"searchId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"max-width":"250px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsPages.searchNameEmail')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('general.search')},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsPages.dateTime')))]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"name":['date_from', 'date_to'],"disabled":_vm.loading},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('label',[_vm._v(_vm._s(_vm.$t('addOrder.choosePay')))]),_vm._v(" "),_c('el-select',{staticClass:"filter-select",attrs:{"multiple":"","collapse-tags":"","placeholder":_vm.$t('settingsPages.filters')},model:{value:(_vm.selectedPaymentMethod),callback:function ($$v) {_vm.selectedPaymentMethod=$$v},expression:"selectedPaymentMethod"}},_vm._l((_vm.paymentMethods),function(val,key){return _c('el-option',{key:key,attrs:{"label":val.name,"value":val.name}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsPages.ordersFilter')))]),_vm._v(" "),_c('el-select',{staticClass:"filter-select",attrs:{"multiple":"","collapse-tags":"","placeholder":_vm.$t('settingsPages.filters')},model:{value:(_vm.filters),callback:function ($$v) {_vm.filters=$$v},expression:"filters"}},_vm._l((_vm.filterOptions),function(loc,key){return _c('el-option',{key:key,attrs:{"label":loc,"value":key}})}))],1),_vm._v(" "),_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.handleSearch}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"data-table customers-table"},[_c('el-table',{attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData'),"row-class-name":_vm.rowClass},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"label":_vm.$t('customers.id'),"prop":"id","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                #"+_vm._s(scope.row.id)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('customers.email'),"prop":"email"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.email)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('customers.phone'),"prop":"phone"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.phone)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('customers.fidelities'),"prop":"label_level"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.label_level ? scope.row.label_level.label_name : scope.row.label_level)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('orders.counterPerCustomer'),"prop":"counter_orders_per_customer","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.counter_orders_per_customer)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('customers.totalSales'),"prop":"sales","width":"140","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.sales && scope.row.sales > 0 ? _vm.formatMoneyAmount(scope.row.sales) : '-')+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('marketingOffers.actions'),"width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                    ▾\n                  ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.goToRecord(scope.row, $event, {})}}},[_vm._v("\n                      "+_vm._s(_vm.$t('gestiune.view'))+"\n                    ")])],1)],1)]}}])})],1),_vm._v(" "),_c('el-pagination',{staticStyle:{"margin-top":"15px","text-align":"center"},attrs:{"total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"pager-count":_vm.pagerCount,"current-page":_vm.paginationDef.page,"layout":"prev, pager, next, total"},on:{"current-change":function($event){_vm.handlePageChange($event)},"prev-click":function($event){_vm.handlePageChange($event)},"next-click":function($event){_vm.handlePageChange($event)}}})],1)])])]),_vm._v(" "),(_vm.showForm())?_c('customer-view',{ref:"customerForm",attrs:{"route":_vm.route}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "seZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tabs_App_vue__ = __webpack_require__("AnFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tabs_CompanyWeb_vue__ = __webpack_require__("XKKy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MeasurementsUnits_MeasurementsUnitsForm_vue__ = __webpack_require__("QHzq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MeasurementsUnits_MeasurementsUnits_vue__ = __webpack_require__("G6CG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableZones_TableZonesForm_vue__ = __webpack_require__("YngB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TableZones_TableZones_vue__ = __webpack_require__("C47s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableManagement_TableManagementForm_vue__ = __webpack_require__("kQ0V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableManagement_TableManagement_vue__ = __webpack_require__("+suy");












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppForm: __WEBPACK_IMPORTED_MODULE_1__Tabs_App_vue__["a" /* default */],
    CompanyWebForm: __WEBPACK_IMPORTED_MODULE_2__Tabs_CompanyWeb_vue__["a" /* default */],
    MeasurementsUnitsForm: __WEBPACK_IMPORTED_MODULE_3__MeasurementsUnits_MeasurementsUnitsForm_vue__["a" /* default */],
    MeasurementsUnitsList: __WEBPACK_IMPORTED_MODULE_4__MeasurementsUnits_MeasurementsUnits_vue__["a" /* default */],
    TableZoneForm: __WEBPACK_IMPORTED_MODULE_5__TableZones_TableZonesForm_vue__["a" /* default */],
    TableZoneList: __WEBPACK_IMPORTED_MODULE_6__TableZones_TableZones_vue__["a" /* default */],
    TableManagementForm: __WEBPACK_IMPORTED_MODULE_7__TableManagement_TableManagementForm_vue__["a" /* default */],
    TableManagementList: __WEBPACK_IMPORTED_MODULE_8__TableManagement_TableManagement_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tabName: 'app',

      isApp: false,
      isCompanyWeb: false,
      isMeasurementsUnits: true,
      isTableZones: false,
      isTableManager: false,

      selectedMeasurementsUnits: false,
      selectedZone: false,
      selectedTable: false,

      model: {},
      defaultData: {},
      websiteData: [],

      posUsers: [] };
  },

  computed: {
    formattedUsers: function formattedUsers() {
      return this.posUsers.map(function (user) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user, {
          fullname: user.firstname + ' ' + user.lastname
        });
      });
    }
  },
  created: function created() {
    this.getModelData();

    this.getPosUsers();
  },

  methods: {
    getPosUsers: function getPosUsers() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this.posUsers = response.data.pos_user;
        }
      });
    },
    getModelData: function getModelData() {
      var _this2 = this;

      var token = this.$session.get('token');
      var companyID = this.$session.get('selectedCompany');

      this.apiRequest('/settings/general/' + companyID, 'GET', { token: token }, function (response2) {
        if (response2.status === true) {
          _this2.model = response2.data[0];
          _this2.model.selected_languages = response2.data[0].languages.map(function (lang) {
            return {
              value: lang.id,
              label: lang.name
            };
          });
        }
      });

      this.apiRequest('/settings/website', 'GET', {
        token: token,
        company_id: companyID
      }, function (response) {
        if (response.status === true) {
          _this2.websiteData = response.data;
          console.log('this.websiteData', _this2.websiteData);
        }
      });
    },
    openTab: function openTab(tab) {
      this.isApp = false;
      this.isCompanyWeb = false;
      this.isMeasurementsUnits = false;
      this.isTableZones = false;
      this.isTableManager = false;

      var tabMap = {
        app: 'isApp',
        companyWeb: 'isCompanyWeb',
        measurementsUnits: 'isMeasurementsUnits',
        tableZones: 'isTableZones',
        tableManager: 'isTableManager'
      };

      var prop = tabMap[tab] || 'isTableManager';
      this[prop] = true;
      this.tabName = tab;
    },
    onUserSubmit: function onUserSubmit(model, isValid) {},
    tableManagementUpdate: function tableManagementUpdate() {
      this.selectedTable = false;
      if (this.$refs.tableManagement) this.$refs.tableManagement.getData();
    },
    measurementsUnitsUpdate: function measurementsUnitsUpdate() {
      this.selectedMeasurementsUnits = false;
      if (this.$refs.tableMeasurementsUnits) this.$refs.tableMeasurementsUnits.getData();
    },
    tableZoneUpdate: function tableZoneUpdate() {
      this.selectedZone = false;
      if (this.$refs.tableZone) this.$refs.tableZone.getData();
    },
    getTable: function getTable(id) {
      this.selectedTable = id;
    },
    getMeasurementsUnits: function getMeasurementsUnits(id) {
      this.selectedMeasurementsUnits = id;
    },
    getZone: function getZone(id) {
      this.selectedZone = id;
    }
  }
});

/***/ }),

/***/ "sjK5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventarView"},[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons mar-rt-10"}),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.addInitialStock($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('gestiune.addInitialStock'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"data-table"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData'),"element-loading-text":"Se încarcă..."}},[_c('el-table-column',{attrs:{"label":"Data Document"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.formatDate(scope.row.date))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"gestiune","label":"Gestiune"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"number_of_products","label":"Nr. Produse"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('general.actions'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',{attrs:{"trigger":"click","placement":"bottom-end"}},[_c('span',{staticClass:"arrow-box"},[_vm._v("\n                  ▾\n                ")]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"custom-dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.editInitialStock(scope.row)}}},[_vm._v("\n                   "+_vm._s(_vm.$t('general.see'))+"\n                  ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadFile(scope.row, 'pdf')}}},[_vm._v("\n                    "+_vm._s(_vm.$t('invoice.download'))+"\n                  ")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){_vm.downloadFile(scope.row, 'xls')}}},[_vm._v("\n                    "+_vm._s(_vm.$t('gestiune.downloadExcel'))+"\n                  ")])],1)],1)]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "slG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OffersForm_vue__ = __webpack_require__("41va");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);







var _components;






__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'OffersForm', __WEBPACK_IMPORTED_MODULE_7__OffersForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      offerModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onOfferSubmit: function onOfferSubmit(model, isValid) {
      this.offerModel = model;
    }
  }
});

/***/ }),

/***/ "smDL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row donation-campaigns-report"},[_c('div',{staticClass:"col-xl-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-start","gap":"10px","flex-wrap":"wrap"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px","align-items":"flex-end","flex":"1 1 auto"}},[_c('div',{staticClass:"form-group donation-campaigns-report__name-filter",staticStyle:{"flex":"0 0 220px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('donationCampaigns.search')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('donationCampaigns.name'),"size":"small","clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applyFilters($event)}},model:{value:(_vm.searchName),callback:function ($$v) {_vm.searchName=$$v},expression:"searchName"}})],1),_vm._v(" "),(_vm.locations.length)?_c('div',{staticClass:"form-group donation-campaigns-report__location-filter",staticStyle:{"margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","collapse-tags":"","clearable":"","filterable":"","size":"small","placeholder":_vm.$t('general.select')},model:{value:(_vm.locationFilter),callback:function ($$v) {_vm.locationFilter=$$v},expression:"locationFilter"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:loc.true_id || loc.id,attrs:{"label":loc.name,"value":loc.true_id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.applyFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"data-table",staticStyle:{"margin-top":"20px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.onRowClick}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('donationCampaigns.id'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('donationCampaigns.name'),"min-width":"180","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('donationCampaigns.location'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"locations-cell",attrs:{"title":_vm.getLocationNames(props.row)}},[_c('span',{staticClass:"locations-name"},[_vm._v(_vm._s(_vm.getVisibleLocationName(props.row)))]),_vm._v(" "),(_vm.getHiddenLocationCount(props.row))?_c('span',{staticClass:"locations-more"},[_vm._v("\n                    +"+_vm._s(_vm.getHiddenLocationCount(props.row))+"\n                  ")]):_vm._e()])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('donationCampaigns.startEnd'),"min-width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatDate(props.row.starts_at || props.row.date_start))+" - "+_vm._s(_vm.formatDate(props.row.ends_at || props.row.date_end))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('orders.status'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.active ? _vm.$t('general.active') : _vm.$t('general.inactive'))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('donationCampaigns.targetAmount'),"width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(parseFloat(props.row.target_amount || 0).toFixed(2))+" "+_vm._s(_vm.currency)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('donationCampaigns.collectedAmount'),"width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(parseFloat(props.row.raised_total || 0).toFixed(2))+" "+_vm._s(_vm.currency)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('donationCampaigns.progress'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(_vm.formatProgress(props.row))+"\n              ")]}}])})],1),_vm._v(" "),_c('div',{staticClass:"donation-campaigns-report__pagination"},[_c('el-pagination',{attrs:{"layout":"prev, pager, next","total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"current-page":_vm.paginationDef.page},on:{"update:currentPage":function($event){_vm.$set(_vm.paginationDef, "page", $event)},"current-change":_vm.handlePageChange}})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "smpd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library__ = __webpack_require__("YE/A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zxing_library__);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "stream-barcode-reader",

    data: function data() {
        return {
            isLoading: true,
            codeReader: new __WEBPACK_IMPORTED_MODULE_0__zxing_library__["BrowserMultiFormatReader"](),
            isMediaStreamAPISupported: navigator && navigator.mediaDevices && "enumerateDevices" in navigator.mediaDevices
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (!this.isMediaStreamAPISupported) {
            throw new __WEBPACK_IMPORTED_MODULE_0__zxing_library__["Exception"]("Media Stream API is not supported");
            return;
        }

        this.start();
        this.$refs.scanner.oncanplay = function (event) {
            _this.isLoading = false;
            _this.$emit("loaded");
        };
    },
    beforeDestroy: function beforeDestroy() {
        this.codeReader.reset();
    },


    methods: {
        start: function start() {
            var _this2 = this;

            this.codeReader.decodeFromVideoDevice(undefined, this.$refs.scanner, function (result, err) {
                if (result) {
                    _this2.$emit("decode", result.text);
                }
            });
        }
    }
});

/***/ }),

/***/ "so2V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "soYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptions_vue__ = __webpack_require__("FfsB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c308fb78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptions_vue__ = __webpack_require__("eTop");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c308fb78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sqsr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaigns_vue__ = __webpack_require__("ftEk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa1302ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaigns_vue__ = __webpack_require__("6sHl");
function injectStyle (ssrContext) {
  __webpack_require__("I8zs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa1302ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonationCampaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa1302ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonationCampaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "stHs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "svfB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "swtX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-top-bar',{attrs:{"title":_vm.$t('reports.operatorSalesReport')}}),_vm._v(" "),_c('div',{staticClass:"sales-report"},[_c('div',{staticClass:"row mar-bt-15"},[_c('div',{staticClass:"col-md-6"},[(_vm.showLocations)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orders.location),expression:"orders.location"}],staticClass:"form-control mar-bt-15",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.orders, "location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","selected":"","label":_vm.$t('general.all')}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return [_c('option',{attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(_vm._s(loc.name))])]})],2)]):_vm._e(),_vm._v(" "),(_vm.posUsers)?_c('div',{staticClass:"mb-3 w-100"},[_c('label',{staticClass:"form-label text-start w-100"},[_vm._v(_vm._s(_vm.$t('reports.operator')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.posUsers,"multiple":"","placeholder":_vm.$t('general.alls')},model:{value:(_vm.selectedPosUser),callback:function ($$v) {_vm.selectedPosUser=$$v},expression:"selectedPosUser"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"center-sales-report-stats",staticStyle:{"height":"225px !important"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"card-content"},[_c('div',{staticClass:"report-row slim"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.orderCounter')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(Number(_vm.productsTableDataTotals.counter || 0)))])]),_vm._v(" "),_c('div',{staticClass:"report-row slim"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.salesChart')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.productsTableDataTotals.total || 0))))])]),_vm._v(" "),_c('div',{staticClass:"report-row slim"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.discount')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.productsTableDataTotals.discount || 0))))])]),_vm._v(" "),_c('div',{staticClass:"report-row slim"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.tips')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.productsTableDataTotals.tips || 0))))])]),_vm._v(" "),_c('div',{staticClass:"report-row slim"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.protocol')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.productsTableDataTotals.total_protocol || 0))))])]),_vm._v(" "),_c('div',{staticClass:"report-row slim"},[_c('div',{staticClass:"report-col left-align"},[_vm._v(_vm._s(_vm.$t('reports.staffFood')))]),_vm._v(" "),_c('div',{staticClass:"report-col right-align"},[_vm._v(_vm._s(_vm.formatMoneyAmount(Number(_vm.productsTableDataTotals.total_staff_food || 0))))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"pull-left"},[_c('el-date-picker',{attrs:{"type":"daterange","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","name":_vm.pickerNames,"picker-options":_vm.pickerOptions},model:{value:(_vm.orders.valid),callback:function ($$v) {_vm.$set(_vm.orders, "valid", $$v)},expression:"orders.valid"}})],1),_c('div',{staticClass:"pull-left",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-left":"10px"}},[_vm._v("\n          "+_vm._s(_vm.$t('general.from'))+"\n          "),_c('el-time-select',{staticClass:"mar-rt-5",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_from,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_from),callback:function ($$v) {_vm.valid_from=$$v},expression:"valid_from"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.to'))+"\n          "),_c('el-time-select',{staticClass:"mar-lt-5",attrs:{"placeholder":_vm.$t('catalogProd.timePlaceholder'),"value":_vm.valid_to,"change":_vm.changeValidFrom(),"picker-options":{
              start: '00:00',
              step: '00:10',
              end: '24:00'
            }},model:{value:(_vm.valid_to),callback:function ($$v) {_vm.valid_to=$$v},expression:"valid_to"}})],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"pull-left search-button-reports"},[_c('div',{staticClass:"btn btn-icon btn-info btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.updateData}},[_c('i',{staticClass:"ti-search"})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports form-group pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.exportData()}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"text-align":"left","margin":"20px 0px"}},[_vm._v(_vm._s(_vm.$t('reports.filteredData'))+" "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[0])+" "+_vm._s(_vm.valid_from)+":00")]),_vm._v(" - "),_c('b',[_vm._v(_vm._s(_vm.orders.valid[1])+" "+_vm._s(_vm.valid_to)+":59")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-content total-pagination reports-center-columns"},[_c('chart-bars-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"topProductSales",attrs:{"chart-data":_vm.topProductSales.data,"chart-options":_vm.topProductSales.options}},[(_vm.noData)?[_c('div',{staticClass:"no-data-message",staticStyle:{"text-align":"center","margin":"20px"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('reports.noDataAvailable')))])])]:_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend",staticStyle:{"display":"flex","flex-wrap":"wrap"}},_vm._l((_vm.topProductSales.data.labels),function(label,index){return _c('div',{key:index,staticStyle:{"display":"flex","align-items":"center","margin-right":"12px"}},[_c('i',{staticClass:"fa fa-circle",style:({ color: _vm.colors[index % _vm.colors.length], marginRight: '5px' })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(label)+" - "+_vm._s(_vm.topProductSales.data.series[0][index]))])])}))])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('data-tables-server',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"sales-table",ref:"reportsTable",staticClass:"report-sales",staticStyle:{"width":"100%"},attrs:{"data":_vm.ordersTableData.data,"search-def":{show: false},"total":_vm.ordersTableData.total,"pagination-props":_vm.paginationProps},on:{"query-change":_vm.paginationChanged}},[_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"operator_name","label":_vm.$t('reports.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"counter","label":_vm.$t('reports.countProtocolStaff')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(Number(props.row.counter))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"total","label":_vm.$t('reports.salesProtocolStaff')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"count_protocol","label":_vm.$t('reports.countProtocol')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(Number(props.row.count_protocol))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"total_protocol","label":_vm.$t('reports.salesProtocol')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_protocol)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"count_staff_food","label":_vm.$t('reports.countStaff')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(Number(props.row.count_staff_food))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"total_staff_food","label":_vm.$t('reports.salesStaff')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_staff_food)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"combined_discount","label":_vm.$t('reports.discount')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.combined_discount)))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"class-name":"centered-cell","min-width":80,"prop":"total_tips","label":_vm.$t('reports.tips')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatMoneyAmount(Number(props.row.total_tips)))+"\n            ")]}}])})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "swva":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sxb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartPieCard_vue__ = __webpack_require__("mjPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__ = __webpack_require__("Ark/");






var _components;









/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */],
    SearchableMultiSelect: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_SearchableMultiSelect_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartPieCard', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartPieCard_vue__["a" /* default */]), _components),
  props: {
    isOperatorSales: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isOperatorSales: function isOperatorSales() {
      if (this.isOperatorSales) {
        this.getOrders();
        this.verifyUserLocations();
        this.verifyUserMethods();
        this.getPosUsers();
      }
    }
  },
  computed: {
    posUsers: function posUsers() {
      return this.rawPosUsers.map(function (user) {
        return {
          value: user.id,
          label: user.firstname + ' ' + user.lastname
        };
      });
    }
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      selectedCategories: [],
      selectedTopCategories: [],
      rawPosUsers: [],
      ordersTableData: {},
      productsTableDataTotals: {},
      selectedPosUser: null,
      topProductSales: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '500px',
          axisX: {
            scaleMinSpace: 50,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_8_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      colors: ['#f44336', '#2196f3', '#ff9800', '#9c27b0', '#00bcd4', '#8bc34a', '#ffc107', '#3f51b5', '#ff5722', '#795548', '#607d8b', '#009688', '#cddc39', '#673ab7', '#03a9f4', '#aed581', '#ffb74d', '#ba68c8'],
      noData: false
    };
  },

  methods: {
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        console.log(allowedLocations);
        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this = this;

      if (!this.isOperatorSales) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: this.orders.valid[0],
        to_date: this.orders.valid[1]
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      if (this.selectedPosUser && this.selectedPosUser.length) {
        data.operator_ids = this.selectedPosUser.map(function (element) {
          return element.value;
        });
      }

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;

      this.apiRequest('/reports/v2/operator' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, function (response) {
        if (response.status) {
          _this.productsTableDataTotals = response.totals;
          if (response.data.table_data.length) {
            _this.ordersTableData.data = response.data.table_data;
            _this.ordersTableData.total = response.pagination.total;
            _this.paginationProps.currentPage = response.pagination.page;
            _this.paginationProps.pageSize = response.pagination.perPage;
          } else {
            _this.ordersTableData.data = [];
            _this.ordersTableData.total = 0;
            _this.paginationProps.currentPage = 1;
            _this.paginationProps.pageSize = 20;
          }

          _this.topProductSales.options.chartPadding = {
            top: 30,
            right: 10,
            bottom: 20,
            left: 20
          };

          if (!response.data.labels.length) {
            _this.$nextTick(function () {
              _this.topProductSales.data.labels = [];
              _this.topProductSales.data.series = [[]];
              _this.noData = true;

              if (_this.$refs.topProductSales.chart) {
                _this.$refs.topProductSales.initChartAndReturn();
              }

              return false;
            });
          }

          _this.noData = false;
          _this.topProductSales.data.labels = response.data.labels;
          _this.topProductSales.data.series = [response.data.series];

          _this.$nextTick(function () {
            _this.$refs.topProductSales.initChartAndReturn();

            if (_this.$refs.topProductSales.chart) {
              _this.$refs.topProductSales.chart.on('draw', function (data) {
                if (data.type === 'bar') {
                  data.element.attr({
                    style: 'stroke: ' + _this.colors[data.index % _this.colors.length] + '; stroke-width: 60px;'
                  });
                }
              });
            }
          });
        } else {
          _this.topProductSales.data.labels = [];
          _this.topProductSales.data.series = [[]];
          _this.discounts = [];
          _this.noData = true;

          if (_this.$refs.topProductSales.chart) {
            _this.$refs.topProductSales.initChartAndReturn();
          }

          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    exportData: function exportData() {
      var _this2 = this;

      var fromDate = this.orders.valid[0];
      var toDate = this.orders.valid[1];

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/operator-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
        }
        _this2.loading = false;
      });
    },
    getPosUsers: function getPosUsers() {
      var _this3 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this3.rawPosUsers = response.data.pos_user;
        }
      });
    }
  }
});

/***/ }),

/***/ "szIs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Marketing_DiscountCampaigns_DiscountCampaignForm_vue__ = __webpack_require__("af5b");

















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_11_vue_select___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DiscountCampaignForm: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Marketing_DiscountCampaigns_DiscountCampaignForm_vue__["a" /* default */]
  },
  props: {
    priceProfileData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: true,
      loadingProducts: false,
      model: {
        name: '',
        location_ids: [],
        top_category_ids: [],
        delivery_range_ids: [],
        customers_group_ids: []
      },
      availableLocations: [],

      scopeFields: ['customers_group_ids', 'delivery_range_ids', 'top_category_ids'],

      loadingScopeOptions: false,
      scopeOptions: {
        top_categories: [],
        delivery_ranges: [],
        customers_group: []
      },

      scopeAllOptions: {
        top_categories: [],
        delivery_ranges: [],
        customers_group: []
      },

      scopeTaken: {
        top_category_ids: {},
        delivery_range_ids: {},
        customers_group_ids: {}
      },
      plainProfileTaken: null,

      companyId: this.$session.get('selectedCompany'),
      token: this.$session.get('token'),

      filters: {
        name: '',
        product_id: '',
        category_id: ''
      },
      debounceTimer: null,
      mainCategories: [],

      sources: [{
        id: 6,
        name: 'GLOVO',
        methods: [{ id: 1, name: 'EatIn' }]
      }, {
        id: 7,
        name: 'BOLT',
        methods: [{ id: 1, name: 'EatIn' }]
      }, {
        id: 8,
        name: 'Wolt',
        methods: [{ id: 1, name: 'EatIn' }]
      }, {
        id: 1,
        name: 'Website',
        methods: [{ id: 1, name: 'EatIn' }, { id: 2, name: 'ToGo' }, { id: 3, name: 'Delivery' }]
      }, {
        id: 2,
        name: 'QR',
        methods: [{ id: 1, name: 'EatIn' }]
      }, {
        id: 3,
        name: 'Kiosk',
        methods: [{ id: 1, name: 'EatIn' }, { id: 2, name: 'ToGo' }]
      }, {
        id: 4,
        name: 'POS',
        methods: [{ id: 1, name: 'EatIn' }, { id: 2, name: 'ToGo' }, { id: 3, name: 'Delivery' }]
      }, {
        id: 5,
        name: 'App',
        methods: [{ id: 1, name: 'EatIn' }, { id: 2, name: 'ToGo' }, { id: 3, name: 'Delivery' }]
      }],
      products: [],
      productsPagination: {
        page: 1,
        perPage: 20,
        totalPages: 0,
        totalRecords: 0
      },

      apiPricingData: {},
      pricingData: {},
      editModes: {},
      vatOptions: [],

      showQuickApplyModal: false,
      quickApplyProduct: null,
      quickApplyData: {
        price: '',
        vat_id: null,
        vat_amount: '',
        pos_id: '',
        active: true
      },

      discountSelection: {},
      showDiscountCampaignModal: false,
      discountCampaignPrefill: null,
      showDiscountLineModal: false,
      discountLineContext: null,
      discountLineEdits: [],
      discountLineSaving: false,
      discountFlashKey: null,
      discountFlashTimer: null
    };
  },

  computed: {
    discountSelectionCount: function discountSelectionCount() {
      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(this.discountSelection).length;
    },
    discountSelectionProductCount: function discountSelectionProductCount() {
      var ids = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_values___default()(this.discountSelection).map(function (s) {
        return s.product_id;
      }));
      return ids.size;
    },
    hasDiscountLineErrors: function hasDiscountLineErrors() {
      return this.discountLineEdits.some(function (line) {
        return !!line.error;
      });
    },
    selectedLocationIds: function selectedLocationIds() {
      return (this.model.location_ids || []).map(function (loc) {
        return loc && (typeof loc === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(loc)) === 'object' ? loc.true_id : loc;
      }).filter(function (id) {
        return id !== null && id !== undefined && id !== '';
      });
    },
    hasAnyScope: function hasAnyScope() {
      var _this = this;

      return this.scopeFields.some(function (field) {
        return (_this.model[field] || []).length > 0;
      });
    }
  },
  created: function created() {
    if (!this.guardPriceListsAccess()) {
      return;
    }
    this.getData();
    this.getVatOptions();
    this.getCategories();
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.discountFlashTimer);
  },

  methods: {
    scopeOptionKey: function scopeOptionKey(field) {
      return {
        top_category_ids: 'top_categories',
        delivery_range_ids: 'delivery_ranges',
        customers_group_ids: 'customers_group'
      }[field];
    },
    scopeIds: function scopeIds(field) {
      return (this.model[field] || []).map(function (item) {
        return item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item)) === 'object' ? item.id : item;
      }).filter(function (id) {
        return id !== null && id !== undefined && id !== '';
      });
    },
    takenLabel: function takenLabel(field) {
      var _this2 = this;

      var taken = this.scopeTaken[field] || {};
      var names = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(taken).map(function (id) {
        return _this2.scopeEntityName(field, id) + ' (' + taken[id] + ')';
      });
      return names.join(', ');
    },
    scopeEntityName: function scopeEntityName(field, id) {
      var list = this.scopeAllOptions[this.scopeOptionKey(field)] || [];
      var found = list.find(function (item) {
        return String(item.id) === String(id);
      });
      return found ? found.name : '#' + id;
    },
    locationNameByToken: function locationNameByToken(token) {
      var found = this.availableLocations.find(function (loc) {
        return String(loc.token) === String(token);
      });
      return found ? found.name : null;
    },
    scopeItemLabel: function scopeItemLabel(item) {
      if (item.missing) {
        return '#' + item.id + ' (leg\u0103tur\u0103 \u0219tears\u0103)';
      }

      var label = item.name;

      if (item.location_id) {
        var locationName = this.locationNameByToken(item.location_id);
        label += ' (' + (locationName || item.location_id) + ')';
      }

      if (item.deleted) {
        label += ' (șters)';
      }

      return label;
    },
    onLocationsChanged: function onLocationsChanged() {
      this.loadScopeOptions();
    },
    loadScopeOptions: function loadScopeOptions() {
      var _this3 = this;

      var locationIds = this.selectedLocationIds;

      if (!locationIds.length) {
        this.scopeOptions = { top_categories: [], delivery_ranges: [], customers_group: [] };
        this.scopeAllOptions = { top_categories: [], delivery_ranges: [], customers_group: [] };
        this.scopeTaken = { top_category_ids: {}, delivery_range_ids: {}, customers_group_ids: {} };
        this.plainProfileTaken = null;
        return;
      }

      this.loadingScopeOptions = true;

      var data = {
        token: this.token,
        company_id: this.companyId,
        location_ids: locationIds
      };

      if (!this.isNew()) {
        data.price_profiles_id = this.route.params.id;
      }

      this.apiRequest('/price-profiles/scope-options', 'GET', data, function (response) {
        _this3.loadingScopeOptions = false;

        if (!response.status) {
          return;
        }

        _this3.scopeTaken = response.taken || { top_category_ids: {}, delivery_range_ids: {}, customers_group_ids: {} };
        _this3.plainProfileTaken = response.plain_profile_taken || null;

        var options = response.data || {};
        var all = {};
        var filtered = {};

        _this3.scopeFields.forEach(function (field) {
          var key = _this3.scopeOptionKey(field);
          var taken = _this3.scopeTaken[field] || {};
          var selected = _this3.scopeIds(field).map(String);

          all[key] = (options[key] || []).map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, item, {
              name: _this3.scopeItemLabel(item)
            });
          });

          filtered[key] = all[key].filter(function (item) {
            return !taken[item.id] || selected.indexOf(String(item.id)) !== -1;
          });
        });

        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this3, 'scopeAllOptions', all);
        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this3, 'scopeOptions', filtered);
        _this3.pruneScopeSelections();
      });
    },
    pruneScopeSelections: function pruneScopeSelections() {
      var _this4 = this;

      this.scopeFields.forEach(function (field) {
        var key = _this4.scopeOptionKey(field);
        var availableIds = (_this4.scopeOptions[key] || []).map(function (item) {
          return String(item.id);
        });

        var kept = (_this4.model[field] || []).filter(function (item) {
          if (item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item)) === 'object' && (item.missing || item.deleted)) {
            return true;
          }
          var id = item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item)) === 'object' ? item.id : item;
          return availableIds.indexOf(String(id)) !== -1;
        });

        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this4.model, field, kept);
      });
    },
    isNew: function isNew() {
      return !this.route.params.id || this.route.params.id === 'add';
    },
    getData: function getData() {
      this.loading = true;
      this.loadAvailableLocations();

      if (!this.isNew()) {
        this.loadProfile();
      } else {
        this.loading = false;
      }
    },
    loadAvailableLocations: function loadAvailableLocations() {
      var companyData = this.$session.get('selectedCompanyData');
      this.availableLocations = companyData.locations_details.map(function (l) {
        return {
          token: l.token,
          true_id: l.true_id,
          name: l.name
        };
      });
    },
    getCategories: function getCategories() {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/category', 'GET', data, function (response) {
        if (response.status === true) {
          _this5.mainCategories = response.data;
        }
      });
    },
    loadProfile: function loadProfile() {
      var _this6 = this;

      var data = {
        token: this.token,
        company_id: this.companyId
      };

      this.apiRequest('/price-profiles/' + this.route.params.id, 'GET', data, function (response) {

        if (response.status) {
          _this6.model = {
            id: response.data.id,
            name: response.data.name,
            location_ids: response.data.location_ids || [],
            top_category_ids: _this6.mapScopeItems(response.data.top_category_ids),
            delivery_range_ids: _this6.mapScopeItems(response.data.delivery_range_ids),
            customers_group_ids: _this6.mapScopeItems(response.data.customers_group_ids)
          };

          _this6.loadScopeOptions();
        }
        _this6.loadProducts(1);
        _this6.loading = false;
      });
    },
    mapScopeItems: function mapScopeItems(items) {
      var _this7 = this;

      return (items || []).map(function (item) {
        return {
          id: item.id,
          name: _this7.scopeItemLabel(item),
          missing: !!item.missing,
          deleted: !!item.deleted
        };
      });
    },
    getVatOptions: function getVatOptions() {
      var _this8 = this;

      var locationIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_ids: locationIds
      };
      this.apiRequest('/location/vat', 'GET', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this8, 'vatOptions', response.data || []);
        }
      });
    },
    debouncedLoadProducts: function debouncedLoadProducts() {
      var _this9 = this;

      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(function () {
        _this9.productsPagination.page = 1;
        _this9.loadProducts();
      }, 1300);
    },
    resetFilters: function resetFilters() {
      this.filters = {
        name: '',
        product_id: '',
        category_id: ''
      };
      this.clearDiscountSelection();
      this.productsPagination.page = 1;
      this.loadProducts();
    },
    loadProducts: function loadProducts() {
      var _this10 = this;

      var firstTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (firstTime) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this10.validate(null, 1);

              case 3:
                _this10.loadingProducts = true;

                _this10.pricingData = {};
                _this10.editModes = {};

                data = {
                  token: _this10.token,
                  company_id: _this10.companyId,
                  location_ids: _this10.model.location_ids,
                  page: _this10.productsPagination.page,
                  perPage: _this10.productsPagination.perPage
                };

                if (_this10.route.params.id && _this10.route.params.id !== 'add') {
                  data.price_profiles_id = _this10.route.params.id;
                }

                if (_this10.filters.name) data.name = _this10.filters.name;
                if (_this10.filters.product_id) data.product_id = _this10.filters.product_id;
                if (_this10.filters.category_id) data.category_id = _this10.filters.category_id;

                _this10.apiRequest('/price-profiles/available-products', 'GET', data, function (response) {
                  if (response.status) {
                    _this10.products = response.data;
                    _this10.productsPagination = response.pagination || _this10.productsPagination;

                    _this10.initializePricingData(response.pricingData || {});
                  }
                  _this10.loadingProducts = false;
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this10);
      }))();
    },
    initializePricingData: function initializePricingData(apiPricingData) {
      var _this11 = this;

      this.products.forEach(function (product) {
        _this11.sources.forEach(function (source) {
          source.methods.forEach(function (method) {
            var key = product.id + '_' + source.id + '_' + method.id;
            var existing = apiPricingData[key];

            if (existing) {
              __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this11.pricingData, key, {
                id: existing.id,
                price: existing.price,
                vat_id: existing.vat_id,
                vat_amount: existing.vat_amount,
                pos_id: existing.pos_id,
                active: existing.active,
                product_id: product.id,
                source: source.id,
                method: method.id,
                discounts: existing.discounts || []
              });

              __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this11.editModes, key, true);
            } else {
              __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this11.pricingData, key, {
                id: null,
                price: product.price || '',
                vat_id: product.vat_id || '',
                vat_amount: product.vat_amount || '',
                pos_id: product.pos_id || '',
                active: product.active || false,
                product_id: product.id,
                source: source.id,
                method: method.id,
                discounts: []
              });

              __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this11.editModes, key, false);
            }
          });
        });
      });
    },
    updateVatFromSelect: function updateVatFromSelect(productId, sourceId, methodId, event) {
      var key = productId + '_' + sourceId + '_' + methodId;
      var selectElement = event.target;
      var selectedOption = selectElement.options[selectElement.selectedIndex];

      if (selectedOption && selectedOption.value !== 'null') {
        var vatId = selectedOption.value;
        var vatAmount = selectedOption.dataset.amount;

        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.pricingData[key], 'vat_id', vatId);
        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.pricingData[key], 'vat_amount', vatAmount);
      } else {
        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.pricingData[key], 'vat_id', '');
        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.pricingData[key], 'vat_amount', '');
      }
    },
    getPricingKey: function getPricingKey(productId, sourceId, methodId) {
      return productId + '_' + sourceId + '_' + methodId;
    },
    getDiscounts: function getDiscounts(productId, sourceId, methodId) {
      var pricing = this.pricingData[this.getPricingKey(productId, sourceId, methodId)];
      return pricing && pricing.discounts ? pricing.discounts : [];
    },
    hasDiscounts: function hasDiscounts(productId, sourceId, methodId) {
      return this.getDiscounts(productId, sourceId, methodId).length > 0;
    },
    getDiscountSum: function getDiscountSum(productId, sourceId, methodId) {
      var sum = this.getDiscounts(productId, sourceId, methodId).reduce(function (total, line) {
        return total + (parseFloat(line.discount) || 0);
      }, 0);
      return Math.round(sum * 100) / 100;
    },
    getDiscountedPrice: function getDiscountedPrice(productId, sourceId, methodId) {
      var discounts = this.getDiscounts(productId, sourceId, methodId);
      if (!discounts.length) return null;
      if (discounts.length === 1) {
        return discounts[0].discounted_price;
      }
      var pricing = this.pricingData[this.getPricingKey(productId, sourceId, methodId)];
      var basePrice = parseFloat(pricing && pricing.price) || 0;
      var discounted = basePrice - this.getDiscountSum(productId, sourceId, methodId);
      return Math.round(discounted * 100) / 100;
    },
    isDiscountCampaignActive: function isDiscountCampaignActive(productId, sourceId, methodId) {
      var discounts = this.getDiscounts(productId, sourceId, methodId);
      return discounts.some(function (line) {
        if (!line.campaign) return true;
        return line.campaign.active === true || parseInt(line.campaign.active, 10) === 1;
      });
    },
    getDiscountTooltip: function getDiscountTooltip(productId, sourceId, methodId) {
      var discounts = this.getDiscounts(productId, sourceId, methodId);
      if (!discounts.length) return '';
      var pricing = this.pricingData[this.getPricingKey(productId, sourceId, methodId)];
      var basePrice = parseFloat(pricing && pricing.price) || 0;
      return discounts.map(function (line) {
        var name = line.campaign && line.campaign.name || '#' + line.discount_campaign_id;
        var finalPrice = line.discounted_price != null ? line.discounted_price : Math.round((basePrice - (parseFloat(line.discount) || 0)) * 100) / 100;
        var parts = [name, basePrice + ' \u2192 ' + finalPrice + ' RON'];
        if (line.number_of_units != null) {
          parts.push('Limit\u0103 ' + line.number_of_units + ' \xB7 V\xE2ndute ' + (line.units_sold || 0));
        }
        return parts.join('\n');
      }).join('\n\n');
    },
    isDiscountCellSelected: function isDiscountCellSelected(productId, sourceId, methodId) {
      return !!this.discountSelection[this.getPricingKey(productId, sourceId, methodId)];
    },
    toggleDiscountCellSelection: function toggleDiscountCellSelection(product, source, method, checked) {
      var key = this.getPricingKey(product.id, source.id, method.id);
      var pricing = this.pricingData[key];
      if (!pricing) return;
      if (checked) {
        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.discountSelection, key, {
          product_id: product.id,
          product_name: product.name,
          source: source.id,
          method: method.id,
          source_name: source.name,
          method_name: method.name,
          price_profile_product_id: pricing.id || null,
          has_discount: this.hasDiscounts(product.id, source.id, method.id),
          line_ids: this.getDiscounts(product.id, source.id, method.id).map(function (d) {
            return d.id;
          })
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.delete(this.discountSelection, key);
      }
    },
    clearDiscountSelection: function clearDiscountSelection() {
      this.discountSelection = {};
    },
    openDiscountCampaignModal: function openDiscountCampaignModal() {
      var selections = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_values___default()(this.discountSelection);
      var productMap = {};
      var comboMap = {};
      selections.forEach(function (sel) {
        productMap[sel.product_id] = {
          id: sel.product_id,
          label: sel.product_name || '#' + sel.product_id
        };
        var comboKey = sel.source + '_' + sel.method;
        comboMap[comboKey] = {
          source: sel.source,
          method: sel.method,
          label: sel.source_name + ' ' + sel.method_name
        };
      });
      this.discountCampaignPrefill = {
        price_profile_id: parseInt(this.route.params.id, 10) || null,
        products: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_values___default()(productMap),
        product_ids: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(productMap).map(function (id) {
          return parseInt(id, 10);
        }),
        source_method_combos: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_values___default()(comboMap)
      };
      this.showDiscountCampaignModal = true;
    },
    closeDiscountCampaignModal: function closeDiscountCampaignModal() {
      this.showDiscountCampaignModal = false;
      this.discountCampaignPrefill = null;
    },
    submitDiscountCampaignModal: function submitDiscountCampaignModal() {
      var form = this.$refs.discountCampaignForm;
      if (form && typeof form.validate === 'function') {
        form.validate();
      }
    },
    onDiscountCampaignSaved: function onDiscountCampaignSaved() {
      this.closeDiscountCampaignModal();
      this.clearDiscountSelection();
      this.loadProducts();
    },
    openDiscountLineModal: function openDiscountLineModal(product, source, method) {
      var discounts = this.getDiscounts(product.id, source.id, method.id);
      if (!discounts.length) return;
      var pricing = this.pricingData[this.getPricingKey(product.id, source.id, method.id)];
      this.discountLineContext = {
        productId: product.id,
        productName: product.name,
        sourceId: source.id,
        methodId: method.id,
        sourceName: source.name,
        methodName: method.name
      };
      this.discountLineEdits = discounts.map(function (line) {
        var basePrice = parseFloat(line.price != null ? line.price : pricing && pricing.price) || 0;
        var discount = parseFloat(line.discount) || 0;
        var campaign = line.campaign || {};
        var period = '';
        if (campaign.start_date || campaign.end_date) {
          period = [campaign.start_date, campaign.end_date].filter(Boolean).join(' – ');
        }
        return {
          id: line.id,
          campaignId: line.discount_campaign_id || campaign.id,
          campaignName: campaign.name || '',
          period: period,
          number_of_units: line.number_of_units,
          units_sold: line.units_sold || 0,
          basePrice: basePrice,
          discount: discount,
          discounted_price: line.discounted_price != null ? line.discounted_price : Math.round((basePrice - discount) * 100) / 100,
          error: ''
        };
      });
      this.showDiscountLineModal = true;
    },
    closeDiscountLineModal: function closeDiscountLineModal() {
      this.showDiscountLineModal = false;
      this.discountLineContext = null;
      this.discountLineEdits = [];
      this.discountLineSaving = false;
    },
    recalcLineEdit: function recalcLineEdit(idx) {
      var line = this.discountLineEdits[idx];
      if (!line) return;
      var discount = parseFloat(line.discount);
      if (isNaN(discount) || discount < 0) {
        line.error = this.$t('discountCampaigns.invalidDiscount');
        return;
      }
      if (discount > line.basePrice) {
        line.error = this.$t('discountCampaigns.discountExceedsPrice');
        return;
      }
      line.error = '';
      line.discounted_price = Math.round((line.basePrice - discount) * 100) / 100;
    },
    saveDiscountLineFromModal: function saveDiscountLineFromModal(lineEdit) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var discounts;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this12.discountLineContext || lineEdit.error)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _this12.discountLineSaving = true;
                _context2.next = 5;
                return _this12.saveDiscountLine(_this12.discountLineContext.productId, _this12.discountLineContext.sourceId, _this12.discountLineContext.methodId, lineEdit.id, lineEdit.discount, { silent: true });

              case 5:
                _this12.discountLineSaving = false;
                discounts = _this12.getDiscounts(_this12.discountLineContext.productId, _this12.discountLineContext.sourceId, _this12.discountLineContext.methodId);

                if (!discounts.length) {
                  _this12.closeDiscountLineModal();
                }

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this12);
      }))();
    },
    saveAllDiscountLinesFromModal: function saveAllDiscountLinesFromModal() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, lineEdit;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this13.hasDiscountLineErrors || !_this13.discountLineEdits.length)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                _this13.discountLineSaving = true;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 6;
                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this13.discountLineEdits);

              case 8:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 15;
                  break;
                }

                lineEdit = _step.value;
                _context3.next = 12;
                return _this13.saveDiscountLine(_this13.discountLineContext.productId, _this13.discountLineContext.sourceId, _this13.discountLineContext.methodId, lineEdit.id, lineEdit.discount, { silent: true });

              case 12:
                _iteratorNormalCompletion = true;
                _context3.next = 8;
                break;

              case 15:
                _context3.next = 21;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3['catch'](6);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 21:
                _context3.prev = 21;
                _context3.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context3.prev = 24;

                if (!_didIteratorError) {
                  _context3.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context3.finish(24);

              case 28:
                return _context3.finish(21);

              case 29:
                _this13.discountLineSaving = false;
                _this13.closeDiscountLineModal();

              case 31:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this13, [[6, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    deleteDiscountLinesFromModal: function deleteDiscountLinesFromModal() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var lines, confirmed, _loop, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, lineEdit;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                lines = _this14.discountLineEdits.slice();

                if (lines.length) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt('return');

              case 3:
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  text: _this14.$t('discountCampaigns.confirmDeleteLine'),
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: _this14.$t('general.yes'),
                  cancelButtonText: _this14.$t('general.cancel')
                }).catch(function () {
                  return false;
                });

              case 5:
                confirmed = _context5.sent;

                if (confirmed) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt('return');

              case 8:

                _this14.discountLineSaving = true;
                _context5.prev = 9;
                _loop = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _loop(lineEdit) {
                  var response, ctx, key, pricing;
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _loop$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return _this14.apiRequestPromise('/discount-campaigns/lines/' + lineEdit.id, 'DELETE', {
                            token: _this14.token,
                            company_id: _this14.companyId
                          });

                        case 2:
                          response = _context4.sent;

                          if (response.status) {
                            _context4.next = 5;
                            break;
                          }

                          throw new Error(response.message || _this14.$t('validations.wentWrong'));

                        case 5:
                          ctx = _this14.discountLineContext;
                          key = _this14.getPricingKey(ctx.productId, ctx.sourceId, ctx.methodId);
                          pricing = _this14.pricingData[key];

                          if (pricing && pricing.discounts) {
                            __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(pricing, 'discounts', pricing.discounts.filter(function (d) {
                              return d.id !== lineEdit.id;
                            }));
                          }

                        case 9:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _loop, _this14);
                });
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context5.prev = 14;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(lines);

              case 16:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context5.next = 22;
                  break;
                }

                lineEdit = _step2.value;
                return _context5.delegateYield(_loop(lineEdit), 't0', 19);

              case 19:
                _iteratorNormalCompletion2 = true;
                _context5.next = 16;
                break;

              case 22:
                _context5.next = 28;
                break;

              case 24:
                _context5.prev = 24;
                _context5.t1 = _context5['catch'](14);
                _didIteratorError2 = true;
                _iteratorError2 = _context5.t1;

              case 28:
                _context5.prev = 28;
                _context5.prev = 29;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 31:
                _context5.prev = 31;

                if (!_didIteratorError2) {
                  _context5.next = 34;
                  break;
                }

                throw _iteratorError2;

              case 34:
                return _context5.finish(31);

              case 35:
                return _context5.finish(28);

              case 36:
                _this14.closeDiscountLineModal();
                _context5.next = 42;
                break;

              case 39:
                _context5.prev = 39;
                _context5.t2 = _context5['catch'](9);

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: '',
                  text: _context5.t2 && _context5.t2.message || _this14.$t('validations.wentWrong'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 2000
                });

              case 42:
                _this14.discountLineSaving = false;

              case 43:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee4, _this14, [[9, 39], [14, 24, 28, 36], [29,, 31, 35]]);
      }))();
    },
    deleteDiscountLineFromModal: function deleteDiscountLineFromModal(lineEdit) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var confirmed, _response, ctx, key, _pricing, next;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  text: _this15.$t('discountCampaigns.confirmDeleteLine'),
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: _this15.$t('general.yes'),
                  cancelButtonText: _this15.$t('general.cancel')
                }).catch(function () {
                  return false;
                });

              case 2:
                confirmed = _context6.sent;

                if (confirmed) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt('return');

              case 5:

                _this15.discountLineSaving = true;
                _context6.prev = 6;
                _context6.next = 9;
                return _this15.apiRequestPromise('/discount-campaigns/lines/' + lineEdit.id, 'DELETE', {
                  token: _this15.token,
                  company_id: _this15.companyId
                });

              case 9:
                _response = _context6.sent;

                if (_response.status) {
                  _context6.next = 12;
                  break;
                }

                throw new Error(_response.message || _this15.$t('validations.wentWrong'));

              case 12:
                ctx = _this15.discountLineContext;
                key = _this15.getPricingKey(ctx.productId, ctx.sourceId, ctx.methodId);
                _pricing = _this15.pricingData[key];

                if (_pricing && _pricing.discounts) {
                  next = _pricing.discounts.filter(function (d) {
                    return d.id !== lineEdit.id;
                  });

                  __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_pricing, 'discounts', next);
                }

                _this15.discountLineEdits = _this15.discountLineEdits.filter(function (e) {
                  return e.id !== lineEdit.id;
                });
                if (!_this15.discountLineEdits.length) {
                  _this15.closeDiscountLineModal();
                }
                _context6.next = 23;
                break;

              case 20:
                _context6.prev = 20;
                _context6.t0 = _context6['catch'](6);

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: '',
                  text: _context6.t0 && _context6.t0.message || _this15.$t('validations.wentWrong'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 2000
                });

              case 23:
                _this15.discountLineSaving = false;

              case 24:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee5, _this15, [[6, 20]]);
      }))();
    },
    onDiscountSumChange: function onDiscountSumChange(productId, sourceId, methodId, event) {
      var discounts = this.getDiscounts(productId, sourceId, methodId);
      if (discounts.length !== 1) return;
      this.saveDiscountLine(productId, sourceId, methodId, discounts[0].id, event.target.value);
    },
    onDiscountInputClick: function onDiscountInputClick(product, source, method) {
      if (this.getDiscounts(product.id, source.id, method.id).length > 1) {
        this.openDiscountLineModal(product, source, method);
      }
    },
    flashDiscountSaved: function flashDiscountSaved(key) {
      var _this16 = this;

      this.discountFlashKey = key;
      clearTimeout(this.discountFlashTimer);
      this.discountFlashTimer = setTimeout(function () {
        _this16.discountFlashKey = null;
      }, 1000);
    },
    saveDiscountLine: function saveDiscountLine(productId, sourceId, methodId, lineId, rawValue) {
      var _this17 = this;

      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var key, pricing, discountValue, lineIndex, line, basePrice, discountedPrice, data, _response2, updated;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                key = _this17.getPricingKey(productId, sourceId, methodId);
                pricing = _this17.pricingData[key];

                if (!(!pricing || !lineId)) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt('return');

              case 4:
                discountValue = parseFloat(rawValue);

                if (!(isNaN(discountValue) || discountValue < 0)) {
                  _context7.next = 8;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: '',
                  text: _this17.$t('discountCampaigns.invalidDiscount'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 2000
                });
                return _context7.abrupt('return');

              case 8:
                lineIndex = (pricing.discounts || []).findIndex(function (d) {
                  return d.id === lineId;
                });

                if (!(lineIndex === -1)) {
                  _context7.next = 11;
                  break;
                }

                return _context7.abrupt('return');

              case 11:
                line = pricing.discounts[lineIndex];
                basePrice = parseFloat(line.price != null ? line.price : pricing.price) || 0;

                if (!(discountValue > basePrice)) {
                  _context7.next = 16;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: '',
                  text: _this17.$t('discountCampaigns.discountExceedsPrice'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 2000
                });
                return _context7.abrupt('return');

              case 16:
                discountedPrice = Math.round((basePrice - discountValue) * 100) / 100;
                data = {
                  token: _this17.token,
                  company_id: _this17.companyId,
                  discount: discountValue,
                  discounted_price: discountedPrice
                };
                _context7.prev = 18;
                _context7.next = 21;
                return _this17.apiRequestPromise('/discount-campaigns/lines/' + lineId, 'PUT', data);

              case 21:
                _response2 = _context7.sent;
                updated = _response2.data && _response2.data.id ? _response2.data : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, line, {
                  discount: discountValue,
                  discounted_price: discountedPrice
                });


                __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(pricing.discounts, lineIndex, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, line, updated));

                _this17.flashDiscountSaved(key);

                if (!options.silent) {}
                _context7.next = 32;
                break;

              case 28:
                _context7.prev = 28;
                _context7.t0 = _context7['catch'](18);

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: '',
                  text: _context7.t0 && _context7.t0.message || _this17.$t('validations.wentWrong'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 2000
                });
                _this17.$forceUpdate();

              case 32:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee6, _this17, [[18, 28]]);
      }))();
    },
    getEditMode: function getEditMode(productId, sourceId, methodId) {
      var key = productId + '_' + sourceId + '_' + methodId;
      return this.editModes[key] || false;
    },
    toggleEditMode: function toggleEditMode(productId, sourceId, methodId, value) {
      var key = productId + '_' + sourceId + '_' + methodId;
      __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.editModes, key, value);

      if (value && this.pricingData[key]) {
        if (!this.pricingData[key].price) {
          var product = this.products.find(function (p) {
            return p.id === productId;
          });
          if (product) {
            __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.pricingData[key], 'price', product.price || '');
            __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.pricingData[key], 'vat_id', product.vat_id || '');
            __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.pricingData[key], 'vat_amount', product.vat_amount || '');
            __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(this.pricingData[key], 'pos_id', product.pos_id || '');
          }
        }
      }
    },
    changePage: function changePage(newPage) {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(newPage < 1 || newPage > _this18.productsPagination.totalPages)) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt('return');

              case 2:
                _this18.productsPagination.page = newPage;
                _this18.loadProducts();

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee7, _this18);
      }))();
    },
    removeLocation: function removeLocation(loc) {
      var idx = this.model.location_ids.findIndex(function (l) {
        return l.id === loc.id;
      });
      if (idx !== -1) {
        this.model.location_ids.splice(idx, 1);
      }
    },
    validate: function validate(e) {
      var _this19 = this;

      var noReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var isValid;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this19.$validator.validateAll();

              case 2:
                isValid = _context9.sent;

                if (isValid) {
                  _context9.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: '',
                  text: _this19.$t('validations.checkErrors'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 2000
                });
                return _context9.abrupt('return');

              case 6:
                if (!(_this19.plainProfileTaken && !_this19.hasAnyScope)) {
                  _context9.next = 9;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: '',
                  text: 'Exist\u0103 deja un profil doar pe loca\u021Bie pentru loca\u021Biile selectate: "' + _this19.plainProfileTaken + '". Alege o categorie de top, o zon\u0103 de livrare sau un grup de clien\u021Bi.',
                  type: 'error',
                  showConfirmButton: true
                });
                return _context9.abrupt('return');

              case 9:
                _context9.next = 11;
                return _this19.saveProfile(null, noReload);

              case 11:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee8, _this19);
      }))();
    },
    saveProfile: function saveProfile(e, noReload) {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var productsToSave, productsToDelete, data, response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this20.loading = true;

                productsToSave = [];
                productsToDelete = [];

                __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(_this20.editModes).forEach(function (key) {
                  var pricing = _this20.pricingData[key];
                  if (!pricing) return;

                  if (_this20.editModes[key]) {
                    if (pricing.price !== '' || pricing.active || pricing.pos_id !== '') {
                      var discounts = pricing.discounts,
                          productPayload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(pricing, ['discounts']);

                      productsToSave.push(productPayload);
                    }
                  } else {
                    if (pricing.id) {
                      productsToDelete.push({
                        id: pricing.id,
                        product_id: pricing.product_id,
                        source: pricing.source,
                        method: pricing.method
                      });
                    }
                  }
                });

                data = {
                  token: _this20.token,
                  company_id: _this20.companyId,
                  name: _this20.model.name,
                  location_ids: _this20.selectedLocationIds,
                  top_category_ids: _this20.scopeIds('top_category_ids'),
                  delivery_range_ids: _this20.scopeIds('delivery_range_ids'),
                  customers_group_ids: _this20.scopeIds('customers_group_ids'),
                  products: productsToSave,
                  products_to_delete: productsToDelete };
                response = null;

                if (!_this20.isNew()) {
                  _context10.next = 13;
                  break;
                }

                _context10.next = 9;
                return _this20.apiRequestPromise('/price-profiles', 'POST', data);

              case 9:
                response = _context10.sent;

                _this20.handleResponse(response, 'creat', noReload, data);
                _context10.next = 17;
                break;

              case 13:
                _context10.next = 15;
                return _this20.apiRequestPromise('/price-profiles/' + _this20.route.params.id, 'PUT', data);

              case 15:
                response = _context10.sent;

                _this20.handleResponse(response, 'actualizat', noReload, data);

              case 17:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee9, _this20);
      }))();
    },
    handleResponse: function handleResponse(response, action, noReload, requestData) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var entityId, field;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this21.loading = false;

                if (response.status) {
                  entityId = _this21.route.params && _this21.route.params.id || response.data && (response.data.id || response.data[0] && response.data[0].id) || null;

                  _this21.trackAdminEvent('ADMIN_PRICE_LIST_UPDATE', 'price_list', entityId, {
                    price_list_id: entityId,
                    name: requestData && requestData.name || _this21.model && _this21.model.name || null,
                    request: requestData || null,
                    response: response
                  });
                  __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                    title: '',
                    text: 'Profil de pre\u021B ' + action + ' cu succes!',
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }).then(function () {});
                  if (action == 'creat') {
                    _this21.backButton();
                  } else {
                    _this21.$bus.$emit('refresh');
                    if (!noReload) {
                      _this21.refreshDataAfterSave();
                    }
                  }
                } else {
                  console.log(response.errors);
                  if (response.errors) {
                    for (field in response.errors) {
                      _this21.errors.add(field, response.errors[field]);
                    }
                  }

                  __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                    title: '',
                    text: response.message || _this21.$t('validations.wentWrong'),
                    type: 'error',
                    showConfirmButton: false,
                    timer: 2000
                  });
                }

              case 2:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee10, _this21);
      }))();
    },
    refreshDataAfterSave: function refreshDataAfterSave() {
      this.deletedKeys = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a();
      this.editModes = {};
      this.pricingData = {};
      this.apiPricingData = {};
      this.allLoadedPricingIds = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_set___default.a();

      this.loadProducts(true);
    },
    handleDelete: function handleDelete() {
      var _this22 = this;

      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        title: 'Confirmare ștergere',
        text: 'E\u0219ti sigur c\u0103 vrei s\u0103 \u0219tergi profilul "' + this.model.name + '"?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        confirmButtonColor: '#f56c6c'
      }).then(function (result) {
        if (result) {
          _this22.loading = true;

          var data = {
            token: _this22.token,
            company_id: _this22.companyId
          };

          _this22.apiRequest('/price-profiles/' + _this22.route.params.id, 'DELETE', data, function (response) {
            _this22.loading = false;

            if (response.status) {
              var id = _this22.route.params.id;
              _this22.trackAdminEvent('ADMIN_PRICE_LIST_DELETED', 'price_list', id, {
                price_list_id: id,
                name: _this22.model && _this22.model.name || null
              });
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                title: '',
                text: 'Profil șters cu succes!',
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).then(function () {});
              _this22.backButton();
            } else {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                title: '',
                text: response.message || _this22.$t('validations.wentWrong'),
                type: 'error',
                showConfirmButton: false,
                timer: 2000
              });
            }
          });
        }
      });
    },
    goToProduct: function goToProduct(prod) {
      return 0;

      this.$router.push({
        name: 'Edit Product',
        params: {
          id: prod.id,
          productData: prod,
          mainCategories: this.mainCategories
        }
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    openQuickApplyModal: function openQuickApplyModal(product) {
      this.quickApplyProduct = product;

      this.quickApplyData = {
        price: product.price || '',
        vat_id: product.vat_id || null,
        vat_amount: product.vat_amount || '',
        pos_id: product.pos_id || '',
        active: true
      };
      this.showQuickApplyModal = true;
    },
    closeQuickApplyModal: function closeQuickApplyModal() {
      this.showQuickApplyModal = false;
      this.quickApplyProduct = null;
      this.quickApplyData = {
        price: '',
        vat_id: null,
        vat_amount: '',
        pos_id: '',
        active: true
      };
    },
    updateQuickApplyVat: function updateQuickApplyVat(event) {
      var _this23 = this;

      var selectedOption = event.target.options[event.target.selectedIndex];
      if (selectedOption && selectedOption.value !== 'null') {
        var vat = this.vatOptions.find(function (v) {
          return v.id == _this23.quickApplyData.vat_id;
        });
        if (vat) {
          this.quickApplyData.vat_amount = vat.amount;
        }
      } else {
        this.quickApplyData.vat_amount = '';
      }
    },
    clearProductPricing: function clearProductPricing() {
      var _this24 = this;

      if (!this.quickApplyProduct) return;

      var product = this.quickApplyProduct;

      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        title: 'Confirmare ștergere',
        text: '\u0218tergi toate pre\u021Burile produsului "' + product.name + '" din acest profil?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        confirmButtonColor: '#f56c6c'
      }).then(function (result) {
        if (!result) return;

        _this24.sources.forEach(function (source) {
          source.methods.forEach(function (method) {
            var key = product.id + '_' + source.id + '_' + method.id;
            __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this24.editModes, key, false);
          });
        });

        _this24.closeQuickApplyModal();

        __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
          title: '',
          text: 'Prețurile au fost marcate pentru ștergere. Salvează pentru a aplica!',
          type: 'success',
          showConfirmButton: false,
          timer: 2000
        });
      });
    },
    applyQuickApply: function applyQuickApply() {
      var _this25 = this;

      if (!this.quickApplyProduct) return;

      var productId = this.quickApplyProduct.id;
      var data = this.quickApplyData;

      this.sources.forEach(function (source) {
        source.methods.forEach(function (method) {
          var key = productId + '_' + source.id + '_' + method.id;

          __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this25.editModes, key, true);

          __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this25.pricingData[key], 'price', data.price);
          __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this25.pricingData[key], 'vat_id', data.vat_id || '');
          __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this25.pricingData[key], 'vat_amount', data.vat_amount || '');
          __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this25.pricingData[key], 'pos_id', data.pos_id);
          __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this25.pricingData[key], 'active', data.active);
        });
      });

      this.closeQuickApplyModal();

      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        title: '',
        text: 'Valorile au fost aplicate la toate sursele și metodele!',
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      });
    }
  }
});

/***/ }),

/***/ "t1ar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AllModulesModal',
  props: {
    activeModulesPercent: {
      type: Number,
      default: 0
    },
    activeModules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    inactiveModules: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      scrollSpeed: 1.2,
      isHovering: false
    };
  },

  methods: {
    open: function open() {
      var _this = this;

      this.$modal.show('allModulesModal');
      this.$nextTick(function () {
        _this.resetScroll();
      });
    },
    close: function close() {
      this.$modal.hide('allModulesModal');
    },
    closeModulesModal: function closeModulesModal() {
      this.$modal.hide('allModulesModal');
    },
    resetScroll: function resetScroll() {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollTop = 0;
      }
    },
    onMouseEnter: function onMouseEnter() {
      this.isHovering = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.isHovering = false;
    },
    onWheel: function onWheel(event) {
      if (!this.$refs.scrollContainer) return;

      var container = this.$refs.scrollContainer;
      var delta = event.deltaY || event.detail || 0;
      var scrollAmount = delta * this.scrollSpeed;

      var isAtTop = container.scrollTop <= 0 && delta < 0;
      var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 1 && delta > 0;

      if (!isAtTop && !isAtBottom) {
        container.scrollTop += scrollAmount;
      } else if (isAtTop && delta < 0) {
        container.scrollTop = 0;
      } else if (isAtBottom && delta > 0) {
        container.scrollTop = container.scrollHeight - container.clientHeight;
      }
    }
  }
});

/***/ }),

/***/ "t1co":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t5XZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementAviz_vue__ = __webpack_require__("5Blt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16a2084a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementAviz_vue__ = __webpack_require__("hAyC");
function injectStyle (ssrContext) {
  __webpack_require__("XdhT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16a2084a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementAviz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16a2084a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementAviz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t5bk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("\n            Support\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"copyright pull-right"},[_vm._v("\n      © Coded with\n      "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n      "),_c('a',{attrs:{"href":"http://www.11digits.com","target":"_blank"}},[_vm._v("11 Digits")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t613":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralCampaigns_vue__ = __webpack_require__("gAb5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdb5ba04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralCampaigns_vue__ = __webpack_require__("H62W");
function injectStyle (ssrContext) {
  __webpack_require__("svfB")
  __webpack_require__("IkKL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bdb5ba04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReferralCampaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdb5ba04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReferralCampaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tDDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('price-profile-form',{attrs:{"priceProfileData":_vm.priceProfileData,"route":_vm.route},on:{"on-submit":_vm.onProfileSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tFKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Settings_Printer_PrinterForm_vue__ = __webpack_require__("+VS9");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PrinterForm: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Settings_Printer_PrinterForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "tIqS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tLlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignForm_vue__ = __webpack_require__("NE6U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e433d26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignForm_vue__ = __webpack_require__("WcH1");
function injectStyle (ssrContext) {
  __webpack_require__("Dhz4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e433d26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tNYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptionsEdit_vue__ = __webpack_require__("DwHs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcf5d8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptionsEdit_vue__ = __webpack_require__("Yf1v");
function injectStyle (ssrContext) {
  __webpack_require__("RR5O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOptionsEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcf5d8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOptionsEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tRiA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoSupport_vue__ = __webpack_require__("rlOj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8a741e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoSupport_vue__ = __webpack_require__("l8pN");
function injectStyle (ssrContext) {
  __webpack_require__("8NwC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e8a741e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoSupport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8a741e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoSupport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tTO3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartBarsCard_vue__ = __webpack_require__("21i8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_json_excel__ = __webpack_require__("fXhN");






var _components;









__WEBPACK_IMPORTED_MODULE_5_vue___default.a.component('downloadExcel', __WEBPACK_IMPORTED_MODULE_11_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartCard', __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'ChartBarsCard', __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_Cards_ChartBarsCard_vue__["a" /* default */]), _components),
  props: {
    isSalesPaymentMethod: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isSalesPaymentMethod: function isSalesPaymentMethod() {
      if (this.isSalesPaymentMethod) {
        this.getOrders();
      }
    }
  },
  created: function created() {
    this.getPaymentMethods();
    this.getOrders();
    this.verifyUserLocations();
    this.verifyUserMethods();
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      paymentMethodSales: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '500px',
          axisX: {
            scaleMinSpace: 50,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      paymentMethods: [],
      selected_payment_method: '',
      loading: true,
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_8_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      ordersTableData: {},
      totalAmount: 0,
      totalCounter: 0,
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },

      hasRceipt: null,
      colors: ['#f44336', '#2196f3', '#ff9800', '#9c27b0', '#00bcd4', '#8bc34a', '#ffc107', '#3f51b5', '#ff5722', '#795548', '#607d8b', '#009688', '#cddc39', '#673ab7', '#03a9f4', '#aed581', '#ffb74d', '#ba68c8'],
      noData: false
    };
  },

  methods: {
    getPaymentMethods: function getPaymentMethods() {
      var _this = this;

      var sessionData = this.$session.get('selectedCompanyData');

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };

        this.apiRequest('/orders/get-payment-methods', 'GET', data, function (response) {
          if (response.status && response.data.length) {
            var result = response.data.filter(function (item) {
              return item !== 'SPLIT';
            }).map(function (item) {
              return { id: item || 'unpaid', name: _this.$t('paymentTypes.' + item) };
            });
            sessionData['payment_methods'] = response.data;
            _this.$session.set('selectedCompanyData', sessionData);

            __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(_this, 'paymentMethods', result);
          }
        });
      } else {
        var result = sessionData['payment_methods'].filter(function (item) {
          return item !== 'SPLIT';
        }).map(function (item) {
          return { id: item || 'unpaid', name: _this.$t('paymentTypes.' + item) };
        });
        __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(this, 'paymentMethods', result);
      }
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this2 = this;

      if (!this.isSalesPaymentMethod) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        payment_method: this.selected_payment_method
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      var hasReceiptValue = this.hasRceipt && this.hasRceipt.value || null;

      this.apiRequest('/reports/v2/sales-payment-type' + '?page=' + page + '&pageSize=' + pageSize + '&has_receipt=' + hasReceiptValue, 'GET', data, function (response) {
        if (response.status) {
          if (response.data.payment_types && response.data.payment_types.length) {
            _this2.noData = false;
            _this2.ordersTableData.data = response.data.table_data;
            _this2.ordersTableData.total = response.data.table_data.length;

            _this2.totalAmount = response.data.total || 0;
            _this2.totalCounter = response.data.total_counter || 0;

            _this2.$nextTick(function () {
              _this2.paymentMethodSales.options.chartPadding = {
                top: 30,
                right: 10,
                bottom: 20,
                left: 20
              };

              if (response.data.payment_types && response.data.payment_types.length) {
                _this2.paymentMethodSales.data.labels = response.data.payment_types.map(function (item) {
                  return _this2.$t('paymentTypes.' + item);
                });
              }

              _this2.paymentMethodSales.data.series = [response.data.total_amounts];
              _this2.$refs.paymentMethodSales.initChartAndReturn();

              if (_this2.$refs.paymentMethodSales.chart) {
                _this2.$refs.paymentMethodSales.chart.on('draw', function (data) {
                  if (data.type === 'bar') {
                    data.element.attr({
                      style: 'stroke: ' + _this2.colors[data.index % _this2.colors.length] + '; stroke-width: 60px;'
                    });

                    if (data.type === 'label' && data.axis.units.pos === 'x') {
                      var words = data.text.split(' ');
                      var labelHtml = words.join('<br>');

                      data.element.remove();

                      var fo = data.group.elem('foreignObject', {
                        x: data.x - 25,
                        y: data.y,
                        width: 60,
                        height: 50,
                        style: 'font-size: 12px; text-align: center; overflow: visible;'
                      });

                      fo.elem('xhtml:div', {
                        xmlns: 'http://www.w3.org/1999/xhtml',
                        style: 'width: 40px; white-space: normal; word-wrap: break-word; text-align: center;'
                      }).html(labelHtml);
                    }
                  }
                });
              }
            });
          } else {
            _this2.paymentMethodSales.data.labels = [];
            _this2.paymentMethodSales.data.series = [[]];
            _this2.noData = true;
            _this2.ordersTableData.data = [];
            _this2.ordersTableData.total = 0;

            if (_this2.$refs.paymentMethodSales.chart) {
              _this2.$refs.paymentMethodSales.initChartAndReturn();
            }
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'), 'error');
        }

        _this2.$nextTick(function () {
          _this2.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    exportData: function exportData() {
      var _this3 = this;

      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }

      var fromDate = this.orders.valid[0] + ' ' + this.valid_from;
      var toDate = this.orders.valid[1] + ' ' + this.valid_to;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/sales-payment-type-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error');
        }
        _this3.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "tXqJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_select__);









var _components;








__WEBPACK_IMPORTED_MODULE_8_vue___default.a.component('v-select', __WEBPACK_IMPORTED_MODULE_12_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Switch_vue__["a" /* default */]), _components),
  props: {
    modeldata: {}
  },
  methods: {
    saveDetails: function saveDetails() {
      var companyID = this.$session.get('selectedCompany');
      var data = {
        'token': this.$session.get('token'),
        'facebookLink': this.modeldata.facebookLink,
        'instagramLink': this.modeldata.instagramLink,
        'tripadvisorLink': this.modeldata.tripadvisorLink,
        'twitter_link': this.modeldata.twitter_link,
        'tiktok_link': this.modeldata.tiktok_link,
        'linkedin_link': this.modeldata.linkedin_link,
        'website_prezentare_link': this.modeldata.website_prezentare_link,
        'googlePlay': this.modeldata.googlePlay,
        'appleStore': this.modeldata.appleStore,
        'facebookPixel': this.modeldata.facebookPixel,
        'facebookAppId': this.modeldata.facebookAppId,
        'interfaceColor': this.modeldata.interfaceColor,
        'header_color': this.modeldata.header_color,
        'header_text_color': this.modeldata.header_text_color,
        'ga4Code': this.modeldata.ga4Code,
        'website_link': this.modeldata.website_link,
        'image_proportion_category': this.modeldata.image_proportion_category,
        'image_proportion_product': this.modeldata.image_proportion_product,
        'display_mode': this.modeldata.display_mode,
        'font_product_description': this.modeldata.font_product_description,
        'font_product_title': this.modeldata.font_product_title,
        'background_color': this.modeldata.background_color,
        'display_image_category': this.modeldata.display_image_category,
        'use_whatsapp_chat': this.modeldata.use_whatsapp_chat,
        'popup_image': this.modeldata.popup_image
      };
      var self = this;
      this.apiRequest('/settings/website/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ 'text': self.$t('settingsWeb.success'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 });
        }
      });
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var _this = this;

      var self = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('general.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        self.$refs.upload.clearFiles();
        this.modeldata.popup_image = [];
      } else {
        if (fileList.length > 1) {
          this.modeldata.popup_image = fileList.slice(1);
        } else {
          this.modeldata.popup_image = fileList;
        }
      }
      this.getBase64(file.raw).then(function (base64enc) {
        _this.modeldata.popup_image = base64enc;
      });
    },
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
        text: this.$t('general.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      this.modeldata.popup_image = '';
    }
  }
});

/***/ }),

/***/ "tYsp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tbrf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Entries_ManagementEntries_vue__ = __webpack_require__("q98Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Entries_ManagementInvoiceSupplier_vue__ = __webpack_require__("+Y1x");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementEntries: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Entries_ManagementEntries_vue__["a" /* default */],
    ManagementInvoiceSupplier: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Entries_ManagementInvoiceSupplier_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isEntries: true,
      isInvoiceSupplier: false
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  methods: {
    openEntries: function openEntries() {
      this.isEntries = true;
      this.isInvoiceSupplier = false;
    },
    openInvoiceSupplier: function openInvoiceSupplier() {
      this.isInvoiceSupplier = true;
      this.isEntries = false;
    }
  }
});

/***/ }),

/***/ "teaP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "thbW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerLifetimeValue_vue__ = __webpack_require__("C8Oy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7143ae70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerLifetimeValue_vue__ = __webpack_require__("32Vb");
function injectStyle (ssrContext) {
  __webpack_require__("/s2G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerLifetimeValue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7143ae70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerLifetimeValue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tnDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-details order-mng mar-bt-0"},[_c('div',[_c('div',[_c('div',[_c('form',[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('error'))+"\n            ")]):_vm._e(),_vm._v(" "),_c('el-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_vm._l((_vm.model.ordering_management),function(order,orderIdx){return [(_vm.deliveryMethodLabels[_vm.getObjectByElemKeyValue('key', order.type, _vm.deliveryMethodLabels)])?[_c('div',{staticClass:"pull-right disable-chck",on:{"click":function($event){_vm.updateTabs(_vm.model.id + order.type, order.enabled)}}},[_c('p-checkbox',{key:"order.type",attrs:{"value":"true","label":order.label},on:{"click":function($event){_vm.updateTabs(_vm.model.id + order.type)}},model:{value:(order.enabled),callback:function ($$v) {_vm.$set(order, "enabled", $$v)},expression:"order.enabled"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.enabled')))])],1),_vm._v(" "),_c('el-collapse-item',{staticClass:"text-left",class:order.enabled ? '' : 'disabled',attrs:{"title":_vm.deliveryMethodLabels[_vm.getObjectByElemKeyValue('key', order.type, _vm.deliveryMethodLabels)]['label'],"name":_vm.model.id + order.type}},[_c('form',[(order.type == 'eat_location')?[_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"order.reservation_available_in_app",attrs:{"value":"true","label":order.reservation_available_in_app},model:{value:(order.reservation_available_in_app),callback:function ($$v) {_vm.$set(order, "reservation_available_in_app", $$v)},expression:"order.reservation_available_in_app"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservation_available_in_app')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"reservations-widget-embed"},[_c('div',{staticClass:"rw-config"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationWidgetTitle')))]),_vm._v(" "),_c('p',{staticClass:"rw-hint"},[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationWidgetHint')))]),_vm._v(" "),_c('div',{staticClass:"rw-auto-ids"},[_c('div',[_c('span',[_vm._v("Company ID")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.reservationWidgetCompanyId))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Method ID")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(order.id || '-'))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Location token")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.model.token || '-'))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationWidgetPosition')))]),_vm._v(" "),_c('div',{staticClass:"rw-position-btns"},_vm._l((_vm.reservationWidgetPositions),function(pos){return _c('button',{key:pos.id,staticClass:"rw-pos-choice",class:{ active: _vm.reservationWidget.position === pos.id },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.reservationWidget.position = pos.id}}},[_vm._v(_vm._s(pos.label))])}))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationWidgetLanguage')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reservationWidget.language),expression:"reservationWidget.language"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reservationWidget, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.reservationWidgetLanguages),function(lang){return _c('option',{key:lang.id,domProps:{"value":lang.id}},[_vm._v(_vm._s(lang.label))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationWidgetHoursToStay')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.reservationWidget.hoursToStay),expression:"reservationWidget.hoursToStay",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.reservationWidget.hoursToStay)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationWidget, "hoursToStay", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationWidgetDefaultPersons')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.reservationWidget.defaultPersons),expression:"reservationWidget.defaultPersons",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.reservationWidget.defaultPersons)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationWidget, "defaultPersons", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationWidgetCountryPrefix')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reservationWidget.countryCodePrefix),expression:"reservationWidget.countryCodePrefix"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.reservationWidget.countryCodePrefix)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationWidget, "countryCodePrefix", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationWidgetTableZone')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.reservationWidget.tableZoneId),expression:"reservationWidget.tableZoneId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.reservationWidget, "tableZoneId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.tableZones),function(zone){return _c('option',{key:zone.id,domProps:{"value":zone.id}},[_vm._v(_vm._s(zone.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationWidgetRestaurantName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reservationWidget.restaurantName),expression:"reservationWidget.restaurantName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.reservationWidget.restaurantName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.reservationWidget, "restaurantName", $event.target.value)},function($event){_vm.reservationWidget.restaurantNameCustomized = true}]}})])])])]),_vm._v(" "),_c('div',{staticClass:"rw-preview-col"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationWidgetPreview')))]),_vm._v(" "),_c('div',{staticClass:"rw-site-preview",class:'pos-' + _vm.reservationWidget.position},[_c('div',{staticClass:"rw-browser-bar"},[_c('span'),_c('span'),_c('span')]),_vm._v(" "),_c('div',{staticClass:"rw-fab"},[_c('span',{staticClass:"rw-fab-icon"},[_c('svg',{attrs:{"viewBox":"0 0 24 24","width":"22","height":"22","aria-hidden":"true"}},[_c('rect',{attrs:{"x":"4","y":"6","width":"16","height":"14","rx":"2","fill":"none","stroke":"#2c2a72","stroke-width":"1.8"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8 6V4M16 6V4M4 10h16","fill":"none","stroke":"#2c2a72","stroke-width":"1.8","stroke-linecap":"round"}}),_vm._v(" "),_c('rect',{attrs:{"x":"8","y":"13","width":"3","height":"3","rx":"0.6","fill":"#2c2a72"}})])]),_vm._v(" "),_c('span',{staticClass:"rw-fab-text"},[_c('strong',[_vm._v(_vm._s(_vm.reservationWidgetButtonLabel))]),_vm._v(" "),_c('span',{staticClass:"rw-online"},[_c('span',{staticClass:"rw-online-dot"}),_vm._v("ONLINE")])]),_vm._v(" "),_c('span',{staticClass:"rw-fab-arrow"},[_c('svg',{attrs:{"viewBox":"0 0 24 24","width":"14","height":"14","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M9 6l6 6-6 6","fill":"none","stroke":"#fff","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}})])])])]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationWidgetScript')))]),_vm._v(" "),_c('textarea',{staticClass:"form-control rw-script",attrs:{"readonly":"","rows":"12"},domProps:{"value":_vm.getReservationWidgetScript(order)}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success rw-copy-btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.copyReservationWidgetScript(order)}}},[_vm._v("\n                              "+_vm._s(_vm.reservationWidget.copied ? _vm.$t('settingsOrdering.reservationWidgetCopied') : _vm.$t('settingsOrdering.reservationWidgetCopy'))+"\n                            ")])])]),_vm._v(" "),[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.closeOrders', {deliveryMethod: order.label})))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(order.closeOrder),expression:"order.closeOrder"}],staticClass:"form-control sml",on:{"input":function($event){_vm.handleClosingHour(orderIdx, $event)},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(order, "closeOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.closeOrderOptions),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v(_vm._s(option.label))])})),_vm._v(" "),(order.closeOrder)?[_c('el-time-select',{attrs:{"placeholder":"Select hour","picker-options":_vm.picker_options_orders_starts_from},model:{value:(order.auto_close_orders_at_hour),callback:function ($$v) {_vm.$set(order, "auto_close_orders_at_hour", $$v)},expression:"order.auto_close_orders_at_hour"}})]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.auto_close_orders_after_hour),expression:"order.auto_close_orders_after_hour"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.auto_close_orders_after_hour),expression:"modelValidate.auto_close_orders_after_hour"}],staticClass:"form-control sml",attrs:{"name":_vm.model.id + order.type + 'auto_close_orders_after_hour',"type":"number","min":"0","max":"12","placeholder":"3"},domProps:{"value":(order.auto_close_orders_after_hour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "auto_close_orders_after_hour", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.hours')))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.model.id + order.type + 'auto_close_orders_after_hour')),expression:"errors.has(model.id + order.type + 'auto_close_orders_after_hour')"}],staticClass:"text-danger"},[_vm._v("\n                                "+_vm._s(_vm.$t('settingsOrdering.closeOrderAfterHours'))+"\n                              ")])]],2)],_vm._v(" "),[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"checkbox mar-bt-20"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isAutoChangeEnabled[orderIdx]),expression:"isAutoChangeEnabled[orderIdx]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isAutoChangeEnabled[orderIdx])?_vm._i(_vm.isAutoChangeEnabled[orderIdx],null)>-1:(_vm.isAutoChangeEnabled[orderIdx])},on:{"change":[function($event){var $$a=_vm.isAutoChangeEnabled[orderIdx],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.isAutoChangeEnabled, orderIdx, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.isAutoChangeEnabled, orderIdx, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.isAutoChangeEnabled, orderIdx, $$c)}},function($event){_vm.isAutoChangeEnabledChange(orderIdx)}]}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.autoChangeStatus', {deliveryMethod: order.label})))])]),_vm._v(" "),(_vm.isAutoChangeEnabled[orderIdx])?[_c('select',{directives:[{name:"model",rawName:"v-model",value:(order.status_from_auto_change),expression:"order.status_from_auto_change"}],staticClass:"form-control sml",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(order, "status_from_auto_change", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.statusesAutoChange),function(option1){return _c('option',{domProps:{"value":option1.name}},[_vm._v(_vm._s(option1.name))])})),_vm._v("\n                              ->\n                              "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(order.status_to_auto_change),expression:"order.status_to_auto_change"}],staticClass:"form-control sml",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(order, "status_to_auto_change", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.statusesAutoChange),function(option){return [(order.status_from_auto_change == option.name)?_vm._l((option.values),function(option2){return _c('option',{domProps:{"value":option2}},[_vm._v(_vm._s(option2))])}):_vm._e()]})],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.auto_change_status_after_min),expression:"order.auto_change_status_after_min"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.auto_change_status_after_min),expression:"modelValidate.auto_change_status_after_min"}],staticClass:"form-control sml",attrs:{"name":_vm.model.id + order.type + 'auto_change_status_after_min',"type":"number","min":"0","max":"360","placeholder":"1"},domProps:{"value":(order.auto_change_status_after_min)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "auto_change_status_after_min", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minutes')))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.model.id + order.type + 'auto_change_status_after_min')),expression:"errors.has(model.id + order.type + 'auto_change_status_after_min')"}],staticClass:"text-danger"},[_vm._v("\n                                  "+_vm._s(_vm.$t('settingsOrdering.errorAutoChangeStatusAfterMin'))+"\n                                ")])]:_vm._e()],2)],_vm._v(" "),(order.reservation_available_in_app)?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Numărul minim de persoane pentru o rezervare")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.min_reservation),expression:"order.min_reservation"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'min_reservation',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.min_reservation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "min_reservation", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Numărul maxim de persoane pentru o rezervare")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.max_reservation),expression:"order.max_reservation"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'max_reservation',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.max_reservation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "max_reservation", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.max_number_seats')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.max_number_seats),expression:"order.max_number_seats"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'max_number_seats',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.max_number_seats)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "max_number_seats", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.min_between_reservations')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"},{name:"model",rawName:"v-model",value:(order.min_between_reservations),expression:"order.min_between_reservations"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'min_between_reservations',"placeholder":"","disabled":!order.enabled},domProps:{"value":(order.min_between_reservations)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "min_between_reservations", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.min_interval_reservations')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"},{name:"model",rawName:"v-model",value:(order.min_standard_reservations),expression:"order.min_standard_reservations"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'min_interval_reservations',"placeholder":"","disabled":!order.enabled},domProps:{"value":(order.min_standard_reservations)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "min_standard_reservations", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('table',{staticClass:"table no-margin"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"200px"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.min_standard_reservations')))])])]),_vm._v(" "),_c('tbody',_vm._l((order.reservations_intervals),function(resInt,resInt_idx){return _c('tr',[_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.reservations_intervals[resInt_idx]),expression:"order.reservations_intervals[resInt_idx]"}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"8"},domProps:{"value":(order.reservations_intervals[resInt_idx])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order.reservations_intervals, resInt_idx, $event.target.value)}}})])])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.deleteReservationsIntervalsValue(orderIdx, resInt_idx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])])])})),_vm._v(" "),_c('button',{staticClass:"btn add mar-to-15 ",attrs:{"title":_vm.$t('general.add')  + ' moreIntervals'},on:{"click":function($event){$event.preventDefault();_vm.addMoreReservationsIntervals(orderIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                      "+_vm._s(_vm.$t('general.add'))+"\n                                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"},attrs:{"for":'swAlwaysOpen_'+order.id}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.isAlwaysOpen')))]),_vm._v(" "),_c('p-switch',{attrs:{"name":'swAlwaysOpen_'+order.id,"type":"success"},model:{value:(order.is_always_open),callback:function ($$v) {_vm.$set(order, "is_always_open", $$v)},expression:"order.is_always_open"}})],1),_vm._v(" "),(order.is_always_open)?_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                              "+_vm._s(_vm.$t('settingsOrdering.isAlwaysOpenPreorderHours'))+"\n                              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.is_always_open_preorder_hours),expression:"order.is_always_open_preorder_hours"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type +'is_always_open_preorder_hours',"disabled":!order.enabled},domProps:{"value":(order.is_always_open_preorder_hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "is_always_open_preorder_hours", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-bottom":"12px","margin-right":"10px"},attrs:{"for":""}},[_vm._v("\n                              "+_vm._s(_vm.$t('settingsOrdering.offset'))+"\n                              "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.offset),expression:"modelValidate.offset"},{name:"model",rawName:"v-model",value:(order.offset),expression:"order.offset"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type +'offset',"disabled":!order.enabled || order.is_always_open},domProps:{"value":(order.offset)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "offset", $event.target.value)}}})]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                              "+_vm._s(_vm.$t('settingsOrdering.period'))+"\n                              "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.period),expression:"modelValidate.period"},{name:"model",rawName:"v-model",value:(order.period),expression:"order.period"}],staticClass:"form-control",attrs:{"type":"number","min":"1","name":_vm.model.id + order.type +'period',"disabled":!order.enabled || order.is_always_open},domProps:{"value":(order.period)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "period", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.available_days')))]),_vm._v(" "),_vm._l((order.available_days),function(day,dayIdx){return _c('div',{staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[(dayIdx == 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"type":"checkbox","name":_vm.model.id + order.type + 'days',"id":_vm.model.id + order.type + day.day,"disabled":!order.enabled || order.is_always_open},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","name":_vm.model.id + order.type + 'days',"id":_vm.model.id + order.type + day.day,"disabled":!order.enabled || order.is_always_open},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.model.id + order.type + day.day}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + day.day))))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                      from\n                                      "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":day.open_from,"picker-options":_vm.pickerOptions},model:{value:(day.open_from),callback:function ($$v) {_vm.$set(day, "open_from", $$v)},expression:"day.open_from"}}),_vm._v("\n                                      to\n                                      "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":day.open_to,"picker-options":_vm.pickerOptions},model:{value:(day.open_to),callback:function ($$v) {_vm.$set(day, "open_to", $$v)},expression:"day.open_to"}})],1)]),_vm._v(" "),(day.intervals)?_c('div',{staticClass:"row intervals"},[_vm._l((day.intervals),function(interval,intervalKey){return [_c('div',{staticClass:"col-md-3 padd in-inline-160"}),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                      from\n                                      "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":interval.open_from,"picker-options":_vm.pickerOptions},model:{value:(interval.open_from),callback:function ($$v) {_vm.$set(interval, "open_from", $$v)},expression:"interval.open_from"}}),_vm._v("\n                                      to\n                                      "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":interval.open_to,"picker-options":_vm.pickerOptions},model:{value:(interval.open_to),callback:function ($$v) {_vm.$set(interval, "open_to", $$v)},expression:"interval.open_to"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon ",attrs:{"disabled":order.is_always_open},on:{"click":function($event){$event.preventDefault();_vm.deleteIntervals(intervalKey, dayIdx, orderIdx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])],1)]})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn add mar-to-15 ",attrs:{"disabled":order.is_always_open,"title":_vm.$t('general.add')  + ' moreIntervals'},on:{"click":function($event){$event.preventDefault();_vm.addMoreIntervals(dayIdx, orderIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                      "+_vm._s(_vm.$t('general.add'))+"\n                                  ")])])])})],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"order.reservation_pay_per_person",attrs:{"value":"true","label":order.reservation_pay_per_person},model:{value:(order.reservation_pay_per_person),callback:function ($$v) {_vm.$set(order, "reservation_pay_per_person", $$v)},expression:"order.reservation_pay_per_person"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservation_pay_per_person')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"card",staticStyle:{"box-shadow":"none","border":"1px solid #dcdfe6"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('div',{staticClass:"col-md-12 display-flex align-items-center justify-content-space-between"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationTaxesTitle')))]),_vm._v(" "),_c('button',{staticClass:"btn add mar-to-15",attrs:{"title":_vm.$t('general.add')  + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.addReservationTaxesInfo(orderIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                          "+_vm._s(_vm.$t('general.add'))+"\n                                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-lf-0 pad-rg-0"},[_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":_vm.$t('catalogProdOpt.plural')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(order.reservation_taxes && order.reservation_taxes.length == 0)?_c('p',{},[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationTaxesTitleEmpty')))]):_vm._e(),_vm._v(" "),_c('el-collapse',{ref:"elColl",refInFor:true,attrs:{"accordion":""},model:{value:(_vm.reservationTaxesIndex),callback:function ($$v) {_vm.reservationTaxesIndex=$$v},expression:"reservationTaxesIndex"}},[_vm._l((order.reservation_taxes),function(tax,idTax){return [(!tax.deleted_at)?_c('div',{staticClass:"align"},[_c('el-collapse-item',{staticClass:"customItem",attrs:{"title":tax.name === '' ? 'Name' : tax.name,"name":idTax}},[_c('div',{staticClass:"clearfix"},[_c('hr',{staticClass:"no-margin mar-bt-15"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',[_vm._v("ID: "+_vm._s(tax.id))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(tax.name),expression:"tax.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogProd.name')},domProps:{"value":(tax.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                                            "+_vm._s(_vm.getError('name'))+"\n                                                            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.chooseZone')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(tax.table_zone_id),expression:"tax.table_zone_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(tax, "table_zone_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v(_vm._s(_vm.$t('general.all')))]),_vm._v(" "),_vm._l((_vm.tableZones),function(zone){return [_c('option',{domProps:{"value":zone.id}},[_vm._v(_vm._s(zone.name))])]})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.startEndDate')))]),_c('br'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":{
                                                                            disabledDate: function disabledDate (time) {
                                                                                if ((time.getTime() + 86401 * 1000) < Date.now()) {
                                                                                return true
                                                                                } else {
                                                                                return false
                                                                                }
                                                                            }
                                                                            }},model:{value:(tax.date_from),callback:function ($$v) {_vm.$set(tax, "date_from", $$v)},expression:"tax.date_from"}}),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":_vm.pickerOptionsTaxTo},model:{value:(tax.date_to),callback:function ($$v) {_vm.$set(tax, "date_to", $$v)},expression:"tax.date_to"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.price')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(tax.price),expression:"tax.price"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"name","placeholder":_vm.$t('catalogProd.price')},domProps:{"value":(tax.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(tax, "price", $event.target.value)}}}),_vm._v(" "),(Number(tax.price) > 0)?_c('div',{staticClass:"mar-to-15"},[_c('p-checkbox',{key:'adv_' + idTax,attrs:{"value":"true","label":tax.is_advance_consumption},model:{value:(tax.is_advance_consumption),callback:function ($$v) {_vm.$set(tax, "is_advance_consumption", $$v)},expression:"tax.is_advance_consumption"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.reservationTaxAdvanceConsumption')))])],1):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"closeBtn"},[_c('button',{staticClass:"btn btn-danger pull-left btn-icon mar-15",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteReservationTaxesInfo(orderIdx, idTax)}}},[_c('i',{staticClass:"ti-close"})])])],1):_vm._e()]})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15 pad-bt-10"})])])])])])])])]:[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.paymentOptions')))]),_vm._v(" "),_vm._l((_vm.paymentOptions),function(opt,idx){return _c('div',{staticClass:"checkbox mar-bt-20"},[(idx == 0)?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(order.payment_options[opt.payment_id]),expression:"order.payment_options[opt.payment_id]"}],attrs:{"type":"checkbox","name":_vm.model.id + order.type + 'payment',"id":_vm.model.id + order.type + opt.payment_id,"disabled":!order.enabled},domProps:{"value":opt.payment_id,"checked":Array.isArray(order.payment_options[opt.payment_id])?_vm._i(order.payment_options[opt.payment_id],opt.payment_id)>-1:(order.payment_options[opt.payment_id])},on:{"change":function($event){var $$a=order.payment_options[opt.payment_id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=opt.payment_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(order.payment_options, opt.payment_id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(order.payment_options, opt.payment_id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(order.payment_options, opt.payment_id, $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.payment_options[opt.payment_id]),expression:"order.payment_options[opt.payment_id]"}],attrs:{"type":"checkbox","name":_vm.model.id + order.type + 'payment',"id":_vm.model.id + order.type + opt.payment_id,"disabled":!order.enabled},domProps:{"value":opt.payment_id,"checked":Array.isArray(order.payment_options[opt.payment_id])?_vm._i(order.payment_options[opt.payment_id],opt.payment_id)>-1:(order.payment_options[opt.payment_id])},on:{"change":function($event){var $$a=order.payment_options[opt.payment_id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=opt.payment_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(order.payment_options, opt.payment_id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(order.payment_options, opt.payment_id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(order.payment_options, opt.payment_id, $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.model.id + order.type + opt.payment_id}},[_vm._v(_vm._s(opt.name))])])}),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.model.id + order.type + 'payment')),expression:"errors.has(model.id + order.type + 'payment')"}],staticClass:"text-danger"},[_vm._v("\n                              "+_vm._s(_vm.$t('settingsOrdering.paymentOptionsErr'))+"\n                            ")])],2),_vm._v(" "),(order.type != 'delivery')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minimumOrderValue')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min_value: 0}),expression:"{required: true, min_value: 0}"},{name:"model",rawName:"v-model",value:(order.minimum_order_value),expression:"order.minimum_order_value"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'minimum_order_value',"placeholder":"","disabled":!order.enabled},domProps:{"value":(order.minimum_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "minimum_order_value", $event.target.value)}}}),_c('b',[_vm._v(_vm._s(_vm.currency))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.waitingTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.default_waiting_time),expression:"order.default_waiting_time"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'default_waiting_time',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.default_waiting_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "default_waiting_time", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minutes')))])]),_vm._v(" "),(order.type == 'eat_location')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Minim rezervari")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.min_reservation),expression:"order.min_reservation"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'min_reservation',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.min_reservation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "min_reservation", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(order.type == 'eat_location')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Maxim rezervari")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.max_reservation),expression:"order.max_reservation"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'max_reservation',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.max_reservation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "max_reservation", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[(order.type != 'self_ordering' && !order.use_multiple_delivery_preferences)?[_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"},attrs:{"for":'swPreorders_'+order.id}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.noPreorders')))]),_vm._v(" "),_c('p-switch',{attrs:{"name":'swPreorders_'+order.id,"type":"success"},model:{value:(order.no_preorders),callback:function ($$v) {_vm.$set(order, "no_preorders", $$v)},expression:"order.no_preorders"}}),_vm._v(" "),(order.offset > 0 || order.period > 1)?_c('span',[_vm._v(_vm._s(_vm.$t('settingsOrdering.offnoPreorders')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"},attrs:{"for":'swAlwaysOpen_'+order.id}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.isAlwaysOpen')))]),_vm._v(" "),_c('p-switch',{attrs:{"name":'swAlwaysOpen_'+order.id,"type":"success"},model:{value:(order.is_always_open),callback:function ($$v) {_vm.$set(order, "is_always_open", $$v)},expression:"order.is_always_open"}})],1),_vm._v(" "),(order.is_always_open)?_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                                  "+_vm._s(_vm.$t('settingsOrdering.isAlwaysOpenPreorderHours'))+"\n                                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.is_always_open_preorder_hours),expression:"order.is_always_open_preorder_hours"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type +'is_always_open_preorder_hours',"disabled":!order.enabled},domProps:{"value":(order.is_always_open_preorder_hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "is_always_open_preorder_hours", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.availableDays')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.model.id + order.type + 'days')),expression:"errors.has(model.id + order.type + 'days')"}],staticClass:"text-danger"},[_vm._v("\n                                "+_vm._s(_vm.$t('settingsOrdering.availableDaysErr'))+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"changeDeliveryDisponibility"},[_c('div',{},_vm._l((_vm.delivery_hour_usage),function(dusg,dusgId){return _c('p-radio',{key:dusgId,attrs:{"label":dusgId,"inline":true},on:{"input":function($event){_vm.changeDeliveryHourUsage(order)}},model:{value:(order.delivery_hour_usage),callback:function ($$v) {_vm.$set(order, "delivery_hour_usage", $$v)},expression:"order.delivery_hour_usage"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering')[dusg.name])+"\n                                  ")])})),_vm._v(" "),_c('hr')])]:_vm._e(),_vm._v(" "),(!order.deactivate_delivery_hour_usage)?[(order.type != 'self_ordering')?[_c('label',{staticStyle:{"margin-bottom":"12px","margin-right":"10px"},attrs:{"for":""}},[_vm._v("\n                                  "+_vm._s(_vm.$t('settingsOrdering.offset'))+"\n                                  "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.offset),expression:"modelValidate.offset"},{name:"model",rawName:"v-model",value:(order.offset),expression:"order.offset"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type +'offset',"disabled":order.is_always_open},domProps:{"value":(order.offset)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "offset", $event.target.value)}}})]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                                  "+_vm._s(_vm.$t('settingsOrdering.period'))+"\n                                  "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.period),expression:"modelValidate.period"},{name:"model",rawName:"v-model",value:(order.period),expression:"order.period"}],staticClass:"form-control",attrs:{"type":"number","min":"1","name":_vm.model.id + order.type +'period',"disabled":order.is_always_open},domProps:{"value":(order.period)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "period", $event.target.value)}}})])]:_vm._e(),_vm._v(" "),_vm._l((order.available_days),function(day,dayIdx){return _c('div',{staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[(dayIdx == 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"type":"checkbox","name":_vm.model.id + order.type + 'days',"id":_vm.model.id + order.type + day.day,"disabled":!order.enabled || order.is_always_open},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","name":_vm.model.id + order.type + 'days',"id":_vm.model.id + order.type + day.day,"disabled":!order.enabled || order.is_always_open},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.model.id + order.type + day.day}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + day.day))))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                    from\n                                    "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":day.open_from,"picker-options":_vm.pickerOptions},model:{value:(day.open_from),callback:function ($$v) {_vm.$set(day, "open_from", $$v)},expression:"day.open_from"}}),_vm._v("\n                                    to\n                                    "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":day.open_to,"picker-options":_vm.pickerOptions},model:{value:(day.open_to),callback:function ($$v) {_vm.$set(day, "open_to", $$v)},expression:"day.open_to"}})],1)]),_vm._v(" "),(day.intervals)?_c('div',{staticClass:"row intervals"},[_vm._l((day.intervals),function(interval,intervalKey){return [_c('div',{staticClass:"col-md-3 padd in-inline-160"}),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                    from\n                                    "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":interval.open_from,"picker-options":_vm.pickerOptions},model:{value:(interval.open_from),callback:function ($$v) {_vm.$set(interval, "open_from", $$v)},expression:"interval.open_from"}}),_vm._v("\n                                    to\n                                    "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":interval.open_to,"picker-options":_vm.pickerOptions},model:{value:(interval.open_to),callback:function ($$v) {_vm.$set(interval, "open_to", $$v)},expression:"interval.open_to"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon ",attrs:{"disabled":order.is_always_open},on:{"click":function($event){$event.preventDefault();_vm.deleteIntervals(intervalKey, dayIdx, orderIdx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])],1)]})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn add",attrs:{"disabled":order.is_always_open,"title":_vm.$t('general.add')  + ' moreIntervals'},on:{"click":function($event){$event.preventDefault();_vm.addMoreIntervals(dayIdx, orderIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                  "+_vm._s(_vm.$t('general.add'))+"\n                                ")])])])})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('hr')])],_vm._v(" "),(order.type != 'self_ordering')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"card",staticStyle:{"box-shadow":"none","border":"1px solid #dcdfe6"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('div',{staticClass:"col-md-12 display-flex align-items-center justify-content-space-between"},[_c('h6',[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxTitle')))]),_vm._v(" "),_c('button',{staticClass:"btn add ",attrs:{"title":_vm.$t('general.add')  + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.addMethodInfo(orderIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                                        "+_vm._s(_vm.$t('general.add'))+"\n                                                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-lf-0 pad-rg-0"},[_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":_vm.$t('catalogProdOpt.plural')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(!order.method_info || (order.method_info && order.method_info.length == 0))?_c('p',{},[_vm._v("No options added yet.")]):_vm._e(),_vm._v(" "),_c('el-collapse',{ref:"elColl",refInFor:true,attrs:{"accordion":""},model:{value:(_vm.methodInfoIndex),callback:function ($$v) {_vm.methodInfoIndex=$$v},expression:"methodInfoIndex"}},[_vm._l((order.method_info),function(option,idxO){return [_c('div',{staticClass:"align"},[_c('el-collapse-item',{staticClass:"customItem",attrs:{"title":option.title === '' ? 'Name' : option.title,"name":idxO}},[_c('div',{staticClass:"clearfix"},[_c('hr',{staticClass:"no-margin mar-bt-15"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(option.title),expression:"option.title"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogProd.name')},domProps:{"value":(option.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "title", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                                                          "+_vm._s(_vm.getError('name'))+"\n                                                                          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxRadioCheck')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.type),expression:"option.type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"check"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxCheck')))]),_vm._v(" "),_c('option',{attrs:{"value":"radio"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxRadio')))])])])])]),_vm._v(" "),_c('table',{staticClass:"table no-margin"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"200px"}},[_vm._v(_vm._s(_vm.$t('catalogProd.optVal')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('general.delete')))])])]),_vm._v(" "),_c('tbody',_vm._l((option.options),function(value,idx){return _c('tr',[_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.title),expression:"value.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(value.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "title", $event.target.value)}}})])])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.deleteMethodInfoOptionValue(orderIdx, idxO, idx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])])])}))]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn add mar-bt-5",on:{"click":function($event){$event.preventDefault();_vm.addMethodInfoOptionValue(orderIdx, idxO)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                                                        "+_vm._s(_vm.$t('general.add'))+"\n                                                                      ")])])]),_vm._v(" "),_c('div',{staticClass:"closeBtn"},[_c('button',{staticClass:"btn btn-danger pull-left btn-icon mar-15",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteMethodInfo(orderIdx, idxO)}}},[_c('i',{staticClass:"ti-close"})])])],1)]})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15 pad-bt-10"})])])])])])])])]):_vm._e()]:[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.paymentOptions')))]),_vm._v(" "),_vm._l((_vm.paymentOptions),function(opt,idx){return _c('div',{staticClass:"checkbox mar-bt-20"},[(idx == 0)?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(order.payment_options[opt.payment_id]),expression:"order.payment_options[opt.payment_id]"}],attrs:{"type":"checkbox","name":_vm.model.id + order.type + 'payment',"id":_vm.model.id + order.type + opt.payment_id,"disabled":!order.enabled},domProps:{"value":opt.payment_id,"checked":Array.isArray(order.payment_options[opt.payment_id])?_vm._i(order.payment_options[opt.payment_id],opt.payment_id)>-1:(order.payment_options[opt.payment_id])},on:{"change":function($event){var $$a=order.payment_options[opt.payment_id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=opt.payment_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(order.payment_options, opt.payment_id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(order.payment_options, opt.payment_id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(order.payment_options, opt.payment_id, $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.payment_options[opt.payment_id]),expression:"order.payment_options[opt.payment_id]"}],attrs:{"type":"checkbox","name":_vm.model.id + order.type + 'payment',"id":_vm.model.id + order.type + opt.payment_id,"disabled":!order.enabled},domProps:{"value":opt.payment_id,"checked":Array.isArray(order.payment_options[opt.payment_id])?_vm._i(order.payment_options[opt.payment_id],opt.payment_id)>-1:(order.payment_options[opt.payment_id])},on:{"change":function($event){var $$a=order.payment_options[opt.payment_id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=opt.payment_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(order.payment_options, opt.payment_id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(order.payment_options, opt.payment_id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(order.payment_options, opt.payment_id, $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.model.id + order.type + opt.payment_id}},[_vm._v(_vm._s(opt.name))])])}),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.model.id + order.type + 'payment')),expression:"errors.has(model.id + order.type + 'payment')"}],staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.$t('settingsOrdering.paymentOptionsErr'))+"\n                          ")])],2),_vm._v(" "),(order.type == 'delivery')?[_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"},attrs:{"for":_vm.model.id + order.type + 'ump'}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.useMultiplePreferences')))]),_vm._v(" "),_c('p-switch',{attrs:{"name":_vm.model.id + order.type + 'ump',"type":"success"},model:{value:(order.use_multiple_delivery_preferences),callback:function ($$v) {_vm.$set(order, "use_multiple_delivery_preferences", $$v)},expression:"order.use_multiple_delivery_preferences"}}),_vm._v(" "),_c('small',{staticClass:"text-muted",staticStyle:{"display":"block"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.useMultiplePreferencesHelp')))])],1),_vm._v(" "),(order.use_multiple_delivery_preferences)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('deliveryPreferences.selectPreferences')))]),_vm._v(" "),(!_vm.deliveryPreferencesList.length)?_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.noData')))]):[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferenceSearch),expression:"preferenceSearch"}],staticClass:"form-control",staticStyle:{"margin-bottom":"8px","max-width":"560px"},attrs:{"type":"text","placeholder":_vm.$t('general.search')},domProps:{"value":(_vm.preferenceSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.preferenceSearch=$event.target.value}}}),_vm._v(" "),_c('div',{staticStyle:{"max-height":"260px","overflow-y":"auto","border":"1px solid #e0e0e0","border-radius":"4px","max-width":"560px"}},[_vm._l((_vm.filteredPreferences()),function(pref){return _c('div',{key:'pref' + pref.id,staticStyle:{"display":"flex","align-items":"center","gap":"8px","padding":"8px 10px","cursor":"pointer","border-bottom":"1px solid #f0f0f0"},style:({ background: _vm.isPreferenceChecked(order, pref.id) ? '#eef7ee' : 'transparent' }),on:{"click":function($event){_vm.togglePreference(order, pref.id)}}},[_c('input',{staticStyle:{"margin":"0","pointer-events":"none"},attrs:{"type":"checkbox"},domProps:{"checked":_vm.isPreferenceChecked(order, pref.id)}}),_vm._v(" "),_c('span',{staticStyle:{"flex":"1"}},[(pref.nume_admin)?_c('strong',[_vm._v(_vm._s(pref.nume_admin))]):_vm._e(),(pref.nume_admin)?_c('span',[_vm._v(" — ")]):_vm._e(),_vm._v(_vm._s(pref.name)+"\n                                    "),_c('small',{staticClass:"text-muted"},[_vm._v("("+_vm._s(pref.type === 2 ? _vm.$t('deliveryPreferences.typeSlot') : _vm.$t('deliveryPreferences.typeClassic'))+")")])])])}),_vm._v(" "),(!_vm.filteredPreferences().length)?_c('p',{staticClass:"text-muted",staticStyle:{"padding":"10px","margin":"0"}},[_vm._v(_vm._s(_vm.$t('deliveryPreferences.noData')))]):_vm._e()],2)]],2):_vm._e()]:_vm._e(),_vm._v(" "),(order.type != 'delivery')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minimumOrderValue')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min_value: 0}),expression:"{required: true, min_value: 0}"},{name:"model",rawName:"v-model",value:(order.minimum_order_value),expression:"order.minimum_order_value"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'minimum_order_value',"placeholder":"","disabled":!order.enabled},domProps:{"value":(order.minimum_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "minimum_order_value", $event.target.value)}}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.currency))])]):_vm._e(),_vm._v(" "),(!(order.type == 'delivery' && order.use_multiple_delivery_preferences))?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.waitingTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.default_waiting_time),expression:"order.default_waiting_time"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'default_waiting_time',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.default_waiting_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "default_waiting_time", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minutes')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.count_orders_starts_from_hour')))]),_vm._v(" "),_c('el-time-select',{attrs:{"disabled":!order.enabled,"placeholder":"Select Hour","value":order.count_orders_starts_from_hour,"picker-options":_vm.picker_options_orders_starts_from},model:{value:(order.count_orders_starts_from_hour),callback:function ($$v) {_vm.$set(order, "count_orders_starts_from_hour", $$v)},expression:"order.count_orders_starts_from_hour"}})],1),_vm._v(" "),(order.type === 'delivery' && !order.use_multiple_delivery_preferences)?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.shipping_department_id')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(order.shipping_department_id),expression:"order.shipping_department_id",modifiers:{"number":true}}],staticClass:"form-control sml",attrs:{"type":"number","min":"1","name":_vm.model.id + order.type + 'shipping_department_id'},domProps:{"value":(order.shipping_department_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "shipping_department_id", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.deliveryRules')))])])]),_vm._v(" "),_vm._l((_vm.zoneLimitations),function(zoneL,zoneId){return _c('el-radio',{key:_vm.model.id + order.type + zoneId,attrs:{"change":_vm.handleChangeArea(order.area, _vm.model.id),"label":zoneId,"inline":true},model:{value:(order.area),callback:function ($$v) {_vm.$set(order, "area", $$v)},expression:"order.area"}},[_vm._v(_vm._s(_vm.$t('settingCompany.'+ zoneL))+"\n                          ")])}),_vm._v(" "),(order.area == 'radius')?[(_vm.taxesVersion === 2)?_c('delivery-tax-panel',{staticClass:"mar-bt-20",attrs:{"location-id":_vm.model.true_id || _vm.model.id,"currency":_vm.currency}}):_vm._e(),_vm._v(" "),_vm._l((order.delivery_rules),function(rule,idx){return _c('table',{key:_vm.model.id+ idx + 'rule',staticClass:"table table-rules"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"15px"}},[_c('b',[_vm._v(_vm._s((idx + 1)))])]),_vm._v(" "),_c('th',{staticStyle:{"line-height":"2"},attrs:{"width":""}},[_vm._v("\n                                  "+_vm._s(_vm.$t('settingsOrdering.deliveryRange'))+" ("+_vm._s(_vm.$t('settingsOrdering.deliveryRangeUnit'))+")\n                                  "),(order.delivery_rules.length > 1)?_c('button',{staticClass:"btn btn-danger btn-icon pull-right",on:{"click":function($event){$event.preventDefault();_vm.removeRule(_vm.model.id, idx, order.type)}}},[_c('i',{staticClass:"ti-trash",attrs:{"title":_vm.$t('general.remove')}}),_vm._v(" "+_vm._s(_vm.$t('general.remove'))+"\n                                  ")]):_vm._e()])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({min_value: 0}),expression:"{min_value: 0}"},{name:"model",rawName:"v-model",value:(rule.delivery_range),expression:"rule.delivery_range"}],ref:_vm.model.id + order.type +'delivery_range'+idx,refInFor:true,staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type +'delivery_range'+idx,"placeholder":"","disabled":!order.enabled,"aria-invalid":_vm.errors.has(_vm.model.id + order.type +'delivery_range'+idx)},domProps:{"value":(rule.delivery_range)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(rule, "delivery_range", $event.target.value)}}}),_vm._v(" "),_c('table',{staticClass:"table table-subrules"},[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$t('settingsOrdering.shippingNeighborhoods')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('settingsOrdering.shippingCities')))]),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('th',{attrs:{"width":"10%"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('settingsOrdering.shippingCost'))+" ("+_vm._s(_vm.currency)+")\n                                      ")]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('th',{attrs:{"width":"10%"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('catalogCateg.vat'))+" "),_c('small',[_vm._v("("+_vm._s(_vm.$t('catalogCateg.included'))+")")])]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('th',{attrs:{"width":"10%"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('settingsOrdering.posId'))+"\n                                      ")]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('th',{attrs:{"width":"10%"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('settingsOrdering.minimumOrderValue'))+" ("+_vm._s(_vm.currency)+")\n                                      ")]):_vm._e(),_vm._v(" "),_c('th')]),_vm._v(" "),_vm._l((rule.subrules),function(subrule,idxSubrule){return _c('tr',{key:_vm.model.id+ idx + idxSubrule + 'subrule'},[_c('td',{staticClass:"display-text-white"},[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(subrule.neighborhoods),callback:function ($$v) {_vm.$set(subrule, "neighborhoods", $$v)},expression:"subrule.neighborhoods"}},_vm._l((subrule.neighborhoods),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('td',{staticClass:"display-text-white"},[[_c('el-select',{attrs:{"multiple":"","filterable":"","allow-create":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(subrule.cities),callback:function ($$v) {_vm.$set(subrule, "cities", $$v)},expression:"subrule.cities"}},_vm._l((subrule.cities),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}))]],2),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min_value: 0}),expression:"{required: true, min_value: 0}"},{name:"model",rawName:"v-model",value:(subrule.shipping_cost),expression:"subrule.shipping_cost"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type +'shipping_cost'+order.type+idx+idxSubrule,"placeholder":"","disabled":!order.enabled},domProps:{"value":(subrule.shipping_cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(subrule, "shipping_cost", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(subrule.tax_id),expression:"subrule.tax_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(subrule, "tax_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('vat.selectVat')))]),_vm._v(" "),_vm._l((_vm.vatOptions),function(tax){return (_vm.model.id == tax.location_token)?_c('option',{domProps:{"value":tax.id}},[_vm._v(_vm._s(tax.amount)+"\n                                            ")]):_vm._e()})],2)]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(subrule.shipping_pos_id),expression:"subrule.shipping_pos_id"}],staticClass:"form-control sml",attrs:{"type":"text","name":_vm.model.id + order.type +'shipping_pos_id'+order.type+idx+idxSubrule,"placeholder":_vm.$t('settingsOrdering.posId'),"disabled":!order.enabled},domProps:{"value":(subrule.shipping_pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(subrule, "shipping_pos_id", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.taxesVersion !== 2)?_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, min_value: 0}),expression:"{required: true, min_value: 0}"},{name:"model",rawName:"v-model",value:(subrule.min_order_value),expression:"subrule.min_order_value"}],staticClass:"form-control sml",attrs:{"type":"text","name":_vm.model.id + order.type +'shipping_pos_id'+order.type+idx+idxSubrule,"placeholder":_vm.$t('settingsOrdering.minimumOrderValue'),"disabled":!order.enabled},domProps:{"value":(subrule.min_order_value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(subrule, "min_order_value", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('td',[(rule.subrules.length > 1)?_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.removeSubRule(_vm.model.id, idx, idxSubrule,order.type)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.remove')}})]):_vm._e()])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":_vm.taxesVersion === 2 ? 2 : 4}}),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addNewSubRule(_vm.model.id, order.type, idx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                            "+_vm._s(_vm.$t('general.add'))+" \n                                          ")])])])],2)])])])])}),_vm._v(" "),_c('button',{staticClass:"btn add mar-bt-15 ",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addNewRule(_vm.model.id, order.type)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                              "+_vm._s(_vm.$t('general.add'))+" \n                            ")]),_vm._v(" "),_c('br')]:_vm._e(),_vm._v(" "),(order.area == 'draw')?[_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"draw-zones-toolbar"},[_c('div',{staticClass:"disable-chck"},[_c('p-checkbox',{key:"showTheRestOfTheZones",attrs:{"value":"true"},model:{value:(_vm.showTheRestOfTheZones),callback:function ($$v) {_vm.showTheRestOfTheZones=$$v},expression:"showTheRestOfTheZones"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.showTheRestOfTheZones')))])],1),_vm._v(" "),_c('button',{staticClass:"btn add",on:{"click":function($event){$event.preventDefault();return _vm.openCopyDeliveryRangesModal($event)}}},[_vm._v("\n                                "+_vm._s(_vm.$t('settingsOrdering.copyRangesFromLocation'))+"\n                              ")])]),_vm._v(" "),_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.model.mapactive),callback:function ($$v) {_vm.$set(_vm.model, "mapactive", $$v)},expression:"model.mapactive"}},[(_vm.deliveryRanges && _vm.deliveryRanges.length > 0 && _vm.deliveryRangesDataReady)?_c('draggable',{attrs:{"element":'div'},model:{value:(_vm.deliveryRanges),callback:function ($$v) {_vm.deliveryRanges=$$v},expression:"deliveryRanges"}},_vm._l((_vm.deliveryRanges),function(zone,indexZone){return _c('div',[(zone)?_c('div',{key:indexZone,staticClass:"sortableRow"},[_c('el-collapse-item',{attrs:{"title":zone.name == '' ? _vm.$t('settingsOrdering.newZone'):zone.name,"name":indexZone}},[_c('template',{slot:"title"},[_c('div',{staticClass:"delivery-zone-header"},[_c('span',[_vm._v(_vm._s(zone.name == '' ? _vm.$t('settingsOrdering.newZone') : zone.name))]),_vm._v(" "),(zone.active === false)?_c('span',{staticClass:"badge",staticStyle:{"background":"#dc3545","color":"#fff","padding":"3px 8px","border-radius":"4px","margin-left":"8px"}},[_vm._v(_vm._s(_vm.$t('zoneAvailability.inactive')))]):(zone.schedule_enabled)?_c('span',{staticClass:"badge",staticStyle:{"background":"#2196f3","color":"#fff","padding":"3px 8px","border-radius":"4px","margin-left":"8px"}},[_vm._v(_vm._s(_vm.$t('zoneAvailability.withSchedule')))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-info delivery-zone-duplicate",attrs:{"type":"button","title":_vm.$t('general.duplicate')},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.duplicateZone(indexZone)}}},[_c('i',{staticClass:"ti-files"}),_vm._v(" "+_vm._s(_vm.$t('general.duplicate'))+"\n                                          ")])])]),_vm._v(" "),(_vm.model.mapactive == indexZone)?[_c('delivery-google-maps',{attrs:{"googleMapsapiKey":_vm.model.google_maps_api_key,"cityFromParent":_vm.model.city,"locationMarker":{lat: _vm.model.lat, lng: _vm.model.lng, name: _vm.model.name},"showTheRestOfTheZones":_vm.showTheRestOfTheZones,"zoneInComp":zone,"deliveryRanges":_vm.deliveryRanges,"indexZone":indexZone,"bussLocationId":_vm.model.id,"location_id":_vm.model.true_id,"orderType":order.type,"currency":_vm.currency,"vatOptions":_vm.vatOptions,"taxes-version":_vm.taxesVersion},on:{"update-zone":_vm.handleUpdateZone}}),_vm._v(" "),_c('zone-availability-editor',{attrs:{"zone":zone,"showErrors":!!zone.__availability_error}})]:_vm._e()],2)],1):_vm._e()])})):_vm._e()],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn add",on:{"click":function($event){$event.preventDefault();_vm.addNewZone(_vm.model.id, order.type)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                              "+_vm._s(_vm.$t('settingsOrdering.addZone')))]),_vm._v(" "),_c('br')]:_vm._e(),_vm._v(" "),_c('br')]:_vm._e(),_vm._v(" "),(order.type === 'meet_half')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.locations')))]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.street')))]),_vm._v(" "),_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.city')))]),_vm._v(" "),_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.country')))]),_vm._v(" "),_c('th',{attrs:{"width":"23%"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.state')))]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}})])]),_vm._v(" "),_c('tbody',[_vm._l((order.locations),function(location,idx){return _c('tr',[_c('td',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"},{name:"model",rawName:"v-model",value:(location.street),expression:"location.street"}],staticClass:"form-control",attrs:{"type":"text","name":_vm.model.id + order.type +'locationstr'+order.type+idx,"disabled":!order.enabled},domProps:{"value":(location.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "street", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.city),expression:"location.city"}],staticClass:"form-control",attrs:{"type":"text","name":_vm.model.id + order.type +'locationcity'+order.type+idx,"disabled":!order.enabled,"vv-validate":"modelValidate.required"},domProps:{"value":(location.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "city", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.country),expression:"location.country"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"select-primary form-control",attrs:{"name":_vm.model.id + order.type +'locationcountry'+order.type+idx,"disabled":!order.enabled},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateCountry(location)}]}},_vm._l((_vm.defaults.countries),function(country){return _c('option',{staticClass:"select-primary",domProps:{"value":country.alpha2}},[_vm._v(_vm._s(country.name)+"\n                                      ")])}))]),_vm._v(" "),_c('td',[(_vm.showStateDrop(location))?[_c('select',{directives:[{name:"model",rawName:"v-model",value:(location.state_id),expression:"location.state_id"}],staticClass:"select-primary form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(location, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.getStatesOptions(location)),function(state){return _c('option',{staticClass:"select-primary",domProps:{"value":state.id}},[_vm._v(_vm._s(state.name)+"\n                                        ")])}))]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(location.state),expression:"location.state"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control",attrs:{"type":"text","name":"state","placeholder":_vm.$t('settingsOrdering.state')},domProps:{"value":(location.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(location, "state", $event.target.value)}}})]],2),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){$event.preventDefault();_vm.removeLocation(_vm.model.id, idx, order.type)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.remove')}})])])])}),_vm._v(" "),[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();_vm.addNewLocation(_vm.model.id, order.type)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                      "+_vm._s(_vm.$t('general.add'))+"\n                                    ")])])])]],2),_vm._v(" "),_c('tfoot')])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[(order.type == 'self_ordering')?[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"checkbox mar-bt-20"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.allow_sms_notifications),expression:"order.allow_sms_notifications"}],attrs:{"type":"checkbox","name":order.id + order.type + 'allow_sms_notifications',"id":order.id + order.type + 'allow_sms_notifications'},domProps:{"value":order.allow_sms_notifications,"checked":Array.isArray(order.allow_sms_notifications)?_vm._i(order.allow_sms_notifications,order.allow_sms_notifications)>-1:(order.allow_sms_notifications)},on:{"change":function($event){var $$a=order.allow_sms_notifications,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=order.allow_sms_notifications,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(order, "allow_sms_notifications", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(order, "allow_sms_notifications", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(order, "allow_sms_notifications", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":order.id + order.type + 'allow_sms_notifications'}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.allow_sms_notifications')))])])])]:_vm._e(),_vm._v(" "),(order.type == 'self_ordering')?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.maxDistanceInMeter')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.max_distance_in_meter),expression:"order.max_distance_in_meter"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.required),expression:"modelValidate.required"}],staticClass:"form-control sml",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type + 'max_distance_in_meter',"disabled":!order.enabled,"placeholder":""},domProps:{"value":(order.max_distance_in_meter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "max_distance_in_meter", $event.target.value)}}})])]:_vm._e(),_vm._v(" "),[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.closeOrders', {deliveryMethod: order.label})))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(order.closeOrder),expression:"order.closeOrder"}],staticClass:"form-control sml",on:{"input":function($event){_vm.handleClosingHour(orderIdx, $event)},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(order, "closeOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.closeOrderOptions),function(option){return _c('option',{domProps:{"value":option.id}},[_vm._v(_vm._s(option.label))])})),_vm._v(" "),(order.closeOrder)?[_c('el-time-select',{attrs:{"placeholder":"Select hour","picker-options":_vm.picker_options_orders_starts_from},model:{value:(order.auto_close_orders_at_hour),callback:function ($$v) {_vm.$set(order, "auto_close_orders_at_hour", $$v)},expression:"order.auto_close_orders_at_hour"}})]:[_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.auto_close_orders_after_hour),expression:"order.auto_close_orders_after_hour"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.auto_close_orders_after_hour),expression:"modelValidate.auto_close_orders_after_hour"}],staticClass:"form-control sml",attrs:{"name":_vm.model.id + order.type + 'auto_close_orders_after_hour',"type":"number","min":"0","max":"12","placeholder":"3"},domProps:{"value":(order.auto_close_orders_after_hour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "auto_close_orders_after_hour", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.hours')))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.model.id + order.type + 'auto_close_orders_after_hour')),expression:"errors.has(model.id + order.type + 'auto_close_orders_after_hour')"}],staticClass:"text-danger"},[_vm._v("\n                                  "+_vm._s(_vm.$t('settingsOrdering.closeOrderAfterHours'))+"\n                                ")])]],2)],_vm._v(" "),[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"checkbox mar-bt-20"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isAutoChangeEnabled[orderIdx]),expression:"isAutoChangeEnabled[orderIdx]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isAutoChangeEnabled[orderIdx])?_vm._i(_vm.isAutoChangeEnabled[orderIdx],null)>-1:(_vm.isAutoChangeEnabled[orderIdx])},on:{"change":[function($event){var $$a=_vm.isAutoChangeEnabled[orderIdx],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.isAutoChangeEnabled, orderIdx, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.isAutoChangeEnabled, orderIdx, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.isAutoChangeEnabled, orderIdx, $$c)}},function($event){_vm.isAutoChangeEnabledChange(orderIdx)}]}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.autoChangeStatus', {deliveryMethod: order.label})))])]),_vm._v(" "),(_vm.isAutoChangeEnabled[orderIdx])?[_c('select',{directives:[{name:"model",rawName:"v-model",value:(order.status_from_auto_change),expression:"order.status_from_auto_change"}],staticClass:"form-control sml",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(order, "status_from_auto_change", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.statusesAutoChange),function(option1){return _c('option',{domProps:{"value":option1.name}},[_vm._v(_vm._s(option1.name))])})),_vm._v("\n                                ->\n                                "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(order.status_to_auto_change),expression:"order.status_to_auto_change"}],staticClass:"form-control sml",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(order, "status_to_auto_change", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.statusesAutoChange),function(option){return [(order.status_from_auto_change == option.name)?_vm._l((option.values),function(option2){return _c('option',{domProps:{"value":option2}},[_vm._v(_vm._s(option2))])}):_vm._e()]})],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.auto_change_status_after_min),expression:"order.auto_change_status_after_min"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.auto_change_status_after_min),expression:"modelValidate.auto_change_status_after_min"}],staticClass:"form-control sml",attrs:{"name":_vm.model.id + order.type + 'auto_change_status_after_min',"type":"number","min":"0","max":"360","placeholder":"1"},domProps:{"value":(order.auto_change_status_after_min)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "auto_change_status_after_min", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.minutes')))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.model.id + order.type + 'auto_change_status_after_min')),expression:"errors.has(model.id + order.type + 'auto_change_status_after_min')"}],staticClass:"text-danger"},[_vm._v("\n                                    "+_vm._s(_vm.$t('settingsOrdering.errorAutoChangeStatusAfterMin'))+"\n                                  ")])]:_vm._e()],2)],_vm._v(" "),(order.type != 'self_ordering' && !order.use_multiple_delivery_preferences)?[_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"},attrs:{"for":'swPreorders_'+order.id}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.noPreorders')))]),_vm._v(" "),_c('p-switch',{attrs:{"name":'swPreorders_'+order.id,"type":"success"},model:{value:(order.no_preorders),callback:function ($$v) {_vm.$set(order, "no_preorders", $$v)},expression:"order.no_preorders"}}),_vm._v(" "),(order.offset > 0 || order.period > 1)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('settingsOrdering.offnoPreorders')))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-right":"10px"},attrs:{"for":'swAlwaysOpen_'+order.id}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.isAlwaysOpen')))]),_vm._v(" "),_c('p-switch',{attrs:{"name":'swAlwaysOpen_'+order.id,"type":"success"},model:{value:(order.is_always_open),callback:function ($$v) {_vm.$set(order, "is_always_open", $$v)},expression:"order.is_always_open"}})],1),_vm._v(" "),(order.is_always_open)?_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                                "+_vm._s(_vm.$t('settingsOrdering.isAlwaysOpenPreorderHours'))+"\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(order.is_always_open_preorder_hours),expression:"order.is_always_open_preorder_hours"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type +'is_always_open_preorder_hours',"disabled":!order.enabled},domProps:{"value":(order.is_always_open_preorder_hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "is_always_open_preorder_hours", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.availableDays')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has(_vm.model.id + order.type + 'days')),expression:"errors.has(model.id + order.type + 'days')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('settingsOrdering.availableDaysErr')))]),_vm._v(" "),_c('div',{staticClass:"changeDeliveryDisponibility"},[_c('div',{},_vm._l((_vm.delivery_hour_usage),function(dusg,dusgId){return _c('p-radio',{key:dusgId,attrs:{"label":dusgId,"inline":true},on:{"input":function($event){_vm.changeDeliveryHourUsage(order)}},model:{value:(order.delivery_hour_usage),callback:function ($$v) {_vm.$set(order, "delivery_hour_usage", $$v)},expression:"order.delivery_hour_usage"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering')[dusg.name])+"\n                                ")])})),_vm._v(" "),_c('hr')])]:_vm._e(),_vm._v(" "),(!order.use_multiple_delivery_preferences)?[(order.type != 'self_ordering' && !order.deactivate_delivery_hour_usage && !order.use_multiple_delivery_preferences)?[_c('label',{staticStyle:{"margin-bottom":"12px","margin-right":"10px"},attrs:{"for":""}},[_vm._v("\n                                "+_vm._s(_vm.$t('settingsOrdering.offset'))+"\n                                "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.offset),expression:"modelValidate.offset"},{name:"model",rawName:"v-model",value:(order.offset),expression:"order.offset"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":_vm.model.id + order.type +'offset',"disabled":order.is_always_open},domProps:{"value":(order.offset)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "offset", $event.target.value)}}})]),_vm._v(" "),_c('label',{staticStyle:{"margin-bottom":"12px"},attrs:{"for":""}},[_vm._v("\n                                "+_vm._s(_vm.$t('settingsOrdering.period'))+"\n                                "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.period),expression:"modelValidate.period"},{name:"model",rawName:"v-model",value:(order.period),expression:"order.period"}],staticClass:"form-control",attrs:{"type":"number","min":"1","name":_vm.model.id + order.type +'period',"disabled":order.is_always_open},domProps:{"value":(order.period)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(order, "period", $event.target.value)}}})])]:_vm._e(),_vm._v(" "),_vm._l((order.available_days),function(day,dayIdx){return _c('div',{staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start","margin-bottom":"20px"}},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 padd in-inline-160"},[_c('div',{staticClass:"checkbox"},[(dayIdx == 0)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"},{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"type":"checkbox","name":_vm.model.id + order.type + 'days',"id":_vm.model.id + order.type + day.day,"disabled":!order.enabled || order.is_always_open},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(day.open),expression:"day.open"}],attrs:{"type":"checkbox","name":_vm.model.id + order.type + 'days',"id":_vm.model.id + order.type + day.day,"disabled":!order.enabled || order.is_always_open},domProps:{"value":day.day,"checked":Array.isArray(day.open)?_vm._i(day.open,day.day)>-1:(day.open)},on:{"change":function($event){var $$a=day.open,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.day,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(day, "open", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(day, "open", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(day, "open", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.model.id + order.type + day.day}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + day.day))))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                      from\n                                      "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":day.open_from,"picker-options":_vm.pickerOptions},model:{value:(day.open_from),callback:function ($$v) {_vm.$set(day, "open_from", $$v)},expression:"day.open_from"}}),_vm._v("\n                                      to\n                                      "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":day.open_to,"picker-options":_vm.pickerOptions},model:{value:(day.open_to),callback:function ($$v) {_vm.$set(day, "open_to", $$v)},expression:"day.open_to"}})],1)]),_vm._v(" "),(day.intervals)?_c('div',{staticClass:"row intervals"},[_vm._l((day.intervals),function(interval,intervalKey){return [_c('div',{staticClass:"col-md-3 padd in-inline-160"}),_vm._v(" "),_c('div',{staticClass:"col-md-9 padd"},[_vm._v("\n                                      from\n                                      "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":interval.open_from,"picker-options":_vm.pickerOptions},model:{value:(interval.open_from),callback:function ($$v) {_vm.$set(interval, "open_from", $$v)},expression:"interval.open_from"}}),_vm._v("\n                                      to\n                                      "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.available_days),expression:"modelValidate.available_days"}],attrs:{"disabled":!day.open || !order.enabled || order.is_always_open,"placeholder":"Select time","value":interval.open_to,"picker-options":_vm.pickerOptions},model:{value:(interval.open_to),callback:function ($$v) {_vm.$set(interval, "open_to", $$v)},expression:"interval.open_to"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-icon ",attrs:{"disabled":order.is_always_open},on:{"click":function($event){$event.preventDefault();_vm.deleteIntervals(intervalKey, dayIdx, orderIdx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])],1)]})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn add",attrs:{"disabled":order.is_always_open,"title":_vm.$t('general.add')  + ' moreIntervals'},on:{"click":function($event){$event.preventDefault();_vm.addMoreIntervals(dayIdx, orderIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                  "+_vm._s(_vm.$t('general.add'))+"\n                                ")])])])})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('hr')]),_vm._v(" "),(order.type != 'self_ordering')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"card",staticStyle:{"box-shadow":"none","border":"1px solid #dcdfe6"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"prod-tabs",attrs:{"direction":"horizontal","type":"tabs"}},[_c('div',{staticClass:"col-md-12 display-flex align-items-center justify-content-space-between"},[_c('p',[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxTitle')))]),_vm._v(" "),_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add')  + ' ' + _vm.$t('catalogProdOpt.single')},on:{"click":function($event){$event.preventDefault();_vm.addMethodInfo(orderIdx)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                          "+_vm._s(_vm.$t('general.add'))+"\n                                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-lf-0 pad-rg-0"},[_c('hr',{staticClass:"sm"})]),_vm._v(" "),_c('div',{staticClass:"text-left",attrs:{"title":_vm.$t('catalogProdOpt.plural')}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(!order.method_info || (order.method_info && order.method_info.length == 0))?_c('p',{},[_vm._v("No options added yet.")]):_vm._e(),_vm._v(" "),_c('el-collapse',{ref:"elColl",refInFor:true,attrs:{"accordion":""},model:{value:(_vm.methodInfoIndex),callback:function ($$v) {_vm.methodInfoIndex=$$v},expression:"methodInfoIndex"}},[_vm._l((order.method_info),function(option,idxO){return [_c('div',{staticClass:"align"},[_c('el-collapse-item',{staticClass:"customItem",attrs:{"title":option.title === '' ? 'Name' : option.title,"name":idxO}},[_c('div',{staticClass:"clearfix"},[_c('hr',{staticClass:"no-margin mar-bt-15"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(option.title),expression:"option.title"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogProd.name')},domProps:{"value":(option.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(option, "title", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                                                              "+_vm._s(_vm.getError('name'))+"\n                                                              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxRadioCheck')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(option.type),expression:"option.type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(option, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"check"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxCheck')))]),_vm._v(" "),_c('option',{attrs:{"value":"radio"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.infoBoxRadio')))])])])])]),_vm._v(" "),_c('table',{staticClass:"table no-margin"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"200px"}},[_vm._v(_vm._s(_vm.$t('catalogProd.optVal')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('general.delete')))])])]),_vm._v(" "),_c('tbody',_vm._l((option.options),function(value,idx){return _c('tr',[_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.title),expression:"value.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(value.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "title", $event.target.value)}}})])])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-simple btn-icon ",on:{"click":function($event){$event.preventDefault();_vm.deleteMethodInfoOptionValue(orderIdx, idxO, idx)}}},[_c('i',{staticClass:"ti-close text-danger",attrs:{"title":_vm.$t('general.delete')}})])])])}))]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn add mar-bt-5",on:{"click":function($event){$event.preventDefault();_vm.addMethodInfoOptionValue(orderIdx, idxO)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                                                      "+_vm._s(_vm.$t('general.add'))+"\n                                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"closeBtn"},[_c('button',{staticClass:"btn btn-danger pull-left btn-icon mar-15",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteMethodInfo(orderIdx, idxO)}}},[_c('i',{staticClass:"ti-close"})])])],1)]})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 pad-to-15 pad-bt-10"})])])])])])])])]):_vm._e()]],2)])]:_vm._e()]})],2)],1)])])]),_vm._v(" "),_c('vmodal',{attrs:{"name":"copyDeliveryRangesModal","height":"600","width":"900"}},[_c('div',{staticClass:"card copy-delivery-ranges-modal"},[_c('div',{staticClass:"card-content"},[_c('h4',[_vm._v(_vm._s(_vm.$t('settingsOrdering.copyRangesFromLocation')))]),_vm._v(" "),_c('div',{staticClass:"copy-delivery-ranges-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.location')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.copyDeliveryRangesLocationToken),expression:"copyDeliveryRangesLocationToken"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.copyDeliveryRangesLocationToken=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.handleCopyDeliveryRangesLocationChange]}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.selectLocation')))]),_vm._v(" "),_vm._l((_vm.copyDeliveryRangesLocations),function(loc){return _c('option',{key:'copy-ranges-loc-' + (loc.token || loc.id),domProps:{"value":loc.token}},[_vm._v("\n                "+_vm._s(loc.name || loc.label || loc.token)+"\n              ")])})],2)]),_vm._v(" "),(_vm.copyDeliveryRangesLoading)?_c('div',{staticClass:"form-group"},[_c('p',[_vm._v(_vm._s(_vm.$t('general.loading')))])]):_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsOrdering.ranges')))]),_vm._v(" "),(!_vm.copyDeliveryRangesFetched || !_vm.copyDeliveryRangesFetched.length)?_c('div',{staticClass:"text-muted"},[_vm._v("\n              "+_vm._s(_vm.copyDeliveryRangesLocationToken ? _vm.$t('general.no_data') : _vm.$t('settingsOrdering.selectLocationToLoadRanges'))+"\n            ")]):_c('div',{staticClass:"copy-ranges-list"},_vm._l((_vm.copyDeliveryRangesFetched),function(z,idx){return _c('div',{key:'copy-range-zone-' + idx,staticClass:"copy-range-item"},[_c('strong',[_vm._v(_vm._s(z.name || _vm.$t('settingsOrdering.newZone')))])])}))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer copy-delivery-ranges-footer"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){$event.preventDefault();return _vm.closeCopyDeliveryRangesModal($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('general.cancel'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success save",attrs:{"disabled":_vm.copyDeliveryRangesLoading || !_vm.copyDeliveryRangesFetched || !_vm.copyDeliveryRangesFetched.length},on:{"click":function($event){$event.preventDefault();return _vm.confirmCopyDeliveryRanges($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.copy'))+"\n          ")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tpoi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationGroupsAdd_vue__ = __webpack_require__("86lR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_922afd8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationGroupsAdd_vue__ = __webpack_require__("D0LU");
function injectStyle (ssrContext) {
  __webpack_require__("zJbz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationGroupsAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_922afd8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationGroupsAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ttQ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't8'
});

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tw0q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      searchProdResults: [],
      selectedVatNumber: null,
      selectedProduct: null,
      loadingProducts: false,
      tableData: [],
      searchDate: false,
      filter: {
        series: ''
      },
      selectedGestiune: null,
      selectedLocation: null
    };
  },

  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id;
      });
      return result;
    }
  },
  watch: {
    searchDate: function searchDate(newGestiune) {
      this.searchTerm = null;
      this.tableData = [];
      if (this.selectedLocation && this.selectedGestiune && this.selectedProduct) {
        this.getData();
      }
    },
    selectedLocation: function selectedLocation(newLocation) {
      this.selectedGestiune = null;
      this.tableData = [];
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code;
    },
    selectedGestiune: function selectedGestiune(newGestiune) {
      this.selectedProduct = null;
      this.searchProdResults = [];
      this.tableData = [];
    },
    groupedLocations: function groupedLocations(newVal) {
      this.firstLoad();
    },
    gestiuneOptions: function gestiuneOptions(newVal) {
      this.firstLoad();
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    this.firstLoad();
  },

  methods: {
    firstLoad: function firstLoad() {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0];
      }
    },
    formatDate: function formatDate(row, column, cellValue) {
      if (!cellValue) return '';
      return new Date(cellValue).toLocaleDateString();
    },
    getData: function getData() {
      var _this2 = this;

      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var externalCompanyId, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                externalCompanyId = _this2.companyID;


                clearTimeout(_this2.loadingTimeout);
                _this2.loadingTimeout = setTimeout(function () {
                  _this2.loading = true;
                }, 200);
                _this2.tableData = [];

                if (externalCompanyId) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                if (_this2.selectedGestiune) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return');

              case 8:
                if (_this2.selectedProduct) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return');

              case 10:
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/stock_history?externalCompanyId=' + externalCompanyId;

                if (date) {
                  url += '&date=' + date;
                }
                if (_this2.selectedGestiune) {
                  url += '&gestiune=' + _this2.selectedGestiune;
                }
                if (_this2.selectedProduct) {
                  url += '&product_id=' + _this2.selectedProduct;
                }
                if (_this2.selectedLocation) {
                  url += '&externalLocationId=' + _this2.selectedLocation.true_id;
                }
                if (_this2.searchDate && _this2.searchDate[0] && _this2.searchDate[0]) {
                  url += '&startDate=' + _this2.searchDate[0];
                  url += '&endDate=' + _this2.searchDate[1];
                }

                _context.prev = 16;
                _context.next = 19;
                return fetch(url);

              case 19:
                response = _context.sent;
                _context.next = 22;
                return response.json();

              case 22:
                data = _context.sent;


                clearTimeout(_this2.loadingTimeout);
                _this2.loading = false;

                if (Array.isArray(data.history)) {
                  _this2.tableData = data.history;
                } else {
                  console.error('Invalid data format:', data);
                }
                _context.next = 31;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context['catch'](16);

                console.error('Error fetching invoices:', _context.t0);

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[16, 28]]);
      }))();
    },
    handleProductSelect: function handleProductSelect(product) {
      this.getData();
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!searchTerm || searchTerm.length < 2)) {
                  _context2.next = 3;
                  break;
                }

                _this3.searchProdResults = [];
                return _context2.abrupt('return');

              case 3:

                _this3.loadingProducts = true;

                _context2.prev = 4;
                _context2.next = 7;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/products?vatNumber=' + _this3.selectedVatNumber + '&name=' + encodeURIComponent(searchTerm) + '&externalCompanyId=' + _this3.companyID);

              case 7:
                response = _context2.sent;
                _context2.next = 10;
                return response.json();

              case 10:
                data = _context2.sent;


                if (Array.isArray(data.products)) {
                  _this3.searchProdResults = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.products));
                } else {
                  _this3.searchProdResults = [];
                }
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](4);

                console.error('Error fetching products:', _context2.t0);
                _this3.searchProdResults = [];

              case 18:
                _context2.prev = 18;

                _this3.loadingProducts = false;
                return _context2.finish(18);

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[4, 14, 18, 21]]);
      }))();
    }
  }
});

/***/ }),

/***/ "u0pN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.id)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();return _vm.handleDelete($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15 mar-bt-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":"ID"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","data-vv-as":"name","placeholder":_vm.$t('kds.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('name'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v("Offline")]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},on:{"input":_vm.limitToOne},model:{value:(_vm.model.is_offline),callback:function ($$v) {_vm.$set(_vm.model, "is_offline", $$v)},expression:"model.is_offline"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.location')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.locations,"value":"id","label":"name","placeholder":_vm.model.locations ? _vm.$t('kds.location') : 'All'},on:{"input":_vm.limitToOne},model:{value:(_vm.model.locations),callback:function ($$v) {_vm.$set(_vm.model, "locations", $$v)},expression:"model.locations"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.section')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%","height":"auto","min-height":"40px"},attrs:{"multiple":"","collapse-tags":"","value-key":"id","placeholder":_vm.model.sections && _vm.model.sections.length ? _vm.$t('kds.section') : 'All'},model:{value:(_vm.model.sections),callback:function ($$v) {_vm.$set(_vm.model, "sections", $$v)},expression:"model.sections"}},_vm._l((_vm.sectionOptions),function(section){return _c('el-option',{key:section.id,attrs:{"label":section.name,"value":section}})}))],1),_vm._v(" "),(_vm.model.id)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.loginCode')))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","name":"token","disabled":"true","placeholder":_vm.$t('settingTable.loginCode')},domProps:{"value":_vm.model.company_id + '.' + _vm.model.id}})]):_vm._e(),_vm._v(" "),(!_vm.model.is_offline)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("URL")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.url),expression:"model.url"}],staticClass:"form-control",attrs:{"type":"text","disabled":"","placeholder":"Url"},domProps:{"value":(_vm.model.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "url", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.model.is_offline)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("IP Server")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.server_ip),expression:"model.server_ip"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Ip"},domProps:{"value":(_vm.model.server_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "server_ip", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group mar-to-15 label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.yumm_integration_external_ip')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.yumm_integration_external_ip),expression:"model.yumm_integration_external_ip"}],staticClass:"form-control",staticStyle:{"max-width":"280px"},attrs:{"type":"text","placeholder":"Ip"},domProps:{"value":(_vm.model.yumm_integration_external_ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "yumm_integration_external_ip", $event.target.value)}}})])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u29E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('gestiune-transfer-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onPageSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u2GW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 480.4 231.5"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 480.4 231.5","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t7_1_","y":"69.7","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t7_3_","d":"M0,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H9C4,161.8,0,157.8,0,152.8z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,161.8V69.7h92.2v92.2H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t7_5_","x":"335","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t7_7_","d":"M335,83.2V9c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H344C339,92.2,335,88.1,335,83.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M335,92.2V0h92.2v92.2H335z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t7_9_","x":"199.9","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t7_11_","d":"M199.9,83.2V9c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2C203.9,92.2,199.9,88.1,199.9,83.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M199.9,92.2V0h92.2v92.2H199.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t7_13_","x":"73.2","y":"69.7","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t7_15_","d":"M73.2,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H82.2C77.2,161.8,73.2,157.8,73.2,152.8\n          z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M73.2,161.8V69.7h92.2v92.2H73.2z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t7_17_","x":"69.7","y":"0","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t7_19_","d":"M78.7,0h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9V9C69.7,4,73.7,0,78.7,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M69.7,0h92.2v92.2H69.7V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t7_21_","x":"69.7","y":"139.4","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t7_23_","d":"M78.7,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9v-74.2\n          C69.7,143.4,73.7,139.4,78.7,139.4z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st2",attrs:{"d":"M69.7,139.4h92.2v92.2H69.7V139.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t7_25_","x":"199.9","y":"139.4","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st13"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t7_27_","d":"M208.9,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2c-5,0-9-4-9-9v-74.2\n          C199.9,143.4,203.9,139.4,208.9,139.4z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('path',{staticClass:"st2",attrs:{"d":"M199.9,139.4h92.2v92.2h-92.2V139.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t7_29_","x":"335","y":"139.4","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_30_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_29_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t7_31_","d":"M335,222.5v-74.2c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H344C339,231.5,335,227.5,335,222.5z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_32_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_31_"}})]),_vm._v(" "),_c('g',{staticClass:"st16"},[_c('path',{staticClass:"st2",attrs:{"d":"M335,231.5v-92.2h92.2v92.2H335z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t7_33_","x":"16.3","y":"16.3","width":"464.1","height":"199"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_34_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_33_"}})]),_vm._v(" "),_c('g',{staticClass:"st17"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"t7_35_","d":"M39.3,16.3h417.9c6.1,0,11.9,2.4,16.3,6.7c4.3,4.3,6.7,10.2,6.7,16.3v153c0,6.1-2.4,11.9-6.7,16.3\n          c-4.3,4.3-10.2,6.7-16.3,6.7H39.3c-6.1,0-12-2.4-16.3-6.7s-6.7-10.2-6.7-16.3v-153c0-6.1,2.4-11.9,6.7-16.3S33.2,16.3,39.3,16.3\n          z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_36_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_35_"}})]),_vm._v(" "),_c('g',{staticClass:"st18"},[_c('path',{staticClass:"st19",attrs:{"d":"M16.3,16.3h464.1v199H16.3V16.3z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"t7_37_","x":"172.5","y":"40.1","width":"151.4","height":"151.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_38_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_37_"}})]),_vm._v(" "),_c('g',{staticClass:"st20"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"t7_39_","cx":"248.2","cy":"115.8","r":"75.7"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"t7_40_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#t7_39_"}})]),_vm._v(" "),_c('g',{staticClass:"st21"},[_c('path',{staticClass:"st2",attrs:{"d":"M172.5,40.1h151.4v151.4H172.5V40.1z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u5IJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u5js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFilters_vue__ = __webpack_require__("yzyr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c369c2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFilters_vue__ = __webpack_require__("bbzh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFilters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c369c2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFilters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u6us":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u8ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u9Do":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementOutputsTabs_vue__ = __webpack_require__("omsB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a7c6890_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementOutputsTabs_vue__ = __webpack_require__("UFww");
function injectStyle (ssrContext) {
  __webpack_require__("JrLq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a7c6890"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementOutputsTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a7c6890_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementOutputsTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean, Number],
    disabled: [Boolean, String],
    inline: Boolean,
    required: Boolean,
    name: String
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked === 1 || this.checked === true;
      },
      set: function set(check) {
        this.$emit('input', check ? 1 : 0);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    },
    isRequired: function isRequired() {
      if (this.required) {
        return 'required';
      } else {
        return '';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "uFAt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("1V4J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58493189_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("zizS");
function injectStyle (ssrContext) {
  __webpack_require__("z7He")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58493189_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uFkR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"left-buttons",staticStyle:{"display":"flex","align-items":"center","gap":"20px","margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selectează")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n              "+_vm._s(loc.name)+"\n            ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"1","display":"flex","flex-direction":"column"}},[_c('label',[_vm._v("Date și oră")]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"disabled":_vm.loading},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"right-buttons",staticStyle:{"display":"flex","gap":"10px"}},[_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":'Export XML'},on:{"click":function($event){_vm.exportSales('XML')}}},[_vm._v("\n          "+_vm._s(_vm.$t('gestiune.download_xml'))+"\n          "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":'Export XLS'},on:{"click":function($event){_vm.exportSales('XLS')}}},[_vm._v("\n          "+_vm._s(_vm.$t('general.download_xls'))+"\n          "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])])]),_vm._v(" "),_c('div',{staticClass:"export-info-text"},[_vm._v("\n    "+_vm._s(_vm.$t('gestiune.exportAccountingSales.infoText'))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uIho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-lg-12 "},[_c('div',{staticClass:"search-bar"},[_c('div',{staticClass:"col-sm-12 no-padding"},[_c('div',{staticClass:"pull-left"},[_c('el-input',{staticClass:"icon-search",attrs:{"placeholder":_vm.$t('reports.search')},on:{"input":function($event){_vm.onInput()}},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn add ",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('marketingAutomation.single'),"to":{ path: '/marketing/automation/add'}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"automation-table width-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"pagination-def":_vm.paginationDef,"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"min-width":240,"label":_vm.$t('marketingAutomation.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"automation-cell-name"},[_c('span',{staticClass:"automation-type-icon"},[_c('i',{class:_vm.typeIcon(props.row.type)})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"automation-name"},[_vm._v(_vm._s(props.row.name))]),_vm._v(" "),_c('div',{staticClass:"automation-sub"},[_vm._v(_vm._s(_vm.typeLabel(props.row.type)))])])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":200,"label":_vm.$t('marketingAutomation.period')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"automation-state-row"},[_c('span',{staticClass:"automation-state",class:'automation-state--' + props.row.state},[_c('span',{staticClass:"automation-state__dot"}),_vm._v(_vm._s(_vm.$t('marketingAutomation.state_' + props.row.state))+"\n                ")]),_vm._v(" "),(_vm.periodHint(props.row))?_c('span',{staticClass:"automation-sub"},[_vm._v(_vm._s(_vm.periodHint(props.row)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"automation-period"},[_c('i',{staticClass:"fa fa-calendar-o"}),_vm._v("\n                "+_vm._s(_vm.formatDay(props.row.date_from))+" – "+_vm._s(_vm.formatDay(props.row.date_to))+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":230,"label":_vm.$t('marketingAutomation.coupons')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"automation-badges"},[_vm._l(((props.row.coupons || []).slice(0, 2)),function(coupon){return _c('span',{key:coupon.id,staticClass:"automation-badge",class:{ 'automation-badge--off': !coupon.active },attrs:{"title":coupon.active ? coupon.name : coupon.name + ' (' + _vm.$t('marketingAutomation.couponInactive') + ')'}},[_c('i',{staticClass:"fa fa-ticket"}),_c('span',{staticClass:"automation-badge__text"},[_vm._v(_vm._s(coupon.name))])])}),_vm._v(" "),((props.row.coupons || []).length > 2)?_c('span',{staticClass:"automation-badge automation-badge--more",attrs:{"title":props.row.coupons.map(function (coupon) { return coupon.name; }).join(', ')}},[_vm._v("\n                  +"+_vm._s(props.row.coupons.length - 2)+"\n                ")]):_vm._e()],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":190,"label":_vm.$t('marketingAutomation.beneficiaries')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.type === 3)?_c('div',{staticClass:"automation-benef-counts"},[_c('span',{attrs:{"title":_vm.$t('marketingAutomation.statusAllSent')}},[_c('i',{staticClass:"fa fa-paper-plane"}),_vm._v(" "+_vm._s((props.row.grants && props.row.grants.all) || 0))]),_vm._v(" "),_c('span',{attrs:{"title":_vm.$t('marketingAutomation.cartStatusUsed')}},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "+_vm._s((props.row.grants && props.row.grants.used) || 0))]),_vm._v(" "),_c('span',{attrs:{"title":_vm.$t('marketingAutomation.status_converted')}},[_c('i',{staticClass:"fa fa-shopping-bag"}),_vm._v(" "+_vm._s((props.row.grants && props.row.grants.converted) || 0))])]):_c('div',{staticClass:"automation-benef-counts"},[_c('span',{attrs:{"title":_vm.$t('marketingAutomation.status_granted')}},[_c('i',{staticClass:"fa fa-gift"}),_vm._v(" "+_vm._s((props.row.grants && props.row.grants.granted) || 0))]),_vm._v(" "),_c('span',{attrs:{"title":_vm.$t('marketingAutomation.status_used')}},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "+_vm._s((props.row.grants && props.row.grants.used) || 0))]),_vm._v(" "),_c('span',{attrs:{"title":_vm.$t('marketingAutomation.status_expired')}},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" "+_vm._s((props.row.grants && props.row.grants.expired) || 0))])]),_vm._v(" "),_c('a',{staticClass:"automation-benef-link",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.openBeneficiaries(props.row)}}},[_vm._v("\n                "+_vm._s(_vm.$t('marketingAutomation.viewBeneficiaries'))+" "),_c('i',{staticClass:"fa fa-angle-right"})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":100,"class-name":"centered-cell","align":"center","header-align":"center","label":_vm.$t('marketingAutomation.status')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('p-switch',{attrs:{"type":"success"},on:{"input":function($event){_vm.handleActive(props.row)}},model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":90,"class-name":"centered-cell","align":"center","header-align":"center","label":_vm.$t('marketingCampaigns.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-icon-small btn-danger",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){$event.stopPropagation();_vm.handleDelete(props.row)}}},[_c('i',{staticClass:"fa fa-trash-o"})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":160,"class-name":"centered-cell","align":"center","header-align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n              ")])]}}])})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uJR6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp",class:'pp--' + _vm.variant},[(_vm.variant === 'wolt')?[_c('div',{staticClass:"pp__hero"},[(_vm.product.image_url)?_c('img',{attrs:{"src":_vm.product.image_url,"alt":_vm.product.name}}):_c('div',{staticClass:"pp__hero-placeholder"}),_vm._v(" "),_c('button',{staticClass:"pp__x pp__x--red",attrs:{"type":"button","aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"pp__scroll"},[_c('h3',{staticClass:"pp__title"},[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('div',{staticClass:"pp__price-row"},[_c('span',{staticClass:"pp__price-badge"},[_vm._v(_vm._s(_vm.formatPrice(_vm.product.price)))])]),_vm._v(" "),(_vm.product.description)?_c('p',{staticClass:"pp__desc"},[_vm._v(_vm._s(_vm.product.description))]):_vm._e(),_vm._v(" "),_vm._l(((_vm.product.options || [])),function(option){return _c('div',{key:option.id,staticClass:"pp__option"},[_c('div',{staticClass:"pp__option-head"},[_c('strong',[_vm._v(_vm._s(option.name))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t('platformMenuImport.groupMin'))+": "+_vm._s(option.min)+" · "+_vm._s(_vm.$t('platformMenuImport.groupMax'))+": "+_vm._s(option.max))])]),_vm._v(" "),_vm._l(((option.values || [])),function(value){return _c('label',{key:value.id,staticClass:"pp__value",class:{ 'is-disabled': value.available === false }},[(option.counter)?_c('input',{attrs:{"type":"number","min":"0","max":value.max_quantity || option.max,"disabled":value.available === false || !_vm.product.available},domProps:{"value":_vm.counterQty(option, value.id)},on:{"input":function($event){_vm.setCounter(option, value, $event.target.value)}}}):(option.multiple)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selections[option.id]),expression:"selections[option.id]"}],attrs:{"type":"checkbox","name":'wolt-opt-' + option.id,"disabled":value.available === false || !_vm.product.available},domProps:{"value":value.id,"checked":Array.isArray(_vm.selections[option.id])?_vm._i(_vm.selections[option.id],value.id)>-1:(_vm.selections[option.id])},on:{"change":function($event){var $$a=_vm.selections[option.id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=value.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selections, option.id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selections, option.id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selections, option.id, $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selections[option.id]),expression:"selections[option.id]"}],attrs:{"type":"radio","name":'wolt-opt-' + option.id,"disabled":value.available === false || !_vm.product.available},domProps:{"value":value.id,"checked":_vm._q(_vm.selections[option.id],value.id)},on:{"change":function($event){_vm.$set(_vm.selections, option.id, value.id)}}}),_vm._v(" "),_c('span',{staticClass:"pp__value-name"},[_vm._v(_vm._s(value.name)),(value.max_quantity != null)?_c('small',[_vm._v(" · "+_vm._s(_vm.$t('platformMenuImport.eachMax'))+": "+_vm._s(value.max_quantity))]):_vm._e(),(value.deposit)?_c('small',[_vm._v(" · "+_vm._s(value.deposit.name || 'SGR')+": "+_vm._s(_vm.formatPrice(value.deposit.price)))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"pp__value-price"},[_vm._v("+"+_vm._s(_vm.formatPrice(value.price || 0)))])])})],2)})],2)]:(_vm.variant === 'bolt')?[_c('div',{staticClass:"pp__hero"},[(_vm.product.image_url)?_c('img',{attrs:{"src":_vm.product.image_url,"alt":_vm.product.name}}):_c('div',{staticClass:"pp__hero-placeholder"}),_vm._v(" "),_c('button',{staticClass:"pp__x pp__x--red",attrs:{"type":"button","aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"pp__scroll"},[_c('h3',{staticClass:"pp__title"},[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('p',{staticClass:"pp__price-plain"},[_vm._v(_vm._s(_vm.formatPrice(_vm.product.price)))]),_vm._v(" "),(_vm.product.description)?_c('p',{staticClass:"pp__desc"},[_vm._v(_vm._s(_vm.product.description))]):_vm._e(),_vm._v(" "),_vm._l(((_vm.product.options || [])),function(option){return _c('div',{key:option.id,staticClass:"pp__option"},[_c('div',{staticClass:"pp__option-head"},[_c('strong',[_vm._v(_vm._s(option.name))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t('platformMenuImport.groupMin'))+": "+_vm._s(option.min)+" · "+_vm._s(_vm.$t('platformMenuImport.groupMax'))+": "+_vm._s(option.max))]),_vm._v(" "),(option.counter)?_c('span',{staticClass:"pp__badge pp__badge--counter"},[_vm._v("\n            "+_vm._s(_vm.$t('gestiune.integrationsMenuPreviewOptionRange', { min: option.min || 0, max: option.max || 0 }))+"\n          ")]):(option.min >= 1)?_c('span',{staticClass:"pp__badge pp__badge--required"},[_vm._v("\n            "+_vm._s(_vm.$t('gestiune.integrationsMenuPreviewRequiredShort'))+"\n          ")]):_vm._e()]),_vm._v(" "),(option.counter)?_vm._l(((option.values || [])),function(value){return _c('div',{key:value.id,staticClass:"pp__value pp__value--counter",class:{ 'is-disabled': value.available === false }},[_c('span',{staticClass:"pp__value-name"},[_vm._v(_vm._s(value.name)),(value.max_quantity != null)?_c('small',[_vm._v(" · "+_vm._s(_vm.$t('platformMenuImport.eachMax'))+": "+_vm._s(value.max_quantity))]):_vm._e(),(value.deposit)?_c('small',[_vm._v(" · "+_vm._s(value.deposit.name || 'SGR')+": "+_vm._s(_vm.formatPrice(value.deposit.price)))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"pp__value-price"},[_vm._v("+"+_vm._s(_vm.formatPrice(value.price || 0)))]),_vm._v(" "),_c('div',{staticClass:"pp__qty pp__qty--option"},[_c('button',{attrs:{"type":"button","disabled":value.available === false || !_vm.product.available || _vm.counterQty(option, value.id) <= 0},on:{"click":function($event){_vm.adjustCounter(option, value.id, -1)}}},[_vm._v("−")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.counterQty(option, value.id)))]),_vm._v(" "),_c('button',{attrs:{"type":"button","disabled":value.available === false || !_vm.product.available || !_vm.canIncreaseCounter(option, value.id)},on:{"click":function($event){_vm.adjustCounter(option, value.id, 1)}}},[_vm._v("+")])])])}):_vm._l(((option.values || [])),function(value){return _c('label',{key:value.id,staticClass:"pp__value",class:{ 'is-disabled': value.available === false }},[(option.multiple)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selections[option.id]),expression:"selections[option.id]"}],attrs:{"type":"checkbox","name":'bolt-opt-' + option.id,"disabled":value.available === false || !_vm.product.available},domProps:{"value":value.id,"checked":Array.isArray(_vm.selections[option.id])?_vm._i(_vm.selections[option.id],value.id)>-1:(_vm.selections[option.id])},on:{"change":function($event){var $$a=_vm.selections[option.id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=value.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selections, option.id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selections, option.id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selections, option.id, $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selections[option.id]),expression:"selections[option.id]"}],attrs:{"type":"radio","name":'bolt-opt-' + option.id,"disabled":value.available === false || !_vm.product.available},domProps:{"value":value.id,"checked":_vm._q(_vm.selections[option.id],value.id)},on:{"change":function($event){_vm.$set(_vm.selections, option.id, value.id)}}}),_vm._v(" "),_c('span',{staticClass:"pp__value-name"},[_vm._v(_vm._s(value.name)),(value.max_quantity != null)?_c('small',[_vm._v(" · "+_vm._s(_vm.$t('platformMenuImport.eachMax'))+": "+_vm._s(value.max_quantity))]):_vm._e(),(value.deposit)?_c('small',[_vm._v(" · "+_vm._s(value.deposit.name || 'SGR')+": "+_vm._s(_vm.formatPrice(value.deposit.price)))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"pp__value-price"},[_vm._v("+"+_vm._s(_vm.formatPrice(value.price || 0)))])])})],2)})],2)]:[_c('button',{staticClass:"pp__x pp__x--red pp__x--glovo",attrs:{"type":"button","aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"pp__glovo"},[_c('div',{staticClass:"pp__glovo-left"},[_vm._l(((_vm.product.options || [])),function(option){return _c('div',{key:option.id,staticClass:"pp__glovo-option"},[_c('div',{staticClass:"pp__glovo-option-head"},[_c('div',[_c('strong',[_vm._v(_vm._s(option.name))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t('platformMenuImport.groupMin'))+": "+_vm._s(option.min)+" · "+_vm._s(_vm.$t('platformMenuImport.groupMax'))+": "+_vm._s(option.max))]),_vm._v(" "),_c('div',{staticClass:"pp__glovo-hint"},[_vm._v(_vm._s(_vm.optionHint(option)))])]),_vm._v(" "),(option.min >= 1)?_c('span',{staticClass:"pp__badge pp__badge--glovo"},[_vm._v("\n              "+_vm._s(_vm.$t('gestiune.integrationsMenuPreviewOptionRequired'))+"\n            ")]):_vm._e()]),_vm._v(" "),_vm._l(((option.values || [])),function(value){return _c('label',{key:value.id,staticClass:"pp__glovo-value",class:{
              'is-disabled': value.available === false,
              'is-selected': _vm.isSelected(option, value.id)
            }},[_c('span',{staticClass:"pp__value-name"},[_vm._v(_vm._s(value.name)),(value.max_quantity != null)?_c('small',[_vm._v(" · "+_vm._s(_vm.$t('platformMenuImport.eachMax'))+": "+_vm._s(value.max_quantity))]):_vm._e(),(value.deposit)?_c('small',[_vm._v(" · "+_vm._s(value.deposit.name || 'SGR')+": "+_vm._s(_vm.formatPrice(value.deposit.price)))]):_vm._e()]),_vm._v(" "),(value.price)?_c('span',{staticClass:"pp__value-price"},[_vm._v("+"+_vm._s(_vm.formatPrice(value.price)))]):_vm._e(),_vm._v(" "),(option.multiple)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selections[option.id]),expression:"selections[option.id]"}],attrs:{"type":"checkbox","name":'glovo-opt-' + option.id,"disabled":value.available === false || !_vm.product.available},domProps:{"value":value.id,"checked":Array.isArray(_vm.selections[option.id])?_vm._i(_vm.selections[option.id],value.id)>-1:(_vm.selections[option.id])},on:{"change":function($event){var $$a=_vm.selections[option.id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=value.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selections, option.id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selections, option.id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selections, option.id, $$c)}}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selections[option.id]),expression:"selections[option.id]"}],attrs:{"type":"radio","name":'glovo-opt-' + option.id,"disabled":value.available === false || !_vm.product.available},domProps:{"value":value.id,"checked":_vm._q(_vm.selections[option.id],value.id)},on:{"change":function($event){_vm.$set(_vm.selections, option.id, value.id)}}})])})],2)}),_vm._v(" "),(!(_vm.product.options || []).length)?_c('p',{staticClass:"pp__glovo-empty"},[_vm._v("\n          "+_vm._s(_vm.product.description || '—')+"\n        ")]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"pp__glovo-right"},[_c('div',{staticClass:"pp__glovo-media"},[(_vm.product.image_url)?_c('img',{attrs:{"src":_vm.product.image_url,"alt":_vm.product.name}}):_c('div',{staticClass:"pp__hero-placeholder"})]),_vm._v(" "),_c('h3',{staticClass:"pp__title"},[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('p',{staticClass:"pp__price-plain"},[_vm._v(_vm._s(_vm.formatPrice(_vm.product.price)))]),_vm._v(" "),(_vm.product.description)?_c('p',{staticClass:"pp__desc"},[_vm._v(_vm._s(_vm.product.description))]):_vm._e()])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uK/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"orderPosClientScreen"},on:{"click":_vm.goFullScreen}},[(_vm.company_id == 201)?[(_vm.loading)?_c('div',{staticClass:"backgroungImg",staticStyle:{"background-image":"url('static/img/background/posBg_201.png')"}}):_vm._e()]:[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])])],_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"row orderView"},[_c('div',{staticClass:" col-lg-12 col-md-12 pad-to-15"},[_c('table',{staticClass:"table orders-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('orders.name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.qty')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.unit')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('orders.total')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.order.people),function(customer){return [(_vm.order.order_type=='GROUP')?_c('tr',{staticClass:"active"},[_c('td',{attrs:{"colspan":"4"}},[_vm._v(_vm._s(_vm.$t('customers.single'))+": "+_vm._s(customer.customer_name))])]):_vm._e(),_vm._v(" "),_vm._l((customer.products),function(prod){return _c('tr',[_c('td',[_vm._v("\n                "+_vm._s(prod.name)+"\n                "),(prod.extra)?_c('p',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(prod.extra))]):_vm._e(),_vm._v(" "),(prod.additional_info != '')?_c('div',{staticClass:"pad-to-10"},[_c('span',[_vm._v(_vm._s(_vm.$t('orders.custComments'))+": "),_c('i',{staticClass:"text-danger"},[_vm._v(_vm._s(prod.additional_info))])])]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(prod.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatMoneyAmount(prod.price_unit, _vm.currency)))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.formatMoneyAmount(parseFloat(prod.quantity) * parseFloat(prod.price), _vm.currency)))])])])})]})],2)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"}),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('table',{staticClass:"table no-border totals-table"},[_c('tbody',[_vm._l((_vm.order.order_totals),function(label){return [((label != 'totals_grandtotal' && label != 'totals_shipping'))?[(label.value > 0)?_c('tr',[_c('td',[(label.name == 'totals_extras')?_c('span',[_vm._v(_vm._s(_vm.$t('orders.' + label.name)))]):_c('span',[_vm._v(_vm._s(label.name))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.formatMoneyAmount(label.value, _vm.currency, true))+"\n                    ")])]):_vm._e()]:_vm._e()]}),_vm._v(" "),_c('tr',[_c('td',[_c('span',[_vm._v(_vm._s(_vm.$t('orders.totals_grandtotal')))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(_vm.formatMoneyAmount(_vm.order.total_order_price, _vm.currency, true))+"\n                ")])])],2)])])])])]):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.bacsisView && _vm.order.use_tips)?_c('div',{staticClass:"bacsisView"},[_c('div',{staticClass:"tipsBox"},[_c('div',{staticClass:"tipsInputsTitle"},[_c('span',[_vm._v(_vm._s(_vm.$t('addOrder.addTip')))])]),_vm._v(" "),_c('div',{staticClass:"tipsBoxCollpase"},[_c('div',{staticClass:"tipsInputs"},[_c('div',{staticClass:"col col-zero",on:{"click":function($event){_vm.addTip(0)}}},[_c('img',{attrs:{"src":"/static/img/icons/sad.png"}}),_vm._v(" "),_c('span',[_vm._v(" 0%")])]),_vm._v(" "),_c('div',{staticClass:"col col-one",on:{"click":function($event){_vm.addTip(5)}}},[_c('img',{attrs:{"src":"/static/img/icons/smile.png"}}),_vm._v(" "),_c('span',[_vm._v(" +5%")])]),_vm._v(" "),_c('div',{staticClass:"col col-two",on:{"click":function($event){_vm.addTip(10)}}},[_c('img',{attrs:{"src":"/static/img/icons/star.png"}}),_vm._v(" "),_c('span',[_vm._v(" +10%")])]),_vm._v(" "),_c('div',{staticClass:"col col-three",on:{"click":function($event){_vm.addTip(15)}}},[_c('img',{attrs:{"src":"/static/img/icons/love.png"}}),_vm._v(" "),_c('span',[_vm._v(" +15%")])])])])])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uMna":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uONr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t9_vue__ = __webpack_require__("ttQ9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2b00fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t9_vue__ = __webpack_require__("QyTD");
function injectStyle (ssrContext) {
  __webpack_require__("K/+R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c2b00fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t9_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2b00fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t9_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uQMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar "},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.add'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15",staticStyle:{"margin-left":"10px","margin-right":"10px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticStyle:{"display":"flex","gap":"10px","flex-wrap":"wrap","align-items":"flex-end"}},[_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"ID","size":"small","clearable":""},model:{value:(_vm.filterId),callback:function ($$v) {_vm.filterId=$$v},expression:"filterId"}})],1),_vm._v(" "),(_vm.locations.length)?_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 180px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('orders.location')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select'),"size":"small","multiple":"","collapse-tags":"","clearable":""},model:{value:(_vm.filterLocation),callback:function ($$v) {_vm.filterLocation=$$v},expression:"filterLocation"}},_vm._l((_vm.locations),function(loc){return _c('el-option',{key:loc.true_id,attrs:{"label":loc.name,"value":loc.true_id}})}))],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 150px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.number')))]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":_vm.$t('settingTable.number'),"size":"small","clearable":""},model:{value:(_vm.filterTableName),callback:function ($$v) {_vm.filterTableName=$$v},expression:"filterTableName"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 150px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.type')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select'),"size":"small","clearable":""},model:{value:(_vm.filterType),callback:function ($$v) {_vm.filterType=$$v},expression:"filterType"}},_vm._l((_vm.tableTypes),function(t){return _c('el-option',{key:t,attrs:{"label":t,"value":t}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 150px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.zone')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.select'),"size":"small","clearable":""},model:{value:(_vm.filterZone),callback:function ($$v) {_vm.filterZone=$$v},expression:"filterZone"}},_vm._l((_vm.zones),function(z){return _c('el-option',{key:z.id,attrs:{"label":z.name,"value":z.name}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 200px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.maps')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('general.search'),"size":"small","multiple":"","filterable":"","collapse-tags":"","clearable":""},model:{value:(_vm.filterMaps),callback:function ($$v) {_vm.filterMaps=$$v},expression:"filterMaps"}},_vm._l((_vm.maps),function(m){return _c('el-option',{key:m.id,attrs:{"label":m.name || ('ID ' + m.id),"value":m.id}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 180px","margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('reports.operator')))]),_vm._v(" "),_c('el-select',{ref:"userSelect",staticStyle:{"width":"100%"},attrs:{"value-key":"id","multiple":"","filterable":"","remote":"","collapse-tags":"","reserve-keyword":"","clearable":"","placeholder":_vm.$t('general.search'),"remote-method":_vm.searchUsers,"loading":_vm.loadingUsers,"size":"small"},on:{"change":_vm.clearUserSearch},model:{value:(_vm.filterUser),callback:function ($$v) {_vm.filterUser=$$v},expression:"filterUser"}},_vm._l((_vm.mergedUsers),function(user){return _c('el-option',{key:user.id,attrs:{"label":user.firstname + ' ' + user.lastname,"value":user}})}))],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.applyFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"card mar-to-15",staticStyle:{"width":"calc(70% - 20px)","margin-left":"10px","margin-right":"10px"}},[_c('div',{staticClass:"card-content"},[_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"userList",staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","min-width":"80","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"location_id","label":_vm.$t('orders.location'),"min-width":"250","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(_vm.getLocationName(scope.row.location_id))+"\n            ")]}}])}),_vm._v(" "),_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('settingTable.type'),"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type === 'Kiosk' ? scope.row.kiosk_offline : scope.row.qr_offline)?_c('div',{staticClass:"cell-center",staticStyle:{"color":"green"}},[_vm._v("Offline")]):_c('div',{staticClass:"cell-center",staticStyle:{"color":"red"}},[_vm._v("Online")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":160}},[[_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n              ")])]],2)],2)],1)]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15",staticStyle:{"width":"calc(30% - 20px)","margin-left":"10px","margin-right":"10px"}},[_c('div',{staticClass:"card-content",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{staticClass:"middle",staticStyle:{"height":"100%","width":"100%","text-align":"center"}},[_c('div',{class:(_vm.loading2 ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),(_vm.isKioskView)?_c('div',{staticClass:"kiosk_reload_wrapper",staticStyle:{"width":"100%"}},[_c('button',{staticClass:"btn btn-info mar-bt-20",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.reloadingAll || _vm.allKiosksReloading},on:{"click":_vm.reloadAllKiosks}},[_vm._v("\n              "+_vm._s(_vm.$t('settingTable.reloadAllKiosks'))+"\n            ")]),_vm._v(" "),_vm._l((_vm.tableData),function(kiosk){return _c('div',{key:kiosk.id,staticClass:"kiosk_reload_row",staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between","gap":"10px","padding":"6px 0","border-bottom":"1px solid #eee"}},[_c('span',[_vm._v(_vm._s(kiosk.type)+" "+_vm._s(kiosk.number))]),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-info",attrs:{"disabled":Number(kiosk.reload) === 1},on:{"click":function($event){_vm.reloadKiosk(kiosk)}}},[_vm._v("\n                "+_vm._s(Number(kiosk.reload) === 1 ? _vm.$t('settingTable.reloadPending') : _vm.$t('settingTable.reload'))+"\n              ")])])}),_vm._v(" "),_c('p',{staticClass:"mar-to-15",staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.$t('settingTable.kiosksWillReloadNextOrder')))])],2):[_vm._l((_vm.locationDataForTableManagement),function(location){return [(location && location.table_management)?_c('div',{key:location.id || location.true_id || location.name,staticClass:"location_wrapper"},[_c('p',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(location.name))]),_vm._v(" "),_c('span',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(location.token))]),_vm._v(" "),_c('img',{staticClass:"mar-to-15",attrs:{"src":location.table_management.qr_code,"alt":"qrCode","data-link":location.table_management.qr_link},on:{"click":function($event){_vm.copyToClipboard(location.table_management.qr_link)}}}),_vm._v(" "),_c('a',{staticClass:"btn btn-info btn-icon duplicate-prod mar-to-15 mar-bt-20",attrs:{"href":_vm.apiUrl + '/settings/download?token=' + _vm.token + '&url=' + location.table_management.qr_code + '&name=' + location.table_management.type + ' ' + location.table_management.number + '.png',"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('upload.download')))]),_vm._v(" "),_c('input',{staticClass:"copy_link mar-bt-20",attrs:{"type":"text","disabled":"true"},domProps:{"value":location.table_management.qr_link},on:{"click":function($event){_vm.copyToClipboard(location.table_management.qr_link)}}})]):_vm._e()]})]],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uVnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__("koIN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6b9869a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__("Ceu5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6b9869a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uWep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_legend__ = __webpack_require__("SKZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartist_plugin_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartist_plugin_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__ = __webpack_require__("L7GT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chartist_plugin_tooltips_dist_chartist_plugin_tooltip_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-pie-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Pie' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.chartOptions['plugins'] = [this.$Chartist.plugins.tooltip(), this.$Chartist.plugins.legend()];
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "uXGO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uXu5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArchiveInput_vue__ = __webpack_require__("Dvak");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc8d45a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArchiveInput_vue__ = __webpack_require__("zw+R");
function injectStyle (ssrContext) {
  __webpack_require__("m4Pk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArchiveInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc8d45a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArchiveInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uY8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uZUK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_downloadjs__);









/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: "xls"
    },

    data: {
      type: Array,
      required: false,
      default: null
    },

    fields: {
      type: Object,
      required: false
    },

    exportFields: {
      type: Object,
      required: false
    },

    defaultValue: {
      type: String,
      required: false,
      default: ""
    },

    title: {
      default: null
    },

    footer: {
      default: null
    },

    name: {
      type: String,
      default: "data.xls"
    },
    fetch: {
      type: Function
    },
    meta: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    worksheet: {
      type: String,
      default: "Sheet1"
    },

    beforeGenerate: {
      type: Function
    },

    beforeFinish: {
      type: Function
    }
  },
  computed: {
    idName: function idName() {
      var now = new Date().getTime();
      return "export_" + now;
    },
    downloadFields: function downloadFields() {
      if (this.fields !== undefined) return this.fields;

      if (this.exportFields !== undefined) return this.exportFields;
    }
  },
  methods: {
    generate: function generate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, json;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof _this.beforeGenerate === 'function')) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this.beforeGenerate();

              case 3:
                data = _this.data;

                if (!(typeof _this.fetch === 'function' || !data)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return _this.fetch();

              case 7:
                data = _context.sent;

              case 8:
                if (!(!data || !data.length)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                json = _this.getProcessedJson(data, _this.downloadFields);

                if (!(_this.type === "html")) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name.replace(".xls", ".html"), "text/html"));

              case 15:
                if (!(_this.type === "csv")) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", _this.export(_this.jsonToCSV(json), _this.name.replace(".xls", ".csv"), "application/csv"));

              case 17:
                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name, "application/vnd.ms-excel"));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    export: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(data, filename, mime) {
        var blob;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                blob = this.base64ToBlob(data, mime);

                if (!(typeof this.beforeFinish === 'function')) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.beforeFinish();

              case 4:
                __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(blob, filename, mime);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _export(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return _export;
    }(),
    jsonToXLS: function jsonToXLS(data) {
      var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>br {mso-data-placement: same-cell;}</style></head><body><table>${table}</table></body></html>';
      var xlsData = "<thead>";
      var colspan = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data[0]).length;
      var _self = this;

      if (this.title != null) {
        xlsData += this.parseExtraData(this.title, '<tr><th colspan="' + colspan + '">${data}</th></tr>');
      }

      xlsData += "<tr>";
      for (var key in data[0]) {
        xlsData += "<th>" + key + "</th>";
      }
      xlsData += "</tr>";
      xlsData += "</thead>";

      xlsData += "<tbody>";
      data.map(function (item, index) {
        xlsData += "<tr>";
        for (var _key in item) {
          xlsData += "<td>" + _self.valueReformattedForMultilines(item[_key]) + "</td>";
        }
        xlsData += "</tr>";
      });
      xlsData += "</tbody>";

      if (this.footer != null) {
        xlsData += "<tfoot>";
        xlsData += this.parseExtraData(this.footer, '<tr><td colspan="' + colspan + '">${data}</td></tr>');
        xlsData += "</tfoot>";
      }

      return xlsTemp.replace("${table}", xlsData).replace("${worksheet}", this.worksheet);
    },
    jsonToCSV: function jsonToCSV(data) {
      var csvData = [];

      if (this.title != null) {
        csvData.push(this.parseExtraData(this.title, "${data}\r\n"));
      }

      for (var key in data[0]) {
        csvData.push(key);
        csvData.push(",");
      }
      csvData.pop();
      csvData.push("\r\n");

      data.map(function (item) {
        for (var _key2 in item) {
          var escapedCSV = '=\"' + item[_key2] + '\"';
          if (escapedCSV.match(/[,"\n]/)) {
            escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
          }
          csvData.push(escapedCSV);
          csvData.push(",");
        }
        csvData.pop();
        csvData.push("\r\n");
      });

      if (this.footer != null) {
        csvData.push(this.parseExtraData(this.footer, "${data}\r\n"));
      }
      return csvData.join("");
    },
    getProcessedJson: function getProcessedJson(data, header) {
      var keys = this.getKeys(data, header);
      var newData = [];
      var _self = this;
      data.map(function (item, index) {
        var newItem = {};
        for (var label in keys) {
          var property = keys[label];
          newItem[label] = _self.getValue(property, item);
        }
        newData.push(newItem);
      });

      return newData;
    },
    getKeys: function getKeys(data, header) {
      if (header) {
        return header;
      }

      var keys = {};
      for (var key in data[0]) {
        keys[key] = key;
      }
      return keys;
    },
    parseExtraData: function parseExtraData(extraData, format) {
      var parseData = "";
      if (Array.isArray(extraData)) {
        for (var i = 0; i < extraData.length; i++) {
          parseData += format.replace("${data}", extraData[i]);
        }
      } else {
        parseData += format.replace("${data}", extraData);
      }
      return parseData;
    },
    getValue: function getValue(key, item) {
      var field = (typeof key === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(key)) !== "object" ? key : key.field;
      var indexes = typeof field !== "string" ? [] : field.split(".");
      var value = this.defaultValue;

      if (!field) value = item;else if (indexes.length > 1) value = this.getValueFromNestedItem(item, indexes);else value = this.parseValue(item[field]);

      if (key.hasOwnProperty('callback')) value = this.getValueFromCallback(value, key.callback);

      return value;
    },
    valueReformattedForMultilines: function valueReformattedForMultilines(value) {
      if (typeof value == "string") return value.replace(/\n/ig, "<br/>");else return value;
    },
    getValueFromNestedItem: function getValueFromNestedItem(item, indexes) {
      var nestedItem = item;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(indexes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var index = _step.value;

          if (nestedItem) nestedItem = nestedItem[index];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.parseValue(nestedItem);
    },
    getValueFromCallback: function getValueFromCallback(item, callback) {
      if (typeof callback !== "function") return this.defaultValue;
      var value = callback(item);
      return this.parseValue(value);
    },
    parseValue: function parseValue(value) {
      return value || value === 0 || typeof value === 'boolean' ? value : this.defaultValue;
    },
    base64ToBlob: function base64ToBlob(data, mime) {
      var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      var bstr = atob(base64);
      var n = bstr.length;
      var u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }
  } });

/***/ }),

/***/ "ucEP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uco5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterReport_vue__ = __webpack_require__("a22L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16091059_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterReport_vue__ = __webpack_require__("YDLQ");
function injectStyle (ssrContext) {
  __webpack_require__("3v1P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16091059_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ug9+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uk0M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductImportList_vue__ = __webpack_require__("+3k5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdfc11d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductImportList_vue__ = __webpack_require__("2v2B");
function injectStyle (ssrContext) {
  __webpack_require__("tYsp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cdfc11d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductImportList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdfc11d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductImportList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ul0L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "umDV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"mar-lt-15"},[_vm._v(_vm._s(_vm.$t('upload.dynamicMenu')))]),_vm._v(" "),(_vm.location.use_dynamic_menu)?[_c('div',{staticClass:"col-md-12 px-0"},[_c('img',{attrs:{"src":_vm.location.dynamic_qr_code}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12 mb-5 ml-4 px-0 mar-to-15"},[_c('a',{staticClass:"btn btn-info btn-icon duplicate-prod",attrs:{"href":this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + _vm.location.dynamic_qr_code + '&name=' + _vm.location.city + ' ' + _vm.location.name + '.png',"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('upload.download')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-sm-5 mar-lt-15"},[_c('input',{ref:"clone",staticClass:"form-control",attrs:{"readonly":""},domProps:{"value":_vm.location.dynamic_menu_url},on:{"focus":function($event){$event.target.select()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-sm-1"},[_c('button',{staticClass:"btn btn-icon btn-info duplicate mar-to-3",on:{"click":function($event){$event.preventDefault();return _vm.copy($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/duplicate.png"}})])])])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "un0T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedVatNumber: null,
      selectedLocationId: '',
      selectedLocation: null,
      vatNumber: null,
      supplier: {
        companyName: '',
        abbreviation: '',
        CUI: '',
        registrationNumber: '',
        email: '',
        address: '',
        bank: '',
        IBAN: '',
        dueDays: null
      },
      searchCUI: '',
      pendingSupplierRow: null
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    getSuppliers: {
      type: Function,
      required: false
    },
    supplierData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editMode: {
      type: Boolean,
      default: false
    },
    filterVatNumber: {
      type: [String, Number],
      default: null
    }
  },
  watch: {
    selectedLocationId: function selectedLocationId(id) {
      this.selectedLocation = this.findLocationById(id);
    },

    supplierData: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        if (!val || !__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(val).length) return;

        var isEmptyForm = !val.id && !val.companyName && !val.CUI && !val.cui && !val.externalLocationId;

        this.supplier = this.mapSupplierRowToForm(val);
        this.searchCUI = '';

        if (!this.editMode && isEmptyForm) {
          this.pendingSupplierRow = null;
          this.selectedLocationId = '';
          this.selectedLocation = null;
          return;
        }

        this.pendingSupplierRow = val;
        this.$modal.show('addSupplierModal');
        this.$nextTick(function () {
          _this.applySupplierLocation(val);
        });
      }
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },

  methods: {
    idsMatch: function idsMatch(a, b) {
      if (a == null || b == null || a === '') return false;
      return String(a) === String(b);
    },
    vatKey: function vatKey(vat) {
      if (vat == null) return '';
      return String(vat).trim();
    },
    getAllLocations: function getAllLocations() {
      return (this.groupedLocations || []).flatMap(function (group) {
        return group.locations || [];
      });
    },
    findLocationById: function findLocationById(id) {
      var _this2 = this;

      if (id == null || id === '') return null;

      return this.getAllLocations().find(function (loc) {
        return _this2.idsMatch(loc.true_id, id) || _this2.idsMatch(loc.id, id);
      }) || null;
    },
    findLocationByVatNumber: function findLocationByVatNumber(vatNumber) {
      var _this3 = this;

      var vat = this.vatKey(vatNumber);
      if (!vat) return null;

      var group = (this.groupedLocations || []).find(function (item) {
        return _this3.vatKey(item.vat) === vat;
      });
      if (group && group.locations && group.locations.length) {
        return group.locations[0];
      }

      return this.getAllLocations().find(function (loc) {
        return _this3.vatKey(loc.inv_fiscal_code) === vat;
      }) || null;
    },
    applySupplierLocation: function applySupplierLocation() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var found = this.findLocationById(row.externalLocationId) || this.findLocationByVatNumber(this.filterVatNumber) || this.findLocationByVatNumber(row.vatNumber);

      if (found) {
        this.selectedLocationId = String(found.true_id);
        this.selectedLocation = found;
        return;
      }

      this.selectedLocationId = '';
      this.selectedLocation = null;
    },
    onSupplierModalOpened: function onSupplierModalOpened() {
      var _this4 = this;

      if (!this.pendingSupplierRow) return;

      this.$nextTick(function () {
        _this4.applySupplierLocation(_this4.pendingSupplierRow);
        _this4.pendingSupplierRow = null;
      });
    },
    mapSupplierRowToForm: function mapSupplierRowToForm() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return {
        companyName: row.companyName || row.distributorName || row.name || '',
        abbreviation: row.abbreviation || '',
        CUI: row.CUI || row.cui || row.supplierVatNumber || '',
        email: row.email || '',
        registrationNumber: row.registrationNumber || '',
        address: row.address || '',
        bank: row.bank || '',
        IBAN: row.IBAN || row.iban || '',
        dueDays: row.dueDays != null ? row.dueDays : null,
        id: row.id || row._id || null,
        _rev: row._rev || null,
        externalLocationId: row.externalLocationId || null,
        vatNumber: row.vatNumber || null
      };
    },
    openAddSupplierModal: function openAddSupplierModal() {
      this.editMode = false;
      this.selectedLocationId = '';
      this.searchCUI = '';
      this.supplier = {
        companyName: '',
        abbreviation: '',
        CUI: '',
        email: '',
        registrationNumber: '',
        address: '',
        bank: '',
        IBAN: '',
        dueDays: null,
        id: null,
        _rev: null
      };
      this.$modal.show('addSupplierModal');
    },
    closeAddSupplierModal: function closeAddSupplierModal() {
      this.editMode = false;
      this.$modal.hide('addSupplierModal');
    },
    searchSupplier: function searchSupplier() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var company;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (_this5.searchCUI) {
                  _context.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Error',
                  text: 'Please enter a CUI to search.',
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                });
                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return _this5.fetchAnafCompanyByCui(_this5.searchCUI);

              case 6:
                company = _context.sent;

                _this5.supplier = _this5.mapSupplierRowToForm(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this5.supplier, {
                  companyName: company.name,
                  CUI: company.cui || _this5.supplier.CUI,
                  registrationNumber: company.registrationNumber,
                  address: company.address,
                  IBAN: company.iban
                }));
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.error('Error fetching supplier details:', _context.t0);
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Error',
                  text: _context.t0.message || 'Failed to retrieve supplier details.',
                  type: 'error',
                  timer: 2500,
                  showConfirmButton: false
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5, [[0, 10]]);
      }))();
    },
    saveSupplier: function saveSupplier() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var selectedLocation, supplierData, response, responseData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(!_this6.selectedLocationId || !_this6.supplier.CUI || !_this6.supplier.companyName || !_this6.supplier.address)) {
                  _context2.next = 4;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Error',
                  text: 'Toate câmpurile marcate cu * sunt obligatorii.',
                  icon: 'error',
                  timer: 1500,
                  buttons: false
                });
                return _context2.abrupt('return');

              case 4:
                selectedLocation = _this6.findLocationById(_this6.selectedLocationId);

                if (selectedLocation) {
                  _context2.next = 8;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Error',
                  text: 'Locația selectată este invalidă.',
                  icon: 'error',
                  timer: 1500,
                  buttons: false
                });
                return _context2.abrupt('return');

              case 8:
                supplierData = {
                  externalCompanyId: _this6.companyID,
                  externalLocationId: selectedLocation.true_id,
                  vatNumber: selectedLocation.inv_fiscal_code,
                  supplierVatNumber: _this6.supplier.CUI,
                  name: _this6.supplier.companyName,
                  abbreviation: _this6.supplier.abbreviation || '',
                  registrationNumber: _this6.supplier.registrationNumber || '',
                  email: _this6.supplier.email || '',
                  address: _this6.supplier.address,
                  bank: _this6.supplier.bank || '',
                  iban: _this6.supplier.IBAN || '',
                  dueDays: _this6.supplier.dueDays != null ? Number(_this6.supplier.dueDays) : 0
                };


                if (_this6.editMode && _this6.supplier.id) {
                  supplierData.id = _this6.supplier.id;
                  if (_this6.supplier._rev) {
                    supplierData._rev = _this6.supplier._rev;
                  }
                }

                _context2.next = 12;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/supplier', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(supplierData)
                });

              case 12:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 15;
                  break;
                }

                throw new Error('Eroare la salvarea furnizorului');

              case 15:
                _context2.next = 17;
                return response.json();

              case 17:
                responseData = _context2.sent;

                console.log('Furnizor salvat:', responseData);

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Furnizorul a fost salvat cu succes.',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                });

                _this6.$emit('getSuppliers');

                _this6.$modal.hide('addSupplierModal');
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2['catch'](0);

                console.error('Eroare la salvarea furnizorului:', _context2.t0);
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Error',
                  text: _context2.t0.message,
                  icon: 'error',
                  timer: 1500,
                  buttons: false
                });

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 24]]);
      }))();
    }
  }
});

/***/ }),

/***/ "upf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CantarList_vue__ = __webpack_require__("9xcS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d07c4d84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CantarList_vue__ = __webpack_require__("+8mR");
function injectStyle (ssrContext) {
  __webpack_require__("D+R4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CantarList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d07c4d84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CantarList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "usQc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uthh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 371.5 231.5"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 371.5 231.5","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVGID_1_","y":"69.7","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"SVGID_3_","d":"M0,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H9C4,161.8,0,157.8,0,152.8z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M0,161.8V69.7h92.2v92.2H0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVGID_5_","x":"229.9","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"SVGID_7_","d":"M229.9,83.2V9c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2C233.9,92.2,229.9,88.1,229.9,83.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M229.9,92.2V0h92.2v92.2H229.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVGID_9_","x":"73.2","y":"69.7","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"SVGID_11_","d":"M73.2,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H82.2C77.2,161.8,73.2,157.8,73.2,152.8\n          z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M73.2,161.8V69.7h92.2v92.2H73.2z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVGID_13_","x":"69.7","y":"0","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"SVGID_15_","d":"M78.7,0h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9V9C69.7,4,73.7,0,78.7,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M69.7,0h92.2v92.2H69.7V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVGID_17_","x":"69.7","y":"139.4","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"SVGID_19_","d":"M78.7,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9v-74.2\n          C69.7,143.4,73.7,139.4,78.7,139.4z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M69.7,139.4h92.2v92.2H69.7V139.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVGID_21_","x":"229.9","y":"139.4","width":"92.2","height":"92.2"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"SVGID_23_","d":"M238.9,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2c-5,0-9-4-9-9v-74.2\n          C229.9,143.4,233.9,139.4,238.9,139.4z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st2",attrs:{"d":"M229.9,139.4h92.2v92.2h-92.2V139.4z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVGID_25_","x":"16.3","y":"16.3","width":"355.3","height":"199"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st13"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"SVGID_27_","d":"M39.3,16.3H348c6.1,0,11.9,2.4,16.3,6.7s6.7,10.2,6.7,16.3v153c0,6.1-2.4,11.9-6.7,16.3\n          c-4.3,4.3-10.2,6.7-16.3,6.7H39.3c-6.1,0-11.9-2.4-16.3-6.7c-4.3-4.3-6.7-10.2-6.7-16.3v-153c0-6.1,2.4-12,6.7-16.3\n          S33.2,16.3,39.3,16.3z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('path',{staticClass:"st15",attrs:{"d":"M16.3,16.3h354.5v199H16.3V16.3z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVGID_29_","x":"117.9","y":"40.1","width":"151.4","height":"151.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_30_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_29_"}})]),_vm._v(" "),_c('g',{staticClass:"st16"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"SVGID_31_","cx":"193.6","cy":"115.8","r":"75.7"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_t5_32_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#SVGID_31_"}})]),_vm._v(" "),_c('g',{staticClass:"st17"},[_c('path',{staticClass:"st2",attrs:{"d":"M117.9,40.1h151.4v151.4H117.9V40.1z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uv+i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v16S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesMarkupReport_vue__ = __webpack_require__("fIC7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_637f3e08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesMarkupReport_vue__ = __webpack_require__("pLZ9");
function injectStyle (ssrContext) {
  __webpack_require__("OV1C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-637f3e08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesMarkupReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_637f3e08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesMarkupReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v2o3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-pagination',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationClass: function paginationClass() {
      return 'pagination-' + this.type;
    },
    totalPages: function totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay: function pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage: function minPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage: function maxPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  data: function data() {
    return {
      defaultPagesToDisplay: 5
    };
  },

  methods: {
    range: function range(min, max) {
      var arr = [];
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage: function changePage(item) {
      this.$emit('input', item);
    },
    nextPage: function nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },
    prevPage: function prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    }
  },
  watch: {
    perPage: function perPage(value) {
      this.$emit('input', 1);
    },
    total: function total(value) {
      this.$emit('input', 1);
    }
  }
});

/***/ }),

/***/ "v6C4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vCTZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryForm_vue__ = __webpack_require__("agLU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a01c9fa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryForm_vue__ = __webpack_require__("va6n");
function injectStyle (ssrContext) {
  __webpack_require__("A8IB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a01c9fa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vDkz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't7'
});

/***/ }),

/***/ "vFiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);












__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isSpinningWheelReport: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      loading: false,
      dateRange: [],
      tableData: []
    };
  },

  watch: {
    isSpinningWheelReport: function isSpinningWheelReport(active) {
      if (active) this.loadReport();
    }
  },
  mounted: function mounted() {
    if (this.isSpinningWheelReport) this.loadReport();
    this.$bus.$on('refresh-spinning-wheel-report', this.loadReport);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh-spinning-wheel-report', this.loadReport);
  },

  methods: {
    applyFilters: function applyFilters() {
      this.loadReport();
    },
    buildParams: function buildParams() {
      var params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      if (this.dateRange && this.dateRange[0]) params.date_from = this.dateRange[0];
      if (this.dateRange && this.dateRange[1]) params.date_to = this.dateRange[1];
      return params;
    },
    loadReport: function loadReport() {
      var _this = this;

      this.loading = true;
      this.apiRequest('/reports/spinning-wheel', 'GET', this.buildParams(), function (response) {
        _this.loading = false;
        if (response.status && response.data) {
          _this.tableData = Array.isArray(response.data) ? response.data : [];
        } else {
          _this.tableData = [];
        }
      });
    },
    onRowClick: function onRowClick(row) {
      if (!row || !row.id) return;
      this.$router.push({
        path: '/reports/spinning-wheel/' + row.id + '/rewards',
        query: {
          title: row.title || '#' + row.id,
          date_from: this.dateRange && this.dateRange[0] || '',
          date_to: this.dateRange && this.dateRange[1] || ''
        }
      });
    }
  }
});

/***/ }),

/***/ "vIJo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__ = __webpack_require__("VNNG");















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);

var itemKey = 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    subscription: {
      type: Object,
      required: true
    },

    assignDates: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      courses: __WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__["c" /* COURSES */],
      loading: false,
      saving: false,
      currency: '',
      pricePerDay: this.subscription.price_per_day,
      menus: [],
      categories: [],
      editor: null,
      search: {
        q: '',
        category_id: null,
        page: 1,
        lastPage: 1,
        items: [],
        loading: false
      },
      searchTimer: null
    };
  },

  computed: {
    totalCents: function totalCents() {
      var _this = this;

      if (!this.editor) {
        return 0;
      }
      return this.editor.items.reduce(function (total, item) {
        return total + _this.lineCents(item);
      }, 0);
    },
    diffCents: function diffCents() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__["d" /* toCents */])(this.pricePerDay) - this.totalCents;
    },
    totalText: function totalText() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__["e" /* formatMoney */])(this.totalCents);
    },
    diffText: function diffText() {
      return (this.diffCents > 0 ? '+' : '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__["e" /* formatMoney */])(this.diffCents);
    }
  },
  created: function created() {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso);
    this.getMenus();
    this.getCategories();
    if (this.assignDates.length) {
      this.openEditor(null);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.searchTimer);
  },

  methods: {
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    url: function url(path) {
      return '/menu-subscription/' + this.subscription.id + (path || '');
    },
    getMenus: function getMenus() {
      var _this2 = this;

      this.loading = true;
      this.apiRequest(this.url('/menus'), 'GET', this.requestData(), function (response) {
        _this2.loading = false;
        if (response.status === true) {
          _this2.applyMenus(response.data);
        }
      });
    },
    applyMenus: function applyMenus(data) {
      this.menus = data && data.menus || [];
      if (data && data.price_per_day !== undefined) {
        this.pricePerDay = data.price_per_day;
      }
    },
    getCategories: function getCategories() {
      var _this3 = this;

      this.apiRequest('/menu-subscription/categories', 'GET', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestData(), { location_id: this.subscription.location_token }), function (response) {
        if (response.status === true) {
          _this3.categories = response.data || [];
        }
      });
    },
    setDefault: function setDefault(menu) {
      var _this4 = this;

      this.apiRequest(this.url('/menus/' + menu.id + '/default'), 'POST', this.requestData(), function (response) {
        if (response.status === true) {
          _this4.applyMenus(response.data);
          _this4.$emit('changed');
        } else {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', _this4.firstError(response), 'error').catch(function () {});
        }
      });
    },
    duplicate: function duplicate(menu) {
      var _this5 = this;

      this.apiRequest(this.url('/menus/' + menu.id + '/duplicate'), 'POST', this.requestData(), function (response) {
        if (response.status === true) {
          _this5.getMenus();
          _this5.$emit('changed');
        } else {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', _this5.firstError(response), 'error').catch(function () {});
        }
      });
    },
    remove: function remove(menu) {
      var _this6 = this;

      var text = this.$t('menuSubscriptions.deleteMenuQuestion', { name: menu.name });
      if (menu.upcoming_days) {
        text += ' ' + this.$t('menuSubscriptions.deleteMenuDays', { count: menu.upcoming_days });
      }
      if (menu.is_default && this.menus.length > 1) {
        text += ' ' + this.$t('menuSubscriptions.deleteMenuDefault');
      }
      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ text: text, type: 'question', showCancelButton: true }).then(function (result) {
        if (!result) {
          return;
        }
        _this6.apiRequest(_this6.url('/menus/' + menu.id), 'DELETE', _this6.requestData(), function (response) {
          if (response.status === true) {
            _this6.applyMenus(response.data);
            _this6.$emit('changed');
          } else {
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', _this6.firstError(response), 'error').catch(function () {});
          }
        });
      }).catch(function () {});
    },
    openEditor: function openEditor(menu) {
      this.editor = {
        id: menu ? menu.id : null,
        name: menu ? menu.name : '',
        items: menu ? menu.items.map(function (item) {
          return {
            key: ++itemKey,
            catalogproduct_id: item.catalogproduct_id,
            name: item.name,
            quantity: item.quantity,
            price: item.price,
            course: item.course,
            catalog_price: item.catalog_price,
            vat: item.vat,
            product_missing: item.product_missing
          };
        }) : []
      };
      this.search.q = '';
      this.searchProducts(1);
    },
    closeEditor: function closeEditor() {
      this.editor = null;
    },
    onSearchInput: function onSearchInput() {
      var _this7 = this;

      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        return _this7.searchProducts(1);
      }, 300);
    },
    searchProducts: function searchProducts(page) {
      var _this8 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestData(), {
        location_id: this.subscription.location_token,
        page: page || 1
      });
      if (this.search.q.trim()) {
        data.q = this.search.q.trim();
      }
      if (this.search.category_id) {
        data.category_id = this.search.category_id;
      }
      this.search.loading = true;
      this.apiRequest('/menu-subscription/products', 'GET', data, function (response) {
        _this8.search.loading = false;
        if (response.status === true && response.data) {
          _this8.search.items = response.data.items || [];
          _this8.search.page = response.data.pagination.current_page;
          _this8.search.lastPage = response.data.pagination.last_page;
        } else {
          _this8.search.items = [];
        }
      });
    },
    addProduct: function addProduct(product) {
      this.editor.items.push({
        key: ++itemKey,
        catalogproduct_id: product.id,
        name: product.name,
        quantity: 1,

        price: product.price !== null && product.price !== undefined ? parseFloat(product.price).toFixed(2) : '0.00',
        course: null,
        catalog_price: product.price,
        vat: product.vat,
        product_missing: false
      });
    },
    move: function move(index, step) {
      var target = index + step;
      if (target < 0 || target >= this.editor.items.length) {
        return;
      }
      var items = this.editor.items;
      items.splice(target, 0, items.splice(index, 1)[0]);
    },
    lineCents: function lineCents(item) {
      var quantity = Math.max(0, parseInt(item.quantity, 10) || 0);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__["d" /* toCents */])(item.price) * quantity;
    },
    lineTotal: function lineTotal(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__["e" /* formatMoney */])(this.lineCents(item));
    },
    putDifference: function putDifference(index) {
      var item = this.editor.items[index];
      var quantity = Math.max(1, parseInt(item.quantity, 10) || 1);
      var newUnit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__["d" /* toCents */])(item.price) + this.diffCents / quantity;
      if (this.diffCents % quantity !== 0 || newUnit < 0) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', this.$t('menuSubscriptions.cannotPutDifference'), 'info').catch(function () {});
        return;
      }
      item.price = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__["e" /* formatMoney */])(newUnit);
    },
    rescale: function rescale() {
      var prices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__menuSubscriptionHelpers__["f" /* scalePrices */])(this.editor.items, this.pricePerDay);
      if (!prices) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', this.$t('menuSubscriptions.cannotRescale'), 'info').catch(function () {});
        return;
      }
      this.editor.items.forEach(function (item, i) {
        item.price = prices[i];
      });
    },
    saveMenu: function saveMenu() {
      var _this9 = this;

      if (!(this.editor.name || '').trim()) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', this.$t('menuSubscriptions.menuNameRequired'), 'warning').catch(function () {});
        return;
      }
      if (!this.editor.items.length) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', this.$t('menuSubscriptions.noItems'), 'warning').catch(function () {});
        return;
      }
      if (this.diffCents !== 0) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', this.$t('menuSubscriptions.totalMustMatch', { total: this.totalText, price: this.pricePerDay }), 'warning').catch(function () {});
        return;
      }
      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestData(), {
        name: this.editor.name,
        items: this.editor.items.map(function (item) {
          return {
            catalogproduct_id: item.catalogproduct_id,
            quantity: String(item.quantity),
            price: item.price,
            course: item.course || null
          };
        })
      });
      var isNew = !this.editor.id;
      this.saving = true;
      this.apiRequest(isNew ? this.url('/menus') : this.url('/menus/' + this.editor.id), isNew ? 'POST' : 'PUT', data, function (response) {
        if (response.status !== true) {
          _this9.saving = false;
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', _this9.firstError(response), 'error').catch(function () {});
          return;
        }
        _this9.applyMenus(response.data.menus);
        _this9.$emit('changed');

        if (isNew && _this9.assignDates.length) {
          _this9.assignToDates(response.data.id);
          return;
        }
        _this9.saving = false;
        _this9.editor = null;
        __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ title: '', text: _this9.$t('menuSubscriptions.menuSaved'), type: 'success', showConfirmButton: false, timer: 1200 }).catch(function () {});
      });
    },
    assignToDates: function assignToDates(menuId) {
      var _this10 = this;

      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestData(), { dates: this.assignDates, menu_id: menuId });
      this.apiRequest(this.url('/calendar'), 'PUT', data, function (response) {
        _this10.saving = false;
        _this10.editor = null;
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ title: '', text: _this10.$t('menuSubscriptions.menuSavedAssigned'), type: 'success', showConfirmButton: false, timer: 1500 }).catch(function () {});
          _this10.$emit('assigned');
        } else {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', _this10.firstError(response), 'error').catch(function () {});
        }
      });
    },
    firstError: function firstError(response) {
      var errors = response && response.errors || {};
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors)[0];
      if (!key) {
        return this.$t('validations.wentWrong');
      }
      return Array.isArray(errors[key]) ? errors[key][0] : errors[key];
    }
  }
});

/***/ }),

/***/ "vIMW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__("sUu7");







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    userLabels: {
      type: [Object, Array],
      required: true
    },
    modelFromParent: {
      type: [Object, Array],
      required: true
    },
    daysParent: {
      type: Array,
      required: true
    },
    customerGroups: {
      type: [Object, Array]
    }
  },
  watch: {
    modelFromParent: function modelFromParent(value, oldVal) {
      this.model = value;
      this.model.user_label_id = this.filters[5].value;
      this.filters[1].value = value.user_filters ? value.user_filters.gender : null;
      this.filters[2].value = value.user_filters ? value.user_filters.orders_above : null;
      this.filters[3].value = value.user_filters ? value.user_filters.age : null;
      this.filters[4].value = value.user_filters ? value.user_filters.location_id : null;
      this.filters[5].value = value.user_filters ? value.user_filters.user_label_id : null;
      this.filters[6].value = value.user_filters ? value.user_filters.orders_below : null;
      this.filters[7].value = value.user_filters ? value.user_filters.orders_above_nr : null;
      this.filters[8].value = value.user_filters ? value.user_filters.orders_below_nr : null;
      this.filters[9].value = value.user_filters && (value.user_filters.with_orders === 0 || value.user_filters.with_orders === 1 || value.user_filters.with_orders === '0' || value.user_filters.with_orders === '1') ? String(value.user_filters.with_orders) : '';
      this.filters[10].value = value.user_filters ? value.user_filters.groups : null;
      this.filters[11].value = value.user_filters ? value.user_filters.period : null;
      this.filters[12].value = value.user_filters && (value.user_filters.with_loyalty_points === 0 || value.user_filters.with_loyalty_points === 1 || value.user_filters.with_loyalty_points === '0' || value.user_filters.with_loyalty_points === '1') ? String(value.user_filters.with_loyalty_points) : '';
      this.counter_matching_users = value.user_filters && value.user_filters.counter_matching_users ? value.user_filters.counter_matching_users : this.counter_matching_users;
      this.model.counter_matching_users = this.counter_matching_users;
      this.applyFilters();
    },
    daysParent: function daysParent(value, oldVal) {
      this.days = value;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vee_validate__["b" /* mapFields */])(['notification_type', 'notification_mode', 'email'])),
  created: function created() {
    var data = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany'),
      campaign_id: this.$route.params.id
    };
    this.getCustomers(data);
    var company = this.$session.get('selectedCompanyData');
    this.locations = company.locations_details.map(function (el) {
      return {
        id: el.id,
        true_id: el.true_id,
        name: el.name
      };
    });
    if (this.locations.length > 1) {
      this.colsClass = 'col-md-2';
    }
    this.currency = this.getCurrencySymbol(company.currency_iso);
  },
  data: function data() {
    var _this = this;

    return {
      tableData: [],
      paginationDef: {
        page: null,
        pageSize: [10, 20, 50],
        totalPages: null,
        totalRecords: null
      },
      model: this.value || this.modelFromParent,
      days: this.value || this.daysParent,
      modelValidations: {
        notification_type: {
          required: true
        },
        notification_mode: {
          required: true
        },
        email: {
          required: true,
          email: true
        }
      },
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      },
      locations: [],
      colsClass: 'col-md-4',
      campaignsNotificationTypes: this.$session.get('defaultData')['campaigns_notification_types'],
      campaignsModes: this.$session.get('defaultData')['campaigns_modes'],
      filters: [{
        value: '',
        prop: ['firstname', 'lastname', 'sales']
      }, {
        value: '',
        prop: ['gender']
      }, {
        value: '',
        prop: ['sales']
      }, {
        value: '',
        prop: ['birthdate'],
        filterFn: function filterFn(row, filter) {
          var age = _this.getAge(row.birthdate);
          switch (filter.value) {
            case '20':
              if (age < 20) {
                return row;
              }
              break;
            case '20-30':
              if (age >= 20 && age <= 30) {
                return row;
              }
              break;
            case '30-40':
              if (age >= 30 && age <= 40) {
                return row;
              }
              break;
            case '40-50':
              if (age >= 40 && age <= 50) {
                return row;
              }
              break;
            case '50+':
              if (age > 50) {
                return row;
              }
              break;
          }
          return false;
        }
      }, {
        value: '',
        prop: ['orders_locations'],
        filterFn: function filterFn(row, filter) {
          if (row.orders_locations.includes(filter.value)) {
            return true;
          }
          return false;
        }
      }, {
        value: '',
        prop: ['user_label_id'],
        filterFn: function filterFn(row, filter) {
          return row.user_label_id === filter.value;
        }
      }, {
        value: '',
        prop: ['sales'],
        filterFn: function filterFn(row, filter) {
          return row.sales <= filter.value;
        }
      }, {
        value: '',
        prop: ['orders']
      }, {
        value: '',
        prop: ['orders']
      }, {
        value: '',
        prop: ['with_orders']
      }, {
        value: '',
        prop: ['groups']
      }, {
        value: '',
        prop: ['period']
      }, {
        value: '',
        prop: ['with_loyalty_points']
      }],
      counter_matching_users: 0,
      currency: '',
      loading: true
    };
  },

  methods: {
    groupCustomersEvent: function groupCustomersEvent() {
      this.$emit('groupCustomers', this.filters[10].value);
    },
    appendWithLoyaltyPointsFilter: function appendWithLoyaltyPointsFilter(data) {
      var value = this.filters[12].value;
      if (value === '0' || value === '1') {
        data.with_loyalty_points = Number(value);
      }
    },
    appendWithOrdersFilter: function appendWithOrdersFilter(data) {
      var value = this.filters[9].value;
      if (value === '0' || value === '1') {
        data.with_orders = Number(value);
      }
    },
    applyFilters: function applyFilters() {
      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      data[this.filters[1].prop[0]] = this.filters[1].value;
      data[this.filters[3].prop[0]] = this.filters[3].value;
      data[this.filters[4].prop[0]] = this.filters[4].value;
      data[this.filters[5].prop[0]] = this.filters[5].value;
      data[this.filters[10].prop[0]] = this.filters[10].value;
      data['period'] = this.filters[11].value;
      data['min_sales'] = this.filters[2].value;
      data['max_sales'] = this.filters[6].value;
      data['min_orders'] = this.filters[7].value;
      data['max_orders'] = this.filters[8].value;
      data['groups'] = this.sanitizeGroups(this.filters[10].value);
      this.appendWithOrdersFilter(data);
      this.appendWithLoyaltyPointsFilter(data);
      this.getCustomers(data);
    },
    resetFilters: function resetFilters() {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      data[this.filters[1].prop[0]] = this.filters[1].value = '';
      data[this.filters[3].prop[0]] = this.filters[3].value = '';
      data[this.filters[4].prop[0]] = this.filters[4].value = '';
      data[this.filters[5].prop[0]] = this.filters[5].value = '';
      data[this.filters[9].prop[0]] = this.filters[9].value = '';
      data[this.filters[10].prop[0]] = this.filters[10].value = '';
      data['min_sales'] = this.filters[2].value = ' ';
      data['max_sales'] = this.filters[6].value = ' ';
      data['min_orders'] = this.filters[7].value = ' ';
      data['max_orders'] = this.filters[8].value = ' ';
      data['groups'] = this.filters[10].value = null;
      data['period'] = this.filters[11].value = null;
      this.filters[12].value = '';
      this.getCustomers(data);
    },
    sanitizeGroups: function sanitizeGroups(groups) {
      if (!groups || !groups.length) return null;
      var res = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(groups).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        res.push(groups[key].id);
      });
      return res;
    },
    getCustomers: function getCustomers(data) {
      var _this2 = this;

      this.loading = true;

      this.apiRequest('/customer', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.tableData = response.data.data;
          _this2.paginationDef.page = response.data.pagination.page;
          _this2.paginationDef.perPage = response.data.pagination.perPage;
          _this2.paginationDef.totalPages = response.data.pagination.totalPages;
          _this2.paginationDef.totalRecords = response.data.pagination.totalRecords;
        }
        _this2.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    handlePageChange: function handlePageChange(page) {
      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: page
      };
      data[this.filters[1].prop[0]] = this.filters[1].value;
      data[this.filters[3].prop[0]] = this.filters[3].value;
      data[this.filters[4].prop[0]] = this.filters[4].value;
      data[this.filters[5].prop[0]] = this.filters[5].value;
      data[this.filters[10].prop[0]] = this.filters[10].value;
      data['min_sales'] = this.filters[2].value;
      data['max_sales'] = this.filters[6].value;
      data['min_orders'] = this.filters[7].value;
      data['max_orders'] = this.filters[8].value;
      data['groups'] = this.filters[10].value;
      this.appendWithOrdersFilter(data);
      this.appendWithLoyaltyPointsFilter(data);
      this.getCustomers(data);
    },
    dataFiltered: function dataFiltered() {
      this.counter_matching_users = this.paginationDef.totalRecords;
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      this.model.user_filters = {
        gender: this.filters[1].value,
        orders_above: this.filters[2].value,
        age: this.filters[3].value,
        location_id: this.filters[4].value,
        user_label_id: this.filters[5].value,
        orders_below: this.filters[6].value,
        orders_above_nr: this.filters[7].value,
        orders_below_nr: this.filters[8].value,
        groups: this.filters[10].value,
        period: this.filters[11].value
      };
      if (this.filters[9].value === '0' || this.filters[9].value === '1') {
        this.model.user_filters.with_orders = Number(this.filters[9].value);
      }
      if (this.filters[12].value === '0' || this.filters[12].value === '1') {
        this.model.user_filters.with_loyalty_points = Number(this.filters[12].value);
      }
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "vLc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlovoMenuLayout_vue__ = __webpack_require__("qqky");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_180fa234_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlovoMenuLayout_vue__ = __webpack_require__("lgBe");
function injectStyle (ssrContext) {
  __webpack_require__("QnKd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-180fa234"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlovoMenuLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_180fa234_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlovoMenuLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faba701c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("LM/7");
function injectStyle (ssrContext) {
  __webpack_require__("6i1p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-faba701c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faba701c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vNt5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_date_picker___default.a),
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getData();
  },
  mounted: function mounted() {
    console.log('mounted');
    this.getData();
  },
  data: function data() {
    return {
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      clients: {
        'valid': [__WEBPACK_IMPORTED_MODULE_4_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_4_moment___default()().endOf('month').format('YYYY-MM-DD')],
        searchClient: null,
        searchEmployee: null
      },
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        defaultSort: {
          prop: 'name',
          order: 'ascending'
        }
      },
      labels: null,
      labelingPrimaryOption: null,
      totalClients: null,
      sortBy: 'name',
      sortOrder: 'asc',
      clientsTableData: [],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      pickerNames: ['date_from', 'date_to'],
      apiUrl: null,
      reportTypes: {
        exportRaportPuncte: 'pointsReport'
      }
    };
  },

  methods: {
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getData(query);
      if (query.type === 'size') this.getData(query);
      if (query.type === 'sort') {
        if (query.sort.order) {
          this.sortBy = query.sort.prop;
          this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc';
        } else {
          this.sortBy = 'name';
          this.sortOrder = 'asc';
        }
        this.getData(query);
      }
    },
    getData: function getData(query) {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.loading = true;

      this.apiRequest('reports/pending-report', 'GET', data, function (response) {
        if (response.status === true) {
          _this.clientsTableData = response.data;
        }
        _this.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    downloadReport: function downloadReport(id) {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.loading = true;
      this.apiRequest('reports/download-pending-report', 'GET', data, function (response) {
        _this2.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    reportStatus: function reportStatus(report) {
      if (Number(report.is_executed) === -1) return 'Generarea a eșuat. Solicită din nou raportul.';
      if (Number(report.is_executed) === 1) return 'Procesat';
      return report.in_progress ? 'În procesare' : 'În așteptare';
    },
    mapReportType: function mapReportType(type) {
      if (type === 'sql-products') return 'Toate produsele (CSV)';
      if (type === 'sql-coupon-orders') return 'Comenzi cu cupon (CSV)';
      return this.reportTypes[type] ? this.$t('reports.' + this.reportTypes[type]) : this.$t('reports.reportTypePlaceholder');
    }
  }
});

/***/ }),

/***/ "vPYJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceProfile_vue__ = __webpack_require__("brEj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d964c95e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceProfile_vue__ = __webpack_require__("mOkA");
function injectStyle (ssrContext) {
  __webpack_require__("ybMI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d964c95e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d964c95e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vQiK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderFromReport_vue__ = __webpack_require__("pmdb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ee17f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderFromReport_vue__ = __webpack_require__("rPCk");
function injectStyle (ssrContext) {
  __webpack_require__("XAsG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderFromReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ee17f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderFromReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vTQ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row spinning-wheel-report"},[_c('div',{staticClass:"col-xl-12 col-md-12 col-xs-12"},[_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"table-top",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"flex-start","gap":"10px","flex-wrap":"wrap"}},[_c('div',{staticClass:"left-group",staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px","align-items":"flex-end","flex":"1 1 auto"}},[_c('div',{staticClass:"form-group",staticStyle:{"margin":"0"}},[_c('label',[_vm._v(_vm._s(_vm.$t('reports.dateInterval')))]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"260px"},attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","size":"small"},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"flex":"0 0 100px","margin":"0"}},[_c('button',{staticClass:"btn add",staticStyle:{"width":"100%","font-size":"12px","padding":"4px 8px"},attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.applyFilters}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "+_vm._s(_vm.$t('general.search'))+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"data-table",staticStyle:{"margin-top":"20px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.onRowClick}},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('customers.id'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":_vm.$t('spinningWheel.campaignTitle'),"min-width":"160","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('spinningWheel.active'),"width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.active ? _vm.$t('general.yes') : _vm.$t('general.no'))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"spins","label":_vm.$t('spinningWheel.spins'),"width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"users_who_spun","label":_vm.$t('spinningWheel.usersWhoSpun'),"width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rewards_won","label":_vm.$t('spinningWheel.rewardsWon'),"width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rewards_redeemed","label":_vm.$t('spinningWheel.rewardsRedeemed'),"width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('spinningWheel.redemptionRate'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.redemption_rate != null ? props.row.redemption_rate + '%' : '—')+"\n              ")]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vTqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThirdStep_vue__ = __webpack_require__("vIMW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccc9fcf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThirdStep_vue__ = __webpack_require__("sKTq");
function injectStyle (ssrContext) {
  __webpack_require__("eJNc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThirdStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccc9fcf0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThirdStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vU3l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vWzQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vYda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceForm_vue__ = __webpack_require__("m1h4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626eaf90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceForm_vue__ = __webpack_require__("vvXC");
function injectStyle (ssrContext) {
  __webpack_require__("Cx4m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-626eaf90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626eaf90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "va6n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew())?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",attrs:{"title":_vm.$t('general.delete') + ' ' + _vm.$t('catalogCateg.single')},on:{"click":function($event){$event.preventDefault();_vm.handleDelete('delete')}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n            "+_vm._s(_vm.$t('general.delete'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.save'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card translations-card"},[_c('div',{staticClass:"card-content"},[_c('h5',{staticClass:"translations-title"},[_vm._v(_vm._s(_vm.$t('catalogCateg.name'))+" / "+_vm._s(_vm.$t('catalogCateg.shortDescription')))]),_vm._v(" "),_c('div',{staticClass:"lang-tabs"},[_c('a',{staticClass:"lang-tab",class:[{ active: _vm.currentSubSection === 'l1', errorT: _vm.invalidTabs.includes('l1') }],on:{"click":function($event){$event.preventDefault();_vm.openSubSection('l1')}}},[_vm._v(_vm._s(_vm.language))]),_vm._v(" "),_vm._l((_vm.languages),function(lang){return _c('a',{key:'tab-' + lang.id,staticClass:"lang-tab",class:[{ active: _vm.currentSubSection === lang.id + '-' + lang.short, errorT: _vm.invalidTabs.includes(lang.id + '-' + lang.short) }],on:{"click":function($event){$event.preventDefault();_vm.openSubSection(lang.id + '-' + lang.short)}}},[_vm._v(_vm._s(lang.short))])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSubSection === 'l1'),expression:"currentSubSection === 'l1'"}]},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('catalogCateg.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('name'))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.shortDescription')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"5","name":"description","placeholder":_vm.$t('catalogCateg.shortDescription')},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}})])]),_vm._v(" "),_vm._l((_vm.languages),function(lang){return [(_vm.model.localized_fields && _vm.model.localized_fields[lang.short])?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSubSection === lang.id + '-' + lang.short),expression:"currentSubSection === lang.id + '-' + lang.short"}],key:'box-' + lang.id},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.name'))+" ("+_vm._s(lang.short)+")")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.localized_fields[lang.short].name),expression:"model.localized_fields[lang.short].name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('catalogCateg.name')},domProps:{"value":(_vm.model.localized_fields[lang.short].name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.localized_fields[lang.short], "name", $event.target.value)}}}),_vm._v(" "),(_vm.invalidTabs.includes(lang.id + '-' + lang.short) && (!_vm.model.localized_fields[lang.short].name || !_vm.model.localized_fields[lang.short].name.trim()))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.$t('validations.requiredField'))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.shortDescription'))+" ("+_vm._s(lang.short)+")")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.localized_fields[lang.short].description),expression:"model.localized_fields[lang.short].description"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":_vm.$t('catalogCateg.shortDescription')},domProps:{"value":(_vm.model.localized_fields[lang.short].description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.localized_fields[lang.short], "description", $event.target.value)}}})])]):_vm._e()]})],2)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"section-header"},[_c('h5',{staticClass:"section-header__title"},[_vm._v(_vm._s(_vm.$t('catalogCateg.single')))])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.assignTopCategory')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.top_category_id),expression:"model.top_category_id"}],ref:"top_category_id",staticClass:"form-control",attrs:{"name":"top_category_id","data-vv-as":"top_category"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "top_category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.changeTopCategory()}]}},[_c('option',{attrs:{"value":"null"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.pleaseSelect')))]),_vm._v(" "),_vm._l((_vm.topCategories),function(option){return _c('option',{key:option.id,attrs:{"label":option.name},domProps:{"value":option.id}})})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.visibleInLocations')))]),_vm._v(" "),_c('v-select',{staticClass:"line-heigth-44",attrs:{"multiple":"","options":_vm.locations,"label":"name","placeholder":_vm.$t('general.all')},on:{"input":_vm.updateDeliverySettings},model:{value:(_vm.selectedLocations),callback:function ($$v) {_vm.selectedLocations=$$v},expression:"selectedLocations"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.visibleInLocationsInfo')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group category-override-group"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.$t('catalogProd.deliveryMethodsandHours')))])]),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.updateDeliverySettings()}}},[_c('p-checkbox',{attrs:{"value":true},on:{"input":function($event){_vm.handleChangeOverrideDelivery()}},model:{value:(_vm.model.override_delivery),callback:function ($$v) {_vm.$set(_vm.model, "override_delivery", $$v)},expression:"model.override_delivery"}},[_vm._v(_vm._s(_vm.$t('catalogProd.overrideSettings')))]),_vm._v(" "),_c('small',{staticClass:"text-muted category-override-help"},[_vm._v(_vm._s(_vm.$t('catalogCateg.overrideSettingsHelp')))]),_vm._v(" "),(_vm.model.override_delivery && (_vm.errors.has('isCheckedDay') || _vm.errors.has('isCheckedDeliveryMethod')))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.$t('validations.chooseLocationAndDeliveryMethod'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.model.override_delivery && _vm.errors.has('intervalError'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.$t('validations.timeInterval'))+"\n                ")]):_vm._e()],1),_vm._v(" "),(_vm.model.override_delivery)?_c('el-collapse',{staticClass:"category-override-collapse",attrs:{"accordion":""}},_vm._l((_vm.model.override_settings),function(loc,locId){return _c('el-collapse-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showThisOverrideLocation(loc.loc_id)),expression:"showThisOverrideLocation(loc.loc_id)"}],key:'override-' + loc.loc_id + '-' + locId,attrs:{"title":_vm.overrideLocationTitle(loc.loc_id),"name":String(loc.loc_id)}},[_c('hr',{staticClass:"sm"}),_vm._v(" "),_vm._l((loc.delivery),function(orderInterval,orderIntervalId){return [_c('div',{key:'dm-' + locId + '-' + orderIntervalId,staticClass:"col-md-12"},[_c('h4',[_vm._v("\n                        "+_vm._s(_vm.$t('settingCompany.' + _vm.deliveryMethodLabel(orderInterval, orderIntervalId)))+"\n                        "),_c('button',{staticClass:"btn btn-success btn-sm",on:{"click":function($event){$event.preventDefault();_vm.addNewOverrideInterval(locId, orderIntervalId, _vm.deliveryMethodLabel(orderInterval, orderIntervalId))}}},[_vm._v("+")])]),_vm._v(" "),_vm._l((orderInterval),function(order,orderId){return [_c('div',{key:'interval-' + locId + '-' + orderIntervalId + '-' + orderId,staticClass:"col-md-12"},[_c('p-checkbox',{attrs:{"value":_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']},on:{"input":function($event){_vm.handleChangeIsCheckedDeliveryMethod(locId, orderIntervalId, orderId)}},model:{value:(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']),callback:function ($$v) {_vm.$set(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId], 'active', $$v)},expression:"model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"}},[_vm._v("\n                            "+_vm._s(_vm.$t('general.active'))+"\n                          ")]),_vm._v("\n\n                          "+_vm._s(_vm.$t('general.from'))+"\n                          "),_c('el-time-select',{staticClass:"in-inline-160",attrs:{"disabled":!_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active'],"placeholder":"Select time","picker-options":_vm.timePickerOptions},model:{value:(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_from']),callback:function ($$v) {_vm.$set(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId], 'available_from', $$v)},expression:"model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_from']"}}),_vm._v("\n\n                          "+_vm._s(_vm.$t('general.to'))+"\n                          "),_c('el-time-select',{staticClass:"in-inline-160",attrs:{"disabled":!_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active'],"placeholder":"Select time","picker-options":_vm.timePickerOptions},model:{value:(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_to']),callback:function ($$v) {_vm.$set(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId], 'available_to', $$v)},expression:"model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_to']"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){$event.preventDefault();_vm.removeOverrideInterval(locId, orderIntervalId, orderId)}}},[_vm._v("-")])],1),_vm._v(" "),_c('div',{key:'days-' + locId + '-' + orderIntervalId + '-' + orderId,staticClass:"col-md-12 pull-left-first-child",staticStyle:{"flex-wrap":"wrap"}},[_vm._l((_vm.weekDays()),function(d,key){return [_c('p-checkbox',{key:'day-' + locId + '-' + orderIntervalId + '-' + orderId + '-' + key,staticClass:"inline-auto mar-rt-5",attrs:{"disabled":!_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active'],"value":d},on:{"input":function($event){_vm.handleCheckDay(locId, orderIntervalId, orderId)}},model:{value:(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId][d.toLowerCase()]),callback:function ($$v) {_vm.$set(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId], d.toLowerCase(), $$v)},expression:"model.override_settings[locId]['delivery'][orderIntervalId][orderId][d.toLowerCase()]"}},[_vm._v("\n                              "+_vm._s(_vm.$t('catalogProd.' + d))+"\n                            ")])]})],2),_vm._v(" "),_c('div',{key:'day-err-' + locId + '-' + orderIntervalId + '-' + orderId,staticClass:"col-md-12 pull-left-first-child",staticStyle:{"flex-wrap":"wrap"}},[(_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active'] &&
                                  !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].monday &&
                                  !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].tuesday &&
                                  !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].wednesday &&
                                  !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].thursday &&
                                  !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].friday &&
                                  !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].saturday &&
                                  !_vm.model.override_settings[locId]['delivery'][orderIntervalId][orderId].sunday)?_c('small',{staticClass:"text-danger"},[_vm._v("\n                            "+_vm._s(_vm.$t('validations.chooseDay'))+"\n                          ")]):_vm._e()])]})],2)]})],2)})):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.vat')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.vat),expression:"model.vat"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":_vm.$t('catalogProd.price')},domProps:{"value":(_vm.model.vat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "vat", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.preparation_time_in_minutes')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preparationTimeInMinutes),expression:"preparationTimeInMinutes"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"1","name":"preparation_time_in_minutes","placeholder":_vm.$t('catalogCateg.preparation_time_in_minutes')},domProps:{"value":(_vm.preparationTimeInMinutes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.preparationTimeInMinutes=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Selecteaza filtre relevante pentru categorie")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-select',{key:'option',ref:'option',attrs:{"multiple":"","options":_vm.filters,"value":"id","label":"type","placeholder":_vm.$t('general.none')},model:{value:(_vm.model.filters),callback:function ($$v) {_vm.$set(_vm.model, "filters", $$v)},expression:"model.filters"}})],1),_vm._v(" "),(_vm.userLabelings.length)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.userLabelings')))]),_vm._v(" "),_c('v-select',{staticClass:"line-heigth-44",attrs:{"multiple":"","options":_vm.userLabelings,"label":"name","reduce":function (item) { return item.id; },"placeholder":_vm.$t('general.none')},model:{value:(_vm.selectedUserLabelings),callback:function ($$v) {_vm.selectedUserLabelings=$$v},expression:"selectedUserLabelings"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('catalogCateg.userLabelingsHelp')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.notification_email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.notification_email),expression:"model.notification_email"}],staticClass:"form-control",attrs:{"type":"text","name":"notification_email","placeholder":_vm.$t('catalogCateg.notification_email')},domProps:{"value":(_vm.model.notification_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "notification_email", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('notification_email'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('notification_email'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.displayType')))]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.displayTypes),function(opt,key){return _c('p-radio',{key:key,attrs:{"label":key,"inline":true,"disabled":key === 'grid'},model:{value:(_vm.model.display_type),callback:function ($$v) {_vm.$set(_vm.model, "display_type", $$v)},expression:"model.display_type"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.'+ opt)))])}),_vm._v(" "),(_vm.errors.has('display_type'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('display_type'))+"\n              ")]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.color')))]),_vm._v(" "),_c('ChromePicker',{attrs:{"value":_vm.model.color || '#FFFFFF',"disable-alpha":true},on:{"input":function($event){_vm.$set(_vm.model, 'color', $event.hex)}}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.validFromTo')))]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"daterange","value-format":"yyyy-MM-dd","format":"dd/MM/yyyy","picker-options":_vm.pickerOptions},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}}),_vm._v(" "),(_vm.errors.has('date_validfrom'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                "+_vm._s(_vm.getError('date_validfrom'))+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"forceMethod",staticClass:"text-purple",attrs:{"disabled":(_vm.model.top_category_id !== 'null' && _vm.model.top_category_id !== null) ? true : false,"label":"forceMethod"},on:{"input":function($event){_vm.showMethods()}},model:{value:(_vm.model.is_force_method),callback:function ($$v) {_vm.$set(_vm.model, "is_force_method", $$v)},expression:"model.is_force_method"}},[_c('span',{ref:"interval",staticClass:"pad-to-7",staticStyle:{"margin":"4px"},attrs:{"name":"forceMethod"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.forceMethod'))+"\n                "),((_vm.model.top_category_id !== 'null' && _vm.model.top_category_id !== null))?_c('span',[_vm._v(_vm._s(_vm.$t('catalogCateg.enableMethod')))]):_vm._e()])]),_vm._v(" "),(_vm.model.is_force_method)?[_c('label',{staticClass:"selectMethod",attrs:{"for":"methods"}},[_vm._v("\n                    "+_vm._s(_vm.$t('catalogCateg.selectMethod'))+"\n                  "),(_vm.delivery_options_labels.length)?_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:((_vm.model.is_force_method) ? 'required' : ''),expression:"(model.is_force_method) ? 'required' : ''"}],key:"methods",attrs:{"name":"methods","multiple":"","filterable":"","default-first-option":"","placeholder":_vm.$t('general.add')},model:{value:(_vm.model.force_methods),callback:function ($$v) {_vm.$set(_vm.model, "force_methods", $$v)},expression:"model.force_methods"}},[_vm._l((_vm.delivery_options_labels),function(item){return [_c('el-option',{attrs:{"label":item.label,"value":item.key}})]})],2):_vm._e()],1)]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChange,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('img',{attrs:{"src":"/static/img/icons/icon-plus-primary.png"}}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingLocationGroups.active')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.disabledOrderSources')))]),_vm._v(" "),_c('v-select',{staticClass:"line-heigth-44",attrs:{"multiple":"","options":_vm.disablableOrderSources,"label":"name","placeholder":_vm.$t('catalogProd.timeOptionsValues.none')},model:{value:(_vm.selectedDisabledOrderSources),callback:function ($$v) {_vm.selectedDisabledOrderSources=$$v},expression:"selectedDisabledOrderSources"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('catalogCateg.disabledOrderSourcesHelp')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.no_discount_allowed),callback:function ($$v) {_vm.$set(_vm.model, "no_discount_allowed", $$v)},expression:"model.no_discount_allowed"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.no_discount_allowed')))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.is_age_restrict),callback:function ($$v) {_vm.$set(_vm.model, "is_age_restrict", $$v)},expression:"model.is_age_restrict"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('catalogCateg.isAgeRestrict')))])],1),_vm._v(" "),(!this.isNew())?_c('div',{staticClass:"form-group"},[_vm._v("\n              "+_vm._s(_vm.$t('catalogCateg.deleteProducts'))+"\n              "),_c('button',{staticClass:"btn btn-danger btn-icon delete-prod mar-to--5 mar-lt-5",on:{"click":function($event){$event.preventDefault();_vm.deleteProducts()}}},[_c('i',{staticClass:"ti-trash"})])]):_vm._e(),_vm._v(" "),(_vm.has_charisma_location)?_c('div',{staticClass:"mar-bt-15"},[_c('h6',[_vm._v(_vm._s(_vm.$t('charisma.charismaInventory')))]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('general.administration')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.locations')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('general.actions')))])])]),_vm._v(" "),_c('tbody',[(!_vm.administrations || !_vm.administrations.length)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"3"}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.noAdministrationsAvailable'))+"\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.administrations && _vm.administrations.length && (!_vm.model.administrations || !_vm.model.administrations.length))?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"3"}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.setAdministration'))+"\n                    ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.model.administrations),function(row,index){return _c('tr',{key:index},[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(row.administration_id),expression:"row.administration_id"}],staticClass:"form-control",attrs:{"placeholder":_vm.$t('general.select')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(row, "administration_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.select')))]),_vm._v(" "),_vm._l((_vm.availableAdministrations(row.administration_id)),function(admin){return _c('option',{key:admin.id,domProps:{"value":admin.id}},[_vm._v("\n                          "+_vm._s(admin.name)+"\n                        ")])})],2),_vm._v(" "),(_vm.errors.has(("administration_id_" + index)))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                        "+_vm._s(_vm.getError(("administration_id_" + index)))+"\n                      ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('v-select',{attrs:{"options":_vm.locations,"multiple":"","label":"name","reduce":function (loc) { return loc.id; },"placeholder":_vm.$t('settingsOrdering.selectLocations')},model:{value:(row.location_ids),callback:function ($$v) {_vm.$set(row, "location_ids", $$v)},expression:"row.location_ids"}})],1),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-icon delete-prod mar-to--5 mar-lt-5",on:{"click":function($event){$event.preventDefault();_vm.removeRow(index)}}},[_c('i',{staticClass:"ti-trash"})])])])})],2)]),_vm._v(" "),(_vm.administrations && _vm.administrations.length && (!_vm.model.administrations || (_vm.model.administrations && _vm.model.administrations.length < _vm.administrations.length)))?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addRow($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.use_gestiune && _vm.model.selectedGestiuni)?[_c('br'),_vm._v(" "),_c('div',{staticClass:"mar-bt-15"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.locations')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('general.administration')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.locationsForGestiune),function(location,index){return _c('tr',{key:location.id},[_c('td',[_vm._v(_vm._s(location.name))]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.selectedGestiuni[location.true_id]),expression:"model.selectedGestiuni[location.true_id]"}],staticClass:"form-control",attrs:{"disabled":!_vm.gestiuni[location.true_id]},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.selectedGestiuni, location.true_id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(" "+_vm._s(_vm.$t('general.select'))+" ")]),_vm._v(" "),_vm._l((_vm.gestiuni[location.true_id] || []),function(admin){return _c('option',{key:admin._id,domProps:{"value":admin._id}},[_vm._v("\n                            "+_vm._s(admin.name)+"\n                          ")])})],2)])])}),_vm._v(" "),(!_vm.locationsForGestiune || !_vm.locationsForGestiune.length)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"2"}},[_vm._v("\n                        No Locations Available\n                      ")])]):_vm._e()],2)])]),_vm._v(" "),_c('br')]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('catalogProd.hideFromPlatforms')))]),_vm._v(" "),_c('v-select',{staticClass:"line-heigth-44",attrs:{"multiple":"","options":_vm.platforms,"label":"name","placeholder":_vm.$t('catalogProd.timeOptionsValues.none')},model:{value:(_vm.selectedPlatforms),callback:function ($$v) {_vm.selectedPlatforms=$$v},expression:"selectedPlatforms"}})],1)],2)])])])]),_vm._v(" "),_c('div',{staticClass:"card reward-card"},[_c('div',{staticClass:"section-header"},[_c('img',{staticClass:"section-header__icon",attrs:{"src":"/static/img/icons/points-sm.png"}}),_vm._v(" "),_c('h5',{staticClass:"section-header__title"},[_vm._v(_vm._s(_vm.$t('catalogProd.rewardPoints')))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p',{staticClass:"reward-card__help"},[_vm._v("\n        "+_vm._s(_vm.$t('catalogProd.numberOfYouNeedToSpend', { currency: _vm.currency }))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"reward-card__control"},[_c('span',[_vm._v("1 "+_vm._s(_vm.currency)+" =")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.monetary_conversion),expression:"model.monetary_conversion"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"0.1","name":"monetary_conversion"},domProps:{"value":(_vm.model.monetary_conversion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "monetary_conversion", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('catalogProd.points')))])])])]),_vm._v(" "),(_vm.sortProductMethod == 'custom' && !_vm.isNew())?_c('div',{staticClass:"card"},[_c('div',{staticClass:"section-header"},[_c('h5',{staticClass:"section-header__title"},[_vm._v(_vm._s(_vm.$t('general.customSort')))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('table',{ref:"sortableTable",staticClass:"table mar-lt-15",staticStyle:{"width":"50%"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"30%"}},[_vm._v(_vm._s(_vm.$t('general.sortOrder')))]),_vm._v(" "),_c('th',{attrs:{"width":"70%"}},[_vm._v(_vm._s(_vm.$t('catalogCateg.name')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.tableData),function(item,index){return _c('tr',{key:'product-sort-' + item.id,staticClass:"sortableRow"},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.sort_order),expression:"item.sort_order"}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"1000","placeholder":_vm.$t('general.sortOrder'),"step":"1"},domProps:{"value":(item.sort_order)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "sort_order", $event.target.value)},function($event){_vm.onSortOrderInput(item)}],"keypress":function($event){_vm.onlyDigits($event)},"click":function($event){_vm.selectInputText($event)}}})]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(item.name)+"\n                "),(item.is_secondary == 1 || item.is_secondary === true)?_c('span',{staticClass:"text-muted",staticStyle:{"font-size":"12px","margin-left":"6px"}},[_vm._v("("+_vm._s(_vm.$t('catalogCateg.secondaryMember'))+")")]):_vm._e()])])}))])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "va9p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ve+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ManagementSuppliersAdd_vue__ = __webpack_require__("TvcY");










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementSuppliersAdd: __WEBPACK_IMPORTED_MODULE_6__ManagementSuppliersAdd_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      selectedVatNumber: null,
      selectedLocationId: '',
      selectedLocation: null,
      vatNumber: null,
      editMode: false,
      supplier: {
        companyName: '',
        abbreviation: '',
        CUI: '',
        registrationNumber: '',
        email: '',
        address: '',
        bank: '',
        IBAN: '',
        dueDays: null
      },
      searchQuery: ''
    };
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  watch: {
    selectedLocationId: function selectedLocationId(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    selectedVatNumber: function selectedVatNumber(newVat) {
      this.selectedVatNumber = newVat;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },

  computed: {
    filteredSuppliers: function filteredSuppliers() {
      var _this = this;

      if (!this.searchQuery) {
        return this.tableData;
      }

      return this.tableData.filter(function (supplier) {
        return supplier.distributorName.toLowerCase().includes(_this.searchQuery.toLowerCase());
      });
    }
  },
  methods: {
    onSearch: function onSearch() {
      if (!this.selectedVatNumber) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectateaza locatiați după cod TVA',
          confirmButtonText: 'OK'
        });

        this.tableData = [];
        this.totalItems = 0;
        this.currentPage = 1;

        return;
      }

      this.getSuppliers();
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.getSuppliers(this.currentPage, this.pageSize);
    },
    openAddSupplierModal: function openAddSupplierModal() {
      this.editMode = false;
      this.supplier = {
        companyName: '',
        abbreviation: '',
        CUI: '',
        email: '',
        registrationNumber: '',
        address: '',
        bank: '',
        IBAN: '',
        dueDays: null,
        id: null,
        _rev: null
      };
      this.$modal.show('addSupplierModal');
    },
    editRow: function editRow(row) {
      this.editMode = true;
      this.supplier = this.mapSupplierRowToForm(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, row, {
        vatNumber: row.vatNumber || this.selectedVatNumber || ''
      }));
      this.$modal.show('addSupplierModal');
    },
    mapSupplierRowToForm: function mapSupplierRowToForm() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return {
        companyName: row.companyName || row.distributorName || row.name || '',
        abbreviation: row.abbreviation || '',
        CUI: row.CUI || row.cui || row.supplierVatNumber || '',
        email: row.email || '',
        registrationNumber: row.registrationNumber || '',
        address: row.address || '',
        bank: row.bank || '',
        IBAN: row.IBAN || row.iban || '',
        dueDays: row.dueDays != null ? row.dueDays : null,
        id: row.id || row._id || null,
        _rev: row._rev || null,
        externalLocationId: row.externalLocationId || null,
        vatNumber: row.vatNumber || this.selectedVatNumber || null
      };
    },
    getSuppliers: function getSuppliers() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.tableData = [];
                _this2.totalItems = 0;
                _this2.currentPage = 1;

                _context.prev = 3;

                if (_this2.companyID) {
                  _context.next = 7;
                  break;
                }

                console.error('Company ID is missing');
                return _context.abrupt('return');

              case 7:
                if (_this2.selectedVatNumber) {
                  _context.next = 10;
                  break;
                }

                console.warn('VAT number is missing. Skipping product fetch.');
                return _context.abrupt('return');

              case 10:

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Se încarcă...',
                  text: 'Așteaptă încărcarea datelor',
                  allowOutsideClick: false,
                  didOpen: function didOpen() {
                    __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.showLoading();
                  }
                });

                clearTimeout(_this2.loadingTimeout);
                _this2.loadingTimeout = setTimeout(function () {
                  _this2.loading = true;
                }, 100);

                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/suppliers?externalCompanyId=' + _this2.companyID + '&page=' + page + '&limit=' + pageSize;


                if (_this2.selectedVatNumber) {
                  url += '&vatNumber=' + encodeURIComponent(_this2.selectedVatNumber);
                }

                _context.next = 17;
                return fetch(url);

              case 17:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 20;
                  break;
                }

                throw new Error('Error fetching suppliers');

              case 20:
                _context.next = 22;
                return response.json();

              case 22:
                data = _context.sent;

                if (!(!data.suppliers || !Array.isArray(data.suppliers))) {
                  _context.next = 25;
                  break;
                }

                throw new Error('Invalid data format: suppliers not found');

              case 25:

                clearTimeout(_this2.loadingTimeout);
                _this2.loading = false;
                _this2.totalItems = data.total || 0;
                _this2.currentPage = data.currentPage || page;
                _this2.pageSize = data.pageSize || pageSize;

                _this2.tableData = data.suppliers.map(function (supplier) {
                  return {
                    id: supplier._id,
                    _rev: supplier._rev,
                    distributorName: supplier.name,
                    address: supplier.address || '',
                    cui: supplier.supplierVatNumber || '',
                    supplierVatNumber: supplier.supplierVatNumber || '',
                    email: supplier.email || '',
                    companyName: supplier.name || '',
                    abbreviation: supplier.abbreviation || '',
                    registrationNumber: supplier.registrationNumber || '',
                    bank: supplier.bank || '',
                    IBAN: supplier.IBAN || supplier.iban || '',
                    dueDays: supplier.dueDays != null ? supplier.dueDays : null,
                    vatNumber: supplier.vatNumber || _this2.selectedVatNumber || '',
                    externalLocationId: supplier.externalLocationId || null
                  };
                });

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.close();
                _context.next = 38;
                break;

              case 34:
                _context.prev = 34;
                _context.t0 = _context['catch'](3);

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.close();
                console.error('Error fetching suppliers:', _context.t0);

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[3, 34]]);
      }))();
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var confirm, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (id) {
                  _context2.next = 3;
                  break;
                }

                console.error('Missing product ID for deletion.');
                return _context2.abrupt('return');

              case 3:
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Ești sigur?',
                  text: 'Furnizorul va fi șters definitiv.',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Da, șterge',
                  cancelButtonText: 'Anulează'
                });

              case 5:
                confirm = _context2.sent;

                if (confirm) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return');

              case 8:
                _context2.prev = 8;
                _context2.next = 11;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/remove', {
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    type: 'supplier',
                    id: id,
                    externalCompanyId: _this3.companyID
                  })
                });

              case 11:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 14;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 14:
                _context2.next = 16;
                return response.json();

              case 16:
                data = _context2.sent;

                console.log('Supplier deleted successfully:', data);

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Succes',
                  text: 'Furnizorul a fost șters cu succes.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this3.getSuppliers();
                _context2.next = 26;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2['catch'](8);

                console.error('Error deleting supplier:', _context2.t0);

                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o eroare la ștergerea furnizorului.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[8, 22]]);
      }))();
    }
  }
});

/***/ }),

/***/ "vgdn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCoupons.selectCoupon')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.coupons,"label":"selectLabel","placeholder":_vm.$t('marketingCoupons.noCoupon')},model:{value:(_vm.selectedCoupon),callback:function ($$v) {_vm.selectedCoupon=$$v},expression:"selectedCoupon"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingCoupons.selectCouponHelp')))])],1),_vm._v(" "),(_vm.selectedCoupon)?_c('div',{staticClass:"box coupon-select-step__summary"},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('marketingCoupons.code'))+":")]),_vm._v(" "),(_vm.selectedCoupon.coupon_has_multiple_codes)?[_vm._v(_vm._s(_vm.$t('marketingCoupons.multipleCodes'))+" ("+_vm._s(_vm.selectedCoupon.coupons_codes_count || 0)+")")]:[_vm._v(_vm._s(_vm.selectedCoupon.coupon_code))]],2),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('marketingCoupons.discount'))+":")]),_vm._v(" "),(_vm.selectedCoupon.type === 'FREE_PRODUCT')?[_vm._v(_vm._s(_vm.$t('marketingCoupons.freeProduct')))]:[_vm._v(_vm._s(_vm.selectedCoupon.discount)+" "+_vm._s(_vm.selectedCoupon.type === 'FIXED' ? _vm.currency : '%'))]],2),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('marketingCoupons.validFromTo'))+":")]),_vm._v("\n        "+_vm._s(_vm.formatDate(_vm.selectedCoupon.datetime_validfrom))+" - "+_vm._s(_vm.formatDate(_vm.selectedCoupon.datetime_validto))+"\n      ")]),_vm._v(" "),(!_vm.selectedCoupon.active)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('marketingCoupons.couponInactive')))]):_vm._e(),_vm._v(" "),(_vm.isOutsideCampaign)?_c('p',{staticClass:"text-warning"},[_vm._v(_vm._s(_vm.$t('marketingCoupons.couponOutsideCampaign')))]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "viQu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerView_vue__ = __webpack_require__("QJOo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7528fb56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerView_vue__ = __webpack_require__("rLJo");
function injectStyle (ssrContext) {
  __webpack_require__("J7qd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7528fb56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vig9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vizI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentGroupsForm_vue__ = __webpack_require__("9KLf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2894df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentGroupsForm_vue__ = __webpack_require__("Xxll");
function injectStyle (ssrContext) {
  __webpack_require__("DCiy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentGroupsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2894df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentGroupsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vkzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      managementRoutes: [{ path: '/management/sidebar?tab=dashboard', key: 'dashboard', right: 'can_access_dashboard' }, { path: '/management/sidebar?tab=outputs', key: 'outputs', right: 'can_access_gestiune' }, { path: '/management/sidebar?tab=entries', key: 'entries', right: 'can_generate_nir' }, { path: '/management/sidebar?tab=stocks', key: 'stocks', right: 'can_access_gestiune' }, { path: '/management/sidebar?tab=production', key: 'production', right: 'can_access_gestiune' }, { path: '/management/sidebar?tab=reteta', key: 'reteta', right: 'can_access_gestiune' }, { path: '/management/sidebar?tab=ordersSuppliers', key: 'ordersSuppliers', right: 'can_access_supplier_orders' }, { path: '/management/sidebar?tab=reports', key: 'reports', right: 'can_access_reports' }, { path: '/management/sidebar?tab=settings', key: 'settings', right: 'can_access_settings' }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.companyID = _this.$session.get('selectedCompany');

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getImageForRoute: function getImageForRoute(routeKey) {
      var images = {
        'dashboard': 'static/img/dispatch-settings.png',
        'outputs': 'static/img/dispatch-settings.png',
        'stocks': 'static/img/dispatch-settings.png',
        'entries': 'static/img/dispatch-settings.png',
        'production': 'static/img/dispatch-settings.png',
        'reteta': 'static/img/dispatch-settings.png',
        'ordersSuppliers': 'static/img/dispatch-settings.png',
        'reports': 'static/img/dispatch-settings.png',
        'settings': 'static/img/dispatch-settings.png'
      };
      return images[routeKey] || 'static/img/default.jpg';
    },
    getBoxColor: function getBoxColor(index) {
      var colors = ['#3AB7CD', '#3AB7CD', '#674BD2', '#FF6B6B', '#FFD93D', '#17B086', '#FF6B6B', '#FFD93D', '#FFD93D', '#FFD93D', '#FFD93D', '#17B086'];
      return colors[index] || '#FFFFFF';
    }
  }
});

/***/ }),

/***/ "vnQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementCasaRegister_vue__ = __webpack_require__("bJkY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12206014_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementCasaRegister_vue__ = __webpack_require__("Ze7l");
function injectStyle (ssrContext) {
  __webpack_require__("kYML")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12206014"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementCasaRegister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12206014_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementCasaRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "voac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"floating-button",on:{"click":_vm.openNewPage}},[_c('svg',{staticClass:"icon",attrs:{"viewBox":"0 0 60 60"}},[_c('path',{staticClass:"path1",attrs:{"d":"M6.90917448,41.3294845 C6.83769725,41.212437 6.76324712,41.0951946 6.68573397,40.9777778 L6.76289975,41.0481461 C4.99532213,37.5958143 4,33.6955382 4,29.5666667 C4,15.4465866 15.6405965,4 30,4 C44.3594035,4 56,15.4465866 56,29.5666667 C56,43.6867468 44.3594035,55.1333333 30,55.1333333 C26.3565321,55.1333333 22.8881035,54.3963917 19.7404572,53.0658224 C-3.68800108,60.6255746 12.4215438,52.3468261 7.38027718,42.1818397 C7.21794615,41.9009974 7.06086812,41.616836 6.90917448,41.3294845 Z","fill":"white"}}),_vm._v(" "),_c('path',{staticClass:"path2",attrs:{"d":"M30,18 C23.9365932,18 19,22.6462054 19,28.3529412 L19,31.4889704 L19,32.1176471 C19,33.1576471 19.895,34 21,34 L23,34 L23,29.2941176 C23,28.2730456 22.1357546,27.4471736 21.0585938,27.4172791 C21.5517466,23.1712651 25.354019,19.8823529 30,19.8823529 C34.645981,19.8823529 38.448253,23.1712651 38.941406,27.4172791 C37.864245,27.4471736 37,28.2730456 37,29.2941176 L37,34 L39,34 C40.105,34 41,33.1576471 41,32.1176471 L41,29.2941176 L41,28.3529412 C41,22.6462054 36.063407,18 30,18 Z M37,38 L37,38.8333333 C37,39.7638883 36.116666,40.5 35,40.5 L31.728516,40.5 C31.3718826,39.9852418 30.713268,39.6677177 30,39.6666667 C28.8954305,39.6666667 28,40.4128588 28,41.3333333 C28,42.2538079 28.8954305,43 30,43 C30.713966,42.9995293 31.3734861,42.6819275 31.730469,42.1666667 L35,42.1666667 C37.197334,42.1666667 39,40.664445 39,38.8333333 L39,38 L37,38 Z","fill":"white"}})]),_vm._v("\n  "+_vm._s(_vm.$t('newsletterCard.helpVideoSupport'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vrDl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RSystemSetup_vue__ = __webpack_require__("3oa1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_FileInput_vue__ = __webpack_require__("lcot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Inputs_ImageInput_vue__ = __webpack_require__("575J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Inputs_DisplayQr_vue__ = __webpack_require__("+65S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Inputs_ImportProductsInput_vue__ = __webpack_require__("s+lY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Inputs_ImportProductsLegacyInput_vue__ = __webpack_require__("21Qg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Inputs_ArchiveInput_vue__ = __webpack_require__("uXu5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Inputs_DisplayQrApp_vue__ = __webpack_require__("Vqwd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Inputs_ProductCrossSellPicker_vue__ = __webpack_require__("57yd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DeliveryMethods_vue__ = __webpack_require__("aS4d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_css__);










var _components;

















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);

var COUNTRIES_LIST = [{
  name: 'România',
  counties: [{ code: 'AB', name: 'Alba' }, { code: 'AR', name: 'Arad' }, { code: 'AG', name: 'Argeș' }, { code: 'BC', name: 'Bacău' }, { code: 'BH', name: 'Bihor' }, { code: 'BN', name: 'Bistrița-Năsăud' }, { code: 'BT', name: 'Botoșani' }, { code: 'BR', name: 'Brăila' }, { code: 'BV', name: 'Brașov' }, { code: 'B', name: 'București' }, { code: 'BZ', name: 'Buzău' }, { code: 'CS', name: 'Caraș-Severin' }, { code: 'CL', name: 'Călărași' }, { code: 'CJ', name: 'Cluj' }, { code: 'CT', name: 'Constanța' }, { code: 'CV', name: 'Covasna' }, { code: 'DB', name: 'Dâmbovița' }, { code: 'DJ', name: 'Dolj' }, { code: 'GL', name: 'Galați' }, { code: 'GR', name: 'Giurgiu' }, { code: 'GJ', name: 'Gorj' }, { code: 'HR', name: 'Harghita' }, { code: 'HD', name: 'Hunedoara' }, { code: 'IL', name: 'Ialomița' }, { code: 'IS', name: 'Iași' }, { code: 'IF', name: 'Ilfov' }, { code: 'MM', name: 'Maramureș' }, { code: 'MH', name: 'Mehedinți' }, { code: 'MS', name: 'Mureș' }, { code: 'NT', name: 'Neamț' }, { code: 'OT', name: 'Olt' }, { code: 'PH', name: 'Prahova' }, { code: 'SM', name: 'Satu Mare' }, { code: 'SJ', name: 'Sălaj' }, { code: 'SB', name: 'Sibiu' }, { code: 'SV', name: 'Suceava' }, { code: 'TR', name: 'Teleorman' }, { code: 'TM', name: 'Timiș' }, { code: 'TL', name: 'Tulcea' }, { code: 'VS', name: 'Vaslui' }, { code: 'VL', name: 'Vâlcea' }, { code: 'VN', name: 'Vrancea' }]
}, { name: 'Albania', counties: [] }, { name: 'Andorra', counties: [] }, { name: 'Austria', counties: [] }, { name: 'Belarus', counties: [] }, { name: 'Belgia', counties: [] }, { name: 'Bosnia și Herțegovina', counties: [] }, { name: 'Bulgaria', counties: [] }, { name: 'Croația', counties: [] }, { name: 'Cehia', counties: [] }, { name: 'Cipru', counties: [] }, { name: 'Danemarca', counties: [] }, { name: 'Elveția', counties: [] }, { name: 'Estonia', counties: [] }, { name: 'Finlanda', counties: [] }, { name: 'Franța', counties: [] }, { name: 'Germania', counties: [] }, { name: 'Grecia', counties: [] }, { name: 'Irlanda', counties: [] }, { name: 'Islanda', counties: [] }, { name: 'Italia', counties: [] }, { name: 'Kosovo', counties: [] }, { name: 'Letonia', counties: [] }, { name: 'Liechtenstein', counties: [] }, { name: 'Lituania', counties: [] }, { name: 'Luxemburg', counties: [] }, { name: 'Macedonia de Nord', counties: [] }, { name: 'Malta', counties: [] }, { name: 'Moldova', counties: [] }, { name: 'Monaco', counties: [] }, { name: 'Muntenegru', counties: [] }, { name: 'Norvegia', counties: [] }, { name: 'Olanda', counties: [] }, { name: 'Polonia', counties: [] }, { name: 'Portugalia', counties: [] }, { name: 'Regatul Unit', counties: [] }, { name: 'Rusia', counties: [] }, { name: 'San Marino', counties: [] }, { name: 'Serbia', counties: [] }, { name: 'Slovacia', counties: [] }, { name: 'Slovenia', counties: [] }, { name: 'Spania', counties: [] }, { name: 'Suedia', counties: [] }, { name: 'Turcia', counties: [] }, { name: 'Ucraina', counties: [] }, { name: 'Ungaria', counties: [] }, { name: 'Vatican', counties: [] }];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    RSystemSetup: __WEBPACK_IMPORTED_MODULE_9__RSystemSetup_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'FileInput', __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_FileInput_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ImageInput', __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Inputs_ImageInput_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'DisplayQr', __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Inputs_DisplayQr_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'DisplayQrApp', __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Inputs_DisplayQrApp_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ImportProductsInput', __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Inputs_ImportProductsInput_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ImportProductsLegacyInput', __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Inputs_ImportProductsLegacyInput_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ArchiveInput', __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Inputs_ArchiveInput_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'ProductCrossSellPicker', __WEBPACK_IMPORTED_MODULE_20_src_components_UIComponents_Inputs_ProductCrossSellPicker_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'DeliveryMethods', __WEBPACK_IMPORTED_MODULE_21__DeliveryMethods_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    'location.integrators_department_id': 'clearIntegratorsPrinterErrorWhenOptional',
    'location.integrators_tax_vat_amount': 'clearIntegratorsPrinterErrorWhenOptional',
    'location.other_taxes_vat_printer_id': 'clearOtherTaxesVatPrinterErrorWhenOptional',
    'location.donation_vat_printer_id': 'clearDonationVatPrinterErrorWhenOptional',
    companyLoyaltyInUse: function companyLoyaltyInUse(enabled) {
      if (!enabled && this.location) {
        this.location.kiosk_allow_fidelities = false;
      }
    }
  },
  data: function data() {
    return {
      rSystemBusy: false,
      id: null,
      location: null,
      selectedHiddenPlatforms: [],
      locationPlatforms: [{ id: 1, name: this.$t('addOrder.application') }, { id: 2, name: 'Website' }],
      currentSection: 'start',
      apiUrl: '',
      model: this.value || this.modeldata,
      countries: [],
      sortMethodsList: [],
      states: [],
      taxes: [],
      vat: [],
      countriesList: COUNTRIES_LIST,
      topCategories: null,
      displayIntegrationCard: false,
      currency: this.getCurrencySymbol((this.$session.get('selectedCompanyData') || {}).currency_iso),
      showDelete: false,
      boltStatus: false,
      boltSchedule: [],
      allLocations: [],
      inv_fiscal_code_disabled_field: false,
      modelValidate: {
        name: { required: true },
        email: { required: true },
        phone: { required: true },
        number: { required: true },
        street: { required: true },
        city: { required: true },
        state: { required: true },
        country: { required: true },
        working_hours: { required: true },
        paymentGroups: { required: true }
      },
      timeFormat: 'HH:mm',
      dateFormat: 'DD/MM/YYYY',
      pickerNames: ['date_from', 'date_to'],
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59',
        format: this.timeFormat
      },
      pickerOptionsReport: {
        start: '01:00',
        step: '00:30',
        end: '23:59',
        format: this.timeFormat
      },
      showUpdateWarning: false,
      languages: (this.$session.get('defaultData') || {}).available_languages || [],
      windowHeight: 0,
      navbarHeaderHeight: 0,
      navButtonsHeight: 0,
      pageTopHeight: 76,
      loading: true,
      initialLoadError: false,
      initialLoadRequests: {
        taxes: false,
        location: false,
        paymentGroups: false,
        locations: false
      },
      glovoStatus: false,
      paymentGroups: null,
      deliveryMethods: [],
      menuType: [{ 'id': 0, 'label': 'PDF' }, { 'id': 1, 'label': 'Dynamic' }],
      defaultData: [],
      hasLocationErrors: false,
      hasPaymentGroupErrors: false,
      hasVatErrors: false,
      hasDeliveryMethodsErrors: false,
      nexusFrom: null,
      nexusTo: null,
      previousPosnetDate: null,
      previousPosnetSwitchState: null,
      woltSchedule: [],
      woltStatus: false,
      locationPriceProfiles: [],
      selectedPriceProfileId: null,
      locationHasProducts: false,
      creatingDefaultPriceProfile: false
    };
  },

  updated: function updated() {},
  computed: {
    companyLoyaltyInUse: function companyLoyaltyInUse() {
      var companyData = this.$session.get('selectedCompanyData') || {};
      return !!(companyData.loyalty_in_use === true || companyData.loyalty_in_use === 1 || companyData.loyalty_in_use === '1');
    },
    downloadImportHref: function downloadImportHref() {
      return this.apiUrl + 'download-import-form?token=' + this.$session.get('token');
    },
    downloadLegacyImportHref: function downloadLegacyImportHref() {
      return this.apiUrl + 'download-import-form-legacy?token=' + this.$session.get('token');
    },
    exportProductsHref: function exportProductsHref() {
      if (!this.canExportProducts) {
        return null;
      }
      return this.apiUrl + 'import-location/products/export?token=' + this.$session.get('token') + '&location_id=' + encodeURIComponent(this.location.true_id) + '&company_id=' + encodeURIComponent(this.$session.get('selectedCompany')) + '&price_profiles_id=' + encodeURIComponent(this.selectedPriceProfileId);
    },
    exportImagesHref: function exportImagesHref() {
      if (!this.canExportImages) {
        return null;
      }
      return this.apiUrl + 'import-location/products/export-images?token=' + this.$session.get('token') + '&location_id=' + encodeURIComponent(this.location.true_id) + '&company_id=' + encodeURIComponent(this.$session.get('selectedCompany'));
    },
    canExportProducts: function canExportProducts() {
      return !!(this.location && this.location.true_id && this.selectedPriceProfileId && this.locationHasProducts);
    },
    canExportImages: function canExportImages() {
      return !!(this.location && this.location.true_id && this.locationHasProducts);
    },
    exportDisabledReason: function exportDisabledReason() {
      if (!this.locationHasProducts) {
        return this.$t('productImport.noProductsForExport');
      }
      if (!this.selectedPriceProfileId) {
        return this.$t('productImport.priceProfileRequired');
      }
      return '';
    },
    exportImagesDisabledReason: function exportImagesDisabledReason() {
      if (!this.locationHasProducts) {
        return this.$t('productImport.noProductsForExport');
      }
      return '';
    },
    selectedCountry: function selectedCountry() {
      var _this = this;

      return this.countriesList.find(function (c) {
        return c.name === _this.location.inv_country;
      }) || null;
    },
    isNexusDatesValid: function isNexusDatesValid() {
      return this.nexusFrom && this.nexusTo && this.nexusFrom !== null && this.nexusTo !== null;
    },
    boltEndTimeOptions: function boltEndTimeOptions() {
      var out = [];
      for (var hour = 0; hour < 24; hour++) {
        for (var minute = 0; minute < 60; minute += 15) {
          if (hour === 23 && minute > 55) break;
          var h = String(hour).padStart(2, '0');
          var m = String(minute).padStart(2, '0');
          out.push(h + ':' + m);
        }
      }
      if (!out.includes('23:59')) {
        out.push('23:59');
      }
      return out;
    },
    integratorsTaxVatPrinterRules: function integratorsTaxVatPrinterRules() {
      if (!this.location) {
        return {};
      }
      var dept = this.location.integrators_department_id;
      var amt = this.location.integrators_tax_vat_amount;
      var deptFilled = dept !== null && dept !== undefined && dept !== '';
      var amtFilled = amt !== null && amt !== undefined && amt !== '';
      if (!deptFilled || !amtFilled) {
        return {};
      }
      return { required: true, numeric: true, min_value: 0, max_value: 10 };
    },
    otherTaxesVatPrinterRules: function otherTaxesVatPrinterRules() {
      var val = this.location && this.location.other_taxes_vat_printer_id;
      var filled = val !== null && val !== undefined && val !== '';
      if (!filled) {
        return {};
      }
      return { numeric: true, min_value: 0, max_value: 10 };
    },
    donationVatPrinterRules: function donationVatPrinterRules() {
      var val = this.location && this.location.donation_vat_printer_id;
      var filled = val !== null && val !== undefined && val !== '';
      if (!filled) {
        return {};
      }
      return { numeric: true, min_value: 0, max_value: 10 };
    }
  },
  created: function created() {
    var _this2 = this;

    this.apiUrl = "https://gatewaydev.taptasty.com/";
    var pageRoute = this.route && this.route.params ? this.route : this.$route;
    this.id = pageRoute && pageRoute.params && pageRoute.params.id || null;
    this.loadLocationForm();

    var data2 = {
      token: this.$session.get('token'),
      company_id: this.$session.get('selectedCompany')
    };
    this.apiRequest('/topcategory', 'GET', data2, function (topCatResp) {
      if (topCatResp.status === true) {
        _this2.topCategories = topCatResp.data;
      }
    });

    this.$bus.$on('upload-location-image', function (payload) {
      _this2.location[payload.field] = payload.file;
    });

    this.$bus.$on('remove-upload-location-image', function (payload) {
      _this2.location[payload.field] = null;
    });

    this.$bus.$on('delivery-methods-loaded', function () {
      _this2.checkInitialLoadComplete();
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.doHeightCalculation();

      window.addEventListener('resize', function () {
        _this3.doHeightCalculation();
      });
    });
  },

  methods: {
    loadLocationForm: function loadLocationForm() {
      var _this4 = this;

      this.loading = true;
      this.initialLoadError = false;
      this.initialLoadRequests = { taxes: false, location: false, paymentGroups: false, locations: false };
      this.defaultData = this.$session.get('defaultData') || {};
      this.countries = this.defaultData.countries || [];
      this.getLocations();
      this.getLocationData();
      this.getData();
      this.requestInitialData('taxes', '/settings/taxes', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, function (response) {
        _this4.taxes = response.data.taxes;
        _this4.vat = response.data.vat;
      });
    },
    requestInitialData: function requestInitialData(name, url, data, hydrate) {
      var _this5 = this;

      var fail = function fail() {
        _this5.initialLoadError = true;
        _this5.markRequestComplete(name);
      };
      try {
        this.apiRequest(url, 'GET', data, function (response) {
          try {
            if (!response || response.status !== true || response.data == null) {
              _this5.initialLoadError = true;
              return;
            }
            hydrate(response);
          } catch (error) {
            _this5.initialLoadError = true;
          } finally {
            _this5.markRequestComplete(name);
          }
        });
      } catch (error) {
        fail();
      }
    },
    onCountryChange: function onCountryChange() {
      this.location.inv_county = '';
    },
    checkInitialLoadComplete: function checkInitialLoadComplete() {
      var allComplete = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.initialLoadRequests).every(function (status) {
        return status === true;
      });
      if (allComplete) {
        this.loading = false;
      }
    },
    markRequestComplete: function markRequestComplete(requestName) {
      this.initialLoadRequests[requestName] = true;
      this.checkInitialLoadComplete();
    },
    redirectToWolt: function redirectToWolt() {
      var _this6 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token')
      };

      this.apiRequest('/wolt/integrate-location/' + this.location.wolt_company_id, 'POST', data, function (response) {
        if (response.status) {
          window.location.href = response.data;
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this6.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
        }
        _this6.loading = false;
      });
    },
    updateWoltMenu: function updateWoltMenu() {
      var _this7 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        wolt_company_id: this.location.wolt_company_id
      };
      this.apiRequest('/wolt/export-menu', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this7.$t('bolt.sync'),
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this7.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
        }
        _this7.loading = false;
      });
    },
    handleWoltStatus: function handleWoltStatus() {
      var _this8 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        wolt_company_id: this.location.wolt_company_id,
        active: this.woltStatus
      };
      this.apiRequest('/wolt/toggle-location-status', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this8.$t('bolt.sync'),
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this8.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
          _this8.woltStatus = !_this8.woltStatus;
        }
        _this8.loading = false;
      });
    },
    updateWoltSchedule: function updateWoltSchedule() {
      var _this9 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        wolt_company_id: this.location.wolt_company_id,
        schedule: this.woltSchedule
      };
      this.apiRequest('/wolt/update-schedule', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this9.$t('bolt.sync'),
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this9.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
        }
        _this9.loading = false;
      });
    },
    addMoreWoltIntervals: function addMoreWoltIntervals(dayIdx) {
      this.woltSchedule[dayIdx].intervals.push({
        opening_time: null,
        closing_time: null
      });
    },
    deleteWoltIntervals: function deleteWoltIntervals(intervalKey, dayIdx) {
      this.woltSchedule[dayIdx].intervals.splice(intervalKey, 1);
    },
    handleBoltStatus: function handleBoltStatus() {
      var _this10 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        bolt_company_id: this.location.bolt_company_id,
        active: this.boltStatus
      };

      this.apiRequest('/bolt/handle-open', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this10.$t('bolt.sync'),
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this10.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
          _this10.boltStatus = !_this10.boltStatus;
        }
        _this10.loading = false;
      });
    },
    updateBoltSchedule: function updateBoltSchedule() {
      var _this11 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        bolt_company_id: this.location.bolt_company_id,
        schedule: this.boltSchedule
      };

      this.apiRequest('/bolt/update-schedule', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this11.$t('bolt.sync'),
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this11.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
        }
        _this11.loading = false;
      });
    },
    updateBoltMenu: function updateBoltMenu() {
      var _this12 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        bolt_company_id: this.location.bolt_company_id
      };

      this.apiRequest('/bolt/push-menu', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this12.$t('bolt.sync'),
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this12.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
        }
        _this12.loading = false;
      });
    },
    handlePosnetReportToggle: function handlePosnetReportToggle() {
      var _this13 = this;

      var currentState = this.location.posnet_company_show_report;

      this.previousPosnetSwitchState = currentState;

      if (currentState === false) {
        this.loading = true;
        var id = this.location.posnet_company_id;
        var _reportDate = this.location.posnet_company_report_date || this.getTodayDate();
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          active: false,
          report_date: _reportDate
        };

        this.apiRequest('/posnet/v2/enable-report/' + id, 'POST', data, function (response) {
          if (response.status) {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              text: _this13.$t('general.success'),
              type: 'success',
              showConfirmButton: false
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              text: _this13.$t('general.error'),
              type: 'error',
              showConfirmButton: false
            });

            _this13.$set(_this13.location, 'posnet_company_show_report', true);
          }
          _this13.loading = false;
        });
        return;
      }

      var reportDate = this.location.posnet_company_report_date;

      if (!reportDate || reportDate === '') {
        var yesterdayDate = this.getYesterdayDate();
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          text: this.$t('posnet.confirmActivateReportAutomated', { date: yesterdayDate }) || 'Are you sure you want to activate the report in automated mode for yesterday\'s date (' + yesterdayDate + ')?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.no')
        }).then(function (result) {
          if (result) {
            _this13.loading = true;
            var _id = _this13.location.posnet_company_id;
            var data = {
              token: _this13.$session.get('token'),
              location_id: _this13.location.true_id,
              company_id: _this13.location.company_id,
              active: _this13.location.posnet_company_show_report,
              report_date: null
            };

            _this13.apiRequest('/posnet/v2/enable-report/' + _id, 'POST', data, function (response) {
              if (response.status) {
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  text: _this13.$t('general.success'),
                  type: 'success',
                  showConfirmButton: false
                });
                _this13.previousPosnetDate = null;
              } else {
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  text: _this13.$t('general.error'),
                  type: 'error',
                  showConfirmButton: false
                });

                __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this13.location, 'posnet_company_show_report', false);
              }
              _this13.loading = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this13.location, 'posnet_company_show_report', false);
          }
        }).catch(function () {
          _this13.$set(_this13.location, 'posnet_company_show_report', false);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          text: this.$t('posnet.confirmActivateReport', { date: reportDate }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.no')
        }).then(function (result) {
          if (result) {
            _this13.loading = true;
            var _id2 = _this13.location.posnet_company_id;
            var data = {
              token: _this13.$session.get('token'),
              location_id: _this13.location.true_id,
              company_id: _this13.location.company_id,
              active: _this13.location.posnet_company_show_report,
              report_date: reportDate
            };

            _this13.apiRequest('/posnet/v2/enable-report/' + _id2, 'POST', data, function (response) {
              if (response.status) {
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  text: _this13.$t('general.success'),
                  type: 'success',
                  showConfirmButton: false
                });
                _this13.previousPosnetDate = reportDate;
              } else {
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  text: _this13.$t('general.error'),
                  type: 'error',
                  showConfirmButton: false
                });

                __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this13.location, 'posnet_company_show_report', false);
              }
              _this13.loading = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this13.location, 'posnet_company_show_report', false);
            console.log('this.location', _this13.location.posnet_company_show_report);
          }
        }).catch(function () {
          _this13.$set(_this13.location, 'posnet_company_show_report', false);
        });
      }
    },
    handlePosnetDateFocus: function handlePosnetDateFocus() {
      if (this.location.posnet_company_report_date) {
        this.previousPosnetDate = this.location.posnet_company_report_date;
      }
    },
    handlePosnetDateVisible: function handlePosnetDateVisible(visible) {
      if (visible && this.location.posnet_company_report_date) {
        this.previousPosnetDate = this.location.posnet_company_report_date;
      }
    },
    handlePosnetDateChange: function handlePosnetDateChange(newDate) {
      var _this14 = this;

      var self = this;

      var previousDate = this.previousPosnetDate;

      if (newDate === null || newDate === '') {
        if (this.location.posnet_company_show_report) {
          var yesterdayDate = this.getYesterdayDate();
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: this.$t('posnet.confirmActivateReportAutomated', { date: yesterdayDate }) || 'Are you sure you want to activate the report in automated mode for yesterday\'s date (' + yesterdayDate + ')?',
            type: 'question',
            showCancelButton: true,
            confirmButtonText: this.$t('general.yes'),
            cancelButtonText: this.$t('general.no')
          }).then(function (result) {
            if (result) {
              _this14.loading = true;
              var id = _this14.location.posnet_company_id;
              var data = {
                token: _this14.$session.get('token'),
                location_id: _this14.location.true_id,
                company_id: _this14.location.company_id,
                active: _this14.location.posnet_company_show_report,
                report_date: null
              };

              _this14.apiRequest('/posnet/v2/enable-report/' + id, 'POST', data, function (response) {
                if (response.status) {
                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                    text: _this14.$t('general.success'),
                    type: 'success',
                    showConfirmButton: false
                  });
                  self.previousPosnetDate = null;
                } else {
                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                    text: _this14.$t('general.error'),
                    type: 'error',
                    showConfirmButton: false
                  });

                  self.$set(self.location, 'posnet_company_report_date', previousDate);
                }
                _this14.loading = false;
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this14.location, 'posnet_company_report_date', previousDate);
            }
          }).catch(function () {
            _this14.$set(_this14.location, 'posnet_company_report_date', previousDate);
          });
        } else {
          this.previousPosnetDate = null;
        }
        return;
      }

      if (this.location.posnet_company_show_report && newDate) {
        if (!previousDate || newDate === previousDate) {
          if (!this.previousPosnetDate && newDate) {
            this.previousPosnetDate = newDate;
          }
          return;
        }

        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          text: this.$t('posnet.confirmActivateReport', { date: newDate }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.no')
        }).then(function (result) {
          if (result) {
            _this14.loading = true;
            var id = _this14.location.posnet_company_id;
            var data = {
              token: _this14.$session.get('token'),
              location_id: _this14.location.true_id,
              company_id: _this14.location.company_id,
              active: _this14.location.posnet_company_show_report,
              report_date: newDate
            };

            _this14.apiRequest('/posnet/v2/enable-report/' + id, 'POST', data, function (response) {
              if (response.status) {
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  text: _this14.$t('general.success'),
                  type: 'success',
                  showConfirmButton: false
                });
                self.previousPosnetDate = newDate;
              } else {
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                  text: _this14.$t('general.error'),
                  type: 'error',
                  showConfirmButton: false
                });

                self.$set(self.location, 'posnet_company_report_date', previousDate);
              }
              _this14.loading = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(_this14.location, 'posnet_company_report_date', previousDate);
          }
        }).catch(function () {
          _this14.$set(_this14.location, 'posnet_company_report_date', previousDate);
        });
      } else {
        if (newDate) {
          this.previousPosnetDate = newDate;
        }
      }
    },
    addMoreBoltIntervals: function addMoreBoltIntervals(dayIdx) {
      this.boltSchedule[dayIdx].intervals.push({
        start_at_minutes_from_midnight: null,
        stop_at_minutes_from_midnight: null
      });
    },
    deleteBoltIntervals: function deleteBoltIntervals(intervalKey, dayIdx) {
      this.boltSchedule[dayIdx].intervals.splice(intervalKey, 1);
    },
    createNexusOrders: function createNexusOrders() {
      var _this15 = this;

      if (!this.nexusFrom || !this.nexusTo) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          text: this.$t('validations.requiredField'),
          type: 'warning',
          showCancelButton: false
        });
        return;
      }
      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        start: this.nexusFrom,
        end: this.nexusTo
      };

      this.apiRequest('/nexus/send-orders', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Sincronizarea a inceput. Finalizarea poate dura cateva minute.',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Sincronizarea nu poate fi realizata',
            type: 'error',
            showCancelButton: false
          });
        }
        _this15.loading = false;
      });
    },
    cancelNexusOrders: function cancelNexusOrders() {
      var _this16 = this;

      if (!this.nexusFrom || !this.nexusTo) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          text: this.$t('validations.requiredField'),
          type: 'warning',
          showCancelButton: false
        });
        return;
      }
      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        start: this.nexusFrom,
        end: this.nexusTo
      };

      this.apiRequest('/nexus/cancel-orders', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Sincronizarea a inceput. Finalizarea poate dura cateva minute',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Sincronizarea nu poate fi realizata',
            type: 'error',
            showCancelButton: false
          });
        }
        _this16.loading = false;
      });
    },
    retryFailedOrders: function retryFailedOrders() {
      var _this17 = this;

      if (!this.nexusFrom || !this.nexusTo) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          text: this.$t('validations.requiredField'),
          type: 'warning',
          showCancelButton: false
        });
        return;
      }
      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        start: this.nexusFrom,
        end: this.nexusTo
      };

      this.apiRequest('/nexus/reset-failed-orders', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Sincronizarea a inceput. Finalizarea poate dura cateva minute',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Sincronizarea nu poate fi realizata',
            type: 'error',
            showCancelButton: false
          });
        }
        _this17.loading = false;
      });
    },
    handleNexusToChange: function handleNexusToChange(value) {
      var _this18 = this;

      if (value && value.endsWith(' 00:00:00')) {
        this.$nextTick(function () {
          _this18.nexusTo = value.replace(' 00:00:00', ' 23:59:59');
        });
      }
    },
    syncEpRestaurantMenu: function syncEpRestaurantMenu(location) {
      var _this19 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };
      if (update) {
        data.update = true;
      }
      this.apiRequest('/ep-restaurant/import-menu/' + location.ep_restaurant_id, 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this19.loading = false;
      });
    },
    syncFreyaCloudMenu: function syncFreyaCloudMenu(location) {
      var _this20 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };

      this.apiRequest('/freya-cloud/import-products/' + location.freya_cloud_id, 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this20.loading = false;
      });
    },
    updateLocationMapActive: function updateLocationMapActive(value) {
      this.location.mapactive = value;
    },
    syncGlovoMenu: function syncGlovoMenu(location) {
      var _this21 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };
      this.apiRequest('/glovo/sync-menu', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: response.errorCode ? _this21.$t('glovo.' + response.errorCode) : 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this21.loading = false;
      });
    },
    handleGlovoStatus: function handleGlovoStatus() {
      var _this22 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        glovo_company_id: this.location.glovo_company_id,
        active: this.glovoStatus
      };

      this.apiRequest('/glovo/toggle-location-status', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this22.$t('bolt.sync'),
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this22.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
          _this22.glovoStatus = !_this22.glovoStatus;
        }
        _this22.loading = false;
      });
    },
    updateGlovoMenu: function updateGlovoMenu() {
      var _this23 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: this.location.true_id,
        company_id: this.location.company_id,
        glovo_company_id: this.location.glovo_company_id
      };

      this.apiRequest('/glovo/menu/send-url', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this23.$t('bolt.sync'),
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: _this23.$t('bolt.syncError'),
            type: 'error',
            showCancelButton: false
          });
        }
        _this23.loading = false;
      });
    },
    ensureRkV2: function ensureRkV2(location) {
      if (location && !location.rkeeper_v2) {
        __WEBPACK_IMPORTED_MODULE_10_vue___default.a.set(location, 'rkeeper_v2', {
          url: '',
          api_user: '',
          api_secret: '',
          restaurant_slug: '',
          active: false,
          login_ok: false,
          login_message: '',
          testing: false,
          saving: false,
          is_running: false,
          sync_status: 'idle',
          sync_message: '',
          loaded: false,
          _polling: false
        });
        this.loadRkV2(location);
      }
      return true;
    },
    rkV2BaseData: function rkV2BaseData(location) {
      return {
        token: this.$session.get('token'),
        company_id: location.company_id,
        location_id: location.true_id
      };
    },
    loadRkV2: function loadRkV2(location) {
      var _this24 = this;

      this.apiRequest('/integrations/rkeeper-v2/config', 'GET', this.rkV2BaseData(location), function (response) {
        if (response && response.status === true && response.data && response.data.config) {
          var c = response.data.config;
          location.rkeeper_v2.url = c.url || '';
          location.rkeeper_v2.api_user = c.api_user || '';
          location.rkeeper_v2.api_secret = c.api_secret || '';
          location.rkeeper_v2.restaurant_slug = c.restaurant_slug || '';
          location.rkeeper_v2.active = !!c.active;
          location.rkeeper_v2.login_ok = !!c.active;
          location.rkeeper_v2.loaded = true;
        }
        _this24.loadRkV2Status(location);
      });
    },
    loadRkV2Status: function loadRkV2Status(location) {
      var _this25 = this;

      this.apiRequest('/integrations/rkeeper-v2/sync-menu/status', 'GET', this.rkV2BaseData(location), function (response) {
        if (response && response.status === true && response.data) {
          _this25.applyRkV2Status(location, response.data);
        }
      });
    },
    applyRkV2Status: function applyRkV2Status(location, s) {
      location.rkeeper_v2.sync_status = s.menu_sync_status;
      location.rkeeper_v2.is_running = !!s.is_running;
      location.rkeeper_v2.sync_message = s.menu_sync_message || '';
      if (s.is_running && !location.rkeeper_v2._polling) {
        this.pollRkV2Status(location);
      }
    },
    pollRkV2Status: function pollRkV2Status(location) {
      location.rkeeper_v2._polling = true;
      var self = this;
      var tick = function tick() {
        self.apiRequest('/integrations/rkeeper-v2/sync-menu/status', 'GET', self.rkV2BaseData(location), function (response) {
          if (response && response.status === true && response.data) {
            var s = response.data;
            location.rkeeper_v2.sync_status = s.menu_sync_status;
            location.rkeeper_v2.is_running = !!s.is_running;
            location.rkeeper_v2.sync_message = s.menu_sync_message || '';
            if (s.is_running) {
              setTimeout(tick, 3000);
            } else {
              location.rkeeper_v2._polling = false;
            }
          } else {
            location.rkeeper_v2._polling = false;
          }
        });
      };
      setTimeout(tick, 3000);
    },
    testRkV2Login: function testRkV2Login(location) {
      var _this26 = this;

      location.rkeeper_v2.testing = true;
      var data = this.rkV2BaseData(location);
      data.url = location.rkeeper_v2.url;
      data.api_user = location.rkeeper_v2.api_user;
      data.api_secret = location.rkeeper_v2.api_secret;
      data.restaurant_slug = location.rkeeper_v2.restaurant_slug;
      this.apiRequest('/integrations/rkeeper-v2/test-login', 'POST', data, function (response) {
        location.rkeeper_v2.testing = false;
        var ok = response && response.status === true;
        location.rkeeper_v2.login_ok = ok;
        location.rkeeper_v2.login_message = ok ? _this26.$t('rkeeperV2.loginOk') : response && response.errors && response.errors[0] ? response.errors[0] : _this26.$t('rkeeperV2.loginFail');
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ title: '', text: location.rkeeper_v2.login_message, type: ok ? 'success' : 'error', showConfirmButton: false, timer: 1800 });
      });
    },
    saveRkV2: function saveRkV2(location) {
      var _this27 = this;

      location.rkeeper_v2.saving = true;
      var data = this.rkV2BaseData(location);
      data.url = location.rkeeper_v2.url;
      data.api_user = location.rkeeper_v2.api_user;
      data.api_secret = location.rkeeper_v2.api_secret;
      data.restaurant_slug = location.rkeeper_v2.restaurant_slug;
      this.apiRequest('/integrations/rkeeper-v2/config', 'POST', data, function (response) {
        location.rkeeper_v2.saving = false;
        var ok = response && response.status === true;
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ title: '', text: ok ? _this27.$t('rkeeperV2.saved') : _this27.$t('rkeeperV2.error'), type: ok ? 'success' : 'error', showConfirmButton: false, timer: 1500 });
      });
    },
    toggleRkV2Active: function toggleRkV2Active(location) {
      var _this28 = this;

      var desired = location.rkeeper_v2.active;
      var data = this.rkV2BaseData(location);
      data.active = desired ? 1 : 0;
      this.apiRequest('/integrations/rkeeper-v2/active', 'POST', data, function (response) {
        var ok = response && response.status === true;
        if (!ok) {
          location.rkeeper_v2.active = !desired;
          var msg = response && response.errors && response.errors[0] ? response.errors[0] : _this28.$t('rkeeperV2.error');
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ title: '', text: msg, type: 'error', showConfirmButton: false, timer: 2500 });
        } else {
          if (desired) {
            location.rkeeper_v2.login_ok = true;
          }
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ title: '', text: _this28.$t('rkeeperV2.saved'), type: 'success', showConfirmButton: false, timer: 1200 });
        }
      });
    },
    syncRkV2Menu: function syncRkV2Menu(location) {
      var _this29 = this;

      this.apiRequest('/integrations/rkeeper-v2/sync-menu', 'POST', this.rkV2BaseData(location), function (response) {
        if (response && response.status === true) {
          location.rkeeper_v2.is_running = true;
          location.rkeeper_v2.sync_status = 'pending';
          location.rkeeper_v2.sync_message = _this29.$t('rkeeperV2.syncQueued');
          _this29.pollRkV2Status(location);
        } else {
          var msg = response && response.errors && response.errors[0] ? response.errors[0] : _this29.$t('rkeeperV2.error');
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ title: '', text: msg, type: 'error', showConfirmButton: false, timer: 2000 });
        }
      });
    },
    importCategories: function importCategories(location) {
      var _this30 = this;

      this.$nextTick(function () {
        this.loading = true;
      });

      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };

      var hasTimedOut = false;
      var timeoutDuration = 30000;
      var timeoutId = setTimeout(function () {
        hasTimedOut = true;
        _this30.$nextTick(function () {
          _this30.loading = false;
        });
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          title: '',
          text: _this30.$t('rkeeper.importInProgress'),
          type: 'info',
          showConfirmButton: true,
          confirmButtonText: _this30.$t('reports.requestConfirm')
        });
      }, timeoutDuration);

      this.apiRequest('/sync-categories-rkeeper', 'POST', data, function (response) {
        clearTimeout(timeoutId);

        if (!hasTimedOut) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this30.$t('rkeeper.importSuccess'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            _this30.$nextTick(function () {
              _this30.loading = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this30.$t('rkeeper.importError'),
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            });
            _this30.$nextTick(function () {
              _this30.loading = false;
            });
          }
        }
      });
    },
    importProducts: function importProducts(location) {
      var _this31 = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this.$nextTick(function () {
        this.loading = true;
      });

      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };

      if (type === 1) {
        data.fetch_new_products_only = true;
      } else if (type === 2) {
        data.fetch_new_options_only = true;
      }

      var hasTimedOut = false;
      var timeoutDuration = 30000;
      var timeoutId = setTimeout(function () {
        hasTimedOut = true;
        _this31.$nextTick(function () {
          _this31.loading = false;
        });
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          title: '',
          text: _this31.$t('rkeeper.importInProgress'),
          type: 'info',
          showConfirmButton: true,
          confirmButtonText: _this31.$t('reports.requestConfirm')
        });
      }, timeoutDuration);

      this.apiRequest('/sync-products-rkeeper', 'POST', data, function (response) {
        clearTimeout(timeoutId);

        if (!hasTimedOut) {
          if (response.status === true) {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this31.$t('rkeeper.importSuccess'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            _this31.$nextTick(function () {
              _this31.loading = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this31.$t('rkeeper.importError'),
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            });
            _this31.$nextTick(function () {
              _this31.loading = false;
            });
          }
        }
      });
    },
    syncProductPrices: function syncProductPrices(location) {
      var _this32 = this;

      this.$nextTick(function () {
        this.loading = true;
      });

      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };

      var hasTimedOut = false;
      var timeoutDuration = 30000;
      var timeoutId = setTimeout(function () {
        hasTimedOut = true;
        _this32.$nextTick(function () {
          _this32.loading = false;
        });
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          title: '',
          text: _this32.$t('rkeeper.syncInProgress'),
          type: 'info',
          showConfirmButton: true,
          confirmButtonText: _this32.$t('reports.requestConfirm')
        });
      }, timeoutDuration);

      this.apiRequest('/sync-product-prices-rkeeper', 'POST', data, function (response) {
        clearTimeout(timeoutId);

        if (!hasTimedOut) {
          if (response.status) {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this32.$t('rkeeper.syncSuccess'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            _this32.$nextTick(function () {
              _this32.loading = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this32.$t('rkeeper.syncError'),
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            });
            _this32.$nextTick(function () {
              _this32.loading = false;
            });
          }
        }
      });
    },
    syncOptionPrices: function syncOptionPrices(location) {
      var _this33 = this;

      this.$nextTick(function () {
        this.loading = true;
      });

      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };

      var hasTimedOut = false;
      var timeoutDuration = 30000;
      var timeoutId = setTimeout(function () {
        hasTimedOut = true;
        _this33.$nextTick(function () {
          _this33.loading = false;
        });
        __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
          title: '',
          text: _this33.$t('rkeeper.syncInProgress'),
          type: 'info',
          showConfirmButton: true,
          confirmButtonText: _this33.$t('reports.requestConfirm')
        });
      }, timeoutDuration);

      this.apiRequest('/sync-option-prices-rkeeper', 'POST', data, function (response) {
        clearTimeout(timeoutId);

        if (!hasTimedOut) {
          if (response.status) {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this33.$t('rkeeper.syncSuccess'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            _this33.$nextTick(function () {
              _this33.loading = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
              title: '',
              text: _this33.$t('rkeeper.syncError'),
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            });
            _this33.$nextTick(function () {
              _this33.loading = false;
            });
          }
        }
      });
    },
    updateTazzMenu: function updateTazzMenu(location) {
      var _this34 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };
      this.apiRequest('/tazz/update-menu', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this34.loading = false;
      });
    },
    updateProductPricesMagister: function updateProductPricesMagister(location) {
      var _this35 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };
      this.apiRequest('/magister/sync-products', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this35.loading = false;
      });
    },
    updateProductStocksMagister: function updateProductStocksMagister(location) {
      var _this36 = this;

      this.loading = true;

      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };
      this.apiRequest('/magister/sync-stock', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this36.loading = false;
      });
    },
    updateVatPrinterId: function updateVatPrinterId(obj, taxIndex) {
      var selectElement = obj.target;
      var selectedOptionName = selectElement.options[selectElement.selectedIndex].getAttribute('data-name');

      this.location.taxes[taxIndex].name = selectedOptionName;
    },
    getData: function getData() {
      var _this37 = this;

      this.deliveryMethods = this.getCompanyDetail('delivery_options_labels');
      this.timeFormat = this.getCompanyDetail('time_format');
      this.dateFormat = this.getCompanyDetail('date_format');
      this.sortMethodsList = this.defaultData.sort_products_methods || [];
      var data = {
        token: this.$session.get('token')
      };
      this.requestInitialData('paymentGroups', '/settings/payment-groups/' + this.$session.get('selectedCompany'), data, function (response) {
        if (response.status === true) {
          if (response.data.length === 0) {
            _this37.paymentGroups = null;
          } else {
            _this37.paymentGroups = response.data;
          }
        }
      });
    },
    getLocationData: function getLocationData() {
      var _this38 = this;

      var data = {
        token: this.$session.get('token')
      };

      if (this.id) {
        this.requestInitialData('location', '/admin/location/' + this.id, data, function (response) {
          if (response.status) {
            var respData = response.data;
            if (!respData.tip_suggestion) {
              respData.tip_suggestion = {
                type: 'proc',
                values: [5, 10, 15, 0]
              };
            }
            respData.discount_suggestion = _this38.normalizeDiscountSuggestion(respData.discount_suggestion);
            if (respData.is_open === undefined || respData.is_open === null) {
              respData.is_open = true;
            } else {
              respData.is_open = !!respData.is_open;
            }
            if (!Array.isArray(respData.cross_sell_products)) {
              respData.cross_sell_products = [];
            }
            if (respData.hide_from_platforms != null && !Array.isArray(respData.hide_from_platforms)) {
              throw new Error('Invalid location platform selection');
            }
            respData.hide_from_platforms = (respData.hide_from_platforms || []).map(Number);
            _this38.selectedHiddenPlatforms = _this38.locationPlatforms.filter(function (platform) {
              return respData.hide_from_platforms.indexOf(platform.id) !== -1;
            });
            _this38.location = respData;
            _this38.location.kiosk_allow_fidelities = _this38.companyLoyaltyInUse ? !!_this38.location.kiosk_allow_fidelities : false;
            _this38.location.pos_display_tips_on_order = _this38.location.pos_display_tips_on_order === null || _this38.location.pos_display_tips_on_order === undefined ? true : !!_this38.location.pos_display_tips_on_order;

            if (_this38.location.inv_is_vat_payer === null) {
              _this38.location.inv_is_vat_payer = 0;
            }

            if (_this38.location.inv_fiscal_code && _this38.location.inv_fiscal_code.trim().length > 0) {
              _this38.inv_fiscal_code_disabled_field = true;
            }

            if (_this38.location.posnet_company_id && !_this38.location.posnet_company_report_date) {
              _this38.location.posnet_company_report_date = _this38.getTodayDate();
            }

            if (_this38.location.posnet_company_id) {
              _this38.previousPosnetDate = _this38.location.posnet_company_report_date || _this38.getTodayDate();
              _this38.previousPosnetSwitchState = _this38.location.posnet_company_show_report;
            }

            if (!_this38.location.ordering_management) {
              _this38.location.ordering_management = _this38.createDefaultDeliveryMethods();
            }

            if (_this38.location.bolt_company_id) {
              _this38.apiRequest('/bolt/company/' + _this38.location.bolt_company_id, 'GET', data, function (response) {
                if (response.status && response.data) {
                  _this38.boltStatus = response.data.active;
                  _this38.boltSchedule = response.data.schedule;
                } else {
                  _this38.boltStatus = false;
                  _this38.boltSchedule = [{
                    'open': true,
                    'intervals': [{
                      'start_at_minutes_from_midnight': '10:00',
                      'stop_at_minutes_from_midnight': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'start_at_minutes_from_midnight': '10:00',
                      'stop_at_minutes_from_midnight': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'start_at_minutes_from_midnight': '10:00',
                      'stop_at_minutes_from_midnight': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'start_at_minutes_from_midnight': '10:00',
                      'stop_at_minutes_from_midnight': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'start_at_minutes_from_midnight': '10:00',
                      'stop_at_minutes_from_midnight': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'start_at_minutes_from_midnight': '10:00',
                      'stop_at_minutes_from_midnight': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'start_at_minutes_from_midnight': '10:00',
                      'stop_at_minutes_from_midnight': '22:00'
                    }]
                  }];
                }
              });
            }

            if (_this38.location.wolt_company_id) {
              _this38.apiRequest('/wolt/company/' + _this38.location.wolt_company_id, 'GET', data, function (response) {
                _this38.woltStatus = response.data.active;
                if (response.data.schedule.length) {
                  _this38.woltSchedule = response.data.schedule;
                } else {
                  _this38.woltSchedule = [{
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }];
                }
              });
            }
            if (_this38.location.glovo_company_id) {
              _this38.apiRequest('/glovo/company/' + _this38.location.glovo_company_id, 'GET', data, function (response) {
                if (response.status && response.data) {
                  _this38.glovoStatus = response.data.store_active;
                } else {
                  _this38.glovoStatus = false;
                }
              });
            }

            if (_this38.location.wolt_company_id) {
              _this38.apiRequest('/wolt/company/' + _this38.location.wolt_company_id, 'GET', data, function (response) {
                _this38.woltStatus = response.data.active;
                if (response.data.schedule.length) {
                  _this38.woltSchedule = response.data.schedule;
                } else {
                  _this38.woltSchedule = [{
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }, {
                    'open': true,
                    'intervals': [{
                      'opening_time': '10:00',
                      'closing_time': '22:00'
                    }]
                  }];
                }
              });
            }

            _this38.displayIntegrationCard = true;

            if (!_this38.location.r_system_company) {
              _this38.location.r_system_company = {
                api_key: null,
                organization_id: null,
                terminal_group_id: null,
                discount_pos_id: null,
                payment_types: ''
              };
            }
          }
        });
      } else {
        this.addLocation();
      }
    },
    addLocation: function addLocation() {
      var _this39 = this;

      var data = {
        'token': this.$session.get('token'),
        'type': 'hashes'
      };

      this.requestInitialData('location', '/helpers', data, function (response) {
        if (response.status) {
          var newRow = {
            id: null,
            city: '',
            country: '',
            email: null,
            name: null,
            is_open: true,
            taxes: [],
            vat: [],
            image: null,
            use_dynamic_menu: 1,
            allow_open_order: false,
            kiosk_is_using_top_category: false,
            kiosk_is_using_fiscal_receipt_for_cash: false,
            kiosk_is_using_non_fiscal_receipt_for_card: false,
            kiosk_add_to_cart_notification_position: 1,
            kiosk_allow_fidelities: false,
            allow_pos_use_coupons: 0,
            pos_confirm_order_close_on_method_select: 0,
            pos_display_all_product_options: 0,
            pos_allow_group_products: 1,
            force_credit_for_integration_cash_orders: 0,
            pos_use_yumm_voucher: false,
            pos_use_stock: false,
            pos_ask_storno_back_in_stock: false,
            pos_keep_first_waiter_id_order_split: false,
            pos_display_tips_on_order: true,
            pos_default_course_count: 0,
            pos_always_set_client: 5,
            inv_is_vat_payer: 0,
            inv_bank_account: null,
            inv_bank: null,
            inv_bank_branch: null,
            ordering_management: [{
              type: 'pick_up',
              label: 'Pick-up',
              enabled: false,
              offset: 0,
              period: 1,
              is_always_open: false,
              is_always_open_preorder_hours: 0,
              minimum_order_value: 0,
              default_waiting_time: 0,
              available_days: [],
              payment_options: { cash: false, credit_card: false, pos: false },
              delivery_hour_usage: 0,
              hour_and_date_delivery_hour_usage: 1,
              allow_fidelities: 1,
              allow_sms_notifications: 1
            }, {
              type: 'meet_half',
              label: 'Meet me half way',
              enabled: false,
              offset: 0,
              period: 1,
              is_always_open: false,
              is_always_open_preorder_hours: 0,
              minimum_order_value: 0,
              default_waiting_time: 0,
              available_days: [],
              payment_options: { cash: false, credit_card: false, pos: false },
              locations: [],
              delivery_hour_usage: 0,
              hour_and_date_delivery_hour_usage: 1,
              allow_fidelities: 1,
              allow_sms_notifications: 1
            }, {
              type: 'delivery',
              label: 'Delivery',
              area: 'radius',
              delivery_rules: [{ 'subrules': [{ 'cities': [], 'neighborhoods': [], 'shipping_cost': 0, 'min_order_value': 0, 'shipping_pos_id': null }], 'shipping_cost': 0, 'delivery_range': '1000', 'shipping_pos_id': [] }],
              enabled: false,
              offset: 0,
              period: 1,
              is_always_open: false,
              is_always_open_preorder_hours: 0,
              minimum_order_value: 0,
              default_waiting_time: 0,
              available_days: [],
              payment_options: { cash: false, credit_card: false, pos: false },
              cost: null,
              shipping_cost: [],
              delivery_hour_usage: 0,
              hour_and_date_delivery_hour_usage: 1,
              allow_fidelities: 1,
              allow_sms_notifications: 1
            }, {
              type: 'eat_location',
              label: 'Eat on location',
              enabled: false,
              offset: 0,
              period: 1,
              is_always_open: false,
              is_always_open_preorder_hours: 0,
              min_reservation: 1,
              max_reservation: 5,
              max_number_seats: null,
              min_between_reservations: 15,
              min_standard_reservations: 60,
              reservations_intervals: [2],
              minimum_order_value: 0,
              default_waiting_time: 0,
              available_days: [],
              payment_options: { cash: false, credit_card: false, pos: false },
              delivery_hour_usage: 0,
              hour_and_date_delivery_hour_usage: 1,
              reservation_taxes: [],
              allow_fidelities: 1,
              allow_sms_notifications: 1
            }, {
              type: 'self_ordering',
              label: 'Self Ordering',
              enabled: false,
              offset: 0,
              period: 1,
              is_always_open: false,
              is_always_open_preorder_hours: 0,
              minimum_order_value: 0,
              default_waiting_time: 0,
              available_days: [],
              max_distance_in_meter: 50,
              payment_options: { cash: false, credit_card: false, pos: false, kiosk_pos: false },
              delivery_hour_usage: 0,
              hour_and_date_delivery_hour_usage: 1,
              allow_fidelities: 1,
              allow_sms_notifications: 1
            }],
            phone: null,
            street: null,
            number: null,
            tip_suggestion: {
              type: 'proc',
              values: [5, 10, 15, 0]
            },
            reorder_popup_minutes: null,
            cross_sell_products: [],
            discount_suggestion: {
              fix: [5, 10, 15, 0],
              proc: [5, 10, 15, 0]
            },
            working_hours: []
          };

          newRow.id = response.data[0].id;

          newRow.isNew = true;

          for (var iDay in _this39.days) {
            newRow.working_hours.push({ day: _this39.days[iDay], open_to: '22:00', open_from: '10:00', open: true });
          }

          for (var iOrder in newRow.ordering_management) {
            for (var _iDay in _this39.days) {
              newRow.ordering_management[iOrder].available_days.push({ day: _this39.days[_iDay], open_to: '22:00', open_from: '10:00', open: true });
            }
          }
          _this39.selectedHiddenPlatforms = [];
          newRow.hide_from_platforms = [];
          _this39.location = newRow;
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this39.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    getTodayDate: function getTodayDate() {
      var today = new Date();
      var year = today.getFullYear();
      var month = String(today.getMonth() + 1).padStart(2, '0');
      var day = String(today.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    },
    getYesterdayDate: function getYesterdayDate() {
      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      var year = yesterday.getFullYear();
      var month = String(yesterday.getMonth() + 1).padStart(2, '0');
      var day = String(yesterday.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    },
    createDefaultDeliveryMethods: function createDefaultDeliveryMethods() {
      var newRow = [{
        type: 'pick_up',
        label: 'Pick-up',
        enabled: false,
        offset: 0,
        period: 1,
        is_always_open: false,
        is_always_open_preorder_hours: 0,
        minimum_order_value: 0,
        default_waiting_time: 0,
        available_days: [],
        payment_options: { cash: false, credit_card: false, pos: false },
        delivery_hour_usage: 0,
        hour_and_date_delivery_hour_usage: 1
      }, {
        type: 'meet_half',
        label: 'Meet me half way',
        enabled: false,
        offset: 0,
        period: 1,
        is_always_open: false,
        is_always_open_preorder_hours: 0,
        minimum_order_value: 0,
        default_waiting_time: 0,
        available_days: [],
        payment_options: { cash: false, credit_card: false, pos: false },
        locations: [],
        delivery_hour_usage: 0,
        hour_and_date_delivery_hour_usage: 1,
        allow_fidelities: 1,
        allow_sms_notifications: 1
      }, {
        type: 'delivery',
        label: 'Delivery',
        area: 'radius',
        delivery_rules: [{ 'subrules': [{ 'cities': [], 'neighborhoods': [], 'shipping_cost': 0, 'min_order_value': 0, 'shipping_pos_id': null }], 'shipping_cost': 0, 'delivery_range': '1000', 'shipping_pos_id': [] }],
        enabled: false,
        offset: 0,
        period: 1,
        is_always_open: false,
        is_always_open_preorder_hours: 0,
        minimum_order_value: 0,
        default_waiting_time: 0,
        available_days: [],
        payment_options: { cash: false, credit_card: false, pos: false },
        cost: null,
        shipping_cost: [],
        delivery_hour_usage: 0,
        hour_and_date_delivery_hour_usage: 1,
        allow_fidelities: 1,
        allow_sms_notifications: 1
      }, {
        type: 'eat_location',
        label: 'Eat on location',
        enabled: false,
        offset: 0,
        period: 1,
        is_always_open: false,
        is_always_open_preorder_hours: 0,
        min_reservation: 1,
        max_reservation: 5,
        max_number_seats: null,
        min_between_reservations: 15,
        min_standard_reservations: 60,
        reservations_intervals: [2],
        minimum_order_value: 0,
        default_waiting_time: 0,
        available_days: [],
        payment_options: { cash: false, credit_card: false, pos: false },
        delivery_hour_usage: 0,
        hour_and_date_delivery_hour_usage: 1,
        reservation_taxes: [],
        allow_fidelities: 1,
        allow_sms_notifications: 1
      }, {
        type: 'self_ordering',
        label: 'Self Ordering',
        enabled: false,
        offset: 0,
        period: 1,
        is_always_open: false,
        is_always_open_preorder_hours: 0,
        minimum_order_value: 0,
        default_waiting_time: 0,
        available_days: [],
        max_distance_in_meter: 50,
        payment_options: { cash: false, credit_card: false, pos: false, kiosk_pos: false },
        delivery_hour_usage: 0,
        hour_and_date_delivery_hour_usage: 1,
        allow_fidelities: 1,
        allow_sms_notifications: 1
      }];

      for (var iOrder in newRow) {
        for (var iDay in this.days) {
          newRow[iOrder].available_days.push({ day: this.days[iDay], open_to: '22:00', open_from: '10:00', open: true });
        }
      }

      return newRow;
    },
    getLocations: function getLocations() {
      var _this40 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        columns: ['id', 'token', 'name', 'email', 'street', 'phone']
      };

      this.requestInitialData('locations', '/locations', data, function (response) {
        if (response.status) {
          _this40.allLocations = response.data;
        }
      });
    },
    checkVal: function checkVal(location) {},
    clearIntegratorsPrinterErrorWhenOptional: function clearIntegratorsPrinterErrorWhenOptional() {
      if (!this.location || !this.errors) {
        return;
      }
      var rules = this.integratorsTaxVatPrinterRules;
      if (!rules || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rules).length) {
        if (this.errors.has('integrators_tax_vat_printer_id')) {
          this.errors.remove('integrators_tax_vat_printer_id');
        }
      }
    },
    clearOtherTaxesVatPrinterErrorWhenOptional: function clearOtherTaxesVatPrinterErrorWhenOptional() {
      if (!this.location || !this.errors) {
        return;
      }
      var rules = this.otherTaxesVatPrinterRules;
      if (!rules || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rules).length) {
        if (this.errors.has('other_taxes_vat_printer_id')) {
          this.errors.remove('other_taxes_vat_printer_id');
        }
      }
    },
    clearDonationVatPrinterErrorWhenOptional: function clearDonationVatPrinterErrorWhenOptional() {
      if (!this.location || !this.errors) {
        return;
      }
      var rules = this.donationVatPrinterRules;
      if (!rules || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rules).length) {
        if (this.errors.has('donation_vat_printer_id')) {
          this.errors.remove('donation_vat_printer_id');
        }
      }
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    localizedValidatorMessage: function localizedValidatorMessage(fieldName) {
      if (!this.errors.has(fieldName)) {
        return '';
      }
      var err = this.errors.items.find(function (e) {
        return e.field === fieldName;
      });
      if (!err) {
        return this.getError(fieldName);
      }
      if (err.rule === 'required') {
        return this.$t('validations.requiredField');
      }
      if (err.rule === 'numeric') {
        return this.$t('validations.vatPrinterIdNumeric');
      }
      if (err.rule === 'min_value' || err.rule === 'max_value') {
        return this.$t('validations.vatPrinterIdRange');
      }
      return this.getError(fieldName);
    },
    vatPrinterFieldName: function vatPrinterFieldName(taxRate, vatIndex) {
      var idPart = taxRate.id !== null && taxRate.id !== undefined ? String(taxRate.id) : 'n' + vatIndex;
      return 'vat_printer_' + idPart;
    },
    validate: function validate(pageId) {
      var _this41 = this;

      if (this.loading || this.rSystemBusy || this.initialLoadError || !this.location) {
        return;
      }
      this.$refs.deliveryMethods.validate().then(function (areDeliveryMethodsValid) {
        if (!areDeliveryMethodsValid) {
          _this41.hasDeliveryMethodsErrors = true;
          return;
        }
        _this41.$validator.validateAll().then(function (isValid) {
          if (isValid) {
            _this41.hasDeliveryMethodsErrors = false;
            var deliveryMethodsData = _this41.$refs.deliveryMethods.getDeliveryMethodsDataToSave();
            _this41.loading = true;
            var integration = _this41.$refs.rSystemSetup;
            var saveIntegration = integration ? integration.saveIfDirty() : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(true);
            saveIntegration.then(function (saved) {
              if (!saved) {
                _this41.loading = false;
                return;
              }
              _this41.saveDetails(deliveryMethodsData);
            }).catch(function () {
              _this41.loading = false;
            });
            _this41.hasLocationErrors = false;
            _this41.hasPaymentGroupErrors = false;
            _this41.hasVatErrors = false;
          } else {
            if (_this41.$validator.errors.items.some(function (item) {
              return item.field === 'name' || item.field === 'email' || item.field === 'phone' || item.field === 'country' || item.field === 'state' || item.field === 'city' || item.field === 'street' || item.field === 'street-number';
            })) {
              _this41.hasLocationErrors = true;
            } else {
              _this41.hasLocationErrors = false;
            }
            _this41.hasVatErrors = _this41.$validator.errors.items.some(function (item) {
              return item.field && item.field.indexOf('vat_printer_') === 0;
            });
            if (_this41.$validator.errors.items.some(function (item) {
              return item.field === 'paymentGroups' || item.field === 'integrators_tax_vat_printer_id' || item.field === 'other_taxes_vat_printer_id' || item.field === 'donation_vat_printer_id';
            })) {
              _this41.hasPaymentGroupErrors = true;
            } else {
              _this41.hasPaymentGroupErrors = false;
            }
            if (_this41.hasLocationErrors) return _this41.scrollToSection('start');
            if (_this41.hasVatErrors) return _this41.scrollToSection('vat');
            if (_this41.hasPaymentGroupErrors) return _this41.scrollToSection('printer');
          }
        });
      });
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;

      if (this.$refs.navButtons) {
        this.navButtonsHeight = this.$refs.navButtons.offsetHeight + 10;
      }
    },
    showStateDrop: function showStateDrop(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);

      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return true;
      } else {
        return false;
      }
    },
    getStatesOptions: function getStatesOptions(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);

      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return countries[countryIdx].states;
      } else {
        return [];
      }
    },
    updateCountry: function updateCountry(location) {
      location.state = null;
      location.state_id = null;
    },
    disableTaxOption: function disableTaxOption(locId, taxId) {
      var thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.location['taxes']);

      if (thisTaxIdx !== false) {
        return true;
      } else {
        return false;
      }
    },
    disableVatOption: function disableVatOption(taxId) {
      var thisTaxIdx = this.getObjectByElemKeyValue('tax_id', taxId, this.location['vat']);

      if (thisTaxIdx !== false) {
        return true;
      } else {
        return false;
      }
    },
    deleteLocation: function deleteLocation(id) {
      var btnCounter = 3;
      var self = this;
      var companyID = this.$session.get('selectedCompany');

      var data = {
        token: this.$session.get('token'),
        company_id: companyID,
        location_id: id
      };

      this.apiRequest('/settings/can-delete-location', 'POST', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: self.$t('settingCompany.areYouSureDelete'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes (' + btnCounter + ')'
          }).then(function (result) {
            if (result) {
              self.apiRequest('/delete-location', 'POST', data, function (response) {
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': self.$t('settingCompany.companyProdDeleted'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
                this.backButton();
              });
            }
          });
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.disableConfirmButton();

          var btnInterval = setInterval(function () {
            btnCounter--;

            if (btnCounter >= 1) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = 'Yes (' + btnCounter + ')';
            } else {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = 'Yes';
              clearInterval(btnInterval);
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.enableConfirmButton();
            }
          }, 1000);
        } else if (response.status === false && response.errors.location_ids !== undefined) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': self.$t('settingCompany.deleteLocationValidation'), 'type': 'error' }).catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    copyProducts: function copyProducts() {
      var _this42 = this;

      var copyFrom = this.$refs['copyFrom'].value;

      var data = {
        copy_to: this.location.id,
        copy_from: copyFrom,
        token: this.$session.get('token')
      };

      this.apiRequest('/locations/duplicate-products', 'POST', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this42.$t('settingCompany.companyProdCopied'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this42.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    addLocationToProducts: function addLocationToProducts() {
      var _this43 = this;

      var copyFrom = this.$refs['copyFrom'].value;

      var data = {
        copy_to: this.location.id,
        copy_from: copyFrom,
        token: this.$session.get('token')
      };

      this.apiRequest('/locations/add-locations-products', 'POST', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this43.$t('settingCompany.companyProdAddLoc'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this43.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    deleteProducts: function deleteProducts(id) {
      var self = this;
      var data = {
        location: id,
        token: self.$session.get('token')
      };
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: self.$t('settingCompany.areYouSureDeleteProd'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          self.apiRequest('/locations/delete-products', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': self.$t('settingCompany.companyProdDeleted'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
            }
          });
        }
      });
    },
    addNewTax: function addNewTax(locId) {
      var newRow = {
        'id': null,
        'type': null,
        'amount': null
      };
      this.location['taxes'].push(newRow);
      this.showUpdateWarning = true;
    },
    addNewVat: function addNewVat() {
      var newRow = {
        'id': null,
        'company_id': this.$session.get('selectedCompany'),
        'location_id': this.location.true_id,
        'location_token': this.location.token,
        'tax_id': null,
        'type': 'PERCENTAGE_EXCLUDED',
        'amount': null,
        'printer_id': null,
        'is_vat': true
      };
      this.location.vat.push(newRow);
      this.showUpdateWarning = true;
    },
    deleteTax: function deleteTax(locId, taxId) {
      var _this44 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: self.$t('settingCompany.areYouSureTax'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          var thisTaxIdx = _this44.getObjectByElemKeyValue('id', taxId, _this44.location['taxes']);
          _this44.location['taxes'].splice(thisTaxIdx, 1);
          _this44.showUpdateWarning = true;
        }
      }).catch({});
    },
    deleteVat: function deleteVat(taxId, vatIndex) {
      var _this45 = this;

      if (!taxId) {
        this.location['vat'].splice(vatIndex, 1);
        return;
      }
      var self = this;
      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: self.$t('settingCompany.areYouSureVat'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          var data = {
            'token': _this45.$session.get('token')
          };
          _this45.apiRequest('/location/vat/delete/' + taxId, 'DELETE', data, function (response) {
            if (response.status) {
              _this45.location['vat'].splice(vatIndex, 1);
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this45.$t('vat.deleteVatSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
            } else {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this45.$t('vat.deleteVatError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 });
            }
          });
          _this45.showUpdateWarning = true;
        }
      }).catch({});
    },
    handleDelete: function handleDelete() {
      var _this46 = this;

      var btnCounter = 3;
      var self = this;
      var companyID = this.$session.get('selectedCompany');

      var data = {
        token: this.$session.get('token'),
        company_id: companyID,
        location_id: this.location.token,
        true_id: this.location.true_id
      };

      this.apiRequest('/settings/can-delete-location', 'POST', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
            text: self.$t('settingCompany.areYouSureDelete'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: _this46.$t('general.yes') + ' (' + btnCounter + ')'
          }).then(function (result) {
            if (result) {
              _this46.loading = true;
              self.apiRequest('admin/location/' + _this46.location.true_id, 'DELETE', data, function (response) {
                if (response.status) {
                  var locId = _this46.location.true_id;
                  self.trackAdminEvent('ADMIN_LOCATION_DELETED', 'location', locId, {
                    location_id: locId,
                    name: _this46.location && _this46.location.name || _this46.model && _this46.model.name || null
                  });
                  _this46.getLocations();
                  _this46.loading = false;
                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
                    text: 'Sucess!',
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1000
                  });
                  _this46.backButton();
                }
              });
            }
          });
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.disableConfirmButton();

          var btnInterval = setInterval(function () {
            btnCounter--;

            if (btnCounter >= 1) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = 'Yes (' + btnCounter + ')';
            } else {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.getConfirmButton().textContent = 'Yes';
              clearInterval(btnInterval);
              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.enableConfirmButton();
            }
          }, 1000);
        } else if (response.status === false && response.errors.location_ids !== undefined) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': self.$t('settingCompany.deleteLocationValidation'), 'type': 'error' }).catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    generateCode: function generateCode() {
      var _this47 = this;

      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany')
      };
      this.apiRequest('/admin/generate-location-code/' + this.location.true_id, 'POST', data, function (response) {
        if (response.status) {
          _this47.location.auth_code = response.data.auth_code;
          _this47.location.auth_qr_code = response.data.auth_qr_code;
        }
      });
    },
    saveDetails: function saveDetails(deliveryMethodsData) {
      var _this48 = this;

      this.$nextTick(function () {
        this.loading = true;
      });
      var countries = this.$session.get('defaultData').countries;

      var countryIso = this.location.country;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);
      var states = [];

      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        states = countries[countryIdx].states;
      }

      if (states.length && this.location.state_id) {
        var state = this.getObjectByElemKeyValue('id', this.location.state_id, states);
        if (state !== undefined) {
          this.location.state = states[state].name;
        } else {
          this.location.state = '';
        }
      }


      var copy = {
        active: this.location.active,
        is_open: this.location.is_open === undefined || this.location.is_open === null ? true : !!this.location.is_open,
        hide_from_platforms: this.selectedHiddenPlatforms.map(function (platform) {
          return platform.id;
        }),
        allow_preorder: this.location.allow_preorder,
        allow_open_order: this.location.allow_open_order,
        kiosk_is_using_top_category: this.location.kiosk_is_using_top_category,
        kiosk_is_using_fiscal_receipt_for_cash: this.location.kiosk_is_using_fiscal_receipt_for_cash,
        kiosk_is_using_non_fiscal_receipt_for_card: this.location.kiosk_is_using_non_fiscal_receipt_for_card,
        kiosk_add_to_cart_notification_position: this.location.kiosk_add_to_cart_notification_position || 1,
        kiosk_allow_fidelities: this.companyLoyaltyInUse ? !!this.location.kiosk_allow_fidelities : false,
        app_link: this.location.app_link,
        app_qr: this.location.app_qr,
        auto_print: this.location.auto_print,
        auto_print_local_server: !!this.location.auto_print_local_server,
        allow_pos_use_coupons: this.location.allow_pos_use_coupons,
        pos_confirm_order_close_on_method_select: this.location.pos_confirm_order_close_on_method_select,
        pos_display_all_product_options: this.location.pos_display_all_product_options,
        pos_allow_group_products: this.location.pos_allow_group_products,
        force_credit_for_integration_cash_orders: this.location.force_credit_for_integration_cash_orders,
        pos_use_yumm_voucher: !!this.location.pos_use_yumm_voucher,
        pos_use_stock: !!this.location.pos_use_stock,
        pos_ask_storno_back_in_stock: !!this.location.pos_ask_storno_back_in_stock,
        pos_keep_first_waiter_id_order_split: !!this.location.pos_keep_first_waiter_id_order_split,
        pos_display_tips_on_order: !!this.location.pos_display_tips_on_order,
        pos_default_course_count: this.location.pos_default_course_count,
        pos_always_set_client: this.location.pos_always_set_client,
        staff_food_daily_budget: this.location.staff_food_daily_budget,
        city: this.location.city,
        company_id: this.location.company_id,
        country: this.location.country,
        custom_sort_order: this.location.custom_sort_order,
        drcarmen_active: this.location.drcarmen_active,
        drcarmen_api_key: this.location.drcarmen_api_key,
        drcarmen_delay: this.location.drcarmen_delay,
        drcarmen_is_auto: this.location.drcarmen_is_auto,
        drcarmen_url: this.location.drcarmen_url,
        dynamic_menu_banner: this.location.dynamic_menu_banner,
        dynamic_menu_logo: this.location.dynamic_menu_logo,
        inv_company_name: this.location.inv_company_name,
        inv_fiscal_code: this.location.inv_fiscal_code,
        inv_trade_register: this.location.inv_trade_register,
        inv_phone: this.location.inv_phone,
        inv_email: this.location.inv_email,
        inv_address: this.location.inv_address,
        inv_street_number: this.location.inv_street_number,
        inv_country: this.location.inv_country,
        inv_county: this.location.inv_county,
        inv_city: this.location.inv_city,
        inv_additional_data: this.location.inv_additional_data,
        inv_is_vat_payer: this.location.inv_is_vat_payer,
        inv_bank_account: this.location.inv_bank_account,
        inv_bank: this.location.inv_bank,
        inv_bank_branch: this.location.inv_bank_branch,
        dynamic_menu_url: this.location.dynamic_menu_url,
        dynamic_qr_code: this.location.dynamic_qr_code,
        email: this.location.email,
        email_transport: this.location.email_transport,
        holiday_is_active: this.location.holiday_is_active,
        holiday_is_active_from: this.location.holiday_is_active_from,
        holiday_is_active_to: this.location.holiday_is_active_to,
        id: this.location.id,
        id_discount_pos: this.location.id_discount_pos,
        image: this.location.image,
        lat: this.location.lat,
        lng: this.location.lng,
        mapactive: this.location.mapactive,
        name: this.location.name,
        number: this.location.number,
        payment_group: this.location.payment_group,
        phone: this.location.phone,
        printer_ip: this.location.printer_ip,
        printer_port: this.location.printer_port,
        qr_code: this.location.qr_code,
        qr_code_url: this.location.qr_code_url,
        selected_group: this.location.selected_group,
        smartbill_add_to_cc: this.location.smartbill_add_to_cc,
        smartbill_api_key: this.location.smartbill_api_key,
        smartbill_cif: this.location.smartbill_cif,
        smartbill_email: this.location.smartbill_email,
        smartbill_send_auto: this.location.smartbill_send_auto,
        smartbill_series: this.location.smartbill_series,
        smartbill_status: this.location.smartbill_status,
        state: this.location.state,
        state_id: this.location.state_id,
        street: this.location.street,
        taxes: this.location.taxes,
        vat: this.location.vat,
        tip_suggestion: this.location.tip_suggestion,
        reorder_popup_minutes: this.location.reorder_popup_minutes,
        cross_sell_products: Array.isArray(this.location.cross_sell_products) ? this.location.cross_sell_products : [],
        discount_suggestion: this.normalizeDiscountSuggestion(this.location.discount_suggestion),
        use_dynamic_menu: this.location.use_dynamic_menu,
        use_printer: this.location.use_printer,
        use_twilio: this.location.use_twilio,
        use_twilio_early_mark: this.location.use_twilio_early_mark,
        twilio_phone: this.location.twilio_phone,
        time__prod_opt_report: this.location.time__prod_opt_report,
        email__prod_opt_report: this.location.email__prod_opt_report,
        integrators_department_id: this.location.integrators_department_id,
        integrators_tax_vat_printer_id: this.location.integrators_tax_vat_printer_id,
        integrators_tax_vat_amount: this.location.integrators_tax_vat_amount,
        other_taxes_vat_printer_id: this.location.other_taxes_vat_printer_id,
        donation_vat_printer_id: this.location.donation_vat_printer_id,
        google_maps_api_key: this.location.google_maps_api_key,
        wolt_drive_errors_url: this.location.wolt_drive_errors_url
      };

      var data = {
        'token': this.$session.get('token'),
        'company_id': this.$session.get('selectedCompany'),
        'locationData': copy
      };

      if (this.location.true_id) {
        this.apiRequest('/admin/location/' + this.location.true_id, 'PUT', data, function (response) {
          _this48.$nextTick(function () {
            this.loading = false;
          });
          if (response.status) {
            var locId = response.data.true_id || _this48.location.true_id;
            _this48.trackAdminEvent('ADMIN_LOCATION_UPDATE', 'location', locId, {
              location_id: locId,
              name: copy.name || null,
              request: data,
              response: response
            });
            deliveryMethodsData.location_token = response.data.token;
            deliveryMethodsData.location_id = response.data.true_id;
            _this48.syncCompanySessionAndCache();
            _this48.saveDeliveryMethods(deliveryMethodsData);
            _this48.backButton();
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this48.$t('settingCompany.locationUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          } else {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this48.$t('settingCompany.updateError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          }
        });
      } else {
        data.locationData.active = true;
        data.locationData.is_open = true;
        this.apiRequest('/admin/location/', 'POST', data, function (response) {
          _this48.$nextTick(function () {
            this.loading = false;
          });
          if (response.status) {
            var locId = response.data.true_id || null;
            _this48.trackAdminEvent('ADMIN_LOCATION_UPDATE', 'location', locId, {
              location_id: locId,
              name: copy.name || null,
              request: data,
              response: response
            });
            deliveryMethodsData.location_token = response.data.token;
            deliveryMethodsData.location_id = response.data.true_id;
            _this48.syncCompanySessionAndCache();
            _this48.saveDeliveryMethods(deliveryMethodsData);
            _this48.backButton();
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this48.$t('settingCompany.locationUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          } else {
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this48.$t('settingCompany.updateError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          }
        });
      }
    },
    saveDeliveryMethods: function saveDeliveryMethods(data) {
      var _this49 = this;

      var trackDeliverySave = function trackDeliverySave(response) {
        var locId = data.location_id || _this49.location && _this49.location.true_id || null;
        var methods = data.delivery_methods || [];
        methods.forEach(function (method) {
          var methodId = method.id || method.type;
          _this49.trackAdminEvent('ADMIN_LOCATION_DELIVERY_METHOD_UPDATE', 'delivery_method', methodId, {
            delivery_method_id: methodId,
            location_id: locId,
            delivery_method_type: method.type || null,
            enabled: !!method.enabled,
            request: data,
            response: response
          });
        });
        if (!methods.length) {
          _this49.trackAdminEvent('ADMIN_LOCATION_DELIVERY_METHOD_UPDATE', 'delivery_method', locId, {
            location_id: locId,
            request: data,
            response: response
          });
        }
      };
      if (this.id) {
        this.apiRequest('/admin/delivery-methods', 'PUT', data, function (response) {
          if (response.status === true) {
            trackDeliverySave(response);
            _this49.$nextTick(function () {
              _this49.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this49.$t('settingsOrdering.saveSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 3000 }).catch(function () {});
          } else {
            _this49.$nextTick(function () {
              _this49.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this49.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          }
        });
      } else {
        this.apiRequest('/admin/delivery-methods', 'POST', data, function (response) {
          if (response.status === true) {
            trackDeliverySave(response);
            _this49.$nextTick(function () {
              _this49.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this49.$t('settingsOrdering.saveSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 3000 }).catch(function () {});
          } else {
            _this49.$nextTick(function () {
              _this49.loading = false;
            });
            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({ 'text': _this49.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          }
        });
      }
    },
    goToCompany: function goToCompany() {
      var _this50 = this;

      __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default()({
        text: this.$t('general.leavePageQuestion'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.cancel2')
      }).then(function (result) {
        if (result) {
          _this50.backButton();
          _this50.$session.set('selectedTab', _this50.$t('settingsPages.taxLabeling'));
        }
      });
    },
    handleMenu: function handleMenu(event) {
      this.location.use_dynamic_menu = event.target.value;
    },
    handleTipType: function handleTipType(event) {
      this.location.tip_suggestion.type = event.target.value;
    },
    normalizeDiscountSuggestion: function normalizeDiscountSuggestion(discountSuggestion) {
      var defaults = {
        fix: [5, 10, 15, 0],
        proc: [5, 10, 15, 0]
      };
      if (!discountSuggestion) {
        return defaults;
      }
      if (Array.isArray(discountSuggestion.fix) && Array.isArray(discountSuggestion.proc)) {
        return {
          fix: discountSuggestion.fix,
          proc: discountSuggestion.proc
        };
      }

      if (Array.isArray(discountSuggestion.values)) {
        return {
          fix: discountSuggestion.type === 'fix' ? discountSuggestion.values : defaults.fix.slice(),
          proc: discountSuggestion.type === 'proc' ? discountSuggestion.values : defaults.proc.slice()
        };
      }
      return defaults;
    },
    downloadForm: function downloadForm() {},
    openImportHistory: function openImportHistory() {
      if (!this.location || !this.location.true_id) {
        return;
      }
      this.$router.push('/locations/' + this.location.true_id + '/product-imports');
    },
    loadLocationPriceProfiles: function loadLocationPriceProfiles() {
      var _this51 = this;

      if (!this.location || !this.location.true_id) {
        this.locationPriceProfiles = [];
        return;
      }
      var locationTrueId = this.location.true_id;
      this.apiRequest('/price-profiles', 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        perPage: 200,
        page: 1
      }, function (response) {
        if (!response || !response.status) {
          _this51.locationPriceProfiles = [];
          return;
        }
        var items = response.data || [];
        _this51.locationPriceProfiles = items.filter(function (profile) {
          var locs = profile.location_details || profile.locationDetails || [];
          return locs.some(function (loc) {
            var locId = loc.true_id != null ? loc.true_id : loc.id;
            return String(locId) === String(locationTrueId);
          });
        });
        if (_this51.selectedPriceProfileId) {
          var stillThere = _this51.locationPriceProfiles.some(function (p) {
            return p.id === _this51.selectedPriceProfileId;
          });
          if (!stillThere) {
            _this51.selectedPriceProfileId = null;
          }
        }
        if (!_this51.locationPriceProfiles.length) {
          _this51.createDefaultPriceProfileForLocation();
        } else if (!_this51.selectedPriceProfileId) {
          _this51.selectedPriceProfileId = _this51.locationPriceProfiles[0].id;
        }
      });
    },
    createDefaultPriceProfileForLocation: function createDefaultPriceProfileForLocation() {
      var _this52 = this;

      if (!this.location || !this.location.true_id || this.creatingDefaultPriceProfile) {
        return;
      }
      this.creatingDefaultPriceProfile = true;
      var locationName = (this.location.name || 'Location').trim();
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        name: locationName + ' default',
        location_ids: [this.location.true_id],
        top_category_ids: [],
        delivery_range_ids: [],
        customers_group_ids: [],
        products: [],
        products_to_delete: []
      };
      this.apiRequest('/price-profiles', 'POST', data, function (response) {
        _this52.creatingDefaultPriceProfile = false;
        if (response && response.status) {
          var created = response.data && (Array.isArray(response.data) ? response.data[0] : response.data);
          if (created && created.id) {
            _this52.locationPriceProfiles = [created];
            _this52.selectedPriceProfileId = created.id;
          } else {
            _this52.loadLocationPriceProfilesAfterCreate();
          }
        }
      });
    },
    loadLocationPriceProfilesAfterCreate: function loadLocationPriceProfilesAfterCreate() {
      var _this53 = this;

      if (!this.location || !this.location.true_id) {
        return;
      }
      var locationTrueId = this.location.true_id;
      this.apiRequest('/price-profiles', 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        perPage: 200,
        page: 1
      }, function (response) {
        if (!response || !response.status) {
          return;
        }
        var items = response.data || [];
        _this53.locationPriceProfiles = items.filter(function (profile) {
          var locs = profile.location_details || profile.locationDetails || [];
          return locs.some(function (loc) {
            var locId = loc.true_id != null ? loc.true_id : loc.id;
            return String(locId) === String(locationTrueId);
          });
        });
        if (_this53.locationPriceProfiles.length && !_this53.selectedPriceProfileId) {
          _this53.selectedPriceProfileId = _this53.locationPriceProfiles[0].id;
        }
      });
    },
    loadLocationProductCount: function loadLocationProductCount() {
      var _this54 = this;

      if (!this.location || !this.location.token) {
        this.locationHasProducts = false;
        return;
      }
      this.apiRequest('/sidemenu-products', 'GET', {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_ids: [this.location.token],
        page: 1
      }, function (response) {
        if (response && response.status && response.data && response.data.pagination) {
          _this54.locationHasProducts = (response.data.pagination.totalRecords || 0) > 0;
          return;
        }
        var rows = response && response.data && response.data.data;
        _this54.locationHasProducts = Array.isArray(rows) && rows.length > 0;
      });
    },
    backButton: function backButton() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    scrollToSection: function scrollToSection(sectionId) {
      var innerContainer = document.getElementById('inner-container');
      var targetElement = document.getElementById(sectionId);
      if (innerContainer && targetElement) {
        var offset = -5;
        var innerContainerRect = innerContainer.getBoundingClientRect();
        var targetElementRect = targetElement.getBoundingClientRect();

        var elementPosition = targetElementRect.top - innerContainerRect.top + innerContainer.scrollTop + offset;
        innerContainer.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    },
    openSection: function openSection(section) {
      this.currentSection = section;
      if (section === 'menu-actions') {
        this.loadLocationPriceProfiles();
        this.loadLocationProductCount();
      }
    }
  }
});

/***/ }),

/***/ "vrT8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadImageModal_vue__ = __webpack_require__("Uehx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c1e0f7f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadImageModal_vue__ = __webpack_require__("xPUc");
function injectStyle (ssrContext) {
  __webpack_require__("aSfd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c1e0f7f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadImageModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c1e0f7f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadImageModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vvXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(_vm.showNexusActions)?[_c('button',{staticClass:"btn btn-icon btn-info mar-rt-10",staticStyle:{"margin-bottom":"0"},attrs:{"type":"button","title":_vm.$t('nexus.invoiceStatus')},on:{"click":function($event){$event.preventDefault();return _vm.fetchNexusInvoiceStatus($event)}}},[_c('i',{staticClass:"ti-reload"}),_vm._v("\n            "+_vm._s(_vm.$t('nexus.invoiceStatus'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-purple mar-rt-10",staticStyle:{"margin-bottom":"0"},attrs:{"type":"button","title":_vm.$t('nexus.invoiceLog')},on:{"click":function($event){$event.preventDefault();return _vm.fetchNexusInvoiceLogs($event)}}},[_c('i',{staticClass:"ti-list"}),_vm._v("\n            "+_vm._s(_vm.$t('nexus.invoiceLog'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-warning mar-rt-10",staticStyle:{"margin-bottom":"0"},attrs:{"type":"button","title":_vm.$t('nexus.invoiceSend')},on:{"click":function($event){$event.preventDefault();return _vm.markNexusInvoiceManual($event)}}},[_c('i',{staticClass:"ti-export"}),_vm._v("\n            "+_vm._s(_vm.$t('nexus.invoiceSend'))+"\n          ")])]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success mar-rt-10 save",staticStyle:{"margin-bottom":"0"},attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])],2)])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('invoice.supplierDetails')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocationId),expression:"selectedLocationId"}],staticClass:"form-control",attrs:{"disabled":_vm.isEditMode},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocationId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Selectează locația")]),_vm._v(" "),_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat) + " — Locații: " + (group.locations.map(function (l) { return l.name; }).join(', ')))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.true_id,domProps:{"value":loc.true_id}},[_vm._v("\n                  "+_vm._s(loc.name)+"\n                ")])}))})],2)]),_vm._v(" "),_c('div',{staticClass:"invoice-address-section"},[_c('div',{staticClass:"row address-row"},[_c('div',{staticClass:"col-xs-6 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientCountry')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceCountryCode),expression:"invoiceCountryCode"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.invoiceCountryCode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.romaniaCountryOptions),function(country){return _c('option',{key:country.code,domProps:{"value":country.code}},[_vm._v("\n                      "+_vm._s(country.name)+"\n                    ")])}))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientCounty')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceCountyCode),expression:"invoiceCountyCode"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.invoiceCountyCode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('invoice.selectCounty')))]),_vm._v(" "),_vm._l((_vm.romanianCounties),function(county){return _c('option',{key:county.code,domProps:{"value":county.code}},[_vm._v("\n                      "+_vm._s(county.name)+"\n                    ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientCity')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceCity),expression:"invoiceCity"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientCity')},domProps:{"value":(_vm.invoiceCity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.invoiceCity=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row address-row"},[_c('div',{staticClass:"col-xs-12 col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientStreet')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceStreet),expression:"invoiceStreet"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientStreet')},domProps:{"value":(_vm.invoiceStreet)},on:{"input":function($event){if($event.target.composing){ return; }_vm.invoiceStreet=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientStreetNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceStreetNumber),expression:"invoiceStreetNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientStreetNumber')},domProps:{"value":(_vm.invoiceStreetNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.invoiceStreetNumber=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.vatPayer')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceVATPayer),expression:"invoiceVATPayer"}],staticClass:"form-control",attrs:{"disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.invoiceVATPayer=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"yes"}},[_vm._v(_vm._s(_vm.$t('invoice.yes')))]),_vm._v(" "),_c('option',{attrs:{"value":"no"}},[_vm._v(_vm._s(_vm.$t('invoice.no')))])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.issueDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.issueDate),expression:"issueDate"}],staticClass:"form-control",attrs:{"type":"datetime-local","max":_vm.today},domProps:{"value":(_vm.issueDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.issueDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.dueDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dueDate),expression:"dueDate"}],staticClass:"form-control",attrs:{"type":"datetime-local","max":_vm.today},domProps:{"value":(_vm.dueDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dueDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.series'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seriesNumber),expression:"seriesNumber"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seriesNumber=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.updateNumber]}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('invoice.selectSeries')))]),_vm._v(" "),_vm._l((_vm.seriesOptionsWithAdd),function(series){return _c('option',{key:series.id || series.series,domProps:{"value":series.id || series.series}},[_vm._v("\n                  "+_vm._s(series.nume || series.series)+"\n                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.currentNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentNumber),expression:"currentNumber"}],staticClass:"form-control",attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.currentNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentNumber=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v(_vm._s(_vm.$t('invoice.clientDetails')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientName'))+"*")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.clientResults,"label":"nume","placeholder":"Caută un client...","filterable":false,"disabled":!_vm.selectedLocation},on:{"search":_vm.fetchClients,"input":_vm.onClientSelect},model:{value:(_vm.clientSelected),callback:function ($$v) {_vm.clientSelected=$$v},expression:"clientSelected"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientCUI'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.clientCUI),expression:"modelValidate.clientCUI"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientCUI')},domProps:{"value":_vm.clientCUI},on:{"input":function($event){_vm.clientCUI = $event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientEmail),expression:"clientEmail"}],staticClass:"form-control",attrs:{"type":"email","placeholder":_vm.$t('invoice.clientEmail')},domProps:{"value":(_vm.clientEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientPhone'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientPhone),expression:"clientPhone"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.clientPhone),expression:"modelValidate.clientPhone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientPhone')},domProps:{"value":(_vm.clientPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientPhone=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"client-address-section"},[_c('label',{staticClass:"address-section-label"},[_vm._v(_vm._s(_vm.$t('invoice.clientAddress'))+"*")]),_vm._v(" "),_c('div',{staticClass:"row address-row"},[_c('div',{staticClass:"col-xs-6 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientCountry'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientCountryCode),expression:"clientCountryCode"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.clientCountryCode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.romaniaCountryOptions),function(country){return _c('option',{key:country.code,domProps:{"value":country.code}},[_vm._v("\n                      "+_vm._s(country.name)+"\n                    ")])}))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientCounty'))+"*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientCountyCode),expression:"clientCountyCode"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.clientCountyCode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('invoice.selectCounty')))]),_vm._v(" "),_vm._l((_vm.romanianCounties),function(county){return _c('option',{key:county.code,domProps:{"value":county.code}},[_vm._v("\n                      "+_vm._s(county.name)+"\n                    ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.isClientBucharest ? _vm.$t('invoice.clientSector') : _vm.$t('invoice.clientCity'))+"*")]),_vm._v(" "),(_vm.isClientBucharest)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientCity),expression:"clientCity"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.clientCity=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('invoice.selectSector')))]),_vm._v(" "),_vm._l((_vm.bucharestSectors),function(sector){return _c('option',{key:sector.code,domProps:{"value":sector.code}},[_vm._v("\n                      "+_vm._s(sector.name)+"\n                    ")])})],2):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientCity),expression:"clientCity"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientCity')},domProps:{"value":(_vm.clientCity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientCity=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row address-row"},[_c('div',{staticClass:"col-xs-12 col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientStreet'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientStreet),expression:"clientStreet"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientStreet')},domProps:{"value":(_vm.clientStreet)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientStreet=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientStreetNumber'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientStreetNumber),expression:"clientStreetNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientStreetNumber')},domProps:{"value":(_vm.clientStreetNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientStreetNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-8 col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('invoice.clientPostalCode')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientPostalCode),expression:"clientPostalCode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('invoice.clientPostalCode')},domProps:{"value":(_vm.clientPostalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clientPostalCode=$event.target.value}}})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"title"},[_c('p',[_vm._v(_vm._s(_vm.$t('gestiune.addProductInInvoice')))])]),_vm._v(" "),(!_vm.isInvoice)?_c('div',{staticClass:"search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search Order Id..."},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"btn btn-icon btn-search",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.searchOrder}},[_c('i',{staticClass:"ti-search"})])]):_vm._e()]),_vm._v(" "),(_vm.hasOrderInfo)?_c('div',{staticClass:"order-info-summary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"order-info-grid"},[(_vm.orderDate)?_c('div',{staticClass:"order-info-card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"order-info-card-body"},[_c('span',{staticClass:"order-info-label"},[_vm._v("Data comandă")]),_vm._v(" "),_c('span',{staticClass:"order-info-value"},[_vm._v(_vm._s(_vm.orderDate))])])]):_vm._e(),_vm._v(" "),(_vm.orderNumber)?_c('div',{staticClass:"order-info-card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"order-info-card-body"},[_c('span',{staticClass:"order-info-label"},[_vm._v("Nr. comandă")]),_vm._v(" "),_c('span',{staticClass:"order-info-value"},[_vm._v("#"+_vm._s(_vm.orderNumber))])])]):_vm._e(),_vm._v(" "),(_vm.bonData)?_c('div',{staticClass:"order-info-card"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"order-info-card-body"},[_c('span',{staticClass:"order-info-label"},[_vm._v("Data bon")]),_vm._v(" "),_c('span',{staticClass:"order-info-value"},[_vm._v(_vm._s(_vm.bonData))])])]):_vm._e(),_vm._v(" "),(_vm.bonNumber)?_c('div',{staticClass:"order-info-card order-info-card--highlight"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"order-info-card-body"},[_c('span',{staticClass:"order-info-label"},[_vm._v("Bon fiscal")]),_vm._v(" "),_c('span',{staticClass:"order-info-value"},[_vm._v(_vm._s(_vm.bonNumber))])])]):_vm._e(),_vm._v(" "),(_vm.paymentType)?_c('div',{staticClass:"order-info-card"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"order-info-card-body"},[_c('span',{staticClass:"order-info-label"},[_vm._v("Plată")]),_vm._v(" "),_c('span',{staticClass:"order-info-value"},[_vm._v(_vm._s(_vm.formatPaymentTypeLabel(_vm.paymentType)))])])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"sm"})])]),_vm._v(" "),[_c('div',[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.productName'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.type'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.codeProduct'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.unitMeasure'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.quantity'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('invoice.vatRate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.pretFaraTva'))+"*")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('gestiune.valoare')))]),_vm._v(" "),_c('th',[_vm._v("TVA")]),_vm._v(" "),(!_vm.isDisabled && !_vm.isEdit)?_c('th',[_vm._v(_vm._s(_vm.$t('general.actions')))]):_vm._e()])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(_vm.getGestiuneName(item.gestiuneFrom)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(typeof item.productName === 'object' ? item.productName.name : item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.unitMeasure))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.vatRate)+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.priceRON))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.valoare))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tva))]),_vm._v(" "),(!_vm.isDisabled && !_vm.isEdit)?_c('td',[_c('a',{staticClass:"btn btn-danger btn-icon delete mar-rt-10",attrs:{"disabled":_vm.isInvoice},on:{"click":function($event){_vm.removeItem(index)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                        "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])]):_vm._e()])}),_vm._v(" "),(!_vm.isEdit && !_vm.isStorno && !_vm.isInvoice && !_vm.isDisabled)?_c('tr',[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.gestiuneId),expression:"newItem.gestiuneId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newItem, "gestiuneId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Selectează gestiunea")]),_vm._v(" "),_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('option',{key:gestiune.id,domProps:{"value":gestiune.id}},[_vm._v("\n                        "+_vm._s(gestiune.name)+"\n                      ")])})],2)]),_vm._v(" "),_c('td',{staticStyle:{"width":"250px !important"}},[_c('v-select',{attrs:{"options":_vm.searchResults,"label":"name","placeholder":"Caută un produs...","filterable":false},on:{"search":_vm.fetchProducts,"input":_vm.onProductSelected},model:{value:(_vm.newItem.productName),callback:function ($$v) {_vm.$set(_vm.newItem, "productName", $$v)},expression:"newItem.productName"}},[[(!_vm.loadingProducts)?_c('span',[_vm._v("Niciun produs găsit")]):_vm._e()]],2),_vm._v(" "),(_vm.loadingProducts)?_c('div',{staticClass:"v-select-loader"}):_vm._e()],1),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.type),expression:"newItem.type"}],staticClass:"form-control",attrs:{"disabled":true},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.newItem, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Tip")]),_vm._v(" "),_c('option',{attrs:{"value":"Marfa"}},[_vm._v("Marfa")]),_vm._v(" "),_c('option',{attrs:{"value":"Materii prime"}},[_vm._v("Materii prime")]),_vm._v(" "),_c('option',{attrs:{"value":"Materiale consumabile"}},[_vm._v("Materiale consumabile")]),_vm._v(" "),_c('option',{attrs:{"value":"Semifabricate (Reteta)"}},[_vm._v("Semifabricate (Reteta)")]),_vm._v(" "),_c('option',{attrs:{"value":"Produs finit (Reteta)"}},[_vm._v("Produs finit (Reteta)")]),_vm._v(" "),_c('option',{attrs:{"value":"Produs rezidual"}},[_vm._v("Produs rezidual")]),_vm._v(" "),_c('option',{attrs:{"value":"Ambalaje"}},[_vm._v("Ambalaje")]),_vm._v(" "),_c('option',{attrs:{"value":"Obiecte de inventar"}},[_vm._v("Obiecte de inventar")])])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItem.code),expression:"newItem.code"}],staticClass:"form-control",attrs:{"type":"text","disabled":true,"placeholder":"Cod"},domProps:{"value":(_vm.newItem.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "code", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('el-select',{attrs:{"disabled":true,"placeholder":"Selectează unitatea de măsură"},model:{value:(_vm.newItem.unitMeasure),callback:function ($$v) {_vm.$set(_vm.newItem, "unitMeasure", $$v)},expression:"newItem.unitMeasure"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.quantity),expression:"newItem.quantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('invoice.quantity')},domProps:{"value":(_vm.newItem.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "quantity", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('el-select',{attrs:{"placeholder":"Cota TVA"},model:{value:(_vm.newItem.vatRate),callback:function ($$v) {_vm.$set(_vm.newItem, "vatRate", $$v)},expression:"newItem.vatRate"}},_vm._l((_vm.vats),function(vat){return _c('el-option',{key:vat.tax_id,attrs:{"label":((vat.amount) + " %"),"value":vat.amount}})}))],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.priceRON),expression:"newItem.priceRON",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","placeholder":_vm.$t('gestiune.pretFaraTva')},domProps:{"value":(_vm.newItem.priceRON)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "priceRON", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('el-select',{attrs:{"placeholder":"Prețul include TVA?"},model:{value:(_vm.newItem.includeVAT),callback:function ($$v) {_vm.$set(_vm.newItem, "includeVAT", $$v)},expression:"newItem.includeVAT"}},[_c('el-option',{attrs:{"label":"Cu TVA","value":"yes"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Fără TVA","value":"no"}})],1)],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.newItem.tva),expression:"newItem.tva",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":_vm.$t('gestiune.tva')},domProps:{"value":(_vm.newItem.tva)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newItem, "tva", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.addItem}},[_vm._v("\n                      "+_vm._s(_vm.$t('general.add'))+"\n                    ")])])]):_vm._e()],2)])])],_vm._v(" "),_c('div',{staticClass:"totals-container"},[_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Total fara TVA:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalFaraTva.toFixed(2))+" RON")])]),_vm._v(" "),_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Total TVA:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalTva.toFixed(2))+" RON")])]),_vm._v(" "),(_vm.totalCorectie !== 0)?_c('div',{staticClass:"total-row"},[_c('span',{staticClass:"label"},[_vm._v("Corectie Document:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalCorectie.toFixed(2))+" RON")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"total-row total-final"},[_c('span',{staticClass:"label"},[_vm._v("Total:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.totalFinal.toFixed(2))+" RON")])])])],2)]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v("Informatii aditionale factura")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"intocmitDe"}},[_vm._v("Întocmit de")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.intocmitDe),expression:"extraFields.intocmitDe"}],staticClass:"form-control",attrs:{"type":"text","id":"intocmitDe","placeholder":"Numele persoanei"},domProps:{"value":(_vm.extraFields.intocmitDe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "intocmitDe", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"cnp"}},[_vm._v("CNP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.cnp),expression:"extraFields.cnp"}],staticClass:"form-control",attrs:{"type":"text","id":"cnp","placeholder":"Cod Numeric Personal"},domProps:{"value":(_vm.extraFields.cnp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "cnp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"delegat"}},[_vm._v("Delegat")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.delegat),expression:"extraFields.delegat"}],staticClass:"form-control",attrs:{"type":"text","id":"delegat","placeholder":"Numele delegatului"},domProps:{"value":(_vm.extraFields.delegat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "delegat", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"carteIdentitate"}},[_vm._v("Carte Identitate")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.carteIdentitate),expression:"extraFields.carteIdentitate"}],staticClass:"form-control",attrs:{"type":"text","id":"carteIdentitate","placeholder":"Seria și numărul cărții de identitate"},domProps:{"value":(_vm.extraFields.carteIdentitate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "carteIdentitate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"auto"}},[_vm._v("Auto")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.auto),expression:"extraFields.auto"}],staticClass:"form-control",attrs:{"type":"text","id":"auto","placeholder":"Marca și modelul auto"},domProps:{"value":(_vm.extraFields.auto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "auto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"agentVanzari"}},[_vm._v("Agent vânzări")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.agentVanzari),expression:"extraFields.agentVanzari"}],staticClass:"form-control",attrs:{"type":"text","id":"agentVanzari","placeholder":"Numele agentului de vânzări"},domProps:{"value":(_vm.extraFields.agentVanzari)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "agentVanzari", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"punctDeLucruClient"}},[_vm._v("Punct de Lucru Client")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.punctDeLucruClient),expression:"extraFields.punctDeLucruClient"}],staticClass:"form-control",attrs:{"type":"text","id":"punctDeLucruClient","placeholder":"Locația punctului de lucru"},domProps:{"value":(_vm.extraFields.punctDeLucruClient)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "punctDeLucruClient", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"numarComandaBT13"}},[_vm._v("Număr comandă BT-13")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.numarComandaBT13),expression:"extraFields.numarComandaBT13"}],staticClass:"form-control",attrs:{"type":"text","id":"numarComandaBT13","placeholder":"Numărul comenzii"},domProps:{"value":(_vm.extraFields.numarComandaBT13)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "numarComandaBT13", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"numarContractBT12"}},[_vm._v("Număr contract BT-12")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.numarContractBT12),expression:"extraFields.numarContractBT12"}],staticClass:"form-control",attrs:{"type":"text","id":"numarContractBT12","placeholder":"Numărul contractului"},domProps:{"value":(_vm.extraFields.numarContractBT12)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "numarContractBT12", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"referintaProiectBT11"}},[_vm._v("Referință proiect BT-11")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.referintaProiectBT11),expression:"extraFields.referintaProiectBT11"}],staticClass:"form-control",attrs:{"type":"text","id":"referintaProiectBT11","placeholder":"Codul proiectului"},domProps:{"value":(_vm.extraFields.referintaProiectBT11)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "referintaProiectBT11", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"identificatorCumparatorBT46"}},[_vm._v("Identificator cumpărător BT-46")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.identificatorCumparatorBT46),expression:"extraFields.identificatorCumparatorBT46"}],staticClass:"form-control",attrs:{"type":"text","id":"identificatorCumparatorBT46","placeholder":"ID-ul cumpărătorului"},domProps:{"value":(_vm.extraFields.identificatorCumparatorBT46)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "identificatorCumparatorBT46", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"numarAvizReceptieBT15"}},[_vm._v("Număr aviz recepție BT-15")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.numarAvizReceptieBT15),expression:"extraFields.numarAvizReceptieBT15"}],staticClass:"form-control",attrs:{"type":"text","id":"numarAvizReceptieBT15","placeholder":"Numărul avizului"},domProps:{"value":(_vm.extraFields.numarAvizReceptieBT15)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "numarAvizReceptieBT15", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"referintaContabilaCumparatorBT19"}},[_vm._v("Referință contabilă cumpărător BT-19")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.referintaContabilaCumparatorBT19),expression:"extraFields.referintaContabilaCumparatorBT19"}],staticClass:"form-control",attrs:{"type":"text","id":"referintaContabilaCumparatorBT19","placeholder":"Referința contabilă"},domProps:{"value":(_vm.extraFields.referintaContabilaCumparatorBT19)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "referintaContabilaCumparatorBT19", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dataLivrarii"}},[_vm._v("Data livrării")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.dataLivrarii),expression:"extraFields.dataLivrarii"}],staticClass:"form-control",attrs:{"type":"date","id":"dataLivrarii"},domProps:{"value":(_vm.extraFields.dataLivrarii)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "dataLivrarii", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dataIncasarii"}},[_vm._v("Data încasării")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.dataIncasarii),expression:"extraFields.dataIncasarii"}],staticClass:"form-control",attrs:{"type":"date","id":"dataIncasarii"},domProps:{"value":(_vm.extraFields.dataIncasarii)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "dataIncasarii", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"bonNota"}},[_vm._v("Observații bon / comandă")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.bonNota),expression:"bonNota"}],staticClass:"form-control observatii-comanda-textarea",attrs:{"id":"bonNota","rows":"4","placeholder":"Detalii comandă și bon fiscal..."},domProps:{"value":(_vm.bonNota)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bonNota=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"notaInterna"}},[_vm._v("Notă internă")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFields.notaInterna),expression:"extraFields.notaInterna"}],staticClass:"form-control",attrs:{"id":"notaInterna","placeholder":"Informații suplimentare"},domProps:{"value":(_vm.extraFields.notaInterna)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.extraFields, "notaInterna", $event.target.value)}}})])])])])]),_vm._v(" "),_c('ManagementClientsAdd',{attrs:{"groupedLocations":_vm.groupedLocations}}),_vm._v(" "),_c('ManagementSeriesAdd',{attrs:{"locations":_vm.locations,"grouped-locations":_vm.groupedLocations,"vat-number":_vm.selectedLocation ? _vm.selectedLocation.inv_fiscal_code : ''},on:{"getSeries":_vm.getSeries}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-info-header"},[_c('div',{staticClass:"order-info-header-icon"},[_c('i',{staticClass:"ti-receipt"})]),_vm._v(" "),_c('div',[_c('p',{staticClass:"order-info-title"},[_vm._v("Informații comandă")]),_vm._v(" "),_c('p',{staticClass:"order-info-subtitle"},[_vm._v("Date preluate automat din comanda asociată")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-info-card-icon"},[_c('i',{staticClass:"ti-calendar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-info-card-icon"},[_c('i',{staticClass:"ti-shopping-cart-full"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-info-card-icon"},[_c('i',{staticClass:"ti-time"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-info-card-icon"},[_c('i',{staticClass:"ti-ticket"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-info-card-icon"},[_c('i',{staticClass:"ti-money"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vyeN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 50,
      tableData: [],
      gestiuniList: []
    };
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.fetchInitialStock();

    this.$bus.$on('refresh', this.handleRefresh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('refresh', this.handleRefresh);
  },

  methods: {
    handleRefresh: function handleRefresh() {
      this.fetchInitialStock();
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.fetchInitialStock(this.currentPage, this.pageSize);
    },
    getGestiuneNameById: function getGestiuneNameById(id) {
      var gest = this.gestiuneOptions.find(function (g) {
        return g._id === id || g.id === id;
      });
      return gest ? gest.name : id;
    },
    addInitialStock: function addInitialStock() {
      this.$router.push('/management/initialStock/add');
    },
    fetchInitialStock: function fetchInitialStock() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, response, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.companyID) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                clearTimeout(_this.loadingTimeout);
                _this.loadingTimeout = setTimeout(function () {
                  _this.loading = true;
                }, 100);

                _context.prev = 4;
                params = new URLSearchParams();

                params.append('externalCompanyId', _this.companyID);

                _context.next = 9;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/stoc-initial/list?' + params.toString());

              case 9:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 12;
                  break;
                }

                throw new Error('Failed to fetch stoc initial');

              case 12:
                _context.next = 14;
                return response.json();

              case 14:
                data = _context.sent;

                _this.tableData = data.documents.map(function (doc) {
                  return {
                    _id: doc.id,
                    date: doc.date,
                    gestiune: doc.gestiune,
                    gestiune_id: doc.gestiune_id,
                    number_of_products: doc.number_of_products
                  };
                });

                _this.totalItems = _this.tableData.length;
                _this.currentPage = 1;
                _this.pageSize = _this.tableData.length;_context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](4);

                __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
                  icon: 'error',
                  title: 'Eroare!',
                  text: 'Request failed: ' + _context.t0.message,
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching stoc initial:', _context.t0);

              case 25:
                _context.prev = 25;

                clearTimeout(_this.loadingTimeout);
                _this.loading = false;
                return _context.finish(25);

              case 29:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 21, 25, 29]]);
      }))();
    },
    editInitialStock: function editInitialStock(row) {
      this.$router.push('/management/initialStock/edit/' + row._id);
    },
    downloadFile: function downloadFile(row, format) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var gestiuneId, externalCompanyId, url, response, blob, link;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                gestiuneId = row.gestiune_id;
                externalCompanyId = _this2.companyID;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/stoc-initial/' + gestiuneId + '/' + format + '?externalCompanyId=' + externalCompanyId;
                _context2.next = 5;
                return fetch(url);

              case 5:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 8;
                  break;
                }

                throw new Error(response.statusText);

              case 8:
                _context2.next = 10;
                return response.blob();

              case 10:
                blob = _context2.sent;
                link = document.createElement('a');


                link.href = URL.createObjectURL(blob);
                link.download = 'stoc-initial-' + gestiuneId + '.' + format;
                link.click();

                URL.revokeObjectURL(link.href);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "w3Bt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__ = __webpack_require__("RPVL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7071eade_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineChart_vue__ = __webpack_require__("32rl");
function injectStyle (ssrContext) {
  __webpack_require__("ettC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7071eade"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7071eade_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w45s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w4Yf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchDrivers_vue__ = __webpack_require__("2CXN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8fb6b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchDrivers_vue__ = __webpack_require__("A8RD");
function injectStyle (ssrContext) {
  __webpack_require__("XRj4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DispatchDrivers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8fb6b1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DispatchDrivers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w5TE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w6nM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscriptionPage_vue__ = __webpack_require__("dCoM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30db0f6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscriptionPage_vue__ = __webpack_require__("a5a3");
function injectStyle (ssrContext) {
  __webpack_require__("YiTc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuSubscriptionPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30db0f6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuSubscriptionPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w8TW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Management_ManagementSeriesAdd_vue__ = __webpack_require__("kgt7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ManagementSeriesAdd: __WEBPACK_IMPORTED_MODULE_11__Management_ManagementSeriesAdd_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      loadingTimeout: null,
      gestiune: '',
      inventoryNumber: '',
      inventoryDate: this.getLocalDateTimeString(),
      selectedLocation: null,
      selectedGestiune: null,
      searchProdName: null,
      extraFields: {
        'presedinte': '',
        'comisia': '',
        'gestionar': '',
        'contabilitate': '',
        'nota': '',
        'nota_completare': ''
      },
      newItem: {
        name: '',
        quantity: '',
        unitMeasure: '',
        stocFaptic: null
      },
      modelValidate: {
        location: 'required',
        gestiune: 'required',
        serie: 'required',
        date: 'required'
      },
      categories: ['Marfa', 'Materii prime', 'Materiale consumabile', 'Semifabricate (Reteta)', 'Produs finit (Reteta)', 'Produs rezidual', 'Ambalaje', 'Obiecte de inventar'],
      state: null,
      selectedCategory: null,
      isInEdit: false,
      isBlocked: false,
      locations: [],
      gestiuneOptions: [],
      productsList: [],
      gestiuniList: [],
      inventoryNumberOptions: []
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee() {
      var vatNumber, series, number, externalLocationId;
      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.companyID = _this.$session.get('selectedCompany');

              vatNumber = _this.route && _this.route.params && _this.route.params.vatNumber;
              series = _this.route && _this.route.params && _this.route.params.series;
              number = _this.route && _this.route.params && _this.route.params.number;
              externalLocationId = _this.route && _this.route.params && _this.route.params.externalLocationId;
              _context.next = 7;
              return _this.fetchLocation();

            case 7:
              console.log('Locations after fetch:', _this.locations);
              _context.next = 10;
              return _this.fetchGestiuni();

            case 10:
              console.log('Gestiuni after fetch:', _this.gestiuneOptions);

              if (!(vatNumber && series && number)) {
                _context.next = 15;
                break;
              }

              _this.isInEdit = true;

              _context.next = 15;
              return _this.getInventory(vatNumber, series, number, externalLocationId);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    selectedLocation: function selectedLocation() {
      if (!this.selectedGestiune && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
      if (!this.isInEdit) {
        this.productsList = [];
        this.getSeries();
      }
    },
    selectedGestiune: function selectedGestiune() {
      if (!this.isInEdit) {
        this.fetchProducts();
      }
    },
    inventoryDate: function inventoryDate() {
      if (!this.isInEdit) {
        this.fetchProducts();
      }
    }
  },
  computed: {
    today: function today() {
      var now = new Date();
      now.setSeconds(0, 0);
      return now.toISOString().slice(0, 16);
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveInventar(false);
        }
      });
    },
    seriesOptionsWithAdd: function seriesOptionsWithAdd() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(this.inventoryNumberOptions), [{ _id: 'add', label: '➕ Adaugă serie' }]);
    },
    searchResults: function searchResults() {
      return this.productsList.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, item, {
          label: item.productDetails.name
        });
      });
    },
    groupedLocations: function groupedLocations() {
      var groups = {};

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this3 = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this3.selectedLocation.true_id;
      });
      return result;
    }
  },
  methods: {
    filterProducts: function filterProducts() {
      var _this4 = this;

      this.productsList.forEach(function (p) {
        if (!_this4.selectedCategory || p.productDetails.categorie === _this4.selectedCategory) {
          p.is_hiden = 0;
        } else {
          p.is_hiden = 1;
        }
      });
    },
    updateStockScriptic: function updateStockScriptic() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var stock, stockMap;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.fetchProducts(true);

              case 2:
                stock = _context2.sent;

                if (stock.length) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:
                stockMap = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a(stock.map(function (p) {
                  return [p.product_id, p];
                }));


                _this5.productsList = _this5.productsList.map(function (p) {
                  var updated = stockMap.get(p.product_id);

                  if (updated) {
                    var changed = p.quantity !== updated.quantity;

                    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, p, {
                      quantity: updated.quantity,
                      _updated: changed
                    });
                  }

                  return p;
                });

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    onProductSelect: function onProductSelect(selected) {
      if (selected && selected.productDetails) {
        this.newItem = {
          id: selected.productDetails._id,
          name: selected.productDetails.name,
          quantity: selected.quantity || 0,
          unitMeasure: selected.productDetails.um || '',
          stocFaptic: null
        };
      }
    },
    formatDateTime: function formatDateTime(value) {
      if (!value) return '-';

      var d = new Date(value);

      return new Intl.DateTimeFormat('ro-RO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(d);
    },
    getProductNameById: function getProductNameById(productId) {
      if (!productId) return '';

      var product = this.productsList.find(function (p) {
        return p.product_id === productId;
      });
      if (product && product.productDetails && product.productDetails.name) {
        return product.productDetails.name;
      }

      return productId;
    },
    translateSaveError: function translateSaveError(error) {
      var translations = {
        'Inventory cannot be validated before existing stock movements': 'Inventarul nu poate fi validat înaintea mișcărilor de stoc existente.'
      };

      return translations[error] || error;
    },
    formatSaveError: function formatSaveError(data, status) {
      var _this6 = this;

      var fallback = 'A apărut o problemă la salvare.';
      if (!data || (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(data)) !== 'object') {
        return status ? fallback + '<br>Cod: ' + status : fallback;
      }

      var message = this.translateSaveError(data.error || data.message) || fallback;
      var details = data.details;
      if (!details || (typeof details === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(details)) !== 'object') {
        return this.escapeHtml(message);
      }

      var rows = [];
      if (details.product_id) {
        rows.push('<strong>Produs:</strong> ' + this.escapeHtml(this.getProductNameById(details.product_id)));
      }
      if (details.movement_timestamp) {
        rows.push('<strong>Data mi\u0219c\u0103rii:</strong> ' + this.escapeHtml(this.formatDateTime(details.movement_timestamp)));
      }
      if (details.movement_id) {
        rows.push('<strong>ID mi\u0219care:</strong> ' + this.escapeHtml(details.movement_id));
      }

      var extraKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(details).filter(function (key) {
        return !['product_id', 'movement_timestamp', 'movement_id'].includes(key);
      });
      extraKeys.forEach(function (key) {
        rows.push('<strong>' + _this6.escapeHtml(key) + ':</strong> ' + _this6.escapeHtml(String(details[key])));
      });

      if (!rows.length) {
        return this.escapeHtml(message);
      }

      return this.escapeHtml(message) + '<br><br>' + rows.join('<br>');
    },
    escapeHtml: function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    onPrintInventory: function onPrintInventory() {
      var _this7 = this;

      var produse = this.productsList.map(function (p) {
        return {
          productDetails: {
            name: p.productDetails.name || '',
            um: p.productDetails.um || ''
          },
          quantity: Number((p.quantity || 0).toFixed(4))
        };
      });

      var gestiuneObj = this.filteredGestiuni.find(function (g) {
        return g.id === _this7.selectedGestiune;
      });

      var gestiuneName = gestiuneObj ? gestiuneObj.name || '' : '';

      var selectedSerie = this.seriesOptionsWithAdd.find(function (s) {
        return s._id === _this7.inventoryNumber;
      });

      var serieLabel = selectedSerie && selectedSerie.label ? selectedSerie.label : '';

      this.printFisaInventariere(produse, serieLabel, this.inventoryDate, gestiuneName);
    },
    printFisaInventariere: function printFisaInventariere() {
      var produse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var serie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var gestiuneName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      var html = '\n        <html>\n          <head>\n            <title>Fi\u0219a de inventariere</title>\n            <style>\n              body {\n                font-family: Arial, sans-serif;\n                padding: 20px;\n              }\n              h1 {\n                text-align: center;\n                margin-bottom: 5px;\n              }\n              .meta {\n                display: flex;\n                justify-content: space-between;\n                margin-bottom: 20px;\n                font-size: 14px;\n              }\n              table {\n                width: 100%;\n                border-collapse: collapse;\n              }\n              th, td {\n                border: 1px solid #000;\n                padding: 8px;\n                font-size: 13px;\n                text-align: left;\n              }\n              th {\n                background: #f2f2f2;\n              }\n              .right {\n                text-align: right;\n              }\n            </style>\n          </head>\n          <body>\n\n            <h1>FI\u0218\u0102 DE INVENTARIERE</h1>\n\n            <div class="meta">\n              <div><strong>Serie:</strong> ' + serie + '</div>\n              <div><strong>Data:</strong> ' + this.formatDateTime(data) + '</div>\n            </div>\n\n            <div class="meta">\n              <div><strong>Gestiune:</strong> ' + gestiuneName + '</div>\n            </div>\n\n            <table>\n              <thead>\n                <tr>\n                  <th>#</th>\n                  <th>Denumire produs</th>\n                  <th>UM</th>\n                  <th>Stoc scriptic</th>\n                  <th>Stoc faptic</th>\n                </tr>\n              </thead>\n              <tbody>\n                ' + produse.map(function (p, i) {
        return '\n                  <tr>\n                    <td>' + (i + 1) + '</td>\n                    <td>' + (p.productDetails.name || '') + '</td>\n                    <td>' + (p.productDetails.um || '') + '</td>\n                    <td class="right">' + (p.quantity || 0) + '</td>\n                    <td></td>\n                  </tr>\n                ';
      }).join('') + '\n              </tbody>\n            </table>\n\n          </body>\n        </html>\n      ';

      var win = window.open('', '_blank', 'width=900,height=700');
      win.document.open();
      win.document.write(html);
      win.document.close();
      win.focus();
      win.print();
    },
    handleSerieChange: function handleSerieChange(val) {
      if (val === 'add') {
        this.openSeriesModal();
        this.inventoryNumber = null;
      }
    },
    openSeriesModal: function openSeriesModal() {
      this.$modal.show('addSeriesModal');
    },
    getSeries: function getSeries() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this8.companyID,
                    vatNumber: _this8.selectedLocation.inv_fiscal_code,
                    tip: 'inventar'
                  })
                });

              case 3:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 6;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 6:
                _context3.next = 8;
                return response.json();

              case 8:
                data = _context3.sent;


                if (Array.isArray(data.series)) {
                  _this8.inventoryNumberOptions = data.series.map(function (serie) {
                    return {
                      _id: serie._id,
                      series: serie.series,
                      currentNumber: serie.currentNumber,
                      label: serie.series + ' (' + serie.currentNumber + ')'
                    };
                  });
                  _this8.inventoryNumber = _this8.inventoryNumberOptions.length > 0 ? _this8.inventoryNumberOptions[0]._id : '';
                } else {
                  console.error('Format invalid pentru series:', data);
                }
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](0);

                console.error('Error fetching series:', _context3.t0);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8, [[0, 12]]);
      }))();
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    addItem: function addItem() {
      var _this9 = this;

      if (this.newItem && this.newItem.name && this.newItem.stocFaptic != null) {
        var index = this.productsList.findIndex(function (p) {
          return p.productDetails._id === _this9.newItem.id;
        });
        if (index !== -1) {
          this.productsList[index].stocFaptic = this.newItem.stocFaptic;
        } else {}
        this.resetNewItem();
      } else {}
      return false;
    },
    removeItem: function removeItem(index) {},
    resetNewItem: function resetNewItem() {
      this.searchProdName = null;
      this.newItem = {
        productName: '',
        code: '',
        unitMeasure: '',
        stocScriptic: null,
        stocFaptic: null
      };
    },
    fetchLocation: function fetchLocation() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dataToSend = {
                  company_id: _this10.companyID,
                  token: _this10.$session.get('token')
                };
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this10.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                    if (!response || response.status !== true || !response.data || !response.data.locations) {
                      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                        title: 'Eroare!',
                        text: response.message || 'Eroare la preluarea locațiilor.',
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false
                      });
                      reject(new Error(response.message || 'Eroare la preluarea locațiilor'));
                      return;
                    }

                    _this10.locations = response.data.locations;
                    resolve(_this10.locations);
                  });
                }));

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this10);
      }))();
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this11.companyID);

              case 3:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context5.next = 8;
                return response.json();

              case 8:
                data = _context5.sent;

                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this11.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      externalLocationId: gest.externalLocationId || ''
                    };
                  });
                } else {
                  _this11.$message.error('Nu s-a primit un array valid de la server.');
                }
                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](0);

                _this11.$message.error('Request failed: ' + _context5.t0.message);
                console.error('Error fetching management data:', _context5.t0);

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this11, [[0, 12]]);
      }))();
    },
    fetchProducts: function fetchProducts() {
      var _this12 = this;

      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this12.selectedLocation) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return', []);

              case 2:

                if (!refresh) {
                  _this12.productsList = [];
                }

                if (refresh) {
                  __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                    title: 'Se actualizează stocul scriptic...',
                    text: 'Vă rugăm așteaptati până se actualizează stocul scriptic cu valorile curente din gestiune',
                    allowOutsideClick: false,
                    didOpen: function didOpen() {
                      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.showLoading();
                    }
                  });
                }

                clearTimeout(_this12.loadingTimeout);
                _this12.loadingTimeout = setTimeout(function () {
                  _this12.loading = true;
                }, 10);

                _context6.prev = 6;
                _context6.next = 9;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/stock?externalCompanyId=' + _this12.companyID + '&gestiune=' + _this12.selectedGestiune + '&externalLocationId=' + _this12.selectedLocation.true_id + '&date=' + _this12.inventoryDate);

              case 9:
                response = _context6.sent;
                _context6.next = 12;
                return response.json();

              case 12:
                data = _context6.sent;

                if (Array.isArray(data.stock)) {
                  _context6.next = 16;
                  break;
                }

                _this12.$message.error('Eroare la încărcarea produselor.');
                return _context6.abrupt('return', []);

              case 16:

                if (!refresh) {
                  _this12.productsList = data.stock;
                }

                clearTimeout(_this12.loadingTimeout);
                _this12.loading = false;
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();

                return _context6.abrupt('return', data.stock);

              case 23:
                _context6.prev = 23;
                _context6.t0 = _context6['catch'](6);

                _this12.$message.error('Eroare: ' + _context6.t0.message);
                clearTimeout(_this12.loadingTimeout);
                _this12.loading = false;
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                return _context6.abrupt('return', []);

              case 30:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this12, [[6, 23]]);
      }))();
    },
    getInventory: function getInventory(vatNumber, series, number, externalLocationId) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var url, response, data, locationId, foundGestiune, itemsMap;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this13.loading = true;

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Se încarcă...',
                  text: 'Așteaptă încărcarea datelor',
                  allowOutsideClick: false,
                  didOpen: function didOpen() {
                    __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.showLoading();
                  }
                });

                _context7.prev = 2;
                url = new URL("https://fiscal-dev.cdntaptasty.com" + ':4443/inventar');

                url.searchParams.append('externalCompanyId', _this13.companyID);
                url.searchParams.append('vatNumber', vatNumber);
                url.searchParams.append('series', series);
                url.searchParams.append('number', number);
                if (externalLocationId) {
                  url.searchParams.append('externalLocationId', externalLocationId);
                }

                _context7.next = 11;
                return fetch(url.toString());

              case 11:
                response = _context7.sent;

                if (response.ok) {
                  _context7.next = 14;
                  break;
                }

                throw new Error('Eroare la preluarea inventarului');

              case 14:
                _context7.next = 16;
                return response.json();

              case 16:
                data = _context7.sent;
                locationId = externalLocationId || data.externalLocationId;

                _this13.selectedLocation = _this13.locations.find(function (loc) {
                  return loc.inv_fiscal_code === vatNumber && (!locationId || String(loc.true_id) === String(locationId));
                });

                _this13.inventoryNumberOptions = [{
                  series: data.series,
                  currentNumber: data.number,
                  label: data.series + ' (' + data.number + ')',
                  _id: data.series + '-' + data.number
                }];
                _this13.inventoryNumber = _this13.inventoryNumberOptions[0]._id;

                _this13.extraFields = Array.isArray(data.extraFields) ? data.extraFields.reduce(function (acc, _ref3) {
                  var key = _ref3.key,
                      value = _ref3.value;

                  acc[key] = value;
                  return acc;
                }, {}) : {};
                _this13.inventoryDate = data.date;

                foundGestiune = _this13.gestiuneOptions.find(function (g) {
                  return g.id === data.gestiune && _this13.selectedLocation && g.externalLocationId === _this13.selectedLocation.true_id;
                });


                _this13.selectedGestiune = foundGestiune ? foundGestiune.id : _this13.gestiuneOptions.length > 0 ? _this13.gestiuneOptions[0].id : null;

                _this13.state = data.state;
                if (data.state === 'VALIDATED') {
                  _this13.isBlocked = true;
                }

                _context7.next = 29;
                return _this13.fetchProducts();

              case 29:
                itemsMap = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a(data.items.map(function (item) {
                  return [item.product_id, item];
                }));

                _this13.productsList = _this13.productsList.map(function (p) {
                  var saved = itemsMap.get(p.product_id);
                  if (saved) {
                    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, p, {
                      quantity: saved.quantity_scriptic || 0,
                      stocFaptic: saved.quantity !== undefined && saved.quantity !== null ? saved.quantity : null
                    });
                  }
                  return p;
                });
                _context7.next = 36;
                break;

              case 33:
                _context7.prev = 33;
                _context7.t0 = _context7['catch'](2);

                console.error(_context7.t0);

              case 36:
                _context7.prev = 36;

                _this13.loading = false;
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.close();
                return _context7.finish(36);

              case 40:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this13, [[2, 33, 36, 40]]);
      }))();
    },
    saveInventar: function saveInventar(andValidate) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var series, number, match, extraFieldsArray, items, confirmed, status, response, data;
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                series = '';
                number = '';
                match = _this14.inventoryNumberOptions.find(function (opt) {
                  return opt._id === _this14.inventoryNumber;
                });

                if (match) {
                  series = match.series;
                  number = match.currentNumber;
                }

                extraFieldsArray = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(_this14.extraFields).map(function (_ref4) {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
                      key = _ref5[0],
                      value = _ref5[1];

                  return {
                    key: key,
                    value: value
                  };
                });
                items = _this14.productsList.map(function (p) {
                  return {
                    product_name: p.productDetails.name,
                    product_um: p.productDetails.um,
                    quantity_scriptic: p.quantity,
                    product_id: p.product_id,
                    quantity: p.stocFaptic !== undefined && p.stocFaptic !== null ? Number(p.stocFaptic) : null,
                    value: p.value || 0
                  };
                }).filter(function (item) {
                  return item.quantity !== null;
                });

                if (items.length) {
                  _context8.next = 9;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Trebuie să completezi cel puțin un produs cu valoare la stoc faptic.',
                  type: 'warning'
                });
                return _context8.abrupt('return');

              case 9:
                _context8.next = 11;
                return __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  icon: 'warning',
                  title: 'Atenție!',
                  text: 'Vă rog să vă asigurați că unitățile de măsură selectate sunt corecte și că prețul este corespunzător unității de măsură selectate. În cazul în care sunt corecte, continuați apăsând butonul „Salvează”.',
                  showCancelButton: true,
                  confirmButtonText: 'Salvează',
                  cancelButtonText: 'Anulează'
                }).then(function (result) {
                  return !!result;
                }).catch(function () {
                  return false;
                });

              case 11:
                confirmed = _context8.sent;

                if (confirmed) {
                  _context8.next = 14;
                  break;
                }

                return _context8.abrupt('return');

              case 14:
                status = 'DRAFT';

                if (andValidate) {
                  status = 'VALIDATED';
                }

                _this14.isBlocked = true;
                _this14.loading = true;

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Se salvează...',
                  text: 'Te rog așteaptă până se finalizează salvarea',
                  allowOutsideClick: false,
                  didOpen: function didOpen() {
                    __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.showLoading();
                  }
                });

                _context8.prev = 19;
                _context8.next = 22;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/inventar', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this14.companyID,
                    vatNumber: _this14.selectedLocation.inv_fiscal_code,
                    externalLocationId: _this14.selectedLocation.true_id,
                    series: series,
                    number: number,
                    date: _this14.inventoryDate,
                    gestiune: _this14.selectedGestiune,
                    state: status,
                    extraFields: extraFieldsArray,
                    items: items
                  })
                });

              case 22:
                response = _context8.sent;
                _context8.next = 25;
                return response.json().catch(function () {
                  return null;
                });

              case 25:
                data = _context8.sent;

                if (response.ok) {
                  _context8.next = 29;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Eroare',
                  html: _this14.formatSaveError(data, response.status),
                  type: 'error'
                });
                return _context8.abrupt('return');

              case 29:

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Success',
                  text: 'Inventar salvat cu succes.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                });

                _this14.$bus.$emit('refresh');
                _this14.$bus.$emit('close-modal');
                _context8.next = 38;
                break;

              case 34:
                _context8.prev = 34;
                _context8.t0 = _context8['catch'](19);

                console.error('Error saving inventory:', _context8.t0);

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
                  title: 'Eroare',
                  html: _this14.formatSaveError(_context8.t0 && _context8.t0.payload, _context8.t0 && _context8.t0.status),
                  type: 'error'
                });

              case 38:
                _context8.prev = 38;

                _this14.isBlocked = false;
                _this14.loading = false;
                return _context8.finish(38);

              case 42:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this14, [[19, 34, 38, 42]]);
      }))();
    }
  }
});

/***/ }),

/***/ "w8qs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wF+N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_FileInput_vue__ = __webpack_require__("lcot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_ImageInput_vue__ = __webpack_require__("575J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_DisplayQr_vue__ = __webpack_require__("+65S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Inputs_ImportProductsInput_vue__ = __webpack_require__("s+lY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_ArchiveInput_vue__ = __webpack_require__("uXu5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Inputs_DisplayQrApp_vue__ = __webpack_require__("Vqwd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_css__);







var _components;













__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'FileInput', __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_FileInput_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'ImageInput', __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Inputs_ImageInput_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'DisplayQr', __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Inputs_DisplayQr_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'DisplayQrApp', __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Inputs_DisplayQrApp_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'ImportProductsInput', __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Inputs_ImportProductsInput_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'ArchiveInput', __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Inputs_ArchiveInput_vue__["a" /* default */]), _components),
  props: {
    countries: {},
    modeldata: {},
    taxesData: {},
    tabRefresh: {},
    isLocationGroups: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isLocationGroups: function isLocationGroups() {
      if (this.isLocationGroups) {
        this.getData();
      }
    },
    countries: function countries(value) {
      this.countriesList = value;
    },
    modeldata: function modeldata(value) {
      for (var idx in value.locations_details) {
        if (!value.locations_details[idx].vat) {
          value.locations_details[idx].vat = [];
        }
        if (!value.locations_details[idx].working_hours) {
          value.locations_details[idx].working_hours = [];
        }
        if (!value.locations_details[idx].allow_preorder) {
          value.locations_details[idx].allow_preorder = false;
        }
        for (var iDay in this.days) {
          var day = this.days[iDay];
          var index = this.getObjectByElemKeyValue('day', day, value.locations_details[idx].working_hours);
          if (index === false) {
            value.locations_details[idx].working_hours.push({ day: day, open_to: '', open_from: '', open: false });
          } else if (value.locations_details[idx].working_hours[index].open === undefined) {}
        }
      }
      this.showDelete = value.locations_details.length > 1;
      this.model = value;
      for (var locIndex in value.locations_details) {
        if (value.locations_details[locIndex].vat) {
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(this.model.locations_details[locIndex], 'vat', value.locations_details[locIndex].vat);
        }
      }
    },
    taxesData: function taxesData(value) {
      this.taxes = value.taxes;
      this.vat = value.vat;
    },
    tabRefresh: function tabRefresh(value) {
      if (value === this.$t('settingCompany.companyLocations')) {
        this.showUpdateWarning = false;
        var data = {
          token: this.$session.get('token')
        };
        var self = this;
        var companyID = this.$session.get('selectedCompany');

        this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response) {
          if (response.status === true) {
            self.$emit('updateModelData', response.data[0]);
          }
        });
      }
    },

    'model.locations_details': {
      handler: function handler(newval, oldval) {
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(this.model, 'locations_details', newval);
      },
      deep: true
    }
  },
  data: function data() {
    return {
      apiUrl: '',
      model: this.value || this.modeldata,
      countriesList: this.value || this.countries,
      sortMethodsList: [],
      states: [],
      taxes: this.value || this.taxesData.taxes,
      vat: this.value || this.taxesData.vat,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      showDelete: false,
      modelValidate: {
        name: { required: true },
        email: { required: true },
        phone: { required: true },
        number: { required: true },
        street: { required: true },
        city: { required: true },
        state: { required: true },
        country: { required: true },
        working_hours: { required: true },
        email_feedback: { required: true }
      },
      timeFormat: 'HH:mm',
      dateFormat: 'DD/MM/YYYY',
      pickerNames: ['date_from', 'date_to'],
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      pickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59',
        format: this.timeFormat
      },
      showUpdateWarning: false,
      languages: this.$session.get('defaultData')['available_languages'],
      windowHeight: 0,
      navbarHeaderHeight: 0,
      pageTopHeight: 76,
      loading: true,
      paymentGroups: null,
      deliveryMethods: [],
      menuType: [{ 'id': 0, 'label': 'PDF' }, { 'id': 1, 'label': 'Dynamic' }]
    };
  },

  updated: function updated() {},
  computed: {},
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.doHeightCalculation();
      _this.loading = false;

      window.addEventListener('resize', function () {
        _this.doHeightCalculation();
      });
    });
  },

  methods: {
    syncEpRestaurantMenu: function syncEpRestaurantMenu(location) {
      var _this2 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };

      if (update) {
        data.update = true;
      }

      this.apiRequest('/ep-restaurant/import-menu/' + location.ep_restaurant_id, 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this2.loading = false;
      });
    },
    syncFreyaCloudMenu: function syncFreyaCloudMenu(location) {
      var _this3 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };

      this.apiRequest('/freya-cloud/import-products/' + location.freya_cloud_id, 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this3.loading = false;
      });
    },
    syncGlovoMenu: function syncGlovoMenu(location) {
      var _this4 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };
      this.apiRequest('/glovo/sync-menu', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: response.errorCode ? _this4.$t('glovo.' + response.errorCode) : 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this4.loading = false;
      });
    },
    importCategories: function importCategories(location) {
      var _this5 = this;

      this.$nextTick(function () {
        this.loading = true;
      });

      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };

      this.apiRequest('/sync-categories-rkeeper', 'POST', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: '',
            text: _this5.$t('rkeeper.importSuccess'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          _this5.$nextTick(function () {
            _this5.loading = false;
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: '',
            text: _this5.$t('rkeeper.importError'),
            type: 'error',
            showConfirmButton: false,
            timer: 1500
          });
          _this5.$nextTick(function () {
            _this5.loading = false;
          });
        }
      });
    },
    importProducts: function importProducts(location) {
      var _this6 = this;

      this.$nextTick(function () {
        this.loading = true;
      });

      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };

      this.apiRequest('/sync-products-rkeeper', 'POST', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: '',
            text: _this6.$t('rkeeper.importSuccess'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          _this6.$nextTick(function () {
            _this6.loading = false;
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: '',
            text: _this6.$t('rkeeper.importError'),
            type: 'error',
            showConfirmButton: false,
            timer: 1500
          });
          _this6.$nextTick(function () {
            _this6.loading = false;
          });
        }
      });
    },
    syncProductPrices: function syncProductPrices(location) {
      var _this7 = this;

      this.$nextTick(function () {
        this.loading = true;
      });

      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };

      this.apiRequest('/sync-product-prices-rkeeper', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: '',
            text: _this7.$t('rkeeper.syncSuccess'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          _this7.$nextTick(function () {
            _this7.loading = false;
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: '',
            text: _this7.$t('rkeeper.syncError'),
            type: 'error',
            showConfirmButton: false,
            timer: 1500
          });
        }
        _this7.$nextTick(function () {
          _this7.loading = false;
        });
      });
    },
    syncOptionPrices: function syncOptionPrices(location) {
      var _this8 = this;

      this.$nextTick(function () {
        this.loading = true;
      });

      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };

      this.apiRequest('/sync-option-prices-rkeeper', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: '',
            text: _this8.$t('rkeeper.syncSuccess'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          _this8.$nextTick(function () {
            _this8.loading = false;
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            title: '',
            text: _this8.$t('rkeeper.syncError'),
            type: 'error',
            showConfirmButton: false,
            timer: 1500
          });
        }
        _this8.$nextTick(function () {
          _this8.loading = false;
        });
      });
    },
    updateTazzMenu: function updateTazzMenu(location) {
      var _this9 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };
      this.apiRequest('/tazz/update-menu', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: response.errorCode ? _this9.$t('importProductsError.' + response.errorCode) : 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this9.loading = false;
      });
    },
    updateProductPricesMagister: function updateProductPricesMagister(location) {
      var _this10 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };
      this.apiRequest('/magister/sync-products', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this10.loading = false;
      });
    },
    updateProductStocksMagister: function updateProductStocksMagister(location) {
      var _this11 = this;

      this.loading = true;
      var data = {
        token: this.$session.get('token'),
        location_id: location.true_id,
        company_id: location.company_id
      };
      this.apiRequest('/magister/sync-stock', 'POST', data, function (response) {
        if (response.status) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: 'Success',
            type: 'success',
            showCancelButton: false
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: 'Error',
            type: 'error',
            showCancelButton: false
          });
        }
        _this11.loading = false;
      });
    },
    updateVatPrinterId: function updateVatPrinterId(obj, locIndex, taxIndex) {
      var selectElement = obj.target;
      var selectedOptionName = selectElement.options[selectElement.selectedIndex].getAttribute('data-name');

      this.model.locations_details[locIndex].taxes[taxIndex].name = selectedOptionName;
    },
    getData: function getData() {
      var _this12 = this;

      this.deliveryMethods = this.getCompanyDetail('delivery_options_labels');
      this.timeFormat = this.getCompanyDetail('time_format');
      this.dateFormat = this.getCompanyDetail('date_format');
      this.sortMethodsList = this.$session.get('defaultData').sort_products_methods;
      var data = {
        token: this.$session.get('token')
      };
      this.apiRequest('/settings/payment-groups/' + this.$session.get('selectedCompany'), 'GET', data, function (response) {
        if (response.status === true) {
          if (response.data.length === 0) {
            _this12.paymentGroups = null;
          } else {
            _this12.paymentGroups = response.data;
          }
        }
      });
    },
    checkVal: function checkVal(location) {},
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate(pageId) {
      var _this13 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this13.saveDetails(false, null);
        } else {}
      });
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
    },
    showStateDrop: function showStateDrop(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);

      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return true;
      } else {
        return false;
      }
    },
    getStatesOptions: function getStatesOptions(location) {
      var countryIso = location.country;
      var countries = this.$session.get('defaultData').countries;
      var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);

      if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
        return countries[countryIdx].states;
      } else {
        return [];
      }
    },
    updateCountry: function updateCountry(location) {
      location.state = null;
      location.state_id = null;
    },
    disableTaxOption: function disableTaxOption(locId, taxId) {
      var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details);
      var thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.model.locations_details[locIdx]['taxes']);

      if (thisTaxIdx !== false) {
        return true;
      } else {
        return false;
      }
    },
    disableVatOption: function disableVatOption(locIdx, taxId) {
      var thisTaxIdx = this.getObjectByElemKeyValue('tax_id', taxId, this.model.locations_details[locIdx]['vat']);

      if (thisTaxIdx !== false) {
        return true;
      } else {
        return false;
      }
    },
    addLocation: function addLocation() {
      var data = {
        'token': this.$session.get('token'),
        'type': 'hashes'
      };
      var self = this;
      this.apiRequest('/helpers', 'GET', data, function (response) {
        if (response.status === true) {
          var newRow = {
            id: null,
            city: '',
            country: '',
            email: null,
            name: null,
            taxes: [],
            image: null,
            use_dynamic_menu: 1,
            ordering_management: [{
              type: 'pick_up',
              label: 'Pick-up',
              enabled: false,
              available_days: [],
              default_waiting_time: null,
              payment_options: { cash: false, credit_card: false, pos: false },
              delivery_hour_usage: 0,
              hour_and_date_delivery_hour_usage: 1
            }, {
              type: 'meet_half',
              label: 'Meet me half way',
              enabled: false,
              available_days: [],
              default_waiting_time: null,
              payment_options: { cash: false, credit_card: false, pos: false },
              locations: [],
              delivery_hour_usage: 0,
              hour_and_date_delivery_hour_usage: 1
            }, {
              type: 'delivery',
              label: 'Delivery',
              enabled: false,
              available_days: [],
              default_waiting_time: null,
              payment_options: { cash: false, credit_card: false, pos: false },
              cost: null,
              shipping_cost: [],
              delivery_hour_usage: 0,
              hour_and_date_delivery_hour_usage: 1
            }, {
              type: 'eat_location',
              label: 'Eat on location',
              enabled: false,
              available_days: [],
              default_waiting_time: null,
              payment_options: { cash: false, credit_card: false, pos: false },
              delivery_hour_usage: 0,
              hour_and_date_delivery_hour_usage: 1
            }, {
              type: 'self_ordering',
              label: 'Self Ordering',
              enabled: false,
              available_days: [],
              default_waiting_time: null,
              max_distance_in_meter: 50,
              payment_options: { cash: false, credit_card: false, pos: false },
              delivery_hour_usage: 0,
              hour_and_date_delivery_hour_usage: 1
            }],
            phone: null,
            street: null,
            number: null,
            working_hours: []
          };

          newRow.id = response.data[0].id;

          newRow.isNew = true;

          for (var iDay in self.days) {
            newRow.working_hours.push({ day: self.days[iDay], open_to: '22:00', open_from: '10:00', open: false });
          }

          for (var iOrder in newRow.ordering_management) {
            for (var _iDay in self.days) {
              newRow.ordering_management[iOrder].available_days.push({ day: self.days[_iDay], open_to: '22:00', open_from: '10:00', open: false });
            }
          }
          self.model.locations_details.unshift(newRow);
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    scrollToPx: function scrollToPx(px) {
      var elem = this.$el;

      elem.scrollTop = elem.clientHeight;
      elem.scrollIntoView({
        alignTop: true,
        behavior: 'smooth'
      });
    },
    deleteLocation: function deleteLocation(id) {
      var btnCounter = 3;
      var self = this;
      var companyID = this.$session.get('selectedCompany');

      var data = {
        token: this.$session.get('token'),
        company_id: companyID,
        location_id: id
      };

      this.apiRequest('/settings/can-delete-location', 'POST', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
            text: self.$t('settingCompany.areYouSureDelete'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes (' + btnCounter + ')'
          }).then(function (result) {
            if (result) {
              var locIdx = self.getObjectByElemKeyValue('id', id, self.model.locations_details);
              if (locIdx) {
                self.model.locations_details.splice(locIdx, 1);
              }
              if (!self.model.from_json) {
                self.apiRequest('/delete-location', 'POST', data, function (response) {
                  if (response.status === true) {
                    self.saveDetails(true, id);
                  }
                });
              } else {
                self.saveDetails(true, id);
              }
            }
          });
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.disableConfirmButton();

          var btnInterval = setInterval(function () {
            btnCounter--;

            if (btnCounter >= 1) {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.getConfirmButton().textContent = 'Yes (' + btnCounter + ')';
            } else {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.getConfirmButton().textContent = 'Yes';
              clearInterval(btnInterval);
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.enableConfirmButton();
            }
          }, 1000);
        } else if (response.status === false && response.errors.location_ids !== undefined) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('settingCompany.deleteLocationValidation'), 'type': 'error' }).catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    copyProducts: function copyProducts(id) {
      var self = this;
      var copyFrom = this.$refs['copyFrom' + id][0].value;
      var data = {
        copy_to: id,
        copy_from: copyFrom,
        token: self.$session.get('token')
      };
      self.apiRequest('/locations/duplicate-products', 'POST', data, function (response) {
        if (response.status === true) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('settingCompany.companyProdCopied'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    deleteProducts: function deleteProducts(id) {
      var self = this;
      var data = {
        location: id,
        token: self.$session.get('token')
      };
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        text: self.$t('settingCompany.areYouSureDeleteProd'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          self.apiRequest('/locations/delete-products', 'POST', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('settingCompany.companyProdDeleted'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
            }
          });
        }
      });
    },
    addNewTax: function addNewTax(locId) {
      var newRow = {
        'id': null,
        'type': null,
        'amount': null
      };
      var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details);
      if (locIdx) {
        if (this.model.locations_details[locIdx]['taxes'] === undefined) {
          this.model.locations_details[locIdx].push({ 'taxes': [] });
        }
        this.model.locations_details[locIdx]['taxes'].push(newRow);
        this.showUpdateWarning = true;
      }
    },
    addNewVat: function addNewVat(locIdx, locToken) {
      var newRow = {
        'id': null,
        'company_id': this.$session.get('selectedCompany'),
        'location_token': locToken,
        'tax_id': null,
        'type': 'PERCENTAGE_EXCLUDED',
        'amount': null,
        'printer_id': null,
        'is_vat': true
      };
      var copy = [];
      if (this.model.locations_details[locIdx]['vat'] && this.model.locations_details[locIdx]['vat'].length) {
        copy = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.model.locations_details[locIdx]['vat']));
      }
      copy.push(newRow);
      __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(this.model.locations_details[locIdx], 'vat', copy);
      this.showUpdateWarning = true;
    },
    deleteTax: function deleteTax(locId, taxId) {
      var _this14 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        text: self.$t('settingCompany.areYouSureTax'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          var locIdx = _this14.getObjectByElemKeyValue('id', locId, _this14.model.locations_details);
          var thisTaxIdx = _this14.getObjectByElemKeyValue('id', taxId, _this14.model.locations_details[locIdx]['taxes']);
          _this14.model.locations_details[locIdx]['taxes'].splice(thisTaxIdx, 1);
          _this14.showUpdateWarning = true;
        }
      }).catch({});
    },
    deleteVat: function deleteVat(locIdx, taxId, vatIndex) {
      var _this15 = this;

      if (!taxId) {
        this.model.locations_details[locIdx]['vat'].splice(vatIndex, 1);
        return;
      }
      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        text: self.$t('settingCompany.areYouSureVat'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          var data = {
            'token': _this15.$session.get('token')
          };
          _this15.apiRequest('/location/vat/delete/' + taxId, 'DELETE', data, function (response) {
            if (response.status) {
              _this15.model.locations_details[locIdx]['vat'].splice(vatIndex, 1);
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': _this15.$t('vat.deleteVatSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
            } else {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': _this15.$t('vat.deleteVatError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 });
            }
          });
          _this15.showUpdateWarning = true;
        }
      }).catch({});
    },
    saveDetails: function saveDetails(isDel, locId) {
      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');
      var countries = this.$session.get('defaultData').countries;
      var currentLocations = [];
      for (var locIdx in this.model.locations_details) {
        var locData = this.copyObject(this.model.locations_details[locIdx]);
        var countryIso = locData.country;
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries);
        var states = [];

        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          states = countries[countryIdx].states;
        }

        if (states.length && locData.state_id) {
          var state = this.getObjectByElemKeyValue('id', locData.state_id, states);
          if (state !== undefined) {
            locData.state = states[state].name;
          } else {
            locData.state = '';
          }
        }
        delete locData.states;
        currentLocations[locIdx] = locData;
      }
      if (this.model.tips_taxes === null) {
        this.model.tips_taxes = [];
      }
      var data = {
        'token': this.$session.get('token'),
        'locations_details': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(currentLocations)
      };

      var self = this;
      this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
        if (response.status === true) {
          self.$emit('updateModelData', response.data[0]);
          self.$session.set('companyName', response.data[0].name);
          self.errors.clear();
          self.$nextTick(function () {
            self.loading = false;
            self.syncCompanySessionAndCache(response.data[0]);
          });
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('settingCompany.companyUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          if (isDel) {
            var filterCookie = self.$cookie.get('filter-locations');
            if (filterCookie) {
              filterCookie = JSON.parse(filterCookie);
              var indexOf = filterCookie.indexOf(locId);
              if (indexOf !== -1) {
                filterCookie.splice(indexOf, 1);
                self.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filterCookie), 30);
              }
            }
          }
          self.$emit('companyName', response.data[0].name);
          self.showDelete = self.model.locations_details.length > 1;
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          if (response.errors.latlng !== undefined) {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('settingCompany.wrongAddress', { location: response.errors.latlng }), 'type': 'error', 'showConfirmButton': true }).catch(function () {});
          } else {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          }
        }
      });
    },
    goToCompany: function goToCompany() {
      this.$emit('setSelectedTab', this.$t('settingsPages.taxLabeling'));
    },
    handleMenu: function handleMenu(index, event) {
      this.model.locations_details[index].use_dynamic_menu = event.target.value;
    },
    downloadForm: function downloadForm() {
      var data = {
        token: this.$session.get('token')
      };
      this.apiRequest('/download-import-form', 'GET', data, function (response) {});
    }
  }
});

/***/ }),

/***/ "wGs9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountCampaigns_vue__ = __webpack_require__("C3Gn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30e772b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountCampaigns_vue__ = __webpack_require__("hcjE");
function injectStyle (ssrContext) {
  __webpack_require__("iaD/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30e772b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountCampaigns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30e772b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountCampaigns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wH4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("1Kqs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_789362c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("pvPl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_789362c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wJGW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wR4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination",class:_vm.paginationClass},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.value === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_vm._l((_vm.range(_vm.minPage, _vm.maxPage)),function(item){return _c('li',{staticClass:"page-item",class:{active: _vm.value === item}},[_c('a',{staticClass:"page-link",on:{"click":function($event){_vm.changePage(item)}}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.value === _vm.totalPages}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fa fa-angle-double-right",attrs:{"aria-hidden":"true"}})])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wYu/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);







var MAX_SIZE = 50 * 1024 * 1024;

var CHUNK_SIZE = 8 * 1024 * 1024;
var CHUNK_RETRIES = 3;
var ALLOWED_EXTENSIONS = ['mp4', 'webm'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'kiosk-video-input',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    companyId: null,
    locationId: null,

    tableId: null,

    multiple: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      file: null,
      uploading: false,
      removing: false,
      progress: 0
    };
  },

  methods: {
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        toast: true,
        type: type,
        text: text,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      }).then(function () {}).catch(function () {});
    },
    formatSize: function formatSize(bytes) {
      return (bytes / 1024 / 1024).toFixed(1) + ' MB';
    },
    handleChange: function handleChange(file) {
      var extension = (file.name.split('.').pop() || '').toLowerCase();
      if (!ALLOWED_EXTENSIONS.includes(extension)) {
        this.toast('warning', this.$t('validations.wrongFormat'));
        this.$refs.upload.clearFiles();
        this.file = null;
      } else if (file.size > MAX_SIZE) {
        this.toast('warning', this.$t('settingTable.kioskVideoTooBig'));
        this.$refs.upload.clearFiles();
        this.file = null;
      } else {
        this.file = file.raw;
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.file = null;
      }
    },
    remove: function remove(index) {
      var _this = this;

      var videos = this.value.slice();
      var removed = videos.splice(index, 1)[0];
      if (!removed) {
        return;
      }

      this.removing = true;
      this.apiRequest('/videos/kiosk-remove', 'POST', {
        token: this.$session.get('token'),
        table_id: this.tableId || null,
        video_id: removed.id
      }, function (response) {
        _this.removing = false;
        if (response && response.status) {
          _this.$emit('input', videos);
          _this.toast('success', _this.$t('settingTable.kioskVideoRemoved'));
        } else {
          _this.toast('error', response && typeof response.data === 'string' ? response.data : _this.$t('general.error'));
        }
      });
    },
    postChunk: function postChunk(data) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.apiRequest('/videos/upload', 'POST', data, resolve);
      });
    },
    sendChunk: function sendChunk(data) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, attempt;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                response = null;
                attempt = 0;

              case 2:
                if (!(attempt < CHUNK_RETRIES)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 5;
                return _this3.postChunk(data);

              case 5:
                response = _context.sent;

                if (!(response && response.status)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', response);

              case 8:
                attempt++;
                _context.next = 2;
                break;

              case 11:
                return _context.abrupt('return', response);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    upload: function upload() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var file, uploadId, response, offset, end, chunk, videos, message;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                file = _this4.file;

                if (!(!file || _this4.uploading)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                _this4.uploading = true;
                _this4.progress = 0;

                uploadId = Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
                response = null;
                _context2.prev = 7;
                offset = 0;

              case 9:
                if (!(offset < file.size)) {
                  _context2.next = 23;
                  break;
                }

                end = Math.min(offset + CHUNK_SIZE, file.size);
                _context2.next = 13;
                return _this4.getBase64(file.slice(offset, end));

              case 13:
                chunk = _context2.sent;
                _context2.next = 16;
                return _this4.sendChunk({
                  token: _this4.$session.get('token'),
                  company_id: _this4.companyId,
                  location_id: _this4.locationId,
                  table_id: _this4.tableId || null,
                  append: _this4.multiple ? 1 : 0,
                  file_name: file.name,
                  upload_id: uploadId,
                  offset: offset,
                  total_size: file.size,
                  is_last: end >= file.size ? 1 : 0,
                  chunk: chunk
                });

              case 16:
                response = _context2.sent;

                if (!(!response || !response.status)) {
                  _context2.next = 19;
                  break;
                }

                return _context2.abrupt('break', 23);

              case 19:
                _this4.progress = Math.round(end / file.size * 100);

              case 20:
                offset += CHUNK_SIZE;
                _context2.next = 9;
                break;

              case 23:
                _context2.next = 28;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2['catch'](7);

                response = null;

              case 28:
                _this4.uploading = false;

                if (response && response.status && response.data && response.data.id) {
                  videos = _this4.multiple ? _this4.value.concat([response.data]) : [response.data];

                  _this4.$emit('input', videos);
                  _this4.file = null;
                  _this4.$refs.upload.clearFiles();
                  _this4.toast('success', _this4.$t(_this4.tableId ? 'settingTable.kioskVideoSaved' : 'settingTable.kioskVideoUploaded'));
                } else {
                  message = response && typeof response.data === 'string' ? response.data : _this4.$t('general.error');

                  _this4.toast('error', message);
                }

              case 30:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[7, 25]]);
      }))();
    }
  }
});

/***/ }),

/***/ "wcsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sweetalert2_dist_sweetalert2_css__);

























__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_18_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a);

var STATES = ['active', 'expiring', 'unpaid', 'expired', 'cancelled', 'pending', 'abandoned'];
var STATE_LABEL_KEYS = {
  active: 'stateActive',
  expiring: 'stateExpiring',
  unpaid: 'stateUnpaid',
  expired: 'stateExpired',
  cancelled: 'stateCancelled',
  pending: 'statePending',
  abandoned: 'stateAbandoned'
};
var PAYMENT_STATUS_KEYS = ['payCreated', 'payPending', 'paySuccess', 'payFailed', 'payExpired', 'payCancelled', 'payRefunded'];
var PERIOD_STATUS_KEYS = ['periodUnpaid', 'periodPaid', 'periodCancelled'];
var KIND_KEYS = { 1: 'kindFirst', 2: 'kindRenewal', 3: 'kindUpgrade' };
var SORT_PROPS = ['active_until', 'total_paid', 'last_payment_at'];
var PER_PAGE = 20;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var query = this.route.query || {};
    return {
      loading: false,
      detailLoading: false,
      currency: '',
      family: null,
      items: [],
      counts: {},
      pagination: { total: 0, page: 1, per_page: PER_PAGE },
      filters: {
        state: '',
        search: '',
        subscription_id: query.subscription_id ? parseInt(query.subscription_id, 10) : '',
        auto_renew: '',
        active_until: null
      },
      sort: 'active_until',
      dir: 'desc',
      detail: null,
      openLogs: {},

      refundPaymentId: null,
      refundComment: '',
      refundError: '',
      refunding: false,

      action: null,
      actionLevelId: null,
      actionComment: '',
      actionError: '',
      actionSaving: false,
      searchTimer: null
    };
  },

  computed: {
    familyId: function familyId() {
      return this.route.query && this.route.query.family_id ? parseInt(this.route.query.family_id, 10) : null;
    },
    stateChips: function stateChips() {
      var _this = this;

      return [{ value: '', label: this.$t('marketingSubscriptions.stateAll') }].concat(STATES.map(function (state) {
        return { value: state, label: _this.stateLabel(state) };
      }));
    }
  },
  created: function created() {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso);
    this.getFamily();
    this.getSubscribers();
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.searchTimer);
  },

  methods: {
    requestData: function requestData() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    getFamily: function getFamily() {
      var _this2 = this;

      if (!this.familyId) {
        return;
      }
      this.apiRequest('/subscription', 'GET', this.requestData(), function (response) {
        if (response.status === true) {
          _this2.family = (response.data || []).find(function (item) {
            return item.id === _this2.familyId;
          }) || null;
        }
      });
    },
    getSubscribers: function getSubscribers() {
      var _this3 = this;

      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.requestData(), {
        page: this.pagination.page,
        per_page: PER_PAGE,
        sort: this.sort,
        dir: this.dir
      });
      if (this.familyId) {
        data.family_id = this.familyId;
      }
      if (this.filters.subscription_id) {
        data.subscription_id = this.filters.subscription_id;
      }
      if (this.filters.state) {
        data.state = this.filters.state;
      }
      if (this.filters.auto_renew !== '') {
        data.auto_renew = this.filters.auto_renew;
      }
      if (this.filters.search.trim().length >= 2) {
        data.search = this.filters.search.trim();
      }
      if (this.filters.active_until && this.filters.active_until[0]) {
        data.active_until_from = this.filters.active_until[0];
        data.active_until_to = this.filters.active_until[1];
      }
      this.loading = true;
      this.apiRequest('/subscription/subscribers', 'GET', data, function (response) {
        _this3.loading = false;
        if (response.status === true && response.data) {
          _this3.items = response.data.items || [];
          _this3.counts = response.data.counts || {};
          _this3.pagination = response.data.pagination || _this3.pagination;
        } else {
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    reload: function reload() {
      this.pagination.page = 1;
      this.getSubscribers();
    },
    setState: function setState(state) {
      this.filters.state = state;
      this.reload();
    },
    onSearchInput: function onSearchInput() {
      var _this4 = this;

      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        var term = _this4.filters.search.trim();
        if (term.length >= 2 || term.length === 0) {
          _this4.reload();
        }
      }, 400);
    },
    onSortChange: function onSortChange(_ref) {
      var prop = _ref.prop,
          order = _ref.order;

      if (!order || SORT_PROPS.indexOf(prop) === -1) {
        this.sort = 'active_until';
        this.dir = 'desc';
      } else {
        this.sort = prop;
        this.dir = order === 'ascending' ? 'asc' : 'desc';
      }
      this.reload();
    },
    handlePageChange: function handlePageChange(page) {
      this.pagination.page = page;
      this.getSubscribers();
    },
    openDetail: function openDetail(row) {
      var _this5 = this;

      this.detail = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, row, { periods: [] });
      this.openLogs = {};
      this.refundPaymentId = null;
      this.action = null;
      this.detailLoading = true;
      this.apiRequest('/subscription/subscribers/' + row.id, 'GET', this.requestData(), function (response) {
        _this5.detailLoading = false;
        if (response.status === true && response.data) {
          _this5.detail = response.data;
        } else {
          __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this5.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    openAction: function openAction(type) {
      this.action = type;
      this.actionComment = '';
      this.actionError = '';
      this.actionLevelId = type === 'downgrade' && this.detail.downgrade_levels.length ? this.detail.downgrade_levels[0].id : null;
    },
    confirmAction: function confirmAction() {
      var _this6 = this;

      var comment = (this.actionComment || '').trim();
      if (comment.length < 3) {
        this.actionError = this.$t('marketingSubscriptions.reasonRequired');
        return;
      }
      var isCancel = this.action === 'cancel';
      var level = !isCancel ? this.detail.downgrade_levels.find(function (item) {
        return item.id === _this6.actionLevelId;
      }) : null;
      if (!isCancel && !level) {
        this.actionError = this.$t('marketingSubscriptions.downgradeTo');
        return;
      }
      this.actionError = '';
      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
        text: isCancel ? this.$t('marketingSubscriptions.cancelAreYouSure') : this.$t('marketingSubscriptions.downgradeAreYouSure', { name: level.name }),
        type: 'warning',
        showCancelButton: true
      }).then(function (result) {
        if (!result) {
          return;
        }
        var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this6.requestData(), { comment: comment });
        if (!isCancel) {
          data.subscription_id = level.id;
        }
        _this6.actionSaving = true;
        _this6.apiRequest('/subscription/subscribers/' + _this6.detail.id + '/' + (isCancel ? 'cancel' : 'downgrade'), 'POST', data, function (response) {
          _this6.actionSaving = false;
          if (response.status === true && response.data) {
            _this6.detail = response.data;
            _this6.action = null;
            _this6.getSubscribers();
            __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this6.$t(isCancel ? 'marketingSubscriptions.cancelDone' : 'marketingSubscriptions.downgradeDone'), 'success').catch(function () {});
            return;
          }
          var errors = response.errors || {};
          var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors)[0];
          _this6.actionError = key ? Array.isArray(errors[key]) ? errors[key][0] : errors[key] : _this6.$t('validations.wentWrong');
        });
      }).catch(function () {});
    },
    eventLabel: function eventLabel(type) {
      var keys = { cancel: 'eventCancel', downgrade: 'eventDowngrade', refund: 'eventRefund' };
      return keys[type] ? this.$t('marketingSubscriptions.' + keys[type]) : type;
    },
    eventDetails: function eventDetails(event) {
      var d = event.data || {};
      if (event.type === 'downgrade') {
        return d.from_name + ' (' + d.price_before + ' ' + this.currency + ') -> ' + d.to_name + ' (' + d.price_after + ' ' + this.currency + ')';
      }
      if (event.type === 'refund') {
        var type = d.refund_type === 'reversal' ? this.$t('marketingSubscriptions.refundTypeReversal') : this.$t('marketingSubscriptions.refundTypeRefund');
        return type + ': ' + d.amount + ' ' + (d.currency || this.currency) + (d.reference ? ' (#' + d.reference + ')' : '');
      }
      return '';
    },
    openRefund: function openRefund(paymentId) {
      this.refundPaymentId = paymentId;
      this.refundComment = '';
      this.refundError = '';
    },
    confirmRefund: function confirmRefund(payment) {
      var _this7 = this;

      var comment = (this.refundComment || '').trim();
      if (comment.length < 3) {
        this.refundError = this.$t('marketingSubscriptions.refundCommentRequired');
        return;
      }
      this.refundError = '';
      __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()({
        text: this.$t('marketingSubscriptions.refundAreYouSure', { amount: payment.amount + ' ' + this.currency }),
        type: 'warning',
        showCancelButton: true
      }).then(function (result) {
        if (!result) {
          return;
        }
        var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this7.requestData(), {
          payment_id: payment.id,
          comment: comment
        });
        _this7.refunding = true;
        _this7.apiRequest('/subscription/subscribers/' + _this7.detail.id + '/refund', 'POST', data, function (response) {
          _this7.refunding = false;
          if (response.status === true && response.data) {
            _this7.detail = response.data;
            _this7.refundPaymentId = null;
            _this7.getSubscribers();
            __WEBPACK_IMPORTED_MODULE_19_sweetalert2___default()('', _this7.$t('marketingSubscriptions.refundDone'), 'success').catch(function () {});
            return;
          }
          var errors = response.errors || {};
          var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors)[0];
          _this7.refundError = key ? Array.isArray(errors[key]) ? errors[key][0] : errors[key] : _this7.$t('validations.wentWrong');
        });
      }).catch(function () {});
    },
    toggleLogs: function toggleLogs(paymentId) {
      this.$set(this.openLogs, paymentId, !this.openLogs[paymentId]);
    },
    renewTitle: function renewTitle(row) {
      if (row.auto_renew || !row.renewal_cancelled_at) {
        return '';
      }
      return this.$t('marketingSubscriptions.renewalCancelledAt') + ': ' + this.$options.filters.formatDateTime(row.renewal_cancelled_at);
    },
    stateLabel: function stateLabel(state) {
      return STATE_LABEL_KEYS[state] ? this.$t('marketingSubscriptions.' + STATE_LABEL_KEYS[state]) : state;
    },
    paymentStatusLabel: function paymentStatusLabel(status) {
      var key = PAYMENT_STATUS_KEYS[status];
      return key ? this.$t('marketingSubscriptions.' + key) : status;
    },
    periodStatusLabel: function periodStatusLabel(status) {
      var key = PERIOD_STATUS_KEYS[status];
      return key ? this.$t('marketingSubscriptions.' + key) : status;
    },
    kindLabel: function kindLabel(kind) {
      return KIND_KEYS[kind] ? this.$t('marketingSubscriptions.' + KIND_KEYS[kind]) : kind;
    },
    prettyJson: function prettyJson(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      try {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JSON.parse(value), null, 2);
      } catch (e) {
        return value;
      }
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    }
  }
});

/***/ }),

/***/ "wdBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar location-group-form-modal"},[_c('div',{staticClass:"top-bar"},[_c('p',{},[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();_vm.closeModal()}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n        "+_vm._s(_vm.$t('general.back'))+"\n      ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")]),_vm._v(" "),(!_vm.isNew)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",attrs:{"title":_vm.$t('settingsPages.locationGroupsDelete')},on:{"click":function($event){$event.preventDefault();_vm.handleDelete('delete')}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card no-shadow"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('error'))+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mb-15"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsPages.locationGroupsName')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('settingsPages.locationGroupsName')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('name'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group mb-15"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsPages.locationGroupsDescription')))]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.description),expression:"modelValidate.description"},{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",attrs:{"rows":"5","name":"description","placeholder":_vm.$t('settingsPages.locationGroupsDescription')},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('description'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                    "+_vm._s(_vm.getError('description'))+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group mb-15"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsPages.locationGroupsPhoto')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":1,"file-list":_vm.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1),_vm._v(" "),(_vm.parentOptions.length > 0)?_c('div',{staticClass:"form-group mb-15 parent"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingLocationGroups.parentGroup')))]),_vm._v(" "),_c('v-select',{attrs:{"value":"id","label":"name","options":_vm.parentOptions,"placeholder":_vm.$t('general.none') + ' ' + _vm.$t('settingLocationGroups.write')},model:{value:(_vm.model.parent),callback:function ($$v) {_vm.$set(_vm.model, "parent", $$v)},expression:"model.parent"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group mb-15"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.active),callback:function ($$v) {_vm.$set(_vm.model, "active", $$v)},expression:"model.active"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingLocationGroups.active')))])],1),_vm._v(" "),(_vm.editData && _vm.editData.show_slider_check)?_c('div',{staticClass:"form-group mb-15"},[_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.display_in_slider_app),callback:function ($$v) {_vm.$set(_vm.model, "display_in_slider_app", $$v)},expression:"model.display_in_slider_app"}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('settingLocationGroups.displayInSlider')))])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.categoryLocations.length > 1)?_c('div',{staticClass:"form-group mb-15 locations"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingsPages.companyLocations')))]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":_vm.categoryLocations,"label":"name","placeholder":_vm.$t('general.none') + ' ' + _vm.$t('settingLocationGroups.write')},model:{value:(_vm.model.location_ids),callback:function ($$v) {_vm.$set(_vm.model, "location_ids", $$v)},expression:"model.location_ids"}})],1):_vm._e()])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wfBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "whIq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-full-width table-tasks"},[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.tasks),function(task,index){return _c('task',{key:task.title,attrs:{"task":task,"index":index},on:{"on-edit":_vm.handleTaskEdit,"on-delete":_vm.handleTaskDelete}})}))])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tasks")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Backend development")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Updated 3 minutes ago\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wiU7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recover_vue__ = __webpack_require__("hZ/Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a152fa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recover_vue__ = __webpack_require__("2qO1");
function injectStyle (ssrContext) {
  __webpack_require__("stHs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a152fa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wl7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelRewardsReport_vue__ = __webpack_require__("hMue");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d6779d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelRewardsReport_vue__ = __webpack_require__("ZBX3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningWheelRewardsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d6779d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningWheelRewardsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wn2q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wpqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserForm_vue__ = __webpack_require__("HOa3");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'UserForm', __WEBPACK_IMPORTED_MODULE_7__UserForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      userModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.userModel = model;
    }
  }
});

/***/ }),

/***/ "wqfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      routess: [{ path: '/pos/tabs?tabIndex=0', name: this.$t('pages.tableMaps') }, { path: '/pos/tabs?tabIndex=1', name: this.$t('pages.pos') }, { path: '/pos/tabs?tabIndex=2', name: this.$t('dispath.users') }, { path: '/pos/tabs?tabIndex=5', name: 'Fiscal Printer' }, { path: '/pos/tabs?tabIndex=6', name: 'Cantar' }, { path: '/pos/tabs?tabIndex=3', name: 'Report' }, { path: '/pos/tabs?tabIndex=4', name: 'Settings' }]
    };
  },

  methods: {
    getImageForRoute: function getImageForRoute(routeName) {
      var images = {};
      images[this.$t('pages.tableMaps')] = 'static/img/tableMapsBg.png';
      images[this.$t('pages.pos')] = 'static/img/posBg.png';
      images[this.$t('dispath.users')] = 'static/img/posUsersBg.png';
      images['Report'] = 'static/img/pickupBg.png';
      images['Settings'] = 'static/img/pickupBg.png';
      images['Fiscal Printer'] = 'static/img/fiscalPrinterBg.png';
      images['Cantar'] = 'static/img/cantarBg.png';

      return images[routeName] || 'static/img/default.jpg';
    },
    getBoxColor: function getBoxColor(index) {
      var colors = ['#FFD93D', '#3AB7CD', '#674BD2', '#FF4D4D', '#5dd5a2', '#FFD93D', '#3AB7CD'];
      return colors[index] || '#FFFFFF';
    }
  }
});

/***/ }),

/***/ "wvB3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_BackgroundColorPicker_vue__ = __webpack_require__("8zHz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__);
















var _components;







__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, 'BackgroundColorPicker', __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_BackgroundColorPicker_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
    this.getKdsSections();
    this.getPoses();
    this.getData();
  },
  data: function data() {
    return {
      apiUrl: '',
      roles: [],
      kdsSections: [],
      allPoses: [],
      id: this.value || this.tableId,
      isNew: true,
      filelist: [],
      model: {
        'id': 0,
        'location_token': '',
        'location_id': '',
        'type': 'Client',
        'include_table_orders': 0,
        'pos_ids': [],
        'kds_section_id': null,
        'excluded_kds_section_ids': [],
        'ods_offline': 0,
        'ip_server': null
      },
      type: ['Kitchen', 'Client'],
      locations: [],
      modelValidate: {
        type: { required: true }
      },
      languages: [{ 'id': 'ro', 'label': 'Romana' }, { 'id': 'en', 'label': 'English' }, { 'id': 'es', 'label': 'Espagnol' }, { 'id': 'gr', 'label': 'Greek' }, { 'id': 'cz', 'label': 'Czech' }],
      loading: true
    };
  },

  computed: {
    odsCode: function odsCode() {
      return this.$session.get('selectedCompany') + '.' + this.model.id;
    }
  },
  watch: {
    'model.kds_section_id': function modelKds_section_id(sectionId) {
      if (sectionId) this.model.excluded_kds_section_ids = [];
    },
    'model.type': function modelType(newType) {
      if (newType !== 'Client') {
        this.model.excluded_kds_section_ids = [];
        this.model.ods_offline = 0;
        this.model.ip_server = null;
      }
    }
  },
  methods: {
    getPoses: function getPoses() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/pos', 'GET', data, function (response) {
        if (response.status === true && response.data && response.data.pos) {
          _this.allPoses = response.data.pos;
        }
      });
    },
    normalizePosIds: function normalizePosIds(posIds) {
      if (!posIds) return [];
      if (typeof posIds === 'string') {
        return posIds.split(',').map(function (id) {
          return parseInt(id, 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
      }
      if (!Array.isArray(posIds)) return [];
      return posIds.map(function (item) {
        if (item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object') return item.id;
        return parseInt(item, 10);
      }).filter(function (id) {
        return id != null && !isNaN(id);
      });
    },
    getKdsSections: function getKdsSections() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/kds-sections', 'GET', data, function (response) {
        if (response.status === true) {
          _this2.kdsSections = response.data;

          _this2.$nextTick(function () {
            _this2.loading = false;
          });
        }
      });
    },
    updateColor: function updateColor(value, attribute) {
      this.model[attribute] = value;
    },
    handleImgChnage: function handleImgChnage(file, fileList) {
      var _this3 = this;

      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$refs.upload.clearFiles();
        this.model.imagelist = [];
      } else {
        if (fileList.length > 1) {
          this.model.imagelist = fileList.slice(1);
        } else {
          this.model.imagelist = fileList;
        }
      }

      if (this.model.imagelist && this.model.imagelist[0].status === 'ready') {
        this.getBase64(this.model.imagelist[0].raw).then(function (base64enc) {
          _this3.model.ods_multimedia = base64enc;
        });
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.model.imagelist = [];
        this.model.ods_multimedia = null;
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: 'Please remove the current file in order to be able to add a new one',
        type: 'warning',
        showConfirmButton: true
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
      return isOkSize;
    },
    copyToClipboard: function copyToClipboard(textToCopy) {
      textToCopy = textToCopy.replace(/\s/g, '');
      this.$copyText(textToCopy);
    },
    getData: function getData() {
      var _this4 = this;

      this.locations = [];
      var requestData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      var id = this.route.params.id;
      if (id) {
        this.apiRequest('/order-screen/' + id, 'GET', requestData, function (response) {
          if (response.status) {
            response.data.excluded_kds_section_ids = _this4.normalizePosIds(response.data.excluded_kds_section_ids);
            _this4.model = response.data;
            _this4.model.pos_ids = _this4.normalizePosIds(response.data.pos_ids);
            if (response.data.ods_multimedia) {
              _this4.model.imagelist = [{ url: response.data.ods_multimedia }];
            } else {
              _this4.model.imagelist = [];
            }
          }
        });
      }

      this.apiRequest('/get-locations', 'GET', requestData, function (response) {
        if (response.status) {
          _this4.locations = response.data;
        }
      });
      this.$nextTick(function () {
        _this4.loading = false;
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this5 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this5.saveTable();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors.hasOwnProperty(prop)) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0]);
          } else {
            this.errors.add(prop, errors[prop]);
          }
        } else {
          this.errors.add('error', errors[prop]);
        }
      }
    },
    saveTable: function saveTable() {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.loading = true;
      });
      var data = this.model;
      data.excluded_kds_section_ids = data.type === 'Client' && !data.kds_section_id ? this.normalizePosIds(data.excluded_kds_section_ids) : [];
      if (!data.print_order) {
        data.print_order = 0;
      }
      if (!data.include_table_orders) {
        data.include_table_orders = 0;
      }
      if (data.type === 'Client') {
        data.pos_ids = this.normalizePosIds(data.pos_ids);
      } else {
        data.pos_ids = [];
      }
      if (data.type !== 'Client' || !data.ods_offline) {
        data.ods_offline = 0;
        data.ip_server = null;
      } else {
        data.ods_offline = 1;
      }
      var companyID = this.$session.get('selectedCompany');
      data.token = this.$session.get('token');
      data.company_id = companyID;

      var id = this.id || this.route.params.id;
      var url = '';
      var request = '';
      if (id) {
        url = '/order-screen/' + id;
        request = 'PUT';
      } else {
        url = '/order-screen/';
        request = 'POST';
      }
      this.apiRequest(url, request, data, function (response) {
        if (response.status === true) {
          _this6.$nextTick(function () {
            _this6.loading = false;
          });
          _this6.errors.clear();
          if (request === 'POST') {
            _this6.$bus.$emit('refresh');
            _this6.$bus.$emit('close-modal');
          } else {
            _this6.backButton();
          }
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
            title: '',
            text: _this6.$t('settingTable.tableSave'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          _this6.$nextTick(function () {
            _this6.loading = false;
          });
          _this6.handleErrors(response.errors);
        }
      });
    },
    deleteOrderScreen: function deleteOrderScreen() {
      var _this7 = this;

      this.$nextTick(function () {
        _this7.loadingReset = true;
      });
      var id = this.id || this.route.params.id;
      var data = {
        company_id: this.$session.get('selectedCompany'),
        token: this.$session.get('token'),
        delete: true
      };
      this.apiRequest('/order-screen/' + id, 'DELETE', data, function (response) {
        if (response.status) {
          _this7.$nextTick(function () {
            _this7.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({ 'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
          _this7.backButton();
        } else {
          _this7.$nextTick(function () {
            _this7.loadingReset = false;
          });
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({ 'text': _this7.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).then(function () {}).catch(function () {});
        }
      });
    },
    backButton: function backButton() {
      this.$session.set('selectedTab', this.$t('pages.orderScreen'));
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    updateLocationId: function updateLocationId(event) {
      if (event.target.value !== 'null') {
        var selectedLocation = this.locations.find(function (item) {
          return item.token === event.target.value;
        });
        this.model.location_id = selectedLocation.id;
      } else {
        this.model.type = 'Kitchen';
      }
    }
  }
});

/***/ }),

/***/ "wvZt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('h4',{staticClass:"purple"},[_vm._v("Date despre trimitere")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"dataCampaign"},[_c('p',[_c('span',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.sent'))+": ")]),_c('span',[_vm._v(_vm._s(_vm.model.sent))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.notif_sent'))+": ")]),_c('span',[_vm._v(_vm._s(_vm.model.notif_sent))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.email_sent'))+": ")]),_c('span',[_vm._v(_vm._s(_vm.model.email_sent))])])]),_vm._v(" "),_c('div',{staticClass:"statusBar"},[_c('div',{staticClass:"barr",style:({ width: _vm.calcWidthProc(_vm.model.in_queue, _vm.model.total_notificatios_to_be_sent) + '%' })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.model.total_notificatios_to_be_sent - _vm.model.in_queue)+" "+_vm._s(_vm.$t('marketingCampaigns.off'))+" "+_vm._s(_vm.model.total_notificatios_to_be_sent)+" - "+_vm._s(_vm.calcWidthProc(_vm.model.in_queue, _vm.model.total_notificatios_to_be_sent))+"%")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',[_c('h4',{staticClass:"purple text-center"},[_vm._v(_vm._s(_vm.$t('marketingPromos.send')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('p-checkbox',{key:"type_email",staticClass:"margin-left-10",attrs:{"label":_vm.$t('marketingPromos.email'),"inline":true,"name":"Email"},on:{"input":_vm.validate},model:{value:(_vm.model.type_email),callback:function ($$v) {_vm.$set(_vm.model, "type_email", $$v)},expression:"model.type_email"}},[_vm._v(_vm._s(_vm.$t('marketingPromos.email'))+"\n            ")]),_vm._v(" "),_c('p-checkbox',{key:"type_push",attrs:{"label":_vm.$t('campaignsNotificationTypes.PUSH'),"inline":true,"name":"Push Notification"},on:{"input":_vm.validate},model:{value:(_vm.model.type_push),callback:function ($$v) {_vm.$set(_vm.model, "type_push", $$v)},expression:"model.type_push"}},[_vm._v(_vm._s(_vm.$t('campaignsNotificationTypes.PUSH'))+"\n            ")])],1),_vm._v(" "),(!_vm.model.type_push && !_vm.model.type_email)?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.$t('validations.requiredField'))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-1 inline-auto pad-rg-0"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label inline"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.mode')))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.mode),expression:"model.mode"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.mode),expression:"modelValidations.mode"}],staticClass:"form-control notof-mode",attrs:{"name":"mode","placeholder":_vm.$t('marketingCampaigns.mode')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":"","value":""}},[_vm._v(" - "+_vm._s(_vm.$t('general.select'))+" - ")]),_vm._v(" "),_vm._l((_vm.campaignsModes),function(type,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(_vm.$t('campaignsModes.' + key)))])})],2),_vm._v(" "),(_vm.errors.has('mode'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.$t('validations.requiredField'))+"\n            ")]):_vm._e()])]),_vm._v(" "),(_vm.model.mode == 'AUTO')?_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.setHours')))]),_vm._v(" "),_c('hr',{staticClass:"sm mar-to-0 mar-bt-0"}),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.daysOfWeek),function(day){return _c('div',{key:day.key,staticClass:"col-md-4 col-sm-4 col-xs-12 padd"},[_c('p-checkbox',{key:day.key,staticClass:"text-purple",attrs:{"label":_vm.$t('days.' + day.key)},on:{"input":function($event){_vm.setDefaultHour($event, day.key)}},model:{value:(_vm.model[day.key + '_active']),callback:function ($$v) {_vm.$set(_vm.model, day.key + '_active', $$v)},expression:"model[day.key + '_active']"}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('days.' + day.key)))+"\n                ")]),_vm._v(" "),_c('el-time-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.time),expression:"modelValidations.time"}],attrs:{"disabled":!_vm.model[day.key + '_active'],"editable":false,"placeholder":_vm.$t('marketingCampaigns.selectTime'),"picker-options":_vm.pickerOptions},model:{value:(_vm.model[day.key]),callback:function ($$v) {_vm.$set(_vm.model, day.key, $$v)},expression:"model[day.key]"}})],1)}))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-center"},[_c('h4',{staticClass:"purple"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.campaignDetails')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.name'))+"*")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.name),expression:"modelValidations.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":_vm.$t('marketingCampaigns.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.nameHelper')))]),_vm._v(" "),_c('div',[(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('name'))+"\n          ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.image')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.model.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.validFromTo'))+"*")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.dateRange),expression:"modelValidations.dateRange"}],attrs:{"type":"daterange","name":"dateRange","picker-options":_vm.pickerOptions1},model:{value:(_vm.model.fromto),callback:function ($$v) {_vm.$set(_vm.model, "fromto", $$v)},expression:"model.fromto"}})],1),_vm._v(" "),(_vm.errors.has('dateRange'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(_vm.$t('validations.requiredField'))+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('h4',{staticClass:"purple text-center"},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.notif_sent')))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.description'))+" "),_c('small',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.maxDescription')))]),_vm._v("*")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"},{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.description),expression:"modelValidations.description"}],staticClass:"form-control",attrs:{"name":"description","rows":"6","placeholder":_vm.$t('marketingCampaigns.description')},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),_c('div',[_c('small',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.model.description ? _vm.model.description.length : '0')+" "+_vm._s(_vm.$t('marketingCampaigns.characters')))])]),_vm._v(" "),(_vm.errors.has('description'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('description'))+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingOffers.linkType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.link_type),expression:"model.link_type"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "link_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getLocations()}]}},[_c('option',{attrs:{"disabled":""}},[_vm._v("- "+_vm._s(_vm.$t('general.select'))+" -")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.intern')))]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.extern')))])]),_vm._v(" "),(_vm.errors.has('link_type'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('link_type'))+"\n        ")]):_vm._e()])]),_vm._v(" "),(_vm.model.link_type === 2)?_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.url')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.url),expression:"model.url"}],staticClass:"form-control",attrs:{"placeholder":"https://www.google.ro/"},domProps:{"value":(_vm.model.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "url", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('url'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('url'))+"\n        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.model.link_type === 1)?_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.location')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.location_token),expression:"model.location_token"}],staticClass:"form-control",on:{"input":_vm.validate,"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "location_token", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getCategories()}]}},[_c('option',{attrs:{"disabled":""}},[_vm._v("- "+_vm._s(_vm.$t('general.select'))+" -")]),_vm._v(" "),_vm._l((_vm.locations),function(loc){return _c('option',{key:loc.token,domProps:{"value":loc.token}},[_vm._v(_vm._s(loc.name))])})],2),_vm._v(" "),(_vm.errors.has('location_token'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('location_token'))+"\n        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.model.link_type === 1)?_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.category')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.category_id),expression:"model.category_id"}],staticClass:"form-control",attrs:{"disabled":!_vm.model.location_token},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.getProducts()}]}},[_c('option',{domProps:{"value":null}},[_vm._v("- "+_vm._s(_vm.$t('general.select'))+" -")]),_vm._v(" "),_vm._l((_vm.categories),function(cat){return _c('option',{key:cat.id,domProps:{"value":cat.id}},[_vm._v(_vm._s(cat.label))])})],2),_vm._v(" "),(_vm.errors.has('category_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('category_id'))+"\n        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.model.link_type === 1)?_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.product')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.product_id),expression:"model.product_id"}],staticClass:"form-control",attrs:{"disabled":!_vm.model.category_id},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "product_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("- "+_vm._s(_vm.$t('general.select'))+" -")]),_vm._v(" "),_vm._l((_vm.products),function(prod){return _c('option',{key:prod.id,domProps:{"value":prod.id}},[_vm._v(_vm._s(prod.name))])})],2),_vm._v(" "),(_vm.errors.has('product_id'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('product_id'))+"\n        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('p-checkbox',{staticClass:"margin-left-10",attrs:{"label":"Foloseste textul notificare pentru email","inline":true},model:{value:(_vm.model.ignore_email_template),callback:function ($$v) {_vm.$set(_vm.model, "ignore_email_template", $$v)},expression:"model.ignore_email_template"}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.useEmailTemplate'))+"\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('h4',{staticClass:"purple text-center"},[_vm._v(_vm._s(_vm.$t('marketingPromos.email')))]),_vm._v(" "),_c('div',{staticClass:"email-builder"},[_c('EmailEditor',{ref:"emailEditor",attrs:{"minHeight":"700px"},on:{"load":_vm.editorLoaded}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-purple mar-to-10 mar-bt-10 generate-code",staticStyle:{"display":"none"},on:{"click":function($event){$event.preventDefault();_vm.exportHtml()}}},[_vm._v("Export")]),_vm._v(" "),_c('button',{staticClass:"btn btn-purple mar-to-10 mar-bt-10 generate-code",on:{"click":function($event){$event.preventDefault();_vm.loadTemplate('template1')}}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.template'))+" 1")]),_vm._v(" "),_c('button',{staticClass:"btn btn-purple mar-to-10 mar-bt-10 generate-code",on:{"click":function($event){$event.preventDefault();_vm.loadTemplate('template2')}}},[_vm._v(_vm._s(_vm.$t('marketingCampaigns.template'))+" 2")])])])])]),_vm._v(" "),_c('upload-image-modal',{ref:"modal",attrs:{"handleModal":_vm.modalState}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x/a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'circle-chart-card',
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    percentage: {
      type: Number,
      default: 0
    },
    title: String,
    description: String
  },
  data: function data() {
    return {
      chartId: 'no-id',
      chart: null
    };
  },

  methods: {
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    renderChart: function renderChart(EasyPieChart) {
      this.chart = new EasyPieChart(this.$refs.chart, {
        lineWidth: 6,
        size: 160,
        scaleColor: false,
        trackColor: 'rgba(255,255,255,.25)',
        barColor: '#FFFFFF',
        animate: { duration: 2000, enabled: true }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var EasyPieChart;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "PeU/"));

            case 3:
              EasyPieChart = _context.sent;

              _this.renderChart(EasyPieChart);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    percentage: function percentage(newVal) {
      if (this.chart) {
        this.chart.update(newVal);
      }
    }
  }
});

/***/ }),

/***/ "x2FS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'image-input',
  inheritAttrs: false,
  props: {
    location: Object,
    label: String,
    image: String,
    imageField: String
  },
  data: function data() {
    return {
      apiUrl: ''
    };
  },

  computed: {
    fileList: function fileList() {
      if (!this.image) return [];
      return [{
        name: this.imageField || this.label || 'image',
        url: this.image
      }];
    }
  },
  created: function created() {
    this.apiUrl = "https://gatewaydev.taptasty.com/";
  },

  methods: {
    beforeUpload: function beforeUpload(file, fileList) {
      var isOkSize = file.size / 1024 / 1024 < 5;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          toast: true,
          type: 'warning',
          title: self.$t('validations.pdfSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
      }
      return isOkSize;
    },
    handleChange: function handleChange(file, fileList) {
      var _this = this;

      var isOkSize = file.size / 1024 / 1024 < 25;
      var self = this;
      if (!isOkSize) {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          toast: true,
          type: 'warning',
          text: self.$t('validations.pdfSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).then(function () {}).catch(function () {});
        this.$refs['upload-location-image'].clearFiles();
      } else {
        self.getBase64(file.raw).then(function (base64enc) {
          self.$bus.$emit('upload-location-image', { id: _this.location.id, file: base64enc, field: _this.imageField });
        });
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      this.$bus.$emit('remove-upload-location-image', { id: this.location.id, field: this.imageField });
    },
    handleExceed: function handleExceed(files, fileList) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        toast: true,
        text: self.$t('validations.removePhoto'),
        type: 'warning',
        position: 'top-end',
        showConfirmButton: true
      });
    }
  }
});

/***/ }),

/***/ "x36W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x3WR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x5cH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x7FO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CharismaLocationReceiptDetails_vue__ = __webpack_require__("Kj5G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55b97c16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CharismaLocationReceiptDetails_vue__ = __webpack_require__("QAyF");
function injectStyle (ssrContext) {
  __webpack_require__("Uwvf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55b97c16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CharismaLocationReceiptDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55b97c16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CharismaLocationReceiptDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x8jG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsGeneral_vue__ = __webpack_require__("MR49");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9df78d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsGeneral_vue__ = __webpack_require__("RQ8p");
function injectStyle (ssrContext) {
  __webpack_require__("y8lU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsGeneral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9df78d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsGeneral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xE4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card mar-to-15"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('catalogProd.groupType')},on:{"click":function($event){$event.preventDefault();_vm.openEditLocationGroupModal()}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n             "+_vm._s(_vm.$t('general.add'))+"\n           ")])])]),_vm._v(" "),(_vm.groupsData && _vm.groupsData.length)?[_c('div',{staticClass:"demo-collapse"},[_c('draggable',{attrs:{"list":_vm.groupsData,"element":'el-collapse',"draggable":".handle"},on:{"end":function($event){_vm.onEndParent($event, _vm.groupsData)}}},[_vm._l((_vm.groupsData),function(group,idx){return [_c('span',{staticClass:"handle"},[_c('div',{staticClass:"pull-right disable-chck-location-groups"},[_c('div',{staticClass:"col-md-6"},[_c('p-checkbox',{key:group.id,on:{"input":function($event){_vm.handleActiveGroup(group)}},model:{value:(group.active),callback:function ($$v) {_vm.$set(group, "active", $$v)},expression:"group.active"}},[_vm._v(_vm._s(_vm.$t('settingsOrdering.enabled')))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-1 mar-lt-15"},[_c('a',{staticClass:"btn btn-icon btn-info mar-rt-10",staticStyle:{"top":"-5px"},attrs:{"title":_vm.$t('general.edit')},on:{"click":function($event){_vm.openEditLocationGroupModal(group)}}},[_c('i',{staticClass:"ti-pencil"})])])]),_vm._v(" "),_c('el-collapse-item',{key:group.name + '_' + group.id,staticClass:"locationGroups",attrs:{"title":group.name,"name":group.name + '_' + group.id}},[(group.children && group.children.length)?[_c('draggable',{attrs:{"list":group.children,"element":'el-collapse',"draggable":".handle"},on:{"end":function($event){_vm.onEndChild($event, group.children)}}},[_vm._l((group.children),function(newphew){return [_c('location-group-section',{staticClass:"handle",attrs:{"name":newphew.name + '_' + newphew.id,"groupsDataProp":newphew,"groupToBeDeletedProp":_vm.groupToBeDeleted,"groupToBeAddedProp":_vm.groupToBeAdded,"groupToBeEditedProp":_vm.groupToBeEdited},on:{"open-modal":function($event){_vm.openEditLocationGroupModal($event)}}})]})],2)]:[_c('div',{staticClass:"pull-left status-line pad-to-10 order-buttons resize-method overflow-container"},[_vm._l((group.location_ids),function(loc,id){return [_c('button',{staticClass:"btn btn-status-margin tablet-overflow "},[_vm._v("\n                             "+_vm._s(loc.name)+"\n                           ")])]})],2)]],2)],1)]})],2)],1)]:[_c('h3',[_vm._v(_vm._s(_vm.$t('settingLocationGroups.noData')))])]],2)]),_vm._v(" "),_c('add-edit-modal',{attrs:{"openModal":_vm.openModal,"editData":_vm.editGroup},on:{"new-group":function($event){_vm.handleNewLocationGroup($event)},"edit-group":function($event){_vm.editLocationsGroup($event)},"delete-group":function($event){_vm.deleteLocationsGroup($event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xEnV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xI2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-buttons "},[_c('div',{staticClass:"left-buttons mar-rt-10"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[(_vm.groupedLocations)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.locatie')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.groupedLocations),function(group){return _c('optgroup',{key:group.vat,attrs:{"label":("VAT: " + (group.vat))}},_vm._l((group.locations),function(loc){return _c('option',{key:loc.id,domProps:{"value":loc}},[_vm._v("\n                "+_vm._s(loc.name)+"\n              ")])}))}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('gestiune.gestiune')))]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Selectează gestiunea","disabled":_vm.loading},model:{value:(_vm.selectedGestiune),callback:function ($$v) {_vm.selectedGestiune=$$v},expression:"selectedGestiune"}},_vm._l((_vm.filteredGestiuni),function(gestiune){return _c('el-option',{key:gestiune.id,attrs:{"label":gestiune.name,"value":gestiune.id}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sursa consumului")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedConsumptionSource),expression:"selectedConsumptionSource"}],staticClass:"form-control",attrs:{"disabled":_vm.loading},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedConsumptionSource=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Toate")]),_vm._v(" "),_c('option',{attrs:{"value":"direct"}},[_vm._v("Consum direct")]),_vm._v(" "),_c('option',{attrs:{"value":"production"}},[_vm._v("Consum producție")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date și oră")]),_vm._v(" "),_c('el-date-picker',{staticClass:"w-100",attrs:{"type":"datetimerange","format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm:ss","picker-options":_vm.pickerOptions,"disabled":_vm.loading || !_vm.selectedGestiune,"placeholder":"Selectează intervalul"},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"right-buttons",staticStyle:{"display":"flex","align-items":"center","justify-content":"flex-end"}},[_c('div',{staticClass:"search-button-reports"},[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('reports.search')},on:{"click":_vm.triggerFilter}},[_c('i',{staticClass:"ti-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.search')))])])]),_vm._v(" "),_c('div',{staticClass:"search-button-reports pull-left"},[_c('div',{staticClass:"btn btn-icon btn-xls-slim",attrs:{"title":_vm.$t('reports.export')},on:{"click":function($event){_vm.fetchConsumptionReport('xls')}}},[_vm._v(_vm._s(_vm.$t('general.download_xls'))+" "),_c('img',{attrs:{"src":"/static/img/export_xls.png"}})])])])]),_vm._v(" "),_c('div',{staticClass:"card mar-to-15 tableInvoice"},[_c('div',{staticClass:"card-content"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"tableInvoice",staticStyle:{"overflow-x":"auto"}},[(_vm.tableData && _vm.tableData.length)?_c('div',{staticClass:"consumption-total-header"},[_c('strong',[_vm._v("TOTAL:")]),_vm._v("\n            "+_vm._s(_vm.totalItems)+" produse —\n            "),_c('strong',[_vm._v(_vm._s(_vm.totalValue.toFixed(2))+" lei")])]):_vm._e(),_vm._v(" "),_c('el-table',{staticStyle:{"min-width":"max-content"},attrs:{"data":_vm.tableData,"empty-text":_vm.$t('gestiune.noData')},on:{"row-click":_vm.openViewConsumption}},[_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('gestiune.product'),"min-width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.price'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.price !== null)?_c('span',[_vm._v("\n                  "+_vm._s(Number(scope.row.price).toFixed(2))+" lei\n                ")]):_c('span',{staticStyle:{"cursor":"pointer","text-decoration":"underline","color":"#409EFF"},on:{"click":function($event){$event.stopPropagation();_vm.openViewConsumption(scope.row)}}},[_vm._v("\n                  "+_vm._s(_vm.$t('general.see'))+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.cantitate'),"min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.quantity).toFixed(2))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"UM","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.unit)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('gestiune.stoc.valoareTotala'),"min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.value).toFixed(2))+" lei\n              ")]}}])})],1)],1)])]),_vm._v(" "),_c('vmodal',{ref:"consumptionModal",attrs:{"name":"consumptionModal","height":"auto","width":"800"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"modal-header"},[_c('p',[_vm._v("Detalii produs: "+_vm._s(_vm.selectedProduct.name))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('el-table',{attrs:{"data":_vm.selectedProduct.consumptionDocuments}},[_c('el-table-column',{attrs:{"prop":"productId","label":"ID Produs"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":"Cantitate"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.quantity).toFixed(2))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unit","label":"UM"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price","label":"Preț"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.price).toFixed(2))+" lei\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"Valoare"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(Number(scope.row.value).toFixed(2))+" lei\n              ")]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":_vm.closeConsumptionModal}},[_vm._v("\n            "+_vm._s(_vm.$t('general.cancel2'))+"\n          ")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_CreateTicketBubble_vue__ = __webpack_require__("0w7I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_GlobalModal_vue__ = __webpack_require__("sEIX");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { CreateTicketBubble: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_CreateTicketBubble_vue__["a" /* default */], GlobalModal: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_GlobalModal_vue__["a" /* default */] },
  data: function data() {
    return {
      excludedRoutes: ['Orders', 'Reports'],
      modalComponent: null,
      modalProps: {},
      loadingView: false,
      modalId: null
    };
  },

  computed: {
    breadcrumbs: function breadcrumbs() {
      if (!this.modalProps.route) return [];
      var paths = this.modalProps.route.path.split('/').filter(function (p) {
        return p;
      });
      return paths.map(function (p, i) {
        return {
          name: p.replace(/-/g, ' ').replace(/\b\w/g, function (l) {
            return l.toUpperCase();
          }),
          path: '/' + paths.slice(0, i + 1).join('/')
        };
      });
    }
  },
  created: function created() {
    var _this = this;

    this.$bus.$on('open-modal', function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
        var id = _ref2.id,
            component = _ref2.component,
            props = _ref2.props;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.modalComponent = null;
                _this.modalProps = {};
                _this.modalId = null;

                _context.next = 5;
                return _this.$nextTick();

              case 5:

                setTimeout(function () {
                  _this.modalId = id;
                  _this.modalComponent = component;
                  _this.modalProps = props;
                }, 0);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    this.$bus.$on('close-modal', function (id) {
      if (!id || id === _this.modalId) {
        _this.modalComponent = null;
        _this.modalProps = {};
        _this.modalId = null;
      }
    });
    this.$bus.$on('set-loading', function (status) {
      _this.loadingView = status;
    });
  },

  methods: {
    breadcrumbLabel: function breadcrumbLabel(segment) {
      var labels = {
        reports: 'pages.reports',
        'referral-program': 'reports.referralProgramReport',
        ambassador: 'referralProgram.ambassadorId'
      };
      if (labels[segment]) {
        return this.$t(labels[segment]);
      }
      if (/^\d+$/.test(segment)) {
        return null;
      }
      return segment.replace(/-/g, ' ').replace(/\b\w/g, function (l) {
        return l.toUpperCase();
      });
    },
    closeModal: function closeModal() {
      this.$bus.$emit('close-modal');
    },
    setLoading: function setLoading(status) {
      this.loadingView = status;
    }
  }
});

/***/ }),

/***/ "xKX6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 337.6 335.2"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 337.6 335.2","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_1_","x":"1.5","y":"128.2","width":"129.3","height":"129.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_3_","x":"11.3","y":"137.8","transform":"matrix(0.9717 -0.2363 0.2363 0.9717 -43.5827 21.0203)","width":"109.1","height":"109.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s5_5_","d":"M8.7,150.1l88.6-21.5c4.8-1.2,9.7,1.8,10.9,6.6l21.5,88.6c1.2,4.8-1.8,9.7-6.6,10.9l-88.6,21.5\n                c-4.8,1.2-9.7-1.8-10.9-6.6L2.1,161C1,156.1,3.9,151.3,8.7,150.1z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st2"},[_c('path',{staticClass:"st3",attrs:{"d":"M0,152.2l106-25.8l25.8,106.1l-106,25.8L0,152.2z"}})])])])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_7_","x":"189.5","y":"148.2","width":"145.3","height":"145.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_9_","x":"207.9","y":"166","transform":"matrix(0.5311 -0.8473 0.8473 0.5311 -63.8197 325.7765)","width":"109.1","height":"109.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s5_11_","d":"M192,230.2l48.4-77.2c2.6-4.2,8.2-5.5,12.4-2.8l77.2,48.4c4.2,2.6,5.5,8.2,2.8,12.4l-48.4,77.2\n                c-2.6,4.2-8.2,5.5-12.4,2.8l-77.2-48.4C190.6,239.9,189.3,234.4,192,230.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st3",attrs:{"d":"M187.2,237.8l58-92.5l92.5,58l-58,92.5L187.2,237.8z"}})])])])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_13_","x":"100.2","y":"214.9","width":"121.3","height":"120"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_15_","x":"106.3","y":"220","transform":"matrix(0.1183 -0.993 0.993 0.1183 -131.0032 401.7345)","width":"108.9","height":"109.3"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s5_17_","d":"M121.9,215.2l90.5,10.8c4.9,0.6,8.5,5.1,7.9,10l-10.8,90.2c-0.6,4.9-5.1,8.5-10,7.9L109,323.3\n                c-4.9-0.6-8.5-5.1-7.9-10l10.8-90.2C112.4,218.1,116.9,214.6,121.9,215.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('path',{staticClass:"st3",attrs:{"d":"M112.9,214.1l108.5,12.9l-12.9,108.1L100,322.2L112.9,214.1z"}})])])])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_19_","x":"176.2","y":"22.9","width":"148","height":"148"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_21_","x":"196.1","y":"42.1","transform":"matrix(0.7604 -0.6495 0.6495 0.7604 -2.7231 185.9504)","width":"109.1","height":"109.1"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s5_23_","d":"M180.5,84.8l69.3-59.2c3.8-3.2,9.5-2.8,12.7,1l59.2,69.3c3.2,3.8,2.8,9.5-1,12.7l-69.3,59.2\n                c-3.8,3.2-9.5,2.8-12.7-1l-59.2-69.3C176.3,93.7,176.8,88,180.5,84.8z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st3",attrs:{"d":"M173.7,90.6l83-70.9l70.9,83l-83,70.9L173.7,90.6z"}})])])])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_25_","x":"112.7","y":"103.7","width":"129.8","height":"129.8"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st13"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s5_27_","d":"M112.7,224.4V112.7c0-5,4-9,9-9h111.8c5,0,9,4,9,9v111.8c0,5-4,9-9,9H121.7\n            C116.7,233.4,112.7,229.4,112.7,224.4z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('path',{staticClass:"st3",attrs:{"d":"M112.7,233.4V103.7h129.8v129.8H112.7z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_29_","x":"48.2","y":"2.9","width":"144","height":"142.7"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_30_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_29_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_31_","x":"65.7","y":"19.8","transform":"matrix(0.8708 -0.4917 0.4917 0.8708 -21.1068 68.7588)","width":"109.1","height":"109.6"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_32_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_31_"}})]),_vm._v(" "),_c('g',{staticClass:"st16"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s5_33_","d":"M53.6,49.2L133,4.4c4.3-2.4,9.8-0.9,12.3,3.4l44.9,79.5c2.4,4.3,0.9,9.8-3.4,12.3l-79.4,44.8\n                c-4.3,2.4-9.8,0.9-12.3-3.4L50.2,61.5C47.8,57.2,49.3,51.7,53.6,49.2z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_34_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_33_"}})]),_vm._v(" "),_c('g',{staticClass:"st17"},[_c('path',{staticClass:"st3",attrs:{"d":"M45.8,53.7l95-53.7l53.7,95l-95,53.7L45.8,53.7z"}})])])])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_35_","x":"26.7","y":"23.5","width":"290","height":"290"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_36_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_35_"}})]),_vm._v(" "),_c('g',{staticClass:"st18"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"s5_37_","cx":"171.7","cy":"168.5","r":"145"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_38_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_37_"}})]),_vm._v(" "),_c('g',{staticClass:"st19"},[_c('path',{staticClass:"st20",attrs:{"d":"M26.7,23.5h290v290h-290V23.5z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"s5_39_","x":"86","y":"81.8","width":"171.5","height":"171.5"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_40_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_39_"}})]),_vm._v(" "),_c('g',{staticClass:"st21"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"s5_41_","d":"M171.7,81.8c-47.3,0-85.7,38.4-85.7,85.7s38.4,85.7,85.7,85.7c47.3,0,85.7-38.4,85.7-85.7\n            S219,81.8,171.7,81.8z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"s5_42_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#s5_41_"}})]),_vm._v(" "),_c('g',{staticClass:"st22"},[_c('path',{staticClass:"st3",attrs:{"d":"M86,81.8h171.5v171.5H86V81.8z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xOTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_data_tables__ = __webpack_require__("tTjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Marketing_Referral_referralRewardSettings__ = __webpack_require__("g/71");









__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      rewardRoles: __WEBPACK_IMPORTED_MODULE_5__Marketing_Referral_referralRewardSettings__["a" /* rewardRoles */],
      level: 'referees',
      paginationProps: { layout: 'prev, pager, next, sizes, total' },
      refereesRows: [],
      refereesTotal: 0,
      ordersRows: [],
      ordersTotal: 0,
      selectedAmbassadorId: null,
      selectedRefereeId: null,
      refereeTitle: '',
      ambassadorNameFromApi: '',
      skipRefereesQueryChange: true,
      skipOrdersQueryChange: false
    };
  },

  computed: {
    hasV2Rewards: function hasV2Rewards() {
      return this.ordersRows.some(function (row) {
        return Array.isArray(row.reward_details);
      });
    },
    ambassadorTitle: function ambassadorTitle() {
      var q = this.route.query || {};
      if (q.title) return q.title;
      if (this.ambassadorNameFromApi) return this.ambassadorNameFromApi;
      var id = this.selectedAmbassadorId;
      return id != null ? this.$t('general.idHash', { id: id }) : '';
    }
  },
  created: function created() {
    var raw = this.route.params && this.route.params.ambassadorId;
    this.selectedAmbassadorId = raw != null && raw !== '' ? raw : null;
    if (this.selectedAmbassadorId == null) {
      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('', this.$t('validations.wentWrong'), 'error').catch(function () {});
      return;
    }
    this.fetchReferees(1, 10);
  },

  methods: {
    roleRewards: function roleRewards(row, role) {
      var rewards = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Marketing_Referral_referralRewardSettings__["b" /* recordedRoleRewards */])(row, role, this.$t.bind(this));
      if (rewards !== null) return rewards;

      if (role === 'ambassador_1') return [];
      var value = role === 'referee' ? this.orderRefereeReward(row) : this.orderAmbassadorOrderReward(row);
      var legacy = [];
      if (value != null) legacy.push(this.$t('referralProgram.v2.order_reward') + ': ' + this.formatMoney(value));
      var cashback = role === 'ambassador_2' ? this.orderAmbassadorCashback(row) : null;
      if (cashback != null) legacy.push(this.$t('referralProgram.v2.cashback') + ': ' + this.formatMoney(cashback));
      return legacy;
    },
    backButton: function backButton() {
      if (this.level === 'orders') {
        this.level = 'referees';
        this.selectedRefereeId = null;
        this.skipRefereesQueryChange = true;
        this.fetchReferees(1, 10);
        return;
      }
      this.$bus.$emit('close-modal');
    },
    formatMoney: function formatMoney(v) {
      if (v === null || v === undefined || v === '') return this.$t('general.emDash');
      var n = Number(v);
      return isNaN(n) ? String(v) : n.toFixed(2);
    },
    pickRowAmount: function pickRowAmount(row, keys) {
      if (!row || !keys) return undefined;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var v = row[key];
          if (v !== null && v !== undefined && v !== '') return v;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return undefined;
    },
    orderGrandtotal: function orderGrandtotal(row) {
      if (row.order_grandtotal != null) return row.order_grandtotal;
      if (row.order && row.order.totals_grandtotal != null) return row.order.totals_grandtotal;
      return this.pickRowAmount(row, ['totals_grandtotal', 'order_total']);
    },
    orderRefereeReward: function orderRefereeReward(row) {
      if (row.referee_reward != null) return row.referee_reward;
      return this.pickRowAmount(row, ['referee_loyalty_awarded', 'referee_reward_amount', 'referee_loyalty_points']);
    },
    orderAmbassadorOrderReward: function orderAmbassadorOrderReward(row) {
      if (row.ambassador_earnings && row.ambassador_earnings.from_order_rewards != null) {
        return row.ambassador_earnings.from_order_rewards;
      }
      return this.pickRowAmount(row, ['ambassador_order_reward', 'ambassador_order_reward_amount']);
    },
    orderAmbassadorCashback: function orderAmbassadorCashback(row) {
      if (row.ambassador_earnings && row.ambassador_earnings.from_cashback != null) {
        return row.ambassador_earnings.from_cashback;
      }
      return this.pickRowAmount(row, ['ambassador_cashback_amount']);
    },
    refereeEarningsCashback: function refereeEarningsCashback(row) {
      if (row.earnings && row.earnings.from_cashback != null) return row.earnings.from_cashback;
      return row.earned_cashback_percent_total;
    },
    refereeEarningsTotal: function refereeEarningsTotal(row) {
      if (row.earnings && row.earnings.total != null) return row.earnings.total;
      return row.earned_for_ambassador_total || row.ambassador_earnings || row.total_ambassador_from_referee;
    },
    displayPersonName: function displayPersonName(row, role) {
      if (!row) return this.$t('general.emDash');
      if (row.full_name) return row.full_name;
      if (row.name) return row.name;
      var fn = String(row.firstname || row.first_name || '').trim();
      var ln = String(row.lastname || row.last_name || '').trim();
      var s = [fn, ln].filter(Boolean).join(' ');
      if (s) return s;
      var id = role === 'referee' ? row.referee_user_id || row.user_id || row.id : row.ambassador_user_id || row.user_id || row.id;
      return this.$t('general.idHash', { id: id });
    },
    refereeIdFromRow: function refereeIdFromRow(row) {
      return row.referee_user_id || row.user_id || row.id;
    },
    onRefereeRow: function onRefereeRow(row) {
      this.selectedRefereeId = this.refereeIdFromRow(row);
      this.refereeTitle = this.displayPersonName(row, 'referee');
      this.level = 'orders';
      this.skipOrdersQueryChange = true;
      this.fetchOrders(1, 10);
    },
    normalizeRows: function normalizeRows(response, listKey) {
      if (!response || !response.data) return [];
      var d = response.data;
      if (Array.isArray(d)) return d;
      if (listKey && Array.isArray(d[listKey])) return d[listKey];
      if (Array.isArray(d.referees)) return d.referees;
      if (Array.isArray(d.orders)) return d.orders;
      if (Array.isArray(d.data)) return d.data;
      return [];
    },
    normalizeTotal: function normalizeTotal(response, listKey) {
      if (response.pagination && response.pagination.total != null) return response.pagination.total;
      if (response.meta && response.meta.total != null) return response.meta.total;
      var d = response.data;
      if (d && d.total != null) return d.total;
      return this.normalizeRows(response, listKey).length;
    },
    baseParams: function baseParams() {
      return {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
    },
    onRefereesPage: function onRefereesPage(q) {
      if (this.skipRefereesQueryChange) {
        this.skipRefereesQueryChange = false;
        return;
      }
      this.fetchReferees(q.page, q.pageSize);
    },
    fetchReferees: function fetchReferees(page, perPage) {
      var _this = this;

      if (!this.selectedAmbassadorId) return;
      this.loading = true;
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.baseParams(), { page: page, perPage: perPage });
      var path = '/reports/v2/referral-ambassadors/' + this.selectedAmbassadorId + '/referees?page=' + page + '&perPage=' + perPage;
      this.apiRequest(path, 'GET', data, function (response) {
        if (response.status) {
          var amb = response.data && response.data.ambassador;
          if (amb && amb.name) {
            _this.ambassadorNameFromApi = String(amb.name).trim();
          }
          _this.refereesRows = _this.normalizeRows(response, 'referees');
          _this.refereesTotal = _this.normalizeTotal(response, 'referees');
        } else {
          __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('', _this.$t('validations.wentWrong'), 'error');
        }
        _this.loading = false;
      });
    },
    onOrdersPage: function onOrdersPage(q) {
      if (this.skipOrdersQueryChange) {
        this.skipOrdersQueryChange = false;
        return;
      }
      this.fetchOrders(q.page, q.pageSize);
    },
    fetchOrders: function fetchOrders(page, perPage) {
      var _this2 = this;

      if (!this.selectedRefereeId) return;
      this.loading = true;
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.baseParams(), { page: page, perPage: perPage });
      var path = '/reports/v2/referral-referees/' + this.selectedRefereeId + '/orders?page=' + page + '&perPage=' + perPage;
      this.apiRequest(path, 'GET', data, function (response) {
        if (response.status) {
          var referee = response.data && response.data.referee;
          if (referee && referee.name) {
            _this2.refereeTitle = referee.name;
          }
          _this2.ordersRows = _this2.normalizeRows(response, 'orders');
          _this2.ordersTotal = _this2.normalizeTotal(response, 'orders');
        } else {
          __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
        }
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "xPUc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vmodal',{attrs:{"name":"uploadImageModal","minWidth":1000,"minHeight":700,"adaptive":true}},[_c('div',{staticClass:"images-modal"},[_c('div',{ref:"optionsTopBar",staticClass:"category-top-bar location-group-form-modal"},[_c('div',{staticClass:"upload-modal-header"},[_c('p',[_c('a',{staticClass:"btn btn-icon btn-danger mar-rt-10",attrs:{"title":_vm.$t('settingsPages.locationGroupsDelete')},on:{"click":function($event){$event.preventDefault();_vm.closeModal()}}},[_c('i',{staticClass:"ti-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"row height-200"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('upload.browse')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","limit":2,"file-list":_vm.imagelist,"list-type":"picture-card","accept":" .jpg, .jpeg, .png","on-change":_vm.handleImgChnage,"on-exceed":_vm.handleExceed,"on-remove":_vm.handleRemove,"auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('validations.pictureSize2MB')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12 choose-image"},[_c('label',[_vm._v(_vm._s(_vm.$t('marketingCampaigns.chooseImage')))])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"productlist"},[_vm._l((_vm.images),function(image){return [_c('div',{staticClass:"product",on:{"click":function($event){_vm.selectImage(image)}}},[_c('div',{staticClass:"product_img_title"},[(image.filename)?[_c('div',{staticClass:"productImage",style:('background: url(' + image.filename + ');')},[_c('a',{staticClass:"btn btn-danger active btn-icon margin-7",on:{"click":function($event){$event.stopPropagation();_vm.deleteImage(image.id)}}},[_c('i',{staticClass:"ti-close"})])])]:_vm._e()],2)])]})],2)])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xRQ2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xUnp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ModuleLocked',
  props: {
    module: { type: String, default: '' },
    title: { type: String, default: 'Modul indisponibil' },
    message: { type: String, required: true },
    hint: { type: String, default: '' },
    icon: { type: String, default: '🔒' },
    actionText: { type: String, default: '' }
  }
});

/***/ }),

/***/ "xUte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert2_dist_sweetalert2_css__);


















__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_js_modal___default.a, { componentName: 'vmodal' });

var TITLE_MAX = 35;
var DESCRIPTION_MAX = 180;
var MAX_IMAGE_MB = 5;
var MAX_IMAGE_PX = 900;

var DISPLAY_MODES = ['contain', 'cover', 'full_page'];
var DISPLAY_DEFAULT = 'contain';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default.a,
    PSwitch: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      TITLE_MAX: TITLE_MAX,
      DESCRIPTION_MAX: DESCRIPTION_MAX,
      MAX_IMAGE_MB: MAX_IMAGE_MB,
      MAX_IMAGE_PX: MAX_IMAGE_PX,
      DISPLAY_MODES: DISPLAY_MODES,
      loading: true,
      saving: false,
      slides: [],
      settings: {
        use_interactive_tour_first_login: false,
        use_interactive_tour_always: false
      },
      form: this.emptyForm()
    };
  },

  computed: {
    companyID: function companyID() {
      return this.$session.get('selectedCompany');
    },
    token: function token() {
      return this.$session.get('token');
    }
  },
  created: function created() {
    this.initPage();
  },

  methods: {
    emptyForm: function emptyForm() {
      return {
        id: null,
        title: '',
        description: '',
        display_mode: DISPLAY_DEFAULT,
        active: 1,
        imagelist: [],
        filename: null
      };
    },
    baseData: function baseData(extra) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({
        token: this.token,
        company_id: this.companyID
      }, extra || {});
    },
    initPage: function initPage() {
      this.loading = true;
      this.getSettings();
      this.getSlides();
    },
    getSlides: function getSlides() {
      var _this = this;

      this.apiRequest('/interactive-tour', 'GET', this.baseData(), function (response) {
        if (response.status === true) {
          _this.slides = response.data;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    getSettings: function getSettings() {
      var _this2 = this;

      this.apiRequest('/interactive-tour/settings', 'GET', this.baseData(), function (response) {
        if (response.status === true && response.data) {
          _this2.settings = {
            use_interactive_tour_first_login: !!response.data.use_interactive_tour_first_login,
            use_interactive_tour_always: !!response.data.use_interactive_tour_always
          };
        }
      });
    },
    displayModeLabel: function displayModeLabel(mode) {
      var key = {
        contain: 'interactiveTourDisplayContain',
        cover: 'interactiveTourDisplayCover',
        full_page: 'interactiveTourDisplayFullPage'
      }[mode] || 'interactiveTourDisplayContain';
      return this.$t('settingsPages.' + key);
    },
    saveSettings: function saveSettings(key) {
      var _this3 = this;

      var value = this.settings[key] ? 1 : 0;
      var data = this.baseData(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, key, value));
      this.apiRequest('/interactive-tour/settings', 'POST', data, function (response) {
        if (response.status !== true) {
          _this3.settings[key] = !_this3.settings[key];
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    openCreate: function openCreate() {
      this.form = this.emptyForm();
      this.$modal.show('tourModal');
    },
    openEdit: function openEdit(item) {
      var _this4 = this;

      this.apiRequest('/interactive-tour/' + item.id, 'GET', this.baseData(), function (response) {
        if (response.status === true) {
          _this4.form = _this4.mapToForm(response.data);
          _this4.$modal.show('tourModal');
        } else {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    closeModal: function closeModal() {
      this.$modal.hide('tourModal');
    },
    onModalOpened: function onModalOpened() {
      var el = document.querySelector('.tourModal.vm--container');
      if (el && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    },
    mapToForm: function mapToForm(data) {
      var form = this.emptyForm();
      form.id = data.id;
      form.title = data.title || '';
      form.description = data.description || '';
      form.display_mode = DISPLAY_MODES.indexOf(data.display_mode) !== -1 ? data.display_mode : DISPLAY_DEFAULT;
      form.active = data.active ? 1 : 0;
      form.filename = data.image_filename || null;
      form.imagelist = data.image_filename ? [{ url: data.image_url, name: data.image_filename, filename: data.image_filename }] : [];
      return form;
    },
    handleImageChange: function handleImageChange(file, fileList) {
      var _this5 = this;

      if (this.isOversized(file)) {
        this.warnOversized();
        this.form.imagelist = fileList.filter(function (f) {
          return f.uid !== file.uid;
        }).slice(-1);
        return;
      }

      var raw = file.raw;
      if (!raw) {
        this.form.imagelist = fileList.filter(function (f) {
          return !_this5.isOversized(f);
        }).slice(-1);
        return;
      }

      this.checkDimensions(raw, function (ok) {
        if (!ok) {
          _this5.warnDimensions();

          _this5.form.imagelist = fileList.filter(function (f) {
            return f.uid !== file.uid;
          }).slice(-1);
        } else {
          _this5.form.imagelist = fileList.filter(function (f) {
            return !_this5.isOversized(f);
          }).slice(-1);
        }
      });
    },
    handleImageRemove: function handleImageRemove() {
      this.form.imagelist = [];
      this.form.filename = null;
    },
    handleExceed: function handleExceed() {
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', 'Poți adăuga o singură poză.', 'warning').catch(function () {});
    },
    isOversized: function isOversized(file) {
      return !!(file && file.size && file.size / 1024 / 1024 > MAX_IMAGE_MB);
    },
    checkDimensions: function checkDimensions(rawFile, onResult) {
      var url = window.URL.createObjectURL(rawFile);
      var img = document.createElement('img');
      img.onload = function () {
        var ok = img.naturalWidth <= MAX_IMAGE_PX && img.naturalHeight <= MAX_IMAGE_PX;
        window.URL.revokeObjectURL(url);
        onResult(ok);
      };
      img.onerror = function () {
        window.URL.revokeObjectURL(url);
        onResult(true);
      };
      img.src = url;
    },
    warnOversized: function warnOversized() {
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        toast: true,
        type: 'warning',
        text: this.$t('validations.pictureSizeExceed'),
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      }).catch(function () {});
    },
    warnDimensions: function warnDimensions() {
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        toast: true,
        type: 'warning',
        text: 'Poza trebuie să fie de maxim ' + MAX_IMAGE_PX + 'x' + MAX_IMAGE_PX + 'px.',
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      }).catch(function () {});
    },
    collectImage: function collectImage() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var f;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                f = _this6.form.imagelist && _this6.form.imagelist[0];

                if (f) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', '');

              case 3:
                if (!f.raw) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', _this6.getBase64(f.raw));

              case 5:
                if (!f.filename) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', f.filename);

              case 7:
                return _context.abrupt('return', '');

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    save: function save() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var title, description, hasImage, image, data, isUpdate, url, method;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                title = (_this7.form.title || '').trim();
                description = (_this7.form.description || '').trim();
                hasImage = !!(_this7.form.imagelist && _this7.form.imagelist[0]);

                if (!(!title && !description && !hasImage)) {
                  _context2.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', 'Adaugă cel puțin o poză, un titlu sau o descriere.', 'warning').catch(function () {});
                return _context2.abrupt('return');

              case 6:
                if (!(title.length > TITLE_MAX)) {
                  _context2.next = 9;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', 'Titlul poate avea maxim ' + TITLE_MAX + ' caractere.', 'warning').catch(function () {});
                return _context2.abrupt('return');

              case 9:
                if (!(description.length > DESCRIPTION_MAX)) {
                  _context2.next = 12;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', 'Descrierea poate avea maxim ' + DESCRIPTION_MAX + ' caractere.', 'warning').catch(function () {});
                return _context2.abrupt('return');

              case 12:

                _this7.saving = true;

                image = void 0;
                _context2.prev = 14;
                _context2.next = 17;
                return _this7.collectImage();

              case 17:
                image = _context2.sent;
                _context2.next = 25;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](14);

                _this7.saving = false;
                __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this7.$t('validations.wentWrong'), 'error').catch(function () {});
                return _context2.abrupt('return');

              case 25:
                data = _this7.baseData({
                  title: _this7.form.title,
                  description: _this7.form.description,
                  image: image,
                  display_mode: _this7.form.display_mode || DISPLAY_DEFAULT,
                  active: _this7.form.active ? 1 : 0
                });
                isUpdate = !!_this7.form.id;
                url = isUpdate ? '/interactive-tour/' + _this7.form.id : '/interactive-tour';
                method = isUpdate ? 'PUT' : 'POST';


                _this7.apiRequest(url, method, data, function (response) {
                  _this7.saving = false;
                  if (response.status === true) {
                    _this7.closeModal();
                    _this7.getSlides();
                    __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()(_this7.$t('general.success') + '!', '', 'success').catch(function () {});
                  } else {
                    var msg = response.errors ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(response.errors)[0] : _this7.$t('validations.wentWrong');
                    __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', msg, 'error').catch(function () {});
                  }
                });

              case 30:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7, [[14, 20]]);
      }))();
    },
    handleActive: function handleActive(row) {
      var _this8 = this;

      var actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = _this8.baseData({ active: row.active ? 1 : 0 });
          _this8.apiRequest('/interactive-tour/' + row.id, 'PUT', data, function (response) {
            if (response.status !== true) {
              row.active = !row.active;
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', _this8.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        } else {
          row.active = !row.active;
        }
      }).catch(function () {
        row.active = !row.active;
      });
    },
    onReorder: function onReorder() {
      var _this9 = this;

      var order = this.slides.map(function (s) {
        return s.id;
      });
      var data = this.baseData({ order: order });
      this.apiRequest('/interactive-tour/reorder', 'POST', data, function (response) {
        if (response.status !== true) {
          __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
            title: '',
            text: _this9.$t('validations.dataCouldNotBeSaved'),
            type: 'error',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
        }
      });
    },
    handleDelete: function handleDelete(index, row, event) {
      var _this10 = this;

      var self = this;
      if (event) event.stopPropagation();
      __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()({
        text: self.$t('marketingCampaigns.areYouSureDelete') + (' \'' + (row.title || '') + '\'?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this10.apiRequest('/interactive-tour/' + row.id, 'DELETE', _this10.baseData(), function (response) {
            if (response.status === true) {
              self.slides.splice(index, 1);
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('general.success') + '!', 'success').catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "xV81":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xVQE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t3_vue__ = __webpack_require__("n7HU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75a4a63a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t3_vue__ = __webpack_require__("6nWX");
function injectStyle (ssrContext) {
  __webpack_require__("lvvt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75a4a63a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_t3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75a4a63a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_t3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xWAE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Groups_vue__ = __webpack_require__("zRY3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf86598_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Groups_vue__ = __webpack_require__("qOx5");
function injectStyle (ssrContext) {
  __webpack_require__("xlS/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bf86598"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Groups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf86598_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Groups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xXAM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xdcT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vmodal',{ref:"allModulesModal",staticClass:"allModulesModal",attrs:{"name":"allModulesModal","height":"auto","width":"1100"}},[_c('div',{staticClass:"modules-modal-wrapper"},[_c('div',{staticClass:"close-modal",on:{"click":_vm.closeModulesModal}},[_vm._v("✕")]),_vm._v(" "),_c('div',{staticClass:"modules-left"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('general.ecosystem')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('general.ecosystem_more_than_you_use')))])]),_vm._v(" "),_c('img',{staticClass:"girl-image",attrs:{"src":__webpack_require__("SvRh")}})]),_vm._v(" "),_c('div',{ref:"scrollContainer",staticClass:"modules-right",on:{"wheel":function($event){$event.preventDefault();return _vm.onWheel($event)},"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},[_c('div',{staticClass:"progress-wrapper"},[_c('p',{staticClass:"progress-title"},[_vm._v(_vm._s(_vm.$t('general.how_much_you_use')))]),_vm._v(" "),_c('div',{staticClass:"progress-bar-area"},[_c('span',{staticClass:"progress-badge"},[_vm._v(_vm._s(_vm.activeModulesPercent)+"%")]),_vm._v(" "),_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-fill",style:({ width: _vm.activeModulesPercent + '%' })})])]),_vm._v(" "),_c('div',{staticClass:"progress-labels"},[_c('span',[_vm._v(_vm._s(_vm.$t('general.only_this_much_you_use')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('general.you_use_full_system')))])])]),_vm._v(" "),_c('div',{staticClass:"modules-title"},[_vm._v(_vm._s(_vm.$t('general.all_taptasty_modules')))]),_vm._v(" "),_c('div',{staticClass:"modules-group-title"},[_vm._v(_vm._s(_vm.$t('general.modules_active')))]),_vm._v(" "),_c('div',{staticClass:"modules-grid"},_vm._l((_vm.activeModules),function(module){return _c('div',{key:module.key,staticClass:"module-card active"},[_c('div',{staticClass:"module-icon"},[_c('img',{attrs:{"src":module.image,"alt":module.key}})]),_vm._v(" "),_c('div',{staticClass:"module-name"},[_vm._v(_vm._s(_vm.$t(("general." + (module.name)))))]),_vm._v(" "),_c('div',{staticClass:"module-check active"},[_vm._v("✓")])])})),_vm._v(" "),_c('div',{staticClass:"modules-group-title inactive-title"},[_vm._v(_vm._s(_vm.$t('general.modules_inactive_hint')))]),_vm._v(" "),_c('div',{staticClass:"modules-grid"},_vm._l((_vm.inactiveModules),function(module){return _c('div',{key:module.key,staticClass:"module-card inactive"},[_c('div',{staticClass:"module-icon"},[_c('img',{attrs:{"src":module.image,"alt":module.key}})]),_vm._v(" "),_c('div',{staticClass:"module-name"},[_vm._v(_vm._s(_vm.$t(("general." + (module.name)))))]),_vm._v(" "),_c('div',{staticClass:"module-check"},[_vm._v("✓")])])}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xeGU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAWVJREFUSEvtVTFOw1AMtYWQ2OgNKDeAI7AglQX2FrWcoM0JKCcgnIBEhZ0urcQCN6BHgBt0RELIPEfJV/r5AScqUgc8RXbsZ/vZ/kwVMptIDFOfmVr6iwgtiSk56XFU5RPSc0ipwRF4GAwkdNU557EVhOd3yG0N0ukhpYD8A7imbE6LqjLx+fOHw1zBnwM0nVhzBVYALM8b/o1ZaIHFe67y+7YH1hZZE1kLQEF4KLlam4y2RDh2egSdPN7LwafQiyq2mA6Pu7wo280A2nMEbz/dSut9m65JKIVuiAt0Vg6Iy/aAo3SDy9tHRRe1WzSfyBjOlyYOcHlrA+QVZG9FCSTNv1d0Ox80MreoTKBXRQrbQAFAduKA83djcwCKCXEkE2VZ56KZq6zo0KLIXEExok1IXgJ51zAVr+j1viNZKME0jeB36vlOMcIxbAPlhutk1GjRMvYx2wJELMjer5UIHfnH7adT8QV0utqlKPlsYgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "xhcJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xidW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__("sUu7");















__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a),
  props: {
    defaultData: {},
    modeldata: {},
    taxesData: {}
  },
  watch: {
    defaultData: function defaultData(value) {
      this.defaults = value;
    },
    modeldata: function modeldata(value) {
      this.model = value;
    },
    taxesData: function taxesData(value) {
      __WEBPACK_IMPORTED_MODULE_7_vue___default.a.set(this, 'taxes', value.taxes);
      __WEBPACK_IMPORTED_MODULE_7_vue___default.a.set(this, 'vat', value.vat);
    }
  },
  data: function data() {
    return {
      model: this.value || this.modeldata,
      defaults: this.value || this.defaultData,
      taxes: this.value || this.taxesData['taxes'],
      vat: this.value || this.taxesData['vat'],
      loading: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vee_validate__["b" /* mapFields */])(['title', 'description'])),
  created: function created() {
    this.$nextTick(function () {
      this.loading = false;
    });
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this.saveTax();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        this.errors.add(prop, errors[prop]);
      }
    },
    goToCompanyLocations: function goToCompanyLocations() {
      console.log('here');
      this.$router.push({
        path: '/settings',
        query: { tabIndex: 1 }
      });
    },
    saveTax: function saveTax() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var data = {};
      var taxes = this.taxes;
      taxes = taxes.concat(this.vat);
      var companyId = this.$session.get('selectedCompany');
      for (var tax in taxes) {
        if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(taxes[tax].id) && taxes[tax].id && taxes[tax].id.indexOf('new') === 0) {
          delete taxes[tax].id;
        }
        taxes[tax].company_id = companyId;
      }
      data.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(taxes);
      data.token = this.$session.get('token');
      data.company_id = this.$session.get('selectedCompany');

      var self = this;
      this.apiRequest('/settings/taxes/all', 'PUT', data, function (response) {
        if (response.status === true) {
          self.errors.clear();
          self.$nextTick(function () {
            self.loading = false;
          });
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': 'Taxes saved successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
          for (var taxIdx in response.data) {
            response.data[taxIdx].hash_id = response.data[taxIdx].id;
          }
          self.$emit('setTaxes');
        } else {
          self.$nextTick(function () {
            self.loading = false;
          });
          self.handleErrors(response.errors);
        }
      });
    },
    addNewTax: function addNewTax() {
      var id = 'new_' + Math.floor(Math.random() * 10000);
      var newRow = {
        'hash_id': id,
        'id': id,
        'name': '',
        'is_vat': false
      };
      this.taxes.push(newRow);
    },
    addNewVat: function addNewVat() {
      var id = 'new_' + Math.floor(Math.random() * 10000);
      var newRow = {
        'hash_id': id,
        'id': id,
        'name': '',
        'is_vat': true
      };
      this.vat.push(newRow);
    },
    deleteTax: function deleteTax(taxId) {
      var _this2 = this;

      var thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.taxes);

      var self = this;
      __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({
        text: 'Are you sure you want to delete this tax?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(taxId) && taxId.indexOf('new') === 0) {
            _this2.taxes.splice(thisTaxIdx, 1);
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': 'Tax deleted successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
          } else {
            var id = taxId;
            var data = {
              id: id,
              token: _this2.$session.get('token'),
              company_id: _this2.$session.get('selectedCompany')
            };
            _this2.apiRequest('/settings/taxes/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                var updatedTaxes = self.taxes;
                updatedTaxes.splice(thisTaxIdx, 1);
                self.$emit('setTaxes');
                __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': 'Tax deleted successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000 });
              } else {
                __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()({ 'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 2000 });
              }
            });
          }
        }
      });
    }
  }
});

/***/ }),

/***/ "xkQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WoltMenuLayout_vue__ = __webpack_require__("mYhK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GlovoMenuLayout_vue__ = __webpack_require__("vLc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BoltMenuLayout_vue__ = __webpack_require__("otpQ");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntegrationMenuPreviewModal',
  components: {
    WoltMenuLayout: __WEBPACK_IMPORTED_MODULE_2__WoltMenuLayout_vue__["a" /* default */],
    GlovoMenuLayout: __WEBPACK_IMPORTED_MODULE_3__GlovoMenuLayout_vue__["a" /* default */],
    BoltMenuLayout: __WEBPACK_IMPORTED_MODULE_4__BoltMenuLayout_vue__["a" /* default */]
  },
  props: {
    visible: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    importing: { type: Boolean, default: false },
    layout: { type: String, default: 'wolt' },
    currency: { type: String, default: 'RON' },
    categories: { type: Array, default: function _default() {
        return [];
      } },
    errorMessage: { type: String, default: '' },
    warnings: { type: Array, default: function _default() {
        return [];
      } },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' }
  },
  data: function data() {
    return {
      searchQuery: ''
    };
  },

  computed: {
    hasCategories: function hasCategories() {
      return Array.isArray(this.categories) && this.categories.length > 0;
    },
    normalizedQuery: function normalizedQuery() {
      return String(this.searchQuery || '').trim().toLowerCase();
    },
    filteredCategories: function filteredCategories() {
      var _this = this;

      var cats = Array.isArray(this.categories) ? this.categories : [];
      var q = this.normalizedQuery;
      if (!q) return cats;

      var out = [];
      cats.forEach(function (category) {
        var catName = String(category && category.name || '').toLowerCase();
        var catId = String(category && category.id || '').toLowerCase();
        var products = Array.isArray(category.products) ? category.products : [];
        var matchedProducts = products.filter(function (product) {
          return _this.productMatches(product, q);
        });

        if (matchedProducts.length) {
          out.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, category, { products: matchedProducts }));
        } else if (catName.indexOf(q) !== -1 || catId.indexOf(q) !== -1) {
          out.push(category);
        }
      });
      return out;
    }
  },
  watch: {
    visible: function visible(val) {
      if (typeof document === 'undefined') return;
      document.body.style.overflow = val ? 'hidden' : '';
      if (!val) this.searchQuery = '';
    },
    categories: function categories() {
      this.searchQuery = '';
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
  },

  methods: {
    warningMessage: function warningMessage(warning) {
      var key = 'marketplace.previewWarnings.' + warning.code;
      return this.$te(key) ? this.$t(key) : warning.message;
    },
    onClose: function onClose() {
      if (this.busy || this.importing) return;
      this.$emit('close');
    },
    productMatches: function productMatches(product, q) {
      if (!product || !q) return false;
      var haystacks = [product.id, product.name, product.description, product.price, product.image_url];
      if (haystacks.some(function (v) {
        return String(v == null ? '' : v).toLowerCase().indexOf(q) !== -1;
      })) {
        return true;
      }
      var options = Array.isArray(product.options) ? product.options : [];
      for (var i = 0; i < options.length; i++) {
        var opt = options[i] || {};
        if (String(opt.id || '').toLowerCase().indexOf(q) !== -1) return true;
        if (String(opt.name || '').toLowerCase().indexOf(q) !== -1) return true;
        var values = Array.isArray(opt.values) ? opt.values : [];
        for (var j = 0; j < values.length; j++) {
          var val = values[j] || {};
          if (String(val.id || '').toLowerCase().indexOf(q) !== -1) return true;
          if (String(val.name || '').toLowerCase().indexOf(q) !== -1) return true;
        }
      }
      try {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(product).toLowerCase().indexOf(q) !== -1;
      } catch (e) {
        return false;
      }
    }
  }
});

/***/ }),

/***/ "xlS/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xlfv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Accounting_AccountingInboundInvoices_vue__ = __webpack_require__("F+V8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Accounting_AccountingSales_vue__ = __webpack_require__("dmW6");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AccountingInboundInvoices: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Views_Management_Accounting_AccountingInboundInvoices_vue__["a" /* default */],
    AccountingSales: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Management_Accounting_AccountingSales_vue__["a" /* default */]
  },

  props: {
    groupedLocations: {
      type: Array,
      required: true
    },
    gestiuneOptions: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      isAccountingInboundInvoices: true,
      isAccountingSales: false
    };
  },


  methods: {
    openAccountingInboundInvoices: function openAccountingInboundInvoices() {
      this.isAccountingInboundInvoices = true;
      this.isAccountingSales = false;
    },
    openAccountingSales: function openAccountingSales() {
      this.isAccountingInboundInvoices = false;
      this.isAccountingSales = true;
    }
  }
});

/***/ }),

/***/ "xp8n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xqpA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xsVP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xt4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.cancelZone($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex"},[(!_vm.isNew)?_c('a',{staticClass:"btn btn-danger btn-icon btn btn mar-rt-10 delete",staticStyle:{"padding":"7px 10px","margin-right":"20px"},on:{"click":function($event){$event.preventDefault();return _vm.deleteZone($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-success btn mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15",staticStyle:{"display":"flex","justify-content":"flex-start","align-items":"stretch"}},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("ID: "+_vm._s(_vm.model.id))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.name')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.name),expression:"modelValidate.name"},{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",attrs:{"type":"text","name":"name","data-vv-as":"name","placeholder":_vm.$t('settingTable.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('name'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.short')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidate.short),expression:"modelValidate.short"},{name:"model",rawName:"v-model",value:(_vm.model.short),expression:"model.short"}],staticClass:"form-control",attrs:{"type":"text","name":"short","data-vv-as":"short","placeholder":_vm.$t('settingTable.short')},domProps:{"value":(_vm.model.short)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "short", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('short'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('short'))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.short_spv')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.short_spv),expression:"model.short_spv"}],attrs:{"type":"hidden","name":"short_spv","data-vv-as":"short_spv"},domProps:{"value":(_vm.model.short_spv)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "short_spv", $event.target.value)}}}),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.unitOptions,"label":"text","placeholder":_vm.$t('settingTable.short_spv'),"searchable":true},model:{value:(_vm.model.short_spv),callback:function ($$v) {_vm.$set(_vm.model, "short_spv", $$v)},expression:"model.short_spv"}}),_vm._v(" "),(_vm.errors.has('short_spv'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.getError('short_spv'))+"\n                ")]):_vm._e()],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"height":"100%","width":"100%","margin":"0"}},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.errors.has('error'))?_c('p',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('button',{staticClass:"btn btn-sm btn-outline-primary",on:{"click":function($event){$event.preventDefault();return _vm.addConversion($event)}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" "+_vm._s(_vm.$t('general.addConversion'))+"\n                ")])]),_vm._v(" "),_vm._l((_vm.model.unit_calc),function(conversion,index){return _c('div',{key:index,staticClass:"d-flex align-items-center mb-2",staticStyle:{"margin-bottom":"20px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.unit_calc[index].unit_id),expression:"model.unit_calc[index].unit_id"}],staticClass:"form-control mr-2",staticStyle:{"max-width":"300px","margin-right":"10px"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.unit_calc[index], "unit_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.onUnitChange(index)}]}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('general.selectUnit')))]),_vm._v(" "),_vm._l((_vm.allUnits),function(unit){return _c('option',{key:unit.id,attrs:{"disabled":_vm.isUnitAlreadyUsed(unit.id, index)},domProps:{"value":unit.id}},[_vm._v("\n                      "+_vm._s(unit.name)+" ("+_vm._s(unit.short)+") \n                    ")])})],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(conversion.value),expression:"conversion.value",modifiers:{"number":true}}],staticClass:"form-control mr-2",staticStyle:{"width":"200px","margin-right":"10px"},attrs:{"type":"number","placeholder":"Valoare"},domProps:{"value":(conversion.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(conversion, "value", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",staticStyle:{"width":"35px","height":"35px","padding":"0"},on:{"click":function($event){$event.preventDefault();_vm.removeConversion(index)}}},[_c('i',{staticClass:"ti-close"})])])})],2)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xwFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"card mar-to-15"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',[_c('button',{staticClass:"btn add mar-rt-10",attrs:{"title":_vm.$t('general.add')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n                "+_vm._s(_vm.$t('general.add'))+"\n              ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"search-def":{},"pagination-def":{},"table-props":{'border': false}}},[_c('el-table-column',{attrs:{"min-width":"10","prop":"name","label":"ID"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.id || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"ip_port_printer","label":"Ip-Port"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.ip_port_printer ? props.row.ip_port_printer : "-"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"30","prop":"series","label":"Series"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"cell-center"},[_vm._v(_vm._s(props.row.series ? props.row.series : "-"))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":320,"label":_vm.$t('general.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('marketingCampaigns.send')},on:{"click":function($event){_vm.handleDelete(props.row.id)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                  "+_vm._s(_vm.$t('general.delete'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"edit",on:{"click":function($event){_vm.goToRecord(props.row, $event, props.row)}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n                ")])]}}])})],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xwWO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xz3T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"outer-container"}},[_c('div',{ref:"navButtons",staticClass:"card mar-bt-0 mar-to-10 max-z-index navButtons"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"clearfix row pad-lf-10 pad-rg-10"},[_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isProducts },on:{"click":_vm.openProducts}},[_vm._v(_vm._s(_vm.$t('gestiune.products')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isClients },on:{"click":_vm.openClients}},[_vm._v(_vm._s(_vm.$t('gestiune.clients')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-fill btn-primary",class:{ active: _vm.isSuppliers },on:{"click":_vm.openSuppliers}},[_vm._v(_vm._s(_vm.$t('gestiune.suppliers')))])])])])]),_vm._v(" "),(_vm.isProducts)?_c('div',[_c('NomenclatorProducts',{attrs:{"grouped-locations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isClients)?_c('div',[_c('ManagementClients',{attrs:{"grouped-locations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e(),_vm._v(" "),(_vm.isSuppliers)?_c('div',[_c('ManagementSuppliers',{attrs:{"grouped-locations":_vm.groupedLocations,"gestiuneOptions":_vm.gestiuneOptions}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xzfl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y0d6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"card mar-to-15",staticStyle:{"width":"100%","margin-left":"10px","margin-right":"10px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"text-right"},[_c('p',{},[_c('button',{staticClass:"btn add",attrs:{"title":_vm.$t('general.add') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.goToAdd($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/add.png"}}),_vm._v("\n              "+_vm._s(_vm.$t('general.add'))+"\n            ")])])]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"userList",staticStyle:{"width":"100%"},attrs:{"data":_vm.paymentGroups,"search-def":{},"pagination-def":{},"table-props":{'border': false}},on:{"row-click":_vm.goToRecord}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"width":150},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(_vm._s(_vm.$t('general.edit'))+"\n              ")])]}}])})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-info mar-to-15",on:{"click":function($event){$event.preventDefault();_vm.showBtPayments = !_vm.showBtPayments}}},[_vm._v(_vm._s(_vm.$t('btPayments.title')))]),_vm._v(" "),(_vm.showBtPayments)?_c('bt-payment-history',{key:_vm.$session.get('selectedCompany'),attrs:{"company-id":_vm.$session.get('selectedCompany')}}):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y0eN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Settings_TableZones_TableZonesForm_vue__ = __webpack_require__("YngB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Settings_TableZones_TableZones_vue__ = __webpack_require__("C47s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Settings_TableManagement_TableManagementForm_vue__ = __webpack_require__("kQ0V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Settings_TableManagement_TableManagement_vue__ = __webpack_require__("+suy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_KioskColorsCard_vue__ = __webpack_require__("4Ds/");











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TableZoneForm: __WEBPACK_IMPORTED_MODULE_1__Settings_TableZones_TableZonesForm_vue__["a" /* default */],
    TableZoneList: __WEBPACK_IMPORTED_MODULE_2__Settings_TableZones_TableZones_vue__["a" /* default */],
    TableManagementForm: __WEBPACK_IMPORTED_MODULE_3__Settings_TableManagement_TableManagementForm_vue__["a" /* default */],
    TableManagementList: __WEBPACK_IMPORTED_MODULE_4__Settings_TableManagement_TableManagement_vue__["a" /* default */],
    KioskColorsCard: __WEBPACK_IMPORTED_MODULE_5_src_components_UIComponents_KioskColorsCard_vue__["a" /* default */]
  },

  data: function data() {
    return {
      isTableZones: true,
      isTableManager: false,

      selectedZone: false,
      selectedTable: false,

      model: {},
      defaultData: {},
      websiteData: [],

      posUsers: []
    };
  },


  computed: {
    formattedUsers: function formattedUsers() {
      return this.posUsers.map(function (user) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user, {
          fullname: user.firstname + ' ' + user.lastname
        });
      });
    }
  },

  created: function created() {
    this.getModelData();
    this.getPosUsers();
  },


  methods: {
    handleTabChange: function handleTabChange(tabIndex, newTab) {
      this.isTableZones = false;
      this.isTableManager = false;

      this.$router.push(this.$route.path + '?tabIndex=' + tabIndex);

      switch (newTab.title) {
        case this.$t('settingsPages.tableZones'):
          this.isTableZones = true;
          break;

        case this.$t('settingsPages.qrModule'):
          this.isTableManager = true;
          break;

        default:
          this.isTableZones = true;
          break;
      }
    },
    getPosUsers: function getPosUsers() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      this.apiRequest('/pos/all/users', 'GET', data, function (response) {
        if (response.status) {
          _this.posUsers = response.data.pos_user;
        }
      });
    },
    getModelData: function getModelData() {
      var _this2 = this;

      var token = this.$session.get('token');
      var companyID = this.$session.get('selectedCompany');

      this.apiRequest('/settings/general/' + companyID, 'GET', { token: token }, function (response2) {
        if (response2.status === true) {
          _this2.model = response2.data[0];

          _this2.model.selected_languages = response2.data[0].languages.map(function (lang) {
            return {
              value: lang.id,
              label: lang.name
            };
          });
        }
      });

      this.apiRequest('/settings/website', 'GET', {
        token: token,
        company_id: companyID
      }, function (response) {
        if (response.status === true) {
          _this2.websiteData = response.data;
        }
      });
    },
    onUserSubmit: function onUserSubmit(model, isValid) {},
    tableManagementUpdate: function tableManagementUpdate() {
      this.selectedTable = false;

      if (this.$refs.tableManagement) {
        this.$refs.tableManagement.getData();
      }
    },
    tableZoneUpdate: function tableZoneUpdate() {
      this.selectedZone = false;

      if (this.$refs.tableZone) {
        this.$refs.tableZone.getData();
      }
    },
    getTable: function getTable(id) {
      this.selectedTable = id;
    },
    getZone: function getZone(id) {
      this.selectedZone = id;
    }
  }
});

/***/ }),

/***/ "y1da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 253.4 275.3"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 253.4 275.3","xml:space":"preserve"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_1_","x":"24.3","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_2_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_1_"}})]),_vm._v(" "),_c('g',{staticClass:"st0"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r2_3_","d":"M24.3,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H33.3c-2.4,0-4.7-0.9-6.4-2.6S24.3,187.7,24.3,185.3z\n            "}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_4_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_3_"}})]),_vm._v(" "),_c('g',{staticClass:"st1"},[_c('path',{staticClass:"st2",attrs:{"d":"M24.3,194.3V80.9h113.4v113.4H24.3z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_5_","x":"125.7","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_6_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_5_"}})]),_vm._v(" "),_c('g',{staticClass:"st3"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r2_7_","d":"M125.7,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4s-4,2.6-6.4,2.6h-95.4c-2.4,0-4.7-0.9-6.4-2.6S125.7,187.7,125.7,185.3z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_8_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_7_"}})]),_vm._v(" "),_c('g',{staticClass:"st4"},[_c('path',{staticClass:"st2",attrs:{"d":"M125.7,194.3V80.9h113.4v113.4H125.7z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_9_","x":"74.3","y":"80.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_10_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_9_"}})]),_vm._v(" "),_c('g',{staticClass:"st5"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r2_11_","d":"M74.3,185.3V89.9c0-2.4,0.9-4.7,2.6-6.4c1.7-1.7,4-2.6,6.4-2.6h95.4c2.4,0,4.7,0.9,6.4,2.6\n            c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-0.9,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H83.3c-2.4,0-4.7-0.9-6.4-2.6S74.3,187.7,74.3,185.3z\n            "}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_12_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_11_"}})]),_vm._v(" "),_c('g',{staticClass:"st6"},[_c('path',{staticClass:"st2",attrs:{"d":"M74.3,194.3V80.9h113.4v113.4H74.3z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_13_","x":"70","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_14_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_13_"}})]),_vm._v(" "),_c('g',{staticClass:"st7"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r2_15_","d":"M79,0h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6H79\n            c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4C74.4,0.9,76.6,0,79,0z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_16_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_15_"}})]),_vm._v(" "),_c('g',{staticClass:"st8"},[_c('path',{staticClass:"st2",attrs:{"d":"M70,0h113.4v113.4H70V0z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_17_","x":"70","y":"161.9","width":"113.4","height":"113.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_18_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_17_"}})]),_vm._v(" "),_c('g',{staticClass:"st9"},[_c('g',[_c('defs',[_c('path',{attrs:{"id":"r2_19_","d":"M79,161.9h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6\n            H79c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4S76.6,161.9,79,161.9z"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_20_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_19_"}})]),_vm._v(" "),_c('g',{staticClass:"st10"},[_c('path',{staticClass:"st2",attrs:{"d":"M70,161.9h113.4v113.4H70V161.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_21_","y":"10.9","width":"253.4","height":"253.4"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_22_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_21_"}})]),_vm._v(" "),_c('g',{staticClass:"st11"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"r2_23_","cx":"126.7","cy":"137.6","r":"126.7"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_24_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_23_"}})]),_vm._v(" "),_c('g',{staticClass:"st12"},[_c('path',{staticClass:"st13",attrs:{"d":"M0,10.9h253.4v253.4H0V10.9z"}})])])])]),_vm._v(" "),_c('g',[_c('defs',[_c('rect',{attrs:{"id":"r2_25_","x":"51.8","y":"62.7","width":"149.8","height":"149.8"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_26_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_25_"}})]),_vm._v(" "),_c('g',{staticClass:"st14"},[_c('g',[_c('defs',[_c('circle',{attrs:{"id":"r2_27_","cx":"126.7","cy":"137.6","r":"74.9"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"r2_28_"}},[_c('use',{staticStyle:{"overflow":"visible"},attrs:{"xlink:href":"#r2_27_"}})]),_vm._v(" "),_c('g',{staticClass:"st15"},[_c('path',{staticClass:"st2",attrs:{"d":"M51.8,62.7h149.8v149.8H51.8V62.7z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y5df":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosUserForm_vue__ = __webpack_require__("Om5e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c70f5e3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosUserForm_vue__ = __webpack_require__("I3/p");
function injectStyle (ssrContext) {
  __webpack_require__("xV81")
  __webpack_require__("qhTQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c70f5e3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosUserForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c70f5e3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosUserForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y6XK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Management_ManagementSeriesAdd_vue__ = __webpack_require__("kgt7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);














function getLocalDateTimeString() {
  var now = new Date();
  var year = now.getFullYear();
  var month = String(now.getMonth() + 1).padStart(2, '0');
  var day = String(now.getDate()).padStart(2, '0');
  var hours = String(now.getHours()).padStart(2, '0');
  var minutes = String(now.getMinutes()).padStart(2, '0');
  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_Switch_vue__["a" /* default */],
    ManagementSeriesAdd: __WEBPACK_IMPORTED_MODULE_9__Management_ManagementSeriesAdd_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      selectedLocation: null,
      selectedLocationId: '',
      selectedToLocationId: '',
      locations: [],
      gestiuneOptions: [],
      avizOptions: [],
      nirOptions: [],
      bon_transferOptions: [],
      searchResults: [],
      selectedAviz: null,
      selectedNir: null,
      selectedSeries: null,
      currencyOptions: [{ code: 'RON', name: 'Leu Românesc (RON)' }, { code: 'EUR', name: 'Euro (EUR)' }, { code: 'USD', name: 'Dolar American (USD)' }],
      bonTransfer: {
        date: getLocalDateTimeString(),
        fromGestiune: null,
        toGestiune: null,
        serie: null,
        currency: 'RON',
        manager: '',
        receiver: '',
        internalNote: '',
        commandProject: ''
      },
      tableData: [],
      item: {
        productObject: null,
        um: '',
        cantitate: null
      },
      editIndex: null,
      isEdit: !!this.route.params.series && !!this.route.params.number,
      fetchTimeout: null,
      genereazaAvizNIR: false,
      avizGestiuneaPredatoare: '',
      dataAviz: '',
      nirGestiuneaPrimitoare: '',
      dataNIR: '',
      mesurementsUnits: []
    };
  },

  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    today: function today() {
      var now = new Date();
      now.setSeconds(0, 0);
      return now.toISOString().slice(0, 16);
    },
    seriesOptionsWithAdd: function seriesOptionsWithAdd() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(this.bon_transferOptions), [{ value: 'add', label: '➕ Adaugă serie' }]);
    },
    groupedLocations: function groupedLocations() {
      var groups = {};

      if (!this.locations || !this.locations.length) return [];

      this.locations.forEach(function (location) {
        var vat = location.inv_fiscal_code || 'Fără cod fiscal';
        if (!groups[vat]) {
          groups[vat] = [];
        }
        groups[vat].push(location);
      });

      var result = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(groups).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            vat = _ref2[0],
            locations = _ref2[1];

        return {
          vat: vat,
          locations: locations
        };
      });

      return result;
    },
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocationId) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocationId;
      });
      return result;
    },
    filteredToGestiuni: function filteredToGestiuni() {
      var _this2 = this;

      if (!this.selectedToLocationId) return [];
      return this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this2.selectedToLocationId;
      }).map(function (g) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, g, {
          disabled: _this2.selectedToLocationId === _this2.selectedLocationId && g.id === _this2.bonTransfer.fromGestiune
        });
      });
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');

    this.fetchGestiuni();
    this.fetchLocation();
  },

  watch: {
    selectedLocationId: function selectedLocationId(id) {
      if (!this.isEdit) {
        this.bonTransfer.fromGestiune = null;
        this.bonTransfer.toGestiune = null;
        this.bonTransfer.serie = null;
        this.selectedToLocationId = '';
        this.series = null;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedLocation = loc;
            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code);
            }
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    selectedToLocationId: function selectedToLocationId(id) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.groupedLocations), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var group = _step2.value;

          var loc = group.locations.find(function (l) {
            return l.true_id === id;
          });
          if (loc) {
            this.selectedToLocation = loc;
            break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    locations: function locations(newLocations) {
      if (newLocations && newLocations.length) {
        var s = this.route && this.route.params && this.route.params.series;
        var inv = this.route && this.route.params && this.route.params.number;
        if (s && inv) {
          this.fetchBonTransfer(s, inv);
        }
      }
    }
  },
  methods: {
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.saveBonTransfer();
        }
      });
    },
    getEmptyItem: function getEmptyItem() {
      return {
        productObject: null,
        um: 'buc',
        cantitate: null,
        editIndex: null
      };
    },
    handleSerieChange: function handleSerieChange(event) {
      var val = event.target.value;
      if (val === 'add') {
        this.openSeriesModal();
        this.bonCasare.serie = null;
      }
    },
    openSeriesModal: function openSeriesModal() {
      this.$modal.show('addSeriesModal');
    },
    fetchLocation: function fetchLocation() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var dataToSend;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataToSend = {
                  company_id: _this4.companyID,
                  token: _this4.$session.get('token')
                };


                _this4.apiRequest('/gestiune/locations', 'GET', dataToSend, function (response) {
                  if (!response || response.status !== true || !response.data || !response.data.locations) {
                    __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                      title: 'Eroare!',
                      text: response.message || 'Eroare la preluarea locațiilor.',
                      type: 'error',
                      timer: 3000,
                      showConfirmButton: false
                    });
                    return;
                  }

                  _this4.locations = response.data.locations;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    fetchBonTransfer: function fetchBonTransfer(seriesParam, invoiceNumberParam) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                return _context3.delegateYield(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                  var response, data, bon, extra, getField, gestiuneFromObj, gestiuneToObj, foundLocation, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, group, foundToLocation, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _group;

                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getDocument?tip=bon_transfer&series=' + seriesParam + '&number=' + invoiceNumberParam + '&externalCompanyId=' + _this5.companyID);

                        case 2:
                          response = _context2.sent;

                          if (response.ok) {
                            _context2.next = 5;
                            break;
                          }

                          throw new Error('Failed to fetch bon de transfer');

                        case 5:
                          _context2.next = 7;
                          return response.json();

                        case 7:
                          data = _context2.sent;

                          if (!(!data || !Array.isArray(data.documents) || !data.documents.length)) {
                            _context2.next = 10;
                            break;
                          }

                          throw new Error('Bon de transfer inexistent');

                        case 10:
                          bon = data.documents[0];
                          extra = bon.extraFields || [];

                          getField = function getField(key) {
                            var field = extra.find(function (f) {
                              return f.key === key;
                            });
                            return field ? field.value : '';
                          };

                          gestiuneFromObj = _this5.gestiuneOptions.find(function (g) {
                            return g.name === bon.gestiune_from;
                          });
                          gestiuneToObj = _this5.gestiuneOptions.find(function (g) {
                            return g.name === bon.gestiune_to;
                          });


                          _this5.bonTransfer = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this5.bonTransfer, {
                            fromGestiune: gestiuneFromObj ? gestiuneFromObj.id : bon.gestiune_from,
                            toGestiune: gestiuneToObj ? gestiuneToObj.id : bon.gestiune_to,
                            serie: bon.series,
                            date: bon.date,
                            documentNumber: bon.documentNumber,
                            manager: getField('manager'),
                            receiver: getField('receiver'),
                            internalNote: getField('internalNote'),
                            commandProject: getField('commandProject')
                          });

                          _this5.consumptionType = bon.type;

                          _this5.tableData = (bon.items || []).map(function (item) {
                            return {
                              productName: item.name,
                              cantitate: item.quantity,
                              um: item.um,
                              posId: item.posId
                            };
                          });

                          if (!(bon.externalLocationId && _this5.locations && _this5.locations.length)) {
                            _context2.next = 48;
                            break;
                          }

                          foundLocation = null;
                          _iteratorNormalCompletion3 = true;
                          _didIteratorError3 = false;
                          _iteratorError3 = undefined;
                          _context2.prev = 23;
                          _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this5.groupedLocations);

                        case 25:
                          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                            _context2.next = 33;
                            break;
                          }

                          group = _step3.value;

                          foundLocation = group.locations.find(function (loc) {
                            return bon.externalLocationId && loc.true_id === bon.externalLocationId || bon.vatNumber && loc.inv_fiscal_code === bon.vatNumber;
                          });

                          if (!foundLocation) {
                            _context2.next = 30;
                            break;
                          }

                          return _context2.abrupt('break', 33);

                        case 30:
                          _iteratorNormalCompletion3 = true;
                          _context2.next = 25;
                          break;

                        case 33:
                          _context2.next = 39;
                          break;

                        case 35:
                          _context2.prev = 35;
                          _context2.t0 = _context2['catch'](23);
                          _didIteratorError3 = true;
                          _iteratorError3 = _context2.t0;

                        case 39:
                          _context2.prev = 39;
                          _context2.prev = 40;

                          if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                          }

                        case 42:
                          _context2.prev = 42;

                          if (!_didIteratorError3) {
                            _context2.next = 45;
                            break;
                          }

                          throw _iteratorError3;

                        case 45:
                          return _context2.finish(42);

                        case 46:
                          return _context2.finish(39);

                        case 47:
                          if (foundLocation) {
                            _this5.selectedLocationId = foundLocation.true_id;
                          }

                        case 48:
                          if (!(bon.externalLocationIdTo && _this5.locations && _this5.locations.length)) {
                            _context2.next = 78;
                            break;
                          }

                          foundToLocation = null;
                          _iteratorNormalCompletion4 = true;
                          _didIteratorError4 = false;
                          _iteratorError4 = undefined;
                          _context2.prev = 53;
                          _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this5.groupedLocations);

                        case 55:
                          if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                            _context2.next = 63;
                            break;
                          }

                          _group = _step4.value;

                          foundToLocation = _group.locations.find(function (loc) {
                            return loc.true_id === bon.externalLocationIdTo || loc.inv_fiscal_code === bon.vatNumberTo;
                          });

                          if (!foundToLocation) {
                            _context2.next = 60;
                            break;
                          }

                          return _context2.abrupt('break', 63);

                        case 60:
                          _iteratorNormalCompletion4 = true;
                          _context2.next = 55;
                          break;

                        case 63:
                          _context2.next = 69;
                          break;

                        case 65:
                          _context2.prev = 65;
                          _context2.t1 = _context2['catch'](53);
                          _didIteratorError4 = true;
                          _iteratorError4 = _context2.t1;

                        case 69:
                          _context2.prev = 69;
                          _context2.prev = 70;

                          if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                          }

                        case 72:
                          _context2.prev = 72;

                          if (!_didIteratorError4) {
                            _context2.next = 75;
                            break;
                          }

                          throw _iteratorError4;

                        case 75:
                          return _context2.finish(72);

                        case 76:
                          return _context2.finish(69);

                        case 77:
                          if (foundToLocation) {
                            _this5.selectedToLocationId = foundToLocation.true_id;
                          }

                        case 78:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this5, [[23, 35, 39, 47], [40,, 42, 46], [53, 65, 69, 77], [70,, 72, 76]]);
                })(), 't0', 2);

              case 2:
                _context3.next = 7;
                break;

              case 4:
                _context3.prev = 4;
                _context3.t1 = _context3['catch'](0);

                console.error('Error fetching bon de transfer:', _context3.t1);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 4]]);
      }))();
    },
    saveProduct: function saveProduct() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var product, productId, isValid, newItem;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!_this6.item.productObject || !_this6.item.cantitate)) {
                  _context4.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Te rugăm să completezi toate câmpurile necesare!',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context4.abrupt('return');

              case 3:
                product = _this6.item.productObject;
                productId = product.product_id || _this6.item.productObject.posId;
                _context4.next = 7;
                return _this6.checkValidatedAfter(_this6.bonTransfer.date, [productId]);

              case 7:
                isValid = _context4.sent;

                if (isValid) {
                  _context4.next = 10;
                  break;
                }

                return _context4.abrupt('return');

              case 10:
                newItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this6.item, {
                  productName: product && product.productDetails && product.productDetails.name ? product.productDetails.name : product.label || product.name,
                  posId: product && (product.product_id || product.posId)
                });


                console.log('New item added:', newItem);

                if (_this6.editIndex !== null && _this6.editIndex !== undefined) {
                  _this6.$set(_this6.tableData, _this6.editIndex, newItem);
                } else {
                  _this6.tableData.push(newItem);
                }

                _this6.resetModal();
                _this6.$modal.hide('addProductModal');

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    deleteRow: function deleteRow(row) {
      var index = this.tableData.indexOf(row);

      if (index !== -1) {
        this.tableData.splice(index, 1);
      }
    },
    isDisabledToLocation: function isDisabledToLocation(loc) {
      if (!this.selectedLocation) return false;
      return loc.inv_fiscal_code !== this.selectedLocation.inv_fiscal_code;
    },
    checkValidatedAfter: function checkValidatedAfter(date) {
      var _this7 = this;

      var products = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var queryParams, body, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                if (date) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt('return', false);

              case 3:

                if (!products) {
                  if (!_this7.tableData || _this7.tableData.length === 0) {
                    products = [];
                  } else {
                    products = _this7.tableData.map(function (item) {
                      return item.posId;
                    });
                  }
                }

                queryParams = new URLSearchParams({
                  date: new Date(date).toISOString(),
                  externalCompanyId: _this7.companyID,
                  externalLocationId: _this7.selectedLocationId
                });
                body = products.length > 0 ? { products: products } : null;
                _context5.next = 8;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/inventar/validated-after-products?' + queryParams.toString(), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: body ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body) : null
                });

              case 8:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 11;
                  break;
                }

                throw new Error('Request failed: ' + response.status);

              case 11:
                _context5.next = 13;
                return response.json();

              case 13:
                data = _context5.sent;

                console.log('Response from validated-after:', data);

                if (!data.exists) {
                  _context5.next = 19;
                  break;
                }

                _context5.next = 18;
                return __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  icon: 'warning',
                  title: 'Atenție!',
                  text: 'Există deja un inventar validat după această dată pentru unul sau mai multe produse selectate.'
                });

              case 18:
                return _context5.abrupt('return', false);

              case 19:
                return _context5.abrupt('return', true);

              case 22:
                _context5.prev = 22;
                _context5.t0 = _context5['catch'](0);

                console.error(_context5.t0);
                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  icon: 'error',
                  title: 'Eroare!',
                  text: 'Nu s-a putut verifica inventarul.'
                });
                return _context5.abrupt('return', false);

              case 27:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 22]]);
      }))();
    },
    editRow: function editRow(row) {
      var index = this.tableData.indexOf(row);
      if (index === -1) return;

      this.editIndex = index;

      var productObject = {
        posId: row.posId,
        productDetails: {
          name: row.productName,
          posId: row.posId,
          um: row.um
        },
        label: row.productName
      };

      var productOption = {
        label: row.productName,
        value: productObject
      };

      this.searchResults = [productOption];

      this.item = {
        productObject: productObject,
        um: row.um,
        cantitate: row.cantitate,
        posId: row.posId || null
      };

      this.$modal.show('addProductModal');
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                clearTimeout(_this8.fetchTimeout);

                _this8.fetchTimeout = setTimeout(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
                  var url, response, data;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _this8.searchResults = [];

                          if (!(!searchTerm || searchTerm.length < 2)) {
                            _context6.next = 3;
                            break;
                          }

                          return _context6.abrupt('return');

                        case 3:
                          if (_this8.bonTransfer.fromGestiune) {
                            _context6.next = 6;
                            break;
                          }

                          __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                            title: 'Atenție',
                            text: 'Selectează gestiunea sursă înainte de a căuta un produs.',
                            type: 'warning',
                            confirmButtonText: 'OK'
                          });
                          return _context6.abrupt('return');

                        case 6:
                          if (!(!_this8.selectedLocation || !_this8.companyID)) {
                            _context6.next = 8;
                            break;
                          }

                          return _context6.abrupt('return');

                        case 8:
                          url = "https://fiscal-dev.cdntaptasty.com" + ':4443/products?externalCompanyId=' + _this8.companyID;


                          url += '&gestiune=' + _this8.bonTransfer.fromGestiune;
                          url += '&externalLocationId=' + _this8.selectedLocation.true_id;
                          url += '&name=' + encodeURIComponent(searchTerm);

                          _this8.loading = true;
                          _context6.prev = 13;
                          _context6.next = 16;
                          return fetch(url);

                        case 16:
                          response = _context6.sent;
                          _context6.next = 19;
                          return response.json();

                        case 19:
                          data = _context6.sent;


                          if (Array.isArray(data.products)) {
                            _this8.searchResults = data.products.map(function (item) {
                              return {
                                label: item.name,
                                posId: item._id,
                                value: item
                              };
                            });
                            console.log(_this8.searchResults);
                          } else {
                            _this8.searchResults = [];
                            console.error('Invalid data format:', data);
                          }
                          _context6.next = 26;
                          break;

                        case 23:
                          _context6.prev = 23;
                          _context6.t0 = _context6['catch'](13);

                          console.error('Error fetching stock:', _context6.t0);

                        case 26:
                          _context6.prev = 26;

                          _this8.loading = false;
                          return _context6.finish(26);

                        case 29:
                        case 'end':
                          return _context6.stop();
                      }
                    }
                  }, _callee6, _this8, [[13, 23, 26, 29]]);
                })), 300);

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    fetchGestiuni: function fetchGestiuni() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/gestiuni?externalCompanyId=' + _this9.companyID);

              case 3:
                response = _context8.sent;

                if (response.ok) {
                  _context8.next = 6;
                  break;
                }

                throw new Error('Failed to fetch gestiuni');

              case 6:
                _context8.next = 8;
                return response.json();

              case 8:
                data = _context8.sent;

                console.log('Date primite de la server:', data.gestiuni);
                if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
                  _this9.gestiuneOptions = data.gestiuni.map(function (gest) {
                    return {
                      id: gest._id,
                      name: gest.name + ' (' + gest.cod_gestiune + ')',
                      externalLocationId: gest.externalLocationId || ''
                    };
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                    title: 'Error!',
                    text: 'Nu s-a primit un array valid de la server.',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }
                _context8.next = 17;
                break;

              case 13:
                _context8.prev = 13;
                _context8.t0 = _context8['catch'](0);

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Error!',
                  text: 'Request failed: ' + _context8.t0.message,
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                console.error('Error fetching management data:', _context8.t0);

              case 17:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9, [[0, 13]]);
      }))();
    },
    getSeries: function getSeries(vatNumber) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/getSeries', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    externalCompanyId: _this10.companyID,
                    vatNumber: vatNumber,
                    tip: 'bon_transfer'
                  })
                });

              case 3:
                response = _context9.sent;

                if (response.ok) {
                  _context9.next = 6;
                  break;
                }

                throw new Error('HTTP error! Status: ' + response.status);

              case 6:
                _context9.next = 8;
                return response.json();

              case 8:
                data = _context9.sent;

                console.log('Serii primite:', data.series);

                if (Array.isArray(data.series)) {
                  _this10.bon_transferOptions = data.series.map(function (serie) {
                    return {
                      value: serie._id,
                      label: serie.series + ' - ' + (serie.currentNumber || 'N/A'),
                      seriesName: serie.series,
                      currentNumber: serie.currentNumber
                    };
                  });
                } else {
                  console.error('Format invalid pentru series:', data);
                }
                _context9.next = 16;
                break;

              case 13:
                _context9.prev = 13;
                _context9.t0 = _context9['catch'](0);

                console.error('Error fetching series:', _context9.t0);

              case 16:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10, [[0, 13]]);
      }))();
    },
    saveBonTransfer: function saveBonTransfer() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var selectedSerie, serieName, serieOnly, bonTransferData, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (Array.isArray(_this11.bon_transferOptions)) {
                  _context10.next = 3;
                  break;
                }

                console.error('Bon Transfer options are not loaded or are not an array.');
                return _context10.abrupt('return');

              case 3:
                if (!(!_this11.tableData || _this11.tableData.length === 0)) {
                  _context10.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'Este necesar un produs minim de adăugat.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                });
                return _context10.abrupt('return');

              case 6:
                selectedSerie = _this11.bon_transferOptions.find(function (serie) {
                  return serie.value === _this11.bonTransfer.serie;
                });
                serieName = selectedSerie ? selectedSerie.label : _this11.bonTransfer.serie || '';
                serieOnly = serieName.split('-')[0].trim();

                if (Array.isArray(_this11.gestiuneOptions)) {
                  _context10.next = 12;
                  break;
                }

                console.error('Gestiune options are not loaded or are not an array.');
                return _context10.abrupt('return');

              case 12:
                bonTransferData = {
                  externalCompanyId: _this11.companyID,
                  externalLocationId: _this11.selectedLocation.true_id,
                  externalLocationIdTo: _this11.selectedToLocation.true_id,
                  vatNumber: _this11.selectedLocation.inv_fiscal_code,
                  series: serieOnly,
                  tip: 'bon_transfer',
                  gestiune_from: _this11.bonTransfer.fromGestiune,
                  gestiune_to: _this11.bonTransfer.toGestiune,
                  items: _this11.tableData.map(function (item) {
                    return {
                      posId: item.posId,
                      name: item.productName,
                      quantity: item.cantitate,
                      price: item.unitPrice,
                      um: item.um
                    };
                  }),
                  currency: _this11.bonTransfer.currency,
                  extraFields: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()({
                    manager: _this11.bonTransfer.manager,
                    receiver: _this11.bonTransfer.receiver,
                    commandProject: _this11.bonTransfer.commandProject,
                    internalNote: _this11.bonTransfer.internalNote
                  }).map(function (_ref4) {
                    var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
                        key = _ref5[0],
                        value = _ref5[1];

                    return { key: key, value: value };
                  })
                };


                if (_this11.bonTransfer.date) {
                  bonTransferData.date = _this11.bonTransfer.date;
                }
                if (_this11.bonTransfer.documentNumber) {
                  bonTransferData.documentNumber = _this11.bonTransfer.documentNumber;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Salvare în curs...',
                  text: 'Se salvează Bonul de Trasnfer. Așteaptă te rog.',
                  buttons: false,
                  closeOnClickOutside: false,
                  closeOnEsc: false,
                  type: 'info'
                });

                _context10.prev = 16;
                _context10.next = 19;
                return fetch("https://fiscal-dev.cdntaptasty.com" + ':4443/bon', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bonTransferData)
                });

              case 19:
                response = _context10.sent;
                _context10.next = 22;
                return response.json();

              case 22:
                data = _context10.sent;


                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.close();

                if (response.ok) {
                  console.log('Bon transfer salvat cu succes!', data);

                  __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                    title: 'Succes',
                    text: 'Bonul de transfer a fost salvat cu succes!',
                    type: 'success',
                    timer: 1500,
                    showConfirmButton: false
                  });

                  _this11.$bus.$emit('refresh');
                  _this11.$bus.$emit('close-modal');
                } else {
                  console.error('Eroare la salvarea bonului de transfer', data);

                  __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                    title: 'Eroare',
                    text: data && data.error ? data.error : 'A apărut o eroare la salvarea bonului de transfer.',
                    type: 'error',
                    confirmButtonText: 'OK'
                  });
                }
                _context10.next = 32;
                break;

              case 27:
                _context10.prev = 27;
                _context10.t0 = _context10['catch'](16);

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.close();
                console.error('Eroare la trimiterea cererii', _context10.t0);

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Eroare',
                  text: 'A apărut o problemă la trimiterea cererii.',
                  type: 'error',
                  timer: 1500,
                  showConfirmButton: false
                });

              case 32:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11, [[16, 27]]);
      }))();
    },
    fetchStockForProducts: function fetchStockForProducts(productIDs, companyID, gestiune, locationID) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var params, url, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(!productIDs || productIDs.length === 0)) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt('return', []);

              case 2:
                params = new URLSearchParams();

                productIDs.forEach(function (id) {
                  return params.append('product_ids', id);
                });

                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/stock?externalCompanyId=' + companyID + ('&gestiune=' + gestiune) + ('&externalLocationId=' + locationID + '&' + params.toString());


                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  type: 'info',
                  title: 'Loading Stock...',
                  text: 'Please wait while we fetch stock data...',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  showConfirmButton: false
                });

                _context11.prev = 6;
                _context11.next = 9;
                return fetch(url);

              case 9:
                response = _context11.sent;
                _context11.next = 12;
                return response.json();

              case 12:
                data = _context11.sent;

                if (!Array.isArray(data.stock)) {
                  _context11.next = 17;
                  break;
                }

                return _context11.abrupt('return', data.stock);

              case 17:
                console.error('Invalid data format:', data);
                return _context11.abrupt('return', []);

              case 19:
                _context11.next = 25;
                break;

              case 21:
                _context11.prev = 21;
                _context11.t0 = _context11['catch'](6);

                console.error('Error fetching stock:', _context11.t0);
                return _context11.abrupt('return', []);

              case 25:
                _context11.prev = 25;

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.close();
                return _context11.finish(25);

              case 28:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this12, [[6, 21, 25, 28]]);
      }))();
    },
    handleProductSelect: function handleProductSelect(selectedProduct) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var stockData, quantity;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return _this13.fetchStockForProducts([selectedProduct.posId || selectedProduct.value._id], _this13.companyID, _this13.bonTransfer.fromGestiune, _this13.selectedLocation.true_id);

              case 2:
                stockData = _context12.sent;

                if (!(!stockData || stockData.length === 0)) {
                  _context12.next = 8;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Stoc indisponibil',
                  text: 'Produsul selectat nu mai are stoc!',
                  icon: 'error',
                  timer: 2500,
                  buttons: false
                });
                _this13.productNameRecipe = null;
                _this13.resetModal();
                return _context12.abrupt('return');

              case 8:
                if (!stockData[0]) {
                  _context12.next = 18;
                  break;
                }

                quantity = stockData[0].quantity;

                if (!(quantity <= 0)) {
                  _context12.next = 15;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default()({
                  title: 'Stoc indisponibil',
                  text: 'Produsul selectat nu mai are stoc!',
                  icon: 'error',
                  timer: 2500,
                  buttons: false
                });

                _this13.productNameRecipe = null;
                _this13.resetModal();
                return _context12.abrupt('return');

              case 15:

                _this13.item.stockQuantity = quantity;

                console.log('STOC', stockData[0]);

                if (stockData[0].productDetails && stockData[0].productDetails.um) {
                  _this13.item.um = stockData[0].productDetails.um;
                }

              case 18:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this13);
      }))();
    },
    validateQty: function validateQty() {
      var max = this.item.stockQuantity;

      if (max === undefined || max === null) return;

      if (!this.item.cantitate) return;

      var val = Number(this.item.cantitate);

      if (val > max) val = max;
      if (val < 0) val = 0;

      this.item.cantitate = val;
    },
    openAddProductModal: function openAddProductModal() {
      this.$modal.show('addProductModal');
    },
    goBack: function goBack() {
      this.$bus.$emit('refresh');
      this.$bus.$emit('close-modal');
    },
    closeModal: function closeModal() {
      this.resetModal();
      this.$modal.hide('addProductModal');
    },
    resetModal: function resetModal() {
      this.item = this.getEmptyItem();
      this.editIndex = null;
    }
  }
});

/***/ }),

/***/ "y6bk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationMenuTopCategoriesField_vue__ = __webpack_require__("bLSn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b8f1eeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationMenuTopCategoriesField_vue__ = __webpack_require__("RUDG");
function injectStyle (ssrContext) {
  __webpack_require__("/zre")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b8f1eeb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntegrationMenuTopCategoriesField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b8f1eeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntegrationMenuTopCategoriesField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y8lU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yCh9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KdsUserForm_vue__ = __webpack_require__("7FDv");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    KdsUserForm: __WEBPACK_IMPORTED_MODULE_0__KdsUserForm_vue__["a" /* default */]
  },
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orderPosModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.orderPosModel = model;
    }
  }
});

/***/ }),

/***/ "yGpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfRaport_vue__ = __webpack_require__("9pV9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3464c15d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfRaport_vue__ = __webpack_require__("aEZk");
function injectStyle (ssrContext) {
  __webpack_require__("bq+c")
  __webpack_require__("OXAs")
  __webpack_require__("aBe/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3464c15d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfRaport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3464c15d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfRaport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yI4Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CatalogSidebar_vue__ = __webpack_require__("JboP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e1826e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CatalogSidebar_vue__ = __webpack_require__("in8J");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CatalogSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e1826e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CatalogSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yIa/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsAndOptionsReport_vue__ = __webpack_require__("lKSC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16274fff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsAndOptionsReport_vue__ = __webpack_require__("ly2u");
function injectStyle (ssrContext) {
  __webpack_require__("RucB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsAndOptionsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16274fff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsAndOptionsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yJ4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_generalTopBar_vue__ = __webpack_require__("ZSHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_LineChart_vue__ = __webpack_require__("w3Bt");







var _components;








/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {
    GeneralTopBar: __WEBPACK_IMPORTED_MODULE_9_src_components_UIComponents_Inputs_generalTopBar_vue__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'LineChart', __WEBPACK_IMPORTED_MODULE_10_src_components_UIComponents_Cards_LineChart_vue__["a" /* default */]), _components),
  props: {
    isSalesTrend: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isSalesTrend: function isSalesTrend() {
      if (this.isSalesTrend) {
        this.getOrders();
        this.verifyUserLocations();
        this.verifyUserMethods();
      }
    }
  },
  data: function data() {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      productsTableData: [],
      productsTableDataTotals: {},
      paymentMethods: [],
      receiptOptions: [{ label: this.$t('reports.withoutReceipt'), value: 1 }, { label: this.$t('reports.withReceipt'), value: 2 }],
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_method: '',
      loading: true,
      loadingProducts: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [__WEBPACK_IMPORTED_MODULE_7_moment___default()().date(1).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-MM-DD')],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      json_meta: [[{
        'key': 'charset',
        'value': 'utf-8'
      }]],
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_7_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      ordersTableData: {},
      totals: {
        total: 0,
        totalCash: 0,
        totalVirament: 0,
        totalOnline: 0,
        totalProtocol: 0,
        totalCard: 0,
        totalPOS: 0,
        totalCARDPOS: 0,
        totalTips: 0,
        totalDiscount: 0,
        totalTax: 0,
        totalShipping: 0,
        avarageOrderValue: 0
      },
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '550px',
          width: '550px'
        }
      },
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Vânzari',
              fontColor: 'red',
              fontSize: 22
            },
            ticks: { beginAtZero: true }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Data',
              fontColor: 'red',
              fontSize: 22
            }
          }]
        }
      },

      use_tips: true,
      hasRceipt: null,
      noData: false,
      selectedProducts: [],
      availableProducts: [],
      allProductsMap: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a()
    };
  },

  methods: {
    searchProducts: function searchProducts(query) {
      var _this = this;

      if (!query) {
        return;
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loadingProducts = true;

      this.apiRequest('/search-order-products', 'GET', data, function (response) {
        if (response.status) {
          response.data.forEach(function (item) {
            _this.allProductsMap.set(item.id, item);
          });

          _this.availableProducts = response.data;
        } else {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this.$t('validations.wentWrong'), 'error');
        }

        _this.$nextTick(function () {
          _this.loadingProducts = false;
        });
      });
    },
    clearSearch: function clearSearch() {
      this.$refs.productSelect.focus();
      var select = this.$refs.productSelect;

      if (select) {
        select.query = '';
        select.handleQueryChange('');
      }
    },
    getPaymentMethods: function getPaymentMethods() {
      var _this2 = this;

      var sessionData = this.$session.get('selectedCompanyData');

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        };

        this.apiRequest('/orders/get-payment-methods', 'GET', data, function (response) {
          if (response.status && response.data.length) {
            var result = response.data.map(function (item) {
              return { id: item || 'unpaid', name: _this2.$t('paymentTypes.' + item) };
            });
            sessionData['payment_methods'] = response.data;
            _this2.$session.set('selectedCompanyData', sessionData);

            __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(_this2, 'paymentMethods', result);
          }
        });
      } else {
        var result = sessionData['payment_methods'].map(function (item) {
          return { id: item || 'unpaid', name: _this2.$t('paymentTypes.' + item) };
        });
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(this, 'paymentMethods', result);
      }
    },
    summaryTotal: function summaryTotal() {
      var result = {
        revenue: 0,
        quantity: 0,
        discount: 0,
        vat: 0
      };

      this.productsTableData.forEach(function (item) {
        result.revenue += Number(item.total_revenue || 0);
        result.quantity += Number(item.quantity_sold || 0);
        result.discount += Number(item.discount || 0);
        result.vat += Number(item.vat || 0);
      });

      return result;
    },
    startDownload: function startDownload() {
      this.loading = true;
    },
    finishDownload: function finishDownload() {
      this.loading = false;
    },
    changeValidFrom: function changeValidFrom() {
      if (!this.valid_from) {
        this.valid_from = '00:00';
      }
      if (!this.valid_to) {
        this.valid_to = '23:59';
      }
    },
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getOrders(query);
      if (query.type === 'size') this.getOrders(query);
      if (query.type === 'sort') this.getOrders(query);
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(function (location) {
        return {
          id: location.true_id,
          name: location.name
        };
      });

      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));

        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }

      if (this.locations.length > 1) {
        this.showLocations = true;
      }

      var filterCookie = this.$cookie.get('filter-locations');
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie);
        this.orders.location = filterCookie[0];
      }
    },
    verifyUserMethods: function verifyUserMethods() {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels;
      this.showMethods = true;
    },
    getOrders: function getOrders(query) {
      var _this3 = this;

      if (!this.isSalesTrend) {
        return;
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59';
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59';
      }
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: this.orders.valid[0],
        to_date: this.orders.valid[1]
      };
      if (this.selectedProducts && this.selectedProducts.length) {
        data.product_ids = this.selectedProducts.map(function (table) {
          return table.id;
        });
      }
      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }
      this.loading = true;

      this.apiRequest('/reports/v2/sales-trends', 'GET', data, function (response) {
        if (response.status) {
          if (response.data.table_data.length) {
            _this3.ordersTableData.data = response.data.table_data;
            _this3.ordersTableData.total = response.data.table_data.length;
            _this3.paginationProps.currentPage = 1;
            _this3.paginationProps.pageSize = 20;
          } else {
            _this3.ordersTableData.data = [];
            _this3.ordersTableData.total = 0;
            _this3.paginationProps.pageSize = 20;
          }

          _this3.$nextTick(function () {
            _this3.chartData = {
              labels: response.data.labels,
              datasets: response.data.datasets
            };
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', response.errors && response.errors['id'] ? response.errors['id'] : _this3.$t('validations.wentWrong'), 'error');
        }

        _this3.$nextTick(function () {
          _this3.loading = false;
        });
      });
    },
    updateData: function updateData() {
      this.getOrders();
      this.$cookie.set('filter-locations', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.orders.location]), 30);
    },
    exportData: function exportData() {
      var _this4 = this;

      var fromDate = this.orders.valid[0];
      var toDate = this.orders.valid[1];

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      };

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location;
      }

      this.loading = true;
      this.apiRequest('/reports/v2/sales-trends-download', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error');
        }
        _this4.loading = false;
      });
    },
    getSalePeriod: function getSalePeriod(saleWeek) {
      var year = parseInt(saleWeek.toString().slice(0, 4));
      var week = parseInt(saleWeek.toString().slice(4));

      var firstDayOfYear = new Date(Date.UTC(year, 0, 1));
      var dayOfWeek = firstDayOfYear.getUTCDay();
      var dayOffset = dayOfWeek <= 4 ? dayOfWeek - 1 : dayOfWeek - 8;
      var firstMonday = new Date(firstDayOfYear);
      firstMonday.setUTCDate(firstDayOfYear.getUTCDate() - dayOffset);

      var weekStart = new Date(firstMonday);
      weekStart.setUTCDate(firstMonday.getUTCDate() + (week - 1) * 7);

      var weekEnd = new Date(weekStart);
      weekEnd.setUTCDate(weekStart.getUTCDate() + 6);

      var formatDate = function formatDate(d) {
        return d.toISOString().slice(0, 10);
      };

      return formatDate(weekStart) + ' - ' + formatDate(weekEnd);
    }
  }
});

/***/ }),

/***/ "yJ5Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yJS/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yKwh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"category-top-bar"},[_c('div',{staticClass:"top-bar"},[_c('p',[_c('a',{staticClass:"btn btn-orange btn-icon back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n            "+_vm._s(_vm.$t('general.back'))+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"middle",staticStyle:{"height":"100%","max-width":"300px","margin":"auto","text-align":"center"}},[(_vm.qr_code)?_c('img',{attrs:{"src":_vm.qr_code,"alt":"qrCodeGroup"}}):_vm._e(),_vm._v(" "),(_vm.qr_code)?_c('br'):_vm._e(),_vm._v(" "),(_vm.qr_code)?_c('br'):_vm._e(),_vm._v(" "),(_vm.qr_code)?_c('a',{staticClass:"btn btn-info btn-primary",staticStyle:{"width":"100%"},attrs:{"href":this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + _vm.qr_code + '&name=' + _vm.group_name + ' ' + '.png',"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('upload.download')))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"btn btn-info btn-primary",staticStyle:{"width":"100%"},on:{"click":function($event){_vm.regenerateQr()}}},[_vm._v(_vm._s(_vm.$t('general.regenerateQr')))])])])]),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-left search-filter",staticStyle:{"display":"flex","align-items":"center","gap":"10px","margin-bottom":"15px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",staticStyle:{"width":"300px"},attrs:{"type":"text","placeholder":_vm.$t('customers.searchPlaceholder')},domProps:{"value":(_vm.searchQuery)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSearch($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-info",attrs:{"title":_vm.$t('general.search')},on:{"click":_vm.handleSearch}},[_c('i',{staticClass:"ti-search"})]),_vm._v(" "),(_vm.searchQuery)?_c('button',{staticClass:"btn btn-icon btn-default",attrs:{"title":_vm.$t('general.clear')},on:{"click":_vm.clearSearch}},[_c('i',{staticClass:"ti-close"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"pull-right"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 add-customer-div"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_client.name),expression:"new_client.name"}],staticClass:"form-control",attrs:{"type":"text","aria-autocomplete":"off","placeholder":_vm.$t('customers.addCustomerToGroup') || 'Add customer to group...',"id":"add_customer","autocomplete":"off","title":"name"},domProps:{"value":(_vm.new_client.name)},on:{"focusout":_vm.handleFocusOut,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }return _vm.handleFocusOut($event)},"keyup":function($event){_vm.searchByName()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.new_client, "name", $event.target.value)}}}),_vm._v(" "),(_vm.existingNames.length)?_c('div',{staticClass:"inputWithSearch_search"},[_vm._l((_vm.existingNames),function(client){return [_c('div',{key:client.id,staticClass:"client",on:{"click":function($event){_vm.selectClient(client)}}},[_c('div',{staticClass:"client__details"},[(client.firstname)?_c('span',[_vm._v(_vm._s(client.firstname))]):_vm._e(),_vm._v(" "),(client.lastname)?_c('span',[_vm._v(_vm._s(client.lastname))]):_vm._e(),_vm._v(" "),(!client.firstname && !client.lastname)?_c('span',[_vm._v(_vm._s(client.email))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"client__adress"},[(client.phone)?_c('span',[_vm._v(_vm._s(client.phone))]):_vm._e()])])]})],2):_vm._e()]),_vm._v(" "),_c('data-tables',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"campaign-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.clientsTableData,"pagination-def":_vm.paginationDef,"table-props":{'border': false},"filters":_vm.filters}},[_c('el-table-column',{attrs:{"min-width":30,"label":_vm.$t('customers.name')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.customer.firstname)+"  "+_vm._s(props.row.customer.lastname))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":30,"label":_vm.$t('customers.email')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.customer.email))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":25,"label":_vm.$t('customers.phone')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.customer.phone))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":20,"label":_vm.$t('customers.approvalStatus')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.is_approved == 1)?_c('span',{staticClass:"approved-badge"},[_c('i',{staticClass:"ti-check",staticStyle:{"color":"#28a745"}}),_vm._v("\n                      "+_vm._s(_vm.$t('customers.approved'))+"\n                    ")]):_c('a',{staticClass:"btn btn-warning btn-icon approve-btn",attrs:{"title":_vm.$t('customers.approve')},on:{"click":function($event){_vm.approveClient(props.row)}}},[_c('i',{staticClass:"ti-check"}),_vm._v("\n                      "+_vm._s(_vm.$t('customers.approve'))+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":12,"label":_vm.$t('marketingOffers.actions')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn delete mar-rt-10",attrs:{"title":_vm.$t('general.delete')},on:{"click":function($event){_vm.removeClient(props.row)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n                      "+_vm._s(_vm.$t('general.delete'))+"\n                    ")])]}}])})],1),_vm._v(" "),_c('el-pagination',{staticClass:"active-pagination",attrs:{"total":_vm.paginationDef.totalRecords,"page-size":_vm.paginationDef.perPage,"pager-count":_vm.pagesCount,"current-page":_vm.paginationDef.page,"layout":"prev, pager, next, total"},on:{"current-change":function($event){_vm.handlePageChange($event)},"prev-click":function($event){_vm.handlePageChange($event)},"next-click":function($event){_vm.handlePageChange($event)}}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yMe9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupAdd_vue__ = __webpack_require__("h3vL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8949145e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupAdd_vue__ = __webpack_require__("JpJd");
function injectStyle (ssrContext) {
  __webpack_require__("8mVm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8949145e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yOgY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"top-bar printer-top-bar"},[_c('div',{staticClass:"printer-heading"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"printer-heading-text"},[_c('h2',{staticClass:"printer-heading-title"},[_vm._v(_vm._s(_vm.$t('printer.title')))]),_vm._v(" "),_c('p',{staticClass:"printer-heading-subtitle"},[_vm._v(_vm._s(_vm.$t('printer.subtitle')))])])]),_vm._v(" "),_c('p',{staticClass:"d-inline-flex printer-actions"},[_c('a',{staticClass:"btn btn-orange btn-icon mar-rt-10 back",attrs:{"title":_vm.$t('general.back')},on:{"click":function($event){$event.preventDefault();return _vm.backButton($event)}}},[_c('i',{staticClass:"ti-arrow-left"}),_vm._v("\n          "+_vm._s(_vm.$t('general.back'))+"\n        ")]),_vm._v(" "),(_vm.id)?_c('a',{staticClass:"btn btn-danger btn-icon mar-rt-10 delete",on:{"click":function($event){$event.preventDefault();return _vm.handleDelete($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-close.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.delete'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-icon save",attrs:{"type":"submit","title":_vm.$t('general.save') + ' ' + _vm.$t('settingUsers.single')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mar-to-15 mar-bt-15 printer-form-wrap"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('div',{staticClass:"card printer-form-card"},[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row printer-sections"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"settings-section"},[_c('div',{staticClass:"settings-section-header"},[_vm._m(1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('printer.sectionGeneral')))])]),_vm._v(" "),_c('div',{staticClass:"settings-section-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],staticClass:"form-control",attrs:{"type":"number","disabled":"","placeholder":"ID"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('companyOptions.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Imprimanta bucatarie locatia 1","name":"name","data-vv-as":_vm.$t('companyOptions.name')},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('name'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('name'))+"\n                        ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.location')))]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.location),expression:"modelValidations.location"}],attrs:{"name":"location","options":_vm.locations,"value":"id","label":"name","placeholder":_vm.$t('kds.location')},model:{value:(_vm.model.location),callback:function ($$v) {_vm.$set(_vm.model, "location", $$v)},expression:"model.location"}}),_vm._v(" "),(_vm.errors.has('location'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.getError('location'))+"\n                    ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"settings-section"},[_c('div',{staticClass:"settings-section-header"},[_vm._m(2),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('printer.sectionConnectivity')))])]),_vm._v(" "),_c('div',{staticClass:"settings-section-body"},[(_vm.selectedType && _vm.selectedType.id == 5)?_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.isLan')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.orderLabelIsLan),callback:function ($$v) {_vm.orderLabelIsLan=$$v},expression:"orderLabelIsLan"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.selectedType && _vm.selectedType.id == 3 || _vm.selectedType && _vm.selectedType.id == 2)?_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingCompany.printer_is_usb')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.printer_is_usb),callback:function ($$v) {_vm.$set(_vm.model, "printer_is_usb", $$v)},expression:"model.printer_is_usb"}})],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[(_vm.selectedType && ((_vm.selectedType.id == 5 && !_vm.orderLabelIsLan) || (_vm.selectedType.id != 5 && _vm.model.printer_is_usb)))?[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.hostname')))])]:(_vm.selectedType && _vm.selectedType.id == 5)?[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('printer.printerIpHost')))])]:[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.printerIp')))])],_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ip),expression:"model.ip"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"ip","data-vv-as":"IP/Host"},domProps:{"value":(_vm.model.ip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ip", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('ip'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('ip'))+"\n                        ")]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[(_vm.selectedType && ((_vm.selectedType.id == 5 && !_vm.orderLabelIsLan) || (_vm.selectedType.id != 5 && _vm.model.printer_is_usb)))?[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.printerName')))])]:(_vm.selectedType && _vm.selectedType.id == 5)?[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('printer.printerPortName')))])]:[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingCompany.printerPort')))])],_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.port),expression:"model.port"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","name":"port","data-vv-as":"Port"},domProps:{"value":(_vm.model.port)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "port", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('port'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('port'))+"\n                        ")]):_vm._e()],2)])])])]),_vm._v(" "),(_vm.selectedType && _vm.selectedType.id == 2 && !_vm.model.printer_is_usb)?_c('div',{staticClass:"settings-section"},[_c('div',{staticClass:"settings-section-header"},[_vm._m(3),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('printer.sectionVersion')))])]),_vm._v(" "),_c('div',{staticClass:"settings-section-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[((_vm.selectedType && _vm.selectedType.id == 2) && !_vm.model.printer_is_usb)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Version")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.printerTypes,"value":"id","label":"name","placeholder":"Standard"},model:{value:(_vm.model.printer_type),callback:function ($$v) {_vm.$set(_vm.model, "printer_type", $$v)},expression:"model.printer_type"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.selectedType && (![3,5].includes(_vm.selectedType.id) && _vm.selectedType.id == 2 && !_vm.model.printer_is_usb))?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("USB")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.usb_path),expression:"model.usb_path"}],staticClass:"form-control",attrs:{"type":"text","name":"usb_path","placeholder":"USB"},domProps:{"value":(_vm.model.usb_path)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "usb_path", $event.target.value)}}})]):_vm._e()])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"settings-section"},[_c('div',{staticClass:"settings-section-header"},[_vm._m(4),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('printer.sectionType')))])]),_vm._v(" "),_c('div',{staticClass:"settings-section-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('settingTable.type')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.types,"reduce":function (item) { return item.id; },"label":"name","name":"type-select","placeholder":_vm.$t('settingTable.type')},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.type),expression:"model.type"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"hidden","name":"type"},domProps:{"value":(_vm.model.type)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "type", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('type'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('type'))+"\n                        ")]):_vm._e()],1)]),_vm._v(" "),(_vm.selectedType && ![3,5].includes(_vm.selectedType.id))?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.printerReceipt')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.print_receipts),callback:function ($$v) {_vm.$set(_vm.model, "print_receipts", $$v)},expression:"model.print_receipts"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.selectedType && _vm.selectedType.id == 2)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingTable.maps')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%","height":"auto","min-height":"40px"},attrs:{"multiple":"","collapse-tags":"","value-key":"id","placeholder":_vm.$t('general.all')},model:{value:(_vm.model.table_maps),callback:function ($$v) {_vm.$set(_vm.model, "table_maps", $$v)},expression:"model.table_maps"}},_vm._l((_vm.maps),function(map){return _c('el-option',{key:map.id,attrs:{"label":map.name,"value":map}})}))],1)])]):_vm._e(),_vm._v(" "),(_vm.selectedType && _vm.selectedType.id == 5)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.orderLabelPrintMode')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.order_label_print_mode),expression:"model.order_label_print_mode"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "order_label_print_mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"grouped"}},[_vm._v(_vm._s(_vm.$t('printer.orderLabelGrouped')))]),_vm._v(" "),_c('option',{attrs:{"value":"per_product"}},[_vm._v(_vm._s(_vm.$t('printer.orderLabelPerProduct')))])]),_vm._v(" "),(_vm.model.order_label_print_mode === 'per_product')?_c('small',{staticClass:"help-block order-label-hint"},[_vm._v("\n                      "+_vm._s(_vm.$t('printer.orderLabelPerProductHint'))+"\n                    ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),(_vm.selectedType && ![3,5].includes(_vm.selectedType.id))?_c('div',{staticClass:"settings-section"},[_c('div',{staticClass:"settings-section-header"},[_vm._m(5),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('printer.sectionOptions')))])]),_vm._v(" "),_c('div',{staticClass:"settings-section-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[(!_vm.model.print_receipts)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('kds.section')))]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.sections,"value":"id","label":"name","placeholder":_vm.$t('general.all')},model:{value:(_vm.model.section),callback:function ($$v) {_vm.$set(_vm.model, "section", $$v)},expression:"model.section"}}),_vm._v(" "),(_vm.errors.has('section'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('section'))+"\n                        ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.model.print_receipts)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('catalogProdOpt.posid')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pos_id),expression:"model.pos_id"}],staticClass:"form-control",attrs:{"type":"text","name":"pos_id","placeholder":"42"},domProps:{"value":(_vm.model.pos_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "pos_id", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(!_vm.model.print_receipts)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.fontSize')))]),_vm._v(" "),_c('v-select',{attrs:{"name":_vm.$t('printer.fontSize'),"options":_vm.fontSizes,"reduce":function (option) { return option.id; },"label":"name","clearable":"false","placeholder":_vm.$t('printer.fontSize')},model:{value:(_vm.selectedFontSize),callback:function ($$v) {_vm.selectedFontSize=$$v},expression:"selectedFontSize"}}),_vm._v(" "),(_vm.errors.has(_vm.$t('printer.fontSize')))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError(_vm.$t('printer.fontSize')))+"\n                        ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.model.print_receipts)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.correspondingPos')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%","height":"auto","min-height":"40px"},attrs:{"multiple":"","collapse-tags":"","value-key":"id","label":"name","placeholder":_vm.$t('printer.none')},model:{value:(_vm.model.pos_ids),callback:function ($$v) {_vm.$set(_vm.model, "pos_ids", $$v)},expression:"model.pos_ids"}},_vm._l((_vm.posList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item}})})),_vm._v(" "),(_vm.errors.has('section'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('section'))+"\n                        ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.model.print_receipts)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.paymentMethodsPrintTwice')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%","height":"auto","min-height":"40px"},attrs:{"multiple":"","collapse-tags":"","value-key":"id","label":"name","placeholder":_vm.$t('printer.none')},model:{value:(_vm.model.print_receipt_twice_payment_methods),callback:function ($$v) {_vm.$set(_vm.model, "print_receipt_twice_payment_methods", $$v)},expression:"model.print_receipt_twice_payment_methods"}},_vm._l((_vm.paymentMethods),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item}})})),_vm._v(" "),(_vm.errors.has('section'))?_c('small',{staticClass:"text-danger"},[_vm._v("\n                          "+_vm._s(_vm.getError('section'))+"\n                        ")]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.model.print_receipts)?_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.printOptions')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.print_options),callback:function ($$v) {_vm.$set(_vm.model, "print_options", $$v)},expression:"model.print_options"}})],1):_vm._e(),_vm._v(" "),(!_vm.model.print_receipts)?_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.printAddress')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.print_address_on_section),callback:function ($$v) {_vm.$set(_vm.model, "print_address_on_section", $$v)},expression:"model.print_address_on_section"}})],1):_vm._e(),_vm._v(" "),(_vm.selectedType && _vm.selectedType.id == 2 && !_vm.model.print_receipts)?_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.hideSingleOptionQty')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.hide_single_option_qty),callback:function ($$v) {_vm.$set(_vm.model, "hide_single_option_qty", $$v)},expression:"model.hide_single_option_qty"}})],1):_vm._e(),_vm._v(" "),(_vm.selectedType && _vm.selectedType.id == 2 && !_vm.model.print_receipts)?_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.displayPricesAndTotals')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.display_prices_and_totals),callback:function ($$v) {_vm.$set(_vm.model, "display_prices_and_totals", $$v)},expression:"model.display_prices_and_totals"}})],1):_vm._e(),_vm._v(" "),(_vm.model.print_receipts)?_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.printProductClientComments')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.print_product_comments),callback:function ($$v) {_vm.$set(_vm.model, "print_product_comments", $$v)},expression:"model.print_product_comments"}})],1):_vm._e(),_vm._v(" "),(_vm.model.print_receipts)?_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.printHotelFields')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.print_hotel_fields),callback:function ($$v) {_vm.$set(_vm.model, "print_hotel_fields", $$v)},expression:"model.print_hotel_fields"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.mergeItems')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.merge_items),callback:function ($$v) {_vm.$set(_vm.model, "merge_items", $$v)},expression:"model.merge_items"}})],1),_vm._v(" "),(_vm.model.print_receipts)?_c('div',{staticClass:"form-group label-input"},[_c('label',[_vm._v(_vm._s(_vm.$t('printer.groupItemsByCategoryOnReceipt')))]),_vm._v(" "),_c('p-switch',{attrs:{"type":"success"},model:{value:(_vm.model.group_items_by_category_on_receipt),callback:function ($$v) {_vm.$set(_vm.model, "group_items_by_category_on_receipt", $$v)},expression:"model.group_items_by_category_on_receipt"}})],1):_vm._e()])])])]):_vm._e()])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"printer-heading-icon"},[_c('i',{staticClass:"ti-printer"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"settings-section-icon"},[_c('i',{staticClass:"ti-file"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"settings-section-icon"},[_c('i',{staticClass:"ti-plug"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"settings-section-icon"},[_c('i',{staticClass:"ti-link"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"settings-section-icon"},[_c('i',{staticClass:"ti-settings"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"settings-section-icon"},[_c('i',{staticClass:"ti-control-shuffle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yQ4Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsModules_vue__ = __webpack_require__("seZu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34743c25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsModules_vue__ = __webpack_require__("I6xf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsModules_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34743c25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsModules_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yT4d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yTmD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yU+I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yUjI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wolt_vue__ = __webpack_require__("AM1d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c80b049_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wolt_vue__ = __webpack_require__("V6Ob");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wolt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c80b049_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wolt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yX82":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ybMI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yecq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ygnR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ygx8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PosScreenForm_vue__ = __webpack_require__("4uSL");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PosScreenForm', __WEBPACK_IMPORTED_MODULE_7__PosScreenForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      posScreenFormModel: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onUserSubmit: function onUserSubmit(model, isValid) {
      this.posScreenFormModel = model;
    }
  }
});

/***/ }),

/***/ "yi0V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ykYJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ylrw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ytkV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('promos-form',{ref:"promos",attrs:{"route":_vm.route},on:{"on-submit":_vm.onOfferSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yv97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yz4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsIntegrations_vue__ = __webpack_require__("CLOz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5ee939c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsIntegrations_vue__ = __webpack_require__("XWxU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsIntegrations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5ee939c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsIntegrations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yzDi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var end = new Date();
    var start = new Date();
    start.setDate(end.getDate() - 29);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    return {
      loading: false,
      tableData: [],
      searchProdResults: [],
      selectedCategory: '',
      selectedGestiune: null,
      selectedLocation: null,
      selectedProduct: null,
      loadingProducts: false,
      searchDate: [start, end],
      categories: [{ value: '', label: 'Selectează categoria' }, { value: 'Marfa', label: 'Marfa' }, { value: 'Materii prime', label: 'Materii prime' }, { value: 'Materiale consumabile', label: 'Materiale consumabile' }, { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' }, { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' }, { value: 'Produs rezidual', label: 'Produs rezidual' }, { value: 'Ambalaje', label: 'Ambalaje' }, { value: 'Obiecte de inventar', label: 'Obiecte de inventar' }, { value: 'fara_categorie', label: 'Fara categorie' }],
      pickerOptions: {
        shortcuts: [{
          text: 'Astăzi',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ieri',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 7 zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Ultimele 30 de zile',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setDate(end.getDate() - 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna curentă',
          onClick: function onClick(picker) {
            var start = new Date();
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
            var end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Luna trecută',
          onClick: function onClick(picker) {
            var date = new Date();
            var start = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            var end = new Date(date.getFullYear(), date.getMonth(), 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul curent',
          onClick: function onClick(picker) {
            var start = new Date(new Date().getFullYear(), 0, 1);
            var end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Anul trecut',
          onClick: function onClick(picker) {
            var year = new Date().getFullYear() - 1;
            var start = new Date(year, 0, 1);
            var end = new Date(year, 11, 31);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0);
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999);
          }
        }
      }
    };
  },

  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni: function filteredGestiuni() {
      var _this = this;

      if (!this.selectedLocation) return [];
      var result = this.gestiuneOptions.filter(function (g) {
        return g.externalLocationId === _this.selectedLocation.true_id;
      });
      return result;
    }
  },
  watch: {
    selectedLocation: function selectedLocation(newLocation) {
      this.resetTable();

      this.selectedGestiune = null;
      this.selectedProduct = null;
      this.tableData = [];
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id;
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code;
    },
    selectedCategory: function selectedCategory() {
      this.resetTable();

      this.selectedProduct = null;
    }
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
  },
  mounted: function mounted() {
    this.firstLoad();
  },

  methods: {
    firstLoad: function firstLoad() {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0];
      }
    },
    triggerFilter: function triggerFilter() {
      if (!this.selectedGestiune) {
        return;
      }
      if (!this.selectedLocation) {
        return;
      }
      if (!this.searchDate || this.searchDate.length !== 2) {
        return;
      }

      this.resetTable();
      this.fetchInventoryReport();
    },
    handleProductSelect: function handleProductSelect(product) {
      this.resetTable();

      this.selectedProduct = product;
    },
    handleClearProduct: function handleClearProduct() {
      this.resetTable();

      this.selectedProduct = null;
    },
    getCategoryClass: function getCategoryClass(categorie) {
      if (!categorie) return '';

      switch (categorie.toLowerCase().replace(/\s+/g, '-')) {
        case 'marfa':
          return 'marfa';
        case 'semifabricate-(reteta)':
          return 'semifabricate';
        case 'materii-prime':
          return 'materii-prime';
        case 'produs-finit-(reteta)':
          return 'produs-finit';
        default:
          return '';
      }
    },
    fetchProducts: function fetchProducts(searchTerm) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!searchTerm || searchTerm.length < 2)) {
                  _context.next = 3;
                  break;
                }

                _this2.searchProdResults = [];
                return _context.abrupt('return');

              case 3:

                _this2.loadingProducts = true;

                _context.prev = 4;
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/products?vatNumber=' + _this2.selectedVatNumber + '&name=' + encodeURIComponent(searchTerm) + '&externalCompanyId=' + _this2.companyID;


                if (_this2.selectedCategory) {
                  url += '&categorie=' + encodeURIComponent(_this2.selectedCategory);
                }

                _context.next = 9;
                return fetch(url);

              case 9:
                response = _context.sent;
                _context.next = 12;
                return response.json();

              case 12:
                data = _context.sent;


                if (Array.isArray(data.products)) {
                  _this2.searchProdResults = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(data.products));
                } else {
                  _this2.searchProdResults = [];
                }
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](4);

                console.error('Error fetching products:', _context.t0);
                _this2.searchProdResults = [];

              case 20:
                _context.prev = 20;

                _this2.loadingProducts = false;
                return _context.finish(20);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 16, 20, 23]]);
      }))();
    },
    fetchInventoryReport: function fetchInventoryReport() {
      var _this3 = this;

      var exportFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var externalCompanyId, _searchDate, startDate, endDate, queryParams, url, response, errorMsg, errData, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this3.selectedGestiune || !_this3.selectedLocation || !_this3.searchDate)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:

                _this3.loading = true;

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  type: 'info',
                  title: 'Se generează raportul în timp real',
                  text: 'Vă rugăm așteptați...',
                  allowOutsideClick: false,
                  didOpen: function didOpen() {
                    __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.showLoading();
                  }
                });

                _context2.prev = 4;
                externalCompanyId = _this3.$session.get('selectedCompany');
                _searchDate = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_this3.searchDate, 2), startDate = _searchDate[0], endDate = _searchDate[1];
                queryParams = new URLSearchParams({
                  gestiune: _this3.selectedGestiune,
                  externalCompanyId: externalCompanyId,
                  externalLocationId: _this3.selectedLocation.true_id,
                  startDate: new Date(startDate),
                  endDate: new Date(endDate)
                }).toString();
                url = "https://fiscal-dev.cdntaptasty.com" + ':4443/reports/inventory?' + queryParams;


                if (_this3.selectedCategory) {
                  url += '&categorie=' + encodeURIComponent(_this3.selectedCategory);
                }

                if (_this3.selectedProduct) {
                  url += '&product_id=' + _this3.selectedProduct;
                }

                if (exportFormat) {
                  url += '&export=' + exportFormat;
                }

                _context2.next = 14;
                return fetch(url);

              case 14:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 28;
                  break;
                }

                errorMsg = 'Eroare necunoscut\u0103: ' + response.status;
                _context2.prev = 17;
                _context2.next = 20;
                return response.json();

              case 20:
                errData = _context2.sent;

                errorMsg = errData.details || errData.error || errorMsg;
                _context2.next = 27;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2['catch'](17);

                console.warn('Nu s-a putut parsa JSON-ul erorii:', _context2.t0);

              case 27:
                throw new Error(errorMsg);

              case 28:
                if (!exportFormat) {
                  _context2.next = 32;
                  break;
                }

                window.location.href = url;

                setTimeout(function () {
                  __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.close();
                }, 800);

                return _context2.abrupt('return');

              case 32:
                _context2.next = 34;
                return response.json();

              case 34:
                data = _context2.sent;


                if (data && data.items) {
                  _this3.tableData = data.items.map(function (item) {
                    return {
                      denumire: item.product_name || '',
                      um: item.unit || '',
                      deschidere: item.opening_stock != null ? item.opening_stock : '',
                      categorie: item.category != null ? item.category : '',
                      intrare: item.delivery != null ? item.delivery : '',
                      transfer: item.transfer != null ? item.transfer : '',
                      pierderiMaterii: item.raw_waste != null ? item.raw_waste : '',
                      pierderiProduse: item.full_waste != null ? item.full_waste : '',
                      pauzaMasa: item.crew_meal != null ? item.crew_meal : '',
                      vandute: item.usage_pre != null ? item.usage_pre : '',
                      trebuie: item.expected_stock != null ? item.expected_stock : '',
                      inventar: item.inventory_count != null ? item.inventory_count : '',
                      inchidere: item.closing_stock != null ? item.closing_stock : '',
                      diferenteCant: item.diff_quantity != null ? item.diff_quantity : '',
                      diferenteVal: item.diff_value != null ? item.diff_value : ''
                    };
                  });
                } else {
                  _this3.tableData = [];
                }
                _context2.next = 43;
                break;

              case 38:
                _context2.prev = 38;
                _context2.t1 = _context2['catch'](4);

                console.error('Error fetching inventory report:', _context2.t1);
                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                  title: 'Error',
                  text: _context2.t1.message || 'Nu s-a putut genera raportul de inventar.',
                  type: 'error'
                });
                _this3.tableData = [];

              case 43:
                _context2.prev = 43;

                _this3.loading = false;
                return _context2.finish(43);

              case 46:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[4, 38, 43, 46], [17, 24]]);
      }))();
    },
    resetTable: function resetTable() {
      this.tableData = [];
    }
  }
});

/***/ }),

/***/ "yzyr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_css__);













__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_input___default.a),
  data: function data() {
    return {
      model: [],
      modelValidate: {
        name: { required: true },
        required: { required: true }
      },
      windowHeight: 0,
      navbarHeaderHeight: 0,
      pageTopHeight: 90,
      loading: true,
      showLocations: false,
      locations: []
    };
  },
  created: function created() {
    this.$nextTick(function () {
      this.loading = true;
    });
    var data = {
      token: this.$session.get('token'),
      detailed_options: 1
    };
    var self = this;

    var companyData = this.$session.get('selectedCompanyData');
    this.locations = companyData.locations_details;
    if (this.locations.length > 1) {
      this.showLocations = true;
    }

    this.apiRequest('/listdefaults', 'GET', data, function (response) {
      if (response.status === true) {
        self.defaultData = response.data[0];
      }
    });
    this.getData();
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.doHeightCalculation();

      window.addEventListener('resize', function () {
        _this.doHeightCalculation();
      });
    });
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate(pageId) {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this2.saveDetails();
        }
      });
    },
    doHeightCalculation: function doHeightCalculation() {
      this.windowHeight = window.innerHeight;
    },
    addNewValue: function addNewValue(optId) {
      var data = {
        'token': this.$session.get('token'),
        'type': 'hashes'
      };
      var self = this;
      var filterId = optId;

      this.apiRequest('/helpers', 'GET', data, function (response) {
        if (response.status === true) {
          var newRow = {
            'id': null,
            'filter_id': filterId,
            'value': ''
          };
          newRow.id = response.data[0].id;


          var zElement = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(self.model).filter(function (element) {
            return element.id === optId;
          });
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(zElement[0].filter_value).length === 0) {
            zElement[0].filter_value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(zElement[0].filter_value));
          }
          zElement[0].filter_value.push(newRow);
        }
      });
    },
    addNewOption: function addNewOption() {
      var data = {
        'token': this.$session.get('token'),
        'type': 'hashes',
        'counter': 2
      };
      var self = this;
      this.apiRequest('/helpers', 'GET', data, function (response) {
        if (response.status === true) {
          var newRow = {
            'id': null,
            'type': '',
            'location_ids': [],
            'filter_value': []
          };
          newRow.id = response.data[0].id;
          var newOption = {
            'id': null,
            'filter_id': response.data[0].id,
            'value': ''
          };
          newOption.id = response.data[1].id;
          newRow.filter_value.push(newOption);
          if (!self.model) {
            self.model = [];
          }
          self.model.push(newRow);
        }
      });
    },
    duplicateOption: function duplicateOption(optId) {
      var optIdx = this.getObjectByElemKeyValue('id', optId, this.model);
      var newObj = this.copyObject(this.model[optIdx]);
      newObj.id = Math.floor((1 + Math.random()) * 0x10000);
      this.model.push(newObj);
    },
    deleteValue: function deleteValue(optId, valId) {
      var optIdx = this.getObjectByElemKeyValue('id', optId, this.model);
      var valIdx = this.getObjectByElemKeyValue('id', valId, this.model[optIdx].filter_value);

      this.model[optIdx].filter_value.splice(valIdx, 1);
    },
    deleteFilter: function deleteFilter(filterId) {
      var _this3 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({
        text: self.$t('filter.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this3.$session.get('token'),
            company_id: _this3.$session.get('selectedCompany'),
            filter_id: filterId
          };
          _this3.apiRequest('/filter-remove', 'POST', data, function (response) {
            if (response.status) {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('filter.deleted'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
              var optIdx = self.getObjectByElemKeyValue('id', filterId, self.model);
              self.model.splice(optIdx, 1);
            } else {
              console.warn(response);
              var msg = response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong');
              __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()('', msg, 'error');
            }
          });
        }
      }).catch(function () {});
    },
    saveDetails: function saveDetails() {
      this.$nextTick(function () {
        this.loading = true;
      });
      var companyID = this.$session.get('selectedCompany');

      var filters = this.copyObject(this.model);
      for (var idxO in filters) {
        var locIds = [];
        if (filters[idxO].location_ids) {
          for (var idxL in filters[idxO].location_ids) {
            locIds.push(filters[idxO].location_ids[idxL]['id']);
          }
        }
        filters[idxO].location_ids = locIds;
      }

      var data = {
        'token': this.$session.get('token'),
        'filters': filters,
        'company_id': companyID
      };

      var self = this;
      this.apiRequest('filter', 'POST', data, function (response) {
        if (response.status === true) {
          self.errors.clear();
          self.model = response.data.filters;
          self.$nextTick(function () {
            self.loading = false;
          });
          if (response.data.message) {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('filter.' + response.data.message), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          } else {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('filter.filterUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
          }
        } else {
          self.$nextTick(function () {
            self.loading = false;
            self.getData();
          });
          __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()({ 'text': self.$t('filter.' + response.errors), 'type': 'error', 'showConfirmButton': false, 'timer': 2000 }).catch(function () {});
        }
      });
    },
    getData: function getData() {
      var self = this;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };
      this.apiRequest('/filter', 'GET', data, function (response) {
        if (response.status === true) {
          self.model = response.data;
          self.$nextTick(function () {
            self.loading = false;
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "z49E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryReport_vue__ = __webpack_require__("yzDi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_669558c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryReport_vue__ = __webpack_require__("QGSD");
function injectStyle (ssrContext) {
  __webpack_require__("W50H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-669558c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_669558c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z4Ma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'r4'
});

/***/ }),

/***/ "z58I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z5H4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z7He":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zATB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_menu_item_group_css__ = __webpack_require__("V5v9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_menu_item_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_menu_item_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group__ = __webpack_require__("D8db");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_menu_item_css__ = __webpack_require__("/bpg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_menu_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_menu_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item__ = __webpack_require__("ACGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_menu_css__ = __webpack_require__("bwiK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu__ = __webpack_require__("SExR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);









var _components;



__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'settings-menu',
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu___default.a.name, __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_menu_item___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_menu_item_group___default.a), _components)
});

/***/ }),

/***/ "zDrT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zGLH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vat-dropdown',
  props: {
    locationIds: {
      type: Array
    },
    vatValue: {
      type: Number
    }
  },
  data: function data() {
    return {
      output: '',
      vatOptions: [],
      vatInputValue: ''
    };
  },
  beforeCreated: function beforeCreated() {
    this.output = this.vatInputValue ? this.vatInputValue : null;
    this.getData();
  },

  watch: {
    locationIds: function locationIds(value) {
      this.locationIds = value;
      this.getData();
    },
    vatValue: function vatValue(value) {
      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(this, 'vatInputValue', value);
    }
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        location_ids: this.locaitonIds
      };
      this.apiRequest('/location/vat', 'GET', data, function (response) {
        if (response.status === true) {
          _this.vatOptions = response.data;
        }
      });
    },
    handleClick: function handleClick() {
      this.$emit('vat-change', this.output);
    }
  }
});

/***/ }),

/***/ "zJbz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zKgQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CouponForm_vue__ = __webpack_require__("0cXx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2000e1d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CouponForm_vue__ = __webpack_require__("ATVL");
function injectStyle (ssrContext) {
  __webpack_require__("BKA/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CouponForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2000e1d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CouponForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zQKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ElPagination: __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_pagination___default.a,
    ElTableColumn: __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default.a
  },
  props: {
    locations: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      orders: [],
      selectedIds: [],
      loading: false,
      resending: false,
      filters: {
        location_id: '',
        search: '',
        only_final: false
      },
      pagination: {
        page: 1,
        perPage: 20,
        total: 0
      },
      logs: [],
      logsOrderId: null,
      logsLoading: false,
      copiedKey: null
    };
  },
  created: function created() {
    this.companyID = this.$session.get('selectedCompany');
    this.fetchOrders();
  },

  methods: {
    search: function search() {
      this.pagination.page = 1;
      this.fetchOrders();
    },
    handlePageChange: function handlePageChange(page) {
      this.pagination.page = page;
      this.fetchOrders();
    },
    fetchOrders: function fetchOrders() {
      var _this = this;

      this.loading = true;
      var dataToSend = {
        token: this.$session.get('token'),
        company_id: this.companyID,
        location_id: this.filters.location_id || null,
        search: this.filters.search || null,
        only_final: this.filters.only_final ? 1 : 0,
        page: this.pagination.page,
        per_page: this.pagination.perPage
      };
      this.apiRequest('/gestiune/order-errors', 'GET', dataToSend, function (response) {
        _this.loading = false;
        if (response && response.status === true) {
          _this.orders = response.data.orders;
          _this.pagination.total = response.data.total;
          _this.selectedIds = [];
        } else {
          _this.showError(response);
        }
      });
    },
    onSelectionChange: function onSelectionChange(rows) {
      this.selectedIds = rows.map(function (row) {
        return row.id;
      });
    },
    resend: function resend() {
      var _this2 = this;

      if (!this.selectedIds.length || this.resending) return;

      this.resending = true;
      var dataToSend = {
        token: this.$session.get('token'),
        company_id: this.companyID,
        order_ids: this.selectedIds
      };
      this.apiRequest('/gestiune/order-resend', 'POST', dataToSend, function (response) {
        _this2.resending = false;
        if (response && response.status === true) {
          var _response$data = response.data,
              success = _response$data.success,
              error = _response$data.error;

          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({
            icon: error ? 'warning' : 'success',
            title: 'Retrimitere finalizată',
            text: 'Trimise cu succes: ' + success + '. Cu eroare: ' + error + '.'
          });
          _this2.fetchOrders();
        } else {
          _this2.showError(response);
        }
      });
    },
    openLogs: function openLogs(row, column) {
      var _this3 = this;

      if (column && column.type === 'selection') return;

      this.logsOrderId = row.id;
      this.logs = [];
      this.logsLoading = true;
      this.$modal.show('gestiuneOrderLogsModal');

      var dataToSend = {
        token: this.$session.get('token'),
        company_id: this.companyID,
        order_id: row.id
      };
      this.apiRequest('/gestiune/order-logs', 'GET', dataToSend, function (response) {
        _this3.logsLoading = false;
        if (response && response.status === true) {
          _this3.logs = response.data.logs;
        } else {
          _this3.showError(response);
        }
      });
    },
    pretty: function pretty(value) {
      if (value === null || value === undefined || value === '') return '-';
      if (typeof value === 'string') return value;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value, null, 2);
    },
    copyJson: function copyJson(value, key) {
      var _this4 = this;

      var text = this.pretty(value);
      var done = function done() {
        _this4.copiedKey = key;
        setTimeout(function () {
          if (_this4.copiedKey === key) _this4.copiedKey = null;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(function () {
          return _this4.fallbackCopy(text, done);
        });
      } else {
        this.fallbackCopy(text, done);
      }
    },
    fallbackCopy: function fallbackCopy(text, done) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        done();
      } catch (e) {}
      document.body.removeChild(textarea);
    },
    showError: function showError(response) {
      var errorMsg = 'A apărut o problemă.';
      if (response && response.errors && response.errors.length > 0) {
        errorMsg = response.errors.join(', ');
      }
      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()({ icon: 'error', title: 'Eroare', text: errorMsg });
    }
  }
});

/***/ }),

/***/ "zRY3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__);





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {},
  created: function created() {
    this.getData();
  },
  data: function data() {
    return {
      groupsData: [],
      modelValidations: {
        title: {
          required: true
        }
      },
      loading: true,
      searchQuery: '',
      group: {
        title: '',
        members_require_approval: false
      }
    };
  },
  mounted: function mounted() {},

  methods: {
    handleSearch: function handleSearch() {
      this.getData();
    },
    clearSearch: function clearSearch() {
      this.searchQuery = '';
      this.getData();
    },
    handleEdit: function handleEdit(idx, focus) {
      var _this = this;

      this.groupsData[idx].visibility = !this.groupsData[idx].visibility;
      if (focus) {
        this.$nextTick(function () {
          return _this.$refs.text_items[idx].focus();
        });
      }
    },
    onEnter: function onEnter(idx) {
      var _this2 = this;

      var val = this.$refs.text_items[idx].value;
      this.groupsData[idx].name = val;
      this.groupsData[idx].visibility = !this.groupsData[idx].visibility;
      var id = this.groupsData[idx].id;
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        name: val,
        members_require_approval: this.groupsData[idx].members_require_approval ? 1 : 0
      };
      this.apiRequest('customersgroup/' + id, 'PUT', data, function (response) {
        if (response.status) {
          _this2.group.title = '';
          _this2.group.members_require_approval = false;
          _this2.$modal.hide('groupModal');
          _this2.getData();
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()(_this2.$t('general.success') + '!', _this2.$t('customers.updateGroup'), 'success').catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this3 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (isValid) {
          _this3.errors.clear();
          _this3.saveGroup();
        }
      });
    },
    handleErrors: function handleErrors(errors) {
      for (var prop in errors) {
        if (errors[prop].length === 1) {
          this.errors.add(prop, errors[prop][0]);
        } else {
          this.errors.add(prop, errors[prop]);
        }
      }
    },
    getData: function getData() {
      var _this4 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      };

      if (this.searchQuery.trim()) {
        data.search = this.searchQuery.trim();
      }

      this.loading = true;
      this.apiRequest('/customersgroup', 'GET', data, function (response) {
        if (response.status === true) {
          _this4.groupsData = response.data;
          _this4.$nextTick(function () {
            this.loading = false;
          });
        } else {
          _this4.loading = false;
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this4.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    saveGroup: function saveGroup() {
      var _this5 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        name: this.group.title,
        members_require_approval: this.group.members_require_approval ? 1 : 0
      };
      this.apiRequest('customersgroup', 'POST', data, function (response) {
        if (response.status) {
          _this5.group.title = '';
          _this5.group.members_require_approval = false;
          _this5.$modal.hide('groupModal');
          _this5.getData();
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()(_this5.$t('general.success') + '!', _this5.$t('customers.saveGroup'), 'success').catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this5.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    handleDelete: function handleDelete(index, item) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        text: this.$t('marketingCampaigns.areYouSureDelete') + (' \'' + item.name + '\'?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = {
            token: _this6.$session.get('token'),
            company_id: _this6.$session.get('selectedCompany')
          };
          _this6.apiRequest('/customersgroup/' + item.id, 'DELETE', data, function (response) {
            if (response.status === true) {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this6.$t('customers.deleteGroup'), 'success');
              _this6.groupsData.splice(index, 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('', _this6.$t('validations.wentWrong'), 'error');
            }
          });
        }
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "zSEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSectionAdd_vue__ = __webpack_require__("BFcM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6da64e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSectionAdd_vue__ = __webpack_require__("D+p6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KdsSectionAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6da64e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KdsSectionAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeNotifications: false,
      logo: 'static/img/logo-taptasty.png'
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    }
  },
  beforeCreate: function beforeCreate() {
    if (this.$route.path === '/login' && this.$session.exists()) {
      this.$router.push('/');
    } else if (!this.$session.exists()) {
      this.$router.push('/login');
    }
    if (this.$session.exists()) {
      var user = JSON.parse(this.$session.get('userData'));
      if (user !== undefined && user.language !== undefined) {
        this.$i18n.locale = user.language;
      }
    }
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$session.get('token');
    }
  }
});

/***/ }),

/***/ "zUd+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementMyOrdersSuppliersForm_vue__ = __webpack_require__("sRwN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d123dce6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementMyOrdersSuppliersForm_vue__ = __webpack_require__("MME9");
function injectStyle (ssrContext) {
  __webpack_require__("8rJ/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d123dce6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementMyOrdersSuppliersForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d123dce6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementMyOrdersSuppliersForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zWhM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonFiscalView_vue__ = __webpack_require__("o/RM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a5054b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonFiscalView_vue__ = __webpack_require__("53nb");
function injectStyle (ssrContext) {
  __webpack_require__("3E23")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a5054b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagementBonFiscalView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a5054b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagementBonFiscalView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zXsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__ = __webpack_require__("01lY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a59544_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__ = __webpack_require__("CnGb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a59544_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zaxN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupView_vue__ = __webpack_require__("UcMu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_644ccb9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupView_vue__ = __webpack_require__("yKwh");
function injectStyle (ssrContext) {
  __webpack_require__("zgD9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-644ccb9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_644ccb9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zfTc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zgD9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zijR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardProgramEdit_vue__ = __webpack_require__("ToeX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc6bb78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardProgramEdit_vue__ = __webpack_require__("fPPq");
function injectStyle (ssrContext) {
  __webpack_require__("m1oP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardProgramEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc6bb78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardProgramEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zixD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.loading ? 'show-loader' : 'hide-loader')},[_c('div',{staticClass:"el-loading-spinner"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none"}})])])]),_vm._v(" "),_c('div',{ref:"optionsTopBar",staticClass:"settings-top-bar sticky-header"},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"d-inline-flex"},[_c('button',{staticClass:"btn btn-success btn-icon mar-rt-10 save",attrs:{"type":"submit","title":_vm.$t('general.saveChanges')},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_c('img',{attrs:{"src":"/static/img/icons/save.png"}}),_vm._v("\n          "+_vm._s(_vm.$t('general.save'))+"\n        ")])])])]),_vm._v(" "),_c('form',{staticClass:"row mar-to-15"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('error')),expression:"errors.has('error')"}],staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.getError('error'))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingDateTime.timezone')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:([{required: true}]),expression:"[{required: true}]"}],staticClass:"col-md-6",attrs:{"placeholder":" - Select Timezone - ","filterable":""},model:{value:(_vm.model.timezone),callback:function ($$v) {_vm.$set(_vm.model, "timezone", $$v)},expression:"model.timezone"}},_vm._l((_vm.defaults.timezones),function(tz){return _c('el-option',{key:tz.select_value,attrs:{"value":tz.select_value,"label":tz.display_name}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingDateTime.timeFormat')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:([{required: true}]),expression:"[{required: true}]"}],staticClass:"col-md-6",attrs:{"placeholder":" - Select Time Format - "},model:{value:(_vm.model.time_format),callback:function ($$v) {_vm.$set(_vm.model, "time_format", $$v)},expression:"model.time_format"}},_vm._l((_vm.defaults.time_formats.client),function(label,key){return _c('el-option',{key:key,attrs:{"value":key,"label":label}})}))],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('settingDateTime.dateFormat')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('el-select',{directives:[{name:"validate",rawName:"v-validate",value:([{required: true}]),expression:"[{required: true}]"}],staticClass:"col-md-12 col-md-6",attrs:{"placeholder":" - Select Date Format - "},model:{value:(_vm.model.date_format),callback:function ($$v) {_vm.$set(_vm.model, "date_format", $$v)},expression:"model.date_format"}},_vm._l((_vm.defaults.date_formats.client),function(label,key){return _c('el-option',{key:key,attrs:{"value":key,"label":label}})}))],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zizS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard pad-to-15"},[(_vm.userRole != 'USER_CUSTOM' || (_vm.userRole === 'USER_CUSTOM' && this.userHasRight('general_can_access_reports')))?[(_vm.showLocations)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{},[_c('span',{staticClass:"pad-rg-5"},[_vm._v(_vm._s(_vm.$t('dashboard.selectLocation')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocation),expression:"selectedLocation"}],staticClass:"form-control inline-auto white ",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLocation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.filterLocations]}},[_c('option',{attrs:{"value":""}},[_vm._v(" - "+_vm._s(_vm.$t('general.all'))+" - ")]),_vm._v(" "),_vm._l((_vm.locations),function(loc,key){return [_c('option',{key:loc.id,attrs:{"label":loc.name},domProps:{"value":loc.id}},[_vm._v(" "+_vm._s(loc.name)+"\n              ")])]})],2)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pad-to-15 pad-bt-15 all-cards dashboard-resize-statistics-card"},[_c('div',{staticClass:"today pad-15"},[_c('p',{staticClass:"category"},[_c('img',{attrs:{"src":"/static/img/icons/icon-calendar.png"}}),_vm._v(" "+_vm._s(_vm.$t('dashboard.today')))])]),_vm._v(" "),_vm._l((_vm.statsCards),function(stats,key){return _c('div',{key:key,class:['col-lg-3', 'col-sm-12', 'card-' + key]},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",attrs:{"slot":"header"},slot:"header"},[_c('img',{attrs:{"src":("/static/img/icons/" + (stats.icon))}})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(stats.title))]),_vm._v("\n            "+_vm._s(stats.value)+"\n            "),(stats.canceled)?_c('small',[_vm._v("( "+_vm._s(stats.canceled)+" "+_vm._s(_vm.$t('ordersStatus.CANCELED'))+")")]):_vm._e(),_vm._v(" "),(stats.average)?_c('p',[_vm._v(_vm._s(stats.average))]):_vm._e()])])],1)})],2),_vm._v(" "),_c('div',{staticClass:"row text-left"},[_c('div',{staticClass:"col-md-12"},[_c('chart-card',{ref:"refOrdersChart",attrs:{"chart-data":_vm.ordersChart.data,"chart-options":_vm.ordersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.orderChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_c('img',{attrs:{"src":"/static/img/icons/icon-calendar.png"}}),_vm._v(" "+_vm._s(_vm.$t('dashboard.today')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('dashboard.completed'))+"\n              ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('chart-card',{ref:"salesChart",attrs:{"chart-data":_vm.salesChart.data,"chart-options":_vm.salesChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.salesChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_c('img',{attrs:{"src":"/static/img/icons/icon-calendar.png"}}),_vm._v(" "+_vm._s(_vm.$t('dashboard.today')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('dashboard.salesIn'))+" "+_vm._s(_vm.currency)+"\n            ")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row text-left"},[_c('div',{staticClass:"col-md-6 chart-bar-label"},[_c('chart-bars-card',{ref:"topProdsChart",attrs:{"chart-data":_vm.topProdsChart.data,"chart-options":_vm.topProdsChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.top5Chart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_c('img',{attrs:{"src":"/static/img/icons/icon-calendar.png"}}),_vm._v(" "+_vm._s(_vm.$t('dashboard.today')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('reports.salesProductNr'))+"\n            ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('chart-bars-card',{ref:"deliveryChart",attrs:{"chart-data":_vm.deliveryChart.data,"chart-options":_vm.deliveryChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t('dashboard.orderingChart')))]),_vm._v(" "),_c('p',{staticClass:"category"},[_c('img',{attrs:{"src":"/static/img/icons/icon-calendar.png"}}),_vm._v(" "+_vm._s(_vm.$t('dashboard.today')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" "+_vm._s(_vm.$t('dashboard.nrOfOrders'))+"\n            ")])])])],1)])]:[_c('div',{staticClass:"centerTxt"},[_c('h2',[_vm._v(_vm._s(_vm.$t('general.noAccessRaport')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('general.contactAdmin')))])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zj2D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pad-to-5"},[_c('fiscal-printer-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onUserSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zks6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__("jAzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__ = __webpack_require__("wOhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__ = __webpack_require__("x36W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_css__);























__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_js_modal___default.a, { componentName: 'vmodal' });

var MAX_ITEMS = 30;
var MIN_IMAGES = 5;
var PRODUCTS_PER_PAGE = 20;
var TITLE_MAX = 200;
var MAX_IMAGE_MB = 5;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_14_vuedraggable___default.a,
    PSwitch: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      MAX_ITEMS: MAX_ITEMS,
      MIN_IMAGES: MIN_IMAGES,
      PRODUCTS_PER_PAGE: PRODUCTS_PER_PAGE,
      TITLE_MAX: TITLE_MAX,
      loading: true,
      saving: false,
      exporting: false,
      productLoading: false,
      productsBrowsed: false,
      sections: [],
      products: [],
      form: this.emptyForm()
    };
  },

  computed: {
    companyID: function companyID() {
      return this.$session.get('selectedCompany');
    },
    token: function token() {
      return this.$session.get('token');
    },
    sectionTypes: function sectionTypes() {
      return [{ value: 1, label: this.typeLabel(1) }, { value: 2, label: this.typeLabel(2) }, { value: 3, label: this.typeLabel(3) }, { value: 4, label: this.typeLabel(4) }, { value: 5, label: this.typeLabel(5) }, { value: 6, label: this.typeLabel(6) }];
    },
    hasNewsletter: function hasNewsletter() {
      return this.sections.some(function (s) {
        return s.section_type === 6;
      });
    },
    availableTypes: function availableTypes() {
      return this.hasNewsletter ? this.sectionTypes.filter(function (t) {
        return t.value !== 6;
      }) : this.sectionTypes;
    },
    typeColumnLabel: function typeColumnLabel() {
      return 'Tip secțiune';
    },
    contentColumnLabel: function contentColumnLabel() {
      return 'Conținut';
    },
    questionLabel: function questionLabel() {
      return 'Întrebare';
    },
    answerLabel: function answerLabel() {
      return 'Răspuns';
    }
  },
  created: function created() {
    this.initPage();
  },

  methods: {
    emptyForm: function emptyForm() {
      return {
        id: null,
        section_type: 1,
        title: '',
        active: 1,
        description: '',
        image_fit: 'cover',
        imagelist: [],
        selectedProducts: [],
        testimonials: [],
        qas: []
      };
    },
    typeLabel: function typeLabel(type) {
      var map = {
        1: 'Poze',
        2: 'Hero',
        3: 'Produse',
        4: 'Testimoniale',
        5: 'Q&A',
        6: 'Newsletter'
      };
      return map[type] || type;
    },
    contentSummary: function contentSummary(item) {
      switch (item.section_type) {
        case 1:
          return (item.images ? item.images.length : 0) + ' poze';
        case 2:
          return (item.images ? item.images.length : 0) + ' poze';
        case 3:
          return (item.products ? item.products.length : 0) + ' produse';
        case 4:
          return (item.testimonials ? item.testimonials.length : 0) + ' testimoniale';
        case 5:
          return (item.qas ? item.qas.length : 0) + ' întrebări';
        case 6:
          return 'Newsletter';
        default:
          return '-';
      }
    },
    baseData: function baseData(extra) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({
        token: this.token,
        company_id: this.companyID
      }, extra || {});
    },
    initPage: function initPage() {
      this.loading = true;
      this.getSections();
    },
    getSections: function getSections() {
      var _this = this;

      this.apiRequest('/homepage-sections', 'GET', this.baseData(), function (response) {
        if (response.status === true) {
          _this.sections = response.data;
        }
        _this.$nextTick(function () {
          _this.loading = false;
        });
      });
    },
    onProductDropdownVisible: function onProductDropdownVisible(visible) {
      if (visible && !this.productsBrowsed) {
        this.searchProducts('');
      }
    },
    searchProducts: function searchProducts(query) {
      var _this2 = this;

      var term = (query || '').trim();
      var params = term ? { q: term } : {};
      this.productLoading = true;
      this.apiRequest('/homepage-sections/products/search', 'GET', this.baseData(params), function (response) {
        _this2.productLoading = false;
        if (response.status === true) {
          _this2.products = _this2.mergeProducts(response.data);
          _this2.productsBrowsed = true;
        }
      });
    },
    mergeProducts: function mergeProducts(incoming) {
      var selected = this.form.selectedProducts || [];
      var kept = this.products.filter(function (p) {
        return selected.indexOf(p.id) !== -1;
      });
      var byId = {};
      kept.concat(incoming || []).forEach(function (p) {
        byId[p.id] = p;
      });
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(byId).map(function (id) {
        return byId[id];
      });
    },
    openCreate: function openCreate() {
      this.form = this.emptyForm();
      this.products = [];
      this.$modal.show('sectionModal');
    },
    openEdit: function openEdit(item) {
      var _this3 = this;

      this.apiRequest('/homepage-sections/' + item.id, 'GET', this.baseData(), function (response) {
        if (response.status === true) {
          _this3.form = _this3.mapToForm(response.data);
          _this3.$modal.show('sectionModal');
        } else {
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', _this3.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    closeModal: function closeModal() {
      this.$modal.hide('sectionModal');
    },
    onModalOpened: function onModalOpened() {
      this.productsBrowsed = false;

      var el = document.querySelector('.sectionModal.vm--container');
      if (el && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    },
    mapToForm: function mapToForm(data) {
      var form = this.emptyForm();
      form.id = data.id;
      form.section_type = data.section_type;
      form.title = data.title;
      form.active = data.active ? 1 : 0;
      form.description = data.description || '';
      form.image_fit = data.image_fit || 'cover';

      if (data.images) {
        form.imagelist = data.images.map(function (i) {
          return {
            url: i.image_url,
            name: i.filename,
            filename: i.filename
          };
        });
      }
      if (data.products) {
        form.selectedProducts = data.products.map(function (p) {
          return p.product_id;
        });

        this.products = data.products.filter(function (p) {
          return p.product;
        }).map(function (p) {
          return { id: p.product_id, name: p.product.name };
        });
      }
      if (data.testimonials) {
        form.testimonials = data.testimonials.map(function (t) {
          return {
            filename: t.filename,
            imagelist: t.filename ? [{ url: t.image_url, name: t.filename, filename: t.filename }] : [],
            title: t.title || '',
            author: t.author || '',
            rating: t.rating !== null && t.rating !== undefined ? t.rating : '',
            description: t.description || ''
          };
        });
      }
      if (data.qas) {
        form.qas = data.qas.map(function (q) {
          return {
            question: q.question || '',
            answer: q.answer || ''
          };
        });
      }
      return form;
    },
    handleImagesChange: function handleImagesChange(file, fileList) {
      var _this4 = this;

      if (this.isOversized(file)) {
        this.warnOversized();
      }

      this.form.imagelist = fileList.filter(function (f) {
        return !_this4.isOversized(f);
      });
    },
    handleImagesRemove: function handleImagesRemove(file, fileList) {
      var _this5 = this;

      this.form.imagelist = fileList.filter(function (f) {
        return !_this5.isOversized(f);
      });
    },
    handleTestimonialImg: function handleTestimonialImg(index, file, fileList) {
      var _this6 = this;

      if (this.isOversized(file)) {
        this.warnOversized();
      }
      var valid = fileList.filter(function (f) {
        return !_this6.isOversized(f);
      });
      this.form.testimonials[index].imagelist = valid.slice(-1);
    },
    handleTestimonialRemove: function handleTestimonialRemove(index, file, fileList) {
      this.form.testimonials[index].imagelist = [];
    },
    handleExceed: function handleExceed() {
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', 'Ai atins numărul maxim de fișiere.', 'warning').catch(function () {});
    },
    isOversized: function isOversized(file) {
      return !!(file && file.size && file.size / 1024 / 1024 >= MAX_IMAGE_MB);
    },
    warnOversized: function warnOversized() {
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        toast: true,
        type: 'warning',
        text: this.$t('validations.pictureSizeExceed'),
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      }).catch(function () {});
    },
    addTestimonial: function addTestimonial() {
      this.form.testimonials.push({ filename: null, imagelist: [], title: '', author: '', rating: '', description: '' });
    },
    removeTestimonial: function removeTestimonial(index) {
      this.form.testimonials.splice(index, 1);
    },
    isEmptyHtml: function isEmptyHtml(value) {
      if (!value) {
        return true;
      }

      var text = String(value).replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').replace(/\s+/g, '');

      return text.length === 0;
    },
    addQa: function addQa() {
      this.form.qas.push({ question: '', answer: '' });
    },
    removeQa: function removeQa(index) {
      this.form.qas.splice(index, 1);
    },
    collectImages: function collectImages() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var arr, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, f;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                arr = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 4;
                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this7.form.imagelist);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 20;
                  break;
                }

                f = _step.value;

                if (!f.raw) {
                  _context.next = 16;
                  break;
                }

                _context.t0 = arr;
                _context.next = 12;
                return _this7.getBase64(f.raw);

              case 12:
                _context.t1 = _context.sent;

                _context.t0.push.call(_context.t0, _context.t1);

                _context.next = 17;
                break;

              case 16:
                if (f.filename) {
                  arr.push(f.filename);
                }

              case 17:
                _iteratorNormalCompletion = true;
                _context.next = 6;
                break;

              case 20:
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t2 = _context['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context.t2;

              case 26:
                _context.prev = 26;
                _context.prev = 27;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 29:
                _context.prev = 29;

                if (!_didIteratorError) {
                  _context.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context.finish(29);

              case 33:
                return _context.finish(26);

              case 34:
                return _context.abrupt('return', arr);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7, [[4, 22, 26, 34], [27,, 29, 33]]);
      }))();
    },
    collectTestimonials: function collectTestimonials() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var arr, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, t, image;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                arr = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 4;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this8.form.testimonials);

              case 6:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 24;
                  break;
                }

                t = _step2.value;
                image = null;

                if (!(t.imagelist && t.imagelist[0])) {
                  _context2.next = 19;
                  break;
                }

                if (!t.imagelist[0].raw) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 13;
                return _this8.getBase64(t.imagelist[0].raw);

              case 13:
                image = _context2.sent;
                _context2.next = 17;
                break;

              case 16:
                if (t.filename) {
                  image = t.filename;
                }

              case 17:
                _context2.next = 20;
                break;

              case 19:
                if (t.filename) {
                  image = t.filename;
                }

              case 20:
                arr.push({
                  image: image,
                  title: t.title,
                  author: t.author,
                  rating: t.rating === '' || t.rating === null || t.rating === undefined ? null : t.rating,
                  description: t.description
                });

              case 21:
                _iteratorNormalCompletion2 = true;
                _context2.next = 6;
                break;

              case 24:
                _context2.next = 30;
                break;

              case 26:
                _context2.prev = 26;
                _context2.t0 = _context2['catch'](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 30:
                _context2.prev = 30;
                _context2.prev = 31;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 33:
                _context2.prev = 33;

                if (!_didIteratorError2) {
                  _context2.next = 36;
                  break;
                }

                throw _iteratorError2;

              case 36:
                return _context2.finish(33);

              case 37:
                return _context2.finish(30);

              case 38:
                return _context2.abrupt('return', arr);

              case 39:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[4, 26, 30, 38], [31,, 33, 37]]);
      }))();
    },
    save: function save() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var badRating, incomplete, data, isUpdate, url, method;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this9.form.title) {
                  _context3.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', 'Titlul este obligatoriu.', 'warning').catch(function () {});
                return _context3.abrupt('return');

              case 3:
                if (!(_this9.form.title.length > TITLE_MAX)) {
                  _context3.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', 'Titlul poate avea maxim ' + TITLE_MAX + ' caractere.', 'warning').catch(function () {});
                return _context3.abrupt('return');

              case 6:
                if (!(_this9.form.section_type === 1 && _this9.form.imagelist.length < MIN_IMAGES)) {
                  _context3.next = 9;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', 'Adaugă cel puțin ' + MIN_IMAGES + ' poze.', 'warning').catch(function () {});
                return _context3.abrupt('return');

              case 9:
                if (!(_this9.form.section_type === 4)) {
                  _context3.next = 14;
                  break;
                }

                badRating = _this9.form.testimonials.findIndex(function (t) {
                  if (t.rating === '' || t.rating === null || t.rating === undefined) {
                    return false;
                  }
                  var n = Number(t.rating);
                  return isNaN(n) || n < 0 || n > 5;
                });

                if (!(badRating !== -1)) {
                  _context3.next = 14;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', 'Nota trebuie să fie un număr între 0 și 5 (verifică #' + (badRating + 1) + ').', 'warning').catch(function () {});
                return _context3.abrupt('return');

              case 14:
                if (!(_this9.form.section_type === 5)) {
                  _context3.next = 22;
                  break;
                }

                if (_this9.form.qas.length) {
                  _context3.next = 18;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', 'Adaugă cel puțin o întrebare.', 'warning').catch(function () {});
                return _context3.abrupt('return');

              case 18:
                incomplete = _this9.form.qas.findIndex(function (q) {
                  return !q.question || !q.question.trim() || _this9.isEmptyHtml(q.answer);
                });

                if (!(incomplete !== -1)) {
                  _context3.next = 22;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', 'Întrebarea și răspunsul sunt obligatorii (verifică #' + (incomplete + 1) + ').', 'warning').catch(function () {});
                return _context3.abrupt('return');

              case 22:

                _this9.saving = true;

                data = _this9.baseData({
                  section_type: _this9.form.section_type,
                  title: _this9.form.title,
                  description: _this9.form.description,
                  image_fit: _this9.form.image_fit,
                  active: _this9.form.active ? 1 : 0
                });
                _context3.prev = 24;
                _context3.t0 = _this9.form.section_type;
                _context3.next = _context3.t0 === 1 ? 28 : _context3.t0 === 2 ? 32 : _context3.t0 === 3 ? 36 : _context3.t0 === 4 ? 38 : _context3.t0 === 5 ? 42 : _context3.t0 === 6 ? 44 : 48;
                break;

              case 28:
                _context3.next = 30;
                return _this9.collectImages();

              case 30:
                data.images = _context3.sent;
                return _context3.abrupt('break', 48);

              case 32:
                _context3.next = 34;
                return _this9.collectImages();

              case 34:
                data.images = _context3.sent;
                return _context3.abrupt('break', 48);

              case 36:
                data.products = _this9.form.selectedProducts;
                return _context3.abrupt('break', 48);

              case 38:
                _context3.next = 40;
                return _this9.collectTestimonials();

              case 40:
                data.testimonials = _context3.sent;
                return _context3.abrupt('break', 48);

              case 42:
                data.qas = _this9.form.qas;
                return _context3.abrupt('break', 48);

              case 44:
                _context3.next = 46;
                return _this9.collectImages();

              case 46:
                data.images = _context3.sent;
                return _context3.abrupt('break', 48);

              case 48:
                _context3.next = 55;
                break;

              case 50:
                _context3.prev = 50;
                _context3.t1 = _context3['catch'](24);

                _this9.saving = false;
                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', _this9.$t('validations.wentWrong'), 'error').catch(function () {});
                return _context3.abrupt('return');

              case 55:
                isUpdate = !!_this9.form.id;
                url = isUpdate ? '/homepage-sections/' + _this9.form.id : '/homepage-sections';
                method = isUpdate ? 'PUT' : 'POST';


                _this9.apiRequest(url, method, data, function (response) {
                  _this9.saving = false;
                  if (response.status === true) {
                    _this9.closeModal();
                    _this9.getSections();
                    __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()(_this9.$t('general.success') + '!', '', 'success').catch(function () {});
                  } else {
                    var msg = response.errors ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(response.errors)[0] : _this9.$t('validations.wentWrong');
                    __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', msg, 'error').catch(function () {});
                  }
                });

              case 59:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this9, [[24, 50]]);
      }))();
    },
    handleActive: function handleActive(row) {
      var _this10 = this;

      var actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate');
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: this.$t('validations.areYouSureYouWantTo') + (' ' + actionText + ' ' + row.title + '?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then(function (result) {
        if (result) {
          var data = _this10.baseData({ active: row.active ? 1 : 0 });
          _this10.apiRequest('/homepage-sections/' + row.id, 'PUT', data, function (response) {
            if (response.status !== true) {
              row.active = !row.active;
              __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', _this10.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        } else {
          row.active = !row.active;
        }
      }).catch(function () {
        row.active = !row.active;
      });
    },
    exportNewsletter: function exportNewsletter() {
      var _this11 = this;

      this.exporting = true;
      this.apiRequest('/homepage-sections/newsletter/export', 'GET', this.baseData(), function (response) {
        _this11.exporting = false;
        if (response.status === true && response.data && response.data.file) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', _this11.$t('validations.wentWrong'), 'error').catch(function () {});
        }
      });
    },
    onReorder: function onReorder() {
      var _this12 = this;

      var order = this.sections.map(function (s) {
        return s.id;
      });
      var data = this.baseData({ order: order });
      this.apiRequest('/homepage-sections/reorder', 'POST', data, function (response) {
        if (response.status !== true) {
          __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
            title: '',
            text: _this12.$t('validations.dataCouldNotBeSaved'),
            type: 'error',
            showConfirmButton: false,
            timer: 1500
          }).catch(function () {});
        }
      });
    },
    handleDelete: function handleDelete(index, row, event) {
      var _this13 = this;

      var self = this;
      if (event) event.stopPropagation();
      __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()({
        text: self.$t('marketingCampaigns.areYouSureDelete') + (' \'' + row.title + '\'?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then(function (result) {
        if (result) {
          _this13.apiRequest('/homepage-sections/' + row.id, 'DELETE', _this13.baseData(), function (response) {
            if (response.status === true) {
              self.sections.splice(index, 1);
              __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', self.$t('general.success') + '!', 'success').catch(function () {});
            } else {
              __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default()('', self.$t('validations.wentWrong'), 'error').catch(function () {});
            }
          });
        }
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "zmRt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "znbb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);










/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a),
  created: function created() {
    this.verifyUserLocations();
  },
  data: function data() {
    return {
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      selecteLocationId: null,
      locations: [],
      showLocations: false,
      clients: {
        'valid': [__WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD')],
        searchClient: null,
        searchEmployee: null
      },
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        defaultSort: {
          prop: 'name',
          order: 'ascending'
        }
      },
      labels: null,
      labelingPrimaryOption: null,
      totalClients: null,
      sortBy: 'name',
      sortOrder: 'asc',
      clientsTableData: [],
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return date < __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(12, 'months').startOf('day');
        }
      },
      pickerNames: ['date_from', 'date_to']
    };
  },

  methods: {
    paginationChanged: function paginationChanged(query) {
      if (query.type === 'page') this.getData(query);
      if (query.type === 'size') this.getData(query);
      if (query.type === 'sort') {
        if (query.sort.order) {
          this.sortBy = query.sort.prop;
          this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc';
        } else {
          this.sortBy = 'name';
          this.sortOrder = 'asc';
        }
        this.getData(query);
      }
    },
    getData: function getData(query) {
      var _this = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.clients.valid[0],
        end_date: this.clients.valid[1],
        search_client: this.clients.searchClient,
        search_employee: this.clients.searchEmployee
      };

      var sortColumn = '';
      var sortType = '';

      if (query) {
        sortColumn = query.sort.prop;
        sortType = query.sort.order === 'descending' ? 'desc' : 'asc';
      } else {
        sortColumn = this.sortBy;
        sortType = this.sortOrder;
      }

      var sortOptions = {
        field: sortColumn,
        order: sortType
      };
      data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, sortOptions);

      this.loading = true;
      var pageSize = query ? query.pageSize : 20;
      var page = query ? query.page : 1;
      this.apiRequest('/reports/ocr?page=' + page + '&pageSize=' + pageSize, 'GET', data, function (response) {
        if (response.status === true) {
          _this.clientsTableData = response.data.data;
          _this.totalClients = response.data.total;
        }
        _this.$nextTick(function () {
          this.loading = false;
        });
      });
    },
    exportData: function exportData() {
      var _this2 = this;

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.clients.valid[0],
        end_date: this.clients.valid[1],
        location_id: this.selecteLocationId
      };

      this.loading = true;
      this.apiRequest('/reports/product-and-options', 'GET', data, function (response) {
        if (response.status === true) {
          var link = document.createElement('a');
          link.href = response.data.file;
          link.setAttribute('download', response.data.file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default()('', _this2.$t('validations.wentWrong'), 'error');
        }
        _this2.loading = false;
      });
    },
    verifyUserLocations: function verifyUserLocations() {
      this.locations = this.$session.get('selectedCompanyData').locations_details;
      if (!this.isOwner()) {
        var allowedLocations = JSON.parse(this.$session.get('userDataLocations'));
        if (allowedLocations.length === 0) {
          this.showLocations = true;
          this.locations.forEach(function (element) {
            allowedLocations.push(element.id);
          });
        }
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id);
        });
      }
      if (this.locations.length > 1) {
        this.showLocations = true;
        this.selecteLocationId = this.locations[0].true_id;
      }
      if (this.locations.length > 0) {
        this.selecteLocationId = this.locations[0].true_id;
      }
    }
  }
});

/***/ }),

/***/ "zre5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProformaForm_vue__ = __webpack_require__("bV0d");







var _components;




__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'ProformaForm', __WEBPACK_IMPORTED_MODULE_7__ProformaForm_vue__["a" /* default */]), _components),
  props: {
    route: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      pageModel: {},
      page: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    };
  },

  methods: {
    onPageSubmit: function onPageSubmit(model, isValid) {
      this.pageModel = model;
    }
  }
});

/***/ }),

/***/ "zrv2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosAdd_vue__ = __webpack_require__("FzEz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df72568_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosAdd_vue__ = __webpack_require__("SZpq");
function injectStyle (ssrContext) {
  __webpack_require__("YBMp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PosAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df72568_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PosAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zv6G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zw+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"mar-lt-20"},[_c('label',{staticClass:"pad-bt-5"},[_vm._v(_vm._s(_vm.$t('upload.uploadImagesArchive')))]),_vm._v(" "),_c('el-upload',{ref:"upload",attrs:{"action":"","on-change":_vm.handleChange,"on-remove":_vm.handleRemove,"on-exceed":_vm.handleExceed,"limit":1,"auto-upload":false,"accept":".zip"}},[_c('el-button',{staticClass:"btn add mar",attrs:{"slot":"trigger","size":"small","type":"primary"},slot:"trigger"},[_vm._v(_vm._s(_vm.$t('upload.browse')))]),_vm._v(" "),_c('el-button',{staticClass:"btn add mar",staticStyle:{"margin-left":"10px"},attrs:{"disabled":!_vm.file || _vm.uploading,"loading":_vm.uploading,"size":"small","type":"primary"},on:{"click":_vm.upload}},[_vm._v(_vm._s(_vm.$t('upload.upload')))]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(_vm._s(_vm.$t('productImport.step3Hint')))]),_vm._v(" "),_c('span',{staticClass:"el-upload-list__item-actions"})],1),_vm._v(" "),(_vm.uploading)?_c('el-progress',{staticClass:"pad-bt-5",attrs:{"percentage":_vm.progress}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zwtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_transitions_collapse_transition__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_transitions_collapse_transition___default.a),
  props: {
    loc: String,
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          hide_for_users: false,
          hide_for_admin_location: false,
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: { default: null },
    removeLink: { default: null }
  },
  data: function data() {
    return {
      children: [],
      collapsed: true
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    linkExact: function linkExact() {
      return this.link.exact === true;
    },
    isActive: function isActive() {
      if (!this.$route) {
        return false;
      }

      var currentPath = this.$route.path;
      var candidatePaths = [];

      if (Array.isArray(this.link.activePaths) && this.link.activePaths.length) {
        candidatePaths.push.apply(candidatePaths, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.link.activePaths));
      } else if (this.link.path) {
        candidatePaths.push(this.link.path);
      }

      var matchesPath = function matchesPath(candidate) {
        if (!candidate) {
          return false;
        }

        if (typeof candidate === 'string') {
          return currentPath === candidate || currentPath.startsWith(candidate + '/');
        }

        if ((typeof candidate === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(candidate)) === 'object') {
          var path = candidate.path || '';
          if (!path) {
            return false;
          }
          if (candidate.exact) {
            return currentPath === path;
          }
          if (candidate.match === 'exact') {
            return currentPath === path;
          }
          if (candidate.match === 'prefix-only') {
            return currentPath.startsWith(path);
          }
          return currentPath === path || currentPath.startsWith(path + '/');
        }

        return false;
      };

      if (candidatePaths.some(matchesPath)) {
        return true;
      }

      if (this.link.includeChildrenInActive !== false) {
        var matchingRoute = this.children.find(function (c) {
          return c.link && typeof c.link.path === 'string' && currentPath.startsWith(c.link.path);
        });

        if (matchingRoute !== undefined) {
          return true;
        }
      }

      return false;
    },
    childIsHidden: function childIsHidden() {
      var showToMenu = true;
      if (this.link.hide_for_admin_location && (this.$session.get('userDataRole') === 'LOCATION_ADMIN' || this.$session.get('userDataRole') === 'LOCATION_STORE_ADMIN')) {
        showToMenu = false;
      }
      if (showToMenu && this.link.hide_for_users && this.$session.get('userDataRole') === 'USER') {
        showToMenu = false;
      }
      if (this.link.companyToShow && showToMenu) {
        if (this.link.companyToShow.includes(this.$session.get('selectedCompany'))) {
          showToMenu = false;
        }
      }
      if (this.link.name === 'dispatch' && !this.$session.get('selectedCompanyData').use_dispatch) {
        showToMenu = false;
      }
      if (this.link.name === 'gestiune' && (!this.$session.get('selectedCompanyData').use_gestiune || !this.userHasRight('GESTIUNE'))) {
        showToMenu = false;
      }
      return !showToMenu;
    },
    isVisible: function isVisible() {
      if (!this.isFeatureEnabled(this.link)) {
        return false;
      }
      if (this.$session.get('userDataRole') === 'USER_CUSTOM' && !this.userHasRight(this.link.custom_permission)) {
        return false;
      }
      if (this.link.hide_bills && !JSON.parse(this.$session.get('userData')).is_allowed_to_see_bills) {
        return false;
      }
      if (this.link.hide_for_marketer && this.$session.get('userDataRole') === 'MARKETER') {
        return false;
      }
      if (this.link.hide_for_operator && this.$session.get('userDataRole') === 'OPERATOR') {
        return false;
      }
      if (this.link.hide_for_admin_location && (this.$session.get('userDataRole') === 'LOCATION_ADMIN' || this.$session.get('userDataRole') === 'LOCATION_STORE_ADMIN')) {
        return false;
      } else {
        return !this.link.hide_for_users || this.link.hide_for_users && !(this.$session.get('userDataRole') === 'USER' && JSON.parse(this.$session.get('userDataLocations')).length >= 0);
      }
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    isFeatureEnabled: function isFeatureEnabled(link) {
      var userData = JSON.parse(this.$session.get('userData') || '{}');
      var company = userData && userData.companies && userData.companies[0] || {};

      var featureMap = {
        dispatch: 'use_dispatch',
        kds: 'use_kds',
        tables: 'use_table',
        reservations: 'use_table',
        pos: 'use_pos',
        screens: 'use_screens',
        marketing: ['use_marketing_standard', 'use_marketing_gift_card'],
        kiosk: 'use_kiosk',
        gestiune: 'use_gestiune',
        qr: 'use_qr_ordering'
      };

      if (link.name === 'online') {
        var hasApp = Number(company.use_app) === 1;
        var hasWebsite = Number(company.use_website) === 1;
        return hasApp || hasWebsite;
      }

      var key = featureMap[link.name];

      if (!key) return true;

      if (Array.isArray(key)) {
        return key.some(function (k) {
          return Number(company[k]) === 1;
        });
      }

      return Number(company[key]) === 1;
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ }),

/***/ "zyut":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f71c5dfff27aba92e97c.js